(function() {
    'use strict';
    
    angular
        .module('app.main.catalogs.orderline.vas', []);
})();
(function() {
    'use strict';

    angular
        .module('app.main.catalogs.orderline.vas')
        .run(runBlock);

    /* @ngInject */
    function runBlock(api) {

        if (angular.isUndefined(api.orderlines)) {
            api.orderlines = {};
        }
         api.orderlines.vas = {
            modelPath: 'orderlines.vas',
            fields: [
                { field: 'Id', type: 'int', displayLabel: 'VAS.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'VasId', type: 'int', displayLabel: 'VAS.FIELDS.VAS_ID', visible: true, creatable: true, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'VasCode', type: 'text', displayLabel: 'VAS.FIELDS.VAS_CODE', visible: true, creatable: false, editable: true, inputType: 'text',
                    validation: {isRequired: true, maxLen: 50, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'OrderlineId', type: 'int', displayLabel: 'VAS.FIELDS.ORDERLINE_ID', visible: false, creatable: false, editable: true, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'AdditionalInfo', type: 'text', displayLabel: 'VAS.FIELDS.ADITIONAL_INFO', visible: true, creatable: true, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: 100, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Status', type: 'text', displayLabel: 'VAS.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedDate', type: 'text', displayLabel: 'VAS.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedDate', type: 'text', displayLabel: 'VAS.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Created_By', type: 'text', displayLabel: 'VAS.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Updated_By', type: 'text', displayLabel: 'VAS.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }

            ],
            idField: 'VasId',
            lookupDisplayField: 'VasId',
            isDirty: false,
            isCatalogSpecificModel: true,
            methods: {
            },
            views: {
                mainList: {
                    columns         : [ 'Id', 'VasCode', 'AdditionalInfo', 'Status', 'UpdatedDate' ],
                    columnFilter    : {},
                    toggleFilterProps: { toggleStatus:false, filterProp:'Status', trueVal:1, trueValTooltipMessage: 'ACTIONS.TOGGLE_ACTIVE', falseVal:'', falseValTooltipMessage:"ACTIONS.TOGGLE_ALL"},
                    topIndex        : 0,
                    showFilterRow   : false,
                    sortColumn      : {'UpdatedDate': false},
                    itemActions     : undefined,
                    listActions     : [],
                    fabAction       : {}

                 },
                 mainDetails: {},
                privileges: {
                    list    : 'GetOrderlineDetails'// as discussed whoever have privilige to access orderline-details can access orderline sizes as well
                }
            }
        };

    }
})();
(function() {
    'use strict';
    
    angular
        .module('app.main.catalogs.orderline.sizes', []);
})();
(function() {
    'use strict';

    angular
        .module('app.main.catalogs.orderline.sizes')
        .run(runBlock);

    /* @ngInject */
    function runBlock(api, activityLogger, $state, utility, crud, catalogFactory) {

        if (angular.isUndefined(api.orderlines)) {
            api.orderlines = {};
        }
         api.orderlines.sizes = {
            modelPath: 'orderlines.sizes',
            fields: [
                { field: 'Id', type: 'int', displayLabel: 'ORDERLINE_SIZES.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'SizeId', type: 'int', displayLabel: 'ORDERLINE_SIZES.FIELDS.SIZE_ID', visible: true, creatable: true, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'OrderlineId', type: 'int', displayLabel: 'ORDERLINE_SIZES.FIELDS.ORDERLINE_ID', visible: false, creatable: false, editable: true, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Size', type: 'text', displayLabel: 'ORDERLINE_SIZES.FIELDS.SIZE', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'SizeIndex', type: 'text', displayLabel: 'ORDERLINE_SIZES.FIELDS.SIZE_INDEX', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'SortOrder', type: 'int', displayLabel: 'ORDERLINE_SIZES.FIELDS.SORT_ORDER', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Quantity', type: 'int', displayLabel: 'ORDERLINE_SIZES.FIELDS.QUANTITY', visible: true, creatable: true, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: 100, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Status', type: 'text', displayLabel: 'ORDERLINE_SIZES.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedDate', type: 'text', displayLabel: 'ORDERLINE_SIZES.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedDate', type: 'text', displayLabel: 'ORDERLINE_SIZES.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Created_By', type: 'text', displayLabel: 'ORDERLINE_SIZES.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Updated_By', type: 'text', displayLabel: 'ORDERLINE_SIZES.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }

            ],
            idField: 'SizeId',
            lookupDisplayField: 'SizeId',
            isDirty: false,
            isCatalogSpecificModel: true,
            methods: {},
            views: {
                mainList: {
                    columns         : [ 'Size', 'SizeIndex', 'SortOrder', 'Quantity', 'Status', 'UpdatedDate' ],
                    columnFilter    : {},
                    toggleFilterProps: { toggleStatus:false, filterProp:'Status', trueVal:1, trueValTooltipMessage: 'ACTIONS.TOGGLE_ACTIVE', falseVal:'', falseValTooltipMessage:"ACTIONS.TOGGLE_ALL"},
                    topIndex        : 0,
                    showFilterRow   : false,
                    sortColumn      : {'UpdatedDate': false},
                    itemActions     : undefined,
                    listActions     : [],
                    fabAction       : {}

                 },
                 mainDetails: {},
                privileges: {
                    list    : 'GetOrderlineDetails'// as discussed whoever have privilige to access orderline-details can access orderline sizes as well
                }
            }
        };
    }
})();
(function() {
    'use strict';
    
    angular
        .module('app.main.catalogs.buyer-limits.limits-criteria.notify-users',[])
        .config(config);

        /** @ngInject */
        function config($translatePartialLoaderProvider)
        {
            // Translation
            $translatePartialLoaderProvider.addPart('app/main/catalogs/sub-modules/buyer-limits/details/tabs/limits-criteria/details/tabs/notify-users');
        }
})();
(function() {
    'use strict';

    angular
        .module('app.main.catalogs.buyer-limits.limits-criteria.notify-users')
        .run(runBlock);

    /* @ngInject */
    function runBlock(api, catalogFactory ) {

        if (angular.isUndefined(api.customers)) {
            api.customers = {};
        }
        api.catalogs.notifyUsers = {
            modelPath: 'customers.notifyUsers',
            fields: [
                { field: 'Id', type: 'int', displayLabel: 'NOTIFY_USERS.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UserId', type: 'int', displayLabel: 'NOTIFY_USERS.FIELDS.USER_ID', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UsersIdList', type:'text', displayLabel: 'NOTIFY_USERS.FIELDS.USERS_LIST', visible: false, creatable: true, editable: true, inputType: 'lookup-many', lookupSource: 'accounts.users',
                    lookupFilter: {Status: 1} , validation: {isRequired: false, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Username', type: 'text', displayLabel: 'NOTIFY_USERS.FIELDS.USER_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: true, maxLen: 50, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'FirstName', type: 'int', displayLabel: 'NOTIFY_USERS.FIELDS.FIRST_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: true, maxLen: 20, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'LastName', type: 'text', displayLabel: 'NOTIFY_USERS.FIELDS.LAST_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: true, maxLen: 20, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Email', type: 'text', displayLabel: 'NOTIFY_USERS.FIELDS.EMAIL', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: true, maxLen: 500, minLen: 1, pattern: '^[A-Za-z]+[A-Za-z0-9._+-]+@{1}[A-Za-z0-9._-]+\.[A-Za-z.]{2,}$', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: 'VALIDATIONS.INVALID_EMAIL'}} },
                { field: 'Designation', type: 'text', displayLabel: 'NOTIFY_USERS.FIELDS.DESIGNATION', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: 20, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Department', type: 'text', displayLabel: 'NOTIFY_USERS.FIELDS.DEPARTMENT', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: 20, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Status', type: 'text', displayLabel: 'NOTIFY_USERS.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedDate', type: 'text', displayLabel: 'NOTIFY_USERS.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedDate', type: 'text', displayLabel: 'NOTIFY_USERS.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedBy', type: 'text', displayLabel: 'NOTIFY_USERS.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedBy', type: 'text', displayLabel: 'NOTIFY_USERS.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
                ],
            uniqueConstraints: [],
            title: 'NOTIFY_USERS.NAV',
            icon: 'icon-book-open',
            idField: 'Id',
            lookupDisplayField: 'UserName',
            isDirty: false,
            methods: {
                update          :   assignUsers
            },
            views: {
                mainList: {
                    columns         : [ 'UserId', 'UserName', 'FirstName','LastName', 'Email', 'Status', 'UpdatedDate' ],
                    columnFilter    : {},
                    topIndex        : 0,
                    showFilterRow   : false,
                    sortColumn      : {'UpdatedDate': false},
                    itemActions     : [],
                    listActions     : [],
                    fabAction       : {id: 'add', label: 'ACTIONS.ADD', icon: 'icon-link', privilege: 'AssignUsersToBuyerLimitAttributeCriteria:true', visible: true}
                },
                 privileges: {
                     list: 'GetBuyerLimitDetails'
                 }
            }
        };

        function assignUsers(undefined, record, parentId) {
            var requestObj = record.UsersIdList;
            var catalogCode = catalogFactory.getActiveCatalog().CatalogCode;
            var promise = api.webPut(api.baseUrl + '/catalogs/' + catalogCode + '/buyerlimits/' + parentId.buyerLimitId + '/attributecriteria/' + parentId.attributeCriteriaId + '/users', requestObj);

            promise.then(function() {
                api.catalogs.notifyUsers.isDirty = true;
            });
            return promise;
        }
    }
})();
(function() {
	'use strict';

	angular
			.module('app.main.catalogs.requests.attachments', []);
})();
(function() {
		'use strict';

		angular
				.module('app.main.catalogs.requests.attachments')
				.controller('viewAttachmentImageController', viewAttachmentImageController);

		/* @ngInject */
		function viewAttachmentImageController($mdDialog, $scope, $filter, hotkeys,
				model, record, event) {
				/* jshint validthis: true */
				var vm = this;

				//Data
				vm.model = model;

				vm.isLoading = false;
				vm.record = record;
				vm.fileName = '';
				vm.imageSource = '';

				//Methods
				vm.closeDialog = closeDialog;

				activate();

				////////////////

				function activate() {
						//Hotkeys
						hotkeys.bindTo($scope).add({
								combo: 'ctrl+enter',
								description: $filter('translate')('ACTIONS.OK'),
								allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
								callback: function(event) {
										if (!vm.isLoading ) {
												vm.closeDialog();
										}
								}
						});
				}

				function closeDialog() {
						$mdDialog.hide();
				}

		}
})();
(function() {
    'use strict';

    angular
        .module('app.main.catalogs.assortments',[
            'app.main.assortments.articles',
            'app.main.assortments.customers',
            'app.main.assortments.users'
        ])
        .config(config);

    /* @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
        // State
        $stateProvider.state('app.assortments', {
            url    : '/collections',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/catalogs/sub-modules/assortments/list/assortments-list.html',
                    controller : 'assortmentsListController as vm'
                }
            },
            data: {
                displayName: 'ASSORTMENTS.NAV'
            },
            resolve: {
                assortmentsModel: function(api, catalogFactory, $q, utility) {
                    var catalogCollectionType = catalogFactory.getActiveCatalog().CollectionsType;
                    return (function ($q) {
                        if(catalogFactory.isActiveCatalogInitialized()) {
                            return $q.when();
                        } else {
                            return catalogFactory.setActiveCatalogDetails();
                        }
                    })($q).then(function() {
                        if(catalogCollectionType === 2) {
                            var model = angular.copy(api.catalogs.assortments);
                            // var setArticlesField= utility.filterObject(model.views.mainList.itemActions, { id: 'setArticles' }, true)[0];
                            // setArticlesField.visible = false;
                            var criteriaField = utility.filterObject(model.fields, {field: 'FilterCriteria'}, true)[0];
                            criteriaField.visible = true;
                            var imageSetField = utility.filterObject(model.fields, {field: 'DunesImageSet'}, true)[0];
                            imageSetField.visible = true;
                            return model;
                        } else {
                            var model = angular.copy(api.catalogs.assortments);
                            return model;
                        }
                    });
                }
            },
            //only users with following accessPrivileges in their role access list can access this route
            //TODO- do we need to mention GetAssortmentFolderList as well since combination of both make web API make the UI-
            //if user have GetAssortmentList privilage he should also have GetAssortmentFolderList as well
            // accessPrivileges: ['GetAssortmentList']
            // accessPrivileges: ['nav_collections']
            accessInfo: {
                accessPrivileges: ['nav_collections']
            }
        });

        $stateProvider.state('app.assortments.details', {
            url	 : '/:id',
            params : {
                imageSetMap: {}
            },
            views: {
				'content@app': {
					templateUrl: 'app/main/catalogs/sub-modules/assortments/details/assortment-details.html',
					controller : 'assortmentDetailsController as vm'
				}
			},
			data: {
				parentState: 'app.assortments',
                displayName: 'ASSORTMENTS.TABS.ASSORTMENT'
			},
            resolve: {
                assortmentsModel: function(api, catalogFactory, $q, utility) {
                    var catalogCollectionType = catalogFactory.getActiveCatalog().CollectionsType;
                    return (function ($q) {
                        if(catalogFactory.isActiveCatalogInitialized()) {
                            return $q.when();
                        } else {
                            return catalogFactory.setActiveCatalogDetails();
                        }
                    })($q).then(function() {
                        if(catalogCollectionType === 2) {
                            var model = angular.copy(api.catalogs.assortments);
                            var criteriaField = utility.filterObject(model.fields, {field: 'FilterCriteria'}, true)[0];
                            criteriaField.visible = true;
                            var imageSetField = utility.filterObject(model.fields, {field: 'DunesImageSet'}, true)[0];
                            imageSetField.visible = true;
                            return model;
                        } else {
                            var model = angular.copy(api.catalogs.assortments);
                            return model;
                        }
                    });
                }
            },
            // accessPrivileges: ['GetAssortmentDetails']
            accessInfo: {
                accessPrivileges: ['GetAssortmentDetails']
            }
		});

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/catalogs/sub-modules/assortments');

        msNavigationServiceProvider.saveItem('catalogs.assortments', {
            title      : 'Collections',
            icon       : 'icon-folder-multiple',
            state      : 'app.assortments',
            translate  : 'ASSORTMENTS.NAV',
            weight     : 80,
            // accessPrivileges: ['GetAssortmentList']
            // accessPrivileges: ['nav_collections']
            accessInfo: {
                accessPrivileges: ['nav_collections']
            }
        });
    }
})();
(function() {
    'use strict';

    angular
        .module('app.main.catalogs.assortments')
        .controller('setAssortmentUsersController', setAssortmentUsersController);

    /* @ngInject */
    function setAssortmentUsersController($mdDialog, $scope, $window, $filter, hotkeys, toast, api, utility, assortmentId, activeCatalogId, model, event) {
        /* jshint validthis: true */
        var vm = this;

        //Data
        vm.api = api;
        vm.inputValues = "";
        vm.isLoading = false;
        vm.displayError = false;
        vm.record = {};
        var activeCustomers = [];


        //Methods
        vm.saveRecord = saveRecord;
        vm.closeDialog = closeDialog;


        activate();

        ////////////////

        function activate() {
            loadActiveCustomers();
            //Hotkeys
            hotkeys.bindTo($scope).add({
                combo: 'ctrl+enter',
                description: $filter('translate')('ACTIONS.SAVE'),
                allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
                callback: function(event) {
                    if (!vm.isLoading && !vm.editForm.$invalid) {
                        vm.saveRecord();
                    }
                }
            });
        }

        function saveRecord() {
            vm.isLoading = true;
            var data = createRequestObject(vm.inputValues);

            // since API dont accept empty array and sending empty array will un-asign which is should not be a behaviour for set customers
            if(data.requestObj.length) {
                model.methods.create(data, assortmentId , activeCatalogId).then(function() {
                    closeDialog(true);
                    toast.success('ASSORTMENTS.DIALOGS.MESSAGE.CUSTOMERS_SET', '', '');
                }).finally(function () {
                    closeDialog();
                    vm.isLoading = false;
                });
            }
            else {
                vm.displayError = true;
                vm.isLoading = false;
            }
        }

        function closeDialog(saved) {
            $mdDialog.hide(saved);
        }

        /**
         * Load all the acticve customers which are not assigned to assortment
         */
        function loadActiveCustomers() {
            // var isLogRequired = false;
            api.getLookupData(api.catalogs.customers).then(function(result) {
                result.data = utility.filterObject(result.data, {Status: 1});
                activeCustomers = result;
            });
        }

        /**
         * @description
         *   a helpre method which creats request object
         *
         * @param {string}  userInput       : user input in string formate
         * @return {object} an object containing request object and items name list(for logging purpose)
         */
        function createRequestObject(userInput) {
            var result = {
                requestObj: [],
                itemsNameList: []
            };
            var customersCode = userInput.match(/[^\r\n]+/g);

            // creating array of object {CustomerId: id} by matching entered text against list of available customer
            var customers = customersCode.map(function(customerCode) {

                //if entered input exist in list of available customers
                var customer = utility.filterObject(activeCustomers.data, {value: customerCode}, true)[0];
                if(angular.isDefined(customer)) {
                    var rCustomer = {};
                    rCustomer[model.idField] = customer.id;
                    rCustomer[model.lookupDisplayField] = customer.value;
                    return rCustomer;
                }
            });

            // removeing undefined entries created during map operation by not matching criteria
            for(var i=customers.length-1; i>=0 ; i--) {
                if(angular.isUndefined(customers[i])){
                    customers.splice(i,1);
                }
            }

            // create request object
            result.requestObj = customers.map(function (customer) {
                var rObj = {};
                rObj[model.idField] = customer[model.idField];
                return rObj;
            });
            // create items name list used for logging
            angular.forEach(customers, function(assignedCustomer) {
                result.itemsNameList.push(assignedCustomer[model.lookupDisplayField])
            });
            return result;
        }
    }
})();
(function() {
    'use strict';
    
    angular
        .module('app.main.catalogs.articles.sizes', []);
})();
(function() {
    'use strict';

    angular
        .module('app.main.catalogs.articles.sizes')
        .controller('assignSizeController', assignSizeController);

    /**ngInject */
    function assignSizeController($mdDialog, $log, $q, $scope, $filter, $window, $document, hotkeys, toast, utility, dialog, model, inheritedArticleSizes, activeCatalog,
        articleId, dataPromise) {
        var vm = this;

        //data
        var parentActiveSizes = [];
        var availableSizes = [];
        var SizesMapObj = {};// map key value pair of article's sizes with size idField as key and size Status as value
        vm.model = model;
        vm.lookupModel = {};
        var requestObj = {};
        vm.isLoading = false;
        vm.isDataDirty = false;
        vm.searchText = {};


        //methods
        vm.saveRecord = saveRecord;
        vm.closeDialog = closeDialog;

        vm.lookupSearch = lookupSearch;
        vm.lookupChange = lookupChange;
        vm.selectText = selectText;


        activate();

        ////////////////

        function activate() {
            createSizesMapObj(inheritedArticleSizes);
            loadAvailableSizes();
            //Hotkeys
            hotkeys.bindTo($scope)
                .add({
                    combo: 'ctrl+enter',
                    description: $filter('translate')('ACTIONS.SAVE'),
                    allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
                    callback: function(event) {
                        if (!vm.isLoading && !vm.editForm.$invalid) {
                            vm.saveRecord();
                        }
                    }
                });

            hotkeys.bindTo($scope)
                .add({
                    combo: 'ctrl+shift+enter',
                    description: $filter('translate')('ACTIONS.SAVE_AND_NEW'),
                    allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
                    callback: function(event) {
                        if (!vm.isLoading && !vm.editForm.$invalid) {
                            vm.saveRecord(true);
                        }
                    }
                });
        }

        function saveRecord(saveAndNew) {
            vm.isLoading = true;
            requestObj.activeCatalogId = activeCatalog.CatalogCode;//used in create method to pass as API's catalogCode
            var p;
            if(angular.isUndefined(SizesMapObj[requestObj[model.lookupDisplayField].trim()])) { // if not created call create api, else call update status
                p = model.methods.create(requestObj, articleId)
                .then(function(response) {
                    if(response.status === 202) {
                        dialog.showAlertDialog(
                            angular.element($document.body),
                            $filter('translate')('MESSAGES.TITLE.ALERT'),
                            $filter('translate')('MESSAGES.CONTENT.CHANGE_REQUEST_ALERT'),
                            $filter('translate')('MESSAGES.TITLE.ALERT'),
                            $filter('translate')('ACTIONS.DIALOG_CLOSE'),
                            !!saveAndNew,
                            null);
                    }
                    else {
                        toast.success('SUCCESS.LINKED', '', '');
                    }
                });
            }
            else {
                var predicate = {};
                // since requestObject derived from availableSizes and itself derived from parent article sizes and will have different Ids which will cause issue with update status api
                predicate[model.lookupDisplayField] = requestObj[model.lookupDisplayField].trim();
                var inheritedRecord = utility.filterObject(inheritedArticleSizes, predicate, true);
                if(inheritedRecord.length>0) {
                    $log.warn('filter based on lookupDisplayField can cause issue');
                }
                p = model.methods.activateBulk(inheritedRecord[0], model, 'activate', articleId, {customMessage: 'SUCCESS.LINKED' });
            }

            p.then(function(response) {
            if (angular.isDefined(saveAndNew) && saveAndNew) {
                vm.editForm.$setPristine();
                vm.editForm.$setUntouched();
                vm.lookupModel['Size'] = undefined;
                vm.searchText = {};
                updateAvailableSizes(requestObj);

                // if isDataDirty is true keep it true otherwise make it true when response.status != 202
                vm.isDataDirty = vm.isDataDirty || (response.status !== 202);

                var el = $window.document.getElementById('dialog_input_assignSize');
                if (el) {
                    el.focus();
                }
            }
            else {
                closeDialog(true);
            }

            }, function(err) {
                closeDialog(vm.isDataDirty);
            }).finally(function () {
                vm.isLoading = false;
            })
        }

        function closeDialog(saved) {
            $mdDialog.hide(saved);
        }

        function lookupSearch(query) {
            var results = [];

            if(availableSizes.length) {
                results = query ? utility.filterObject(availableSizes , {SizeName: query}) : availableSizes;
                return results;
            }
            else {
                return loadAvailableSizes().then(function(reolvedVals) {
                    results = query ? utility.filterObject(reolvedVals , {SizeName: query}) : reolvedVals;
                    return results;
                });
            }
        }

        function lookupChange(selectedObj) {
            if(angular.isObject(selectedObj)) {
                requestObj = selectedObj;
            }
            else if(angular.isUndefined(selectedObj) || selectedObj === null){
                requestObj = undefined;
            }
        }

        function selectText(event) {
            utility.selectInputText(event);
        }

        function loadAvailableSizes() {
            var deferred = $q.defer();
            dataPromise['parentSizes'].then(function(response) {
                parentActiveSizes = utility.filterObject(response.data, {Status: 1});
                angular.forEach(parentActiveSizes, function(parentActiveSize) {
                    //if parent article size is not created for inherited article or if created but in active
                    if(angular.isUndefined(SizesMapObj[parentActiveSize[model.lookupDisplayField].trim()]) || SizesMapObj[parentActiveSize[model.lookupDisplayField].trim()] == 0) {
                        availableSizes.push(parentActiveSize);
                    }
                });
                deferred.resolve(availableSizes);
            });
            return deferred.promise;
        }

        // creates index of inherited article's sizes (inherited article's active and inactive sizes)
        function createSizesMapObj(inheritedArticleSizes) {
            angular.forEach(inheritedArticleSizes, function(inheritedArticleSize) {
                SizesMapObj[inheritedArticleSize[model.lookupDisplayField].trim()] = inheritedArticleSize['Status'];
            });
        }

        function updateAvailableSizes(assignedSize) {
            availableSizes.length = 0;
            SizesMapObj[assignedSize[model.lookupDisplayField]] = 1;
            loadAvailableSizes();
        }
    }
})();
(function() {
	'use strict';

	angular
		.module('app.main.accounts.sellers.seller-lookup-table.values',[]);
})();

(function() {
	'use strict';

	angular
		.module('app.main.accounts.sellers.seller-lookup-table.values')
		.run(runBlock);

	/* @ngInject */
	function runBlock(api) {

		if(angular.isUndefined(api.sellers)) {
			api.sellers = {};
		}

		api.sellers.lookupValues = {
			modelPath: 'sellers.lookupValues',
			fields: [
				{ field: 'CreatedDate', type: 'text', displayLabel: 'SELLER_LOOKUP_TABLE.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'CreatedBy', type: 'text', displayLabel: 'SELLER_LOOKUP_TABLE.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				],
			uniqueConstraints: [],
			title: 'SELLER_LOOKUP_TABLE.TABS.VALUES',
			icon: 'icon-book-open',
			idField: '',
			lookupDisplayField: '',
			isDirty: false,
			methods: {
				createBulk          :   importLookupValues
			},
			views: {
				mainList: {
					columns         : [ 'CreatedBy', 'CreatedDate' ],
					columnFilter    : {},
					topIndex        : 0,
					showFilterRow   : false,
					sortColumn      : {'CreatedDate': false},
					itemActions     : [],
					listActions     : [
						{ id: 'import', label: 'ACTIONS.IMPORT', icon: 'icon-import', privilege: 'ImportLookupValues', disabled: false, visible: true},
					],
					fabAction       : {}
				},
				 privileges: {
					 list: 'GetLookupDefinitionDetails'
				 }
			}
		};

		function importLookupValues(model, records, lookupId, sellerId) {
			var requestArray = [];
			angular.forEach(records, function(record) {
				var reqObj = {
					Source: {},
					Destination: {}
				};
				angular.forEach(model.fields, function(field) {
					if(field.displayLabel.startsWith('S:')) {
						reqObj.Source[field.field] = record[field.field];
					} else if(field.displayLabel.startsWith('D:')) {
						reqObj.Destination[field.field] = record[field.field];
					}
				});
				requestArray.push(reqObj);
			});
			var promise = api.webPut(api.baseUrl + '/sellers/' + sellerId + '/lookups/' + lookupId +'/import' , requestArray);

			promise.then(function() {
				api.sellers.lookupValues.isDirty = true;
			});
			return promise;
		}
	}
})();
(function() {
	'use strict';

	angular
		.module('app.main.accounts.sellers.seller-datasets.values',[]);
})();

(function() {
	'use strict';

	angular
		.module('app.main.accounts.sellers.seller-datasets.values')
		.run(runBlock);

	/* @ngInject */
	function runBlock(api, $state, activityLogger, utility, jobsTracker, toast) {

		if(angular.isUndefined(api.sellers)) {
			api.sellers = {};
		}

		api.sellers.datasetValues = {
			modelPath: 'sellers.datasetValues',
			fields: [
				{ field: 'Id', type: 'int', displayLabel: 'SELLER_DATASETS.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'DisplayValue', type: 'text', displayLabel: 'SELLER_DATASETS.FIELDS.DISPLAY_VALUE', visible: true, creatable: false, editable: false, showInEdit: true, inputType: 'textArea',
					validation: {isRequired: true, maxLen: 1000, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'Status', type: 'text', displayLabel: 'SELLER_DATASETS.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'CreatedDate', type: 'text', displayLabel: 'SELLER_LOOKUP_TABLE.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'CreatedBy', type: 'text', displayLabel: 'SELLER_LOOKUP_TABLE.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'UpdatedDate', type: 'text', displayLabel: 'SELLER_DATASETS.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'UpdatedBy', type: 'text', displayLabel: 'SELLER_DATASETS.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				],
			uniqueConstraints: [],
			title: 'SELLER_DATASETS.TABS.VALUES',
			icon: 'icon-book-open',
			idField: 'Id',
			lookupDisplayField: 'DisplayValue',
			isDirty: false,
			methods: {
				getList     :   getDatasetValues,
				createBulk  :   createDatasetValues,
				updateBulk  :   updateDatasetValues,
				deleteBulk  :   deleteDatasetValues,
			},
			views: {
				mainList: {
					columns         : [ 'Id', 'DisplayValue', 'Status', 'UpdatedBy', 'UpdatedDate' ],
					columnFilter    : {},
					topIndex        : 0,
					showFilterRow   : false,
					sortColumn      : {'UpdatedDate': false},
					itemActions     : [
						{ id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'DeleteDatasetValues', disabled: false, visible: 'itm.Status',
							requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'}
					],
					listActions     : [
						{ id: 'import', label: 'SELLER_DATASETS.ACTIONS.CREATE_DATASETS_VALUES', icon: 'icon-import', privilege: 'CreateDatasetValues', disabled: false, visible: true},
						{ id: 'updateBulk', label: 'ACTIONS.UPDATE_BULK', icon: 'icon-pencil', privilege: 'UpdateDatasetValues:true', disabled: '{selected: true}', visible: true, requiresConfirmation: false },
						{ id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'DeleteDatasetValues', disabled: '{selected: true, Status: 1}', visible: true, requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
					],
					fabAction       : {}
				},
				privileges: {
					list: 'GetDatasetValues'
				}
			}
		};

		function getDatasetValues(generalProperties, sellerId, datasetId) {
			var promise;
			if (angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
					var state = {};
					state.name = $state.current.name;
					state.params = $state.params;
					var isBulk = true;
					var logData = activityLogger.createLogData(null, state, 'sellers.datasetValues', 'VIEW', isBulk, new Date(), null, null);
					promise = api.webGet(api.t1v2URL + '/sellers/' + sellerId + '/datasets/' + datasetId + '/values', undefined, true, generalProperties.forceFetch);
					promise = activityLogger.log(logData, promise);
			}
			else {
					promise = api.webGet(api.t1v2URL + '/sellers/' + sellerId + '/datasets/' + datasetId + '/values', undefined, true, generalProperties.forceFetch);
			}

			promise.then(function () {
				if (api.sellers.datasetValues.isDirty) {
					//Invalidate lookupData
					api.sellers.datasetValues.lookupData = undefined;
					api.sellers.datasetValues.isDirty = false;
				}
				api.sellers.datasetValues.isBulkActionCompleted = false;
			});
			return promise;
		}

		function createDatasetValues(model, records, datasetId, sellerId) {
			// Coerce each value to its declared dataset-attribute type so the
			// payload uses native JSON types (int/bool/string) instead of stringifying.
			var dynamicAttributes = utility.filterObject(model.fields, {isDynamicProperty: true}, true);
			var typedRecords = records.map(function(record) {
				var typed = {};
				angular.forEach(record, function(val, key) {
					var field = utility.filterObject(dynamicAttributes, {field: key}, true)[0];
					typed[key] = field ? utility.coerceByAttributeType(val, field) : val;
				});
				return typed;
			});

			var state = {};
			state.name = $state.current.name;
			state.params = $state.params;
			var logData = activityLogger.createLogData(null, state, 'sellers.datasetValues', 'ADD', false, new Date(), null, null);
			var promise = api.webPost(api.t1v2URL + '/sellers/' + sellerId + '/datasets/' + datasetId + '/values', typedRecords);
			promise.then(function() {
				api.sellers.datasetValues.isDirty = true;
			});
			return activityLogger.log(logData, promise);
		}

		// Soft-delete dataset values (single or bulk) via the T1 API V2 endpoint.
		// The same method serves the row action (one-item array) and the bulk list action.
		function deleteDatasetValues(records, sellerId, datasetId) {
			if (!angular.isArray(records)) {
				records = utility.pushItemToArray(records);
			}
			var ids = records.map(function (record) { return record.Id; });
			var state = {};
			state.name = $state.current.name;
			state.params = $state.params;
			var isBulk = ids.length > 1;
			var logData = activityLogger.createLogData(records, state, 'sellers.datasetValues', 'DELETE', isBulk, new Date(), null, null);
			var promise = api.webDelete(api.t1v2URL + '/sellers/' + sellerId + '/datasets/' + datasetId + '/values', ids);

			promise.then(function () {
				api.sellers.datasetValues.isDirty = true;
				toast.success(isBulk ? 'SUCCESS.DELETE_BULK' : 'SUCCESS.DELETE', '', '');
			});
			return activityLogger.log(logData, promise);
		}

		function updateDatasetValues(model, records, updateRecord, idMap) {
			var jobIndex = jobsTracker.addJob(api.sellers.datasetValues, 'SELLER_DATASETS.MESSAGES.UPDATE_VALUES', 1);
			var dynamicAttributes = utility.filterObject(model.fields, {isDynamicProperty: true}, true);
			var requestObjects = []
			angular.forEach(records, function(record) {
				var valueObj = {};
				angular.forEach(dynamicAttributes, function(attr) {
					var raw = updateRecord.hasOwnProperty(attr.field) ? updateRecord[attr.field] : record[attr.field];
					valueObj[attr.field] = utility.coerceByAttributeType(raw, attr);
				});

				requestObjects.push({
					Id: record.Id,
					Value: valueObj
				});
			});

			var state = {};
			state.name = $state.current.name;
			state.params = $state.params;
			var logData = activityLogger.createLogData(null, state, 'sellers.datasetValues', 'EDIT', false, new Date(), null, null);
			var promise = api.webPut(api.baseUrl + '/sellers/' + idMap.sellerId + '/datasets/' + idMap.datasetId + '/values', requestObjects);

			promise.then(function(response) {
				jobsTracker.trackJob(jobIndex, response.data.Id);
			}).catch(function(error) {
				jobsTracker.setCriticlaFail(jobIndex, error);
			});
			return activityLogger.log(logData, promise);
		}
	}
})();
(function() {
	'use strict';

	angular
		.module('app.main.accounts.sellers.capacities', [])
		.config(config);

	/* @ngInject */
	function config($stateProvider) {

		// Capacity details (Seller > Capacities > Details)
		$stateProvider.state('app.seller_capacity_details', {
			url  : '/sellerId/:sellerId/capacityId/:capacityId',
			params: { capacity: {} },
			views: {
				'content@app': {
					templateUrl: 'app/main/accounts/sellers/details/tabs/capacities/details/capacity-details.html',
					controller : 'capacityDetailsController as vm'
				}
			},
			data: {
				displayName: 'SELLERS.CAPACITIES.NAV',
				parentState: 'app.accounts_sellers'
			},
			accessInfo: {
				accessPrivileges: ['GetCapacityDetails']
			}
		});
	}
})();

(function() {
	'use strict';

	// Read-only model for the "Linked Customers" tab on the Capacity Details page.
	// Data is fed directly from the API-3 (Get Capacity Details) response's Customers[] array
	// via tx-data; this model defines no methods and no write actions.
	//
	// API 3 returns ONE ROW PER CUSTOMER PER CATALOG - a capacity is seller-owned and reusable, but its
	// assignment (and the article/model figures) belongs to a single catalog. The same CustomerId therefore
	// repeats once per catalog it is linked in, so the row key is the synthesized LinkId (CustomerId-CatalogCode)
	// built by capacityDetailsController, not CustomerId. Deactivated links (Status 0) ARE returned here.
	angular
		.module('app.main.accounts.sellers.capacities')
		.run(runBlock);

	/* @ngInject */
	function runBlock(api) {

		if(angular.isUndefined(api.capacities)) {
			api.capacities = {};
		}

		// NOTE(modelPath): renamed from 'capacities.customers' when API 3 became per-catalog.
		// settingsFactory.applyPersistedListViewLayout REPLACES views.mainList.columns with the
		// user's persisted column set for this modelPath, so anyone who had already saved a layout
		// for the old 4-column grid would never see the new CatalogCode/CatalogName/Status columns.
		// A new key retires those stale entries. Keep this string in step with the registration path
		// below - api.getModel() resolves a model by walking `api` along modelPath.
		api.capacities.customerLinks = {
			modelPath: 'capacities.customerLinks',
			fields: [
				// Synthesized client-side (CustomerId-CatalogCode) - API 3 has no single-column row key now that
				// the same customer is returned once per catalog. See capacity-details.controller.js.
				{ field: 'LinkId', type: 'text', displayLabel: 'SELLERS.CAPACITIES.LINKED_CUSTOMERS.FIELDS.LINK_ID', visible: false, creatable: false, editable: false, inputType: 'text',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'CustomerId', type: 'int', displayLabel: 'SELLERS.CAPACITIES.LINKED_CUSTOMERS.FIELDS.CUSTOMER_ID', visible: false, creatable: false, editable: false, inputType: 'number',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'CustomerCode', type: 'text', displayLabel: 'SELLERS.CAPACITIES.LINKED_CUSTOMERS.FIELDS.CUSTOMER_CODE', visible: true, creatable: false, editable: false, inputType: 'text',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'CustomerName', type: 'text', displayLabel: 'SELLERS.CAPACITIES.LINKED_CUSTOMERS.FIELDS.CUSTOMER_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'ArticleCapacity', type: 'int', displayLabel: 'SELLERS.CAPACITIES.FIELDS.ARTICLE_CAPACITY', visible: true, creatable: false, editable: false, inputType: 'number',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'ModelCapacity', type: 'int', displayLabel: 'SELLERS.CAPACITIES.FIELDS.MODEL_CAPACITY', visible: true, creatable: false, editable: false, inputType: 'number',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				// The catalog the link belongs to - without it the same customer renders as indistinguishable rows.
				{ field: 'CatalogCode', type: 'int', displayLabel: 'SELLERS.CAPACITIES.LINKED_CUSTOMERS.FIELDS.CATALOG_CODE', visible: true, creatable: false, editable: false, inputType: 'number',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'CatalogName', type: 'text', displayLabel: 'SELLERS.CAPACITIES.LINKED_CUSTOMERS.FIELDS.CATALOG_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				// Link status (0 = deactivated for that catalog). API 3 returns deactivated links too.
				{ field: 'Status', type: 'text', displayLabel: 'SELLERS.CAPACITIES.LINKED_CUSTOMERS.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
			],
			title: 'SELLERS.CAPACITIES.LINKED_CUSTOMERS.NAV',
			icon: 'icon-account-multiple',
			idField: 'LinkId',
			lookupDisplayField: 'CustomerName',
			isDirty: false,
			methods: {},
			views: {
				mainList: {
					columns       : [ 'CustomerCode', 'CustomerName', 'CatalogCode', 'CatalogName', 'ArticleCapacity', 'ModelCapacity', 'Status' ],
					columnFilter  : {},
					topIndex      : 0,
					showFilterRow : false,
					// tx-data-table's doSort dereferences view.sortColumn before it would create one,
					// so the grid must ship with an initial sort column or every sort click throws.
					sortColumn    : {'CustomerName': false},
					itemActions   : [],
					listActions   : [],
					fabAction     : {}
				},
				mainDetails: {},
				// The tab read has no dedicated backend privilege - it rides on the API 3 response the page
				// already fetched - so it is gated on GetCapacityDetails (4041), the same privilege as the page.
				privileges: {
					list: 'GetCapacityDetails'
				}
			}
		};
	}
})();

(function () {
    'use strict';

    angular
        .module('app.main.catalogs.resources.models', []);
})();
(function() {
    'use strict';

    angular
        .module('app.main.catalogs.resources.models')
        .controller('assignModelsController', assignModelsController);

    /* @ngInject */
    function assignModelsController(api, $scope, $window, $filter, hotkeys, $mdDialog, utility, toast,
                defaultValues, assignedModels, resourceId, activeCatalogCode, lookupPromises, event) {
        /* jshint validthis: true */
        var vm = this;

        //Data
        var resourceModelsModel = api.resources.models;
        var linkedModelsModel = api.catalogs.models;

        vm.isLoading = false;
        vm.isDataDirty = false;
        vm.record = defaultValues;
        vm.record.ModelIds = [];
        vm.modelLookup = {};
        vm.acLookupModel = {};
        vm.searchText = {};

        //Methods
        vm.saveRecord = saveRecord;
        vm.closeDialog = closeDialog;

        vm.lookupSearch = lookupSearch;
        vm.getLookupDisplayValue = getLookupDisplayValue;
        vm.selectText = selectText;

        activate();

        ////////////////

        function activate() {
            loadAvailableModels();
            hotkeys.bindTo($scope).add({
                combo: 'ctrl+enter',
                description: $filter('translate')('ACTIONS.SAVE'),
                allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
                callback: function() {
                    if (!vm.isLoading && !vm.editForm.$invalid) {
                        vm.saveRecord();
                    }
                }
            });
            hotkeys.bindTo($scope).add({
                combo: 'ctrl+shift+enter',
                description: $filter('translate')('ACTIONS.SAVE_AND_NEW'),
                allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
                callback: function() {
                    if (!vm.isLoading && !vm.editForm.$invalid) {
                        vm.saveRecord(true);
                    }
                }
            });
        }

        function saveRecord(saveAndNew) {
            if(angular.isDefined(vm.acLookupModel.ModelIds) && angular.isDefined(vm.acLookupModel.ModelIds.id)){
                var modelObj = {};
                modelObj[resourceModelsModel.idField] = vm.acLookupModel.ModelIds.id;
                assignedModels.push(modelObj);
            }
            var recordCopy = angular.copy(vm.record);
            angular.forEach(assignedModels, function(assignedModel) {
                recordCopy.ModelIds.push(assignedModel.ModelId || assignedModel[resourceModelsModel.idField]);
            });
            resourceModelsModel.methods.assign(resourceId, recordCopy, activeCatalogCode).then(function() {
                if (angular.isDefined(saveAndNew) && saveAndNew) {
                    vm.editForm.$setPristine();
                    vm.editForm.$setUntouched();
                    updateAssignedModels();
                    vm.record = defaultValues;
                    vm.record.ModelIds = [];
                    vm.searchText = {};
                    vm.isDataDirty = true;
                    var el = $window.document.getElementById('dialog_input_first');
                    if (el) {
                        el.focus();
                    }
                }
                else {
                    closeDialog(true);
                }
                toast.success('SUCCESS.LINKED', '', '');
            }, function() {
                closeDialog(vm.isDataDirty);
            }).finally(function () {
                vm.isLoading = false;
            });
        }

        function closeDialog(isSaved) {
            $mdDialog.hide(isSaved);
        }

        function lookupSearch(query, fieldName) {
            var results = [];
            var lookupFilter = {Status: 1};
            var predicate = angular.copy(lookupFilter);
            predicate.value = query;

            if(angular.isDefined(vm.modelLookup.data) && vm.modelLookup.data.length) {
                results = query ? utility.filterObject(vm.modelLookup.data, predicate) : utility.filterObject(vm.modelLookup.data, lookupFilter);
                return results;
            }
            else {
                return loadAvailableModels().then(function() {
                    results = query ? utility.filterObject(vm.modelLookup.data, predicate) : utility.filterObject(vm.modelLookup.data, lookupFilter);
                    return results;
                });
            }
        }

        function getLookupDisplayValue(item, fieldName) {
            if(angular.isDefined(linkedModelsModel.lookupData) && angular.isDefined(linkedModelsModel.lookupData.data) && linkedModelsModel.lookupData.data.length) {
                return getLookupDisplayVal(item, linkedModelsModel.lookupData);
            }
            else {
                return lookupPromises['ModelIds'].then(function(lookupData) {
                    return getLookupDisplayVal(item, lookupData);
                });
            }
        }

        function getLookupDisplayVal(item, lookupData) {
            var result;
            if(lookupData) {
                if(angular.isObject(item)) {
                    result = utility.filterObject(lookupData.data, {id: item.id}, true);
                }
                else {
                    result = utility.filterObject(lookupData.data, {id: item}, true);
                }

                if (angular.isArray(result) && result.length > 0) {
                    return result[0].value;
                }
                else {
                    return result.value;
                }
            }
        }

        function selectText(event) {
            utility.selectInputText(event);
        }

        function loadAvailableModels() {
            return lookupPromises['ModelIds'].then(function(result) {
                var resultClone = angular.copy(result);
                resultClone.data = utility.filterObject(resultClone.data, {Status: 1});
                angular.forEach(assignedModels, function(assignedModel) {
                    var index = resultClone.data.indexOf(utility.filterObject(resultClone.data, {id: assignedModel[resourceModelsModel.idField]}, true)[0]);
                    if(index !== -1) {
                        resultClone.data.splice(index, 1);
                    }
                });
                vm.modelLookup = resultClone;
            });
        }

        function updateAssignedModels() {
            loadAvailableModels();
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.main.catalogs.resources.articles', []);
})();
(function() {
    'use strict';

    angular
        .module('app.main.catalogs.resources.articles')
        .controller('assignArticlesController', assignArticlesController);

    /* @ngInject */
    function assignArticlesController(api, $scope, $window, $filter, hotkeys, $mdDialog, utility, toast, 
                defaultValues, asignedArticles, resourceId, activeCatalogCode, lookupPromises, event) {
        /* jshint validthis: true */
        var vm = this;       
        
        //Data
        var resourceArticlesModel = api.resources.articles;        
        var linkedArticlesModel = api.catalogs.articles;
        
        vm.isLoading = false;
        vm.isDataDirty = false;
        vm.record = defaultValues;
        vm.record.ArticleIds = [];
        vm.resourceTypes = [];            
        vm.articleLookup = {};
        vm.acLookupModel = {};
        vm.searchText = {};
           

        //Methods           
        vm.saveRecord = saveRecord;
        vm.closeDialog = closeDialog;
        
        vm.lookupSearch = lookupSearch;
        vm.getLookupDisplayValue = getLookupDisplayValue;
        vm.selectText = selectText;
        
                    
        activate();

        ////////////////

        function activate() {     
            loadAvailableArticles();
            //Hotkeys
            hotkeys.bindTo($scope).add({
                combo: 'ctrl+enter',
                description: $filter('translate')('ACTIONS.SAVE'),
                allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
                callback: function(event) {
                    if (!vm.isLoading && !vm.editForm.$invalid) {
                        vm.saveRecord();
                    }
                }
            });
            hotkeys.bindTo($scope).add({
                combo: 'ctrl+shift+enter',
                description: $filter('translate')('ACTIONS.SAVE_AND_NEW'),
                allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
                callback: function(event) {
                    if (!vm.isLoading && !vm.editForm.$invalid) {
                        vm.saveRecord(true);
                    }
                }
            });
        }
        
        function saveRecord(saveAndNew) {
            if(angular.isDefined(vm.acLookupModel.ArticleIds) && angular.isDefined(vm.acLookupModel.ArticleIds.id)){
                var articleObj = {};
                articleObj[resourceArticlesModel.idField] = vm.acLookupModel.ArticleIds.id;
                asignedArticles.push(articleObj);                
            }
            var recordCopy = angular.copy(vm.record); // to avoid display pushed existing records
            angular.forEach(asignedArticles, function(asignedArticle) {                
                // push assigned article Ids
                recordCopy.ArticleIds.push(asignedArticle[resourceArticlesModel.idField]);
            });
            resourceArticlesModel.methods.assign(resourceId, recordCopy, activeCatalogCode).then(function() {

                if (angular.isDefined(saveAndNew) && saveAndNew) {
                    vm.editForm.$setPristine();
                    vm.editForm.$setUntouched();
                    updateAsignedArticles(); 
                    vm.record = defaultValues;
                    vm.record.ArticleIds = [];
                    vm.acSearchText = [];
                    vm.searchText = {};
                    vm.isDataDirty = true;                    
                    var el = $window.document.getElementById('dialog_input_first');
                    if (el) {
                        el.focus();
                    }
                }
                else {
                    closeDialog(true);
                }
                toast.success('SUCCESS.LINKED', '', '');
            }, function(err) {
                closeDialog(vm.isDataDirty);
            }).finally(function () {
                vm.isLoading = false;
            }); 
        }
        
        function closeDialog(isSaved) {
            $mdDialog.hide(isSaved);
        }

        function lookupSearch(query, fieldName) { // to avoid filtering out alrady assigned articles filter them in loadAvailable articles and assign it in scope var "vm.articleLookup"
            var results = [];            

            // var field = utility.filterObject(model.fields, {field: fieldName})[0];
            var lookupFilter = {Status: 1} //field.lookupFilter ? field.lookupFilter : {};            
            var predicate = angular.copy(lookupFilter);            
            predicate.value = query;

            if(angular.isDefined(vm.articleLookup.data) && vm.articleLookup.data.length) {
                results = query ? utility.filterObject(vm.articleLookup.data , predicate) :  utility.filterObject(vm.articleLookup.data, lookupFilter);
                return results;                
            }   
            else {
                return loadAvailableArticles().then(function() {
                    results = query ? utility.filterObject(vm.articleLookup.data , predicate) :  utility.filterObject(vm.articleLookup.data, lookupFilter);
                    return results;
                });
            }
        }

        function getLookupDisplayValue(item, fieldName) {
            if(angular.isDefined(linkedArticlesModel.lookupData) && angular.isDefined(linkedArticlesModel.lookupData.data) && linkedArticlesModel.lookupData.data.length) {
                return getLookupDisplayVal(item, linkedArticlesModel.lookupData);
            }
            else {
                return lookupPromises['ArticleIds'].then(function(lookupData) {
                    return getLookupDisplayVal(item, lookupData);
                });
            }    
        }

        //helper method
        function getLookupDisplayVal(item, lookupData) {
            var result;
            if(lookupData) {
                // since autocomplte return object                
                if(angular.isObject(item)) {
                    result = utility.filterObject(lookupData.data, {id: item.id}, true);
                }
                // to initialize field value if any (when open update record dialog)         
                else {                     
                    result = utility.filterObject(lookupData.data, {id: item}, true);                                       
                }               
                
                if (angular.isArray(result) && result.length > 0) {
                    return result[0].value;
                } 
                else {
                    return result.value;
                }
            }
        }

        function selectText(event) {
            utility.selectInputText(event);         
        }


        //Helper Methods 
        
        function loadAvailableArticles() {
            // return api.getLookupData(linkedArticlesModel).then(function(result) {
            return lookupPromises['ArticleIds'].then(function(result) {    
                var resultClone = angular.copy(result);                
                //filter lookup data with active records
                resultClone.data = utility.filterObject(resultClone.data, {Status: 1});
                //Remove already assigned articles
                angular.forEach(asignedArticles, function(asignedArticle) {
                    var index = resultClone.data.indexOf(utility.filterObject(resultClone.data, {id: asignedArticle[resourceArticlesModel.idField]}, true)[0]);
                    if(index !== -1) {
                        resultClone.data.splice(index, 1);
                    }                    
                });
                
                //update indexArray of dirty lookup if needed
                // utility.updateLookupDataIndexes(resultClone);
                vm.articleLookup = resultClone;
            });
        }

        // decorator method
        function updateAsignedArticles() {
            loadAvailableArticles();
        }
        
    }
})();
(function () {
    'use strict';

    angular
        .module('app.main.catalogs.orderline', [
            'app.main.catalogs.orderline.vas',
            'app.main.catalogs.orderline.sizes'
        ])
        .config(config);

    /* @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider) {
        $stateProvider.state('app.orders.details.orderline-details', {
			url	 : '/orderline/:orderlineId',
			params: {
				OrderProcessStatusId: null,
				Orderline: undefined,
				Order: undefined
			},
            views: {
				'content@app': {
					templateUrl: 'app/main/catalogs/sub-modules/orders/details/tabs/order-line/details/orderline-details.html',
					controller : 'orderlineDetailsController as vm'
				}
			},
            resolve: {
                orderLineModel : function(catalogFactory, $stateParams, utility) {
                    var orderlineModel = catalogFactory.createOrderlineModel();
                    if($stateParams.OrderProcessStatusId === 1 || $stateParams.OrderProcessStatusId === 5) {
                        utility.filterObject(orderlineModel.views.mainDetails.itemActions, { id: 'activate' }, true)[0].visible = false;
                    }

                    // disable order creation and updation when order by size curve is enables
                    if(catalogFactory.getActiveCatalog().OrderBySizeCurve) {
                        utility.filterObject(orderlineModel.views.mainList.itemActions, { id: 'edit' }, true)[0].visible = false;
                        utility.filterObject(orderlineModel.views.mainList.listActions, { id: 'saveOrders' }, true)[0].visible = false;
                        orderlineModel.views.mainList.fabAction.visible = false;
                    }
                    // if stock enabled then hide delivery date field
                    var activeCatalog = catalogFactory.getActiveCatalog();
                    if(activeCatalog.IsStockApply) {
                        var deliveryDateField = utility.filterObject(orderlineModel.fields, {field: 'CrdId'}, true)[0];
                        deliveryDateField.visible = false;
                    }
                    return orderlineModel;
                }
            },
			data: {
				parentState: 'app.orders.details',
                displayName: 'ORDERLINE.TABS.ORDERLINE'
            },
            // accessPrivileges: ['GetOrderlineDetails']
            accessInfo: {
                accessPrivileges: ['GetOrderlineDetails']
            }
		});

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/catalogs/sub-modules/orders/details/tabs/order-line');
    }
})();
(function() {
    'use strict';

    angular.module('app.main.catalogs.orderline')
    .factory('orderlineDialog', orderlineDialog);

    /** @ngInject */
	function orderlineDialog
    (api, $mdDialog) {

        //Data
		var dialogObj = {
                controller         : 'orderlineDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/catalogs/sub-modules/orders/details/tabs/order-line/dialogs/orderline-dialog.html',
                targetEvent        : null,
                clickOutsideToClose: false,
                locals             : {}
            };
		//Methods
		var service = {
			showCreateOrderlineDialog: showCreateOrderlineDialog,
            showUpdateOrderlineDialog: showUpdateOrderlineDialog,
            createStocksSizeMap: createStocksSizeMap,
            transforArticleStockResponse: transforArticleStockResponse
		};

		return service;


        //Methods implementation

        function showCreateOrderlineDialog(parent, targetEvent, model, order, defaultValues) {
            var promises = {};
            angular.forEach(model.fields, function(field) {
                if ((field.editable || field.creatable || field.visible) && (field.inputType === 'lookup' || field.inputType === 'lookup-many')
                 && angular.isDefined(field.lookupSource)) {
                    var lookupModel = api.getModel(field.lookupSource);
                    promises[field.field] = api.getLookupData(lookupModel);
                }
            });

            dialogObj.parent = angular.element(parent);
            dialogObj.targetEvent = targetEvent;
            dialogObj.locals['isNew'] = true;
            dialogObj.locals['lookupPromises'] = promises;
            dialogObj.locals['model'] = model;
            dialogObj.locals['order'] = order;
            dialogObj.locals['defaultValues'] = defaultValues;
            dialogObj.locals['event'] = targetEvent;
            dialogObj.locals['record'] = undefined;
            return $mdDialog.show(dialogObj);
        }

        function showUpdateOrderlineDialog(parent, targetEvent, model, order, defaultValues, record) {
            var promises = {};
            angular.forEach(model.fields, function(field) {
                if ((field.editable || field.creatable || field.visible) && (field.inputType === 'lookup' || field.inputType === 'lookup-many')
                 && angular.isDefined(field.lookupSource)) {
                    var lookupModel = api.getModel(field.lookupSource);
                    promises[field.field] = api.getLookupData(lookupModel);
                }
            });

            dialogObj.parent = angular.element(parent);
            dialogObj.targetEvent = targetEvent;
            dialogObj.locals['isNew'] = false;
            dialogObj.locals['lookupPromises'] = promises;
            dialogObj.locals['model'] = model;
            dialogObj.locals['order'] = order;
            dialogObj.locals['defaultValues'] = defaultValues;
            dialogObj.locals['event'] = targetEvent;
            dialogObj.locals['record'] = angular.copy(record);
            return $mdDialog.show(dialogObj);
        }

        /**
        * will flatten sourceData and create size and availale stocks map
        * @param {array} sourceData: source object (response of get articles sizes)
        * @param {string} nestedArrayName: name of the nested array in sourceData
        * @return:
        */
        function createStocksSizeMap(sourceData, nestedArrayName, articleSizeIds) {
            var result = {};
            angular.forEach(sourceData, function (obj) {
                angular.forEach(obj[nestedArrayName], function (nestedObj) {
                    var availablenumberOfStocks = nestedObj.Actual;
                    if(nestedObj.Reserved > 0) {
                        availablenumberOfStocks = nestedObj.Actual - nestedObj.Reserved // total available stocks after deducting the reserved stocks
                    }
                    result[obj.SizeId] = availablenumberOfStocks;
                    var index = articleSizeIds.indexOf(obj.SizeId);
                    if (index > -1) {
                        articleSizeIds.splice(index, 1);
                    }
                });
            });
            for(var i=0; i<= articleSizeIds.length; i++) {
                result[articleSizeIds[i]] = 0;
            }
            return result;
        }

        /**
        * will flatten sourceData
        * @param {array} sourceData: source object (response of get articles sizes)
        * @param {string} nestedArrayName: name of the nested array in sourceData
        * @return: flattened array
        */
        function transforArticleStockResponse(sourceData, nestedArrayName) {
            var result = [];
            angular.forEach(sourceData, function (obj) {
                angular.forEach(obj[nestedArrayName], function (nestedObj) {
                  var record = {
                    ArticleId       : obj.ArticleId,
                    ArticleNumber   : obj.ArticleNumber,
                    ArticleName     : obj.ArticleName,
                    SizeId          : obj.SizeId,
                    SizeName        : obj.SizeName,
                    StockCode       : nestedObj.StockCode,
                    StockDefinitionId: nestedObj.StockDefinitionId,
                    StockName       : nestedObj.StockName,
                    Actual          : nestedObj.Actual,
                    Reserved        : nestedObj.Reserved,
                    Available       : nestedObj.Actual - nestedObj.Reserved
                  };
                  result.push(record);
                });
            });
            return result;
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.main.catalogs.orderline')
        .controller('orderlineDialogController', orderlineDialogController);

    /* @ngInject */
    function orderlineDialogController($mdDialog, $q, $scope, $window, $filter, hotkeys, $log, toast, api, utility, record, lookupPromises, defaultValues, isNew, model, order, event, orderlineDialog, catalogFactory) {
        /* jshint validthis: true */
        var vm = this;

        //Data
        vm.api = api;
        vm.model = model;
        vm.order = order;
        vm.isStockApply = defaultValues.isStockApply;
        if(vm.isStockApply) {
            vm.stockDefinitionId = vm.order.StockDefinitionId;
            vm.availableStocksSizeIdMap = {};
        }
        vm.customerRequiredDateValidation = {};
        vm.isCustomerRequiredDateValidationAdded = false;
        var operators = ['<=', '>=', '>', '<', '===', '!=='];
        vm.startDate = '';
        vm.endDate = '';
        vm.crdValidationError = '';
        var isCRDValid = true;

        // all the custome methods and following two models which being used in template to get display value; are used to avoid extra processing converting getlist of these models lookupData ish
        vm.articleCRDsModel = api.articles.crds;
        vm.articleSizesModel = api.articles.sizes;
        vm.isLoading = false;
        vm.record = (angular.isDefined(record) && record!== null) ? record : {};
        vm.lookupData = (angular.isDefined(record) && record!== null) ? record : {};
        vm.searchText = {};
        vm.isDataDirty = false;
        vm.isNew = isNew;
        vm.customerLocations = [];
        var articleRelatedFields = ['CrdId', 'SizeId'];
        vm.articleRelatedLookupData = {};
        vm.sellerVAS = [];
        vm.checkedVAS = {};
        var catalogDeliveryDates = catalogFactory.getActiveCatalogDetails().CatalogCRDList;


        //Methods
        vm.saveRecord = saveRecord;
        vm.closeDialog = closeDialog;

        vm.onArticleChange = onArticleChange;
        vm.articleRelatedLookupSearch = articleRelatedLookupSearch;
        vm.getArticleCRDLookupDisplayValue = getArticleCRDLookupDisplayValue;
        vm.onCRDLookupChange = onCRDLookupChange;

        vm.lookupSearch = lookupSearch;
        vm.lookupChange = lookupChange;
        vm.getLookupDisplayValue = getLookupDisplayValue;
        vm.selectText = selectText;

        vm.isQuantityRequired = isQuantityRequired;
        vm.checkVASEmpty = checkVASEmpty;
        vm.showValidDateRangeFilter = showValidDateRangeFilter;


        activate();

        ////////////////

        function activate() {
            loadVAS();
            parseCustomerRequiredDateValidation();
            initializeData();
            //try to load article related lookups for edit dialog
            if(!isNew && angular.isDefined(record) && angular.isDefined(record.ArticleId) ) {
                getArticleRelatedLookupData(record.ArticleId);
            }

            //Hotkeys
            hotkeys.bindTo($scope).add({
                combo: 'ctrl+enter',
                description: $filter('translate')('ACTIONS.SAVE'),
                allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
                callback: function(event) {
                    if (!vm.isLoading && !vm.editForm.$invalid) {
                        vm.saveRecord();
                    }
                }
            });
            if(vm.isNew) {
                hotkeys.bindTo($scope).add({
                    combo: 'ctrl+shift+enter',
                    description: $filter('translate')('ACTIONS.SAVE_AND_NEW'),
                    allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
                    callback: function(event) {
                        if (!vm.isLoading && !vm.editForm.$invalid) {
                            vm.saveRecord(true);
                        }
                    }
                });
            }
        }

        function saveRecord(saveAndNew) {
            vm.record.sizeInfo = vm.articleRelatedLookupData.SizeId;
            vm.record.VASInfo = vm.sellerVAS;
            vm.record.VASSelectionInfo = vm.checkedVAS;
            // if stock is enabled send the first delivery date as CRD
            if(vm.isStockApply) {
                vm.record['CrdId'] = vm.articleRelatedLookupData['CrdId'][0].CrdId;
            }
            // to avoid timezone issue for CRD
            if (angular.isDefined(vm.record['DeliveryDate']) &&  angular.isDate(vm.record['DeliveryDate'])) {
                var d = vm.record['DeliveryDate'];
                vm.record['DeliveryDate'] = new Date(d.setHours(12-(d.getTimezoneOffset()/60),0,0));
            }
            vm.isLoading = true;
            var p;
            if(vm.isNew) {
                p = model.methods.create(vm.record, defaultValues.orderId, defaultValues.catalogCode, vm.order);
            }
            else {
                p = model.methods.update(vm.record[vm.model.idField] , vm.record, defaultValues.orderId, defaultValues.catalogCode, vm.order);
            }

            p.then(function(response) {
                if (angular.isDefined(saveAndNew) && saveAndNew) {
                    vm.editForm.$setPristine();
                    vm.editForm.$setUntouched();
                    initializeData();
                    vm.isDataDirty = true;
                    var el = $window.document.getElementById('dialog_input_first');
                    if (el) {
                        el.focus();
                    }
                } else {
                    closeDialog(true);
                }
                var toastMessage;
                toastMessage = vm.isNew ? 'SUCCESS.CREATE': 'SUCCESS.UPDATE';
                toast.success(toastMessage, '', '');
            }, function(err) {
                var toastMessage;
                toastMessage = vm.isNew ? 'SUCCESS.CREATE': 'SUCCESS.UPDATE';
                toast.success(toastMessage, '', '');
                closeDialog(vm.isDataDirty);
            }).finally(function () {
                vm.isLoading = false;
            });
        }

        function closeDialog(saved) {
            $mdDialog.hide(saved);
        }

        function onArticleChange(selectedObj, fieldName) {
            if(angular.isObject(selectedObj)) {
                if(selectedObj.id !== vm.record.ArticleId) {
                    cleanArticleRelatedLookupFields(articleRelatedFields);
                }
                lookupChange(selectedObj, fieldName);

                getArticleRelatedLookupData(selectedObj.id);
                // call article getDetails
                getArticlePriceGroupAndInitialPrice(selectedObj.id);
            }
        }

        function articleRelatedLookupSearch(query, fieldName) {
            var results = [];
            var field = utility.filterObject(model.fields, {field: fieldName}, true)[0];
            var lookupFilter = field.lookupFilter ? field.lookupFilter : {};
            var predicate = angular.copy(lookupFilter);
            predicate.value = query;

            if(angular.isDefined(vm.articleRelatedLookupData[fieldName]) && angular.isArray(vm.articleRelatedLookupData[fieldName]) && vm.articleRelatedLookupData[fieldName].length > 0) {
                results = query ? utility.filterObject(vm.articleRelatedLookupData[fieldName] , predicate) :  utility.filterObject(vm.articleRelatedLookupData[fieldName], lookupFilter);
                return results;
            }
            else {
                return lookupPromises[fieldName].then(function() {
                    results = query ? utility.filterObject(vm.articleRelatedLookupData[fieldName] , predicate) :  utility.filterObject(vm.articleRelatedLookupData[fieldName], lookupFilter);
                    return results;
                });
            }
        }

        function getArticleCRDLookupDisplayValue(item, fieldName) {
            var result;
            var predicate = {};

            return lookupPromises[fieldName].then(function() {
                // since autocomplte return object
                if(angular.isObject(item)) {
                    predicate['CrdId'] = item['CrdId'];
                    result = utility.filterObject(vm.articleRelatedLookupData[fieldName], predicate, true);
                }
                // to initialize field value if any (when open update record dialog)
                else {
                    predicate['CrdId'] = item;
                    result = utility.filterObject(vm.articleRelatedLookupData[fieldName], predicate, true);
                }

                if (angular.isDefined(result) && angular.isArray(result) && result.length > 0) {
                    return result[0]['CustomerRequiredDate'];
                }
                else if(angular.isDefined(result)){
                    return result['CustomerRequiredDate'];
                }
                else {
                    $log.warn('Could not load lookup values for '+ fieldName);
                    return [];
                }

            });
        }

        function onCRDLookupChange(selectedObj) {
            if(angular.isObject(selectedObj)) {
                vm.record['CrdId'] = selectedObj['CrdId'];
                if(vm.isCustomerRequiredDateValidationAdded) {
                    // set the selected delivery date as CRD if it matches the criteria
                    validateCustomerRequiredDate(true);
                    if(vm.isNew && isCRDValid) {
                        var selectedDeliveryDate = utility.filterObject(catalogDeliveryDates, {Id: vm.record['CrdId']}, true)[0];
                        var CRDDate = new Date(selectedDeliveryDate.CustomerRequiredDate);
                        vm.record['DeliveryDate'] = CRDDate;
                    }
                    setValidDateRange();
                }
            }
            else if(angular.isUndefined(selectedObj) || selectedObj === null) {
                vm.record['CrdId'] = undefined; // on record removal make field undefined or the property can be deleted using delete keywork
            }
        }

        function setValidDateRange() {
            // set min and max date
            // related bug #47228: T1 - Month should be active where CRD is available currently material date picker is disabling the month when there is disabled dates
            // so we will show the allowed date range while opening date pcker so user doesnt need to change the months
            if(vm.customerRequiredDateValidation.length === 1) {
                var numberOfDays = (vm.customerRequiredDateValidation[0].hasOwnProperty('numberOfDays') && vm.customerRequiredDateValidation[0].numberOfDays > 0) ? vm.customerRequiredDateValidation[0].numberOfDays : 0;
                var expression = vm.customerRequiredDateValidation.relation;
                var selectedDeliveryDate = utility.filterObject(catalogDeliveryDates, {Id: vm.record['CrdId']}, true)[0];
                var CRDDate = new Date(selectedDeliveryDate.CustomerRequiredDate);
                CRDDate.setHours(0,0,0);
                // Related to bug #33790, we have to remove 1 day for '>=' and '<='
                if(vm.customerRequiredDateValidation.relation === '<=' || vm.customerRequiredDateValidation.relation === '>=') {
                    numberOfDays = numberOfDays - 1
                }
                var startTime = CRDDate.getTime() - numberOfDays * 24 * 60 * 60 * 1000;
                var endTime = CRDDate.getTime() + numberOfDays * 24 * 60 * 60 * 1000;
                if(numberOfDays > 0 && expression !== '===' && expression !== '!==') {
                    vm.startDate = new Date(startTime);
                    if(expression === '<') { // when the date is less than we will show the max date as one day less
                        vm.endDate = new Date(CRDDate.getTime() -1 * 24 * 60 * 60 * 1000);
                    } else {
                        vm.endDate = new Date(endTime);
                    }
                } if(numberOfDays > 0 && expression === '===') {
                    vm.startDate = new Date(startTime);
                    vm.endDate = new Date(endTime);
                }
            } else if(vm.customerRequiredDateValidation.length === 2) {
                var relation0NumberOfDays = (vm.customerRequiredDateValidation[0].hasOwnProperty('numberOfDays') && vm.customerRequiredDateValidation[0].numberOfDays > 0) ? vm.customerRequiredDateValidation[0].numberOfDays : 0;
                var relation1NumberOfDays = (vm.customerRequiredDateValidation[1].hasOwnProperty('numberOfDays') && vm.customerRequiredDateValidation[1].numberOfDays > 0) ? vm.customerRequiredDateValidation[1].numberOfDays : 0;
                var expression = vm.customerRequiredDateValidation.relation;
                var selectedDeliveryDate = utility.filterObject(catalogDeliveryDates, {Id: vm.record['CrdId']}, true)[0];
                var CRDDate = new Date(selectedDeliveryDate.CustomerRequiredDate);
                CRDDate.setHours(0,0,0);
                // Related to bug #33790, we have to remove 1 day for '>=' and '<='
                if(vm.customerRequiredDateValidation[0].relation === '<=' || vm.customerRequiredDateValidation[0].relation === '>=') {
                    relation0NumberOfDays = relation0NumberOfDays - 1;
                }
                if(vm.customerRequiredDateValidation[1].relation === '<=' || vm.customerRequiredDateValidation[1].relation === '>=') {
                    relation1NumberOfDays = relation1NumberOfDays - 1;
                }
                var startNumberOfDays = (vm.customerRequiredDateValidation[1].relation === '<=' || vm.customerRequiredDateValidation[1].relation === '<') ? relation1NumberOfDays : (vm.customerRequiredDateValidation[0].relation === '<=' || vm.customerRequiredDateValidation[0].relation === '<') ? relation0NumberOfDays : 0;
                var endNumberOfDays = (vm.customerRequiredDateValidation[1].relation === '>=' || vm.customerRequiredDateValidation[1].relation === '>') ? relation1NumberOfDays : (vm.customerRequiredDateValidation[0].relation === '>=' || vm.customerRequiredDateValidation[0].relation === '>') ? relation0NumberOfDays : 0;
                var startTime = CRDDate.getTime() - startNumberOfDays * 24 * 60 * 60 * 1000;
                var endTime = CRDDate.getTime() + endNumberOfDays * 24 * 60 * 60 * 1000;

                if(relation0NumberOfDays > 0 && relation1NumberOfDays > 0) {
                    vm.startDate = new Date(startTime);
                    vm.endDate = new Date(endTime);
                }
            }
        }

        function lookupSearch(query, fieldName) {
            var results = [];

            var field = utility.filterObject(model.fields, {field: fieldName}, true)[0];
            var lookupFilter = field.lookupFilter ? field.lookupFilter : {};
            var predicate = angular.copy(lookupFilter);
            predicate.value = query;

            var lookupModel = api.getModel(field.lookupSource);

            if(angular.isDefined(lookupModel.lookupData) && lookupModel.lookupData.data.length) {
                results = query ? utility.filterObject(lookupModel.lookupData.data , predicate) :  utility.filterObject(lookupModel.lookupData.data, lookupFilter);
                return results;
            }
            else {
                return lookupPromises[fieldName].then(function(lookupData) {
                    results = query ? utility.filterObject(lookupData.data , predicate) :  utility.filterObject(lookupData.data, lookupFilter);
                    return results;
                });
            }
        }

        // convert dropdown scope value form object(lookup record) to id property of lookup record
        function lookupChange(selectedObj, fieldName) {
            if(angular.isObject(selectedObj)) {
                vm.record[fieldName] = selectedObj.id;
            }
            else if(angular.isUndefined(selectedObj) || selectedObj === null) {
                vm.record[fieldName] = undefined; // on record removal make field undefined or the property can be deleted using delete keywork
            }
        }

        function getLookupDisplayValue(item, fieldName) {
            var result;
            var field = utility.filterObject(model.fields, {field: fieldName}, true)[0];
            var lookupModel = api.getModel(field.lookupSource);

            if(lookupModel.lookupData) {
                // since autocomplte return object
                if(angular.isObject(item)) {
                    result = utility.filterObject(lookupModel.lookupData.data, {id: item.id}, true);
                }
                // to initialize field value if any (when open update record dialog)
                else {
                    result = utility.filterObject(lookupModel.lookupData.data, {id: item}, true);
                }

                if (angular.isArray(result) && result.length > 0) {
                    return result[0].value;
                }
                else {
                    return result.value;
                }
            }
        }

        function selectText(event) {
            utility.selectInputText(event);
        }

        function isQuantityRequired(articleSizes) {
            var isRequired = false;
            for(var i=0, len=articleSizes.length; i < len ; i++) {
                if(angular.isDefined(articleSizes[i].quantity) && articleSizes[i].quantity > 0) {
                    isRequired = false;
                    break;
                }
                else {
                     isRequired = true;
                }
            }
            return isRequired;
        }

        function checkVASEmpty(vas) {
            if(angular.isDefined(vas.AdditionalInfo) && vas.AdditionalInfo.trim() !== "") {
                vm.checkedVAS[vas.id] = true;
            }
            else {
                vm.checkedVAS[vas.id] = false;
            }
        }

        // we will show only the valid date range when there is number of days configured
        function showValidDateRangeFilter(date) {
            if(vm.isCustomerRequiredDateValidationAdded) {
                if(vm.customerRequiredDateValidation.length === 1) {
                    var numberOfDays = (vm.customerRequiredDateValidation[0].hasOwnProperty('numberOfDays') && vm.customerRequiredDateValidation[0].numberOfDays > 0) ? vm.customerRequiredDateValidation[0].numberOfDays : 0;
                    // validate number of days.
                    if(numberOfDays > 0) {
                        var selectedDeliveryDate = utility.filterObject(catalogDeliveryDates, {Id: vm.record['CrdId']}, true)[0];
                        var CRDDate = new Date(selectedDeliveryDate.CustomerRequiredDate);
                        CRDDate.setHours(0,0,0);
                        var currentDate = new Date(date).getTime();
                        // Related to bug #33790, we have to remove 1 day for '>=' and '<='
                        if(vm.customerRequiredDateValidation[0].relation === '<=' || vm.customerRequiredDateValidation[0].relation === '>=') {
                            numberOfDays = numberOfDays - 1
                        }
                        var startTime = CRDDate.getTime() - numberOfDays * 24 * 60 * 60 * 1000;
                        var endTime = CRDDate.getTime() + numberOfDays * 24 * 60 * 60 * 1000;
                        var crdTime = CRDDate.getTime();
                        if(eval(currentDate + vm.customerRequiredDateValidation[0].relation + CRDDate.getTime())) {
                            if(((currentDate < endTime && currentDate > startTime) || currentDate === endTime || currentDate === startTime)
                            || ((vm.customerRequiredDateValidation[0].relation === '!=' || vm.customerRequiredDateValidation[0].relation === '!==') && currentDate !== crdTime)) {
                                return true;
                            } else {
                                return false;
                            }
                        } else {
                            return false;
                        }
                    } else {
                        return true;
                    }
                } else if(vm.customerRequiredDateValidation.length === 2) {
                    var relation0NumberOfDays = (vm.customerRequiredDateValidation[0].hasOwnProperty('numberOfDays') && vm.customerRequiredDateValidation[0].numberOfDays > 0) ? vm.customerRequiredDateValidation[0].numberOfDays : 0;
                    var relation1NumberOfDays = (vm.customerRequiredDateValidation[1].hasOwnProperty('numberOfDays') && vm.customerRequiredDateValidation[1].numberOfDays > 0) ? vm.customerRequiredDateValidation[1].numberOfDays : 0;
                    // validate number of days.
                    if(relation0NumberOfDays > 0 && relation1NumberOfDays > 0) {
                        var selectedDeliveryDate = utility.filterObject(catalogDeliveryDates, {Id: vm.record['CrdId']}, true)[0];
                        var CRDDate = new Date(selectedDeliveryDate.CustomerRequiredDate);
                        CRDDate.setHours(0,0,0);
                        var currentDate = new Date(date).getTime();
                        // Related to bug #33790, we have to remove 1 day for '>=' and '<='
                        if(vm.customerRequiredDateValidation[0].relation === '<=' || vm.customerRequiredDateValidation[0].relation === '>=') {
                            relation0NumberOfDays = relation0NumberOfDays - 1;
                        }
                        if(vm.customerRequiredDateValidation[1].relation === '<=' || vm.customerRequiredDateValidation[1].relation === '>=') {
                            relation1NumberOfDays = relation1NumberOfDays - 1;
                        }
                        var startNumberOfDays = (vm.customerRequiredDateValidation[1].relation === '<=' || vm.customerRequiredDateValidation[1].relation === '<') ? relation1NumberOfDays : (vm.customerRequiredDateValidation[0].relation === '<=' || vm.customerRequiredDateValidation[0].relation === '<') ? relation0NumberOfDays : 0;
                        var endNumberOfDays = (vm.customerRequiredDateValidation[1].relation === '>=' || vm.customerRequiredDateValidation[1].relation === '>') ? relation1NumberOfDays : (vm.customerRequiredDateValidation[0].relation === '>=' || vm.customerRequiredDateValidation[0].relation === '>') ? relation0NumberOfDays : 0;
                        var crdTime = CRDDate.getTime();
                        var startTime = CRDDate.getTime() - startNumberOfDays * 24 * 60 * 60 * 1000;
                        var endTime = CRDDate.getTime() + endNumberOfDays * 24 * 60 * 60 * 1000;

                        // Validate the date within the calculated range
                        if (currentDate >= startTime && currentDate <= endTime) {
                            return true;
                        } else {
                            return false;
                        }
                    } else {
                        return true;
                    }
                }
            } else {
                return true;
            }
        }

        function validateCustomerRequiredDate(isDefaultDeliveryDateValue) {
            if(vm.isCustomerRequiredDateValidationAdded) {
                var selectedDeliveryDate = utility.filterObject(catalogDeliveryDates, {Id: vm.record['CrdId']}, true)[0];
                var CRDValue = new Date(selectedDeliveryDate.CustomerRequiredDate);
                CRDValue = CRDValue.setHours(0,0,0,0);
                var deliveryDate = angular.isDefined(vm.record['DeliveryDate']) ? vm.record['DeliveryDate'] : selectedDeliveryDate.CustomerRequiredDate; // customer required date
                var deliveryDateValue = new Date(deliveryDate);
                deliveryDateValue = deliveryDateValue.setHours(0,0,0,0);
                var expression = vm.customerRequiredDateValidation.relation;

                switch(expression) {
                    case '<':
                        vm.crdValidationError = 'ORDERLINE.VALIDATIONS.CRD_LESSER_DELIVERY_DATE';
                        break;
                    case '>':
                        vm.crdValidationError = 'ORDERLINE.VALIDATIONS.CRD_GREATER_DELIVERY_DATE';
                        break;
                    case '<=':
                        vm.crdValidationError = 'ORDERLINE.VALIDATIONS.CRD_LESSER_EQUEAL_DELIVERY_DATE';
                        break;
                    case '>=':
                        vm.crdValidationError = 'ORDERLINE.VALIDATIONS.CRD_GREATER_EQUAL_DELIVERY_DATE';
                        break;
                    case '===':
                        vm.crdValidationError = 'ORDERLINE.VALIDATIONS.CRD_EQUAL_DELIVERY_DATE';
                        break;
                    case '!==':
                        vm.crdValidationError = 'ORDERLINE.VALIDATIONS.CRD_NOT_EQUAL_DELIVERY_DATE';
                        break;
                }

                if(!eval(deliveryDateValue + expression + CRDValue)) {
                    isCRDValid = false;
                    if(!isDefaultDeliveryDateValue) {
                        if(angular.isDefined(vm.editForm['DeliveryDate'])) {
                            vm.editForm['DeliveryDate'].$setValidity('pattern', false);
                        }
                    }
                } else {
                    isCRDValid = true;
                    if(!isDefaultDeliveryDateValue) {
                        if(angular.isDefined(vm.editForm['DeliveryDate'])) {
                            vm.editForm['DeliveryDate'].$setValidity('pattern', true);
                        }
                    }
                }
            }
        }


        //helper methods

        function cleanArticleRelatedLookupFields(fields) {
            angular.forEach(fields, function(fieldName) {
                vm.searchText[fieldName] = '';
                vm.lookupData[fieldName] = undefined;
            });
        }

        function getArticleRelatedLookupData(articleId) {
            var articlesCRDsModel = api.articles.crds;
            var articlesSizesModel = api.articles.sizes;

            lookupPromises['CrdId'] = articlesCRDsModel.methods.getList({forceFetch: true, isLogRequired: false}, articleId, defaultValues.catalogCode).then(function(response) {
                if(angular.isDefined(response.data) && response.data.length > 0 && utility.isValidDate(response.data[0][articlesCRDsModel.lookupDisplayField])) {
                    var formatedDateString;
                    for (var i=0; i<response.data.length; i++) {
                        formatedDateString = utility.formatDate(response.data[i][articlesCRDsModel.lookupDisplayField], 'MMM d, y');
                        response.data[i][articlesCRDsModel.lookupDisplayField] = formatedDateString;
                    }
                }
                vm.articleRelatedLookupData['CrdId'] = response.data;
                // remove already assigned crds against the artilceId
                filterAlreadyAssignedCRDs('CrdId', articleId);
            });

            lookupPromises['SizeId'] = articlesSizesModel.methods.getList({forceFetch: true, isLogRequired: false}, articleId, defaultValues.catalogCode).then(function(response) {
                vm.articleRelatedLookupData['SizeId'] = response.data;
                // add quantity to size lookup
                addQuantitiesToSizesLookup('SizeId');
                vm.articleSizes = vm.articleRelatedLookupData['SizeId'];
                if(vm.isStockApply) {
                    var articleStocksModel = api.catalogs.stock;
                    var articleSizeIds = vm.articleSizes.map(function(size) {
                        return size['Id'];
                    });
                    articleStocksModel.methods.getCustomerAssignedStocks({forceFetch: true, isLogRequired: false}, defaultValues.catalogCode, vm.order.CustomerId, articleId).then(function(response) {
                        vm.availableStocksSizeIdMap = orderlineDialog.createStocksSizeMap(response.data, 'Stocks', articleSizeIds);
                    });
                }
            });
        }

        function getArticlePriceGroupAndInitialPrice(articleId) {
            api.getLookupData(api.catalogs.customers).then(function(result) {
                var selectedCustomer = utility.filterObject(result.data, {value: order.CustomerNumber}, true)[0];
                vm.record.CurrentPriceGroupId = selectedCustomer.OrderPriceGroupId;
                api.catalogs.articles.methods.getDetails(false, articleId, defaultValues.catalogCode)
                .then(function (response) {
                    var articleDetails = response.data;
                    if(articleDetails.CatalogArticlePricesResponseList.length > 0) {
                        var customerPriceGroupData = utility.filterObject(articleDetails.CatalogArticlePricesResponseList, {PriceGroupId: vm.record.CurrentPriceGroupId}, true)[0];
                        vm.record.InitialPrice = customerPriceGroupData.price;
                    } else {
                        vm.record.InitialPrice = 0;
                    }
                });
            });
        }

        /**
         * @description
         *  this method will loop through articles crds lookup and will remove the one from 'articleRelatedLookupData' which are assigned (orderline with combination of
         *  articleId and CrdId already created)
         */
        function filterAlreadyAssignedCRDs(fieldName, articleId) {
            if(angular.isDefined(defaultValues.existingOrderlines)) {
                var existingOrderlines = defaultValues.existingOrderlines;
                var searchPredicate = {};
                searchPredicate.ArticleId = articleId;
                for(var index = vm.articleRelatedLookupData[fieldName].length-1; index >= 0 ; index--) {
                    searchPredicate[vm.articleCRDsModel.idField] = vm.articleRelatedLookupData[fieldName][index][vm.articleCRDsModel.idField];
                    var matchedRecords = utility.filterObject(existingOrderlines, searchPredicate, true);
                    if(angular.isDefined(matchedRecords) && angular.isArray(matchedRecords) && matchedRecords.length > 0
                        && (!isNew && vm.articleRelatedLookupData[fieldName][index])[vm.articleCRDsModel.idField] !== vm.lookupData.CrdId) {//if its edit mode do not remove already assigned crd
                        //combination of article and crd is already exist, remove already assigend crdId form crds lookup
                        vm.articleRelatedLookupData[fieldName].splice(index, 1);
                    }
                }
            }
            else {
                $log.warn('list of orderlines undefined, they are needed to be pass as part default values');
            }
        }

        function addQuantitiesToSizesLookup(fieldName) {
            angular.forEach(vm.articleRelatedLookupData[fieldName], function(articleSizes) {
                if(angular.isDefined(defaultValues.orderlineDetails)) {
                    if(angular.isDefined(defaultValues.orderlineDetails.orderLineSizeResponse)) {
                        var orderlineSize = utility.filterObject(defaultValues.orderlineDetails.orderLineSizeResponse, {SizeId: articleSizes.Id} , true)[0];
                        if (angular.isDefined(orderlineSize)) {
                            articleSizes.quantity = orderlineSize.Quantity;
                        } else {
                            articleSizes.quantity = '';
                        }
                    } else {
                        articleSizes.quantity = '';
                    }
                }
                else {
                    articleSizes.quantity = '';
                }
            });
        }

        function loadVAS() {
            api.getLookupData(api.sellers.vas).then(function(response) {
                vm.sellerVAS = utility.filterObject(angular.copy(response.data), {Status: 1});
                addVASAdditionalInfo(vm.sellerVAS);
            });
        }

        function addVASAdditionalInfo(sellerVAS) {
            angular.forEach(sellerVAS, function(vas) {
                if(angular.isDefined(defaultValues.orderlineDetails) && angular.isDefined(defaultValues.orderlineDetails.orderLineVasResponse)) {
                    var orderlineVAS = utility.filterObject(defaultValues.orderlineDetails.orderLineVasResponse, {VasId: vas.id} , true)[0];
                    if (angular.isDefined(orderlineVAS)) {
                        vm.checkedVAS[vas.id] = true;
                        vas.AdditionalInfo = orderlineVAS.AdditionalInfo;
                    } else {
                        vas.AdditionalInfo = '';
                    }
                }
                else {
                    vas.AdditionalInfo = '';
                }
            });
        }

        function initializeData() {
            vm.record = (angular.isDefined(record) && record!== null) ? record : {};
            vm.lookupData = (angular.isDefined(record) && record!== null) ? record : {};
            vm.searchText = {};
            vm.articleSizes = [];
            angular.forEach(vm.sellerVAS, function(vas) {
                vas.AdditionalInfo = '';
                vm.checkedVAS[vas.id] = false;
            });

            if(vm.isCustomerRequiredDateValidationAdded) {
                setValidDateRange();
            }
        }

        function parseCustomerRequiredDateValidation() {
            if(defaultValues && defaultValues.customerRequiredDateValidation && defaultValues.customerRequiredDateValidation != null && defaultValues.customerRequiredDateValidation != '') {
                vm.customerRequiredDateValidation = defaultValues.customerRequiredDateValidation;
                if(vm.customerRequiredDateValidation.length) {
                    if(vm.customerRequiredDateValidation[0].hasOwnProperty('relation') && vm.customerRequiredDateValidation[0].relation.toString().trim().length && operators.indexOf(vm.customerRequiredDateValidation[0].relation) !== -1) {
                        vm.isCustomerRequiredDateValidationAdded = true;
                    }
                }
            }
        }

    }
})();
(function() {
    'use strict';

    angular
        .module('app.main.catalogs.orderline')
        .controller('orderlineDetailsController', orderlineDetailsController);

    /* @ngInject */
    function orderlineDetailsController(api, $q, $scope, $state, $stateParams, $rootScope, $document, catalogFactory, orderlineDialog, orderLineModel, settingsFactory, $sessionStorage, dialog, utility, $mdDialog) {
       /* jshint validthis: true */
        var vm = this;

        // Data
        var orderId = $stateParams.id;
        var orderlineId = $stateParams.orderlineId;
        var OrderProcessStatusId = $stateParams.OrderProcessStatusId;
        var orderline = $stateParams.Orderline;
        var order = $stateParams.Order;
        var orderModel = api.catalogs.orders;
        vm.activeCatalog = catalogFactory.getActiveCatalog();
        var catalogCode = vm.activeCatalog.CatalogCode;

        vm.model = orderLineModel;

        vm.VASModel = api.orderlines.vas;
        settingsFactory.applyPersistedListViewLayout(vm.VASModel);

        vm.sizesModel = api.orderlines.sizes;
        settingsFactory.applyPersistedListViewLayout(vm.sizesModel);

        vm.orderLine = {};
        vm.sizes = [];
		vm.filteredSizes = [];
        vm.VAS = [];
		vm.filteredVAS = [];

        vm.isLoading = false;
        // vm.isSizesLoading = false;
        // vm.isVASLoading = false;


        // Methods

        vm.refreshRecord = refreshRecord;
        // vm.refreshSizes = refreshSizes;
        // vm.refreshVAS = refreshVAS

        vm.doOrderLineItemAction = doOrderLineItemAction;
        vm.editOrderline = editOrderline;


        activate();

        ////////////////

        function activate() {
            refreshRecord(true);
        }

        function refreshRecord(isLogRequired) {
            if(OrderProcessStatusId !== 1 && angular.isDefined(orderlineId) && orderlineId !== '') {
                vm.isLoading = true;

                vm.model.methods.getDetails(isLogRequired, orderlineId, orderId, catalogCode)
                    .then(function (response) {
                        vm.orderLine = response.data;
                        vm.orderLine.OrderProcessStatusId = OrderProcessStatusId;

                        for(var prop in vm.orderLine.Attributes) {
                            vm.orderLine[prop] = vm.orderLine.Attributes[prop];
                        }
                        delete vm.orderLine.Attributes;

                        vm.title = angular.copy(vm.orderLine[vm.model.lookupDisplayField]);

                        //Update Breadcrumb
                        $state.current.data.displayName = vm.title;
                        $rootScope.$broadcast('breadcrumb-updated');

                        vm.sizes = response.data.orderLineSizeResponse;
                        vm.VAS = response.data.orderLineVasResponse;
                })
                .finally(function () {
                    vm.isLoading = false;
                });
            } else { // draft
                vm.orderLine = orderline;
                vm.orderLine.OrderProcessStatusId = OrderProcessStatusId;

                vm.title = angular.copy(vm.orderLine[vm.model.lookupDisplayField]);

                //Update Breadcrumb
                $state.current.data.displayName = vm.title;
                $rootScope.$broadcast('breadcrumb-updated');
                // add sizes field values and vas field values from article sizes and vas records
                var sizesModel = api.catalogs.sizes;
                var generalSizesProperties = {
                    forceFetch: true,
                    isLogRequired: false,
                    config: {},
                    supportIncrementalResult: true,
                    modelIdField: sizesModel.idField,
                    isMajor: false,
                    isArticleRelatedData: false,
                    nestedArrayName: 'Sizes',
                    nestedDataIdField:'Id'
                }

                sizesModel.methods.getList(generalSizesProperties, sizesModel, catalogCode).then(function(sizesResponse) {
                    var articleSizes = utility.filterObject(sizesResponse.data, {Id: vm.orderLine.ArticleId}, true)[0];
                    if(angular.isDefined(articleSizes) && articleSizes.Sizes.length) {
                        angular.forEach(vm.orderLine.OrderlineSize, function(size) {
                            var orderlineSize = utility.filterObject(articleSizes.Sizes, {Id: size.SizeId}, true)[0];
                            size.Size = orderlineSize.SizeName;
                            size.SizeIndex = orderlineSize.SizeIndex;
                        });
                    }
                    angular.forEach(vm.orderLine.OrderlineVas, function(vas) {
                        vas.VasCode = vas.Code;
                    });
                    vm.sizes = vm.orderLine.OrderlineSize;
                    vm.VAS = vm.orderLine.OrderlineVas;
                });
            }
        }


        function doOrderLineItemAction(action, record) {
            if (action) {
                switch (action.id) {
                    case 'delete':
                    case 'activate':
                        if(OrderProcessStatusId !== 1 && angular.isDefined(record.Id)) {
                            vm.model.methods.activateBulk(record, vm.model, action.id, catalogCode, orderId, orderlineId);
                        } else {
                            vm.model.methods.deleteDraftAndReopnedOrders(record, order).then(function() {
                                // redirect to order details page as the deleted order line is not displayed in the list again
                                var stateParams = {id: orderId, OrderProcessStatusId: OrderProcessStatusId};
                                $state.go('app.orders.details', stateParams);
                            });
                        }
                        break;
                    case 'saveOrders':
                        saveDraftOrders(record);
                        break;
                }
            }
        }

        function editOrderline(record, ev) {
            if(OrderProcessStatusId !== 1 && angular.isDefined(orderlineId) && orderlineId !== '') {
                orderlineDialog.showUpdateOrderlineDialog(angular.element($document.body), ev, vm.model, order,
                {catalogCode: catalogCode, orderId: orderId, orderlineDetails: record, existingOrderlines: [vm.orderLine]}, record).then(function(saved) {
                    if (saved) {
                        refreshRecord(false);
                    }
                });
            } else {
                record['orderLineSizeResponse'] = record.OrderlineSize;
                record['orderLineVasResponse'] = record.OrderlineVas;
                delete record.OrderlineSize;
                delete record.OrderlineVas;
                orderlineDialog.showUpdateOrderlineDialog(angular.element($document.body), ev, vm.model, order,
                    {catalogCode: catalogCode, orderId: orderId, orderlineDetails: record, existingOrderlines: [vm.orderLine]}, angular.copy(record)).then(function(saved) {
                    if (saved) {
                        refreshRecord(false);
                    }
                });
            }
        }

        function saveDraftOrders(record) {
            vm.model.methods.saveDraftOrders(record, orderId, catalogCode)(function(saved) {
                if (saved) {
                    refreshRecord(false);
                }
            });
        }

        //helper methods

        function assignOrderProcessStatus(OrderProcessStatusId) {
            var deferred = $q.defer();
            if(angular.isDefined(OrderProcessStatusId) && OrderProcessStatusId !== null) {
                deferred.resolve(OrderProcessStatusId);
            }
            else {
                orderModel.methods.getDetails(false, orderId, catalogCode).then(function(response) {
                    deferred.resolve(response.data.OrderProcessStatusId);
                });
            }
            return deferred.promise;
        }
        function showSaveOrdersPopup() {
            if($state.current.name !== 'app.orders.details' ) {
                var confirmationContent = {};
                confirmationContent.title = 'MESSAGES.TITLE.UNSAVED_ORDERS';
                confirmationContent.message = 'MESSAGES.CONTENT.UNSAVED_ORDERS';
                var confirmationAction = 'ACTIONS.SAVE';
                dialog.confirm(confirmationContent, confirmationAction)
                .then(function(response) {
                    if(response.userAction.toLowerCase() === 'confirm') {
                        api.orders.orderlines.methods.saveDraftOrders();
                    } else {
                        delete $sessionStorage.UnSavedDraftOrders;
                    }
                }, function () {
                    delete $sessionStorage.UnSavedDraftOrders;
                    $mdDialog.hide(false);
                });
            }
        }

        $scope.$on('$destroy', function () {
            var unsavedOrders = angular.isDefined(catalogFactory.getUnsavedDraftOrders()) ? catalogFactory.getUnsavedDraftOrders() : [];
            // if unsaved orders show popup
            if(unsavedOrders.length > 0) {
                showSaveOrdersPopup();
            }
        });

    }
})();
(function () {
    'use strict';

    angular
        .module('app.main.catalogs.orders.files', []);
})();
(function() {
    'use strict';

    angular
        .module('app.main.catalogs.orders.files')
        .controller('uploadFilesController', uploadFilesController);

    /* @ngInject */
    function uploadFilesController($mdDialog, $scope, $window, $filter, hotkeys, $rootScope, $localStorage, $auth, $q, $log, promises) {
        /* jshint validthis: true */
        var vm = this;

        //Data
        vm.record = {};
        vm.isLoading = false;
        vm.isFileValid = false;
        vm.enableFileSelector = false;
        var validFileTypePromise;

        if (angular.isUndefined($rootScope.flowObj)) {
            $rootScope.flowObj = {};
        }
        vm.obj = $rootScope.flowObj;

        vm.flowInit = {
            target      : $localStorage.baseUrl + '/UploadFileChunk',
            headers     : { Authorization: 'Bearer ' + $auth.getToken()},
            singleFile  : true
        };


        //Methods
        vm.validateFile = validateFile;
        vm.saveRecord = saveRecord;
        vm.closeDialog = closeDialog;


        activate();

        ////////////////


        function activate() {
            //Hotkeys
            validFileTypePromise = generateValidFileTypeRegexp()
                .then(function(validFileTypes) {
                    vm.enableFileSelector = true;
                    return validFileTypes;// to make it available when reusing the same promise under validate method
                })
                .catch(function() {
                    $log.warn('Unable to create accepted file format');
                })
                .finally(function() {
                    vm.enableFileSelector = true;
                });
            hotkeys.bindTo($scope).add({
                combo: 'ctrl+enter',
                description: $filter('translate')('ACTIONS.SAVE'),
                allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
                callback: function(event) {
                    if (vm.obj.flow.files.length > 0 && !vm.editForm.$invalid) {
                        vm.saveRecord();
                    }
                }
            });
        }

        function validateFile(file, message, flow) {//TODO- should make custom form validator
          //TODO- better to use async validation and display progress while creating RegExp
          validFileTypePromise.then(function(validFileTypes) {
              if (angular.isDefined(file) && !file.name.match(new RegExp('.('+ validFileTypes +')$'))) {
                  vm.isFileValid = false;
              }
              else {
                  vm.isFileValid = true;
              }
          }).catch(function() {
            $log.warn('could not get valid file types');
            vm.isFileValid = false;
          });
        }

        function saveRecord() {
            closeDialog({record: vm.record, flowObj: vm.obj.flow});
        }

        function closeDialog(saved) {
            $mdDialog.hide(saved);
        }

        function generateValidFileTypeRegexp() {
          var deferred = $q.defer();
          var promise = deferred.promise;
          promises['FileType'].then(function(response) {
            var validFileTypes = '';
            vm.commaSeparatedValidTypes = '';
            angular.forEach(response.data, function(fileType) {
              vm.commaSeparatedValidTypes += fileType['Extension'] + ',';
              validFileTypes += fileType['Extension'].substring(1) + '|';
            });
            //remove last inserted pipe character
            validFileTypes = validFileTypes.substring(0, validFileTypes.length-1);
            vm.commaSeparatedValidTypes = vm.commaSeparatedValidTypes.substring(0, vm.commaSeparatedValidTypes.length-1);
            deferred.resolve(validFileTypes);
          }).catch(function(err) {deferred.reject(err)});
          return promise;
        }

    }
})();
(function() {
    'use strict';
    
    angular
        .module('app.main.catalogs.customers.segmentations', []);
    
})();
(function() {
    'use strict';

    angular
        .module('app.main.catalogs.customers.segmentations')
        .controller('assignSegmentationToCustomerController', assignSegmentationToCustomerController);

    /* @ngInject */
    function assignSegmentationToCustomerController(api, $q, $mdDialog, $scope, $window, $filter, hotkeys, toast, utility,
                 model, assignedRecords, activeCatalog, customerId, lookupPromises, event) {
        /* jshint validthis: true */
        var vm = this;       
        
        //Data        
        vm.model = model;
        
        var availableSegmentations = {};
        vm.isLoading = false;
        vm.isDataDirty = false;
        vm.record = {};
        vm.lookupModel = {}
        vm.searchText = {};

           
        //Methods   
        vm.saveRecord = saveRecord;
        vm.closeDialog = closeDialog;  

        vm.lookupSearch = lookupSearch;
        vm.lookupChange = lookupChange;
        vm.getLookupDisplayValue = getLookupDisplayValue;
        vm.selectText = selectText;     
        

        activate();

        ////////////////

        function activate() {
            // loadAvailableSegmentations();
            //Hotkeys
            hotkeys.bindTo($scope).add({
                combo: 'ctrl+enter',
                description: $filter('translate')('ACTIONS.SAVE'),
                allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
                callback: function(event) {
                    if (!vm.isLoading && !vm.editForm.$invalid) {
                        vm.saveRecord();
                    }
                }
            });
            hotkeys.bindTo($scope).add({
                combo: 'ctrl+shift+enter',
                description: $filter('translate')('ACTIONS.SAVE_AND_NEW'),
                allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
                callback: function(event) {
                    if (!vm.isLoading && !vm.editForm.$invalid) {
                        vm.saveRecord(true);
                    }
                }
            });
        }        
        
        function saveRecord(saveAndNew) {
            vm.record.activeCatalogCode = activeCatalog.CatalogCode;
            vm.record.sellerId = activeCatalog.AccountId;
            vm.record.customerId = customerId;
            vm.isLoading = true;
            vm.model.methods.create(vm.record, assignedRecords).then(function() {
                if (angular.isDefined(saveAndNew) && saveAndNew) {
                    vm.editForm.$setPristine();
                    vm.editForm.$setUntouched();
                    updateAssignedRecords(vm.record);
                    vm.record = {};
                    vm.acSearchText = [];
                    vm.searchText = {};
                    vm.isDataDirty = true;                    
                    var el = $window.document.getElementById('dialog_input_first');
                    if (el) {
                        el.focus();
                    }
                } else {
                    closeDialog(true);
                }
                toast.success('SUCCESS.LINKED', '', '');
            }, function() {
                closeDialog(vm.isDataDirty);
            }).finally(function () {
                vm.isLoading = false;
            });                       
        }
        
        function closeDialog(saved) {
            $mdDialog.hide(saved);
        }
        
        function lookupSearch(query, fieldName) {
            var results = [];            

            var field = utility.filterObject(model.fields, {field: fieldName})[0];
            var lookupFilter = field.lookupFilter ? field.lookupFilter : {};            
            var predicate = angular.copy(lookupFilter);            
            predicate.value = query;

            if(angular.isDefined(availableSegmentations.data) && availableSegmentations.data.length) {
                results = query ? utility.filterObject(availableSegmentations.data , predicate) :  utility.filterObject(availableSegmentations.data, lookupFilter);
                return results;                
            }   
            else {
                return loadAvailableSegmentations().then(function(availableSegmentations) {
                    results = query ? utility.filterObject(availableSegmentations.data , predicate) :  utility.filterObject(availableSegmentations.data, lookupFilter);
                    return results;
                });
            }
        }

        // convert dropdown scope value form object(lookup record) to id property of lookup record
        function lookupChange(selectedObj, field) {
            if(angular.isObject(selectedObj)) {
                vm.record[field] = selectedObj.id; 
            }
            else if(angular.isUndefined(selectedObj) || selectedObj === null) {
                vm.record[field] = undefined; // on record removal make field undefined or the property can be deleted using delete keywork
            }
        }

        function getLookupDisplayValue(item, fieldName) {
            var result;
            var field = utility.filterObject(model.fields, {field: fieldName})[0];
            var lookupModel = api.getModel(field.lookupSource);

            if(lookupModel.lookupData) {
                // since autocomplte return object                
                if(angular.isObject(item)) {
                    result = utility.filterObject(lookupModel.lookupData.data, {id: item.id}, true);
                }
                // to initialize filed value if any (when open update record dialog)         
                else {                     
                    result = utility.filterObject(lookupModel.lookupData.data, {id: item}, true);                                       
                }               
                
                if (angular.isArray(result) && result.length > 0) {
                    return result[0].value;
                } 
                else {
                    return result.value;
                }
            }            
        }

        function selectText(event) {
            utility.selectInputText(event);         
        }

        //helper methods
        function loadAvailableSegmentations() {
            var defrred = $q.defer();
            // var segmentationsModel = api.catalogs.segmentations;
            // api.getLookupData(segmentationsModel).then(function(lookupData) {
            lookupPromises['SegmentationId'].then(function(lookupData) {
                var catalogSegmentations = angular.copy(lookupData);
                // var catalogSegmentations = utility.filterObject(lookupData.data, {Status: 1}); // not required -  will be filtered during autocomplet serchQuery
                angular.forEach(assignedRecords, function(record) {
                    var index = catalogSegmentations.data.indexOf(utility.filterObject(catalogSegmentations.data, {id: record[model.idField]}, true)[0]);
                    if(index !== -1) {
                        catalogSegmentations.data.splice(index, 1);
                    }
                });
                availableSegmentations = catalogSegmentations
                defrred.resolve(availableSegmentations);
                // if indexArry needed to be utelize uncomment following code to update arrayIndexes values
                // utility.updateLookupDataIndexes(vm.availableSegmentations, segmentationsModel);
                
            });
            return defrred.promise;
        }        
        
        // decorator method
        function updateAssignedRecords(record) {
            // assignedRecords.push(record); // since in create(assign) segmentation record will be push to assignedRecords
            loadAvailableSegmentations();
        }
        
    }
})();
(function() {
	'use strict';

	angular
		.module('app.main.catalogs.customers.capacities', []);
})();

(function() {
	'use strict';

	// Single link dialog (API 7). Used by both the Linked Customer Details > Capacities tab (Area C)
	// and the Linked Customers list "Link Capacities" item action (Area B).
	// Offers the seller's ACTIVE capacities (minus already-linked, when assignedRecords is provided)
	// plus the two static numeric fields, then PUTs the single link directly.
	angular
		.module('app.main.catalogs.customers.capacities')
		.controller('assignCapacityToCustomerController', assignCapacityToCustomerController);

	/* @ngInject */
	function assignCapacityToCustomerController(api, $q, $mdDialog, $scope, $filter, hotkeys, toast, utility,
		model, assignedRecords, catalogCode, customerId, lookupPromises, event) {
		/* jshint validthis: true */
		var vm = this;

		// Data
		vm.model = model;
		vm.isLoading = false;
		vm.isDataDirty = false;
		vm.record = {};
		vm.lookupModel = {};
		vm.searchText = {};

		var availableCapacities = {};

		// Methods
		vm.saveRecord = saveRecord;
		vm.closeDialog = closeDialog;
		vm.lookupSearch = lookupSearch;
		vm.lookupChange = lookupChange;
		vm.getLookupDisplayValue = getLookupDisplayValue;
		vm.selectText = selectText;

		activate();

		////////////////

		function activate() {
			hotkeys.bindTo($scope).add({
				combo: 'ctrl+enter',
				description: $filter('translate')('ACTIONS.SAVE'),
				allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
				callback: function() {
					if (!vm.isLoading && !vm.editForm.$invalid) {
						vm.saveRecord();
					}
				}
			});
		}

		// API 7 - single PUT to api/catalogs/{catalogCode}/capacities/{capacityId}/customers/{customerId}
		// (not segmentation's whole-array pattern)
		function saveRecord() {
			vm.isLoading = true;
			var body = {
				ArticleCapacity: vm.record.ArticleCapacity,
				ModelCapacity: vm.record.ModelCapacity
			};
			vm.model.methods.assign(body, catalogCode, vm.record.CapacityId, customerId).then(function() {
				toast.success('SUCCESS.LINKED', '', '');
				closeDialog(true);
			}, function() {
				// Keep the dialog open on failure so the user's selection/inputs are preserved;
				// the global HTTP error handler surfaces the error (finally resets isLoading).
			}).finally(function() {
				vm.isLoading = false;
			});
		}

		function closeDialog(saved) {
			$mdDialog.hide(saved);
		}

		function selectText(event) {
			utility.selectInputText(event);
		}

		function lookupSearch(query, fieldName) {
			var field = utility.filterObject(model.fields, {field: fieldName})[0];
			var lookupFilter = field.lookupFilter ? field.lookupFilter : {};
			var predicate = angular.copy(lookupFilter);
			predicate.value = query;

			if (angular.isDefined(availableCapacities.data) && availableCapacities.data.length) {
				return query ? utility.filterObject(availableCapacities.data, predicate) : utility.filterObject(availableCapacities.data, lookupFilter);
			} else {
				return loadAvailableCapacities().then(function(available) {
					return query ? utility.filterObject(available.data, predicate) : utility.filterObject(available.data, lookupFilter);
				});
			}
		}

		function lookupChange(selectedObj, field) {
			if (angular.isObject(selectedObj)) {
				vm.record[field] = selectedObj.id;
			} else if (angular.isUndefined(selectedObj) || selectedObj === null) {
				vm.record[field] = undefined;
			}
		}

		function getLookupDisplayValue(item, fieldName) {
			var field = utility.filterObject(model.fields, {field: fieldName})[0];
			var lookupModel = api.getModel(field.lookupSource);
			if (lookupModel.lookupData) {
				var result;
				if (angular.isObject(item)) {
					result = utility.filterObject(lookupModel.lookupData.data, {id: item.id}, true);
				} else {
					result = utility.filterObject(lookupModel.lookupData.data, {id: item}, true);
				}
				if (angular.isArray(result) && result.length > 0) {
					return result[0].value;
				} else if (result) {
					return result.value;
				}
			}
		}

		// available = active capacities (lookup) minus already-linked (assignedRecords)
		function loadAvailableCapacities() {
			var deferred = $q.defer();
			lookupPromises['CapacityId'].then(function(lookupData) {
				var capacities = angular.copy(lookupData);
				angular.forEach(assignedRecords, function(record) {
					var linked = utility.filterObject(capacities.data, {id: record[model.idField]}, true)[0];
					var index = capacities.data.indexOf(linked);
					if (index !== -1) {
						capacities.data.splice(index, 1);
					}
				});
				availableCapacities = capacities;
				deferred.resolve(availableCapacities);
			});
			return deferred.promise;
		}
	}
})();

(function() {
  'use strict';

  angular
      .module('app.main.catalogs.buyer-limits.limits-criteria', [
          'app.main.catalogs.buyer-limits.limits-criteria.notify-users'
      ])
      .config(config);

  /** @ngInject */
  function config($translatePartialLoaderProvider)
  {
      // Translation
      $translatePartialLoaderProvider.addPart('app/main/catalogs/sub-modules/buyer-limits/details/tabs/limits-criteria');
  }

})();
(function() {
	'use strict';

	angular
		.module('app.main.catalogs.buyer-limits.limits-criteria')
		.controller('createAttributeController', createAttributeController);

	/* @ngInject */
	function createAttributeController($mdDialog, toast, utility, $scope, $window, $filter, hotkeys, assignedRecords,
				record, buyerLimitId, isNew, model, event, catalogFactory, api) {
		/* jshint validthis: true */
		var vm = this;

		//Data
		vm.model = model;
		vm.buyerLimitId = buyerLimitId;

		vm.isLoading = false;
		vm.record = {};
		vm.isNew = isNew;
		vm.acLookupModel = angular.copy(record);
		vm.assignedCatalogAttributes = replaceAttributeNames(utility.filterObject(catalogFactory.getActiveCatalogDetails().AssignedCatalogAttributes, {IsSeasonless: 0}, true));
		vm.availableCatalogAttributes = angular.copy(vm.assignedCatalogAttributes);
		vm.assignedRecords = assignedRecords;
		if(!isNew) {
			vm.assignedRecords = angular.copy(vm.assignedRecords);
			for (var i = 0; i < vm.assignedRecords.length; i++){
				if(vm.assignedRecords[i].Id === record.Id) {
					vm.assignedRecords.splice(i, 1);
				}
			}
		}
		vm.showAttribute_1_Id = false;
		vm.showAttribute_2_Id = false;
		vm.showAttribute_3_Id = false;
		vm.showAttribute_4_Id = false;
		vm.acSelectedItem = [];
		vm.acSearchText = [];
		var multiValueAttrbiuteIdList = [];


		//Methods
		vm.saveRecord = saveRecord;
		vm.closeDialog = closeDialog;

		vm.lookupSearch = lookupSearch;
		vm.lookupChange = lookupChange;
		vm.lookupChangeAttribute2 = lookupChangeAttribute2;
		vm.lookupChangeAttribute3 = lookupChangeAttribute3;
		vm.lookupChangeAttribute4 = lookupChangeAttribute4;
		vm.getlookupDisplayValue = getlookupDisplayValue;
		vm.getDateObj = getDateObj;
		vm.transformChip = transformChip;
		vm.multiValueQuerySearch = multiValueQuerySearch;

		activate();

		////////////////

		function activate() {
			if(!isNew) {
				vm.record = record;
				if(vm.record.Attribute_1_Id !== null) {
					vm.selectedAttibute = utility.changeAttributeType(utility.filterObject(vm.assignedCatalogAttributes, {Attributeid: vm.record.Attribute_1_Id}, true)[0]);
					//if vetting list assigned assign those to values
					if(angular.isDefined(vm.selectedAttibute.AllowedValues) && vm.selectedAttibute.AllowedValues !== null) {
						vm.selectedAttibute.values = vm.selectedAttibute.AllowedValues
						.map(function(value) {
							return value.trim();
						})
						.sort(function(a, b) {
							return a.toLowerCase().localeCompare(b.toLowerCase());
						});
						// for multivalue dropdown make the record as array
						if(vm.selectedAttibute.inputType === 'multi-value') {
							if(vm.record.Attribute_1_Value.length === 0) {
								vm.record.Attribute_1_Value = [];
							}
						}
					}
				}
				if(vm.record.Attribute_2_Id !== null) {
					vm.selectedAttibute2 = utility.changeAttributeType(utility.filterObject(vm.assignedCatalogAttributes, {Attributeid: vm.record.Attribute_2_Id}, true)[0]);
					//if vetting list assigned assign those to values
					if(angular.isDefined(vm.selectedAttibute2.AllowedValues) && vm.selectedAttibute2.AllowedValues !== null) {
						vm.selectedAttibute2.values = vm.selectedAttibute2.AllowedValues
						.map(function(value) {
							return value.trim();
						})
						.sort(function(a, b) {
							return a.toLowerCase().localeCompare(b.toLowerCase());
						});
						// for multivalue dropdown make the record as array
						if(vm.selectedAttibute2.inputType === 'multi-value') {
							if(vm.record.Attribute_2_Value.length === 0) {
								vm.record.Attribute_2_Value = [];
							}
						}
					}
				}
				if(vm.record.Attribute_3_Id !== null) {
					vm.selectedAttibute3 = utility.changeAttributeType(utility.filterObject(vm.assignedCatalogAttributes, {Attributeid: vm.record.Attribute_3_Id}, true)[0]);
					//if vetting list assigned assign those to values
					if(angular.isDefined(vm.selectedAttibute3.AllowedValues) && vm.selectedAttibute3.AllowedValues !== null) {
						vm.selectedAttibute3.values = vm.selectedAttibute3.AllowedValues
						.map(function(value) {
							return value.trim();
						})
						.sort(function(a, b) {
							return a.toLowerCase().localeCompare(b.toLowerCase());
						});
						// for multivalue dropdown make the record as array
						if(vm.selectedAttibute3.inputType === 'multi-value') {
							if(vm.record.Attribute_3_Value.length === 0) {
								vm.record.Attribute_3_Value = [];
							}
						}
					}
				}
				if(vm.record.Attribute_4_Id !== null) {
					vm.selectedAttibute4 = utility.changeAttributeType(utility.filterObject(vm.assignedCatalogAttributes, {Attributeid: vm.record.Attribute_4_Id}, true)[0]);
					//if vetting list assigned assign those to values
					if(angular.isDefined(vm.selectedAttibute4.AllowedValues) && vm.selectedAttibute4.AllowedValues !== null) {
						vm.selectedAttibute4.values = vm.selectedAttibute4.AllowedValues
						.map(function(value) {
							return value.trim();
						})
						.sort(function(a, b) {
							return a.toLowerCase().localeCompare(b.toLowerCase());
						});
						// for multivalue dropdown make the record as array
						if(vm.selectedAttibute4.inputType === 'multi-value') {
							if(vm.record.Attribute_4_Value.length === 0) {
								vm.record.Attribute_4_Value = [];
							}
						}
					}
				}
			}

			//Hotkeys
			hotkeys.bindTo($scope).add({
				combo: 'ctrl+enter',
				description: $filter('translate')('ACTIONS.SAVE'),
				allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
				callback: function(event) {
					if (!vm.isLoading && !vm.editForm.$invalid) {
						vm.saveRecord();
					}
				}
			});
			hotkeys.bindTo($scope).add({
				combo: 'ctrl+shift+enter',
				description: $filter('translate')('ACTIONS.SAVE_AND_NEW'),
				allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
				callback: function(event) {
					if (!vm.isLoading && !vm.editForm.$invalid) {
						vm.saveRecord(true);
					}
				}
			});
		}

		function saveRecord(saveAndNew) {
			// send multivalue attributes value as string
			for(var key in vm.record) {
				if(vm.record.hasOwnProperty(key)) {
						if(multiValueAttrbiuteIdList.includes(vm.record[key])) {
							var attributeIndex = key.split('_')[1].split('_')[0];
							vm.record['Attribute_'+ attributeIndex + '_Value'] = vm.record['Attribute_'+ attributeIndex + '_Value'].toString();
						}
				}
			}

			vm.isLoading = true;
			var promise;
			if(isNew) {
				promise = vm.model.methods.create(vm.record, buyerLimitId);
			}
			else {
				promise = vm.model.methods.update(vm.record[vm.model.idField], vm.record, buyerLimitId);
			}
			promise.then(function() {
				if (angular.isDefined(saveAndNew) && saveAndNew) {
					vm.editForm.$setPristine();
					vm.editForm.$setUntouched();
					vm.record = {};
					vm.searchText = {};
					vm.isDataDirty = true;
					var el = $window.document.getElementById('dialog_input_first');
					if (el) {
						el.focus();
					}
				} else {
					closeDialog(true);
				}
				var toastMessage = isNew ? 'SUCCESS.CREATE': 'SUCCESS.UPDATE';
				toast.success(toastMessage, '', '');
			}, function() {
				closeDialog(vm.isDataDirty);
			}).finally(function () {
				vm.isLoading = false;
			});
		}

		function closeDialog(saved) {
			$mdDialog.hide(saved);
		}


		function lookupSearch(query, fieldName, lookupObj) {
			var results = [];

			var field = utility.filterObject(vm.model.fields, {field: fieldName})[0];
			var lookupFilter = angular.isDefined(field.lookupFilter) ? field.lookupFilter : {};
			var predicate = angular.copy(lookupFilter);
			predicate['AttributeDisplayName'] = query;

			if(angular.isDefined(lookupObj) && angular.isArray(lookupObj) && lookupObj.length) {
				results = query ? utility.filterObject(lookupObj , predicate) : utility.filterObject(lookupObj, lookupFilter, true);
				return results;
			}
			else {
				return results;
			}
		}

		function lookupChange(selectedObj, field) {
			if(angular.isObject(selectedObj)) {
				vm.record[field] = selectedObj.Attributeid;
				vm.showAttribute_1_Id = true;
				vm.selectedAttibute = utility.changeAttributeType(selectedObj);
				//if vetting list assigned assign those to values
				if(angular.isDefined(vm.selectedAttibute.AllowedValues) && vm.selectedAttibute.AllowedValues !== null) {
					vm.selectedAttibute.values = vm.selectedAttibute.AllowedValues
						.map(function(value) {
							return value.trim();
						})
						.sort(function(a, b) {
							return a.toLowerCase().localeCompare(b.toLowerCase());
						});
				}
				// for multivalue dropdown make the record as array
				if(vm.selectedAttibute.inputType === 'multi-value') {
					multiValueAttrbiuteIdList.push(vm.selectedAttibute.Attributeid);
					vm.record.Attribute_1_Value = [];
				}
				removeSelectedAttributeFromList(selectedObj);
			}
			else if(angular.isUndefined(selectedObj) || selectedObj === null) {
				vm.availableCatalogAttributes.unshift(utility.filterObject(vm.assignedCatalogAttributes, { Attributeid: vm.record[field] }, true)[0]);
				vm.record[field] = undefined; // on record removal make field undefined or the property can be deleted using delete keywork
			}
		}

		// convert dropdown scope value form object(lookup record) to id property of lookup record
		function lookupChangeAttribute2(selectedObj, field) {
			if(angular.isObject(selectedObj)) {
				vm.record[field] = selectedObj.Attributeid;
				vm.showAttribute_2_Id = true;
				vm.selectedAttibute2 = utility.changeAttributeType(selectedObj);
				//if vetting list assigned assign those to values
				if(angular.isDefined(vm.selectedAttibute2.AllowedValues) && vm.selectedAttibute2.AllowedValues !== null) {
					vm.selectedAttibute2.values = vm.selectedAttibute2.AllowedValues
						.map(function(value) {
							return value.trim();
						})
						.sort(function(a, b) {
							return a.toLowerCase().localeCompare(b.toLowerCase());
						});
				}

				// for multivalue dropdown make the record as array
				if(vm.selectedAttibute2.inputType === 'multi-value') {
					multiValueAttrbiuteIdList.push(vm.selectedAttibute2.Attributeid);
					vm.record.Attribute_2_Value = [];
				}
				removeSelectedAttributeFromList(selectedObj);
			}
			else if(angular.isUndefined(selectedObj) || selectedObj === null) {
				vm.availableCatalogAttributes.unshift(utility.filterObject(vm.assignedCatalogAttributes, { Attributeid: vm.record[field] }, true)[0]);
				vm.record[field] = undefined; // on record removal make field undefined or the property can be deleted using delete keywork
			}
		}

		function lookupChangeAttribute3(selectedObj, field) {
			if(angular.isObject(selectedObj)) {
				vm.record[field] = selectedObj.Attributeid;
				vm.showAttribute_3_Id = true;
				vm.selectedAttibute3 = utility.changeAttributeType(selectedObj);
				//if vetting list assigned assign those to values
				if(angular.isDefined(vm.selectedAttibute3.AllowedValues) && vm.selectedAttibute3.AllowedValues !== null) {
					vm.selectedAttibute3.values = vm.selectedAttibute3.AllowedValues
						.map(function(value) {
							return value.trim();
						})
						.sort(function(a, b) {
							return a.toLowerCase().localeCompare(b.toLowerCase());
						});
				}

				// for multivalue dropdown make the record as array
				if(vm.selectedAttibute3.inputType === 'multi-value') {
					multiValueAttrbiuteIdList.push(vm.selectedAttibute3.Attributeid);
					vm.record.Attribute_3_Value = [];
				}
				removeSelectedAttributeFromList(selectedObj);
			}
			else if(angular.isUndefined(selectedObj) || selectedObj === null) {
				vm.availableCatalogAttributes.unshift(utility.filterObject(vm.assignedCatalogAttributes, { Attributeid: vm.record[field] }, true)[0]);
				vm.record[field] = undefined; // on record removal make field undefined or the property can be deleted using delete keywork
			}
		}

		function lookupChangeAttribute4(selectedObj, field) {
			if(angular.isObject(selectedObj)) {
				vm.record[field] = selectedObj.Attributeid;
				vm.showAttribute_4_Id = true;
				vm.selectedAttibute4 = utility.changeAttributeType(selectedObj);
				//if vetting list assigned assign those to values
				if(angular.isDefined(vm.selectedAttibute4.AllowedValues) && vm.selectedAttibute4.AllowedValues !== null) {
					vm.selectedAttibute4.values = vm.selectedAttibute4.AllowedValues
						.map(function(value) {
							return value.trim();
						})
						.sort(function(a, b) {
							return a.toLowerCase().localeCompare(b.toLowerCase());
						});
				}

				// for multivalue dropdown make the record as array
				if(vm.selectedAttibute4.inputType === 'multi-value') {
					multiValueAttrbiuteIdList.push(vm.selectedAttibute2.Attributeid);
					vm.record.Attribute_4_Value = [];
				}
				removeSelectedAttributeFromList(selectedObj);
			}
			else if(angular.isUndefined(selectedObj) || selectedObj === null) {
				vm.availableCatalogAttributes.unshift(utility.filterObject(vm.assignedCatalogAttributes, { Attributeid: vm.record[field] }, true)[0]);
				vm.record[field] = undefined; // on record removal make field undefined or the property can be deleted using delete keywork
			}
		}

		function getlookupDisplayValue(item, allAttributes) {
			var attributeId = '';
			if(angular.isObject(item)) {
				attributeId = item.Attributeid;
			} else {
				attributeId = item;
			}
			var res = utility.filterObject(allAttributes, {Attributeid: attributeId}, true);
			if (angular.isArray(res) && res.length > 0) {
					return res[0].AttributeDisplayName;
			}

		}

		function getDateObj(dateString, field, fromUTC) {
			if(dateString) {
					return utility.createDateObject(dateString, field, fromUTC);
			}
		}

		function transformChip(chip, isMultiValue) {
			if(isMultiValue) {
					return chip;
			}
			return undefined;
		}

		function multiValueQuerySearch(query, selectedItems, field) {
			var values = field.values;
			var searchQueryResult = [];
			var searchQueryResult = utility.filterObject(values, query);
			if (selectedItems && selectedItems.length > 0) {
				for (var index = searchQueryResult.length - 1; index >= 0; index--) {
					if (selectedItems.indexOf(searchQueryResult[index]) !== -1) {
						searchQueryResult.splice(index, 1);
					}
				}
			}
			return searchQueryResult;
		}

		function removeSelectedAttributeFromList(selectedObj) {
			var index = vm.availableCatalogAttributes.indexOf(utility.filterObject(vm.availableCatalogAttributes, { Attributeid: selectedObj.Attributeid }, true)[0]);
			if (index !== -1) {
				vm.availableCatalogAttributes.splice(index, 1);
			}
		}

		// replace "Article" and "Model" in attributes name with T1S-ArticleLabel and T1S-ModelLabel if configured
		function replaceAttributeNames(attributes) {
			if((angular.isDefined(api.articleLabelConfiguration) && api.articleLabelConfiguration !== '') || (angular.isDefined(api.modelLabelConfiguration) && api.modelLabelConfiguration !== '')) {
				angular.forEach(attributes, function(attribute) {
					if(api.articleLabelConfiguration.length && attribute.AttributeDisplayName.toLowerCase().includes('article')) {
						attribute.AttributeDisplayName =  utility.replaceStringWithCase(attribute.AttributeDisplayName, 'article', api.articleLabelConfiguration);
					}
					if(api.modelLabelConfiguration.length && attribute.AttributeDisplayName.toLowerCase().includes('model')) {
						attribute.AttributeDisplayName =  utility.replaceStringWithCase(attribute.AttributeDisplayName, 'model', api.modelLabelConfiguration);
					}
					if(api.segmentationLabelConfiguration.length && attribute.AttributeDisplayName.toLowerCase().includes('segmentation')) {
						attribute.AttributeDisplayName =  utility.replaceStringWithCase(attribute.AttributeDisplayName, 'segmentation', api.segmentationLabelConfiguration);
					}
				});
			}
			return attributes;
		}

	}
})();
(function() {
	'use strict';

	angular
		.module('app.main.catalogs.buyer-limits.limits-criteria')
		.controller('attributeCriteriaDetailsController', attributeCriteriaDetailsController);

	/* @ngInject */
	function attributeCriteriaDetailsController($document, api, $state, $stateParams, $rootScope, catalogFactory, $mdDialog, utility, settingsFactory) {
	   /* jshint validthis: true */
		var vm = this;
		var attributeCriteriaId = $stateParams.id;
		vm.buyerLimitId = $stateParams.buyerLimitId;
		var activeCatalog = catalogFactory.getActiveCatalog();
		var activeCatalogCode = activeCatalog.CatalogCode;

		vm.model = api.catalogs.attributeCriteria;

		vm.notifyUsersModel = api.catalogs.notifyUsers;
		settingsFactory.applyPersistedListViewLayout(vm.notifyUsersModel);

		vm.attributeCriteria = {};
		var attributeCriteriaList = [];

		vm.notifyUsers = [];
		vm.filteredNotifyUsers = [];

		vm.isLoading = false;

		vm.refreshRecord = refreshRecord;

		vm.assignNotifyUsers = assignNotifyUsers;
		vm.doAttributeCriteriaItemAction = doAttributeCriteriaItemAction;
		vm.editAttributeCriteria = editAttributeCriteria;

		activate();

		////////////////

		function activate() {
			refreshRecord(true);
		}

		function refreshRecord() {
			vm.isLoading = true;

			api.catalogs.buyerLimits.methods.getDetails(vm.buyerLimitId, activeCatalogCode)
				.then(function (response) {
					attributeCriteriaList = response.data.AttributeCriteria;
					vm.attributeCriteria = utility.filterObject(attributeCriteriaList, {Id: parseInt(attributeCriteriaId)}, true)[0];
					vm.title = angular.copy(vm.attributeCriteria[vm.model.lookupDisplayField]);

					//Update Breadcrumb
					$state.current.data.displayName = vm.title;
					$rootScope.$broadcast('breadcrumb-updated');

					vm.notifyUsers = vm.attributeCriteria.NotifyUsers;
				})
				.finally(function () {
					vm.isLoading = false;
				});
		}

		function assignNotifyUsers(ev) {
			// add assigned customer id's to CustomerIdList
			var record = {};
			var assignedUsers = utility.filterObject(vm.notifyUsers, {'Status': 1}, true);

			record.UsersIdList = assignedUsers.map(function(record) {
				return record['UserId'];
			});
			api.showEditRecordDialog(angular.element($document.body), ev, vm.notifyUsersModel, record,  { 'attributeCriteriaId': attributeCriteriaId, 'buyerLimitId': vm.buyerLimitId })
			.then(function(saved) {
				if (saved) {
					refreshRecord();
				}
			});
		}

		function doAttributeCriteriaItemAction(action, record) {
			if (action) {
				switch (action.id) {
					case 'delete':
					case 'activate':
						vm.model.methods.activateBulk(record, vm.model, action.id, vm.buyerLimitId);
						break;
				}
			}
		}

		function editAttributeCriteria(record, ev) {
			$mdDialog.show({
				controller         : 'createAttributeController',
				controllerAs       : 'vm',
				templateUrl        : 'app/main/catalogs/sub-modules/buyer-limits/details/tabs/limits-criteria/dialogs/create-limits-criteria.html',
				parent             : angular.element($document.body),
				targetEvent        : ev,
				clickOutsideToClose: false,
				locals             : {
						isNew: false,
						record: record,
						buyerLimitId : vm.buyerLimitId,
						assignedRecords: angular.copy(attributeCriteriaList),
						model: vm.model,
						event: ev
				}
			}).then(function(saved) {
					if (saved) {
						refreshRecord();
					}
			});
		}

	}
})();
(function() {
    'use strict';
    
    angular
        .module('app.main.assortments.customers',[]);
})();
(function() {
    'use strict';

    angular
        .module('app.main.assortments.customers')
        .controller('createAssortmentCustomerController', createAssortmentCustomerController);

    /* @ngInject */
    function createAssortmentCustomerController($mdDialog, $scope, $window, $filter, hotkeys, toast, api, utility, assortmentId, activeCatalogId, model, assignedCustomers, promise, event, $q) {
        /* jshint validthis: true */
        var vm = this;

        //Data
        vm.api = api;
        vm.isLoading = false;
        vm.record = {};
        vm.availableCustomers = [];
        vm.catalogCustomersPromise = promise['catalogCustomersPromise'];
        var validData = [];
        var invalidData = [];
        var activeCustomersMapObj;

        //Methods

        vm.saveRecord = saveRecord;
        vm.closeDialog = closeDialog;

        var watchUnsubscribe = $scope.$watch('vm.editForm.CustomersCode.$error["tx-exist-value"]', function (newVal) {
            if (angular.isDefined(newVal) && vm.editForm.CustomersCode.$invalid && vm.editForm.CustomersCode.$error['tx-exist-value']) {
              vm.containInvalidRecords = true;
              removeInvalidData();
            }
        });

        activate();

        ////////////////

        function activate() {
            loadAvailableCustomers();
            //Hotkeys
            hotkeys.bindTo($scope).add({
                combo: 'ctrl+enter',
                description: $filter('translate')('ACTIONS.SAVE'),
                allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
                callback: function(event) {
                    if (!vm.isLoading && !vm.editForm.$invalid) {
                        vm.saveRecord();
                    }
                }
            });
        }

        function saveRecord() {
            vm.isLoading = true;
            var data = createRequestObject(assignedCustomers);

            model.methods.create(data, assortmentId, activeCatalogId).then(function() {
                closeDialog(true);
                toast.success('SUCCESS.CREATE', '', '');
            }).finally(function () {
                closeDialog();
                vm.isLoading = false;
            });
        }

        function closeDialog(saved) {
            $mdDialog.hide(saved);
        }

        function loadAvailableCustomers() {
            return api.getLookupData(api.catalogs.customers).then(function(result) {
                var resultClone = angular.copy(result);
                resultClone.data = utility.filterObject(resultClone.data, {Status: 1});
                vm.availableCustomers = resultClone;
                angular.forEach(assignedCustomers, function(assignedCustomer) {
                    var index = vm.availableCustomers.data.indexOf(utility.filterObject(vm.availableCustomers.data, {id: assignedCustomer[model.idField]}, true)[0]);
                    vm.availableCustomers.data.splice(index,1);
                    vm.availableCustomers.indexArray.splice(index,1);
                });
                return resultClone.data;
            });
        }

        function removeInvalidData() {
            validData.length = 0;
            invalidData.length = 0;
      
            var inputCustomerNumberList = vm.editForm.CustomersCode.$viewValue;// invalid models does not contain data
            populateValidAndInvalidData(inputCustomerNumberList)
              .then(function() {
                vm.inputValues = validData.join('\n');
                vm.invalidDataString = invalidData.join('\n');
              });
          }

          function populateValidAndInvalidData(inputValue) {
            var inputArticleNumberList = inputValue.match(/[^\r\n]+/g);
            return loadAvailableCustomers()
              .then(function(customers) {
                if (angular.isUndefined(activeCustomersMapObj) || utility.isObjectEmpty(activeCustomersMapObj)) {
                  return buildCustomersMapObj(customers);
                }
              })
              .then(function() {
                if(inputArticleNumberList) {
                  for (var i = 0, len = inputArticleNumberList.length; i < len; i++) {
                    if (angular.isDefined(activeCustomersMapObj[inputArticleNumberList[i]])) {
                      validData.push(inputArticleNumberList[i]);
                    }
                    else {
                      invalidData.push(inputArticleNumberList[i]);
                    }
                  }
                }
                else {
                  validData = [];
                  invalidData = [];
                }
              });
          }

          function buildCustomersMapObj(customers) {
            activeCustomersMapObj = {};
            for (var i = 0, len = customers.length; i < len; i++) {
              if (customers[i].Status === 1) {
                activeCustomersMapObj[customers[i]['value']] = 1;
              }
            }
            return $q.when(activeCustomersMapObj);
          }

        /**
         * @description
         *   a helper method which creates request object
         *
         * @param {string}  userInput       : user input in string format
         * @param {array}   assignedCustomers: all the assigned customers including newly assigned customers
         * @param {array}   availableCustomers  : list of unassigned and active customers
         * @return {object} an object containing request object and items name list(for logging purpose)
         *
         */
        function createRequestObject(assignedCustomers) {
            var result = {
                requestObj: [],
                itemsNameList: []
            };
            var customersCode = vm.inputValues.match(/[^\r\n]+/g);

            // creating array of object {CustomerId: id} by matching entered text against list of available customers
            var customers = customersCode.map(function(customerCode) {
                // check if entered input exist in list of available articles added to customers
                var customer = utility.filterObject(vm.availableCustomers.data, {value: customerCode}, true)[0];
                if(angular.isDefined(customer)) {
                    var rCustomer = {};
                    rCustomer[model.idField] = customer.id;
                    rCustomer[model.lookupDisplayField] = customer.value;
                    return rCustomer;
                }
            });

            // merge matched articles with already assigned articles
            angular.forEach(customers, function(customer) {
                if(customer) { // since map function retun undefine if criteria doesnot match
                    assignedCustomers.push(customer);
                }
            });

            // reate request object
            result.requestObj = assignedCustomers.map(function (customer) {
                var rObj = {};
                rObj[model.idField] = customer[model.idField];
                return rObj;
            });
            // create items name list used for logging
            angular.forEach(assignedCustomers, function(assignedArticle) {
                result.itemsNameList.push(assignedArticle[model.lookupDisplayField])
            });
            return result;
        }

        $scope.$on('$destroy', function () {
          watchUnsubscribe();
        });
    }
})();
(function() {
    'use strict';
    
    angular
        .module('app.main.assortments.articles',[]);
})();
(function() {
    'use strict';

    angular
        .module('app.main.assortments.articles')
        .controller('createAssortmentArticleController', createAssortmentArticleController);

    /* @ngInject */
    function createAssortmentArticleController($mdDialog, $scope, $filter, hotkeys, toast, api, utility, assortmentId, activeCatalogId, model, assignedArticles, promise, event, $q) {
        /* jshint validthis: true */
        var vm = this;

        //Data
        vm.api = api;
        vm.inputValues = "";
        vm.isLoading = false;
        vm.record = {};
        vm.availableArticles = [];
        vm.catalogArticlessPromise = promise['catalogArticlesPromise'];
        var activeArticlesMapObj;

        var validData = [];
        var invalidData = [];

        //Methods
        vm.saveRecord = saveRecord;
        vm.closeDialog = closeDialog;

        var watchUnsubscribe = $scope.$watch('vm.editForm.ArticleNumber.$error["tx-exist-value"]', function (newVal) {
            if (angular.isDefined(newVal) && vm.editForm.ArticleNumber.$invalid && vm.editForm.ArticleNumber.$error['tx-exist-value']) {
              vm.containInvalidRecords = true;
              removeInvalidData();
            }
        });

        activate();

        ////////////////

        function activate() {
            loadAvailableArticles();
            //Hotkeys
            hotkeys.bindTo($scope).add({
                combo: 'ctrl+enter',
                description: $filter('translate')('ACTIONS.SAVE'),
                allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
                callback: function(event) {
                    if (!vm.isLoading && !vm.editForm.$invalid) {
                        vm.saveRecord();
                    }
                }
            });
        }

        function saveRecord() {
            vm.isLoading = true;
            var data = createRequestObject(assignedArticles);

            model.methods.create(data, assortmentId , activeCatalogId).then(function() {
                closeDialog(true);
                toast.success('SUCCESS.CREATE', '', '');
            }).finally(function () {
                closeDialog();
                vm.isLoading = false;
            });
        }

        function closeDialog(saved) {
            $mdDialog.hide(saved);
        }

        /**
         * Load all the acticve articles which are not assigned to assortment
         */
        function loadAvailableArticles() {
            return api.getLookupData(api.catalogs.articles).then(function(result) {
                result.data = utility.filterObject(result.data, {Status: 1});
                vm.availableArticles = result;
                angular.forEach(assignedArticles, function(assignedArticle) {
                    var index = vm.availableArticles.data.indexOf(utility.filterObject(vm.availableArticles.data, {id: assignedArticle.ArticleId}, true)[0]);
                    vm.availableArticles.data.splice(index,1);
                    vm.availableArticles.indexArray.splice(index,1);
                });
                return result.data;
            });
        }

        function removeInvalidData() {
            validData.length = 0;
            invalidData.length = 0;

            var inputCustomerNumberList = vm.editForm.ArticleNumber.$viewValue;// invalid models does not contain data
            populateValidAndInvalidData(inputCustomerNumberList)
              .then(function() {
                vm.inputValues = validData.join('\n');
                vm.invalidDataString = invalidData.join('\n');
              });
          }

          function populateValidAndInvalidData(inputValue) {
            var inputArticleNumberList = inputValue.match(/[^\r\n]+/g);
            return loadAvailableArticles()
              .then(function(customers) {
                if (angular.isUndefined(activeArticlesMapObj) || utility.isObjectEmpty(activeArticlesMapObj)) {
                  return buildArticlesMapObj(customers);
                }
              })
              .then(function() {
                if(inputArticleNumberList) {
                  for (var i = 0, len = inputArticleNumberList.length; i < len; i++) {
                    if (angular.isDefined(activeArticlesMapObj[inputArticleNumberList[i]])) {
                      validData.push(inputArticleNumberList[i]);
                    }
                    else {
                      invalidData.push(inputArticleNumberList[i]);
                    }
                  }
                }
                else {
                  validData = [];
                  invalidData = [];
                }
              });
          }

          function buildArticlesMapObj(articles) {
            activeArticlesMapObj = {};
            for (var i = 0, len = articles.length; i < len; i++) {
              if (articles[i].Status === 1) {
                activeArticlesMapObj[articles[i]['value']] = 1;
              }
            }
            return $q.when(activeArticlesMapObj);
          }

        /**
         * @description
         *   a helper method which creates request object
         *
         * @param {string}  userInput       : user input in string format
         * @param {array}   assignedArticles: all the assigned articles including newly assigned articles
         * @param {array}   availableArticles  : list of unassigned and active articles
         * @return {object} an object containing request object and items name list(for logging purpose)
         *
         */
        function createRequestObject(assignedArticles) {
            var result = {
                requestObj: [],
                itemsNameList: []
            };
            var articleNumbers = vm.inputValues.match(/[^\r\n]+/g);

            // creating array of object {ArticleId: id} by matching entered text against list of available articles
            var articles = articleNumbers.map(function(articleNumber) {
                //if entered input exist in list of available articles
                var article = utility.filterObject(vm.availableArticles.data, {value: articleNumber}, true)[0];
                if(angular.isDefined(article)) {
                    var rArticle = {};
                    rArticle[model.idField] = article.id;
                    rArticle[model.lookupDisplayField] = article.value;
                    return rArticle;
                }
            });

            // merge matched articles with already assigned articles
            angular.forEach(articles, function(article) {
                if(article) { // since map function retun undefine if criteria doesnot match
                    assignedArticles.push(article);
                }
            });

            // reate request object
            result.requestObj = assignedArticles.map(function (article) {
                var rObj = {};
                rObj[model.idField] = article[model.idField];
                return rObj;
            });
            // create items name list used for logging
            angular.forEach(assignedArticles, function(assignedArticle) {
                result.itemsNameList.push(assignedArticle[model.lookupDisplayField])
            });
            return result;
        }

        $scope.$on('$destroy', function () {
            watchUnsubscribe();
        });
    }
})();
(function() {
    'use strict';
    
    angular
        .module('app.main.catalogs.articles.segmentation', []);
})();
(function() {
    'use strict';

    angular
        .module('app.main.catalogs.articles.segmentation')
        .controller('assignSegmentationToArticleController', assignSegmentationToArticleController);

    /* @ngInject */
    function assignSegmentationToArticleController(api, $q, $mdDialog, $scope, $window, $filter, hotkeys,
                toast, utility, model, assignedSegmentationsPromise, activeCatalog, articleId, lookupPromises, event, isArticleListAction, CONSTANTS, catalogFactory) {
        /* jshint validthis: true */
        var vm = this;

        //Data
        vm.model = model;

        vm.isLoading = false;
        vm.availableSegmentations = [];
        vm.isDataDirty = false;
        vm.record = {};
        vm.lookupModel = {};
        var assignedRecords = [];


        //Methods
        vm.saveRecord = saveRecord;
        vm.closeDialog = closeDialog;

        vm.lookupSearch = lookupSearch;
        vm.lookupChange = lookupChange;
        vm.getLookupDisplayValue = getLookupDisplayValue;
        vm.selectText = selectText;

        activate();


        ////////////////

        function activate() {

            loadAvailableSegmentations();
            if (catalogFactory.getActiveCatalog().SegmentationPlanningEnable === 1) {
                vm.isSegmentationPlanningEnable = true;
            }
            vm.planningValue = api.getSegmentationPlanningValues();
            if (vm.isSegmentationPlanningEnable) {
                // pre-select the configured default planning value for the new assignment
                vm.record.PlanningValue = api.getSegmentationPlanningDefault();
            }
            hotkeys.bindTo($scope).add({
                combo: 'ctrl+enter',
                description: $filter('translate')('ACTIONS.SAVE'),
                allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
                callback: function(event) {
                    if (!vm.isLoading && !vm.editForm.$invalid) {
                        vm.saveRecord();
                    }
                }
            });

            hotkeys.bindTo($scope).add({
                combo: 'ctrl+shift+enter',
                description: $filter('translate')('ACTIONS.SAVE_AND_NEW'),
                allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
                callback: function(event) {
                    if (!vm.isLoading && !vm.editForm.$invalid) {
                        vm.saveRecord(true);
                    }
                }
            });
        }

        function saveRecord(saveAndNew) {
            vm.record.activeCatalogCode = activeCatalog.CatalogCode;
            vm.record.articleId = articleId;
            vm.isLoading = true;
            vm.model.methods.create(vm.record, assignedRecords).then(function() {
                if (angular.isDefined(saveAndNew) && saveAndNew) {
                    vm.editForm.$setPristine();
                    vm.editForm.$setUntouched();
                    updateAssignedRecords();
                    vm.record = {};
                    if (vm.isSegmentationPlanningEnable) {
                        // re-apply the configured default planning value for the next assignment
                        vm.record.PlanningValue = api.getSegmentationPlanningDefault();
                    }
                    vm.acSearchText = [];
                    vm.searchText = {};
                    vm.isDataDirty = true;
                    var el = $window.document.getElementById('dialog_input_first');
                    if (el) {
                        el.focus();
                    }
                } else {
                    closeDialog(true);
                }
                toast.success('SUCCESS.LINKED', '', '');
            }, function() {
                closeDialog(vm.isDataDirty);
            }).finally(function () {
                vm.isLoading = false;
            });
        }

        function closeDialog(saved) {
            $mdDialog.hide(saved);
        }

        function lookupSearch(query, fieldName) {
            var results = [];

            var field = utility.filterObject(model.fields, {field: fieldName})[0];
            var lookupFilter = field.lookupFilter ? field.lookupFilter : {};
            var predicate = angular.copy(lookupFilter);
            predicate.value = query;

            if(angular.isDefined(vm.availableSegmentations.data) && vm.availableSegmentations.data.length) {
                results = query ? utility.filterObject(vm.availableSegmentations.data , predicate) : utility.filterObject(vm.availableSegmentations.data, lookupFilter);
                return results;
            }
            else {
                return loadAvailableSegmentations().then(function(availableSegmentations) {
                    results = query ? utility.filterObject(availableSegmentations.data , predicate) : utility.filterObject(availableSegmentations.data, lookupFilter);
                    return results;
                });
            }
        }

        // convert dropdown scope value form object(lookup record) to id property of lookup record
        function lookupChange(selectedObj, field) {
            if(angular.isObject(selectedObj)) {
                vm.record[field] = selectedObj.id;
            }
            else if(angular.isUndefined(selectedObj) || selectedObj === null) {
                vm.record[field] = undefined; // on record removal make field undefined or the property can be deleted using delete keywork
            }
        }

        function getLookupDisplayValue(item, fieldName) {
            var result;
            var field = utility.filterObject(model.fields, {field: fieldName})[0];
            var lookupModel = api.getModel(field.lookupSource);
            // internal open segmentation
            if(item.value === CONSTANTS.OPEN_SEGMENTATION) {
                return item.value;
            }
            else if(lookupModel.lookupData) {
                // since autocomplte return object
                if(angular.isObject(item)) {
                    result = utility.filterObject(lookupModel.lookupData.data, {id: item.id}, true);
                }
                // to initialize filed value if any (when open update record dialog)
                else {
                    result = utility.filterObject(lookupModel.lookupData.data, {id: item}, true);
                }

                if (angular.isArray(result) && result.length > 0) {
                    return result[0].value;
                }
                else {
                    return result.value;
                }
            }
        }

        function selectText(event) {
            utility.selectInputText(event);
        }


        // helper methods
        function loadAvailableSegmentations(skipAssignedReset) {
            var deferred = $q.defer();
            var promises = {lookupPromise: lookupPromises['SegmentationId'], assignedSegmentationsPromise: assignedSegmentationsPromise};
            $q.all(promises).then(function(response) {
                vm.availableSegmentations = angular.copy(response.lookupPromise);
                // Only (re)initialize assignedRecords from the one-time snapshot on the initial load.
                // assignedSegmentationsPromise is resolved once when the dialog opens, so re-reading it on a
                // post-save refresh would drop segmentations added during this session (skipAssignedReset === true).
                if(skipAssignedReset !== true) {
                    if(angular.isDefined(isArticleListAction) && !isArticleListAction) {
                        assignedRecords = response.assignedSegmentationsPromise.data;
                    } else if(angular.isDefined(isArticleListAction) && isArticleListAction) {
                        assignedRecords = utility.filterObject(response.assignedSegmentationsPromise.data, {Status: 1});
                    }
                }

                // vm.availableSegmentations.data = utility.filterObject(vm.availableSegmentations.data, {Status: 1});
                angular.forEach(assignedRecords, function(assignedRecord) {
                    // ignore Open segmentation
                    if(assignedRecord.Name !== CONSTANTS.OPEN_SEGMENTATION) {
                        var index = vm.availableSegmentations.data.indexOf(utility.filterObject(vm.availableSegmentations.data, {id: assignedRecord[model.idField]}, true)[0]);
                        if(index !== -1) {
                            vm.availableSegmentations.data.splice(index, 1);
                        }
                    }
                });
                // if all segmentations are un assigned or few are unassigned we are addung Open segmentaion to the dropdown option
                // user can select open and we will assign all the segmentations to article
                // if all the segmentations are assigned we will not show the 'Open' segmentations option
                if(vm.availableSegmentations.data.length > 0) {
                    var openObject = {
                        Status: 1,
                        id: 0,
                        value: CONSTANTS.OPEN_SEGMENTATION
                    }
                    vm.availableSegmentations.data.unshift(openObject);
                    vm.availableSegmentations.indexArray.unshift(0);
                }
                deferred.resolve(vm.availableSegmentations);
                // if indexArry needed to be utelize uncomment following code to update arrayIndexes values
                // utility.updateLookupDataIndexes(vm.availableSegmentations, segmentationsModel);
            });
            return deferred.promise;
        }

        // Saves are partial: the request carries only the segmentations being added, and the model's create()
        // appends them to assignedRecords. Rebuild the 'available' dropdown from that grown list rather than
        // from the one-time snapshot the dialog opened with, so a Save & New no longer re-offers a segmentation
        // added earlier in this session.
        function updateAssignedRecords() {
            loadAvailableSegmentations(true);
        }

    }
})();
(function() {
    'use strict';
    
    angular
        .module('app.main.catalogs.articles.resources', []);
})();

(function() {
    'use strict';

    angular
        .module('app.main.catalogs.articles.resources')
        .controller('assignResourcesController', assignResourcesController);

    /* @ngInject */
    function assignResourcesController($mdDialog, $scope, $filter, hotkeys, toast, api, utility, $q, articleId,
                activeCatalogId, sellerId, sellerAttributeGroupId, model, assignedResources, lookupPromises, event) {
        /* jshint validthis: true */
        var vm = this;

        //Data
        vm.model = model;
        vm.isLoading = false;
        vm.record = {};
        vm.record.ResourceId = [];
        vm.resourceLookup = {};

        // Map to track source of each resource by id
        var resourceSourceMap = {};

        //Methods
        vm.saveRecord = saveRecord;
        vm.closeDialog = closeDialog;

        vm.transformChip = transformChip;
        vm.acQuerySearch = acQuerySearch;
        vm.getChipDisplayValue = getChipDisplayValue;

        activate();

        ////////////////

        function activate() {
            loadResourcesLookup();
            hotkeys.bindTo($scope).add({
                combo: 'ctrl+enter',
                description: $filter('translate')('ACTIONS.SAVE'),
                allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
                callback: function(event) {
                    if (!vm.isLoading && !vm.editForm.$invalid) {
                        saveRecord();
                    }
                }
            });
        }

        function saveRecord() {
            vm.isLoading = true;

            // Split selected resources by source
            var catalogResourceIds = [];
            var sellerResourceIds = [];
            angular.forEach(vm.record.ResourceId, function(id) {
                if(resourceSourceMap[id] === 'seller') {
                    sellerResourceIds.push(id);
                } else {
                    catalogResourceIds.push(id);
                }
            });

            var promises = [];

            // Save catalog resources via existing method (only include seasonal resources in existing list)
            if(catalogResourceIds.length > 0) {
                var catalogRecord = angular.copy(vm.record);
                catalogRecord.ResourceId = catalogResourceIds;
                catalogRecord.activeCatalogId = activeCatalogId;
                catalogRecord.articleId = articleId;
                var seasonalAssignedResources = assignedResources.filter(function(r) { return r.IsSeasonal !== false; });
                promises.push(vm.model.methods.create(catalogRecord, seasonalAssignedResources));
            }

            // Save seller resources via seller endpoint (existing seasonless + newly selected)
            if(sellerResourceIds.length > 0) {
                var existingSellerIds = assignedResources.filter(function(r) { return r.IsSeasonal === false; }).map(function(r) { return r[api.catalogs.resources.idField]; });
                var sellerRequestObj = { ResourceId: existingSellerIds.concat(sellerResourceIds) };
                promises.push(api.webPut(api.baseUrl + '/sellers/' + sellerId + '/' + sellerAttributeGroupId + '/articles/' + articleId + '/assignresources', sellerRequestObj));
            }

            $q.all(promises).then(function() {
                closeDialog(true);
                toast.success('SUCCESS.CREATE', '', '');
            }).finally(function () {
                vm.isLoading = false;
            });
        }

        function closeDialog(saved) {
            $mdDialog.hide(saved);
        }

        function transformChip(chip) {
            if (angular.isObject(chip)) {
                return chip.id;
            }
            return undefined;
        }

        function getChipDisplayValue(chip, resourcesLookup) {
            var res = utility.filterObject(resourcesLookup.data, {id: chip}, true);
            if (angular.isArray(res) && res.length > 0) {
                return res[0].value;
            }
        }

        //TODO: Check performance impact on using nested filter
        function acQuerySearch(query, selectedItems, resourcesLookup) {
            var searchQueryResult = [];
            if(angular.isDefined(resourcesLookup.data) && resourcesLookup.data.length) {
                searchQueryResult = utility.filterObject(resourcesLookup.data, query);
                removeSelectedResources(selectedItems, searchQueryResult);
                return searchQueryResult;
            }
            else {
                return loadResourcesLookup().then(function(availableResources) {
                    searchQueryResult = utility.filterObject(availableResources.data, query);
                    removeSelectedResources(selectedItems, searchQueryResult);
                    return searchQueryResult;
                });
            }
        }

        //Helper Methods
        function loadResourcesLookup() {
            var deferred = $q.defer();
            var resourceModel = api.catalogs.resources;

            // Load both catalog and seller resources in parallel
            $q.all({
                catalog: lookupPromises['ResourceId'],
                seller: lookupPromises['SellerResourceId']
            }).then(function(results) {
                var catalogData = angular.copy(results.catalog);
                var sellerData = angular.copy(results.seller);

                // Filter to active only
                catalogData.data = utility.filterObject(catalogData.data, {Status: 1});
                sellerData.data = utility.filterObject(sellerData.data, {Status: 1});

                // Remove already-assigned resources from both
                angular.forEach(assignedResources, function(assignedResource) {
                    var assignedId = assignedResource[resourceModel.idField];
                    var catalogIndex = catalogData.data.indexOf(utility.filterObject(catalogData.data, {id: assignedId}, true)[0]);
                    if(catalogIndex !== -1) {
                        catalogData.data.splice(catalogIndex, 1);
                    }
                    var sellerIndex = sellerData.data.indexOf(utility.filterObject(sellerData.data, {id: assignedId}, true)[0]);
                    if(sellerIndex !== -1) {
                        sellerData.data.splice(sellerIndex, 1);
                    }
                });

                // Build source map and merge
                angular.forEach(catalogData.data, function(item) {
                    resourceSourceMap[item.id] = 'catalog';
                });
                angular.forEach(sellerData.data, function(item) {
                    resourceSourceMap[item.id] = 'seller';
                });

                vm.resourceLookup = { data: catalogData.data.concat(sellerData.data) };
                deferred.resolve(vm.resourceLookup);
            });

            return deferred.promise;
        }

        function removeSelectedResources(selectedItems, searchQueryResult) {
            if (angular.isDefined(selectedItems) && selectedItems.length > 0) {
                for (var index = searchQueryResult.length-1; index >= 0; index--) {
                    if (selectedItems.indexOf(searchQueryResult[index].id) !== -1) {
                        searchQueryResult.splice(index,1);
                    }
                }
            }
        }

    }
})();

(function() {
    'use strict';
    
    angular
        .module('app.main.catalogs.articles.prices', []);
})();
(function() {
    'use strict';

    angular
        .module('app.main.catalogs.articles.prices')
        .controller('createArticlePriceController', createArticlePriceController);

    /* @ngInject */
    function createArticlePriceController($mdDialog, $q, $scope, $window, $filter, $document, $localStorage, hotkeys, toast, api, utility, dialog,
                articleId, activeCatalogId, model, assignedPriceGroupsPromise, lookupPromises, articleStateId, event, catalogFactory, SecurityFactory, CONSTANTS) {
        /* jshint validthis: true */
        var vm = this;

        //Data
        vm.model = model;
        vm.isLoading = false;
        vm.record = {};
        vm.record.price = null;
        vm.lookupModel = {};
        vm.listOfActivePriceGroups = [];
        vm.searchText = {};
        vm.isDataDirty = false;
        var assignedPriceGroups = [];
        vm.numberOfDecimalsForPrices = api.numberOfDecimalsForPrices;
        vm.priceGroupNonEditable = false;
        vm.isAllowChangeRequestEnabled = false;
        vm.isPriceMandatory = false;
        // check the special privilege is assigned to the user for updating the state. if then does not restrict sizescale and model name update
        var isSpecialPermissionToIgnoreArticleStateIsAssigned = SecurityFactory.isAuthorized({accessPrivileges: CONSTANTS.PRIVILEGES.ARTICLES.SPECIAL_PRIVILEGE_TO_SKIP_STATE_VALIDATION});
        vm.updatePricesChangeManagementExternalURL = '';


        //Methods

        vm.saveRecord = saveRecord;
        vm.closeDialog = closeDialog;

        vm.lookupSearch = lookupSearch;
        vm.lookupChange = lookupChange;
        vm.getLookupDisplayValue = getLookupDisplayValue;
        vm.selectText = selectText;


        activate();

        ////////////////

        function activate() {

            loadAvailablePriceGroups();
            api.webGet('/app/app.config.json').then(function(response) {
                if (angular.isDefined(response) && angular.isDefined(response.data)) {
                    if(angular.isDefined(response.data['updatePricesChangeManagementExternalURL']) && response.data['updatePricesChangeManagementExternalURL'].length) {
                        vm.updatePricesChangeManagementExternalURL = response.data['updatePricesChangeManagementExternalURL'];
                    }
                }
            });
            //Hotkeys
            hotkeys.bindTo($scope).add({
                combo: 'ctrl+enter',
                description: $filter('translate')('ACTIONS.SAVE'),
                allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
                callback: function(event) {
                    if (!vm.isLoading && !vm.editForm.$invalid) {
                        vm.saveRecord();
                    }
                }
            });

            hotkeys.bindTo($scope).add({
                combo: 'ctrl+shift+enter',
                description: $filter('translate')('ACTIONS.SAVE_AND_NEW'),
                allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
                callback: function(event) {
                    if (!vm.isLoading && !vm.editForm.$invalid) {
                        vm.saveRecord(true);
                    }
                }
            });
        }

        function saveRecord(saveAndNew) {
            vm.isLoading = true;
            // For non-mandatory price groups, send 0 instead of null
            if (!vm.isPriceMandatory && (vm.record.price == null || vm.record.price == '')) {
                vm.record.price = 0;
            }
            vm.model.methods.create(vm.record, articleId , activeCatalogId).then(function(response) {
                if (angular.isDefined(saveAndNew) && saveAndNew) {
                    vm.editForm.$setPristine();
                    vm.editForm.$setUntouched();
                    updateAssignedPriceGroups(vm.record);
                    vm.record = {};
                    vm.acSearchText = [];
                    vm.searchText = {};
                    // if isDataDirty is true keep it true otherwise make it true when response.status != 202
                    vm.isDataDirty = vm.isDataDirty || (response.status !== 202);

                    var el = $window.document.getElementById('dialog_input_first');
                    if (el) {
                        el.focus();
                    }
                }
                else {
                    closeDialog(true);
                }

                if(response.status === 202) {
                    dialog.showAlertDialog(
                        angular.element($document.body),
                        $filter('translate')('MESSAGES.TITLE.ALERT'),
                        $filter('translate')('MESSAGES.CONTENT.CHANGE_REQUEST_ALERT'),
                        $filter('translate')('MESSAGES.TITLE.ALERT'),
                        $filter('translate')('ACTIONS.DIALOG_CLOSE'),
                        !!saveAndNew,
                        event);
                }
                else {
                    toast.success('SUCCESS.CREATE', '', '');
                }
            }, function(err) {
                closeDialog(vm.isDataDirty);
            }).finally(function () {
                vm.isLoading = false;
            });
        }

        function closeDialog(saved) {
            $mdDialog.hide(saved);
        }

        function lookupSearch(query, fieldName) {
            var results = [];

            var field = utility.filterObject(model.fields, {field: fieldName})[0];
            var lookupFilter = field.lookupFilter ? field.lookupFilter : {};
            var predicate = angular.copy(lookupFilter);
            predicate.value = query;

            if(angular.isDefined(vm.listOfActivePriceGroups.data) && vm.listOfActivePriceGroups.data.length) {
                results = query ? utility.filterObject(vm.listOfActivePriceGroups.data , predicate) :  utility.filterObject(vm.listOfActivePriceGroups.data, lookupFilter);
                return results;
            }
            else {
                return loadAvailablePriceGroups().then(function(listOfActivePriceGroups) {
                    results = query ? utility.filterObject(listOfActivePriceGroups.data , predicate) :  utility.filterObject(listOfActivePriceGroups.data, lookupFilter);
                    return results;
                });
            }
        }

        // convert dropdown scope value form object(lookup record) to id property of lookup record
        function lookupChange(selectedObj, field) {
            if(angular.isObject(selectedObj)) {
                vm.record[field] = selectedObj.id;
                // check if the article state rank is greater that or equal to price group state rank if yes then make the price non editable
                if(!isSpecialPermissionToIgnoreArticleStateIsAssigned && selectedObj.StateId != null) {
                    var assignedState = utility.filterObject(api.articleStatesList, {StateId: articleStateId}, true)[0];
                    if(assignedState) {
                        if(assignedState.StateRank >= selectedObj.StateRank) {
                            vm.priceGroupNonEditable = true;
                            if(selectedObj.AllowChangeRequestForPriceGroups && vm.updatePricesChangeManagementExternalURL !== '') {
                                vm.isAllowChangeRequestEnabled = true;
                            }
                        }
                    }
                }
                if(selectedObj.IsMandatory) {
                    vm.isPriceMandatory = true;
                }
            }
            else if(angular.isUndefined(selectedObj) || selectedObj === null) {
                vm.record[field] = undefined; // on record removal make field undefined or the property can be deleted using delete keywork
                vm.priceGroupNonEditable = false;
                vm.isAllowChangeRequestEnabled = false;
                vm.isPriceMandatory = false;
            }
        }

        function getLookupDisplayValue(item, fieldName) {
            var result;
            var field = utility.filterObject(model.fields, {field: fieldName})[0];
            var lookupModel = api.getModel(field.lookupSource);

            if(lookupModel.lookupData) {
                // since autocomplte return object
                if(angular.isObject(item)) {
                    result = utility.filterObject(lookupModel.lookupData.data, {id: item.id}, true);
                }
                // to initialize filed value if any (when open update record dialog)
                else {
                    result = utility.filterObject(lookupModel.lookupData.data, {id: item}, true);
                }

                if (angular.isArray(result) && result.length > 0) {
                    return result[0].value;
                }
                else {
                    return result.value;
                }
            }
        }

        function selectText(event) {
            utility.selectInputText(event);
        }

        //Helper method
        function loadAvailablePriceGroups() {
            var deferred = $q.defer();
            var promises = {lookupPromise: lookupPromises['PriceGroupId'], assignedPriceGroupsPromise: assignedPriceGroupsPromise};
            $q.all(promises).then(function(response) {
                assignedPriceGroups = response.assignedPriceGroupsPromise.data;
                vm.listOfActivePriceGroups = angular.copy(response.lookupPromise);
                vm.listOfActivePriceGroups.data = utility.filterObject(response.lookupPromise.data, {Status: 1, IsEditable: 1}); // to avoid always filtering when searching for value in autocomplete (second condition in ternary) we can filter them all here
                angular.forEach(assignedPriceGroups, function(assignedPriceGroup) {
                    var index = vm.listOfActivePriceGroups.data.indexOf(utility.filterObject(vm.listOfActivePriceGroups.data, {id: assignedPriceGroup.PriceGroupId}, true)[0]);
                    if(index !== -1) {
                        vm.listOfActivePriceGroups.data.splice(index, 1);
                    }
                });
                deferred.resolve(vm.listOfActivePriceGroups);
                // if indexArry needed to be utelize uncomment following code to update arrayIndexes values
                // utility.updateLookupDataIndexes(vm.listOfActivePriceGroups, api.catalogs.priceGroup);
            });
            return deferred.promise;
        }

        function updateAssignedPriceGroups(addedRecord) {
            assignedPriceGroups.push(addedRecord);
            loadAvailablePriceGroups();
        }

    }
})();
(function() {
    'use strict';

    angular
        .module('app.main.accounts.sellers.seller-resources', [])
        .config(config);

    /* @ngInject */
    function config($stateProvider) {

        $stateProvider.state('app.seller-resources', {
            url: '/seller-resources',
            abstract: true
        });

        $stateProvider.state('app.seller-resources.details', {
            url: '/:id',
            views: {
                'content@app': {
                    templateUrl: 'app/main/accounts/sellers/details/tabs/seller-resources/details/seller-resource-details.html',
                    controller: 'sellerResourceDetailsController as vm'
                }
            },
            data: {
                parentState: 'app.accounts_sellers',
                displayName: 'RESOURCES.TABS.RESOURCE'
            },
            accessInfo: {
                accessPrivileges: ['GetSellerResourceDetails']
            }
        });
    }
})();
(function() {
    'use strict';

    angular
        .module('app.main.accounts.sellers.seller-resources')
        .controller('assignSellerResourceEntitiesController', assignSellerResourceEntitiesController);

    /* @ngInject */
    function assignSellerResourceEntitiesController($mdDialog, toast, api, utility,
                sellerId, attributeGroupId, resourceId, isModelLevel, assignedArticles, assignedModels, entityApiUrl, displayField, idField) {
        /* jshint validthis: true */
        var vm = this;

        //Data
        vm.isLoading = false;
        vm.isLookupLoading = true;
        vm.selectedIds = [];
        vm.acSearchText = '';
        vm.acSelectedItem = null;
        vm.entityLookup = {};
        vm.label = isModelLevel ? 'Models' : 'Articles';

        var existingIds = isModelLevel
            ? assignedModels.map(function(m) { return m.ModelId || m.Id; })
            : assignedArticles.map(function(a) { return a.ArticleId || a.Id; });
        var latestSearchQuery = '';

        //Methods
        vm.saveRecord = saveRecord;
        vm.closeDialog = closeDialog;
        vm.transformChip = transformChip;
        vm.querySearch = querySearch;
        vm.getChipDisplayValue = getChipDisplayValue;

        activate();

        ////////////////

        function activate() {
            // Load first page for initial display
            var paginatedUrl = entityApiUrl + (entityApiUrl.indexOf('?') !== -1 ? '&' : '?') + 'page=1&pageSize=100';
            api.webGet(api.baseUrl + paginatedUrl, undefined, true, true).then(function(response) {
                var allEntities = (response.data || []).filter(function(entity) {
                    return existingIds.indexOf(entity[idField] || entity.Id) === -1;
                });
                vm.entityLookup = {
                    data: allEntities.map(function(entity) {
                        return { id: entity[idField] || entity.Id, value: entity[displayField], Status: 1 };
                    })
                };
            }).finally(function() {
                vm.isLookupLoading = false;
            });
        }

        function saveRecord() {
            vm.isLoading = true;
            var existingArticleIds = assignedArticles.map(function(a) { return a.ArticleId || a.Id; });
            var existingModelIds = assignedModels.map(function(m) { return m.ModelId || m.Id; });
            var finalArticleIds = isModelLevel ? [] : existingArticleIds.concat(vm.selectedIds);
            var finalModelIds = isModelLevel ? existingModelIds.concat(vm.selectedIds) : [];
            var requestObj = {
                IsModelLevel: finalModelIds.length > 0 ? 1 : (finalArticleIds.length > 0 ? 0 : null),
                ArticleIds: finalArticleIds,
                ModelIds: finalModelIds
            };
            api.webPut(api.baseUrl + '/sellers/' + sellerId + '/' + attributeGroupId + '/resources/' + resourceId + '/assignentities', requestObj)
            .then(function() {
                closeDialog(true);
                toast.success('SUCCESS.LINKED', '', '');
            }).finally(function() {
                vm.isLoading = false;
            });
        }

        function closeDialog(saved) {
            $mdDialog.hide(saved);
        }

        function transformChip(chip) {
            if (angular.isObject(chip)) {
                return chip.id;
            }
            return undefined;
        }

        function getChipDisplayValue(chip, entityLookup) {
            var res = utility.filterObject(entityLookup.data, {id: chip}, true);
            if (angular.isArray(res) && res.length > 0) {
                return res[0].value;
            }
        }

        function querySearch(query, selectedItems, entityLookup) {
            // Server-side search for 3+ characters
            if(query && query.length >= 3) {
                var currentQuery = query;
                latestSearchQuery = currentQuery;
                var filterParam = isModelLevel ? 'modelnumber' : 'articlenumber';
                var searchUrl = entityApiUrl + (entityApiUrl.indexOf('?') !== -1 ? '&' : '?') + filterParam + '=' + encodeURIComponent(query) + '&page=1&pageSize=100';

                return api.webGet(api.baseUrl + searchUrl, undefined, true, true).then(function(response) {
                    // Ignore stale responses
                    if(latestSearchQuery !== currentQuery) {
                        return filterSelected([], selectedItems);
                    }
                    var mapped = (response.data || []).filter(function(entity) {
                        return existingIds.indexOf(entity[idField] || entity.Id) === -1;
                    }).map(function(entity) {
                        return { id: entity[idField] || entity.Id, value: entity[displayField], Status: 1 };
                    });
                    // Merge into local cache for chip display resolution
                    angular.forEach(mapped, function(m) {
                        var exists = false;
                        for(var j = 0; j < vm.entityLookup.data.length; j++) {
                            if(vm.entityLookup.data[j].id === m.id) { exists = true; break; }
                        }
                        if(!exists) { vm.entityLookup.data.push(m); }
                    });
                    return filterSelected(mapped, selectedItems);
                });
            }

            // Client-side filter on cached data for < 3 chars
            var data = (entityLookup && entityLookup.data) ? entityLookup.data : [];
            return filterSelected(clientFilter(data, query), selectedItems);
        }

        function clientFilter(data, query) {
            var maxResults = 100;
            var results = [];
            var lowerQuery = query ? query.toLowerCase() : '';
            for(var i = 0; i < data.length && results.length < maxResults; i++) {
                if(!query || (data[i].value && data[i].value.toLowerCase().indexOf(lowerQuery) !== -1)) {
                    results.push(data[i]);
                }
            }
            return results;
        }

        function filterSelected(results, selectedItems) {
            if(!angular.isDefined(selectedItems) || selectedItems.length === 0) return results;
            return results.filter(function(item) {
                return selectedItems.indexOf(item.id) === -1;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.main.catalogs',[
            'app.main.catalogs.overview',
            'app.main.catalogs.attributes',
            'app.main.catalogs.restrict-attributes',
            'app.main.catalogs.configurations',
            'app.main.catalogs.CRD',
            'app.main.catalogs.price-group',
            'app.main.catalogs.segmentations',
            'app.main.catalogs.articles',
            'app.main.catalogs.article-color',
            'app.main.catalogs.targets',
            'app.main.catalogs.customers',
            'app.main.catalogs.sizes',
            'app.main.catalogs.prices',
            'app.main.catalogs.crds',
            'app.main.catalog-articles.segmentation',
            'app.main.catalog-customers.segmentation',
            'app.main.catalogs.assortments',
            'app.main.catalogs.treeDefinition',
            'app.main.catalogs.tree',
            'app.main.catalogs.packages',
            'app.main.catalogs.images',
            'app.main.catalogs.resources',
            'app.main.catalogs.orders',
            'app.main.catalogs.consolidations',
            'app.main.catalogs.consolidation-templates',
            'app.main.catalogs.reports',
            'app.main.catalogs.articles-replacement',
            'app.main.catalogs.change-logs',
            'app.main.catalogs.shipment-window',
            'app.main.catalogs.size-scale-groups',
            'app.main.catalogs.allocation-groups',
            'app.main.catalogs.customer-allocations',
            'app.main.catalogs.linked-buyers',
            'app.main.catalogs.forecast',
            'app.main.catalogs.stock-definition',
            'app.main.catalogs.stock',
            'app.main.catalogs.attribute-vetting-list',
            'app.main.catalogs.segmentation-group',
            'app.main.catalogs.linkedAttributes',
            'app.main.catalogs.linkedCatalogs',
            'app.main.catalogs.targetedAttributes',
            'app.main.catalogs.articles-blocking',
            'app.main.catalogs.favorites',
            'app.main.catalogs.merch-boards',
            'app.main.catalogs.customers-locations',
            'app.main.catalogs.order-adjustments',
            'app.main.catalogs.seller-users',
            'app.main.catalogs.modelLevelAttributes',
            'app.main.catalog-customers.segmentation-linear',
            'app.main.catalog-articles.segmentation-linear',
            'app.main.catalogs.prices-linear',
            'app.main.catalogs.stock-linear',
            'app.main.catalogs.crds-linear',
            'app.main.catalogs.tree-list',
            'app.main.catalogs.dune-images',
            'app.main.catalogs.models',
            'app.main.catalogs.requests',
            'app.main.catalogs.requestAttributes',
            'app.main.catalogs.buyer-limits',
            'app.main.catalogs.request-reasons',
            'app.main.catalogs.article-change-logs',
            'app.main.catalogs.watch-filters',
            'app.main.catalogs.orders-terms-conditons',
            'app.main.catalogs.bucketLevelAttributes',
            'app.main.catalogs.restrict-bucket-attributes',
            'app.main.catalogs.color-definition',
            'app.main.catalogs.buy-windows',
            'app.main.catalogs.shared-folders',
            'app.main.catalogs.relation-types',
            'app.main.catalogs.restrict-segmentations',
            'app.main.catalogs.restrict-retail-windows',
            'app.main.catalogs.catalog-color-palette',
            'app.main.catalogs.shared-folders-tree',
            'app.main.catalogs.saved-views',
            'app.main.catalogs.aggregateAttributes',
            'app.main.catalogs.size-curves',
            'app.main.catalogs.catalog-datasets',
        ])
        .config(config);

    /* @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
        // State
        $stateProvider.state('app.catalogs', {
            url    : '/catalogs',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/catalogs/list/catalogs-list.html',
                    controller : 'catalogsController as vm'
                }
            },
            data: {
                displayName: 'CATALOGS.NAV'
            },
            resolve: {

            },
            //only users with following accessPrivileges in their role access list can access this route
            // accessPrivileges: ['CatalogList']
            // accessPrivileges: ['nav_catalogs']
            accessInfo: {
                accessPrivileges: ['nav_catalogs']
            },
            visibleForLinePlan: true
        });
        $stateProvider.state('app.catalogs.details', {
            url	 : '/:id',
            params: {
                dataSourceTypeId: undefined,
                isShippingWindowApply: undefined
            },
            views: {
                'content@app': {
                    templateUrl: 'app/main/catalogs/details/catalog-details.html',
                    controller : 'catalogDetailsController as vm'
                }
            },
            data: {
                parentState: 'app.catalogs',
                displayName: 'CATALOGS.TABS.CATALOG'
            },
            resolve: {
                catalogModel: function (api, utility) {
                    var catalogModel = angular.copy(api.catalogs.catalogs);
                    utility.filterObject(catalogModel.fields, { field: 'CopyPriceCatalogs' }, true)[0].visible = true;
                    return catalogModel;
                },
                shipmentWindowRangeModel: function(api, catalogFactory, utility) {
                    var shipmentWindowsModel = angular.copy(api.catalogs.shipmentWindows);
                    var retailwindowAttribute = catalogFactory.getActiveCatalog().RetailWindowAttribute;
                    var isRetailWindowAttributeAdded = (retailwindowAttribute != null && retailwindowAttribute !== '') ? true : false;
                    if(!isRetailWindowAttributeAdded) {
                        shipmentWindowsModel.views.mainList.fabAction = {};
                        shipmentWindowsModel.views.mainList.itemActions = [];
                        shipmentWindowsModel.views.mainList.listActions = [];
                    }
                    return shipmentWindowsModel;
                }
            },
            //only users with following accessPrivileges in their role access list can access this route
            // accessPrivileges: ['GetCatalogDetails']
            accessInfo: {
                accessPrivileges: ['GetCatalogDetails']
            },
            visibleForLinePlan: true
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/catalogs');


        msNavigationServiceProvider.saveItem('main.catalogs', {
            title      : 'Catalogs',
            icon       : 'icon-book-open',
            state      : 'app.catalogs',
            translate  : 'CATALOGS.NAV',
            weight     : 10,
            // accessPrivileges: ['CatalogList']
            // accessPrivileges: ['nav_catalogs'],
            accessInfo: {
                accessPrivileges: ['nav_catalogs']
            },
            visibleForLinePlan: true
        });
    }
})();
(function () {
	'use strict';

	angular
			.module('app.main.catalogs')
			.controller('createLookupTable', createLookupTable);

	/* @ngInject */
	function createLookupTable($mdDialog, $scope, $filter, hotkeys, toast, api, utility, $q, model, sellerId, existingRecordsForUniqueValue, event) {
			/* jshint validthis: true */
			var vm = this;

			//Data
			vm.isLoading = false;
			var allAttributes = [];
			vm.isDataDirty = false;
			vm.maxChips = 2;
			vm.record = {};
			vm.existingRecordsForUniqueValue = existingRecordsForUniqueValue;

			vm.acSelectedItem = [];
			vm.acSearchText = [];
			vm.searchText = {};
			vm.record.SourceAttributesIds = [];
			vm.record.DestinationAttributesIds = [];


			//Methods
			vm.saveRecord = saveRecord;
			vm.closeDialog = closeDialog;

			vm.lookupSearch = lookupSearch;
			vm.onLookupChange = onLookupChange;
			vm.getLookupDisplayValue = getLookupDisplayValue;

			vm.acQuerySearch = acQuerySearch;
			vm.transformChip = transformChip;
			vm.getChipDisplayValue = getChipDisplayValue;

			vm.selectText = selectText;

			activate();

			////////////////

			function activate() {
					//Hotkeys
					hotkeys.bindTo($scope).add({
							combo: 'ctrl+enter',
							description: $filter('translate')('ACTIONS.SAVE'),
							allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
							callback: function (event) {
									if (!vm.isLoading && !vm.editForm.$invalid) {
											vm.saveRecord();
									}
							}
					});
			}

			function saveRecord() {
					vm.isLoading = true;
					var p = model.methods.create(vm.record, sellerId);
					p.then(function () {
							closeDialog(true);
							var toastMessage;
							toastMessage = 'SUCCESS.CREATE';
							toast.success(toastMessage, '', '');
					}, function () {
							closeDialog(vm.isDataDirty);
					}).finally(function () {
							vm.isLoading = false;
					});
			}


			function closeDialog(saved) {
					$mdDialog.hide(saved);
			}

			function lookupSearch(query, fieldName) {
					var results = [];

					var field = utility.filterObject(model.fields, { field: fieldName }, true)[0];
					var lookupFilter = field.lookupFilter ? field.lookupFilter : {};
					var predicate = angular.copy(lookupFilter);
					predicate.value = query;
					var lookupModel = api.getModel(field.lookupSource);

					if (angular.isDefined(lookupModel.lookupData)) {
							results = query ? utility.filterObject(lookupModel.lookupData.data, predicate) : utility.filterObject(lookupModel.lookupData.data, lookupFilter, true);
							return results;
					}
					else {
							return api.getLookupData(lookupModel).then(function () {
									results = query ? utility.filterObject(lookupModel.lookupData.data, predicate) : utility.filterObject(lookupModel.lookupData.data, lookupFilter, true);
									return results;
							});
					}
			}

			// convert drop down scope value form object(lookup record) to id property of lookup record
			function onLookupChange(selectedObj, field) {
					if (angular.isObject(selectedObj)) {
							vm.record[field] = selectedObj.id;
							loadAttributes(vm.record.AttributeGroupId);
					} else if (angular.isUndefined(selectedObj) || selectedObj === null) {
						vm.record[field] = undefined;
					}
			}

			function getLookupDisplayValue(item, lookupSource) {
					var lookupModel = api.getModel(lookupSource);

					if (lookupModel.lookupData && angular.isDefined(lookupModel.lookupData.data) && lookupModel.lookupData.data.length) {
							return getLookupDisplayVal(item, lookupModel.lookupData);
					}
					else {
							return api.getLookupData(lookupModel).then(function (lookupData) {
									return getLookupDisplayVal(item, lookupData);
							});
					}
			}

			function getLookupDisplayVal(item, lookupData) {
					var result;
					if (lookupData) {
							// since autocomplete return object
							if (angular.isObject(item)) {
									result = utility.filterObject(lookupData.data, { id: item.id }, true);
							}
							// to initialize field value if any (when open update record dialog)
							else {
									result = utility.filterObject(lookupData.data, { id: item }, true);
							}
							if (angular.isArray(result) && result.length > 0) {
									return result[0].value;
							}
							else {
									return result.value;
							}
					}
			}

			function acQuerySearch(query, selectedItems, isSourceAttribute) {
					var predicate = { AttributeDisplayName: query };
					var searchQueryResult = utility.filterObject(allAttributes, predicate);
					for (var index = searchQueryResult.length - 1; index >= 0; index--) {
							if (selectedItems && selectedItems.length > 0) {
								if (selectedItems.indexOf(searchQueryResult[index].Attributeid) !== -1) {
										searchQueryResult.splice(index, 1);
								}
							}
							if(isSourceAttribute) { // source attributes are always non lookuptable type attributes
								if(searchQueryResult[index].AttributeTypeId === 14) {
									searchQueryResult.splice(index, 1);
								}
							} else if(!isSourceAttribute) { // destinations attributes are always lookuptable type attributes
								var lookupTableAttributes = utility.filterObject(searchQueryResult, {AttributeTypeId: 14}, true);
								searchQueryResult = lookupTableAttributes;
							}
					}
					return searchQueryResult;
			}

			function transformChip(chip) {
					if (angular.isObject(chip)) {
						return chip.Attributeid;
					}
					return undefined;
			}

			function getChipDisplayValue(chip) {
					var res = utility.filterObject(allAttributes, { Attributeid: chip }, true);
					if (angular.isArray(res) && res.length > 0) {
							return res[0].AttributeDisplayName;
					}
			}

			function selectText(event) {
					utility.selectInputText(event);
			}

			function loadAttributes(attributeGroupId) {
					allAttributes = [];
					// get all the attributes including seasonless and seasonal
					api.lists.allAttributesFromAGroup.methods.getList(false, sellerId, attributeGroupId)
					.then(function (response) {
						allAttributes = utility.filterObject(response.data, { Status: 1 }, true);
					});
			}

	}
})();
(function() {
		'use strict';

		angular
				.module('app.main.accounts.sellers.seller-datasets', [
					'app.main.accounts.sellers.seller-datasets.values'
				])
				.config(config);

				/* @ngInject */
				function config($translatePartialLoaderProvider) {
						// Translation
						$translatePartialLoaderProvider.addPart('app/main/accounts/sellers/details/tabs/seller-datasets');
				}
})();
(function () {
	'use strict';

	angular
			.module('app.main.accounts.sellers.seller-datasets')
			.controller('createUpdateDatasets', createUpdateDatasets);

	/* @ngInject */
	function createUpdateDatasets($mdDialog, $scope, $filter, hotkeys, toast, api, utility, model, sellerId, record, isNew, existingRecordsForUniqueValue, lookupPromises) {
			/* jshint validthis: true */
			var vm = this;

			//Data
			vm.isLoading = false;
			vm.record = (angular.isDefined(record) && record != null) ? angular.copy(record) : {};
			vm.isDataDirty = false;
			vm.maxChips = 2;
			vm.existingRecordsForUniqueValue = existingRecordsForUniqueValue;
			vm.isNew = isNew;

			vm.acSelectedItem = [];
			vm.acSearchText = [];
			vm.searchText = {};
			vm.record.AttributesIds = vm.record.AttributesIds ? vm.record.AttributesIds : [];


			//Methods
			vm.saveRecord = saveRecord;
			vm.closeDialog = closeDialog;

			vm.acQuerySearch = acQuerySearch;
			vm.transformChip = transformChip;
			vm.getChipDisplayValue = getChipDisplayValue;

			vm.selectText = selectText;

			activate();

			////////////////

			function activate() {
					//Hotkeys
					hotkeys.bindTo($scope).add({
							combo: 'ctrl+enter',
							description: $filter('translate')('ACTIONS.SAVE'),
							allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
							callback: function (event) {
									if (!vm.isLoading && !vm.editForm.$invalid) {
											vm.saveRecord();
									}
							}
					});
			}

			function saveRecord() {
					vm.isLoading = true;
					var p;

					if (vm.isNew)
					{
							p = model.methods.create(vm.record, sellerId);
					} else {
							p = model.methods.update(vm.record.Id, vm.record, sellerId);
					}

					p.then(function(response) {
							closeDialog(true);
							// Only show toast for create (synchronous). Update is a background job — progress shown in Quick Panel.
							if (vm.isNew) {
								toast.success('SUCCESS.CREATE', '', '');
							}
					}, function() {
							closeDialog(vm.isDataDirty);
					}).finally(function () {
							vm.isLoading = false;
					});
			}

			function closeDialog(saved) {
					$mdDialog.hide(saved);
			}

			function acQuerySearch(query, selectedRecords, fieldName) {
				var results = [];
				var field = utility.filterObject(model.fields, { field: fieldName, inputType: 'lookup-many' }, true)[0];
				var lookupFilter = angular.isDefined(field.lookupFilter) ? field.lookupFilter : {};
				var predicate = angular.copy(lookupFilter);
				predicate.value = query;

				var lookupModel = api.getModel(field.lookupSource);
				if (angular.isDefined(lookupModel.lookupData) && angular.isDefined(lookupModel.lookupData.data) && lookupModel.lookupData.data.length) {
					results = query ? utility.filterObject(lookupModel.lookupData.data, predicate) : utility.filterObject(lookupModel.lookupData.data, lookupFilter);
					results = removeSelectedChips(selectedRecords, results);
					// ALLOW ONLY nvarchar, bool, int, decimal, date and dateoption type attributes
					return getAllowedAttributes(results)
				}
				else {
					return lookupPromises[field.field].then(function (lookupData) {
						results = query ? utility.filterObject(lookupData.data, predicate) : utility.filterObject(lookupData.data, lookupFilter);
						results = removeSelectedChips(selectedRecords, results);
						// ALLOW ONLY nvarchar, bool, int, decimal, date and dateoption type attributes
						return getAllowedAttributes(results)
					});
				}
			}

			function getAllowedAttributes(results) {
				var allowedAttributes = [];
				angular.forEach(results, function(attribute) {
					if(attribute.AttributeTypeId === 1 || attribute.AttributeTypeId === 2 || attribute.AttributeTypeId === 3 || attribute.AttributeTypeId === 4 || attribute.AttributeTypeId === 5 || attribute.AttributeTypeId === 7 || attribute.AttributeTypeId === 9) {
						allowedAttributes.push(attribute);
					}
				})
				return allowedAttributes;
			}

			function removeSelectedChips(selectedRecords, records) {
				if (angular.isDefined(selectedRecords) && selectedRecords.length > 0) {
					for (var index = records.length - 1; index >= 0; index--) {
						if (selectedRecords.indexOf(records[index].id) !== -1) {
							records.splice(index, 1);
						}
					}
				}
				return records;
			}

			function transformChip(chip) {
					if (angular.isObject(chip)) {
						return chip.id;
					}
					return undefined;
			}

			function getChipDisplayValue(chip, fieldName) {
					var field = utility.filterObject(model.fields, { field: fieldName }, true)[0];
					var lookupModel = api.getModel(field.lookupSource);
					if (angular.isDefined(lookupModel.lookupData) && angular.isDefined(lookupModel.lookupData.data) && lookupModel.lookupData.data.length) {
						return getChipDisplayVal(lookupModel.lookupData, chip);
					}
					else { // it will never go to else part since before try to load display value for selected chips, it always load lookup on focus of chips input element
						return lookupPromises[field.field].then(function (lookupData) {
							return getChipDisplayVal(lookupData, chip);
						});
					}
			}

			function getChipDisplayVal(lookupData, chip) {
				var res = utility.filterObject(lookupData.data, { id: chip }, true);
				if (angular.isArray(res) && res.length > 0) {
					return res[0].value;
				}
				else {
					$log.warn('viewCreator controller: Unable to resolve chip display value!');
					return "";
				}
			}

			function selectText(event) {
					utility.selectInputText(event);
			}

	}
})();
(function () {
	'use strict';

	angular
		.module('app.main.accounts.sellers.capacities')
		.controller('createCapacityController', createCapacityController);

	/* @ngInject */
	function createCapacityController($mdDialog, $scope, $filter, toast, hotkeys, utility,
		record, isNew, model, existingRecordsForUniqueValue, sellerId, availableAttributes, event) {
		/* jshint validthis: true */
		var vm = this;

		// Data
		vm.isLoading = false;
		vm.isDataDirty = false;
		vm.isNew = isNew;
		vm.model = model;
		vm.record = record ? angular.copy(record) : {};
		vm.criterias = [];
		vm.existingRecordsForUniqueValue = existingRecordsForUniqueValue;
		vm.availableAttributes = availableAttributes || [];

		vm.lookupModel = [];
		vm.searchText = [];

		// Methods
		vm.saveRecord = saveRecord;
		vm.closeDialog = closeDialog;
		vm.selectText = selectText;
		vm.lookupAttributeSearch = lookupAttributeSearch;
		vm.lookupAttributeChange = lookupAttributeChange;
		vm.getAttributeLookupDisplayValue = getAttributeLookupDisplayValue;

		if (vm.isNew) {
			createEmptyRow();
		} else {
			populateEditDialog();
		}

		activate();

		////////////////

		function activate() {
			hotkeys.bindTo($scope).add({
				combo: 'ctrl+enter',
				description: $filter('translate')('ACTIONS.SAVE'),
				allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
				callback: function () {
					if (!vm.isLoading && !vm.editForm.$invalid) {
						vm.saveRecord();
					}
				}
			});
		}

		function saveRecord() {
			var criteria = buildCriteria(vm.criterias);

			// at least one complete condition (Attribute + non-empty Value) is required
			if (!criteria.length) {
				toast.error('SELLERS.CAPACITIES.MESSAGES.CRITERIA_REQUIRED', '', '');
				return;
			}

			// Send only the fields the API owns. On edit, vm.record is a copy of the list row, so
			// posting it whole would leak Status/LinkedCustomersCount/CapacityId into the body.
			var payload = { Name: vm.record.Name, Criteria: criteria };

			vm.isLoading = true;
			var p;
			if (vm.isNew) {
				p = vm.model.methods.create(payload, sellerId);       // API 1
			} else {
				p = vm.model.methods.update(vm.record.CapacityId, payload, sellerId); // API 4
			}

			p.then(function (response) {
				closeDialog(true);
				var toastMessage = response.config.method.toUpperCase() === 'POST' ? 'SUCCESS.CREATE' : 'SUCCESS.UPDATE';
				toast.success(toastMessage, '', '');
			}, function (error) {
				// Name uniqueness (per seller, case-insensitive) is enforced server-side.
				// Keep the dialog open so the user can correct the name.
				if (error && error.status === 409) {
					toast.error('SELLERS.CAPACITIES.MESSAGES.NAME_NOT_UNIQUE', '', '');
				}
			}).finally(function () {
				vm.isLoading = false;
			});
		}

		function closeDialog(saved) {
			$mdDialog.hide(saved);
		}

		function selectText(event) {
			utility.selectInputText(event);
		}

		// Criteria builder ------------------------------------------------------

		function lookupAttributeSearch(query) {
			var predicate = { AttributeDisplayName: query };
			return query ? utility.filterObject(vm.availableAttributes, predicate) : vm.availableAttributes;
		}

		function lookupAttributeChange(selectedObj, rowIndex) {
			if (angular.isObject(selectedObj)) {
				vm.criterias[rowIndex] = utility.changeAttributeType(selectedObj);
				vm.criterias[rowIndex].value = [];
			} else if (angular.isUndefined(selectedObj) || selectedObj === null) {
				vm.criterias[rowIndex] = { Attributeid: undefined, value: [] };
			}
			// keep a trailing empty row
			if (rowIndex === vm.criterias.length - 1) {
				createEmptyRow();
			}
		}

		function getAttributeLookupDisplayValue(item) {
			var result;
			if (!vm.availableAttributes) {
				return;
			}
			if (angular.isObject(item)) {
				result = utility.filterObject(vm.availableAttributes, { Attributeid: item.Attributeid }, true);
			} else {
				result = utility.filterObject(vm.availableAttributes, { Attributeid: item }, true);
			}
			if (angular.isArray(result) && result.length > 0) {
				return result[0].AttributeDisplayName;
			} else if (result) {
				return result.AttributeDisplayName;
			}
		}

		function createEmptyRow() {
			vm.searchText.push({});
			vm.lookupModel.push({});
			vm.criterias.push({ Attributeid: null, value: [] });
		}

		// Serialize rows -> flat array [{Attribute, Value:[...]}] (the DTCR capacity contract).
		// Value is a list of strings collected from md-chips; blank/whitespace entries and duplicates
		// are dropped, and a condition left with no values is skipped entirely.
		function buildCriteria(rows) {
			var criteria = [];
			angular.forEach(rows, function (row) {
				if (angular.isObject(row) && row.Attributeid != null && angular.isArray(row.value)) {
					var values = [];
					angular.forEach(row.value, function (val) {
						if (val != null && val.toString().trim() !== '') {
							var trimmed = val.toString().trim();
							if (values.indexOf(trimmed) === -1) {
								values.push(trimmed);
							}
						}
					});
					if (values.length) {
						criteria.push({ Attribute: row.AttributeSystemName, Value: values });
					}
				}
			});
			return criteria;
		}

		// Normalize a stored condition value into an array of strings for md-chips (the value control).
		// Accepts the new array shape and tolerates a legacy scalar/string by wrapping it.
		function normalizeCriteriaValue(value) {
			if (angular.isArray(value)) {
				return value.slice();
			}
			if (value == null || value.toString().trim() === '') {
				return [];
			}
			return [value.toString()];
		}

		// Re-hydrate stored Criteria (array, or JSON string when stringified for display) into typed rows
		function populateEditDialog() {
			var criteriaArray = vm.record.Criteria;
			if (angular.isString(criteriaArray)) {
				criteriaArray = utility.isValidJSON(criteriaArray) ? JSON.parse(criteriaArray) : [];
			}
			if (angular.isArray(criteriaArray)) {
				angular.forEach(criteriaArray, function (condition) {
					// Resolve the attribute by its stored system name. Import no longer validates attribute names,
					// so a stored Criteria may reference an attribute that does not exist; such a condition is
					// intentionally skipped (no row is added), and is therefore dropped from the record if the user saves.
					var attribute = utility.filterObject(vm.availableAttributes, { AttributeSystemName: condition.Attribute }, true)[0];
					if (angular.isDefined(attribute)) {
						var length = vm.criterias.push({ Attributeid: attribute.Attributeid });
						if (angular.isUndefined(vm.lookupModel[length - 1])) {
							vm.lookupModel[length - 1] = {};
						}
						if (angular.isUndefined(vm.searchText[length - 1])) {
							vm.searchText[length - 1] = {};
						}
						vm.lookupModel[length - 1].Attributeid = attribute.Attributeid;
						vm.criterias[length - 1] = utility.changeAttributeType(attribute);
						// Value is a list of strings rendered by md-chips (see buildCriteria)
						vm.criterias[length - 1].value = normalizeCriteriaValue(condition.Value);
					}
				});
			}
			createEmptyRow();
		}
	}
})();

(function() {
	'use strict';

	angular
			.module('app.main.catalogs.shared-folders-tree.shared-folder-users', [])
			.config(config);

			/* @ngInject */
			function config($translatePartialLoaderProvider) {

				// Translation
				$translatePartialLoaderProvider.addPart('app/main/catalogs/sub-modules/shared-folders-tree/details/tabs/shared-folder-users');
			}
})();
(function () {
	'use strict';

	angular
		.module('app.main.catalogs.shared-folders-tree.shared-folder-users')
		.run(runBlock);

	/* @ngInject */
	function runBlock(api, activityLogger, $state, crud) {

		if (angular.isUndefined(api.catalogs)) {
			api.catalogs = {};
		}
		api.catalogs.sharedFolderTreeUsers = {
			modelPath: 'catalogs.sharedFolderTreeUsers',
			fields: [
				{ field: 'Id', type: 'int', displayLabel: 'SHARED_FOLDER_USERS.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
					validation: { isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
				{ field: 'UserId', type: 'int', displayLabel: 'SHARED_FOLDER_USERS.FIELDS.USER_ID', visible: true, creatable: false, editable: false, inputType: 'number',
					validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
				{ field: 'FirstName', type: 'text', displayLabel: 'SHARED_FOLDER_USERS.FIELDS.FIRST_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
					validation: { isRequired: true, maxLen: 20, minLen: 1, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
				{ field: 'LastName', type: 'text', displayLabel: 'SHARED_FOLDER_USERS.FIELDS.LAST_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
					validation: { isRequired: true, maxLen: 20, minLen: 1, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
				{ field: 'Email', type: 'text', displayLabel: 'SHARED_FOLDER_USERS.FIELDS.EMAIL', visible: true, creatable: false, editable: false, inputType: 'text',
					validation: { isRequired: true, maxLen: 500, minLen: 1, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: 'VALIDATIONS.INVALID_EMAIL' } }},
				{ field: 'UserName', type: 'text', displayLabel: 'SHARED_FOLDER_USERS.FIELDS.USER_NAME', visible: true, creatable: true, editable: false, inputType: 'text',
					validation: { isRequired: true, maxLen: 50, minLen: 1, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } } },
				{ field: 'Status', type: 'text', displayLabel: 'SHARED_FOLDER_USERS.FIELDS.STATUS', visible: true, creatable: true, editable: false, inputType: 'status',
					validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
				{ field: 'AllowSharing', type: 'text', displayLabel: 'SHARED_FOLDER_USERS.FIELDS.ALLOW_SHARING', visible: true, creatable: true, editable: false, inputType: 'bool-int',
					validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
				{ field: 'Users', type:'text', displayLabel: 'SHARED_FOLDER_USERS.FIELDS.USERS', visible: false, creatable: false, editable: true, inputType: 'lookup-many', lookupSource: 'lists.accessibleUsers',
					lookupFilter: {Status: 1}, validation: {isRequired: false, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
			],
			uniqueConstraints: [],
			title: 'SHARED_FOLDERS.TABS.USERS',
			icon: '',
			idField: 'UserId',
			lookupDisplayField: 'Email',
			isDirty: false,
			methods: {
				assignUsers    :   assignUsers,
				activateBulk   :   activateUsers
			},
			views: {
				mainList: {
					columns: ['UserId', 'UserName', 'UserName', 'Email', 'AllowSharing', 'Status'],
					columnFilter: {},
					toggleFilterProps: {},
					topIndex: 0,
					showFilterRow: false,
					sortColumn: { 'UserId': false },
					itemActions: [
						{ id: 'toggleSharing', label: 'SHARED_FOLDER_USERS.ACTIONS.TOGGLE_SHARING', icon: 'icon-pencil', privilege: 'AssignUsersToSharingFolder', disabled: '!itm.Status', visible: true },
						{ id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateSharingFolderUserStatus:true', disabled: 'itm._disabled', visible: 'itm.Status',
								requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
						{ id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateSharingFolderUserStatus:true', disabled: false, visible: '!itm.Status',
								requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
					],
					listActions: [
						{ id: 'delete', label: 'ACTIONS.DELETE_BULK', icon: 'icon-delete', privilege: 'UpdateSharingFolderUserStatus:true', disabled: '{selected: true, Status: 1}', visible: true,
								requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
						{ id: 'activate', label: 'ACTIONS.ACTIVATE_BULK', icon: 'icon-undo-variant', privilege: 'UpdateSharingFolderUserStatus:true', disabled: '{selected: true, Status: 0}', visible: true,
								requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'},
						{ id: 'toggleSharingBulk', label: 'SHARED_FOLDER_USERS.ACTIONS.TOGGLE_SHARING_BULK', icon: 'icon-pencil', privilege: 'AssignUsersToSharingFolder:true', disabled: '{selected: true}', visible: true, requiresConfirmation: false },
					],
					fabAction: { id: 'add', label: 'ACTIONS.ASSIGN', icon: 'icon-plus', privilege: 'AssignUsersToSharingFolder', visible: true }
				},
				mainDetails: {},
				privileges: {
					list: 'GetSharingFolderDetails',
				}
			}
		};

		function assignUsers(record, sharedFolderId, catalogCode) {
			var state = {};
			state.name = $state.current.name;
			state.params = $state.params;
			// from record.USers delete hideen and disable properties
			angular.forEach(record.Users, function (user) {
				delete user.hidden;
				delete user.disable;
			});
			var logData = activityLogger.createLogData(record.Users, state, 'catalogs.sharedFolderUsers', 'ADD', false, new Date(), null, null);
			var promise = api.webPut(api.baseUrl + '/catalogs/' + catalogCode + '/sharingfolders/'+ sharedFolderId + '/users', record.Users);

			promise.then(function() {
					api.catalogs.sharedFolderUsers.isDirty = true;
			});
			return activityLogger.log(logData, promise);
		}

		function activateUsers(records, model, actionType, catalogCode, folderId) {
			var result = crud.createRequestObject(records, model, actionType, {secondaryIdField : 'Id'});
			var state = {};
			state.name = $state.current.name;
			state.params = $state.params;
			var isBulk = result.itemsNameList.length > 1 ? true : false;
			var logData = activityLogger.createLogData(result.itemsNameList, state, 'catalogs.sharedFolderUsers', actionType.toUpperCase(), isBulk, new Date(), null, null);
			var promise = api.webPut(api.baseUrl + '/catalogs/' + catalogCode + '/sharingfolders/' + folderId + '/users/status', result.requestObj);

			promise.then(function() {
					crud.onRecordStatusChange(records, model, actionType);
			});

			return activityLogger.log(logData, promise);
		}

	}
})();
(function() {
	'use strict';

	angular
			.module('app.main.catalogs.shared-folders.shared-folder-users', [])
			.config(config);

			/* @ngInject */
			function config($translatePartialLoaderProvider) {

				// Translation
				$translatePartialLoaderProvider.addPart('app/main/catalogs/sub-modules/shared-folders/details/tabs/shared-folder-users');
			}
})();
(function () {
	'use strict';

	angular
		.module('app.main.catalogs.shared-folders.shared-folder-users')
		.run(runBlock);

	/* @ngInject */
	function runBlock(api, activityLogger, $state, crud) {

		if (angular.isUndefined(api.catalogs)) {
			api.catalogs = {};
		}
		api.catalogs.sharedFolderUsers = {
			modelPath: 'catalogs.sharedFolderUsers',
			fields: [
				{ field: 'Id', type: 'int', displayLabel: 'SHARED_FOLDER_USERS.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
					validation: { isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
				{ field: 'UserId', type: 'int', displayLabel: 'SHARED_FOLDER_USERS.FIELDS.USER_ID', visible: true, creatable: false, editable: false, inputType: 'number',
					validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
				{ field: 'FirstName', type: 'text', displayLabel: 'SHARED_FOLDER_USERS.FIELDS.FIRST_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
					validation: { isRequired: true, maxLen: 20, minLen: 1, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
				{ field: 'LastName', type: 'text', displayLabel: 'SHARED_FOLDER_USERS.FIELDS.LAST_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
					validation: { isRequired: true, maxLen: 20, minLen: 1, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
				{ field: 'Email', type: 'text', displayLabel: 'SHARED_FOLDER_USERS.FIELDS.EMAIL', visible: true, creatable: false, editable: false, inputType: 'text',
					validation: { isRequired: true, maxLen: 500, minLen: 1, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: 'VALIDATIONS.INVALID_EMAIL' } }},
				{ field: 'UserName', type: 'text', displayLabel: 'SHARED_FOLDER_USERS.FIELDS.USER_NAME', visible: true, creatable: true, editable: false, inputType: 'text',
					validation: { isRequired: true, maxLen: 50, minLen: 1, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } } },
				{ field: 'Status', type: 'text', displayLabel: 'SHARED_FOLDER_USERS.FIELDS.STATUS', visible: true, creatable: true, editable: false, inputType: 'status',
					validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
				{ field: 'AllowSharing', type: 'text', displayLabel: 'SHARED_FOLDER_USERS.FIELDS.ALLOW_SHARING', visible: true, creatable: true, editable: false, inputType: 'bool-int',
					validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
				{ field: 'Users', type:'text', displayLabel: 'SHARED_FOLDER_USERS.FIELDS.USERS', visible: false, creatable: false, editable: true, inputType: 'lookup-many', lookupSource: 'lists.accessibleUsers',
					lookupFilter: {Status: 1}, validation: {isRequired: false, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
			],
			uniqueConstraints: [],
			title: 'SHARED_FOLDERS.TABS.USERS',
			icon: '',
			idField: 'UserId',
			lookupDisplayField: 'Email',
			isDirty: false,
			methods: {
				assignUsers    :   assignUsers,
				activateBulk   :   activateUsers
			},
			views: {
				mainList: {
					columns: ['UserId', 'UserName', 'UserName', 'Email', 'AllowSharing', 'Status'],
					columnFilter: {},
					toggleFilterProps: {},
					topIndex: 0,
					showFilterRow: false,
					sortColumn: { 'UserId': false },
					itemActions: [
						{ id: 'toggleSharing', label: 'SHARED_FOLDER_USERS.ACTIONS.TOGGLE_SHARING', icon: 'icon-pencil', privilege: 'AssignUsersToSharingFolder', disabled: '!itm.Status', visible: true },
						{ id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateSharingFolderUserStatus:true', disabled: 'itm._disabled', visible: 'itm.Status',
								requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
						{ id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateSharingFolderUserStatus:true', disabled: false, visible: '!itm.Status',
								requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
					],
					listActions: [
						{ id: 'delete', label: 'ACTIONS.DELETE_BULK', icon: 'icon-delete', privilege: 'UpdateSharingFolderUserStatus:true', disabled: '{selected: true, Status: 1}', visible: true,
								requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
						{ id: 'activate', label: 'ACTIONS.ACTIVATE_BULK', icon: 'icon-undo-variant', privilege: 'UpdateSharingFolderUserStatus:true', disabled: '{selected: true, Status: 0}', visible: true,
								requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'},
						{ id: 'toggleSharingBulk', label: 'SHARED_FOLDER_USERS.ACTIONS.TOGGLE_SHARING_BULK', icon: 'icon-pencil', privilege: 'AssignUsersToSharingFolder:true', disabled: '{selected: true}', visible: true, requiresConfirmation: false },
					],
					fabAction: { id: 'add', label: 'ACTIONS.ASSIGN', icon: 'icon-plus', privilege: 'AssignUsersToSharingFolder', visible: true }
				},
				mainDetails: {},
				privileges: {
					list: 'GetSharingFolderDetails',
				}
			}
		};

		function assignUsers(record, sharedFolderId, catalogCode) {
			var state = {};
			state.name = $state.current.name;
			state.params = $state.params;
			// from record.USers delete hideen and disable properties
			angular.forEach(record.Users, function (user) {
				delete user.hidden;
				delete user.disable;
			});
			var logData = activityLogger.createLogData(record.Users, state, 'catalogs.sharedFolderUsers', 'ADD', false, new Date(), null, null);
			var promise = api.webPut(api.baseUrl + '/catalogs/' + catalogCode + '/sharingfolders/'+ sharedFolderId + '/users', record.Users);

			promise.then(function() {
					api.catalogs.sharedFolderUsers.isDirty = true;
			});
			return activityLogger.log(logData, promise);
		}

		function activateUsers(records, model, actionType, catalogCode, folderId) {
			var result = crud.createRequestObject(records, model, actionType, {secondaryIdField : 'Id'});
			var state = {};
			state.name = $state.current.name;
			state.params = $state.params;
			var isBulk = result.itemsNameList.length > 1 ? true : false;
			var logData = activityLogger.createLogData(result.itemsNameList, state, 'catalogs.sharedFolderUsers', actionType.toUpperCase(), isBulk, new Date(), null, null);
			var promise = api.webPut(api.baseUrl + '/catalogs/' + catalogCode + '/sharingfolders/' + folderId + '/users/status', result.requestObj);

			promise.then(function() {
					crud.onRecordStatusChange(records, model, actionType);
			});

			return activityLogger.log(logData, promise);
		}

	}
})();
(function() {
	'use strict';

	angular
		.module('app.main.catalogs.saved-views.shared-with-users', []);
})();
(function () {
	'use strict';

	angular
		.module('app.main.catalogs.saved-views.shared-with-users')
		.run(runBlock);

	/* @ngInject */
	function runBlock(api) {

		if (angular.isUndefined(api.savedViews)) {
			api.savedViews = {};
		}
		api.savedViews.sharedWithUsers = {
			modelPath: 'savedViews.sharedWithUsers',
			fields: [
				{field: 'UserId', type: 'int', displayLabel: 'USERS.FIELDS.USER_ID', visible: true, creatable: false, editable: false, inputType: 'number',
					validation: { isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
				{field: 'FirstName', type: 'text', displayLabel: 'USERS.FIELDS.FIRST_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
					validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
				{field: 'LastName', type: 'text', displayLabel: 'USERS.FIELDS.LAST_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
					validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
				{field: 'Email', type: 'text', displayLabel: 'USERS.FIELDS.EMAIL', visible: true, creatable: false, editable: false, inputType: 'text',
					validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }}
			],
			uniqueConstraints: [],
			title: 'SAVED_VIEWS.TABS.SHARED_WITH_USERS',
			icon: '',
			idField: 'UserId',
			lookupDisplayField: 'Email',
			isDirty: false,
			methods: {},
			views: {
				mainList: {
					columns: ['UserId', 'FirstName', 'LastName', 'Email'],
					columnFilter: {},
					toggleFilterProps: {},
					topIndex: 0,
					showFilterRow: false,
					sortColumn: { 'FirstName': false },
					itemActions: [],
					listActions: [],
					fabAction: {}
				},
				mainDetails: {},
				privileges: {
					list: 'GetSavedViewDetails',
				}
			}
		};
	}
})();
(function() {
	'use strict';

	angular
		.module('app.main.catalogs.saved-views.shared-with-user-groups', []);
})();
(function () {
	'use strict';

	angular
		.module('app.main.catalogs.saved-views.shared-with-user-groups')
		.run(runBlock);

	/* @ngInject */
	function runBlock(api) {

		if (angular.isUndefined(api.savedViews)) {
			api.savedViews = {};
		}
		api.savedViews.sharedWithUserGroups = {
			modelPath: 'savedViews.sharedWithUserGroups',
			fields: [
				{field: 'Id', type: 'int', displayLabel: 'USER_GROUPS.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
					validation: { isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
				{field: 'AccountId', type: 'int', displayLabel: 'USER_GROUPS.FIELDS.ACCOUNT_ID', visible: true, creatable: false, editable: false, inputType: 'static',
					validation: { isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } } },
				{field: 'AccountName', type: 'text', displayLabel: 'USER_GROUPS.FIELDS.ACCOUNT_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
					validation: { isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
				{field: 'Name', type: 'text', displayLabel: 'USER_GROUPS.FIELDS.NAME', visible: true, creatable: true, editable: true, inputType: 'text',
					validation: { isRequired: true, maxLen: 20, minLen: 1, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
				{field: 'Status', type: 'text', displayLabel: 'USER_GROUPS.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
					validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
				{field: 'CreatedDate', type: 'text', displayLabel: 'USER_GROUPS.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',},
				{field: 'UpdatedDate', type: 'text', displayLabel: 'USER_GROUPS.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
					validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
				{field: 'CreatedBy', type: 'text', displayLabel: 'USER_GROUPS.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
					validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
				{field: 'UpdatedBy', type: 'text', displayLabel: 'USER_GROUPS.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
					validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }
				}
			],
			uniqueConstraints: [],
			title: 'SAVED_VIEWS.TABS.SHARED_WITH_USER_GROUPS',
			icon: '',
			idField: 'Id',
			lookupDisplayField: 'Name',
			isDirty: false,
			methods: {},
			views: {
				mainList: {
					columns: ['Id', 'AccountId', 'AccountName', 'Name', 'Status', 'UpdatedDate'],
					columnFilter: {},
					toggleFilterProps: {},
					topIndex: 0,
					showFilterRow: false,
					sortColumn: { 'UpdatedDate': false },
					itemActions: [],
					listActions: [],
					fabAction: {}
				},
				mainDetails: {},
				privileges: {
					list: 'GetSavedViewDetails',
				}
			}
		};
	}
})();
(function() {
    'use strict';

    angular
        .module('app.main.catalogs.resources.models')
        .run(runBlock);

    /* @ngInject */
    function runBlock(api, activityLogger, $state, utility, crud) {

        if (angular.isUndefined(api.resources)) {
            api.resources = {};
        }
        api.resources.models = {
            modelPath: 'resources.models',
            fields: [
                { field: 'Id', type: 'int', displayLabel: 'SELLER_MODELS.FIELDS.MODEL_ID', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ModelNumber', type: 'text', displayLabel: 'SELLER_MODELS.FIELDS.MODEL_NUMBER', visible: true, creatable: true, editable: true, inputType: 'text',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ModelName', type: 'text', displayLabel: 'SELLER_MODELS.FIELDS.MODEL_NAME', visible: true, creatable: true, editable: true, inputType: 'text',
                    validation: {isRequired: true, maxLen: 100, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Status', type: 'text', displayLabel: 'ARTICLES.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedDate', type: 'text', displayLabel: 'ARTICLES.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
            ],
            uniqueConstraints: [],
            idField: 'Id',
            lookupDisplayField: 'ModelNumber',
            isDirty: false,
            isCatalogSpecificModel: true,
            methods: {
                assign             :   assignModels,
                unasign            :   unassignModels
            },
            views: {
                mainList: {
                    columns         : [ 'ModelNumber', 'ModelName', 'Status', 'UpdatedDate' ],
                    columnFilter    : {},
                    topIndex        : 0,
                    showFilterRow   : false,
                    sortColumn      : {'UpdatedDate': false},
                    itemActions     : [
                                        { id: 'view', label: 'ACTIONS.VIEW', icon: 'icon-magnify', privilege: 'GetCatalogTrueModelDetails', disabled: '!itm.Status', visible: true },
                                        { id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'AssignModelsToResource', disabled: false, visible: 'itm.Status',
                                            requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'}
                                      ],
                    listActions     : [
                                        { id: 'delete', label: 'ACTIONS.DELETE_BULK', icon: 'icon-delete', privilege: 'AssignModelsToResource', disabled: '{selected: true, Status: 1}', visible: true,
                                            requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'}
                                      ],
                    fabAction       : {id: 'add', label: 'ACTIONS.ADD', icon: 'icon-plus', privilege: 'AssignModelsToResource', visible: true}
                 },
                 mainDetails: {},
                privileges: {
                    list    : 'GetCatalogResourceDetails',
                    details : 'GetCatalogTrueModelDetails'
                }
            }
        };

        function unassignModels(records, resourceObj, model, actionType, recordId, parentId) {
            var itemsNameList = [];
            var remainingModelIds = [];

            if(!angular.isArray(records)) {
                records = utility.pushItemToArray(records);
            }

            angular.forEach(resourceObj.ModelResponseList, function(modelItem) {
                if(modelItem.Status !== 0) {
                    var index = records.indexOf(utility.filterObject(records, {Id: modelItem.Id}, true)[0]);
                    if(index === -1) {
                        remainingModelIds.push(modelItem.ModelId);
                    }
                    else {
                        itemsNameList.push(modelItem[model.lookupDisplayField]);
                    }
                }
            });

            var requestObj = { ModelIds: remainingModelIds };

            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var isBulk = itemsNameList.length > 1 ? true : false;
            var logData = activityLogger.createLogData(itemsNameList, state, 'resources.models', actionType.toUpperCase(), isBulk, new Date(), null, null);
            var promise = api.webPut(api.baseUrl + '/catalogs/' + parentId + '/resources/' + recordId + '/assignmodels', requestObj);

            promise.then(function() {
                crud.onRecordStatusChange(records, model, actionType);
            });

            return activityLogger.log(logData, promise);
        }

        function assignModels(recordId, record, catalogId) {
            var requestObj = { ModelIds: record.ModelIds };

            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var logData = activityLogger.createLogData(record[api.resources.models.lookupDisplayField], state, 'resources.models', 'EDIT', false, new Date(), null, null);
            var promise = api.webPut(api.baseUrl + '/catalogs/' + catalogId + '/resources/' + recordId + '/assignmodels', requestObj);

            promise.then(function() {
               api.resources.models.isDirty = true;
            });
            return activityLogger.log(logData, promise);
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.main.catalogs.resources.articles')
        .run(runBlock);

    /* @ngInject */
    function runBlock(api, activityLogger, $state, utility, crud) {

        if (angular.isUndefined(api.resources)) {
            api.resources = {};
        }
         api.resources.articles = {
            modelPath: 'resources.articles',
            fields: [
                { field: 'Id', type: 'int', displayLabel: 'ARTICLES.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ArticleNumber', type: 'text', displayLabel: 'ARTICLES.FIELDS.ARTICLE_NUMBER', visible: true, creatable: true, editable: true, inputType: 'text',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ArticleName', type: 'text', displayLabel: 'ARTICLES.FIELDS.MODEL_NAME', visible: true, creatable: true, editable: true, inputType: 'text',
                    validation: {isRequired: true, maxLen: 100, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'SortOrder', type: 'int', displayLabel: 'ARTICLES.FIELDS.SORT_ORDER', visible: true, creatable: true, editable: true, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Status', type: 'text', displayLabel: 'ARTICLES.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedDate', type: 'text', displayLabel: 'ARTICLES.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedDate', type: 'text', displayLabel: 'ARTICLES.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedBy', type: 'text', displayLabel: 'ARTICLES.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedBy', type: 'text', displayLabel: 'ARTICLES.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }

            ],
            uniqueConstraints: [
                {name: 'Constraint 1', fields: ['ArticleNumber']}
            ],
            idField: 'Id',
            lookupDisplayField: 'ArticleNumber',
            isDirty: false,
            isCatalogSpecificModel: true,
            methods: {
                assign             :   assignArticles,
                unasign            :   unassignArticles
            },
            views: {
                mainList: {
                    columns         : [ 'ArticleNumber', 'ArticleName', 'Status', 'UpdatedDate' ],
                    columnFilter    : {},
                    toggleFilterProps: { toggleStatus:false, filterProp:'Status', trueVal:1, trueValTooltipMessage: 'ACTIONS.TOGGLE_ACTIVE', falseVal:'', falseValTooltipMessage:"ACTIONS.TOGGLE_ALL"},
                    topIndex        : 0,
                    showFilterRow   : false,
                    sortColumn      : {'UpdatedDate': false},
                    itemActions     : [
                                        { id: 'view', label: 'ACTIONS.VIEW', icon: 'icon-magnify', privilege: 'GetCatalogArticleDetails', disabled: '!itm.Status', visible: true },
                                        { id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'AssignArticlesToResource:true', disabled: false, visible: 'itm.Status',
                                            requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                                        { id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'AssignArticlesToResource:true', disabled: false, visible: false,
                                            requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
                                      ],
                    listActions     : [
                                        { id: 'delete', label: 'ACTIONS.DELETE_BULK', icon: 'icon-delete', privilege: 'AssignArticlesToResource:true', disabled: '{selected: true, Status: 1}', visible: true,
                                            requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                                        { id: 'activate', label: 'ACTIONS.ACTIVATE_BULK', icon: 'icon-undo-variant', privilege: 'AssignArticlesToResource:true', disabled: '{selected: true, Status: 0}', visible: false,
                                            requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
                                      ],
                    fabAction       :
                                        {id: 'add', label: 'ACTIONS.ADD', icon: 'icon-plus', privilege: 'AssignArticlesToResource:true', visible: true}

                 },
                 mainDetails: {},
                privileges: {
                    list    : 'GetCatalogResourceDetails',
                    details : 'GetCatalogArticleDetails'
                }
            }
        };

        // this method will only be used for un-assigning since only active data will be displayed
		function unassignArticles(records, resourceObj, model, actionType, recordId, parentId) {
            var itemsNameList = [];
            var remainingArticleIds = [];
            var linkedArticleModel = api.resources.articles;

            if(!angular.isArray(records)) {
                records = utility.pushItemToArray(records);
            }

            // create request object by adding ids of articles which are not needed to be removed
            angular.forEach(resourceObj.ArticleResponseList, function(articles) {
                if(articles.Status !== 0) {
                    var index = records.indexOf(utility.filterObject(records, {Id: articles.Id}, true)[0]);
                    if(index === -1) {
                        remainingArticleIds.push(articles.ArticleId || articles[linkedArticleModel.idField]);
                    }
                    else {
                        itemsNameList.push(articles[linkedArticleModel.lookupDisplayField]);
                    }
                }
            });

            var requestObj = { ArticleIds: remainingArticleIds };

            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var isBulk = itemsNameList.length > 1 ? true : false;
            var logData = activityLogger.createLogData(itemsNameList, state, 'resources.articles', actionType.toUpperCase(), isBulk, new Date(), null, null);
            var promise = api.webPut(api.baseUrl + '/catalogs/' + parentId + '/resources/' + recordId + '/assignarticles', requestObj);

             promise.then(function() {
                crud.onRecordStatusChange(records, model, actionType);
            });

            return activityLogger.log(logData, promise);
		}

        function assignArticles(recordId, record, catalogId) {
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var logData = activityLogger.createLogData(record[api.resources.articles.lookupDisplayField], state, 'resources.articles', 'EDIT', false, new Date(), null, null);
            var requestObj = { ArticleIds: record.ArticleIds };
            var promise = api.webPut(api.baseUrl + '/catalogs/' + catalogId + '/resources/' + recordId + '/assignarticles', requestObj);

            promise.then(function() {
               api.resources.articles.isDirty = true;
            });
            return activityLogger.log(logData, promise);
		}
    }
})();
(function() {
	'use strict';

	angular
			.module('app.main.catalogs.requests.participants', []);
})();
(function () {
	'use strict';

	angular
		.module('app.main.catalogs.requests.participants')
		.run(runBlock);

	/* @ngInject */
	function runBlock(api, activityLogger, $state, crud) {

		if (angular.isUndefined(api.requests)) {
			api.requests = {};
		}
		api.requests.participants = {
			modelPath: 'requests.participants',
			fields: [
				{ field: 'Id', map:'Id', type: 'int', displayLabel: 'REQUESTS.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'UserId', map:'UserId', type: 'text', displayLabel: 'REQUESTS.FIELDS.USER_ID', visible: true, creatable: false, editable: false, inputType: 'text',
					validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'ParticipantAccountName', map:'ParticipantAccountName', type: 'text', displayLabel: 'REQUESTS.FIELDS.ACCOUNT_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'ParticipantUserName', map:'ParticipantUserName', type: 'text', displayLabel: 'REQUESTS.FIELDS.USER_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'Status', map:'Status', type: 'text', displayLabel: 'REQUESTS.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'CreatedDate', map:'CreatedDate', type: 'text', displayLabel: 'REQUESTS.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'UpdatedDate', map:'UpdatedDate', type: 'text', displayLabel: 'REQUESTS.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'UpdatedBy', map:'UpdatedBy', type: 'int', displayLabel: 'REQUESTS.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'number',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'UpdatedByUserName', map:'UpdatedByUserName', type: 'text', displayLabel: 'REQUESTS.FIELDS.UPDATED_BY_USER_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
			],
			uniqueConstraints: [],
			title: 'REQUESTS.TABS.PARTICIPANTS',
			icon: 'icon-cube-outline',
			idField: 'Id',
			lookupDisplayField: 'ParticipantUserName',
			isDirty: false,
			isBulkActionCompleted: false,
			isCatalogSpecificModel: true,
			methods: {
				activateBulk: activateParticipants
			},
			views: {
				mainList: {
					columns           : ['UserId', 'AccountName', 'ParticipantUserName', 'Status', 'UpdatedDate', 'UpdatedByUserName'],
					columnFilter      : {},
					toggleFilterProps : {},
					topIndex          : 0,
					showFilterRow     : false,
					sortColumn        : { 'UpdatedDate': false },
					sortDescending    : true,
					itemActions       : [
																{ id: 'deactivate', label: 'ACTIONS.DEACTIVATE', icon: 'icon-delete', privilege: 'UpdateRequestParticipantStatus', disabled: false, visible: 'itm.Status',
																	requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DEACTIVATE'}, confirmationAction: 'ACTIONS.DEACTIVATE'},
																{ id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateRequestParticipantStatus', disabled: false, visible: '!itm.Status',
																	requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
															],
					listActions       : [
																{ id: 'deactivate', label: 'ACTIONS.DEACTIVATE_BULK', icon: 'icon-delete', privilege: 'UpdateRequestParticipantStatus', disabled: '{selected: true, Status: 1}', visible: true,
																	requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DEACTIVATE'}, confirmationAction: 'ACTIONS.DEACTIVATE'},
																{ id: 'activate', label: 'ACTIONS.ACTIVATE_BULK', icon: 'icon-undo-variant', privilege: 'UpdateRequestParticipantStatus', disabled: '{selected: true, Status: 0}', visible: true,
																	requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
															],
					fabAction         : {}
				},
				mainDetails: {},
				privileges: {
					list: 'GetRequestDetails'
				}
			}
		};

		function activateParticipants(records, model, actionType, catalogCode, requestId) {
			var result = crud.createRequestObject(records, model, actionType);
			var state = {};
			state.name = $state.current.name;
			state.params = $state.params;
			var isBulk = result.itemsNameList.length > 1 ? true : false;
			var logData = activityLogger.createLogData(result.itemsNameList, state, 'catalogs.requests', actionType.toUpperCase(), isBulk, new Date(), null, null);
			var promise = api.webPut(api.baseUrl + '/catalogs/' + catalogCode + '/requests/'+ requestId + '/participants/status', result.requestObj);

			promise.then(function() {
				crud.onRecordStatusChange(records, model, actionType);
			});

			return activityLogger.log(logData, promise);
		}

	}
})();
(function () {
    'use strict';

    angular
        .module('app.main.catalogs.requests.history', [])
        .config(config);

    /* @ngInject */
    function config($translatePartialLoaderProvider) {

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/catalogs/sub-modules/requests/details/tabs/history');
    }
})();
(function() {
	'use strict';

	angular
			.module('app.main.catalogs.requests.history')
			.run(runBlock);

	/* @ngInject */
	function runBlock(api, activityLogger, $state) {

		if (angular.isUndefined(api.requests)) {
			api.requests = {};
		}
		api.requests.auditTrailHistory = {
			modelPath: 'requests.auditTrailHistory',
			fields: [
				{ field: 'ChangeMaker', type: 'text', displayLabel: 'AUDIT_TRAIL_HISTORY.FIELDS.CHANGE_MAKER', visible: true, creatable: false, editable: false, inputType: 'text',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'ChangeDate', type: 'date', displayLabel: 'AUDIT_TRAIL_HISTORY.FIELDS.CHANGE_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: ''}},
				{ field: 'FieldName', type: 'text', displayLabel: 'AUDIT_TRAIL_HISTORY.FIELDS.FIELD_NAME', visible: false, creatable: false, editable: false, inputType: 'text',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'Old', type: 'text', displayLabel: 'AUDIT_TRAIL_HISTORY.FIELDS.OLD_VALUE', visible: true, creatable: false, editable: false, inputType: 'text',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'New', type: 'text', displayLabel: 'AUDIT_TRAIL_HISTORY.FIELDS.NEW_VALUE', visible: true, creatable: false, editable: false, inputType: 'text',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
			],
			uniqueConstraints: [
					{}
			],
			title: 'AUDIT_TRAIL_HISTORY.NAV',
			icon: '',
			idField: 'ChangeMaker',
			lookupDisplayField: '',
			isDirty: false,
			isBulkActionCompleted: false,
			methods: {
					getList                     :   getRequestAuditTrailHistory
			},
			views: {
				mainList: {
					columns             : [ 'ChangeMaker', 'ChangeDate', 'Old', 'New' ],
					columnFilter        : {},
					toggleFilterProps   : {},
					topIndex            : 0,
					showFilterRow       : false,
					sortColumn          : {'ChangeDate': false},
					itemActions         : [],
					listActions         : [],
					fabAction           : {}
				},
				mainDetails: {
					selectedTabIndex    : 0,
					itemActions         : [],
					fabAction                 : {}
				},
				privileges: {
					list    : 'GetRequestHistory'
				}
			}
		};

		function getRequestAuditTrailHistory(generalProperties, requestId, catalogCode) {
			var promise;

			if(angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
				var state = {};
				state.name = $state.current.name;
				state.params = $state.params;
				var isBulk = false;
				var logData = activityLogger.createLogData(null, state, 'requests.auditTrailHistory', 'VIEW', isBulk, new Date(), null, null);

				promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/requests/' + requestId + '/history');
				promise = activityLogger.log(logData, promise);
			}
			else {
				promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/requests/' + requestId + '/history');
			}

			return promise;
		}
	}
})();
(function () {
	'use strict';

	angular
		.module('app.main.catalogs.requests.attachments')
		.run(runBlock);

	/* @ngInject */
	function runBlock(api, activityLogger, $state, crud) {

		if (angular.isUndefined(api.requests)) {
			api.requests = {};
		}
		api.requests.attachments = {
			modelPath: 'requests.attachments',
			fields: [
				{ field: 'Id', type: 'int', displayLabel: 'REQUESTS.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'FileName', type: 'text', displayLabel: 'REQUESTS.FIELDS.FILE_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
					validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'FilePath', type: 'text', displayLabel: 'REQUESTS.FIELDS.FILE_PATH', visible: true, creatable: false, editable: false, inputType: 'text',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'Status', type: 'text', displayLabel: 'REQUESTS.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'CreatedDate', type: 'text', displayLabel: 'REQUESTS.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'UpdatedDate', type: 'text', displayLabel: 'REQUESTS.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'UpdatedBy', type: 'int', displayLabel: 'REQUESTS.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'number',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
			],
			uniqueConstraints: [],
			title: 'REQUESTS.TABS.ATTACHMENTS',
			icon: 'icon-plus-box',
			idField: 'Id',
			lookupDisplayField: 'FileName',
			isDirty: false,
			isBulkActionCompleted: false,
			isCatalogSpecificModel: true,
			methods: { 
				activateBulk: activateAttachments
			},
			views: {
				mainList: {
					columns           : ['Id', 'FileName', 'FilePath', 'Status', 'UpdatedDate', 'UpdatedBy'],
					columnFilter      : {},
					toggleFilterProps : {},
					topIndex          : 0,
					showFilterRow     : false,
					sortColumn        : { 'UpdatedDate': false },
					sortDescending    : true,
					itemActions       : [
																{ id: 'deactivate', label: 'ACTIONS.DEACTIVATE', icon: 'icon-delete', privilege: 'UpdateRequestAttachmentStatus', disabled: false, visible: 'itm.Status',
																	requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DEACTIVATE'}, confirmationAction: 'ACTIONS.DEACTIVATE'},
																{ id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateRequestAttachmentStatus', disabled: false, visible: '!itm.Status',
																	requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'},
																{ id: 'viewImage', label: 'ACTIONS.VIEW_IMAGE', icon: 'icon-magnify', privilege: 'GetRequestDetails', disabled: 'false', visible: 'itm.isImage' },
																{ id: 'download', label: 'ACTIONS.DOWNLOAD', icon: 'icon-download', privilege: 'GetRequestDetails:true', disabled: 'false', visible: 'true'},
															],
					listActions       : [
																{ id: 'deactivate', label: 'ACTIONS.DEACTIVATE_BULK', icon: 'icon-delete', privilege: 'UpdateRequestAttachmentStatus', disabled: '{selected: true, Status: 1}', visible: true,
																	requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DEACTIVATE'}, confirmationAction: 'ACTIONS.DEACTIVATE'},
																{ id: 'activate', label: 'ACTIONS.ACTIVATE_BULK', icon: 'icon-undo-variant', privilege: 'UpdateRequestAttachmentStatus', disabled: '{selected: true, Status: 0}', visible: true,
																	requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
															],
					fabAction         : {}
				},
				mainDetails: {},
				privileges: {
					list: 'GetRequestDetails'
				}
			}
		};

		function activateAttachments(records, model, actionType, catalogCode, requestId) {
			var result = crud.createRequestObject(records, model, actionType);
			var state = {};
			state.name = $state.current.name;
			state.params = $state.params;
			var isBulk = result.itemsNameList.length > 1 ? true : false;
			var logData = activityLogger.createLogData(result.itemsNameList, state, 'catalogs.requests', actionType.toUpperCase(), isBulk, new Date(), null, null);
			var promise = api.webPut(api.baseUrl + '/catalogs/' + catalogCode + '/requests/'+ requestId + '/attachments/status', result.requestObj);

			promise.then(function() {
				crud.onRecordStatusChange(records, model, actionType);
			});

			return activityLogger.log(logData, promise);
		}

	}
})();
(function() {
    'use strict';
    
    angular
        .module('app.main.catalogs.packages.packageErrors', []);
})();
(function() {
    'use strict';

    angular
            .module('app.main.catalogs.packages.packageErrors')
            .run(runBlock);

    /* @ngInject */
    function runBlock(api) {

            if (angular.isUndefined(api.catalogs)) {
                api.catalogs = {};
            }

            api.catalogs.packageErrors = {
                modelPath: 'catalogs.packageErrors',
                fields: [
                        { field: 'Id', type: 'int', displayLabel: 'PACKAGES.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
                                validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                        { field: 'BackgroundJobTypeId', type: 'int', displayLabel: 'PACKAGES.FIELDS.JOB_TYPE_ID', visible: true, creatable: false, editable: false, inputType: 'number',
                                validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                        { field: 'BackgroundJobType', type: 'text', displayLabel: 'PACKAGES.FIELDS.JOB_TYPE', visible: true, creatable: false, editable: false, inputType: 'text',
                                validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                        { field: 'Operation', type: 'text', displayLabel: 'PACKAGES.FIELDS.OPERATION', visible: true, creatable: false, editable: false, inputType: 'text',
                                validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                        { field: 'ImportType', type: 'text', displayLabel: 'PACKAGES.FIELDS.IMPORT_TYPE', visible: true, creatable: false, editable: false, inputType: 'text',
                                validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                        { field: 'ErrorMessage', type: 'text', displayLabel: 'PACKAGES.FIELDS.ERROR_MESSAGE', visible: true, creatable: false, editable: false, inputType: 'text',
                                validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                        { field: 'CreateDate', type: 'text', displayLabel: 'PACKAGES.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                                validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                        { field: 'ErrorType', type: 'text', displayLabel: 'PACKAGES.FIELDS.ERROR_TYPE', visible: true, creatable: false, editable: false, inputType: 'text',
                                validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                        { field: 'CatalogCode', type: 'int', displayLabel: 'PACKAGES.FIELDS.CATALOG_CODE', visible: false, creatable: false, editable: false, inputType: 'number',
                                validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                        { field: 'SellerAccountId', type: 'int', displayLabel: 'PACKAGES.FIELDS.SELLER_ID', visible: true, creatable: false, editable: false, inputType: 'number',
                                validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                        { field: 'JobId', type: 'text', displayLabel: 'PACKAGES.FIELDS.JOB_ID', visible: true, creatable: false, editable: false, inputType: 'text',
                                validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
                ],
                uniqueConstraints: [],
                idField: 'Id',
                lookupDisplayField: 'Id',
                isDirty: false,
                methods: {},
                views: {
                        mainList: {
                                columns             : [ 'Id', 'BackgroundJobTypeId', 'BackgroundJobType', 'Operation', 'ImportType', 'ErrorMessage', 'CreateDate', 'ErrorType', 'CatalogCode', 'SellerAccountId', 'JobId'],
                                columnFilter        : {},
                                topIndex            : 0,
                                showFilterRow       : false,
                                sortColumn          : {},
                                sortDescending      : true,
                                itemActions         : [
                                                        { id: 'view', label: 'ACTIONS.VIEW', icon: 'icon-magnify', privilege: 'GetCatalogDataUpdateDetails', disabled: '', visible: true }],
                                listActions         : [],
                                fabAction           : undefined
                        },
                        mainDetails: {
                                selectedTabIndex    : 0,
                                itemActions         : [],
                                fabAction           : undefined
                        },
                        privileges: {
                                list    : 'GetCatalogDataUpdateDetails'
                        }
                }
            };
    }

})();
(function () {
    'use strict';

    angular
        .module('app.main.catalogs.rejected-orderline', [])
        .config(config);

    /* @ngInject */
    function config($translatePartialLoaderProvider) {

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/catalogs/sub-modules/orders/details/tabs/rejected-order-line');
    }
})();
(function() {
    'use strict';

    angular
        .module('app.main.catalogs.rejected-orderline')
        .run(runBlock);

    /* @ngInject */
    function runBlock(api, activityLogger, $state, $q) {

        if(angular.isUndefined(api.orders)) {
            api.orders = {};
        }
        api.orders.rejectedOrderlines = {
            modelPath: 'orders.rejectedOrderlines', // used in dataTable, dataDetails and dataGrid directives apart from usual use of it
            fields: [
                { field: 'Id', type: 'int', displayLabel: 'REJECTED_ORDERLINES.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'OrderId', type: 'int', displayLabel: 'REJECTED_ORDERLINES.FIELDS.ORDER_ID', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ArticleNumber', type: 'text', displayLabel: 'REJECTED_ORDERLINES.FIELDS.ARTICLE_NUMBER', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ArticleId', type: 'int', displayLabel: 'REJECTED_ORDERLINES.FIELDS.ARTICLE_ID', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ArticleNumber', type: 'text', displayLabel: 'REJECTED_ORDERLINES.FIELDS.ARTICLE_NUMBER', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Crd', type: 'text', displayLabel: 'REJECTED_ORDERLINES.FIELDS.CRD', visible: true, creatable: false, editable: false, inputType: 'date-utc',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CrdId', type: 'int', displayLabel: 'REJECTED_ORDERLINES.FIELDS.CRD_ID', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'DeliveryDate', type: 'text', displayLabel: 'REJECTED_ORDERLINES.FIELDS.DELIVERY_DATE', visible: true, creatable: false, editable: false, inputType: 'date-utc',
                    validation: {isRequired: false, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Forecast', type: 'int', displayLabel: 'REJECTED_ORDERLINES.FIELDS.FORECAST', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Reason', type: 'text', displayLabel: 'REJECTED_ORDERLINES.FIELDS.REASON', visible: true, creatable: false, editable: false, inputType: 'lookup', lookupSource: 'rejectedOrderlines.reasons',
                    validation: {isRequired: false, maxLen: 2000, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Comment', type: 'text', displayLabel: 'REJECTED_ORDERLINES.FIELDS.COMMENT', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: 2000, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedBy', type: 'text', displayLabel: 'REJECTED_ORDERLINES.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedBy', type: 'text', displayLabel: 'REJECTED_ORDERLINES.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedDate', type: 'text', displayLabel: 'REJECTED_ORDERLINES.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedDate', type: 'text', displayLabel: 'REJECTED_ORDERLINES.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Size', type: 'int', displayLabel: 'REJECTED_ORDERLINES.FIELDS.SIZE', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'SizeIndex', type: 'text', displayLabel: 'REJECTED_ORDERLINES.FIELDS.SIZE_INDEX', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'SizeId', type: 'int', displayLabel: 'REJECTED_ORDERLINES.FIELDS.SIZE_ID', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Quantity', type: 'int', displayLabel: 'REJECTED_ORDERLINES.FIELDS.QUANTITY', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'VasIds', type: 'text', displayLabel: 'REJECTED_ORDERLINES.FIELDS.VAS_ID', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'VasCodes', type: 'text', displayLabel: 'REJECTED_ORDERLINES.FIELDS.VAS_CODES', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
            ],
            uniqueConstraints: [
                {}
            ],
            title: 'REJECTED_ORDERLINES.NAV',
            icon: '',
            idField: 'Id',
            lookupDisplayField: 'Reason',
            // customStatusField: '', not required any more, use modelPath to identify module and calculate `Reason`
            isDirty: false,
            isBulkActionCompleted: false,
            isCatalogSpecificModel: true,
            methods: {
                getList                     :   getRejectedOrderLines
            },
            views: {
                mainList: {
                    columns             : [ 'ArticleNumber', 'Crd', 'DeliveryDate', 'Size', 'SizeIndex', 'Quantity', 'Reason', 'UpdatedDate' ],
                    columnFilter        : {},
                    toggleFilterProps   : {},
                    topIndex            : 0,
                    showFilterRow       : false,
                    sortColumn          : {'UpdatedDate': false},
                    itemActions         : undefined,
                    listActions         : [],
                    fabAction           : {}
                },
                mainDetails: {
                    selectedTabIndex    : 0,
                    itemActions         : [],
                    fabAction                 : {}
                },
                privileges: {
                    list    : 'GetRejectedOrderlineList'
                }
            }

        };

        // to translate reasons
        if(angular.isUndefined(api.rejectedOrderlines)) {
            api.rejectedOrderlines = {};
        }
        api.rejectedOrderlines.reasons = {
            fields: [
                { field: 'id', type: 'int', displayLabel: 'REJECTED_ORDERLINES.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'text'},
                { field: 'value', type: 'text', displayLabel: 'REJECTED_ORDERLINES.FIELDS.VALUE', visible: true, creatable: false, editable: false, inputType: 'text'}
            ],
            idField: 'id',
            lookupDisplayField: 'value',
            methods: {
                getList                     :   getRejectedOrderLineReason
            }
        };

        function getRejectedOrderLineReason(dummy1, dummy2) {
            var deferred = $q.defer();
            var response = {};
            var reasons = [
                {id: '1', value: 'Invalid Article Number'},
                {id: '2', value: 'Invalid Delivery Date or master Delivery Date is not available'},
                {id: '3', value: 'Article Delivery Date availability criteria not valid'}, //moved to orderlines with inactive status
                {id: '4', value: 'Invalid Segmentation'},
                {id: '5', value: 'Invalid Size/SizeIndex or Quantity'},
                {id: '6', value: 'Invalid VAS'},
                {id: '7', value: 'Article Allocation Criteria Failed'}, //moved to orderlines with inactive status
                {id: '8', value: 'Article does not have price'},
                {id: '9', value: 'Invalid Stock'}
            ];
            response.data = reasons;
            deferred.resolve(response);

            return deferred.promise;
        }

        function getRejectedOrderLines(generalProperties, model, orderId, catalogCode) {
            if(angular.isDefined(model)) { // to skip this part for load lookup
                model.isBulkActionCompleted = false;
            }
            var promise;

            if(angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
                var state = {};
                state.name = $state.current.name;
                state.params = $state.params;
                var isBulk = true;
                var logData = activityLogger.createLogData(null, state, 'orders.rejectedOrderlines', 'VIEW', isBulk, new Date(), null, null);

                promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/orders/' + orderId + '/rejectedorderlines', undefined, true, generalProperties.forceFetch);
                promise = activityLogger.log(logData, promise);
            }
            else {
                promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/orders/' + orderId + '/rejectedorderlines', undefined, true, generalProperties.forceFetch);
            }

            promise.then(function() {
                if (api.orders.rejectedOrderlines.isDirty) {
                    //Invalidate lookupData
                    api.orders.rejectedOrderlines.lookupData = undefined;
                    api.orders.rejectedOrderlines.isDirty = false;
                }
            });
            return promise;
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.main.catalogs.order-status-history', [])
        .config(config);

    /* @ngInject */
    function config($translatePartialLoaderProvider) {

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/catalogs/sub-modules/orders/details/tabs/order-status-history');
    }
})();
(function() {
		'use strict';

		angular
				.module('app.main.catalogs.order-status-history')
				.run(runBlock);

		/* @ngInject */
		function runBlock(api, activityLogger, $state) {

				if(angular.isUndefined(api.catalogs)) {
						api.catalogs = {};
				}
				api.catalogs.orderStatusHistory = {
						modelPath: 'catalogs.orderStatusHistory',
						fields: [
								{ field: 'Id', type: 'int', displayLabel: 'ORDER_STATUS_HISTORY.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'ChangedFromStatusId', type: 'int', displayLabel: 'ORDER_STATUS_HISTORY.FIELDS.CHANGED_FROM_STATUS_ID', visible: true, creatable: false, editable: false, inputType: 'number',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'ChangedFromStatus', type: 'text', displayLabel: 'ORDER_STATUS_HISTORY.FIELDS.CHANGED_FROM_STATUS', visible: true, creatable: false, editable: false, inputType: 'text',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'ChangedToStatusId', type: 'int', displayLabel: 'ORDER_STATUS_HISTORY.FIELDS.CHNAGED_TO_STATUS_ID', visible: true, creatable: false, editable: false, inputType: 'number',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'ChangedToStatus', type: 'text', displayLabel: 'ORDER_STATUS_HISTORY.FIELDS.CHNAGED_TO_STATUS', visible: true, creatable: false, editable: false, inputType: 'text',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'TotalQuantity', type: 'int', displayLabel: 'ORDER_STATUS_HISTORY.FIELDS.TOTAL_QUANTITY', visible: true, creatable: false, editable: false, inputType: 'number',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'InactiveQuantity', type: 'int', displayLabel: 'ORDER_STATUS_HISTORY.FIELDS.INACTIVE_QUANTITY', visible: true, creatable: false, editable: false, inputType: 'number',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'RejectedQuantity', type: 'int', displayLabel: 'ORDER_STATUS_HISTORY.FIELDS.REJECTED_QUANTITY', visible: true, creatable: false, editable: false, inputType: 'number',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'TotalCurrentValue', type: 'int', displayLabel: 'ORDER_STATUS_HISTORY.FIELDS.TOTAL_CURRENT_VALUE', visible: true, creatable: false, editable: false, inputType: 'number',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'ChangedBy', type: 'text', displayLabel: 'ORDER_STATUS_HISTORY.FIELDS.CHANGED_BY', visible: true, creatable: false, editable: false, inputType: 'text',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'ChangedDate', type: 'text', displayLabel: 'ORDER_STATUS_HISTORY.FIELDS.CHANGED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
						],
						uniqueConstraints: [
								{}
						],
						title: 'ORDER_STATUS_HISTORY.NAV',
						icon: '',
						idField: 'Id',
						lookupDisplayField: '',
						isDirty: false,
						isBulkActionCompleted: false,
						methods: {
								getList                     :   getOrderStatusHistory
						},
						views: {
								mainList: {
										columns             : [ 'Id', 'ChangedFromStatusId', 'ChangedFromStatus', 'ChangedToStatusId', 'ChangedToStatus', 'TotalQuantity', 'InactiveQuantity', 'RejectedQuantity', 'TotalCurrentValue', 'ChangedBy', 'ChangedDate'],
										columnFilter        : {},
										toggleFilterProps   : {},
										topIndex            : 0,
										showFilterRow       : false,
										sortColumn          : {'ChangedDate': false},
										itemActions         : undefined,
										listActions         : [],
										fabAction           : {}
								},
								mainDetails: {
										selectedTabIndex    : 0,
										itemActions         : [],
										fabAction                 : {}
								},
								privileges: {
										list    : 'GetOrderStatusHistory'
								}
						}

				};

				function getOrderStatusHistory(generalProperties, orderId, catalogCode) {
						var promise;

						if(angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
								var state = {};
								state.name = $state.current.name;
								state.params = $state.params;
								var isBulk = false;
								var logData = activityLogger.createLogData(null, state, 'orders.statushistory', 'VIEW', isBulk, new Date(), null, null);

								promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/orders/' + orderId + '/statushistory');
								promise = activityLogger.log(logData, promise);
						}
						else {
								promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/orders/' + orderId + '/statushistory');
						}

						return promise;
				}
		}
})();
(function() {
    'use strict';

    angular
        .module('app.main.catalogs.orderline')
        .run(runBlock);

    /* @ngInject */
    function runBlock(api, activityLogger, $state, crud, utility, catalogFactory, $localStorage, $sessionStorage, $q) {

        if(angular.isUndefined(api.orders)) {
            api.orders = {};
        }
        api.orders.orderlines = {
            modelPath: "orders.orderlines", // used in dataTable, dataDetails and dataGrid directivs apart from usual use of it
            fields: [
                { field: 'Id', type: 'int', displayLabel: 'ORDERLINE.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'OrderId', type: 'int', displayLabel: 'ORDERLINE.FIELDS.ORDER_ID', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'OrderReference', type: 'text', displayLabel: 'ORDERLINE.FIELDS.ORDER_REFERENCE', exportHeader: 'ORDERLINE.EXPORT_HEADER.ORDER_REFERENCE', visible: true, creatable: false, editable: false, inputType: 'text', reportable: true,
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ConsolidationId', type: 'int', displayLabel: 'ORDERLINE.FIELDS.CONSOLIDATION_REFEFANCE', visible: true, creatable: false, editable: false, inputType: 'lookup', lookupSource:'catalogs.consolidations',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ArticleId', type: 'text', displayLabel: 'ORDERLINE.FIELDS.ARTICLE_ID', exportHeader: 'ORDERLINE.EXPORT_HEADER.ARTICLE_NUMBER', visible: false, creatable: true, editable: false, inputType: 'lookup', lookupSource: 'catalogs.articles', reportable: true,
                    lookupFilter: {Status: 1} ,validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ArticleId', type: 'int', displayLabel: 'ORDERLINE.FIELDS.ARTICLE_ID', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ArticleName', type: 'text', displayLabel: 'ORDERLINE.FIELDS.ARTICLE_NAME', visible: true, creatable: false, editable: false, inputType: 'text', reportable: true,
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ArticleNumber', type: 'text', displayLabel: 'ORDERLINE.FIELDS.ARTICLE_NUMBER', visible: true, creatable: false, editable: false, inputType: 'text', reportable: true,
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CrdId', type: 'text', displayLabel: 'ORDERLINE.FIELDS.CRD_ID', exportHeader:"ORDERLINE.EXPORT_HEADER.CRD", visible: true, creatable: true, editable: false, inputType: 'lookup', lookupSource: 'catalogs.CRD',reportable: true,
                    lookupFilter: {Status: 1}, validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'AvailabilityFrom', type: 'text', displayLabel: 'ORDERLINE.FIELDS.AVAILABILITY_FROM', visible: true, creatable: false, editable: false, inputType: 'date-utc',
                    validation: {isRequired: false, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'AvailabilityTo', type: 'text', displayLabel: 'ORDERLINE.FIELDS.AVAILABILITY_TO', visible: true, creatable: false, editable: false, inputType: 'date-utc',
                    lookupFilter: {Status: 1}, validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'InitialPrice', type: 'int', displayLabel: 'ORDERLINE.FIELDS.INITIAL_PRICE', visible: true, creatable: false, editable: false, inputType: 'number', reportable: true,
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CurrentPrice', type: 'int', displayLabel: 'ORDERLINE.FIELDS.CURRENT_PRICE', visible: true, creatable: false, editable: false, inputType: 'number',  reportable: true,
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CurrentPriceGroupId', type: 'text', displayLabel: 'ORDERLINE.FIELDS.CURRENT_PRICE_GROUP_ID', visible: false, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'DeliveryDate', type: 'text', displayLabel: 'ORDERLINE.FIELDS.DELIVERY_DATE', exportHeader: 'ORDERLINE.EXPORT_HEADER.DELIVERY_DATE', visible: true, creatable: true, editable: false, inputType: 'date-without-time',  reportable: true,
                    validation: {isRequired: false, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Forecast', type: 'int', displayLabel: 'ORDERLINE.FIELDS.FORECAST', visible: false, creatable: true, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'TotalQuantity', type: 'int', displayLabel: 'ORDERLINE.FIELDS.TOTAL_QUANTITY', visible: true, creatable: false, editable: false, inputType: 'number',  reportable: true,
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'TotalInitialValue', type: 'int', displayLabel: 'ORDERLINE.FIELDS.TOTAL_INITIAL_VALUE', visible: true, creatable: false, editable: false, inputType: 'number',  reportable: true,
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'TotalCurrentValue', type: 'int', displayLabel: 'ORDERLINE.FIELDS.TOTAL_CURRENT_VALUE', visible: true, creatable: false, editable: false, inputType: 'number',  reportable: true,
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'IsActive', type: 'text', displayLabel: 'ORDERLINE.FIELDS.IS_ACTIVE', visible: true, creatable: false, editable: false, inputType: 'status',  reportable: true,
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Comment', type: 'text', displayLabel: 'ORDERLINE.FIELDS.COMMENT', visible: true, creatable: true, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: 2000, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'PriceGroupName', type: 'text', displayLabel: 'ORDERLINE.FIELDS.PRICEGROUP_NAME', visible: true, creatable: false, editable: false, inputType: 'text', reportable: true,
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CurrencyCode', type: 'text', displayLabel: 'ORDERLINE.FIELDS.CURRENCY_CODE', visible: true, creatable: false, editable: false, inputType: 'lookup', lookupSource: 'lists.currencies', reportable: true,
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Status', type: 'text', displayLabel: 'ORDERLINE.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'orderlineStatus', orderLineActiveStatusField: 'IsActive',  reportable: true,
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedBy', type: 'text', displayLabel: 'ORDERLINE.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',  reportable: true,
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedBy', type: 'text', displayLabel: 'ORDERLINE.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',  reportable: true,
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedDate', type: 'text', displayLabel: 'ORDERLINE.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',  reportable: true,
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedDate', type: 'text', displayLabel: 'ORDERLINE.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',  reportable: true,
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'SizeId', type: 'int', displayLabel: 'ORDERLINE_SIZES.FIELDS.SIZE_ID', visible: false, creatable: true, editable: false, inputType: 'DONOTCHANGE', lookupSource: 'articles.sizes',
                    lookupFilter: {Status: 1}, validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Quantity', type: 'int', displayLabel: 'ORDERLINE_SIZES.FIELDS.QUANTITY', visible: false, creatable: true, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'VasId', type: 'int', displayLabel: 'VAS.FIELDS.VAS_ID', visible: false, creatable: true, editable: false, inputType: 'lookup', lookupSource:'sellers.vas',
                    lookupFilter: {Status: 1}, validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'AdditionalInfo', type: 'text', displayLabel: 'VAS.FIELDS.ADITIONAL_INFO', visible: false, creatable: true, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: 2000, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'IsDeleted', type: 'text', displayLabel: 'ORDERLINE.FIELDS.IS_ACTIVE', visible: false, creatable: false, editable: false, inputType: 'status'} // used internally
                ],
            uniqueConstraints: [
                {name: 'Constraint 1', fields: ['ArticleId', 'CrdId', 'sizeIndex']}
            ],
            title: 'ORDERLINE.NAV',
            exportTitle: 'ORDERLINE.EXPORT_TITLE',
            icon: '',
            idField: 'Id',
            customStatusField: 'IsActive',
            lookupDisplayField: 'ArticleId',
            isDirty: false,
            isBulkActionCompleted: false,
            isCatalogSpecificModel: true,
            methods: {
                getList                     :   getOrderLines,
                getDetails                  :   getOrderLine,
                activateBulk                :   activateOrderlines,
                create                      :   createOrderLine,
                update                      :   updateOrderLine,
                saveDraftOrders             :   saveDraftOrders,
                deleteDraftAndReopnedOrders :   deleteDraftAndReopnedOrders
            },
            views: {
                mainList: {
                    columns             : [ 'ArticleId', 'CrdId', 'TotalQuantity', 'TotalCurrentValue' , 'IsActive', 'Status', 'UpdatedDate' ],
                    columnFilter        : {},
                    toggleFilterProps   : { toggleStatus:false, filterProp:'IsActive', trueVal:1, trueValTooltipMessage: 'ACTIONS.TOGGLE_ACTIVE', falseVal:'', falseValTooltipMessage:"ACTIONS.TOGGLE_ALL"},
                    topIndex            : 0,
                    showFilterRow       : false,
                    sortColumn          : {'UpdatedDate': false},
                    itemActions         : [
                                            { id: 'view', label: 'ACTIONS.VIEW', icon: 'icon-magnify', privilege: 'GetOrderlineDetails:true', disabled: '!itm.IsActive', visible: true },
                                            { id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UpdateOrderline:true', disabled: '!itm.IsActive || !(itm.OrderProcessStatusId === 1 || itm.OrderProcessStatusId === 5) || itm.ConsolidationId !== 0', visible: true },
                                            { id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateOrderlineStatus:true', disabled: 'itm.OrderProcessStatusId !== 1 && itm.OrderProcessStatusId !== 5', visible: 'itm.IsActive',
                                                requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                                            { id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateOrderlineStatus:true', disabled: 'itm.OrderProcessStatusId !== 1 && itm.OrderProcessStatusId !== 5', visible: '!itm.IsActive && (itm.OrderProcessStatusId !== 1 || itm.OrderProcessStatusId !== 5)',
                                            requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
                                          ],
                    listActions         : [
                                            { id: 'delete', label: 'ACTIONS.DELETE_BULK', icon: 'icon-delete', privilege: '', disabled: '{selected: true, IsActive: 1, OrderProcessStatusId: ["!6", "!8"]}', visible: true,
                                                requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                                            { id: 'activate', label: 'ACTIONS.ACTIVATE_BULK', icon: 'icon-undo-variant', privilege: '', disabled: '{selected: true, IsActive: 0, OrderProcessStatusId: ["!6", "!8"]}', visible: "itm.OrderProcessStatusId !== 1 || itm.OrderProcessStatusId !== 5",
                                                requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'},
                                            { id: 'saveOrders', label: 'ORDERS.ACTIONS.SAVE_ORDERS', icon: 'icon-content-save', privilege: 'ProcessOrder:true', disabled: false, visible: true,
                                                requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'ORDERS.MESSAGES.CONTENT.CONFIRM_SAVE_ORDERS'}, confirmationAction: 'ORDERS.ACTIONS.SAVE_ORDERS'}
                                          ],
                    fabAction           : {id: 'add', label: 'ACTIONS.ADD', icon: 'icon-plus', privilege: 'CreateOrderlineBulk:true', visible: true, disabled: '!(itm.OrderProcessStatusId === 1 || itm.OrderProcessStatusId === 5)'}
                },
                mainDetails: {
                    selectedTabIndex    : 0,
                    itemActions         : [
                                            { id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateOrderlineStatus:true', disabled: '{selected: true, IsActive: 1, OrderProcessStatusId: ["1", "5"]}',
                                                visible: true, requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                                            { id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateOrderlineStatus:true', disabled: '{selected: true, IsActive: 0, OrderProcessStatusId: ["!6", "!8"]}',
                                                visible: "OrderProcessStatusId !== 1 || OrderProcessStatusId !== 5", requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'},
                                            { id: 'saveOrders', label: 'ORDERS.ACTIONS.SAVE_ORDERS', icon: 'icon-content-save', privilege: 'ProcessOrder:true', disabled: false, visible: true,
                                                requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'ORDERS.MESSAGES.CONTENT.CONFIRM_SAVE_ORDERS'}, confirmationAction: 'ORDERS.ACTIONS.SAVE_ORDERS'}
                                          ]
                },
                privileges: {
                    list    : 'GetOrderlineList',
                    details : 'GetOrderlineDetails'
                }
            }

        };

        api.orders.importOrderlines = {
            fields: [
                { field: 'Id', type: 'int', displayLabel: 'ORDERLINE.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'OrderId', type: 'int', displayLabel: 'ORDERLINE.FIELDS.ORDER_ID', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ArticleNumber', type: 'text', displayLabel: 'ORDERLINE.FIELDS.ARTICLE_NUMBER', visible: true, creatable: true, editable: false, inputType: 'lookup', lookupSource: 'catalogs.articles',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Crd', type: 'text', displayLabel: 'ORDERLINE.FIELDS.RID', visible: true, creatable: true, editable: false, inputType: 'lookup', lookupSource: 'catalogs.CRD',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'AvailabilityFrom', type: 'text', displayLabel: 'ORDERLINE.FIELDS.AVAILABILITY_FROM', visible: true, creatable: false, editable: false, inputType: 'date-utc',
                    validation: {isRequired: false, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'AvailabilityTo', type: 'text', displayLabel: 'ORDERLINE.FIELDS.AVAILABILITY_TO', visible: true, creatable: false, editable: false, inputType: 'date-utc',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'InitialPrice', type: 'int', displayLabel: 'ORDERLINE.FIELDS.INITIAL_PRICE', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CurrentPrice', type: 'int', displayLabel: 'ORDERLINE.FIELDS.CURRENT_PRICE', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CurrentPriceGroupId', type: 'text', displayLabel: 'ORDERLINE.FIELDS.CURRENT_PRICE_GROUP_ID', visible: false, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                    { field: 'DeliveryDate', type: 'text', displayLabel: 'ORDERLINE.FIELDS.DELIVERY_DATE', visible: true, creatable: true, editable: true, inputType: 'date-without-time',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', validateCRD: true, messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                // { field: 'Forecast', type: 'int', displayLabel: 'ORDERLINE.FIELDS.FORECAST', visible: false, creatable: true, editable: false, inputType: 'number',
                //     validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                // { field: 'IsActive', type: 'text', displayLabel: 'ORDERLINE.FIELDS.IS_ACTIVE', visible: true, creatable: false, editable: false, inputType: 'status',
                //     validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                // { field: 'Comment', type: 'text', displayLabel: 'ORDERLINE.FIELDS.COMMENT', visible: true, creatable: true, editable: false, inputType: 'text',
                //     validation: {isRequired: false, maxLen: 2000, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                // { field: 'Status', type: 'text', displayLabel: 'ORDERLINE.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
                //     validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedBy', type: 'text', displayLabel: 'ORDERLINE.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedBy', type: 'text', displayLabel: 'ORDERLINE.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedDate', type: 'text', displayLabel: 'ORDERLINE.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedDate', type: 'text', displayLabel: 'ORDERLINE.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Size', type: 'int', displayLabel: 'ORDERLINE_SIZES.FIELDS.SIZE', visible: false, creatable: true, editable: false, inputType: 'text',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'SizeIndex', type: 'text', displayLabel: 'ORDERLINE_SIZES.FIELDS.SIZE_INDEX', visible: false, creatable: true, editable: false, inputType: 'text',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Quantity', type: 'int', displayLabel: 'ORDERLINE_SIZES.FIELDS.QUANTITY', visible: false, creatable: true, editable: false, inputType: 'number',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '^[1-9][0-9]*$', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: 'ORDERLINE_SIZES.VALIDATIONS.PATTERN'}} },
                { field: 'VasCode', type: 'int', displayLabel: 'VAS.FIELDS.VAS_ID', visible: false, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'AdditionalInfo', type: 'text', displayLabel: 'VAS.FIELDS.ADITIONAL_INFO', visible: false, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: 2000, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
            ],
            uniqueConstraints: [
                {name: 'Constraint 1', fields: ['ArticleNumber', 'Crd', 'Size']}
            ],
            title: 'ORDERLINE.NAV',
            icon: '',
            idField: 'Id',
            lookupDisplayField: 'Id',
            isDirty: false,
            isBulkActionCompleted: false,
            methods: {},
            views: {
                mainList: {},
                mainDetails: {},
                privileges: {
                    list    : 'GetOrderlineList',
                    details : 'GetOrderlineDetails'
                }
            }

        };

        function getOrderLines(generalProperties, model, orderId, catalogCode) {
            if(angular.isDefined(model)) { // to skip this part for load lookup
                model.isBulkActionCompleted = false;
            }
            var promise;

            if(angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
                var state = {};
                state.name = $state.current.name;
                state.params = $state.params;
                var isBulk = true;
                var logData = activityLogger.createLogData(null, state, 'orders.orderlines', 'VIEW', isBulk, new Date(), null, null);

                promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/orders/' + orderId + '/orderlines', undefined, true, generalProperties.forceFetch);
                promise = activityLogger.log(logData, promise);
            }
            else {
                promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/orders/' + orderId + '/orderlines', undefined, true, generalProperties.forceFetch);
            }

            promise.then(function() {
                if (api.orders.orderlines.isDirty) {
                    //Invalidate lookupData
                    api.orders.orderlines.lookupData = undefined;
                    api.orders.orderlines.isDirty = false;
                }
            });
            return promise;
        }

        function getOrderLine(isLogRequired, orderLineId, orderId, catalogCode) {
            var promise;
            if(angular.isDefined(isLogRequired) && isLogRequired === true) {
                var state = {};
                state.name = $state.current.name;
                state.params = $state.params;
                var isBulk = false;
                var items = [];

                promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/orders/' + orderId +  '/orderlines/' + orderLineId + '?status=0', undefined, true, true);
                promise.then(function(response) {
                    items.push(response.data[api.orders.orderlines.lookupDisplayField]);
                });

                var logData = activityLogger.createLogData(items, state, 'orders.orderlines', 'VIEW', isBulk, new Date(), null, null);
                promise = activityLogger.log(logData, promise);
            }
            else {
                promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/orders/' + orderId +  '/orderlines/' + orderLineId + '?status=0', undefined, true, true);
            }
            return promise;
        }

        function activateOrderlines(records, model, actionType, parentId, orderId, orderlineId) {
            // var result = crud.createRequestObject(records, model, actionType);
            var requestObj = {};
            if(actionType.toUpperCase() === 'DELETE') {
                requestObj.status = 0;
            }
            else if(actionType.toUpperCase() === 'ACTIVATE') {
                requestObj.status = 1;
            }
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var isBulk = false;
            var logData = activityLogger.createLogData(records[model.lookupDisplayField], state, 'orders.orderlines', actionType.toUpperCase(), isBulk, new Date(), null, null);
			var promise = api.webPut(api.baseUrl + '/catalogs/' + parentId + '/orders/' + orderId + '/orderlines/' + orderlineId + '/status', requestObj);


            promise.then(function() {
                crud.onRecordStatusChange(records, model, actionType, 'IsActive');
            });

            return activityLogger.log(logData, promise);
        }

		function createOrderLine(orderLine, orderId, catalogCode, order) {
            var deferred = $q.defer();
            orderLine.OrderlineSize = [];
            orderLine.OrderlineVas = [];
            var quantity = 0;
            var unsavedOrders = angular.isDefined(catalogFactory.getUnsavedDraftOrders()) ? catalogFactory.getUnsavedDraftOrders() : [];

            if (angular.isDefined(orderLine.sizeInfo)) {
                angular.forEach(orderLine.sizeInfo, function (sizeInf) {
                    if(angular.isDefined(sizeInf.Id) && angular.isDefined(sizeInf.quantity) && sizeInf.quantity > 0) {
                        var orderLineSize = {};
                        orderLineSize.SizeId = sizeInf.Id;
                        orderLineSize.Quantity = sizeInf.quantity && angular.isDefined(sizeInf.quantity) ? sizeInf.quantity : 0;
                        quantity += orderLineSize.Quantity;
                        orderLine.OrderlineSize.push(orderLineSize);
                    }
                });
            }

            if(angular.isDefined(orderLine.VASInfo)) {
                angular.forEach(orderLine.VASInfo, function(VASInf) {
                    if(angular.isDefined(orderLine.VASSelectionInfo[VASInf.id]) && orderLine.VASSelectionInfo[VASInf.id] == true) {
                        var orderLineVAS = {};
                        orderLineVAS.VasId = VASInf.id;
                        orderLineVAS.Code = VASInf.value;
                        orderLineVAS.AdditionalInfo = VASInf.AdditionalInfo;
                        orderLine.OrderlineVas.push(orderLineVAS);
                    }
                });
            }

            orderLine.TotalQuantity = quantity,
            orderLine.TotalCurrentValue = quantity * orderLine.InitialPrice,
            orderLine.TotalInitialValue = quantity * orderLine.InitialPrice,

            delete orderLine.sizeInfo;
            delete orderLine.AdditionalInfo;
            delete orderLine.VASInfo;
            delete orderLine.VASSelectionInfo;

            var orderLineList = [];
            orderLineList.push(orderLine);
            var orderContent = {
                Orderlines: orderLineList
            }

            // store draft order's orderline data to sessions storage
            var requestObj = {
                OrderReference: order.OrderReference,
                CustomerId: order.CustomerId,
                LocationId: order.LocationId,
                CustomerReference: order.CustomerReference,
                Alias: order.Alias,
                SourceId: 2,
                TotalQuantity: order.TotalQuantity + quantity,
                TotalCurrentValue: order.TotalCurrentValue + orderLine.TotalCurrentValue,
                TotalInitialValue: order.TotalInitialValue + orderLine.TotalInitialValue,
                OrderContent: angular.toJson(orderContent)
            }
            // if existing draft orders with orderline
            var existingOrderContent = null;
            var existingOrderlineList = [];
            if(angular.isDefined(order.OrderContent)) { // if it is not saved in server no value will be returned by server
                try {
                    existingOrderContent = JSON.parse(order.OrderContent);
                } catch(error) {
                    console.error('Unable to parse saved order content from server\n', error);
                }
            }
            if(angular.isDefined(existingOrderContent) && existingOrderContent !== null) {
                // if updated orders are there show it from the unsaved orders
                angular.forEach(existingOrderContent.Orderlines, function(orderline) {
                    existingOrderlineList.push(orderline);
                });
            }
            var index = unsavedOrders.indexOf(utility.filterObject(unsavedOrders, { OrderReference: order.OrderReference }, true)[0]);
            if (index !== -1) {
                var currentOrder = utility.filterObject(unsavedOrders, { OrderReference: order.OrderReference }, true)[0];
                currentOrder.TotalQuantity += quantity;
                currentOrder.TotalCurrentValue += orderLine.TotalCurrentValue;
                currentOrder.TotalInitialValue += orderLine.TotalInitialValue;
                var orderContent = JSON.parse(currentOrder.OrderContent);
                if(angular.isDefined(orderContent) && orderContent !== null) {
                    var orderlineIndex = orderContent.Orderlines.indexOf(utility.filterObject(orderContent.Orderlines, { ArticleId: orderLine.ArticleId, CrdId: orderLine.CrdId}, true)[0]);
                    if (orderlineIndex !== -1) {
                        orderContent.Orderlines.splice(orderlineIndex, 1);
                        orderContent.Orderlines.push(orderLine);
                        orderContent = angular.toJson(orderContent);
                        currentOrder.OrderContent = orderContent;
                        unsavedOrders.splice(index, 1);
                        unsavedOrders.push(currentOrder);
                        deferred.resolve(true);
                    } else {
                        orderContent.Orderlines.push(orderLine);
                        orderContent = angular.toJson(orderContent);
                        currentOrder.OrderContent = orderContent;
                        unsavedOrders.splice(index, 1);
                        unsavedOrders.push(currentOrder);
                        deferred.resolve(true);
                    }
                }
            } else {
                unsavedOrders.push(requestObj);
                deferred.resolve(true);
            }
            $sessionStorage.UnSavedDraftOrders = unsavedOrders;
            return deferred.promise;
        }

        function updateOrderLine(orderLineId, orderLine, orderId, catalogCode, order) {
            var deferred = $q.defer();
            orderLine.OrderlineSize = [];
            orderLine.OrderlineVas = [];
            var quantity = 0;
            var unsavedOrders = angular.isDefined(catalogFactory.getUnsavedDraftOrders()) ? catalogFactory.getUnsavedDraftOrders() : [];

            if (angular.isDefined(orderLine.sizeInfo)) {
                angular.forEach(orderLine.sizeInfo, function (sizeInf) {
                    var orderLineSize = {};
                    orderLineSize.SizeId = sizeInf.Id;
                    orderLineSize.Quantity = sizeInf.quantity && angular.isDefined(sizeInf.quantity) ? sizeInf.quantity : 0;
                    quantity += orderLineSize.Quantity;
                    orderLine.OrderlineSize.push(orderLineSize);
                });
            }

            if(angular.isDefined(orderLine.VASInfo)) {
                angular.forEach(orderLine.VASInfo, function(VASInf) {
                    if(angular.isDefined(orderLine.VASSelectionInfo[VASInf.id]) && orderLine.VASSelectionInfo[VASInf.id] == true) {
                        var orderLineVAS = {};
                        orderLineVAS.VasId = VASInf.id;
                        orderLineVAS.Code = VASInf.value;
                        orderLineVAS.AdditionalInfo = VASInf.AdditionalInfo;
                        orderLine.OrderlineVas.push(orderLineVAS);
                    }
                });
            }

            orderLine.TotalQuantity = quantity,
            orderLine.TotalCurrentValue = quantity * orderLine.InitialPrice,
            orderLine.TotalInitialValue = quantity * orderLine.InitialPrice,

            delete orderLine.sizeInfo;
            delete orderLine.AdditionalInfo;
            delete orderLine.VASInfo;
            delete orderLine.VASSelectionInfo;

            var orderLineList = [];
            orderLineList.push(orderLine);
            var orderContent = {
                Orderlines: orderLineList
            }

            // store draft order's orderline data in sessions storage
            var requestObj = {
                OrderReference: order.OrderReference,
                CustomerId: order.CustomerId,
                LocationId: order.LocationId,
                CustomerReference: order.CustomerReference,
                Alias: order.Alias,
                SourceId: 2,
                TotalQuantity: order.TotalQuantity + quantity,
                TotalCurrentValue: order.TotalCurrentValue + orderLine.TotalCurrentValue,
                TotalInitialValue: order.TotalInitialValue + orderLine.TotalInitialValue,
                OrderContent: angular.toJson(orderContent)
            }
            // if existing draft orders with orderline
            var existingOrderContent = null;
            var existingOrderlineList = [];
            if(angular.isDefined(order.OrderContent)) { // if it is not saved in server no value will be returned by server
                try {
                    existingOrderContent = JSON.parse(order.OrderContent);
                } catch(error) {
                    console.error('Unable to parse saved order content from server\n', error);
                }
            }
            if(angular.isDefined(existingOrderContent) && existingOrderContent !== null) {
                // if updated orders are there show it from the unsaved orders
                angular.forEach(existingOrderContent.Orderlines, function(orderline) {
                    existingOrderlineList.push(orderline);
                });
            }
            var index = unsavedOrders.indexOf(utility.filterObject(unsavedOrders, { OrderReference: order.OrderReference }, true)[0]);
            if (index !== -1) {
                var currentOrder = utility.filterObject(unsavedOrders, { OrderReference: order.OrderReference }, true)[0];
                currentOrder.TotalQuantity += quantity;
                currentOrder.TotalCurrentValue += orderLine.TotalCurrentValue;
                currentOrder.TotalInitialValue += orderLine.TotalInitialValue;
                var orderContent = JSON.parse(currentOrder.OrderContent);
                if(angular.isDefined(orderContent) && orderContent !== null) {
                    var orderlineIndex = orderContent.Orderlines.indexOf(utility.filterObject(orderContent.Orderlines, { ArticleId: orderLine.ArticleId, CrdId: orderLine.CrdId}, true)[0]);
                    if (orderlineIndex !== -1) {
                        orderContent.Orderlines.splice(orderlineIndex, 1);
                        orderContent.Orderlines.push(orderLine);
                        orderContent = angular.toJson(orderContent);
                        currentOrder.OrderContent = orderContent;
                        unsavedOrders.splice(index, 1);
                        unsavedOrders.push(currentOrder);
                        deferred.resolve(true);
                    } else {
                        orderContent.Orderlines.push(orderLine);
                        orderContent = JSON.stringify(orderContent);
                        currentOrder.OrderContent = orderContent;
                        unsavedOrders.splice(index, 1);
                        unsavedOrders.push(currentOrder);
                        deferred.resolve(true);
                    }
                }
            } else {
                unsavedOrders.push(requestObj);
                deferred.resolve(true);
            }
            $sessionStorage.UnSavedDraftOrders = unsavedOrders;
            return deferred.promise;
        }

        function saveDraftOrders(order, catalogCode) {
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            catalogCode = angular.isUndefined(catalogCode) ? catalogFactory.getActiveCatalog().CatalogCode : catalogCode;
            // store draft order's orderline data to sessions storage
            var orderlineList = [];
            var unsavedOrders = angular.isDefined(catalogFactory.getUnsavedDraftOrders()) ? catalogFactory.getUnsavedDraftOrders() : [];
            if(unsavedOrders.length > 0) {
                var currentOrderData;
                if(angular.isDefined(order) && angular.isDefined(order.OrderReference)) {
                    currentOrderData = utility.filterObject(unsavedOrders, { OrderReference: order.OrderReference }, true)[0];
                } else {
                    currentOrderData = order = unsavedOrders[0];
                }
                if(angular.isDefined(currentOrderData)) {
                    orderlineList = orderlineList.concat(JSON.parse(currentOrderData.OrderContent).Orderlines);
                }
            }
            if(angular.isDefined(order)) {
                var orderContent = null;
                if(angular.isDefined(order.OrderContent)) { // if not save in server no value will be returned by server
                    try {
                        orderContent = JSON.parse(order.OrderContent);
                    } catch(error) {
                        console.error('Unable to parse saved order content from server\n', error);
                    }
                }
                if(angular.isDefined(orderContent) && orderContent !== null) {
                    // remove updated and deleted records
                    angular.forEach(orderContent.Orderlines, function(orderline) {
                        var index = orderlineList.indexOf(utility.filterObject(orderlineList, { ArticleId: orderline.ArticleId, CrdId: orderline.CrdId }, true)[0]);
                        if (index === -1) {
                            orderlineList.push(orderline);
                        }
                    });
                }

                // add existing data in the required format
                if(order.orderlineResponse.length > 0) {
                    angular.forEach(order.orderlineResponse, function(savedOrderline) {
                        var orderlineIndex = orderlineList.indexOf(utility.filterObject(orderlineList, { ArticleId: savedOrderline.ArticleId, CrdId: savedOrderline.CrdId}, true)[0]);
                        if(orderlineIndex === -1) {
                            var orderlineObj = {
                                ArticleId:savedOrderline.ArticleId,
                                CurrentPriceGroupId : savedOrderline.CurrentPriceGroupId,
                                CrdId : savedOrderline.CrdId,
                                DeliveryDate: savedOrderline.DeliveryDate,
                                InitialPrice : savedOrderline.InitialPrice,
                                TotalQuantity : savedOrderline.TotalQuantity,
                                TotalCurrentValue : savedOrderline.TotalCurrentValue,
                                TotalInitialValue : savedOrderline.TotalInitialValue
                            }
                            orderlineObj.OrderlineSize = [];
                            orderlineObj.OrderlineVas = [];

                            if (angular.isDefined(savedOrderline.orderLineSizeResponse)) {
                                angular.forEach(savedOrderline.orderLineSizeResponse, function (sizeInf) {
                                    if(angular.isDefined(sizeInf.SizeId) && angular.isDefined(sizeInf.Quantity)) {
                                        var orderLineSize = {};
                                        orderLineSize.SizeId = sizeInf.SizeId;
                                        orderLineSize.Quantity = sizeInf.Quantity;
                                        orderlineObj.OrderlineSize.push(orderLineSize);
                                    }
                                });
                            }

                            if(angular.isDefined(savedOrderline.orderLineVasResponse)) {
                                angular.forEach(savedOrderline.orderLineVasResponse, function(VASInf) {
                                    if(angular.isDefined(VASInf.VasId) && angular.isDefined(VASInf.Code)) {
                                        var orderLineVAS = {};
                                        orderLineVAS.VasId = VASInf.VasId;
                                        orderLineVAS.Code = VASInf.Code;
                                        orderLineVAS.AdditionalInfo = VASInf.AdditionalInfo;
                                        orderlineObj.OrderlineVas.push(orderLineVAS);
                                    }
                                });
                            }
                            orderlineList.push(orderlineObj);
                        }
                    });
                }
            }
            var totalQty = 0;
            var totalIP = 0;
            var totalCP = 0;
            var actualOrderlinesList = [];
            if(orderlineList.length > 0) {
                angular.forEach(orderlineList, function(orderline) {
                    if(orderline.IsDeleted !== 1) {
                        totalQty += orderline.TotalQuantity;
                        totalIP += orderline.TotalInitialValue;
                        totalCP += orderline.TotalCurrentValue;
                        actualOrderlinesList.push(orderline);
                    }
                });
            }
            order.OrderContent = actualOrderlinesList.length > 0 ? angular.toJson({ 'Orderlines' : actualOrderlinesList }) : null;
            var requestObj = {
                OrderReference: order.OrderReference,
                CustomerId: order.CustomerId,
                LocationId: order.LocationId,
                CustomerReference: order.CustomerReference,
                Alias: order.Alias,
                SourceId: 2,
                TotalQuantity: totalQty,
                TotalCurrentValue: totalCP,
                TotalInitialValue: totalIP,
                OrderContent: order.OrderContent
            }
            if(catalogFactory.getActiveCatalog().IsStockApply) {
                requestObj['StockDefinitionId'] = order.StockDefinitionId;
            }

            var logData = activityLogger.createLogData('', state, 'orders.orderlines', 'ADD', false, new Date(), null, null);
            var promise = api.webPut(api.baseUrl + '/catalogs/' + catalogCode + '/orders/draft', requestObj);

            promise.then(function() {
                var index = unsavedOrders.indexOf(utility.filterObject(unsavedOrders, { OrderReference: order.OrderReference }, true)[0]);
                if (index !== -1) {
                    unsavedOrders.splice(index, 1);
                }
                api.orders.orderlines.isDirty = true;
                api.catalogs.orders.isDirty = true;
            });
            return activityLogger.log(logData, promise);
        }

        function deleteDraftAndReopnedOrders(record, order) {
            var deferred = $q.defer();

            // store draft order's orderline data in sessions storage
            var unsavedOrders = angular.isDefined(catalogFactory.getUnsavedDraftOrders()) ? catalogFactory.getUnsavedDraftOrders() : [];

            var index = unsavedOrders.indexOf(utility.filterObject(unsavedOrders, { OrderReference: order.OrderReference }, true)[0]);
            if (index !== -1) {
                var currentOrder = utility.filterObject(unsavedOrders, { OrderReference: order.OrderReference }, true)[0];
                var orderContent = JSON.parse(currentOrder.OrderContent);
                if(angular.isDefined(orderContent) && orderContent !== null) {
                    var orderlineIndex = orderContent.Orderlines.indexOf(utility.filterObject(orderContent.Orderlines, { ArticleId: record.ArticleId, CrdId: record.CrdId}, true)[0]);
                    if (orderlineIndex !== -1) {
                        var deletedOrderline = utility.filterObject(orderContent.Orderlines, { ArticleId: record.ArticleId, CrdId: record.CrdId}, true)[0];
                        deletedOrderline.IsDeleted = 1;
                        orderContent.Orderlines.splice(orderlineIndex, 1);
                        orderContent.Orderlines.push(deletedOrderline);
                        orderContent = angular.toJson(orderContent);
                        currentOrder.OrderContent = orderContent;
                        unsavedOrders.splice(index, 1);
                        unsavedOrders.push(currentOrder);
                        deferred.resolve(currentOrder);
                    }
                }
            } else {
                var orderContent = JSON.parse(order.OrderContent);
                if(angular.isDefined(orderContent) && orderContent !== null) {
                    var orderlineIndex = orderContent.Orderlines.indexOf(utility.filterObject(orderContent.Orderlines, { ArticleId: record.ArticleId, CrdId: record.CrdId}, true)[0]);
                    if (orderlineIndex !== -1) {
                        var deletedOrderline = utility.filterObject(orderContent.Orderlines, { ArticleId: record.ArticleId, CrdId: record.CrdId}, true)[0];
                        deletedOrderline.IsDeleted = 1;
                        orderContent.Orderlines.splice(orderlineIndex, 1);
                        orderContent.Orderlines.push(deletedOrderline);
                        orderContent = angular.toJson(orderContent);
                        order.OrderContent = orderContent;
                        unsavedOrders.push(order);
                        deferred.resolve(order);
                    }
                }
            }
            $sessionStorage.UnSavedDraftOrders = unsavedOrders;
            return deferred.promise;
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.main.catalogs.orders.notifications', []);
})();
(function () {
  'use strict';

  angular
    .module('app.main.catalogs.orders.notifications')
    .run(runBlock);

  /* @ngInject */
  function runBlock(api, activityLogger, $state) {

    if (angular.isUndefined(api.orders)) {
      api.orders = {};
    }
    api.orders.notifications = {
      modelPath: 'orders.notifications',
      fields: [
        { field: 'Id', type: 'int', displayLabel: 'NOTIFICATIONS.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
          validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } } },
        { field: 'UserId', type: 'int', displayLabel: 'NOTIFICATIONS.FIELDS.USER_ID', visible: true, creatable: false, editable: false, inputType: 'lookup', lookupSource: 'accounts.users',
          validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } } },
        { field: 'CustomerId', type: 'int', displayLabel: 'NOTIFICATIONS.FIELDS.CUSTOMER_ID', visible: true, creatable: false, editable: false, inputType: 'number',
          validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } } },
        {  field: 'Content', type: 'text', displayLabel: 'NOTIFICATIONS.FIELDS.CONTENT', visible: true, creatable: false, editable: false, inputType: 'text',
          validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } } },
        { field: 'Email', type: 'text', displayLabel: 'NOTIFICATIONS.FIELDS.EMAIL', visible: true, creatable: false, editable: false, inputType: 'text',
            validation: {isRequired: false, maxLen: 500, minLen: 0, pattern: '^[A-Za-z]+[A-Za-z0-9._+-]+@{1}[A-Za-z0-9._-]+\.[A-Za-z.]{2,}$', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: 'VALIDATIONS.INVALID_EMAIL'}} },
        { field: 'EntityId', type: 'int', displayLabel: 'NOTIFICATIONS.FIELDS.ENTITY_ID', visible: true, creatable: false, editable: false, inputType: 'number',
          validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } } },
        {  field: 'Channel', type: 'text', displayLabel: 'NOTIFICATIONS.FIELDS.CHANNEL', visible: true, creatable: false, editable: false, inputType: 'text',
          validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } } },
        { field: 'NotificationTypeId', type: 'int', displayLabel: 'NOTIFICATIONS.FIELDS.NOTIFICATION_TYPE_ID', visible: true, creatable: false, editable: false, inputType: 'number',
          validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } } },
        { field: 'NotificationType', type: 'text', displayLabel: 'NOTIFICATIONS.FIELDS.NOTIFICATION_TYPE', visible: true, creatable: false, editable: false, inputType: 'text',
          validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } } },
        { field: 'Title', type: 'text', displayLabel: 'NOTIFICATIONS.FIELDS.TITLE', visible: true, creatable: false, editable: false, inputType: 'text',
          validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } } },
        { field: 'Status', type: 'text', displayLabel: 'NOTIFICATIONS.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'notificationStatus',
          validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } } },
        { field: 'CreatedDateTime', type: 'text', displayLabel: 'NOTIFICATIONS.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
          validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } } },
        { field: 'SentDateTime', type: 'text', displayLabel: 'NOTIFICATIONS.FIELDS.SENT_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
          validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } } },
        { field: 'EmailStatus', type: 'text', displayLabel: 'NOTIFICATIONS.FIELDS.EMAIL_STATUS', visible: true, creatable: false, editable: false, inputType: 'text',
          validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } } },
        { field: 'ErrorReason', type: 'text', displayLabel: 'NOTIFICATIONS.FIELDS.ERROR_REASON', visible: true, creatable: false, editable: false, inputType: 'text',
          validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } } },
      ],
      uniqueConstraints: [],
      title: 'NOTIFICATIONS.NAV',
      icon: 'icon-alert-box',
      idField: 'Id',
      lookupDisplayField: '',
      isDirty: false,
      methods: {
        getList: getNotifications
      },
      views: {
        mainList: {
          columns: ['Email', 'Channel', 'NotificationType', 'Title', 'Content', 'Status', 'SentDateTime'],
          columnFilter: {},
          toggleFilterProps: {},
          topIndex: 0,
          showFilterRow: false,
          sortColumn: {'SentDateTime': false},
          sortDescending: true,
          itemActions: [
            { id: 'view', label: 'ACTIONS.VIEW', icon: 'icon-magnify', privilege: 'GetNotificationDetails', disabled: false, visible: true }
          ],
          listActions: [ ],
          fabAction: {}
        },
        mainDetails: {
          selectedTabIndex: 0,
          itemActions: [],
          fabAction: {}
        },
        privileges: {
          list: 'GetOrderNotifications'
        }
      }

    };

    function getNotifications(generalProperties, orderId, catalogId) {
      var promise;

      if (angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
        var state = {};
        state.name = $state.current.name;
        state.params = $state.params;
        var isBulk = true;
        var logData = activityLogger.createLogData(null, state, 'orders.notifications', 'VIEW', isBulk, new Date(), null, null);

        promise = api.webGet(api.baseUrl + '/catalogs/' + catalogId + '/orders/' + orderId + '/notifications', undefined, true, generalProperties.forceFetch);
        promise = activityLogger.log(logData, promise);
      }
      else {
        promise = api.webGet(api.baseUrl + '/catalogs/' + catalogId  + '/orders/' + orderId + '/notifications', undefined, true, generalProperties.forceFetch);
      }

      promise.then(function () {
        if (api.orders.notifications.isDirty) {
          //Invalidate lookupData
          api.orders.notifications.lookupData = undefined;
          api.orders.notifications.isDirty = false;
        }
      });
      return promise;
    }

  }
})();
(function () {
		'use strict';

		angular
				.module('app.main.catalogs.impacted-adjustments', [
						'app.main.catalogs.impacted-orders'])
				.config(config);

		/* @ngInject */
		function config($translatePartialLoaderProvider) {

				// Translation
				$translatePartialLoaderProvider.addPart('app/main/catalogs/sub-modules/orders/details/tabs/impacted-adjustments');
		}
})();
(function() {
		'use strict';

		angular
				.module('app.main.catalogs.impacted-adjustments')
				.run(runBlock);

		/* @ngInject */
		function runBlock(api, activityLogger, $state) {

				if(angular.isUndefined(api.catalogs)) {
						api.catalogs = {};
				}
				api.catalogs.impactedAdjustments = {
						modelPath: 'catalogs.impactedAdjustments',
						fields: [
							{ field: 'Id', type: 'int', displayLabel: 'ORDER_ADJUSTMENTS.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
								validation: { isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
							{ field: 'Name', type: 'text', displayLabel: 'ORDER_ADJUSTMENTS.FIELDS.NAME', visible: true, creatable: true, editable: true, inputType: 'text',
								validation: { isRequired: true, maxLen: 50, minLen: 1, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
							{ field: 'Status', type: 'text', displayLabel: 'ORDER_ADJUSTMENTS.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'text',
								validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
							{ field: 'JobId', type: 'text', displayLabel: 'ORDER_ADJUSTMENTS.FIELDS.JOB_ID', visible: true, creatable: false, editable: false, inputType: 'text',
								validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
							{ field: 'CreatedBy', type: 'text', displayLabel: 'ORDER_ADJUSTMENTS.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
								validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
							{ field: 'CreatedDate', type: 'text', displayLabel: 'ORDER_ADJUSTMENTS.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
								validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
							{ field: 'UpdatedBy', type: 'text', displayLabel: 'ORDER_ADJUSTMENTS.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
								validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
							{ field: 'UpdatedDate', type: 'text', displayLabel: 'ORDER_ADJUSTMENTS.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
								validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
							],
						uniqueConstraints: [],
						title: 'ORDER_ADJUSTMENTS.NAV',
						idField: 'Id',
						lookupDisplayField: 'Name',
						isDirty: false,
						isCatalogSpecificModel: true,
						methods: {
							getList      : getOrderAdjustmentsByOrderId
						},
						views: {
							mainList: {
								columns: ['Id', 'Name', 'Status', 'JobId', 'CreatedBy', 'CreatedDate'],
								columnFilter: {},
								toggleFilterProps: {},
								topIndex: 0,
								showFilterRow: false,
								sortColumn: {},
								itemActions: [],
								listActions: []
							},
							mainDetails: {},
							privileges: {
								list: 'GetOrderAdjustmentsByOrderId'
							}
						}
				};

				function getOrderAdjustmentsByOrderId(generalProperties, orderId, catalogCode) {
					var promise;

					if(angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
							var state = {};
							state.name = $state.current.name;
							state.params = $state.params;
							var isBulk = false;
							var logData = activityLogger.createLogData(null, state, 'orders.orderadjustments', 'VIEW', isBulk, new Date(), null, null);

							promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/orders/' + orderId + '/orderadjustments');
							promise = activityLogger.log(logData, promise);
					}
					else {
							promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/orders/' + orderId + '/orderadjustments');
					}

					return promise;
				}
		}
})();
(function() {
    'use strict';

    angular
        .module('app.main.catalogs.orders.files')
        .run(runBlock);

    /* @ngInject */
    function runBlock(api, activityLogger, $state, jobsTracker, utility) {

        if(angular.isUndefined(api.orders)) {
            api.orders = {};
        }
        api.orders.files = {
            modelPath: "orders.files",
            fields: [
                { field: 'Id', type: 'int', displayLabel: 'FILES.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'FileType', type: 'text', displayLabel: 'FILES.FIELDS.FILE_TYPE', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'FileName', type: 'text', displayLabel: 'FILES.FIELDS.FILE_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                // { field: 'FileSource', type: 'text', displayLabel: 'FILES.FIELDS.FILE_SOURCE', visible: true, creatable: false, editable: false, inputType: 'url',
                //     validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'FilePath', type: 'text', displayLabel: 'FILES.FIELDS.FILE_SOURCE', visible: false, creatable: false, editable: false, inputType: 'url',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'FileSource', type: 'text', displayLabel: 'FILES.FIELDS.FILE_SOURCE', visible: true, creatable: false, editable: false, inputType: 'calculated-url', calculatedExpression: 'data["FilePath"] + "/" + data["FileName"]',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'FileSize', type: 'text', displayLabel: 'FILES.FIELDS.FILE_SIZE', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Description', type: 'text', displayLabel: 'FILES.FIELDS.DESCRIPTION', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedBy', type: 'text', displayLabel: 'FILES.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedDate', type: 'text', displayLabel: 'FILES.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
            ],
            uniqueConstraints: [],
            title: 'FILES.NAV',
            icon: 'icon-file',
            idField: 'Id',
            lookupDisplayField: 'FileName',
            isDirty: false,
            isCatalogSpecificModel: true,
            methods: {
                getList                     :   getFiles,
                delete                      :   deleteFiles,
                create                      :   createFile,
            },
            views: {
                mainList: {
                    columns             : [ 'FileName', 'FileType', 'FileSource', 'FileSize' , 'CreatedBy', 'CreatedDate' ],
                    columnFilter        : {},
                    toggleFilterProps   : {},
                    topIndex            : 0,
                    showFilterRow       : false,
                    sortColumn          : {'CreatedDate': false},
                    itemActions         : [
                                            { id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'DeleteOrderFiles:true', disabled: false, visible: true,
                                                requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'}
                                          ],
                    listActions         : [
                                            { id: 'delete', label: 'ACTIONS.DELETE_BULK', icon: 'icon-delete', privilege: 'DeleteOrderFiles:true', disabled: '{selected: true}', visible: true,
                                                requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'}
                                          ],
                    fabAction           : { id: 'add', label: 'ACTIONS.ADD', icon: 'icon-plus', privilege: 'CreateOrderFile:true', visible: true}
                },
                mainDetails: {},
                privileges: {
                    list    : 'GetOrderFiles'
                }
            }

        };

        function getFiles (generalProperties, orderId, catalogCode) {
            var promise;

            if(angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
                var state = {};
                state.name = $state.current.name;
                state.params = $state.params;
                var isBulk = true;
                var logData = activityLogger.createLogData(null, state, 'orders.files', 'VIEW', isBulk, new Date(), null, null);

                promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/orders/' + orderId + '/files', undefined, true, generalProperties.forceFetch);
                promise = activityLogger.log(logData, promise);
            }
            else {
                promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/orders/' + orderId + '/files', undefined, true, generalProperties.forceFetch);
            }

            promise.then(function() {
                if (api.orders.files.isDirty) {
                    //Invalidate lookupData
                    api.orders.files.lookupData = undefined;
                    api.orders.files.isDirty = false;
                }
            });
            return promise;
        }

        function deleteFiles(selectedRecords, allRecords, orderId, catalogId) {
            var data = {
              requestObj: [],
              itemsNameList: []
            };
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var isBulk = true;

            if(!angular.isArray(selectedRecords)) {
              isBulk = false;
              selectedRecords = utility.pushItemToArray(selectedRecords);
            }
            angular.forEach(selectedRecords, function(selectedRecord) {
              data.requestObj.push(selectedRecord[api.orders.files.idField]);
              data.itemsNameList.push(selectedRecord[api.orders.files.lookupDisplayField]);
            });

            var logData = activityLogger.createLogData(data.itemsNameList, state, 'orders.files', 'DELETE', isBulk, new Date(), null, null);
            var promise = api.webDelete(api.baseUrl + '/catalogs/' + catalogId + '/orders/' + orderId + '/files', data.requestObj);

            return activityLogger.log(logData, promise);
        }

        function createFile(data, orderId, catalogCode) {
            return api.webPost(api.baseUrl + '/catalogs/' + catalogCode + '/orders/' + orderId + '/files', data);
        }

    }
})();
(function() {
	'use strict';

	angular
		.module('app.main.catalogs.impacted-orders', [])
		.config(config);

	/* @ngInject */
	function config($translatePartialLoaderProvider) {

		// Translation
		$translatePartialLoaderProvider.addPart('app/main/catalogs/sub-modules/order-adjustments/details/tabs/impacted-orders');
	}
})();
(function () {
	'use strict';

	angular
		.module('app.main.catalogs.impacted-orders')
		.run(runBlock);

	/* @ngInject */
	function runBlock(api) {

		if (angular.isUndefined(api.catalogs)) {
			api.catalogs = {};
		}
		api.catalogs.impactedOrders = {
			modelPath: 'catalogs.impactedOrders',
			fields: [
				{ field: 'Id', type: 'int', displayLabel: 'IMPACTED_ORDERS.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'OrderReference', type: 'text', displayLabel: 'IMPACTED_ORDERS.FIELDS.ORDER_REFERENCE', visible: true, creatable: true, editable: true, inputType: 'text',
					validation: { isRequired: true, maxLen: 50, minLen: 1, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
				{ field: 'LocationId', type: 'int', displayLabel: 'IMPACTED_ORDERS.FIELDS.LOCATION_ID', visible: true, creatable: true, editable: true, inputType: 'number', lookupSource: '',
					lookupFilter: {Status: 1}, validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'LocationName', type: 'text', displayLabel: 'IMPACTED_ORDERS.FIELDS.LOCATION_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'LocationCode', type: 'text', displayLabel: 'IMPACTED_ORDERS.FIELDS.LOCATION_CODE', visible: true, creatable: false, editable: false, inputType: 'text',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'CustomerId', type: 'int', displayLabel: 'IMPACTED_ORDERS.FIELDS.CUSTOMER_ID', visible: false, creatable: true, editable: true, inputType: 'lookup', lookupSource: 'catalogs.customers',
					lookupFilter: {Status: 1}, validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'CustomerReference', type: 'text', displayLabel: 'IMPACTED_ORDERS.FIELDS.CUSTOMER_REFERENCE', visible: true, creatable: true, editable: true, inputType: 'text',
					validation: {isRequired: false, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'Alias', type: 'text', displayLabel: 'IMPACTED_ORDERS.FIELDS.ALIAS', visible: true, creatable: true, editable: true, inputType: 'text',
					validation: {isRequired: false, maxLen: 300, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'CustomerName', type: 'text', displayLabel: 'IMPACTED_ORDERS.FIELDS.CUSTOMER_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
					validation: {isRequired: false, maxLen: 100, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'CustomerNumber', type: 'int', displayLabel: 'IMPACTED_ORDERS.FIELDS.CUSTOMER_NUMBER', visible: true, creatable: true, editable: false, inputType: 'text',
					validation: { isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
				{ field: 'OrderProcessStatusId', type: 'int', displayLabel: 'IMPACTED_ORDERS.FIELDS.ORDER_PROCESS_STATUS_ID', visible: false, creatable: false, editable: false, inputType: 'number',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'OrderProcessStatus', type: 'text', displayLabel: 'IMPACTED_ORDERS.FIELDS.ORDER_PROCESS_STATUS', visible: true, creatable: false, editable: false, inputType: 'text',
					validation: {isRequired: false, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'RevisionNumber', type: 'text', displayLabel: 'IMPACTED_ORDERS.FIELDS.REVISION_NUMBER', visible: true, creatable: false, editable: false, inputType: 'text',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'Status', type: 'text', displayLabel: 'IMPACTED_ORDERS.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'CreatedDate', type: 'text', displayLabel: 'IMPACTED_ORDERS.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'UpdatedDate', type: 'text', displayLabel: 'IMPACTED_ORDERS.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'CreatedBy', type: 'text', displayLabel: 'IMPACTED_ORDERS.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'UpdatedBy', type: 'text', displayLabel: 'IMPACTED_ORDERS.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'SourceId', type: 'int', displayLabel: 'IMPACTED_ORDERS.FIELDS.SOURCE_ID', visible: false, creatable: false, editable: false, inputType: 'static', fieldDefaultValue: 2,
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'Source', type: 'text', displayLabel: 'IMPACTED_ORDERS.FIELDS.SOURCE', visible: true, creatable: false, editable: false, inputType: 'text',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'SellerAccountid', type: 'int', displayLabel: 'IMPACTED_ORDERS.FIELDS.SELLER_ID', visible: true, creatable: false, editable: false, inputType: 'number',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'Comment', type: 'text', displayLabel: 'IMPACTED_ORDERS.FIELDS.COMMENT', visible: true, creatable: false, editable: false, inputType: 'text',
					validation: {isRequired: false, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'OrderTypeId', type: 'int', displayLabel: 'IMPACTED_ORDERS.FIELDS.ORDER_TYPE_ID', visible: true, creatable: false, editable: false, inputType: 'number',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'OrderType', type: 'text', displayLabel: 'IMPACTED_ORDERS.FIELDS.ORDER_TYPE', visible: true, creatable: false, editable: false, inputType: 'text',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
			],
			uniqueConstraints: [],
			title: 'IMPACTED_ORDERS.NAV',
			idField: 'Id',
			lookupDisplayField: 'Id',
			isDirty: false,
			isBulkActionCompleted: false,
			isCatalogSpecificModel: true,
			methods: {},
			views: {
				mainList: {
					columns           : ['Id', 'OrderReference', 'LocationId', 'LocationName', 'LocationCode',  'UpdatedDate'],
					columnFilter      : {},
					toggleFilterProps : {},
					topIndex          : 0,
					showFilterRow     : false,
					sortColumn        : { 'UpdatedDate': false },
					itemActions       : [],
					listActions       : [],
					fabAction         : {}
				},
				mainDetails: {},
				privileges: {
					list: 'GetOrderAdjustmentDetails'
				}
			}
		};
	}
})();
(function () {
  'use strict';

  angular
    .module('app.main.catalogs.merch-boards', [
      'app.main.catalogs.merch-boards.shared-with-users',
      'app.main.catalogs.merch-boards.shared-with-user-groups',
      'app.main.catalogs.merch-boards.shared-with-folders'
    ])
    .config(config);

  /* @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
    // State
    $stateProvider.state('app.merch_boards', {
      url: '/merch-boards',
      views: {
        'content@app': {
          templateUrl: 'app/main/catalogs/sub-modules/merch-boards/list/merch-boards-list.html',
          controller: 'merchBoardsListController as vm'
        }
      },
      data: {
        displayName: 'MERCH_BOARDS.NAV'
      },
      //only users with following accessPrivileges in their role access list can access this route
      // accessPrivileges: ['GetMerchSlids']
      // accessPrivileges: ['nav_merch_boards']
      accessInfo: {
        accessPrivileges: ['nav_merch_boards']
      },
      visibleForLinePlan: true
    });
    $stateProvider.state('app.merch_boards.details', {
      url: '/:id',
      views: {
        'content@app': {
          templateUrl: 'app/main/catalogs/sub-modules/merch-boards/details/merch-boards-details.html',
          controller: 'merchBoardsDetailsController as vm'
        }
      },
      data: {
        parentState: 'app.merch_boards',
        displayName: 'MERCH_BOARDS.NAV'
      },
      //only users with following accessPrivileges in their role access list can access this route
      // accessPrivileges: ['GetMerchSlideDetails']
      accessInfo: {
        accessPrivileges: ['GetMerchSlideDetails']
      },
      visibleForLinePlan: true
    });

    // Translation
    $translatePartialLoaderProvider.addPart('app/main/catalogs/sub-modules/merch-boards');

    msNavigationServiceProvider.saveItem('catalogs.merch-boards', {
      title: 'Merch Boards',
      icon: 'icon-view-dashboard',
      state: 'app.merch_boards',
      translate: 'MERCH_BOARDS.NAV',
      weight: 42,
      // accessPrivileges: ['nav_merch_boards'],
      accessInfo: {
        accessPrivileges: ['nav_merch_boards']
      },
      visibleForLinePlan: true
    });

  }
})();
(function () {
	'use strict';

	angular
		.module('app.main.catalogs.merch-boards')
		.controller('selectUserController', selectUserController);

	/* @ngInject */
	function selectUserController($mdDialog, $scope, $filter, hotkeys, utility, api) {
		var vm = this;

		//data
		vm.isLoading = false;
		vm.record = {};
		vm.lookupModel = angular.copy(vm.record);
		vm.searchText = '';

		vm.usersList = [];


		//methods
		vm.saveRecord = saveRecord;
		vm.closeDialog = closeDialog;
		vm.querySearch = querySearch;
		vm.userChange = userChange;



		activate();

		////////////////

		function activate() {
			//Hotkeys
			hotkeys.bindTo($scope).add({
				combo: 'ctrl+enter',
				description: $filter('translate')('ACTIONS.SAVE'),
				allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
				callback: function (event) {
					if (!vm.isLoading && !vm.editForm.$invalid) {
						vm.saveRecord();
					}
				}
			});

			if (vm.isNew) {
				hotkeys.bindTo($scope).add({
					combo: 'ctrl+shift+enter',
					description: $filter('translate')('ACTIONS.SAVE_AND_NEW'),
					allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
					callback: function (event) {
						if (!vm.isLoading && !vm.editForm.$invalid) {
							vm.saveRecord(true);
						}
					}
				});
			}
			getUsersWithCatalogAcess();
		}

		function saveRecord() {
				closeDialog(vm.record);
		}

		function closeDialog(saved) {
			$mdDialog.hide(saved);
		}

		function querySearch(search) {
			if (!search || search == '') {
				return vm.usersList;
			} else {
				return utility.filterObject(vm.usersList, { UserNameWithAccount: search });
			}
		}

		function getUsersWithCatalogAcess() {
			var generalProperties = {
				forceFetch: true,
				isLogRequired: false
			}

			api.lists.usersWithCatalogAccess.methods.getList(generalProperties)
				.then(function (response) {
					if (angular.isDefined(response) && angular.isDefined(response.data)) {
						vm.usersList = response.data;
					}
				});
		}

		function userChange(selectedUser) {
			if(angular.isDefined(selectedUser)) {
				vm.record.UserId = selectedUser.Id;
			}
		}
	}

})();
(function() {
  'use strict';

  angular
      .module('app.main.catalogs.merch-boards.shared-with-users', []);
})();
(function () {
  'use strict';

  angular
    .module('app.main.catalogs.merch-boards.shared-with-users')
    .run(runBlock);

  /* @ngInject */
  function runBlock(api, activityLogger, $state, crud, toast) {

    if (angular.isUndefined(api.merchBoards)) {
      api.merchBoards = {};
    }
    api.merchBoards.sharedWithUsers = {
      modelPath: 'merchBoards.sharedWithUsers',
      fields: [
        {field: 'UserId', type: 'int', displayLabel: 'USERS.FIELDS.USER_ID', visible: true, creatable: false, editable: false, inputType: 'number',
          validation: { isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
        {field: 'AccountId', type: 'int', displayLabel: 'USERS.FIELDS.ACCOUNT_ID', visible: true, creatable: false, editable: false, inputType: 'static',
          validation: { isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } } },
        {field: 'AccountName', type: 'text', displayLabel: 'USERS.FIELDS.ACCOUNT_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
          validation: { isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
        { field: 'AccountTypeId', type: 'int', displayLabel: 'USERS.FIELDS.ACCOUNT_TYPE_ID', visible: true, creatable: false, editable: false, inputType: 'number',
          validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
        {field: 'AccountType', type: 'text', displayLabel: 'USERS.FIELDS.ACCOUNT_TYPE', visible: true, creatable: false, editable: false, inputType: 'text',
          validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
        {field: 'FirstName', type: 'text', displayLabel: 'USERS.FIELDS.FIRST_NAME', visible: true, creatable: true, editable: true, inputType: 'text',
          validation: { isRequired: true, maxLen: 20, minLen: 1, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
        {field: 'LastName', type: 'text', displayLabel: 'USERS.FIELDS.LAST_NAME', visible: true, creatable: true, editable: true, inputType: 'text',
          validation: { isRequired: true, maxLen: 20, minLen: 1, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
        {field: 'Email', type: 'text', displayLabel: 'USERS.FIELDS.EMAIL', visible: true, creatable: true, editable: true, inputType: 'text',
          validation: { isRequired: true, maxLen: 500, minLen: 1, pattern: '^[A-Za-z]+[A-Za-z0-9._+-]+@{1}[A-Za-z0-9._-]+\.[A-Za-z.]{2,}$', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: 'VALIDATIONS.INVALID_EMAIL' } }},
        {field: 'UserName', type: 'text', displayLabel: 'USERS.FIELDS.USER_NAME', visible: true, creatable: true, editable: true, inputType: 'text',
          validation: { isRequired: true, maxLen: 50, minLen: 1, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } } },
        {field: 'Phone', type: 'text', displayLabel: 'USERS.FIELDS.PHONE', visible: true, creatable: true, editable: true, inputType: 'tel',
          validation: {isRequired: false, maxLen: 20, minLen: 0, pattern: '[0-9]*', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '', invalidType: 'VALIDATIONS.INVALID_PHONE_NUMBER'} }},
        {field: 'CountryCode', type: 'text', displayLabel: 'USERS.FIELDS.COUNTRY', visible: false, creatable: true, editable: true, inputType: 'lookup', lookupSource: 'lists.countries',
          validation: { isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } } },
        {field: 'Country', type: 'text', displayLabel: 'USERS.FIELDS.COUNTRY', visible: true, creatable: false, editable: false, inputType: 'text',
          validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }
        },
        {field: 'City', type: 'text', displayLabel: 'USERS.FIELDS.CITY', visible: true, creatable: true, editable: true, inputType: 'text',
          validation: { isRequired: true, maxLen: 25, minLen: 1, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
        { field: 'Designation', type: 'text', displayLabel: 'USERS.FIELDS.DESIGNATION', visible: true, creatable: true, editable: true, inputType: 'text',
          validation: { isRequired: false, maxLen: 20, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
        {field: 'Department', type: 'text', displayLabel: 'USERS.FIELDS.DEPARTMENT', visible: true, creatable: true, editable: true, inputType: 'text',
          validation: { isRequired: false, maxLen: 20, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
        {field: 'Status', type: 'text', displayLabel: 'USERS.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
          validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
        {field: 'LoginType', type: 'text', displayLabel: 'USERS.FIELDS.LOGIN_TYPE', visible: true, creatable: true, editable: true, inputType: 'lookup', lookupSource: 'lists.loginTypes',
          validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
        {field: 'Roles', type: 'text', displayLabel: 'USERS.FIELDS.USER_ROLE', visible: true, creatable: true, editable: true, inputType: 'lookup-many', lookupSource: 'roles.roles',
          validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
        {field: 'CreateDate', type: 'text', displayLabel: 'USERS.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',},
        {field: 'UpdateDate', type: 'text', displayLabel: 'USERS.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
          validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
        {field: 'AllowedClients', type: 'text', displayLabel: 'USERS.FIELDS.ALLOWED_CLIENTS', visible: true, creatable: true, editable: true, inputType: 'lookup-many', lookupSource: 'lists.clients',
          validation: { isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
        {field: 'RestrictFullRange', type: 'int', displayLabel: 'USERS.FIELDS.RESTRICT_FULL_RANGE', visible: true, creatable: true, editable: true, inputType: 'bool-int',
          validation: { isRequired: false, maxLen: -1, minLen: 1, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
        {field: 'CreatedBy', type: 'text', displayLabel: 'USERS.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
          validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
        {field: 'UpdatedBy', type: 'text', displayLabel: 'USERS.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
          validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }
        }
      ],
      uniqueConstraints: [],
      title: 'MERCH_BOARDS.TABS.SHARED_WITH',
      icon: '',
      idField: 'Id',
      lookupDisplayField: 'Email',
      isDirty: false,
      methods: {},
      views: {
        mainList: {
          columns: ['UserName', 'AccountName', 'AccountType', 'Country', 'City', 'Status', 'UpdateDate'],
          columnFilter: {},
          toggleFilterProps: { toggleStatus: false, filterProp: 'Status', trueVal: 1, trueValTooltipMessage: 'ACTIONS.TOGGLE_ACTIVE', falseVal: '', falseValTooltipMessage: "ACTIONS.TOGGLE_ALL" },
          topIndex: 0,
          showFilterRow: false,
          sortColumn: { 'UpdateDate': false },
          itemActions: [],
          listActions: [],
          fabAction: {}
        },
        mainDetails: {},
        privileges: {
          list: 'GetMerchSlideDetails',
        }
      }
    };
  }
})();
(function() {
  'use strict';

  angular
      .module('app.main.catalogs.merch-boards.shared-with-user-groups', []);
})();
(function () {
  'use strict';

  angular
    .module('app.main.catalogs.merch-boards.shared-with-user-groups')
    .run(runBlock);

  /* @ngInject */
  function runBlock(api) {

    if (angular.isUndefined(api.merchBoards)) {
      api.merchBoards = {};
    }
    api.merchBoards.sharedWithUserGroups = {
      modelPath: 'merchBoards.sharedWithUserGroups',
      fields: [
        {field: 'Id', type: 'int', displayLabel: 'USER_GROUPS.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
          validation: { isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
        {field: 'AccountId', type: 'int', displayLabel: 'USER_GROUPS.FIELDS.ACCOUNT_ID', visible: true, creatable: false, editable: false, inputType: 'static',
          validation: { isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } } },
        {field: 'AccountName', type: 'text', displayLabel: 'USER_GROUPS.FIELDS.ACCOUNT_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
          validation: { isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
        {field: 'Name', type: 'text', displayLabel: 'USER_GROUPS.FIELDS.NAME', visible: true, creatable: true, editable: true, inputType: 'text',
          validation: { isRequired: true, maxLen: 20, minLen: 1, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
        {field: 'Status', type: 'text', displayLabel: 'USER_GROUPS.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
          validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
        {field: 'CreatedDate', type: 'text', displayLabel: 'USER_GROUPS.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',},
        {field: 'UpdatedDate', type: 'text', displayLabel: 'USER_GROUPS.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
          validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
        {field: 'CreatedBy', type: 'text', displayLabel: 'USER_GROUPS.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
          validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
        {field: 'UpdatedBy', type: 'text', displayLabel: 'USER_GROUPS.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
          validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }
        }
      ],
      uniqueConstraints: [],
      title: 'MERCH_BOARDS.TABS.SHARED_WITH_USER_GROUPS',
      icon: '',
      idField: 'Id',
      lookupDisplayField: 'Name',
      isDirty: false,
      methods: {},
      views: {
        mainList: {
          columns: ['Id', 'AccountId', 'AccountName', 'Name', 'Status', 'UpdatedDate'],
          columnFilter: {},
          toggleFilterProps: {},
          topIndex: 0,
          showFilterRow: false,
          sortColumn: { 'UpdatedDate': false },
          itemActions: [],
          listActions: [],
          fabAction: {}
        },
        mainDetails: {},
        privileges: {
          list: 'GetMerchSlideDetails',
        }
      }
    };
  }
})();
(function() {
  'use strict';

  angular
      .module('app.main.catalogs.merch-boards.shared-with-folders', [])
			.config(config);

			/* @ngInject */
			function config($translatePartialLoaderProvider) {

				// Translation
				$translatePartialLoaderProvider.addPart('app/main/catalogs/sub-modules/merch-boards/details/tabs/shared-with-folders');
			}
})();
(function () {
	'use strict';

	angular
		.module('app.main.catalogs.merch-boards.shared-with-folders')
		.run(runBlock);

	/* @ngInject */
	function runBlock(api) {

		if (angular.isUndefined(api.merchBoards)) {
			api.merchBoards = {};
		}
		api.merchBoards.sharedWithFolders = {
			modelPath: 'merchBoards.sharedWithFolders',
			fields: [
				{ field: 'Id', type: 'int', displayLabel: 'SHARED_WITH_FOLDERS.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
					validation: { isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
				{ field: 'Name', type: 'text', displayLabel: 'SHARED_WITH_FOLDERS.FIELDS.NAME', visible: true, creatable: false, editable: false, inputType: 'text',
					validation: { isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
				{ field: 'Entity', type: 'int', displayLabel: 'SHARED_WITH_FOLDERS.FIELDS.ENTITY', visible: true, creatable: false, editable: false, inputType: 'lookup', lookupSource: 'lists.entityList',
					validation: { isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
				{ field: 'Status', type: 'text', displayLabel: 'SHARED_WITH_FOLDERS.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
					validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
				{ field: 'CreatedBy', type: 'text', displayLabel: 'SHARED_WITH_FOLDERS.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
					validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
				{ field: 'CreatedDate', type: 'text', displayLabel: 'SHARED_WITH_FOLDERS.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
					validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
				{ field: 'UpdatedBy', type: 'text', displayLabel: 'SHARED_WITH_FOLDERS.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
					validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
				{ field: 'UpdatedDate', type: 'text', displayLabel: 'SHARED_WITH_FOLDERS.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
					validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }}
			],
			uniqueConstraints: [],
			title: 'MERCH_BOARDS.TABS.SHARED_WITH_FOLDERS',
			icon: '',
			idField: 'Id',
			lookupDisplayField: 'Name',
			isDirty: false,
			methods: {},
			views: {
				mainList: {
					columns: ['Id', 'Name', 'Entity', 'Status', 'UpdatedBy', 'UpdatedDate'],
					columnFilter: {},
					toggleFilterProps: { toggleStatus: false, filterProp: 'Status', trueVal: 1, trueValTooltipMessage: 'ACTIONS.TOGGLE_ACTIVE', falseVal: '', falseValTooltipMessage: "ACTIONS.TOGGLE_ALL" },
					topIndex: 0,
					showFilterRow: false,
					sortColumn: { 'UpdatedDate': false },
					itemActions: [
						{ id: 'view', label: 'ACTIONS.VIEW', icon: 'icon-magnify', privilege: 'GetSharingFolderDetails', disabled: '!itm.Status', visible: true }
					],
					listActions: [],
					fabAction: {}
				},
				mainDetails: {},
				privileges: {
					list: 'GetMerchSlideDetails',
				}
			}
		};
	}
})();
(function() {
  'use strict';

  angular
      .module('app.main.catalogs.forecast.articles', []);
})();
(function () {
  'use strict';

  angular
    .module('app.main.catalogs.forecast.articles')
    .run(runBlock);

  /* @ngInject */
  function runBlock(api, activityLogger, $state, crud, catalogFactory) {

    if (angular.isUndefined(api.forecast)) {
      api.forecast = {};
    }
    api.forecast.articles = {
      modelPath: 'forecast.articles',
      fields: [
        { field: 'Id', type: 'int', displayLabel: 'ARTICLES.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
          validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
        { field: 'ArticleId', type: 'int', displayLabel: 'ARTICLES.FIELDS.ARTICLE_ID', visible: true, creatable: false, editable: false, inputType: 'number',
          validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
        { field: 'ArticleNumber', type: 'text', displayLabel: 'ARTICLES.FIELDS.ARTICLE_NUMBER', visible: true, creatable: false, editable: false, inputType: 'text',
          validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
        { field: 'Quantity', type: 'int', displayLabel: 'FORECAST.FIELDS.QUANTITY', visible: true, creatable: false, editable: true, inputType: 'number',
          validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '^[1-9][0-9]*|0$', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: 'Quantity must be non-negative integer'}} },
        { field: 'Difference', type: 'int', displayLabel: 'FORECAST.FIELDS.VARIANCE', visible: true, creatable: false, editable: true, inputType: 'number',
          validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
        { field: 'OrderedQuantity', type: 'int', displayLabel: 'FORECAST.FIELDS.ORDER_QUANTITY', visible: true, creatable: false, editable: true, inputType: 'number',
          validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '^[1-9][0-9]*|0$', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: 'Quantity must be non-negative integer'}} },
        { field: 'Status', type: 'text', displayLabel: 'ARTICLES.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
          validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
        { field: 'ForecastLineStatus', type: 'text', displayLabel: 'FORECAST.FIELDS.LINE_STATUS', visible: true, creatable: false, editable: false, inputType: 'forecastLineStatus',
          validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
        { field: 'CreatedDate', type: 'text', displayLabel: 'ARTICLES.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
          validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
        { field: 'UpdatedDate', type: 'text', displayLabel: 'ARTICLES.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
          validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
        { field: 'CreatedBy', type: 'text', displayLabel: 'ARTICLES.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
          validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
        { field: 'UpdatedBy', type: 'text', displayLabel: 'ARTICLES.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
          validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
      ],
      uniqueConstraints: [],
      title: 'ARTICLES.NAV',
      icon: 'icon-cube-outline',
      idField: 'Id',
      lookupDisplayField: 'ArticleNumber',
      isDirty: false,
      isBulkActionCompleted: false,
      isCatalogSpecificModel: true,
      methods: {
        // update         : updateQuantity,
        // activateBulk   : activateForecastArticles

       },
      views: {
        mainList: {
          columns           : ['ArticleId', 'ArticleNumber', 'Quantity', 'OrderedQuantity', 'Difference', 'Status', 'UpdatedBy', 'UpdatedDate'],
          columnFilter      : {},
          toggleFilterProps : {},
          topIndex          : 0,
          showFilterRow     : false,
          sortColumn        : { 'UpdatedDate': false },
          sortDescending    : true,
          itemActions       : [
                                { id: 'view', label: 'ACTIONS.VIEW', icon: 'icon-magnify', privilege: 'GetCatalogArticleDetails', disabled: '!itm.Status', visible: true },
                                // { id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateForecastArticleStatusBulk:true', disabled: false, visible: 'itm.Status',
                                //     requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                                // { id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateForecastArticleStatusBulk:true', disabled: false, visible: '!itm.Status',
                                //     requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'},
                                // { id: 'edit', label: 'FORECAST.ACTIONS.EDIT_QUANTITY', icon: 'icon-pencil', privilege: 'UpdateForecastArticleQuantity:true', disabled: '!itm.Status', visible: true }
                              ],
            listActions     : [
                                  // { id: 'delete', label: 'ACTIONS.DELETE_BULK', icon: 'icon-delete', privilege: 'UpdateForecastArticleStatusBulk:true', disabled: '{selected: true, Status: 1}', visible: true,
                                  //     requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                                  // { id: 'activate', label: 'ACTIONS.ACTIVATE_BULK', icon: 'icon-undo-variant', privilege: 'UpdateForecastArticleStatusBulk:true', disabled: '{selected: true, Status: 0}', visible: true,
                                  //     requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
                              ],
          fabAction         : {}
        },
        mainDetails: {},
        privileges: {
          list: 'GetForecastDetails',
          details: 'GetCatalogArticleDetails'
        }
      }
    };

    function updateQuantity(Id, article, forecastId) {
      var requestObj = {
        quantity: article.Quantity
      };
      var state = {};
      state.name = $state.current.name;
      state.params = $state.params;
      var logData = activityLogger.createLogData(Id, state, 'forecast.articles', 'EDIT', false, new Date(), null, null);
      var promise = api.webPut(api.baseUrl + '/catalogs/' + catalogFactory.getActiveCatalog().CatalogCode + '/forecasts/' + forecastId + '/forecastarticle/' + Id, requestObj);
      promise.then(function () {
        api.forecast.articles.isDirty = true;
      });
      return activityLogger.log(logData, promise);
    }

    function activateForecastArticles(records, model, actionType, catalogCode, forecastId) {
      var result = {
        requestObj: [],
        itemsNameList: []
      };

      var obj;
      var index = 0;
      var status = -1;
      if (actionType.toUpperCase() === 'DELETE') {
        status = 0;
      }
      else {
        status = 1;
      }

      if (!angular.isArray(records)) {
        records = crud.pushItemToArray(records);
      }

      for (index; index < records.length; index++) {
        obj = {}
        obj.Id = records[index][model.idField];
        obj.status = status;
        result.requestObj.push(obj);
        result.itemsNameList.push(records[index][model.lookupDisplayField]);
      }
      var state = {};
      state.name = $state.current.name;
      state.params = $state.params;
      var isBulk = result.itemsNameList.length > 1 ? true : false;
      var logData = activityLogger.createLogData(result.itemsNameList, state, 'forecast.articles', actionType.toUpperCase(), isBulk, new Date(), null, null);
      var promise = api.webPut(api.baseUrl + '/catalogs/' + catalogCode + '/forecasts/' + forecastId + '/articlestatus', result.requestObj);

      promise.then(function () {
        crud.onRecordStatusChange(records, api.forecast.articles, actionType);
      });

      return activityLogger.log(logData, promise);
    }


  }
})();
(function() {
  'use strict';

  angular
      .module('app.main.catalogs.favorites.shared-with-users', []);
})();
(function () {
  'use strict';

  angular
    .module('app.main.catalogs.favorites.shared-with-users')
    .run(runBlock);

  /* @ngInject */
  function runBlock(api, activityLogger, $state, crud, toast) {

    if (angular.isUndefined(api.favorites)) {
      api.favorites = {};
    }
    api.favorites.sharedWithUsers = {
      modelPath: 'favorites.sharedWithUsers',
      fields: [
        {field: 'UserId', type: 'int', displayLabel: 'USERS.FIELDS.USER_ID', visible: true, creatable: false, editable: false, inputType: 'number',
          validation: { isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
        {field: 'AccountId', type: 'int', displayLabel: 'USERS.FIELDS.ACCOUNT_ID', visible: true, creatable: false, editable: false, inputType: 'static',
          validation: { isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } } },
        {field: 'AccountName', type: 'text', displayLabel: 'USERS.FIELDS.ACCOUNT_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
          validation: { isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
        { field: 'AccountTypeId', type: 'int', displayLabel: 'USERS.FIELDS.ACCOUNT_TYPE_ID', visible: true, creatable: false, editable: false, inputType: 'number',
          validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
        {field: 'AccountType', type: 'text', displayLabel: 'USERS.FIELDS.ACCOUNT_TYPE', visible: true, creatable: false, editable: false, inputType: 'text',
          validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
        {field: 'FirstName', type: 'text', displayLabel: 'USERS.FIELDS.FIRST_NAME', visible: true, creatable: true, editable: true, inputType: 'text',
          validation: { isRequired: true, maxLen: 20, minLen: 1, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
        {field: 'LastName', type: 'text', displayLabel: 'USERS.FIELDS.LAST_NAME', visible: true, creatable: true, editable: true, inputType: 'text',
          validation: { isRequired: true, maxLen: 20, minLen: 1, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
        {field: 'Email', type: 'text', displayLabel: 'USERS.FIELDS.EMAIL', visible: true, creatable: true, editable: true, inputType: 'text',
          validation: { isRequired: true, maxLen: 500, minLen: 1, pattern: '^[A-Za-z]+[A-Za-z0-9._+-]+@{1}[A-Za-z0-9._-]+\.[A-Za-z.]{2,}$', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: 'VALIDATIONS.INVALID_EMAIL' } }},
        {field: 'UserName', type: 'text', displayLabel: 'USERS.FIELDS.USER_NAME', visible: true, creatable: true, editable: true, inputType: 'text',
          validation: { isRequired: true, maxLen: 50, minLen: 1, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } } },
        {field: 'Phone', type: 'text', displayLabel: 'USERS.FIELDS.PHONE', visible: true, creatable: true, editable: true, inputType: 'tel',
          validation: {isRequired: false, maxLen: 20, minLen: 0, pattern: '[0-9]*', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '', invalidType: 'VALIDATIONS.INVALID_PHONE_NUMBER'} }},
        {field: 'CountryCode', type: 'text', displayLabel: 'USERS.FIELDS.COUNTRY', visible: false, creatable: true, editable: true, inputType: 'lookup', lookupSource: 'lists.countries',
          validation: { isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } } },
        {field: 'Country', type: 'text', displayLabel: 'USERS.FIELDS.COUNTRY', visible: true, creatable: false, editable: false, inputType: 'text',
          validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }
        },
        {field: 'City', type: 'text', displayLabel: 'USERS.FIELDS.CITY', visible: true, creatable: true, editable: true, inputType: 'text',
          validation: { isRequired: true, maxLen: 25, minLen: 1, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
        { field: 'Designation', type: 'text', displayLabel: 'USERS.FIELDS.DESIGNATION', visible: true, creatable: true, editable: true, inputType: 'text',
          validation: { isRequired: false, maxLen: 20, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
        {field: 'Department', type: 'text', displayLabel: 'USERS.FIELDS.DEPARTMENT', visible: true, creatable: true, editable: true, inputType: 'text',
          validation: { isRequired: false, maxLen: 20, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
        {field: 'Status', type: 'text', displayLabel: 'USERS.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
          validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
        {field: 'LoginType', type: 'text', displayLabel: 'USERS.FIELDS.LOGIN_TYPE', visible: true, creatable: true, editable: true, inputType: 'lookup', lookupSource: 'lists.loginTypes',
          validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
        {field: 'Roles', type: 'text', displayLabel: 'USERS.FIELDS.USER_ROLE', visible: true, creatable: true, editable: true, inputType: 'lookup-many', lookupSource: 'roles.roles',
          validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
        {field: 'CreateDate', type: 'text', displayLabel: 'USERS.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',},
        {field: 'UpdateDate', type: 'text', displayLabel: 'USERS.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
          validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
        {field: 'AllowedClients', type: 'text', displayLabel: 'USERS.FIELDS.ALLOWED_CLIENTS', visible: true, creatable: true, editable: true, inputType: 'lookup-many', lookupSource: 'lists.clients',
          validation: { isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
        {field: 'RestrictFullRange', type: 'int', displayLabel: 'USERS.FIELDS.RESTRICT_FULL_RANGE', visible: true, creatable: true, editable: true, inputType: 'bool-int',
          validation: { isRequired: false, maxLen: -1, minLen: 1, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
        {field: 'CreatedBy', type: 'text', displayLabel: 'USERS.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
          validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
        {field: 'UpdatedBy', type: 'text', displayLabel: 'USERS.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
          validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }
        }
      ],
      uniqueConstraints: [],
      title: 'FAVORITES.TABS.SHARED_WITH',
      icon: '',
      idField: 'Id',
      lookupDisplayField: 'Email',
      isDirty: false,
      methods: {},
      views: {
        mainList: {
          columns: ['UserName', 'AccountName', 'AccountType', 'Country', 'City', 'Status', 'UpdateDate'],
          columnFilter: {},
          toggleFilterProps: { toggleStatus: false, filterProp: 'Status', trueVal: 1, trueValTooltipMessage: 'ACTIONS.TOGGLE_ACTIVE', falseVal: '', falseValTooltipMessage: "ACTIONS.TOGGLE_ALL" },
          topIndex: 0,
          showFilterRow: false,
          sortColumn: { 'UpdateDate': false },
          itemActions: [],
          listActions: [],
          fabAction: {}
        },
        mainDetails: {},
        privileges: {
          list: 'GetUserFavoriteDetails',
        }
      }
    };
  }
})();
(function() {
  'use strict';

  angular
      .module('app.main.catalogs.favorites.shared-with-user-groups', []);
})();
(function () {
  'use strict';

  angular
    .module('app.main.catalogs.favorites.shared-with-user-groups')
    .run(runBlock);

  /* @ngInject */
  function runBlock(api) {

    if (angular.isUndefined(api.favorites)) {
      api.favorites = {};
    }
    api.favorites.sharedWithUserGroups = {
      modelPath: 'favorites.sharedWithUserGroups',
      fields: [
        {field: 'Id', type: 'int', displayLabel: 'USER_GROUPS.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
          validation: { isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
        {field: 'AccountId', type: 'int', displayLabel: 'USER_GROUPS.FIELDS.ACCOUNT_ID', visible: true, creatable: false, editable: false, inputType: 'static',
          validation: { isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } } },
        {field: 'AccountName', type: 'text', displayLabel: 'USER_GROUPS.FIELDS.ACCOUNT_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
          validation: { isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
        {field: 'Name', type: 'text', displayLabel: 'USER_GROUPS.FIELDS.NAME', visible: true, creatable: true, editable: true, inputType: 'text',
          validation: { isRequired: true, maxLen: 20, minLen: 1, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
        {field: 'Status', type: 'text', displayLabel: 'USER_GROUPS.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
          validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
        {field: 'CreatedDate', type: 'text', displayLabel: 'USER_GROUPS.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',},
        {field: 'UpdatedDate', type: 'text', displayLabel: 'USER_GROUPS.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
          validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
        {field: 'CreatedBy', type: 'text', displayLabel: 'USER_GROUPS.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
          validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
        {field: 'UpdatedBy', type: 'text', displayLabel: 'USER_GROUPS.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
          validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }
        }
      ],
      uniqueConstraints: [],
      title: 'MERCH_BOARDS.TABS.SHARED_WITH_USER_GROUPS',
      icon: '',
      idField: 'Id',
      lookupDisplayField: 'Name',
      isDirty: false,
      methods: {},
      views: {
        mainList: {
          columns: ['Id', 'AccountId', 'AccountName', 'Name', 'Status', 'UpdatedDate'],
          columnFilter: {},
          toggleFilterProps: {},
          topIndex: 0,
          showFilterRow: false,
          sortColumn: { 'UpdatedDate': false },
          itemActions: [],
          listActions: [],
          fabAction: {}
        },
        mainDetails: {},
        privileges: {
          list: 'GetUserFavoriteDetails',
        }
      }
    };
  }
})();
(function() {
  'use strict';

  angular
      .module('app.main.catalogs.favorites.articles', []);
})();
(function () {
  'use strict';

  angular
    .module('app.main.catalogs.favorites.articles')
    .run(runBlock);

  /* @ngInject */
  function runBlock(api) {

    if (angular.isUndefined(api.favorites)) {
      api.favorites = {};
    }
    api.favorites.articles = {
      modelPath: 'favorites.articles',
      fields: [
        {field: 'ArticleId', type: 'int', displayLabel: 'ARTICLES.FIELDS.ARTICLE_ID', visible: true, creatable: false, editable: false, inputType: 'number',
          validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
        {field: 'ArticleNumber', type: 'text', displayLabel: 'ARTICLES.FIELDS.ARTICLE_NUMBER', visible: true, creatable: true, editable: true, inputType: 'text',
          validation: { isRequired: true, maxLen: 20, minLen: 1, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
        {field: 'ModelNumber', type: 'text', displayLabel: 'ARTICLES.FIELDS.MODEL_NUMBER', visible: true, creatable: true, editable: true, inputType: 'text',
          validation: { isRequired: false, maxLen: 200, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
        {field: 'ArticleName', type: 'text', displayLabel: 'ARTICLES.FIELDS.ARTICLE_NAME', visible: true, creatable: true, editable: true, inputType: 'text',
          validation: { isRequired: true, maxLen: 100, minLen: 1, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
        { field: 'Status', type: 'text', displayLabel: 'ARTICLES.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
          validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } } },
        {field: 'Locked', type: 'int', displayLabel: 'ARTICLES.FIELDS.LOCKED', visible: true, creatable: false, editable: false, inputType: 'bool-int',
          validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
        {field: 'SortOrder', type: 'int', displayLabel: 'ARTICLES.FIELDS.SORT_ORDER', visible: true, creatable: true, editable: true, inputType: 'number',
          validation: { isRequired: true, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
        {field: 'CreatedDate', type: 'text', displayLabel: 'ARTICLES.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
          validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
        {field: 'UpdatedDate', type: 'text', displayLabel: 'ARTICLES.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
          validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
        {field: 'Created_By', type: 'text', displayLabel: 'ARTICLES.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
          validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
        {field: 'Updated_By', type: 'text', displayLabel: 'ARTICLES.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
          validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
      ],
      uniqueConstraints: [],
      title: 'FAVORITES.TABS.ARTICLES',
      icon: 'icon-cube-outline',
      idField: 'Id',
      lookupDisplayField: 'ArticleNumber',
      isDirty: false,
      isBulkActionCompleted: false,
      isCatalogSpecificModel: true,
      methods: {},
      views: {
        mainList: {
          columns: ['ArticleNumber', 'ArticleName', 'Status', 'UpdatedDate'],
          columnFilter: {},
          imagesSize: 'large',
          toggleFilterProps: { toggleStatus: false, filterProp: 'Status', trueVal: 1, trueValTooltipMessage: 'ACTIONS.TOGGLE_ACTIVE', falseVal: '', falseValTooltipMessage: "ACTIONS.TOGGLE_ALL" },
          topIndex: 0,
          showFilterRow: false,
          sortColumn: { 'UpdatedDate': false },
          sortDescending: true,
          itemActions: []
        },
        mainDetails: {},
        privileges: {
          list: 'GetUserFavoriteDetails'
        }
      }
    };

  }
})();
(function() {
	'use strict';

	angular
			.module('app.main.catalogs.dune-images.tags', [])
			.config(config);

			/* @ngInject */
			function config($translatePartialLoaderProvider) {

				// Translation
				$translatePartialLoaderProvider.addPart('app/main/catalogs/sub-modules/dune-images/details/tabs/tags');
			}
})();
(function () {
	'use strict';

	angular
		.module('app.main.catalogs.dune-images.tags')
		.run(runBlock);

	/* @ngInject */
	function runBlock(api) {

		if (angular.isUndefined(api.t1Dune)) {
			api.t1Dune = {};
		}
		api.t1Dune.tags = {
			modelPath: 't1Dune.tags',
			fields: [
				{ field: 'Tag', type: 'text', displayLabel: 'TAGS.FIELDS.TAG', visible: true, creatable: false, editable: false, inputType: 'text',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'Status', type: 'text', displayLabel: 'TAGS.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'bool',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'CreatedOn', type: 'text', displayLabel: 'TAGS.FIELDS.CREATED_ON', visible: true, creatable: false, editable: false, inputType: 'date',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'UpdatedOn', type: 'text', displayLabel: 'TAGS.FIELDS.UPDATED_ON', visible: true, creatable: false, editable: false, inputType: 'date',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'CreatedBy', type: 'text', displayLabel: 'TAGS.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'text',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'UpdatedBy', type: 'text', displayLabel: 'TAGS.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'text',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
			],
			uniqueConstraints: [],
			title: 'TAGS.NAV',
			icon: 'icon-cube-outline',
			idField: 'Tag',
			lookupDisplayField: '',
			isDirty: false,
			isBulkActionCompleted: false,
			isCatalogSpecificModel: true,
			methods: {},
			views: {
				mainList: {
					columns           : ['Tag', 'Status', 'UpdatedOn', 'UpdatedBy', 'CreatedOn', 'CreatedBy'],
					columnFilter      : {},
					toggleFilterProps : {},
					topIndex          : 0,
					showFilterRow     : false,
					sortColumn        : { 'UpdatedOn': false },
					sortDescending    : true,
					itemActions       : [],
						listActions     : [],
					fabAction         : {}
				},
				mainDetails: {},
				privileges: {
					list: 'UI_T1DuneReadAccess'
				}
			}
		};
	}
})();
(function() {
    'use strict';

    angular
        .module('app.main.catalogs.customers.segmentations')
        .run(runBlock);

    /* @ngInject */
    function runBlock(api, activityLogger, $state, crud, catalogFactory) {

        if(angular.isUndefined(api.customers)) {
            api.customers = {};
        }
        api.customers.segmentations = {
            modelPath: 'customers.segmentations',
            fields: [
                { field: 'SegmentationId', type: 'int', displayLabel: 'SEGMENTATIONS.FIELDS.ID', visible: false, creatable: true, editable: true, inputType: 'lookup', lookupSource: 'catalogs.segmentations',
                    lookupFilter:{Status: 1}, validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'SegmentationId', type: 'int', displayLabel: 'SEGMENTATIONS.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
                    lookupFilter:{Status: 1}, validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CustomerId', type: 'int', displayLabel: 'SEGMENTATIONS.FIELDS.CUSTOMER_ID', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CatalogCode', type: 'text', displayLabel: 'SEGMENTATIONS.FIELDS.CATALOG_CODE', visible: false, creatable: false, editable: false, inputType: 'lookup', lookupSource: 'catalogs.catalogs',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'SegmentationName', type: 'text', displayLabel: 'SEGMENTATIONS.FIELDS.NAME', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: true, maxLen: 100, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Status', type: 'text', displayLabel: 'SEGMENTATIONS.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'SortOrder', type: 'int', displayLabel: 'SEGMENTATIONS.FIELDS.SORT_ORDER', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedDate', type: 'text', displayLabel: 'SEGMENTATIONS.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedDate', type: 'text', displayLabel: 'SEGMENTATIONS.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedBy', type: 'text', displayLabel: 'SEGMENTATIONS.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedBy', type: 'text', displayLabel: 'SEGMENTATIONS.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
            ],
            title: 'SEGMENTATIONS.NAV',
            icon: 'icon-group',
            idField: 'SegmentationId',
            lookupDisplayField: 'SegmentationName',
            isDirty: false,
            isCatalogSpecificModel: true,
            methods: {
                getList         :   getSegmentations,
                activateBulk    :   activateSegmentations,
                create          :   assignSegmentation
            },
            views: {
                mainList: {
                    columns             : [ 'SegmentationName', 'Status', 'UpdatedDate' ],
                    columnFilter        : {},
                    topIndex            : 0,
                    showFilterRow       : false,
                    sortColumn          : {'UpdatedDate': false},
                    itemActions         : [
                                            { id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateCustomerSegmentationStatusBulk:true', disabled: 'itm._nonEditable', visible: 'itm.Status',
                                                requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'}
                                        ],
                    listActions         : [
                                            { id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateCustomerSegmentationStatusBulk:true', disabled: '{selected: true, Status: 1, _nonEditable: ["!1"]}',
                                                visible: true, requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'}
                                        ],
                    fabAction           : {id: 'add', label: 'ACTIONS.ADD', icon: 'icon-link', privilege: 'CreateCatalogSegmentation:true', visible: true}
                },
                mainDetails: {},
                privileges: {
                    list: 'GetSellerCustomerSegmentations'
                }
            }

        };

        function getSegmentations(generalProperties, customerId, sellerId, CatalogCode) {
            var promise;

            if(angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
                var state = {};
                state.name = $state.current.name;
                state.params = $state.params;
                var isBulk = true;
                var logData = activityLogger.createLogData(null, state, 'customers.segmentations', 'VIEW', isBulk, new Date(), null, null);
                promise = api.webGet(api.baseUrl + '/sellers/' + sellerId + '/catalogs/' + CatalogCode + '/customers/' + customerId + '/customersegmentations', undefined, true, generalProperties.forceFetch);
                promise = activityLogger.log(logData, promise);
            }
            else {
                CatalogCode = angular.isUndefined(CatalogCode) ? catalogFactory.getActiveCatalog().CatalogCode : CatalogCode;
                return api.webGet(api.baseUrl + '/sellers/' + sellerId + '/catalogs/' + CatalogCode + '/customers/' + customerId + '/customersegmentations', undefined, true, generalProperties.forceFetch);
            }

            promise.then(function() {
                if (api.customers.segmentations.isDirty) {
                    //Invalidate lookupData
                    api.customers.segmentations.lookupData = undefined;
                    api.customers.segmentations.isDirty = false;
                }
            });
            return promise;
		}

        function activateSegmentations(records, model, actionType, sellerId, catalogId, customerId) {
            var result = crud.createRequestObject(records, model, actionType);
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var isBulk = result.itemsNameList.length > 1 ? true : false;
            var logData = activityLogger.createLogData(result.itemsNameList, state, 'customers.segmentations', actionType.toUpperCase(), isBulk, new Date(), null, null);
			var promise = api.webPut(api.baseUrl + '/sellers/' + sellerId + '/catalogs/'+ catalogId + '/customers/' + customerId + '/customersegmentations/status', result.requestObj);

             promise.then(function() {
                crud.onRecordStatusChange(records, model, actionType);
            });

            return activityLogger.log(logData, promise);
        }

        function assignSegmentation(segmentation, linkedSegmentations) {
            linkedSegmentations.push(segmentation);
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var logData = activityLogger.createLogData(segmentation[api.customers.segmentations.lookupDisplayField], state, 'customers.segmentations', 'ADD', false, new Date(), null, null);
			var promise = api.webPut(api.baseUrl + '/sellers/' + segmentation.sellerId + '/catalogs/'+ segmentation.activeCatalogCode + '/customers/' + segmentation.customerId + '/customersegmentations', linkedSegmentations);

            promise.then(function() {
               api.customers.segmentations.isDirty = true;
            });
            return activityLogger.log(logData, promise);
        }

    }
})();
(function() {
    'use strict';

    angular
        .module('app.main.customers.locations', [])
        .config(config);

        function config($stateProvider) {
            $stateProvider.state('app.locations_details', {
                url  : '/seller/:accountId/customers/:customerId/locations/:id',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/customers/locations/details/locations-details.html',
                        controller : 'LocationDetailsController as vm'
                    }
                },
                data: {
                    displayName: 'LOCATIONS.NAV'
                },
                // accessPrivileges: ['GetLocationDetails']
                accessInfo: {
                    accessPrivileges: ['GetLocationDetails']
                }
            });

        }
})();
(function() {
    'use strict';

    angular
        .module('app.main.customers.locations')
        .run(runBlock);

    /* @ngInject */
    function runBlock(api, activityLogger, $state, crud) {

        if(angular.isUndefined(api.linkedCustomers)) {
            api.linkedCustomers = {};
        }
        api.linkedCustomers.locations = {
            modelPath: 'linkedCustomers.locations',
            fields: [
                { field: 'Id', type: 'int', displayLabel: 'LOCATIONS.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'BuyerAccountId', type: 'text', displayLabel: 'LOCATIONS.FIELDS.BUYER_ACCOUNT_ID', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Name', type: 'text', displayLabel: 'LOCATIONS.FIELDS.NAME', visible: true, creatable: true, editable: true, inputType: 'text',
                    validation: {isRequired: true, maxLen: 50, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Code', type: 'text', displayLabel: 'LOCATIONS.FIELDS.CODE', visible: true, creatable: true, editable: true, inputType: 'text',
                    validation: {isRequired: true, maxLen: 50, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Address', type: 'text', displayLabel: 'LOCATIONS.FIELDS.ADDRESS', visible: true, creatable: true, editable: true, inputType: 'textArea',
                    validation: {isRequired: false, maxLen: 100, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'City', type: 'text', displayLabel: 'LOCATIONS.FIELDS.CITY', visible: true, creatable: true, editable: true, inputType: 'text',
                    validation: {isRequired: false, maxLen: 25, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'State', type: 'text', displayLabel: 'LOCATIONS.FIELDS.STATE', visible: true, creatable: true, editable: true, inputType: 'text',
                    validation: {isRequired: false, maxLen: 25, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Zip', type: 'text', displayLabel: 'LOCATIONS.FIELDS.ZIP', visible: true, creatable: true, editable: true, inputType: 'text',
                    validation: {isRequired: false, maxLen: 7, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CountryCode', type: 'text', displayLabel: 'LOCATIONS.FIELDS.COUNTRY', visible: false, creatable: true, editable: true, inputType: 'lookup', lookupSource: 'lists.countries',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CountryCode', type: 'text', displayLabel: 'LOCATIONS.FIELDS.COUNTRY_CODE', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CountryName', type: 'text', displayLabel: 'LOCATIONS.FIELDS.COUNTRY', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'LocationReference', type: 'text', displayLabel: 'LOCATIONS.FIELDS.LOCATION_REFERENCE', visible: true, creatable: true, editable: true, inputType: 'text',
                    validation: {isRequired: false, maxLen: 200, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Phone', type: 'text', displayLabel: 'LOCATIONS.FIELDS.PHONE', visible: true, creatable: true, editable: true, inputType: 'text',
                    validation: {isRequired: false, maxLen: 15, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreateDate', type: 'text', displayLabel: 'LOCATIONS.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdateDate', type: 'text', displayLabel: 'LOCATIONS.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedBy', type: 'text', displayLabel: 'LOCATIONS.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedBy', type: 'text', displayLabel: 'LOCATIONS.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'SellerCustomerId', type: 'text', displayLabel: 'LOCATIONS.FIELDS.SELLER_CUSTOMER_ID', visible: false, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Status', type: 'text', displayLabel: 'LOCATIONS.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
            ],
            uniqueConstraints: [],
            title: 'LOCATIONS.NAV',
            idField: 'Id',
            lookupDisplayField: 'Name',
            isDirty: false,
            isCatalogSpecificModel: true,
            methods: {
                getList         :   getLocations,
                activateBulk    :   activateLocations,
                create          :   createLocation,
                update          :   updateLocation
            },
            views: {
                mainList: {
                    columns             : [ 'Name', 'Code', 'CountryName', 'City', 'Status', 'UpdateDate'],
                    columnFilter        : {},
                    toggleFilterProps   : { toggleStatus:false, filterProp:'Status', trueVal:1, trueValTooltipMessage: 'ACTIONS.TOGGLE_ACTIVE', falseVal:'', falseValTooltipMessage:"ACTIONS.TOGGLE_ALL"},
                    topIndex            : 0,
                    showFilterRow       : false,
                    sortColumn          : {'UpdateDate': false},
                    itemActions         : [
                                            { id: 'view', label: 'ACTIONS.VIEW', icon: 'icon-magnify', privilege: 'GetLocationDetails', disabled: '!itm.Status', visible: true },
                                            { id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UpdateLocation', disabled: '!itm.Status', visible: true },
                                            { id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateCustomerLocationStatusBulk', disabled: false, visible: 'itm.Status',
                                                requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                                            { id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateCustomerLocationStatusBulk', disabled: false, visible: '!itm.Status',
                                                requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
                                        ],
                    listActions         : [
                                            { id: 'delete', label: 'ACTIONS.DELETE_BULK', icon: 'icon-delete', privilege: 'UpdateCustomerLocationStatusBulk', disabled: '{selected: true, Status: 1}', visible: true,
                                                requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                                            { id: 'activate', label: 'ACTIONS.ACTIVATE_BULK', icon: 'icon-undo-variant', privilege: 'UpdateCustomerLocationStatusBulk', disabled: '{selected: true, Status: 0}', visible: true,
                                                requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
                                        ],
                    fabAction           : {id: 'add', label: 'ACTIONS.ADD', icon: 'icon-plus', privilege: 'CreateLocation', visible: true}
                },
                mainDetails: {},
                privileges: {
                    list    : 'GetLocationList'
                }
            }

        };

        //lookup doesn't support for this module
        function getLocations(generalProperties, customerId, sellerId) {
            var promise;

            if(angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
                var state = {};
                state.name = $state.current.name;
                state.params = $state.params;
                var isBulk = true;
                var logData = activityLogger.createLogData(null, state, 'linkedCustomers.locations', 'VIEW', isBulk, new Date(), null, null);
                promise = api.webGet(api.baseUrl + '/sellers/' + sellerId + '/customers/' + customerId + '/locations', undefined, true, generalProperties.forceFetch);
                promise = activityLogger.log(logData, promise);
            }
            else {
                promise = api.webGet(api.baseUrl + '/sellers/' + sellerId + '/customers/' + customerId + '/locations', undefined, true, generalProperties.forceFetch);
            }

            promise.then(function() {
                if (api.linkedCustomers.locations.isDirty) {
                    //Invalidate lookupData
                    api.linkedCustomers.locations.lookupData = undefined;
                    api.linkedCustomers.locations.isDirty = false;
                }
            });
            return promise;
        }

        function activateLocations(records, model, actionType, parentId, sellerId) {
            var result = crud.createRequestObject(records, model, actionType);
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var isBulk = result.itemsNameList.length > 1 ? true : false;
            var logData = activityLogger.createLogData(result.itemsNameList, state, 'linkedCustomers.locations', actionType.toUpperCase(), isBulk, new Date(), null, null);
			var promise = api.webPut(api.baseUrl + '/sellers/' + sellerId + '/customers/' + parentId + '/locations/status', result.requestObj);

            promise.then(function() {
                crud.onRecordStatusChange(records, model, actionType);
            });

            return activityLogger.log(logData, promise);
		}
        //get sellerId from record
		function createLocation(record, customerId) {
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var logData = activityLogger.createLogData(record[api.linkedCustomers.locations.lookupDisplayField], state, 'linkedCustomers.locations.locations', 'ADD', false, new Date(), null, null);
            //sellerId is added as a default value to record in api.showCreateRecordDialog
			var promise = api.webPost(api.baseUrl + '/sellers/' + record.sellerId + '/customers/' + customerId + '/locations', record);

            promise.then(function() {
                api.linkedCustomers.locations.isDirty = true;
            });
            return activityLogger.log(logData, promise);
        }

        function updateLocation(recordId, record, parentId) {
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var logData = activityLogger.createLogData(record[api.linkedCustomers.locations.lookupDisplayField], state, 'linkedCustomers.locations.locations', 'EDIT', false, new Date(), null, null);
			var promise = api.webPut(api.baseUrl + '/sellers/' + parentId.sellerId + '/customers/' + parentId.customerId + '/locations/' + recordId, record);

            promise.then(function() {
                api.linkedCustomers.locations.isDirty = true;
            });
            return activityLogger.log(logData, promise);
		}

    }
})();
(function() {
    'use strict';

    angular
        .module('app.main.catalogs.customers.favorites', []);

})();
(function() {
    'use strict';

    angular
        .module('app.main.catalogs.customers.favorites')
        .run(runBlock);

    /* @ngInject */
    function runBlock(api, activityLogger, $state, crud, catalogFactory, jobsTracker, utility) {

        if(angular.isUndefined(api.customers)) {
            api.customers = {};
        }
        api.customers.favorites = {
            modelPath: 'customers.favorites',
            fields: [
                { field: 'Id', type: 'int', displayLabel: 'FAVORITES.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CatalogCode', type: 'text', displayLabel: 'FAVORITES.FIELDS.CATALOG_CODE', visible: false, creatable: false, editable: false, inputType: 'lookup', lookupSource: 'catalogs.catalogs',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CustomerId', type: 'int', displayLabel: 'FAVORITES.FIELDS.CUSTOMER_ID', visible: false, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CustomerCode', type: 'text', displayLabel: 'FAVORITES.FIELDS.CUSTOMER_CODE', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ArticleId', type: 'text', displayLabel: 'FAVORITES.FIELDS.ARTICLE_ID', visible: false, creatable: true, editable: true, inputType: 'lookup', lookupSource: 'catalogs.articles',
                    lookupFilter: {Status: 1}, validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ArticleNumber', type: 'text', displayLabel: 'FAVORITES.FIELDS.ARTICLE_NUMBER', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: 20, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Notes', type: 'text', displayLabel: 'FAVORITES.FIELDS.NOTES', visible: true, creatable: true, editable: true, inputType: 'text',
                    validation: {isRequired: false, maxLen: 250, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Tags', type: 'text', displayLabel: 'FAVORITES.FIELDS.TAGS', visible: true, creatable: true, editable: true, inputType: 'tags', tagSeparator: '|',
                    validation: {isRequired: true, maxLen: 250, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: 'Invalid Tag ,pipe character ( | ) is not allowed.'}} },
                { field: 'CreatedDate', type: 'text', displayLabel: 'FAVORITES.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedDate', type: 'text', displayLabel: 'FAVORITES.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedBy', type: 'text', displayLabel: 'FAVORITES.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedBy', type: 'text', displayLabel: 'FAVORITES.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
            ],
            title: 'FAVORITES.NAV',
            icon: '',
            idField: 'Id',
            lookupDisplayField: 'Notes',
            isDirty: false,
            isBulkActionCompleted: false,
            isCatalogSpecificModel: true,
            methods: {
                getList         :   getFavorites,
                activateBulk    :   activateFavorites,
                create          :   createFavorite,
                update          :   updateFavorite,
                createBulk      :   importFavorites
            },
            views: {
                mainList: {
                    columns             : [ 'CustomerCode', 'ArticleNumber', 'Tags', 'Notes', 'UpdatedDate' ],
                    columnFilter        : {},
                    topIndex            : 0,
                    showFilterRow       : false,
                    sortColumn          : {'UpdatedDate': false},
                    itemActions         : [
                                            { id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UpdateFavorites:true', disabled: false, visible: true },
                                            { id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'DeleteFavorites:true', disabled: false, visible: true,
                                                requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'}
                                          ],
                    listActions         : [
                                            { id: 'delete', label: 'ACTIONS.DELETE_BULK', icon: 'icon-delete', privilege: 'DeleteFavorites:true', disabled: false, visible: true,
                                                requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                                            { id: 'import', label: 'ACTIONS.IMPORT', icon: 'icon-import', privilege: 'UpdateBulkFavorites:true', disabled: false, visible: true, requiresConfirmation: false}
                                          ],
                    fabAction           : {id: 'add', label: 'ACTIONS.ADD', icon: 'icon-plus', privilege: 'CreateFavorites:true', visible: true}
                },
                mainDetails: {},
                privileges: {
                    list: 'GetFavoriteList'
                }
            }

        };

        api.customers.importFavorites = {
            modelPath: 'customers.importFavorites',
            fields: [
                { field: 'Id', type: 'int', displayLabel: 'FAVORITES.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CatalogCode', type: 'text', displayLabel: 'FAVORITES.FIELDS.CATALOG_CODE', visible: false, creatable: false, editable: false, inputType: 'lookup', lookupSource: 'catalogs.catalogs',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CustomerId', type: 'int', displayLabel: 'FAVORITES.FIELDS.CUSTOMER_ID', visible: false, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CustomerCode', type: 'text', displayLabel: 'FAVORITES.FIELDS.CUSTOMER_CODE', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ArticleId', type: 'text', displayLabel: 'FAVORITES.FIELDS.ARTICLE_ID', visible: false, creatable: false, editable: false, inputType: 'lookup', lookupSource: 'catalogs.articles',
                    lookupFilter: {Status: 1}, validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ArticleNumber', type: 'text', displayLabel: 'FAVORITES.FIELDS.ARTICLE_NUMBER', visible: true, creatable: true, editable: true, inputType: 'text',
                    validation: {isRequired: true, maxLen: 20, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Notes', type: 'text', displayLabel: 'FAVORITES.FIELDS.NOTES', visible: true, creatable: true, editable: true, inputType: 'text',
                    validation: {isRequired: false, maxLen: 250, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Tags', type: 'text', displayLabel: 'FAVORITES.FIELDS.TAGS', visible: true, creatable: true, editable: true, inputType: 'tags', tagSeparator: '|',
                    validation: {isRequired: true, maxLen: 250, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedDate', type: 'text', displayLabel: 'FAVORITES.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedDate', type: 'text', displayLabel: 'FAVORITES.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedBy', type: 'text', displayLabel: 'FAVORITES.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedBy', type: 'text', displayLabel: 'FAVORITES.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
            ],
            uniqueConstraints: [
                { name: 'Constraint 1', fields: ['ArticleNumber'] }
            ],
            title: 'FAVORITES.NAV',
            icon: '',
            idField: 'Id',
            lookupDisplayField: 'Notes',
            isDirty: false,
            isBulkActionCompleted: false,
            isCatalogSpecificModel: true,
            methods: {},
            views: {
                mainList: {},
                mainDetails: {},
                privileges: {
                    list: 'GetFavoriteList'
                }
            }
        };

        function getFavorites(generalProperties, model, customerId, CatalogCode) {
            if(angular.isDefined(model)) { // to skip this part for load lookup
                model.isBulkActionCompleted = false;
            }
            var promise;

            if(angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
                var state = {};
                state.name = $state.current.name;
                state.params = $state.params;
                var isBulk = true;
                var logData = activityLogger.createLogData(null, state, 'customers.favorites', 'VIEW', isBulk, new Date(), null, null);
                promise = api.webGet(api.baseUrl + '/catalogs/' + CatalogCode + '/customers/' + customerId + '/favorites', undefined, true, generalProperties.forceFetch);
                promise = activityLogger.log(logData, promise);
            }
            else {
                CatalogCode = angular.isUndefined(CatalogCode) ? catalogFactory.getActiveCatalog().CatalogCode : CatalogCode;
                return api.webGet(api.baseUrl + '/catalogs/' + CatalogCode + '/customers/' + customerId + '/favorites', undefined, true, generalProperties.forceFetch);
            }

            promise.then(function() {
                if (api.customers.favorites.isDirty) {
                    //Invalidate lookupData
                    api.customers.favorites.lookupData = undefined;
                    api.customers.favorites.isDirty = false;
                }
            });
            return promise;
		}

        function activateFavorites(records, model, actionType, parentIdObj) {
             var result = {
                requestObj: [],
                itemsNameList: []
            };
            // pushing single item to array
            if(!angular.isArray(records)) {
                records = utility.pushItemToArray(records);
            }
            for(var index=0; index < records.length ; index++) {
                result.requestObj.push(records[index][model.idField]);
                result.itemsNameList.push(records[index][model.lookupDisplayField]);
            }
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var isBulk = result.itemsNameList.length > 1 ? true : false;
            var logData = activityLogger.createLogData(result.itemsNameList, state, 'customers.favorites', actionType.toUpperCase(), isBulk, new Date(), null, null);
			var promise = api.webDelete(api.baseUrl + '/catalogs/'+ parentIdObj.catalogCode + '/customers/' + parentIdObj.customerId + '/favorites', result.requestObj);

             promise.then(function() {
                // crud.onRecordStatusChange(records, model, actionType); since its a hard delete and does not have status
                api.customers.favorites.isDirty = true;
            });

            return activityLogger.log(logData, promise);
        }

        function createFavorite(favoriteObj, parentIdObj) {
            var favoriteObjClone = angular.copy(favoriteObj);
            favoriteObjClone.Tags = favoriteObjClone.Tags.join('|');
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var logData = activityLogger.createLogData(favoriteObj[api.customers.favorites.lookupDisplayField], state, 'customers.favorites', 'ADD', false, new Date(), null, null);
            var promise = api.webPost(api.baseUrl + '/catalogs/' + parentIdObj.catalogCode + '/customers/' + parentIdObj.customerId + '/favorites', favoriteObjClone);

            promise.then(function() {
                api.customers.favorites.isDirty = true;
            });
            return activityLogger.log(logData, promise);
        }

        function updateFavorite(favoriteId, favoriteObj, parentIdObj) {
            var favoriteObjClone = angular.copy(favoriteObj);
            favoriteObjClone.Tags = favoriteObjClone.Tags.join('|');
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var logData = activityLogger.createLogData(favoriteObj[api.customers.favorites.lookupDisplayField], state, 'customers.favorites', 'EDIT', false, new Date(), null, null);
            var promise = api.webPut(api.baseUrl + '/catalogs/' + parentIdObj.catalogCode + '/customers/' + parentIdObj.customerId + '/favorites/' + favoriteId, favoriteObjClone);

            promise.then(function() {
                api.customers.favorites.isDirty = true;
            });
            return activityLogger.log(logData, promise);
		}

        function importFavorites(model, data, customerNumber, catalogCode) {
           api.webPut(api.baseUrl + '/catalogs/' + catalogCode + '/customers/' + customerNumber + '/bulkfavorites', data).then(function() {
                api.customers.favorites.isDirty = true;
                api.customers.favorites.isBulkActionCompleted = true;
            });
        }

    }
})();
(function() {
	'use strict';

	angular
		.module('app.main.catalogs.customers.stocks', []);

})();
(function() {
		'use strict';

		angular
				.module('app.main.catalogs.customers.stocks')
				.run(runBlock);

		/* @ngInject */
		function runBlock(api) {

				if(angular.isUndefined(api.customers)) {
						api.customers = {};
				}
				api.customers.stocks = {
						modelPath: 'customers.stocks',
						fields: [
								{ field: 'StockDefinitionId', type: 'int', displayLabel: 'LINKED_CUSTOMERS.FIELDS.STOCK_DEFINITION_ID', visible: true, creatable: true, editable: true, inputType: 'number',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'StockCode', type: 'text', displayLabel: 'LINKED_CUSTOMERS.FIELDS.STOCK_CODE', visible: true, creatable: true, editable: true, inputType: 'text',
										validation: {isRequired: false, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'StockName', type: 'text', displayLabel: 'LINKED_CUSTOMERS.FIELDS.STOCK_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
										 validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
						],
						title: 'STOCKS.NAV',
						icon: '',
						idField: 'StockDefinitionId',
						lookupDisplayField: 'StockName',
						isDirty: false,
						isBulkActionCompleted: false,
						isCatalogSpecificModel: true,
						methods: {},
						views: {
								mainList: {
										columns             : [ 'StockDefinitionId', 'StockCode', 'StockName'],
										columnFilter        : {},
										topIndex            : 0,
										showFilterRow       : false,
										sortColumn          : {},
										itemActions         : [],
										listActions         : [],
										fabAction           : {}
								},
								mainDetails: {},
								privileges: {
										list: 'GetCatalogLinkedSellerCustomers'
								}
						}
				};
		}
})();
(function() {
	'use strict';

	angular
		.module('app.main.catalogs.customers.capacities')
		.run(runBlock);

	/* @ngInject */
	function runBlock(api, activityLogger, $state, $q, crud, catalogFactory, jobsTracker) {

		if(angular.isUndefined(api.customers)) {
			api.customers = {};
		}

		// ------------------------------------------------------------------
		// Customer <-> Capacity links (Linked Customer Details > Capacities tab)
		// ------------------------------------------------------------------
		api.customers.capacities = {
			modelPath: 'customers.capacities',
			fields: [
				// lookup field feeding the "link capacity" dialog (active capacities of the seller)
				{ field: 'CapacityId', type: 'int', displayLabel: 'SELLERS.CAPACITIES.FIELDS.NAME', visible: false, creatable: true, editable: true, inputType: 'lookup', lookupSource: 'sellers.capacities',
					lookupFilter: {Status: 1}, validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'Name', type: 'text', displayLabel: 'SELLERS.CAPACITIES.FIELDS.NAME', visible: true, creatable: false, editable: false, inputType: 'text',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'Status', type: 'text', displayLabel: 'SELLERS.CAPACITIES.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'Criteria', type: 'text', displayLabel: 'SELLERS.CAPACITIES.FIELDS.CRITERIA', visible: true, creatable: false, editable: false, inputType: 'textArea',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'ArticleCapacity', type: 'int', displayLabel: 'SELLERS.CAPACITIES.FIELDS.ARTICLE_CAPACITY', visible: true, creatable: true, editable: true, inputType: 'number',
					validation: {isRequired: true, maxLen: -1, minLen: 0, pattern: '^\\d+$', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: 'VALIDATIONS.POSITIVE_NUMBER'}} },
				{ field: 'ModelCapacity', type: 'int', displayLabel: 'SELLERS.CAPACITIES.FIELDS.MODEL_CAPACITY', visible: true, creatable: true, editable: true, inputType: 'number',
					validation: {isRequired: true, maxLen: -1, minLen: 0, pattern: '^\\d+$', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: 'VALIDATIONS.POSITIVE_NUMBER'}} }
			],
			title: 'LINKED_CUSTOMERS.CAPACITIES.NAV',
			icon: 'icon-gauge',
			idField: 'CapacityId',
			lookupDisplayField: 'Name',
			isDirty: false,
			isBulkActionCompleted: false,
			isCatalogSpecificModel: true,
			methods: {
				getList      :   getCustomerCapacities,   // API 10
				assign       :   assignCapacity,          // API 7
				activateBulk :   setLinkStatus,           // API 8 (single-record; loops selected)
				createBulk   :   importCustomerCapacities // API 9
			},
			// DTCR customer<->capacity privileges (backend ids in parens). The `:true` suffix marks a
			// catalog-scoped check (these surfaces live inside a catalog context):
			//   LinkCustomerToCapacity (4044) link, UpdateCapacityCustomerStatus (4045) activate/deactivate,
			//   ImportCustomersWithCapacities (4047) import. The tab read has no dedicated backend privilege
			//   (data rides on the v1 catalog linked-customers detail, API 10), so it is gated on GetCapacity (4040).
			views: {
				mainList: {
					columns             : [ 'Name', 'Status', 'Criteria', 'ArticleCapacity', 'ModelCapacity' ],
					columnFilter        : {},
					topIndex            : 0,
					showFilterRow       : false,
					sortColumn          : {'Name': false},
					itemActions         : [
											{ id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateCapacityCustomerStatus:true', disabled: false, visible: 'itm.Status',
												requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
											{ id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateCapacityCustomerStatus:true', disabled: false, visible: '!itm.Status',
												requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
										],
					listActions         : [
											{ id: 'import', label: 'ACTIONS.IMPORT', icon: 'icon-import', privilege: 'ImportCustomersWithCapacities:true', disabled: false, visible: true, requiresConfirmation: false },
											{ id: 'delete', label: 'ACTIONS.DELETE_BULK', icon: 'icon-delete', privilege: 'UpdateCapacityCustomerStatus:true', disabled: '{selected: true, Status: 1}', visible: true,
												requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'}
										],
					fabAction           : { id: 'add', label: 'ACTIONS.ADD', icon: 'icon-link', privilege: 'LinkCustomerToCapacity:true', visible: true }
				},
				mainDetails: {},
				privileges: {
					list: 'GetCapacity'
				}
			}
		};

		// Dedicated import model (API 9 row shape differs from the display model)
		api.customers.importCustomerCapacities = {
			modelPath: 'customers.importCustomerCapacities',
			fields: [
				{ field: 'CustomerCode', type: 'text', displayLabel: 'LINKED_CUSTOMERS.FIELDS.CUSTOMER_NUMBER', visible: true, creatable: true, editable: true, inputType: 'text',
					validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'CapacityName', type: 'text', displayLabel: 'SELLERS.CAPACITIES.FIELDS.NAME', visible: true, creatable: true, editable: true, inputType: 'text',
					validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', dataExistConstraints: {modelPath: 'sellers.capacities', model: {lookupDisplayField: 'Name'}, promise: null, data: null, shouldNotExist: false, errorMessage: 'is not an existing capacity for this seller'}, messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'ArticleCapacity', type: 'int', displayLabel: 'SELLERS.CAPACITIES.FIELDS.ARTICLE_CAPACITY', visible: true, creatable: true, editable: true, inputType: 'number',
					validation: {isRequired: true, maxLen: -1, minLen: 0, pattern: '^\\d+$', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: 'VALIDATIONS.POSITIVE_NUMBER'}} },
				{ field: 'ModelCapacity', type: 'int', displayLabel: 'SELLERS.CAPACITIES.FIELDS.MODEL_CAPACITY', visible: true, creatable: true, editable: true, inputType: 'number',
					validation: {isRequired: true, maxLen: -1, minLen: 0, pattern: '^\\d+$', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: 'VALIDATIONS.POSITIVE_NUMBER'}} }
			],
			uniqueConstraints: [],
			title: 'LINKED_CUSTOMERS.CAPACITIES.NAV',
			icon: '',
			idField: 'CustomerCode',
			lookupDisplayField: 'CustomerCode',
			isDirty: false,
			isCatalogSpecificModel: true,
			methods: {},
			views: {
				mainList: {},
				mainDetails: {},
				privileges: {
					list: 'ImportCustomersWithCapacities'
				}
			}
		};

		// API VERSIONS: customer<->capacity link + link-status (APIs 7,8) are v2 -> api.t1v2URL, and are
		// CATALOG-scoped: a capacity is seller-owned but its assignment to a customer belongs to one catalog.
		// The catalog linked-customers read (API 10) and the import background job (API 9) are v1 -> api.baseUrl.

		// API 10 (v1) - GET api/catalogs/{catalogCode}/customers/{customerId} -> .Capacities (Status-0 links omitted).
		// The seller-customer endpoints are NOT enriched with capacities - they carry no catalog context, so the
		// per-customer article/model figures (which are per catalog) would be meaningless there.
		function getCustomerCapacities(generalProperties, customerId, catalogCode) {
			if(angular.isUndefined(catalogCode)) {
				catalogCode = catalogFactory.getActiveCatalog().CatalogCode;
			}
			var forceFetch = angular.isDefined(generalProperties) ? generalProperties.forceFetch : true;
			var promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/customers/' + customerId, undefined, true, forceFetch);
			if(angular.isDefined(generalProperties) && generalProperties.isLogRequired === true) {
				var state = {};
				state.name = $state.current.name;
				state.params = $state.params;
				var logData = activityLogger.createLogData(null, state, 'customers.capacities', 'VIEW', true, new Date(), null, null);
				promise = activityLogger.log(logData, promise);
			}
			return promise.then(function(response) {
				// Clear the "records have been modified, please refresh" banner once the refreshed list resolves
				// (jobsTracker sets isBulkActionCompleted=true when the customer-capacities import job completes).
				api.customers.capacities.isBulkActionCompleted = false;
				// This detail route had no front-end consumer before, and the sibling list route on the same
				// path returns an array - so unwrap a single-element array rather than silently rendering
				// an empty tab from `.Capacities` read off an array.
				var record = response.data;
				if(angular.isArray(record)) {
					record = record.filter(function(row) {
						return row && Number(row.CustomerId) === Number(customerId);
					})[0];
				}
				return { data: (record && record.Capacities) ? record.Capacities : [] };
			});
		}

		// API 7 (v2) - PUT api/catalogs/{catalogCode}/capacities/{capacityId}/customers/{customerId}  body {ArticleCapacity, ModelCapacity}
		// The capacity id identifies its owning seller, so the route carries the catalog rather than the seller.
		function assignCapacity(body, catalogCode, capacityId, customerId) {
			var state = {};
			state.name = $state.current.name;
			state.params = $state.params;
			var logData = activityLogger.createLogData(null, state, 'customers.capacities', 'ADD', false, new Date(), null, null);
			var promise = api.webPut(api.t1v2URL + '/catalogs/' + catalogCode + '/capacities/' + capacityId + '/customers/' + customerId, body);

			promise.then(function() {
				api.customers.capacities.isDirty = true;
			});
			return activityLogger.log(logData, promise);
		}

		// API 8 (v2) - PUT api/catalogs/{catalogCode}/capacities/{capacityId}/customers/{customerId}/status  body {Status}
		// single-record endpoint; loop for multi-select. Deactivating is confined to this catalog - the same
		// customer's links in other catalogs are untouched.
		function setLinkStatus(records, model, actionType, catalogCode, customerId) {
			var status = (actionType.toUpperCase() === 'ACTIVATE') ? 1 : 0;
			if(!angular.isArray(records)) {
				records = [records];
			}
			var promises = records.map(function(rec) {
				return api.webPut(api.t1v2URL + '/catalogs/' + catalogCode + '/capacities/' + rec.CapacityId + '/customers/' + customerId + '/status', { Status: status });
			});
			var promise = $q.all(promises);
			promise.then(function() {
				api.customers.capacities.isDirty = true;
			});
			return promise;
		}

		// API 9 (v1 bg job) - POST api/sellers/{sellerId}/catalogs/{catalogCode}/customers/capacities/import
		// The catalog is chosen at upload time and travels in the route, so the file carries no catalog/season
		// column and the same file is uploaded once per season. The seller travels alongside the catalog because
		// one catalog can hold customers from several sellers with colliding customer codes.
		function importCustomerCapacities(model, data, sellerId, catalogCode) {
			var jobIndex = jobsTracker.addJob(model, 'LINKED_CUSTOMERS.CAPACITIES.ACTIONS.IMPORT', 1);
			api.webPost(api.baseUrl + '/sellers/' + sellerId + '/catalogs/' + catalogCode + '/customers/capacities/import', data).then(function(response) {
				jobsTracker.trackJob(jobIndex, response.data.JobId || response.data.Id);
			}).catch(function(error) {
				jobsTracker.setCriticlaFail(jobIndex, error);
			});
		}
	}
})();

(function() {
  'use strict';

  angular
      .module('app.main.catalogs.customer-allocations.allocation-groups', []);
})();
(function () {
  'use strict';

  angular
    .module('app.main.catalogs.customer-allocations.allocation-groups')
    .run(runBlock);

  /* @ngInject */
  function runBlock(api, activityLogger, $state, catalogFactory) {

    if (angular.isUndefined(api.customerAllocations)) {
      api.customerAllocations = {};
    }
    api.customerAllocations.allocationGroups = {
      modelPath: 'customerAllocations.allocationGroups',
      fields: [
        { field: 'Id', type: 'int', displayLabel: 'CUSTOMER_ALLOCATIONS.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
          validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
        { field: 'AllocationGroupName', type: 'text', displayLabel: 'CUSTOMER_ALLOCATIONS.FIELDS.ALLOCATION_GROUP_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
          validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
        { field: 'Quantity', type: 'text', displayLabel: 'CUSTOMER_ALLOCATIONS.FIELDS.QUANTITY', visible: true, creatable: false, editable: false, inputType: 'text',
          validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
        { field: 'MinQuantity', type: 'text', displayLabel: 'CUSTOMER_ALLOCATIONS.FIELDS.MIN_QUANTITY', visible: true, creatable: false, editable: false, inputType: 'text',
          validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
        { field: 'Status', type: 'text', displayLabel: 'CUSTOMER_ALLOCATIONS.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
          validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
        { field: 'CreatedDate', type: 'text', displayLabel: 'CUSTOMER_ALLOCATIONS.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
          validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
        { field: 'UpdatedDate', type: 'text', displayLabel: 'CUSTOMER_ALLOCATIONS.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
          validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
        { field: 'CreatedBy', type: 'text', displayLabel: 'CUSTOMER_ALLOCATIONS.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
          validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
        { field: 'UpdatedBy', type: 'text', displayLabel: 'CUSTOMER_ALLOCATIONS.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
          validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
      ],
      uniqueConstraints: [],
      title: 'CUSTOMER_ALLOCATIONS.NAV',
      icon: 'icon-cube-outline',
      idField: 'Id',
      lookupDisplayField: 'AllocationGroup',
      isDirty: false,
      isBulkActionCompleted: false,
      isCatalogSpecificModel: true,
      methods: { },
      views: {
        mainList: {
          columns           : ['AllocationGroupName', 'Quantity', 'Status', 'UpdatedDate'],
          columnFilter      : {},
          toggleFilterProps : { toggleStatus: false, filterProp: 'Status', trueVal: 1, trueValTooltipMessage: 'ACTIONS.TOGGLE_ACTIVE', falseVal: '', falseValTooltipMessage: "ACTIONS.TOGGLE_ALL" },
          topIndex          : 0,
          showFilterRow     : false,
          sortColumn        : { 'UpdatedDate': false },
          sortDescending    : true,
          itemActions       : [
                                { id: 'view', label: 'ACTIONS.VIEW', icon: 'icon-magnify', privilege: 'GetAssignAllocationGroupsToCustomerDetails', disabled: '!itm.Status', visible: true }],
          listActions       : [],
          fabAction         : {}
        },
        mainDetails: {},
        privileges: {
          list: 'GetAssignAllocationGroupsToCustomerDetails',
          details: 'GetAssignAllocationGroupsToCustomerDetails'
        }
      }
    };
  }
})();
(function () {
    'use strict';

    angular
        .module('app.main.catalogs.consolidation-templates', [])
        .config(config);

    /* @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
        // State
        $stateProvider.state('app.consolidation-templates', {
            url    : '/consolidation-templates',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/catalogs/sub-modules/consolidation-templates/list/consolidation-templates-list.html',
                    controller : 'consolidationTemplatesListController as vm'
                }
            },
            data: {
                displayName: 'CONSOLIDATION_TEMPLATES.NAV'
            },
            //only users with following accessPrivileges in their role access list can access this route
			// accessPrivileges: ['GetOrderConsolidationTemplateList']
            // accessPrivileges: ['nav_consolidation_templates']
            accessInfo: {
                accessPrivileges: ['nav_consolidation_templates']
            }
        });
        $stateProvider.state('app.consolidation-templates.details', {
			url	 : '/:id',
            views: {
				'content@app': {
					templateUrl: 'app/main/catalogs/sub-modules/consolidation-templates/details/consolidation-templates-details.html',
					controller : 'consolidationTemplatesDetailsController as vm'
				}
			},
			data: {
				parentState: 'app.consolidation-templates',
                displayName: 'CONSOLIDATION_TEMPLATES.TABS.CONSOLIDATION_TEMPLATE'
			},
            //only users with following accessPrivileges in their role access list can access this route
            // accessPrivileges: ['GetOrderConsolidationTemplateDetails']
            accessInfo: {
                accessPrivileges: ['GetOrderConsolidationTemplateDetails']
            }
		});

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/catalogs/sub-modules/consolidation-templates');

        msNavigationServiceProvider.saveItem('orders.consolidation-templates', {
            title      : 'Consolidation Templates',
            icon       : 'icon-table-column-width',
            state      : 'app.consolidation-templates',
            translate  : 'CONSOLIDATION_TEMPLATES.NAV',
            weight     : 140,
            // accessPrivileges: ['GetOrderConsolidationTemplateList']
            // accessPrivileges: ['nav_consolidation_templates']
            accessInfo: {
                accessPrivileges: ['nav_consolidation_templates']
            }
        });
    }
})();
(function() {
    'use strict';

    angular
        .module('app.main.catalogs.consolidation-templates')
        .run(runBlock);

    /* @ngInject */
    function runBlock(api) {

        if (angular.isUndefined(api.consolidationTemplates)) {
            api.consolidationTemplates = {};
        }
         api.consolidationTemplates.output = {
            modelPath: 'consolidationTemplates.output',
            fields: [
                { field: 'ConsolidationFieldId', type: 'int', displayLabel: 'CONSOLIDATION_TEMPLATES_OUTPUT.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'TemplateId', type: 'int', displayLabel: 'CONSOLIDATION_TEMPLATES_OUTPUT.FIELDS.TEMPLATE_ID', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'FieldId', type: 'int', displayLabel: 'CONSOLIDATION_TEMPLATES_OUTPUT.FIELDS.FIELD_ID', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'SortOrder', type: 'int', displayLabel: 'CONSOLIDATION_TEMPLATES_OUTPUT.FIELDS.SORT_ORDER', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ColumnName', type: 'text', displayLabel: 'CONSOLIDATION_TEMPLATES_OUTPUT.FIELDS.COLUMN_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ColumnMapping', type: 'text', displayLabel: 'CONSOLIDATION_TEMPLATES_OUTPUT.FIELDS.COLUMN_MAPPING', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ColumnDataType', type: 'text', displayLabel: 'CONSOLIDATION_TEMPLATES_OUTPUT.FIELDS.DATA_TYPE', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'FilterOperator', type: 'text', displayLabel: 'CONSOLIDATION_TEMPLATES_OUTPUT.FIELDS.OPERATOR', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'IsInputField', type: 'text', displayLabel: 'CONSOLIDATION_TEMPLATES_OUTPUT.FIELDS.IS_INPUT', visible: false, creatable: false, editable: false, inputType: 'bool',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'IsOutPutField', type: 'text', displayLabel: 'CONSOLIDATION_TEMPLATES_OUTPUT.FIELDS.IS_OUTPUT', visible: false, creatable: false, editable: false, inputType: 'bool',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedDate', type: 'text', displayLabel: 'CONSOLIDATION_TEMPLATES_OUTPUT.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedDate', type: 'text', displayLabel: 'CONSOLIDATION_TEMPLATES_OUTPUT.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedBy', type: 'text', displayLabel: 'CONSOLIDATION_TEMPLATES_OUTPUT.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedBy', type: 'text', displayLabel: 'CONSOLIDATION_TEMPLATES_OUTPUT.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
            ],
            uniqueConstraints: [
            ],
            title: 'CONSOLIDATION_TEMPLATES_OUTPUT.NAV',
            icon: 'icon-table-column-width',
            idField: 'ConsolidationFieldId',
            lookupDisplayField: 'ColumnName',
            isDirty: false,
            isBulkActionCompleted: false,
            isCatalogSpecificModel: true,
            methods: {},
            views: {
                mainList: {
                    columns         : [ 'ColumnName', 'UpdatedDate' ],
                    columnFilter    : {},
                    toggleFilterProps: {},
                    topIndex        : 0,
                    showFilterRow   : false,
                    sortColumn      : {'UpdatedDate': false},
                    itemActions     : [],
                    listActions     : [],
                    fabAction       : {}

                 },
                 mainDetails: {
                     selectedTabIndex   : 0,
                     itemActions        : [],
                     fab                : {}

                 },
                privileges: {
                    list    : 'GetOrderConsolidationTemplateDetails'
                }
            }
        };

    }
})();
(function() {
    'use strict';

    angular
        .module('app.main.catalogs.consolidation-templates')
        .run(runBlock);

    /* @ngInject */
    function runBlock(api) {

        if (angular.isUndefined(api.consolidationTemplates)) {
            api.consolidationTemplates = {};
        }
         api.consolidationTemplates.criteria = {
            modelPath: 'consolidationTemplates.criteria',
            fields: [
                { field: 'ConsolidationFieldId', type: 'int', displayLabel: 'CONSOLIDATION_TEMPLATES_CRITERIA.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'TemplateId', type: 'int', displayLabel: 'CONSOLIDATION_TEMPLATES_CRITERIA.FIELDS.TEMPLATE_ID', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'FieldId', type: 'int', displayLabel: 'CONSOLIDATION_TEMPLATES_CRITERIA.FIELDS.FIELD_ID', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'SortOrder', type: 'int', displayLabel: 'CONSOLIDATION_TEMPLATES_CRITERIA.FIELDS.SORT_ORDER', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ColumnName', type: 'text', displayLabel: 'CONSOLIDATION_TEMPLATES_CRITERIA.FIELDS.COLUMN_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ColumnMapping', type: 'text', displayLabel: 'CONSOLIDATION_TEMPLATES_CRITERIA.FIELDS.COLUMN_MAPPING', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ColumnDataType', type: 'text', displayLabel: 'CONSOLIDATION_TEMPLATES_CRITERIA.FIELDS.DATA_TYPE', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'FilterOperator', type: 'text', displayLabel: 'CONSOLIDATION_TEMPLATES_CRITERIA.FIELDS.OPERATOR', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'IsInputField', type: 'text', displayLabel: 'CONSOLIDATION_TEMPLATES_CRITERIA.FIELDS.IS_INPUT', visible: false, creatable: false, editable: false, inputType: 'bool',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'IsOutPutField', type: 'text', displayLabel: 'CONSOLIDATION_TEMPLATES_CRITERIA.FIELDS.IS_OUTPUT', visible: false, creatable: false, editable: false, inputType: 'bool',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedDate', type: 'text', displayLabel: 'CONSOLIDATION_TEMPLATES_CRITERIA.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedDate', type: 'text', displayLabel: 'CONSOLIDATION_TEMPLATES_CRITERIA.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedBy', type: 'text', displayLabel: 'CONSOLIDATION_TEMPLATES_CRITERIA.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedBy', type: 'text', displayLabel: 'CONSOLIDATION_TEMPLATES_CRITERIA.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
            ],
            uniqueConstraints: [
            ],
            title: 'CONSOLIDATION_TEMPLATES_CRITERIA.NAV',
            icon: 'icon-table-column-width',
            idField: 'ConsolidationFieldId',
            lookupDisplayField: 'ColumnName',
            isDirty: false,
            isBulkActionCompleted: false,
            isCatalogSpecificModel: true,
            methods: {},
            views: {
                mainList: {
                    columns         : [ 'ColumnName', 'ColumnDataType', 'FilterOperator', 'UpdatedDate' ],
                    columnFilter    : {},
                    toggleFilterProps: {},
                    topIndex        : 0,
                    showFilterRow   : false,
                    sortColumn      : {'UpdatedDate': false},
                    itemActions     : [],
                    listActions     : [],
                    fabAction       : {}

                 },
                 mainDetails: {
                     selectedTabIndex   : 0,
                     itemActions        : [],
                     fab                : {}

                 },
                privileges: {
                    list    : 'GetOrderConsolidationTemplateDetails'
                }
            }
        };

    }
})();
(function() {
        'use strict';

        angular
                .module('app.main.catalogs.models.model-resources', []);
})();
(function() {
    'use strict';

    angular
        .module('app.main.catalogs.models.model-resources')
        .controller('assignCatalogModelResourcesController', assignCatalogModelResourcesController);

    /* @ngInject */
    function assignCatalogModelResourcesController($mdDialog, $scope, $filter, hotkeys, toast, api, utility, $q, modelId,
                activeCatalogId, sellerId, sellerAttributeGroupId, model, assignedResources, lookupPromises, event) {
        /* jshint validthis: true */
        var vm = this;

        //Data
        vm.model = model;
        vm.isLoading = false;
        vm.record = {};
        vm.record.ResourceId = [];
        vm.resourceLookup = {};

        // Map to track source of each resource by id
        var resourceSourceMap = {};

        //Methods
        vm.saveRecord = saveRecord;
        vm.closeDialog = closeDialog;

        vm.transformChip = transformChip;
        vm.acQuerySearch = acQuerySearch;
        vm.getChipDisplayValue = getChipDisplayValue;

        activate();

        ////////////////

        function activate() {
            loadResourcesLookup();
            hotkeys.bindTo($scope).add({
                combo: 'ctrl+enter',
                description: $filter('translate')('ACTIONS.SAVE'),
                allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
                callback: function() {
                    if (!vm.isLoading && !vm.editForm.$invalid) {
                        saveRecord();
                    }
                }
            });
        }

        function saveRecord() {
            vm.isLoading = true;

            // Split selected resources by source
            var catalogResourceIds = [];
            var sellerResourceIds = [];
            angular.forEach(vm.record.ResourceId, function(id) {
                if(resourceSourceMap[id] === 'seller') {
                    sellerResourceIds.push(id);
                } else {
                    catalogResourceIds.push(id);
                }
            });

            var promises = [];

            // Save catalog resources via existing method (only include seasonal resources in existing list)
            if(catalogResourceIds.length > 0) {
                var catalogRecord = angular.copy(vm.record);
                catalogRecord.ResourceId = catalogResourceIds;
                catalogRecord.activeCatalogId = activeCatalogId;
                catalogRecord.modelId = modelId;
                var seasonalAssignedResources = assignedResources.filter(function(r) { return r.IsSeasonal !== false; });
                promises.push(vm.model.methods.create(catalogRecord, seasonalAssignedResources));
            }

            // Save seller resources via seller endpoint (existing seasonless + newly selected)
            if(sellerResourceIds.length > 0) {
                var existingSellerIds = assignedResources.filter(function(r) { return r.IsSeasonal === false; }).map(function(r) { return r[api.catalogs.modelResources.idField]; });
                var sellerRequestObj = { ResourceId: existingSellerIds.concat(sellerResourceIds) };
                promises.push(api.webPut(api.baseUrl + '/sellers/' + sellerId + '/' + sellerAttributeGroupId + '/models/' + modelId + '/assignresources', sellerRequestObj));
            }

            $q.all(promises).then(function() {
                closeDialog(true);
                toast.success('SUCCESS.CREATE', '', '');
            }).finally(function () {
                vm.isLoading = false;
            });
        }

        function closeDialog(saved) {
            $mdDialog.hide(saved);
        }

        function transformChip(chip) {
            if (angular.isObject(chip)) {
                return chip.id;
            }
            return undefined;
        }

        function getChipDisplayValue(chip, resourcesLookup) {
            var res = utility.filterObject(resourcesLookup.data, {id: chip}, true);
            if (angular.isArray(res) && res.length > 0) {
                return res[0].value;
            }
        }

        function acQuerySearch(query, selectedItems, resourcesLookup) {
            var searchQueryResult = [];
            if(angular.isDefined(resourcesLookup.data) && resourcesLookup.data.length) {
                searchQueryResult = utility.filterObject(resourcesLookup.data, query);
                removeSelectedResources(selectedItems, searchQueryResult);
                return searchQueryResult;
            }
            else {
                return loadResourcesLookup().then(function(availableResources) {
                    searchQueryResult = utility.filterObject(availableResources.data, query);
                    removeSelectedResources(selectedItems, searchQueryResult);
                    return searchQueryResult;
                });
            }
        }

        //Helper Methods
        function loadResourcesLookup() {
            var deferred = $q.defer();

            // Load both catalog and seller resources in parallel
            $q.all({
                catalog: lookupPromises['ResourceId'],
                seller: lookupPromises['SellerResourceId']
            }).then(function(results) {
                var catalogData = angular.copy(results.catalog);
                var sellerData = angular.copy(results.seller);

                // Filter to active only
                catalogData.data = utility.filterObject(catalogData.data, {Status: 1});
                sellerData.data = utility.filterObject(sellerData.data, {Status: 1});

                // Remove already-assigned resources from both
                angular.forEach(assignedResources, function(assignedResource) {
                    var assignedId = assignedResource[api.catalogs.modelResources.idField];
                    var catalogIndex = catalogData.data.indexOf(utility.filterObject(catalogData.data, {id: assignedId}, true)[0]);
                    if(catalogIndex !== -1) {
                        catalogData.data.splice(catalogIndex, 1);
                    }
                    var sellerIndex = sellerData.data.indexOf(utility.filterObject(sellerData.data, {id: assignedId}, true)[0]);
                    if(sellerIndex !== -1) {
                        sellerData.data.splice(sellerIndex, 1);
                    }
                });

                // Build source map and merge
                angular.forEach(catalogData.data, function(item) {
                    resourceSourceMap[item.id] = 'catalog';
                });
                angular.forEach(sellerData.data, function(item) {
                    resourceSourceMap[item.id] = 'seller';
                });

                vm.resourceLookup = { data: catalogData.data.concat(sellerData.data) };
                deferred.resolve(vm.resourceLookup);
            });

            return deferred.promise;
        }

        function removeSelectedResources(selectedItems, searchQueryResult) {
            if (angular.isDefined(selectedItems) && selectedItems.length > 0) {
                for (var index = searchQueryResult.length-1; index >= 0; index--) {
                    if (selectedItems.indexOf(searchQueryResult[index].id) !== -1) {
                        searchQueryResult.splice(index,1);
                    }
                }
            }
        }

    }
})();

(function() {
	'use strict';

	angular
		.module('app.main.catalogs.catalog-datasets.values',[]);
})();

(function() {
	'use strict';

	angular
		.module('app.main.catalogs.catalog-datasets.values')
		.run(runBlock);

	/* @ngInject */
	function runBlock(api, $state, activityLogger, utility, jobsTracker, toast) {

		if(angular.isUndefined(api.catalogs)) {
			api.catalogs = {};
		}

		api.catalogs.datasetValues = {
			modelPath: 'catalogs.datasetValues',
			fields: [
				{ field: 'Id', type: 'int', displayLabel: 'SELLER_DATASETS.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'DisplayValue', type: 'text', displayLabel: 'SELLER_DATASETS.FIELDS.DISPLAY_VALUE', visible: true, creatable: false, editable: false, showInEdit: true, inputType: 'textArea',
					validation: {isRequired: true, maxLen: 1000, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'Status', type: 'text', displayLabel: 'SELLER_DATASETS.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'CreatedDate', type: 'text', displayLabel: 'SELLER_LOOKUP_TABLE.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'CreatedBy', type: 'text', displayLabel: 'SELLER_LOOKUP_TABLE.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'UpdatedDate', type: 'text', displayLabel: 'SELLER_DATASETS.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'UpdatedBy', type: 'text', displayLabel: 'SELLER_DATASETS.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				],
			uniqueConstraints: [],
			title: 'CATALOG_DATASETS.TABS.VALUES',
			icon: 'icon-book-open',
			idField: 'Id',
			lookupDisplayField: 'DisplayValue',
			isDirty: false,
			methods: {
				getList     :   getDatasetValues,
				createBulk  :   createDatasetValues,
				updateBulk  :   updateDatasetValues,
				deleteBulk  :   deleteDatasetValues,
			},
			views: {
				mainList: {
					columns         : [ 'Id', 'DisplayValue', 'Status', 'UpdatedBy', 'UpdatedDate' ],
					columnFilter    : {},
					topIndex        : 0,
					showFilterRow   : false,
					sortColumn      : {'UpdatedDate': false},
					itemActions     : [
						{ id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'DeleteDatasetValues', disabled: false, visible: 'itm.Status',
							requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'}
					],
					listActions     : [
						{ id: 'import', label: 'SELLER_DATASETS.ACTIONS.CREATE_DATASETS_VALUES', icon: 'icon-import', privilege: 'CreateCatalogDatasetValues', disabled: false, visible: true},
						{ id: 'updateBulk', label: 'ACTIONS.UPDATE_BULK', icon: 'icon-pencil', privilege: 'UpdateCatalogDatasetValues', disabled: '{selected: true}', visible: true, requiresConfirmation: false },
						{ id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'DeleteDatasetValues', disabled: '{selected: true, Status: 1}', visible: true, requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
					],
					fabAction       : {}
				},
				privileges: {
					// Values read reuses the seller values API (same GetDatasetValues privilege), with a catalogCode query param.
					list: 'GetDatasetValues'
				}
			}
		};

		// Catalog-scoped dataset values read.
		// Uses the seller values endpoint with a catalogCode query param so values are scoped to the catalog.
		function getDatasetValues(generalProperties, accountId, datasetId, catalogCode) {
			var url = api.t1v2URL + '/sellers/' + accountId + '/datasets/' + datasetId + '/values';
			if (angular.isDefined(catalogCode) && catalogCode !== null && catalogCode !== '') {
				url += '?catalogCode=' + catalogCode;
			}

			var promise;
			if (angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
					var state = {};
					state.name = $state.current.name;
					state.params = $state.params;
					var isBulk = true;
					var logData = activityLogger.createLogData(null, state, 'catalogs.datasetValues', 'VIEW', isBulk, new Date(), null, null);
					promise = api.webGet(url, undefined, true, generalProperties.forceFetch);
					promise = activityLogger.log(logData, promise);
			}
			else {
					promise = api.webGet(url, undefined, true, generalProperties.forceFetch);
			}

			promise.then(function () {
				if (api.catalogs.datasetValues.isDirty) {
					//Invalidate lookupData
					api.catalogs.datasetValues.lookupData = undefined;
					api.catalogs.datasetValues.isDirty = false;
				}
				api.catalogs.datasetValues.isBulkActionCompleted = false;
			});
			return promise;
		}

		// Catalog-scoped dataset values create (T1 API V2).
		function createDatasetValues(model, records, datasetId, catalogCode) {
			// Coerce each value to its declared dataset-attribute type so the
			// payload uses native JSON types (int/bool/string) instead of stringifying.
			var dynamicAttributes = utility.filterObject(model.fields, {isDynamicProperty: true}, true);
			var typedRecords = records.map(function(record) {
				var typed = {};
				angular.forEach(record, function(val, key) {
					var field = utility.filterObject(dynamicAttributes, {field: key}, true)[0];
					typed[key] = field ? utility.coerceByAttributeType(val, field) : val;
				});
				return typed;
			});

			var state = {};
			state.name = $state.current.name;
			state.params = $state.params;
			var logData = activityLogger.createLogData(null, state, 'catalogs.datasetValues', 'ADD', false, new Date(), null, null);
			var promise = api.webPost(api.t1v2URL + '/catalogs/' + catalogCode + '/datasets/' + datasetId + '/values', typedRecords);
			promise.then(function() {
				api.catalogs.datasetValues.isDirty = true;
			});
			return activityLogger.log(logData, promise);
		}

		// Soft-delete dataset values (single or bulk). Uses the same seller-level T1 API V2 endpoint
		// as the seller screen (deletion is by explicit value id, so no catalogCode is needed).
		function deleteDatasetValues(records, accountId, datasetId) {
			if (!angular.isArray(records)) {
				records = utility.pushItemToArray(records);
			}
			var ids = records.map(function (record) { return record.Id; });
			var state = {};
			state.name = $state.current.name;
			state.params = $state.params;
			var isBulk = ids.length > 1;
			var logData = activityLogger.createLogData(records, state, 'catalogs.datasetValues', 'DELETE', isBulk, new Date(), null, null);
			var promise = api.webDelete(api.t1v2URL + '/sellers/' + accountId + '/datasets/' + datasetId + '/values', ids);

			promise.then(function () {
				api.catalogs.datasetValues.isDirty = true;
				toast.success(isBulk ? 'SUCCESS.DELETE_BULK' : 'SUCCESS.DELETE', '', '');
			});
			return activityLogger.log(logData, promise);
		}

		// Catalog-scoped dataset values bulk update (T1 API V1 - background job).
		function updateDatasetValues(model, records, updateRecord, idMap) {
			var jobIndex = jobsTracker.addJob(api.catalogs.datasetValues, 'CATALOG_DATASETS.MESSAGES.UPDATE_VALUES', 1);
			var dynamicAttributes = utility.filterObject(model.fields, {isDynamicProperty: true}, true);
			var requestObjects = []
			angular.forEach(records, function(record) {
				var valueObj = {};
				angular.forEach(dynamicAttributes, function(attr) {
					var raw = updateRecord.hasOwnProperty(attr.field) ? updateRecord[attr.field] : record[attr.field];
					valueObj[attr.field] = utility.coerceByAttributeType(raw, attr);
				});

				requestObjects.push({
					Id: record.Id,
					Value: valueObj
				});
			});

			var state = {};
			state.name = $state.current.name;
			state.params = $state.params;
			var logData = activityLogger.createLogData(null, state, 'catalogs.datasetValues', 'EDIT', false, new Date(), null, null);
			var promise = api.webPut(api.baseUrl + '/catalogs/' + idMap.catalogCode + '/datasets/' + idMap.datasetId + '/values', requestObjects);

			promise.then(function(response) {
				jobsTracker.trackJob(jobIndex, response.data.Id);
			}).catch(function(error) {
				jobsTracker.setCriticlaFail(jobIndex, error);
			});
			return activityLogger.log(logData, promise);
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('app.main.catalogs.buyer-limits.limits-criteria')
		.run(runBlock);

	/* @ngInject */
	function runBlock(api, $state, crud, catalogFactory) {

		if (angular.isUndefined(api.catalogs)) {
			api.catalogs = {};
		}
		api.catalogs.attributeCriteria = {
			modelPath: 'catalogs.attributeCriteria',
			fields: [
				{field: 'Id', type: 'int', displayLabel: 'LIMITS_CRITERIA.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
					validation: { isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
				{field: 'Name', type: 'text', displayLabel: 'LIMITS_CRITERIA.FIELDS.NAME', visible: true, creatable: true, editable: true, inputType: 'text',
					validation: { isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
				{field: 'Attribute_1_Id', type: 'int', displayLabel: 'LIMITS_CRITERIA.FIELDS.ATTRIBUTE_1_ID', visible: true, creatable: true, editable: true, inputType: 'number',
					validation: { isRequired: false, maxLen: -1, minLen: 1, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
				{ field: 'Attribute_1_Name', type: 'text', displayLabel: 'LIMITS_CRITERIA.FIELDS.ATTRIBUTE_1_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
					validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
				{field: 'Attribute_1_Value', type: 'text', displayLabel: 'LIMITS_CRITERIA.FIELDS.ATTRIBUTE_1_VALUE', visible: true, creatable: true, editable: true, inputType: 'dynamic-attribute-value',
					validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
				{field: 'Attribute_2_Id', type: 'int', displayLabel: 'LIMITS_CRITERIA.FIELDS.ATTRIBUTE_2_ID', visible: true, creatable: true, editable: true, inputType:  'number',
					validation: { isRequired: false, maxLen: 20, minLen: 1, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
				{field: 'Attribute_2_Name', type: 'text', displayLabel: 'LIMITS_CRITERIA.FIELDS.ATTRIBUTE_2_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
					validation: { isRequired: false, maxLen: 20, minLen: 1, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
				{field: 'Attribute_2_Value', type: 'text', displayLabel: 'LIMITS_CRITERIA.FIELDS.ATTRIBUTE_2_VALUE', visible: true, creatable: true, editable: true, inputType: 'dynamic-attribute-value',
					validation: { isRequired: false, maxLen: 50, minLen: 1, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''} }},
				{field: 'Attribute_3_Id', type: 'int', displayLabel: 'LIMITS_CRITERIA.FIELDS.ATTRIBUTE_3_ID', visible: true, creatable: true, editable: true, inputType:  'number',
					validation: { isRequired: false, maxLen: 50, minLen: 1, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
				{field: 'Attribute_3_Name', type: 'text', displayLabel: 'LIMITS_CRITERIA.FIELDS.ATTRIBUTE_3_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
					validation: {isRequired: false, maxLen: 20, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '',} }},
				{field: 'Attribute_3_Value', type: 'text', displayLabel: 'LIMITS_CRITERIA.FIELDS.ATTRIBUTE_3_VALUE', visible: true, creatable: true, editable: true, inputType: 'dynamic-attribute-value',
					validation: { isRequired: false, maxLen: -1, minLen: 1, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
				{field: 'Attribute_4_Id', type: 'int', displayLabel: 'LIMITS_CRITERIA.FIELDS.ATTRIBUTE_4_ID', visible: true, creatable: true, editable: true, inputType: 'number',
					validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
				{field: 'Attribute_4_Name', type: 'text', displayLabel: 'LIMITS_CRITERIA.FIELDS.ATTRIBUTE_4_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
					validation: { isRequired: false, maxLen: 25, minLen: 1, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
				{ field: 'Attribute_4_Value', type: 'text', displayLabel: 'LIMITS_CRITERIA.FIELDS.ATTRIBUTE_4_VALUE', visible: true, creatable: true, editable: true, inputType: 'dynamic-attribute-value',
					validation: { isRequired: false, maxLen: 20, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
				{field: 'Target', type: 'int', displayLabel: 'LIMITS_CRITERIA.FIELDS.TARGET', visible: true, creatable: true, editable: true, inputType: 'number',
					validation: { isRequired: true, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
				{field: 'Limit', type: 'int', displayLabel: 'LIMITS_CRITERIA.FIELDS.LIMIT', visible: true, creatable: true, editable: true, inputType: 'number',
						validation: { isRequired: true, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
				{field: 'Status', type: 'text', displayLabel: 'LIMITS_CRITERIA.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
					validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
				{field: 'CreatedDate', type: 'text', displayLabel: 'LIMITS_CRITERIA.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
					validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
				{field: 'UpdatedDate', type: 'text', displayLabel: 'LIMITS_CRITERIA.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
					validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
				{field: 'CreatedBy', type: 'text', displayLabel: 'LIMITS_CRITERIA.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
					validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
				{field: 'UpdatedBy', type: 'text', displayLabel: 'LIMITS_CRITERIA.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
					validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }
				}
			],
			uniqueConstraints: [],
			title: 'BUYER_LIMITS.TABS.LIMITS_CRITERIA',
			icon: '',
			idField: 'Id',
			lookupDisplayField: 'Name',
			isDirty: false,
			methods: {
				create          :   createAttributeCriteria,
				activateBulk    :   activateAttributeCriteria,
				update          :   updateAttributeCriteria
			},
			views: {
				mainList: {
					columns: ['Name', 'Attribute_1_Id', 'Attribute_1_Name', 'Attribute_1_Value', 'Target', 'Limit', 'Status', 'UpdatedDate'],
					columnFilter: {},
					toggleFilterProps: {},
					topIndex: 0,
					showFilterRow: false,
					sortColumn: { 'UpdatedDate': false },
					itemActions: [
												{ id: 'view', label: 'ACTIONS.VIEW', icon: 'icon-magnify', privilege: 'GetCatalogArticleSegmentationList', disabled: false, visible: true },
												{ id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UpdateCatalogArticleBulkSegmentation:true', disabled: false, visible: true },
												{ id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateBuyerLimitAttributeCriteriaStatuses:true', disabled: false, visible: 'itm.Status',
														requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
												{ id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateBuyerLimitAttributeCriteriaStatuses:true', disabled: false, visible: '!itm.Status',
														requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
											],
					listActions: [
												{ id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateBuyerLimitAttributeCriteriaStatuses', disabled: '{selected: true, Status: 1}',
														visible: true, requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
												{ id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateBuyerLimitAttributeCriteriaStatuses', disabled: '{selected: true, Status: 0}',
														visible: true, requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
											],
					fabAction: {id: 'add', label: 'ACTIONS.ADD', icon: 'icon-plus', privilege: 'CreateAttributeCriteriaToBuyerLimit:true', visible: true}
				},
				mainDetails: {
					selectedTabIndex   : 0,
					itemActions: [
												{ id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateBuyerLimitAttributeCriteriaStatuses', disabled: '{selected: true, Status: 1}',
														visible: true, requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'},confirmationAction: 'ACTIONS.DELETE'},
												{ id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateBuyerLimitAttributeCriteriaStatuses', disabled: '{selected: true, Status: 0}',
														visible: true, requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
											],
					fab: {id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UpdateAttributeCriteriaToBuyerLimit', visible: true}
				},
				privileges: {
					list: 'GetBuyerLimitDetails',
					details: 'GetBuyerLimitDetails'
				}
			}
		};

		function activateAttributeCriteria(records, model, actionType, buyerLimitId) {
			var catalogCode = catalogFactory.getActiveCatalog().CatalogCode;
			var result = crud.createRequestObject(records, model, actionType);
			var promise = api.webPut(api.baseUrl + '/catalogs/' + catalogCode + '/buyerlimits/' + buyerLimitId + '/attributecriteria/status', result.requestObj);

			promise.then(function() {
					crud.onRecordStatusChange(records, api.catalogs.attributeCriteria, actionType);
			});
			return promise;
		}

	function createAttributeCriteria(record, buyerLimitId) {
			var catalogCode = catalogFactory.getActiveCatalog().CatalogCode;
			var promise = api.webPut(api.baseUrl + '/catalogs/' + catalogCode + '/buyerlimits/'+ buyerLimitId + '/attributecriteria', record);

			promise.then(function() {
					 api.catalogs.attributeCriteria.isDirty = true;
			});
			return promise;
		}

	function updateAttributeCriteria(itemId, item, buyerLimitId) {
			var catalogCode = catalogFactory.getActiveCatalog().CatalogCode;
			var promise = api.webPut(api.baseUrl + '/catalogs/' + catalogCode + '/buyerlimits/'+ buyerLimitId + '/attributecriteria/' + itemId, item);

			promise.then(function() {
					 api.catalogs.attributeCriteria.isDirty = true;
			});
			return promise;
	}

	}
})();
(function() {
  'use strict';

  angular
      .module('app.main.catalogs.buyer-limits.buyer-customers', [])
      .config(config);

  /** @ngInject */
  function config($translatePartialLoaderProvider)
  {
      // Translation
      $translatePartialLoaderProvider.addPart('app/main/catalogs/sub-modules/buyer-limits/details/tabs/buyer-limit-customers');
  }

})();
(function () {
	'use strict';

	angular
		.module('app.main.catalogs.buyer-limits.buyer-customers')
		.run(runBlock);

	/* @ngInject */
	function runBlock(api, catalogFactory) {

		if (angular.isUndefined(api.catalogs)) {
			api.catalogs = {};
		}
		api.catalogs.buyerLimitCustomers = {
			modelPath: 'catalogs.buyerLimitCustomers',
			fields: [
				{ field: 'Id', type: 'int', displayLabel: 'BUYER_CUSTOMERS.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
						validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'CustomerId', type: 'int', displayLabel: 'BUYER_CUSTOMERS.FIELDS.CUSTOMER_ID', visible: true, creatable: false, editable: false, inputType: 'number',
						validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'CustomerIdList', type:'text', displayLabel: 'BUYER_CUSTOMERS.FIELDS.CUSTOMERS_LIST', visible: false, creatable: true, editable: true, inputType: 'lookup-many', lookupSource: 'catalogs.customers',
						lookupFilter: {Status: 1}, validation: {isRequired: false, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'CustomerCode', type: 'text', displayLabel: 'BUYER_CUSTOMERS.FIELDS.CUSTOMER_CODE', visible: true, creatable: false, editable: false, inputType: 'text',
						validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'CustomerName', type: 'text', displayLabel: 'BUYER_CUSTOMERS.FIELDS.CUSTOMER_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
						validation: {isRequired: false, maxLen: 50, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'CustomerEmail', type: 'text', displayLabel: 'BUYER_CUSTOMERS.FIELDS.CUSTOMER_EMAIL', visible: true, creatable: false, editable: false, inputType: 'text',
						validation: {isRequired: false, maxLen: 50, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'Status', type: 'text', displayLabel: 'BUYER_CUSTOMERS.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
						validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'CreatedBy', type: 'text', displayLabel: 'BUYER_CUSTOMERS.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
						validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'UpdatedBy', type: 'text', displayLabel: 'BUYER_CUSTOMERS.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
						validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'CreatedDate', type: 'text', displayLabel: 'BUYER_CUSTOMERS.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
						validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'UpdatedDate', type: 'text', displayLabel: 'BUYER_CUSTOMERS.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
						validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
		],
		uniqueConstraints: [],
		title: 'BUYER_LIMITS.TABS.CUSTOMERS',
		idField: 'CustomerId',
		lookupDisplayField: 'CustomerCode',
		isDirty: false,
		methods: {
				update          :   assignCustomers
		},
		views: {
				mainList: {
						columns             : [ 'CustomerId', 'CustomerCode', 'CustomerName', 'Status', 'UpdatedDate' ],
						columnFilter        : {},
						topIndex            : 0,
						showFilterRow       : false,
						sortColumn          : {'UpdatedDate': false},
						itemActions         : [],
						listActions         : [],
						fabAction           : {id: 'add', label: 'ACTIONS.ADD', icon: 'icon-link', privilege: 'AssignCustomersToBuyerLimit:true', visible: true}
				},
				privileges: {
						list    : 'GetBuyerLimitDetails'
				}
		}

	};

	function assignCustomers(undefined, record, buyerLimitId) {
		var requestObj = record.CustomerIdList;
		var catalogCode = catalogFactory.getActiveCatalog().CatalogCode;
		var promise = api.webPut(api.baseUrl + '/catalogs/' + catalogCode + '/buyerlimits/' + buyerLimitId + '/customers', requestObj);

		promise.then(function() {
			api.catalogs.buyerLimitCustomers.isDirty = true;
		});
		return promise;
	}

}
})();
(function() {
    'use strict';

    angular
        .module('app.main.catalogs.assortments')
        .controller('setAssortmentCustomersController', setAssortmentCustomersController);

    /* @ngInject */
    function setAssortmentCustomersController($mdDialog, $scope, $window, $filter, hotkeys, toast, api, utility, assortmentId, activeCatalogId, model, event) {
        /* jshint validthis: true */
        var vm = this;

        //Data
        vm.api = api;
        vm.inputValues = "";
        vm.isLoading = false;
        vm.displayError = false;
        vm.record = {};
        var activeCustomers = [];


        //Methods
        vm.saveRecord = saveRecord;
        vm.closeDialog = closeDialog;


        activate();

        ////////////////

        function activate() {
            loadActiveCustomers();
            //Hotkeys
            hotkeys.bindTo($scope).add({
                combo: 'ctrl+enter',
                description: $filter('translate')('ACTIONS.SAVE'),
                allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
                callback: function(event) {
                    if (!vm.isLoading && !vm.editForm.$invalid) {
                        vm.saveRecord();
                    }
                }
            });
        }

        function saveRecord() {
            vm.isLoading = true;
            var data = createRequestObject(vm.inputValues);

            // since API dont accept empty array and sending empty array will un-asign which is should not be a behaviour for set customers
            if(data.requestObj.length) {
                model.methods.create(data, assortmentId , activeCatalogId).then(function() {
                    closeDialog(true);
                    toast.success('ASSORTMENTS.DIALOGS.MESSAGE.CUSTOMERS_SET', '', '');
                }).finally(function () {
                    closeDialog();
                    vm.isLoading = false;
                });
            }
            else {
                vm.displayError = true;
                vm.isLoading = false;
            }
        }

        function closeDialog(saved) {
            $mdDialog.hide(saved);
        }

        /**
         * Load all the acticve customers which are not assigned to assortment
         */
        function loadActiveCustomers() {
            // var isLogRequired = false;
            api.getLookupData(api.catalogs.customers).then(function(result) {
                result.data = utility.filterObject(result.data, {Status: 1});
                activeCustomers = result;
            });
        }

        /**
         * @description
         *   a helpre method which creats request object
         *
         * @param {string}  userInput       : user input in string formate
         * @return {object} an object containing request object and items name list(for logging purpose)
         */
        function createRequestObject(userInput) {
            var result = {
                requestObj: [],
                itemsNameList: []
            };
            var customersCode = userInput.match(/[^\r\n]+/g);

            // creating array of object {CustomerId: id} by matching entered text against list of available customer
            var customers = customersCode.map(function(customerCode) {

                //if entered input exist in list of available customers
                var customer = utility.filterObject(activeCustomers.data, {value: customerCode}, true)[0];
                if(angular.isDefined(customer)) {
                    var rCustomer = {};
                    rCustomer[model.idField] = customer.id;
                    rCustomer[model.lookupDisplayField] = customer.value;
                    return rCustomer;
                }
            });

            // removeing undefined entries created during map operation by not matching criteria
            for(var i=customers.length-1; i>=0 ; i--) {
                if(angular.isUndefined(customers[i])){
                    customers.splice(i,1);
                }
            }

            // create request object
            result.requestObj = customers.map(function (customer) {
                var rObj = {};
                rObj[model.idField] = customer[model.idField];
                return rObj;
            });
            // create items name list used for logging
            angular.forEach(customers, function(assignedCustomer) {
                result.itemsNameList.push(assignedCustomer[model.lookupDisplayField])
            });
            return result;
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.main.catalogs.assortments')
        .controller('setAssortmentArticleController', setAssortmentArticleController);

    /* @ngInject */
    function setAssortmentArticleController($mdDialog, $scope, $window, $filter, hotkeys, toast, api, utility, assortmentId, activeCatalogId, model, event) {
        /* jshint validthis: true */
        var vm = this;

        //Data
        vm.api = api;
        vm.inputValues = "";
        vm.isLoading = false;
        vm.displayError = false;
        vm.record = {};
        var activeArticles = [];


        //Methods
        vm.saveRecord = saveRecord;
        vm.closeDialog = closeDialog;


        activate();

        ////////////////

        function activate() {
            loadactiveArticles();
            //Hotkeys
            hotkeys.bindTo($scope).add({
                combo: 'ctrl+enter',
                description: $filter('translate')('ACTIONS.SAVE'),
                allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
                callback: function(event) {
                    if (!vm.isLoading && !vm.editForm.$invalid) {
                        vm.saveRecord();
                    }
                }
            });
        }

        function saveRecord() {
            vm.isLoading = true;
            var data = createRequestObject(vm.inputValues);

            // since API dont accept empty array and sending empty array will un-asign which is should not be a behaviour for set articles
            if(data.requestObj.length) {
                model.methods.create(data, assortmentId , activeCatalogId).then(function() {
                    closeDialog(true);
                    toast.success('ASSORTMENTS.DIALOGS.MESSAGE.ARTICLES_SET', '', '');
                }).finally(function () {
                    closeDialog();
                    vm.isLoading = false;
                });
            }
            else {
                vm.displayError = true;
                vm.isLoading = false;
            }
        }

        function closeDialog(saved) {
            $mdDialog.hide(saved);
        }

        /**
         * Load all the acticve articles which are not assigned to assortment
         */
        function loadactiveArticles() {
            // var isLogRequired = false;
            api.getLookupData(api.catalogs.articles).then(function(result) {
                result.data = utility.filterObject(result.data, {Status: 1});
                activeArticles = result;
            });
        }

        /**
         * @description
         *   a helpre method which creats request object
         *
         * @param {string}  userInput       : user input in string formate
         * @return {object} an object containing request object and items name list(for logging purpose)
         */
        function createRequestObject(userInput) {
            var result = {
                requestObj: [],
                itemsNameList: []
            };
            var articleNumbers = userInput.match(/[^\r\n]+/g);

            // creating array of object {ArticleId: id} by matching entered text against list of available articles
            var articles = articleNumbers.map(function(articleNumber) {
                //if entered input exist in list of available articles
                var article = utility.filterObject(activeArticles.data, {value: articleNumber}, true)[0];
                if(angular.isDefined(article)) {
                    var rArticle = {};
                    rArticle[model.idField] = article.id;
                    rArticle[model.lookupDisplayField] = article.value;
                    return rArticle;
                }
            });

            for(var i=articles.length-1; i>=0 ; i--) {
                if(angular.isUndefined(articles[i])){
                    articles.splice(i,1);
                }
            }

            // create request object
            result.requestObj = articles.map(function (article) {
                var rObj = {};
                rObj[model.idField] = article[model.idField];
                return rObj;
            });
            // create items name list used for logging
            angular.forEach(articles, function(assignedArticle) {
                result.itemsNameList.push(assignedArticle[model.lookupDisplayField])
            });
            return result;
        }
    }
})();
(function() {
		'use strict';

		angular
				.module('app.main.catalogs.assortments')
				.controller('createCriteriaCollectionController', createCriteriaCollectionController);

		/* @ngInject */
		function createCriteriaCollectionController($mdDialog, $scope, $window, $filter, hotkeys, $rootScope, $localStorage,
				$auth, toast, model, record, isNew, contextKey, duneContext, imageSetMap, folderId, sortOrder, event, api, catalogFactory) {
				/* jshint validthis: true */
				var vm = this;

				//Data
				vm.model = model;
				vm.imageSetMap = imageSetMap;
				var folderId = folderId;
				var sortOrder = sortOrder;
				var activeCatalog = catalogFactory.getActiveCatalog();
				var activeCatalogCode = activeCatalog.CatalogCode;

				if (angular.isUndefined($rootScope.flowObj)) {
						$rootScope.flowObj = {};
				}
				vm.obj = $rootScope.flowObj;

				vm.flowInit = {
					headers     : { Authorization: 'Bearer ' + $auth.getToken()},
					singleFile  : true
				};

				vm.isFileValid = true;
				vm.isLoading = false;
				vm.isImageLoading = false;
				vm.isNew = isNew;
				vm.record = record;
				vm.imageTypes = [];
				vm.fileName = '';
				vm.duneImageSource = {};
				if(!vm.record) {
						vm.record = {};
						vm.record.SortOrder = sortOrder;
				}

				vm.isDataDirty = false;
				vm.lookupModel = angular.copy(vm.record);
				vm.searchText = {};
				vm.isImageChanged = false; // for edit action show boxify and trim only when user changes image
				vm.assetTypes = [];
				vm.isAssetTypesLoading = false;

				// Fetch asset types for the current context
				if(duneContext && contextKey) {
					vm.isAssetTypesLoading = true;
					api.catalogs.t1Dune.methods.getAssetTypes(duneContext, contextKey).then(function(response) {
						vm.assetTypes = response.data;
					}).finally(function() {
						vm.isAssetTypesLoading = false;
					});
				}

				//Methods
				vm.saveRecord = saveRecord;
				vm.closeDialog = closeDialog;
				vm.validateFile = validateFile;
				vm.upload = upload;
				vm.onSuccessUpload = onSuccessUpload;

				if(!isNew) {
					if(angular.isDefined(vm.record.DunesImageSet) && vm.record.DunesImageSet !== '') {
						vm.isImageLoading = true;
						var generalProperties = {
							forceFetch: true,
							isLogRequired: true
						}
						var requestObjet = {
								Type : 'ImageSet',
								Filter: [vm.record.DunesImageSet],
								Context: catalogFactory.getActiveCatalog().DuneContext,
								ContextKey: catalogFactory.getCatalogContextKey(),
								FirstImage: true,
								Status: true,
								Op: 'equals'
						};
						api.catalogs.t1Dune.methods.getListByFilter(generalProperties, vm.model, requestObjet).then(function (duneImageData) {
								var duneImageData = duneImageData.data[0];
								if(duneImageData.AssetTypeId) {
									vm.record.AssetTypeId = duneImageData.AssetTypeId;
								}
								if(duneImageData.FileName) {
									vm.fileName = duneImageData.FileName.slice(duneImageData.FileName.lastIndexOf('/') + 1, duneImageData.FileName.length)
								}
								api.catalogs.t1Dune.methods.downloadDuneImage(duneImageData.StorageFile, contextKey, true).then(function(response) {
									vm.duneImageSource[vm.record.DunesImageSet] = response;
								});
								activate();
						}).finally(function() {
							vm.isImageLoading = false;
						});
					}
				} else {
					activate();
				}

				////////////////

				function activate() {
						//Hotkeys
						hotkeys.bindTo($scope).add({
								combo: 'ctrl+enter',
								description: $filter('translate')('ACTIONS.SAVE'),
								allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
								callback: function(event) {
										if (!vm.isLoading && !vm.editForm.$invalid && vm.obj.flow.files.length > 0 && vm.isFileValid && !vm.obj.flow.isUploading()) {
												vm.saveRecord();
										}
								}
						});
						if(vm.isNew) {
								hotkeys.bindTo($scope).add({
										combo: 'ctrl+shift+enter',
										description: $filter('translate')('ACTIONS.SAVE_AND_NEW'),
										allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
										callback: function(event) {
												if (!vm.isLoading && !vm.editForm.$invalid && vm.obj.flow.files.length > 0 && vm.isFileValid && !vm.obj.flow.isUploading() && vm.isNew) {
														vm.saveRecord(true);
												}
										}
								});
						}
				}

				function saveRecord() {
						vm.isLoading = true;
						//var promise;
						// TODO : CODE REFACTOR
						if(vm.isNew) {
							if(angular.isDefined(vm.record.file)) {
								var duneReqObj = {};
								// add dune context to record
								duneReqObj.Context = duneContext;
								duneReqObj.ContextKey = catalogFactory.getCatalogContextKey();
								duneReqObj.SortOrder = 0;
								duneReqObj.Key = vm.record.file.name.substring(0, vm.record.file.name.lastIndexOf('.'));
								duneReqObj.ImageSet = generateImageSet();
								duneReqObj.AssetTypeId = vm.record.AssetTypeId;
								duneReqObj.file = vm.record.file;
								api.catalogs.t1Dune.methods.create(duneReqObj, contextKey).then(function(response) {
									var requestObj = {
										FolderId: folderId,
										SortOrder: vm.record.SortOrder,
										Name: vm.record.Name,
										FilterCriteria: vm.record.FilterCriteria,
										DunesImageSet: duneReqObj.ImageSet
									};
									vm.model.methods.create(requestObj, activeCatalogCode).then(function() {
										closeDialog(true);
										var toastMessage;
										toastMessage = 'SUCCESS.CREATE';
										toast.success(toastMessage, '', '');
									}, function(err) {
										closeDialog(vm.isDataDirty);
									});
								}, function(err) {
									closeDialog(vm.isDataDirty);
								}).finally(function () {
										vm.isLoading = false;
								});
							} else {
								var requestObj = {
									FolderId: folderId,
									SortOrder: vm.record.SortOrder,
									Name: vm.record.Name,
									FilterCriteria: vm.record.FilterCriteria
								};
								vm.model.methods.create(requestObj, activeCatalogCode).then(function() {
									closeDialog(true);
									var toastMessage;
									toastMessage = 'SUCCESS.CREATE';
									toast.success(toastMessage, '', '');
								}, function(err) {
									closeDialog(vm.isDataDirty);
								});
							}
						}
						else { // new image added or existing image changed
								var requestObj = {};
								var collectionRegObj = {};
								if(angular.isDefined(vm.record.FileGuid)) {
									requestObj.Context = duneContext;
									requestObj.ContextKey = catalogFactory.getCatalogContextKey();
									requestObj.SortOrder = 0;
									requestObj.Key = vm.record.file.name.substring(0, vm.record.file.name.lastIndexOf('.'));
									requestObj.ImageSet = generateImageSet();
									requestObj.AssetTypeId = vm.record.AssetTypeId;
									requestObj.file = vm.record.file;
									api.catalogs.t1Dune.methods.create(requestObj, contextKey).then(function(response) {
										collectionRegObj = {
											FolderId: folderId,
											SortOrder: vm.record.SortOrder,
											Name: vm.record.Name,
											FilterCriteria: vm.record.FilterCriteria,
											DunesImageSet: requestObj.ImageSet
										};
										vm.model.methods.update(vm.record.Id, collectionRegObj, activeCatalogCode).then(function() {
											closeDialog(true);
											var toastMessage;
											toastMessage = 'SUCCESS.UPDATE';
											toast.success(toastMessage, '', '');
										}, function(err) {
											closeDialog(vm.isDataDirty);
										});
									}, function(err) {
										closeDialog(vm.isDataDirty);
									}).finally(function () {
											vm.isLoading = false;
									});
								} else { // when image is not changed
									collectionRegObj = vm.record;
									vm.model.methods.update(vm.record.Id, collectionRegObj, activeCatalogCode).then(function() {
										closeDialog(true);
										var toastMessage;
										toastMessage = 'SUCCESS.UPDATE';
										toast.success(toastMessage, '', '');
									}, function(err) {
										closeDialog(vm.isDataDirty);
									});
								}
						}
				}

				function closeDialog(saved, cancelUpload) {
						//If user cancel upload
						if(angular.isDefined(cancelUpload) && cancelUpload === true){
								vm.obj.flow.cancel();
						}
						$mdDialog.hide(saved);
				}

				function validateFile(file, message, flow) {
						vm.record.file = file.file;
						if (angular.isDefined(file) && !file.name.match(/\.(jpe?g|png|tif?f|JPE?G|PNG|TIF?F|glb|GLB)$/)) {
								vm.isFileValid = false;
						}
						else {
								vm.isFileValid = true;
						}
				}

				function upload() {
						if(vm.isFileValid) {
								vm.obj.flow.upload();
								if(!vm.isNew && (vm.fileName !== vm.obj.flow.files[0].name)) {
									vm.isImageChanged = true;
								} else {
									vm.isImageChanged = false;
								}
						}
						else {
								//remove file from flowObj.files if file is not valid and set vm.isFileValid to default value which is true
								// vm.obj.flow.files.splice(vm.obj.flow.files.length-1,1);
								vm.obj.flow.removeFile(vm.obj.flow.files[vm.obj.flow.files.length-1]);// or vm.obj.flow.files[0]
						}
				}

				function onSuccessUpload(file, message, chunk) {
						message = message.replace(/\"/g,"");
						vm.record.FileGuid = message;
				}

				/**
			 * @description: return unique ImageSet (like Col-{catalog code}-123456)
			 */
				function generateImageSet() {
					var generatedImageSet = 'Col-'+ activeCatalogCode + '-' +(Math.floor(Math.random() * 899999) + 100000);
					if(imageSetMap[generatedImageSet]) {
						return generateImageSet();
					} else {
						imageSetMap[generatedImageSet] = 1;
						return generatedImageSet;
					}
				}

		}
})();
(function() {
    'use strict';

    angular
        .module('app.main.assortments.customers')
        .run(runBlock);

    /* @ngInject */
    function runBlock(api, activityLogger, $state, crud, utility, catalogFactory) {

        if(angular.isUndefined(api.assortments)) {
            api.assortments = {};
        }
        api.assortments.sellerUsers = {
            modelPath: 'assortments.sellerUsers',
            fields: [
                { field: 'Id', type: 'int', displayLabel: 'ASSORTMENTS.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UserId', type: 'int', displayLabel: 'ASSORTMENTS.FIELDS.USER_ID', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } } },
                { field: 'Username', type: 'text', displayLabel: 'ASSORTMENTS.FIELDS.USER_NAME', visible: true, creatable: true, editable: false, inputType: 'text',
                    validation: {isRequired: true, maxLen: 50, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'AssortmentId', type: 'text', displayLabel: 'ASSORTMENTS.FIELDS.ASSORTMENT_ID', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Status', type: 'text', displayLabel: 'ASSORTMENTS.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedBy', type: 'text', displayLabel: 'ASSORTMENTS.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedBy', type: 'text', displayLabel: 'ASSORTMENTS.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedDate', type: 'text', displayLabel: 'ASSORTMENTS.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedDate', type: 'text', displayLabel: 'ASSORTMENTS.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Users', type: 'text', displayLabel: 'USER_GROUPS.FIELDS.USERS', visible: false, creatable: true, editable: true, inputType: 'lookup-many', lookupSource: 'catalogs.sellerUsers',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
            ],
            uniqueConstraints: [],
            idField: 'Id',
            lookupDisplayField: 'AssortmentId',
            isDirty: false,
            methods: {
                update          :   assignSellerUsers
            },
            views: {
                mainList: {
                    columns             : [ 'Id', 'UserId', 'Username', 'AssortmentId', 'Status', 'UpdatedDate' ],
                    columnFilter        : {},
                    topIndex            : 0,
                    showFilterRow       : false,
                    sortColumn          : {'UpdatedDate': false},
                    itemActions         : [],
                    listActions         : [],
                    fabAction           : {id: 'add', label: 'ACTIONS.ADD', icon: 'icon-link', privilege: 'UpdateCustomereAssortment:true', visible: true}
                },
                privileges: {
                    list    : 'GetAssortmentDetails'
                }
            }

        };

        function assignSellerUsers(undefined, users, assortmentId) {
            var catalogId = catalogFactory.getActiveCatalog().CatalogCode;
            var reqObj = users.Users;
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var isBulk = users.length > 0 ? true: false;
            var logData = activityLogger.createLogData(users, state, 'assortments.sellerUsers', 'ADD', isBulk, new Date(), null, null);
			var promise = api.webPut(api.baseUrl + '/catalogs/' + catalogId + '/assortments/' + assortmentId + '/users', users.Users);

            promise.then(function() {
               api.assortments.customers.isDirty = true;
            });
            return activityLogger.log(logData, promise);
		}

    }
})();
(function() {
    'use strict';

    angular
        .module('app.main.assortments.customers')
        .run(runBlock);

    /* @ngInject */
    function runBlock(api, activityLogger, $state, crud, utility) {

        if(angular.isUndefined(api.assortments)) {
            api.assortments = {};
        }
        api.assortments.customers = {
            fields: [
                { field: 'Id', type: 'int', displayLabel: 'CUSTOMERS.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CustomerId', type: 'int', displayLabel: 'CUSTOMERS.FIELDS.CUSTOMER_ID', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CustomerCode', type: 'text', displayLabel: 'CUSTOMERS.FIELDS.CUSTOMER_CODE', visible: true, creatable: true, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Name', type: 'text', displayLabel: 'CUSTOMERS.FIELDS.NAME', visible: true, creatable: true, editable: true, inputType: 'text',
                    validation: {isRequired: false, maxLen: 50, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedBy', type: 'text', displayLabel: 'CUSTOMERS.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedBy', type: 'text', displayLabel: 'CUSTOMERS.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedDate', type: 'text', displayLabel: 'CUSTOMERS.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedDate', type: 'text', displayLabel: 'CUSTOMERS.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Status', type: 'text', displayLabel: 'CUSTOMERS.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
            ],
            uniqueConstraints: [
                {name: 'Constraint 1', fields: ['CustomerNumber']}
            ],
            idField: 'CustomerId',
            lookupDisplayField: 'CustomerCode',
            isDirty: false,
            methods: {
                activateBulk    :   activateCustomers,
                create          :   createCustomer
            },
            views: {
                mainList: {
                    columns             : [ 'CustomerCode', 'Name', 'Status', 'UpdatedDate' ],
                    columnFilter        : {},
                    topIndex            : 0,
                    showFilterRow       : false,
                    sortColumn          : {'UpdatedDate': false},
                    itemActions         : [
                                            { id: 'view', label: 'ACTIONS.VIEW', icon: 'icon-magnify', privilege: 'GetSellerCustomerDetails', disabled: '!itm.Status', visible: true },
                                            { id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateCustomerStatusBulk:true', disabled: false, visible: 'itm.Status',
                                                requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                                            { id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateCustomerStatusBulk:true', disabled: false, visible: '!itm.Status',
                                                requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
                                        ],
                    listActions         : [
                                            { id: 'delete', label: 'ACTIONS.DELETE_BULK', icon: 'icon-delete', privilege: 'UpdateCustomerStatusBulk:true', disabled: '{selected: true, Status: 1}', visible: true,
                                                requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                                            { id: 'activate', label: 'ACTIONS.ACTIVATE_BULK', icon: 'icon-undo-variant', privilege: 'UpdateCustomerStatusBulk:true', disabled: '{selected: true, Status: 0}', visible: true,
                                                requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
                                        ],
                    fabAction           : {id: 'add', label: 'ACTIONS.ADD', icon: 'icon-link', privilege: 'UpdateCustomereAssortment:true', visible: true}
                },
                privileges: {
                    list    : 'GetAssortmentDetails'
                }
            }

        };

		function activateCustomers(records, allRecords, model, actionType, parentId, activeCatalogId) {
            var itemsNameList = [];
            if(!angular.isArray(records)){
                records = utility.pushItemToArray(records);
            }
            angular.forEach(records, function(record) {
                itemsNameList.push(record[model.lookupDisplayField]);
                //if undelete action, change record status to 1
                if(record.Status === 0){ //since decided to filter out deactivated records if condition will never get executed
                    utility.filterObject(allRecords, {CustomerId: record.CustomerId}, true)[0].Status = 1;
                }
                //if delete action change record status to 0
                else{
                    utility.filterObject(allRecords, {CustomerId: record.CustomerId}, true)[0].Status = 0;
                }
            });
            //keep the active records since the WEB API required the actived records to be send as part of request object otherwise they will gets deactivated
            var activeRecords = utility.filterObject(allRecords, {Status: 1});
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var isBulk = itemsNameList.length > 1 ? true : false;
            var logData = activityLogger.createLogData(itemsNameList, state, 'assortments.customers', actionType.toUpperCase(), isBulk, new Date(), null, null);
			var promise = api.webPut(api.baseUrl + '/catalogs/' + activeCatalogId + '/assortments/' + parentId + '/customerassortments', activeRecords);

             promise.then(function() {
                crud.onRecordStatusChange(records, model, actionType);
            });

            return activityLogger.log(logData, promise);
		}

        function createCustomer(data, assortmentId, activeCatalogId) {
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var isBulk = data.requestObj.length > 0 ? true: false;
            var logData = activityLogger.createLogData(data.itemsNameList, state, 'assortments.customers', 'ADD', isBulk, new Date(), null, null);
			var promise = api.webPut(api.baseUrl + '/catalogs/' + activeCatalogId + '/assortments/' + assortmentId + '/customerassortments', data.requestObj);

            promise.then(function() {
               api.assortments.customers.isDirty = true;
            });
            return activityLogger.log(logData, promise);
		}

    }
})();
(function() {
    'use strict';

    angular
        .module('app.main.assortments.articles')
        .run(runBlock);

    /* @ngInject */
    function runBlock(api, activityLogger, $state, utility, crud) {

        if (angular.isUndefined(api.assortments)) {
            api.assortments = {};
        }
         api.assortments.articles = {
            fields: [
                { field: 'Id', type: 'int', displayLabel: 'ARTICLES.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ArticleId', type: 'text', displayLabel: 'ARTICLES.FIELDS.ARTICLE_ID', visible: true, creatable: true, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ArticleNumber', type: 'text', displayLabel: 'ARTICLES.FIELDS.ARTICLE_NUMBER', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ArticleName', type: 'text', displayLabel: 'ARTICLES.FIELDS.MODEL_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: 100, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Status', type: 'text', displayLabel: 'ARTICLES.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedDate', type: 'text', displayLabel: 'ARTICLES.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedDate', type: 'text', displayLabel: 'ARTICLES.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedBy', type: 'text', displayLabel: 'ARTICLES.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedBy', type: 'text', displayLabel: 'ARTICLES.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }

            ],
            uniqueConstraints: [
                {name: 'Constraint 1', fields: ['ArticleNumber']}
            ],
            idField: 'ArticleId',
            lookupDisplayField: 'ArticleName',
            isDirty: false,
            methods: {
                activateBulk    : activateArticles,
                create          : createArticle
            },
            views: {
                mainList: {
                    columns         : [ 'ArticleNumber', 'ArticleName', 'Status', 'UpdatedDate' ],
                    columnFilter    : {},
                    topIndex        : 0,
                    showFilterRow   : false,
                    sortColumn      : {'UpdatedDate': false},
                    itemActions     : [
                                        { id: 'view', label: 'ACTIONS.VIEW', icon: 'icon-magnify', privilege: 'GetCatalogArticleDetails', disabled: '!itm.Status', visible: true },
                                        { id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateArticleAssortment:true', disabled: false, visible: 'itm.Status',
                                            requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                                        { id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateArticleAssortment:true', disabled: false, visible: '!itm.Status',
                                            requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
                                      ],
                    listActions     : [
                                        { id: 'delete', label: 'ACTIONS.DELETE_BULK', icon: 'icon-delete', privilege: 'UpdateArticleAssortment:true', disabled: '{selected: true, Status: 1}', visible: true,
                                            requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                                        { id: 'activate', label: 'ACTIONS.ACTIVATE_BULK', icon: 'icon-undo-variant', privilege: 'UpdateArticleAssortment:true', disabled: '{selected: true, Status: 0}', visible: true,
                                            requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}

                                      ],
                    fabAction       :
                                        {id: 'add', label: 'ACTIONS.ADD', icon: 'icon-link', privilege: 'UpdateArticleAssortment:true', visible: true}

                 },
                privileges: {
                    list    : 'GetAssortmentDetails'
                }
            }
        };

        function activateArticles(records, allRecords, model, actionType, parentId, activeCatalogId) {
            var itemsNameList = [];
            if(!angular.isArray(records)){
                records = utility.pushItemToArray(records);
            }
            angular.forEach(records, function(record) {
                itemsNameList.push(record[model.lookupDisplayField]);
                //if undelete action, change record status to 1
                if(record.Status === 0){
                    utility.filterObject(allRecords, {Id: record.Id})[0].Status = 1;
                }
                //id delete action change record status to 0
                else{
                    utility.filterObject(allRecords, {Id: record.Id})[0].Status = 0;
                }
            });
            var activeRecords = utility.filterObject(allRecords, {Status: 1});
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var isBulk = itemsNameList.length > 1 ? true : false;
            var logData = activityLogger.createLogData(itemsNameList, state, 'assortments.articles', actionType.toUpperCase(), isBulk, new Date(), null, null);
			var promise = api.webPut(api.baseUrl + '/catalogs/' + activeCatalogId + '/assortments/' + parentId + '/articleassortments', activeRecords);

             promise.then(function() {
                crud.onRecordStatusChange(records, model, actionType);
            });

            return activityLogger.log(logData, promise);
		}

        function createArticle(data, assortmentId, activeCatalogId) {
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var isBulk = data.requestObj.length > 0 ? true: false;
            var logData = activityLogger.createLogData(data.itemsNameList, state, 'assortments.articles', 'ADD', isBulk, new Date(), null, null);
			var promise = api.webPut(api.baseUrl + '/catalogs/' + activeCatalogId + '/assortments/' + assortmentId + '/articleassortments', data.requestObj);

            promise.then(function() {
               api.assortments.articles.isDirty = true;
            });
            return activityLogger.log(logData, promise);
		}
    }
})();
(function() {
    'use strict';

    angular
        .module('app.main.catalogs.articles.sizes')
        .run(runBlock);

    /* @ngInject */
    function runBlock(api, activityLogger, $state, $document, $filter, utility, crud, catalogFactory, dialog) {

        if (angular.isUndefined(api.articles)) {
            api.articles = {};
        }
         api.articles.sizes = {
            modelPath: 'articles.sizes',
            fields: [
                { field: 'Id', type: 'int', displayLabel: 'SIZES.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'SizeIndex', type: 'text', displayLabel: 'SIZES.FIELDS.SIZE_INDEX', visible: true, creatable: true, editable: false, inputType: 'text',
                    validation: {isRequired: true, maxLen: 25, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'NewSizeIndex', type: 'text', displayLabel: 'SIZES.FIELDS.SIZE_INDEX', visible: false, creatable: false, editable: true, inputType: 'text',
                    validation: {isRequired: false, maxLen: 25, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'SizeName', type: 'text', displayLabel: 'SIZES.FIELDS.SIZE_NAME', visible: true, creatable: true, editable: false, inputType: 'text',
                    validation: {isRequired: true, maxLen: 50, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'NewSizeName', type: 'text', displayLabel: 'SIZES.FIELDS.SIZE_NAME', visible: false, creatable: false, editable: true, inputType: 'text',
                    validation: {isRequired: false, maxLen: 50, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Upc', type: 'text', displayLabel: 'SIZES.FIELDS.UPC', visible: true, creatable: true, editable: true, inputType: 'text',
                    validation: {isRequired: false, maxLen: 25, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Status', type: 'text', displayLabel: 'SIZES.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'SortOrder', type: 'int', displayLabel: 'SIZES.FIELDS.SORT_ORDER', visible: true, creatable: true, editable: true, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedDate', type: 'text', displayLabel: 'SIZES.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedDate', type: 'text', displayLabel: 'SIZES.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedBy', type: 'text', displayLabel: 'SIZES.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedBy', type: 'text', displayLabel: 'SIZES.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
            ],
            title: 'SIZES.NAV',
            icon: 'icon-layers',
            idField: 'Id',
            lookupDisplayField: 'SizeName',
            isDirty: false,
            isCatalogSpecificModel: true,
            methods: {
                getList         :   getArticleSizes,
                activateBulk    :   activateSizes,
                create          :   createArticleSize,
                update          :   updateArticleSize
            },
            views: {
                mainList: {
                    columns         : [ 'ArticleNumber', 'SizeName', 'SizeIndex', 'SortOrder', 'Status', 'UpdatedDate' ],
                    columnFilter    : {},
                    toggleFilterProps: { toggleStatus:false, filterProp:'Status', trueVal:1, trueValTooltipMessage: 'ACTIONS.TOGGLE_ACTIVE', falseVal:'', falseValTooltipMessage:"ACTIONS.TOGGLE_ALL"},
                    topIndex        : 0,
                    showFilterRow   : false,
                    sortColumn      : {'UpdatedDate': false},
                    itemActions     : [
                                        { id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UpdateCatalogArticleSizes:true', disabled: '!itm.Status || itm.CatalogTypeId != 1', visible: true },
                                        { id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateArticleSizeStatusBulk:true', disabled: false, visible: 'itm.Status',
                                            requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                                        { id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateArticleSizeStatusBulk:true', disabled: false, visible: '!itm.Status',
                                            requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
                                      ],
                    listActions     : [
                                        { id: 'delete', label: 'ACTIONS.DELETE_BULK', icon: 'icon-delete', privilege: 'UpdateArticleSizeStatusBulk:true', disabled: '{selected: true, Status: 1}', visible: true,
                                            requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                                        { id: 'activate', label: 'ACTIONS.ACTIVATE_BULK', icon: 'icon-undo-variant', privilege: 'UpdateArticleSizeStatusBulk:true', disabled: '{selected: true, Status: 0}', visible: true,
                                            requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
                                      ],
                    fabAction       : { id: 'add', label: 'ACTIONS.ADD', icon: 'icon-plus', privilege: 'CreateCatalogArticleSizes:true', visible: true }

                 },
                 mainDetails: {},
                privileges: {
                    list    : 'GetArticleSizes'
                }
            }
        };

        // Not supported for lookup
        function getArticleSizes(generalProperties, articleId, catalogId) {
            var promise;

            if(angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
                var state = {};
                state.name = $state.current.name;
                state.params = $state.params;
                var isBulk = true;
                var logData = activityLogger.createLogData(null, state, 'articles.sizes', 'VIEW', isBulk, new Date(), null, null);

                promise = api.webGet(api.baseUrl + '/catalogs/' + catalogId + '/articles/' + articleId + '/sizes',
                generalProperties.config || {}, true, generalProperties.forceFetch,
                generalProperties.supportIncrementalResult || true,
                generalProperties.modelIdField,
                generalProperties.isMajor || false,
                generalProperties.model || api.articles.sizes);
                promise = activityLogger.log(logData, promise);
            }
            else {
                promise = api.webGet(api.baseUrl + '/catalogs/' + catalogId + '/articles/' + articleId + '/sizes',
                generalProperties.config || {}, true, generalProperties.forceFetch,
                generalProperties.supportIncrementalResult || true,
                generalProperties.modelIdField,
                generalProperties.isMajor || false,
                generalProperties.model || api.articles.sizes);
            }

            promise.then(function() {
                if (api.articles.sizes.isDirty) {
                    //Invalidate lookupData
                    api.articles.sizes.lookupData = undefined;
                    api.articles.sizes.isDirty = false;
                }
            });
            return promise;
        }

        function activateSizes(records, model, actionType, parentId, additionalInfo) {
            var requestBody = {
                Sizes: [],
            };
            var activeCatalogId = catalogFactory.getActiveCatalog().CatalogCode;
            var result = crud.createRequestObject(records, model, actionType);

            requestBody.Sizes = result.requestObj;

            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var isBulk = result.itemsNameList.length > 1 ? true : false;
            var logData = activityLogger.createLogData(result.itemsNameList, state, 'articles.sizes', actionType.toUpperCase(), isBulk, new Date(), null, null);
			var promise = api.webPut(api.baseUrl + '/catalogs/' + activeCatalogId + '/articles/' + parentId + '/sizes/status', requestBody);

             promise.then(function(response) {

                if(response.status === 202) {
                    dialog.showAlertDialog(
                        angular.element($document.body),
                        $filter('translate')('MESSAGES.TITLE.ALERT'),
                        $filter('translate')('MESSAGES.CONTENT.CHANGE_REQUEST_ALERT'),
                        $filter('translate')('MESSAGES.TITLE.ALERT'),
                        $filter('translate')('ACTIONS.DIALOG_CLOSE'),
                        true,
                        null);
                }
                else {
                    crud.onRecordStatusChange(records, model, actionType, undefined, additionalInfo);
                }
            });

            return activityLogger.log(logData, promise);
		}

        function createArticleSize(record, parentId) {
            var requestBody = {
                Sizes: []
            };
            requestBody.Sizes = utility.pushItemToArray(record);
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var logData = activityLogger.createLogData(record[api.articles.sizes.lookupDisplayField], state, 'articles.sizes', 'ADD', false, new Date(), null, null);
			var promise = api.webPost(api.baseUrl + '/catalogs/' + record.activeCatalogId + '/articles/' + parentId + '/sizes', requestBody);

            promise.then(function() {
                api.articles.sizes.isDirty = true;
            });
            return activityLogger.log(logData, promise);
        }

        function updateArticleSize(recordId, record, parentId) {
            var requestBody = {
                Sizes: []
            };
            // If there is no changes in SizeIndex or SizeName discard NewSizeIndex and NewSizeName since API is not accepting
            if(record.SizeIndex === record.NewSizeIndex){
                delete record.NewSizeIndex;
            }
            if(record.SizeName === record.NewSizeName){
                delete record.NewSizeName;
            }

            requestBody.Sizes = utility.pushItemToArray(record);

            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var logData = activityLogger.createLogData(record[api.articles.sizes.lookupDisplayField], state, 'articles.sizes', 'EDIT', false, new Date(), null, null);
			var promise = api.webPut(api.baseUrl + '/catalogs/' + parentId.activeCatalogId + '/articles/' + parentId.ArticleId + '/sizes', requestBody);

            promise.then(function() {
                api.articles.sizes.isDirty = true;
            });
            return activityLogger.log(logData, promise);
		}

    }
})();
(function() {
    'use strict';

    angular
        .module('app.main.catalogs.articles.segmentation')
        .run(runBlock);

    /* @ngInject */
    function runBlock(api, activityLogger, $state, $q, crud, catalogFactory) {

        if (angular.isUndefined(api.articles)) {
            api.articles = {};
        }
         api.articles.segmentation = {
            modelPath: 'articles.segmentation',
            fields: [
                { field: 'SegmentationId', type: 'int', displayLabel: 'SEGMENTATION.FIELDS.SEGMENTATION_ID', visible: false, creatable: true, editable: true, inputType: 'lookup', lookupSource:'catalogs.segmentations',
                    lookupFilter: {'Status': 1}, validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'SegmentationId', type: 'int', displayLabel: 'SEGMENTATION.FIELDS.SEGMENTATION_ID', visible: true, creatable: false, editable: false, inputType: 'number',
                    lookupFilter: {'Status': 1}, validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Name', type: 'text', displayLabel: 'SEGMENTATION.FIELDS.NAME', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Status', type: 'text', displayLabel: 'SEGMENTATION.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CatalogSegmentationStatus', type: 'text', displayLabel: 'SEGMENTATION.FIELDS.CATALOG_SEGMENTATION_STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedDate', type: 'text', displayLabel: 'SEGMENTATION.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedDate', type: 'text', displayLabel: 'SEGMENTATION.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedBy', type: 'text', displayLabel: 'SEGMENTATION.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedBy', type: 'text', displayLabel: 'SEGMENTATION.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'PlanningValue', type: 'text', displayLabel: 'SEGMENTATION.FIELDS.PLANNING_VALUE', visible: false, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'IsOutOfParentSegmentation', type: 'text', displayLabel: 'SEGMENTATION.FIELDS.OUT_OF_PARENT_SEGMENTATION', visible: true, creatable: false, editable: false, inputType: 'bool-int',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
            ],
            title: 'SEGMENTATION.NAV',
            icon: 'icon-cube-unfolded',
            idField: 'SegmentationId',
            lookupDisplayField: 'Name',
            isDirty: false,
            isCatalogSpecificModel: true,
            methods: {
                getList     : getArticleSegmentations,
                activateBulk: activateSegmentations,
                create      : createArticleSegmentation
            },
            views: {
                mainList: {
                    columns         : [ 'Name', 'Status', 'CatalogSegmentationStatus', 'UpdatedDate'],
                    columnFilter    : {},
                    topIndex        : 0,
                    showFilterRow   : false,
                    sortColumn      : {'UpdatedDate': false},
                    itemActions     : [
                                        { id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateArticleBulkSegmentationStatus:true', disabled: '!itm.CatalogSegmentationStatus || itm.Name ==="Open" || itm._nonEditable', visible: 'itm.Status',
                                            requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                                        { id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateArticleBulkSegmentationStatus:true', disabled: '!itm.CatalogSegmentationStatus || itm.Name ==="Open"', visible: '!itm.Status',
                                            requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
                                      ],
                    listActions     : [ // SegmentationId: 0 is Open segmentation which is added internally
                                        { id: 'delete', label: 'ACTIONS.DELETE_BULK', icon: 'icon-delete', privilege: 'UpdateArticleBulkSegmentationStatus:true', disabled: '{selected: true, Status: 1, CatalogSegmentationStatus: 1, SegmentationId: ["!0"], _nonEditable: ["!1"]}', visible: true,
                                            requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                                        { id: 'activate', label: 'ACTIONS.ACTIVATE_BULK', icon: 'icon-undo-variant', privilege: 'UpdateArticleBulkSegmentationStatus:true', disabled: '{selected: true, Status: 0, CatalogSegmentationStatus: 1, SegmentationId: ["!0"]}', visible: true,
                                            requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
                                      ],
                    // assigns through the partial update API, which is guarded by UpdateCatalogArticleSegmentations (4074)
                    fabAction       : {id: 'add', label: 'ACTIONS.ADD', icon: 'icon-link', privilege: 'UpdateCatalogArticleSegmentations:true', visible: true}
                 },
                 mainDetails: {},
                 privileges: {
                     list: 'GetCatalogArticleSegmentationList'
                 }
            }
        };

        // Not supported for lookup (getLookupData implementation need to be modified)
        function getArticleSegmentations(generalProperties, articleId, catalogId) {
            var promise;

            if(angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
                var state = {};
                state.name = $state.current.name;
                state.params = $state.params;
                var isBulk = true;
                var logData = activityLogger.createLogData(null, state, 'articles.segmentation', 'VIEW', isBulk, new Date(), null, null);

                promise = api.webGet(api.baseUrl + '/catalogs/' + catalogId + '/articles/' + articleId + '/segmentations',
                generalProperties.config || {}, true, generalProperties.forceFetch,
                generalProperties.supportIncrementalResult || true,
                generalProperties.modelIdField,
                generalProperties.isMajor || false,
                generalProperties.model || api.articles.segmentation);
                promise = activityLogger.log(logData, promise);
            }
            else {
                promise = api.webGet(api.baseUrl + '/catalogs/' + catalogId + '/articles/' + articleId + '/segmentations',
                generalProperties.config || {}, true, generalProperties.forceFetch,
                generalProperties.supportIncrementalResult || true,
                generalProperties.modelIdField,
                generalProperties.isMajor || false,
                generalProperties.model || api.articles.segmentation);
            }

            promise.then(function() {
                if (api.articles.segmentation.isDirty) {
                    //Invalidate lookupData
                    api.articles.segmentation.lookupData = undefined;
                    api.articles.segmentation.isDirty = false;
                }
            });
            return promise;
		}

        function activateSegmentations(records, model, actionType, parentIds) {
            var result = crud.createRequestObject(records, model, actionType);
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var isBulk = result.itemsNameList.length > 1 ? true : false;
            var logData = activityLogger.createLogData(result.itemsNameList, state, 'articles.segmentation', actionType.toUpperCase(), isBulk, new Date(), null, null);
			var promise = api.webPut(api.baseUrl + '/catalogs/' + parentIds.activeCatalogId + '/articles/' + parentIds.articleId + '/segmentations/status', result.requestObj);

             promise.then(function() {
                api.catalogArticles.segmentation.isDirty = true;
            });

            return activityLogger.log(logData, promise);
		}

        /**
         * Assigns segmentation(s) to a single article through the partial update API
         * (PUT .../articlesegmentations/update). Only the segmentations being added are sent, each with
         * an explicit Status 1; the ones the article already has are omitted and left as they are.
         * Previously the article's whole set was restated on every assign, which made an assign able to
         * unassign restricted or deactivated segmentations as a side effect.
         *
         * @param {object} record          the segmentation picked in the dialog. SegmentationId 0 is the
         *                                 virtual 'Open' option, meaning "assign every catalog segmentation".
         * @param {array}  assignedRecords the article's current segmentations. Read to skip what the article
         *                                 already has, and appended with the new assignments so the dialog's
         *                                 'available' list stays correct for a Save & New.
         */
        function createArticleSegmentation(record, assignedRecords) {
            var isSegmentationPlanningEnable = catalogFactory.getActiveCatalog().SegmentationPlanningEnable === 1 ? true : false;
            // null leaves the stored planning value untouched, which is what a planning-disabled catalog
            // wants: the dialog never showed the user a value to save
            var planningValue = isSegmentationPlanningEnable ? (record.PlanningValue || api.getSegmentationPlanningDefault()) : null;

            var newAssignments = [];
            if (record.SegmentationId === 0) {
                // 'Open' is the only multi-segmentation case: it assigns every catalog segmentation the
                // current role is allowed to see, skipping the ones the article already has so their
                // stored planning value is not overwritten with the one picked in the dialog.
                var assignedSegmentationIds = {};
                angular.forEach(assignedRecords, function(assignedRecord) {
                    if (assignedRecord.Status === 1) {
                        assignedSegmentationIds[assignedRecord[api.articles.segmentation.idField]] = true;
                    }
                });
                var catalogSegmentations = catalogFactory.removeRestrictedSegmentations(
                    catalogFactory.getActiveCatalogDetails().CatalogSegmentationList || [],
                    api.roleBasedRestrictions.restrictedSegmentationsArray);
                angular.forEach(catalogSegmentations, function(segmentation) {
                    if (!assignedSegmentationIds[segmentation.Id]) {
                        newAssignments.push({SegmentationId: segmentation.Id, Name: segmentation.Name, Status: 1});
                    }
                });

                // the endpoint rejects an empty list, and there is nothing to save anyway
                if (!newAssignments.length) {
                    return $q.when({data: []});
                }
            } else {
                // the dropdown is single-select and already excludes assigned segmentations, so the pick is the payload
                newAssignments.push({SegmentationId: record.SegmentationId, Name: record[api.articles.segmentation.lookupDisplayField], Status: 1});
            }

            var requestObj = [];
            angular.forEach(newAssignments, function(assignment) {
                requestObj.push({SegmentationId: assignment.SegmentationId, Status: 1, PlanningValue: planningValue});
            });

            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var logData = activityLogger.createLogData(record[api.articles.segmentation.lookupDisplayField], state, 'articles.segmentation', 'ADD', false, new Date(), null, null);
			var promise = api.webPut(api.baseUrl + '/catalogs/' + record.activeCatalogCode + '/articles/' + record.articleId + '/articlesegmentations/update', requestObj);

            promise.then(function() {
               api.articles.segmentation.isDirty = true;
               api.catalogArticles.segmentation.isDirty = true;
               Array.prototype.push.apply(assignedRecords, newAssignments);
            });
            return activityLogger.log(logData, promise);
		}
    }
})();
(function() {
    'use strict';

    angular
        .module('app.main.catalogs.articles.resources')
        .run(runBlock);

    /* @ngInject */
    function runBlock(api, activityLogger, $state, utility, crud) {

        if (angular.isUndefined(api.articles)) {
            api.articles = {};
        }
         api.articles.resources = {
            modelPath: 'articles.resources',
            fields: [
                { field: 'IsSeasonal', type: 'text', displayLabel: 'RESOURCES.FIELDS.IS_SEASONAL', visible: true, creatable: false, editable: false, inputType: 'bool-int',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Id', type: 'int', displayLabel: 'RESOURCES.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ArticleId', type: 'int', displayLabel: 'RESOURCES.FIELDS.ARTICLE_ID', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ArticleNumber', type: 'text', displayLabel: 'RESOURCES.FIELDS.ARTICLE_NUMBER', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ArticleName', type: 'text', displayLabel: 'ARTICLES.FIELDS.MODEL_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ResourceId', type: 'int', displayLabel: 'RESOURCES.FIELDS.RESOURCE_ID', visible: false, creatable: true, editable: false, inputType: 'lookup', lookupSource: 'catalogs.resources',
                    lookupFilter: {Status: 1}, validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ResourceId', type: 'int', displayLabel: 'RESOURCES.FIELDS.RESOURCE_ID', visible: true, creatable: false, editable: false, inputType: 'number',
                    lookupFilter: {Status: 1}, validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'RefResourceId', type: 'int', displayLabel: 'RESOURCES.FIELDS.REF_RESOURCE_ID', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'TypeId', type: 'text', displayLabel: 'RESOURCES.FIELDS.RESOURCE_TYPE_ID', visible: true, creatable: false, editable: false, inputType: 'lookup', lookupSource: 'lists.resourceTypes',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ResourceName', type: 'text', displayLabel: 'RESOURCES.FIELDS.RESOURCE_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'FileName', type: 'text', displayLabel: 'RESOURCES.FIELDS.FILE_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'FilePath', type: 'text', displayLabel: 'RESOURCES.FIELDS.FILE_PATH', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Status', type: 'text', displayLabel: 'RESOURCES.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Description', type: 'text', displayLabel: 'RESOURCES.FIELDS.DESCRIPTION', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: 2000, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Category', type: 'text', displayLabel: 'RESOURCES.FIELDS.CATEGORY', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: 1000, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'SortOrder', type: 'int', displayLabel: 'RESOURCES.FIELDS.SORT_ORDER', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedDate', type: 'text', displayLabel: 'RESOURCES.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedDate', type: 'text', displayLabel: 'RESOURCES.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedBy', type: 'text', displayLabel: 'RESOURCES.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedBy', type: 'text', displayLabel: 'RESOURCES.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
            ],
            uniqueConstraints: [],
            title: 'RESOURCES.NAV',
            icon: 'icon-image-filter-black-white',
            idField: 'ResourceId',
            lookupDisplayField: 'ResourceName',
            isDirty: false,
            isCatalogSpecificModel: true,
            methods: {
                getList     : getArticleResources,
                activateBulk: unassignResources,
                create      : assignResources
            },
            views: {
                mainList: {
                    columns         : [ 'ResourceName', 'ResourceId', 'IsSeasonal', 'ResourceTypeId', 'Status', 'UpdatedDate' ],
                    columnFilter    : {},
                    topIndex        : 0,
                    showFilterRow   : false,
                    sortColumn      : {'UpdatedDate': false},
                    itemActions     : [
                                        { id: 'view', label: 'ACTIONS.VIEW', icon: 'icon-magnify', privilege: 'GetCatalogResourceDetails', disabled: '!itm.Status', visible: true },
                                        { id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'AssignResourceToArticles:true', disabled: false, visible: 'itm.Status',
                                            requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                                        { id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'AssignResourceToArticles:true', disabled: false, visible: false,
                                            requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
                                      ],
                    listActions     : [
                                        { id: 'delete', label: 'ACTIONS.DELETE_BULK', icon: 'icon-delete', privilege: 'AssignResourceToArticles:true', disabled: '{selected: true, Status: 1}', visible: true,
                                            requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                                        { id: 'activate', label: 'ACTIONS.ACTIVATE_BULK', icon: 'icon-undo-variant', privilege: 'AssignResourceToArticles:true', disabled: '{selected: true, Status: 0}', visible: false,
                                            requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
                                      ],
                    fabAction       : {id: 'add', label: 'ACTIONS.ADD', icon: 'icon-link', privilege: 'AssignResourceToArticles:true', visible: true}
                 },
                 mainDetails: {},
                privileges: {
                    list    : 'GetCatalogArticleResourcesList',
                    details : 'GetCatalogResourceDetails'
                }
            }
        };


        function getArticleResources(generalProperties, articleId, catalogId) {
            var promise;

            if(angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
                var state = {};
                state.name = $state.current.name;
                state.params = $state.params;
                var isBulk = true;
                var logData = activityLogger.createLogData(null, state, 'articles.resources', 'VIEW', isBulk, new Date(), null, null);

                promise = api.webGet(api.baseUrl + '/catalogs/' + catalogId + '/articles/' + articleId + '/resources', undefined, true, generalProperties.forceFetch);
                promise = activityLogger.log(logData, promise);
            }
            else {
                promise = api.webGet(api.baseUrl + '/catalogs/' + catalogId + '/articles/' + articleId + '/resources', undefined, true, generalProperties.forceFetch);
            }

            promise.then(function() {
                if (api.articles.resources.isDirty) {
                    //Invalidate lookupData
                    api.articles.resources.lookupData = undefined;
                    api.articles.resources.isDirty = false;
                }
            });
            return promise;
        }

        // Since filtering inactive resources this method will only un-assign resource(s)
		function unassignResources(records, assignedResources, model, actionType, parentId, activeCatalogCode) {
            var requestObj = {};
            var itemsNameList = [];
            requestObj[model.idField] = [];
            requestObj[model.idField] = assignedResources.map(function(assignedResource) {
                return assignedResource[model.idField];
            });

            if(!angular.isArray(records)) {
                records = utility.pushItemToArray(records);
            }

            angular.forEach(records, function(recordToBeDeleted) {
                itemsNameList.push(recordToBeDeleted[model.lookupDisplayField]);
                var index = requestObj[model.idField].indexOf(recordToBeDeleted[model.idField]);
                requestObj[model.idField].splice(index,1);
            });

            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var isBulk = itemsNameList.length > 1 ? true : false;
            var logData = activityLogger.createLogData(itemsNameList, state, 'articles.resources', actionType.toUpperCase(), isBulk, new Date(), null, null);
            var promise = api.webPut(api.baseUrl + '/catalogs/' + activeCatalogCode + '/articles/' + parentId + '/assignresources', requestObj);

             promise.then(function() {
                crud.onRecordStatusChange(records, model, actionType);
            });

            return activityLogger.log(logData, promise);
		}

		function assignResources(record, assignedResources) {
            var requestObj = {};
            var assigned = [];
            assigned = assignedResources.map(function(assignedResource) {
                return assignedResource[api.articles.resources.idField];
            });
            requestObj[api.articles.resources.idField] = [];
            requestObj[api.articles.resources.idField] = assigned.concat(record[api.articles.resources.idField]);

            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var logData = activityLogger.createLogData(record[api.articles.resources.lookupDisplayField], state, 'articles.resources', 'ADD', false, new Date(), null, null);
            var promise = api.webPut(api.baseUrl + '/catalogs/' + record.activeCatalogId + '/articles/' + record.articleId + '/assignresources', requestObj);

            promise.then(function() {
               api.articles.resources.isDirty = true;
            });
            return activityLogger.log(logData, promise);
		}
    }
})();
(function() {
		'use strict';
		
		angular
				.module('app.main.catalogs.articles.relations', [])
				.config(config);

		/* @ngInject */
		function config($translatePartialLoaderProvider) {

				// Translation
				$translatePartialLoaderProvider.addPart('app/main/catalogs/sub-modules/articles/details/tabs/relations');
		}
})();
(function() {
		'use strict';

		angular
				.module('app.main.catalogs.articles.relations')
				.run(runBlock);

		/* @ngInject */
		function runBlock(api, activityLogger, $state, crud, catalogFactory) {

			if (angular.isUndefined(api.articles)) {
					api.articles = {};
			}
			api.articles.articleRelations = {
					modelPath: 'articles.articleRelations',
					fields: [
							{ field: 'Id', type: 'int', displayLabel: 'RELATIONS.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
									validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
							{ field: 'EntityId', type: 'int', displayLabel: 'RELATIONS.FIELDS.ENTITY', visible: false, creatable: true, editable: false, inputType: 'lookup', lookupSource:'lists.relationsEntityList',
									validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
							{ field: 'RelationTypeId', type: 'int', displayLabel: 'RELATIONS.FIELDS.RELATION_TYPE_ID', visible: false, creatable: true, editable: false, inputType: 'lookup', lookupSource:'catalogs.relationTypes',
									validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
							{ field: 'RelationTypeName', type: 'text', displayLabel: 'RELATIONS.FIELDS.RELATION_TYPE_NAME', visible: true, creatable: false, editable: false,  inputType: 'text',
									validation: {isRequired: true, maxLen: 500, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
							{ field: 'RelatedObjectId', type: 'int', displayLabel: 'RELATIONS.FIELDS.RELATED_OBJECT_ID', visible: false, creatable: true, editable: false, inputType: 'lookup', lookupSource:'catalogs.articles',
									validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
							// Related is used internally
							{ field: 'Related', type: 'text', displayLabel: 'RELATIONS.FIELDS.RELATED', visible: true, creatable: false, editable: false, inputType: 'text',
									validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
							{ field: 'RelatedArticleName', type: 'text', displayLabel: 'RELATIONS.FIELDS.RELATED_NAME', visible: true, creatable: false, editable: false,  inputType: 'text',
									validation: {isRequired: true, maxLen: 500, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
							{ field: 'RelatedArticleNumber', type: 'text', displayLabel: 'RELATIONS.FIELDS.RELATED_NUMBER', visible: true, creatable: false, editable: false,  inputType: 'text',
									validation: {isRequired: true, maxLen: 500, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
							{ field: 'CreatedDate', type: 'text', displayLabel: 'RELATIONS.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
									validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
							{ field: 'UpdatedDate', type: 'text', displayLabel: 'RELATIONS.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
									validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
							{ field: 'CreatedBy', type: 'text', displayLabel: 'RELATIONS.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
									validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
							{ field: 'UpdatedBy', type: 'text', displayLabel: 'RELATIONS.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
									validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
					],
					uniqueConstraints: [],
					title: 'RELATIONS.NAV',
					icon: 'icon-image-filter-black-white',
					idField: 'Id',
					lookupDisplayField: 'Id',
					isDirty: false,
					isCatalogSpecificModel: true,
					methods: {
							getList         :   getRelations,
							create          :   createRelation,
							activateBulk    :   activateRelations
					},
					views: {
							mainList: {
									columns         : [ 'Id', 'Related', 'RelationTypeName', 'RelatedArticleName', 'RelatedArticleNumber', 'UpdatedBy', 'UpdatedDate'],
									columnFilter    : {},
									topIndex        : 0,
									showFilterRow   : false,
									sortColumn      : {'UpdatedDate': false},
									itemActions     : [
																			{ id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'DeleteObjectRelation', disabled: false, visible: true,
																					requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
																		],
									listActions     : [],
									fabAction       : { id: 'add', label: 'ACTIONS.ADD', icon: 'icon-plus', privilege: 'CreateObjectRelation:true', visible: true }
							},
							mainDetails: {},
							privileges: {
									list    : 'GetObjectRelationDetails'
							}
					}
			};

			function getRelations(generalProperties, objectId, catalogId) {
					var promise;

					if (angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
							promise = api.webGet(api.baseUrl + '/catalogs/' + catalogId + '/objects/' + objectId + '/relations?entityid=1', undefined, true, generalProperties.forceFetch);
					}
					else {
							promise = api.webGet(api.baseUrl + '/catalogs/' + catalogId + '/objects/' + objectId + '/relations?entityid=1', undefined, true, generalProperties.forceFetch);
					}

					promise.then(function () {
							if (api.articles.articleRelations.isDirty) {
									//Invalidate lookupData
									api.articles.articleRelations.lookupData = undefined;
									api.articles.articleRelations.isDirty = false;
							}
					});
					return promise;
			}

			function createRelation(record, articleId) {
				var state = {};
				state.name = $state.current.name;
				state.params = $state.params;
				var catalogCode = catalogFactory.getActiveCatalog().CatalogCode;
				var logData = activityLogger.createLogData(record[api.articles.articleRelations.lookupDisplayField], state, 'catalogs.relationTypes', 'ADD', false, new Date(), null, null);
				var promise = api.webPost(api.baseUrl + '/catalogs/' + catalogCode + '/relations/' + articleId, record);

				promise.then(function () {
					api.articles.articleRelations.isDirty = true;
				});
				return activityLogger.log(logData, promise);
			}

			function activateRelations(record, model, actionType, catalogCode) {
				var state = {};
				state.name = $state.current.name;
				state.params = $state.params;
				var isBulk = false;
				var logData = activityLogger.createLogData(record, state, 'catalogs.relationTypes', actionType.toUpperCase(), isBulk, new Date(), null, null);
				var promise = api.webDelete(api.baseUrl + '/catalogs/' + catalogCode + '/relations/' + record.Id);

				promise.then(function () {
					model.isDirty = true;
				});

				return activityLogger.log(logData, promise);
			}

	}
})();
(function() {
    'use strict';

    angular
        .module('app.main.catalogs.articles.prices')
        .run(runBlock);

    /* @ngInject */
    function runBlock(api, activityLogger, $state) {

        if (angular.isUndefined(api.articles)) {
            api.articles = {};
        }
         api.articles.prices = {
            modelPath: 'articles.prices',
            fields: [
                { field: 'Id', type: 'int', displayLabel: 'PRICES.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'PriceGroupId', type: 'int', displayLabel: 'PRICES.FIELDS.PRICEGROUP_ID', visible: false, creatable: true, editable: false, inputType: 'lookup', lookupSource:'catalogs.priceGroup',
                   lookupFilter: {Status: 1}, validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'PriceGroupId', type: 'int', displayLabel: 'PRICES.FIELDS.PRICEGROUP_ID', visible: true, creatable: false, editable: false, inputType: 'number',
                   lookupFilter: {Status: 1}, validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'articleId', type: 'int', displayLabel: 'PRICES.FIELDS.ARTICLE_ID', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Name', type: 'text', displayLabel: 'PRICES.FIELDS.NAME', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'price', type: 'int', displayLabel: 'PRICES.FIELDS.PRICE', visible: true, creatable: true, editable: true, inputType: 'decimal',
                    validation: {isRequired: false, maxLen: -1, minLen: 1, pattern: '^[+]?\\d+([.]\\d+)?$', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: 'VALIDATIONS.PRICE'}} },
                { field: 'IsEditable', type: 'int', displayLabel: 'PRICES.FIELDS.IS_EDITABLE', visible: true, creatable: false, editable: false, inputType: 'bool-int',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CurrencyCode', type: 'text', displayLabel: 'PRICES.FIELDS.CURRENCY', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedDate', type: 'text', displayLabel: 'PRICES.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedDate', type: 'text', displayLabel: 'PRICES.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedBy', type: 'text', displayLabel: 'PRICES.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedBy', type: 'text', displayLabel: 'PRICES.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
            ],
            title: 'PRICES.NAV',
            icon: 'icon-coin',
            idField: 'Id',
            lookupDisplayField: 'Name',
            isDirty: false,
            isCatalogSpecificModel: true,
            methods: {
                getList     : getPrices,
                create      : createArticlePrice,
                update      : updateArticlePrice
            },
            views: {
                mainList: {
                    columns         : [ 'PriceGroupId', 'Name', 'price', 'UpdatedDate'],
                    columnFilter    : {},
                    topIndex        : 0,
                    showFilterRow   : false,
                    sortColumn      : {'UpdatedDate': false},
                    itemActions     : [
                                        { id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UpdateCatalogBulkArticlePrices:true', disabled: 'itm.Locked', visible: true }
                                      ],
                    listActions     : [],
                    fabAction       : { id: 'add', label: 'ACTIONS.ADD', icon: 'icon-plus', privilege: 'CreateCatalogArticlePrice:true', visible: true}
                 },
                mainDetails: {},
                privileges: {
                    list    : 'GetCatalogArticlePricesList'
                }
            }
        };

        // Not supported for lookup
        function getPrices(generalProperties, articleId, catalogId) {
            var promise;

            if(angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
                var state = {};
                state.name = $state.current.name;
                state.params = $state.params;
                var isBulk = true;
                var logData = activityLogger.createLogData(null, state, 'articles.prices', 'VIEW', isBulk, new Date(), null, null);

                promise = api.webGet(api.baseUrl + '/catalogs/' + catalogId + '/articles/' + articleId + '/prices',
                generalProperties.config || {}, true, generalProperties.forceFetch,
                generalProperties.supportIncrementalResult || true,
                generalProperties.modelIdField,
                generalProperties.isMajor || false,
                generalProperties.model || api.articles.prices);
                promise = activityLogger.log(logData, promise);
            }
            else {
                promise = api.webGet(api.baseUrl + '/catalogs/' + catalogId + '/articles/' + articleId + '/prices',
                generalProperties.config || {}, true, generalProperties.forceFetch,
                generalProperties.supportIncrementalResult || true,
                generalProperties.modelIdField,
                generalProperties.isMajor || false,
                generalProperties.model || api.articles.prices);
            }

            promise.then(function() {
                if (api.articles.prices.isDirty) {
                    //Invalidate lookupData
                    api.articles.prices.lookupData = undefined;
                    api.articles.prices.isDirty = false;
                }
            });
            return promise;
		}

        function createArticlePrice(record, parentId, activeCatalogId) {
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var logData = activityLogger.createLogData(record[api.articles.prices.lookupDisplayField], state, 'articles.prices', 'ADD', false, new Date(), null, null);
			var promise = api.webPost(api.baseUrl + '/catalogs/' + activeCatalogId + '/articles/' + parentId + '/prices', record);

            promise.then(function() {
               api.articles.prices.isDirty = true;
               api.catalogs.prices.isDirty = true;//dirty prices model to see the create prices
            });
            return activityLogger.log(logData, promise);
		}

        function updateArticlePrice(recordId, record, parentId) {
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var logData = activityLogger.createLogData(record.PriceGroupId, state, 'articles.prices', 'EDIT', false, new Date(), null, null);
			var promise = api.webPut(api.baseUrl + '/catalogs/' + parentId + '/articles/' + record.ArticleId + '/prices/' + recordId, record);

            promise.then(function() {
               api.articles.prices.isDirty = true;
               api.catalogs.prices.isDirty = true;//dirty prices model to see the updated prices
            });
            return activityLogger.log(logData, promise);
		}
    }
})();
(function() {
    'use strict';
    
    angular
        .module('app.main.catalogs.articles.images', []);
})();
(function () {
	'use strict';

	angular
		.module('app.main.catalogs.articles.images')
		.run(runBlock);

	/* @ngInject */
	function runBlock(api) {

		if (angular.isUndefined(api.catalogs)) {
			api.catalogs = {};
		}
		api.catalogs.articleDuneImages = {
			modelPath: 'catalogs.articleDuneImages',
			fields: [
					{ field: 'Id', type: 'text', displayLabel: 'T1_DUNE.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'text',
							validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
					{ field: 'ImageSet', type: 'text', displayLabel: 'T1_DUNE.FIELDS.IMAGE_SET', visible: true, creatable: false, editable: false, inputType: 'text',
							validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
					{ field: 'ContextId', type: 'text', displayLabel: 'T1_DUNE.FIELDS.CONTEXT_ID', visible: true, creatable: false, editable: false, inputType: 'text',
							validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
					{ field: 'Key', type: 'text', displayLabel: 'T1_DUNE.FIELDS.KEY', visible: true, creatable: false, editable: false, inputType: 'text',
							validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
					{ field: 'FileName', type: 'text', displayLabel: 'T1_DUNE.FIELDS.FILE_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
							validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
					{ field: 'FilePath', type: 'text', displayLabel: 'T1_DUNE.FIELDS.FILE_PATH', visible: true, creatable: false, editable: false, inputType: 'text',
							validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
					{ field: 'SortOrder', type: 'int', displayLabel: 'T1_DUNE.FIELDS.SORT_ORDER', visible: true, creatable: false, editable: false, inputType: 'number',
							validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
					{ field: 'Status', type: 'text', displayLabel: 'T1_DUNE.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'bool',
							validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
					{ field: 'AssetHash', type: 'text', displayLabel: 'T1_DUNE.FIELDS.ASSET_HASH', visible: true, creatable: false, editable: false, inputType: 'text',
							validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
					{ field: 'ReferenceAssetId', type: 'text', displayLabel: 'T1_DUNE.FIELDS.REF_ASSET_ID', visible: true, creatable: false, editable: false, inputType: 'text',
							validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
					{ field: 'Format', type: 'text', displayLabel: 'T1_DUNE.FIELDS.FORMAT', visible: true, creatable: false, editable: false, inputType: 'text',
							validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
					{ field: 'Width', type: 'int', displayLabel: 'T1_DUNE.FIELDS.WIDTH', visible: true, creatable: false, editable: false, inputType: 'number',
							validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
					{ field: 'Height', type: 'int', displayLabel: 'T1_DUNE.FIELDS.HEIGHT', visible: true, creatable: false, editable: false, inputType: 'number',
							validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
					{ field: 'Density', type: 'int', displayLabel: 'T1_DUNE.FIELDS.DENSITY', visible: true, creatable: false, editable: false, inputType: 'number',
							validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
					{ field: 'Size', type: 'text', displayLabel: 'T1_DUNE.FIELDS.SIZE', visible: true, creatable: false, editable: false, inputType: 'text',
							validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
					{ field: 'StorageFile', type: 'text', displayLabel: 'T1_DUNE.FIELDS.STORAGE_FILE', visible: true, creatable: false, editable: false, inputType: 'text',
							validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
					{ field: 'CreatedOn', type: 'text', displayLabel: 'T1_DUNE.FIELDS.CREATED_ON', visible: true, creatable: false, editable: false, inputType: 'date',
							validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
					{ field: 'UpdatedOn', type: 'text', displayLabel: 'T1_DUNE.FIELDS.UPDATED_ON', visible: true, creatable: false, editable: false, inputType: 'date',
							validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
					{ field: 'CreatedBy', type: 'text', displayLabel: 'T1_DUNE.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'text',
							validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
					{ field: 'UpdatedBy', type: 'text', displayLabel: 'T1_DUNE.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'text',
							validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
					{ field: 'AssetTypeId', type: 'text', displayLabel: 'T1_DUNE.FIELDS.ASSET_TYPE', visible: false, creatable: false, editable: false, inputType: 'text',
							validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
					{ field: 'AssetTypeName', type: 'text', displayLabel: 'T1_DUNE.FIELDS.ASSET_TYPE', visible: true, creatable: false, editable: false, inputType: 'text',
							validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
			],
			uniqueConstraints: [],
			title: 'T1_DUNE.NAV',
			icon: 'icon-image-filter',
			idField: 'Id',
			lookupDisplayField: 'Id',
			isBulkActionCompleted: false,
			isDirty: false,
			isCatalogSpecificModel: true,
			methods: {},
			views: {
					mainList: {
							columns         : [ 'Id', 'ImageSet', 'ContextId', 'Key', 'FilePath', 'FileName', 'SortOrder', 'AssetTypeName', 'Status', 'UpdatedDate' ],
							columnFilter    : {},
							imagesSize      : 'large',
							topIndex        : 0,
							showFilterRow   : false,
							sortColumn      : {'UpdatedOn': false},
							itemActions     : [
																	{ id: 'view', label: 'ACTIONS.VIEW', icon: 'icon-magnify', privilege: 'UI_T1DuneReadAccess:true', disabled: '!itm.Status', visible: true },
																	{ id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UI_T1DuneReadWriteAccess:true', disabled: '!itm.Status', visible: true },
																	{ id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UI_T1DuneReadWriteAccess:true', disabled: false, visible: 'itm.Status',
																			requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
																	{ id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UI_T1DuneReadWriteAccess:true', disabled: false, visible: '!itm.Status',
																			requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}],
							listActions     : [
																	{ id: 'delete', label: 'ACTIONS.DELETE_BULK', icon: 'icon-delete', privilege: 'UI_T1DuneReadWriteAccess:true', disabled: '{selected: true, Status: 1}', visible: true,
																			requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
																	{ id: 'activate', label: 'ACTIONS.ACTIVATE_BULK', icon: 'icon-undo-variant', privilege: 'UI_T1DuneReadWriteAccess:true', disabled: '{selected: true, Status: 0}', visible: true,
																			requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
																],
							fabAction       : {id: 'add', label: 'ACTIONS.ADD', icon: 'icon-plus', privilege: 'UI_T1DuneReadWriteAccess:true', visible: true}
					 },
					 mainDetails: {
							 selectedTabIndex   : 0,
							 itemActions        : [
																		{ id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UI_T1DuneReadWriteAccess:true', disabled: '{selected: true, Status: 1}', visible: true,
																				requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
																		{ id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UI_T1DuneReadWriteAccess:true', disabled: '{selected: true, Status: 0}', visible: true,
																				requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
							 ],
							 fab                 : {id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UI_T1DuneReadWriteAccess:true', visible: true}

					 },
					privileges: {
							list    : 'UI_T1DuneReadAccess',
							details : 'UI_T1DuneReadAccess'
					}
				}
		};

	}
})();
(function() {
    'use strict';
    
    angular
        .module('app.main.catalogs.articles.crds', []);
})();
(function() {
    'use strict';

    angular
        .module('app.main.catalogs.articles.crds')
        .run(runBlock);

    /* @ngInject */
    function runBlock(api, activityLogger, $state, utility, crud) {

        if (angular.isUndefined(api.articles)) {
            api.articles = {};
        }
         api.articles.crds = {
            modelPath: 'articles.crds',
            fields: [
                { field: 'ArticleId', map:'Id', type: 'int', displayLabel: 'CRD.FIELDS.ARTICLE_ID', visible: false, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ArticleNumber', type: 'text', displayLabel: 'ARTICLES.FIELDS.ARTICLE_NUMBER', visible: false, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Id', type: 'int', displayLabel: 'CRD.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CrdId', type: 'int', displayLabel: 'CRD.FIELDS.CRD_ID', visible: false, creatable: true, editable: false, inputType: 'lookup', lookupSource:'catalogs.CRD',
                    lookupFilter: {'Status': 1}, validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CrdId', type: 'int', displayLabel: 'CRD.FIELDS.CRD_ID', visible: true, creatable: false, editable: false, inputType: 'number',
                    lookupFilter: {'Status': 1}, validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CustomerRequiredDate', type: 'text', displayLabel: 'CRD.FIELDS.CRD', visible: true, creatable: false, editable: false, inputType: 'date-utc',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'AvailabilityFrom', type: 'text', displayLabel: 'CRD.FIELDS.AVAILABILITY_FROM', visible: true, creatable: true, editable: true, inputType: 'date-utc',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'AvailabilityTo', type: 'text', displayLabel: 'CRD.FIELDS.AVAILABILITY_TO', visible: true, creatable: true, editable: true, inputType: 'date-utc',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Status', type: 'text', displayLabel: 'CRD.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CatalogCRDStatus', type: 'text', displayLabel: 'CRD.FIELDS.CATALOG_CRD_STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedDate', type: 'text', displayLabel: 'CRD.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedDate', type: 'text', displayLabel: 'CRD.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedBy', type: 'text', displayLabel: 'CRD.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedBy', type: 'text', displayLabel: 'CRD.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Description', type: 'text', displayLabel: 'CRD.FIELDS.DESCRIPTION', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },

            ],
            title: 'CRD.NAV',
            icon: 'icon-calendar-clock',
            idField: 'CrdId',
            lookupDisplayField: 'CustomerRequiredDate',
            isDirty: false,
            isCatalogSpecificModel: true,
            methods: {
                getList     : getArticleCRDs,
                activateBulk: activateCRDs,
                create      : createArticleCRD,
                update      : updateArticleCRD
            },
            views: {
                mainList: {
                    columns         : [ 'CustomerRequiredDate', 'Description', 'AvailabilityFrom', 'AvailabilityTo', 'Status', 'CatalogCRDStatus', 'UpdatedDate'],
                    columnFilter    : {},
                    topIndex        : 0,
                    showFilterRow   : false,
                    toggleFilterProps: { toggleStatus:true, filterProp:'Status', trueVal:1, trueValTooltipMessage: 'ACTIONS.TOGGLE_ACTIVE', falseVal:'', falseValTooltipMessage:"ACTIONS.TOGGLE_ALL"},
                    sortColumn      : {'UpdatedDate': false},
                    itemActions     : [
                                        { id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UpdateArticleBulkCRD:true', disabled: '!itm.Status || !itm.CatalogCRDStatus', visible: true },
                                        { id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateArticleBulkCRD:true', disabled: '!itm.CatalogCRDStatus', visible: 'itm.Status',
                                            requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                                        { id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateArticleBulkCRD:true', disabled: '!itm.CatalogCRDStatus', visible: '!itm.Status',
                                            requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
                                      ],
                    listActions     : [
                                        { id: 'delete', label: 'ACTIONS.DELETE_BULK', icon: 'icon-delete', privilege: 'UpdateArticleBulkCRD:true', disabled: '{selected: true, Status: 1, CatalogCRDStatus: 1}', visible: true,
                                            requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                                        { id: 'activate', label: 'ACTIONS.ACTIVATE_BULK', icon: 'icon-undo-variant', privilege: 'UpdateArticleBulkCRD:true', disabled: '{selected: true, Status: 0, CatalogCRDStatus: 1}', visible: true,
                                            requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
                                      ],
                    fabAction       : {id: 'add', label: 'ACTIONS.ADD', icon: 'icon-link', privilege: 'UpdateArticleBulkCRD:true', visible: true}
                 },
                 mainDetails: {},
                 privileges: {
                     list: 'GetCatalogArticleCRD'
                 }
            }
        };

        // Not supported for lookup
        function getArticleCRDs(generalProperties, articleId, catalogId) {
            var promise;

            if(angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
                var state = {};
                state.name = $state.current.name;
                state.params = $state.params;
                var isBulk = true;
                var logData = activityLogger.createLogData(null, state, 'articles.crds', 'VIEW', isBulk, new Date(), null, null);

                promise = api.webGet(api.baseUrl + '/catalogs/' + catalogId + '/articles/' + articleId + '/CRDs',
                generalProperties.config || {}, true, generalProperties.forceFetch,
                generalProperties.supportIncrementalResult || true,
                generalProperties.modelIdField,
                generalProperties.isMajor || false,
                generalProperties.model || api.articles.crds);
                promise = activityLogger.log(logData, promise);
            }
            else {
                promise = api.webGet(api.baseUrl + '/catalogs/' + catalogId + '/articles/' + articleId + '/CRDs',
                generalProperties.config || {}, true, generalProperties.forceFetch,
                generalProperties.supportIncrementalResult || true,
                generalProperties.modelIdField,
                generalProperties.isMajor || false,
                generalProperties.model || api.articles.crds);
            }

            promise.then(function() {
                if (api.articles.crds.isDirty) {
                    //Invalidate lookupData
                    api.articles.crds.lookupData = undefined;
                    api.articles.crds.isDirty = false;
                }
            });
            return promise;
		}

        function activateCRDs(records, allRecords, model, actionType, parentId, activeCatalogId) {
            var itemsNameList = [];
            if(!angular.isArray(records)){
                records = utility.pushItemToArray(records);
            }
            angular.forEach(records, function(record) {
                itemsNameList.push(record[model.lookupDisplayField]);
                //if undelete action
                if(record.Status === 0){
                    utility.filterObject(allRecords, {CrdId: record.CrdId}, true)[0].Status = 1;
                }
                //id delete action
                else{
                    utility.filterObject(allRecords, {CrdId: record.CrdId}, true)[0].Status = 0;
                }

            });
            var activeRecords = utility.filterObject(allRecords, {Status: 1});
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var isBulk = itemsNameList.length > 1 ? true : false;
            var logData = activityLogger.createLogData(itemsNameList, state, 'articles.crds', actionType.toUpperCase(), isBulk, new Date(), null, null);
			var promise = api.webPut(api.baseUrl + '/catalogs/' + activeCatalogId + '/articles/' + parentId + '/crds', activeRecords);

             promise.then(function() {
                crud.onRecordStatusChange(records, model, actionType);
            });

            return activityLogger.log(logData, promise);
		}

        function createArticleCRD(record, allRecords) {
            // set date hour to 12 UTC time
            utility.setDateHourUTC(record.AvailabilityFrom, 12);
            utility.setDateHourUTC(record.AvailabilityTo, 12);

            var existingRecord = utility.filterObject(allRecords, {CrdId : record.CrdId}, true)[0];
            allRecords.splice(allRecords.indexOf(existingRecord), 1);

            //This WEB API activate the status of records which are part of request body and deactivate remaining so-
            //only keep the active records & records with CatalogCRDStatus = 1 since API accepts records with CatalogCRDStatus =1 and since at the time of building article CRDs-
            //the scope object will includs deactivated catalog CRD as well to be displayd on UI, we need to filter out records with CatalogCRDStatus = 0
            var activeRecords = utility.filterObject(allRecords, {Status: 1, CatalogCRDStatus : 1});
            activeRecords.push(record);
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var logData = activityLogger.createLogData(record[api.articles.crds.lookupDisplayField], state, 'articles.crds', 'ADD', false, new Date(), null, null);
			var promise = api.webPut(api.baseUrl + '/catalogs/' + record.activeCatalogId + '/articles/' + record.ArticleId + '/crds', activeRecords);

            promise.then(function() {
                api.articles.crds.isDirty = true;
                api.catalogs.crds.isDirty = true;
            });
            return activityLogger.log(logData, promise);
		}

        function updateArticleCRD(recordId, record, allRecords) {
            // set date hour to 12 UTC time
            utility.setDateHourUTC(record.AvailabilityFrom, 12);
            utility.setDateHourUTC(record.AvailabilityTo, 12);

            allRecords.splice(allRecords.indexOf(utility.filterObject(allRecords, {CrdId : record.CrdId}, true)[0]), 1);
            allRecords.push(record);
            var activeRecords = utility.filterObject(allRecords, {Status: 1});
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var logData = activityLogger.createLogData(record[api.articles.crds.lookupDisplayField], state, 'articles.crds', 'EDIT', false, new Date(), null, null);
			var promise = api.webPut(api.baseUrl + '/catalogs/' + record.activeCatalogId + '/articles/' + record.ArticleId + '/crds', activeRecords);

            promise.then(function() {
                api.articles.crds.isDirty = true;
                api.catalogs.crds.isDirty = true;
            });
            return activityLogger.log(logData, promise);
		}
    }
})();
(function () {
    'use strict';

    angular
        .module('app.main.catalogs.articles.audit-trail-history', [])
        .config(config);

    /* @ngInject */
    function config($translatePartialLoaderProvider) {

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/catalogs/sub-modules/articles/details/tabs/audit-trail-history');
    }
})();
(function() {
	'use strict';

	angular
			.module('app.main.catalogs.articles.audit-trail-history')
			.run(runBlock);

	/* @ngInject */
	function runBlock(api, activityLogger, $state) {

		if (angular.isUndefined(api.articles)) {
			api.articles = {};
		}
		api.articles.auditTrailHistory = {
			modelPath: 'articles.auditTrailHistory',
			fields: [
				{ field: 'ChangeMaker', type: 'text', displayLabel: 'AUDIT_TRAIL_HISTORY.FIELDS.CHANGE_MAKER', visible: true, creatable: false, editable: false, inputType: 'text',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'ChangeDate', type: 'date', displayLabel: 'AUDIT_TRAIL_HISTORY.FIELDS.CHANGE_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: ''}},
				{ field: 'FieldName', type: 'text', displayLabel: 'AUDIT_TRAIL_HISTORY.FIELDS.FIELD_NAME', visible: false, creatable: false, editable: false, inputType: 'text',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'Old', type: 'text', displayLabel: 'AUDIT_TRAIL_HISTORY.FIELDS.OLD_VALUE', visible: true, creatable: false, editable: false, inputType: 'text',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'New', type: 'text', displayLabel: 'AUDIT_TRAIL_HISTORY.FIELDS.NEW_VALUE', visible: true, creatable: false, editable: false, inputType: 'text',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
			],
			uniqueConstraints: [
					{}
			],
			title: 'AUDIT_TRAIL_HISTORY.NAV',
			icon: '',
			idField: 'ChangeMaker',
			lookupDisplayField: '',
			isDirty: false,
			isBulkActionCompleted: false,
			methods: {
					getList                     :   getArticleAuditTrailHistory
			},
			views: {
				mainList: {
					columns             : [ 'ChangeMaker', 'ChangeDate', 'Old', 'New' ],
					columnFilter        : {},
					toggleFilterProps   : {},
					topIndex            : 0,
					showFilterRow       : false,
					sortColumn          : {'ChangeDate': false},
					itemActions         : [],
					listActions         : [],
					fabAction           : {}
				},
				mainDetails: {
					selectedTabIndex    : 0,
					itemActions         : [],
					fabAction                 : {}
				},
				privileges: {
					list    : 'GetArticleHistory'
				}
			}
		};

		function getArticleAuditTrailHistory(generalProperties, articleId, catalogCode) {
			var promise;

			if(angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
				var state = {};
				state.name = $state.current.name;
				state.params = $state.params;
				var isBulk = false;
				var logData = activityLogger.createLogData(null, state, 'articles.auditTrailHistory', 'VIEW', isBulk, new Date(), null, null);

				promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/articles/' + articleId + '/history');
				promise = activityLogger.log(logData, promise);
			}
			else {
				promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/articles/' + articleId + '/history');
			}

			return promise;
		}
	}
})();
(function() {
  'use strict';

  angular
      .module('app.main.catalogs.allocation-groups.articles', []);
})();
(function () {
  'use strict';

  angular
    .module('app.main.catalogs.allocation-groups.articles')
    .run(runBlock);

  /* @ngInject */
  function runBlock(api) {

    if (angular.isUndefined(api.allocationGroups)) {
      api.allocationGroups = {};
    }
    api.allocationGroups.articles = {
      modelPath: 'allocationGroups.articles',
      fields: [
        { field: 'ArticleId', type: 'int', displayLabel: 'ARTICLES.FIELDS.ARTICLE_ID', visible: true, creatable: false, editable: false, inputType: 'number',
          validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
        { field: 'ArticleName', type: 'text', displayLabel: 'ARTICLES.FIELDS.MODEL_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
          validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
        { field: 'ArticleNumber', type: 'text', displayLabel: 'ARTICLES.FIELDS.ARTICLE_NUMBER', visible: true, creatable: false, editable: false, inputType: 'text',
          validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
        { field: 'Status', type: 'text', displayLabel: 'ARTICLES.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
          validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
        { field: 'CreatedDate', type: 'text', displayLabel: 'ARTICLES.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
          validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
        { field: 'UpdatedDate', type: 'text', displayLabel: 'ARTICLES.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
          validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
        { field: 'CreatedBy', type: 'text', displayLabel: 'ARTICLES.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
          validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
        { field: 'UpdatedBy', type: 'text', displayLabel: 'ARTICLES.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
          validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
      ],
      uniqueConstraints: [],
      title: 'ARTICLES.NAV',
      icon: 'icon-cube-outline',
      idField: 'ArticleId',
      lookupDisplayField: 'ArticleNumber',
      isDirty: false,
      isBulkActionCompleted: false,
      isCatalogSpecificModel: true,
      methods: { },
      views: {
        mainList: {
          columns           : ['ArticleNumber', 'ArticleName', 'Status', 'UpdatedDate'],
          columnFilter      : {},
          toggleFilterProps : { toggleStatus: false, filterProp: 'Status', trueVal: 1, trueValTooltipMessage: 'ACTIONS.TOGGLE_ACTIVE', falseVal: '', falseValTooltipMessage: "ACTIONS.TOGGLE_ALL" },
          topIndex          : 0,
          showFilterRow     : false,
          sortColumn        : { 'UpdatedDate': false },
          sortDescending    : true,
          itemActions       : [
                                { id: 'view', label: 'ACTIONS.VIEW', icon: 'icon-magnify', privilege: 'GetCatalogArticleDetails', disabled: '!itm.Status', visible: true }],
          listActions       : [],
          fabAction         : {}
        },
        mainDetails: {},
        privileges: {
          list: 'GetAllocationGroupDetails',
          details: 'GetCatalogArticleDetails'
        }
      }
    };
  }
})();
(function() {
    'use strict';
    
    angular
        .module('app.main.catalogs.treeDefinition', []);
})();
(function () {
	'use strict';

	angular
		.module('app.main.catalogs.treeDefinition')
		.controller('createTreeController', createTreeController);

	/* @ngInject */
	function createTreeController($mdDialog, $scope, $filter, hotkeys, toast, utility, model, record, isNew, event, catalogAttributes, catalogId, existingRecordsForUniqueValue, treeFactory, catalogFactory) {
		var vm = this;

		//data
		vm.isLoading = false;
		vm.record = (angular.isDefined(record) && record != null) ? angular.copy(record) : {};
		vm.lookupModel = angular.copy(vm.record);
		vm.isNew = isNew;
		vm.attributes = catalogAttributes;
		var treeAttributes = (angular.isDefined(record) && record != null && angular.isDefined(record.Attributes) && record.Attributes != null) ? angular.copy(record.Attributes) : [];
		vm.record.Attributes = utility.orderBy(treeAttributes, 'Level', false);
		vm.treeUnUtilizedAttributes = treeFactory.getUnUtilizedCatalogAttributes(angular.copy(vm.attributes), vm.record.Attributes);
		vm.existingRecordsForUniqueValue = existingRecordsForUniqueValue;
		var catalogCode = catalogId;

		//methods
		vm.saveRecord = saveRecord;
		vm.closeDialog = closeDialog;
		// if catalog tree attributes order get changed
		vm.treeListeners = {
			orderChanged: resetTreeAttributesLevel
		}
		// and attribute added to catalog tree
		vm.catalogTreeListeners = {
			itemMoved: resetTreeAttributesLevel
		}

		if(vm.isNew) {
			vm.record.IsDefault = 0; // assigning false as default value
		}

		activate();

		////////////////

		function activate() {
			//Hotkeys
			hotkeys.bindTo($scope).add({
				combo: 'ctrl+enter',
				description: $filter('translate')('ACTIONS.SAVE'),
				allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
				callback: function (event) {
					if (!vm.isLoading && !vm.editForm.$invalid) {
						vm.saveRecord();
					}
				}
			});
		}

		function saveRecord() {
			vm.isLoading = true;

			var p;
			var requestObj = {
				Name: vm.record.Name,
				IsDefault: vm.record.IsDefault,
				Attributes: []
			}
			if(angular.isDefined(vm.record.Attributes) && vm.record.Attributes.length > 0) {
				angular.forEach(vm.record.Attributes, function(attribute) {
					requestObj.Attributes.push({
						Attributeid: attribute.Attributeid,
						Level: attribute.Level
					});
				})
			}

			if (vm.isNew) {
				p = model.methods.create(catalogCode, requestObj);
			}
			else {
				p = model.methods.update(catalogCode, vm.record[model.idField], requestObj);
			}

			p.then(function (response) {
				closeDialog(true);
				var toastMessage;
				toastMessage = response.config.method.toUpperCase() === 'POST' ? 'SUCCESS.CREATE' : 'SUCCESS.UPDATE';
				toast.success(toastMessage, '', '');
			}, function (err) {
				closeDialog(vm.isDataDirty);
			}).finally(function () {
				vm.isLoading = false;
			})
		}

		function closeDialog(saved) {
			$mdDialog.hide(saved);
		}

		function resetTreeAttributesLevel() {
			angular.forEach(vm.record.Attributes, function (attribute, index) {
				attribute.Level = index;
			});
		}

	}

})();
(function() {
    'use strict';

    angular
        .module('app.main.catalogs.segmentation-group',[]);
})();
(function() {
	'use strict';

	angular
			.module('app.main.catalogs.segmentation-group')
			.controller('updateSegmentationGroupsController', updateSegmentationGroupsController);

	/* @ngInject */
	function updateSegmentationGroupsController($mdDialog, $scope, $filter, hotkeys, $window, $log, toast, utility, model, record, isNew, existingRecordsForUniqueValue, segmentations, roleBasedRestrictedSegmentations, catalogCode) {
		var vm = this;

		//data
		vm.isLoading = false;
		vm.record = (angular.isDefined(record) && record != null) ? angular.copy(record) : {};
		vm.record.SegmentationidsList = (!vm.record.SegmentationidsList) ? [] : vm.record.SegmentationidsList;
		vm.lookupModel = angular.copy(vm.record);
		vm.isNew = isNew;
		vm.model = model;

		vm.acSelectedItem = [];
		vm.acSearchText = [];
		vm.searchText = {};

		vm.existingRecordsForUniqueValue = existingRecordsForUniqueValue;

		//methods
		vm.saveRecord = saveRecord;
		vm.closeDialog = closeDialog;

		vm.transformChip = transformChip;
		vm.acQuerySearch = acQuerySearch;
		vm.getChipDisplayValue = getChipDisplayValue;

		activate();

		////////////////

		function activate() {
			//Hotkeys
			hotkeys.bindTo($scope).add({
				combo: 'ctrl+enter',
				description: $filter('translate')('ACTIONS.SAVE'),
				allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
				callback: function (event) {
					if (!vm.isLoading && !vm.editForm.$invalid) {
						vm.saveRecord();
					}
				}
			});

			if (vm.isNew) {
				hotkeys.bindTo($scope).add({
					combo: 'ctrl+shift+enter',
					description: $filter('translate')('ACTIONS.SAVE_AND_NEW'),
					allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
					callback: function (event) {
						if (!vm.isLoading && !vm.editForm.$invalid) {
							vm.saveRecord(true);
						}
					}
				});
			}

			// make segmentations restricted as not editable as non removable chip
			if(!vm.isNew && vm.record.SegmentationidsList.length > 0) {
				vm.existingRecords = [];
				angular.forEach(vm.record.SegmentationidsList, function(segmentation) {
					var segmentationObj = utility.filterObject(roleBasedRestrictedSegmentations, { Id: segmentation, notEditable : 1}, true)[0];
						if (angular.isDefined(segmentationObj)) {
							vm.existingRecords.push(segmentation);
						}
				});
			}
		}

		function saveRecord(saveAndNew) {
			vm.isLoading = true;

			var p;

			if (vm.isNew) {
				p = vm.model.methods.create(vm.record, catalogCode);
			}
			else {
				p = vm.model.methods.update(vm.record[vm.model.idField], vm.record, catalogCode);
			}

			p.then(function (response) {
				if (vm.isNew && angular.isDefined(saveAndNew) && saveAndNew) {
					vm.editForm.$setPristine();
					vm.editForm.$setUntouched();
					vm.record = {};
					vm.record.SegmentationidsList = [];
					vm.acSearchText = [];
					vm.searchText = {};
					vm.accountType = {};
					vm.isDataDirty = true;

					var el = $window.document.getElementById('dialog_input_first');
					if (el) {
						el.focus();
					}
				} else {
					closeDialog(true);
				}

				var toastMessage;
				toastMessage = response.config.method.toUpperCase() === 'POST' ? 'SUCCESS.CREATE' : 'SUCCESS.UPDATE';
				toast.success(toastMessage, '', '');
			}, function (err) {
				closeDialog(vm.isDataDirty);
			}).finally(function () {
				vm.isLoading = false;
			})
		}

		function closeDialog(saved) {
			$mdDialog.hide(saved);
		}

		function transformChip(chip) {
			if (angular.isObject(chip)) {
				return chip.Id;
			}
			return undefined;
		}

		function acQuerySearch(query, selectedRecords, fieldName) {
			var results = [];
			var field = utility.filterObject(vm.model.fields, { field: fieldName }, true)[0];
			var lookupFilter = angular.isDefined(field.lookupFilter) ? field.lookupFilter : {};
			var predicate = angular.copy(lookupFilter);
			predicate.value = query;

			if (angular.isDefined(segmentations) && segmentations.length) {
				results = query ? utility.filterObject(segmentations, predicate) : utility.filterObject(segmentations, lookupFilter);
				results = removeSelectedChips(selectedRecords, results);
				return utility.filterObject(results, {AccountId: vm.record.AccountId, Status: 1}, true);
			}
		}

		/**
		 * @description
		 * This method will remove selected chips form records (helper method)
		 * @param {array} selectedRecords: list of selected chips
		 * @param {array} records: data property of lookup-data
		 * @returns {array}: list of available chips (chips which are not selected) // it does not really need to return a value but for readability returning modified value
		 */
		function removeSelectedChips(selectedRecords, records) {
			if (angular.isDefined(selectedRecords) && selectedRecords.length > 0) {
				for (var index = records.length - 1; index >= 0; index--) {
					if (selectedRecords.indexOf(records[index].Id) !== -1) {
						records.splice(index, 1);
					}
				}
			}
			return records;
		}

		function getChipDisplayValue(chip) {
			if (angular.isDefined(segmentations) && segmentations.length) {
				return getChipDisplayVal(chip);
			}
		}

		//helper method
		function getChipDisplayVal(chip) {
			var res = utility.filterObject(segmentations, { Id: chip }, true);
			if (angular.isArray(res) && res.length > 0) {
				return res[0].Name;
			}
			else {
				$log.warn('viewCreator controller: Unable to resolve chip display value!');
				return "";
			}
		}

	}
})();
(function () {
	'use strict';

	angular
		.module('app.main.catalogs.restrict-segmentations', [])
		.config(config);

	/* @ngInject */
	function config($translatePartialLoaderProvider) {

		// Translation
		$translatePartialLoaderProvider.addPart('app/main/catalogs/details/tabs/restrict-segmentations');
	}
})();
(function () {
	'use strict';

	angular
		.module('app.main.catalogs.restrict-segmentations')
		.controller('viewRoleBasedSegmantationsRestrictionController', viewRoleBasedSegmantationsRestrictionController);

	/* @ngInject */
	function viewRoleBasedSegmantationsRestrictionController($mdDialog, model, data) {
		var vm = this;

		vm.data = data;
		vm.model = model;
		vm.filteredData = [];

		vm.closeDialog = closeDialog;

		function closeDialog() {
			$mdDialog.hide();
		}

	}
})();
(function () {
	'use strict';

	angular
		.module('app.main.catalogs.restrict-segmentations')
		.controller('addUpdateRoleBasedSegmantationsRestrictionController', addUpdateRoleBasedSegmantationsRestrictionController);

	/* @ngInject */
	function addUpdateRoleBasedSegmantationsRestrictionController($mdDialog, $scope, $filter, toast, hotkeys, utility, record, isNew, model, promises, assignedRolesList, activeCatalogCode, event, api, catalogFactory) {
		/* jshint validthis: true */
		var vm = this;

		//Data
		vm.isLoading = false;
		vm.isDataDirty = false;
		vm.isNew = isNew;
		vm.records = [];
		vm.searchText = [];
		vm.lookupModel = [];
		vm.rolesList = [];

		vm.accountTypes = [
			{ id: 1, value: "Admin" },
			{ id: 2, value: "Seller"},
			{ id: 3, value: "Buyer"}
		];
		vm.accountType = {};
		var assignedSegmentationsMap = {};

		//Methods
		vm.saveRecord = saveRecord;
		vm.closeDialog = closeDialog;

		vm.searchRole = searchRole;
		vm.getRoleDisplayValue = getRoleDisplayValue;
		vm.onRoleChange = onRoleChange;
		vm.lookupSearch = lookupSearch;
		vm.lookupChange = lookupChange;
		vm.getLookupDisplayValue = getLookupDisplayValue;
		vm.selectText = selectText;
		vm.onAccountTypeChange = onAccountTypeChange;


		activate();

		////////////////

		function activate() {
			if (!isNew) {
				populateEditDialog();
			}
			else {
				createEmptyRow();
			}
			//Hotkeys
			hotkeys.bindTo($scope).add({
				combo: 'ctrl+enter',
				description: $filter('translate')('ACTIONS.SAVE'),
				allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
				callback: function (event) {
					if (!vm.isLoading && !vm.editForm.$invalid) {
						vm.saveRecord();
					}
				}
			});
		}

		function saveRecord() {
			vm.isLoading = true;
			var segmentations = [];
			angular.forEach(vm.records, function(record) {
				if(angular.isDefined(record.Id) && record.Id !== null) {
					if((record.NotViewable && record.NotEditable) || (!record.NotViewable && record.NotEditable)) {
						segmentations.push(record);
					}
				}
			});
			var requestObj = {
				RoleId: vm.isNew ? vm.records.RoleId : record.RoleId,
				Segmentations: segmentations
			}

			var actionType = vm.isNew ? 'ADD' : 'EDIT';
			model.methods.update(requestObj, activeCatalogCode, actionType)
				.then(function () {
					closeDialog(true);
					var toastMessage = vm.isNew ? 'SUCCESS.CREATE' : 'SUCCESS.UPDATE';
					toast.success(toastMessage, '', '');
				}, function () {
					closeDialog(vm.isDataDirty);
				}).finally(function () {
					vm.isLoading = false;
				})
		}

		function closeDialog(saved) {
			$mdDialog.hide(saved);
		}

		function searchRole(query) {
			return loadAvailableRoles()
				.then(function(rolesList) {
					var availableRolesList = utility.filterObject(rolesList, {AccountTypeId: vm.accountTypeId}, true);
					var predicate = { UserRole: query };
					return query ? utility.filterObject(availableRolesList, predicate) : availableRolesList;
				});
		}

		function getRoleDisplayValue(item) {
			return loadAvailableRoles()
        .then(function(rolesList) {
          var result;
          if(angular.isObject(item)) {
            result = utility.filterObject(rolesList, { Id: item.Id }, true)[0]
          }
          else {
            result = utility.filterObject(rolesList, { Id: item }, true)[0];
          }
          if(result) {
            return result.UserRole;
          }
      });
		}

		function onRoleChange(selectedObj) {
			if (angular.isObject(selectedObj)) {
				vm.records['RoleId'] = selectedObj.Id;
			}
			else if (angular.isUndefined(selectedObj) || selectedObj === null) {
				vm.records['RoleId'] = undefined; // on record removal make field undefined or the property can be deleted using delete keyword
			}
		}

		function lookupSearch(query) {
			var results = [];
			var predicate = {};
			predicate.Name = query;
			return loadAvailableSegmentations()
			.then(function (availablecatalogSegmentations) {
				results = query ? utility.filterObject(availablecatalogSegmentations, predicate) : availablecatalogSegmentations;
				return results;
			});
		}

		function lookupChange(selectedObj, rowIndex) {
			if (angular.isObject(selectedObj)) {
				vm.records[rowIndex].Id = selectedObj.Id;
				assignedSegmentationsMap[selectedObj.Id] = 1;
			}
			else if (angular.isUndefined(selectedObj) || selectedObj === null) {
				delete assignedSegmentationsMap[vm.records[rowIndex].Id];
				vm.records[rowIndex].Id = undefined; // on record removal make field undefined or the property can be deleted using delete keyword
			}
			// if adding data to last row and quantity is added create new row
			if(rowIndex === vm.records.length-1) {
				createEmptyRow();
			}
		}

		function getLookupDisplayValue(item) {
			return loadCatalogSegmentations()
			.then(function(catalogSegmentationList) {
				return getLookupDisplayVal(item, catalogSegmentationList);
			});
		}

		function getLookupDisplayVal(item, catalogSegmentationList) {
			var result;
			if (catalogSegmentationList) {
				// since autocomplete return object
				if (angular.isObject(item)) {
					result = utility.filterObject(catalogSegmentationList, { Id: item.Id }, true);
				}
				// to initialize field value if any (when open update record dialog)
				else {
					result = utility.filterObject(catalogSegmentationList, { Id: item }, true);
				}

				if (angular.isArray(result) && result.length > 0) {
					return result[0].Name;
				}
				else {
					return result.Name;
				}
			}
		}

		function selectText(event) {
			utility.selectInputText(event);
		}

		function onAccountTypeChange(accountType) {
			vm.accountTypeId = accountType.id;
		}

		function populateEditDialog() {
			angular.forEach(record.Segmentations, function(segmentation) {
				var recordsLength = vm.records.push({ Id: segmentation.Id, NotEditable: segmentation.NotEditable, NotViewable: segmentation.NotViewable });
				if(angular.isUndefined(vm.lookupModel[recordsLength-1])) {
					vm.lookupModel[recordsLength-1] = {};
				}
				vm.lookupModel[recordsLength-1].Id = segmentation.Id;
				assignedSegmentationsMap[segmentation.Id] = 1;
			});
			if(angular.isUndefined(vm.lookupModel)) {
				vm.lookupModel = {};
			}
			vm.lookupModel.roleName = record.RoleName;
			createEmptyRow();
		}

		function createEmptyRow() {
			vm.searchText.push({});
			vm.lookupModel.push({});
			vm.records.push({ Id: null, NotViewable: 0, NotEditable: 0 });
		}

		function loadAvailableRoles() {
      return promises['rolesPromise']
        .then(function(response) {
          var rolesList = response.data;
          if(isNew) {
            angular.forEach(assignedRolesList, function (role) {
              var index = rolesList.indexOf(utility.filterObject(rolesList, { Id: role['RoleId'] }, true)[0]);
              if (index !== -1) {
                rolesList.splice(index, 1);
              }
            });
          }
          return rolesList;
        });
    }

		function loadAvailableSegmentations() {
      var availableSegmentations = [];
      return loadCatalogSegmentations()
      .then(function(catalogSegmentationList) {
        angular.forEach(catalogSegmentationList, function (catalogSegmentation) {
					if (catalogSegmentation.Status && !assignedSegmentationsMap[catalogSegmentation.Id]) {
						availableSegmentations.push(catalogSegmentation);
					}
				});
				return availableSegmentations;
      });
    }

		function loadCatalogSegmentations() {
      return promises['catalogSegmentationsPromise']
        .then(function (response) {
          return utility.filterObject(response.data, { Status: 1 });
        });
    }

	}
})();
(function () {
	'use strict';

	angular
		.module('app.main.catalogs.restrict-retail-windows', [])
		.config(config);

	/* @ngInject */
	function config($translatePartialLoaderProvider) {

		// Translation
		$translatePartialLoaderProvider.addPart('app/main/catalogs/details/tabs/restrict-retail-windows');
	}
})();
(function () {
	'use strict';

	angular
		.module('app.main.catalogs.restrict-retail-windows')
		.controller('addOrUpdateRetailWindowsRestrictionController', addOrUpdateRetailWindowsRestrictionController);

	/* @ngInject */
	function addOrUpdateRetailWindowsRestrictionController($mdDialog, $scope, $filter, toast, hotkeys, utility, record, isNew, model, promises, assignedRolesList, activeCatalogCode, event, api) {
		/* jshint validthis: true */
		var vm = this;

		//Data
		vm.isLoading = false;
		vm.isDataDirty = false;
		vm.isNew = isNew;
		vm.record = {};
		if(vm.isNew) {
			vm.record['NotViewable'] = 0;
			vm.record['NotEditable'] = 0;
		}
		vm.searchText = '';
		vm.lookupModel = {};
		vm.rolesList = [];

		vm.accountTypes = [
			{ id: 1, value: "Admin" },
			{ id: 2, value: "Seller"},
			{ id: 3, value: "Buyer"}
		];
		vm.accountType = {};

		//Methods
		vm.saveRecord = saveRecord;
		vm.closeDialog = closeDialog;

		vm.searchRole = searchRole;
		vm.getRoleDisplayValue = getRoleDisplayValue;
		vm.onRoleChange = onRoleChange;
		vm.selectText = selectText;
		vm.onAccountTypeChange = onAccountTypeChange;


		activate();

		////////////////

		function activate() {
			if (!isNew) {
				populateEditDialog();
			}
			//Hotkeys
			hotkeys.bindTo($scope).add({
				combo: 'ctrl+enter',
				description: $filter('translate')('ACTIONS.SAVE'),
				allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
				callback: function (event) {
					if (!vm.isLoading && !vm.editForm.$invalid) {
						vm.saveRecord();
					}
				}
			});
		}

		function saveRecord() {
			vm.isLoading = true;
			var attribuites = [];
			if((vm.record.NotViewable && vm.record.NotEditable) || (!vm.record.NotViewable && vm.record.NotEditable)) {
				vm.record.Name = 'ShipmentWindow';
				attribuites.push(vm.record);
			}
			var requestObj = {
				RoleId: vm.isNew ? vm.record.RoleId : record.RoleId,
				Attributes: attribuites
			}

			var actionType = vm.isNew ? 'ADD' : 'EDIT';
			model.methods.update(requestObj, activeCatalogCode, actionType)
				.then(function () {
					closeDialog(true);
					var toastMessage = vm.isNew ? 'SUCCESS.CREATE' : 'SUCCESS.UPDATE';
					toast.success(toastMessage, '', '');
				}, function () {
					closeDialog(vm.isDataDirty);
				}).finally(function () {
					vm.isLoading = false;
				})
		}

		function closeDialog(saved) {
			$mdDialog.hide(saved);
		}

		function searchRole(query) {
			return loadAvailableRoles()
				.then(function(rolesList) {
					var availableRolesList = utility.filterObject(rolesList, {AccountTypeId: vm.accountTypeId}, true);
					var predicate = { UserRole: query };
					return query ? utility.filterObject(availableRolesList, predicate) : availableRolesList;
				});
		}

		function getRoleDisplayValue(item) {
			return loadAvailableRoles()
        .then(function(rolesList) {
          var result;
          if(angular.isObject(item)) {
            result = utility.filterObject(rolesList, { Id: item.Id }, true)[0]
          }
          else {
            result = utility.filterObject(rolesList, { Id: item }, true)[0];
          }
          if(result) {
            return result.UserRole;
          }
      });
		}

		function onRoleChange(selectedObj) {
			if (angular.isObject(selectedObj)) {
				vm.record['RoleId'] = selectedObj.Id;
			}
			else if (angular.isUndefined(selectedObj) || selectedObj === null) {
				vm.record['RoleId'] = undefined; // on record removal make field undefined or the property can be deleted using delete keyword
			}
		}

		function selectText(event) {
			utility.selectInputText(event);
		}

		function onAccountTypeChange(accountType) {
			vm.accountTypeId = accountType.id;
		}

		function populateEditDialog() {
			if(record !== null) {
				vm.record = record;
				vm.lookupModel.roleName = record.RoleName;
			}
		}

		function loadAvailableRoles() {
			return promises['rolesPromise']
				.then(function(response) {
					var rolesList = response.data;
					if(isNew) {
						angular.forEach(assignedRolesList, function (role) {
							var index = rolesList.indexOf(utility.filterObject(rolesList, { Id: role['RoleId'] }, true)[0]);
							if (index !== -1) {
								rolesList.splice(index, 1);
							}
						});
					}
					return rolesList;
				});
		}

	}
})();
(function() {
		'use strict';
		
		angular
				.module('app.main.catalogs.restrict-bucket-attributes', [])
				.config(config);

		/* @ngInject */
		function config($translatePartialLoaderProvider) {

				// Translation
				$translatePartialLoaderProvider.addPart('app/main/catalogs/details/tabs/restrict-bucket-attributes');
		}
})();
(function () {
	'use strict';

	angular
		.module('app.main.catalogs.restrict-bucket-attributes')
		.controller('viewRestrictedAttributesListController', viewRestrictedAttributesListController);

	/* @ngInject */
	function viewRestrictedAttributesListController($mdDialog, model, data) {
		var vm = this;

		vm.data = data;
		vm.model = model;
		vm.filteredData = [];

		vm.closeDialog = closeDialog;

		function closeDialog() {
			$mdDialog.hide();
		}

	}
})();
(function () {
	'use strict';

	angular
		.module('app.main.catalogs.restrict-bucket-attributes')
		.controller('updateRestrictBucketAttributeController', updateRestrictBucketAttributeController);

	/* @ngInject */
	function updateRestrictBucketAttributeController($mdDialog, $scope, $filter, toast, hotkeys, utility, record, isNew, model, promises, assignedRolesList, activeCatalogCode, event, api) {
		/* jshint validthis: true */
		var vm = this;

		//Data
		vm.isLoading = false;
		vm.isDataDirty = false;
		vm.isNew = isNew;
		vm.records = [];
		vm.searchText = [];
		vm.lookupModel = [];
		vm.rolesList = [];
		vm.avaialableBucketAttributes = [];

		vm.accountTypes = [
			{ id: 1, value: "Admin" },
			{ id: 2, value: "Seller"},
			{ id: 3, value: "Buyer"}
		];
		vm.accountType = {};
		var assignedBucketAttributesMap = {};


		//Methods
		vm.saveRecord = saveRecord;
		vm.closeDialog = closeDialog;

		vm.searchRole = searchRole;
		vm.getRoleDisplayValue = getRoleDisplayValue;
		vm.onRoleChange = onRoleChange;
		vm.lookupSearch = lookupSearch;
		vm.lookupChange = lookupChange;
		vm.getLookupDisplayValue = getLookupDisplayValue;
		vm.selectText = selectText;
		vm.onAccountTypeChange = onAccountTypeChange;


		activate();

		////////////////

		function activate() {
			if (!isNew) {
				populateEditDialog();
			}
			else {
				createEmptyRow();
			}
			//Hotkeys
			hotkeys.bindTo($scope).add({
				combo: 'ctrl+enter',
				description: $filter('translate')('ACTIONS.SAVE'),
				allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
				callback: function (event) {
					if (!vm.isLoading && !vm.editForm.$invalid) {
						vm.saveRecord();
					}
				}
			});
		}

		function saveRecord() {
			vm.isLoading = true;
			var attribuites = [];
			angular.forEach(vm.records, function(record) {
				if(angular.isDefined(record.Id) && record.Id !== null) {
					if((record.NotViewable && record.NotEditable) || (!record.NotViewable && record.NotEditable)) {
						attribuites.push(record);
					}
				}
			});
			var requestObj = {
				RoleId: vm.isNew ? vm.records.RoleId : record.RoleId,
				Attributes: attribuites
			}

			var actionType = vm.isNew ? 'ADD' : 'EDIT';
			model.methods.update(requestObj, activeCatalogCode, actionType)
				.then(function () {
					closeDialog(true);
					var toastMessage = vm.isNew ? 'SUCCESS.CREATE' : 'SUCCESS.UPDATE';
					toast.success(toastMessage, '', '');
				}, function () {
					closeDialog(vm.isDataDirty);
				}).finally(function () {
					vm.isLoading = false;
				})
		}

		function closeDialog(saved) {
			$mdDialog.hide(saved);
		}

		function searchRole(query) {
			return loadAvailableRoles()
				.then(function(rolesList) {
					var availableRolesList = utility.filterObject(rolesList, {AccountTypeId: vm.accountTypeId}, true);
					var predicate = { UserRole: query };
					return query ? utility.filterObject(availableRolesList, predicate) : availableRolesList;
				});
		}

		function getRoleDisplayValue(item) {
			return loadAvailableRoles()
				.then(function(rolesList) {
					var result;
					if(angular.isObject(item)) {
						result = utility.filterObject(rolesList, { Id: item.Id }, true)[0]
					}
					else {
						result = utility.filterObject(rolesList, { Id: item }, true)[0];
					}
					if(result) {
						return result.UserRole;
					}
			});
		}

		function onRoleChange(selectedObj) {
			if (angular.isObject(selectedObj)) {
				vm.records['RoleId'] = selectedObj.Id;
			}
			else if (angular.isUndefined(selectedObj) || selectedObj === null) {
				vm.records['RoleId'] = undefined; // on record removal make field undefined or the property can be deleted using delete keyword
			}
		}

		function lookupSearch(query) {
			var results = [];
			var predicate = {};
			predicate.AttributeDisplayName = query;
			return loadAvailableBucketAttributes()
				.then(function (avaialableBucketAttributes) {
					results = query ? utility.filterObject(avaialableBucketAttributes, predicate) : avaialableBucketAttributes;
					return results;
				});
		}

		function lookupChange(selectedObj, rowIndex) {
			if (angular.isObject(selectedObj)) {
				vm.records[rowIndex].Id = selectedObj.AttributeId;
				assignedBucketAttributesMap[selectedObj.AttributeId] = 1;
			}
			else if (angular.isUndefined(selectedObj) || selectedObj === null) {
				delete assignedBucketAttributesMap[vm.records[rowIndex].AttributeId];
				vm.records[rowIndex].AttributeId= undefined; // on record removal make field undefined or the property can be deleted using delete keyword
			}
			// if adding data to last row and quantity is added create new row
			if(rowIndex === vm.records.length-1) {
				createEmptyRow();
			}
		}

		function getLookupDisplayValue(item) {
				return loadBucketAttributes()
				.then(function(avaialableBucketAttributes) {
					return getLookupDisplayVal(item, avaialableBucketAttributes);
				});
		}

		function getLookupDisplayVal(item, avaialableBucketAttributes) {
			var result;
			if (avaialableBucketAttributes) {
				// since autocomplete return object
				if (angular.isObject(item)) {
					result = utility.filterObject(avaialableBucketAttributes, { AttributeId: item.AttributeId }, true);
				}
				// to initialize field value if any (when open update record dialog)
				else {
					result = utility.filterObject(avaialableBucketAttributes, { AttributeId: item }, true);
				}

				if (angular.isArray(result) && result.length > 0) {
					return result[0].AttributeDisplayName;
				}
				else {
					return result.AttributeDisplayName;
				}
			}
		}

		function selectText(event) {
			utility.selectInputText(event);
		}

		function onAccountTypeChange(accountType) {
			vm.accountTypeId = accountType.id;
		}

		function populateEditDialog() {
			angular.forEach(record.Attributes, function(attribute) {
				var recordsLength = vm.records.push({ Id: attribute.Id, NotEditable: attribute.NotEditable, NotViewable: attribute.NotViewable });
				if(angular.isUndefined(vm.lookupModel[recordsLength-1])) {
					vm.lookupModel[recordsLength-1] = {};
				}
				vm.lookupModel[recordsLength-1].Id = attribute.Id;
				assignedBucketAttributesMap[attribute.Id] = 1;
			});
			if(angular.isUndefined(vm.lookupModel)) {
				vm.lookupModel = {};
			}
			vm.lookupModel.roleName = record.RoleName;
			createEmptyRow();
		}

		function createEmptyRow() {
			vm.searchText.push({});
			vm.lookupModel.push({});
			vm.records.push({ Id: null, NotViewable: 0, NotEditable: 0 });
		}

		function loadAvailableRoles() {
      return promises['rolesPromise']
        .then(function(response) {
          var rolesList = response.data;
          if(isNew) {
            angular.forEach(assignedRolesList, function (role) {
              var index = rolesList.indexOf(utility.filterObject(rolesList, { Id: role['RoleId'] }, true)[0]);
              if (index !== -1) {
                rolesList.splice(index, 1);
              }
            });
          }
          return rolesList;
        });
    }

		function loadAvailableBucketAttributes() {
      return loadBucketAttributes()
        .then(function (bucketAttributes) {
          var avaialableBucketAttributes = [];
          angular.forEach(bucketAttributes, function (bucketAttribute) {
            if (bucketAttribute.Status && !assignedBucketAttributesMap[bucketAttribute.AttributeId]) {
              avaialableBucketAttributes.push(bucketAttribute);
            }
          })
          return avaialableBucketAttributes;
        });
    }

		function loadBucketAttributes() {
      return promises['bucketAttributesPromise']
        .then(function (response) {
          return utility.filterObject(response.data, {Status: 1});
        });
    }
	}
})();
(function () {
  'use strict';

  angular
    .module('app.main.catalogs.restrict-attributes', [])
    .config(config);

  /* @ngInject */
  function config($translatePartialLoaderProvider) {

    // Translation
    $translatePartialLoaderProvider.addPart('app/main/catalogs/details/tabs/restrict-attributes');
  }
})();
(function () {
	'use strict';

	angular
		.module('app.main.catalogs.restrict-attributes')
		.controller('viewRoleBasedAttributeRestrictionController', viewRoleBasedAttributeRestrictionController);

	/* @ngInject */
	function viewRoleBasedAttributeRestrictionController($mdDialog, model, data) {
		var vm = this;

		vm.data = data;
		vm.model = model;
		vm.filteredData = [];

		vm.closeDialog = closeDialog;

		function closeDialog() {
			$mdDialog.hide();
		}

	}
})();
(function () {
	'use strict';

	angular
		.module('app.main.catalogs.restrict-attributes')
		.controller('addOrUpdateAttributeRestrictionController', addOrUpdateAttributeRestrictionController);

	/* @ngInject */
	function addOrUpdateAttributeRestrictionController($mdDialog, $scope, $filter, toast, hotkeys, utility, record, isNew, model, promises, assignedRolesList, activeCatalogCode, event, api) {
		/* jshint validthis: true */
		var vm = this;

		//Data
		vm.isLoading = false;
		vm.isDataDirty = false;
		vm.isNew = isNew;
		vm.records = [];
		vm.searchText = [];
		vm.lookupModel = [];
		vm.rolesList = [];

		vm.accountTypes = [
			{ id: 1, value: "Admin" },
			{ id: 2, value: "Seller"},
			{ id: 3, value: "Buyer"}
		];
		vm.accountType = {};
		var assignedAttributesMap = {};


		//Methods
		vm.saveRecord = saveRecord;
		vm.closeDialog = closeDialog;

		vm.searchRole = searchRole;
		vm.getRoleDisplayValue = getRoleDisplayValue;
		vm.onRoleChange = onRoleChange;
		vm.lookupSearch = lookupSearch;
		vm.lookupChange = lookupChange;
		vm.getLookupDisplayValue = getLookupDisplayValue;
		vm.selectText = selectText;
		vm.onAccountTypeChange = onAccountTypeChange;


		activate();

		////////////////

		function activate() {
			if (!isNew) {
				populateEditDialog();
			}
			else {
				createEmptyRow();
			}
			//Hotkeys
			hotkeys.bindTo($scope).add({
				combo: 'ctrl+enter',
				description: $filter('translate')('ACTIONS.SAVE'),
				allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
				callback: function (event) {
					if (!vm.isLoading && !vm.editForm.$invalid) {
						vm.saveRecord();
					}
				}
			});
		}

		function saveRecord() {
			vm.isLoading = true;
			var attribuites = [];
			angular.forEach(vm.records, function(record) {
				if(angular.isDefined(record.Id) && record.Id !== null) {
					if((record.NotViewable && record.NotEditable) || (!record.NotViewable && record.NotEditable)) {
						attribuites.push(record);
					}
				}
			});
			var requestObj = {
				RoleId: vm.isNew ? vm.records.RoleId : record.RoleId,
				Attributes: attribuites
			}

			var actionType = vm.isNew ? 'ADD' : 'EDIT';
			model.methods.update(requestObj, activeCatalogCode, actionType)
				.then(function () {
					closeDialog(true);
					var toastMessage = vm.isNew ? 'SUCCESS.CREATE' : 'SUCCESS.UPDATE';
					toast.success(toastMessage, '', '');
				}, function () {
					closeDialog(vm.isDataDirty);
				}).finally(function () {
					vm.isLoading = false;
				})
		}

		function closeDialog(saved) {
			$mdDialog.hide(saved);
		}

		function searchRole(query) {
			return loadAvailableRoles()
				.then(function(rolesList) {
					var availableRolesList = utility.filterObject(rolesList, {AccountTypeId: vm.accountTypeId}, true);
					var predicate = { UserRole: query };
					return query ? utility.filterObject(availableRolesList, predicate) : availableRolesList;
				});
		}

		function getRoleDisplayValue(item) {
			return loadAvailableRoles()
        .then(function(rolesList) {
          var result;
          if(angular.isObject(item)) {
            result = utility.filterObject(rolesList, { Id: item.Id }, true)[0]
          }
          else {
            result = utility.filterObject(rolesList, { Id: item }, true)[0];
          }
          if(result) {
            return result.UserRole;
          }
      });
		}

		function onRoleChange(selectedObj) {
			if (angular.isObject(selectedObj)) {
				vm.records['RoleId'] = selectedObj.Id;
			}
			else if (angular.isUndefined(selectedObj) || selectedObj === null) {
				vm.records['RoleId'] = undefined; // on record removal make field undefined or the property can be deleted using delete keyword
			}
		}

		function lookupSearch(query) {
			var results = [];
			var predicate = {};
			predicate.AttributeDisplayName = query;
			return loadAvailableAttributes()
				.then(function (availableAttributes) {
					results = query ? utility.filterObject(availableAttributes, predicate) : availableAttributes;
					return results;
				});
		}

		function lookupChange(selectedObj, rowIndex) {
			if (angular.isObject(selectedObj)) {
				vm.records[rowIndex].Id = selectedObj.Attributeid;
				assignedAttributesMap[selectedObj.Attributeid] = 1;
			}
			else if (angular.isUndefined(selectedObj) || selectedObj === null) {
				delete assignedAttributesMap[vm.records[rowIndex].AttributeId];
				vm.records[rowIndex].AttributeId= undefined; // on record removal make field undefined or the property can be deleted using delete keyword
			}
			// if adding data to last row and quantity is added create new row
			if(rowIndex === vm.records.length-1) {
				createEmptyRow();
			}
		}

		function getLookupDisplayValue(item) {
				return loadCatalogAttributes()
        .then(function(catalogAttributes) {
          return getLookupDisplayVal(item, catalogAttributes);
        });
		}

		function getLookupDisplayVal(item, catalogAttributes) {
			var result;
			if (catalogAttributes) {
				// since autocomplete return object
				if (angular.isObject(item)) {
					result = utility.filterObject(catalogAttributes, { Attributeid: item.Attributeid }, true);
				}
				// to initialize field value if any (when open update record dialog)
				else {
					result = utility.filterObject(catalogAttributes, { Attributeid: item }, true);
				}

				if (angular.isArray(result) && result.length > 0) {
					return result[0].AttributeDisplayName;
				}
				else {
					return result.AttributeDisplayName;
				}
			}
		}

		function selectText(event) {
			utility.selectInputText(event);
		}

		function onAccountTypeChange(accountType) {
			vm.accountTypeId = accountType.id;
		}

		function populateEditDialog() {
			angular.forEach(record.Attributes, function(attribute) {
				var recordsLength = vm.records.push({ Id: attribute.Id, NotEditable: attribute.NotEditable, NotViewable: attribute.NotViewable });
				if(angular.isUndefined(vm.lookupModel[recordsLength-1])) {
					vm.lookupModel[recordsLength-1] = {};
				}
				vm.lookupModel[recordsLength-1].Id = attribute.Id;
				assignedAttributesMap[attribute.Id] = 1;
			});
			if(angular.isUndefined(vm.lookupModel)) {
				vm.lookupModel = {};
			}
			vm.lookupModel.roleName = record.RoleName;
			createEmptyRow();
		}

		function createEmptyRow() {
			vm.searchText.push({});
      vm.lookupModel.push({});
			vm.records.push({ Id: null, NotViewable: 0, NotEditable: 0 });
		}

		function loadAvailableRoles() {
      return promises['rolesPromise']
        .then(function(response) {
          var rolesList = response.data;
          if(isNew) {
            angular.forEach(assignedRolesList, function (role) {
              var index = rolesList.indexOf(utility.filterObject(rolesList, { Id: role['RoleId'] }, true)[0]);
              if (index !== -1) {
                rolesList.splice(index, 1);
              }
            });
          }
          return rolesList;
        });
    }

		function loadAvailableAttributes() {
      var availableBucketAttributes = [];
      return loadCatalogAttributes()
      .then(function(catalogAttributes) {
        angular.forEach(catalogAttributes, function (catalogAttribute) {
          if (catalogAttribute.Status && !assignedAttributesMap[catalogAttribute.Attributeid]) {
            availableBucketAttributes.push(catalogAttribute);
          }
        })
        return availableBucketAttributes;
      });
    }

		function loadCatalogAttributes() {
      return promises['catalogAttributesPromise']
        .then(function (response) {
          return utility.filterObject(response.data.AttributeList, { Status: 1 });
        });
    }
	}
})();
(function() {
		'use strict';

		angular
				.module('app.main.catalogs.catalog-color-palette', [])
				.config(config);

		/* @ngInject */
		function config($translatePartialLoaderProvider) {

				// Translation
				$translatePartialLoaderProvider.addPart('app/main/catalogs/details/tabs/catalog-color-palette');
		}
})();
(function () {
	'use strict';

	angular
		.module('app.main.catalogs.catalog-color-palette')
		.controller('viewColorsListController', viewColorsListController);

	/* @ngInject */
	function viewColorsListController($mdDialog, model, data) {
		var vm = this;

		vm.data = data;
		vm.model = model;
		vm.filteredData = [];

		vm.closeDialog = closeDialog;

		function closeDialog() {
			$mdDialog.hide();
		}

	}
})();
(function () {
	'use strict';

	angular
		.module('app.main.catalogs.catalog-color-palette')
		.controller('addOrUpdateColorPaletteController', addOrUpdateColorPaletteController);

	/* @ngInject */
	function addOrUpdateColorPaletteController($mdDialog, $scope, $filter, $mdConstant, toast, hotkeys, utility, record, isNew, model, promises, activeCatalogCode, sellerId, assignedCatalogAttributes, existingRecordsForUniqueValue, event, $q, api) {
		/* jshint validthis: true */
		var vm = this;

		//Data
		vm.isLoading = false;
		vm.isDataDirty = false;
		vm.isNew = isNew;
		vm.record = { SellerColorIds: isNew ? [] : generateColorIds(record) };
		vm.existingRecordsForUniqueValue = existingRecordsForUniqueValue;
		vm.sellerColors = [];
		vm.searchText = [];        // [groupIndex][rowIndex] -> attribute autocomplete search text
		vm.lookupModel = [];       // [groupIndex][rowIndex] -> attribute selected in that row
		vm.acSearchText = [];
		vm.acSelectedItem = [];
		vm.tagSeperatorKeys = {};

		// A palette can carry several criteria: the conditions inside one criteria are AND'ed, and the
		// criteria themselves are OR'ed (a color is offered when any one of them matches). Each criteria
		// keeps its own rows, so the same attribute can be used in another criteria with a different
		// value - which is the whole point - but not twice inside one criteria.
		vm.criteriaGroups = [];
		var assignedAttributes = [];   // [groupIndex] -> {Attributeid: true} for the attributes already used

		//Methods
		vm.saveRecord = saveRecord;
		vm.closeDialog = closeDialog;

		vm.addGroup = addGroup;
		vm.removeGroup = removeGroup;
		vm.removeRow = removeRow;
		vm.clearRowError = clearRowError;

		vm.lookupAttributeSearch = lookupAttributeSearch;
		vm.lookupAttributeChange = lookupAttributeChange;
		vm.getAttributeLookupDisplayValue = getAttributeLookupDisplayValue;
		vm.selectText = selectText;
		vm.getDateObj = getDateObj;
		vm.multiValueQuerySearch = multiValueQuerySearch;
		vm.add = add;
		vm.transformChip = transformChip;
		vm.transformColorChip = transformColorChip;
		vm.acQuerySearch = acQuerySearch;
		vm.getChipDisplayValue = getChipDisplayValue;

		activate();

		////////////////

		function activate() {
			loadSellerColors();
			if (!vm.isNew) {
				populateEditDialog();
			}
			else {
				addGroup();
			}
			//Hotkeys
			hotkeys.bindTo($scope).add({
				combo: 'ctrl+enter',
				description: $filter('translate')('ACTIONS.SAVE'),
				allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
				callback: function (event) {
					if (!vm.isLoading && !vm.editForm.$invalid) {
						vm.saveRecord();
					}
				}
			});
		}

		function saveRecord() {
			var criteria = buildCriteria();

			// incomplete or repeated criteria are reported here rather than through the form, because a
			// criteria is only valid as a whole (see validateCriteria)
			if (!validateCriteria(criteria)) {
				return;
			}

			var colorCriteria = serializeCriteria(criteria.groups);
			var requestObject = {
				Name: vm.record.Name,
				SellerColorIds: vm.record.SellerColorIds
			};
			// on create the property is left out when there is no criteria, as it always has been; on update
			// it is sent empty as well, so criteria can be removed from an existing palette
			if (colorCriteria !== '' || !vm.isNew) {
				requestObject['ColorCriteria'] = colorCriteria;
			}
			if(!vm.isNew) {
				requestObject['Id'] = record.Id;
			}

			vm.isLoading = true;
			var p;
			if (vm.isNew) {
					p = model.methods.create([requestObject], activeCatalogCode);
			} else {
					p = model.methods.update([requestObject], activeCatalogCode);
			}
			p.then(function () {
				closeDialog(true);
				var toastMessage = vm.isNew ? 'SUCCESS.CREATE' : 'SUCCESS.UPDATE';
				toast.success(toastMessage, '', '');
			}, function () {
				closeDialog(vm.isDataDirty);
			}).finally(function () {
				vm.isLoading = false;
			});
		}

		function closeDialog(saved) {
			$mdDialog.hide(saved);
		}

		// Criteria builder ------------------------------------------------------

		function addGroup() {
			vm.criteriaGroups.push({ rows: [] });
			vm.searchText.push([]);
			vm.lookupModel.push([]);
			assignedAttributes.push({});
			createEmptyRow(vm.criteriaGroups.length - 1);
		}

		function removeGroup(groupIndex) {
			vm.criteriaGroups.splice(groupIndex, 1);
			vm.searchText.splice(groupIndex, 1);
			vm.lookupModel.splice(groupIndex, 1);
			assignedAttributes.splice(groupIndex, 1);
			// the criteria block is always present, so removing the last one leaves an empty criteria
			if (!vm.criteriaGroups.length) {
				addGroup();
			}
		}

		function removeRow(groupIndex, rowIndex) {
			var row = vm.criteriaGroups[groupIndex].rows[rowIndex];
			if (angular.isDefined(row) && row.Attributeid != null) {
				delete assignedAttributes[groupIndex][row.Attributeid];
			}
			vm.criteriaGroups[groupIndex].rows.splice(rowIndex, 1);
			vm.searchText[groupIndex].splice(rowIndex, 1);
			vm.lookupModel[groupIndex].splice(rowIndex, 1);
			// keep a trailing empty row so another condition can always be added
			if (!hasEmptyRow(groupIndex)) {
				createEmptyRow(groupIndex);
			}
		}

		function createEmptyRow(groupIndex) {
			vm.searchText[groupIndex].push({});
			vm.lookupModel[groupIndex].push({});
			vm.criteriaGroups[groupIndex].rows.push({ Attributeid: null });
		}

		function hasEmptyRow(groupIndex) {
			var rows = vm.criteriaGroups[groupIndex].rows;
			for (var i = 0; i < rows.length; i++) {
				if (rows[i].Attributeid == null) {
					return true;
				}
			}
			return false;
		}

		// Only the attributes not already used in THIS criteria are offered, so one criteria cannot
		// hold the same attribute twice. Another criteria is free to use it again.
		function lookupAttributeSearch(query, groupIndex) {
			var predicate = {};
			predicate.AttributeDisplayName = query;
			return loadAvailableAttributes(groupIndex)
				.then(function (availableAttributes) {
					return query ? utility.filterObject(availableAttributes, predicate) : availableAttributes;
				});
		}

		function lookupAttributeChange(selectedObj, groupIndex, rowIndex) {
			var rows = vm.criteriaGroups[groupIndex].rows;
			var previousAttributeId = rows[rowIndex].Attributeid;
			if (previousAttributeId != null) {
				delete assignedAttributes[groupIndex][previousAttributeId];
			}

			if (angular.isObject(selectedObj)) {
				rows[rowIndex] = utility.changeAttributeType(selectedObj);
				rows[rowIndex].value = isMultiValueInput(rows[rowIndex]) ? [] : '';
				assignedAttributes[groupIndex][selectedObj.Attributeid] = true;
				updateSeparatorKeys(rows[rowIndex]);
			}
			else if (angular.isUndefined(selectedObj) || selectedObj === null) {
				// the autocomplete owns vm.lookupModel[groupIndex][rowIndex].Attributeid, so it is left
				// alone here: writing to it would re-enter this handler through its own watcher
				rows[rowIndex] = { Attributeid: null };
			}

			clearGroupErrors(groupIndex);
			if (!hasEmptyRow(groupIndex)) {
				createEmptyRow(groupIndex);
			}
		}

		// Resolved against the attributes already loaded with the dialog, so the autocomplete has a
		// display value to show straight away instead of waiting on a promise
		function getAttributeLookupDisplayValue(item) {
			var result;
			if (!assignedCatalogAttributes) {
				return;
			}
			// since autocomplete return object
			if (angular.isObject(item)) {
				result = utility.filterObject(assignedCatalogAttributes, { Attributeid: item.Attributeid }, true);
			}
			// to initialize field value if any (when open update record dialog)
			else {
				result = utility.filterObject(assignedCatalogAttributes, { Attributeid: item }, true);
			}

			if (angular.isArray(result) && result.length > 0) {
				return result[0].AttributeDisplayName;
			}
			else if (result) {
				return result.AttributeDisplayName;
			}
		}

		function clearRowError(row) {
			row.hasValueError = false;
		}

		function clearGroupErrors(groupIndex) {
			vm.criteriaGroups[groupIndex].isDuplicate = false;
			angular.forEach(vm.criteriaGroups[groupIndex].rows, function (row) {
				row.hasValueError = false;
			});
		}

		// Serialize the rows of every criteria into {AttributeSystemName: value} conditions. Rows without
		// an attribute are ignored (the trailing empty row), rows with an attribute but no value are
		// reported back so the user can complete or remove them, and a criteria left without any
		// condition is dropped.
		function buildCriteria() {
			var groups = [];
			var incompleteRows = [];

			angular.forEach(vm.criteriaGroups, function (group, groupIndex) {
				var conditions = {};
				group.isDuplicate = false;

				angular.forEach(group.rows, function (row) {
					row.hasValueError = false;
					if (row.Attributeid == null) {
						return;
					}
					if (isEmptyValue(row.value)) {
						row.hasValueError = true;
						incompleteRows.push({ groupIndex: groupIndex, row: row });
						return;
					}
					addCondition(conditions, row);
				});

				if (!utility.isObjectEmpty(conditions)) {
					groups.push({ conditions: conditions, groupIndex: groupIndex });
				}
			});

			return { groups: groups, incompleteRows: incompleteRows };
		}

		function validateCriteria(criteria) {
			if (criteria.incompleteRows.length) {
				var incomplete = criteria.incompleteRows[0];
				toast.error('CATALOG_COLOR_PALETTE.MESSAGES.CRITERIA_VALUE_REQUIRED', '',
					criteriaLabel(incomplete.groupIndex) + ': ' + incomplete.row.AttributeDisplayName);
				return false;
			}

			var duplicate = findDuplicateGroup(criteria.groups);
			if (duplicate !== null) {
				vm.criteriaGroups[criteria.groups[duplicate.index].groupIndex].isDuplicate = true;
				toast.error('CATALOG_COLOR_PALETTE.MESSAGES.CRITERIA_DUPLICATE', '',
					criteriaLabel(criteria.groups[duplicate.index].groupIndex) + ' / ' + criteriaLabel(criteria.groups[duplicate.firstIndex].groupIndex));
				return false;
			}

			return true;
		}

		// Two criteria holding the same conditions would be OR'ed with each other, which says nothing
		// new, so the second one is rejected instead of being saved.
		function findDuplicateGroup(groups) {
			var seen = {};
			for (var i = 0; i < groups.length; i++) {
				var key = canonicalConditions(groups[i].conditions);
				if (angular.isDefined(seen[key])) {
					return { index: i, firstIndex: seen[key] };
				}
				seen[key] = i;
			}
			return null;
		}

		// Order-independent representation of one criteria, so {A,B} and {B,A} count as the same.
		function canonicalConditions(conditions) {
			var attributes = Object.keys(conditions).sort();
			var parts = [];
			angular.forEach(attributes, function (attribute) {
				var values = angular.isArray(conditions[attribute]) ? conditions[attribute].slice().sort() : [conditions[attribute]];
				parts.push(attribute + '=' + values.join('|'));
			});
			return parts.join('&');
		}

		// A single criteria is stored as the plain {Attribute: value} object it has always been, and only
		// several criteria are stored as an array. Palettes with one criteria therefore keep a shape that
		// every consumer already understands.
		function serializeCriteria(groups) {
			if (!groups.length) {
				return '';
			}
			var conditions = groups.map(function (group) {
				return group.conditions;
			});
			return angular.toJson(conditions.length === 1 ? conditions[0] : conditions);
		}

		// Add one row to a criteria. Repeated rows for the same attribute (only reachable from criteria
		// stored before this dialog, since the picker no longer offers a used attribute) are merged into
		// a list of accepted values.
		function addCondition(conditions, row) {
			var value = getRowValue(row);
			if (angular.isUndefined(conditions[row.AttributeSystemName])) {
				conditions[row.AttributeSystemName] = value;
				return;
			}
			var existing = conditions[row.AttributeSystemName];
			var values = angular.isArray(existing) ? existing : [existing];
			conditions[row.AttributeSystemName] = values.concat(angular.isArray(value) ? value : [value]);
		}

		function getRowValue(row) {
			if (row.inputType === 'date-without-time' || row.inputType === 'date-option') {
				return toCriteriaDateValue(row.value);
			}
			return row.value;
		}

		// Dates are compared against date-only attribute values, so the time is dropped after pulling the
		// value away from the day boundary (the same correction the article dialogs apply).
		function toCriteriaDateValue(value) {
			if (!angular.isDate(value)) {
				return value;
			}
			var utcDate = utility.setDateHourUTC(value, 12);
			return utcDate.toISOString().split('T')[0];
		}

		function isEmptyValue(value) {
			if (angular.isArray(value)) {
				return !value.length;
			}
			if (angular.isDate(value)) {
				return false;
			}
			return value === null || angular.isUndefined(value) || value.toString().trim() === '';
		}

		function isMultiValueInput(row) {
			return row.inputType === 'multi-value' || row.inputType === 'tags';
		}

		function criteriaLabel(groupIndex) {
			return $filter('translate')('CATALOG_COLOR_PALETTE.CRITERIA.TITLE', { number: groupIndex + 1 });
		}

		/**
		 * Enable Enter and the separator key defined on the attribute to be used as chip separators
		 */
		function updateSeparatorKeys(row) {
			vm.tagSeperatorKeys[row.AttributeSystemName] = [$mdConstant.KEY_CODE.ENTER];
			if (angular.isDefined(row.tagSeparator)) {
				var additionalSeparator = row.tagSeparator.charCodeAt();
				if (angular.isDefined(additionalSeparator) && !isNaN(additionalSeparator)) {
					vm.tagSeperatorKeys[row.AttributeSystemName].push(additionalSeparator);
				}
			}
		}

		// Colors and value controls ---------------------------------------------

		function selectText(event) {
			utility.selectInputText(event);
		}

		function getDateObj(dateString, fromUTC) {
			if (dateString) {
				return utility.createDateObject(dateString, fromUTC);
			}
		}

		function multiValueQuerySearch(query, selectedItems, field) {
			var values = field.values;
			var searchQueryResult = utility.filterObject(values, query);
			if (selectedItems && selectedItems.length > 0) {
				for (var index = searchQueryResult.length - 1; index >= 0; index--) {
					if (selectedItems.indexOf(searchQueryResult[index]) !== -1) {
						searchQueryResult.splice(index, 1);
					}
				}
			}
			return searchQueryResult;
		}

		// on addition of new tag it validates that the tag should not contain the separator
		function add(chip, row) {
			if (chip && angular.isDefined(row.tagSeparator) && chip.indexOf(row.tagSeparator) !== -1) {
				row.value.splice(row.value.indexOf(chip), 1);
				row.value = row.value.concat(chip.split(row.tagSeparator));
			}
			clearRowError(row);
		}

		function transformChip(chip) {
			if (angular.isObject(chip)) {
				return chip.id;
			}
			return undefined;
		}

		function getChipDisplayValue(chip, sellerColors) {
				var res = utility.filterObject(sellerColors, {ColorId: chip}, true);
				if (angular.isArray(res) && res.length > 0) {
						return res[0].ColorName;
				}
		}

		function acQuerySearch(query, selectedItems, sellerColors) {
				var searchQueryResult = [];
				if(angular.isDefined(sellerColors) && vm.sellerColors.length) {
						searchQueryResult = utility.filterObject(vm.sellerColors, query);
						searchQueryResult = removeSelectedRecods(selectedItems, searchQueryResult);
						return searchQueryResult;
				}
				else {
						return searchQueryResult;
				}
		}

		function transformColorChip(chip) {
			if (angular.isObject(chip)) {
				return chip.ColorId;
			}
			return undefined;
		}

		function removeSelectedRecods(selectedItems, searchQueryResult) {
				if (angular.isDefined(selectedItems) && selectedItems.length > 0) {
						for (var index = searchQueryResult.length-1; index >= 0; index--) {
								if (selectedItems.indexOf(searchQueryResult[index].ColorId) !== -1) {
										searchQueryResult.splice(index,1);
								}
						}
				}
				return searchQueryResult;
		}

		// Loading an existing palette -------------------------------------------

		function populateEditDialog() {
			// accepts both the stored shapes: one criteria as a plain object, several as an array
			var storedGroups = utility.normalizeColorCriteria(record.ColorCriteria);

			angular.forEach(storedGroups, function (storedGroup) {
				addGroup();
				populateGroup(vm.criteriaGroups.length - 1, storedGroup);
			});

			if (!vm.criteriaGroups.length) {
				addGroup();
			}

			vm.record.Name = record.Name;
			for (var i = 0; i < existingRecordsForUniqueValue.length; i++) {
				if(existingRecordsForUniqueValue[i].Id === record.Id) {
					existingRecordsForUniqueValue.splice(i, 1);
				}
			}
		}

		function populateGroup(groupIndex, storedGroup) {
			for (var attributeSystemName in storedGroup) {
				if (!storedGroup.hasOwnProperty(attributeSystemName)) {
					continue;
				}
				var attribute = utility.filterObject(assignedCatalogAttributes, {AttributeSystemName: attributeSystemName}, true)[0];
				// an attribute that no longer exists on the catalog cannot be shown, and is therefore
				// dropped from the criteria if the palette is saved again
				if (angular.isUndefined(attribute)) {
					continue;
				}

				var typedAttribute = utility.changeAttributeType(attribute);
				var values = storedGroup[attributeSystemName];

				if (isMultiValueInput(typedAttribute)) {
					addPopulatedRow(groupIndex, attribute, values);
				} else {
					// criteria written before this dialog could hold several values for one attribute; each
					// one gets its own row so nothing is hidden from the user
					angular.forEach(values, function (value) {
						addPopulatedRow(groupIndex, attribute, value);
					});
				}
			}
		}

		function addPopulatedRow(groupIndex, attribute, value) {
			var rows = vm.criteriaGroups[groupIndex].rows;
			var rowIndex = rows.length - 1;   // reuse the trailing empty row

			vm.lookupModel[groupIndex][rowIndex] = { Attributeid: attribute.Attributeid };
			rows[rowIndex] = utility.changeAttributeType(attribute);
			rows[rowIndex].value = value;
			assignedAttributes[groupIndex][attribute.Attributeid] = true;
			updateSeparatorKeys(rows[rowIndex]);

			createEmptyRow(groupIndex);
		}

		function generateColorIds(colorPalette) {
			if(colorPalette.Colors && colorPalette.Colors.length) {
				return colorPalette.Colors.map(function(color) {
					return color.ColorId;
				})
			}
			return [];
		}

		function loadAvailableAttributes(groupIndex) {
			var availableAttributes = [];
			return loadCatalogAttributes()
			.then(function(catalogAttributes) {
				angular.forEach(catalogAttributes, function (catalogAttribute) {
					if (catalogAttribute.Status && !assignedAttributes[groupIndex][catalogAttribute.Attributeid]) {
						availableAttributes.push(catalogAttribute);
					}
				})
				return availableAttributes;
			});
		}

		function loadCatalogAttributes() {
			return promises['catalogAttributesPromise'].then(function (response) {
					return utility.filterObject(response.data.AttributeList, { Status: 1 });
				});
		}

		function loadSellerColors() {
			var deferred = $q.defer();
			var generalProperties = {
					forceFetch: true,
					isLogRequired: false
			}
			api.sellers.sellerColors.methods.getList(generalProperties, sellerId).then(function(response) {
				 vm.sellerColors = utility.filterObject(response.data);
				 deferred.resolve(vm.sellerColors);
			});
			return deferred.promise;
		}
	}
})();

(function() {
  'use strict';

  angular
      .module('app.main.accounts.users.catalog-access', []);
})();
(function () {
  'use strict';

  angular
    .module('app.main.accounts.users.catalog-access')
    .controller('assignCatalogToSellerUserController', assignCatalogToSellerUserController);

  /* @ngInject */
  function assignCatalogToSellerUserController($q, $mdDialog, $scope, $window, $log, $filter, hotkeys, utility, model,
                                                event, assignedCatalogs, accountId, userId) {
    /* jshint validthis: true */
    var vm = this;

    //Data
    vm.isLoading = false;
    vm.isDataDirty = false;
    var availableCatalogs = [];

    vm.assignedCatalogCodes = [];
    vm.acSelectedItem = {};
    vm.searchText = '';


    //Methods
    vm.saveRecord = saveRecord;
    vm.closeDialog = closeDialog;

    vm.transformChip = transformChip;
    vm.querySearch = querySearch;
    vm.getChipDisplayValue = getChipDisplayValue;

    activate();

    //////////////////

    function activate() {
      loadAvailableCatalogs()
        .then(function(availableCatalogsResponse) {
          availableCatalogs = availableCatalogsResponse
        });
      hotkeys.bindTo($scope).add({
        combo: 'ctrl+enter',
        description: $filter('translate')('ACTIONS.SAVE'),
        allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
        callback: function (event) {
          if (!vm.isLoading && !vm.editForm.$invalid) {
            vm.saveRecord();
          }
        }
      });
      hotkeys.bindTo($scope).add({
        combo: 'ctrl+shift+enter',
        description: $filter('translate')('ACTIONS.SAVE_AND_NEW'),
        allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
        callback: function (event) {
          if (!vm.isLoading && !vm.editForm.$invalid) {
            vm.saveRecord(true);
          }
        }
      });
    }

    function saveRecord(saveAndNew) {
      vm.isLoading = true;
      var mapedResult = [];
      angular.forEach(vm.assignedCatalogCodes, function(assignedCatalogCode) {
        var resultObj = {};
        resultObj[model.idField] = assignedCatalogCode
        resultObj[model.lookupDisplayField] = utility.filterObject(availableCatalogs, {CatalogCode: assignedCatalogCode}, true)[0][model.lookupDisplayField]
        mapedResult.push(resultObj);
      });
      model.methods.activateBulk(mapedResult, model, 'activate', accountId, userId).then(function () {
        if (angular.isDefined(saveAndNew) && saveAndNew) {
          vm.editForm.$setPristine();
          vm.editForm.$setUntouched();
          resetDialog()
          vm.isDataDirty = true;
          var el = $window.document.getElementById('dialog_input_first');
          if (el) {
            el.focus();
          }
        } else {
          closeDialog(true);
        }
      }, function () {
        closeDialog(vm.isDataDirty);
      }).finally(function () {
        vm.isLoading = false;
      });
    }

    function closeDialog(saved) {
      $mdDialog.hide(saved);
    }

    function transformChip(chip) {
      if (angular.isObject(chip)) {
        return chip.CatalogCode;
      }
      return undefined;
    }

    function querySearch(search, selectedRecords) {
      var predicate = {};
      var results = [];
      predicate.CatalogName = search;
      if (availableCatalogs.length) {
        results = search ? utility.filterObject(availableCatalogs, predicate) : angular.copy(availableCatalogs);
        results = removeSelectedChips(selectedRecords, results);
      }
      else {
        loadAvailableCatalogs().then(function (availableCatalogResult) {
          results = search ? utility.filterObject(availableCatalogResult, predicate) : availableCatalogResult;
          results = removeSelectedChips(selectedRecords, results);
        });
      }
      return results;
    }

    function getChipDisplayValue(chip) {
      if (availableCatalogs.length) {
        return getChipDisplayVal(availableCatalogs, chip);
      }
      else {
        return loadAvailableCatalogs().then(function (availableCatalogResult) {
          return getChipDisplayVal(availableCatalogResult, chip);
        });
      }
    }


    //helper methods

    function loadAvailableCatalogs() {
      var availableCatalogs = [];
      var generalProperties = {
        forceFetch: true,
        isLogRequired: false
      }
      var deferred = $q.defer();
      var promise = deferred.promise;
      model.methods.getSellerCatalogs(generalProperties, accountId).then(function (response) {
        availableCatalogs = utility.filterObject(response.data, { Status: 1 });
        angular.forEach(assignedCatalogs, function (assignedCatalog) {
          var index = availableCatalogs.indexOf(utility.filterObject(availableCatalogs, { CatalogCode: assignedCatalog[model.idField] }, true)[0]);
          if (index !== -1) {
            availableCatalogs.splice(index, 1);
          }
        });
        deferred.resolve(utility.orderBy(availableCatalogs, 'CatalogName'));
      });
      return promise;
    }

    function getChipDisplayVal(availableCatalogs, chip) {
      if (availableCatalogs.length) {
        var res = utility.filterObject(availableCatalogs, { CatalogCode: chip }, true);
        if (res.length > 0) {
          return res[0].CatalogName;
        }
        else {
          $log.warn('viewCreator controller: Unable to resolve chip display value!');
          return "";
        }
      }
      else {
        return loadAvailableCatalogs().then(function (availableCatalogResult) {
          var res = utility.filterObject(availableCatalogResult, { CatalogCode: chip }, true);
          if (res.length > 0) {
            return res[0].CatalogName;
          }
          else {
            $log.warn('viewCreator controller: Unable to resolve chip display value!');
            return "";
          }
        });
      }
    }

    function removeSelectedChips(selectedRecords, records) {
      if (angular.isDefined(selectedRecords) && selectedRecords.length > 0) {
        for (var index = records.length - 1; index >= 0; index--) {
          if (selectedRecords.indexOf(records[index].CatalogCode) !== -1) {
            records.splice(index, 1);
          }
        }
      }
      return records;
    }

    function resetDialog() {
      vm.acSelectedItem = {};
      vm.searchText = '';
      for (var index = availableCatalogs.length - 1; index >= 0; index--) {
        if (vm.assignedCatalogCodes.indexOf(availableCatalogs[index].CatalogCode) > -1) {
          availableCatalogs.splice(index, 1);
        }
      }
      vm.assignedCatalogCodes = [];
    }
  }
})();
(function() {
    'use strict';

    angular
        .module('app.main.accounts.sellers.size-scale-groups', []);
})();
(function () {
	'use strict';

	angular
		.module('app.main.accounts.sellers.size-scale-groups')
		.controller('addUpdateSizeScaleController', addUpdateSizeScaleController);

	/* @ngInject */
	function addUpdateSizeScaleController($mdDialog, $scope, $filter, toast, hotkeys, utility, record, isNew, model, promises, existingRecordsForUniqueValue, sellerId, event) {
		/* jshint validthis: true */
		var vm = this;

		//Data
		vm.isLoading = false;
		vm.isDataDirty = false;
		vm.isNew = isNew;
		vm.record = angular.copy(record);
		vm.selectedSizeScales = record;

		vm.acSelectedItem = [];
		vm.acSearchText = [];
		vm.searchText = [];
		vm.lookupModel = [];
		vm.masterSizeScaleList = [];
		vm.availableSizes = [];
		vm.existingRecordsForUniqueValue = existingRecordsForUniqueValue;

		if (!vm.record) {
			vm.record = {};
			vm.record['Sizes'] = [];
			vm.record.IsObsolete = 0; // default
		} else {
			vm.record.Sizes = vm.record.Sizes.split(',');
			vm.lookupModel.MasterSizeScaleId = vm.record.MasterSizeScaleId;
			loadAvailableMasterSizeScales();
		}

		//Methods
		vm.saveRecord = saveRecord;
		vm.closeDialog = closeDialog;

		vm.searchMasterSizeScale = searchMasterSizeScale;
		vm.getMasterSizeScaleDisplayValue = getMasterSizeScaleDisplayValue;
		vm.onMasterSizeScaleChange = onMasterSizeScaleChange;
		vm.selectText = selectText;

		vm.transformChip = transformChip;
		vm.acQuerySearch = acQuerySearch;
		vm.getChipDisplayValue = getChipDisplayValue;

		activate();

		////////////////

		function activate() {
			//Hotkeys
			hotkeys.bindTo($scope).add({
				combo: 'ctrl+enter',
				description: $filter('translate')('ACTIONS.SAVE'),
				allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
				callback: function (event) {
					if (!vm.isLoading && !vm.editForm.$invalid) {
						vm.saveRecord();
					}
				}
			});
		}

		function saveRecord() {
			vm.isLoading = true;
			var p;

			if (vm.isNew)
			{
					p = model.methods.create(vm.record, sellerId);
			} else {
					p = model.methods.update(vm.record.Id, vm.record, sellerId);
			}

			p.then(function(response) {
					closeDialog(true);
					var toastMessage;
					toastMessage = response.config.method.toUpperCase() === 'POST' ? 'SUCCESS.CREATE': 'SUCCESS.UPDATE';
					toast.success(toastMessage, '', '');
			}, function() {
					closeDialog(vm.isDataDirty);
			}).finally(function () {
					vm.isLoading = false;
			});
		}

		function closeDialog(saved) {
			$mdDialog.hide(saved);
		}

		function searchMasterSizeScale(query) {
			return loadAvailableMasterSizeScales()
				.then(function(masterSizeScaleList) {
					var predicate = { SizeScale: query };
					return query ? utility.filterObject(masterSizeScaleList, predicate) : masterSizeScaleList;
				});
		}

		function getMasterSizeScaleDisplayValue(item) {
			return loadAvailableMasterSizeScales()
				.then(function(masterSizeScaleList) {
					var result;
					if(angular.isObject(item)) {
						result = utility.filterObject(masterSizeScaleList, { Id: item.Id }, true)[0]
					}
					else {
						result = utility.filterObject(masterSizeScaleList, { Id: item }, true)[0];
					}
					if(result) {
						return result.SizeScale;
					}
			});
		}

		function onMasterSizeScaleChange(selectedObj) {
			if (angular.isObject(selectedObj)) {
				vm.record['MasterSizeScaleId'] = selectedObj.Id;
				var sizes = selectedObj.Sizes.split(',');
				if(sizes.length) {
					vm.availableSizes = sizes;
				}
				// filter the size scales under the selected master size scale for UniqueValue check
				vm.existingRecordsForUniqueValue = utility.filterObject(existingRecordsForUniqueValue, {MasterSizeScaleId: selectedObj.Id}, true);
			}
			else if (angular.isUndefined(selectedObj) || selectedObj === null) {
				vm.record['MasterSizeScaleId'] = undefined; // on record removal make field undefined or the property can be deleted using delete keyword
				vm.record['Sizes'] = [];
				vm.availableSizes = [];
				vm.existingRecordsForUniqueValue = [];
			}
		}

		function selectText(event) {
			utility.selectInputText(event);
		}

		function transformChip(chip) {
			if (angular.isObject(chip)) {
				return chip;
			}
			return undefined;
		}

		function acQuerySearch(query, selectedRecords, allAttributes) {
			var searchQueryResult = [];
				if(angular.isDefined(allAttributes) && allAttributes.length) {
						searchQueryResult = utility.filterObject(allAttributes, query);
						removeSelectedChips(selectedRecords, searchQueryResult);
						return searchQueryResult;
				}
				else {
					return searchQueryResult;
				}
		}

		/**
		 * @description
		 * This method will remove selected chips form records (helper method)
		 * @param {array} selectedRecords: list of selected chips
		 * @param {array} records: data property of lookup-data
		 * @returns {array}: list of available chips (chips which are not selected) // it does not really need to return a value but for readability returning modified value
		 */
		function removeSelectedChips(selectedRecords, records) {
			if (angular.isDefined(selectedRecords) && selectedRecords.length > 0) {
				for (var index = records.length - 1; index >= 0; index--) {
					if (selectedRecords.indexOf(records[index]) !== -1) {
						records.splice(index, 1);
					}
				}
			}
			return records;
		}

		function getChipDisplayValue(chip) {
			return chip;
		}

		function loadAvailableMasterSizeScales() {
			return promises['masterSizeScalePromise']
				.then(function(response) {
					vm.masterSizeScaleList = utility.filterObject(response.data, {Status: 1}, true);
					if(vm.record) {
						var selectedMasterSizeScale = utility.filterObject(vm.masterSizeScaleList, {Id: vm.record.MasterSizeScaleId}, true)[0];
						var availableSizes = selectedMasterSizeScale.Sizes.split(',');
						var obsoleteSizes = selectedMasterSizeScale.ObsoleteSizes.split(',');
						var obsoleteSizesLower = obsoleteSizes.map(function(size) {
								return size.toLowerCase();
						});

						// filter out obsolete sizes in a case-insensitive manner
						var filteredSizes = availableSizes.filter(function(size) {
							return !obsoleteSizesLower.includes(size.toLowerCase());
						});

						// set the updated available sizes
						vm.availableSizes = filteredSizes;
					}
					// Sort the vm.masterSizeScaleList by SizeScale
					vm.masterSizeScaleList.sort(function(a, b) {
						if (a.SizeScale && b.SizeScale) {
								return a.SizeScale.toLowerCase().localeCompare(b.SizeScale.toLowerCase());
						}
						return 0;
					});
					return vm.masterSizeScaleList;
				});
		}

	}
})();
(function() {
    'use strict';

    angular
        .module('app.main.accounts.sellers.seller-resources')
        .controller('createSellerResourceController', createSellerResourceController);

    /* @ngInject */
    function createSellerResourceController(api, $mdDialog, $scope, $window, $filter, hotkeys, $rootScope, $localStorage,
            utility, $auth, toast, model, sellerId, attributeGroupId, record, isNew, event) {
        /* jshint validthis: true */
        var vm = this;

        //Data
        vm.model = model;
        if (angular.isUndefined($rootScope.flowObj) || angular.isUndefined($rootScope.flowObj2)) {
            $rootScope.flowObj = {};
            $rootScope.flowObj2 = {};
        }
        vm.obj = $rootScope.flowObj;
        vm.obj2 = $rootScope.flowObj2;

        vm.flowInit = {
            target      : $localStorage.baseUrl + '/UploadFileChunk',
            headers     : { Authorization: 'Bearer ' + $auth.getToken()},
            singleFile  : true
        };

        vm.isFileValid = true;
        vm.isResourceFileValid = true;
        vm.isIconFileValid = true;
        vm.isLoading = false;
        vm.isNew = angular.isDefined(isNew) ? isNew : true;
        vm.record = (angular.isDefined(record) && record != null) ? angular.copy(record) : {};
        if(vm.isNew) {
            vm.record.IsModelLevel = null;
            vm.record.Cascading = 1;
            vm.record.ArticleIds = [];
            vm.record.ModelIds = [];
        }
        vm.resourceName = '';
        vm.iconName = '';
        if(vm.record.FileName) {
            vm.resourceName = vm.record.FileName.slice(vm.record.FileName.lastIndexOf('/') + 1, vm.record.FileName.length);
        }
        if(vm.record.Icon) {
            vm.iconName = vm.record.Icon.slice(vm.record.Icon.lastIndexOf('/') + 1, vm.record.Icon.length);
        }

        vm.lookupModel = angular.copy(vm.record);
        vm.searchText = {};
        vm.allowedFileTypesList = ['pdf', 'jpg', 'jpeg', 'png', 'mp4', 'mpeg', 'mpg', 'avi', 'ppt', 'pptm', 'pptx'];
        vm.allowedFileTypeExtentions = [];
        vm.acSelectedItem = {};
        vm.acSearchText = {};
        var localLookupData = { ArticleIds: [], ModelIds: [] };
        var articlesBaseUrl = api.baseUrl + '/sellers/' + sellerId + '/attributegroups/' + attributeGroupId + '/articles?getSimplifiedSellerArticles=1';
        var modelsBaseUrl = api.baseUrl + '/sellers/' + sellerId + '/' + attributeGroupId + '/models';
        var latestSearchQuery = {};

        //Methods
        vm.saveRecord = saveRecord;
        vm.closeDialog = closeDialog;
        vm.onResourceTypeChange = onResourceTypeChange;
        vm.validateFile = validateFile;
        vm.upload = upload;
        vm.onSuccessUpload = onSuccessUpload;
        vm.onModelLevelToggleChange = onModelLevelToggleChange;

        vm.transformChip = transformChip;
        vm.acQuerySearch = acQuerySearch;
        vm.getChipDisplayValue = getChipDisplayValue;

        vm.lookupSearch = lookupSearch;
        vm.getLookupDisplayValue = getLookupDisplayValue;
        vm.selectText = selectText;

        activate();

        ////////////////

        function activate() {
            hotkeys.bindTo($scope).add({
                combo: 'ctrl+enter',
                description: $filter('translate')('ACTIONS.SAVE'),
                allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
                callback: function() {
                    if (!vm.isLoading && !vm.editForm.$invalid && vm.isFileValid) {
                        vm.saveRecord();
                    }
                }
            });
            hotkeys.bindTo($scope).add({
                combo: 'ctrl+shift+enter',
                description: $filter('translate')('ACTIONS.SAVE_AND_NEW'),
                allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
                callback: function() {
                    if (!vm.isLoading && !vm.editForm.$invalid && vm.isFileValid) {
                        vm.saveRecord(true);
                    }
                }
            });

            //Load WebAPI allowed file types
            api.webGet('/app/app.config.json')
            .then(function (response) {
                if (angular.isDefined(response) && angular.isDefined(response.data)) {
                    if (angular.isDefined(response.data.resourcesAllowedFileTypes) && response.data.resourcesAllowedFileTypes.length > 0) {
                        vm.allowedFileTypesList = [];
                        angular.forEach(response.data.resourcesAllowedFileTypes, function(resourceFileType) {
                            vm.allowedFileTypesList.push(resourceFileType.fileType.toLowerCase());
                        });
                    }
                }

                if(vm.allowedFileTypesList.length > 0) {
                    angular.forEach(vm.allowedFileTypesList, function(resourceFileType) {
                        resourceFileType = '.' + resourceFileType;
                        vm.allowedFileTypeExtentions.push(resourceFileType);
                    });
                    vm.allowedFileTypeExtentions = vm.allowedFileTypeExtentions.toString();
                }
            });

            // Manually load seller-level lookups (generic crud.createLookupPromise can't pass sellerId/attributeGroupId)

            // Load resource types from global endpoint
            var resourceTypesModel = api.lists.resourceTypes;
            resourceTypesModel.methods.getList({ forceFetch: true, isLogRequired: false }).then(function(response) {
                resourceTypesModel.lookupData = {
                    data: response.data.map(function(item) {
                        return { id: item[resourceTypesModel.idField], value: item[resourceTypesModel.lookupDisplayField], Status: 1 };
                    })
                };
                // On edit, resolve TypeId from raw ID to lookup object for md-autocomplete display
                if(!vm.isNew && vm.record.TypeId) {
                    var match = utility.filterObject(resourceTypesModel.lookupData.data, {id: vm.record.TypeId}, true);
                    if(angular.isArray(match) && match.length > 0) {
                        vm.lookupModel.TypeId = match[0];
                    }
                }
            });

            // Load seller articles (first page)
            vm.isArticlesLookupLoading = true;
            api.webGet(articlesBaseUrl + '&page=1&pageSize=100', undefined, true, true).then(function(response) {
                localLookupData.ArticleIds = (response.data || []).map(function(item) {
                    return { id: item.Id || item.ArticleId, value: item.ArticleNumber, Status: item.Status || 1 };
                });
            }).finally(function() {
                vm.isArticlesLookupLoading = false;
            });

            // Load seller models (first page)
            vm.isModelsLookupLoading = true;
            api.webGet(modelsBaseUrl + '?page=1&pageSize=100', undefined, true, true).then(function(response) {
                localLookupData.ModelIds = (response.data || []).map(function(item) {
                    return { id: item.ModelId, value: item.ModelNumber, Status: item.Status || 1 };
                });
            }).finally(function() {
                vm.isModelsLookupLoading = false;
            });
        }

        function saveRecord(saveAndNew) {
            vm.isLoading = true;
            var promise;
            if(vm.isNew) {
                var articleIds = vm.record.IsModelLevel ? [] : (vm.record.ArticleIds || []);
                var modelIds = vm.record.IsModelLevel ? (vm.record.ModelIds || []) : [];
                var requestObj = {
                    ResourceName: vm.record.ResourceName,
                    FileId: vm.record.FileId,
                    IconFileId: vm.record.IconFileId,
                    TypeId: vm.record.TypeId,
                    Description: vm.record.Description,
                    Category: vm.record.Category,
                    Cascading: vm.record.Cascading || 1,
                    SortOrder: vm.record.SortOrder || null,
                    IsModelLevel: modelIds.length > 0 ? 1 : (articleIds.length > 0 ? 0 : null),
                    ArticleIds: articleIds,
                    ModelIds: modelIds
                };
                promise = vm.model.methods.create(requestObj, sellerId, attributeGroupId);
            } else {
                // Edit mode: send back the full record with updated fields
                var updateObj = angular.copy(vm.record);
                // Map ArticleList/ModelList back to ArticleIds/ModelIds for the API
                updateObj.ArticleIds = (updateObj.ArticleList || []).map(function(a) { return a.ArticleId || a.Id; });
                updateObj.ModelIds = (updateObj.ModelList || []).map(function(m) { return m.ModelId || m.Id; });
                updateObj.IsModelLevel = updateObj.ModelIds.length > 0 ? 1 : (updateObj.ArticleIds.length > 0 ? 0 : null);
                delete updateObj.ArticleList;
                delete updateObj.ModelList;
                promise = vm.model.methods.update(updateObj, vm.record.ResourceId, sellerId, attributeGroupId);
            }

            promise.then(function() {
                if (angular.isDefined(saveAndNew) && saveAndNew) {
                    vm.editForm.$setPristine();
                    vm.editForm.$setUntouched();
                    vm.record = {};
                    vm.record.IsModelLevel = null;
                    vm.record.ArticleIds = [];
                    vm.record.ModelIds = [];
                    vm.obj.flow.files.length = 0;
                    vm.obj2.flow.files.length = 0;
                    vm.searchText = {};
                    vm.isDataDirty = true;

                    var el = $window.document.getElementById('dialog_input_first');
                    if (el) {
                        el.focus();
                    }
                }
                else {
                    closeDialog(true);
                }
                toast.success('SUCCESS.CREATE', '', '');
            }, function() {
                closeDialog(vm.isDataDirty);
            }).finally(function () {
                vm.isLoading = false;
            });
        }

        function closeDialog(saved, cancelUpload) {
            if(angular.isDefined(cancelUpload) && cancelUpload === true) {
                vm.obj.flow.cancel();
            }
            $mdDialog.hide(saved);
        }

        function onModelLevelToggleChange() {
            vm.record.ArticleIds = [];
            vm.record.ModelIds = [];
        }

        function onResourceTypeChange(resourceType, fieldName, files) {
            lookupChange(resourceType, fieldName);
            if(files && files.length && resourceType === 8) {
                var isValid = true;
                angular.forEach(files, function(file) {
                    if(!file.name.match(/\.(jpe?g|png)$/)) {
                        vm.obj.flow.removeFile(file);
                        vm.isFileValid = false;
                        isValid = false;
                    }
                });
                if(isValid) {
                    vm.isFileValid = true;
                }
            }
        }

        function validateFile(file, ev, flow, resourceFileType) {
            var fileNameSplitArray = file.name.split(".");
            var fileType = fileNameSplitArray[fileNameSplitArray.length - 1];
            var allowedFileTypePresent = vm.allowedFileTypesList.indexOf(fileType.toLowerCase());
            if(allowedFileTypePresent === -1) {
                vm.isFileValid = false;
                if(resourceFileType === 'resource') {
                    vm.isResourceFileValid = false;
                } else {
                    vm.isIconFileValid = false;
                }
            } else {
                vm.isFileValid = true;
                if(resourceFileType === 'resource') {
                    vm.isResourceFileValid = true;
                } else {
                    vm.isIconFileValid = true;
                }
            }
        }

        function upload(fileType) {
            if (vm.isFileValid && fileType === 'resource') {
                vm.obj.flow.upload();
            } else if (vm.isFileValid && fileType === 'icon') {
                vm.obj2.flow.upload();
            } else if (!vm.isFileValid && fileType === 'resource') {
                vm.obj.flow.removeFile(vm.obj.flow.files[vm.obj.flow.files.length - 1]);
            } else if (!vm.isFileValid && fileType === 'icon') {
                vm.obj2.flow.removeFile(vm.obj2.flow.files[vm.obj2.flow.files.length - 1]);
            }
        }

        function onSuccessUpload(file, message, chunk, fileType) {
            message = message.replace(/\"/g, "");
            if (fileType === 'resource') {
                vm.record.FileId = message;
            } else if (fileType === 'icon') {
                vm.record.IconFileId = message;
            }
        }

        function lookupSearch(query, fieldName) {
            var results = [];
            var field = utility.filterObject(model.fields, {field: fieldName})[0];
            if(!field) return results;
            var lookupFilter = field.lookupFilter ? field.lookupFilter : {};
            var predicate = angular.copy(lookupFilter);
            predicate.value = query;
            var lookupModel = api.getModel(field.lookupSource);

            if(angular.isDefined(lookupModel.lookupData) && lookupModel.lookupData.data.length) {
                results = query ? utility.filterObject(lookupModel.lookupData.data, predicate) : utility.filterObject(lookupModel.lookupData.data, lookupFilter);
                return results;
            }
        }

        function lookupChange(selectedObj, field) {
            if(angular.isObject(selectedObj)) {
                vm.record[field] = selectedObj.id;
            }
            else if(angular.isUndefined(selectedObj) || selectedObj === null) {
                vm.record[field] = undefined;
            }
        }

        function getLookupDisplayValue(item, fieldName) {
            var field = utility.filterObject(model.fields, {field: fieldName})[0];
            if(!field) return '';
            var lookupModel = api.getModel(field.lookupSource);

            if(lookupModel.lookupData) {
                var result;
                if(angular.isObject(item)) {
                    result = utility.filterObject(lookupModel.lookupData.data, {id: item.id}, true);
                } else {
                    result = utility.filterObject(lookupModel.lookupData.data, {id: item}, true);
                }
                if (angular.isArray(result) && result.length > 0) {
                    return result[0].value;
                } else {
                    return result ? result.value : '';
                }
            }
        }

        function selectText(event) {
            utility.selectInputText(event);
        }

        function transformChip(chip) {
            if (angular.isObject(chip)) {
                return chip.id;
            }
            return undefined;
        }

        function getChipDisplayValue(chip, fieldName) {
            var data = localLookupData[fieldName] || [];
            for(var i = 0; i < data.length; i++) {
                if(data[i].id === chip) {
                    return data[i].value;
                }
            }
            return '';
        }

        function acQuerySearch(query, selectedItems, fieldName) {
            // Server-side search for 3+ characters
            if(query && query.length >= 3) {
                var currentQuery = query;
                latestSearchQuery[fieldName] = currentQuery;
                var searchUrl;
                if(fieldName === 'ArticleIds') {
                    searchUrl = articlesBaseUrl + '&articlenumber=' + encodeURIComponent(query) + '&page=1&pageSize=100';
                } else if(fieldName === 'ModelIds') {
                    searchUrl = modelsBaseUrl + '?modelnumber=' + encodeURIComponent(query) + '&page=1&pageSize=100';
                }
                if(searchUrl) {
                    return api.webGet(searchUrl, undefined, true, true).then(function(response) {
                        // Ignore stale responses — only process if this is still the latest query
                        if(latestSearchQuery[fieldName] !== currentQuery) {
                            return filterSelected([], selectedItems);
                        }
                        var mapped = (response.data || []).map(function(item) {
                            if(fieldName === 'ArticleIds') {
                                return { id: item.Id || item.ArticleId, value: item.ArticleNumber, Status: item.Status || 1 };
                            } else {
                                return { id: item.ModelId, value: item.ModelNumber, Status: item.Status || 1 };
                            }
                        });
                        // Merge into local cache for chip display resolution
                        angular.forEach(mapped, function(m) {
                            var exists = false;
                            for(var j = 0; j < localLookupData[fieldName].length; j++) {
                                if(localLookupData[fieldName][j].id === m.id) { exists = true; break; }
                            }
                            if(!exists) { localLookupData[fieldName].push(m); }
                        });
                        return filterSelected(mapped, selectedItems);
                    });
                }
            }

            // Client-side filter on cached data for < 3 chars
            return filterSelected(clientFilter(localLookupData[fieldName] || [], query), selectedItems);
        }

        function clientFilter(data, query) {
            var maxResults = 100;
            var results = [];
            var lowerQuery = query ? query.toLowerCase() : '';
            for(var i = 0; i < data.length && results.length < maxResults; i++) {
                if(!query || (data[i].value && data[i].value.toLowerCase().indexOf(lowerQuery) !== -1)) {
                    results.push(data[i]);
                }
            }
            return results;
        }

        function filterSelected(results, selectedItems) {
            if(!angular.isDefined(selectedItems) || selectedItems.length === 0) return results;
            return results.filter(function(item) {
                return selectedItems.indexOf(item.id) === -1;
            });
        }

    }
})();
(function() {
    'use strict';

    angular
        .module('app.main.accounts.sellers.seller-resources')
        .controller('sellerResourceDetailsController', sellerResourceDetailsController);

    /* @ngInject */
    function sellerResourceDetailsController(api, $state, $stateParams, $mdDialog, $rootScope, $document, catalogFactory, utility, settingsFactory) {
       /* jshint validthis: true */
        var vm = this;

        // Data
        var resourceId = parseInt($stateParams.id);
        var activeCatalog = catalogFactory.getActiveCatalog();
        var sellerId = activeCatalog.AccountId;
        var attributeGroupId = activeCatalog.AttributeGroupId;

        // Details model with all fields for the resource details view
        vm.detailsModel = {
            modelPath: 'sellers.sellerResourceDetails',
            fields: [
                { field: 'ResourceId', type: 'int', displayLabel: 'RESOURCES.FIELDS.RESOURCE_ID', visible: true, inputType: 'number' },
                { field: 'Resource', type: 'int', displayLabel: 'RESOURCES.FIELDS.RESOURCE', visible: true, inputType: 'calculated-url', calculatedExpression: 'data["Resource"]' },
                { field: 'ResourceName', type: 'text', displayLabel: 'RESOURCES.FIELDS.RESOURCE_NAME', visible: true, inputType: 'text' },
                { field: 'FileName', type: 'text', displayLabel: 'RESOURCES.FIELDS.FILE_NAME', visible: true, inputType: 'text' },
                { field: 'FilePath', type: 'text', displayLabel: 'RESOURCES.FIELDS.FILE_PATH', visible: true, inputType: 'text' },
                { field: 'TypeId', type: 'text', displayLabel: 'RESOURCES.FIELDS.RESOURCE_TYPE_ID', visible: true, inputType: 'lookup', lookupSource: 'lists.resourceTypes' },
                { field: 'IsModelLevel', type: 'text', displayLabel: 'RESOURCES.FIELDS.IS_MODEL_LEVEL', visible: false, inputType: 'bool-int' },
                { field: 'Icon', type: 'text', displayLabel: 'RESOURCES.FIELDS.ICON', visible: true, inputType: 'calculated-url', calculatedExpression: 'data["Icon"]' },
                { field: 'Description', type: 'text', displayLabel: 'RESOURCES.FIELDS.DESCRIPTION', visible: true, inputType: 'text' },
                { field: 'Category', type: 'text', displayLabel: 'RESOURCES.FIELDS.CATEGORY', visible: true, inputType: 'text' },
                { field: 'SortOrder', type: 'int', displayLabel: 'RESOURCES.FIELDS.SORT_ORDER', visible: true, inputType: 'number' },
                { field: 'Status', type: 'text', displayLabel: 'RESOURCES.FIELDS.STATUS', visible: true, inputType: 'status' },
                { field: 'CreatedDate', type: 'text', displayLabel: 'RESOURCES.FIELDS.CREATED_DATE', visible: true, inputType: 'date' },
                { field: 'UpdatedDate', type: 'text', displayLabel: 'RESOURCES.FIELDS.UPDATED_DATE', visible: true, inputType: 'date' },
                { field: 'CreatedBy', type: 'text', displayLabel: 'RESOURCES.FIELDS.CREATED_BY', visible: true, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap' },
                { field: 'UpdatedBy', type: 'text', displayLabel: 'RESOURCES.FIELDS.UPDATED_BY', visible: true, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap' }
            ],
            idField: 'ResourceId',
            lookupDisplayField: 'ResourceName',
            methods: api.sellers.sellerResources.methods,
            views: {
                mainDetails: {},
                privileges: {
                    details: 'GetSellerResourceDetails'
                }
            }
        };

        // Article model for the articles tab
        vm.articleModel = {
            modelPath: 'sellers.sellerResourceArticles',
            fields: [
                { field: 'Id', type: 'int', displayLabel: 'ARTICLES.FIELDS.ID', visible: true, inputType: 'number' },
                { field: 'ArticleNumber', type: 'text', displayLabel: 'ARTICLES.FIELDS.ARTICLE_NUMBER', visible: true, inputType: 'text' },
                { field: 'ArticleName', type: 'text', displayLabel: 'ARTICLES.FIELDS.MODEL_NAME', visible: true, inputType: 'text' },
                { field: 'Status', type: 'text', displayLabel: 'ARTICLES.FIELDS.STATUS', visible: true, inputType: 'status' },
                { field: 'UpdatedDate', type: 'text', displayLabel: 'ARTICLES.FIELDS.UPDATED_DATE', visible: true, inputType: 'date' }
            ],
            idField: 'Id',
            lookupDisplayField: 'ArticleNumber',
            views: {
                mainList: {
                    columns: ['ArticleNumber', 'ArticleName', 'Status', 'UpdatedDate'],
                    columnFilter: {},
                    topIndex: 0,
                    showFilterRow: false,
                    sortColumn: {'UpdatedDate': false},
                    itemActions: [
                        { id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateSellerArticleResourceStatus', disabled: false, visible: 'itm.Status',
                            requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'}
                    ],
                    listActions: [
                        { id: 'delete', label: 'ACTIONS.DELETE_BULK', icon: 'icon-delete', privilege: 'UpdateSellerArticleResourceStatus', disabled: '{selected: true, Status: 1}', visible: true,
                            requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'}
                    ]
                },
                mainDetails: {},
                privileges: {
                    list: 'GetSellerResourceDetails'
                }
            }
        };
        settingsFactory.applyPersistedListViewLayout(vm.articleModel);

        // Model model for the models tab
        vm.modelModel = {
            modelPath: 'sellers.sellerResourceModels',
            fields: [
                { field: 'Id', type: 'int', displayLabel: 'SELLER_MODELS.FIELDS.MODEL_ID', visible: true, inputType: 'number' },
                { field: 'ModelNumber', type: 'text', displayLabel: 'SELLER_MODELS.FIELDS.MODEL_NUMBER', visible: true, inputType: 'text' },
                { field: 'ModelName', type: 'text', displayLabel: 'SELLER_MODELS.FIELDS.MODEL_NAME', visible: true, inputType: 'text' },
                { field: 'Status', type: 'text', displayLabel: 'ARTICLES.FIELDS.STATUS', visible: true, inputType: 'status' },
                { field: 'UpdatedDate', type: 'text', displayLabel: 'ARTICLES.FIELDS.UPDATED_DATE', visible: true, inputType: 'date' }
            ],
            idField: 'Id',
            lookupDisplayField: 'ModelNumber',
            views: {
                mainList: {
                    columns: ['ModelNumber', 'ModelName', 'Status', 'UpdatedDate'],
                    columnFilter: {},
                    topIndex: 0,
                    showFilterRow: false,
                    sortColumn: {'UpdatedDate': false},
                    itemActions: [
                        { id: 'view', label: 'ACTIONS.VIEW', icon: 'icon-magnify', privilege: 'GetSellerResourceDetails', disabled: '!itm.Status', visible: true },
                        { id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateSellerModelResourceStatus', disabled: false, visible: 'itm.Status',
                            requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'}
                    ],
                    listActions: [
                        { id: 'delete', label: 'ACTIONS.DELETE_BULK', icon: 'icon-delete', privilege: 'UpdateSellerModelResourceStatus', disabled: '{selected: true, Status: 1}', visible: true,
                            requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'}
                    ]
                },
                mainDetails: {},
                privileges: {
                    list: 'GetSellerResourceDetails'
                }
            }
        };
        settingsFactory.applyPersistedListViewLayout(vm.modelModel);

        vm.resource = {};
        vm.assignedArticles = [];
        vm.filteredAssignedArticles = [];
        vm.assignedModels = [];
        vm.filteredAssignedModels = [];

        // Methods
        vm.refreshRecord = refreshRecord;
        vm.editResource = editResource;
        vm.doArticleItemAction = doArticleItemAction;
        vm.doArticleListAction = doArticleListAction;
        vm.doModelItemAction = doModelItemAction;
        vm.doModelListAction = doModelListAction;
        vm.viewArticle = viewArticle;
        vm.viewModel = viewModel;
        vm.assignArticles = assignArticles;
        vm.assignModels = assignModels;

        activate();

        ////////////////

        function activate() {
            refreshRecord(true);
        }

        function refreshRecord(isLogRequired) {
            vm.isLoading = true;
            vm.detailsModel.methods.getDetails(isLogRequired, resourceId, sellerId, attributeGroupId)
            .then(function (response) {
                vm.resource = response.data;

                // Build resource URL for display
                if(vm.resource.FilePath && vm.resource.FileName) {
                    vm.resource.Resource = vm.resource.FilePath + '/' + vm.resource.FileName;
                } else {
                    vm.resource.Resource = '';
                }

                vm.title = vm.resource[vm.detailsModel.lookupDisplayField] || vm.resource.FileName || ('Resource ' + vm.resource.ResourceId);

                //Update Breadcrumb
                $state.current.data.displayName = vm.title;
                $rootScope.$broadcast('breadcrumb-updated');

                // Populate articles and models from response
                vm.assignedArticles = vm.resource.ArticleList || [];
                vm.assignedModels = vm.resource.ModelList || [];
                // Resource is unlinked if IsModelLevel is false and both lists are empty
                vm.isUnlinkedResource = !vm.resource.IsModelLevel && vm.assignedArticles.length === 0 && vm.assignedModels.length === 0;
            })
            .finally(function () {
                vm.isLoading = false;
            });
        }

        function editResource(ev, record) {
            $mdDialog.show({
                controller         : 'createSellerResourceController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/accounts/sellers/details/tabs/seller-resources/dialogs/create-seller-resource.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: false,
                locals             : {
                    model: vm.detailsModel,
                    sellerId: sellerId,
                    attributeGroupId: attributeGroupId,
                    record: angular.copy(vm.resource),
                    isNew: false,
                    event: ev
                }
            }).then(function(saved) {
                if (saved) {
                    refreshRecord(false);
                }
            });
        }

        function doArticleItemAction(action, record) {
            if(action && record) {
                switch (action.id) {
                    case 'view':
                        viewArticle(record);
                        break;
                    case 'delete':
                        var artId = record.ArticleId || record.Id;
                        api.webPut(api.baseUrl + '/sellers/' + sellerId + '/' + attributeGroupId + '/articles/' + artId + '/resources/' + resourceId + '/status', {Status: 0})
                        .then(function() { refreshRecord(false); });
                        break;
                }
            }
        }

        function doArticleListAction(action, records) {
            if(action && records) {
                switch (action.id) {
                    case 'delete':
                        unassignEntities(records, false);
                        break;
                }
            }
        }

        function doModelItemAction(action, record) {
            if(action && record) {
                switch (action.id) {
                    case 'view':
                        viewModel(record);
                        break;
                    case 'delete':
                        var mdlId = record.ModelId || record.Id;
                        api.webPut(api.baseUrl + '/sellers/' + sellerId + '/' + attributeGroupId + '/models/' + mdlId + '/resources/' + resourceId + '/status', {Status: 0})
                        .then(function() { refreshRecord(false); });
                        break;
                }
            }
        }

        function doModelListAction(action, records) {
            if(action && records) {
                switch (action.id) {
                    case 'delete':
                        unassignEntities(records, true);
                        break;
                }
            }
        }

        // Build remaining IDs minus deleted records and call assignentities
        function unassignEntities(recordsToRemove, isModelAction) {
            var deleteIds = recordsToRemove.map(function(r) {
                return isModelAction ? (r.ModelId || r.Id) : (r.ArticleId || r.Id);
            });

            var remainingArticleIds = vm.assignedArticles
                .filter(function(a) { return a.Status !== 0 && deleteIds.indexOf(a.ArticleId || a.Id) === -1; })
                .map(function(a) { return a.ArticleId || a.Id; });

            var remainingModelIds = vm.assignedModels
                .filter(function(m) { return m.Status !== 0 && deleteIds.indexOf(m.ModelId || m.Id) === -1; })
                .map(function(m) { return m.ModelId || m.Id; });

            var requestObj = {
                IsModelLevel: remainingModelIds.length > 0 ? 1 : (remainingArticleIds.length > 0 ? 0 : null),
                ArticleIds: remainingArticleIds,
                ModelIds: remainingModelIds
            };

            api.webPut(api.baseUrl + '/sellers/' + sellerId + '/' + attributeGroupId + '/resources/' + resourceId + '/assignentities', requestObj)
            .then(function() {
                refreshRecord(false);
            });
        }

        function viewArticle(record) {
            var id = record.ArticleId || record.Id;
            $state.go('app.articles.details', {id: id, tab: 'DETAILS'});
        }

        function viewModel(record) {
            var id = record.ModelId || record.Id;
            $state.go('app.seller_models.details', {id: id});
        }

        function assignArticles(ev) {
            showAssignEntityDialog(ev, '/sellers/' + sellerId + '/attributegroups/' + attributeGroupId + '/articles?getSimplifiedSellerArticles=1', 'ArticleNumber', 'ArticleId', false);
        }

        function assignModels(ev) {
            showAssignEntityDialog(ev, '/sellers/' + sellerId + '/' + attributeGroupId + '/models', 'ModelNumber', 'ModelId', true);
        }

        function showAssignEntityDialog(ev, apiUrl, displayField, idField, isModelLevel) {
            $mdDialog.show({
                controller         : 'assignSellerResourceEntitiesController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/accounts/sellers/details/tabs/seller-resources/details/dialogs/assign-seller-resource-entities.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: false,
                locals             : {
                    sellerId: sellerId,
                    attributeGroupId: attributeGroupId,
                    resourceId: resourceId,
                    isModelLevel: isModelLevel,
                    assignedArticles: angular.copy(vm.assignedArticles),
                    assignedModels: angular.copy(vm.assignedModels),
                    entityApiUrl: apiUrl,
                    displayField: displayField,
                    idField: idField
                }
            }).then(function(saved) {
                if(saved) {
                    refreshRecord(false);
                }
            });
        }

    }
})();
(function() {
		'use strict';

		angular
				.module('app.main.accounts.sellers.seller-lookup-table', [
					'app.main.accounts.sellers.seller-lookup-table.values'
				])
				.config(config);

				/* @ngInject */
				function config($translatePartialLoaderProvider) {
						// Translation
						$translatePartialLoaderProvider.addPart('app/main/accounts/sellers/details/tabs/seller-lookup-table');
				}
})();
(function() {
	'use strict';

	angular
		.module('app.main.accounts.sellers.seller-lookup-table')
		.controller('lookupTableDetailsController', lookupTableDetailsController);

	/* @ngInject */
	function lookupTableDetailsController(api, $state, $stateParams, $rootScope, $filter, settingsFactory, createLookupValuesModelWithSourceAndDestAttributes, dataImporter) {
	   /* jshint validthis: true */
		var vm = this;
		var lookupId = $stateParams.id;
		vm.sellerId = $stateParams.sellerId;

		vm.model = api.sellers.sellerLookups;

		vm.valuesModel = createLookupValuesModelWithSourceAndDestAttributes;
		settingsFactory.applyPersistedListViewLayout(vm.valuesModel);

		vm.lookupDefinition = {};

		vm.lookupValues = [];
		vm.filteredLookupValues = [];

		vm.isLoading = false;

		vm.refreshRecord = refreshRecord;

		vm.doValuesListAction = doValuesListAction;

		activate();

		////////////////

		function activate() {
			refreshRecord(true);
		}

		function refreshRecord(isLogRequired) {
			vm.isLoading = true;

			vm.model.methods.getDetails(isLogRequired, lookupId, vm.sellerId)
				.then(function (response) {
					// transform data
					vm.lookupDefinition = response.data;
					vm.title = angular.copy(vm.lookupDefinition[vm.model.lookupDisplayField]);
					vm.lookupValues = transformLookupValuesResponse(vm.lookupDefinition);

					//Update Breadcrumb
					$state.current.data.displayName = vm.title;
					$rootScope.$broadcast('breadcrumb-updated');
				})
				.finally(function () {
					vm.isLoading = false;
				});
		}

		function doValuesListAction(action, records) {
			if (action) {
				switch (action.id) {
					case 'import':
						dataImporter.importExcel(vm.valuesModel, true).then(function (result) {
							vm.valuesModel.methods.createBulk(vm.valuesModel, result.data, lookupId, vm.sellerId).then(function() {
								refreshRecord(true);
							})
						})
						break;
				}
			}
		}

		// transform lookup values to required form
		function transformLookupValuesResponse(lookupValues) {
			var transformedResponse = [];
			var valueObj = {
				CreatedBy: lookupValues.CreatedBy,
				CreatedDate: lookupValues.CreatedDate
			}
			angular.forEach(lookupValues.Values, function(value) {
				transformedResponse.push(Object.assign({}, valueObj, value.Source, value.Destination));
			});
			return transformedResponse;
		}
	}
})();
(function() {
    'use strict';

    angular
        .module('app.main.accounts.sellers.seller-configurations',[])
        .config(config);

    /* @ngInject */
    function config($translatePartialLoaderProvider) {

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/accounts/sellers/details/tabs/seller-configurations');
    }
})();
(function() {
    'use strict';

    angular
        .module('app.main.accounts.sellers.seller-configurations')
        .controller('createSellerConfigurationController', createSellerConfigurationController);

    /* @ngInject */
    function createSellerConfigurationController($scope,  $window, $mdDialog, $filter, toast, utility, api, hotkeys, model, record, sellerId, isNew) {
        /* jshint validthis: true */
        var vm = this;

        //Data
        vm.masterConfigurationsModel = api.lists.configurations;
        vm.model = model;

        vm.configType = '';
        vm.isLoading = false;
        vm.record = angular.copy(record);
        vm.isNew = isNew;

        var masterConfigurations = [];
        vm.searchText = '';
        vm.isDataDirty = false;
        vm.lookupModel = angular.copy(vm.record);

        // When an existing config is picked from the dropdown its definition fields are
        // populated and locked; only the link (ConfigId) + Value are saved. When the user
        // types a new name instead, the definition fields stay editable and are saved too.
        vm.isExistingSelected = false;
        vm.defaultValueTypes = [
            {Id: 'nvarchar', value: 'Text'},
            {Id: 'int', value: 'Number'},
            {Id: 'datetime', value: 'Date'},
            {Id: 'bool', value: 'Boolean'}
        ];


        //Methods
        vm.saveRecord = saveRecord;
        vm.closeDialog = closeDialog;

        vm.lookupSearch = lookupSearch;
        vm.lookupChange = lookupChange;
        vm.getConfigurationDisplayValue = getConfigurationDisplayValue;
        vm.selectText = selectText;
        vm.onTypeChange = onTypeChange;

        activate();

        ////////////////

        function activate() {
            loadConfigurations();
            if (vm.isNew) {
                vm.record.DefaultValueType = vm.record.DefaultValueType || 'nvarchar';
                vm.configType = vm.record.DefaultValueType;
            } else {
                // Edit: drive the value input from the stored type; numeric values need a Number for the input.
                vm.configType = vm.record.DefaultValueType || '';
                if (vm.record.DefaultValueType === 'int' && angular.isDefined(vm.record.Value)) {
                    vm.record.Value = parseInt(vm.record.Value, 10);
                }
            }
            //Hotkeys
            hotkeys.bindTo($scope).add({
                combo: 'ctrl+enter',
                description: $filter('translate')('ACTIONS.SAVE'),
                allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
                callback: function(event) {
                    if (!vm.isLoading && !vm.editForm.$invalid) {
                        vm.saveRecord();
                    }
                }
            });

            if (vm.isNew) {
                hotkeys.bindTo($scope).add({
                    combo: 'ctrl+shift+enter',
                    description: $filter('translate')('ACTIONS.SAVE_AND_NEW'),
                    allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
                    callback: function(event) {
                        if (!vm.isLoading && !vm.editForm.$invalid) {
                            vm.saveRecord(true);
                        }
                    }
                });
            }
        }

        function saveRecord(saveAndNew) {
            vm.isLoading = true;
            var promise;

            if (isNew && !vm.isExistingSelected) {
                // New configuration: send the typed name + definition, with no existing link.
                vm.record.ConfigId = undefined;
                vm.record.Name = (vm.searchText && vm.searchText.ConfigId) ? vm.searchText.ConfigId : vm.record.Name;
            }

            if(isNew) {
                promise = vm.model.methods.create(vm.record, sellerId);
            }
            else {
                promise = vm.model.methods.update(vm.record, vm.record[model.idField], sellerId);
            }

            promise.then(function() {
                if (vm.isNew && angular.isDefined(saveAndNew) && saveAndNew) {
                    vm.editForm.$setPristine();
                    vm.editForm.$setUntouched();
                    vm.record = {};
                    vm.record.DefaultValueType = 'nvarchar';
                    vm.searchText = '';
                    vm.isExistingSelected = false;
                    vm.configType = 'nvarchar';
                    vm.lookupModel = {};
                    vm.isDataDirty = true;
                    var el = $window.document.getElementById('dialog_input_first');
                    if (el) {
                        el.focus();
                    }
                } else {
                    closeDialog(true);
                }
                var toastMessage = isNew ? 'SUCCESS.CREATE': 'SUCCESS.UPDATE';
                toast.success(toastMessage, '', '');
            }, function(err) {
                closeDialog(vm.isDataDirty);
            }).finally(function () {
                vm.isLoading = false;
            });
        }

        function closeDialog(saved) {
            $mdDialog.hide(saved);
        }

        function lookupSearch(query) {
            var results = [];
            var predicate = {};
            predicate[vm.masterConfigurationsModel.lookupDisplayField] = query;

            if(masterConfigurations.length) {
                results = query ? utility.filterObject(masterConfigurations , predicate) :  masterConfigurations;
                return results;
            }
            else {
                return loadConfigurations().then(function() {
                    results = query ? utility.filterObject(masterConfigurations , predicate) : masterConfigurations;
                    return results;
                });
            }
        }

        function lookupChange(selectedValue, field) {
            if(angular.isObject(selectedValue)){
                // Existing config picked: populate and lock the definition fields.
                vm.isExistingSelected = true;
                vm.record[field] = selectedValue[vm.masterConfigurationsModel.idField];
                vm.record.Name = selectedValue.Name;
                vm.record.DefaultValueType = selectedValue.DefaultValueType;
                vm.record.DefaultValue = coerceValueForType(selectedValue.Value, selectedValue.DefaultValueType);
                vm.record.SortOrder = toNumberOrUndefined(selectedValue.SortOrder);
                vm.record.Description = selectedValue.Description;
                vm.configType = selectedValue.DefaultValueType;
                if (selectedValue.DefaultValueType === 'bool' && angular.isUndefined(vm.record.Value)) {
                    vm.record.Value = 'false';
                }
            }
            else if(angular.isUndefined(selectedValue) || selectedValue === null) {
                // Back to a new config: clear the link and re-enable the definition fields.
                vm.isExistingSelected = false;
                vm.record[field] = undefined; // on record removal make field undefined or the property can be deleted using delete keyword
                vm.record.DefaultValueType = 'nvarchar';
                vm.record.DefaultValue = undefined;
                vm.record.SortOrder = undefined;
                vm.record.Description = undefined;
                vm.record.Value = undefined;
                vm.configType = 'nvarchar';
            }
        }

        function getConfigurationDisplayValue(item) {
            if(masterConfigurations.length) {
                return getLookupDisplayValue(item);
            }
            else {
                return loadConfigurations().then(function() {
                    return getLookupDisplayValue(item);
                });
            }
        }

        function getLookupDisplayValue(item) {
            var result;
            var predicate = {};
            if(angular.isObject(item)) {
                predicate[vm.masterConfigurationsModel.idField] = item[vm.masterConfigurationsModel.idField];
            }
            else {
                predicate[vm.masterConfigurationsModel.idField] = item;
            }
            result = utility.filterObject(masterConfigurations, predicate, true)[0];
            return result ? result[vm.masterConfigurationsModel.lookupDisplayField] : '';
        }

        function selectText(event) {
            utility.selectInputText(event);
        }

        // Reset the value inputs whenever the value type changes (mirrors the vetting
        // create-configuration dialog) so DefaultValue/Value match the selected type.
        function onTypeChange(type) {
            vm.configType = type;
            vm.record.Value = undefined;
            vm.record.DefaultValue = undefined;
            if (type === 'bool') {
                vm.record.Value = 'false';
                vm.record.DefaultValue = 'false';
            }
        }

        // type="number" inputs and md-datepicker need real Number/Date values, not the
        // strings the master config stores them as - otherwise ngModel throws numfmt/dateparse.
        function toNumberOrUndefined(val) {
            if (val === null || angular.isUndefined(val) || val === '') { return undefined; }
            var num = parseInt(val, 10);
            return isNaN(num) ? undefined : num;
        }

        function coerceValueForType(val, type) {
            if (val === null || angular.isUndefined(val) || val === '') { return undefined; }
            if (type === 'int') { return toNumberOrUndefined(val); }
            if (type === 'datetime') {
                var date = new Date(val);
                return isNaN(date.getTime()) ? undefined : date;
            }
            return val;
        }

        function loadConfigurations() {
            return vm.masterConfigurationsModel.methods.getList({forceFetch: true, isLogRequired: false}).then(function(response) {
                masterConfigurations = response.data;
            });
        }
    }
})();
(function() {
	'use strict';

	angular
		.module('app.main.accounts.sellers.seller-datasets')
		.controller('datasetsDetailsController', datasetsDetailsController);

	/* @ngInject */
	function datasetsDetailsController(api, $state, $stateParams, $rootScope, $scope, crud, settingsFactory, createDatasetValuesModelWithAttributes, dataImporter, bulkUpdater, SecurityFactory, CONSTANTS) {
		 /* jshint validthis: true */
		var vm = this;
		var datasetId = $stateParams.id;
		vm.sellerId = $stateParams.sellerId;

		vm.model = api.sellers.datasets;

		vm.valuesModel = createDatasetValuesModelWithAttributes;
		settingsFactory.applyPersistedListViewLayout(vm.valuesModel);

		vm.datasetDefinition = {};

		vm.datasetValues = [];
		vm.filteredDatasetValues = [];

		vm.isLoading = false;
		vm.isValuesLoading = false;

		vm.refreshRecord = refreshRecord;
		vm.refreshValues = refreshValues;

		vm.doValuesListAction = doValuesListAction;
		vm.doValuesItemAction = doValuesItemAction;

		activate();

		////////////////

		function activate() {
			refreshRecord(true);

			// Listen for background job completion to show banner; refresh happens on banner click
			var deregisterJobCompleted = $rootScope.$on('jobCompletedEvent', function() {
				if (api.sellers.datasetValues.isBulkActionCompleted) {
					vm.valuesModel.isBulkActionCompleted = true;
				}
				if (api.sellers.datasets.isBulkActionCompleted) {
					vm.model.isBulkActionCompleted = true;
				}
			});
			$scope.$on('$destroy', deregisterJobCompleted);
		}

		function refreshRecord(isLogRequired) {
			vm.isLoading = true;

			vm.model.methods.getDetails(isLogRequired, datasetId, vm.sellerId)
				.then(function (response) {
					// transform data
					vm.datasetDefinition = response.data;
					vm.datasetDefinition['AttributesIds'] = vm.datasetDefinition.Attributes.map(function(attr) {
						return attr.AttributeId;
					})
					vm.title = angular.copy(vm.datasetDefinition[vm.model.lookupDisplayField]);

					initializeTabData(isLogRequired);

					//Update Breadcrumb
					$state.current.data.displayName = vm.title;
					$rootScope.$broadcast('breadcrumb-updated');
					vm.model.isBulkActionCompleted = false;
				})
				.finally(function () {
					vm.isLoading = false;
				});
		}

		function initializeTabData(isLogRequired) {
			if(SecurityFactory.isAuthorized({accessPrivileges: CONSTANTS.PRIVILEGES.SELLERS.DETAIL.GET_DATASET_VALUES})) {
				refreshValues(vm.valuesModel.isDirty, isLogRequired);
			}
		}

		function refreshValues(forceFetch, isLogRequired) {
			var generalProperties = {
				forceFetch: forceFetch,
				isLogRequired: isLogRequired
			}
			vm.isValuesLoading = true;

			vm.valuesModel.methods.getList(generalProperties, vm.sellerId, datasetId)
			.then(function (response) {
				vm.datasetValues = transformDatasetValuesResponse(response.data);
				vm.valuesModel.isBulkActionCompleted = false;
			})
			.finally(function() {
				vm.isValuesLoading = false;
			});
			// vm.datasetValues = transformDatasetValuesResponse([{
    	// "Id": 5,
			// "Value": {
			// 		"Gender": "Mens",
			// 		"FitType": "Value2",
			// },
			// "DisplayValue": "ABC",
			// "CreatedDate": "2022-11-10T02:46:03.490Z",
			// "UpdatedDate": "2022-11-10T02:46:03.490Z",
			// "CreatedBy": 1816,
			// "UpdatedBy": 1816,
			// }])
		}

		function doValuesListAction(action, records) {
			if (action) {
				switch (action.id) {
					case 'import':
						dataImporter.importExcel(vm.valuesModel, true).then(function (result) {
							vm.valuesModel.methods.createBulk(vm.valuesModel, result.data, datasetId, vm.sellerId).then(function() {
								refreshValues(true);
							})
						})
						break;
					case 'updateBulk':
						var modelCopy = angular.copy(vm.valuesModel);
						var lookupPromises = {};
						lookupPromises = crud.createLookupPromise(modelCopy, undefined , 'edit');
						bulkUpdater.showDialog(modelCopy, vm.datasetValues, {'sellerId': vm.sellerId, 'datasetId': datasetId}, lookupPromises);
						break;
					case 'delete':
						vm.valuesModel.methods.deleteBulk(records, vm.sellerId, datasetId).then(function () {
							refreshValues(true);
						});
						break;
				}
			}
		}

		function doValuesItemAction(action, record) {
			if (action) {
				switch (action.id) {
					case 'delete':
						vm.valuesModel.methods.deleteBulk([record], vm.sellerId, datasetId).then(function () {
							refreshValues(true);
						});
						break;
				}
			}
		}

		// transform dataset values to required form
		function transformDatasetValuesResponse(datasetValues) {
			 var transformedResponse = [];
			angular.forEach(datasetValues, function(item) {
					var transformedItem = {
							Id: item.Id,
							DisplayValue: item.DisplayValue,
							// The read side returns active values only, so treat a row as Active (1) unless the
							// API explicitly marks it inactive. Coerced to int 1/0 because the 'status' column
							// renderer uses strict === 1/=== 0, and the delete actions gate on Status === 1
							// (visible:'itm.Status', disabled:'{selected:true, Status:1}'). A missing/null Status
							// must NOT read as 0, or the column shows blank and the delete actions vanish/disable.
							Status: (item.Status === false || item.Status === 0) ? 0 : 1,
							CreatedBy: item.CreatedBy,
							UpdatedBy: item.UpdatedBy,
							CreatedDate: item.CreatedDate,
							UpdatedDate: item.UpdatedDate
					};
					// Parse numeric string values (e.g. "16.0") to numbers for number/decimal fields,
						// as Angular ngModel requires actual numbers for input[type=number]
						angular.forEach(item.Value, function(val, key) {
							var field = vm.valuesModel.fields.filter(function(f) { return f.field === key; })[0];
							if (field && (field.inputType === 'number' || field.inputType === 'decimal') && val !== null && val !== '') {
								transformedItem[key] = parseFloat(val);
							} else {
								transformedItem[key] = val;
							}
						});
					transformedResponse.push(transformedItem);
			});
			return transformedResponse;
		}
	}
})();
(function() {
    'use strict';
    
    angular
        .module('app.main.accounts.sellers.resource-types', []);    
})();
(function() {
    'use strict';

    angular
        .module('app.main.accounts.sellers.resource-types')
        .controller('createResourceTypeController', createResourceTypeController);

    /* @ngInject */
    function createResourceTypeController($scope,  $window, $mdDialog, $filter, toast, hotkeys, record, sellerId, isNew, event, model) {
        /* jshint validthis: true */
        var vm = this;

        //Data
        vm.model = model;

        vm.isLoading = false;
        vm.record = (angular.isDefined(record) && record != null)? record: {};
        vm.isNew = isNew;
        vm.searchText = '';
        vm.isDataDirty = false;
        vm.lookupModel = angular.copy(vm.record);


        //Methods
        vm.saveRecord = saveRecord;
        vm.closeDialog = closeDialog;

        activate();

        ////////////////

        function activate() {
            //Hotkeys
            hotkeys.bindTo($scope).add({
                combo: 'ctrl+enter',
                description: $filter('translate')('ACTIONS.SAVE'),
                allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
                callback: function(event) {
                    if (!vm.isLoading && !vm.editForm.$invalid) {
                        vm.saveRecord();
                    }
                }
            });

            if (vm.isNew) {
                hotkeys.bindTo($scope).add({
                    combo: 'ctrl+shift+enter',
                    description: $filter('translate')('ACTIONS.SAVE_AND_NEW'),
                    allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
                    callback: function(event) {
                        if (!vm.isLoading && !vm.editForm.$invalid) {
                            vm.saveRecord(true);
                        }
                    }
                });
            }
        }

        function saveRecord(saveAndNew) {
            vm.isLoading = true;
            var promise;
            if(isNew) {
                promise = vm.model.methods.create(vm.record, sellerId);
            }
            else {
                promise = vm.model.methods.update(vm.record, vm.record[model.idField], sellerId);
            }

            promise.then(function() {
                if (vm.isNew && angular.isDefined(saveAndNew) && saveAndNew) {
                    vm.editForm.$setPristine();
                    vm.editForm.$setUntouched();
                    vm.record = {};
                    vm.searchText = '';
                    vm.isDataDirty = true;
                    var el = $window.document.getElementById('dialog_input_first');
                    if (el) {
                        el.focus();
                    }
                } else {
                    closeDialog(true);
                }
                var toastMessage = isNew ? 'SUCCESS.CREATE': 'SUCCESS.UPDATE';
                toast.success(toastMessage, '', '');
            }, function(err) {
                closeDialog(vm.isDataDirty);
            }).finally(function () {
                vm.isLoading = false;
            });
        }

        function closeDialog(saved) {
            $mdDialog.hide(saved);
        }

    }
})();
(function() {
		'use strict';

		angular
				.module('app.main.accounts.sellers.master-size-scales', []);
})();
(function () {
	'use strict';

	angular
		.module('app.main.accounts.sellers.master-size-scales')
		.controller('addUpdateMasterSizeScaleController', addUpdateMasterSizeScaleController);

	/* @ngInject */
	function addUpdateMasterSizeScaleController($mdDialog, $scope, $filter, toast, hotkeys, utility, record, isNew, model, existingRecordsForUniqueValue, sellerId, availableSeasonlessModelAttributes, isEditCriteria, event) {
		/* jshint validthis: true */
		var vm = this;

		//Data
		vm.isLoading = false;
		vm.isDataDirty = false;
		vm.isNew = isNew;
		vm.record = angular.isArray(record) ? undefined : angular.copy(record);
		vm.criterias = [];
		vm.isEditCriteria = isEditCriteria;
		vm.selectedSizeScales = record; // for bulk edit criteria this will be array of records
		vm.existingRecordsForUniqueValue = existingRecordsForUniqueValue;

		vm.acSelectedItem = [];
		vm.acSearchText = [];
		vm.searchText = [];
		vm.lookupModel = [];
		vm.selectedAttibute = {};
		vm.tagSeperatorKeys = {};

		if (!vm.record) {
			vm.record = {};
			if(!vm.isEditCriteria) {
				vm.record['Sizes'] = [];
				vm.record['ObsoleteSizes'] = [];
			}
			vm.record.IsObsolete = 0; // default
			createEmptyRow();
		} else {
			// De-dupe on load: legacy records can hold duplicate sizes (e.g. "8.5"/"9" saved twice).
			// Duplicates break the md-chips render (ngRepeat:dupes -> no chips shown) and are rejected
			// by the API on save ("Duplicate Size Name(s)"), so normalise the values here.
			vm.record.Sizes = dedupeSizes(vm.record.Sizes.split(','));
			vm.record.ObsoleteSizes = vm.record.ObsoleteSizes.length ? dedupeSizes(vm.record.ObsoleteSizes.split(',')) : [];
			populateEditDialog();
		}

		//Methods
		vm.saveRecord = saveRecord;
		vm.closeDialog = closeDialog;

		vm.selectText = selectText;

		vm.add = add;
		vm.addSizes = addSizes;
		vm.transformChip = transformChip;
		vm.acQuerySearch = acQuerySearch;
		vm.getChipDisplayValue = getChipDisplayValue;

		vm.lookupAttributeSearch = lookupAttributeSearch;
		vm.lookupAttributeChange = lookupAttributeChange;
		vm.getAttributeLookupDisplayValue = getAttributeLookupDisplayValue;
		vm.getDateObj = getDateObj;


		activate();

		////////////////

		function activate() {
			//Hotkeys
			hotkeys.bindTo($scope).add({
				combo: 'ctrl+enter',
				description: $filter('translate')('ACTIONS.SAVE'),
				allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
				callback: function (event) {
					if (!vm.isLoading && !vm.editForm.$invalid) {
						vm.saveRecord();
					}
				}
			});
		}

		function saveRecord() {
			vm.isLoading = true;
			var p;

			// Guard: strip any duplicate sizes before persisting. md-chips blocks duplicates typed into
			// the input, but inline chip editing (md-enable-chip-edit) and legacy data can still bypass it,
			// and the API rejects duplicates with "Duplicate Size Name(s)".
			if (angular.isArray(vm.record.Sizes)) {
				vm.record.Sizes = dedupeSizes(vm.record.Sizes);
			}
			if (angular.isArray(vm.record.ObsoleteSizes)) {
				vm.record.ObsoleteSizes = dedupeSizes(vm.record.ObsoleteSizes);
			}

			// attributes
			var attributes = {};
			angular.forEach(vm.criterias, function(attribute) {
					if (angular.isDefined(attribute.value) && attribute.value.toString().trim() !== '') {
							if (angular.isObject(attribute) && attribute.Attributeid != null && angular.isUndefined(attributes[attribute.AttributeSystemName])) {

									// remove time from date and date option
									if (attribute.inputType === 'date-without-time' || attribute.inputType === 'date-option') {
											var value = attribute.value;
											var date = new Date(value.setHours(12 - (d.getTimezoneOffset() / 60), 0, 0));
											attributes[attribute.AttributeSystemName] = [date.split('T', 1)[0]];  // Ensure it's stored as an array
									}
									// send multivalue attributes as JSON array
									else if(attribute.inputType === 'multi-value' && angular.isDefined(attribute.value) && attribute.value != null && attribute.value !== '') {
											var multiValue = attribute.value;
											attributes[attribute.AttributeSystemName] = angular.isArray(multiValue) ? multiValue : [multiValue];  // Store as array
									}
									// For single value attributes, wrap them in an array
									else {
											attributes[attribute.AttributeSystemName] = [angular.isDefined(attribute.value) ? attribute.value : ''];  // Store as array even if single value
									}
							}
							// If the attribute already exists, push the value to the array
							else if (angular.isDefined(attributes[attribute.AttributeSystemName])) {
									// to support multi value, user can select the attribute again when wanting to create multi-value
									if (angular.isArray(attributes[attribute.AttributeSystemName])) {
											attributes[attribute.AttributeSystemName].push(angular.isDefined(attribute.value) ? attribute.value : '');
									} else {
											// Convert the existing single value to an array and add the new value
											var valueArray = [];
											valueArray.push(attributes[attribute.AttributeSystemName]);
											valueArray.push(angular.isDefined(attribute.value) ? attribute.value : '');
											attributes[attribute.AttributeSystemName] = valueArray;
									}
							}
					}
			});

			// stringfy criteria
			if (!utility.isObjectEmpty(attributes)) {
				vm.record['Criteria'] = angular.toJson(attributes);
			}
			else {
				vm.record['Criteria'] = '';
			}

			if (vm.isNew)
			{
					p = model.methods.create(vm.record, sellerId);
			} else if(vm.isEditCriteria) {
					p = model.methods.updateSizeScaleCriteriaBulk(vm.record['Criteria'], sellerId, vm.selectedSizeScales);
			} else {
					p = model.methods.update(vm.record.Id, vm.record, sellerId);
			}

			p.then(function(response) {
					closeDialog(true);
					var toastMessage;
					toastMessage = response.config.method.toUpperCase() === 'POST' ? 'SUCCESS.CREATE': 'SUCCESS.UPDATE';
					toast.success(toastMessage, '', '');
			}, function() {
					closeDialog(vm.isDataDirty);
			}).finally(function () {
					vm.isLoading = false;
			});
		}

		function closeDialog(saved) {
			$mdDialog.hide(saved);
		}

		function selectText(event) {
			utility.selectInputText(event);
		}

		function getDateObj(dateString, fromUTC) {
			if (dateString) {
				return utility.createDateObject(dateString, fromUTC);
			}
		}

		function add(chip, fields, rowIndex) {
			var field = fields[rowIndex]
			if (chip) {
					if (chip.indexOf(field.tagSeparator) !== -1) {
						vm.criterias[field.AttributeSystemName].splice(vm.criterias[field.AttributeSystemName].indexOf(chip), 1);
						vm.criterias[field.AttributeSystemName] = vm.criterias[field.AttributeSystemName].concat(chip.split(field.tagSeparator));
							vm.maxTags = vm.criterias[field.AttributeSystemName].length + 1;
					} else {
							vm.maxTags = field.maxLen;
					}
			}
			// for displaying error message
			if (angular.isDefined(field.maxLen) && vm.maxTags != field.maxLen) {
					vm.ErrorMessage = field.validation.messages.pattern;
					return true;
			} else {
					vm.ErrorMessage = "";
					return false;
			}
		}

		/**
		 * @description Removes duplicate values from a size list while preserving order.
		 * @param {array} list list of size strings
		 * @returns {array} list without duplicate values
		 */
		function dedupeSizes(list) {
			var result = [];
			angular.forEach(list, function (size) {
				if (result.indexOf(size) === -1) {
					result.push(size);
				}
			});
			return result;
		}

		/**
		 * @description md-on-add handler for the Sizes / Obsolete Sizes chip inputs. Drops an
		 *  accidental duplicate and surfaces an error message. Only mutates on a real add event
		 *  ($chip truthy); when re-evaluated from the ng-if that renders the error message
		 *  ($chip undefined) it simply reports the current state so it is digest-safe.
		 * @param {string} chip the chip that was just added
		 * @param {array} sizes the chip model the value was added to
		 * @returns {boolean} true when a duplicate is present
		 */
		function addSizes(chip, sizes) {
			if (chip && angular.isArray(sizes)) {
				if (sizes.indexOf(chip) !== sizes.lastIndexOf(chip)) {
					sizes.splice(sizes.lastIndexOf(chip), 1);
					vm.ErrorMessage = $filter('translate')('SELLER_SIZE_SCALE_GROUP.VALIDATIONS.DUPLICATE_SIZE');
					vm.hasDuplicateSize = true;
					return true;
				}
				vm.ErrorMessage = '';
				vm.hasDuplicateSize = false;
				return false;
			}
			return !!vm.hasDuplicateSize;
		}

		function transformChip(chip) {
			if (angular.isObject(chip)) {
				return chip;
			}
			return undefined;
		}

		function acQuerySearch(query, selectedRecords, allAttributes) {
			var searchQueryResult = [];
				if(angular.isDefined(allAttributes) && allAttributes.length) {
						searchQueryResult = utility.filterObject(allAttributes, query);
						removeSelectedChips(selectedRecords, searchQueryResult);
						return searchQueryResult;
				}
				else {
					return searchQueryResult;
				}
		}

		/**
		 * @description
		 * This method will remove selected chips form records (helper method)
		 * @param {array} selectedRecords: list of selected chips
		 * @param {array} records: data property of lookup-data
		 * @returns {array}: list of available chips (chips which are not selected) // it does not really need to return a value but for readability returning modified value
		 */
		function removeSelectedChips(selectedRecords, records) {
			if (angular.isDefined(selectedRecords) && selectedRecords.length > 0) {
				for (var index = records.length - 1; index >= 0; index--) {
					if (selectedRecords.indexOf(records[index]) !== -1) {
						records.splice(index, 1);
					}
				}
			}
			return records;
		}

		function getChipDisplayValue(chip) {
			return chip;
		}

		function lookupAttributeSearch(query) {
			var results = [];
			var predicate = {};
			predicate.AttributeDisplayName = query;
			results = query ? utility.filterObject(availableSeasonlessModelAttributes, predicate) : availableSeasonlessModelAttributes;
			return results;
		}

		function lookupAttributeChange(selectedObj, rowIndex) {
			if (angular.isObject(selectedObj)) {
				vm.criterias[rowIndex].Attributeid = selectedObj.Attributeid;
				vm.criterias[rowIndex] = utility.changeAttributeType(selectedObj);
				vm.criterias[rowIndex].value = '';
				if(vm.criterias[rowIndex].inputType === 'tags' || vm.criterias[rowIndex].inputType === 'multi-value') {
					vm.criterias[rowIndex].value = [];
				}
			}
			else if (angular.isUndefined(selectedObj) || selectedObj === null) {
				vm.selectedAttibute[rowIndex] = {};
				vm.criterias[rowIndex].Attributeid = undefined; // on record removal make field undefined or the property can be deleted using delete keyword
				vm.criterias[rowIndex].value = '';
			}
			if(rowIndex === vm.criterias.length-1) {
				createEmptyRow();
			}
		}

		function getAttributeLookupDisplayValue(item) {
			return getAttributeLookupDisplayVal(item);
		}

		function getAttributeLookupDisplayVal(item) {
			var result;
			if (availableSeasonlessModelAttributes) {
				// since autocomplete return object
				if (angular.isObject(item)) {
					result = utility.filterObject(availableSeasonlessModelAttributes, { Attributeid: item.Attributeid }, true);
				}
				// to initialize field value if any (when open update record dialog)
				else {
					result = utility.filterObject(availableSeasonlessModelAttributes, { Attributeid: item }, true);
				}

				if (angular.isArray(result) && result.length > 0) {
					return result[0].AttributeDisplayName;
				}
				else {
					return result.AttributeDisplayName;
				}
			}
		}

		function populateEditDialog() {
			if(utility.isValidJSON(record.Criteria)) {
				var criteria = JSON.parse(record.Criteria);

				for(var key in criteria) {
					if(criteria.hasOwnProperty(key)) {
							// if multiple values are assigned show the attibute with multiple values one by one
							var values = criteria[key];
							if(!angular.isArray(criteria[key])) {
								values = [criteria[key]];
							}
							var attribute = utility.filterObject(availableSeasonlessModelAttributes, {AttributeSystemName: key}, true)[0];
							if(angular.isDefined(attribute)) {
								if(attribute.AttributeTypeName !== 'multivalue') {
									angular.forEach(values, function(value) {
										var recordsLength = vm.criterias.push({ Attributeid: attribute.Attributeid});
										if(angular.isUndefined(vm.lookupModel[recordsLength-1])) {
											vm.lookupModel[recordsLength-1] = {};
										}
										vm.lookupModel[recordsLength-1].Attributeid = attribute.Attributeid;
										vm.criterias[recordsLength-1] = utility.changeAttributeType(attribute);
										vm.criterias[recordsLength-1].value = value;
									});
								} else {
									var recordsLength = vm.criterias.push({ Id: attribute.Attributeid});
									if(angular.isUndefined(vm.lookupModel[recordsLength-1])) {
										vm.lookupModel[recordsLength-1] = {};
									}
									vm.lookupModel[recordsLength-1].Attributeid = attribute.Attributeid;
									vm.criterias[recordsLength-1] = utility.changeAttributeType(attribute);
									vm.criterias[recordsLength-1].value = values;
								}
							}
					}
				}
			}
			createEmptyRow();
		}

		function createEmptyRow() {
			vm.searchText.push({});
			vm.lookupModel.push({});
			vm.criterias.push({ Attributeid: null});
		}

	}
})();
(function() {
	'use strict';

	angular
		.module('app.main.accounts.sellers.capacities')
		.controller('capacityDetailsController', capacityDetailsController);

	/* @ngInject */
	function capacityDetailsController(api, $state, $stateParams, $rootScope, settingsFactory) {
		/* jshint validthis: true */
		var vm = this;

		// Data
		var sellerId = $stateParams.sellerId;
		var capacityId = $stateParams.capacityId;

		vm.capacitiesModel = api.sellers.capacities;
		vm.capacityCustomersModel = api.capacities.customerLinks;
		settingsFactory.applyPersistedListViewLayout(vm.capacityCustomersModel);

		vm.tabIndex = 0;
		vm.capacity = {};
		vm.customers = [];
		vm.filteredCustomers = [];
		vm.isLoading = false;

		// Methods
		vm.refreshRecord = refreshRecord;

		activate();

		////////////////

		function activate() {
			refreshRecord(true);
		}

		// API 3 - GET api/sellers/{sellerId}/capacities/{capacityId}
		function refreshRecord(isLogRequired) {
			vm.isLoading = true;
			vm.capacitiesModel.methods.getDetails(isLogRequired, capacityId, sellerId).then(function(response) {
				vm.capacity = response.data;
				// render Criteria as the raw JSON string (mirrors the Master Size Scale Criteria field)
				vm.capacity.Criteria = angular.isString(vm.capacity.Criteria) ? vm.capacity.Criteria : angular.toJson(vm.capacity.Criteria);
				vm.customers = vm.capacity.Customers || [];
				// API 3 returns one row per customer PER CATALOG, so CustomerId alone is not a row key.
				// Synthesize the (customer, catalog) pair the grid model declares as its idField.
				angular.forEach(vm.customers, function(link) {
					link.LinkId = link.CustomerId + '-' + link.CatalogCode;
				});
				// API 3 (details) doesn't return LinkedCustomersCount (it returns the full Customers[] instead),
				// so derive it from the embedded array — otherwise the "Linked Customers" field renders blank.
				// Count ACTIVE links only: that is what API 2's LinkedCustomersCount means, and API 3 returns
				// deactivated links too, so an unfiltered length would disagree with the Capacities list.
				vm.capacity.LinkedCustomersCount = vm.customers.filter(function(link) {
					return link.Status === 1;
				}).length;
				vm.title = vm.capacity[vm.capacitiesModel.lookupDisplayField];

				// Update breadcrumb
				$state.current.data.displayName = vm.title;
				$rootScope.$broadcast('breadcrumb-updated');
			}).finally(function() {
				vm.isLoading = false;
			});
		}
	}
})();

(function() {
  'use strict';

  angular
      .module('app.main.accounts.auth-users.auth-environments', []);
})();
(function () {
  'use strict';

  angular
    .module('app.main.accounts.auth-users.auth-environments')
    .controller('addEnvironmentToAuthUserController', addEnvironmentToAuthUserController);

  /* @ngInject */
  function addEnvironmentToAuthUserController($mdDialog, $scope, $window, hotkeys, $filter, utility, model, unAssignedEnvironments, userId, isNew, record, api, toast) {
    /* jshint validthis: true */
    var vm = this;

    //Data
    vm.model = model;
    vm.userId = userId;
    vm.unAssignedEnvironments = unAssignedEnvironments;
    vm.record = {};
    vm.record.updateT1 = false;
    vm.isNew = isNew;

    vm.isLoading = false;
    vm.availableSegmentations = [];
    vm.isDataDirty = false;
    vm.lookupModel = {};
    if(!vm.isNew && record !== null) {
        vm.lookupModel = angular.copy(record);
        vm.record.envCode = vm.lookupModel.code;
    }
    vm.accountTypes = [
        { id: 1, value: "Admin" },
        { id: 2, value: "Seller", lookupSource: 'accounts.sellers' },
        { id: 3, value: "Buyer", lookupSource: 'accounts.buyers' }
    ];
    vm.record.accountId = 1;//set default id as 1(admin)
    vm.accountType = {};
    var requestforSeller = false;
    var requestforBuyer = false;
    var lookupPromises= {};

    //Methods
    vm.saveRecord = saveRecord;
    vm.closeDialog = closeDialog;

    vm.lookupSearch = lookupSearch;
    vm.lookupChange = lookupChange;
    vm.getLookupDisplayValue = getLookupDisplayValue;
    vm.accountLookupSearch = accountLookupSearch;
    vm.getAccountLookupDisplayValue = getAccountLookupDisplayValue;
    vm.accountLookupChange = accountLookupChange;
    vm.onAccountTypeChange = loadAccounts;
    vm.selectText = selectText;

    activate();


    ////////////////

    function activate() {

        hotkeys.bindTo($scope).add({
            combo: 'ctrl+enter',
            description: $filter('translate')('ACTIONS.SAVE'),
            allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
            callback: function(event) {
                if (!vm.isLoading && !vm.editForm.$invalid) {
                    vm.saveRecord();
                }
            }
        });

        if (vm.isNew) {
            hotkeys.bindTo($scope).add({
                combo: 'ctrl+shift+enter',
                description: $filter('translate')('ACTIONS.SAVE_AND_NEW'),
                allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
                callback: function(event) {
                    if (!vm.isLoading && !vm.editForm.$invalid) {
                        vm.saveRecord(true);
                    }
                }
            });
        }
    }

    function saveRecord(saveAndNew) {
        vm.isLoading = true;
        var p;
        if (vm.isNew)
        {
            p = model.methods.create(vm.record, vm.userId);
        } else {
            p = model.methods.delete(vm.record, vm.userId);
        }

        p.then(function(response) {
            if (angular.isDefined(saveAndNew) && saveAndNew) {
                vm.editForm.$setPristine();
                vm.editForm.$setUntouched();
                updateUnAssignedRecords(vm.record);
                vm.record = {};
                vm.acSearchText = [];
                vm.searchText = {};
                vm.isDataDirty = true;
                var el = $window.document.getElementById('dialog_input_first');
                if (el) {
                    el.focus();
                }
            } else {
                closeDialog(true);
            }
            var toastMessage;
            toastMessage = response.config.method.toUpperCase() === 'POST' ? 'SUCCESS.CREATE': 'SUCCESS.DELETE';
            toast.success(toastMessage, '', '');
        }, function() {
            closeDialog(vm.isDataDirty);
        }).finally(function () {
            vm.isLoading = false;
        });
    }

    function closeDialog(saved) {
        $mdDialog.hide(saved);
    }

    function lookupSearch(query, data, lookupPropertyName) {
        var results = [];
        var predicate = {};
        predicate[lookupPropertyName] = query;
        results = query ? utility.filterObject(data, predicate) : data;
        return results;
    }

    function lookupChange(selectedObj, recordPropertyName, lookupPropertyName) {
        if (angular.isObject(selectedObj)) {
            vm.record[recordPropertyName] = selectedObj[lookupPropertyName];
        }
        else if (angular.isUndefined(selectedObj) || selectedObj === null) {
            vm.record[recordPropertyName] = undefined;
        }
    }

    function getLookupDisplayValue(item, sourceData, lookupProperty) {
        var result;
        var predicate = {};
        // since autocomplete return object
        if (angular.isObject(item)) {
            predicate[lookupProperty] = item[lookupProperty];
            result = utility.filterObject(sourceData, predicate, true);
        }
        else {
            predicate[lookupProperty] = item;
            result = utility.filterObject(sourceData, predicate, true);
        }

        if (angular.isArray(result) && result.length > 0) {
            return result[0].name;
        }
        else {
            return result.name;
        }
    }

    function loadAccounts(accountType) {
        if (accountType.id === 2 && !requestforSeller) {
            requestforSeller = true;
            lookupPromises['Seller'] = api.getLookupData(api.accounts.sellers);

        }
        else if (accountType.id === 3 && !requestforBuyer) {
            requestforBuyer = true;
            lookupPromises['Buyer'] = api.getLookupData(api.accounts.buyers);
        }
        vm.accountTypeId = accountType.id;
        vm.lookupModel.AccountId = undefined;
        vm.searchText.AccountId = '';
    }

    function accountLookupSearch(query, field, lookupSource, lookupFilter) {
        var results = [];
        var predicate = angular.isDefined(lookupFilter) ? angular.copy(lookupFilter) : {};
        predicate.value = query;
        var lookupModel = api.getModel(lookupSource);

        if (angular.isDefined(lookupModel.lookupData) && angular.isDefined(lookupModel.lookupData.data) && lookupModel.lookupData.data.length) {
            results = query ? utility.filterObject(lookupModel.lookupData.data, predicate) : utility.filterObject(lookupModel.lookupData.data, lookupFilter, true);
            return results;
        }
        else {
            return lookupPromises[field].then(function (lookupData) {
                results = query ? utility.filterObject(lookupData.data, predicate) : utility.filterObject(lookupData.data, lookupFilter, true);
                return results;
            });
        }
    }

    function accountLookupChange(selectedObj, field) {
        if (angular.isObject(selectedObj)) {
            vm.record[field] = selectedObj.id;
        }
        else if (angular.isUndefined(selectedObj) || selectedObj === null) {
            vm.record[field] = undefined;
        }
    }

    function getAccountLookupDisplayValue(item, field, lookupSource) {
        var lookupModel = api.getModel(lookupSource);

        if (angular.isDefined(lookupModel.lookupData) && angular.isDefined(lookupModel.lookupData.data) && lookupModel.lookupData.data.length) {
            return getLookupDisplayVal(item, lookupModel.lookupData);
        }
        else {
            return lookupPromises[field].then(function (lookupData) {
                return getLookupDisplayVal(item, lookupData);
            });
        }
    }

    function getLookupDisplayVal(item, lookupData) {
        var result;
        if (lookupData) {
            if (angular.isObject(item)) {
                result = utility.filterObject(lookupData.data, { id: item.id }, true);
            }
            else {
                result = utility.filterObject(lookupData.data, { id: item }, true);
            }

            if (angular.isArray(result) && result.length > 0) {
                return result[0].value;
            }
            else {
                return result.value;
            }
        }
    }

    function selectText(event) {
        utility.selectInputText(event);
    }

    function updateUnAssignedRecords(record) {
        var index = vm.unAssignedEnvironments.indexOf(utility.filterObject(vm.unAssignedEnvironments, { code: record.envCode }, true)[0]);
        if (index !== -1) {
            vm.unAssignedEnvironments.splice(index, 1);
        }
    }

  }
})();
(function() {
        'use strict';

        angular
                .module('app.main.seller-models.seller-model-resources', []);
})();
(function() {
    'use strict';

    angular
        .module('app.main.seller-models.seller-model-resources')
        .controller('assignSellerModelResourcesController', assignSellerModelResourcesController);

    /* @ngInject */
    function assignSellerModelResourcesController($mdDialog, $scope, $filter, hotkeys, toast, api, utility, $q,
                sellerId, attributeGroupId, modelId, model, assignedResources) {
        /* jshint validthis: true */
        var vm = this;

        //Data
        vm.model = model;
        vm.isLoading = false;
        vm.record = {};
        vm.record.ResourceId = [];
        vm.resourceLookup = {};

        //Methods
        vm.saveRecord = saveRecord;
        vm.closeDialog = closeDialog;

        vm.transformChip = transformChip;
        vm.acQuerySearch = acQuerySearch;
        vm.getChipDisplayValue = getChipDisplayValue;

        activate();

        ////////////////

        function activate() {
            loadResourcesLookup();
            hotkeys.bindTo($scope).add({
                combo: 'ctrl+enter',
                description: $filter('translate')('ACTIONS.SAVE'),
                allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
                callback: function() {
                    if (!vm.isLoading && !vm.editForm.$invalid) {
                        saveRecord();
                    }
                }
            });
        }

        function saveRecord() {
            vm.isLoading = true;
            vm.model.methods.create(vm.record, sellerId, attributeGroupId, modelId).then(function() {
                closeDialog(true);
                toast.success('SUCCESS.CREATE', '', '');
            }).finally(function () {
                closeDialog();
                vm.isLoading = false;
            });
        }

        function closeDialog(saved) {
            $mdDialog.hide(saved);
        }

        function transformChip(chip) {
            if (angular.isObject(chip)) {
                return chip.id;
            }
            return undefined;
        }

        function getChipDisplayValue(chip, resourcesLookup) {
            var res = utility.filterObject(resourcesLookup.data, {id: chip}, true);
            if (angular.isArray(res) && res.length > 0) {
                return res[0].value;
            }
        }

        function acQuerySearch(query, selectedItems, resourcesLookup) {
            var searchQueryResult = [];
            if(angular.isDefined(resourcesLookup.data) && resourcesLookup.data.length) {
                searchQueryResult = utility.filterObject(resourcesLookup.data, query);
                removeSelectedResources(selectedItems, searchQueryResult);
                return searchQueryResult;
            }
            else {
                return loadResourcesLookup().then(function(availableResources) {
                    searchQueryResult = utility.filterObject(availableResources.data, query);
                    removeSelectedResources(selectedItems, searchQueryResult);
                    return searchQueryResult;
                });
            }
        }

        //Helper Methods
        function loadResourcesLookup() {
            var deferred = $q.defer();
            // Fetch seller resources and filter to model-level only
            var generalProperties = { forceFetch: true, isLogRequired: false };
            api.webGet(api.baseUrl + '/sellers/' + sellerId + '/' + attributeGroupId + '/resources', undefined, true, true).then(function(result) {
                var allResources = result.data || [];
                // Filter to model-level, active resources only
                var modelLevelResources = allResources.filter(function(resource) {
                    return resource.IsModelLevel && resource.Status === 1;
                });
                // Convert to lookup format
                vm.resourceLookup = {
                    data: modelLevelResources.map(function(resource) {
                        return { id: resource.ResourceId, value: resource.ResourceName, Status: resource.Status, IsModelLevel: resource.IsModelLevel };
                    })
                };
                // Remove already-assigned resources
                angular.forEach(assignedResources, function(assignedResource) {
                    var index = -1;
                    for(var i = 0; i < vm.resourceLookup.data.length; i++) {
                        if(vm.resourceLookup.data[i].id === assignedResource.ResourceId) {
                            index = i;
                            break;
                        }
                    }
                    if(index !== -1) {
                        vm.resourceLookup.data.splice(index, 1);
                    }
                });
                deferred.resolve(vm.resourceLookup);
            });
            return deferred.promise;
        }

        function removeSelectedResources(selectedItems, searchQueryResult) {
            if (angular.isDefined(selectedItems) && selectedItems.length > 0) {
                for (var index = searchQueryResult.length-1; index >= 0; index--) {
                    if (selectedItems.indexOf(searchQueryResult[index].id) !== -1) {
                        searchQueryResult.splice(index,1);
                    }
                }
            }
        }

    }
})();
(function() {
    'use strict';
    
    angular
        .module('app.main.roles.privileges', []);
    
})();
(function() {
    'use strict';

    angular
        .module('app.main.roles.privileges')
        .controller('managePrivilegesController', managePrivilegesController);

    /* @ngInject */
    function managePrivilegesController($mdDialog, toast, $scope, $filter, hotkeys, model, assignedPrivileges, roleId, event) {
       /* jshint validthis: true */
        var vm = this;


        //data
        vm.model = model;
        vm.assignedPrivileges= assignedPrivileges
        vm.selectedPrivileges = [];
        vm.isSaving = false;
        vm.isLoading = false;


        //methods
        vm.saveRecord = saveRecord
        vm.closeDialog = closeDialog;


        activate();

        /////////////

        function activate() {
            getAllPrivileges();
            //Hotkeys
            hotkeys.bindTo($scope)
                .add({
                    combo: 'ctrl+enter',
                    description: $filter('translate')('ACTIONS.SAVE'),
                    allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
                    callback: function(event) {
                        if (!vm.isSaving && !vm.editForm.$invalid) {
                            vm.saveRecord();
                        }
                    }
                });
        }

        function saveRecord() {
                vm.isSaving = true;
            model.methods.update(roleId, vm.selectedPrivileges).then(function() {
                toast.success('SUCCESS.UPDATE', '', '');

            }).finally(function () {
                vm.isSaving = false;
                closeDialog(true);
            });
        }

        function closeDialog(saved) {
            $mdDialog.hide(saved);
        }

        function getAllPrivileges() {
            vm.isLoading = true;
            model.methods.getAllPrivileges(true, false).then(function (response) {
                vm.privilegesList = response.data;
            }).finally(function() {
                vm.isLoading = false;
            });
        }

    }
})();
(function() {
    'use strict';
    
    angular
        .module('app.main.customers.catalogs',[]);
})();
(function() {
    'use strict';

    angular
        .module('app.main.customers.catalogs')
        .controller('customerCatalogRelationController', customerCatalogRelationController);

    /* @ngInject */
    function customerCatalogRelationController($mdDialog, toast, api, utility, $scope, $window, $filter, hotkeys, $q, assignedRecords,
                record, sellerId, customerId, isNew, event) {
        /* jshint validthis: true */
        var vm = this;

        //Data
        vm.priceGroupModel = api.catalogs.priceGroup;
        var pgLookupPromise;
        vm.sellerCatalogModel = api.sellers.catalogs;
        vm.model = api.customers.catalogs;
        vm.sellerUsersModel = api.sellers.users;

        vm.isLoading = false;
        vm.record = {};
        vm.activeCatalogs = [];
        vm.priceGroups= [];
        var sellerUsers = [];
        vm.isNew = isNew;
        vm.acLookupModel = angular.copy(record);


        //Methods
        vm.loadCatalogActivePriceGroups = loadCatalogActivePriceGroups;
        vm.saveRecord = saveRecord;
        vm.closeDialog = closeDialog;

        vm.catLookupSearch = catLookupSearch;
        vm.catLookupChange = catLookupChange;
        vm.getCatLookupDisplayValue = getCatLookupDisplayValue;

        vm.pgLookupSearch = pgLookupSearch;
        vm.pgLookupChange = pgLookupChange;
        vm.getPgLookupDisplayValue = getPgLookupDisplayValue;

        vm.usersLookupSearch = usersLookupSearch;
        vm.getUserLookupDisplayValue = getUserLookupDisplayValue;
        vm.userLookupChange = userLookupChange;

        vm.selectText = selectText;


        activate();

        ////////////////

        function activate() {
            loadActiveSellerCatalogs();
            if(!isNew) {
                vm.record = record;
                loadOrderPriceGroupDisplayValue();
                //for new records it gets called catalog on change of catalog-dropdown
                loadCatalogActivePriceGroups(record.CatalogCode);
            }

            //Hotkeys
            hotkeys.bindTo($scope).add({
                combo: 'ctrl+enter',
                description: $filter('translate')('ACTIONS.SAVE'),
                allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
                callback: function(event) {
                    if (!vm.isLoading && !vm.editForm.$invalid) {
                        vm.saveRecord();
                    }
                }
            });
            hotkeys.bindTo($scope).add({
                combo: 'ctrl+shift+enter',
                description: $filter('translate')('ACTIONS.SAVE_AND_NEW'),
                allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
                callback: function(event) {
                    if (!vm.isLoading && !vm.editForm.$invalid) {
                        vm.saveRecord(true);
                    }
                }
            });
        }

        function saveRecord(saveAndNew) {
            vm.isLoading = true;
            var promise;
            if (vm.orderPriceGroup === 1) {
                vm.record.OrderPriceGroupId = vm.record.WholesalePriceGroupId;
            }
            else if (vm.orderPriceGroup === 2) {
                vm.record.OrderPriceGroupId = vm.record.RetailPriceGroupId;
            }
            if(isNew) {
                promise = vm.model.methods.create(vm.record, sellerId, customerId);
            }
            else {
                promise = vm.model.methods.update(vm.record, sellerId, customerId);
            }
            promise.then(function() {
                if (angular.isDefined(saveAndNew) && saveAndNew) {
                    vm.editForm.$setPristine();
                    vm.editForm.$setUntouched();
                    // Add vm.record.CustomerId to assignedRecords, it will be used in save&new to splice assigned record from the dropdown
                    var assignedCatalog = {};
                    assignedCatalog.CatalogCode = vm.record.CatalogCode;
                    assignedRecords.push(assignedCatalog);

                    loadActiveSellerCatalogs();
                    vm.record = {};
                    vm.orderPriceGroup = undefined;
                    vm.acSearchText = [];
                    vm.searchText = {};
                    vm.isDataDirty = true;
                    var el = $window.document.getElementById('dialog_input_first');
                    if (el) {
                        el.focus();
                    }
                } else {
                    closeDialog(true);
                }
                var toastMessage = isNew ? 'SUCCESS.CREATE': 'SUCCESS.UPDATE';
                toast.success(toastMessage, '', '');
            }, function() {
                closeDialog(vm.isDataDirty);
            }).finally(function () {
                vm.isLoading = false;
            });
        }

        function closeDialog(saved) {
            $mdDialog.hide(saved);
        }


        function catLookupSearch(query, fieldName, lookupObj) {
            var results = [];

            var field = utility.filterObject(vm.model.fields, {field: fieldName})[0];
            var lookupFilter = angular.isDefined(field.lookupFilter) ? field.lookupFilter : {};
            var predicate = angular.copy(lookupFilter);
            predicate[vm.sellerCatalogModel.lookupDisplayField] = query;

            if(angular.isDefined(vm.activeCatalogs) && angular.isArray(vm.activeCatalogs) && vm.activeCatalogs.length) {
                results = query ? utility.filterObject(vm.activeCatalogs , predicate) : utility.filterObject(vm.activeCatalogs, lookupFilter, true);
                return results;
            }
            else {
                return loadActiveSellerCatalogs().then(function(activeCatalogs) {
                    results = query ? utility.filterObject(activeCatalogs, predicate) : utility.filterObject(activeCatalogs, lookupFilter, true);
                    return results;
                });
            }
        }

        // convert dropdown scope value form object(lookup record) to id property of lookup record
        function catLookupChange(selectedObj, field) {
            if(angular.isObject(selectedObj)) {
                vm.record[field] = selectedObj[vm.sellerCatalogModel.idField];
                loadCatalogActivePriceGroups(vm.record[field]);
            }
            else if(angular.isUndefined(selectedObj) || selectedObj === null) {
                vm.record[field] = undefined; // on record removal make field undefined or the property can be deleted using delete keywork
            }
        }

        function getCatLookupDisplayValue(item, fieldName) {
            if(angular.isDefined(vm.activeCatalogs) && angular.isArray(vm.activeCatalogs) && vm.activeCatalogs.length) {
                return getCatLookupDisplayVal(item, vm.activeCatalogs);
            }
            else {
                return loadActiveSellerCatalogs().then(function(activeCatalogs) {
                    return getCatLookupDisplayVal(item, activeCatalogs);
                });
            }
        }

        function pgLookupSearch(query, fieldName, lookupObj) {
            var results = [];

            var field = utility.filterObject(vm.model.fields, {field: fieldName})[0];
            var lookupFilter = angular.isDefined(field.lookupFilter) ? field.lookupFilter : {};
            var predicate = angular.copy(lookupFilter);
            predicate[vm.priceGroupModel.lookupDisplayField] = query;

            if(angular.isDefined(vm.priceGroups) && angular.isArray(vm.priceGroups) && vm.priceGroups.length) {
                results = query ? utility.filterObject(vm.priceGroups , predicate) : utility.filterObject(vm.priceGroups, lookupFilter, true);
                return results;
            }
            else {
                return pgLookupPromise.then(function(result) {
                    results = query ? utility.filterObject(result , predicate) : utility.filterObject(result, lookupFilter, true);
                    return results;
                });
            }
        }

        // convert dropdown scope value form object(lookup record) to id property of lookup record
        function pgLookupChange(selectedObj, field) {
            if(angular.isObject(selectedObj)) {
                vm.record[field] = selectedObj[vm.priceGroupModel.idField];
            }
            else if(angular.isUndefined(selectedObj) || selectedObj === null) {
                vm.record[field] = undefined; // on record removal make field undefined or the property can be deleted using delete keywork
            }
        }

        function getPgLookupDisplayValue(item, fieldName) {
            if(angular.isDefined(vm.priceGroups) && angular.isArray(vm.priceGroups) && vm.priceGroups.length) {
                return getPgLookupDisplayVal(item, vm.priceGroups);
            }
            else {
                return pgLookupPromise.then(function(priceGroups) {
                    return getPgLookupDisplayVal(item, priceGroups);
                });
            }
        }

        function usersLookupSearch(query) {
            var results = [];
            var predicate = {};
            predicate[vm.sellerUsersModel.lookupDisplayField] = query;

            if(angular.isDefined(sellerUsers) && angular.isArray(sellerUsers) && sellerUsers.length) {
                results = query ? utility.filterObject(sellerUsers , predicate) : sellerUsers;
                return results;
            }
            else {
                return loadSellerUsers().then(function() {
                    results = query ? utility.filterObject(sellerUsers , predicate) : sellerUsers;
                    return results;
                });
            }
        }

        function getUserLookupDisplayValue(item) {

            if(angular.isDefined(sellerUsers) && angular.isArray(sellerUsers) && sellerUsers.length) {
                return getUserLookupDisplayVal(item, sellerUsers);
            }
            else {
                return loadSellerUsers().then(function() {
                    return getUserLookupDisplayVal(item, sellerUsers);
                });
            }
        }

        function userLookupChange(selectedObj, field) {
            if(angular.isObject(selectedObj)) {
                vm.record[field] = selectedObj[vm.sellerUsersModel.idField];
            }
            else if(angular.isUndefined(selectedObj) || selectedObj === null) {
                vm.record[field] = undefined; // on record removal make field undefined or the property can be deleted using delete keywork
            }
        }


        //helper method
        function getCatLookupDisplayVal(item, activeCatalogs) {
            var result;
            var filterPredicate = {};
            if(activeCatalogs) {
                // since autocomplte return object
                if(angular.isObject(item)) {
                    filterPredicate[vm.sellerCatalogModel.idField] = item[vm.sellerCatalogModel.idField];
                    result = utility.filterObject(activeCatalogs, filterPredicate, true);
                }
                // to initialize field value if any (when open update record dialog)
                else {
                    filterPredicate[vm.sellerCatalogModel.idField] = item;
                    result = utility.filterObject(activeCatalogs, filterPredicate, true);
                }

                if (angular.isArray(result) && result.length > 0) {
                    return result[0][vm.sellerCatalogModel.lookupDisplayField];
                }
                else {
                    return result[vm.sellerCatalogModel.lookupDisplayField];
                }
            }
        }

        function getPgLookupDisplayVal(item, priceGroups) {
            var result;
            var filterPredicate = {};
            if(priceGroups) {
                // since autocomplte return object
                if(angular.isObject(item)) {
                    filterPredicate[vm.priceGroupModel.idField] = item[vm.priceGroupModel.idField];
                    result = utility.filterObject(priceGroups, filterPredicate, true);
                }
                // to initialize field value if any (when open update record dialog)
                else {
                    filterPredicate[vm.priceGroupModel.idField] = item;
                    result = utility.filterObject(priceGroups, filterPredicate, true);
                }

                if (angular.isArray(result) && result.length > 0) {
                    return result[0][vm.priceGroupModel.lookupDisplayField];
                }
                else {
                    return result[vm.priceGroupModel.lookupDisplayField];
                }
            }
        }

        function getUserLookupDisplayVal(item, sellerUsersList) {
            var result;
            if(sellerUsersList) {
                var predicate = {}
                // since autocomplte return object
                if(angular.isObject(item)) {
                    predicate[vm.sellerUsersModel.idField] = item[vm.sellerUsersModel.idField];
                    result = utility.filterObject(sellerUsersList, predicate, true);
                }
                // to initialize field value if any (when open update record dialog)
                else {
                    predicate[vm.sellerUsersModel.idField] = item;
                    result = utility.filterObject(sellerUsersList, predicate, true);
                }

                if (angular.isArray(result) && result.length > 0) {
                    return result[0][vm.sellerUsersModel.lookupDisplayField];
                }
                else {
                    return result[vm.sellerUsersModel.lookupDisplayField];
                }
            }
        }

        function selectText(event) {
            utility.selectInputText(event);
        }

        function loadOrderPriceGroupDisplayValue() {
            if(angular.isUndefined(vm.record.WholesalePriceGroupId)) {
                vm.orderPriceGroup = 2;
            }
            else if(angular.isUndefined(vm.record.RetailPriceGroupId)) {
                vm.orderPriceGroup = 1;
            }
            else if(vm.record.OrderPriceGroupId === vm.record.WholesalePriceGroupId) {
                vm.orderPriceGroup = 1;
            }
            else if(vm.record.OrderPriceGroupId === vm.record.RetailPriceGroupId) {
                vm.orderPriceGroup = 2;
            }
        }

        function loadSellerUsers() {
            var deferred = $q.defer();
            vm.sellerUsersModel.methods.getList( { forceFetch: vm.sellerUsersModel.isDirty, isLogRequired: false }, sellerId).then(function(response) {
                sellerUsers = utility.filterObject(response.data, {Status: 1});
                deferred.resolve();
            });
            return deferred.promise;
        }

        function loadActiveSellerCatalogs() {
            var deferred = $q.defer();
            vm.activeCatalogs = [];
            vm.sellerCatalogModel.methods.getList( { forceFetch: vm.sellerCatalogModel.isDirty, isLogRequired: false }, sellerId).then(function(response) {
                var resultClone = utility.filterObject(response.data, {Status: 1});
                angular.forEach(assignedRecords, function(assignedRecord) {
                    var index = resultClone.indexOf(utility.filterObject(resultClone, {CatalogCode: assignedRecord.CatalogCode}, true)[0]);
                    if(index !== -1) {
                        resultClone.splice(index, 1);
                    }
                });

                // update indexArray of dirty lookup if needed
                // utility.updateLookupDataIndexes(resultClone);
                vm.activeCatalogs = resultClone;
                deferred.resolve(vm.activeCatalogs);
            });
            return deferred.promise;
        }

        function loadCatalogActivePriceGroups(CatalogCode) {
            var deferred = $q.defer();
            vm.priceGroups = [];
            var isLogRequired = false;
            api.catalogs.catalogs.methods.getDetails(isLogRequired, CatalogCode).then(function(response) {
                vm.priceGroups = utility.filterObject(response.data.CatalogPriceGroupList, {Status: 1});
                deferred.resolve(vm.priceGroups);
            });
            pgLookupPromise = deferred.promise;
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.main.catalogs.tree-list',[])
        .config(config);

    /* @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
        // State
        $stateProvider.state('app.tree_list', {
            url    : '/catalog-tree-list',
            params : {treeDefinition : undefined, catalog: undefined},
            views  : {
                'content@app': {
                    templateUrl: 'app/main/catalogs/sub-modules/tree-list/list/tree-list.html',
                    controller : 'treeListController as vm'
                }
            },
            resolve: {
            },
            data: {
                displayName: 'CATALOG_TREE.NAV'
            },
            //only users with following accessPrivileges in their role access list can access this route
            // accessPrivileges: ['GetCatalogTreeNodes']
            // accessPrivileges: ['nav_catalog_tree']
            accessInfo: {
                accessPrivileges: ['nav_catalog_tree']
            },
            visibleForLinePlan: true
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/catalogs/sub-modules/tree-list');

        msNavigationServiceProvider.saveItem('catalogs.tree.tree_list', {
            title      : 'List View',
            subTitle   : 'Catalog Tree',
            icon       : 'icon-sitemap',
            state      : 'app.tree_list',
            translate  : 'NAV.LIST_VIEW',
            weight     : 90,
            // accessPrivileges: ['GetCatalogTreeNodes']
            // accessPrivileges: ['nav_catalog_tree']
            accessInfo: {
                accessPrivileges: ['nav_catalog_tree']
            },
            visibleForLinePlan: true
        });
    }
})();
(function() {
	'use strict';

	angular
		.module('app.main.catalogs.tree-list')
		.controller('updateSortOrderController', updateSortOrderController);

	/**ngInject */
	function updateSortOrderController($mdDialog, toast, model, record, activeCatalogCode, currentTreeNodeProperties, catalogTreeId, treeFactory) {
		var vm = this;
		//data
		vm.record = angular.copy(record);
		vm.isDataDirty = false;
		vm.currentTreeNodeProperties = angular.copy(currentTreeNodeProperties);
		var catalogTreeId = catalogTreeId;
		vm.min = 0;
		vm.max = 0;

		//methods
		vm.saveRecord = saveRecord;
		vm.closeDialog = closeDialog;

		activate();

		////////////////

		function activate() {
			var sameLevelNodes = treeFactory.getSameLevelNodes(vm.record, vm.currentTreeNodeProperties);
			getMinMaxValidationvalues(sameLevelNodes);
		}

		function saveRecord() {
			vm.isLoading = true;
			model.methods.update(vm.record, activeCatalogCode, currentTreeNodeProperties, catalogTreeId).then(function() {
				closeDialog(true);
				toast.success('SUCCESS.UPDATE', '', '');
			}, function(err) {
				closeDialog(vm.isDataDirty);
			}).finally(function () {
				vm.isLoading = false;
			});
		}

		function closeDialog(saved) {
			$mdDialog.hide(saved);
		}

		function getMinMaxValidationvalues(sameLevelNodes) {
			vm.max = sameLevelNodes.length -1;
			angular.forEach(sameLevelNodes, function(node) {
				if(node.SortOrder <= vm.min) {
					vm.min = node.SortOrder;
				} else if(node.SortOrder > vm.max) {
					vm.max = node.SortOrder;
				}
			});
		}
	}
})();
(function() {
		'use strict';

		angular
				.module('app.main.catalogs.shared-folders', [
					'app.main.catalogs.shared-folders.shared-folder-users'
				])
				.config(config);

		/* @ngInject */
		function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {

				$stateProvider.state('app.shared_folders', {
						url    : '/shared-folders',
						views  : {
								'content@app': {
										templateUrl: 'app/main/catalogs/sub-modules/shared-folders/list/shared-folders-list.html',
										controller : 'sharedFoldersListController as vm'
								}
						},
						resolve: {},
						data: {
								displayName: 'SHARED_FOLDERS.NAV'
						},
						// accessPrivileges: ['GetSharingFolderList']
						// accessPrivileges: ['nav_shared_folders']
						accessInfo: {
							accessPrivileges: ['nav_shared_folders']
						}
				});

				$stateProvider.state('app.shared_folders.details', {
					url	 : '/:id',
					views: {
						'content@app': {
							templateUrl: 'app/main/catalogs/sub-modules/shared-folders/details/shared-folders-details.html',
							controller : 'sharedFoldersDetailsController as vm'
						}
					},
					data: {
						parentState: 'app.shared_folders',
						displayName: 'SHARED_FOLDERS.TABS.SHARED_FOLDER'
					},
					//only users with following accessPrivileges in their role access list can access this route
					// accessPrivileges: ['GetSharingFolderDetails']
					accessInfo: {
						accessPrivileges: ['GetSharingFolderDetails']
					}
				});

				// Translation
				$translatePartialLoaderProvider.addPart('app/main/catalogs/sub-modules/shared-folders');

				// Navigation
				msNavigationServiceProvider.saveItem('catalogs.shared_folders', {
						title      : 'Shared Folders',
						icon       : 'icon-folder-move',
						weight     : 41,
						// accessPrivileges: ['GetSharingFolderList']
						// accessPrivileges: ['nav_shared_folders'],
						accessInfo: {
							accessPrivileges: ['nav_shared_folders']
						}
				});

				// Navigation
				msNavigationServiceProvider.saveItem('catalogs.shared_folders.shared_folders', {
					title      : 'List View',
					subTitle   : 'Shared Folders',
					icon       : 'icon-folder-move',
					state      : 'app.shared_folders',
					translation: 'SHARED_FOLDERS.NAV',
					weight     : 41,
					// accessPrivileges: ['GetSharingFolderList']
					// accessPrivileges: ['nav_shared_folders'],
					accessInfo: {
						accessPrivileges: ['nav_shared_folders']
					}
				});
		}

})();
(function () {
	'use strict';

	angular
		.module('app.main.catalogs.shared-folders')
		.controller('addOrUpdateSharedFolderController', addOrUpdateSharedFolderController);

	/* @ngInject */
	function addOrUpdateSharedFolderController($mdDialog, $scope, $filter, toast, hotkeys, utility, record, isNew, model, existingRecordsForUniqueValue, lookupPromises, catalogCode, isToggleSharing, fromUsers, api, event) {
		/* jshint validthis: true */
		var vm = this;

		//Data
		vm.isLoading = false;
		vm.isDataDirty = false;
		vm.isNew = isNew;
		vm.record = (angular.isDefined(record) && record != null) ? angular.copy(record) : {};
		vm.searchText = [];
		vm.lookupModel = [];
		vm.acSelectedItem = [];
		vm.acSearchText = [];
		vm.record.Users = [];
		vm.isToggleSharing = isToggleSharing;
		vm.fromUsers = fromUsers;
		if (vm.isNew) {
			vm.record.Entity = 1; // default Merch
			vm.lookupModel.Entity = 1;
			vm.record.ParentFolderId = null;
		}
		var assignedUsersMap = {};
		vm.existingRecordsForUniqueValue = existingRecordsForUniqueValue;


		//Methods
		vm.saveRecord = saveRecord;
		vm.closeDialog = closeDialog;

		vm.lookupSearch = lookupSearch;
		vm.lookupChange = lookupChange;
		vm.getLookupDisplayValue = getLookupDisplayValue;
		vm.selectText = selectText;

		vm.entityLookupSearch = entityLookupSearch;
		vm.entityLookupChange = entityLookupChange;
		vm.getEntityLookupDisplayValue = getEntityLookupDisplayValue;

		activate();

		////////////////

		function activate() {
			if (!isNew) {
				populateEditDialog();
			}
			else if(!vm.isToggleSharing) {
				createEmptyUsersRow();
			}
			//Hotkeys
			hotkeys.bindTo($scope).add({
				combo: 'ctrl+enter',
				description: $filter('translate')('ACTIONS.SAVE'),
				allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
				callback: function (event) {
					if (!vm.isLoading && !vm.editForm.$invalid) {
						vm.saveRecord();
					}
				}
			});
		}

		function saveRecord() {
			vm.isLoading = true;
			var users = [];
			angular.forEach(vm.record.Users, function(user) {
				if(user.UserId != null) {
					users.push(user);
				}
			});
			vm.record.Users = users;

			var p;
			if (vm.isNew)
			{
					p = model.methods.create(vm.record, catalogCode);
			} else if(!vm.isToggleSharing) {
					p = model.methods.update(vm.record.Id, vm.record, catalogCode);
			} else {
					p = model.methods.assignUsers(vm.record, vm.record.Id, catalogCode);
			}

			p.then(function(response) {
					closeDialog(true);
					var toastMessage;
					toastMessage = response.config.method.toUpperCase() === 'POST' ? 'SUCCESS.CREATE': 'SUCCESS.UPDATE';
					toast.success(toastMessage, '', '');
			}, function() {
					closeDialog(vm.isDataDirty);
			}).finally(function () {
					vm.isLoading = false;
			});
		}

		function closeDialog(saved) {
			$mdDialog.hide(saved);
		}

		function lookupSearch(query, field, lookupSource, lookupFilter) {
			var results = [];
			var predicate = angular.isDefined(lookupFilter) ? angular.copy(lookupFilter) : {};
			predicate.value = query;
			var lookupModel = api.getModel(lookupSource);

			if (angular.isDefined(lookupModel.lookupData) && angular.isDefined(lookupModel.lookupData.data) && lookupModel.lookupData.data.length) {
				results = query ? utility.filterObject(lookupModel.lookupData.data, predicate) : utility.filterObject(lookupModel.lookupData.data, lookupFilter, true);
				var availableUsers = [];
				angular.forEach(results, function(user) {
					if(!assignedUsersMap[user.id]) {
						availableUsers.push(user);
					}
				})
				return availableUsers;
			}
			else {
				return lookupPromises[field].then(function (lookupData) {
					results = query ? utility.filterObject(lookupData.data, predicate) : utility.filterObject(lookupData.data, lookupFilter, true);
					var availableUsers = [];
					angular.forEach(results, function(user) {
						if(!assignedUsersMap[user.id]) {
							availableUsers.push(user);
						}
					})
					return availableUsers;
				});
			}
		}

		// convert dropdown scope value form object(lookup record) to id property of lookup record
		function lookupChange(selectedObj, field, rowIndex) {
			if (angular.isObject(selectedObj)) {
				vm.record.Users[rowIndex].UserId = selectedObj.id;
				assignedUsersMap[selectedObj.id] = 1;
			}
			else if (angular.isUndefined(selectedObj) || selectedObj === null) {
				delete assignedUsersMap[vm.record.Users[rowIndex].Id];
				vm.record.Users[rowIndex].UserId = undefined;
			}
			// if adding data to last row and quantity is added create new row
			createEmptyUsersRow();
		}


		function getLookupDisplayValue(item, field, lookupSource) {
			var lookupModel = api.getModel(lookupSource);

			if (angular.isDefined(lookupModel.lookupData) && angular.isDefined(lookupModel.lookupData.data) && lookupModel.lookupData.data.length) {
				return getLookupDisplayVal(item, lookupModel.lookupData);
			}
			else {
				return lookupPromises[field].then(function (lookupData) {
					return getLookupDisplayVal(item, lookupData);
				});
			}
		}

		function getLookupDisplayVal(item, lookupData) {
			var result;
			if (lookupData) {
				// since autocomplte return object
				if (angular.isObject(item)) {
					result = utility.filterObject(lookupData.data, { id: item.id }, true);
				}
				// to initialize field value if any (when open update record dialog)
				else {
					result = utility.filterObject(lookupData.data, { id: item }, true);
				}

				if (angular.isArray(result) && result.length > 0) {
					return result[0].value;
				}
				else {
					return result.value;
				}
			}
		}

		function selectText(event) {
			utility.selectInputText(event);
		}

		function entityLookupSearch(query) {
			var results = [];
			var predicate = {};
			predicate.value = query;
			var lookupModel = api.getModel('lists.entityList');

			if (angular.isDefined(lookupModel.lookupData) && angular.isDefined(lookupModel.lookupData.data) && lookupModel.lookupData.data.length) {
				results = query ? utility.filterObject(lookupModel.lookupData.data, predicate) : lookupModel.lookupData.data;
				return results;
			}
			else {
				return lookupPromises['Entity'].then(function (lookupData) {
					results = query ? utility.filterObject(lookupData.data, predicate) : lookupModel.lookupData.data;
					return results;
				});
			}
		}

		// convert dropdown scope value form object(lookup record) to id property of lookup record
		function entityLookupChange(selectedObj, field) {

			if (angular.isObject(selectedObj)) {
				vm.record[field] = selectedObj.id;
			}
			else if (angular.isUndefined(selectedObj) || selectedObj === null) {
				vm.record[field] = undefined; // on record removal make field undefined or the property can be deleted using delete keywork
			}
		}

		function getEntityLookupDisplayValue(item, field, lookupSource) {
			var lookupModel = api.getModel(lookupSource);

			if (angular.isDefined(lookupModel.lookupData) && angular.isDefined(lookupModel.lookupData.data) && lookupModel.lookupData.data.length) {
				return getEntityLookupDisplayVal(item, lookupModel.lookupData);
			}
			else {
				return lookupPromises[field].then(function (lookupData) {
					return getEntityLookupDisplayVal(item, lookupData);
				});
			}
		}

		//helper method
		function getEntityLookupDisplayVal(item, lookupData) {
			var result;
			if (lookupData) {
				// since autocomplte return object
				if (angular.isObject(item)) {
					result = utility.filterObject(lookupData.data, { id: item.id }, true);
				}
				// to initialize field value if any (when open update record dialog)
				else {
					result = utility.filterObject(lookupData.data, { id: item }, true);
				}

				if (angular.isArray(result) && result.length > 0) {
					return result[0].value;
				}
				else {
					return result.value;
				}
			}
		}

		function populateEditDialog() {
			angular.forEach(record.Users, function(user) {
				var hidden = user.hidden ? user.hidden : false
				var disable = user.disable ? user.disable : false
				var recordsLength = vm.record.Users.push({ UserId: user.UserId, AllowSharing: user.AllowSharing, hidden: hidden, disable: disable});
				if(angular.isUndefined(vm.lookupModel[recordsLength-1])) {
					vm.lookupModel[recordsLength-1] = {};
				}
				vm.lookupModel[recordsLength-1].UserId = user.UserId;
				assignedUsersMap[user.UserId] = 1;
			});
			// if assignedusers then assign the active once to it
			if(record.AssignedRecords && record.AssignedRecords.length) {
				angular.forEach(record.AssignedRecords, function(assignedUser) {
					assignedUsersMap[assignedUser.UserId] = 1;
				})
			}
			if(!vm.isToggleSharing) {
				createEmptyUsersRow();
			}
		}

		function createEmptyUsersRow() {
			vm.searchText.push({});
			vm.lookupModel.push({});
			vm.record.Users.push({ UserId: null, AllowSharing: 0, hidden: false, disable: false});
		}

	}
})();
 (function() {
    'use strict';

    angular
        .module('app.main.catalog-articles.segmentation-linear',[])
        .config(config);

    /* @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
        // State
        $stateProvider.state('app.segmentation_linear', {
            url    : '/segmentation-linear',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/catalogs/sub-modules/segmentation-linear/list/segmentation-linear-list.html',
                    controller : 'segmentationLinearListController as vm'
                }
            },
            resolve: {},
            data: {
                displayName: 'SEGMENTATION_LINEAR.NAV'
            },
            //only users with following accessPrivileges in their role access list can access this route
            // accessPrivileges: ['GetCatalogListArticleSegmentations']
            // accessPrivileges: ['nav_article_segmentation']
            accessInfo: {
                accessPrivileges: ['nav_article_segmentation']
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/catalogs/sub-modules/segmentation-linear');

        msNavigationServiceProvider.saveItem('catalogs.segmentation.segmentation_linear', {
            title      : 'Linear View',
            subTitle   : 'Article Segmentation',
            icon       : 'icon-cube-unfolded',
            state      : 'app.segmentation_linear',
            translate  : 'NAV.LINEAR_VIEW',
            weight     : 41,
            // accessPrivileges: ['GetCatalogListArticleSegmentations']
            // accessPrivileges: ['nav_article_segmentation']
            accessInfo: {
                accessPrivileges: ['nav_article_segmentation']
            }
        });
    }
})();
(function () {
	'use strict';

	angular
		.module('app.main.catalog-articles.segmentation-linear')
		.controller('assignArticleSegmentationController', assignArticleSegmentationController);

	/* @ngInject */
	function assignArticleSegmentationController($mdDialog, api, utility, $scope, $filter, hotkeys, lookupPromises, model, catalogId) {
		/* jshint validthis: true */
		var vm = this;

		//Data
		vm.model = model;
		vm.record = {};
		vm.record.ArticleId = [];
		vm.record.SegmentationId = [];
		vm.activeCatalogCode = catalogId;
		var isRoleBasedRestrictedSegmentationsAdded = (angular.isDefined(api.roleBasedRestrictions) && angular.isDefined(api.roleBasedRestrictions.restrictedSegmentationsArray) && api.roleBasedRestrictions.restrictedSegmentationsArray.length > 0) ? true : false;

		vm.isLoading = false;
		vm.isDataDirty = false;
		vm.acLookupModel = {};
		vm.acSelectedItem = [];
		vm.acSearchText = [];

		//Methods
		vm.saveRecord = saveRecord;
		vm.closeDialog = closeDialog;

		vm.acQuerySearch = acQuerySearch;
		vm.transformChip = transformChip;
		vm.getChipDisplayValue = getChipDisplayValue;
		vm.onOpenValueChange = onOpenValueChange


		activate();

		////////////////

		function activate() {
			//Hotkeys
			hotkeys.bindTo($scope).add({
				combo: 'ctrl+enter',
				description: $filter('translate')('ACTIONS.SAVE'),
				allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
				callback: function (event) {
					if (!vm.isLoading && !vm.editForm.$invalid) {
						vm.saveRecord();
					}
				}
			});
			hotkeys.bindTo($scope).add({
				combo: 'ctrl+shift+enter',
				description: $filter('translate')('ACTIONS.SAVE_AND_NEW'),
				allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
				callback: function (event) {
					if (!vm.isLoading && !vm.editForm.$invalid) {
						vm.saveRecord(true);
					}
				}
			});
		}

		function saveRecord() {
			vm.isLoading = true;
			vm.model.methods.updateBulk(vm.record);
			closeDialog(true);
		}

		function closeDialog(saved) {
			$mdDialog.hide(saved);
		}
		function transformChip(chip) {
			if (angular.isObject(chip)) {
				return chip.value;
			}
			return undefined;
		}

		function acQuerySearch(query, selectedRecords, fieldName) {
			var results = [];
			var field = utility.filterObject(model.fields, { field: fieldName, creatable: true }, true)[0];
			var lookupFilter = angular.isDefined(field.lookupFilter) ? field.lookupFilter : {};
			var predicate = angular.copy(lookupFilter);
			predicate.value = query;

			var lookupModel = api.getModel(field.lookupSource);
			if (angular.isDefined(lookupModel.lookupData) && angular.isDefined(lookupModel.lookupData.data) && lookupModel.lookupData.data.length) {
				results = query ? utility.filterObject(lookupModel.lookupData.data, predicate) : utility.filterObject(lookupModel.lookupData.data, lookupFilter);
				results = removeSelectedChips(selectedRecords, results);
				if(isRoleBasedRestrictedSegmentationsAdded) {
					results = removeRestrictedSegmentations(results);
				}
				return results;
			}
			else {
				return lookupPromises[field.field].then(function (lookupData) {
					results = query ? utility.filterObject(lookupData.data, predicate) : utility.filterObject(lookupData.data, lookupFilter);
					results = removeSelectedChips(selectedRecords, results);
					if(isRoleBasedRestrictedSegmentationsAdded) {
						results = removeRestrictedSegmentations(results);
					}
					return results;
				});
			}
		}

		/**
		 * @description
		 * This method will remove selected chips form records (helper method)
		 * @param {array} selectedRecords: list of selected chips
		 * @param {array} records: data property of lookup-data
		 * @returns {array}: list of available chips (chips which are not selected) // it does not really need to return a value but for readability returning modified value
		 */
		function removeSelectedChips(selectedRecords, records) {
			if (angular.isDefined(selectedRecords) && selectedRecords.length > 0) {
				for (var index = records.length - 1; index >= 0; index--) {
					if (selectedRecords.indexOf(records[index].value) !== -1) {
						records.splice(index, 1);
					}
				}
			}
			return records;
		}

		function removeRestrictedSegmentations(records) {
			var restrictedSegmentations = api.roleBasedRestrictions.restrictedSegmentationsArray;
			var nonRestrictedSegmentations = [];
			angular.forEach(records, function(segmentation) {
				var segmentationObj = utility.filterObject(restrictedSegmentations, { Id: segmentation.id, notEditable : 1}, true)[0];
				if (angular.isDefined(segmentationObj) && !segmentationObj.notEditable) {
					nonRestrictedSegmentations.push(segmentation);
				} else if(angular.isUndefined(segmentationObj)) {
					nonRestrictedSegmentations.push(segmentation);
				}
			});
			return nonRestrictedSegmentations;
		}

		function getChipDisplayValue(chip, fieldName) {
			var field = utility.filterObject(model.fields, { field: fieldName, creatable: true }, true)[0];
			var lookupModel = api.getModel(field.lookupSource);
			if (angular.isDefined(lookupModel.lookupData) && angular.isDefined(lookupModel.lookupData.data) && lookupModel.lookupData.data.length) {
				return getChipDisplayVal(lookupModel.lookupData, chip);
			}
			else { // it will never go to else part since before try to load display value for selected chips, it always load lookup on focus of chips input element
				return lookupPromises[field.field].then(function (lookupData) {
					return getChipDisplayVal(lookupData, chip);
				});
			}
		}

		//helper method
		function getChipDisplayVal(lookupData, chip) {
			var res = utility.filterObject(lookupData.data, { value: chip }, true);
			if (angular.isArray(res) && res.length > 0) {
				return res[0].value;
			}
		}

		function onOpenValueChange(isOpen, fieldName) {
			vm.record.SegmentationId = [];
			if(isOpen) {
				var results = [];
				var field = utility.filterObject(model.fields, { field: fieldName, creatable: true }, true)[0];
				var lookupModel = api.getModel(field.lookupSource);
				if (angular.isDefined(lookupModel.lookupData) && angular.isDefined(lookupModel.lookupData.data) && lookupModel.lookupData.data.length) {
					results = lookupModel.lookupData.data;
					if(isRoleBasedRestrictedSegmentationsAdded) {
						results = removeRestrictedSegmentations(results);
					}
				}
				else {
					lookupPromises[field.field].then(function (lookupData) {
						results = lookupData.data;
						if(isRoleBasedRestrictedSegmentationsAdded) {
							results = removeRestrictedSegmentations(results);
						}
					});
				}
				angular.forEach(results, function(record) {
					vm.record.SegmentationId.push(record.value);
				});
			}
		}
	}
})();
 (function() {
    'use strict';

    angular
        .module('app.main.catalog-articles.segmentation',[])
        .config(config);

    /* @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
        // State
        $stateProvider.state('app.segmentation', {
            url    : '/segmentation',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/catalogs/sub-modules/segmentation/list/segmentation-list.html',
                    controller : 'segmentationListController as vm'
                }
            },
            resolve: {
                catalogSpecificSegmentationModel : function(api, catalogFactory) {
                    //Mapping response source property to fields target property
                    var propertiesMapper = [{target: 'field', source: 'field["Id"]+field["Name"]'}, {target: 'importField', source: 'field["Name"]'}, {target: 'displayLabel', source: 'field["Name"]'}],
                        inputType = 'switch',
                        nestedArrayName = 'Segmentations',
                        //dummmy value since the value for each column in segmentations depend on existance of the object in get all the articles segmentation
                        valueMapper = 'Id',
                        targetModel = 'catalogArticles.segmentation',
                        sourceModel = 'catalogs.segmentations';

                    return catalogFactory.createDynamicModel(targetModel, sourceModel, propertiesMapper, inputType, nestedArrayName, valueMapper);
                }
            },
            data: {
                displayName: 'SEGMENTATION.NAV'
            },
            //only users with following accessPrivileges in their role access list can access this route
            // accessPrivileges: ['GetCatalogListArticleSegmentations']
            // accessPrivileges: ['nav_article_segmentation']
            accessInfo: {
                accessPrivileges: ['nav_article_segmentation']
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/catalogs/sub-modules/segmentation');

        // Navigation
        msNavigationServiceProvider.saveItem('catalogs.segmentation', {
            title : 'Article Segmentation',
            translate: 'SEGMENTATION.NAV',
            icon  : 'icon-cube-unfolded',
            weight: 40,
            // accessPrivileges: ['GetCatalogListArticleSegmentations']
            // accessPrivileges: ['nav_article_segmentation']
            accessInfo: {
                accessPrivileges: ['nav_article_segmentation']
            }
        });

        msNavigationServiceProvider.saveItem('catalogs.segmentation.segmentation', {
            title      : 'Tabular View',
            subTitle   : 'Article Segmentation',
            icon       : 'icon-cube-unfolded',
            state      : 'app.segmentation',
            translate  : 'NAV.TABULAR_VIEW',
            weight     : 40,
            // accessPrivileges: ['GetCatalogListArticleSegmentations']
            // accessPrivileges: ['nav_article_segmentation']
            accessInfo: {
                accessPrivileges: ['nav_article_segmentation']
            }
        });
    }
})();
(function() {
    'use strict';

    angular
        .module('app.main.catalog-articles.segmentation')
        .controller('updateSegmentationsController', updateSegmentationsController);

    /**ngInject */
    function updateSegmentationsController($mdDialog, utility, catalogFactory, toast, model, record, activeCatalogCode, api, $translate) {
        var vm = this;
        //data
        vm.isSegmentationGroup = false;
        vm.SegmentationGroupList  = utility.filterObject(catalogFactory.getActiveCatalogDetails().SegmentationGroupList, { Status: 1 });
        vm.SegmentationGroup = {};
        vm.planningValue = api.getSegmentationPlanningValues();
        vm.records = createRecord(model, record);
        vm.filteredEditableFields = vm.records;
        // number of segmentations the save would actually write; the Save button stays disabled while it is 0
        vm.changedCount = 0;
        //methods
        vm.saveRecord = saveRecord;
        vm.closeDialog = closeDialog;
        vm.onSegmentationGroupChange = onSegmentationGroupChange;
        vm.onSegmentationValueChange = onSegmentationValueChange;
        vm.onPlanningValueChange = onPlanningValueChange;
        vm.onOpenValueChange = onOpenValueChange;
        vm.onSearchTextChanged= onSearchTextChanged;

        function saveRecord() {
            var requestObj = getRequestObj(vm.records);
            // the Save button is disabled in this state; guard anyway since the endpoint rejects an empty list
            if (!requestObj.length) {
                closeDialog(false);
                return;
            }
            vm.isLoading = true;
            model.methods.update(requestObj, record['Id'], activeCatalogCode).then(function() {
                closeDialog(true);
                toast.success('SUCCESS.UPDATE', '', '');
            }, function() {
                closeDialog();
            }).finally(function () {
                vm.isLoading = false;
            });
        }

        function closeDialog(saved) {
            $mdDialog.hide(saved);
        }

        function createRecord(model, record) {
            var defaultPlanning = api.getSegmentationPlanningDefault();
            var result = [];
            if (catalogFactory.getActiveCatalog().SegmentationPlanningEnable === 1) {
                vm.isSegmentationPlanningEnable = true;
            }
            var articleSegmentationsList = [];//list of active article segmentations
            angular.forEach(model.fields, function (field) {
                var resultField = {};
                if (field.editable) {
                    resultField['displayLabel'] = field['displayLabel'];
                    resultField['SegmentationId'] = field['catalogEntityId'];
                    resultField['value'] = true;
                    // record[field.field] holds the grid display value: a configured planning value,
                    // legacy 'Yes' (assigned without a planning value), or 'No' (unassigned).
                    var fieldValue = record[field.field];
                    var planningValue = api.matchSegmentationPlanningValue(fieldValue);
                    if (planningValue) {
                        articleSegmentationsList.push(fieldValue);
                        resultField['PlanningValue'] = planningValue;
                    } else if (angular.isDefined(fieldValue) && fieldValue !== null && fieldValue.toString().toUpperCase() === 'YES') {
                        articleSegmentationsList.push(fieldValue);
                        resultField['PlanningValue'] = defaultPlanning; //assigned without planning -> default
                    } else {
                        resultField['value'] = false;
                        resultField['PlanningValue'] = defaultPlanning; //add default value
                    }
                    // State the delta is diffed against. A planning value that is no longer configured seeds
                    // as the default above; that substitution is display-only and must not count as a change,
                    // so an assigned segmentation is only rewritten once _planningTouched is set by the user.
                    resultField['_originalValue'] = resultField['value'];
                    resultField['_originalPlanningValue'] = resultField['value'] ? resultField['PlanningValue'] : null;
                    resultField['_planningTouched'] = false;
                    result.push(angular.copy(resultField));
                }
            });
            //code below checks for the article segmentations belong to which Segmentation Group
            var SegmentationsList = [];
            if(vm.SegmentationGroupList && vm.SegmentationGroupList.length > 0){
                vm.isSegmentationGroup = true;
                var list = angular.copy(vm.SegmentationGroupList);
                angular.forEach(list, function(segmentationGroupObject){
                    SegmentationsList = segmentationGroupObject.Segmentations.split(',');
                    var SegmentationsListLength = SegmentationsList.length;
                    var count = 0;
                    for(var index = 0; index < SegmentationsListLength; index++){
                        if(  articleSegmentationsList.length === SegmentationsListLength && articleSegmentationsList.indexOf(SegmentationsList[index])!= -1){
                            count= count +1;
                        }
                    }
                    if(count === SegmentationsListLength){
                        vm.SegmentationGroup = segmentationGroupObject;
                    }
                })
            }
            // for virtual segmentation open
            var editableFieldsCount = utility.filterObject(model.fields, {editable: true}, true).length;
            if(articleSegmentationsList.length === editableFieldsCount) {
                vm.open = 1;
            }
            return result;
        }


        function onSegmentationGroupChange() {
            var selectedSegmentationGroup = utility.filterObject(vm.SegmentationGroupList, { SegmentationGroup: vm.SegmentationGroup.SegmentationGroup }, true);
            var segmentations = selectedSegmentationGroup[0].Segmentations.split(',');
            var planningValue = api.getSegmentationPlanningDefault();
            // Toggle the existing records in place: rebuilding them would drop the original assignment state
            // the partial payload is diffed against, and would also detach vm.filteredEditableFields.
            // Segmentations which do not belong to the group are set to false.
            angular.forEach(vm.records, function (record) {
                if (segmentations.indexOf(record.displayLabel) != -1) {
                    record.value = true;
                    if (vm.isSegmentationPlanningEnable && record.PlanningValue !== planningValue) {
                        record.PlanningValue = planningValue;//configured default value
                        record._planningTouched = true;
                    }
                } else {
                    record.value = false;
                }
            });
            refreshChangedCount();
        }

        function onSegmentationValueChange(record) {
            var planningValue = api.getSegmentationPlanningDefault();
            if (vm.isSegmentationGroup && record.value && vm.SegmentationGroup) {
                var selectedSegmentationGroup = utility.filterObject(vm.SegmentationGroupList, { SegmentationGroup: vm.SegmentationGroup.SegmentationGroup }, true);
                var segmentations = selectedSegmentationGroup[0].Segmentations.split(',');
                if (segmentations.indexOf(record.displayLabel) == -1) {
                    vm.SegmentationGroup = {};
                }
                if(vm.isSegmentationPlanningEnable && record['PlanningValue'] !== planningValue){
                    record['PlanningValue'] = planningValue;
                    record['_planningTouched'] = true;
                }
            }
            refreshChangedCount();
        }

        function onPlanningValueChange(record) {
            // Only a user-driven edit marks the planning value dirty; a seeded value never does.
            record['_planningTouched'] = true;
            refreshChangedCount();
        }

        /**
         * Builds the partial payload: only the segmentations the user added, changed or removed. Untouched
         * segmentations are omitted and the backend leaves them as they are, so editing one segmentation no
         * longer rewrites the article's whole set.
         */
        function getRequestObj(records) {
            var result = [];
            for(var i=0; i<records.length; i++) {
                var change = getRecordChange(records[i]);
                if(change) {
                    result.push(change);
                }
            }
            return result;
        }

        /**
         * @return {object|null} the payload entry for one segmentation, or null when it is unchanged.
         */
        function getRecordChange(record) {
            if(record['value'] === true) {
                // null leaves the stored planning value unchanged, which is what a planning-disabled catalog
                // wants: the dialog never showed the user a value to save
                var planningValue = vm.isSegmentationPlanningEnable ? (record['PlanningValue'] || api.getSegmentationPlanningDefault()) : null;
                if(!record['_originalValue']) {
                    return {SegmentationId: record['SegmentationId'], Status: 1, PlanningValue: planningValue};
                }
                // already assigned: only a planning value the user actually edited is worth sending
                if(record['_planningTouched'] && planningValue !== null && planningValue !== record['_originalPlanningValue']) {
                    return {SegmentationId: record['SegmentationId'], Status: 1, PlanningValue: planningValue};
                }
                return null;
            }
            // unassign only what the article actually has; Status 0 ignores the planning value
            return record['_originalValue'] ? {SegmentationId: record['SegmentationId'], Status: 0, PlanningValue: null} : null;
        }

        function refreshChangedCount() {
            var count = 0;
            angular.forEach(vm.records, function (record) {
                if(getRecordChange(record)) {
                    count++;
                }
            });
            vm.changedCount = count;
        }

        function onOpenValueChange(isOpen) {
            if(isOpen) {
                angular.forEach(vm.records, function (record) {
                    record.value = true;
                });
                angular.forEach(vm.filteredEditableFields, function (record) {
                    record.value = true;
                });
            } else {
                angular.forEach(vm.records, function (record) {
                    record.value = false;
                });
                angular.forEach(vm.filteredEditableFields, function (record) {
                    record.value = false;
                });
            }
            refreshChangedCount();
        }

        function onSearchTextChanged() {
            if (!vm.searchPageText) {
                vm.filteredEditableFields = vm.records;
                return;
            }

            vm.filteredEditableFields = vm.records.filter(function(item) {
                if (!item || !item.displayLabel) return false;

                var translatedLabel = $translate.instant(item.displayLabel);
                return translatedLabel.toLowerCase().indexOf(vm.searchPageText.toLowerCase()) !== -1;
            });
        }
    }
})();
(function () {
	'use strict';

	angular
		.module('app.main.catalogs.article-status', [])
		.config(config);

	/* @ngInject */
	function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
		// State
		$stateProvider.state('app.article_status', {
			url: '/article-status',
			views: {
				'content@app': {
					templateUrl: 'app/main/catalogs/sub-modules/reports/article-status/list/article-status-list.html',
					controller: 'articleStatusListController as vm'
				}
			},
			resolve: {
				articleStatusModel: function (catalogFactory) {
					return catalogFactory.createArticleStatusReportModel();
				}
			},
			data: {
				displayName: 'ARTICLE_STATUS.NAV'
			},
			//only users with following accessPrivileges in their role access list can access this route
			// accessPrivileges: ['ArticlesStatusReport']
			// accessPrivileges: ['nav_articles_status']
			accessInfo: {
				accessPrivileges: ['nav_articles_status']
			}
		});

		// Translation
		$translatePartialLoaderProvider.addPart('app/main/catalogs/sub-modules/reports/article-status');

		msNavigationServiceProvider.saveItem('catalogs.reports.article_status', {
			title: 'Article Status',
			subTitle: 'Reports',
			icon: 'icon-tile-four',
			state: 'app.article_status',
			translate: 'ARTICLE_STATUS.NAV',
			weight: 70,
			// accessPrivileges: ['ArticlesStatusReport']
			// accessPrivileges: ['nav_articles_status']
			accessInfo: {
				accessPrivileges: ['nav_articles_status']
			}
		});
	}
})();
(function () {
	'use strict';

	angular
		.module('app.main.catalogs.article-status')
		.controller('articleStatusListController', articleStatusListController);

	/* @ngInject */
	function articleStatusListController($state, articleStatusModel, catalogFactory, settingsFactory, $rootScope, $scope, $timeout) {
		/* jshint validthis: true */
		var vm = this;

		//Data
		var activeCatalog = catalogFactory.getActiveCatalog();
		var activeCatalogId = activeCatalog.CatalogCode;
		vm.activeCatalogId = activeCatalogId;

		vm.model = articleStatusModel;
		settingsFactory.applyPersistedListViewLayout(vm.model);

		vm.articleStatus = [];
		vm.filteredArticleStatus = [];
		vm.isLoading = false;
		var timeoutPromise;

		//Methods
		vm.refreshItems = refreshItems;
		vm.viewItem = viewItem;

		activate();

		////////////////

		function activate() {
			refreshItems(vm.model.isDirty, true);
		}

		function refreshItems(forceFetch, isLogRequired) {
			vm.isLoading = true;
			var generalProperties = {
				forceFetch: forceFetch,
				isLogRequired: isLogRequired
			}
			timeoutPromise = $timeout(function() {
				vm.model.methods.getList(generalProperties, activeCatalogId)
				.then(function (response) {
					vm.articleStatus = catalogFactory.transformArticleStatusReportResponse(response.data, 'Catalogs', vm.model.fields);
				})
				.finally(function () {
					vm.isLoading = false;
				});
			},500);
		}

		function viewItem(record) {
			var id = record.ArticleId;
			var stateParams = { id: id};
			$state.go('app.articles.details', stateParams);
		}

		var catalogChangedEventCleanup = $rootScope.$on('ActiveCatalogChangedEvent', function(e) {
			if(activeCatalogId !== catalogFactory.getActiveCatalog().CatalogCode) {
					$state.reload('app.article_status');
			}
		});

		$scope.$on('$destroy', function () {
				catalogChangedEventCleanup();
				$timeout.cancel(timeoutPromise);
		});

	}
})();
(function () {
	'use strict';

	angular
		.module('app.main.catalogs.article-prices', [])
		.config(config);

	/* @ngInject */
	function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
		// State
		$stateProvider.state('app.article_prices', {
			url: '/article-prices',
			views: {
				'content@app': {
					templateUrl: 'app/main/catalogs/sub-modules/reports/article-prices/list/article-prices-list.html',
					controller: 'articlePricesListController as vm'
				}
			},
			resolve: {
				articlePricesReportModel: function (catalogFactory) {
					var activeCatalog = catalogFactory.getActiveCatalog();
					return catalogFactory.createArticlePricesReportModel(activeCatalog);
				}
			},
			data: {
				displayName: 'ARTICLE_PRICES.NAV'
			},
			//only users with following accessPrivileges in their role access list can access this route
			// accessPrivileges: ['ArticlesPriceReport']
			// accessPrivileges: ['nav_articles_prices_report']
			accessInfo: {
				accessPrivileges: ['nav_articles_prices_report']
			}
		});

		// Translation
		$translatePartialLoaderProvider.addPart('app/main/catalogs/sub-modules/reports/article-prices');

		msNavigationServiceProvider.saveItem('catalogs.reports.article_prices', {
			title: 'Article Prices',
			subTitle: 'Reports', 
			icon: 'icon-tile-four',
			state: 'app.article_prices',
			translate: 'ARTICLE_PRICES.NAV',
			weight: 70,
			// accessPrivileges: ['ArticlesPriceReport']
			// accessPrivileges: ['nav_articles_prices_report']
			accessInfo: {
				accessPrivileges: ['nav_articles_prices_report']
			}
		});
	}
})();
(function () {
	'use strict';

	angular
		.module('app.main.catalogs.article-prices')
		.controller('articlePricesListController', articlePricesListController);

	/* @ngInject */
	function articlePricesListController($state, articlePricesReportModel, catalogFactory, settingsFactory, $rootScope, $scope, $timeout) {
		/* jshint validthis: true */
		var vm = this;

		//Data
		var activeCatalog = catalogFactory.getActiveCatalog();
		var activeCatalogId = activeCatalog.CatalogCode;
		vm.activeCatalogId = activeCatalogId;

		vm.model = articlePricesReportModel;
		settingsFactory.applyPersistedListViewLayout(vm.model);

		vm.articlePrices = [];
		vm.filteredArticlePrices = [];
		vm.isLoading = false;
		var timeoutPromise;

		//Methods
		vm.refreshItems = refreshItems;
		vm.viewItem = viewItem;

		activate();

		////////////////

		function activate() {
			refreshItems(vm.model.isDirty, true);
		}

		function refreshItems(forceFetch, isLogRequired) {
			vm.isLoading = true;
			var generalProperties = {
				forceFetch: forceFetch,
				isLogRequired: isLogRequired
			}
			timeoutPromise = $timeout(function() {
				vm.model.methods.getList(generalProperties, activeCatalogId)
				.then(function (response) {
					vm.articlePrices = response.data;
				})
				.finally(function () {
					vm.isLoading = false;
				});
			},500);
		}

		function viewItem(record) {
			var id = record.ArticleId;
			var stateParams = { id: id};
			$state.go('app.articles.details', stateParams);
		}

		var catalogChangedEventCleanup = $rootScope.$on('ActiveCatalogChangedEvent', function(e) {
			if(activeCatalogId !== catalogFactory.getActiveCatalog().CatalogCode) {
					$state.reload('app.article_prices');
			}
		});

		$scope.$on('$destroy', function () {
				catalogChangedEventCleanup();
				$timeout.cancel(timeoutPromise);
		});

	}
})();
 (function() {
    'use strict';

    angular
        .module('app.main.catalogs.prices-linear',[])
        .config(config);

    /* @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
        // State
        $stateProvider.state('app.prices_linear', {
            url    : '/prices-linear',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/catalogs/sub-modules/prices-linear/list/prices-linear-list.html',
                    controller : 'pricesLinearListController as vm'
                }
            },
            resolve: {
                catalogSpecificPricesModel : function(api, catalogFactory, utility, $q, SecurityFactory, CONSTANTS) {
                    var deferred = $q.defer();
                    var pricesModel = api.catalogs.pricesLinear;
                    var activeCatalog = catalogFactory.getActiveCatalog();
                    if(activeCatalog.IsPriceByStyleApply === 1) {
                        // if privilege is not assigned remove update and import actions
                        if(!SecurityFactory.isAuthorized({accessPrivileges: CONSTANTS.PRIVILEGES.PRICES.UPDATE_CATALOG_MODEL_PRICES})) {
                            var action = utility.filterObject(pricesModel.views.mainList.listActions, {id: 'import'}, true)[0];
                            if(action) {
                                action.visible = false;
                            }
                            var editAction = utility.filterObject(pricesModel.views.mainList.itemActions, {id: 'edit'}, true)[0];
                            if(editAction) {
                                editAction.visible = false;
                            }
                        }
                        deferred.resolve(pricesModel);
                    }
                    else {
                        deferred.resolve(pricesModel);
                    }
                    return deferred.promise;
                }
            },
            data: {
                displayName: 'PRICES_LINEAR.NAV'
            },
            //only users with following accessPrivileges in their role access list can access this route
            // accessPrivileges: ['GetCatalogAllArticlePrices']
            // accessPrivileges: ['nav_prices']
            accessInfo: {
                accessPrivileges: ['nav_prices']
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/catalogs/sub-modules/prices-linear');

        msNavigationServiceProvider.saveItem('catalogs.prices.prices_linear', {
            title      : 'Linear View',
            subTitle   : 'Prices',
            icon       : 'icon-coin',
            state      : 'app.prices_linear',
            translate  : 'NAV.LINEAR_VIEW',
            weight     : 70,
            // accessPrivileges: ['GetCatalogAllArticlePrices']
            // accessPrivileges: ['nav_prices']
            accessInfo: {
                accessPrivileges: ['nav_prices']
            }
        });
    }
})();
(function () {
	'use strict';

	angular
		.module('app.main.catalogs.prices-linear')
		.controller('updatePricesLinearController', updatePricesLinearController);

	/**ngInject */
	function updatePricesLinearController($mdDialog, $document, $filter, toast, dialog, utility, model, record, activeCatalog,
		catalogFactory, api, SecurityFactory, CONSTANTS) {
		var vm = this;

		//data
		vm.record = {};
		vm.record = record;
		vm.activeCatalog = activeCatalog;
		vm.AllowExternalChangeManagement = false;
		vm.checkingForLockedArticles = false;
		vm.lookupModel = angular.copy(vm.record);
		vm.searchText = '';
		vm.numberOfDecimalsForPrices = api.numberOfDecimalsForPrices;
		vm.priceGroupNonEditable = false;
		vm.isAllowChangeRequestEnabled = false;
		// check the special privilege is assigned to the user for updating the state. if then does not restrict sizescale and model name update
		var isSpecialPermissionToIgnoreArticleStateIsAssigned = SecurityFactory.isAuthorized({accessPrivileges: CONSTANTS.PRIVILEGES.ARTICLES.SPECIAL_PRIVILEGE_TO_SKIP_STATE_VALIDATION});
		vm.updatePricesChangeManagementExternalURL = '';
		var catalogPriceGroupList = catalogFactory.getActiveCatalogDetails().CatalogPriceGroupList;


		//methods
		vm.saveRecord = saveRecord;
		vm.closeDialog = closeDialog;
		vm.lookupSearch = lookupSearch;
		vm.getLookupDisplayValue = getLookupDisplayValue;


		activate();

		////////////////

		function activate() {
			// check if the article state rank is greater that or equal to price group state rank if yes then make the price non editable
			if(!isSpecialPermissionToIgnoreArticleStateIsAssigned && selectedObj.StateId != null) {
				api.webGet('/app/app.config.json').then(function(response) {
					if (angular.isDefined(response) && angular.isDefined(response.data)) {
							if(angular.isDefined(response.data['updatePricesChangeManagementExternalURL']) && response.data['updatePricesChangeManagementExternalURL'].length) {
									vm.updatePricesChangeManagementExternalURL = response.data['updatePricesChangeManagementExternalURL'];
							}
					}
					makePriceGroupNoneditable();
				});
			}
		}

		function saveRecord() {
			vm.isLoading = true;
			var filteredRecord = angular.copy(vm.record);
			// For non-mandatory price groups, send 0 instead of null
			if (!filteredRecord.isMandatory && (filteredRecord.Price == null || filteredRecord.Price == '')) {
				filteredRecord.Price = 0;
			}
			filteredRecord.Prices = utility.filterObject(vm.record.Prices, { readOnly: false });
			var article;
			if (activeCatalog.IsPriceByStyleApply === 0) {
				article = record['ArticleId'];
			}
			else {
				article = record['ModelNumber'];
			}
			model.methods.update(filteredRecord, article, activeCatalog).then(function (response) {
				if (response.status === 202) {
					// opening another dialog will automatically close previous one
					dialog.showAlertDialog(
						angular.element($document.body),
						$filter('translate')('MESSAGES.TITLE.ALERT'),
						$filter('translate')('MESSAGES.CONTENT.CHANGE_REQUEST_ALERT'),
						$filter('translate')('MESSAGES.TITLE.ALERT'),
						$filter('translate')('ACTIONS.DIALOG_CLOSE'),
						null);
				}
				else {
					closeDialog(true);
					toast.success('SUCCESS.UPDATE', '', '');
				}
			}, function () {
				closeDialog();
			}).finally(function () {
				vm.isLoading = false;
			});
		}

		function closeDialog(saved) {
			$mdDialog.hide(saved);
		}

		function lookupSearch(query, field, lookupSource, lookupFilter) {
			var results = [];
			var predicate = angular.isDefined(lookupFilter) ? angular.copy(lookupFilter) : {};
			predicate.value = query;
			var lookupModel = api.getModel(lookupSource);

			if (angular.isDefined(lookupModel.lookupData) && angular.isDefined(lookupModel.lookupData.data) && lookupModel.lookupData.data.length) {
				results = query ? utility.filterObject(lookupModel.lookupData.data, predicate) : utility.filterObject(lookupModel.lookupData.data, lookupFilter, true);
				return results;
			}
			else {
				return lookupPromises[field].then(function (lookupData) {
					results = query ? utility.filterObject(lookupData.data, predicate) : utility.filterObject(lookupData.data, lookupFilter, true);
					return results;
				});
			}
		}

		function getLookupDisplayValue(item, field, lookupSource) {
			var lookupModel = api.getModel(lookupSource);

			if (angular.isDefined(lookupModel.lookupData) && angular.isDefined(lookupModel.lookupData.data) && lookupModel.lookupData.data.length) {
				return getLookupDisplayVal(item, lookupModel.lookupData);
			}
			else {
				return lookupPromises[field].then(function (lookupData) {
					return getLookupDisplayVal(item, lookupData);
				});
			}
		}

		//helper method
		function getLookupDisplayVal(item, lookupData) {
			var result;
			if (lookupData) {
				// since autocomplte return object
				if (angular.isObject(item)) {
					result = utility.filterObject(lookupData.data, { id: item.id }, true);
				}
				// to initialize field value if any (when open update record dialog)
				else {
					result = utility.filterObject(lookupData.data, { id: item }, true);
				}

				if (angular.isArray(result) && result.length > 0) {
					return result[0].value;
				}
				else {
					return result.value;
				}
			}
		}
	}

	function makePriceGroupNoneditable() {
		// IsPriceByStyleApply is enabled check the article state with height model state rank
		// IsPriceByStyleApply is disabled check the article state with height article state rank
		// check if the article state rank is greater that or equal to price group state rank if yes then make the price non editable
		var assignedPriceGroup = utility.filterObject(catalogPriceGroupList, {Id: record.PriceGroupId}, true)[0];
		if(assignedPriceGroup) {
			if(activeCatalog.IsPriceByStyleApply) {
					if(vm.record.StateRank >= assignedPriceGroup.StateRank) {
							vm.priceGroupNonEditable = true;
							if(selectedObj.AllowChangeRequestForPriceGroups && vm.updatePricesChangeManagementExternalURL !== '') {
									vm.isAllowChangeRequestEnabled = true;
							}
					}
			} else {
					if(vm.record.ModelStateRank >= assignedPriceGroup.StateRank) {
						vm.priceGroupNonEditable = true;
						if(selectedObj.AllowChangeRequestForPriceGroups && vm.updatePricesChangeManagementExternalURL !== '') {
								vm.isAllowChangeRequestEnabled = true;
						}
					}
			}
		}
	}
})();
 (function() {
    'use strict';

    angular
        .module('app.main.catalogs.prices',[])
        .config(config);

    /* @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
        // State
        $stateProvider.state('app.prices', {
            url    : '/prices',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/catalogs/sub-modules/prices/list/prices-list.html',
                    controller : 'pricesListController as vm'
                }
            },
            resolve: {
                catalogSpecificPricesModel : function(api, catalogFactory, utility, $q, $log, SecurityFactory, CONSTANTS) {
                    var deferred = $q.defer();
                    var activeCatalog = catalogFactory.getActiveCatalog();
                    var propertiesMapper = [{target: 'field', source: ' field["Id"]+field["Name"]'}, {target: 'importField', source: 'field["Name"]'}, {target: 'displayLabel', source: 'field["Name"] + " ("+ field["CurrencyCode"] +")"'}, {target: 'priceGroupId', source: 'field["Id"]'}],
                        inputType = 'decimal',
                        nestedArrayName = 'Prices',
                        valueMapper = 'Price',
                        targetModel = 'catalogs.prices',
                        sourceModel = 'catalogs.priceGroup';
                    catalogFactory.createDynamicModel(targetModel, sourceModel, propertiesMapper, inputType, nestedArrayName, valueMapper)
                        .then(function(pricesModel) {
                            if(activeCatalog.IsPriceByStyleApply === 1) {
                                // hide update bulk, add ModelNumber Column make it creatable and update unique constraint, make ArticleNumber non creatable
                                var action = utility.filterObject(pricesModel.views.mainList.listActions, {id: 'updateBulk'}, true)[0];
                                if(action) {
                                    action.visible = false;
                                }
                                var field = utility.filterObject(pricesModel.fields, {field: 'ModelNumber'}, true)[0];
                                if(field) {
                                    field.visible = true;
                                    field.creatable = true;
                                }
                                field = utility.filterObject(pricesModel.fields, {field: 'ArticleNumber'}, true)[0];
                                if(field) {
                                    field.creatable = false;
                                }
                                pricesModel.uniqueConstraints = [
                                    {name: 'Constraint 1', fields: ['ModelNumber']}
                                ]
                                // if privilege is not assigned remove update and import actions
                                if(!SecurityFactory.isAuthorized({accessPrivileges: CONSTANTS.PRIVILEGES.PRICES.UPDATE_CATALOG_MODEL_PRICES})) {
                                    var action = utility.filterObject(pricesModel.views.mainList.listActions, {id: 'import'}, true)[0];
                                    if(action) {
                                        action.visible = false;
                                    }
                                    var editAction = utility.filterObject(pricesModel.views.mainList.itemActions, {id: 'edit'}, true)[0];
                                    if(editAction) {
                                        editAction.visible = false;
                                    }
                                }
                                deferred.resolve(pricesModel);
                            }
                            else {
                                deferred.resolve(pricesModel);
                            }
                        }).catch(function() {
                            $log.error('unable to resolve articles prices model');
                        });

                    return deferred.promise;
                }
            },
            data: {
                displayName: 'PRICES.NAV'
            },
            //only users with following accessPrivileges in their role access list can access this route
            // accessPrivileges: ['GetCatalogAllArticlePrices']
            // accessPrivileges: ['nav_prices']
            accessInfo: {
                accessPrivileges: ['nav_prices']
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/catalogs/sub-modules/prices');

        // Navigation
        msNavigationServiceProvider.saveItem('catalogs.prices', {
            title : 'Prices',
            translate: 'PRICES.NAV',
            icon  : 'icon-coin',
            weight: 70,
            // accessPrivileges: ['GetCatalogAllArticlePrices']
            // accessPrivileges: ['nav_prices']
            accessInfo: {
                accessPrivileges: ['nav_prices']
            }
        });

        msNavigationServiceProvider.saveItem('catalogs.prices.prices', {
            title      : 'Tabular View',
            subTitle   : 'Prices',
            icon       : 'icon-coin',
            state      : 'app.prices',
            translate  : 'NAV.TABULAR_VIEW',
            weight     : 70,
            // accessPrivileges: ['GetCatalogAllArticlePrices']
            // accessPrivileges: ['nav_prices']
            accessInfo: {
                accessPrivileges: ['nav_prices']
            }
        });
    }
})();
(function() {
    'use strict';

    angular
        .module('app.main.catalogs.prices')
        .controller('updatePricesController', updatePricesController);

    /**ngInject */
    function updatePricesController($mdDialog, $document, $filter, $localStorage, toast, dialog, utility, model, record, activeCatalog, catalogFactory, api) {
        var vm = this;

        //data
        vm.record = {};
        vm.record.Prices = createRecord(model, record);
        vm.activeCatalog = activeCatalog;
        vm.AllowExternalChangeManagement = false;
        vm.checkingForLockedArticles = false;
        vm.numberOfDecimalsForPrices = api.numberOfDecimalsForPrices;


        //methods
        vm.saveRecord = saveRecord;
        vm.closeDialog = closeDialog;


        activate();

        ////////////////

        function activate() {}

        function saveRecord() {
            vm.isLoading = true;
            var filteredRecord = angular.copy(vm.record);
            filteredRecord.Prices = utility.filterObject(vm.record.Prices, {readOnly: false, priceGroupNonEditable: false});
            // For non-mandatory price groups, send 0 instead of null
            angular.forEach(filteredRecord.Prices, function(price) {
                if (!price.isMandatory && (price.Price == null || price.Price == '')) {
                    price.Price = 0;
                }
            });
            var article;
            if(activeCatalog.IsPriceByStyleApply === 0) {
                article = record['ArticleId'];
            }
            else {
                article = record['ModelNumber'];
            }
            model.methods.update(filteredRecord, article, activeCatalog).then(function(response) {
                if(response.status === 202) {
                    // opening another dialog will automatically close previous one
                    dialog.showAlertDialog(
                        angular.element($document.body),
                        $filter('translate')('MESSAGES.TITLE.ALERT'),
                        $filter('translate')('MESSAGES.CONTENT.CHANGE_REQUEST_ALERT'),
                        $filter('translate')('MESSAGES.TITLE.ALERT'),
                        $filter('translate')('ACTIONS.DIALOG_CLOSE'),
                        null);
                }
                else {
                    closeDialog(true);
                    toast.success('SUCCESS.UPDATE', '', '');
                }
            }, function() {
                closeDialog();
            }).finally(function () {
                vm.isLoading = false;
            });
        }

        function closeDialog(saved) {
            $mdDialog.hide(saved);
        }

        function createRecord(model, record) {
            var result = [];
            var resultField = {};
            angular.forEach(model.fields, function(field) {
                // due to time crunch add || field.enabled to allow priceGroups which are not editable to be visible but disabled in this dialog, it should be non editable to prevent them to be visible in edit bulk
                if(field.editable || field.readOnly) {
                    resultField['displayLabel'] = field['displayLabel'];
                    resultField['PriceGroupId'] = field['priceGroupId'];
                    resultField['Price'] = record[field.field];
                    resultField['readOnly'] = field['readOnly'];
                    resultField['isMandatory'] = field['isMandatory'];
                    resultField['priceGroupNonEditable'] = angular.isDefined(field['priceGroupNonEditable']) ? field['priceGroupNonEditable'] : false;
                    resultField['isAllowChangeRequestEnabled'] = field['isAllowChangeRequestEnabled'];
                    result.push(angular.copy(resultField));
                }
            });
            return result;
        }
    }
})();
(function () {
	'use strict';

	angular
		.module('app.main.catalogs.orders-terms-conditons', [])
		.config(config);

	/* @ngInject */
	function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {

		$stateProvider.state('app.orders_terms_conditions', {
			url: '/terms-conditions',
			views: {
				'content@app': {
					templateUrl: 'app/main/catalogs/sub-modules/orders-terms-conditions/list/orders-terms-conditions-list.html',
					controller: 'ordersTermsConditionsListController as vm'
				}
			},
			resolve: {},
			data: {
				displayName: 'ORDERS_T&C.NAV'
			},
			// accessPrivileges: ['GetListOrderTermsAndConditions']
			// accessPrivileges: ['nav_orders_terms_conditions']
			accessInfo: {
				accessPrivileges: ['nav_orders_terms_conditions']
			}
		});

		$stateProvider.state('app.orders_terms_conditions.details', {
			url: '/:id',
			views: {
				'content@app': {
					templateUrl: 'app/main/catalogs/sub-modules/orders-terms-conditions/details/orders-terms-conditions-details.html',
					controller: 'ordersTermsConditionsDetailsController as vm'
				}
			},
			resolve: {},
			data: {
				parentState: 'app.orders_terms_conditions',
				displayName: 'ORDERS_T&C.TABS.ORDERS_T&C'
			},
			// only users with following accessPrivileges in their role access list can access this route
			// accessPrivileges: ['GetDetailsOrderTermsAndConditions']
			accessInfo: {
				accessPrivileges: ['GetDetailsOrderTermsAndConditions']
			}
		});

		// Translation
		$translatePartialLoaderProvider.addPart('app/main/catalogs/sub-modules/orders-terms-conditions');

		// Navigation
		msNavigationServiceProvider.saveItem('orders.terms_conditions', {
			title: 'Terms and Conditions',
			icon: 'icon-file-document',
			state: 'app.orders_terms_conditions',
			translate: 'ORDERS_T&C.NAV',
			weight: 125.5,
			// accessPrivileges: ['GetListOrderTermsAndConditions']
			// accessPrivileges: ['nav_orders_terms_conditions'],
			accessInfo: {
				accessPrivileges: ['nav_orders_terms_conditions']
			}
		});
	}

})();
(function () {
	'use strict';

	angular
		.module('app.main.catalogs.orders-terms-conditons')
		.controller('createOrderTermsAndConditionsController', createOrderTermsAndConditionsController);

	/* @ngInject */
	function createOrderTermsAndConditionsController($state, $scope, $window, $mdDialog, $filter, toast, hotkeys, event, model, record, isCopyTermsAndConditions, catalogFactory) {
		/* jshint validthis: true */
		var vm = this;

		//Data
		vm.model = model;
		vm.isLoading = false;
		vm.record = {};
		vm.isDataDirty = false;
		vm.isCopyTermsAndConditions = isCopyTermsAndConditions;
		vm.loadingContent = false;
		var activeCatalog = catalogFactory.getActiveCatalog();
		var catalogCode = activeCatalog.CatalogCode;

		if (vm.isCopyTermsAndConditions) {
			vm.record = record;
			if(angular.isUndefined(vm.record.Content) || vm.record.Content == null ||  vm.record.Content === '') {
				vm.loadingContent = true
				getContent()
				.then(function(content) {
					vm.record.Content = content
				})
				.finally(function() {
					vm.loadingContent = false
				})
			}
		}

		//Methods
		vm.saveRecord = saveRecord;
		vm.closeDialog = closeDialog;

		activate();

		////////////////

		function activate() {
			//Hotkeys
			hotkeys.bindTo($scope).add({
				combo: 'ctrl+enter',
				description: $filter('translate')('ACTIONS.SAVE'),
				allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
				callback: function (event) {
					if (!vm.isLoading && !vm.editForm.$invalid) {
						vm.saveRecord();
					}
				}
			});
		}

		function saveRecord() {
			vm.isLoading = true;
			vm.model.methods.create(vm.record, catalogCode).then(function (response) {
				closeDialog(true);
				toast.success('SUCCESS.CREATE', '', '');
			}, function (err) {
				closeDialog(vm.isDataDirty);
			}).finally(function () {
				vm.isLoading = false;
			});
		}

		function closeDialog(saved) {
			$mdDialog.hide(saved);
		}

		function getContent() {
			return vm.model.methods.getDetails(false, vm.record[vm.model.idField])
				.then(function(response) {
					return response.data.Content
				})
		}


	}
})();
(function () {
    'use strict';

    angular
        .module('app.main.catalogs.orders', [
            'app.main.catalogs.orderline',
            'app.main.catalogs.rejected-orderline',
            'app.main.catalogs.orders.files',
            'app.main.catalogs.orders.notifications',
            'app.main.catalogs.order-status-history',
            'app.main.catalogs.impacted-adjustments'
        ])
        .config(config);

    /* @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
        // State
        $stateProvider.state('app.orders', {
            url    : '/orders',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/catalogs/sub-modules/orders/list/orders-list.html',
                    controller : 'ordersListController as vm'
                }
            },
            resolve: {
                orderModel: function (api, catalogFactory, utility) {
                    var orderModel = angular.copy(api.catalogs.orders);
                    var editAction = utility.filterObject(orderModel.views.mainList.itemActions, { id: 'edit' }, true)[0];
                    var importAction = utility.filterObject(orderModel.views.mainList.listActions, { id: 'import' }, true)[0];
                    // disable order creation and updation when order by size curve is enables
                    if(!catalogFactory.getActiveCatalog().OrderBySizeCurve) {
                        editAction.visible = catalogFactory.getActiveCatalog().ReceiveOrders === 1 ? true : false;
                        orderModel.views.mainList.fabAction.visible = catalogFactory.getActiveCatalog().ReceiveOrders === 1 ? true : false;
                        importAction.disabled = catalogFactory.getActiveCatalog().ReceiveOrders === 0 ? 'true' : 'false';
                    } else {
                        editAction.visible = false;
                        orderModel.views.mainList.fabAction.visible = false;
                        importAction.visible = false;
                        utility.filterObject(orderModel.views.mainList.processOrdersItemActions, { id: 'submit' }, true)[0].visible = false;
                        utility.filterObject(orderModel.views.mainDetails.itemActions, { id: 'saveOrders' }, true)[0].visible = false;
                        utility.filterObject(orderModel.views.mainDetails.processOrdersItemActions, { id: 'submit' }, true)[0].visible = false;
                    }
                    return orderModel;
                }
            },
            data: {
                displayName: 'ORDERS.NAV'
            },
			// accessPrivileges: ['GetOrderList']
            // accessPrivileges: ['nav_orders']
            accessInfo: {
                accessPrivileges: ['nav_orders']
            }
        });
        $stateProvider.state('app.orders.details', {
			url	 : '/:id/opid/:orderProcessStatusId',
            views: {
				'content@app': {
					templateUrl: 'app/main/catalogs/sub-modules/orders/details/orders-details.html',
					controller : 'ordersDetailsController as vm'
				}
			},
            resolve: {
                orderLineModel : function(catalogFactory, settingsFactory, utility) {
                    var orderlineModel = catalogFactory.createOrderlineModel();
                    utility.filterObject(orderlineModel.views.mainList.itemActions, { id: 'edit' }, true)[0].visible = catalogFactory.getActiveCatalog().ReceiveOrders === 1 ? true : false;
                    orderlineModel.views.mainList.fabAction.visible = catalogFactory.getActiveCatalog().ReceiveOrders === 1 ? true : false;
                    // if stock enabled then hide delivery date field
                    var activeCatalog = catalogFactory.getActiveCatalog();
                    if(activeCatalog.IsStockApply) {
                        var deliveryDateField = utility.filterObject(orderlineModel.fields, {field: 'CrdId'}, true)[0];
                        deliveryDateField.visible = false;
                    }
                    // disable order creation and updation when order by size curve is enables
                    if(catalogFactory.getActiveCatalog().OrderBySizeCurve) {
                        utility.filterObject(orderlineModel.views.mainList.itemActions, { id: 'edit' }, true)[0].visible = false;
                        utility.filterObject(orderlineModel.views.mainDetails.itemActions, { id: 'saveOrders' }, true)[0].visible = false;
                        utility.filterObject(orderlineModel.views.mainList.listActions, { id: 'saveOrders' }, true)[0].visible = false;
                        orderlineModel.views.mainList.fabAction.visible = false;
                    }
                    return settingsFactory.applyPersistedListViewLayout(orderlineModel);// can be moved to controller as well
                },
                orderModel: function(api, catalogFactory, utility) {
                    var orderModel = angular.copy(api.catalogs.orders);
                    utility.filterObject(orderModel.views.mainList.itemActions, { id: 'edit' }, true)[0].visible = catalogFactory.getActiveCatalog().ReceiveOrders === 1 ? true : false;
                    orderModel.views.mainDetails.fab.visible = catalogFactory.getActiveCatalog().ReceiveOrders === 1 ? true : false;
                    var GFRbyValue = utility.filterObject(orderModel.fields, {field: 'GFRValue'}, true)[0];
                    var GFRbyQuantity = utility.filterObject(orderModel.fields, {field: 'GFRQuantity'}, true)[0];
                    if(angular.isDefined(GFRbyValue)) {
                        GFRbyValue.visible = true;
                    }
                    if(angular.isDefined(GFRbyQuantity)) {
                        GFRbyQuantity.visible = true;
                    }
                    // disable order creation and updation when order by size curve is enables
                    if(catalogFactory.getActiveCatalog().OrderBySizeCurve) {
                        orderModel.views.mainDetails.fab.visible = false;
                        utility.filterObject(orderModel.views.mainDetails.processOrdersItemActions, { id: 'submit' }, true)[0].visible = false;
                        utility.filterObject(orderModel.views.mainDetails.itemActions, { id: 'saveOrders' }, true)[0].visible = false;
                    }
                    return orderModel;
                }
            },
			data: {
				parentState: 'app.orders',
                displayName: 'ORDERS.TABS.ORDER'
			},
			// accessPrivileges: ['GetOrderDetails']
            accessInfo: {
                accessPrivileges: ['GetOrderDetails']
            }
		});

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/catalogs/sub-modules/orders');

         // Navigation
        msNavigationServiceProvider.saveItem('orders', {
            title : 'Catalog Orders',
            translate: 'NAV.CATALOG_ORDERS',
            group : true,
            weight: 2
        });

        msNavigationServiceProvider.saveItem('orders.orders', {
            title      : 'Orders',
            icon       : 'icon-cart-outline',
            state      : 'app.orders',
            translate  : 'ORDERS.NAV',
            weight     : 125,
            // accessPrivileges: ['GetOrderList']
            // accessPrivileges: ['nav_orders']
            accessInfo: {
                accessPrivileges: ['nav_orders']
            }
        });
    }
})();
(function() {
    'use strict';

    angular
        .module('app.main.catalogs.orders')
        .controller('ordersDialogController', ordersDialogController);

    /* @ngInject */
    function ordersDialogController($mdDialog, $scope, $window, $filter, hotkeys, toast, api, utility, record, lookupPromises, defaultValues, isNew, model, event, ordersDialog) {
        /* jshint validthis: true */
        var vm = this;

        //Data
        vm.model = model;
        vm.isLoading = false;
        vm.record = angular.isDefined(record) && record !== null ? record : {};
        vm.lookupModel = record;
        vm.searchText = {};
        vm.isDataDirty = false;
        vm.isNew = isNew;
        vm.customerLocations = [];
        vm.customerStocks = [];
        vm.isStockApply = defaultValues.isStockApply;

        vm.locationModel = api.customers.locations;
        vm.customersModel = api.catalogs.customers;
        var locationPromise;
        var stocksPromise;
        var customerCode = '';
        var locationCode = '';


        //Methods

        vm.saveRecord = saveRecord;
        vm.closeDialog = closeDialog;

        vm.onCustomerChange = onCustomerChange;
        vm.locationSearch = locationSearch;
        vm.getLocationDisplayValue = getLocationDisplayValue;
        vm.onLocationChange = onLocationChange;

        vm.lookupSearch = lookupSearch;
        vm.lookupChange = lookupChange;
        vm.getLookupDisplayValue = getLookupDisplayValue;
        vm.selectText = selectText;
        vm.stocksLookupSearch = stocksLookupSearch;
        vm.getStockLookupDisplayValue = getStockLookupDisplayValue;


        activate();

        ////////////////

        function activate() {
            //try to load locations for edit dialog
            if(!isNew && angular.isDefined(record) && angular.isDefined(record.LocationId) && angular.isDefined(record.CustomerId) ) {
                locationPromise = vm.locationModel.methods.getList({forceFetch: true, isLogRequired: false}, record.CustomerId, defaultValues.sellerId).then(function(response) {
                    vm.customerLocations = response.data;
                });

                // get assigned stocks
                if(vm.isStockApply) {
                    stocksPromise = vm.customersModel.methods.getList({forceFetch: true, isLogRequired: false}, vm.customersModel, record.CustomerId).then(function(response) {
                        vm.customerStocks = response.data;
                    });
                }
            }

            //Hotkeys
            hotkeys.bindTo($scope).add({
                combo: 'ctrl+enter',
                description: $filter('translate')('ACTIONS.SAVE'),
                allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
                callback: function(event) {
                    if (!vm.isLoading && !vm.editForm.$invalid) {
                        vm.saveRecord();
                    }
                }
            });
            if(vm.isNew) {
                hotkeys.bindTo($scope).add({
                    combo: 'ctrl+shift+enter',
                    description: $filter('translate')('ACTIONS.SAVE_AND_NEW'),
                    allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
                    callback: function(event) {
                        if (!vm.isLoading && !vm.editForm.$invalid) {
                            vm.saveRecord(true);
                        }
                    }
                });
            }
        }

        function saveRecord(saveAndNew) {
            vm.isLoading = true;
            vm.record.SourceId = 2;
            var p;
            if(vm.isNew) {
                p = model.methods.create(vm.record, defaultValues.catalogCode);
            }
            else {
                p = model.methods.update(vm.record[vm.model.idField] , vm.record, defaultValues.catalogCode);
            }

            p.then(function(response) {
                if (angular.isDefined(saveAndNew) && saveAndNew) {
                    vm.editForm.$setPristine();
                    vm.editForm.$setUntouched();
                    vm.record = {};
                    vm.searchText = {};
                    vm.isDataDirty = true;
                    var el = $window.document.getElementById('dialog_input_first');
                    if (el) {
                        el.focus();
                    }
                } else {
                    closeDialog(true);
                }
                var toastMessage;
                toastMessage = response.config.method.toUpperCase() === 'POST' ? 'SUCCESS.CREATE': 'SUCCESS.UPDATE';
                toast.success(toastMessage, '', '');
            }, function(err) {
                closeDialog(vm.isDataDirty);
            }).finally(function () {
                vm.isLoading = false;
            });
        }

        function closeDialog(saved) {
            $mdDialog.hide(saved);
        }

        function onCustomerChange(selectedObj, fieldName) {
            if(angular.isObject(selectedObj)) {
                customerCode = selectedObj.value;
                if(selectedObj.id !== vm.record.LocationId) {
                    vm.searchText.LocationId = '';
                    vm.lookupModel.LocationId = undefined;
                }
                lookupChange(selectedObj, fieldName);

                locationPromise = vm.locationModel.methods.getList({forceFetch: true, isLogRequired: false}, selectedObj.id, defaultValues.sellerId).then(function(response) {
                    vm.customerLocations = response.data;
                });

                // get assigned stocks
                if(vm.isStockApply) {
                    stocksPromise = vm.customersModel.methods.getList({forceFetch: true, isLogRequired: false}, vm.customersModel, defaultValues.catalogCode).then(function(response) {
                        var customer = utility.filterObject(angular.copy(response.data), {CustomerId: vm.record.CustomerId}, true)[0]
                        vm.customerStocks = customer.Stocks;
                    });
                }
            }
            else if(angular.isUndefined(selectedObj) || selectedObj === null) {
                vm.record[fieldName] = undefined; // on record removal make field undefined or the property can be deleted using delete keywork
            }
        }

        function locationSearch(query, fieldName) {
            var results = [];
            var field = utility.filterObject(model.fields, {field: fieldName})[0];
            var lookupFilter = field.lookupFilter ? field.lookupFilter : {};
            var predicate = angular.copy(lookupFilter);
            predicate.value = query;
            if(angular.isDefined(vm.customerLocations) && angular.isArray(vm.customerLocations) && vm.customerLocations.length > 0) {
                results = query ? utility.filterObject(vm.customerLocations , predicate) :  utility.filterObject(vm.customerLocations, lookupFilter);
                return results;
            }
            else {
                return locationPromise.then(function() {
                    results = query ? utility.filterObject(vm.customerLocations , predicate) :  utility.filterObject(vm.customerLocations, lookupFilter);
                    return results;
                });
            }
        }

        function getLocationDisplayValue(item, fieldName) {
            if (vm.customerLocations && vm.customerLocations.length) {
                return getLookupDisplayVal(item, fieldName, vm.customerLocations);
            } else {
                if (!isNew && angular.isDefined(record) && angular.isDefined(record.LocationId) && angular.isDefined(record.CustomerId)) {
                    return vm.locationModel.methods.getList({ forceFetch: true, isLogRequired: false }, record.CustomerId, defaultValues.sellerId).then(function (response) {
                        return getLookupDisplayVal(item, fieldName, vm.customerLocations);
                    });
                }
            }
        }

        function getLookupDisplayVal(item, fieldName, locationLookupData) {
            var result;
            var predicate = {};
            if (locationLookupData) {
                // since autocomplete return object
                if (angular.isObject(item)) {
                    predicate[vm.locationModel.idField] = item[vm.locationModel.idField];
                    result = utility.filterObject(locationLookupData, predicate, true);
                }
                // to initialize filed value if any (when open update record dialog)
                else {
                    predicate[vm.locationModel.idField] = item;
                    result = utility.filterObject(locationLookupData, predicate, true);
                }
                if (angular.isArray(result) && result.length > 0) {
                    return result[0][vm.locationModel.lookupDisplayField];
                }
                else {
                    return result[vm.locationModel.lookupDisplayField];
                }
            }
        }

        function onLocationChange(selectedObj, fieldName) {
            if(angular.isObject(selectedObj)) {
                locationCode = selectedObj.Code;
                vm.record[fieldName] = selectedObj[vm.locationModel.idField];
                vm.record.OrderReference = ordersDialog.generateOrderReference(customerCode, locationCode);
            }
            else if(angular.isUndefined(selectedObj) || selectedObj === null) {
                vm.record[fieldName] = undefined; // on record removal make field undefined or the property can be deleted using delete keywork
                vm.record.OrderReference = '';
            }
        }

        function lookupSearch(query, fieldName) {
            var results = [];

            var field = utility.filterObject(model.fields, {field: fieldName})[0];
            var lookupFilter = field.lookupFilter ? field.lookupFilter : {};
            var predicate = angular.copy(lookupFilter);
            predicate.value = query;

            var lookupModel = api.getModel(field.lookupSource);

            if(angular.isDefined(lookupModel.lookupData) && lookupModel.lookupData.data.length) {
                results = query ? utility.filterObject(lookupModel.lookupData.data , predicate) :  utility.filterObject(lookupModel.lookupData.data, lookupFilter);
                return results;
            }
            else {
                return lookupPromises[fieldName].then(function(lookupData) {
                    results = query ? utility.filterObject(lookupData.data , predicate) :  utility.filterObject(lookupData.data, lookupFilter);
                    return results;
                });
            }
        }

        // convert dropdown scope value form object(lookup record) to id property of lookup record
        function lookupChange(selectedObj, field) {
            if(angular.isObject(selectedObj)) {
                if(field !== 'StockDefinitionId') {
                    vm.record[field] = selectedObj.id;
                } else {
                    vm.record[field] = selectedObj.StockDefinitionId;
                }
            }
        }

        function getLookupDisplayValue(item, fieldName) {
            var result;
            var field = utility.filterObject(model.fields, {field: fieldName})[0];
            var lookupModel = api.getModel(field.lookupSource);

            if(lookupModel.lookupData) {
                // since autocomplte return object
                if(angular.isObject(item)) {
                    result = utility.filterObject(lookupModel.lookupData.data, {id: item.id}, true);
                }
                // to initialize filed value if any (when open update record dialog)
                else {
                    result = utility.filterObject(lookupModel.lookupData.data, {id: item}, true);
                }

                if (angular.isArray(result) && result.length > 0) {
                    return result[0].value;
                }
                else {
                    return result.value;
                }
            }
        }

        function selectText(event) {
            utility.selectInputText(event);
        }

        function stocksLookupSearch(query, fieldName, customerStocks) {
            var results = [];
            var field = utility.filterObject(vm.model.fields, { field: fieldName })[0];
            var lookupFilter = angular.isDefined(field.lookupFilter) ? field.lookupFilter : {};
            var predicate = angular.copy(lookupFilter);
            predicate.value = query;

            if (angular.isDefined(customerStocks) && angular.isArray(customerStocks) && customerStocks.length > 0) {
                results = query ? utility.filterObject(customerStocks, predicate) : utility.filterObject(customerStocks, lookupFilter, true);
                return results;
            }
            else {
                return stocksPromise.then(function () {
                    results = query ? utility.filterObject(vm.customerStocks, predicate) : utility.filterObject(vm.customerStocks, lookupFilter, true);
                    return results;
                });
            }
        }

        function getStockLookupDisplayValue(item, customerStocks) {
            var stockDefinitionId = '';
            if(angular.isObject(item)) {
                stockDefinitionId = item.StockDefinitionId;
            } else {
                stockDefinitionId = item;
            }
            var res = utility.filterObject(customerStocks, {StockDefinitionId: stockDefinitionId}, true);
            if (angular.isArray(res) && res.length > 0) {
                    return res[0].StockName;
            }
        }

    }
})();
(function(){
    'use strict';

    angular
        .module('app.main.catalogs.orders')
        .controller('approveOrdersController', approveOrdersController);

    /** @ngInject */
    function approveOrdersController($mdDialog, $q, utility, api, items, model){
        /* jshint validthis: true */
        var vm = this;

        //Data
        vm.items = [];
        vm.model = model;
        var assignedOrderTypeIds = [];
        var sellerOrderTypes = [];
        var orderTypeLookup = [];
        var orderType = undefined;
        vm.isRejectedOrInactiveOrderlines = false;

        vm.lookupModel = {};
        vm.searchText = {};


        //Methods
        vm.cancel = cancel;
        vm.closeDialog = closeDialog;
        vm.lookupSearch = lookupSearch;
        vm.lookupChange = lookupChange;
        vm.selectText = selectText;


        activate();

        //Methods Implementation

        function activate() {
            if(angular.isDefined(items)) {
                if (angular.isArray(items)) {
                    vm.items = items;
                }
                else {
                    vm.items.push(items);
                }
                for (var i = 0; i < vm.items.length; i++) {
                    if (vm.items[i].RejectedQuantity > 0 || vm.items[i].InactiveQuantity > 0) {
                        vm.isRejectedOrInactiveOrderlines = true;
                        break;
                    }
                }
            }
            if(vm.items[0] && vm.items[0].UseOrderType && vm.items[0].UseOrderType == 1) {
                var loadCustomersPromise = api.customers.customers.methods.getDetails(false, vm.items[0].CustomerId , vm.items[0].SellerAccountid)
                    .then(function(response) {
                        assignedOrderTypeIds = response.data.OrderTypes;
                    });
                var loadOrderTypesPromise = api.sellers.orderTypes.methods.getList({isLogRequired: false, forceFetch: true}, vm.items[0].SellerAccountid)
                    .then(function(response) {
                        sellerOrderTypes = response.data;
                    });
                $q.all([loadCustomersPromise, loadOrderTypesPromise]).then(function() {
                    angular.forEach(assignedOrderTypeIds, function(assignedOrderTypeId) {
                        var predicate = { Status: 1};
                        predicate[api.sellers.orderTypes.idField] = assignedOrderTypeId;
                        var filteredSellerOrderType = utility.filterObject(sellerOrderTypes, predicate, true);
                        if(filteredSellerOrderType && filteredSellerOrderType.length) {
                            var orderType = {id: assignedOrderTypeId, value: ''};
                            orderType['value'] = filteredSellerOrderType[0][api.sellers.orderTypes.lookupDisplayField];
                            orderTypeLookup.push(orderType);
                        }
                    })
                });
            }
        }

        function cancel() {
           $mdDialog.cancel();
        }

        function closeDialog(confirmation) {
            var result = {};
            result.confirmation = confirmation;
            result.orderType = orderType;
            $mdDialog.hide(result);
        }

        function lookupSearch(query) {
            var results = [];

            if(angular.isDefined(orderTypeLookup) && orderTypeLookup.length) {
                results = query ? utility.filterObject(orderTypeLookup , {value: query}) : orderTypeLookup;
            }
            return results;
        }

        function lookupChange(selectedObj) {
            if(angular.isObject(selectedObj)) {
                orderType = selectedObj.id;
            }
            else if(angular.isUndefined(selectedObj) || selectedObj === null){
                orderType = undefined; // on record removal make field undefined or the property can be deleted using delete keywork
            }
        }

        function selectText(event) {
            utility.selectInputText(event);
        }
    }
})();
(function () {
	'use strict';

	angular
		.module('app.main.catalogs.dune-images', [
			'app.main.catalogs.dune-images.tags'
		])
		.config(config);

	/* @ngInject */
	function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
		// State
		$stateProvider.state('app.dune-images', {
			url    : '/dune-images',
			views  : {
				'content@app': {
					templateUrl: 'app/main/catalogs/sub-modules/dune-images/list/dune-images-list.html',
					controller : 't1DuneListController as vm'
				}
			},
			resolve: {
				duneImagesModel : function (api, catalogFactory, SecurityFactory, CONSTANTS) {
					var duneImagesModelCopy = angular.copy(api.catalogs.t1Dune);
					var duneContext = catalogFactory.getActiveCatalog().DuneContext;
					var assignedContextKey = catalogFactory.getCatalogContextKey();
					var userWritePrivilege = SecurityFactory.isAuthorized({accessPrivileges: CONSTANTS.PRIVILEGES.T1_DUNE.READ_WRITE_ACCESS});
					if(duneContext === null && assignedContextKey === null) {
						if(userWritePrivilege) {
							angular.forEach(duneImagesModelCopy.views.mainList.itemActions, function(action) {
								action.visible = false;
							});
							angular.forEach(duneImagesModelCopy.views.mainList.listActions, function(action) {
								action.visible = false;
							});
							duneImagesModelCopy.views.mainList.fabAction.visible = false;
							duneImagesModelCopy.views.mainDetails.fab.visible = false;
						}
					} else {
						if(userWritePrivilege) {
							angular.forEach(duneImagesModelCopy.views.mainList.listActions, function(action) {
								action.visible = true;
							});
							duneImagesModelCopy.views.mainList.fabAction.visible = true;
							duneImagesModelCopy.views.mainDetails.fab.visible = true;
						}
					}
					return duneImagesModelCopy;
				}
			},
			data: {
				displayName: 'T1_DUNE.NAV'
			},
			//only users with following accessPrivileges in their role access list can access this route
			// accessPrivileges: ['nav_t1_dune_images']
			accessInfo: {
				accessPrivileges: ['nav_t1_dune_images']
			},
			visibleForLinePlan: true
		});

		$stateProvider.state('app.dune-images.details', {
			url	 : '/:id',
			params: {},
			views: {
				'content@app': {
					templateUrl: 'app/main/catalogs/sub-modules/dune-images/details/dune-images-details.html',
					controller : 't1DuneDetailsController as vm'
				}
			},
			resolve: {
				duneImagesModel : function (api, utility) {
					// dont show tags field in details
					var duneImagesModelCopy = angular.copy(api.catalogs.t1Dune);
					var tagsField = utility.filterObject(duneImagesModelCopy.fields, {field: 'Tags'}, true)[0];
					tagsField.visible = false;
					return duneImagesModelCopy;
				}
			},
			data: {
				parentState: 'app.dune-images',
				displayName:'T1_DUNE.TABS.IMAGE'
			},
			// no details API
			// accessPrivileges: ['nav_t1_dune_images']
			accessInfo: {
				accessPrivileges: ['nav_t1_dune_images']
			},
			visibleForLinePlan: true
		});

		// Translation
		$translatePartialLoaderProvider.addPart('app/main/catalogs/sub-modules/dune-images');

		msNavigationServiceProvider.saveItem('catalogs.dune-images', {
			title      : 'Dune Images',
			icon       : 'icon-image-filter',
			state      : 'app.dune-images',
			translate  : 'T1_DUNE.NAV',
			weight     : 111,
			// accessPrivileges: ['nav_t1_dune_images']
			accessInfo: {
				accessPrivileges: ['nav_t1_dune_images']
			},
			visibleForLinePlan: true
		});
	}
})();
(function() {
	'use strict';

	angular
		.module('app.main.catalogs.dune-images')
		.controller('uploadDuneImagesController', uploadDuneImagesController);

	/* @ngInject */
	function uploadDuneImagesController($mdDialog, $scope, $filter, hotkeys, $rootScope, $localStorage, $auth, toast) {
		/* jshint validthis: true */
		var vm = this;

		//Data
		vm.isLoading = false;
		vm.isFileValid = false;
		vm.record = {};

		if (angular.isUndefined($rootScope.flowObj)) {
			$rootScope.flowObj = {};
		}
		vm.obj = $rootScope.flowObj;
		vm.flowInit = {
			target      : $localStorage.t1DuneBaseUrl + '/asset/upload',
			headers     : { Authorization: 'Bearer ' + $auth.getToken()},
			singleFile  : true
		};

		//Methods
		vm.validateFile = validateFile;
		vm.saveRecord = saveRecord;
		vm.closeDialog = closeDialog;

		activate();

		////////////////

		function activate() {
			//Hotkeys
			hotkeys.bindTo($scope).add({
				combo: 'ctrl+enter',
				description: $filter('translate')('ACTIONS.SAVE'),
				allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
				callback: function(event) {
					if (!vm.isLoading && !vm.editForm.$invalid && vm.obj.flow.files.length > 0 && vm.isFileValid && !vm.obj.flow.isUploading()) {
						vm.saveRecord();
					}
				}
			});
		}

		function validateFile(file, message, flow) {
			// we have sugegsted for keeping a vetting list for allowed imaged types and read it from the vetting list for validation.
			// as discussed with Amardeep they are not planning to implement it for now and will be considered in future
			if (angular.isDefined(file) && !file.name.match(/\.(zip)$/)) {
				toast.success('IMAGES.MESSAGES.INVALID_FILE_FORMAT', '', '');
				vm.isFileValid = false;
			}
			else {
				vm.isFileValid = true;
			}
		}

		function saveRecord() {
			closeDialog(vm.obj.flow);
		}

		function closeDialog(saved) {
			var record = {
				flowObj: saved,
				record: vm.record
			}
			$mdDialog.hide(record);
		}

	}
})();
(function() {
		'use strict';

		angular
				.module('app.main.catalogs.dune-images')
				.controller('uploadDuneImageController', uploadDuneImageController);

		/* @ngInject */
		function uploadDuneImageController($mdDialog, $scope, $window, $filter, hotkeys, $rootScope,
				$auth, toast, model, record, isNew, contextKey, duneContext, isEditSortOrder, event, api) {
				/* jshint validthis: true */
				var vm = this;

				//Data
				vm.model = model;

				if (angular.isUndefined($rootScope.flowObj)) {
						$rootScope.flowObj = {};
				}
				vm.obj = $rootScope.flowObj;

				vm.flowInit = {
						headers     : { Authorization: 'Bearer ' + $auth.getToken()},
						singleFile  : true
				};

				vm.isFileValid = true;
				vm.isLoading = false;
				vm.isImageLoading = false;
				vm.isNew = isNew;
				vm.record = record;
				vm.imageTypes = [];
				vm.acticveArticles = [];
				vm.fileName = '';
				vm.duneImageSource = {};
				if(!vm.record) {
						vm.record = {};
				}
				vm.isEditSortOrder = isEditSortOrder;
				vm.assetTypes = [];
				vm.isAssetTypesLoading = false;

				// Fetch asset types for the current context
				if(duneContext && contextKey) {
					vm.isAssetTypesLoading = true;
					api.catalogs.t1Dune.methods.getAssetTypes(duneContext, contextKey).then(function(response) {
						vm.assetTypes = response.data;
					}).finally(function() {
						vm.isAssetTypesLoading = false;
					});
				}

				if(!isNew) {
					vm.isImageLoading = true;
					api.catalogs.t1Dune.methods.downloadDuneImage(vm.record.StorageFile, contextKey, false).then(function(response) {
						vm.duneImageSource[vm.record.Id] = response;
					}).finally(function() {
						vm.isImageLoading = false;
					});
				}

				if(vm.record) {
						if(vm.record.FileName) {
								vm.fileName = vm.record.FileName.slice(vm.record.FileName.lastIndexOf('/') + 1, vm.record.FileName.length)
						}
				}
				vm.isDataDirty = false;
				vm.lookupModel = angular.copy(vm.record);
				vm.isImageChanged = false; // for edit action show boxify and trim only when user changes image

				//Methods
				vm.saveRecord = saveRecord;
				vm.closeDialog = closeDialog;
				vm.validateFile = validateFile;
				vm.upload = upload;
				vm.onSuccessUpload = onSuccessUpload;

				activate();

				////////////////

				function activate() {
						//Hotkeys
						hotkeys.bindTo($scope).add({
								combo: 'ctrl+enter',
								description: $filter('translate')('ACTIONS.SAVE'),
								allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
								callback: function(event) {
										if (!vm.isLoading && !vm.editForm.$invalid && vm.obj.flow.files.length > 0 && vm.isFileValid && !vm.obj.flow.isUploading()) {
												vm.saveRecord();
										}
								}
						});
						if(vm.isNew) {
								hotkeys.bindTo($scope).add({
										combo: 'ctrl+shift+enter',
										description: $filter('translate')('ACTIONS.SAVE_AND_NEW'),
										allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
										callback: function(event) {
												if (!vm.isLoading && !vm.editForm.$invalid && vm.obj.flow.files.length > 0 && vm.isFileValid && !vm.obj.flow.isUploading() && vm.isNew) {
														vm.saveRecord(true);
												}
										}
								});
						}
				}

				function saveRecord(saveAndNew) {
						vm.isLoading = true;
						// add dune context to record
						vm.record.Context = duneContext;
						vm.record.ContextKey = contextKey;
						var promise;
						if(vm.isNew) {
								promise = vm.model.methods.create(vm.record, contextKey);
						}
						else {
								promise = vm.model.methods.update(vm.record[vm.model.idField], vm.record);
						}
						promise.then(function() {
								if (vm.isNew && angular.isDefined(saveAndNew) && saveAndNew) {
										vm.editForm.$setPristine();
										vm.editForm.$setUntouched();
										vm.record = {};
										vm.obj.flow.files.length = 0;
										vm.searchText = {};
										vm.isDataDirty = true;

										var el = $window.document.getElementById('dialog_input_first');
										if (el) {
												el.focus();
										}
								}
								else {
										closeDialog(true);
								}
								var toastMessage;
								toastMessage = vm.isNew ? 'SUCCESS.CREATE': 'SUCCESS.UPDATE';
								toast.success(toastMessage, '', '');
						}, function(err) {
								closeDialog(vm.isDataDirty);
						}).finally(function () {
								vm.isLoading = false;
						});
				}

				function closeDialog(saved, cancelUpload) {
						//If user cancel upload
						if(angular.isDefined(cancelUpload) && cancelUpload === true){
								vm.obj.flow.cancel();
						}
						$mdDialog.hide(saved);
				}

				function validateFile(file, message, flow) {
						vm.record.file = file.file;
						if (angular.isDefined(file) && !file.name.match(/\.(jpe?g|png|tif?f|JPE?G|PNG|TIF?F|glb|GLB)$/)) {
								vm.isFileValid = false;
						}
						else {
								vm.isFileValid = true;
								// Update FileName with the new file's name for edit
								if(!vm.isNew) {
									vm.record.FileName = file.name;
								}
						}
				}

				function upload() {
					if(vm.isFileValid) {
						if(!vm.isNew) {
							vm.isImageChanged = true;
						}
					}
					else {
							//remove file from flowObj.files if file is not valid and set vm.isFileValid to default value which is true
							// vm.obj.flow.files.splice(vm.obj.flow.files.length-1,1);
							vm.obj.flow.removeFile(vm.obj.flow.files[vm.obj.flow.files.length-1]);// or vm.obj.flow.files[0]
					}
				}

				function onSuccessUpload(file, message) {
						message = message.replace(/\"/g,"");
						vm.record.FileGuid = message;
				}

		}
})();
(function ()
{
    'use strict';

    angular
        .module('app.viewCreator', []);
})();

(function() {
    'use strict';

    angular
        .module('app.viewCreator')
        .controller('removeTagsController', removeTagsController);

    /* @ngInject */
    function removeTagsController($mdDialog, $scope, $filter, hotkeys, toast, model, records, contextKey) {
        var vm = this;

		//data
		vm.isLoading = false;
		var assignedContextKey = contextKey;
		vm.tags = getUniqueTags(records);

		//methods
		vm.saveRecord = saveRecord;
		vm.closeDialog = closeDialog;

		activate();

		////////////////

		function activate() {
			//Hotkeys
			hotkeys.bindTo($scope).add({
				combo: 'ctrl+enter',
				description: $filter('translate')('ACTIONS.SAVE'),
				allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
				callback: function (event) {
					if (!vm.isLoading && !vm.editForm.$invalid) {
						vm.saveRecord();
					}
				}
			});

			if (vm.isNew) {
				hotkeys.bindTo($scope).add({
					combo: 'ctrl+shift+enter',
					description: $filter('translate')('ACTIONS.SAVE_AND_NEW'),
					allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
					callback: function (event) {
						if (!vm.isLoading && !vm.editForm.$invalid) {
							vm.saveRecord(true);
						}
					}
				});
			}
		}

		function saveRecord() {
			vm.isLoading = true;
			var selectedAssetsIds = records.map(function(record) {
				var id = record.Id;
				return id;
			});
			var requestObj = {
				ContextKey: assignedContextKey,
				Ids: selectedAssetsIds,
				Tag: vm.tag
			}

			var p = model.methods.removeTag(requestObj);

			p.then(function () {
				closeDialog(true);
				var toastMessage;
				toastMessage = 'SUCCESS.CREATE';
				toast.success(toastMessage, '', '');
			}, function (err) {
				closeDialog(vm.isDataDirty);
			}).finally(function () {
				vm.isLoading = false;
			})
		}

		function closeDialog(saved) {
			$mdDialog.hide(saved);
		}

		function getUniqueTags(assets) {
			var uniqueTags = [];
			var uniqueValuesIndex = {};
			angular.forEach(assets, function(asset) {
				if(asset.Tags.length > 0) {
					angular.forEach(asset.Tags, function(tag) {
						if (angular.isUndefined(uniqueValuesIndex[tag.Tag]) && tag.Status) {
							uniqueValuesIndex[tag.Tag] = 1;
							uniqueTags.push(tag.Tag);
						}
					});
				}
			});
			uniqueTags = $filter('orderBy')(uniqueTags);
			return uniqueTags;
		}

  }
})();
(function() {
	'use strict';

	angular
		.module('app.main.catalog-customers.segmentation-linear',[])
		.config(config);

	/* @ngInject */
	function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
		// State
		$stateProvider.state('app.customers_segmentation_linear', {
			url    : '/customers-segmentation-linear',
			views  : {
				'content@app': {
					templateUrl: 'app/main/catalogs/sub-modules/customers-segmentation-linear/list/customers-segmentation-linear-list.html',
					controller : 'customersSegmentationLinearController as vm'
				}
			},
			resolve: {
				customerSpecificSegmentationModel : function(api, catalogFactory) {
					 // update targetModel to make DPAccountGroup field visible based on catalog specific configuration
					 var catalogSpecificConfigurationList = catalogFactory.getActiveCatalogDetails().CatalogSpecificConfigurationList;
					 angular.forEach(catalogSpecificConfigurationList, function (configuration) {
							if(configuration.Name == 'Display-DPAccountGroupInCustomersSegmentation' && configuration.Value == '1') {
							angular.forEach(api.catalogCustomers.segmentationLinear.fields, function(field) {
								if(field.field == 'DPAccountGroup') {
									field.visible = true;
								}
							});
						 }
					 });

					return api.catalogCustomers.segmentationLinear;
				}
			},
			data: {
				displayName: 'CUSTOMERS_SEGMENTATION_LINEAR.NAV'
			},
			//only users with following accessPrivileges in their role access list can access this route
			// accessPrivileges: ['GetSellerCatalogBulkCustomerSegmentations']
			// accessPrivileges: ['nav_customers_segmentation']
			accessInfo: {
				accessPrivileges: ['nav_customers_segmentation']//Change UI privileges
			}
		});

		// Translation
		$translatePartialLoaderProvider.addPart('app/main/catalogs/sub-modules/customers-segmentation-linear');

		msNavigationServiceProvider.saveItem('catalogs.customers_segmentation.customers_segmentation_linear', {
			title      : 'Linear View',
			subTitle   : 'Customers Segmentation',
			icon       : 'icon-account-key',
			state      : 'app.customers_segmentation_linear',
			translate  : 'NAV.LINEAR_VIEW',
			weight     : 21,
			// accessPrivileges: ['GetSellerCatalogBulkCustomerSegmentations']
			// accessPrivileges: ['nav_customers_segmentation']
			accessInfo: {
				accessPrivileges: ['nav_customers_segmentation']
			}
		});
	}
})();
(function () {
	'use strict';

	angular
		.module('app.main.catalog-customers.segmentation-linear')
		.controller('assignCustomerSegmentationController', assignCustomerSegmentationController);

	/* @ngInject */
	function assignCustomerSegmentationController($mdDialog, api, utility, $scope, $filter, hotkeys, lookupPromises, model, actualModel, customersModel, catalogId, assignedSegmentation, event, $q) {
		/* jshint validthis: true */
		var vm = this;

		//Data
		vm.model = model;
		vm.record = {};
		vm.record.CustomerNumber = [];
		vm.record.SegmentationId = [];
		vm.customersModel = customersModel;
		vm.actualModel = actualModel;
		vm.activeCatalogCode = catalogId;
		vm.assignedSegmentation = assignedSegmentation;

		vm.isLoading = false;
		vm.isDataDirty = false;
		vm.acLookupModel = {};
		vm.acSelectedItem = [];
		vm.acSearchText = [];
		vm.allLinkedCustomers = [];
		vm.catalogSegmentations = [];

		//Methods
		vm.saveRecord = saveRecord;
		vm.closeDialog = closeDialog;

		vm.acQuerySearch = acQuerySearch;
		vm.transformChip = transformChip;
		vm.getChipDisplayValue = getChipDisplayValue;
		vm.acCustomerNumberQuerySearch = acCustomerNumberQuerySearch;
		vm.getCustomerNumberChipDisplayValue = getCustomerNumberChipDisplayValue;


		activate();

		////////////////

		function activate() {
			loadLinkedCustomers();
			//Hotkeys
			hotkeys.bindTo($scope).add({
				combo: 'ctrl+enter',
				description: $filter('translate')('ACTIONS.SAVE'),
				allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
				callback: function (event) {
					if (!vm.isLoading && !vm.editForm.$invalid) {
						vm.saveRecord();
					}
				}
			});
			hotkeys.bindTo($scope).add({
				combo: 'ctrl+shift+enter',
				description: $filter('translate')('ACTIONS.SAVE_AND_NEW'),
				allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
				callback: function (event) {
					if (!vm.isLoading && !vm.editForm.$invalid) {
						vm.saveRecord(true);
					}
				}
			});
		}

		function saveRecord() {
			vm.isLoading = true;
			vm.model.methods.updateBulk(vm.record, vm.actualModel, vm.assignedSegmentation);
			closeDialog(true);
		}

		function closeDialog(saved) {
			$mdDialog.hide(saved);
		}

		function transformChip(chip, fieldName) {
			if (angular.isObject(chip)) {
				if(fieldName === 'CustomerNumber') {
						return chip.CustomerNumber;
				} else {
						return chip.value;
				}
			}
			return undefined;
		}

		function acQuerySearch(query, selectedRecords, fieldName) {
			var results = [];
			var field = utility.filterObject(model.fields, { field: fieldName, creatable: true }, true)[0];
			var lookupFilter = angular.isDefined(field.lookupFilter) ? field.lookupFilter : {};
			var predicate = angular.copy(lookupFilter);
			predicate.value = query;

			var lookupModel = api.getModel(field.lookupSource);
			if (angular.isDefined(lookupModel.lookupData) && angular.isDefined(lookupModel.lookupData.data) && lookupModel.lookupData.data.length) {
				results = query ? utility.filterObject(lookupModel.lookupData.data, predicate) : utility.filterObject(lookupModel.lookupData.data, lookupFilter);
				results = removeSelectedChips(selectedRecords, results, field.field);
				return results;
			}
			else {
				return lookupPromises[field.field].then(function (lookupData) {
					results = query ? utility.filterObject(lookupData.data, predicate) : utility.filterObject(lookupData.data, lookupFilter);
					results = removeSelectedChips(selectedRecords, results, field.field);
					return results;
				});
			}
		}

		/**
		 * @description
		 * This method will remove selected chips form records (helper method)
		 * @param {array} selectedRecords: list of selected chips
		 * @param {array} records: data property of lookup-data
		 * @returns {array}: list of available chips (chips which are not selected) // it does not really need to return a value but for readability returning modified value
		 */
		function removeSelectedChips(selectedRecords, records) {
			if (angular.isDefined(selectedRecords) && selectedRecords.length > 0) {
				for (var index = records.length - 1; index >= 0; index--) {
					if (selectedRecords.indexOf(records[index].value) !== -1) {
						records.splice(index, 1);
					}
				}
			}
			return records;
		}

		function getChipDisplayValue(chip, fieldName) {
			var field = utility.filterObject(model.fields, { field: fieldName, creatable: true }, true)[0];
			var lookupModel = api.getModel(field.lookupSource);
			if (angular.isDefined(lookupModel.lookupData) && angular.isDefined(lookupModel.lookupData.data) && lookupModel.lookupData.data.length) {
				return getChipDisplayVal(lookupModel.lookupData, chip);
			}
			else { // it will never go to else part since before try to load display value for selected chips, it always load lookup on focus of chips input element
				return lookupPromises[field.field].then(function (lookupData) {
					return getChipDisplayVal(lookupData, chip);
				});
			}
		}

		//helper method
		function getChipDisplayVal(lookupData, chip) {
			var res = utility.filterObject(lookupData.data, { value: chip }, true);
			if (angular.isArray(res) && res.length > 0) {
				return res[0].value;
			}
		}

		function acCustomerNumberQuerySearch(query, selectedItems, linkedCustomers) {  
				var searchQueryResult = [];
				if(angular.isDefined(linkedCustomers) && linkedCustomers.length) {
						searchQueryResult = utility.filterObject(linkedCustomers, query);                 
						removeSelectedCustomers(selectedItems, searchQueryResult);
						return searchQueryResult;
				}
				else { 
						return loadLinkedCustomers().then(function(linkedCustomers) {
								searchQueryResult = utility.filterObject(linkedCustomers, query);
								removeSelectedCustomers(selectedItems, searchQueryResult);
								return searchQueryResult;
						});
				}
		}

		function removeSelectedCustomers(selectedItems, searchQueryResult) {
			if (angular.isDefined(selectedItems) && selectedItems.length > 0) {
					for (var index = searchQueryResult.length-1; index >= 0; index--) {
							if (selectedItems.indexOf(searchQueryResult[index].CustomerNumber) !== -1) {
									searchQueryResult.splice(index,1);
							}
					}
			}
		}

		function getCustomerNumberChipDisplayValue(chip, linkedCustomers) {
				var res = utility.filterObject(linkedCustomers, {CustomerNumber: chip}, true);            
				if (angular.isArray(res) && res.length > 0) {
						return res[0].CustomerNumber;
				}
		}

		function loadLinkedCustomers() {
			var defrred = $q.defer();
			var generalProperties = {
				forceFetch: true,
				isLogRequired: false
			}
			vm.customersModel.methods.getList(generalProperties, vm.model, vm.activeCatalogCode).then(function(response) {
				vm.allLinkedCustomers = angular.copy(utility.filterObject(response.data, {Status: 1}, true));
				defrred.resolve(vm.allLinkedCustomers);
			});
			return defrred.promise;
		}

	}
})();
(function() {
    'use strict';

    angular
        .module('app.main.catalogs.crds-linear',[])
        .config(config);

    /* @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
        // State
        $stateProvider.state('app.crds_linear', {
            url    : '/crds-linear',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/catalogs/sub-modules/crds-linear/list/crds-linear-list.html',
                    controller : 'crdsLinearListController as vm'
                }
            },
            resolve: {},
            data: {
                displayName: 'CRD_LINEAR.NAV'
            },
            //only users with following accessPrivileges in their role access list can access this route
            // accessPrivileges: ['GetCatalogListArticleCRDs']
            // accessPrivileges: ['nav_delivery_dates']
            accessInfo: {
                accessPrivileges: ['nav_delivery_dates']
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/catalogs/sub-modules/crds-linear');

        msNavigationServiceProvider.saveItem('catalogs.crds.crds_linear', {
            title      : 'Linear View',
            subTitle   : 'Delivery Dates',
            icon       : 'icon-calendar-clock',
            state      : 'app.crds_linear',
            translate  : 'NAV.LINEAR_VIEW',
            weight     : 60,
            // accessPrivileges: ['GetCatalogListArticleCRDs']
            // accessPrivileges: ['nav_delivery_dates']
            accessInfo: {
                accessPrivileges: ['nav_delivery_dates']
            }
        });
    }
})();
(function () {
	'use strict';

	angular
		.module('app.main.catalogs.crds-linear')
		.controller('assignArticleCRDsController', assignArticleCRDsController);

	/* @ngInject */
	function assignArticleCRDsController($mdDialog, api, utility, $scope, $filter, hotkeys, lookupPromises, model, event) {
		/* jshint validthis: true */
		var vm = this;

		//Data
		vm.model = model;
		vm.record = {};
		vm.record.ArticleId = [];
		vm.record.CrdId = [];

		vm.isLoading = false;
		vm.isDataDirty = false;
		vm.acLookupModel = {};
		vm.acSelectedItem = [];
		vm.acSearchText = [];

		//Methods
		vm.saveRecord = saveRecord;
		vm.closeDialog = closeDialog;

		vm.acQuerySearch = acQuerySearch;
		vm.transformChip = transformChip;
		vm.getChipDisplayValue = getChipDisplayValue;


		activate();

		////////////////

		function activate() {
			//Hotkeys
			hotkeys.bindTo($scope).add({
				combo: 'ctrl+enter',
				description: $filter('translate')('ACTIONS.SAVE'),
				allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
				callback: function (event) {
					if (!vm.isLoading && !vm.editForm.$invalid) {
						vm.saveRecord();
					}
				}
			});
			hotkeys.bindTo($scope).add({
				combo: 'ctrl+shift+enter',
				description: $filter('translate')('ACTIONS.SAVE_AND_NEW'),
				allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
				callback: function (event) {
					if (!vm.isLoading && !vm.editForm.$invalid) {
						vm.saveRecord(true);
					}
				}
			});
		}

		function saveRecord() {
			vm.isLoading = true;
			vm.model.methods.updateBulk(vm.record);
			closeDialog(true);
		}

		function closeDialog(saved) {
			$mdDialog.hide(saved);
		}

		function transformChip(chip, fieldName) {
			if (angular.isObject(chip)) {
				if (fieldName === 'ArticleId') {
					return chip.value;
				} else if (fieldName === 'CrdId') {
					return chip.id;
				}
			}
			return undefined;
		}

		function acQuerySearch(query, selectedRecords, fieldName) {
			var results = [];
			var field = utility.filterObject(model.fields, { field: fieldName, creatable: true }, true)[0];
			var lookupFilter = angular.isDefined(field.lookupFilter) ? field.lookupFilter : {};
			var predicate = angular.copy(lookupFilter);
			predicate.value = query;

			var lookupModel = api.getModel(field.lookupSource);
			if (angular.isDefined(lookupModel.lookupData) && angular.isDefined(lookupModel.lookupData.data) && lookupModel.lookupData.data.length) {
				results = query ? utility.filterObject(lookupModel.lookupData.data, predicate) : utility.filterObject(lookupModel.lookupData.data, lookupFilter);
				results = removeSelectedChips(selectedRecords, results, field.field);
				return results;
			}
			else {
				return lookupPromises[field.field].then(function (lookupData) {
					results = query ? utility.filterObject(lookupData.data, predicate) : utility.filterObject(lookupData.data, lookupFilter);
					results = removeSelectedChips(selectedRecords, results, field.field);
					return results;
				});
			}
		}

		/**
		 * @description
		 * This method will remove selected chips form records (helper method)
		 * @param {array} selectedRecords: list of selected chips
		 * @param {array} records: data property of lookup-data
		 * @returns {array}: list of available chips (chips which are not selected) // it does not really need to return a value but for readability returning modified value
		 */
		function removeSelectedChips(selectedRecords, records, fieldName) {
			if (angular.isDefined(selectedRecords) && selectedRecords.length > 0) {
				for (var index = records.length - 1; index >= 0; index--) {
					var recordIndex = -1;
					if (fieldName === 'ArticleId') {
						recordIndex = selectedRecords.indexOf(records[index].value);
					} else if (fieldName === 'CrdId') {
						recordIndex = selectedRecords.indexOf(records[index].id);
					}
					if (recordIndex !== -1) {
						records.splice(index, 1);
					}
				}
			}
			return records;
		}

		function getChipDisplayValue(chip, fieldName) {
			var field = utility.filterObject(model.fields, { field: fieldName, creatable: true }, true)[0];
			var lookupModel = api.getModel(field.lookupSource);
			if (angular.isDefined(lookupModel.lookupData) && angular.isDefined(lookupModel.lookupData.data) && lookupModel.lookupData.data.length) {
				return getChipDisplayVal(lookupModel.lookupData, chip, fieldName);
			}
			else { // it will never go to else part since before try to load display value for selected chips, it always load lookup on focus of chips input element
				return lookupPromises[field.field].then(function (lookupData) {
					return getChipDisplayVal(lookupData, chip, fieldName);
				});
			}
		}

		//helper method
		function getChipDisplayVal(lookupData, chip, fieldName) {
			if (fieldName === 'ArticleId') {
				var res = utility.filterObject(lookupData.data, { value: chip }, true);
				if (angular.isArray(res) && res.length > 0) {
					return res[0].value;
				}
			} else if (fieldName === 'CrdId') {
				var res = utility.filterObject(lookupData.data, { id: chip }, true);
				if (angular.isArray(res) && res.length > 0) {
					return res[0].value;
				}
			}
		}

	}
})();
(function () {
    'use strict';

    angular
        .module('app.main.catalogs.consolidations.error-list', []);
})();
(function() {
    'use strict';

    angular
        .module('app.main.catalogs.consolidations.error-list')
        .run(runBlock);

    /* @ngInject */
    function runBlock(api) {

        if (angular.isUndefined(api.consolidations)) {
            api.consolidations = {};
        }
         api.consolidations.errorList = {
            modelPath: 'consolidations.errorList',
            fields: [
                { field: 'Id', type: 'int', displayLabel: 'CONSOLIDATION_ERROR_LIST.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'BackgroundJobTypeId', type: 'int', displayLabel: 'CONSOLIDATION_ERROR_LIST.FIELDS.JOB_TYPE_ID', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'BackgroundJobType', type: 'int', displayLabel: 'CONSOLIDATION_ERROR_LIST.FIELDS.JOB_TYPE', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Operation', type: 'text', displayLabel: 'CONSOLIDATION_ERROR_LIST.FIELDS.OPERATION', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ConsolidationStatus', type: 'text', displayLabel: 'CONSOLIDATION_ERROR_LIST.FIELDS.CONSOLIDATION_STATUS', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ErrorMessage', type: 'text', displayLabel: 'CONSOLIDATION_ERROR_LIST.FIELDS.ERROR_MESSAGE', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ErrorType', type: 'text', displayLabel: 'CONSOLIDATION_ERROR_LIST.FIELDS.ERROR_TYPE', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'JobId', type: 'text', displayLabel: 'CONSOLIDATION_ERROR_LIST.FIELDS.JOB_ID', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'RecordLineNumber', type: 'text', displayLabel: 'CONSOLIDATION_ERROR_LIST.FIELDS.RECORD_LINE_NUMBER', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreateDate', type: 'text', displayLabel: 'CONSOLIDATION_ERROR_LIST.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
            ],
            uniqueConstraints: [
            ],
            title: 'CONSOLIDATION_ERROR_LIST.NAV',
            icon: 'icon-sigma',
            idField: 'Id',
            lookupDisplayField: 'Operation',
            isDirty: false,
            isBulkActionCompleted: false,
            isCatalogSpecificModel: true,
            methods: {
                getDetails          :   getConsolidationErrorDetails
            },
            views: {
                mainList: {
                    columns         : [ 'ConsolidationStatus', 'Operation', 'JobId', 'ErrorMessage', 'RecordLineNumber', 'CreateDate'],
                    columnFilter    : {},
                    toggleFilterProps: {},
                    topIndex        : 0,
                    showFilterRow   : false,
                    sortColumn      : {'CreateDate': false},
                    itemActions     : [],
                    listActions     : [],
                    fabAction       : {}

                 },
                 mainDetails: {
                     selectedTabIndex   : 0,
                     itemActions        : [],
                    fabAction           : {}

                 },
                privileges: {
                    list    : 'GetConsolidationsBackGroundJobDetails'
                }
            }
        };

        function getConsolidationErrorDetails(consolidationJobId) {
            return api.webGet(api.baseUrl + '/backgroundjobs/consolidations/' + consolidationJobId + '?status=0');
		}

    }
})();
(function () {
    'use strict';

    angular
        .module('app.main.catalogs.consolidations.criteria', []);
})();
(function() {
    'use strict';

    angular
        .module('app.main.catalogs.consolidations.criteria')
        .run(runBlock);

    /* @ngInject */
    function runBlock(api) {

        if (angular.isUndefined(api.consolidations)) {
            api.consolidations = {};
        }
         api.consolidations.criteria = {
            modelPath: 'consolidations.criteria',
            fields: [
                { field: 'Id', type: 'int', displayLabel: 'CONSOLIDATION_CRITERIA.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'FieldId', type: 'int', displayLabel: 'CONSOLIDATION_CRITERIA.FIELDS.FIELD_ID', visible: true, creatable: false, editable: false, inputType: 'lookup', lookupSource: 'consolidationTemplates.templateFields',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ConsolidationFieldValue', type: 'int', displayLabel: 'CONSOLIDATION_CRITERIA.FIELDS.FIELD_VALUE', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ColumnDataType', type: 'text', displayLabel: 'CONSOLIDATION_CRITERIA.FIELDS.DATA_TYPE', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedDate', type: 'text', displayLabel: 'CONSOLIDATION_CRITERIA.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedDate', type: 'text', displayLabel: 'CONSOLIDATION_CRITERIA.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedBy', type: 'text', displayLabel: 'CONSOLIDATION_CRITERIA.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedBy', type: 'text', displayLabel: 'CONSOLIDATION_CRITERIA.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
            ],
            uniqueConstraints: [
            ],
            title: 'CONSOLIDATION_CRITERIA.NAV',
            icon: '',
            idField: 'FieldId',
            lookupDisplayField: 'ConsolidationFieldValue',
            isDirty: false,
            isBulkActionCompleted: false,
            isCatalogSpecificModel: true,
            methods: {
            },
            views: {
                mainList: {
                    columns         : [ 'FieldId', 'ConsolidationFieldValue', 'UpdatedDate'],
                    columnFilter    : {},
                    toggleFilterProps: {},
                    topIndex        : 0,
                    showFilterRow   : false,
                    sortColumn      : {'UpdatedDate': false},
                    itemActions     : [
                                        { }
                                      ],
                    listActions     : [],
                    fabAction       :
                                        {}

                 },
                 mainDetails: {
                     selectedTabIndex   : 0,
                     itemActions        : [],
                    fabAction           : {}

                 },
                privileges: {
                    list    : 'GetOrderConsolidationDetails' // same as consolidation details page
                }
            }
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.main.catalogs.consolidations', [
            'app.main.catalogs.consolidations.criteria',
            'app.main.catalogs.consolidations.error-list'

        ])
        .config(config);

    /* @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
        // State
        $stateProvider.state('app.consolidations', {
            url    : '/consolidations',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/catalogs/sub-modules/consolidations/list/consolidations-list.html',
                    controller : 'consolidationsListController as vm'
                }
            },
            data: {
                displayName: 'CONSOLIDATIONS.NAV'
            },
            //only users with following accessPrivileges in their role access list can access this route
			// accessPrivileges: ['GetOrderConsolidationList']
            // accessPrivileges: ['nav_consolidations']
            accessInfo: {
                accessPrivileges: ['nav_consolidations']
            }
        });
        $stateProvider.state('app.consolidations.details', {
			url	 : '/:id',
            views: {
				'content@app': {
					templateUrl: 'app/main/catalogs/sub-modules/consolidations/details/consolidations-details.html',
					controller : 'consolidationsDetailsController as vm'
				}
			},
			data: {
				parentState: 'app.consolidations',
                displayName: 'CONSOLIDATIONS.TABS.CONSOLIDATION'
			},
            //only users with following accessPrivileges in their role access list can access this route
            // accessPrivileges: ['GetOrderConsolidationDetails']
            accessInfo: {
                accessPrivileges: ['GetOrderConsolidationDetails']
            }
		});

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/catalogs/sub-modules/consolidations');

        msNavigationServiceProvider.saveItem('orders.consolidations', {
            title      : 'Consolidations',
            icon       : 'icon-sigma',
            state      : 'app.consolidations',
            translate  : 'CONSOLIDATIONS.NAV',
            weight     : 150,
            // accessPrivileges: ['GetOrderConsolidationList']
            // accessPrivileges: ['nav_consolidations']
            accessInfo: {
                accessPrivileges: ['nav_consolidations']
            }
        });
    }
})();
(function () {
	'use strict';

	angular
			.module('app.main.catalogs.consolidations')
			.controller('copyTemplates', copyTemplates);

	/* @ngInject */
	function copyTemplates($mdDialog, $scope, $filter, hotkeys, toast, api, utility, model, sellerId, attributeGroupId, activeCatalogCode, event) {
			/* jshint validthis: true */
			var vm = this;

			//Data
			vm.isLoading = false;
			var templates = [];
			vm.isDataDirty = false;
			vm.maxChips = 2;
			vm.record = {};

			vm.acSelectedItem = [];
			vm.acSearchText = [];
			vm.searchText = {};
			vm.record.TemplateIds = [];


			//Methods
			vm.saveRecord = saveRecord;
			vm.closeDialog = closeDialog;

			vm.lookupSearch = lookupSearch;
			vm.onLookupChange = onLookupChange;
			vm.getLookupDisplayValue = getLookupDisplayValue;

			vm.acQuerySearch = acQuerySearch;
			vm.transformChip = transformChip;
			vm.getChipDisplayValue = getChipDisplayValue;

			vm.selectText = selectText;

			activate();

			////////////////

			function activate() {
					//Hotkeys
					hotkeys.bindTo($scope).add({
							combo: 'ctrl+enter',
							description: $filter('translate')('ACTIONS.SAVE'),
							allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
							callback: function (event) {
									if (!vm.isLoading && !vm.editForm.$invalid) {
											vm.saveRecord();
									}
							}
					});
			}

			function saveRecord() {
					vm.isLoading = true;
					var p = model.methods.copyTemplates(vm.record, activeCatalogCode, sellerId);
					p.then(function () {
							closeDialog(true);
							var toastMessage;
							toastMessage = 'SUCCESS.CREATE';
							toast.success(toastMessage, '', '');
					}, function () {
							closeDialog(vm.isDataDirty);
					}).finally(function () {
							vm.isLoading = false;
					});
			}


			function closeDialog(saved) {
					$mdDialog.hide(saved);
			}

			function lookupSearch(query, fieldName) {
					var results = [];

					var field = utility.filterObject(model.fields, { field: fieldName }, true)[0];
					var lookupFilter = field.lookupFilter ? field.lookupFilter : {};
					var predicate = angular.copy(lookupFilter);
					predicate.value = query;
					var lookupModel = api.getModel(field.lookupSource);

					if (angular.isDefined(lookupModel.lookupData)) {
							results = query ? utility.filterObject(lookupModel.lookupData.data, predicate) : utility.filterObject(lookupModel.lookupData.data, lookupFilter, true);
							// return only catalogs with same account id and attribute group
							return utility.filterObject(results, {AccountId: sellerId, AttributeGroupId: attributeGroupId}, true);
					} else {
							return api.getLookupData(lookupModel).then(function () {
									results = query ? utility.filterObject(lookupModel.lookupData.data, predicate) : utility.filterObject(lookupModel.lookupData.data, lookupFilter, true);
									// return only catalogs with same account id and attribute group
									return utility.filterObject(results, {AccountId: sellerId, AttributeGroupId: attributeGroupId}, true);
							});
					}
			}

			// convert drop down scope value form object(lookup record) to id property of lookup record
			function onLookupChange(selectedObj, field) {
					if (angular.isObject(selectedObj)) {
							vm.record[field] = selectedObj.id;
							loadTemplates(vm.record.SourceCatalogCode, sellerId);
					} else if (angular.isUndefined(selectedObj) || selectedObj === null) {
						vm.record[field] = undefined;
					}
			}

			function getLookupDisplayValue(item, lookupSource) {
					var lookupModel = api.getModel(lookupSource);

					if (lookupModel.lookupData && angular.isDefined(lookupModel.lookupData.data) && lookupModel.lookupData.data.length) {
							return getLookupDisplayVal(item, lookupModel.lookupData);
					}
					else {
							return api.getLookupData(lookupModel).then(function (lookupData) {
									return getLookupDisplayVal(item, lookupData);
							});
					}
			}

			function getLookupDisplayVal(item, lookupData) {
					var result;
					if (lookupData) {
							// since autocomplete return object
							if (angular.isObject(item)) {
									result = utility.filterObject(lookupData.data, { id: item.id }, true);
							}
							// to initialize field value if any (when open update record dialog)
							else {
									result = utility.filterObject(lookupData.data, { id: item }, true);
							}
							if (angular.isArray(result) && result.length > 0) {
									return result[0].value;
							}
							else {
									return result.value;
							}
					}
			}

			function acQuerySearch(query, selectedItems) {
					var searchQueryResult = utility.filterObject(templates, query);
					if (selectedItems && selectedItems.length > 0) {
						for (var index = searchQueryResult.length - 1; index >= 0; index--) {
								if (selectedItems.indexOf(searchQueryResult[index].Id) !== -1) {
										searchQueryResult.splice(index, 1);
								}
							}
					}
					return searchQueryResult;
			}

			function transformChip(chip) {
					if (angular.isObject(chip)) {
						return chip.Id;
					}
					return undefined;
			}

			function getChipDisplayValue(chip) {
					var res = utility.filterObject(templates, { Id: chip }, true);
					if (angular.isArray(res) && res.length > 0) {
							return res[0].Name;
					}
			}

			function selectText(event) {
					utility.selectInputText(event);
			}

			function loadTemplates(sourceCatalogCode, sellerId) {
					templates = [];
					var generalProperties = {
						forceFetch: true,
						isLogRequired: false
					}
					// get all the consolidation templates
					api.catalogs.consolidationTemplates.methods.getList(generalProperties, sourceCatalogCode, sellerId)
					.then(function (response) {
						templates = utility.filterObject(response.data, { Status: 1 });
					});
			}

	}
})();
(function () {
	'use strict';

	angular
		.module('app.main.catalogs.models', [
			'app.main.catalogs.models.model-articles',
			'app.main.catalogs.models.model-sizes',
			'app.main.catalogs.models.model-resources'
		])
		.config(config);

	/* @ngInject */
	function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {

		$stateProvider.state('app.catalog-models', {
			url: '/catalog-models',
			views: {
				'content@app': {
					templateUrl: 'app/main/catalogs/sub-modules/catalog-models/list/catalog-models-list.html',
					controller: 'modelsListController as vm'
				}
			},
			resolve: {
				catalogModelsModel: function (api, catalogFactory) {
					var model = api.catalogs.models;
					return catalogFactory.createCatalogModelsModel(model);
				}
			},
			data: {
				displayName: 'MODELS.NAV'
			},
			// accessPrivileges: ['GetCatalogTrueModels']
			// accessPrivileges: ['nav_models']
			accessInfo: {
				accessPrivileges: ['nav_models']
			}
		});

		$stateProvider.state('app.catalog-models.details', {
			url: '/:id',
			views: {
				'content@app': {
					templateUrl: 'app/main/catalogs/sub-modules/catalog-models/details/catalog-models-details.html',
					controller: 'modelsDetailsController as vm'
				}
			},
			resolve: {
				articlesModel: function ($q, catalogFactory, api) {
					var modelsArticlesModel = api.catalogs.modelArticles;
					var deferred = $q.defer();
					var activeCatalog = catalogFactory.getActiveCatalog();
					catalogFactory.createArticleModel(activeCatalog, undefined, modelsArticlesModel).then(function (resolvedModel) {
						// we will not display seasonless model attributes in articles list
						angular.forEach(resolvedModel.fields, function (field) {
							if (field.visible && !field.IsSeasonless && field.isDynamicProperty ) {
								field.visible = false;
							}
							if(field.field !== 'Articles') {
								field.creatable = false;
								field.editable = false;
							}
						});
						deferred.resolve(resolvedModel);
					});
					return deferred.promise;
				},

				catalogSpecificArticlesModel : function(catalogFactory, $q) {
					var activeCatalog = catalogFactory.getActiveCatalog();
					return (function ($q) {
							if(catalogFactory.isActiveCatalogInitialized()) {
									return $q.when();
							} else {
									return catalogFactory.setActiveCatalogDetails();
							}
					})($q).then(function() {
						return catalogFactory.createArticleModel(activeCatalog);
					});
				}
			},
			data: {
				parentState: 'app.catalog-models',
				displayName: 'MODELS.TABS.MODEL'
			},
			// only users with following accessPrivileges in their role access list can access this route
			// accessPrivileges: ['GetAssignAllocationGroupsToCustomerDetails']
			accessInfo: {
				accessPrivileges: ['GetCatalogTrueModelDetails']
			}
		});

		// Translation
		$translatePartialLoaderProvider.addPart('app/main/catalogs/sub-modules/catalog-models');

		// Navigation
		msNavigationServiceProvider.saveItem('catalogs.catalog-models', {
			title: 'Catalog Models',
			icon: 'icon-android-studio',
			state: 'app.catalog-models',
			translate: 'MODELS.NAV',
			weight: 29,
			// accessPrivileges: ['GetCatalogTrueModels']
			// accessPrivileges: ['nav_models'],
			accessInfo: {
				accessPrivileges: ['nav_models']
			}
		});
	}

})();
(function () {
	'use strict';

	angular
		.module('app.main.catalogs.models')
		.controller('createCatalogModelsController', createCatalogModelsController);

	/* @ngInject */
	function createCatalogModelsController($mdDialog, $scope, $filter, scope, toast, hotkeys, $log, $translate,
		api, utility, editMode, model, record, parentId, existingRecordsForUniqueValue, lookupExtras, event, lookupPromises, $mdConstant, catalogFactory, mockFactory, crud) {
		var vm = this;

		vm.visibleFields = [];
		vm.isLoading = false;
		vm.model = model;
		vm.record = angular.copy(record);
		vm.filterExpression = { creatable: true };
		vm.isNew = false;
		vm.isDataDirty = false;
		vm.maxTags;
		vm.ErrorMessage = "";
		vm.colors = [];
		vm.randomColorForFavoriteTag = '';
		// model number field will be creatable
		vm.isAutomaticNumberingEnabled = catalogFactory.getAutomaticNumbering();

		vm.dependingAttributesMap = [];
		vm.criteriaDeptAttributeMap = {};
		vm.vettingListCriteriaList = [];
		vm.criteriaV2Map = {}; // AttributeSystemName -> parsed CriteriaV2 rules array (preferred over OLD Criteria)

		vm.acSelectedItem = [];
		vm.acSearchText = [];
		vm.searchText = {};
		vm.tagSeperatorKeys = {};
		vm.existingRecordsForUniqueValue = [];
		vm.isNew = !editMode;
		if (!vm.record) {
			//Create empty object
			vm.record = {};
			vm.isNew = true;
		}
		vm.isModelFromSeller = true;
		vm.enteredValidModelNumber = '';
		vm.avaialableModels = [];
		var validSellerLookupsDestinationAttributesMap = api.validSellerLookupsDestinationAttributesMap;
		vm.lookupSourceAndDeptAttributeMap = {};
		vm.showColorTypeInColorPalatteDropdown = api.showColorTypeInColorPalatteDropdown
		var dataSourceTypeId = catalogFactory.getActiveCatalogDetails().DataSourceTypeId;

		vm.saveRecord = saveRecord;
		vm.closeDialog = closeDialog;

		vm.lookupSearch = lookupSearch;
		vm.lookupChange = lookupChange;
		vm.customLookupChange = customLookupChange;
		vm.getLookupDisplayValue = getLookupDisplayValue;
		vm.getCustomLookupDisplayValue = getCustomLookupDisplayValue;
		vm.selectText = selectText;
		vm.colorPaletteLookupChange = colorPaletteLookupChange;

		vm.transformChip = transformChip;
		vm.acQuerySearch = acQuerySearch;
		vm.getChipDisplayValue = getChipDisplayValue;
		vm.add = add;

		vm.isInputRequired = isInputRequired;
		vm.getDateObj = getDateObj;
		vm.validateTxPattern = validateTxPattern;
		vm.getConditionalVettingList = getConditionalVettingList;
		vm.multiValueQuerySearch = multiValueQuerySearch;
		vm.validateJSON = validateJSON;
		vm.onToggleChange = onToggleChange;
		vm.colorDependentCriteriaAttributeChanged = colorDependentCriteriaAttributeChanged;
		vm.lookupSourceAttributeChanged = lookupSourceAttributeChanged;
		vm.isFormValid = isFormValid;
		vm.handleFieldChange = handleFieldChange;
		vm.onSearchTextChanged = onSearchTextChanged;

		activate();

		////////////////

		function activate() {
			vm.visibleFields = getVisibleFields(vm.model);
			populateDefaultValues();
			vm.filteredVisibleFields = angular.copy(vm.visibleFields)
			//Hotkeys
			hotkeys.bindTo($scope)
				.add({
					combo: 'ctrl+enter',
					description: $filter('translate')('ACTIONS.SAVE'),
					allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
					callback: function (event) {
						if (!vm.isLoading && !vm.editForm.$invalid) {
							vm.saveRecord();
						}
					}
				});

			if (vm.isNew) {
				hotkeys.bindTo($scope)
					.add({
						combo: 'ctrl+shift+enter',
						description: $filter('translate')('ACTIONS.SAVE_AND_NEW'),
						allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
						callback: function (event) {
							if (!vm.isLoading && !vm.editForm.$invalid) {
								vm.saveRecord(true);
							}
						}
					});
			}
		}

		//On addition of new tag it validates that the tag should not contain pipe
		function add(chip, chips, field) {
			if (chip) {
				if (chip.indexOf(field.tagSeparator) !== -1) {
					vm.record[field.field].splice(vm.record[field.field].indexOf(chip), 1);
					vm.record[field.field] = vm.record[field.field].concat(chip.split(field.tagSeparator));
					vm.maxTags = vm.record[field.field].length + 1;
				} else {
					vm.maxTags = field.maxLen;
				}
			}
			//for displaying error message
			if (angular.isDefined(field.maxLen) && vm.maxTags != field.maxLen) {
				vm.ErrorMessage = field.validation.messages.pattern;
				return true;
			} else {
				vm.ErrorMessage = "";
				return false;
			}
		}

		function saveRecord() {
			vm.isLoading = true;

			//Transform the fields of type dateUTC
			angular.forEach(vm.model.fields, function (itm) {
				//To avoid date-option and datetime timezone issue
				if ((itm.inputType === 'date-utc' || itm.inputType === 'date-option' || itm.inputType === 'date') && angular.isDefined(vm.record[itm.field]) && angular.isDate(vm.record[itm.field])) {
					var d = vm.record[itm.field];
					vm.record[itm.field] = new Date(d.setHours(12 - (d.getTimezoneOffset() / 60), 0, 0));
				}

				if (itm.inputType === 'calculated') {
					delete vm.record[itm.field];
				}

				if ((itm.inputType === 'articlenumber' || itm.inputType === 'modelnumber') && angular.isDefined(vm.record[itm.field]) && vm.record[itm.field] !== null && vm.record[itm.field].toString().length > 0) {
					vm.record[itm.field] = vm.record[itm.field].toString();
				}

				if ((itm.inputType === 'number' || itm.type === 'int') && vm.record[itm.field] != null) {
					vm.record[itm.field] = parseInt(vm.record[itm.field]);
				}

				if ((itm.inputType === 'color-palette') && angular.isDefined(vm.record[itm.field]) && vm.record[itm.field] != null && vm.record[itm.field] !== '' && angular.isObject(vm.record[itm.field])) {
					var key = Object.keys(vm.record[itm.field])[0];
					var val = vm.record[itm.field][key];
					if (typeof val === 'string' && val.includes(':')) {
							val = val.split(':')[1].trim();
					}
					vm.record[itm.field][key] = val;
					vm.record[itm.field] = angular.toJson(vm.record[itm.field]);
				}

				// remove all invisible special characters from strings
				if ((itm.inputType === 'text' || itm.inputType === 'textArea') && vm.record[itm.field] != null && vm.record[itm.field] !== '' && typeof vm.record[itm.field] === 'string') {
					vm.record[itm.field] = vm.record[itm.field].replace(/[\u00A0\u00AD\u200B-\u200D\uFEFF\u2028\u2029\u2060]/g, '');
				}

				if ((itm.inputType === 'multi-value' || itm.inputSubType === 'multi-value') && vm.record[itm.field] != null && vm.record[itm.field] !== '' && vm.record[itm.field].length) {
					angular.forEach(vm.record[itm.field], function(value, index) {
						vm.record[itm.field][index] = value.replace(/[\u00A0\u00AD\u200B-\u200D\uFEFF\u2028\u2029\u2060]/g, '');
					})
				}

				// remove seasonless attributes from catalog models request if its from the seller
				if(vm.isModelFromSeller && itm.IsSeasonlessModelAttribute) {
					delete vm.record[itm.field];
				}

				if (itm.inputType === 'dataset' && vm.record[itm.field] != null && vm.record[itm.field] !== '') {
					if(typeof (vm.record[itm.field]) === 'object') {
							vm.record[itm.field] = Object.keys(vm.record[itm.field])[0].toString()
					}
					else {
							vm.record[itm.field] = vm.record[itm.field].toString();
					}
				}

				if(itm.inputType === 'datatable' && vm.record[itm.field] != null && vm.record[itm.field] !== '') {
						vm.record[itm.field] = (typeof vm.record[itm.field] === 'string') ? vm.record[itm.field] : angular.toJson(vm.record[itm.field]);
				}
			});


			var p;
			// remove model id and model number for new model creation when isAutomaticNumberingEnabled
			if(!vm.isModelFromSeller && vm.isAutomaticNumberingEnabled) {
				delete vm.record['ModelId'];
				delete vm.record['ModelNumber'];
			} else if(!vm.isModelFromSeller && !vm.isAutomaticNumberingEnabled) {
				delete vm.record['ModelId'];
			}

			if (!vm.editForm.$invalid) {
				p = vm.model.methods.create(vm.record, parentId, vm.model);

				p.then(function (response) {
					closeDialog(true);
					var toastMessage;
					toastMessage = response.config.method.toUpperCase() === 'POST' ? 'SUCCESS.CREATE': 'SUCCESS.DELETE';
					toast.success(toastMessage, '', '');
				}, function () {
					closeDialog(vm.isDataDirty);
				}).finally(function () {
					vm.isLoading = false;
				});
			} else {
				vm.isLoading = false;
			}
		}

		function closeDialog(saved) {
			$mdDialog.hide(saved);
		}

		function lookupSearch(query, field) {
			var results = [];
			var lookupFilter = angular.isDefined(field.lookupFilter) ? field.lookupFilter : {};
			var predicate = angular.copy(lookupFilter);
			predicate.value = query;
			var lookupModel = api.getModel(field.lookupSource);
			if (lookupModel && angular.isDefined(lookupModel.lookupData) && angular.isDefined(lookupModel.lookupData.data) && lookupModel.lookupData.data.length) {
				results = query ? utility.filterObject(lookupModel.lookupData.data, predicate) : utility.filterObject(lookupModel.lookupData.data, lookupFilter, true);
				// this is to reduce the rendering time. It was very slow and was impacted overall page responsiveness
				// so while displaying we will display only the first 100 records and user can filter with any value
				if(field.isfilterCriteria) {
					// filter article colors based on the color palette conditions
					results = getFilteredCriteriaValues(results)
				}
				if(results.length > 100) {
					field['isAboveDropDownLimit'] = true;
					return results.slice(0, 100);
				} else {
					field['isAboveDropDownLimit'] = false;
					return results;
				}
			}
			else {
				return lookupPromises[field.field].then(function (lookupData) {
					results = query ? utility.filterObject(lookupData.data, predicate) : utility.filterObject(lookupData.data, lookupFilter, true);
					// this is to reduce the rendering time. It was very slow and was impacted overall page responsiveness
					// so while displaying we will display only the first 100 records and user can filter with any value
					if(field.isfilterCriteria) {
						// filter article colors based on the color palette conditions
						results = getFilteredCriteriaValues(results)
					}
					if(results.length > 100) {
						field['isAboveDropDownLimit'] = true;
						return results.slice(0, 100);
					} else {
						field['isAboveDropDownLimit'] = false;
						return results;
					}
				});
			}
		}

		function getFilteredCriteriaValues(colors) {
			var results = [];
			angular.forEach(colors, function(color) {
					// conditions inside one criteria are AND'ed, several criteria on the same palette are OR'ed
					var match = utility.matchesColorCriteria(utility.normalizeColorCriteria(color.ColorCriteria), getCriteriaRecordValue);
					if(match.isMatch) {
							flagColorDeptAttributes(match.matchedAttributes);
							results.push(color);
					}
			});
			return results;
		}

		function getCriteriaRecordValue(attributeSystemName) {
			return vm.record[attributeSystemName];
		}

		// mark the attributes the matched criteria depends on, so changing one clears the selected color
		function flagColorDeptAttributes(attributeSystemNames) {
			angular.forEach(attributeSystemNames, function(attributeSystemName) {
					var colorDeptAttributeField = utility.filterObject(vm.visibleFields, {field: attributeSystemName}, true)[0];
					if(angular.isDefined(colorDeptAttributeField)) {
							colorDeptAttributeField.isColorDeptAttribute = true;
					}
			});
		}

		// convert dropdown scope value form object(lookup record) to id property of lookup record
		function lookupChange(selectedObj, field, fieldObject) {
			if (angular.isObject(selectedObj)) {
				vm.record[field] = selectedObj.id;
				if(field === 'ModelId') {
					vm.record['ModelNumber'] = selectedObj.value;
					vm.record['ModelName'] = selectedObj.ModelName;
				}
				// load data from server based on the lockup value
				if (angular.isDefined(fieldObject.validation.onChangeLookUp) && fieldObject.validation.onChangeLookUp.length > 0) {
					var lookUpChangeValues = utility.splitString(fieldObject.validation.onChangeLookUp, ',');
					if (angular.isDefined(lookupExtras[lookUpChangeValues[0]])) {
						lookupExtras[lookUpChangeValues[0]][lookUpChangeValues[1]] = selectedObj.id;
					}
					lookupPromises[field] = crud.createLookupPromise(vm.model, lookupExtras, 'create');
				}
			}
			else if (angular.isUndefined(selectedObj) || selectedObj === null) {
				if(field === 'ModelId') { // when model id is not selected
					vm.record[field] = undefined; // on record removal make field undefined or the property can be deleted using delete keywork
					vm.record['ModelName'] = '';
				} else { // for other fields
					vm.record[field] = undefined;
				}
			}
		}

		function customLookupChange(selectedObj, field) {
			if (angular.isObject(selectedObj)) {
				vm.record[field.field] = selectedObj[field.customLookupInfo.value];
			}
			else if (angular.isUndefined(selectedObj) || selectedObj === null) {
				vm.record[field.field] = undefined; // on record removal make field undefined or the property can be deleted using delete keywork
			}
		}

		function colorPaletteLookupChange(selectedObj, field) {
			if(angular.isObject(selectedObj) && Object.keys(selectedObj)[0] != null && angular.isDefined(selectedObj.value)) {
					// color palette values are stores as key value pair
					var objectVal = {};
					objectVal[selectedObj.id] = selectedObj.value
					vm.record[field.field] = objectVal;
			}
			else if(angular.isUndefined(selectedObj) || selectedObj === null){
					vm.record[field.field] = undefined; // on record removal make field undefined or the property can be deleted using delete keywork
			}
		}

		// isArticleNumberType for converting article id from string to int
		function getLookupDisplayValue(item, field, isArticleNumberType) {
			var lookupModel = api.getModel(field.lookupSource);
			item = isArticleNumberType ? parseInt(item) : item;

			if (angular.isDefined(lookupModel.lookupData) && angular.isDefined(lookupModel.lookupData.data) && lookupModel.lookupData.data.length) {
				return getLookupDisplayVal(item, lookupModel.lookupData);
			}
			else {
				return lookupPromises[field.field].then(function (lookupData) {
					return getLookupDisplayVal(item, lookupData);
				});
			}
		}

		function getCustomLookupDisplayValue(item, field) {
			//  show only color name for color palette attributes
			if(field.inputType === 'color-palette') {
				return $filter('colorPaletteRenderer')(item, field);
			} else {
				var lookupModel = api.getModel(field.lookupSource);

				if (angular.isDefined(lookupModel.lookupData) && angular.isDefined(lookupModel.lookupData.data) && lookupModel.lookupData.data.length) {
					return getCustomLookupDisplayVal(item, lookupModel.lookupData, field);
				}
				else {
					return lookupPromises[field.field].then(function (lookupData) {
						return getCustomLookupDisplayVal(item, lookupData, field);
					});
				}
			}
		}

		//helper method
		function getLookupDisplayVal(item, lookupData) {
			var result;
			if (lookupData) {
				// since autocomplte return object
				if (angular.isObject(item)) {
					result = utility.filterObject(lookupData.data, { id: item.id }, true);
				}
				// to initialize field value if any (when open update record dialog)
				else {
					result = utility.filterObject(lookupData.data, { id: item }, true);
				}

				if (angular.isArray(result) && result.length > 0) {
					return result[0].value;
				}
				else {
					return result.value;
				}
			}
		}

		function getCustomLookupDisplayVal(item, lookupData, field) {
			var result;
			var predicate = {};
			if (lookupData) {
				// since autocomplete return object
				if (angular.isObject(item)) {
					predicate[field.customLookupInfo.value] = item[field.customLookupInfo.value];
					result = utility.filterObject(lookupData.data, predicate, true);
				}
				// to initialize field value if any (when open update record dialog)
				else {
					predicate[field.customLookupInfo.value] = item;
					result = utility.filterObject(lookupData.data, predicate, true);
				}

				if (angular.isArray(result) && result.length > 0) {
					return result[0].value;
				}
				else {
					return result.value;
				}
			}
		}

		function selectText(event) {
			utility.selectInputText(event);
		}

		function transformChip(chip, isMultiValue) {
			if (angular.isObject(chip)) {
				return chip.id;
			} else if (isMultiValue) {
				return chip;
			}
			return undefined;
		}

		function acQuerySearch(query, selectedRecords, field) {
			var results = [];
			var lookupFilter = angular.isDefined(field.lookupFilter) ? field.lookupFilter : {};
			var predicate = angular.copy(lookupFilter);
			predicate.value = query;

			var lookupModel = api.getModel(field.lookupSource);
			if (angular.isDefined(lookupModel.lookupData) && angular.isDefined(lookupModel.lookupData.data) && lookupModel.lookupData.data.length) {
				results = query ? utility.filterObject(lookupModel.lookupData.data, predicate) : utility.filterObject(lookupModel.lookupData.data, lookupFilter);
				results = removeSelectedChips(selectedRecords, results);
				results;
			}
			else {
				lookupPromises[field.field].then(function (lookupData) {
					results = query ? utility.filterObject(lookupData.data, predicate) : utility.filterObject(lookupData.data, lookupFilter);
					results = removeSelectedChips(selectedRecords, results);
					results;
				});
			}
			return results;
		}

		/**
		* @description
		* This method will remove selected chips form records (helper method)
		* @param {array} selectedRecords: list of selected chips
		* @param {array} records: data property of lookup-data
		* @returns {array}: list of available chips (chips which are not selected) // it does not really need to return a value but for readability returning modified value
		*/
		function removeSelectedChips(selectedRecords, records) {
			if (angular.isDefined(selectedRecords) && selectedRecords != null && selectedRecords.length > 0) {
				for (var index = records.length - 1; index >= 0; index--) {
					if (selectedRecords.indexOf(records[index].id) !== -1) {
						records.splice(index, 1);
					}
					if (selectedRecords.indexOf(records[index]) !== -1) {
						records.splice(index, 1);
					}
				}
			}
			return records;
		}

		function getChipDisplayValue(chip, field) {
			var lookupModel = api.getModel(field.lookupSource);
			if (angular.isDefined(lookupModel.lookupData) && angular.isDefined(lookupModel.lookupData.data) && lookupModel.lookupData.data.length) {
				return getChipDisplayVal(lookupModel.lookupData, chip);
			}
			else { // it will never go to else part since before try to load display value for selected chips, it always load lookup on focus of chips input element
				return lookupPromises[field.field].then(function (lookupData) {
					return getChipDisplayVal(lookupData, chip);
				});
			}
		}

		//helper method
		function getChipDisplayVal(lookupData, chip) {
			var res = utility.filterObject(lookupData.data, { id: chip }, true);
			if (angular.isArray(res) && res.length > 0) {
				return res[0].value;
			}
			else {
				$log.warn('viewCreator controller: Unable to resolve chip display value!');
				return "";
			}
		}

		function isInputRequired(field) {
			if (angular.isString(field.validation.isRequired)) {
				return (scope.$eval(field.validation.isRequired) && (angular.isUndefined(field.validation.disabledCriteria) || !scope.$eval(field.validation.disabledCriteria)));
			} else {
				return (field.validation.isRequired && (angular.isUndefined(field.validation.disabledCriteria) || !scope.$eval(field.validation.disabledCriteria)));
			}
		}

		function getDateObj(dateString, fromUTC) {
			if (dateString) {
				return utility.createDateObject(dateString, fromUTC);
			}
		}

		function validateTxPattern(field) {
				var validationExpression = utility.isValidJSON(field.validation['tx-pattern']);
				if(validationExpression && angular.isDefined(validationExpression.F) && validationExpression.F.length > 0) {
						var parsedExpressionObjects = validationExpression.F;
						vm.isValidValue = true;
						angular.forEach(parsedExpressionObjects, function(parsedExpressionObject) {
								if(vm.isValidValue) {
										// skip validating overridable attribute with parent attributes for master catalog
										if(angular.isDefined(parsedExpressionObject['SourceField']) && (dataSourceTypeId === 1 && field.Overridable && !parsedExpressionObject['SourceField'].startsWith('#')) || (dataSourceTypeId === 3)) {
												// if SourceValueRequired is true then the source field should be required for this attribute to have value
												if(parsedExpressionObject['SourceValueRequired']) {
														if(vm.record[parsedExpressionObject['SourceField']] !== '' && vm.record[parsedExpressionObject['SourceField']] != null) {
																setAttributeFieldValidity(field, parsedExpressionObject);
														} else if(vm.record[field.field] !== '' && vm.record[field.field] != null) {
																vm.editForm[field.field].$setValidity('pattern', false);
																vm.editForm[field.field].$touched = true;
																if(angular.isDefined(parsedExpressionObject.Message)) {
																		field.validation.messages.pattern = parsedExpressionObject.Message;
																}
																vm.isValidValue = false;
														}
												} else {
														if(vm.record[parsedExpressionObject['SourceField']] !== '' && vm.record[parsedExpressionObject['SourceField']] != null
																&& vm.record[field.field] !== '' && vm.record[field.field] != null && parsedExpressionObject['SourceField'] !== 'ShipmentStartDate' && parsedExpressionObject['SourceField'] !== 'ShipmentEndDate') {
																setAttributeFieldValidity(field, parsedExpressionObject);
														} else if((parsedExpressionObject['SourceField'] === 'ShipmentStartDate' || parsedExpressionObject['SourceField'] === 'ShipmentEndDate') && (vm.record['RetailIntroMonth'] != null && vm.record['RetailIntroMonth'] !== '') && (vm.record['RetailExitMonth'] != null && vm.record['RetailExitMonth'] !== '') && vm.record[field.field] !== '' && vm.record[field.field] != null) {
																// get the data from the mapped retail window and validate
																var retailWindowDataList = api.getModel('catalogs.retailExitMonthsForArticle').lookupData.data;
																var mappedRetailWindow = utility.filterObject(retailWindowDataList, {id: vm.record['RetailExitMonthId']}, true)[0];
																if(angular.isDefined(mappedRetailWindow)) {
																		vm.record['ShipmentStartDate'] = mappedRetailWindow.ShipmentStartDate;
																		vm.record['ShipmentEndDate'] = mappedRetailWindow.ShipmentEndDate;
																		setAttributeFieldValidity(field, parsedExpressionObject);
																}
														}
														else if(vm.editForm[field.field]) {
																vm.editForm[field.field].$setValidity('pattern', true);
																vm.editForm[field.field].$touched = true;
														}
												}
										}
										if(angular.isUndefined(parsedExpressionObject['SourceField']) && angular.isDefined(parsedExpressionObject['Expression']) && angular.isDefined(parsedExpressionObject['ExpressionValue'])) {
												if(vm.record[field.field] !== '' && vm.record[field.field] != null) {
														setAttributeFieldValidity(field, parsedExpressionObject, true);
												}
												else if(vm.editForm[field.field]) {
														vm.editForm[field.field].$setValidity('pattern', true);
												}
										}
								}
						});
				}
		}

		function setAttributeFieldValidity(field, parsedExpressionObject, isExpressionValidation) {
				var valid = validateExpression(field, parsedExpressionObject, isExpressionValidation);
				if(!valid) {
						if(angular.isDefined(vm.editForm[field.field])) {
								vm.editForm[field.field].$setValidity('pattern', false);
								vm.editForm[field.field].$touched = true;
								if(angular.isDefined(parsedExpressionObject.Message)) {
										field.validation.messages.pattern = parsedExpressionObject.Message;
								}
								vm.isValidValue = false;
						}
				} else {
						if(angular.isDefined(vm.editForm[field.field])) {
								vm.editForm[field.field].$setValidity('pattern', true);
								vm.editForm[field.field].$touched = true;
						}
				}
		}

		function validateExpression(field, parsedExpressionObject, isExpressionValidation) {
				var Expression = parsedExpressionObject.Expression;
				var SourceField = parsedExpressionObject.SourceField;
				var currentAttributeValue = vm.record[field.field];
				var sourceAttributeValue = !isExpressionValidation ? vm.record[SourceField] : parsedExpressionObject.ExpressionValue;

				//Transform the date fields to type dateUTC
				angular.forEach(vm.model.fields, function(itm) {
						if(itm.field === field.field || itm.field === SourceField) {
								// for date fields
								if ((itm.inputType === 'date-utc' || itm.inputType === 'date-option' || itm.inputType === 'date-without-time' || itm.inputType === 'date')) {
										if(itm.field === field.field) {
												currentAttributeValue = new Date(vm.record[itm.field]);
												currentAttributeValue = currentAttributeValue.setHours(0,0,0,0);
												if(isExpressionValidation) {
														sourceAttributeValue = new Date(sourceAttributeValue)
														sourceAttributeValue = sourceAttributeValue.setHours(0,0,0,0);
												}
										} else if(itm.field === SourceField) {
												sourceAttributeValue = new Date(vm.record[itm.field]);
												sourceAttributeValue = sourceAttributeValue.setHours(0,0,0,0);
										}
								}
								// for text input types
								if (itm.inputType === 'textArea' || itm.inputType === 'text' || (angular.isDefined(itm.type) && itm.type === 'text' && itm.inputType === 'list')) {
										if(itm.field === field.field) {
												currentAttributeValue = vm.record[itm.field].toUpperCase();
													if(isExpressionValidation) {
														sourceAttributeValue = sourceAttributeValue.toString().toUpperCase();
												}
										} else if(itm.field === SourceField) {
												sourceAttributeValue = vm.record[itm.field].toUpperCase();
										}
								}
						}
				});

				if(dataSourceTypeId === 3 && field.Overridable) {
						if(field.inputType === 'textArea' || field.inputType === 'text' || (angular.isDefined(field.type) && field.type === 'text' && field.inputType === 'list')) {
								sourceAttributeValue = vm.record[SourceField].toUpperCase();
						}

						// for date fields
						if ((field.inputType === 'date-utc' || field.inputType === 'date-option' || field.inputType === 'date-without-time' || field.inputType === 'date')) {
								sourceAttributeValue = new Date(vm.record[SourceField]);
								sourceAttributeValue = sourceAttributeValue.setHours(0,0,0,0);
						}
				}

				var isValid = false;
				switch(Expression) {
						case '<':
								isValid = currentAttributeValue < sourceAttributeValue ? true : false;
								break;
						case '>':
								isValid = currentAttributeValue > sourceAttributeValue ? true : false;
								break;
						case '<=':
								isValid = currentAttributeValue <= sourceAttributeValue ? true : false;
								break;
						case '>=':
								isValid = currentAttributeValue >= sourceAttributeValue ? true : false;
								break;
						case '=':
								isValid = currentAttributeValue === sourceAttributeValue ? true : false;
								break;
						case '!=':
								isValid = currentAttributeValue !== sourceAttributeValue ? true : false;
								break;
				}
				return isValid;
		}

		function getConditionalVettingList(field) {
			var attribute = field.field;
			// CriteriaV2 (preferred): dropdown = matched rule's AllowedValues ([] when no rule matches)
			if (vm.criteriaV2Map[attribute]) {
				var getDependentValueForCriteriaV2 = function(dependentField) {
					var depVal = vm.record[dependentField];
					return (depVal && typeof depVal === 'object') ? (angular.isDefined(depVal.value) ? depVal.value : depVal) : depVal;
				};
				var criteriaV2Allowed = utility.getCriteriaV2AllowedValues(vm.criteriaV2Map[attribute], getDependentValueForCriteriaV2);
				var criteriaV2AttributeField = utility.filterObject(vm.filteredVisibleFields || vm.visibleFields, { field: attribute }, true)[0];
				if (angular.isDefined(criteriaV2AttributeField)) {
					criteriaV2AttributeField.values = (criteriaV2Allowed || [])
						.map(function(value) { return value.toString().trim(); })
						.sort(function(a, b) { return a.toLowerCase().localeCompare(b.toLowerCase()); });
				}
				return;
			}
			var criteriaObj = {};
			var catalogAttribute = utility.filterObject(catalogFactory.getActiveCatalogDetails().AssignedCatalogAttributes,
					{ AttributeSystemName: attribute }, true)[0];
			var catalogAttributeAllowedValues = (catalogAttribute.AllowedValues || []).map(function (v) {
					return v.toString().toLowerCase()
			})
			angular.forEach(vm.vettingListCriteriaList, function (criteriaAttr) {
				for (var key1 in criteriaAttr) {
					if (criteriaAttr.hasOwnProperty(key1)) {
						if (key1.toLocaleLowerCase() === attribute.toLowerCase()) {
							criteriaObj = criteriaAttr[key1];
							break;
						}
					}
				}
			});

			var validValues = [];
			var noMatch = true
			Object.keys(criteriaObj).forEach(function (key) {
				var item = criteriaObj[key];
				var subItems = Object.keys(item);
				var validItems = 0;
				subItems.forEach(function (key2) {
					if (vm.record.hasOwnProperty(key2) && vm.record[key2] != null && vm.record[key2] !== '') {
						var articleAttributeValue = typeof (vm.record[key2]) === 'object' ?
							angular.isDefined(vm.record[key2]['value']) ? vm.record[key2]['value'] : vm.record[key2] :
							vm.record[key2];
						var isDate = validateDate(articleAttributeValue);
						if (articleAttributeValue != null && articleAttributeValue.toString() != '') {
							noMatch = false;
							var lowerCaseValues = item[key2].map(function (value) {
								return isDate == true ? new Date(value).getTime().toString().toLowerCase() : value.toString().toLowerCase();
							});

							if (isDate == true) {
								if (lowerCaseValues.indexOf(new Date(articleAttributeValue).getTime().toString().toLowerCase()) !== -1) {
									validItems++;
								}
							} else {
								if (lowerCaseValues.indexOf(articleAttributeValue.toString().toLowerCase()) !== -1) {
									validItems++;
								}
							}
						}
					} else {
						validItems++;
					}
				});

				if (subItems.length == validItems && catalogAttributeAllowedValues.indexOf(key.toLowerCase()) !== -1) {
					validValues.push(key);
				}
			});
			var attributeField = utility.filterObject(vm.filteredVisibleFields, { field: attribute }, true)[0];
			if (!noMatch) {
				attributeField.values = (validValues || [])
				.map(function(value) {
					return value.trim();
				})
				.sort(function(a, b) {
					return a.toLowerCase().localeCompare(b.toLowerCase());
				})
			} else {
					attributeField.values = (catalogAttribute.AllowedValues || [])
					.map(function(value) {
						return value.trim();
					})
					.sort(function(a, b) {
						return a.toLowerCase().localeCompare(b.toLowerCase());
					})
			}
		}

		function validateDate(value, formats) {
			if (angular.isUndefined(formats)) {
				formats = [
					moment.ISO_8601
				];
			}
			return moment(value, formats, true).isValid();
		}

		function multiValueQuerySearch(query, selectedItems, field) {
			if (field.isCriteriaAdded) {
				getConditionalVettingList(field);
			}
			var values = field.values;
			var searchQueryResult = [];
			var searchQueryResult = utility.filterObject(values, query);
			if (selectedItems && selectedItems.length > 0) {
				for (var index = searchQueryResult.length - 1; index >= 0; index--) {
					if (selectedItems.indexOf(searchQueryResult[index]) !== -1) {
						searchQueryResult.splice(index, 1);
					}
				}
			}
			return searchQueryResult;
		}

		function validateJSON(field) {
			var valid = utility.isValidJSON(vm.record[field.field]);
			if (valid && utility.isObjectEmpty(JSON.parse(vm.record[field.field]))) {
				valid = false;
			}
			if (valid) {
				if (angular.isDefined(vm.editForm[field.field])) {
					vm.editForm[field.field].$setValidity('checkIfValidJson', true);
				}
			} else {
				if (angular.isDefined(vm.editForm[field.field])) {
					vm.editForm[field.field].$setValidity('checkIfValidJson', false);
				}
			}
		}

		function onToggleChange() {
			vm.record['ModelId'] = undefined;
			vm.record['ModelNumber'] = undefined;
			vm.record['ModelName'] = undefined;
			vm.searchText['ModelId'] = undefined;
		}

		// color palette dependentant attribute change method
		function colorDependentCriteriaAttributeChanged() {
			var colorPaletteAttributes = utility.filterObject(vm.visibleFields, {inputType: 'color-palette'}, true);
			angular.forEach(colorPaletteAttributes, function(colorAttr) {
				vm.record[colorAttr.field] = null;
			});
		}

		/**
		* Enable use Enter and any other seperator key defined on model to be use as a seperator key for chips
		*/
		function updateSperatorKeys(field) {
			vm.tagSeperatorKeys[field.field] = [$mdConstant.KEY_CODE.ENTER];
			if (angular.isDefined(field.tagSeparator)) {
				var aditionalSeperator = field.tagSeparator.charCodeAt();
				if (angular.isDefined(aditionalSeperator) && aditionalSeperator !== 'NaN') {
					vm.tagSeperatorKeys[field.field].push(aditionalSeperator);
				}
			}
		}

		function populateTags(record, field) {
			if(angular.isUndefined(record[field.field]) || record[field.field] === null || record[field.field] === '') {
				record[field.field] = [];
			}
			else if (angular.isDefined(field.tagSeparator)) {
					var stringVal = record[field.field];
					var tagSeparator = field.tagSeparator;
					if(!angular.isArray(stringVal) && stringVal !== null) {
						record[field.field] = stringVal.split(tagSeparator);
					}
			}
			else {
				$log.warn('tagSeparator property is missing in model for ' + field.field);
			}
		}


		function populateDefaultValues() {
			//Populate default values
			for (var i = 0; i < vm.model.fields.length; i++) {
				var field = vm.model.fields[i];
				// if default value assigned then assign it on creation
				var isDefaultValueAssigned = vm.isNew && angular.isDefined(field.DefaultValue) && field.DefaultValue != null && field.DefaultValue !== '' ? true : false;
				if (vm.isNew && (field.editable || field.inputType === 'static') && angular.isDefined(field.fieldDefaultValue)) {
					vm.record[field.field] = field.fieldDefaultValue;
				}

				if (vm.model.fields[i].inputType === 'text' || vm.model.fields[i].inputType === 'textArea') {
					if(angular.isUndefined(vm.record[vm.model.fields[i].field]) && vm.isNew) {
						vm.record[vm.model.fields[i].field] = isDefaultValueAssigned ? vm.model.fields[i].DefaultValue : '';
					}
				}

				else if (vm.model.fields[i].inputType === 'number') {
					if(angular.isUndefined(vm.record[vm.model.fields[i].field]) && vm.isNew) {
						vm.record[vm.model.fields[i].field] = isDefaultValueAssigned ? Number(vm.model.fields[i].DefaultValue) : 0;
					}
				}

				else if (field.inputType === 'lookup-many') {
					vm.record[field.field] = [];
				}

				else if (field.inputType === 'tags') {
					updateSperatorKeys(field);
					populateTags(vm.record, field);
				}

				else if (field.inputType === 'bool') {
					vm.record[field.field] = false;
				}

				//for listing populated values of attributes in active catalog's attributeVettingList
				else if (field.inputType === 'list' || (field.inputType === 'multi-value')) {
					if (vm.isNew || angular.isUndefined(vm.record[field.field])) {
						vm.record[field.field] = (vm.isNew && isDefaultValueAssigned) ? field.DefaultValue : field.type === 'int' ? 0 : '';
					}
					// for multivalue dropdown make the record as array
					if(field.inputType === 'multi-value') {
							if(vm.isNew) {
									vm.record[field.field] = isDefaultValueAssigned ? utility.splitString(field.DefaultValue, '|') : [];
							} else if((!vm.isNew && vm.record[field.field] === null)) {
									vm.record[field.field] = [];
							} if(!vm.isNew) {//Non Removable Existing Chips: send existingRecords only when action is edit and nonRemovableChips is true
								if(angular.isDefined(field.nonRemovableChips) && field.nonRemovableChips === true) {
										vm.existingRecords = angular.copy(vm.record[field.field]);
								}
							}
					}
					var attributes = catalogFactory.getActiveCatalogDetails().AssignedCatalogAttributes;
					if (attributes && attributes.length > 0) {
						angular.forEach(attributes, function (attribute) {
							if (attribute.AttributeSystemName === field.field) {
								field.values = (attribute.AllowedValues || [])
								.map(function(value) {
									return value.trim();
								})
								.sort(function(a, b) {
									return a.toLowerCase().localeCompare(b.toLowerCase());
								})
								// for attribute vetting list criteria — CriteriaV2 preferred over OLD Criteria
								if (field.isDynamicProperty && attribute.CriteriaV2 && attribute.CriteriaV2.length > 0) {
									try {
										vm.criteriaV2Map[attribute.AttributeSystemName] = JSON.parse(attribute.CriteriaV2);
									} catch (error) {
										console.warn(attribute.AttributeDisplayName + " - Attribute CriteriaV2: Invalid JSON Format");
									}
									field.isCriteriaAdded = true;
									var v2DependentDisplayNames = [];
									utility.getCriteriaV2DependentFields(vm.criteriaV2Map[attribute.AttributeSystemName]).forEach(function(depKey) {
										var v2DependentField = utility.filterObject(vm.visibleFields, { field: depKey }, true)[0];
										if (angular.isDefined(v2DependentField)) {
											if (!vm.criteriaDeptAttributeMap[depKey]) {
												vm.criteriaDeptAttributeMap[depKey] = [];
											}
											if (vm.criteriaDeptAttributeMap[depKey].indexOf(attribute.AttributeSystemName) === -1) {
												vm.criteriaDeptAttributeMap[depKey].push(attribute.AttributeSystemName);
											}
											v2DependentField.isDependentAttribute = true;
											v2DependentDisplayNames.push(utility.getAttributeDisplayNameUsingSystemName(catalogFactory.getActiveCatalogDetails().AssignedCatalogAttributes, depKey));
										}
									});
									field.criteriaDisplayMessage = 'Attribute ' + attribute.AttributeDisplayName + ' is dependent on the attribute(s) ' + v2DependentDisplayNames + '.';
								} else if (field.isDynamicProperty && attribute.Criteria.length > 0) {
									// parse json
									try {
										var vettinglistCriteria = JSON.parse(attribute.Criteria);
									} catch (error) {
										console.warn(attribute.AttributeDisplayName + " - Attribute Criteria: Invalid JSON Format");
									}
									var dependentAttributesDisplayNames = [];
									field.isCriteriaAdded = true;
									var dependingAttributes = {};
									var obj2 = {};
									for (var key in vettinglistCriteria) {
										if (vettinglistCriteria.hasOwnProperty(key)) {
											var deptAttr = vettinglistCriteria[key];
											for (var key1 in deptAttr) {
												var obj = {};
												if (deptAttr.hasOwnProperty(key1)) {
													var index = dependentAttributesDisplayNames.indexOf(utility.getAttributeDisplayNameUsingSystemName(catalogFactory.getActiveCatalogDetails().AssignedCatalogAttributes, key1));
													if (index === -1) {
														var dependentAttributeField = utility.filterObject(vm.visibleFields, { field: key1 }, true)[0];
														if (angular.isDefined(dependentAttributeField)) {
															if(!vm.criteriaDeptAttributeMap[key1]) {
																vm.criteriaDeptAttributeMap[key1] = [];
															}
															vm.criteriaDeptAttributeMap[key1].push(attribute.AttributeSystemName);
															dependentAttributesDisplayNames.push(utility.getAttributeDisplayNameUsingSystemName(catalogFactory.getActiveCatalogDetails().AssignedCatalogAttributes, key1));
															dependentAttributeField.isDependentAttribute = true;
														}
													}
													if (obj2[key1]) {
														angular.forEach(deptAttr[key1], function (val) {
															if (obj2[key1][val]) {
																if (obj2[key1][val].indexOf(key)) {
																	obj2[key1][val].push(key);
																}
															} else {
																obj2[key1][val] = [key];
															}
														});
													} else {
														angular.forEach(deptAttr[key1], function (val) {
															obj[val] = [key];
														});
														obj2[key1] = obj;
													}
												}
											}
										}
									}
									dependingAttributes[attribute.AttributeSystemName] = obj2;
									vm.dependingAttributesMap.push(dependingAttributes);
									var obj = {};
									obj[attribute.AttributeSystemName] = vettinglistCriteria;
									vm.vettingListCriteriaList.push(obj);
									var criteriaDisplayMessage = 'Attribute ' + attribute.AttributeDisplayName + ' is dependent on the attribute(s) ' + dependentAttributesDisplayNames + '.';
									field.criteriaDisplayMessage = criteriaDisplayMessage;
								}
							}
						})
					}
				}

				else if (vm.model.modelPath === 'catalogs.linePlanArticles' && field.inputType === 'text' && field.field.toLowerCase() === 'article_type') {
					if (vm.isNew) {
						vm.record[field.field] = 'new';
					}
					field.validation.disabledCriteria = true;
				}

				else if (field.inputType === 'int-bool') {
					vm.record[field.field] = '0';
				}

				else if (field.inputType === 'bool-int') {
					vm.record[field.field] = 0;
				}

				else if(vm.model.fields[i].inputType === 'bool-str') {
					if(angular.isUndefined(vm.record[vm.model.fields[i].field])) {
						vm.record[vm.model.fields[i].field] = isDefaultValueAssigned ? vm.model.fields[i].DefaultValue.toLowerCase() : 'false';
					}
				}

				else if (field.inputType === 'date' || field.inputType === 'date-option') { // workaround for issue with interpolation on ng-disabled on md-datepicker
					if(angular.isUndefined(vm.record[field.field]) && isDefaultValueAssigned) {
						vm.record[field.field] = utility.formatDate(new Date(field.DefaultValue), 'yyyy-MM-dd');
					}
					if ($scope.$eval(field.validation.disabledCriteria) || (field.showInEdit && !field.editable)) {
						//vm.disableDate =  true;
						field.validation.disabled = true;
					} else {
						field.validation.disabled = false;
					}
				}
				else if (field.inputType === 'date-utc') { // workaround for issue with interpolation on ng-disabled on md-datepicker
					if ($scope.$eval(field.validation.disabledCriteria) || (field.showInEdit && !field.editable)) {
						//vm.disableDateUTC =  true;
						field.validation.disabled = true;
					} else {
						field.validation.disabled = false;
					}
				}
				else if (field.inputType === 'date-without-time') { // workaround for issue with interpolation on ng-disabled on md-datepicker
					if(angular.isUndefined(vm.record[field.field]) && isDefaultValueAssigned) {
						vm.record[field.field] = utility.formatDate(new Date(field.DefaultValue), 'yyyy-MM-dd');
					}
					if ($scope.$eval(field.validation.disabledCriteria) || (field.showInEdit && !field.editable)) {
						field.validation.disabled = true;
					} else {
						field.validation.disabled = false;
					}
				}
				else if (field.inputType === 'calculated') { // calculated fields are neither creatable nor editable
					field.creatable = false;
					field.editable = false;
				}
				else if (field.inputType === 'color') {
					vm.colors = mockFactory.getFavoritesColors();
					if (vm.isNew) {
						// assign color based on index when creating new favorite tag
						vm.randomColorForFavoriteTag = vm.colors[existingRecordsForUniqueValue.length % vm.colors.length];
					}
				}

				else if (field.inputType === 'color-picker') {
					vm.record[field.field] = '#969696';
				}

				else if(vm.model.fields[i].inputType === 'decimal') {
					if(angular.isUndefined(vm.record[vm.model.fields[i].field])) {
						vm.record[vm.model.fields[i].field] = isDefaultValueAssigned ? Number(vm.model.fields[i].DefaultValue) : 0;
					}
				}

				else if (field.inputType === 'lookup-table') {
					field.isLookupAdded = true;
					if (angular.isDefined(validSellerLookupsDestinationAttributesMap[field.field])) {
							var attributeLookupValues = validSellerLookupsDestinationAttributesMap[field.field];
							var sourceAttributesDisplayNames = [];
							var matched = false;
							for (var j = 0; j < attributeLookupValues.length; j++) {
									var allAttributesMatch = true;
								var value = attributeLookupValues[j];
									for (var attributeSystemName in value.Source) {
											if (value.Source.hasOwnProperty(attributeSystemName)) {
												if(vm.record[attributeSystemName] == null || value.Source[attributeSystemName].toString().toLowerCase() !== vm.record[attributeSystemName].toString().toLowerCase()) {
														allAttributesMatch = false;
														break;
												}
											}
									}

									if (allAttributesMatch) {
											if(vm.record[field.field] !== value.Destination[field.field]) {
													vm.record[field.field] = value.Destination[field.field];
											}
											matched = true;
											break;
									}
							}

							// create source attributes map
							if(attributeLookupValues.length) {
									var firstSourceDestinationValue = attributeLookupValues[0];
									for (var attributeSystemName in firstSourceDestinationValue.Source) {
											var index = sourceAttributesDisplayNames.indexOf(utility.getAttributeDisplayNameUsingSystemName(catalogFactory.getActiveCatalogDetails().AssignedCatalogAttributes, attributeSystemName));
											if (index === -1) {
												sourceAttributesDisplayNames.push(utility.getAttributeDisplayNameUsingSystemName(catalogFactory.getActiveCatalogDetails().AssignedCatalogAttributes, attributeSystemName));
													var sourceAttributeField = utility.filterObject(vm.visibleFields, { field: attributeSystemName }, true)[0];
													if (angular.isDefined(sourceAttributeField)) {
															sourceAttributeField.isLookupSourceAttribute = true;
													}
											}
											if (!vm.lookupSourceAndDeptAttributeMap[attributeSystemName]) {
													vm.lookupSourceAndDeptAttributeMap[attributeSystemName] = [];
											}
											if (vm.lookupSourceAndDeptAttributeMap[attributeSystemName].indexOf(field.field) === -1) {
													vm.lookupSourceAndDeptAttributeMap[attributeSystemName].push(field.field);
											}
									}
							}
							if (!matched) {
									vm.record[field.field] = null;
							}
							field.lookupDisplayMessage = 'Attribute ' + field.displayLabel + ' is dependent on the attribute(s) ' + sourceAttributesDisplayNames.join(', ') + '.';
					} else {
						field.lookupDisplayMessage = 'Attribute ' + field.displayLabel + ' does not have any source attribute(s) assigned';
					}
				}

				if (field.checkIfUnique) {
					vm.existingRecordsForUniqueValue = existingRecordsForUniqueValue ? existingRecordsForUniqueValue : [];
				}
			}
		}

		function getVisibleFields(model) {
			return $filter('filterUnion')(model.fields, vm.filterExpression);
		}

		// when lookup source attribute changed
		function lookupSourceAttributeChanged(field) {
			var sourceAttributeName = field.field;
			if (vm.lookupSourceAndDeptAttributeMap.hasOwnProperty(sourceAttributeName)) {
					var dependentAttributeNames = vm.lookupSourceAndDeptAttributeMap[sourceAttributeName];
					for (var i = 0; i < dependentAttributeNames.length; i++) {
							var dependentAttributeName = dependentAttributeNames[i];
							if (angular.isDefined(validSellerLookupsDestinationAttributesMap[dependentAttributeName])) {
									var attributeLookupValues = validSellerLookupsDestinationAttributesMap[dependentAttributeName];
									var matched = false;
									for (var j = 0; j < attributeLookupValues.length; j++) {
											var allAttributesMatch = true;
										var value = attributeLookupValues[j];
											for (var attributeSystemName in value.Source) {
													if (value.Source.hasOwnProperty(attributeSystemName)) {
														if(vm.record[attributeSystemName] == null || value.Source[attributeSystemName].toString().toLowerCase() !== vm.record[attributeSystemName].toString().toLowerCase()) {
																allAttributesMatch = false;
																break;
														}
													}
											}
											if (allAttributesMatch) {
													if(vm.record[dependentAttributeName] !== value.Destination[dependentAttributeName]) {
														vm.record[dependentAttributeName] = value.Destination[dependentAttributeName];
													}
													matched = true;
													break;
											}
									}
									if (!matched) {
											vm.record[dependentAttributeName] = null;
									}
							}
					}
			}
		}

		function isFormValid() {
			var isRequiredFieldsValid = true;
			// check if any required fields are empty
			angular.forEach(vm.visibleFields, function (field) {
				if (field.field !== 'ModelId' && field.field !== 'ModelNumber' && ((vm.isModelFromSeller && !field.IsSeasonlessModelAttribute) || (!vm.isModelFromSeller)) && field.validation && field.validation.isRequired) {
					if (angular.isUndefined(vm.record[field.field]) || vm.record[field.field] === null || vm.record[field.field] === '') {
						isRequiredFieldsValid = false;
					}
				}
			});
			return vm.editForm.$valid && isRequiredFieldsValid;
		}

		function handleFieldChange(field) {
			// Validate tx-pattern
			if (field.validation['tx-pattern'] && vm.currentFocusedField === field.field) {
					vm.validateTxPattern(field);
			}

			if (field.isColorDeptAttribute) {
					vm.colorDependentCriteriaAttributeChanged(field);
			}

			// Handle lookup source attribute changes
			if (field.isLookupSourceAttribute) {
					vm.lookupSourceAttributeChanged(field);
			}

			// if this attribute is a dependant attribute of any criteria attribute revalidat the values of criteria attributes
			var dependentAttributeField = field.field;
			if(vm.criteriaDeptAttributeMap[dependentAttributeField]) {
				var criteriaAttributes = vm.criteriaDeptAttributeMap[dependentAttributeField];
				angular.forEach(criteriaAttributes, function(criteriaAttribute) {
						var criteriaField = utility.filterObject(vm.visibleFields, { field: criteriaAttribute }, true)[0];
						if (!criteriaField) { return; } // target criteria attribute isn't a field in this dialog -> nothing to refresh/clear
						var isMultiValueAttribute = (criteriaField.inputType === 'multi-value') ? true : false;
						// CriteriaV2 (preferred): refresh dropdown + clear current value if not in matched rule's AllowedValues
						if(vm.criteriaV2Map[criteriaAttribute]) {
								getConditionalVettingList(criteriaField);
								var getDependentValueForCriteriaV2 = function(dependentField) {
										var depVal = vm.record[dependentField];
										return (depVal && typeof depVal === 'object') ? (angular.isDefined(depVal.value) ? depVal.value : depVal) : depVal;
								};
								var criteriaV2AllowedLower = utility.getCriteriaV2AllowedValues(vm.criteriaV2Map[criteriaAttribute], getDependentValueForCriteriaV2)
										.map(function(value) { return value.toString().toLowerCase(); });
								var currentCriteriaValue = vm.record[criteriaAttribute];
								var isCriteriaV2Valid;
								if (isMultiValueAttribute) {
										isCriteriaV2Valid = (Array.isArray(currentCriteriaValue) && currentCriteriaValue.length > 0)
												? currentCriteriaValue.every(function(value) { return criteriaV2AllowedLower.indexOf((value == null ? '' : value).toString().toLowerCase()) !== -1; })
												: true;
								} else {
										isCriteriaV2Valid = (currentCriteriaValue === null || currentCriteriaValue === undefined || currentCriteriaValue === '')
												? true
												: criteriaV2AllowedLower.indexOf(currentCriteriaValue.toString().toLowerCase()) !== -1;
								}
								if (!isCriteriaV2Valid) {
										vm.record[criteriaAttribute] = isMultiValueAttribute ? [] : null;
										vm.editForm[criteriaAttribute].$touched = true;
								}
								return; // skip OLD criteria path
						}
						var attributeCriteria = {};
						angular.forEach(vm.dependingAttributesMap, function(criteriaAttr) {
								for(var key in criteriaAttr) {
										if(criteriaAttr.hasOwnProperty(key)) {
												if(key.toLocaleLowerCase() === criteriaAttribute.toLowerCase()) {
														attributeCriteria = criteriaAttr[key];
														break;
												}
										}
								}
						});
						if(angular.isDefined(attributeCriteria[dependentAttributeField][vm.record[dependentAttributeField]])) {
								var index = attributeCriteria[dependentAttributeField][vm.record[dependentAttributeField]].indexOf(vm.record[criteriaAttribute]);
								if (index === -1) {
										vm.record[criteriaAttribute] = isMultiValueAttribute ? [] : null;
										vm.editForm[criteriaAttribute].$touched = true;
								}
						} else {
								vm.record[criteriaAttribute] = isMultiValueAttribute ? [] : null;
								vm.editForm[criteriaAttribute].$touched = true;
						}
				});
			}
		}

		function onSearchTextChanged() {
			if (!vm.searchPageText) {
				vm.filteredVisibleFields = angular.copy(vm.visibleFields);
					return;
			}

			vm.filteredVisibleFields = vm.visibleFields.filter(function(item) {
					if (!item || !item.displayLabel) return false;

					var translatedLabel = $translate.instant(item.displayLabel);
					return translatedLabel.toLowerCase().indexOf(vm.searchPageText.toLowerCase()) !== -1;
			});
		}

	}
})();
(function() {
    'use strict';

    angular
        .module('app.main.catalogs.models.model-sizes', []);
})();
(function() {
	'use strict';

	angular
		.module('app.main.catalogs.models.model-sizes')
		.run(runBlock);

	/* @ngInject */
	function runBlock(api) {
		if (angular.isUndefined(api.catalogs)) {
			api.catalogs = {};
		}
		 api.catalogs.modelSizes = {
			modelPath: 'catalogs.modelSizes',
			fields: [
				{ field: 'SizeIndex', type: 'text', displayLabel: 'SIZES.FIELDS.SIZE_INDEX', visible: true, creatable: false, editable: false, inputType: 'text',
					validation: {isRequired: true, maxLen: 25, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'SizeName', type: 'text', displayLabel: 'SIZES.FIELDS.SIZE_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
					validation: {isRequired: true, maxLen: 50, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'SortOrder', type: 'int', displayLabel: 'SIZES.FIELDS.SORT_ORDER', visible: true, creatable: false, editable: false, inputType: 'number',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
			],
			title: 'SIZES.NAV',
			icon: 'icon-layers',
			idField: 'SizeIndex',
			lookupDisplayField: 'SizeName',
			isDirty: false,
			isCatalogSpecificModel: true,
			methods: {},
			views: {
				mainList: {
					columns         : [ 'SizeName', 'SizeIndex', 'SortOrder'],
					columnFilter    : {},
					toggleFilterProps: {},
					topIndex        : 0,
					showFilterRow   : false,
					sortColumn      : {},
					itemActions     : [],
					listActions     : [],
					fabAction       : {}
				 },
				 mainDetails: {},
				privileges: {
					list    : 'GetCatalogTrueModelDetails'
				}
			}
		};
	}
})();
(function() {
    'use strict';

    angular
        .module('app.main.catalogs.models.model-resources')
        .run(runBlock);

    /* @ngInject */
    function runBlock(api, $state, activityLogger, catalogFactory, crud, utility) {

        if (angular.isUndefined(api.catalogs)) {
            api.catalogs = {};
        }
        api.catalogs.modelResources = {
            modelPath: 'catalogs.modelResources',
            fields: [
                { field: 'ResourceId', type: 'int', displayLabel: 'RESOURCES.FIELDS.RESOURCE_ID', visible: false, creatable: true, editable: false, inputType: 'lookup', lookupSource: 'catalogs.resources',
                    lookupFilter: {Status: 1, IsModelLevel: 1}, validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ResourceId', type: 'int', displayLabel: 'RESOURCES.FIELDS.RESOURCE_ID', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'IsSeasonal', type: 'text', displayLabel: 'RESOURCES.FIELDS.IS_SEASONAL', visible: true, creatable: false, editable: false, inputType: 'bool-int',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ResourceName', type: 'text', displayLabel: 'RESOURCES.FIELDS.RESOURCE_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'TypeId', type: 'text', displayLabel: 'RESOURCES.FIELDS.RESOURCE_TYPE_ID', visible: true, creatable: false, editable: false, inputType: 'lookup', lookupSource: 'lists.resourceTypes',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Status', type: 'text', displayLabel: 'RESOURCES.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedDate', type: 'text', displayLabel: 'RESOURCES.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
            ],
            uniqueConstraints: [],
            title: 'RESOURCES.NAV',
            icon: 'icon-image-filter-black-white',
            idField: 'ResourceId',
            lookupDisplayField: 'ResourceName',
            isDirty: false,
            isCatalogSpecificModel: true,
            methods: {
                getList     : getModelResources,
                activateBulk: unassignResources,
                create      : assignResources
            },
            views: {
                mainList: {
                    columns         : [ 'ResourceName', 'ResourceId', 'IsSeasonal', 'ResourceTypeId', 'Status', 'UpdatedDate' ],
                    columnFilter    : {},
                    topIndex        : 0,
                    showFilterRow   : false,
                    sortColumn      : {'UpdatedDate': false},
                    itemActions     : [
                                        { id: 'view', label: 'ACTIONS.VIEW', icon: 'icon-magnify', privilege: 'GetCatalogModelResourcesList', disabled: '!itm.Status', visible: true },
                                        { id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'AssignResourcesToModel', disabled: false, visible: 'itm.Status',
                                            requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'}
                                      ],
                    listActions     : [
                                        { id: 'delete', label: 'ACTIONS.DELETE_BULK', icon: 'icon-delete', privilege: 'AssignResourcesToModel', disabled: '{selected: true, Status: 1}', visible: true,
                                            requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'}
                                      ],
                    fabAction       : {id: 'add', label: 'ACTIONS.ADD', icon: 'icon-link', privilege: 'AssignResourcesToModel', visible: true}
                 },
                 mainDetails: {},
                privileges: {
                    list    : 'GetCatalogModelResourcesList',
                    details : 'GetCatalogResourceDetails'
                }
            }
        };

        function getModelResources(generalProperties, modelId, catalogId) {
            var promise;

            if(angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
                var state = {};
                state.name = $state.current.name;
                state.params = $state.params;
                var isBulk = true;
                var logData = activityLogger.createLogData(null, state, 'catalogs.modelResources', 'VIEW', isBulk, new Date(), null, null);

                promise = api.webGet(api.baseUrl + '/catalogs/' + catalogId + '/models/' + modelId + '/resources', undefined, true, generalProperties.forceFetch);
                promise = activityLogger.log(logData, promise);
            }
            else {
                promise = api.webGet(api.baseUrl + '/catalogs/' + catalogId + '/models/' + modelId + '/resources', undefined, true, generalProperties.forceFetch);
            }

            return promise;
        }

        function unassignResources(records, assignedResources, model, actionType, parentId, activeCatalogCode) {
            var requestObj = {};
            var itemsNameList = [];
            requestObj[model.idField] = [];
            requestObj[model.idField] = assignedResources.map(function(assignedResource) {
                return assignedResource[model.idField];
            });

            if(!angular.isArray(records)) {
                records = utility.pushItemToArray(records);
            }

            angular.forEach(records, function(recordToBeDeleted) {
                itemsNameList.push(recordToBeDeleted[model.lookupDisplayField]);
                var index = requestObj[model.idField].indexOf(recordToBeDeleted[model.idField]);
                requestObj[model.idField].splice(index,1);
            });

            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var isBulk = itemsNameList.length > 1 ? true : false;
            var logData = activityLogger.createLogData(itemsNameList, state, 'catalogs.modelResources', actionType.toUpperCase(), isBulk, new Date(), null, null);
            var promise = api.webPut(api.baseUrl + '/catalogs/' + activeCatalogCode + '/models/' + parentId + '/assignresources', requestObj);

            promise.then(function() {
                crud.onRecordStatusChange(records, model, actionType);
            });

            return activityLogger.log(logData, promise);
        }

        function assignResources(record, assignedResources) {
            var requestObj = {};
            var assigned = [];
            assigned = assignedResources.map(function(assignedResource) {
                return assignedResource[api.catalogs.modelResources.idField];
            });
            requestObj[api.catalogs.modelResources.idField] = [];
            requestObj[api.catalogs.modelResources.idField] = assigned.concat(record[api.catalogs.modelResources.idField]);

            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var logData = activityLogger.createLogData(record[api.catalogs.modelResources.lookupDisplayField], state, 'catalogs.modelResources', 'ADD', false, new Date(), null, null);
            var promise = api.webPut(api.baseUrl + '/catalogs/' + record.activeCatalogId + '/models/' + record.modelId + '/assignresources', requestObj);

            promise.then(function() {
               api.catalogs.modelResources.isDirty = true;
            });
            return activityLogger.log(logData, promise);
        }
    }
})();
(function() {
		'use strict';

		angular
				.module('app.main.catalogs.models.model-articles', []);
})();
(function() {
	'use strict';

	angular
		.module('app.main.catalogs.models.model-articles')
		.run(runBlock);

	/* @ngInject */
	function runBlock(api, $state, activityLogger, catalogFactory) {

		if (angular.isUndefined(api.catalogs)) {
			api.catalogs = {};
		}
		 api.catalogs.modelArticles = {
			modelPath: 'catalogs.modelArticles',
			fields: [
				{ field: 'Id', map:'Id', type: 'int', displayLabel: 'ARTICLES.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'ArticleNumber', map:'ArticleNumber', type: 'text', displayLabel: 'ARTICLES.FIELDS.ARTICLE_NUMBER', visible: true, creatable: false, editable: false, inputType: 'text',
					validation: {isRequired: true, maxLen: 20, minLen: 1, pattern: '^[^ ]*(?: [^ ]+)* ?$', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: 'VALIDATIONS.WHITE_SPACE_NOT_ALLOWED'}} },
				{ field: 'ArticleName',  map:'ArticleName', type: 'text', displayLabel: 'ARTICLES.FIELDS.MODEL_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
					validation: {isRequired: true, maxLen: 100, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'ModelId', map:'ModelId', type: 'int', displayLabel: 'SELLER_MODELS.FIELDS.MODEL_ID', visible: true, creatable: false, editable: false, inputType: 'number',
					validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'ModelNumber', map:'ModelNumber', type: 'text', displayLabel: 'SELLER_MODELS.FIELDS.MODEL_NUMBER', visible: true, creatable: false, editable: false, inputType: 'text',
					validation: {isRequired: true, maxLen: 200, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'Status',  map:'Status', type: 'text', displayLabel: 'ARTICLES.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'CreatedDate',  map:'CreatedDate', type: 'text', displayLabel: 'ARTICLES.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'UpdatedDate',  map:'UpdatedDate', type: 'text', displayLabel: 'ARTICLES.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'Articles', type: 'text', displayLabel: 'MODELS.FIELDS.ARTICLES', visible: false, creatable: true, editable: true, inputType: 'lookup-many', lookupSource:'lists.availableCatalogModelArticles',
					validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'ColorId', type: 'int', displayLabel: 'ARTICLES.FIELDS.COLOR', visible: false, creatable: false, editable: false, inputType: 'lookup', lookupSource: 'lists.sellerColorsFromColorPalette', isfilterCriteria: true,
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				// following fields SizeScaleId, SizeScale properties like creatable visible etc will be set dynamically and they need to remain false in model
				{ field: 'SizeScaleId',  map:'SizeScaleId', type: 'int', displayLabel: 'ARTICLES.FIELDS.SIZE_SCALE_ID', visible: false, creatable: false, editable: false, inputType: 'number',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'SizeScaleId',  map:'SizeScaleId', type: 'int', displayLabel: 'ARTICLES.FIELDS.SIZE_SCALE', visible: false, creatable: false, editable: false, inputType: 'lookup', lookupSource: 'catalogs.sizeScaleGroups',
					validation: {isRequired: true, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'MasterSizeScale', map:'MasterSizeScale', type: 'text', displayLabel: 'SELLER_MODELS.FIELDS.MASTER_SIZE_SCALE', visible: true, creatable: false, editable: false, inputType: 'text',
					validation: {isRequired: true, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'SizeScale',  map:'SizeScale', type: 'text', displayLabel: 'ARTICLES.FIELDS.SIZE_SCALE', visible: false, creatable: false, editable: false, inputType: 'text',
					validation: {isRequired: true, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'MasterSizeScaleId',  map:'MasterSizeScaleId',type: 'int', displayLabel: 'ARTICLES.FIELDS.MASTER_SIZE_SCALE_ID', visible: true, creatable: false, editable: false, inputType: 'number',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				// above fields SizeScaleId, SizeScale properties like creatable visible etc will be set dynamically and they need to remain false in model
				{ field: 'ModelSourceSeason', map:'ModelSourceSeason', type: 'text', displayLabel: 'ARTICLES.FIELDS.SEASON_MODEL_CARRIED_OVER_FROM', visible: true, creatable: false, editable: false, inputType: 'text',
					validation: {isRequired: false, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'ArticleSourceSeason', map:'ArticleSourceSeason', type: 'text', displayLabel: 'ARTICLES.FIELDS.SEASON_ARTICLE_CARRIED_OVER_FROM', visible: true, creatable: false, editable: false, inputType: 'text',
					validation: {isRequired: false, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'ActivationDate', map:'ActivationDate', type: 'text', displayLabel: 'ARTICLES.FIELDS.REACTIVATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'DropDate', map:'DropDate', type: 'text', displayLabel: 'ARTICLES.FIELDS.DROP_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'ModelCreatedDate', map:'ModelCreatedDate', type: 'text', displayLabel: 'ARTICLES.FIELDS.MODEL_CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'ModelDropDate', map:'ModelDropDate', type: 'text', displayLabel: 'ARTICLES.FIELDS.MODEL_DROP_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'ModelActivationDate', map:'ModelActivationDate', type: 'text', displayLabel: 'ARTICLES.FIELDS.MODEL_REACTIVATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'ColorCode',  map:'ColorCode', type: 'int', displayLabel: 'ARTICLES.FIELDS.COLOR_CODE', visible: false, creatable: false, editable: false, inputType: 'number', prefixZeros: 3,
					validation: {isRequired: false, maxLen: -1, minLen: 1, pattern: '^(0*[1-9][0-9]{0,2}|100|999)$', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: 'VALIDATIONS.CODE_POSITIVE_NUMBER'}} },
				{ field: 'ColorName',  map:'ColorName', type: 'text', displayLabel: 'ARTICLES.FIELDS.PRIMARY_COLOR_NAME', visible: false, creatable: false, editable: false, inputType: 'text',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'HexCode',  map:'HexCode', type: 'text', displayLabel: 'ARTICLES.FIELDS.HEXCODE', visible: false, creatable: false, editable: false, inputType: 'color-picker',
					validation: {isRequired: false, maxLen: 7, minLen: 0, pattern: '^#(?:[0-9a-fA-F]{3}){2}$', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: 'COLOR_DEFINITION.VALIDATIONS.INVALID'}} },
				{ field: 'ColorGroup',  map:'ColorGroup', type: 'text', displayLabel: 'ARTICLES.FIELDS.COLOR_GROUP', visible: true, creatable: false, editable: false, inputType: 'text',
					validation: {isRequired: false, maxLen: 250, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'ColorType',  map:'ColorType', type: 'text', displayLabel: 'ARTICLES.FIELDS.COLOR_TYPE', visible: true, creatable: false, editable: false, inputType: 'text',
					validation: {isRequired: false, maxLen: 250, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'ColorAssetId',  map:'ColorAssetId', type: 'text', displayLabel: 'ARTICLES.FIELDS.COLOR_ASSET_ID', visible: true, creatable: false, editable: false, inputType: 'text',
					validation: {isRequired: false, maxLen: 250, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'ColoredUpBy', map:'ColoredUpBy', type: 'text', displayLabel: 'ARTICLES.FIELDS.COLORED_UP_BY', visible: true, creatable: false, editable: false, inputType: 'text',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'ColoredUpDate', map:'ColoredUpDate', type: 'text', displayLabel: 'ARTICLES.FIELDS.COLORED_UP_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
			],
			uniqueConstraints: [],
			title: 'ARTICLES.NAV',
			icon: 'icon-cube-outline',
			idField: 'Id',
			lookupDisplayField: 'ArticleNumber',
			isDirty: false,
			isBulkActionCompleted: false,
			isCatalogSpecificModel: true,
			methods: {
				getList   : getCatalogModelArticles,
				create    : assignCatalogModelArticles
			},
			views: {
				mainList: {
					columns         : [ 'Id', 'ArticleNumber', 'ArticleName', 'ModelNumber' ],
					columnFilter    : {},
					imagesSize      : 'large',
					toggleFilterProps: {},
					topIndex        : 0,
					showFilterRow   : false,
					sortColumn      : {'UpdatedDate': false},
					sortDescending  : true,
					itemActions     : [
						{ id: 'view', label: 'ACTIONS.VIEW', icon: 'icon-magnify', privilege: 'GetCatalogArticleDetails', disabled: false, visible: true }
					],
					listActions     : [],
					fabAction: { id: 'add', label: 'ACTIONS.ASSIGN', icon: 'icon-link', privilege: 'AssignArticlesToCatalogModel', visible: true }
				},
				mainDetails: {
					selectedTabIndex   : 0,
					itemActions        : [],
					fab                 : {}
				},
				privileges: {
					list    : 'GetCatalogModelAssociatedArticles'
				}
			}
		};

		function getCatalogModelArticles(generalProperties, modelId, catalogCode) {
			var promise;

			if(angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
					var state = {};
					state.name = $state.current.name;
					state.params = $state.params;
					var isBulk = false;
					var logData = activityLogger.createLogData(null, state, 'catalogs.modelArticles', 'VIEW', isBulk, new Date(), null, null);
					promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/true/models/'+ modelId +'/articles', undefined, true, generalProperties.forceFetch);
					promise = activityLogger.log(logData, promise);
			}
			else {
					promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/true/models/' + modelId +'/articles', undefined, true, generalProperties.forceFetch);
			}

			return promise;
		}

		function assignCatalogModelArticles(record, modelId) {
			var catalogCode = catalogFactory.getActiveCatalog().CatalogCode;
			var requestObjet = record.Articles;
			var state = {};
			state.name = $state.current.name;
			state.params = $state.params;
			var logData = activityLogger.createLogData(record[api.catalogs.modelArticles.lookupDisplayField], state, 'catalogs.modelArticles', 'ADD', false, new Date(), null, null);
			var promise = api.webPut(api.baseUrl + '/catalogs/' + catalogCode + '/true/models/' + modelId + '/assignarticles', requestObjet);

			promise.then(function() {
				api.catalogs.modelArticles.isDirty = true;
				api.lists.availableCatalogModelArticles.isDirty = true;
			});
			return activityLogger.log(logData, promise);
		}

	}
})();
(function () {
    'use strict';

    angular
        .module('app.main.catalogs.articles', [
            'app.main.catalogs.articles.sizes',
            'app.main.catalogs.articles.prices',
            'app.main.catalogs.articles.crds',
            'app.main.catalogs.articles.segmentation',
            'app.main.catalogs.articles.images',
            'app.main.catalogs.articles.resources',
            'app.main.catalogs.articles.audit-trail-history',
            'app.main.catalogs.articles.relations'
        ])
        .config(config);

    /* @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
        // State
        $stateProvider.state('app.articles', {
            url    : '/articles',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/catalogs/sub-modules/articles/list/articles-list.html',
                    controller : 'articlesListController as vm'
                }
            },
            resolve: {
                catalogSpecificArticlesModel : function(catalogFactory, api, $q) {
                    var activeCatalog = catalogFactory.getActiveCatalog();
                    if(activeCatalog.IsLinePlan === 1) {
                        return catalogFactory.createLinePlanArticleModel(activeCatalog, api.catalogs.linePlanArticles );
                    } else {
                        return (function ($q) {
                            if(catalogFactory.isActiveCatalogInitialized()) {
                                return $q.when()
                            } else {
                                return catalogFactory.setActiveCatalogDetails()
                            }
                        })($q).then(function() {
                            if(api.enablePricesSegmentationsInArticlesList) {
                                var articlesDynamicProperties = [{
                                    propertiesMapper: [
                                        { target: 'field', source: 'field["Name"]' },
                                        { target: 'displayLabel', source: '"P:" + field["Name"] + " ("+ field["CurrencyCode"] +")"' },
                                        { target: 'priceGroupId', source: 'field["Id"]' }
                                    ],
                                    inputType: 'number',
                                    nestedArrayName: 'Prices',
                                    valueMapper: 'Price',
                                    sourceModel: 'catalogs.priceGroup'
                                }, {
                                    propertiesMapper: [
                                        { target: 'field', source: 'field["Id"]+field["Name"]' },
                                        { target: "displayLabel", source: '"S:" + field["Name"]' },
                                        { target: 'importField', source: 'field["Name"]' }
                                    ],
                                    inputType: 'switch',
                                    nestedArrayName: 'Segmentations',
                                    valueMapper: 'Id',
                                    sourceModel: 'catalogs.segmentations'
                                }];
                                return catalogFactory.createArticleModel(activeCatalog, articlesDynamicProperties);
                            } else {
                                return catalogFactory.createArticleModel(activeCatalog);
                            }
                        })
                    }
                },

                linkedCatalogsArticleDynamicModel : function(catalogFactory, api) {
                    var activeCatalog = catalogFactory.getActiveCatalog();
                    if(activeCatalog.IsLinePlan === 1) {
                        return catalogFactory.createLinePlanArticleModel(activeCatalog, api.catalogs.linkedCatalogArticleModel);
                    } else {
                        return undefined;
                    }
                },

                catalogSpecificPricesModel : function(catalogFactory, $q, $log) {
                    var deferred = $q.defer();
                    var propertiesMapper = [{target: 'field', source: ' field["Id"]+field["Name"]'}, {target: 'importField', source: 'field["Name"]'}, {target: 'displayLabel', source: 'field["Name"] + " ("+ field["CurrencyCode"] +")"'}, {target: 'priceGroupId', source: 'field["Id"]'}],
                        inputType = 'decimal',
                        nestedArrayName = 'Prices',
                        valueMapper = 'Price',
                        targetModel = 'catalogs.prices',
                        sourceModel = 'catalogs.priceGroup';
                    catalogFactory.createDynamicModel(targetModel, sourceModel, propertiesMapper, inputType, nestedArrayName, valueMapper)
                        .then(function(pricesModel) {
                            deferred.resolve(pricesModel);
                        }).catch(function() {
                            $log.error('unable to resolve articles prices model');
                        });

                    return deferred.promise;
                }
            },
            data: {
                displayName: 'ARTICLES.NAV'
            },
            //only users with following accessPrivileges in their role access list can access this route
			// accessPrivileges: ['GetCatalogArticleList']
            // accessPrivileges: ['nav_articles']
            accessInfo: {
                accessPrivileges: ['nav_articles']
            },
            visibleForLinePlan: true
        });

        $stateProvider.state('app.articles.details', {
			url	 : '/:id',
            params: {tab :'details'},
            views: {
				'content@app': {
					templateUrl: 'app/main/catalogs/sub-modules/articles/details/articles-details.html',
					controller : 'articlesDetailsController as vm'
				}
			},
            resolve: {
                dynamicModels: function ($q, api, catalogFactory, utility) {
                    var deferred = $q.defer();
                    var activeCatalog = catalogFactory.getActiveCatalog();
                    var isSizeScaleByStyle = catalogFactory.getIsSizeScaleByStyle();

                    if (activeCatalog.IsLinePlan === 1) {
                        var result = {
                            catalogSpecificArticlesModel: {}
                        }
                        catalogFactory.createLinePlanArticleModel(activeCatalog, api.catalogs.linePlanArticles).then(function (resolvedModel) {
                            result.catalogSpecificArticlesModel = resolvedModel;
                            deferred.resolve(result);
                        });
                    } else {
                        var result = {
                            catalogSpecificArticlesModel: {},
                            sizesModel: angular.copy(api.articles.sizes),
                            pricesModel: angular.copy(api.articles.prices),
                            imagesModel: angular.copy(api.catalogs.articleDuneImages)
                        };

                        result.imagesModel = angular.copy(api.catalogs.articleDuneImages);
                        result.imagesModel.methods = api.catalogs.t1Dune.methods;
                        result.imagesModel.baseModel = api.catalogs.articleDuneImages;

                        if (activeCatalog.DataSourceTypeId === 3) { // if active catalog is inherited catalog
                            if(activeCatalog.IndependentSizes !== 1) {
                                result.sizesModel.views.mainList.fabAction.label = 'ACTIONS.ASSIGN';
                                result.sizesModel.views.mainList.fabAction.icon = 'icon-link';
                            } else { // hide fab action if independentsize is enabled
                                result.sizesModel.views.mainList.fabAction.visible = false;
                            }

                            result.imagesModel.views.mainList.itemActions = [];
                            result.imagesModel.views.mainList.listActions = [];
                            result.imagesModel.views.mainList.fabAction.visible = false;
                            result.imagesModel.views.mainDetails.fab.visible = false;
                        }
                        // if size scale is enabled remove all update/create actions from item actions and list actions
                        if (isSizeScaleByStyle === 1) {
                            result.sizesModel.views.mainList.itemActions = [];
                            result.sizesModel.views.mainList.listActions = [];
                            result.sizesModel.views.mainList.fabAction.visible = false;
                            result.imagesModel.views.mainDetails.fab.visible = false;
                        }
                        // if price by style is enabled remove all update/create actions
                        if (activeCatalog.IsPriceByStyleApply === 1) {
                            result.pricesModel.views.mainList.fabAction.visible = false;
                            var editAction = utility.filterObject(result.pricesModel.views.mainList.itemActions, { id: 'edit' }, true)[0];
                            if (editAction) {
                                var editActionIndex = result.pricesModel.views.mainList.itemActions.indexOf(editAction);
                                result.pricesModel.views.mainList.itemActions.splice(editActionIndex, 1);
                            }
                        }
                        var articlesDynamicProperties = [{
                            propertiesMapper: [
                                { target: 'field', source: 'field["Name"]' },
                                { target: 'displayLabel', source: '"P:" + field["Name"] + " ("+ field["CurrencyCode"] +")"' },
                                { target: 'priceGroupId', source: 'field["Id"]' }
                            ],
                            inputType: 'number',
                            nestedArrayName: 'Prices',
                            valueMapper: 'Price',
                            sourceModel: 'catalogs.priceGroup'
                        }, {
                            propertiesMapper: [
                                { target: 'field', source: 'field["Id"]+field["Name"]' },
                                { target: "displayLabel", source: '"S:" + field["Name"]' },
                                { target: 'importField', source: 'field["Name"]' }
                            ],
                            inputType: 'switch',
                            nestedArrayName: 'Segmentations',
                            valueMapper: 'Id',
                            sourceModel: 'catalogs.segmentations'
                        }];
                        catalogFactory.createArticleModel(activeCatalog, articlesDynamicProperties).then(function (resolvedModel) {
                            result.catalogSpecificArticlesModel = resolvedModel;
                            deferred.resolve(result);
                        });
                    }

                    return deferred.promise;
                }
            },
			data: {
				parentState: 'app.articles',
                displayName: 'ARTICLES.TABS.ARTICLE'
			},
            //only users with following accessPrivileges in their role access list can access this route
            // accessPrivileges: ['GetCatalogArticleDetails']
            accessInfo: {
                accessPrivileges: ['GetCatalogArticleDetails']
            },
            visibleForLinePlan: true
		});

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/catalogs/sub-modules/articles');

        // Navigation
        msNavigationServiceProvider.saveItem('catalogs', {
            title : 'Catalog Data',
            translate: 'NAV.CATALOG_DATA',
            group : true,
            weight: 1
        });

        msNavigationServiceProvider.saveItem('catalogs.articles', {
            title      : 'Articles',
            icon       : 'icon-cube-outline',
            state      : 'app.articles',
            translate  : 'ARTICLES.NAV',
            weight     : 30,
            // accessPrivileges: ['GetCatalogArticleList']
            // accessPrivileges: ['nav_articles'],
            accessInfo: {
                accessPrivileges: ['nav_articles']
            },
            visibleForLinePlan: true
        });
    }
})();
(function () {
	'use strict';

	angular
		.module('app.main.catalogs.articles')
		.controller('generateSummaryReportController', generateSummaryReportController);

	/* @ngInject */
	function generateSummaryReportController($mdDialog, data, model, event) {
		var vm = this;

		vm.data = data;
		vm.model = model;
		vm.filteredData = [];
		vm.isLoading = false;

		vm.closeDialog = closeDialog;

		activate();

		////////////////

		function activate() {
			if (angular.isDefined(vm.tableControl) && angular.isDefined(vm.tableControl.updateData)) {
				vm.tableControl.updateData();
			}
		}

		function closeDialog() {
			$mdDialog.hide();
		}
	}
})();
(function () {
	'use strict';

	angular
		.module('app.main.catalogs.articles')
		.run(runBlock);

	/* @ngInject */
	function runBlock(api) {

		if (angular.isUndefined(api.catalogs)) {
			api.catalogs = {};
		}
		api.catalogs.summaryReport = {
			modelPath: 'catalogs.summaryReport',
			fields: [
				{ field: 'SKU|Targets', type: 'text', displayLabel: 'ARTICLE.REPORT.FIELDS.SKU_TARGETS', visible: true, creatable: true, editable: true, inputType: 'text'},
				{ field: 'SKU|TTL|TY', type: 'text', displayLabel: 'ARTICLE.REPORT.FIELDS.SKU_TTL_TY', visible: true, creatable: true, editable: true, inputType: 'text'},
				{ field: 'SKU|TTL|LY', type: 'text', displayLabel: 'ARTICLE.REPORT.FIELDS.SKU_TTL_LY', visible: true, creatable: true, editable: true, inputType: 'textArea'},
				{ field: 'SKU|%|Change|LY', type: 'text', displayLabel: 'ARTICLE.REPORT.FIELDS.SKU_CHANGE_LY', visible: true, creatable: true, editable: true, inputType: 'text'},
				{ field: 'Model|Targets', type: 'text', displayLabel: 'ARTICLE.REPORT.FIELDS.MODEL_TARGETS', visible: true, creatable: true, editable: true, inputType: 'text'},
				{ field: 'Model|TTL|TY', type: 'text', displayLabel: 'ARTICLE.REPORT.FIELDS.MODEL_TTL_TY', visible: true, creatable: true, editable: true, inputType: 'text'},
				{ field: 'Model|TTL|LY', type: 'text', displayLabel: 'ARTICLE.REPORT.FIELDS.MODEL_TTL_LY', visible: true, creatable: true, editable: true, inputType: 'textArea'},
				{ field: 'Model|%|Change|LY', type: 'text', displayLabel: 'ARTICLE.REPORT.FIELDS.MODEL_CHANGE_LY', visible: true, creatable: true, editable: true, inputType: 'text'}
			],
			uniqueConstraints: [],
			title: 'ARTICLE.REPORTS',
			idField: '',
			lookupDisplayField: '',
			isDirty: false,
			isCatalogSpecificModel: true,
			methods: {},
			views: {
				mainList: {
					columns: ['SKU|Targets', 'SKU|TTL|TY', 'SKU|TTL|LY', 'SKU|%|Change|LY'],
					columnFilter: {},
					toggleFilterProps: {},
					topIndex: 0,
					showFilterRow: false,
					sortColumn: {},
					itemActions: [],
					listActions: []
				},
				mainDetails: {},
				privileges: {
					list: 'GetAllActiveCustomersAllLocations'
				}
			}
		};
	}
})();
(function(){
	'use strict';

	angular
		.module('app.main.catalogs.articles')
		.controller('selectArticleDropReasonController', selectArticleDropReasonController);

	/* @ngInject */
	function selectArticleDropReasonController($mdDialog, $q, utility, api, dropReasons, articles, catalogId, articleReplacementAttributeId) {
		/**jshint validthis: true */
		var vm = this;

		//data
		vm.dropReasons = dropReasons;
		vm.record = {};
		vm.lookupModel = {};
		vm.searchText = {};
		vm.requiresReplacement = false;
		vm.requiresComment = false;
		vm.dropComment = '';
		vm.articleRows = [];

		//methods
		vm.cancel = cancel;
		vm.closeDialog = closeDialog;

		vm.lookupSearch = lookupSearch;
		vm.lookupChange = lookupChange;
		vm.getLookupDisplayValue = getLookupDisplayValue;
		vm.selectText = selectText;
		vm.isSaveDisabled = isSaveDisabled;

		vm.lookupReplacementArticles = lookupReplacementArticles;
		vm.getReplacementDisplayValue = getReplacementDisplayValue;
		vm.replacementChange = replacementChange;

		function cancel(cancelVal) {
		   $mdDialog.cancel(cancelVal); // do nothing
		}

		function closeDialog() {
			if(vm.dropComment) {
				vm.record['DropComment'] = vm.dropComment;
			}
			if(vm.requiresReplacement) {
				vm.record['replacements'] = [];
				angular.forEach(vm.articleRows, function(row) {
					vm.record['replacements'].push({
						ArticleId: row.ArticleId,
						ReplacementArticleId: row.ReplacementArticleId
					});
				});
			}
			$mdDialog.hide(vm.record);
		}

		function lookupSearch(query) {
			var results = [];
			results = query ? utility.filterObject(dropReasons, {Reason: query}) : dropReasons;
			return results;
		}

		// convert drawdown scope value form object(lookup record) to id property of lookup record
		function lookupChange(selectedObj) {
			if(angular.isObject(selectedObj)) {
				vm.record['DropReason'] = selectedObj.Id;
				vm.record['Reason'] = selectedObj.Reason;
				vm.requiresReplacement = selectedObj.RequiresReplacement === 1;
				vm.requiresComment = selectedObj.RequiresComment === 1;
				if(vm.requiresReplacement) {
					buildArticleRows();
				} else {
					vm.articleRows = [];
				}
				if(!vm.requiresComment) {
					vm.dropComment = '';
				}
			}
			else if(angular.isUndefined(selectedObj) || selectedObj === null) {
				vm.record['DropReason'] = undefined;
				vm.requiresReplacement = false;
				vm.requiresComment = false;
				vm.dropComment = '';
				vm.articleRows = [];
			}
		}

		function getLookupDisplayValue(item) {
			return getLookupDisplayVal(item, dropReasons);
		}

		function selectText(event) {
			utility.selectInputText(event);
		}

		function isSaveDisabled() {
			if(!vm.lookupModel.DropReasonId) {
				return true;
			}
			if(vm.requiresComment && !vm.dropComment) {
				return true;
			}
			if(vm.requiresReplacement) {
				for(var i = 0; i < vm.articleRows.length; i++) {
					if(!vm.articleRows[i].ReplacementArticleId) {
						return true;
					}
				}
			}
			return false;
		}

		function buildArticleRows() {
			vm.articleRows = [];
			var articlesArray = angular.isArray(articles) ? articles : [articles];
			angular.forEach(articlesArray, function(article) {
				var articleId = article.ArticleId || article.Id;
				vm.articleRows.push({
					ArticleId: articleId,
					ArticleNumber: article.ArticleNumber,
					ReplacementArticleId: undefined,
					selectedReplacement: undefined,
					searchText: '',
					suggestedArticles: [],
					suggestedArticlesPromise: null
				});
			});

			// same pattern as confirm-drop: fire API call per row, store promise
			angular.forEach(vm.articleRows, function(row) {
				var apiResult = api.catalogs.articles.methods.getArticlesWithSameSizes(catalogId, row.ArticleId, articleReplacementAttributeId);
				if(apiResult && angular.isFunction(apiResult.then)) {
					row.suggestedArticlesPromise = apiResult.then(function(response) {
						row.suggestedArticles = response.data || [];
						return row.suggestedArticles;
					}, function() {
						row.suggestedArticles = [];
						return row.suggestedArticles;
					});
				} else {
					row.suggestedArticlesPromise = $q.when([]);
				}
			});
		}

		// same pattern as confirm-drop lookupSearch: sync when data loaded, promise when pending
		function lookupReplacementArticles(query, articleRow) {
			if(articleRow.suggestedArticles.length) {
				return filterArticles(articleRow.suggestedArticles, query);
			} else if(articleRow.suggestedArticlesPromise) {
				return articleRow.suggestedArticlesPromise.then(function(data) {
					return filterArticles(data, query);
				});
			}
			return [];
		}

		// lightweight filter: simple indexOf match on ArticleNumber, capped at 50 results
		function filterArticles(data, query) {
			if(!query) {
				return data.length > 50 ? data.slice(0, 50) : data;
			}
			var queryLower = query.toLowerCase();
			var results = [];
			for(var i = 0; i < data.length && results.length < 50; i++) {
				if(data[i].ArticleNumber && data[i].ArticleNumber.toLowerCase().indexOf(queryLower) !== -1) {
					results.push(data[i]);
				}
			}
			return results;
		}

		function replacementChange(articleRow, selectedObj) {
			if(angular.isObject(selectedObj)) {
				articleRow.ReplacementArticleId = selectedObj.ArticleId;
			} else {
				articleRow.ReplacementArticleId = undefined;
			}
		}

		function getReplacementDisplayValue(item) {
			if(angular.isObject(item)) {
				return item.ArticleNumber;
			}
			return '';
		}

		//helper method
		function getLookupDisplayVal(item, data) {
			var result;
			if(data) {
				// since autocomplete return object
				if(angular.isObject(item)) {
					result = utility.filterObject(data, {Reason: item.Reason}, true);
				}
				// to initialize field value if any (when open update record dialog)
				else {
					result = utility.filterObject(data, {Reason: item.Reason}, true);
				}

				if (angular.isArray(result) && result.length > 0) {
					return result[0].Reason;
				}
				else {
					return result.Reason;
				}
			}
		}

	}
})();
(function () {
	'use strict';

	angular
		.module('app.main.catalogs.articles')
		.controller('manageArticlesStateController', manageArticlesStateController);

	// TODO: REMOVE UNWANTED CODE, DUE TO TIME CRUNCH RESUING THE ARTICLE CREATE VIEW
	/* @ngInject */
	function manageArticlesStateController($mdDialog, $scope, $filter, scope, toast, hotkeys, $log, $translate,
		api, utility, model, articles, catalogCode, lookupPromises, catalogFactory, $q, articlesFactory, SecurityFactory, CONSTANTS) {
		var vm = this;

		var activeCatalog = catalogFactory.getActiveCatalog();
		var sellerId = activeCatalog.AccountId;
		var attributeGroupId = activeCatalog.AttributeGroupId;

		vm.isLoading = false;
		vm.model = model;
		vm.articles = angular.copy(articles);
		vm.filterExpression = { creatable: true };
		vm.isDataDirty = false;
		vm.maxTags;
		vm.ErrorMessage = "";
		vm.colors = [];
		vm.randomColorForFavoriteTag = '';

		vm.dependingAttributesMap = [];
		vm.criteriaDeptAttributeMap = {};
		vm.vettingListCriteriaList = [];
		vm.criteriaV2Map = {}; // AttributeSystemName -> parsed CriteriaV2 rules array (preferred over OLD Criteria)
		vm.requiredAttributesErrorMessages = [];
		// check the special privilege is assigned to the user for updating the state. if then does not restrict sizescale and model name update
		var isSpecialPermissionToIgnoreArticleStateIsAssigned = SecurityFactory.isAuthorized({accessPrivileges: CONSTANTS.PRIVILEGES.ARTICLES.SPECIAL_PRIVILEGE_TO_SKIP_STATE_VALIDATION});

		vm.acSelectedItem = [];
		vm.acSearchText = [];
		vm.searchText = {};
		vm.tagSeperatorKeys = {};
		vm.existingRecordsForUniqueValue = [];
		vm.availableArticleStates = utility.filterObject(api.articleStatesList, { Status: 1 });
		vm.isAboveDropDownLimit = false;
		vm.requiredAttributesList = [];
		var validSellerLookupsDestinationAttributesMap = api.validSellerLookupsDestinationAttributesMap;
		vm.lookupSourceAndDeptAttributeMap = {};
		vm.record = {};
		vm.record.StateId = areAllStateIdsSame(articles);
		vm.isFormDirty = false;
		vm.isMasterSizeScaleObsolete = false;
		var isRequiredAttributesChanged = false;
		var isSizeScaleChanged = false;
		var colorCriteriaAttributes = {};   // attributes referenced by the color palette criteria in play
		vm.showColorTypeInColorPalatteDropdown = api.showColorTypeInColorPalatteDropdown
		var dataSourceTypeId = catalogFactory.getActiveCatalogDetails().DataSourceTypeId;

		vm.saveRecord = saveRecord;
		vm.closeDialog = closeDialog;

		vm.lookupSearch = lookupSearch;
		vm.lookupChange = lookupChange;
		vm.customLookupChange = customLookupChange;
		vm.getLookupDisplayValue = getLookupDisplayValue;
		vm.getCustomLookupDisplayValue = getCustomLookupDisplayValue;
		vm.selectText = selectText;
		vm.colorPaletteLookupChange = colorPaletteLookupChange;

		vm.transformChip = transformChip;
		vm.acQuerySearch = acQuerySearch;
		vm.getChipDisplayValue = getChipDisplayValue;
		vm.add = add;

		vm.isInputRequired = isInputRequired;
		vm.getDateObj = getDateObj;
		vm.validateTxPattern = validateTxPattern;
		vm.getConditionalVettingList = getConditionalVettingList;
		vm.multiValueQuerySearch = multiValueQuerySearch;

		vm.validateJSON = validateJSON;
		vm.searchArticleStates = searchArticleStates;
		vm.getArticleStateDisplayValue = getArticleStateDisplayValue;
		vm.onArticleStateChange = onArticleStateChange;
		vm.lookupSourceAttributeChanged = lookupSourceAttributeChanged;
		vm.onRequiredAttributesChange = onRequiredAttributesChange;
		vm.handleFieldChange = handleFieldChange;
		vm.onSearchTextChanged= onSearchTextChanged;
		vm.isFormValid = isFormValid; // this to avoid enabling save button when filtering the fields and updating a value

		activate();

		////////////////

		function activate() {
			if (!vm.availableArticleStates.length) {
				loadAvailableArticleStates()
					.then(function (avaialableModelsResponse) {
						vm.availableArticleStates = avaialableModelsResponse;
					});
			}
			//Hotkeys
			hotkeys.bindTo($scope)
				.add({
					combo: 'ctrl+enter',
					description: $filter('translate')('ACTIONS.SAVE'),
					allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
					callback: function (event) {
						if (!vm.isLoading && !vm.editForm.$invalid) {
							vm.saveRecord();
						}
					}
				});
		}

		//On addition of new tag it validates that the tag should not contain pipe
		function add(chip, chips, field) {
			if (chip) {
				if (chip.indexOf(field.tagSeparator) !== -1) {
					vm.record[field.field].splice(vm.record[field.field].indexOf(chip), 1);
					vm.record[field.field] = vm.record[field.field].concat(chip.split(field.tagSeparator));
					vm.maxTags = vm.record[field.field].length + 1;
				} else {
					vm.maxTags = field.maxLen;
				}
			}
			//for displaying error message
			if (angular.isDefined(field.maxLen) && vm.maxTags != field.maxLen) {
				vm.ErrorMessage = field.validation.messages.pattern;
				return true;
			} else {
				vm.ErrorMessage = "";
				return false;
			}
		}

		function saveRecord() {
			vm.isLoading = true;

			//Transform the fields of type dateUTC
			angular.forEach(vm.model.fields, function (itm) {
				//To avoid date-option and datetime timezone issue
				if ((itm.inputType === 'date-utc' || itm.inputType === 'date-option' || itm.inputType === 'date') && angular.isDefined(vm.record[itm.field]) && angular.isDate(vm.record[itm.field])) {
					var d = vm.record[itm.field];
					vm.record[itm.field] = new Date(d.setHours(12 - (d.getTimezoneOffset() / 60), 0, 0));
				}

				if (itm.inputType === 'calculated') {
					delete vm.record[itm.field];
				}

				if ((itm.inputType === 'articlenumber' || itm.inputType === 'modelnumber') && angular.isDefined(vm.record[itm.field]) && vm.record[itm.field] !== null && vm.record[itm.field].toString().length > 0) {
					vm.record[itm.field] = vm.record[itm.field].toString();
				}

				if ((itm.inputType === 'number' || itm.type === 'int') && vm.record[itm.field] != null) {
					vm.record[itm.field] = parseInt(vm.record[itm.field]);
				}

				if ((itm.inputType === 'color-palette') && angular.isDefined(vm.record[itm.field]) && vm.record[itm.field] != null && vm.record[itm.field] !== '' && angular.isObject(vm.record[itm.field])) {
					var key = Object.keys(vm.record[itm.field])[0];
					var val = vm.record[itm.field][key];
					if (typeof val === 'string' && val.includes(':')) {
						val = val.split(':')[1].trim();
					}
					vm.record[itm.field][key] = val;
					vm.record[itm.field] = angular.toJson(vm.record[itm.field]);
				}

				// remove all invisible special characters from strings
				if ((itm.inputType === 'text' || itm.inputType === 'textArea') && vm.record[itm.field] != null && vm.record[itm.field] !== '' && typeof vm.record[itm.field] === 'string') {
					vm.record[itm.field] = vm.record[itm.field].replace(/[\u00A0\u00AD\u200B-\u200D\uFEFF\u2028\u2029\u2060]/g, '');
				}

				if ((itm.inputType === 'multi-value' || itm.inputSubType === 'multi-value') && vm.record[itm.field] != null && vm.record[itm.field] !== '' && vm.record[itm.field].length) {
					angular.forEach(vm.record[itm.field], function(value, index) {
						vm.record[itm.field][index] = value.replace(/[\u00A0\u00AD\u200B-\u200D\uFEFF\u2028\u2029\u2060]/g, '');
					})
				}

				if (itm.inputType === 'dataset' && vm.record[itm.field] != null && vm.record[itm.field] !== '') {
					if(typeof (vm.record[itm.field]) === 'object') {
							vm.record[itm.field] = Object.keys(vm.record[itm.field])[0].toString()
					}
					else {
							vm.record[itm.field] = vm.record[itm.field].toString();
					}
				}

				if(itm.inputType === 'datatable' && vm.record[itm.field] != null && vm.record[itm.field] !== '') {
						vm.record[itm.field] = (typeof vm.record[itm.field] === 'string') ? vm.record[itm.field] : angular.toJson(vm.record[itm.field]);
				}
			});

			saveData();
		}

		function saveData() {
			var p;

			if (!vm.editForm.$invalid) {
				p = vm.model.methods.assignArtcleStates(vm.record, catalogCode, vm.model, vm.articles, isRequiredAttributesChanged, isSizeScaleChanged);

				p.then(function () {
					closeDialog(true);
					var toastMessage;
					toastMessage = 'SUCCESS.UPDATE';
					toast.success(toastMessage, '', '');
				}, function () {
					closeDialog(vm.isDataDirty);
				}).finally(function () {
					vm.isLoading = false;
				});
			} else {
				vm.isLoading = false;
			}
		}

		function closeDialog(saved) {
			$mdDialog.hide(saved);
		}

		function lookupSearch(query, field) {
			var results = [];
			var lookupFilter = angular.isDefined(field.lookupFilter) ? field.lookupFilter : {};
			var sortBy = angular.isDefined(field.sortBy) ? field.sortBy : null;
			var predicate = angular.copy(lookupFilter);

			if (query) {
				predicate['value'] = query;
			}

			var lookupModel = api.getModel(field.lookupSource);

			// Filter Size Scales or Master Size Scales
			if (field.field === 'SizeScaleId') {
				predicate['MasterSizeScaleId'] = vm.record.MasterSizeScaleId;
			}

			if(lookupModel && angular.isDefined(lookupModel.lookupData) && (angular.isDefined(lookupModel.lookupData.data) && lookupModel.lookupData.data.length)) {
				var lookupDataList = lookupModel.lookupData.data;
				results = utility.filterObject(lookupDataList, predicate);

				if (field.field === 'SizeScaleId') {
						results = filterSizeScales(results);
				}

				if (field.field === 'MasterSizeScaleId') {
						results = filterMasterSizeScales(results);
				}

				if (field.isfilterCriteria) {
						results = getFilteredColorCriteriaValues(results);
				}

				results = handleSortingAndLimit(results, sortBy, field);
				return results;
			} else {
				return lookupPromises[field.field].then(function (lookupData) {
					 var lookupDataList = lookupData.data;
						results = utility.filterObject(lookupDataList, predicate);

						if (field.field === 'SizeScaleId') {
							results = filterSizeScales(results);
						}

						if (field.field === 'MasterSizeScaleId') {
							results = filterMasterSizeScales(results);
						}

						if (field.isfilterCriteria) {
							results = getFilteredColorCriteriaValues(results);
						}

						results = handleSortingAndLimit(results, sortBy, field);
						return results;
				});
			}
	}

	// filter valid size scales and handle obsolete size scales
	function filterSizeScales(filteredResults) {
			var filteredSizeScales = utility.filterObject(filteredResults, { MasterSizeScaleId: vm.record.MasterSizeScaleId, Status: 1, IsObsolete: 0 }, true);

			if (angular.isDefined(vm.record.SizeScaleId) && vm.record.SizeScaleId !== null) {
					var obsoleteAssignedSizeScale = utility.filterObject(filteredResults, { id: vm.record.SizeScaleId, IsObsolete: 1 }, true)[0];
					if (obsoleteAssignedSizeScale && !filteredResults.some(function (item) { return item.id === obsoleteAssignedSizeScale.id; })) {
						filteredSizeScales.push(obsoleteAssignedSizeScale);
					}
			}

			// Sort the filteredSizeScales by SizeScale
			filteredSizeScales.sort(function(a, b) {
				if (a.SizeScale && b.SizeScale) {
						return a.SizeScale.toLowerCase().localeCompare(b.SizeScale.toLowerCase());
				}
				return 0;
			});

			return filteredSizeScales;
	}

	// filter master size scales and handle obsolete scales
	function filterMasterSizeScales(filteredResults) {
			var activeMasterSizeScales = utility.filterObject(filteredResults, { Status: 1, IsObsolete: 0 }, true);

			var results = getFilteredCriteriaValues(activeMasterSizeScales);

			if (angular.isDefined(vm.record.MasterSizeScaleId) && vm.record.MasterSizeScaleId !== null) {
					var obsoleteAssignedMasterSizeScale = utility.filterObject(filteredResults, { id: vm.record.MasterSizeScaleId, IsObsolete: 1 }, true)[0];
					if (obsoleteAssignedMasterSizeScale && !results.some(function (item) { return item.id === obsoleteAssignedMasterSizeScale.id; })) {
							results.push(obsoleteAssignedMasterSizeScale);
							vm.isMasterSizeScaleObsolete = true;
					} else {
							vm.isMasterSizeScaleObsolete = false;
					}
			}

			// Sort the results by SizeScale
			results.sort(function(a, b) {
				if (a.SizeScale && b.SizeScale) {
						return a.SizeScale.toLowerCase().localeCompare(b.SizeScale.toLowerCase());
				}
				return 0;
			});

			// if the existing MasterSizeScale is invalid then assign the MasterSizeScaleId as null, we will allow user to update it
			// Check if the existing MasterSizeScaleId is part of the results or not
			if(vm.record.MasterSizeScaleId != null) {
				var isAssignedMasterSizeScaleValid = results.some(function (item) {
						return item.id === vm.record.MasterSizeScaleId;
				});

				// If the MasterSizeScaleId is not valid, set MasterSizeScaleId and SizeScaleId to null
				if (!isAssignedMasterSizeScaleValid) {
						vm.record.MasterSizeScaleId = null;
						vm.record.SizeScaleId = null;
				}
			}

			return results;
	}

	// function for sorting and limiting the dropdown list size
	function handleSortingAndLimit(results, sortBy, field) {
			var sortedList = results;

			if (sortBy !== null) {
					var sortKey = Object.keys(sortBy)[0];
					var isAscending = sortBy[sortKey];
					sortedList = utility.orderBy(results, sortKey, isAscending);
			}

			field['isAboveDropDownLimit'] = sortedList.length > 100;
			return sortedList.slice(0, 100);
	}

		// convert dropdown scope value form object(lookup record) to id property of lookup record
		function lookupChange(selectedObj, field) {
			if (angular.isObject(selectedObj)) {
				vm.record[field] = selectedObj.id;
			}
			else if (angular.isUndefined(selectedObj) || selectedObj === null) {
				vm.record[field] = undefined;
			}
			if(field === 'MasterSizeScaleId') {
				vm.record.SizeScaleId = null;
			}
		}

		function customLookupChange(selectedObj, field) {
			if (angular.isObject(selectedObj)) {
				vm.record[field.field] = selectedObj[field.customLookupInfo.value];
			}
			else if (angular.isUndefined(selectedObj) || selectedObj === null) {
				vm.record[field.field] = undefined; // on record removal make field undefined or the property can be deleted using delete keywork
			}
		}

		function colorPaletteLookupChange(selectedObj, field) {
			if (angular.isObject(selectedObj) && Object.keys(selectedObj)[0] != null && angular.isDefined(selectedObj.value)) {
				// color palette values are stores as key value pair
				var objectVal = {};
				objectVal[selectedObj.id] = selectedObj.value
				vm.record[field.field] = objectVal;
			}
			else if (angular.isUndefined(selectedObj) || selectedObj === null) {
				vm.record[field.field] = undefined; // on record removal make field undefined or the property can be deleted using delete keywork
			}
		}

		// isArticleNumberType for converting article id from string to int
		function getLookupDisplayValue(item, field, isArticleNumberType) {
			var lookupModel = api.getModel(field.lookupSource);
			item = isArticleNumberType ? parseInt(item) : item;

			if (angular.isDefined(lookupModel.lookupData) && angular.isDefined(lookupModel.lookupData.data) && lookupModel.lookupData.data.length) {
				return getLookupDisplayVal(item, lookupModel.lookupData, field);
			}
			else {
				return lookupPromises[field.field].then(function (lookupData) {
					return getLookupDisplayVal(item, lookupData, field);
				});
			}
		}

		function getCustomLookupDisplayValue(item, field) {
			//  show only color name for color palette attributes
			if (field.inputType === 'color-palette') {
				return $filter('colorPaletteRenderer')(item, field);
			} else {
				var lookupModel = api.getModel(field.lookupSource);

				if (angular.isDefined(lookupModel.lookupData) && angular.isDefined(lookupModel.lookupData.data) && lookupModel.lookupData.data.length) {
					return getCustomLookupDisplayVal(item, lookupModel.lookupData, field);
				}
				else {
					return lookupPromises[field.field].then(function (lookupData) {
						return getCustomLookupDisplayVal(item, lookupData, field);
					});
				}
			}
		}

		//helper method
		function getLookupDisplayVal(item, lookupData, field) {
			var result;

			if (lookupData) {
				// since autocomplte return object
				if (angular.isObject(item)) {
					result = utility.filterObject(lookupData.data, { id: item.id }, true);
				}
				// to initialize field value if any (when open update record dialog)
				else {
					result = utility.filterObject(lookupData.data, { id: item }, true);
				}

				if (angular.isArray(result) && result.length > 0) {
					return result[0].value;
				}
				else {
					if(field.field === 'SizeScaleId') {
						vm.record.SizeScaleId = null;
					} else {
						return result.value;
					}
				}
			}
		}

		function getCustomLookupDisplayVal(item, lookupData, field) {
			var result;
			var predicate = {};
			if (lookupData) {
				// since autocomplete return object
				if (angular.isObject(item)) {
					predicate[field.customLookupInfo.value] = item[field.customLookupInfo.value];
					result = utility.filterObject(lookupData.data, predicate, true);
				}
				// to initialize field value if any (when open update record dialog)
				else {
					predicate[field.customLookupInfo.value] = item;
					result = utility.filterObject(lookupData.data, predicate, true);
				}

				if (angular.isArray(result) && result.length > 0) {
					return result[0].value;
				}
				else {
					return result.value;
				}
			}
		}

		function selectText(event) {
			utility.selectInputText(event);
		}

		function transformChip(chip, isMultiValue) {
			if (angular.isObject(chip)) {
				return chip.id;
			} else if (isMultiValue) {
				return chip;
			}
			return undefined;
		}

		//TODO: Check performance impact on using nested filter
		function acQuerySearch(query, selectedRecords, field) {
			var results = [];
			var lookupFilter = angular.isDefined(field.lookupFilter) ? field.lookupFilter : {};
			var predicate = angular.copy(lookupFilter);
			predicate.value = query;

			var lookupModel = api.getModel(field.lookupSource);
			if (angular.isDefined(lookupModel.lookupData) && angular.isDefined(lookupModel.lookupData.data) && lookupModel.lookupData.data.length) {
				results = query ? utility.filterObject(lookupModel.lookupData.data, predicate) : utility.filterObject(lookupModel.lookupData.data, lookupFilter);
				results = removeSelectedChips(selectedRecords, results);
				results;
			}
			else {
				lookupPromises[field.field].then(function (lookupData) {
					results = query ? utility.filterObject(lookupData.data, predicate) : utility.filterObject(lookupData.data, lookupFilter);
					results = removeSelectedChips(selectedRecords, results);
					results;
				});
			}
			return results;
		}

		/**
		* @description
		* This method will remove selected chips form records (helper method)
		* @param {array} selectedRecords: list of selected chips
		* @param {array} records: data property of lookup-data
		* @returns {array}: list of available chips (chips which are not selected) // it does not really need to return a value but for readability returning modified value
		*/
		function removeSelectedChips(selectedRecords, records) {
			if (angular.isDefined(selectedRecords) && selectedRecords != null && selectedRecords.length > 0) {
				for (var index = records.length - 1; index >= 0; index--) {
					if (selectedRecords.indexOf(records[index].id) !== -1) {
						records.splice(index, 1);
					}
					if (selectedRecords.indexOf(records[index]) !== -1) {
						records.splice(index, 1);
					}
				}
			}
			return records;
		}

		function getChipDisplayValue(chip, field) {
			var lookupModel = api.getModel(field.lookupSource);
			if (angular.isDefined(lookupModel.lookupData) && angular.isDefined(lookupModel.lookupData.data) && lookupModel.lookupData.data.length) {
				return getChipDisplayVal(lookupModel.lookupData, chip);
			}
			else { // it will never go to else part since before try to load display value for selected chips, it always load lookup on focus of chips input element
				return lookupPromises[field.field].then(function (lookupData) {
					return getChipDisplayVal(lookupData, chip);
				});
			}
		}

		//helper method
		function getChipDisplayVal(lookupData, chip) {
			var res = utility.filterObject(lookupData.data, { id: chip }, true);
			if (angular.isArray(res) && res.length > 0) {
				return res[0].value;
			}
			else {
				$log.warn('viewCreator controller: Unable to resolve chip display value!');
				return "";
			}
		}

		function isInputRequired(field) {
			if (angular.isString(field.validation.isRequired)) {
				return (scope.$eval(field.validation.isRequired) && (angular.isUndefined(field.validation.disabledCriteria) || !scope.$eval(field.validation.disabledCriteria)));
			} else {
				return (field.validation.isRequired && (angular.isUndefined(field.validation.disabledCriteria) || !scope.$eval(field.validation.disabledCriteria)));
			}
		}

		function getDateObj(dateString, fromUTC) {
			if (dateString) {
				return utility.createDateObject(dateString, fromUTC);
			}
		}

		function validateTxPattern(field) {
				var validationExpression = utility.isValidJSON(field.validation['tx-pattern']);
				if(validationExpression && angular.isDefined(validationExpression.F) && validationExpression.F.length > 0) {
						var parsedExpressionObjects = validationExpression.F;
						vm.isValidValue = true;
						angular.forEach(parsedExpressionObjects, function(parsedExpressionObject) {
								if(vm.isValidValue) {
										// skip validating overridable attribute with parent attributes for master catalog
										if(angular.isDefined(parsedExpressionObject['SourceField']) && (dataSourceTypeId === 1 && field.Overridable && !parsedExpressionObject['SourceField'].startsWith('#')) || (dataSourceTypeId === 3)) {
												// if SourceValueRequired is true then the source field should be required for this attribute to have value
												if(parsedExpressionObject['SourceValueRequired']) {
														if(vm.record[parsedExpressionObject['SourceField']] !== '' && vm.record[parsedExpressionObject['SourceField']] != null) {
																setAttributeFieldValidity(field, parsedExpressionObject);
														} else if(vm.record[field.field] !== '' && vm.record[field.field] != null) {
																vm.editForm[field.field].$setValidity('pattern', false);
																vm.editForm[field.field].$touched = true;
																if(angular.isDefined(parsedExpressionObject.Message)) {
																		field.validation.messages.pattern = parsedExpressionObject.Message;
																}
																vm.isValidValue = false;
														}
												} else {
														if(vm.record[parsedExpressionObject['SourceField']] !== '' && vm.record[parsedExpressionObject['SourceField']] != null
																&& vm.record[field.field] !== '' && vm.record[field.field] != null && parsedExpressionObject['SourceField'] !== 'ShipmentStartDate' && parsedExpressionObject['SourceField'] !== 'ShipmentEndDate') {
																setAttributeFieldValidity(field, parsedExpressionObject);
														} else if((parsedExpressionObject['SourceField'] === 'ShipmentStartDate' || parsedExpressionObject['SourceField'] === 'ShipmentEndDate') && (vm.record['RetailIntroMonth'] != null && vm.record['RetailIntroMonth'] !== '') && (vm.record['RetailExitMonth'] != null && vm.record['RetailExitMonth'] !== '') && vm.record[field.field] !== '' && vm.record[field.field] != null) {
																// get the data from the mapped retail window and validate
																var retailWindowDataList = api.getModel('catalogs.retailExitMonthsForArticle').lookupData.data;
																var mappedRetailWindow = utility.filterObject(retailWindowDataList, {id: vm.record['RetailExitMonthId']}, true)[0];
																if(angular.isDefined(mappedRetailWindow)) {
																		vm.record['ShipmentStartDate'] = mappedRetailWindow.ShipmentStartDate;
																		vm.record['ShipmentEndDate'] = mappedRetailWindow.ShipmentEndDate;
																		setAttributeFieldValidity(field, parsedExpressionObject);
																}
														}
														else if(vm.editForm[field.field]) {
																vm.editForm[field.field].$setValidity('pattern', true);
																vm.editForm[field.field].$touched = true;
														}
												}
										}
										if(angular.isUndefined(parsedExpressionObject['SourceField']) && angular.isDefined(parsedExpressionObject['Expression']) && angular.isDefined(parsedExpressionObject['ExpressionValue'])) {
												if(vm.record[field.field] !== '' && vm.record[field.field] != null) {
														setAttributeFieldValidity(field, parsedExpressionObject, true);
												}
												else if(vm.editForm[field.field]) {
														vm.editForm[field.field].$setValidity('pattern', true);
												}
										}
								}
						});
				}
		}

		function setAttributeFieldValidity(field, parsedExpressionObject, isExpressionValidation) {
				var valid = validateExpression(field, parsedExpressionObject, isExpressionValidation);
				if(!valid) {
						if(angular.isDefined(vm.editForm[field.field])) {
								vm.editForm[field.field].$setValidity('pattern', false);
								vm.editForm[field.field].$touched = true;
								if(angular.isDefined(parsedExpressionObject.Message)) {
										field.validation.messages.pattern = parsedExpressionObject.Message;
								}
								vm.isValidValue = false;
						}
				} else {
						if(angular.isDefined(vm.editForm[field.field])) {
								vm.editForm[field.field].$setValidity('pattern', true);
								vm.editForm[field.field].$touched = true;
						}
				}
		}

		function validateExpression(field, parsedExpressionObject, isExpressionValidation) {
				var Expression = parsedExpressionObject.Expression;
				var SourceField = parsedExpressionObject.SourceField;
				var currentAttributeValue = vm.record[field.field];
				var sourceAttributeValue = !isExpressionValidation ? vm.record[SourceField] : parsedExpressionObject.ExpressionValue;

				//Transform the date fields to type dateUTC
				angular.forEach(vm.model.fields, function(itm) {
						if(itm.field === field.field || itm.field === SourceField) {
								// for date fields
								if ((itm.inputType === 'date-utc' || itm.inputType === 'date-option' || itm.inputType === 'date-without-time' || itm.inputType === 'date')) {
										if(itm.field === field.field) {
												currentAttributeValue = new Date(vm.record[itm.field]);
												currentAttributeValue = currentAttributeValue.setHours(0,0,0,0);
												if(isExpressionValidation) {
														sourceAttributeValue = new Date(sourceAttributeValue)
														sourceAttributeValue = sourceAttributeValue.setHours(0,0,0,0);
												}
										} else if(itm.field === SourceField) {
												sourceAttributeValue = new Date(vm.record[itm.field]);
												sourceAttributeValue = sourceAttributeValue.setHours(0,0,0,0);
										}
								}
								// for text input types
								if (itm.inputType === 'textArea' || itm.inputType === 'text' || (angular.isDefined(itm.type) && itm.type === 'text' && itm.inputType === 'list')) {
										if(itm.field === field.field) {
												currentAttributeValue = vm.record[itm.field].toUpperCase();
												if(isExpressionValidation) {
													sourceAttributeValue = sourceAttributeValue.toString().toUpperCase();
												}
										} else if(itm.field === SourceField) {
												sourceAttributeValue = vm.record[itm.field].toUpperCase();
										}
								}
						}
				});

				if(dataSourceTypeId === 3 && field.Overridable) {
						if(field.inputType === 'textArea' || field.inputType === 'text' || (angular.isDefined(field.type) && field.type === 'text' && field.inputType === 'list')) {
								sourceAttributeValue = vm.record[SourceField].toUpperCase();
						}

						// for date fields
						if ((field.inputType === 'date-utc' || field.inputType === 'date-option' || field.inputType === 'date-without-time' || field.inputType === 'date')) {
								sourceAttributeValue = new Date(vm.record[SourceField]);
								sourceAttributeValue = sourceAttributeValue.setHours(0,0,0,0);
						}
				}

				var isValid = false;
				switch(Expression) {
						case '<':
								isValid = currentAttributeValue < sourceAttributeValue ? true : false;
								break;
						case '>':
								isValid = currentAttributeValue > sourceAttributeValue ? true : false;
								break;
						case '<=':
								isValid = currentAttributeValue <= sourceAttributeValue ? true : false;
								break;
						case '>=':
								isValid = currentAttributeValue >= sourceAttributeValue ? true : false;
								break;
						case '=':
								isValid = currentAttributeValue === sourceAttributeValue ? true : false;
								break;
						case '!=':
								isValid = currentAttributeValue !== sourceAttributeValue ? true : false;
								break;
				}
				return isValid;
		}

		function getConditionalVettingList(field) {
			var attribute = field.field;
			// CriteriaV2 (preferred): dropdown = matched rule's AllowedValues ([] when no rule matches)
			if (vm.criteriaV2Map[attribute]) {
				var getDependentValueForCriteriaV2 = function(dependentField) {
					var depVal = vm.record[dependentField];
					return (depVal && typeof depVal === 'object') ? (angular.isDefined(depVal.value) ? depVal.value : depVal) : depVal;
				};
				var criteriaV2Allowed = utility.getCriteriaV2AllowedValues(vm.criteriaV2Map[attribute], getDependentValueForCriteriaV2);
				var criteriaV2AttributeField = utility.filterObject(vm.filteredRequiredAttributesList || vm.requiredAttributesList, { field: attribute }, true)[0];
				if (angular.isDefined(criteriaV2AttributeField)) {
					criteriaV2AttributeField.values = (criteriaV2Allowed || [])
						.map(function(value) { return value.toString().trim(); })
						.sort(function(a, b) { return a.toLowerCase().localeCompare(b.toLowerCase()); });
				}
				return;
			}
			var criteriaObj = {};
			var catalogAttribute = utility.filterObject(catalogFactory.getActiveCatalogDetails().AssignedCatalogAttributes,
					{ AttributeSystemName: attribute }, true)[0];
			var catalogAttributeAllowedValues = (catalogAttribute.AllowedValues || []).map(function (v) {
					return v.toString().toLowerCase()
			})
			angular.forEach(vm.vettingListCriteriaList, function (criteriaAttr) {
				for (var key1 in criteriaAttr) {
					if (criteriaAttr.hasOwnProperty(key1)) {
						if (key1.toLocaleLowerCase() === attribute.toLowerCase()) {
							criteriaObj = criteriaAttr[key1];
							break;
						}
					}
				}
			});

			var validValues = [];
			var noMatch = true
			Object.keys(criteriaObj).forEach(function (key) {
				var item = criteriaObj[key];
				var subItems = Object.keys(item);
				var validItems = 0;
				subItems.forEach(function (key2) {
					if (vm.record.hasOwnProperty(key2) && vm.record[key2] != null && vm.record[key2] !== '') {
						var articleAttributeValue = typeof (vm.record[key2]) === 'object' ?
							angular.isDefined(vm.record[key2]['value']) ? vm.record[key2]['value'] : vm.record[key2] :
							vm.record[key2];
						var isDate = validateDate(articleAttributeValue);
						if (articleAttributeValue != null && articleAttributeValue.toString() != '') {
							noMatch = false;
							var lowerCaseValues = item[key2].map(function (value) {
								return isDate == true ? new Date(value).getTime().toString().toLowerCase() : value.toString().toLowerCase();
							});

							if (isDate == true) {
								if (lowerCaseValues.indexOf(new Date(articleAttributeValue).getTime().toString().toLowerCase()) !== -1) {
									validItems++;
								}
							} else {
								if (lowerCaseValues.indexOf(articleAttributeValue.toString().toLowerCase()) !== -1) {
									validItems++;
								}
							}
						}
					} else {
						validItems++;
					}
				});

				if (subItems.length == validItems && catalogAttributeAllowedValues.indexOf(key.toLowerCase()) !== -1) {
					validValues.push(key);
				}
			});
			var attributeField = utility.filterObject(vm.filteredRequiredAttributesList, { field: attribute }, true)[0];
			if (!noMatch) {
				attributeField.values = (validValues || [])
				.map(function(value) {
					return value.trim();
				})
				.sort(function(a, b) {
					return a.toLowerCase().localeCompare(b.toLowerCase());
				})
			} else {
				attributeField.values = (catalogAttribute.AllowedValues || [])
				.map(function(value) {
					return value.trim();
				})
				.sort(function(a, b) {
					return a.toLowerCase().localeCompare(b.toLowerCase());
				})
			}
		}

		function validateDate(value, formats) {
			if (angular.isUndefined(formats)) {
				formats = [
					moment.ISO_8601
				];
			}
			return moment(value, formats, true).isValid();
		}

		function multiValueQuerySearch(query, selectedItems, field) {
			if (field.isCriteriaAdded) {
				getConditionalVettingList(field);
			}
			var values = field.values;
			var searchQueryResult = [];
			var searchQueryResult = utility.filterObject(values, query);
			if (selectedItems && selectedItems.length > 0) {
				for (var index = searchQueryResult.length - 1; index >= 0; index--) {
					if (selectedItems.indexOf(searchQueryResult[index]) !== -1) {
						searchQueryResult.splice(index, 1);
					}
				}
			}
			return searchQueryResult;
		}

		function validateJSON(field) {
			var valid = utility.isValidJSON(vm.record[field.field]);
			if (valid && utility.isObjectEmpty(JSON.parse(vm.record[field.field]))) {
				valid = false;
			}
			if (valid) {
				if (angular.isDefined(vm.editForm[field.field])) {
					vm.editForm[field.field].$setValidity('checkIfValidJson', true);
				}
			} else {
				if (angular.isDefined(vm.editForm[field.field])) {
					vm.editForm[field.field].$setValidity('checkIfValidJson', false);
				}
			}
		}

		function searchArticleStates(query) {
			var predicate = {};
			var results = [];
			predicate.StateName = query;
			if (vm.availableArticleStates.length) {
				results = query ? utility.filterObject(vm.availableArticleStates, predicate) : angular.copy(vm.availableArticleStates);
				// show only allowed states which are higher than the selected articles current state
				var highestArticleStateRankStateId = articlesFactory.getHighestArticleStateRankStateId(vm.articles);
				if(highestArticleStateRankStateId !== 0) {
					var assignedArticleState = utility.filterObject(vm.availableArticleStates, {StateId: highestArticleStateRankStateId}, true)[0];
					// when assigned article state is inactive then check from master list
					if(angular.isUndefined(assignedArticleState)) {
						assignedArticleState = utility.filterObject(api.articleStatesList, {StateId: highestArticleStateRankStateId}, true)[0];
					}
					var heighestArticleStateRank = assignedArticleState.StateRank;
					var filteredArticleStates = results.filter(function(article) {
						return article.StateRank > heighestArticleStateRank;
					})
					results = filteredArticleStates;
				}
			} else {
				loadAvailableArticleStates().then(function (availableArticleStatesResult) {
					results = query ? utility.filterObject(availableArticleStatesResult, predicate) : availableArticleStatesResult;
				});
			}
			// this is to reduce the rendering time. It was very slow and was impacted overall page responsiveness
			// so while displaying we will display only the first 100 records and user can filter with any value
			var sortedList = utility.orderBy(results, 'StateRank', false);
			vm.isAboveDropDownLimit = sortedList.length > 100;
			return sortedList.slice(0, 100);
		}

		// helper methods
		function loadAvailableArticleStates() {
			var generalProperties = {
				forceFetch: true,
				isLogRequired: false
			}
			var deferred = $q.defer();
			var promise = deferred.promise;
			api.catalogs.articleStates.methods.getList(generalProperties, sellerId, attributeGroupId).then(function (response) {
				// show only allowed states which are higher than the selected articles current state
				var highestArticleStateRankStateId = articlesFactory.getHighestArticleStateRankStateId(vm.articles);
				if(highestArticleStateRankStateId !== 0) {
					var activeStates = utility.filterObject(response.data, { Status: 1 });
					var assignedArticleState = utility.filterObject(activeStates, {StateId: highestArticleStateRankStateId}, true)[0];
					var heighestArticleStateRank = assignedArticleState.StateRank;
					var filteredArticleStates = activeStates.filter(function(state) {
							return state.StateRank > heighestArticleStateRank;
					})
					vm.availableArticleStates = filteredArticleStates;
				} else {
					vm.availableArticleStates = utility.filterObject(response.data, { Status: 1 });
				}
				deferred.resolve(vm.availableArticleStates);
			});
			return promise;
		}

		function getArticleStateDisplayValue(item) {
			if (vm.availableArticleStates.length) {
				return getArticleStateLookupDisplayVal(item);
			}
			else {
				return loadAvailableArticleStates().then(function () {
					return getArticleStateLookupDisplayVal(item);
				});
			}
		}

		function getArticleStateLookupDisplayVal(item) {
			var result;
			var predicate = {};
			// since autocomplete return object
			if (angular.isObject(item)) {
				predicate['StateId'] = item['StateId'];
				result = utility.filterObject(api.articleStatesList, predicate, true)[0];
			}
			else {
				predicate['StateId'] = item;
				result = utility.filterObject(api.articleStatesList, predicate, true)[0];
			}

			if (angular.isArray(result) && result.length > 0) {
				return result[0].StateName;
			}
			else if (angular.isDefined(result)) {
				return result.StateName;
			}
		}


		function onArticleStateChange(selectedObj, isFromInit) {
			vm.isFormDirty = isFromInit ? false : true;
			if (angular.isObject(selectedObj)) {
				vm.record.StateId = selectedObj.StateId;
				// find and show the required attributes
				var selectedState = utility.filterObject(vm.availableArticleStates, { StateId: vm.record.StateId }, true)[0];
				var requiredAttributes = selectedState.RequiredAttributes;
				var isSizeScaleRequired = selectedState.IsSizeScaleRequired;
				var isPrimaryColorRequired = selectedState.IsPrimaryColorRequired;
				var articlesRequiredAttributes = [];
				var doesArticleMeetSelectedStateRequirement = true;
				vm.requiredAttributesErrorMessages = [];
				vm.requiredAttributesList = [];

				if (requiredAttributes.length || isSizeScaleRequired || isPrimaryColorRequired) {
					var requiredAttibutesWithIsValid = articlesFactory.doesArticlesMeetSelectedStateRequirement(articles, requiredAttributes, isSizeScaleRequired, isPrimaryColorRequired);
					doesArticleMeetSelectedStateRequirement = requiredAttibutesWithIsValid.doesArticlesMeetSelectedStateRequirement;
					articlesRequiredAttributes = requiredAttibutesWithIsValid.articlesRequiredAttributes;
				}
				// for bulk article state management we will show error message
				if (vm.articles.length > 1) {
					if (!doesArticleMeetSelectedStateRequirement) {
						vm.requiredAttributesErrorMessages.push('Can not update selected article(s) state,');
						for (var key in articlesRequiredAttributes) {
							var reqAttributeDisplayNames = [];
							if (!articlesRequiredAttributes[key].doesArticleMeetSelectedStateRequirement) {
								angular.forEach(articlesRequiredAttributes[key]['articlesRequiredAttributesList'], function(attrSystemName) {
									if(attrSystemName !== 'ColorId' && attrSystemName !== 'SizeScaleId') {
										reqAttributeDisplayNames.push(utility.getAttributeDisplayNameUsingSystemName(catalogFactory.getActiveCatalogDetails().AssignedCatalogAttributes, attrSystemName));
									} else {
										var staticAttributeDisplayName = attrSystemName === 'ColorId' ? 'Primary Color' : attrSystemName === 'SizeScaleId' ? 'Size Scale' : '';
										reqAttributeDisplayNames.push(staticAttributeDisplayName);
									}
								});
								vm.requiredAttributesErrorMessages.push(key + ' might not have value for required attribute(s) ' + reqAttributeDisplayNames.join(', '));
							}
						}
					}
				} else { // show required attributes
					var currentArticle =  vm.articles[0]; // single article
					var currentArticleState = utility.filterObject(vm.availableArticleStates, { StateId: currentArticle.StateId }, true)[0];
					var currentArticleModelState = currentArticleState
					if (currentArticle.StateId !== currentArticle.ModelStateId) {
						currentArticleModelState = utility.filterObject(vm.availableArticleStates, { StateId: currentArticle.ModelStateId }, true)[0];
					}
					// make size scale and master size scale non editable if its set as non editable on selected state if the SizeScaleByStyleIsEnabled
					var isSizeScaleEditable = true;
					if (catalogFactory.getIsSizeScaleByStyle()) {
							if (isSpecialPermissionToIgnoreArticleStateIsAssigned) {
									// If special permission is present, ignore selectedState.IsSizeScaleEditable
									isSizeScaleEditable = true;
							} else {
									isSizeScaleEditable = !!currentArticleModelState.IsSizeScaleEditable;
							}
					}
					var requiredAttributesMap = {};
					for (var key in articlesRequiredAttributes) {
						var stateLevelValidRequiredAttributesList = articlesRequiredAttributes[key]['stateLevelValidRequiredAttributesList'];
						angular.forEach(stateLevelValidRequiredAttributesList, function (systemName) {
							var attribute = utility.filterObject(vm.model.fields, { field: systemName }, true)[0];
							if (!requiredAttributesMap[systemName]) {
								if (systemName === 'SizeScaleId') {
									attribute = utility.filterObject(vm.model.fields, { field: systemName, inputType: 'lookup' }, true)[0];
									// add master size scale id MasterSizeScaleId
									var masterSizeScaleIdField = utility.filterObject(vm.model.fields, { field: 'MasterSizeScaleId', inputType: 'lookup' }, true)[0];
									masterSizeScaleIdField.editable = true;
									masterSizeScaleIdField.validation.isRequired = true;
									masterSizeScaleIdField.isReadOnly = (!isSizeScaleEditable) ? true : false;
									masterSizeScaleIdField.attributeNonEditableOnStateMessage = !isSizeScaleEditable ? 'Size Scale is non editable at state' + currentArticleModelState.StateName : '',
									// make the MasterSizeScale non editable if its assigned
									masterSizeScaleIdField.validation.disabledCriteria = 'field.isReadOnly === true';
									requiredAttributesMap['MasterSizeScaleId'] = 1;
									vm.requiredAttributesList.push(masterSizeScaleIdField);
								}
								if (attribute) {
									attribute.editable = true;
									attribute.validation.isRequired = true;
									requiredAttributesMap[systemName] = 1;
									if (systemName === 'SizeScaleId') {
										attribute.isReadOnly = (!isSizeScaleEditable) ? true : false;
										attribute.validation.disabledCriteria = 'vm.record.MasterSizeScaleId == null || field.isReadOnly === true';
										vm.requiredAttributesList.push(attribute);
									}
									else if(systemName !== 'ColorId') {
										var isAttributeEditable = true
										var attributeNonEditableOnStateMessage = ''
										if (!isSpecialPermissionToIgnoreArticleStateIsAssigned) { // only check editable if privilege is not assigned
											if (attribute.isModelLevelAttribute) {
												isAttributeEditable = !currentArticleModelState.NonEditableAttributes.length || !(currentArticleModelState.NonEditableAttributes.length && angular.isDefined(currentArticleModelState.NonEditableAttributes.find(function(attr) {return attr.AttributeSystemName === systemName})))
												attributeNonEditableOnStateMessage = !isAttributeEditable ? attribute.displayLabel + 'is non editable at state ' + currentArticleModelState.StateName : ''
											}
											else {
												isAttributeEditable = !currentArticleState.NonEditableAttributes.length || !(currentArticleState.NonEditableAttributes.length && angular.isDefined(currentArticleState.NonEditableAttributes.find(function(attr) {return attr.AttributeSystemName === systemName})))
												attributeNonEditableOnStateMessage = !isAttributeEditable ? attribute.displayLabel + 'is non editable at state ' + currentArticleState.StateName : ''
											}
										}
										attribute.isReadOnly = (!isAttributeEditable) ? true : false;
										attribute.validation.disabledCriteria = 'field.isReadOnly === true';
										attribute.attributeNonEditableOnStateMessage = attributeNonEditableOnStateMessage
										vm.requiredAttributesList.push(attribute);
									} else {
										// carry overed articles will have the same color name but the color id is different
									// currently id is displyed instead of color name when we cannot find the assigned Id on active catalog
									// so when color id already assigned then show the color name as readonly text box instead of autocomplete
										if(currentArticle[systemName] == null || currentArticle[systemName] === 0) {
											vm.requiredAttributesList.push(attribute);
										} else { // push the color name field
											var colorNameField = utility.filterObject(vm.model.fields, { field: 'ColorName' }, true)[0];
											vm.record['ColorName'] = currentArticle['ColorName'];
											colorNameField.validation.disabledCriteria = 'vm.record.ColorName !== null';
											vm.requiredAttributesList.push(colorNameField);
										}
									}
								}
							}
							// if article is having value then prefill it
							if (currentArticle.hasOwnProperty(systemName)) {
								vm.record[systemName] = currentArticle[systemName]
								if (systemName === 'SizeScaleId') { // assign master size scale value
									vm.record['MasterSizeScaleId'] = currentArticle['MasterSizeScaleId']
									var masterSizeScaleField = utility.filterObject(vm.model.fields, { field:'MasterSizeScaleId', inputType: 'lookup' }, true)[0];
									lookupSearch(undefined, masterSizeScaleField);
									lookupSearch(undefined, attribute);
								}
							}
						})
					}
					populateDefaultValues(currentArticle);
					vm.filteredRequiredAttributesList = angular.copy(vm.requiredAttributesList);
				}
			}
			else if (angular.isUndefined(selectedObj) || selectedObj === null) {
				vm.record.StateId = undefined;
				vm.requiredAttributesErrorMessages = [];
			}
		}

		function areAllStateIdsSame(articles) {
			var firstStateId = articles[0].StateId;
			for (var i = 1; i < articles.length; i++) {
				if (articles[i].StateId !== firstStateId) {
					return null;
				}
			}
			return firstStateId;
		}

		function populateDefaultValues(currentArticle) {
			for (var i = 0; i < vm.requiredAttributesList.length; i++) {
				var field = vm.requiredAttributesList[i];
				// if default value assigned then assign it while assigning aticle
				var defaultValue = angular.isDefined(field.DefaultValue) && field.DefaultValue != null && field.DefaultValue !== '' ? field.DefaultValue : undefined;

				if(angular.isDefined(vm.record[field.field]) && vm.record[field.field] !== null) {
					defaultValue = vm.record[field.field];
				}

				if ((field.editable || field.inputType === 'static') && angular.isDefined(field.fieldDefaultValue)) {
					vm.record[field.field] = field.fieldDefaultValue;
				}

				if (field.inputType === 'text' || field.inputType === 'textArea') {
					vm.record[field.field] = defaultValue ? defaultValue : '';
				} else if (field.inputType === 'number') {
					vm.record[field.field] = defaultValue ? Number(defaultValue) : 0;
				} else if (field.inputType === 'lookup-many' && (angular.isUndefined(vm.record[field.field]) || vm.record[field.field] == null)) {
					vm.record[field.field] = [];
				} else if (field.inputType === 'tags') {
					updateSeparatorKeys(field);
					populateTags(vm.record, field);
				} else if (field.inputType === 'bool') {
					vm.record[field.field] = false;
				}

				//for listing populated values of attributes in active catalog's attributeVettingList
				else if (field.inputType === 'list' || (field.inputType === 'multi-value')) {
						vm.record[field.field] = (defaultValue) ? defaultValue : '';
					// for multivalue dropdown make the record as array
					if (field.inputType === 'multi-value') {
						if ((vm.record[field.field] === null)) {
							vm.record[field.field] = [];
						}
					}
					if (vm.model.modelPath === 'catalogs.articles' || vm.model.modelPath === 'catalogs.linePlanArticles') {
						var attributes = catalogFactory.getActiveCatalogDetails().AssignedCatalogAttributes;
						if (attributes && attributes.length > 0) {
							var attribute = utility.filterObject(attributes, { AttributeSystemName: field.field }, true)[0];
							if(attribute) {
								field.values = (attribute.AllowedValues || [])
								.map(function(value) {
									return value.trim();
								})
								.sort(function(a, b) {
									return a.toLowerCase().localeCompare(b.toLowerCase());
								})
								if (field.isDynamicProperty && attribute.CriteriaV2 && attribute.CriteriaV2.length > 0) {
									try {
										vm.criteriaV2Map[attribute.AttributeSystemName] = JSON.parse(attribute.CriteriaV2);
									} catch (error) {
										console.warn(attribute.AttributeDisplayName + " - Attribute CriteriaV2: Invalid JSON Format");
									}
									field.isCriteriaAdded = true;
									vm.getConditionalVettingList(field);
									var v2DependentDisplayNames = [];
									utility.getCriteriaV2DependentFields(vm.criteriaV2Map[attribute.AttributeSystemName]).forEach(function(depKey) {
										var v2DependentField = utility.filterObject(vm.visibleAttributeFields, { field: depKey }, true)[0];
										if (v2DependentField) {
											if (!vm.criteriaDeptAttributeMap[depKey]) {
												vm.criteriaDeptAttributeMap[depKey] = [];
											}
											if (vm.criteriaDeptAttributeMap[depKey].indexOf(attribute.AttributeSystemName) === -1) {
												vm.criteriaDeptAttributeMap[depKey].push(attribute.AttributeSystemName);
											}
											v2DependentField.isDependentAttribute = true;
											v2DependentDisplayNames.push(utility.getAttributeDisplayNameUsingSystemName(catalogFactory.getActiveCatalogDetails().AssignedCatalogAttributes, depKey));
										}
									});
									field.criteriaDisplayMessage = 'Attribute ' + attribute.AttributeDisplayName + ' is dependent on the attribute(s) ' + v2DependentDisplayNames + '.';
								} else if (field.isDynamicProperty && attribute.Criteria.length > 0) {
									try {
										var vettinglistCriteria = JSON.parse(attribute.Criteria);
										var dependentAttributesDisplayNames = [];
										field.isCriteriaAdded = true;
										vm.getConditionalVettingList(field);
										var dependingAttributes = {};
										var obj2 = {};

										for (var key in vettinglistCriteria) {
											if (vettinglistCriteria.hasOwnProperty(key)) {
												var deptAttr = vettinglistCriteria[key];
												for (var key1 in deptAttr) {
													if (deptAttr.hasOwnProperty(key1)) {
														var index = dependentAttributesDisplayNames.indexOf(utility.getAttributeDisplayNameUsingSystemName(catalogFactory.getActiveCatalogDetails().AssignedCatalogAttributes, key1));
														if (index === -1) {
															var dependentAttributeField = utility.filterObject(vm.visibleAttributeFields, { field: key1 }, true)[0];
															if (dependentAttributeField) {
																if(!vm.criteriaDeptAttributeMap[key1]) {
																	vm.criteriaDeptAttributeMap[key1] = [];
																}
																vm.criteriaDeptAttributeMap[key1].push(attribute.AttributeSystemName);
																dependentAttributesDisplayNames.push(utility.getAttributeDisplayNameUsingSystemName(catalogFactory.getActiveCatalogDetails().AssignedCatalogAttributes, key1));
																dependentAttributeField.isDependentAttribute = true;
															}
														}

														if (obj2[key1]) {
															for (var j = 0; j < deptAttr[key1].length; j++) {
																var val = deptAttr[key1][j];
																if (obj2[key1][val]) {
																	if (obj2[key1][val].indexOf(key) === -1) {
																		obj2[key1][val].push(key);
																	}
																} else {
																	obj2[key1][val] = [key];
																}
															}
														} else {
															var obj = {};
															for (var j = 0; j < deptAttr[key1].length; j++) {
																var val = deptAttr[key1][j];
																obj[val] = [key];
															}
															obj2[key1] = obj;
														}
													}
												}
											}
										}

										dependingAttributes[attribute.AttributeSystemName] = obj2;
										vm.dependingAttributesMap.push(dependingAttributes);
										var obj = {};
										obj[attribute.AttributeSystemName] = vettinglistCriteria;
										vm.vettingListCriteriaList.push(obj);
										var criteriaDisplayMessage = 'Attribute ' + attribute.AttributeDisplayName + ' is dependent on the attribute(s) ' + dependentAttributesDisplayNames + '.';
										field.criteriaDisplayMessage = criteriaDisplayMessage;
									} catch (error) {
										console.warn(attribute.AttributeDisplayName + " - Attribute Criteria: Invalid JSON Format");
									}
								}
							}
						}
					}
				}

				else if (field.inputType === 'int-bool') {
					vm.record[field.field] = '0';
				}

				else if (field.inputType === 'bool-int') {
					vm.record[field.field] = 0;
				}

				else if (field.inputType === 'bool-str') {
					vm.record[field.field] = defaultValue ? defaultValue.toLowerCase() : 'false';
				}

				else if (field.inputType === 'date' || field.inputType === 'date-option') { // workaround for issue with interpolation on ng-disabled on md-datepicker
					if (defaultValue) {
						vm.record[field.field] = utility.formatDate(new Date(defaultValue), 'yyyy-MM-dd');
					}
					if ($scope.$eval(field.validation.disabledCriteria) || (field.showInEdit && !field.editable)) {
						//vm.disableDate =  true;
						field.validation.disabled = true;
					} else {
						field.validation.disabled = false;
					}
				}
				else if (field.inputType === 'date-utc') { // workaround for issue with interpolation on ng-disabled on md-datepicker
					if ($scope.$eval(field.validation.disabledCriteria) || (field.showInEdit && !field.editable)) {
						//vm.disableDateUTC =  true;
						field.validation.disabled = true;
					} else {
						field.validation.disabled = false;
					}
				}
				else if (field.inputType === 'date-without-time') { // workaround for issue with interpolation on ng-disabled on md-datepicker
					if (defaultValue) {
						vm.record[field.field] = utility.formatDate(new Date(defaultValue), 'yyyy-MM-dd');
					}
					if ($scope.$eval(field.validation.disabledCriteria) || (field.showInEdit && !field.editable)) {
						field.validation.disabled = true;
					} else {
						field.validation.disabled = false;
					}
				}
				else if (field.inputType === 'calculated') { // calculated fields are neither creatable nor editable
					field.creatable = false;
					field.editable = false;
				}
				else if (field.inputType === 'color') {
					vm.colors = mockFactory.getFavoritesColors();
				}

				else if (field.inputType === 'color-picker') {
					vm.record[field.field] = '#969696';
				}

				else if (field.inputType === 'decimal') {
					vm.record[field.field] = defaultValue ? Number(defaultValue) : 0;
				}

				else if (field.inputType === 'lookup-table') {
					field.isLookupAdded = true;
					if (angular.isDefined(validSellerLookupsDestinationAttributesMap[field.field])) {
							var attributeLookupValues = validSellerLookupsDestinationAttributesMap[field.field];
							var sourceAttributesDisplayNames = [];
							var matched = false;
							for (var j = 0; j < attributeLookupValues.length; j++) {
									var allAttributesMatch = true;
								var value = attributeLookupValues[j];
									for (var attributeSystemName in value.Source) {
											if (value.Source.hasOwnProperty(attributeSystemName)) {
												if(currentArticle[attributeSystemName] == null || value.Source[attributeSystemName].toString().toLowerCase() !== currentArticle[attributeSystemName].toString().toLowerCase()) {
														allAttributesMatch = false;
														break;
												}
											}
									}

									if (allAttributesMatch) {
											if(vm.record[field.field] !== value.Destination[field.field]) {
													vm.record[field.field] = value.Destination[field.field];
											}
											matched = true;
											break;
									}
							}

							// create source attributes map
							if(attributeLookupValues.length) {
									var firstSourceDestinationValue = attributeLookupValues[0];
									for (var attributeSystemName in firstSourceDestinationValue.Source) {
											var index = sourceAttributesDisplayNames.indexOf(utility.getAttributeDisplayNameUsingSystemName(catalogFactory.getActiveCatalogDetails().AssignedCatalogAttributes, attributeSystemName));
											if (index === -1) {
													sourceAttributesDisplayNames.push(utility.getAttributeDisplayNameUsingSystemName(catalogFactory.getActiveCatalogDetails().AssignedCatalogAttributes, attributeSystemName));
													var sourceAttributeField = utility.filterObject(vm.requiredAttributesList, { field: attributeSystemName }, true)[0];
													if (angular.isDefined(sourceAttributeField)) {
															sourceAttributeField.isLookupSourceAttribute = true;
													}
											}
											if (!vm.lookupSourceAndDeptAttributeMap[attributeSystemName]) {
													vm.lookupSourceAndDeptAttributeMap[attributeSystemName] = [];
											}
											if (vm.lookupSourceAndDeptAttributeMap[attributeSystemName].indexOf(field.field) === -1) {
													vm.lookupSourceAndDeptAttributeMap[attributeSystemName].push(field.field);
											}
									}
							}
							if (!matched) {
									vm.record[field.field] = null;
							}
							field.lookupDisplayMessage = 'Attribute ' + field.displayLabel + ' is dependent on the attribute(s) ' + sourceAttributesDisplayNames.join(', ') + '.';
					} else {
						field.lookupDisplayMessage = 'Attribute ' + field.displayLabel + ' does not have any source attribute(s) assigned';
					}
				}

				if (field.checkIfUnique) {
					vm.existingRecordsForUniqueValue = existingRecordsForUniqueValue ? existingRecordsForUniqueValue : [];
				}
			}
		}

		/**
* Enable use Enter and any other seperator key defined on model to be use as a seperator key for chips
*/
		function updateSeparatorKeys(field) {
			vm.tagSeperatorKeys[field.field] = [$mdConstant.KEY_CODE.ENTER];
			if (angular.isDefined(field.tagSeparator)) {
				var aditionalSeperator = field.tagSeparator.charCodeAt();
				if (angular.isDefined(aditionalSeperator) && aditionalSeperator !== 'NaN') {
					vm.tagSeperatorKeys[field.field].push(aditionalSeperator);
				}
			}
		}

		function populateTags(record, field) {
			if (angular.isUndefined(record[field.field]) || record[field.field] === null || record[field.field] === '') {
				record[field.field] = [];
			}
			else if (angular.isDefined(field.tagSeparator)) {
				var stringVal = record[field.field];
				var tagSeparator = field.tagSeparator;
				if (!angular.isArray(stringVal) && stringVal !== null) {
					record[field.field] = stringVal.split(tagSeparator);
				}
			}
			else {
				$log.warn('tagSeparator property is missing in model for ' + field.field);
			}
		}

		// when lookup source attribute changed
		function lookupSourceAttributeChanged(field) {
			var sourceAttributeName = field.field;
			if (vm.lookupSourceAndDeptAttributeMap.hasOwnProperty(sourceAttributeName)) {
					var dependentAttributeNames = vm.lookupSourceAndDeptAttributeMap[sourceAttributeName];
					for (var i = 0; i < dependentAttributeNames.length; i++) {
							var dependentAttributeName = dependentAttributeNames[i];
							if (angular.isDefined(validSellerLookupsDestinationAttributesMap[dependentAttributeName])) {
									var attributeLookupValues = validSellerLookupsDestinationAttributesMap[dependentAttributeName];
									var matched = false;
									for (var j = 0; j < attributeLookupValues.length; j++) {
											var allAttributesMatch = true;
										var value = attributeLookupValues[j];
											for (var attributeSystemName in value.Source) {
													if (value.Source.hasOwnProperty(attributeSystemName)) {
														if(vm.record[attributeSystemName] == null || value.Source[attributeSystemName].toString().toLowerCase() !== vm.record[attributeSystemName].toString().toLowerCase()) {
																allAttributesMatch = false;
																break;
														}
													}
											}
											if (allAttributesMatch) {
													if(vm.record[dependentAttributeName] !== value.Destination[dependentAttributeName]) {
														vm.record[dependentAttributeName] = value.Destination[dependentAttributeName];
													}
													matched = true;
													break;
											}
									}
									if (!matched) {
											vm.record[dependentAttributeName] = null;
									}
							}
					}
			}
		}

		function onRequiredAttributesChange(attributeSystemName) {
			vm.isFormDirty = true;
			var currentArticle =  vm.articles[0];
			// Check if the attribute has changed
			if (vm.record[attributeSystemName] !== currentArticle[attributeSystemName]) {
				if (attributeSystemName === 'SizeScaleId' || attributeSystemName === 'MasterSizeScaleId') {
					isSizeScaleChanged = true;
				} else {
					isRequiredAttributesChanged = true;
				}
			}
			// a color picked earlier can stop matching its palette criteria once a criteria attribute
			// changes, so the selection is cleared and has to be made again from the filtered list
			if (colorCriteriaAttributes[attributeSystemName] && vm.record.ColorId != null) {
				vm.record.ColorId = undefined;   // same reset lookupChange applies when a lookup is cleared
			}
		}

		// Colors are filtered by their palette criteria: a color whose palette carries no criteria is
		// always offered, and one with criteria only when the article satisfies it - the conditions of a
		// criteria are AND'ed and several criteria on a palette are OR'ed (utility.normalizeColorCriteria).
		function getFilteredColorCriteriaValues(colors) {
			var results = [];
			colorCriteriaAttributes = {};
			angular.forEach(colors, function (color) {
				var criteriaGroups = utility.normalizeColorCriteria(color.ColorCriteria);
				angular.forEach(utility.getColorCriteriaAttributes(criteriaGroups), function (attributeSystemName) {
					colorCriteriaAttributes[attributeSystemName] = true;
				});
				if (utility.matchesColorCriteria(criteriaGroups, getCriteriaRecordValue).isMatch) {
					results.push(color);
				}
			});
			return results;
		}

		// the article being managed, overlaid with the attribute values edited in this dialog
		function getCriteriaRecordValue(attributeSystemName) {
			if (angular.isDefined(vm.record[attributeSystemName]) && vm.record[attributeSystemName] !== null) {
				return vm.record[attributeSystemName];
			}
			return vm.articles.length ? vm.articles[0][attributeSystemName] : undefined;
		}

		function getFilteredCriteriaValues(records) {
			var recordsWithOutObsoleteValues = utility.filterObject(records, { IsObsolete: 0 }, true);
			var results = [];
			angular.forEach(recordsWithOutObsoleteValues, function (record) {
				var criteria = record.Criteria;
				if (angular.isDefined(criteria) && criteria !== '' && criteria.length) {
					try {
						var criteriaJSON = JSON.parse(criteria);
						var validItemsCount = 0;
						for (var key in criteriaJSON) {
							if (criteriaJSON.hasOwnProperty(key)) {
								var crts = criteriaJSON[key];
								var isValid = false;
								if (!angular.isArray(criteriaJSON[key])) {
									crts = [criteriaJSON[key]];
								}
								angular.forEach(crts, function (crt) {
									if (crt.toString().toLowerCase() === vm.articles[0][key].toString().toLowerCase()) {
										isValid = true;
									}
								});
								if (isValid) {
									validItemsCount++;
								}
							}
						}
						if (validItemsCount === Object.keys(criteriaJSON).length) {
							results.push(record);
						}
					} catch (error) {
						console.warn("Criteria : Invalid JSON format");
					}
				} else {
					results.push(record);
				}
			});
			return results;
		}


		function handleFieldChange(field) {
			// Validate tx-pattern
			if (field.validation['tx-pattern'] && vm.currentFocusedField === field.field) {
					vm.validateTxPattern(field);
			}

			// Handle lookup source attribute changes
			if (field.isLookupSourceAttribute) {
					vm.lookupSourceAttributeChanged(field);
			}

			// if this attribute is a dependant attribute of any criteria attribute revalidat the values of criteria attributes
			var dependentAttributeField = field.field;
			if(vm.criteriaDeptAttributeMap[dependentAttributeField]) {
					var criteriaAttributes = vm.criteriaDeptAttributeMap[dependentAttributeField];
					angular.forEach(criteriaAttributes, function(criteriaAttribute) {
							var criteriaField = utility.filterObject(vm.requiredAttributesList, { field: criteriaAttribute }, true)[0];
							if (!criteriaField) { return; } // target criteria attribute isn't a field in this dialog -> nothing to refresh/clear
							var isMultiValueAttribute = (criteriaField.inputType === 'multi-value') ? true : false;
							// CriteriaV2 (preferred): refresh dropdown + clear current value if not in matched rule's AllowedValues
							if(vm.criteriaV2Map[criteriaAttribute]) {
								vm.getConditionalVettingList(criteriaField);
								var getDependentValueForCriteriaV2 = function(dependentField) {
									var depVal = vm.record[dependentField];
									return (depVal && typeof depVal === 'object') ? (angular.isDefined(depVal.value) ? depVal.value : depVal) : depVal;
								};
								var criteriaV2AllowedLower = utility.getCriteriaV2AllowedValues(vm.criteriaV2Map[criteriaAttribute], getDependentValueForCriteriaV2)
									.map(function(value) { return value.toString().toLowerCase(); });
								var currentCriteriaValue = vm.record[criteriaAttribute];
								var isCriteriaV2Valid;
								if (isMultiValueAttribute) {
									isCriteriaV2Valid = (Array.isArray(currentCriteriaValue) && currentCriteriaValue.length > 0)
										? currentCriteriaValue.every(function(value) { return criteriaV2AllowedLower.indexOf((value == null ? '' : value).toString().toLowerCase()) !== -1; })
										: true;
								} else {
									isCriteriaV2Valid = (currentCriteriaValue === null || currentCriteriaValue === undefined || currentCriteriaValue === '')
										? true
										: criteriaV2AllowedLower.indexOf(currentCriteriaValue.toString().toLowerCase()) !== -1;
								}
								if (!isCriteriaV2Valid) {
									vm.record[criteriaAttribute] = isMultiValueAttribute ? [] : null;
									vm.editForm[criteriaAttribute].$touched = true;
								}
								return; // skip OLD criteria path
							}
							var attributeCriteria = {};
							angular.forEach(vm.dependingAttributesMap, function(criteriaAttr) {
									for(var key in criteriaAttr) {
											if(criteriaAttr.hasOwnProperty(key)) {
													if(key.toLocaleLowerCase() === criteriaAttribute.toLowerCase()) {
															attributeCriteria = criteriaAttr[key];
															break;
													}
											}
									}
							});
							if(angular.isDefined(attributeCriteria[dependentAttributeField][vm.record[dependentAttributeField]])) {
									var index = attributeCriteria[dependentAttributeField][vm.record[dependentAttributeField]].indexOf(vm.record[criteriaAttribute]);
									if (index === -1) {
											vm.record[criteriaAttribute] = isMultiValueAttribute ? [] : null;
											vm.editForm[criteriaAttribute].$touched = true;
									}
							} else {
									vm.record[criteriaAttribute] = isMultiValueAttribute ? [] : null;
									vm.editForm[criteriaAttribute].$touched = true;
							}
					});
			}
		}


		function onSearchTextChanged() {
			if (!vm.searchPageText) {
				vm.filteredRequiredAttributesList = angular.copy(vm.requiredAttributesList);
					return;
			}

			vm.filteredRequiredAttributesList = vm.requiredAttributesList.filter(function(item) {
					if (!item || !item.displayLabel) return false;

					var translatedLabel = $translate.instant(item.displayLabel);
					return translatedLabel.toLowerCase().indexOf(vm.searchPageText.toLowerCase()) !== -1;
			});
		}

		function isFormValid() {
			var isRequiredFieldsValid = true;
			// check if any required fields are empty
			angular.forEach(vm.requiredAttributesList, function (field) {
					if (field.validation && field.validation.isRequired) {
							if (angular.isUndefined(vm.record[field.field]) || vm.record[field.field] === null || vm.record[field.field] === '') {
									isRequiredFieldsValid = false;
							}
					}
			});
			return vm.editForm.$valid && isRequiredFieldsValid;
		}

	}
})();
(function () {
	'use strict';

	angular
		.module('app.main.catalogs.articles')
		.controller('createSingleLinePlanArticleController', createSingleLinePlanArticleController);

	/* @ngInject */
	function createSingleLinePlanArticleController($mdDialog, $scope, $filter, scope, toast, hotkeys, utility, catalogFactory, model, record, parentId, filterExpression, articleTypeAttribute, api, $translate) {
		var vm = this;
		var activeCatalogDetails = catalogFactory.getActiveCatalogDetails();
		var linkedAttributes = activeCatalogDetails.LinkedAttributeList;
		var linkedAttributesMap = {};
		var assignedAttributes = activeCatalogDetails.AssignedCatalogAttributes;
		var assignedAttributeMap = {};
		vm.acSelectedItem = [];
		vm.acSearchText = [];
		vm.searchText = {};
		vm.searchValue = {};

		vm.visibleFields = [];
		vm.isLoading = false;
		vm.model = model;
		vm.record = {};
		vm.isDataDirty = false;
		vm.filterExpression = filterExpression;
		vm.dependingAttributesMap = [];
		vm.criteriaDeptAttributeMap = {};
		vm.vettingListCriteriaList = [];
		vm.criteriaV2Map = {}; // AttributeSystemName -> parsed CriteriaV2 rules array (preferred over OLD Criteria)
		vm.linkedCatalogSeasons = [];
		var validSellerLookupsDestinationAttributesMap = api.validSellerLookupsDestinationAttributesMap;
		vm.lookupSourceAndDeptAttributeMap = {};
		vm.showColorTypeInColorPalatteDropdown = api.showColorTypeInColorPalatteDropdown

		// methods

		vm.saveRecord = saveRecord;
		vm.closeDialog = closeDialog;
		vm.isInputRequired = isInputRequired;
		vm.getConditionalVettingList = getConditionalVettingList;
		vm.transformChip = transformChip;
		vm.multiValueQuerySearch = multiValueQuerySearch;
		vm.lookupSearch = lookupSearch;
		vm.lookupChange = lookupChange;
		vm.getLookupDisplayValue = getLookupDisplayValue;
		vm.clearSearchTerm = clearSearchTerm;
		vm.colorPaletteLookupChange = colorPaletteLookupChange;
		vm.lookupSourceAttributeChanged = lookupSourceAttributeChanged;
		vm.handleFieldChange = handleFieldChange;
		vm.onSearchTextChanged = onSearchTextChanged;

		activate();

		////////////////

		function activate() {
			angular.forEach(linkedAttributes, function (linkedAttribute) {
				linkedAttributesMap[linkedAttribute.AttributeSystemName] = 1;
			});
			angular.forEach(assignedAttributes, function (assignedAttribute) {
				assignedAttributeMap[assignedAttribute.AttributeSystemName] = assignedAttribute.AllowedValues;
			});
			vm.record['ModelNumber'] = record['ModelNumber'];
			vm.visibleFields = getVisibleFields(vm.model);
			updateFields();
			vm.filteredVisibleFields = angular.copy(vm.visibleFields)

			//Hotkeys
			hotkeys.bindTo($scope)
				.add({
					combo: 'ctrl+enter',
					description: $filter('translate')('ACTIONS.SAVE'),
					allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
					callback: function (event) {
						if (!vm.isLoading && !vm.editForm.$invalid) {
							vm.saveRecord();
						}
					}
				});

			hotkeys.bindTo($scope)
				.add({
					combo: 'ctrl+shift+enter',
					description: $filter('translate')('ACTIONS.SAVE_AND_NEW'),
					allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
					callback: function () {
						if (!vm.isLoading && !vm.editForm.$invalid) {
							vm.saveRecord(true);
						}
					}
				});
		}

		function saveRecord() {
			vm.isLoading = true;
			var p;
			// pass image id and image source for single article create(comp & carryover) to API
			vm.record.ImageId = record.ImageId;
			vm.record.ImageSource = record.ImageSource;
			//remove linked attributes from carryover and add IsCarryOverArticle flag as 1
			if (articleTypeAttribute && articleTypeAttribute.toLowerCase() === 'carryover') {
				vm.record.IsCarryOverArticle = 1;
				angular.forEach(linkedAttributes, function(linkedAttribute) {
					//check current and previous linked attribute values, if there is no change in.
					if((vm.record[linkedAttribute.AttributeSystemName] === record[linkedAttribute.AttributeSystemName]) || !linkedAttribute.Editable) {
						delete vm.record[linkedAttribute.AttributeSystemName];
					}
				});
			} else if (articleTypeAttribute && articleTypeAttribute.toLowerCase() === 'new') {
				//if user entered any value for linkedattributes send those values to api with IsCarryOverArticle else remove linkedattributes and send IsCarryOverArticle flag as 1
				angular.forEach(linkedAttributes, function(linkedAttribute) {
					//check current and previous linked attribute values, if there is no change in.
					if(vm.record[linkedAttribute.AttributeSystemName] === record[linkedAttribute.AttributeSystemName]) {
						delete vm.record[linkedAttribute.AttributeSystemName];
					}
				});
				vm.record.IsCarryOverArticle = 1;
			}

			//Transform the fields of type dateUTC
			angular.forEach(vm.model.fields, function(itm) {
				// to avoid timezone issue
				if ((itm.inputType === 'date-utc' || itm.inputType === 'date') && angular.isDefined(vm.record[itm.field]) &&  angular.isDate(vm.record[itm.field])) {
						var d = vm.record[itm.field];
						vm.record[itm.field] = new Date(d.setHours(12-(d.getTimezoneOffset()/60),0,0));
				}

				// remove time from date-option and date type attributes
				if ((itm.inputType === 'date-option' || itm.inputType === 'date-without-time') && angular.isDefined(vm.record[itm.field]) &&  angular.isDate(vm.record[itm.field])) {
						var d = vm.record[itm.field];
						var dateValueWithTime = new Date(d.setHours(12-(d.getTimezoneOffset()/60),0,0)).toISOString();
						vm.record[itm.field] = dateValueWithTime.split('T', 1)[0];
				}

				if (itm.inputType === 'calculated') {
						delete vm.record[itm.field];
				}

				if ((itm.inputType === 'number' || itm.type === 'int') && vm.record[itm.field] != null) {
					vm.record[itm.field] = parseInt(vm.record[itm.field]);
				}

				if ((itm.inputType === 'articlenumber' || itm.inputType === 'modelnumber') && angular.isDefined(vm.record[itm.field]) && vm.record[itm.field] != null && vm.record[itm.field].toString().length > 0) {
						vm.record[itm.field] = vm.record[itm.field].toString();
				}

				if ((itm.inputType === 'color-palette') && angular.isDefined(vm.record[itm.field]) && vm.record[itm.field] != null && vm.record[itm.field] !== '' && angular.isObject(vm.record[itm.field])) {
					var key = Object.keys(vm.record[itm.field])[0];
					var val = vm.record[itm.field][key];
					if (typeof val === 'string' && val.includes(':')) {
						val = val.split(':')[1].trim();
					}
					vm.record[itm.field][key] = val;
					vm.record[itm.field] = angular.toJson(vm.record[itm.field]);
				}

				// remove all invisible special characters from strings
				if ((itm.inputType === 'text' || itm.inputType === 'textArea') && vm.record[itm.field] != null && vm.record[itm.field] !== '' && typeof vm.record[itm.field] === 'string') {
					vm.record[itm.field] = vm.record[itm.field].replace(/[\u00A0\u00AD\u200B-\u200D\uFEFF\u2028\u2029\u2060]/g, '');
				}

				if ((itm.inputType === 'multi-value' || itm.inputSubType === 'multi-value') && vm.record[itm.field] != null && vm.record[itm.field] !== '' && vm.record[itm.field].length) {
					angular.forEach(vm.record[itm.field], function(value, index) {
						vm.record[itm.field][index] = value.replace(/[\u00A0\u00AD\u200B-\u200D\uFEFF\u2028\u2029\u2060]/g, '');
					})
				}

				if (itm.inputType === 'dataset' && vm.record[itm.field] != null && vm.record[itm.field] !== '') {
					if(typeof (vm.record[itm.field]) === 'object') {
							vm.record[itm.field] = Object.keys(vm.record[itm.field])[0].toString()
					}
					else {
							vm.record[itm.field] = vm.record[itm.field].toString();
					}
				}

				if(itm.inputType === 'datatable' && vm.record[itm.field] != null && vm.record[itm.field] !== '') {
					vm.record[itm.field] = (typeof vm.record[itm.field] === 'string') ? vm.record[itm.field] : angular.toJson(vm.record[itm.field]);
				}
			});

			p = vm.model.methods.create(vm.record, parentId, vm.model, articleTypeAttribute);
			p.then(function (response) {
					closeDialog(true);
					var toastMessage = 'SUCCESS.CREATE';
					toast.success(toastMessage, '', '');
			}, function () {
				closeDialog(vm.isDataDirty);
			}).finally(function () {
				vm.isLoading = false;
			})
		}

		function closeDialog(saved) {
			$mdDialog.hide(saved);
		}

		function isInputRequired(field) {
			if (angular.isString(field.validation.isRequired)) {
				return (scope.$eval(field.validation.isRequired) && (angular.isUndefined(field.validation.disabledCriteria) || !scope.$eval(field.validation.disabledCriteria)));
			} else {
				return (field.validation.isRequired && (angular.isUndefined(field.validation.disabledCriteria) || !scope.$eval(field.validation.disabledCriteria)));
			}
		}

		function getConditionalVettingList(field) {
			var attribute = field.field;
			// CriteriaV2 (preferred): dropdown = matched rule's AllowedValues ([] when no rule matches)
			if (vm.criteriaV2Map[attribute]) {
				var getDependentValueForCriteriaV2 = function(dependentField) {
					var depVal = vm.record[dependentField];
					return (depVal && typeof depVal === 'object') ? (angular.isDefined(depVal.value) ? depVal.value : depVal) : depVal;
				};
				var criteriaV2Allowed = utility.getCriteriaV2AllowedValues(vm.criteriaV2Map[attribute], getDependentValueForCriteriaV2);
				var criteriaV2AttributeField = utility.filterObject(vm.filteredVisibleFields || vm.visibleFields, { field: attribute }, true)[0];
				if (angular.isDefined(criteriaV2AttributeField)) {
					criteriaV2AttributeField.values = (criteriaV2Allowed || [])
						.map(function(value) { return value.toString().trim(); })
						.sort(function(a, b) { return a.toLowerCase().localeCompare(b.toLowerCase()); });
				}
				return;
			}
			var criteriaObj = {};
			var catalogAttribute = utility.filterObject(catalogFactory.getActiveCatalogDetails().AssignedCatalogAttributes,
					{ AttributeSystemName: attribute }, true)[0];
			var catalogAttributeAllowedValues = (catalogAttribute.AllowedValues || []).map(function (v) {
					return v.toString().toLowerCase()
			})
			angular.forEach(vm.vettingListCriteriaList, function(criteriaAttr) {
					for(var key1 in criteriaAttr) {
							if(criteriaAttr.hasOwnProperty(key1)) {
									if(key1.toLocaleLowerCase() === attribute.toLowerCase()) {
											criteriaObj = criteriaAttr[key1];
											break;
									}
							}
					}
			});

			var validValues = [];
			var noMatch = true
			Object.keys(criteriaObj).forEach(function (key) {
					var item = criteriaObj[key];
					var subItems = Object.keys(item);
					var validItems = 0;
					subItems.forEach(function (key2) {
							if (vm.record.hasOwnProperty(key2) && vm.record[key2] != null && vm.record[key2] !== '') {
									var articleAttributeValue = typeof(vm.record[key2]) === 'object' ?
											angular.isDefined(vm.record[key2]['value']) ? vm.record[key2]['value'] : vm.record[key2] :
											vm.record[key2];
									var isDate = validateDate(articleAttributeValue);
									if(articleAttributeValue != null && articleAttributeValue.toString() != '') {
											noMatch = false;
											var lowerCaseValues = item[key2].map(function (value) {
													return isDate == true ? new Date(value).getTime().toString().toLowerCase() : value.toString().toLowerCase();
											});

											if(isDate == true) {
													// remove time while comparing date-without-time and date-option values
													if(field.inputType === 'date-option' || field.inputType === 'date-without-time') {
															lowerCaseValues = lowerCaseValues.split('T', 1)[0];
													}
													if(lowerCaseValues.indexOf(new Date(articleAttributeValue).getTime().toString().toLowerCase()) !== -1) {
														validItems++;
													}
											} else {
													if(lowerCaseValues.indexOf(articleAttributeValue.toString().toLowerCase()) !== -1) {
															validItems++;
													}
											}
									}
							} else {
								validItems++;
							}
					});

					if (subItems.length == validItems && catalogAttributeAllowedValues.indexOf(key.toLowerCase()) !== -1) {
							validValues.push(key);
					}
			});
			var attributeField = utility.filterObject(vm.filteredVisibleFields, {field: attribute}, true)[0];
			if (!noMatch) {
				attributeField.values = (validValues || [])
				.map(function(value) {
					return value.trim();
				})
				.sort(function(a, b) {
					return a.toLowerCase().localeCompare(b.toLowerCase());
				})
			} else {
				attributeField.values = (catalogAttribute.AllowedValues || [])
				.map(function(value) {
					return value.trim();
				})
				.sort(function(a, b) {
					return a.toLowerCase().localeCompare(b.toLowerCase());
				})
			}
	}

	function validateDate(value, formats) {
			if(angular.isUndefined(formats)) {
					formats = [
							moment.ISO_8601
					];
			}
			return moment(value, formats, true).isValid();
	}

	function transformChip(chip, isMultiValue) {
		if(isMultiValue) {
				return chip;
		}
		return undefined;
	}

	function multiValueQuerySearch(query, selectedItems, field) {
		if(field.isCriteriaAdded) {
				getConditionalVettingList(field);
		}
		var values = field.values;
		var searchQueryResult = [];
		var searchQueryResult = utility.filterObject(values, query);
		if (selectedItems && selectedItems.length > 0) {
			for (var index = searchQueryResult.length - 1; index >= 0; index--) {
				if (selectedItems.indexOf(searchQueryResult[index]) !== -1) {
					searchQueryResult.splice(index, 1);
				}
			}
		}
		return searchQueryResult;
	}

	function lookupSearch(query, field) {
			var results = [];
			var lookupFilter = angular.isDefined(field.lookupFilter) ? field.lookupFilter : {};
			var predicate = angular.copy(lookupFilter);
			predicate.value = query;
			var lookupModel = api.getModel(field.lookupSource);

			if(lookupModel && angular.isDefined(lookupModel.lookupData) && angular.isDefined(lookupModel.lookupData.data) && lookupModel.lookupData.data.length) {
				results = query ? utility.filterObject(lookupModel.lookupData.data, predicate) : utility.filterObject(lookupModel.lookupData.data, lookupFilter, true);
			}
			else {
				lookupPromises[field.field].then(function (lookupData) {
					var lookupDataList = lookupData.data;
					results = query ? utility.filterObject(lookupDataList, predicate) : utility.filterObject(lookupDataList, lookupFilter, true);
				});
			}
			return	results;
	}

	// convert dropdown scope value form object(lookup record) to id property of lookup record
	function lookupChange(selectedObj, field) {
			if(angular.isObject(selectedObj)) {
					vm.record[field] = selectedObj.id;
			}
			else if(angular.isUndefined(selectedObj) || selectedObj === null){
					vm.record[field] = undefined; // on record removal make field undefined or the property can be deleted using delete keywork
			}
	}

	function colorPaletteLookupChange(selectedObj, field) {
		if(angular.isObject(selectedObj) && Object.keys(selectedObj)[0] != null && angular.isDefined(selectedObj.value)) {
				// color palette values are stores as key value pair
				var objectVal = {};
				objectVal[selectedObj.id] = selectedObj.value
				vm.record[field.field] = objectVal;
		}
		else if(angular.isUndefined(selectedObj) || selectedObj === null){
				vm.record[field.field] = undefined; // on record removal make field undefined or the property can be deleted using delete keywork
		}
	}

	// isArticleNumberType for converting article id from string to int
	function getLookupDisplayValue(item, field, isArticleNumberType) {
			var lookupModel = api.getModel(field.lookupSource);
			item = isArticleNumberType ? parseInt(item) : item;

			if (angular.isDefined(lookupModel.lookupData) && angular.isDefined(lookupModel.lookupData.data) && lookupModel.lookupData.data.length) {
				return getLookupDisplayVal(item, lookupModel.lookupData, field);
			}
			else {
				return lookupPromises[field.field].then(function (lookupData) {
					return getLookupDisplayVal(item, lookupData, field);
				});
			}
		}

	//helper method
	function getLookupDisplayVal(item, lookupData) {
			var result;
			if(lookupData) {
					// since autocomplte return object
					if(angular.isObject(item)) {
							result = utility.filterObject(lookupData.data, {id: item.id}, true);
					}
					// to initialize field value if any (when open update record dialog)
					else {
							result = utility.filterObject(lookupData.data, {id: item}, true);
					}

					if (angular.isArray(result) && result.length > 0) {
							return result[0].value;
					}
					else {
							return result.value;
					}
			}
	}

		// This function update the field depending on input types, Also populate linked attributes and Vetting list attribute values
		function updateFields() {
			for (var i = 0; i < vm.model.fields.length; i++) {

				// for listing populated values of attributes in active catalog's attributeVettingList
				if ((vm.model.fields[i].inputType === 'list' || (vm.model.fields[i].inputType === 'multi-value')) && assignedAttributeMap[vm.model.fields[i].field]) {
						vm.model.fields[i].values = utility.splitString(assignedAttributeMap[vm.model.fields[i].field], ',');
						var attribute = utility.filterObject(assignedAttributes, {AttributeSystemName: vm.model.fields[i].field}, true)[0];
						// for multivalue dropdown make the record as array
						if(vm.model.fields[i].inputType === 'multi-value') {
							vm.record[vm.model.fields[i].field] = [];
						}
						// for attribute vetting list criteria — CriteriaV2 preferred over OLD Criteria
						if(vm.model.fields[i].isDynamicProperty && attribute.CriteriaV2 && attribute.CriteriaV2.length > 0) {
							try {
									vm.criteriaV2Map[attribute.AttributeSystemName] = JSON.parse(attribute.CriteriaV2);
							} catch(error) {
									console.warn(attribute.AttributeDisplayName + " - Attribute CriteriaV2: Invalid JSON Format");
							}
							vm.model.fields[i].isCriteriaAdded = true;
							var v2DependentDisplayNames = [];
							utility.getCriteriaV2DependentFields(vm.criteriaV2Map[attribute.AttributeSystemName]).forEach(function(depKey) {
									var v2DependentField = utility.filterObject(vm.visibleFields, {field: depKey}, true)[0];
									if(angular.isDefined(v2DependentField)) {
											if(!vm.criteriaDeptAttributeMap[depKey]) {
													vm.criteriaDeptAttributeMap[depKey] = [];
											}
											if(vm.criteriaDeptAttributeMap[depKey].indexOf(attribute.AttributeSystemName) === -1) {
													vm.criteriaDeptAttributeMap[depKey].push(attribute.AttributeSystemName);
											}
											v2DependentField.isDependentAttribute = true;
											v2DependentDisplayNames.push(utility.getAttributeDisplayNameUsingSystemName(catalogFactory.getActiveCatalogDetails().AssignedCatalogAttributes, depKey));
									}
							});
							vm.model.fields[i].criteriaDisplayMessage = 'Attribute '+ attribute.AttributeDisplayName +' is dependent on the attribute(s) ' + v2DependentDisplayNames + '.';
						} else if(vm.model.fields[i].isDynamicProperty && attribute.Criteria.length > 0) {
							// parse json
							try {
									var vettinglistCriteria = JSON.parse(attribute.Criteria);
							} catch(error) {
									console.warn(attribute.AttributeDisplayName + " - Attribute Criteria: Invalid JSON Format");
							}
							var dependentAttributesDisplayNames = [];
							vm.model.fields[i].isCriteriaAdded = true;
							var dependingAttributes = {};
							var obj2 = {};
							for(var key in vettinglistCriteria) {
									if(vettinglistCriteria.hasOwnProperty(key)) {
											var deptAttr = vettinglistCriteria[key];
											for(var key1 in deptAttr) {
													var obj = {};
													if(deptAttr.hasOwnProperty(key1)) {
															var index = dependentAttributesDisplayNames.indexOf(utility.getAttributeDisplayNameUsingSystemName(catalogFactory.getActiveCatalogDetails().AssignedCatalogAttributes, key1));
															if( index === -1 ) {
																	var dependentAttributeField = utility.filterObject(vm.visibleFields, {field: key1}, true)[0];
																	if(angular.isDefined(dependentAttributeField)) {
																		if(!vm.criteriaDeptAttributeMap[key1]) {
																				vm.criteriaDeptAttributeMap[key1] = [];
																			}
																			vm.criteriaDeptAttributeMap[key1].push(attribute.AttributeSystemName);
																			dependentAttributesDisplayNames.push(utility.getAttributeDisplayNameUsingSystemName(catalogFactory.getActiveCatalogDetails().AssignedCatalogAttributes, key1));
																			dependentAttributeField.isDependentAttribute = true;
																	}
															}
															if(obj2[key1]) {
																	angular.forEach(deptAttr[key1], function(val) {
																			if(obj2[key1][val]) {
																					if(obj2[key1][val].indexOf(key)) {
																							obj2[key1][val].push(key);
																					}
																			} else {
																					obj2[key1][val] = [key];
																			}
																	});
															} else {
																	angular.forEach(deptAttr[key1], function(val) {
																			obj[val] = [key];
																	});
																	obj2[key1] = obj;
															}
													}
											}
									}
							}
							dependingAttributes[attribute.AttributeSystemName] = obj2;
							vm.dependingAttributesMap.push(dependingAttributes);
							var obj = {};
							obj[attribute.AttributeSystemName] = vettinglistCriteria;
							vm.vettingListCriteriaList.push(obj);
							var criteriaDisplayMessage = 'Attribute '+ attribute.AttributeDisplayName +' is dependent on the attribute(s) ' + dependentAttributesDisplayNames + '.';
							vm.model.fields[i].criteriaDisplayMessage = criteriaDisplayMessage;
						}
				}

				else if (vm.model.fields[i].inputType === 'bool-str') {
					if (angular.isUndefined(vm.record[vm.model.fields[i].field])) {
						vm.record[vm.model.fields[i].field] = 'false';
					}
				}

				else if (vm.model.fields[i].inputType === 'date' || vm.model.fields[i].inputType === 'date-option') { // workaround for issue with interpolation on ng-disabled on md-datepicker
					if ($scope.$eval(vm.model.fields[i].validation.disabledCriteria) || (vm.model.fields[i].showInEdit && !vm.model.fields[i].editable)) {
						vm.model.fields[i].validation.disabled = true;
					} else {
						vm.model.fields[i].validation.disabled = false;
					}
				}
				else if (vm.model.fields[i].inputType === 'date-without-time') { // workaround for issue with interpolation on ng-disabled on md-datepicker
					if ($scope.$eval(vm.model.fields[i].validation.disabledCriteria) || (vm.model.fields[i].showInEdit && !vm.model.fields[i].editable)) {
						vm.model.fields[i].validation.disabled = true;
					} else {
						vm.model.fields[i].validation.disabled = false;
					}
				}
				else if (vm.model.fields[i].inputType === 'calculated') { // calculated fields are not creatable
						vm.model.fields[i].creatable = false;
				}

				else if(vm.model.fields[i].inputType === 'textArea') {
					if (angular.isDefined(record[vm.model.fields[i].field]) && record[vm.model.fields[i].field] !== null && record[vm.model.fields[i].field].length > 0) {
						vm.record[vm.model.fields[i].field] = record[vm.model.fields[i].field];
					}
				}

				else if (vm.model.fields[i].inputType === 'lookup-table') {
					vm.model.fields[i].isLookupAdded = true;
					if (angular.isDefined(validSellerLookupsDestinationAttributesMap[vm.model.fields[i].field])) {
							var attributeLookupValues = validSellerLookupsDestinationAttributesMap[vm.model.fields[i].field];
							var sourceAttributesDisplayNames = [];
							var matched = false;
							for (var j = 0; j < attributeLookupValues.length; j++) {
									var allAttributesMatch = true;
								var value = attributeLookupValues[j];
									for (var attributeSystemName in value.Source) {
											if (value.Source.hasOwnProperty(attributeSystemName)) {
												if(vm.record[attributeSystemName] == null || value.Source[attributeSystemName].toString().toLowerCase() !== vm.record[attributeSystemName].toString().toLowerCase()) {
														allAttributesMatch = false;
														break;
												}
											}
									}

									if (allAttributesMatch) {
											if(vm.record[vm.model.fields[i].field] !== value.Destination[vm.model.fields[i].field]) {
													vm.record[vm.model.fields[i].field] = value.Destination[vm.model.fields[i].field];
											}
											matched = true;
											break;
									}
							}

							// create source attributes map
							if(attributeLookupValues.length) {
									var firstSourceDestinationValue = attributeLookupValues[0];
									for (var attributeSystemName in firstSourceDestinationValue.Source) {
											var index = sourceAttributesDisplayNames.indexOf(utility.getAttributeDisplayNameUsingSystemName(catalogFactory.getActiveCatalogDetails().AssignedCatalogAttributes, key1));
											if (index === -1) {
													sourceAttributesDisplayNames.push(utility.getAttributeDisplayNameUsingSystemName(catalogFactory.getActiveCatalogDetails().AssignedCatalogAttributes, key1));
													var sourceAttributeField = utility.filterObject(vm.visibleFields, { field: attributeSystemName }, true)[0];
													if (angular.isDefined(sourceAttributeField)) {
															sourceAttributeField.isLookupSourceAttribute = true;
													}
											}
											if (!vm.lookupSourceAndDeptAttributeMap[attributeSystemName]) {
													vm.lookupSourceAndDeptAttributeMap[attributeSystemName] = [];
											}
											if (vm.lookupSourceAndDeptAttributeMap[attributeSystemName].indexOf(vm.model.fields[i].field) === -1) {
													vm.lookupSourceAndDeptAttributeMap[attributeSystemName].push(vm.model.fields[i].field);
											}
									}
							}
							if (!matched) {
									vm.record[vm.model.fields[i].field] = null;
							}
							field.lookupDisplayMessage = 'Attribute ' + field.displayLabel + ' is dependent on the attribute(s) ' + sourceAttributesDisplayNames.join(', ') + '.';
					} else {
						field.lookupDisplayMessage = 'Attribute ' + field.displayLabel + ' does not have any source attribute(s) assigned';
					}
				}

				if (linkedAttributesMap[vm.model.fields[i].field]) {
					// linked attributes will be editable if Editable property is true for linked attribute
					// if linked attribute is defined in app.config.json then priority goes to config value(we can only make the linked attribute noneditable by configuration)
					if (articleTypeAttribute.toLowerCase() === 'carryover') {
						if(angular.isDefined(vm.model.fields[i].isLinkedAttributeCreatable)) {
							if(vm.model.fields[i].isLinkedAttributeCreatable) {
								vm.model.fields[i].editable = true;
								vm.model.fields[i].showInEdit = true;
								vm.model.fields[i].validation.disabledCriteria = false;
							} else if(!vm.model.fields[i].isLinkedAttributeCreatable) {
								vm.model.fields[i].validation.disabledCriteria = true;
							}
						} else {
							var isLinkedAttributeEditable = angular.isDefined(utility.filterObject(linkedAttributes,{AttributeSystemName: vm.model.fields[i].field} , true)[0]) ?
								utility.filterObject(linkedAttributes,{AttributeSystemName: vm.model.fields[i].field} , true)[0].Editable : false;
							if(isLinkedAttributeEditable === 0) {
								vm.model.fields[i].validation.disabledCriteria = true;
							} else if(isLinkedAttributeEditable === 1) {
								vm.model.fields[i].editable = true;
								vm.model.fields[i].showInEdit = true;
								vm.model.fields[i].validation.disabledCriteria = false;
							}
						}
					}
					if(vm.model.fields[i].inputType !== 'multi-value') {
						vm.record[vm.model.fields[i].field] = record[vm.model.fields[i].field]; // populate linked attributes value
					}
				}

				if (articleTypeAttribute.toLowerCase() === 'carryover' && vm.model.fields[i].field === 'ArticleName') { // article name should be non editable and same as carryover article
					vm.model.fields[i].validation.disabledCriteria = true;
					vm.record[vm.model.fields[i].field] = record[vm.model.fields[i].field];
				}

				if (articleTypeAttribute.toLowerCase() === 'linkedcatalogarticlenumber') { // for linkedcatalogarticlenumber types get the linked catalog seasons
					var linkedCatalogs = activeCatalogDetails.LinkedCatalogList;
					if(linkedCatalogs.length > 0) {
						angular.forEach(linkedCatalogs, function(catalog, $index) {
							var seasonObject = {
								id: $index,
								value: catalog.Season
							}
							vm.linkedCatalogSeasons.push(seasonObject);
						});
					}
				}
			}
		}

		function getVisibleFields(model) {
			return $filter('filterUnion')(model.fields, vm.filterExpression);
		}

		function clearSearchTerm(field) {
			vm.searchValue[field] = '';
		};

		// when lookup source attribute changed
		function lookupSourceAttributeChanged(field) {
			var sourceAttributeName = field.field;
			if (vm.lookupSourceAndDeptAttributeMap.hasOwnProperty(sourceAttributeName)) {
					var dependentAttributeNames = vm.lookupSourceAndDeptAttributeMap[sourceAttributeName];
					for (var i = 0; i < dependentAttributeNames.length; i++) {
							var dependentAttributeName = dependentAttributeNames[i];
							if (angular.isDefined(validSellerLookupsDestinationAttributesMap[dependentAttributeName])) {
									var attributeLookupValues = validSellerLookupsDestinationAttributesMap[dependentAttributeName];
									var matched = false;
									for (var j = 0; j < attributeLookupValues.length; j++) {
											var allAttributesMatch = true;
										var value = attributeLookupValues[j];
											for (var attributeSystemName in value.Source) {
													if (value.Source.hasOwnProperty(attributeSystemName)) {
														if(vm.record[attributeSystemName] == null || value.Source[attributeSystemName].toString().toLowerCase() !== vm.record[attributeSystemName].toString().toLowerCase()) {
																allAttributesMatch = false;
																break;
														}
													}
											}
											if (allAttributesMatch) {
													if(vm.record[dependentAttributeName] !== value.Destination[dependentAttributeName]) {
														vm.record[dependentAttributeName] = value.Destination[dependentAttributeName];
													}
													matched = true;
													break;
											}
									}
									if (!matched) {
											vm.record[dependentAttributeName] = null;
									}
							}
					}
			}
		}

		function handleFieldChange(field) {
				// Handle lookup source attribute changes
				if (field.isLookupSourceAttribute) {
						vm.lookupSourceAttributeChanged(field);
				}

				// if this attribute is a dependant attribute of any criteria attribute revalidat the values of criteria attributes
				var dependentAttributeField = field.field;
				if(vm.criteriaDeptAttributeMap[dependentAttributeField]) {
						var criteriaAttributes = vm.criteriaDeptAttributeMap[dependentAttributeField];
						angular.forEach(criteriaAttributes, function(criteriaAttribute) {
								var criteriaField = utility.filterObject(vm.visibleFields, {field: criteriaAttribute}, true)[0];
								if (!criteriaField) { return; } // target criteria attribute isn't a field in this dialog -> nothing to refresh/clear
								var isMultiValueAttribute = (criteriaField.inputType === 'multi-value') ? true : false;
								// CriteriaV2 (preferred): refresh dropdown + clear current value if not in matched rule's AllowedValues
								if(vm.criteriaV2Map[criteriaAttribute]) {
										getConditionalVettingList(criteriaField);
										var getDependentValueForCriteriaV2 = function(dependentField) {
												var depVal = vm.record[dependentField];
												return (depVal && typeof depVal === 'object') ? (angular.isDefined(depVal.value) ? depVal.value : depVal) : depVal;
										};
										var criteriaV2AllowedLower = utility.getCriteriaV2AllowedValues(vm.criteriaV2Map[criteriaAttribute], getDependentValueForCriteriaV2)
												.map(function(value) { return value.toString().toLowerCase(); });
										var currentCriteriaValue = vm.record[criteriaAttribute];
										var isCriteriaV2Valid;
										if (isMultiValueAttribute) {
												isCriteriaV2Valid = (Array.isArray(currentCriteriaValue) && currentCriteriaValue.length > 0)
														? currentCriteriaValue.every(function(value) { return criteriaV2AllowedLower.indexOf((value == null ? '' : value).toString().toLowerCase()) !== -1; })
														: true;
										} else {
												isCriteriaV2Valid = (currentCriteriaValue === null || currentCriteriaValue === undefined || currentCriteriaValue === '')
														? true
														: criteriaV2AllowedLower.indexOf(currentCriteriaValue.toString().toLowerCase()) !== -1;
										}
										if (!isCriteriaV2Valid) {
												vm.record[criteriaAttribute] = isMultiValueAttribute ? [] : null;
												if (vm.editForm && vm.editForm[criteriaAttribute]) {
														vm.editForm[criteriaAttribute].$touched = true;
												}
										}
										return; // skip OLD criteria path
								}
								var attributeCriteria = {};
								angular.forEach(vm.dependingAttributesMap, function(criteriaAttr) {
										for(var key in criteriaAttr) {
												if(criteriaAttr.hasOwnProperty(key)) {
														if(key.toLocaleLowerCase() === criteriaAttribute.toLowerCase()) {
																attributeCriteria = criteriaAttr[key];
																break;
														}
												}
										}
								});
								if(angular.isDefined(attributeCriteria[dependentAttributeField][vm.record[dependentAttributeField]])) {
										var index = attributeCriteria[dependentAttributeField][vm.record[dependentAttributeField]].indexOf(vm.record[criteriaAttribute]);
										if (index === -1) {
												vm.record[criteriaAttribute] = isMultiValueAttribute ? [] : null;
												vm.editForm[criteriaAttribute].$touched = true;
										}
								} else {
										vm.record[criteriaAttribute] = isMultiValueAttribute ? [] : null;
										vm.editForm[criteriaAttribute].$touched = true;
								}
						});
				}
		}

		function onSearchTextChanged() {
			if (!vm.searchPageText) {
				vm.filteredVisibleFields = angular.copy(vm.visibleFields);
					return;
			}

			vm.filteredVisibleFields = vm.visibleFields.filter(function(item) {
					if (!item || !item.displayLabel) return false;

					var translatedLabel = $translate.instant(item.displayLabel);
					return translatedLabel.toLowerCase().indexOf(vm.searchPageText.toLowerCase()) !== -1;
			});
		}
	}
})();
(function () {
	'use strict';

	angular
		.module('app.main.catalogs.articles')
		.controller('createLinePlanArticlesController', createLinePlanArticlesController);

	/* @ngInject */
	function createLinePlanArticlesController($document, $mdDialog, articlesFactory, model, linePlanModel, data, existingArticles, articleType, catalogCode, catalogFactory) {
		var vm = this;

		vm.data = data;
		vm.model = model;
		vm.filteredData = [];
		vm.isLoading = false;
		vm.articleType = articleType;
		var activeCatalogDetails = catalogFactory.getActiveCatalogDetails();
		var linkedAttributes = activeCatalogDetails.LinkedAttributeList;

		vm.closeDialog = closeDialog;
		vm.doListAction = doListAction;

		activate();

		////////////////

		function activate() {
			//if carryover then remove already created articles from vm.data (linkedCatalogModelsData)
			if (articleType && articleType.toLowerCase() === 'carryover' && vm.data && vm.data.length > 0) {
				var existingArticlesMap = {};
				angular.forEach(existingArticles, function (article) {
					existingArticlesMap[article.ArticleNumber] = 1;
				})
				for (var index = vm.data.length - 1; index >= 0; index--) {
					if (existingArticlesMap[vm.data[index].ModelNumber] === 1) {
						vm.data.splice(index, 1);
					}
				}
			}
			if (angular.isDefined(vm.tableControl) && angular.isDefined(vm.tableControl.updateData)) {
				vm.tableControl.updateData();
			}
		}

		function closeDialog() {
			$mdDialog.hide();
		}

		function doListAction(action, records) {
			switch (action.id) {
				case 'save':
					if(angular.isArray(records) && records.length === 1) {
						// single create
						$mdDialog.show({
							controller         : 'createSingleLinePlanArticleController',
							controllerAs       : 'vm',
							templateUrl        : 'app/main/catalogs/sub-modules/articles/dialogs/create-line-plan-articles/create-single-line-plan-article.html',
							parent             : angular.element($document.body),
							targetEvent        : null,
							clickOutsideToClose: false,
							multiple           : true,
							locals             : {
									editMode: false,
									model: angular.copy(linePlanModel),
									record : records[0],
									parentId : catalogCode,
									filterExpression: {creatable: true},
									articleTypeAttribute : vm.articleType
							}
						})
						.then(function(response) {
							if(response.toString().trim().toLowerCase() === 'true') {
								closeDialog();
							}
						});
					} else {
						closeDialog();
						angular.forEach(records, function (record) {
							//remove linked attributes from carry over and comp records
							angular.forEach(linkedAttributes, function(linkedAttribute) {
								delete record[linkedAttribute.AttributeSystemName];
							});
							record.IsCarryOverArticle = 1;
							//for carryover set attribute article_type value as carryover and ArticleNumber as ModelNumber
							if (articleType && articleType.toLowerCase() === 'carryover') {
								record.ArticleNumber = record.ModelNumber;
							} else if (articleType && articleType.toLowerCase() === 'new') {
								record.ArticleNumber = articlesFactory.generateArticleNumber();
							}
							record.article_type = articleType;
						});
						linePlanModel.methods.createBulk(linePlanModel, records, catalogCode);
					}
				break;
			}
		}

	}
})();
(function() {
	'use strict';

	angular
			.module('app.main.catalogs.articles')
			.controller('createArticleController', createArticleController);

	/* @ngInject */
	function createArticleController($mdDialog, $window, $scope, $filter, $document, scope, toast, hotkeys, $log, dialog, $translate,
							api, utility, editMode, model, record, defaultValues, parentId, additionalInfo, existingValues, existingRecordsForUniqueValue, lookupExtras, event, filterExpression, lookupPromises, $mdConstant, catalogFactory, mockFactory, crud, articlesFactory) {
			var vm = this;

			vm.visibleFields = [];
			vm.isLoading = false;
			vm.model = model;
			vm.record = angular.copy(record);
			vm.filterExpression = filterExpression;
			vm.AllowExternalChangeManagement = false;
			vm.checkingForLockedArticles = false;
			vm.isNew = false;
			vm.isDataDirty = false;
			vm.maxTags;
			vm.ErrorMessage = "";
			vm.colors = [];
			vm.randomColorForFavoriteTag = '';
			var months = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];

			vm.dependingAttributesMap = [];
			vm.criteriaDeptAttributeMap = {};
			vm.vettingListCriteriaList = [];
			vm.criteriaV2Map = {}; // AttributeSystemName -> parsed CriteriaV2 rules array (preferred over OLD Criteria)

			vm.acSelectedItem = [];
			vm.acSearchText = [];
			vm.searchText = {};
			vm.tagSeperatorKeys = {};
			vm.existingRecordsForUniqueValue = [];
			var isAdditionalActionAdded = angular.isDefined(additionalInfo) && angular.isDefined(additionalInfo.additionalAction) ? true : false;
			if(isAdditionalActionAdded) {
					var additionalAction = additionalInfo.additionalAction;
			}
			// this is to set a field with preselected value for lookup(used in shared folders module)
			// this have the field name and the value to be prepopulated for create(Entity with Merch as preselected)
			var isDefaultSelectedFieldValueAdded = (angular.isDefined(additionalInfo) && angular.isDefined(additionalInfo.isDefaultSelectedFieldValueAdded) && !utility.isObjectEmpty(additionalInfo.isDefaultSelectedFieldValueAdded)) ? true : false;
			vm.isNew = !editMode;
			if (!vm.record)
			{
					//Create empty object
					vm.record = {};
					vm.isNew = true;
					if(isDefaultSelectedFieldValueAdded) {
							var field = Object.keys(additionalInfo.isDefaultSelectedFieldValueAdded)[0];
							vm.record[field] = additionalInfo.isDefaultSelectedFieldValueAdded[field];
					}
					// set default state
					if(api.defaultCreateArticleState !== '') {
						var defaultState = utility.filterObject(api.articleStatesList, {StateName: api.defaultCreateArticleState, Status: 1}, true)[0];
						if(defaultState) {
							var defaultStateField = utility.filterObject(vm.model.fields, {field: 'StateId'}, true)[0];
							if(api.allowedStatesForCreateArticleConfig.length !== 0) {
								if(api.allowedStatesForCreateArticleConfig.includes(api.defaultCreateArticleState.toLowerCase())) {
									vm.record['StateId'] = defaultState.StateId;
								}
							}
							else { // asign default value
								vm.record['StateId'] = defaultState.StateId;
							}
							if(vm.record.StateId && vm.record.StateId !== null && vm.record.StateId !== 0) {
								vm.requiredAttributesErrorMessages = [];
								var requiredAttributes = defaultState.RequiredAttributes;
								var requiredAttributeNames = [];
								angular.forEach(requiredAttributes, function(attribute) {
									requiredAttributeNames.push(utility.getAttributeDisplayNameUsingSystemName(catalogFactory.getActiveCatalogDetails().AssignedCatalogAttributes, attribute.AttributeSystemName));
								});
								requiredAttributeNames.push(defaultState.IsPrimaryColorRequired ? 'Primary Color' : defaultState.IsSizeScaleRequired ? 'Size Scale' : '');
								defaultStateField.requiredAttributeNames = 'For applying ' + defaultState.StateName  + ' state, required attribute(s) ' + requiredAttributeNames.join(', ') + ' must have value';
							}
						}
					}
			}
			// model articles assign model number and model id. used for articles creating from catalog models module
			var isAdditionalModelData = angular.isDefined(additionalInfo) && angular.isDefined(additionalInfo.modelArticles) ? additionalInfo.modelArticles : null;
			if(isAdditionalModelData !== null && !utility.isObjectEmpty(isAdditionalModelData)) {
					for(var key in isAdditionalModelData) {
							if(isAdditionalModelData.hasOwnProperty(key)) {
									vm.record[key] = isAdditionalModelData[key];
							}
					}
			}
			vm.enteredNewValuesLookup = {};
			var isAutomaticNumberingEnabled = catalogFactory.getAutomaticNumbering();
			var activeCatalogModelLevelAttributes = utility.filterObject(catalogFactory.getActiveCatalogDetails().ModelLevelAttributeList, {Status: 1});
			var retailWindowAttribute = catalogFactory.getActiveCatalog().RetailWindowAttribute;
			vm.searchValue = {};
			var validSellerLookupsDestinationAttributesMap = api.validSellerLookupsDestinationAttributesMap;
			vm.lookupSourceAndDeptAttributeMap = {};
			vm.requiredAttributesErrorMessages = [];
			vm.isStateValidationFailedWithoutElement = false;
			vm.showColorTypeInColorPalatteDropdown = api.showColorTypeInColorPalatteDropdown
			var dataSourceTypeId = catalogFactory.getActiveCatalogDetails().DataSourceTypeId;

			vm.saveRecord = saveRecord;
			vm.closeDialog = closeDialog;

			vm.lookupSearch = lookupSearch;
			vm.lookupChange = lookupChange;
			vm.customLookupChange = customLookupChange;
			vm.getLookupDisplayValue = getLookupDisplayValue;
			vm.getCustomLookupDisplayValue = getCustomLookupDisplayValue;
			vm.selectText = selectText;
			vm.colorPaletteLookupChange = colorPaletteLookupChange;

			vm.transformChip = transformChip;
			vm.acQuerySearch = acQuerySearch;
			vm.getChipDisplayValue = getChipDisplayValue;
			vm.add =add;

			vm.isInputRequired = isInputRequired;
			vm.getDateObj = getDateObj;
			vm.validateTxPattern = validateTxPattern;
			vm.getConditionalVettingList = getConditionalVettingList;
			vm.multiValueQuerySearch = multiValueQuerySearch;
			vm.validateJSON = validateJSON;
			vm.colorDependentCriteriaAttributeChanged = colorDependentCriteriaAttributeChanged;
			vm.clearSearchTerm = clearSearchTerm;
			vm.lookupSourceAttributeChanged = lookupSourceAttributeChanged;
			vm.isFormValid = isFormValid; // this to avoid enabling save button when filtering the fields and updating a value
			vm.handleFieldChange = handleFieldChange;
			vm.onSearchTextChanged = onSearchTextChanged;

			activate();

			////////////////

			function activate() {
					vm.visibleFields = getVisibleFields(vm.model);
					populateDefaultValues(defaultValues);
					vm.filteredVisibleFields = angular.copy(vm.visibleFields)
					//Hotkeys
					hotkeys.bindTo($scope)
							.add({
									combo: 'ctrl+enter',
									description: $filter('translate')('ACTIONS.SAVE'),
									allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
									callback: function (event) {
											if (!vm.isLoading && !vm.editForm.$invalid) {
													vm.saveRecord();
											}
									}
							});

					if (vm.isNew) {
							hotkeys.bindTo($scope)
									.add({
											combo: 'ctrl+shift+enter',
											description: $filter('translate')('ACTIONS.SAVE_AND_NEW'),
											allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
											callback: function (event) {
													if (!vm.isLoading && !vm.editForm.$invalid) {
															vm.saveRecord(true);
													}
											}
									});
					}
			}

			//On addition of new tag it validates that the tag should not contain pipe
			function add(chip, chips, field) {
					if (chip) {
							if (chip.indexOf(field.tagSeparator) !== -1) {
								vm.record[field.field].splice(vm.record[field.field].indexOf(chip), 1);
								vm.record[field.field] = vm.record[field.field].concat(chip.split(field.tagSeparator));
								vm.maxTags = vm.record[field.field].length + 1;
							} else {
									vm.maxTags = field.maxLen;
							}
					}
					//for displaying error message
					if (angular.isDefined(field.maxLen) && vm.maxTags != field.maxLen) {
							vm.ErrorMessage = field.validation.messages.pattern;
							return true;
					} else {
							vm.ErrorMessage = "";
							return false;
					}
			}

			function saveRecord(saveAndNew) {
					vm.isLoading = true;
					angular.forEach(vm.model.fields, function(field) {
							if(angular.isDefined(field.validation) && field.validation['tx-pattern']) {
									validateTxPattern(field, true);
							}
					});

					//Transform the fields of type dateUTC
					angular.forEach(vm.model.fields, function(itm) {
							//To avoid date-option and datetime timezone issue
							if ((itm.inputType === 'date-utc' || itm.inputType === 'date-option' || itm.inputType === 'date') && angular.isDefined(vm.record[itm.field]) &&  angular.isDate(vm.record[itm.field])) {
									var d = vm.record[itm.field];
									vm.record[itm.field] = new Date(d.setHours(12-(d.getTimezoneOffset()/60),0,0));
							}

							if ((itm.inputType === 'date-without-time') && angular.isDefined(vm.record[itm.field]) &&  angular.isDate(vm.record[itm.field])) {
									var d = vm.record[itm.field];
									vm.record[itm.field] = new Date(d.setHours(12-(d.getTimezoneOffset()/60),0,0)).toISOString();
							}

							if (itm.inputType === 'calculated') {
									delete vm.record[itm.field];
							}

							if ((itm.inputType === 'articlenumber' || itm.inputType === 'modelnumber') && angular.isDefined(vm.record[itm.field]) && vm.record[itm.field] != null && vm.record[itm.field].toString().length > 0) {
									vm.record[itm.field] = vm.record[itm.field].toString();
							}

							if ((itm.inputType === 'number' || itm.type === 'int') && vm.record[itm.field] != null) {
								vm.record[itm.field] = parseInt(vm.record[itm.field]);
							}

							if ((itm.inputType === 'color-palette') && angular.isDefined(vm.record[itm.field]) && vm.record[itm.field] != null && vm.record[itm.field] !== '' && angular.isObject(vm.record[itm.field])) {
								var key = Object.keys(vm.record[itm.field])[0];
								var val = vm.record[itm.field][key];
								if (typeof val === 'string' && val.includes(':')) {
									val = val.split(':')[1].trim();
								}
								vm.record[itm.field][key] = val;
								vm.record[itm.field] = angular.toJson(vm.record[itm.field]);
							}

							// remove all invisible special characters from strings
							if ((itm.inputType === 'text' || itm.inputType === 'textArea') && vm.record[itm.field] != null && vm.record[itm.field] !== '' && typeof vm.record[itm.field] === 'string') {
								vm.record[itm.field] = vm.record[itm.field].replace(/[\u00A0\u00AD\u200B-\u200D\uFEFF\u2028\u2029\u2060]/g, '');
							}

							if ((itm.inputType === 'multi-value' || itm.inputSubType === 'multi-value') && vm.record[itm.field] != null && vm.record[itm.field] !== '' && vm.record[itm.field].length) {
								angular.forEach(vm.record[itm.field], function(value, index) {
									vm.record[itm.field][index] = value.replace(/[\u00A0\u00AD\u200B-\u200D\uFEFF\u2028\u2029\u2060]/g, '');
								})
							}

							if (itm.inputType === 'dataset' && vm.record[itm.field] != null && vm.record[itm.field] !== '') {
								if(typeof (vm.record[itm.field]) === 'object') {
										vm.record[itm.field] = Object.keys(vm.record[itm.field])[0].toString()
								}
								else {
										vm.record[itm.field] = vm.record[itm.field].toString();
								}
							}
							if(itm.inputType === 'datatable' && vm.record[itm.field] != null && vm.record[itm.field] !== '') {
									vm.record[itm.field] = (typeof vm.record[itm.field] === 'string') ? vm.record[itm.field] : angular.toJson(vm.record[itm.field]);
							}
					});
					// StateId is populated as empty string when the state field is not part of the dialog (eg: create article from catalog model details)
					// remove it so an empty state is not sent to the API
					if(vm.record.StateId === '') {
						delete vm.record.StateId;
					}
					// if create in state is selected the validate state required attributes
					var selectedState = (angular.isDefined(vm.record.StateId) && vm.record.StateId !== null && vm.record.StateId !== '')
						? utility.filterObject(api.articleStatesList, { StateId: vm.record.StateId }, true)[0]
						: undefined;
					if (angular.isDefined(selectedState)) {
						var requiredAttributes = selectedState.RequiredAttributes || [];
						var isSizeScaleRequired = selectedState.IsSizeScaleRequired;
						var isPrimaryColorRequired = selectedState.IsPrimaryColorRequired;

						var articlesRequiredAttributes = [];
						var doesArticleMeetSelectedStateRequirement = true;

						if (requiredAttributes.length || isSizeScaleRequired || isPrimaryColorRequired) {
							var requiredAttibutesWithIsValid = articlesFactory.doesArticlesMeetSelectedStateRequirement([vm.record], requiredAttributes, isSizeScaleRequired, isPrimaryColorRequired);
							doesArticleMeetSelectedStateRequirement = requiredAttibutesWithIsValid.doesArticlesMeetSelectedStateRequirement;
							articlesRequiredAttributes = requiredAttibutesWithIsValid.articlesRequiredAttributes;
						}
						if (!doesArticleMeetSelectedStateRequirement) {
							vm.requiredAttributesErrorMessages.push('Can not create article in selected state,');
							for (var key in articlesRequiredAttributes) {
								var reqAttributeDisplayNames = [];
								if (!articlesRequiredAttributes[key].doesArticleMeetSelectedStateRequirement) {
									angular.forEach(articlesRequiredAttributes[key]['articlesRequiredAttributesList'], function(attrSystemName) {
										if(attrSystemName !== 'ColorId' && attrSystemName !== 'SizeScaleId') {
											reqAttributeDisplayNames.push(utility.getAttributeDisplayNameUsingSystemName(catalogFactory.getActiveCatalogDetails().AssignedCatalogAttributes, attrSystemName));
										} else {
											var staticAttributeDisplayName = attrSystemName === 'ColorId' ? 'Primary Color' : attrSystemName === 'SizeScaleId' ? 'Size Scale' : '';
											reqAttributeDisplayNames.push(staticAttributeDisplayName);
										}
									});
									vm.requiredAttributesErrorMessages.push(key + ' does not have value for required attribute(s) ' + reqAttributeDisplayNames.join(', '));
								}
							}
							if(vm.editForm['StateId']) {
								vm.editForm['StateId'].$setValidity('stateRequirement', false);
								vm.editForm['StateId'].$setTouched();
							}
							else {
								vm.isStateValidationFailedWithoutElement = true;
							}
						}
						else {
							if(vm.editForm['StateId']) {
								vm.requiredAttributesErrorMessages = []
								vm.editForm['StateId'].$setValidity('stateRequirement', true);
								vm.editForm['StateId'].$setTouched();
							}
							else {
								vm.isStateValidationFailedWithoutElement = false;
							}
						}
					}

					saveData(saveAndNew);
			}

			function saveData(saveAndNew) {
					var p;
					if(!vm.editForm.$invalid && !vm.requiredAttributesErrorMessages.length) {
							// if any felds with allowEnterNewValue for lookup is present
							if(!utility.isObjectEmpty(vm.enteredNewValuesLookup)) {
									for(var key in vm.enteredNewValuesLookup) {
											if(vm.enteredNewValuesLookup.hasOwnProperty(key)) {
													vm.record[key] = vm.enteredNewValuesLookup[key];
											}
									}
							}

							// if retail window is applied then send the shipmentwindowrangeid frm selected intro and exit month
							if(catalogFactory.getActiveCatalogDetails().IsShippingWindowApply == 1) {
								vm.record['ShipmentWindowRangeId'] = vm.record.RetailExitMonthId;
							}

							if (vm.isNew) {
									p = vm.model.methods.create(vm.record, parentId, vm.model);
							} else if(!vm.isNew) {
									p = vm.model.methods.update(vm.record[vm.model.idField], vm.record, parentId, vm.model);
							}

							p.then(function(response) {
									// when click on save and new while creating record
									if (vm.isNew && angular.isDefined(saveAndNew) && saveAndNew) {
											vm.editForm.$setPristine();
											vm.editForm.$setUntouched();
											if(angular.isDefined(existingValues)) {
													existingValues.push(vm.record);
											}
											vm.record = {};
											populateDefaultValues(defaultValues);
											vm.acSearchText = [];
											vm.searchText = {};
											// if isDataDirty is true keep it true otherwise make it true when response.status != 202
											vm.isDataDirty = vm.isDataDirty || (response.status !== 202);

											var el = $window.document.getElementById('dialog_input_first');
											if (el) {
													el.focus();
											}
									}
									else {
											closeDialog(true);
									}

									if(response && response.status === 202) {
											dialog.showAlertDialog(
													angular.element($document.body),
													$filter('translate')('MESSAGES.TITLE.ALERT'),
													$filter('translate')('MESSAGES.CONTENT.CHANGE_REQUEST_ALERT'),
													$filter('translate')('MESSAGES.TITLE.ALERT'),
													$filter('translate')('ACTIONS.DIALOG_CLOSE'),
													!!saveAndNew,
													event);
									}
									else {
											var toastMessage;
											var postSuccessMessage = additionalInfo && additionalInfo.postSuccessMessage ? additionalInfo.postSuccessMessage : 'SUCCESS.CREATE';
											var putSuccessMessage = additionalInfo && additionalInfo.putSuccessMessage ? additionalInfo.putSuccessMessage : 'SUCCESS.UPDATE';
											toastMessage = response.config.method.toUpperCase() === 'POST' ? postSuccessMessage : putSuccessMessage;
											toast.success(toastMessage, '', '');
									}
							}, function() {
									closeDialog(vm.isDataDirty);
							}).finally(function () {
									vm.isLoading = false;
							});
					} else {
							vm.isLoading = false;
					}
			}

			function closeDialog(saved) {
					$mdDialog.hide(saved);
			}

			function lookupSearch(query, field) {
					var results = [];
					var lookupFilter = angular.isDefined(field.lookupFilter) ? field.lookupFilter : {};
					var predicate = angular.copy(lookupFilter);
					predicate.value = query;
					var lookupModel = api.getModel(field.lookupSource);
					var conditionalColorsCriteria = api.conditonalColorVettingList;

					// allowEnterNewValue is used to allow user to enter new value for the loopup field
					// if we want to send the entred value as a different field allowEnterNewValue will contain the field name
					// if allowEnterNewValue: 'true' then its for the same field
					if(angular.isDefined(field.allowEnterNewValue) && field.allowEnterNewValue.length && angular.isDefined(query) && query.trim().length > 0) {
							// assigning with same field
							var allowedField = field.field;
							if(field.allowEnterNewValue !== 'true') {
									allowedField = field.allowEnterNewValue;
							}
							vm.enteredNewValuesLookup[allowedField] = query;
							vm.editForm[field.field].$setValidity('required', true);
					}

					if(lookupModel && angular.isDefined(lookupModel.lookupData) && angular.isDefined(lookupModel.lookupData.data) && lookupModel.lookupData.data.length) {
							var lookupDataList = lookupModel.lookupData.data;
							// conditionalColorVettingListEnabled filter the colors list based on the selected articles properties
							if(angular.isDefined(field.conditionalColorVettingListEnabled) && field.conditionalColorVettingListEnabled && conditionalColorsCriteria.length) {
									var articlesList = api.getModel('catalogs.articles').lookupData.data;
									var articleData = utility.filterObject(articlesList, {Id: vm.record.ArticleId}, true)[0];
									if(angular.isDefined(articleData)) {
											lookupDataList = utility.filterArticleColors(lookupDataList, [articleData], conditionalColorsCriteria);
									}
							}

							// if RetailIntroMonth/RetailExitMonth filter the retail window intro/exit month based on configured retailWindowAttribute and value
							if(field.field === 'RetailIntroMonthId' || field.field === 'RetailExitMonthId') {
								var assignedRetailWindowAttributeValue = vm.record[retailWindowAttribute];
								if(assignedRetailWindowAttributeValue != null) {
										// filter intro month based on assignedRetailWindowAttributeValue
										if(field.field === 'RetailIntroMonthId') {
												lookupDataList = utility.getUniquieRetailIntroAndExitMonths(utility.filterObject(lookupDataList, {CriteriaAttributeValue: assignedRetailWindowAttributeValue, Status: 1}, true));
												lookupDataList = lookupDataList.sort(function(a, b) {
														return months.indexOf(a.RetailIntroMonth.toString().toLowerCase().trim().substring(0, 3)) - months.indexOf(b.RetailIntroMonth.toString().toLowerCase().trim().substring(0, 3))
												})
										}
										// filter exit month based on selected retail intro month and assignedRetailWindowAttributeValue
										if(field.field === 'RetailExitMonthId') {
												var assignedRetailIntroMonth = {};
												if(angular.isDefined(vm.record['RetailIntroMonthId'])) {
														assignedRetailIntroMonth = utility.filterObject(lookupDataList, {id: vm.record['RetailIntroMonthId']}, true)[0];
												} else { // filter with monthvalue
														assignedRetailIntroMonth = utility.filterObject(lookupDataList, {value: vm.record['RetailIntroMonth']}, true)[0];
												}
												if(angular.isDefined(assignedRetailIntroMonth)) {
														lookupDataList = utility.getUniquieRetailIntroAndExitMonths(utility.filterObject(lookupDataList, {RetailIntroMonth: assignedRetailIntroMonth.RetailIntroMonth, CriteriaAttributeValue: assignedRetailWindowAttributeValue, Status: 1}, true));
														lookupDataList = lookupDataList.sort(function(a, b) {
																return months.indexOf(a.value.toString().toLowerCase().trim().substring(0, 3)) - months.indexOf(b.value.toString().toLowerCase().trim().substring(0, 3))
														})
												} else {
														lookupDataList = [];
												}
										}
								} else {
										lookupDataList = [];
								}
							}
							else if (field.field === 'StateId') {
								// for article states "Create In" show only the allowedStatesForCreateArticleConfig States in the list
								if (api.allowedStatesForCreateArticleConfig.length !== 0) {
									lookupDataList = lookupDataList.filter(function (state) {
										return api.allowedStatesForCreateArticleConfig.includes(state.value.toLowerCase());
									})
								}
							}
							results = query ? utility.filterObject(lookupDataList, predicate) : utility.filterObject(lookupDataList, lookupFilter, true);
							results = filterExistingValues(results, existingValues, lookupModel, field);
							// this is to reduce the rendering time. It was very slow and was impacted overall page responsiveness
							// so while displaying we will display only the first 100 records and user can filter with any value
							if(results.length > 100) {
								field['isAboveDropDownLimit'] = true;
								return results.slice(0, 100);
							} else {
								field['isAboveDropDownLimit'] = false;
								return results;
							}
					}
					else {
							 return lookupPromises[field.field].then(function (lookupData) {
									var lookupDataList = lookupData.data;
									// conditionalColorVettingListEnabled filter the colors list based on the selected articles properties
									if(angular.isDefined(field.conditionalColorVettingListEnabled) && field.conditionalColorVettingListEnabled && lookupDataList.length && conditionalColorsCriteria.length) {
											var articlesList = api.getModel('catalogs.articles').lookupData.data;
											var articleData = utility.filterObject(articlesList, {Id: vm.record.ArticleId}, true)[0];
											if(angular.isDefined(articleData)) {
													lookupDataList = utility.filterArticleColors(lookupDataList, [articleData], conditionalColorsCriteria);
											}
									}

									//  if RetailIntroMonth/RetailExitMonth filter the retail window intro/exit month based on configured retailWindowAttribute and value
									if(field.field === 'RetailIntroMonthId' || field.field === 'RetailExitMonthId') {
										var assignedRetailWindowAttributeValue = vm.record[retailWindowAttribute];
										if(assignedRetailWindowAttributeValue != null) {
												// filter intro month based on assignedRetailWindowAttributeValue
												if(field.field === 'RetailIntroMonthId') {
														lookupDataList = utility.getUniquieRetailIntroAndExitMonths(utility.filterObject(lookupDataList, {CriteriaAttributeValue: assignedRetailWindowAttributeValue, Status: 1}, true));
														lookupDataList = lookupDataList.sort(function(a, b) {
																return months.indexOf(a.RetailIntroMonth.toString().toLowerCase().trim().substring(0, 3)) - months.indexOf(b.RetailIntroMonth.toString().toLowerCase().trim().substring(0, 3))
														})
												}
												// filter exit month based on selected retail intro month and assignedRetailWindowAttributeValue
												if(field.field === 'RetailExitMonthId') {
														var assignedRetailIntroMonth = {};
														if(angular.isDefined(vm.record['RetailIntroMonthId'])) {
																assignedRetailIntroMonth = utility.filterObject(lookupDataList, {id: vm.record['RetailIntroMonthId']}, true)[0];
														} else { // filter with monthvalue
																assignedRetailIntroMonth = utility.filterObject(lookupDataList, {value: vm.record['RetailIntroMonth']}, true)[0];
														}
														if(angular.isDefined(assignedRetailIntroMonth)) {
																lookupDataList = utility.getUniquieRetailIntroAndExitMonths(utility.filterObject(lookupDataList, {RetailIntroMonth: assignedRetailIntroMonth.RetailIntroMonth, CriteriaAttributeValue: assignedRetailWindowAttributeValue, Status: 1}, true));
																lookupDataList = lookupDataList.sort(function(a, b) {
																		return months.indexOf(a.value.toString().toLowerCase().trim().substring(0, 3)) - months.indexOf(b.value.toString().toLowerCase().trim().substring(0, 3))
																})
														} else {
																lookupDataList = [];
														}
												}
										} else {
												lookupDataList = [];
										}
									}
									else if (field.field === 'StateId') {
										// for article states "Create In" show only the allowedStatesForCreateArticleConfig States in the list
										if (api.allowedStatesForCreateArticleConfig.length !== 0) {
											lookupDataList = lookupDataList.filter(function (state) {
												return api.allowedStatesForCreateArticleConfig.includes(state.value.toLowerCase());
											})
										}
									}
									results = query ? utility.filterObject(lookupDataList, predicate) : utility.filterObject(lookupDataList, lookupFilter, true);
									results = filterExistingValues(results, existingValues, lookupModel, field);
									// this is to reduce the rendering time. It was very slow and was impacted overall page responsiveness
									// so while displaying we will display only the first 100 records and user can filter with any value
									if(results.length > 100) {
										field['isAboveDropDownLimit'] = true;
										return results.slice(0, 100);
									} else {
										field['isAboveDropDownLimit'] = false;
										return results;
									}
							});
					}
			}

			function filterExistingValues(results, existingValues, lookupModel, field) {
					if (existingValues && existingValues.length > 0) {
							angular.forEach(existingValues, function (existingValue) {
									if (existingValue[field.field] && angular.isDefined(existingValue[field.field])) {
											var index = results.indexOf(utility.filterObject(results, { value: existingValue[lookupModel.lookupDisplayField] }, true)[0]);
											if (index !== -1) {
													results.splice(index, 1);
											}
									}
							});
					}
					// filter article colors based on the color palette conditions
					if(field.isfilterCriteria) {
							results = getFilteredCriteriaValues(results);
					}
					return results;
			}
			// convert dropdown scope value form object(lookup record) to id property of lookup record
			function lookupChange(selectedObj, field, fieldObject) {
					if(angular.isObject(selectedObj)) {
							vm.record[field] = selectedObj.id;
							// load data from server based on the lockup value
							if(angular.isDefined(fieldObject.validation.onChangeLookUp) && fieldObject.validation.onChangeLookUp.length > 0) {
									var lookUpChangeValues = utility.splitString(fieldObject.validation.onChangeLookUp, ',');
									if(angular.isDefined(lookupExtras[lookUpChangeValues[0]])) {
											lookupExtras[lookUpChangeValues[0]][lookUpChangeValues[1]] = selectedObj.id;
									}
									lookupPromises[field] = crud.createLookupPromise(vm.model, lookupExtras, 'create');
							}
							// if onChangeLookUpSetValue is defined then add the value of configured field from the selectedobj(ArticleName-ModelName) and assign it to ModelName field
							// used in articles module
							if(angular.isDefined(fieldObject.validation.onChangeLookUpSetValue) && fieldObject.validation.onChangeLookUpSetValue.length > 0) {
									var lookUpSetValues = utility.splitString(fieldObject.validation.onChangeLookUpSetValue, ',');
									// make the dependant field disabled
									var dependantField = utility.filterObject(vm.model.fields, {field: lookUpSetValues[0]}, true)[0];
									dependantField.validation.disabledCriteria = true;
									vm.record[lookUpSetValues[0]] = selectedObj[lookUpSetValues[1]];
							}

							// get model level attrbutes value when isAutomaticNumberingEnabled is enabled
							if(field === 'ModelId' && isAutomaticNumberingEnabled) {
								api.catalogs.models.methods.getDetails(true, selectedObj.id, parentId)
								.then(function (response) {
									var modelDetails = response.data[0];
									vm.record.SizeScaleId = modelDetails.SizeScaleId;
									angular.forEach(activeCatalogModelLevelAttributes, function(modelLevelAttribute) {
											if(modelDetails[modelLevelAttribute.AttributeSystemName] != null && modelDetails[modelLevelAttribute.AttributeSystemName] !== '') {
												// push only valid vetting list values
												var attributeField = utility.filterObject(vm.filteredVisibleFields, {field: modelLevelAttribute.AttributeSystemName}, true)[0];
												if (attributeField && attributeField.values && attributeField.values.length) {
													if(attributeField.values.includes(modelDetails[modelLevelAttribute.AttributeSystemName])) {
														vm.record[modelLevelAttribute.AttributeSystemName] = modelDetails[modelLevelAttribute.AttributeSystemName];
													}
													else {
														assignDefaultValueBasedOnType(attributeField);
													}
												}
												else {
													vm.record[modelLevelAttribute.AttributeSystemName] = modelDetails[modelLevelAttribute.AttributeSystemName];
												}
											} else {
												var modelAttr = utility.filterObject(vm.model.fields, {field: modelLevelAttribute.AttributeSystemName}, true)[0];
												assignDefaultValueBasedOnType(modelAttr);
											}
											// if lookup source attribute prepopulate the lookuptable destination attribute
											if(vm.lookupSourceAndDeptAttributeMap.hasOwnProperty(modelLevelAttribute.AttributeSystemName)) {
												lookupSourceAttributeChanged(modelLevelAttribute.AttributeSystemName);
											}
									});
								});
							}

							// filter exit month based on assignedRetailWindowAttributeValue
							if(field === 'RetailIntroMonthId') {
								vm.record['RetailExitMonthId'] = null;
							}
							if(field === 'ColorId') {
								vm.handleFieldChange(fieldObject);
							}
							else if(field === 'StateId') { // show info message
								if(vm.editForm['StateId']) {
									vm.editForm['StateId'].$setValidity('stateRequirement', true);
								}
								vm.requiredAttributesErrorMessages = [];
								var selectedState = utility.filterObject(api.articleStatesList, { StateId: vm.record.StateId }, true)[0];
								if(angular.isDefined(selectedState)) {
									var requiredAttributes = selectedState.RequiredAttributes || [];
									var requiredAttributeNames = [];
									angular.forEach(requiredAttributes, function(attribute) {
										requiredAttributeNames.push(utility.getAttributeDisplayNameUsingSystemName(catalogFactory.getActiveCatalogDetails().AssignedCatalogAttributes, attribute.AttributeSystemName));
									});
									requiredAttributeNames.push(selectedState.IsPrimaryColorRequired ? 'Primary Color' : selectedState.IsSizeScaleRequired ? 'Size Scale' : '');
									fieldObject.requiredAttributeNames = 'For applying ' + selectedState.StateName  + ' state, required attribute(s) ' + requiredAttributeNames.join(', ') + ' must have value';
								}
								else {
									fieldObject.requiredAttributeNames = '';
								}
							}
					}
					else if(angular.isUndefined(selectedObj) || selectedObj === null) {
							vm.record[field] = undefined; // on record removal make field undefined or the property can be deleted using delete keywork
							if(angular.isDefined(fieldObject.validation.onChangeLookUpSetValue) && fieldObject.validation.onChangeLookUpSetValue.length > 0) {
									var lookUpSetValues = utility.splitString(fieldObject.validation.onChangeLookUpSetValue, ',');
									// make the dependant field disabled
									var dependantField = utility.filterObject(vm.model.fields, {field: lookUpSetValues[0]}, true)[0];
									dependantField.validation.disabledCriteria = false;
									vm.record[lookUpSetValues[0]] = '';
							}

							if(field === 'ModelId') { // when model id is not selected
								// when value is removed assign model level attributes with default value
								vm.record.SizeScaleId = null;
								angular.forEach(activeCatalogModelLevelAttributes, function(modelLevelAttribute) {
									var modelAttr = utility.filterObject(vm.model.fields, {field: modelLevelAttribute.AttributeSystemName}, true)[0];
									assignDefaultValueBasedOnType(modelAttr);
								});
							}

							// filter intro month based on assignedRetailWindowAttributeValue
							if(field === 'RetailIntroMonthId') {
								vm.record['RetailExitMonthId'] = null;
							}
							else if(field === 'StateId') { // show info message
								fieldObject.requiredAttributeNames = '';
								vm.requiredAttributesErrorMessages = [];
								if(vm.editForm['StateId']) {
									vm.editForm['StateId'].$setValidity('stateRequirement', true);
								}
							}
					}
			}

			function customLookupChange(selectedObj, field) {
					if(angular.isObject(selectedObj)) {
							vm.record[field.field] = selectedObj[field.customLookupInfo.value];
					}
					else if(angular.isUndefined(selectedObj) || selectedObj === null){
							vm.record[field.field] = undefined; // on record removal make field undefined or the property can be deleted using delete keywork
					}
			}

			function colorPaletteLookupChange(selectedObj, field) {
				if(angular.isObject(selectedObj) && Object.keys(selectedObj)[0] != null && angular.isDefined(selectedObj.value)) {
						// color palette values are stores as key value pair
						var objectVal = {};
						objectVal[selectedObj.id] = selectedObj.value
						vm.record[field.field] = objectVal;
				}
				else if(angular.isUndefined(selectedObj) || selectedObj === null){
						vm.record[field.field] = undefined; // on record removal make field undefined or the property can be deleted using delete keywork
				}
			}

			// isArticleNumberType for converting article id from string to int
			function getLookupDisplayValue(item, field, isArticleNumberType) {
					var lookupModel = api.getModel(field.lookupSource);
					item = isArticleNumberType ? parseInt(item) : item;

					if(angular.isDefined(lookupModel.lookupData) && angular.isDefined(lookupModel.lookupData.data) && lookupModel.lookupData.data.length) {
							return getLookupDisplayVal(item, lookupModel.lookupData);
					}
					else {
							return lookupPromises[field.field].then(function(lookupData) {
									return getLookupDisplayVal(item, lookupData);
							});
					}
			}

			function getCustomLookupDisplayValue(item, field) {
				//  show only color name for color palette attributes
				if(field.inputType === 'color-palette') {
					return $filter('colorPaletteRenderer')(item, field);
				} else {
					var lookupModel = api.getModel(field.lookupSource);

					if(angular.isDefined(lookupModel.lookupData) && angular.isDefined(lookupModel.lookupData.data) && lookupModel.lookupData.data.length) {
							return getCustomLookupDisplayVal(item, lookupModel.lookupData, field);
					}
					else {
							return lookupPromises[field.field].then(function(lookupData) {
									return getCustomLookupDisplayVal(item, lookupData, field);
							});
					}
				}
			}

			//helper method
			function getLookupDisplayVal(item, lookupData) {
					var result;
					if(lookupData) {
							// since autocomplte return object
							if(angular.isObject(item)) {
									result = utility.filterObject(lookupData.data, {id: item.id}, true);
							}
							// to initialize field value if any (when open update record dialog)
							else {
									result = utility.filterObject(lookupData.data, {id: item}, true);
							}

							if (angular.isArray(result) && result.length > 0) {
									return result[0].value;
							}
							else {
									return result.value;
							}
					}
			}

			function getCustomLookupDisplayVal(item, lookupData, field) {
					var result;
					var predicate = {};
					if(lookupData) {
							// since autocomplete return object
							if(angular.isObject(item)) {
									predicate[field.customLookupInfo.value] = item[field.customLookupInfo.value];
									result = utility.filterObject(lookupData.data, predicate, true);
							}
							// to initialize field value if any (when open update record dialog)
							else {
									predicate[field.customLookupInfo.value] = item;
									result = utility.filterObject(lookupData.data, predicate, true);
							}

							if (angular.isArray(result) && result.length > 0) {
									return result[0].value;
							}
							else {
									return result.value;
							}
					}
			}

			function selectText(event) {
					utility.selectInputText(event);
			}

			function transformChip(chip, isMultiValue) {
					if (angular.isObject(chip)) {
							return chip.id;
					} else if(isMultiValue) {
							return chip;
					}
					return undefined;
			}

			//TODO: Check performance impact on using nested filter
			function acQuerySearch(query, selectedRecords, field) {
					var results = [];
					var lookupFilter = angular.isDefined(field.lookupFilter) ? field.lookupFilter : {};
					var predicate = angular.copy(lookupFilter);
					predicate.value = query;

					var lookupModel = api.getModel(field.lookupSource);
					if(angular.isDefined(lookupModel.lookupData) && angular.isDefined(lookupModel.lookupData.data) && lookupModel.lookupData.data.length) {
							results = query ? utility.filterObject(lookupModel.lookupData.data , predicate) : utility.filterObject(lookupModel.lookupData.data, lookupFilter);
							results = removeSelectedChips(selectedRecords, results);
							results;
					}
					else {
							lookupPromises[field.field].then(function(lookupData) {
									results = query ? utility.filterObject(lookupData.data , predicate) : utility.filterObject(lookupData.data, lookupFilter);
									results = removeSelectedChips(selectedRecords, results);
									results;
							});
					}

					if (existingValues && existingValues.length > 0) {
							angular.forEach(existingValues, function (existingValue) {
									if (existingValue[field.field] && angular.isDefined(existingValue[field.field])) {
											angular.forEach(existingValue[field.field], function (fieldId) {
													var index = results.indexOf(utility.filterObject(results, { id: fieldId }, true)[0]);
													if (index !== -1) {
															results.splice(index, 1);
													}
											})
									}
							});
					}
					return results;
			}

			/**
			 * @description
			 * This method will remove selected chips form records (helper method)
			 * @param {array} selectedRecords: list of selected chips
			 * @param {array} records: data property of lookup-data
			 * @returns {array}: list of available chips (chips which are not selected) // it does not really need to return a value but for readability returning modified value
			 */
			function removeSelectedChips(selectedRecords, records) {
					if (angular.isDefined(selectedRecords) && selectedRecords != null && selectedRecords.length > 0) {
							for (var index = records.length-1; index >= 0; index--) {
									if (selectedRecords.indexOf(records[index].id) !== -1) {
											records.splice(index,1);
									}
									if (selectedRecords.indexOf(records[index]) !== -1) {
											records.splice(index,1);
									}
							}
					}
					return records;
			}

			function getChipDisplayValue(chip, field) {
					var lookupModel = api.getModel(field.lookupSource);
					if(angular.isDefined(lookupModel.lookupData) && angular.isDefined(lookupModel.lookupData.data) && lookupModel.lookupData.data.length) {
							return getChipDisplayVal(lookupModel.lookupData, chip);
					}
					else { // it will never go to else part since before try to load display value for selected chips, it always load lookup on focus of chips input element
							return lookupPromises[field.field].then(function(lookupData) {
									return getChipDisplayVal(lookupData, chip);
							});
					}
			}

			//helper method
			function getChipDisplayVal(lookupData, chip) {
					var res = utility.filterObject(lookupData.data, {id: chip}, true);
					if (angular.isArray(res) && res.length > 0) {
							return res[0].value;
					}
					else {
							$log.warn('viewCreator controller: Unable to resolve chip display value!');
							return "";
					}
			}

			function isInputRequired(field) {
					if (angular.isString(field.validation.isRequired)) {
							return (scope.$eval(field.validation.isRequired) && (angular.isUndefined(field.validation.disabledCriteria) || !scope.$eval(field.validation.disabledCriteria)));
					} else {
							return (field.validation.isRequired && (angular.isUndefined(field.validation.disabledCriteria) || !scope.$eval(field.validation.disabledCriteria)));
					}
			}

			function getDateObj(dateString, fromUTC) {
					if(dateString){
							return utility.createDateObject(dateString, fromUTC);
					}
			}

			function validateTxPattern(field) {
					var validationExpression = utility.isValidJSON(field.validation['tx-pattern']);
					if(validationExpression && angular.isDefined(validationExpression.F) && validationExpression.F.length > 0) {
							var parsedExpressionObjects = validationExpression.F;
							vm.isValidValue = true;
							angular.forEach(parsedExpressionObjects, function(parsedExpressionObject) {
									if(vm.isValidValue) {
											// skip validating overridable attribute with parent attributes for master catalog
											if(angular.isDefined(parsedExpressionObject['SourceField']) && (dataSourceTypeId === 1 && field.Overridable && !parsedExpressionObject['SourceField'].startsWith('#')) || (dataSourceTypeId === 3)) {
													// if SourceValueRequired is true then the source field should be required for this attribute to have value
													if(parsedExpressionObject['SourceValueRequired']) {
															if(vm.record[parsedExpressionObject['SourceField']] !== '' && vm.record[parsedExpressionObject['SourceField']] != null) {
																	setAttributeFieldValidity(field, parsedExpressionObject);
															} else if(vm.record[field.field] !== '' && vm.record[field.field] != null) {
																	vm.editForm[field.field].$setValidity('pattern', false);
																	vm.editForm[field.field].$touched = true;
																	if(angular.isDefined(parsedExpressionObject.Message)) {
																			field.validation.messages.pattern = parsedExpressionObject.Message;
																	}
																	vm.isValidValue = false;
															}
													} else {
															if(vm.record[parsedExpressionObject['SourceField']] !== '' && vm.record[parsedExpressionObject['SourceField']] != null
																	&& vm.record[field.field] !== '' && vm.record[field.field] != null && parsedExpressionObject['SourceField'] !== 'ShipmentStartDate' && parsedExpressionObject['SourceField'] !== 'ShipmentEndDate') {
																	setAttributeFieldValidity(field, parsedExpressionObject);
															} else if((parsedExpressionObject['SourceField'] === 'ShipmentStartDate' || parsedExpressionObject['SourceField'] === 'ShipmentEndDate') && (vm.record['RetailIntroMonth'] != null && vm.record['RetailIntroMonth'] !== '') && (vm.record['RetailExitMonth'] != null && vm.record['RetailExitMonth'] !== '') && vm.record[field.field] !== '' && vm.record[field.field] != null) {
																	// get the data from the mapped retail window and validate
																	var retailWindowDataList = api.getModel('catalogs.retailExitMonthsForArticle').lookupData.data;
																	var mappedRetailWindow = utility.filterObject(retailWindowDataList, {id: vm.record['RetailExitMonthId']}, true)[0];
																	if(angular.isDefined(mappedRetailWindow)) {
																			vm.record['ShipmentStartDate'] = mappedRetailWindow.ShipmentStartDate;
																			vm.record['ShipmentEndDate'] = mappedRetailWindow.ShipmentEndDate;
																			setAttributeFieldValidity(field, parsedExpressionObject);
																	}
															}
															else if(vm.editForm[field.field]) {
																	vm.editForm[field.field].$setValidity('pattern', true);
																	vm.editForm[field.field].$touched = true;
															}
													}
											}
											if(angular.isUndefined(parsedExpressionObject['SourceField']) && angular.isDefined(parsedExpressionObject['Expression']) && angular.isDefined(parsedExpressionObject['ExpressionValue'])) {
													if(vm.record[field.field] !== '' && vm.record[field.field] != null) {
															setAttributeFieldValidity(field, parsedExpressionObject, true);
													}
													else if(vm.editForm[field.field]) {
															vm.editForm[field.field].$setValidity('pattern', true);
													}
											}
									}
							});
					}
			}

			function setAttributeFieldValidity(field, parsedExpressionObject, isExpressionValidation) {
					var valid = validateExpression(field, parsedExpressionObject, isExpressionValidation);
					if(!valid) {
							if(angular.isDefined(vm.editForm[field.field])) {
									vm.editForm[field.field].$setValidity('pattern', false);
									vm.editForm[field.field].$touched = true;
									if(angular.isDefined(parsedExpressionObject.Message)) {
											field.validation.messages.pattern = parsedExpressionObject.Message;
									}
									vm.isValidValue = false;
							}
					} else {
							if(angular.isDefined(vm.editForm[field.field])) {
									vm.editForm[field.field].$setValidity('pattern', true);
									vm.editForm[field.field].$touched = true;
							}
					}
			}

			function validateExpression(field, parsedExpressionObject, isExpressionValidation) {
					var Expression = parsedExpressionObject.Expression;
					var SourceField = parsedExpressionObject.SourceField;
					var currentAttributeValue = vm.record[field.field];
					var sourceAttributeValue = !isExpressionValidation ? vm.record[SourceField] : parsedExpressionObject.ExpressionValue;

					//Transform the date fields to type dateUTC
					angular.forEach(vm.model.fields, function(itm) {
							if(itm.field === field.field || itm.field === SourceField) {
									// for date fields
									if ((itm.inputType === 'date-utc' || itm.inputType === 'date-option' || itm.inputType === 'date-without-time' || itm.inputType === 'date')) {
											if(itm.field === field.field) {
													currentAttributeValue = new Date(vm.record[itm.field]);
													currentAttributeValue = currentAttributeValue.setHours(0,0,0,0);
													if(isExpressionValidation) {
															sourceAttributeValue = new Date(sourceAttributeValue)
															sourceAttributeValue = sourceAttributeValue.setHours(0,0,0,0);
													}
											} else if(itm.field === SourceField) {
													sourceAttributeValue = new Date(vm.record[itm.field]);
													sourceAttributeValue = sourceAttributeValue.setHours(0,0,0,0);
											}
									}
									// for text input types
									if (itm.inputType === 'textArea' || itm.inputType === 'text' || (angular.isDefined(itm.type) && itm.type === 'text' && itm.inputType === 'list')) {
											if(itm.field === field.field) {
													currentAttributeValue = vm.record[itm.field].toUpperCase();
														if(isExpressionValidation) {
															sourceAttributeValue = sourceAttributeValue.toString().toUpperCase();
													}
											} else if(itm.field === SourceField) {
													sourceAttributeValue = vm.record[itm.field].toUpperCase();
											}
									}
							}
					});

					if(dataSourceTypeId === 3 && field.Overridable) {
							if(field.inputType === 'textArea' || field.inputType === 'text' || (angular.isDefined(field.type) && field.type === 'text' && field.inputType === 'list')) {
									sourceAttributeValue = vm.record[SourceField].toUpperCase();
							}

							// for date fields
							if ((field.inputType === 'date-utc' || field.inputType === 'date-option' || field.inputType === 'date-without-time' || field.inputType === 'date')) {
									sourceAttributeValue = new Date(vm.record[SourceField]);
									sourceAttributeValue = sourceAttributeValue.setHours(0,0,0,0);
							}
					}

					var isValid = false;
					switch(Expression) {
							case '<':
									isValid = currentAttributeValue < sourceAttributeValue ? true : false;
									break;
							case '>':
									isValid = currentAttributeValue > sourceAttributeValue ? true : false;
									break;
							case '<=':
									isValid = currentAttributeValue <= sourceAttributeValue ? true : false;
									break;
							case '>=':
									isValid = currentAttributeValue >= sourceAttributeValue ? true : false;
									break;
							case '=':
									isValid = currentAttributeValue === sourceAttributeValue ? true : false;
									break;
							case '!=':
									isValid = currentAttributeValue !== sourceAttributeValue ? true : false;
									break;
					}
					return isValid;
			}

			function getConditionalVettingList(field) {
					var attribute = field.field;
					// CriteriaV2 (preferred): dropdown = matched rule's AllowedValues ([] when no rule matches)
					if (vm.criteriaV2Map[attribute]) {
						var getDependentValueForCriteriaV2 = function(dependentField) {
							var depVal = vm.record[dependentField];
							return (depVal && typeof depVal === 'object') ? (angular.isDefined(depVal.value) ? depVal.value : depVal) : depVal;
						};
						var criteriaV2Allowed = utility.getCriteriaV2AllowedValues(vm.criteriaV2Map[attribute], getDependentValueForCriteriaV2);
						var criteriaV2AttributeField = utility.filterObject(vm.filteredVisibleFields || vm.visibleFields, { field: attribute }, true)[0];
						if (angular.isDefined(criteriaV2AttributeField)) {
							criteriaV2AttributeField.values = (criteriaV2Allowed || [])
								.map(function(value) { return value.toString().trim(); })
								.sort(function(a, b) { return a.toLowerCase().localeCompare(b.toLowerCase()); });
						}
						return;
					}
					var criteriaObj = {};
					var catalogAttribute = utility.filterObject(catalogFactory.getActiveCatalogDetails().AssignedCatalogAttributes,
					{ AttributeSystemName: attribute }, true)[0];
					var catalogAttributeAllowedValues = (catalogAttribute.AllowedValues || []).map(function (v) {
							return v.toString().toLowerCase()
					})
					angular.forEach(vm.vettingListCriteriaList, function(criteriaAttr) {
							for(var key1 in criteriaAttr) {
									if(criteriaAttr.hasOwnProperty(key1)) {
											if(key1.toLocaleLowerCase() === attribute.toLowerCase()) {
													criteriaObj = criteriaAttr[key1];
													break;
											}
									}
							}
					});

					var validValues = [];
					var noMatch = true
					Object.keys(criteriaObj).forEach(function (key) {
							var item = criteriaObj[key];
							var subItems = Object.keys(item);
							var validItems = 0;
							subItems.forEach(function (key2) {
									if (vm.record.hasOwnProperty(key2) && vm.record[key2] != null && vm.record[key2] !== '') {
											var articleAttributeValue = typeof(vm.record[key2]) === 'object' ?
													angular.isDefined(vm.record[key2]['value']) ? vm.record[key2]['value'] : vm.record[key2] :
													vm.record[key2];
											var isDate = validateDate(articleAttributeValue);
											if(articleAttributeValue != null && articleAttributeValue.toString() != '') {
													noMatch = false;
													var lowerCaseValues = item[key2].map(function (value) {
															return isDate == true ? new Date(value).getTime().toString().toLowerCase() : value.toString().toLowerCase();
													});

													if(isDate == true) {
															// remove time while comparing date-without-time and date-option values
															if(field.inputType === 'date-option' || field.inputType === 'date-without-time') {
																	lowerCaseValues = lowerCaseValues.split('T', 1)[0];
															}
															if(lowerCaseValues.indexOf(new Date(articleAttributeValue).getTime().toString().toLowerCase()) !== -1) {
																validItems++;
															}
													} else {
															if(lowerCaseValues.indexOf(articleAttributeValue.toString().toLowerCase()) !== -1) {
																	validItems++;
															}
													}
											}
									} else {
											validItems++;
									}
							});

							if (subItems.length == validItems && catalogAttributeAllowedValues.indexOf(key.toLowerCase()) !== -1) {
									validValues.push(key);
							}
					});
					var attributeField = utility.filterObject(vm.filteredVisibleFields, {field: attribute}, true)[0];
					if (!noMatch) {
							attributeField.values = (validValues || [])
							.map(function(value) {
								return value.trim();
							})
							.sort(function(a, b) {
								return a.toLowerCase().localeCompare(b.toLowerCase());
							})
					} else {
						attributeField.values = (catalogAttribute.AllowedValues || [])
						.map(function(value) {
							return value.trim();
						})
						.sort(function(a, b) {
							return a.toLowerCase().localeCompare(b.toLowerCase());
						})
					}
			}

			function validateDate(value, formats) {
					if(angular.isUndefined(formats)) {
							formats = [
									moment.ISO_8601
							];
					}
					return moment(value, formats, true).isValid();
			}

			function multiValueQuerySearch(query, selectedItems, field) {
					if(field.isCriteriaAdded) {
							getConditionalVettingList(field);
					}
					var values = field.values;
					var searchQueryResult = [];
					var searchQueryResult = utility.filterObject(values, query);
					if (selectedItems && selectedItems.length > 0) {
						for (var index = searchQueryResult.length - 1; index >= 0; index--) {
							if (selectedItems.indexOf(searchQueryResult[index]) !== -1) {
								searchQueryResult.splice(index, 1);
							}
						}
					}
					return searchQueryResult;
			}

			function validateJSON(field) {
					var valid = utility.isValidJSON(vm.record[field.field]);
					if(valid && utility.isObjectEmpty(JSON.parse(vm.record[field.field]))) {
							valid = false;
					}
					if(valid) {
							if(angular.isDefined(vm.editForm[field.field])) {
									vm.editForm[field.field].$setValidity('checkIfValidJson', true);
							}
					} else {
							if(angular.isDefined(vm.editForm[field.field])) {
									vm.editForm[field.field].$setValidity('checkIfValidJson', false);
							}
					}
			}

			// color palette dependentant attribute change method
			function colorDependentCriteriaAttributeChanged() {
				var colorPaletteAttributes =  utility.filterObject(vm.visibleFields, {inputType: 'color-palette'}, true);
				angular.forEach(colorPaletteAttributes, function(colorAttr) {
					vm.record[colorAttr.field] = null;
				});
				// empty parimary color field as well
				var primaryColorField =  utility.filterObject(vm.visibleFields, {field: 'ColorId'}, true)[0];
				vm.record[primaryColorField.field] = null;
			}

			/**
			 * Enable use Enter and any other seperator key defined on model to be use as a seperator key for chips
			 */
			function updateSperatorKeys(field) {
					vm.tagSeperatorKeys[field.field] = [$mdConstant.KEY_CODE.ENTER];
					if(angular.isDefined(field.tagSeparator)) {
							var aditionalSeperator = field.tagSeparator.charCodeAt();
							if(angular.isDefined(aditionalSeperator) && aditionalSeperator !== 'NaN') {
									vm.tagSeperatorKeys[field.field].push(aditionalSeperator);
							}
					}
			}

			function clearSearchTerm(field) {
				vm.searchValue[field] = '';
			};

			function populateTags(record, field) {
					if(angular.isUndefined(record[field.field]) || record[field.field] === null || record[field.field] === '') {
						record[field.field] = [];
					}
					else if(angular.isDefined(field.tagSeparator)) {
							var stringVal = record[field.field];
							var tagSeparator = field.tagSeparator;
							if(!angular.isArray(stringVal) && stringVal !== null) {
								record[field.field] = stringVal.split(tagSeparator);
							}
					}
					else {
							$log.warn('tagSeparator property is missing in model for ' + field.field);
					}
			}


			function populateDefaultValues(defaultVals) {
					if (angular.isDefined(defaultValues) && defaultValues !== null) {
							for(var prop in defaultVals) {
									vm.record[prop] = defaultVals[prop];
							}
					}

					//Populate default values
					for (var i = 0; i < vm.model.fields.length; i++) {
						assignDefaultValueBasedOnType(vm.model.fields[i]);
					}
			}

			function assignDefaultValueBasedOnType(field) {
				// if default value assigned then assign it on creation
				var isDefaultValueAssigned = vm.isNew && angular.isDefined(field.DefaultValue) && field.DefaultValue != null && field.DefaultValue !== '' ? true : false;
				if (vm.isNew && (field.editable || field.inputType === 'static') && angular.isDefined(field.fieldDefaultValue)) {
					vm.record[field.field] = field.fieldDefaultValue;
				}

				if (field.inputType === 'text' || field.inputType === 'textArea') {
					if(angular.isUndefined(vm.record[field.field]) || vm.record[field.field] === null) {
						vm.record[field.field] = isDefaultValueAssigned ? field.DefaultValue : '';
					}
				}

				if (field.inputType === 'number') {
					if(angular.isUndefined(vm.record[field.field])) {
						vm.record[field.field] = isDefaultValueAssigned ? Number(field.DefaultValue) : 0;
					}
				}

				if (field.inputType === 'lookup-many' && (angular.isUndefined(vm.record[field.field]) || vm.record[field.field] == null )) {
					vm.record[field.field] = [];
				}

				else if (field.inputType === 'tags') {
					updateSperatorKeys(field);
					populateTags(vm.record, field);
				}

				else if (field.inputType === 'bool') {
					if(angular.isUndefined(vm.record[field.field])) {
						vm.record[field.field] = false;
					}
				}

				/// test this one

				//for listing populated values of attributes in active catalog's attributeVettingList
				else if (field.inputType === 'list' || (field.inputType === 'multi-value')) {
					if (vm.isNew || angular.isUndefined(vm.record[field.field])) {
							vm.record[field.field] = (vm.isNew && isDefaultValueAssigned) ? field.DefaultValue : angular.isDefined(vm.record[field.field]) ? vm.record[field.field]: field.type === 'int' ? 0 : '';
					}
					// for multivalue dropdown make the record as array
					if(field.inputType === 'multi-value') {
							if(vm.isNew) {
									vm.record[field.field] = isDefaultValueAssigned ? utility.splitString(field.DefaultValue, '|') : [];
							} else if((!vm.isNew && vm.record[field.field] === null)) {
									vm.record[field.field] = [];
							} if(!vm.isNew) {//Non Removable Existing Chips: send existingRecords only when action is edit and nonRemovableChips is true
								if(angular.isDefined(field.nonRemovableChips) && field.nonRemovableChips === true) {
										vm.existingRecords = angular.copy(vm.record[field.field]);
								}
							}
					}
					if (vm.model.modelPath === 'catalogs.articles' || vm.model.modelPath === 'catalogs.linePlanArticles' || vm.model.modelPath === 'sellerModels.sellerModels' || vm.model.modelPath === 'catalogs.models') {
						var attributes = catalogFactory.getActiveCatalogDetails().AssignedCatalogAttributes;
						if (attributes && attributes.length > 0) {
							angular.forEach(attributes, function (attribute) {
								if (attribute.AttributeSystemName === field.field) {
									field.values = (attribute.AllowedValues || [])
									.map(function(value) {
										return value.trim();
									})
									.sort(function(a, b) {
										return a.toLowerCase().localeCompare(b.toLowerCase());
									})
									// for attribute vetting list criteria — CriteriaV2 preferred over OLD Criteria
									if (field.isDynamicProperty && attribute.CriteriaV2 && attribute.CriteriaV2.length > 0) {
										try {
											vm.criteriaV2Map[attribute.AttributeSystemName] = JSON.parse(attribute.CriteriaV2);
										} catch (error) {
											console.warn(attribute.AttributeDisplayName + " - Attribute CriteriaV2: Invalid JSON Format");
										}
										field.isCriteriaAdded = true;
										var v2DependentDisplayNames = [];
										utility.getCriteriaV2DependentFields(vm.criteriaV2Map[attribute.AttributeSystemName]).forEach(function(depKey) {
											var v2DependentField = utility.filterObject(vm.visibleFields, { field: depKey }, true)[0];
											if (angular.isDefined(v2DependentField)) {
												if (!vm.criteriaDeptAttributeMap[depKey]) {
													vm.criteriaDeptAttributeMap[depKey] = [];
												}
												if (vm.criteriaDeptAttributeMap[depKey].indexOf(attribute.AttributeSystemName) === -1) {
													vm.criteriaDeptAttributeMap[depKey].push(attribute.AttributeSystemName);
												}
												v2DependentField.isDependentAttribute = true;
												v2DependentDisplayNames.push(utility.getAttributeDisplayNameUsingSystemName(catalogFactory.getActiveCatalogDetails().AssignedCatalogAttributes, depKey));
											}
										});
										field.criteriaDisplayMessage = 'Attribute ' + attribute.AttributeDisplayName + ' is dependent on the attribute(s) ' + v2DependentDisplayNames + '.';
									} else if (field.isDynamicProperty && attribute.Criteria.length > 0) {
										// parse json
										try {
											var vettinglistCriteria = JSON.parse(attribute.Criteria);
										} catch (error) {
											console.warn(attribute.AttributeDisplayName + " - Attribute Criteria: Invalid JSON Format");
										}
										var dependentAttributesDisplayNames = [];
										field.isCriteriaAdded = true;
										var dependingAttributes = {};
										var obj2 = {};
										for (var key in vettinglistCriteria) {
											if (vettinglistCriteria.hasOwnProperty(key)) {
												var deptAttr = vettinglistCriteria[key];
												for (var key1 in deptAttr) {
													var obj = {};
													if (deptAttr.hasOwnProperty(key1)) {
														var index = dependentAttributesDisplayNames.indexOf(utility.getAttributeDisplayNameUsingSystemName(catalogFactory.getActiveCatalogDetails().AssignedCatalogAttributes, key1));
														if (index === -1) {
															var dependentAttributeField = utility.filterObject(vm.visibleFields, { field: key1 }, true)[0];
															if (angular.isDefined(dependentAttributeField)) {
																if(!vm.criteriaDeptAttributeMap[key1]) {
																	vm.criteriaDeptAttributeMap[key1] = [];
																}
																vm.criteriaDeptAttributeMap[key1].push(attribute.AttributeSystemName);
																dependentAttributesDisplayNames.push(utility.getAttributeDisplayNameUsingSystemName(catalogFactory.getActiveCatalogDetails().AssignedCatalogAttributes, key1));
																dependentAttributeField.isDependentAttribute = true;
															}
														}
														if (obj2[key1]) {
															angular.forEach(deptAttr[key1], function (val) {
																if (obj2[key1][val]) {
																	if (obj2[key1][val].indexOf(key)) {
																		obj2[key1][val].push(key);
																	}
																} else {
																	obj2[key1][val] = [key];
																}
															});
														} else {
															angular.forEach(deptAttr[key1], function (val) {
																obj[val] = [key];
															});
															obj2[key1] = obj;
														}
													}
												}
											}
										}
										dependingAttributes[attribute.AttributeSystemName] = obj2;
										vm.dependingAttributesMap.push(dependingAttributes);
										var obj = {};
										obj[attribute.AttributeSystemName] = vettinglistCriteria;
										vm.vettingListCriteriaList.push(obj);
										var criteriaDisplayMessage = 'Attribute ' + attribute.AttributeDisplayName + ' is dependent on the attribute(s) ' + dependentAttributesDisplayNames + '.';
										field.criteriaDisplayMessage = criteriaDisplayMessage;
									}
								}
							})
						}
					}
				}

				else if (vm.model.modelPath === 'catalogs.linePlanArticles' && field.inputType === 'text' && field.field.toLowerCase() === 'article_type') {
					if (vm.isNew) {
						vm.record[field.field] = 'new';
					}
					field.validation.disabledCriteria = true;
				}

				else if (field.inputType === 'int-bool') {
					if(angular.isUndefined(vm.record[field.field])) {
						vm.record[field.field] = '0';
					}
				}

				else if (field.inputType === 'bool-int') {
					if(angular.isUndefined(vm.record[field.field])) {
						vm.record[field.field] = 0;
					}
				}

				else if (field.inputType === 'bool-str') {
					if(angular.isUndefined(vm.record[field.field])) {
						vm.record[field.field] = isDefaultValueAssigned ? field.DefaultValue.toLowerCase() : 'false';
					}
				}

				else if (field.inputType === 'date' || field.inputType === 'date-option') { // workaround for issue with interpolation on ng-disabled on md-datepicker
					if(angular.isUndefined(vm.record[field.field]) && isDefaultValueAssigned) {
						vm.record[field.field] = utility.formatDate(new Date(field.DefaultValue), 'yyyy-MM-dd');
					}
					if ($scope.$eval(field.validation.disabledCriteria) || (field.showInEdit && !field.editable)) {
						//vm.disableDate =  true;
						field.validation.disabled = true;
					} else {
						field.validation.disabled = false;
					}
				}
				else if (field.inputType === 'date-utc') { // workaround for issue with interpolation on ng-disabled on md-datepicker
					if ($scope.$eval(field.validation.disabledCriteria) || (field.showInEdit && !field.editable)) {
						//vm.disableDateUTC =  true;
						field.validation.disabled = true;
					} else {
						field.validation.disabled = false;
					}
				}
				else if (field.inputType === 'date-without-time') { // workaround for issue with interpolation on ng-disabled on md-datepicker
					if(angular.isUndefined(vm.record[field.field]) && isDefaultValueAssigned) {
						vm.record[field.field] = utility.formatDate(new Date(field.DefaultValue), 'yyyy-MM-dd');
					}
					if ($scope.$eval(field.validation.disabledCriteria) || (field.showInEdit && !field.editable)) {
						field.validation.disabled = true;
					} else {
						field.validation.disabled = false;
					}
				}
				else if (field.inputType === 'calculated') { // calculated fields are neither creatable nor editable
					field.creatable = false;
					field.editable = false;
				}
				else if (field.inputType === 'color') {
					vm.colors = mockFactory.getFavoritesColors();
					if (vm.isNew) {
						// assign color based on index when creating new favorite tag
						vm.randomColorForFavoriteTag = vm.colors[existingRecordsForUniqueValue.length % vm.colors.length];
					}
				}

				else if (field.inputType === 'color-picker') {
					if(angular.isUndefined(vm.record[field.field])) {
						vm.record[field.field] = '#969696';
					}
				}

				else if(field.inputType === 'decimal') {
					if(angular.isUndefined(vm.record[field.field])) {
						vm.record[field.field] = isDefaultValueAssigned ? Number(field.DefaultValue) : 0;
					}
				}
				else if (field.inputType === 'lookup-table') {
					field.isLookupAdded = true;
					if (angular.isDefined(validSellerLookupsDestinationAttributesMap[field.field])) {
							var attributeLookupValues = validSellerLookupsDestinationAttributesMap[field.field];
							var sourceAttributesDisplayNames = [];
							var matched = false;
							for (var j = 0; j < attributeLookupValues.length; j++) {
									var allAttributesMatch = true;
								var value = attributeLookupValues[j];
									for (var attributeSystemName in value.Source) {
											if (value.Source.hasOwnProperty(attributeSystemName)) {
												if(vm.record[attributeSystemName] == null || value.Source[attributeSystemName].toString().toLowerCase() !== vm.record[attributeSystemName].toString().toLowerCase()) {
														allAttributesMatch = false;
														break;
												}
											}
									}

									if (allAttributesMatch) {
											if(vm.record[field.field] !== value.Destination[field.field]) {
													vm.record[field.field] = value.Destination[field.field];
											}
											matched = true;
											break;
									}
							}

							// create source attributes map
							if(attributeLookupValues.length) {
									var firstSourceDestinationValue = attributeLookupValues[0];
									for (var attributeSystemName in firstSourceDestinationValue.Source) {
											var index = sourceAttributesDisplayNames.indexOf(utility.getAttributeDisplayNameUsingSystemName(catalogFactory.getActiveCatalogDetails().AssignedCatalogAttributes, attributeSystemName));
											if (index === -1) {
													sourceAttributesDisplayNames.push(utility.getAttributeDisplayNameUsingSystemName(catalogFactory.getActiveCatalogDetails().AssignedCatalogAttributes, attributeSystemName));
													var sourceAttributeField = utility.filterObject(vm.visibleFields, { field: attributeSystemName }, true)[0];
													if (angular.isDefined(sourceAttributeField)) {
															sourceAttributeField.isLookupSourceAttribute = true;
													}
											}
											if (!vm.lookupSourceAndDeptAttributeMap[attributeSystemName]) {
													vm.lookupSourceAndDeptAttributeMap[attributeSystemName] = [];
											}
											if (vm.lookupSourceAndDeptAttributeMap[attributeSystemName].indexOf(field.field) === -1) {
													vm.lookupSourceAndDeptAttributeMap[attributeSystemName].push(field.field);
											}
									}
							}
							if (!matched) {
									vm.record[field.field] = null;
							}
							field.lookupDisplayMessage = 'Attribute ' + field.displayLabel + ' is dependent on the attribute(s) ' + sourceAttributesDisplayNames.join(', ') + '.';
					} else {
						field.lookupDisplayMessage = 'Attribute ' + field.displayLabel + ' does not have any source attribute(s) assigned';
					}
				}

				if (field.checkIfUnique) {
					vm.existingRecordsForUniqueValue = existingRecordsForUniqueValue ? existingRecordsForUniqueValue : [];
				}

				// validate dependant attributes on tx pattern attribute changes
				if((vm.model.modelPath === 'catalogs.articles' || vm.model.modelPath === 'catalogs.linePlanArticles')) {
						if(angular.isDefined(field.validation) && field.validation['tx-pattern']) {
								var validationExpression = utility.isValidJSON(field.validation['tx-pattern']);
								if(validationExpression && angular.isDefined(validationExpression.F) && validationExpression.F.length > 0) {
										var parsedExpressionObjects = validationExpression.F;
										angular.forEach(parsedExpressionObjects, function(parsedExpressionObject) {
												var sourceField = parsedExpressionObject['SourceField'];
												var sourceAttributeField = utility.filterObject(vm.visibleFields, {field: sourceField}, true)[0];
												if(angular.isDefined(sourceAttributeField) && (!sourceAttributeField.validation.disabledCriteria)) {
														// if source field is required then make the isRequired property true for that attribute
														if(parsedExpressionObject.SourceValueRequired) {
																sourceAttributeField.validation.isRequired = true;
														}
														sourceAttributeField.isSourceAttributeForValidation = true;
												}
										});
								}
						}

						// show info message for retail intro and exit months
						if (field.inputType === 'lookup') {
								if(field.field === 'RetailIntroMonthId') {
									field.retailMonthDisplayMessage = 'Retail Intro Month is dependent on the attribute ' + retailWindowAttribute + '.';
								}

								if(field.field === 'RetailExitMonthId') {
									field.retailMonthDisplayMessage = 'Retail Exit Month is dependent on the attribute ' + retailWindowAttribute + ' and Retail Intro Month.';
								}
						}
				}
			}

			function getVisibleFields(model) {
					return $filter('filterUnion')(model.fields, vm.filterExpression);
			}

			function getFilteredCriteriaValues(colors) {
					var results = [];
					angular.forEach(colors, function(color) {
							// conditions inside one criteria are AND'ed, several criteria on the same palette are OR'ed
							var match = utility.matchesColorCriteria(utility.normalizeColorCriteria(color.ColorCriteria), getCriteriaRecordValue);
							if(match.isMatch) {
									flagColorDeptAttributes(match.matchedAttributes);
									results.push(color);
							}
					});
					return results;
			}

			function getCriteriaRecordValue(attributeSystemName) {
					return vm.record[attributeSystemName];
			}

			// mark the attributes the matched criteria depends on, so changing one clears the selected color
			function flagColorDeptAttributes(attributeSystemNames) {
					angular.forEach(attributeSystemNames, function(attributeSystemName) {
							var colorDeptAttributeField = utility.filterObject(vm.visibleFields, {field: attributeSystemName}, true)[0];
							if(angular.isDefined(colorDeptAttributeField)) {
									colorDeptAttributeField.isColorDeptAttribute = true;
							}
					});
			}

			// when lookup source attribute changed
			function lookupSourceAttributeChanged(field) {
				// when model number change attribute system name is passed
				var sourceAttributeName = angular.isDefined(field.field) ? field.field: field;
				if (vm.lookupSourceAndDeptAttributeMap.hasOwnProperty(sourceAttributeName)) {
						var dependentAttributeNames = vm.lookupSourceAndDeptAttributeMap[sourceAttributeName];
						for (var i = 0; i < dependentAttributeNames.length; i++) {
								var dependentAttributeName = dependentAttributeNames[i];
								if (angular.isDefined(validSellerLookupsDestinationAttributesMap[dependentAttributeName])) {
										var attributeLookupValues = validSellerLookupsDestinationAttributesMap[dependentAttributeName];
										var matched = false;
										for (var j = 0; j < attributeLookupValues.length; j++) {
												var allAttributesMatch = true;
											var value = attributeLookupValues[j];
												for (var attributeSystemName in value.Source) {
														if (value.Source.hasOwnProperty(attributeSystemName)) {
															if(vm.record[attributeSystemName] == null || value.Source[attributeSystemName].toString().toLowerCase() !== vm.record[attributeSystemName].toString().toLowerCase()) {
																	allAttributesMatch = false;
																	break;
															}
														}
												}
												if (allAttributesMatch) {
														if(vm.record[dependentAttributeName] !== value.Destination[dependentAttributeName]) {
															vm.record[dependentAttributeName] = value.Destination[dependentAttributeName];
														}
														matched = true;
														break;
												}
										}
										if (!matched) {
												vm.record[dependentAttributeName] = null;
										}
								}
						}
				}
			}

			function isFormValid() {
					var isRequiredFieldsValid = true;
					// check if any required fields are empty
					angular.forEach(vm.visibleFields, function (field) {
							if (field.validation && field.validation.isRequired) {
									if (angular.isUndefined(vm.record[field.field]) || vm.record[field.field] === null || vm.record[field.field] === '') {
											isRequiredFieldsValid = false;
									}
							}
					});
					return vm.editForm.$valid && isRequiredFieldsValid;
			}

			function handleFieldChange(field) {
				vm.requiredAttributesErrorMessages = [];
				if(vm.editForm['StateId']) {
					vm.editForm['StateId'].$setValidity('stateRequirement', true);
					vm.isStateValidationFailedWithoutElement = false;
				}
				// Validate tx-pattern
				if (field.validation['tx-pattern'] && vm.currentFocusedField === field.field) {
						vm.validateTxPattern(field);
				}

				// Handle criteria dependent changes
				if (field.isColorDeptAttribute) {
						vm.colorDependentCriteriaAttributeChanged(field);
				}

				// Handle lookup source attribute changes
				if (field.isLookupSourceAttribute) {
						vm.lookupSourceAttributeChanged(field);
				}

				// if this attribute is a dependant attribute of any criteria attribute revalidat the values of criteria attributes
				var dependentAttributeField = field.field;
				if(vm.criteriaDeptAttributeMap[dependentAttributeField]) {
						var criteriaAttributes = vm.criteriaDeptAttributeMap[dependentAttributeField];
						angular.forEach(criteriaAttributes, function(criteriaAttribute) {
								var criteriaField = utility.filterObject(vm.visibleFields, {field: criteriaAttribute}, true)[0];
								if (!criteriaField) { return; } // target criteria attribute isn't a field in this dialog -> nothing to refresh/clear
								var isMultiValueAttribute = (criteriaField.inputType === 'multi-value') ? true : false;
								// CriteriaV2 (preferred): refresh dropdown + clear current value if not in matched rule's AllowedValues
								if(vm.criteriaV2Map[criteriaAttribute]) {
										getConditionalVettingList(criteriaField);
										var getDependentValueForCriteriaV2 = function(dependentField) {
												var depVal = vm.record[dependentField];
												return (depVal && typeof depVal === 'object') ? (angular.isDefined(depVal.value) ? depVal.value : depVal) : depVal;
										};
										var criteriaV2AllowedLower = utility.getCriteriaV2AllowedValues(vm.criteriaV2Map[criteriaAttribute], getDependentValueForCriteriaV2)
												.map(function(value) { return value.toString().toLowerCase(); });
										var currentCriteriaValue = vm.record[criteriaAttribute];
										var isCriteriaV2Valid;
										if (isMultiValueAttribute) {
												isCriteriaV2Valid = (Array.isArray(currentCriteriaValue) && currentCriteriaValue.length > 0)
														? currentCriteriaValue.every(function(value) { return criteriaV2AllowedLower.indexOf((value == null ? '' : value).toString().toLowerCase()) !== -1; })
														: true;
										} else {
												isCriteriaV2Valid = (currentCriteriaValue === null || currentCriteriaValue === undefined || currentCriteriaValue === '')
														? true
														: criteriaV2AllowedLower.indexOf(currentCriteriaValue.toString().toLowerCase()) !== -1;
										}
										if (!isCriteriaV2Valid) {
												vm.record[criteriaAttribute] = isMultiValueAttribute ? [] : null;
												vm.editForm[criteriaAttribute].$touched = true;
										}
										return; // skip OLD criteria path
								}
								var attributeCriteria = {};
								angular.forEach(vm.dependingAttributesMap, function(criteriaAttr) {
										for(var key in criteriaAttr) {
												if(criteriaAttr.hasOwnProperty(key)) {
														if(key.toLocaleLowerCase() === criteriaAttribute.toLowerCase()) {
																attributeCriteria = criteriaAttr[key];
																break;
														}
												}
										}
								});
								if(angular.isDefined(attributeCriteria[dependentAttributeField][vm.record[dependentAttributeField]])) {
										var index = attributeCriteria[dependentAttributeField][vm.record[dependentAttributeField]].indexOf(vm.record[criteriaAttribute]);
										if (index === -1) {
												vm.record[criteriaAttribute] = isMultiValueAttribute ? [] : null;
												vm.editForm[criteriaAttribute].$touched = true;
										}
								} else {
										vm.record[criteriaAttribute] = isMultiValueAttribute ? [] : null;
										vm.editForm[criteriaAttribute].$touched = true;
								}
						});
				}
			}

			function onSearchTextChanged() {
				if (!vm.searchPageText) {
					vm.filteredVisibleFields = angular.copy(vm.visibleFields);
						return;
				}

				vm.filteredVisibleFields = vm.visibleFields.filter(function(item) {
						if (!item || !item.displayLabel) return false;

						var translatedLabel = $translate.instant(item.displayLabel);
						return translatedLabel.toLowerCase().indexOf(vm.searchPageText.toLowerCase()) !== -1;
				});
			}

	}
})();
(function(){
    'use strict';

    angular
        .module('app.main.catalogs.articles')
        .controller('confirmDropController', confirmDropController);

    /* @ngInject */
    function confirmDropController($mdDialog, utility, model, record, actionObject, suggestedArticlesPromise, dropReasons) {
        /**jshint validthis: true */
        var vm = this;

        //data
        vm.title = actionObject.confirmationContent.title;
        vm.message = actionObject.confirmationContent.message;
        vm.action = actionObject.confirmationAction;
        vm.translateVar = {artNumber: record['ArticleNumber']};
        vm.lookupModel = angular.copy(record);
        vm.lookupModel.RAID = undefined;
        vm.isDropReasonsAdded = dropReasons.length ? true : false;
        vm.requiresReplacement = false;
        vm.requiresComment = false;
        vm.dropComment = '';

        var dropRequestObj = {};
        dropRequestObj['ArticleIdDropped'] = record[model.idField];
        var suggestedArticles = [];


        //methods
        vm.cancel = cancel;
        vm.closeDialog = closeDialog;

        vm.lookupSearch = lookupSearch;
        vm.lookupChange = lookupChange;
        vm.getLookupDisplayValue = getLookupDisplayValue;
        vm.selectText = selectText;

        vm.lookupArticleDropReasons = lookupArticleDropReasons;
        vm.lookupArticleDropReasonChange = lookupArticleDropReasonChange;
        vm.getLookupArticleDropReasonDisplayValue = getLookupArticleDropReasonDisplayValue;


        activate();

        /////////////

        function activate() {
            getSuggestedArticles();
        }

        function cancel(cancelVal) {
           $mdDialog.cancel(cancelVal); // do nothing
        }

        function closeDialog() {
            if(vm.dropComment) {
                dropRequestObj['DropComment'] = vm.dropComment;
            }
            if(angular.isDefined(vm.lookupModel.RAID) && vm.lookupModel.RAID != null && vm.lookupModel.RAID !== record.RAID) {
                dropRequestObj['ReplacementArticleId'] = dropRequestObj['ArticleIdAlt'];
            }
            $mdDialog.hide(dropRequestObj);
        }

        function lookupSearch(query) {
            var results = [];

            if(suggestedArticles.length) {
                results = query ? utility.filterObject(suggestedArticles , {ArticleNumber: query}) : suggestedArticles;
                return results;
            }
            else {
                return suggestedArticlesPromise['suggestedArticles'].then(function(response) {
                    results = query ? utility.filterObject(response.data , {ArticleNumber: query}) : response.data;
                    return results;
                });
            }
        }

        // convert drawdown scope value form object(lookup record) to id property of lookup record
        function lookupChange(selectedObj) {
            if(angular.isObject(selectedObj)) {
                dropRequestObj['ArticleIdAlt'] = selectedObj['ArticleId'];
            }
            else if(angular.isUndefined(selectedObj) || selectedObj === null) {
                dropRequestObj['ArticleIdAlt'] = undefined; // on record removal make field undefined or the property can be deleted using delete keyword
            }
        }

        function getLookupDisplayValue(item) {
            if(suggestedArticles.length) {
                return getLookupDisplayVal(item, suggestedArticles);
            }
            else {
                return suggestedArticlesPromise['suggestedArticles'].then(function(response) {
                    return getLookupDisplayVal(item, response.data);
                });
            }
        }

        function selectText(event) {
            utility.selectInputText(event);
        }

        //helper method
        function getLookupDisplayVal(item, data) {
            var result;
            if(data) {
                // since autocomplete return object
                if(angular.isObject(item)) {
                    result = utility.filterObject(data, {ArticleId: item.ArticleId}, true);
                }
                // to initialize field value if any (when open update record dialog)
                else {
                    result = utility.filterObject(data, {ArticleId: item}, true);
                }

                if (angular.isArray(result) && result.length > 0) {
                    return result[0].ArticleNumber;
                }
                else {
                    return result.ArticleNumber;
                }
            }
        }

        function lookupArticleDropReasons(query) {
            var results = [];
            results = query ? utility.filterObject(dropReasons, {Reason: query}) : dropReasons;
            return results;
        }

        // convert drawdown scope value form object(lookup record) to id property of lookup record
        function lookupArticleDropReasonChange(selectedObj) {
            if(angular.isObject(selectedObj)) {
                dropRequestObj['DropReason'] = selectedObj.Id;
                dropRequestObj['Reason'] = selectedObj.Reason;
                vm.requiresReplacement = selectedObj.RequiresReplacement === 1;
                vm.requiresComment = selectedObj.RequiresComment === 1;
                if(!vm.requiresComment) {
                    vm.dropComment = '';
                }
            }
            else if(angular.isUndefined(selectedObj) || selectedObj === null) {
                dropRequestObj['DropReason'] = undefined;
                vm.requiresReplacement = false;
                vm.requiresComment = false;
                vm.dropComment = '';
            }
        }

        function getLookupArticleDropReasonDisplayValue(item) {
            var result;
            if(dropReasons) {
                // since autocomplete return object
                if(angular.isObject(item)) {
                    result = utility.filterObject(dropReasons, {Reason: item.Reason}, true);
                }
                // to initialize field value if any (when open update record dialog)
                else {
                    result = utility.filterObject(dropReasons, {Reason: item.Reason}, true);
                }

                if (angular.isArray(result) && result.length > 0) {
                    return result[0].Reason;
                }
                else {
                    return result.Reason;
                }
            }
        }

        function selectText(event) {
            utility.selectInputText(event);
        }

        function getSuggestedArticles() {
            suggestedArticlesPromise['suggestedArticles'].then(function(response) {
                suggestedArticles = response.data;
            });
        }

    }
})();
(function () {
	'use strict';

	angular
		.module('app.main.catalogs.articles')
		.controller('assignArticleToMasterCatalogController', assignArticleToMasterCatalogController);

	/* @ngInject */
	function assignArticleToMasterCatalogController($mdDialog, $scope, $filter, scope, toast, hotkeys, $log, $translate,
		api, utility, editMode, model, record, catalogCode, lookupPromises, $mdConstant, catalogFactory, mockFactory, crud, $q) {
		var vm = this;

		var activeCatalog = catalogFactory.getActiveCatalog();
		var retailWindowAttribute = activeCatalog.RetailWindowAttribute;

		vm.isLoading = false;
		vm.model = model;
		vm.record = angular.copy(record);
		vm.filterExpression = { creatable: true };
		vm.isNew = false;
		vm.isDataDirty = false;
		vm.maxTags;
		vm.ErrorMessage = "";
		vm.colors = [];
		vm.randomColorForFavoriteTag = '';
		var months = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];

		vm.dependingAttributesMap = [];
		vm.criteriaDeptAttributeMap = {};
		vm.vettingListCriteriaList = [];
		vm.criteriaV2Map = {}; // AttributeSystemName -> parsed CriteriaV2 rules array (preferred over OLD Criteria)

		vm.acSelectedItem = [];
		vm.acSearchText = [];
		vm.searchText = {};
		vm.tagSeperatorKeys = {};
		vm.existingRecordsForUniqueValue = [];
		vm.isNew = !editMode;
		if (!vm.record) {
			//Create empty object
			vm.record = {};
			vm.isNew = true;
		}
		vm.availableModels = [];
		vm.visibleAttributeFields = [];
		vm.availableArticles = [];
		vm.isAboveModelDropDownLimit = false;
		vm.isAboveArticleDropDownLimit = false;
		var validSellerLookupsDestinationAttributesMap = api.validSellerLookupsDestinationAttributesMap;
		vm.lookupSourceAndDeptAttributeMap = {};
		vm.selectedArticle = {};
		vm.selectedModel = {};
		vm.showColorTypeInColorPalatteDropdown = api.showColorTypeInColorPalatteDropdown
		var dataSourceTypeId = catalogFactory.getActiveCatalogDetails().DataSourceTypeId;

		vm.saveRecord = saveRecord;
		vm.closeDialog = closeDialog;

		vm.lookupSearch = lookupSearch;
		vm.lookupChange = lookupChange;
		vm.customLookupChange = customLookupChange;
		vm.getLookupDisplayValue = getLookupDisplayValue;
		vm.getCustomLookupDisplayValue = getCustomLookupDisplayValue;
		vm.selectText = selectText;
		vm.colorPaletteLookupChange = colorPaletteLookupChange;

		vm.transformChip = transformChip;
		vm.acQuerySearch = acQuerySearch;
		vm.getChipDisplayValue = getChipDisplayValue;
		vm.add = add;

		vm.isInputRequired = isInputRequired;
		vm.getDateObj = getDateObj;
		vm.validateTxPattern = validateTxPattern;
		vm.getConditionalVettingList = getConditionalVettingList;
		vm.multiValueQuerySearch = multiValueQuerySearch;

		vm.validateJSON = validateJSON;
		vm.searchModels = searchModels;
		vm.getModelDisplayValue = getModelDisplayValue;
		vm.onModelsChange = onModelsChange;
		vm.searchArticles = searchArticles;
		vm.getArticleDisplayValue = getArticleDisplayValue;
		vm.onArticlesChange = onArticlesChange;
		vm.lookupSourceAttributeChanged = lookupSourceAttributeChanged;
		vm.isFormValid = isFormValid;
		vm.handleFieldChange = handleFieldChange;
		vm.onSearchTextChanged= onSearchTextChanged;

		activate();

		////////////////

		function activate() {
			vm.visibleAttributeFields = getVisibleAttributeFields(vm.model);
			populateDefaultValues();
			vm.filteredVisibleAttributeFields = angular.copy(vm.visibleAttributeFields )
			//Hotkeys
			hotkeys.bindTo($scope)
				.add({
					combo: 'ctrl+enter',
					description: $filter('translate')('ACTIONS.SAVE'),
					allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
					callback: function (event) {
						if (!vm.isLoading && !vm.editForm.$invalid) {
							vm.saveRecord();
						}
					}
				});

			if (vm.isNew) {
				hotkeys.bindTo($scope)
					.add({
						combo: 'ctrl+shift+enter',
						description: $filter('translate')('ACTIONS.SAVE_AND_NEW'),
						allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
						callback: function (event) {
							if (!vm.isLoading && !vm.editForm.$invalid) {
								vm.saveRecord(true);
							}
						}
					});
			}
		}

		//On addition of new tag it validates that the tag should not contain pipe
		function add(chip, chips, field) {
			if (chip) {
				if (chip.indexOf(field.tagSeparator) !== -1) {
					vm.record[field.field].splice(vm.record[field.field].indexOf(chip), 1);
					vm.record[field.field] = vm.record[field.field].concat(chip.split(field.tagSeparator));
					vm.maxTags = vm.record[field.field].length + 1;
				} else {
					vm.maxTags = field.maxLen;
				}
			}
			//for displaying error message
			if (angular.isDefined(field.maxLen) && vm.maxTags != field.maxLen) {
				vm.ErrorMessage = field.validation.messages.pattern;
				return true;
			} else {
				vm.ErrorMessage = "";
				return false;
			}
		}

		function saveRecord() {
			vm.isLoading = true;

			//Transform the fields of type dateUTC
			angular.forEach(vm.model.fields, function (itm) {
				//To avoid date-option and datetime timezone issue
				if ((itm.inputType === 'date-utc' || itm.inputType === 'date-option' || itm.inputType === 'date') && angular.isDefined(vm.record[itm.field]) && angular.isDate(vm.record[itm.field])) {
					var d = vm.record[itm.field];
					vm.record[itm.field] = new Date(d.setHours(12 - (d.getTimezoneOffset() / 60), 0, 0));
				}

				if (itm.inputType === 'calculated') {
					delete vm.record[itm.field];
				}

				if(!itm.validation.isRequired && (vm.record[itm.field] === '' || vm.record[itm.field] === 0 || (vm.record[itm.field] && vm.record[itm.field].length === 0))) {
					delete vm.record[itm.field];
				}

				if ((itm.inputType === 'articlenumber' || itm.inputType === 'modelnumber') && angular.isDefined(vm.record[itm.field]) && vm.record[itm.field] !== null && vm.record[itm.field].toString().length > 0) {
					vm.record[itm.field] = vm.record[itm.field].toString();
				}

				if ((itm.inputType === 'number' || itm.type === 'int') && vm.record[itm.field] != null) {
					vm.record[itm.field] = parseInt(vm.record[itm.field]);
				}

				if ((itm.inputType === 'color-palette') && angular.isDefined(vm.record[itm.field]) && vm.record[itm.field] != null && vm.record[itm.field] !== '' && angular.isObject(vm.record[itm.field])) {
					var key = Object.keys(vm.record[itm.field])[0];
					var val = vm.record[itm.field][key];
					if (typeof val === 'string' && val.includes(':')) {
						val = val.split(':')[1].trim();
					}
					vm.record[itm.field][key] = val;
					vm.record[itm.field] = angular.toJson(vm.record[itm.field]);
				}

				// remove all invisible special characters from strings
				if ((itm.inputType === 'text' || itm.inputType === 'textArea') && vm.record[itm.field] != null && vm.record[itm.field] !== '' && typeof vm.record[itm.field] === 'string') {
					vm.record[itm.field] = vm.record[itm.field].replace(/[\u00A0\u00AD\u200B-\u200D\uFEFF\u2028\u2029\u2060]/g, '');
				}

				if ((itm.inputType === 'multi-value' || itm.inputSubType === 'multi-value') && vm.record[itm.field] != null && vm.record[itm.field] !== '' && vm.record[itm.field].length) {
					angular.forEach(vm.record[itm.field], function(value, index) {
						vm.record[itm.field][index] = value.replace(/[\u00A0\u00AD\u200B-\u200D\uFEFF\u2028\u2029\u2060]/g, '');
					})
				}

				if (itm.inputType === 'dataset' && vm.record[itm.field] != null && vm.record[itm.field] !== '') {
					if(typeof (vm.record[itm.field]) === 'object') {
							vm.record[itm.field] = Object.keys(vm.record[itm.field])[0].toString()
					}
					else {
							vm.record[itm.field] = vm.record[itm.field].toString();
					}
				}

				if(itm.inputType === 'datatable' && vm.record[itm.field] != null && vm.record[itm.field] !== '') {
					 vm.record[itm.field] = angular.toJson(vm.record[itm.field]);
				}
			});

			saveData();
		}

		function saveData() {
			var p;

			if (!vm.editForm.$invalid) {
				// remove model id and model number
				delete vm.record['ModelNumber'];
				vm.record['ArticleNumber'] = vm.record['ArticleNumber'].ArticleNumber;
				// if retail window is applied then send the shipmentwindowrangeid frm selected intro and exit month
				if(catalogFactory.getActiveCatalogDetails().IsShippingWindowApply == 1 && vm.record.RetailExitMonthId != null) {
					vm.record['ShipmentWindowRangeId'] = vm.record.RetailExitMonthId;
				}
				p = vm.model.methods.assignArticlesToMasterCatalog(vm.record, catalogCode, vm.model);

				p.then(function (response) {
					closeDialog(true);
					var toastMessage = 'SUCCESS.CREATE';
					toast.success(toastMessage, '', '');
				}, function () {
					closeDialog(vm.isDataDirty);
				}).finally(function () {
					vm.isLoading = false;
				});
			} else {
				vm.isLoading = false;
			}
		}

		function closeDialog(saved) {
			$mdDialog.hide(saved);
		}

		function lookupSearch(query, field) {
			var results = [];
			var lookupFilter = angular.isDefined(field.lookupFilter) ? field.lookupFilter : {};
			var predicate = angular.copy(lookupFilter);
			predicate.value = query;
			var lookupModel = api.getModel(field.lookupSource);

			if (lookupModel && angular.isDefined(lookupModel.lookupData) && angular.isDefined(lookupModel.lookupData.data) && lookupModel.lookupData.data.length) {
				var lookupDataList = lookupModel.lookupData.data;
				// if RetailIntroMonth/RetailExitMonth filter the retail window intro/exit month based on configured retailWindowAttribute and value
				if(field.field === 'RetailIntroMonthId' || field.field === 'RetailExitMonthId') {
					var assignedRetailWindowAttributeValue = vm.selectedArticle[retailWindowAttribute];
					if(assignedRetailWindowAttributeValue != null) {
							// filter intro month based on assignedRetailWindowAttributeValue
							if(field.field === 'RetailIntroMonthId') {
									lookupDataList = utility.getUniquieRetailIntroAndExitMonths(utility.filterObject(lookupDataList, {CriteriaAttributeValue: assignedRetailWindowAttributeValue, Status: 1}, true));
									lookupDataList = lookupDataList.sort(function(a, b) {
											return months.indexOf(a.RetailIntroMonth.toString().toLowerCase().trim().substring(0, 3)) - months.indexOf(b.RetailIntroMonth.toString().toLowerCase().trim().substring(0, 3))
									})
							}
							// filter exit month based on selected retail intro month and assignedRetailWindowAttributeValue
							if(field.field === 'RetailExitMonthId') {
									var assignedRetailIntroMonth = {};
									if(angular.isDefined(vm.record['RetailIntroMonthId'])) {
											assignedRetailIntroMonth = utility.filterObject(lookupDataList, {id: vm.record['RetailIntroMonthId']}, true)[0];
									} else { // filter with monthvalue
											assignedRetailIntroMonth = utility.filterObject(lookupDataList, {value: vm.record['RetailIntroMonth']}, true)[0];
									}
									if(angular.isDefined(assignedRetailIntroMonth)) {
											lookupDataList = utility.getUniquieRetailIntroAndExitMonths(utility.filterObject(lookupDataList, {RetailIntroMonth: assignedRetailIntroMonth.RetailIntroMonth, CriteriaAttributeValue: assignedRetailWindowAttributeValue, Status: 1}, true));
											lookupDataList = lookupDataList.sort(function(a, b) {
													return months.indexOf(a.value.toString().toLowerCase().trim().substring(0, 3)) - months.indexOf(b.value.toString().toLowerCase().trim().substring(0, 3))
											})
									} else {
											lookupDataList = [];
									}
							}
					} else {
							lookupDataList = [];
					}
				}
				results = query ? utility.filterObject(lookupDataList, predicate) : utility.filterObject(lookupDataList, lookupFilter, true);
				// this is to reduce the rendering time. It was very slow and was impacted overall page responsiveness
				// so while displaying we will display only the first 100 records and user can filter with any value
				if(results.length > 100) {
					field['isAboveDropDownLimit'] = true;
					return results.slice(0, 100);
				} else {
					field['isAboveDropDownLimit'] = false;
					return results;
				}
			}
			else {
				return lookupPromises[field.field].then(function (lookupData) {
					var lookupDataList = lookupData.data;
					//  if RetailIntroMonth/RetailExitMonth filter the retail window intro/exit month based on configured retailWindowAttribute and value
					if(field.field === 'RetailIntroMonthId' || field.field === 'RetailExitMonthId') {
						var assignedRetailWindowAttributeValue = vm.selectedArticle[retailWindowAttribute];
						if(assignedRetailWindowAttributeValue != null) {
								// filter intro month based on assignedRetailWindowAttributeValue
							if(field.field === 'RetailIntroMonthId') {
									lookupDataList = utility.getUniquieRetailIntroAndExitMonths(utility.filterObject(lookupDataList, {CriteriaAttributeValue: assignedRetailWindowAttributeValue, Status: 1}, true));
									lookupDataList = lookupDataList.sort(function(a, b) {
											return months.indexOf(a.RetailIntroMonth.toString().toLowerCase().trim().substring(0, 3)) - months.indexOf(b.RetailIntroMonth.toString().toLowerCase().trim().substring(0, 3))
									})
							}
							// filter exit month based on selected retail intro month and assignedRetailWindowAttributeValue
							if(field.field === 'RetailExitMonthId') {
									var assignedRetailIntroMonth = {};
									if(angular.isDefined(vm.record['RetailIntroMonthId'])) {
											assignedRetailIntroMonth = utility.filterObject(lookupDataList, {id: vm.record['RetailIntroMonthId']}, true)[0];
									} else { // filter with monthvalue
											assignedRetailIntroMonth = utility.filterObject(lookupDataList, {value: vm.record['RetailIntroMonth']}, true)[0];
									}
									if(angular.isDefined(assignedRetailIntroMonth)) {
											lookupDataList = utility.getUniquieRetailIntroAndExitMonths(utility.filterObject(lookupDataList, {RetailIntroMonth: assignedRetailIntroMonth.RetailIntroMonth, CriteriaAttributeValue: assignedRetailWindowAttributeValue, Status: 1}, true));
											lookupDataList = lookupDataList.sort(function(a, b) {
													return months.indexOf(a.value.toString().toLowerCase().trim().substring(0, 3)) - months.indexOf(b.value.toString().toLowerCase().trim().substring(0, 3))
											})
									} else {
											lookupDataList = [];
									}
							}
						} else {
								lookupDataList = [];
						}
					}
					results = query ? utility.filterObject(lookupDataList, predicate) : utility.filterObject(lookupDataList, lookupFilter, true);
					// this is to reduce the rendering time. It was very slow and was impacted overall page responsiveness
					// so while displaying we will display only the first 100 records and user can filter with any value
					if(results.length > 100) {
						field['isAboveDropDownLimit'] = true;
						return results.slice(0, 100);
					} else {
						field['isAboveDropDownLimit'] = false;
						return results;
					}
				});
			}
		}

		// convert dropdown scope value form object(lookup record) to id property of lookup record
		function lookupChange(selectedObj, field, fieldObject) {
			if (angular.isObject(selectedObj)) {
				vm.record[field] = selectedObj.id;
				// load data from server based on the lockup value
				if (angular.isDefined(fieldObject.validation.onChangeLookUp) && fieldObject.validation.onChangeLookUp.length > 0) {
					var lookUpChangeValues = utility.splitString(fieldObject.validation.onChangeLookUp, ',');
					if (angular.isDefined(lookupExtras[lookUpChangeValues[0]])) {
						lookupExtras[lookUpChangeValues[0]][lookUpChangeValues[1]] = selectedObj.id;
					}
					lookupPromises[field] = crud.createLookupPromise(vm.model, lookupExtras, 'create');
				}

				// filter exit month based on assignedRetailWindowAttributeValue
				if(field === 'RetailIntroMonthId') {
					vm.record['RetailExitMonthId'] = null;
				}
			}
			else if (angular.isUndefined(selectedObj) || selectedObj === null) {
				vm.record[field] = undefined;
				// filter exit month based on assignedRetailWindowAttributeValue
				if(field === 'RetailIntroMonthId') {
					vm.record['RetailExitMonthId'] = null;
				}
			}
		}

		function customLookupChange(selectedObj, field) {
			if (angular.isObject(selectedObj)) {
				vm.record[field.field] = selectedObj[field.customLookupInfo.value];
			}
			else if (angular.isUndefined(selectedObj) || selectedObj === null) {
				vm.record[field.field] = undefined; // on record removal make field undefined or the property can be deleted using delete keywork
			}
		}

		function colorPaletteLookupChange(selectedObj, field) {
			if(angular.isObject(selectedObj) && Object.keys(selectedObj)[0] != null && angular.isDefined(selectedObj.value)) {
					// color palette values are stores as key value pair
					var objectVal = {};
					objectVal[selectedObj.id] = selectedObj.value
					vm.record[field.field] = objectVal;
			}
			else if(angular.isUndefined(selectedObj) || selectedObj === null){
					vm.record[field.field] = undefined; // on record removal make field undefined or the property can be deleted using delete keywork
			}
		}

		// isArticleNumberType for converting article id from string to int
		function getLookupDisplayValue(item, field, isArticleNumberType) {
			var lookupModel = api.getModel(field.lookupSource);
			item = isArticleNumberType ? parseInt(item) : item;

			if (angular.isDefined(lookupModel.lookupData) && angular.isDefined(lookupModel.lookupData.data) && lookupModel.lookupData.data.length) {
				return getLookupDisplayVal(item, lookupModel.lookupData);
			}
			else {
				return lookupPromises[field.field].then(function (lookupData) {
					return getLookupDisplayVal(item, lookupData);
				});
			}
		}

		function getCustomLookupDisplayValue(item, field) {
			//  show only color name for color palette attributes
			if(field.inputType === 'color-palette') {
				return $filter('colorPaletteRenderer')(item, field);
			} else {
				var lookupModel = api.getModel(field.lookupSource);

				if (angular.isDefined(lookupModel.lookupData) && angular.isDefined(lookupModel.lookupData.data) && lookupModel.lookupData.data.length) {
					return getCustomLookupDisplayVal(item, lookupModel.lookupData, field);
				}
				else {
					return lookupPromises[field.field].then(function (lookupData) {
						return getCustomLookupDisplayVal(item, lookupData, field);
					});
				}
			}
		}

		//helper method
		function getLookupDisplayVal(item, lookupData) {
			var result;
			if (lookupData) {
				// since autocomplte return object
				if (angular.isObject(item)) {
					result = utility.filterObject(lookupData.data, { id: item.id }, true);
				}
				// to initialize field value if any (when open update record dialog)
				else {
					result = utility.filterObject(lookupData.data, { id: item }, true);
				}

				if (angular.isArray(result) && result.length > 0) {
					return result[0].value;
				}
				else {
					return result.value;
				}
			}
		}

		function getCustomLookupDisplayVal(item, lookupData, field) {
			var result;
			var predicate = {};
			if (lookupData) {
				// since autocomplete return object
				if (angular.isObject(item)) {
					predicate[field.customLookupInfo.value] = item[field.customLookupInfo.value];
					result = utility.filterObject(lookupData.data, predicate, true);
				}
				// to initialize field value if any (when open update record dialog)
				else {
					predicate[field.customLookupInfo.value] = item;
					result = utility.filterObject(lookupData.data, predicate, true);
				}

				if (angular.isArray(result) && result.length > 0) {
					return result[0].value;
				}
				else {
					return result.value;
				}
			}
		}

		function selectText(event) {
			utility.selectInputText(event);
		}

		function transformChip(chip, isMultiValue) {
			if (angular.isObject(chip)) {
				return chip.id;
			} else if (isMultiValue) {
				return chip;
			}
			return undefined;
		}

		//TODO: Check performance impact on using nested filter
		function acQuerySearch(query, selectedRecords, field) {
			var results = [];
			var lookupFilter = angular.isDefined(field.lookupFilter) ? field.lookupFilter : {};
			var predicate = angular.copy(lookupFilter);
			predicate.value = query;

			var lookupModel = api.getModel(field.lookupSource);
			if (angular.isDefined(lookupModel.lookupData) && angular.isDefined(lookupModel.lookupData.data) && lookupModel.lookupData.data.length) {
				results = query ? utility.filterObject(lookupModel.lookupData.data, predicate) : utility.filterObject(lookupModel.lookupData.data, lookupFilter);
				results = removeSelectedChips(selectedRecords, results);
				results;
			}
			else {
				lookupPromises[field.field].then(function (lookupData) {
					results = query ? utility.filterObject(lookupData.data, predicate) : utility.filterObject(lookupData.data, lookupFilter);
					results = removeSelectedChips(selectedRecords, results);
					results;
				});
			}
			return results;
		}

		/**
		* @description
		* This method will remove selected chips form records (helper method)
		* @param {array} selectedRecords: list of selected chips
		* @param {array} records: data property of lookup-data
		* @returns {array}: list of available chips (chips which are not selected) // it does not really need to return a value but for readability returning modified value
		*/
		function removeSelectedChips(selectedRecords, records) {
			if (angular.isDefined(selectedRecords) && selectedRecords != null && selectedRecords.length > 0) {
				for (var index = records.length - 1; index >= 0; index--) {
					if (selectedRecords.indexOf(records[index].id) !== -1) {
						records.splice(index, 1);
					}
					if (selectedRecords.indexOf(records[index]) !== -1) {
						records.splice(index, 1);
					}
				}
			}
			return records;
		}

		function getChipDisplayValue(chip, field) {
			var lookupModel = api.getModel(field.lookupSource);
			if (angular.isDefined(lookupModel.lookupData) && angular.isDefined(lookupModel.lookupData.data) && lookupModel.lookupData.data.length) {
				return getChipDisplayVal(lookupModel.lookupData, chip);
			}
			else { // it will never go to else part since before try to load display value for selected chips, it always load lookup on focus of chips input element
				return lookupPromises[field.field].then(function (lookupData) {
					return getChipDisplayVal(lookupData, chip);
				});
			}
		}

		//helper method
		function getChipDisplayVal(lookupData, chip) {
			var res = utility.filterObject(lookupData.data, { id: chip }, true);
			if (angular.isArray(res) && res.length > 0) {
				return res[0].value;
			}
			else {
				$log.warn('viewCreator controller: Unable to resolve chip display value!');
				return "";
			}
		}

		function isInputRequired(field) {
			if (angular.isString(field.validation.isRequired)) {
				return (scope.$eval(field.validation.isRequired) && (angular.isUndefined(field.validation.disabledCriteria) || !scope.$eval(field.validation.disabledCriteria)));
			} else {
				return (field.validation.isRequired && (angular.isUndefined(field.validation.disabledCriteria) || !scope.$eval(field.validation.disabledCriteria)));
			}
		}

		function getDateObj(dateString, fromUTC) {
			if (dateString) {
				return utility.createDateObject(dateString, fromUTC);
			}
		}

		function validateTxPattern(field) {
				var validationExpression = utility.isValidJSON(field.validation['tx-pattern']);
				if(validationExpression && angular.isDefined(validationExpression.F) && validationExpression.F.length > 0) {
						var parsedExpressionObjects = validationExpression.F;
						vm.isValidValue = true;
						angular.forEach(parsedExpressionObjects, function(parsedExpressionObject) {
								if(vm.isValidValue) {
										// skip validating overridable attribute with parent attributes for master catalog
										if(angular.isDefined(parsedExpressionObject['SourceField']) && (dataSourceTypeId === 1 && field.Overridable && !parsedExpressionObject['SourceField'].startsWith('#')) || (dataSourceTypeId === 3)) {
												// if SourceValueRequired is true then the source field should be required for this attribute to have value
												if(parsedExpressionObject['SourceValueRequired']) {
														if(vm.record[parsedExpressionObject['SourceField']] !== '' && vm.record[parsedExpressionObject['SourceField']] != null) {
																setAttributeFieldValidity(field, parsedExpressionObject);
														} else if(vm.record[field.field] !== '' && vm.record[field.field] != null) {
																vm.editForm[field.field].$setValidity('pattern', false);
																vm.editForm[field.field].$touched = true;
																if(angular.isDefined(parsedExpressionObject.Message)) {
																		field.validation.messages.pattern = parsedExpressionObject.Message;
																}
																vm.isValidValue = false;
														}
												} else {
														if(vm.record[parsedExpressionObject['SourceField']] !== '' && vm.record[parsedExpressionObject['SourceField']] != null
																&& vm.record[field.field] !== '' && vm.record[field.field] != null && parsedExpressionObject['SourceField'] !== 'ShipmentStartDate' && parsedExpressionObject['SourceField'] !== 'ShipmentEndDate') {
																setAttributeFieldValidity(field, parsedExpressionObject);
														} else if((parsedExpressionObject['SourceField'] === 'ShipmentStartDate' || parsedExpressionObject['SourceField'] === 'ShipmentEndDate') && (vm.record['RetailIntroMonth'] != null && vm.record['RetailIntroMonth'] !== '') && (vm.record['RetailExitMonth'] != null && vm.record['RetailExitMonth'] !== '') && vm.record[field.field] !== '' && vm.record[field.field] != null) {
																// get the data from the mapped retail window and validate
																var retailWindowDataList = api.getModel('catalogs.retailExitMonthsForArticle').lookupData.data;
																var mappedRetailWindow = utility.filterObject(retailWindowDataList, {id: vm.record['RetailExitMonthId']}, true)[0];
																if(angular.isDefined(mappedRetailWindow)) {
																		vm.record['ShipmentStartDate'] = mappedRetailWindow.ShipmentStartDate;
																		vm.record['ShipmentEndDate'] = mappedRetailWindow.ShipmentEndDate;
																		setAttributeFieldValidity(field, parsedExpressionObject);
																}
														}
														else if(vm.editForm[field.field]) {
																vm.editForm[field.field].$setValidity('pattern', true);
																vm.editForm[field.field].$touched = true;
														}
												}
										}
										if(angular.isUndefined(parsedExpressionObject['SourceField']) && angular.isDefined(parsedExpressionObject['Expression']) && angular.isDefined(parsedExpressionObject['ExpressionValue'])) {
												if(vm.record[field.field] !== '' && vm.record[field.field] != null) {
														setAttributeFieldValidity(field, parsedExpressionObject, true);
												}
												else if(vm.editForm[field.field]) {
														vm.editForm[field.field].$setValidity('pattern', true);
												}
										}
								}
						});
				}
		}

		function setAttributeFieldValidity(field, parsedExpressionObject, isExpressionValidation) {
				var valid = validateExpression(field, parsedExpressionObject, isExpressionValidation);
				if(!valid) {
						if(angular.isDefined(vm.editForm[field.field])) {
								vm.editForm[field.field].$setValidity('pattern', false);
								vm.editForm[field.field].$touched = true;
								if(angular.isDefined(parsedExpressionObject.Message)) {
										field.validation.messages.pattern = parsedExpressionObject.Message;
								}
								vm.isValidValue = false;
						}
				} else {
						if(angular.isDefined(vm.editForm[field.field])) {
								vm.editForm[field.field].$setValidity('pattern', true);
								vm.editForm[field.field].$touched = true;
						}
				}
		}

		function validateExpression(field, parsedExpressionObject, isExpressionValidation) {
				var Expression = parsedExpressionObject.Expression;
				var SourceField = parsedExpressionObject.SourceField;
				var currentAttributeValue = vm.record[field.field];
				var sourceAttributeValue = !isExpressionValidation ? vm.record[SourceField] : parsedExpressionObject.ExpressionValue;

				//Transform the date fields to type dateUTC
				angular.forEach(vm.model.fields, function(itm) {
						if(itm.field === field.field || itm.field === SourceField) {
								// for date fields
								if ((itm.inputType === 'date-utc' || itm.inputType === 'date-option' || itm.inputType === 'date-without-time' || itm.inputType === 'date')) {
										if(itm.field === field.field) {
												currentAttributeValue = new Date(vm.record[itm.field]);
												currentAttributeValue = currentAttributeValue.setHours(0,0,0,0);
												if(isExpressionValidation) {
														sourceAttributeValue = new Date(sourceAttributeValue)
														sourceAttributeValue = sourceAttributeValue.setHours(0,0,0,0);
												}
										} else if(itm.field === SourceField) {
												sourceAttributeValue = new Date(vm.record[itm.field]);
												sourceAttributeValue = sourceAttributeValue.setHours(0,0,0,0);
										}
								}
								// for text input types
								if (itm.inputType === 'textArea' || itm.inputType === 'text' || (angular.isDefined(itm.type) && itm.type === 'text' && itm.inputType === 'list')) {
										if(itm.field === field.field) {
												currentAttributeValue = vm.record[itm.field].toUpperCase();
													if(isExpressionValidation) {
														sourceAttributeValue = sourceAttributeValue.toString().toUpperCase();
												}
										} else if(itm.field === SourceField) {
												sourceAttributeValue = vm.record[itm.field].toUpperCase();
										}
								}
						}
				});

				if(dataSourceTypeId === 3 && field.Overridable) {
						if(field.inputType === 'textArea' || field.inputType === 'text' || (angular.isDefined(field.type) && field.type === 'text' && field.inputType === 'list')) {
								sourceAttributeValue = vm.record[SourceField].toUpperCase();
						}

						// for date fields
						if ((field.inputType === 'date-utc' || field.inputType === 'date-option' || field.inputType === 'date-without-time' || field.inputType === 'date')) {
								sourceAttributeValue = new Date(vm.record[SourceField]);
								sourceAttributeValue = sourceAttributeValue.setHours(0,0,0,0);
						}
				}

				var isValid = false;
				switch(Expression) {
						case '<':
								isValid = currentAttributeValue < sourceAttributeValue ? true : false;
								break;
						case '>':
								isValid = currentAttributeValue > sourceAttributeValue ? true : false;
								break;
						case '<=':
								isValid = currentAttributeValue <= sourceAttributeValue ? true : false;
								break;
						case '>=':
								isValid = currentAttributeValue >= sourceAttributeValue ? true : false;
								break;
						case '=':
								isValid = currentAttributeValue === sourceAttributeValue ? true : false;
								break;
						case '!=':
								isValid = currentAttributeValue !== sourceAttributeValue ? true : false;
								break;
				}
				return isValid;
		}

		// Re-run criteria evaluation for every criteria-driven target field. Used after the model/article
		// selection changes, since the dependents (e.g. model-level UADivision/Department) come from the
		// selected model/article rather than editable fields in this dialog.
		function refreshCriteriaVettingLists() {
			angular.forEach(vm.visibleAttributeFields, function(refreshField) {
				if (refreshField.isCriteriaAdded) {
					getConditionalVettingList(refreshField);
				}
			});
		}

		function getConditionalVettingList(field) {
			var attribute = field.field;
			// CriteriaV2 (preferred): dropdown = matched rule AllowedValues ([] when no rule matches)
			if (vm.criteriaV2Map[attribute]) {
				var getDependentValueForCriteriaV2 = function(dependentField) {
					var depVal = vm.record[dependentField];
					// model-level dependents (e.g. UADivision/Department) aren't editable in this article dialog;
					// fall back to the selected article's data, then the selected model's data.
					if (depVal === undefined || depVal === null || depVal === '') {
						if (vm.selectedArticle && vm.selectedArticle[dependentField] != null && vm.selectedArticle[dependentField] !== '') {
							depVal = vm.selectedArticle[dependentField];
						} else if (vm.selectedModel && vm.selectedModel[dependentField] != null && vm.selectedModel[dependentField] !== '') {
							depVal = vm.selectedModel[dependentField];
						}
					}
					return (depVal && typeof depVal === "object") ? (angular.isDefined(depVal.value) ? depVal.value : depVal) : depVal;
				};
				var criteriaV2Allowed = utility.getCriteriaV2AllowedValues(vm.criteriaV2Map[attribute], getDependentValueForCriteriaV2);
				var criteriaV2AttributeField = utility.filterObject(vm.filteredVisibleAttributeFields || vm.visibleAttributeFields, { field: attribute }, true)[0];
				if (angular.isDefined(criteriaV2AttributeField)) {
					criteriaV2AttributeField.values = (criteriaV2Allowed || [])
						.map(function(value) { return value.toString().trim(); })
						.sort(function(a, b) { return a.toLowerCase().localeCompare(b.toLowerCase()); });
				}
				return;
			}
			var criteriaObj = {};
			var catalogAttribute = utility.filterObject(catalogFactory.getActiveCatalogDetails().AssignedCatalogAttributes,
					{ AttributeSystemName: attribute }, true)[0];
			var catalogAttributeAllowedValues = (catalogAttribute.AllowedValues || []).map(function (v) {
					return v.toString().toLowerCase()
			})
			angular.forEach(vm.vettingListCriteriaList, function (criteriaAttr) {
				for (var key1 in criteriaAttr) {
					if (criteriaAttr.hasOwnProperty(key1)) {
						if (key1.toLocaleLowerCase() === attribute.toLowerCase()) {
							criteriaObj = criteriaAttr[key1];
							break;
						}
					}
				}
			});

			var validValues = [];
			var noMatch = true
			Object.keys(criteriaObj).forEach(function (key) {
				var item = criteriaObj[key];
				var subItems = Object.keys(item);
				var validItems = 0;
				subItems.forEach(function (key2) {
					if (vm.record.hasOwnProperty(key2) && vm.record[key2] != null && vm.record[key2] !== '') {
						var articleAttributeValue = typeof (vm.record[key2]) === 'object' ?
							angular.isDefined(vm.record[key2]['value']) ? vm.record[key2]['value'] : vm.record[key2] :
							vm.record[key2];
						var isDate = validateDate(articleAttributeValue);
						if (articleAttributeValue != null && articleAttributeValue.toString() != '') {
							noMatch = false;
							var lowerCaseValues = item[key2].map(function (value) {
								return isDate == true ? new Date(value).getTime().toString().toLowerCase() : value.toString().toLowerCase();
							});

							if (isDate == true) {
								if (lowerCaseValues.indexOf(new Date(articleAttributeValue).getTime().toString().toLowerCase()) !== -1) {
									validItems++;
								}
							} else {
								if (lowerCaseValues.indexOf(articleAttributeValue.toString().toLowerCase()) !== -1) {
									validItems++;
								}
							}
						}
					} else {
						validItems++;
					}
				});

				if (subItems.length == validItems && catalogAttributeAllowedValues.indexOf(key.toLowerCase()) !== -1) {
					validValues.push(key);
				}
			});
			var attributeField = utility.filterObject(vm.filteredVisibleAttributeFields, { field: attribute }, true)[0];
			if (!noMatch) {
				attributeField.values = (validValues || [])
				.map(function(value) {
						return value.trim();
				})
				.sort(function(a, b) {
						return a.toLowerCase().localeCompare(b.toLowerCase());
				})
			} else {
				attributeField.values = (catalogAttribute.AllowedValues || []).map(function(value) {
					return value.trim();
				})
				.sort(function(a, b) {
					return a.toLowerCase().localeCompare(b.toLowerCase());
				});
			}
		}

		function validateDate(value, formats) {
			if (angular.isUndefined(formats)) {
				formats = [
					moment.ISO_8601
				];
			}
			return moment(value, formats, true).isValid();
		}


		function multiValueQuerySearch(query, selectedItems, field) {
			if (field.isCriteriaAdded) {
				getConditionalVettingList(field);
			}
			var values = field.values;
			var searchQueryResult = [];
			var searchQueryResult = utility.filterObject(values, query);
			if (selectedItems && selectedItems.length > 0) {
				for (var index = searchQueryResult.length - 1; index >= 0; index--) {
					if (selectedItems.indexOf(searchQueryResult[index]) !== -1) {
						searchQueryResult.splice(index, 1);
					}
				}
			}
			return searchQueryResult;
		}

		function validateJSON(field) {
			var valid = utility.isValidJSON(vm.record[field.field]);
			if (valid && utility.isObjectEmpty(JSON.parse(vm.record[field.field]))) {
				valid = false;
			}
			if (valid) {
				if (angular.isDefined(vm.editForm[field.field])) {
					vm.editForm[field.field].$setValidity('checkIfValidJson', true);
				}
			} else {
				if (angular.isDefined(vm.editForm[field.field])) {
					vm.editForm[field.field].$setValidity('checkIfValidJson', false);
				}
			}
		}

		/**
		* Enable use Enter and any other seperator key defined on model to be use as a seperator key for chips
		*/
		function updateSperatorKeys(field) {
			vm.tagSeperatorKeys[field.field] = [$mdConstant.KEY_CODE.ENTER];
			if (angular.isDefined(field.tagSeparator)) {
				var aditionalSeperator = field.tagSeparator.charCodeAt();
				if (angular.isDefined(aditionalSeperator) && aditionalSeperator !== 'NaN') {
					vm.tagSeperatorKeys[field.field].push(aditionalSeperator);
				}
			}
		}

		function populateTags(record, field) {
			if(angular.isUndefined(record[field.field]) || record[field.field] === null || record[field.field] === '') {
				record[field.field] = [];
			}
			else if (angular.isDefined(field.tagSeparator)) {
					var stringVal = record[field.field];
					var tagSeparator = field.tagSeparator;
					if(!angular.isArray(stringVal) && stringVal !== null) {
						record[field.field] = stringVal.split(tagSeparator);
					}
			}
			else {
				$log.warn('tagSeparator property is missing in model for ' + field.field);
			}
		}


		function populateDefaultValues() {
			for (var i = 0; i < vm.visibleAttributeFields.length; i++) {
				var field = vm.visibleAttributeFields[i];
				// if default value assigned then assign it while assigning aticle
				var isDefaultValueAssigned = angular.isDefined(field.DefaultValue) && field.DefaultValue != null && field.DefaultValue !== '' ? true : false;
				if (vm.isNew && (field.editable || field.inputType === 'static') && angular.isDefined(field.fieldDefaultValue)) {
					vm.record[field.field] = field.fieldDefaultValue;
				}

				if (field.inputType === 'text' || field.inputType === 'textArea') {
					if(angular.isUndefined(vm.record[field.field])) {
						vm.record[field.field] = isDefaultValueAssigned ? field.DefaultValue : '';
					}
				}

				if (field.inputType === 'number') {
					if(angular.isUndefined(vm.record[field.field])) {
						vm.record[field.field] = isDefaultValueAssigned ? Number(field.DefaultValue) : 0;
					}
				}

				if (field.inputType === 'lookup-many' && (angular.isUndefined(vm.record[field.field]) || vm.record[field.field] == null )) {
					vm.record[field.field] = [];
				}

				else if (field.inputType === 'tags') {
					updateSperatorKeys(field);
					populateTags(vm.record, field);
				}

				else if (field.inputType === 'bool') {
					if(angular.isUndefined(vm.record[field.field])) {
						vm.record[field.field] = false;
					}
				}

				//for listing populated values of attributes in active catalog's attributeVettingList
				else if (field.inputType === 'list' || (field.inputType === 'multi-value')) {
					if (vm.isNew || angular.isUndefined(vm.record[field.field])) {
						vm.record[field.field] = (vm.isNew && isDefaultValueAssigned) ? field.DefaultValue : field.type === 'int' ? 0 : '';
					}
					// for multivalue dropdown make the record as array
					if(field.inputType === 'multi-value') {
							if(vm.isNew) {
									vm.record[field.field] = isDefaultValueAssigned ? utility.splitString(field.DefaultValue, '|') : [];
							} else if((!vm.isNew && vm.record[field.field] === null)) {
									vm.record[field.field] = [];
							} if(!vm.isNew) {//Non Removable Existing Chips: send existingRecords only when action is edit and nonRemovableChips is true
								if(angular.isDefined(field.nonRemovableChips) && field.nonRemovableChips === true) {
										vm.existingRecords = angular.copy(vm.record[field.field]);
								}
							}
					}
					if (vm.model.modelPath === 'catalogs.articles' || vm.model.modelPath === 'catalogs.linePlanArticles' || vm.model.modelPath === 'sellerModels.sellerModels' || vm.model.modelPath === 'catalogs.models') {
						var attributes = catalogFactory.getActiveCatalogDetails().AssignedCatalogAttributes;
						if (attributes && attributes.length > 0) {
							angular.forEach(attributes, function (attribute) {
								if (attribute.AttributeSystemName === field.field) {
									field.values = (attribute.AllowedValues || [])
									.map(function(value) {
										return value.trim();
									})
									.sort(function(a, b) {
										return a.toLowerCase().localeCompare(b.toLowerCase());
									});
									// for attribute vetting list criteria
									if (field.isDynamicProperty && attribute.CriteriaV2 && attribute.CriteriaV2.length > 0) {
										try {
											vm.criteriaV2Map[attribute.AttributeSystemName] = JSON.parse(attribute.CriteriaV2);
										} catch (error) {
											console.warn(attribute.AttributeDisplayName + " - Attribute CriteriaV2: Invalid JSON Format");
										}
										field.isCriteriaAdded = true;
										vm.getConditionalVettingList(field);
										var v2DependentDisplayNames = [];
										utility.getCriteriaV2DependentFields(vm.criteriaV2Map[attribute.AttributeSystemName]).forEach(function(depKey) {
											// always include the dependent's display name in the tooltip, even if it isn't an editable field in this dialog
											v2DependentDisplayNames.push(utility.getAttributeDisplayNameUsingSystemName(catalogFactory.getActiveCatalogDetails().AssignedCatalogAttributes, depKey));
											var v2DependentField = utility.filterObject(vm.visibleAttributeFields, { field: depKey }, true)[0];
											if (angular.isDefined(v2DependentField)) {
												if (!vm.criteriaDeptAttributeMap[depKey]) {
													vm.criteriaDeptAttributeMap[depKey] = [];
												}
												if (vm.criteriaDeptAttributeMap[depKey].indexOf(attribute.AttributeSystemName) === -1) {
													vm.criteriaDeptAttributeMap[depKey].push(attribute.AttributeSystemName);
												}
												v2DependentField.isDependentAttribute = true;
											}
										});
										field.criteriaDisplayMessage = 'Attribute ' + attribute.AttributeDisplayName + ' is dependent on the attribute(s) ' + v2DependentDisplayNames + '.';
									} else if (field.isDynamicProperty && attribute.Criteria.length > 0) {
										// parse json
										try {
											var vettinglistCriteria = JSON.parse(attribute.Criteria);
										} catch (error) {
											console.warn(attribute.AttributeDisplayName + " - Attribute Criteria: Invalid JSON Format");
										}
										var dependentAttributesDisplayNames = [];
										field.isCriteriaAdded = true;
										vm.getConditionalVettingList(field);
										var dependingAttributes = {};
										var obj2 = {};
										for (var key in vettinglistCriteria) {
											if (vettinglistCriteria.hasOwnProperty(key)) {
												var deptAttr = vettinglistCriteria[key];
												for (var key1 in deptAttr) {
													var obj = {};
													if (deptAttr.hasOwnProperty(key1)) {
														var index = dependentAttributesDisplayNames.indexOf(utility.getAttributeDisplayNameUsingSystemName(catalogFactory.getActiveCatalogDetails().AssignedCatalogAttributes, key1));
														if (index === -1) {
															var dependentAttributeField = utility.filterObject(vm.visibleAttributeFields, { field: key1 }, true)[0];
															if (angular.isDefined(dependentAttributeField)) {
																if(!vm.criteriaDeptAttributeMap[key1]) {
																	vm.criteriaDeptAttributeMap[key1] = [];
																}
																vm.criteriaDeptAttributeMap[key1].push(attribute.AttributeSystemName);
																dependentAttributesDisplayNames.push(utility.getAttributeDisplayNameUsingSystemName(catalogFactory.getActiveCatalogDetails().AssignedCatalogAttributes, key1));
																dependentAttributeField.isDependentAttribute = true;
															}
														}
														if (obj2[key1]) {
															angular.forEach(deptAttr[key1], function (val) {
																if (obj2[key1][val]) {
																	if (obj2[key1][val].indexOf(key)) {
																		obj2[key1][val].push(key);
																	}
																} else {
																	obj2[key1][val] = [key];
																}
															});
														} else {
															angular.forEach(deptAttr[key1], function (val) {
																obj[val] = [key];
															});
															obj2[key1] = obj;
														}
													}
												}
											}
										}
										dependingAttributes[attribute.AttributeSystemName] = obj2;
										vm.dependingAttributesMap.push(dependingAttributes);
										var obj = {};
										obj[attribute.AttributeSystemName] = vettinglistCriteria;
										vm.vettingListCriteriaList.push(obj);
										var criteriaDisplayMessage = 'Attribute ' + attribute.AttributeDisplayName + ' is dependent on the attribute(s) ' + dependentAttributesDisplayNames + '.';
										field.criteriaDisplayMessage = criteriaDisplayMessage;
									}
								}
							})
						}
					}
				}

				else if (vm.model.modelPath === 'catalogs.linePlanArticles' && field.inputType === 'text' && field.field.toLowerCase() === 'article_type') {
					if (vm.isNew) {
						vm.record[field.field] = 'new';
					}
					field.validation.disabledCriteria = true;
				}

				else if (field.inputType === 'int-bool') {
					if(angular.isUndefined(vm.record[field.field])) {
						vm.record[field.field] = '0';
					}
				}

				else if (field.inputType === 'bool-int') {
					if(angular.isUndefined(vm.record[field.field])) {
						vm.record[field.field] = 0;
					}
				}

				else if (field.inputType === 'bool-str') {
					if(angular.isUndefined(vm.record[field.field])) {
						vm.record[field.field] = isDefaultValueAssigned ? field.DefaultValue.toLowerCase() : 'false';
					}
				}

				else if (field.inputType === 'date' || field.inputType === 'date-option') { // workaround for issue with interpolation on ng-disabled on md-datepicker
					if(angular.isUndefined(vm.record[field.field]) && isDefaultValueAssigned) {
						vm.record[field.field] = utility.formatDate(new Date(field.DefaultValue), 'yyyy-MM-dd');
					}
					if ($scope.$eval(field.validation.disabledCriteria) || (field.showInEdit && !field.editable)) {
						//vm.disableDate =  true;
						field.validation.disabled = true;
					} else {
						field.validation.disabled = false;
					}
				}
				else if (field.inputType === 'date-utc') { // workaround for issue with interpolation on ng-disabled on md-datepicker
					if ($scope.$eval(field.validation.disabledCriteria) || (field.showInEdit && !field.editable)) {
						//vm.disableDateUTC =  true;
						field.validation.disabled = true;
					} else {
						field.validation.disabled = false;
					}
				}
				else if (field.inputType === 'date-without-time') { // workaround for issue with interpolation on ng-disabled on md-datepicker
					if(angular.isUndefined(vm.record[field.field]) && isDefaultValueAssigned) {
						vm.record[field.field] = utility.formatDate(new Date(field.DefaultValue), 'yyyy-MM-dd');
					}
					if ($scope.$eval(field.validation.disabledCriteria) || (field.showInEdit && !field.editable)) {
						field.validation.disabled = true;
					} else {
						field.validation.disabled = false;
					}
				}
				else if (field.inputType === 'calculated') { // calculated fields are neither creatable nor editable
					field.creatable = false;
					field.editable = false;
				}
				else if (field.inputType === 'color') {
					vm.colors = mockFactory.getFavoritesColors();
					if (vm.isNew) {
						// assign color based on index when creating new favorite tag
						vm.randomColorForFavoriteTag = vm.colors[existingRecordsForUniqueValue.length % vm.colors.length];
					}
				}

				else if (field.inputType === 'color-picker') {
					if(angular.isUndefined(vm.record[field.field])) {
						vm.record[field.field] = '#969696';
					}
				}

				else if(field.inputType === 'decimal') {
					if(angular.isUndefined(vm.record[field.field])) {
						vm.record[field.field] = isDefaultValueAssigned ? Number(field.DefaultValue) : 0;
					}
				}

				else if (field.inputType === 'lookup-table') {
					field.isLookupAdded = true;
					if (angular.isDefined(validSellerLookupsDestinationAttributesMap[field.field])) {
							var attributeLookupValues = validSellerLookupsDestinationAttributesMap[field.field];
							var sourceAttributesDisplayNames = [];
							var matched = false;
							for (var j = 0; j < attributeLookupValues.length; j++) {
									var allAttributesMatch = true;
								var value = attributeLookupValues[j];
									for (var attributeSystemName in value.Source) {
											if (value.Source.hasOwnProperty(attributeSystemName)) {
												if(vm.record[attributeSystemName] == null || value.Source[attributeSystemName].toString().toLowerCase() !== vm.record[attributeSystemName].toString().toLowerCase()) {
														allAttributesMatch = false;
														break;
												}
											}
									}

									if (allAttributesMatch) {
											if(vm.record[field.field] !== value.Destination[field.field]) {
												vm.record[field.field] = value.Destination[field.field];
											}
											matched = true;
											break;
									}
							}

							// create source attributes map
							if(attributeLookupValues.length) {
									var firstSourceDestinationValue = attributeLookupValues[0];
									for (var attributeSystemName in firstSourceDestinationValue.Source) {
											var index = sourceAttributesDisplayNames.indexOf(utility.getAttributeDisplayNameUsingSystemName(catalogFactory.getActiveCatalogDetails().AssignedCatalogAttributes, attributeSystemName));
											if (index === -1) {
													sourceAttributesDisplayNames.push(utility.getAttributeDisplayNameUsingSystemName(catalogFactory.getActiveCatalogDetails().AssignedCatalogAttributes, attributeSystemName));
													var sourceAttributeField = utility.filterObject(vm.visibleAttributeFields, { field: attributeSystemName }, true)[0];
													if (angular.isDefined(sourceAttributeField)) {
															sourceAttributeField.isLookupSourceAttribute = true;
													}
											}
											if (!vm.lookupSourceAndDeptAttributeMap[attributeSystemName]) {
													vm.lookupSourceAndDeptAttributeMap[attributeSystemName] = [];
											}
											if (vm.lookupSourceAndDeptAttributeMap[attributeSystemName].indexOf(field.field) === -1) {
													vm.lookupSourceAndDeptAttributeMap[attributeSystemName].push(field.field);
											}
									}
							}
							if (!matched) {
									vm.record[field.field] = null;
							}
							field.lookupDisplayMessage = 'Attribute ' + field.displayLabel + ' is dependent on the attribute(s) ' + sourceAttributesDisplayNames.join(', ') + '.';
					} else {
						field.lookupDisplayMessage = 'Attribute ' + field.displayLabel + ' does not have any source attribute(s) assigned';
					}
				}

				else if (field.checkIfUnique) {
					vm.existingRecordsForUniqueValue = existingRecordsForUniqueValue ? existingRecordsForUniqueValue : [];
				}

				if((vm.model.modelPath === 'catalogs.articles' || vm.model.modelPath === 'catalogs.linePlanArticles')) {
					// show info message for retail intro and exit months
					if(field.inputType === 'lookup') {
							if (field.field === 'RetailIntroMonthId') {
								field.retailMonthDisplayMessage = 'Retail Intro Month is dependent on the attribute ' + retailWindowAttribute + '.';
							}

							if(field.field === 'RetailExitMonthId') {
								field.retailMonthDisplayMessage = 'Retail Exit Month is dependent on the attribute ' + retailWindowAttribute + ' and Retail Intro Month.';
							}
					}
				}
			}

			// non creatable seasonal attributes with default value
			var nonCreatableFields = $filter('filterUnion')(model.fields, {creatable: false, isModelLevelAttribute: false, IsSeasonless: false, isDynamicProperty: true });
			// only seasonal article attributes
			angular.forEach(nonCreatableFields, function(fld) {
				if(angular.isDefined(fld.DefaultValue) && fld.DefaultValue != null && fld.DefaultValue !== '') {
					if(angular.isUndefined(vm.record[fld.field])) {
						vm.record[fld.field] = utility.setAttributeTypeSpecificValue(fld, fld.DefaultValue);
					}
				}
			});
		}

		function searchModels(query) {
			var predicate = {};
			var results = [];
			predicate.ModelNumber = query;
			if (vm.availableModels.length) {
				results = query ? utility.filterObject(vm.availableModels, predicate) : angular.copy(vm.availableModels);
				// this is to reduce the rendering time. It was very slow and was impacted overall page responsiveness
				// so while displaying we will display only the first 100 records and user can filter with any value
				if(results.length > 100) {
					vm.isAboveModelDropDownLimit = true;
					return results.slice(0, 100);
				} else {
					vm.isAboveModelDropDownLimit = false;
					return results;
				}
			}
			else {
				return loadAvailableModels().then(function (availableModelsResult) {
					results = query ? utility.filterObject(availableModelsResult, predicate) : availableModelsResult;
					// this is to reduce the rendering time. It was very slow and was impacted overall page responsiveness
					// so while displaying we will display only the first 100 records and user can filter with any value
					if(results.length > 100) {
						vm.isAboveModelDropDownLimit = true;
						return results.slice(0, 100);
					} else {
						vm.isAboveModelDropDownLimit = false;
						return results;
					}
				});
			}
		}

		// helper methods
		function loadAvailableModels() {
			var generalProperties = {
				forceFetch: true,
				isLogRequired: false
			}
			var deferred = $q.defer();
			var promise = deferred.promise;
			api.lists.catalogModelList.methods.getList(generalProperties, catalogCode).then(function (response) {
				vm.availableModels = response.data;
				deferred.resolve(vm.availableModels);
			});
			return promise;
		}

		function getVisibleAttributeFields(model) {
			var creatableFields = $filter('filterUnion')(model.fields, vm.filterExpression);
			var creatableSeasonalAttributes = [];
			// only seasonal article attributes are creatable
			angular.forEach(creatableFields, function(field) {
				if((!field.isModelLevelAttribute && !field.IsSeasonless && field.isDynamicProperty) || (field.field === 'RetailIntroMonthId' || field.field === 'RetailExitMonthId' || field.field === 'StateId')) {
					creatableSeasonalAttributes.push(field);
				}
			});
			return creatableSeasonalAttributes;
		}

		function getModelDisplayValue(item) {
			return item.ModelNumber;
		}

		function onModelsChange(selectedObj) {
			if (angular.isObject(selectedObj)) {
				vm.record.ModelId = selectedObj.ModelId;
				// article name is the selected model's name (same as create article flow)
				vm.record['ArticleName'] = selectedObj.ModelName;
				vm.selectedModel = selectedObj; // carries model-level UADivision/Department for criteria
			}
			else if (angular.isUndefined(selectedObj) || selectedObj === null) {
				vm.record.ModelId = undefined;
				vm.record.ArticleNumber = undefined;
				vm.record['ArticleName'] = undefined;
				vm.availableArticles = [];
				vm.selectedModel = {};
				vm.selectedArticle = {};
			}
			refreshCriteriaVettingLists(); // model dependents changed -> recompute target options
		}

		function searchArticles(query) {
			var predicate = {};
			var results = [];
			predicate.ModelNumber = query;
			if (angular.isDefined(vm.availableArticles) && vm.availableArticles.length) {
				results = query ? utility.filterObject(vm.availableArticles, predicate) : angular.copy(vm.availableArticles);
				if(results.length > 100) {
					vm.isAboveArticleDropDownLimit = true;
					return results.slice(0, 100);
				} else {
					vm.isAboveArticleDropDownLimit = false;
					return results;
				}
			}
			else {
				return loadAvailableArticles().then(function (availableModelsResult) {
					results = query ? utility.filterObject(availableModelsResult, predicate) : availableModelsResult;
					if(results.length > 100) {
						vm.isAboveArticleDropDownLimit = true;
						return results.slice(0, 100);
					} else {
						vm.isAboveArticleDropDownLimit = false;
						return results;
					}
				});
			}
		}

		function getArticleDisplayValue(item) {
			return item.ArticleNumber;
		}

		function onArticlesChange(selectedObj) {
			vm.selectedArticle = {};
			if (angular.isObject(selectedObj)) {
				vm.record.ArticleId = selectedObj.ArticleId;
				api.catalogs.articles.methods.getDetails(true, selectedObj.ArticleId, selectedObj.CatalogCode)
				.then(function (response) {
					vm.selectedArticle = response.data.Article;
					refreshCriteriaVettingLists(); // article loaded -> recompute target options from its dependents
				});
			} else if (angular.isUndefined(selectedObj) || selectedObj === null) {
				vm.record.ArticleId = undefined;
			}
			refreshCriteriaVettingLists();
		}

		// helper methods
		function loadAvailableArticles() {
			var generalProperties = {
				forceFetch: true,
				isLogRequired: false
			}
			var deferred = $q.defer();
			var promise = deferred.promise;
			api.lists.availableArticlesFromModel.methods.getList(generalProperties, catalogCode, vm.record.ModelId).then(function (response) {
				vm.availableArticles = response.data; //utility.filterObject(, { Status: 1 });
				deferred.resolve(vm.availableArticles);
			});
			return promise;
		}

		// when lookup source attribute changed
		function lookupSourceAttributeChanged(field) {
			var sourceAttributeName = field.field;
			if (vm.lookupSourceAndDeptAttributeMap.hasOwnProperty(sourceAttributeName)) {
					var dependentAttributeNames = vm.lookupSourceAndDeptAttributeMap[sourceAttributeName];
					for (var i = 0; i < dependentAttributeNames.length; i++) {
							var dependentAttributeName = dependentAttributeNames[i];
							if (angular.isDefined(validSellerLookupsDestinationAttributesMap[dependentAttributeName])) {
									var attributeLookupValues = validSellerLookupsDestinationAttributesMap[dependentAttributeName];
									var matched = false;
									for (var j = 0; j < attributeLookupValues.length; j++) {
											var allAttributesMatch = true;
										var value = attributeLookupValues[j];
											for (var attributeSystemName in value.Source) {
													if (value.Source.hasOwnProperty(attributeSystemName)) {
														if(vm.record[attributeSystemName] == null || value.Source[attributeSystemName].toString().toLowerCase() !== vm.record[attributeSystemName].toString().toLowerCase()) {
																allAttributesMatch = false;
																break;
														}
													}
											}
											if (allAttributesMatch) {
													if(vm.record[dependentAttributeName] !== value.Destination[dependentAttributeName]) {
														vm.record[dependentAttributeName] = value.Destination[dependentAttributeName];
													}
													matched = true;
													break;
											}
									}
									if (!matched) {
											vm.record[dependentAttributeName] = null;
									}
							}
					}
			}
		}

		function isFormValid() {
			var isRequiredFieldsValid = true;
			// check if any required fields are empty
			angular.forEach(vm.visibleAttributeFields, function (field) {
					if (field.validation && field.validation.isRequired) {
							if (angular.isUndefined(vm.record[field.field]) || vm.record[field.field] === null || vm.record[field.field] === '') {
									isRequiredFieldsValid = false;
							}
					}
			});
			return vm.editForm.$valid && isRequiredFieldsValid;
		}

		function handleFieldChange(field) {
			// Validate tx-pattern
			if (field.validation['tx-pattern'] && vm.currentFocusedField === field.field) {
					vm.validateTxPattern(field);
			}

			// Handle lookup source attribute changes
			if (field.isLookupSourceAttribute) {
					vm.lookupSourceAttributeChanged(field);
			}

			// if this attribute is a dependant attribute of any criteria attribute revalidat the values of criteria attributes
			var dependentAttributeField = field.field;
			if(vm.criteriaDeptAttributeMap[dependentAttributeField]) {
					var criteriaAttributes = vm.criteriaDeptAttributeMap[dependentAttributeField];
					angular.forEach(criteriaAttributes, function(criteriaAttribute) {
							var criteriaField = utility.filterObject(vm.visibleAttributeFields, { field: criteriaAttribute }, true)[0];
							if (!criteriaField) { return; } // target criteria attribute isn't a field in this dialog -> nothing to refresh/clear
							var isMultiValueAttribute = (criteriaField.inputType === 'multi-value') ? true : false;
							// CriteriaV2 (preferred): refresh dropdown + clear current value if not in matched rule AllowedValues
							if (vm.criteriaV2Map[criteriaAttribute]) {
								vm.getConditionalVettingList(criteriaField);
								var getDependentValueForCriteriaV2 = function(dependentField) {
									var depVal = vm.record[dependentField];
									return (depVal && typeof depVal === "object") ? (angular.isDefined(depVal.value) ? depVal.value : depVal) : depVal;
								};
								var criteriaV2AllowedLower = utility.getCriteriaV2AllowedValues(vm.criteriaV2Map[criteriaAttribute], getDependentValueForCriteriaV2)
									.map(function(value) { return value.toString().toLowerCase(); });
								var currentCriteriaValue = vm.record[criteriaAttribute];
								var isCriteriaV2Valid;
								if (isMultiValueAttribute) {
									isCriteriaV2Valid = (Array.isArray(currentCriteriaValue) && currentCriteriaValue.length > 0)
										? currentCriteriaValue.every(function(value) { return criteriaV2AllowedLower.indexOf((value == null ? "" : value).toString().toLowerCase()) !== -1; })
										: true;
								} else {
									isCriteriaV2Valid = (currentCriteriaValue === null || currentCriteriaValue === undefined || currentCriteriaValue === "")
										? true
										: criteriaV2AllowedLower.indexOf(currentCriteriaValue.toString().toLowerCase()) !== -1;
								}
								if (!isCriteriaV2Valid) {
									vm.record[criteriaAttribute] = isMultiValueAttribute ? [] : null;
									if (vm.editForm && vm.editForm[criteriaAttribute]) { vm.editForm[criteriaAttribute].$touched = true; }
								}
								return;
							}
							var attributeCriteria = {};
							angular.forEach(vm.dependingAttributesMap, function(criteriaAttr) {
									for(var key in criteriaAttr) {
											if(criteriaAttr.hasOwnProperty(key)) {
													if(key.toLocaleLowerCase() === criteriaAttribute.toLowerCase()) {
															attributeCriteria = criteriaAttr[key];
															break;
													}
											}
									}
							});
							if(angular.isDefined(attributeCriteria[dependentAttributeField][vm.record[dependentAttributeField]])) {
									var index = attributeCriteria[dependentAttributeField][vm.record[dependentAttributeField]].indexOf(vm.record[criteriaAttribute]);
									if (index === -1) {
											vm.record[criteriaAttribute] = isMultiValueAttribute ? [] : null;
											vm.editForm[criteriaAttribute].$touched = true;
									}
							} else {
									vm.record[criteriaAttribute] = isMultiValueAttribute ? [] : null;
									vm.editForm[criteriaAttribute].$touched = true;
							}
					});
			}
		}

		function onSearchTextChanged() {
			if (!vm.searchPageText) {
					vm.filteredVisibleAttributeFields = angular.copy(vm.visibleAttributeFields);
					return;
			}

			vm.filteredVisibleAttributeFields = vm.visibleAttributeFields.filter(function(item) {
					if (!item || !item.displayLabel) return false;

					var translatedLabel = $translate.instant(item.displayLabel);
					return translatedLabel.toLowerCase().indexOf(vm.searchPageText.toLowerCase()) !== -1;
			});
		}
	}
})();
(function() {
		'use strict';
		
		angular
				.module('app.main.catalogs.modelLevelAttributes', [])
				.config(config);

		/* @ngInject */
		function config($translatePartialLoaderProvider) {

				// Translation
				$translatePartialLoaderProvider.addPart('app/main/catalogs/details/tabs/model-level-attributes');
		}
})();

(function () {
	'use strict';

	angular
		.module('app.main.catalogs.modelLevelAttributes')
		.controller('assignModelLevelAttributesController', assignModelLevelAttributesController);

	/* @ngInject */
	function assignModelLevelAttributesController($mdDialog, $scope, $filter, hotkeys, toast, api, utility, $q,
		activeCatalogId, model, assignedAttributes, allAttributes) {
		/* jshint validthis: true */
		var vm = this;

		//Data
		vm.model = model;
		vm.masterAttributesModel = api.catalogs.attributes;
		vm.isLoading = false;
		vm.record = {};
		vm.record.AttributeId = (!assignedAttributes) ? [] : getAssignedAttributeIdArray(assignedAttributes);
		vm.allAttributes = allAttributes;

		vm.acSelectedItem = [];
		vm.acSearchText = [];

		//Methods
		vm.saveRecord = saveRecord;
		vm.closeDialog = closeDialog;

		vm.transformChip = transformChip;
		vm.acQuerySearch = acQuerySearch;
		vm.getChipDisplayValue = getChipDisplayValue;

		activate();

		////////////////

		function activate() {
			hotkeys.bindTo($scope).add({
				combo: 'ctrl+enter',
				description: $filter('translate')('ACTIONS.SAVE'),
				allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
				callback: function (event) {
					if (!vm.isLoading && !vm.editForm.$invalid) {
						saveRecord();
					}
				}
			});
		}

		function saveRecord() {
			vm.record.activeCatalogId = activeCatalogId;
			vm.isLoading = true;
			vm.model.methods.create(vm.record, assignedAttributes).then(function () {
				closeDialog(true);
				toast.success('SUCCESS.CREATE', '', '');
			}).finally(function () {
				closeDialog();
				vm.isLoading = false;
			});
		}

		function closeDialog(saved) {
			$mdDialog.hide(saved);
		}

		function getAssignedAttributeIdArray(assignedAttributes) {
			var ids = [];
			if (assignedAttributes.length > 0) {
				angular.forEach(assignedAttributes, function (attribute) {
					ids.push(attribute.AttributeId);
				});
			}
			return ids;
		}

		function transformChip(chip) {
			if (angular.isObject(chip)) {
				return chip.Attributeid;
			}
			return undefined;
		}

		function acQuerySearch(query, selectedRecords, allAttributes) {
			var searchQueryResult = [];
				if(angular.isDefined(allAttributes) && allAttributes.length) {
						searchQueryResult = utility.filterObject(allAttributes, query);
						removeSelectedChips(selectedRecords, searchQueryResult);
						return searchQueryResult;
				}
				else { 
					return searchQueryResult;
				}
		}

		/**
		 * @description
		 * This method will remove selected chips form records (helper method)
		 * @param {array} selectedRecords: list of selected chips
		 * @param {array} records: data property of lookup-data
		 * @returns {array}: list of available chips (chips which are not selected) // it does not really need to return a value but for readability returning modified value
		 */
		function removeSelectedChips(selectedRecords, records) {
			if (angular.isDefined(selectedRecords) && selectedRecords.length > 0) {
				for (var index = records.length - 1; index >= 0; index--) {
					if (selectedRecords.indexOf(records[index].Attributeid) !== -1) {
						records.splice(index, 1);
					}
				}
			}
			return records;
		}

		function getChipDisplayValue(chip, allAttributes) {
			var res = utility.filterObject(allAttributes, {Attributeid: chip}, true);           
				if (angular.isArray(res) && res.length > 0) {
						return res[0].AttributeDisplayName;
				}
		}

	}
})();
(function() {
    'use strict';
    
    angular
        .module('app.main.catalogs.configurations',[]);  
})();
(function() {
    'use strict';

    angular
        .module('app.main.catalogs.configurations')
        .controller('createCatalogConfigurationController', createCatalogConfigurationController);

    /* @ngInject */
    function createCatalogConfigurationController($scope,  $window, $mdDialog, $filter, toast, utility, api, hotkeys, model, record, catalogCode, isNew, event) {
        /* jshint validthis: true */
        var vm = this;

        //Data
        vm.masterConfigurationsModel = api.lists.configurations;
        vm.model = model;

        vm.configType = '';
        vm.isLoading = false;
        vm.record = angular.copy(record);
        vm.isNew = isNew;

        var masterConfigurations = [];
        vm.searchText = '';
        vm.isDataDirty = false;
        vm.lookupModel = angular.copy(vm.record);

        // When an existing config is picked from the dropdown its definition fields are
        // populated and locked; only the link (ConfigId) + Value are saved. When the user
        // types a new name instead, the definition fields stay editable and are saved too.
        vm.isExistingSelected = false;
        vm.defaultValueTypes = [
            {Id: 'nvarchar', value: 'Text'},
            {Id: 'int', value: 'Number'},
            {Id: 'datetime', value: 'Date'},
            {Id: 'bool', value: 'Boolean'}
        ];


        //Methods
        vm.saveRecord = saveRecord;
        vm.closeDialog = closeDialog;

        vm.lookupSearch = lookupSearch;
        vm.lookupChange = lookupChange;
        vm.getConfigurationDisplayValue = getConfigurationDisplayValue;
        vm.selectText = selectText;
        vm.onTypeChange = onTypeChange;

        activate();

        ////////////////

        function activate() {
            loadConfigurations();
            if (vm.isNew) {
                vm.record.DefaultValueType = vm.record.DefaultValueType || 'nvarchar';
                vm.configType = vm.record.DefaultValueType;
            } else {
                // Edit: drive the value input from the stored type; numeric values need a Number for the input.
                vm.configType = vm.record.DefaultValueType || '';
                if (vm.record.DefaultValueType === 'int' && angular.isDefined(vm.record.Value)) {
                    vm.record.Value = parseInt(vm.record.Value, 10);
                }
            }
            //Hotkeys
            hotkeys.bindTo($scope).add({
                combo: 'ctrl+enter',
                description: $filter('translate')('ACTIONS.SAVE'),
                allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
                callback: function(event) {
                    if (!vm.isLoading && !vm.editForm.$invalid) {
                        vm.saveRecord();
                    }
                }
            });

            if (vm.isNew) {
                hotkeys.bindTo($scope).add({
                    combo: 'ctrl+shift+enter',
                    description: $filter('translate')('ACTIONS.SAVE_AND_NEW'),
                    allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
                    callback: function(event) {
                        if (!vm.isLoading && !vm.editForm.$invalid) {
                            vm.saveRecord(true);
                        }
                    }
                });
            }
        }

        function saveRecord(saveAndNew) {
            vm.isLoading = true;
            var promise;

            if (isNew && !vm.isExistingSelected) {
                // New configuration: send the typed name + definition, with no existing link.
                vm.record.ConfigId = undefined;
                vm.record.Name = (vm.searchText && vm.searchText.ConfigId) ? vm.searchText.ConfigId : vm.record.Name;
            }

            if(isNew) {
                promise = vm.model.methods.create(vm.record, catalogCode);
            }
            else {
                promise = vm.model.methods.update(vm.record, vm.record[model.idField], catalogCode);
            }

            promise.then(function() {
                if (vm.isNew && angular.isDefined(saveAndNew) && saveAndNew) {
                    vm.editForm.$setPristine();
                    vm.editForm.$setUntouched();
                    vm.record = {};
                    vm.record.DefaultValueType = 'nvarchar';
                    vm.searchText = '';
                    vm.isExistingSelected = false;
                    vm.configType = 'nvarchar';
                    vm.lookupModel = {};
                    vm.isDataDirty = true;
                    var el = $window.document.getElementById('dialog_input_first');
                    if (el) {
                        el.focus();
                    }
                } else {
                    closeDialog(true);
                }
                var toastMessage = isNew ? 'SUCCESS.CREATE': 'SUCCESS.UPDATE';
                toast.success(toastMessage, '', '');
            }, function(err) {
                closeDialog(vm.isDataDirty);
            }).finally(function () {
                vm.isLoading = false;
            });
        }

        function closeDialog(saved) {
            $mdDialog.hide(saved);
        }

        function lookupSearch(query) {
            var results = [];
            var predicate = {};
            predicate[vm.masterConfigurationsModel.lookupDisplayField] = query;

            if(masterConfigurations.length) {
                results = query ? utility.filterObject(masterConfigurations , predicate) :  masterConfigurations;
                return results;
            }
            else {
                return loadConfigurations().then(function() {
                    results = query ? utility.filterObject(masterConfigurations , predicate) : masterConfigurations;
                    return results;
                });
            }
        }

        function lookupChange(selectedValue, field) {
            if(angular.isObject(selectedValue)){
                // Existing config picked: populate and lock the definition fields.
                vm.isExistingSelected = true;
                vm.record[field] = selectedValue[vm.masterConfigurationsModel.idField];
                vm.record.Name = selectedValue.Name;
                vm.record.DefaultValueType = selectedValue.DefaultValueType;
                vm.record.DefaultValue = coerceValueForType(selectedValue.Value, selectedValue.DefaultValueType);
                vm.record.SortOrder = toNumberOrUndefined(selectedValue.SortOrder);
                vm.record.Description = selectedValue.Description;
                vm.configType = selectedValue.DefaultValueType;
                if (selectedValue.DefaultValueType === 'bool' && angular.isUndefined(vm.record.Value)) {
                    vm.record.Value = 'false';
                }
            }
            else if(angular.isUndefined(selectedValue) || selectedValue === null) {
                // Back to a new config: clear the link and re-enable the definition fields.
                vm.isExistingSelected = false;
                vm.record[field] = undefined; // on record removal make field undefined or the property can be deleted using delete keyword
                vm.record.DefaultValueType = 'nvarchar';
                vm.record.DefaultValue = undefined;
                vm.record.SortOrder = undefined;
                vm.record.Description = undefined;
                vm.record.Value = undefined;
                vm.configType = 'nvarchar';
            }
        }

        function getConfigurationDisplayValue(item) {
            if(masterConfigurations.length) {
                return getLookupDisplayValue(item);
            }
            else {
                return loadConfigurations().then(function() {
                    return getLookupDisplayValue(item);
                });
            }
        }

        function getLookupDisplayValue(item) {
            var result;
            var predicate = {};
            if(angular.isObject(item)) {
                predicate[vm.masterConfigurationsModel.idField] = item[vm.masterConfigurationsModel.idField];
            }
            else {
                predicate[vm.masterConfigurationsModel.idField] = item;
            }
            result = utility.filterObject(masterConfigurations, predicate, true)[0];
            return result ? result[vm.masterConfigurationsModel.lookupDisplayField] : '';
        }

        function selectText(event) {
            utility.selectInputText(event);
        }

        // Reset the value inputs whenever the value type changes (mirrors the vetting
        // create-configuration dialog) so DefaultValue/Value match the selected type.
        function onTypeChange(type) {
            vm.configType = type;
            vm.record.Value = undefined;
            vm.record.DefaultValue = undefined;
            if (type === 'bool') {
                vm.record.Value = 'false';
                vm.record.DefaultValue = 'false';
            }
        }

        // type="number" inputs and md-datepicker need real Number/Date values, not the
        // strings the master config stores them as - otherwise ngModel throws numfmt/dateparse.
        function toNumberOrUndefined(val) {
            if (val === null || angular.isUndefined(val) || val === '') { return undefined; }
            var num = parseInt(val, 10);
            return isNaN(num) ? undefined : num;
        }

        function coerceValueForType(val, type) {
            if (val === null || angular.isUndefined(val) || val === '') { return undefined; }
            if (type === 'int') { return toNumberOrUndefined(val); }
            if (type === 'datetime') {
                var date = new Date(val);
                return isNaN(date.getTime()) ? undefined : date;
            }
            return val;
        }

        function loadConfigurations() {
            return vm.masterConfigurationsModel.methods.getList({forceFetch: true, isLogRequired: false}).then(function(response) {
                masterConfigurations = response.data;
            });
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.viewCreator')
        .controller('updateUserController', updateUserController);

    /* @ngInject */
    function updateUserController($mdDialog, $scope, $filter, hotkeys, $window, $log, api, toast, utility, model, record, isNew, lookupPromises) {
        var vm = this;

        //data
        vm.isLoading = false;
        vm.record = (angular.isDefined(record) && record != null)? angular.copy(record): {};
        vm.record.Roles = (!vm.record.Roles) ? [] : vm.record.Roles;
        vm.record.LicenseTypeIds = (!vm.record.LicenseTypeIds) ? [] : vm.record.LicenseTypeIds;
        vm.lookupModel = angular.copy(vm.record);
        vm.isNew = isNew;
        vm.searchText = '';

        vm.acSelectedItem = [];
        vm.acSearchText = [];
        vm.searchText = {};

        vm.accountTypes = [
            {id:1, value: "Admin"},
            {id:2, value: "Seller", lookupSource:'accounts.sellers'},
            {id:3, value: "Buyer", lookupSource:'accounts.buyers'}
        ];
        vm.accountType = {};
        var requestforSeller = false;
        var requestforBuyer = false;

        //methods
        vm.saveRecord = saveRecord;
        vm.closeDialog = closeDialog;

        vm.onAccountTypeChange = loadAccounts;
        vm.lookupSearch = lookupSearch;
        vm.lookupChange = lookupChange;
        vm.getLookupDisplayValue = getLookupDisplayValue;
        vm.selectText = selectText;

        vm.transformChip = transformChip;
        vm.acQuerySearch = acQuerySearch;
        vm.getChipDisplayValue = getChipDisplayValue;



         activate();

        ////////////////

        function activate() {
            //Hotkeys
            hotkeys.bindTo($scope).add({
                combo: 'ctrl+enter',
                description: $filter('translate')('ACTIONS.SAVE'),
                allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
                callback: function(event) {
                    if (!vm.isLoading && !vm.editForm.$invalid) {
                        vm.saveRecord();
                    }
                }
            });

            if (vm.isNew) {
                hotkeys.bindTo($scope).add({
                    combo: 'ctrl+shift+enter',
                    description: $filter('translate')('ACTIONS.SAVE_AND_NEW'),
                    allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
                    callback: function(event) {
                        if (!vm.isLoading && !vm.editForm.$invalid) {
                            vm.saveRecord(true);
                        }
                    }
                });
            }
        }

        function saveRecord(saveAndNew) {
            vm.isLoading = true;

            var p;

            if (vm.isNew)
            {
                //as discussed with Amardeep for admin user will hardCode the account id as 1
                if(vm.record.AccountTypeId === 1){
                    vm.record.AccountId = 1;
                }
                p = model.methods.create(vm.record);
            } else {
                p = model.methods.update(vm.record[model.idField], vm.record);
            }

            p.then(function(response) {
                if (vm.isNew && angular.isDefined(saveAndNew) && saveAndNew) {

                    vm.editForm.$setPristine();
                    vm.editForm.$setUntouched();
                    vm.record = {};
                    vm.record.Roles = [];
                    vm.record.LicenseTypeIds = [];
                    vm.acSearchText = [];
                    vm.searchText = {};
                    vm.accountType = {};
                    vm.isDataDirty = true;

                    var el = $window.document.getElementById('dialog_input_first');
                    if (el) {
                        el.focus();
                    }
                } else {
                    closeDialog(true);
                }

                var toastMessage;
                toastMessage = response.config.method.toUpperCase() === 'POST' ? 'SUCCESS.CREATE': 'SUCCESS.UPDATE';
                toast.success(toastMessage, '', '');
            }, function(err) {
                closeDialog(vm.isDataDirty);
            }).finally(function () {
                vm.isLoading = false;
            })
        }

        function closeDialog(saved) {
            $mdDialog.hide(saved);
        }

        function loadAccounts(accountType) {
            if(accountType.id === 2 && !requestforSeller) {
                requestforSeller = true;
                lookupPromises['Seller'] = api.getLookupData(api.accounts.sellers);

            }
            else if(accountType.id === 3 && !requestforBuyer) {
                requestforBuyer = true;
                lookupPromises['Buyer'] = api.getLookupData(api.accounts.buyers);
            }

            vm.record.AccountTypeId = accountType.id; // use to filter role based on selected account type
            vm.lookupModel.AccountId = undefined; // to clear account field on account type change
            vm.searchText.AccountId = '';
        }

        function lookupSearch(query, field, lookupSource, lookupFilter) {
            var results = [];
            var predicate = angular.isDefined(lookupFilter) ? angular.copy(lookupFilter) : {};
            predicate.value = query;
            var lookupModel = api.getModel(lookupSource);

            if(angular.isDefined(lookupModel.lookupData) && angular.isDefined(lookupModel.lookupData.data) && lookupModel.lookupData.data.length) {
                results = query ? utility.filterObject(lookupModel.lookupData.data , predicate) : utility.filterObject(lookupModel.lookupData.data, lookupFilter, true);
                return results;
            }
            else {
                return lookupPromises[field].then(function(lookupData) {
                    results = query ? utility.filterObject(lookupData.data , predicate) : utility.filterObject(lookupData.data, lookupFilter, true);
                    return results;
                });
            }
        }

        // convert dropdown scope value form object(lookup record) to id property of lookup record
        function lookupChange(selectedObj, field) {
            if(angular.isObject(selectedObj)) {
                vm.record[field] = selectedObj.id;
            }
            else if(angular.isUndefined(selectedObj) || selectedObj === null){
                vm.record[field] = undefined; // on record removal make field undefined or the property can be deleted using delete keywork
            }
        }

        function getLookupDisplayValue(item, field, lookupSource) {
            var lookupModel = api.getModel(lookupSource);

            if(angular.isDefined(lookupModel.lookupData) && angular.isDefined(lookupModel.lookupData.data) && lookupModel.lookupData.data.length) {
                return getLookupDisplayVal(item, lookupModel.lookupData);
            }
            else {
                return lookupPromises[field].then(function(lookupData) {
                    return getLookupDisplayVal(item, lookupData);
                });
            }
        }

        //helper method
        function getLookupDisplayVal(item, lookupData) {
            var result;
            if(lookupData) {
                // since autocomplte return object
                if(angular.isObject(item)) {
                    result = utility.filterObject(lookupData.data, {id: item.id}, true);
                }
                // to initialize field value if any (when open update record dialog)
                else {
                    result = utility.filterObject(lookupData.data, {id: item}, true);
                }

                if (angular.isArray(result) && result.length > 0) {
                    return result[0].value;
                }
                else {
                    return result.value;
                }
            }
        }

        function selectText(event) {
            utility.selectInputText(event);
        }

        function transformChip(chip) {
            if (angular.isObject(chip)) {
                return chip.id;
            }
            return undefined;
        }

        function acQuerySearch(query, selectedRecords, fieldName) {
            var results = [];
            var field = utility.filterObject(model.fields, {field: fieldName}, true)[0];
            var lookupFilter = angular.isDefined(field.lookupFilter) ? field.lookupFilter : {};
            if(fieldName === 'Roles') {
                lookupFilter.AccountTypeId = vm.record.AccountTypeId;
            }
            var predicate = angular.copy(lookupFilter);
            predicate.value = query;

            var lookupModel = api.getModel(field.lookupSource);
            if(angular.isDefined(lookupModel.lookupData) && angular.isDefined(lookupModel.lookupData.data) && lookupModel.lookupData.data.length) {
                results = query ? utility.filterObject(lookupModel.lookupData.data , predicate) : utility.filterObject(lookupModel.lookupData.data, lookupFilter);
                results = removeSelectedChips(selectedRecords, results);
                return results;
            }
            else {
                return lookupPromises[field.field].then(function(lookupData) {
                    results = query ? utility.filterObject(lookupData.data , predicate) : utility.filterObject(lookupData.data, lookupFilter);
                    results = removeSelectedChips(selectedRecords, results);
                    return results;
                });
            }
        }

        /**
         * @description
         * This method will remove selected chips form records (helper method)
         * @param {array} selectedRecords: list of selected chips
         * @param {array} records: data property of lookup-data
         * @returns {array}: list of available chips (chips which are not selected) // it does not really need to return a value but for readability returning modified value
         */
        function removeSelectedChips(selectedRecords, records) {
            if (angular.isDefined(selectedRecords) && selectedRecords.length > 0) {
                for (var index = records.length-1; index >= 0; index--) {
                    if (selectedRecords.indexOf(records[index].id) !== -1) {
                        records.splice(index,1);
                    }
                }
            }
            return records;
        }

        function getChipDisplayValue(chip, fieldName) {
            var field = utility.filterObject(model.fields, {field: fieldName}, true)[0];
            var lookupModel = api.getModel(field.lookupSource);
            if(angular.isDefined(lookupModel.lookupData) && angular.isDefined(lookupModel.lookupData.data) && lookupModel.lookupData.data.length) {
                return getChipDisplayVal(lookupModel.lookupData, chip);
            }
            else { // it will never go to else part since before try to load display value for selected chips, it always load lookup on focus of chips input element
                return lookupPromises[field.field].then(function(lookupData) {
                    return getChipDisplayVal(lookupData, chip);
                });
            }
        }

        //helper method
        function getChipDisplayVal(lookupData, chip) {
            var res = utility.filterObject(lookupData.data, {id: chip}, true);
            if (angular.isArray(res) && res.length > 0) {
                return res[0].value;
            }
            else {
                $log.warn('viewCreator controller: Unable to resolve chip display value!');
                return "";
            }
        }

    }
})();
(function () {
	'use strict';

	angular
		.module('app.viewCreator')
		.controller('changeAccountController', changeAccountController);

	/* @ngInject */
	function changeAccountController($mdDialog, $scope, $filter, hotkeys, api, toast, utility, model, selectedRecords) {
		var vm = this;

		//data
		vm.isLoading = false;
		vm.record = {};
		vm.lookupModel = angular.copy(vm.record);
		vm.searchText = '';
		var lookupPromises = {};

		vm.acSelectedItem = [];
		vm.acSearchText = [];
		vm.searchText = {};

		vm.accountTypes = [
			{ id: 2, value: "Seller", lookupSource: 'accounts.sellers' },
			{ id: 3, value: "Buyer", lookupSource: 'accounts.buyers' }
		];
		vm.accountType = {};
		var requestforSeller = false;
		var requestforBuyer = false;
		var isSameAccountUsers = false;
		var selectedUsersAccountId = 0; 

		//methods
		vm.saveRecord = saveRecord;
		vm.closeDialog = closeDialog;

		vm.onAccountTypeChange = loadAccounts;
		vm.lookupSearch = lookupSearch;
		vm.lookupChange = lookupChange;
		vm.getLookupDisplayValue = getLookupDisplayValue;
		vm.selectText = selectText;



		activate();

		////////////////

		function activate() {
			//Hotkeys
			hotkeys.bindTo($scope).add({
				combo: 'ctrl+enter',
				description: $filter('translate')('ACTIONS.SAVE'),
				allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
				callback: function (event) {
					if (!vm.isLoading && !vm.editForm.$invalid) {
						vm.saveRecord();
					}
				}
			});

			isUsersBelongToSameAccount();
		}

		function saveRecord() {
			vm.isLoading = true;
			var p = model.methods.changeAccount(selectedRecords, vm.record.accountId, model);

			p.then(function (response) {
				closeDialog(true);
				var toastMessage;
				toastMessage = response.config.method.toUpperCase() === 'POST' ? 'SUCCESS.CREATE' : 'SUCCESS.UPDATE';
				toast.success(toastMessage, '', '');
			}, function (err) {
				closeDialog(vm.isDataDirty);
			}).finally(function () {
				vm.isLoading = false;
			})
		}

		function closeDialog(saved) {
			$mdDialog.hide(saved);
		}

		function loadAccounts(accountType) {
			if (accountType.id === 2 && !requestforSeller) {
				requestforSeller = true;
				lookupPromises['Seller'] = api.getLookupData(api.accounts.sellers);
			}
			else if (accountType.id === 3 && !requestforBuyer) {
				requestforBuyer = true;
				lookupPromises['Buyer'] = api.getLookupData(api.accounts.buyers);
			}
			vm.accountTypeId = accountType.id; // use to filter role based on selected account type
			vm.lookupModel.accountId = undefined; // to clear account field on account type change
			vm.searchText.accountId = '';
		}

		function lookupSearch(query, field, lookupSource, lookupFilter) {
			var results = [];
			var predicate = angular.isDefined(lookupFilter) ? angular.copy(lookupFilter) : {};
			predicate.value = query;
			var lookupModel = api.getModel(lookupSource);

			if (angular.isDefined(lookupModel.lookupData) && angular.isDefined(lookupModel.lookupData.data) && lookupModel.lookupData.data.length) {
				results = query ? utility.filterObject(lookupModel.lookupData.data, predicate) : utility.filterObject(lookupModel.lookupData.data, lookupFilter, true);
				if(isSameAccountUsers) {
					var index = results.indexOf(utility.filterObject(results, {AccountId: selectedUsersAccountId}, true)[0]);
					if (index >= 0) {
						results.splice(index, 1);
					}
				}
				return results;
			}
			else {
				return lookupPromises[field].then(function (lookupData) {
					results = query ? utility.filterObject(lookupData.data, predicate) : utility.filterObject(lookupData.data, lookupFilter, true);
					if(isSameAccountUsers) {
						var index = results.indexOf(utility.filterObject(results, {AccountId: selectedUsersAccountId}, true)[0]);
						if (index >= 0) {
							results.splice(index, 1);
						}
					}
					return results;
				});
			}
		}

		// convert dropdown scope value form object(lookup record) to id property of lookup record
		function lookupChange(selectedObj, field) {

			if (angular.isObject(selectedObj)) {
				vm.record[field] = selectedObj.id;
			}
			else if (angular.isUndefined(selectedObj) || selectedObj === null) {
				vm.record[field] = undefined; // on record removal make field undefined or the property can be deleted using delete keywork
			}
		}

		function getLookupDisplayValue(item, field, lookupSource) {
			var lookupModel = api.getModel(lookupSource);

			if (angular.isDefined(lookupModel.lookupData) && angular.isDefined(lookupModel.lookupData.data) && lookupModel.lookupData.data.length) {
				return getLookupDisplayVal(item, lookupModel.lookupData);
			}
			else {
				return lookupPromises[field].then(function (lookupData) {
					return getLookupDisplayVal(item, lookupData);
				});
			}
		}

		//helper method
		function getLookupDisplayVal(item, lookupData) {
			var result;
			if (lookupData) {
				// since autocomplte return object
				if (angular.isObject(item)) {
					result = utility.filterObject(lookupData.data, { id: item.id }, true);
				}
				// to initialize field value if any (when open update record dialog)
				else {
					result = utility.filterObject(lookupData.data, { id: item }, true);
				}

				if (angular.isArray(result) && result.length > 0) {
					return result[0].value;
				}
				else {
					return result.value;
				}
			}
		}

		function selectText(event) {
			utility.selectInputText(event);
		}

		function isUsersBelongToSameAccount() {
			var uniqueValues = [];
			var uniqueValuesIndex = {};
			angular.forEach(selectedRecords, function (data) {
					if (angular.isUndefined(uniqueValuesIndex[data['AccountId']])) {
							uniqueValuesIndex[data['AccountId']] = true;
							uniqueValues.push(data['AccountId']);
					}
			});

			if(uniqueValues.length === 1) {
				isSameAccountUsers = true;
				selectedUsersAccountId = uniqueValues[0];
			}
		}
	}

})();
(function() {
  'use strict';

  angular
      .module('app.main.accounts.users.privacy-policy', []);
})();
(function () {
  'use strict';

  angular
  .module('app.main.accounts.users.privacy-policy')
  .run(runBlock);

  /* @ngInject */
  function runBlock(api, activityLogger, $state, crud, toast) {

    if (angular.isUndefined(api.users)) {
      api.users = {};
    }
    api.users.privacyPolicy = {
      modelPath: 'users.privacyPolicy',
      fields: [
        { field: 'Id', type: 'int', displayLabel: 'PRIVACY_POLICY.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
        validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
        { field: 'VersionNumber', type: 'int', displayLabel: 'PRIVACY_POLICY.FIELDS.VERSION', visible: true, creatable: false, editable: false, inputType: 'number',
            validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
        { field: 'Title', type: 'text', displayLabel: 'PRIVACY_POLICY.FIELDS.TITLE', visible: true, creatable: false, editable: false, inputType: 'text',
            validation: {isRequired: true, maxLen: 250, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
        { field: 'Status', type: 'text', displayLabel: 'PRIVACY_POLICY.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
            validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
        { field: 'AcceptedDate', type: 'text', displayLabel: 'PRIVACY_POLICY.FIELDS.ACCEPTED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
            validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
        { field: 'CreatedBy', type: 'text', displayLabel: 'PRIVACY_POLICY.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
            validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
        { field: 'UpdatedBy', type: 'text', displayLabel: 'PRIVACY_POLICY.FIELDS.UPDATED_BY', visible: true, creatable: true, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
            validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
        { field: 'CreatedDate', type: 'text', displayLabel: 'PRIVACY_POLICY.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
            validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
        { field: 'UpdatedDate', type: 'text', displayLabel: 'PRIVACY_POLICY.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
            validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
      ],
      uniqueConstraints: [],
      title: 'PRIVACY_POLICY.NAV',
      icon: 'icon-file-document',
      idField: 'Id',
      lookupDisplayField: 'Title',
      isDirty: false,
      methods: {
        getList: getUserAcceptedPrivacyPolicyList
      },
      views: {
        mainList: {
          columns: [ 'Title', 'VersionNumber', 'Status', 'AcceptedDate' ],
          columnFilter: {},
          toggleFilterProps: {},
          topIndex: 0,
          showFilterRow: false,
          sortColumn: {'VersionNumber': false},
          sortDescending: true,
          itemActions: []
        },
        mainDetails: { },
        privileges: {
            list: 'GetUserPrivacyPolicyList'
        }
      }
    };

    function getUserAcceptedPrivacyPolicyList(generalProperties, accountId, userId) {
      var promise;

      if (angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
        var state = {};
        state.name = $state.current.name;
        state.params = $state.params;
        var isBulk = true;
        var logData = activityLogger.createLogData(null, state, 'users.privacyPolicy', 'VIEW', isBulk, new Date(), null, null);
        promise = api.webGet(api.baseUrl + '/users/' + userId + '/privacypolicies', undefined, true, generalProperties.forceFetch);
        promise = activityLogger.log(logData, promise);
      }
      else {
        promise = api.webGet(api.baseUrl + '/users/' + userId + '/privacypolicies', undefined, true, generalProperties.forceFetch);
      }

      promise.then(function () {
        if (api.users.privacyPolicy.isDirty) {
          //Invalidate lookupData
          api.users.privacyPolicy.lookupData = undefined;
          api.users.privacyPolicy.isDirty = false;
        }
      });
      return promise;
    }

  }
})();
(function () {
  'use strict';

  angular
    .module('app.main.notifications', [])
    .config(config);

  /* @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {

    $stateProvider.state('app.notifications', {
      url: '/notifications',
      views: {
        'content@app': {
          templateUrl: 'app/main/notifications/list/notifications-list.html',
          controller: 'notificationsListController as vm'
        }
      },
      data: {
        displayName: 'NOTIFICATIONS.NAV'
      },
      // accessPrivileges: ['GetAllNotification']
      // accessPrivileges: ['nav_notifications']
      accessInfo: {
        accessPrivileges: ['nav_notifications']
      },
      visibleForLinePlan: true
    });

    $stateProvider.state('app.notifications.details', {
      url: '/:id',
      views: {
        'content@app': {
          templateUrl: 'app/main/notifications/details/notification-details.html',
          controller: 'notificationsDetailsController as vm'
        }
      },
      data: {
        displayName: 'NOTIFICATIONS.TABS.NOTIFICATION',
        parentState: 'app.notifications'
      },
      // accessPrivileges: ['GetNotificationDetails']
      accessInfo: {
        accessPrivileges: ['GetNotificationDetails']
      },
      visibleForLinePlan: true
    });

    // Translation
    $translatePartialLoaderProvider.addPart('app/main/notifications');

    // Navigation
    msNavigationServiceProvider.saveItem('main.notifications', {
      title: 'Notifications',
      icon: 'icon-alert-box',
      state: 'app.notifications',
      translate: 'NOTIFICATIONS.NAV',
      weight: 13,
      // accessPrivileges: ['GetAllNotification']
      // accessPrivileges: ['nav_notifications'],
      accessInfo: {
        accessPrivileges: ['nav_notifications']
      },
      visibleForLinePlan: true
    });
  }

})();
(function () {
  'use strict';

  angular
    .module('app.main.notifications')
    .run(runBlock);

  /* @ngInject */
  function runBlock(api, activityLogger, $state) {

    if (angular.isUndefined(api.users)) {
      api.users = {};
    }
    api.users.notifications = {
      modelPath: 'users.notifications',
      fields: [
        { field: 'Id', type: 'int', displayLabel: 'NOTIFICATIONS.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
          validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } } },
        { field: 'UserId', type: 'int', displayLabel: 'NOTIFICATIONS.FIELDS.USER_ID', visible: true, creatable: false, editable: false, inputType: 'lookup', lookupSource: 'accounts.users',
          validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } } },
        { field: 'CustomerId', type: 'int', displayLabel: 'NOTIFICATIONS.FIELDS.CUSTOMER_ID', visible: true, creatable: false, editable: false, inputType: 'number',
          validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } } },
        {  field: 'Content', type: 'text', displayLabel: 'NOTIFICATIONS.FIELDS.CONTENT', visible: true, creatable: false, editable: false, inputType: 'text',
          validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } } },
        { field: 'Email', type: 'text', displayLabel: 'NOTIFICATIONS.FIELDS.EMAIL', visible: true, creatable: false, editable: false, inputType: 'text',
            validation: {isRequired: false, maxLen: 500, minLen: 0, pattern: '^[A-Za-z]+[A-Za-z0-9._+-]+@{1}[A-Za-z0-9._-]+\.[A-Za-z.]{2,}$', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: 'VALIDATIONS.INVALID_EMAIL'}} },
        { field: 'EntityId', type: 'int', displayLabel: 'NOTIFICATIONS.FIELDS.ENTITY_ID', visible: true, creatable: false, editable: false, inputType: 'number',
          validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } } },
        {  field: 'Channel', type: 'text', displayLabel: 'NOTIFICATIONS.FIELDS.CHANNEL', visible: true, creatable: false, editable: false, inputType: 'text',
          validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } } },
        { field: 'NotificationTypeId', type: 'int', displayLabel: 'NOTIFICATIONS.FIELDS.NOTIFICATION_TYPE_ID', visible: true, creatable: false, editable: false, inputType: 'number',
          validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } } },
        { field: 'NotificationType', type: 'text', displayLabel: 'NOTIFICATIONS.FIELDS.NOTIFICATION_TYPE', visible: true, creatable: false, editable: false, inputType: 'text',
          validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } } },
        { field: 'Title', type: 'text', displayLabel: 'NOTIFICATIONS.FIELDS.TITLE', visible: true, creatable: false, editable: false, inputType: 'text',
          validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } } },
        { field: 'Status', type: 'text', displayLabel: 'NOTIFICATIONS.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'notificationStatus',
          validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } } },
        { field: 'CreatedDateTime', type: 'text', displayLabel: 'NOTIFICATIONS.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
          validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } } },
        { field: 'SentDateTime', type: 'text', displayLabel: 'NOTIFICATIONS.FIELDS.SENT_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
          validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } } },
      ],
      uniqueConstraints: [],
      title: 'NOTIFICATIONS.NAV',
      icon: 'icon-alert-box',
      idField: 'Id',
      lookupDisplayField: '',
      isDirty: false,
      methods: {
        getList: getNotifications
      },
      views: {
        mainList: {
          columns: ['Email', 'Channel', 'NotificationType', 'Title', 'Content', 'Status', 'SentDateTime'],
          columnFilter: {},
          toggleFilterProps: {},
          topIndex: 0,
          showFilterRow: false,
          sortColumn: {'SentDateTime': false},
          sortDescending: true,
          itemActions: [
            { id: 'view', label: 'ACTIONS.VIEW', icon: 'icon-magnify', privilege: 'GetNotificationDetails', disabled: false, visible: true }
          ],
          listActions: [ ],
          fabAction: {}
        },
        mainDetails: {
          selectedTabIndex: 0,
          itemActions: [],
          fabAction: {}
        },
        privileges: {
          list: 'GetUsersNotifications'
        }
      }

    };

    function getNotifications(generalProperties, userId) {
      var promise;

      if (angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
        var state = {};
        state.name = $state.current.name;
        state.params = $state.params;
        var isBulk = true;
        var logData = activityLogger.createLogData(null, state, 'users.notifications', 'VIEW', isBulk, new Date(), null, null);

        promise = api.webGet(api.baseUrl + '/users/' + userId + '/notifications', undefined, true, generalProperties.forceFetch);
        promise = activityLogger.log(logData, promise);
      }
      else {
        promise = api.webGet(api.baseUrl + '/users/' + userId +  '/notifications', undefined, true, generalProperties.forceFetch);
      }

      promise.then(function () {
        if (api.users.notifications.isDirty) {
          //Invalidate lookupData
          api.users.notifications.lookupData = undefined;
          api.users.notifications.isDirty = false;
        }
      });
      return promise;
    }

  }
})();
(function() {
		'use strict';

		angular
				.module('app.main.accounts.users.notification-types', []);
})();
(function() {
		'use strict';

		angular
				.module('app.main.accounts.users.notification-types')
				.run(runBlock);

		/* @ngInject */
		function runBlock(api, activityLogger, $state) {

				if (angular.isUndefined(api.users)) {
						api.users = {};
				}
				 api.users.notificationTypes = {
						modelPath: 'users.notificationTypes',
						fields: [
								{ field: 'Id', type: 'text', displayLabel: 'NOTIFICATION_TYPES.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'text',
										validation: {isRequired: true, maxLen: 250, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'TypeId', type: 'text', displayLabel: 'NOTIFICATION_TYPES.FIELDS.TYPE_ID', visible: true, creatable: false, editable: false, inputType: 'text',
										validation: {isRequired: true, maxLen: 250, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'Type', type: 'text', displayLabel: 'NOTIFICATION_TYPES.FIELDS.TYPE', visible: true, creatable: false, editable: false, inputType: 'text',
										validation: {isRequired: true, maxLen: 250, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'AutoSubscribe', type: 'text', displayLabel: 'NOTIFICATION_TYPES.FIELDS.AUTOSUBSCRIBE', visible: true, creatable: false, editable: false, inputType: 'text',
										validation: {isRequired: true, maxLen: 250, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'CatalogCode', type: 'int', displayLabel: 'NOTIFICATION_TYPES.FIELDS.CATALOG_CODE', visible: true, creatable: false, editable: false, inputType: 'number',
										validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'Status', type: 'text', displayLabel: 'NOTIFICATION_TYPES.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'CreatedDate', type: 'text', displayLabel: 'NOTIFICATION_TYPES.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'UpdatedDate', type: 'text', displayLabel: 'NOTIFICATION_TYPES.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'CreatedBy', type: 'text', displayLabel: 'NOTIFICATION_TYPES.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'UpdatedBy', type: 'text', displayLabel: 'NOTIFICATION_TYPES.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'NotificationTypeIdsList', type:'text', displayLabel: 'NOTIFICATION_TYPES.NAV', visible: false, creatable: false, editable: true, inputType: 'lookup-many', lookupSource: 'lists.notificationTypes',
										validation: {isRequired: false, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
						],
						uniqueConstraints: [],
						title: 'NOTIFICATION_TYPES.NAV',
						icon: 'icon-book-open',
						idField: 'TypeId',
						lookupDisplayField: 'Type',
						isDirty: false,
						methods: {
							update         :   assignNotificationTypes
						},
						views: {
							mainList: {
								 columns         : [ 'TypeId', 'Type', 'AutoSubscribe', 'CatalogCode', 'Status', 'UpdatedDate' ],
								 columnFilter    : {},
								 toggleFilterProps: { toggleStatus:false, filterProp:'Status', trueVal:1, trueValTooltipMessage: 'ACTIONS.TOGGLE_ACTIVE', falseVal:'', falseValTooltipMessage:"ACTIONS.TOGGLE_ALL"},
								 topIndex        : 0,
								 showFilterRow   : false,
								 sortColumn      : {'UpdatedDate': false},
								 itemActions     : [],
								 listActions     : [],
								 fabAction       : { id: 'add', label: 'ACTIONS.ADD', icon: 'icon-link', privilege: 'BulkSubscribeNotifications:true', visible: true }
							},
							mainDetails: {},
							privileges: {
									list: 'GetUserDetails'
							}
				 	}
				};

				function assignNotificationTypes(undefined, record, userId) {
					var requestObj = [
						{
							UserId: userId,
							Types: []
						}
					];
					angular.forEach(record.NotificationTypeIdsList, function(type) {
							var types = {
									TypeId: type
							}
							requestObj[0].Types.push(types);
					});

					var state = {};
					state.name = $state.current.name;
					state.params = $state.params;
					var logData = activityLogger.createLogData(record, state, 'users.notificationTypes', 'ADD', false, new Date(), null, null);
					var promise = api.webPut(api.baseUrl + '/notifications/bulksubscribe', requestObj);

					promise.then(function() {
							api.users.notificationTypes.isDirty = true;
					});
					return activityLogger.log(logData, promise);
				}

		}
})();
(function() {
  'use strict';

  angular
      .module('app.main.accounts.users.customers', []);
})();
(function () {
  'use strict';

  angular
  .module('app.main.accounts.users.customers')
  .run(runBlock);

  /* @ngInject */
  function runBlock(api, activityLogger, $state, crud) {

    if (angular.isUndefined(api.users)) {
      api.users = {};
    }
    api.users.customers = {
      modelPath: 'users.customers',
      fields: [
          { field: 'Id', type: 'int', displayLabel: 'BUYER_USER_CUSTOMERS.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
              validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
          { field: 'CustomerCode', type: 'text', displayLabel: 'BUYER_USER_CUSTOMERS.FIELDS.CUSTOMER_CODE', visible: true, creatable: true, editable: true, inputType: 'text',
              validation: {isRequired: true, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
          { field: 'CustomerName', type: 'text', displayLabel: 'BUYER_USER_CUSTOMERS.FIELDS.CUSTOMER_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
              validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
          { field: 'SellerAccountId', type: 'int', displayLabel: 'BUYER_USER_CUSTOMERS.FIELDS.SELLER_ACCOUNT_ID', visible: true, creatable: false, editable: false, inputType: 'number',
              validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
          { field: 'SellerAccountName', type: 'text', displayLabel: 'BUYER_USER_CUSTOMERS.FIELDS.SELLER_ACCOUNT_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
              validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
          { field: 'Status', type: 'text', displayLabel: 'BUYER_USER_CUSTOMERS.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
              validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
          { field: 'Token', type: 'text', displayLabel: 'BUYER_USER_CUSTOMERS.FIELDS.TOKEN', visible: false, creatable: true, editable: true, inputType: 'text',
              validation: {isRequired: true, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
      ],
      uniqueConstraints: [],
      title: 'BUYER_USER_CUSTOMERS.NAV',
      icon: 'icon-alert-box',
      idField: 'Id',
      lookupDisplayField: 'CustomerName',
      isDirty: false,
      isBulkActionCompleted: false,
      methods: {
        getList       : getCustomersList,
        activateBulk  : activateCustomers,
        create        : linkCustomer
      },
      views: {
        mainList: {
          columns: [ 'CustomerName', 'CustomerCode', 'SellerAccountName', 'Status'],
          columnFilter: {},
          toggleFilterProps: {},
          topIndex: 0,
          showFilterRow: false,
          sortColumn: {},
          sortDescending: true,
          itemActions: [
            { id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'BuyerUserToCustomerStatusUpdateBulk', disabled: false, visible: 'itm.Status',
            requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
            { id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'BuyerUserToCustomerStatusUpdateBulk', disabled: false, visible: '!itm.Status',
            requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'},
          ],
          listActions: [
            { id: 'delete', label: 'ACTIONS.DELETE_BULK', icon: 'icon-delete', privilege: 'BuyerUserToCustomerStatusUpdateBulk', disabled: '{selected: true, Status: 1}', visible: true,
            requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
            { id: 'activate', label: 'ACTIONS.ACTIVATE_BULK', icon: 'icon-undo-variant', privilege: 'BuyerUserToCustomerStatusUpdateBulk', disabled: '{selected: true, Status: 0}', visible: true,
            requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
          ],
          fabAction:
           { id: 'add', label: 'ACTIONS.ASSIGN', icon: 'icon-link', privilege: 'LinkBuyerUserToCustomer', visible: true }
        },
        mainDetails: { },
        privileges: {
            list: 'GetBuyerUserCustomerList'
        }
      }
    };

    function getCustomersList(generalProperties, buyerId, userId, model) {
      if (angular.isDefined(model)) { // to skip this part for load lookup
        model.isBulkActionCompleted = false;
      }
      var promise;
      if (angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
        var state = {};
        state.name = $state.current.name;
        state.params = $state.params;
        var isBulk = true;
        var logData = activityLogger.createLogData(null, state, 'users.customers', 'VIEW', isBulk, new Date(), null, null);
        promise = api.webGet(api.baseUrl + '/buyers/' + buyerId + '/users/' + userId + '/customers', undefined, true, generalProperties.forceFetch);
        promise = activityLogger.log(logData, promise);
      }
      else {
        promise = api.webGet(api.baseUrl + '/buyers/' + buyerId + '/users/' + userId + '/customers', undefined, true, generalProperties.forceFetch);
      }
      promise.then(function () {
        if (api.users.customers.isDirty) {
          //Invalidate lookupData
          api.users.customers.lookupData = undefined;
          api.users.customers.isDirty = false;
        }
      });
      return promise;
    }

    function activateCustomers(records, model, actionType, buyerId, userId) {
      var result = crud.createRequestObject(records, model, actionType);
      var state = {};
      state.name = $state.current.name;
      state.params = $state.params;
      var isBulk = result.itemsNameList.length > 1 ? true : false;
      var logData = activityLogger.createLogData(result.itemsNameList, state, 'users.customers', actionType.toUpperCase(), isBulk, new Date(), null, null);
      var promise = api.webPut(api.baseUrl + '/buyers/'+ buyerId + '/users/' + userId + '/customers/status', result.requestObj);

      promise.then(function() {
          crud.onRecordStatusChange(records, model, actionType);
      });
      return activityLogger.log(logData, promise);
   }


    function linkCustomer(record, parentIds) {
      var state = {};
      state.name = $state.current.name;
      state.params = $state.params;
      var logData = activityLogger.createLogData(null, state, 'users.customers', 'ADD', false, new Date(), null, null);
      var promise = api.webPut(api.baseUrl + '/buyers/' + parentIds.buyerId + '/users/' + parentIds.userId + '/linkcustomers', record);

      promise.then(function () {
        model.isDirty = true;
      });
      return activityLogger.log(logData, promise);
    }

  }
})();
(function () {
  'use strict';

  angular
  .module('app.main.accounts.users.catalog-access')
  .run(runBlock);

  /* @ngInject */
  function runBlock(api, activityLogger, $state, crud, toast) {

    if (angular.isUndefined(api.users)) {
      api.users = {};
    }
    api.users.catalogAccess = {
      modelPath: 'users.catalogAccess',
      fields: [
          { field: 'Season', type: 'text', displayLabel: 'CATALOGS.FIELDS.SEASON', visible: true, creatable: false, editable: false, inputType: 'text',
              validation: {isRequired: false, maxLen: 100, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
          { field: 'Year', type: 'int', displayLabel: 'CATALOGS.FIELDS.YEAR', visible: true, creatable: false, editable: false, inputType: 'number',
              validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
          { field: 'DataSourceTypeId', type: 'int', displayLabel: 'CATALOGS.FIELDS.DATA_SOURCE_TYPE', visible: false, creatable: false, editable: false, inputType: 'number',
              validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
          { field: 'DataSourceType', type: 'text', displayLabel: 'CATALOGS.FIELDS.DATA_SOURCE_TYPE', visible: true, creatable: false, editable: false, inputType: 'text',
              validation: {isRequired: false, maxLen: 100, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
          { field: 'CatalogCode', type: 'int', displayLabel: 'CATALOGS.FIELDS.CATALOG_CODE', visible: true, creatable: true, editable: false, inputType: 'number',
              validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
          { field: 'CatalogName', type: 'text', displayLabel: 'CATALOGS.FIELDS.CATALOG_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
              validation: {isRequired: false, maxLen: 100, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
          { field: 'Status', type: 'text', displayLabel: 'CATALOGS.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
              validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
          { field: 'CreatedDate', type: 'text', displayLabel: 'CATALOGS.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
              validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
          { field: 'UpdatedDate', type: 'text', displayLabel: 'CATALOGS.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
              validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
          { field: 'UpdatedBy', type: 'text', displayLabel: 'CATALOGS.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
              validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
          { field: 'CreatedBy', type: 'text', displayLabel: 'USERS.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
              validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
      ],
      uniqueConstraints: [],
      title: 'CATALOG_ACCESS.NAV',
      icon: 'icon-alert-box',
      idField: 'CatalogCode',
      lookupDisplayField: 'CatalogName',
      isDirty: false,
      methods: {
        getList: getAccessibleCatalogs,
        activateBulk: activateCatalogAccess,
        getSellerCatalogs  : getSellerCatalogs
      },
      views: {
        mainList: {
          columns: [ 'CatalogName', 'DataSourceType', 'Status', 'UpdatedDate' ],
          columnFilter: {},
          toggleFilterProps: {},
          topIndex: 0,
          showFilterRow: false,
          sortColumn: { 'UpdatedDate': false },
          sortDescending: true,
          itemActions: [
            { id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'AssignSellerUserCatalogs', disabled: false, visible: 'itm.Status',
            requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'}
          ],
          listActions: [
            { id: 'delete', label: 'ACTIONS.DELETE_BULK', icon: 'icon-delete', privilege: 'AssignSellerUserCatalogs', disabled: '{selected: true, Status: 1}', visible: true,
            requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'}
          ],
          fabAction:
           { id: 'add', label: 'ACTIONS.ASSIGN', icon: 'icon-link', privilege: 'AssignSellerUserCatalogs', visible: true }
        },
        mainDetails: { },
        privileges: {
            list: 'GetSellerUserAssignedCatalogs'
        }
      }
    };

    function getAccessibleCatalogs(generalProperties, accountId, userId) {
      var promise;

      if (angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
        var state = {};
        state.name = $state.current.name;
        state.params = $state.params;
        var isBulk = true;
        var logData = activityLogger.createLogData(null, state, 'users.catalogAccess', 'VIEW', isBulk, new Date(), null, null);
        promise = api.webGet(api.baseUrl + '/sellers/' + accountId + '/users/' + userId + '/catalogs', undefined, true, generalProperties.forceFetch);
        promise = activityLogger.log(logData, promise);
      }
      else {
        promise = api.webGet(api.baseUrl + '/sellers/' + accountId + '/users/' + userId + '/catalogs', undefined, true, generalProperties.forceFetch);
      }

      promise.then(function () {
        if (api.users.catalogAccess.isDirty) {
          //Invalidate lookupData
          api.users.catalogAccess.lookupData = undefined;
          api.users.catalogAccess.isDirty = false;
        }
      });
      return promise;
    }

    function activateCatalogAccess(records, model, actionType, accountId, userId) {
      var result = crud.createRequestObject(records, model, actionType);
      var state = {};
      state.name = $state.current.name;
      state.params = $state.params;
      var isBulk = result.itemsNameList.length > 1 ? true : false;
      var logData = activityLogger.createLogData(result.itemsNameList, state, 'users.catalogAccess', actionType.toUpperCase(), isBulk, new Date(), null, null);
      var promise = api.webPut(api.baseUrl + '/sellers/' + accountId + '/users/' + userId + '/catalogs', result.requestObj);

      promise.then(function () {
        var toastMessageKey = '';
        model.isDirty = true
        if (actionType.toUpperCase() === 'ACTIVATE') {
          toastMessageKey = records.length > 1 ? 'SUCCESS.LINKED_BULK' : 'SUCCESS.LINKED';
        } else {
          toastMessageKey = records.length > 1 ? 'SUCCESS.DELETE_BULK' : 'SUCCESS.DELETE';
        }
        toast.success(toastMessageKey, '', '');
      });
      return activityLogger.log(logData, promise);
    }

    function getSellerCatalogs(generalProperties, accountId) {
      return api.webGet(api.baseUrl + '/sellers/' + accountId + '/catalogs', undefined, true, generalProperties.forceFetch);
    }

  }
})();
(function () {
	'use strict';

	angular
		.module('app.viewCreator')
		.controller('updateUserGroupsController', updateUserGroupsController);

	/* @ngInject */
	function updateUserGroupsController($mdDialog, $scope, $filter, hotkeys, $window, $log, api, toast, utility, model, record, isNew, existingRecordsForUniqueValue, lookupPromises, catalogFactory) {
		var vm = this;

		//data
		vm.isLoading = false;
		vm.record = (angular.isDefined(record) && record != null) ? angular.copy(record) : {};
		vm.record.Users = (!vm.record.Users) ? [] : vm.record.Users;
		vm.record.Criteria = (!vm.record.Criteria) ? [] : Array.isArray(vm.record.Criteria) ? vm.record.Criteria : vm.record.Criteria.split(',');
		vm.record.Actions = (!vm.record.Actions) ? [] : Array.isArray(vm.record.Actions) ? vm.record.Actions : vm.record.Actions.split(',');
		vm.lookupModel = angular.copy(vm.record);
		vm.isNew = isNew;
		vm.searchText = '';

		if (vm.isNew) {
			vm.record.Source = 'Requests'; //default
			// add AttributeGroupId
			vm.record.AttributeGroupId = catalogFactory.getActiveCatalog().AttributeGroupId;
		}

		vm.acSelectedItem = [];
		vm.acSearchText = [];
		vm.searchText = {};

		vm.accountTypes = [
			{ id: 2, value: "Seller", lookupSource: 'accounts.sellers' },
			{ id: 3, value: "Buyer", lookupSource: 'accounts.buyers' }
		];
		vm.accountType = {};
		var requestforSeller = false;
		var requestforBuyer = false;
		vm.existingRecordsForUniqueValue = existingRecordsForUniqueValue;
		vm.onSourceChange = onSourceChange;
		vm.sourceList = [
			{ id: 'Requests',    value: 'Requests' },
			{ id: 'Merchboard',  value: 'Merchboard' },
			{ id: 'Whiteboard',  value: 'Whiteboard' },
			{ id: 'Favorites',   value: 'Favorites' },
			{ id: 'SavedViews',  value: 'Saved Views' },
		];


		//methods
		vm.saveRecord = saveRecord;
		vm.closeDialog = closeDialog;

		vm.onAccountTypeChange = loadAccounts;
		vm.lookupSearch = lookupSearch;
		vm.lookupChange = lookupChange;
		vm.getLookupDisplayValue = getLookupDisplayValue;
		vm.selectText = selectText;

		vm.transformChip = transformChip;
		vm.acQuerySearch = acQuerySearch;
		vm.getChipDisplayValue = getChipDisplayValue;
		vm.validateJSON = validateJSON;

		activate();

		////////////////

		function activate() {
			//Hotkeys
			hotkeys.bindTo($scope).add({
				combo: 'ctrl+enter',
				description: $filter('translate')('ACTIONS.SAVE'),
				allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
				callback: function (event) {
					if (!vm.isLoading && !vm.editForm.$invalid) {
						vm.saveRecord();
					}
				}
			});

			if (vm.isNew) {
				hotkeys.bindTo($scope).add({
					combo: 'ctrl+shift+enter',
					description: $filter('translate')('ACTIONS.SAVE_AND_NEW'),
					allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
					callback: function (event) {
						if (!vm.isLoading && !vm.editForm.$invalid) {
							vm.saveRecord(true);
						}
					}
				});
			}

			// Add compound uniqueness validator for Name + Source
			$scope.$watch(function () { return vm.editForm && vm.editForm.Name; }, function (nameCtrl) {
				if (nameCtrl) {
					nameCtrl.$validators['uniqueNameSource'] = function (modelValue) {
						if (!modelValue) {
							return true;
						}
						var nameLower = modelValue.toString().toLowerCase();
						var currentSource = vm.record.Source;
						for (var i = 0; i < existingRecordsForUniqueValue.length; i++) {
							var rec = existingRecordsForUniqueValue[i];
							if (rec.Name && rec.Name.toString().toLowerCase() === nameLower && rec.Source === currentSource) {
								return false;
							}
						}
						return true;
					};
				}
			});
		}

		function onSourceChange() {
			// Re-validate the Name field when Source changes, since uniqueness depends on the Name + Source combination
			if (vm.editForm && vm.editForm.Name) {
				vm.editForm.Name.$validate();
				vm.editForm.Name.$setTouched();
				vm.editForm.Name.$setDirty();
			}
		}

		function saveRecord(saveAndNew) {
			vm.isLoading = true;
			var requestObject = angular.copy(vm.record);

			if (requestObject.Source !== 'Requests') {
				delete requestObject.Criteria;
				delete requestObject.Actions;
				delete requestObject.AdditionalCriteria;
			}

			var p;

			if (vm.isNew) {
				p = model.methods.create(requestObject);
			}
			else {
				p = model.methods.update(vm.record[model.idField], requestObject);
			}

			p.then(function (response) {
				if (vm.isNew && angular.isDefined(saveAndNew) && saveAndNew) {
					vm.editForm.$setPristine();
					vm.editForm.$setUntouched();
					vm.record = {};
					vm.lookupModel = {};
					vm.record.Users = [];
					vm.record.Criteria = [];
					vm.record.Actions = [];
					vm.acSearchText = [];
					vm.searchText = {};
					vm.accountType = {};
					vm.acSelectedItem = [];
					vm.isDataDirty = true;
					vm.record.Source = 'Requests';

					var el = $window.document.getElementById('dialog_input_first');
					if (el) {
						el.focus();
					}
				} else {
					closeDialog(true);
				}

				var toastMessage;
				toastMessage = response.config.method.toUpperCase() === 'POST' ? 'SUCCESS.CREATE' : 'SUCCESS.UPDATE';
				toast.success(toastMessage, '', '');
			}, function (err) {
				closeDialog(vm.isDataDirty);
			}).finally(function () {
				vm.isLoading = false;
			})
		}

		function closeDialog(saved) {
			$mdDialog.hide(saved);
		}

		function loadAccounts(accountType) {
			if (accountType.id === 2 && !requestforSeller) {
				requestforSeller = true;
				lookupPromises['Seller'] = api.getLookupData(api.accounts.sellers);
			}
			else if (accountType.id === 3 && !requestforBuyer) {
				requestforBuyer = true;
				lookupPromises['Buyer'] = api.getLookupData(api.accounts.buyers);
			}
			vm.accountTypeId = accountType.id; // use to filter role based on selected account type
			vm.lookupModel.AccountId = undefined; // to clear account field on account type change
			vm.searchText.AccountId = '';
		}

		function lookupSearch(query, field, lookupSource, lookupFilter) {
			var results = [];
			var predicate = angular.isDefined(lookupFilter) ? angular.copy(lookupFilter) : {};
			predicate.value = query;
			var lookupModel = api.getModel(lookupSource);

			if (angular.isDefined(lookupModel.lookupData) && angular.isDefined(lookupModel.lookupData.data) && lookupModel.lookupData.data.length) {
				results = query ? utility.filterObject(lookupModel.lookupData.data, predicate) : utility.filterObject(lookupModel.lookupData.data, lookupFilter, true);
				return results;
			}
			else {
				return lookupPromises[field].then(function (lookupData) {
					results = query ? utility.filterObject(lookupData.data, predicate) : utility.filterObject(lookupData.data, lookupFilter, true);
					return results;
				});
			}
		}

		// convert dropdown scope value form object(lookup record) to id property of lookup record
		function lookupChange(selectedObj, field) {

			if (angular.isObject(selectedObj)) {
				vm.record[field] = selectedObj.id;
			}
			else if (angular.isUndefined(selectedObj) || selectedObj === null) {
				vm.record[field] = undefined; // on record removal make field undefined or the property can be deleted using delete keywork
			}
		}

		function getLookupDisplayValue(item, field, lookupSource) {
			var lookupModel = api.getModel(lookupSource);

			if (angular.isDefined(lookupModel.lookupData) && angular.isDefined(lookupModel.lookupData.data) && lookupModel.lookupData.data.length) {
				return getLookupDisplayVal(item, lookupModel.lookupData);
			}
			else {
				return lookupPromises[field].then(function (lookupData) {
					return getLookupDisplayVal(item, lookupData);
				});
			}
		}

		//helper method
		function getLookupDisplayVal(item, lookupData) {
			var result;
			if (lookupData) {
				// since autocomplte return object
				if (angular.isObject(item)) {
					result = utility.filterObject(lookupData.data, { id: item.id }, true);
				}
				// to initialize field value if any (when open update record dialog)
				else {
					result = utility.filterObject(lookupData.data, { id: item }, true);
				}

				if (angular.isArray(result) && result.length > 0) {
					return result[0].value;
				}
				else {
					return result.value;
				}
			}
		}

		function selectText(event) {
			utility.selectInputText(event);
		}

		function transformChip(chip) {
			if (angular.isObject(chip)) {
				return chip.id;
			}
			return undefined;
		}

		function acQuerySearch(query, selectedRecords, fieldName) {
			var results = [];
			var field = utility.filterObject(model.fields, { field: fieldName, inputType: 'lookup-many' }, true)[0];
			var lookupFilter = angular.isDefined(field.lookupFilter) ? field.lookupFilter : {};
			var predicate = angular.copy(lookupFilter);
			predicate.value = query;

			var lookupModel = api.getModel(field.lookupSource);
			if (angular.isDefined(lookupModel.lookupData) && angular.isDefined(lookupModel.lookupData.data) && lookupModel.lookupData.data.length) {
				results = query ? utility.filterObject(lookupModel.lookupData.data, predicate) : utility.filterObject(lookupModel.lookupData.data, lookupFilter);
				results = removeSelectedChips(selectedRecords, results);
				if (fieldName === 'Users') {
					return utility.filterObject(results, { AccountId: vm.record.AccountId, Status: 1 }, true);
				}
				else {
					return results;
				}
			}
			else {
				return lookupPromises[field.field].then(function (lookupData) {
					results = query ? utility.filterObject(lookupData.data, predicate) : utility.filterObject(lookupData.data, lookupFilter);
					results = removeSelectedChips(selectedRecords, results);
					if (fieldName === 'Users') {
						return utility.filterObject(results, { AccountId: vm.record.AccountId, Status: 1 }, true);
					}
					else {
						return results;
					}
				});
			}
		}

		/**
		 * @description
		 * This method will remove selected chips form records (helper method)
		 * @param {array} selectedRecords: list of selected chips
		 * @param {array} records: data property of lookup-data
		 * @returns {array}: list of available chips (chips which are not selected) // it does not really need to return a value but for readability returning modified value
		 */
		function removeSelectedChips(selectedRecords, records) {
			if (angular.isDefined(selectedRecords) && selectedRecords.length > 0) {
				for (var index = records.length - 1; index >= 0; index--) {
					if (selectedRecords.indexOf(records[index].id) !== -1) {
						records.splice(index, 1);
					}
				}
			}
			return records;
		}

		function getChipDisplayValue(chip, fieldName) {
			var field = utility.filterObject(model.fields, { field: fieldName }, true)[0];
			var lookupModel = api.getModel(field.lookupSource);
			if (angular.isDefined(lookupModel.lookupData) && angular.isDefined(lookupModel.lookupData.data) && lookupModel.lookupData.data.length) {
				return getChipDisplayVal(lookupModel.lookupData, chip);
			}
			else { // it will never go to else part since before try to load display value for selected chips, it always load lookup on focus of chips input element
				return lookupPromises[field.field].then(function (lookupData) {
					return getChipDisplayVal(lookupData, chip);
				});
			}
		}

		//helper method
		function getChipDisplayVal(lookupData, chip) {
			var res = utility.filterObject(lookupData.data, { id: chip }, true);
			if (angular.isArray(res) && res.length > 0) {
				return res[0].value;
			}
			else {
				$log.warn('viewCreator controller: Unable to resolve chip display value!');
				return "";
			}
		}

		function validateJSON(field) {
			if(angular.isUndefined(vm.record[field]) || vm.record[field] === '') {
				if (angular.isDefined(vm.editForm[field])) {
					vm.editForm[field].$setValidity('checkIfValidJson', true);
				}
			}
			else {
				var valid = utility.isValidJSON(vm.record[field]);
				if (valid && utility.isObjectEmpty(JSON.parse(vm.record[field]))) {
					valid = false;
				}
				if (valid) {
					if (angular.isDefined(vm.editForm[field])) {
						vm.editForm[field].$setValidity('checkIfValidJson', true);
					}
				} else {
					if (angular.isDefined(vm.editForm[field])) {
						vm.editForm[field].$setValidity('checkIfValidJson', false);
					}
				}
			}
		}
	}
})();
(function() {
  'use strict';

  angular
      .module('app.main.accounts.user-groups.user-group-users', []);
})();
(function () {
  'use strict';

  angular
  .module('app.main.accounts.user-groups.user-group-users')
  .run(runBlock);

  /* @ngInject */
  function runBlock(api, activityLogger, $state) {

    if (angular.isUndefined(api.userGroups)) {
      api.userGroups = {};
    }
    api.userGroups.userGroupUsers = {
      modelPath: 'userGroups.userGroupUsers',
      fields: [
          { field: 'Id', type: 'int', displayLabel: 'USERS.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
              validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
          { field: 'UserId', type: 'int', displayLabel: 'NOTIFICATIONS.FIELDS.USER_ID', visible: true, creatable: false, editable: false, inputType: 'number',
              validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } } },
          { field: 'FirstName', type: 'int', displayLabel: 'ADMIN_USERS.FIELDS.FIRST_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
              validation: {isRequired: true, maxLen: 20, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
          { field: 'LastName', type: 'text', displayLabel: 'ADMIN_USERS.FIELDS.LAST_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
              validation: {isRequired: true, maxLen: 20, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
          { field: 'Email', type: 'text', displayLabel: 'ADMIN_USERS.FIELDS.EMAIL', visible: true, creatable: false, editable: false, inputType: 'text',
              validation: {isRequired: true, maxLen: 500, minLen: 0, pattern: '^[A-Za-z]+[A-Za-z0-9._+-]+@{1}[A-Za-z0-9._-]+\.[A-Za-z.]{2,}$', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: 'VALIDATIONS.INVALID_EMAIL'}} },
          { field: 'UserName', type: 'text', displayLabel: 'ADMIN_USERS.FIELDS.USER_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
              validation: {isRequired: true, maxLen: 50, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
          { field: 'Status', type: 'text', displayLabel: 'CATALOGS.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
              validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
          { field: 'CreatedDate', type: 'text', displayLabel: 'CATALOGS.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
              validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
          { field: 'UpdatedDate', type: 'text', displayLabel: 'CATALOGS.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
              validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
          { field: 'UpdatedBy', type: 'text', displayLabel: 'CATALOGS.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
              validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
          { field: 'CreatedBy', type: 'text', displayLabel: 'USERS.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
              validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
          { field: 'Users', type:'text', displayLabel: 'USER_GROUPS.FIELDS.USERS', visible: false, creatable: false, editable: true, inputType: 'lookup-many', lookupSource: 'accounts.users',
              lookupFilter: {Status: 1}, validation: {isRequired: false, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
      ],
      uniqueConstraints: [],
      title: 'CATALOG_ACCESS.NAV',
      icon: 'icon-alert-box',
      idField: 'Id',
      lookupDisplayField: 'UserName',
      isDirty: false,
      methods: {
        update         :   assignUsers
      },
      views: {
        mainList: {
          columns: [ 'Id', 'UserId', 'UserName', 'Status', 'UpdatedDate' ],
          columnFilter: {},
          toggleFilterProps: {},
          topIndex: 0,
          showFilterRow: false,
          sortColumn: {'UpdatedDate': false},
          sortDescending: true,
          itemActions: [],
          listActions: [],
          fabAction:
           { id: 'add', label: 'ACTIONS.ASSIGN', icon: 'icon-link', privilege: 'AssignUsersToAccountGroup', visible: true }
        },
        mainDetails: {},
        privileges: {
            list: 'GetAccountGroupDetails'
        }
      }
    };

    function assignUsers(undefined, record, userGroupId) {
      var requestObj = record.Users;
      var state = {};
      state.name = $state.current.name;
      state.params = $state.params;
      var logData = activityLogger.createLogData(record, state, 'userGroups.userGroupUsers', 'ADD', false, new Date(), null, null);
      var promise = api.webPut(api.baseUrl + '/accountgroups/'+ userGroupId + '/users', requestObj);

      promise.then(function() {
          api.userGroups.userGroupUsers.isDirty = true;
      });
      return activityLogger.log(logData, promise);
    }

  }
})();
(function() {
    'use strict';

    angular
        .module('app.main.accounts.sellers.vas', []);
})();
(function() {
    'use strict';

    angular
        .module('app.main.accounts.sellers.vas')
        .run(runBlock);

    /* @ngInject */
    function runBlock(api, activityLogger, $state, crud, toast, catalogFactory, utility) {

        if(angular.isUndefined(api.sellers)) {
            api.sellers = {};
        }
        api.sellers.vas = {
            modelPath: 'sellers.vas',
            fields: [
                { field: 'Id', type: 'int', displayLabel: 'VAS.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Name', type: 'text', displayLabel: 'VAS.FIELDS.NAME', visible: true, creatable: true, editable: true, inputType: 'text',
                    validation: {isRequired: true, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'VasCode', type: 'text', displayLabel: 'VAS.FIELDS.VAS_CODE', visible: true, creatable: true, editable: true, inputType: 'text',
                    validation: {isRequired: true, maxLen: 50, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Description', type: 'text', displayLabel: 'VAS.FIELDS.DESCRIPTION', visible: true, creatable: true, editable: true, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'RequiredAdditionalInfo', type: 'int', displayLabel: 'VAS.FIELDS.REQUIRED_ADDITIONAL_INFO', visible: true, creatable: true, editable: true, inputType: 'int-bool',
                    validation: {isRequired: true, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'AdditionalInfoType', type: 'int', displayLabel: 'VAS.FIELDS.ADDITIONAL_INFO_TYPE', visible: false, creatable: false, editable: false, inputType: 'static',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'SellerAccountId', type: 'int', displayLabel: 'VAS.FIELDS.SELLER_ACCOUNT_ID', visible: false, creatable: false, editable: false, inputType: 'static',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Status', type: 'text', displayLabel: 'VAS.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedDate', type: 'text', displayLabel: 'VAS.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedDate', type: 'text', displayLabel: 'VAS.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedBy', type: 'text', displayLabel: 'VAS.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedBy', type: 'text', displayLabel: 'VAS.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
            ],
            uniqueConstraints: [],
            title: 'VAS.NAV',
            icon: '',
            idField: 'Id',
            lookupDisplayField: 'VasCode',
            isDirty: false,
            isBulkActionCompleted: false,
            methods: {
                getList         :   getVASList,
                updateStatus    :   updateStatus,
                create          :   createVAS,
                update          :   updateVAS
            },
            views: {
                mainList: {
                    columns             : [ 'VasCode', 'Name', 'Description', 'Status', 'UpdatedDate' ],
                    columnFilter        : {},
                    toggleFilterProps   : { toggleStatus:false, filterProp:'Status', trueVal:1, trueValTooltipMessage: 'ACTIONS.TOGGLE_ACTIVE', falseVal:'', falseValTooltipMessage:"ACTIONS.TOGGLE_ALL"},
                    topIndex            : 0,
                    showFilterRow       : false,
                    sortColumn          : {'UpdatedDate': false},
                    itemActions         : [
                                            { id: 'view', label: 'ACTIONS.VIEW', icon: 'icon-magnify', privilege: 'GetVasDetails', disabled: '!itm.Status', visible: true },
                                            { id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UpdateVas', disabled: '!itm.Status', visible: true },
                                            { id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateVasStatus', disabled: false, visible: 'itm.Status',
                                                requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                                            { id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateVasStatus', disabled: false, visible: '!itm.Status',
                                                requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
                                        ],
                    listActions         : [
                        //no API for bulk
                                            // { id: 'delete', label: 'ACTIONS.DELETE_BULK', icon: 'icon-delete', privilege: 'UpdateVasStatus', disabled: '{selected: true, Status: 1}', visible: true,
                                            //     requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                                            // { id: 'activate', label: 'ACTIONS.ACTIVATE_BULK', icon: 'icon-undo-variant', privilege: 'UpdateVasStatus', disabled: '{selected: true, Status: 0}', visible: true,
                                            //     requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
                                        ],
                    fabAction           : {id: 'add', label: 'ACTIONS.ADD', icon: 'icon-plus', privilege: 'CreateVasBulk', visible: true}
                },
                mainDetails: {
                    selectedTabIndex    : 0,
                    itemActions         : [
                                            { id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateVasStatus', disabled: '{selected: true, Status: 1}',
                                                visible: true, requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                                            { id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateVasStatus', disabled: '{selected: true, Status: 0}',
                                                visible: true, requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
                                            ],
                    fabAction           : {id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UpdateVas', visible: true}
                },
                privileges: {
                    list: 'GetVasList',
                    details: 'GetVasDetails'
                }
            }
        };

        function getVASList(generalProperties, model, accountId) {
            if(angular.isDefined(model)) { // to skip this part for load lookup
                model.isBulkActionCompleted = false;
            }
            var promise;
            if(angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
                var state = {};
                state.name = $state.current.name;
                state.params = $state.params;
                var isBulk = true;
                var logData = activityLogger.createLogData(null, state, 'sellers.vas', 'VIEW', isBulk, new Date(), null, null);
                promise = api.webGet(api.baseUrl + '/sellers/' + accountId + '/vas', undefined, true, generalProperties.forceFetch);
                promise = activityLogger.log(logData, promise);
            }
            else {
                accountId = angular.isDefined(accountId) ? accountId : catalogFactory.getActiveCatalog().AccountId;
                promise = api.webGet(api.baseUrl + '/sellers/' + accountId + '/vas', undefined, true, generalProperties.forceFetch);
            }
            return promise;
        }

        function updateStatus(record, model, actionType, vasId, sellerId) {
            var result = {
                itemsNameList: [],
                requestObj: {}
            }
            result.itemsNameList.push(record[api.vas.vas.lookupDisplayField]);
            if(record.Status == 1) {
                result.requestObj['Status'] = 0;
            }
            else {
                result.requestObj['Status'] = 1;
            }
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var isBulk = result.itemsNameList.length > 1 ? true : false;
            var logData = activityLogger.createLogData(result.itemsNameList, state, 'vas.vas', actionType.toUpperCase(), isBulk, new Date(), null, null);
            var promise = api.webPut(api.baseUrl + '/sellers/' + sellerId + '/vas/' + vasId + '/status', result.requestObj);

            promise.then(function() {
                crud.onRecordStatusChange(record, model, actionType);
            });

            return activityLogger.log(logData, promise);
        }

        function createVAS(vas) {
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var logData = activityLogger.createLogData(vas[api.sellers.vas.lookupDisplayField], state, 'sellers.vas', 'ADD', false, new Date(), null, null);
            var promise = api.webPost(api.baseUrl + '/sellers/' + vas.SellerAccountId + '/vas', utility.pushItemToArray(vas));

            promise.then(function() {
               api.sellers.vas.isDirty = true;
            });
            return activityLogger.log(logData, promise);
        }

        function updateVAS(vasId, vas) {
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var logData = activityLogger.createLogData(vas[api.sellers.vas.lookupDisplayField], state, 'sellers.vas', 'EDIT', false, new Date(), null, null);
            var promise = api.webPut(api.baseUrl + '/sellers/' + vas.SellerAccountId + '/vas/' + vasId , vas);

            promise.then(function() {
               api.sellers.vas.isDirty = true;
            });
            return activityLogger.log(logData, promise);
        }

    }
})();
(function() {
    'use strict';
    
    angular
        .module('app.main.accounts.sellers.users', []);    
})();
(function() {
    'use strict';

    angular
        .module('app.main.accounts.sellers.users')
        .run(runBlock);

    /* @ngInject */
    function runBlock(api, activityLogger, $state, crud, catalogFactory) {

        if(angular.isUndefined(api.sellers)) {
            api.sellers = {};
        }
        api.sellers.users = {
            modelPath: 'sellers.users',
            fields: [
                { field: 'Id', type: 'int', displayLabel: 'USERS.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'AccountId', type: 'int', displayLabel: 'USERS.FIELDS.ACCOUNT_ID', visible: false, creatable: false, editable: false, inputType: 'static',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'AccountName', type: 'text', displayLabel: 'USERS.FIELDS.ACCOUNT_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'FirstName', type: 'int', displayLabel: 'USERS.FIELDS.FIRST_NAME', visible: true, creatable: false, editable: true, inputType: 'text',
                    validation: {isRequired: true, maxLen: 20, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'LastName', type: 'text', displayLabel: 'USERS.FIELDS.LAST_NAME', visible: true, creatable: false, editable: true, inputType: 'text',
                    validation: {isRequired: true, maxLen: 20, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Email', type: 'text', displayLabel: 'USERS.FIELDS.EMAIL', visible: true, creatable: false, editable: true, inputType: 'text',
                    validation: {isRequired: true, maxLen: 500, minLen: 1, pattern: '^[A-Za-z]+[A-Za-z0-9._+-]+@{1}[A-Za-z0-9._-]+\.[A-Za-z.]{2,}$', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: 'VALIDATIONS.INVALID_EMAIL'}} },
                { field: 'UserName', type: 'text', displayLabel: 'USERS.FIELDS.USER_NAME', visible: true, creatable: false, editable: true, inputType: 'text',
                    validation: {isRequired: true, maxLen: 50, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Phone', type: 'text', displayLabel: 'USERS.FIELDS.PHONE', visible: true, creatable: false, editable: true, inputType: 'tel',
                    validation: {isRequired: false, maxLen: 20, minLen: 0, pattern: '[0-9]*', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '',
                    invalidType: 'VALIDATIONS.INVALID_PHONE_NUMBER'}} },
                { field: 'CountryCode', type: 'text', displayLabel: 'USERS.FIELDS.COUNTRY', visible: false, creatable: false, editable: true, inputType: 'lookup', lookupSource: 'lists.countries',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CountryCode', type: 'text', displayLabel: 'USERS.FIELDS.COUNTRY_CODE', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Country', type: 'text', displayLabel: 'USERS.FIELDS.COUNTRY', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'City', type: 'text', displayLabel: 'USERS.FIELDS.CITY', visible: true, creatable: false, editable: true, inputType: 'text',
                    validation: {isRequired: false, maxLen: 25, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Designation', type: 'text', displayLabel: 'USERS.FIELDS.DESIGNATION', visible: true, creatable: false, editable: true, inputType: 'text',
                    validation: {isRequired: false, maxLen: 20, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Department', type: 'text', displayLabel: 'USERS.FIELDS.DEPARTMENT', visible: true, creatable: false, editable: true, inputType: 'text',
                    validation: {isRequired: false, maxLen: 20, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Status', type: 'text', displayLabel: 'USERS.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Roles', type: 'text', displayLabel: 'USERS.FIELDS.USER_ROLE', visible: true, creatable: false, editable: true, inputType: 'lookup-many', lookupSource: 'roles.roles',
                    lookupFilter: {'AccountTypeId': 2}, // these are seller account users, so only seller roles are applicable
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreateDate', type: 'text', displayLabel: 'USERS.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdateDate', type: 'text', displayLabel: 'USERS.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'RestrictFullRange', type: 'int', displayLabel: 'USERS.FIELDS.RESTRICT_FULL_RANGE', visible: true, creatable: false, editable: true, inputType: 'bool-int',
                    validation: {isRequired: false, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedBy', type: 'text', displayLabel: 'USERS.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedBy', type: 'text', displayLabel: 'USERS.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
            ],
            uniqueConstraints: [
                {name: 'Constraint 1', fields: ['AccountName']}
            ],
            title: 'USERS.NAV',
            icon: '',
            idField: 'Id',
            lookupDisplayField: 'UserName',
            isDirty: false,
            methods: {
                getList         :   getSellerUsers,
                activateBulk    :   activateUsers,
                update          :   updateUser,
            },
            views: {
                mainList: {
                    columns             : [ 'FirstName', 'Email', 'Designation', 'Status', 'UpdateDate' ],
                    columnFilter        : {},
                    toggleFilterProps   : { toggleStatus:false, filterProp:'Status', trueVal:1, trueValTooltipMessage: 'ACTIONS.TOGGLE_ACTIVE', falseVal:'', falseValTooltipMessage:"ACTIONS.TOGGLE_ALL"},
                    topIndex            : 0,
                    showFilterRow       : false,
                    sortColumn          : {'UpdateDate': false},
                    itemActions         : [
                                            { id: 'view', label: 'ACTIONS.VIEW', icon: 'icon-magnify', privilege: 'GetUserDetails', disabled: '!itm.Status', visible: true },
                                            { id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UpdateUser', disabled: '!itm.Status', visible: true },
                                            { id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateBulkUserStatus', disabled: false, visible: 'itm.Status',
                                                requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                                            { id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateBulkUserStatus', disabled: false, visible: '!itm.Status',
                                                requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
                                        ],
                    listActions         : [
                                            { id: 'delete', label: 'ACTIONS.DELETE_BULK', icon: 'icon-delete', privilege: 'UpdateBulkUserStatus', disabled: '{selected: true, Status: 1}', visible: true,
                                                requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                                            { id: 'activate', label: 'ACTIONS.ACTIVATE_BULK', icon: 'icon-undo-variant', privilege: 'UpdateBulkUserStatus', disabled: '{selected: true, Status: 0}', visible: true,
                                                requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'},
                                            { id: 'changeAccount', label: 'USERS.ACTIONS.CHANGE_ACCOUNT', icon: 'icon-account-switch', privilege: 'ChangeUsersAccount:true', disabled: '{selected: true}', visible: true,
                                                requiresConfirmation: false, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'ARTICLES.MESSAGES.CONFIRM_ASSIGN'}, confirmationAction: 'ACTIONS.ASSIGN'}
                                        ]
                },
                mainDetails: {
                    selectedTabIndex   : 0,
                    itemActions        : [],
                    fabAction           : {}
                },
                privileges: {
                    list: 'GetSellersUsersList',
                    details: 'GetUserDetails'
                }
            }
        };


        function getSellerUsers(generalProperties, accountId) {
            var promise;
            if(angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
                var state = {};
                state.name = $state.current.name;
                state.params = $state.params;
                var isBulk = true;
                var logData = activityLogger.createLogData(null, state, 'sellers.users', 'VIEW', isBulk, new Date(), null, null);
                promise = api.webGet(api.baseUrl + '/sellers/' + accountId + '/users', undefined, true, generalProperties.forceFetch);
                promise = activityLogger.log(logData, promise);
            }
            else {
                accountId = angular.isDefined(accountId) ? accountId : catalogFactory.getActiveCatalog().AccountId;
                promise = api.webGet(api.baseUrl + '/sellers/' + accountId + '/users', undefined, true, generalProperties.forceFetch);
            }
            return promise;
        }


        function activateUsers(records, model, actionType) {
            var result = crud.createRequestObject(records, model, actionType);
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var isBulk = result.itemsNameList.length > 1 ? true : false;
            var logData = activityLogger.createLogData(result.itemsNameList, state, 'sellers.users', actionType.toUpperCase(), isBulk, new Date(), null, null);
            var promise = api.webPut(api.baseUrl + '/users/status', result.requestObj);

            promise.then(function() {
                crud.onRecordStatusChange(records, model, actionType);
            });

            return activityLogger.log(logData, promise);
        }


        function updateUser(userId, user) {
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var logData = activityLogger.createLogData(user[api.sellers.users.lookupDisplayField], state, 'sellers.users', 'EDIT', false, new Date(), null, null);
            var promise = api.webPut(api.baseUrl + '/users/' + userId , user);

            promise.then(function() {
               api.sellers.users.isDirty = true;
            });
            return activityLogger.log(logData, promise);
        }


    }
})();
(function() {
    'use strict';

    angular
        .module('app.main.accounts.sellers.size-scale-groups')
        .run(runBlock);

    /* @ngInject */
    function runBlock(api, activityLogger, $state, jobsTracker, crud, CONSTANTS) {

        if(angular.isUndefined(api.sellers)) {
            api.sellers = {};
        }
        api.sellers.sizeScaleGroups = {
            modelPath: 'sellers.sizeScaleGroups',
            fields: [
                { field: 'Id', type: 'int', displayLabel: 'SELLER_SIZE_SCALE_GROUP.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'MasterSizeScaleId', type: 'int', displayLabel: 'SELLER_SIZE_SCALE_GROUP.FIELDS.MASTER_SIZE_SCALE_ID', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'MasterSizeScale', type: 'text', displayLabel: 'SELLER_SIZE_SCALE_GROUP.FIELDS.MASTER_SIZE_SCALE', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'SizeScale', type: 'text', displayLabel: 'SELLER_SIZE_SCALE_GROUP.FIELDS.SIZE_SCALE', visible: true, creatable: true, editable: true, inputType: 'text',
                    validation: {isRequired: true, maxLen: 400, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Sizes', type: 'text', displayLabel: 'SELLER_SIZE_SCALE_GROUP.FIELDS.SIZES', visible: true, creatable: true, editable: false, inputType: 'text',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Sizes', type: 'text', displayLabel: 'SELLER_SIZE_SCALE_GROUP.FIELDS.SIZES', visible: false, creatable: false, editable: true, inputType: 'tags', tagSeparator: ',',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'IsObsolete', type: 'int', displayLabel: 'SELLER_SIZE_SCALE_GROUP.FIELDS.IS_OBSOLETE', visible: true, creatable: false, editable: true, inputType: 'bool-int',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Status', type: 'text', displayLabel: 'SELLER_SIZE_SCALE_GROUP.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedDate', type: 'text', displayLabel: 'SELLER_SIZE_SCALE_GROUP.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedDate', type: 'text', displayLabel: 'SELLER_SIZE_SCALE_GROUP.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedBy', type: 'text', displayLabel: 'SELLER_SIZE_SCALE_GROUP.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedBy', type: 'text', displayLabel: 'SELLER_SIZE_SCALE_GROUP.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
            ],
            uniqueConstraints: [],
            title: 'SELLER_SIZE_SCALE_GROUP.NAV',
            icon: 'icon-layers',
            idField: 'Id',
            lookupDisplayField: 'SizeScale',
            isDirty: false,
            methods: {
                getList     :   getSizeScaleGroups,
                create      :   createSizeScaleGroup,
                update      :   updateSizeScaleGroup,
                createBulk  :   createBulk,
                activateBulk:   activateBulk,
            },
            views: {
                mainList: {
                    columns             : [ 'Id', 'SizeScale', 'Sizes', 'MasterSizeScale', 'IsObsolete', 'Status'],
                    columnFilter        : {},
                    toggleFilterProps   : { toggleStatus:false, filterProp:'Status', trueVal:1, trueValTooltipMessage: 'ACTIONS.TOGGLE_ACTIVE', falseVal:'', falseValTooltipMessage:"ACTIONS.TOGGLE_ALL" },
                    topIndex            : 0,
                    showFilterRow       : false,
                    sortColumn          : {'UpdatedDate': false},
                    itemActions         : [
                                            { id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UpdateSizeScale', disabled: '!itm.Status', visible: true },
                                            { id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateSizeScaleStatusBulk', disabled: false, visible: 'itm.Status',
                                                requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                                            { id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateSizeScaleStatusBulk', disabled: false, visible: '!itm.Status',
                                                requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'},
                                        ],
                    listActions         : [
                                            { id: 'import', label: 'ACTIONS.IMPORT', icon: 'icon-import', privilege: 'CreateUpdateSizeScalesBulk', disabled: false, visible: true, requiresConfirmation: false },
                                            { id: 'delete', label: 'ACTIONS.DELETE_BULK', icon: 'icon-delete', privilege: 'UpdateSizeScaleStatusBulk', disabled: '{selected: true, Status: 1}', visible: true,
                                                requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                                            { id: 'activate', label: 'ACTIONS.ACTIVATE_BULK', icon: 'icon-undo-variant', privilege: 'UpdateSizeScaleStatusBulk', disabled: '{selected: true, Status: 0}', visible: true,
                                                requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'},
                                        ],
                    fabAction           : { id: 'add', label: 'ACTIONS.ADD', icon: 'icon-plus', privilege: 'CreateSizeScaleBulk:true', visible: true }
                },
                mainDetails: {},
                privileges: {
                    list: 'GetSellerSizeScaleList',
                }
            }
        };

        function getSizeScaleGroups(model, generalProperties, accountId) {
            if (angular.isDefined(model)) { // to skip this part for load lookup
                model.isBulkActionCompleted = false;
            }
            var promise;
            if(angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
                var state = {};
                state.name = $state.current.name;
                state.params = $state.params;
                var isBulk = true;
                var logData = activityLogger.createLogData(null, state, 'sellers.sizeScaleGroups', 'VIEW', isBulk, new Date(), null, null);
                promise = api.webGet(api.baseUrl + '/sellers/' + accountId + '/sizescales', undefined, true, generalProperties.forceFetch);
                promise = activityLogger.log(logData, promise);
            }
            else {
                promise = api.webGet(api.baseUrl + '/sellers/' + accountId + '/sizescales', undefined, true, generalProperties.forceFetch);
            }
            return promise;
        }

        function createSizeScaleGroup(record, accountId) {
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var logData = activityLogger.createLogData(record[api.sellers.sizeScaleGroups.lookupDisplayField], state, 'sellers.sizeScaleGroups', 'ADD', false, new Date(), null, null);

            record.Sizes = record.Sizes.join(',');
            var promise = api.webPost(api.baseUrl + '/sellers/' + accountId + '/createsizescales', [record]);

            promise.then(function () {
                api.sellers.sizeScaleGroups.isDirty = true;
            });
            return activityLogger.log(logData, promise);
        }

        function updateSizeScaleGroup(sizeScaleId, record, accountId) {
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var logData = activityLogger.createLogData(record[api.sellers.sizeScaleGroups.lookupDisplayField], state, 'sellers.sizeScaleGroups', 'EDIT', false, new Date(), null, null);

            record.Sizes = record.Sizes.join(',');
            var promise = api.webPut(api.baseUrl + '/sellers/' + accountId + '/sizescales/' + sizeScaleId, record);

            promise.then(function () {
                api.sellers.sizeScaleGroups.isDirty = true;
            });
            return activityLogger.log(logData, promise);
        }

        function createBulk(model, data, accountId) {
            var jobIndex = jobsTracker.addJob(model, 'SELLER_SIZE_SCALE_GROUP.ACTIONS.IMPORT_SIZE_SCALE', 1);
            api.webPut(api.baseUrl + '/sellers/' + accountId + '/bulksizescales?sourceapplication=' + CONSTANTS.SOURCE_APPLICATION + '&sourceaction=Import Size Scale', data).then(function(response) {
                jobsTracker.trackJob(jobIndex, response.data.Id);
            }).catch(function(error) {
                jobsTracker.setCriticlaFail(jobIndex, error);
            });
        }

        function activateBulk(records, model, actionType, accountId) {
            var result = crud.createRequestObject(records, model, actionType);
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var isBulk = result.itemsNameList.length > 1 ? true : false;
            var logData = activityLogger.createLogData(result.itemsNameList, state, 'sellers.sizeScaleGroups', actionType.toUpperCase(), isBulk, new Date(), null, null);
            var promise = api.webPut(api.baseUrl + '/sellers/' + accountId + '/sizescales/status', result.requestObj);

            promise.then(function() {
                crud.onRecordStatusChange(records, model, actionType);
            });

            return activityLogger.log(logData, promise);
        }

    }
})();
(function() {
    'use strict';

    angular
        .module('app.main.accounts.sellers.seller-resources')
        .run(runBlock);

    /* @ngInject */
    function runBlock(api, activityLogger, $state, utility, crud, jobsTracker) {

        if (angular.isUndefined(api.sellers)) {
            api.sellers = {};
        }
        api.sellers.sellerResources = {
            modelPath: 'sellers.sellerResources',
            fields: [
                { field: 'ArticleIds', type: 'int', displayLabel: 'RESOURCES.FIELDS.ARTICLE_NUMBER', visible: false, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ModelIds', type: 'int', displayLabel: 'RESOURCES.FIELDS.MODEL_NUMBER', visible: false, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ResourceId', type: 'int', displayLabel: 'RESOURCES.FIELDS.RESOURCE_ID', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'IsModelLevel', type: 'text', displayLabel: 'RESOURCES.FIELDS.IS_MODEL_LEVEL', visible: false, creatable: false, editable: false, inputType: 'bool-int',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ResourceName', type: 'text', displayLabel: 'RESOURCES.FIELDS.RESOURCE_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'TypeId', type: 'text', displayLabel: 'RESOURCES.FIELDS.RESOURCE_TYPE_ID', visible: true, creatable: true, editable: true, inputType: 'lookup', lookupSource: 'lists.resourceTypes',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Status', type: 'text', displayLabel: 'RESOURCES.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'SortOrder', type: 'int', displayLabel: 'RESOURCES.FIELDS.SORT_ORDER', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
            ],
            uniqueConstraints: [],
            title: 'RESOURCES.NAV',
            icon: 'icon-image-filter-black-white',
            idField: 'ResourceId',
            lookupDisplayField: 'ResourceName',
            isDirty: false,
            methods: {
                getList         : getSellerResources,
                getDetails      : getSellerResourceDetails,
                create          : createSellerResource,
                update          : updateSellerResource,
                activateBulk    : deactivateSellerResource,
                uploadBulk      : uploadBulkSellerResources,
                createBulk      : createBulkSellerResources,
                editSortOrder   : editSellerResourceSortOrder
            },
            views: {
                mainList: {
                    columns         : [ 'ResourceName', 'ResourceId', 'TypeId', 'Status', 'SortOrder' ],
                    columnFilter    : {},
                    toggleFilterProps: { toggleStatus:false, filterProp:'Status', trueVal:1, trueValTooltipMessage: 'ACTIONS.TOGGLE_ACTIVE', falseVal:'', falseValTooltipMessage:"ACTIONS.TOGGLE_ALL"},
                    topIndex        : 0,
                    showFilterRow   : false,
                    sortColumn      : {'ResourceId': false},
                    itemActions     : [
                                        { id: 'view', label: 'ACTIONS.VIEW', icon: 'icon-magnify', privilege: 'GetSellerResources', disabled: '!itm.Status', visible: true },
                                        { id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UpdateSellerResource', disabled: '!itm.Status || !itm.ResourceId', visible: true },
                                        { id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateSellerResourceStatus', disabled: false, visible: 'itm.Status',
                                            requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                                        { id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateSellerResourceStatus', disabled: false, visible: '!itm.Status',
                                            requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
                                      ],
                    listActions     : [
                                        { id: 'delete', label: 'ACTIONS.DELETE_BULK', icon: 'icon-delete', privilege: 'UpdateBulkSellerResourceStatus', disabled: '{selected: true, Status: 1}', visible: true,
                                            requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                                        { id: 'activate', label: 'ACTIONS.ACTIVATE_BULK', icon: 'icon-undo-variant', privilege: 'UpdateBulkSellerResourceStatus', disabled: '{selected: true, Status: 0}', visible: true,
                                            requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'},
                                        { id: 'upload', label: 'RESOURCES.ACTIONS.UPLOAD', icon: 'icon-upload', privilege: 'CreateSellerBulkResource', disabled: false, visible: true, requiresConfirmation: false},
                                        { id: 'import', label: 'RESOURCES.ACTIONS.MAP', icon: 'icon-import', privilege: 'UpdateBulkSellerResource', disabled: false, visible: true, requiresConfirmation: false},
                                        { id: 'editBulkSortOrder', label: 'RESOURCES.ACTIONS.EDIT_BULK_SORTORDER_CATEGORY', icon: 'icon-pencil', privilege: 'UpdateBulkSellerResourceSortOrder', disabled: '{selected: true, Status: 1}', visible: true, requiresConfirmation: false }
                                      ],
                    fabAction       : {id: 'add', label: 'ACTIONS.ADD', icon: 'icon-plus', privilege: 'CreateSellerResource', visible: true}
                 },
                 mainDetails: {},
                privileges: {
                    list    : 'GetSellerResources',
                    details : 'GetSellerResourceDetails'
                }
            }
        };

        // Dedicated import model for seller-level "Map Resources to Colorways"
        if (angular.isUndefined(api.sellers.mapResourcesToArticles)) {
            api.sellers.mapResourcesToArticles = {
                modelPath: 'sellers.mapResourcesToArticles',
                fields: [
                    { field: 'ArticleNumber', type: 'text', displayLabel: 'RESOURCES.FIELDS.ARTICLE_NUMBER', visible: true, creatable: true, editable: false, inputType: 'lookup',
                        lookupSource: 'sellers.sellerArticlesLookup', lookupFilter: {Status: 1}, useLookupName: true, validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '' } },
                    { field: 'FileName', type: 'text', displayLabel: 'RESOURCES.FIELDS.FILE_NAME', visible: true, creatable: true, editable: false, inputType: 'text',
                        validation: {isRequired: true, maxLen: 250, minLen: 1, pattern: '' } },
                    { field: 'ResourceName', type: 'text', displayLabel: 'RESOURCES.FIELDS.RESOURCE_NAME', visible: true, creatable: true, editable: false, inputType: 'text',
                        validation: {isRequired: true, maxLen: 250, minLen: 1, pattern: '' } },
                    { field: 'TypeId', type: 'text', displayLabel: 'RESOURCES.FIELDS.RESOURCE_TYPE_ID', visible: true, creatable: false, editable: false, inputType: 'text',
                        validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '' } }
                ],
                uniqueConstraints: [
                    {name: 'Constraint 1', fields: ['FileName','ArticleNumber']}
                ],
                title: 'RESOURCES.NAV',
                icon: 'icon-image-filter-black-white',
                idField: 'ResourceId',
                lookupDisplayField: 'ResourceName',
                isDirty: false,
                methods: {},
                views: {
                    mainList: {},
                    mainDetails: {},
                    privileges: {
                        list    : 'GetSellerResources',
                        details : 'GetSellerResourceDetails'
                    }
                }
            };
        }

        // Dedicated import model for seller-level "Map Resources to Styles"
        if (angular.isUndefined(api.sellers.mapResourcesToModels)) {
            api.sellers.mapResourcesToModels = {
                modelPath: 'sellers.mapResourcesToModels',
                fields: [
                    { field: 'ModelNumber', type: 'text', displayLabel: 'SELLER_MODELS.FIELDS.MODEL_NUMBER', visible: true, creatable: true, editable: false, inputType: 'text',
                        validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '' } },
                    { field: 'FileName', type: 'text', displayLabel: 'RESOURCES.FIELDS.FILE_NAME', visible: true, creatable: true, editable: false, inputType: 'text',
                        validation: {isRequired: true, maxLen: 250, minLen: 1, pattern: '' } },
                    { field: 'ResourceName', type: 'text', displayLabel: 'RESOURCES.FIELDS.RESOURCE_NAME', visible: true, creatable: true, editable: false, inputType: 'text',
                        validation: {isRequired: true, maxLen: 250, minLen: 1, pattern: '' } },
                    { field: 'TypeId', type: 'text', displayLabel: 'RESOURCES.FIELDS.RESOURCE_TYPE_ID', visible: true, creatable: false, editable: false, inputType: 'text',
                        validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '' } }
                ],
                uniqueConstraints: [
                    {name: 'Constraint 1', fields: ['FileName','ModelNumber']}
                ],
                title: 'RESOURCES.NAV',
                icon: 'icon-image-filter-black-white',
                idField: 'ResourceId',
                lookupDisplayField: 'ResourceName',
                isDirty: false,
                methods: {},
                views: {
                    mainList: {},
                    mainDetails: {},
                    privileges: {
                        list    : 'GetSellerResources',
                        details : 'GetSellerResourceDetails'
                    }
                }
            };
        }

        function getSellerResources(generalProperties, sellerId, attributeGroupId) {
            api.sellers.sellerResources.isBulkActionCompleted = false;
            var promise;

            if(angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
                var state = {};
                state.name = $state.current.name;
                state.params = $state.params;
                var isBulk = true;
                var logData = activityLogger.createLogData(null, state, 'sellers.sellerResources', 'VIEW', isBulk, new Date(), null, null);

                promise = api.webGet(api.baseUrl + '/sellers/' + sellerId + '/' + attributeGroupId + '/resources', undefined, true, generalProperties.forceFetch);
                promise = activityLogger.log(logData, promise);
            }
            else {
                promise = api.webGet(api.baseUrl + '/sellers/' + sellerId + '/' + attributeGroupId + '/resources', undefined, true, generalProperties.forceFetch);
            }

            promise.then(function() {
                if (api.sellers.sellerResources.isDirty) {
                    api.sellers.sellerResources.isDirty = false;
                }
            });
            return promise;
        }

        function createSellerResource(record, sellerId, attributeGroupId) {
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var logData = activityLogger.createLogData(record.ResourceName, state, 'sellers.sellerResources', 'ADD', false, new Date(), null, null);
            var promise = api.webPost(api.baseUrl + '/sellers/' + sellerId + '/' + attributeGroupId + '/resources', record);

            promise.then(function() {
                api.sellers.sellerResources.isDirty = true;
            });
            return activityLogger.log(logData, promise);
        }

        function updateSellerResource(record, resourceId, sellerId, attributeGroupId) {
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var logData = activityLogger.createLogData(record.ResourceName, state, 'sellers.sellerResources', 'EDIT', false, new Date(), null, null);
            var promise = api.webPut(api.baseUrl + '/sellers/' + sellerId + '/' + attributeGroupId + '/resources/' + resourceId, record);

            promise.then(function() {
                api.sellers.sellerResources.isDirty = true;
            });
            return activityLogger.log(logData, promise);
        }

        function deactivateSellerResource(records, model, actionType, sellerId, attributeGroupId) {
            if(!angular.isArray(records)) {
                records = utility.pushItemToArray(records);
            }

            var itemsNameList = [];
            var requestObj = [];
            var statusVal = actionType === 'delete' ? 0 : 1;
            angular.forEach(records, function(record) {
                itemsNameList.push(record[model.lookupDisplayField]);
                requestObj.push({ResourceId: record[model.idField], Status: statusVal});
            });

            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var isBulk = itemsNameList.length > 1;
            var logData = activityLogger.createLogData(itemsNameList, state, 'sellers.sellerResources', actionType.toUpperCase(), isBulk, new Date(), null, null);
            var promise = api.webPut(api.baseUrl + '/sellers/' + sellerId + '/' + attributeGroupId + '/resources/status', requestObj);

            promise.then(function() {
                crud.onRecordStatusChange(records, model, actionType);
            });

            return activityLogger.log(logData, promise);
        }

        function getSellerResourceDetails(isLogRequired, resourceId, sellerId, attributeGroupId) {
            var promise;
            if(angular.isDefined(isLogRequired) && isLogRequired === true) {
                var state = {};
                state.name = $state.current.name;
                state.params = $state.params;
                promise = api.webGet(api.baseUrl + '/sellers/' + sellerId + '/' + attributeGroupId + '/resources/' + resourceId);
                var logData = activityLogger.createLogData(null, state, 'sellers.sellerResources', 'VIEW', false, new Date(), null, null);
                promise = activityLogger.log(logData, promise);
            }
            else {
                promise = api.webGet(api.baseUrl + '/sellers/' + sellerId + '/' + attributeGroupId + '/resources/' + resourceId);
            }
            return promise;
        }

        function uploadBulkSellerResources(data, resourceType, sellerId, attributeGroupId, model) {
            var requestObj = {
                FileId: data,
                TypeId: resourceType.TypeId
            };
            var jobIndex = jobsTracker.addJob(model, 'RESOURCES.ACTIONS.UPLOAD', 1);
            return api.webPost(api.baseUrl + '/sellers/' + sellerId + '/' + attributeGroupId + '/processresources', requestObj).then(function(response) {
                jobsTracker.trackJob(jobIndex, response.data.Id);
            });
        }

        function editSellerResourceSortOrder(records, updateRecord, sellerId, attributeGroupId) {
            if(!angular.isArray(records)) {
                records = utility.pushItemToArray(records);
            }
            var requestObj = [];
            angular.forEach(records, function(record) {
                if(angular.isDefined(updateRecord)) {
                    record.SortOrder = updateRecord['SortOrder'];
                    record.Category = updateRecord['Category'];
                }
                requestObj.push({
                    ResourceId: record.ResourceId,
                    SortOrder: record.SortOrder,
                    Category: record.Category
                });
            });

            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var logData = activityLogger.createLogData(records, state, 'sellers.sellerResources', 'EDIT', false, new Date(), null, null);
            var promise = api.webPut(api.baseUrl + '/sellers/' + sellerId + '/' + attributeGroupId + '/resources/sortorder', requestObj);

            promise.then(function() {
                api.sellers.sellerResources.isDirty = true;
            });
            return activityLogger.log(logData, promise);
        }

        function createBulkSellerResources(model, records, sellerId, attributeGroupId, isModelLevel) {
            var requestArray = [];
            var fileNameIndexObj = {};
            angular.forEach(records, function(record) {
                var entityValue = isModelLevel ? record.ModelNumber : record.ArticleNumber;
                var entityField = isModelLevel ? 'Models' : 'Articles';
                var groupKey = record.FileName;

                if(angular.isDefined(fileNameIndexObj[groupKey])) {
                    requestArray[fileNameIndexObj[groupKey]][entityField].push(entityValue);
                }
                else {
                    var requestObj = {
                        ResourceName: record.ResourceName,
                        FileName: record.FileName,
                        Description: '',
                        Category: null,
                        SortOrder: 0,
                        IsModelLevel: isModelLevel ? 1 : 0,
                        Models: [],
                        Articles: []
                    };
                    fileNameIndexObj[groupKey] = requestArray.length;
                    requestObj[entityField].push(entityValue);
                    requestArray.push(requestObj);
                }
            });
            var jobIndex = jobsTracker.addJob(model, 'RESOURCES.ACTIONS.IMPORT', 1);

            return api.webPut(api.baseUrl + '/sellers/' + sellerId + '/' + attributeGroupId + '/assignresources', requestArray).then(function(response) {
                jobsTracker.trackJob(jobIndex, response.data.Id);
            });
        }
    }
})();
(function() {
		'use strict';

		angular
				.module('app.main.accounts.sellers.seller-lookup-table')
				.run(runBlock);

		/* @ngInject */
	function runBlock(api, $state, activityLogger, $rootScope, toast) {

				if(angular.isUndefined(api.sellers)) {
						api.sellers = {};
				}

				api.sellers.sellerLookups = {
						modelPath: 'sellers.sellerLookups',
						fields: [
								{ field: 'Id', type: 'int', displayLabel: 'SELLER_LOOKUP_TABLE.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
									validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'Name', type: 'text', displayLabel: 'SELLER_LOOKUP_TABLE.FIELDS.NAME', visible: true, creatable: true, editable: false, showInEdit: true, inputType: 'text',
										validation: {isRequired: true, maxLen: 200, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								// no onChangeLookUp here: this model's create dialog is the dedicated 'createLookupTable' controller, not viewCreator,
								// so it reloads the source/destination attributes itself through loadAttributes() when this dropdown changes
								{ field: 'AttributeGroupId', type: 'int', displayLabel: 'SELLER_LOOKUP_TABLE.FIELDS.ATTRIBUTE_GROUP_NAME', visible: true, creatable: true, editable: false, inputType: 'lookup', lookupSource: 'attributes.attributeGroups',
										validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', disabledCriteria: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'SourceAttributes', type: 'text', displayLabel: 'SELLER_LOOKUP_TABLE.FIELDS.SOURCE_ATTRIBUTES', visible: true, creatable: false, editable: false, inputType: 'text',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'DestinationAttributes', type: 'text', displayLabel: 'SELLER_LOOKUP_TABLE.FIELDS.DESTINATION_ATTRIBUTES', visible: true, creatable: false, editable: false, inputType: 'text',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'Values', type: 'text', displayLabel: 'SELLER_LOOKUP_TABLE.FIELDS.VALUES', visible: false, creatable: false, editable: false, inputType: 'text',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'CreatedDate', type: 'text', displayLabel: 'SELLER_LOOKUP_TABLE.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'UpdatedDate', type: 'text', displayLabel: 'SELLER_LOOKUP_TABLE.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'CreatedBy', type: 'text', displayLabel: 'SELLER_LOOKUP_TABLE.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'UpdatedBy', type: 'text', displayLabel: 'SELLER_LOOKUP_TABLE.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
						],

						title: 'SELLER_LOOKUP_TABLE.NAV',
						icon: '',
						idField: 'Id',
						lookupDisplayField: 'Name',
						methods: {
								getList         :   getLookupDefinitions,
								getDetails      :   getLookupDefinitionDetails,
								create          :   createLookupDefinitions,
								delete          :   deleteLookupDefinition,
						},
						views: {
								mainList: {
										columns             : [ 'Name', 'AttributeGroupId', 'SourceAttributes', 'DestinationAttributes', 'UpdatedBy', 'UpdatedDate' ],
										columnFilter        : {},
										topIndex            : 0,
										showFilterRow       : false,
										sortColumn          : {'UpdatedDate': false},
										itemActions         : [
																						{ id: 'view', label: 'ACTIONS.VIEW', icon: 'icon-magnify', privilege: 'GetLookupDefinitionDetails', disabled: false, visible: true },
																						{ id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'DeleteLookupDefinition', disabled: false, visible: true,
																								requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'}
																					],
										listActions         : [],
										fabAction           : {id: 'add', label: 'ACTIONS.ADD', icon: 'icon-plus', privilege: 'CreateLookupDefinition:true', visible: true}
								},
								mainDetails: {},
								privileges: {
										list: 'GetLookupDefinitions',
										details: 'GetLookupDefinitionDetails'
								}
						}
				};

				function getLookupDefinitions(generalProperties, sellerId) {
						var promise;
						if (angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
								var state = {};
								state.name = $state.current.name;
								state.params = $state.params;
								var isBulk = true;
								var logData = activityLogger.createLogData(null, state, 'sellers.sellerLookups', 'VIEW', isBulk, new Date(), null, null);
								promise = api.webGet(api.baseUrl + '/sellers/' + sellerId + '/lookups', undefined, true, generalProperties.forceFetch);
								promise = activityLogger.log(logData, promise);
						}
						else {
								promise = api.webGet(api.baseUrl + '/sellers/' + sellerId + '/lookups', undefined, true, generalProperties.forceFetch);
						}

						promise.then(function () {
								if (api.sellers.sellerLookups.isDirty) {
										//Invalidate lookupData
										api.sellers.sellerLookups.lookupData = undefined;
										api.sellers.sellerLookups.isDirty = false;
								}
						});
						return promise;
				}

				function getLookupDefinitionDetails(isLogRequired, lookupId, sellerId) {
					var promise;
					if(angular.isDefined(isLogRequired) && isLogRequired === true) {
						var state = {};
						state.name = $state.current.name;
						state.params = $state.params;
						var isBulk = false;
						var items = [];
						promise = api.webGet(api.baseUrl + '/sellers/' + sellerId + '/lookups/' + lookupId);
						promise.then(function(response) {
							items.push(response.data[api.sellers.sellerLookups.lookupDisplayField]);
						});
						var logData = activityLogger.createLogData(items, state, 'sellers.sellerLookups', 'VIEW', isBulk, new Date(), null, null);
						promise = activityLogger.log(logData, promise);
					}
					else {
						promise = api.webGet(api.baseUrl + '/sellers/' + sellerId + '/lookups/' + lookupId);
					}
					return promise;
				}

				function createLookupDefinitions(lookup, sellerId) {
						var state = {};
						state.name = $state.current.name;
						state.params = $state.params;
						var logData = activityLogger.createLogData(lookup[api.sellers.sellerLookups.lookupDisplayField], state, 'attributes.attributes', 'ADD', false, new Date(), null, null);
						var promise = api.webPost(api.baseUrl + '/sellers/' + sellerId + '/lookups', lookup);

						promise.then(function() {
								api.sellers.sellerLookups.isDirty = true;
								$rootScope.$emit('CatalogsUpdatedEvent');
						});
						return activityLogger.log(logData, promise);
				}

				function deleteLookupDefinition(record, sellerId, lookupId) {
					var state = {};
					state.name = $state.current.name;
					state.params = $state.params;
					var logData = activityLogger.createLogData(record, state, 'api.sellers.sellerLookups', 'DELETE', false, new Date(), null, null);
					var promise = api.webDelete(api.baseUrl + '/sellers/' + sellerId + '/lookups/' + lookupId, record);

					promise.then(function() {
						api.sellers.sellerLookups.isDirty = false;
						toast.success('SUCCESS.DELETE', '', '');
					});
					return activityLogger.log(logData, promise);
				}

		}
})();
(function() {
	'use strict';

	angular
		.module('app.main.accounts.sellers.seller-configurations')
		.run(runBlock);

	/* @ngInject */
	function runBlock(api, $state, activityLogger, catalogFactory, jobsTracker, $rootScope) {

		if(angular.isUndefined(api.sellers)) {
			api.sellers = {};
		}

		api.sellers.configurations = {
			modelPath: 'sellers.configurations',
			fields: [
				{ field: 'ConfigId', type: 'int', displayLabel: 'SELLER_CONFIGURATIONS.FIELDS.CONFIGURE_ID', visible: false, creatable: true, editable: true, inputType: 'lookup', lookupSource:'lists.configurations',
					validation: {isRequired: true, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'ConfigId', type: 'int', displayLabel: 'SELLER_CONFIGURATIONS.FIELDS.CONFIGURE_ID', visible: true, creatable: false, editable: false, inputType: 'number',
					validation: {isRequired: true, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'Id', type: 'int', displayLabel: 'SELLER_CONFIGURATIONS.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'Name', type: 'text', displayLabel: 'SELLER_CONFIGURATIONS.FIELDS.NAME', visible: true, creatable: false, editable: false, inputType: 'text', showTooltip: true,
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'Value', type: 'text', displayLabel: 'SELLER_CONFIGURATIONS.FIELDS.VALUE', visible: true, creatable: true, editable: true, inputType: 'text',
					validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'CreatedDate', type: 'text', displayLabel: 'SELLER_CONFIGURATIONS.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'UpdatedDate', type: 'text', displayLabel: 'SELLER_CONFIGURATIONS.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'DefaultValueType', type: 'text', displayLabel: 'SELLER_CONFIGURATIONS.FIELDS.DEFAULT_VALUE_TYPE', visible: true, creatable: false, editable: false, inputType: 'text',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'CreatedBy', type: 'text', displayLabel: 'SELLER_CONFIGURATIONS.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'UpdatedBy', type: 'text', displayLabel: 'SELLER_CONFIGURATIONS.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
			],
			title: 'SELLER_CONFIGURATIONS.NAV',
			detailsDialogTitle: 'PARTS.DETAILS',
			icon: 'icon-checkerboard',
			idField: 'Id',
			lookupDisplayField: 'Name',
			isDirty: false,
			methods: {
				getList         :   getConfigurations,
				create          :   createConfiguration,
				update          :   updateConfiguration,
				delete          :   deleteConfiguration,
				createBulk      :   createBulk
			},
			views: {
				mainList: {
					columns             : [ 'Name', 'Value', 'DefaultValueType', 'UpdatedDate' ],
					columnFilter        : {},
					toggleFilterProps   : {},
					topIndex            : 0,
					showFilterRow       : false,
					sortColumn          : {'UpdatedDate': false},
					itemActions         : [
											{ id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UpdateSellerConfiguration', disabled: '', visible: true },
											{ id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'DeleteSellerConfigurations', disabled: false, visible: true,
												requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
										  ],
					listActions         : [
											{ id: 'delete', label: 'ACTIONS.DELETE_BULK', icon: 'icon-delete', privilege: 'DeleteSellerConfigurations', disabled: '{selected: true}', visible: true,
												requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
											{ id: 'import', label: 'ACTIONS.IMPORT', icon: 'icon-import', privilege: 'UpdateSellerBulkConfiguration', disabled: false, visible: true, requiresConfirmation: false}
										  ],
					fabAction           : { id: 'add', label: 'ACTIONS.ADD', icon: 'icon-plus', privilege: 'CreateSellerConfiguration', visible: true }
				},
				mainDetails: {},
				privileges: {
					list: 'GetSellerSpecificConfigurations'
				}
			}

		};

		api.sellers.importConfigurations = {
			modelPath: 'sellers.importConfigurations',
			fields: [
				{ field: 'ConfigId', type: 'int', displayLabel: 'SELLER_CONFIGURATIONS.FIELDS.CONFIGURE_ID', visible: true, creatable: false, editable: false, inputType: 'number',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'Id', type: 'int', displayLabel: 'SELLER_CONFIGURATIONS.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'Name', type: 'text', displayLabel: 'SELLER_CONFIGURATIONS.FIELDS.NAME', visible: true, creatable: true, editable: false, inputType: 'text',
					validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'Value', type: 'text', displayLabel: 'SELLER_CONFIGURATIONS.FIELDS.VALUE', visible: true, creatable: true, editable: false, inputType: 'text',
					validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'CreatedDate', type: 'text', displayLabel: 'SELLER_CONFIGURATIONS.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'UpdatedDate', type: 'text', displayLabel: 'SELLER_CONFIGURATIONS.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'DefaultValueType', type: 'text', displayLabel: 'SELLER_CONFIGURATIONS.FIELDS.DEFAULT_VALUE_TYPE', visible: true, creatable: false, editable: false, inputType: 'text',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'CreatedBy', type: 'text', displayLabel: 'SELLER_CONFIGURATIONS.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'UpdatedBy', type: 'text', displayLabel: 'SELLER_CONFIGURATIONS.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
			],
			title: 'SELLER_CONFIGURATIONS.NAV',
			icon: 'icon-checkerboard',
			idField: 'ConfigId',
			lookupDisplayField: 'Name',
			isDirty: false,
			isBulkActionCompleted: false,
			methods: {
			},
			views: {
				mainList: {},
				mainDetails: {},
				privileges: {
					list: 'GetSellerSpecificConfigurations'
				}
			}

		};

		function getConfigurations(generalProperties, sellerId, model) {
			if (angular.isDefined(model)) { // to skip this part for load lookup
				model.isBulkActionCompleted = false;
			}
			var promise;

			if(angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
				var state = {};
				state.name = $state.current.name;
				state.params = $state.params;
				var isBulk = true;
				var logData = activityLogger.createLogData(null, state, 'sellers.configurations', 'VIEW', isBulk, new Date(), null, null);
				promise = api.webGet(api.baseUrl + '/sellers/' + sellerId + '/sellerConfigurations', undefined, true, generalProperties.forceFetch);
				promise = activityLogger.log(logData, promise);
			}
			else {
				sellerId = angular.isUndefined(sellerId) ? catalogFactory.getActiveCatalog().CatalogCode : sellerId;
				promise = api.webGet(api.baseUrl + '/sellers/' + sellerId + '/sellerConfigurations', undefined, true, generalProperties.forceFetch);
			}

			promise.then(function() {
				if (api.sellers.configurations.isDirty) {
					//Invalidate lookupData
					api.sellers.configurations.lookupData = undefined;
					api.sellers.configurations.isDirty = false;
				}
			});
			return promise;
		}

		function createConfiguration(item, sellerId) {
			var state = {};
			state.name = $state.current.name;
			state.params = $state.params;
			var logData = activityLogger.createLogData(item[api.sellers.configurations.lookupDisplayField], state, 'sellers.configurations', 'ADD', false, new Date(), null, null);
			var promise = api.webPost(api.baseUrl + '/sellers/' + sellerId + '/sellerConfigurations', item);
			promise.then(function() {
				api.sellers.configurations.isDirty = true;
				$rootScope.$emit('CatalogsUpdatedEvent');
			});
			return activityLogger.log(logData, promise);
		}

		function updateConfiguration(item, itemId, sellerId) {
			var state = {};
			state.name = $state.current.name;
			state.params = $state.params;
			var logData = activityLogger.createLogData(item[api.sellers.configurations.lookupDisplayField], state, 'sellers.configurations', 'EDIT', false, new Date(), null, null);
			var promise = api.webPut(api.baseUrl + '/sellers/' + sellerId + '/sellerConfigurations/' + itemId, item);
			promise.then(function() {
				api.sellers.configurations.isDirty = true;
				$rootScope.$emit('CatalogsUpdatedEvent');
			});
			return activityLogger.log(logData, promise);
		}

		function deleteConfiguration(records, actionType, sellerId) {
			var data = { requestObj: [], itemNameList: [] }
			var isBulk = true;
			if(!angular.isArray(records)) {
				records = [records];
				isBulk = false;
			}
			angular.forEach(records, function(record) {
				data.itemNameList.push(record[api.sellers.configurations.lookupDisplayField]);
				data.requestObj.push( { CongigurationId: record[api.sellers.configurations.idField] } );
			});
			var state = {};
			state.name = $state.current.name;
			state.params = $state.params;
			var logData = activityLogger.createLogData(data.itemNameList, state, 'sellers.configurations', actionType.toUpperCase(), isBulk, new Date(), null, null);
			var promise = api.webDelete(api.baseUrl + '/sellers/' + sellerId + '/sellerConfigurations', data.requestObj);
			promise.then(function() {
				api.sellers.configurations.isDirty = true;
				$rootScope.$emit('CatalogsUpdatedEvent');
			});
			return activityLogger.log(logData, promise);
		}

		function createBulk(model, data, sellerId) {
			var jobIndex = jobsTracker.addJob(model, 'SELLER_CONFIGURATIONS.ACTIONS.IMPORT_CONFIGURATIONS', 1, api.sellers.configurations);
			api.webPut(api.baseUrl + '/sellers/' + sellerId + '/sellerConfigurations', data).then(function(response) {
				jobsTracker.setCompleted(jobIndex, response);
			}).catch(function(error) {
				jobsTracker.setCriticlaFail(jobIndex, error);
			});
		}
	}
})();
(function() {
		'use strict';

		angular
				.module('app.main.accounts.sellers.seller-datasets')
				.run(runBlock);

		/* @ngInject */
	function runBlock(api, $state, activityLogger, $rootScope, crud, catalogFactory, jobsTracker) {
				if(angular.isUndefined(api.sellers)) {
						api.sellers = {};
				}

				api.sellers.datasets = {
						modelPath: 'sellers.datasets',
						fields: [
								{ field: 'Id', type: 'int', displayLabel: 'SELLER_DATASETS.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
									validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'Name', type: 'text', displayLabel: 'SELLER_DATASETS.FIELDS.NAME', visible: true, creatable: true, editable: true, showInEdit: true, inputType: 'text', checkIfUnique: true,
									validation: {isRequired: true, maxLen: 500, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'Code', type: 'text', displayLabel: 'SELLER_DATASETS.FIELDS.CODE', visible: true, creatable: true, editable: true, showInEdit: true, inputType: 'text', checkIfUnique: true,
									validation: {isRequired: true, maxLen: 100, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'DisplayValueExpression', type: 'text', displayLabel: 'SELLER_DATASETS.FIELDS.DISPLAY_VALUE_EXPRESSION', visible: true, creatable: true, editable: true, showInEdit: true, inputType: 'textArea',
									validation: {isRequired: true, maxLen: 1000, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'AttributesIds', type: 'int', displayLabel: 'SELLER_DATASETS.FIELDS.ATTRIBUTES', visible: true, creatable: true, editable: true, inputType: 'lookup-many', lookupSource: 'attributes.attributes',
									validation: {isRequired: true, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'Attributes', type: 'int', displayLabel: 'SELLER_DATASETS.FIELDS.ATTRIBUTES', visible: false, creatable: false, editable: false, inputType: 'text',
									validation: {isRequired: true, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								// { field: 'Values', type: 'text', displayLabel: 'SELLER_DATASETS.FIELDS.VALUES', visible: false, creatable: false, editable: false, inputType: 'text',
								// 	validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'Status', type: 'text', displayLabel: 'SELLER_DATASETS.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
									validation: {isRequired: false, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'CreatedDate', type: 'text', displayLabel: 'SELLER_DATASETS.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
									validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'UpdatedDate', type: 'text', displayLabel: 'SELLER_DATASETS.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
									validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'CreatedBy', type: 'text', displayLabel: 'SELLER_DATASETS.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
									validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'UpdatedBy', type: 'text', displayLabel: 'SELLER_DATASETS.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
									validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
						],

						title: 'SELLER_DATASETS.NAV',
						icon: '',
						idField: 'Id',
						lookupDisplayField: 'Name',
						methods: {
								getList         :   getDatasetDefinitions,
								getDetails      :   getDatasetDefinitionDetails,
								create          :   createDatasetDefinition,
								update          :   updateDatasetDefinition,
								activateBulk    :   activateDatasetDefinitions,
						},
						views: {
								mainList: {
										columns             : [ 'Id', 'Name', 'Code', 'DisplayValueExpression', 'Attributes', 'Status', 'UpdatedBy', 'UpdatedDate' ],
										columnFilter        : {},
										topIndex            : 0,
										showFilterRow       : false,
										sortColumn          : {'UpdatedDate': false},
										itemActions         : [
																						{ id: 'view', label: 'ACTIONS.VIEW', icon: 'icon-magnify', privilege: 'GetDatasetDefinitionDetails', disabled: false, visible: true },
																						{ id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UpdateDatasetDefinition', disabled: false, visible: true },
																						{ id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateDatasetDefinitionStatus', disabled: false, visible: 'itm.Status',
																								requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
																						{ id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateDatasetDefinitionStatus', disabled: false, visible: '!itm.Status',
																								requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
																					],
										listActions         : [
																						{ id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateDatasetDefinitionStatus', disabled: '{selected: true, Status: 1}',
																								visible: true, requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
																						{ id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateDatasetDefinitionStatus', disabled: '{selected: true, Status: 0}',
																								visible: true, requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
																					],
										fabAction           : {id: 'add', label: 'ACTIONS.ADD', icon: 'icon-plus', privilege: 'CreateDatasetDefinition:true', visible: true}
								},
								mainDetails: {},
								privileges: {
										list: 'GetDatasetDefinitions',
										details: 'GetDatasetDefinitionDetails'
								}
						}
				};

				function getDatasetDefinitions(generalProperties, sellerId) {
						sellerId = angular.isDefined(sellerId) ? sellerId : catalogFactory.getActiveCatalog().AccountId;
						var promise;
						if (angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
								var state = {};
								state.name = $state.current.name;
								state.params = $state.params;
								var isBulk = true;
								var logData = activityLogger.createLogData(null, state, 'sellers.datasets', 'VIEW', isBulk, new Date(), null, null);
								promise = api.webGet(api.t1v2URL + '/sellers/' + sellerId + '/datasets', undefined, true, generalProperties.forceFetch);
								promise = activityLogger.log(logData, promise);
						}
						else {
								promise = api.webGet(api.t1v2URL + '/sellers/' + sellerId + '/datasets', undefined, true, generalProperties.forceFetch);
						}

						promise.then(function () {
								if (api.sellers.datasets.isDirty) {
										//Invalidate lookupData
										api.sellers.datasets.lookupData = undefined;
										api.sellers.datasets.isDirty = false;
								}
								api.sellers.datasets.isBulkActionCompleted = false;
						});
						return promise;
				}

				function getDatasetDefinitionDetails(isLogRequired, datasetId, sellerId) {
					var promise;
					if(angular.isDefined(isLogRequired) && isLogRequired === true) {
						var state = {};
						state.name = $state.current.name;
						state.params = $state.params;
						var isBulk = false;
						var items = [];
						promise = api.webGet(api.t1v2URL + '/sellers/' + sellerId + '/datasets/' + datasetId);
						promise.then(function(response) {
							items.push(response.data[api.sellers.datasets.lookupDisplayField]);
						});
						var logData = activityLogger.createLogData(items, state, 'sellers.datasets', 'VIEW', isBulk, new Date(), null, null);
						promise = activityLogger.log(logData, promise);
					}
					else {
						promise = api.webGet(api.t1v2URL + '/sellers/' + sellerId + '/datasets/' + datasetId);
					}
					return promise;
				}

				function createDatasetDefinition(dataset, sellerId) {
						var state = {};
						state.name = $state.current.name;
						state.params = $state.params;
						var logData = activityLogger.createLogData(dataset[api.sellers.datasets.lookupDisplayField], state, 'sellers.datasets', 'ADD', false, new Date(), null, null);
						var promise = api.webPost(api.t1v2URL + '/sellers/' + sellerId + '/datasets', dataset);

						promise.then(function() {
								api.sellers.datasets.isDirty = true;
								$rootScope.$emit('CatalogsUpdatedEvent');
						});
						return activityLogger.log(logData, promise);
				}

				function updateDatasetDefinition(datasetId, record, sellerId) {
					var jobIndex = jobsTracker.addJob(api.sellers.datasets, 'SELLER_DATASETS.MESSAGES.UPDATE_DEFINITION', 1);
					var state = {};
					state.name = $state.current.name;
					state.params = $state.params;
					var logData = activityLogger.createLogData(record[api.sellers.datasets.lookupDisplayField], state, 'sellers.datasets', 'EDIT', false, new Date(), null, null);
					var promise = api.webPut(api.baseUrl + '/sellers/' + sellerId + '/datasets/' + datasetId, record);

					promise.then(function (response) {
						jobsTracker.trackJob(jobIndex, response.data.Id);
					}).catch(function(error) {
						jobsTracker.setCriticlaFail(jobIndex, error);
					});
					return activityLogger.log(logData, promise);
				}

				function activateDatasetDefinitions(records, model, actionType, sellerId) {
					var result = crud.createRequestObject(records, model, actionType);
					var state = {};
					state.name = $state.current.name;
					state.params = $state.params;
					var isBulk = result.itemsNameList.length > 1 ? true : false;
					var logData = activityLogger.createLogData(result.itemsNameList, state, 'sellers.datasets', actionType.toUpperCase(), isBulk, new Date(), null, null);
					var promise = api.webPut(api.t1v2URL + '/sellers/' + sellerId + '/datasets/status', result.requestObj);

					promise.then(function () {
						api.sellers.datasets.isDirty = true;
					});

					return activityLogger.log(logData, promise);
				}

		}
})();
(function() {
		'use strict';

		angular
				.module('app.main.accounts.sellers.seller-colors', [])
				.config(config);

		/* @ngInject */
		function config($translatePartialLoaderProvider) {

				// Translation
				$translatePartialLoaderProvider.addPart('app/main/accounts/sellers/details/tabs/seller-colors');
		}
})();
(function() {
		'use strict';

		angular
				.module('app.main.accounts.sellers.seller-colors')
				.run(runBlock);

		/* @ngInject */
		function runBlock(api, activityLogger, $state, catalogFactory) {

		if(angular.isUndefined(api.sellers)) {
			api.sellers = {};
		}

		api.sellers.sellerColors = {
					modelPath: 'sellers.sellerColors',
					fields: [
							{ field: 'ColorId', type: 'int', displayLabel: 'SELLER_COLORS.FIELDS.COLOR_ID', visible: true, creatable: false, editable: false, inputType: 'number',
									validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
							{ field: 'ColorName', type: 'text', displayLabel: 'SELLER_COLORS.FIELDS.COLOR_NAME', visible: true, creatable: true, editable: true, inputType: 'text', checkIfUnique: true,
									validation: {isRequired: true, maxLen: 100, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
							{ field: 'Code', type: 'int', displayLabel: 'SELLER_COLORS.FIELDS.COLOR_CODE', visible: true, creatable: true, editable: true, inputType: 'number', prefixZeros: 3,
									validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '^(0*[1-9][0-9]{0,2}|100|999)$', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: 'VALIDATIONS.CODE_POSITIVE_NUMBER'}} },
							{ field: 'ColorType', type: 'text', displayLabel: 'SELLER_COLORS.FIELDS.COLOR_TYPE', visible: true, creatable: true, editable: true, inputType: 'lookup', lookupSource:'lists.ColorTypes',
									validation: {isRequired: false, maxLen: 10, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
							{ field: 'ColorAssetId', type: 'text', displayLabel: 'SELLER_COLORS.FIELDS.COLOR_ASSET_ID', visible: true, creatable: true, editable: true, inputType: 'text',
									validation: {isRequired: 'vm.record.ColorType === "Pattern"', maxLen: 36, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
							{ field: 'HexCode', type: 'text', displayLabel: 'SELLER_COLORS.FIELDS.HEXCODE', visible: false, creatable: true, editable: true, inputType: 'text',
									validation: {isRequired: false, maxLen: 7, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
							{ field: 'HexCode',  map:'HexCode', type: 'text', displayLabel: 'ARTICLES.FIELDS.HEXCODE', visible: true, creatable: false, editable: false, inputType: 'color-picker',
									validation: {isRequired: false, maxLen: 7, minLen: 0, pattern: '^#(?:[0-9a-fA-F]{3}){2}$', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: 'COLOR_DEFINITION.VALIDATIONS.INVALID'}} },
							{ field: 'ColorGroup', type: 'text', displayLabel: 'SELLER_COLORS.FIELDS.COLOR_GROUP', visible: true, creatable: true, editable: true, inputType: 'text',
									validation: {isRequired: false, maxLen: 250, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
							{ field: 'CreatedDate', type: 'text', displayLabel: 'SELLER_COLORS.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
									validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
							{ field: 'UpdatedDate', type: 'text', displayLabel: 'SELLER_COLORS.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
									validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
							{ field: 'CreatedBy', type: 'text', displayLabel: 'SELLER_COLORS.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
									validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
							{ field: 'UpdatedBy', type: 'text', displayLabel: 'SELLER_COLORS.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
									validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
					],
					uniqueConstraints: [
						{name: 'Constraint 1', fields: ['ColorName', 'Code']}
					],
					title: 'SELLER_COLORS.NAV',
					icon: 'icon-image-filter-black-white',
					idField: 'ColorId',
					lookupDisplayField: 'ColorName',
					isDirty: false,
					isCatalogSpecificModel: true,
					methods: {
							getList         :   getSellerColors,
							create          :   createSellerColor,
							update          :   updateSellerColor,
							createBulk      :   createBulkSellerColors,
					},
					views: {
							mainList: {
									columns         : [ 'ColorId', 'ColorName', 'Code', 'HexCode', 'ColorGroup', 'UpdatedBy', 'UpdatedDate'],
									columnFilter    : {},
									topIndex        : 0,
									showFilterRow   : false,
									sortColumn      : {'UpdatedDate': false},
									itemActions     : [
																			{ id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UpdateSellerColors', disabled: false, visible: true },
																		],
									listActions     : [
																			{ id: 'import', label: 'ACTIONS.IMPORT', icon: 'icon-import', privilege: 'CreateSellerColors:true', disabled: false, visible: true, requiresConfirmation: false}
																		],
									fabAction       : { id: 'add', label: 'ACTIONS.ADD', icon: 'icon-plus', privilege: 'CreateSellerColors:true', visible: true }
							},
							mainDetails: {},
							privileges: {
									list    : 'GetSellerColors'
							}
					}
			};

			function getSellerColors(generalProperties, sellerId) {
					var promise;
					var sellerId = angular.isUndefined(sellerId) ? catalogFactory.getActiveCatalog().AccountId : sellerId;

					if (angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
							promise = api.webGet(api.baseUrl + '/sellers/' + sellerId + '/colors', undefined, true, generalProperties.forceFetch);
					}
					else {
							promise = api.webGet(api.baseUrl + '/sellers/' + sellerId + '/colors', undefined, true, generalProperties.forceFetch);
					}

					promise.then(function () {
							if (api.sellers.sellerColors.isDirty) {
									//Invalidate lookupData
									api.sellers.sellerColors.lookupData = undefined;
									api.sellers.sellerColors.isDirty = false;
							}
					});
					return promise;
			}

			function createSellerColor(record, sellerId) {
				var state = {};
				state.name = $state.current.name;
				state.params = $state.params;
				var logData = activityLogger.createLogData(record[api.sellers.sellerColors.lookupDisplayField], state, 'sellers.sellerColors', 'ADD', false, new Date(), null, null);
				var promise = api.webPut(api.baseUrl + '/sellers/' + sellerId + '/colors', [record]);

				promise.then(function () {
					api.sellers.sellerColors.isDirty = true;
					api.catalogs.articles.isDirty = true;
				});
				return activityLogger.log(logData, promise);
			}

			function updateSellerColor(Id, color, sellerId) {
				var state = {};
				state.name = $state.current.name;
				state.params = $state.params;
				var logData = activityLogger.createLogData(color[api.sellers.sellerColors.lookupDisplayField], state, 'sellers.sellerColors', 'EDIT', false, new Date(), null, null);
				var promise = api.webPut(api.baseUrl + '/sellers/' + sellerId + '/colors/' + Id, color);

				promise.then(function () {
					api.sellers.sellerColors.isDirty = true;
					api.catalogs.articles.isDirty = true;
				});
				return activityLogger.log(logData, promise);
			}

			function createBulkSellerColors(records, sellerId) {
				var state = {};
				state.name = $state.current.name;
				state.params = $state.params;
				var logData = activityLogger.createLogData(null, state, 'sellers.sellerColors', 'ADD', false, new Date(), null, null);
				var promise = api.webPut(api.baseUrl + '/sellers/' + sellerId + '/colors', records);

				promise.then(function () {
					api.sellers.sellerColors.isDirty = true;
					api.catalogs.articles.isDirty = true;
				});
				return activityLogger.log(logData, promise);
			}
	}
})();
(function() {
    'use strict';
    
    angular
        .module('app.main.accounts.sellers.seasonless-model-attributes',[])
        .config(config);

        /* @ngInject */
        function config($translatePartialLoaderProvider) {

                // Translation
                $translatePartialLoaderProvider.addPart('app/main/accounts/sellers/details/tabs/seasonless-model-attributes');
        }
})();
(function() {
		'use strict';

		angular
				.module('app.main.accounts.sellers.seasonless-model-attributes')
				.run(runBlock);

		/* @ngInject */
		function runBlock(api, $state, activityLogger, crud, $rootScope) {

				if(angular.isUndefined(api.sellers)) {
						api.sellers = {};
				}

				api.sellers.seasonlessModelAttributes = {
						modelPath: 'sellers.seasonlessModelAttributes',
						fields: [
								{ field: 'AttributeGroupId', type: 'int', displayLabel: 'SEASONLESS_MODEL_ATTRIBUTES.FIELDS.ATTRIBUTE_GROUP_NAME', visible: true, creatable: true, editable: false, inputType: 'lookup', lookupSource: 'attributes.attributeGroups',
										validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', disabledCriteria: '', onChangeLookUp: 'lists.availableSeasonlessModelAttributeList,AttributeGroupId', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'Attributeid', type: 'text', displayLabel: 'SEASONLESS_MODEL_ATTRIBUTES.FIELDS.ATTRIBUTE', visible: false, creatable: true, editable: false, inputType: 'lookup', lookupSource: 'lists.availableSeasonlessModelAttributeList',
										validation: {isRequired: true, maxLen: -1, minLen: 0, pattern: '', disabledCriteria: '!vm.record.AttributeGroupId', onChangeLookUpSetValue: 'AttributeTypeId,AttributeTypeId', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'Attributeid', type: 'int', displayLabel: 'SEASONLESS_MODEL_ATTRIBUTES.FIELDS.ATTRIBUTE_ID', visible: true, creatable: false, editable: false, inputType: 'number',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'AttributeDisplayName', type: 'text', displayLabel: 'SEASONLESS_MODEL_ATTRIBUTES.FIELDS.NAME', visible: true, creatable: false, editable: false, showInEdit: true, inputType: 'text',
										validation: {isRequired: true, maxLen: 200, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'AttributeSystemName', type: 'text', displayLabel: 'SEASONLESS_MODEL_ATTRIBUTES.FIELDS.SYSTEM_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
										validation: {isRequired: false, maxLen: 128, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'AttributeTypeId', type: 'int', displayLabel: 'SEASONLESS_MODEL_ATTRIBUTES.FIELDS.ATTRIBUTE_TYPE_ID', visible: true, creatable: false, editable: false, inputType: 'number',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'InitialValueAttribute', type: 'text', displayLabel: 'SEASONLESS_MODEL_ATTRIBUTES.FIELDS.INITIAL_VALUE_ATTRIBUTE', visible: true, creatable: false, editable: false, inputType: 'text',
										validation: {isRequired: false, maxLen: 100, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'AllowedValues', type: 'text', displayLabel: 'SEASONLESS_MODEL_ATTRIBUTES.FIELDS.ALLOWED_VALUES', visible: true, creatable: true, editable: true, inputType: 'tags', tagSeparator: '|', importable:'true',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', disabledCriteria: 'vm.record.AttributeTypeId === 12', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: 'Invalid value, pipe ( | ) is not allowed'}} },
								{ field: 'ValidationExpression', type: 'text', displayLabel: 'SEASONLESS_MODEL_ATTRIBUTES.FIELDS.VALIDATION_EXPRESSION', visible: true, creatable: false, editable: false, inputType: 'textArea',
										validation: {isRequired: false, maxLen: 100, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'ValidationMessage', type: 'text', displayLabel: 'SEASONLESS_MODEL_ATTRIBUTES.FIELDS.VALIDATION_MESSAGE', visible: true, creatable: false, editable: false, inputType: 'textArea',
										validation: {isRequired: false, maxLen: 200, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'Criteria', type: 'text', displayLabel: 'SEASONLESS_MODEL_ATTRIBUTES.FIELDS.CRITERIA', visible: true, creatable: true, editable: true, inputType: 'textArea',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', disabledCriteria: 'vm.record.AttributeTypeId === 12', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'AllowedValuesV2', type: 'text', displayLabel: 'SEASONLESS_MODEL_ATTRIBUTES.FIELDS.ALLOWED_VALUES_V2', visible: true, creatable: true, editable: true, inputType: 'textArea',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', checkIfValidJson: true, disabledCriteria: 'vm.record.AttributeTypeId === 12', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '', isValidJson: 'VALIDATIONS.INVALID_JSON'}} },
								{ field: 'CriteriaV2', type: 'text', displayLabel: 'SEASONLESS_MODEL_ATTRIBUTES.FIELDS.CRITERIA_V2', visible: true, creatable: true, editable: true, inputType: 'textArea',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', disabledCriteria: 'vm.record.AttributeTypeId === 12', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'IsSeasonless', type: 'text', displayLabel: 'SEASONLESS_MODEL_ATTRIBUTES.FIELDS.IS_SEASONLESS_ARTICLE_ATTRIBUTES', visible: true, creatable: false, editable: false, inputType: 'bool-int',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'IsSeasonlessModelAttribute', type: 'text', displayLabel: 'SEASONLESS_MODEL_ATTRIBUTES.FIELDS.IS_SEASONLESS_MODEL_ATTRIBUTES', visible: true, creatable: false, editable: false, inputType: 'bool-int',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'IsRequired', type: 'text', displayLabel: 'SEASONLESS_MODEL_ATTRIBUTES.FIELDS.IS_REQUIRED', visible: true, creatable: false, editable: false, inputType: 'bool',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'Editable', type: 'text', displayLabel: 'SEASONLESS_MODEL_ATTRIBUTES.FIELDS.EDITABLE', visible: true, creatable: false, editable: false, inputType: 'bool',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'Creatable', type: 'text', displayLabel: 'SEASONLESS_MODEL_ATTRIBUTES.FIELDS.CREATEABLE', visible: true, creatable: false, editable: false, inputType: 'bool',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'Visible', type: 'text', displayLabel: 'SEASONLESS_MODEL_ATTRIBUTES.FIELDS.VISIBLE', visible: true, creatable: false, editable: false, inputType: 'bool',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'VisibleInListByDefault', type: 'text', displayLabel: 'SEASONLESS_MODEL_ATTRIBUTES.FIELDS.VISIBLE_IN_LIST_DEFAULT', visible: true, creatable: false, editable: false, inputType: 'bool',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'ShowInEdit', type: 'text', displayLabel: 'SEASONLESS_MODEL_ATTRIBUTES.FIELDS.SHOW_IN_EDIT', visible: true, creatable: false, editable: false, inputType: 'bool',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'SupportFilterLookup', type: 'text', displayLabel: 'SEASONLESS_MODEL_ATTRIBUTES.FIELDS.SUPPORT_FILTER_LOOKUP', visible: true, creatable: false, editable: false, inputType: 'bool',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'CreatedDate', type: 'text', displayLabel: 'SEASONLESS_MODEL_ATTRIBUTES.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'UpdatedDate', type: 'text', displayLabel: 'SEASONLESS_MODEL_ATTRIBUTES.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'AttributeTypeName', type: 'text', displayLabel: 'SEASONLESS_MODEL_ATTRIBUTES.FIELDS.ATTRIBUTE_TYPE_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
										validation: {isRequired: false, maxLen: 25, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'AttributeSource', type: 'text', displayLabel: 'SEASONLESS_MODEL_ATTRIBUTES.FIELDS.ATTRIBUTE_SOURCE', visible: true, creatable: false, editable: false, inputType: 'text',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'SortOrder', type: 'int', displayLabel: 'SEASONLESS_MODEL_ATTRIBUTES.FIELDS.SORT_ORDER', visible: true, creatable: false, editable: false, inputType: 'number',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'Status', type: 'text', displayLabel: 'SEASONLESS_MODEL_ATTRIBUTES.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
										validation: {isRequired: false, maxLen: 25, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'CreatedBy', type: 'text', displayLabel: 'SEASONLESS_MODEL_ATTRIBUTES.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'UpdatedBy', type: 'text', displayLabel: 'SEASONLESS_MODEL_ATTRIBUTES.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'AttributeSize', type: 'int', displayLabel: 'SEASONLESS_MODEL_ATTRIBUTES.FIELDS.ATTRIBUTE_SIZE', visible: true, creatable: false, editable: false, inputType: 'number',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'DefaultValue', type: 'text', displayLabel: 'ATTRIBUTES.FIELDS.DEFAULT_VALUE', visible: true, creatable: false, editable: false, inputType: 'textArea',
										validation: {isRequired: false, maxLen: 4000, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
						],

						title: 'SEASONLESS_MODEL_ATTRIBUTES.NAV',
						icon: 'icon-dice-1',
						idField: 'Attributeid',
						lookupDisplayField: 'AttributeDisplayName',
						methods: {
								getList         :   getSeasonlessModelAttributes,
								create          :   assignSeasonlessModelAttributes,
								update          :   editSeasonlessModelAttributes,
								activateBulk    :   activateSeasonlessModelAttributes,
						},
						views: {
								mainList: {
										columns             : [ 'AttributeDisplayName', 'AttributeSystemName', 'AttributeGroupId', 'UpdatedDate', 'AttributeTypeName', 'IsRequired' ],
										columnFilter        : {},
										topIndex            : 0,
										showFilterRow       : false,
										sortColumn          : {'SortOrder': true},
										itemActions         : [
																						{ id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UpdateSeasonlessModelAttributes', disabled: 'itm.AttributeSource !== "Self"', visible: true},
																						{ id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateSeasonlessModelAttributeStatus', disabled: 'itm.AttributeSource !== "Self"', visible: 'itm.Status',
																								requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
																						{ id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateSeasonlessModelAttributeStatus', disabled: 'itm.AttributeSource !== "Self"', visible: '!itm.Status',
																								requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
																					],
										listActions         : [
																						{ id: 'delete', label: 'ACTIONS.DELETE_BULK', icon: 'icon-delete', privilege: 'UpdateSeasonlessModelAttributeStatus', disabled: '{selected: true, Status: 1, AttributeSource :"Self"}', visible: true,
																								requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
																						{ id: 'activate', label: 'ACTIONS.ACTIVATE_BULK', icon: 'icon-undo-variant', privilege: 'UpdateSeasonlessModelAttributeStatus', disabled: '{selected: true, Status: 0, AttributeSource :"Self"}', visible: true,
																								requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
																					],
										fabAction           : {id: 'add', label: 'ACTIONS.ADD', icon: 'icon-link', privilege: 'AssignSeasonlessModelAttributes:true', visible: true}
								},
								mainDetails: {},
								privileges: {
										list: 'GetSeasonlessModelAttributes'
								}
						}
				};

				function getSeasonlessModelAttributes(generalProperties, accountId, attributeGroupId) {
						var promise;
						if (angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
								var state = {};
								state.name = $state.current.name;
								state.params = $state.params;
								var isBulk = true;
								var logData = activityLogger.createLogData(null, state, 'sellers.seasonlessModelAttributes', 'VIEW', isBulk, new Date(), null, null);
								promise = api.webGet(api.baseUrl + '/sellers/' + accountId + '/' + attributeGroupId + '/modellevelseasonlessattributes', undefined, true, generalProperties.forceFetch);
								promise = activityLogger.log(logData, promise);
						}
						else {
								promise = api.webGet(api.baseUrl + '/sellers/' + accountId + '/' + attributeGroupId + '/modellevelseasonlessattributes', undefined, true, generalProperties.forceFetch);
						}

						promise.then(function () {
								if (api.sellers.seasonlessModelAttributes.isDirty) {
										//Invalidate lookupData
										api.sellers.seasonlessModelAttributes.lookupData = undefined;
										api.sellers.seasonlessModelAttributes.isDirty = false;
								}
						});
						return promise;
				}

				function assignSeasonlessModelAttributes(attribute, accountId) {
						var requestObject = {
							'AttributeId': attribute.Attributeid,
							'AttributeGroupId': attribute.AttributeGroupId,
							'Values': attribute.AllowedValues,
							'Criteria': angular.isDefined(attribute.Criteria) ? attribute.Criteria : '',
							'CriteriaV2': angular.isDefined(attribute.CriteriaV2) ? attribute.CriteriaV2 : '',
							'AllowedValuesV2': angular.isDefined(attribute.AllowedValuesV2) ? attribute.AllowedValuesV2 : '',
						}
						var state = {};
						state.name = $state.current.name;
						state.params = $state.params;
						var logData = activityLogger.createLogData(attribute[api.sellers.seasonlessAttributes.lookupDisplayField], state, 'attributes.attributes', 'ADD', false, new Date(), null, null);
						var promise = api.webPost(api.baseUrl + '/sellers/' + accountId + '/' + attribute.AttributeGroupId + '/modellevelseasonlessattributes', requestObject);

						promise.then(function() {
								api.sellers.seasonlessModelAttributes.isDirty = true;
								$rootScope.$emit('CatalogsUpdatedEvent');
						});
						return activityLogger.log(logData, promise);
				}

				function editSeasonlessModelAttributes(undefined, attribute, accountId) {
						var requestObject = {
							'AttributeId': attribute.Attributeid,
							'AttributeGroupId': attribute.AttributeGroupId,
							'Values': attribute.AllowedValues,
							'Criteria': angular.isDefined(attribute.Criteria) ? attribute.Criteria : '',
							'CriteriaV2': angular.isDefined(attribute.CriteriaV2) ? attribute.CriteriaV2 : '',
							'AllowedValuesV2': angular.isDefined(attribute.AllowedValuesV2) ? attribute.AllowedValuesV2 : '',
						}
						var promise = api.webPut(api.baseUrl + '/sellers/' + accountId + '/' + attribute.AttributeGroupId + '/modellevelseasonlessattributes', [requestObject]);
						promise.then(function () {
								api.sellers.seasonlessModelAttributes.isDirty = true;
								$rootScope.$emit('CatalogsUpdatedEvent');
						});
						return promise;
				}

				function activateSeasonlessModelAttributes(records, model, actionType, accountId) {
						var result = crud.createRequestObject(records, model, actionType, {isSeasonlessAttributes : true});
						var state = {};
						state.name = $state.current.name;
						state.params = $state.params;
						var isBulk = result.itemsNameList.length > 1 ? true : false;
						var logData = activityLogger.createLogData(result.itemsNameList, state, 'sellers.seasonlessModelAttributes', actionType.toUpperCase(), isBulk, new Date(), null, null);
						var promise = api.webPut(api.baseUrl + '/sellers/' + accountId + '/modellevelseasonlessattributes/status', result.requestObj);

						promise.then(function() {
								crud.onRecordStatusChange(records, model, actionType);
						});

						return activityLogger.log(logData, promise);
				}

		}
})();
(function() {
    'use strict';
    
    angular
        .module('app.main.accounts.sellers.seasonless-attributes',[])
        .config(config);

        /* @ngInject */
        function config($translatePartialLoaderProvider) {

                // Translation
                $translatePartialLoaderProvider.addPart('app/main/accounts/sellers/details/tabs/seasonless-attributes');
        } 
})();
(function() {
		'use strict';

		angular
				.module('app.main.accounts.sellers.seasonless-attributes')
				.run(runBlock);

		/* @ngInject */
		function runBlock(api, $state, activityLogger, crud, $rootScope) {

				if(angular.isUndefined(api.sellers)) {
						api.sellers = {};
				}

				api.sellers.seasonlessAttributes = {
						modelPath: 'sellers.seasonlessAttributes',
						fields: [
								{ field: 'AttributeGroupId', type: 'int', displayLabel: 'SEASONLESS_ARTICLE_ATTRIBUTES.FIELDS.ATTRIBUTE_GROUP_NAME', visible: true, creatable: true, editable: false, inputType: 'lookup', lookupSource: 'attributes.attributeGroups',
										validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', disabledCriteria: '', onChangeLookUp: 'lists.availableSeasonlessAttributeList,AttributeGroupId', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								// onChangeLookUp is used to load data for another field with current fields value parameters are lookup source of related fields and current field name
								{ field: 'Attributeid', type: 'text', displayLabel: 'SEASONLESS_ARTICLE_ATTRIBUTES.FIELDS.ATTRIBUTE', visible: false, creatable: true, editable: false, inputType: 'lookup', lookupSource: 'lists.availableSeasonlessAttributeList',
										validation: {isRequired: true, maxLen: -1, minLen: 0, pattern: '', disabledCriteria: '!vm.record.AttributeGroupId', onChangeLookUpSetValue: 'AttributeTypeId,AttributeTypeId', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'Attributeid', type: 'int', displayLabel: 'SEASONLESS_ARTICLE_ATTRIBUTES.FIELDS.ATTRIBUTE_ID', visible: true, creatable: false, editable: false, inputType: 'number',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'AttributeDisplayName', type: 'text', displayLabel: 'SEASONLESS_ARTICLE_ATTRIBUTES.FIELDS.NAME', visible: true, creatable: false, editable: false, showInEdit: true, inputType: 'text',
										validation: {isRequired: true, maxLen: 200, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'AttributeSystemName', type: 'text', displayLabel: 'SEASONLESS_ARTICLE_ATTRIBUTES.FIELDS.SYSTEM_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
										validation: {isRequired: false, maxLen: 128, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'AttributeTypeId', type: 'int', displayLabel: 'SEASONLESS_ARTICLE_ATTRIBUTES.FIELDS.ATTRIBUTE_TYPE_ID', visible: true, creatable: false, editable: false, inputType: 'number',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'InitialValueAttribute', type: 'text', displayLabel: 'SEASONLESS_ARTICLE_ATTRIBUTES.FIELDS.INITIAL_VALUE_ATTRIBUTE', visible: true, creatable: false, editable: false, inputType: 'text',
										validation: {isRequired: false, maxLen: 100, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'AllowedValues', type: 'text', displayLabel: 'SEASONLESS_ARTICLE_ATTRIBUTES.FIELDS.ALLOWED_VALUES', visible: true, creatable: true, editable: true, inputType: 'tags', tagSeparator: '|', importable:'true',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', disabledCriteria: 'vm.record.AttributeTypeId === 12', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: 'Invalid value, pipe ( | ) is not allowed'}} },
								{ field: 'ValidationExpression', type: 'text', displayLabel: 'SEASONLESS_ARTICLE_ATTRIBUTES.FIELDS.VALIDATION_EXPRESSION', visible: true, creatable: false, editable: false, inputType: 'textArea',
										validation: {isRequired: false, maxLen: 100, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'ValidationMessage', type: 'text', displayLabel: 'SEASONLESS_ARTICLE_ATTRIBUTES.FIELDS.VALIDATION_MESSAGE', visible: true, creatable: false, editable: false, inputType: 'textArea',
										validation: {isRequired: false, maxLen: 200, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'Criteria', type: 'text', displayLabel: 'SEASONLESS_ARTICLE_ATTRIBUTES.FIELDS.CRITERIA', visible: true, creatable: true, editable: true, inputType: 'textArea',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', disabledCriteria: 'vm.record.AttributeTypeId === 12', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'AllowedValuesV2', type: 'text', displayLabel: 'SEASONLESS_ARTICLE_ATTRIBUTES.FIELDS.ALLOWED_VALUES_V2', visible: true, creatable: true, editable: true, inputType: 'textArea',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', checkIfValidJson: true, disabledCriteria: 'vm.record.AttributeTypeId === 12', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '', isValidJson: 'VALIDATIONS.INVALID_JSON'}} },
								{ field: 'CriteriaV2', type: 'text', displayLabel: 'SEASONLESS_ARTICLE_ATTRIBUTES.FIELDS.CRITERIA_V2', visible: true, creatable: true, editable: true, inputType: 'textArea',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', disabledCriteria: 'vm.record.AttributeTypeId === 12', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'IsSeasonless', type: 'text', displayLabel: 'SEASONLESS_ARTICLE_ATTRIBUTES.FIELDS.IS_SEASONLESS_ARTICLE_ATTRIBUTES', visible: true, creatable: false, editable: false, inputType: 'bool-int',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'IsSeasonlessModelAttribute', type: 'text', displayLabel: 'SEASONLESS_ARTICLE_ATTRIBUTES.FIELDS.IS_SEASONLESS_MODEL_ATTRIBUTES', visible: true, creatable: false, editable: false, inputType: 'bool-int',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'IsRequired', type: 'text', displayLabel: 'SEASONLESS_ARTICLE_ATTRIBUTES.FIELDS.IS_REQUIRED', visible: true, creatable: false, editable: false, inputType: 'bool',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'Editable', type: 'text', displayLabel: 'SEASONLESS_ARTICLE_ATTRIBUTES.FIELDS.EDITABLE', visible: true, creatable: false, editable: false, inputType: 'bool',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'Creatable', type: 'text', displayLabel: 'SEASONLESS_ARTICLE_ATTRIBUTES.FIELDS.CREATEABLE', visible: true, creatable: false, editable: false, inputType: 'bool',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'Visible', type: 'text', displayLabel: 'SEASONLESS_ARTICLE_ATTRIBUTES.FIELDS.VISIBLE', visible: true, creatable: false, editable: false, inputType: 'bool',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'VisibleInListByDefault', type: 'text', displayLabel: 'SEASONLESS_ARTICLE_ATTRIBUTES.FIELDS.VISIBLE_IN_LIST_DEFAULT', visible: true, creatable: false, editable: false, inputType: 'bool',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'ShowInEdit', type: 'text', displayLabel: 'SEASONLESS_ARTICLE_ATTRIBUTES.FIELDS.SHOW_IN_EDIT', visible: true, creatable: false, editable: false, inputType: 'bool',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'SupportFilterLookup', type: 'text', displayLabel: 'SEASONLESS_ARTICLE_ATTRIBUTES.FIELDS.SUPPORT_FILTER_LOOKUP', visible: true, creatable: false, editable: false, inputType: 'bool',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'CreatedDate', type: 'text', displayLabel: 'SEASONLESS_ARTICLE_ATTRIBUTES.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'UpdatedDate', type: 'text', displayLabel: 'SEASONLESS_ARTICLE_ATTRIBUTES.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'AttributeTypeName', type: 'text', displayLabel: 'SEASONLESS_ARTICLE_ATTRIBUTES.FIELDS.ATTRIBUTE_TYPE_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
										validation: {isRequired: false, maxLen: 25, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'AttributeSource', type: 'text', displayLabel: 'SEASONLESS_ARTICLE_ATTRIBUTES.FIELDS.ATTRIBUTE_SOURCE', visible: true, creatable: false, editable: false, inputType: 'text',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'SortOrder', type: 'int', displayLabel: 'SEASONLESS_ARTICLE_ATTRIBUTES.FIELDS.SORT_ORDER', visible: true, creatable: false, editable: false, inputType: 'number',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'Status', type: 'text', displayLabel: 'SEASONLESS_ARTICLE_ATTRIBUTES.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
										validation: {isRequired: false, maxLen: 25, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'CreatedBy', type: 'text', displayLabel: 'SEASONLESS_ARTICLE_ATTRIBUTES.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'UpdatedBy', type: 'text', displayLabel: 'SEASONLESS_ARTICLE_ATTRIBUTES.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'AttributeSize', type: 'int', displayLabel: 'SEASONLESS_ARTICLE_ATTRIBUTES.FIELDS.ATTRIBUTE_SIZE', visible: true, creatable: false, editable: false, inputType: 'number',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'DefaultValue', type: 'text', displayLabel: 'ATTRIBUTES.FIELDS.DEFAULT_VALUE', visible: true, creatable: false, editable: false, inputType: 'textArea',
										validation: {isRequired: false, maxLen: 4000, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
						],

						title: 'SEASONLESS_ARTICLE_ATTRIBUTES.NAV',
						icon: 'icon-dice-1',
						idField: 'Attributeid',
						lookupDisplayField: 'AttributeDisplayName',
						methods: {
								getList         :   getSeasonlessAttributes,
								create          :   assignSeasonlessAttributes,
								update          :   editSeasonlessAttributes,
								activateBulk    :   activateSeasonlessAttributes,
						},
						views: {
								mainList: {
										columns             : [ 'AttributeDisplayName', 'AttributeSystemName', 'AttributeGroupId', 'UpdatedDate', 'AttributeTypeName', 'IsRequired' ],
										columnFilter        : {},
										topIndex            : 0,
										showFilterRow       : false,
										sortColumn          : {'SortOrder': true},
										itemActions         : [
																						{ id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UpdateSeasonlessAttributes', disabled: 'itm.AttributeSource !== "Self"', visible: true},
																						{ id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateSeasonlessAttributeStatus', disabled: 'itm.AttributeSource !== "Self"', visible: 'itm.Status',
																								requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
																						{ id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateSeasonlessAttributeStatus', disabled: 'itm.AttributeSource !== "Self"', visible: '!itm.Status',
																								requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
																					],
										listActions         : [
																						{ id: 'delete', label: 'ACTIONS.DELETE_BULK', icon: 'icon-delete', privilege: 'UpdateSeasonlessAttributeStatus', disabled: '{selected: true, Status: 1, AttributeSource :"Self"}', visible: true,
																								requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
																						{ id: 'activate', label: 'ACTIONS.ACTIVATE_BULK', icon: 'icon-undo-variant', privilege: 'UpdateSeasonlessAttributeStatus', disabled: '{selected: true, Status: 0, AttributeSource :"Self"}', visible: true,
																								requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
																					],
										fabAction           : {id: 'add', label: 'ACTIONS.ADD', icon: 'icon-link', privilege: 'AssignSeasonlessAttributes:true', visible: true}
								},
								mainDetails: {},
								privileges: {
										list: 'GetSeasonlessAttributes'
								}
						}
				};

				function getSeasonlessAttributes(generalProperties, accountId) {
						var promise;
						if (angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
								var state = {};
								state.name = $state.current.name;
								state.params = $state.params;
								var isBulk = true;
								var logData = activityLogger.createLogData(null, state, 'sellers.seasonlessAttributes', 'VIEW', isBulk, new Date(), null, null);
								promise = api.webGet(api.baseUrl + '/sellers/' + accountId + '/seasonlessattributes', undefined, true, generalProperties.forceFetch);
								promise = activityLogger.log(logData, promise);
						}
						else {
								promise = api.webGet(api.baseUrl + '/sellers/' + accountId + '/seasonlessattributes', undefined, true, generalProperties.forceFetch);
						}

						promise.then(function () {
								if (api.sellers.seasonlessAttributes.isDirty) {
										//Invalidate lookupData
										api.sellers.seasonlessAttributes.lookupData = undefined;
										api.sellers.seasonlessAttributes.isDirty = false;
								}
						});
						return promise;
				}

				function assignSeasonlessAttributes(attribute, accountId) {
						var requestObject = {
							'AttributeId': attribute.Attributeid,
							'AttributeGroupId': attribute.AttributeGroupId,
							'Values': attribute.AllowedValues,
							'Criteria': angular.isDefined(attribute.Criteria) ? attribute.Criteria : '',
							'CriteriaV2': angular.isDefined(attribute.CriteriaV2) ? attribute.CriteriaV2 : '',
							'AllowedValuesV2': angular.isDefined(attribute.AllowedValuesV2) ? attribute.AllowedValuesV2 : '',
						}
						var state = {};
						state.name = $state.current.name;
						state.params = $state.params;
						var logData = activityLogger.createLogData(attribute[api.sellers.seasonlessAttributes.lookupDisplayField], state, 'attributes.attributes', 'ADD', false, new Date(), null, null);
						var promise = api.webPost(api.baseUrl + '/sellers/' + accountId + '/' + attribute.AttributeGroupId + '/seasonlessattributes', requestObject);

						promise.then(function() {
								api.sellers.seasonlessAttributes.isDirty = true;
								$rootScope.$emit('CatalogsUpdatedEvent');
						});
						return activityLogger.log(logData, promise);
				}

				function editSeasonlessAttributes(undefined, attribute, accountId) {
						var requestObject = {
							'AttributeId': attribute.Attributeid,
							'AttributeGroupId': attribute.AttributeGroupId,
							'Values': attribute.AllowedValues,
							'Criteria': angular.isDefined(attribute.Criteria) ? attribute.Criteria : '',
							'CriteriaV2': angular.isDefined(attribute.CriteriaV2) ? attribute.CriteriaV2 : '',
							'AllowedValuesV2': angular.isDefined(attribute.AllowedValuesV2) ? attribute.AllowedValuesV2 : '',
						}
						var promise = api.webPut(api.baseUrl + '/sellers/' + accountId + '/' + attribute.AttributeGroupId + '/seasonlessattributes', [requestObject]);
						promise.then(function () {
								api.sellers.seasonlessAttributes.isDirty = true;
								$rootScope.$emit('CatalogsUpdatedEvent');
						});
						return promise;
				}

				function activateSeasonlessAttributes(records, model, actionType, accountId) {
						var result = crud.createRequestObject(records, model, actionType, {isSeasonlessAttributes : true});
						var state = {};
						state.name = $state.current.name;
						state.params = $state.params;
						var isBulk = result.itemsNameList.length > 1 ? true : false;
						var logData = activityLogger.createLogData(result.itemsNameList, state, 'sellers.seasonlessAttributes', actionType.toUpperCase(), isBulk, new Date(), null, null);
						var promise = api.webPut(api.baseUrl + '/sellers/' + accountId + '/seasonlessattributes/status', result.requestObj);

						promise.then(function() {
								crud.onRecordStatusChange(records, model, actionType);
						});

						return activityLogger.log(logData, promise);
		}

		}
})();
(function() {
    'use strict';

    angular
        .module('app.main.accounts.sellers.resource-types')
        .run(runBlock);

    /* @ngInject */
    function runBlock(api, activityLogger, $state, catalogFactory) {

        if(angular.isUndefined(api.sellers)) {
            api.sellers = {};
        }
        api.sellers.resourceTypes = {
            modelPath: 'sellers.resourceTypes',
            fields: [
                { field: 'TypeId', type: 'int', displayLabel: 'RESOURCE_TYPES.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Type', type: 'int', displayLabel: 'RESOURCE_TYPES.FIELDS.TYPE', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: true, maxLen: 50, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Expression', type: 'int', displayLabel: 'RESOURCE_TYPES.FIELDS.EXPRESSION', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: 100, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'SortOrder', type: 'int', displayLabel: 'RESOURCE_TYPES.FIELDS.SORT_ORDER', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedDate', type: 'text', displayLabel: 'RESOURCE_TYPES.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedDate', type: 'text', displayLabel: 'RESOURCE_TYPES.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedBy', type: 'text', displayLabel: 'RESOURCE_TYPES.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedBy', type: 'text', displayLabel: 'RESOURCE_TYPES.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
            ],
            uniqueConstraints: [],
            title: 'RESOURCE_TYPES.NAV',
            icon: 'icon-image-filter-black-white',
            idField: 'TypeId',
            lookupDisplayField: 'Type',
            isDirty: false,
            methods: {
                getList         :   getSellerResourceTypes,
                create          :   createSellerResourceType,
                update          :   updateSellerResourceType
            },
            views: {
                mainList: {
                    columns             : [ 'TypeId', 'Type', 'Expression', 'UpdatedDate' ],
                    columnFilter        : {},
                    toggleFilterProps   : {},
                    topIndex            : 0,
                    showFilterRow       : false,
                    sortColumn          : {'UpdatedDate': false},
                    itemActions         : [
                                            { id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UpdateImagesResourcesType', disabled: '', visible: true }
                                        ],
                    listActions         : [],
                    fabAction           : {id: 'add', label: 'ACTIONS.ADD', icon: 'icon-plus', privilege: 'CreateImagesResourcesType', visible: true}
                },
                mainDetails: {},
                privileges: {
                    list: 'GetImagesResourcesTypeList'
                }
            }
        };

        function getSellerResourceTypes(generalProperties, sellerId) {
            var promise;

            if(angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
                var state = {};
                state.name = $state.current.name;
                state.params = $state.params;
                var isBulk = true;
                var logData = activityLogger.createLogData(null, state, 'sellers.resourceTypes', 'VIEW', isBulk, new Date(), null, null);
                promise = api.webGet(api.baseUrl + '/sellers/' + sellerId + '/resourceTypes', undefined, true, generalProperties.forceFetch);
                promise = activityLogger.log(logData, promise);
            }
            else {
                sellerId = angular.isUndefined(sellerId) ? catalogFactory.getActiveCatalog().AccountId : sellerId;
                return api.webGet(api.baseUrl + '/sellers/' + sellerId + '/resourceTypes', undefined, true, generalProperties.forceFetch);
            }

            promise.then(function() {
                if (api.sellers.resourceTypes.isDirty) {
                    //Invalidate lookupData
                    api.sellers.resourceTypes.lookupData = undefined;
                    api.sellers.resourceTypes.isDirty = false;
                }
            });
            return promise;
        }

        function createSellerResourceType(resourceType, sellerId) {
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var logData = activityLogger.createLogData(resourceType[api.sellers.resourceTypes.lookupDisplayField], state, 'sellers.resourceTypes', 'ADD', false, new Date(), null, null);
            var promise = api.webPost(api.baseUrl + '/sellers/' + sellerId + '/resourceTypes', resourceType);

            promise.then(function() {
               api.sellers.resourceTypes.isDirty = true;
            });
            return activityLogger.log(logData, promise);
        }

        function updateSellerResourceType(resourceType, resourceId, sellerId) {
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var logData = activityLogger.createLogData(resourceType[api.sellers.resourceTypes.lookupDisplayField], state, 'sellers.resourceTypes', 'EDIT', false, new Date(), null, null);
            var promise = api.webPut(api.baseUrl + '/sellers/' + sellerId + '/resourceTypes/' + resourceId, resourceType);

            promise.then(function() {
               api.sellers.resourceTypes.isDirty = true;
            });
            return activityLogger.log(logData, promise);
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.main.accounts.sellers.order-types', []);
})();
(function() {
    'use strict';

    angular
        .module('app.main.accounts.sellers.order-types')
        .run(runBlock);

    /* @ngInject */
    function runBlock(api, activityLogger, $state, catalogFactory, crud) {

        if(angular.isUndefined(api.sellers)) {
            api.sellers = {};
        }
        api.sellers.orderTypes = {
            modelPath: 'sellers.orderTypes',
            fields: [
                { field: 'Id', type: 'int', displayLabel: 'ORDER_TYPES.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'OrderType', type: 'text', displayLabel: 'ORDER_TYPES.FIELDS.ORDER_TYPE', visible: true, creatable: true, editable: true, inputType: 'text',
                    validation: {isRequired: true, maxLen: 50, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Status', type: 'int', displayLabel: 'ORDER_TYPES.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedDate', type: 'text', displayLabel: 'ORDER_TYPES.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'updatedDate', type: 'text', displayLabel: 'ORDER_TYPES.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedBy', type: 'text', displayLabel: 'ORDER_TYPES.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedBy', type: 'text', displayLabel: 'ORDER_TYPES.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
            ],
            uniqueConstraints: [],
            title: 'ORDER_TYPES.NAV',
            icon: 'icon-tile-four',
            idField: 'Id',
            lookupDisplayField: 'OrderType',
            isDirty: false,
            methods: {
                getList         :   getSellerOrderTypes,
                activateBulk    :   activateSellerOrderTypes,
                create          :   createSellerOrderType,
                update          :   updateSellerOrderType
            },
            views: {
                mainList: {
                    columns             : [ 'OrderType', 'Status', 'updatedDate' ],
                    columnFilter        : {},
                    toggleFilterProps   : { toggleStatus:false, filterProp:'Status', trueVal:1, trueValTooltipMessage: 'ACTIONS.TOGGLE_ACTIVE', falseVal:'', falseValTooltipMessage:"ACTIONS.TOGGLE_ALL"},
                    topIndex            : 0,
                    showFilterRow       : false,
                    sortColumn          : {'updatedDate': false},
                    itemActions         : [
                                            { id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UpdateOrderType', disabled: '!itm.Status', visible: true },
                                            { id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateBulkOrderTypeStatus', disabled: false, visible: 'itm.Status',
                                                requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                                            { id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateBulkOrderTypeStatus', disabled: false, visible: '!itm.Status',
                                                requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
                                          ],
                    listActions         : [
                                            { id: 'delete', label: 'ACTIONS.DELETE_BULK', icon: 'icon-delete', privilege: 'UpdateBulkOrderTypeStatus', disabled: '{selected: true, Status: 1}', visible: true,
                                                requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                                            { id: 'activate', label: 'ACTIONS.ACTIVATE_BULK', icon: 'icon-undo-variant', privilege: 'UpdateBulkOrderTypeStatus', disabled: '{selected: true, Status: 0}', visible: true,
                                                requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
                                          ],
                    fabAction           : {id: 'add', label: 'ACTIONS.ADD', icon: 'icon-plus', privilege: 'CreateOrderType', visible: true}
                },
                mainDetails: {},
                privileges: {
                    list: 'GetOrderTypes'
                }
            }
        };

        function getSellerOrderTypes(generalProperties, sellerId) {
            var promise;
            var id = sellerId || generalProperties.idMap.id1;

            if(angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
                var state = {};
                state.name = $state.current.name;
                state.params = $state.params;
                var isBulk = true;
                var logData = activityLogger.createLogData(null, state, 'sellers.orderTypes', 'VIEW', isBulk, new Date(), null, null);
                promise = api.webGet(api.baseUrl + '/sellers/' + id + '/ordertypes', undefined, true, generalProperties.forceFetch);
                promise = activityLogger.log(logData, promise);
            }
            else {
                return api.webGet(api.baseUrl + '/sellers/' + id + '/ordertypes', undefined, true, generalProperties.forceFetch);
            }

            promise.then(function() {
                if (api.sellers.orderTypes.isDirty) {
                    //Invalidate lookupData
                    api.sellers.orderTypes.lookupData = undefined;
                    api.sellers.orderTypes.isDirty = false;
                }
            });
            return promise;
        }

        function activateSellerOrderTypes(records, model, actionType, sellerId) {
          var result = crud.createRequestObject(records, model, actionType);
          var state = {};
          state.name = $state.current.name;
          state.params = $state.params;
          var isBulk = result.itemsNameList.length > 1 ? true : false;
          var logData = activityLogger.createLogData(result.itemsNameList, state, 'accounts.orderTypes', actionType.toUpperCase(), isBulk, new Date(), null, null);
          var promise = api.webPut(api.baseUrl + '/sellers/' + sellerId + '/ordertypes/status', result.requestObj);

          promise.then(function() {
              crud.onRecordStatusChange(records, model, actionType);
          });

          return activityLogger.log(logData, promise);
        }

        function createSellerOrderType(orderType, sellerId) {
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var logData = activityLogger.createLogData(orderType[api.sellers.orderTypes.lookupDisplayField], state, 'sellers.orderTypes', 'ADD', false, new Date(), null, null);
            var promise = api.webPost(api.baseUrl + '/sellers/' + sellerId + '/ordertypes', [orderType]);

            promise.then(function() {
               api.sellers.orderTypes.isDirty = true;
            });
            return activityLogger.log(logData, promise);
        }

        function updateSellerOrderType(orderTypeId, orderType, sellerId) {
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var logData = activityLogger.createLogData(orderType[api.sellers.orderTypes.lookupDisplayField], state, 'sellers.orderTypes', 'EDIT', false, new Date(), null, null);
            var promise = api.webPut(api.baseUrl + '/sellers/' + sellerId + '/ordertypes/' + orderTypeId, orderType);

            promise.then(function() {
               api.sellers.orderTypes.isDirty = true;
            });
            return activityLogger.log(logData, promise);
        }
    }
})();
(function() {
	'use strict';

	angular
		.module('app.main.accounts.sellers.master-size-scales')
		.run(runBlock);

	/* @ngInject */
	function runBlock(api, activityLogger, $state, jobsTracker, crud, catalogFactory, CONSTANTS) {

		if(angular.isUndefined(api.sellers)) {
			api.sellers = {};
		}
		api.sellers.masterSizeScales = {
			modelPath: 'sellers.masterSizeScales',
			fields: [
				{ field: 'Id', type: 'int', displayLabel: 'SELLER_SIZE_SCALE_GROUP.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'SizeScale', type: 'text', displayLabel: 'SELLER_SIZE_SCALE_GROUP.FIELDS.SIZE_SCALE', visible: true, creatable: true, editable: true, inputType: 'text', checkIfUnique: true,
					validation: {isRequired: true, maxLen: 400, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'Sizes', type: 'text', displayLabel: 'SELLER_SIZE_SCALE_GROUP.FIELDS.SIZES', visible: true, creatable: false, editable: false, inputType: 'text',
					validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'Sizes', type: 'text', displayLabel: 'SELLER_SIZE_SCALE_GROUP.FIELDS.SIZES', visible: false, creatable: true, editable: true, inputType: 'tags', tagSeparator: ',',
					validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'ObsoleteSizes', type: 'text', displayLabel: 'SELLER_SIZE_SCALE_GROUP.FIELDS.OBSOLETE_SIZES', visible: true, creatable: false, editable: false, inputType: 'text',
					validation: {isRequired: false, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'ObsoleteSizes', type: 'text', displayLabel: 'SELLER_SIZE_SCALE_GROUP.FIELDS.OBSOLETE_SIZES', visible: false, creatable: false, editable: true, inputType: 'tags', tagSeparator: ',',
					validation: {isRequired: false, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'IsObsolete', type: 'int', displayLabel: 'SELLER_SIZE_SCALE_GROUP.FIELDS.IS_OBSOLETE', visible: true, creatable: false, editable: true, inputType: 'bool-int',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'Status', type: 'text', displayLabel: 'SELLER_SIZE_SCALE_GROUP.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
					validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'Criteria', type: 'text', displayLabel: 'SELLER_SIZE_SCALE_GROUP.FIELDS.CRITERIA', visible: true, creatable: true, editable: true, inputType: 'textArea',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'CreatedDate', type: 'text', displayLabel: 'SELLER_SIZE_SCALE_GROUP.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'UpdatedDate', type: 'text', displayLabel: 'SELLER_SIZE_SCALE_GROUP.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'CreatedBy', type: 'text', displayLabel: 'SELLER_SIZE_SCALE_GROUP.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'UpdatedBy', type: 'text', displayLabel: 'SELLER_SIZE_SCALE_GROUP.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
			],
			uniqueConstraints: [],
			title: 'SELLERS.TABS.MASTER_SIZE_SCALES',
			icon: 'icon-layers',
			idField: 'Id',
			lookupDisplayField: 'SizeScale',
			isDirty: false,
			methods: {
				getList     :   getMasterSizeScales,
				create      :   createMasterSizeScales,
				update      :   updateMasterSizeScales,
				createBulk  :   createBulk,
				activateBulk:   activateBulk,
				updateSizeScaleCriteriaBulk: updateSizeScaleCriteriaBulk
			},
			views: {
				mainList: {
					columns             : [ 'Id', 'SizeScale', 'Sizes', 'IsObsolete', , 'Criteria', 'Status'],
					columnFilter        : {},
					toggleFilterProps   : { toggleStatus:false, filterProp:'Status', trueVal:1, trueValTooltipMessage: 'ACTIONS.TOGGLE_ACTIVE', falseVal:'', falseValTooltipMessage:"ACTIONS.TOGGLE_ALL" },
					topIndex            : 0,
					showFilterRow       : false,
					sortColumn          : {'UpdatedDate': false},
					itemActions         : [
											{ id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UpdateMasterSizeScale', disabled: '!itm.Status', visible: true },
											{ id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateMasterSizeScaleStatusBulk', disabled: false, visible: 'itm.Status',
												requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
											{ id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateMasterSizeScaleStatusBulk', disabled: false, visible: '!itm.Status',
												requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'},
											{ id: 'editCriteria', label: 'SELLER_SIZE_SCALE_GROUP.ACTIONS.UPDATE_CRITERIA', icon: 'icon-pencil', privilege: 'UpdateMasterSizeScaleCriteriaBulk', disabled: '!itm.Status', visible: true },
										],
					listActions         : [
											{ id: 'import', label: 'ACTIONS.IMPORT', icon: 'icon-import', privilege: 'CreateUpdateMasterSizeScalesBulk', disabled: false, visible: true, requiresConfirmation: false },
											{ id: 'delete', label: 'ACTIONS.DELETE_BULK', icon: 'icon-delete', privilege: 'UpdateMasterSizeScaleStatusBulk', disabled: '{selected: true, Status: 1}', visible: true,
												requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
											{ id: 'activate', label: 'ACTIONS.ACTIVATE_BULK', icon: 'icon-undo-variant', privilege: 'UpdateMasterSizeScaleStatusBulk', disabled: '{selected: true, Status: 0}', visible: true,
												requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'},
											{ id: 'updateBulkCriteria', label: 'SELLER_SIZE_SCALE_GROUP.ACTIONS.UPDATE_BULK_CRITERIA', icon: 'icon-pencil', privilege: 'UpdateMasterSizeScaleCriteriaBulk:true', disabled: '{selected: true, Status: 1}', visible: true, requiresConfirmation: false },
										],
					fabAction           : { id: 'add', label: 'ACTIONS.ADD', icon: 'icon-plus', privilege: 'CreateMasterSizeScaleBulk:true', visible: true }
				},
				mainDetails: {},
				privileges: {
					list: 'GetSellerMasterSizeScaleList',
				}
			}
		};

		function getMasterSizeScales(model, generalProperties, sellerId) {
			if (angular.isDefined(model)) { // to skip this part for load lookup
				model.isBulkActionCompleted = false;
			}
			if(angular.isUndefined(sellerId)) {
				sellerId = catalogFactory.getActiveCatalog().AccountId;
			}
			var promise;
			if(angular.isDefined(generalProperties) && angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
				var state = {};
				state.name = $state.current.name;
				state.params = $state.params;
				var isBulk = true;
				var logData = activityLogger.createLogData(null, state, 'sellers.masterSizeScales', 'VIEW', isBulk, new Date(), null, null);
				promise = api.webGet(api.baseUrl + '/sellers/' + sellerId + '/mastersizescales', undefined, true, generalProperties.forceFetch);
				promise = activityLogger.log(logData, promise);
			}
			else {
				promise = api.webGet(api.baseUrl + '/sellers/' + sellerId + '/mastersizescales', undefined, true, true);
			}
			return promise;
		}

		function createMasterSizeScales(record, sellerId) {
			var state = {};
			state.name = $state.current.name;
			state.params = $state.params;
			var logData = activityLogger.createLogData(record[api.sellers.masterSizeScales.lookupDisplayField], state, 'sellers.masterSizeScales', 'ADD', false, new Date(), null, null);

			record.Sizes = record.Sizes.join(',');
			// delete ObsoleteSizes
			delete record['ObsoleteSizes'];
			var promise = api.webPost(api.baseUrl + '/sellers/' + sellerId + '/createmastersizescales', [record]);

			promise.then(function () {
				api.sellers.masterSizeScales.isDirty = true;
			});
			return activityLogger.log(logData, promise);
		}

		function updateMasterSizeScales(sizeScaleId, record, sellerId) {
			var state = {};
			state.name = $state.current.name;
			state.params = $state.params;
			var logData = activityLogger.createLogData(record[api.sellers.masterSizeScales.lookupDisplayField], state, 'sellers.masterSizeScales', 'EDIT', false, new Date(), null, null);

			record.Sizes = record.Sizes.join(',');
			record.ObsoleteSizes = record.ObsoleteSizes.length ? record.ObsoleteSizes.join(',') : '';
			var promise = api.webPut(api.baseUrl + '/sellers/' + sellerId + '/mastersizescales/' + sizeScaleId, record);

			promise.then(function () {
				api.sellers.masterSizeScales.isDirty = true;
			});
			return activityLogger.log(logData, promise);
		}

		function createBulk(model, data, sellerId) {
			var jobIndex = jobsTracker.addJob(model, 'SELLER_SIZE_SCALE_GROUP.ACTIONS.IMPORT_MASTER_SIZE_SCALE', 1);
			api.webPut(api.baseUrl + '/sellers/' + sellerId + '/bulkmastersizescales?sourceapplication=' + CONSTANTS.SOURCE_APPLICATION + '&sourceaction=Import Master Size Scale', data).then(function(response) {
				jobsTracker.trackJob(jobIndex, response.data.Id);
			}).catch(function(error) {
				jobsTracker.setCriticlaFail(jobIndex, error);
			});
		}

		function activateBulk(records, model, actionType, sellerId) {
			var result = crud.createRequestObject(records, model, actionType);
			var state = {};
			state.name = $state.current.name;
			state.params = $state.params;
			var isBulk = result.itemsNameList.length > 1 ? true : false;
			var logData = activityLogger.createLogData(result.itemsNameList, state, 'sellers.masterSizeScales', actionType.toUpperCase(), isBulk, new Date(), null, null);
			var promise = api.webPut(api.baseUrl + '/sellers/' + sellerId + '/mastersizescales/status', result.requestObj);

			promise.then(function() {
				crud.onRecordStatusChange(records, model, actionType);
			});

			return activityLogger.log(logData, promise);
		}

		function updateSizeScaleCriteriaBulk(criteria, accountId, selectedRecords) {
			var state = {};
			state.name = $state.current.name;
			state.params = $state.params;
			var logData = activityLogger.createLogData(null, state, 'sellers.masterSizeScales', 'EDIT', false, new Date(), null, null);
			var requestObject = [];
			if(angular.isArray(selectedRecords)) {
					angular.forEach(selectedRecords, function(record) {
							var obj = {
									'SizescaleId' : record.Id,
									'Criteria' : criteria
							}
							requestObject.push(obj);
					});
			} else {
					var obj = {
							'SizescaleId' : selectedRecords.Id,
							'Criteria' : criteria
					}
					requestObject.push(obj);
			}

			var promise = api.webPut(api.baseUrl + '/sellers/' + accountId + '/mastersizescales/criteria', requestObject);

			promise.then(function () {
					api.sellers.masterSizeScales.isDirty = true;
			});
			return activityLogger.log(logData, promise);
		}

	}
})();
(function() {
	'use strict';

	angular
		.module('app.main.accounts.sellers.design-option-attributes', [])
		.config(config);

	/* @ngInject */
	function config($translatePartialLoaderProvider) {
		// Translation
		$translatePartialLoaderProvider.addPart('app/main/accounts/sellers/details/tabs/design-option-attributes');
	}
})();

(function() {
	'use strict';

	angular
		.module('app.main.accounts.sellers.design-option-attributes')
		.run(runBlock);

	/* @ngInject */
	function runBlock(api, $state, activityLogger, crud, utility, SecurityFactory, CONSTANTS, errorDialog, $q) {

		if (angular.isUndefined(api.sellers)) {
			api.sellers = {};
		}
		if (angular.isUndefined(api.lists)) {
			api.lists = {};
		}

		// -----------------------------------------------------------------
		// Seller Design Option attribute definitions
		// All Design Option endpoints (attribute-definition APIs #14-#19) live in
		// T1 API v2, so every call uses api.t1v2URL (NOT api.baseUrl, which is v1).
		// -----------------------------------------------------------------
		api.sellers.designOptionAttributes = {
			modelPath: 'sellers.designOptionAttributes',
			fields: [
				{ field: 'Id', type: 'int', displayLabel: 'DESIGN_OPTION_ATTRIBUTES.FIELDS.ID', visible: false, creatable: false, editable: false, inputType: 'number',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				// Attribute picker (add dialog only) - populated from the seller-scoped available list
				{ field: 'AttributeId', type: 'text', displayLabel: 'DESIGN_OPTION_ATTRIBUTES.FIELDS.ATTRIBUTE', visible: false, creatable: true, editable: false, inputType: 'lookup', lookupSource: 'lists.availableDesignOptionAttributeList',
					validation: {isRequired: true, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'Name', type: 'text', displayLabel: 'DESIGN_OPTION_ATTRIBUTES.FIELDS.NAME', visible: true, creatable: false, editable: false, showInEdit: true, inputType: 'text',
					validation: {isRequired: false, maxLen: 200, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				// Type column - the numeric DataTypeId is resolved to a friendly label via the shared attribute-types list
				{ field: 'DataTypeId', type: 'int', displayLabel: 'DESIGN_OPTION_ATTRIBUTES.FIELDS.TYPE', visible: true, creatable: false, editable: false, inputType: 'lookup', lookupSource: 'lists.attributeTypes',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				// Allowed Values - identical tags/pipe input to the Seasonless Attributes tab; editable for all types
				{ field: 'AllowedValues', type: 'text', displayLabel: 'DESIGN_OPTION_ATTRIBUTES.FIELDS.ALLOWED_VALUES', visible: true, creatable: true, editable: true, inputType: 'tags', tagSeparator: '|', importable: 'true',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: 'Invalid value, pipe ( | ) is not allowed'}} },
				{ field: 'SortOrder', type: 'int', displayLabel: 'DESIGN_OPTION_ATTRIBUTES.FIELDS.SORT_ORDER', visible: true, creatable: true, editable: true, inputType: 'number',
					validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'Status', type: 'text', displayLabel: 'DESIGN_OPTION_ATTRIBUTES.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
			],
			uniqueConstraints: [],
			title: 'DESIGN_OPTION_ATTRIBUTES.NAV',
			icon: 'icon-dice-1',
			idField: 'Id',
			lookupDisplayField: 'Name',
			isDirty: false,
			methods: {
				getList         :   getDesignOptionAttributes,
				create          :   createDesignOptionAttribute,
				update          :   updateDesignOptionAttribute,
				activateBulk    :   activateDesignOptionAttributes,
				editSortOrder   :   editDesignOptionAttributeSortOrder
			},
			views: {
				mainList: {
					columns          : [ 'Name', 'DataTypeId', 'AllowedValues', 'SortOrder', 'Status' ],
					columnFilter     : {},
					toggleFilterProps: { toggleStatus:false, filterProp:'Status', trueVal:1, trueValTooltipMessage: 'ACTIONS.TOGGLE_ACTIVE', falseVal:'', falseValTooltipMessage:"ACTIONS.TOGGLE_ALL"},
					topIndex         : 0,
					showFilterRow    : false,
					sortColumn       : {'SortOrder': true},
					itemActions      : [
											{ id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UpdateDesignOptionAttribute', disabled: '!itm.Status', visible: true },
											{ id: 'editSortOrder', label: 'DESIGN_OPTION_ATTRIBUTES.ACTIONS.EDIT_SORTORDER', icon: 'icon-pencil', privilege: 'UpdateDesignOptionAttributeSortOrder', disabled: false, visible: true },
											{ id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateDesignOptionAttributeStatus', disabled: false, visible: 'itm.Status',
												requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
											{ id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateDesignOptionAttributeStatus', disabled: false, visible: '!itm.Status',
												requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
										],
					listActions      : [
											{ id: 'delete', label: 'ACTIONS.DELETE_BULK', icon: 'icon-delete', privilege: 'UpdateDesignOptionAttributeStatus', disabled: '{selected: true, Status: 1}', visible: true,
												requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
											{ id: 'activate', label: 'ACTIONS.ACTIVATE_BULK', icon: 'icon-undo-variant', privilege: 'UpdateDesignOptionAttributeStatus', disabled: '{selected: true, Status: 0}', visible: true,
												requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'},
											{ id: 'editBulkSortOrder', label: 'DESIGN_OPTION_ATTRIBUTES.ACTIONS.EDIT_BULK_SORTORDER', icon: 'icon-pencil', privilege: 'UpdateDesignOptionAttributeSortOrder', disabled: '{selected: true}', visible: true, requiresConfirmation: false }
										],
					fabAction        : { id: 'add', label: 'ACTIONS.ADD', icon: 'icon-plus', privilege: 'AssignDesignOptionAttribute:true', visible: true }
				},
				mainDetails: {},
				privileges: {
					list    : 'GetDesignOptionAttributes'
				}
			}
		};

		function getDesignOptionAttributes(generalProperties, sellerId) {
			var promise = api.webGet(api.t1v2URL + '/sellers/' + sellerId + '/designoptions/attributes', undefined, true, generalProperties.forceFetch);

			promise.then(function () {
				if (api.sellers.designOptionAttributes.isDirty) {
					// Invalidate lookupData
					api.sellers.designOptionAttributes.lookupData = undefined;
					api.sellers.designOptionAttributes.isDirty = false;
				}
			});
			return promise;
		}

		function createDesignOptionAttribute(record, sellerId) {
			var requestObject = {
				AttributeId  : record.AttributeId,
				AllowedValues: angular.isDefined(record.AllowedValues) ? record.AllowedValues : [],
				SortOrder    : record.SortOrder
			};
			var state = {};
			state.name = $state.current.name;
			state.params = $state.params;
			var logData = activityLogger.createLogData(record[api.sellers.designOptionAttributes.lookupDisplayField], state, 'sellers.designOptionAttributes', 'ADD', false, new Date(), null, null);
			var promise = api.webPost(api.t1v2URL + '/sellers/' + sellerId + '/designoptions/attributes', requestObject);

			promise.then(function () {
				api.sellers.designOptionAttributes.isDirty = true;
			});
			return activityLogger.log(logData, promise);
		}

		function updateDesignOptionAttribute(attributeId, record, sellerId) {
			var requestObject = {
				AllowedValues: angular.isDefined(record.AllowedValues) ? record.AllowedValues : [],
				SortOrder    : record.SortOrder
			};
			var state = {};
			state.name = $state.current.name;
			state.params = $state.params;
			var logData = activityLogger.createLogData(record[api.sellers.designOptionAttributes.lookupDisplayField], state, 'sellers.designOptionAttributes', 'EDIT', false, new Date(), null, null);
			var promise = api.webPut(api.t1v2URL + '/sellers/' + sellerId + '/designoptions/attributes/' + record.AttributeId, requestObject);

			promise.then(function () {
				api.sellers.designOptionAttributes.isDirty = true;
			});
			return activityLogger.log(logData, promise);
		}

		function activateDesignOptionAttributes(records, model, actionType, sellerId) {
			if (!angular.isArray(records)) {
				records = utility.pushItemToArray(records);
			}

			var itemsNameList = [];
			var requestObj = [];
			var statusVal = actionType === 'delete' ? 0 : 1;
			angular.forEach(records, function (record) {
				itemsNameList.push(record[model.lookupDisplayField]);
				requestObj.push({ Id: record[model.idField], Status: statusVal });
			});

			var state = {};
			state.name = $state.current.name;
			state.params = $state.params;
			var isBulk = itemsNameList.length > 1;
			var logData = activityLogger.createLogData(itemsNameList, state, 'sellers.designOptionAttributes', actionType.toUpperCase(), isBulk, new Date(), null, null);
			var promise = api.webPut(api.t1v2URL + '/sellers/' + sellerId + '/designoptions/attributes/status', requestObj);

			promise.then(function () {
				crud.onRecordStatusChange(records, model, actionType);
			});
			return activityLogger.log(logData, promise);
		}

		function editDesignOptionAttributeSortOrder(records, updateRecord, sellerId) {
			if (!angular.isArray(records)) {
				records = utility.pushItemToArray(records);
			}

			var requestObj = [];
			angular.forEach(records, function (record) {
				if (angular.isDefined(updateRecord)) {
					record.SortOrder = updateRecord['SortOrder'];
				}
				requestObj.push({ Id: record.Id, SortOrder: record.SortOrder });
			});

			var state = {};
			state.name = $state.current.name;
			state.params = $state.params;
			var logData = activityLogger.createLogData(records, state, 'sellers.designOptionAttributes', 'EDIT', false, new Date(), null, null);
			var promise = api.webPut(api.t1v2URL + '/sellers/' + sellerId + '/designoptions/attributes/sortorder', requestObj);

			promise.then(function () {
				api.sellers.designOptionAttributes.isDirty = true;
			});
			return activityLogger.log(logData, promise);
		}

		// -----------------------------------------------------------------
		// Available attributes for the add picklist (seller-scoped, all types)
		// -----------------------------------------------------------------
		api.lists.availableDesignOptionAttributeList = {
			modelPath: 'lists.availableDesignOptionAttributeList',
			fields: [
				{ field: 'AttributeId', type: 'text', displayLabel: 'GENERAL.ID', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: false, maxLen: -1 },
				{ field: 'SystemName', type: 'text', displayLabel: 'GENERAL.VALUE', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: false, maxLen: -1 },
				{ field: 'Name', type: 'text', displayLabel: 'GENERAL.VALUE', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: false, maxLen: -1 }
			],
			idField: 'AttributeId',
			lookupDisplayField: 'Name',
			methods: {
				getList: getAvailableDesignOptionAttributes
			}
		};

		function getAvailableDesignOptionAttributes(generalProperties) {
			var sellerId = generalProperties.idMap && generalProperties.idMap.sellerId;
			if (!sellerId) {
				// No seller context (e.g. edit dialog pre-loading the picker lookup that isn't shown) - nothing to load.
				return $q.when({ data: [] });
			}
			if (SecurityFactory.isAuthorized({accessPrivileges: CONSTANTS.PRIVILEGES.SELLERS.DETAIL.GET_AVAILABLE_DESIGN_OPTION_ATTRIBUTES})) {
				return api.webGet(api.t1v2URL + '/sellers/' + sellerId + '/designoptions/attributes/available', undefined, true, generalProperties.forceFetch);
			} else {
				var privilege = {
					id: 4063,
					description: 'Design Option Attributes - List available'
				};
				errorDialog.show('ERRORS.NO_PRIVILEGES', undefined, privilege);
			}
		}
	}
})();

(function() {
    'use strict';
    
    angular
        .module('app.main.accounts.sellers.catalogs', []);    
})();
(function() {
    'use strict';

    angular
        .module('app.main.accounts.sellers.catalogs')
        .run(runBlock);

    /* @ngInject */
    function runBlock(api, activityLogger, $state) {

        if (angular.isUndefined(api.sellers)) {
            api.sellers = {};
        }
         api.sellers.catalogs = {
            modelPath: 'sellers.catalogs',
            fields: [
                { field: 'Id', type: 'int', displayLabel: 'CATALOGS.FIELDS.ID', visible: false, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'DataSourceTypeId', type: 'int', displayLabel: 'CATALOGS.FIELDS.DATA_SOURCE_TYPE', visible: false, creatable: true, editable: false, inputType: 'lookup',  lookupSource: 'lists.dataSourceTypes',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'DataSourceType', type: 'text', displayLabel: 'CATALOGS.FIELDS.DATA_SOURCE_TYPE', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: 100, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'AccountId', type: 'int', displayLabel: 'CATALOGS.FIELDS.SELLER_ACCOUNT', visible: false, creatable: true, editable: true, inputType: 'lookup', lookupSource: 'accounts.sellers',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CatalogCode', type: 'int', displayLabel: 'CATALOGS.FIELDS.CATALOG_CODE', visible: false, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CatalogName', type: 'text', displayLabel: 'CATALOGS.FIELDS.CATALOG_NAME', visible: true, creatable: true, editable: true, inputType: 'text',
                    validation: {isRequired: true, maxLen: 100, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ReferenceCatalogCode', type: 'text', displayLabel: 'CATALOGS.FIELDS.REFERENCE_CATAOG_CODE', visible: true, creatable: true, editable: false, inputType: 'lookup', lookupSource: 'catalogs.catalogs',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', disabledCriteria: 'vm.record.DataSourceTypeId === 1', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'AttributeGroupId', type: 'int', displayLabel: 'CATALOGS.FIELDS.ATTRIBUTE_GROUP_NAME', visible: false, creatable: true, editable: false, inputType: 'lookup', lookupSource: 'attributes.attributeGroups',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', disabledCriteria: 'vm.record.DataSourceTypeId === 2 || vm.record.DataSourceTypeId === 3', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'AttributeGroupName', type: 'text', displayLabel: 'CATALOGS.FIELDS.ATTRIBUTE_GROUP_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'AttributeIdsList', type: 'text', displayLabel: 'CATALOGS.FIELDS.ATTRIBUTE_IDS_LIST', visible: false, creatable: true, editable: true, inputType: 'lookup-many', lookupSource: 'attributes.attributes',
                    validation: {isRequired: 'vm.record.DataSourceTypeId === 3', maxLen: -1, minLen: 0, pattern: '', disabledCriteria: 'vm.record.DataSourceTypeId === 2', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ImageName', type: 'text', displayLabel: 'CATALOGS.FIELDS.IMAGE_NAME', visible: false, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: 100, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ImageFile', type: 'text', displayLabel: 'CATALOGS.FIELDS.IMAGE_FILE', visible: false, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: 100, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ImagePath', type: 'text', displayLabel: 'CATALOGS.FIELDS.IMAGE_PATH', visible: false, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: 100, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'IsVasInUse', type: 'text', displayLabel: 'CATALOGS.FIELDS.IS_VAS_IN_USE', visible: true, creatable: false, editable: false, inputType: 'int-bool',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'IndependentSizes', type: 'text', displayLabel: 'CATALOGS.FIELDS.INDEPENDENT_SIZES', visible: true, creatable: false, editable: false, inputType: 'bool-int',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Status', type: 'text', displayLabel: 'CATALOGS.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Season', type: 'text', displayLabel: 'CATALOGS.FIELDS.SEASON', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: 100, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Year', type: 'int', displayLabel: 'CATALOGS.FIELDS.YEAR', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CatalogShared', type: 'text', displayLabel: 'CATALOGS.FIELDS.CATALOG_SHARED', visible: false, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedDate', type: 'text', displayLabel: 'CATALOGS.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedDate', type: 'text', displayLabel: 'CATALOGS.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UserId', type: 'text', displayLabel: 'CATALOGS.FIELDS.USER_ID', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CatalogCRDList', type: 'text', displayLabel: 'CATALOGS.FIELDS.CATALOG_CRD_LIST', visible: false, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CatalogSpecificConfigurationList', type: 'text', displayLabel: 'CATALOGS.FIELDS.CATALOG_SPECIFIC_CONFIGURATION_LIST', visible: false, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CatalogPriceGroupList', type: 'text', displayLabel: 'CATALOGS.FIELDS.CATALOG_PRICEGROUP_LIST', visible: false, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedBy', type: 'text', displayLabel: 'CATALOGS.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ReceiveOrders', type: 'text', displayLabel: 'CATALOGS.FIELDS.RECEIVE_ORDERS', visible: true, creatable: false, editable: false, inputType: 'bool-int',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ReceiveOrdersWithoutPrice', type: 'int', displayLabel: 'CATALOGS.FIELDS.RECEIVE_ORDERS_WITHOUT_PRICE', visible: true, creatable: false, editable: false, inputType: 'bool-int',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ArticleCascading', type: 'text', displayLabel: 'CATALOGS.FIELDS.ARTICLE_CASCADING', visible: true, creatable: false, editable: false, inputType: 'bool-int',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'IsStockApply', type: 'text', displayLabel: 'CATALOGS.FIELDS.IS_STOCK_APPLY', visible: true, creatable: false, editable: false, inputType: 'bool-int',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'SegmentationCascading', type: 'text', displayLabel: 'CATALOGS.FIELDS.SEGMENTATION_CASCADING', visible: true, creatable: false, editable: false, inputType: 'bool-int',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'SegmentationPlanningEnable', type: 'text', displayLabel: 'CATALOGS.FIELDS.SEGMENTATION_PLANNING_ENABLE', visible: true, creatable: false, editable: false, inputType: 'bool-int',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ArticleLocking', type: 'text', displayLabel: 'CATALOGS.FIELDS.ARTICLE_LOCKING', visible: true, creatable: false, editable: false, inputType: 'bool-int',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'State', type: 'text', displayLabel: 'CATALOGS.FIELDS.STATE', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'IsLinePlan', type: 'text', displayLabel: 'CATALOGS.FIELDS.IS_LINE_PLAN', visible: false, creatable: false, editable: false, inputType: 'bool-int',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'LinkedCatalogs', type: 'text', displayLabel: 'CATALOGS.FIELDS.LINKED_CATALOGS', visible: false, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'LinkedAttributes', type: 'text', displayLabel: 'CATALOGS.FIELDS.LINKED_ATTRIBUTES', visible: false, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
            ],
            uniqueConstraints: [
                {name: 'Constraint 1', fields: ['CatalogName']}
            ],
            title: 'CATALOGS.NAV',
            icon: 'icon-book-open',
            idField: 'CatalogCode',
            lookupDisplayField: 'CatalogName',
            isDirty: false,
            methods: {
                getList         :   getSellerCatalogs
            },
            views: {
                 mainList: {
                    columns         : [ 'CatalogCode', 'CatalogName', 'ReferenceCatalogCode', 'Status', 'UpdatedDate' ],
                    columnFilter    : {},
                    toggleFilterProps: { toggleStatus:false, filterProp:'Status', trueVal:1, trueValTooltipMessage: 'ACTIONS.TOGGLE_ACTIVE', falseVal:'', falseValTooltipMessage:"ACTIONS.TOGGLE_ALL"},
                    topIndex        : 0,
                    showFilterRow   : false,
                    sortColumn      : {'UpdatedDate': false},
                    itemActions     : [
                                        { id: 'view', label: 'ACTIONS.VIEW', icon: 'icon-magnify', privilege: 'GetCatalogDetails', disabled: '!itm.Status', visible: true }
                                      ],
                    listActions     : [],
                    fabAction       : {}

                 },
                 mainDetails: {
                     selectedTabIndex   : 0,
                     itemActions        : [
                                            { id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateBulkCatalogStatus', disabled: '{selected: true, Status: 1}',
                                                visible: true, requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                                            { id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateBulkCatalogStatus', disabled: '{selected: true, Status: 0}',
                                                visible: true, requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
                                          ],
                    fabAction           : {id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UpdateCatalogDefination', visible: true}

                 },
                 privileges: {
                     list: 'GetCatalogList',
                     details: 'GetCatalogDetails',
                     sellerDetails: 'GetCatalogDetailsByAccIdAndCatalogCode'
                 }
            }
        };

        // does not suppor lookup
        function getSellerCatalogs(generalProperties, accountId) {
            var promise;

            if(angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
                var state = {};
                state.name = $state.current.name;
                state.params = $state.params;
                var isBulk = false;
                var logData = activityLogger.createLogData(null, state, 'catalogs.catalogs', 'VIEW', isBulk, new Date(), null, null);
                promise = api.webGet(api.baseUrl + '/sellers/'+ accountId +'/catalogs', undefined, true, generalProperties.forceFetch);
                promise = activityLogger.log(logData, promise);
            }
            else {
                promise = api.webGet(api.baseUrl + '/sellers/'+ accountId +'/catalogs', undefined, true, generalProperties.forceFetch);
            }

            return promise;
        }

    }
})();
(function() {
	'use strict';

	angular
		.module('app.main.accounts.sellers.capacities')
		.run(runBlock);

	/* @ngInject */
	function runBlock(api, activityLogger, $state, jobsTracker, crud, catalogFactory) {

		if(angular.isUndefined(api.sellers)) {
			api.sellers = {};
		}

		api.sellers.capacities = {
			modelPath: 'sellers.capacities',
			fields: [
				{ field: 'CapacityId', type: 'int', displayLabel: 'SELLERS.CAPACITIES.FIELDS.ID', visible: false, creatable: false, editable: false, inputType: 'number',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'Name', type: 'text', displayLabel: 'SELLERS.CAPACITIES.FIELDS.NAME', visible: true, creatable: true, editable: true, inputType: 'text', checkIfUnique: true,
					validation: {isRequired: true, maxLen: 500, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'Status', type: 'text', displayLabel: 'SELLERS.CAPACITIES.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				// Criteria is entered/edited through the capacity dialog (criteria builder), not the generic form.
				// It is rendered as the raw JSON string in the list (mirrors the Master Size Scale Criteria column).
				// For import, the list controller toggles this field creatable and treats it as a valid-JSON cell.
				{ field: 'Criteria', type: 'text', displayLabel: 'SELLERS.CAPACITIES.FIELDS.CRITERIA', visible: true, creatable: false, editable: false, inputType: 'textArea',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', checkIfValidJson: true, messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '', isValidJson: 'VALIDATIONS.INVALID_JSON'}} },
				{ field: 'LinkedCustomersCount', type: 'int', displayLabel: 'SELLERS.CAPACITIES.FIELDS.LINKED_CUSTOMERS_COUNT', visible: true, creatable: false, editable: false, inputType: 'number',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
			],
			uniqueConstraints: [],
			title: 'SELLERS.CAPACITIES.NAV',
			icon: 'icon-gauge',
			idField: 'CapacityId',
			lookupDisplayField: 'Name',
			isDirty: false,
			isBulkActionCompleted: false,
			methods: {
				getList      :   getCapacities,      // API 2
				getDetails   :   getCapacityDetails, // API 3
				create       :   createCapacity,     // API 1
				update       :   updateCapacity,     // API 4
				activateBulk :   setCapacityStatus,  // API 5
				createBulk   :   importCapacities    // API 6
			},
			// DTCR capacity privileges (backend ids in parens):
			//   GetCapacity (4040) list, GetCapacityDetails (4041) view, CreateCapacity (4039),
			//   UpdateCapacity (4042), UpdateCapacityStatus (4043) drop/activate, ImportSellerCapacities (4046).
			views: {
				mainList: {
					columns             : [ 'Name', 'Status', 'Criteria', 'LinkedCustomersCount' ],
					columnFilter        : {},
					toggleFilterProps   : { toggleStatus:false, filterProp:'Status', trueVal:1, trueValTooltipMessage: 'ACTIONS.TOGGLE_ACTIVE', falseVal:'', falseValTooltipMessage:'ACTIONS.TOGGLE_ALL' },
					topIndex            : 0,
					showFilterRow       : false,
					sortColumn          : {'Name': false},
					itemActions         : [
											{ id: 'view', label: 'SELLERS.CAPACITIES.ACTIONS.VIEW_RECORD', icon: 'icon-magnify', privilege: 'GetCapacityDetails', disabled: false, visible: true },
											{ id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UpdateCapacity', disabled: '!itm.Status', visible: true },
											{ id: 'delete', label: 'SELLERS.CAPACITIES.ACTIONS.DROP', icon: 'icon-delete', privilege: 'UpdateCapacityStatus', disabled: false, visible: 'itm.Status',
												requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
											{ id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateCapacityStatus', disabled: false, visible: '!itm.Status',
												requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
										],
					listActions         : [
											{ id: 'import', label: 'ACTIONS.IMPORT', icon: 'icon-import', privilege: 'ImportSellerCapacities', disabled: false, visible: true, requiresConfirmation: false },
											{ id: 'delete', label: 'ACTIONS.DELETE_BULK', icon: 'icon-delete', privilege: 'UpdateCapacityStatus', disabled: '{selected: true, Status: 1}', visible: true,
												requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
											{ id: 'activate', label: 'ACTIONS.ACTIVATE_BULK', icon: 'icon-undo-variant', privilege: 'UpdateCapacityStatus', disabled: '{selected: true, Status: 0}', visible: true,
												requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
										],
					fabAction           : { id: 'add', label: 'ACTIONS.ADD', icon: 'icon-plus', privilege: 'CreateCapacity', visible: true }
				},
				mainDetails: {},
				privileges: {
					list: 'GetCapacity'
				}
			}
		};

		// API VERSIONS: capacity CRUD + status (APIs 1-5) are v2 -> api.t1v2URL.
		// The import background job (API 6) is v1 -> api.baseUrl.

		// API 2 (v2) - GET api/sellers/{sellerId}/capacities
		function getCapacities(generalProperties, sellerId) {
			// When used as a lookup source (link dialogs), api.getLookupData calls getList with no sellerId.
			if(angular.isUndefined(sellerId)) {
				sellerId = catalogFactory.getActiveCatalog().AccountId;
			}
			var forceFetch = angular.isDefined(generalProperties) ? generalProperties.forceFetch : true;
			var promise;
			if(angular.isDefined(generalProperties) && angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
				var state = {};
				state.name = $state.current.name;
				state.params = $state.params;
				var logData = activityLogger.createLogData(null, state, 'sellers.capacities', 'VIEW', true, new Date(), null, null);
				promise = api.webGet(api.t1v2URL + '/sellers/' + sellerId + '/capacities', undefined, true, forceFetch);
				promise = activityLogger.log(logData, promise);
			}
			else {
				promise = api.webGet(api.t1v2URL + '/sellers/' + sellerId + '/capacities', undefined, true, forceFetch);
			}
			// Clear the "records have been modified, please refresh" banner once the refreshed list resolves
			// (jobsTracker sets isBulkActionCompleted=true when the import job completes).
			promise.then(function() {
				api.sellers.capacities.isBulkActionCompleted = false;
			});
			return promise;
		}

		// API 3 (v2) - GET api/sellers/{sellerId}/capacities/{capacityId}
		function getCapacityDetails(isLogRequired, capacityId, sellerId) {
			var promise = api.webGet(api.t1v2URL + '/sellers/' + sellerId + '/capacities/' + capacityId, undefined, true, true);
			if(isLogRequired === true) {
				var state = {};
				state.name = $state.current.name;
				state.params = $state.params;
				var logData = activityLogger.createLogData(null, state, 'sellers.capacities', 'VIEW', false, new Date(), null, null);
				promise = activityLogger.log(logData, promise);
			}
			return promise;
		}

		// API 1 (v2) - POST api/sellers/{sellerId}/capacities
		function createCapacity(capacity, sellerId) {
			var state = {};
			state.name = $state.current.name;
			state.params = $state.params;
			var logData = activityLogger.createLogData(capacity[api.sellers.capacities.lookupDisplayField], state, 'sellers.capacities', 'ADD', false, new Date(), null, null);
			var promise = api.webPost(api.t1v2URL + '/sellers/' + sellerId + '/capacities', capacity);

			promise.then(function() {
				api.sellers.capacities.isDirty = true;
			});
			return activityLogger.log(logData, promise);
		}

		// API 4 (v2) - PUT api/sellers/{sellerId}/capacities/{capacityId}
		function updateCapacity(capacityId, capacity, sellerId) {
			var state = {};
			state.name = $state.current.name;
			state.params = $state.params;
			var logData = activityLogger.createLogData(capacity[api.sellers.capacities.lookupDisplayField], state, 'sellers.capacities', 'EDIT', false, new Date(), null, null);
			var promise = api.webPut(api.t1v2URL + '/sellers/' + sellerId + '/capacities/' + capacityId, capacity);

			promise.then(function() {
				api.sellers.capacities.isDirty = true;
			});
			return activityLogger.log(logData, promise);
		}

		// API 5 (v2) - PUT api/sellers/{sellerId}/capacities/status  (body [{Id, status}])
		function setCapacityStatus(records, model, actionType, sellerId) {
			var result = crud.createRequestObject(records, model, actionType);
			// The shared helper keys each entry by model.idField (CapacityId) and emits lowercase `status`.
			// API 5 expects [{ Id, Status }], so remap to the documented shape.
			var requestObj = result.requestObj.map(function(item) {
				return { Id: item[model.idField], Status: item.status };
			});
			var state = {};
			state.name = $state.current.name;
			state.params = $state.params;
			var isBulk = result.itemsNameList.length > 1 ? true : false;
			var logData = activityLogger.createLogData(result.itemsNameList, state, 'sellers.capacities', actionType.toUpperCase(), isBulk, new Date(), null, null);
			var promise = api.webPut(api.t1v2URL + '/sellers/' + sellerId + '/capacities/status', requestObj);

			promise.then(function() {
				crud.onRecordStatusChange(records, model, actionType);
				api.sellers.capacities.isDirty = true;
			});
			return activityLogger.log(logData, promise);
		}

		// API 6 (v1 bg job) - POST api/sellers/{sellerId}/capacities/import  (background job, upsert by Name)
		function importCapacities(model, data, sellerId) {
			var jobIndex = jobsTracker.addJob(model, 'SELLERS.CAPACITIES.ACTIONS.IMPORT', 1);
			// Excel cells are text, so Criteria arrives as a JSON string. The import contract expects
			// Criteria as an array ([{Attribute, Value:[...]}]), so parse each row before posting.
			var payload = (data || []).map(function(row) {
				return { Name: row.Name, Criteria: toCriteriaArray(row.Criteria) };
			});
			api.webPost(api.baseUrl + '/sellers/' + sellerId + '/capacities/import', payload).then(function(response) {
				jobsTracker.trackJob(jobIndex, response.data.JobId || response.data.Id);
			}).catch(function(error) {
				jobsTracker.setCriticlaFail(jobIndex, error);
			});
		}

		// Coerce a Criteria cell into the array shape the API expects. Accepts an already-parsed array,
		// or a JSON string from an imported Excel cell; anything unparseable becomes an empty array.
		function toCriteriaArray(value) {
			if (angular.isArray(value)) {
				return value;
			}
			if (angular.isString(value) && value.trim() !== '') {
				try {
					var parsed = JSON.parse(value);
					return angular.isArray(parsed) ? parsed : [];
				} catch (e) {
					return [];
				}
			}
			return [];
		}
	}
})();

(function() {
		'use strict';
		
		angular
				.module('app.main.accounts.sellers.article-drop-reasons', [])
				.config(config);

		/* @ngInject */
		function config($translatePartialLoaderProvider) {

				// Translation
				$translatePartialLoaderProvider.addPart('app/main/accounts/sellers/details/tabs/article-drop-reasons');
		}
})();
(function() {
		'use strict';

	angular
			.module('app.main.accounts.sellers.article-drop-reasons')
			.run(runBlock);

	/* @ngInject */
	function runBlock(api, activityLogger, $state, crud) {

		if (angular.isUndefined(api.sellers)) {
			api.sellers = {};
		}
		api.sellers.articleDropReasons = {
				modelPath: 'sellers.articleDropReasons',
				fields: [
						{ field: 'Id', type: 'int', displayLabel: 'ARTICLE_DROP_REASONS.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
								validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
						{ field: 'Reason', type: 'text', displayLabel: 'ARTICLE_DROP_REASONS.FIELDS.REASON', visible: true, creatable: true, editable: true,  inputType: 'textArea', checkIfUnique: true,
								validation: {isRequired: true, maxLen: 2000, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
						{ field: 'Status', type: 'text', displayLabel: 'ARTICLE_DROP_REASONS.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
								validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
						{ field: 'CreatedDate', type: 'text', displayLabel: 'ARTICLE_DROP_REASONS.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
								validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
						{ field: 'UpdatedDate', type: 'text', displayLabel: 'ARTICLE_DROP_REASONS.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
								validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
						{ field: 'CreatedBy', type: 'text', displayLabel: 'ARTICLE_DROP_REASONS.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
								validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
						{ field: 'UpdatedBy', type: 'text', displayLabel: 'ARTICLE_DROP_REASONS.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
								validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
						{ field: 'RequiresReplacement', type: 'int', displayLabel: 'ARTICLE_DROP_REASONS.FIELDS.REQUIRES_REPLACEMENT', visible: true, creatable: true, editable: true, inputType: 'bool-int',
								validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
						{ field: 'RequiresComment', type: 'int', displayLabel: 'ARTICLE_DROP_REASONS.FIELDS.REQUIRES_COMMENT', visible: true, creatable: true, editable: true, inputType: 'bool-int',
								validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
				],
				uniqueConstraints: [],
				title: 'ARTICLE_DROP_REASONS.NAV',
				icon: 'icon-image-filter-black-white',
				idField: 'Id',
				lookupDisplayField: 'Reason',
				isDirty: false,
				isCatalogSpecificModel: true,
				methods: {
						getList         :   getArticleDropReasons,
						create          :   createArticleDropReason,
						update          :   updateArticleDropReason,
						activateBulk    :   activatArticleDropReasons
				},
				views: {
						mainList: {
								columns         : [ 'Id', 'Reason', 'RequiresReplacement', 'RequiresComment', 'Status', 'UpdatedBy', 'UpdatedDate'],
								columnFilter    : {},
								topIndex        : 0,
								showFilterRow   : false,
								sortColumn      : {'UpdatedDate': false},
								itemActions     : [
																		{ id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UpdateArticleDropReason', disabled: '!itm.Status', visible: true },
																		{ id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateArticleDropReasonStatuses', disabled: false, visible: 'itm.Status',
																				requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
																		{ id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateArticleDropReasonStatuses', disabled: false, visible: '!itm.Status',
																				requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
																	],
								listActions     : [
																		{ id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateArticleDropReasonStatuses', disabled: '{selected: true, Status: 1}',
																				visible: true, requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
																		{ id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateArticleDropReasonStatuses', disabled: '{selected: true, Status: 0}',
																				visible: true, requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
																	],
								fabAction       : { id: 'add', label: 'ACTIONS.ADD', icon: 'icon-plus', privilege: 'CreateArticleDropReason:true', visible: true }
						},
						mainDetails: {},
						privileges: {
								list    : 'GetArticleDropReasonList'
						}
				}
		};

		function getArticleDropReasons(generalProperties, sellerId) {
				var promise;

				if (angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
						promise = api.webGet(api.baseUrl + '/sellers/' + sellerId + '/articles/reasons', undefined, true, generalProperties.forceFetch);
				}
				else {
						promise = api.webGet(api.baseUrl + '/sellers/' + sellerId + '/articles/reasons', undefined, true, generalProperties.forceFetch);
				}

				promise.then(function () {
						if (api.sellers.articleDropReasons.isDirty) {
								//Invalidate lookupData
								api.sellers.articleDropReasons.lookupData = undefined;
								api.sellers.articleDropReasons.isDirty = false;
						}
				});
				return promise;
		}

		function createArticleDropReason(record, sellerId) {
			var state = {};
			state.name = $state.current.name;
			state.params = $state.params;
			var logData = activityLogger.createLogData(record[api.sellers.articleDropReasons.lookupDisplayField], state, 'sellers.articleDropReasons', 'ADD', false, new Date(), null, null);
			var promise = api.webPost(api.baseUrl + '/sellers/' + sellerId + '/articles/reasons', record);

			promise.then(function () {
				api.sellers.articleDropReasons.isDirty = true;
			});
			return activityLogger.log(logData, promise);
		}

		function updateArticleDropReason(Id, articleDropReason, sellerId) {
			var state = {};
			state.name = $state.current.name;
			state.params = $state.params;
			var logData = activityLogger.createLogData(articleDropReason[api.sellers.articleDropReasons.lookupDisplayField], state, 'sellers.articleDropReasons', 'EDIT', false, new Date(), null, null);
			var promise = api.webPut(api.baseUrl + '/sellers/' + sellerId + '/articles/reasons/' + Id, articleDropReason);

			promise.then(function () {
				api.sellers.articleDropReasons.isDirty = true;
			});
			return activityLogger.log(logData, promise);
		}

		function activatArticleDropReasons(records, model, actionType, sellerId) {
			var result = crud.createRequestObject(records, model, actionType);
			var state = {};
			state.name = $state.current.name;
			state.params = $state.params;
			var isBulk = result.itemsNameList.length > 1 ? true : false;
			var logData = activityLogger.createLogData(result.itemsNameList, state, 'sellers.articleDropReasons', actionType.toUpperCase(), isBulk, new Date(), null, null);
			var promise = api.webPut(api.baseUrl + '/sellers/' + sellerId + '/articles/reasons/status', result.requestObj);

			promise.then(function () {
				api.sellers.articleDropReasons.isDirty = true;
			});

			return activityLogger.log(logData, promise);
		}

}
})();

(function () {
	'use strict';

	angular
		.module('app.viewCreator')
		.controller('createInterfaceUserController', createInterfaceUserController);

	/* @ngInject */
	function createInterfaceUserController($mdDialog, $scope, $filter, hotkeys, $window, api, toast, utility, model, record, isNew, lookupPromises) {
		var vm = this;

		//data
		vm.isLoading = false;
		vm.record = (angular.isDefined(record) && record != null) ? angular.copy(record) : {};
		vm.lookupModel = angular.copy(vm.record);
		vm.isNew = isNew;
		vm.searchText = '';
		vm.record.loginType = 1;//login type is password for all interface users
		vm.record.createUserOnT1 = false;
		vm.searchText = {};

		vm.accountTypes = [
			{ id: 1, value: "Admin" },
			{ id: 2, value: "Seller", lookupSource: 'accounts.sellers' },
			{ id: 3, value: "Buyer", lookupSource: 'accounts.buyers' }
		];
		vm.accountType = {};
		var requestforSeller = false;
		var requestforBuyer = false;


		//methods
		vm.saveRecord = saveRecord;
		vm.closeDialog = closeDialog;

		vm.onAccountTypeChange = loadAccounts;
		vm.lookupSearch = lookupSearch;
		vm.lookupChange = lookupChange;
		vm.getLookupDisplayValue = getLookupDisplayValue;
		vm.selectText = selectText;

		activate();

		////////////////

		function activate() {
			//Hotkeys
			hotkeys.bindTo($scope).add({
				combo: 'ctrl+enter',
				description: $filter('translate')('ACTIONS.SAVE'),
				allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
				callback: function (event) {
					if (!vm.isLoading && !vm.editForm.$invalid) {
						vm.saveRecord();
					}
				}
			});

			if (vm.isNew) {
				hotkeys.bindTo($scope).add({
					combo: 'ctrl+shift+enter',
					description: $filter('translate')('ACTIONS.SAVE_AND_NEW'),
					allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
					callback: function (event) {
						if (!vm.isLoading && !vm.editForm.$invalid) {
							vm.saveRecord(true);
						}
					}
				});
			}
		}

		function saveRecord(saveAndNew) {
			vm.isLoading = true;

			var p;

			if (vm.isNew) {
				if (vm.accountTypeId === 1) {
					vm.record.accountId = 1;
				}
				p = model.methods.create(vm.record);
			}
			// else {
			//     p = model.methods.update(vm.record[model.idField], vm.record);
			// }

			p.then(function () {
				if (vm.isNew && angular.isDefined(saveAndNew) && saveAndNew) {

					vm.editForm.$setPristine();
					vm.editForm.$setUntouched();
					vm.record = {};
					vm.searchText = {};
					vm.accountType = {};
					vm.isDataDirty = true;

					var el = $window.document.getElementById('dialog_input_first');
					if (el) {
						el.focus();
					}
				} else {
					closeDialog(true);
				}

				var toastMessage;
				toastMessage = 'SUCCESS.CREATE';
				toast.success(toastMessage, '', '');
			}, function (err) {
				closeDialog(vm.isDataDirty);
			}).finally(function () {
				vm.isLoading = false;
			})
		}

		function closeDialog(saved) {
			$mdDialog.hide(saved);
		}

		function loadAccounts(accountType) {
			if (accountType.id === 2 && !requestforSeller) {
				requestforSeller = true;
				lookupPromises['Seller'] = api.getLookupData(api.accounts.sellers);
			}
			else if (accountType.id === 3 && !requestforBuyer) {
				requestforBuyer = true;
				lookupPromises['Buyer'] = api.getLookupData(api.accounts.buyers);
			}
			vm.accountTypeId = accountType.id; // use to filter role based on selected account type
			vm.lookupModel.AccountId = undefined; // to clear account field on account type change
			vm.searchText.AccountId = '';
		}

		function lookupSearch(query, field, lookupSource, lookupFilter) {
			var results = [];
			var predicate = angular.isDefined(lookupFilter) ? angular.copy(lookupFilter) : {};
			predicate.value = query;
			var lookupModel = api.getModel(lookupSource);

			if (angular.isDefined(lookupModel.lookupData) && angular.isDefined(lookupModel.lookupData.data) && lookupModel.lookupData.data.length) {
				results = query ? utility.filterObject(lookupModel.lookupData.data, predicate) : utility.filterObject(lookupModel.lookupData.data, lookupFilter, true);
				return results;
			}
			else {
				return lookupPromises[field].then(function (lookupData) {
					results = query ? utility.filterObject(lookupData.data, predicate) : utility.filterObject(lookupData.data, lookupFilter, true);
					return results;
				});
			}
		}

		// convert dropdown scope value form object(lookup record) to id property of lookup record
		function lookupChange(selectedObj, field) {

			if (angular.isObject(selectedObj)) {
				vm.record[field] = selectedObj.id;
			}
			else if (angular.isUndefined(selectedObj) || selectedObj === null) {
				vm.record[field] = undefined; // on record removal make field undefined or the property can be deleted using delete keywork
			}
		}

		function getLookupDisplayValue(item, field, lookupSource) {
			var lookupModel = api.getModel(lookupSource);

			if (angular.isDefined(lookupModel.lookupData) && angular.isDefined(lookupModel.lookupData.data) && lookupModel.lookupData.data.length) {
				return getLookupDisplayVal(item, lookupModel.lookupData);
			}
			else {
				return lookupPromises[field].then(function (lookupData) {
					return getLookupDisplayVal(item, lookupData);
				});
			}
		}

		//helper method
		function getLookupDisplayVal(item, lookupData) {
			var result;
			if (lookupData) {
				// since autocomplte return object
				if (angular.isObject(item)) {
					result = utility.filterObject(lookupData.data, { id: item.id }, true);
				}
				// to initialize field value if any (when open update record dialog)
				else {
					result = utility.filterObject(lookupData.data, { id: item }, true);
				}

				if (angular.isArray(result) && result.length > 0) {
					return result[0].value;
				}
				else {
					return result.value;
				}
			}
		}

		function selectText(event) {
			utility.selectInputText(event);
		}

	}

})();
(function() {
    'use strict';

    angular
        .module('app.main.accounts.buyers.users', []);
})();
(function() {
    'use strict';

    angular
        .module('app.main.accounts.buyers.users')
        .run(runBlock);

    /* @ngInject */
    function runBlock(api, activityLogger, $state, crud, toast) {

        if(angular.isUndefined(api.buyers)) {
            api.buyers = {};
        }
        api.buyers.users = {
            modelPath: 'buyers.users',
            fields: [
                { field: 'Id', type: 'int', displayLabel: 'USERS.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'AccountId', type: 'int', displayLabel: 'USERS.FIELDS.ACCOUNT_ID', visible: false, creatable: false, editable: false, inputType: 'static',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'AccountName', type: 'text', displayLabel: 'USERS.FIELDS.ACCOUNT_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'FirstName', type: 'int', displayLabel: 'USERS.FIELDS.FIRST_NAME', visible: true, creatable: true, editable: true, inputType: 'text',
                    validation: {isRequired: true, maxLen: 20, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'LastName', type: 'text', displayLabel: 'USERS.FIELDS.LAST_NAME', visible: true, creatable: true, editable: true, inputType: 'text',
                    validation: {isRequired: true, maxLen: 20, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Email', type: 'text', displayLabel: 'USERS.FIELDS.EMAIL', visible: true, creatable: true, editable: true, inputType: 'text',
                    validation: {isRequired: true, maxLen: 500, minLen: 1, pattern: '^[A-Za-z]+[A-Za-z0-9._+-]+@{1}[A-Za-z0-9._-]+\.[A-Za-z.]{2,}$', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: 'VALIDATIONS.INVALID_EMAIL'}} },
                { field: 'UserName', type: 'text', displayLabel: 'USERS.FIELDS.USER_NAME', visible: true, creatable: true, editable: true, inputType: 'text',
                    validation: {isRequired: true, maxLen: 50, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Phone', type: 'text', displayLabel: 'USERS.FIELDS.PHONE', visible: true, creatable: true, editable: true, inputType: 'tel',
                    validation: {isRequired: false, maxLen: 20, minLen: 0, pattern: '[0-9]*', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '',
                    invalidType: 'VALIDATIONS.INVALID_PHONE_NUMBER'}} },
                { field: 'CountryCode', type: 'text', displayLabel: 'USERS.FIELDS.COUNTRY', visible: false, creatable: true, editable: true, inputType: 'lookup', lookupSource: 'lists.countries',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CountryCode', type: 'text', displayLabel: 'USERS.FIELDS.COUNTRY_CODE', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Country', type: 'text', displayLabel: 'USERS.FIELDS.COUNTRY', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'City', type: 'text', displayLabel: 'USERS.FIELDS.CITY', visible: true, creatable: true, editable: true, inputType: 'text',
                    validation: {isRequired: false, maxLen: 25, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Designation', type: 'text', displayLabel: 'USERS.FIELDS.DESIGNATION', visible: true, creatable: true, editable: true, inputType: 'text',
                    validation: {isRequired: false, maxLen: 20, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Department', type: 'text', displayLabel: 'USERS.FIELDS.DEPARTMENT', visible: true, creatable: true, editable: true, inputType: 'text',
                    validation: {isRequired: false, maxLen: 20, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Status', type: 'text', displayLabel: 'USERS.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Roles', type: 'text', displayLabel: 'USERS.FIELDS.USER_ROLE', visible: true, creatable: true, editable: true, inputType: 'lookup-many', lookupSource: 'roles.roles',
                    lookupFilter: {'AccountTypeId': 3}, // these are buyer account users, so only buyer roles are applicable
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreateDate', type: 'text', displayLabel: 'USERS.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdateDate', type: 'text', displayLabel: 'USERS.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedBy', type: 'text', displayLabel: 'USERS.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedBy', type: 'text', displayLabel: 'USERS.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
            ],
            uniqueConstraints: [
                {name: 'Constraint 1', fields: ['AccountName']}
            ],
            title: 'USERS.NAV',
            icon: '',
            idField: 'Id',
            lookupDisplayField: 'Email',
            isDirty: false,
            methods: {
                getList         :   getBuyerUsers,
                activateBulk    :   activateUsers,
                update          :   updateUser
            },
            views: {
                mainList: {
                    columns             : [ 'FirstName', 'Email', 'Designation', 'Status', 'UpdateDate' ],
                    columnFilter        : {},
                    toggleFilterProps   : { toggleStatus:false, filterProp:'Status', trueVal:1, trueValTooltipMessage: 'ACTIONS.TOGGLE_ACTIVE', falseVal:'', falseValTooltipMessage:"ACTIONS.TOGGLE_ALL"},
                    topIndex            : 0,
                    showFilterRow       : false,
                    sortColumn          : {'UpdateDate': false},
                    itemActions         : [
                                            { id: 'view', label: 'ACTIONS.VIEW', icon: 'icon-magnify', privilege: 'GetUserDetails', disabled: '!itm.Status', visible: true },
                                            { id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UpdateUser', disabled: '!itm.Status', visible: true },
                                            { id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateBulkUserStatus', disabled: false, visible: 'itm.Status',
                                                requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                                            { id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateBulkUserStatus', disabled: false, visible: '!itm.Status',
                                                requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
                                        ],
                    listActions         : [
                                            { id: 'delete', label: 'ACTIONS.DELETE_BULK', icon: 'icon-delete', privilege: 'UpdateBulkUserStatus', disabled: '{selected: true, Status: 1}', visible: true,
                                                requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                                            { id: 'activate', label: 'ACTIONS.ACTIVATE_BULK', icon: 'icon-undo-variant', privilege: 'UpdateBulkUserStatus', disabled: '{selected: true, Status: 0}', visible: true,
                                                requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'},
                                            { id: 'changeAccount', label: 'USERS.ACTIONS.CHANGE_ACCOUNT', icon: 'icon-account-switch', privilege: 'ChangeUsersAccount:true', disabled: '{selected: true}', visible: true,
                                                requiresConfirmation: false, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'ARTICLES.MESSAGES.CONFIRM_ASSIGN'}, confirmationAction: 'ACTIONS.ASSIGN'}
                                        ]
                },
                mainDetails: {
                    selectedTabIndex   : 0,
                    itemActions        : [
                                            { id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateSellerAccountStatusBulk', disabled: '{selected: true, Status: 1}',
                                                visible: true, requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                                            { id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateSellerAccountStatusBulk', disabled: '{selected: true, Status: 0}',
                                                visible: true, requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
                                        ],
                    fabAction           : {id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UpdateUser', visible: true}
                },
                privileges: {
                    list: 'GetBuyersUsersList',
                    details: 'GetUserDetails'
                }
            }
        };


        function getBuyerUsers(generalProperties, accountId) {
             var promise;
             if(angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
                var state = {};
                state.name = $state.current.name;
                state.params = $state.params;
                var isBulk = true;
                var logData = activityLogger.createLogData(null, state, 'buyers.users', 'VIEW', isBulk, new Date(), null, null);
                promise = api.webGet(api.baseUrl + '/buyers/' + accountId + '/users', undefined, true, generalProperties.forceFetch);
                promise = activityLogger.log(logData, promise);
             }
             else {
                 promise = api.webGet(api.baseUrl + '/buyers/' + accountId + '/users', undefined, true, generalProperties.forceFetch);
             }
             return promise;
        }


        function activateUsers(records, model, actionType) {
            var result = crud.createRequestObject(records, model, actionType);
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var isBulk = result.itemsNameList.length > 1 ? true : false;
            var logData = activityLogger.createLogData(result.itemsNameList, state, 'buyers.users', actionType.toUpperCase(), isBulk, new Date(), null, null);
            var promise = api.webPut(api.baseUrl + '/users/status', result.requestObj);

            promise.then(function() {
                crud.onRecordStatusChange(records, model, actionType);
            });

            return activityLogger.log(logData, promise);
        }

        function updateUser(userId, user) {
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var logData = activityLogger.createLogData(user[api.buyers.users.lookupDisplayField], state, 'buyers.users', 'EDIT', false, new Date(), null, null);
            var promise = api.webPut(api.baseUrl + '/users/' + userId , user);

            promise.then(function() {
               api.buyers.users.isDirty = true;
            });
            return activityLogger.log(logData, promise);
        }

    }
})();
(function() {
  'use strict';

  angular
      .module('app.main.accounts.buyers.customers', []);
})();
(function () {
  'use strict';

  angular
  .module('app.main.accounts.buyers.customers')
  .run(runBlock);

  /* @ngInject */
  function runBlock(api, activityLogger, $state, crud, toast) {

    if (angular.isUndefined(api.buyers)) {
      api.buyers = {};
    }
    api.buyers.customers = {
      modelPath: 'buyers.customers',
      fields: [
          { field: 'SellerAccountId', type: 'int', displayLabel: 'CUSTOMERS.FIELDS.SELLER_ID', visible: true, creatable: false, editable: false, inputType: 'number',
              validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
          { field: 'SellerAccountName', type: 'text', displayLabel: 'CUSTOMERS.FIELDS.SELLER_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
              validation: {isRequired: false, maxLen: 100, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
          { field: 'CustomerCode', type: 'int', displayLabel: 'CUSTOMERS.FIELDS.CUSTOMER_CODE', visible: true, creatable: false, editable: false, inputType: 'text',
              validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
          { field: 'CustomerName', type: 'text', displayLabel: 'CUSTOMERS.FIELDS.CUSTOMER_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
              validation: {isRequired: false, maxLen: 100, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
      ],
      uniqueConstraints: [],
      title: 'CUSTOMERS.NAV',
      icon: 'icon-alert-box',
      idField: 'CustomerCode',
      lookupDisplayField: 'CustomerName',
      isDirty: false,
      methods: {
        getList: getBuyerCustomers
      },
      views: {
        mainList: {
          columns: [ 'CustomerCode', 'CustomerName', 'SellerAccountId', 'SellerAccountName' ],
          columnFilter: {},
          toggleFilterProps: {},
          topIndex: 0,
          showFilterRow: false,
          sortColumn: {},
          sortDescending: true,
          itemActions: [],
          listActions: [],
          fabAction:{}
        },
        mainDetails: { },
        privileges: {
          list: 'GetBuyerCustomerList'
        }
      }
    };

    function getBuyerCustomers(generalProperties, accountId) {
      var promise;

      if (angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
        var state = {};
        state.name = $state.current.name;
        state.params = $state.params;
        var isBulk = true;
        var logData = activityLogger.createLogData(null, state, 'buyers.customers', 'VIEW', isBulk, new Date(), null, null);
        promise = api.webGet(api.baseUrl + '/buyers/' + accountId + '/customers', undefined, true, generalProperties.forceFetch);
        promise = activityLogger.log(logData, promise);
      }
      else {
        promise = api.webGet(api.baseUrl+ '/buyers/' + accountId + '/customers', undefined, true, generalProperties.forceFetch);
      }

      promise.then(function () {
        if (api.buyers.customers.isDirty) {
          //Invalidate lookupData
          api.buyers.customers.lookupData = undefined;
          api.buyers.customers.isDirty = false;
        }
      });
      return promise;
    }
  }
})();
(function() {
    'use strict';

    angular
        .module('app.main.accounts.buyers.catalogs', []);
})();
(function() {
    'use strict';

    angular
        .module('app.main.accounts.buyers.catalogs')
        .run(runBlock);

    /* @ngInject */
    function runBlock(api, activityLogger, $state) {

        if(angular.isUndefined(api.buyers)) {
            api.buyers = {};
        }
         api.buyers.catalogs = {
            modelPath: 'buyers.catalogs',
            fields: [
                { field: 'Id', type: 'int', displayLabel: 'CATALOGS.FIELDS.ID', visible: false, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'DataSourceTypeId', type: 'int', displayLabel: 'CATALOGS.FIELDS.DATA_SOURCE_TYPE', visible: false, creatable: true, editable: false, inputType: 'lookup',  lookupSource: 'lists.dataSourceTypes',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'DataSourceType', type: 'text', displayLabel: 'CATALOGS.FIELDS.DATA_SOURCE_TYPE', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: 100, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'AccountId', type: 'int', displayLabel: 'CATALOGS.FIELDS.SELLER_ACCOUNT', visible: false, creatable: true, editable: true, inputType: 'lookup', lookupSource: 'accounts.sellers',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CatalogCode', type: 'int', displayLabel: 'CATALOGS.FIELDS.CATALOG_CODE', visible: false, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CatalogName', type: 'text', displayLabel: 'CATALOGS.FIELDS.CATALOG_NAME', visible: true, creatable: true, editable: true, inputType: 'text',
                    validation: {isRequired: true, maxLen: 100, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ReferenceCatalogCode', type: 'text', displayLabel: 'CATALOGS.FIELDS.REFERENCE_CATAOG_CODE', visible: true, creatable: true, editable: false, inputType: 'lookup', lookupSource: 'catalogs.catalogs',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', disabledCriteria: 'vm.record.DataSourceTypeId === 1', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'AttributeGroupId', type: 'int', displayLabel: 'CATALOGS.FIELDS.ATTRIBUTE_GROUP_NAME', visible: false, creatable: true, editable: false, inputType: 'lookup', lookupSource: 'attributes.attributeGroups',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', disabledCriteria: 'vm.record.DataSourceTypeId === 2 || vm.record.DataSourceTypeId === 3', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'AttributeGroupName', type: 'text', displayLabel: 'CATALOGS.FIELDS.ATTRIBUTE_GROUP_NAME', visible: false, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'AttributeIdsList', type: 'text', displayLabel: 'CATALOGS.FIELDS.ATTRIBUTE_IDS_LIST', visible: false, creatable: true, editable: true, inputType: 'lookup-many', lookupSource: 'attributes.attributes',
                    validation: {isRequired: 'vm.record.DataSourceTypeId === 3', maxLen: -1, minLen: 0, pattern: '', disabledCriteria: 'vm.record.DataSourceTypeId === 2', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ImageName', type: 'text', displayLabel: 'CATALOGS.FIELDS.IMAGE_NAME', visible: false, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: 100, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ImageFile', type: 'text', displayLabel: 'CATALOGS.FIELDS.IMAGE_FILE', visible: false, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: 100, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ImagePath', type: 'text', displayLabel: 'CATALOGS.FIELDS.IMAGE_PATH', visible: false, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: 100, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'IsVasInUse', type: 'text', displayLabel: 'CATALOGS.FIELDS.IS_VAS_IN_USE', visible: true, creatable: false, editable: false, inputType: 'int-bool',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Status', type: 'text', displayLabel: 'CATALOGS.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Season', type: 'text', displayLabel: 'CATALOGS.FIELDS.SEASON', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: 100, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Year', type: 'int', displayLabel: 'CATALOGS.FIELDS.YEAR', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CatalogShared', type: 'text', displayLabel: 'CATALOGS.FIELDS.CATALOG_SHARED', visible: false, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedDate', type: 'text', displayLabel: 'CATALOGS.FIELDS.CREATED_DATE', visible: false, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedDate', type: 'text', displayLabel: 'CATALOGS.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UserId', type: 'text', displayLabel: 'CATALOGS.FIELDS.USER_ID', visible: false, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CatalogCRDList', type: 'text', displayLabel: 'CATALOGS.FIELDS.CATALOG_CRD_LIST', visible: false, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CatalogSpecificConfigurationList', type: 'text', displayLabel: 'CATALOGS.FIELDS.CATALOG_SPECIFIC_CONFIGURATION_LIST', visible: false, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CatalogPriceGroupList', type: 'text', displayLabel: 'CATALOGS.FIELDS.CATALOG_PRICEGROUP_LIST', visible: false, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedBy', type: 'text', displayLabel: 'CATALOGS.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'SourceCatalog', type: 'int', displayLabel: 'CATALOGS.FIELDS.SOURCE_CATALOG', visible: false, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ReceiveOrders', type: 'text', displayLabel: 'CATALOGS.FIELDS.RECEIVE_ORDERS', visible: true, creatable: false, editable: false, inputType: 'bool-int',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ReceiveOrdersWithoutPrice', type: 'int', displayLabel: 'CATALOGS.FIELDS.RECEIVE_ORDERS_WITHOUT_PRICE', visible: true, creatable: false, editable: false, inputType: 'bool-int',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ArticleCascading', type: 'text', displayLabel: 'CATALOGS.FIELDS.ARTICLE_CASCADING', visible: true, creatable: false, editable: false, inputType: 'bool-int',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'IsStockApply', type: 'text', displayLabel: 'CATALOGS.FIELDS.IS_STOCK_APPLY', visible: true, creatable: false, editable: false, inputType: 'bool-int',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'SegmentationCascading', type: 'text', displayLabel: 'CATALOGS.FIELDS.SEGMENTATION_CASCADING', visible: true, creatable: false, editable: false, inputType: 'bool-int',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'SegmentationPlanningEnable', type: 'text', displayLabel: 'CATALOGS.FIELDS.SEGMENTATION_PLANNING_ENABLE', visible: true, creatable: false, editable: false, inputType: 'bool-int',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ArticleLocking', type: 'text', displayLabel: 'CATALOGS.FIELDS.ARTICLE_LOCKING', visible: true, creatable: false, editable: false, inputType: 'bool-int',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'State', type: 'text', displayLabel: 'CATALOGS.FIELDS.STATE', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'IsLinePlan', type: 'text', displayLabel: 'CATALOGS.FIELDS.IS_LINE_PLAN',visible: false, creatable: false, editable: false, inputType: 'bool-int',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'LinkedCatalogs', type: 'text', displayLabel: 'CATALOGS.FIELDS.LINKED_CATALOGS', visible: false, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'LinkedAttributes', type: 'text', displayLabel: 'CATALOGS.FIELDS.LINKED_ATTRIBUTES', visible: false, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CustomerId', type: 'int', displayLabel: 'CATALOGS.FIELDS.CUSTOMER_ID', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' }} },
                { field: 'CustomerCode', type: 'text', displayLabel: 'CATALOGS.FIELDS.CUSTOMER_CODE', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CustomerName', type: 'text', displayLabel: 'CATALOGS.FIELDS.CUSTOMER_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: 100, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
            ],
            uniqueConstraints: [
                {name: 'Constraint 1', fields: ['CatalogName']}
            ],
            title: 'CATALOGS.NAV',
            icon: 'icon-book-open',
            idField: 'CatalogCode',
            lookupDisplayField: 'CatalogName',
            isDirty: false,
            methods: {
                getList         :   getBuyerCatalogs
            },
            views: {
                 mainList: {
                    columns         : [ 'CatalogCode', 'CatalogName', 'ReferenceCatalogCode', 'Status', 'UpdatedDate' ],
                    columnFilter    : {},
                    toggleFilterProps: { toggleStatus:false, filterProp:'Status', trueVal:1, trueValTooltipMessage: 'ACTIONS.TOGGLE_ACTIVE', falseVal:'', falseValTooltipMessage:"ACTIONS.TOGGLE_ALL"},
                    topIndex        : 0,
                    showFilterRow   : false,
                    sortColumn      : {'UpdatedDate': false},
                    itemActions     : [
                                        { id: 'view', label: 'ACTIONS.VIEW', icon: 'icon-magnify', privilege: 'GetCatalogDetails', disabled: '!itm.Status', visible: true }
                                      ],
                    listActions     : [],
                    fabAction       : {}

                 },
                 mainDetails: { },
                 privileges: {
                     list: 'GetBuyerCatalogList',
                     details: 'GetCatalogDetails',
                     buyerDetails: 'GetBuyerCatalogDetails'
                 }
            }
        };

        function getBuyerCatalogs(generalProperties, accountId) {
            var promise;

            if(angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
                var state = {};
                state.name = $state.current.name;
                state.params = $state.params;
                var isBulk = false;
                var logData = activityLogger.createLogData(null, state, 'catalogs.catalogs', 'VIEW', isBulk, new Date(), null, null);
                promise = api.webGet(api.baseUrl + '/buyers/'+ accountId +'/catalogs', undefined, true, generalProperties.forceFetch);
                promise = activityLogger.log(logData, promise);
            }
            else {
                promise = api.webGet(api.baseUrl + '/buyers/'+ accountId +'/catalogs', undefined, true, generalProperties.forceFetch);
            }

            return promise;
        }

    }
})();
(function () {
	'use strict';

	angular
		.module('app.viewCreator')
		.controller('createAuthUserController', createAuthUserController);

	/* @ngInject */
	function createAuthUserController($mdDialog, $scope, $filter, hotkeys, $window, $log, api, toast, utility, model, record, isNew, lookupPromises, masterUsersList, masterUserName, existingUsers, $localStorage) {
		var vm = this;

		//data
		vm.isLoading = false;
		vm.record = (angular.isDefined(record) && record != null) ? angular.copy(record) : {};
		vm.record.allowedClients = (!vm.record.allowedClients) ? [] : vm.record.allowedClients;
		vm.record.restrictFullRange = 0;
		vm.lookupModel = angular.copy(vm.record);
		vm.isNew = isNew;
		vm.searchText = '';
		vm.masterUsersList = masterUsersList;
		vm.existingUsers = existingUsers; // list of existing auth users, used to validate username uniqueness

		// precompute lowercase list of existing emails in the system for uniqueness validation
		var existingEmailsLowerCase = [];
		angular.forEach(existingUsers, function (user) {
			if (user.email) {
				existingEmailsLowerCase.push(user.email.toString().trim().toLowerCase());
			}
		});
		var selectedMasterUserEmail = null; // email of the currently selected master user (if any)

		vm.acSelectedItem = [];
		vm.acSearchText = [];
		vm.searchText = {};

		vm.accountTypes = [
			{ id: 1, value: "Admin" },
			{ id: 2, value: "Seller", lookupSource: 'accounts.sellers' },
			{ id: 3, value: "Buyer", lookupSource: 'accounts.buyers' }
		];
		vm.accountType = {};
		var requestforSeller = false;
		var requestforBuyer = false;
		vm.isAboveMasterUserDropDownLimit = false;

		if(!vm.isNew && angular.isDefined(masterUserName)) {
			vm.lookupModel.masterUser = vm.lookupModel.masterUser < 1 ? '' : masterUserName;
		}

		//methods
		vm.saveRecord = saveRecord;
		vm.closeDialog = closeDialog;

		vm.onAccountTypeChange = loadAccounts;
		vm.lookupSearch = lookupSearch;
		vm.lookupChange = lookupChange;
		vm.getLookupDisplayValue = getLookupDisplayValue;
		vm.selectText = selectText;

		vm.transformChip = transformChip;
		vm.acQuerySearch = acQuerySearch;
		vm.getChipDisplayValue = getChipDisplayValue;
		vm.querySearch = querySearch;
		vm.masterUserChange = masterUserChange;
		vm.validateEmail = validateEmail;



		activate();

		////////////////

		function activate() {
			//Hotkeys
			hotkeys.bindTo($scope).add({
				combo: 'ctrl+enter',
				description: $filter('translate')('ACTIONS.SAVE'),
				allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
				callback: function (event) {
					if (!vm.isLoading && !vm.editForm.$invalid) {
						vm.saveRecord();
					}
				}
			});

			if (vm.isNew) {
				hotkeys.bindTo($scope).add({
					combo: 'ctrl+shift+enter',
					description: $filter('translate')('ACTIONS.SAVE_AND_NEW'),
					allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
					callback: function (event) {
						if (!vm.isLoading && !vm.editForm.$invalid) {
							vm.saveRecord(true);
						}
					}
				});
			}
		}

		function saveRecord(saveAndNew) {
			vm.isLoading = true;

			var p;

			if (vm.isNew) {
				vm.record.envCode = $localStorage.env.code;
				// trim all the leading and trailing spaces from username
				vm.record.username = vm.record.username.trim();
				if (vm.accountTypeId === 1) {
					vm.record.accountId = 1;
					vm.record.userType = 90;
				} else if (vm.accountTypeId === 2 || vm.accountTypeId === 3) {
					vm.record.userType = 0;
				}
				p = model.methods.create(vm.record);
			}
			else {
				/**
				 *  when user change login type while logged in and system gets locked show current logintype lock screen
				 */
				$localStorage.user = angular.isDefined($localStorage.user) ? $localStorage.user : {};
				if(angular.isDefined($localStorage.user.loginType) && $localStorage.user.loginType !== vm.record.loginType) {
					$localStorage.user.loginType = vm.record.loginType;
				}
			    p = model.methods.update(vm.record[model.idField], vm.record);
			}

			p.then(function (response) {
				if (vm.isNew && angular.isDefined(saveAndNew) && saveAndNew) {

					vm.editForm.$setPristine();
					vm.editForm.$setUntouched();
					vm.record = {};
					vm.record.allowedClients = [];
					vm.acSearchText = [];
					vm.searchText = {};
					vm.accountType = {};
					vm.lookupModel.masterUser = '';
					vm.isDataDirty = true;

					var el = $window.document.getElementById('dialog_input_first');
					if (el) {
						el.focus();
					}
				} else {
					closeDialog(true);
				}

				var toastMessage;
				toastMessage = response.config.method.toUpperCase() === 'POST' ? 'SUCCESS.CREATE' : 'SUCCESS.UPDATE';
				toast.success(toastMessage, '', '');
			}, function (err) {
				closeDialog(vm.isDataDirty);
			}).finally(function () {
				vm.isLoading = false;
			})
		}

		function closeDialog(saved) {
			$mdDialog.hide(saved);
		}

		function loadAccounts(accountType) {
			if (accountType.id === 2 && !requestforSeller) {
				requestforSeller = true;
				lookupPromises['Seller'] = api.getLookupData(api.accounts.sellers);
			}
			else if (accountType.id === 3 && !requestforBuyer) {
				requestforBuyer = true;
				lookupPromises['Buyer'] = api.getLookupData(api.accounts.buyers);
			}
			vm.accountTypeId = accountType.id; // use to filter role based on selected account type
			vm.lookupModel.accountId = undefined; // to clear account field on account type change
			vm.searchText.accountId = '';
		}

		function lookupSearch(query, field, lookupSource, lookupFilter) {
			var results = [];
			var predicate = angular.isDefined(lookupFilter) ? angular.copy(lookupFilter) : {};
			predicate.value = query;
			var lookupModel = api.getModel(lookupSource);

			if (angular.isDefined(lookupModel.lookupData) && angular.isDefined(lookupModel.lookupData.data) && lookupModel.lookupData.data.length) {
				results = query ? utility.filterObject(lookupModel.lookupData.data, predicate) : utility.filterObject(lookupModel.lookupData.data, lookupFilter, true);
				return results;
			}
			else {
				return lookupPromises[field].then(function (lookupData) {
					results = query ? utility.filterObject(lookupData.data, predicate) : utility.filterObject(lookupData.data, lookupFilter, true);
					return results;
				});
			}
		}

		// convert dropdown scope value form object(lookup record) to id property of lookup record
		function lookupChange(selectedObj, field) {

			if (angular.isObject(selectedObj)) {
				vm.record[field] = selectedObj.id;
			}
			else if (angular.isUndefined(selectedObj) || selectedObj === null) {
				vm.record[field] = undefined; // on record removal make field undefined or the property can be deleted using delete keywork
			}
		}

		function getLookupDisplayValue(item, field, lookupSource) {
			var lookupModel = api.getModel(lookupSource);

			if (angular.isDefined(lookupModel.lookupData) && angular.isDefined(lookupModel.lookupData.data) && lookupModel.lookupData.data.length) {
				return getLookupDisplayVal(item, lookupModel.lookupData);
			}
			else {
				return lookupPromises[field].then(function (lookupData) {
					return getLookupDisplayVal(item, lookupData);
				});
			}
		}

		//helper method
		function getLookupDisplayVal(item, lookupData) {
			var result;
			if (lookupData) {
				// since autocomplte return object
				if (angular.isObject(item)) {
					result = utility.filterObject(lookupData.data, { id: item.id }, true);
				}
				// to initialize field value if any (when open update record dialog)
				else {
					result = utility.filterObject(lookupData.data, { id: item }, true);
				}

				if (angular.isArray(result) && result.length > 0) {
					return result[0].value;
				}
				else {
					return result.value;
				}
			}
		}

		function selectText(event) {
			utility.selectInputText(event);
		}

		function transformChip(chip) {
			if (angular.isObject(chip)) {
				return chip.id;
			}
			return undefined;
		}

		function acQuerySearch(query, selectedRecords, fieldName) {
			var results = [];
			var field = utility.filterObject(model.fields, { field: fieldName }, true)[0];
			var lookupFilter = angular.isDefined(field.lookupFilter) ? field.lookupFilter : {};
			var predicate = angular.copy(lookupFilter);
			predicate.value = query;

			var lookupModel = api.getModel(field.lookupSource);
			if (angular.isDefined(lookupModel.lookupData) && angular.isDefined(lookupModel.lookupData.data) && lookupModel.lookupData.data.length) {
				results = query ? utility.filterObject(lookupModel.lookupData.data, predicate) : utility.filterObject(lookupModel.lookupData.data, lookupFilter);
				results = removeSelectedChips(selectedRecords, results);
				return results;
			}
			else {
				return lookupPromises[field.field].then(function (lookupData) {
					results = query ? utility.filterObject(lookupData.data, predicate) : utility.filterObject(lookupData.data, lookupFilter);
					results = removeSelectedChips(selectedRecords, results);
					return results;
				});
			}
		}

		/**
		 * @description
		 * This method will remove selected chips form records (helper method)
		 * @param {array} selectedRecords: list of selected chips
		 * @param {array} records: data property of lookup-data
		 * @returns {array}: list of available chips (chips which are not selected) // it does not really need to return a value but for readability returning modified value
		 */
		function removeSelectedChips(selectedRecords, records) {
			if (angular.isDefined(selectedRecords) && selectedRecords.length > 0) {
				for (var index = records.length - 1; index >= 0; index--) {
					if (selectedRecords.indexOf(records[index].id) !== -1) {
						records.splice(index, 1);
					}
				}
			}
			return records;
		}

		function getChipDisplayValue(chip, fieldName) {
			var field = utility.filterObject(model.fields, { field: fieldName }, true)[0];
			var lookupModel = api.getModel(field.lookupSource);
			if (angular.isDefined(lookupModel.lookupData) && angular.isDefined(lookupModel.lookupData.data) && lookupModel.lookupData.data.length) {
				return getChipDisplayVal(lookupModel.lookupData, chip);
			}
			else { // it will never go to else part since before try to load display value for selected chips, it always load lookup on focus of chips input element
				return lookupPromises[field.field].then(function (lookupData) {
					return getChipDisplayVal(lookupData, chip);
				});
			}
		}

		//helper method
		function getChipDisplayVal(lookupData, chip) {
			var res = utility.filterObject(lookupData.data, { id: chip }, true);
			if (angular.isArray(res) && res.length > 0) {
				return res[0].value;
			}
			else {
				$log.warn('viewCreator controller: Unable to resolve chip display value!');
				return "";
			}
		}

		function querySearch(search) {
			var results = vm.masterUsersList;
			if (!search || search == '') {
				results = vm.masterUsersList;
			} else {
				results = utility.filterObject(vm.masterUsersList, { username: search });
			}
			// this is to reduce the rendering time. It was very slow and was impacted overall page responsiveness
			// so while displaying we will display only the first 100 records and user can filter with any value
			if(results.length > 100) {
				vm.isAboveMasterUserDropDownLimit = true;
				return results.slice(0, 100);
			} else {
				vm.isAboveMasterUserDropDownLimit = false;
				return results;
			}
		}

		function masterUserChange(selectedUser) {
			if(angular.isDefined(selectedUser) && selectedUser !== null) {
				vm.record.masterUserId = selectedUser.id;
				selectedMasterUserEmail = selectedUser.email;
			} else {
				vm.record.masterUserId = undefined;
				selectedMasterUserEmail = null;
			}
			// re-validate email since the allowed value depends on the selected master user
			validateEmail();
		}

		/**
		 * @description
		 * Validates email uniqueness for new users.
		 * If a master user is selected, the email may match the selected master user's email or be unique.
		 * If no master user is selected, the email must be unique in the system.
		 */
		function validateEmail() {
			if (!vm.isNew || angular.isUndefined(vm.editForm) || angular.isUndefined(vm.editForm.email)) {
				return;
			}
			var isUnique = true;
			var email = vm.record.email;
			if (angular.isDefined(email) && email !== null && email.toString().trim() !== '') {
				var emailLowerCase = email.toString().trim().toLowerCase();
				if (selectedMasterUserEmail && emailLowerCase === selectedMasterUserEmail.toString().trim().toLowerCase()) {
					// email matches the selected master user's email, allowed
					isUnique = true;
				} else {
					// otherwise email must not already exist in the system
					isUnique = existingEmailsLowerCase.indexOf(emailLowerCase) === -1;
				}
			}
			vm.editForm.email.$setValidity('emailUnique', isUnique);
		}
	}

})();
(function () {
	'use strict';

	angular
	.module('app.main.accounts.auth-users.auth-environments')
	.run(runBlock);

	/* @ngInject */
	function runBlock(api, activityLogger, $state, $localStorage) {

		if (angular.isUndefined(api.authUsers)) {
				api.authUsers = {};
		}
		api.authUsers.authEnvironments = {
			modelPath: 'authUsers.authEnvironments',
			fields: [
				{ field: 'id', type: 'int', displayLabel: 'AUTH_ENVIRONMENTS.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
					validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'name', type: 'text', displayLabel: 'AUTH_ENVIRONMENTS.FIELDS.NAME', visible: true, creatable: false, editable: false, inputType: 'text',
					validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'code', type: 'text', displayLabel: 'AUTH_ENVIRONMENTS.FIELDS.CODE', visible: true, creatable: false, editable: false, inputType: 'text',
					validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
			],
			uniqueConstraints: [],
			title: 'AUTH_ENVIRONMENTS.NAV',
			icon: '',
			idField: 'id',
			lookupDisplayField: 'code',
			isDirty: false,
			methods: {
				getList   : getEnvironments,
				create    : addEnvironment,
				delete    : deleteEnvironment
			},
			views: {
				mainList: {
					columns: [ 'id', 'name', 'code'],
					columnFilter: {},
					toggleFilterProps: {},
					topIndex: 0,
					showFilterRow: false,
					sortColumn: {},
					sortDescending: true,
					itemActions: [
						{ id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UI_CreateAuthUser', disabled: false, visible: true,
						requiresConfirmation: false, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'}
					],
					listActions: [],
					fabAction: {id: 'add', label: 'ACTIONS.ADD', icon: 'icon-plus', privilege: 'UI_CreateAuthUser', visible: true}
				},
				mainDetails: { },
				privileges: {
						list: 'nav_auth_users'
				}
			}
		};

		function getEnvironments(generalProperties) {
			var promise;

			if (angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
				var state = {};
				state.name = $state.current.name;
				state.params = $state.params;
				var isBulk = true;
				var logData = activityLogger.createLogData(null, state, 'authUsers.authEnvironments', 'VIEW', isBulk, new Date(), null, null);
				promise = api.webGet($localStorage.authBaseUrl + '/environments', undefined, true, generalProperties.forceFetch);
				promise = activityLogger.log(logData, promise);
			}
			else {
				promise = api.webGet($localStorage.authBaseUrl + '/environments', undefined, true, generalProperties.forceFetch);
			}

			promise.then(function () {
				if (api.authUsers.authEnvironments.isDirty) {
					//Invalidate lookupData
					api.authUsers.authEnvironments.lookupData = undefined;
					api.authUsers.authEnvironments.isDirty = false;
				}
			});
			return promise;
		}

		function addEnvironment(environments, userId) {
			var state = {};
			state.name = $state.current.name;
			state.params = $state.params;
			var promise;
			var logData = activityLogger.createLogData(environments, state, 'accounts.authUsers.authEnvironments', 'ADD', false, new Date(), null, null);
			promise = api.webPost($localStorage.authBaseUrl + '/users/' + userId + '/env', environments);
			promise = activityLogger.log(logData, promise);

			return promise;
		}

		function deleteEnvironment(record, userId) {
			var state = {};
			state.name = $state.current.name;
			state.params = $state.params;
			var logData = activityLogger.createLogData(record, state, 'accounts.authUsers.authEnvironments', 'DELETE', false, new Date(), null, null);
			var promise = api.webDelete($localStorage.authBaseUrl + '/users/' + userId + '/env', record);

			promise.then(function() {
				//Invalidate lookupData
				api.authUsers.authEnvironments.lookupData = undefined;
				api.authUsers.authEnvironments.isDirty = false;
			});
			return activityLogger.log(logData, promise);
		}

	}
})();
(function () {
	'use strict';

	angular
		.module('app.main.seller-models', [
			'app.main.seller-models.seller-model-articles',
			'app.main.seller-models.seller-model-catalogs',
			'app.main.seller-models.seller-model-sizes',
			'app.main.seller-models.seller-model-resources'
		])
		.config(config);

	/* @ngInject */
	function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {

		$stateProvider.state('app.seller_models', {
			url: '/seller-models',
			views: {
				'content@app': {
					templateUrl: 'app/main/seller-models/list/seller-models-list.html',
					controller: 'sellerModelsListController as vm'
				}
			},
			resolve: {
				sellerModelAttributesModel: function (api, catalogFactory) {
					var model = api.sellerModels.sellerModels;
					return catalogFactory.createSellerModelAttributesModel(model);
				}
			},
			data: {
				displayName: 'SELLER_MODELS.NAV'
			},
			// accessPrivileges: ['GetSellerModels']
			// accessPrivileges: ['nav_seller_models']
			accessInfo: {
				accessPrivileges: ['nav_seller_models']
			}
		});

		$stateProvider.state('app.seller_models.details', {
			url: '/:id',
			views: {
				'content@app': {
					templateUrl: 'app/main/seller-models/details/seller-models-details.html',
					controller: 'sellerModelsDetailsController as vm'
				}
			},
			resolve: {
				articlesModel: function ($q, catalogFactory, api) {
					var modelsArticlesModel = api.sellerModels.sellerModelArticles;
					var deferred = $q.defer();
					var activeCatalog = catalogFactory.getActiveCatalog();
					catalogFactory.createArticleModel(activeCatalog, undefined, modelsArticlesModel).then(function (resolvedModel) {
						// we will not display seasonless model attributes in articles list
						angular.forEach(resolvedModel.fields, function (field) {
							if (field.visible && field.isSeasonlessModelAttribute) {
								field.visible = false;
							}
							field.reportable = false;
						});
						deferred.resolve(resolvedModel);
					});
					return deferred.promise;
				}
			},
			data: {
				parentState: 'app.seller_models',
				displayName: 'SELLER_MODELS.TABS.SELLER_MODEL'
			},
			// only users with following accessPrivileges in their role access list can access this route
			// accessPrivileges: ['GetSellerModelDetails']
			accessInfo: {
				accessPrivileges: ['GetSellerModelDetails']
			}
		});

		// Translation
		$translatePartialLoaderProvider.addPart('app/main/seller-models');

		// Navigation
		msNavigationServiceProvider.saveItem('main.seller-models', {
			title: 'Seller Models',
			icon: 'icon-android-studio',
			state: 'app.seller_models',
			translate: 'SELLER_MODELS.NAV',
			weight: 4,
			// accessPrivileges: ['GetSellerModels']
			// accessPrivileges: ['nav_seller_models'],
			accessInfo: {
				accessPrivileges: ['nav_seller_models']
			},
			visibleForLinePlan: true
		});
	}

})();
(function () {
	'use strict';

	angular
		.module('app.main.seller-models')
		.controller('setModelSizeScaleController', setModelSizeScaleController);

	/* @ngInject */
	function setModelSizeScaleController(api, $q, $mdDialog, $scope, $filter, hotkeys, utility,
		sellerId, attributeGroupId, model, record, currentModel, selectedModel) {
		/* jshint validthis: true */
		var vm = this;

		//Data
		vm.model = model;

		var availableSizeScales = [];
		var availableSizeScalesWithOutObsolete = [];
		var availableMasterSizeScalesWithOutObsolete = [];
		vm.isLoading = false;
		vm.isDataDirty = false;
		vm.isMasterSizeScalesLoading = true;
		vm.record = angular.copy(record);

		vm.lookupModel = {}
		vm.lookupModel.MasterSizeScaleId = vm.record.MasterSizeScaleId != null ? vm.record.MasterSizeScaleId : null;
		vm.lookupModel.SizeScaleId = vm.record.SizeScaleId != null ? vm.record.SizeScaleId : null;
		vm.searchText = {};
		vm.isAboveDropDownLimit = false;
		vm.isMasterSizeScaleObsolete = false;
		vm.isAssignedMasterSizeScaleInvalid = false;

		//Methods
		vm.saveRecord = saveRecord;
		vm.closeDialog = closeDialog;

		vm.lookupSearch = lookupSearch;
		vm.lookupChange = lookupChange;
		vm.getLookupDisplayValue = getLookupDisplayValue;
		vm.selectText = selectText;

		vm.masterSizeScaleLookupSearch = masterSizeScaleLookupSearch;
		vm.masterSizeScaleLookupChange = masterSizeScaleLookupChange;
		vm.getMasterSizeScaleLookupDisplayValue = getMasterSizeScaleLookupDisplayValue;

		activate();

		////////////////

		function activate() {
			loadAvailableMasterSizeScales();
			//Hotkeys
			hotkeys.bindTo($scope).add({
				combo: 'ctrl+enter',
				description: $filter('translate')('ACTIONS.SAVE'),
				allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
				callback: function (event) {
					if (!vm.isLoading && !vm.editForm.$invalid) {
						vm.saveRecord();
					}
				}
			});
			hotkeys.bindTo($scope).add({
				combo: 'ctrl+shift+enter',
				description: $filter('translate')('ACTIONS.SAVE_AND_NEW'),
				allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
				callback: function (event) {
					if (!vm.isLoading && !vm.editForm.$invalid) {
						vm.saveRecord(true);
					}
				}
			});
		}

		function saveRecord() {
			vm.isLoading = true;
			var sizeScaleGroupsPromise = api.sellers.sizeScaleGroups.methods.getList(undefined, { forceFetch: true, isLogRequired: false }, sellerId);
			var masterSizeScalesPromise = api.sellers.masterSizeScales.methods.getList(undefined, { forceFetch: true, isLogRequired: true }, sellerId);
			vm.model.methods.setSizeScaleBulk(vm.model, [vm.record], sellerId, attributeGroupId, [currentModel], sizeScaleGroupsPromise, masterSizeScalesPromise);
			closeDialog(true);
		}

		function closeDialog(saved) {
			$mdDialog.hide(saved);
		}

		function lookupSearch(query, fieldName) {
			var results = [];
			var predicate = {};
			if (query) {
				predicate[fieldName] = query;
			}

			if (angular.isDefined(availableSizeScalesWithOutObsolete) && availableSizeScalesWithOutObsolete.length) {
				var sizeScalesOfMaster = utility.filterObject(availableSizeScalesWithOutObsolete, {MasterSizeScaleId: vm.record.MasterSizeScaleId}, true);
				results = query ? utility.filterObject(sizeScalesOfMaster, predicate) : sizeScalesOfMaster;
				// this is to reduce the rendering time. It was very slow and was impacted overall page responsiveness
				// so while displaying we will display only the first 100 records and user can filter with any value
				if (results.length > 100) {
					vm.isAboveDropDownLimit = true;
					return results.slice(0, 100);
				} else {
					vm.isAboveDropDownLimit = false;
					return results;
				}
			}
			else {
				return loadAvailableSizeScales().then(function () {
					var sizeScalesOfMaster = utility.filterObject(availableSizeScalesWithOutObsolete, {MasterSizeScaleId: vm.record.MasterSizeScaleId}, true);
					results = query ? utility.filterObject(sizeScalesOfMaster, predicate) : sizeScalesOfMaster;
					// this is to reduce the rendering time. It was very slow and was impacted overall page responsiveness
					// so while displaying we will display only the first 100 records and user can filter with any value
					if (results.length > 100) {
						vm.isAboveDropDownLimit = true;
						return results.slice(0, 100);
					} else {
						vm.isAboveDropDownLimit = false;
						return results;
					}
				});
			}
		}

		// convert dropdown scope value form object(lookup record) to id property of lookup record
		function lookupChange(selectedObj, field) {
			if (angular.isObject(selectedObj)) {
				vm.record[field] = selectedObj[field];
			}
			else if (angular.isUndefined(selectedObj) || selectedObj === null) {
				vm.record[field] = undefined; // on record removal make field undefined or the property can be deleted using delete keywork
			}
		}

		function getLookupDisplayValue(item, fieldName) {
			if (availableSizeScales.length) {
				return getLookupDisplayVal(item, fieldName);
			}
			else {
				return loadAvailableSizeScales().then(function () {
					return getLookupDisplayVal(item, fieldName);
				});
			}
		}

		function getLookupDisplayVal(item, fieldName) {
			var result;
			// since autocomplte return object
			if (angular.isObject(item)) {
				result = item;
			}
			// to initialize filed value if any (when open update record dialog)
			else {
				result = utility.filterObject(availableSizeScales, { Id: item }, true);
			}
			if (angular.isArray(result) && result.length > 0) {
				return result[0][fieldName];
			}
			else {
				return result[fieldName];
			}
		}

		function selectText(event) {
			utility.selectInputText(event);
		}

		function masterSizeScaleLookupSearch(query, fieldName) {
			var results = [];
			var predicate = {};
			predicate[fieldName] = query;

			if (angular.isDefined(availableMasterSizeScalesWithOutObsolete) && availableMasterSizeScalesWithOutObsolete.length) {
				results = query ? utility.filterObject(availableMasterSizeScalesWithOutObsolete, predicate) : availableMasterSizeScalesWithOutObsolete;
				// this is to reduce the rendering time. It was very slow and was impacted overall page responsiveness
				// so while displaying we will display only the first 100 records and user can filter with any value
				if (results.length > 100) {
					vm.isAboveDropDownLimit = true;
					return results.slice(0, 100);
				} else {
					vm.isAboveDropDownLimit = false;
					return results;
				}
			}
			else {
				return loadAvailableMasterSizeScales().then(function () {
					results = query ? utility.filterObject(availableMasterSizeScalesWithOutObsolete, predicate) : availableMasterSizeScalesWithOutObsolete;
					// this is to reduce the rendering time. It was very slow and was impacted overall page responsiveness
					// so while displaying we will display only the first 100 records and user can filter with any value
					if (results.length > 100) {
						vm.isAboveDropDownLimit = true;
						return results.slice(0, 100);
					} else {
						vm.isAboveDropDownLimit = false;
						return results;
					}
				});
			}
		}

		// convert dropdown scope value form object(lookup record) to id property of lookup record
		function masterSizeScaleLookupChange(selectedObj) {
			if (angular.isObject(selectedObj)) {
				vm.record['MasterSizeScaleId'] = selectedObj.Id;
				vm.record['MasterSizeScale'] = selectedObj.SizeScale;
				vm.record['SizeScaleId'] = undefined;
				vm.lookupModel.SizeScaleId = undefined;
				vm.record['SizeScale'] = undefined;
			}
			else if (angular.isUndefined(selectedObj) || selectedObj === null) {
				vm.record['MasterSizeScaleId'] = undefined; // on record removal make field undefined or the property can be deleted using delete keywork
				vm.record['MasterSizeScale'] = undefined;
				vm.record['SizeScaleId'] = undefined;
				vm.lookupModel.SizeScaleId = undefined;
				vm.record['SizeScale'] = undefined;
			}
		}

		function getMasterSizeScaleLookupDisplayValue(item, fieldName) {
			if (availableMasterSizeScalesWithOutObsolete.length) {
				return getMasterSizeScaleLookupDisplayVal(item, fieldName);
			}
			else {
				return loadAvailableMasterSizeScales().then(function () {
					return getMasterSizeScaleLookupDisplayVal(item, fieldName);
				});
			}
		}

		function getMasterSizeScaleLookupDisplayVal(item, fieldName) {
			var result;
			if (angular.isObject(item)) {
				result = item;
			}
			else {
				result = utility.filterObject(availableMasterSizeScalesWithOutObsolete, { Id: item }, true);
			}
			if (angular.isArray(result) && result.length > 0) {
				return result[0][fieldName];
			}
			else {
				return result[fieldName];
			}
		}

		//helper methods
		function loadAvailableSizeScales() {
			var deferred = $q.defer();

			api.sellers.sizeScaleGroups.methods.getList(undefined, { forceFetch: true, isLogRequired: false }, sellerId).then(function(response) {
					var filterCriteria = { Status: 1 };
					availableSizeScales = utility.filterObject(response.data, filterCriteria, true);
					availableSizeScalesWithOutObsolete = utility.filterObject(availableSizeScales, { IsObsolete: 0 }, true);
					if (angular.isDefined(vm.record.SizeScaleId) && vm.record.SizeScaleId !== null) {
							var obsoleteAssignedSizeScale = utility.filterObject(availableSizeScales, { Id: vm.record.SizeScaleId, IsObsolete: 1 }, true)[0];
							// Check if obsoleteAssignedSizeScale is not already present in availableSizeScalesWithOutObsolete
							if (obsoleteAssignedSizeScale && !availableSizeScalesWithOutObsolete.some(function(item) { return item.Id === obsoleteAssignedSizeScale.Id; })) {
									availableSizeScalesWithOutObsolete.push(obsoleteAssignedSizeScale);
							}
					}

					// Sort the availableSizeScalesWithOutObsolete by SizeScale
					availableSizeScalesWithOutObsolete.sort(function(a, b) {
						if (a.SizeScale && b.SizeScale) {
								return a.SizeScale.toLowerCase().localeCompare(b.SizeScale.toLowerCase());
						}
						return 0;
					});

					deferred.resolve(availableSizeScalesWithOutObsolete);
			});

			return deferred.promise;
		}

		function loadAvailableMasterSizeScales() {
			var deferred = $q.defer();
			// filter the master size scales based on size scale criteria
			api.sellers.masterSizeScales.methods.getList(undefined, { forceFetch: true, isLogRequired: false }, sellerId).then(function(response) {
				var filterCriteria = { Status: 1, IsObsolete: 0 };
				var availableActiveMasterSizeScales = utility.filterObject(response.data, filterCriteria, true);
				availableMasterSizeScalesWithOutObsolete = getFilteredCriteriaValues(availableActiveMasterSizeScales);
				if (angular.isDefined(vm.record.SizeScaleId) && vm.record.SizeScaleId !== null) {
						var obsoleteAssignedSizeScale = utility.filterObject(response.data, { Id: vm.record.SizeScaleId, IsObsolete: 1 }, true)[0];
						// Check if obsoleteAssignedSizeScale is not already present in availableMasterSizeScalesWithOutObsolete
						if (obsoleteAssignedSizeScale && !availableMasterSizeScalesWithOutObsolete.some(function(item) { return item.Id === obsoleteAssignedSizeScale.Id; })) {
							availableMasterSizeScalesWithOutObsolete.push(obsoleteAssignedSizeScale);
						}
				}
				// Sort the availableMasterSizeScalesWithOutObsolete by SizeScale
				availableMasterSizeScalesWithOutObsolete.sort(function(a, b) {
					if (a.SizeScale && b.SizeScale) {
							return a.SizeScale.toLowerCase().localeCompare(b.SizeScale.toLowerCase());
					}
					return 0;
				});
				// if the existing MasterSizeScale is invalid then assign the MasterSizeScaleId as null, we will allow user to update it
				// Check if the existing MasterSizeScaleId is part of the results or not
				if(vm.record.MasterSizeScaleId != null) {
					var isAssignedMasterSizeScaleValid = availableMasterSizeScalesWithOutObsolete.some(function (item) {
							return item.Id === vm.record.MasterSizeScaleId;
					});

					// If the MasterSizeScaleId is not valid, set MasterSizeScaleId and SizeScaleId to null
					if (!isAssignedMasterSizeScaleValid) {
							vm.record.MasterSizeScaleId = null;
							vm.record.SizeScaleId = null;
							vm.lookupModel.MasterSizeScaleId = null;
							vm.lookupModel.SizeScaleId = null;
					}
				}

				vm.isMasterSizeScalesLoading = false;
				deferred.resolve(availableMasterSizeScalesWithOutObsolete);
			}, function() {
				vm.isMasterSizeScalesLoading = false;
				deferred.resolve([]);
			});

			return deferred.promise;
		}

		function getFilteredCriteriaValues(records) {
			var results = [];
			angular.forEach(records, function (record) {
					var criteria = record.Criteria;
					if (angular.isDefined(criteria) && criteria !== '' && criteria.length) {
							try {
									var criteriaJSON = JSON.parse(criteria);
									var validItemsCount = 0;
									for (var key in criteriaJSON) {
											if (criteriaJSON.hasOwnProperty(key)) {
													var crts = criteriaJSON[key]; // the criteria value
													var selectedValue = selectedModel[key]; // the selected model value
													var isValid = false;

													// Ensure both are arrays for comparison
													if (!angular.isArray(crts)) {
															crts = [crts];
													}
													if (!angular.isArray(selectedValue)) {
															selectedValue = [selectedValue];
													}

													// Check if any value from selectedModel matches criteria (case-insensitive)
													angular.forEach(crts, function (crt) {
															angular.forEach(selectedValue, function (selVal) {
																	if (crt.toString().toLowerCase() === selVal.toString().toLowerCase()) {
																			isValid = true;
																	}
															});
													});

													// If this criteria key is valid, increase the valid items count
													if (isValid) {
															validItemsCount++;
													}
											}
									}

									// All keys in criteriaJSON must have a valid match in selectedModel
									if (validItemsCount === Object.keys(criteriaJSON).length) {
											results.push(record);
									}
							} catch (error) {
									console.warn("Criteria : Invalid JSON format");
							}
					} else {
							results.push(record); // If no criteria, consider the record as valid
					}
			});
			return results;
		}

	}
})();
(function() {
    'use strict';

    angular
        .module('app.main.seller-models.seller-model-sizes', []);
})();
(function() {
	'use strict';

	angular
		.module('app.main.seller-models.seller-model-sizes')
		.run(runBlock);

	/* @ngInject */
	function runBlock(api) {
		if (angular.isUndefined(api.sellerModels)) {
			api.sellerModels = {};
		}
		 api.sellerModels.sellerModelSizes = {
			modelPath: 'sellerModels.sellerModelSizes',
			fields: [
				{ field: 'SizeIndex', type: 'text', displayLabel: 'SIZES.FIELDS.SIZE_INDEX', visible: true, creatable: true, editable: false, inputType: 'text',
					validation: {isRequired: true, maxLen: 25, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'SizeName', type: 'text', displayLabel: 'SIZES.FIELDS.SIZE_NAME', visible: true, creatable: true, editable: false, inputType: 'text',
					validation: {isRequired: true, maxLen: 50, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'SortOrder', type: 'int', displayLabel: 'SIZES.FIELDS.SORT_ORDER', visible: true, creatable: true, editable: true, inputType: 'number',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
			],
			title: 'SIZES.NAV',
			icon: 'icon-layers',
			idField: 'SizeIndex',
			lookupDisplayField: 'SizeName',
			isDirty: false,
			isCatalogSpecificModel: true,
			methods: {},
			views: {
				mainList: {
					columns         : [ 'SizeName', 'SizeIndex', 'SortOrder'],
					columnFilter    : {},
					toggleFilterProps: {},
					topIndex        : 0,
					showFilterRow   : false,
					sortColumn      : {},
					itemActions     : [],
					listActions     : [],
					fabAction       : {}

				 },
				 mainDetails: {},
				privileges: {
					list    : 'GetSellerModelDetails'
				}
			}
		};
	}
})();
(function() {
    'use strict';

    angular
        .module('app.main.seller-models.seller-model-resources')
        .run(runBlock);

    /* @ngInject */
    function runBlock(api, $state, activityLogger, utility, crud) {

        if (angular.isUndefined(api.sellerModels)) {
            api.sellerModels = {};
        }
        api.sellerModels.sellerModelResources = {
            modelPath: 'sellerModels.sellerModelResources',
            fields: [
                { field: 'ResourceId', type: 'int', displayLabel: 'RESOURCES.FIELDS.RESOURCE_ID', visible: false, creatable: true, editable: false, inputType: 'lookup', lookupSource: 'catalogs.resources',
                    lookupFilter: {Status: 1, IsModelLevel: 1}, validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ResourceId', type: 'int', displayLabel: 'RESOURCES.FIELDS.RESOURCE_ID', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ResourceName', type: 'text', displayLabel: 'RESOURCES.FIELDS.RESOURCE_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'TypeId', type: 'text', displayLabel: 'RESOURCES.FIELDS.RESOURCE_TYPE_ID', visible: true, creatable: false, editable: false, inputType: 'lookup', lookupSource: 'lists.resourceTypes',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Status', type: 'text', displayLabel: 'RESOURCES.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedDate', type: 'text', displayLabel: 'RESOURCES.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
            ],
            uniqueConstraints: [],
            title: 'RESOURCES.NAV',
            icon: 'icon-image-filter-black-white',
            idField: 'ResourceId',
            lookupDisplayField: 'ResourceName',
            isDirty: false,
            methods: {
                getList     : getSellerModelResources,
                activateBulk: deactivateResource,
                create      : assignResources
            },
            views: {
                mainList: {
                    columns         : [ 'ResourceName', 'ResourceId', 'TypeId', 'Status', 'UpdatedDate' ],
                    columnFilter    : {},
                    topIndex        : 0,
                    showFilterRow   : false,
                    sortColumn      : {'UpdatedDate': false},
                    itemActions     : [
                                        { id: 'view', label: 'ACTIONS.VIEW', icon: 'icon-magnify', privilege: 'GetSellerResourceDetails', disabled: '!itm.Status', visible: true },
                                        { id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateSellerModelResourceStatus', disabled: false, visible: 'itm.Status',
                                            requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'}
                                      ],
                    listActions     : [
                                        { id: 'delete', label: 'ACTIONS.DELETE_BULK', icon: 'icon-delete', privilege: 'UpdateSellerModelResourceStatus', disabled: '{selected: true, Status: 1}', visible: true,
                                            requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'}
                                      ],
                    fabAction       : {id: 'add', label: 'ACTIONS.ADD', icon: 'icon-link', privilege: 'AssignResourcesToSellerModel', visible: true}
                 },
                 mainDetails: {},
                privileges: {
                    list    : 'GetSellerModelResourcesList',
                    details : 'GetSellerResourceDetails'
                }
            }
        };

        function getSellerModelResources(generalProperties, sellerId, attributeGroupId, modelId) {
            var promise;

            if(angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
                var state = {};
                state.name = $state.current.name;
                state.params = $state.params;
                var isBulk = true;
                var logData = activityLogger.createLogData(null, state, 'sellerModels.sellerModelResources', 'VIEW', isBulk, new Date(), null, null);

                promise = api.webGet(api.baseUrl + '/sellers/' + sellerId + '/' + attributeGroupId + '/models/' + modelId + '/resources', undefined, true, generalProperties.forceFetch);
                promise = activityLogger.log(logData, promise);
            }
            else {
                promise = api.webGet(api.baseUrl + '/sellers/' + sellerId + '/' + attributeGroupId + '/models/' + modelId + '/resources', undefined, true, generalProperties.forceFetch);
            }

            return promise;
        }

        function deactivateResource(records, model, actionType, sellerId, attributeGroupId, modelId) {
            if(!angular.isArray(records)) {
                records = utility.pushItemToArray(records);
            }

            angular.forEach(records, function(record) {
                var resourceId = record[model.idField];
                api.webPut(api.baseUrl + '/sellers/' + sellerId + '/' + attributeGroupId + '/models/' + modelId + '/resources/' + resourceId + '/status', {Status: 0});
            });

            crud.onRecordStatusChange(records, model, actionType);
        }

        function assignResources(record, sellerId, attributeGroupId, modelId) {
            var requestObj = {
                ResourceId: record.ResourceId
            };

            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var logData = activityLogger.createLogData(null, state, 'sellerModels.sellerModelResources', 'ADD', false, new Date(), null, null);
            var promise = api.webPut(api.baseUrl + '/sellers/' + sellerId + '/' + attributeGroupId + '/models/' + modelId + '/assignresources', requestObj);

            promise.then(function() {
                api.sellerModels.sellerModelResources.isDirty = true;
            });
            return activityLogger.log(logData, promise);
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.main.seller-models.seller-model-catalogs', []);
})();
(function() {
    'use strict';

    angular
        .module('app.main.seller-models.seller-model-catalogs')
        .run(runBlock);

    /* @ngInject */
    function runBlock(api, activityLogger, $state) {

        if (angular.isUndefined(api.sellerModels)) {
            api.sellerModels = {};
        }
         api.sellerModels.sellerModelCatalogs = {
            modelPath: 'sellerModels.sellerModelCatalogs',
            fields: [
                { field: 'CatalogCode', type: 'int', displayLabel: 'CATALOGS.FIELDS.CATALOG_CODE', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CatalogName', type: 'text', displayLabel: 'CATALOGS.FIELDS.CATALOG_NAME', visible: true, creatable: true, editable: true, inputType: 'text',
                    validation: {isRequired: true, maxLen: 100, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Season', type: 'text', displayLabel: 'CATALOGS.FIELDS.SEASON', visible: true, creatable: true, editable: true, inputType: 'text',
                    validation: {isRequired: true, maxLen: 100, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
            ],
            uniqueConstraints: [],
            title: 'CATALOGS.NAV',
            icon: 'icon-book-open',
            idField: 'CatalogCode',
            lookupDisplayField: 'CatalogName',
            isDirty: false,
            methods: {
                getList         :   getSellerModelCatalogs
            },
            views: {
                 mainList: {
                    columns         : [ 'CatalogCode', 'CatalogName', 'Season'],
                    columnFilter    : {},
                    toggleFilterProps: {},
                    topIndex        : 0,
                    showFilterRow   : false,
                    sortColumn      : {},
                    itemActions     : [],
                    listActions     : [],
                    fabAction       : {}

                 },
                 mainDetails: {
                     selectedTabIndex   : 0,
                     itemActions        : [],
                    fabAction           : {}

                 },
                 privileges: {
                     list: 'GetSellerModelAssociatedCatalogs',
                 }
            }
        };

        function getSellerModelCatalogs(generalProperties, sellerId, modelId) {
            var promise;

            if(angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
                var state = {};
                state.name = $state.current.name;
                state.params = $state.params;
                var isBulk = false;
                var logData = activityLogger.createLogData(null, state, 'catalogs.sellerModelCatalogs', 'VIEW', isBulk, new Date(), null, null);
                promise = api.webGet(api.baseUrl + '/sellers/'+ sellerId +'/models/' + modelId + '/catalogs', undefined, true, generalProperties.forceFetch);
                promise = activityLogger.log(logData, promise);
            }
            else {
                promise = api.webGet(api.baseUrl + '/sellers/'+ sellerId +'/models/' + modelId +'/catalogs', undefined, true, generalProperties.forceFetch);
            }

            return promise;
        }

    }
})();
(function() {
		'use strict';

		angular
				.module('app.main.seller-models.seller-model-articles', []);
})();
(function() {
	'use strict';

	angular
		.module('app.main.seller-models.seller-model-articles')
		.run(runBlock);

	/* @ngInject */
	function runBlock(api, activityLogger, $state) {

		if (angular.isUndefined(api.sellerModels)) {
			api.sellerModels = {};
		}
		 api.sellerModels.sellerModelArticles = {
			modelPath: 'sellerModels.sellerModelArticles',
			fields: [
				{ field: 'Id', map:'Id', type: 'int', displayLabel: 'ARTICLES.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'ArticleNumber', map:'ArticleNumber', type: 'text', displayLabel: 'ARTICLES.FIELDS.ARTICLE_NUMBER', visible: true, creatable: false, editable: false, inputType: 'text',
					validation: {isRequired: true, maxLen: 20, minLen: 1, pattern: '^[^ ]*(?: [^ ]+)* ?$', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: 'VALIDATIONS.WHITE_SPACE_NOT_ALLOWED'}} },
				{ field: 'ArticleName',  map:'ArticleName', type: 'text', displayLabel: 'ARTICLES.FIELDS.MODEL_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
					validation: {isRequired: true, maxLen: 100, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'ModelId', map:'ModelId', type: 'int', displayLabel: 'SELLER_MODELS.FIELDS.MODEL_ID', visible: true, creatable: false, editable: false, inputType: 'number',
					validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'ModelNumber', map:'ModelNumber', type: 'text', displayLabel: 'SELLER_MODELS.FIELDS.MODEL_NUMBER', visible: true, creatable: true, editable: true, inputType: 'text',
					validation: {isRequired: true, maxLen: 200, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'Status',  map:'Status', type: 'text', displayLabel: 'ARTICLES.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'CreatedDate',  map:'CreatedDate', type: 'text', displayLabel: 'ARTICLES.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'UpdatedDate',  map:'UpdatedDate', type: 'text', displayLabel: 'ARTICLES.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'ColoredUpBy', map:'ColoredUpBy', type: 'text', displayLabel: 'ARTICLES.FIELDS.COLORED_UP_BY', visible: true, creatable: false, editable: false, inputType: 'text',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'ColoredUpDate', map:'ColoredUpDate', type: 'text', displayLabel: 'ARTICLES.FIELDS.COLORED_UP_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'ColorCode',  map:'ColorCode', type: 'int', displayLabel: 'ARTICLES.FIELDS.COLOR_CODE', visible: false, creatable: false, editable: false, inputType: 'number', prefixZeros: 3,
					validation: {isRequired: false, maxLen: -1, minLen: 1, pattern: '^(0*[1-9][0-9]{0,2}|100|999)$', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: 'VALIDATIONS.CODE_POSITIVE_NUMBER'}} },
				{ field: 'ColorName',  map:'ColorName', type: 'text', displayLabel: 'ARTICLES.FIELDS.PRIMARY_COLOR_NAME', visible: false, creatable: false, editable: false, inputType: 'text',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'HexCode',  map:'HexCode', type: 'text', displayLabel: 'ARTICLES.FIELDS.HEXCODE', visible: false, creatable: false, editable: false, inputType: 'color-picker',
					validation: {isRequired: false, maxLen: 7, minLen: 0, pattern: '^#(?:[0-9a-fA-F]{3}){2}$', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: 'COLOR_DEFINITION.VALIDATIONS.INVALID'}} },
				{ field: 'ColorGroup',  map:'ColorGroup', type: 'text', displayLabel: 'ARTICLES.FIELDS.COLOR_GROUP', visible: true, creatable: false, editable: false, inputType: 'text',
					validation: {isRequired: false, maxLen: 250, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'ColorType',  map:'ColorType', type: 'text', displayLabel: 'ARTICLES.FIELDS.COLOR_TYPE', visible: true, creatable: false, editable: false, inputType: 'text',
					validation: {isRequired: false, maxLen: 250, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'ColorAssetId',  map:'ColorAssetId', type: 'text', displayLabel: 'ARTICLES.FIELDS.COLOR_ASSET_ID', visible: true, creatable: false, editable: false, inputType: 'text',
					validation: {isRequired: false, maxLen: 250, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
			],
			uniqueConstraints: [],
			title: 'ARTICLES.NAV',
			icon: 'icon-cube-outline',
			idField: 'Id',
			lookupDisplayField: 'ArticleNumber',
			isDirty: false,
			isBulkActionCompleted: false,
			isCatalogSpecificModel: true,
			methods: {
				getList: getSellerModelArticles
			},
			views: {
				mainList: {
					columns         : [ 'Id', 'ArticleNumber', 'ArticleName', 'ModelNumber'],
					columnFilter    : {},
					imagesSize      : 'large',
					toggleFilterProps: {},
					topIndex        : 0,
					showFilterRow   : false,
					sortColumn      : {'UpdatedDate': false},
					sortDescending  : true,
					itemActions     : [],
					listActions     : [],
					fabAction       :{}

				},
				mainDetails: {
					selectedTabIndex   : 0,
					itemActions        : [],
					fab                 : {}
				},
				privileges: {
					list    : 'GetSellerModelAssociatedArticles'
				}
			}
		};

		function getSellerModelArticles(generalProperties, sellerId, modelId) {
			var promise;

			if(angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
					var state = {};
					state.name = $state.current.name;
					state.params = $state.params;
					var isBulk = false;
					var logData = activityLogger.createLogData(null, state, 'sellerModels.sellerModelArticles', 'VIEW', isBulk, new Date(), null, null);
					promise = api.webGet(api.baseUrl + '/sellers/'+ sellerId +'/models/' + modelId +'/articles', undefined, true, generalProperties.forceFetch);
					promise = activityLogger.log(logData, promise);
			}
			else {
					promise = api.webGet(api.baseUrl + '/sellers/'+ sellerId +'/models/' + modelId +'/articles', undefined, true, generalProperties.forceFetch);
			}

			return promise;
	}

	}
})();
(function() {
    'use strict';

    angular
        .module('app.main.roles.privileges')
        .run(runBlock);

    /* @ngInject */
    function runBlock(api, activityLogger, $state, mockFactory) {

        if(angular.isUndefined(api.roles)) {
            api.roles = {};
        }
        api.roles.privileges = {
            modelPath: 'roles.privileges',
            fields: [
                { field: 'Id', type: 'int', displayLabel: 'PRIVILEGES.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'discription', type: 'text', displayLabel: 'PRIVILEGES.FIELDS.DESCRIPTION', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'RouteName', type: 'int', displayLabel: 'PRIVILEGES.FIELDS.ROUTE_NAME', visible: false, creatable: false, editable: false, inputType: 'lookup', lookupSource: 'lists.accountTypes',
                    validation: {isRequired: false, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
            ],
            uniqueConstraints: [],
            title: 'PRIVILEGES.NAV',
            icon: 'icon-account',
            idField: 'Id',
            lookupDisplayField: 'UserRole',
            isDirty: false,
            methods: {
                getList         :   getPrivileges,
                getAllPrivileges:   getAllPrivileges,
                update          :   updatePrivilege
            },
            views: {
                mainList: {
                    columns             : [ 'Id', 'discription' ],
                    columnFilter        : {},
                    toggleFilterProps   : {},
                    topIndex            : 0,
                    showFilterRow       : false,
                    sortColumn          : {'discription': true},
                    itemActions         : [],
                    listActions         : [],
                    fabAction           : {id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UpdateWebapisAssignedRole', visible: true}
                },
                mainDetails: {},
                privileges: {
                    list: 'WebapisRoleGetList'
                }
            }
        };

        function getPrivileges(generalProperties, roleId) {
            var promise;

            if(angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
                var state = {};
                state.name = $state.current.name;
                state.params = $state.params;
                var isBulk = true;
                var logData = activityLogger.createLogData(null, state, 'roles.privileges', 'VIEW', isBulk, new Date(), null, null);

                promise = api.webGet(api.baseUrl + '/roles/' + roleId + '/webapis', undefined, true, generalProperties.forceFetch);
                promise = activityLogger.log(logData, promise);
            }
            else {
                promise = api.webGet(api.baseUrl + '/roles/' + roleId + '/webapis', undefined, true, generalProperties.forceFetch);
            }

            promise.then(function() {
                if (api.roles.privileges.isDirty) {
                    //Invalidate lookupData
                    api.roles.privileges.lookupData = undefined;
                    api.roles.privileges.isDirty = false;
                }
            });
            return promise;
		}

        function getAllPrivileges(forceFetch, isLogRequired) {
            var promise;

            if(angular.isDefined(isLogRequired) && isLogRequired === true) {
                var state = {};
                state.name = $state.current.name;
                state.params = $state.params;
                var isBulk = true;
                var logData = activityLogger.createLogData(null, state, 'roles.privileges', 'VIEW', isBulk, new Date(), null, null);

                promise = api.webGet(api.baseUrl + '/webapis', undefined, true, forceFetch);
                promise = activityLogger.log(logData, promise); // since its geting use in dialog to see all the privileges to assign to a role not logging this information
            }
            else {
                promise = api.webGet(api.baseUrl + '/webapis', undefined, true, forceFetch);
            }
            return promise;
        }

        function updatePrivilege(roleId, privileges) {
            var requestObj = {};
            requestObj.WebapiIdList = [];
            var privilegesNameList = privileges.map(function(privilage) {
                requestObj.WebapiIdList.push(privilage[api.roles.privileges.idField]);
                return privilage[api.roles.privileges.lookupDisplayField];
            });

            //if selected contains UI privileges add respective API privilegs to request body
            var UIPrivilegesMap = mockFactory.getUIPrivilegesMap();
            for(var key in UIPrivilegesMap) {
                // if any UI privilege assigned and its respective API privilege does not exist push API privilege as to request body
                if(requestObj.WebapiIdList.indexOf(parseInt(key)) >= 0) {
                    if(!angular.isArray(UIPrivilegesMap[key]['APIPrivilegeId'])) {
                        if(requestObj.WebapiIdList.indexOf(UIPrivilegesMap[key]['APIPrivilegeId']) === -1) {
                            requestObj.WebapiIdList.push(UIPrivilegesMap[key]['APIPrivilegeId']);
                        }
                    } else {
                        angular.forEach(UIPrivilegesMap[key]['APIPrivilegeId'], function(APIPrivilegeId) {
                            if(requestObj.WebapiIdList.indexOf(APIPrivilegeId) === -1) {
                                requestObj.WebapiIdList.push(APIPrivilegeId)
                            }
                        })
                    }
                }
            }

            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var logData = activityLogger.createLogData(privilegesNameList, state, 'roles.privileges', 'EDIT', false, new Date(), null, null);
			var promise = api.webPut(api.baseUrl + '/roles/' + roleId + '/webapis', requestObj);

            promise.then(function() {
                api.roles.privileges.isDirty = true;
            });
            return activityLogger.log(logData, promise);
		}

    }
})();
(function() {
  'use strict';

  angular
      .module('app.main.roles.linkedCatalogs', []);

})();
(function() {
  'use strict';

  angular
      .module('app.main.roles.linkedCatalogs')
      .run(runBlock);

  /* @ngInject */
  function runBlock(api, activityLogger, $state) {


      if (angular.isUndefined(api.roles)) {
        api.roles = {};
      }

      api.roles.linkedCatalogs = {
          modelPath: 'roles.linkedCatalogs',
          fields: [
              { field: 'Id', type: 'int', displayLabel: 'CATALOGS.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
                  validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
              { field: 'CatalogId', type: 'int', displayLabel: 'LINKED_CATALOGS.FIELDS.CATALOG_ID', visible: true, creatable: false, editable: false, inputType: 'number',
                  validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
              { field: 'CatalogCode', type: 'int', displayLabel: 'CATALOGS.FIELDS.CATALOG_CODE', visible: true, creatable: false, editable: false, inputType: 'number',
                  validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
              { field: 'CatalogName', type: 'text', displayLabel: 'CATALOGS.FIELDS.CATALOG_NAME', visible: true, creatable: true, editable: true, inputType: 'text',
                  validation: {isRequired: true, maxLen: 100, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
              { field: 'Status', type: 'text', displayLabel: 'CATALOGS.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
                  validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
              { field: 'CreatedDate', type: 'text', displayLabel: 'CATALOGS.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                  validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
              { field: 'UpdatedDate', type: 'text', displayLabel: 'CATALOGS.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                  validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
              { field: 'CreatedBy', type: 'text', displayLabel: 'LINKED_CATALOGS.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                  validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
              { field: 'UpdatedBy', type: 'text', displayLabel: 'CATALOGS.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                  validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
          ],
          title: 'LINKED_CATALOGS.NAV',
          icon: 'icon-book-open',
          idField: 'CatalogCode',
          lookupDisplayField: 'CatalogName',
          isDirty: false,
          methods: {},
          views: {
               mainList: {
                  columns         : [ 'CatalogCode', 'CatalogName', 'Status', 'UpdatedDate' ],
                  columnFilter    : {},
                  toggleFilterProps: { toggleStatus:false, filterProp:'Status', trueVal:1, trueValTooltipMessage: 'ACTIONS.TOGGLE_ACTIVE', falseVal:'', falseValTooltipMessage:"ACTIONS.TOGGLE_ALL"},
                  topIndex        : 0,
                  showFilterRow   : false,
                  sortColumn      : {'UpdatedDate': false},
                  itemActions     : [],
                  listActions     : [],
                  fabAction       : {}

               },
               mainDetails: {},
               privileges: {
                   list: 'GetAccountTypeRolesDetails',
                   details: 'GetCatalogDetails',
               }
          }
      };



  }
})();
(function() {
  'use strict';

  angular
      .module('app.main.organizations.sales-data', []);
})();
(function () {
	'use strict';

	angular
	.module('app.main.organizations.sales-data')
	.run(runBlock);

	/* @ngInject */
	function runBlock(api, activityLogger, $state, jobsTracker, utility, CONSTANTS) {

		if (angular.isUndefined(api.organizations)) {
				api.organizations = {};
		}
		api.organizations.salesData = {
			modelPath: 'organizations.salesData',
			fields: [
				{ field: 'Id', type: 'int', displayLabel: 'SALES_DATA.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
					validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'Brand', type: 'text', displayLabel: 'SALES_DATA.FIELDS.BRAND', visible: true, creatable: true, editable: false, inputType: 'text',
					validation: {isRequired: true, maxLen: 200, minLen: -1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'ArticleNumber', type: 'text', displayLabel: 'SALES_DATA.FIELDS.ARTICLE_NUMBER', visible: true, creatable: true, editable: true, inputType: 'text',
					validation: {isRequired: true, maxLen: 20, minLen: 1, pattern: '^[^ ]*(?: [^ ]+)* ?$', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: 'VALIDATIONS.WHITE_SPACE_NOT_ALLOWED'}} },
				{ field: 'ArticleName', type: 'text', displayLabel: 'ARTICLES.FIELDS.MODEL_NAME', visible: true, creatable: true, editable: true, inputType: 'text',
					validation: {isRequired: true, maxLen: 100, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'SalesDate', type: 'text', displayLabel: 'SALES_DATA.FIELDS.SALES_DATE', visible: true, creatable: true, editable: false, inputType: 'date-utc',
					validation: {isRequired: true, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'AverageUnitRetail', type: 'int', displayLabel: 'SALES_DATA.FIELDS.AVERAGE_UNIT_RETAIL', visible: true, creatable: true, editable: false, inputType: 'number',
					validation: {isRequired: true, maxLen: 18, minLen: -1, pattern: '^[+]?\\d+([.]\\d{0,4})?$', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: 'VALIDATIONS.POSITIVE_DECIMAL_4PONTS'}} },
				{ field: 'MSRP', type: 'int', displayLabel: 'SALES_DATA.FIELDS.MSRP', visible: true, creatable: true, editable: false, inputType: 'number',
					validation: {isRequired: true, maxLen: 18, minLen: -1, pattern: '^[+]?\\d+([.]\\d{0,4})?$', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: 'VALIDATIONS.POSITIVE_DECIMAL_4PONTS'}} },
				{ field: 'Units', type: 'int', displayLabel: 'SALES_DATA.FIELDS.UNITS', visible: true, creatable: true, editable: false, inputType: 'number',
					validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '[0-9]+', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: 'VALIDATIONS.INVALID_UNITS'}} },
				{ field: 'CreatedBy', type: 'text', displayLabel: 'SALES_DATA.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'CreatedDate', type: 'text', displayLabel: 'SALES_DATA.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
			],
			uniqueConstraints: [],
			title: 'SALES_DATA.NAV',
			icon: '',
			idField: 'Id',
			lookupDisplayField: '',
			isDirty: false,
			methods: {
				getList         : getSalesData,
				create          : createSalesData,
				createBulk      : createBulk,
				deleteBulk      : deleteSalesData,
			},
			views: {
				mainList: {
					columns: [ 'Id', 'Brand', 'ArticleNumber', 'SalesDate', 'CreatedDate'],
					columnFilter: {},
					toggleFilterProps: {},
					topIndex: 0,
					showFilterRow: false,
					sortColumn: {},
					sortDescending: true,
					itemActions: [
						{ id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'DeleteSalesData', disabled: false, visible: true,
							requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'}
					],
					listActions: [
						{ id: 'delete', label: 'ACTIONS.DELETE_BULK', icon: 'icon-delete', privilege: 'DeleteSalesData', disabled: '{selected: true}', visible: true,
							requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
						{ id: 'import', label: 'ACTIONS.IMPORT', icon: 'icon-import', privilege: 'ImportSalesData', disabled: false, visible: true, requiresConfirmation: false}
					],
					fabAction: {id: 'add', label: 'ACTIONS.ADD', icon: 'icon-plus', privilege: 'CreateSalesData', visible: true}
				},
				mainDetails: { },
				privileges: {
						list: 'GetOrganizationDetails'
				}
			}
		};

		function getSalesData(generalProperties, model, organizationId) {
			if(angular.isDefined(model)) { // to skip this part for load lookup
				model.isBulkActionCompleted = false;
			}
			var promise;

			if (angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
				var state = {};
				state.name = $state.current.name;
				state.params = $state.params;
				var isBulk = true;
				var logData = activityLogger.createLogData(null, state, 'organizations.salesData', 'VIEW', isBulk, new Date(), null, null);
				promise = api.webPut(api.baseUrl + '/organizations/' + organizationId + '/getsalesdata', {});
				promise = activityLogger.log(logData, promise);
			}
			else {
				promise = api.webPut(api.baseUrl + '/organizations/' + organizationId + '/getsalesdata', {});
			}

			promise.then(function () {
				if (api.organizations.salesData.isDirty) {
					//Invalidate lookupData
					api.organizations.salesData.lookupData = undefined;
					api.organizations.salesData.isDirty = false;
				}
			});
			return promise;
		}

		function createSalesData(salesData, organizationId) {
			var state = {};
			state.name = $state.current.name;
			state.params = $state.params;
			var promise;
			var logData = activityLogger.createLogData(salesData, state, 'organizations.salesData', 'ADD', false, new Date(), null, null);
			promise = api.webPost(api.baseUrl + '/organizations/' + organizationId + '/salesdata', salesData);
			promise = activityLogger.log(logData, promise);

			return promise;
		}

		function createBulk(model, data, organizationId) {
			var jobIndex = jobsTracker.addJob(model, 'SALES_DATA.ACTIONS.IMPORT_SALES_DATA', 1);
			api.webPut(api.baseUrl + '/organizations/'+ organizationId +'/importsalesdata?sourceapplication=' + CONSTANTS.SOURCE_APPLICATION + '&sourceaction=Import Sales Data', data).then(function(response) {
				jobsTracker.trackJob(jobIndex, response.data.Id);
			}).catch(function(error) {
				jobsTracker.setCriticlaFail(jobIndex, error);
			});
		}

		function deleteSalesData(records, actionType, organizationId) {
			var state = {};
			state.name = $state.current.name;
			state.params = $state.params;
			if (!angular.isArray(records)) {
				records = utility.pushItemToArray(records);
			}
			var requestObj = records.map(function(record) {
				return record['Id'];
			});

			var isBulk = records.length > 1 ? true : false;
			var logData = activityLogger.createLogData(records, state, 'organizations.salesData', actionType.toUpperCase(), isBulk, new Date(), null, null);
			var promise = api.webDelete(api.baseUrl + '/organizations/'+ organizationId +'/salesdata', requestObj);

			promise.then(function() {
				if (api.organizations.salesData.isDirty) {
					//Invalidate lookupData
					api.organizations.salesData.lookupData = undefined;
					api.organizations.salesData.isDirty = false;
				}
			});

			return activityLogger.log(logData, promise);
		}

	}
})();
(function() {
    'use strict';

    angular
        .module('app.main.customers.catalogs')
        .run(runBlock);

    /* @ngInject */
    function runBlock(api, activityLogger, $state, crud, utility) {

        if (angular.isUndefined(api.customers)) {
            api.customers = {};
        }
         api.customers.catalogs = {
            modelPath: 'customers.catalogs',
            fields: [
                { field: 'Id', type: 'int', displayLabel: 'CATALOGS.FIELDS.ID', visible: false, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'AccountId', type: 'int', displayLabel: 'CATALOGS.FIELDS.SELLER_ACCOUNT', visible: true, creatable: false, editable: false, inputType: 'lookup', lookupSource: 'accounts.sellers',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CatalogCode', type: 'int', displayLabel: 'CATALOGS.FIELDS.CATALOG_CODE', visible: false, creatable: false, editable: false, inputType: 'lookup', lookupSource: 'catalogs.catalogs',
                    lookupFilter: {Status: 1}, validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CatalogName', type: 'text', displayLabel: 'CATALOGS.FIELDS.CATALOG_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: 100, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'DataSourceTypeId', type: 'int', displayLabel: 'CATALOGS.FIELDS.DATA_SOURCE_TYPE', visible: false, creatable: false, editable: false, inputType: 'lookup',  lookupSource: 'lists.dataSourceTypes',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'DataSourceType', type: 'text', displayLabel: 'CATALOGS.FIELDS.DATA_SOURCE_TYPE', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: 100, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'AttributeGroupId', type: 'int', displayLabel: 'CATALOGS.FIELDS.ATTRIBUTE_GROUP_NAME', visible: false, creatable: false, editable: false, inputType: 'lookup', lookupSource: 'attributes.attributeGroups',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', disabledCriteria: 'vm.record.DataSourceTypeId === 2 || vm.record.DataSourceTypeId === 3', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'AttributeGroupName', type: 'text', displayLabel: 'CATALOGS.FIELDS.ATTRIBUTE_GROUP_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ReferenceCatalogCode', type: 'text', displayLabel: 'CATALOGS.FIELDS.REFERENCE_CATAOG_CODE', visible: true, creatable: false, editable: false, inputType: 'lookup', lookupSource: 'catalogs.catalogs',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', disabledCriteria: 'vm.record.DataSourceTypeId === 1', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ImageName', type: 'text', displayLabel: 'CATALOGS.FIELDS.IMAGE_NAME', visible: false, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: 100, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ImageFile', type: 'text', displayLabel: 'CATALOGS.FIELDS.IMAGE_FILE', visible: false, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: 100, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ImagePath', type: 'text', displayLabel: 'CATALOGS.FIELDS.IMAGE_PATH', visible: false, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: 100, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'IsVasInUse', type: 'text', displayLabel: 'CATALOGS.FIELDS.IS_VAS_IN_USE', visible: true, creatable: false, editable: false, inputType: 'int-bool',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Status', type: 'text', displayLabel: 'CATALOGS.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedDate', type: 'text', displayLabel: 'CATALOGS.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedDate', type: 'text', displayLabel: 'CATALOGS.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UserId', type: 'text', displayLabel: 'CATALOGS.FIELDS.USER_ID', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedBy', type: 'text', displayLabel: 'CATALOGS.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'AssignedCatalogAttributes', type: 'text', displayLabel: 'CATALOGS.FIELDS.CATALOG_ATTRIBUTES_LIST', visible: false, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CatalogSpecificConfigurationList', type: 'text', displayLabel: 'CATALOGS.FIELDS.CATALOG_SPECIFIC_CONFIGURATION_LIST', visible: false, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'WholesalePriceGroupId', type: 'text', displayLabel: 'CUSTOMERS.FIELDS.WHOLESALE_PRICE_GROUP', visible: true, creatable: false, editable: false, inputType: 'number', lookupSource: 'catalogs.priceGroup',
                    validation: {isRequired: '', maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'WholesaleAltPriceGroupId', type: 'text', displayLabel: 'CUSTOMERS.FIELDS.WHOLESALE_ALT_PRICE_GROUP', visible: true, creatable: false, editable: false, inputType: 'number', lookupSource: 'catalogs.priceGroup',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'RetailPriceGroupId', type: 'text', displayLabel: 'CUSTOMERS.FIELDS.RETAIL_PRICE_GROUP', visible: true, creatable: false, editable: false, inputType: 'number', lookupSource: 'catalogs.priceGroup',
                    validation: {isRequired: '', maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'RetailAltPriceGroupId', type: 'text', displayLabel: 'CUSTOMERS.FIELDS.RETAIL_ALT_PRICE_GROUP', visible: true, creatable: false, editable: false, inputType: 'number', lookupSource: 'catalogs.priceGroup',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'OrderPriceGroupId', type: 'text', displayLabel: 'CUSTOMERS.FIELDS.ORDER_PRICE_GROUP', visible: true, creatable: false, editable: false, inputType: 'number', lookupSource: 'catalogs.priceGroup',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                    //TODO-update input type of all lookups to number since lookup wount work for them
                { field: 'AccountManager1', type: 'text', displayLabel: 'CUSTOMERS.FIELDS.ACCOUNT_MANAGER_1', visible: true, creatable: false, editable: false, inputType: 'lookup', lookupSource: 'accounts.users',
                    lookupFilter: {Status: 1}, validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'AccountManager2', type: 'text', displayLabel: 'CUSTOMERS.FIELDS.ACCOUNT_MANAGER_2', visible: true, creatable: false, editable: false, inputType: 'lookup', lookupSource: 'accounts.users',
                    lookupFilter: {Status: 1}, validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
                    //TODO-lookup to accounts.user since seller.users will read active catalog seller id, need to change if we update lookup behaviour
            ],
            uniqueConstraints: [
                {name: 'Constraint 1', fields: ['CatalogName']}
            ],
            title: 'CATALOGS.NAV',
            icon: 'icon-book-open',
            idField: 'CatalogCode',
            lookupDisplayField: 'CatalogName',
            isDirty: false,
            methods: {
                getList                      :   getCustomerCatalogs,
                unlinkCatalogFromCustomer    :   unlinkCatalogFromCustomer,
                linkCatalogToCustomer        :   linkCatalogToCustomer,
                create                       :   createCatalogToCustomerRelation,
                update                       :   updateCatalog
            },
            views: {
                mainList: {
                    columns         : [ 'CatalogName', 'WholesalePriceGroupId', 'RetailPriceGroupId','OrderPriceGroupId', 'Status', 'UpdatedDate' ],
                    columnFilter    : {},
                    topIndex        : 0,
                    showFilterRow   : false,
                    sortColumn      : {'UpdatedDate': false},
                    itemActions     : [
                                        { id: 'view', label: 'ACTIONS.VIEW', icon: 'icon-magnify', privilege: 'GetCatalogDetails', disabled: '!itm.Status', visible: true },
                                        { id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'AssignCatalogAndPriceGroupToSellerCustomer', disabled: '!itm.Status', visible: true },
                                        { id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'RemoveSellerCustomerFromCatalog', disabled: false, visible: 'itm.Status',
                                            requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                                        { id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'AssignCatalogAndPriceGroupToSellerCustomer', disabled: false, visible: '!itm.Status',
                                            requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
                                      ],
                    listActions     : [
                                        { id: 'delete', label: 'ACTIONS.DELETE_BULK', icon: 'icon-delete', privilege: 'RemoveSellerCustomerFromCatalog', disabled: '{selected: true, Status: 1}', visible: true,
                                            requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                                        { id: 'activate', label: 'ACTIONS.ACTIVATE_BULK', icon: 'icon-undo-variant', privilege: 'AssignCatalogAndPriceGroupToSellerCustomer', disabled: '{selected: true, Status: 0}', visible: true,
                                            requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
                                      ],
                    fabAction       :
                                        {id: 'add', label: 'ACTIONS.ADD', icon: 'icon-link', privilege: 'AssignCatalogAndPriceGroupToSellerCustomer', visible: true}

                 },
                 privileges: {
                     list: 'GetSellerCustomerCatalogs',
                     details: 'GetCatalogDetails'
                 }
            }
        };

        // lookup not supported
        function getCustomerCatalogs(generalProperties, customerId, accountId) {
            var promise;

            if(angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
                var state = {};
                state.name = $state.current.name;
                state.params = $state.params;
                var isBulk = false;
                var logData = activityLogger.createLogData(null, state, 'customers.catalogs', 'VIEW', isBulk, new Date(), null, null);
                promise = api.webGet(api.baseUrl + '/sellers/' + accountId + '/customers/' + customerId + '/catalogs', undefined, true, generalProperties.forceFetch);
                promise = activityLogger.log(logData, promise);
            }
            else {
                promise = api.webGet(api.baseUrl + '/sellers/' + accountId + '/customers/' + customerId + '/catalogs', undefined, true, generalProperties.forceFetch);
            }

            promise.then(function() {
                if (api.customers.catalogs.isDirty) {
                    //Invalidate lookupData
                    api.customers.catalogs.lookupData = undefined;
                    api.customers.catalogs.isDirty = false;
                }
            });
            return promise;
        }

		function unlinkCatalogFromCustomer(records, model, actionType, customerId, sellerId) {
            //TODO- can modify crud.createRequestObject so that it return object with desired struture(custome properties)
            //var result = crud.createRequestObject(records, model, actionType);
            var result = {
                requestObj: [],
                itemsNameList: []
            };
            // pushing single item to array
            if(!angular.isArray(records)) {
                records = utility.pushItemToArray(records);
            }
            for(var index=0; index < records.length ; index++) {
                var obj = {};
                obj[model.idField] = records[index][model.idField];
                result.requestObj.push(obj);
                result.itemsNameList.push(records[index][model.lookupDisplayField]);
            }
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var isBulk = result.itemsNameList.length > 1 ? true : false;
            var logData = activityLogger.createLogData(result.itemsNameList, state, 'customers.catalogs', actionType.toUpperCase(), isBulk, new Date(), null, null);
			var promise = api.webDelete(api.baseUrl + '/sellers/' + sellerId + '/customers/' + customerId + '/catalogs', result.requestObj);

            promise.then(function() {
                //Not required to change the status of record in UI since list view filter deleted records
                // crud.onRecordStatusChange(records, model, actionType);
               api.customers.catalogs.isDirty = true;
            });
            return activityLogger.log(logData, promise);
		}

        function linkCatalogToCustomer(records, model, actionType, customerId, sellerId) {
            var itemsNameList = [];
            // pushing single item to array
            if(!angular.isArray(records)) {
                records = utility.pushItemToArray(records);
            }
            for(var index=0; index < records.length ; index++) {
                itemsNameList.push(records[index][model.lookupDisplayField]);
            }
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var isBulk = itemsNameList.length > 1 ? true : false;
            var logData = activityLogger.createLogData(itemsNameList, state, 'customers.catalogs', actionType.toUpperCase(), isBulk, new Date(), null, null);
            var promise = api.webPut(api.baseUrl + '/sellers/' + sellerId + '/customers/' + customerId + '/catalogs', records);

            promise.then(function() {
               api.customers.catalogs.isDirty = true;
            });
            return activityLogger.log(logData, promise);
        }

		function createCatalogToCustomerRelation(record, sellerId, customerId) {
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var logData = activityLogger.createLogData(record[api.customers.catalogs.lookupDisplayField], state, 'customers.catalogs', 'ADD', false, new Date(), null, null);
            var promise = api.webPut(api.baseUrl + '/sellers/' + sellerId + '/customers/' + customerId + '/catalogs', utility.pushItemToArray(record));

            promise.then(function() {
               api.customers.catalogs.isDirty = true;
            });
            return activityLogger.log(logData, promise);
		}

        function updateCatalog(record, sellerId, customerId) {
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var logData = activityLogger.createLogData(record[api.customers.catalogs.lookupDisplayField], state, 'customers.catalogs', 'EDIT', false, new Date(), null, null);
            var promise = api.webPut(api.baseUrl + '/sellers/' + sellerId + '/customers/' + customerId + '/catalogs', utility.pushItemToArray(record));

            promise.then(function() {
               api.customers.catalogs.isDirty = true;
            });
            return activityLogger.log(logData, promise);
		}
    }
})();
(function() {
    'use strict';

	angular
		.module('app.main.catalogs.tree-list')
		.controller('treeListController', treeListController);

	/* @ngInject */
	function treeListController(api, $rootScope, $scope, $state, $stateParams, catalogFactory, toast, $q, utility, treeFactory, settingsFactory,
		$document, $mdDialog) {
		/* jshint validthis: true */
		var vm = this;

        //Data
        var activeCatalog = catalogFactory.getActiveCatalog();
        var activeCatalogCode = -999;
        if(angular.isDefined($stateParams.catalog)) {
            activeCatalogCode = $stateParams.catalog.CatalogCode;
            vm.catalogName = $stateParams.catalog.CatalogName;
        }
        else {
            activeCatalogCode = activeCatalog.CatalogCode;
            vm.catalogName = activeCatalog.CatalogName;
        }
        var treeDefinition = $stateParams.treeDefinition;
        var articles = [];
        var treeNodeProperties = [];
        var selectedcatalogTreeId = 0;
        var catalogTreeList = catalogFactory.getActiveCatalogDetails().TreeDefination;

        vm.model = api.catalogs.treeNodesList;
        settingsFactory.applyPersistedListViewLayout(vm.model);

        vm.treeListData = [];
        vm.filteredTreeListData = [];
        vm.isTreeDirty = false;
        vm.isLoading = false;


        //Methods

        vm.doRefresh = refreshTree;
        vm.doItemAction = doItemAction;


		activate();

		////////////////


        function activate() {
            if(angular.isUndefined(treeDefinition)) {
                if(catalogTreeList.length > 0) {
                    selectedcatalogTreeId = angular.isDefined(utility.filterObject(catalogTreeList, {IsDefault: 1})[0]) ? utility.filterObject(catalogTreeList, {IsDefault: 1})[0].Id :
                    catalogTreeList[0].Id;
                    if(catalogFactory.getActiveCatalogTree() === '') {
                        var treeDef = angular.isDefined(utility.filterObject(catalogTreeList, {IsDefault: 1})[0]) ? utility.filterObject(catalogTreeList, {IsDefault: 1})[0] :
                        catalogTreeList[0];
                        catalogFactory.setActiveCatalogTree(treeDef);
                    }
                }
            } else {
                selectedcatalogTreeId = treeDefinition[0].Id;
                if(catalogFactory.getActiveCatalogTree() === '') {
                    catalogFactory.setActiveCatalogTree(treeDefinition[0]);
                }
            }
            refreshTree(false, true);
        }

		function refreshTree(forceFetch, isLogRequired) {
            if(catalogTreeList.length > 0) {
                vm.isLoading = true;
                var promises = [ getTreeNodeProperties(forceFetch, isLogRequired), getArticles(forceFetch), gettreeDefinition(forceFetch)];
                $q.all(promises).then(function() {
                    if(articles.length === 0) {
                        toast.error('', 'There are no articles in catalog', '', {message: 'You can not create catalog tree without articles'});
                    }
                    else if(treeDefinition.length > 0) {
                        var currentTree = utility.filterObject(treeDefinition, {Id: selectedcatalogTreeId}, true)[0];
                        vm.tree = treeFactory.buildTreeNodes(currentTree.Attributes, articles, treeNodeProperties);
                        vm.treeListData = transformDataToRequiredListForm(vm.tree[0]);
                    }
                })
                .finally(function() {
                    vm.isLoading = false;
                });
            } else {
                toast.error('', 'Catalog tree definitions has not been set', '', {message: 'You can not create catalog tree without defining attribute levels'});
            }
		}

        function getArticles(forceFetch) {
            var articleModel = api.catalogs.articles;
            var generalProperties = {
                forceFetch: (articleModel.isDirty || forceFetch),
                isLogRequired: false,
                config: {},
                supportIncrementalResult: true,
                modelIdField: articleModel.idField,
                isMajor: false
            }
            return articleModel.methods.getList(generalProperties, articleModel, activeCatalogCode).then(function(response) {
                articles = utility.filterObject(response.data, {Status: 1});
            });
        }

        function getTreeNodeProperties(forceFetch, isLogRequired) {
            return vm.model.methods.getList( { forceFetch: (vm.model.isDirty || forceFetch), isLogRequired: isLogRequired }, activeCatalogCode, selectedcatalogTreeId).then(function(response) {
                treeNodeProperties = response.data;
            });
        }

        function gettreeDefinition(forceFetch) {
            if(angular.isUndefined(treeDefinition) || (angular.isDefined(treeDefinition[0]) && angular.isUndefined(treeDefinition[0].Attributes))) {
                var treeDefinitionModel = api.catalogs.treeDefinition;
                return treeDefinitionModel.methods.getList( { forceFetch: (forceFetch || treeDefinitionModel.isDirty), isLogRequired: false }, activeCatalogCode).then(function(response) {
                    treeDefinition = response.data;
                });
            }
            else {// if navigating from tree definition page
                return $q.when();
            }
        }

        //change this
        var catalogChangedEventCleanup = $rootScope.$on('ActiveCatalogChangedEvent', function(e) {
            if(activeCatalogCode !== catalogFactory.getActiveCatalog().CatalogCode) {
                catalogFactory.setActiveCatalogTree('');
                $state.transitionTo($state.current, {treeDefinition : undefined, catalog: undefined}, { reload: true, inherit: false, notify: true });
            }
        });

        var activeCatalogTreeChangedEventCleanup = $rootScope.$on('ActiveCatalogTreeChangedEvent', function(event, activeTree) {
            selectedcatalogTreeId = activeTree.Id;
            refreshTree(true, false);
        });

        function transformDataToRequiredListForm(treeData, name, path, sortOrder, result) {
            var result = result || [];
            // we will list the catalog tree as catagory and path
            if(angular.isDefined(name) && angular.isDefined(path) ) {
                result.push({
                    Category: name,
                    Path: path === null ? null : path.toString().replace(/,/g, '\\'), // To avoid null exception while transforming data
                    SortOrder: sortOrder
                });
            }

            if(treeData.nodes) {
                angular.forEach(treeData.nodes, function(node) {
                    transformDataToRequiredListForm(node, node.Name, node.branch, node.sortOrder, result);
                })
            }

            return result;
        }

        //Item Action button pressed event
        function doItemAction(action, record) {
            if (action && record) {
                switch (action.id) {
                    case 'edit':
                    editItem(record, null);
                    break;
                }
            }
        }

        function editItem(record, ev) {
            $mdDialog.show({
                controller         : 'updateSortOrderController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/catalogs/sub-modules/tree-list/dialogs/update-sort-order/update-sort-order.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: false,
                locals             : {
                    model: vm.model,
                    record: record,
                    activeCatalogCode: activeCatalogCode,
                    currentTreeNodeProperties: treeNodeProperties,
                    catalogTreeId: selectedcatalogTreeId
                }
            }).then(function(saved) {
                if(saved) {
                    refreshTree(true, false);
                }
            });
        }

        $scope.$on('$destroy', function () {
            catalogChangedEventCleanup();
            activeCatalogTreeChangedEventCleanup();
        });

    }
})();
(function() {
    'use strict';

    angular
        .module('app.main.catalogs.tree',[])
        .config(config);

    /* @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
        // State
        $stateProvider.state('app.tree', {
            url    : '/catalog-tree',
            params : {treeDefinition : undefined, catalog: undefined},
            views  : {
                'content@app': {
                    templateUrl: 'app/main/catalogs/sub-modules/tree/nodes/tree-nodes.html',
                    controller : 'treeNodesController as vm'
                }
            },
            resolve: {
            },
            data: {
                displayName: 'CATALOG_TREE.NAV'
            },
            //only users with following accessPrivileges in their role access list can access this route
            // accessPrivileges: ['GetCatalogTreeNodes']
            // accessPrivileges: ['nav_catalog_tree']
            accessInfo: {
                accessPrivileges: ['nav_catalog_tree']
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/catalogs/sub-modules/tree');

        // Navigation
		msNavigationServiceProvider.saveItem('catalogs.tree', {
			title : 'Catalog Tree',
            translate: 'CATALOG_TREE.NAV',
			icon  : 'icon-sitemap',
			weight: 90,
			// accessPrivileges: ['GetCatalogTreeNodes']
            // accessPrivileges: ['nav_catalog_tree']
            accessInfo: {
                accessPrivileges: ['nav_catalog_tree']
            },
            visibleForLinePlan: true
		});

        msNavigationServiceProvider.saveItem('catalogs.tree.tree', {
            title      : 'Tree View',
            subTitle   : 'Catalog Tree',
            icon       : 'icon-sitemap',
            state      : 'app.tree',
            translate  : 'NAV.TREE_VIEW',
            weight     : 90,
            // accessPrivileges: ['GetCatalogTreeNodes']
            // accessPrivileges: ['nav_catalog_tree']
            accessInfo: {
                accessPrivileges: ['nav_catalog_tree']
            },
            visibleForLinePlan: true
        });
    }
})();
(function() {
    'use strict';

	angular
		.module('app.main.catalogs.tree')
		.controller('treeNodesController', treeNodesController);

	/* @ngInject */
	function treeNodesController(api, $rootScope, $scope, $state, $stateParams, catalogFactory, toast, $q, utility, treeFactory) {
		/* jshint validthis: true */
		var vm = this;

        //Data
        var activeCatalog = catalogFactory.getActiveCatalog();
        var activeCatalogCode = -999;
        if(angular.isDefined($stateParams.catalog)) {
            activeCatalogCode = $stateParams.catalog.CatalogCode;
            vm.catalogName = $stateParams.catalog.CatalogName;
        }
        else {
            activeCatalogCode = activeCatalog.CatalogCode;
            vm.catalogName = activeCatalog.CatalogName;
        }
        var treeDefinition = $stateParams.treeDefinition;
        var articles = [];
        var treeNodeProperties = [];
        var selectedcatalogTreeId = 0;
        var activeCatalogDetails = catalogFactory.getActiveCatalogDetails();
        var catalogTreeList = activeCatalogDetails.TreeDefination;
        var assignedCatalogAttributes = activeCatalogDetails.AssignedCatalogAttributes;

        vm.model = api.catalogs.treeNodes;

        vm.tree = [];
        vm.isTreeDirty = false;
        vm.isLoading = false;

        //Methods

        vm.treeOptions = {
            dropped : dropped,
            beforeDrop: beforeDrop
        }
        vm.doRefresh = refreshTree;
        vm.doTreeListAction = doTreeListAction;
        vm.toggle = toggle;


		activate();

		////////////////


        function activate() {
            //Set the branch types
            vm.branchTypes = {
                folder      : {
                    icon    : api.catalogs.treeNodes.icon,
                    title   : api.catalogs.treeNodes.title,
                    actions : api.catalogs.treeNodes.views.mainList.itemActions,
                    model   : vm.model
                }
            };
            vm.filter = "";
            vm.showFilterRow = false;

            vm.treeViewOptions = {
                customersListView : false,
                articleListVIew : false
            }

            if(angular.isUndefined(treeDefinition)) {
                if(catalogTreeList.length > 0) {
                    selectedcatalogTreeId = angular.isDefined(utility.filterObject(catalogTreeList, {IsDefault: 1})[0]) ? utility.filterObject(catalogTreeList, {IsDefault: 1})[0].Id :
                    catalogTreeList[0].Id;
                    if(catalogFactory.getActiveCatalogTree() === '') {
                        var treeDef = angular.isDefined(utility.filterObject(catalogTreeList, {IsDefault: 1})[0]) ? utility.filterObject(catalogTreeList, {IsDefault: 1})[0] :
                        catalogTreeList[0];
                        catalogFactory.setActiveCatalogTree(treeDef);
                    }
                }
            } else {
                selectedcatalogTreeId = treeDefinition[0].Id;
                if(catalogFactory.getActiveCatalogTree() === '') {
                    catalogFactory.setActiveCatalogTree(treeDefinition[0]);
                }
            }
            refreshTree(false, true);
        }

		function refreshTree(forceFetch, isLogRequired) {
            if(catalogTreeList.length > 0) {
                vm.isLoading = true;
                var promises = [ getTreeNodeProperties(forceFetch, isLogRequired), getArticles(forceFetch), gettreeDefinition(forceFetch)];
                $q.all(promises).then(function() {
                    if(articles.length === 0) {
                        toast.error('', 'There are no articles in catalog', '', {message: 'You can not create catalog tree without articles'});
                    }
                    else if(treeDefinition.length > 0) {
                        var multiValueAttributeSystemNames = {};
                        var currentTree = utility.filterObject(treeDefinition, {Id: selectedcatalogTreeId}, true)[0];
                        angular.forEach(currentTree.Attributes, function(attr) {
                            var assignedCatalogAttribute = utility.filterObject(assignedCatalogAttributes, {Attributeid: attr.Attributeid}, true)[0];
                            if(angular.isDefined(assignedCatalogAttribute) && assignedCatalogAttribute.AttributeTypeName === 'multivalue') {
                                multiValueAttributeSystemNames[assignedCatalogAttribute.AttributeSystemName] = true;
                            }
                        });
                        vm.tree = treeFactory.buildTreeNodes(currentTree.Attributes, articles, treeNodeProperties, multiValueAttributeSystemNames);
                    }
                })
                .finally(function() {
                    vm.isLoading = false;
                });
            } else {
                toast.error('', 'Catalog tree definitions has not been set', '', {message: 'You can not create catalog tree without defining attribute levels'});
            }
		}

        function dropped(event) {
            var record = event.source.nodesScope.$modelValue;
            vm.isTreeDirty = true;
            vm.model.views.mainList.listActions[0].disabled = false;
            for (var i=0; i<record.length; i++) {
                record[i].sortOrder = i;
            }
        }

        //To prevent nodes getting droped outside of its parent node
        function beforeDrop(event) {
            var isDestinationDrobable = event.dest.nodesScope.isParent(event.source.nodeScope);
            if(!isDestinationDrobable){
                toast.success('', 'Can not move node out of its parent', '');
            }
            return isDestinationDrobable
        }

        function toggle(scope) {
            scope.toggle();
        }

        function doTreeListAction(action) {
            switch (action.id) {
                case 'save':
                    saveTreeStructure();
                    break;
            }
        }

        function saveTreeStructure() {
            vm.isLoading = true;
            var requestObj = treeFactory.buildTreeProperties(vm.tree[0].nodes);
            vm.model.methods.create(activeCatalogCode, requestObj, selectedcatalogTreeId).then(function() {
                toast.success('SUCCESS.SAVE ','', '');
                vm.model.isDirty = true;//TODO- not required anymore after code refactor
                refreshTree();
            }).finally(function() {
                vm.isLoading = false;
            });
        }

        function getArticles(forceFetch) {
            var articleModel = api.catalogs.articles;
            var generalProperties = {
                forceFetch: (articleModel.isDirty || forceFetch),
                isLogRequired: false,
                config: {},
                supportIncrementalResult: true,
                modelIdField: articleModel.idField,
                isMajor: false
            }
            return articleModel.methods.getList(generalProperties, articleModel, activeCatalogCode).then(function(response) {
                articles = utility.filterObject(response.data, {Status: 1});
            });
        }

        function getTreeNodeProperties(forceFetch, isLogRequired) {
            return vm.model.methods.getList( { forceFetch: (vm.model.isDirty || forceFetch), isLogRequired: isLogRequired }, activeCatalogCode, selectedcatalogTreeId).then(function(response) {
                treeNodeProperties = response.data;
            });
        }

        function gettreeDefinition(forceFetch) {
            if(angular.isUndefined(treeDefinition) || (angular.isDefined(treeDefinition[0]) && angular.isUndefined(treeDefinition[0].Attributes))) {
                var treeDefinitionModel = api.catalogs.treeDefinition;
                return treeDefinitionModel.methods.getList( { forceFetch: (forceFetch || treeDefinitionModel.isDirty), isLogRequired: false }, activeCatalogCode).then(function(response) {
                    treeDefinition = response.data;
                });
            }
            else {// if navigating from tree definition page
                return $q.when();
            }
        }

        var catalogChangedEventCleanup = $rootScope.$on('ActiveCatalogChangedEvent', function(e) {
            if(activeCatalogCode !== catalogFactory.getActiveCatalog().CatalogCode) {
                catalogFactory.setActiveCatalogTree('');
                $state.transitionTo($state.current, {treeDefinition : undefined, catalog: undefined}, { reload: true, inherit: false, notify: true });
            }
        });

        var activeCatalogTreeChangedEventCleanup = $rootScope.$on('ActiveCatalogTreeChangedEvent', function(event, activeTree) {
            selectedcatalogTreeId = activeTree.Id;
            refreshTree(true, false);
        });

        $scope.$on('$destroy', function () {
            catalogChangedEventCleanup();
            activeCatalogTreeChangedEventCleanup();
        });

    }
})();
(function () {
  'use strict';

  angular
      .module('app.main.catalogs.targets',[])
      .config(config);

  /* @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
      // State
      $stateProvider.state('app.targets', {
          url    : '/targets',
          views  : {
              'content@app': {
                  templateUrl: 'app/main/catalogs/sub-modules/targets/list/targets-list.html',
                  controller : 'targetsListController as vm'
              }
          },
          data: {
              displayName: 'TARGETS.NAV'
          },

        //   accessPrivileges: ['GetTargetList']
        //   accessPrivileges: ['nav_targets']
          accessInfo: {
            accessPrivileges: ['nav_targets']
          }
      });


      // Translation
      $translatePartialLoaderProvider.addPart('app/main/catalogs/sub-modules/targets');

      msNavigationServiceProvider.saveItem('catalogs.targets', {
          title      : 'Targets',
          icon       : 'icon-album',
          state      : 'app.targets',
          translate  : 'TARGETS.NAV',
          weight     : 37,
          // accessPrivileges: ['GetTargetList']
          // accessPrivileges: ['nav_targets'],
          accessInfo: {
            accessPrivileges: ['nav_targets']
          }
      });
  }
})();
(function () {
  'use strict';

  angular
    .module('app.main.catalogs.targets')
    .controller('targetsListController', targetsListController);
  /* @ngInject */
  function targetsListController(api, catalogFactory, settingsFactory, $mdDialog, $document, utility, dataImporter, dialog, $filter, $rootScope, $scope, $state) {
    /* jshint validthis: true */
    var vm = this;

    //Data
    var activeCatalogCode = catalogFactory.getActiveCatalog().CatalogCode;

    vm.model = api.catalogs.targets;
    settingsFactory.applyPersistedListViewLayout(vm.model);

    vm.targets = [];
    vm.filteredTargets = [];
    vm.isLoading = false;

    //Methods
    vm.refreshItems = refreshItems;
    vm.doListAction = doListAction;
    vm.doItemAction = doItemAction;
    vm.addRecord = addRecord;

    activate();

    ////////////////

    function activate() {
      refreshItems(vm.model.isDirty, true);
    }

    function refreshItems(forceFetch, isLogRequired) {
      var generalProperties = {
        forceFetch: forceFetch,
        isLogRequired: isLogRequired
      }

      vm.isLoading = true;
      return vm.model.methods.getList(generalProperties, vm.model, activeCatalogCode)
        .then(function (response) {
          vm.targets= response.data;
        }).finally(function () {
          vm.isLoading = false;
        });
    }

    //Item Action button pressed event
    function doItemAction(action, record) {
      if (action && record) {
        switch (action.id) {
          case 'edit':
            editItem(record, null);
            break;
          case 'delete':
          case 'activate':
            vm.model.methods.activate(record, vm.model, action.id, activeCatalogCode);
            break;
        }
      }
    }

    //List Action button pressed event
    function doListAction(action, records) {
      if (action) {
        switch (action.id) {
          case 'delete':
          case 'activate':
            vm.model.methods.activate(records, vm.model, action.id, activeCatalogCode);
            break;
					case 'import':
					var targetedAttributes = catalogFactory.getActiveCatalogDetails().TargettedAttributeList || [];
					var aggregateAttributes = catalogFactory.getActiveCatalogDetails().AggregateAttributeList || [];
					if(targetedAttributes.length && aggregateAttributes.length) {
							var modelCopy = angular.copy(vm.model)
							var targetedAttributesSystemName = []
							targetedAttributesSystemName = targetedAttributes.map(function(targetedAttribute) {
								return targetedAttribute.AttributeSystemName
							})
							// add targeted attributes from column mapping, also create atLeastOneRequiredConstraints
							angular.forEach(targetedAttributes, function(targetedAttribute) {
								if(targetedAttribute.AttributeTypeId !== 6 && targetedAttribute.Status === 1) {
									var targetAttributeField = {
										field: '', type: 'text', displayLabel: '', visible: true, creatable: true, editable: false, showInEdit: false, inputType: 'text', reportable: true, values: '',
										validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }
									};
									targetAttributeField.field = targetedAttribute.AttributeSystemName;
									targetAttributeField.displayLabel = targetedAttribute.AttributeDisplayName;
									var requiredCriteria = '';
									angular.forEach(targetedAttributesSystemName, function(targetedAttributeSystemName, index) {
										if(index === 0) {
											requiredCriteria = 'data["'+ targetedAttributeSystemName +'"] == null';
										}
										requiredCriteria += '&& data["'+ targetedAttributeSystemName +'"] == null';
									});

									targetAttributeField.validation.isRequired = requiredCriteria;
									modelCopy.fields.push(targetAttributeField);
									modelCopy.atLeastOneRequiredConstraints[0].fields.push(targetedAttribute.AttributeSystemName);
									if (!modelCopy.uniqueConstraints) {
										modelCopy.uniqueConstraints = [{ name: 'Constraint 1', fields: [] }];
									}
									if (!modelCopy.uniqueConstraints[0].fields.includes(targetedAttribute.AttributeSystemName)) {
										modelCopy.uniqueConstraints[0].fields.push(targetedAttribute.AttributeSystemName);
									}
								}
							});

							// add aggregate attributes
							if(aggregateAttributes.length) {
								var aggregateAttributesSystemName = []
								aggregateAttributesSystemName = aggregateAttributes.map(function(aggregatedAttribute) {
									return aggregatedAttribute.AttributeSystemName
								})
								angular.forEach(aggregateAttributes, function(aggregatedAttribute) {
									if(aggregatedAttribute.Status === 1) {
										var aggregatedAttributeField = {
											field: '', type: 'text', displayLabel: '', visible: true, creatable: true, editable: false, showInEdit: false, inputType: 'text', reportable: true, values: '',
											validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }
										};
										aggregatedAttributeField.field = aggregatedAttribute.AttributeSystemName;
										aggregatedAttributeField.displayLabel = aggregatedAttribute.AttributeDisplayName;
										var requiredCriteria = '';
										angular.forEach(aggregateAttributesSystemName, function(aggregateAttributesSystemName, index) {
											if(index === 0) {
												requiredCriteria = 'data["'+ aggregateAttributesSystemName +'"] == null';
											}
											requiredCriteria += '&& data["'+ aggregateAttributesSystemName +'"] == null';
										});

										aggregatedAttributeField.validation.isRequired = requiredCriteria;
										modelCopy.fields.push(aggregatedAttributeField);
										modelCopy.atLeastOneRequiredConstraints[1].fields.push(aggregatedAttribute.AttributeSystemName);
									}
								});
								if (!modelCopy.uniqueConstraints) {
										modelCopy.uniqueConstraints = [];
								}

								var constraint2 = modelCopy.uniqueConstraints.find(function(constraint) {
										return constraint.name === 'Constraint 2';
								});

								if (!constraint2) {
										modelCopy.uniqueConstraints.push({ name: 'Constraint 2', fields: [] });
										constraint2 = modelCopy.uniqueConstraints[modelCopy.uniqueConstraints.length - 1];
								}

								angular.forEach(aggregateAttributes, function(aggregatedAttribute) {
										if (aggregatedAttribute.Status === 1 && !constraint2.fields.includes(aggregatedAttribute.AttributeSystemName)) {
												constraint2.fields.push(aggregatedAttribute.AttributeSystemName);
										}
								});
							}

							dataImporter.importExcel(modelCopy, true).then(function(result) {
								vm.model.methods.import(vm.model, result.data, activeCatalogCode, targetedAttributes, aggregateAttributes);
							});
						} else {
							dialog.showAlertDialog(
								angular.element($document.body),
								$filter('translate')('MESSAGES.TITLE.ALERT'),
								$filter('translate')('TARGETS.MESSAGES.NO_TARGETED_ATTRIBUTES'),
								$filter('translate')('MESSAGES.TITLE.ALERT'),
								$filter('translate')('ACTIONS.DIALOG_CLOSE'),
								true,
								null
							);
						}
            break;
        }
      }
    }

    function addRecord(ev) {
      var targetedAttributes = utility.filterObject(catalogFactory.getActiveCatalogDetails().TargettedAttributeList, { Status: 1 }, true);
      var aggregateAttributes = utility.filterObject(catalogFactory.getActiveCatalogDetails().AggregateAttributeList, { Status: 1 }, true);
      return $mdDialog.show({
        controller: 'createTargetController',
        controllerAs: 'vm',
        templateUrl: 'app/main/catalogs/sub-modules/targets/dialogs/create-target.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: false,
        locals: {
          record: null,
          isNew: true,
          model: vm.model,
          activeCatalogCode: activeCatalogCode,
          targetedAttributesList: targetedAttributes,
          aggregateAttributesList: aggregateAttributes,
          event: ev
        }
      }).then(function (saved) {
        if (saved) {
          refreshItems(true);
        }
      });
    }

    function editItem(record, ev) {
      var targetedAttributes = utility.filterObject(catalogFactory.getActiveCatalogDetails().TargettedAttributeList, { Status: 1 }, true);
      var aggregateAttributes = utility.filterObject(catalogFactory.getActiveCatalogDetails().AggregateAttributeList, { Status: 1 }, true);
      return $mdDialog.show({
        controller: 'createTargetController',
        controllerAs: 'vm',
        templateUrl: 'app/main/catalogs/sub-modules/targets/dialogs/create-target.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: false,
        locals: {
          record: record,
          isNew: false,
          model: vm.model,
          activeCatalogCode: activeCatalogCode,
          targetedAttributesList: targetedAttributes,
          aggregateAttributesList: aggregateAttributes,
          event: ev
        }
      }).then(function (saved) {
        if (saved) {
          refreshItems(true);
        }
      });
    }

    var catalogChangedEventCleanup = $rootScope.$on('ActiveCatalogChangedEvent', function(e) {
			if(activeCatalogCode !== catalogFactory.getActiveCatalog().CatalogCode) {
					$state.reload('app.targets');
			}
		});
		$scope.$on('$destroy', function () {
				catalogChangedEventCleanup();
		});

  }
})();
(function () {
  'use strict';

  angular
    .module('app.main.catalogs.targets')
    .controller('createTargetController', createTargetController);

  /* @ngInject */
  function createTargetController($mdDialog, $scope, $window, $filter, $timeout, toast, hotkeys, utility, record, isNew, model, targetedAttributesList, aggregateAttributesList, activeCatalogCode, event, catalogFactory) {
    /* jshint validthis: true */
    var vm = this;

    //Data
    vm.isLoading = false;
    vm.isDataDirty = false;
    vm.isNew = isNew;

    vm.attributesData = [];
    vm.aggregateAttributesData = [];
    vm.searchText = [];
    vm.lookupModel = [];
    vm.isVettingListAttribute = [];
    vm.isVettingListAttribute[0] = false;
    vm.isMultiValueAttribute = [];
    vm.isMultiValueAttribute[0] = false;
    vm.acSelectedItem = [];
    vm.acSearchText = [];
    vm.index = 0;

    var attributesMap = {};
    var valueChangeTimeoutPromise;
    var targetId = "";
    var previousRowIndex = -1;
    var aggregateAttributesMap = {};
    var assignedCatalogAttributes = catalogFactory.getActiveCatalogDetails().AssignedCatalogAttributes;

    //Methods
    vm.saveRecord = saveRecord;
    vm.closeDialog = closeDialog;

    vm.lookupSearch = lookupSearch;
    vm.lookupChange = lookupChange;
    vm.getLookupDisplayValue = getLookupDisplayValue;
    vm.selectText = selectText;
    vm.isRequired = isRequired;
    vm.onValueChange = onValueChange;
    vm.multiValueQuerySearch = multiValueQuerySearch;
    vm.transformChip = transformChip;
    vm.aggregateAttributeLookupSearch = aggregateAttributeLookupSearch;
    vm.aggregateAttributeLookupChange = aggregateAttributeLookupChange;
    vm.getAggregateAttributeLookupDisplayValue = getAggregateAttributeLookupDisplayValue;
    vm.onAggregateAttributeValueChange = onAggregateAttributeValueChange;
    vm.isAggregateAttributeRequired = isAggregateAttributeRequired;

    activate();

    ////////////////

    function activate() {

      if (!vm.isNew) {
        vm.record = record;
        targetId = record.Id;
        populateEditDialog();
      }
      else {
        createEmptyRow();
        createAggregateAttributeEmptyRow();
        vm.record = {};
      }

      //Hotkeys
      hotkeys.bindTo($scope).add({
        combo: 'ctrl+enter',
        description: $filter('translate')('ACTIONS.SAVE'),
        allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
        callback: function (event) {
          if (!vm.isLoading && !vm.editForm.$invalid) {
            vm.saveRecord();
          }
        }
      });

      if (vm.isNew) {
        hotkeys.bindTo($scope)
          .add({
            combo: 'ctrl+shift+enter',
            description: $filter('translate')('ACTIONS.SAVE_AND_NEW'),
            allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
            callback: function (event) {
              if (!vm.isLoading && !vm.editForm.$invalid) {
                vm.saveRecord(true);
              }
            }
          });
      }
    }

    function saveRecord(saveAndNew) {
      vm.isLoading = true;
      vm.record.Attributes = {};
      vm.record.AggregateAttributes = {};
      //push attribute id and value into Attributes property of new record
      angular.forEach(vm.attributesData, function (attribute) {
        if (angular.isDefined(attribute.AttributeId) && attribute.AttributeId !== null && angular.isDefined(attribute.Value) && attribute.Value !== null) {
          vm.record.Attributes[attribute.AttributeId] = attribute.Value;
          if (attribute.inputType === 'multi-value') {
            var multiValue = attribute.Value;
            vm.record.Attributes[attribute.AttributeId] = multiValue;
          }
        }
      });

      //transform the Attributes Object into Json
      if (vm.record.Attributes) {
        vm.record.Attributes = angular.toJson(vm.record.Attributes);
      }

      // push aggregate attribute id and value into Attributes property of new record
      angular.forEach(vm.aggregateAttributesData, function (attribute) {
        if (angular.isDefined(attribute.AggregateAttributeId) && attribute.AggregateAttributeId !== null && angular.isDefined(attribute.Target) && attribute.Target !== null) {
          vm.record.AggregateAttributes[attribute.AggregateAttributeId] = attribute.Target;
        }
      });

      //transform the Attributes Object into Json
      if (vm.record.AggregateAttributes) {
        vm.record.AggregateAttributes = angular.toJson(vm.record.AggregateAttributes);
      }

      var promise;
      if (vm.isNew) {
        promise = model.methods.create(vm.record, activeCatalogCode);
      } else {
        promise = model.methods.update(vm.record, activeCatalogCode, targetId);
      }

      promise.then(function () {
        // when click on save and new while creating record
        if (vm.isNew && angular.isDefined(saveAndNew) && saveAndNew) {
          vm.editForm.$setPristine();
          vm.editForm.$setUntouched();
          vm.attributesData = [];
          vm.aggregateAttributesData = [];
          vm.searchText = [];
          vm.lookupModel = [];
          createEmptyRow();
          createAggregateAttributeEmptyRow();
          vm.isDataDirty = true;

          var el = $window.document.getElementById('dialog_input_first');
          if (el) {
            el.focus();
          }
        }
        else {
          closeDialog(true);
        }
        var toastMessage = vm.isNew ? 'SUCCESS.CREATE' : 'SUCCESS.UPDATE';
        toast.success(toastMessage, '', '');
      }, function () {
        closeDialog(vm.isDataDirty);
      }).finally(function () {
        vm.isLoading = false;
      })
    }

    function closeDialog(saved) {
      $mdDialog.hide(saved);
    }

    function lookupSearch(query, rowIndex) {
      var results = [];
      var predicate = {};
      predicate.AttributeDisplayName = query;
      var availableAttributes = [];
      availableAttributes = loadAvailableAttributes(rowIndex);
      results = query ? utility.filterObject(availableAttributes, predicate) : availableAttributes;
      return results;
    }

    function lookupChange(selectedObj, rowIndex) {
      if (angular.isObject(selectedObj)) {
        previousRowIndex = rowIndex;
        vm.attributesData[rowIndex].AttributeId = selectedObj.AttributeId;
        attributesMap[selectedObj.AttributeId] = 1;
        //check if AllowedValues is present, then show the drop-down list for attribute value
        var attribute = utility.filterObject(assignedCatalogAttributes, {AttributeSystemName: selectedObj.AttributeSystemName}, true)[0];
        if (attribute.AllowedValues != null) {
          vm.isVettingListAttribute[rowIndex] = true;
          vm.attributesData[rowIndex].Values = (attribute.AllowedValues || [])
          .map(function(value) {
            return value.trim();
          })
          .sort(function(a, b) {
            return a.toLowerCase().localeCompare(b.toLowerCase());
          });
        } else {
          vm.isVettingListAttribute[rowIndex] = false;
        }

        if(selectedObj.AttributeTypeName.toUpperCase() === 'MULTIVALUE') {
          vm.isMultiValueAttribute[rowIndex] = true;
          if(vm.isVettingListAttribute[rowIndex]) {
            vm.attributesData[rowIndex].Value = [];
            vm.attributesData[rowIndex].inputType = 'multi-value';
          }
        } else {
          vm.isMultiValueAttribute[rowIndex] = false;
        }
      }
      else if (angular.isUndefined(selectedObj) || selectedObj === null) {
        delete attributesMap[vm.attributesData[rowIndex].AttributeId];
        vm.attributesData[rowIndex].AttributeId = undefined; // on record removal make field undefined or the property can be deleted using delete keyword
        if(vm.isVettingListAttribute[rowIndex]) {
          vm.attributesData[rowIndex].Value = [];
        } else {
          vm.attributesData[rowIndex].Value = '';
        }
      }
      // if adding data to last row and value is added create new row
      if (rowIndex === vm.attributesData.length - 1 && angular.isDefined(vm.attributesData[rowIndex].Value) && vm.attributesData[rowIndex].Value !== null && vm.attributesData[rowIndex].Value.length >0) {
        createEmptyRow(rowIndex);
      }
    }

    function onValueChange(rowIndex) {
      if (angular.isDefined(vm.attributesData[rowIndex].Value)) {
        $timeout.cancel(valueChangeTimeoutPromise);
        valueChangeTimeoutPromise = $timeout(function () {
          // if last row and attribute is selected create empty row
          if (rowIndex === vm.attributesData.length - 1 && angular.isDefined(vm.attributesData[rowIndex].AttributeId) && vm.attributesData[rowIndex].AttributeId !== null
            && angular.isDefined(vm.attributesData[rowIndex].Value) && vm.attributesData[rowIndex].Value !== null) {
            createEmptyRow();
          }
        }, 100);
      }
    }

    function getLookupDisplayValue(item) {
      return getLookupDisplayVal(item, targetedAttributesList);
    }

    function aggregateAttributeLookupSearch(query, rowIndex) {
      var results = [];
      var predicate = {};
      predicate.AttributeDisplayName = query;
      var availableAttributes = [];
      availableAttributes = loadAvailableAggregateAttributes(rowIndex);
      results = query ? utility.filterObject(availableAttributes, predicate) : availableAttributes;
      return results;
    }

    function aggregateAttributeLookupChange(selectedObj, rowIndex) {
      if (angular.isObject(selectedObj)) {
        previousRowIndex = rowIndex;
        vm.aggregateAttributesData[rowIndex].AggregateAttributeId = selectedObj.AttributeId;
        aggregateAttributesMap[selectedObj.AttributeId] = 1;
      }
      else if (angular.isUndefined(selectedObj) || selectedObj === null) {
        delete aggregateAttributesMap[vm.aggregateAttributesData[rowIndex].AggregateAttributeId];
        vm.aggregateAttributesData[rowIndex].AggregateAttributeId = undefined; // on record removal make field undefined or the property can be deleted using delete keyword
      }
      // if adding data to last row and value is added create new row
      if (rowIndex === vm.aggregateAttributesData.length - 1 && angular.isDefined(vm.aggregateAttributesData[rowIndex].Target) && vm.aggregateAttributesData[rowIndex].Target !== null && vm.aggregateAttributesData[rowIndex].Target.length >0) {
        createAggregateAttributeEmptyRow(rowIndex);
      }
    }

    function onAggregateAttributeValueChange(rowIndex) {
      if (angular.isDefined(vm.aggregateAttributesData[rowIndex].Target)) {
        $timeout.cancel(valueChangeTimeoutPromise);
        valueChangeTimeoutPromise = $timeout(function () {
          // if last row and attribute is selected create empty row
          if (rowIndex === vm.aggregateAttributesData.length - 1 && angular.isDefined(vm.aggregateAttributesData[rowIndex].AggregateAttributeId) && vm.aggregateAttributesData[rowIndex].AggregateAttributeId !== null
            && angular.isDefined(vm.aggregateAttributesData[rowIndex].Target) && vm.aggregateAttributesData[rowIndex].Target !== null) {
              createAggregateAttributeEmptyRow();
          }
        }, 100);
      }
    }

    function getAggregateAttributeLookupDisplayValue(item) {
      return getLookupDisplayVal(item, aggregateAttributesList);
    }

    function getLookupDisplayVal(item, attributes) {
      var result;
      if (attributes) {
        // since autocomplete return object
        if (angular.isObject(item)) {
          result = utility.filterObject(attributes, { AttributeId: item.AttributeId }, true);
        }
        // to initialize field value if any (when open update record dialog)
        else {
          result = utility.filterObject(attributes, { AttributeId: item }, true);
        }

        if (angular.isArray(result) && result.length > 0) {
          return result[0].AttributeDisplayName;
        }
        else {
          return result.AttributeDisplayName;
        }
      }
    }

    function selectText(event) {
      utility.selectInputText(event);
    }

    function isRequired(attribute, Value, rowIndex) {
      if (rowIndex === 0) {
        if (vm.attributesData[rowIndex][attribute]) {
          if (angular.isUndefined(vm.attributesData[rowIndex][Value]) || vm.attributesData[rowIndex][Value] === null) {
            return true; //if Value is not defined
          }
          else return false;//if Value is defined
        }
        else return true;//if attribute is not defined
      }
    }

    function isAggregateAttributeRequired(attribute, Value, rowIndex) {
      if (rowIndex === 0) {
        if (vm.attributesData[rowIndex][attribute]) {
          if (angular.isUndefined(vm.attributesData[rowIndex][Value]) || vm.attributesData[rowIndex][Value] === null) {
            return true; //if Value is not defined
          }
          else return false;//if Value is defined
        }
        else return true;//if attribute is not defined
      }
    }

    function loadAvailableAttributes(rowIndex) {
      var availableAttributes = [];
      angular.forEach(targetedAttributesList, function (attribute) {
        if (!attributesMap[attribute.AttributeId]) {
          availableAttributes.push(attribute);
        } else if (previousRowIndex == rowIndex && attribute.AttributeId == vm.attributesData[rowIndex].AttributeId) {//add the attribute for the same row when removed
          availableAttributes.push(attribute);
        }
      })
      return availableAttributes;
    }

    function loadAvailableAggregateAttributes(rowIndex) {
      var availableAttributes = [];
      angular.forEach(aggregateAttributesList, function (attribute) {
        if (!aggregateAttributesMap[attribute.AttributeId]) {
          availableAttributes.push(attribute);
        } else if (previousRowIndex == rowIndex && attribute.AttributeId == vm.aggregateAttributesData[rowIndex].AggregateAttributeId) {//add the attribute for the same row when removed
          availableAttributes.push(attribute);
        }
      })
      return availableAttributes;
    }

    function populateEditDialog() {
      var attributesDataLength = 0;
      if(vm.record.Attributes != null && vm.record.Attributes !== '') {
        var attributes = angular.fromJson(vm.record.Attributes);
        for (var key in attributes) {
          attributesDataLength = vm.attributesData.push({ AttributeId: parseInt(key), Value: attributes[key] });
          attributesMap[key] = 1;
          if (angular.isUndefined(vm.lookupModel[attributesDataLength - 1])) {
            vm.lookupModel[attributesDataLength - 1] = {};
          }
          vm.lookupModel[attributesDataLength - 1].AttributeId = parseInt(key);
        }
      }
      createEmptyRow(attributesDataLength);
      var aggregateAttributesDataLength = 0;
      if(vm.record.AggregateAttributes != null && vm.record.AggregateAttributes !== '') {
        var aggregateAttributes = angular.fromJson(vm.record.AggregateAttributes);
        for (var key in aggregateAttributes) {
          var targetValue = typeof(aggregateAttributes[key]) === 'string' ? parseInt(aggregateAttributes[key]) : aggregateAttributes[key];
          aggregateAttributesDataLength = vm.aggregateAttributesData.push({ AggregateAttributeId: parseInt(key), Target: targetValue });
          attributesMap[key] = 1;
          if (angular.isUndefined(vm.lookupModel[attributesDataLength - 1])) {
            vm.lookupModel[aggregateAttributesDataLength - 1] = {};
          }
          vm.lookupModel[aggregateAttributesDataLength - 1].AggregateAttributeId = parseInt(key);
        }
      }
      createAggregateAttributeEmptyRow(aggregateAttributesDataLength);
    }

    function createEmptyRow(rowIndex) {
      vm.searchText.push({});
      vm.lookupModel.push({});
      vm.attributesData.push({ AttributeId: null, Value: null });
      if(rowIndex) {
        vm.isVettingListAttribute[rowIndex+1] = false;
      } else {
        vm.isVettingListAttribute[vm.attributesData.length] = false;
      }
    }

    function createAggregateAttributeEmptyRow(rowIndex) {
      vm.searchText.push({});
      vm.lookupModel.push({});
      vm.aggregateAttributesData.push({ AggregateAttributeId: null, Target: null });
      if(rowIndex) {
        vm.isVettingListAttribute[rowIndex+1] = false;
      } else {
        vm.isVettingListAttribute[vm.aggregateAttributesData.length] = false;
      }
    }

    function multiValueQuerySearch(query, selectedItems, field) {
      var values = field.Values;
      var searchQueryResult = [];
      var searchQueryResult = utility.filterObject(values, query);
      if (selectedItems && selectedItems.length > 0) {
        for (var index = searchQueryResult.length - 1; index >= 0; index--) {
          if (selectedItems.indexOf(searchQueryResult[index]) !== -1) {
            searchQueryResult.splice(index, 1);
          }
        }
      }
      return searchQueryResult;
    }

    function transformChip(chip, isMultiValue) {
      if(isMultiValue) {
          return chip;
      }
      return undefined;
    }

    $scope.$on('$destroy', function () {
      $timeout.cancel(valueChangeTimeoutPromise);
    })

  }
})();
(function () {
	'use strict';

	angular
		.module('app.main.catalogs.stock-linear', [])
		.config(config);

	/* @ngInject */
	function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
		// State
		$stateProvider.state('app.stock_linear', {
			url: '/stock-linear',
			views: {
				'content@app': {
					templateUrl: 'app/main/catalogs/sub-modules/stock-linear/list/stock-linear-list.html',
					controller: 'stockLinearListController as vm'
				}
			},
			resolve: {},
			data: {
				displayName: 'STOCK_LINEAR.NAV'
			},
			//only users with following accessPrivileges in their role access list can access this route
			// accessPrivileges: ['GetStockList']
			// accessPrivileges: ['nav_stock']
			accessInfo: {
				accessPrivileges: ['nav_stock']
			}
		});

		// Translation
		$translatePartialLoaderProvider.addPart('app/main/catalogs/sub-modules/stock-linear');

		msNavigationServiceProvider.saveItem('catalogs.stock.stock_linear', {
			title   : 'Linear View',
			subTitle: 'Stock',
			icon    : 'icon-basket-fill',
			state   : 'app.stock_linear',
			translate: 'NAV.LINEAR_VIEW',
			weight: 43,
			// accessPrivileges: ['GetStockList']
			// accessPrivileges: ['nav_stock']
			accessInfo: {
				accessPrivileges: ['nav_stock']
			}
		});
	}
})();
(function () {
  'use strict';

  angular
    .module('app.main.catalogs.stock-linear')
    .controller('stockLinearListController', stockLinearListController);

  /* @ngInject */
  function stockLinearListController( api, $rootScope, $scope, $state, catalogFactory, dataImporter, $timeout, settingsFactory) {
    /* jshint validthis: true */
    var vm = this;

    //Data
    var activeCatalog =  catalogFactory.getActiveCatalog();
    var activeCatalogId = activeCatalog.CatalogCode;
    vm.activeCatalogId = activeCatalogId;

    vm.model = api.catalogs.stockLinear;
    settingsFactory.applyPersistedListViewLayout(vm.model);

    vm.stock = [];
    vm.filteredStock = [];
    vm.isLoading = false;
    var timeoutPromise;


    //Methods

    vm.refreshItems = refreshItems;
    vm.doListAction = doListAction;

    activate();

    ////////////////

    function activate() {
      refreshItems(vm.model.isDirty, true);
    }

    function refreshItems(forceFetch, isLogRequired) {
      vm.isLoading = true;
      var generalProperties = {
        forceFetch: forceFetch,
        isLogRequired: isLogRequired,
        config: {},
        supportIncrementalResult: true,
        modelIdField: 'ArticleNumber',
        isMajor: true
      }
      timeoutPromise = $timeout(function () {
        vm.model.methods.getList(generalProperties, vm.model, activeCatalogId)
          .then(function (response) {
            var responseData = [];
            angular.forEach(response.data, function(article) {
                if(angular.isDefined(article.Stocks) && article.Stocks.length > 0) {
                    angular.forEach(article.Stocks, function(stock) {
                        responseData.push({
                            ArticleId: article.ArticleId,
                            ArticleNumber: article.ArticleNumber,
                            ArticleName: article.ArticleName,
                            SizeName: article.SizeName,
                            Actual: stock.Actual,
                            Reserved: stock.Reserved,
                            Status: stock.Status,
                            StockCode: stock.StockCode,
                            StockDefinitionId: stock.StockDefinitionId,
                            StockName: stock.StockName,
                            UpdatedBy: stock.UpdatedBy,
                            CreatedBy: stock.CreatedBy,
                            CreatedDate: stock.CreatedDate,
                            UpdatedDate: stock.UpdatedDate
                        });
                    });
                }
            });
            vm.stock = responseData;
          })
          .finally(function () {
            vm.isLoading = false;
          });
      }, 500);
    }

    //User can select different articles sizes
    function doListAction(action) {
      if (action) {
        switch (action.id) {
          case 'import':
            dataImporter.importExcel(vm.model, true).then(function (result) {
              vm.model.methods.createBulk(result, activeCatalog, vm.model, action.id);
            });
            break;
        }
      }
    }

    var catalogChangedEventCleanup = $rootScope.$on('ActiveCatalogChangedEvent', function (e) {
      if (activeCatalogId !== catalogFactory.getActiveCatalog().CatalogCode) {
        $state.reload('app.stock_linear');
      }
    });

    $scope.$on('$destroy', function () {
      catalogChangedEventCleanup();
      $timeout.cancel(timeoutPromise);
    });

  }
})();
(function () {
	'use strict';

	angular
		.module('app.main.catalogs.stock', [])
		.config(config);

	/* @ngInject */
	function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
		// State
		$stateProvider.state('app.stock', {
			url: '/stock',
			views: {
				'content@app': {
					templateUrl: 'app/main/catalogs/sub-modules/stock/list/stock-list.html',
					controller: 'stockListController as vm'
				}
			},
			resolve: {
				stockModel: function (api, catalogFactory) {
					//Mapping response source property to fields target property
					var propertiesMapper = [{ target: 'field', source: 'field["StockCode"]' }, { target: 'displayLabel', source: 'field["StockCode"]' }, { target: 'stockDefinitionId', source: 'field["Id"]' }],
						inputType = 'number',
						nestedArrayName = 'Stocks',
						valueMapper = 'Actual',
						targetModel = 'catalogs.stock',
						sourceModel = 'catalogs.stockDefinition';

					return catalogFactory.createDynamicModel(targetModel, sourceModel, propertiesMapper, inputType, nestedArrayName, valueMapper);
				}
			},
			data: {
				displayName: 'STOCK.NAV'
			},
			//only users with following accessPrivileges in their role access list can access this route
			// accessPrivileges: ['GetStockList']
			// accessPrivileges: ['nav_stock']
			accessInfo: {
				accessPrivileges: ['nav_stock']
			}
		});

		// Translation
		$translatePartialLoaderProvider.addPart('app/main/catalogs/sub-modules/stock');

		// Navigation
		msNavigationServiceProvider.saveItem('catalogs.stock', {
			title : 'Stock',
			icon  : 'icon-basket-fill',
			translate: 'STOCK.NAV',
			weight: 45,
			// accessPrivileges: ['GetStockList']
			// accessPrivileges: ['nav_stock']
			accessInfo: {
				accessPrivileges: ['nav_stock']
			}
		});

		msNavigationServiceProvider.saveItem('catalogs.stock.stock', {
			title   : 'Tabular View',
			subTitle: 'Stock',
			icon    : 'icon-basket-fill',
			state   : 'app.stock',
			translate: 'NAV.TABULAR_VIEW',
			weight: 43,
			// accessPrivileges: ['GetStockList']
			// accessPrivileges: ['nav_stock']
			accessInfo: {
				accessPrivileges: ['nav_stock']
			}
		});
	}
})();
(function () {
  'use strict';

  angular
    .module('app.main.catalogs.stock')
    .controller('stockListController', stockListController);

  /* @ngInject */
  function stockListController( stockModel, $rootScope, $scope, $state, catalogFactory, dataImporter, $timeout, settingsFactory, utility) { // api
    /* jshint validthis: true */
    var vm = this;

    //Data
    var activeCatalog =  catalogFactory.getActiveCatalog();
    var activeCatalogId = activeCatalog.CatalogCode;
    vm.activeCatalogId = activeCatalogId;

    vm.model = stockModel;
    settingsFactory.applyPersistedListViewLayout(vm.model);

    vm.stock = [];
    vm.filteredStock = [];
    vm.isLoading = false;
    var timeoutPromise;


    //Methods

    vm.refreshItems = refreshItems;
    vm.doListAction = doListAction;

    activate();

    ////////////////

    function activate() {
      refreshItems(vm.model.baseModel.isDirty, true);
    }

    function refreshItems(forceFetch, isLogRequired) {
      vm.isLoading = true;
      var generalProperties = {
        forceFetch: forceFetch,
        isLogRequired: isLogRequired,
        config: {},
        supportIncrementalResult: true,
        modelIdField: ['ArticleId',
                      'SizeId'],// it should be outerObject Id
        isMajor: true,
        nestedDataIdField: 'Id'//it should be nestedObject Id
      }
      //todo
      timeoutPromise = $timeout(function () {
        vm.model.methods.getList(generalProperties, vm.model, activeCatalogId)
          .then(function (response) {
            vm.stock = catalogFactory.transformStockResponse(response.data, 'Stocks', vm.model.fields);
          })
          .finally(function () {
            vm.isLoading = false;
          });
      }, 500);
    }



    //User can select different articles sizes
    function doListAction(action, records, additionalInfo) {
      if (action) {
        switch (action.id) {
          case 'import':
            dataImporter.importExcel(vm.model, true).then(function (result) {
              vm.model.methods.createBulk(result, activeCatalog, vm.model, action.id);
            });
            break;
        }
      }
    }

    var catalogChangedEventCleanup = $rootScope.$on('ActiveCatalogChangedEvent', function (e) {
      if (activeCatalogId !== catalogFactory.getActiveCatalog().CatalogCode) {
        $state.reload('app.stock');
      }
    });
    $scope.$on('$destroy', function () {
      catalogChangedEventCleanup();
      $timeout.cancel(timeoutPromise);
    });

  }
})();
(function() {
    'use strict';

    angular
        .module('app.main.catalogs.sizes',[])
        .config(config);

    /* @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
        // State
        $stateProvider.state('app.sizes', {
            url    : '/sizes',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/catalogs/sub-modules/sizes/list/sizes-list.html',
                    controller : 'sizesListController as vm'
                }
            },
            resolve: {
                sizesModel: function(api, utility, catalogFactory) {
                    var sizesModelClone = angular.copy(api.catalogs.sizes);
                    sizesModelClone.baseModel = api.catalogs.sizes;
                    var activeCatalog = catalogFactory.getActiveCatalog();
                    var isSizeScaleByStyle = catalogFactory.getIsSizeScaleByStyle();

                    // update model to make only ArticleNumber, SizeIndex, SizeName creatable for import
                    if (activeCatalog.DataSourceTypeId == 3 && activeCatalog.IndependentSizes != 1) {
                        var creatableFields = utility.filterObject(sizesModelClone.fields, { creatable: true });
                        angular.forEach(creatableFields, function (creatableField) {
                            if (!(creatableField.field == 'ArticleNumber' || creatableField.field == 'SizeIndex' || creatableField.field == 'SizeName')) {
                                creatableField.creatable = false;
                            }
                        });
                    }

                    //if inherited catalog and sizeScale disabled on catalog (when sizeScale enable there will be no action but view item)
                    if(activeCatalog.DataSourceTypeId == 3 && isSizeScaleByStyle === 0) {
                        //hide import sizes by index for inherited catalogs if independentSizes is not enabled
                        if(activeCatalog.IndependentSizes != 1) {
                            var indexOfImportByIndex = sizesModelClone.views.mainList.listActions.indexOf(
                                utility.filterObject(sizesModelClone.views.mainList.listActions, {id: 'importSizeIndexes'}, true)[0]);
                            if(indexOfImportByIndex != -1) {
                                sizesModelClone.views.mainList.listActions.splice(indexOfImportByIndex, 1);
                            }
                        }
                        // disable update record for inherited catalogs
                        var editItemAction = utility.filterObject(sizesModelClone.views.mainList.itemActions, {id: 'edit'}, true)[0];
                        if(editItemAction) {
                            editItemAction.disabled = true;
                        }
                    }
                    // if size scale enabled disable all the actions
                    else if(isSizeScaleByStyle === 1) {
                        // when IndependentSizes is enabled do not disable import actions
                        if(activeCatalog.IndependentSizes == 1) {
                            angular.forEach(sizesModelClone.views.mainList.listActions, function(listAction) {
                                if(listAction.id.toUpperCase() !== 'IMPORTSIZES' && listAction.id.toUpperCase() !== 'IMPORTSIZEINDEXES') {
                                    listAction.visible = false;
                                }
                            })
                        }
                        else {
                            sizesModelClone.views.mainList.listActions = [];
                        }
                        angular.forEach(sizesModelClone.views.mainList.itemActions, function(itemAction) {
                            if(itemAction.id !== 'view') {
                                itemAction.visible = false;
                            }
                        });
                    }
                    return sizesModelClone;
                }
            },
            data: {
                displayName: 'SIZES.NAV'
            },
            //only users with following accessPrivileges in their role access list can access this route
            // accessPrivileges: ['GetListArticleSizes']
            // accessPrivileges: ['nav_sizes']
            accessInfo: {
                accessPrivileges: ['nav_sizes']
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/catalogs/sub-modules/sizes');

        msNavigationServiceProvider.saveItem('catalogs.sizes', {
            title      : 'Sizes',
            icon       : 'icon-layers',
            state      : 'app.sizes',
            translate  : 'SIZES.NAV',
            weight     : 50,
            // accessPrivileges: ['GetListArticleSizes']
            // accessPrivileges: ['nav_sizes']
            accessInfo: {
                accessPrivileges: ['nav_sizes']
            }
        });
    }
})();
(function() {
    'use strict';

	angular
		.module('app.main.catalogs.sizes')
		.controller('sizesListController', sizesListController);

	/* @ngInject */
	function sizesListController(api, $rootScope, $scope, $state, $document, sizesModel, catalogFactory, dataImporter, $timeout, settingsFactory, utility) {
		/* jshint validthis: true */
		var vm = this;

        //Data

        var activeCatalog = catalogFactory.getActiveCatalog();
		var activeCatalogId = activeCatalog.CatalogCode;
        vm.activeCatalogId = activeCatalogId;

        vm.model = sizesModel;
        settingsFactory.applyPersistedListViewLayout(vm.model);

		vm.sizes = [];
		vm.filteredSizes = [];
		vm.isLoading = false;
        var timeoutPromise;


		//Methods
		vm.refreshItems = refreshItems;
		vm.doItemAction = doItemAction;
        vm.doListAction = doListAction;
		vm.viewItem = viewItem;

		activate();

		////////////////

        function activate() {
            refreshItems(vm.model.baseModel.isDirty, true);
        }

		function refreshItems(forceFetch, isLogRequired) {
            vm.isLoading = true;
            var generalProperties = {
                forceFetch: forceFetch,
                isLogRequired: isLogRequired,
                config: {},
                supportIncrementalResult: true,
                modelIdField: vm.model.idField,// it should be outerObject Id
                isMajor: true,
                nestedDataIdField: 'Id'//it should be nestedObject Id
            }
            timeoutPromise = $timeout(function() {// TODO - need to change GET method catching mechanism (since the data is catched controll goes to then part imidiatly and transform function freezes the UI)
                vm.model.methods.getList(generalProperties, vm.model, activeCatalogId)
                    .then(function (response) {
                        vm.sizes = catalogFactory.transform( response.data, 'Sizes');
                    })
                    .finally(function () {
                        vm.isLoading = false;
                    });
            },500);
		}

		//Item Action button pressed event
		function doItemAction(action, record, additionalInfo) {
			if (action && record) {
                switch (action.id) {
                    case 'view':
                        viewItem(record);
                        break;
                    case 'edit':
                        editSize(record, null);
                        break;
                    case 'delete':
                    case 'activate':
                        vm.model.methods.activateBulk(record, vm.model, action.id, activeCatalogId, additionalInfo);
                        break;
                }
			}
		}

        //User can select different articles sizes
        function doListAction(action, records, additionalInfo) {
            if (action) {
                switch (action.id) {
                    case 'delete':
                    case 'activate':
                        vm.model.methods.activateBulk(records, vm.model, action.id, activeCatalogId, additionalInfo);
                        break;
                    case 'importSizes':
                    case 'importSizeIndexes':
                        dataImporter.importExcel(vm.model, true, { showReasonPage: true }).then(function (result) {
                            vm.model.methods.createBulk(result, activeCatalog, vm.model, action.id);
                        });

                        break;
                }
            }
        }

         function viewItem(item) {
            var id = item.ArticleId;
            var stateParams = {id: id, tab: 'SIZES'};
            $state.go('app.articles.details', stateParams);
		}

        function editSize(record, ev) {
            // Add NewSizeName and NewSizeIndex to record and assign them with SizeName and SizeIndex to pre-populate the edit dialog with old values
            record.NewSizeName = record.SizeName;
            record.NewSizeIndex = record.SizeIndex;
            var modelClone = angular.copy(vm.model);
            api.showEditRecordDialog(angular.element($document.body), ev, modelClone, record, { 'activeCatalogId': activeCatalogId, 'ArticleId': record.ArticleId })
                .then(function (saved) {
                    if (saved) {
                        refreshItems(true);
                    }
                });
        }

        var catalogChangedEventCleanup = $rootScope.$on('ActiveCatalogChangedEvent', function(e) {
            if(activeCatalogId !== catalogFactory.getActiveCatalog().CatalogCode) {
                $state.reload('app.sizes');
            }
        });
        $scope.$on('$destroy', function () {
            catalogChangedEventCleanup();
            $timeout.cancel(timeoutPromise);
        });

	}
})();
(function() {
	'use strict';

	angular
			.module('app.main.catalogs.size-curves', [])
			.config(config);

	/* @ngInject */
	function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {

			$stateProvider.state('app.size_curves', {
					url    : '/size-curves',
					views  : {
							'content@app': {
									templateUrl: 'app/main/catalogs/sub-modules/size-curves/list/size-curves-list.html',
									controller : 'sizeCurveListController as vm'
							}
					},
					resolve: {},
					data: {
							displayName: 'SIZE_CURVES.NAV'
					},
					// accessPrivileges: ['GetSizeCurves']
					// accessPrivileges: ['nav_sizecurves']
					accessInfo: {
						accessPrivileges: ['nav_sizecurves']
					}
			});

			// Translation
			$translatePartialLoaderProvider.addPart('app/main/catalogs/sub-modules/size-curves');

			// Navigation
			msNavigationServiceProvider.saveItem('catalogs.size_curves', {
					title      : 'Size Curves',
					icon       : 'icon-arrow-collapse',
					state      : 'app.size_curves',
					translation: 'SIZE_CURVES.NAV',
					weight     : 51,
					// accessPrivileges: ['GetSizeCurves']
					// accessPrivileges: ['nav_sizecurves'],
					accessInfo: {
						accessPrivileges: ['nav_sizecurves']
					}
			});
	}

})();
(function () {
	'use strict';

	angular
		.module('app.main.catalogs.size-curves')
		.controller('sizeCurveListController', sizeCurveListController);

	/* @ngInject */
	function sizeCurveListController(api, $rootScope, $scope, $state, $document, catalogFactory, dataImporter, $timeout, settingsFactory, utility, $mdDialog, dataExporter) {
		/* jshint validthis: true */
		var vm = this;

		//Data

		var activeCatalog = catalogFactory.getActiveCatalog();
		var catalogCode = activeCatalog.CatalogCode;
		var activeCatalogDetails = catalogFactory.getActiveCatalogDetails();
		var catalogConfigurationsList = activeCatalogDetails.CatalogSpecificConfigurationList;
		var sizeCurveCriteriaAttributes = [];
		var dataSourceTypeId = activeCatalog.DataSourceTypeId
		var allAttributes = activeCatalogDetails.AssignedCatalogAttributes;
		var isSizeCurveByCriteria = false;

		vm.model = api.catalogs.sizeCurves;
		settingsFactory.applyPersistedListViewLayout(vm.model);

		vm.sizeCurves = [];
		vm.filteredSizeCurves = [];
		vm.formattedFilteredSizeCurves = []; // used in size curve export
		vm.isLoading = false;
		var timeoutPromise;


		//Methods
		vm.refreshItems = refreshItems;
		vm.doItemAction = doItemAction;
		vm.doListAction = doListAction;
		vm.addSizeCurves = addSizeCurves;

		activate();

		////////////////

		function activate() {
			if(catalogConfigurationsList.length) {
				// T1S-SizeCurveByCriteria
				var sizeCurveByCriteriaConfig = utility.filterObject(catalogConfigurationsList, { Name: 'T1S-SizeCurveByCriteria' }, true)[0];
				if(angular.isDefined(sizeCurveByCriteriaConfig) && (sizeCurveByCriteriaConfig.Value === true || sizeCurveByCriteriaConfig.Value === 'true')) {
					isSizeCurveByCriteria = true;
				} else {
					isSizeCurveByCriteria = false;
				}
			} else {
				sizeCurveCriteriaAttributes = [];
				isSizeCurveByCriteria = false;
			}
			if (!isSizeCurveByCriteria) {
				var sizeCurveCriteriaAttributesConfig = utility.filterObject(catalogConfigurationsList, { Name: 'T1S-SizeCurveCriteriaAttributes' }, true)[0];
				if(angular.isDefined(sizeCurveCriteriaAttributesConfig) && sizeCurveCriteriaAttributesConfig.Value != '') {
						try {
							sizeCurveCriteriaAttributes = JSON.parse(sizeCurveCriteriaAttributesConfig.Value);
						} catch(error) {
								console.warn("T1S-SizeCurveCriteriaAttributes Configuration : Invalid JSON format");
						}
				} else {
					sizeCurveCriteriaAttributes = [];
				}
			}
			refreshItems(vm.model.isDirty, true);
		}

		function refreshItems(forceFetch, isLogRequired) {
			var generalProperties = {
				forceFetch: forceFetch,
				isLogRequired: isLogRequired
			}
			vm.isLoading = true;
			vm.model.methods.getList(generalProperties, catalogCode, vm.model).then(function (response) {
				vm.sizeCurves = response.data;
			}).finally(function () {
				vm.isLoading = false;
			});
		}

		function doItemAction(action, record) {
			if (action && record) {
				switch (action.id) {
					case 'edit':
						editSizeCurves(record, null);
						break;
					case 'delete':
					case 'activate':
						vm.model.methods.activateBulk(record, vm.model, action.id, catalogCode).then(function () {
							refreshItems(true, false);
						});
						break;
				}
			}
		}

		function doListAction(action, records) {
			if (action) {
				switch (action.id) {
					case 'delete':
					case 'activate':
						vm.model.methods.activateBulk(records, vm.model, action.id, catalogCode).then(function () {
							refreshItems(true, false);
						});
						break;
					case 'import':
						var modelCopy = angular.copy(vm.model);
						if (!isSizeCurveByCriteria) {
							// add the configured attributes to the model field list
							if(sizeCurveCriteriaAttributes.length) {
								angular.forEach(sizeCurveCriteriaAttributes, function(attributeSystemName) {
									var attribute = utility.changeAttributeType(utility.filterObject(allAttributes, {AttributeSystemName: attributeSystemName}, true)[0]);
									if(attribute) {
										attribute.field = attribute.AttributeSystemName;
										attribute.displayLabel = attribute.AttributeDisplayName;
										attribute.inputType = attribute.AttributeDisplayName;
										attribute.creatable = true;
										attribute['validation'] = {isRequired: false, maxLen: -1, minLen: 0, pattern: ''};
										modelCopy.fields.push(attribute);
									}
								})
							}
						}
						else {
							var criteriaField = utility.filterObject(modelCopy.fields, {field: 'Criteria'}, true)[0];
							criteriaField.creatable = true;
						}

						dataImporter.importExcel(modelCopy, true).then(function (result) {
							vm.model.methods.createBulk(vm.model, result.data, catalogCode, isSizeCurveByCriteria, sizeCurveCriteriaAttributes);
						});
						break;
					case 'export':
						var modelCopy = angular.copy(vm.model);
						// remove Sizes fiels from column list
						var index = modelCopy.fields.indexOf(utility.filterObject(modelCopy.fields, {field: 'Sizes'}, true)[0]);
						if (index !== -1) {
							modelCopy.fields.splice(index, 1);
						}
						var sizeField = utility.filterObject(modelCopy.fields, {field: 'Size'}, true)[0];
						sizeField.visible = true;
						var quantityField = utility.filterObject(modelCopy.fields, {field: 'Quantity'}, true)[0];
						quantityField.visible = true;
						var createdDateField = utility.filterObject(modelCopy.fields, {field: 'CreatedDate'}, true)[0];
						createdDateField.visible = false;
						var updatedDateField = utility.filterObject(modelCopy.fields, {field: 'UpdatedDate'}, true)[0];
						updatedDateField.visible = false;
						var updatedByField = utility.filterObject(modelCopy.fields, {field: 'UpdatedBy'}, true)[0];
						updatedByField.visible = false;
						var createdByField = utility.filterObject(modelCopy.fields, {field: 'CreatedBy'}, true)[0];
						createdByField.visible = false;
						// add the configured attributes to the model field list
						if(!isSizeCurveByCriteria && sizeCurveCriteriaAttributes.length) {
							var criteriaField = utility.filterObject(modelCopy.fields, {field: 'Criteria'}, true)[0];
							criteriaField.visible = false;
							angular.forEach(sizeCurveCriteriaAttributes, function(attributeSystemName) {
								var attribute = utility.changeAttributeType(utility.filterObject(allAttributes, {AttributeSystemName: attributeSystemName}, true)[0]);
								if(attribute) {
									attribute.field = attribute.AttributeSystemName;
									attribute.displayLabel = attribute.AttributeDisplayName;
									attribute.inputType = attribute.AttributeDisplayName;
									attribute.visible = true;
									modelCopy.fields.push(attribute);
								}
							})
						}
						var allFormattedRecords = formatSelectedrecordsToRequiredForm(vm.sizeCurves, records);
						var columnList = utility.filterObject(modelCopy.fields, {visible: true});
						var defaultOpt = '0';
						if (records.length > 0) {
							//Set default to `Selections`
							defaultOpt = '2';
						} else if (vm.sizeCurves.length != vm.filteredSizeCurves.length) {
							//Set default to `Filtered Data`
							defaultOpt = '1';
						}
						dataExporter.exportExcel(modelCopy, allFormattedRecords, vm.formattedFilteredSizeCurves, {}, columnList, defaultOpt);
						break;
				}
			}
		}

		// helper method
		function formatSelectedrecordsToRequiredForm(sizeCurves, selectedRecords) {
			// we will loop through size curve's sizes and create each row
			vm.formattedFilteredSizeCurves = [];
			var flattenedData = [];
			sizeCurves.forEach(function(sizeCurve) {
				// if size curve is selected the set the selected flag true
				var selectedSizeCurve = utility.filterObject(selectedRecords, {Name: sizeCurve.Name}, true)[0];
				var selected = angular.isDefined(selectedSizeCurve) ? true : false;

				sizeCurve.Sizes.forEach(function(size) {
					var flattenedObject = {
						Id: sizeCurve.Id,
						Name: sizeCurve.Name,
						Status: sizeCurve.Status,
						Size: size.Size,
						Quantity: size.Quantity,
						AllocationType: sizeCurve.AllocationType,
						Level: sizeCurve.Level,
						CustomerCode: sizeCurve.CustomerCode,
						selected: selected
					};
					if (!isSizeCurveByCriteria) {
						// flatten criteria
						try {
							var criteria = JSON.parse(sizeCurve.Criteria);
							for(var key in criteria) {
								if(criteria[key] !== '' && criteria[key].length) {
									flattenedObject[key] = criteria[key];
								}
							}
						} catch(error) {
							console.warn("T1S-SizeCurveCriteriaAttributes Configuration : Invalid JSON format");
						}
					}
					else {
						flattenedObject['Criteria'] = sizeCurve.Criteria;
					}

					flattenedData.push(flattenedObject);
					// add the filteted sizecurves to new array
					var filteredSizeCurve = utility.filterObject(vm.filteredSizeCurves, {Name: sizeCurve.Name}, true)[0];
					if(angular.isDefined(filteredSizeCurve)) {
						vm.formattedFilteredSizeCurves.push(flattenedObject);
					}
				});
			});
			return flattenedData;
		}

		function addSizeCurves(ev) {
			$mdDialog.show({
				controller: 'addUpdateSizeCurveController',
				controllerAs: 'vm',
				templateUrl: 'app/main/catalogs/sub-modules/size-curves/dialogs/add-update-size-curve.html',
				parent: angular.element($document.body),
				targetEvent: ev,
				clickOutsideToClose: false,
				locals: {
					record: null,
					isNew: true,
					model: vm.model,
					existingRecordsForUniqueValue: angular.copy(vm.sizeCurves),
					catalogCode: catalogCode,
					dataSourceTypeId: dataSourceTypeId,
					availableAttributes: allAttributes,
					sizeCurveCriteriaAttributes: sizeCurveCriteriaAttributes,
					isSizeCurveByCriteria: isSizeCurveByCriteria,
					event: ev
				}
			}).then(function(saved) {
				if (saved) {
					refreshItems(true, false);
				}
			});
		}

		function editSizeCurves(record, ev) {
			var existingRecordsForUniqueValue = angular.copy(vm.sizeCurves);
			for (var i = 0; i < existingRecordsForUniqueValue.length; i++) {
				if(existingRecordsForUniqueValue[i].Id === record.Id) {
					existingRecordsForUniqueValue.splice(i, 1);
				}
			}
			$mdDialog.show({
				controller: 'addUpdateSizeCurveController',
				controllerAs: 'vm',
				templateUrl: 'app/main/catalogs/sub-modules/size-curves/dialogs/add-update-size-curve.html',
				parent: angular.element($document.body),
				targetEvent: ev,
				clickOutsideToClose: false,
				locals: {
					record: record,
					isNew: angular.isDefined(record)? false: true,
					model: vm.model,
					existingRecordsForUniqueValue: angular.copy(existingRecordsForUniqueValue),
					catalogCode: catalogCode,
					dataSourceTypeId: dataSourceTypeId,
					availableAttributes: allAttributes,
					sizeCurveCriteriaAttributes: sizeCurveCriteriaAttributes,
					isSizeCurveByCriteria: isSizeCurveByCriteria,
					event: ev
				}
			}).then(function(saved) {
				if (saved) {
					refreshItems(true, false);
				}
			});
		}

		var catalogChangedEventCleanup = $rootScope.$on('ActiveCatalogChangedEvent', function (e) {
			if (catalogCode !== catalogFactory.getActiveCatalog().CatalogCode) {
				$state.reload('app.size_curves');
			}
		});

		$scope.$on('$destroy', function () {
			catalogChangedEventCleanup();
			$timeout.cancel(timeoutPromise);
		});

	}
})();
(function () {
	'use strict';

	angular
		.module('app.main.catalogs.size-curves')
		.controller('addUpdateSizeCurveController', addUpdateSizeCurveController);

	/* @ngInject */
	function addUpdateSizeCurveController($mdDialog, $scope, $filter,  $timeout, toast, hotkeys, utility, record, isNew, model, existingRecordsForUniqueValue, catalogCode, dataSourceTypeId, availableAttributes, sizeCurveCriteriaAttributes, isSizeCurveByCriteria, event, api) {
		/* jshint validthis: true */
		var vm = this;

		//Data
		vm.isLoading = false;
		vm.isDataDirty = false;
		vm.isNew = isNew;
		vm.record = angular.isArray(record) ? undefined : angular.copy(record);
		vm.criterias = [];
		vm.existingRecordsForUniqueValue = existingRecordsForUniqueValue;
		vm.selectedSizeScales = record; // for bulk edit criteria this will be array od records
		vm.isSizeCurveByCriteria = isSizeCurveByCriteria;

		vm.acSelectedItem = [];
		vm.acSearchText = [];
		vm.searchText = [];
		vm.lookupModel = [];
		vm.recordLookupModel = angular.copy(vm.record);
		vm.availableSizes = [];
		vm.selectedAttibute = {};
		var quantityChangeTimeoutPromise;
		var catalogArticleSizes = [];
		vm.articleNumbers = '';
		vm.favorites = [];
		var catalogArticles = [];
		vm.validSizes = [];
		vm.validSizeCurveCriterias = {};
		vm.selectedDataChoice = 1; // default data choice is favorites
		var activeCustomers = [];
		var favoritesList = [];
		vm.showAdditionalFields = vm.isSizeCurveByCriteria ? true : false;
		vm.quantityRegEx = /^[0-9]\d*$/;
		vm.percentageRegEx = /^(100(\.00?)?|\d{0,2}(\.\d{1,2})?)$/;
		vm.isQuantityAdded = false;
		vm.favorites = [];
		vm.totalPercentageExceedsLimit = false;
		var totalPercentageValue = 0;
		vm.maxTags;

		if (!vm.record) {
			vm.record = {};
			vm.record.AllocationType = 'Quantity'; // default
			vm.record.Level = 'Catalog'; // default
			if(vm.isSizeCurveByCriteria) {
				createEmptyCriteriaRow();
				createEmptySizesRow();
			}
		} else {
			if(vm.isSizeCurveByCriteria) {
				populateCriteriaEditDialog();
			}
			else {
				populateEditDialog();
			}
		}

		//Methods
		vm.saveRecord = saveRecord;
		vm.closeDialog = closeDialog;

		vm.selectText = selectText;
		vm.transformChip = transformChip;
		vm.acQuerySearch = acQuerySearch;
		vm.getChipDisplayValue = getChipDisplayValue;

		vm.getValidSizes = getValidSizes;

		vm.lookupSearch = lookupSearch;
		vm.onCustomerChange = onCustomerChange;
		vm.getLookupDisplayValue = getLookupDisplayValue;
		vm.selectText = selectText;
		vm.levelChange = levelChange;
		vm.typeChange = typeChange;
		vm.validateTotalPercentage = validateTotalPercentage;
		vm.reset = reset;
		vm.isSizeRequired = isSizeRequired;

		vm.multiValueQuerySearch = multiValueQuerySearch;

		vm.lookupAttributeSearch = lookupAttributeSearch;
		vm.lookupAttributeChange = lookupAttributeChange;
		vm.getAttributeLookupDisplayValue = getAttributeLookupDisplayValue;
		vm.isSizeAndQuantityRequired = isSizeAndQuantityRequired;
		vm.onSizeQuantityChange = onSizeQuantityChange;
		vm.transformAttributeChip = transformAttributeChip;
		vm.add = add;
		vm.getDateObj = getDateObj;


		activate();

		////////////////

		function activate() {
			if(vm.isNew && !vm.isSizeCurveByCriteria) {
				loadCatalogArticlesSizes();
				loadFavorites();
			}
			//Hotkeys
			hotkeys.bindTo($scope).add({
				combo: 'ctrl+enter',
				description: $filter('translate')('ACTIONS.SAVE'),
				allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
				callback: function (event) {
					if (!vm.isLoading && !vm.editForm.$invalid) {
						vm.saveRecord();
					}
				}
			});
		}

		function saveRecord() {
			vm.isLoading = true;
			var p;
			if (!vm.isSizeCurveByCriteria) {
					// stringfy criteria
				if(!utility.isObjectEmpty(vm.validSizeCurveCriterias)) {
					vm.record['Criteria'] = angular.toJson(vm.validSizeCurveCriterias);
				}
				var sizesWithNonZeroQuantity = [];
				angular.forEach(vm.validSizes, function(size) {
					if(size.Quantity > 0) {
						sizesWithNonZeroQuantity.push(size);
					}
				})
				vm.record['Sizes'] = sizesWithNonZeroQuantity;
			}
			else {
				// attributes
				var attributes = {};
				angular.forEach(vm.criterias, function(attribute) {
					if (angular.isDefined(attribute.value) && attribute.value.toString().trim() !== '') {
						if (angular.isObject(attribute) && attribute.Attributeid != null && angular.isUndefined(attributes[attribute.AttributeSystemName])) {
							// remove time from date and date option
							if (attribute.inputType === 'date-without-time' || attribute.inputType === 'date-option' || attribute.inputType === 'date') {
								var d = attribute.value;
								var dateValueWithTime = new Date(d.setHours(12-(d.getTimezoneOffset()/60),0,0)).toISOString();
								attributes[attribute.AttributeSystemName] = dateValueWithTime.split('T', 1)[0];
							} else {
								if(angular.isDefined(attribute.value)) {
									attributes[attribute.AttributeSystemName] = angular.isArray(attribute.value) ? attribute.value :
									(attribute.value.indexOf(',') !== -1) ? attribute.value.split(',') : [attribute.value];
								} else {
									attributes[attribute.AttributeSystemName] = '';
								}
							}
						} else if (angular.isDefined(attributes[attribute.AttributeSystemName])) {
							// to support multi value user can select the attribute again when wants to create multi value
							// if an attribute already present means its an array
							if (angular.isArray(attributes[attribute.AttributeSystemName])) {
								attributes[attribute.AttributeSystemName].push(angular.isDefined(attribute.value) ? attribute.value : '');
							} else {
								var valueArray = [];
								valueArray.push(attributes[attribute.AttributeSystemName]);
								valueArray.push(angular.isDefined(attribute.value) ? attribute.value : '');
								attributes[attribute.AttributeSystemName] = valueArray;
							}
						}
					}
				});

				// stringfy criteria
				if (!utility.isObjectEmpty(attributes)) {
					vm.record['Criteria'] = angular.toJson(attributes);
				}

				var sizesArray = [];
				// remove empty size from sizes
				angular.forEach(vm.validSizes, function(size) {
					if(size.Size !== '') {
						sizesArray.push(size);
					}
				})
				vm.record['Sizes'] = sizesArray;
			}
			if (vm.isNew) {
					p = model.methods.create(vm.record, catalogCode);
			} else {
					p = model.methods.update(vm.record.Id, vm.record, catalogCode);
			}

			p.then(function(response) {
					closeDialog(true);
					var toastMessage;
					toastMessage = response.config.method.toUpperCase() === 'POST' ? 'SUCCESS.CREATE': 'SUCCESS.UPDATE';
					toast.success(toastMessage, '', '');
			}, function() {
					closeDialog(vm.isDataDirty);
			}).finally(function () {
					vm.isLoading = false;
			});
		}

		function closeDialog(saved) {
			$mdDialog.hide(saved);
		}

		// todo test
		function lookupSearch(query) {
			var results = [];
			var predicate = {Name: query};
			if(activeCustomers.length) {
				results = query ? utility.filterObject(activeCustomers, predicate):  activeCustomers;
				return results;
			} else {
				return loadCustomers().then(function() {
					results = query ? utility.filterObject(activeCustomers , predicate) : activeCustomers;
					return results;
				});
			}
		}

		function onCustomerChange(selectedObj) {
			if(angular.isObject(selectedObj)) {
				vm.record['CustomerCode'] = selectedObj.CustomerNumber;
			}
		}

		function getLookupDisplayValue(item) {
			var result;
			var predicate = {};
			// since autocomplete return object
			if (angular.isObject(item)) {
				predicate['CustomerNumber'] = item['CustomerNumber'];
				result = utility.filterObject(activeCustomers, predicate, true)[0];
			}
			else {
				predicate['CustomerNumber'] = item;
				result = utility.filterObject(activeCustomers, predicate, true)[0];
			}

			if (angular.isArray(result) && result.length > 0) {
				return result[0].Name;
			}
			else if(angular.isDefined(result)) {
				return result.Name;
			}
		}

		function selectText(event) {
			utility.selectInputText(event);
		}

		function transformChip(chip) {
			if (angular.isObject(chip)) {
				return chip.Tag;
			}
			return undefined;
		}

		function acQuerySearch(query, selectedRecords) {
			var searchQueryResult = [];
				if(angular.isDefined(favoritesList) && favoritesList.length) {
						searchQueryResult = utility.filterObject(favoritesList, query);
						removeSelectedChips(selectedRecords, searchQueryResult);
						return searchQueryResult;
				}
				else {
					return searchQueryResult;
				}
		}

		function removeSelectedChips(selectedRecords, records) {
			if (angular.isDefined(selectedRecords) && selectedRecords.length > 0) {
				for (var index = records.length - 1; index >= 0; index--) {
					if (selectedRecords.indexOf(records[index].Tag) !== -1) {
						records.splice(index, 1);
					}
				}
			}
			return records;
		}

		function getChipDisplayValue(chip) {
			return chip;
		}

		function getValidSizes() {
			var articleNumbersArray = []
			if(vm.articleNumbers !== '' && vm.articleNumbers != null && vm.articleNumbers.length) {
					articleNumbersArray = vm.articleNumbers.split('\n');
			} else if(vm.favorites.length) { // find unique articles from the selected favorites
				var uniqueArticleIds = [];
				angular.forEach(vm.favorites, function(tag) {
						var favorites = utility.filterObject(favoritesList, { Tag: tag }, true);
						angular.forEach(favorites, function(fav) {
								uniqueArticleIds = uniqueArticleIds.concat(fav.Articles.filter(function(article) {
										return uniqueArticleIds.indexOf(article) === -1;
								}));
						});
				});
				// the article numbers from the id's
				angular.forEach(uniqueArticleIds, function(id) {
					var article = utility.filterObject(catalogArticles, { Id: id }, true)[0];
					if(article) {
						articleNumbersArray.push(article.ArticleNumber)
					}
				});
			}
			if(articleNumbersArray.length) {
				var firstArticleSizes = [];
				angular.forEach(articleNumbersArray, function(articleNumber, index) {
					var articleSize = utility.filterObject(catalogArticleSizes, {ArticleNumber: articleNumber}, true)[0];
					if(articleSize && articleSize.Sizes && articleSize.Sizes.length) {
						if(index === 0) {
							firstArticleSizes = articleSize.Sizes.map(function(size) {
								return size.SizeName;
							})
							if(sizeCurveCriteriaAttributes.length) {
								generateCriteria(articleNumber);
							}
						} else {
							firstArticleSizes = firstArticleSizes.filter(function(size) {
								return articleSize.Sizes.some(function(articleSize) {
									return articleSize.SizeName === size;
								})
							});
							if (sizeCurveCriteriaAttributes.length && firstArticleSizes.length > 0) {
								generateCriteria(articleNumber);
							}
						}
					}
				})
				angular.forEach(firstArticleSizes, function(sizeName) {
					vm.validSizes.push({Size: sizeName, Quantity: null});
				})
				vm.noValidSizes = firstArticleSizes.length === 0;
				vm.showAdditionalFields = firstArticleSizes.length > 0
			} else {
				vm.validSizes = [];
				vm.noValidSizes = true;
			}
		}

		function generateCriteria(articleNumber) {
			var article = utility.filterObject(catalogArticles, {ArticleNumber: articleNumber}, true)[0];
			if (article) {
				angular.forEach(sizeCurveCriteriaAttributes, function(attributeSystemName) {
					var attributeValue = article[attributeSystemName];
					if (attributeValue && attributeValue !== null && attributeValue !== '') {
						if (!vm.validSizeCurveCriterias[attributeSystemName]) {
							vm.validSizeCurveCriterias[attributeSystemName] = [];
						}
						var attribute = utility.changeAttributeType(utility.filterObject(availableAttributes, {AttributeSystemName: attributeSystemName}, true)[0]);
						var values;
						if (attribute.AttributeTypeName.toLowerCase() === 'date-without-time' || attribute.AttributeTypeName.toLowerCase() === 'date-option') {
							// For date attributes, extract the date part only
							values = [attributeValue.split('T', 1)[0].toLowerCase()];
						} else if (attribute.AttributeTypeName.toLowerCase() === 'multivalue' || attribute.AttributeTypeName.toLowerCase() === 'multi-value' || (attribute.calcType && attribute.calcType.toLowerCase() === 'multivalue')) {
							// For multivalue attributes, split by comma
							values = attributeValue.toLowerCase().split(',');
						} else {
							// For other attribute types, convert to lowercase
							values = [attributeValue.toString().toLowerCase()];
						}
						// Add unique values to the criteria array
						angular.forEach(values, function(value) {
							if (!vm.validSizeCurveCriterias[attributeSystemName].includes(value)) {
								vm.validSizeCurveCriterias[attributeSystemName].push(value);
							}
						});
					}
				});
			}
		}

		function populateEditDialog() {
			vm.showAdditionalFields = true;
			if(utility.isValidJSON(vm.record.Criteria)) {
				vm.validSizeCurveCriterias = JSON.parse(record.Criteria);
			}
			if(vm.record.Sizes.length) {
				angular.forEach(vm.record.Sizes, function(size) {
					vm.validSizes.push({Size: size.Size, Quantity: size.Quantity});
				});
			}
		}

		function loadCatalogArticlesSizes() {
			vm.isLoading = true;
			api.catalogs.articles.methods.getList({ forceFetch: true, isLogRequired: false }, api.catalogs.articles, catalogCode, dataSourceTypeId)
			.then(function(articleResponse) {
				catalogArticles = articleResponse.data;
				api.catalogs.sizes.methods.getList({ forceFetch: true, isLogRequired: false }, api.catalogs.articles, catalogCode)
				.then(function(response) {
					catalogArticleSizes = utility.filterObject(response.data, {Status: 1});
				});
			}).finally(function () {
				vm.isLoading = false;
			})
		}

		function loadFavorites() {
			api.catalog.favorites.methods.getList({ forceFetch: true, isLogRequired: false }, api.customers.favorites, catalogCode)
			.then(function(response) {
				favoritesList = utility.filterObject(response.data, {Status: 1});
			});
		}

		function levelChange() {
			if(vm.record.Level === 'Customer' && !activeCustomers.Length) {
				loadCustomers();
			}
		}

		function loadCustomers() {
			api.catalogs.customers.methods.getList({forceFetch: true, isLogRequired: false}, api.catalogs.customers, catalogCode).then(function(response) {
				activeCustomers = utility.filterObject(response.data, {Status: 1});
			})
		}

		function typeChange() {
			angular.forEach(vm.validSizes, function(size) {
				size.Quantity = null;
			})
		}

		function validateTotalPercentage() {
			if (vm.record.AllocationType === 'Percentage') {
				var totalPercentage = 0;
				totalPercentageValue = 0;
				angular.forEach(vm.validSizes, function(size) {
					totalPercentage += parseFloat(size.Quantity) || 0;
				});
				totalPercentageValue = totalPercentage;
				vm.totalPercentageExceedsLimit = totalPercentage !== 100;
			}
		}

		function reset() {
			vm.validSizes = [];
			vm.noValidSizes = false;
			vm.articleNumbers = '';
			vm.favorites = [];
		}

		// atleast one valid size quantity is required
		function isSizeRequired() {
			for(var i=0; i< vm.validSizes.length ;i++) {
				if(angular.isDefined(vm.validSizes[i].Quantity) && vm.validSizes[i].Quantity >= 0) {
					vm.isQuantityAdded = true;
					break;
				}
			}
		}

		function transformAttributeChip(chip) {
			if (angular.isObject(chip)) {
				return chip;
			}
			return undefined;
		}

		function multiValueQuerySearch(query, selectedItems, field) {
			var values = field.values;
			var searchQueryResult = [];
			var searchQueryResult = utility.filterObject(values, query);
			if (selectedItems && selectedItems.length > 0) {
				for (var index = searchQueryResult.length - 1; index >= 0; index--) {
					if (selectedItems.indexOf(searchQueryResult[index]) !== -1) {
						searchQueryResult.splice(index, 1);
					}
				}
			}
			return searchQueryResult;
		}

		function getChipDisplayValue(chip) {
			return chip;
		}

		function lookupAttributeSearch(query) {
			var results = [];
			var predicate = {};
			predicate.AttributeDisplayName = query;
			results = query ? utility.filterObject(availableAttributes, predicate) : availableAttributes;
			return results;
		}

		function lookupAttributeChange(selectedObj, rowIndex) {
			if (angular.isObject(selectedObj)) {
				vm.criterias[rowIndex].Attributeid = selectedObj.Attributeid;
				vm.criterias[rowIndex] = utility.changeAttributeType(selectedObj);
				if(vm.criterias[rowIndex].inputType !== 'bool-str'
					&& vm.criterias[rowIndex].inputType !== 'date-option'
					&& vm.criterias[rowIndex].inputType !== 'date-without-time'
					&& vm.criterias[rowIndex].inputType !== 'date') {
					vm.criterias[rowIndex].value = [];
				}
			}
			else if (angular.isUndefined(selectedObj) || selectedObj === null) {
				vm.selectedAttibute[rowIndex] = {};
				vm.criterias[rowIndex].Attributeid = undefined; // on record removal make field undefined or the property can be deleted using delete keyword
				vm.criterias[rowIndex].value = '';
			}
			if(rowIndex === vm.criterias.length-1) {
				createEmptyCriteriaRow();
			}
		}

		function getAttributeLookupDisplayValue(item) {
			return getAttributeLookupDisplayVal(item);
		}

		function getAttributeLookupDisplayVal(item) {
			var result;
			if (availableAttributes) {
				if (angular.isObject(item)) {
					result = utility.filterObject(availableAttributes, { Attributeid: item.Attributeid }, true);
				}
				else {
					result = utility.filterObject(availableAttributes, { Attributeid: item }, true);
				}

				if (angular.isArray(result) && result.length > 0) {
					return result[0].AttributeDisplayName;
				}
				else {
					return result.AttributeDisplayName;
				}
			}
		}

		function onSizeQuantityChange(rowIndex) {
			if (angular.isDefined(vm.validSizes[rowIndex].Quantity)) {
				$timeout.cancel(quantityChangeTimeoutPromise);
				quantityChangeTimeoutPromise = $timeout(function () {
					// if last row and attribute is selected create empty row
					if (rowIndex === vm.validSizes.length - 1 && angular.isDefined(vm.validSizes[rowIndex].Size) && vm.validSizes[rowIndex].Size !== null
						&& angular.isDefined(vm.validSizes[rowIndex].Quantity) && vm.validSizes[rowIndex].Quantity !== null) {
							createEmptySizesRow();
					}
				}, 100);
			}
		}

		function isSizeAndQuantityRequired(Size, Quantity, rowIndex) {
			if (rowIndex === 0) {
				if (vm.validSizes[rowIndex][Size] && vm.validSizes[rowIndex][Size] !== '') {
					if (vm.validSizes[rowIndex][Quantity] == null || vm.validSizes[rowIndex][Quantity] === 0) {
						return true; //if Quantity is not defined
					}
					else return false;//if Quantity is defined
				}
				else return true;//if Size is not defined
			}
			if (angular.isDefined(vm.validSizes[rowIndex][Size]) && vm.validSizes[rowIndex][Size] != null && vm.validSizes[rowIndex][Size] !== '') {
				if (vm.validSizes[rowIndex][Quantity] == null) {
					return true; //if Quantity is not defined
				}
			}
			return false;
		}

		//On addition of new tag it validates that the tag should not contain pipe
		function add(chip, chips, field) {
			if (chip) {
					if (chip.indexOf(',') !== -1) {
							vm.maxTags = chips.length;
					} else {
							vm.maxTags = field.maxLen;
					}
			}
			//for displaying error message
			if (vm.maxTags != field.maxLen) {
					vm.ErrorMessage = field.validation.messages.pattern;
					return true;
			} else {
					vm.ErrorMessage = "";
					return false;
			}
		}

		function getDateObj(dateString, field, fromUTC) {
			if(dateString) {
				return utility.createDateObject(dateString, field, fromUTC);
			}
		}

		function populateCriteriaEditDialog() {
			if(utility.isValidJSON(record.Criteria)) {
				var criteria = JSON.parse(record.Criteria);

				for(var key in criteria) {
					if(criteria.hasOwnProperty(key)) {
							// if multiple values are assigned show the attibute with multiple values one by one
							var values = criteria[key];
							if(!angular.isArray(criteria[key])) {
								values = [criteria[key]];
							}
							var attribute = utility.filterObject(availableAttributes, {AttributeSystemName: key}, true)[0];
							if(angular.isDefined(attribute)) {
								if(attribute.AttributeTypeName === 'bool-str'
									|| attribute.AttributeTypeName === 'date-option'
									|| attribute.AttributeTypeName === 'date-without-time'
									|| attribute.AttributeTypeName === 'date') {
									angular.forEach(values, function(value) {
										var recordsLength = vm.criterias.push({ Attributeid: attribute.Attributeid});
										if(angular.isUndefined(vm.lookupModel[recordsLength-1])) {
											vm.lookupModel[recordsLength-1] = {};
										}
										vm.lookupModel[recordsLength-1].Attributeid = attribute.Attributeid;
										vm.criterias[recordsLength-1] = utility.changeAttributeType(attribute);
										vm.criterias[recordsLength-1].value = value;
									});
								} else {
									var recordsLength = vm.criterias.push({ Attributeid: attribute.Attributeid});
									if(angular.isUndefined(vm.lookupModel[recordsLength-1])) {
										vm.lookupModel[recordsLength-1] = {};
									}
									vm.lookupModel[recordsLength-1].Attributeid = attribute.Attributeid;
									vm.criterias[recordsLength-1] = utility.changeAttributeType(attribute);
									vm.criterias[recordsLength-1].value = values;
								}
							}
					}
				}
			}
			if(vm.record.Sizes.length) {
				angular.forEach(vm.record.Sizes, function(size) {
					vm.validSizes.push({ Size: size.Size, Quantity: size.Quantity});
				});
				vm.isQuantityAdded = true;
			}
			createEmptyCriteriaRow();
			createEmptySizesRow();
		}

		function createEmptyCriteriaRow() {
			vm.searchText.push({});
			vm.lookupModel.push({});
			vm.criterias.push({ Attributeid: null});
		}

		function createEmptySizesRow() {
			if(totalPercentageValue < 100) {
				vm.validSizes.push({ Size: ''});
			}
		}

		$scope.$on('$destroy', function () {
			$timeout.cancel(quantityChangeTimeoutPromise);
		});

	}
})();
(function() {
		'use strict';

		angular
				.module('app.main.catalogs.shared-folders-tree', [
					'app.main.catalogs.shared-folders-tree.shared-folder-users'
				])
				.config(config);

		/* @ngInject */
		function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {

				$stateProvider.state('app.shared_folders_tree', {
						url    : '/shared-folders-tree',
						views  : {
								'content@app': {
										templateUrl: 'app/main/catalogs/sub-modules/shared-folders-tree/tree/shared-folders-tree.html',
										controller : 'sharedFoldersTreeController as vm'
								}
						},
						resolve: {},
						data: {
								displayName: 'SHARED_FOLDERS.NAV'
						},
						// accessPrivileges: ['GetSharingFolderList']
						// accessPrivileges: ['nav_shared_folders']
						accessInfo: {
							accessPrivileges: ['nav_shared_folders']
						}
				});

				$stateProvider.state('app.shared_folders_tree.details', {
					url	 : '/:id',
					views: {
						'content@app': {
							templateUrl: 'app/main/catalogs/sub-modules/shared-folders-tree/details/shared-folders-tree-details.html',
							controller : 'sharedFoldersTreeDetailsController as vm'
						}
					},
					data: {
						parentState: 'app.shared_folders_tree',
						displayName: 'SHARED_FOLDERS.TABS.SHARED_FOLDER'
					},
					//only users with following accessPrivileges in their role access list can access this route
					// accessPrivileges: ['GetSharingFolderDetails']
					accessInfo: {
						accessPrivileges: ['GetSharingFolderDetails']
					}
				});

				// Translation
				$translatePartialLoaderProvider.addPart('app/main/catalogs/sub-modules/shared-folders-tree');

				// Navigation
				msNavigationServiceProvider.saveItem('catalogs.shared_folders.shared_folders_tree', {
						title      : 'Tree View',
						subTitle   : 'Shared Folders',
						icon       : 'icon-folder-move',
						state      : 'app.shared_folders_tree',
						translation: 'SHARED_FOLDERS.NAV',
						weight     : 41,
						// accessPrivileges: ['GetSharingFolderList']
						// accessPrivileges: ['nav_shared_folders'],
						accessInfo: {
							accessPrivileges: ['nav_shared_folders']
						}
				});
		}

})();
(function () {
	'use strict';

	angular
		.module('app.main.catalogs.shared-folders-tree')
		.controller('sharedFoldersTreeController', sharedFoldersTreeController);

	/* @ngInject */
	function sharedFoldersTreeController(api, $rootScope, $scope, $state, catalogFactory, settingsFactory, $document, dataImporter, utility, crud, $mdDialog) {
		/* jshint validthis: true */
		var vm = this;

		//Data
		var activeCatalog = catalogFactory.getActiveCatalog();
		var catalogCode = activeCatalog.CatalogCode;

		vm.model = api.catalogs.sharedFoldersTree;
		settingsFactory.applyPersistedListViewLayout(vm.model);

		vm.sharedFoldersTree = [];
		vm.filteredSharedFolders = [];
		vm.sharedFolders = [];
		vm.isLoading = false;

		//Methods
		vm.refreshItems = refreshItems;
		vm.doListAction = doListAction;
		vm.doItemAction = doItemAction;
		vm.addRecord = addRecord;
		vm.onTreeNodeClick = onTreeNodeClick;

		activate();

		////////////////

		function activate() {
			//Set the branch types
			vm.branchTypes = {
				folder      : {
						icon    : api.catalogs.sharedFoldersTree.icon,
						title   : api.catalogs.sharedFoldersTree.title,
						actions : api.catalogs.sharedFoldersTree.views.mainList.itemActions,
						model   : vm.model
				}
			};
			vm.filter = "";
			refreshItems(true, true);
		}

		function refreshItems(forceFetch, isLogRequired) {
			vm.isLoading = true;
			var generalProperties = {
				forceFetch: forceFetch,
				isLogRequired: isLogRequired
			}
			vm.model.methods.getList(generalProperties, vm.model, catalogCode)
			.then(function (response) {
				vm.sharedFolders = angular.copy(response.data);
				var parentSharedFoldersCopy = utility.filterObject(response.data, {ParentFolderId: null}, true);
				// transform folders to desired structure for ui.tree
				vm.sharedFoldersTree = catalogFactory.transformSharedFolders(parentSharedFoldersCopy, response.data);
			})
			.finally(function () {
				vm.isLoading = false;
			});
		}

		//Item Action button pressed event
		function doItemAction(action, record) {
			if (action && record) {
				switch (action.id) {
					case 'activate':
					case 'delete':
							vm.model.methods.activateBulk(record, vm.model, action.id, catalogCode)
							.then(function() {
								refreshItems(true);
							});
							break;
					case 'edit':
							editRecord(record, null);
							break;
					case 'view':
							onTreeNodeClick(record);
							break;
					case 'addSubFolder':
						addSubFolder(record, null);
						break;
				}
			}
		}

		//List Action button pressed event
		function doListAction(action, records) {
			if (action) {
				switch (action.id) {
					case 'activate':
					case 'delete':
							vm.model.methods.activateBulk(records, vm.model, action.id, catalogCode).then(function() {
								refreshItems(true);
							});
							break;
					case 'import':
						var importSharedFolderUsers = api.catalogs.importSharedFolderUsers;
						dataImporter.importExcel(importSharedFolderUsers, true).then(function(result) {
							vm.model.methods.createBulk(vm.model, result.data, catalogCode).then(function() {
									refreshItems(true, false);
							});
						});
						break;
				}
			}
		}

		function addRecord(ev) {
			var existingRecordsForUniqueValue = utility.filterObject(vm.sharedFolders, {ParentFolderId: null}, true);
			var modelCopy = angular.copy(vm.model);
			var lookupPromises = {};
			lookupPromises = crud.createLookupPromise(modelCopy, undefined, 'create');
			$mdDialog.show({
				controller: 'addOrUpdateSharedFolderController',
				controllerAs: 'vm',
				templateUrl: 'app/main/catalogs/sub-modules/shared-folders/dialogs/add-update-shared-folder/add-update-shared-folder.html',
				parent: angular.element($document.body),
				targetEvent: ev,
				clickOutsideToClose: false,
				locals: {
					record: null,
					isNew: true,
					model: vm.model,
					existingRecordsForUniqueValue: existingRecordsForUniqueValue,
					lookupPromises: lookupPromises,
					catalogCode: catalogCode,
					isToggleSharing: false,
					fromUsers: false,
					event: ev
				}
			}).then(function(saved) {
				if (saved) {
					refreshItems(true, false);
				}
			});
		}

		function editRecord(record, ev) {
			var existingRecordsForUniqueValue = [];
			if(record.ParentFolderId === null) { // parent folder
				existingRecordsForUniqueValue = utility.filterObject(vm.sharedFolders, {ParentFolderId: null}, true);
			} else { // sub folder
				existingRecordsForUniqueValue = utility.filterObject(vm.sharedFolders, {ParentFolderId: record.ParentFolderId}, true);
			}
			for (var i = 0; i < existingRecordsForUniqueValue.length; i++) {
				if(existingRecordsForUniqueValue[i].Id === record.Id) {
					existingRecordsForUniqueValue.splice(i, 1);
				}
			}
			vm.model.methods.getDetails(true, record.Id, catalogCode)
			.then(function (response) {
				var sharedFolder = response.data;
				var sharedFolderUsers = response.data.Users;
				var activeUsers = utility.filterObject(sharedFolderUsers, {'Status': 1}, true);
				// as there are 100's of assigned users we will remove it from the Users and assign it to AssignedRecords
				// we will remove the assigned users using this field and when saving will combine with selected ones
				sharedFolder.AssignedRecords = activeUsers.map(function(user) {
					var userId = user['UserId'];
					var allowSharing = user['AllowSharing'];
					return { UserId: userId, AllowSharing: allowSharing };
				});
				sharedFolder.Users = [];
				var modelCopy = angular.copy(vm.model);
				var lookupPromises = {};
				lookupPromises = crud.createLookupPromise(modelCopy, undefined, 'create');
				$mdDialog.show({
					controller: 'addOrUpdateSharedFolderController',
					controllerAs: 'vm',
					templateUrl: 'app/main/catalogs/sub-modules/shared-folders/dialogs/add-update-shared-folder/add-update-shared-folder.html',
					parent: angular.element($document.body),
					targetEvent: ev,
					clickOutsideToClose: false,
					locals: {
						record: sharedFolder,
						isNew: false,
						model: vm.model,
						existingRecordsForUniqueValue: existingRecordsForUniqueValue,
						lookupPromises: lookupPromises,
						catalogCode: catalogCode,
						isToggleSharing: false,
						fromUsers: false,
						event: ev
					}
				}).then(function(saved) {
					if (saved) {
						refreshItems(true, false);
					}
				});
			});
		}

		function onTreeNodeClick(record) {
			if(record.Status === 1) {
				var stateParams = { id: record[vm.model.idField]};
				$state.go('app.shared_folders_tree.details', stateParams);
			}
		}

		// users can be assigned only on parent folder
		function addSubFolder(record, ev) {
			var sharedFolder = { ParentFolderId: record.Id };
			var modelCopy = angular.copy(vm.model);
			var usersField = utility.filterObject(modelCopy.fields, {field: 'Users'}, true)[0];
			usersField.creatable = false;
			var existingRecordsForUniqueValue = utility.filterObject(vm.sharedFolders, {ParentFolderId: record.Id}, true);
			api.showCreateRecordDialog(angular.element($document.body), ev, modelCopy, catalogCode, sharedFolder, undefined, {isDefaultSelectedFieldValueAdded: { Entity: 1 }}, undefined, existingRecordsForUniqueValue)
			.then(function(saved) {
				if (saved) {
					refreshItems(true, false);
				}
			});
		}

		var catalogChangedEventCleanup = $rootScope.$on('ActiveCatalogChangedEvent', function (e) {
			if (catalogCode !== catalogFactory.getActiveCatalog().CatalogCode) {
				$state.reload('app.shared_folders_tree');
			}
		});

		$scope.$on('$destroy', function () {
			catalogChangedEventCleanup();
		});

	}
})();
(function () {
	'use strict';

	angular
		.module('app.main.catalogs.shared-folders-tree')
		.controller('sharedFoldersTreeDetailsController', sharedFoldersTreeDetailsController);

	/* @ngInject */
	function sharedFoldersTreeDetailsController(api, $state, $stateParams, $rootScope, catalogFactory, settingsFactory, $document, utility, crud, $mdDialog) {
		/* jshint validthis: true */
		var vm = this;

		// Data
		var sharedFolderId = $stateParams.id;
		vm.activeCatalog = catalogFactory.getActiveCatalog();
		var catalogCode = vm.activeCatalog.CatalogCode;

		vm.model = api.catalogs.sharedFolders;

		vm.sharedFolderUsersModel = api.catalogs.sharedFolderTreeUsers;
		settingsFactory.applyPersistedListViewLayout(vm.sharedFolderUsersModel);

		vm.sharedFolder = {};
		vm.sharedFolderUsers = [];
		vm.filteredSharedFolderUsers = [];

		vm.isLoading = false;

		// Methods
		vm.refreshRecord = refreshRecord;
		vm.assignUsers = assignUsers;

		vm.doUsersItemAction = doUsersItemAction;
		vm.doUsersListAction = doUsersListAction;
		vm.editItem = editItem;

		activate();

		////////////////

		function activate() {
			refreshRecord(true);
		}

		function refreshRecord(isLogRequired) {
			vm.isLoading = true;
			vm.model.methods.getDetails(isLogRequired, sharedFolderId, catalogCode)
			.then(function (response) {
				vm.sharedFolder = response.data;
				// users list
				vm.sharedFolderUsers = response.data.Users;
				vm.title = vm.sharedFolder[vm.model.lookupDisplayField];

				//Update Breadcrumb
				$state.current.data.displayName = vm.title;
				$rootScope.$broadcast('breadcrumb-updated');
			})
			.finally(function () {
				vm.isLoading = false;
			});
		}

		function assignUsers(ev) {
			var sharedFolder = vm.sharedFolder;
			var activeUsers= utility.filterObject(sharedFolder.Users, {'Status': 1}, true);
			sharedFolder.AssignedRecords = activeUsers.map(function(user) {
				var userId = user['UserId'];
				var allowSharing = user['AllowSharing'];
				return { UserId: userId, AllowSharing: allowSharing };
			});
			sharedFolder.Users = [];
			var modelCopy = angular.copy(vm.model);
			var lookupPromises = {};
			lookupPromises = crud.createLookupPromise(modelCopy, undefined, 'create');
			$mdDialog.show({
				controller: 'addOrUpdateSharedFolderController',
				controllerAs: 'vm',
				templateUrl: 'app/main/catalogs/sub-modules/shared-folders/dialogs/add-update-shared-folder/add-update-shared-folder.html',
				parent: angular.element($document.body),
				targetEvent: ev,
				clickOutsideToClose: false,
				locals: {
					record: sharedFolder,
					isNew: false,
					model: vm.model,
					existingRecordsForUniqueValue: [],
					lookupPromises: lookupPromises,
					catalogCode: catalogCode,
					isToggleSharing: false,
					fromUsers: true,
					event: ev
				}
			}).then(function(saved) {
				if (saved) {
					refreshRecord(true);
				}
			});
		}

		function doUsersItemAction(action, record) {
			if (action) {
				switch (action.id) {
					case 'delete':
					case 'activate':
						vm.sharedFolderUsersModel.methods.activateBulk(record, vm.sharedFolderUsersModel, action.id, catalogCode, vm.sharedFolder.Id);
						break;
					case 'toggleSharing':
						toggleSharing(null, [record]);
						break;
				}
			}
		}

		function doUsersListAction(action, records) {
			if (action) {
				switch (action.id) {
					case 'delete':
					case 'activate':
						vm.sharedFolderUsersModel.methods.activateBulk(records, vm.sharedFolderUsersModel, action.id, catalogCode, vm.sharedFolder.Id);
						break;
					case 'toggleSharingBulk':
						toggleSharing(null, records);
						break;
				}
			}
		}

		function editItem(record, ev) {
			var sharedFolder = record;
			var activeUsers = utility.filterObject(sharedFolder.Users, {'Status': 1}, true);
			// as there are 100's of assigned users we will remove it from the Users and assign it to AssignedRecords
			// we will remove the assigned users using this field and when saving will combine with selected ones
			sharedFolder.AssignedRecords = activeUsers.map(function(user) {
				var userId = user['UserId'];
				var allowSharing = user['AllowSharing'];
				return { UserId: userId, AllowSharing: allowSharing };
			});
			sharedFolder.Users = [];
			var modelCopy = angular.copy(vm.model);
			var lookupPromises = {};
			lookupPromises = crud.createLookupPromise(modelCopy, undefined, 'create');
			$mdDialog.show({
				controller: 'addOrUpdateSharedFolderController',
				controllerAs: 'vm',
				templateUrl: 'app/main/catalogs/sub-modules/shared-folders/dialogs/add-update-shared-folder/add-update-shared-folder.html',
				parent: angular.element($document.body),
				targetEvent: ev,
				clickOutsideToClose: false,
				locals: {
					record: sharedFolder,
					isNew: false,
					model: vm.model,
					existingRecordsForUniqueValue: [],
					lookupPromises: lookupPromises,
					catalogCode: catalogCode,
					isToggleSharing: false,
					fromUsers: false,
					event: ev
				}
			}).then(function(saved) {
				if (saved) {
					refreshRecord(true);
				}
			});
		}

		function toggleSharing(ev, records) {
			var modelCopy = angular.copy(vm.sharedFolderUsersModel);
			var lookupPromises = {};
			lookupPromises = crud.createLookupPromise(vm.model, undefined, 'create');
			var folderRecord = vm.sharedFolder;
			var activeUsers = utility.filterObject(vm.sharedFolderUsers, {'Status': 1}, true);
			folderRecord.Users = activeUsers.map(function(user) {
				var userId = user['UserId'];
				var allowSharing = user['AllowSharing'];
				return { UserId: userId, AllowSharing: allowSharing, hidden: true };
			});
			// filter the selected users
			angular.forEach(records, function(user) {
				var user = utility.filterObject(folderRecord.Users, {UserId: user.UserId}, true)[0];
				if(user) {
					user.hidden = false;
					user.disable = true;
				}
			})

			$mdDialog.show({
				controller: 'addOrUpdateSharedFolderController',
				controllerAs: 'vm',
				templateUrl: 'app/main/catalogs/sub-modules/shared-folders/dialogs/add-update-shared-folder/add-update-shared-folder.html',
				parent: angular.element($document.body),
				targetEvent: null,
				clickOutsideToClose: false,
				locals: {
					record: folderRecord,
					isNew: false,
					model: modelCopy,
					existingRecordsForUniqueValue: [],
					lookupPromises: lookupPromises,
					catalogCode: catalogCode,
					isToggleSharing: true,
					fromUsers: false,
					event: null
				}
			}).then(function(saved) {
				if (saved) {
					refreshRecord(true);
				}
			});
		}

	}
})();
(function () {
	'use strict';

	angular
		.module('app.main.catalogs.shared-folders')
		.controller('sharedFoldersListController', sharedFoldersListController);

	/* @ngInject */
	function sharedFoldersListController(api, $rootScope, $scope, $state, catalogFactory, settingsFactory, $document, dataImporter, utility, crud, $mdDialog) {
		/* jshint validthis: true */
		var vm = this;

		//Data
		var activeCatalog = catalogFactory.getActiveCatalog();
		var catalogCode = activeCatalog.CatalogCode;

		vm.model = api.catalogs.sharedFolders;
		settingsFactory.applyPersistedListViewLayout(vm.model);

		vm.sharedFolders = [];
		vm.filteredSharedFolders = [];
		vm.isLoading = false;


		//Methods
		vm.refreshItems = refreshItems;
		vm.doListAction = doListAction;
		vm.doItemAction = doItemAction;
		vm.addRecord = addRecord;
		vm.viewItem = viewItem;

		activate();

		////////////////

		function activate() {
			refreshItems(true, true);
		}

		function refreshItems(forceFetch, isLogRequired) {
			vm.isLoading = true;
			var generalProperties = {
				forceFetch: forceFetch,
				isLogRequired: isLogRequired
			}
			vm.model.methods.getList(generalProperties, vm.model, catalogCode)
			.then(function (response) {
				vm.sharedFolders = response.data;
			})
			.finally(function () {
				vm.isLoading = false;
			});
		}

		//Item Action button pressed event
		function doItemAction(action, record) {
			if (action && record) {
				switch (action.id) {
					case 'activate':
					case 'delete':
							vm.model.methods.activateBulk(record, vm.model, action.id, catalogCode)
							.then(function() {
								refreshItems(true);
							});
							break;
					case 'edit':
							editRecord(record, null);
							break;
					case 'view':
							viewItem(record);
							break;
					case 'addSubFolder':
						addSubFolder(record, null);
						break;
				}
			}
		}

		//List Action button pressed event
		function doListAction(action, records) {
			if (action) {
				switch (action.id) {
					case 'activate':
					case 'delete':
							vm.model.methods.activateBulk(records, vm.model, action.id, catalogCode).then(function() {
								refreshItems(true);
							});
							break;
					case 'import':
						var importSharedFolderUsers = api.catalogs.importSharedFolderUsers;
						dataImporter.importExcel(importSharedFolderUsers, true).then(function(result) {
							vm.model.methods.createBulk(vm.model, result.data, catalogCode).then(function() {
									refreshItems(true, false);
							});
						});
						break;
				}
			}
		}

		function addRecord(ev) {
			var existingRecordsForUniqueValue = utility.filterObject(vm.sharedFolders, {ParentFolderId: null}, true);
			var modelCopy = angular.copy(vm.model);
			var lookupPromises = {};
			lookupPromises = crud.createLookupPromise(modelCopy, undefined, 'create');
			$mdDialog.show({
				controller: 'addOrUpdateSharedFolderController',
				controllerAs: 'vm',
				templateUrl: 'app/main/catalogs/sub-modules/shared-folders/dialogs/add-update-shared-folder/add-update-shared-folder.html',
				parent: angular.element($document.body),
				targetEvent: ev,
				clickOutsideToClose: false,
				locals: {
					record: null,
					isNew: true,
					model: vm.model,
					existingRecordsForUniqueValue: existingRecordsForUniqueValue,
					lookupPromises: lookupPromises,
					catalogCode: catalogCode,
					isToggleSharing: false,
					fromUsers: false,
					event: ev
				}
			}).then(function(saved) {
				if (saved) {
					refreshItems(true, false);
				}
			});
		}

		function editRecord(record, ev) {
			var existingRecordsForUniqueValue = [];
			if(record.ParentFolderId === null) { // parent folder
				existingRecordsForUniqueValue = utility.filterObject(vm.sharedFolders, {ParentFolderId: null}, true);
			} else { // sub folder
				existingRecordsForUniqueValue = utility.filterObject(vm.sharedFolders, {ParentFolderId: record.ParentFolderId}, true);
			}
			for (var i = 0; i < existingRecordsForUniqueValue.length; i++) {
				if(existingRecordsForUniqueValue[i].Id === record.Id) {
					existingRecordsForUniqueValue.splice(i, 1);
				}
			}
			vm.model.methods.getDetails(true, record.Id, catalogCode)
			.then(function (response) {
				var sharedFolder = response.data;
				var sharedFolderUsers = response.data.Users;
				var activeUsers = utility.filterObject(sharedFolderUsers, {'Status': 1}, true);
				// as there are 100's of assigned users we will remove it from the Users and assign it to AssignedRecords
				// we will remove the assigned users using this field and when saving will combine with selected ones
				sharedFolder.AssignedRecords = activeUsers.map(function(user) {
					var userId = user['UserId'];
					var allowSharing = user['AllowSharing'];
					return { UserId: userId, AllowSharing: allowSharing };
				});
				sharedFolder.Users = [];
				var modelCopy = angular.copy(vm.model);
				var lookupPromises = {};
				lookupPromises = crud.createLookupPromise(modelCopy, undefined, 'create');
				$mdDialog.show({
					controller: 'addOrUpdateSharedFolderController',
					controllerAs: 'vm',
					templateUrl: 'app/main/catalogs/sub-modules/shared-folders/dialogs/add-update-shared-folder/add-update-shared-folder.html',
					parent: angular.element($document.body),
					targetEvent: ev,
					clickOutsideToClose: false,
					locals: {
						record: sharedFolder,
						isNew: false,
						model: vm.model,
						existingRecordsForUniqueValue: existingRecordsForUniqueValue,
						lookupPromises: lookupPromises,
						catalogCode: catalogCode,
						isToggleSharing: false,
						fromUsers: false,
						event: ev
					}
				}).then(function(saved) {
					if (saved) {
						refreshItems(true, false);
					}
				});
			});
		}

		function viewItem(record) {
			if(record.Status === 1) {
				var stateParams = { id: record[vm.model.idField]};
				$state.go('app.shared_folders.details', stateParams);
			}
		}

		// users can be assigned only on parent folder
		function addSubFolder(record, ev) {
			var sharedFolder = { ParentFolderId: record.Id };
			var modelCopy = angular.copy(vm.model);
			var usersField = utility.filterObject(modelCopy.fields, {field: 'Users'}, true)[0];
			usersField.creatable = false;
			var existingRecordsForUniqueValue = utility.filterObject(vm.sharedFolders, {ParentFolderId: record.Id}, true);
			api.showCreateRecordDialog(angular.element($document.body), ev, modelCopy, catalogCode, sharedFolder, undefined, {isDefaultSelectedFieldValueAdded: { Entity: 1 }}, undefined, existingRecordsForUniqueValue)
			.then(function(saved) {
				if (saved) {
					refreshItems(true, false);
				}
			});
		}

		var catalogChangedEventCleanup = $rootScope.$on('ActiveCatalogChangedEvent', function (e) {
			if (catalogCode !== catalogFactory.getActiveCatalog().CatalogCode) {
				$state.reload('app.shared_folders');
			}
		});

		$scope.$on('$destroy', function () {
			catalogChangedEventCleanup();
		});

	}
})();
(function () {
	'use strict';

	angular
		.module('app.main.catalogs.shared-folders')
		.controller('sharedFoldersDetailsController', sharedFoldersDetailsController);

	/* @ngInject */
	function sharedFoldersDetailsController(api, $state, $stateParams, $rootScope, catalogFactory, settingsFactory, $document, utility, crud, $mdDialog) {
		/* jshint validthis: true */
		var vm = this;

		// Data
		var sharedFolderId = $stateParams.id;
		vm.activeCatalog = catalogFactory.getActiveCatalog();
		var catalogCode = vm.activeCatalog.CatalogCode;

		vm.model = api.catalogs.sharedFolders;

		vm.sharedFolderUsersModel = api.catalogs.sharedFolderUsers;
		settingsFactory.applyPersistedListViewLayout(vm.sharedFolderUsersModel);

		vm.sharedFolder = {};
		vm.sharedFolderUsers = [];
		vm.filteredSharedFolderUsers = [];

		vm.isLoading = false;

		// Methods
		vm.refreshRecord = refreshRecord;
		vm.assignUsers = assignUsers;

		vm.doUsersItemAction = doUsersItemAction;
		vm.doUsersListAction = doUsersListAction;
		vm.editItem = editItem;

		activate();

		////////////////

		function activate() {
			refreshRecord(true);
		}

		function refreshRecord(isLogRequired) {
			vm.isLoading = true;
			vm.model.methods.getDetails(isLogRequired, sharedFolderId, catalogCode)
			.then(function (response) {
				vm.sharedFolder = response.data;
				// users list
				vm.sharedFolderUsers = response.data.Users;
				vm.title = vm.sharedFolder[vm.model.lookupDisplayField];

				//Update Breadcrumb
				$state.current.data.displayName = vm.title;
				$rootScope.$broadcast('breadcrumb-updated');
			})
			.finally(function () {
				vm.isLoading = false;
			});
		}

		function assignUsers(ev) {
			var sharedFolder = vm.sharedFolder;
			var activeUsers= utility.filterObject(sharedFolder.Users, {'Status': 1}, true);
			sharedFolder.AssignedRecords = activeUsers.map(function(user) {
				var userId = user['UserId'];
				var allowSharing = user['AllowSharing'];
				return { UserId: userId, AllowSharing: allowSharing };
			});
			sharedFolder.Users = [];
			var modelCopy = angular.copy(vm.model);
			var lookupPromises = {};
			lookupPromises = crud.createLookupPromise(modelCopy, undefined, 'create');
			$mdDialog.show({
				controller: 'addOrUpdateSharedFolderController',
				controllerAs: 'vm',
				templateUrl: 'app/main/catalogs/sub-modules/shared-folders/dialogs/add-update-shared-folder/add-update-shared-folder.html',
				parent: angular.element($document.body),
				targetEvent: ev,
				clickOutsideToClose: false,
				locals: {
					record: sharedFolder,
					isNew: false,
					model: vm.model,
					existingRecordsForUniqueValue: [],
					lookupPromises: lookupPromises,
					catalogCode: catalogCode,
					isToggleSharing: false,
					fromUsers: true,
					event: ev
				}
			}).then(function(saved) {
				if (saved) {
					refreshRecord(true);
				}
			});
		}

		function doUsersItemAction(action, record) {
			if (action) {
				switch (action.id) {
					case 'delete':
					case 'activate':
						vm.sharedFolderUsersModel.methods.activateBulk(record, vm.sharedFolderUsersModel, action.id, catalogCode, vm.sharedFolder.Id);
						break;
					case 'toggleSharing':
						toggleSharing(null, [record]);
						break;
				}
			}
		}

		function doUsersListAction(action, records) {
			if (action) {
				switch (action.id) {
					case 'delete':
					case 'activate':
						vm.sharedFolderUsersModel.methods.activateBulk(records, vm.sharedFolderUsersModel, action.id, catalogCode, vm.sharedFolder.Id);
						break;
					case 'toggleSharingBulk':
						toggleSharing(null, records);
						break;
				}
			}
		}

		function editItem(record, ev) {
			var sharedFolder = record;
			var activeUsers= utility.filterObject(sharedFolder.Users, {'Status': 1}, true);
			sharedFolder.AssignedRecords = activeUsers.map(function(user) {
				var userId = user['UserId'];
				var allowSharing = user['AllowSharing'];
				return { UserId: userId, AllowSharing: allowSharing };
			});
			sharedFolder.Users = [];
			var modelCopy = angular.copy(vm.model);
			var lookupPromises = {};
			lookupPromises = crud.createLookupPromise(modelCopy, undefined, 'create');
			$mdDialog.show({
				controller: 'addOrUpdateSharedFolderController',
				controllerAs: 'vm',
				templateUrl: 'app/main/catalogs/sub-modules/shared-folders/dialogs/add-update-shared-folder/add-update-shared-folder.html',
				parent: angular.element($document.body),
				targetEvent: ev,
				clickOutsideToClose: false,
				locals: {
					record: sharedFolder,
					isNew: false,
					model: vm.model,
					existingRecordsForUniqueValue: [],
					lookupPromises: lookupPromises,
					catalogCode: catalogCode,
					isToggleSharing: false,
					fromUsers: false,
					event: ev
				}
			}).then(function(saved) {
				if (saved) {
					refreshRecord(true);
				}
			});
		}

		function toggleSharing(ev, records) {
			var modelCopy = angular.copy(vm.sharedFolderUsersModel);
			var lookupPromises = {};
			lookupPromises = crud.createLookupPromise(vm.model, undefined, 'create');
			var folderRecord = vm.sharedFolder;
			var activeUsers = utility.filterObject(vm.sharedFolderUsers, {'Status': 1}, true);
			folderRecord.Users = activeUsers.map(function(user) {
				var userId = user['UserId'];
				var allowSharing = user['AllowSharing'];
				return { UserId: userId, AllowSharing: allowSharing, hidden: true };
			});
			// filter the selected users
			angular.forEach(records, function(user) {
				var user = utility.filterObject(folderRecord.Users, {UserId: user.UserId}, true)[0];
				if(user) {
					user.hidden = false;
					user.disable = true;
				}
			})

			$mdDialog.show({
				controller: 'addOrUpdateSharedFolderController',
				controllerAs: 'vm',
				templateUrl: 'app/main/catalogs/sub-modules/shared-folders/dialogs/add-update-shared-folder/add-update-shared-folder.html',
				parent: angular.element($document.body),
				targetEvent: null,
				clickOutsideToClose: false,
				locals: {
					record: folderRecord,
					isNew: false,
					model: modelCopy,
					existingRecordsForUniqueValue: [],
					lookupPromises: lookupPromises,
					catalogCode: catalogCode,
					isToggleSharing: true,
					fromUsers: false,
					event: null
				}
			}).then(function(saved) {
				if (saved) {
					refreshRecord(true);
				}
			});
		}

	}
})();
(function () {
	'use strict';

	angular
		.module('app.main.catalog-articles.segmentation-linear')
		.controller('segmentationLinearListController', segmentationLinearListController);

	/* @ngInject */
	function segmentationLinearListController(api, utility, $rootScope, $scope, $state, catalogFactory,
		dataImporter, bulkUpdater, $timeout, settingsFactory, $mdDialog, $document, crud, dialog, $filter) {
		/* jshint validthis: true */
		var vm = this;

		//Data
		var activeCatalog = catalogFactory.getActiveCatalog();
		var activeCatalogId = activeCatalog.CatalogCode;
		vm.activeCatalogId = activeCatalogId;

		vm.model = api.catalogArticles.segmentationLinear;
		var planningValueField = utility.filterObject(vm.model.fields, {field: 'PlanningValue'}, true)[0];
		if(planningValueField && activeCatalog.SegmentationPlanningEnable === 1) {
			planningValueField.visible = true;
		}
		settingsFactory.applyPersistedListViewLayout(vm.model);
		var activieCatalogSegmentationList = catalogFactory.getActiveCatalogDetails().CatalogSegmentationList;
		var isRoleBasedRestrictedSegmentationsAdded = (angular.isDefined(api.roleBasedRestrictions) && angular.isDefined(api.roleBasedRestrictions.restrictedSegmentationsArray) && api.roleBasedRestrictions.restrictedSegmentationsArray.length > 0) ? true : false;

		vm.segmentations = [];
		vm.filteredSegmentations = [];
		vm.isLoading = false;
		var timeoutPromise;

		//Methods
		vm.refreshItems = refreshItems;
		vm.doItemAction = doItemAction;
		vm.doListAction = doListAction;
		vm.viewItem = viewItem;
		vm.assignArticleSegmentations = assignArticleSegmentations;

		activate();

		////////////////
		function activate() {
			refreshItems(vm.model.isDirty, true);
		}

		function refreshItems(forceFetch, isLogRequired) {
			vm.isLoading = true;
			var generalProperties = {
				forceFetch: forceFetch,
				isLogRequired: isLogRequired,
				config: {},
				supportIncrementalResult: true,
				modelIdField: 'ArticleNumber',
				isMajor: false
		}
			timeoutPromise = $timeout(function () {
				vm.model.methods.getList(generalProperties, vm.model, activeCatalogId)
					.then(function (response) {
						var responseData = [];
						angular.forEach(response.data, function (article) {
							if (angular.isDefined(article.Segmentations) && article.Segmentations.length > 0 && (activeCatalog.DataSourceTypeId !== 3 || article.Status === 1)) {
								angular.forEach(article.Segmentations, function (segmentation) {
									// render the planning value returned by the API verbatim
									var planningValue = segmentation.PlanningValue;
									var index = activieCatalogSegmentationList.indexOf(utility.filterObject(activieCatalogSegmentationList, { Id: segmentation.Id, Status: 1 }, true)[0]);
									if (index !== -1) {
										if(!isRoleBasedRestrictedSegmentationsAdded) {
											responseData.push({
												ArticleId: article.Id,
												ArticleNumber: article.ArticleNumber,
												ArticleName: article.ArticleName,
												LastUpdatedOn: article.LastUpdatedOn,
												ModelNumber: article.ModelNumber,
												PlanningValue: planningValue,
												SegmentationId: segmentation.Id,
												SegmentationStatus: 1,
												IsOutOfParentSegmentation: segmentation.IsOutOfParentSegmentation,
												Status: article.Status,
											});
										} else {
											// check if any restricted segmentations
											var restrictedSegmentation = utility.filterObject(api.roleBasedRestrictions.restrictedSegmentationsArray, { Id: segmentation.Id}, true)[0];
											if(angular.isDefined(restrictedSegmentation) && !restrictedSegmentation.notViewable && restrictedSegmentation.notEditable) {
												responseData.push({
													ArticleId: article.Id,
													ArticleNumber: article.ArticleNumber,
													ArticleName: article.ArticleName,
													LastUpdatedOn: article.LastUpdatedOn,
													ModelNumber: article.ModelNumber,
													PlanningValue: planningValue,
													SegmentationId: segmentation.Id,
													SegmentationStatus: 1,
													IsOutOfParentSegmentation: segmentation.IsOutOfParentSegmentation,
													Status: article.Status,
												});
											} else if(angular.isUndefined(restrictedSegmentation)) {
												responseData.push({
													ArticleId: article.Id,
													ArticleNumber: article.ArticleNumber,
													ArticleName: article.ArticleName,
													LastUpdatedOn: article.LastUpdatedOn,
													ModelNumber: article.ModelNumber,
													PlanningValue: planningValue,
													SegmentationId: segmentation.Id,
													SegmentationStatus: 1,
													IsOutOfParentSegmentation: segmentation.IsOutOfParentSegmentation,
													Status: article.Status,
												});
											}
										}
									}
								});
							}
						});
						vm.segmentations = responseData;
						var containInvalid = false;
						angular.forEach(vm.segmentations, function(segmentation) {
								if(segmentation['IsOutOfParentSegmentation'] === 1) {
									segmentation['warn'] = true;
									containInvalid = true;
								}
						});
						if(activeCatalog.DataSourceTypeId === 3 && containInvalid) {
							dialog.showAlertDialog(
									angular.element($document.body),
									$filter('translate')('MESSAGES.TITLE.ALERT'),
									$filter('translate')('SEGMENTATION.MESSAGES.ARTICLE_WITH_INVALID_SEGMENTATION'),
									$filter('translate')('MESSAGES.TITLE.ALERT'),
									$filter('translate')('ACTIONS.DIALOG_CLOSE'),
									true,
									null
							);
						}

					})
					.finally(function () {
						vm.isLoading = false;
					});
			}, 500);
		}

		//Item Action button pressed event
		function doItemAction(action, record) {
			if (action && record) {
				switch (action.id) {
					case 'view':
						viewItem(record);
						break;
					case 'delete':
						vm.model.methods.activateBulk(record, action.id, activeCatalogId, record.ArticleId).then(function() {
							refreshItems(true, false);
						})
						break;
				}
			}
		}

		function doListAction(action) {
			if (action) {
				switch (action.id) {
					case 'import':
						var modelCopy = angular.copy(vm.model);
						var modelNumberField = utility.filterObject(modelCopy.fields, { field: 'ModelNumber' }, true)[0];
						modelNumberField.creatable = false;
						if (activeCatalog.SegmentationPlanningEnable === 1) {
							var segmentationStatusField = utility.filterObject(modelCopy.fields, { field: 'SegmentationStatus' }, true)[0];
							if (segmentationStatusField) {
								segmentationStatusField.displayLabel = 'SEGMENTATION_LINEAR.FIELDS.PLANNING_VALUE';
							}
						}
						dataImporter.importExcel(modelCopy, true).then(function (result) {
							vm.model.methods.createBulk(result.data, activeCatalog, vm.model, action.id);
						});
						break;
					case 'importBySegmentationGroup':
						dataImporter.importExcel(api.catalogs.importBySegmentationGroup, true).then(function (result) {
							vm.model.methods.createBulk(result.data, activeCatalog, vm.model, action.id);
						});
						break;
					case 'updateBulk':
						var lookupPromises = {};
						lookupPromises = crud.createLookupPromise(vm.model, undefined , 'edit');
						bulkUpdater.showDialog(vm.model, vm.segmentations, {
							'catalogId': activeCatalogId,
							'segmentationGroupList': utility.filterObject(catalogFactory.getActiveCatalogDetails().SegmentationGroupList, { Status: 1 }),
							'isSegmentationPlanningEnable': activeCatalog.SegmentationPlanningEnable
						}, lookupPromises);
						break;
					case 'updateSegmentationViaImportModel':
						var modelCopy = angular.copy(vm.model);
						var articleNumberField = utility.filterObject(modelCopy.fields, { field: 'ArticleNumber' }, true)[0];
						articleNumberField.creatable = false;

						dataImporter.importExcel(modelCopy, true, { isUpdateArticleSegmentationByModel: true }).then(function (result) {
							vm.model.methods.updateSegmentationViaImportModel(vm.model, result.data, activeCatalog);
						});
						break;
				}
			}
		}

		function viewItem(item) {
			var id = item.ArticleId;
			var stateParams = { id: id, tab: 'SEGMENTATION' };
			$state.go('app.articles.details', stateParams);
		}

		var catalogChangedEventCleanup = $rootScope.$on('ActiveCatalogChangedEvent', function (e) {
			if (activeCatalogId !== catalogFactory.getActiveCatalog().CatalogCode) {
				$state.reload('app.segmentation_linear');
			}
		});

		function assignArticleSegmentations(ev) {
			var modelCopy = angular.copy(vm.model);
			var articleIdModel = utility.filterObject(modelCopy.fields, {field: 'ArticleId', visible: false}, true)[0];
      articleIdModel.creatable = true;
			var segmentationIdModel = utility.filterObject(modelCopy.fields, {field: 'SegmentationId'}, true)[0];
      segmentationIdModel.creatable = true;
			var lookupPromises = {};
			lookupPromises = crud.createLookupPromise(modelCopy, undefined , 'create');
			$mdDialog.show({
					controller         : 'assignArticleSegmentationController',
					controllerAs       : 'vm',
					templateUrl        : 'app/main/catalogs/sub-modules/segmentation-linear/dialogs/assign-article-segmentation/assign-article-segmentation.html',
					parent             : angular.element($document.body),
					targetEvent        : ev,
					clickOutsideToClose: false,
					locals             : {
							lookupPromises: lookupPromises,
							model: modelCopy,
							catalogId: activeCatalogId,
							event: ev
					}
			});
		}

		$scope.$on('$destroy', function () {
			catalogChangedEventCleanup();
			$timeout.cancel(timeoutPromise);
		});

	}
})();
(function() {
    'use strict';

	angular
		.module('app.main.catalog-articles.segmentation')
		.controller('segmentationListController', segmentationListController);

	/* @ngInject */
	function segmentationListController(api, utility, $rootScope, $scope, $state, catalogFactory, catalogSpecificSegmentationModel,
											dataImporter, bulkUpdater, $timeout, settingsFactory, $mdDialog, $document, dialog, $filter, crud) {
		/* jshint validthis: true */
		var vm = this;


        //Data
        var activeCatalog = catalogFactory.getActiveCatalog();
		var activeCatalogId = activeCatalog.CatalogCode;
        vm.activeCatalogId = activeCatalogId;

        vm.model = catalogSpecificSegmentationModel;
        settingsFactory.applyPersistedListViewLayout(vm.model);

		vm.segmentations = [];
		vm.filteredSegmentations = [];
		vm.isLoading = false;
		var timeoutPromise;


		//Methods
		vm.refreshItems = refreshItems;
		vm.doItemAction = doItemAction;
		vm.doListAction = doListAction;
		vm.viewItem = viewItem;

		activate();

		////////////////

        function activate() {
            refreshItems(vm.model.baseModel.isDirty, true);
		}

		function refreshItems(forceFetch, isLogRequired) {
            vm.isLoading = true;
            var generalProperties = {
                forceFetch: forceFetch,
                isLogRequired: isLogRequired,
                config: {},
                supportIncrementalResult: true,
                modelIdField: vm.model.idField,
                isMajor: false,
                isArticleRelatedData: true,
				nestedArrayName: 'Segmentations',
				nestedDataIdField: 'Id' //it should be nestedObject Id
            }
			timeoutPromise = $timeout(function() {// TODO - need to change GET method catching mechanism (since the data is catched controll goes to then part imidiatly and transform function freezes the UI)
				vm.model.methods.getList(generalProperties, vm.model, activeCatalogId)
				.then(function (response) {
					var responseData;
					responseData = response.data;
					vm.segmentations = catalogFactory.transformSegmentationsResponse(responseData, 'Segmentations', vm.model.fields);

					if(activeCatalog.DataSourceTypeId === 3) {
						var containInvalid = false;
						angular.forEach(vm.segmentations, function(segmentation) {
								if(segmentation['outOfParentSegmentationsArray'].length > 0) {
									segmentation['warn'] = true;
									containInvalid = true;
								}
						})

						if(containInvalid) {
							dialog.showAlertDialog(
									angular.element($document.body),
									$filter('translate')('MESSAGES.TITLE.ALERT'),
									$filter('translate')('SEGMENTATION.MESSAGES.ARTICLE_WITH_INVALID_SEGMENTATION'),
									$filter('translate')('MESSAGES.TITLE.ALERT'),
									$filter('translate')('ACTIONS.DIALOG_CLOSE'),
									true,
									null
							);
						}
					}
				})
				.finally(function () {
					vm.isLoading = false;
				});
			},500);
		}

		//Item Action button pressed event
		function doItemAction(action, record) {
			if (action && record) {
				switch (action.id) {
				case 'view':
					viewItem(record);
					break;
				case 'edit':
					editItem(record, null);
					break;
				}
			}
		}

		function doListAction(action, records) {
			if (action) {
                switch (action.id) {
					case 'import':
						var modelCopy = angular.copy(vm.model);
						var modelNumberField = utility.filterObject(modelCopy.fields, {field: 'ModelNumber'}, true)[0];
						modelNumberField.creatable = false;
						dataImporter.importExcel(modelCopy, true).then(function(result) {
							vm.model.methods.createBulk(result.data, activeCatalog, vm.model, action.id);
						});
						break;
					case 'importBySegmentationGroup':
						dataImporter.importExcel(api.catalogs.importBySegmentationGroup, true).then(function(result) {
							vm.model.methods.createBulk(result.data, activeCatalog, vm.model, action.id);
						});
						break;
					case 'updateBulk':
						var lookupPromises = {};
						lookupPromises = crud.createLookupPromise(vm.model, undefined , 'edit');
						bulkUpdater.showDialog(vm.model, vm.segmentations, {
							'catalogId'			          : activeCatalogId,
							'segmentationGroupList'       : utility.filterObject(catalogFactory.getActiveCatalogDetails().SegmentationGroupList, { Status: 1 }),
							'isSegmentationPlanningEnable': activeCatalog.SegmentationPlanningEnable
						}, lookupPromises);
						break;
					case 'updateSegmentationViaImportModel':
						var modelCopy = angular.copy(vm.model);
						var articleNumberField = utility.filterObject(modelCopy.fields, {field: 'ArticleNumber'}, true)[0];
						articleNumberField.creatable = false;

						//make model number as unique constraint
						modelCopy.uniqueConstraints = [{name: 'Constraint 1', fields: ['ModelNumber']}];
						//make all attribute non editable and make segmentations editable
						angular.forEach(modelCopy.fields, function(field) {
							if(field.isCatalogProperty) {
								field.creatable = true;
							}
							if(field.isAttribute && field.creatable) {
								field.creatable = false;
							}
						});

						dataImporter.importExcel(modelCopy, true, {isUpdateArticleSegmentationByModel : true}).then(function(result) {
							vm.model.methods.updateSegmentationViaImportModel(vm.model, result.data, activeCatalog);
						});
						break;
				}
			}
		}

         function viewItem(item) {
            var id = item.Id;
            var stateParams = {id: id, tab: 'SEGMENTATION'};
            $state.go('app.articles.details', stateParams);
		}

		function editItem(record, ev) {
            $mdDialog.show({
                controller         : 'updateSegmentationsController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/catalogs/sub-modules/segmentation/dialogs/update-segmentations/update-segmentations.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: false,
                locals             : {
                    model: vm.model,
                    record: record,
					activeCatalogCode: activeCatalogId
                }
            }).then(function(saved) {
                if(saved) {
                    refreshItems(true, false);
                }
            });
		}

        var catalogChangedEventCleanup = $rootScope.$on('ActiveCatalogChangedEvent', function(e) {
            if(activeCatalogId !== catalogFactory.getActiveCatalog().CatalogCode) {
                $state.reload('app.segmentation');
            }
        });
        $scope.$on('$destroy', function () {
            catalogChangedEventCleanup();
			$timeout.cancel(timeoutPromise);
        });

	}
})();
(function () {
	'use strict';

	angular
		.module('app.main.catalogs.saved-views', [
			'app.main.catalogs.saved-views.shared-with-users',
			'app.main.catalogs.saved-views.shared-with-user-groups'
		])
		.config(config);

	/* @ngInject */
	function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {

		$stateProvider.state('app.saved_views', {
			url: '/saved-views',
			views: {
				'content@app': {
					templateUrl: 'app/main/catalogs/sub-modules/saved-views/list/saved-views-list.html',
					controller: 'savedViewsListController as vm'
				}
			},
			data: {
				displayName: 'SAVED_VIEWS.NAV'
			},
			// accessPrivileges: ['nav_saved_views']
			// accessPrivileges: ['GetAllSavedViews']
			accessInfo: {
				accessPrivileges: ['nav_saved_views']
			},
			visibleForLinePlan: true
		});

		$stateProvider.state('app.saved_views.details', {
			url	 : '/:id',
			views: {
					'content@app': {
							templateUrl: 'app/main/catalogs/sub-modules/saved-views/details/saved-views-details.html',
							controller : 'savedViewsDetailsController as vm'
					}
			},
			data: {
				parentState: 'app.saved_views',
				displayName: 'SAVED_VIEWS.TABS.SAVED_VIEW'
			},
			// accessPrivileges: ['GetSavedViewDetails']
			accessInfo: {
					accessPrivileges: ['nav_saved_views']
			},
			visibleForLinePlan: true
		});

		// Translation
		$translatePartialLoaderProvider.addPart('app/main/catalogs/sub-modules/saved-views');

		// Navigation
		msNavigationServiceProvider.saveItem('catalogs.saved-views', {
			title: 'Saved Views',
			icon: 'icon-bookmark',
			state: 'app.saved_views',
			translation: 'SAVED_VIEWS.NAV',
			weight: 44,
			// accessPrivileges: ['nav_saved_views']
			// accessPrivileges: ['GetAllSavedViews'],
			accessInfo: {
				accessPrivileges: ['nav_saved_views']
			},
			visibleForLinePlan: true
		});
	}

})();
(function () {
	'use strict';

	angular
		.module('app.main.catalogs.saved-views')
		.controller('savedViewsListController', savedViewsListController);

	/* @ngInject */
	function savedViewsListController(api, settingsFactory, dataImporter, $state, $document, utility, catalogFactory, $localStorage, $rootScope, $scope) {
		/* jshint validthis: true */
		var vm = this;

		var activeCatalog = catalogFactory.getActiveCatalog();
		var catalogCode = activeCatalog.CatalogCode;

		vm.model = api.catalogs.savedViews;
		settingsFactory.applyPersistedListViewLayout(vm.model);

		vm.savedViews = [];
		vm.filteredSavedViews = [];
		vm.isLoading = false;

		vm.refreshItems = refreshItems;
		vm.doListAction = doListAction;
		vm.doItemAction = doItemAction;
		vm.viewItem = viewItem;

		activate();

		////////////////

		function activate() {
			refreshItems(vm.model.isDirty, true);
		}

		function refreshItems(forceFetch, isLogRequired) {
			var generalProperties = {
				forceFetch: forceFetch,
				isLogRequired: isLogRequired
			}
			vm.isLoading = true;

			return vm.model.methods.getList(generalProperties, vm.model, catalogCode)
				.then(function (response) {
					vm.savedViews = response.data;
				})
				.finally(function () {
					vm.isLoading = false;
				});
		}

		// item Action button pressed event
		function doItemAction(action, record) {
			if (action && record) {
				switch (action.id) {
					case 'edit':
								vm.model.methods.getDetails(true, record[vm.model.idField], catalogCode)
								.then(function (response) {
										editRecord(response.data, null);
								})
								break;
					case 'view':
								viewItem(record);
								break;
					case 'delete':
					case 'activate':
							vm.model.methods.activateBulk(record, vm.model, action.id, catalogCode);
							break;
				}
			}
		}

		// list Action button pressed event
		function doListAction(action, records) {
			if (action) {
				switch (action.id) {
					case 'import':
						var modelCopy = angular.copy(vm.model);
						if(angular.isDefined($localStorage.account) && $localStorage.account.accountType == 1) {
							var containerValueField = utility.filterObject(modelCopy.fields, { field: 'IsCatalogLevel' }, true)[0];
							if(angular.isDefined(containerValueField)) {
								containerValueField.creatable = true;
							}
						}
						dataImporter.importExcel(modelCopy, true).then(function (result) {
							vm.model.methods.createBulk(vm.model, result.data, catalogCode);
						})
						break;
					case 'delete':
					case 'activate':
						vm.model.methods.activateBulk(records, vm.model, action.id, catalogCode);
						break;
				}
			}
		}

		function editRecord(record, ev) {
			api.showEditRecordDialog(angular.element($document.body), ev, vm.model, record, catalogCode)
			.then(function(saved) {
					if (saved) {
						refreshItems(true, false);
					}
			});
		}

		function viewItem(record) {
			var stateParams = { id: record[vm.model.idField]};
			$state.go('app.saved_views.details', stateParams);
		}

		var catalogChangedEventCleanup = $rootScope.$on('ActiveCatalogChangedEvent', function(e) {
			if(catalogCode !== catalogFactory.getActiveCatalog().CatalogCode) {
					$state.reload('app.saved_views');
			}
		});
		$scope.$on('$destroy', function () {
				catalogChangedEventCleanup();
		});
	}
})();
(function () {
	'use strict';

	angular
		.module('app.main.catalogs.saved-views')
		.controller('savedViewsDetailsController', savedViewsDetailsController);

	/* @ngInject */
	function savedViewsDetailsController(api, $state, $stateParams, $rootScope, $document, catalogFactory, settingsFactory) {
		/* jshint validthis: true */
		var vm = this;

		// Data
		var savedViewId = $stateParams.id;
		var activeCatalog = catalogFactory.getActiveCatalog();
		var catalogCode = activeCatalog.CatalogCode;

		vm.model = api.catalogs.savedViews;

		vm.sharedWithModelUsers = api.savedViews.sharedWithUsers;
		settingsFactory.applyPersistedListViewLayout(vm.sharedWithModelUsers);
		vm.sharedWithModelUserGroups = api.savedViews.sharedWithUserGroups;
		settingsFactory.applyPersistedListViewLayout(vm.sharedWithModelUserGroups);

		vm.savedView = {};
		vm.sharedWithUsers = [];
		vm.filteredSharedWithUsers = [];
		vm.sharedWithUserGroups = [];
		vm.filteredSharedWithUserGroups = [];

		vm.isLoading = false;

		// Methods
		vm.refreshRecord = refreshRecord;
		vm.editItem = editItem;
		vm.doItemAction = doItemAction;

		activate();

		////////////////

		function activate() {
			refreshRecord(true);
		}

		function refreshRecord(isLogRequired) {
			vm.isLoading = true;
			vm.model.methods.getDetails(isLogRequired, savedViewId, catalogCode)
			.then(function (response) {
				vm.savedView = response.data;
				vm.sharedWithUsers = response.data.SharedUsers;
				vm.sharedWithUserGroups = response.data.SharedAccountGroups;
				vm.title = vm.savedView['Name'];

				//Update Breadcrumb
				$state.current.data.displayName = vm.title;
				$rootScope.$broadcast('breadcrumb-updated');
			})
			.finally(function () {
				vm.isLoading = false;
			});
		}

		function editItem(record, ev) {
			api.showEditRecordDialog(angular.element($document.body), ev, vm.model, record, catalogCode)
			.then(function(saved) {
					if (saved) {
						refreshRecord(false);
					}
			});
		}

		function doItemAction(action, record) {
			if (action) {
				switch (action.id) {
					case 'delete':
					case 'activate':
						vm.model.methods.activateBulk(record, vm.model, action.id, catalogCode);
						break;
				}
			}
		}

	}
})();
(function () {
    'use strict';

    angular
        .module('app.main.catalogs.resources', [
            'app.main.catalogs.resources.articles',
            'app.main.catalogs.resources.models'
        ])
        .config(config);

    /* @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
        // State
        $stateProvider.state('app.resources', {
            url    : '/resources',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/catalogs/sub-modules/resources/list/resources-list.html',
                    controller : 'resourcesListController as vm'
                }
            },
            resolve: {
                resourcesModel : function(catalogFactory, api, utility) {
                    var activeCatalog = catalogFactory.getActiveCatalog();
                    var modelCopy = angular.copy(api.catalogs.resources);
                    if(activeCatalog.DataSourceTypeId === 3) {
                        utility.filterObject(modelCopy.views.mainList.listActions, { id: 'copyResources' }, true)[0].visible = true;
                        return modelCopy;
                    } else {
                        return modelCopy;
                    }
                }
            },
            data: {
                displayName: 'RESOURCES.NAV'
            },
            //only users with following accessPrivileges in their role access list can access this route
			// accessPrivileges: ['GetCatalogResourceList']
            // accessPrivileges: ['nav_resources']
            accessInfo: {
                accessPrivileges: ['nav_resources']
            }
        });

        $stateProvider.state('app.resources.details', {
			url	 : '/:id',
            views: {
				'content@app': {
					templateUrl: 'app/main/catalogs/sub-modules/resources/details/resources-details.html',
					controller : 'resourcesDetailsController as vm'
				}
			},
            resolve: {},
			data: {
				parentState: 'app.resources',
                displayName: 'RESOURCES.TABS.RESOURCE'
			},
            // accessPrivileges: ['GetCatalogResourceDetails']
            accessInfo: {
                accessPrivileges: ['GetCatalogResourceDetails']
            }
		});

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/catalogs/sub-modules/resources');

        msNavigationServiceProvider.saveItem('catalogs.resources', {
            title      : 'Resources',
            icon       : 'icon-image-filter-black-white',
            state      : 'app.resources',
            translate  : 'RESOURCES.NAV',
            weight     : 100,
            // accessPrivileges: ['GetCatalogResourceList']
            // accessPrivileges: ['nav_resources']
            accessInfo: {
                accessPrivileges: ['nav_resources']
            }
        });
    }
})();
(function() {
    'use strict';

	angular
		.module('app.main.catalogs.resources')
		.controller('resourcesListController', resourcesListController);

	/* @ngInject */
	function resourcesListController(api, $mdDialog, $rootScope, $scope, $state, $document, resourcesModel, catalogFactory, dialog, toast, uploadsTracker, crud, settingsFactory, dataImporter, bulkUpdater) {
		/* jshint validthis: true */
		var vm = this;

        // Data
        var activeCatalog = catalogFactory.getActiveCatalog();
		var activeCatalogCode = activeCatalog.CatalogCode;

        var importResourceasModel = api.resources.mapToArticles;
        vm.model = resourcesModel;
        settingsFactory.applyPersistedListViewLayout(vm.model);

		vm.resources = [];
		vm.filteredResources = [];
		vm.isLoading = false;

        // Methods
		vm.refreshRecords = refreshRecords;
		vm.doListAction = doListAction;
		vm.doItemAction = doItemAction;
		vm.viewRecord = viewRecord;
		vm.addRecord = addRecord;

		activate();

		////////////////

        function activate() {
            refreshRecords(vm.model.isDirty, true);
            // Pre-load catalog models lookup so it's cached for Map Resources to Colorways toggle
            var catalogModelsModel = api.getModel('catalogs.models');
            catalogModelsModel._loadPromise = api.getLookupData(catalogModelsModel);
		}

		function refreshRecords(forceFetch, isLogRequired) {
            vm.isLoading = true;
            var generalProperties = {
                forceFetch: forceFetch,
                isLogRequired: isLogRequired
            }
			vm.model.methods.getList(generalProperties, vm.model, activeCatalogCode)
			.then(function (response) {
                angular.forEach(response.data, function(resource){
                    //To avoid creating null or empty url in resources
                    if(resource.FilePath !== null && resource.FilePath !== "" && resource.FileName !== null && resource.FileName !== "" ) {
                        resource.Resource = resource.FilePath + "/" + resource.FileName;
                    } else {
                        resource.Resource = "";
                    }
                });
				vm.resources = response.data;
			})
			.finally(function () {
				vm.isLoading = false;
			});
		}

		//Item Action button pressed event
		function doItemAction(action, record) {
			if (action && record) {
                switch (action.id) {
                    case 'view':
                        viewRecord(record);
                        break;
                    case 'edit':
                        vm.model.methods.getDetails(true, record[vm.model.idField] || record['RefResourceId'], activeCatalogCode)
                        .then(function (response) {
                            editRecord(response.data, null);
                        })
                        break;
                    case 'delete':
                    case 'activate':
                        vm.model.methods.activateBulk(record, vm.model, action.id, activeCatalogCode);
                        break;
                    case 'editSortOrder':
                        editSortOrder(record, null);
                        break;

                }
			}
		}

        // //List Action button pressed event
        function doListAction(action, records) {
            if (action) {
                switch (action.id) {
                    case 'delete':
                    case 'activate':
                        vm.model.methods.activateBulk(records, vm.model, action.id, activeCatalogCode);
                        break;
                    case 'upload':
                        uploadResources();
                        break;
                    case 'import':
                        dataImporter.importExcel(importResourceasModel, true).then(function(result) {
                            vm.model.methods.createBulk(vm.model, result.data, activeCatalogCode, result.isModelLevelImport);
                        });
                        break;
                    case 'copyResources':
                        var generalProperties = {
                            forceFetch: true,
                            isLogRequired: false
                        }
                        vm.model.methods.getMasterCatalogResources(generalProperties, activeCatalogCode).then(function(response){
                            var modelCopy = angular.copy(vm.model);
                            modelCopy.views.mainList.listActions = [{ id: 'copyResources', label: 'RESOURCES.ACTIONS.COPY_RESOURCES', icon: 'icon-content-copy', privilege: 'UpdateBulkResource', disabled: '{selected: true, Status: 1}', visible: true, requiresConfirmation: false}];
                            modelCopy.views.mainList.itemActions = [];
                            $mdDialog.show({
                            controller: 'copyResourcesController',
                            controllerAs: 'vm',
                            templateUrl: 'app/main/catalogs/sub-modules/resources/dialogs/copy-resources.html',
                            parent: angular.element($document.body),
                            targetEvent: null,
                            clickOutsideToClose: false,
                            multiple: true,
                            locals: {
                                event: null,
                                data: response.data,
                                model: modelCopy,
                                catalogCode: activeCatalogCode
                            }
                            }).then(function(saved) {
                                if (saved) {
                                    refreshRecords(true);
                                }
                            });
                        });
                        break;
                    case 'editBulkSortOrder':
                        var modelCopy = angular.copy(vm.model);
                        // make editable false to all fields except SortOrder and Category
                        angular.forEach(modelCopy.fields, function(field) {
                            if(field.field !== 'SortOrder' && field.field !== 'Category' && field.editable) {
                                field.editable = false;
                            } else if(field.field === 'SortOrder' || field.field === 'Category'){
                                field.editable = true;
                            }
                        });
                        var lookupPromises = {};
                        lookupPromises = crud.createLookupPromise(modelCopy, undefined , 'edit');
                        bulkUpdater.showDialog(modelCopy, vm.resources, null, lookupPromises)
                        .then(function(response) {
                            if(angular.isDefined(response) && response.toString() != 'false') {
                                vm.model.methods.editSortOrder(response.selectedRecords, response.propertiesToUpdate).then(function() {
                                    toast.success('RESOURCES.MESSAGES.UPDATE_SUCCESS', '', '');
                                    refreshRecords(true);
                                });
                            }
                        });
                        break;
                }
            }
        }

        function viewRecord(item) {
            if(item.Status === 1) {
                var id = item[vm.model.idField] || item['RefResourceId'];
                var stateParams = {id: id, resource: item};
                $state.go('app.resources.details', stateParams);
            }
		}

        function addRecord(ev) {
            var lookupPromises = {};
            lookupPromises = crud.createLookupPromise(vm.model, undefined , 'create');
            $mdDialog.show({
                controller         : 'uploadResourceController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/catalogs/sub-modules/resources/dialogs/upload-resource.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: false,
                locals             : {
                    model: vm.model,
                    record: {},
                    activeCatalogCode : activeCatalogCode,
                    lookupPromises: lookupPromises,
                    isNew: true,
                    isArticleDetails: false,
                    event: ev
                }
            }).then(function(saved) {
                if (saved) {
                    refreshRecords(true);
                }
            });
		}

		function editRecord(record, ev) {
            var lookupPromises = {};
            lookupPromises = crud.createLookupPromise(vm.model, undefined , 'edit');
             $mdDialog.show({
                controller         : 'uploadResourceController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/catalogs/sub-modules/resources/dialogs/upload-resource.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: false,
                locals             : {
                    model: vm.model,
                    record: angular.copy(record),
                    activeCatalogCode : activeCatalogCode,
                    lookupPromises: lookupPromises,
                    isNew: false,
                    isArticleDetails: false,
                    event: ev
                }
            }).then(function(saved) {
                if (saved) {
                    refreshRecords(true);
                }
            });
        }

        function editSortOrder(record, ev) {
            var modelCopy = vm.model;
            var additionalInfo = { 'additionalAction': 'resourcesEditSortOrder'};
            angular.forEach(modelCopy.fields, function(field) {
                if(field.field !== 'SortOrder' && field.editable) {
                    field.editable = false;
                } else if(field.field === 'SortOrder'){
                    field.editable = true;
                }
            });
            api.showEditRecordDialog(angular.element($document.body), ev, modelCopy, record, undefined, undefined, additionalInfo)
            .then(function(saved) {
                if (saved) {
                    refreshRecords(true);
                }
            });
        }

        function uploadResources() {
            var lookupPromises = {};
            lookupPromises = crud.createLookupPromise(vm.model, undefined , 'edit');
            $mdDialog.show({
                controller         : 'uploadResourcesController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/catalogs/sub-modules/resources/dialogs/upload-resources.html',
                parent             : angular.element($document.body),
                targetEvent        : null,
                clickOutsideToClose: false,
                closeTo            : '#quick-panel-toggle',
                locals             : {
                    lookupPromises: lookupPromises,
                    model : vm.model
                }
            }).then(function (data) {
                if (angular.isDefined(data) && angular.isDefined(data.flowObj)) {
                    var index = uploadsTracker.addUpload('Bulk Resources', data.flowObj);
                    uploadsTracker.uploads[index].defer.promise.then(function() {
                        for (var fileIndex=0, len=uploadsTracker.uploads[index].flow.files.length; fileIndex< len ; fileIndex++) {
                            vm.model.methods.uploadBulk(uploadsTracker.uploads[index].flow.files[fileIndex].fileId, data.resourceType, activeCatalogCode, vm.model);
                        }
                    }, function() {
                        //If any files of flow object doesnt upload successfully
                    });
                }
            });
        }

        var catalogChangedEventCleanup = $rootScope.$on('ActiveCatalogChangedEvent', function(e) {
            if(activeCatalogCode !== catalogFactory.getActiveCatalog().CatalogCode) {
                $state.reload('app.resources');
            }
        });
        $scope.$on('$destroy', function () {
            catalogChangedEventCleanup();
        });

	}
})();
(function() {
    'use strict';

    angular
        .module('app.main.catalogs.resources')
        .controller('uploadResourcesController', uploadResourcesController);

    /* @ngInject */
    function uploadResourcesController(api, $mdDialog, $scope, $window, $filter, hotkeys, $rootScope, $localStorage, $auth, toast, utility, lookupPromises, model) {
        /* jshint validthis: true */
        var vm = this;

        //Data
        vm.isLoading = false;
        vm.isFileValid = false;

        if (angular.isUndefined($rootScope.flowObj)) {
            $rootScope.flowObj = {};
        }
        vm.obj = $rootScope.flowObj;

        vm.flowInit = {
            target      : $localStorage.baseUrl + '/UploadFileChunk',
            headers     : { Authorization: 'Bearer ' + $auth.getToken()},
            singleFile  : true
        };

        vm.searchText = {};
        var acResourceType = {};


        //Methods
        vm.validateFile = validateFile;
        vm.saveRecord = saveRecord;
        vm.closeDialog = closeDialog;

        vm.lookupSearch = lookupSearch;
        vm.lookupChange = lookupChange;
        vm.getLookupDisplayValue = getLookupDisplayValue;
        vm.selectText = selectText;


        activate();

        ////////////////


        function activate() {
            //Hotkeys
            hotkeys.bindTo($scope).add({
                combo: 'ctrl+enter',
                description: $filter('translate')('ACTIONS.SAVE'),
                allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
                callback: function(event) {
                    if (vm.obj.files.length > 0) {
                        vm.saveRecord();
                    }
                }
            });
        }

        function validateFile(file, message, flow) {
            if (angular.isDefined(file) && !file.name.match(/\.(zip|rar|7z)$/)) {
                toast.success('RESOURCES.MESSAGES.INVALID_FILE_FORMAT', '', '');
                vm.isFileValid = false;
            }
            else {
                vm.isFileValid = true;
            }
        }

        function saveRecord() {
            closeDialog({flowObj: vm.obj.flow, resourceType: acResourceType});
        }

        function closeDialog(saved) {
            $mdDialog.hide(saved);
        }

        function lookupSearch(query, fieldName) {
            var results = [];
            var field = utility.filterObject(model.fields, {field: fieldName})[0];
            var lookupFilter = field.lookupFilter ? field.lookupFilter : {};
            var predicate = angular.copy(lookupFilter);
            predicate.value = query;
            var lookupModel = api.getModel(field.lookupSource);

            if(angular.isDefined(lookupModel.lookupData) && lookupModel.lookupData.data.length) {
                results = query ? utility.filterObject(lookupModel.lookupData.data , predicate) :  utility.filterObject(lookupModel.lookupData.data, lookupFilter);
                return results;
            }
            else {
                return lookupPromises[fieldName].then(function(lookupData) {
                    results = query ? utility.filterObject(lookupData.data , predicate) :  utility.filterObject(lookupData.data, lookupFilter);
                    return results;
                });
            }
        }

        // convert dropdown scope value form object(lookup record) to id property of lookup record
        function lookupChange(selectedObj, field) {
            if(angular.isObject(selectedObj)) {
                acResourceType[field] = selectedObj.id;
            }
            else if(angular.isUndefined(selectedObj) || selectedObj === null) {
                acResourceType[field] = undefined; // on record removal make field undefined or the property can be deleted using delete keywork
            }
        }

        function getLookupDisplayValue(item, fieldName) {
            var result;
            var field = utility.filterObject(model.fields, {field: fieldName})[0];
            var lookupModel = api.getModel(field.lookupSource);

            if(lookupModel.lookupData) {
                // since autocomplte return object
                if(angular.isObject(item)) {
                    result = utility.filterObject(lookupModel.lookupData.data, {id: item.id}, true);
                }
                // to initialize filed value if any (when open update record dialog)
                else {
                    result = utility.filterObject(lookupModel.lookupData.data, {id: item}, true);
                }

                if (angular.isArray(result) && result.length > 0) {
                    return result[0].value;
                }
                else {
                    return result.value;
                }
            }
        }

        function selectText(event) {
            utility.selectInputText(event);
        }

    }
})();
(function() {
    'use strict';

    angular
        .module('app.main.catalogs.resources')
        .controller('uploadResourceController', uploadResourceController);

    /* @ngInject */
    function uploadResourceController(api, $mdDialog, $scope, $window, $filter, hotkeys, $rootScope, $localStorage, $log,
            utility, $auth, toast, model, record, activeCatalogCode, isNew, isArticleDetails, lookupPromises, event) {
        /* jshint validthis: true */
        var vm = this;

        //Data
        vm.model = model;
        vm.articleModel = api.catalogs.articles;
        if (angular.isUndefined($rootScope.flowObj) || angular.isUndefined($rootScope.flowObj2)) {
            $rootScope.flowObj = {};
            $rootScope.flowObj2 = {};
        }
        vm.obj = $rootScope.flowObj;
        vm.obj2 = $rootScope.flowObj2;

        vm.flowInit = {
            target      : $localStorage.baseUrl + '/UploadFileChunk',
            headers     : { Authorization: 'Bearer ' + $auth.getToken()},
            singleFile  : true
        };

        vm.isFileValid = true;
        vm.isResourceFileValid = true;
        vm.isIconFileValid = true;
        vm.isLoading = false;
        vm.isNew = isNew;
        vm.isArticleDetails = isArticleDetails;
        vm.record = record;
        vm.resourceName = '';
        vm.iconName = '';
        if(isNew) {//Set default value as 1 when creating new record
            vm.record.Cascading = 1;
        }
        if(!vm.record) {
            vm.record = {};
        } else {
            if(vm.record.FileName) {
                vm.resourceName = vm.record.FileName.slice(vm.record.FileName.lastIndexOf('/') + 1, vm.record.FileName.length)
            }
            if(vm.record.Icon) {
                vm.iconName = vm.record.Icon.slice(vm.record.Icon.lastIndexOf('/') + 1, vm.record.Icon.length );
            }
        }
        vm.record.ArticleIds = vm.record.ArticleIds || [];
        vm.record.ModelIds = vm.record.ModelIds || [];
        if(isNew) {
            vm.record.IsModelLevel = null;
        }


        if(!isNew) {
            vm.imgSrc = vm.record.FilePath+'/'+vm.record.FileName
        }
        vm.lookupModel = angular.copy(vm.record);
        vm.searchText = {};
        vm.allowedFileTypesList = ['pdf', 'jpg', 'jpeg', 'png', 'mp4', 'mpeg', 'mpg', 'avi', 'ppt', 'pptm', 'pptx'];
        vm.allowedFileTypeExtentions = [];


        //Methods
        vm.saveRecord = saveRecord;
        vm.closeDialog = closeDialog;
        vm.onResourceTypeChange =onResourceTypeChange;
        vm.validateFile = validateFile;
        vm.upload = upload;
        vm.onSuccessUpload = onSuccessUpload;

        vm.transformChip = transformChip;
        vm.acQuerySearch = acQuerySearch;
        vm.getChipDisplayValue = getChipDisplayValue;
        vm.onModelLevelToggleChange = onModelLevelToggleChange;
        vm.acSelectedItem = {};
        vm.acSearchText = {};

        vm.lookupSearch = lookupSearch;
        vm.lookupChange = lookupChange;
        vm.getLookupDisplayValue = getLookupDisplayValue;
        vm.selectText = selectText;


        activate();

        ////////////////

        function activate() {
            //Hotkeys
            hotkeys.bindTo($scope).add({
                combo: 'ctrl+enter',
                description: $filter('translate')('ACTIONS.SAVE'),
                allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
                callback: function(event) {
                    if (!vm.isLoading && !vm.editForm.$invalid && vm.obj.flow.files.length > 0 && vm.isFileValid && !vm.obj.flow.isUploading()) {
                        vm.saveRecord();
                    }
                }
            });
            if(vm.isNew) {
                hotkeys.bindTo($scope).add({
                    combo: 'ctrl+shift+enter',
                    description: $filter('translate')('ACTIONS.SAVE_AND_NEW'),
                    allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
                    callback: function(event) {
                        if (!vm.isLoading && !vm.editForm.$invalid && vm.obj.flow.files.length > 0 && vm.isFileValid && !vm.obj.flow.isUploading() && vm.isNew) {
                            vm.saveRecord(true);
                        }
                    }
                });
            }

            // Pre-load lookup data for ArticleIds and ModelIds with inline loaders
            if(vm.isNew) {
                if(lookupPromises['ArticleIds']) {
                    vm.isArticlesLookupLoading = true;
                    lookupPromises['ArticleIds'].finally(function() {
                        vm.isArticlesLookupLoading = false;
                    });
                }
                if(lookupPromises['ModelIds']) {
                    vm.isModelsLookupLoading = true;
                    lookupPromises['ModelIds'].finally(function() {
                        vm.isModelsLookupLoading = false;
                    });
                }
            }

            //Load WebAPI allowed file types
			api.webGet('/app/app.config.json')
            .then(function (response) {
                if (angular.isDefined(response) && angular.isDefined(response.data)) {
                    if (angular.isDefined(response.data.resourcesAllowedFileTypes) && response.data.resourcesAllowedFileTypes.length > 0) {
                        vm.allowedFileTypesList = [];
                        angular.forEach(response.data.resourcesAllowedFileTypes, function(resourceFileType) {
                            vm.allowedFileTypesList.push(resourceFileType.fileType.toLowerCase());
                        });
                    }
                }

                if(vm.allowedFileTypesList.length > 0) {
                    angular.forEach(vm.allowedFileTypesList, function(resourceFileType) {
                        resourceFileType = '.' + resourceFileType;
                        vm.allowedFileTypeExtentions.push(resourceFileType);
                    });
                    //converting the array to string for validating file types
                    vm.allowedFileTypeExtentions = vm.allowedFileTypeExtentions.toString();
                }
            });
        }

        function saveRecord(saveAndNew) {
            vm.isLoading = true;
            var promise;
            if(vm.isNew) {
                promise = vm.model.methods.create(vm.record, activeCatalogCode);
            }
            else {
                promise = vm.model.methods.update(vm.record[vm.model.idField], vm.record, activeCatalogCode);
            }
            promise.then(function() {
                if (vm.isNew && angular.isDefined(saveAndNew) && saveAndNew) {
                    vm.editForm.$setPristine();
                    vm.editForm.$setUntouched();
                    vm.record = {};
                    vm.record.ArticleIds = [];
                    vm.record.ModelIds = [];
                    vm.record.IsModelLevel = null;
                    vm.obj.flow.files.length = 0;
                    vm.obj2.flow.files.length = 0;
                    vm.searchText = {};
                    vm.isDataDirty = true;

                    var el = $window.document.getElementById('dialog_input_first');
                    if (el) {
                        el.focus();
                    }
                }
                else {
                    closeDialog(true);
                }
                var toastMessage;
                toastMessage = vm.isNew ? 'SUCCESS.CREATE': 'SUCCESS.UPDATE';
                toast.success(toastMessage, '', '');
            }, function(err) {
                closeDialog(vm.isDataDirty);
            }).finally(function () {
                vm.isLoading = false;
            });
        }

        function closeDialog(saved, cancelUpload) {
            //If user cancel upload
            if(angular.isDefined(cancelUpload) && cancelUpload === true) {
                vm.obj.flow.cancel();
            }
            $mdDialog.hide(saved);
        }

        /**
         * since on drop upload start, Check image file type if user upload and then change dropdown
         */
        function onResourceTypeChange(resourceType, fieldName, files) {
            lookupChange(resourceType, fieldName);
            //If image
            if(files.length && resourceType === 8) {
                //invalid file flag
                var isValid = true;
                angular.forEach(files, function(file, index) {
                    if(!file.name.match(/\.(jpe?g|png)$/)) {
                        vm.obj.flow.removeFile(file);
                        vm.isFileValid = false;
                        isValid = false;
                    }
                });
                //if all files valid
                if(isValid) {
                    vm.isFileValid = true;
                }
            }
        }

        //validate image resources files
        function validateFile(file, ev, flow, resourceFileType) {
            var fileNameSplitArray = file.name.split(".");
            var fileType = fileNameSplitArray[fileNameSplitArray.length - 1];
            var allowedFileTypePresent = vm.allowedFileTypesList.indexOf(fileType.toLowerCase());
            if(allowedFileTypePresent === -1) {
                vm.isFileValid = false;
                if(resourceFileType === 'resource') {
                    vm.isResourceFileValid = false;
                } else {
                    vm.isIconFileValid = false;
                }
            } else {
                vm.isFileValid = true;
                if(resourceFileType === 'resource') {
                    vm.isResourceFileValid = true;
                } else {
                    vm.isIconFileValid = true;
                }
            }
        }

        function upload(fileType) {
            if (vm.isFileValid && fileType === 'resource') {
                vm.obj.flow.upload();
            } else if (vm.isFileValid && fileType === 'icon') {
                vm.obj2.flow.upload();
            } else if (!vm.isFileValid && fileType === 'resource') {
                //remove file from flowObj.files if file is not valid and set vm.isFileValid to default value which is true
                // vm.obj.flow.files.splice(vm.obj.flow.files.length-1,1);
                vm.obj.flow.removeFile(vm.obj.flow.files[vm.obj.flow.files.length - 1]);// or vm.obj.flow.files[0]
            } else if (!vm.isFileValid && fileType === 'icon') {
                vm.obj2.flow.removeFile(vm.obj2.flow.files[vm.obj2.flow.files.length - 1]);// or vm.obj.flow.files[0]
            }
        }

        function onSuccessUpload(file, message, chunk, fileType) {
            message = message.replace(/\"/g, "");
            if (fileType === 'resource') {
                vm.record.FileId = message;
            } else if (fileType === 'icon') {
                vm.record.IconFileId = message;
            }
        }

        function onModelLevelToggleChange() {
            // Clear selections when switching between article and model level
            vm.record.ArticleIds = [];
            vm.record.ModelIds = [];
        }

        function transformChip(chip) {
            if (angular.isObject(chip)) {
                return chip.id;
            }
            return undefined;
        }

        function getChipDisplayValue(chip, fieldName) {
            var field = utility.filterObject(model.fields, {field: fieldName})[0];
            var lookupModel = api.getModel(field.lookupSource);
            if(angular.isDefined(lookupModel.lookupData) && lookupModel.lookupData.data.length) {
                return getChipDisplayVal(lookupModel.lookupData, chip);
            }
            else {
                return lookupPromises[fieldName].then(function(lookupData) {
                    return getChipDisplayVal(lookupData, chip);
                });
            }
        }

        //TODO: Check performance impact on using nested filter
        function acQuerySearch(query, selectedItems, fieldName) {
            var results = [];
            var field = utility.filterObject(model.fields, {field: fieldName})[0];
            var lookupFilter = field.lookupFilter ? field.lookupFilter : {};
            var predicate = angular.copy(lookupFilter);
            predicate.value = query;
            var lookupModel = api.getModel(field.lookupSource);

            if(angular.isDefined(lookupModel.lookupData) && lookupModel.lookupData.data.length) {
                results = query ? utility.filterObject(lookupModel.lookupData.data , predicate) :  utility.filterObject(lookupModel.lookupData.data, lookupFilter);
                results = removeSelectedChips(selectedItems, results);
                return results;
            }
            else {
                return lookupPromises[fieldName].then(function(lookupData) {
                    results = query ? utility.filterObject(lookupData.data , predicate) :  utility.filterObject(lookupData.data, lookupFilter);
                    results = removeSelectedChips(selectedItems, results);
                    return results;
                });
            }
        }

        function lookupSearch(query, fieldName) {
            var results = [];
            var field = utility.filterObject(model.fields, {field: fieldName})[0];
            var lookupFilter = field.lookupFilter ? field.lookupFilter : {};
            var predicate = angular.copy(lookupFilter);
            predicate.value = query;
            var lookupModel = api.getModel(field.lookupSource);

            if(angular.isDefined(lookupModel.lookupData) && lookupModel.lookupData.data.length) {
                results = query ? utility.filterObject(lookupModel.lookupData.data , predicate) :  utility.filterObject(lookupModel.lookupData.data, lookupFilter);
                return results;
            }
            else {
                return lookupPromises[fieldName].then(function(lookupData) {
                    results = query ? utility.filterObject(lookupData.data , predicate) :  utility.filterObject(lookupData.data, lookupFilter);
                    return results;
                });
            }
        }

        // convert dropdown scope value form object(lookup record) to id property of lookup record
        function lookupChange(selectedObj, field) {
            if(angular.isObject(selectedObj)) {
                vm.record[field] = selectedObj.id;
            }
            else if(angular.isUndefined(selectedObj) || selectedObj === null) {
                vm.record[field] = undefined; // on record removal make field undefined or the property can be deleted using delete keywork
            }
        }

        function getLookupDisplayValue(item, fieldName) {
            var result;
            var field = utility.filterObject(model.fields, {field: fieldName})[0];
            var lookupModel = api.getModel(field.lookupSource);

            if(lookupModel.lookupData) {
                // since autocomplte return object
                if(angular.isObject(item)) {
                    result = utility.filterObject(lookupModel.lookupData.data, {id: item.id}, true);
                }
                // to initialize filed value if any (when open update record dialog)
                else {
                    result = utility.filterObject(lookupModel.lookupData.data, {id: item}, true);
                }

                if (angular.isArray(result) && result.length > 0) {
                    return result[0].value;
                }
                else {
                    return result.value;
                }
            }
        }

        function selectText(event) {
            utility.selectInputText(event);
        }

        //Helper Methods

        function removeSelectedChips(selectedArticles, articles) {
            if (angular.isDefined(selectedArticles) && selectedArticles.length > 0) {
                for (var index = articles.length-1; index >= 0; index--) {
                    if (selectedArticles.indexOf(articles[index].id) !== -1) {
                        articles.splice(index,1);
                    }
                }
            }
            return articles;
        }

        function getChipDisplayVal(lookupData, chip) {
            var res = utility.filterObject(lookupData.data, {id: chip}, true);
            if (angular.isArray(res) && res.length > 0) {
                return res[0].value;
            }
            else {
                $log.warn('uploadResourceController: Unable to resolve chip display value!');
                return "";
            }
        }
    }
})();
(function () {
  'use strict';

  angular
    .module('app.main.catalogs.resources')
    .controller('copyResourcesController', copyResourcesController);

  /* @ngInject */
  function copyResourcesController($mdDialog, api,  model, data, catalogCode) {
    var vm = this;

    vm.data = data;
    vm.model = model;
    vm.filteredData = [];
    vm.isLoading = false;

    vm.closeDialog = closeDialog;
    vm.doListAction = doListAction;

    activate();

    ////////////////

    function activate() {
      if (angular.isDefined(vm.tableControl) && angular.isDefined(vm.tableControl.updateData)) {
        vm.tableControl.updateData();
      }
    }

    function closeDialog(saved) {
      $mdDialog.hide(saved);
    }

    function doListAction(action, records) {
      switch (action.id) {
        case 'copyResources':
          model.methods.copyResources(records, catalogCode);
          closeDialog(true);
          break;
      }
    }

  }
})();
(function() {
    'use strict';

    angular
        .module('app.main.catalogs.resources')
        .controller('resourcesDetailsController', resourcesDetailsController);

    /* @ngInject */
    function resourcesDetailsController(api, $state, $stateParams, $mdDialog, $rootScope, $document, catalogFactory, toast, utility, crud, settingsFactory) {
       /* jshint validthis: true */
        var vm = this;

        // Data
        var resourceId = parseInt($stateParams.id);
        var activeCatalog = catalogFactory.getActiveCatalog();
        var activeCatalogCode = activeCatalog.CatalogCode;

        vm.model = api.catalogs.resources;

        vm.articleModel = api.resources.articles;
        settingsFactory.applyPersistedListViewLayout(vm.articleModel);

        vm.modelModel = api.resources.models;
        settingsFactory.applyPersistedListViewLayout(vm.modelModel);

        vm.resource = {};
        vm.assignedArticles = [];
        vm.filteredAssignedArticles = [];
        vm.assignedModels = [];
        vm.filteredAssignedModels = [];

        // Methods
        vm.refreshRecord = refreshRecord;
        vm.doResourceItemAction = doResourceItemAction;
        vm.editResource = editResource;
        vm.doArticleItemAction = doArticleItemAction;
        vm.doArticlesListAction = doArticlesListAction;
        vm.viewArticle = viewArticle;
        vm.assignArticles = assignArticles;
        vm.doModelItemAction = doModelItemAction;
        vm.doModelsListAction = doModelsListAction;
        vm.viewModel = viewModel;
        vm.assignModels = assignModels;


        activate();

        ////////////////

        function activate() {
            refreshRecord(true);
        }

        function refreshRecord(isLogRequired) {
            vm.isLoading = true;
            vm.model.methods.getDetails(isLogRequired, resourceId, activeCatalogCode)
            .then(function (response) {
                //To avoid creating null or empty url in resources
                if(response.data.FilePath !== null && response.data.FilePath !== "" && response.data.FileName !== null && response.data.FileName !== "" ) {
                    response.data.Resource = response.data.FilePath + "/" + response.data.FileName;
                } else {
                    response.data.Resource = "";
                };
                vm.resource = response.data;
                vm.title = vm.resource[vm.model.lookupDisplayField];

                //Update Breadcrumb
                $state.current.data.displayName = vm.title;
                $rootScope.$broadcast('breadcrumb-updated');

                vm.assignedArticles = utility.filterObject(response.data.ArticleResponseList, {Status: 1});
                vm.assignedModels = angular.isDefined(response.data.ModelResponseList) ? utility.filterObject(response.data.ModelResponseList, {Status: 1}) : [];
                // Resource is unlinked if IsModelLevel is false and both lists are empty
                vm.isUnlinkedResource = !vm.resource.IsModelLevel && vm.assignedArticles.length === 0 && vm.assignedModels.length === 0;
            })
            .finally(function () {
                vm.isLoading = false;
            });

        }

        function doResourceItemAction(action, record) {
            if (action) {
                switch (action.id) {
                    case 'delete':
                    case 'activate':
                        vm.model.methods.activateBulk(record, vm.model, action.id, activeCatalogCode);
                        break;
                }
            }
        }

        function editResource(ev, record) {
            var lookupPromises = {};
            lookupPromises = crud.createLookupPromise(vm.model, undefined , 'edit');
            $mdDialog.show({
                controller         : 'uploadResourceController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/catalogs/sub-modules/resources/dialogs/upload-resource.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: false,
                locals             : {
                    model: vm.model,
                    record: angular.copy(record),
                    activeCatalogCode : activeCatalogCode,
                    lookupPromises: lookupPromises,
                    isNew: false,
                    isArticleDetails: false,
                    event: ev
                }
            }).then(function(saved) {
                if (saved) {
                    refreshRecord(false);
                }
            });
		}

        function doArticleItemAction(action, record) {
            if(action && record){
                switch (action.id) {
                    case 'view':
                        viewArticle(record);
                        break;
                    case 'delete':
                    case 'activate':
                        vm.articleModel.methods.unasign(record, angular.copy(vm.resource), vm.articleModel, action.id, resourceId, activeCatalogCode).then(function() {
                            //crud.removeDeletedRecords(vm.resource.ArticleResponseList, record);
                            refreshRecord(false);
                        });
                        break;
                }
            }
        }

        function doArticlesListAction(action, records) {
            if(action && records){
                switch (action.id) {
                    case 'delete':
                    case 'activate':
                        vm.articleModel.methods.unasign(records, angular.copy(vm.resource), vm.articleModel, action.id, resourceId, activeCatalogCode).then(function() {
                            //crud.removeDeletedRecords(vm.resource.ArticleResponseList, records);
                            refreshRecord(false);
                        });
                        break;
                }
            }
        }

        function viewArticle(record) {
            var id = record[vm.articleModel.idField];
            var stateParams = {id: id, tab: 'DETAILS'};
            $state.go('app.articles.details', stateParams);
        }

        function assignArticles(ev) {
            var lookupPromises = {};
            lookupPromises = crud.createLookupPromise(vm.model, undefined , 'edit');
            var record = {};
            record.TypeId = vm.resource.TypeId;
            record.ResourceName = vm.resource.ResourceName;
            $mdDialog.show({
                controller         : 'assignArticlesController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/catalogs/sub-modules/resources/details/tabs/articles/dialogs/assign-articles.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: false,
                locals             : {
                    defaultValues: record,
                    asignedArticles: angular.copy(vm.assignedArticles),
                    resourceId: resourceId,
                    activeCatalogCode: activeCatalogCode,
                    lookupPromises: lookupPromises,
                    event: ev
                }
            }).then(function(saved) {
                if(saved){
                    refreshRecord(false);
                }
            });
        }

        // Model-level resource methods

        function doModelItemAction(action, record) {
            if(action && record){
                switch (action.id) {
                    case 'view':
                        viewModel(record);
                        break;
                    case 'delete':
                    case 'activate':
                        vm.modelModel.methods.unasign(record, angular.copy(vm.resource), vm.modelModel, action.id, resourceId, activeCatalogCode).then(function() {
                            refreshRecord(false);
                        });
                        break;
                }
            }
        }

        function doModelsListAction(action, records) {
            if(action && records){
                switch (action.id) {
                    case 'delete':
                    case 'activate':
                        vm.modelModel.methods.unasign(records, angular.copy(vm.resource), vm.modelModel, action.id, resourceId, activeCatalogCode).then(function() {
                            refreshRecord(false);
                        });
                        break;
                }
            }
        }

        function viewModel(record) {
            var stateParams = {id: record.ModelId};
            $state.go('app.catalog-models.details', stateParams);
        }

        function assignModels(ev) {
            var lookupPromises = {};
            lookupPromises = crud.createLookupPromise(vm.model, undefined , 'edit');
            var record = {};
            record.TypeId = vm.resource.TypeId;
            record.ResourceName = vm.resource.ResourceName;
            $mdDialog.show({
                controller         : 'assignModelsController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/catalogs/sub-modules/resources/details/tabs/models/dialogs/assign-models.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: false,
                locals             : {
                    defaultValues: record,
                    assignedModels: angular.copy(vm.assignedModels),
                    resourceId: resourceId,
                    activeCatalogCode: activeCatalogCode,
                    lookupPromises: lookupPromises,
                    event: ev
                }
            }).then(function(saved) {
                if(saved){
                    refreshRecord(false);
                }
            });
        }

    }
})();
(function() {
	'use strict';

	angular
		.module('app.main.catalogs.requests', [
			'app.main.catalogs.requests.participants',
			'app.main.catalogs.requests.attachments',
			'app.main.catalogs.requests.history'
		])
		.config(config);

		/* @ngInject */
		function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
			// State
			$stateProvider.state('app.requests', {
				url: '/requests',
				views: {
					'content@app': {
						templateUrl: 'app/main/catalogs/sub-modules/requests/list/requests-list.html',
						controller: 'requestsListController as vm'
					}
				},
				data: {
					displayName: 'REQUESTS.NAV'
				},
				//only users with following accessPrivileges in their role access list can access this route
				// accessPrivileges: ['GetRequests']
				// accessPrivileges: ['nav_requests']
				accessInfo: {
					accessPrivileges: ['nav_requests']
				},
				visibleForLinePlan: true
			});

			$stateProvider.state('app.requests.details', {
				url	 : '/:id',
				params: {
					requestCatalogCode: undefined
				},
				views: {
					'content@app': {
						templateUrl: 'app/main/catalogs/sub-modules/requests/details/requests-details.html',
						controller : 'requestsDetailsController as vm'
					}
				},
				resolve: {
					requestDetailsModel: function (requestsFactory, $stateParams) {
						var requestId = $stateParams.id;
						var catalogCode = $stateParams.requestCatalogCode;
						return requestsFactory.createRequestDetailsModel(requestId, catalogCode);
					},
					participantsModel: function (requestsFactory, catalogFactory) {
						var catalogCode = catalogFactory.getActiveCatalog().CatalogCode;
						return requestsFactory.createParticipantsModel(catalogCode);
					}
				},
				data: {
					 parentState: 'app.requests',
					 displayName: 'REQUESTS.TABS.REQUEST'
				},
				//only users with following accessPrivileges in their role access list can access this route
				// accessPrivileges: ['GetRequestDetails']
				accessInfo: {
					accessPrivileges: ['GetRequestDetails']
				},
				visibleForLinePlan: true
			});

			// Translation
			$translatePartialLoaderProvider.addPart('app/main/catalogs/sub-modules/requests');

			msNavigationServiceProvider.saveItem('catalogs.requests', {
				title: 'Requests',
				icon: 'icon-plus-box',
				state: 'app.requests',
				translate: 'REQUESTS.NAV',
				weight: 25,
				// accessPrivileges: ['GetRequests']
				// accessPrivileges: ['nav_requests']
				accessInfo: {
					accessPrivileges: ['nav_requests']
				},
				visibleForLinePlan: true
			});
		}
})();
(function () {
	'use strict';

	angular
		.module('app.main.catalogs.requests')
		.controller('requestsListController', requestsListController);
	/* @ngInject */
	function requestsListController(api, $rootScope, $scope, $state, catalogFactory, settingsFactory, utility, requestsFactory) {
		/* jshint validthis: true */
		var vm = this;

		var activeCatalogCode = catalogFactory.getActiveCatalog().CatalogCode;
		vm.model = api.catalogs.requests;
		settingsFactory.applyPersistedListViewLayout(vm.model);
		hideShowStopAcceptButton();

		vm.allRequests = [];
		vm.filteredRequests = [];
		vm.isLoading = false;

		vm.refreshItems = refreshItems;
		vm.doListAction = doListAction;
		vm.doItemAction = doItemAction;
		vm.viewItem = viewItem;

		activate();

		////////////////

		function activate() {
			refreshItems(vm.model.isDirty, true);
		}

		function refreshItems(forceFetch, isLogRequired) {
			var generalProperties = {
				forceFetch: forceFetch,
				isLogRequired: isLogRequired
			}
			vm.isLoading = true;
			return vm.model.methods.getList(generalProperties, vm.model, activeCatalogCode)
				.then(function (response) {
					vm.allRequests = requestsFactory.transformRequestResponse(response.data);
				}).finally(function () {
					vm.isLoading = false;
				});
		}

		//Item Action button pressed event
		function doItemAction(action, record) {
			if (action && record) {
				switch (action.id) {
					case 'view':
						viewItem(record);
						break;
						case 'deactivate':
						case 'activate':
								vm.model.methods.activateBulk(record, vm.model, action.id, activeCatalogCode);
								break;
				}
			}
		}

		//List Action button pressed event
		function doListAction(action, records) {
			if (action) {
				switch (action.id) {
					case 'stopRequests':
					case 'acceptRequests':
						vm.model.methods.updateCreateRequestsStatus(activeCatalogCode, action.id)
						.then(function() {
							hideShowStopAcceptButton();
						});
						break;
					case 'deactivate':
					case 'activate':
							vm.model.methods.activateBulk(records, vm.model, action.id, activeCatalogCode);
							break;
				}
			}
		}

		function viewItem(item) {
			var stateParams = { id: item.Id, requestCatalogCode: item.CatalogCode};
			$state.go('app.requests.details', stateParams);
		}

		// Hide/Show actions Stop/Accept Request according to catalogAcceptRequestsStatus
		function hideShowStopAcceptButton() {
			var stopRequestBtn = utility.filterObject(vm.model.views.mainList.listActions, {id: 'stopRequests'}, true)[0];
			var acceptRequestBtn = utility.filterObject(vm.model.views.mainList.listActions, {id: 'acceptRequests'}, true)[0]
			if(catalogFactory.getActiveCatalogDetails().AcceptRequests === 1) {
				stopRequestBtn.visible = true;
				acceptRequestBtn.visible = false;
			} else {
				acceptRequestBtn.visible = true;
				stopRequestBtn.visible = false;
			}
		}

		var catalogChangedEventCleanup = $rootScope.$on('ActiveCatalogChangedEvent', function(e) {
			if(activeCatalogCode !== catalogFactory.getActiveCatalog().CatalogCode) {
					$state.reload('app.requests');
			}
		});
		$scope.$on('$destroy', function () {
				catalogChangedEventCleanup();
		})

	}
})();
(function () {
	'use strict';

	angular
		.module('app.main.catalogs.requests')
		.controller('requestsDetailsController', requestsDetailsController);

	/* @ngInject */
	function requestsDetailsController($state, $stateParams, $rootScope, requestsFactory, settingsFactory, requestDetailsModel, participantsModel, api, $mdDialog, $document, $http) {
		/* jshint validthis: true */
		var vm = this;

		// Data
		var requestId = $stateParams.id;
		var requestCatalogCode = $stateParams.requestCatalogCode;
		vm.requestAuditTrailHistoryLimit = 25;

		vm.model = requestDetailsModel;

		vm.participantsModel = participantsModel;
		settingsFactory.applyPersistedListViewLayout(vm.participantsModel);

		vm.attachmentsModel = api.requests.attachments;
		settingsFactory.applyPersistedListViewLayout(vm.attachmentsModel);

		vm.requestAuditTrailHistoryModel = api.requests.auditTrailHistory;
		settingsFactory.applyPersistedListViewLayout(vm.requestAuditTrailHistoryModel);

		vm.requestData = {};
		vm.participants = [];
		vm.filteredParticipants = [];
		vm.attachments = [];
		vm.filteredAttachments = [];
		vm.requestAuditTrailHistory = [];
		vm.filteredAuditTrailHistory = [];

		vm.isLoading = false;
		vm.isAuditTrailHistoryLoading = false;

		// Methods
		vm.refreshRecord = refreshRecord;
		vm.refreshAuditTrailHistory = refreshAuditTrailHistory;

		vm.doRequestItemAction = doRequestItemAction;
		vm.doParticipantsItemAction = doParticipantsItemAction;
		vm.doParticipantsListAction = doParticipantsListAction;
		vm.doAttachmentsItemAction = doAttachmentsItemAction;
		vm.doAttachmentsListAction = doAttachmentsListAction
		vm.loadMoreAuditHistory = loadMoreAuditHistory;

		activate();

		////////////////

		function activate() {
			refreshRecord(true);
		}

		function refreshRecord(isLogRequired) {
			vm.isLoading = true;

			vm.model.methods.getDetails(isLogRequired, requestId, requestCatalogCode)
				.then(function (response) {
					vm.requestData = requestsFactory.transformRequestDetailsResponse(response.data, vm.model);
					requestCatalogCode = vm.requestData.CatalogCode;
					// transform participants response
					vm.participants = requestsFactory.transformParticipantsResponse(response.data.Participants, 'RequestAttributes', vm.participantsModel.fields);
					vm.attachments = response.data.Attachments;
					angular.forEach(vm.attachments, function(attachment) {
						var fileExtn = attachment.FileName.split('.').pop();
						if(fileExtn.toLowerCase() === 'jpg' || fileExtn.toLowerCase() === 'jpeg' ||
						fileExtn.toLowerCase() === 'png' || fileExtn.toLowerCase() === 'gif' || fileExtn.toLowerCase() === 'bmp') {
							attachment.isImage = true;
						} else {
							attachment.isImage = false;
						}
					})
					vm.title = angular.copy(vm.requestData[vm.model.lookupDisplayField]);

					//Update Breadcrumb
					$state.current.data.displayName = vm.title;
					$rootScope.$broadcast('breadcrumb-updated');
				})
				.finally(function () {
					vm.isLoading = false;
				});
		}

		function doRequestItemAction(action, record) {
			if (action) {
				switch (action.id) {
					case 'view':
						viewAllocationGroupsDetails(record);
						break;
					case 'deactivate':
					case 'activate':
							vm.model.methods.activateBulk(record, vm.model, action.id, requestCatalogCode);
							break;
				}
			}
		}

		function doParticipantsItemAction(action, record) {
			if (action) {
				switch (action.id) {
					case 'deactivate':
					case 'activate':
						vm.participantsModel.methods.activateBulk(record, vm.participantsModel, action.id, requestCatalogCode, requestId);
						break;
				}
			}
		}

		function doParticipantsListAction(action, records) {
			if (action) {
				switch (action.id) {
					case 'deactivate':
					case 'activate':
						vm.participantsModel.methods.activateBulk(records, vm.participantsModel, action.id, requestCatalogCode, requestId);
						break;
				}
			}
		}

		function doAttachmentsItemAction(action, record) {
			if (action) {
				switch (action.id) {
					case 'deactivate':
					case 'activate':
						vm.attachmentsModel.methods.activateBulk(record, vm.attachmentsModel, action.id, requestCatalogCode, requestId);
						break;
					case 'download':
						var URL = record.FilePath;
						var fileName = record.FileName;
						$http.get(URL, {
							responseType: 'arraybuffer',
							headers: {}
						})
						.then(function(response) {
							var blob = new Blob([response.data]);
							var downloadLink = angular.element('<a></a>');
							downloadLink.attr('href', window.URL.createObjectURL(blob));
							downloadLink.attr('download', fileName);
							downloadLink[0].click();
						});

						break;
					case 'viewImage':
						showAttachmentImage(record, null);
						break;
					}
			}
		}

		function doAttachmentsListAction(action, records) {
			if (action) {
				switch (action.id) {
					case 'deactivate':
					case 'activate':
						vm.attachmentsModel.methods.activateBulk(records, vm.attachmentsModel, action.id, requestCatalogCode, requestId);
						break;
				}
			}
		}

		function showAttachmentImage(record, ev) {
			$mdDialog.show({
				controller         : 'viewAttachmentImageController',
				controllerAs       : 'vm',
				templateUrl        : 'app/main/catalogs/sub-modules/requests/details/tabs/attachments/dialogs/view-image/view-image.html',
				parent             : angular.element($document.body),
				targetEvent        : ev,
				clickOutsideToClose: false,
				locals             : {
					model: vm.model,
					record: angular.copy(record),
					event: ev
				}
			}).then(function(saved) {
				if (saved) {
					refreshRecords(true, false);
				}
			});
		}

		function refreshAuditTrailHistory(forceFetch, isLogRequired) {
			var generalProperties = {
					forceFetch: forceFetch,
					isLogRequired: isLogRequired
			}
			vm.isAuditTrailHistoryLoading = true;
			vm.requestAuditTrailHistoryModel.methods.getList(generalProperties, requestId, requestCatalogCode).then(function(response) {
					vm.requestAuditTrailHistory = requestsFactory.formatAuditTrailHistoryData(response.data);
			}).finally(function() {
					vm.isAuditTrailHistoryLoading = false;
			});
		}

		function loadMoreAuditHistory() {
			vm.requestAuditTrailHistoryLimit += 5;
		}

	}
})();
(function () {
    'use strict';

    angular
        .module('app.main.catalogs.reports', [
            'app.main.catalogs.article-status',
            'app.main.catalogs.article-prices'
        ])
        .config(config);

    /* @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
        // State
        $stateProvider.state('app.articles_without_crds', {
            url    : '/articles-without-crds',
            params: {modelPath :'catalogs.articlesWithoutCrds'},
            views  : {
                'content@app': {
                    templateUrl: 'app/main/catalogs/sub-modules/reports/list/reports-list.html',
                    controller : 'reportsListController as vm'
                }
            },
            data: {
                displayName: 'ARTICLES_WITHOUT_CRDS.NAV'
            },
			// accessPrivileges: ['GetArticleListWithMissingCrds']
            // accessPrivileges: ['nav_articles_without_delivery_date']
            accessInfo: {
                accessPrivileges: ['nav_articles_without_delivery_date']
            }
        });

        $stateProvider.state('app.articles_without_images', {
            url    : '/articles-without-images',
            params: {modelPath :'catalogs.articlesWithoutImages'},
            views  : {
                'content@app': {
                    templateUrl: 'app/main/catalogs/sub-modules/reports/list/reports-list.html',
                    controller : 'reportsListController as vm'
                }
            },
            data: {
                displayName: 'ARTICLES_WITHOUT_IMAGES.NAV'
            },
			// accessPrivileges: ['GetArticleListWithMissingImages']
            // accessPrivileges: ['nav_articles_without_images']
            accessInfo: {
                accessPrivileges: ['nav_articles_without_images']
            }
        });

        $stateProvider.state('app.articles_without_sizes', {
            url    : '/articles-without-sizes',
            params: {modelPath :'catalogs.articlesWithoutSizes'},
            views  : {
                'content@app': {
                    templateUrl: 'app/main/catalogs/sub-modules/reports/list/reports-list.html',
                    controller : 'reportsListController as vm'
                }
            },
            data: {
                displayName: 'ARTICLES_WITHOUT_SIZES.NAV'
            },
			// accessPrivileges: ['GetArticleListWithMissingSizes']
            // accessPrivileges: ['nav_articles_without_sizes']
            accessInfo: {
                accessPrivileges: ['nav_articles_without_sizes']
            }
        });

        $stateProvider.state('app.articles_with_dp_account', {
            url    : '/articles-with-dp-account',
            params: {modelPath :'catalogs.articlesWithDpAccount'},
            views  : {
                'content@app': {
                    templateUrl: 'app/main/catalogs/sub-modules/reports/list/reports-list.html',
                    controller : 'reportsListController as vm'
                }
            },
            data: {
                displayName: 'ARTICLES_WITH_DP_ACCOUNT.NAV'
            },
			// accessPrivileges: ['GetArticlesWithDPAccount']
            // accessPrivileges: ['nav_articles_with_dp_account']
            accessInfo: {
                accessPrivileges: ['nav_articles_with_dp_account']
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/catalogs/sub-modules/reports');

         // Navigation
        msNavigationServiceProvider.saveItem('catalogs.reports', {
            title : 'Reports',
            icon  : 'icon-alert-octagon',
            translate: 'NAV.REPORTS',
            weight: 140,
            // accessPrivileges: ['GetArticleListWithMissingCrds','GetArticleListWithMissingImages','GetArticleListWithMissingSizes']
            // accessPrivileges: ['nav_articles_without_delivery_date','nav_articles_without_images','nav_articles_without_sizes']
            accessInfo: {
                accessPrivileges: ['nav_articles_without_delivery_date','nav_articles_without_images','nav_articles_without_sizes']
            }
        });

        msNavigationServiceProvider.saveItem('catalogs.reports.articles_without_crds', {
            title      : 'Articles Without Del. Date',
            subTitle   : 'Reports',
            icon       : 'icon-tile-four',
            state      : 'app.articles_without_crds',
            translate  : 'ARTICLES_WITHOUT_CRDS.NAV',
            weight     : 10,
            // accessPrivileges: ['GetArticleListWithMissingCrds']
            // accessPrivileges: ['nav_articles_without_delivery_date']
            accessInfo: {
                accessPrivileges: ['nav_articles_without_delivery_date']
            }
        });

        msNavigationServiceProvider.saveItem('catalogs.reports.articles_without_images', {
            title      : 'Articles Without Images',
            subTitle   : 'Reports',
            icon       : 'icon-tile-four',
            state      : 'app.articles_without_images',
            translate  : 'ARTICLES_WITHOUT_IMAGES.NAV',
            weight     : 20,
            // accessPrivileges: ['GetArticleListWithMissingImages']
            // accessPrivileges: ['nav_articles_without_images']
            accessInfo: {
                accessPrivileges: ['nav_articles_without_images']
            }
        });

        msNavigationServiceProvider.saveItem('catalogs.reports.articles_without_sizes', {
            title      : 'Articles Without Sizes',
            subTitle   : 'Reports',
            icon       : 'icon-tile-four',
            state      : 'app.articles_without_sizes',
            translate  : 'ARTICLES_WITHOUT_SIZES.NAV',
            weight     : 30,
            // accessPrivileges: ['GetArticleListWithMissingSizes']
            // accessPrivileges: ['nav_articles_without_sizes']
            accessInfo: {
                accessPrivileges: ['nav_articles_without_sizes']
            }
        });

        msNavigationServiceProvider.saveItem('catalogs.reports.articles_with_dp_account', {
            title      : 'Articles With DP Account',
            subTitle   : 'Reports',
            icon       : 'icon-tile-four',
            state      : 'app.articles_with_dp_account',
            translate  : 'ARTICLES_WITH_DP_ACCOUNT.NAV',
            weight     : 40,
            // accessPrivileges: ['GetArticlesWithDPAccount']
            // accessPrivileges: ['nav_articles_with_dp_account']
            accessInfo: {
                accessPrivileges: ['nav_articles_with_dp_account']
            }
        });
    }
})();
(function() {
    'use strict';

	angular
		.module('app.main.catalogs.reports')
		.controller('reportsListController', reportsListController);

	/* @ngInject */
	function reportsListController(api, $rootScope, $scope, $state, $stateParams, catalogFactory, settingsFactory, utility) {
		/* jshint validthis: true */
		var vm = this;


        //Data
        var activeCatalog = catalogFactory.getActiveCatalog();
		var activeCatalogId = activeCatalog.CatalogCode;
        vm.activeCatalogId = activeCatalogId;
        var modelPath = $stateParams.modelPath;
        vm.model = api.getModel(modelPath);
        if(modelPath === 'catalogs.articlesWithoutImages') {
            vm.model = api.catalogs.articlesWithoutDuneImages;
        }
        settingsFactory.applyPersistedListViewLayout(vm.model);

		var currentState = $state.current.name;

		vm.articlesReport = [];
		vm.filteredArticlesReport = [];
		vm.isLoading = false;

        //Methods
		vm.refreshItems = refreshItems;
		vm.viewItem = viewItem;


		activate();

		////////////////

        function activate() {
            refreshItems(vm.model.isDirty, true);
		}

		function refreshItems(forceFetch, isLogRequired) {
            vm.isLoading = true;
            if(modelPath !== 'catalogs.articlesWithoutImages') {
                var generalProperties = {
                    forceFetch: forceFetch,
                    isLogRequired: isLogRequired
                }
                vm.model.methods.getList(generalProperties, activeCatalogId)
                .then(function (response) {
                    vm.articlesReport = response.data;
                })
                .finally(function () {
                    vm.isLoading = false;
                });
            } else if(modelPath === 'catalogs.articlesWithoutImages') {
                var generalProperties = {
                    forceFetch: true,
                    isLogRequired: isLogRequired,
                    config: {},
                    supportIncrementalResult: true,
                    modelIdField: 'Id',
                    isMajor: false,
                }
                var articlesWithImages = [];
                var catalogArticleNumbersArray = [];
                var requestObjet = {};
                api.catalogs.articles.methods.getList(generalProperties, vm.model, vm.activeCatalogId).then(function (articleResponse) {
                    var articleList = articleResponse.data;
                    catalogArticleNumbersArray = catalogFactory.createCatalogArticleNumbersArray(articleResponse.data, true);
                    if(catalogArticleNumbersArray.length > 0) {
                        var articleWithOutImagesList = [];
                        requestObjet = {
                            Type : 'ImageSet',
                            Filter: catalogArticleNumbersArray,
                            Context: catalogFactory.getActiveCatalog().DuneContext,
                            ContextKey: catalogFactory.getCatalogContextKey(),
                            FirstImage: true,
                            Status: true,
                            Op: 'equals'
                        };
                        api.catalogs.t1Dune.methods.getListByFilter(generalProperties, vm.model, requestObjet).then(function (response) {
                            articlesWithImages = response.data;
                            var articleNumbersWithActiveImages = catalogFactory.createCatalogArticleNumbersArray(articlesWithImages);

                            angular.forEach(articleList,function(article) {
                                var articleWithOutImageIndex = articleNumbersWithActiveImages.indexOf(article.ArticleNumber);
                                if(articleWithOutImageIndex === -1) {
                                    articleWithOutImagesList.push(article);
                                }
                            });
                            vm.articlesReport = articleWithOutImagesList;
                        }).finally(function () {
                            vm.isLoading = false;
                        });
                    } else {
                        vm.isLoading = false;
                    }
                });
            }

		}

         function viewItem(item) {
            var id = item[vm.model.idField];
            var stateParams = {id: id};
            $state.go('app.articles.details', stateParams);
		}

        var catalogChangedEventCleanup = $rootScope.$on('ActiveCatalogChangedEvent', function(e) {
            if(activeCatalogId !== catalogFactory.getActiveCatalog().CatalogCode) {
                // vm.model.isDirty = true; // not required since invalidating all the lookups under catalogs on dropdown change (in toolbar controller)
                $state.reload(currentState);
            }
        });
        $scope.$on('$destroy', function () {
            catalogChangedEventCleanup();
        });

	}
})();
(function () {
	'use strict';

	angular
		.module('app.main.catalogs.article-status')
		.run(runBlock);

	/* @ngInject */
	function runBlock(api, activityLogger, $state, catalogFactory) {

		if (angular.isUndefined(api.catalogs)) {
			api.catalogs = {};
		}
		api.catalogs.articleStatus = {
			modelPath: 'catalogs.articleStatus',
			fields: [
				{ field: 'ArticleNumber', map: 'ArticleNumber', type: 'text', displayLabel: 'ARTICLE_STATUS.FIELDS.ARTICLE_NUMBER', visible: true, creatable: true, editable: false, inputType: 'text',
					validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'ArticleId', map:'ArticleId', type: 'int', displayLabel: 'ARTICLE_STATUS.FIELDS.ARTICLE_ID', visible: true, creatable: false, editable: false, inputType: 'number',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
			],
			title: 'ARTICLE_STATUS.NAV',
			icon: 'icon-coin',
			idField: 'ArticleNumber',
			lookupDisplayField: 'ArticleNumber',
			isDirty: false,
			isBulkActionCompleted: false,
			isCatalogSpecificModel: true,
			methods: {
				getList     : getArticleStatus
			},
			views: {
				mainList: {
					columns         : ['ArticleNumber', 'ArticleId'],
					columnFilter    : {},
					topIndex        : 0,
					showFilterRow   : false,
					sortColumn      : {},
					itemActions     : [],
					listActions     : [],
					fabAction       : {}

				 },
				 mainDetails: {},
				privileges: {
					list    : 'ArticlesStatusReport'
				}
			}
		};


		function getArticleStatus(generalProperties, catalogCode) {
				var promise;

				if(angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
						var state = {};
						state.name = $state.current.name;
						state.params = $state.params;
						var isBulk = true;
						var logData = activityLogger.createLogData(null, state, 'catalogs.articleStatus', 'VIEW', isBulk, new Date(), null, null);

						promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/articles/statusreport', undefined, true, generalProperties.forceFetch);
						promise = activityLogger.log(logData, promise);
				}
				else {
						catalogCode = angular.isUndefined(catalogCode) ? catalogFactory.getActiveCatalog().CatalogCode : catalogCode;
						promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/articles/statusreport', undefined, true, generalProperties.forceFetch);
				}

				promise.then(function() {
						if (api.catalogs.articleStatus.isDirty) {
								//Invalidate lookupData
								api.catalogs.articleStatus.lookupData = undefined;
								api.catalogs.articleStatus.isDirty = false;
						}
				});
				return promise;
		}
	}
})();
(function () {
	'use strict';

	angular
		.module('app.main.catalogs.article-prices')
		.run(runBlock);

	/* @ngInject */
	function runBlock(api, activityLogger, $state, catalogFactory) {

		if (angular.isUndefined(api.catalogs)) {
			api.catalogs = {};
		}
		api.catalogs.articlePricesReport = {
			modelPath: 'catalogs.articlePricesReport',
			fields: [
				{ field: 'ArticleNumber', map: 'ArticleNumber', type: 'text', displayLabel: 'ARTICLE_PRICES.FIELDS.ARTICLE_NUMBER', visible: true, creatable: true, editable: false, inputType: 'text',
					validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'ArticleId', map:'ArticleId', type: 'int', displayLabel: 'ARTICLE_PRICES.FIELDS.ARTICLE_ID', visible: true, creatable: false, editable: false, inputType: 'number',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'ModelNumber',  map:'ModelNumber', type: 'text', displayLabel: 'ARTICLE_PRICES.FIELDS.MODEL_NUMBER', visible: true, creatable: true, editable: true, inputType: 'text',
					validation: {isRequired: false, maxLen: 200, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'ArticleName',  map:'ArticleName', type: 'text', displayLabel: 'ARTICLES.FIELDS.MODEL_NAME', visible: true, creatable: true, editable: true, inputType: 'text',
					validation: {isRequired: true, maxLen: 100, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
			],
			title: 'ARTICLE_PRICES.NAV',
			icon: 'icon-coin',
			idField: 'ArticleId',
			lookupDisplayField: 'ArticleName',
			isDirty: false,
			isBulkActionCompleted: false,
			isCatalogSpecificModel: true,
			methods: {
				getList     : getArticlePrices
			},
			views: {
				mainList: {
					columns         : ['ArticleId', 'ArticleNumber', 'ArticleName', 'ModelNumber'],
					columnFilter    : {},
					topIndex        : 0,
					showFilterRow   : false,
					sortColumn      : {},
					itemActions     : [],
					listActions     : [],
					fabAction       : {}

				 },
				 mainDetails: {},
				 privileges: {
					list    : 'ArticlesPriceReport'
				}
			}
		};


		function getArticlePrices(generalProperties, catalogCode) {
				var promise;

				if(angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
						var state = {};
						state.name = $state.current.name;
						state.params = $state.params;
						var isBulk = true;
						var logData = activityLogger.createLogData(null, state, 'catalogs.articlePricesReport', 'VIEW', isBulk, new Date(), null, null);

						promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/articles/pricereport', undefined, true, generalProperties.forceFetch);
						promise = activityLogger.log(logData, promise);
				}
				else {
						catalogCode = angular.isUndefined(catalogCode) ? catalogFactory.getActiveCatalog().CatalogCode : catalogCode;
						promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/articles/pricereport', undefined, true, generalProperties.forceFetch);
				}

				promise.then(function() {
						if (api.catalogs.articlePricesReport.isDirty) {
								//Invalidate lookupData
								api.catalogs.articlePricesReport.lookupData = undefined;
								api.catalogs.articlePricesReport.isDirty = false;
						}
				});
				return promise;
		}
	}
})();
(function () {
	'use strict';

	angular
		.module('app.main.catalogs.prices-linear')
		.controller('pricesLinearListController', pricesLinearListController);

	/* @ngInject */
	function pricesLinearListController(api, $rootScope, $scope, $state, $document, catalogFactory, dataImporter, catalogSpecificPricesModel, $timeout, settingsFactory, $mdDialog, utility, SecurityFactory, CONSTANTS) {
		/* jshint validthis: true */
		var vm = this;


		//Data
		var activeCatalog = catalogFactory.getActiveCatalog();
		var activeCatalogId = activeCatalog.CatalogCode;
		vm.activeCatalogId = activeCatalogId;

		vm.model = catalogSpecificPricesModel;
		settingsFactory.applyPersistedListViewLayout(vm.model);
		var activieCatalogPriceGroupList = catalogFactory.getActiveCatalogDetails().CatalogPriceGroupList;

		vm.prices = [];
		vm.filteredPrices = [];
		vm.isLoading = false;
		var timeoutPromise;


		//Methods
		vm.refreshItems = refreshItems;
		vm.doItemAction = doItemAction;
		vm.doListAction = doListAction;
		vm.viewItem = viewItem;

		activate();

		////////////////

		function activate() {
			refreshItems(vm.model.isDirty, true);
		}

		function refreshItems(forceFetch, isLogRequired) {
			vm.prices = [];
			vm.isLoading = true;
			var generalProperties = {
				forceFetch: forceFetch,
				isLogRequired: isLogRequired,
				config: {},
				supportIncrementalResult: true,
				modelIdField: 'ArticleNumber',
				isMajor: false,
		}
			timeoutPromise = $timeout(function () {
				vm.model.methods.getList(generalProperties, vm.model, activeCatalogId)
					.then(function (response) {
						var responseData = [];
						var modelNumberMap = {};
						angular.forEach(response.data, function (article) {
							if (angular.isDefined(article.Prices) && article.Prices.length > 0 && (activeCatalog.DataSourceTypeId !== 3 || article.Status === 1)) {
									angular.forEach(article.Prices, function (price) {
											// Filter price groups that meet the conditions
											var index = activieCatalogPriceGroupList.indexOf(
													utility.filterObject(activieCatalogPriceGroupList, { Id: price.PriceGroupId, Status: 1 }, true)[0]
											);

											if (index !== -1) {
													var priceItem = {
															ArticleId: article.Id,
															ArticleNumber: article.ArticleNumber,
															ArticleName: article.ArticleName,
															ModelNumber: article.ModelNumber,
															Locked: article.Locked,
															Status: article.Status,
															StateId: article.StateId,
															StateRank: article.StateRank,
															PriceGroupId: price.PriceGroupId,
															Price: price.Price,
															Id: price.Id,
															CreatedDate: price.CreatedDate,
															UpdatedDate: price.UpdatedDate,
															IsEditable: price.IsEditable,
															isEditDisable: article.Locked && activeCatalog.ArticleLocking === 1 ? 1 : 0,
															readOnly: price.IsEditable === 0 ? true : false,
															isMandatory: price.IsMandatory === 1 ? true : false
													};

													if (activeCatalog.IsPriceByStyleApply === 1) {
														if (!priceItem.ModelNumber) {
															priceItem.isEditDisable = 1;
														} else {
															if (modelNumberMap[priceItem.ModelNumber] === undefined) {
																var modelNumberArticleList = utility.filterObject(response.data, { ModelNumber: priceItem.ModelNumber, Locked: 1 }, true);
																modelNumberMap[priceItem.ModelNumber] = modelNumberArticleList.length && activeCatalog.ArticleLocking === 1 ? 1 : 0;
															}
															priceItem.isEditDisable = modelNumberMap[priceItem.ModelNumber];
														}
													}

													responseData.push(priceItem);
											}
									});
							}
						});

					vm.prices = responseData;
			})
			.finally(function () {
					vm.isLoading = false;
			});
			}, 500);
		}

		//Item Action button pressed event
		function doItemAction(action, record) {
			if (action && record) {
				switch (action.id) {
					case 'view':
						viewItem(record);
						break;
					case 'edit':
						editItem(record, null);
						break;
				}
			}
		}

		//User can select different articles prices
		function doListAction(action, records) {
			if (action) {
				switch (action.id) {
					case 'import':
						var modelCopy = angular.copy(vm.model);
						modelCopy.uniqueConstraints = [
							{name: 'Constraint 1', fields: ['ArticleNumber', 'PriceGroupId']}
						]
						if(activeCatalog.IsPriceByStyleApply === 1) {
							var modelNumberField = utility.filterObject(modelCopy.fields, {field: 'ModelNumber'}, true)[0];
							if(modelNumberField) {
								modelNumberField.visible = true;
								modelNumberField.creatable = true;
							}
							var articleNumberField = utility.filterObject(modelCopy.fields, {field: 'ArticleNumber'}, true)[0];
							if(articleNumberField) {
								articleNumberField.creatable = false;
							}
							modelCopy.uniqueConstraints = [
									{name: 'Constraint 1', fields: ['ModelNumber', 'PriceGroupId']}
							]
						}
						// // for prices if they are not editable (priceGroups IsEditable is 0) field dynamically marked as readOnly true and they should not be present in column mapper (they should not be importable)
						// angular.forEach(modelCopy.fields, function (field) {
						// 	if (field.isCatalogProperty === true && field.readOnly === true) {
						// 		field.creatable = false;
						// 	}
						// 	if (field.field.toLowerCase() === 'price') {
						// 		field.validation.pattern = '^[+]?\\d+([.]\\d{0,'+ api.numberOfDecimalsForPrices +'})?$';
						// 		field.validation.messages.pattern = 'Invalid price value, Should be a positive number and not contain more than '+ api.numberOfDecimalsForPrices +' decimals.';
						// 	}
						// });
						dataImporter.importExcel(modelCopy, true, { validateArticleLocking: activeCatalog.ArticleLocking === 1 }, action.id).then(function (result) {
							if (result.data) {
								vm.model.methods.createBulk(result, activeCatalog, vm.model);
							}
						});
						break;
				}
			}
		}

		function viewItem(record) {
			var id = record.ArticleId;
			var stateParams = { id: id, tab: 'PRICES' };
			$state.go('app.articles.details', stateParams);
		}

		function editItem(record, ev) {
			$mdDialog.show({
				controller: 'updatePricesLinearController',
				controllerAs: 'vm',
				templateUrl: 'app/main/catalogs/sub-modules/prices-linear/dialogs/update-prices-linear/update-prices-linear.html',
				parent: angular.element($document.body),
				targetEvent: ev,
				clickOutsideToClose: false,
				locals: {
					model: vm.model,
					record: record,
					activeCatalog: activeCatalog
				}
			}).then(function (saved) {
				if (saved) {
					refreshItems(true, false);
				}
			});
		}

		var catalogChangedEventCleanup = $rootScope.$on('ActiveCatalogChangedEvent', function (e) {
			if (activeCatalogId !== catalogFactory.getActiveCatalog().CatalogCode) {
				$state.reload('app.prices_linear');
			}
		});

		$scope.$on('$destroy', function () {
			catalogChangedEventCleanup();
			$timeout.cancel(timeoutPromise);
		});

	}
})();
(function() {
    'use strict';

	angular
		.module('app.main.catalogs.prices')
		.controller('pricesListController', pricesListController);

	/* @ngInject */
	function pricesListController(api, $rootScope, $scope, $state, $document, catalogFactory, catalogSpecificPricesModel, dataImporter,
        bulkUpdater, $timeout, settingsFactory, $mdDialog, utility, SecurityFactory, CONSTANTS, crud) {
		/* jshint validthis: true */
		var vm = this;


        //Data
        var activeCatalog = catalogFactory.getActiveCatalog();
		var activeCatalogId = activeCatalog.CatalogCode;
        vm.activeCatalogId = activeCatalogId;

        // check the special privilege is assigned to the user for updating the state. if then does not vaidate editable fields
        var isSpecialPermissionToIgnoreArticleStateIsAssigned = SecurityFactory.isAuthorized({accessPrivileges: CONSTANTS.PRIVILEGES.ARTICLES.SPECIAL_PRIVILEGE_TO_SKIP_STATE_VALIDATION});
        vm.updatePricesChangeManagementExternalURL = '';
        var catalogPriceGroupList = catalogFactory.getActiveCatalogDetails().CatalogPriceGroupList;

        vm.model = catalogSpecificPricesModel;
        settingsFactory.applyPersistedListViewLayout(vm.model);

		vm.prices = [];
		vm.filteredPrices = [];
		vm.isLoading = false;
        var timeoutPromise;


		//Methods
		vm.refreshItems = refreshItems;
		vm.doItemAction = doItemAction;
        vm.doListAction = doListAction;
		vm.viewItem = viewItem;

		activate();

		////////////////

        function activate() {
            refreshItems(vm.model.baseModel.isDirty, true);
            api.webGet('/app/app.config.json').then(function(response) {
                if (angular.isDefined(response) && angular.isDefined(response.data)) {
                    if(angular.isDefined(response.data['updatePricesChangeManagementExternalURL']) && response.data['updatePricesChangeManagementExternalURL'].length) {
                        vm.updatePricesChangeManagementExternalURL = response.data['updatePricesChangeManagementExternalURL'];
                    }
                }
            });
        }

        function refreshItems(forceFetch, isLogRequired) {
            vm.isLoading = true;
            var generalProperties = {
                forceFetch: forceFetch,
                isLogRequired: isLogRequired,
                config: {},
                supportIncrementalResult: true,
                modelIdField: 'Id',// it should be outerObject Id
                isMajor: false,
                isArticleRelatedData: true,
                nestedArrayName: 'Prices',
                nestedDataIdField: 'Id'//it should be nestedObject Id
            }
            timeoutPromise = $timeout(function () {// TODO - need to change GET method catching mechanism (since the data is catched controll goes to then part imidiatly and transform function freezes the UI)
                vm.model.methods.getList(generalProperties, vm.model, activeCatalogId)
                    .then(function (response) {
                        vm.prices = catalogFactory.transformPricesResponse(response.data, 'Prices', vm.model.fields);
                    })
                    .finally(function () {
                        vm.isLoading = false;
                    });
            }, 500);
        }

		//Item Action button pressed event
		function doItemAction(action, record) {
			if (action && record) {
                switch (action.id) {
                    case 'view':
                        viewItem(record);
                        break;
                    case 'edit':
                        editItem(record, null);
                        break;
                }
			}
		}

        //User can select different articles prices
        function doListAction(action, records) {
            if (action) {
                switch (action.id) {
                    case 'import':
                        var modelCopy = angular.copy(vm.model);
                        // for prices if they are not editable (priceGroups IsEditable is 0) field dynamically marked as readOnly true and they should not be present in column mapper (they should not be importable)
                        angular.forEach(modelCopy.fields, function (field) {
                            if (field.isCatalogProperty === true) {
                                if(field.readOnly === true) {
                                    field.creatable = false;
                                }
                                if(field.isMandatory ) {
                                    field.validation.isRequired = true;
                                    field.validation.pattern = '^[+]?((\\d*[1-9]\\d*)([.]\\d{0,' + api.numberOfDecimalsForPrices + '})?)$'
                                    field.validation.messages.pattern = 'Invalid price value, Should be greater than 0 with no more than '+ api.numberOfDecimalsForPrices +' decimals.';
                                }
                                else {
                                    field.validation.pattern = '^[+]?\\d+([.]\\d{0,'+ api.numberOfDecimalsForPrices +'})?$';
                                    field.validation.messages.pattern = 'Invalid price value, Should be a positive number and not contain more than '+ api.numberOfDecimalsForPrices +' decimals.';
                                }
                            }
                        });
                        dataImporter.importExcel(modelCopy, true, { validateArticleLocking: activeCatalog.ArticleLocking === 1 }, action.id).then(function (result) {
                            if(result.data) {
                                vm.model.methods.createBulk(result, activeCatalog, vm.model);
                            }
                        });
                        break;
                    case 'updateBulk':
                        var modelCopy = angular.copy(vm.model);
                        // if state is assigned for any one of article then make the highest rank model states non editable attrbutes as non editable
                        // check if model level state rank is assigned and value greater than zero then we will consider that
                        // if article is assigned with model state rank as zero and state's state rank is higher than the other articles model state rank will use states's state rank
                        if(!isSpecialPermissionToIgnoreArticleStateIsAssigned) {
                            if(activeCatalog.IsPriceByStyleApply) {
                                var articleWithHeightModelStateRank = records.reduce(function(prev, current) {
                                    return (prev.ModelStateRank > current.ModelStateRank) ? prev : current;
                                });
                                if(articleWithHeightModelStateRank && articleWithHeightModelStateRank.ModelStateId !== 0) {
                                    var assignedState = utility.filterObject(api.articleStatesList, {StateId: articleWithHeightModelStateRank.ModelStateId}, true)[0];
                                    angular.forEach(modelCopy.fields, function(field) {
                                        if(angular.isDefined(field.priceGroupId)) {
                                            var assignedPriceGroup = utility.filterObject(catalogPriceGroupList, {Id: field.priceGroupId}, true)[0];
                                            if(assignedState && (assignedPriceGroup && angular.isDefined(assignedPriceGroup.StateRank) && assignedPriceGroup.StateRank !== null)) {
                                                if(assignedState.StateRank >= assignedPriceGroup.StateRank) {
                                                    field.priceGroupNonEditable = true;
                                                    field.editable = false;
                                                    field.showInEdit = true;
                                                    field.isBulkEditable = false;
                                                    if(assignedPriceGroup.AllowChangeRequestForPriceGroups && vm.updatePricesChangeManagementExternalURL !== '') {
                                                        field.isAllowChangeRequestEnabled = true;
                                                    }
                                                }
                                            }
                                        }
                                    });
                                }
                            } else {
                                var articleWithHeightStateRank = records.reduce(function(prev, current) {
                                    return (prev.StateRank > current.StateRank) ? prev : current;
                                });
                                if(articleWithHeightStateRank && articleWithHeightStateRank.StateId !== 0) {
                                    var assignedState = utility.filterObject(api.articleStatesList, {StateId: articleWithHeightStateRank.StateId}, true)[0];
                                    angular.forEach(modelCopy.fields, function(field) {
                                        if(angular.isDefined(field.priceGroupId)) {
                                            var assignedPriceGroup = utility.filterObject(catalogPriceGroupList, {Id: field.priceGroupId}, true)[0];
                                            if(assignedState && (assignedPriceGroup && angular.isDefined(assignedPriceGroup.StateRank) && assignedPriceGroup.StateRank !== null)) {
                                                if(assignedState.StateRank >= assignedPriceGroup.StateRank) {
                                                    field.priceGroupNonEditable = true;
                                                    field.editable = false;
                                                    field.showInEdit = true;
                                                    field.isBulkEditable = false;
                                                    if(assignedPriceGroup.AllowChangeRequestForPriceGroups && vm.updatePricesChangeManagementExternalURL !== '') {
                                                        field.isAllowChangeRequestEnabled = true;
                                                    }
                                                }
                                            }
                                        }
                                    });
                                }
                            }
                        }
                        angular.forEach(modelCopy.fields, function (field) {
                            if (field.isCatalogProperty === true) {
                                if(field.isMandatory) {
                                    field.validation.isRequired = true;
                                    field.validation.pattern = '^[+]?((\\d*[1-9]\\d*)([.]\\d{0,' + api.numberOfDecimalsForPrices + '})?)$'
                                    field.validation.messages.pattern = 'Invalid price value, Should be greater than 0 with no more than '+ api.numberOfDecimalsForPrices +' decimals.';
                                }
                                else {
                                    field.validation.pattern = '^[+]?\\d+([.]\\d{0,'+ api.numberOfDecimalsForPrices +'})?$';
                                    field.validation.messages.pattern = 'Invalid price value, Should be a positive number and not contain more than '+ api.numberOfDecimalsForPrices +' decimals.';
                                }
                            }
                        });
                        var lookupPromises = {};
                        lookupPromises = crud.createLookupPromise(modelCopy, undefined , 'edit');
                        bulkUpdater.showDialog(modelCopy, vm.prices, { 'catalogId': activeCatalogId }, lookupPromises);
                        break;
                }
            }
        }

         function viewItem(record) {
            var id = record.ArticleId;
            var stateParams = {id: id, tab: 'PRICES'};
            $state.go('app.articles.details', stateParams);
		}

        function editItem(record, ev) {
            var modelCopy = angular.copy(vm.model);
            // check if the article state rank is greater that or equal to price group state rank if yes then make the price non editable
            if(!isSpecialPermissionToIgnoreArticleStateIsAssigned && record.StateId != null && record.ModelStateId != null) {
                if(activeCatalog.IsPriceByStyleApply) {
                    var assignedModelState = utility.filterObject(api.articleStatesList, {StateId: record.ModelStateId}, true)[0];
                    angular.forEach(modelCopy.fields, function(field) {
                        if(angular.isDefined(field.priceGroupId)) {
                            var assignedPriceGroup = utility.filterObject(catalogPriceGroupList, {Id: field.priceGroupId}, true)[0];
                            if(assignedModelState && (assignedPriceGroup && angular.isDefined(assignedPriceGroup.StateRank) && assignedPriceGroup.StateRank !== null)) {
                                if(assignedModelState.StateRank >= assignedPriceGroup.StateRank) {
                                    field.priceGroupNonEditable = true;
                                    if(assignedPriceGroup.AllowChangeRequestForPriceGroups && vm.updatePricesChangeManagementExternalURL !== '') {
                                        field.isAllowChangeRequestEnabled = true;
                                    }
                                }
                            }
                        }
                    });
                } else {
                    var assignedArticleState = utility.filterObject(api.articleStatesList, {StateId: record.StateId}, true)[0];
                    angular.forEach(modelCopy.fields, function(field) {
                        if(angular.isDefined(field.priceGroupId)) {
                            var assignedPriceGroup = utility.filterObject(catalogPriceGroupList, {Id: field.priceGroupId}, true)[0];
                            if(assignedArticleState && (assignedPriceGroup && angular.isDefined(assignedPriceGroup.StateRank) && assignedPriceGroup.StateRank !== null)) {
                                if(assignedArticleState.StateRank >= assignedPriceGroup.StateRank) {
                                    field.priceGroupNonEditable = true;
                                    if(assignedPriceGroup.AllowChangeRequestForPriceGroups && vm.updatePricesChangeManagementExternalURL !== '') {
                                        field.isAllowChangeRequestEnabled = true;
                                    }
                                }
                            }
                        }
                    });
                }
            }

            $mdDialog.show({
                controller: 'updatePricesController',
                controllerAs: 'vm',
                templateUrl: 'app/main/catalogs/sub-modules/prices/dialogs/update-prices/update-prices.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: false,
                locals: {
                    model: modelCopy,
                    record: record,
                    activeCatalog: activeCatalog
                }
            }).then(function (saved) {
                if (saved) {
                    refreshItems(true, false);
                }
            });
        }

        var catalogChangedEventCleanup = $rootScope.$on('ActiveCatalogChangedEvent', function(e) {
            if(activeCatalogId !== catalogFactory.getActiveCatalog().CatalogCode) {
                $state.reload('app.prices');
            }
        });
        $scope.$on('$destroy', function () {
            catalogChangedEventCleanup();
            $timeout.cancel(timeoutPromise);
        });

	}
})();
(function() {
    'use strict';

    angular
        .module('app.main.catalogs.packages', [
            'app.main.catalogs.packages.packageErrors'
        ])
        .config(config);

    /* @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {

        $stateProvider.state('app.packages', {
            url    : '/packages',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/catalogs/sub-modules/packages/list/packages-list.html',
                    controller : 'packagesListController as vm'
                }
            },
            resolve: {
                packageModel: function (catalogFactory, api) {
                    var activeCatalog = catalogFactory.getActiveCatalog();
                    var catalogIsLive = activeCatalog.IsLive;
                    var packageModel = angular.copy(api.catalogs.packages);
                    if(catalogIsLive === 1) {
                        packageModel.views.mainList.fabAction.visible = false;
                    }
                    return packageModel;
                }
            },
            data: {
                displayName: 'PACKAGES.NAV'
            },
			// accessPrivileges: ['GetCatalogDataUpdateList']
            // accessPrivileges: ['nav_packages']
            accessInfo: {
                accessPrivileges: ['nav_packages']
            },
            visibleForLinePlan: true
        });

        $stateProvider.state('app.packages.details', {
			url	 : '/:id',
            params: {package: undefined},
            views: {
				'content@app': {
					templateUrl: 'app/main/catalogs/sub-modules/packages/details/packages-details.html',
					controller : 'packageDetailsController as vm'
				}
			},
			data: {
				parentState: 'app.packages',
                displayName: 'PACKAGES.TABS.PACKAGE'
			},
            resolve: {
            },
            // accessPrivileges: ['GetCatalogDataUpdateDetails']
            accessInfo: {
                accessPrivileges: ['GetCatalogDataUpdateDetails']
            },
            visibleForLinePlan: true
		});

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/catalogs/sub-modules/packages');

        // Navigation
        msNavigationServiceProvider.saveItem('catalogs.packages', {
            title      : 'Packages',
            icon       : 'icon-package-variant',
            state      : 'app.packages',
            translate  : 'PACKAGES.NAV',
            weight     : 130,
            // accessPrivileges: ['GetCatalogDataUpdateList']
            // accessPrivileges: ['nav_packages'],
            accessInfo: {
                accessPrivileges: ['nav_packages']
            },
            visibleForLinePlan: true
        });
    }

})();
(function() {
	'use strict';

	angular
		.module('app.main.catalogs.packages')
		.controller('packagesListController', packagesListController);

	/* @ngInject */
	function packagesListController(api, $rootScope, $scope, $state, catalogFactory, dialog, settingsFactory, packageModel) {
		/* jshint validthis: true */
		var vm = this;

		//Data
		var activeCatalog = catalogFactory.getActiveCatalog();
		var catalogCode = activeCatalog.CatalogCode;
		var sellerId = activeCatalog.AccountId;

		vm.model = packageModel;
		settingsFactory.applyPersistedListViewLayout(vm.model);

		vm.packages = [];
		vm.filteredPackages = [];
		vm.isLoading = false;


		//Methods
		vm.refreshRecords = refreshRecords;
		vm.doItemAction = doItemAction;
		vm.viewRecord = viewRecord;
		vm.publishRecord = publishRecord;

		activate();

		////////////////

		function activate() {
			refreshRecords(vm.model.isDirty, true);
		}

		function refreshRecords(forceFetch, isLogRequired) {
			vm.isLoading = true;
			var generalProperties = {
					forceFetch: forceFetch,
					isLogRequired: isLogRequired
			}
			vm.model.methods.getList(generalProperties, vm.model, catalogCode)
			.then(function (response) {
				vm.packages = response.data;
			})
			.finally(function () {
				vm.isLoading = false;
			});
		}

		//Item Action button pressed event
		function doItemAction(action, record) {
			if (action && record) {
				switch (action.id) {
					case 'view':
						viewRecord(record);
						break;
				}
			}
		}

		function viewRecord(record) {
			var id = record[vm.model.idField];
			var stateParams = {id: id};
			$state.go('app.packages.details', stateParams);
		}

		function publishRecord(ev, action) {
			dialog.confirm(action.confirmationContent, action.confirmationAction)
				.then(function(response) {
						if(response.userAction.toLowerCase() === 'confirm') {
							vm.model.methods.publish(vm.model, {'SellerAccountId': sellerId}, activeCatalog, catalogCode).then(function(response) {
								vm.packages.splice(vm.packages.length, 1, response.data);
							});
						}
				});
		}

		var catalogChangedEventCleanup = $rootScope.$on('ActiveCatalogChangedEvent', function(e) {
			if(catalogCode !== catalogFactory.getActiveCatalog().CatalogCode) {
				$state.reload('app.packages');
			}
		});
		$scope.$on('$destroy', function () {
				catalogChangedEventCleanup();
		});

	}
})();
(function() {
	'use strict';

	angular
		.module('app.main.catalogs.packages')
		.controller('packageDetailsController', packageDetailsController);

	/* @ngInject */
	function packageDetailsController(api, $stateParams, $state, $rootScope, $mdDialog, $filter, $translate, settingsFactory) {
		/* jshint validthis: true */
		var vm = this;

		//Data
		var packageId = $stateParams.id;

		vm.filteredErrors = [];
		vm.isLoading = false;

		vm.model = api.catalogs.packages;
		settingsFactory.applyPersistedListViewLayout(vm.model);

		vm.errorsModel = api.catalogs.packageErrors;
		settingsFactory.applyPersistedListViewLayout(vm.errorsModel);

		vm.package = {};
		vm.title = vm.package[vm.model.lookupDisplayField];

		//Methods
		vm.doErrorsItemAction = doErrorsItemAction;
		vm.viewError = viewError;
		vm.refreshRecord = refreshRecord;

		activate();

		////////////////

		function activate() {
			refreshRecord(true);
		}

		function refreshRecord(isLogRequired) {
			vm.isLoading = true;

			vm.model.methods.getDetails(packageId, isLogRequired)
				.then(function (response) {
						vm.package = response.data;
						vm.title = '';
						$translate('PACKAGES.TITLE').then(function (translation) {
								vm.title = translation + packageId;
								//Update Breadcrumb
								$state.current.data.displayName = vm.title;
								$rootScope.$broadcast('breadcrumb-updated');
						});
				})
				.finally(function () {
						vm.isLoading = false;
				});
		}

		function doErrorsItemAction(action, item) {
			if (action && item) {
				switch (action.id) {
					case 'view':
						viewError(item);
						break;
				}
			}
		}

		function viewError(item) {
			$mdDialog.show(
				$mdDialog.confirm()
						.title($filter('translate')('PACKAGES.ERROR_MESSAGE'))
						.textContent(item.ErrorMessage)
						.ariaLabel($filter('translate')('PACKAGES.ERROR'))
						.ok('Ok')
			);
		}
	}
})();
(function () {
	'use strict';

	angular
		.module('app.main.catalogs.orders-terms-conditons')
		.controller('ordersTermsConditionsListController', ordersTermsConditionsListController);

	/* @ngInject */
	function ordersTermsConditionsListController(api, $rootScope, $scope, $state, catalogFactory, settingsFactory, $mdDialog, $document) {
		/* jshint validthis: true */
		var vm = this;

		//Data
		var activeCatalog = catalogFactory.getActiveCatalog();
		var catalogCode = activeCatalog.CatalogCode;

		vm.model = api.catalogs.ordersTermsConditions;
		settingsFactory.applyPersistedListViewLayout(vm.model);

		vm.termsAndConditions = [];
		vm.filteredTtermsAndConditions = [];
		vm.isLoading = false;


		//Methods
		vm.refreshItems = refreshItems;
		vm.doListAction = doListAction;
		vm.doItemAction = doItemAction;
		vm.viewItem = viewItem;
		vm.addRecord = addRecord;

		activate();

		////////////////

		function activate() {
			refreshItems(vm.model, true);
		}

		function refreshItems(forceFetch, isLogRequired) {
			vm.isLoading = true;
			var generalProperties = {
				forceFetch: forceFetch,
				isLogRequired: isLogRequired
			}
			vm.model.methods.getList(generalProperties, vm.model, catalogCode)
				.then(function (response) {
					vm.termsAndConditions = response.data;
				})
				.finally(function () {
					vm.isLoading = false;
				});
		}

		//Item Action button pressed event
		function doItemAction(action, record) {
			if (action && record) {
				switch (action.id) {
					case 'view':
						viewItem(record);
						break;
					case 'delete':
					case 'activate':
							vm.model.methods.activate(record, vm.model, action.id, catalogCode);
						break;
					case 'copyFrom':
							doCopyFrom(record);
						break;
				}
			}
		}

		//List Action button pressed event
		function doListAction(action, records) {
			if (action) {
				switch (action.id) {
					case 'delete':
					case 'activate':
						vm.model.methods.activate(records, vm.model, action.id, catalogCode);
						break;
				}
			}
		}

		function viewItem(item) {
			var stateParams = { id: item[vm.model.idField] };
			$state.go('app.orders_terms_conditions.details', stateParams);
		}

		function doCopyFrom(record) {
			$mdDialog.show({
				controller: 'createOrderTermsAndConditionsController',
				controllerAs: 'vm',
				templateUrl: 'app/main/catalogs/sub-modules/orders-terms-conditions/dialogs/create-terms-conditions/create-terms-conditions.html',
				parent: angular.element($document.body),
				targetEvent: null,
				clickOutsideToClose: false,
				locals: {
					event: null,
					model: vm.model,
					record: angular.copy(record),
					isCopyTermsAndConditions: true
				}
			}).then(function (saved) {
				if (saved) {
					refreshItems(true, false);
				}
			});
		}

		function addRecord(ev) {
			$mdDialog.show({
				controller: 'createOrderTermsAndConditionsController',
				controllerAs: 'vm',
				templateUrl: 'app/main/catalogs/sub-modules/orders-terms-conditions/dialogs/create-terms-conditions/create-terms-conditions.html',
				parent: angular.element($document.body),
				targetEvent: ev,
				clickOutsideToClose: false,
				locals: {
					event: ev,
					model: vm.model,
					record: undefined,
					isCopyTermsAndConditions: false
				}
			}).then(function (saved) {
				if (saved) {
					refreshItems(true, false);
				}
			});
		}

		var catalogChangedEventCleanup = $rootScope.$on('ActiveCatalogChangedEvent', function (e) {
			if (catalogCode !== catalogFactory.getActiveCatalog().CatalogCode) {
				$state.reload('app.orders_terms_conditions');
			}
		});

		$scope.$on('$destroy', function () {
			catalogChangedEventCleanup();
		});

	}
})();
(function () {
	'use strict';

	angular
		.module('app.main.catalogs.orders-terms-conditons')
		.controller('ordersTermsConditionsDetailsController', ordersTermsConditionsDetailsController);

	/* @ngInject */
	function ordersTermsConditionsDetailsController($document, api, $state, $rootScope, $stateParams, $mdDialog, catalogFactory) {
		/* jshint validthis: true */
		var vm = this;

		// the page was crashed on copying content from wiki
		// Data
		var Id = $stateParams.id;
		vm.model = api.catalogs.ordersTermsConditions;
		var activeCatalog = catalogFactory.getActiveCatalog();
		var catalogCode = activeCatalog.CatalogCode;

		vm.record = {};
		vm.isLoading = false;

		// Methods
		vm.refreshRecord = refreshRecord;
		vm.copyPrivacyPolicy = copyPrivacyPolicy;
		activate();

		vm.editorConfig = {
			toolbar: false
		}

		////////////////

		function activate() {
			refreshRecord(true);
		}

		function refreshRecord(isLogRequired) {
			vm.isLoading = true;

			vm.model.methods.getDetails(isLogRequired, Id, catalogCode)
				.then(function (response) {
					vm.record = response.data;
					vm.title = angular.copy(vm.record[vm.model.lookupDisplayField]);

					//Update Breadcrumb
					$state.current.data.displayName = vm.title;
					$rootScope.$broadcast('breadcrumb-updated');
				})
				.finally(function () {
					vm.isLoading = false;
				});
		}

		function copyPrivacyPolicy(ev) {
			$mdDialog.show({
				controller: 'createOrderTermsAndConditionsController',
				controllerAs: 'vm',
				templateUrl: 'app/main/catalogs/sub-modules/orders-terms-conditions/dialogs/create-terms-conditions/create-terms-conditions.html',
				parent: angular.element($document.body),
				targetEvent: ev,
				clickOutsideToClose: false,
				locals: {
					event: ev,
					model: vm.model,
					record: vm.record,
					isCopyTermsAndConditions: true
				}
			}).then(function (saved) {
				if (saved) {
					$state.go('app.orders_terms_conditions');
				}
			});
		}

	}
})();
(function() {
    'use strict';

    angular
        .module('app.main.catalogs.orders')
        .controller('ordersListController', ordersListController);

    /* @ngInject */
    function ordersListController(api, $rootScope, $scope, $state, $document, utility, catalogFactory, ordersDialog, dataImporter, settingsFactory,
                                    orderlineExporter, orderModel, errorDialog) {
        /* jshint validthis: true */
        var vm = this;

        //Data
        var activeCatalog = catalogFactory.getActiveCatalog();
        var catalogCode = activeCatalog.CatalogCode;

        vm.model = orderModel;
        settingsFactory.applyPersistedListViewLayout(vm.model);

        vm.orders = [];
        vm.filteredOrders = [];
        vm.isLoading = false;
        vm.activeCustomers = [];
        vm.customerRequiredDateValidation = {};
        var isCustomerRequiredDateValidationAdded = false;


        //Methods
        vm.refreshItems = refreshItems;
        vm.doListAction = doListAction;
        vm.doItemAction = doItemAction;
        vm.doProcessOrderListAction = doProcessOrderListAction;
        vm.doProcessOrderItemAction = doProcessOrderItemAction;
        vm.viewItem = viewItem;
        vm.addRecord = addRecord;

        activate();

        ////////////////

        function activate() {
            if(!activeCatalog.IsStockApply) {
                getAndSetCustomerRequiredDateValidation();
            }
            refreshItems(vm.model.isDirty, true);
        }

        function refreshItems(forceFetch, isLogRequired) {
            vm.isLoading = true;
            var generalProperties = {
                forceFetch: forceFetch,
                isLogRequired: isLogRequired
            }
            vm.model.methods.getList(generalProperties, vm.model, catalogCode)
            .then(function (response) {
                vm.orders = response.data;
                //following properties are added inorder to making order process actions disable status controlled by model
                angular.forEach(vm.orders, function(order) {
                    order['UseOrderType'] = catalogFactory.getUseOrderType();
                    order['UseConfirmOrder'] = catalogFactory.getUseConfirmOrder();
                    if(order['RejectedQuantity']) { // mark orders with rejectedQuantity red
                        order['warn'] = true;
                    }
                    order.isReopenOrderDisable = 1;
                    if (order.Status && (order.OrderProcessStatusId == 2 || order.OrderProcessStatusId == 3 || order.OrderProcessStatusId == 4)) {
                        order.isReopenOrderDisable = 0;
                    }
                    // assign the most recent date from UpdatedDate and OrderLine_RecentUpdatedDate as UpdatedDate
                    if(order.OrderLine_RecentUpdatedDate != null && order.OrderLine_RecentUpdatedDate.length) {
                        var updatedDate = new Date(order.UpdatedDate);
                        var orderLine_RecentUpdatedDate = new Date(order.OrderLine_RecentUpdatedDate);
                        order.UpdatedDate = orderLine_RecentUpdatedDate > updatedDate ? order.OrderLine_RecentUpdatedDate : order.UpdatedDate;
                    }
                });
                ordersDialog.createOrderReferenceMap(vm.orders);
            })
            .finally(function () {
                vm.isLoading = false;
            });
        }

        //Item Action button pressed event
        function doItemAction(action, record) {
            if (action && record) {
                switch (action.id) {
                    case 'view':
                        viewItem(record);
                        break;
                    case 'edit':
                        vm.model.methods.getDetails(true, record[vm.model.idField], catalogCode)
                        .then(function (response) {
                            editItem(response.data, null);
                        })
                        break;
                    case 'delete':
                    case 'activate':
                        vm.model.methods.activateBulk(record, vm.model, action.id, catalogCode);
                        // as discussed with @amardeep, we will refresh list page when a draft order is deleted from the orders list page as the order is deleted physically
                        if(orderProcessStatusId === 1 && action.id == 'delete') {
                            refreshItems(true, false);
                        }
                        break;
                    case 'export':
                        var orderlineModel = angular.copy(catalogFactory.createOrderlineModel());
                        angular.forEach(orderlineModel.fields, function(field) {
                            if(field.field === 'TotalInitialValue' || field.field === 'TotalCurrentValue') {
                                field.visible = false;
                            }
                        });
                        orderlineExporter.exportOrderline(orderlineModel, vm.model, record[vm.model.idField]);
                        break;
                }
            }
        }

        //List Action button pressed event
        function doListAction(action, records) {
            if (action) {
                switch (action.id) {
                    case 'delete':
                    case 'activate':
                        vm.model.methods.activateBulk(records, vm.model, action.id, catalogCode);
                        // as discussed with @amardeep, we will refresh list page when a draft order is deleted from the orders list page as the order is deleted physically
                        if(orderProcessStatusId === 1 && action.id == 'delete') {
                            refreshItems(true, false);
                        }
                        break;
                    case 'import':
                        var importOrderModel = api.catalogs.importOrders;
                        var importOrderLinesModel = api.orders.importOrderlines;
                        var mergedModels = getUpdatedModel(importOrderModel, importOrderLinesModel);
                        var additionalInfo = {};
                        if(activeCatalog.IsStockApply) {
                            additionalInfo = {validateCustomerAssignedStocks : true};
                            var deliveryDateField = utility.filterObject(mergedModels.fields, {field: 'Crd'}, true)[0];
                            deliveryDateField.creatable = false;
                        }
                        // if customer required date validation added then make delivery date(crd) required
                        if(isCustomerRequiredDateValidationAdded) {
                            var customerRequiredDateField = utility.filterObject(mergedModels.fields, {field: 'DeliveryDate'}, true)[0];
                            customerRequiredDateField.validation.isRequired = true;
                        }
                        dataImporter.importExcel(mergedModels, true, additionalInfo).then(function(result) {
                            vm.model.methods.createBulk(result.data, catalogCode).then(function() {
                                refreshItems(true, false);
                            });
                        });
                        break;
                }
            }
        }

        function doProcessOrderListAction(action, records) {
            if (action && records.length) {
                switch (action.id) {
                    // case 'submit':
                    //     vm.model.methods.submitOrders(records, vm.model, action.id, action.status, catalogCode);
                    //     break;
                    case 'approve':
                        ordersDialog.approveOrders(records, vm.model)
                            .then(function(result) {
                                if(result.confirmation.toLowerCase() === 'confirm') {
                                    vm.model.methods.approveOrders(records, vm.model, action.id, action.status, catalogCode, result.orderType);
                                }
                            });
                        break;
                    case 'reject':
                        vm.model.methods.rejectOrders(records, vm.model, action.id, action.status, catalogCode);
                        break;
                    case 'reopen':
                        vm.model.methods.reopenOrders(records, vm.model, action.id, action.status, catalogCode);
                        break;
                    case 'confirm':
                        if(catalogFactory.getUseConfirmOrder() == 1) {
                            vm.model.methods.confirmOrders(records, vm.model, action.id, action.status, catalogCode);
                        }
                        break;
                    case 'unlock':
                        vm.model.methods.unlockOrders(records, vm.model, action.id, action.status, catalogCode);
                        break;
                }
            }
        }

        function doProcessOrderItemAction(action, record) {
            if (action && record) {
                switch (action.id) {
                    case 'submit':
                        vm.model.methods.getDetails(false, record[vm.model.idField], catalogCode).then(function(response) {
                            if(!isCustomerRequiredDateValidationAdded) {
                                vm.model.methods.submitOrders(response.data, vm.model, action.id, action.status, catalogCode);
                            } else { // when cutomer required date validation added validate CRD
                                var orderContent = undefined;
                                var orderlines = [];
                                var orderDetails = response.data;
                                if(angular.isDefined(orderDetails.OrderContent)) {
                                    orderContent = JSON.parse(orderDetails.OrderContent);
                                }

                                if(angular.isDefined(orderContent) && orderContent !== null) {
                                    orderlines = orderContent.Orderlines;
                                } else if(angular.isDefined(orderDetails.orderlineResponse)) {
                                    orderlines = orderDetails.orderlineResponse;
                                }

                                for (var i = 0; i<orderlines.length; i++) {
                                    var isValid = validateCRD(orderlines[i]);
                                    if(!isValid) {
                                        break;
                                    }
                                }
                                if(isValid) {
                                    vm.model.methods.submitOrders(response.data, vm.model, action.id, action.status, catalogCode, isCustomerRequiredDateValidationAdded);
                                } else { // show error message
                                    errorDialog.show('ORDERLINE.VALIDATIONS.CRD_CRITERIA_FAILED', undefined);
                                }
                            }
                        });
                        break;
                    case 'approve':
                        ordersDialog.approveOrders(record, vm.model)
                            .then(function(result) {
                                if(result.confirmation.toLowerCase() === 'confirm') {
                                    vm.model.methods.approveOrders(record, vm.model, action.id, action.status, catalogCode, result.orderType);
                                }
                            });
                        break;
                    case 'reject':
                        vm.model.methods.rejectOrders(record, vm.model, action.id, action.status, catalogCode);
                        break;
                    case 'reopen':
                        vm.model.methods.reopenOrders(record, vm.model, action.id, action.status, catalogCode);
                        break;
                    case 'confirm':
                        if(catalogFactory.getUseConfirmOrder() == 1) {
                            vm.model.methods.confirmOrders(record, vm.model, action.id, action.status, catalogCode);
                        }
                        break;
                    case 'unlock':
                        vm.model.methods.unlockOrders(record, vm.model, action.id, action.status, catalogCode);
                        break;
                }
            }
        }

        function viewItem(record) {
            var stateParams = {id: record[vm.model.idField], orderProcessStatusId: record.OrderProcessStatusId};
            $state.go('app.orders.details', stateParams);
        }

        function addRecord(ev) {
            ordersDialog.showCreateOrderDialog(angular.element($document.body), ev, vm.model, {catalogCode: catalogCode, sellerId: activeCatalog.AccountId, isStockApply: activeCatalog.IsStockApply}).then(function(saved) {
                if (saved) {
                    refreshItems(true, false);
                }
            });
        }

        function editItem(record, ev) {
            ordersDialog.showUpdateOrderDialog(angular.element($document.body), ev, vm.model, {catalogCode: catalogCode, sellerId: activeCatalog.AccountId, isStockApply: activeCatalog.IsStockApply}, angular.copy(record))
            .then(function(saved) {
                if (saved) {
                    refreshItems(true, false);
                }
            });
        }

        function getUpdatedModel(orderModel, orderlinesModel) {
            var updatedModel = angular.copy(orderModel);
            // updatedModel.fields.concat(orderlineModelClone.fields);
            // merge fields
            angular.forEach(orderlinesModel.fields, function(orderlineField) {
                updatedModel.fields.push(orderlineField);
            });

            // merge unique constraints
            angular.forEach(orderlinesModel.uniqueConstraints, function(uniqueConstraint) {
                var orderLineUniqueConstraints = {name: '', fields:[]};
                orderLineUniqueConstraints.name = 'Constraint ' + (updatedModel.uniqueConstraints.length+1);
                orderLineUniqueConstraints.fields = uniqueConstraint.fields;
                updatedModel.uniqueConstraints.push(orderLineUniqueConstraints);
            });
            return updatedModel;
        }

        function getAndSetCustomerRequiredDateValidation() {
            var customerRequiredDateValidation = activeCatalog.CustomerRequiredDateValidation;
            if(customerRequiredDateValidation != null && customerRequiredDateValidation != '') {
                var operators = ['<=', '>=', '>', '<', '===', '!=='];
                try {
                    vm.customerRequiredDateValidation = JSON.parse(customerRequiredDateValidation);
                    if(vm.customerRequiredDateValidation.length) {
                        if(vm.customerRequiredDateValidation[0].hasOwnProperty('relation') && vm.customerRequiredDateValidation[0].relation.toString().trim().length && operators.indexOf(vm.customerRequiredDateValidation[0].relation) !== -1) {
                            isCustomerRequiredDateValidationAdded = true;
                        }
                    }
                } catch(error) {
                    console.warn("Customer Required Date Validation : Invalid JSON format");
                    return '';
                }
            }
        }

        // helper method
        function validateCRD(orderLineObj) {
            var catalogDeliveryDates = catalogFactory.getActiveCatalogDetails().CatalogCRDList;

            for (var i = 0; i < vm.customerRequiredDateValidation.length; i++) {
                var validation = vm.customerRequiredDateValidation[i];
                var addedDeliveryDate = utility.filterObject(catalogDeliveryDates, { Id: orderLineObj.CrdId }, true)[0];
                var CRDValue = new Date(addedDeliveryDate.CustomerRequiredDate);
                CRDValue = CRDValue.setHours(0, 0, 0, 0); // this is the customer required date as the labels are confusing)

                var deliveryDateValue = new Date(orderLineObj.DeliveryDate);
                deliveryDateValue = deliveryDateValue.setHours(0, 0, 0, 0);

                var expression = validation.relation;

                // validate the customer required date based on the current validation item
                if(eval(deliveryDateValue + expression + CRDValue)) {
                    return true;
                }
            }

            return false;
        }

        var catalogChangedEventCleanup = $rootScope.$on('ActiveCatalogChangedEvent', function(e) {
            if(catalogCode !== catalogFactory.getActiveCatalog().CatalogCode) {
                $state.reload('app.orders');
            }
        });
        $scope.$on('$destroy', function () {
            catalogChangedEventCleanup();
            ordersDialog.cleanOrderReferenceMap();
        });

    }
})();
(function() {
    'use strict';

    angular.module('app.main.catalogs.orders')
    .factory('ordersDialog',ordersDialog);

    /** @ngInject */
	function ordersDialog(api, $mdDialog, $document) {
        var orderReferenceMap = {};
        //Data
		var dialogObj = {
                controller         : 'ordersDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/catalogs/sub-modules/orders/dialogs/update-order/orders-dialog.html',
                targetEvent        : null,
                clickOutsideToClose: false,
                locals             : {}
            };
		//Methods
		var service = {
			showCreateOrderDialog   : showCreateOrderDialog,
            showUpdateOrderDialog   : showUpdateOrderDialog,
            approveOrders           : approveOrders,
            createOrderReferenceMap : createOrderReferenceMap,
            generateOrderReference  : generateOrderReference,
            cleanOrderReferenceMap  : cleanOrderReferenceMap
		};

		return service;


        //Methods implementation

        function showCreateOrderDialog(parent, targetEvent, model, defaultValues) {
            var promises = {};
            angular.forEach(model.fields, function(field) {
                if ((field.editable || field.creatable || field.visible) && (field.inputType === 'lookup' || field.inputType === 'lookup-many' || field.inputType === 'articlenumber' || field.inputType === 'modelnumber' || field.inputType === 'linkedcatalogarticlenumber')
                 && angular.isDefined(field.lookupSource)) {
                    var lookupModel = api.getModel(field.lookupSource);
                    promises[field.field] = api.getLookupData(lookupModel);
                }
            });

            dialogObj.parent = angular.element(parent);
            dialogObj.targetEvent = targetEvent;
            dialogObj.locals['isNew'] = true;
            dialogObj.locals['lookupPromises'] = promises;
            dialogObj.locals['model'] = model;
            dialogObj.locals['defaultValues'] = defaultValues;
            dialogObj.locals['event'] = targetEvent;
            dialogObj.locals['record'] = undefined;
            return $mdDialog.show(dialogObj);
        }

        function showUpdateOrderDialog(parent, targetEvent, model, defaultValues, record) {
            var promises = {};
            angular.forEach(model.fields, function(field) {
                if ((field.editable || field.creatable || field.visible) && (field.inputType === 'lookup' || field.inputType === 'lookup-many'  || field.inputType === 'articlenumber' || field.inputType === 'modelnumber' || field.inputType === 'linkedcatalogarticlenumber')
                 && angular.isDefined(field.lookupSource)) {
                    var lookupModel = api.getModel(field.lookupSource);
                    promises[field.field] = api.getLookupData(lookupModel);
                }
            });

            dialogObj.parent = angular.element(parent);
            dialogObj.targetEvent = targetEvent;
            dialogObj.locals['isNew'] = false;
            dialogObj.locals['lookupPromises'] = promises;
            dialogObj.locals['model'] = model;
            dialogObj.locals['defaultValues'] = defaultValues;
            dialogObj.locals['event'] = targetEvent;
            dialogObj.locals['record'] = record;
            return $mdDialog.show(dialogObj);
        }

        function approveOrders(items, model) {
            return $mdDialog.show({
                controller         : 'approveOrdersController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/catalogs/sub-modules/orders/dialogs/approve-orders/approve-orders.html',
                parent             : angular.element($document.body),
                targetEvent        : null,
                clickOutsideToClose: true,
                locals             : {
                    items: items,
                    model: model
                }
            });
        }

        /**
       * @description: It creates the orderReferenceMap inorder to check if the order reference number using function generateOrderReference() is unique or not
       * @param {array|object} orders
       */
      function createOrderReferenceMap(orders) {
        angular.forEach(orders, function(order) {
            orderReferenceMap[order.OrderReference] = 1;
        })
        return orderReferenceMap;
      }

      /**
       * @description: return unique Order Reference (like : customerCode-locationCode-123456) for order reference number for orders
       */
      function generateOrderReference(customerCode, locationCode) {
        var generatedOrderReference = customerCode + '-' + locationCode + '-' + (Math.floor(Math.random() * 899999) + 100000);
        if(orderReferenceMap[generatedOrderReference]) {
          return generateOrderReference(record);
        } else {
          orderReferenceMap[generatedOrderReference] = 1;
          return generatedOrderReference;
        }
      }

      function cleanOrderReferenceMap() {
        orderReferenceMap = {};
      }
    }
})();
(function() {
		'use strict';

		angular
				.module('app.main.catalogs.order-adjustments', [])
				.config(config);

		/* @ngInject */
		function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {

				$stateProvider.state('app.order_adjustments', {
						url    : '/order-adjustments',
						views  : {
								'content@app': {
										templateUrl: 'app/main/catalogs/sub-modules/order-adjustments/list/order-adjustments-list.html',
										controller : 'orderAdjustmentsListController as vm'
								}
						},
						resolve: {},
						data: {
								displayName: 'ORDER_ADJUSTMENTS.NAV'
						},
						// accessPrivileges: ['GetOrderAdjustments']
						// accessPrivileges: ['nav_order_adjustments']
						accessInfo: {
							accessPrivileges: ['nav_order_adjustments']
						}
				});

				$stateProvider.state('app.order_adjustments.details', {
					url	 : '/:id',
					views: {
						'content@app': {
							templateUrl: 'app/main/catalogs/sub-modules/order-adjustments/details/order-adjustments-details.html',
							controller : 'orderAdjustmentsDetailsController as vm'
						}
					},
					data: {
						parentState: 'app.order_adjustments',
						displayName: 'ORDER_ADJUSTMENTS.TABS.ORDER_ADJUSTMENT'
					},
					//only users with following accessPrivileges in their role access list can access this route
					// accessPrivileges: ['GetOrderAdjustmentDetails']
					accessInfo: {
						accessPrivileges: ['GetOrderAdjustmentDetails']
					}
				});

				// Translation
				$translatePartialLoaderProvider.addPart('app/main/catalogs/sub-modules/order-adjustments');

				// Navigation
				msNavigationServiceProvider.saveItem('orders.order_adjustments', {
						title      : 'Order Adjustments',
						icon       : 'icon-cart-outline',
						state      : 'app.order_adjustments',
						translate  : 'ORDER_ADJUSTMENTS.NAV',
						weight     : 126,
						// accessPrivileges: ['GetOrderAdjustments']
						// accessPrivileges: ['nav_order_adjustments'],
						accessInfo: {
							accessPrivileges: ['nav_order_adjustments']
						}
				});
		}

})();
(function () {
	'use strict';

	angular
		.module('app.main.catalogs.order-adjustments')
		.controller('orderAdjustmentsListController', orderAdjustmentsListController);

	/* @ngInject */
	function orderAdjustmentsListController(api, $rootScope, $scope, $state, catalogFactory, dataImporter, settingsFactory, utility) {
		/* jshint validthis: true */
		var vm = this;

		//Data
		var activeCatalog = catalogFactory.getActiveCatalog();
		var catalogCode = activeCatalog.CatalogCode;

		vm.model = api.catalogs.orderAdjustments;
		settingsFactory.applyPersistedListViewLayout(vm.model);

		vm.orderAdjustments = [];
		vm.filteredOrderAdjustments = [];
		vm.isLoading = false;


		//Methods
		vm.refreshItems = refreshItems;
		vm.doListAction = doListAction;
		vm.doItemAction = doItemAction;
		vm.viewItem = viewItem;

		activate();

		////////////////

		function activate() {
			refreshItems(vm.model.isDirty, true);
		}

		function refreshItems(forceFetch, isLogRequired) {
			vm.isLoading = true;
			var generalProperties = {
				forceFetch: forceFetch,
				isLogRequired: isLogRequired
			}
			vm.model.methods.getList(generalProperties, vm.model, catalogCode)
			.then(function (response) {
				vm.orderAdjustments = response.data;
			})
			.finally(function () {
				vm.isLoading = false;
			});
		}

		//Item Action button pressed event
		function doItemAction(action, record) {
			if (action && record) {
				switch (action.id) {
				case 'view':
					viewItem(record);
					break;
				}
			}
		}

		//List Action button pressed event
		function doListAction(action) {
			if (action) {
				switch (action.id) {
					case 'import':
					var modelCopy = angular.copy(api.catalogs.orderAdjustmentDetailList);
					modelCopy.conditionalRequired = null // this constants is only for Adjust Without Order Reference

					dataImporter.importExcel(modelCopy, true).then(function(result) {
						var validData = [];
						var data = {};
						var name = '';
						if(angular.isDefined(result.data) && result.data.length > 0 ) {
							angular.forEach(result.data, function(record) {
								if(name === '') {
									name = record.AdjustmentsName;
								}
								delete record['AdjustmentsName'];
								validData.push(record);
							});
						}
						if(validData.length > 0) {
							//Convert data to required reuest format
							data['Name'] = name;
							data['Adjustments'] = validData;
							vm.model.methods.createBulk(data, catalogCode, vm.model);
						} else {
							console.warn('No data available for import');
						}
					});
					break;
					// Adjust Without Order Reference(Bulk)
					case 'importAdjustments' :
					var modelCopy = angular.copy(api.catalogs.orderAdjustmentDetailList);
					var orderReferenceField = utility.filterObject(modelCopy.fields, { field: 'OrderReference' }, true)[0];
					orderReferenceField.creatable = false;
					var newCrdField = utility.filterObject(modelCopy.fields, { field: 'NewCrd' }, true)[0];
					newCrdField.creatable = false;
					var newQuantityField = utility.filterObject(modelCopy.fields, { field: 'NewQuantity' }, true)[0];
					newQuantityField.creatable = false;
					// We will allow only positive and negative intergers for Quantity and will not allow decimal numbers
					var newQuantityField = utility.filterObject(modelCopy.fields, { field: 'Quantity' }, true)[0];
					newQuantityField.validation.pattern = '^-?[0-9]\\d*$';
					newQuantityField.validation.messages.pattern = 'Decimal numbers are not allowed';
					modelCopy.atLeastOneRequiredConstraints = [];
					var customerCode = utility.filterObject(modelCopy.fields, { field: 'CustomerReference' }, true)[0];
					customerCode.creatable = true;
					var customerCode = utility.filterObject(modelCopy.fields, { field: 'CustomerCode' }, true)[0];
					customerCode.creatable = true;
					var locationCode = utility.filterObject(modelCopy.fields, { field: 'LocationCode' }, true)[0];
					locationCode.creatable = true;

					dataImporter.importExcel(modelCopy, true).then(function(result) {
						vm.model.methods.adjustWithoutOrderReference(result.data, catalogCode, vm.model);
					});
					break;
				}
			}
		}

		function viewItem(item) {
			//User can see the details only when status is fails or complete
			if(item.Status.toLowerCase() === 'fail' || item.Status.toLowerCase() === 'complete') {
				if(item.Status.toLowerCase() === 'fail') {
					var jobId = item.JobId;
					var stateParams = {id: jobId, tab: 'ERRORS'};
					$state.go('app.jobs.details', stateParams);
				} else {
					var id = item[vm.model.idField];
					var stateParams = {id: id};
					$state.go('app.order_adjustments.details', stateParams);
				}
			}
		}

		var catalogChangedEventCleanup = $rootScope.$on('ActiveCatalogChangedEvent', function (e) {
			if (catalogCode !== catalogFactory.getActiveCatalog().CatalogCode) {
				$state.reload('app.order_adjustments');
			}
		});

		$scope.$on('$destroy', function () {
			catalogChangedEventCleanup();
		});

	}
})();
(function() {
    'use strict';

    angular
        .module('app.main.catalogs.orders')
        .controller('ordersDetailsController', ordersDetailsController);

    /* @ngInject */
    function ordersDetailsController(api, $state, $stateParams, $rootScope, $document, utility, catalogFactory, ordersDialog,
    orderlineDialog, orderLineModel, settingsFactory, SecurityFactory, CONSTANTS, $mdDialog,
    uploadsTracker, orderModel, $scope, dialog, toast, $sessionStorage, errorDialog) {
       /* jshint validthis: true */
        var vm = this;

        // Data
        var orderId = $stateParams.id;
        var orderProcessStatusId = parseInt($stateParams.orderProcessStatusId);
        vm.activeCatalog = catalogFactory.getActiveCatalog();
        var catalogCode = vm.activeCatalog.CatalogCode;
        var isStockApply = vm.activeCatalog.IsStockApply;
        vm.customerRequiredDateValidation = [];
        var isCustomerRequiredDateValidationAdded = false;

        vm.model = orderModel;
        vm.orderLineModel = angular.copy(orderLineModel);

        vm.rejectedOrderlineModel = api.orders.rejectedOrderlines;
        settingsFactory.applyPersistedListViewLayout(vm.rejectedOrderlineModel);

        vm.filesModel = api.orders.files;
        settingsFactory.applyPersistedListViewLayout(vm.filesModel);

        vm.notificationsModel = api.orders.notifications;
        settingsFactory.applyPersistedListViewLayout(vm.notificationsModel);

        vm.orderStatusHistoryModel = api.catalogs.orderStatusHistory;
        settingsFactory.applyPersistedListViewLayout(vm.orderStatusHistoryModel);

        vm.impactedAdjustmentsModel = api.catalogs.impactedAdjustments;
        settingsFactory.applyPersistedListViewLayout(vm.impactedAdjustmentsModel);

        vm.order = {};
        vm.orderLines = [];
        vm.filteredOrderLines = [];
        vm.rejectedOrderlines = [];
        vm.filteredRejectedOrderlines = [];
        vm.files = [];
        vm.filteredFiles = [];
        vm.notifications = [];
        vm.filteredNotifications = [];
        vm.orderStatusHistoryList = [];
        vm.filteredOrderStatusHistoryList = [];
        vm.impactedAdjustments = [];
        vm.filteredImpactedAdjustments = [];

        vm.isLoading = false;
        vm.isOrederLineLoading = false;
        vm.isRejectedOrederLineLoading = false;
        vm.isFilesLoading = false;
        vm.isNotificationsLoading = false;
        vm.isOrderStatusHistoryLoading = false;
        vm.isImpactedAdjustmentsLoading = false;

        var isTabDataInitialized = false;


        // Methods
        vm.refreshRecord = refreshRecord;
        vm.refreshOrderLines = refreshOrderLines;
        vm.refreshRejectedOrderlines = refreshRejectedOrderlines;
        vm.refreshFiles = refreshFiles;
        vm.refreshNotifications = refreshNotifications;
        vm.refreshOrderStatusHistoryList = refreshOrderStatusHistoryList;
        vm.refreshImpactedAdjustmentsList = refreshImpactedAdjustmentsList;

        vm.doOrderItemAction = doOrderItemAction;
        vm.doProcessOrderItemAction = doProcessOrderItemAction;
        vm.editOrder = editOrder;

        vm.doOrderLineItemAction = doOrderLineItemAction;
        vm.doOrderLineListAction = doOrderLineListAction;
        vm.viewOrderLine = viewOrderLine;
        vm.addOrderLine = addOrderLine;

        vm.doFilesItemAction = doFilesItemAction;
        vm.doFilesListAction = doFilesListAction;
        vm.uploadFile = uploadFile;

        vm.doNotificationItemAction = doNotificationItemAction;
        vm.viewNotification = viewNotification;


        activate();

        ////////////////

        function activate() {
            if(!isStockApply) {
                getAndSetCustomerRequiredDateValidation();
            }
            refreshRecord(true);
        }

        function refreshRecord(isLogRequired) {
            vm.isLoading = true;
            vm.isOrederLineLoading = true;

            vm.model.methods.getDetails(isLogRequired, orderId, catalogCode, vm.model)
                .then(function (response) {
                    orderProcessStatusId = response.data.OrderProcessStatusId;
                    vm.order = response.data;
                    vm.order['UseOrderType'] = catalogFactory.getUseOrderType();
                    vm.order['UseConfirmOrder'] = catalogFactory.getUseConfirmOrder();

                    vm.title = angular.copy(vm.order[vm.model.lookupDisplayField]);
                    vm.orderLineModelCopy = angular.copy(vm.orderLineModel);
                    if(orderProcessStatusId !== 1 && orderProcessStatusId !== 5) {
                        vm.orderLines = response.data.orderlineResponse;
                        flattenOrderlineAttributes(vm.orderLines);
                    } else {
                        var unsavedOrders = angular.isDefined(catalogFactory.getUnsavedDraftOrders()) ? catalogFactory.getUnsavedDraftOrders() : [];
                        var orderlineList = [];
                        vm.orderLines = [];
                        // for reopened orders with data from server
                        if(orderProcessStatusId === 5) {
                            orderlineList = response.data.orderlineResponse;
                            flattenOrderlineAttributes(orderlineList);
                        }
                        if(unsavedOrders.length > 0) {
                            var currentOrderData = utility.filterObject(unsavedOrders, { OrderReference: vm.order.OrderReference }, true)[0];
                            if(angular.isDefined(currentOrderData)) {
                                var unsavedOderLines = null;
                                try {
                                    var unsavedOderLines = JSON.parse(currentOrderData.OrderContent).Orderlines;
                                } catch(error) {
                                    console.error('Unable to parse saved order content from server\n', error);
                                }
                                if(angular.isDefined(unsavedOderLines) && unsavedOderLines !== null) {
                                    angular.forEach(unsavedOderLines, function(orderLine) {
                                        var orderlineIndex = orderlineList.indexOf(utility.filterObject(orderlineList, { ArticleId: orderLine.ArticleId, CrdId: orderLine.CrdId}, true)[0]);
                                        if (orderlineIndex !== -1) {
                                            orderlineList.splice(orderlineIndex, 1);
                                            orderLine['isUnsavedOrderline'] = true;
                                            orderlineList.push(orderLine);
                                        } else {
                                            orderLine['isUnsavedOrderline'] = true;
                                            orderlineList.push(orderLine);
                                        }
                                    });
                                }
                            }
                        }

                        // if saved draft orders with orderline
                        var orderContent = null;
                        if(angular.isDefined(vm.order.OrderContent)) { // if it is not saved in server no value will be returned by server
                            try {
                                orderContent = JSON.parse(vm.order.OrderContent);
                            } catch(error) {
                                console.error('Unable to parse saved order content from server\n', error);
                            }
                        }
                        if(angular.isDefined(orderContent) && orderContent !== null) {
                            // if updated orders are there show it from the unsaved orders
                            angular.forEach(orderContent.Orderlines, function(orderline) {
                                var index = orderlineList.indexOf(utility.filterObject(orderlineList, { ArticleId: orderline.ArticleId, CrdId: orderline.CrdId}, true)[0]);
                                if (index === -1) {
                                    orderlineList.push(orderline);
                                }
                            });
                        }
                        angular.forEach(orderlineList, function(ol) {
                            if(ol.IsDeleted !== 1) {
                                vm.orderLines.push(ol);
                            }
                        })
                        // add status, isActive and ConsolidationId fields
                        if(vm.orderLines.length > 0) {
                            flattenOrderlineAttributesForDraftAndReopnedOrders();
                        }
                    }

                    if(angular.isDefined(vm.orderLines) && vm.orderLines.length && angular.isDefined(vm.orderLines[0]) && vm.orderLines[0].hasOwnProperty('GFR')) {
                        calculateGFR();
                    }

                    initializeTabData(isLogRequired);

                    //Update Breadcrumb
                    $state.current.data.displayName = vm.title;
                    $rootScope.$broadcast('breadcrumb-updated');

                })
                .finally(function () {
                    vm.isLoading = false;
                    vm.isOrederLineLoading = false;
                });
        }

        function refreshOrderLines(forceFetch, isLogRequired) {
            if(orderProcessStatusId !== 1 && orderProcessStatusId !== 5) {
                vm.isOrederLineLoading = true;
                var generalProperties = {
                    forceFetch: forceFetch,
                    isLogRequired: isLogRequired
                }
                vm.orderLineModel.methods.getList(generalProperties, vm.orderLineModel, orderId, catalogCode).then(function(response) {
                    vm.orderLines = response.data;
                    flattenOrderlineAttributes(vm.orderLines);
                    // utility.addCustomProperty(vm.orderLines, 'OrderProcessStatusId', vm.order.OrderProcessStatusId);
                }).finally(function() {
                    vm.isOrederLineLoading = false;
                });
            } else {
                refreshRecord(false);
            }
        }

        function refreshRejectedOrderlines(forceFetch, isLogRequired) {
            vm.isRejectedOrederLineLoading = true;
            var generalProperties = {
                forceFetch: forceFetch,
                isLogRequired: isLogRequired
            }
            vm.rejectedOrderlineModel.methods.getList(generalProperties, vm.rejectedOrderlineModel, orderId, catalogCode).then(function(response) {
                vm.rejectedOrderlines = response.data;
            }).finally(function() {
                vm.isRejectedOrederLineLoading = false;
            });
        }

        function refreshFiles(forceFetch, isLogRequired) {
            vm.isFilesLoading = true;
            var generalProperties = {
                forceFetch: forceFetch,
                isLogRequired: isLogRequired
            }
            vm.filesModel.methods.getList(generalProperties, orderId, catalogCode)
                .then(function(response) {
                    vm.files = response.data;
                }).finally(function() {
                    vm.isFilesLoading = false;
                });
        }

        function refreshNotifications(forceFetch, isLogRequired) {
            vm.isNotificationsLoading = true;
            var generalProperties = {
                forceFetch: forceFetch,
                isLogRequired: isLogRequired
            }
            vm.notificationsModel.methods.getList(generalProperties, orderId, catalogCode).then(function(response) {
                vm.notifications = response.data;
            }).finally(function() {
                vm.isNotificationsLoading = false;
            });
        }

        function refreshOrderStatusHistoryList(forceFetch, isLogRequired) {
            vm.isOrderStatusHistoryLoading = true;
            var generalProperties = {
                forceFetch: forceFetch,
                isLogRequired: isLogRequired
            }
            vm.orderStatusHistoryModel.methods.getList(generalProperties, orderId, catalogCode).then(function(response) {
                vm.orderStatusHistoryList = response.data;
            }).finally(function() {
                vm.isOrderStatusHistoryLoading = false;
            });
        }

        function refreshImpactedAdjustmentsList(forceFetch, isLogRequired) {
            vm.isImpactedAdjustmentsLoading = true;
            var generalProperties = {
                forceFetch: forceFetch,
                isLogRequired: isLogRequired
            }
            vm.impactedAdjustmentsModel.methods.getList(generalProperties, orderId, catalogCode).then(function(response) {
                vm.impactedAdjustments = response.data;
            }).finally(function() {
                vm.isImpactedAdjustmentsLoading = false;
            });
        }

        function doOrderItemAction(action, record) {
            if (action) {
                switch (action.id) {
                    case 'delete':
                    case 'activate':
                        vm.model.methods.activateBulk(record, vm.model, action.id, catalogCode)
                            .then(function() {
                                if(!isTabDataInitialized && action.id == 'activate') {
                                    initializeTabData(true);
                                }
                                // as discussed with @amardeep, we will redirect to orders list page when a draft order is deleted from the orders details page as the order is deleted physically
                                if(orderProcessStatusId === 1 && action.id == 'delete') {
                                    api.catalogs.orders.isDirty = true
                                    $state.go('app.orders', {}, { reload: true });
                                }
                            });
                        break;
                    case 'saveOrders':
                        saveDraftOrders();
                        break;
                }
            }
        }

        function doProcessOrderItemAction(action, record) {
            if (action && record) {
                switch (action.id) {
                    case 'submit':
                        var unsavedOrders = angular.isDefined(catalogFactory.getUnsavedDraftOrders()) ? catalogFactory.getUnsavedDraftOrders() : [];
                        // if unsaved orders show popup
                        if(unsavedOrders.length > 0) {
                            showSaveOrdersPopup(action, record);
                        } else {
                            if(!isCustomerRequiredDateValidationAdded) {
                                vm.model.methods.submitOrders(record, vm.model, action.id, action.status, catalogCode);
                            } else { // when cutomer required date validation added validate CRD
                                var orderContent = undefined;
                                var orderlines = [];
                                if(angular.isDefined(record.OrderContent)) {
                                    orderContent = JSON.parse(record.OrderContent);
                                }

                                if(angular.isDefined(orderContent) && orderContent !== null) {
                                    orderlines = orderContent.Orderlines;
                                } else if(angular.isDefined(record.orderlineResponse)) {
                                    orderlines = record.orderlineResponse;
                                }

                                for (var i =0; i<orderlines.length; i++) {
                                    var isValid = validateCRD(orderlines[i]);
                                    if(!isValid) {
                                        break;
                                    }
                                }
                                if(isValid) {
                                    vm.model.methods.submitOrders(record, vm.model, action.id, action.status, catalogCode, isCustomerRequiredDateValidationAdded);
                                } else { // show error message
                                    errorDialog.show('ORDERLINE.VALIDATIONS.CRD_CRITERIA_FAILED', undefined);
                                }
                            }
                        }
                        break;
                    case 'approve':
                        ordersDialog.approveOrders(record, vm.model)
                            .then(function(result) {
                                if(result.confirmation.toLowerCase() === 'confirm') {
                                    vm.model.methods.approveOrders(record, vm.model, action.id, action.status, catalogCode, result.orderType);
                                }
                            });
                        break;
                    case 'reject':
                        vm.model.methods.rejectOrders(record, vm.model, action.id, action.status, catalogCode);
                        break;
                    case 'reopen':
                        vm.model.methods.reopenOrders(record, vm.model, action.id, action.status, catalogCode);
                        break;
                    case 'confirm':
                        if(catalogFactory.getUseConfirmOrder() == 1) {
                            vm.model.methods.confirmOrders(record, vm.model, action.id, action.status, catalogCode);
                        }
                        break;
                    case 'unlock':
                        vm.model.methods.unlockOrders(record, vm.model, action.id, action.status, catalogCode);
                        break;
                }
			}
        }

        function editOrder(record, ev) {
            ordersDialog.showUpdateOrderDialog(angular.element($document.body), ev, vm.model, {catalogCode: catalogCode, sellerId: vm.activeCatalog.AccountId}, angular.copy(record)).then(function(saved) {
                if (saved) {
                    refreshRecord(false);
                }
            });
        }

        function doOrderLineItemAction(action, record) {
			if (action && record) {
                switch (action.id) {
                    case 'view':
                        viewOrderLine(record);
                        break;
                    case 'edit':
                        editOrderLine(record, null);
                        break;
                    case 'delete':
                    case 'activate':
                        if(orderProcessStatusId !== 1 && angular.isDefined(record.Id)) {
                            vm.orderLineModel.methods.activateBulk(record, vm.model, action.id, catalogCode, orderId, record.Id);
                        } else {
                            vm.orderLineModel.methods.deleteDraftAndReopnedOrders(record, vm.order).then(function(order) {
                                vm.order.OrderContent = order.OrderContent;
                            });
                            refreshRecord(false);
                        }
                        break;
                }
			}
		}

        function doOrderLineListAction(action, records) {
            if (action) {
                switch (action.id) {
                    case 'delete':
                    case 'activate':
                        break;
                    case 'saveOrders':
                        saveDraftOrders();
                        break;
                }
            }
        }

        function viewOrderLine(record) {
            var stateParams = {id: orderId, orderlineId: record[vm.orderLineModel.idField], OrderProcessStatusId: orderProcessStatusId, Orderline: record, Order: vm.order};
            $state.go('app.orders.details.orderline-details', stateParams);
		}

        function addOrderLine(ev) {
            orderlineDialog.showCreateOrderlineDialog(angular.element($document.body), ev, vm.orderLineModel, vm.order, {
                catalogCode: catalogCode,
                orderId: orderId,
                existingOrderlines: vm.orderLines,
                isStockApply: isStockApply,
                customerRequiredDateValidation: vm.customerRequiredDateValidation
            })
            .then(function(saved) {
                if (saved) {
                    refreshRecord(false);
                }
            }).catch(function(error) {
                jobsTracker.setCriticlaFail(jobIndex, error);
            });
        }

        function editOrderLine(record, ev) {
            if(orderProcessStatusId !== 1 && angular.isDefined(record[vm.orderLineModel.idField]) && !record.isUnsavedOrderline) {
                vm.orderLineModel.methods.getDetails(false, record[vm.orderLineModel.idField], orderId, catalogCode).then(function(response) {
                    var orderLineDetails = angular.copy(response.data);

                    orderlineDialog.showUpdateOrderlineDialog(angular.element($document.body), ev, vm.orderLineModel, vm.order,
                    {
                        catalogCode: catalogCode,
                        orderId: orderId,
                        orderlineDetails: orderLineDetails,
                        existingOrderlines: vm.orderLines,
                        isStockApply: isStockApply,
                        customerRequiredDateValidation: vm.customerRequiredDateValidation
                    }, angular.copy(record)).then(function(saved) {
                        if (saved) {
                            refreshOrderLines(false);
                        }
                    });
                });
            } else {
                var recordCopy = angular.copy(record);
                recordCopy['orderLineSizeResponse'] = recordCopy.OrderlineSize;
                recordCopy['orderLineVasResponse'] = recordCopy.OrderlineVas;
                delete recordCopy.OrderlineSize;
                delete recordCopy.OrderlineVas;
                orderlineDialog.showUpdateOrderlineDialog(angular.element($document.body), ev, vm.orderLineModel, vm.order,
                    {
                        catalogCode: catalogCode,
                        orderId: orderId,
                        orderlineDetails: recordCopy,
                        existingOrderlines: vm.orderLines,
                        customerRequiredDateValidation: vm.customerRequiredDateValidation
                    }, recordCopy ).then(function(saved) {
                    if (saved) {
                        refreshOrderLines(false);
                    }
                });
            }
        }

        function saveDraftOrders() {
            vm.orderLineModel.methods.saveDraftOrders(vm.order, catalogCode).then(function(response) {
                var toastMessage = 'ORDERLINE.MESSAGES.SUCCESS';
                toast.success(toastMessage, '', '');
            });
        }

        function doFilesItemAction(action, record) {
			if (action && record) {
                switch (action.id) {
                    case 'delete':
                        vm.filesModel.methods.delete(record, vm.files, orderId, catalogCode)
                        .then(function() {
                            refreshFiles(true, false);
                        });
                }
			}
        }

        function doFilesListAction(action, records) {
			if (action && records) {
                switch (action.id) {
                    case 'delete':
                        vm.filesModel.methods.delete(records, vm.files, orderId, catalogCode)
                        .then(function() {
                            refreshFiles(true, false);
                        });
                }
			}
        }

        function uploadFile(ev) {
            var promises = {};
            promises['FileType'] = api.getLookupData(api.lists.fileTypes);
            $mdDialog.show({
                controller         : 'uploadFilesController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/catalogs/sub-modules/orders/details/tabs/files/dialogs/upload-files.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: false,
                closeTo            : '#quick-panel-toggle',
                locals             : {
                    promises: promises
                }
            }).then(function (data) {
                if (angular.isDefined(data) && angular.isDefined(data.flowObj)) {
                    var index = uploadsTracker.addUpload('Upload File', data.flowObj);

                    uploadsTracker.uploads[index].defer.promise.then(function() {
                        for(var fileIndex=0, len=uploadsTracker.uploads[index].flow.files.length; fileIndex< len ; fileIndex++) {
                            data.record.FileId = uploadsTracker.uploads[index].flow.files[fileIndex].fileId;
                            vm.filesModel.methods.create(data.record, orderId, catalogCode)
                                .then(function() {
                                    refreshFiles(true, false);
                                });
                        }
                    }, function() {
                        //If any files of flow object doesn't upload successfully
                    });
                }
            });
        }

        function doNotificationItemAction(action, record) {
			if (action && record) {
                switch (action.id) {
                    case 'view':
                        viewNotification(record);
                }
			}
        }

        function viewNotification(record) {
            var id = record[vm.notificationsModel.idField];
            var stateParams = { id: id };
            $state.go('app.notifications.details', stateParams);
        }

        function flattenOrderlineAttributes(orderLines) {
            angular.forEach(orderLines, function(orderLine) {
                for(var prop in orderLine.Attributes) {
                    orderLine[prop] = orderLine.Attributes[prop];
                    orderLine['isFromServer'] = true;
                }
                delete orderLine.Attributes;
                orderLine['OrderProcessStatusId'] = vm.order.OrderProcessStatusId;
            });
        }

        function flattenOrderlineAttributesForDraftAndReopnedOrders() {
            // filter articles based on model dynamic properties and assign article values to orderline model
            var articleModel = api.catalogs.articles;
            var generalProperties = {
                forceFetch: true,
                isLogRequired: false,
                config: {},
                supportIncrementalResult: true,
                modelIdField: articleModel.idField,
                isMajor: false,
                isArticleRelatedData: true
            }
            articleModel.methods.getList(generalProperties, articleModel, catalogCode).then(function(response) {
                var articlesList = response.data;
                angular.forEach(vm.orderLines, function(orderline) {
                    if(!orderline.isFromServer) {
                        orderline.Status = 0;
                        orderline.IsActive = 1;
                        orderline.ConsolidationId = 0;
                        orderline.OrderReference = vm.order.OrderReference;
                        orderline.OrderId = orderId;
                        orderline.CreatedBy = vm.order.CreatedBy;
                        orderline.UpdatedBy = vm.order.UpdatedBy;
                        orderline['TotalQuantity'] = 0;
                        angular.forEach(orderline.OrderlineSize, function(size) {
                            orderline['TotalQuantity'] += size['Quantity'];
                        });
                        orderline['TotalInitialValue'] = orderline['TotalQuantity'] * orderline['InitialPrice']
                        orderline['TotalCurrentValue'] = orderline['TotalQuantity'] * orderline['InitialPrice'] //CurrentPrice
                        var currentArticle = utility.filterObject(articlesList, { Id: orderline.ArticleId }, true)[0];
                        if(angular.isDefined(currentArticle)) {
                            var dynamicFields = utility.filterObject(vm.orderLineModel.fields, { isDynamicProperty: true }, true);
                            // assign article number and name
                            orderline['ArticleNumber'] = currentArticle.ArticleNumber;
                            orderline['ArticleName'] = currentArticle.ArticleName;
                            angular.forEach(dynamicFields, function(field) {
                                orderline[field.field] = currentArticle[field.field];
                            });
                        }
                        orderline['OrderProcessStatusId'] = vm.order.OrderProcessStatusId;
                    }
                });
            });
        }

        function calculateGFR() {
            var acumulativeOrderlineQuantity = 0;
            var acumulativeOrderlinePrice = 0;
            angular.forEach(vm.orderLines, function(orderline) {
                if(orderline['GFR'].toString().toUpperCase() === 'YES' || orderline['GFR'].toString().toUpperCase() === 'TRUE') {
                    acumulativeOrderlineQuantity += orderline['TotalQuantity'];
                    acumulativeOrderlinePrice += (orderline['TotalQuantity']*orderline['CurrentPrice']);
                }
            });
            vm.order['GFRQuantity'] = vm.order['TotalQuantity'] == 0 ? 0 : (acumulativeOrderlineQuantity/vm.order['TotalQuantity']).toFixed(2);
            vm.order['GFRValue'] = vm.order['TotalCurrentValue'] == 0 ? 0 : (acumulativeOrderlinePrice/vm.order['TotalCurrentValue']).toFixed(2);
        }

        function getAndSetCustomerRequiredDateValidation () {
            var customerRequiredDateValidation = vm.activeCatalog.CustomerRequiredDateValidation;
            if(customerRequiredDateValidation != null && customerRequiredDateValidation != '') {
                var operators = ['<=', '>=', '>', '<', '===', '!=='];
                try {
                    vm.customerRequiredDateValidation = JSON.parse(customerRequiredDateValidation);
                    if(vm.customerRequiredDateValidation.length) {
                        if(vm.customerRequiredDateValidation[0].hasOwnProperty('relation') && vm.customerRequiredDateValidation[0].relation.toString().trim().length && operators.indexOf(vm.customerRequiredDateValidation[0].relation) !== -1) {
                            isCustomerRequiredDateValidationAdded = true;
                        }
                    }
                } catch(error) {
                    console.warn("Customer Required Date Validation : Invalid JSON format");
                    return '';
                }
            }
        }

        // helper method
        function validateCRD(orderLineObj) {
            var catalogDeliveryDates = catalogFactory.getActiveCatalogDetails().CatalogCRDList;

            for (var i = 0; i < vm.customerRequiredDateValidation.length; i++) {
                var validation = vm.customerRequiredDateValidation[i];
                var addedDeliveryDate = utility.filterObject(catalogDeliveryDates, { Id: orderLineObj.CrdId }, true)[0];
                var CRDValue = new Date(addedDeliveryDate.CustomerRequiredDate);
                CRDValue = CRDValue.setHours(0, 0, 0, 0); // this is the customer required date as the labels are confusing)

                var deliveryDateValue = new Date(orderLineObj.DeliveryDate);
                deliveryDateValue = deliveryDateValue.setHours(0, 0, 0, 0);

                var expression = validation.relation;

                // validate the customer required date based on the current validation item
                if(eval(deliveryDateValue + expression + CRDValue)) {
                    return true;
                }
            }

            return false;
        }


        function initializeTabData(isLogRequired) {
            if(vm.order.Status !== 0) {
                isTabDataInitialized = true;
                if(SecurityFactory.isAuthorized({accessPrivileges: CONSTANTS.PRIVILEGES.ORDERS.DETAIL.REJECTED_ORDERLINES_LIST})) {
                    refreshRejectedOrderlines(true, isLogRequired);
                }
                if(SecurityFactory.isAuthorized({accessPrivileges: CONSTANTS.PRIVILEGES.ORDERS.DETAIL.NOTIFICATIONS})) {
                    refreshNotifications(true, isLogRequired);
                }
                if(SecurityFactory.isAuthorized({accessPrivileges: CONSTANTS.PRIVILEGES.ORDERS.DETAIL.FILES})) {
                    refreshFiles(true, isLogRequired);
                }
            }
            if(SecurityFactory.isAuthorized({accessPrivileges: CONSTANTS.PRIVILEGES.ORDERS.DETAIL.ORDER_STATUS_HISTORY_LIST})) {
                refreshOrderStatusHistoryList(true, isLogRequired);
            }
            if(SecurityFactory.isAuthorized({accessPrivileges: CONSTANTS.PRIVILEGES.ORDERS.DETAIL.IMPACTED_ADJUSTMENTS})) {
                refreshImpactedAdjustmentsList(true, isLogRequired);
            }
        }

        function showSaveOrdersPopup(action, record) {
            if($state.current.name !== 'app.orders.details.orderline-details') {
                var confirmationContent = {};
                confirmationContent.title = 'MESSAGES.TITLE.UNSAVED_ORDERS';
                confirmationContent.message = 'MESSAGES.CONTENT.UNSAVED_ORDERS';
                var confirmationAction = 'ACTIONS.SAVE';
                dialog.confirm(confirmationContent, confirmationAction)
                .then(function(response) {
                    if(response.userAction.toLowerCase() === 'confirm') {
                        api.orders.orderlines.methods.saveDraftOrders(vm.order, catalogCode).then(function() {
                            refreshRecord(false);
                            if(angular.isDefined(action) && action.id === 'submit') {
                                vm.model.methods.submitOrders(vm.order, vm.model, action.id, action.status, catalogCode);
                            }
                        });
                    } else {
                        delete $sessionStorage.UnSavedDraftOrders;
                    }
                }, function () {
                    delete $sessionStorage.UnSavedDraftOrders;
                    if(angular.isDefined(action) && action.id === 'submit') {
                        vm.model.methods.submitOrders(vm.order, vm.model, action.id, action.status, catalogCode);
                    }
                    $mdDialog.hide(false);
                });
            }
        }

        $scope.$on('$destroy', function () {
            var unsavedOrders = angular.isDefined(catalogFactory.getUnsavedDraftOrders()) ? catalogFactory.getUnsavedDraftOrders() : [];
            // if unsaved orders show popup
            if(unsavedOrders.length > 0) {
                showSaveOrdersPopup();
            }
        });
    }
})();
(function () {
	'use strict';

	angular
		.module('app.main.catalogs.order-adjustments')
		.controller('orderAdjustmentsDetailsController', orderAdjustmentsDetailsController);

	/* @ngInject */
	function orderAdjustmentsDetailsController(api, $state, $stateParams, $rootScope, catalogFactory,
		settingsFactory, $filter) {
		/* jshint validthis: true */
		var vm = this;

		// Data
		var adjustmentId = $stateParams.id;
		vm.activeCatalog = catalogFactory.getActiveCatalog();
		var catalogCode = vm.activeCatalog.CatalogCode;

		vm.orderAdjustmentDetailsModel = api.catalogs.orderAdjustmentDetailList;
		settingsFactory.applyPersistedListViewLayout(vm.orderAdjustmentDetailsModel);

		//impacted order model
		vm.impactedOrdersModel = api.catalogs.impactedOrders;
		settingsFactory.applyPersistedListViewLayout(vm.impactedOrdersModel);


		vm.adjustedLines = [];
		vm.filteredAdjustedLines = [];
		vm.impactedOrders = [];
		vm.filteredImpactedOrders = [];
		var keys = [];

		vm.isLoading = false;

		// Methods
		vm.refreshRecord = refreshRecord;

		activate();

		////////////////

		function activate() {
			refreshRecord(true);
		}

		function refreshRecord(isLogRequired) {
			vm.isLoading = true;
			vm.orderAdjustmentDetailsModel.methods.getList(isLogRequired, adjustmentId, catalogCode)
			.then(function (response) {
				vm.adjustedLines = response.data;
				//impacted orders data
				vm.impactedOrders = getImpactedOrders(vm.adjustedLines);

				vm.title = $filter('translate')('ORDER_ADJUSTMENTS.TABS.ORDER_ADJUSTMENT');

				//Update Breadcrumb
				$state.current.data.displayName = vm.title;
				$rootScope.$broadcast('breadcrumb-updated');
			})
			.finally(function () {
				vm.isLoading = false;
			});
		}

		function getImpactedOrders(adjustedLines) {
			var impactedOrders = [];
			angular.forEach(adjustedLines, function(adjustments) {
				var adjustmentsData = adjustments.ImpactedOrders[0];
				var key = adjustmentsData['Id'];
				if(keys.indexOf(key) === -1) {
					keys.push(key);
					impactedOrders.push(adjustmentsData);
				}
			});
			return impactedOrders;
		}

	}
})();
(function() {
  'use strict';

angular
  .module('app.main.catalogs.merch-boards')
  .controller('merchBoardsListController', merchBoardsListController);

/* @ngInject */
function merchBoardsListController(api, $rootScope, $scope, $state, catalogFactory, settingsFactory, $mdDialog, $document) {
  /* jshint validthis: true */
  var vm = this;

  //Data
  var activeCatalog = catalogFactory.getActiveCatalog();
  var catalogCode = activeCatalog.CatalogCode;

  vm.model = api.catalogs.merchBoards;
  settingsFactory.applyPersistedListViewLayout(vm.model);

  vm.merchSlides = [];
  vm.filteredMerchSlides = [];
  vm.isLoading = false;


  //Methods
  vm.refreshItems = refreshItems;
  vm.doListAction = doListAction;
  vm.doItemAction = doItemAction;
  vm.viewItem = viewItem;
  vm.doMerchViewChange = doMerchViewChange;

  activate();

  ////////////////

  function activate() {
    refreshItems(vm.model.isDirty, true);
  }

  function refreshItems(forceFetch, isLogRequired, action, userId) {
    vm.isLoading = true;
    var generalProperties = {
      forceFetch: forceFetch,
      isLogRequired: isLogRequired
    }
    var promise;
    if(angular.isUndefined(action) || action === 'merchBorads') {
      promise = vm.model.methods.getList(generalProperties, catalogCode)
    } else if(angular.isDefined(action) && action !== 'merchBorads') {
      promise = vm.model.methods.getSharedByOrWithSlides(generalProperties, catalogCode, action, userId)
    }

    promise.then(function (response) {
      vm.merchSlides = response.data;
    })
    .finally(function () {
      vm.isLoading = false;
    });
  }

  //Item Action button pressed event
  function doItemAction(action, record) {
    if (action && record) {
      switch (action.id) {
        case 'view':
          viewItem(record);
          break;
        case 'delete':
        case 'activate':
            vm.model.methods.activate(record, vm.model, action.id, catalogCode);
            break;
      }
    }
  }

  //List Action button pressed event
  function doListAction(action, records) {
    if (action) {
      switch (action.id) {
        case 'delete':
        case 'activate':
          vm.model.methods.activate(records, vm.model, action.id, catalogCode);
          break;
      }
    }
  }

  function viewItem(record) {
    var stateParams = { id: record[vm.model.idField], favorite: record };
    $state.go('app.merch_boards.details', stateParams);
  }

  function doMerchViewChange(action) {
    if (action) {
      switch (action.id) {
        case 'merchBorads':
          refreshItems(true, false, action.id);
          break;
        case 'sharedBy':
        case 'sharedWith':
          selectUser(null, action.id);
          break;
      }
    }
  }

  function selectUser(ev, action) {
    $mdDialog.show({
      controller: 'selectUserController',
      controllerAs: 'vm',
      templateUrl: 'app/main/catalogs/sub-modules/merch-boards/list/dialogs/select-user-for-filter/select-user-for-filter.html',
      parent: angular.element($document.body),
      targetEvent: ev,
      clickOutsideToClose: false,
      locals: {
        event: ev
      }
    }).then(function (saved) {
      if (saved && angular.isDefined(saved.UserId)) {
        var userId = saved.UserId;
        refreshItems(true, false, action, userId);
      }
    });
  }

  var catalogChangedEventCleanup = $rootScope.$on('ActiveCatalogChangedEvent', function (e) {
    if (catalogCode !== catalogFactory.getActiveCatalog().CatalogCode) {
      $state.reload('app.merch_boards');
    }
  });
  $scope.$on('$destroy', function () {
    catalogChangedEventCleanup();
  });

}
})();
(function () {
  'use strict';

  angular
    .module('app.main.catalogs.merch-boards')
    .controller('merchBoardsDetailsController', merchBoardsDetailsController);

  /* @ngInject */
  function merchBoardsDetailsController(api, $state, $stateParams, $rootScope, catalogFactory, settingsFactory) {
    /* jshint validthis: true */
    var vm = this;

    // Data
    var merchBoardId = $stateParams.id;
    vm.activeCatalog = catalogFactory.getActiveCatalog();

    var activeCatalogId = vm.activeCatalog.CatalogCode;

    vm.model = api.catalogs.merchBoards;

    vm.sharedWithModelUsers = api.merchBoards.sharedWithUsers;
    settingsFactory.applyPersistedListViewLayout(vm.sharedWithModelUsers);

    vm.sharedWithUserGroupsModel = api.merchBoards.sharedWithUserGroups;
    settingsFactory.applyPersistedListViewLayout(vm.sharedWithUserGroupsModel);

    vm.sharedWithFoldersModel = api.merchBoards.sharedWithFolders;
    settingsFactory.applyPersistedListViewLayout(vm.sharedWithFoldersModel);

    vm.merchSlide = [];
    vm.sharedWithUsers = [];
    vm.filteredSharedWithUsers = [];
    vm.sharedWithUserGroups = [];
    vm.filteredSharedWithUserGroups = [];
    vm.sharedWithFolders = [];
    vm.filteredSharedWithFolders = [];

    vm.isLoading = false;

    // Methods
    vm.refreshRecord = refreshRecord;

    vm.doMerchSlideItemAction = doMerchSlideItemAction;
    vm.doFolderItemAction = doFolderItemAction;
    vm.viewFolder = viewFolder;

    activate();

    ////////////////

    function activate() {
      refreshRecord(true);
    }

    function refreshRecord(isLogRequired) {
      vm.isLoading = true;
      vm.model.methods.getDetails(isLogRequired, merchBoardId, activeCatalogId)
        .then(function (response) {
          vm.merchSlide = response.data;
          vm.sharedWithUsers = response.data.SharedUsersList;
          vm.sharedWithUserGroups = response.data.SharedUsersGroups;
          vm.sharedWithFolders = response.data.SharedFolders;
          vm.title = angular.copy(vm.merchSlide[vm.model.lookupDisplayField]);

           //Update Breadcrumb
           $state.current.data.displayName = vm.title;
           $rootScope.$broadcast('breadcrumb-updated');
        })
        .finally(function () {
          vm.isLoading = false;
        });
    }

    function doMerchSlideItemAction(action, record) {
      if (action) {
        switch (action.id) {
          case 'delete':
          case 'activate':
            vm.model.methods.activate(record, vm.model, action.id, activeCatalogId);
            break;
        }
      }
    }

    function doFolderItemAction(action, record) {
      if (action && record) {
        switch (action.id) {
          case 'view':
            vm.viewFolder(record);
            break;
        }
      }
    }

    function viewFolder(record) {
      var id = record[vm.sharedWithFoldersModel.idField];
      var stateParams = {id:id};
      $state.go('app.shared_folders.details', stateParams);
    }
  }
})();
(function() {
  'use strict';

  angular
    .module('app.main.catalogs.linked-buyers', [])
    .config(config);

    /* @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
    // State
    $stateProvider.state('app.linked_buyers', {
      url: '/linked-buyers',
      views: {
        'content@app': {
          templateUrl: 'app/main/catalogs/sub-modules/linked-buyers/list/linked-buyers-list.html',
          controller: 'linkedBuyersListController as vm'
        }
      },
      data: {
        displayName: 'LINKED_BUYERS.NAV'
      },
      //only users with following accessPrivileges in their role access list can access this route
      // accessPrivileges: ['GetCatalogBuyerUsers']
      // accessPrivileges: ['nav_linked_buyers']
      accessInfo: {
        accessPrivileges: ['nav_linked_buyers']
      }
    });

    // Translation
    $translatePartialLoaderProvider.addPart('app/main/catalogs/sub-modules/linked-buyers');

    // Navigation
    msNavigationServiceProvider.saveItem('catalogs.linked_buyers', {
      title: 'Linked Buyers',
      icon: 'icon-account-multiple',
      state: 'app.linked_buyers',
      translate: 'LINKED_BUYERS.NAV',
      weight: 18,
      // accessPrivileges: ['GetCatalogBuyerUsers']
      // accessPrivileges: ['nav_linked_buyers']
      accessInfo: {
        accessPrivileges: ['nav_linked_buyers']
      }
    });
  }
})();
(function () {
  'use strict';

  angular
    .module('app.main.catalogs.linked-buyers')
    .controller('linkedBuyersListController', linkedBuyersListController);
  // TODO - create and update
  /* @ngInject */
  function linkedBuyersListController(api, $state, $document, $rootScope, $scope, $mdDialog, catalogFactory, dataImporter, dialog, settingsFactory) {
    /* jshint validthis: true */
    var vm = this;

    //Data
    var activeCatalogCode = catalogFactory.getActiveCatalog().CatalogCode;

    vm.model = api.catalogs.linkedBuyers;
    settingsFactory.applyPersistedListViewLayout(vm.model);

    vm.linkedBuyers = [];
    vm.filteredLinkedBuyers = [];
    vm.isLoading = false;

    //Methods
    vm.refreshItems = refreshItems;

    activate();

    ////////////////

    function activate() {
      refreshItems(vm.model.isDirty, true);
    }

    function refreshItems(forceFetch, isLogRequired) {
      var generalProperties = {
        forceFetch: forceFetch,
        isLogRequired: isLogRequired
      }
      vm.isLoading = true;
      return vm.model.methods.getList(generalProperties, vm.model, activeCatalogCode)
        .then(function (response) {
          vm.linkedBuyers = response.data;
        }).finally(function () {
          vm.isLoading = false;
        });
    }

    var catalogChangedEventCleanup = $rootScope.$on('ActiveCatalogChangedEvent', function (e) {
      if (activeCatalogCode !== catalogFactory.getActiveCatalog().CatalogCode) {
        $state.reload('app.linked_buyers');
      }
    });

    $scope.$on('$destroy', function () {
      catalogChangedEventCleanup();
    });
  }
})();
(function () {
    'use strict';

    angular
        .module('app.main.catalogs.images', [])
        .config(config);

    /* @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
        // State
        $stateProvider.state('app.images', {
            url    : '/images',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/catalogs/sub-modules/images/list/images-list.html',
                    controller : 'imagesListController as vm'
                }
            },
            resolve: {
                imagesModel: function(api, catalogFactory, $q, utility) {
                    return (function ($q) {
                        if(catalogFactory.isActiveCatalogInitialized()) {
                            return $q.when()
                        } else {
                            return catalogFactory.setActiveCatalogDetails()
                        }
                    })($q).then(function() {
                        var duneImagesModel = angular.copy(api.catalogs.duneImages);
                        duneImagesModel.methods = api.catalogs.t1Dune.methods;
                        duneImagesModel.baseModel = api.catalogs.duneImages;
                        var activeCatalog = catalogFactory.getActiveCatalog();
                        if(activeCatalog.DataSourceTypeId === 3) {
                            duneImagesModel.views.mainList.itemActions = [];
                            duneImagesModel.views.mainList.listActions = [];
                            duneImagesModel.views.mainList.fabAction.visible = false;
                        }
                        return duneImagesModel;
                    });
                }
            },
            data: {
                displayName: 'IMAGES.NAV'
            },
            //only users with following accessPrivileges in their role access list can access this route
			// accessPrivileges: ['GetCatalogAllArticleImagesList']
            // accessPrivileges: ['nav_images']
            accessInfo: {
                accessPrivileges: ['nav_images']
            }
        });

        $stateProvider.state('app.images.details', {
			url	 : '/:id',
            params: {image : {}},
            views: {
				'content@app': {
					templateUrl: 'app/main/catalogs/sub-modules/images/details/images-details.html',
					controller : 'imagesDetailsController as vm'
				}
			},
            resolve: {
                imagesModel: function(api, catalogFactory, $q, utility) {
                    return (function ($q) {
                        if(catalogFactory.isActiveCatalogInitialized()) {
                            return $q.when()
                        } else {
                            return catalogFactory.setActiveCatalogDetails()
                        }
                    })($q).then(function() {
                        var duneImagesModel = angular.copy(api.catalogs.duneImages);
                        duneImagesModel.methods = api.catalogs.t1Dune.methods;
                        duneImagesModel.baseModel = api.catalogs.duneImages;
                        var activeCatalog = catalogFactory.getActiveCatalog();
                        if(activeCatalog.DataSourceTypeId === 3) {
                            duneImagesModel.views.mainDetails.itemActions = [];
                            duneImagesModel.views.mainDetails.fab.visible = false;
                        }
                        return duneImagesModel;
                    });
                }
            },
			data: {
				parentState: 'app.images',
                displayName:'IMAGES.TABS.IMAGE'
			},
            // no details API
            // accessPrivileges: ['GetCatalogAllArticleImagesList']
            accessInfo: {
                accessPrivileges: ['GetCatalogAllArticleImagesList']
            }
		});

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/catalogs/sub-modules/images');

        msNavigationServiceProvider.saveItem('catalogs.images', {
            title      : 'Images',
            icon       : 'icon-image-filter',
            state      : 'app.images',
            translate  : 'IMAGES.NAV',
            weight     : 110,
            // accessPrivileges: ['GetCatalogAllArticleImagesList']
            // accessPrivileges: ['nav_images']
            accessInfo: {
                accessPrivileges: ['nav_images']
            }
        });
    }
})();
(function() {
    'use strict';

	angular
		.module('app.main.catalogs.images')
		.controller('imagesListController', imagesListController);

	/* @ngInject */
	function imagesListController(api, $mdDialog, $rootScope, $scope, $state, $document, catalogFactory, settingsFactory, imagesModel, utility, dataImporter) {
		/* jshint validthis: true */
		var vm = this;

        // Data
        var activeCatalog = catalogFactory.getActiveCatalog();
        var activeCatalogCode = activeCatalog.CatalogCode;
        var duneContext = activeCatalog.DuneContext;
        var assignedContextKey = catalogFactory.getCatalogContextKey();

        vm.model = imagesModel;
        settingsFactory.applyPersistedListViewLayout(vm.model);

		vm.images = [];
		vm.filteredImages = [];
		vm.isLoading = false;
        var assetTypesMap = {};

        // Methods
		vm.refreshRecords = refreshRecords;
		vm.doListAction = doListAction;
		vm.doItemAction = doItemAction;
		vm.viewRecord = viewRecord;
		vm.addRecord = addRecord;

		// Fetch asset types for resolving AssetTypeId to name
		if(duneContext && assignedContextKey) {
			api.catalogs.t1Dune.methods.getAssetTypes(duneContext, assignedContextKey).then(function(response) {
				angular.forEach(response.data, function(assetType) {
					assetTypesMap[assetType.Id] = assetType.Name;
				});
				activate();
			});
		} else {
			activate();
		}

		////////////////

        function resolveAssetTypeNames(records) {
            angular.forEach(records, function(record) {
                if(angular.isDefined(record.AssetTypeId) && assetTypesMap[record.AssetTypeId]) {
                    record.AssetTypeName = assetTypesMap[record.AssetTypeId];
                } else if(angular.isDefined(record.AssetTypeId)) {
                    record.AssetTypeName = record.AssetTypeId;
                }
            });
        }

        function activate() {
            refreshRecords(vm.model.baseModel.isDirty, true);
		}

		function refreshRecords(forceFetch, isLogRequired) {
            vm.images = [];
            vm.isLoading = true;
            var requestObjet = {};
            var catalogArticleNumbersArray = [];
            var modelNumbersArray = [];
            var catalogArticleNumbersArrayCopy = [];

            var generalProperties = {
                forceFetch: forceFetch,
                isLogRequired: isLogRequired,
                cache: true,
                config: {},
                supportIncrementalResult: true,
                modelIdField: 'Id',
                isMajor: false,
            }
            api.catalogs.articles.methods.getList(generalProperties, vm.model, activeCatalogCode).then(function (articleResponse) {
                catalogArticleNumbersArray = catalogFactory.createCatalogArticleNumbersArray(articleResponse.data, true);
                catalogArticleNumbersArrayCopy = angular.copy(catalogArticleNumbersArray);
                // if modelLevelImagesKeys are assigned then get images assigned for those models.
                if(angular.isDefined(api.modelLevelImagesKeyConfig)) {
                    angular.forEach(articleResponse.data, function(article) {
                        if(article.Status === 1 && !catalogArticleNumbersArray.includes(article.ModelNumber) && article.ModelNumber !== null) {
                            catalogArticleNumbersArray.push(article.ModelNumber);
                        }
                        if(article.Status === 1 && !modelNumbersArray.includes(article.ModelNumber) && article.ModelNumber !== null) {
                            modelNumbersArray.push(article.ModelNumber);
                        }
                    });
                }
                if(catalogArticleNumbersArray.length > 0) {
                    requestObjet = {
                        Context: catalogFactory.getActiveCatalog().DuneContext,
                        ContextKey: catalogFactory.getCatalogContextKey(),
                        FirstImage: true,
                        Op: 'equals',
                        Type : 'ImageSet',
                        Filter: catalogArticleNumbersArray
                    };
                    vm.model.methods.getListByFilter(generalProperties, vm.model, requestObjet).then(function (response) {
                        // get all the model level images if modelLevelImagesKeyConfig is assigned
                        if(angular.isDefined(api.modelLevelImagesKeyConfig)) {
                            angular.forEach(catalogArticleNumbersArrayCopy, function(articleNumber) {
                                var articleImagesArray = utility.filterObject(response.data, { ImageSet: articleNumber }, true);
                                vm.images = vm.images.concat(articleImagesArray);
                            });

                            var modelLevelImages = utility.filterObject(response.data, { SortOrder: 999 }, true);
                            angular.forEach(modelLevelImages, function(duneImage) {
                                angular.forEach(modelNumbersArray, function(modelNumber) {
                                    if(duneImage.ImageSet === modelNumber) {
                                        angular.forEach(api.modelLevelImagesKeyConfig, function(key) {
                                            if(duneImage.Key.toLowerCase() === key.toLowerCase()) {
                                                vm.images.push(duneImage);
                                            }
                                        })
                                    }
                                });
                            });
                        } else {
                            vm.images = response.data;
                        }
                        resolveAssetTypeNames(vm.images);
                        if (angular.isDefined(vm.tableControl) && angular.isDefined(vm.tableControl.updateData)) {
                            vm.tableControl.updateData();
                        }
                    })
                    .finally(function () {
                        vm.isLoading = false;
                    });
                } else {
                    vm.isLoading = false;
                }
            });
        }

		//Item Action button pressed event
		function doItemAction(action, record) {
			if (action && record) {
                switch (action.id) {
                    case 'view':
                        viewRecord(record);
                        break;
                    case 'edit':
                        vm.model.methods.getDetails(true, record[vm.model.idField])
                        .then(function (response) {
                            editRecord(response.data, null);
                        })
                        break;
                    case 'editSortOrder':
                        editSortOrder(record, null);
                        break;
                    case 'delete':
                    case 'activate':
                        vm.model.methods.activateBulk(record, vm.model, action.id, assignedContextKey);
                        break;
                }
			}
		}

        //List Action button pressed event
        function doListAction(action, records) {
            if (action) {
                switch (action.id) {
                    case 'delete':
                    case 'activate':
                        vm.model.methods.activateBulk(records, vm.model, action.id, assignedContextKey);
                        break;
                    case 'updateBulkSortOrder':
                        var modelCopy = angular.copy(vm.model);
                        var imageSetField = utility.filterObject(modelCopy.fields, {field: 'ImageSet'}, true)[0];
                        if(imageSetField) {
                            imageSetField.editable = true;
                        }
                        var fileNameField = utility.filterObject(modelCopy.fields, {field: 'FileName'}, true)[0];
                        if(fileNameField) {
                            fileNameField.editable = true;
                        }
                        var sortOrderField = utility.filterObject(modelCopy.fields, {field: 'SortOrder'}, true)[0];
                        if(sortOrderField) {
                            sortOrderField.editable = true;
                        }
                        dataImporter.importExcel(modelCopy, false).then(function(result) {
                            vm.model.methods.updateBulkSortOrder(result.data, duneContext, assignedContextKey).then(function() {
                                refreshRecords(true);
                            });
                        });
                        break;
                }
            }
        }

        function viewRecord(item) {
            if(item.Status) {
                var id = item[vm.model.idField];
                var stateParams = {id: id, image: item};
                $state.go('app.images.details', stateParams);
            }
        }

        function addRecord(ev) {
            $mdDialog.show({
                controller         : 'uploadDuneImageController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/catalogs/sub-modules/dune-images/dialogs/upload-dune-image/upload-dune-image.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: false,
                locals             : {
                    model: vm.model,
                    record: null,
                    isNew: true,
                    contextKey: assignedContextKey,
                    duneContext: duneContext,
                    isEditSortOrder: false,
                    event: ev
                }
            }).then(function(saved) {
                if (saved) {
                    refreshRecords(true);
                }
            });
		}

		function editRecord(record, ev) {
            $mdDialog.show({
                controller         : 'uploadDuneImageController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/catalogs/sub-modules/dune-images/dialogs/upload-dune-image/upload-dune-image.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: false,
                locals             : {
                    model: vm.model,
                    record: angular.copy(record),
                    isNew: false,
                    contextKey: assignedContextKey,
                    duneContext: duneContext,
                    isEditSortOrder: false,
                    event: ev
                }
            }).then(function(saved) {
                if (saved) {
                    refreshRecords(true);
                }
            });
		}

        function editSortOrder(record, ev) {
            $mdDialog.show({
                controller         : 'uploadDuneImageController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/catalogs/sub-modules/dune-images/dialogs/upload-dune-image/upload-dune-image.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: false,
                locals             : {
                    model: vm.model,
                    record: angular.copy(record),
                    isNew: false,
                    contextKey: assignedContextKey,
                    duneContext: duneContext,
                    isEditSortOrder: true,
                    event: ev
                }
            }).then(function(saved) {
                if (saved) {
                    refreshRecords(true);
                }
            });
        }

        var catalogChangedEventCleanup = $rootScope.$on('ActiveCatalogChangedEvent', function(e) {
            if(activeCatalogCode !== catalogFactory.getActiveCatalog().CatalogCode) {
                $state.reload('app.images');
            }
        });
        $scope.$on('$destroy', function () {
            catalogChangedEventCleanup();
        });
	}
})();
(function() {
    'use strict';

    angular
        .module('app.main.catalogs.images')
        .controller('uploadImagesController', uploadImagesController);

    /* @ngInject */
    function uploadImagesController($mdDialog, $scope, $window, $filter, hotkeys, $rootScope, $localStorage, $auth, toast) {
        /* jshint validthis: true */
        var vm = this;

        //Data
        vm.isLoading = false;
        vm.isFileValid = false;

        if (angular.isUndefined($rootScope.flowObj)) {
            $rootScope.flowObj = {};
        }
        vm.obj = $rootScope.flowObj;

        vm.flowInit = {
            target      : $localStorage.baseUrl + '/UploadFileChunk',
            headers     : { Authorization: 'Bearer ' + $auth.getToken()},
            singleFile  : true
        };


        //Methods
        vm.validateFile = validateFile;
        vm.saveRecord = saveRecord;
        vm.closeDialog = closeDialog;


        activate();

        ////////////////


        function activate() {
            //Hotkeys
            hotkeys.bindTo($scope).add({
                combo: 'ctrl+enter',
                description: $filter('translate')('ACTIONS.SAVE'),
                allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
                callback: function(event) {
                    if (vm.obj.flow.files.length > 0) {
                        vm.saveRecord();
                    }
                }
            });
        }

        function validateFile(file, message, flow) {//TODO- should make custome form validator
            if (angular.isDefined(file) && !file.name.match(/\.(zip|rar|7z)$/)) {
                toast.success('IMAGES.MESSAGES.INVALID_FILE_FORMAT', '', '');
                vm.isFileValid = false;
            }
            else {
                vm.isFileValid = true;
            }
        }

        function saveRecord() {
            closeDialog(vm.obj.flow);
        }

        function closeDialog(saved) {
            $mdDialog.hide(saved);
        }

    }
})();
(function() {
    'use strict';

    angular
        .module('app.main.catalogs.images')
        .controller('uploadImageController', uploadImageController);

    /* @ngInject */
    function uploadImageController(api, $mdDialog, $scope, $window, $filter, hotkeys, $rootScope, $localStorage, utility,
        $auth, toast, model, record, activeCatalogCode, isNew, isArticleDetails, lookupPromises, event) {
        /* jshint validthis: true */
        var vm = this;

        //Data
        vm.model = model;

        if (angular.isUndefined($rootScope.flowObj)) {
            $rootScope.flowObj = {};
        }
        vm.obj = $rootScope.flowObj;

        vm.flowInit = {
            target      : $localStorage.baseUrl + '/UploadFileChunk',
            headers     : { Authorization: 'Bearer ' + $auth.getToken()},
            singleFile  : true
        };

        vm.isFileValid = true;
        vm.isLoading = false;
        vm.isNew = isNew;
        vm.isArticleDetails = isArticleDetails;
        vm.record = record;
        vm.imageTypes = [];
        vm.acticveArticles = [];
        vm.fileName = '';
        if(!vm.record) {
            vm.record = {};
        } else {
            if(vm.record.FileName) {
                vm.fileName = vm.record.FileName.slice(vm.record.FileName.lastIndexOf('/') + 1, vm.record.FileName.length)
            }
        }

        if(!isNew) {
            vm.imgSrc = vm.record.FilePath+'/'+vm.record.FileName
        }
        vm.isDataDirty = false;
        vm.lookupModel = angular.copy(vm.record);
        vm.searchText = {};


        //Methods
        vm.saveRecord = saveRecord;
        vm.closeDialog = closeDialog;
        vm.validateFile = validateFile;
        vm.upload = upload;
        vm.onSuccessUpload = onSuccessUpload;

        vm.lookupSearch = lookupSearch;
        vm.lookupChange = lookupChange;
        vm.getLookupDisplayValue = getLookupDisplayValue;
        vm.selectText = selectText;


        activate();

        ////////////////


        function activate() {
            //Hotkeys
            hotkeys.bindTo($scope).add({
                combo: 'ctrl+enter',
                description: $filter('translate')('ACTIONS.SAVE'),
                allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
                callback: function(event) {
                    if (!vm.isLoading && !vm.editForm.$invalid && vm.obj.flow.files.length > 0 && vm.isFileValid && !vm.obj.flow.isUploading()) {
                        vm.saveRecord();
                    }
                }
            });
            if(vm.isNew) {
                hotkeys.bindTo($scope).add({
                    combo: 'ctrl+shift+enter',
                    description: $filter('translate')('ACTIONS.SAVE_AND_NEW'),
                    allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
                    callback: function(event) {
                        if (!vm.isLoading && !vm.editForm.$invalid && vm.obj.flow.files.length > 0 && vm.isFileValid && !vm.obj.flow.isUploading() && vm.isNew) {
                            vm.saveRecord(true);
                        }
                    }
                });
            }
        }

        function saveRecord(saveAndNew) {
            vm.isLoading = true;
            var promise;
            if(vm.isNew) {
                promise = vm.model.methods.create(vm.record, activeCatalogCode, vm.record.ArticleId);
            }
            else {
                promise = vm.model.methods.update(vm.record[vm.model.idField], vm.record, activeCatalogCode, vm.record.ArticleId);
            }
            promise.then(function() {
                if (vm.isNew && angular.isDefined(saveAndNew) && saveAndNew) {
                    vm.editForm.$setPristine();
                    vm.editForm.$setUntouched();
                    vm.record = {};
                    vm.obj.flow.files.length = 0;
                    vm.searchText = {};
                    vm.isDataDirty = true;

                    var el = $window.document.getElementById('dialog_input_first');
                    if (el) {
                        el.focus();
                    }
                }
                else {
                    closeDialog(true);
                }
                var toastMessage;
                toastMessage = vm.isNew ? 'SUCCESS.CREATE': 'SUCCESS.UPDATE';
                toast.success(toastMessage, '', '');
            }, function(err) {
                closeDialog(vm.isDataDirty);
            }).finally(function () {
                vm.isLoading = false;
            });
        }

        function closeDialog(saved, cancelUpload) {
            //If user cancel upload
            if(angular.isDefined(cancelUpload) && cancelUpload === true){
                vm.obj.flow.cancel();
            }
            $mdDialog.hide(saved);
        }

        function validateFile(file, message, flow) {//TODO- should make custome form validator
            if (angular.isDefined(file) && !file.name.match(/\.(jpe?g|png|gif)$/)) {
                vm.isFileValid = false;
            }
            else {
                vm.isFileValid = true;
            }
        }

        function upload() {
            if(vm.isFileValid) {
                vm.obj.flow.upload();
            }
            else {
                //remove file from flowObj.files if file is not valid and set vm.isFileValid to default value which is true
                // vm.obj.flow.files.splice(vm.obj.flow.files.length-1,1);
                vm.obj.flow.removeFile(vm.obj.flow.files[vm.obj.flow.files.length-1]);// or vm.obj.flow.files[0]
            }
        }

        function onSuccessUpload(file, message, chunk) {
            message = message.replace(/\"/g,"");
            vm.record.FileId = message;
        }

        function lookupSearch(query, fieldName) {
            var results = [];

            var field = utility.filterObject(model.fields, {field: fieldName})[0];
            var lookupFilter = field.lookupFilter ? field.lookupFilter : {};
            var predicate = angular.copy(lookupFilter);
            predicate.value = query;
            var lookupModel = api.getModel(field.lookupSource);

            if(angular.isDefined(lookupModel.lookupData)) {
                results = query ? utility.filterObject(lookupModel.lookupData.data , predicate) :  utility.filterObject(lookupModel.lookupData.data, lookupFilter);
                return results;
            }
            else {
                return lookupPromises[fieldName].then(function() {
                    results = query ? utility.filterObject(lookupModel.lookupData.data , predicate) :  utility.filterObject(lookupModel.lookupData.data, lookupFilter);
                    return results;
                });
            }
        }

        // convert dropdown scope value form object(lookup record) to id property of lookup record
        function lookupChange(selectedObj, field) {
            if(angular.isObject(selectedObj)) {
                vm.record[field] = selectedObj.id;
            }
            else if(angular.isUndefined(selectedObj) || selectedObj === null) {
                vm.record[field] = undefined; // on record removal make field undefined or the property can be deleted using delete keywork
            }
        }

        function getLookupDisplayValue(item, fieldName) {
            var result;
            var field = utility.filterObject(model.fields, {field: fieldName})[0];
            var lookupModel = api.getModel(field.lookupSource);

            if(lookupModel.lookupData) {
                // since autocomplte return object
                if(angular.isObject(item)) {
                    result = utility.filterObject(lookupModel.lookupData.data, {id: item.id}, true);
                }
                // to initialize filed value if any (when open update record dialog)
                else {
                    result = utility.filterObject(lookupModel.lookupData.data, {id: item}, true);
                }

                if (angular.isArray(result) && result.length > 0) {
                    return result[0].value;
                }
                else {
                    return result.value;
                }
            }
        }

        function selectText(event) {
            utility.selectInputText(event);
        }

    }
})();
(function() {
    'use strict';

    angular
        .module('app.main.catalogs.images')
        .controller('imagesDetailsController', imagesDetailsController);

    /* @ngInject */
    function imagesDetailsController(api, $state, $stateParams, $mdDialog, $rootScope, $document, catalogFactory, toast, activityLogger, utility, crud, imagesModel) {
       /* jshint validthis: true */
        var vm = this;

        // Data
        var imageId = $stateParams.id;
        var activeCatalog = catalogFactory.getActiveCatalog();
        var activeCatalogCode = activeCatalog.CatalogCode;
        var duneContext = activeCatalog.DuneContext;
        var assignedContextKey = catalogFactory.getCatalogContextKey();

        vm.model = imagesModel;

        vm.image = {};
        var assetTypesMap = {};

        // Methods
        vm.refreshRecord = refreshRecord;
        vm.doImageItemAction = doImageItemAction;
        vm.editImage = editImage;


        // Fetch asset types then activate
        if(duneContext && assignedContextKey) {
            api.catalogs.t1Dune.methods.getAssetTypes(duneContext, assignedContextKey).then(function(response) {
                angular.forEach(response.data, function(assetType) {
                    assetTypesMap[assetType.Id] = assetType.Name;
                });
                activate();
            });
        } else {
            activate();
        }

        ////////////////

        function activate() {
            refreshRecord(true);
        }

        function refreshRecord(isLogRequired) {
            showMetaData();
            vm.isLoading = true;
            vm.model.methods.getDetails(isLogRequired, imageId, assignedContextKey)
            .then(function (response) {
                // add meta data to the image record
                if (angular.isDefined(response.data.Meta)) {
                    for (var key in response.data.Meta) {
                        if (response.data.Meta.hasOwnProperty(key)) {
                            if (key.toUpperCase() === 'ID') {
                                response.data['MetaId'] = response.data.Meta[key];
                            } else {
                                response.data[key] = response.data.Meta[key];
                            }
                        }
                    }
                }
                delete response.data['Meta'];
                vm.image = response.data;
                if(vm.image.AssetTypeId && assetTypesMap[vm.image.AssetTypeId]) {
                    vm.image.AssetTypeName = assetTypesMap[vm.image.AssetTypeId];
                } else if(vm.image.AssetTypeId) {
                    vm.image.AssetTypeName = vm.image.AssetTypeId;
                }
                vm.title = vm.image[vm.model.lookupDisplayField];
                //Update Breadcrumb
                $state.current.data.displayName = vm.title;
                $rootScope.$broadcast('breadcrumb-updated');
            })
            .finally(function () {
                vm.isLoading = false;
            });
        }

        function doImageItemAction(action, record) {
            if (action) {
                switch (action.id) {
                    case 'delete':
                    case 'activate':
                        vm.model.methods.activateBulk(record, vm.model, action.id, assignedContextKey);
                        break;
                }
            }
        }

        function editImage(ev, record) {
            $mdDialog.show({
                controller         : 'uploadDuneImageController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/catalogs/sub-modules/dune-images/dialogs/upload-dune-image/upload-dune-image.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: false,
                locals             : {
                    model: vm.model,
                    record: angular.copy(record),
                    isNew: false,
                    contextKey: assignedContextKey,
                    duneContext: duneContext,
                    isEditSortOrder: false,
                    event: ev
                }
            }).then(function(saved) {
                if (saved) {
                    refreshRecord();
                }
            });
        }

        // meta data fields are visible false by default , change it to visible for catalog details
        function showMetaData() {
            angular.forEach(vm.model.fields, function(field) {
                if(!field.visible) {
                    field.visible = true;
                }
            });
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.main.catalogs.forecast', [
            'app.main.catalogs.forecast.articles'
        ])
        .config(config);

    /* @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
        // State
        $stateProvider.state('app.forecast', {
            url: '/forecast',
            views: {
                'content@app': {
                    templateUrl: 'app/main/catalogs/sub-modules/forecast/list/forecast-list.html',
                    controller: 'forecastListController as vm'
                }
            },
            data: {
                displayName: 'FORECAST.NAV'
            },
            //only users with following accessPrivileges in their role access list can access this route
            // accessPrivileges: ['GetForecastList']
            // accessPrivileges: ['nav_forecasts']
            accessInfo: {
                accessPrivileges: ['nav_forecasts']
            }
        });
        $stateProvider.state('app.forecast.details', {
            url: '/:id',
            views: {
                'content@app': {
                    templateUrl: 'app/main/catalogs/sub-modules/forecast/details/forecast-details.html',
                    controller: 'forecastDetailsController as vm'
                }
            },
            data: {
                parentState: 'app.forecast',
                displayName: 'FORECAST.TABS.FORECAST'
            },
            //only users with following accessPrivileges in their role access list can access this route
            // accessPrivileges: ['GetForecastDetails']
            accessInfo: {
                accessPrivileges: ['GetForecastDetails']
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/catalogs/sub-modules/forecast');

        msNavigationServiceProvider.saveItem('orders.forecast', {
            title: 'Forecasting',
            icon: 'icon-trending-up',
            state: 'app.forecast',
            translate: 'FORECAST.NAV',
            weight: 124,
            // accessPrivileges: ['GetForecastList']
            // accessPrivileges: ['nav_forecasts']
            accessInfo: {
                accessPrivileges: ['nav_forecasts']
            }
        });
    }
})();
(function () {
  'use strict';

  angular
    .module('app.main.catalogs.forecast')
    .controller('forecastListController', forecastListController);

  /* @ngInject */
  function forecastListController(api, $rootScope, $scope, $state, catalogFactory, dataImporter, settingsFactory, $localStorage, utility) {
    /* jshint validthis: true */
    var vm = this;

    //Data
    var activeCatalog = catalogFactory.getActiveCatalog();
    var catalogCode = activeCatalog.CatalogCode;
    var loggedUserType = $localStorage.account.accountId;

    vm.model = api.catalogs.forecast;
    settingsFactory.applyPersistedListViewLayout(vm.model);

    vm.forecast = [];
    vm.filteredForecast = [];
    vm.isLoading = false;


    //Methods
    vm.refreshItems = refreshItems;
    vm.doItemAction = doItemAction;
    vm.doListAction = doListAction;
    vm.viewItem = viewItem;

    activate();

    ////////////////

    function activate() {
      refreshItems(vm.model.isDirty, true);
    }

    function refreshItems(forceFetch, isLogRequired) {
      vm.isLoading = true;
      var generalProperties = {
        forceFetch: forceFetch,
        isLogRequired: isLogRequired
      }
      vm.model.methods.getList(generalProperties, vm.model, catalogCode)
        .then(function (response) {
          vm.forecast = response.data;
          angular.forEach(vm.forecast, function(record) {
            if(record.TypeId === 3 && loggedUserType === 2) {
              record.disableAction = 1;
            } else {
              record.disableAction = 0;
            }
          })
        })
        .finally(function () {
          vm.isLoading = false;
        });
    }

    //Item Action button pressed event
    function doItemAction(action, record) {
      if (action && record) {
        switch (action.id) {
          case 'activate':
          case 'delete':
                vm.model.methods.activateBulk(record, vm.model, action.id, catalogCode);
                break;
          case 'publish':
          case 'draft':
                vm.model.methods.updatePublishStatusBulk(record, vm.model, action.id, catalogCode);
                break;
          case 'view':
                viewItem(record);
                break;
        }
      }
    }

    //List Action button pressed event
    function doListAction(action, records) {
      if (action) {
        switch (action.id) {
          case 'activate':
          case 'delete':
                vm.model.methods.activateBulk(records, vm.model, action.id, catalogCode);
                break;
          case 'publish':
          case 'draft':
                vm.model.methods.updatePublishStatusBulk(records, vm.model, action.id, catalogCode);
                break;
          case 'import':
                var modelCopy = angular.copy(api.catalogs.importForecast);
                // make Buy Window field creatable  and mandatory mandatory if catalog has more than 1 active buy window
                api.catalogs.buyWindows.methods.getList({forceFetch: true, isLogRequired: false}, catalogCode).then(function(response) {
                  var buyWindowList = [];
                  if(response.data.length > 0) {
                    buyWindowList = utility.filterObject(response.data, {Status: 1}, true);
                    if(buyWindowList.length > 1) {
                      var buyWindowField = utility.filterObject(modelCopy.fields, {field: 'BuyWindowName'}, true)[0];
                      buyWindowField.creatable = true;
                      buyWindowField.validation.dataExistConstraints = { data: buyWindowList , model: api.catalogs.buyWindows};
                    }
                  }
                  dataImporter.importExcel(modelCopy, true).then(function (result) {
                    vm.model.methods.createBulk(vm.model, result.data, catalogCode);
                  })
                });
                break;
        }
      }
    }

    function viewItem(record) {
      if(record.Status === 1) {
        var stateParams = { id: record[vm.model.idField] };
        $state.go('app.forecast.details', stateParams);
      }
    }

    var catalogChangedEventCleanup = $rootScope.$on

    ('ActiveCatalogChangedEvent', function (e) {
      if (catalogCode !== catalogFactory.getActiveCatalog().CatalogCode) {
        $state.reload('app.forecast');
      }
    });

    $scope.$on('$destroy', function () {
      catalogChangedEventCleanup();
    });

  }
})();
(function () {
  'use strict';

  angular
    .module('app.main.catalogs.forecast')
    .controller('forecastDetailsController', forecastDetailsController);

  /* @ngInject */
  function forecastDetailsController(api, $document, $state, $stateParams, $rootScope, catalogFactory, settingsFactory, $localStorage) {
    /* jshint validthis: true */
    var vm = this;

    // Data
    var forecastId = $stateParams.id;
    var activeCatalog = catalogFactory.getActiveCatalog();
    var activeCatalogCode = activeCatalog.CatalogCode;
    var loggedUserType = $localStorage.account.accountId;

    vm.model = angular.copy(api.catalogs.forecast);

    vm.articlesModel = api.forecast.articles;
    settingsFactory.applyPersistedListViewLayout(vm.articlesModel);

    vm.forecast = {};
    vm.articles = [];
    vm.filteredArticles = [];

    vm.isLoading = false;


    // Methods
    vm.refreshRecord = refreshRecord;
    vm.doItemAction = doItemAction;
    vm.doArticlesListAction = doArticlesListAction;
    vm.doArticlesItemAction = doArticlesItemAction;
    vm.viewArticleDetails = viewArticleDetails;

    activate();

    ////////////////

    function activate() {
      refreshRecord(true);
    }


    function refreshRecord(isLogRequired) {
      vm.isLoading = true;
      vm.model.methods.getDetails(isLogRequired, forecastId, activeCatalogCode).then(function (response) {
        vm.forecast = response.data;
        if(vm.forecast.TypeId === 3 && loggedUserType === 2) {
          vm.forecast.disableAction = 1;
        } else {
          vm.forecast.disableAction = 0;
        }
        vm.articles = response.data.ArticleList;
        vm.title = vm.forecast[vm.model.lookupDisplayField];
        //Update Breadcrumb
        $state.current.data.displayName = vm.title;
        $rootScope.$broadcast('breadcrumb-updated');
      })
        .finally(function () {
          vm.isLoading = false;
        });
    }

    function doItemAction(action, record) {
      if (action) {
        switch (action.id) {
          case 'delete':
          case 'activate':
            vm.model.methods.activateBulk(record, vm.model, action.id, activeCatalogCode);
            break;
          case 'publish':
          case 'draft':
            vm.model.methods.updatePublishStatusBulk(record, vm.model, action.id, activeCatalogCode);
            break;
        }
      }
    }

    function doArticlesListAction(action, records) {
      if (action) {
        switch (action.id) {
          case 'delete':
          case 'activate':
            vm.articlesModel.methods.activateBulk(records, vm.articlesModel, action.id, activeCatalogCode, forecastId);
            break;
        }
      }
    }

    function doArticlesItemAction(action, record) {
      if (action) {
        switch (action.id) {
          case 'view':
            viewArticleDetails(record);
            break;
          case 'edit':
            editArticleQuantity(record, null);
            break;
          case 'delete':
          case 'activate':
            vm.articlesModel.methods.activateBulk(record, vm.articlesModel, action.id, activeCatalogCode, forecastId);
            break;
        }
      }
    }

    function editArticleQuantity(item, ev) {
      api.showEditRecordDialog(angular.element($document.body), ev, vm.articlesModel, item, forecastId)
        .then(function (saved) {
          if (saved) {
            refreshRecord(true, false);
          }
        });
    }

    function viewArticleDetails(record) {
      var stateParams = {};
      stateParams.id = record['ArticleId'];
      $state.go('app.articles.details', stateParams)
    }

  }
})();
(function () {
  'use strict';

  angular
    .module('app.main.catalogs.favorites', [
      'app.main.catalogs.favorites.articles',
      'app.main.catalogs.favorites.shared-with-users',
      'app.main.catalogs.favorites.shared-with-user-groups'
    ])
    .config(config);

  /* @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
    // State
    $stateProvider.state('app.favorites', {
      url: '/favorites',
      views: {
        'content@app': {
          templateUrl: 'app/main/catalogs/sub-modules/favorites/list/favorites-list.html',
          controller: 'favoritesListController as vm'
        }
      },
      data: {
        displayName: 'FAVORITES.NAV'
      },
      //only users with following accessPrivileges in their role access list can access this route
      // accessPrivileges: ['GetMyUserFavorites']
      // accessPrivileges: ['nav_favorites']
      accessInfo: {
        accessPrivileges: ['nav_favorites']
      },
      visibleForLinePlan: true
    });
    $stateProvider.state('app.favorites.details', {
      url: '/:id',
      params: {tab :'details'},
      views: {
        'content@app': {
          templateUrl: 'app/main/catalogs/sub-modules/favorites/details/favorites-details.html',
          controller: 'favoritesDetailsController as vm'
        }
      },
      data: {
        parentState: 'app.favorites',
        displayName: 'FAVORITES.NAV'
      },
      //only users with following accessPrivileges in their role access list can access this route
      // accessPrivileges: ['GetUserFavoriteDetails']
      accessInfo: {
        accessPrivileges: ['GetUserFavoriteDetails']
      },
      visibleForLinePlan: true
    });

    // Translation
    $translatePartialLoaderProvider.addPart('app/main/catalogs/sub-modules/favorites');

    msNavigationServiceProvider.saveItem('catalogs.favorites', {
      title: 'Favorites',
      icon: 'icon-star-circle',
      state: 'app.favorites',
      translate: 'FAVORITES.NAV',
      weight: 43,
      // accessPrivileges: ['nav_favorites'],
      accessInfo: {
        accessPrivileges: ['nav_favorites']
      },
      visibleForLinePlan: true
    });

  }
})();
(function() {
  'use strict';

angular
  .module('app.main.catalogs.favorites')
  .controller('favoritesListController', favoritesListController);

/* @ngInject */
function favoritesListController(api, $rootScope, $scope, $state, $document, catalogFactory, settingsFactory, $localStorage) {
  /* jshint validthis: true */
  var vm = this;

  //Data
  var activeCatalog = catalogFactory.getActiveCatalog();
  var catalogCode = activeCatalog.CatalogCode;

  vm.model = api.catalog.favorites;
  settingsFactory.applyPersistedListViewLayout(vm.model);

  vm.favorites = [];
  vm.filteredFavorites = [];
  vm.isLoading = false;


  //Methods
  vm.refreshItems = refreshItems;
  vm.doListAction = doListAction;
  vm.doItemAction = doItemAction;
  vm.viewItem = viewItem;
  vm.addRecord = addRecord;

  activate();

  ////////////////

  function activate() {
    refreshItems(vm.model.isDirty, true);
  }

  function refreshItems(forceFetch, isLogRequired) {
    vm.isLoading = true;
    var generalProperties = {
      forceFetch: forceFetch,
      isLogRequired: isLogRequired
    }
    vm.model.methods.getList(generalProperties, vm.model, catalogCode)
      .then(function (response) {
        vm.favorites = response.data;
      })
      .finally(function () {
        vm.isLoading = false;
      });
  }

  //Item Action button pressed event
  function doItemAction(action, record) {
    if (action && record) {
      switch (action.id) {
        case 'view':
          viewItem(record);
          break;
        case 'edit':
          vm.model.methods.getDetails(true, record[vm.model.idField], catalogCode)
          .then(function (response) {
            editItem(response.data, null);
          })
          break;
        case 'delete':
        case 'activate':
            vm.model.methods.activate(record, vm.model, action.id, catalogCode);
            break;
      }
    }
  }

  //List Action button pressed event
  function doListAction(action, records) {
    if (action) {
      switch (action.id) {
        case 'delete':
        case 'activate':
          vm.model.methods.activate(records, vm.model, action.id, catalogCode);
          break;
      }
    }
  }

  function viewItem(record) {
    var stateParams = { id: record[vm.model.idField], favorite: record };
    $state.go('app.favorites.details', stateParams);
  }

  function addRecord(ev) {
    var modelCopy = angular.copy(vm.model);
    api.showCreateRecordDialog(angular.element($document.body), ev, modelCopy, catalogCode, undefined, undefined, undefined, [{'SharedUsers':[$localStorage.UserId]}], angular.copy(vm.favorites))
      .then(function (saved) {
        if (saved) {
          refreshItems(true, false);
        }
      });
  }

  function editItem(record, ev) {
    var modelCopy = angular.copy(vm.model);
    var existingRecordsForUniqueValue = angular.copy(vm.favorites);
    for (var i = 0; i < existingRecordsForUniqueValue.length; i++){
      if(existingRecordsForUniqueValue[i].Id === record.Id) {
        existingRecordsForUniqueValue.splice(i, 1);
      }
    }
    api.showEditRecordDialog(angular.element($document.body), ev, modelCopy, record, catalogCode, undefined, undefined, [{'SharedUsers':[$localStorage.UserId]}], existingRecordsForUniqueValue)
      .then(function (saved) {
        if (saved) {
          refreshItems(true, false);
        }
      });
  }

  var catalogChangedEventCleanup = $rootScope.$on('ActiveCatalogChangedEvent', function (e) {
    if (catalogCode !== catalogFactory.getActiveCatalog().CatalogCode) {
      $state.reload('app.favorites');
    }
  });
  $scope.$on('$destroy', function () {
    catalogChangedEventCleanup();
  });

}
})();
(function () {
  'use strict';

  angular
    .module('app.main.catalogs.favorites')
    .controller('favoritesDetailsController', favoritesDetailsController);

  /* @ngInject */
  function favoritesDetailsController(api, $state, $stateParams, $rootScope, catalogFactory, settingsFactory) {
    /* jshint validthis: true */
    var vm = this;

    // Data
    var favoriteId = $stateParams.id;
    var tabName = $stateParams.tab.toUpperCase();
    vm.activeCatalog = catalogFactory.getActiveCatalog();

    var activeCatalogId = vm.activeCatalog.CatalogCode;
    var activeCatalogDetails = catalogFactory.getActiveCatalogDetails();

    vm.model = api.catalog.favorites;

    vm.articlesModel = api.favorites.articles;
    settingsFactory.applyPersistedListViewLayout(vm.articlesModel);

    vm.sharedWithModelUsers = api.favorites.sharedWithUsers;
    settingsFactory.applyPersistedListViewLayout(vm.sharedWithModelUsers);
    vm.sharedWithModelUserGroups = api.favorites.sharedWithUserGroups;
    settingsFactory.applyPersistedListViewLayout(vm.sharedWithModelUserGroups);

    vm.favorite = [];
    vm.articles =[];
    vm.filteredArticles = [];
    vm.sharedWithUsers = [];
    vm.filteredSharedWithUsers = [];
    vm.sharedWithUserGroups = [];
    vm.filteredSharedWithUserGroups = [];

    vm.isLoading = false;

    // Methods
    vm.refreshRecord = refreshRecord;

    vm.doFavoriteItemAction = doFavoriteItemAction;

    activate();

    ////////////////

    function activate() {
      refreshRecord(true);
    }

    function refreshRecord(isLogRequired) {
      vm.isLoading = true;
      vm.model.methods.getDetails(isLogRequired, favoriteId, activeCatalogId)
        .then(function (response) {
          vm.favorite = response.data;
          vm.articles = response.data.ArticlesList;
          vm.sharedWithUsers = response.data.SharedUsersList;
          vm.sharedWithUserGroups = response.data.SharedUsersGroups;
          vm.favorite.Articles = populateFavoriteArticles(vm.articles);
          vm.favorite.SharedUsers = populateFavoriteSharedUsers(vm.sharedWithUsers);

          vm.title = angular.copy(vm.favorite[vm.model.lookupDisplayField]);

           //Update Breadcrumb
           $state.current.data.displayName = vm.title;
           $rootScope.$broadcast('breadcrumb-updated');
        })
        .finally(function () {
          vm.isLoading = false;
        });
    }

    function doFavoriteItemAction(action, record) {
      if (action) {
        switch (action.id) {
          case 'delete':
          case 'activate':
            vm.model.methods.activate(record, vm.model, action.id, activeCatalogId);
            break;
        }
      }
    }

    function populateFavoriteArticles(articles) {
      var result = [];
      angular.forEach(articles, function (article) {
        if(result.indexOf(article.ArticleId) === -1) {
          result.push(article.ArticleId);
        }
      });
      return result;
    }

    function populateFavoriteSharedUsers(users) {
      var result = [];
      angular.forEach(users, function (user) {
        result.push(user.UserId);
      });
      return result;
    }

  }
})();
(function() {
	'use strict';

	angular
		.module('app.main.catalogs.dune-images')
		.controller('t1DuneListController', t1DuneListController);

	/* @ngInject */
	function t1DuneListController($q, $mdDialog, $state, $document, catalogFactory, duneImagesModel, settingsFactory, $rootScope, $scope, api, utility, dataImporter, duneImagesPaginationCache, $timeout) {
		/* jshint validthis: true */
		var vm = this;

		// Data
		var activeCatalog = catalogFactory.getActiveCatalog();
		var activeCatalogCode = activeCatalog.CatalogCode;
		var duneContext = activeCatalog.DuneContext;
		var assignedContextKey = catalogFactory.getCatalogContextKey();

		vm.model = duneImagesModel;
		settingsFactory.applyPersistedListViewLayout(vm.model);
		vm.images = [];
		vm.filteredImages = [];
		vm.isLoading = false;
		var ITEMS_PER_PAGE = 100;
		vm.currentPage = 0;
		vm.totalCount = 0;
		vm.hasMorePages = false;
		var pagesMap = {};
		var assetTypesMap = {};

		// Methods
		vm.refreshRecords = refreshRecords;
		vm.doListAction = doListAction;
		vm.doItemAction = doItemAction;
		vm.viewRecord = viewRecord;
		vm.addRecord = addRecord;
		vm.loadNextPage = loadNextPage;

		// Fetch asset types for resolving AssetTypeId to name
		if(duneContext && assignedContextKey) {
			vm.model.methods.getAssetTypes(duneContext, assignedContextKey).then(function(response) {
				angular.forEach(response.data, function(assetType) {
					assetTypesMap[assetType.Id] = assetType.Name;
				});
				activate();
			});
		} else {
			activate();
		}

		////////////////

		function activate() {
			var isDirty = api.catalogs.t1Dune.isDirty;
			if (duneImagesPaginationCache.hasCachedState()) {
				if (isDirty) {
					// Changes were made — refetch all previously loaded pages, scroll to top
					refreshAllCachedPages();
				} else {
					// No changes — restore cached state with scroll position
					restoreFromCache();
				}
			} else {
				refreshRecords();
			}
		}

		function restoreFromCache() {
			var cached = duneImagesPaginationCache.get();
			duneImagesPaginationCache.clear();

			// Restore pagination state
			pagesMap = cached.pagesMap;
			vm.currentPage = cached.currentPage;
			vm.totalCount = cached.totalCount;
			vm.hasMorePages = cached.hasMorePages;

			// Rebuild images from all cached pages and restore scroll position
			vm.model.views.mainList.topIndex = cached.topIndex;
			vm.images = rebuildImagesFromPagesMap();
		}

		function refreshAllCachedPages() {
			var cached = duneImagesPaginationCache.get();
			duneImagesPaginationCache.clear();

			var totalPages = cached.currentPage;
			vm.currentPage = totalPages;
			vm.totalCount = cached.totalCount;
			vm.hasMorePages = cached.hasMorePages;
			pagesMap = {};
			vm.isLoading = true;

			// Fetch all pages that were previously loaded (page 0 through currentPage)
			var promises = [];
			for (var i = 0; i <= totalPages; i++) {
				promises.push(fetchPage(i));
			}

			// Wait for all pages, rebuild the flat array, retain scroll position
			$q.all(promises).then(function (results) {
				for (var i = 0; i < results.length; i++) {
					pagesMap[i] = results[i];
				}
				vm.model.views.mainList.topIndex = cached.topIndex;
				vm.images = rebuildImagesFromPagesMap();
				// Update totalCount from first page if available
				if (angular.isDefined(vm.tableControl) && angular.isDefined(vm.tableControl.updateData)) {
					vm.tableControl.updateData();
				}
			}).finally(function () {
				vm.isLoading = false;
			});
		}

		function rebuildImagesFromPagesMap() {
			var result = [];
			for (var i = 0; i <= vm.currentPage; i++) {
				if (pagesMap[i]) {
					result = result.concat(pagesMap[i]);
				}
			}
			return result;
		}

		function getFieldDef(fieldName) {
			for (var i = 0; i < vm.model.fields.length; i++) {
				if (vm.model.fields[i].field === fieldName) {
					return vm.model.fields[i];
				}
			}
			return { inputType: 'text' };
		}

		function buildFilterModel() {
			var columnFilter = vm.model.views.mainList.columnFilter;
			var filterModel = {};
			angular.forEach(columnFilter, function(value, field) {
				if (value === null || value === undefined || value === '') { return; }
				var fieldDef = getFieldDef(field);
				switch (fieldDef.inputType) {
					case 'bool':
						filterModel[field] = { filterType: 'set', values: [value] };
						break;
					case 'number':
						filterModel[field] = { filterType: 'number', type: 'equals', filter: Number(value) };
						break;
					case 'date':
						filterModel[field] = { filterType: 'date', type: 'greaterThan', filter: value };
						break;
					default:
						filterModel[field] = { filterType: 'text', type: 'contains', filter: value };
						break;
				}
			});
			return filterModel;
		}

		function buildSortModel() {
			var sortColumn = vm.model.views.mainList.sortColumn;
			var sortModel = [];
			angular.forEach(sortColumn, function(isAsc, colId) {
				sortModel.push({ colId: colId, sort: isAsc ? 'asc' : 'desc' });
			});
			if (sortModel.length === 0) {
				sortModel.push({ colId: 'UpdatedOn', sort: 'desc' });
			}
			return sortModel;
		}

		function fetchPage(pageIndex) {
			var startRow = pageIndex * ITEMS_PER_PAGE;
			var endRow = startRow + ITEMS_PER_PAGE;
			var requestBody = {
				Context: duneContext,
				ContextKey: assignedContextKey,
				startRow: startRow,
				endRow: endRow,
				filterModel: buildFilterModel(),
				sortModel: buildSortModel()
			};
			return vm.model.methods.queryAssets(requestBody)
			.then(function (response) {
				var data = response.data;
				if (angular.isDefined(data.rowCount)) {
					vm.totalCount = data.rowCount;
				}
				return catalogFactory.transformDunesResponse(angular.copy(data.rows || []), assetTypesMap);
			});
		}

		function getPageForItem(item) {
			var id = item[vm.model.idField];
			for (var page in pagesMap) {
				if (pagesMap.hasOwnProperty(page)) {
					var pageItems = pagesMap[page];
					for (var i = 0; i < pageItems.length; i++) {
						if (pageItems[i][vm.model.idField] === id) {
							return parseInt(page, 10);
						}
					}
				}
			}
			return 0;
		}

		function savePaginationState(clickedPage) {
			duneImagesPaginationCache.save({
				pagesMap: pagesMap,
				currentPage: vm.currentPage,
				clickedPage: clickedPage,
				topIndex: vm.model.views.mainList.topIndex,
				totalCount: vm.totalCount,
				hasMorePages: vm.hasMorePages
			});
		}

		function refreshRecords() {
			vm.currentPage = 0;
			vm.hasMorePages = false;
			pagesMap = {};
			duneImagesPaginationCache.clear();
			vm.isLoading = true;

			var startRow = 0;
			var endRow = ITEMS_PER_PAGE;
			var requestBody = {
				Context: duneContext,
				ContextKey: assignedContextKey,
				startRow: startRow,
				endRow: endRow,
				filterModel: buildFilterModel(),
				sortModel: buildSortModel()
			};

			vm.model.methods.queryAssets(requestBody)
			.then(function (response) {
				var data = response.data;
				var pageImages = catalogFactory.transformDunesResponse(angular.copy(data.rows || []), assetTypesMap);
				pagesMap[0] = pageImages;
				vm.images = pageImages;
				if (angular.isDefined(data.rowCount)) {
					vm.totalCount = data.rowCount;
				}
				vm.hasMorePages = (startRow + pageImages.length) < vm.totalCount;
				if (angular.isDefined(vm.tableControl) && angular.isDefined(vm.tableControl.updateData)) {
					vm.tableControl.updateData();
				}
			})
			.finally(function () {
				vm.isLoading = false;
			});
		}

		function loadNextPage() {
			vm.currentPage++;
			var startRow = vm.currentPage * ITEMS_PER_PAGE;
			var endRow = startRow + ITEMS_PER_PAGE;
			var requestBody = {
				Context: duneContext,
				ContextKey: assignedContextKey,
				startRow: startRow,
				endRow: endRow,
				filterModel: buildFilterModel(),
				sortModel: buildSortModel()
			};

			vm.model.methods.queryAssets(requestBody)
			.then(function (response) {
				var data = response.data;
				var newImages = catalogFactory.transformDunesResponse(angular.copy(data.rows || []), assetTypesMap);
				pagesMap[vm.currentPage] = newImages;
				vm.images = vm.images.concat(newImages);
				if (angular.isDefined(data.rowCount)) {
					vm.totalCount = data.rowCount;
				}
				vm.hasMorePages = (startRow + newImages.length) < vm.totalCount;
				if (angular.isDefined(vm.tableControl) && angular.isDefined(vm.tableControl.updateData)) {
					vm.tableControl.updateData();
				}
			});
		}

		//Item Action button pressed event
		function doItemAction(action, record) {
			if (action && record) {
				switch (action.id) {
					case 'view':
						viewRecord(record);
						break;
					case 'edit':
						vm.model.methods.getDetails(true, record[vm.model.idField])
						.then(function (response) {
							editRecord(response.data, null);
						})
						break;
					case 'editSortOrder':
						editSortOrder(record, null);
						break;
					case 'delete':
					case 'activate':
						vm.model.methods.activateBulk(record, vm.model, action.id, assignedContextKey);
						break;
					case 'assignTag':
						var additionalInfo = { 'additionalAction': 'assignTag'};
						api.showCreateRecordDialog(angular.element($document.body), null, vm.model, null, [record], null, additionalInfo)
						.then(function (saved) {
							if (saved) {
								refreshRecords();
							}
						});
						break;
					case 'removeTag':
						$mdDialog.show({
							controller         : 'removeTagsController',
							controllerAs       : 'vm',
							templateUrl        : 'app/main/catalogs/sub-modules/dune-images/dialogs/remove-tag/remove-tag.html',
							parent             : angular.element($document.body),
							targetEvent        : null,
							clickOutsideToClose: false,
							locals             : {
								model: vm.model,
								records: [record],
								contextKey: assignedContextKey,
								event: null
							}
						}).then(function(saved) {
							if (saved) {
								refreshRecords();
							}
						});
						break;
				}
			}
		}

		//List Action button pressed event
		function doListAction(action, records) {
			if (action) {
				switch (action.id) {
					case 'delete':
					case 'activate':
						vm.model.methods.activateBulk(records, vm.model, action.id, assignedContextKey);
						break;
					case 'assignTag':
						var additionalInfo = { 'additionalAction': 'assignTag'};
						api.showCreateRecordDialog(angular.element($document.body), null, vm.model, null, records, null, additionalInfo)
						.then(function (saved) {
							if (saved) {
								refreshRecords();
							}
						});
						break;
					case 'removeTag':
						$mdDialog.show({
							controller         : 'removeTagsController',
							controllerAs       : 'vm',
							templateUrl        : 'app/main/catalogs/sub-modules/dune-images/dialogs/remove-tag/remove-tag.html',
							parent             : angular.element($document.body),
							targetEvent        : null,
							clickOutsideToClose: false,
							locals             : {
								model: vm.model,
								records: records,
								contextKey: assignedContextKey,
								event: null
							}
						}).then(function(saved) {
							if (saved) {
								refreshRecords();
							}
						});
						break;
					case 'updateBulkSortOrder':
						var modelCopy = angular.copy(vm.model);
						var imageSetField = utility.filterObject(modelCopy.fields, {field: 'ImageSet'}, true)[0];
						if(imageSetField) {
							imageSetField.editable = true;
						}
						var fileNameField = utility.filterObject(modelCopy.fields, {field: 'FileName'}, true)[0];
						if(fileNameField) {
							fileNameField.editable = true;
						}
						var sortOrderField = utility.filterObject(modelCopy.fields, {field: 'SortOrder'}, true)[0];
						if(sortOrderField) {
							sortOrderField.editable = true;
						}
						var tagsField = utility.filterObject(modelCopy.fields, {field: 'Tags'}, true)[0];
						if(tagsField) {
							tagsField.editable = false;
						}
						dataImporter.importExcel(modelCopy, false).then(function(result) {
							vm.model.methods.updateBulkSortOrder(result.data, duneContext, assignedContextKey).then(function() {
								refreshRecords();
							});
						});
						break;
				}
			}
		}

		 function viewRecord(item) {
			if(item.Status) {
				var id = item[vm.model.idField];
				var clickedPage = getPageForItem(item);
				savePaginationState(clickedPage);
				var stateParams = {id: id};
				$state.go('app.dune-images.details', stateParams);
			}
		}

		function addRecord(ev) {
			$mdDialog.show({
				controller         : 'uploadDuneImageController',
				controllerAs       : 'vm',
				templateUrl        : 'app/main/catalogs/sub-modules/dune-images/dialogs/upload-dune-image/upload-dune-image.html',
				parent             : angular.element($document.body),
				targetEvent        : ev,
				clickOutsideToClose: false,
				locals             : {
					model: vm.model,
					record: null,
					isNew: true,
					contextKey: assignedContextKey,
					duneContext: duneContext,
					isEditSortOrder: false,
					event: ev
				}
			}).then(function(saved) {
				if (saved) {
					refreshRecords();
				}
			});
		}

		function editRecord(record, ev) {
			$mdDialog.show({
				controller         : 'uploadDuneImageController',
				controllerAs       : 'vm',
				templateUrl        : 'app/main/catalogs/sub-modules/dune-images/dialogs/upload-dune-image/upload-dune-image.html',
				parent             : angular.element($document.body),
				targetEvent        : ev,
				clickOutsideToClose: false,
				locals             : {
					model: vm.model,
					record: angular.copy(record),
					isNew: false,
					contextKey: assignedContextKey,
					duneContext: duneContext,
					isEditSortOrder: false,
					event: ev
				}
			}).then(function(saved) {
				if (saved) {
					refreshRecords();
				}
			});
		}

		function editSortOrder(record, ev) {
			$mdDialog.show({
				controller         : 'uploadDuneImageController',
				controllerAs       : 'vm',
				templateUrl        : 'app/main/catalogs/sub-modules/dune-images/dialogs/upload-dune-image/upload-dune-image.html',
				parent             : angular.element($document.body),
				targetEvent        : ev,
				clickOutsideToClose: false,
				locals             : {
					model: vm.model,
					record: angular.copy(record),
					isNew: false,
					contextKey: assignedContextKey,
					duneContext: duneContext,
					isEditSortOrder: true,
					event: ev
				}
			}).then(function(saved) {
				if (saved) {
					refreshRecords();
				}
			});
		}

		// Server-side filter: debounce column filter changes and re-fetch
		var filterDebounce;
		$scope.$watch(function() { return vm.model.views.mainList.columnFilter; }, function(newVal, oldVal) {
			if (newVal !== oldVal) {
				if (filterDebounce) { $timeout.cancel(filterDebounce); }
				filterDebounce = $timeout(function() { refreshRecords(); }, 300);
			}
		}, true);

		// Server-side sort: re-fetch when sort column changes
		$scope.$watch(function() { return vm.model.views.mainList.sortColumn; }, function(newVal, oldVal) {
			if (newVal !== oldVal) {
				refreshRecords();
			}
		}, true);

		var catalogChangedEventCleanup = $rootScope.$on('ActiveCatalogChangedEvent', function(e) {
			if(activeCatalogCode !== catalogFactory.getActiveCatalog().CatalogCode) {
				$state.reload('app.dune-images');
			}
		});
		$scope.$on('$destroy', function () {
			catalogChangedEventCleanup();
			if (filterDebounce) { $timeout.cancel(filterDebounce); }
		});

	}
})();
(function () {
	'use strict';

	angular
		.module('app.main.catalogs.dune-images')
		.controller('t1DuneDetailsController', t1DuneDetailsController);

	/* @ngInject */
	function t1DuneDetailsController(api, $state, $stateParams, $mdDialog, $rootScope, $document, catalogFactory, settingsFactory, duneImagesModel) {
		/* jshint validthis: true */
		var vm = this;

		// Data
		var imageId = $stateParams.id;
		var assignedContextKey = catalogFactory.getCatalogContextKey();
		var duneContext = catalogFactory.getActiveCatalog().DuneContext;

		vm.model = duneImagesModel;

		vm.tagsModel = api.t1Dune.tags;
		settingsFactory.applyPersistedListViewLayout(vm.tagsModel);

		vm.image = {};
		var assetTypesMap = {};

		vm.tags = [];
		vm.filteredTags = [];

		// Methods
		vm.refreshRecord = refreshRecord;
		vm.doImageItemAction = doImageItemAction;
		vm.editImage = editImage;


		// Fetch asset types then activate
		if(duneContext && assignedContextKey) {
			api.catalogs.t1Dune.methods.getAssetTypes(duneContext, assignedContextKey).then(function(response) {
				angular.forEach(response.data, function(assetType) {
					assetTypesMap[assetType.Id] = assetType.Name;
				});
				activate();
			});
		} else {
			activate();
		}

		////////////////

		function activate() {
			refreshRecord(true);
		}

		function refreshRecord(isLogRequired) {
			vm.isLoading = true;
			vm.model.methods.getDetails(isLogRequired, imageId, assignedContextKey)
				.then(function (response) {
					vm.image = response.data;
					if(vm.image.AssetTypeId && assetTypesMap[vm.image.AssetTypeId]) {
						vm.image.AssetTypeName = assetTypesMap[vm.image.AssetTypeId];
					} else if(vm.image.AssetTypeId) {
						vm.image.AssetTypeName = vm.image.AssetTypeId;
					}
					vm.tags = vm.image.Tags;
					vm.title = vm.image[vm.model.lookupDisplayField];
					//Update Breadcrumb
					$state.current.data.displayName = vm.title;
					$rootScope.$broadcast('breadcrumb-updated');
				})
				.finally(function () {
					vm.isLoading = false;
				});
		}

		function doImageItemAction(action, record) {
			if (action) {
				switch (action.id) {
					case 'delete':
					case 'activate':
						vm.model.methods.activateBulk(record, vm.model, action.id, assignedContextKey);
						break;
					case 'assignTag':
						var additionalInfo = { 'additionalAction': 'assignTag'};
						api.showCreateRecordDialog(angular.element($document.body), null, vm.model, null, [record], null, additionalInfo)
						.then(function (saved) {
							if (saved) {
								refreshRecord(true);
							}
						});
						break;
					case 'removeTag':
						$mdDialog.show({
							controller         : 'removeTagsController',
							controllerAs       : 'vm',
							templateUrl        : 'app/main/catalogs/sub-modules/dune-images/dialogs/remove-tag/remove-tag.html',
							parent             : angular.element($document.body),
							targetEvent        : null,
							clickOutsideToClose: false,
							locals             : {
								model: vm.model,
								records: [record],
								contextKey: assignedContextKey,
								event: null
							}
						}).then(function(saved) {
							if (saved) {
								refreshRecords(true, false);
							}
						});
						break;
				}
			}
		}

		function editImage(ev, record) {
			$mdDialog.show({
				controller         : 'uploadDuneImageController',
				controllerAs       : 'vm',
				templateUrl        : 'app/main/catalogs/sub-modules/dune-images/dialogs/upload-dune-image/upload-dune-image.html',
				parent             : angular.element($document.body),
				targetEvent        : ev,
				clickOutsideToClose: false,
				locals             : {
					model: vm.model,
					record: angular.copy(record),
					isNew: false,
					contextKey: assignedContextKey,
					duneContext: duneContext,
					isEditSortOrder: false,
					event: ev
				}
			}).then(function(saved) {
				if (saved) {
					refreshRecord();
				}
			});
		}
	}
})();
(function () {
	'use strict';

	angular
		.module('app.main.catalog-customers.segmentation-linear')
		.controller('customersSegmentationLinearController', customersSegmentationLinearController);

	/* @ngInject */
	function customersSegmentationLinearController(api, $rootScope, $scope, $state, catalogFactory, customerSpecificSegmentationModel,
		dataImporter, $timeout, settingsFactory, crud, $mdDialog, $document, utility) {
		/* jshint validthis: true */
		var vm = this;


		//Data

		var activeCatalog = catalogFactory.getActiveCatalog();
		var activeCatalogId = activeCatalog.CatalogCode;
		var sellerId = activeCatalog.AccountId;

		vm.model = customerSpecificSegmentationModel;
		settingsFactory.applyPersistedListViewLayout(vm.model);
		var activieCatalogSegmentationList = catalogFactory.getActiveCatalogDetails().CatalogSegmentationList;
		var isRoleBasedRestrictedSegmentationsAdded = (angular.isDefined(api.roleBasedRestrictions) && angular.isDefined(api.roleBasedRestrictions.restrictedSegmentationsArray) && api.roleBasedRestrictions.restrictedSegmentationsArray.length > 0) ? true : false;

		vm.segmentations = [];
		vm.filteredSegmentations = [];
		vm.isLoading = false;
		var timeoutPromise;


		//Methods

		vm.refreshItems = refreshItems;
		vm.doItemAction = doItemAction;
		vm.doListAction = doListAction;
		vm.viewItem = viewItem;
		vm.assignCustomerSegmentations = assignCustomerSegmentations;

		activate();

		////////////////

		function activate() {
			refreshItems(vm.model.isDirty, true);
		}

		function refreshItems(forceFetch, isLogRequired) {
			vm.isLoading = true;
			var generalProperties = {
				forceFetch: forceFetch,
				isLogRequired: isLogRequired
			}
			timeoutPromise = $timeout(function () {
				vm.model.methods.getList(generalProperties, vm.model, activeCatalogId, sellerId)
					.then(function (response) {
						var responseData = [];
						angular.forEach(response.data, function(customer) {
							if(angular.isDefined(customer.Segmentations) && customer.Segmentations.length > 0) {
								angular.forEach(customer.Segmentations, function(segmentation) {
									var index = activieCatalogSegmentationList.indexOf(utility.filterObject(activieCatalogSegmentationList, { Id: segmentation.SegmentationId, Status: 1 }, true)[0]);
									if (index !== -1) {
										if(!isRoleBasedRestrictedSegmentationsAdded) {
											responseData.push({
												CustomerId: customer.Id,
												CustomerNumber: customer.CustomerNumber,
												DPAccountGroup: customer.DPAccountGroup,
												CustomerName: customer.CustomerName,
												Status: 1,
												SegmentationId: segmentation.SegmentationId,
												CreatedDate: segmentation.CreatedDate,
												UpdatedDate: segmentation.UpdatedDate
											});
										} else {
											// check if any restricted segmentations
											var restrictedSegmentation = utility.filterObject(api.roleBasedRestrictions.restrictedSegmentationsArray, { Id: segmentation.SegmentationId}, true)[0];
											if(angular.isDefined(restrictedSegmentation) && !restrictedSegmentation.notViewable && restrictedSegmentation.notEditable) {
												responseData.push({
													CustomerId: customer.Id,
													CustomerNumber: customer.CustomerNumber,
													DPAccountGroup: customer.DPAccountGroup,
													CustomerName: customer.CustomerName,
													Status: 1,
													SegmentationId: segmentation.SegmentationId,
													CreatedDate: segmentation.CreatedDate,
													UpdatedDate: segmentation.UpdatedDate
												});
											} else if(angular.isUndefined(restrictedSegmentation)) {
												responseData.push({
													CustomerId: customer.Id,
													CustomerNumber: customer.CustomerNumber,
													DPAccountGroup: customer.DPAccountGroup,
													CustomerName: customer.CustomerName,
													Status: 1,
													SegmentationId: segmentation.SegmentationId,
													CreatedDate: segmentation.CreatedDate,
													UpdatedDate: segmentation.UpdatedDate
												});
											}
										}
									}
								});
							}
						});
						vm.segmentations = responseData;
					})
					.finally(function () {
						vm.isLoading = false;
					});
			}, 500);
		}

		//Item Action button pressed event
		function doItemAction(action, record) {
			switch (action.id) {
				case 'delete':
						vm.model.methods.activateBulk(record, vm.model, action.id, sellerId, activeCatalogId, record.CustomerId).then(function() {
							refreshItems(true, false);
					});
					break;
				case 'view':
					viewItem(record);
					break;
			}
		}

		function doListAction(action) {
			if (action) {
				switch (action.id) {
					case 'import':
						var assignedSegmentation = angular.copy(vm.segmentations);
						dataImporter.importExcel(vm.model, true).then(function (result) {
							vm.model.methods.createBulk(result.data, activeCatalogId, vm.model, assignedSegmentation);
						});
						break;
				}
			}
		}

		function viewItem(item) {
			var id = item[vm.model.idField];
			var stateParams = { id: id, tab: 'SEGMENTATION' };
			$state.go('app.customers.details', stateParams);
		}

		function assignCustomerSegmentations(ev) {
			var modelCopy = angular.copy(vm.model);
			var segmentationIdModel = utility.filterObject(modelCopy.fields, {field: 'SegmentationId'}, true)[0];
			segmentationIdModel.creatable = true;

			var lookupPromises = {};
			lookupPromises = crud.createLookupPromise(modelCopy, undefined , 'create');
			$mdDialog.show({
					controller         : 'assignCustomerSegmentationController',
					controllerAs       : 'vm',
					templateUrl        : 'app/main/catalogs/sub-modules/customers-segmentation-linear/dialogs/assign-customers-segmentation/assign-customers-segmentation.html',
					parent             : angular.element($document.body),
					targetEvent        : ev,
					clickOutsideToClose: false,
					locals             : {
							lookupPromises: lookupPromises,
							model: modelCopy,
							actualModel: customerSpecificSegmentationModel,
							customersModel: api.catalogs.customers,
							catalogId: activeCatalogId,
							assignedSegmentation: angular.copy(vm.segmentations),
							event: ev
					}
			});
		}

		var catalogChangedEventCleanup = $rootScope.$on('ActiveCatalogChangedEvent', function (e) {
			if (activeCatalogId !== catalogFactory.getActiveCatalog().CatalogCode) {
				$state.reload('app.customers_segmentation_linear');
			}
		});

		$scope.$on('$destroy', function () {
			catalogChangedEventCleanup();
			$timeout.cancel(timeoutPromise);
		});

	}
})();
(function() {
    'use strict';

    angular
        .module('app.main.catalog-customers.segmentation',[])
        .config(config);

    /* @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
        // State
        $stateProvider.state('app.customers_segmentation', {
            url    : '/customers-segmentation',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/catalogs/sub-modules/customers-segmentation/list/customers-segmentation-list.html',
                    controller : 'customersSegmentationListController as vm'
                }
            },
            resolve: {
                customerSpecificSegmentationModel : function(api, catalogFactory) {
                    //Mapping source property in getList response of sourceModel to fields target property
                    var propertiesMapper = [{target: 'field', source: 'field["Name"]'}, {target: 'displayLabel', source: 'field["Name"]'}],
                        inputType = 'switch',
                        nestedArrayName = 'Segmentations',
                        //decorator value since the value for each column in segmentations depend on existence of the object in get all the customer segmentation
                        valueMapper = 'Id',
                        targetModel = 'catalogCustomers.segmentation',
                        sourceModel = 'catalogs.segmentations';

                     // update targetModel to make DPAccountGroup field visible based on catalog specific configuration
                     var catalogSpecificConfigurationList = catalogFactory.getActiveCatalogDetails().CatalogSpecificConfigurationList;
                     angular.forEach(catalogSpecificConfigurationList, function (configuration){
                            if(configuration.Name == 'Display-DPAccountGroupInCustomersSegmentation' && configuration.Value == '1'){
                            angular.forEach(api.catalogCustomers.segmentation.fields, function(field){
                                if(field.field == 'DPAccountGroup'){
                                    field.visible = true;
                                }
                            });
                         }
                     });

                    return catalogFactory.createDynamicModel(targetModel, sourceModel, propertiesMapper, inputType, nestedArrayName, valueMapper);
                }
            },
            data: {
                displayName: 'CUSTOMERS_SEGMENTATION.NAV'
            },
            //only users with following accessPrivileges in their role access list can access this route
            // accessPrivileges: ['GetSellerCatalogBulkCustomerSegmentations']
            // accessPrivileges: ['nav_customers_segmentation']
            accessInfo: {
                accessPrivileges: ['nav_customers_segmentation']
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/catalogs/sub-modules/customers-segmentation');

        // Navigation
        msNavigationServiceProvider.saveItem('catalogs.customers_segmentation', {
            title : 'Customers Segmentation',
            translate: 'CUSTOMERS_SEGMENTATION.NAV',
            icon  : 'icon-account-key',
            weight: 20,
            // accessPrivileges: ['GetSellerCatalogBulkCustomerSegmentations']
            // accessPrivileges: ['nav_customers_segmentation']
            accessInfo: {
                accessPrivileges: ['nav_customers_segmentation']
            }
        });

        msNavigationServiceProvider.saveItem('catalogs.customers_segmentation.customers_segmentation', {
            title      : 'Tabular View',
            subTitle   : 'Customers Segmentation',
            icon       : 'icon-account-key',
            state      : 'app.customers_segmentation',
            translate  : 'NAV.TABULAR_VIEW',
            weight     : 20,
            // accessPrivileges: ['GetSellerCatalogBulkCustomerSegmentations']
            // accessPrivileges: ['nav_customers_segmentation']
            accessInfo: {
                accessPrivileges: ['nav_customers_segmentation']
            }
        });
    }
})();
(function() {
    'use strict';

	angular
		.module('app.main.catalog-customers.segmentation')
		.controller('customersSegmentationListController', customersSegmentationListController);

	/* @ngInject */
	function customersSegmentationListController($rootScope, $scope, $state, catalogFactory, customerSpecificSegmentationModel,
													dataImporter, bulkUpdater, $timeout, settingsFactory, crud) {
		/* jshint validthis: true */
		var vm = this;


        //Data

        var activeCatalog = catalogFactory.getActiveCatalog();
		var activeCatalogId = activeCatalog.CatalogCode;
		var sellerId = activeCatalog.AccountId;

        vm.model = customerSpecificSegmentationModel;
        settingsFactory.applyPersistedListViewLayout(vm.model);

		vm.segmentations = [];
		vm.filteredSegmentations = [];
		vm.isLoading = false;
		var timeoutPromise;


		//Methods

		vm.refreshItems = refreshItems;
		vm.doItemAction = doItemAction;
		vm.doListAction = doListAction;
		vm.viewItem = viewItem;

		activate();

		////////////////

        function activate() {
            refreshItems(vm.model.baseModel.isDirty, true);
		}

		function refreshItems(forceFetch, isLogRequired) {
            vm.isLoading = true;
            var generalProperties = {
                forceFetch: forceFetch,
                isLogRequired: isLogRequired
            }
			timeoutPromise = $timeout(function() {// TODO - need to change GET method catching mechanism (since the data is catched controll goes to then part imidiatly and transform function freezes the UI)
			vm.model.methods.getList(generalProperties, vm.model, activeCatalogId, sellerId)
			.then(function (response) {
                var responseData;
				responseData = response.data;
                vm.segmentations = catalogFactory.transformCustomerSegmentationsResponse(responseData, 'Segmentations', vm.model.fields);
			})
			.finally(function () {
				vm.isLoading = false;
			});
			},500);
		}

		//Item Action button pressed event
		function doItemAction(action, record) {
			if (action && record && action.id === 'view') {
                viewItem(record);
			}
		}

		function doListAction(action, records) {
			if (action) {
                switch (action.id) {
					case 'import':
						dataImporter.importExcel(vm.model, true).then(function(result) {
							vm.model.methods.createBulk(result.data, activeCatalogId, vm.model);
						});
						break;
					case 'updateBulk':
						var lookupPromises = {};
						lookupPromises = crud.createLookupPromise(vm.model, undefined , 'edit');
						bulkUpdater.showDialog(vm.model, vm.segmentations, {'catalogId': activeCatalogId}, lookupPromises);
						break;
				}
			}
		}

         function viewItem(item) {
            var id = item[vm.model.idField];
            var stateParams = {id: id, tab: 'SEGMENTATION'};
            $state.go('app.customers.details', stateParams);
		}

        var catalogChangedEventCleanup = $rootScope.$on('ActiveCatalogChangedEvent', function(e) {
            if(activeCatalogId !== catalogFactory.getActiveCatalog().CatalogCode) {
                $state.reload('app.customers_segmentation');
            }
        });
        $scope.$on('$destroy', function () {
            catalogChangedEventCleanup();
			$timeout.cancel(timeoutPromise);
        });

	}
})();
(function() {
		'use strict';

		angular
				.module('app.main.catalogs.customers-locations', [])
				.config(config);

		/* @ngInject */
		function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {

        $stateProvider.state('app.customers_locations', {
            url    : '/locations',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/catalogs/sub-modules/customers-locations/list/customers-locations-list.html',
                    controller : 'locationsListController as vm'
                }
            },
            resolve: {},
            data: {
                displayName: 'CUSTOMERS_LOCATIONS.NAV'
            },
            // accessPrivileges: ['GetAllActiveCustomersAllLocations']
            // accessPrivileges: ['nav_customers_locations']
            accessInfo: {
                accessPrivileges: ['nav_customers_locations']
            }
        });

				// Translation
				$translatePartialLoaderProvider.addPart('app/main/catalogs/sub-modules/customers-locations');

        // Navigation
        msNavigationServiceProvider.saveItem('catalogs.customers_locations', {
            title      : 'Locations',
            icon       : 'icon-map-marker',
            state      : 'app.customers_locations',
            translate  : 'CUSTOMERS_LOCATIONS.NAV',
            weight     : 16,
            // accessPrivileges: ['GetAllActiveCustomersAllLocations']
            // accessPrivileges: ['nav_customers_locations'],
            accessInfo: {
                accessPrivileges: ['nav_customers_locations']
            }
        });
    }

})();
(function () {
	'use strict';

	angular
		.module('app.main.catalogs.customers-locations')
		.controller('locationsListController', locationsListController);

	/* @ngInject */
	function locationsListController(api, $rootScope, $scope, $state, catalogFactory, dataImporter, settingsFactory) {
		/* jshint validthis: true */
		var vm = this;

		//Data
		var activeCatalog = catalogFactory.getActiveCatalog();
		var catalogCode = activeCatalog.CatalogCode;

		vm.model = api.catalogs.locations;
		settingsFactory.applyPersistedListViewLayout(vm.model);

		vm.locations = [];
		vm.filteredLocations = [];
		vm.isLoading = false;


		//Methods
		vm.refreshItems = refreshItems;
		vm.doListAction = doListAction;

		activate();

		////////////////

		function activate() {
			refreshItems(vm.model.isDirty, true);
		}

		function refreshItems(forceFetch, isLogRequired) {
			vm.isLoading = true;
			var generalProperties = {
				forceFetch: forceFetch,
				isLogRequired: isLogRequired
			}
			vm.model.methods.getList(generalProperties, vm.model, catalogCode)
				.then(function (response) {
					vm.locations = response.data;
				})
				.finally(function () {
					vm.isLoading = false;
				});
		}

		//List Action button pressed event
		function doListAction(action) {
			if (action) {
				switch (action.id) {
					case 'import':
						dataImporter.importExcel(vm.model, true).then(function (result) {
							vm.model.methods.createBulk(result.data, catalogCode, vm.model);
						});
						break;
				}
			}
		}

		var catalogChangedEventCleanup = $rootScope.$on('ActiveCatalogChangedEvent', function (e) {
			if (catalogCode !== catalogFactory.getActiveCatalog().CatalogCode) {
				$state.reload('app.customers_locations');
			}
		});

		$scope.$on('$destroy', function () {
			catalogChangedEventCleanup();
		});

	}
})();
(function() {
    'use strict';

    angular
        .module('app.main.catalogs.customers', [
            'app.main.catalogs.customers.segmentations',
            'app.main.catalogs.customers.favorites',
            'app.main.catalogs.customers.locations',
            'app.main.catalogs.customers.stocks',
            'app.main.catalogs.customers.capacities'
        ])
        .config(config);

    /* @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {

        $stateProvider.state('app.customers', {
            url    : '/customers',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/catalogs/sub-modules/customers/list/customers-list.html',
                    controller : 'linkedCustomersListController as vm'
                }
            },
            resolve: {
            },
            data: {
                displayName: 'LINKED_CUSTOMERS.NAV'
            },
			// accessPrivileges: ['GetCatalogLinkedSellerCustomers']
            // accessPrivileges: ['nav_linked_customers']
            accessInfo: {
                accessPrivileges: ['nav_linked_customers']
            }
        });

        $stateProvider.state('app.customers.details', {
			url	 : '/:id',
            params: {
                customer : undefined,
                tab :'details'
                },
            views: {
				'content@app': {
					templateUrl: 'app/main/catalogs/sub-modules/customers/details/customers-details.html',
					controller : 'linkedCustomerDetailsController as vm'
				}
			},
            resolve: {},
			data: {
				parentState: 'app.customers',
                displayName: 'LINKED_CUSTOMERS.TABS.CUSTOMER'
			},
            // no details API
            // accessPrivileges: ['GetCatalogLinkedSellerCustomers']
            accessInfo: {
                accessPrivileges: ['GetCatalogLinkedSellerCustomers']
            }
		});

         // Translation
        $translatePartialLoaderProvider.addPart('app/main/catalogs/sub-modules/customers');

        // Navigation
        msNavigationServiceProvider.saveItem('catalogs.customers', {
            title      : 'Linked Customers',
            icon       : 'icon-account-multiple',
            state      : 'app.customers',
            translate  : 'LINKED_CUSTOMERS.NAV',
            weight     : 15,
            // accessPrivileges: ['GetCatalogLinkedSellerCustomers']
            // accessPrivileges: ['nav_linked_customers']
            accessInfo: {
                accessPrivileges: ['nav_linked_customers']
            }
        });
    }

})();
(function() {
    'use strict';

	angular
		.module('app.main.catalogs.customers')
		.controller('linkedCustomersListController', linkedCustomersListController);

	/* @ngInject */
	function linkedCustomersListController(api, $rootScope, $scope, $state, $document, $mdDialog, catalogFactory, utility, crud, dataImporter, settingsFactory) {
		/* jshint validthis: true */
		var vm = this;

        //Data
        var activeCatalog = catalogFactory.getActiveCatalog();
        var catalogCode = activeCatalog.CatalogCode;
        var sellerId = activeCatalog.AccountId;
        var isStockApply = activeCatalog.IsStockApply;

        vm.model = api.catalogs.customers;
        settingsFactory.applyPersistedListViewLayout(vm.model);

		vm.customers = [];
		vm.filteredCustomers = [];
		vm.isLoading = false;


		//Methods
		vm.refreshItems = refreshItems;
		vm.doListAction = doListAction;
		vm.doItemAction = doItemAction;
		vm.viewItem = viewItem;
		vm.addRecord = addRecord;

		activate();

		////////////////

		function activate() {
			refreshItems(vm.model.isDirty, true);
		}

		function refreshItems(forceFetch, isLogRequired) {
			vm.isLoading = true;
            var generalProperties = {
                forceFetch: forceFetch,
                isLogRequired: isLogRequired,
                config: {},
                supportIncrementalResult: !forceFetch,
                modelIdField: 'CustomerId',
                isMajor: false,
                model: vm.model
            }
            vm.model.methods.getList(generalProperties, vm.model, catalogCode)
            .then(function (response) {
                vm.customers = utility.filterObject(response.data, {Status: 1});
                // map stock codes and stock names to each record
                angular.forEach(vm.customers, function(customer) {
                    if(customer.Stocks.length) {
                        customer['StockCodes'] = customer.Stocks.map(function(user) {
                            return user['StockCode'];
                        });
                        customer['StockNames'] = customer.Stocks.map(function(user) {
                            return user['StockName'];
                        });
                    } else {
                        customer['StockCodes'] = [];
                        customer['StockNames'] = [];
                    }
                    // Area D: derive comma-separated, alpha-sorted capacity names (rendered by arrayTagsRenderer)
                    customer['CapacityNames'] = (customer.Capacities || []).map(function(capacity) {
                        return capacity['Name'];
                    });
                });
                if (angular.isDefined(vm.tableControl) && angular.isDefined(vm.tableControl.updateData)) {
                    vm.tableControl.updateData();
                }
			})
			.finally(function () {
				vm.isLoading = false;
			});
		}

		//Item Action button pressed event
		function doItemAction(action, record) {
			if (action && record) {
                switch (action.id) {
                    case 'view':
                        viewItem(record);
                        break;
                    case 'viewDetails':
                        viewCustomerDetails(record);
                        break;
                    case 'edit':
                        editItem(record, null);
                        break;
                    case 'delete':
                        vm.model.methods.unlinkCustomerFromCatalog(record, vm.model, action.id, catalogCode, sellerId).then(function() {
                            //refreshItems(true);
                            crud.removeDeletedRecords(vm.customers, record);
                            refreshItems(true, false);
                        });
                        break;
                    case 'linkCapacities':
                        // doItemAction carries no DOM event; pass null like editItem does (no dialog origin).
                        openLinkCapacityDialog(record, null);
                        break;
                }
			}
		}

        // Area B: quick-link the customer to a seller capacity (API 7)
        function openLinkCapacityDialog(record, ev) {
            var capacitiesModel = api.customers.capacities;
            var lookupPromises = crud.createLookupPromise(capacitiesModel, undefined, 'edit');
            $mdDialog.show({
                controller         : 'assignCapacityToCustomerController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/catalogs/sub-modules/customers/details/tabs/capacities/dialogs/assign-capacity-to-customer.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: false,
                locals             : {
                    model: capacitiesModel,
                    assignedRecords: record.Capacities || [],
                    catalogCode: catalogCode,
                    customerId: record.CustomerId,
                    lookupPromises: lookupPromises,
                    event: ev
                }
            }).then(function(saved) {
                // saveRecord resolves the dialog with `true` only on a successful link (API 7);
                // refetch so the row's CapacityNames column reflects the new link.
                if (saved) {
                    refreshItems(true, false);
                }
            });
        }

        //List Action button pressed event
        function doListAction(action, records) {
            if (action) {
                switch (action.id) {
                    case 'delete':
                        vm.model.methods.unlinkCustomerFromCatalog(records, vm.model, action.id, catalogCode, sellerId).then(function() {
                            // refreshItems(true);
                            crud.removeDeletedRecords(vm.customers);
                            refreshItems(true, false);
                        });
                        break;
                    case 'import':
                        //make CustomerId field input type as number to avoid lookup error
                        var modelCopy = angular.copy(vm.model);
                        var customerIdField = utility.filterObject(modelCopy.fields, {field: 'CustomerId'}, true)[0];
                        customerIdField.inputType = 'number';
                        // hide stocks and stok threshold when catalog isStockApply flag disabled
                        if(!isStockApply) {
                            var stocksField = utility.filterObject(modelCopy.fields, {field: 'StockDefinitionIds'}, true)[0];
                            stocksField.creatable = false;
                            var stockThresholdField = utility.filterObject(modelCopy.fields, {field: 'StockThreshold'}, true)[0];
                            stockThresholdField.creatable = false;
                            var hideZeroStockField = utility.filterObject(modelCopy.fields, {field: 'HideZeroStock'}, true)[0];
                            hideZeroStockField.creatable = false;
                        }
                        dataImporter.importExcel(modelCopy, true).then(function(result) {
                            vm.model.methods.createBulk(result.data, sellerId, catalogCode, vm.model);
                        });
                        break;
                }
            }
        }

        function viewItem(record) {
            var stateParams = {id: record[vm.model.idField], customer: record};
            $state.go('app.customers.details', stateParams);
		}

         function viewCustomerDetails(record) {
            var id = record[vm.model.idField];
            var stateParams = {id: id, sellerId: sellerId};
            $state.go('app.customer_details', stateParams);
		}

        function addRecord(ev) {
            var lookupPromises = {};
            lookupPromises = crud.createLookupPromise(vm.model, undefined , 'create');
            $mdDialog.show({
                controller         : 'catalogCustomerRelationController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/catalogs/sub-modules/customers/dialogs/update-catalog-customer-relation.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: false,
                locals             : {
                    isNew: true,
                    record: null,
                    assignedRecords: angular.copy(vm.customers),
                    sellerId : sellerId,
                    CatalogCode: catalogCode,
                    lookupPromises: lookupPromises,
                    isStockApply: isStockApply,
                    event: ev
                }
            }).then(function(saved) {
                if (saved) {
                    refreshItems(true);
                }
            });
		}

		function editItem(record, ev) {
            record['StockDefinitionIds'] = record.Stocks.map(function(user) {
                return user['StockDefinitionId'];
            });
            var lookupPromises = {};
            lookupPromises = crud.createLookupPromise(vm.model, undefined , 'edit');
            $mdDialog.show({
                controller         : 'catalogCustomerRelationController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/catalogs/sub-modules/customers/dialogs/update-catalog-customer-relation.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: false,
                locals             : {
                    isNew: false,
                    record: angular.copy(record),
                    assignedRecords: angular.copy(vm.customers),
                    sellerId: sellerId,
                    CatalogCode: catalogCode,
                    lookupPromises: lookupPromises,
                    isStockApply: isStockApply,
                    event: ev
                }
            }).then(function(saved) {
                if (saved) {
                    refreshItems(true);
                }
            });
		}

        var catalogChangedEventCleanup = $rootScope.$on('ActiveCatalogChangedEvent', function(e) {
            if(catalogCode !== catalogFactory.getActiveCatalog().CatalogCode) {
                $state.reload('app.customers');
            }
        });
        $scope.$on('$destroy', function () {
            catalogChangedEventCleanup();
        });

	}
})();
(function() {
    'use strict';

    angular
        .module('app.main.customers.catalogs')
        .controller('catalogCustomerRelationController', catalogCustomerRelationController);

    /* @ngInject */
    function catalogCustomerRelationController($mdDialog, toast, api, utility, $scope, $window, $filter, hotkeys, $q,
                record, assignedRecords, sellerId, CatalogCode, isNew, lookupPromises, isStockApply, event) {
        /* jshint validthis: true */
        var vm = this;

        //Data
        vm.model = api.catalogs.customers;
        vm.sellerCustomerModel = api.customers.customers;
        vm.catalogModel = api.catalogs.catalogs;
        vm.priceGroupModel = api.catalogs.priceGroup;
        vm.stockDefinitionModel = api.catalogs.stockDefinition;

        vm.isLoading = false;
        vm.isDataDirty = false;
        vm.record = {};
        vm.activeCustomers = undefined;
        vm.priceGroups= [];
        vm.stockDefinitions = [];
        vm.isNew = isNew;
        vm.acLookupModel = angular.copy(record);
        vm.record['StockDefinitionIds'] = isNew ? [] : record['StockDefinitionIds'];
        vm.isStockApply = isStockApply;
        if (vm.isNew) {
            vm.record.MoqEnabled = true; // default true
            vm.record.MultipleOfEnabled = true; // default true
        }


        //Methods
        vm.saveRecord = saveRecord;
        vm.closeDialog = closeDialog;
        vm.loadCatalogActivePriceGroups = loadCatalogActivePriceGroups;
        vm.loadStockDefinitions = loadStockDefinitions;

        vm.custLookupSearch = custLookupSearch;
        vm.pgLookupSearch = pgLookupSearch;
        vm.usersLookupSearch = usersLookupSearch;
        vm.lookupChange = lookupChange;
        vm.getLookupDisplayValue = getLookupDisplayValue;
        vm.selectText = selectText;

        vm.transformChip = transformChip;
        vm.acQuerySearch = acQuerySearch;
        vm.getChipDisplayValue = getChipDisplayValue;


        activate();

        ////////////////

        vm.isValidJSON = utility.isValidJSON;

        function activate() {
            initializelookups();

            //Hotkeys
            hotkeys.bindTo($scope).add({
                combo: 'ctrl+enter',
                description: $filter('translate')('ACTIONS.SAVE'),
                allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
                callback: function(event) {
                    if (!vm.isLoading && !vm.editForm.$invalid) {
                        vm.saveRecord();
                    }
                }
            });
            hotkeys.bindTo($scope).add({
                combo: 'ctrl+shift+enter',
                description: $filter('translate')('ACTIONS.SAVE_AND_NEW'),
                allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
                callback: function(event) {
                    if (!vm.isLoading && !vm.editForm.$invalid) {
                        vm.saveRecord(true);
                    }
                }
            });
        }

        function saveRecord(saveAndNew) {

            // Guard: never PUT to /sellers/{sellerId}/customers/undefined/catalogs. The customer
            // autocomplete can hold free-typed text without resolving to a selected record, which
            // leaves CustomerId undefined; block the save (and prompt) instead of calling the API.
            if (angular.isUndefined(vm.record.CustomerId) || vm.record.CustomerId === null) {
                toast.error('LINKED_CUSTOMERS.VALIDATIONS.CUSTOMER_REQUIRED', '', '');
                return;
            }

            vm.record.CatalogCode = CatalogCode;
            vm.isLoading = true;
            var promise;

            if (vm.orderPriceGroup === 1) {
                vm.record.OrderPriceGroupId = vm.record.WholesalePriceGroupId;
            }
            else if (vm.orderPriceGroup === 2) {
                vm.record.OrderPriceGroupId = vm.record.RetailPriceGroupId;
            }

            // remove the stocks array
            delete vm.record['Stocks'];

            if(isNew) {
                promise = vm.model.methods.create(vm.record, sellerId, vm.record.CustomerId);
            }
            else {
                promise = vm.model.methods.update(vm.record, sellerId, vm.record.CustomerId);
            }

            promise.then(function() {
                if (angular.isDefined(saveAndNew) && saveAndNew) {
                    vm.editForm.$setPristine();
                    vm.editForm.$setUntouched();
                    // Add vm.record.CustomerId to assignedRecords, it will be used in save&new to splice assigned record from the dropdown
                    var assignedCustomer = {};
                    assignedCustomer.CustomerId = vm.record.CustomerId;
                    assignedRecords.push(assignedCustomer);
                    initializelookups();
                    vm.record = {};
                    vm.orderPriceGroup = undefined;
                    vm.acSearchText = [];
                    vm.searchText = {};
                    vm.isDataDirty = true;
                    var el = $window.document.getElementById('dialog_input_first');
                    if (el) {
                        el.focus();
                    }
                } else {
                    closeDialog(true);
                }

                var toastMessage = isNew ? 'SUCCESS.CREATE': 'SUCCESS.UPDATE';
                toast.success(toastMessage, '', '');
            }, function() {
                closeDialog(vm.isDataDirty);
            }).finally(function () {
                vm.isLoading = false;
            });
        }

        function closeDialog(saved) {
            $mdDialog.hide(saved);
        }

        function loadOrderPriceGroupDisplayValue() {
            if(angular.isUndefined(vm.record.WholesalePriceGroupId)) {
                vm.orderPriceGroup = 2;
            }
            else if(angular.isUndefined(vm.record.RetailPriceGroupId)) {
                vm.orderPriceGroup = 1;
            }
            else if(vm.record.OrderPriceGroupId === vm.record.WholesalePriceGroupId) {
                vm.orderPriceGroup = 1;
            }
            else if(vm.record.OrderPriceGroupId === vm.record.RetailPriceGroupId) {
                vm.orderPriceGroup = 2;
            }
        }

         function custLookupSearch(query, fieldName, lookupObj) {
            var results = [];

            var field = utility.filterObject(vm.model.fields, {field: fieldName})[0];
            var lookupFilter = angular.isDefined(field.lookupFilter) ? field.lookupFilter : {};
            var predicate = angular.copy(lookupFilter);
            predicate.value = query;

            if(angular.isDefined(lookupObj) && angular.isDefined(lookupObj.data) && lookupObj.data.length) {
                results = query ? utility.filterObject(lookupObj.data , predicate) : utility.filterObject(lookupObj.data, lookupFilter, true);
                return results;
            }
            else {
                return loadActiveSellerCustomers().then(function(lookupResult) {
                    results = query ? utility.filterObject(lookupResult.data , predicate) : utility.filterObject(lookupResult.data, lookupFilter, true);
                    return results;
                });
            }
        }

        function pgLookupSearch(query, fieldName, lookupObj) {
            var results = [];

            var field = utility.filterObject(vm.model.fields, {field: fieldName})[0];
            var lookupFilter = angular.isDefined(field.lookupFilter) ? field.lookupFilter : {};
            var predicate = angular.copy(lookupFilter);
            predicate.value = query;

            if(angular.isDefined(lookupObj) && angular.isDefined(lookupObj.data) && lookupObj.data.length) {
                results = query ? utility.filterObject(lookupObj.data , predicate) : utility.filterObject(lookupObj.data, lookupFilter, true);
                return results;
            }
            else {
                return loadCatalogActivePriceGroups().then(function(lookupResult) {
                    results = query ? utility.filterObject(lookupResult.data , predicate) : utility.filterObject(lookupResult.data, lookupFilter, true);
                    return results;
                });
            }
        }

        function usersLookupSearch(query, fieldName) {
            var results = [];

            var field = utility.filterObject(vm.model.fields, {field: fieldName})[0];
            var lookupFilter = angular.isDefined(field.lookupFilter) ? field.lookupFilter : {};
            var predicate = angular.copy(lookupFilter);
            predicate.value = query;
            var lookupModel = api.getModel(field.lookupSource);

            if(angular.isDefined(lookupModel.lookupData) && angular.isDefined(lookupModel.lookupData.data) && lookupModel.lookupData.data.length) {
                results = query ? utility.filterObject(lookupModel.lookupData.data , predicate) : utility.filterObject(lookupModel.lookupData.data, lookupFilter, true);
                return results;
            }
            else {
                return lookupPromises[fieldName].then(function(lookupData) {
                    results = query ? utility.filterObject(lookupData.data , predicate) : utility.filterObject(lookupData.data, lookupFilter, true);
                    return results;
                });
            }
        }

        // convert dropdown scope value form object(lookup record) to id property of lookup record
        function lookupChange(selectedObj, field) {
            if(angular.isObject(selectedObj)) {
                vm.record[field] = selectedObj.id;
            }
            else if(angular.isUndefined(selectedObj) || selectedObj === null) {
                vm.record[field] = undefined; // on record removal make field undefined or the property can be deleted using delete keywork
            }
        }

        function selectText(event) {
            utility.selectInputText(event);
        }

        function getLookupDisplayValue(item, fieldName) {
            var field = utility.filterObject(vm.model.fields, {field: fieldName})[0];
            var lookupModel = api.getModel(field.lookupSource);

            if(angular.isDefined(lookupModel.lookupData) && angular.isDefined(lookupModel.lookupData.data) && lookupModel.lookupData.data.length) {
                return getLookupDisplayVal(item, lookupModel.lookupData);
            }
            else {
                return lookupPromises[fieldName].then(function(lookupData) {
                    return getLookupDisplayVal(item, lookupData);
                });
            }
        }

        //helper method
        function getLookupDisplayVal(item, lookupData) {
            var result;
            if(lookupData) {
                // since autocomplte return object
                if(angular.isObject(item)) {
                    result = utility.filterObject(lookupData.data, {id: item.id}, true);
                }
                // to initialize field value if any (when open update record dialog)
                else {
                    result = utility.filterObject(lookupData.data, {id: item}, true);
                }

                if (angular.isArray(result) && result.length > 0) {
                    return result[0].value;
                }
                else {
                    return result.value;
                }
            }
        }

        function transformChip(chip) {
            if (angular.isObject(chip)) {
                return chip.Id;
            }
            return undefined;
        }

        function getChipDisplayValue(chip, stockDefinitions) {
            var res = utility.filterObject(stockDefinitions, {Id: chip}, true);
            if (angular.isArray(res) && res.length > 0) {
                return res[0].StockCode;
            }
        }

        function acQuerySearch(query, selectedItems, stockDefinitions) {
            var searchQueryResult = [];
            if(angular.isDefined(stockDefinitions) && vm.stockDefinitions.length) {
                searchQueryResult = utility.filterObject(vm.stockDefinitions, query);
                searchQueryResult = removeSelectedRecods(selectedItems, searchQueryResult);
                return searchQueryResult;
            }
            else {
                return searchQueryResult;
            }
        }

        function removeSelectedRecods(selectedItems, searchQueryResult) {
            if (angular.isDefined(selectedItems) && selectedItems.length > 0) {
                for (var index = searchQueryResult.length-1; index >= 0; index--) {
                    if (selectedItems.indexOf(searchQueryResult[index].Id) !== -1) {
                        searchQueryResult.splice(index,1);
                    }
                }
            }
            return searchQueryResult;
        }

        function initializelookups() {
            //No need to laod customers list since if its edit  customerId is part of record and user is just updating the price groups
            if(isNew) {
                loadActiveSellerCustomers();
            }
            else {
                vm.record = record;
                loadOrderPriceGroupDisplayValue();
            }
            loadCatalogActivePriceGroups(CatalogCode);
            if(vm.isStockApply) {
                loadStockDefinitions();
            }
        }

        function loadActiveSellerCustomers() {
            var deferred = $q.defer();
            lookupPromises['CustomerId'].then(function (result) {
                var resultClone = angular.copy(result);
                var assignedSellerCustomerIndexMap = utility.createIndexMap(assignedRecords, vm.model.idField);
                for (var index = resultClone.data.length - 1; index >= 0; index--) {
                    if (angular.isDefined(assignedSellerCustomerIndexMap[resultClone.data[index]['id']])) {
                        resultClone.data.splice(index, 1);
                    }
                }
                vm.activeCustomers = resultClone;
                deferred.resolve(vm.activeCustomers);
            });
            return deferred.promise;
        }

        function loadCatalogActivePriceGroups() {
            var deferred = $q.defer();
            lookupPromises['WholesalePriceGroupId'].then(function(result) {
                vm.priceGroups = result;
                deferred.resolve(vm.priceGroups);
            });
             return deferred.promise;
        }

        function loadStockDefinitions() {
             var deferred = $q.defer();
             var generalProperties = {
                 forceFetch: true,
                 isLogRequired: false
             }
             api.catalogs.stockDefinition.methods.getList(generalProperties, CatalogCode).then(function(response) {
                vm.stockDefinitions = utility.filterObject(response.data, {Status: 1});
                deferred.resolve(vm.stockDefinitions);
             });
             return deferred.promise;
        }

    }
})();
(function() {
'use strict';

    angular
        .module('app.main.catalogs.customers')
        .controller('linkedCustomerDetailsController', linkedCustomerDetailsController);

    /* @ngInject */
    function linkedCustomerDetailsController($document, api, $state, $stateParams, $rootScope, $mdDialog, catalogFactory, utility, crud,
                                                activityLogger, CONSTANTS, settingsFactory, dataImporter, SecurityFactory) {
        /* jshint validthis: true */
        var vm = this;

        // Data
        var customerId = parseInt($stateParams.id);
        var tabName = $stateParams.tab.toUpperCase();
        vm.customer = $stateParams.customer;
        var activeCatalog = catalogFactory.getActiveCatalog();
        var activeCatalogCode = activeCatalog.CatalogCode;
        var sellerId = activeCatalog.AccountId;
        var isRoleBasedRestrictedSegmentationsAdded = angular.isDefined(api.roleBasedRestrictions) && angular.isDefined(api.roleBasedRestrictions.restrictedSegmentationsArray) && api.roleBasedRestrictions.restrictedSegmentationsArray.length > 0;
        var isStockApply = activeCatalog.IsStockApply;
        vm.selectedTabIndex = CONSTANTS.TABS.CUSTOMER[tabName] ? CONSTANTS.TABS.CUSTOMER[tabName]: 0;

        vm.model = api.catalogs.customers;

        vm.segmentationModel = api.customers.segmentations;
        settingsFactory.applyPersistedListViewLayout(vm.segmentationModel);

        vm.favoriteModel = api.customers.favorites;
        settingsFactory.applyPersistedListViewLayout(vm.favoriteModel);

        vm.locationsModel = api.linkedCustomers.locations;
        settingsFactory.applyPersistedListViewLayout(vm.locationsModel);

        vm.stocksModel = api.customers.stocks;
        settingsFactory.applyPersistedListViewLayout(vm.stocksModel);

        vm.capacitiesModel = api.customers.capacities;
        settingsFactory.applyPersistedListViewLayout(vm.capacitiesModel);

        vm.segmentations = [];
        vm.filteredSegmentations = [];

        vm.capacities = [];
        vm.filteredCapacities = [];
        vm.isCapacitiesLoading = false;

        vm.favorites = [];
        vm.filteredFavorites = [];

        vm.locations = [];
        vm.filteredLocations = [];

        vm.stocks = [];
        vm.filteredStocks = [];

        vm.isLoading = false;
        vm.isSegmentationsLoading = false;
        vm.isFavoritesLoading = false;
        vm.isLocationLoading = false;


        // Methods
        vm.refreshRecord = refreshRecord;
        vm.refreshSegmentations = refreshSegmentations;
        vm.refreshFavorites = refreshFavorites;
        vm.refreshLocations = refreshLocations;

        vm.doCustomerItemAction = doCustomerItemAction;
        vm.editCustomer = editCustomer;

        vm.doSegmentationsItemAction = doSegmentationsItemAction;
        vm.doSegmentationsListAction = doSegmentationsListAction;
        vm.assignSegmentation = assignSegmentation;
        vm.refreshCapacities = refreshCapacities;
        vm.doCapacitiesItemAction = doCapacitiesItemAction;
        vm.doCapacitiesListAction = doCapacitiesListAction;
        vm.assignCapacity = assignCapacity;
        vm.doFavoritesItemAction = doFavoritesItemAction;
        vm.doFavoritesListAction = doFavoritesListAction;
        vm.createFavorite = createFavorite;
        vm.doLocationsItemAction = doLocationsItemAction;
        vm.doLocationsListAction = doLocationsListAction;
        vm.viewLocation = viewLocation;
        vm.addLocation = addLocation;

        activate();

        ////////////////

        function activate() {
            refreshRecord(true);
        }

        function refreshRecord(isLogRequired) {
            if(angular.isUndefined(vm.customer) || utility.isObjectEmpty(vm.customer)) {
                vm.isLoading = true;
                var generalProperties = {
                    forceFetch: true,
                    isLogRequired: isLogRequired
                }

                vm.model.methods.getList(generalProperties, vm.model, activeCatalogCode)
                    .then(function (response) {
                        vm.customer = utility.filterObject(response.data, {CustomerId: customerId}, true)[0];
                        vm.stocks = vm.customer.Stocks;
                        vm.title = vm.customer[vm.model.lookupDisplayField];

                        initializeTabData(isLogRequired);

                        //Update Breadcrumb
                        $state.current.data.displayName = vm.title;
                        $rootScope.$broadcast('breadcrumb-updated');
                })
                .finally(function () {
                    vm.isLoading = false;
                });
            }
            else {
                vm.title = vm.customer[vm.model.lookupDisplayField];
                vm.stocks = vm.customer.Stocks;

                initializeTabData(isLogRequired);

                //Update Breadcrumb
                $state.current.data.displayName = vm.title;
                $rootScope.$broadcast('breadcrumb-updated');

                //if getting data from stateparams
                logActivity();
            }
        }

        function refreshSegmentations(forceFetch, isLogRequired) {
            vm.isSegmentationsLoading = true;
            var generalProperties = {
                forceFetch: forceFetch,
                isLogRequired: isLogRequired
            }
            vm.segmentationModel.methods.getList(generalProperties, customerId, sellerId, activeCatalogCode).then(function (response) {
                vm.segmentations = !isRoleBasedRestrictedSegmentationsAdded ? utility.filterObject(response.data, {Status:1}) : removeRestrictedSegmentations(utility.filterObject(response.data, {Status:1}));
            })
            .finally(function() {
                vm.isSegmentationsLoading = false;
            });
        }

        function refreshCapacities(forceFetch, isLogRequired) {
            vm.isCapacitiesLoading = true;
            var generalProperties = {
                forceFetch: forceFetch,
                isLogRequired: isLogRequired
            }
            vm.capacitiesModel.methods.getList(generalProperties, customerId, activeCatalogCode).then(function (response) {
                vm.capacities = response.data;
                // render Criteria as the raw JSON string (mirrors the Master Size Scale Criteria column)
                angular.forEach(vm.capacities, function(capacity) {
                    capacity.Criteria = angular.isString(capacity.Criteria) ? capacity.Criteria : angular.toJson(capacity.Criteria);
                });
            })
            .finally(function() {
                vm.isCapacitiesLoading = false;
            });
        }

        function refreshFavorites(forceFetch, isLogRequired) {
            vm.isFavoritesLoading = true;
            var generalProperties = {
                forceFetch: forceFetch,
                isLogRequired: isLogRequired
            }
            vm.favoriteModel.methods.getList(generalProperties, vm.favoriteModel, vm.customer['CustomerNumber'], activeCatalogCode).then(function (response) {
                vm.favorites = response.data;
            })
            .finally(function() {
                vm.isFavoritesLoading = false;
            });
        }

        function refreshLocations(forceFetch, isLogRequired) {
            vm.isLocationLoading = true;
            var generalProperties = {
                forceFetch: forceFetch,
                isLogRequired: isLogRequired
            }
            vm.locationsModel.methods.getList(generalProperties, customerId, sellerId).then(function(response) {
                vm.locations = response.data;
            })
            .finally(function () {
                vm.isLocationLoading = false;
            });
        }

        function doCustomerItemAction(action, record) {
            if (action) {
                switch (action.id) {
                    case 'delete':
                        vm.model.methods.unlinkCustomerFromCatalog(record, vm.model, action.id, activeCatalogCode, sellerId);
                        break;
                }
            }
        }

        function editCustomer(ev, record) {
            record['StockDefinitionIds'] = record.Stocks.map(function(user) {
                return user['StockDefinitionId'];
            });
            var lookupPromises = {};
            lookupPromises = crud.createLookupPromise(vm.model, undefined , 'edit');
            $mdDialog.show({
                controller         : 'catalogCustomerRelationController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/catalogs/sub-modules/customers/dialogs/update-catalog-customer-relation.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: false,
                locals             : {
                    isNew: false,
                    record: angular.copy(record),
                    assignedRecords: utility.pushItemToArray(angular.copy(vm.customer)),
                    sellerId: sellerId,
                    CatalogCode: activeCatalogCode,
                    lookupPromises: lookupPromises,
                    isStockApply: isStockApply,
                    event: ev
                }
            }).then(function(saved) {
                if (saved) {
                    vm.customer = undefined;
                    refreshRecord(true);
                }
            });
		}

        // to remove restricted segmentations
        function removeRestrictedSegmentations(segmentations) {
            var articleSegmentationsWithoutRestricted = [];
            angular.forEach(segmentations, function(segmentation) {
                var restrictedSegmentation = utility.filterObject(api.roleBasedRestrictions.restrictedSegmentationsArray, { Id: segmentation.SegmentationName}, true)[0];
                if (angular.isDefined(restrictedSegmentation) && !restrictedSegmentation.notViewable && !restrictedSegmentation.notEditable) {
                    articleSegmentationsWithoutRestricted.push(segmentation);
                } else if (angular.isDefined(restrictedSegmentation) && !restrictedSegmentation.notViewable && restrictedSegmentation.notEditable) {
                    // restricted segmentation is not updatable to disable the delete button adding this property
                    segmentation['_nonEditable'] = 1;
                    articleSegmentationsWithoutRestricted.push(segmentation);
                } else if (angular.isUndefined(restrictedSegmentation)) {
                    articleSegmentationsWithoutRestricted.push(segmentation);
                }
            });
            return articleSegmentationsWithoutRestricted;
        }

		function doSegmentationsItemAction(action, record) {
			if (action && record) {
				switch (action.id) {
					case 'delete':
                    case 'activate':
                        vm.segmentationModel.methods.activateBulk(record, vm.segmentationModel, action.id, sellerId, activeCatalogCode, customerId).then(function() {
                            //since filtering the deactivated records- to avoid WEB API call
                            crud.removeDeletedRecords(vm.segmentations, record);
                            refreshSegmentations(false, false);
                        });
                        break;
				}
			}
		}

        function doSegmentationsListAction(action, records) {
            if (action) {
                switch (action.id) {
                    case 'delete':
                    case 'activate':
                        vm.segmentationModel.methods.activateBulk(records, vm.segmentationModel, action.id, sellerId, activeCatalogCode, customerId).then(function() {
                            //since filtering the deactivated records- to avoid WEB API call
                            crud.removeDeletedRecords(vm.segmentations);
                            refreshSegmentations(false, false);
                        });
                        break;
                }
            }
        }

        //Assign segmentation to customer
        function assignSegmentation(ev) {
            var lookupPromises = {};
            lookupPromises = crud.createLookupPromise(vm.segmentationModel, undefined , 'edit');
            $mdDialog.show({
                controller         : 'assignSegmentationToCustomerController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/catalogs/sub-modules/customers/details/tabs/segmentations/dialogs/assign-segmentation-to-customer.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: false,
                locals             : {
                    model: vm.segmentationModel,
                    assignedRecords: angular.copy(vm.segmentations),
                    activeCatalog: activeCatalog,
                    customerId: customerId,
                    lookupPromises: lookupPromises,
                    event: ev
                }
            }).then(function(saved) {
                if (saved) {
                    refreshSegmentations(true, false);
                }
            });
		}

        // Capacities -----------------------------------------------------------

        function doCapacitiesItemAction(action, record) {
            if (action && record) {
                switch (action.id) {
                    case 'delete':
                    case 'activate':
                        vm.capacitiesModel.methods.activateBulk(record, vm.capacitiesModel, action.id, activeCatalogCode, customerId).then(function() {
                            // API 10 omits Status-0 links; drop the deactivated row locally then refresh
                            crud.removeDeletedRecords(vm.capacities, record);
                            refreshCapacities(true, false);
                        });
                        break;
                }
            }
        }

        function doCapacitiesListAction(action, records) {
            if (action) {
                switch (action.id) {
                    case 'import':
                        var importModel = api.customers.importCustomerCapacities;
                        dataImporter.importExcel(importModel, true).then(function(result) {
                            vm.capacitiesModel.methods.createBulk(vm.capacitiesModel, result.data, sellerId, activeCatalogCode);
                        });
                        break;
                    case 'delete':
                    case 'activate':
                        // setLinkStatus (API 8) doesn't mutate local Status, so there's nothing for
                        // removeDeletedRecords to strip — the refresh below re-fetches the correct list.
                        vm.capacitiesModel.methods.activateBulk(records, vm.capacitiesModel, action.id, activeCatalogCode, customerId).then(function() {
                            refreshCapacities(true, false);
                        });
                        break;
                }
            }
        }

        // Link a capacity to this customer (API 7)
        function assignCapacity(ev) {
            var lookupPromises = crud.createLookupPromise(vm.capacitiesModel, undefined, 'edit');
            $mdDialog.show({
                controller         : 'assignCapacityToCustomerController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/catalogs/sub-modules/customers/details/tabs/capacities/dialogs/assign-capacity-to-customer.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: false,
                locals             : {
                    model: vm.capacitiesModel,
                    assignedRecords: angular.copy(vm.capacities),
                    catalogCode: activeCatalogCode,
                    customerId: customerId,
                    lookupPromises: lookupPromises,
                    event: ev
                }
            }).then(function(saved) {
                if (saved) {
                    refreshCapacities(true, false);
                }
            });
        }

        function doFavoritesItemAction(action, record) {
			if (action && record) {
				switch (action.id) {
                    case 'edit':
                        editFavorite(record, null);
                        break;
					case 'delete':
                        vm.favoriteModel.methods.activateBulk(record, vm.favoriteModel, action.id, {catalogCode: activeCatalogCode, customerId: vm.customer.CustomerId})
                        .then(function() {
                            refreshFavorites(true, false);
                        });
                        break;
				}
			}
		}

        function doFavoritesListAction(action, records) {
            if (action) {
                switch (action.id) {
                    case 'import':
                    var importFavoriteModel = api.customers.importFavorites;
                        dataImporter.importExcel(importFavoriteModel, true).then(function(result) {
                            vm.favoriteModel.methods.createBulk(vm.favoriteModel, result.data, vm.customer.CustomerNumber, activeCatalogCode);
                        });
                        break;
                    case 'delete':
                        vm.favoriteModel.methods.activateBulk(records, vm.favoriteModel, action.id, {catalogCode: activeCatalogCode, customerId: vm.customer.CustomerId})
                        .then(function() {
                            refreshFavorites(true, false);
                        });
                        break;
                }
            }
        }

        function editFavorite(record, ev) {
            api.showEditRecordDialog(angular.element($document.body), ev, vm.favoriteModel, record, {catalogCode: activeCatalogCode, customerId: vm.customer.CustomerId})
            .then(function(saved) {
                if (saved) {
                    refreshFavorites(true, false);
                }
            });
        }

        function createFavorite(ev) {
            api.showCreateRecordDialog(angular.element($document.body), ev, vm.favoriteModel, {catalogCode: activeCatalogCode, customerId: vm.customer.CustomerId},"","","",vm.favorites)
            .then(function(saved) {
                if (saved) {
                    refreshFavorites(true, false);
                }
            });
        }

        function doLocationsItemAction(action, record) {
            if (action && record) {
				switch (action.id) {
					case 'view':
						viewLocation(record);
                        break;
					case 'edit':
						editLocation(record, null);
                        break;
					case 'delete':
                    case 'activate':
                        vm.locationsModel.methods.activateBulk(record, vm.locationsModel, action.id, customerId, sellerId);
                        break;
				}
			}
		}

        function doLocationsListAction(action, records) {
            if (action) {
                switch (action.id) {
                    case 'delete':
                    case 'activate':
                        vm.locationsModel.methods.activateBulk(records, vm.locationsModel, action.id, customerId, sellerId);
                        break;
                }
            }
        }

        function viewLocation(record) {
            var id = record[vm.locationsModel.idField];
            var stateParams = {accountId: sellerId, customerId: customerId, id: id};
            $state.go('app.locations_details', stateParams);
        }

        function addLocation(ev) {
            api.showCreateRecordDialog(angular.element($document.body), ev, vm.locationsModel, customerId, {'sellerId': sellerId})
            .then(function(saved) {
                if (saved) {
                    refreshRecord();
                }
            });
		}

        function editLocation(item, ev) {
            var parentId = {};
            parentId.customerId = customerId;
            parentId.sellerId = sellerId;
            api.showEditRecordDialog(angular.element($document.body), ev, vm.locationsModel, item, parentId)
            .then(function(saved) {
                if (saved) {
                    refreshRecord();
                }
            });
		}


        //Log activity if getting data form stateparamS
        function logActivity() {
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var isBulk = false;
            var items = [];
            items.push(vm.customer[vm.model.lookupDisplayField]);
            activityLogger.log(activityLogger.createLogData(items, state, 'catalogs.customers', 'VIEW', isBulk, new Date(), null, null));
        }

        function initializeTabData(isLogRequired) {
            if(vm.customer.Status != 0) {
                if(SecurityFactory.isAuthorized({accessPrivileges: CONSTANTS.PRIVILEGES.LINKED_CUSTOMERS.DETAIL.SEGMENTATION_LIST})) {
                    refreshSegmentations(vm.segmentationModel.isDirty, isLogRequired);
                }
                if(SecurityFactory.isAuthorized({accessPrivileges: CONSTANTS.PRIVILEGES.LINKED_CUSTOMERS.DETAIL.FAVORITES_LIST})) {
                    refreshFavorites(vm.favoriteModel.isDirty, isLogRequired);
                }
                if(SecurityFactory.isAuthorized({accessPrivileges: CONSTANTS.PRIVILEGES.LINKED_CUSTOMERS.DETAIL.LOCATIONS_LIST})) {
                    refreshLocations(vm.locationsModel.isDirty, isLogRequired);
                }
                if(SecurityFactory.isAuthorized({accessPrivileges: CONSTANTS.PRIVILEGES.LINKED_CUSTOMERS.DETAIL.CAPACITIES_LIST})) {
                    refreshCapacities(vm.capacitiesModel.isDirty, isLogRequired);
                }
            }
        }
    }
})();
(function() {
  'use strict';

  angular
    .module('app.main.catalogs.allocation-groups', [
      'app.main.catalogs.allocation-groups.articles'
    ])
    .config(config);

    /* @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
      // State
      $stateProvider.state('app.allocation_groups', {
        url: '/allocation-groups',
        views: {
          'content@app': {
            templateUrl: 'app/main/catalogs/sub-modules/allocation-groups/list/allocation-groups-list.html',
            controller: 'allocationGroupsListController as vm'
          }
        },
        data: {
          displayName: 'ALLOCATION_GROUPS.NAV'
        },
        //only users with following accessPrivileges in their role access list can access this route
        // accessPrivileges: ['GetAllocationGroupList']
        // accessPrivileges: ['nav_allocation_groups']
        accessInfo: {
          accessPrivileges: ['nav_allocation_groups']
        }
      });

      $stateProvider.state('app.allocation_groups.details', {
        url	 : '/:id',
        views: {
          'content@app': {
            templateUrl: 'app/main/catalogs/sub-modules/allocation-groups/details/allocation-groups-details.html',
            controller : 'allocationGroupsDetailsController as vm'
          }
        },
        data: {
           parentState: 'app.allocation_groups',
           displayName: 'ALLOCATION_GROUPS.TABS.ALLOCATION_GROUP'
        },
        //only users with following accessPrivileges in their role access list can access this route
        // accessPrivileges: ['GetAllocationGroupDetails']
        accessInfo: {
          accessPrivileges: ['GetAllocationGroupDetails']
        }
      });

      // Translation
      $translatePartialLoaderProvider.addPart('app/main/catalogs/sub-modules/allocation-groups');

      msNavigationServiceProvider.saveItem('orders.allocationGroups', {
        title: 'Allocation Groups',
        icon: 'icon-source-fork',
        state: 'app.allocation_groups',
        translate: 'ALLOCATION_GROUPS.NAV',
        weight: 122,
        // accessPrivileges: ['GetAllocationGroupList']
        // accessPrivileges: ['nav_allocation_groups']
        accessInfo: {
          accessPrivileges: ['nav_allocation_groups']
        }
      });
    }
})();
(function () {
  'use strict';

  angular
    .module('app.main.catalogs.allocation-groups')
    .controller('customerAllocationsListController', customerAllocationsListController);
  // TODO - create and update
  /* @ngInject */
  function customerAllocationsListController(api, $rootScope, $scope, $state, $document, catalogFactory, dataImporter, settingsFactory, $mdDialog) {
    /* jshint validthis: true */
    var vm = this;

    //Data
    var activeCatalogCode = catalogFactory.getActiveCatalog().CatalogCode;

    vm.model = api.catalogs.customerAllocations;
    settingsFactory.applyPersistedListViewLayout(vm.model);

    vm.customerAllocations = [];
    vm.filteredCustomerAllocations = [];
    vm.isLoading = false;

    //Methods
    vm.refreshItems = refreshItems;
    vm.doListAction = doListAction;
    vm.doItemAction = doItemAction;
    vm.viewItem = viewItem;
    vm.addRecord = addRecord;

    activate();

    ////////////////

    function activate() {
      refreshItems(vm.model.isDirty, true);
    }

    function refreshItems(forceFetch, isLogRequired) {
      var generalProperties = {
        forceFetch: forceFetch,
        isLogRequired: isLogRequired
      }
      vm.isLoading = true;
      return vm.model.methods.getList(generalProperties, vm.model, activeCatalogCode)
        .then(function (response) {
          vm.customerAllocations = response.data;
        }).finally(function () {
          vm.isLoading = false;
        });
    }

    //Item Action button pressed event
    function doItemAction(action, record) {
      if (action && record) {
        switch (action.id) {
          case 'view':
            viewItem(record);
            break;
          case 'edit':
            vm.model.methods.getDetails(true, record.CustomerId, activeCatalogCode)
            .then(function (response) {
              editItem(response.data, null);
            })
            break;
        }
      }
    }

    //List Action button pressed event
    function doListAction(action, records) {
      if (action) {
        switch (action.id) {
          case 'import':
            dataImporter.importExcel(api.catalogs.importAllocationsGroups, true).then(function (result) {
              vm.model.methods.createBulk(vm.model, result.data, activeCatalogCode);
            })
            break;
        }
      }
    }

    function viewItem(item) {
      var stateParams = { id: item.CustomerId };
      $state.go('app.customer_allocations.details', stateParams);
    }

    function addRecord(ev) {
      var allocationGroupsModel =  api.catalogs.allocationGroups;
      var linkedCustomerModel = api.catalogs.customers;
      var promises = {};
      var generalProperties = {
        forceFetch: true,
        isLogRequired: false
      }
      promises['allocationGroupsPromise'] = allocationGroupsModel.methods.getList(generalProperties, allocationGroupsModel, activeCatalogCode);
      promises['linkedCustomerPromise'] = linkedCustomerModel.methods.getList(generalProperties, linkedCustomerModel, activeCatalogCode);
      $mdDialog.show({
        controller: 'assignAllocationGroupsController',
        controllerAs: 'vm',
        templateUrl: 'app/main/catalogs/sub-modules/customer-allocations/dialogs/assign-allocation-groups.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: false,
        locals: {
          record: null,
          isNew: true,
          model: vm.model,
          promises: promises,
          activeCatalogCode: activeCatalogCode,
          customersList: vm.customerAllocations,
          event: ev
        }
      }).then(function(saved) {
        if (saved) {
            refreshItems(true, false);
        }
    });
    }

    function editItem(item, ev) {
      var allocationGroupsModel =  api.catalogs.allocationGroups;
      var linkedCustomerModel = api.catalogs.customers;
      var promises = {};
      var generalProperties = {
        forceFetch: true,
        isLogRequired: false
      }
      promises['allocationGroupsPromise'] = allocationGroupsModel.methods.getList(generalProperties, allocationGroupsModel, activeCatalogCode);
      promises['linkedCustomerPromise'] = linkedCustomerModel.methods.getList(generalProperties, linkedCustomerModel, activeCatalogCode);
      promises['customerAllocation'] = vm.model.methods.getDetails(false, item.CustomerId, activeCatalogCode);
      $mdDialog.show({
        controller: 'assignAllocationGroupsController',
        controllerAs: 'vm',
        templateUrl: 'app/main/catalogs/sub-modules/customer-allocations/dialogs/assign-allocation-groups.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: false,
        locals: {
          record: item,
          isNew: false,
          model: vm.model,
          promises: promises,
          activeCatalogCode: activeCatalogCode,
          customersList: [],
          event: ev
        }
      }).then(function(saved) {
        if (saved) {
            refreshItems(true, false);
        }
      });
    }

    var catalogChangedEventCleanup = $rootScope.$on('ActiveCatalogChangedEvent', function(e) {
      if(activeCatalogCode !== catalogFactory.getActiveCatalog().CatalogCode) {
          $state.reload('app.customer_allocations');
      }
    });
    $scope.$on('$destroy', function () {
        catalogChangedEventCleanup();
    })

  }
})();
(function () {
  'use strict';

  angular
    .module('app.main.catalogs.articles')
    .controller('assignAllocationGroupsController', assignAllocationGroupsController);

  /* @ngInject */
  function assignAllocationGroupsController($mdDialog, $scope, $window, $filter, $q, $timeout, toast, hotkeys, utility, record, isNew, model, promises, customersList, activeCatalogCode, event) {
    /* jshint validthis: true */
    var vm = this;

    //Data
    vm.isLoading = false;
    vm.isDataDirty = false;
    vm.isNew = isNew;
    vm.records = [];
    vm.searchText = [];
    vm.lookupModel = [];

    var customerId;
    var assignedAllocationGroupsMap = {};
    var quantityChangeTimeoutPromise;


    //Methods
    vm.saveRecord = saveRecord;
    vm.closeDialog = closeDialog;

    vm.onQuantityChange = onQuantityChange;
    vm.searchCustomer = searchCustomer;
    vm.getCustomerDisplayValue = getCustomerDisplayValue;
    vm.onCustomerChange = onCustomerChange;
    vm.lookupSearch = lookupSearch;
    vm.lookupChange = lookupChange;
    vm.getLookupDisplayValue = getLookupDisplayValue;
    vm.selectText = selectText;
    vm.isRequired = isRequired;


    activate();

    ////////////////

    function activate() {
      if (!isNew) {
        populateEditDialog();
      }
      else {
        createEmptyRow();
      }
      //Hotkeys
      hotkeys.bindTo($scope).add({
        combo: 'ctrl+enter',
        description: $filter('translate')('ACTIONS.SAVE'),
        allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
        callback: function (event) {
          if (!vm.isLoading && !vm.editForm.$invalid) {
            vm.saveRecord();
          }
        }
      });

      if (vm.isNew) {
        hotkeys.bindTo($scope)
          .add({
            combo: 'ctrl+shift+enter',
            description: $filter('translate')('ACTIONS.SAVE_AND_NEW'),
            allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
            callback: function (event) {
              if (!vm.isLoading && !vm.editForm.$invalid) {
                vm.saveRecord(true);
              }
            }
          });
      }
    }

    function saveRecord(saveAndNew) {
      vm.isLoading = true;
      // remove rows without data
      var requestObj = [];
      angular.forEach(vm.records, function(record) {
        if(angular.isDefined(record.AllocationGroupId) && record.AllocationGroupId !== null ) {
          requestObj.push(record);
        }
      });

      var actionType = vm.isNew ? 'ADD' : 'EDIT';
      model.methods.update(customerId, requestObj, activeCatalogCode, actionType)
        .then(function () {
          // when click on save and new while creating record
          if (vm.isNew && angular.isDefined(saveAndNew) && saveAndNew) {
            vm.editForm.$setPristine();
            vm.editForm.$setUntouched();
            vm.records = [];
            vm.searchText = [];
            vm.lookupModel = [];
            createEmptyRow();
            vm.isDataDirty = true;

            var el = $window.document.getElementById('dialog_input_first');
            if (el) {
              el.focus();
            }
          }
          else {
            closeDialog(true);
          }
          var toastMessage = vm.isNew ? 'SUCCESS.CREATE' : 'SUCCESS.UPDATE';
          toast.success(toastMessage, '', '');
        }, function () {
          closeDialog(vm.isDataDirty);
        }).finally(function () {
          vm.isLoading = false;
        })
    }

    function closeDialog(saved) {
      $mdDialog.hide(saved);
    }

    function onQuantityChange(rowIndex) {
      if(angular.isDefined(vm.records[rowIndex].Quantity)) {
        $timeout.cancel(quantityChangeTimeoutPromise);
        quantityChangeTimeoutPromise = $timeout(function() {
          // if last row and allocation groups is selected create empty row
          if(vm.isNew && rowIndex === vm.records.length-1 && angular.isDefined(vm.records[rowIndex].AllocationGroupId) && vm.records[rowIndex].AllocationGroupId !== null) {
            createEmptyRow();
          }
        }, 500);
      }
    }

    function searchCustomer(query) {
      return loadAvailableCustomers()
        .then(function(availableCustomers) {
          var predicate = { CustomerNumber: query };
          return query ? utility.filterObject(availableCustomers, predicate) : availableCustomers;
        });
    }

    function getCustomerDisplayValue(item) {
      return loadAvailableCustomers()
        .then(function(availableCustomers) {
          var result;
          if(angular.isObject(item)) {
            result = utility.filterObject(availableCustomers, { CustomerId: item.CustomerId }, true)[0];
          }
          else {
            result = utility.filterObject(availableCustomers, { CustomerId: item }, true)[0];
          }
          if(result) {
            return result.CustomerNumber;
          }
        });
    }

    function onCustomerChange(selectedObj) {
      if (angular.isObject(selectedObj)) {
        customerId = selectedObj.CustomerId;
      }
      else if (angular.isUndefined(selectedObj) || selectedObj === null) {
        customerId = undefined; // on record removal make field undefined or the property can be deleted using delete keyword
      }
    }

    function lookupSearch(query) {
      var results = [];
      var predicate = {};
      predicate.AllocationGroupName = query;
      return loadAvailableAllocationGroups()
        .then(function (availableAllocationGroups) {
          results = query ? utility.filterObject(availableAllocationGroups, predicate) : availableAllocationGroups;
          return results;
        });
    }

    function lookupChange(selectedObj, rowIndex) {
      if (angular.isObject(selectedObj)) {
        vm.records[rowIndex].AllocationGroupId = selectedObj.Id;
        assignedAllocationGroupsMap[selectedObj.Id] = 1;
      }
      else if (angular.isUndefined(selectedObj) || selectedObj === null) {
        delete assignedAllocationGroupsMap[vm.records[rowIndex].AllocationGroupId];
        vm.records[rowIndex].AllocationGroupId = undefined; // on record removal make field undefined or the property can be deleted using delete keyword
      }
      // if adding data to last row and quantity is added create new row
      if(rowIndex === vm.records.length-1 && angular.isDefined(vm.records[rowIndex].Quantity) && vm.records[rowIndex].Quantity !== null) {
        createEmptyRow();
      }
    }

    function getLookupDisplayValue(item) {
      return loadAllocationGroups()
        .then(function(allocationGroups) {
          return getLookupDisplayVal(item, allocationGroups);
        });
    }

    function getLookupDisplayVal(item, allocationGroups) {
      var result;
      if (allocationGroups) {
        // since autocomplete return object
        if (angular.isObject(item)) {
          result = utility.filterObject(allocationGroups, { Id: item.Id }, true);
        }
        // to initialize field value if any (when open update record dialog)
        else {
          result = utility.filterObject(allocationGroups, { Id: item }, true);
        }

        if (angular.isArray(result) && result.length > 0) {
          return result[0].AllocationGroupName;
        }
        else {
          return result.AllocationGroupName;
        }
      }
    }

    function selectText(event) {
      utility.selectInputText(event);
    }

    function isRequired(groupName, maxQuantity, minQuantity, rowIndex) {
      if ((isNew && rowIndex === 0)) {
        if (angular.isDefined(vm.records[rowIndex][groupName]) && vm.records[rowIndex][groupName] !== null) {
          if ((angular.isUndefined(vm.records[rowIndex][maxQuantity]) || vm.records[rowIndex][maxQuantity] === null) &&
            (angular.isUndefined(vm.records[rowIndex][minQuantity]) || vm.records[rowIndex][minQuantity] === null)) {
            return true;
          }
          else return false;//for any one of the quantity is defined
        }
        else return true;//if groupName is not defined
      }
      if (angular.isDefined(vm.records[rowIndex][groupName]) && vm.records[rowIndex][groupName] !== null) {
        if ((angular.isUndefined(vm.records[rowIndex][maxQuantity]) || vm.records[rowIndex][maxQuantity] === null) &&
          (angular.isUndefined(vm.records[rowIndex][minQuantity]) || vm.records[rowIndex][minQuantity] === null)) {
          return true;
        }
      }
      else if ((angular.isDefined(vm.records[rowIndex][maxQuantity]) && vm.records[rowIndex][maxQuantity] !== null) ||
        (angular.isDefined(vm.records[rowIndex][minQuantity]) && vm.records[rowIndex][minQuantity] !== null)) {
        return true;
      }
      return false;
    }


    function loadAvailableCustomers() {
      return promises['linkedCustomerPromise']
        .then(function(response) {
          var availableCustomers = utility.filterObject(response.data, {Status: 1});
          if(isNew){
            angular.forEach(customersList, function (customer) {
              var index = availableCustomers.indexOf(utility.filterObject(availableCustomers, { CustomerId: customer['CustomerId'] }, true)[0]);
              if (index !== -1) {
                availableCustomers.splice(index, 1);
              }
            });
          }
          return availableCustomers;
        });
    }

    function loadAllocationGroups() {
      return promises['allocationGroupsPromise']
        .then(function (response) {
          return response.data;
        });
    }

    function loadAvailableAllocationGroups() {
      // TODO if does not work (even after adding a value it will display selected record since once promise resolved it will be the same value) create promise locally and resolve every time (it should not work and if it work can be move to loadAllocationGroups)
      return loadAllocationGroups()
        .then(function (allocationGroups) {
          var availableAllocationGroups = [];
          angular.forEach(allocationGroups, function (allocationGroup) {
            if (allocationGroup.Status && !assignedAllocationGroupsMap[allocationGroup.Id]) {
              availableAllocationGroups.push(allocationGroup);
            }
          })
          return availableAllocationGroups;
        });
    }

    function populateEditDialog() {
      vm.isAllocationsLoaded = false;
      promises['customerAllocation']
        .then(function(response) {
          angular.forEach(response.data.AllocationGroups, function(AllocationGroup) {
            var recordsLength = vm.records.push({ AllocationGroupId: AllocationGroup.Id, Quantity: AllocationGroup.Quantity, MinQuantity: AllocationGroup.MinQuantity });
            if(angular.isUndefined(vm.lookupModel[recordsLength-1])) {
              vm.lookupModel[recordsLength-1] = {};
            }
            vm.lookupModel[recordsLength-1].AllocationGroupId = AllocationGroup.Id;
          });
          createEmptyRow();
          customerId = response.data.CustomerId;
          vm.lookupModel[0].customerId = customerId;
          vm.isAllocationsLoaded = true;
        });
    }

    function createEmptyRow() {
      vm.searchText.push({});
      vm.lookupModel.push({});
      vm.records.push({ AllocationGroupId: null, Quantity: null, MinQuantity: null })
    }

    $scope.$on('$destroy', function() {
      $timeout.cancel(quantityChangeTimeoutPromise);
    })

  }
})();
(function () {
  'use strict';

  angular
    .module('app.main.catalogs.allocation-groups')
    .controller('customerAllocationsDetailsController', customerAllocationsDetailsController);

  /* @ngInject */
  function customerAllocationsDetailsController($document, api, $state, $stateParams, $rootScope, $q, catalogFactory,
    $mdDialog, utility, settingsFactory) {
    /* jshint validthis: true */
    var vm = this;

    // Data
    var customerId = $stateParams.id;
    var activeCatalogCode = catalogFactory.getActiveCatalog().CatalogCode;

    vm.model = api.catalogs.customerAllocations;

    vm.allocationGroupsModel = api.customerAllocations.allocationGroups;
    settingsFactory.applyPersistedListViewLayout(vm.allocationGroupsModel);

    vm.customerAllocation = {};
    vm.allocationGroups = [];
    vm.filteredAllocationGroups = [];

    vm.isLoading = false;

    // Methods
    vm.refreshRecord = refreshRecord;
    vm.edit = edit;
    vm.doAllocationGroupsItemAction = doAllocationGroupsItemAction;
    vm.viewAllocationGroupsDetails = viewAllocationGroupsDetails;

    activate();

    ////////////////

    function activate() {
      refreshRecord(true);
    }

    function refreshRecord(isLogRequired) {
      vm.isLoading = true;

      vm.model.methods.getDetails(isLogRequired, customerId, activeCatalogCode)
        .then(function (response) {
          vm.customerAllocation = response.data;
          vm.customerAllocation.Status = 1;
          vm.allocationGroups = response.data.AllocationGroups;
          vm.title = angular.copy(vm.customerAllocation[vm.model.lookupDisplayField]);

          //Update Breadcrumb
          $state.current.data.displayName = vm.title;
          $rootScope.$broadcast('breadcrumb-updated');
        })
        .finally(function () {
          vm.isLoading = false;
        });
    }

    function edit(record, ev) {
      var allocationGroupsModel =  api.catalogs.allocationGroups;
      var linkedCustomerModel = api.catalogs.customers;
      var promises = {};
      var generalProperties = {
        forceFetch: true,
        isLogRequired: false
      }
      promises['allocationGroupsPromise'] = allocationGroupsModel.methods.getList(generalProperties, allocationGroupsModel, activeCatalogCode);
      promises['linkedCustomerPromise'] = linkedCustomerModel.methods.getList(generalProperties, linkedCustomerModel, activeCatalogCode);
      promises['customerAllocation'] = $q.when({ data: vm.customerAllocation });
      return $mdDialog.show({
        controller: 'assignAllocationGroupsController',
        controllerAs: 'vm',
        templateUrl: 'app/main/catalogs/sub-modules/customer-allocations/dialogs/assign-allocation-groups.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: false,
        locals: {
          record: record,
          isNew: false,
          model: vm.model,
          promises: promises,
          activeCatalogCode: activeCatalogCode,
          customersList: [],
          event: ev
        }
      });
    }

    function doAllocationGroupsItemAction(action, record) {
      if (action) {
        switch (action.id) {
          case 'view':
            viewAllocationGroupsDetails(record);
            break;
        }
      }
    }

    function viewAllocationGroupsDetails(record) {
      var stateParams = {};
      stateParams.id = record['Id'];
      $state.go('app.allocation_groups.details', stateParams)
    }
  }
})();
(function () {
	'use strict';

	angular
		.module('app.main.catalogs.crds-linear')
		.controller('crdsLinearListController', crdsLinearListController);

	/* @ngInject */
	function crdsLinearListController(api, $rootScope, $scope, $state, catalogFactory, dataImporter, $timeout, settingsFactory, crud, $mdDialog,
		$document, utility) {
		/* jshint validthis: true */
		var vm = this;


		//Data
		var activeCatalog = catalogFactory.getActiveCatalog();
		var activeCatalogId = activeCatalog.CatalogCode;
		vm.activeCatalogId = activeCatalogId;

		vm.model = api.catalogs.crdsLinear;
		settingsFactory.applyPersistedListViewLayout(vm.model);
		var activieCatalogCRDsList = catalogFactory.getActiveCatalogDetails().CatalogCRDList;


		vm.CRDs = [];
		vm.filteredCRDs = [];
		vm.isLoading = false;
		var timeoutPromise;


		//Methods
		vm.refreshItems = refreshItems;
		vm.doItemAction = doItemAction;
		vm.doListAction = doListAction;
		vm.viewItem = viewItem;
		vm.assignCRDs = assignCRDs;

		activate();

		////////////////

		function activate() {
			refreshItems(vm.model.isDirty, true);
		}

		function refreshItems(forceFetch, isLogRequired) {
			vm.isLoading = true;
			var generalProperties = {
				forceFetch: forceFetch,
				isLogRequired: isLogRequired,
				config: {},
				supportIncrementalResult: true,
				modelIdField: 'ArticleNumber',
				isMajor: false,
			}
			timeoutPromise = $timeout(function () {
				vm.model.methods.getList(generalProperties, vm.model, activeCatalogId)
					.then(function (response) {
						var responseData = [];
						angular.forEach(response.data, function (article) {
							if (angular.isDefined(article.Crds) && article.Crds.length > 0 && (activeCatalog.DataSourceTypeId !== 3 || article.Status === 1)) {
								angular.forEach(article.Crds, function (crd) {
									var index = activieCatalogCRDsList.indexOf(utility.filterObject(activieCatalogCRDsList, { Id: crd.CrdId, Status: 1 }, true)[0]);
									if (index !== -1) {
										responseData.push({
											ArticleId: article.Id,
											ArticleNumber: article.ArticleNumber,
											ModelNumber: article.ModelNumber,
											Status: article.Status,
											CrdId: crd.CrdId,
											Description: crd.Description,
											CreatedDate: crd.CreatedDate,
											UpdatedDate: crd.UpdatedDate,
										});
									}
								});
							}
						});
						vm.CRDs = responseData;
					})
					.finally(function () {
						vm.isLoading = false;
					});
			}, 500);
		}

		//Item Action button pressed event
		function doItemAction(action, record) {
			if (action) {
				switch (action.id) {
					case 'delete':
							var recordCopy = angular.copy(record);
							var currentArticleCrds = utility.filterObject(vm.CRDs, {ArticleId: recordCopy.ArticleId}, true);
							recordCopy.Status = 0;
							vm.model.methods.activateBulk(recordCopy, angular.copy(currentArticleCrds), vm.model, action.id, recordCopy.ArticleId, activeCatalogId).then(function() {
								refreshItems(true, false);
							})
						break;
					case 'view':
						viewItem(record);
						break;
				}
			}
		}

		function doListAction(action) {
			if (action) {
				switch (action.id) {
					case 'import':
						dataImporter.importExcel(vm.model, true).then(function(result) {
							vm.model.methods.createBulk(result.data, activeCatalogId, vm.model, action.id);
						});
						break;
					case 'shiftCrd':
						dataImporter.importExcel(api.catalogs.shiftCrds, true).then(function (result) {
							vm.model.methods.shiftCrds(vm.model, result.data, activeCatalogId);
						});
						break;
				}
			}
		}

		function viewItem(item) {
			var id = item.ArticleId;
			var stateParams = { id: id, tab: 'CRDS' };
			$state.go('app.articles.details', stateParams);
		}

		function assignCRDs(ev) {
			var modelCopy = angular.copy(vm.model);
			var articleNumberModel = utility.filterObject(modelCopy.fields, {field: 'ArticleNumber'}, true)[0];
			articleNumberModel.creatable = false;
			var articleIdModel = utility.filterObject(modelCopy.fields, {field: 'ArticleId', visible: false}, true)[0];
      articleIdModel.creatable = true;
			var lookupPromises = {};
			lookupPromises = crud.createLookupPromise(modelCopy, undefined , 'create');
			$mdDialog.show({
					controller         : 'assignArticleCRDsController',
					controllerAs       : 'vm',
					templateUrl        : 'app/main/catalogs/sub-modules/crds-linear/dialogs/assign-crds/assign-crds.html',
					parent             : angular.element($document.body),
					targetEvent        : ev,
					clickOutsideToClose: false,
					locals             : {
							lookupPromises: lookupPromises,
							model: modelCopy,
							event: ev
					}
			});
		}

		var catalogChangedEventCleanup = $rootScope.$on('ActiveCatalogChangedEvent', function (e) {
			if (activeCatalogId !== catalogFactory.getActiveCatalog().CatalogCode) {
				$state.reload('app.crds_linear');
			}
		});
		$scope.$on('$destroy', function () {
			catalogChangedEventCleanup();
			$timeout.cancel(timeoutPromise);
		});

	}
})();
(function() {
    'use strict';

    angular
        .module('app.main.catalogs.crds',[])
        .config(config);

    /* @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
        // State
        $stateProvider.state('app.crds', {
            url    : '/crds',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/catalogs/sub-modules/crds/list/crds-list.html',
                    controller : 'crdsListController as vm'
                }
            },
            resolve: {
                catalogSpecificCRDsModel : function(api, catalogFactory) {
                    //Mapping response source property to fields target property
                    var propertiesMapper = [{target: 'field', source:'CustomerRequiredDate', formatDate:'MMM d, y'}, {target: 'displayLabel', source: 'CustomerRequiredDate', description: 'Description', formatDate:'MMM d, y'}, {target: 'crdId', source: 'Id'}],
                        inputType = 'switch',
                        nestedArrayName = 'Crds',
                        //dummy value since the value for CRD depend on existence of the object in get all the articles CRDs
                        valueMapper = 'Id',
                        targetModel = 'catalogs.crds',
                        sourceModel = 'catalogs.CRD',
                        isCRD = true;
                    return catalogFactory.createDynamicModel(targetModel, sourceModel, propertiesMapper, inputType, nestedArrayName, valueMapper, isCRD);
                }
            },
            data: {
                displayName: 'CRD.NAV'
            },
            //only users with following accessPrivileges in their role access list can access this route
            // accessPrivileges: ['GetCatalogListArticleCRDs']
            // accessPrivileges: ['nav_delivery_dates']
            accessInfo: {
                accessPrivileges: ['nav_delivery_dates']
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/catalogs/sub-modules/crds');

        // Navigation
        msNavigationServiceProvider.saveItem('catalogs.crds', {
            title : 'Delivery Dates',
            icon  : 'icon-calendar-clock',
            translate: 'CRD.NAV',
            weight: 60,
            // accessPrivileges: ['GetCatalogListArticleCRDs']
            // accessPrivileges: ['nav_delivery_dates']
            accessInfo: {
                accessPrivileges: ['nav_delivery_dates']
            }
        });

        msNavigationServiceProvider.saveItem('catalogs.crds.crds', {
            title      : 'Tabular View',
            subTitle   : 'Delivery Dates',
            icon       : 'icon-calendar-clock',
            state      : 'app.crds',
            translate  : 'NAV.TABULAR_VIEW',
            weight     : 60,
            // accessPrivileges: ['GetCatalogListArticleCRDs']
            // accessPrivileges: ['nav_delivery_dates']
            accessInfo: {
                accessPrivileges: ['nav_delivery_dates']
            }
        });
    }
})();
(function() {
    'use strict';

	angular
		.module('app.main.catalogs.crds')
		.controller('crdsListController', crdsListController);

	/* @ngInject */
	function crdsListController(api, $rootScope, $scope, $state, catalogFactory, catalogSpecificCRDsModel, dataImporter, bulkUpdater, $timeout, settingsFactory, crud) {
		/* jshint validthis: true */
		var vm = this;


        //Data
        var activeCatalog = catalogFactory.getActiveCatalog();
		var activeCatalogId = activeCatalog.CatalogCode;
        vm.activeCatalogId = activeCatalogId;

        vm.model = catalogSpecificCRDsModel;
        settingsFactory.applyPersistedListViewLayout(vm.model);


		vm.CRDs = [];
		vm.filteredCRDs = [];
		vm.isLoading = false;
		var timeoutPromise;


		//Methods
		vm.refreshItems = refreshItems;
		vm.doItemAction = doItemAction;
		vm.doListAction = doListAction;
		vm.viewItem = viewItem;

		activate();

		////////////////

        function activate() {
            refreshItems(vm.model.baseModel.isDirty, true);
		}

		function refreshItems(forceFetch, isLogRequired) {
            vm.isLoading = true;
            var generalProperties = {
                forceFetch: forceFetch,
                isLogRequired: isLogRequired,
                config: {},
                supportIncrementalResult: true,
                modelIdField: 'Id',// it should be outerObject Id
                isMajor: false,
                isArticleRelatedData: true,
				nestedArrayName: 'Crds',
				nestedDataIdField: 'Id' //it should be nestedObject Id
            }
			timeoutPromise = $timeout(function() {// TODO - need to change GET method catching mechanism (since the data is catched controll goes to then part imidiatly and transform function freezes the UI)
				vm.model.methods.getList(generalProperties, vm.model, activeCatalogId)
				.then(function (response) {
					var responseData;
					responseData = response.data;
					vm.CRDs = catalogFactory.transformCRDsResponse(responseData, 'Crds', vm.model.fields);
				})
				.finally(function () {
					vm.isLoading = false;
				});
			},500);
		}

		//Item Action button pressed event
		function doItemAction(action, record) {
			if (action && record && action.id === 'view') {
                viewItem(record);
			}
		}

		function doListAction(action, records) {
			if (action) {
                switch (action.id) {
					case 'importTabular':
						dataImporter.importExcel(vm.model, true).then(function(result) {
							vm.model.methods.createBulk(result.data, activeCatalogId, vm.model, action.id);
						});
						break;
					case 'importLinear':
						dataImporter.importExcel(api.catalogs.importLinear, true).then(function(result) {
							vm.model.methods.createBulk(result.data, activeCatalogId, vm.model, action.id);
						});
						break;
					case 'shiftCrd':
						dataImporter.importExcel(api.catalogs.shiftCrds, true).then(function(result) {
							vm.model.methods.shiftCrds(vm.model, result.data, activeCatalogId);
						});
						break;
					case 'updateBulk':
						var lookupPromises = {};
						lookupPromises = crud.createLookupPromise(vm.model, undefined , 'edit');
						bulkUpdater.showDialog(vm.model, vm.CRDs, {'catalogId': activeCatalogId}, lookupPromises);
						break;
				}
			}
		}

         function viewItem(item) {
            var id = item.ArticleId;
            var stateParams = {id: id, tab: 'CRDS'};
            $state.go('app.articles.details', stateParams);
		}

        var catalogChangedEventCleanup = $rootScope.$on('ActiveCatalogChangedEvent', function(e) {
            if(activeCatalogId !== catalogFactory.getActiveCatalog().CatalogCode) {
                $state.reload('app.crds');
            }
        });
        $scope.$on('$destroy', function () {
            catalogChangedEventCleanup();
			$timeout.cancel(timeoutPromise);
        });

	}
})();
(function() {
    'use strict';

	angular
		.module('app.main.catalogs.consolidations')
		.controller('consolidationsListController', consolidationsListController);

	/* @ngInject */
	function consolidationsListController(api, $document, $rootScope, $scope, $state, catalogFactory, $mdDialog, crud, settingsFactory, SecurityFactory) {
		/* jshint validthis: true */
		var vm = this;

        //Data
        var activeCatalog = catalogFactory.getActiveCatalog();
        var catalogCode = activeCatalog.CatalogCode;
        var canLockOrders = SecurityFactory.isAuthorized({accessPrivileges: 'CreateOrderConsolidation_LockOrders'});

        vm.model = api.catalogs.consolidations;
        settingsFactory.applyPersistedListViewLayout(vm.model);

		vm.consolidations = [];
		vm.filteredConsolidations = [];
		vm.isLoading = false;


		//Methods
		vm.refreshItems = refreshItems;
		vm.doItemAction = doItemAction;
		vm.viewItem = viewItem;
		vm.addRecord = addRecord;

		activate();

		////////////////

		function activate() {
			refreshItems(vm.model.isDirty, true);
		}

		function refreshItems(forceFetch, isLogRequired) {
			vm.isLoading = true;
            var generalProperties = {
                forceFetch: forceFetch,
                isLogRequired: isLogRequired
            }
			vm.model.methods.getList(generalProperties, catalogCode)
			.then(function (response) {
				vm.consolidations = response.data;
			})
			.finally(function () {
				vm.isLoading = false;
			});
		}

		//Item Action button pressed event
		function doItemAction(action, record) {
			if (action && record) {
                switch (action.id) {
                    case 'view':
                        viewItem(record);
                        break;
					case 'reRun':
                        reRunConsolidation(record, null);
                        break;
                }
			}
		}

        function viewItem(record) {
            var stateParams = {id: record[vm.model.idField]};
            $state.go('app.consolidations.details', stateParams);
		}

        function addRecord(ev) {
			var lookupPromise = {};
			lookupPromise = crud.createLookupPromise(vm.model, undefined , 'create');
			$mdDialog.show({
                controller         : 'createConsolidationController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/catalogs/sub-modules/consolidations/dialogs/create-consolidation.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: false,
                locals             : {
                    lookupPromise: lookupPromise,
					model: vm.model,
					record: null,
                    activeCatalogCode: catalogCode,
					sellerId: activeCatalog.AccountId,
					isNew: true,
                    canLockOrders: canLockOrders,
                    existingRecords: angular.copy(vm.consolidations),
                    event: ev
                }
            }).then(function(saved) {
                if (saved) {
                    api.catalogs.consolidationTemplates.isDirty = true; // since on creation of consolidation values of consolidation tempplate gets changed (totalConsolidations)
                    refreshItems(true, false);
                }
            });
		}

		function reRunConsolidation(record, ev) {
			var lookupPromise = {};
			lookupPromise = crud.createLookupPromise(vm.model, undefined , 'create');
			$mdDialog.show({
                controller         : 'createConsolidationController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/catalogs/sub-modules/consolidations/dialogs/create-consolidation.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: false,
                locals             : {
                    lookupPromise: lookupPromise,
					model: vm.model,
					record: record,
                    activeCatalogCode: catalogCode,
					sellerId: activeCatalog.AccountId,
					isNew: false,
                    canLockOrders: canLockOrders,
                    existingRecords: angular.copy(vm.consolidations),
                    event: ev
                }
            }).then(function(saved) {
                if (saved) {
                    refreshItems(true, false);
                }
            });
		}

        var catalogChangedEventCleanup = $rootScope.$on('ActiveCatalogChangedEvent', function(e) {
            if(catalogCode !== catalogFactory.getActiveCatalog().CatalogCode) {
                $state.reload('app.consolidations');
            }
        });
        $scope.$on('$destroy', function () {
            catalogChangedEventCleanup();
        });

	}
})();
(function() {
    'use strict';

    angular
        .module('app.main.catalogs.consolidations')
        .controller('createConsolidationController', createConsolidationController);

    /* @ngInject */
    function createConsolidationController($mdDialog, $q, $scope, $window, $filter, hotkeys, toast, api, utility, lookupPromise,
                 model, record, activeCatalogCode, sellerId, isNew, canLockOrders, existingRecords, event) {
        /* jshint validthis: true */
        var vm = this;

        //Data
        vm.model = model;
        var templateModel = api.catalogs.consolidationTemplates;
        vm.isLoading = false;
        vm.record = {};
        vm.lookupModel = {};
        vm.searchText = {};
        vm.templateCriteria = [];
        vm.templateFieldMap = {};
        vm.isDataDirty = false;
        vm.isNew = isNew;
        vm.canLockOrders = canLockOrders;
        vm.existingRecords = existingRecords;
        var isTemplateFieldsLoading = false;


        if(angular.isDefined(record) && record != null) {
            vm.lockOrders = record.LockOrders;
            vm.record.IncludeRejectedOrders = record.IncludeRejectedOrders;
            vm.record.IncludeChildCatalogs = record.IncludeChildCatalogs;
            vm.record.IncludeLockedOrders = record.IncludeLockedOrders;
        }
        else {
            vm.lockOrders = 0;
            vm.record.IncludeRejectedOrders = 0;
            vm.record.IncludeChildCatalogs = 0;
            vm.record.IncludeLockedOrders = 0;
        }


        //Methods

        vm.saveRecord = saveRecord;
        vm.closeDialog = closeDialog;

        vm.lookupSearch = lookupSearch;
        vm.lookupChange = lookupChange;
        vm.getLookupDisplayValue = getLookupDisplayValue;
        vm.selectText = selectText;
        vm.onConsolidateUnapproveOrdersChange = onConsolidateUnapproveOrdersChange;


        activate();

        ////////////////

        function activate() {
            loadConsolidationTemplates().then(function() {
                if(!isNew) { // if re-rerun, reload form data
                    vm.record = angular.copy(record);
                    vm.record.Name = undefined;
                    vm.lookupModel.TemplateId = record.TemplateId; // it is different then templateModel.idField
                    // getTemplateFields(record[templateModel.idField]); // to avoid 2 api calls in case of re-run calling below method
                    getTemplateFieldValues();
                }
            });
            //Hotkeys
            hotkeys.bindTo($scope).add({
                combo: 'ctrl+enter',
                description: $filter('translate')('ACTIONS.SAVE'),
                allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
                callback: function(event) {
                    if (!vm.isLoading && !vm.editForm.$invalid) {
                        vm.saveRecord();
                    }
                }
            });
        }

        function saveRecord() {
            var canLockOrds;
            if(canLockOrders && vm.lockOrders) {
                canLockOrds = true;
            }
            else {
                canLockOrds = false;
            }
            vm.isLoading = true;
            createRequestObject(vm.record, vm.templateCriteria, vm.templateFieldMap);
            vm.model.methods.create(vm.record, activeCatalogCode, canLockOrds).then(function() {
                toast.success('SUCCESS.CREATE', '', '');
            }, function(err) {
                closeDialog(true);
            }).finally(function () {
                closeDialog(true);
                vm.isLoading = false;
            });
        }

        function closeDialog(saved) {
            $mdDialog.hide(saved);
        }

        function lookupSearch(query, fieldName) {
            var field = utility.filterObject(model.fields, { field: fieldName }, true)[0];
            var results = [];
            var lookupFilter = angular.isDefined(field.lookupFilter) ? field.lookupFilter : {};
            var predicate = angular.copy(lookupFilter);
            predicate.value = query;
            var lookupModel = api.getModel(field.lookupSource);

            if ( lookupModel && angular.isDefined(lookupModel.lookupData) && angular.isDefined(lookupModel.lookupData.data) && lookupModel.lookupData.data.length) {
                results = query ? utility.filterObject(lookupModel.lookupData.data, predicate) : utility.filterObject(lookupModel.lookupData.data, lookupFilter, true);
            }
            else {
                return lookupPromises[field.field].then(function (lookupData) {
                   return results = query ? utility.filterObject(lookupData.data, predicate) : utility.filterObject(lookupData.data, lookupFilter, true);
                });
            }
            return results;
        }

        // convert dropdown scope value form object(lookup record) to id property of lookup record
        function lookupChange(selectedObj, fieldName) {
            if(angular.isObject(selectedObj)) {
                vm.record[fieldName] = selectedObj.id;
                if (fieldName == 'TemplateId') {
                    getTemplateFields(selectedObj.id);
                }
            }
            else if(angular.isUndefined(selectedObj) || selectedObj === null) {
                vm.record[fieldName] = undefined; // on record removal make field undefined or the property can be deleted using delete keywork
                if (fieldName == 'TemplateId') {
                    vm.templateCriteria = [];
                }
            }
        }

        function getLookupDisplayValue(item, lookupSource) {
            var lookupModel = api.getModel(lookupSource);

            if (lookupModel.lookupData && angular.isDefined(lookupModel.lookupData.data) && lookupModel.lookupData.data.length) {
                return getLookupDisplayVal(item, lookupModel.lookupData);
            }
            else {
                return api.getLookupData(lookupModel).then(function (lookupData) {
                    return getLookupDisplayVal(item, lookupData);
                });
            }
        }

        function getLookupDisplayVal(item, lookupData) {
            var result;
            if (lookupData) {
                // since autocomplete return object
                if (angular.isObject(item)) {
                    result = utility.filterObject(lookupData.data, { id: item.id }, true);
                }
                // to initialize field value if any (when open update record dialog)
                else {
                    result = utility.filterObject(lookupData.data, { id: item }, true);
                }

                if (angular.isArray(result) && result.length > 0) {
                    return result[0].value;
                }
                else {
                    return result.value;
                }
            }
        }

        function selectText(event) {
            utility.selectInputText(event);
        }

        function onConsolidateUnapproveOrdersChange() {
            if(vm.record.IncludeRejectedOrders == 1) {
                vm.lockOrders = 0;
            }
        }

        //Helper method
        function loadConsolidationTemplates() {
            return lookupPromise['TemplateId'].then(function(result) {
                vm.listOfActiveTemplates = angular.copy(result);
                vm.listOfActiveTemplates.data = utility.filterObject(result.data, {Status: 1});
                // if indexArry needed to be utelize uncomment following code to update arrayIndexes values
                // utility.updateLookupDataIndexes(vm.listOfActivePriceGroups, api.catalogs.priceGroup);
            });
        }

        function getTemplateFields(templateId) {
            isTemplateFieldsLoading = true;
            templateModel.methods.getDetails(false, templateId, activeCatalogCode, sellerId).then(function(response) {
                vm.templateCriteria = $filter('orderBy')(utility.filterObject(response.data.OrderConsolidationTemplateFieldList, {IsInputField: true}), 'SortOrder');
                angular.forEach(vm.templateCriteria, function(criteria){
                    // inorder to use vm.templateFieldMap for BETWEEN operator to contain FROM and TO values
                    if(criteria.FilterOperator.toUpperCase() === 'BETWEEN') {
                        vm.templateFieldMap[criteria.ConsolidationFieldId] = {};
                    }
                });
            }).finally(function() {
                isTemplateFieldsLoading = false;
            });
        }

        function createRequestObject(records, templateCriteria, templateFieldMap) {
            records.ConsoliationFieldsValueRequest = [];
            angular.forEach(templateCriteria, function(criteria) {
                var ConsolidationField = {ConsoliationFieldId: '', ConsolidationFieldValue: ''};
                    ConsolidationField.ConsoliationFieldId = criteria.ConsolidationFieldId.toString();

                if(angular.isDefined(templateFieldMap[criteria.ConsolidationFieldId])) {

                    // if textarea (multiple input values separated by nextline)
                    if(angular.isDefined(criteria.FilterOperator) && (criteria.FilterOperator.toUpperCase() === 'IN' || criteria.FilterOperator.toUpperCase() === 'NOT IN')) {
                        var valueList = templateFieldMap[criteria.ConsolidationFieldId].toString().match(/[^\r\n]+/g);
                        if(angular.isArray(valueList)) {
                            ConsolidationField.ConsolidationFieldValue = valueList.join();
                        }
                        else if(valueList === null) {
                            ConsolidationField.ConsolidationFieldValue = "";
                        }
                    }
                    else if(angular.isDefined(criteria.FilterOperator) && (criteria.FilterOperator.toUpperCase() === 'BETWEEN')) {
                        if(angular.isDate(templateFieldMap[criteria.ConsolidationFieldId]['from']) && angular.isDate(templateFieldMap[criteria.ConsolidationFieldId]['to'])) {
                                ConsolidationField.ConsolidationFieldValue = utility.setDateHourUTC(templateFieldMap[criteria.ConsolidationFieldId]['from'], 12).toISOString()
                                + ',' + utility.setDateHourUTC(templateFieldMap[criteria.ConsolidationFieldId]['to'], 12).toISOString();
                        }
                        else {
                            ConsolidationField.ConsolidationFieldValue = templateFieldMap[criteria.ConsolidationFieldId]['from']
                            + ',' +templateFieldMap[criteria.ConsolidationFieldId]['to'];
                        }
                    }
                    else {
                        if(angular.isDate(templateFieldMap[criteria.ConsolidationFieldId])) {
                                ConsolidationField.ConsolidationFieldValue = utility.setDateHourUTC(templateFieldMap[criteria.ConsolidationFieldId], 12);
                        }
                        else {
                            ConsolidationField.ConsolidationFieldValue = templateFieldMap[criteria.ConsolidationFieldId].toString();
                        }
                    }

                    records.ConsoliationFieldsValueRequest.push(ConsolidationField);
                }
                // if user kept switch untouch make field value false
                else if(angular.isUndefined(templateFieldMap[criteria.ConsolidationFieldId]) && criteria.ColumnDataType == 'bit') {
                    ConsolidationField.ConsolidationFieldValue = false;
                    records.ConsoliationFieldsValueRequest.push(ConsolidationField);
                }
            });
        }

        // only used in case of consolidation re-run to populate input fields and their respective values
        function getTemplateFieldValues() {
            isTemplateFieldsLoading = true;
            var criteriaVal = [];
            vm.model.methods.getDetails(false, vm.record[vm.model.idField], activeCatalogCode).then(function(response) {
                vm.templateCriteria = response.data.ConsolidationFields;
                angular.forEach(vm.templateCriteria, function(criteria) {
                    if(!(criteria.ColumnDataType === 'date' || criteria.ColumnDataType === 'datetime')) {
                        if(criteria.FilterOperator === 'BETWEEN') {
                            criteriaVal = [];
                            criteriaVal = criteria.ConsolidationFieldValue.split(',');
                            if(criteriaVal.length) {
                                var from = criteriaVal[0],
                                    to = criteriaVal[1];
                                //since API sending int data type as string
                                if(criteria.ColumnDataType == 'bigint' || criteria.ColumnDataType == 'decimal' || criteria.ColumnDataType == 'int') {
                                    from = parseInt(from);
                                    to = parseInt(to);
                                }
                                vm.templateFieldMap[criteria.ConsolidationFieldId] = {};
                                vm.templateFieldMap[criteria.ConsolidationFieldId]['from'] = from;
                                vm.templateFieldMap[criteria.ConsolidationFieldId]['to'] = to;
                            }
                        }
                        else {
                            var val = criteria.ConsolidationFieldValue;
                            if(criteria.ColumnDataType == 'bigint' || criteria.ColumnDataType == 'decimal' || criteria.ColumnDataType == 'int') {
                                val = parseInt(val);
                            }
                            vm.templateFieldMap[criteria.ConsolidationFieldId] = val;
                        }
                    }
                    else {
                        if(criteria.FilterOperator === 'BETWEEN') {
                            criteriaVal = [];
                            criteriaVal = criteria.ConsolidationFieldValue.split(',');
                            if(criteriaVal.length) {
                                vm.templateFieldMap[criteria.ConsolidationFieldId] = {};
                                vm.templateFieldMap[criteria.ConsolidationFieldId]['from'] = utility.createDateObject(criteriaVal[0]);
                                vm.templateFieldMap[criteria.ConsolidationFieldId]['to'] = utility.createDateObject(criteriaVal[1]);
                            }
                        }
                        else {
                            vm.templateFieldMap[criteria.ConsolidationFieldId] = utility.createDateObject(criteria.ConsolidationFieldValue);
                        }
                    }
                });
            }).finally(function() {
                isTemplateFieldsLoading = false;
            });
        }

    }
})();
(function() {
'use strict';

    angular
        .module('app.main.catalogs.consolidations')
        .controller('consolidationsDetailsController', consolidationsDetailsController);

    /* @ngInject */
    function consolidationsDetailsController(api, $state, $stateParams, $rootScope, catalogFactory, settingsFactory, utility, SecurityFactory, CONSTANTS) {
        /* jshint validthis: true */
        var vm = this;

        // Data
        var consolidationId = $stateParams.id;
        var activeCatalog = catalogFactory.getActiveCatalog();
        var activeCatalogCode = activeCatalog.CatalogCode;

        vm.model = angular.copy(api.catalogs.consolidations);
        utility.filterObject(vm.model.fields, {field: 'DownloadURL'}, true)[0].visible = true;

        vm.criteriaModel = api.consolidations.criteria;
        settingsFactory.applyPersistedListViewLayout(vm.criteriaModel);

        vm.consolidation = {};
        vm.criteria = [];
        vm.filteredCriteria = [];

        //TODO- TEMP UNTIL BACKGROUND JOB API CHANGE
        vm.errorsModel = api.consolidations.errorList;
        settingsFactory.applyPersistedListViewLayout(vm.errorsModel);

        vm.errorList = [];
        vm.filteredErrorList = [];
        vm.isErrorLoading = false;
        var consolidationJobId = -1;
        //TODO- TEMP UNTIL BACKGROUND JOB API CHANGE


        vm.isLoading = false;


        // Methods
        vm.refreshRecord = refreshRecord;

        //TODO- TEMP UNTIL BACKGROUND JOB API CHANGE
        vm.refereshErrors = refereshErrors;
        //TODO- TEMP UNTIL BACKGROUND JOB API CHANGE

        activate();

        ////////////////

        function activate() {
            refreshRecord(true);
        }

        function refreshRecord(isLogRequired) {
            vm.isLoading = true;
            vm.model.methods.getDetails(isLogRequired, consolidationId, activeCatalogCode).then(function(response) {
                vm.consolidation = response.data;
                vm.title = vm.consolidation[vm.model.lookupDisplayField];
                vm.criteria = response.data.ConsolidationFields;

                //TODO- TEMP UNTIL BACKGROUND JOB API CHANGE
                consolidationJobId = vm.consolidation[vm.model.idField];
                if(SecurityFactory.isAuthorized({accessPrivileges: CONSTANTS.PRIVILEGES.CONSOLIDATIONS.DETAIL.ERRORS_LIST})) {
                    refereshErrors();
                }
                //TODO- TEMP UNTIL BACKGROUND JOB API CHANGE

                //Update Breadcrumb
                $state.current.data.displayName = vm.title;
                $rootScope.$broadcast('breadcrumb-updated');
            })
            .finally(function() {
                vm.isLoading = false;
            });
        }

        //TODO- TEMP UNTIL BACKGROUND JOB API CHANGE
        function refereshErrors() {
            vm.isErrorLoading = true;
            vm.errorsModel.methods.getDetails(consolidationJobId).then(function(response) {
                vm.errorList = response.data.ImportErrorList;
                angular.forEach(vm.errorList, function(errorList) {
                    errorList.ConsolidationStatus = response.data.ConsolidationStatus;
                })
            })
            .finally(function() {
                vm.isErrorLoading = false;
            });
        }
        //TODO- TEMP UNTIL BACKGROUND JOB API CHANGE
    }
})();
(function() {
    'use strict';

	angular
		.module('app.main.catalogs.consolidation-templates')
		.controller('consolidationTemplatesListController', consolidationTemplatesListController);

	/* @ngInject */
	function consolidationTemplatesListController(api, $rootScope, $scope, $state, $document, catalogFactory, $mdDialog, settingsFactory, crud) {
		/* jshint validthis: true */
		var vm = this;

        //Data
        var activeCatalog = catalogFactory.getActiveCatalog();
        var activeCatalogCode = activeCatalog.CatalogCode;
        var sellerId = activeCatalog.AccountId;

        vm.model = api.catalogs.consolidationTemplates;
        settingsFactory.applyPersistedListViewLayout(vm.model);

		vm.consolidationTempates = [];
		vm.filteredConsolidationTempates = [];
		vm.isLoading = false;


		//Methods
		vm.refreshItems = refreshItems;
		vm.doItemAction = doItemAction;
		vm.viewRecord = viewRecord;
		vm.addRecord = addRecord;
        vm.copyTemplates = copyTemplates;

		activate();

		////////////////

		function activate() {
			refreshItems(vm.model.isDirty, true);
		}

		function refreshItems(forceFetch, isLogRequired) {
            var generalProperties = {
                forceFetch: forceFetch,
                isLogRequired: isLogRequired
            }
			vm.isLoading = true;
			vm.model.methods.getList(generalProperties, activeCatalogCode, sellerId)
			.then(function (response) {
				vm.consolidationTempates = response.data;
			})
			.finally(function () {
				vm.isLoading = false;
			});
		}

		//Item Action button pressed event
		function doItemAction(action, record) {
			if (action && record) {
                switch (action.id) {
                    case 'view':
                        viewRecord(record);
                        break;
                    case 'edit':
                        vm.model.methods.getDetails(true, record[vm.model.idField], activeCatalogCode, sellerId)
                        .then(function (response) {
                            editRecord(response.data, null);
                        })
                        break;
                    case 'delete':
                    case 'activate':
                        vm.model.methods.activateBulk(record, vm.model, action.id, activeCatalogCode, sellerId, record[vm.model.idField]);
                        break;
                }
			}
		}

        function addRecord(ev) {
            var lookupPromise = {};
            lookupPromise = crud.createLookupPromise(vm.model, undefined , 'create');
            lookupPromise['dataSet'] = api.getLookupData(api.consolidationTemplates.templateFields);
			$mdDialog.show({
                controller         : 'createConsolidationTemplateController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/catalogs/sub-modules/consolidation-templates/dialogs/create-template.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: false,
                locals             : {
                    lookupPromise: lookupPromise,
					model: vm.model,
                    isNew: true,
                    record: null,
                    templateId: -1,
                    sellerId: sellerId,
                    activeCatalogCode: activeCatalogCode,
                    event: ev
                }
            }).then(function(saved) {
                if (saved) {
                    refreshItems(true, false);
                }
            });
		}

        function editRecord(record, ev) {
            var lookupPromise = {};
            lookupPromise = crud.createLookupPromise(vm.model, undefined , 'edit');
			lookupPromise['dataSet'] = api.getLookupData(api.consolidationTemplates.templateFields);
            $mdDialog.show({
                controller         : 'createConsolidationTemplateController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/catalogs/sub-modules/consolidation-templates/dialogs/create-template.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: false,
                locals             : {
                    lookupPromise: lookupPromise,
                    model: vm.model,
                    isNew: false,
                    record: null,
                    templateId : record[vm.model.idField],
                    sellerId: sellerId,
                    activeCatalogCode: activeCatalogCode,
                    event: ev
                }
            }).then(function(saved) {
                if (saved) {
                    refreshItems(true, false);
                }
            });
        }

        function copyTemplates(ev) {
            $mdDialog.show({
                controller         : 'copyTemplates',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/catalogs/sub-modules/consolidation-templates/dialogs/copy-templates/copy-templates.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: false,
                locals: {
                    model: angular.copy(vm.model),
                    sellerId: sellerId,
                    attributeGroupId: activeCatalog.AttributeGroupId,
                    activeCatalogCode: activeCatalogCode,
                    event: ev
                }
            }).then(function (saved) {
                if (saved) {
                    refreshItems(true, false);
                }
            });
        }

        function viewRecord(record) {
            var stateParams = {id: record[vm.model.idField]};
            $state.go('app.consolidation-templates.details', stateParams);
		}

        var catalogChangedEventCleanup = $rootScope.$on('ActiveCatalogChangedEvent', function(e) {
            if(activeCatalogCode !== catalogFactory.getActiveCatalog().CatalogCode) {
                $state.reload('app.consolidation-templates');
            }
        });
        $scope.$on('$destroy', function () {
            catalogChangedEventCleanup();
        });

	}
})();
(function() {
    'use strict';

    angular
        .module('app.main.catalogs.consolidation-templates')
        .controller('createConsolidationTemplateController', createConsolidationTemplateController);

    /* @ngInject */
    function createConsolidationTemplateController(api, $mdDialog, $scope, $filter, $window, hotkeys, toast, utility, $q, lookupPromise, model, isNew,
                                                    record, templateId, sellerId, activeCatalogCode) {
        /* jshint validthis: true */
        var vm = this;



        //Data
        var operatorList = [
            {id: '>',     value: 'Greater  than'},
            {id: '>=',    value: 'Greater  than or Equal',},
            {id: '<',     value: 'Less than'},
            {id: '<=',    value: 'Less than or Equal'},
            {id: '=',     value: 'Equal'},
            {id: '!=',    value: 'Not Equal'},
            {id: 'BETWEEN',  value: 'Between'},
            {id: 'LIKE',  value: 'Like'},
            {id: 'IN',  value: 'In'},
            {id: 'NOT IN',  value: 'Not In'}
        ];

        vm.rowData = { //use to create input rows dynamically
            // fieldIds:[],//not used anymore
            rows: []
        };
        vm.lookupModel = {
            InputFieldId: {},
            FilterOperator: {}
        };
        vm.isNew = isNew;
        var pristineInputFields = {};
        var loadSellerConsolidationPluginsPromise = {};
        var sellerConsolidationPluginList = [];
        vm.inputFields = {}; //lookup data for input fields(criteria)
        vm.outputFields = {}; //lookup data for output fields
        vm.isLoading = false;
        vm.isLoadingData = false;
        vm.record = {};
        vm.outputFieldIds = []; // model for chip data
        vm.searchText = {// lookup search text
            InputFieldId: {},
            FilterOperator: {}
        };

        vm.selectedOutputFields = [];
        vm.acSearchText = ''; // chip search text


        // //Methods
        vm.saveRecord = saveRecord;
        vm.closeDialog = closeDialog;

        vm.inputFieldSearch = inputFieldSearch;
        vm.isOutputFieldRequired = isOutputFieldRequired;

        vm.transformChip = transformChip;
        vm.getChipDisplayValue = getChipDisplayValue;
        vm.acQuerySearch = acQuerySearch;

        vm.onCriteriaLookupChange = onCriteriaLookupChange;
        vm.getCriteriaDisplayValue = getCriteriaDisplayValue;

        vm.filterOperatorSearch = filterOperatorSearch;
        vm.onFilterOperatorChange = onFilterOperatorChange;
        vm.getFilterOperatorDisplayValue = getFilterOperatorDisplayValue;

        vm.consolidationPluginSearch = consolidationPluginSearch;
        vm.lookupChange = lookupChange;
        vm.getLookupDisplayValue = getLookupDisplayValue;

        vm.selectText = selectText;
        // vm.loadChipData = loadChipData;


        activate();

        ////////////////

        function activate() {
            loadTemplateFields();
            if(isNew) {
                createEmptyRow();
            }
            else {
                if(record === null) { //when open edit dialog from list view
                    vm.isLoadingData = true;
                    model.methods.getDetails(false, templateId, activeCatalogCode, sellerId).then(function(response) {
                        vm.record = response.data;
                        populateEditForm();
                    }).finally(function (){
                        vm.isLoadingData = false;
                    });
                }
                else { // when open edit dialog from details view
                    vm.record = angular.copy(record);
                    populateEditForm();
                }
            }
            var promises = {}
            promises['sellerConsolidationPluginsIdsPromise']  = api.accounts.sellers.methods.getDetails(false, sellerId); // get seller consolidation plugins from seller details
            promises['consolidationPluginsPromise'] = lookupPromise['ConsolidationPluginId']; // get all consolidation plugins
            loadSellerConsolidationPluginsPromise = $q.all(promises).then(function (responses) {
                var sellerConsolidationPluginIds = responses['sellerConsolidationPluginsIdsPromise'].data.ConsolidationPluginIds;
                angular.forEach(responses['consolidationPluginsPromise'].data, function(consolidation) {
                    if(sellerConsolidationPluginIds.indexOf(consolidation.id) >= 0) {
                        sellerConsolidationPluginList.push(consolidation);
                    }
                })
            })

            //Hotkeys
            hotkeys.bindTo($scope).add({
                combo: 'ctrl+enter',
                description: $filter('translate')('ACTIONS.SAVE'),
                allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
                callback: function(event) {
                    if (!vm.isLoading && !vm.editForm.$invalid) {
                        vm.saveRecord();
                    }
                }
            });

            hotkeys.bindTo($scope).add({
                combo: 'ctrl+shift+enter',
                description: $filter('translate')('ACTIONS.SAVE_AND_NEW'),
                allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
                callback: function(event) {
                    if (!vm.isLoading && !vm.editForm.$invalid) {
                        vm.saveRecord(true);
                    }
                }
            });
        }

        function saveRecord(saveAndNew) {
            createRequestObject(vm.outputFieldIds, vm.rowData.rows);
            vm.isLoading = true;
            var promise;
            var toastMessage = '';
            if(isNew){
                promise = model.methods.create(vm.record, activeCatalogCode, sellerId);
                toastMessage = 'SUCCESS.CREATE';
            }
            else {
                promise = model.methods.update(templateId, vm.record, activeCatalogCode, sellerId);
                toastMessage = 'SUCCESS.UPDATE';
            }
            promise.then(function() {
                if (angular.isDefined(saveAndNew) && saveAndNew) {
                    clearDialog();
                    var el = $window.document.getElementById('dialog_input_first');
                    if (el) {
                        el.focus();
                    }
                }
                else {
                    closeDialog(true);
                }
                toast.success(toastMessage, '', '');
            }, function() {
                closeDialog(vm.isDataDirty);
            }).finally(function () {
                vm.isLoading = false;
            });
        }

        function closeDialog(saved) {
            $mdDialog.hide(saved);
        }

        function transformChip(chip) {
            if (angular.isObject(chip)) {
                return chip.id;
            }
            return undefined;
        }

        function getChipDisplayValue(chip, lookupData) {
            var res = utility.filterObject(lookupData, {id: chip}, true);
            if (angular.isArray(res) && res.length > 0) {
                return res[0].value;
            }
        }

        function acQuerySearch(query, selectedItems, lookupData, type) {
            var searchQueryResult = [];
            if(angular.isDefined(lookupData.data) && lookupData.data.length) {
                searchQueryResult = angular.copy(utility.filterObject(lookupData.data, query));
            }
            else {
                 return loadTemplateFields(type).then(function(lookupResult) {
                     searchQueryResult = angular.copy(utility.filterObject(lookupResult.data, query));
                 });
            }
            if (angular.isDefined(selectedItems) && selectedItems.length > 0) {
                for (var index = searchQueryResult.length-1; index >= 0; index--) {
                    if (selectedItems.indexOf(searchQueryResult[index].id) !== -1) {
                        searchQueryResult.splice(index,1);
                    }
                }
            }
            return searchQueryResult;
        }

        function inputFieldSearch(query, lookupData, type) {
            var results = [];
            var lookupFilter = {Status: 1};
            var predicate = angular.copy(lookupFilter);
            predicate.value = query;

            if(angular.isDefined(lookupData.data) && lookupData.data.length) {
                results = query ? utility.filterObject(lookupData.data , predicate) : utility.filterObject(lookupData.data, lookupFilter, true);
                return results;
            }
            else {
                return loadTemplateFields(type).then(function(lookupResult) {
                    results = query ? utility.filterObject(lookupResult.data , predicate) : utility.filterObject(lookupResult.data, lookupFilter, true);
                    return results;
                });
            }
        }

        function onCriteriaLookupChange(selectedObj, rowIndex) {
            var isLastRow = (rowIndex === vm.rowData.rows.length - 1);
            if (angular.isObject(selectedObj)) {
                vm.rowData.rows[rowIndex].InputFieldId = selectedObj.id;
                updateListofInputFields();
                //if user selected an input-field for last row and operator is already selected for that field create a new row
                if(isLastRow && angular.isDefined(vm.rowData.rows[rowIndex]['FilterOperator']) && vm.rowData.rows[rowIndex]['FilterOperator'] !== null) {
                    createEmptyRow();
                }
            }
            else if(angular.isUndefined(selectedObj) || selectedObj === null) {
                vm.rowData.rows[rowIndex].InputFieldId = undefined;
                updateListofInputFields();
            }
        }

        function getCriteriaDisplayValue(item) {
            var result;
            // since autocomplete return object
            if(angular.isObject(item)) {
                result = utility.filterObject(pristineInputFields.data, {id: item.id}, true);
            }
            // to initialize filed value if any (when open update record dialog)
            else {
                result = utility.filterObject(pristineInputFields.data, {id: item}, true);
            }

            if (angular.isArray(result) && result.length > 0) {
                return result[0].value;
            }
            else {
                return result.value;
            }
        }

        function filterOperatorSearch(query) {
            var results = [];
            results = query ? utility.filterObject(operatorList , query) : operatorList;
            return results;
        }

        function onFilterOperatorChange(selectedObj, rowIndex) {
            var isLastRow = (rowIndex === vm.rowData.rows.length - 1);
            if(angular.isObject(selectedObj)) {
                vm.rowData.rows[rowIndex].FilterOperator = selectedObj.id;
                //if user selected an operator for last row and input-field is already selected for that operator creat a new row
                if(isLastRow && angular.isDefined(vm.rowData.rows[rowIndex].InputFieldId) && vm.rowData.rows[rowIndex].InputFieldId !== null) {
                    createEmptyRow();
                }
            }
            else if(angular.isUndefined(selectedObj) || selectedObj === null) {
                vm.rowData.rows[rowIndex].FilterOperator = undefined;
            }
        }

        function getFilterOperatorDisplayValue(item) {
            var result;
            // exception check since ! is a special character for filter and there is no escape sequence for that(to avoid negate filter operator)
            if((angular.isObject(item) && item.id === '!=') || item === '!=') {
                return 'Not Equal';
            }
            // since autocomplete return object
            if(angular.isObject(item)) {
                result = utility.filterObject(operatorList, {id: item.id}, true);
            }
            // to initialize filed value if any (when open update record dialog)
            else {
                result = utility.filterObject(operatorList, {id: item}, true);
            }

            if (angular.isArray(result) && result.length > 0) {
                return result[0].value;
            }
            else {
                return result.value;
            }
        }

        function selectText(event) {
            utility.selectInputText(event);
        }


        //helper methods

        // will initialize vm.outputFields, vm.inputFields and pristineInputFields, and since it initialize input and output it takes type so it can resolve either of them when requested in lookupsearch
        function loadTemplateFields(type) {
            var deferred = $q.defer();
            lookupPromise['dataSet'].then(function(lookupData) {
                vm.outputFields = lookupData;
                pristineInputFields.data = utility.filterObject(lookupData.data, {IsInput: 1});
                // update indexArray of dirty lookup if needed
                // utility.updateLookupDataIndexes(pristineInputFieldsCopy);

                vm.inputFields = angular.copy(pristineInputFields);
                if(angular.isDefined(type) && type.toUpperCase() === 'INPUT') {
                    deferred.resolve(vm.inputFields);
                }
                else if(angular.isDefined(type) && type.toUpperCase() === 'OUTPUT') {
                    deferred.resolve(vm.outputFields);
                }
                else {
                    deferred.resolve(lookupData);
                }
            });
            return deferred.promise;
        }

        /**
         * @description :
         * create request object
         * @param {array} outputFieldIds: list of output fields id
         * @param {array} criteriaModels: model containing criteria field-id and corresponding operator {InputFieldId:  inputFieldId, FilterOperator: operator}}
         */
        function createRequestObject(outputFields, criteriaModels) {
            vm.record.templateFieldsRequest = [];
            var templateFieldBody = { FieldId: "", FilterOperator: "", IsInputField: "", IsOutputField: "", SortOrder: "" };

            angular.forEach(outputFields, function (unassignedOutputField) {
                templateFieldBody = { FieldId: unassignedOutputField, FilterOperator: "", IsInputField: 0, IsOutputField: 1, SortOrder: vm.record.templateFieldsRequest.length };
                vm.record.templateFieldsRequest.push(templateFieldBody);
            });

            angular.forEach(criteriaModels, function(criteriaModel) {
                if(angular.isDefined(criteriaModel.InputFieldId) && criteriaModel.InputFieldId !== null) { //since making it undefined when user clear field
                    var outputIndex = outputFields.indexOf(criteriaModel.InputFieldId);
                    if (outputIndex === -1) {
                        templateFieldBody = { FieldId: "", FilterOperator: "", IsInputField: "", IsOutputField: "", SortOrder: "" };

                        templateFieldBody.FieldId = criteriaModel.InputFieldId;
                        templateFieldBody.IsInputField = 1;
                        templateFieldBody.IsOutputField = 0;
                        templateFieldBody.FilterOperator = criteriaModel.FilterOperator;
                        templateFieldBody.SortOrder = vm.record.templateFieldsRequest.length;
                        vm.record.templateFieldsRequest.push(templateFieldBody);
                    } else {
                        vm.record.templateFieldsRequest[outputIndex].IsInputField = 1;
                        vm.record.templateFieldsRequest[outputIndex].FilterOperator = criteriaModel.FilterOperator;
                    }
                }
            });
        }

        function populateEditForm() {
            vm.lookupModel['ConsolidationPluginId'] = vm.record.ConsolidationPluginId;
            // sort by sort order in order to make sure order for output properties maintain in same sequence
            var sortedTemplateFieldList = $filter('orderBy')(vm.record.OrderConsolidationTemplateFieldList, 'SortOrder');
            angular.forEach(sortedTemplateFieldList, function (data) {
                if(data.IsOutPutField === true || data.IsOutPutField === 1) {
                    vm.outputFieldIds.push(data.FieldId);
                }
                if(data.IsInputField === true || data.IsInputField === 1) {
                    // vm.rowData.fieldIds.push(data.FieldId);// not used anymore
                    vm.rowData.rows.push({InputFieldId: data.FieldId, FilterOperator: data.FilterOperator.trim()});
                    vm.lookupModel.InputFieldId[vm.rowData.rows.length-1] = {id: data.FieldId, value: data.ColumnName};
                    vm.lookupModel.FilterOperator[vm.rowData.rows.length-1] = {id: data.FilterOperator.trim(), value: utility.filterObject(operatorList, {id: data.FilterOperator.trim()}, true)};
                }
            });
            createEmptyRow();
        }

        function createEmptyRow() {
            vm.rowData.rows.push({InputFieldId: undefined, FilterOperator: undefined});
        }

        function updateListofInputFields() {
            var pristineInputFieldsCopy = angular.copy(pristineInputFields);
            angular.forEach(vm.rowData.rows, function(field) {
                if(angular.isDefined(field.InputFieldId) && field.InputFieldId !== null) {
                    // remove already assigned fields
                    var inUseField = utility.filterObject(pristineInputFieldsCopy.data, {id: field.InputFieldId}, true)[0];
                    pristineInputFieldsCopy.data.splice(pristineInputFieldsCopy.data.indexOf(inUseField), 1);
                }
            });
            // update indexArray of dirty lookup if needed
            // utility.updateLookupDataIndexes(pristineInputFieldsCopy);
            vm.inputFields = pristineInputFieldsCopy;
        }

        function consolidationPluginSearch(query, fieldName) {
            var field = utility.filterObject(model.fields, { field: fieldName }, true)[0];
            var results = [];
            var lookupFilter = angular.isDefined(field.lookupFilter) ? field.lookupFilter : {};
            var predicate = angular.copy(lookupFilter);
            predicate.value = query;
            var lookupModel = api.getModel(field.lookupSource);

            if (lookupModel && angular.isDefined(lookupModel.lookupData) && angular.isDefined(lookupModel.lookupData.data) && lookupModel.lookupData.data.length && sellerConsolidationPluginList.length) {
                results = query ? utility.filterObject(sellerConsolidationPluginList, predicate) : utility.filterObject(sellerConsolidationPluginList, lookupFilter, true);
            } else {
                return loadSellerConsolidationPluginsPromise.then(function () {
                    return query ? utility.filterObject(sellerConsolidationPluginList, predicate) : utility.filterObject(sellerConsolidationPluginList, lookupFilter, true);
                });
            }
            return results;
        }

        // convert dropdown scope value form object(lookup record) to id property of lookup record
        function lookupChange(selectedObj, fieldName) {
            if(angular.isObject(selectedObj)) {
                vm.record[fieldName] = selectedObj.id;
            }
            else if(angular.isUndefined(selectedObj) || selectedObj === null) {
                vm.record[fieldName] = undefined; // on record removal make field undefined or the property can be deleted using delete keywork
            }
        }

        function getLookupDisplayValue(item, lookupSource) {
            var lookupModel = api.getModel(lookupSource);

            if (lookupModel.lookupData && angular.isDefined(lookupModel.lookupData.data) && lookupModel.lookupData.data.length) {
                return getLookupDisplayVal(item, lookupModel.lookupData);
            }
            else {
                return api.getLookupData(lookupModel).then(function (lookupData) {
                    return getLookupDisplayVal(item, lookupData);
                });
            }
        }

        function getLookupDisplayVal(item, lookupData) {
            var result;
            if (lookupData) {
                // since autocomplete return object
                if (angular.isObject(item)) {
                    result = utility.filterObject(lookupData.data, { id: item.id }, true);
                }
                // to initialize field value if any (when open update record dialog)
                else {
                    result = utility.filterObject(lookupData.data, { id: item }, true);
                }

                if (angular.isArray(result) && result.length > 0) {
                    return result[0].value;
                }
                else {
                    return result.value;
                }
            }
        }

        function clearDialog() {
            vm.editForm.$setPristine();
            vm.editForm.$setUntouched();
            vm.isDataDirty = true;
            vm.record = {};
            vm.rowData.rows = [];
            createEmptyRow();
            vm.outputFieldIds = [];
            vm.searchText = {};
            vm.selectedOutputFields;
            vm.acSearchText = '';
            vm.inputFields = pristineInputFields;
        }

        function isOutputFieldRequired(outputFieldIdsList) {
            if (outputFieldIdsList && outputFieldIdsList.length > 0) {
                return false;
            } else {
                return true;
            }
        }

    }
})();
(function() {
'use strict';

    angular
        .module('app.main.catalogs.consolidation-templates')
        .controller('consolidationTemplatesDetailsController', consolidationTemplatesDetailsController);

    /* @ngInject */
    function consolidationTemplatesDetailsController(api, $state, $stateParams, $rootScope, catalogFactory, $mdDialog, $document, utility, settingsFactory, crud) {
        /* jshint validthis: true */
        var vm = this;

        // Data
        var templateId = $stateParams.id;
        var activeCatalog = catalogFactory.getActiveCatalog();
        var activeCatalogCode = activeCatalog.CatalogCode;
        var sellerId = activeCatalog.AccountId;

        vm.model = api.catalogs.consolidationTemplates;

        vm.criteriaModel = api.consolidationTemplates.criteria;
        settingsFactory.applyPersistedListViewLayout(vm.criteriaModel);

        vm.outputModel = api.consolidationTemplates.output;
        settingsFactory.applyPersistedListViewLayout(vm.outputModel);

        vm.consolidationTemplate = {};
        vm.criteria = [];
        vm.filteredCriteria = [];
        vm.output = [];
        vm.filteredOutput = [];

        vm.isLoading = false;


        // Methods
        vm.refreshRecord = refreshRecord;
        vm.doItemAction = doItemAction;
        vm.editRecord = editRecord;

        activate();

        ////////////////

        function activate() {
            refreshRecord(true);
        }

        function refreshRecord(isLogRequired) {
            vm.isLoading = true;
            vm.model.methods.getDetails(isLogRequired, templateId, activeCatalogCode, sellerId).then(function(response) {
                vm.consolidationTemplate = response.data;
                vm.title = vm.consolidationTemplate[vm.model.lookupDisplayField];

                vm.criteria = utility.filterObject(response.data.OrderConsolidationTemplateFieldList, {IsInputField: true});
                vm.output = utility.filterObject(response.data.OrderConsolidationTemplateFieldList, {IsOutPutField: true});

                //Update Breadcrumb
                $state.current.data.displayName = vm.title;
                $rootScope.$broadcast('breadcrumb-updated');
            })
            .finally(function() {
                vm.isLoading = false;
            });
        }

        function doItemAction(action, record) {
            if (action) {
                switch (action.id) {
                    case 'delete':
                    case 'activate':
                        vm.model.methods.activateBulk(record, vm.model, action.id, activeCatalogCode, sellerId, record[vm.model.idField]);
                        break
                }
            }
        }

        function editRecord(record, ev) {
            var lookupPromise = {};
            lookupPromise = crud.createLookupPromise(vm.model, undefined , 'edit');
			lookupPromise['dataSet'] = api.getLookupData(api.consolidationTemplates.templateFields);
            $mdDialog.show({
                controller         : 'createConsolidationTemplateController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/catalogs/sub-modules/consolidation-templates/dialogs/create-template.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: false,
                locals             : {
                    lookupPromise: lookupPromise,
                    model: vm.model,
                    isNew: false,
                    templateId : templateId,
                    record: vm.consolidationTemplate,
                    sellerId: sellerId,
                    activeCatalogCode: activeCatalogCode,
                    event: ev
                }
            }).then(function(saved) {
                if (saved) {
                    refreshRecord(true, false);
                }
            });
        }

    }
})();
(function() {
    'use strict';

    angular
        .module('app.main.catalogs.change-logs',[])
        .config(config);

    /* @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
        // State
        $stateProvider.state('app.change_logs', {
            url    : '/change-logs',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/catalogs/sub-modules/change-logs/change-logs.html',
                    controller : 'changeLogsController as vm'
                }
            },
            data: {
                displayName: 'CHANGE_LOGS.NAV'
            },
            resolve: {

            },
            //only users with following accessPrivileges in their role access list can access this route
            // accessPrivileges: ['GetCatalogChangeLogList']
            // accessPrivileges: ['nav_change_logs']
            accessInfo: {
                accessPrivileges: ['nav_change_logs']
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/catalogs/sub-modules/change-logs');


        msNavigationServiceProvider.saveItem('catalogs.change-logs', {
            title      : 'Change Logs',
            icon       : 'icon-tile-four',
            state      : 'app.change_logs',
            translate  : 'CHANGE_LOGS.NAV',
            weight     : 12,
            // accessPrivileges: ['GetCatalogChangeLogList']
            // accessPrivileges: ['nav_change_logs']
            accessInfo: {
                accessPrivileges: ['nav_change_logs']
            }
        });
    }
})();
(function() {
    'use strict';

        angular
        .module('app.main.catalogs.change-logs')
        .controller('changesDialogController', changesDialogController);

    /**@ngInject */
    function changesDialogController(api, $mdDialog, $filter, $q, utility, model, record) {
        /* jshint validthis: true */
        var vm = this;

        //data
        vm.model = model;
        vm.record = record;
        vm.record['changeObj'] = angular.fromJson(record['AC']);
        vm.translateVar = {artNumber: ''};
        var lookupData = {};
        //methods

        vm.closeDialog = closeDialog;

        activate();

        ////////////////

        function activate() {
            var articleIdField = utility.filterObject(model.fields, {field: 'AId'})[0];
            loadArticlesLookup().then(function() {
                vm.translateVar['artNumber'] = $filter('recordRenderer')(vm.record['AId'], lookupData, articleIdField);
            });
        }

        function closeDialog() {
           $mdDialog.hide();
        }

        function loadArticlesLookup() {
            var deferred = $q.defer();
            api.getLookupData(api.getModel('catalogs.articles')).then(function(result) {
                lookupData['catalogs.articles'] = result;
                deferred.resolve(lookupData);
            });
            return deferred.promise;
        }
    }
})();
(function () {
	'use strict';

	angular
		.module('app.main.catalogs.models')
		.controller('modelsListController', modelsListController);

	/* @ngInject */
	function modelsListController(api, $rootScope, $scope, $state, catalogFactory, settingsFactory, catalogModelsModel, $document, $mdDialog, crud, utility, dataImporter, SecurityFactory, CONSTANTS, $filter, alertDialog, dialog, bulkUpdater, articlesFactory) {
		/* jshint validthis: true */
		var vm = this;

		//Data
		var activeCatalog = catalogFactory.getActiveCatalog();
		var catalogCode = activeCatalog.CatalogCode;
		var sellerId = activeCatalog.AccountId;
		var attributeGroupId = activeCatalog.AttributeGroupId;

		// check the special privilege is assigned to the user for updating the state. if then does not restrict sizescale and model name update
		var isSpecialPermissionToIgnoreArticleStateIsAssigned = SecurityFactory.isAuthorized({accessPrivileges: CONSTANTS.PRIVILEGES.ARTICLES.SPECIAL_PRIVILEGE_TO_SKIP_STATE_VALIDATION});
		var updateSizeScaleChangeManagementExternalURL = '';
		var updateModelNameChangeManagementExternalURL = '';
		var updateArticleChangeManagementExternalURL = '';

		vm.model = catalogModelsModel;
		settingsFactory.applyPersistedListViewLayout(vm.model);

		vm.catalogModels = [];
		vm.filteredModels = [];
		vm.isLoading = false;


		//Methods
		vm.refreshItems = refreshItems;
		vm.doItemAction = doItemAction;
		vm.doListAction = doListAction;
		vm.viewItem = viewItem;
		vm.addRecord = addRecord;

		activate();

		////////////////

		function activate() {
			refreshItems(api.catalogs.models.isDirty, true);
			api.webGet('/app/app.config.json').then(function(response) {
				if (angular.isDefined(response) && angular.isDefined(response.data)) {
						if(angular.isDefined(response.data['updateSizeScaleChangeManagementExternalURL']) && response.data['updateSizeScaleChangeManagementExternalURL'].length) {
							updateSizeScaleChangeManagementExternalURL = response.data['updateSizeScaleChangeManagementExternalURL'];
						}
						if(angular.isDefined(response.data['updateModelNameChangeManagementExternalURL']) && response.data['updateModelNameChangeManagementExternalURL'].length) {
							updateModelNameChangeManagementExternalURL = response.data['updateModelNameChangeManagementExternalURL'];
						}
						if(angular.isDefined(response.data['updateArticleChangeManagementExternalURL']) && response.data['updateArticleChangeManagementExternalURL'].length) {
							updateArticleChangeManagementExternalURL = response.data['updateArticleChangeManagementExternalURL'];
						}
				}
			});
		}

		function refreshItems(forceFetch, isLogRequired) {
			vm.isLoading = true;
			var generalProperties = {
				forceFetch: forceFetch,
				isLogRequired: isLogRequired,
				config: {},
				supportIncrementalResult: true,
				modelIdField: 'ModelId',
				isMajor: false,
				model: vm.model
			}
			vm.model.methods.getList(generalProperties, vm.model, catalogCode)
			.then(function (response) {
				vm.catalogModels = catalogFactory.transformCatalogModelsResponse(response.data, vm.model.fields);
				if (angular.isDefined(vm.tableControl) && angular.isDefined(vm.tableControl.updateData)) {
					vm.tableControl.updateData();
				}
			}).finally(function () {
				vm.isLoading = false;
			});
		}

		//Item Action button pressed event
		function doItemAction(action, record) {
			if (action && record) {
				switch (action.id) {
					case 'view':
						viewItem(record);
						break;
					case 'edit':
						vm.model.methods.getDetails(true, record.ModelId, catalogCode).then(function (response) {
							editItem(response.data[0], null);
						});
						break;
					// case 'delete':
					// case 'activate':
					// 	vm.model.methods.activateBulk(record, vm.model, action.id, catalogCode);
					// 	break;
					case 'SetSizes':
						// if state is assigned for the modeland size scale is not editable at state level then restrict updating sizescales
						if(!isSpecialPermissionToIgnoreArticleStateIsAssigned && record.ModelStateId != null) {
							var assignedState = utility.filterObject(api.articleStatesList, {StateId: record.ModelStateId}, true)[0];
							if(assignedState && !assignedState.IsSizeScaleEditable) {
								if(assignedState.AllowChangeRequestForSizeScale && updateSizeScaleChangeManagementExternalURL !== '') {
									alertDialog.show('ALERT.NOT_EDITABLE_SIZE_SCALE_AT_ARTICLE_STATE', updateSizeScaleChangeManagementExternalURL);
								} else {
									dialog.showAlertDialog(
										angular.element($document.body),
										$filter('translate')('MESSAGES.TITLE.ALERT'),
										$filter('translate')('SELLER_MODELS.MESSAGES.NOT_EDITABLE_SIZE_SCALE'),
										$filter('translate')('MESSAGES.TITLE.ALERT'),
										$filter('translate')('ACTIONS.DIALOG_CLOSE'),
										true,
										null
									);
								}
							} else {
								setCatalogModelsSizeScale(record, null);
							}
						} else {
							setCatalogModelsSizeScale(record, null);
						}
				}
			}
		}

		function doListAction(action, records) {
			if (action) {
				switch (action.id) {
					// case 'delete':
					// case 'activate':
					// 	vm.model.methods.activateBulk(records, vm.model, action.id, catalogCode);
					// 	break;
					case 'SetSizes':
						var modelCopy = angular.copy(vm.model);
						var sizeScaleField = utility.filterObject(modelCopy.fields, { field: 'SizeScale' }, true)[0];
						sizeScaleField.editable = true;
						var sizeScaleGroupsPromise = api.sellers.sizeScaleGroups.methods.getList(undefined, { forceFetch: true, isLogRequired: false }, sellerId);
						sizeScaleField.validation.dataExistConstraints = { promise: sizeScaleGroupsPromise };

						var masterSizeScaleField = utility.filterObject(modelCopy.fields, { field: 'MasterSizeScale' }, true)[0];
						masterSizeScaleField.editable = true;
						var masterSizeScalesPromise = api.sellers.masterSizeScales.methods.getList(undefined, {forceFetch: true, isLogRequired: true}, sellerId);
						masterSizeScaleField.validation.dataExistConstraints = { promise: masterSizeScalesPromise, model: api.sellers.masterSizeScales };

						// make creatable false to all fields except SizeScaleId
						angular.forEach(modelCopy.fields, function( field) {
							if((field.field !== 'SizeScale' && field.field !== 'MasterSizeScale') && field.editable) {
								field.editable = false;
							}
						});

						var modelNumberField = utility.filterObject(modelCopy.fields, { field: 'ModelNumber' }, true)[0];
						modelNumberField.editable = true;
						modelNumberField.validation.dataExistConstraints = { checkinListData: true };
						//make model number as unique constraint
						modelCopy.uniqueConstraints = [{name: 'Constraint 1', fields: ['ModelNumber']}];
						dataImporter.importExcel(modelCopy, false, {}, action.id, vm.catalogModels).then(function (result) {
								modelCopy.methods.setSizeScaleBulk(vm.model, result.data, sellerId, attributeGroupId, vm.catalogModels, sizeScaleGroupsPromise, masterSizeScalesPromise);
						});
						break;
					case 'updateBulk':
						var isArticleCountWithinLimit = true;
						if(api.articlesLimitForBackgroundJobs > 0 && records.length > api.articlesLimitForBackgroundJobs) {
							isArticleCountWithinLimit = false;
						}
						if(isArticleCountWithinLimit) {
							modelCopy = angular.copy(vm.model);
							modelNumberField = utility.filterObject(modelCopy.fields, {field: 'ModelNumber'}, true)[0];
							modelNumberField.editable = false;

							// we will find out the states with height model state rank as this form will have only model level attributes
							if(!isSpecialPermissionToIgnoreArticleStateIsAssigned) {
								var highestModelStateRankStateId = articlesFactory.getHighestModelStateRankStateId(records);
								if(highestModelStateRankStateId !== 0) {
										var assignedModelState = utility.filterObject(api.articleStatesList, {StateId: highestModelStateRankStateId}, true)[0];
										if(assignedModelState && assignedModelState.NonEditableAttributes.length) {
												angular.forEach(assignedModelState.NonEditableAttributes, function(attribute) {
														var nonEditableModelAttrField = utility.filterObject(modelCopy.fields, {field: attribute.AttributeSystemName, isModelLevelAttribute: true}, true)[0];
														if(angular.isDefined(nonEditableModelAttrField)) {
																nonEditableModelAttrField.editable = false;
																nonEditableModelAttrField.showInEdit = true;
																nonEditableModelAttrField.isBulkEditable = false;
																nonEditableModelAttrField['isAllowChangeRequestEnabled'] = attribute.AllowChangeRequest;
																if(attribute.AllowChangeRequest) {
																		nonEditableModelAttrField['updateArticleChangeManagementExternalURL'] = updateArticleChangeManagementExternalURL;
																}
														}
												});
										}
								}
							}
							var lookupPromises = {};
							lookupPromises = crud.createLookupPromise(modelCopy, undefined , 'edit');
							bulkUpdater.showDialog(modelCopy, vm.catalogModels, {'catalogId': catalogCode}, lookupPromises)
									.then(function(response) {
											if(angular.isDefined(response) && response.toString() != 'false') {
													for(var key in response.propertiesToUpdate) {
															if(response.propertiesToUpdate.hasOwnProperty(key)) {
																	var multiValueAttribute = utility.filterObject(modelCopy.fields, {field: key}, true)[0];
																	if (angular.isDefined(multiValueAttribute) && multiValueAttribute.inputType === 'multi-value') {
																			var multiValue = response.propertiesToUpdate[key];
																			response.propertiesToUpdate[key] = multiValue;
																	}
															}
													}

													vm.model.methods.updateBulk(vm.model, response.selectedRecords, response.propertiesToUpdate, response.idMap);
											}
									});
						}
						else {
							dialog.showAlertDialog(
									angular.element($document.body),
									$filter('translate')('MESSAGES.TITLE.ALERT'),
									$filter('translate')('ARTICLES.MESSAGES.SHOW_ARTICLE_BACKGROUND_JOB_LIMIT_WARNING'),
									$filter('translate')('MESSAGES.TITLE.ALERT'),
									$filter('translate')('ACTIONS.DIALOG_CLOSE'),
									true,
									null
							);
						}
						break;
					case 'updateViaImport':
						var modelCopy = angular.copy(vm.model);
						var modelNumberField = utility.filterObject(modelCopy.fields, {field: 'ModelNumber'}, true)[0];
						modelNumberField.creatable = true;
						var articleNameField = utility.filterObject(modelCopy.fields, {field: 'ModelName'}, true)[0];
						articleNameField.creatable = false;
						var modelIdField = utility.filterObject(modelCopy.fields, {field: 'ModelId', inputType: 'lookup'}, true)[0];
						modelIdField.creatable = false;
						var parentModelTypeField = utility.filterObject(modelCopy.fields, {field: 'parent_model_type'}, true)[0];
						if(parentModelTypeField && parentModelTypeField.creatable) {
								// make ParentModelNumber creatable
								var parentModelNumberField = utility.filterObject(modelCopy.fields, {field: 'ParentModelNumber'}, true)[0];
								if(angular.isDefined(parentModelNumberField)) {
										parentModelNumberField.creatable = true;
								}
						}
						//make all attribute non mandatory for import by model number
						angular.forEach(modelCopy.fields, function(field) {
								if(field.isAttribute && field.creatable) {
										field.validation.isRequiredIfMapped = field.validation.isRequired;
										field.validation.isRequired = false;
								}
								if(field.inputType === 'linkedcatalogarticlenumber' || field.inputType === 'lookup-table') {
										field.creatable = false;
								}
						});

						//make model number as unique constraint
						modelCopy.uniqueConstraints = [{name: 'Constraint 1', fields: ['ModelNumber']}];

						dataImporter.importExcel(modelCopy, true, {isUpdateArticlesByModel : true}, action.id, vm.catalogModels).then(function(result) {
								vm.model.methods.updateViaImport(vm.model, result.data, activeCatalog);
						});
						break;
				}
			}
		}

		function viewItem(item) {
			var stateParams = { id: item.ModelId };
			$state.go('app.catalog-models.details', stateParams);
		}

		function addRecord(ev) {
			var modelCopy = angular.copy(vm.model);
			var lookupPromises = {};
			var lookupExtras = {};
			lookupPromises = crud.createLookupPromise(vm.model, undefined , 'create');
			// if configured model name length then change the allowed max length to the configured value
			var configuredModelNameLength = catalogFactory.getModelNameLength();
			if(configuredModelNameLength !== 100) {
				var modelNameField = utility.filterObject(modelCopy.fields, {field: 'ModelName'}, true)[0];
				modelNameField.validation.maxLen = configuredModelNameLength;
			}
			$mdDialog.show({
				controller         : 'createCatalogModelsController',
				controllerAs       : 'vm',
				templateUrl        : 'app/main/catalogs/sub-modules/catalog-models/dialogs/create-catalog-models/create-catalog-models.html',
				parent             : angular.element($document.body),
				targetEvent        : null,
				clickOutsideToClose: false,
				multiple           : true,
				locals             : {
					editMode : false,
					model : modelCopy,
					record : null,
					parentId: catalogCode,
					existingRecordsForUniqueValue: null,
					lookupExtras: lookupExtras,
					lookupPromises: lookupPromises,
					event: ev
				}
			})
			.then(function(saved) {
				if(saved) {
					refreshItems(true, false);
				}
			});
		}

		function editItem(record, ev) {
			var modelCopy = angular.copy(vm.model);
			// if state is assigned then make non editable attrbutes as non editable
			if(!isSpecialPermissionToIgnoreArticleStateIsAssigned && record.ModelStateId != null) {
				var assignedState = utility.filterObject(api.articleStatesList, {StateId: record.ModelStateId}, true)[0];
				if(assignedState && !assignedState.IsModelNameEditable) {
					var modelNameField = utility.filterObject(modelCopy.fields, {field: 'ModelName'}, true)[0];
					if(angular.isDefined(modelNameField)) {
							modelNameField.editable = false;
							modelNameField['isAllowChangeRequestEnabled'] = assignedState.AllowChangeRequestForModelName;
							if(assignedState.AllowChangeRequestForModelName && updateModelNameChangeManagementExternalURL !== '') {
								modelNameField['updateArticleChangeManagementExternalURL'] = updateModelNameChangeManagementExternalURL;
							}
					}
					// if any non editable attribute set them as readonly
					if(assignedState && assignedState.NonEditableAttributes.length) {
						angular.forEach(assignedState.NonEditableAttributes, function(attribute) {
								var nonEditableAttrField = utility.filterObject(modelCopy.fields, {field: attribute.AttributeSystemName}, true)[0];
								if(angular.isDefined(nonEditableAttrField)) {
										nonEditableAttrField.editable = false;
										nonEditableAttrField.showInEdit = true;
										nonEditableAttrField['isAllowChangeRequestEnabled'] = attribute.AllowChangeRequest;
										if(attribute.AllowChangeRequest) {
												nonEditableAttrField['updateArticleChangeManagementExternalURL'] = updateArticleChangeManagementExternalURL;
										}
								}
						});
					}
				}
			}
			api.showEditRecordDialog(angular.element($document.body), ev, modelCopy, record, catalogCode)
			.then(function(saved) {
					if (saved) {
							refreshItems(true, false);
					}
			});
		}

		function setCatalogModelsSizeScale(record, ev) {
			$mdDialog.show({
				controller         : 'setModelSizeScaleController',
				controllerAs       : 'vm',
				templateUrl        : 'app/main/seller-models/list/dialogs/set-model-size-scales/set-model-size-scales.html',
				parent             : angular.element($document.body),
				targetEvent        : ev,
				clickOutsideToClose: false,
				locals             : {
						sellerId: sellerId,
						attributeGroupId: attributeGroupId,
						model: vm.model,
						record: record,
						currentModel: utility.filterObject(vm.catalogModels, {ModelNumber: record.ModelNumber}, true)[0],
						selectedModel: record,
						event: ev
				}
			});
		}

		var catalogChangedEventCleanup = $rootScope.$on('ActiveCatalogChangedEvent', function (e) {
			if (catalogCode !== catalogFactory.getActiveCatalog().CatalogCode) {
				$state.reload('app.catalog-models');
			}
		});

		$scope.$on('$destroy', function () {
			catalogChangedEventCleanup();
		});

	}
})();
(function () {
	'use strict';

	angular
		.module('app.main.catalogs.models')
		.controller('modelsDetailsController', modelsDetailsController);

	/* @ngInject */
	function modelsDetailsController($rootScope, $state, $stateParams, catalogFactory,
		settingsFactory, SecurityFactory, articlesModel, catalogSpecificArticlesModel, catalogModelsModel, CONSTANTS, api, $document, utility, crud, $mdDialog, $q) {
		/* jshint validthis: true */
		var vm = this;

		// Data
		var modelId = $stateParams.id;
		var activeCatalog = catalogFactory.getActiveCatalog();
		var activeCatalogCode = activeCatalog.CatalogCode;
		var isApplyRetailWindowPrivilegeIsAssigned = SecurityFactory.isAuthorized({accessPrivileges: CONSTANTS.PRIVILEGES.ARTICLES.UPDATE_ARTICLE_SHIPMENT_WINDOW});
		var restrictedRetailWindowOnRole = (angular.isDefined(api.roleBasedRestrictions.restrictedRetailWindow) && !utility.isObjectEmpty(api.roleBasedRestrictions.restrictedRetailWindow)) ? api.roleBasedRestrictions.restrictedRetailWindow : undefined;
		// var isAutomaticNumberingEnabled = catalogFactory.getAutomaticNumbering();
		var sellerId = activeCatalog.AccountId;
		// check the special privilege is assigned to the user for updating the state. if then does not restrict sizescale and model name update
		var isSpecialPermissionToIgnoreArticleStateIsAssigned = SecurityFactory.isAuthorized({accessPrivileges: CONSTANTS.PRIVILEGES.ARTICLES.SPECIAL_PRIVILEGE_TO_SKIP_STATE_VALIDATION});
		var updateModelNameChangeManagementExternalURL = '';

		vm.model = catalogModelsModel;

		vm.catalogModelArticlesModel = angular.copy(articlesModel);
		settingsFactory.applyPersistedListViewLayout(vm.catalogModelArticlesModel);

		vm.catalogArticlesModel = catalogSpecificArticlesModel;

		vm.catalogModelSizesModel = api.catalogs.modelSizes;
		settingsFactory.applyPersistedListViewLayout(vm.catalogModelSizesModel);

		vm.catalogModelResourcesModel = api.catalogs.modelResources;
		settingsFactory.applyPersistedListViewLayout(vm.catalogModelResourcesModel);

		vm.modelDetails = {};
		vm.catalogModelsArticles = [];
		vm.filteredCatalogModelsArticles = [];
		vm.catalogModelSizes = [];
		vm.filteredCatalogModelSizes = [];
		vm.catalogModelResources = [];
		vm.filteredCatalogModelResources = [];

		vm.isLoading = false;
		vm.isModelArticlesLoading = false;
		vm.isCatalogModelSizesLoading = false;
		vm.isModelResourcesLoading = false;

		// Methods
		vm.refreshRecord = refreshRecord;
		vm.refreshCatalogModelArticles = refreshCatalogModelArticles;

		vm.editItem = editItem;
		vm.doArticleItemAction = doArticleItemAction;
		vm.assignArticles = assignArticles;
		vm.addArticle = addArticle;
		vm.doCatalogModelItemAction = doCatalogModelItemAction;
		vm.refreshCatalogModelResources = refreshCatalogModelResources;
		vm.doResourceItemAction = doResourceItemAction;
		vm.doResourceListAction = doResourceListAction;
		vm.assignResources = assignResources;
		vm.viewResource = viewResource;

		activate();

		////////////////

		function activate() {
			refreshRecord(true);
			api.webGet('/app/app.config.json').then(function(response) {
				if (angular.isDefined(response) && angular.isDefined(response.data)) {
						if(angular.isDefined(response.data['updateModelNameChangeManagementExternalURL']) && response.data['updateModelNameChangeManagementExternalURL'].length) {
							updateModelNameChangeManagementExternalURL = response.data['updateModelNameChangeManagementExternalURL'];
						}
				}
			});
		}

		function refreshRecord(isLogRequired) {
			vm.isLoading = true;
			vm.model.methods.getDetails(isLogRequired, modelId, activeCatalogCode)
				.then(function (response) {
					// transform response to show period columns currently the details API returns array
					var results = catalogFactory.transformCatalogModelsResponse(response.data, vm.model.fields);
					vm.modelDetails = results[0];
					// if size scale is assigned create sizes data
					if(vm.modelDetails.SizeScaleId != null) {
						createSizesDataForListView();
					}

					vm.title = angular.copy(vm.modelDetails[vm.model.lookupDisplayField]);
					initializeTabData(isLogRequired);
					//Update Breadcrumb
					$state.current.data.displayName = vm.title;
					$rootScope.$broadcast('breadcrumb-updated');
				})
				.finally(function () {
					vm.isLoading = false;
				});
		}

		function createSizesDataForListView() {
			// seller sizesscales API
			vm.isCatalogModelSizesLoading = true;
			var generalProperties = {
				forceFetch: true,
				isLogRequired: true
			}
			api.sellers.sizeScaleGroups.methods.getList(api.sellers.sizeScaleGroups, generalProperties, sellerId).then(function(response) {
				// do we need to list obsolete and inactive sizes
				var sizeScales = response.data;
				vm.catalogModelSizes = [];
				var assignedSizeScale = utility.filterObject(sizeScales, {Id: vm.modelDetails.SizeScaleId}, true)[0];
				if(assignedSizeScale) {
					var sizes = assignedSizeScale.Sizes.split(',').map(function(size) {
						return size.toString().trim();
					});
					// find the size index of assigned sizes from the SizesMap list
					api.lists.sizeMap.methods.getList(generalProperties).then(function(sizeMapsResponse) {
						var sizeMapsList = sizeMapsResponse.data;
						angular.forEach(sizes, function(size) {
							var sizeMap = utility.filterObject(sizeMapsList, {Size: size}, true)[0];
							if(sizeMap) {
								vm.catalogModelSizes.push(
									{
										SizeName: sizeMap.Size,
										SizeIndex: sizeMap.SizeIndex,
										SortOrder: 0
									}
								);
							} else {
								vm.catalogModelSizes.push(
									{
										SizeName: size,
										SizeIndex: 0,
										SortOrder: 0
									}
								);
							}
						})
						if(angular.isDefined(vm.tableSizesControl) && angular.isDefined(vm.tableSizesControl.updateData)) {
							vm.tableSizesControl.updateData();
						}
					})
				}
			})
			.finally(function () {
				vm.isCatalogModelSizesLoading = false;
			})
		}

		function editItem(record, ev) {
			var modelCopy = angular.copy(vm.model);
			// if configured model name length then change the allowed max length to the configured value
			var configuredModelNameLength = catalogFactory.getModelNameLength();
			if(configuredModelNameLength !== 100) {
				var modelNameField = utility.filterObject(modelCopy.fields, {field: 'ModelName'}, true)[0];
				modelNameField.validation.maxLen = configuredModelNameLength;
			}
			// if state is assigned then make non editable attrbutes as non editable
			if(!isSpecialPermissionToIgnoreArticleStateIsAssigned && record.ModelStateId != null) {
				var assignedState = utility.filterObject(api.articleStatesList, {StateId: record.ModelStateId}, true)[0];
				if(assignedState && !assignedState.IsModelNameEditable) {
					var modelNameField = utility.filterObject(modelCopy.fields, {field: 'ModelName'}, true)[0];
					if(angular.isDefined(modelNameField)) {
							modelNameField.editable = false;
							modelNameField.showInEdit = true;
							modelNameField['isAllowChangeRequestEnabled'] = assignedState.AllowChangeRequestForModelName;
							if(assignedState.AllowChangeRequestForModelName && updateModelNameChangeManagementExternalURL !== '') {
								modelNameField['updateArticleChangeManagementExternalURL'] = updateModelNameChangeManagementExternalURL;
							}
					}
				}
			}
			api.showEditRecordDialog(angular.element($document.body), ev, vm.model, record, activeCatalogCode)
			.then(function(saved) {
					if (saved) {
						refreshRecord(false);
					}
			});
		}

		function refreshCatalogModelArticles(forceFetch, isLogRequired) {
			var generalProperties = {
				forceFetch: forceFetch,
				isLogRequired: isLogRequired
			}
			vm.isModelArticlesLoading = true;
			vm.catalogModelArticlesModel.methods.getList(generalProperties, modelId, activeCatalogCode)
			.then(function(response) {
				vm.catalogModelsArticles = response.data;
			})
			.finally(function() {
				vm.isModelArticlesLoading = false;
			});
		}

		function assignArticles(ev) {
			var modelCopy = angular.copy(vm.catalogModelArticlesModel);
			api.showCreateRecordDialog(angular.element($document.body), ev, modelCopy, parseInt(modelId))
			.then(function(saved) {
					if (saved) {
						refreshCatalogModelArticles(true, false);
					}
			});
		}

		function addArticle(ev) {
			var lookupExtras = {};
			var modelCopy = angular.copy(vm.catalogArticlesModel);
			var modelNumberField = utility.filterObject(modelCopy.fields, {field: 'ModelId'}, true)[0];
			modelNumberField.validation.disabledCriteria = true;
			var modelNameField = utility.filterObject(modelCopy.fields, {field: 'ArticleName'}, true)[0]; // article name is displyed as ModelName
			modelNameField.validation.disabledCriteria = true;
			var modelNumberField = utility.filterObject(modelCopy.fields, {field: 'ModelNumber'}, true)[0];
			modelNumberField.creatable = false;
			// this is to remove the lookup data like users which are part of article fields and are of lookup data. and current articles module does not load users list.
			angular.forEach(modelCopy.fields, function(field) {
				field.visible = false;
			});

			// if configured model name length then change the allowed max length to the configured value
			var configuredModelNameLength = catalogFactory.getModelNameLength();
			if(configuredModelNameLength !== 100) {
					var articleNameField = utility.filterObject(modelCopy.fields, {field: 'ArticleName'}, true)[0];
					articleNameField.validation.maxLen = configuredModelNameLength;
			}

			// make Shipment Range Field creatable when "DummyArticleApplyRetailWindow" privilege is assigned
			if(isApplyRetailWindowPrivilegeIsAssigned && activeCatalog.IsShippingWindowApply == 1) {
					var retailIntroMonthField = utility.filterObject(modelCopy.fields, {field: 'RetailIntroMonthId', inputType: 'lookup'}, true)[0];
					var retailExitMonthField = utility.filterObject(modelCopy.fields, {field: 'RetailExitMonthId', inputType: 'lookup'}, true)[0];
					if(angular.isUndefined(restrictedRetailWindowOnRole)) {
							retailIntroMonthField.creatable = true;
							retailExitMonthField.creatable = true;
					} else if(angular.isDefined(restrictedRetailWindowOnRole) && restrictedRetailWindowOnRole.notEditable) {
							retailIntroMonthField.creatable = false;
							retailExitMonthField.creatable = false;
					}
			}

				var defaultValues = {AllowRetailWindowUpdateOnChild: 1};
				var lookupPromises = {};
				lookupPromises = crud.createLookupPromise(modelCopy, undefined , 'create');
				$mdDialog.show({
						controller         : 'createArticleController',
						controllerAs       : 'vm',
						templateUrl        : 'app/main/catalogs/sub-modules/articles/dialogs/create-article/create-article.html',
						parent             : angular.element($document.body),
						targetEvent        : null,
						clickOutsideToClose: false,
						multiple           : true,
						locals             : {
								event : ev,
								editMode : false,
								model : modelCopy,
								record : vm.modelDetails, // as API doesnot return model level attribute and values set the catalog details as record
								defaultValues : defaultValues,
								parentId: activeCatalogCode,
								additionalInfo: { 'modelArticles': { 'ModelId': vm.modelDetails.ModelId, "ArticleName": vm.modelDetails.ModelName} },
								existingValues: null,
								existingRecordsForUniqueValue: null,
								lookupExtras: lookupExtras,
								filterExpression: {creatable: true},
								lookupPromises: lookupPromises
						}
				})
				.then(function(saved) {
					if(saved) {
						refreshCatalogModelArticles(true, false);
					}
				});
		}

		function doCatalogModelItemAction(action, record) {
			if (action) {
				switch (action.id) {
					// case 'delete':
					// case 'activate':
					// 	vm.model.methods.activateBulk(record, vm.model, action.id, activeCatalogCode);
					// 	break;
				}
			}
		}

		function initializeTabData(isLogRequired) {
			if(SecurityFactory.isAuthorized({accessPrivileges: CONSTANTS.PRIVILEGES.CATLOG_MODELS.DETAIL.CATALOG_MODEL_ARTICLE_LIST})) {
				refreshCatalogModelArticles(vm.catalogModelArticlesModel.isDirty, isLogRequired);
			}
			refreshCatalogModelResources(true, isLogRequired);
		}

		function doArticleItemAction(action, record) {
			if(action && record){
				switch (action.id) {
					case 'view':
						viewArticle(record);
						break;
				}
			}
		}

		function viewArticle(record) {
			var id = record[vm.catalogModelArticlesModel.idField];
			var stateParams = {id: id, tab: 'DETAILS'};
			$state.go('app.articles.details', stateParams);
		}

		function refreshCatalogModelResources(forceFetch, isLogRequired) {
			var generalProperties = {
				forceFetch: forceFetch,
				isLogRequired: isLogRequired
			};
			vm.isModelResourcesLoading = true;
			vm.catalogModelResourcesModel.methods.getList(generalProperties, modelId, activeCatalogCode)
			.then(function(response) {
				vm.catalogModelResources = utility.filterObject(response.data, {Status: 1});
			})
			.finally(function() {
				vm.isModelResourcesLoading = false;
			});
		}

		function doResourceItemAction(action, record) {
			if(action && record) {
				switch (action.id) {
					case 'view':
						viewResource(record);
						break;
					case 'delete':
						if(record.IsSeasonal === false) {
							var sellerAttributeGroupId = activeCatalog.AttributeGroupId;
							api.webPut(api.baseUrl + '/sellers/' + sellerId + '/' + sellerAttributeGroupId + '/models/' + modelId + '/resources/' + record[vm.catalogModelResourcesModel.idField] + '/status', {Status: 0})
							.then(function() { refreshCatalogModelResources(true, false); });
						} else {
							var seasonalResources = vm.catalogModelResources.filter(function(r) { return r.IsSeasonal !== false; });
							vm.catalogModelResourcesModel.methods.activateBulk(record, seasonalResources, vm.catalogModelResourcesModel, 'delete', modelId, activeCatalogCode);
						}
						break;
				}
			}
		}

		function doResourceListAction(action, records) {
			if(action && records) {
				switch (action.id) {
					case 'delete':
						unassignModelResources(records);
						break;
				}
			}
		}

		function unassignModelResources(recordsToRemove) {
			// Split remaining resources by seasonal vs seller
			var seasonalRecordsToRemove = recordsToRemove.filter(function(r) { return r.IsSeasonal !== false; });
			var sellerRecordsToRemove = recordsToRemove.filter(function(r) { return r.IsSeasonal === false; });
			var promises = [];

			// Catalog: send remaining seasonal IDs via existing unassign method
			if(seasonalRecordsToRemove.length > 0) {
				var seasonalResources = vm.catalogModelResources.filter(function(r) { return r.IsSeasonal !== false; });
				promises.push(vm.catalogModelResourcesModel.methods.activateBulk(seasonalRecordsToRemove, seasonalResources, vm.catalogModelResourcesModel, 'delete', modelId, activeCatalogCode));
			}

			// Seller: send remaining seller resource IDs via assignresources
			if(sellerRecordsToRemove.length > 0) {
				var sellerDeleteIds = sellerRecordsToRemove.map(function(r) { return r[vm.catalogModelResourcesModel.idField]; });
				var remainingSellerIds = vm.catalogModelResources
					.filter(function(r) { return r.IsSeasonal === false && r.Status !== 0 && sellerDeleteIds.indexOf(r[vm.catalogModelResourcesModel.idField]) === -1; })
					.map(function(r) { return r[vm.catalogModelResourcesModel.idField]; });
				var sellerAttributeGroupId = activeCatalog.AttributeGroupId;
				promises.push(api.webPut(api.baseUrl + '/sellers/' + sellerId + '/' + sellerAttributeGroupId + '/models/' + modelId + '/assignresources', { ResourceId: remainingSellerIds }));
			}

			$q.all(promises).then(function() {
				refreshCatalogModelResources(true, false);
			});
		}

		function viewResource(record) {
			if(record.Status === 1) {
				var id = record[vm.catalogModelResourcesModel.idField];
				if(record.IsSeasonal === false) {
					$state.go('app.seller-resources.details', {id: id});
				} else {
					$state.go('app.resources.details', {id: id});
				}
			}
		}

		function assignResources(ev) {
			var lookupPromises = {};
			var resourcesModel = api.catalogs.resources;
			// Fetch catalog resources excluding those linked to articles
			lookupPromises['ResourceId'] = api.webGet(api.baseUrl + '/catalogs/' + activeCatalogCode + '/resources?excludeLinked=articles', undefined, true, true)
			.then(function(response) {
				var lookupData = (response.data || []).map(function(item) {
					return { id: item[resourcesModel.idField], value: item[resourcesModel.lookupDisplayField], Status: item.Status, _source: 'catalog' };
				});
				return { data: lookupData };
			});
			// Fetch seller resources
			var sellerAttributeGroupId = activeCatalog.AttributeGroupId;
			lookupPromises['SellerResourceId'] = api.webGet(api.baseUrl + '/sellers/' + sellerId + '/' + sellerAttributeGroupId + '/resources', undefined, true, true)
			.then(function(response) {
				var lookupData = (response.data || []).map(function(item) {
					return { id: item[resourcesModel.idField], value: item[resourcesModel.lookupDisplayField], Status: item.Status, _source: 'seller' };
				});
				return { data: lookupData };
			});
			$mdDialog.show({
				controller         : 'assignCatalogModelResourcesController',
				controllerAs       : 'vm',
				templateUrl        : 'app/main/catalogs/sub-modules/catalog-models/details/catalog-models-resources/dialogs/assign-catalog-model-resources.html',
				parent             : angular.element($document.body),
				targetEvent        : ev,
				clickOutsideToClose: false,
				locals             : {
					model: vm.catalogModelResourcesModel,
					modelId: modelId,
					activeCatalogId: activeCatalogCode,
					sellerId: sellerId,
					sellerAttributeGroupId: sellerAttributeGroupId,
					assignedResources: vm.catalogModelResources,
					lookupPromises: lookupPromises,
					event: ev
				}
			}).then(function(saved) {
				if (saved) {
					refreshCatalogModelResources(true, false);
				}
			});
		}

	}
})();
(function() {
	'use strict';

	angular
		.module('app.main.catalogs.catalog-datasets', [
			'app.main.catalogs.catalog-datasets.values'
		])
		.config(config);

	/* @ngInject */
	function config($stateProvider, $translatePartialLoaderProvider) {

		// Catalog-level Dataset details (own page, does not reuse the seller dataset details page).
		$stateProvider.state('app.catalog_dataset_details', {
			url  : '/catalog/:catalogCode/accountId/:accountId/datasetId/:id',
			params: {dataset : {}},
			views: {
				'content@app': {
					templateUrl: 'app/main/catalogs/sub-modules/catalog-datasets/details/catalog-datasets-details.html',
					controller : 'catalogDatasetsDetailsController as vm'
				}
			},
			data: {
				parentState: 'app.catalogs.details',
				displayName: 'CATALOG_DATASETS.NAV'
			},
			resolve: { // stateParams
				createDatasetValuesModelWithAttributes: function(catalogFactory, $stateParams, api, utility, $q) {
					var dataset = $stateParams.dataset;
					var deferred = $q.defer();
					
					function hideValueActionsForChildCatalog(valuesModel) {
						if (catalogFactory.getActiveCatalog().DataSourceTypeId === 3) {
							var importAction = utility.filterObject(valuesModel.views.mainList.listActions, {id: 'import'}, true)[0];
							if (importAction) { importAction.visible = false; }
							var updateBulkAction = utility.filterObject(valuesModel.views.mainList.listActions, {id: 'updateBulk'}, true)[0];
							if (updateBulkAction) { updateBulkAction.visible = false; }
						}
						return valuesModel;
					}

					if(angular.isDefined(dataset) && !utility.isObjectEmpty(dataset)) {
						catalogFactory.createDatasetValuesModelWithAttributes(dataset, 'catalogs.datasetValues').then(function (resolvedModel) {
							deferred.resolve(hideValueActionsForChildCatalog(resolvedModel));
						});
					} else {
						api.sellers.datasets.methods.getDetails(true, $stateParams.id, $stateParams.accountId)
						.then(function (response) {
							catalogFactory.createDatasetValuesModelWithAttributes(response.data, 'catalogs.datasetValues').then(function (resolvedModel) {
								deferred.resolve(hideValueActionsForChildCatalog(resolvedModel));
							});
						});
					}
					return deferred.promise;
				}
			},
			// Same privilege as the seller dataset details (reads the definition via the same seller API).
			accessInfo: {
				accessPrivileges: ['GetDatasetDefinitionDetails']
			}
		});

		// Translation
		$translatePartialLoaderProvider.addPart('app/main/catalogs/sub-modules/catalog-datasets');
	}
})();

(function() {
	'use strict';

	angular
		.module('app.main.catalogs.catalog-datasets')
		.controller('catalogDatasetsDetailsController', catalogDatasetsDetailsController);

	/* @ngInject */
	function catalogDatasetsDetailsController(api, $state, $stateParams, $rootScope, $scope, crud, settingsFactory, createDatasetValuesModelWithAttributes, dataImporter, bulkUpdater, SecurityFactory, CONSTANTS) {
		 /* jshint validthis: true */
		var vm = this;
		var datasetId = $stateParams.id;
		vm.catalogCode = $stateParams.catalogCode;
		vm.accountId = $stateParams.accountId;

		// Dataset definitions are seller-scoped; reuse the seller definition model for the read-only details view.
		vm.model = angular.copy(api.sellers.datasets);

		vm.valuesModel = createDatasetValuesModelWithAttributes;
		settingsFactory.applyPersistedListViewLayout(vm.valuesModel);

		vm.datasetDefinition = {};

		vm.datasetValues = [];
		vm.filteredDatasetValues = [];

		vm.isLoading = false;
		vm.isValuesLoading = false;

		vm.refreshRecord = refreshRecord;
		vm.refreshValues = refreshValues;

		vm.doValuesListAction = doValuesListAction;
		vm.doValuesItemAction = doValuesItemAction;

		activate();

		////////////////

		function activate() {
			refreshRecord(true);

			// Listen for background job completion to show banner; refresh happens on banner click
			var deregisterJobCompleted = $rootScope.$on('jobCompletedEvent', function() {
				if (api.catalogs.datasetValues.isBulkActionCompleted) {
					vm.valuesModel.isBulkActionCompleted = true;
				}
			});
			$scope.$on('$destroy', deregisterJobCompleted);
		}

		function refreshRecord(isLogRequired) {
			vm.isLoading = true;

			vm.model.methods.getDetails(isLogRequired, datasetId, vm.accountId)
				.then(function (response) {
					// transform data
					vm.datasetDefinition = response.data;
					vm.datasetDefinition['AttributesIds'] = vm.datasetDefinition.Attributes.map(function(attr) {
						return attr.AttributeId;
					})
					vm.title = angular.copy(vm.datasetDefinition[vm.model.lookupDisplayField]);

					initializeTabData(isLogRequired);

					//Update Breadcrumb
					$state.current.data.displayName = vm.title;
					$rootScope.$broadcast('breadcrumb-updated');
				})
				.finally(function () {
					vm.isLoading = false;
				});
		}

		function initializeTabData(isLogRequired) {
			if (SecurityFactory.isAuthorized({accessPrivileges: CONSTANTS.PRIVILEGES.SELLERS.DETAIL.GET_DATASET_VALUES})) {
				refreshValues(vm.valuesModel.isDirty, isLogRequired);
			}
		}

		function refreshValues(forceFetch, isLogRequired) {
			var generalProperties = {
				forceFetch: forceFetch,
				isLogRequired: isLogRequired
			}
			vm.isValuesLoading = true;

			vm.valuesModel.methods.getList(generalProperties, vm.accountId, datasetId, vm.catalogCode)
			.then(function (response) {
				vm.datasetValues = transformDatasetValuesResponse(response.data);
				vm.valuesModel.isBulkActionCompleted = false;
			})
			.finally(function() {
				vm.isValuesLoading = false;
			});
		}

		function doValuesListAction(action, records) {
			if (action) {
				switch (action.id) {
					case 'import':
						dataImporter.importExcel(vm.valuesModel, true).then(function (result) {
							vm.valuesModel.methods.createBulk(vm.valuesModel, result.data, datasetId, vm.catalogCode).then(function() {
								refreshValues(true);
							})
						})
						break;
					case 'updateBulk':
						var modelCopy = angular.copy(vm.valuesModel);
						var lookupPromises = {};
						lookupPromises = crud.createLookupPromise(modelCopy, undefined , 'edit');
						bulkUpdater.showDialog(modelCopy, vm.datasetValues, {'catalogCode': vm.catalogCode, 'datasetId': datasetId}, lookupPromises);
						break;
					case 'delete':
						vm.valuesModel.methods.deleteBulk(records, vm.accountId, datasetId).then(function () {
							refreshValues(true);
						});
						break;
				}
			}
		}

		function doValuesItemAction(action, record) {
			if (action) {
				switch (action.id) {
					case 'delete':
						vm.valuesModel.methods.deleteBulk([record], vm.accountId, datasetId).then(function () {
							refreshValues(true);
						});
						break;
				}
			}
		}

		// transform dataset values to required form
		function transformDatasetValuesResponse(datasetValues) {
			 var transformedResponse = [];
			angular.forEach(datasetValues, function(item) {
					var transformedItem = {
							Id: item.Id,
							DisplayValue: item.DisplayValue,
							// The read side returns active values only, so treat a row as Active (1) unless the
							// API explicitly marks it inactive. Coerced to int 1/0 because the 'status' column
							// renderer uses strict === 1/=== 0, and the delete actions gate on Status === 1
							// (visible:'itm.Status', disabled:'{selected:true, Status:1}'). A missing/null Status
							// must NOT read as 0, or the column shows blank and the delete actions vanish/disable.
							Status: (item.Status === false || item.Status === 0) ? 0 : 1,
							CreatedBy: item.CreatedBy,
							UpdatedBy: item.UpdatedBy,
							CreatedDate: item.CreatedDate,
							UpdatedDate: item.UpdatedDate
					};
					// Parse numeric string values (e.g. "16.0") to numbers for number/decimal fields,
						// as Angular ngModel requires actual numbers for input[type=number]
						angular.forEach(item.Value, function(val, key) {
							var field = vm.valuesModel.fields.filter(function(f) { return f.field === key; })[0];
							if (field && (field.inputType === 'number' || field.inputType === 'decimal') && val !== null && val !== '') {
								transformedItem[key] = parseFloat(val);
							} else {
								transformedItem[key] = val;
							}
						});
					transformedResponse.push(transformedItem);
			});
			return transformedResponse;
		}
	}
})();

(function () {
  'use strict';

  angular
      .module('app.main.catalogs.buyer-limits',[
        'app.main.catalogs.buyer-limits.buyer-customers',
        'app.main.catalogs.buyer-limits.limits-criteria'
      ])
      .config(config);

  /* @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
      // State
      $stateProvider.state('app.buyer_limits', {
          url    : '/buyer-limits',
          views  : {
              'content@app': {
                  templateUrl: 'app/main/catalogs/sub-modules/buyer-limits/list/buyer-limits-list.html',
                  controller : 'buyerLimitsListController as vm'
              }
          },
          data: {
              displayName: 'BUYER_LIMITS.NAV'
          },

        //   accessPrivileges: ['GetBuyerLimits']
        //   accessPrivileges: ['nav_buyer_limits']
          accessInfo: {
            accessPrivileges: ['nav_buyer_limits']
          }
      });

      $stateProvider.state('app.buyer_limits.details', {
        url: '/:id',
        params: {tab :'details'},
        views: {
          'content@app': {
            templateUrl: 'app/main/catalogs/sub-modules/buyer-limits/details/buyer-limits-details.html',
            controller: 'buyerLimitDetailsController as vm'
          }
        },
        data: {
          parentState: 'app.buyer_limits',
          displayName: 'BUYER_LIMITS.NAV'
        },
        //only users with following accessPrivileges in their role access list can access this route
        // accessPrivileges: ['GetBuyerLimitDetails']
        accessInfo: {
          accessPrivileges: ['GetBuyerLimitDetails']
        }
      });

      $stateProvider.state('app.limits_criteria_details', {
        url  : '/buyerLimitId/:buyerLimitId/id/:id',
        params: {},
        views: {
            'content@app': {
                templateUrl: 'app/main/catalogs/sub-modules/buyer-limits/details/tabs/limits-criteria/details/limits-criteria-details.html',
                controller : 'attributeCriteriaDetailsController as vm'
            }
        },
        data: {
            displayName: 'LIMITS_CRITERIA.NAV>'
        },
        resolve: {},
        // accessPrivileges: ['GetBuyerLimitDetails']
        accessInfo: {
            accessPrivileges: ['GetBuyerLimitDetails']
        }
      });


      // Translation
      $translatePartialLoaderProvider.addPart('app/main/catalogs/sub-modules/buyer-limits');

      msNavigationServiceProvider.saveItem('catalogs.buyer-limits', {
          title      : 'Buyer Limits',
          icon       : 'icon-file-delimited',
          state      : 'app.buyer_limits',
          translate  : 'BUYER_LIMITS.NAV',
          weight     : 38,
          // accessPrivileges: ['GetBuyerLimits']
          // accessPrivileges: ['nav_buyer_limits'],
          accessInfo: {
            accessPrivileges: ['nav_buyer_limits']
          }
      });
  }
})();
(function () {
	'use strict';

	angular
		.module('app.main.catalogs.buyer-limits')
		.controller('buyerLimitsListController', buyerLimitsListController);

	/* @ngInject */
	function buyerLimitsListController(api, catalogFactory, settingsFactory, $document, $state, $rootScope, $scope) {
		/* jshint validthis: true */
		var vm = this;

		//Data
		var activeCatalogCode = catalogFactory.getActiveCatalog().CatalogCode;

		vm.model = api.catalogs.buyerLimits;
		settingsFactory.applyPersistedListViewLayout(vm.model);

		vm.buyerLimits = [];
		vm.filteredBuyerLimits = [];
		vm.isLoading = false;

		//Methods
		vm.refreshItems = refreshItems;
		vm.doListAction = doListAction;
		vm.doItemAction = doItemAction;
		vm.addRecord = addRecord;
		vm.viewItem = viewItem;

		activate();

		////////////////

		function activate() {
			refreshItems(vm.model.isDirty, true);
		}

		function refreshItems(forceFetch, isLogRequired) {
			var generalProperties = {
				forceFetch: forceFetch,
				isLogRequired: isLogRequired
			}

			vm.isLoading = true;
			return vm.model.methods.getList(generalProperties, vm.model, activeCatalogCode)
				.then(function (response) {
					vm.buyerLimits = response.data;
				}).finally(function () {
					vm.isLoading = false;
				});
		}

		//Item Action button pressed event
		function doItemAction(action, record) {
			if (action && record) {
				switch (action.id) {
					case 'view':
						viewItem(record);
						break;
					case 'edit':
						vm.model.methods.getDetails(record[vm.model.idField], activeCatalogCode)
						.then(function (response) {
							editItem(response.data, null);
						})
						break;
					case 'delete':
					case 'activate':
						vm.model.methods.activate(record, vm.model, action.id, activeCatalogCode);
						break;
				}
			}
		}

		//List Action button pressed event
		function doListAction(action, records) {
			if (action) {
				switch (action.id) {
					case 'delete':
					case 'activate':
						vm.model.methods.activate(records, vm.model, action.id, activeCatalogCode);
						break;
				}
			}
		}

		function addRecord(ev) {
			var modelCopy = angular.copy(vm.model);
			var existingRecordsForUniqueValue = angular.copy(vm.buyerLimits);
			api.showCreateRecordDialog(angular.element($document.body), ev, modelCopy, activeCatalogCode, undefined, undefined, undefined, undefined, existingRecordsForUniqueValue)
			.then(function(saved) {
				if (saved) {
					refreshItems(true, false);
				}
			});
		}

		function editItem(record, ev) {
			var modelCopy = angular.copy(vm.model);
			var existingRecordsForUniqueValue = angular.copy(vm.buyerLimits);
			for (var i = 0; i < existingRecordsForUniqueValue.length; i++){
				if(existingRecordsForUniqueValue[i].Id === record.Id) {
					existingRecordsForUniqueValue.splice(i, 1);
				}
			}
			api.showEditRecordDialog(angular.element($document.body), ev, modelCopy, record, activeCatalogCode, undefined, undefined, undefined, existingRecordsForUniqueValue)
			.then(function(saved) {
					if (saved) {
							refreshItems(true, false);
					}
			});
		}

		function viewItem(record) {
			var stateParams = { id: record[vm.model.idField] };
			$state.go('app.buyer_limits.details', stateParams);
		}

		var catalogChangedEventCleanup = $rootScope.$on('ActiveCatalogChangedEvent', function(e) {
			if(activeCatalogCode !== catalogFactory.getActiveCatalog().CatalogCode) {
					$state.reload('app.buyer_limits');
			}
		});
		$scope.$on('$destroy', function () {
				catalogChangedEventCleanup();
		})

	}
})();
(function () {
	'use strict';

	angular
		.module('app.main.catalogs.buyer-limits')
		.controller('buyerLimitDetailsController', buyerLimitDetailsController);

	/* @ngInject */
	function buyerLimitDetailsController(api, $state, $stateParams, $rootScope, catalogFactory, settingsFactory, utility, $document, $mdDialog) {
		/* jshint validthis: true */
		var vm = this;

		// Data
		var buyerLimitId = $stateParams.id;
		vm.activeCatalog = catalogFactory.getActiveCatalog();
		var activeCatalogCode = vm.activeCatalog.CatalogCode;

		vm.model = api.catalogs.buyerLimits;

		vm.buyerLimitCustomersModel = api.catalogs.buyerLimitCustomers;
		settingsFactory.applyPersistedListViewLayout(vm.buyerLimitCustomersModel);

		vm.attributeCriteriaModel = api.catalogs.attributeCriteria;
		settingsFactory.applyPersistedListViewLayout(vm.attributeCriteriaModel);

		vm.buyerLimit = {};
		vm.buyerLimitCustomers =[];
		vm.filteredBuyerLimitCustomers = [];
		vm.attributeCriteria = [];
		vm.filteredAttributeCriteria = [];

		vm.isLoading = false;

		// Methods
		vm.refreshRecord = refreshRecord;

		vm.doBuyerLimitsItemAction = doBuyerLimitsItemAction;
		vm.editItem = editItem;

		vm.assignBuyerLimitCustomers = assignBuyerLimitCustomers;

		vm.viewAttributeCriteria = viewAttributeCriteria;
		vm.addAttributeCriteria = addAttributeCriteria;
		vm.doAttributeCriteriaItemAction = doAttributeCriteriaItemAction,
		vm.doAttributeCriteriaListAction = doAttributeCriteriaListAction

		activate();

		////////////////

		function activate() {
			refreshRecord();
		}

		function refreshRecord() {
			vm.isLoading = true;
			vm.model.methods.getDetails(buyerLimitId, activeCatalogCode)
				.then(function (response) {
					vm.buyerLimit = response.data;
					vm.buyerLimitCustomers = vm.buyerLimit.Customers;
					vm.attributeCriteria = vm.buyerLimit.AttributeCriteria;
					vm.title = angular.copy(vm.buyerLimit[vm.model.lookupDisplayField]);

					 //Update Breadcrumb
					 $state.current.data.displayName = vm.title;
					 $rootScope.$broadcast('breadcrumb-updated');
				})
				.finally(function () {
					vm.isLoading = false;
				});
		}

		function doBuyerLimitsItemAction(action, record) {
			if (action) {
				switch (action.id) {
					case 'delete':
					case 'activate':
						vm.model.methods.activate(record, vm.model, action.id, activeCatalogCode);
						break;
				}
			}
		}

		function editItem(record, ev) {
			var modelCopy = angular.copy(vm.model);
			var existingRecordsForUniqueValue = angular.copy(vm.buyerLimits);
			for (var i = 0; i < existingRecordsForUniqueValue.length; i++){
				if(existingRecordsForUniqueValue[i].Id === record.Id) {
					existingRecordsForUniqueValue.splice(i, 1);
				}
			}
			api.showEditRecordDialog(angular.element($document.body), ev, modelCopy, record, activeCatalogCode, undefined, undefined, undefined, existingRecordsForUniqueValue)
			.then(function(saved) {
					if (saved) {
						refreshRecord();
					}
			});
		}

		function assignBuyerLimitCustomers(ev) {
			// add assigned customer id's to CustomerIdList
			var record = {};
			var assignedCustomers = utility.filterObject(vm.buyerLimitCustomers, {'Status': 1}, true);

			record.CustomerIdList = assignedCustomers.map(function(record) {
				return record['CustomerId'];
			});
			api.showEditRecordDialog(angular.element($document.body), ev, vm.buyerLimitCustomersModel, record, buyerLimitId)
			.then(function(saved) {
				if (saved) {
					refreshRecord();
				}
			});
		}

		function doAttributeCriteriaItemAction(action, record) {
			if (action && record) {
				switch (action.id) {
					case 'view':
						viewAttributeCriteria(record);
						break;
					case 'edit':
						editAttributeCriteria(record, null);
						break;
					case 'delete':
					case 'activate':
						vm.attributeCriteriaModel.methods.activateBulk(record, vm.attributeCriteriaModel, action.id, buyerLimitId).then(function () {
							refreshRecord();
						});
						break;
				}
			}
		}

		function viewAttributeCriteria(record) {
			var stateParams = { id: record[vm.attributeCriteriaModel.idField], buyerLimitId: buyerLimitId };
			$state.go('app.limits_criteria_details', stateParams);
		}

		function addAttributeCriteria(ev) {
			$mdDialog.show({
				controller         : 'createAttributeController',
				controllerAs       : 'vm',
				templateUrl        : 'app/main/catalogs/sub-modules/buyer-limits/details/tabs/limits-criteria/dialogs/create-limits-criteria.html',
				parent             : angular.element($document.body),
				targetEvent        : ev,
				clickOutsideToClose: false,
				locals             : {
						isNew: true,
						record: null,
						buyerLimitId : buyerLimitId,
						assignedRecords: angular.copy(vm.attributeCriteria),
						model: vm.attributeCriteriaModel,
						event: ev
				}
			}).then(function(saved) {
					if (saved) {
						refreshRecord();
					}
			});
		}

		function editAttributeCriteria(record, ev) {
			$mdDialog.show({
					controller         : 'createAttributeController',
					controllerAs       : 'vm',
					templateUrl        : 'app/main/catalogs/sub-modules/buyer-limits/details/tabs/limits-criteria/dialogs/create-limits-criteria.html',
					parent             : angular.element($document.body),
					targetEvent        : ev,
					clickOutsideToClose: false,
					locals             : {
							isNew: false,
							record: record,
							buyerLimitId : buyerLimitId,
							assignedRecords: angular.copy(vm.attributeCriteria),
							model: vm.attributeCriteriaModel,
							event: ev
					}
			}).then(function(saved) {
					if (saved) {
						refreshRecord();
					}
			});
		}

		function doAttributeCriteriaListAction(action, records) {
			if (action) {
				switch (action.id) {
					case 'delete':
					case 'activate':
						vm.attributeCriteriaModel.methods.activateBulk(records, vm.attributeCriteriaModel, action.id, buyerLimitId).then(function () {
						  refreshRecord();
						});
						break;
				}
			}
		}

	}
})();
(function () {
	'use strict';

	angular
		.module('app.main.catalogs.buy-windows', [])
		.config(config);

	/* @ngInject */
	function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
		// State
		$stateProvider.state('app.buy_windows', {
			url: '/buy-windows',
			views: {
				'content@app': {
					templateUrl: 'app/main/catalogs/sub-modules/buy-windows/list/buy-windows-list.html',
					controller: 'buyWindowListController as vm'
				}
			},
			data: {
				displayName: 'BUY_WINDOWS.NAV'
			},
			//only users with following accessPrivileges in their role access list can access this route
			// accessPrivileges: ['GetBuyWindowsList']
			// accessPrivileges: ['nav_buy_windows']
			accessInfo: {
				accessPrivileges: ['nav_buy_windows']
			}
		});
		$stateProvider.state('app.buy_windows.details', {
			url: '/:id',
			params: {
				item: undefined
			},
			views: {
				'content@app': {
					templateUrl: 'app/main/catalogs/sub-modules/buy-windows/details/buy-windows-details.html',
					controller: 'buyWindowDetailsController as vm'
				}
			},
			data: {
				parentState: 'app.buy_windows',
				displayName: 'BUY_WINDOWS.TABS.BUY_WINDOW'
			},
			//only users with following accessPrivileges in their role access list can access this route
			// accessPrivileges: ['GetBuyWindowsList']
			accessInfo: {
				accessPrivileges: ['GetBuyWindowsList']
			}
		});

		// Translation
		$translatePartialLoaderProvider.addPart('app/main/catalogs/sub-modules/buy-windows');

		msNavigationServiceProvider.saveItem('orders.buy_windows', {
			title: 'Buy Windows',
			icon: 'icon-view-carousel',
			state: 'app.buy_windows',
			translate: 'BUY_WINDOWS.NAV',
			weight: 123.5,
			// accessPrivileges: ['GetBuyWindowsList']
			// accessPrivileges: ['nav_buy_windows']
			accessInfo: {
				accessPrivileges: ['nav_buy_windows']
			}
		});
	}
})();
(function () {
	'use strict';

	angular
		.module('app.main.catalogs.buy-windows')
		.controller('buyWindowListController', buyWindowListController);

	/* @ngInject */
	function buyWindowListController(api, $rootScope, $scope, $state, catalogFactory, settingsFactory, $document, utility) {
		/* jshint validthis: true */
		var vm = this;

		//Data
		var activeCatalog = catalogFactory.getActiveCatalog();
		var catalogCode = activeCatalog.CatalogCode;

		vm.model = api.catalogs.buyWindows;
		settingsFactory.applyPersistedListViewLayout(vm.model);

		vm.buyWindows = [];
		vm.filteredBuyWindows = [];
		vm.isLoading = false;


		//Methods
		vm.refreshItems = refreshItems;
		vm.doItemAction = doItemAction;
		vm.doListAction = doListAction;
		vm.addRecord = addRecord;
		vm.viewItem = viewItem;

		activate();

		////////////////

		function activate() {
			refreshItems(vm.model.isDirty, true);
		}

		function refreshItems(forceFetch, isLogRequired) {
			vm.isLoading = true;
			var generalProperties = {
				forceFetch: forceFetch,
				isLogRequired: isLogRequired
			}
			vm.model.methods.getList(generalProperties, catalogCode)
				.then(function (response) {
					vm.buyWindows = response.data;
					// disable delete button if inactive records length is equal to vm.buyWindows.length-1
					var numberOfInactiveBuyWindows = utility.filterObject(vm.buyWindows, { Status: 0 }, true).length;
					if(numberOfInactiveBuyWindows === (vm.buyWindows.length - 1)) {
						var activeBuyWindows = utility.filterObject(vm.buyWindows, { Status: 1 }, true)[0];
						activeBuyWindows._disabled = true;
					}
				})
				.finally(function () {
					vm.isLoading = false;
				});
		}

		//Item Action button pressed event
		function doItemAction(action, record) {
			if (action && record) {
				switch (action.id) {
					case 'activate':
					case 'delete':
								vm.model.methods.activateBulk(record, vm.model, action.id, catalogCode)
								.then(function() {
									refreshItems(true);
								});
								break;
					case 'edit':
								editRecord(record, null);
								break;
					case 'view':
								viewItem(record);
								break;
				}
			}
		}

		//List Action button pressed event
		function doListAction(action, records) {
			if (action) {
				switch (action.id) {
					case 'activate':
					case 'delete':
								vm.model.methods.activateBulk(records, vm.model, action.id, catalogCode).then(function() {
									refreshItems(true);
								});
								break;
				}
			}
		}

		function addRecord(ev) {
			var modelCopy = angular.copy(vm.model);
			var existingRecordsForUniqueValue = angular.copy(vm.buyWindows);
			api.showCreateRecordDialog(angular.element($document.body), ev, modelCopy, catalogCode, undefined, undefined, undefined, undefined, existingRecordsForUniqueValue)
			.then(function(saved) {
				if (saved) {
					refreshItems(true, false);
				}
			});
		}

		function editRecord(record, ev) {
			var modelCopy = angular.copy(vm.model);
			var existingRecordsForUniqueValue = angular.copy(vm.buyWindows);
			for (var i = 0; i < existingRecordsForUniqueValue.length; i++){
				if(existingRecordsForUniqueValue[i].Id === record.Id) {
					existingRecordsForUniqueValue.splice(i, 1);
				}
			}
			api.showEditRecordDialog(angular.element($document.body), ev, modelCopy, record, catalogCode, undefined, undefined, undefined, existingRecordsForUniqueValue)
			.then(function(saved) {
					if (saved) {
							refreshItems(true, false);
					}
			});
		}

		function viewItem(record) {
			if(record.Status === 1) {
				var stateParams = { id: record[vm.model.idField], item: record };
				$state.go('app.buy_windows.details', stateParams);
			}
		}

		var catalogChangedEventCleanup = $rootScope.$on('ActiveCatalogChangedEvent', function (e) {
			if (catalogCode !== catalogFactory.getActiveCatalog().CatalogCode) {
				$state.reload('app.buy_windows');
			}
		});

		$scope.$on('$destroy', function () {
			catalogChangedEventCleanup();
		});

	}
})();
(function () {
	'use strict';

	angular
		.module('app.main.catalogs.buy-windows')
		.controller('buyWindowDetailsController', buyWindowDetailsController);

	/* @ngInject */
	function buyWindowDetailsController(api, $state, $stateParams, $rootScope, catalogFactory, utility) {
		/* jshint validthis: true */
		var vm = this;

		// Data
		var buyWindowId = $stateParams.id;
		var buyWindow = $stateParams.item;
		var activeCatalog = catalogFactory.getActiveCatalog();
		var catalogCode = activeCatalog.CatalogCode;

		vm.model = angular.copy(api.catalogs.buyWindows);

		vm.isLoading = false;


		// Methods
		vm.refreshRecord = refreshRecord;
		vm.doItemAction = doItemAction;

		activate();

		////////////////

		function activate() {
			refreshRecord(true);
		}


		function refreshRecord(isLogRequired) {
			if(angular.isDefined(buyWindow)) {
					vm.buyWindow = buyWindow;
					vm.title = vm.buyWindow[vm.model.lookupDisplayField];
					//Update Breadcrumb
					$state.current.data.displayName = vm.title;
					$rootScope.$broadcast('breadcrumb-updated');
			} else {
				vm.isLoading = true;
				vm.model.methods.getList({ forceFetch: false, isLogRequired: isLogRequired }, catalogCode).then(function (response) {
					var buyWindows = response.data;
					vm.buyWindow = utility.filterObject(buyWindows, {Id: parseInt(buyWindowId)}, true)[0];
					vm.title = vm.buyWindow[vm.model.lookupDisplayField];
					//Update Breadcrumb
					$state.current.data.displayName = vm.title;
					$rootScope.$broadcast('breadcrumb-updated');
				})
				.finally(function () {
					vm.isLoading = false;
				});
			}
		}

		function doItemAction(action, record) {
			if (action) {
				switch (action.id) {
					case 'delete':
					case 'activate':
						vm.model.methods.activateBulk(record, vm.model, action.id, catalogCode);
						break;
				}
			}
		}

	}
})();
(function() {
    'use strict';

  angular
    .module('app.main.catalogs.assortments')
    .controller('assortmentsListController', assortmentsListController);

  /* @ngInject */
  function assortmentsListController(api, $rootScope, $scope, $state, $document, catalogFactory, toast, $q, utility, SecurityFactory, $mdDialog, dataImporter,
    settingsFactory, $timeout, assortmentsModel) {
    /* jshint validthis: true */
    var vm = this;

        //Data
        var activeCatalog = catalogFactory.getActiveCatalog();
        var activeCatalogCode = activeCatalog.CatalogCode;
        var catalogCollectionType = activeCatalog.CollectionsType;
        var duneContext = activeCatalog.DuneContext;
        var assignedContextKey = catalogFactory.getCatalogContextKey();
        var imageSetMap = {};

        var foldersList = []; // Flat list of folders
        var catalogAssortmentsList = []; //flat lis of assortments
        var flatFoldersWithAssortments = []; //list of flat folders with assortments

        vm.model = assortmentsModel;
        vm.folderModel = api.catalogs.folders;
        vm.folders = [];
        vm.importTabularFields = [];
        //vm.filteredNodes = [];
        vm.isLoading = false;
        vm.tabularArticlesModel = api.catalogs.assortmentsWithArticles;
        settingsFactory.applyPersistedListViewLayout(vm.tabularArticlesModel);

        vm.tabularCustomersModel = api.catalogs.assortmentsCustomers;
        settingsFactory.applyPersistedListViewLayout(vm.tabularCustomersModel);

        vm.tabularArticlesData = [];
        vm.filteredTabularArticlesData = [];
        vm.isLoadingTabularArticlesData = false;

        vm.tabularCustomersData = [];
        vm.filteredTabularCustomersData = [];
        vm.isLoadingTabularCustomersData = false;
        vm.currentCollectionView = 1;//Default view is Article List View
        vm.supportTableView = false;

        //Methods
        // vm.doFolderItemAction = doFolderItemAction;
        vm.addFolder = addFolder;
        // vm.toggle = toggle;
        // vm.doAssortmentItemAction = doAssortmentItemAction;
        // vm.addAssortment = addAssortment;
        vm.cols = [];
        vm.treeOptions = {
            dropped : dropped,
            beforeDrag: beforeDrag,
            beforeDrop: beforeDrop
        }
        vm.doRefresh = refreshItems;
        vm.refreshTabularArticlesData = refreshTabularArticlesData;
        vm.doListAction = doListAction;
        vm.doItemAction = doItemAction;
        // vm.doItemClick = doItemClick;
        vm.onTreeNodeClick = onTreeNodeClick;
        vm.refreshTabularCustomersData = refreshTabularCustomersData;
        vm.doSwitchCollectionsView = doSwitchCollectionsView;
        vm.doArticlesListAction = doArticlesListAction;
        vm.doArticlesItemAction = doArticlesItemAction;
        vm.doCustomersItemAction = doCustomersItemAction;
        vm.doCustomersListAction = doCustomersListAction

    activate(true);

    ////////////////


        function activate(isLogRequired) {
            //Set the branch types
            vm.branchTypes = {
                folder      : {
                    icon    : api.catalogs.folders.icon,
                    title   : api.catalogs.folders.title,
                    actions : api.catalogs.folders.views.mainList.itemActions,
                    model   : vm.folderModel
                },
                assortment  : {
                    icon    : api.catalogs.assortments.icon,
                    title   : api.catalogs.assortments.title,
                    actions : vm.model.views.mainList.itemActions,
                    model   : vm.model
                }
            };

            vm.filter = "";
            vm.showFilterRow = false;

            vm.treeViewOptions = {
                customersListView : true,
                articleListVIew : true
            }
            refreshTabularArticlesData(isLogRequired);
            //refreshItems(isLogRequired);
        }

        function doListAction(action) {
            if (action) {
                switch (action.id) {
                    case 'import':
                        var importAssortmentModel = angular.copy(api.catalogs.importAssortments);
                        if(catalogCollectionType === 2) {
                            var articleNumberField = utility.filterObject(importAssortmentModel.fields, {field: 'ArticleNumber'}, true)[0];
                            articleNumberField.creatable = false;
                            importAssortmentModel.uniqueConstraints = [{ name: 'Constraint 1', fields: ['Name', 'Path'] }];
                        }

                        dataImporter.importExcel(importAssortmentModel, true).then(function(result) {
                            vm.model.methods.createBulk(vm.model, result.data, activeCatalogCode);
                        });
                        break;
                    case 'importCustomers':
                        var importCustomersModel = api.catalogs.assortmentsCustomers;
                        dataImporter.importExcel(importCustomersModel, true).then(function(result) {
                            vm.model.methods.createCustomersBulk(vm.model, result.data, activeCatalogCode);
                        });
                        break;
                    case 'importTabular':
                        var modelCopy = angular.copy(api.catalogs.importAssortmentsTabular);
                        modelCopy.fields = modelCopy.fields.concat(vm.importTabularFields);
                        var customerNumberField = utility.filterObject(modelCopy.fields, {field: 'CustomerNumber'}, true)[0];
                        customerNumberField.creatable = false;

                        dataImporter.importExcel(modelCopy, true).then(function(result) {
                            vm.model.methods.createBulkTabular(vm.model, result.data, activeCatalogCode);
                        });
                        break;
                    case 'importCustomersTabular':
                        var modelCopy = angular.copy(api.catalogs.importAssortmentsTabular);
                        modelCopy.fields = modelCopy.fields.concat(vm.importTabularFields);
                        var articleNumberField = utility.filterObject(modelCopy.fields, {field: 'ArticleNumber'}, true)[0];
                        articleNumberField.creatable = false;
                        modelCopy.uniqueConstraints = [{ name: 'Constraint 1', fields: ['CustomerNumber'] }];
                        dataImporter.importExcel(modelCopy, true).then(function(result) {
                            vm.model.methods.createCustomersBulkTabular(vm.model, result.data, activeCatalogCode);
                        });
                        break;
                }
            }
        }

        function doItemAction(action, node) {
            if(node.type.toUpperCase() === 'FOLDER') {
                doFolderItemAction(action, node);
            }
            else if(node.type.toUpperCase() === 'ASSORTMENT') {
                doAssortmentItemAction(action, node);
            }
        }

          //Item Action button pressed event
        function doArticlesItemAction(action, record) {
            if (action && record) {
                switch (action.id) {
                    case 'delete':
                    case 'activate':
                        vm.tabularArticlesModel.methods.activate(record, vm.tabularArticlesModel, action.id, activeCatalogCode);
                        break;
                }
            }
        }

        //List Action button pressed event
        function doArticlesListAction(action, records) {
            if (action) {
                switch (action.id) {
                    case 'delete':
                    case 'activate':
                        vm.tabularArticlesModel.methods.activate(records, vm.tabularArticlesModel, action.id, activeCatalogCode);
                    break;
                }
            }
        }

          // Customers Item Action button pressed event
          function doCustomersItemAction(action, record) {
            if (action && record) {
                switch (action.id) {
                    case 'delete':
                    case 'activate':
                        vm.tabularCustomersModel.methods.activate(record, vm.tabularArticlesModel, action.id, activeCatalogCode);
                        break;
                }
            }
        }

        // Customers List Action button pressed event
        function doCustomersListAction(action, records) {
            if (action) {
                switch (action.id) {
                    case 'delete':
                    case 'activate':
                        vm.tabularCustomersModel.methods.activate(records, vm.tabularArticlesModel, action.id, activeCatalogCode);
                        break;
                }
            }
        }

        // function doItemClick(item) {
        //     //Need to confirme what is this
        // }

        function onTreeNodeClick(node) {
            viewAssortment(node);
        }

    function refreshItems(isLogRequired) {
            vm.isLoading = true;
            loadAssortmentsAndFolders(isLogRequired).then(function() {
                //Set the title property for all assortments
                angular.forEach(catalogAssortmentsList, function(item) {
                    item.title = item.Name;
                    item.type = 'assortment';
                });
                //Set the title property for all folders
                angular.forEach(foldersList, function(item) {
                    item.title = item.Name;
                    item.type = 'folder';
                });

                //Add assortment to their respective folders
                flatFoldersWithAssortments = catalogFactory.assignAssortmentsToFolder(angular.copy(catalogAssortmentsList), angular.copy(foldersList));
                var flatFoldersWithAssortmentsCopy =  angular.copy(flatFoldersWithAssortments);
                //to push parent folder at the begining of the list
                flatFoldersWithAssortmentsCopy = utility.orderBy(flatFoldersWithAssortmentsCopy, 'ParentFolderId', false);
                //Transform folders to desired structure for ui.tree
                vm.folders = catalogFactory.transformFolders(flatFoldersWithAssortmentsCopy, flatFoldersWithAssortmentsCopy);

                vm.importTabularFields = catalogFactory.generateImportTabularFields(vm.folders);
                //Add ancestorDisabledStatus to assortments
                catalogFactory.addAncestorDisabledStatusToAssortment(vm.folders, -1);

                //sorting all the root folders based on their sort orders to be dispalyed based on their sortOrder
                vm.folders = utility.orderBy(vm.folders, 'SortOrder', false);
            })
            .finally(function() {
                vm.isLoading = false;
            });
        }

        function refreshTabularArticlesData(isLogRequired) {
            if(catalogCollectionType !== 2) {
                vm.isLoadingTabularArticlesData = true;
                vm.tabularArticlesModel.methods.getList({ forceFetch: true, isLogRequired: isLogRequired }, activeCatalogCode)
                .then(function(response) {
                    vm.tabularArticlesData = response.data;
                })
                .finally(function() {
                    vm.isLoadingTabularArticlesData = false;
                });
            }
        }

        //CHANGE WHEN API IS READY
        function refreshTabularCustomersData(isLogRequired) {
            vm.isLoadingTabularCustomersData = true;

            vm.tabularCustomersModel.methods.getList({ forceFetch: true, isLogRequired: isLogRequired }, activeCatalogCode)
            .then(function(response) {
                vm.tabularCustomersData = response.data;
            })
            .finally(function() {
                vm.isLoadingTabularCustomersData = false;
            });
        }

    function doSwitchCollectionsView(id) {
        switch(id) {
            case 0: //tree view
                refreshItems(true);
                vm.currentCollectionView = 0;
                break;
            case 1: //articles list view
                if(catalogCollectionType !== 2) {
                    refreshTabularArticlesData(true);
                }
                vm.supportTableView = true;
                vm.currentCollectionView = 1;
                break;
            case 2: //customers list view
                refreshTabularCustomersData(true);
                vm.supportTableView = true;
                vm.currentCollectionView = 2;
                break;
        }
    }

    function doFolderItemAction(action, node) {
      if (action && node) {
                switch (action.id) {
                    case 'addFolder':
                        addFolder(null, node.nodes.length, node.Id);
                        break;
                    case 'addAssortment':
                        addAssortment(null, node.nodes.length, node.Id);
                        break;
                    case 'edit':
                        editFolder(null, node);
                        break;
                    case 'delete':
                    case 'activate':
                        vm.folderModel.methods.activateBulk(node, vm.folderModel, action.id, activeCatalogCode).then(function() {
                            activate();
                        });
                        break;
                }
      }
    }

        function addFolder(ev, index, parentFolderId) {
            api.showCreateRecordDialog(angular.element($document.body), ev, vm.folderModel, activeCatalogCode,
             {'ParentFolderId': angular.isDefined(parentFolderId) ? parentFolderId : 0, SortOrder: index}).then(function(saved) {
                if (saved) {
                    vm.folderModel.isDirty = true;//TODO- can be removed
                    refreshItems(true);
                    activate();
                }
            });
        }

        function editFolder(ev, record) {
            api.showEditRecordDialog(angular.element($document.body), ev, vm.folderModel, record, activeCatalogCode)
            .then(function(saved) {
                if (saved) {
                    vm.folderModel.isDirty = true;//TODO- can be removed
                    activate();
                }
            });
    }

        // function toggle(scope) {
        //     // scope.toggle();
        // }

        function doAssortmentItemAction(action, node) {
            if (action && node) {
                switch (action.id) {
                    case 'view':
                       viewAssortment(node);
                        break;
                    case 'edit':
                        editAssortment(null, node);
                        break;
                    case 'setArticles':
                        setArticles(null, node);
                        break;
                    case 'setCustomers':
                        setCustomers(null, node);
                        break;
                    case 'setUsers':
                        setUsers(null, node);
                        break;
                    case 'delete':
                    case 'activate':
                        vm.model.methods.activateBulk(node, vm.model, action.id, activeCatalogCode);
                        break;
                }
      }
        }

        function addAssortment(ev, index, folderId) {
            if(catalogCollectionType !== 2) {
                api.showCreateRecordDialog(angular.element($document.body), ev, vm.model, activeCatalogCode,
                {'FolderId': angular.isDefined(folderId) ? folderId : 0, SortOrder: index}).then(function(saved) {
                    if (saved) {
                        vm.model.isDirty = true;
                        refreshItems(true);
                        activate();
                    }
                });
            } else {
                $mdDialog.show({
                    controller         : 'createCriteriaCollectionController',
                    controllerAs       : 'vm',
                    templateUrl        : 'app/main/catalogs/sub-modules/assortments/list/dialogs/create-criteria-collection/create-criteria-collection.html',
                    parent             : angular.element($document.body),
                    targetEvent        : ev,
                    clickOutsideToClose: false,
                    locals             : {
                        model: vm.model,
                        record: null,
                        isNew: true,
                        contextKey: assignedContextKey,
                        duneContext: duneContext,
                        imageSetMap: imageSetMap,
                        folderId   : angular.isDefined(folderId) ? folderId : 0,
                        sortOrder  : index,
                        event: ev
                    }
                }).then(function(saved) {
                    if (saved) {
                        refreshItems(true);
                        activate();
                    }
                });
            }
        }

        function createImageSetMap(assortments) {
            angular.forEach(assortments, function(assortments) {
                if(assortments.DunesImageSet !== '') {
                    imageSetMap[assortments.DunesImageSet] = 1;
                }
            })
            return imageSetMap;
        }

        function editAssortment(ev, record) {
            if(catalogCollectionType !== 2) {
                api.showEditRecordDialog(angular.element($document.body), ev, vm.model, record, activeCatalogCode)
                .then(function(saved) {
                    if (saved) {
                        vm.model.isDirty = true;
                        refreshItems(true);
                        activate();
                    }
                });
            } else {
                $mdDialog.show({
                    controller         : 'createCriteriaCollectionController',
                    controllerAs       : 'vm',
                    templateUrl        : 'app/main/catalogs/sub-modules/assortments/list/dialogs/create-criteria-collection/create-criteria-collection.html',
                    parent             : angular.element($document.body),
                    targetEvent        : ev,
                    clickOutsideToClose: false,
                    locals             : {
                        model: vm.model,
                        record: record,
                        isNew: false,
                        contextKey: assignedContextKey,
                        duneContext: duneContext,
                        imageSetMap: imageSetMap,
                        folderId   : record.FolderId,
                        sortOrder  : record.SortOrder,
                        event: ev
                    }
                }).then(function(saved) {
                    if (saved) {
                        refreshItems(true);
                        activate();
                    }
                });
            }
        }

        function setArticles(ev, record) {
            $mdDialog.show({
                controller         : 'setAssortmentArticleController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/catalogs/sub-modules/assortments/list/dialogs/set-articles/set-articles.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: false,
                locals             : {
                    activeCatalogId : activeCatalogCode,
                    assortmentId : record[vm.model.idField],
                    model: api.assortments.articles,
                    event: ev
                }
            });
        }

        function setCustomers(ev, record) {
            $mdDialog.show({
                controller         : 'setAssortmentCustomersController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/catalogs/sub-modules/assortments/list/dialogs/set-customers/set-customers.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: false,
                locals             : {
                    activeCatalogId : activeCatalogCode,
                    assortmentId : record[vm.model.idField],
                    model: api.assortments.customers,
                    event: ev
                }
            });
        }

        function viewAssortment(record) {
            var id = record[vm.model.idField];
            var stateParams = {id:id, imageSetMap: imageSetMap};
            $state.go('app.assortments.details', stateParams);
        }

    function dropped(event) {
            var record = event.source.nodeScope.$modelValue,
                position = event.dest.index,
                parentFolderId = event.dest.nodesScope.$parent.$modelValue ? event.dest.nodesScope.$parent.$modelValue.Id : 0;
            $timeout(function () {
                //if same parent
                if(event.dest.nodesScope.isParent(event.source.nodeScope)) {
                    updateSortOrders(record, event.source.nodesScope.$modelValue, event.source.nodesScope.$nodeScope, position).then(function() {
                        vm.model.isDirty = true;
                        vm.folderModel.isDirty = true;
                        activate(); //for better UX can be comment, only need to prevent assortment to be dragged on root
                    });
                }
                //if change it's root
                else {
                    updateSortOrders(record, event.dest.nodesScope.$modelValue, event.dest.nodesScope.$nodeScope, position).then(function() {
                        vm.model.isDirty = true;
                        vm.folderModel.isDirty = true;
                        activate(); //for better UX can be comment, only need to prevent assortment to be dragged on root
                    });
                }
            });
        }

        //destinationRecords will be ordered the way it should be after drop
        function updateSortOrders(sourceRecordsRoot, destinationRecords, parentRecord, toIndex) {
            var isFoldersLoaded = false;
            var isCatalogAssortmentsLoaded = false;
            var deferred = $q.defer();
            var folders = [];
            var assortments = [];
            var isAssortmentExists = false;

            //Update sourceRecordsRoot parentFolderId
            //if not moved to root
            if(angular.isDefined(parentRecord) && parentRecord !== null) {
                if(angular.isDefined(sourceRecordsRoot.nodes)) {// if folder
                    sourceRecordsRoot.ParentFolderId = parentRecord.$modelValue.Id;
                }
                else {// if assortment
                    sourceRecordsRoot.FolderId = parentRecord.$modelValue.Id;
                }
            }//if moved to root
            else {
                sourceRecordsRoot.ParentFolderId = 0;
            }

            angular.forEach(destinationRecords, function(record) {
                if(record.Name.toLowerCase() === sourceRecordsRoot.Name.toLowerCase()) {
                    isAssortmentExists = true;
                }
            })

            if(!isAssortmentExists) {
                assortments.push(sourceRecordsRoot);
            }

            for(var index = 0, len = destinationRecords.length; index < len; index++) {
                //Since destinationRecords is orderd the way it should be after drop, sortOrder of each record will be their index in array
                destinationRecords[index].SortOrder = index;
                //if record is folder
                if(angular.isDefined(destinationRecords[index].nodes)) {
                    folders.push(destinationRecords[index]);
                }
                //if record is assortment
                else {
                    assortments.push(destinationRecords[index]);
                }
            }
            //Update folders sortOrder
            if(folders.length > 0) {
                vm.folderModel.methods.updateBulk(folders, activeCatalogCode).then(function() {
                    isFoldersLoaded = true;
                    if(isCatalogAssortmentsLoaded || assortments.length == 0) {
                        deferred.resolve();
                    }
                });
            }

            //Update Assortment sortOrder
            if(assortments.length > 0) {
                vm.model.methods.updateBulk(assortments, activeCatalogCode).then(function() {
                    isCatalogAssortmentsLoaded = true;
                    if(isFoldersLoaded || folders.length == 0) {
                        deferred.resolve();
                    }
                });
            }
            return deferred.promise;
        }

        //To check if source is draggable (active)
        function beforeDrag(sourceNodeScope) {
            var isAuthorizedToReOrder = SecurityFactory.isAuthorized({accessPrivileges: ['UpdateAssortmentDefinationBulk', 'UpdateAssortmentFolderBulk']});
            if(isAuthorizedToReOrder) {
                //if authorized recursively check status of nodes right upto the root if any disabled
                return utility.checkRecordOrParentsPropertyValueRecursively(sourceNodeScope, '$parentNodeScope', '$modelValue.Status', 0);
            }
            //if not authorized user can not drag
            else {
                return false
            }
        }

        //To check if destination is droppable (active)
        function beforeDrop(event) {
            var isDestinationDrobable = utility.checkRecordOrParentsPropertyValueRecursively(event.dest.nodesScope.$nodeScope, '$parentNodeScope', '$modelValue.Status', 0);
            if(!isDestinationDrobable){
                toast.error('', 'The Destination is not dropable', '', {'Message': 'The root directory is disabled'})
            }
            return isDestinationDrobable
        }

        function loadAssortmentsAndFolders(isLogRequired) {
            var promises = {
                loadAssortment: {},
                loadFolders: {}
            }
            var generalProperties = {
                forceFetch: true,
                isLogRequired: isLogRequired,
                config: {},
                supportIncrementalResult: true,
                modelIdField: 'Id',
                isMajor: false,
                model: vm.model
            }

            // load catalog assortments
            promises.loadAssortment = vm.model.methods.getList(generalProperties, activeCatalogCode, vm.model)
            .then(function(response) {
                catalogAssortmentsList = response.data;
                createImageSetMap(catalogAssortmentsList);
                utility.addPropertiesToObject(catalogAssortmentsList, ['folderStatus'], ['number']);
            });

            //load assortments folders
            promises.loadFolders = vm.folderModel.methods.getList({ forceFetch: true, isLogRequired: isLogRequired }, vm.folderModel, activeCatalogCode)
            .then(function(response) {
                foldersList = response.data;
                utility.addPropertiesToObject(foldersList, ['nodes', 'ancestorDisabledStatus'], ['array', 'boolean']);
            });
            return $q.all(promises);
    }

        var catalogChangedEventCleanup = $rootScope.$on('ActiveCatalogChangedEvent', function(e) {
            if(activeCatalogCode !== catalogFactory.getActiveCatalog().CatalogCode) {
                $state.reload('app.assortments');
            }
        });
        $scope.$on('$destroy', function () {
            catalogChangedEventCleanup();
        });

  }
})();
(function() {
    'use strict';

    angular
        .module('app.main.catalogs.assortments')
        .controller('assortmentDetailsController', assortmentDetailsController);

    /* @ngInject */
    function assortmentDetailsController($document, api, $state, $stateParams, $rootScope, $mdDialog, catalogFactory, utility, assortmentsModel) {
       /* jshint validthis: true */
        var vm = this;
        var assortmentId = $stateParams.id;
        var imageSetMap = $stateParams.imageSetMap;
        var activeCatalog = catalogFactory.getActiveCatalog();
        vm.catalogCollectionType = activeCatalog.CollectionsType;
        var duneContext = activeCatalog.DuneContext;
        var assignedContextKey = catalogFactory.getCatalogContextKey();
        var sellerId = activeCatalog.AccountId;
        vm.activeCatalogCode = activeCatalog.CatalogCode;

        vm.model = assortmentsModel;
        vm.articlesModel = api.assortments.articles;
        vm.customersModel = api.assortments.customers;
        vm.sellerUserModel = api.assortments.sellerUsers;

        vm.assortment = {};
        vm.articles = [];
        var allArticles = [];
        vm.filteredArticles = [];
        vm.customers = [];
        var allCustomers = [];
        vm.filteredCustomers = [];
        vm.isLoading = false;
        vm.sellerUsers = [];
        vm.filteredSellerUsers = [];


        vm.refreshRecord = refreshRecord;
        vm.editItem = editItem;
        vm.doAssortmentItemAction = doAssortmentItemAction;
        vm.doArticleItemAction = doArticleItemAction;
        vm.doArticleListAction = doArticleListAction;
        vm.addArticle = addArticle;
        vm.viewArticle = viewArticle;
        vm.doCustomerItemAction = doCustomerItemAction;
        vm.doCustomersListAction = doCustomersListAction;
        vm.addCustomer = addCustomer;
        vm.viewCustomer = viewCustomer;
        vm.assignSellerUsers = assignSellerUsers;

        activate();

        ////////////////

        function activate() {
            refreshRecord(true);
        }

        function refreshRecord(isLogRequired) {
            vm.isLoading = true;

            vm.model.methods.getDetails(isLogRequired, vm.activeCatalogCode, assortmentId)
                .then(function (response) {
                    vm.assortment = response.data;
                    vm.title = angular.copy(vm.assortment[vm.model.lookupDisplayField]);

                    //Update Breadcrumb
                    $state.current.data.displayName = vm.title;
                    $rootScope.$broadcast('breadcrumb-updated');

                    allArticles = response.data.ArticleList;
                    vm.articles = utility.filterObject(allArticles, {Status: 1});
                    allCustomers = response.data.CustomerList;
                    vm.customers = utility.filterObject(allCustomers, {Status: 1});
                    vm.sellerUsers = response.data.UserList;
                    if(utility.isObjectEmpty(imageSetMap)) {
                        var generalProperties = {
                            forceFetch: true,
                            isLogRequired: isLogRequired,
                            config: {},
                            supportIncrementalResult: true,
                            modelIdField: 'Id',
                            isMajor: false,
                            model: vm.model
                        }
                        vm.model.methods.getList(generalProperties, vm.activeCatalogCode, vm.model)
                        .then(function(response) {
                            createImageSetMap(response.data);
                        });
                    }
                })
                .finally(function () {
                    vm.isLoading = false;
                });
        }

        function editItem(record, ev) {
            if(vm.catalogCollectionType !== 2) {
                api.showEditRecordDialog(angular.element($document.body), ev, vm.model, record, vm.activeCatalogCode)
                .then(function(saved) {
                    if (saved) {
                        vm.model.isDirty = true;
                        refreshRecord(true);
                    }
                });
            } else {
                $mdDialog.show({
                    controller         : 'createCriteriaCollectionController',
                    controllerAs       : 'vm',
                    templateUrl        : 'app/main/catalogs/sub-modules/assortments/list/dialogs/create-criteria-collection/create-criteria-collection.html',
                    parent             : angular.element($document.body),
                    targetEvent        : ev,
                    clickOutsideToClose: false,
                    locals             : {
                        model: vm.model,
                        record: record,
                        isNew: false,
                        contextKey: assignedContextKey,
                        duneContext: duneContext,
                        imageSetMap: imageSetMap,
                        folderId   : record.FolderId,
                        sortOrder  : record.SortOrder,
                        event: ev
                    }
                }).then(function(saved) {
                    if (saved) {
                        refreshRecord(true);
                    }
                });
            }
        }

        function createImageSetMap(assortments) {
            angular.forEach(assortments, function(assortments) {
                if(assortments.DunesImageSet !== '') {
                    imageSetMap[assortments.DunesImageSet] = 1;
                }
            })
            return imageSetMap;
        }

        function doAssortmentItemAction(action, record) {
            if (action) {
                switch (action.id) {
                    case 'delete':
                    case 'activate':
                        vm.model.methods.activateBulk(record, vm.model, action.id, vm.activeCatalogCode);
                        break;
                }
            }
        }

		function doArticleListAction(action, record) {
			if (action && record) {
				switch (action.id) {
					case "delete":
					case "activate":
                        vm.articlesModel.methods.activateBulk(record, angular.copy(allArticles), vm.articlesModel, action.id, assortmentId, vm.activeCatalogCode).then(function() {
                            refreshRecord();
                        });
                        break;
				}
			}
		}

        function doArticleItemAction(action, record) {
            if (action) {
                switch (action.id) {
					case "view":
						viewArticle(record);
                        break;
                    case 'delete':
                    case 'activate':
                        vm.articlesModel.methods.activateBulk(record, angular.copy(allArticles), vm.articlesModel, action.id, assortmentId, vm.activeCatalogCode).then(function() {
                            refreshRecord();
                        });
                        break;
                }
            }
        }

        function addArticle(ev) {
            var promise = {};
            var generalProperties = {
                forceFetch: true,
                isLogRequired: false,
                config: {},
                supportIncrementalResult: true,
                isMajor: false,
                modelIdField: vm.model.idField
            }
            promise['catalogArticlesPromise'] = api.catalogs.articles.methods.getList(generalProperties, vm.customersModel, vm.activeCatalogCode);
            $mdDialog.show({
                controller         : 'createAssortmentArticleController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/catalogs/sub-modules/assortments/details/tabs/articles/dialogs/create-assortment-article.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: false,
                locals             : {
                    activeCatalogId : vm.activeCatalogCode,
                    assortmentId : assortmentId,
                    model: vm.articlesModel,
                    assignedArticles: angular.copy(vm.articles),
                    promise: promise,
                    event: ev
                }
            }).then(function(saved) {
                if (saved) {
                    refreshRecord(api.assortments.articles.isDirty);
                }
            });
        }

        function viewArticle(record) {
            var id = record[vm.articlesModel.idField];
            var stateParams = {id:id};
            $state.go('app.articles.details', stateParams);
        }

        function doCustomerItemAction(action, record) {
            if (action && record) {
                switch (action.id) {
                    case "view":
                        viewCustomer(record);
                        break;
                    case "delete":
                    case "activate":
                        vm.customersModel.methods.activateBulk(record, angular.copy(allCustomers), vm.customersModel, action.id, assortmentId, vm.activeCatalogCode).then(function() {
                            refreshRecord();
                        });
                        break;
                }
            }
        }

        function doCustomersListAction(action, record) {
            if (action && record) {
                switch (action.id) {
                    case "delete":
                    case "activate":
                        vm.customersModel.methods.activateBulk(record, angular.copy(allCustomers), vm.customersModel, action.id, assortmentId, vm.activeCatalogCode).then(function() {
                            refreshRecord();
                        });
                        break;
                }
            }
        }

        function addCustomer(ev) {
            var promise = {};
            var generalProperties = {
                forceFetch: true,
                isLogRequired: false,
                config: {},
                supportIncrementalResult: true,
                isMajor: false,
                modelIdField: vm.model.idField
            }
            promise['catalogCustomersPromise'] = api.catalogs.customers.methods.getList(generalProperties, vm.customersModel, vm.activeCatalogCode);
            $mdDialog.show({
                controller         : 'createAssortmentCustomerController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/catalogs/sub-modules/assortments/details/tabs/customers/dialogs/create-assortment-customer.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: false,
                locals             : {
                    activeCatalogId : vm.activeCatalogCode,
                    assortmentId : assortmentId,
                    model: vm.customersModel,
                    assignedCustomers: vm.customers,
                    promise: promise,
                    event: ev
                }
            }).then(function(saved) {
                if (saved) {
                    refreshRecord(api.assortments.articles.isDirty);
                }
            });
        }

        function viewCustomer(record) {
            var id = record[vm.customersModel.idField];
            var stateParams = {id:id, sellerId: sellerId};
            $state.go('app.customer_details', stateParams);
        }

        function assignSellerUsers(ev) {
            // add assigned User id's to Users
            var record = {};
            var activeUsers= utility.filterObject(vm.sellerUsers, {'Status': 1}, true);

            if(angular.isDefined(activeUsers)) {
                record.Users = activeUsers.map(function(record) {
                    var userId = record['UserId'];
                    return userId;
                });
            };
            api.showEditRecordDialog(angular.element($document.body), ev, vm.sellerUserModel, record, assortmentId)
            .then(function(saved) {
                if (saved) {
                    refreshRecord(true, false);
                }
            });
        }

    }
})();
(function() {
    'use strict';

    angular
        .module('app.main.catalogs.articles-replacement',[])
        .config(config);

    /* @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
        // State
        $stateProvider.state('app.articles_replacement', {
            url    : '/article-replacement',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/catalogs/sub-modules/articles-replacement/list/articles-replacement-list.html',
                    controller : 'articlesReplacementController as vm'
                }
            },
            data: {
                displayName: 'ARTICLES_REPLACEMENT.NAV'
            },
            resolve: {

            },
            //only users with following accessPrivileges in their role access list can access this route
            // accessPrivileges: ['GetCatalogArticleReplacementList']
            // accessPrivileges: ['nav_articles_replacement']
            accessInfo: {
                accessPrivileges: ['nav_articles_replacement']
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/catalogs/sub-modules/articles-replacement');


        msNavigationServiceProvider.saveItem('catalogs.articles_replacement', {
            title      : 'Articles Replacement',
            icon       : 'icon-tile-four',
            state      : 'app.articles_replacement',
            translate  : 'ARTICLES_REPLACEMENT.NAV',
            weight     : 39,
            // accessPrivileges: ['GetCatalogArticleReplacementList']
            // accessPrivileges: ['nav_articles_replacement']
            accessInfo: {
                accessPrivileges: ['nav_articles_replacement']
            }
        });
    }
})();
(function() {
    'use strict';

    angular
        .module('app.main.catalogs.articles-replacement')
        .controller('articlesReplacementController', articlesReplacementController);

    /* @ngInject */
    function articlesReplacementController(api, $rootScope, $scope, $state, $document, $mdDialog, catalogFactory, settingsFactory, $q) {
        /* jshint validthis: true */
        var vm = this;

        //data
        var activeCatalog = catalogFactory.getActiveCatalog();
		var activeCatalogCode = activeCatalog.CatalogCode;

        vm.model = api.catalogs.articlesReplacement;
        settingsFactory.applyPersistedListViewLayout(vm.model);

        var articlesModel = api.catalogs.articles;

		vm.articlesWithReplacement = [];
		vm.filteredArticlesWithReplacement = [];
		vm.isLoading = false;


		vm.refreshRecords = refreshRecords;
		vm.doItemAction = doItemAction;
		vm.addRecord = addRecord;

		activate();

		////////////////

		function activate() {
			refreshRecords(vm.model.isDirty, true);
		}

		function refreshRecords(forceFetch, isLogRequired) {
            var generalProperties = {
                forceFetch: forceFetch,
                isLogRequired: isLogRequired
            }
			vm.isLoading = true;

			vm.model.methods.getList(generalProperties, activeCatalogCode)
			.then(function(response) {
				vm.articlesWithReplacement = response.data;
			})
			.finally(function () {
				vm.isLoading = false;
			});
		}

		//Item Action button pressed event
		function doItemAction(action, record) {
			if (action && record) {
                switch (action.id) {
                    case 'edit':
                        editItem(record, null);
                        break;
                    case 'delete':
                    case 'activate':
                        vm.model.methods.activate(record, vm.model, action.id, activeCatalogCode);
                        break;
                }
			}
		}

        function addRecord(ev) {
            var generalProperties = {
                forceFetch: true,
                isLogRequired: false,
                config: {},
                supportIncrementalResult: true,
                isMajor: false,
                modelIdField: articlesModel.idField
            }
            var promises = {ActiveCatalogArticlesPromise: articlesModel.methods.getList(generalProperties, articlesModel, activeCatalogCode)};
            $mdDialog.show({
                controller         : 'replaceArticleController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/catalogs/sub-modules/articles-replacement/dialogs/replace-article.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: false,
                locals             : {
                    model : vm.model,
                    articlesModel: articlesModel,
                    activeCatalog: activeCatalog,
                    articlesWithReplacementPromise: $q.when({data:vm.articlesWithReplacement}),
                    record: null,
                    isNew: true,
                    lookupPromises: promises
                }
            }).then(function(saved) {
                if (saved) {
                    refreshRecords(true, false);
                }
            });
		}

		function editItem(record, ev) {
            var promises = {ActiveCatalogArticlesPromise: $q.when({})};//no use of it in update since original article dropdown is disabled
            $mdDialog.show({
                controller         : 'replaceArticleController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/catalogs/sub-modules/articles-replacement/dialogs/replace-article.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: false,
                locals             : {
                    model : vm.model,
                    articlesModel: articlesModel,
                    activeCatalog: activeCatalog,
                    articlesWithReplacementPromise: $q.when({data:vm.articlesWithReplacement}),
                    record: record,
                    isNew: false,
                    lookupPromises: promises
                }
            }).then(function(saved) {
                if (saved) {
                    refreshRecords(true, false);
                }
            });
		}

        var catalogChangedEventCleanup = $rootScope.$on('ActiveCatalogChangedEvent', function(e) {
            if(activeCatalogCode !== catalogFactory.getActiveCatalog().CatalogCode) {
                // vm.model.isDirty = true; // not required since invalidating all the lookups under catalogs on dropdown change (in toolbar controller)
                $state.reload('app.articles_replacement');
            }
        });
        $scope.$on('$destroy', function () {
            catalogChangedEventCleanup();
        });

	}
})();
(function() {
    'use strict';

    angular
        .module('app.main.catalogs.articles-replacement')
        .controller('replaceArticleController', replaceArticleController);

    /* @ngInject */
    function replaceArticleController($mdDialog, $scope, $filter, $window, $q, utility, hotkeys, toast,
                                        model, articlesModel, activeCatalog, articlesWithReplacementPromise, record, isNew, lookupPromises) {
        /* jshint validthis: true */
        var vm = this;

        //data
        var articlesWithoutReplacement = []; // processed data of getList of articles API
        var suggestedArticles = []; // result of getList of articels with same sizes

        var articlesWithReplacementMapObj = {};
        vm.record = {};
        vm.isNew = isNew;
        vm.autocompleteModel = {};
        vm.searchText = {};


        //methods
        vm.saveRecord = saveRecord;
        vm.closeDialog = closeDialog;

        vm.searchOriginalArticles = searchOriginalArticles;
        vm.searchSuggestedArticles = searchSuggestedArticles;
        vm.onOriginalArticleChange = onOriginalArticleChange;
        vm.onSuggestedAticleChange = onSuggestedAticleChange;
        vm.getOriginalArticlesDisplayValue = getOriginalArticlesDisplayValue;
        vm.getSuggestedArticlesDisplayValue = getSuggestedArticlesDisplayValue;
        vm.selectText = selectText;


        activate();

        ////////////////

        function activate() {
            if(record !== null) {
                vm.record = record;
                vm.autocompleteModel = record;
                loadArticleWithSameSizes(record['ArticleIdDropped']);
            }
            //Hotkeys
            hotkeys.bindTo($scope).add({
                combo: 'ctrl+enter',
                description: $filter('translate')('ACTIONS.SAVE'),
                allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
                callback: function(event) {
                    if (!vm.isLoading && !vm.editForm.$invalid) {
                        vm.saveRecord();
                    }
                }
            });
            if(vm.isNew) {
                hotkeys.bindTo($scope).add({
                    combo: 'ctrl+shift+enter',
                    description: $filter('translate')('ACTIONS.SAVE_AND_NEW'),
                    allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
                    callback: function(event) {
                        if (!vm.isLoading && !vm.editForm.$invalid) {
                            vm.saveRecord(true);
                        }
                    }
                });
            }
        }

        function saveRecord(saveAndNew) {
            vm.isLoading = true;

            var p;

            if (vm.isNew)
            {
                p = model.methods.create(vm.record, activeCatalog.CatalogCode);
            } else {
                p = model.methods.update(vm.record, activeCatalog.CatalogCode);
            }

            p.then(function(response) {
                if (vm.isNew && angular.isDefined(saveAndNew) && saveAndNew) {

                    vm.editForm.$setPristine();
                    vm.editForm.$setUntouched();
                    vm.record = {};
                    //remove added object from list of articlesWithoutReplacement
                    var index = articlesWithoutReplacement.indexOf(utility.filterObject(articlesWithoutReplacement, {Id: vm.record.ArticleIdDropped})[0]);// articlesWithoutReplacement from get list of articles
                    articlesWithReplacementMapObj[vm.record.ArticleIdDropped] = 'dummyVal'; // not requires since we are removing record from articlesWithoutReplacement list
                    articlesWithoutReplacement.splice(index, 1);

                    vm.autocompleteModel = {};
                    vm.searchText = {};
                    vm.isDataDirty = true;

                    var el = $window.document.getElementById('dialog_input_articleReplacement_ArticleIdDropped');
                    if (el) {
                        el.focus();
                    }
                } else {
                    closeDialog(true);
                }

                var toastMessage;
                toastMessage = vm.isNew ? 'SUCCESS.CREATE': 'SUCCESS.UPDATE';
                toast.success(toastMessage, '', '');
            }, function(err) {
                closeDialog(vm.isDataDirty);
            }).finally(function () {
                vm.isLoading = false;
            })
        }

        function closeDialog(saved) {
            $mdDialog.hide(saved);
        }

        function searchOriginalArticles(query) {
            var results = [];

            if(articlesWithoutReplacement.length) {
                results = query ? utility.filterObject(articlesWithoutReplacement, {ArticleNumber :query}) : articlesWithoutReplacement;
                return results;
            }
            else {
                return loadArticlesWithoutReplacement().then(function() {
                    results = query ? utility.filterObject(articlesWithoutReplacement , {ArticleNumber :query}) : articlesWithoutReplacement;
                    return results;
                });
            }
        }

        function searchSuggestedArticles(query) {
            var results = [];
            if(suggestedArticles.length) {
                results = query ? utility.filterObject(suggestedArticles , {ArticleNumber: query}) : suggestedArticles;
                return results;
            }
            else {
                return loadArticleWithSameSizes(vm.record['ArticleIdDropped']).then(function() {
                    results = query ? utility.filterObject(suggestedArticles , {ArticleNumber: query}) : suggestedArticles;
                    return results;
                });
            }
        }

        //selected object will be result of getList of articles
        function onOriginalArticleChange(selectedObj) {
            if(angular.isObject(selectedObj)) {
                vm.record['ArticleIdDropped'] = selectedObj[articlesModel.idField];
                loadArticleWithSameSizes(selectedObj[articlesModel.idField]);
            }
            else if(angular.isUndefined(selectedObj) || selectedObj === null){
                suggestedArticles.length = 0;
                vm.record['ArticleIdDropped'] = undefined; // on record removal make field undefined or the property can be deleted using delete keywork
            }
        }

        // selected object will be result of getlist of articles with same sizes
        function onSuggestedAticleChange(selectedObj) {
            if(angular.isObject(selectedObj)) {
                vm.record['ArticleIdAlt'] = selectedObj['ArticleId'];
            }
            else if(angular.isUndefined(selectedObj) || selectedObj === null){
                vm.record['ArticleIdAlt'] = undefined; // on record removal make field undefined or the property can be deleted using delete keywork
            }
        }

        function getOriginalArticlesDisplayValue(item) {
            var mapperObj = {idField: articlesModel.idField, displayField: articlesModel.lookupDisplayField};
            if(!vm.isNew) {
                return record['ArticleNumberDropped'];// since the field is disabled and its value wont get changed duing update action
            }
            if(articlesWithoutReplacement.length) {
                return getLookupDisplayVal(item, articlesWithoutReplacement, mapperObj);
            }
            else {
                return lookupPromises['ActiveCatalogArticlesPromise'].then(function(response) {
                    return getLookupDisplayVal(item, response.data, mapperObj);
                });
            }
        }

        function getSuggestedArticlesDisplayValue(item) {
            if(suggestedArticles.length) {
                return getLookupDisplayVal(item, suggestedArticles, {idField: 'ArticleId', displayField: 'ArticleNumber'});
            }
            else {
                return loadArticleWithSameSizes(vm.record['ArticleIdDropped']).then(function() {
                    return getLookupDisplayVal(item, suggestedArticles, {idField: 'ArticleId', displayField: 'ArticleNumber'});
                });
            }
        }

        function selectText(event) {
            utility.selectInputText(event);
        }


        //helper method
        function getLookupDisplayVal(item, data, mapperObj) {
            var result;
            if(data) {
                var predicate = {};
                // since autocomplte return object
                if(angular.isObject(item)) {
                    predicate[mapperObj.idField] = item[mapperObj.idField];
                    result = utility.filterObject(data, predicate, true);
                }
                // to initialize field value if any (when open update record dialog)
                else {
                    predicate[mapperObj.idField] = item;
                    result = utility.filterObject(data, predicate, true);
                }

                if (angular.isArray(result) && result.length > 0) {
                    return result[0][mapperObj.displayField];
                }
                else {
                    return result[mapperObj.displayField];
                }
            }
        }

        function loadArticleWithSameSizes(articleId) {
            return articlesModel.methods.getArticlesWithSameSizes(activeCatalog.CatalogCode, articleId, activeCatalog.ArticleReplacementAttributeId).then(function(response) {
                suggestedArticles = response.data;
            });
        }

        // filter out articles with replacements
        function loadArticlesWithoutReplacement() {
            var deferred = $q.defer();
            createArticlesWithReplacementMapObj();
            lookupPromises['ActiveCatalogArticlesPromise'].then(function(response) {
                angular.forEach(response.data, function(activeCatalogArticle) {
                    if(angular.isUndefined(articlesWithReplacementMapObj[activeCatalogArticle[articlesModel.idField]])) {
                        articlesWithoutReplacement.push(activeCatalogArticle);
                    }
                });
                deferred.resolve(articlesWithoutReplacement);
            });
            return deferred.promise;
        }

        // get list of existing data (articles with replacement) and create a map of key value pair with key beeing id of original articles
        function createArticlesWithReplacementMapObj() {
            articlesWithReplacementMapObj = {};
            $q.when(articlesWithReplacementPromise).then(function(response) {
                angular.forEach(response.data, function(articleWithReplacement) {
                    articlesWithReplacementMapObj[articleWithReplacement['ArticleIdDropped']] = 'dummyVal';
                });
            });
        }
    }
})();
(function() {
  'use strict';

  angular
      .module('app.main.catalogs.articles-blocking', [])
      .config(config);

  /* @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
      // State
      $stateProvider.state('app.articles_blocking', {
          url    : '/articles-blocking',
          views  : {
              'content@app': {
                  templateUrl: 'app/main/catalogs/sub-modules/articles-blocking/list/articles-blocking-list.html',
                  controller : 'articlesBlockingListController as vm'
              }
          },
          resolve: {
            articlesBlockingDynamicModel: function(catalogFactory) {
              //Mapping response source property to fields target property
              var propertiesMapper = [{target: 'field', source:'field["CatalogCode"]'}, {target: 'displayLabel', source: 'field["CatalogName"]'}],
                  inputType = 'switch',
                  targetModel = 'catalogs.articlesBlocking',
                  sourceModel = 'catalogs.catalogs';
              return catalogFactory.createArticlesBlockingModel(targetModel, sourceModel, propertiesMapper, inputType);
            }
          },
          data: {
              displayName: 'ARTICLES_BLOCKING.NAV'
          },
          //only users with following accessPrivileges in their role access list can access this route
          // accessPrivileges: ['GetBlockedArticleList']
          // accessPrivileges: ['nav_block_articles']
          accessInfo: {
            accessPrivileges: ['nav_block_articles']
          }
      });

      // Translation
      $translatePartialLoaderProvider.addPart('app/main/catalogs/sub-modules/articles-blocking');


      msNavigationServiceProvider.saveItem('catalogs.articles_blocking', {
          title      : 'Articles Blocking',
          icon       : 'icon-block-helper',
          state      : 'app.articles_blocking',
          translate  : 'ARTICLES_BLOCKING.NAV',
          weight     : 35,
          // accessPrivileges: ['GetBlockedArticleList']
        //   accessPrivileges: ['nav_block_articles']
          accessInfo: {
            accessPrivileges: ['nav_block_articles']
          }
      });
  }
})();
(function () {
  'use strict';

  angular
    .module('app.main.catalogs.articles-blocking')
    .controller('articlesBlockingListController', articlesBlockingListController);

  /* @ngInject */
  function articlesBlockingListController(api, $rootScope, $scope, $state, $document, utility, catalogFactory, articlesBlockingDynamicModel,
    dataImporter, settingsFactory, crud, $mdDialog) {
    /* jshint validthis: true */
    var vm = this;


    //Data
    var activeCatalog = catalogFactory.getActiveCatalog();
    var activeCatalogId = activeCatalog.CatalogCode;

    vm.model = articlesBlockingDynamicModel;
    settingsFactory.applyPersistedListViewLayout(vm.model);

    vm.blockedArticles = [];
    vm.filteredBlockedArticles = [];
    vm.isLoading = false;

    var assignedAttributes = catalogFactory.getActiveCatalogDetails().AssignedCatalogAttributes;

    //Methods
    vm.refreshRecords = refreshRecords;
    vm.doListAction = doListAction;
    vm.doItemAction = doItemAction;
    vm.addRecord = addRecord;


    activate();
    ////////////////

    function activate() {
      refreshRecords(vm.model.baseModel.isDirty, true);
    }

    function refreshRecords(forceFetch, isLogRequired) {
      vm.isLoading = true;
      var generalProperties = {
        forceFetch: forceFetch,
        isLogRequired: isLogRequired
      }

      vm.model.methods.getList(generalProperties, vm.model, activeCatalogId)
      .then(function (response) {
        vm.blockedArticles = catalogFactory.transformArticlesBlockingResponse(response.data, vm.model.fields);
      })
      .finally(function () {
        vm.isLoading = false;
      });
    }

    //Item Action button pressed event
    function doItemAction(action, record) {
      if (action && record) {
        switch (action.id) {
          case 'edit':
            editItem(record, null);
            break;
          case 'delete':
          case 'activate':
            vm.model.methods.activateBulk(record, vm.model, action.id, activeCatalogId);
            break;
        }
      }
    }

    //List Action button pressed event
    function doListAction(action, records) {
      if (action) {
        switch (action.id) {
          case 'delete':
          case 'activate':
            vm.model.methods.activateBulk(records, vm.model, action.id, activeCatalogId);
            break;
          case 'import':
            var modelClone = angular.copy(vm.model);
            var dynamicFields = utility.filterObject(modelClone.fields, {isDynamicProperty: true}, true);
            angular.forEach(modelClone.fields, function(field) {
              if(field.isDynamicProperty) {
                field.creatable = true;
                var requiredCriteria = '';
                angular.forEach(dynamicFields, function(dynamicField, index) {
                  if(index === 0) {
                    requiredCriteria = 'data["'+ dynamicField.field +'"] == null';
                  } else {
                    requiredCriteria += '&& data["'+ dynamicField.field +'"] == null';
                  }
                });
                field.validation.isRequired = requiredCriteria;
              } else if(field.field === 'AttributeDisplayName') {
                field.creatable = true;
                field.validation.isRequired = true;
                var attributesListWithModelNumberAndArticleNumber = assignedAttributes.concat([{'AttributeDisplayName': 'ModelNumber'},{'AttributeDisplayName': 'ArticleNumber'}]);
                field.validation.dataExistConstraints = { data: attributesListWithModelNumberAndArticleNumber };
              } else if(field.field === 'BlockedCatalogs' || field.field === 'AttributeId') {
                field.creatable = false;
              }
            });
            dataImporter.importExcel(modelClone, true).then(function (result) {
              vm.model.methods.createBulk(vm.model, result.data, activeCatalogId, assignedAttributes);
            });
            break;
            case 'blockedArticles':
            var affectedArticlesModel = angular.copy(api.catalogs.affectedArticles);
            var blockedArticlesList = [];
            utility.filterObject(affectedArticlesModel.fields, {field: 'Reason'}, true)[0].visible = true;
            affectedArticlesModel.methods.getBlockedArticles(activeCatalogId, records).then(function(response){
              blockedArticlesList = response.data;
              $mdDialog.show({
                controller: 'affectedArticlesListController',
                controllerAs: 'vm',
                templateUrl: 'app/main/catalogs/sub-modules/articles-blocking/dialogs/affected-articles-list.html',
                parent: angular.element($document.body),
                targetEvent: null,
                clickOutsideToClose: false,
                multiple: true,
                locals: {
                  event: null,
                  data: blockedArticlesList,
                  model: affectedArticlesModel,
                  secondaryModel: vm.model,
                  record: null,
                  catalogCode: activeCatalogId,
                  action: 'blockedArticles'
                }
              });
            });
            break;
        }
      }
    }

    function addRecord(ev) {
      var modelCopy = angular.copy(vm.model);
      var lookupPromises = {};
      lookupPromises = crud.createLookupPromise(modelCopy, undefined, 'create');
       $mdDialog.show({
        controller         : 'createArticlesBlockingController',
        controllerAs       : 'vm',
        templateUrl        : 'app/main/catalogs/sub-modules/articles-blocking/dialogs/create-articles-blocking.html',
        parent             : angular.element($document.body),
        targetEvent        : ev,
        clickOutsideToClose: false,
        locals             : {
            editMode: false,
            model: modelCopy,
            record : null,
            parentId : activeCatalogId,
            event: ev,
            lookupPromises: lookupPromises
        }
        })
        .then(function (saved) {
          if (saved) {
            refreshRecords(true, false);
          }
        });
    }

    function editItem(item, ev) {
      var modelCopy = angular.copy(vm.model);
      var lookupPromises = {};
      lookupPromises = crud.createLookupPromise(modelCopy, undefined, 'edit');
      $mdDialog.show({
        controller         : 'createArticlesBlockingController',
        controllerAs       : 'vm',
        templateUrl        : 'app/main/catalogs/sub-modules/articles-blocking/dialogs/create-articles-blocking.html',
        parent             : angular.element($document.body),
        targetEvent        : ev,
        clickOutsideToClose: false,
        locals             : {
            editMode: true,
            model: modelCopy,
            record : item,
            parentId : activeCatalogId,
            event: ev,
            lookupPromises: lookupPromises
        }
        })
        .then(function (saved) {
          if (saved) {
            refreshRecords(true, false);
          }
        });
    }


    var catalogChangedEventCleanup = $rootScope.$on('ActiveCatalogChangedEvent', function (e) {
      if (activeCatalogId !== catalogFactory.getActiveCatalog().CatalogCode) {
        // vm.model.isDirty = true; // not required since invalidating all the lookups under catalogs on drop down change (in toolbar controller)
        $state.reload('app.articles_blocking');
      }
    });
    $scope.$on('$destroy', function () {
      catalogChangedEventCleanup();
    });

  }
})();
(function () {
  'use strict';

  angular
    .module('app.main.catalogs.articles-blocking')
    .controller('createArticlesBlockingController', createArticlesBlockingController);

  /* @ngInject */
  function createArticlesBlockingController($mdDialog, $document, $scope, $filter, scope, toast, hotkeys, $log, dialog,
    api, utility, editMode, model, record, parentId, event, lookupPromises, catalogFactory) {
    var vm = this;
    var childCatalogsList = [];
    var attributeValuePromise = undefined;
    vm.attributeValues = undefined;
    vm.isAttributeValueExist = false;
    var assignedCatalogAttributes = catalogFactory.getActiveCatalogDetails().AssignedCatalogAttributes;

    vm.isLoading = false;
    vm.model = model;
    vm.record = angular.copy(record);
    vm.isNew = false;
    vm.isDataDirty = false;

    vm.acSelectedItem = [];
    vm.acSearchText = [];
    vm.searchText = {};

    vm.isNew = !editMode;
    if (!vm.record) {
      //Create empty object
      vm.record = {};
      vm.isNew = true;
      vm.record.BlockedCatalogs = [];
    }
    var articleNumberLabel = 'ArticleNumber';
    var modelNumberLabel = 'ModelNumber';

    vm.saveRecord = saveRecord;
    vm.closeDialog = closeDialog;

    vm.lookupSearch = lookupSearch;
    vm.lookupChange = lookupChange;
    vm.getLookupDisplayValue = getLookupDisplayValue;
    vm.selectText = selectText;

    vm.getAttributeValues = getAttributeValues;

    vm.transformChip = transformChip;
    vm.acQuerySearch = acQuerySearch;
    vm.getChipDisplayValue = getChipDisplayValue;


    activate();

    ////////////////

    function activate() {

      //Hotkeys
      hotkeys.bindTo($scope)
        .add({
          combo: 'ctrl+enter',
          description: $filter('translate')('ACTIONS.SAVE'),
          allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
          callback: function (event) {
            if (!vm.isLoading && !vm.editForm.$invalid) {
              vm.saveRecord();
            }
          }
        });

      if (vm.isNew) {
        hotkeys.bindTo($scope)
          .add({
            combo: 'ctrl+shift+enter',
            description: $filter('translate')('ACTIONS.SAVE_AND_NEW'),
            allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
            callback: function (event) {
              if (!vm.isLoading && !vm.editForm.$invalid) {
                vm.saveRecord(true);
              }
            }
          });
      } else {
        api.webGet(api.baseUrl + '/catalogs/' + parentId + '/attributes/' + vm.record.AttributeSystemName + '/values').then(function(response) {
            if( response && response.data && response.data.Values && angular.isArray(response.data.Values) && response.data.Values.length >0) {
            vm.isAttributeValueExist  = true;
            vm.attributeValues = response.data.Values;
            }
        });
      }
    }



    function saveRecord(ev) {
      var affectedArticlesList = [];
      var affectedArticlesLoader = true;
      api.catalogs.affectedArticles.methods.getList(parentId, vm.record).then(function (response) {
        affectedArticlesList = response.data;
        affectedArticlesLoader = false;
        var affectedArticlesModel = angular.copy(api.catalogs.affectedArticles);
        // utility.filterObject(affectedArticlesModel.fields, {field: 'AffectedCatalogs'}, true)[0].visible = true;
        $mdDialog.show({
          controller: 'affectedArticlesListController',
          controllerAs: 'vm',
          templateUrl: 'app/main/catalogs/sub-modules/articles-blocking/dialogs/affected-articles-list.html',
          parent: angular.element($document.body),
          targetEvent: null,
          clickOutsideToClose: false,
          multiple: true,
          locals: {
            event: ev,
            data: affectedArticlesList,
            model: affectedArticlesModel,
            secondaryModel: vm.model,
            record: vm.record,
            catalogCode: parentId,
            action: 'affectedArticles'
          }
        }).then(function (response) {
          if (response.toString().trim().toLowerCase() === 'true') {
            closeDialog(true);
          }
        }).finally(function () {
          vm.isLoading = false;
        });
      }).catch(function (error) {
        closeDialog(false);
      });
    }

    function closeDialog(saved) {
      $mdDialog.hide(saved);
    }

    function lookupSearch(query, fieldName) {
      var results = [];
      if(angular.isDefined(api.articleLabelConfiguration) && api.articleLabelConfiguration !== '' && api.articleLabelConfiguration.length) {
        articleNumberLabel =  utility.replaceStringWithCase(articleNumberLabel, 'article', api.articleLabelConfiguration);
      }
      if(angular.isDefined(api.modelLabelConfiguration) && api.modelLabelConfiguration !== '' && api.modelLabelConfiguration.length) {
        modelNumberLabel =  utility.replaceStringWithCase(modelNumberLabel, 'model', api.modelLabelConfiguration);
      }
      var articleAndModelNumberList = [{ id: -1, value: modelNumberLabel }, { id: -2, value: articleNumberLabel }];
      var field = utility.filterObject(model.fields, { field: fieldName }, true)[0];
      var lookupFilter = angular.isDefined(field.lookupFilter) ? field.lookupFilter : {};
      var predicate = angular.copy(lookupFilter);
      predicate.value = query;
      var lookupModel = api.getModel(field.lookupSource);

      if (lookupModel && angular.isDefined(lookupModel.lookupData) && angular.isDefined(lookupModel.lookupData.data) && lookupModel.lookupData.data.length) {
        results = query ? utility.filterObject(lookupModel.lookupData.data, predicate) : utility.filterObject(lookupModel.lookupData.data, lookupFilter, true);
        results = results.concat(articleAndModelNumberList);
      }
      else {
        return lookupPromises[field.field].then(function (lookupData) {
          results = query ? utility.filterObject(lookupData.data, predicate) : utility.filterObject(lookupData.data, lookupFilter, true);
          results = results.concat(articleAndModelNumberList);
          return results;
        });
      }
      return results;
    }

    // convert dropdown scope value form object(lookup record) to id property of lookup record
    function lookupChange(selectedObj, fieldName) {
      if (angular.isObject(selectedObj)) {
        vm.record[fieldName] = selectedObj.id;
        vm.record.AttributeValue = undefined;
        vm.attributeValues = undefined;
        vm.isAttributeValueExist = false;
        if (selectedObj.id != -1 && selectedObj.id != -2) {
          attributeValuePromise = api.webGet(api.baseUrl + '/catalogs/' + parentId + '/attributes/' + selectedObj.AttributeSystemName + '/values');
          vm.isAttributeValueExist = true;
        }
      }
      else if (angular.isUndefined(selectedObj) || selectedObj === null) {
        vm.record[fieldName] = undefined; // on record removal make field undefined or the property can be deleted using delete keywork
      }
    }

    function getAttributeValues(query) {
      var result = [];
      var selectedAttribute = utility.filterObject(assignedCatalogAttributes, { Attributeid: vm.record.AttributeId }, true)[0];
      var isMultiValueAttribute = angular.isDefined(selectedAttribute) && selectedAttribute.AttributeTypeName === 'multivalue' ? true : false;
      if (vm.attributeValues) {
        result = query ? utility.filterObject(vm.attributeValues, query) : vm.attributeValues;
        if(isMultiValueAttribute) {
          result = getUniqueValuesFromMultiValueAttribute(result);
        }
        return result;
      }
      else if (angular.isDefined(attributeValuePromise)) {
        return attributeValuePromise.then(function (response) {
          if (response && response.data && angular.isArray(response.data) && response.data.length > 0) {
            vm.isAttributeValueExist = true;
            result = vm.attributeValues = query ? utility.filterObject(response.data, query) : response.data;
            if(isMultiValueAttribute) {
              result = getUniqueValuesFromMultiValueAttribute(result);
            }
            return result;
          } else {
            vm.isAttributeValueExist = false;
            vm.record.AttributeValue = undefined;
            return result;
          }
        })
      } else {
        vm.isAttributeValueExist = false;
        return result;
      }
    }

    function getLookupDisplayValue(item, fieldName) {
      var field = utility.filterObject(model.fields, { field: fieldName }, true)[0];
      var lookupModel = api.getModel(field.lookupSource);

      if (angular.isDefined(lookupModel.lookupData) && angular.isDefined(lookupModel.lookupData.data) && lookupModel.lookupData.data.length) {
        return getLookupDisplayVal(item, lookupModel.lookupData, fieldName);
      }
      else {
        return lookupPromises[field.field].then(function (lookupData) {
          return getLookupDisplayVal(item, lookupData, fieldName);
        });
      }
    }

    //helper method
    function getLookupDisplayVal(item, lookupData, fieldName) {
      var result;
      if (lookupData) {
        if (item.id === -1 || item === -1) { // if for Attribute id field, ModelNumber is selected
          return modelNumberLabel;
        }
        else if (item.id === -2 || item === -2) { // if for Attribute id field, ArticleNumber is selected
          return articleNumberLabel;
        }
        // since autocomplete return object
        else if (angular.isObject(item) || item === -2) {
          result = utility.filterObject(lookupData.data, { id: item.id }, true);
        }
        // to initialize field value if any (when open update record dialog)
        else {
          result = utility.filterObject(lookupData.data, { id: item }, true);
        }

        if (angular.isArray(result) && result.length > 0) {
          return result[0].value;
        }
        else {
          return result.value;
        }
      }
    }

    function selectText(event) {
      utility.selectInputText(event);
    }

    function transformChip(chip) {
      if (angular.isObject(chip)) {
        return chip.id;
      }
      return undefined;
    }

    function acQuerySearch(query, selectedRecords, fieldName) {
      childCatalogsList = [];
      var field = utility.filterObject(model.fields, { field: fieldName }, true)[0];
      var lookupFilter = angular.isDefined(field.lookupFilter) ? field.lookupFilter : {};
      var predicate = angular.copy(lookupFilter);
      predicate.value = query;

      var lookupModel = api.getModel(field.lookupSource);
      if (angular.isDefined(lookupModel.lookupData) && angular.isDefined(lookupModel.lookupData.data) && lookupModel.lookupData.data.length) {
        getAllChildCatalogs(lookupModel.lookupData.data, parentId, childCatalogsList);
        childCatalogsList = query ? utility.filterObject(childCatalogsList, predicate, true) : childCatalogsList;
        childCatalogsList = removeSelectedChips(selectedRecords, childCatalogsList);
        return childCatalogsList;
      }
      else {
        return lookupPromises[field.field].then(function (lookupData) {
          getAllChildCatalogs(lookupData.data, parentId, childCatalogsList);
          childCatalogsList = query ? utility.filterObject(childCatalogsList, predicate, true) : childCatalogsList;
          childCatalogsList = removeSelectedChips(selectedRecords, childCatalogsList);
          return childCatalogsList;
        });
      }
    }

    function getAllChildCatalogs(catalogList, catalogCode, childCatalogsList) {
      angular.forEach(catalogList, function (field) {
        if (catalogCode === field.ReferenceCatalogCode && angular.isDefined(field.Status) && field.Status === 1) {// only active child catalog
          childCatalogsList.push(field);
          getAllChildCatalogs(catalogList, field.id, childCatalogsList);
        }
      });
    }

    /**
     * @description
     * This method will remove selected chips form records (helper method)
     * @param {array} selectedRecords: list of selected chips
     * @param {array} records: data property of lookup-data
     * @returns {array}: list of available chips (chips which are not selected) // it does not really need to return a value but for readability returning modified value
     */
    function removeSelectedChips(selectedRecords, records) {
      if (angular.isDefined(selectedRecords) && selectedRecords.length > 0) {
        for (var index = records.length - 1; index >= 0; index--) {
          if (selectedRecords.indexOf(records[index].id) !== -1) {
            records.splice(index, 1);
          }
          if (selectedRecords.indexOf(records[index]) !== -1) {
            records.splice(index, 1);
          }
        }
      }
      return records;
    }

    function getChipDisplayValue(chip, fieldName) {
      var field = utility.filterObject(model.fields, { field: fieldName }, true)[0];
      var lookupModel = api.getModel(field.lookupSource);
      if (angular.isDefined(lookupModel.lookupData) && angular.isDefined(lookupModel.lookupData.data) && lookupModel.lookupData.data.length) {
        return getChipDisplayVal(lookupModel.lookupData, chip);
      }
      else { // it will never go to else part since before try to load display value for selected chips, it always load lookup on focus of chips input element
        return lookupPromises[field.field].then(function (lookupData) {
          return getChipDisplayVal(lookupData, chip);
        });
      }
    }

    //helper method
    function getChipDisplayVal(lookupData, chip) {
      var res = utility.filterObject(lookupData.data, { id: chip }, true);
      if (angular.isArray(res) && res.length > 0) {
        return res[0].value;
      }
      else {
        $log.warn('createArticlesBlocking controller: Unable to resolve chip display value!');
        return "";
      }
    }

    function getUniqueValuesFromMultiValueAttribute(multiValues) {
      var result = [];
      var uniqueValuesIndex = {};
      angular.forEach(multiValues, function (value) {
          if (angular.isUndefined(uniqueValuesIndex[value])) {
            // list the multuvalue attribues as single values
            var multiValueArray = value;
            angular.forEach(multiValueArray, function(item) {
                if(angular.isUndefined(uniqueValuesIndex[item])) {
                    uniqueValuesIndex[item] = true;
                    result.push(item);
                }
            });
          }
        });
        return result = $filter('orderBy')(result);
    }

  }
})();
(function () {
  'use strict';

  angular
    .module('app.main.catalogs.articles-blocking')
    .controller('affectedArticlesListController', affectedArticlesListController);

  /* @ngInject */
  function affectedArticlesListController($document, $mdDialog, api, toast, event, model, secondaryModel, data, record, catalogCode, action) {
    var vm = this;

    vm.data = data;
    vm.action = action;
    vm.model = model;
    vm.filteredData = [];
    vm.isLoading = false;

    vm.closeDialog = closeDialog;
    vm.saveRecord = saveRecord;

    activate();

    ////////////////

    function activate() {
      if (angular.isDefined(vm.tableControl) && angular.isDefined(vm.tableControl.updateData)) {
        vm.tableControl.updateData();
      }
    }

    function closeDialog(saved) {
      $mdDialog.hide(saved);
    }

    function saveRecord() {
      secondaryModel.methods.create(record, catalogCode);
      closeDialog(true);
    }

  }
})();
(function() {
    'use strict';

    angular
        .module('app.main.catalogs.articles')
        .controller('articlesListController', articlesListController);

    /* @ngInject */
    function articlesListController(api, $rootScope, $scope, $state, $document, $log, utility, catalogFactory, catalogSpecificArticlesModel,
        dialog, dataImporter, bulkUpdater, $mdDialog, crud, $q, settingsFactory, $filter, articlesFactory,
        SecurityFactory, linkedCatalogsArticleDynamicModel, catalogSpecificPricesModel, CONSTANTS) {
        /* jshint validthis: true */
        var vm = this;


        //Data
        var activeCatalog = catalogFactory.getActiveCatalog();
        var activeCatalogDetails = catalogFactory.getActiveCatalogDetails();
        var activeCatalogId = activeCatalog.CatalogCode;
        vm.activeCatalogId = activeCatalogId;
        vm.isLinePLanCatalog = activeCatalog.IsLinePlan;
        var isApplyRetailWindowPrivilegeIsAssigned = SecurityFactory.isAuthorized({accessPrivileges: CONSTANTS.PRIVILEGES.ARTICLES.UPDATE_ARTICLE_SHIPMENT_WINDOW});
        var restrictedRetailWindowOnRole = (angular.isDefined(api.roleBasedRestrictions.restrictedRetailWindow) && !utility.isObjectEmpty(api.roleBasedRestrictions.restrictedRetailWindow)) ? api.roleBasedRestrictions.restrictedRetailWindow : undefined;
        vm.model = catalogSpecificArticlesModel;
        settingsFactory.applyPersistedListViewLayout(vm.model);
        //Prices and segmentations fields are visible: false by default. making them visible: true for article list page
        angular.forEach(vm.model.fields, function(field) {
            if(field.catalogEntityId) {
                field.visible = true;
            }
        });
        // article number field will be non creatable and editable
        var isAutomaticNumberingEnabled = catalogFactory.getAutomaticNumbering();
        var sellerId = activeCatalog.AccountId;
        var attributeGroupId = activeCatalog.AttributeGroupId;
        // article drop reasons
        var articleDropReasonsList = api.articleDropReasonsList;
        // check the special privilege is assigned to the user for updating the state. if then does not vaidate editable fields
        var isSpecialPermissionToIgnoreArticleStateIsAssigned = SecurityFactory.isAuthorized({accessPrivileges: CONSTANTS.PRIVILEGES.ARTICLES.SPECIAL_PRIVILEGE_TO_SKIP_STATE_VALIDATION});
        var updateArticleChangeManagementExternalURL = '';

        //prices model
        vm.pricesModel = api.catalogs.prices;

        //segmentations model
        vm.segmentationsModel = api.catalogArticles.segmentation;

        vm.catalogSpecificPricesModelTransformed = catalogSpecificPricesModel;

        vm.articles = [];
        vm.filteredArticles = [];
        vm.allSelected = false;
        vm.isLoading = false;

        var linkedCatalogModelsData = [];
        var linkedCatalogArticleModel = linkedCatalogsArticleDynamicModel;
        if(angular.isDefined(linkedCatalogArticleModel)) {
            settingsFactory.applyPersistedListViewLayout(linkedCatalogArticleModel);
        }
        var linkedAttributes = activeCatalogDetails.LinkedAttributeList;
        var linePlanImportantAttributesList = [];



        //Methods
        vm.refreshItems = refreshItems;
        vm.doListAction = doListAction;
        vm.doItemAction = doItemAction;
        vm.viewItem = viewItem;
        vm.addRecord = addRecord;
        vm.addCarryOverArticles = addCarryOverArticles;
        vm.addCompArticles = addCompArticles;
        vm.assignArticlesOnMatserCatalog = assignArticlesOnMatserCatalog; // add life cycle articles


        activate();
        ////////////////

        function activate() {
            refreshItems(vm.model.baseModel.isDirty, true);

            // $state.current.data.displayName = 'LINE_PLANE.NAV';
            api.webGet('/app/app.config.json').then(function(response) {
                if (angular.isDefined(response) && angular.isDefined(response.data)) {
                    if (vm.isLinePLanCatalog === 1) {
                        if(angular.isDefined(response.data['LinePlanImportantAttributes']) && angular.isArray(response.data['LinePlanImportantAttributes'])) {
                            linePlanImportantAttributesList = response.data['LinePlanImportantAttributes'];
                        }
                    }
                    if(angular.isDefined(response.data['updateArticleChangeManagementExternalURL']) && response.data['updateArticleChangeManagementExternalURL'].length) {
                        updateArticleChangeManagementExternalURL = response.data['updateArticleChangeManagementExternalURL'];
                    }
                }
                if (vm.isLinePLanCatalog === 1) {
                    // removing calculated fields as calculated fields will not be responsible for highlighting the articles
                    if(linePlanImportantAttributesList.length > 0) {
                        for (var index = 0; index < vm.model.fields.length; index++) {
                            if (vm.model.fields[index].inputType === 'calculated' && linePlanImportantAttributesList.indexOf(vm.model.fields[index].field) > -1) {
                                linePlanImportantAttributesList.splice(linePlanImportantAttributesList.indexOf(vm.model.fields[index].field), 1);
                            }
                        }
                    }
                }
            });
        }

        function refreshItems(forceFetch, isLogRequired) {
            var generalProperties = {
                forceFetch: forceFetch,
                isLogRequired: isLogRequired,
                config: {},
                supportIncrementalResult: true,
                modelIdField: vm.model.idField,
                isMajor: true,
                isArticleRelatedData: true
            }
            if(api.enablePricesSegmentationsInArticlesList) {
                generalProperties.articlesPricesModel = vm.pricesModel;
                generalProperties.articlesSegmentationsModel = vm.segmentationsModel;
                generalProperties.isLinePlan = vm.isLinePLanCatalog;
            }

            vm.isLoading = true;
            // if retail window restricted on role hide article with invalid shipment window popup
            var isRestrictedRetailWindowOnRole = (angular.isDefined(api.roleBasedRestrictions.restrictedRetailWindow) && !utility.isObjectEmpty(api.roleBasedRestrictions.restrictedRetailWindow)) ? true : false;

            vm.model.methods.getList(generalProperties, vm.model, activeCatalogId).then(function (response) {
                vm.articles = response.data;
                if(vm.isLinePLanCatalog !== 1) {
                    //Transform articles data to list prices, segmentations and article states in the list
                    vm.articles = catalogFactory.transformArticlesResponse(vm.articles, vm.model.fields);
                }
                //on get list save the existing article numbers into a map for line plan catalogs
                if (vm.isLinePLanCatalog === 1) {
                    articlesFactory.createArticleNumberMap(vm.articles);
                    if (linkedCatalogModelsData && linkedCatalogModelsData.length == 0) {
                        // save the GetLinkedCatalogsModels data
                        getLinkedCatalogModelsData(true, false);
                    }
                }

                // for Inherited Catalog dont show not assorted articles articles if the UI_ViewUnAssortedArticles is not assigned.
                if(activeCatalog.DataSourceTypeId === 3 && !SecurityFactory.isAuthorized({accessPrivileges: CONSTANTS.PRIVILEGES.ARTICLES.LIST.VIEW_UNASSORTED_ARTICLES})) {
                    vm.articles = utility.filterInheritedArticlesObject(vm.articles);
                };

                for (var index = 0; index < vm.articles.length; index++) {
                    if (vm.isLinePLanCatalog != 1) {
                        //Control article locking based on active catalog flag ArticleLocking(by updating value of field 'isArticleLockingDisable' based on catalog flag)
                        vm.articles[index].isArticleLockingDisable = 1;
                        if(activeCatalog.ArticleLocking === 1 && vm.articles[index].Status === 1 && vm.articles[index].Locked === 0) {
                            vm.articles[index].isArticleLockingDisable = 0;
                        }
                        vm.articles[index].isPriceUpdateLocked = activeCatalog.ArticleLocking === 1 && vm.articles[index].Locked
                        // check IsArticleNumberEditable is enabled at Article State level and Primary Color is assigned then enable Overwrite Color actions
                        vm.articles[index].isOverwriteColorDisable = 0;
                        if(vm.articles[index].StateId != null && !isSpecialPermissionToIgnoreArticleStateIsAssigned) {
                            var assignedArticleState = utility.filterObject(api.articleStatesList, {StateId: vm.articles[index].StateId}, true)[0];
                            vm.articles[index].isOverwriteColorDisable = assignedArticleState.IsArticleNumberEditable && vm.articles[index].ColorId != null ? 1 : 0;
                        } else {
                            vm.articles[index].isOverwriteColorDisable = vm.articles[index].ColorId != null ? 1 : 0;
                        }
                    } else if ( vm.isLinePLanCatalog === 1 && linePlanImportantAttributesList.length > 0 ) {
                        for (var i = 0; i < linePlanImportantAttributesList.length; i++) {
                            if(vm.articles[index][linePlanImportantAttributesList[i]] == null || angular.isUndefined(vm.articles[index][linePlanImportantAttributesList[i]]) || vm.articles[index][linePlanImportantAttributesList[i]].toString().trim() === '') {
                                vm.articles[index]['warn'] = true;
                                break;
                            }
                        }
                    }
                }

                if (angular.isDefined(vm.tableControl) && angular.isDefined(vm.tableControl.updateData)) {
                    vm.tableControl.updateData();
                }
                if(activeCatalog.DataSourceTypeId !== 1 && activeCatalog.IsShippingWindowApply === 1
                    && SecurityFactory.isAuthorized({accessPrivileges: 'UpdateCatalogArticleDetails'}) && !isRestrictedRetailWindowOnRole) {
                    var containsInvalidShipmentRange = articlesFactory.validateArticleShippingRange(vm.articles);
                    if(containsInvalidShipmentRange) {
                        dialog.showAlertDialog(
                            angular.element($document.body),
                            $filter('translate')('MESSAGES.TITLE.ALERT'),
                            $filter('translate')('ARTICLES.MESSAGES.ARTICLE_WITH_INVALID_SHIPPING_RANGE'),
                            $filter('translate')('MESSAGES.TITLE.ALERT'),
                            $filter('translate')('ACTIONS.DIALOG_CLOSE'),
                            true,
                            null
                        );
                    }
                }
            })
            .finally(function () {
                vm.isLoading = false;
            });
        }

        //Item Action button pressed event
        function doItemAction(action, record) {
            if (action && record) {
                switch (action.id) {
                    case 'view':
                        viewItem(record);
                        break;
                    case 'edit':
                        if(activeCatalog.DataSourceTypeId === 1) {
                            vm.model.methods.getDetails(true, record.Id, vm.activeCatalogId)
                            .then(function (response) {
                                var transformedData = catalogFactory.transformArticlesResponse([response.data.Article], vm.model.fields)
                                editItem(transformedData[0], null);
                            });
                        } else {
                            editItem(record, null);
                        }
                        break;
                    case 'delete':
                    case 'unAssign':
                        if(vm.isLinePLanCatalog !== 1) {
                            var promise = {suggestedArticles: vm.model.methods.getArticlesWithSameSizes(activeCatalogId, record[vm.model.idField], activeCatalog.ArticleReplacementAttributeId)};
                            $mdDialog.show({
                                controller         : 'confirmDropController',
                                controllerAs       : 'vm',
                                templateUrl        : 'app/main/catalogs/sub-modules/articles/dialogs/confirm-drop/confirm-drop.html',
                                parent             : angular.element($document.body),
                                targetEvent        : null,
                                clickOutsideToClose: true,
                                locals             : {
                                    model : vm.model,
                                    record: record,
                                    actionObject: action,
                                    suggestedArticlesPromise: promise,
                                    dropReasons: activeCatalog.DataSourceTypeId !== 3 ? api.articleDropReasonsList : [] // show drop reasons only for master catalog
                                }
                            }).then(function(result) {
                                if(result !== 'cancel') {
                                    vm.model.methods.activateBulk(record, vm.model, action.id, activeCatalogId, result).then(function() {
                                        refreshItems(true, false);
                                    });
                                }
                            });
                        } else {
                            // show dropreasons popup if article drop reasons are added
                            if(articleDropReasonsList.length) {
                                $mdDialog.show({
                                    controller         : 'selectArticleDropReasonController',
                                    controllerAs       : 'vm',
                                    templateUrl        : 'app/main/catalogs/sub-modules/articles/dialogs/select-article-drop-reason/select-article-drop-reason.html',
                                    parent             : angular.element($document.body),
                                    targetEvent        : null,
                                    clickOutsideToClose: true,
                                    multiple: true,
                                    locals             : {
                                        dropReasons: api.articleDropReasonsList,
                                        articles: record,
                                        catalogId: activeCatalogId,
                                        articleReplacementAttributeId: activeCatalog.ArticleReplacementAttributeId
                                    }
                                }).then(function(result) {
                                    if(result !== 'cancel') {
                                        vm.model.methods.activateBulk(record, vm.model, action.id, activeCatalogId, result).then(function() {
                                            refreshItems(true, false);
                                        });
                                    }
                                });
                            } else {
                                vm.model.methods.activateBulk(record, vm.model, action.id, activeCatalogId).then(function() {
                                    refreshItems(true, false);
                                });
                            }
                        }
                        break;
                    case 'activate':
                        vm.model.methods.activateBulk(record, vm.model, action.id, activeCatalogId).then(function() {
                            refreshItems(true, false);
                        });
                        break;
                    case 'assign':
                        if(record['IsAccessible'] == 0) {// if already assigned
                            vm.model.methods.activateBulk(record, vm.model, action.id, activeCatalogId).then(function() {
                                refreshItems(true, false);
                            });
                        } else {
                            vm.model.methods.assignArticles(record, vm.model, activeCatalog);
                        }
                        break;
                    case 'lock':
                    case 'unlock':
                        vm.model.methods.updateLockStatus(record, vm.model, action.id, activeCatalogId);
                        refreshItems(true, false);
                        break;
                    case 'editReplacement':
                        updateArticleReplacement(record);
                        break;
                    case 'addSegmentation':
                        addSegmentation(record);
                        break;
                    case 'AddPrice':
                        addPrice(record);
                        break;
                    case 'manageArticleStates':
                        var modelCopy = angular.copy(vm.model);
                        var stateIdField = utility.filterObject(modelCopy.fields, {field:'StateId'}, true)[0];
                        if(stateIdField) {
                            stateIdField.editable = true;
                        }
                        var sizeScaleIdField = utility.filterObject(modelCopy.fields, {field:'SizeScaleId', inputType: 'lookup'}, true)[0];
                        if(sizeScaleIdField) {
                            sizeScaleIdField.editable = true;
                        }
                        var masterSizeScaleIdField = utility.filterObject(modelCopy.fields, {field:'MasterSizeScaleId', inputType: 'lookup'}, true)[0];
                        if(masterSizeScaleIdField) {
                            masterSizeScaleIdField.editable = true;
                        }
                        // set all other attributes editable false
                        modelCopy.fields.forEach(function(field) {
                            if (field.field !== "StateId" && field.field !== "SizeScaleId" && field.field !== "ColorId" && field.field !== "MasterSizeScaleId") {
                                field.editable = false;
                                field.showInEdit = false;
                            }
                        });

                        var lookupPromises = {};
                        lookupPromises = crud.createLookupPromise(modelCopy, undefined , 'edit');
                        $mdDialog.show({
                            controller         : 'manageArticlesStateController',
                            controllerAs       : 'vm',
                            templateUrl        : 'app/main/catalogs/sub-modules/articles/dialogs/manage-articles-state/manage-articles-state.html',
                            parent             : angular.element($document.body),
                            targetEvent        : null,
                            clickOutsideToClose: false,
                            multiple           : true,
                            locals             : {
                                model: vm.model,
                                articles : [record],
                                catalogCode : vm.activeCatalogId,
                                lookupPromises: lookupPromises,
                                event: null
                            }
                        })
                        .then(function(saved) {
                            if(saved) {
                                refreshItems(true, false);
                            }
                        });
                        break;
                    case 'overwriteColor':
                        overwriteColor(record);
                        break;
                }
            }
        }

        //List Action button pressed event
        function doListAction(action, records) {
            if (action) {
                var sizeScaleGroupsPromise, modelCopy, modelNumberField;
                switch (action.id) {
                    case 'activate':
                        vm.model.methods.activateBulk(records, vm.model, action.id, activeCatalogId).then(function() {
                            refreshItems(true, false);
                        });
                        break;
                    case 'delete':
                    case 'unAssign':
                        // show dropreasons popup if article drop reasons are added for master catalog
                        if(articleDropReasonsList.length && activeCatalog.DataSourceTypeId !== 3) {
                            $mdDialog.show({
                                controller         : 'selectArticleDropReasonController',
                                controllerAs       : 'vm',
                                templateUrl        : 'app/main/catalogs/sub-modules/articles/dialogs/select-article-drop-reason/select-article-drop-reason.html',
                                parent             : angular.element($document.body),
                                targetEvent        : null,
                                clickOutsideToClose: true,
                                multiple: true,
                                locals             : {
                                    dropReasons: api.articleDropReasonsList,
                                    articles: records,
                                    catalogId: activeCatalogId,
                                    articleReplacementAttributeId: activeCatalog.ArticleReplacementAttributeId
                                }
                            }).then(function(result) {
                                if(result !== 'cancel') {
                                    vm.model.methods.activateBulk(records, vm.model, action.id, activeCatalogId, result).then(function() {
                                        refreshItems(true, false);
                                    });
                                }
                            });
                        } else {
                            vm.model.methods.activateBulk(records, vm.model, action.id, activeCatalogId).then(function() {
                                refreshItems(true, false);
                            });
                        }
                        break;
                    case 'assign':
                        vm.model.methods.assignArticles(records, vm.model, activeCatalog);
                        break;
                    case 'lock':
                    case 'unlock':
                        vm.model.methods.updateLockStatus(records, vm.model, action.id, activeCatalogId);
                        refreshItems(true, false);
                        break;
                    case 'import':
                        modelCopy = angular.copy(vm.model);
                        utility.filterObject(modelCopy.fields, {field: 'Status'}, true)[0].creatable = true;
                        if(activeCatalog.DataSourceTypeId === 3) {
                            modifyInheritedModelForImport(modelCopy);
                        } else {
                            // enable Drop Reason column for mapping as an optional field
                            var dropReasonField = utility.filterObject(modelCopy.fields, {field: 'DropReason'}, true)[0];
                            dropReasonField.creatable = true;
                            // make the DropReason column mandatory while validation(id status o) and not mandatory while mapping
                            dropReasonField.validation.isRequiredWhileValidating = true;
                            dropReasonField.validation.dataExistConstraints = { data: articleDropReasonsList };
                            dropReasonField.validation.dataExistConstraints['model'] = {};
                            dropReasonField.validation.dataExistConstraints['model']['lookupDisplayField'] = 'Reason';
                        }

                        // if automatic article numbering is enabled remove article number and model number field
                        // and add ArticleId and ModelId as optional fields(User should enter the id's in excel file)
                        if(isAutomaticNumberingEnabled) {
                            var articleNumberField = utility.filterObject(modelCopy.fields, {field: 'ArticleNumber'}, true)[0];
                            if(angular.isDefined(articleNumberField)) {
                                articleNumberField.creatable = true;
                                if(activeCatalog.DataSourceTypeId == 3) {
                                    articleNumberField.validation.isRequired = true;
                                } else {
                                    articleNumberField.validation.isRequired = false;
                                    articleNumberField.validation.minLen = 0;
                                }
                            }
                            var modelNumberField = utility.filterObject(modelCopy.fields, {field: 'ModelNumber'}, true)[0];
                            if(angular.isDefined(modelNumberField)) {
                                modelNumberField.creatable = true;
                                modelNumberField.validation.minLen = 0;
                            }
                            modelCopy.uniqueConstraints = [];
                        }
                        // make ParentModelNumber creatable
                        var parentModelTypeField = utility.filterObject(modelCopy.fields, {field: 'parent_model_type'}, true)[0];
                        if(parentModelTypeField && parentModelTypeField.creatable) {
                            // make ParentModelNumber creatable
                            var parentModelNumberField = utility.filterObject(modelCopy.fields, {field: 'ParentModelNumber'}, true)[0];
                            if(angular.isDefined(parentModelNumberField)) {
                                parentModelNumberField.creatable = true;
                            }
                        }

                        // if configured model name length then change the allowed max length to the configured value
                        var configuredModelNameLength = catalogFactory.getModelNameLength();
                        if(configuredModelNameLength !== 100) {
                            var articleNameField = utility.filterObject(modelCopy.fields, {field: 'ArticleName'}, true)[0];
                            articleNameField.validation.maxLen = configuredModelNameLength;
                        }

                        var modelIdField = utility.filterObject(modelCopy.fields, {field: 'ModelId'}, true)[0];
                        modelIdField.creatable = false;

                        // make Shipment Range Field creatable when "DummyArticleApplyRetailWindow" privilege is assigned
                        if(isApplyRetailWindowPrivilegeIsAssigned && activeCatalog.IsShippingWindowApply == 1) {
                            if((angular.isDefined(restrictedRetailWindowOnRole) && !restrictedRetailWindowOnRole.notEditable) || (angular.isUndefined(restrictedRetailWindowOnRole))) {
                                var retailIntroMonthField = utility.filterObject(modelCopy.fields, {field: 'RetailIntroMonthId', inputType: 'lookup'}, true)[0];
                                var retailExitMonthField = utility.filterObject(modelCopy.fields, {field: 'RetailExitMonthId', inputType: 'lookup'}, true)[0];
                                retailIntroMonthField.creatable = true;
                                retailIntroMonthField.validation.isRequired = true;
                                retailExitMonthField.creatable = true;
                                retailExitMonthField.validation.isRequired = true;
                            }
                        }
                        // make LinkedCatalogArticleNumber type attributes not creatable through import
                        var linkedArticleNumberFields = utility.filterObject(modelCopy.fields, {inputType:'linkedcatalogarticlenumber'}, true);
                        angular.forEach(linkedArticleNumberFields, function(linkedArticleNumberField) {
                            linkedArticleNumberField.creatable = false;
                        });

                        // primary color is not updatable by child catalog
                        if(activeCatalog.DataSourceTypeId === 3) {
                            var colorIdField = utility.filterObject(modelCopy.fields, {field: 'ColorId'}, true)[0];
                            if(angular.isDefined(colorIdField)) {
                                colorIdField.creatable = false;
                            }
                        }

                        // make lookuptable type attributes not creatable through import we are not allowing user to map it and will calculate the value internally and send it
                        var lookupTableFields = utility.filterObject(modelCopy.fields, {inputType:'lookup-table'}, true);
                        angular.forEach(lookupTableFields, function(lookupTableField) {
                            lookupTableField.creatable = false;
                        });
                        modelCopy.validateRequiredLookupTableAttributes = true;

                        // make datatable type attributes not creatable through import
                        var dataTableFields = utility.filterObject(modelCopy.fields, {inputType:'datatable'}, true);
                        angular.forEach(dataTableFields, function(dataTableField) {
                            dataTableField.creatable = false;
                        });

                        // add StateName as Ceate In
                        var stateField = utility.filterObject(modelCopy.fields, {field: 'StateName'}, true)[0];
                        stateField.creatable = true;
                        var articleStatePromise = api.catalogs.articleStates.methods.getList({forceFetch: true, isLogRequired: true}, sellerId, attributeGroupId);
                        stateField.validation.dataExistConstraints = { promise: articleStatePromise };
                        var masterSizeScaleField = utility.filterObject(modelCopy.fields, { field: 'MasterSizeScale' }, true)[0];
                        masterSizeScaleField.creatable = true;
                        var masterSizeScalesPromise = api.sellers.masterSizeScales.methods.getList(undefined, {forceFetch: true, isLogRequired: true}, sellerId);
                        masterSizeScaleField.validation.dataExistConstraints = { promise: masterSizeScalesPromise, model: api.sellers.masterSizeScales };
                        var sizeScaleField = utility.filterObject(modelCopy.fields, {field: 'SizeScale'}, true)[0];
                        sizeScaleField.creatable = true;
                        var sizeScaleGroupsPromise = api.sellers.sizeScaleGroups.methods.getList(undefined, {forceFetch: true, isLogRequired: true}, sellerId);
                        sizeScaleField.validation.dataExistConstraints = { promise: sizeScaleGroupsPromise };

                        dataImporter.importExcel(modelCopy, true, {}, action.id).then(function(result) {
                            vm.model.methods.createBulk(vm.model, result.data, activeCatalogId);
                        });
                        break;
                    case 'updateBulk':
                        var isArticleCountWithinLimit = true;
                        if(api.articlesLimitForBackgroundJobs > 0 && records.length > api.articlesLimitForBackgroundJobs) {
                            isArticleCountWithinLimit = false;
                        }
                        if(isArticleCountWithinLimit) {
                            modelCopy = angular.copy(vm.model);
                            modelNumberField = utility.filterObject(modelCopy.fields, {field: 'ModelNumber'}, true)[0];
                            modelNumberField.editable = false;
                            // assign all the model level attributes as editable false
                            angular.forEach(modelCopy.fields, function(field) {
                                if(field.isModelLevelAttribute && !field.isBulkEditable) {
                                    field.showInEdit = false;
                                    field.editable = false;
                                }
                            });
                            // if automatic article numbering is enabled make model id and color non editable
                            if(isAutomaticNumberingEnabled) {
                                var modelIdField = utility.filterObject(modelCopy.fields, {field: 'ModelId'}, true)[0];
                                if(angular.isDefined(modelIdField)) {
                                    modelIdField.editable = false;
                                    modelIdField.showInEdit = false;
                                }
                                var colorIdField = utility.filterObject(modelCopy.fields, {field: 'ColorId'}, true)[0];
                                if(angular.isDefined(colorIdField)) {
                                    colorIdField.editable = false;
                                    colorIdField.showInEdit = false;
                                }
                            }

                            // we will find out the states with height article state rank and height model state rank
                            // if the attribute is article level then apply the validation from height state ranked article state
                            // if the attribute is model level then apply the validation from the height model state ranked article state
                            if(!isSpecialPermissionToIgnoreArticleStateIsAssigned) {
                                var highestArticleStateRankStateId = articlesFactory.getHighestArticleStateRankStateId(records);
                                if(highestArticleStateRankStateId !== 0) {
                                    var assignedArticleState = utility.filterObject(api.articleStatesList, {StateId: highestArticleStateRankStateId}, true)[0];
                                    if(assignedArticleState && assignedArticleState.NonEditableAttributes.length) {
                                        angular.forEach(assignedArticleState.NonEditableAttributes, function(attribute) {
                                            var nonEditableArticleAttrField = utility.filterObject(modelCopy.fields, {field: attribute.AttributeSystemName, isModelLevelAttribute: false}, true)[0];
                                            if(angular.isDefined(nonEditableArticleAttrField)) {
                                                nonEditableArticleAttrField.editable = false;
                                                nonEditableArticleAttrField.showInEdit = true;
                                                nonEditableArticleAttrField.isBulkEditable = false;
                                                nonEditableArticleAttrField['isAllowChangeRequestEnabled'] = attribute.AllowChangeRequest;
                                                if(attribute.AllowChangeRequest) {
                                                    nonEditableArticleAttrField['updateArticleChangeManagementExternalURL'] = updateArticleChangeManagementExternalURL;
                                                }
                                            }
                                        });
                                    }
                                }
                                var highestModelStateRankStateId = articlesFactory.getHighestModelStateRankStateId(records);
                                if(highestModelStateRankStateId !== 0) {
                                    var assignedModelState = utility.filterObject(api.articleStatesList, {StateId: highestModelStateRankStateId}, true)[0];
                                    if(assignedModelState && assignedModelState.NonEditableAttributes.length) {
                                        angular.forEach(assignedModelState.NonEditableAttributes, function(attribute) {
                                            var nonEditableModelAttrField = utility.filterObject(modelCopy.fields, {field: attribute.AttributeSystemName, isModelLevelAttribute: true}, true)[0];
                                            if(angular.isDefined(nonEditableModelAttrField)) {
                                                nonEditableModelAttrField.editable = false;
                                                nonEditableModelAttrField.showInEdit = true;
                                                nonEditableModelAttrField.isBulkEditable = false;
                                                nonEditableModelAttrField['isAllowChangeRequestEnabled'] = attribute.AllowChangeRequest;
                                                if(attribute.AllowChangeRequest) {
                                                    nonEditableModelAttrField['updateArticleChangeManagementExternalURL'] = updateArticleChangeManagementExternalURL;
                                                }
                                            }
                                        });
                                    }
                                }
                            }

                            // make datatable type attributes not creatable through import
                            var dataTableFields = utility.filterObject(modelCopy.fields, {inputType:'datatable'}, true);
                            angular.forEach(dataTableFields, function(dataTableField) {
                                dataTableField.editable = false;
                            });
                            var lookupPromises = {};
                            lookupPromises = crud.createLookupPromise(modelCopy, undefined , 'edit');
                            bulkUpdater.showDialog(modelCopy, vm.articles, {'catalogId': activeCatalogId}, lookupPromises)
                            .then(function(response) {
                                if(angular.isDefined(response) && response.toString() != 'false') {
                                    for(var key in response.propertiesToUpdate) {
                                        if(response.propertiesToUpdate.hasOwnProperty(key)) {
                                            var multiValueAttribute = utility.filterObject(modelCopy.fields, {field: key}, true)[0];
                                            if (angular.isDefined(multiValueAttribute) && multiValueAttribute.inputType === 'multi-value') {
                                                var multiValue = response.propertiesToUpdate[key];
                                                response.propertiesToUpdate[key] = multiValue;
                                            }
                                        }
                                    }

                                    vm.model.methods.updateBulk(vm.model, response.selectedRecords, response.propertiesToUpdate, response.idMap);
                                    if(activeCatalog.IsShippingWindowApply == 1 && activeCatalog.DataSourceTypeId === 3) {
                                        dialog.showAlertDialog(
                                            angular.element($document.body),
                                            $filter('translate')('MESSAGES.TITLE.ALERT'),
                                            $filter('translate')('ARTICLES.MESSAGES.INVALID_SHIPMENTWINDOW_RANGE'),
                                            $filter('translate')('MESSAGES.TITLE.ALERT'),
                                            $filter('translate')('ACTIONS.DIALOG_CLOSE'),
                                            true,
                                            null
                                        );
                                    }
                                }
                            });
                        }
                        else {
                            dialog.showAlertDialog(
                                angular.element($document.body),
                                $filter('translate')('MESSAGES.TITLE.ALERT'),
                                $filter('translate')('ARTICLES.MESSAGES.SHOW_ARTICLE_BACKGROUND_JOB_LIMIT_WARNING'),
                                $filter('translate')('MESSAGES.TITLE.ALERT'),
                                $filter('translate')('ACTIONS.DIALOG_CLOSE'),
                                true,
                                null
                            );
                        }
                        break;
                    case 'updateViaImport':
                        modelCopy = angular.copy(vm.model);
                        modelNumberField = utility.filterObject(modelCopy.fields, {field: 'ModelNumber'}, true)[0];
                        modelNumberField.creatable = false;
                        var modelIdField = utility.filterObject(modelCopy.fields, {field: 'ModelId'}, true)[0];
                        modelIdField.creatable = false;
                        //always make articleNumber field creatable for updateViaImport action so user will be able to map a field from excel file
                        var articleNumberField = utility.filterObject(modelCopy.fields, {field:'ArticleNumber'}, true)[0];
                        articleNumberField.creatable = true;
                        // make all attributes none mandatory field, remove article name field
                        var articleNameField = utility.filterObject(modelCopy.fields, {field:'ArticleName'}, true)[0];
                        articleNameField.creatable = false;
                        var parentModelTypeField = utility.filterObject(modelCopy.fields, {field: 'parent_model_type'}, true)[0];
                        if(parentModelTypeField && parentModelTypeField.creatable) {
                            // make ParentModelNumber creatable
                            var parentModelNumberField = utility.filterObject(modelCopy.fields, {field: 'ParentModelNumber'}, true)[0];
                            if(angular.isDefined(parentModelNumberField)) {
                                parentModelNumberField.creatable = true;
                            }
                        }
                        angular.forEach(modelCopy.fields, function(field) {
                            if(field.isDynamicProperty) {
                                field.validation.isRequiredIfMapped = field.validation.isRequired;
                                field.validation.isRequired = false;
                            }
                            if (field.inputType === 'linkedcatalogarticlenumber' || field.inputType === 'lookup-table') {
                                field.creatable = false;
                            }
                        });
                        if(activeCatalog.DataSourceTypeId == 3) {
                            modifyInheritedModelForImport(modelCopy);
                        }

                        // make Shipment Range Field creatable when "DummyArticleApplyRetailWindow" privilege is assigned
                        if( isApplyRetailWindowPrivilegeIsAssigned && activeCatalog.IsShippingWindowApply == 1) {
                            if((angular.isDefined(restrictedRetailWindowOnRole) && !restrictedRetailWindowOnRole.notEditable) || (angular.isUndefined(restrictedRetailWindowOnRole))) {
                                var retailIntroMonthField = utility.filterObject(modelCopy.fields, {field: 'RetailIntroMonthId', inputType: 'lookup'}, true)[0];
                                var retailExitMonthField = utility.filterObject(modelCopy.fields, {field: 'RetailExitMonthId', inputType: 'lookup'}, true)[0];
                                retailIntroMonthField.creatable = true;
                                retailExitMonthField.creatable = true;
                            }
                        }

                        // primary color is not updatable by child catalog
                        if(activeCatalog.DataSourceTypeId === 3) {
                            var colorIdField = utility.filterObject(modelCopy.fields, {field: 'ColorId'}, true)[0];
                            if(angular.isDefined(colorIdField)) {
                                colorIdField.creatable = false;
                            }
                        }
                        // make datatable type attributes not creatable through import
                        var dataTableFields = utility.filterObject(modelCopy.fields, {inputType:'datatable'}, true);
                        angular.forEach(dataTableFields, function(dataTableField) {
                            dataTableField.creatable = false;
                        });
                        modelCopy.validateRequiredLookupTableAttributes = true;

                        dataImporter.importExcel(modelCopy, true, {}, action.id).then(function(result) {
                            vm.model.methods.updateViaImport(vm.model, result.data, activeCatalog);
                        });
                        break;
                    case 'setSegmentations':
                        var propertiesMapper = [{target: 'field', source: 'field["Id"]+field["Name"]'}, {target: 'importField', source: 'field["Name"]'}, {target: 'displayLabel', source: 'field["Name"]'}],
                            inputType = 'switch',
                            nestedArrayName = 'Segmentations',
                            //dummy value since the value for each column in segmentations depend on existence of the object in get all the articles segmentation
                            valueMapper = 'Id',
                            targetModel = 'catalogArticles.segmentation',
                            sourceModel = 'catalogs.segmentations';
                        var articlesSegmentationModelPromise = catalogFactory.createDynamicModel(targetModel, sourceModel, propertiesMapper, inputType, nestedArrayName, valueMapper);
                        $q.when(articlesSegmentationModelPromise).then(function(articlesSegmentationModel) {
                            var lookupPromises = {};
                            lookupPromises = crud.createLookupPromise(articlesSegmentationModel, undefined , 'edit');
                            bulkUpdater.showDialog(articlesSegmentationModel, records, {
                                'catalogId'			          : activeCatalogId,
                                'segmentationGroupList'       : utility.filterObject(catalogFactory.getActiveCatalogDetails().SegmentationGroupList, { Status: 1 }),
                                'isSegmentationPlanningEnable': activeCatalog.SegmentationPlanningEnable,
                                'parentModel'                 : vm.model
                            }, lookupPromises);
                        });
                        break;
                    case 'importLinePlan':
                        var modelCopy = angular.copy(vm.model);
                        utility.filterObject(modelCopy.fields, {field: 'Status'}, true)[0].creatable = true;
                        var articleNumberField = utility.filterObject(modelCopy.fields, { field: 'ArticleNumber' }, true)[0];
                        articleNumberField.creatable = true;
                        articleNumberField.validation.isRequired = false;
                        angular.forEach(modelCopy.fields, function(field) {
                            if(field.inputType === 'linkedcatalogarticlenumber' || field.inputType === 'lookup-table') {
                                field.creatable = false;
                            }
                        });
                        modelCopy.validateRequiredLookupTableAttributes = true;

                        dataImporter.importExcel(modelCopy, true).then(function(result) {
                            vm.model.methods.importLinePlans(vm.model, result.data, activeCatalogId, vm.articles, linkedAttributes || []);
                        });
                        break;
                    case 'updateBulkLinePlan':
                        modelCopy = angular.copy(vm.model);
                        utility.filterObject(modelCopy.fields, {field: 'ModelNumber'}, true)[0].editable = false;
                        utility.filterObject(modelCopy.fields, { field: 'ArticleNumber' }, true)[0].editable = false;
                        var lookupPromises = {};
                        lookupPromises = crud.createLookupPromise(modelCopy, undefined , 'edit');
                        bulkUpdater.showDialog(modelCopy, vm.articles, {'catalogId': activeCatalogId}, lookupPromises)
                            .then(function(response) {
                                if(angular.isDefined(response) && response.toString() != 'false') {
                                    vm.model.methods.updateBulkLinePlans(vm.model, response.selectedRecords, response.propertiesToUpdate, activeCatalogId);
                                }
                            });
                        break;
                    case 'updateViaImportModel':
                        var modelCopy = angular.copy(vm.model);

                        angular.forEach(modelCopy.fields, function(field) {
                            // Handle fields that are not model-level attributes
                            if (!field.isModelLevelAttribute || field.inputType === 'linkedcatalogarticlenumber' || field.inputType === 'lookup-table') {
                                field.validation.isRequired = false;
                                field.editable = false;
                            } else if (field.isModelLevelAttribute && field.editable && field.AttributeSource.toUpperCase() === 'SELF') {
                                field.validation.isRequiredIfMapped = field.validation.isRequired;
                                field.validation.isRequired = false;
                            }

                            // Ensure ModelNumber is editable and required
                            if (field.field === 'ModelNumber') {
                                field.editable = true;
                                field.validation.isRequired = true;
                            }

                            // Make ParentModelNumber editable if parent_model_type is editable
                            if (field.field === 'parent_model_type' && field.editable) {
                                var parentModelNumberField = utility.filterObject(modelCopy.fields, { field: 'ParentModelNumber' }, true)[0];
                                if (parentModelNumberField) {
                                    parentModelNumberField.editable = true;
                                }
                            }
                        });

                        // Set unique constraints and validation
                        modelCopy.uniqueConstraints = [{ name: 'Constraint 1', fields: ['ModelNumber'] }];
                        modelCopy.validateRequiredLookupTableAttributes = true;
                        // make datatable type attributes not creatable through import
                        var dataTableFields = utility.filterObject(modelCopy.fields, {inputType:'datatable'}, true);
                        angular.forEach(dataTableFields, function(dataTableField) {
                            dataTableField.creatable = false;
                        });

                        // Import Excel data
                        dataImporter.importExcel(modelCopy, false, { isUpdateArticlesByModel: true }, action.id)
                            .then(function(result) {
                                vm.model.methods.updateViaImportModel(vm.model, result.data, activeCatalog);
                            });
                        break;
                    case 'editModelAttributes':
                        var isArticleCountWithinLimit = true;
                        if(api.articlesLimitForBackgroundJobs > 0 && records.length > api.articlesLimitForBackgroundJobs) {
                            isArticleCountWithinLimit = false;
                        }
                        if(isArticleCountWithinLimit) {
                            var modelCopy = angular.copy(vm.model);
                            // only model level attributes which are configured as editable will be shown in the UI
                            angular.forEach(modelCopy.fields, function(field) {
                                if(field.editable && !field.isModelLevelAttribute) {
                                    field.editable = false;
                                } else if(field.isModelLevelAttribute && field.isBulkEditable && field.AttributeSource.toUpperCase() === 'SELF') {
                                    field.editable = true;
                                    field.validation.disabledCriteria = false;
                                }
                            });

                            if(activeCatalog.DataSourceTypeId === 3) {
                                var parentModelTypeField = utility.filterObject(modelCopy.fields, {field: 'parent_model_type'}, true)[0];
                                if(parentModelTypeField) {
                                    parentModelTypeField.editable = false;
                                }
                            }

                            // we will find out the states with height model state rank as this form will have only model level attributes
                            if(!isSpecialPermissionToIgnoreArticleStateIsAssigned) {
                                var highestModelStateRankStateId = articlesFactory.getHighestModelStateRankStateId(records);
                                if(highestModelStateRankStateId !== 0) {
                                    var assignedModelState = utility.filterObject(api.articleStatesList, {StateId: highestModelStateRankStateId}, true)[0];
                                    if(assignedModelState && assignedModelState.NonEditableAttributes.length) {
                                        angular.forEach(assignedModelState.NonEditableAttributes, function(attribute) {
                                            var nonEditableModelAttrField = utility.filterObject(modelCopy.fields, {field: attribute.AttributeSystemName, isModelLevelAttribute: true}, true)[0];
                                            if(angular.isDefined(nonEditableModelAttrField)) {
                                                nonEditableModelAttrField.editable = false;
                                                nonEditableModelAttrField.showInEdit = true;
                                                nonEditableModelAttrField.isBulkEditable = false;
                                                nonEditableModelAttrField['isAllowChangeRequestEnabled'] = attribute.AllowChangeRequest;
                                                if(attribute.AllowChangeRequest) {
                                                    nonEditableModelAttrField['updateArticleChangeManagementExternalURL'] = updateArticleChangeManagementExternalURL;
                                                }
                                            }
                                        });
                                    }
                                }
                            }
                            // make datatable type attributes not creatable through import
                            var dataTableFields = utility.filterObject(modelCopy.fields, {inputType:'datatable'}, true);
                            angular.forEach(dataTableFields, function(dataTableField) {
                                dataTableField.editable = false;
                            });
                            // change dialog title to "Edit Model Attributes"
                            modelCopy.title = 'ARTICLES.TITLES.MODEL_ATTRIBUTES';
                            var lookupPromises = {};
                            lookupPromises = crud.createLookupPromise(modelCopy, undefined , 'edit');
                            bulkUpdater.showDialog(modelCopy, vm.articles, {'catalogId': activeCatalogId}, lookupPromises)
                                .then(function(response) {
                                    if(angular.isDefined(response) && response.toString() != 'false') {
                                        for(var key in response.propertiesToUpdate) {
                                            if(response.propertiesToUpdate.hasOwnProperty(key)) {
                                                var multiValueAttribute = utility.filterObject(modelCopy.fields, {field: key}, true)[0];
                                                if (angular.isDefined(multiValueAttribute) && multiValueAttribute.inputType === 'multi-value') {
                                                    var multiValue = response.propertiesToUpdate[key];
                                                    response.propertiesToUpdate[key] = multiValue;
                                                }
                                            }
                                        }
                                        vm.model.methods.editModelAttributes(vm.model, response.selectedRecords, response.propertiesToUpdate, response.idMap);
                                    }
                                });
                        }
                        else {
                            dialog.showAlertDialog(
                                angular.element($document.body),
                                $filter('translate')('MESSAGES.TITLE.ALERT'),
                                $filter('translate')('ARTICLES.MESSAGES.SHOW_ARTICLE_BACKGROUND_JOB_LIMIT_WARNING'),
                                $filter('translate')('MESSAGES.TITLE.ALERT'),
                                $filter('translate')('ACTIONS.DIALOG_CLOSE'),
                                true,
                                null
                            );
                        }
                        break;
                    case 'updateViaImportLinePlan':
                        modelCopy = angular.copy(vm.model);
                        modelNumberField = utility.filterObject(modelCopy.fields, {field: 'ModelNumber'}, true)[0];
                        modelNumberField.creatable = false;
                        //always make articleNumber field creatable for updateViaImport action so user will be able to map a field from excel file
                        var articleNumberField = utility.filterObject(modelCopy.fields, {field:'ArticleNumber'}, true)[0];
                        articleNumberField.creatable = true;
                        // make all attributes none mandatory field, remove article name field
                        var articleNameField = utility.filterObject(modelCopy.fields, {field:'ArticleName'}, true)[0];
                        articleNameField.creatable = false;
                        angular.forEach(modelCopy.fields, function(field) {
                            if(field.isDynamicProperty) {
                                field.validation.isRequired = false;
                            }
                            if(field.inputType === 'linkedcatalogarticlenumber' || field.inputType === 'lookup-table') {
                                field.creatable = false;
                            }
                        });
                        modelCopy.validateRequiredLookupTableAttributes = true;

                        dataImporter.importExcel(modelCopy, true).then(function(result) {
                            vm.model.methods.updateViaImport(vm.model, result.data, activeCatalog);
                        });
                        break;
                    case 'manageArticleStates':
                        // API supports only 15000 records at a time if user select more that 15k show error popup
                        if(records.length <= 15000) {
                            var modelCopy = angular.copy(vm.model);
                            var stateIdField = utility.filterObject(modelCopy.fields, {field:'StateId'}, true)[0];
                            if(stateIdField) {
                                stateIdField.editable = true;
                            }
                            var sizeScaleIdField = utility.filterObject(modelCopy.fields, {field:'SizeScaleId', inputType: 'lookup'}, true)[0];
                            if(sizeScaleIdField) {
                                sizeScaleIdField.editable = true;
                            }
                            var masterSizeScaleIdField = utility.filterObject(modelCopy.fields, {field:'MasterSizeScaleId', inputType: 'lookup'}, true)[0];
                            if(masterSizeScaleIdField) {
                                masterSizeScaleIdField.editable = true;
                            }
                            // set all other attributes editable false
                            modelCopy.fields.forEach(function(field) {
                                if (field.field !== "StateId" && field.field !== "SizeScaleId" && field.field !== "ColorId" && field.field !== "MasterSizeScaleId") {
                                    field.editable = false;
                                    field.showInEdit = false;
                                }
                            });
                            var lookupPromises = {};
                            lookupPromises = crud.createLookupPromise(modelCopy, undefined , 'edit');
                            $mdDialog.show({
                                controller         : 'manageArticlesStateController',
                                controllerAs       : 'vm',
                                templateUrl        : 'app/main/catalogs/sub-modules/articles/dialogs/manage-articles-state/manage-articles-state.html',
                                parent             : angular.element($document.body),
                                targetEvent        : null,
                                clickOutsideToClose: false,
                                multiple           : true,
                                locals             : {
                                    model: vm.model,
                                    articles : records,
                                    catalogCode : vm.activeCatalogId,
                                    lookupPromises: lookupPromises,
                                    event: null
                                }
                            })
                            .then(function(saved) {
                                if(saved) {
                                    refreshItems(true, false);
                                }
                            });
                        } else {
                            dialog.showAlertDialog(
                                angular.element($document.body),
                                $filter('translate')('MESSAGES.TITLE.ALERT'),
                                $filter('translate')('ARTICLES.MESSAGES.EXCEEDS_ARTICLE_STATES_LIMIT'),
                                $filter('translate')('MESSAGES.TITLE.ALERT'),
                                $filter('translate')('ACTIONS.DIALOG_CLOSE'),
                                true,
                                null
                            );
                        }
                        break;
                    case 'importByLicensee':
                        modelCopy = angular.copy(vm.model);
                        utility.filterObject(modelCopy.fields, {field: 'Status'}, true)[0].creatable = true;
                        if(activeCatalog.DataSourceTypeId == 3) {
                            modifyInheritedModelForImport(modelCopy);
                        } else {
                            // enable Drop Reason column for mapping as an optional field
                            var dropReasonField = utility.filterObject(modelCopy.fields, {field: 'DropReason'}, true)[0];
                            dropReasonField.creatable = true;
                            // make the DropReason column mandatory while validation and not mandatory while mapping
                            dropReasonField.validation.isRequiredWhileValidating = true;
                            dropReasonField.validation.dataExistConstraints = { data: articleDropReasonsList };
                            dropReasonField.validation.dataExistConstraints['model'] = {};
                            dropReasonField.validation.dataExistConstraints['model']['lookupDisplayField'] = 'Reason';
                        }
                        modelCopy.validateStateEditableFields = false;

                        // if automatic article numbering is enabled remove article number and model number field
                        // and add ArticleId and ModelId as optional fields(User should enter the id's in excel file)
                        if(isAutomaticNumberingEnabled) {
                            var articleNumberField = utility.filterObject(modelCopy.fields, {field: 'ArticleNumber'}, true)[0];
                            if(angular.isDefined(articleNumberField)) {
                                articleNumberField.creatable = false;
                            }
                            var modelNumberField = utility.filterObject(modelCopy.fields, {field: 'ModelNumber'}, true)[0];
                            if(angular.isDefined(modelNumberField)) {
                                modelNumberField.creatable = false;
                            }
                            var articleIdField = utility.filterObject(modelCopy.fields, {field: 'ArticleId'}, true)[0];
                            if(angular.isDefined(articleIdField)) {
                                articleIdField.creatable = false;
                            }
                            var modelIdField = utility.filterObject(modelCopy.fields, {field: 'ModelId', inputType: 'number'}, true)[0];
                            if(angular.isDefined(modelIdField)) {
                                modelIdField.creatable = false;
                            }
                        }
                        // if configured model name length then change the allowed max length to the configured value
                        var configuredModelNameLength = catalogFactory.getModelNameLength();
                        if(configuredModelNameLength !== 100) {
                            var articleNameField = utility.filterObject(modelCopy.fields, {field: 'ArticleName'}, true)[0];
                            articleNameField.validation.maxLen = configuredModelNameLength;
                        }

                        // make ParentModelNumber creatable
                        var parentModelTypeField = utility.filterObject(modelCopy.fields, {field: 'parent_model_type'}, true)[0];
                        if(parentModelTypeField && parentModelTypeField.creatable) {
                            // make ParentModelNumber creatable
                            var parentModelNumberField = utility.filterObject(modelCopy.fields, {field: 'ParentModelNumber'}, true)[0];
                            if(angular.isDefined(parentModelNumberField)) {
                                parentModelNumberField.creatable = true;
                            }
                        }

                        // if Article Attrbute and Model Attribute is assigned at catalog level then make those attributes mandatory
                        var articleAttribute = activeCatalog.ArticleAttribute;
                        var modelAttribute = activeCatalog.ModelAttribute;
                        angular.forEach(modelCopy.fields, function(field) {
                            if(angular.isDefined(articleAttribute) && articleAttribute !== '' && articleAttribute != null && articleAttribute.toString().toLocaleLowerCase() === field.field.toString().toLocaleLowerCase()) {
                                field.creatable = true;
                                field.validation.minLen = 1;
                                field.validation.isRequired = true;
                            }
                            if(angular.isDefined(modelAttribute) && modelAttribute !== '' && modelAttribute != null && modelAttribute.toString().toLocaleLowerCase() === field.field.toString().toLocaleLowerCase() ) {
                                field.creatable = true;
                                field.validation.minLen = 1;
                                field.validation.isRequired = true;
                            }
                            // make lookuptable  type attributes not creatable through import we are not allowing user to map it and will calculate the value internally and send it
                            // make LinkedCatalogArticleNumber type attributes not creatable through import
                            if(field.inputType === 'lookup-table' || field.inputType === 'linkedcatalogarticlenumber') {
                                field.creatable = false;
                            }
                        });
                        // add unique constraints
                        modelCopy.uniqueConstraints = [{name: 'Constraint 1', fields: [articleAttribute]}];

                        var modelIdField = utility.filterObject(modelCopy.fields, {field: 'ModelId'}, true)[0];
                        modelIdField.creatable = false;

                        // make datatable type attributes not creatable through import
                        var dataTableFields = utility.filterObject(modelCopy.fields, {inputType:'datatable'}, true);
                        angular.forEach(dataTableFields, function(dataTableField) {
                            dataTableField.creatable = false;
                        });

                        // make Shipment Range Field creatable when "DummyArticleApplyRetailWindow" privilege is assigned
                        if(isApplyRetailWindowPrivilegeIsAssigned && activeCatalog.IsShippingWindowApply == 1) {
                            if((angular.isDefined(restrictedRetailWindowOnRole) && !restrictedRetailWindowOnRole.notEditable) || (angular.isUndefined(restrictedRetailWindowOnRole))) {
                                var retailIntroMonthField = utility.filterObject(modelCopy.fields, {field: 'RetailIntroMonthId', inputType: 'lookup'}, true)[0];
                                var retailExitMonthField = utility.filterObject(modelCopy.fields, {field: 'RetailExitMonthId', inputType: 'lookup'}, true)[0];
                                retailIntroMonthField.creatable = true;
                                retailIntroMonthField.validation.isRequired = true;
                                retailExitMonthField.creatable = true;
                                retailExitMonthField.validation.isRequired = true;
                            }
                        }

                        // add StateName as Ceate In
                        var stateField = utility.filterObject(modelCopy.fields, {field: 'StateName'}, true)[0];
                        stateField.creatable = true;
                        var articleStatePromise = api.catalogs.articleStates.methods.getList({forceFetch: true, isLogRequired: true}, sellerId, attributeGroupId);
                        stateField.validation.dataExistConstraints = { promise: articleStatePromise };
                        var masterSizeScaleField = utility.filterObject(modelCopy.fields, { field: 'MasterSizeScale' }, true)[0];
                        masterSizeScaleField.creatable = true;
                        var masterSizeScalesPromise = api.sellers.masterSizeScales.methods.getList(undefined, {forceFetch: true, isLogRequired: true}, sellerId);
                        masterSizeScaleField.validation.dataExistConstraints = { promise: masterSizeScalesPromise, model: api.sellers.masterSizeScales };
                        var sizeScaleField = utility.filterObject(modelCopy.fields, {field: 'SizeScale'}, true)[0];
                        sizeScaleField.creatable = true;
                        var sizeScaleGroupsPromise = api.sellers.sizeScaleGroups.methods.getList(undefined, {forceFetch: true, isLogRequired: true}, sellerId);
                        sizeScaleField.validation.dataExistConstraints = { promise: sizeScaleGroupsPromise };

                        modelCopy.validateRequiredLookupTableAttributes = true;

                        dataImporter.importExcel(modelCopy, true,  {}, action.id).then(function(result) {
                            vm.model.methods.createBulkByLicensee(vm.model, result.data, activeCatalogId);
                        });
                        break;
                    case 'setSizesByLicenseeModelNumber':
                        var modelCopy = angular.copy(vm.model);
                        var sizeScaleField = utility.filterObject(modelCopy.fields, { field: 'SizeScale' }, true)[0];
                        sizeScaleField.editable = true;
                        sizeScaleField.validation.isRequired = true;
                        var sizeScaleGroupsPromise = api.sellers.sizeScaleGroups.methods.getList(undefined, {forceFetch: true, isLogRequired: true}, sellerId);
                        sizeScaleField.validation.dataExistConstraints = { promise: sizeScaleGroupsPromise };

                        var masterSizeScaleField = utility.filterObject(modelCopy.fields, { field: 'MasterSizeScale' }, true)[0];
                        masterSizeScaleField.editable = true;
                        masterSizeScaleField.validation.isRequired = true;
                        var masterSizeScalesPromise = api.sellers.masterSizeScales.methods.getList(undefined, {forceFetch: true, isLogRequired: true}, sellerId);
                        masterSizeScaleField.validation.dataExistConstraints = { promise: masterSizeScalesPromise, model: api.sellers.masterSizeScales };

                        // make creatable false to all fields except SizeScale and MasterSizeScale
                        angular.forEach(modelCopy.fields, function( field) {
                            if((field.field !== 'SizeScale' && field.field !== 'MasterSizeScale') && field.editable) {
                                field.editable = false;
                            }
                        });
                        var modelNumberField = utility.filterObject(modelCopy.fields, { field: 'LicenseeModelNumber' }, true)[0];
                        modelNumberField.editable = true;
                        modelNumberField.validation.isRequired = true;
                        // add unique constraint
                        modelCopy.uniqueConstraints = [
                            {name: 'Constraint 1', fields: ['LicenseeModelNumber']}
                        ];
                        dataImporter.importExcel(modelCopy, false,  {}, action.id, vm.articles).then(function (result) {
                            modelCopy.methods.setSizeScaleByLicenceeModelNumberBulk(vm.model, result.data, activeCatalogId, sizeScaleGroupsPromise, masterSizeScalesPromise);
                        });
                        break;
                    case 'setPricesByLicenseeModelNumber':
                        var modelCopy = angular.copy(vm.catalogSpecificPricesModelTransformed);
                        // for prices if they are not editable (priceGroups IsEditable is 0) field dynamically marked as readOnly true and they should not be present in column mapper (they should not be importable)
                        angular.forEach(modelCopy.fields, function (field) {
                            if (field.isCatalogProperty === true) {
                                if(field.readOnly === true) {
                                    field.creatable = false;
                                }
                                if(field.isMandatory ) {
                                    field.validation.isRequired = true;
                                    field.validation.pattern = '^[+]?((\\d*[1-9]\\d*)([.]\\d{0,' + api.numberOfDecimalsForPrices + '})?)$'
                                    field.validation.messages.pattern = 'Invalid price value, Should be greater than 0 with no more than '+ api.numberOfDecimalsForPrices +' decimals.';
                                }
                                else {
                                    field.validation.pattern = '^[+]?\\d+([.]\\d{0,'+ api.numberOfDecimalsForPrices +'})?$';
                                    field.validation.messages.pattern = 'Invalid price value, Should be a positive number and not contain more than '+ api.numberOfDecimalsForPrices +' decimals.';
                                }
                            }
                        });
                        var priceGroupNames = utility.filterObject(modelCopy.fields, { editable: true }, true).map(function(field) {
                            return field.field;
                        })
                        var articleNumberField = utility.filterObject(modelCopy.fields, { field: 'ArticleNumber' }, true)[0];
                        articleNumberField.creatable = false;
                        var modelNumberField = utility.filterObject(modelCopy.fields, { field: 'ModelNumber' }, true)[0];
                        modelNumberField.creatable = false;
                        var licenseeModelNumberField = utility.filterObject(modelCopy.fields, { field: 'LicenseeModelNumber' }, true)[0];
                        licenseeModelNumberField.creatable = true;
                        licenseeModelNumberField.validation.isRequired = true
                        // add unique constraint
                        modelCopy.uniqueConstraints = [
                            {name: 'Constraint 1', fields: ['LicenseeModelNumber']}
                        ];
                        modelCopy.atLeastOneRequiredConstraints = [
                            { name: 'Constraint 1', fields: priceGroupNames }
                        ];
                        dataImporter.importExcel(modelCopy, true, { validateArticleLocking: activeCatalog.ArticleLocking === 1 }, action.id).then(function (result) {
                            if(result.data) {
                                vm.model.methods.setPricesByLicenseeModelNumberBulk(result, activeCatalog, modelCopy, vm.model);
                            }
                        });
                        break;
                    case 'overwriteColorBulk':
                        var modelCopy = angular.copy(vm.model);
                        angular.forEach(modelCopy.fields, function (field) {
                            if (field.field !== 'ArticleNumber' && field.field !== 'ColorCode') {
                                field.creatable = false;
                            } else {
                                field.creatable = true;
                                field.validation.isRequired = true
                            }
                        });
                        // add unique constraint
                        modelCopy.uniqueConstraints = [
                            {name: 'Constraint 1', fields: ['ArticleNumber']}
                        ];
                        dataImporter.importExcel(modelCopy, true).then(function (result) {
                            if(result.data) {
                                vm.model.methods.overwriteColorBulk(vm.model, result.data, activeCatalog.CatalogCode);
                            }
                        });
                        break;
                    case 'generateReport':
                        api.catalogs.targets.methods.getReports({forceFetch: false, isLogRequired: false}, catalogFactory.getActiveCatalog().CatalogCode)
                        .then(function (response) {
                            var data = response.data;
                            var reportModel = api.catalogs.summaryReport;
                            if(data.length) {
                                reportModel = catalogFactory.createSummaryReportModel(data[0]);
                            }
                            $mdDialog.show({
                                controller         : 'generateSummaryReportController',
                                controllerAs       : 'vm',
                                templateUrl        : 'app/main/catalogs/sub-modules/articles/dialogs/summary-report/summary-report.html',
                                parent             : angular.element($document.body),
                                targetEvent        : null,
                                clickOutsideToClose: false,
                                multiple           : true,
                                locals             : {
                                    data: data,
                                    model: reportModel,
                                    event : null
                                }
                            });
                        });
                    break;
                }
            }
        }

        function viewItem(item, event) {
            var id = item[vm.model.idField];
            var stateParams = { id: id };
            // if article does not yet assorted
            if (activeCatalog.DataSourceTypeId === 3 && angular.isDefined(item.IsAccessible) && item.IsAccessible === 1) {
                dialog.showAlertDialog(
                    angular.element($document.body),
                    $filter('translate')('MESSAGES.TITLE.ALERT'),
                    $filter('translate')('ARTICLES.MESSAGES.VIEW_UN_ASSIGNED_ARTICLE'),
                    $filter('translate')('MESSAGES.TITLE.ALERT'),
                    $filter('translate')('ACTIONS.DIALOG_CLOSE'),
                    false,
                    event);
            }
            else {
                $state.go('app.articles.details', stateParams);
            }
        }

        function addRecord(ev) {
            var modelCopy = angular.copy(vm.model);
            var lookupExtras = {};
            if(isAutomaticNumberingEnabled) {
                // user cannot enter nre model number
                var modelIdField = utility.filterObject(modelCopy.fields, {field: 'ModelId'}, true)[0];
                modelIdField.allowEnterNewValue = undefined;
            }
            // if configured model name length then change the allowed max length to the configured value
            var configuredModelNameLength = catalogFactory.getModelNameLength();
            if(configuredModelNameLength !== 100) {
                var articleNameField = utility.filterObject(modelCopy.fields, {field: 'ArticleName'}, true)[0];
                articleNameField.validation.maxLen = configuredModelNameLength;
            }
            var modelNumberField = utility.filterObject(modelCopy.fields, {field: 'ModelNumber'}, true)[0];
            modelNumberField.creatable = false;
            // make Shipment Range Field creatable when "DummyArticleApplyRetailWindow" privilege is assigned
            if(isApplyRetailWindowPrivilegeIsAssigned && activeCatalog.IsShippingWindowApply == 1) {
                var retailIntroMonthField = utility.filterObject(modelCopy.fields, {field: 'RetailIntroMonthId', inputType: 'lookup'}, true)[0];
                var retailExitMonthField = utility.filterObject(modelCopy.fields, {field: 'RetailExitMonthId', inputType: 'lookup'}, true)[0];
                if(angular.isUndefined(restrictedRetailWindowOnRole)) {
                    retailIntroMonthField.creatable = true;
                    retailIntroMonthField.validation.isRequired = true;
                    retailExitMonthField.creatable = true;
                    retailExitMonthField.validation.isRequired = true;
                } else if(angular.isDefined(restrictedRetailWindowOnRole) && restrictedRetailWindowOnRole.notEditable) {
                    retailIntroMonthField.creatable = false;
                    retailExitMonthField.creatable = false;
                }
            }

            // add state as Ceate IN
            var stateField = utility.filterObject(modelCopy.fields, {field: 'StateId', inputType: 'lookup'}, true)[0];
            stateField.creatable = true;
            stateField.validation.isRequired = false;

            var defaultValues = {AllowRetailWindowUpdateOnChild: 1};
            var lookupPromises = {};
            lookupPromises = crud.createLookupPromise(modelCopy, undefined , 'create');
            $mdDialog.show({
                controller         : 'createArticleController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/catalogs/sub-modules/articles/dialogs/create-article/create-article.html',
                parent             : angular.element($document.body),
                targetEvent        : null,
                clickOutsideToClose: false,
                multiple           : true,
                locals             : {
                    event : ev,
                    editMode : false,
                    model : modelCopy,
                    record : null,
                    defaultValues : defaultValues,
                    parentId: activeCatalogId,
                    additionalInfo: undefined,
                    existingValues: null,
                    existingRecordsForUniqueValue: null,
                    lookupExtras: lookupExtras,
                    filterExpression: {creatable: true},
                    lookupPromises: lookupPromises
                }
            })
            .then(function(saved) {
                if(saved) {
                    refreshItems(true, false);
                }
            });
        }

        function addCarryOverArticles(ev) {
            $mdDialog.show({
                controller         : 'createLinePlanArticlesController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/catalogs/sub-modules/articles/dialogs/create-line-plan-articles/create-line-plan-articles.html',
                parent             : angular.element($document.body),
                targetEvent        : null,
                clickOutsideToClose: false,
                multiple           : true,
                locals             : {
                    event : ev,
                    model : linkedCatalogArticleModel,
                    linePlanModel : vm.model,
                    data  : angular.copy(linkedCatalogModelsData),
                    existingArticles : vm.articles,
                    articleType: 'carryover',
                    catalogCode: vm.activeCatalogId
                }
            })
                .then(function() {
                    refreshItems(true, false);
                });
        }

        function addCompArticles(ev) {
            $mdDialog.show({
                controller         : 'createLinePlanArticlesController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/catalogs/sub-modules/articles/dialogs/create-line-plan-articles/create-line-plan-articles.html',
                parent             : angular.element($document.body),
                targetEvent        : null,
                clickOutsideToClose: false,
                multiple           : true,
                locals             : {
                    event : ev,
                    model : linkedCatalogArticleModel,
                    linePlanModel : vm.model,
                    data  : angular.copy(linkedCatalogModelsData),
                    existingArticles : vm.articles,
                    articleType: 'new',
                    catalogCode: vm.activeCatalogId
                }
            })
                .then(function() {
                    refreshItems(true, false);
                });
        }

        // life cycle articles
        function assignArticlesOnMatserCatalog(ev) {
            var modelCopy = angular.copy(vm.model);
            // make Shipment Range Field creatable when "DummyArticleApplyRetailWindow" privilege is assigned
            if(isApplyRetailWindowPrivilegeIsAssigned && activeCatalog.IsShippingWindowApply == 1) {
                var retailIntroMonthField = utility.filterObject(modelCopy.fields, {field: 'RetailIntroMonthId', inputType: 'lookup'}, true)[0];
                var retailExitMonthField = utility.filterObject(modelCopy.fields, {field: 'RetailExitMonthId', inputType: 'lookup'}, true)[0];
                if(angular.isUndefined(restrictedRetailWindowOnRole)) {
                    retailIntroMonthField.creatable = true;
                    retailIntroMonthField.validation.isRequired = true;
                    retailExitMonthField.creatable = true;
                    retailExitMonthField.validation.isRequired = true;
                } else if(angular.isDefined(restrictedRetailWindowOnRole) && restrictedRetailWindowOnRole.notEditable) {
                    retailIntroMonthField.creatable = false;
                    retailExitMonthField.creatable = false;
                }
            }

            var lookupPromises = {};
            lookupPromises = crud.createLookupPromise(modelCopy, undefined , 'create');
            $mdDialog.show({
                controller         : 'assignArticleToMasterCatalogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/catalogs/sub-modules/articles/dialogs/assign-articles-to-master-catalog/assign-articles-to-master-catalog.html',
                parent             : angular.element($document.body),
                targetEvent        : null,
                clickOutsideToClose: false,
                multiple           : true,
                locals             : {
                    editMode: false,
                    model: modelCopy,
                    record : null,
                    catalogCode : vm.activeCatalogId,
                    lookupPromises: lookupPromises,
                    event: ev
                }
            })
            .then(function(saved) {
                if(saved) {
                    refreshItems(true, false);
                }
            });
        }

        function editItem(item, ev) {
            var lookupExtras = {};
            var modelCopy = angular.copy(vm.model);
            // make retail window Fields editable when "DummyArticleApplyRetailWindow" privilege is assigned
            if(isApplyRetailWindowPrivilegeIsAssigned && activeCatalog.IsShippingWindowApply == 1 && item.AllowRetailWindowUpdate) {
                var retailIntroMonthField = utility.filterObject(modelCopy.fields, {field: 'RetailIntroMonthId', inputType: 'lookup'}, true)[0];
                var retailExitMonthField = utility.filterObject(modelCopy.fields, {field: 'RetailExitMonthId', inputType: 'lookup'}, true)[0];
                if(angular.isUndefined(restrictedRetailWindowOnRole)) {
                    retailIntroMonthField.editable = true;
                    retailIntroMonthField.validation.isRequired = true;
                    retailExitMonthField.editable = true;
                    retailExitMonthField.validation.isRequired = true;
                } else if(angular.isDefined(restrictedRetailWindowOnRole) && restrictedRetailWindowOnRole.notEditable) {
                    retailIntroMonthField.editable = false;
                    retailExitMonthField.editable = false;
                }
            }

            if(activeCatalog.IsShippingWindowApply == 1 && activeCatalog.DataSourceTypeId === 3 && item.AllowRetailWindowUpdate) { // add activeCatalog.DataSourceTypeId === 3 condition temporarily to hide it for master article
                //create lookupExtras use to filter shipment range based on PShipmentStartDate
                if(activeCatalog.DataSourceTypeId === 3) {
                    if(!item.PShipmentStartDate) {
                        $log.info('parent article does not have shipmentStartDate');
                    }
                    // lookup extra provided as a helper for get lookup method to filter appropriate shipment windows
                    lookupExtras['catalogs.retailIntroMonthsForArticle'] = {};
                    lookupExtras['catalogs.retailIntroMonthsForArticle']['parentArticle'] = { ShipmentStartDate: item.PShipmentStartDate };
                    lookupExtras['catalogs.retailIntroMonthsForArticle']['CatalogCode'] = activeCatalog.CatalogCode;
                    // retail exit month
                    lookupExtras['catalogs.retailExitMonthsForArticle'] = {};
                    lookupExtras['catalogs.retailExitMonthsForArticle']['parentArticle'] = { ShipmentStartDate: item.PShipmentStartDate };
                    lookupExtras['catalogs.retailExitMonthsForArticle']['CatalogCode'] = activeCatalog.CatalogCode;
                }
            }

            if(isAutomaticNumberingEnabled) {
                // if automatic numbering enabled and colorid is not null then make colorid field non editable.
                if(item.ColorId != null) {
                    var colorIdField = utility.filterObject(modelCopy.fields, {field: 'ColorId'}, true)[0];
                    if(angular.isDefined(colorIdField)) {
                        colorIdField.editable = false;
                    }
                }
            }

            // primary color is not updatable by child catalog
            if(activeCatalog.DataSourceTypeId === 3) {
                var colorIdField = utility.filterObject(modelCopy.fields, {field: 'ColorId'}, true)[0];
                if(angular.isDefined(colorIdField)) {
                    colorIdField.editable = false;
                }
            }

            // if configured model name length then change the allowed max length to the configured value
            var configuredModelNameLength = catalogFactory.getModelNameLength();
            if(configuredModelNameLength !== 100) {
                var articleNameField = utility.filterObject(modelCopy.fields, {field: 'ArticleName'}, true)[0];
                articleNameField.validation.maxLen = configuredModelNameLength;
            }

            // if state is assigned then make non editable attrbutes as non editable
            if(!isSpecialPermissionToIgnoreArticleStateIsAssigned && item.StateId != null && item.ModelStateId != null) {
                // article attributes to be validated against article state
                var assignedArticleState = utility.filterObject(api.articleStatesList, {StateId: item.StateId}, true)[0];
                if(assignedArticleState && assignedArticleState.NonEditableAttributes.length) {
                    angular.forEach(assignedArticleState.NonEditableAttributes, function(attribute) {
                        var nonEditableArticleAttrField = utility.filterObject(modelCopy.fields, {field: attribute.AttributeSystemName, isModelLevelAttribute: false}, true)[0];
                        if(angular.isDefined(nonEditableArticleAttrField)) {
                            nonEditableArticleAttrField.editable = false;
                            nonEditableArticleAttrField.showInEdit = true;
                            nonEditableArticleAttrField['isAllowChangeRequestEnabled'] = attribute.AllowChangeRequest;
                            if(attribute.AllowChangeRequest) {
                                nonEditableArticleAttrField['updateArticleChangeManagementExternalURL'] = updateArticleChangeManagementExternalURL;
                            }
                        }
                    });
                }
                // model attributes to be validated against model state
                var assignedModelState = utility.filterObject(api.articleStatesList, {StateId: item.ModelStateId}, true)[0];
                if(assignedModelState && assignedModelState.NonEditableAttributes.length) {
                    angular.forEach(assignedModelState.NonEditableAttributes, function(attribute) {
                        var nonEditableModelAttrField = utility.filterObject(modelCopy.fields, {field: attribute.AttributeSystemName, isModelLevelAttribute: true}, true)[0];
                        if(angular.isDefined(nonEditableModelAttrField)) {
                            nonEditableModelAttrField.editable = false;
                            nonEditableModelAttrField.showInEdit = true;
                            nonEditableModelAttrField['isAllowChangeRequestEnabled'] = attribute.AllowChangeRequest;
                            if(attribute.AllowChangeRequest) {
                                nonEditableModelAttrField['updateArticleChangeManagementExternalURL'] = updateArticleChangeManagementExternalURL;
                            }
                        }
                    });
                }
            }

            //while editing carryover articles make sure linkedAttributes and articleName are disabled and cant be edited
            if (vm.isLinePLanCatalog === 1 && item.article_type && item.article_type.toLowerCase() === 'carryover' && linkedAttributes && linkedAttributes.length > 0) {
                angular.forEach(modelCopy.fields, function (field) {
                    if(angular.isDefined(field.isLinkedAttributeEditable)) {
                        if(!field.isLinkedAttributeEditable) {
                            field.validation.disabledCriteria = true;
                        } else if(field.isLinkedAttributeEditable) {
                            field.editable = true;
                            field.showInEdit = true;
                            field.validation.disabledCriteria = false;
                        }
                    } else {
                        var isLinkedAttributeEditable = angular.isDefined(utility.filterObject(linkedAttributes,{AttributeSystemName: field.field} , true)[0]) ?
                            utility.filterObject(linkedAttributes,{AttributeSystemName: field.field} , true)[0].Editable : false;
                        if(isLinkedAttributeEditable === 0) {
                            field.validation.disabledCriteria = true;
                        } else if(isLinkedAttributeEditable === 1) {
                            field.editable = true;
                            field.showInEdit = true;
                            field.validation.disabledCriteria = false;
                        }
                    }
                    utility.filterObject(modelCopy.fields, { field: 'ArticleName' }, true)[0].validation.disabledCriteria = true;
                })
            }
            //activeCatalogDetails passed to help evaluating shipment range field through shipmentStart and end dates
            api.showEditRecordDialog(angular.element($document.body), ev, modelCopy, item, activeCatalogId, lookupExtras, {activeCatalogDetails: catalogFactory.getActiveCatalogDetails()})
                .then(function(saved) {
                    if (saved) {
                        refreshItems(true, false);
                        if(activeCatalog.IsShippingWindowApply == 1 && activeCatalog.DataSourceTypeId === 3) {
                            dialog.showAlertDialog(
                                angular.element($document.body),
                                $filter('translate')('MESSAGES.TITLE.ALERT'),
                                $filter('translate')('ARTICLES.MESSAGES.INVALID_SHIPMENTWINDOW_RANGE'),
                                $filter('translate')('MESSAGES.TITLE.ALERT'),
                                $filter('translate')('ACTIONS.DIALOG_CLOSE'),
                                true,
                                null
                            );
                        }
                    }
                });
        }

        function modifyInheritedModelForImport(modelClone) {
            var articleNumberField = utility.filterObject(modelClone.fields, {field:'ArticleNumber'}, true)[0];
            articleNumberField.creatable = true;
        }

        function updateArticleReplacement(article) {
            var recordCopy = angular.copy(article);
            recordCopy['ArticleIdDropped'] = recordCopy[vm.model.idField];
            recordCopy['ArticleNumberDropped'] = recordCopy[vm.model.lookupDisplayField];
            recordCopy['ArticleIdAlt'] = recordCopy.RAID;

            $mdDialog.show({
                controller         : 'replaceArticleController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/catalogs/sub-modules/articles-replacement/dialogs/replace-article.html',
                parent             : angular.element($document.body),
                targetEvent        : null,
                clickOutsideToClose: false,
                locals             : {
                    model : api.catalogs.articlesReplacement,
                    articlesModel: vm.model,
                    activeCatalog: activeCatalog,
                    articlesWithReplacementPromise: $q.when({}),// no use of it in update since original article dropdown is disabled
                    record: recordCopy,
                    isNew: false,
                    lookupPromises: $q.when({}),// no use of it in update since original article dropdown is disabled
                }
            });
        }

        function addSegmentation(article) {
            var articleSegmentationsModel = api.articles.segmentation;
            var assignedAarticleSegmentationPromise = articleSegmentationsModel.methods.getList({forceFetch: true, isLogRequired: false}, article[vm.model.idField], activeCatalogId);
            var lookupPromises = {};
            lookupPromises = crud.createLookupPromise(articleSegmentationsModel, undefined , 'create');
            $mdDialog.show({
                controller         : 'assignSegmentationToArticleController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/catalogs/sub-modules/articles/details/tabs/segmentation/dialogs/assign-segmentation-to-article.html',
                parent             : angular.element($document.body),
                targetEvent        : null,
                clickOutsideToClose: false,
                locals             : {
                    model: articleSegmentationsModel,
                    assignedSegmentationsPromise: assignedAarticleSegmentationPromise,
                    activeCatalog: activeCatalog,
                    articleId: article[vm.model.idField],
                    lookupPromises: lookupPromises,
                    event: null,
                    isArticleListAction: true
                }
            }).then(function(saved) {
                if(saved) {
                    vm.refreshItems(true, false);
                }
            });
        }

        function addPrice(article) {
            var articlePricesModel = api.articles.prices;
            var assignedPriceGroupsPromise = articlePricesModel.methods.getList({ forceFetch: true, isLogRequired: false }, article[vm.model.idField], activeCatalogId)
            var lookupPromises = {};
            lookupPromises = crud.createLookupPromise(articlePricesModel, undefined , 'create');
            return $mdDialog.show({
                controller: 'createArticlePriceController',
                controllerAs: 'vm',
                templateUrl: 'app/main/catalogs/sub-modules/articles/details/tabs/prices/dialogs/create-article-price.html',
                parent: angular.element($document.body),
                targetEvent: null,
                clickOutsideToClose: false,
                locals: {
                    articleId: article[vm.model.idField],
                    activeCatalogId: activeCatalogId,
                    model: articlePricesModel,
                    assignedPriceGroupsPromise: assignedPriceGroupsPromise,
                    lookupPromises: lookupPromises,
                    articleStateId: article.StateId,
                    event: null
                }
            }).then(function (saved) {
                if (saved) {
                    vm.refreshItems(true, false);
                }
            });
        }

        function overwriteColor(record) {
            var modelCopy = angular.copy(vm.model);
            angular.forEach(modelCopy.fields, function (field) {
                if(field.field !== 'ColorCode') {
                    field.editable = false;
                    field.showInEdit = false;
                } else {
                    field.editable = true;
                }
            })
            var additionalInfo = { 'additionalAction': 'overwriteColor'};
            api.showEditRecordDialog(angular.element($document.body), null, modelCopy, record, activeCatalog.CatalogCode, undefined, additionalInfo)
            .then(function(saved) {
                if (saved) {
                    refreshItems(true, false);
                }
            });
        }

        function getLinkedCatalogModelsData(forceFetch, isLogRequired) {
            var generalProperties = {
                forceFetch: forceFetch,
                isLogRequired: isLogRequired,
                config: {},
                supportIncrementalResult: true,
                modelIdField: vm.model.idField,
                isMajor: false
            }
            linkedCatalogArticleModel.methods.getLinkedCatalogModelsData(generalProperties, activeCatalogId).then(function (response) {
                linkedCatalogModelsData =  response.data;
            })
        }

        var catalogChangedEventCleanup = $rootScope.$on('ActiveCatalogChangedEvent', function(e) {
            if(activeCatalogId !== catalogFactory.getActiveCatalog().CatalogCode) {
                // vm.model.isDirty = true; // not required since invalidating all the lookups under catalogs on drop down change (in toolbar controller)
                $state.reload('app.articles');
            }
        });
        $scope.$on('$destroy', function () {
            catalogChangedEventCleanup();
            articlesFactory.cleanArticleNumbersMap();
        });

    }
})();
(function() {
    'use strict';

    angular
        .module('app.main.catalogs.articles')
        .controller('articlesDetailsController', articlesDetailsController);

    /* @ngInject */
    function articlesDetailsController($document, api, $state, $stateParams, $rootScope, catalogFactory, dynamicModels, CONSTANTS,
        $mdDialog, utility, crud, settingsFactory, $q, $log, $localStorage, SecurityFactory, articlesFactory) {
       /* jshint validthis: true */
        var vm = this;

        // Data
        var articleId = $stateParams.id;
        var tabName = $stateParams.tab.toUpperCase();
        vm.activeCatalog = catalogFactory.getActiveCatalog();
        var isApplyRetailWindowPrivilegeIsAssigned = SecurityFactory.isAuthorized({accessPrivileges: CONSTANTS.PRIVILEGES.ARTICLES.UPDATE_ARTICLE_SHIPMENT_WINDOW});
        var duneContext = vm.activeCatalog.DuneContext;
        var assignedContextKey = catalogFactory.getCatalogContextKey();
        var assetTypesMap = {};
        // article number field will be non creatable and editable
        var isAutomaticNumberingEnabled = catalogFactory.getAutomaticNumbering();

        var mirrorSegmentation = vm.activeCatalog.MirrorSegmentation;
        var dataSourceTypeId = vm.activeCatalog.DataSourceTypeId;

        var activeCatalogId = vm.activeCatalog.CatalogCode;
        var activeCatalogDetails = catalogFactory.getActiveCatalogDetails();

        // allSizes is use to pass all the article's sizes list to assign sizes dialog (in case of inherited article),
        //to identify to call create method (POST) if it is not created for inherited article or updateStatus if it created for inherited article
        var allSizes = [];
        vm.articleAuditTrailHistoryLimit = 25;
        var lookupData = {};
        // article drop reasons
        var articleDropReasonsList = api.articleDropReasonsList;
        // check the special privilege is assigned to the user for updating the state. if then does not vaidate editable fields
        var isSpecialPermissionToIgnoreArticleStateIsAssigned = SecurityFactory.isAuthorized({accessPrivileges: CONSTANTS.PRIVILEGES.ARTICLES.SPECIAL_PRIVILEGE_TO_SKIP_STATE_VALIDATION});
        var updateArticleChangeManagementExternalURL = '';
        var catalogPriceGroupList = catalogFactory.getActiveCatalogDetails().CatalogPriceGroupList;
        var updatePricesChangeManagementExternalURL = '';

        vm.model = dynamicModels.catalogSpecificArticlesModel;

        if(vm.activeCatalog.IsLinePlan !== 1) {
            vm.CRDModel = api.articles.crds;
            settingsFactory.applyPersistedListViewLayout(vm.CRDModel);

            vm.resourcesModel = api.articles.resources;
            settingsFactory.applyPersistedListViewLayout(vm.resourcesModel);

            vm.imagesModel = dynamicModels.imagesModel;
            settingsFactory.applyPersistedListViewLayout(vm.imagesModel);

            vm.sizesModel = dynamicModels.sizesModel;
            settingsFactory.applyPersistedListViewLayout(vm.sizesModel);

            vm.pricesModel = dynamicModels.pricesModel;
            settingsFactory.applyPersistedListViewLayout(vm.pricesModel);

            vm.segmentationModel = api.articles.segmentation;
            settingsFactory.applyPersistedListViewLayout(vm.segmentationModel);
            vm.segmentationModelCopy = angular.copy(vm.segmentationModel);
            if(dataSourceTypeId === 3 && mirrorSegmentation === 1) {
                catalogFactory.modifySegmentationActions(vm.segmentationModelCopy);
            } else {
                vm.segmentationModelCopy = vm.segmentationModel;
            }
        }

        vm.auditTrailHistoryModel = api.articles.auditTrailHistory;
        settingsFactory.applyPersistedListViewLayout(vm.auditTrailHistoryModel);

        vm.articleRelationsModel = api.articles.articleRelations;
        settingsFactory.applyPersistedListViewLayout(vm.articleRelationsModel);

        vm.article = {};
        vm.articleCRDs = [];
        var allCRDs = [];
        vm.filteredArticleCRDs = [];
        vm.articleResources = [];
        vm.filteredArticleResources = [];
        vm.articleImages = [];
        vm.filteredArticleImages = [];
        vm.articleSizes = [];
        vm.filteredArticleSizes = [];
        vm.articlePrices = [];
        vm.filteredArticlePrices = [];
        vm.articleSegmentation = [];
        var allSegmentation = [];
        vm.filteredArticleSegmentation = [];
        vm.articleAuditTrailHistory = [];
        vm.filteredAuditTrailHistory = [];
        vm.articleRelations = [];
        vm.filteredArticleRelations = [];

        vm.isLoading = false;
        vm.isCRDLoading = false;
        vm.isResourceLoading = false;
        vm.isImageLoading = false;
        vm.isSizeLoading = false;
        vm.isPriceLoading = false;
        vm.isSegmentationLoading = false;
        vm.isAuditTrailLoading = false;
        vm.isAuditTrailHistoryLoading = false;
        vm.isArticleRelationsLoading = false;


        // Methods
        vm.refreshRecord = refreshRecord;
        vm.refreshCRDs = refreshCRDs;
        vm.refreshResources = refreshResources;
        vm.refreshImages = refreshImages;
        vm.refreshSizes = refreshSizes;
        vm.refreshPrices = refreshPrices;
        vm.refreshSegmentations = refreshSegmentations;
        vm.refreshAuditTrailHistory = refreshAuditTrailHistory;
        vm.refreshArticleRelations = refreshArticleRelations;

        vm.doArticleItemAction = doArticleItemAction;
        vm.editArticle = editArticle;
        vm.doCRDItemAction = doCRDItemAction;
        vm.doCRDsListAction = doCRDsListAction;
        vm.addCRD = addCRD;
        vm.doResourcesItemAction = doResourcesItemAction;
        vm.doResourcesListAction = doResourcesListAction;
        vm.viewResource = viewResource;
        vm.addResource = addResource;
        vm.doImagesItemAction = doImagesItemAction;
        vm.doImagesListAction = doImagesListAction;
        vm.viewImage = viewImage;
        vm.addImage = addImage;
        vm.doSizesItemAction = doSizesItemAction;
        vm.doSizesListAction = doSizesListAction;
        vm.addSize = addSize;
        vm.doPricesItemAction = doPricesItemAction;
        vm.addPrice = addPrice;
        vm.doSegmentationItemAction = doSegmentationItemAction;
        vm.doSegmentationListAction = doSegmentationListAction;
        vm.addSegmentation = addSegmentation;
        vm.loadMoreAuditHistory = loadMoreAuditHistory;
        vm.doArticleRelationsItemAction = doArticleRelationsItemAction;
        vm.addArticleRelations = addArticleRelations;

        activate();

        ////////////////

        function activate() {
            refreshRecord(true);

            api.webGet('/app/app.config.json').then(function(response) {
                if (angular.isDefined(response) && angular.isDefined(response.data)) {
                    if(angular.isDefined(response.data['updateArticleChangeManagementExternalURL']) && response.data['updateArticleChangeManagementExternalURL'].length) {
                        updateArticleChangeManagementExternalURL = response.data['updateArticleChangeManagementExternalURL'];
                    }
                    if(angular.isDefined(response.data['updatePricesChangeManagementExternalURL']) && response.data['updatePricesChangeManagementExternalURL'].length) {
                        updatePricesChangeManagementExternalURL = response.data['updatePricesChangeManagementExternalURL'];
                    }
                }
            });
        }

        function refreshRecord(isLogRequired) {
            vm.isLoading = true;
            vm.model.isBulkActionCompleted = false;
            //display column planning value
            if(vm.activeCatalog.SegmentationPlanningEnable === 1){
                utility.filterObject( vm.segmentationModel.fields, {field: 'PlanningValue'}, true)[0].visible = true;
            }

            vm.model.methods.getDetails(isLogRequired, articleId, activeCatalogId)
                .then(function (response) {
                    vm.article = response.data.Article;
                    if(vm.isLinePLanCatalog !== 1) {
                        //Transform articles data to list prices, segmentations and article states in the list
                        var results = catalogFactory.transformArticlesResponse([vm.article], vm.model.fields);
                        vm.article = results[0];
                    }
                    // get article status value for inherited catalogs
                    if(vm.activeCatalog.DataSourceTypeId === 3) {
                        var articleStatusField = utility.filterObject(vm.model.fields, {inputType: 'article-status'}, true)[0]; // only one article status field
                        vm.article[articleStatusField.field] = utility.getArticleStatusValue(vm.article, articleStatusField, dataSourceTypeId);
                    }
                    vm.tabIndex = CONSTANTS.TABS.ARTICLE[tabName] ? CONSTANTS.TABS.ARTICLE[tabName]: 0;
                    vm.title = angular.copy(vm.article[vm.model.lookupDisplayField]);

                    //Update Breadcrumb
                    $state.current.data.displayName = vm.title;
                    $rootScope.$broadcast('breadcrumb-updated');

                    // TODO- can be removed if API have same behavior in CRDs(if parent record is disabled API wont return segmentation however in case of CRDs it return the assigned CRD with status 1 )
                    //Add all the missing CRDs of active catalog to an article CRD with status 0 and empty availability dates (list of linked and unlined CRDs)
                    allCRDs = catalogFactory.getAllArticleCRDs(response.data.ArticleCRDResponseList, activeCatalogDetails.CatalogCRDList);
                    vm.articleCRDs = angular.copy(allCRDs);
                    vm.articleResources = utility.filterObject(response.data.CatalogArticleSpecificResourceResponseList, {Status: 1});
                    if(vm.activeCatalog.IsLinePlan !== 1) {
                        refreshImages(true, false);
                    }

                    vm.articleSizes = response.data.ArticleSizesListResponse;
                    allSizes = response.data.ArticleSizesListResponse;

                    //Add catalog type to article-sizes record
                    utility.addCustomProperty(vm.articleSizes, 'CatalogTypeId', vm.activeCatalog.DataSourceTypeId);

                    vm.articlePrices = response.data.CatalogArticlePricesResponseList;
                    var isPriceUpdateLocked = vm.activeCatalog.ArticleLocking === 1 && vm.article['Locked'] ? 1 : 0;
                    utility.addCustomProperty(vm.articlePrices, 'Locked', isPriceUpdateLocked);

                    //Add all the missing Segmentation of active catalog to an article Segmentation with status 0
                    // TODO- can be removed if API have same behavior in CRDs(if parent record is disabled API wont return segmentation however in case of CRDs it return the assigned CRD with status 1 )
                    allSegmentation = catalogFactory.getAllArticleSegmentations(response.data.CatalogArticleSegmentationResponseList, activeCatalogDetails.CatalogSegmentationList);
                    vm.articleSegmentation = utility.filterObject(allSegmentation, {Status: 1});
                    // internal segmentation
                    var openSegmentation = utility.filterObject(allSegmentation, {Name: CONSTANTS.OPEN_SEGMENTATION, Status: 0}, true)[0];
                    if(angular.isDefined(openSegmentation)) {
                        vm.articleSegmentation.push(openSegmentation);
                    }

                    // add article prices and segmentations as the get details API does not contain the nested object using it details response
                    if(api.enablePricesSegmentationsInArticlesList) {
                        var segmentationPlanningEnable = vm.activeCatalog.SegmentationPlanningEnable;
                        angular.forEach(vm.articlePrices, function(price) {
                            vm.article[price.Name] = price.price;
                        });
                        angular.forEach(allSegmentation, function(segmentation) {
                            vm.article[segmentation.SegmentationId+segmentation.Name] = 'No';
                            if(segmentation.Status) {
                                if (segmentationPlanningEnable === 1) {
                                    if (angular.isUndefined(segmentation.PlanningValue)) {
                                        vm.article[segmentation.SegmentationId+segmentation.Name] = 'Yes';
                                    } else {
                                        vm.article[segmentation.SegmentationId+segmentation.Name] = segmentation.PlanningValue;
                                    }
                                } else {
                                    vm.article[segmentation.SegmentationId+segmentation.Name] = 'Yes';
                                }
                            }
                        });
                    }

                    //get article relations
                    if(SecurityFactory.isAuthorized({accessPrivileges: CONSTANTS.PRIVILEGES.ARTICLES.DETAIL.ARTICLES_RELATIONS })) {
                        vm.refreshArticleRelations(true, false);
                    }
                })
                .finally(function () {
                    vm.isLoading = false;
                });
        }

        function refreshCRDs(forceFetch, isLogRequired) {
            var generalProperties = {
                forceFetch: forceFetch,
                isLogRequired: isLogRequired,
                config: {},
                supportIncrementalResult: false,
                modelIdField: 'Id',
                isMajor: false,
                model: vm.CRDModel
            }
            vm.isCRDLoading = true;
            vm.CRDModel.methods.getList(generalProperties, articleId, activeCatalogId).then(function(response) {
                // TODO- can be removed if API have same behavior in CRDs(if parent record is disabled API wont return segmentation however in case of CRDs it return the assigned CRD with status 1 )
                allCRDs = catalogFactory.getAllArticleCRDs(response.data, activeCatalogDetails.CatalogCRDList);
                vm.articleCRDs = angular.copy(allCRDs);
                if (angular.isDefined(vm.tableCrdControl) && angular.isDefined(vm.tableCrdControl.updateData)) {
                    vm.tableCrdControl.updateData();
                }
            }).finally(function() {
                vm.isCRDLoading = false;
            });
        }

        function refreshResources(forceFetch, isLogRequired) {
            var generalProperties = {
                forceFetch: forceFetch,
                isLogRequired: isLogRequired
            }
            vm.isResourceLoading = true;
            vm.resourcesModel.methods.getList(generalProperties, articleId, activeCatalogId).then(function(response) {
                vm.articleResources = utility.filterObject(response.data, {Status: 1});
            }).finally(function() {
                vm.isResourceLoading = false;
            });
        }

        function resolveAssetTypeNames(records) {
            angular.forEach(records, function(record) {
                if(angular.isDefined(record.AssetTypeId) && assetTypesMap[record.AssetTypeId]) {
                    record.AssetTypeName = assetTypesMap[record.AssetTypeId];
                } else if(angular.isDefined(record.AssetTypeId)) {
                    record.AssetTypeName = record.AssetTypeId;
                }
            });
        }

        function refreshImages(forceFetch, isLogRequired) {
            vm.isImageLoading = true;
            // Fetch asset types if not already loaded
            if(Object.keys(assetTypesMap).length === 0 && duneContext && assignedContextKey) {
                api.catalogs.t1Dune.methods.getAssetTypes(duneContext, assignedContextKey).then(function(response) {
                    angular.forEach(response.data, function(assetType) {
                        assetTypesMap[assetType.Id] = assetType.Name;
                    });
                });
            }
            var requestObjet = {};
            var catalogArticleNumbersArray = [];
            if(catalogFactory.doesUserHaveAccessToBlockedImagesForActiveCatalog()) {
                catalogArticleNumbersArray.push(vm.article.ArticleNumber);
            } else if(!vm.article.BlockImage) {
                catalogArticleNumbersArray.push(vm.article.ArticleNumber);
            }

            var generalProperties = {
                forceFetch: forceFetch,
                isLogRequired: isLogRequired,
                cache: false,
                config: {},
                supportIncrementalResult: false,
                modelIdField: 'Id',
                isMajor: false,
            }
            // if modelLevelImagesKeys are assigned then get images assigned for those models.
            if(angular.isDefined(api.modelLevelImagesKeyConfig)) {
                if(vm.article.ArticleNumber !== vm.article.ModelNumber && vm.article.ModelNumber !== null ) {
                    catalogArticleNumbersArray.push(vm.article.ModelNumber);
                }
            }
            if(catalogArticleNumbersArray.length > 0) {
                requestObjet = {
                    Type : 'ImageSet',
                    Filter: catalogArticleNumbersArray,
                    Context: catalogFactory.getActiveCatalog().DuneContext,
                    ContextKey: catalogFactory.getCatalogContextKey(),
                    FirstImage: true,
                    Status: true,
                    Op: 'equals'
                };
                vm.imagesModel.methods.getListByFilter(generalProperties, vm.imagesModel, requestObjet).then(function (response) {
                    if(angular.isDefined(response) && response.data.length) {
                        if(angular.isDefined(api.modelLevelImagesKeyConfig)) {
                            if(vm.article.ArticleNumber !== vm.article.ModelNumber) {
                                vm.articleImages = utility.filterObject(response.data, { ImageSet: vm.article.ArticleNumber }, true);
                                angular.forEach(response.data, function(duneImage) {
                                    if(duneImage.ImageSet === vm.article.ModelNumber) {
                                        angular.forEach(api.modelLevelImagesKeyConfig, function(key) {
                                            if(duneImage.Key.toLowerCase() === key.toLowerCase()) {
                                                vm.articleImages.push(duneImage);
                                            }
                                        });
                                    }
                                });
                            } else {
                                vm.articleImages = response.data;
                            }
                        } else {
                            vm.articleImages = response.data;
                        }
                    }
                    resolveAssetTypeNames(vm.articleImages);
                    if (angular.isDefined(vm.tableControl) && angular.isDefined(vm.tableControl.updateData)) {
                        vm.tableControl.updateData();
                    }
                })
                .finally(function () {
                    vm.isImageLoading = false;
                });
            } else {
                vm.isImageLoading = false;
            }
        }

        function refreshSizes(forceFetch, isLogRequired) {
            var generalProperties = {
                forceFetch: forceFetch,
                isLogRequired: isLogRequired,
                config: {},
                supportIncrementalResult: true,
                modelIdField: 'Id',
                isMajor: false,
                model: vm.sizesModel
            }
            vm.isSizeLoading = true;
            vm.sizesModel.methods.getList(generalProperties, articleId, activeCatalogId).then(function(response) {
                vm.articleSizes = response.data;
                allSizes = response.data;
                utility.addCustomProperty(vm.articleSizes, 'CatalogTypeId', vm.activeCatalog.DataSourceTypeId);
                if (angular.isDefined(vm.tableSizesControl) && angular.isDefined(vm.tableSizesControl.updateData)) {
                    vm.tableSizesControl.updateData();
                }
            }).finally(function() {
                vm.isSizeLoading = false;
            });
        }

        function refreshPrices(forceFetch, isLogRequired) {
            var generalProperties = {
                forceFetch: forceFetch,
                isLogRequired: isLogRequired,
                config: {},
                supportIncrementalResult: true,
                modelIdField: 'Id',
                isMajor: false,
                model: vm.pricesModel
            }
            vm.isPriceLoading = true;
            vm.pricesModel.methods.getList(generalProperties, articleId, activeCatalogId).then(function(response) {
                vm.articlePrices = response.data;
                var isPriceUpdateLocked = vm.activeCatalog.ArticleLocking === 1 && vm.article['Locked'] ? 1 : 0;
                utility.addCustomProperty(vm.articlePrices, 'Locked', isPriceUpdateLocked);
                if (angular.isDefined(vm.tablePricesControl) && angular.isDefined(vm.tablePricesControl.updateData)) {
                    vm.tablePricesControl.updateData();
                }
            }).finally(function() {
                vm.isPriceLoading = false;
            });
        }

        function refreshSegmentations(forceFetch, isLogRequired) {
            var generalProperties = {
                forceFetch: forceFetch,
                isLogRequired: isLogRequired,
                config: {},
                supportIncrementalResult: true,
                modelIdField: 'Id',
                isMajor: false,
                model: vm.segmentationModel
            }
            vm.isSegmentationLoading = true;
            vm.segmentationModel.methods.getList(generalProperties, articleId, activeCatalogId).then(function(response) {
                // TODO- can be removed if API have same behavior in CRDs(if parent record is disabled API wont return segmentation however in case of CRDs it return the assign CRD with status 1 )
                allSegmentation = catalogFactory.getAllArticleSegmentations(response.data, activeCatalogDetails.CatalogSegmentationList);
                vm.articleSegmentation = utility.filterObject(allSegmentation, {Status: 1});
                // internal segmentation
                var openSegmentation = utility.filterObject(allSegmentation, {Name: CONSTANTS.OPEN_SEGMENTATION, Status: 0}, true)[0];
                if(angular.isDefined(openSegmentation)) {
                    vm.articleSegmentation.push(openSegmentation);
                }
                if (angular.isDefined(vm.tableSegmentationsControl) && angular.isDefined(vm.tableSegmentationsControl.updateData)) {
                    vm.tableSegmentationsControl.updateData();
                }
            }).finally(function() {
                vm.isSegmentationLoading = false;
            });
        }

        function refreshArticleRelations(forceFetch, isLogRequired) {
            var generalProperties = {
                forceFetch: forceFetch,
                isLogRequired: isLogRequired
            }
            vm.isArticleRelationsLoading = true;
            vm.articleRelationsModel.methods.getList(generalProperties, articleId, activeCatalogId).then(function(response) {
                vm.articleRelations = response.data;
                // format request articles relations(IsRequestArticle = 1) and assign RelatedArticleId/RelatedArticleName/RelatedArticleNumber with RequestArticleId/RequestArticleName/RequestArticleNumber
                // add new column related if IsRequestArticle = 1 then Request else Article
                angular.forEach(vm.articleRelations, function(relation) {
                    if(relation.IsRequestArticle === 1) {
                        relation.RelatedArticleId = relation.RequestArticleId;
                        relation.RelatedArticleName = relation.RequestArticleName;
                        relation.RelatedArticleNumber = relation.RequestArticleNumber;
                        relation.Related = 'Request';
                    } else {
                        relation.Related = 'Article';
                    }
                });
            }).finally(function() {
                vm.isArticleRelationsLoading = false;
            });
        }

        function refreshAuditTrailHistory(forceFetch, isLogRequired) {
            var generalProperties = {
                forceFetch: forceFetch,
                isLogRequired: isLogRequired
            }
            vm.isAuditTrailHistoryLoading = true;
            vm.auditTrailHistoryModel.methods.getList(generalProperties, articleId, activeCatalogId).then(function(response) {
                vm.articleAuditTrailHistory = articlesFactory.formatAuditTrailData(allSegmentation, vm.articlePrices, response.data, vm.model, lookupData, {CreatedBy: vm.article.Created_By_User, CreatedDate: vm.article.CreatedDate});
            }).finally(function() {
                vm.isAuditTrailHistoryLoading = false;
            });
        }

        function doArticleItemAction(action, record) {
            if (action) {
                switch (action.id) {
                    case 'delete':
                        if(vm.activeCatalog.IsLinePlan !== 1) {
                            var promise = {suggestedArticles: vm.model.methods.getArticlesWithSameSizes(activeCatalogId, record[vm.model.idField], vm.activeCatalog.ArticleReplacementAttributeId)};
                            $mdDialog.show({
                                controller         : 'confirmDropController',
                                controllerAs       : 'vm',
                                templateUrl        : 'app/main/catalogs/sub-modules/articles/dialogs/confirm-drop/confirm-drop.html',
                                parent             : angular.element($document.body),
                                targetEvent        : null,
                                clickOutsideToClose: true,
                                locals             : {
                                    model : vm.model,
                                    record: record,
                                    actionObject: action,
                                    suggestedArticlesPromise: promise,
                                    dropReasons: api.articleDropReasonsList
                                }
                            }).then(function(result) {
                                if(result !== 'cancel') {
                                    vm.model.methods.activateBulk(record, vm.model, action.id, activeCatalogId, result).then(function() {
                                        refreshRecord(false);
                                    });
                                }
                            });
                        } else {
                            // show dropreasons popup if article drop reasons are added
                            if(articleDropReasonsList.length) {
                                $mdDialog.show({
                                    controller         : 'selectArticleDropReasonController',
                                    controllerAs       : 'vm',
                                    templateUrl        : 'app/main/catalogs/sub-modules/articles/dialogs/select-article-drop-reason/select-article-drop-reason.html',
                                    parent             : angular.element($document.body),
                                    targetEvent        : null,
                                    clickOutsideToClose: true,
                                    multiple: true,
                                    locals             : {
                                        dropReasons: api.articleDropReasonsList,
                                        articles: record,
                                        catalogId: activeCatalogId,
                                        articleReplacementAttributeId: vm.activeCatalog.ArticleReplacementAttributeId
                                    }
                                }).then(function(result) {
                                    if(result !== 'cancel') {
                                        vm.model.methods.activateBulk(record, vm.model, action.id, activeCatalogId, result).then(function() {
                                            refreshRecord(false);
                                        });
                                    }
                                });
                            } else {
                                vm.model.methods.activateBulk(record, vm.model, action.id, activeCatalogId).then(function() {
                                    refreshRecord(false);
                                });
                            }
                        }
                        break;
                    case 'activate':
                        vm.model.methods.activateBulk(record, vm.model, action.id, activeCatalogId).then(function() {
                            refreshRecord(false);
                        });
                        break;
                    case 'lock':
                    case 'unlock':
                        vm.model.methods.updateLockStatus(record, vm.model, action.id, activeCatalogId);
                        break;
                    case 'unAssign':
                        if(vm.activeCatalog.IsLinePlan !== 1) {
                            var promise = {suggestedArticles: vm.model.methods.getArticlesWithSameSizes(activeCatalogId, record[vm.model.idField], vm.activeCatalog.ArticleReplacementAttributeId)};
                            $mdDialog.show({
                                controller         : 'confirmDropController',
                                controllerAs       : 'vm',
                                templateUrl        : 'app/main/catalogs/sub-modules/articles/dialogs/confirm-drop/confirm-drop.html',
                                parent             : angular.element($document.body),
                                targetEvent        : null,
                                clickOutsideToClose: true,
                                locals             : {
                                    model : vm.model,
                                    record: record,
                                    actionObject: action,
                                    suggestedArticlesPromise: promise,
                                    dropReasons: api.articleDropReasonsList
                                }
                            }).then(function(result) {
                                if(result !== 'cancel') {
                                    vm.model.methods.activateBulk(record, vm.model, action.id, activeCatalogId, result).then(function() {
                                        refreshRecord(false);
                                    });
                                }
                            });
                        } else {
                            // show dropreasons popup if article drop reasons are added
                            if(articleDropReasonsList.length) {
                                $mdDialog.show({
                                    controller         : 'selectArticleDropReasonController',
                                    controllerAs       : 'vm',
                                    templateUrl        : 'app/main/catalogs/sub-modules/articles/dialogs/select-article-drop-reason/select-article-drop-reason.html',
                                    parent             : angular.element($document.body),
                                    targetEvent        : null,
                                    clickOutsideToClose: true,
                                    multiple: true,
                                    locals             : {
                                        dropReasons: api.articleDropReasonsList,
                                        articles: record,
                                        catalogId: activeCatalogId,
                                        articleReplacementAttributeId: vm.activeCatalog.ArticleReplacementAttributeId
                                    }
                                }).then(function(result) {
                                    if(result !== 'cancel') {
                                        vm.model.methods.activateBulk(record, vm.model, action.id, activeCatalogId, result).then(function() {
                                            refreshRecord(false);
                                        });
                                    }
                                });
                            } else {
                                vm.model.methods.activateBulk(record, vm.model, action.id, activeCatalogId).then(function() {
                                    refreshRecord(false);
                                });
                            }
                        }
                        break;
                    case 'assign':
                        if(record['IsAccessible'] == 0) {// if already assigned
                            vm.model.methods.activateBulk(record, vm.model, action.id, activeCatalogId).then(function() {
                                refreshRecord(false);
                            });
                        } else {
                            vm.model.methods.assignArticles(record, vm.model, vm.activeCatalog);
                            refreshRecord(false);
                        }
                        break;
                    case 'manageArticleStates':
                        var modelCopy = angular.copy(vm.model);
                        var stateIdField = utility.filterObject(modelCopy.fields, {field:'StateId'}, true)[0];
                        if(stateIdField) {
                            stateIdField.editable = true;
                        }
                        var sizeScaleIdField = utility.filterObject(modelCopy.fields, {field:'SizeScaleId', inputType: 'lookup'}, true)[0];
                        if(sizeScaleIdField) {
                            sizeScaleIdField.editable = true;
                        }
                        var masterSizeScaleIdField = utility.filterObject(modelCopy.fields, {field:'MasterSizeScaleId', inputType: 'lookup'}, true)[0];
                        if(masterSizeScaleIdField) {
                            masterSizeScaleIdField.editable = true;
                        }
                        // set all other attributes editable false
                        modelCopy.fields.forEach(function(field) {
                            if (field.field !== "StateId" && field.field !== "SizeScaleId" && field.field !== "ColorId" && field.field !== "MasterSizeScaleId") {
                                field.editable = false;
                                field.showInEdit = false;
                            }
                        });

                        var lookupPromises = {};
                        lookupPromises = crud.createLookupPromise(modelCopy, undefined , 'edit');
                        $mdDialog.show({
                            controller         : 'manageArticlesStateController',
                            controllerAs       : 'vm',
                            templateUrl        : 'app/main/catalogs/sub-modules/articles/dialogs/manage-articles-state/manage-articles-state.html',
                            parent             : angular.element($document.body),
                            targetEvent        : null,
                            clickOutsideToClose: false,
                            multiple           : true,
                            locals             : {
                                model: vm.model,
                                articles : [record],
                                catalogCode : activeCatalogId,
                                lookupPromises: lookupPromises,
                                event: null
                            }
                        })
                        .then(function(saved) {
                            if(saved) {
                                refreshRecord(false);
                            }
                        });
                        break;
                }
            }
        }

        function editArticle(record, ev) {
            var lookupExtras = {};
            var modelCopy = angular.copy(vm.model);
            var restrictedRetailWindowOnRole = (angular.isDefined(api.roleBasedRestrictions.restrictedRetailWindow) && !utility.isObjectEmpty(api.roleBasedRestrictions.restrictedRetailWindow)) ? api.roleBasedRestrictions.restrictedRetailWindow : undefined;

            // make retail window Fields creatable when "DummyArticleApplyRetailWindow" privilege is assigned
            if(isApplyRetailWindowPrivilegeIsAssigned && vm.activeCatalog.IsShippingWindowApply == 1 && record.AllowRetailWindowUpdate) {
                var retailIntroMonthField = utility.filterObject(modelCopy.fields, {field: 'RetailIntroMonthId', inputType: 'lookup'}, true)[0];
                var retailExitMonthField = utility.filterObject(modelCopy.fields, {field: 'RetailExitMonthId', inputType: 'lookup'}, true)[0];
                if(angular.isUndefined(restrictedRetailWindowOnRole)) {
                    retailIntroMonthField.editable = true;
                    retailExitMonthField.editable = true;
                } else if(angular.isDefined(restrictedRetailWindowOnRole) && restrictedRetailWindowOnRole.notEditable) {
                    retailIntroMonthField.editable = false;
                    retailExitMonthField.editable = false;
                }
            }

            if(vm.activeCatalog.IsShippingWindowApply == 1 && vm.activeCatalog.DataSourceTypeId === 3 && record.AllowRetailWindowUpdate) { // add activeCatalog.DataSourceTypeId === 3 condition temporarily to hide it for master article) {
                //create lookupExtras use to filter shipment range based on PShipmentStartDate
                if(vm.activeCatalog.DataSourceTypeId == 3) {
                    if(!record.PShipmentStartDate) {
                        $log.info('parent article does not have shipmentStartDate');
                    }
                    // lookup extra provided as a helper for get lookup method to filter appropriate shipment windows
                    lookupExtras['catalogs.retailIntroMonthsForArticle'] = {};
                    lookupExtras['catalogs.retailIntroMonthsForArticle']['parentArticle'] = { ShipmentStartDate: record.PShipmentStartDate };
                    lookupExtras['catalogs.retailIntroMonthsForArticle']['CatalogCode'] = vm.activeCatalog.CatalogCode;
                    // retail exit month
                    lookupExtras['catalogs.retailExitMonthsForArticle'] = {};
                    lookupExtras['catalogs.retailExitMonthsForArticle']['parentArticle'] = { ShipmentStartDate: record.PShipmentStartDate };
                    lookupExtras['catalogs.retailExitMonthsForArticle']['CatalogCode'] = vm.activeCatalog.CatalogCode;
                }
            }

            if(isAutomaticNumberingEnabled) {
                // if automatic numbering enabled and colorid is not null then make colorid field non editable.
                if(record.ColorId != null) {
                    var colorIdField = utility.filterObject(modelCopy.fields, {field: 'ColorId'}, true)[0];
                    if(angular.isDefined(colorIdField)) {
                        colorIdField.editable = false;
                    }
                }
            }

            //while editing carryover articles make sure linkedAttributes and articleName are disabled and cant be edited
            if(vm.activeCatalog.IsLinePlan === 1 && record.article_type && record.article_type.toLowerCase() === 'carryover' && activeCatalogDetails.LinkedAttributeList && activeCatalogDetails.LinkedAttributeList.length > 0) {
                angular.forEach(activeCatalogDetails.LinkedAttributeList, function (attributeObject) {
                        utility.filterObject(modelCopy.fields, {field: attributeObject.AttributeSystemName}, true)[0].validation.disabledCriteria = true;
                        utility.filterObject(modelCopy.fields, { field: 'ArticleName' }, true)[0].validation.disabledCriteria = true;
                })
            }

            // if state is assigned then make non editable attrbutes as non editable
            if(!isSpecialPermissionToIgnoreArticleStateIsAssigned && record.StateId != null) {
                var assignedState = utility.filterObject(api.articleStatesList, {StateId: record.StateId}, true)[0];
                if(assignedState && assignedState.NonEditableAttributes.length) {
                    angular.forEach(assignedState.NonEditableAttributes, function(attribute) {
                        var nonEditableAttrField = utility.filterObject(modelCopy.fields, {field: attribute.AttributeSystemName}, true)[0];
                        if(angular.isDefined(nonEditableAttrField)) {
                            nonEditableAttrField.editable = false;
                            nonEditableAttrField.showInEdit = true;
                            nonEditableAttrField['isAllowChangeRequestEnabled'] = attribute.AllowChangeRequest;
                            if(attribute.AllowChangeRequest) {
                                nonEditableAttrField['updateArticleChangeManagementExternalURL'] = updateArticleChangeManagementExternalURL;
                            }
                        }
                    });
                }
            }

            api.showEditRecordDialog(angular.element($document.body), ev, modelCopy, record, activeCatalogId, lookupExtras, {activeCatalogDetails: catalogFactory.getActiveCatalogDetails()})
                .then(function(saved) {
                    if (saved) {
                        refreshRecord(false);
                    }
                });
        }

        function doCRDItemAction(action, record) {
			if (action && record) {
                switch (action.id) {
                    case 'edit':
                    editCRD(record, null);
                        break;
                    case 'delete':
                    case 'activate':
                        vm.CRDModel.methods.activateBulk(record, angular.copy(allCRDs), vm.CRDModel, action.id, articleId, activeCatalogId);
                        break;
                }
			}
		}

        function doCRDsListAction(action, record) {
            if (action) {
                switch (action.id) {
                    case 'delete':
                    case 'activate':
                        vm.CRDModel.methods.activateBulk(record, angular.copy(allCRDs), vm.CRDModel, action.id, articleId, activeCatalogId);
                        break;
                }
            }
        }

        function addCRD(ev) {
            api.showCreateRecordDialog(angular.element($document.body), ev, vm.CRDModel, allCRDs , {'activeCatalogId' : activeCatalogId, 'ArticleId': articleId},undefined,undefined,angular.copy(allCRDs))
            .then(function(saved) {
                if (saved) {
                    refreshCRDs(true, false);
                }
            });
		}

        function editCRD(record, ev) {
            var recordCopy = angular.copy(record);
            recordCopy.AvailabilityFrom = utility.createDateObject(recordCopy.AvailabilityFrom);
            recordCopy.AvailabilityTo = utility.createDateObject(recordCopy.AvailabilityTo);
            recordCopy.activeCatalogId = activeCatalogId;
            api.showEditRecordDialog(angular.element($document.body), ev, vm.CRDModel, recordCopy, allCRDs)
            .then(function(saved) {
                if (saved) {
                    refreshCRDs(true, false);
                }
            });
        }

        function doResourcesItemAction(action, record) {
			if (action && record) {
                switch (action.id) {
                    case 'view':
                        viewResource(record);
                        break;
                    case 'delete':
                    case 'activate':
                        if(record.IsSeasonal === false) {
                            var sellerAccId = vm.activeCatalog.AccountId;
                            var sellerAttrGrpId = vm.activeCatalog.AttributeGroupId;
                            api.webPut(api.baseUrl + '/sellers/' + sellerAccId + '/' + sellerAttrGrpId + '/articles/' + articleId + '/resources/' + record[vm.resourcesModel.idField] + '/status', {Status: action.id === 'delete' ? 0 : 1})
                            .then(function() { refreshResources(true, false); });
                        } else {
                            var seasonalResources = vm.articleResources.filter(function(r) { return r.IsSeasonal !== false; });
                            vm.resourcesModel.methods.activateBulk(record, seasonalResources, vm.resourcesModel, action.id, articleId, activeCatalogId).then(function() {
                                crud.removeDeletedRecords(vm.articleResources, record);
                                refreshResources(false, false);
                            });
                        }
                        break;
                }
			}
        }

        function doResourcesListAction(action, records) {
            if (action) {
                switch (action.id) {
                    case 'delete':
                    case 'activate':
                        unassignArticleResources(records, action.id);
                        break;
                }
            }
        }

        function unassignArticleResources(recordsToRemove, actionId) {
            var seasonalRecordsToRemove = recordsToRemove.filter(function(r) { return r.IsSeasonal !== false; });
            var sellerRecordsToRemove = recordsToRemove.filter(function(r) { return r.IsSeasonal === false; });
            var promises = [];

            // Catalog: use existing unassign method with filtered seasonal list
            if(seasonalRecordsToRemove.length > 0) {
                var seasonalResources = vm.articleResources.filter(function(r) { return r.IsSeasonal !== false; });
                promises.push(vm.resourcesModel.methods.activateBulk(seasonalRecordsToRemove, seasonalResources, vm.resourcesModel, actionId, articleId, activeCatalogId));
            }

            // Seller: send remaining seller resource IDs via assignresources
            if(sellerRecordsToRemove.length > 0) {
                var sellerDeleteIds = sellerRecordsToRemove.map(function(r) { return r[vm.resourcesModel.idField]; });
                var remainingSellerIds = vm.articleResources
                    .filter(function(r) { return r.IsSeasonal === false && r.Status !== 0 && sellerDeleteIds.indexOf(r[vm.resourcesModel.idField]) === -1; })
                    .map(function(r) { return r[vm.resourcesModel.idField]; });
                var sellerAccId = vm.activeCatalog.AccountId;
                var sellerAttrGrpId = vm.activeCatalog.AttributeGroupId;
                promises.push(api.webPut(api.baseUrl + '/sellers/' + sellerAccId + '/' + sellerAttrGrpId + '/articles/' + articleId + '/assignresources', { ResourceId: remainingSellerIds }));
            }

            $q.all(promises).then(function() {
                crud.removeDeletedRecords(vm.articleResources, recordsToRemove);
                refreshResources(true, false);
            });
        }

        function viewResource(record) {
            var id = record[vm.resourcesModel.idField];
            if(record.IsSeasonal === false) {
                $state.go('app.seller-resources.details', {id: id});
            } else {
                $state.go('app.resources.details', {id: id});
            }
        }

        function addResource(ev) {
            var lookupPromises = {};
            var resourcesModel = api.catalogs.resources;
            var sellerAccountId = vm.activeCatalog.AccountId;
            var sellerAttrGroupId = vm.activeCatalog.AttributeGroupId;
            // Fetch catalog resources excluding those linked to models
            lookupPromises['ResourceId'] = api.webGet(api.baseUrl + '/catalogs/' + activeCatalogId + '/resources?excludeLinked=models', undefined, true, true)
            .then(function(response) {
                var lookupData = (response.data || []).map(function(item) {
                    return { id: item[resourcesModel.idField], value: item[resourcesModel.lookupDisplayField], Status: item.Status, _source: 'catalog' };
                });
                return { data: lookupData };
            });
            // Fetch seller resources
            lookupPromises['SellerResourceId'] = api.webGet(api.baseUrl + '/sellers/' + sellerAccountId + '/' + sellerAttrGroupId + '/resources', undefined, true, true)
            .then(function(response) {
                var lookupData = (response.data || []).map(function(item) {
                    return { id: item[resourcesModel.idField], value: item[resourcesModel.lookupDisplayField], Status: item.Status, _source: 'seller' };
                });
                return { data: lookupData };
            });
            $mdDialog.show({
                controller         : 'assignResourcesController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/catalogs/sub-modules/articles/details/tabs/resources/dialogs/assign-resources.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: false,
                locals             : {
                    articleId: articleId,
                    activeCatalogId: activeCatalogId,
                    sellerId: sellerAccountId,
                    sellerAttributeGroupId: sellerAttrGroupId,
                    model: vm.resourcesModel,
                    assignedResources: vm.articleResources,
                    lookupPromises: lookupPromises,
                    event: ev
                }
            }).then(function(saved) {
                if (saved) {
                    refreshResources(true, false);
                }
            });
            // api.showCreateRecordDialog(angular.element($document.body), ev, vm.resourcesModel, vm.articleResources , {'activeCatalogId' : activeCatalogId, 'articleId': articleId})
            // .then(function(saved) {
            //     if (saved) {
            //         refreshRecord();
            //     }
            // });
        }

        //Item Action button pressed event
		function doImagesItemAction(action, record) {
			if (action && record) {
                switch (action.id) {
                    case 'view':
                        viewImage(record);
                        break;
                    case 'edit':
                        editImage(record, null);
                        break;
                    case 'delete':
                    case 'activate':
                        vm.imagesModel.methods.activateBulk(record, vm.imagesModel, action.id, assignedContextKey);
                        break;
                }
			}
		}

        //List Action button pressed event
        function doImagesListAction(action, records) {
            if (action) {
                switch (action.id) {
                    case 'delete':
                    case 'activate':
                        vm.imagesModel.methods.activateBulk(records, vm.imagesModel, action.id, assignedContextKey);
                        break;
                }
            }
        }

        function viewImage(item) {
            if(item.Status === 1) {
                var id = item[vm.imagesModel.idField];
                var stateParams = {id: id, image: item};
                $state.go('app.images.details', stateParams);
            }
        }

        function addImage(ev) {
            $mdDialog.show({
                controller         : 'uploadDuneImageController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/catalogs/sub-modules/dune-images/dialogs/upload-dune-image/upload-dune-image.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: false,
                locals             : {
                    model: vm.imagesModel,
                    record: null,
                    isNew: true,
                    contextKey: assignedContextKey,
                    duneContext: duneContext,
                    isEditSortOrder: false,
                    event: ev
                }
            }).then(function(saved) {
                if (saved) {
                    refreshImages(true);
                }
            });
		}

		function editImage(record, ev) {
            $mdDialog.show({
                controller         : 'uploadDuneImageController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/catalogs/sub-modules/dune-images/dialogs/upload-dune-image/upload-dune-image.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: false,
                locals             : {
                    model: vm.imagesModel,
                    record: angular.copy(record),
                    isNew: false,
                    contextKey: assignedContextKey,
                    duneContext: duneContext,
                    isEditSortOrder: false,
                    event: ev
                }
            }).then(function(saved) {
                if (saved) {
                    refreshImages(true);
                }
            });
		}

        function doSizesItemAction(action, record, additionalInfo) {
			if (action && record) {
                switch (action.id) {
                    case 'edit':
                        editSize(record, null);
                        break;
                    case 'delete':
                    case 'activate':
                        vm.sizesModel.methods.activateBulk(record, vm.sizesModel, action.id, articleId, additionalInfo).then(function() {
                            refreshSizes(true, false);
                        });
                        break;
                }
			}
		}

        function doSizesListAction(action, record, additionalInfo) {
            if (action) {
                switch (action.id) {
                    case 'delete':
                    case 'activate':
                        vm.sizesModel.methods.activateBulk(record, vm.sizesModel, action.id, articleId, additionalInfo).then(function() {
                            refreshSizes(true, false);
                        });
                        break;
                }
            }
        }

        function addSize(ev) {
            var modelClone = angular.copy(vm.sizesModel);
            if (vm.activeCatalog.DataSourceTypeId == 1) {
                api.showCreateRecordDialog(angular.element($document.body), ev, modelClone, articleId, { 'activeCatalogId': activeCatalogId })
                    .then(function (saved) {
                        if (saved) {
                            refreshSizes(true, false);
                        }
                    });
            }
            else {
                var promise = { parentSizes: vm.sizesModel.methods.getList({ forceFetch: true, isLogRequired: false }, vm.article[vm.model.idField], vm.activeCatalog.ReferenceCatalogCode) };
                $mdDialog.show({
                    controller: 'assignSizeController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/catalogs/sub-modules/articles/details/tabs/sizes/dialogs/assign-size/assign-size.html',
                    parent: angular.element($document.body),
                    targetEvent: ev,
                    clickOutsideToClose: false,
                    locals: {
                        assignedSizes: vm.articleSizes,
                        inheritedArticleSizes: allSizes,
                        model: vm.sizesModel,
                        activeCatalog: vm.activeCatalog,
                        articleId: vm.article[vm.model.idField],
                        dataPromise: promise
                    }
                }).then(function (saved) {
                    if (saved) {
                        refreshSizes(true, false);
                    }
                });
            }
        }

        function editSize(record, ev) {
            var modelClone = angular.copy(vm.sizesModel);
            //Add NewSizeName and NewSizeIndex to record and assign them with SizeName and SizeIndex to pre populate the edit dialog with old values
            record.NewSizeName = record.SizeName;
            record.NewSizeIndex = record.SizeIndex;
            api.showEditRecordDialog(angular.element($document.body), ev, modelClone, record, { 'activeCatalogId': activeCatalogId, 'ArticleId': articleId })
                .then(function (saved) {
                    if (saved) {
                        refreshSizes(true, false);
                    }
                });
        }

        function doPricesItemAction(action, record) {
            if (action && record) {
                switch (action.id) {
                    case 'edit':
                        editPrice(record, null);
                        break;
                }
            }
        }

        function addPrice(ev) {
            var assignedPriceGroups = {};
            assignedPriceGroups.data = angular.copy(vm.articlePrices);
            var lookupPromises = {};
            lookupPromises = crud.createLookupPromise(vm.pricesModel, undefined , 'create');
            return $mdDialog.show({
                controller: 'createArticlePriceController',
                controllerAs: 'vm',
                templateUrl: 'app/main/catalogs/sub-modules/articles/details/tabs/prices/dialogs/create-article-price.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: false,
                locals: {
                    articleId: articleId,
                    activeCatalogId: activeCatalogId,
                    model: vm.pricesModel,
                    assignedPriceGroupsPromise: $q.when(assignedPriceGroups),
                    lookupPromises: lookupPromises,
                    articleStateId: vm.article.StateId,
                    event: ev
                }
            }).then(function (saved) {
                if (saved) {
                    refreshPrices(true, false);
                }
            });
        }

        function editPrice(record, ev) {
            var modelClone = angular.copy(vm.pricesModel);
            var priceField = utility.filterObject(modelClone.fields, { field: 'price' }, true)[0];
            // change prices regex based on price group mandatory flag
            var editPriceGroup = utility.filterObject(catalogPriceGroupList, {Id: record.PriceGroupId}, true)[0];
            if(editPriceGroup && editPriceGroup.IsMandatory === 1) {
                priceField.validation.pattern = '^[+]?((\\d*[1-9]\\d*)([.]\\d{0,'+ api.numberOfDecimalsForPrices +'})?)$';
                priceField.validation.messages.pattern = 'Invalid price value, Should be greater than 0 with no more than '+ api.numberOfDecimalsForPrices +' decimals.';
                priceField.validation.isRequired = true;
            } else {
                priceField.validation.pattern = '^[+]?\\d+([.]\\d{0,'+ api.numberOfDecimalsForPrices +'})?$';
                priceField.validation.messages.pattern = 'Invalid price value, Should be a positive number and not contain more than '+ api.numberOfDecimalsForPrices +' decimals.';
            }

            // if state is assigned then validate non editable price groups
            if(!isSpecialPermissionToIgnoreArticleStateIsAssigned && vm.article.StateId != null) {
                var assignedPriceGroup = utility.filterObject(catalogPriceGroupList, {Id: record.PriceGroupId}, true)[0];
                if(vm.activeCatalog.IsPriceByStyleApply) { // IsPriceByStyleApply is enabled check the article state with height model state rank
                    var assignedModelState = utility.filterObject(api.articleStatesList, {StateId: vm.article.ModelStateId}, true)[0];
                    if(assignedModelState && (assignedPriceGroup && angular.isDefined(assignedPriceGroup.StateRank))) {
                        if(assignedModelState.ModelStateRank >= assignedPriceGroup.StateRank) {
                            priceField.editable = false;
                            priceField.showInEdit = true;
                            priceField['isAllowChangeRequestEnabled'] = assignedPriceGroup.AllowChangeRequestForPriceGroups;
                            if(assignedPriceGroup.AllowChangeRequestForPriceGroups && updatePricesChangeManagementExternalURL != '') {
                                priceField['updateArticleChangeManagementExternalURL'] = updateArticleChangeManagementExternalURL;
                            }
                        }
                    }
                } else { // IsPriceByStyleApply is disabled check the article state with height article state rank
                    var assignedArticleState = utility.filterObject(api.articleStatesList, {StateId: vm.article.StateId}, true)[0];
                    if(assignedArticleState && (assignedPriceGroup && angular.isDefined(assignedPriceGroup.StateRank))) {
                        if(assignedArticleState.StateRank >= assignedPriceGroup.StateRank) {
                            priceField.editable = false;
                            priceField.showInEdit = true;
                            priceField['isAllowChangeRequestEnabled'] = assignedPriceGroup.AllowChangeRequestForPriceGroups;
                            if(assignedPriceGroup.AllowChangeRequestForPriceGroups && updatePricesChangeManagementExternalURL != '') {
                                priceField['updateArticleChangeManagementExternalURL'] = updateArticleChangeManagementExternalURL;
                            }
                        }
                    }
                }
            }
            api.showEditRecordDialog(angular.element($document.body), ev, modelClone, record, activeCatalogId)
                .then(function (saved) {
                    if (saved) {
                        refreshPrices(true, false);
                    }
                });
        }

        function doSegmentationItemAction(action, record) {
            if (action && record) {
                switch (action.id) {
                    case 'delete':
                    case 'activate':
                        vm.segmentationModel.methods.activateBulk(record, vm.segmentationModel, action.id, {'activeCatalogId' : activeCatalogId, 'articleId': articleId}).then(function() {
                            refreshSegmentations(true, false);
                        });
                        break;
                }
			}
        }

        function doSegmentationListAction(action, record) {
            if (action) {
                switch (action.id) {
                    case 'delete':
                    case 'activate':
                        vm.segmentationModel.methods.activateBulk(record, vm.segmentationModel, action.id, {'activeCatalogId' : activeCatalogId, 'articleId': articleId}).then(function() {
                            refreshSegmentations(true, false);
                        });
                        break;
                }
            }
        }

        function addSegmentation(ev) {
            var articleSegmentation = {};
            articleSegmentation.data = angular.copy(vm.articleSegmentation);
            var lookupPromises = {};
            lookupPromises = crud.createLookupPromise(vm.segmentationModel, undefined , 'create');
            $mdDialog.show({
                controller         : 'assignSegmentationToArticleController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/catalogs/sub-modules/articles/details/tabs/segmentation/dialogs/assign-segmentation-to-article.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: false,
                locals             : {
                    model: vm.segmentationModel,
                    assignedSegmentationsPromise: $q.when(articleSegmentation),
                    activeCatalog: vm.activeCatalog,
                    articleId: articleId,
                    lookupPromises: lookupPromises,
                    event: ev,
                    isArticleListAction: false
                }
            }).then(function(saved) {
                if (saved) {
                    refreshSegmentations(true, false);
                }
            });
        }

        function loadMoreAuditHistory() {
            vm.articleAuditTrailHistoryLimit += 5;
        }

        function doArticleRelationsItemAction(action, record) {
            if (action && record) {
                switch (action.id) {
                    case 'delete':
                        vm.articleRelationsModel.methods.activateBulk(record, vm.articleRelationsModel, action.id, activeCatalogId).then(function () {
                            refreshArticleRelations(true, false);
                        });
                        break;
                }
            }
        }

        function addArticleRelations(ev) {
            api.showCreateRecordDialog(angular.element($document.body), ev, vm.articleRelationsModel, articleId,  undefined, undefined, {isDefaultSelectedFieldValueAdded: { EntityId: 1 }})
            .then(function (saved) {
                if (saved) {
                    refreshArticleRelations(true, false);
                }
            });
        }

    }
})();
(function() {
		'use strict';

		angular
				.module('app.main.catalogs.watch-filters', [])
				.config(config);

		/* @ngInject */
		function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {

				$stateProvider.state('app.watch_filters', {
						url    : '/watch-filters',
						views  : {
								'content@app': {
										templateUrl: 'app/main/catalogs/sub-modules/article-watch-filters/list/article-watch-filters-list.html',
										controller : 'watchFiltersListController as vm'
								}
						},
						resolve: {},
						data: {
								displayName: 'WATCH_FILTERS.NAV'
						},
						// accessPrivileges: ['GetAllCatalogWatchedFilters']
						// accessPrivileges: ['nav_article_change_logs']
						accessInfo: {
								accessPrivileges: ['nav_article_change_logs']
						},
						visibleForLinePlan: true
				});

				$stateProvider.state('app.watch_filters.details', {
					url	 : '/:id',
								views: {
						'content@app': {
							templateUrl: 'app/main/catalogs/sub-modules/article-watch-filters/details/article-watch-filters-details.html',
							controller : 'watchFilterDetailsController as vm'
						}
					},
					data: {
						parentState: 'app.watch_filters',
										displayName: 'WATCH_FILTERS.TABS.WATCH_FILTER'
					},
								//only users with following accessPrivileges in their role access list can access this route
								// accessPrivileges: ['GetAllCatalogWatchedFilters']
								accessInfo: {
										accessPrivileges: ['GetAllCatalogWatchedFilters']
								},
								visibleForLinePlan: true
				});

				// Translation
				$translatePartialLoaderProvider.addPart('app/main/catalogs/sub-modules/article-watch-filters');

				// Navigation
				msNavigationServiceProvider.saveItem('catalogs.article-change-logs.watch-filters', {
						title      : 'Watch Filters',
						subTitle   : 'Article Change Logs',
						icon       : 'icon-alert-box',
						state      : 'app.watch_filters',
						translate  : 'WATCH_FILTERS.NAV',
						weight     : 31.5,
						// accessPrivileges: ['GetAllCatalogWatchedFilters']
						// accessPrivileges: ['nav_article_change_logs']
						accessInfo: {
								accessPrivileges: ['nav_article_change_logs']
						},
						visibleForLinePlan: true
				});
		}

})();
(function () {
	'use strict';

	angular
		.module('app.main.catalogs.watch-filters')
		.controller('watchFiltersListController', watchFiltersListController);

	/* @ngInject */
	function watchFiltersListController(api, $rootScope, $scope, $state, catalogFactory, dataImporter, settingsFactory, $document, utility, $localStorage) {
		/* jshint validthis: true */
		var vm = this;

		//Data
		var activeCatalog = catalogFactory.getActiveCatalog();
		var catalogCode = activeCatalog.CatalogCode;

		vm.model = api.catalogs.watchFilters;
		settingsFactory.applyPersistedListViewLayout(vm.model);

		vm.watchFilters = [];
		vm.filteredWatchFilters = [];
		vm.isLoading = false;


		//Methods
		vm.refreshItems = refreshItems;
		vm.doListAction = doListAction;
		vm.doItemAction = doItemAction;
		vm.viewItem = viewItem;
		vm.addRecord = addRecord;

		activate();

		////////////////

		function activate() {
			refreshItems(vm.model.isDirty, true);
		}

		function refreshItems(forceFetch, isLogRequired) {
			vm.isLoading = true;
			var generalProperties = {
				forceFetch: forceFetch,
				isLogRequired: isLogRequired
			}
			vm.model.methods.getList(generalProperties, vm.model, catalogCode)
				.then(function (response) {
					vm.watchFilters = response.data;
				})
				.finally(function () {
					vm.isLoading = false;
				});
		}

		//List Action button pressed event
		function doListAction(action, records) {
			if (action) {
				switch (action.id) {
					case 'import':
						var modelCopy = angular.copy(vm.model);
						if($localStorage.account && $localStorage.account.accountType === '1') {
							var userNameField = utility.filterObject(modelCopy.fields, {field: 'UserName'}, true)[0];
							userNameField.creatable = true;
						}
						dataImporter.importExcel(modelCopy, true).then(function (result) {
							vm.model.methods.createBulk(result.data, catalogCode, vm.model)
							.then(function() {
								refreshItems(true, false);
							});
						});
						break;
					case 'delete':
					case 'activate':
						vm.model.methods.activateBulk(records, vm.model, action.id, catalogCode);
						break;
				}
			}
		}

		//Item Action button pressed event
		function doItemAction(action, record) {
			if (action && record) {
				switch (action.id) {
					case 'view':
						viewItem(record);
						break;
					case 'delete':
					case 'activate':
						vm.model.methods.activateBulk(record, vm.model, action.id, catalogCode);
						break;
				}
			}
		}

		function addRecord(ev) {
			var modelCopy = angular.copy(vm.model);
			if($localStorage.account && $localStorage.account.accountType === '1') {
				var userIdField = utility.filterObject(modelCopy.fields, {field: 'UserId', visible: false}, true)[0];
				userIdField.creatable = true;
			}
			var existingRecordsForUniqueValue = angular.copy(vm.watchFilters);
			api.showCreateRecordDialog(angular.element($document.body), ev, modelCopy, catalogCode, undefined, undefined, undefined, undefined, existingRecordsForUniqueValue)
			.then(function (saved) {
					if (saved) {
						refreshItems(true, false);
					}
				});
		}

		function viewItem(record) {
			var id = record[vm.model.idField];
			var stateParams = { id: id };
			$state.go('app.watch_filters.details', stateParams);
		}

		var catalogChangedEventCleanup = $rootScope.$on('ActiveCatalogChangedEvent', function (e) {
			if (catalogCode !== catalogFactory.getActiveCatalog().CatalogCode) {
				$state.reload('app.watch_filters');
			}
		});

		$scope.$on('$destroy', function () {
			catalogChangedEventCleanup();
		});

	}
})();
(function() {
'use strict';

	angular
		.module('app.main.catalogs.watch-filters')
		.controller('watchFilterDetailsController', watchFilterDetailsController);

	/* @ngInject */
	function watchFilterDetailsController(api, $state, $rootScope, $stateParams, catalogFactory) {
		/* jshint validthis: true */
		var vm = this;

		// Data
		var watchFilterID = $stateParams.id;
		var activeCatalog = catalogFactory.getActiveCatalog();
		var catalogCode = activeCatalog.CatalogCode;

		vm.model = api.catalogs.watchFilters;

		vm.watchFilter = {};


		// Methods
		vm.isLoading = false;
		vm.refreshRecord = refreshRecord;


		activate();

		////////////////

		function activate() {
			refreshRecord(true);
		}

		function refreshRecord(isLogRequired) {
			vm.isLoading = true;

			vm.model.methods.getDetails(isLogRequired, watchFilterID, catalogCode)
				.then(function (response) {
					vm.watchFilter = response.data[0];
					vm.title = angular.copy(vm.watchFilter[vm.model.lookupDisplayField]);

					//Update Breadcrumb
					$state.current.data.displayName = vm.title;
					$rootScope.$broadcast('breadcrumb-updated');
				})
				.finally(function () {
					vm.isLoading = false;
				});
		}

	}
})();
(function () {
  'use strict';

  angular
      .module('app.main.catalogs.article-color', [])
      .config(config);

  /* @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
      // State
      $stateProvider.state('app.article_color', {
          url    : '/article-color',
          views  : {
              'content@app': {
                  templateUrl: 'app/main/catalogs/sub-modules/article-color/list/article-color-list.html',
                  controller : 'articleColorListController as vm'
              }
          },
          resolve: {
          },
          data: {
              displayName: 'ARTICLE_COLOR.NAV'
          },
          //only users with following accessPrivileges in their role access list can access this route
          // accessPrivileges: ['GetAllArticlesColor']
          // accessPrivileges: ['nav_article_colors']
          accessInfo: {
              accessPrivileges: ['nav_article_colors']
          },
          visibleForLinePlan: true
      });

      // Translation
      $translatePartialLoaderProvider.addPart('app/main/catalogs/sub-modules/article-color');

      // Navigation

      msNavigationServiceProvider.saveItem('catalogs.article_color', {
          title      : 'Article Color',
          icon       : 'icon-format-paint',
          state      : 'app.article_color',
          translate  : 'ARTICLE_COLOR.NAV',
          weight     : 33,
          // accessPrivileges: ['GetAllArticlesColor']
          // accessPrivileges: ['nav_article_colors'],
          accessInfo: {
              accessPrivileges: ['nav_article_colors']
          },
          visibleForLinePlan: true
      });
  }
})();
(function() {
  'use strict';

angular
  .module('app.main.catalogs.article-color')
  .controller('articleColorListController', articleColorListController);

  /* @ngInject */
  function articleColorListController(api, $rootScope, $scope, $state, $document, catalogFactory, utility, bulkUpdater , dataImporter, settingsFactory, toast, crud) {
    /* jshint validthis: true */
    var vm = this;

    //Data
    var activeCatalog = catalogFactory.getActiveCatalog();
    var catalogCode = activeCatalog.CatalogCode;

    vm.model = api.catalogs.articleColor;
    settingsFactory.applyPersistedListViewLayout(vm.model);

    vm.articleColorList = [];
    vm.filteredArticleColorList = [];
    vm.isLoading = false;


    //Methods
    vm.refreshItems = refreshItems;
    vm.doListAction = doListAction;
    vm.doItemAction = doItemAction;
    vm.viewItem = viewItem;
    vm.addRecord = addRecord;

    activate();

    ////////////////

    function activate() {
      refreshItems(vm.model.isDirty, true);
    }

    function refreshItems(forceFetch, isLogRequired) {
      vm.isLoading = true;
      var generalProperties = {
        forceFetch: forceFetch,
        isLogRequired: isLogRequired
      }
      vm.model.methods.getList(generalProperties, vm.model, catalogCode)
      .then(function (response) {
        vm.articleColorList = response.data;
      })
      .finally(function () {
        vm.isLoading = false;
      });
    }

    //Item Action button pressed event
    function doItemAction(action, record) {
      if (action && record) {
        switch (action.id) {
          case 'view':
            viewItem(record);
            break;
          case 'edit':
            editItem(record, null);
            break;
          case 'activate':
          case 'delete':
            vm.model.methods.activateBulk(record, vm.model, action.id, catalogCode).then(function() {
              refreshItems(true, false);
            });
            break;
        }
      }
    }

    //List Action button pressed event
    function doListAction(action, records) {
      if (action) {
        switch (action.id) {
          case 'activate':
          case 'delete':
            vm.model.methods.activateBulk(records, vm.model, action.id, catalogCode).then(function() {
              refreshItems(true, false);
            });
            break;
          case 'import':
            var modelCopy = angular.copy(vm.model);
            utility.filterObject(modelCopy.fields, {field: 'ArticleId'}, true)[0].creatable = false;
            utility.filterObject(modelCopy.fields, {field: 'ColorId'}, true)[0].creatable = false;
            utility.filterObject(modelCopy.fields, {field: 'ArticleNumber'}, true)[0].creatable = true;
            utility.filterObject(modelCopy.fields, {field: 'ColorName'}, true)[0].creatable = true;
            dataImporter.importExcel(modelCopy, true).then(function (result) {
              vm.model.methods.createBulk(result.data, catalogCode, vm.model);
            });
            break;
          case 'updateBulk':
            var modelCopy = angular.copy(vm.model);
            utility.filterObject(modelCopy.fields, {field: 'ColorId'}, true)[0].validation.disabledCriteria = '';
            var lookupPromises = {};
            lookupPromises = crud.createLookupPromise(modelCopy, undefined , 'edit');
            bulkUpdater.showDialog(modelCopy, vm.articleColorList, {'id1': catalogCode}, lookupPromises).then(function(response) {
              if(angular.isDefined(response) && response.toString() != 'false') {
                toast.success('ARTICLE_COLOR.MESSAGES.UPDATE_SUCCESS', '', '');
                refreshItems(true, false);
              }
            });
            break;
        }
      }
    }

    function viewItem(record) {
      var stateParams = {};
      stateParams.id = record['ArticleId'];
      $state.go('app.articles.details', stateParams)
    }

    function addRecord(ev) {
      var lookupExtras = {};
			lookupExtras['catalogs.colorDefinition'] = {};
			lookupExtras['catalogs.colorDefinition']['id1'] = catalogCode;
			api.showCreateRecordDialog(angular.element($document.body), ev, vm.model, catalogCode, null, lookupExtras)
			.then(function(saved) {
				if (saved) {
					refreshItems(true, false);
				}
			});
    }

    function editItem(record, ev) {
      var lookupExtras = {};
			lookupExtras['catalogs.colorDefinition'] = {};
			lookupExtras['catalogs.colorDefinition']['id1'] = catalogCode;
      api.showEditRecordDialog(angular.element($document.body), ev, vm.model, record, catalogCode, lookupExtras)
      .then(function (saved) {
        if (saved) {
          refreshItems(true, false);
        }
      });
    }

    var catalogChangedEventCleanup = $rootScope.$on('ActiveCatalogChangedEvent', function(e) {
      if(catalogCode !== catalogFactory.getActiveCatalog().CatalogCode) {
        $state.reload('app.article_color');
      }
    });

    $scope.$on('$destroy', function () {
      catalogChangedEventCleanup();
    });
  }
})();
(function () {
	'use strict';

	angular
		.module('app.main.catalogs.article-change-logs', [])
		.config(config);

	/* @ngInject */
	function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
		// State
		$stateProvider.state('app.article_change_logs', {
			url: '/article-change-logs',
			views: {
				'content@app': {
					templateUrl: 'app/main/catalogs/sub-modules/article-change-logs/list/article-change-logs-list.html',
					controller: 'articleChangeLogsController as vm'
				}
			},
			data: {
				displayName: 'ARTICLE_CHANGE_LOGS.NAV'
			},
			resolve: {},
			//only users with following accessPrivileges in their role access list can access this route
			// accessPrivileges: ['GetAllCatalogWatchedFilters']
			// accessPrivileges: ['nav_article_change_logs']
			accessInfo: {
				accessPrivileges: ['nav_article_change_logs']
			},
			visibleForLinePlan: true
		});

		// Translation
		$translatePartialLoaderProvider.addPart('app/main/catalogs/sub-modules/article-change-logs');

		msNavigationServiceProvider.saveItem('catalogs.article-change-logs', {
			title: 'Article Change Logs',
			icon: 'icon-alert-box',
			translate: 'ARTICLE_CHANGE_LOGS.NAV',
			weight: 36,
			// accessPrivileges: ['GetAllCatalogWatchedFilters']
			// accessPrivileges: ['nav_article_change_logs']
			accessInfo: {
				accessPrivileges: ['nav_article_change_logs']
			},
			visibleForLinePlan: true
		});

		msNavigationServiceProvider.saveItem('catalogs.article-change-logs.change-logs', {
			title: 'Change Logs',
			subTitle: 'Article Change Logs',
			icon: 'icon-alert-box',
			state: 'app.article_change_logs',
			translate: 'CHANGE_LOGS.NAV',
			weight: 36,
			// accessPrivileges: ['GetAllCatalogWatchedFilters']
			// accessPrivileges: ['nav_article_change_logs']
			accessInfo: {
				accessPrivileges: ['nav_article_change_logs']
			},
			visibleForLinePlan: true
		});
	}
})();
(function() {
	'use strict';

	angular
		.module('app.main.catalogs.article-change-logs')
		.controller('articleChangeLogsController', articleChangeLogsController);

	/* @ngInject */
	function articleChangeLogsController(api, $rootScope, $scope, $state, catalogFactory) {
		/* jshint validthis: true */
		var vm = this;

		//Data
		var activeCatalog = catalogFactory.getActiveCatalog();
		var activeCatalogCode = activeCatalog.CatalogCode;

		vm.model = api.catalogs.articleChangeLogs;

		vm.changeLogs = [];
		vm.filteredChangeLogs = [];

		vm.isLoading = false;


		//Methods
		vm.refreshItems = refreshItems;


		activate();


		////////////////

		function activate() {
			refreshItems(vm.model.isDirty, true);
		}

		function refreshItems(forceFetch, isLogRequired) {
			var generalProperties = {
				forceFetch: forceFetch,
				isLogRequired: isLogRequired,
				filterByDate: vm.model.views.mainList.filterByDate
			}
			vm.isLoading = true;
			vm.model.methods.getList(generalProperties, activeCatalogCode).then(function (response) {
					vm.changeLogs = response.data;
			}).finally(function () {
				vm.isLoading = false;
			});
		}

		var catalogChangedEventCleanup = $rootScope.$on('ActiveCatalogChangedEvent', function(e) {
			if(activeCatalogCode !== catalogFactory.getActiveCatalog().CatalogCode) {
				$state.reload('app.article_change_logs');
			}
		});

		$scope.$on('$destroy', function () {
			catalogChangedEventCleanup();
		});

	}
})();
(function () {
  'use strict';

  angular
    .module('app.main.catalogs.allocation-groups')
    .controller('allocationGroupsListController', allocationGroupsListController);
  // TODO - create and update
  /* @ngInject */
  function allocationGroupsListController(api, $rootScope, $scope, $state, $document, $mdDialog, catalogFactory, dataImporter, settingsFactory) {
    /* jshint validthis: true */
    var vm = this;

    //Data
    var activeCatalogCode = catalogFactory.getActiveCatalog().CatalogCode;

    vm.model = api.catalogs.allocationGroups;
    settingsFactory.applyPersistedListViewLayout(vm.model);

    vm.allocationGroups = [];
    vm.filteredAllocationGroups = [];
    vm.isLoading = false;

    //Methods
    vm.refreshItems = refreshItems;
    vm.doListAction = doListAction;
    vm.doItemAction = doItemAction;
    vm.viewItem = viewItem;
    vm.addRecord = addRecord;

    activate();

    ////////////////

    function activate() {
      refreshItems(vm.model.isDirty, true);
    }

    function refreshItems(forceFetch, isLogRequired) {
      var generalProperties = {
        forceFetch: forceFetch,
        isLogRequired: isLogRequired
      }
      vm.isLoading = true;
      return vm.model.methods.getList(generalProperties, vm.model, activeCatalogCode)
        .then(function (response) {
          vm.allocationGroups = response.data;
        }).finally(function () {
          vm.isLoading = false;
        });
    }

    //Item Action button pressed event
    function doItemAction(action, record) {
      if (action && record) {
        switch (action.id) {
          case 'view':
            viewItem(record);
            break;
          case 'edit':
            vm.model.methods.getDetails(true, record[vm.model.idField], activeCatalogCode)
            .then(function (response) {
              editItem(response.data, null);
            })
            break;
          case 'delete':
          case 'activate':
            vm.model.methods.activateBulk(record, vm.model, action.id, activeCatalogCode);
            break;
        }
      }
    }

    //List Action button pressed event
    function doListAction(action, records) {
      if (action) {
        switch (action.id) {
          case 'delete':
          case 'activate':
            vm.model.methods.activateBulk(records, vm.model, action.id, activeCatalogCode);
            break;
          case 'import':
            dataImporter.importExcel(vm.model, true).then(function (result) {
              vm.model.methods.createBulk(vm.model, result.data, activeCatalogCode);
            })
            break;
        }
      }
    }

    function viewItem(item, event) {
      var id = item[vm.model.idField];
      var stateParams = { id: id };
      $state.go('app.allocation_groups.details', stateParams);
    }

    function addRecord(ev) {
      var articleModel = api.catalogs.articles;
      var promises = {};
      var generalProperties = {
        forceFetch: true,
        isLogRequired: false,
        config: {},
        supportIncrementalResult: true,
        isMajor: false,
        modelIdField: vm.model.idField
      }
      promises['catalogArticlesPromise'] = articleModel.methods.getList(generalProperties, articleModel, activeCatalogCode);
      $mdDialog.show({
        controller: 'updateAllocationGroupsController',
        controllerAs: 'vm',
        templateUrl: 'app/main/catalogs/sub-modules/allocation-groups/dialogs/update-allocation-group.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: false,
        locals: {
          record: null,
          isNew: true,
          model: vm.model,
          promises: promises,
          activeCatalogCode: activeCatalogCode,
          event: ev
        }
      }).then(function(saved) {
        if (saved) {
            refreshItems(true, false);
        }
      });
    }

    function editItem(item, ev) {
      var articleModel = api.catalogs.articles;
      var promises = {};
      var generalProperties = {
        forceFetch: true,
        isLogRequired: false,
        config: {},
        supportIncrementalResult: true,
        isMajor: false,
        modelIdField: vm.model.idField
      }
      promises['catalogArticlesPromise'] = articleModel.methods.getList(generalProperties, articleModel, activeCatalogCode);
      promises['allocationGroupPromise'] = vm.model.methods.getDetails(false, item[vm.model.idField], activeCatalogCode);
      $mdDialog.show({
        controller: 'updateAllocationGroupsController',
        controllerAs: 'vm',
        templateUrl: 'app/main/catalogs/sub-modules/allocation-groups/dialogs/update-allocation-group.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: false,
        locals: {
          record: item,
          isNew: false,
          model: vm.model,
          promises: promises,
          activeCatalogCode: activeCatalogCode,
          event: ev
        }
      }).then(function(saved) {
        if (saved) {
            refreshItems(true, false);
        }
      });
    }

    var catalogChangedEventCleanup = $rootScope.$on('ActiveCatalogChangedEvent', function(e) {
      if(activeCatalogCode !== catalogFactory.getActiveCatalog().CatalogCode) {
          $state.reload('app.allocation_groups');
      }
    });
    $scope.$on('$destroy', function () {
        catalogChangedEventCleanup();
    });

  }
})();
(function () {
  'use strict';

  angular
    .module('app.main.catalogs.articles')
    .controller('updateAllocationGroupsController', updateAllocationGroupsController);

  /* @ngInject */
  function updateAllocationGroupsController($mdDialog, $scope, $window, $filter, $q, toast, hotkeys, utility, record, isNew, model, promises, activeCatalogCode, event) {
    /* jshint validthis: true */
    var vm = this;

    //Data
    vm.inputValues = "";
    vm.isLoading = false;
    vm.isDataDirty = false;
    vm.isNew = isNew;
    vm.record = {};

    var activeArticlesMapObj; // map of key value pair, key is articleNumber of Articles and value is a dummy value (1)

    vm.articles = [];
    vm.catalogArticlesPromise = promises['catalogArticlesPromise'];

    var validData = [];
    var invalidData = [];

    var watchUnsubscribe = $scope.$watch('vm.editForm.ArticleNumbers.$error["tx-exist-value"]', function (newVal) {
      if (angular.isDefined(newVal) && vm.editForm.ArticleNumbers.$invalid && vm.editForm.ArticleNumbers.$error['tx-exist-value']) {
        vm.containInvalidRecords = true;
        removeInvalidData();
      }
    });


    //Methods
    vm.saveRecord = saveRecord;
    vm.closeDialog = closeDialog;


    activate();

    ////////////////

    function activate() {
      loadCatalogArticles();
      if (!isNew) {
        vm.record = record;
        loadAssignedArticles();
      }
      //Hotkeys
      hotkeys.bindTo($scope).add({
        combo: 'ctrl+enter',
        description: $filter('translate')('ACTIONS.SAVE'),
        allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
        callback: function (event) {
          if (!vm.isLoading && !vm.editForm.$invalid && (vm.isNew || vm.isAssignedArticlesLoaded)) {
            vm.saveRecord();
          }
        }
      });

      if (vm.isNew) {
        hotkeys.bindTo($scope)
          .add({
            combo: 'ctrl+shift+enter',
            description: $filter('translate')('ACTIONS.SAVE_AND_NEW'),
            allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
            callback: function (event) {
              if (!vm.isLoading && !vm.editForm.$invalid && (vm.isNew || vm.isAssignedArticlesLoaded)) {
                vm.saveRecord(true);
              }
            }
          });
      }
    }

    function saveRecord(saveAndNew) {
      vm.isLoading = true;
      populateValidAndInvalidData(vm.inputValues)
        .then(function() {
          vm.record.Articles = validData;
          var actionType = vm.isNew ? 'ADD' : 'EDIT';
          model.methods.update(vm.record, activeCatalogCode, actionType)
            .then(function () {
              // when click on save and new while creating record
              if (vm.isNew && angular.isDefined(saveAndNew) && saveAndNew) {
                vm.editForm.$setPristine();
                vm.editForm.$setUntouched();
                vm.record = {};
                vm.inputValues = "";
                vm.invalidDataString = "";
                validData = [];
                invalidData = [];
                vm.containInvalidRecords = false;
                vm.isDataDirty = true;

                var el = $window.document.getElementById('dialog_input_first');
                if (el) {
                  el.focus();
                }
              }
              else {
                closeDialog(true);
              }
              var toastMessage = vm.isNew ? 'SUCCESS.CREATE' : 'SUCCESS.UPDATE';
              toast.success(toastMessage, '', '');
            }, function () {
              closeDialog(vm.isDataDirty);
            }).finally(function () {
              vm.isLoading = false;
            })
        });
    }

    function closeDialog(saved) {
      $mdDialog.hide(saved);
    }

    function removeInvalidData() {
      validData.length = 0;
      invalidData.length = 0;

      var inputArticleNumberList = vm.editForm.ArticleNumbers.$viewValue;// invalid models does not contain data
      populateValidAndInvalidData(inputArticleNumberList)
        .then(function() {
          vm.inputValues = validData.join('\n');
          vm.invalidDataString = invalidData.join('\n');
        });

    }

    function buildArticlesMapObj(articles) {
      activeArticlesMapObj = {};
      for (var i = 0, len = articles.length; i < len; i++) {
        if (articles[i].Status) {
          activeArticlesMapObj[articles[i]['ArticleNumber']] = 1;
        }
      }
      return $q.when(activeArticlesMapObj);
    }

    function loadCatalogArticles() {
      return promises['catalogArticlesPromise']
        .then(function (response) {
          vm.articles = response.data;
          return vm.articles;
        });
    }

    function loadAssignedArticles() {
      promises['allocationGroupPromise']
        .then(function (response) {
          var articleNumbers = response.data.Articles.map(function (article) {
            return article.ArticleNumber;
          });
          vm.inputValues = articleNumbers.join('\n');
          vm.isAssignedArticlesLoaded = true;
        })
    }

    function populateValidAndInvalidData(inputValue) {
      var inputArticleNumberList = inputValue.match(/[^\r\n]+/g);
      return loadCatalogArticles()
        .then(function(articles) {
          if (angular.isUndefined(activeArticlesMapObj) || utility.isObjectEmpty(activeArticlesMapObj)) {
            return buildArticlesMapObj(articles);
          }
        })
        .then(function() {
          if(inputArticleNumberList) {
            for (var i = 0, len = inputArticleNumberList.length; i < len; i++) {
              if (angular.isDefined(activeArticlesMapObj[inputArticleNumberList[i]])) {
                validData.push(inputArticleNumberList[i]);
              }
              else {
                invalidData.push(inputArticleNumberList[i]);
              }
            }
          }
          else {
            validData = [];
            invalidData = [];
          }
        });
    }

    $scope.$on('$destroy', function () {
      watchUnsubscribe();
    });

  }
})();
(function () {
  'use strict';

  angular
    .module('app.main.catalogs.allocation-groups')
    .controller('allocationGroupsDetailsController', allocationGroupsDetailsController);

  /* @ngInject */
  function allocationGroupsDetailsController($document, api, $state, $stateParams, $rootScope, $q, catalogFactory,
    $mdDialog, utility, settingsFactory) {
    /* jshint validthis: true */
    var vm = this;

    // Data
    var allocationGroupId = $stateParams.id;
    var activeCatalogCode = catalogFactory.getActiveCatalog().CatalogCode;

    vm.model = api.catalogs.allocationGroups;

    vm.articlesModel = api.allocationGroups.articles;
    settingsFactory.applyPersistedListViewLayout(vm.articlesModel);

    vm.allocationGroup = {};
    vm.articles = [];
    vm.filteredArticles = [];

    vm.isLoading = false;

    // Methods
    vm.refreshRecord = refreshRecord;

    vm.doItemAction = doItemAction;
    vm.edit = edit;
    vm.doArticlesItemAction = doArticlesItemAction;
    vm.viewArticleDetails = viewArticleDetails;
    vm.doArticleItemAction = doArticleItemAction;

    activate();

    ////////////////

    function activate() {
      refreshRecord(true);
    }

    function refreshRecord(isLogRequired) {
      vm.isLoading = true;

      vm.model.methods.getDetails(isLogRequired, allocationGroupId, activeCatalogCode)
        .then(function (response) {
          vm.allocationGroup = response.data;
          vm.articles =  response.data.Articles;
          vm.title = angular.copy(vm.allocationGroup[vm.model.lookupDisplayField]);

          //Update Breadcrumb
          $state.current.data.displayName = vm.title;
          $rootScope.$broadcast('breadcrumb-updated');
        })
        .finally(function () {
          vm.isLoading = false;
        });
    }

    function doItemAction(action, record) {
      if (action) {
        switch (action.id) {
          case 'delete':
          case 'activate':
            vm.model.methods.activateBulk(record, vm.model, action.id, activeCatalogCode);
            break;
        }
      }
    }

    function edit(record, ev) {
      var articleModel = api.catalogs.articles;
      var promises = {};
      var generalProperties = {
          forceFetch: true,
          isLogRequired: false,
          config: {},
          supportIncrementalResult: true,
          isMajor: false,
          modelIdField: vm.model.idField
      }
      promises['catalogArticlesPromise'] = articleModel.methods.getList(generalProperties, articleModel, activeCatalogCode);
      promises['allocationGroupPromise'] = $q.when({data :record})
      return $mdDialog.show({
          controller         : 'updateAllocationGroupsController',
          controllerAs       : 'vm',
          templateUrl        : 'app/main/catalogs/sub-modules/allocation-groups/dialogs/update-allocation-group.html',
          parent             : angular.element($document.body),
          targetEvent        : ev,
          clickOutsideToClose: false,
          locals             : {
              record: record,
              isNew: false,
              model: vm.model,
              promises: promises,
              activeCatalogCode: activeCatalogCode,
              event: ev
          }
      });
    }

    function doArticlesItemAction(action, record) {
      if (action) {
        switch (action.id) {
          case 'view':
            viewArticleDetails(record);
            break;
        }
      }
    }

    function viewArticleDetails(record) {
      var stateParams = {};
      stateParams.id = record['ArticleId'];
      $state.go('app.articles.details', stateParams)
    }

    function doArticleItemAction(action, record) {
      if (action) {
          switch (action.id) {
            case 'delete':
            case 'activate':
              vm.model.methods.activateBulk(record, vm.model, action.id, activeCatalogCode);
              break;
          }
      }
  }

  }
})();
(function() {
    'use strict';

    angular
        .module('app.main.catalogs.treeDefinition')
        .run(runBlock);

    /* @ngInject */
    function runBlock(api, catalogFactory, crud) {

        if (angular.isUndefined(api.catalogs)) {
            api.catalogs = {};
        }
         api.catalogs.treeDefinition = {
            modelPath: 'catalogs.treeDefinition',
            fields: [
                { field: 'Id', type: 'int', displayLabel: 'TREE_DEFINITION.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Name', type: 'text', displayLabel: 'TREE_DEFINITION.FIELDS.NAME', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'IsDefault', type: 'text', displayLabel: 'TREE_DEFINITION.FIELDS.IS_DEFAULT', visible: true, creatable: false, editable: false, inputType: 'bool-int',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Status', type: 'text', displayLabel: 'TREE_DEFINITION.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedDate', type: 'text', displayLabel: 'TREE_DEFINITION.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedDate', type: 'text', displayLabel: 'TREE_DEFINITION.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedBy', type: 'text', displayLabel: 'TREE_DEFINITION.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedBy', type: 'text', displayLabel: 'TREE_DEFINITION.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
            ],
            uniqueConstraints: [],
            title: '',
            icon: '',
            idField: 'Id',
            lookupDisplayField: 'Name',
            isDirty: false,
            methods: {
                getList   :   getTreeDefination,
                create    :   createTreeDefination,
                update    :   updateTreeDefination,
                activateBulk: activateTreeDefinations
            },
            views: {
                mainList: {
                    columns         : [ 'Id', 'Name', 'IsDefault', 'Status', 'UpdatedBy', 'UpdatedDate', 'CreatedBy'],
                    columnFilter    : {},
                    toggleFilterProps   : { toggleStatus:false, filterProp:'Status', trueVal:1, trueValTooltipMessage: 'ACTIONS.TOGGLE_ACTIVE', falseVal:'', falseValTooltipMessage:"ACTIONS.TOGGLE_ALL"},
                    topIndex        : 0,
                    showFilterRow   : false,
                    sortColumn      : {'UpdatedDate': false},
                    sortDescending  : true,
                    itemActions     : [
                        { id: 'view', label: 'ACTIONS.VIEW', icon: 'icon-magnify', privilege: 'GetCatalogTreeNodes', disabled: '!itm.Status', visible: true },
                        { id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UpdateteCatalogTree', disabled: '!itm.Status', visible: true },
                        { id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateCatalogTreeStatus', disabled: false, visible: 'itm.Status',
                            requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                        { id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateCatalogTreeStatus', disabled: false, visible: '!itm.Status',
                            requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
                    ],
                    listActions     : [
                        { id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateCatalogTreeStatus', disabled: '{selected: true, Status: 1}',
                            visible: true, requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                        { id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateCatalogTreeStatus', disabled: '{selected: true, Status: 0}',
                            visible: true, requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
                     ],
                    fabAction       : {id: 'add', label: 'ACTIONS.ADD', icon: 'icon-plus', privilege: 'CreateCatalogTreeNodes', visible: true}
                 },
                 mainDetails: {},
                 privileges: {
                    list    : 'GetCatalogTreeDefinitionList'
                }
            }
        };

        function getTreeDefination(generalProperties, catalogCode) {
            var promise;

            if(angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
                promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/trees', undefined, true, generalProperties.forceFetch);
            }
            else {
                catalogCode = angular.isUndefined(catalogCode) ? catalogFactory.getActiveCatalog().CatalogCode : catalogCode;
                return api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/trees', undefined, true, generalProperties.forceFetch);
            }

            promise.then(function() {
                if (api.catalogs.treeDefinition.isDirty) {
                    //Invalidate lookupData
                    api.catalogs.treeDefinition.lookupData = undefined;
                    api.catalogs.treeDefinition.isDirty = false;
                }
            });
            return promise;
		}

        function createTreeDefination(catalogCode, records) {
            var promise = api.webPost(api.baseUrl + '/catalogs/' + catalogCode + '/trees', records);

            promise.then(function() {
                api.catalogs.treeDefinition.isDirty = true;
            });
            return promise;
        }

        function updateTreeDefination(catalogCode, treeId, records) {
            var promise = api.webPut(api.baseUrl + '/catalogs/' + catalogCode + '/trees/' + treeId, records);

            promise.then(function() {
                api.catalogs.treeDefinition.isDirty = true;
            });
            return promise;
        }

        function activateTreeDefinations(records, model, actionType, catalogCode) {
            var result = crud.createRequestObject(records, model, actionType);
            var promise = api.webPut(api.baseUrl + '/catalogs/'+ catalogCode +'/trees/status', result.requestObj);

            promise.then(function() {
                api.catalogs.treeDefinition.isDirty = true;
                crud.onRecordStatusChange(records, model, actionType);
            });

            return promise;
        }

    }
})();
(function() {
  'use strict';

  angular
      .module('app.main.catalogs.targetedAttributes',[]);
})();
(function() {
  'use strict';

  angular
      .module('app.main.catalogs.targetedAttributes')
      .run(runBlock);

  /* @ngInject */
  function runBlock(api, $state, activityLogger, catalogFactory) {

      if(angular.isUndefined(api.catalogs)) {
          api.catalogs = {};
      }

      api.catalogs.targetedAttributes = {
          modelPath: 'catalogs.targetedAttributes',
          fields: [
              { field: 'AttributeId', type: 'int', displayLabel: 'ATTRIBUTES.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
                  validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
              { field: 'AttributeDisplayName', type: 'text', displayLabel: 'ATTRIBUTES.FIELDS.NAME', visible: true, creatable: false, editable: false, inputType: 'textArea',
                  validation: {isRequired: true, maxLen: 200, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
              { field: 'AttributeSystemName', type: 'text', displayLabel: 'ATTRIBUTES.FIELDS.SYSTEM_NAME', visible: true, creatable: false, editable: false, inputType: 'textArea',
                  validation: {isRequired: false, maxLen: 128, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
              { field: 'AttributeTypeId', type: 'int', displayLabel: 'ATTRIBUTES.FIELDS.ATTRIBUTE_TYPE_ID', visible: true, creatable: false, editable: false, inputType: 'number',
                  validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
              { field: 'CreatedDate', type: 'text', displayLabel: 'ATTRIBUTES.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                  validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
              { field: 'UpdatedDate', type: 'text', displayLabel: 'ATTRIBUTES.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                  validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
              { field: 'AttributeTypeName', type: 'text', displayLabel: 'ATTRIBUTES.FIELDS.ATTRIBUTE_TYPE_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
                  validation: {isRequired: false, maxLen: 25, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
              { field: 'CreatedBy', type: 'text', displayLabel: 'ATTRIBUTES.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                  validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
              { field: 'UpdatedBy', type: 'text', displayLabel: 'ATTRIBUTES.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                  validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
          ],

          title: 'ATTRIBUTES.NAV',
          icon: 'icon-dice-1',
          idField: 'AttributeId',
          lookupDisplayField: 'AttributeDisplayName',
          methods: {},
          views: {
              mainList: {
                  columns             : [ 'AttributeDisplayName', 'AttributeSystemName', 'UpdatedDate', 'AttributeTypeName' ],
                  columnFilter        : {},
                  topIndex            : 0,
                  showFilterRow       : false,
                  sortColumn          : {'UpdatedDate': false},
                  itemActions         : [
                                          { id: 'view', label: 'ACTIONS.VIEW', icon: 'icon-magnify', privilege: 'GetAttributeDetailsById', disabled: '', visible: true }
                                        ],
                  listActions         : [],
                  fabAction           : {}
              },
              mainDetails: {},
              privileges: {}
          }
      };



  }
})();
(function() {
  'use strict';

  angular
      .module('app.main.catalogs.stock-definition', []);
})();
(function() {
  'use strict';

  angular
      .module('app.main.catalogs.stock-definition')
      .run(runBlock);

  /* @ngInject */
  function runBlock(api, activityLogger, $state, crud, toast, catalogFactory) {

      if(angular.isUndefined(api.catalogs)) {
          api.catalogs = {};
      }
      api.catalogs.stockDefinition = {
        modelPath: 'catalogs.stockDefinition',
        fields: [
            { field: 'Id', type: 'int', displayLabel: 'STOCK_DEFINITION.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
                validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
            { field: 'StockCode', type: 'text', displayLabel: 'STOCK_DEFINITION.FIELDS.STOCK_CODE', visible: true, creatable: true, editable: true, inputType: 'text',
                validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
            { field: 'StockName', type: 'text', displayLabel: 'STOCK_DEFINITION.FIELDS.STOCK_NAME', visible: true, creatable: true, editable: true, inputType: 'text',
                validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
            { field: 'CatalogCode', type: 'int', displayLabel: 'STOCK_DEFINITION.FIELDS.CATALOG_CODE', visible: true, creatable: false, editable: false, inputType: 'number',
                validation: {isRequired: false, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
            { field: 'Status', type: 'text', displayLabel: 'STOCK_DEFINITION.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
                validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
            { field: 'CreatedDate', type: 'text', displayLabel: 'STOCK_DEFINITION.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
            { field: 'UpdatedDate', type: 'text', displayLabel: 'STOCK_DEFINITION.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
            { field: 'UpdatedBy', type: 'text', displayLabel: 'STOCK_DEFINITION.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
            { field: 'CreatedBy', type: 'text', displayLabel: 'STOCK_DEFINITION.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
        ],
        uniqueConstraints: [],
        title: 'STOCK_DEFINITION.NAV',
        icon: 'icon-layers',
        idField: 'Id',
        lookupDisplayField: 'StockCode',
        isDirty: false,
        methods: {
          getList         :   getStockDefinitions,
          activateBulk    :   activateStockDefinitions,
          create          :   createStockDefinition,
          update          :   updateStockDefinition
        },
        views: {
            mainList: {
                columns             : [ 'Id', 'StockName', 'StockCode', 'UpdatedDate', 'Status'],
                columnFilter        : {},
                toggleFilterProps   : { toggleStatus:false, filterProp:'Status', trueVal:1, trueValTooltipMessage: 'ACTIONS.TOGGLE_ACTIVE', falseVal:'', falseValTooltipMessage:"ACTIONS.TOGGLE_ALL"},
                topIndex            : 0,
                showFilterRow       : false,
                sortColumn          : {'UpdatedDate': false},
                itemActions         : [
                                        { id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UpdateStockDefinition', disabled: '!itm.Status', visible: true },
                                        { id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateStockDefinitionStatusBulk', disabled: false, visible: 'itm.Status',
                                            requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                                        { id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateStockDefinitionStatusBulk', disabled: false, visible: '!itm.Status',
                                            requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
                                      ],
                listActions         : [
                                        { id: 'delete', label: 'ACTIONS.DELETE_BULK', icon: 'icon-delete', privilege: 'UpdateStockDefinitionStatusBulk', disabled: '{selected: true, Status: 1}', visible: true,
                                            requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                                        { id: 'activate', label: 'ACTIONS.ACTIVATE_BULK', icon: 'icon-undo-variant', privilege: 'UpdateStockDefinitionStatusBulk', disabled: '{selected: true, Status: 0}', visible: true,
                                            requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
                                      ],
                fabAction           : {id: 'add', label: 'ACTIONS.ADD', icon: 'icon-plus', privilege: 'CreateStockDefinition', visible: true}
            },
            mainDetails: {},
            privileges: {
                list: 'GetStockDefinitionList',
            }
        }
      };

    function getStockDefinitions(generalProperties, catalogCode) {
      var promise;
      if (angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
        var state = {};
        state.name = $state.current.name;
        state.params = $state.params;
        var isBulk = true;
        var logData = activityLogger.createLogData(null, state, 'catalogs.stockDefinition', 'VIEW', isBulk, new Date(), null, null);
        promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/stockdefinitions', undefined, true, generalProperties.forceFetch);
        promise = activityLogger.log(logData, promise);
      }
      else {
        catalogCode = angular.isDefined(catalogCode) ? catalogCode : catalogFactory.getActiveCatalog().CatalogCode;
        promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/stockdefinitions', undefined, true, generalProperties.forceFetch);
      }
      return promise;
    }

    function activateStockDefinitions(records, model, actionType, catalogCode) {
      var result = crud.createRequestObject(records, model, actionType);
      var state = {};
      state.name = $state.current.name;
      state.params = $state.params;
      var isBulk = result.itemsNameList.length > 1 ? true : false;
      var logData = activityLogger.createLogData(result.itemsNameList, state, 'catalogs.stockDefinition', actionType.toUpperCase(), isBulk, new Date(), null, null);
      var promise = api.webPut(api.baseUrl + '/catalogs/' + catalogCode + '/stockdefinitions/status', result.requestObj);

      promise.then(function () {
        crud.onRecordStatusChange(records, model, actionType);
      });

      return activityLogger.log(logData, promise);
    }

    function createStockDefinition(record, catalogCode) {
      var state = {};
      state.name = $state.current.name;
      state.params = $state.params;
      var logData = activityLogger.createLogData(record[api.catalogs.stockDefinition.lookupDisplayField], state, 'catalogs.stockDefinition', 'ADD', false, new Date(), null, null);
      var promise = api.webPost(api.baseUrl + '/catalogs/' + catalogCode + '/stockdefinitions', record);

      promise.then(function () {
        api.catalogs.stockDefinition.isDirty = true;
      });
      return activityLogger.log(logData, promise);
    }

    function updateStockDefinition(Id, stock, catalogCode) {
      var state = {};
      state.name = $state.current.name;
      state.params = $state.params;
      var logData = activityLogger.createLogData(stock[api.catalogs.stockDefinition.lookupDisplayField], state, 'catalogs.stockDefinition', 'EDIT', false, new Date(), null, null);
      var promise = api.webPut(api.baseUrl + '/catalogs/' + catalogCode + '/stockdefinitions/' + Id, stock);

      promise.then(function () {
        api.catalogs.stockDefinition.isDirty = true;
      });
      return activityLogger.log(logData, promise);
    }

  }
})();
(function() {
    'use strict';

    angular
        .module('app.main.catalogs.size-scale-groups', []);
})();
(function() {
    'use strict';

    angular
        .module('app.main.catalogs.size-scale-groups')
        .run(runBlock);

    /* @ngInject */
    function runBlock(api, activityLogger, $state, crud, toast, catalogFactory) {

        if(angular.isUndefined(api.catalogs)) {
            api.catalogs = {};
        }
        api.catalogs.sizeScaleGroups = {
            modelPath: 'catalogs.sizeScaleGroups',
            fields: [
                { field: 'Id', type: 'int', displayLabel: 'SIZE_SCALE_GROUP.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'MasterSizeScaleId', type: 'int', displayLabel: 'SIZE_SCALE_GROUP.FIELDS.MASTER_SIZE_SCALE_ID', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'MasterSizeScale', type: 'text', displayLabel: 'SIZE_SCALE_GROUP.FIELDS.MASTER_SIZE_SCALE', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'SizeScale', type: 'text', displayLabel: 'SIZE_SCALE_GROUP.FIELDS.SIZE_SCALE', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Sizes', type: 'text', displayLabel: 'SIZE_SCALE_GROUP.FIELDS.SIZE', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Status', type: 'text', displayLabel: 'SIZE_SCALE_GROUP.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'IsObsolete', type: 'int', displayLabel: 'SIZE_SCALE_GROUP.FIELDS.IS_OBSOLETE', visible: true, creatable: false, editable: true, inputType: 'bool-int',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
            ],
            uniqueConstraints: [],
            title: 'SIZE_SCALE_GROUP.NAV',
            icon: 'icon-layers',
            idField: 'Id',
            lookupDisplayField: 'SizeScale',
            isDirty: false,
            methods: {
                getList     :   getSizeScaleGroups
            },
            views: {
                mainList: {
                    columns             : [ 'Id', 'SizeScale', 'Sizes', 'MasterSizeScale', 'IsObsolete', 'Criteria', 'Status'],
                    columnFilter        : {},
                    toggleFilterProps   : { toggleStatus:false, filterProp:'Status', trueVal:1, trueValTooltipMessage: 'ACTIONS.TOGGLE_ACTIVE', falseVal:'', falseValTooltipMessage:"ACTIONS.TOGGLE_ALL"},
                    topIndex            : 0,
                    showFilterRow       : false,
                    sortColumn          : {'SizeScale': false},
                    itemActions         : [],
                    listActions         : [],
                    fabAction           : {}
                },
                mainDetails: {},
                privileges: {
                    list: 'GetSizeScaleList',
                }
            }
        };

        function getSizeScaleGroups(generalProperties, catalogCode) {
            var promise;
            if(angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
                var state = {};
                state.name = $state.current.name;
                state.params = $state.params;
                var isBulk = true;
                var logData = activityLogger.createLogData(null, state, 'catalogs.sizeScaleGroups', 'VIEW', isBulk, new Date(), null, null);
                promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/sizescales', undefined, true, generalProperties.forceFetch);
                promise = activityLogger.log(logData, promise);
            }
            else {
                catalogCode = angular.isDefined(catalogCode) ? catalogCode : catalogFactory.getActiveCatalog().CatalogCode;
                promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/sizescales', undefined, true, generalProperties.forceFetch);
            }
            return promise;
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.main.catalogs.shipment-window',[]);
})();
(function () {
  'use strict';

  angular
    .module('app.main.catalogs.shipment-window')
    .run(runBlock);

  /* @ngInject */
  function runBlock(api, activityLogger, $state, catalogFactory, jobsTracker, $q, crud, CONSTANTS) {

    if (angular.isUndefined(api.catalogs)) {
      api.catalogs = {};
    }
    api.catalogs.shipmentWindows = {
      modelPath: 'catalogs.shipmentWindows',
      fields: [
        { field: 'Id', type: 'int', displayLabel: 'SHIPMENT_WINDOWS.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
          validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } } },
        { field: 'RetailIntroMonth', type: 'text', displayLabel: 'SHIPMENT_WINDOWS.FIELDS.RETAIL_WINDOW_MONTH', visible: true, creatable: true, editable: true, showInEdit: true, inputType: 'text',
          validation: { isRequired: true, maxLen: 3, minLen: 1, pattern: '^[a-zA-Z]{3}$', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: 'SHIPMENT_WINDOWS.VALIDATIONS.ALLOWED_ONLY_THREE_CHARS' } } },
        { field: 'RetailExitMonth', type: 'text', displayLabel: 'SHIPMENT_WINDOWS.FIELDS.RETAIL_EXIT_MONTH', visible: true, creatable: true, editable: true, showInEdit: true, inputType: 'text',
          validation: { isRequired: true, maxLen: 3, minLen: 1, pattern: '^[a-zA-Z]{3}$', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: 'SHIPMENT_WINDOWS.VALIDATIONS.ALLOWED_ONLY_THREE_CHARS' } } },
        { field: 'ShipmentStartDate', type: 'text', displayLabel: 'SHIPMENT_WINDOWS.FIELDS.SHIPMENT_START_DATE', visible: true, creatable: true, editable: false, showInEdit: true, inputType: 'date-utc',
          validation: { isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } } },
        { field: 'ShipmentEndDate', type: 'text', displayLabel: 'SHIPMENT_WINDOWS.FIELDS.SHIPMENT_END_DATE', visible: true, creatable: true, editable: false, showInEdit: true, inputType: 'date-utc',
          validation: { isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } } },
        { field: 'CriteriaAttributeValue', type: 'text', displayLabel: 'SHIPMENT_WINDOWS.FIELDS.CRITERIA_ATTRIBUTE_VALUE', visible: true, creatable: true, editable: true, inputType: 'text',
          validation: { isRequired: true, maxLen: 4000, minLen: 1, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } } },
        { field: 'Status', type: 'text', displayLabel: 'SHIPMENT_WINDOWS.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
          validation: { isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } } },
        { field: 'Period', type: 'text', displayLabel: 'SHIPMENT_WINDOWS.FIELDS.PERIOD', visible: true, creatable: true, editable: true, inputType: 'text',
          validation: { isRequired: true, maxLen: 200, minLen: 1, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } } },
        { field: 'CreatedDate', type: 'text', displayLabel: 'SHIPMENT_WINDOWS.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
          validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } } },
        { field: 'UpdatedDate', type: 'text', displayLabel: 'SHIPMENT_WINDOWS.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
          validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } } },
        { field: 'CreatedBy', type: 'text', displayLabel: 'SHIPMENT_WINDOWS.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
          validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } } },
        { field: 'UpdatedBy', type: 'text', displayLabel: 'SHIPMENT_WINDOWS.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
          validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } } },
        // used internally
        { field: 'dataExistsCombinationField', type: 'text', displayLabel: '', visible: false, creatable: false, editable: false, inputType: 'text',
          validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', dataExistConstraints: {modelPath: 'lists.retailWindows', promise: null, data: null, shouldNotExist: true}, messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
      ],
      uniqueConstraints: [
        {name: 'Constraint 1', fields: ['ShipmentStartDate', 'ShipmentEndDate', 'CriteriaAttributeValue']}
      ],
      // this is to load the data in import dataExistsCombinationConstraints this is used for validating combination of fields are exists or not
      dataExistsCombinationConstraints: ['ShipmentStartDate', 'ShipmentEndDate', 'CriteriaAttributeValue'],
      dateRangeValidation: {
        startDateField: 'ShipmentStartDate',
        endDateField: 'ShipmentEndDate',
        messages: {
          startDateError: 'SHIPMENT_WINDOWS.VALIDATIONS.START_DATE_AFTER_END_DATE',
          endDateError: 'SHIPMENT_WINDOWS.VALIDATIONS.END_DATE_BEFORE_START_DATE'
        }
      },
      title: 'SHIPMENT_WINDOWS.NAV',
      icon: 'icon-tile-four',
      idField: 'Id',
      lookupDisplayField: 'RetailIntroMonth',
      isDirty: false,
      lastUpdatedOn: {},
      methods: {
        getList: getShipmentWindows,
        createBulk: importShipmentWindows,
        create    :   createShipmentWindow,
        update    :   updateShipmentWindow,
        activateBulk:   activateShipmentWindows,
      },
      views: {
        mainList: {
          columns: ['RetailIntroMonth', 'RetailExitMonth', 'ShipmentStartDate', 'ShipmentEndDate', 'CriteriaAttributeValue', 'Status', 'Period', 'UpdatedDate'],
          columnFilter: {},
          toggleFilterProps: { toggleStatus: false, filterProp: 'Status', trueVal: 1, trueValTooltipMessage: 'ACTIONS.TOGGLE_ACTIVE', falseVal: '', falseValTooltipMessage: "ACTIONS.TOGGLE_ALL" },
          topIndex: 0,
          showFilterRow: false,
          sortColumn: { 'UpdatedDate': false },
          itemActions: [
                          { id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UpdateShipmentWindow', disabled: '!itm.Status', visible: true },
                          { id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateShipmentWindowStatus', disabled: false, visible: 'itm.Status',
                              requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                          { id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateShipmentWindowStatus', disabled: false, visible: '!itm.Status',
                              requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
          ],
          listActions: [
                          { id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateShipmentWindowStatus', disabled: '{selected: true, Status: 1}',
                            visible: true, requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                          { id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateShipmentWindowStatus', disabled: '{selected: true, Status: 0}',
                            visible: true, requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'},
                          { id: 'import', label: 'ACTIONS.IMPORT', icon: 'icon-import', privilege: 'CreateUpdateShipmentWindowBulk', disabled: false, visible: true, requiresConfirmation: false }
          ],
          fabAction    : {id: 'add', label: 'ACTIONS.ADD', icon: 'icon-plus', privilege: 'CreateShipmentWindowBulk', visible: true}
        },
        mainDetails: {},
        privileges: {
          list: 'GetCatalogShipmentWindowList'
        }
      }
    };


    // only use for lookup based on different article
    if (angular.isUndefined(api.catalogs)) {
      api.catalogs = {};
    }
    api.catalogs.retailIntroMonthsForArticle = {
      modelPath: 'catalogs.retailIntroMonthsForArticle',
      fields: [
        { field: 'Id', type: 'int', displayLabel: 'SHIPMENT_WINDOWS.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
          validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } } },
        { field: 'RetailIntroMonth', type: 'text', displayLabel: 'SHIPMENT_WINDOWS.FIELDS.RETAIL_WINDOW_MONTH', visible: true, creatable: true, editable: false, showInEdit: true, inputType: 'text',
          validation: { isRequired: true, maxLen: 20, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } } },
        { field: 'RetailExitMonth', type: 'text', displayLabel: 'SHIPMENT_WINDOWS.FIELDS.RETAIL_EXIT_MONTH', visible: true, creatable: true, editable: false, showInEdit: true, inputType: 'text',
          validation: { isRequired: true, maxLen: 20, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } } },
        { field: 'CriteriaAttributeValue', type: 'text', displayLabel: 'SHIPMENT_WINDOWS.FIELDS.CRITERIA_ATTRIBUTE_VALUE', visible: true, creatable: true, editable: true, inputType: 'text',
          validation: { isRequired: true, maxLen: 4000, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } } },
        { field: 'ShipmentStartDate', type: 'text', displayLabel: 'SHIPMENT_WINDOWS.FIELDS.SHIPMENT_START_DATE', visible: true, creatable: true, editable: false, inputType: 'date-utc',
          validation: { isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } } },
        { field: 'ShipmentEndDate ', type: 'text', displayLabel: 'SHIPMENT_WINDOWS.FIELDS.SHIPMENT_END_DATE', visible: true, creatable: true, editable: false, inputType: 'date-utc',
          validation: { isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } } },
        { field: 'Status', type: 'text', displayLabel: 'SHIPMENT_WINDOWS.FIELDS.STATUS', visible: true, creatable: true, editable: false, inputType: 'status',
          validation: { isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } } },
        { field: 'Period', type: 'text', displayLabel: 'SHIPMENT_WINDOWS.FIELDS.PERIOD', visible: true, creatable: true, editable: true, inputType: 'text',
          validation: { isRequired: false, maxLen: 200, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } } },
        { field: 'CreatedDate', type: 'text', displayLabel: 'SHIPMENT_WINDOWS.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
          validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } } },
        { field: 'UpdatedDate', type: 'text', displayLabel: 'SHIPMENT_WINDOWS.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
          validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } } },
        { field: 'CreatedBy', type: 'text', displayLabel: 'SHIPMENT_WINDOWS.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
          validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } } },
        { field: 'UpdatedBy', type: 'text', displayLabel: 'SHIPMENT_WINDOWS.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
          validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } } }
      ],
      title: 'SHIPMENT_WINDOWS.NAV',
      icon: 'icon-tile-four',
      idField: 'Id',
      lookupDisplayField: 'RetailIntroMonth',
      isDirty: false,
      lastUpdatedOn: {},
      methods: {
        getList: getShipmentWindowsForArticle,
        // getFilteredList: getShipmentWindowsForArticle,
      }
    };

    // lookup for retail exit month
    api.catalogs.retailExitMonthsForArticle = {
      modelPath: 'catalogs.retailExitMonthsForArticle',
      fields: [
        { field: 'Id', type: 'int', displayLabel: 'SHIPMENT_WINDOWS.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
          validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } } },
        { field: 'RetailIntroMonth', type: 'text', displayLabel: 'SHIPMENT_WINDOWS.FIELDS.RETAIL_WINDOW_MONTH', visible: true, creatable: true, editable: false, showInEdit: true, inputType: 'text',
          validation: { isRequired: true, maxLen: 20, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } } },
        { field: 'RetailExitMonth', type: 'text', displayLabel: 'SHIPMENT_WINDOWS.FIELDS.RETAIL_EXIT_MONTH', visible: true, creatable: true, editable: false, showInEdit: true, inputType: 'text',
          validation: { isRequired: true, maxLen: 20, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } } },
        { field: 'CriteriaAttributeValue', type: 'text', displayLabel: 'SHIPMENT_WINDOWS.FIELDS.CRITERIA_ATTRIBUTE_VALUE', visible: true, creatable: true, editable: true, inputType: 'text',
          validation: { isRequired: true, maxLen: 4000, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } } },
        { field: 'ShipmentStartDate', type: 'text', displayLabel: 'SHIPMENT_WINDOWS.FIELDS.SHIPMENT_START_DATE', visible: true, creatable: true, editable: false, inputType: 'date-utc',
          validation: { isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } } },
        { field: 'ShipmentEndDate ', type: 'text', displayLabel: 'SHIPMENT_WINDOWS.FIELDS.SHIPMENT_END_DATE', visible: true, creatable: true, editable: false, inputType: 'date-utc',
          validation: { isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } } },
        { field: 'Status', type: 'text', displayLabel: 'SHIPMENT_WINDOWS.FIELDS.STATUS', visible: true, creatable: true, editable: false, inputType: 'status',
          validation: { isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } } },
        { field: 'Period', type: 'text', displayLabel: 'SHIPMENT_WINDOWS.FIELDS.PERIOD', visible: true, creatable: true, editable: true, inputType: 'text',
          validation: { isRequired: false, maxLen: 200, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } } },
        { field: 'CreatedDate', type: 'text', displayLabel: 'SHIPMENT_WINDOWS.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
          validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } } },
        { field: 'UpdatedDate', type: 'text', displayLabel: 'SHIPMENT_WINDOWS.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
          validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } } },
        { field: 'CreatedBy', type: 'text', displayLabel: 'SHIPMENT_WINDOWS.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
          validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } } },
        { field: 'UpdatedBy', type: 'text', displayLabel: 'SHIPMENT_WINDOWS.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
          validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } } }
      ],
      title: 'SHIPMENT_WINDOWS.NAV',
      icon: 'icon-tile-four',
      idField: 'Id',
      lookupDisplayField: 'RetailExitMonth',
      isDirty: false,
      lastUpdatedOn: {},
      methods: {
        getList: getShipmentWindowsForArticle,
        // getFilteredList: getShipmentWindowsForArticle,
      }
    };

    function getShipmentWindows(generalProperties, catalogCode, model) {
      if(angular.isDefined(model)) { // to skip this part for load lookup
          model.isBulkActionCompleted = false;
      }
      var promise;

      if (angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
        var state = {};
        state.name = $state.current.name;
        state.params = $state.params;
        var isBulk = true;
        var logData = activityLogger.createLogData(null, state, 'catalogs.shipmentWindows', 'VIEW', isBulk, new Date(), null, null);
        promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/shipmentwindows', undefined, true, generalProperties.forceFetch);
        promise = activityLogger.log(logData, promise);
      }
      else {
        catalogCode = angular.isUndefined(catalogCode) ? catalogFactory.getActiveCatalog().CatalogCode : catalogCode;
        promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/shipmentwindows', undefined, true, generalProperties.forceFetch);
      }

      promise.then(function () {
        if (api.catalogs.shipmentWindows.isDirty) {
          //Invalidate lookupData
          api.catalogs.shipmentWindows.lookupData = undefined;
          api.catalogs.shipmentWindows.isDirty = false;
        }
      });
      return promise;
    }

    function importShipmentWindows(model, data, catalogCode) {
      // transform RetailIntroMonth and RetailExitMonth in the required format as Intro Month: [Month] ([Shipment Start Date Month]/[Shipment Start Date Day] Start Ship)
      // Exit Month: [Month] ([Shipment End Date Month]/[Shipment End Date Day] End Ship)
      var transformedData = catalogFactory.transformRetailIntroAndRetailExitMonth(data, true);

      var jobIndex = jobsTracker.addJob(model, 'SHIPMENT_WINDOWS.ACTIONS.IMPORT_SHIPMENT_WINDOWS', 1);
      api.webPut(api.baseUrl + '/catalogs/' + catalogCode + '/bulkshipmentwindows?sourceapplication=' + CONSTANTS.SOURCE_APPLICATION + '&sourceaction=Import Retail Windows', transformedData).then(function (response) {
        jobsTracker.trackJob(jobIndex, response.data.Id);
      }).catch(function (error) {
        jobsTracker.setCriticlaFail(jobIndex, error);
      });
    }


    // this method is created to specifically get filtered list of shipment range based on ShipmentStartDate & ShipmentEndDate passed as properties to parentArticle object inside idMap property
    // if needs to be used as a lookup need to pass as lookupExtras, if parentArticle is not present or shipment dates are not present it will return all the shipment range of master catalog
    function getShipmentWindowsForArticle(generalProperties) {
      var lookupData;
      // if request for master catalog
      if(angular.isUndefined(generalProperties.idMap) || angular.isUndefined(generalProperties.idMap['parentArticle'])) {
        // get shipment range for master catalog
        // lookupData = utility.transformToLookupData(catalogFactory.getActiveCatalogDetails().ShipmentWindowRangeList, api.catalogs.shipmentWindowsForArticle, ['ShipmentStartDate', 'ShipmentEndDate', 'Status']);
        // return $q.when(lookupData);
        return $q.when({data:catalogFactory.getActiveCatalogDetails().ShipmentWindowRangeList});
      }
      // if passing lookup extras to get shipment window for inherited article needs to pass MasterCatalogCode as well
      else {
        var deferred = $q.defer();
        var promise = deferred.promise;
        api.webGet(api.baseUrl + '/catalogs/' + generalProperties.idMap['CatalogCode'] + '/shipmentwindows', undefined, true, generalProperties.forceFetch)
          .then(function(response) {
            var parentShipmentStartDate = generalProperties.idMap['parentArticle']['ShipmentStartDate'];

            // if parent shipmentStartDate is specified in lookup extras => filter, otherwise resolve all
            if(parentShipmentStartDate != null && angular.isDefined(parentShipmentStartDate) && parentShipmentStartDate.toString().trim() !== '') {
              // if shipmentStart date defined on parent article filter based on it
              var filteredShipmentWindows = [];
              angular.forEach(response.data, function(shipmentWindow) {
                // child window must start on or after parent start date (end date restriction removed)
                if (moment(shipmentWindow['ShipmentStartDate']).isSameOrAfter(parentShipmentStartDate, 'day')) {
                    filteredShipmentWindows.push(shipmentWindow);
                  }
              });
              // lookupData = utility.transformToLookupData(filteredShipmentWindows, api.catalogs.retailIntroMonthsForArticle, ['ShipmentStartDate', 'ShipmentEndDate', 'Status']);
              // deferred.resolve(lookupData);
              deferred.resolve({data:filteredShipmentWindows});
            }
            else {
              // resolve master catalog values
              // lookupData = utility.transformToLookupData(response.data, api.catalogs.retailIntroMonthsForArticle, ['ShipmentStartDate', 'ShipmentEndDate', 'Status']);
              // deferred.resolve(lookupData);
              deferred.resolve({data: []});
            }
          });
          return promise;
      }
    }

    function createShipmentWindow(retailWindow, catalogCode) {
      var state = {};
      state.name = $state.current.name;
      state.params = $state.params;
      var logData = activityLogger.createLogData(retailWindow[api.catalogs.shipmentWindows.lookupDisplayField], state, 'catalogs.shipmentWindows', 'ADD', false, new Date(), null, null);
      // transform RetailIntroMonth and RetailExitMonth in the required format as Intro Month: [Month] ([Shipment Start Date Month]/[Shipment Start Date Day] Start Ship)
      // Exit Month: [Month] ([Shipment End Date Month]/[Shipment End Date Day] End Ship)
      var transformedData = catalogFactory.transformRetailIntroAndRetailExitMonth([retailWindow]);

      var promise = api.webPost(api.baseUrl + '/catalogs/' + catalogCode + '/createshipmentwindows', transformedData);

      promise.then(function() {
        api.catalogs.shipmentWindows.isDirty = true;
      });
      return activityLogger.log(logData, promise);
    }

    function updateShipmentWindow(itemId, item, catalogCode) {
      var state = {};
      state.name = $state.current.name;
      state.params = $state.params;
      var logData = activityLogger.createLogData(item[api.catalogs.shipmentWindows.lookupDisplayField], state, 'catalogs.shipmentWindows', 'EDIT', false, new Date(), null, null);
      // transform RetailIntroMonth and RetailExitMonth in the required format as Intro Month: [Month] ([Shipment Start Date Month]/[Shipment Start Date Day] Start Ship)
      // Exit Month: [Month] ([Shipment End Date Month]/[Shipment End Date Day] End Ship)
      var transformedData = catalogFactory.transformRetailIntroAndRetailExitMonth([item]);
      var promise = api.webPut(api.baseUrl + '/catalogs/' + catalogCode + '/shippingwindows/' + itemId, transformedData[0]);

      promise.then(function() {
        api.catalogs.shipmentWindows.isDirty = true;
      });
      return activityLogger.log(logData, promise);
    }

    function activateShipmentWindows(records, model, actionType, parentId) {
      var result = crud.createRequestObject(records, model, actionType);
      var state = {};
      state.name = $state.current.name;
      state.params = $state.params;
      var isBulk = result.itemsNameList.length > 1 ? true : false;
      var logData = activityLogger.createLogData(result.itemsNameList, state, 'catalogs.shipmentWindows', actionType.toUpperCase(), isBulk, new Date(), null, null);
      var promise = api.webPut(api.baseUrl + '/catalogs/'+ parentId +'/shippingwindows/status', result.requestObj);

      promise.then(function() {
          crud.onRecordStatusChange(records, model, actionType);
      });
      return activityLogger.log(logData, promise);
  }

  }
})();
(function() {
  'use strict';

  angular
      .module('app.main.catalogs.seller-users',[])
      .config(config);

    /* @ngInject */
    function config($translatePartialLoaderProvider) {

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/catalogs/details/tabs/seller-users');
    }
})();
(function() {
	'use strict';

	angular
			.module('app.main.catalogs.seller-users')
			.run(runBlock);

	/* @ngInject */
	function runBlock(api, $state, activityLogger, catalogFactory) {

		if(angular.isUndefined(api.catalogs)) {
				api.catalogs = {};
		}

		api.catalogs.sellerUsers = {
				modelPath: 'catalogs.sellerUsers',
				fields: [
					{ field: 'Id', type: 'int', displayLabel: 'SELLER_USERS.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
							validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
					{ field: 'AccountId', type: 'int', displayLabel: 'SELLER_USERS.FIELDS.ACCOUNT_ID', visible: true, creatable: false, editable: false, inputType: 'static',
							validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
					{ field: 'AccountName', type: 'text', displayLabel: 'SELLER_USERS.FIELDS.ACCOUNT_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
							validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
					{ field: 'AccountTypeId', type: 'int', displayLabel: 'SELLER_USERS.FIELDS.ACCOUNT_TYPE_ID', visible: true, creatable: false, editable: false, inputType: 'number',
							validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
					{ field: 'FirstName', type: 'text', displayLabel: 'SELLER_USERS.FIELDS.FIRST_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
							validation: {isRequired: true, maxLen: 20, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
					{ field: 'LastName', type: 'text', displayLabel: 'SELLER_USERS.FIELDS.LAST_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
							validation: {isRequired: true, maxLen: 20, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
					{ field: 'Email', type: 'text', displayLabel: 'SELLER_USERS.FIELDS.EMAIL', visible: true, creatable: false, editable: false, inputType: 'text',
							validation: {isRequired: true, maxLen: 500, minLen: 1, pattern: '^[A-Za-z]+[A-Za-z0-9._+-]+@{1}[A-Za-z0-9._-]+\.[A-Za-z.]{2,}$', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: 'VALIDATIONS.INVALID_EMAIL'}} },
					{ field: 'Phone', type: 'text', displayLabel: 'SELLER_USERS.FIELDS.PHONE', visible: true, creatable: false, editable: false, inputType: 'tel',
							validation: {isRequired: false, maxLen: 20, minLen: 0, pattern: '[0-9]*', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '',
							invalidType: 'VALIDATIONS.INVALID_PHONE_NUMBER'}} },
					{ field: 'CountryCode', type: 'text', displayLabel: 'SELLER_USERS.FIELDS.COUNTRY', visible: false, creatable: false, editable: false, inputType: 'lookup', lookupSource: 'lists.countries',
							validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
					{ field: 'Country', type: 'text', displayLabel: 'SELLER_USERS.FIELDS.COUNTRY', visible: true, creatable: false, editable: false, inputType: 'text',
							validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
					{ field: 'City', type: 'text', displayLabel: 'SELLER_USERS.FIELDS.CITY', visible: true, creatable: false, editable: false, inputType: 'text',
							validation: {isRequired: false, maxLen: 25, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
					{ field: 'Designation', type: 'text', displayLabel: 'SELLER_USERS.FIELDS.DESIGNATION', visible: true, creatable: false, editable: false, inputType: 'text',
							validation: {isRequired: false, maxLen: 20, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
					{ field: 'Department', type: 'text', displayLabel: 'SELLER_USERS.FIELDS.DEPARTMENT', visible: true, creatable: false, editable: false, inputType: 'text',
							validation: {isRequired: false, maxLen: 20, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
					{ field: 'Status', type: 'text', displayLabel: 'SELLER_USERS.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
							validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
					{ field: 'UserName', type: 'text', displayLabel: 'SELLER_USERS.FIELDS.USER_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
							validation: {isRequired: true, maxLen: 50, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
					{ field: 'CreateDate', type: 'text', displayLabel: 'SELLER_USERS.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
							validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
					{ field: 'UpdateDate', type: 'text', displayLabel: 'SELLER_USERS.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
							validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
					{ field: 'RestrictFullRange', type: 'int', displayLabel: 'SELLER_USERS.FIELDS.RESTRICT_FULL_RANGE', visible: true, creatable: false, editable: false, inputType: 'bool-int',
							validation: {isRequired: false, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
					{ field: 'CreatedBy', type: 'text', displayLabel: 'SELLER_USERS.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
							validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
					{ field: 'UpdatedBy', type: 'text', displayLabel: 'SELLER_USERS.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
							validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
					{ field: 'Gender', type: 'text', displayLabel: 'SELLER_USERS.FIELDS.GENDER', visible: true, creatable: false, editable: false, inputType: 'text',
							validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
					{ field: 'DOB', type: 'text', displayLabel: 'SELLER_USERS.FIELDS.DOB', visible: true, creatable: false, editable: false, inputType: 'date',
							validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}}},
					{ field: 'Nationality', type: 'text', displayLabel: 'SELLER_USERS.FIELDS.NATIONALITY', visible: true, creatable: false, editable: false, inputType: 'text',
							validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
					{ field: 'Address', type: 'text', displayLabel: 'SELLER_USERS.FIELDS.ADDRESS', visible: true, creatable: false, editable: false, inputType: 'text',
							validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
					{ field: 'Website', type: 'text', displayLabel: 'SELLER_USERS.FIELDS.WEBSITE', visible: true, creatable: false, editable: false, inputType: 'text',
							validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
			],

			title: 'SELLER_USERS.NAV',
			icon: 'icon-account',
			idField: 'Id',
			lookupDisplayField: 'UserName',
			methods: {
				getList         :   getSellerUsers,
			},
			views: {
					mainList: {
							columns             : [ 'Id', 'FirstName', 'LastName', 'AccountId', 'AccountName', 'Status', 'UpdateDate', 'UpdatedBy'],
							columnFilter        : {},
							topIndex            : 0,
							showFilterRow       : false,
							sortColumn          : {'UpdateDate': false},
							itemActions         : [],
							listActions         : [],
							fabAction           : {}
					},
					mainDetails: {},
					privileges: {
							list: 'GetCatalogSellerUserList'
					}
			}
		};

		function getSellerUsers(generalProperties, catalogId) {
			var promise;
			catalogId = angular.isDefined(catalogId) ? catalogId : catalogFactory.getActiveCatalog().CatalogCode;

			if(angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
					var state = {};
					state.name = $state.current.name;
					state.params = $state.params;
					var isBulk = true;
					var logData = activityLogger.createLogData(null, state, 'catalogs.sellerUsers', 'VIEW', isBulk, new Date(), null, null);
					promise = api.webGet(api.baseUrl + '/catalogs/' + catalogId + '/sellerusers', undefined, true, generalProperties.forceFetch);
					promise = activityLogger.log(logData, promise);
			}
			else {
					promise = api.webGet(api.baseUrl + '/catalogs/' + catalogId + '/sellerusers', undefined, true, generalProperties.forceFetch);
			}

			promise.then(function() {
					if (api.catalogs.sellerUsers.isDirty) {
							//Invalidate lookupData
							api.catalogs.sellerUsers.lookupData = undefined;
							api.catalogs.sellerUsers.isDirty = false;
					}
			});
			return promise;
		}
	}
})();
(function() {
    'use strict';
    
    angular
        .module('app.main.catalogs.segmentations',[]);  
})();
(function() {
    'use strict';

    angular
        .module('app.main.catalogs.segmentations')
        .run(runBlock);

    /* @ngInject */
    function runBlock(api, activityLogger, $state, crud, catalogFactory, jobsTracker) {

        if(angular.isUndefined(api.catalogs)) {
            api.catalogs = {};
        }
        api.catalogs.segmentations = {
            modelPath: 'catalogs.segmentations',
            fields: [
                { field: 'Id', type: 'int', displayLabel: 'SEGMENTATIONS.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CatalogCode', type: 'text', displayLabel: 'SEGMENTATIONS.FIELDS.CATALOG_CODE', visible: false, creatable: false, editable: false, inputType: 'lookup', lookupSource: 'catalogs.catalogs',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Name', type: 'text', displayLabel: 'SEGMENTATIONS.FIELDS.NAME', visible: true, creatable: true, editable: true, inputType: 'text',
                    validation: {isRequired: true, maxLen: 100, minLen: 1, pattern: '^[^!*]+$', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: 'VALIDATIONS.INVALID_CHARACTER'}} },
                { field: 'Description', type: 'text', displayLabel: 'SEGMENTATIONS.FIELDS.DESCRIPTION', visible: true, creatable: true, editable: true, inputType: 'text',
                    validation: {isRequired: false, maxLen: 200, minLen: 0, pattern: '^[^!*]+$', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: 'VALIDATIONS.INVALID_CHARACTER'}} },
                { field: 'Status', type: 'text', displayLabel: 'SEGMENTATIONS.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedDate', type: 'text', displayLabel: 'SEGMENTATIONS.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedDate', type: 'text', displayLabel: 'SEGMENTATIONS.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedBy', type: 'text', displayLabel: 'SEGMENTATIONS.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedBy', type: 'text', displayLabel: 'SEGMENTATIONS.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ParentSegmentationId', type: 'int', displayLabel: 'SEGMENTATIONS.FIELDS.PARENT_SEGMENTATION_ID', visible: false, creatable: true, editable: true, inputType: 'lookup', lookupSource: 'catalogs.segmentations',
                    validation: {isRequired: false, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ParentSegmentationId', type: 'int', displayLabel: 'SEGMENTATIONS.FIELDS.PARENT_SEGMENTATION_ID', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ParentSegmentationName', type: 'text', displayLabel: 'SEGMENTATIONS.FIELDS.PARENT_SEGMENTATION_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
            ],
            uniqueConstraints: [
                {name: 'Constraint 1', fields: ['Name']}
            ],
            title: 'SEGMENTATIONS.NAV',
            icon: 'icon-group',
            idField: 'Id',
            lookupDisplayField: 'Name',
            isDirty: false,
            lastUpdatedOn: {},
            methods: {
                getList         :   getSegmentations,
                activateBulk    :   activateSegmentations,
                create          :   createSegmentation,
                createBulk      :   createBulk,
                update          :   updateSegmentation,
            },
            views: {
                mainList: {
                    columns             : [ 'Name', 'Description', 'Status', 'UpdatedDate' ],
                    columnFilter        : {},
                    toggleFilterProps   : { toggleStatus:false, filterProp:'Status', trueVal:1, trueValTooltipMessage: 'ACTIONS.TOGGLE_ACTIVE', falseVal:'', falseValTooltipMessage:"ACTIONS.TOGGLE_ALL"},
                    topIndex            : 0,
                    showFilterRow       : false,
                    sortColumn          : {'UpdatedDate': false},
                    itemActions         : [
                                            { id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UpdateCatalogSegmentation', disabled: '!itm.Status', visible: true },
                                            { id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateSegmentationStatusBulk', disabled: false, visible: 'itm.Status',
                                                requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                                            { id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateSegmentationStatusBulk', disabled: false, visible: '!itm.Status',
                                                requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
                                        ],
                    listActions         : [
                                            { id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateSegmentationStatusBulk', disabled: '{selected: true, Status: 1}',
                                                visible: true, requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                                            { id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateSegmentationStatusBulk', disabled: '{selected: true, Status: 0}',
                                                visible: true, requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'},
                                            { id: 'import', label: 'ACTIONS.IMPORT', icon: 'icon-import', privilege: 'CreateUpdateBulkCatalogSegmentation', disabled: false, visible: true, requiresConfirmation: false}
                                        ],
                    fabAction           : {id: 'add', label: 'ACTIONS.ADD', icon: 'icon-plus', privilege: 'CreateCatalogSegmentation', visible: true}
                },
                mainDetails: {},
                privileges: {
                    list: 'GetCatalogSegmentationList'
                }
            }

        };

        function getSegmentations(generalProperties, catalogId, model) {
            if(angular.isDefined(model)) { // to skip this part for load lookup
                model.isBulkActionCompleted = false;
            }
            var promise;

            if(angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
                var state = {};
                state.name = $state.current.name;
                state.params = $state.params;
                var isBulk = true;
                var logData = activityLogger.createLogData(null, state, 'catalogs.segmentations', 'VIEW', isBulk, new Date(), null, null);
                promise = api.webGet(api.baseUrl + '/catalogs/' + catalogId + '/segmentations',
                generalProperties.config || {}, true, generalProperties.forceFetch,
                generalProperties.supportIncrementalResult || true,
                generalProperties.modelIdField,
                generalProperties.isMajor || false,
                generalProperties.model || api.catalogs.segmentations);
                promise = activityLogger.log(logData, promise);
            }
            else {
                if (angular.isUndefined(catalogId)) {
                    if (angular.isDefined(generalProperties.idMap) && angular.isDefined(generalProperties.idMap.id1)) {
                        catalogId = generalProperties.idMap.id1
                    } else {
                        catalogId = catalogFactory.getActiveCatalog().CatalogCode
                    }
                }
                promise = api.webGet(api.baseUrl + '/catalogs/' + catalogId + '/segmentations',
                generalProperties.config || {}, true, generalProperties.forceFetch,
                generalProperties.supportIncrementalResult || true,
                generalProperties.modelIdField,
                generalProperties.isMajor || false,
                generalProperties.model || api.catalogs.segmentations);
            }

            promise.then(function() {
                api.catalogs.segmentations.lastUpdatedOn[catalogId] = new Date().getTime();
                if (api.catalogs.segmentations.isDirty) {
                    //Invalidate lookupData
                    api.catalogs.segmentations.lookupData = undefined;
                    api.catalogs.segmentations.isDirty = false;
                }
            });
            return promise;
		}

        function activateSegmentations(records, model, actionType, parentId) {
            var result = crud.createRequestObject(records, model, actionType);
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var isBulk = result.itemsNameList.length > 1 ? true : false;
            var logData = activityLogger.createLogData(result.itemsNameList, state, 'catalogs.segmentations', actionType.toUpperCase(), isBulk, new Date(), null, null);
			var promise = api.webPut(api.baseUrl + '/catalogs/'+ parentId +'/segmentations/status', result.requestObj);

            promise.then(function() {
                api.catalogArticles.segmentationLinear.isDirty = true;
                api.catalogCustomers.segmentationLinear.isDirty = true;
                crud.onRecordStatusChange(records, model, actionType);
            });

            return activityLogger.log(logData, promise);
        }

        function createSegmentation(segmentation, catalogId) {
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var logData = activityLogger.createLogData(segmentation[api.catalogs.segmentations.lookupDisplayField], state, 'catalogs.segmentations', 'ADD', false, new Date(), null, null);
			var promise = api.webPost(api.baseUrl + '/catalogs/' + catalogId + '/segmentations', segmentation);

            promise.then(function() {
                api.catalogs.segmentations.isDirty = true;
                api.catalogArticles.segmentationLinear.isDirty = true;
                api.catalogCustomers.segmentationLinear.isDirty = true;
            });
            return activityLogger.log(logData, promise);
        }

		function updateSegmentation(itemId, item, catalogId) {
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            if(angular.isUndefined(item.ParentSegmentationId)) {
                item.ParentSegmentationId = null;
            }
            var logData = activityLogger.createLogData(item[api.catalogs.segmentations.lookupDisplayField], state, 'catalogs.segmentations', 'EDIT', false, new Date(), null, null);
			var promise = api.webPut(api.baseUrl + '/catalogs/' + catalogId + '/segmentations/' + itemId, item);

            promise.then(function() {
                api.catalogs.segmentations.isDirty = true;
                api.catalogArticles.segmentationLinear.isDirty = true;
                api.catalogCustomers.segmentationLinear.isDirty = true;
            });
            return activityLogger.log(logData, promise);
		}

        function createBulk(model, data, catalogCode) {
            var customerSegmentationModel = api.catalogCustomers.segmentationLinear;
			var articleSegmentationModel = api.catalogArticles.segmentationLinear;
			var modelArray = [customerSegmentationModel, articleSegmentationModel];
            var jobIndex = jobsTracker.addJob(model, 'SEGMENTATIONS.ACTIONS.IMPORT_SEGMENTATIONS', 1, modelArray);
            api.webPut(api.baseUrl + '/catalogs/' + catalogCode + '/bulkcatalogsegmentations', data).then(function(response) {
                jobsTracker.setCompleted(jobIndex, response);
            }).catch(function(error) {
                jobsTracker.setCriticlaFail(jobIndex, error);
            });
        }

    }
})();
(function() {
  'use strict';

  angular
      .module('app.main.catalogs.segmentation-group')
      .run(runBlock);

  /* @ngInject */
  function runBlock(api, activityLogger, $state, crud, catalogFactory, jobsTracker) {

      if(angular.isUndefined(api.catalogs)) {
          api.catalogs = {};
      }
      api.catalogs.segmentationGroup = {
          modelPath: 'catalogs.segmentationGroup',
          fields: [
              { field: 'Id', type: 'int', displayLabel: 'SEGMENTATION_GROUP.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
                  validation: {isRequired: false, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
              { field: 'SegmentationGroup', type: 'text', displayLabel: 'SEGMENTATION_GROUP.FIELDS.SEGMENTATION_GROUP', visible: true, creatable: true, editable: false, inputType: 'text',
                  validation: {isRequired: true, maxLen: 100, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
              { field: 'Segmentations', type: 'text', displayLabel: 'SEGMENTATION_GROUP.FIELDS.SEGMENTATIONS', visible: true, creatable: false, editable: false, inputType: 'text',
                  validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
              { field: 'Status', type: 'text', displayLabel: 'SEGMENTATION_GROUP.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
                  validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
              { field: 'CreatedDate', type: 'text', displayLabel: 'SEGMENTATION_GROUP.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                  validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
              { field: 'UpdatedDate', type: 'text', displayLabel: 'SEGMENTATION_GROUP.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                  validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
              { field: 'CreatedBy', type: 'text', displayLabel: 'SEGMENTATION_GROUP.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                  validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
              { field: 'UpdatedBy', type: 'text', displayLabel: 'SEGMENTATION_GROUP.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                  validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
              { field: 'SegmentationidsList', type:'text', displayLabel: 'SEGMENTATION_GROUP.FIELDS.SEGMENTATIONS', visible: false, creatable: true, editable: true, inputType: 'lookup-many', lookupSource: 'catalogs.segmentations',
                  validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
          ],
          uniqueConstraints: [],
          title: 'SEGMENTATION_GROUP.NAV',
          icon: 'icon-group',
          idField: 'Id',
          lookupDisplayField: 'SegmentationGroup',
          isDirty: false,
          lastUpdatedOn: {},
          methods: {
              getList         :   getSegmentationGroups,
              activateBulk    :   activateSegmentationGroups,
              create          :   createSegmentationGroup,
              update          :   updateSegmentationGroup,
          },
          views: {
              mainList: {
                  columns             : [ 'SegmentationGroup', 'Segmentations', 'Status', 'UpdatedDate' ],
                  columnFilter        : {},
                  toggleFilterProps   : { toggleStatus:false, filterProp:'Status', trueVal:1, trueValTooltipMessage: 'ACTIONS.TOGGLE_ACTIVE', falseVal:'', falseValTooltipMessage:"ACTIONS.TOGGLE_ALL"},
                  topIndex            : 0,
                  showFilterRow       : false,
                  sortColumn          : {'UpdatedDate': false},
                  itemActions         : [
                                          { id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UpdateSegmentationGroup', disabled: '!itm.Status', visible: true },
                                          { id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateSegmentationGroupStatusBulk', disabled: false, visible: 'itm.Status',
                                              requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                                          { id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateSegmentationGroupStatusBulk', disabled: false, visible: '!itm.Status',
                                              requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
                                      ],
                  listActions         : [
                                          { id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateSegmentationGroupStatusBulk', disabled: '{selected: true, Status: 1}',
                                              visible: true, requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                                          { id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateSegmentationStatusBulk', disabled: '{selected: true, Status: 0}',
                                              visible: true, requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
                                      ],
                  fabAction           : {id: 'add', label: 'ACTIONS.ADD', icon: 'icon-plus', privilege: 'CreateSegmentationGroup', visible: true}
              },
              mainDetails: {},
              privileges: {
                  list: 'GetSegmentationGroups'
              }
          }

      };

    function getSegmentationGroups(generalProperties, catalogId, model) {
      if (angular.isDefined(model)) { // to skip this part for load lookup
        model.isBulkActionCompleted = false;
      }
      var promise;

      if (angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
        var state = {};
        state.name = $state.current.name;
        state.params = $state.params;
        var isBulk = true;
        var logData = activityLogger.createLogData(null, state, 'catalogs.segmentationGroup', 'VIEW', isBulk, new Date(), null, null);
        promise = api.webGet(api.baseUrl + '/catalogs/' + catalogId + '/segmentationgroups', undefined, true, generalProperties.forceFetch);
        promise = activityLogger.log(logData, promise);
      }
      else {
        catalogId = angular.isUndefined(catalogId) ? catalogFactory.getActiveCatalog().CatalogCode : catalogId;
        promise = api.webGet(api.baseUrl + '/catalogs/' + catalogId + '/segmentationgroups', undefined, true, generalProperties.forceFetch);
      }

      promise.then(function () {
        api.catalogs.segmentationGroup.lastUpdatedOn[catalogId] = new Date().getTime();
        if (api.catalogs.segmentationGroup.isDirty) {
          //Invalidate lookupData
          api.catalogs.segmentationGroup.lookupData = undefined;
          api.catalogs.segmentationGroup.isDirty = false;
        }
      });
      return promise;
    }

    function activateSegmentationGroups(records, model, actionType, parentId) {
      var result = crud.createRequestObject(records, model, actionType);
      var state = {};
      state.name = $state.current.name;
      state.params = $state.params;
      var isBulk = result.itemsNameList.length > 1 ? true : false;
      var logData = activityLogger.createLogData(result.itemsNameList, state, 'catalogs.segmentationGroup', actionType.toUpperCase(), isBulk, new Date(), null, null);
      var promise = api.webPut(api.baseUrl + '/catalogs/' + parentId + '/segmentationgroups/status', result.requestObj);

      promise.then(function () {
        crud.onRecordStatusChange(records, model, actionType);
      });

      return activityLogger.log(logData, promise);
    }

    function createSegmentationGroup(segmentationGroup, catalogId) {
      var state = {};
      var requestObject = {
        SegmentationGroup: segmentationGroup.SegmentationGroup,
        Segmentations: segmentationGroup.SegmentationidsList
    }
      state.name = $state.current.name;
      state.params = $state.params;
      var logData = activityLogger.createLogData(segmentationGroup[api.catalogs.segmentationGroup.lookupDisplayField], state, 'catalogs.segmentationGroup', 'ADD', false, new Date(), null, null);
      var promise = api.webPost(api.baseUrl + '/catalogs/' + catalogId + '/segmentationgroups', requestObject);

      promise.then(function () {
        api.catalogs.segmentationGroup.isDirty = true;
      });
      return activityLogger.log(logData, promise);
    }

    function updateSegmentationGroup(itemId, item, catalogId) {
      var state = {};
      var requestObject = {
          SegmentationGroup: item.SegmentationGroup,
          Segmentations: item.SegmentationidsList
      }
      state.name = $state.current.name;
      state.params = $state.params;
      var logData = activityLogger.createLogData(item[api.catalogs.segmentationGroup.lookupDisplayField], state, 'catalogs.segmentationGroup', 'EDIT', false, new Date(), null, null);
      var promise = api.webPut(api.baseUrl + '/catalogs/' + catalogId + '/segmentationgroups/' + itemId, requestObject);

      promise.then(function () {
        api.catalogs.segmentationGroup.isDirty = true;
      });
      return activityLogger.log(logData, promise);
    }



  }
})();
(function() {
	'use strict';

	angular
			.module('app.main.catalogs.restrict-segmentations')
			.run(runBlock);

	/* @ngInject */
	function runBlock(api, activityLogger, $state, crud) {

		if (angular.isUndefined(api.catalogs)) {
				api.catalogs = {};
		}
		api.catalogs.roleBasedRestrictSegmentations = {
				modelPath: 'catalogs.roleBasedRestrictSegmentations',
				fields: [
						{ field: 'RoleId', type: 'int', displayLabel: 'RESTRICT_SEGMENTATIONS.FIELDS.ROLE_ID', visible: true, creatable: false, editable: false, inputType: 'number',
								validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
						{ field: 'RoleName', type: 'text', displayLabel: 'RESTRICT_SEGMENTATIONS.FIELDS.ROLE_NAME', visible: true, creatable: false, editable: false,  inputType: 'textArea',
								validation: {isRequired: true, maxLen: 2000, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
						{ field: 'AccountTypeId', type: 'int', displayLabel: 'RESTRICT_SEGMENTATIONS.FIELDS.ACCOUNT_TYPE_ID', visible: true, creatable: false, editable: false, inputType: 'number',
								validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
						{ field: 'AccountType', type: 'text', displayLabel: 'RESTRICT_SEGMENTATIONS.FIELDS.ACCOUNT_TYPE', visible: true, creatable: false, editable: false, inputType: 'text',
								validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				],
				uniqueConstraints: [],
				title: 'RESTRICT_SEGMENTATIONS.NAV',
				icon: 'icon-image-filter-black-white',
				idField: 'RoleId',
				lookupDisplayField: 'RoleName',
				isDirty: false,
				isCatalogSpecificModel: true,
				methods: {
						getList         :   getRolesBasedRestrictedAttributes,
						update          :   updateRoleBasedRestrictAttributes,
						deleteBulk      :   deleteRoleBaseAttributeRestriction
				},
				views: {
						mainList: {
								columns         : [ 'RoleId', 'RoleName', 'AccountTypeId', 'AccountType'],
								columnFilter    : {},
								topIndex        : 0,
								showFilterRow   : false,
								sortColumn      : {},
								itemActions     : [
																		{ id: 'view', label: 'RESTRICT_SEGMENTATIONS.ACTIONS.VIEW_ATTRIBUTES', icon: 'icon-magnify', privilege: 'GetRoleBasedSegmentations', disabled: false, visible: true },
																		{ id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UpdateRoleBasedSegmentations', disabled: false, visible: true },
																		{ id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'RemoveRoleRestrictionFromSegmentations', disabled: false, visible: true,
																				requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
																		],
								listActions     : [
																		{ id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'RemoveRoleRestrictionFromSegmentations', disabled: '{selected: true}',
																				visible: true, requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
																		],
								fabAction       : { id: 'add', label: 'ACTIONS.ADD', icon: 'icon-plus', privilege: 'UpdateRoleBasedSegmentations', visible: true }
						},
						mainDetails: {},
						privileges: {
								list    : 'GetRoleBasedSegmentations'
						}
				}
		};

		api.catalogs.restrictedSegmentations = {
			modelPath: 'catalogs.restrictedAttributes',
			fields: [
					{ field: 'Id', type: 'int', displayLabel: 'RESTRICT_SEGMENTATIONS.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
							validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
					{ field: 'Name', type: 'text', displayLabel: 'RESTRICT_SEGMENTATIONS.FIELDS.NAME', visible: true, creatable: false, editable: false,  inputType: 'text',
							validation: {isRequired: true, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
					{ field: 'NotEditable', type: 'int', displayLabel: 'RESTRICT_SEGMENTATIONS.FIELDS.NOT_EDITABLE', visible: true, creatable: false, editable: false, inputType: 'bool-int',
							validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
					{ field: 'NotViewable', type: 'int', displayLabel: 'RESTRICT_SEGMENTATIONS.FIELDS.NOT_VIEWABLE', visible: true, creatable: false, editable: false, inputType: 'bool-int',
							validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
					],
			uniqueConstraints: [],
			title: 'RESTRICT_SEGMENTATIONS.TITLES',
			icon: 'icon-image-filter-black-white',
			idField: 'Id',
			lookupDisplayField: 'Name',
			isDirty: false,
			isCatalogSpecificModel: true,
			methods: {},
			views: {
					mainList: {
							columns         : ['Id', 'Name', 'NotEditable', 'NotViewable'],
							columnFilter    : {},
							topIndex        : 0,
							showFilterRow   : false,
							sortColumn      : {},
							itemActions     : [],
							listActions     : [],
							fabAction       : {}
					},
					mainDetails: {},
					privileges: {
							list    : 'GetRoleBasedSegmentations'
					}
			}
		};

		function getRolesBasedRestrictedAttributes(generalProperties, catalogId) {
			var promise;

			if (angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
					promise = api.webGet(api.baseUrl + '/catalogs/' + catalogId + '/role/segmentations', undefined, true, generalProperties.forceFetch);
			}
			else {
					promise = api.webGet(api.baseUrl + '/catalogs/' + catalogId + '/role/segmentations', undefined, true, generalProperties.forceFetch);
			}

			promise.then(function () {
					if (api.catalogs.roleBasedRestrictSegmentations.isDirty) {
							//Invalidate lookupData
							api.catalogs.roleBasedRestrictSegmentations.lookupData = undefined;
							api.catalogs.roleBasedRestrictSegmentations.isDirty = false;
					}
			});
			return promise;
		}

		function updateRoleBasedRestrictAttributes(records, catalogCode) {
			var state = {};
			state.name = $state.current.name;
			state.params = $state.params;
			var logData = activityLogger.createLogData(records[api.catalogs.roleBasedRestrictSegmentations.lookupDisplayField], state, 'catalogs.roleBasedRestrictSegmentations', 'EDIT', false, new Date(), null, null);
			var promise = api.webPut(api.baseUrl + '/catalogs/' + catalogCode + '/role/segmentations', records);

			promise.then(function () {
				api.catalogs.roleBasedRestrictSegmentations.isDirty = true;
			});
			return activityLogger.log(logData, promise);
		}

		function deleteRoleBaseAttributeRestriction(records, model, actionType, catalogCode) {
			var requestObj = [];
			if (!angular.isArray(records)) {
				records = crud.pushItemToArray(records);
			}
			requestObj = records.map(function(role) {
				return role['RoleId'];
			});
			var state = {};
			state.name = $state.current.name;
			state.params = $state.params;
			var isBulk = records.length > 1 ? true : false;
			var logData = activityLogger.createLogData(records, state, 'catalogs.roleBasedRestrictSegmentations', actionType.toUpperCase(), isBulk, new Date(), null, null);
			var promise = api.webPut(api.baseUrl + '/catalogs/' + catalogCode + '/segmentations/remove/roles', requestObj);

			promise.then(function () {
				api.catalogs.roleBasedRestrictSegmentations.isDirty = true;
			});
			return activityLogger.log(logData, promise);
		}
	}
})();
(function() {
	'use strict';

	angular
			.module('app.main.catalogs.restrict-retail-windows')
			.run(runBlock);

	/* @ngInject */
	function runBlock(api, activityLogger, $state, crud) {

		if (angular.isUndefined(api.catalogs)) {
				api.catalogs = {};
		}
		api.catalogs.roleBasedRestrictRetailWindows = {
				modelPath: 'catalogs.roleBasedRestrictRetailWindows',
				fields: [
						{ field: 'RoleId', type: 'int', displayLabel: 'RESTRICT_RETAIL_WINDOWS.FIELDS.ROLE_ID', visible: true, creatable: false, editable: false, inputType: 'number',
								validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
						{ field: 'RoleName', type: 'text', displayLabel: 'RESTRICT_RETAIL_WINDOWS.FIELDS.ROLE_NAME', visible: true, creatable: false, editable: false,  inputType: 'textArea',
								validation: {isRequired: true, maxLen: 2000, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
						{ field: 'AccountTypeId', type: 'int', displayLabel: 'RESTRICT_RETAIL_WINDOWS.FIELDS.ACCOUNT_TYPE_ID', visible: true, creatable: false, editable: false, inputType: 'number',
								validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
						{ field: 'AccountType', type: 'text', displayLabel: 'RESTRICT_RETAIL_WINDOWS.FIELDS.ACCOUNT_TYPE', visible: true, creatable: false, editable: false, inputType: 'text',
								validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
						{ field: 'NotEditable', type: 'int', displayLabel: 'RESTRICT_RETAIL_WINDOWS.FIELDS.NOT_EDITABLE', visible: true, creatable: false, editable: false, inputType: 'bool-int',
								validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
						{ field: 'NotViewable', type: 'int', displayLabel: 'RESTRICT_RETAIL_WINDOWS.FIELDS.NOT_VIEWABLE', visible: true, creatable: false, editable: false, inputType: 'bool-int',
								validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
				],
				uniqueConstraints: [],
				title: 'RESTRICT_RETAIL_WINDOWS.NAV',
				icon: 'icon-image-filter-black-white',
				idField: 'RoleId',
				lookupDisplayField: 'RoleName',
				isDirty: false,
				isCatalogSpecificModel: true,
				methods: {
						getList         :   getRolesBasedRestrictedAttributes,
						update          :   updateRoleBasedRestrictAttributes,
						deleteBulk      :   deleteRoleBaseAttributeRestriction
				},
				views: {
						mainList: {
								columns         : [ 'RoleId', 'RoleName', 'NotEditable', 'NotViewable', 'AccountType'],
								columnFilter    : {},
								topIndex        : 0,
								showFilterRow   : false,
								sortColumn      : {},
								itemActions     : [
																		{ id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UpdateRoleBasedInformation', disabled: false, visible: true },
																		{ id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'RemoveRoleRestrictionFromInformation', disabled: false, visible: true,
																				requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
																		],
								listActions     : [
																		{ id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'RemoveRoleRestrictionFromInformation', disabled: '{selected: true}',
																				visible: true, requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
																		],
								fabAction       : { id: 'add', label: 'ACTIONS.ADD', icon: 'icon-plus', privilege: 'UpdateRoleBasedInformation', visible: true }
						},
						mainDetails: {},
						privileges: {
								list    : 'GetRoleBasedInformation'
						}
				}
		};

		function getRolesBasedRestrictedAttributes(generalProperties, catalogId) {
			var promise;

			if (angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
					promise = api.webGet(api.baseUrl + '/catalogs/' + catalogId + '/role/reservedattributes', undefined, true, generalProperties.forceFetch);
			}
			else {
					promise = api.webGet(api.baseUrl + '/catalogs/' + catalogId + '/role/reservedattributes', undefined, true, generalProperties.forceFetch);
			}

			promise.then(function () {
					if (api.catalogs.roleBasedRestrictRetailWindows.isDirty) {
							//Invalidate lookupData
							api.catalogs.roleBasedRestrictRetailWindows.lookupData = undefined;
							api.catalogs.roleBasedRestrictRetailWindows.isDirty = false;
					}
			});
			return promise;
		}

		function updateRoleBasedRestrictAttributes(records, catalogCode) {
			var state = {};
			state.name = $state.current.name;
			state.params = $state.params;
			var logData = activityLogger.createLogData(records[api.catalogs.roleBasedRestrictRetailWindows.lookupDisplayField], state, 'catalogs.roleBasedRestrictRetailWindows', 'EDIT', false, new Date(), null, null);
			var promise = api.webPut(api.baseUrl + '/catalogs/' + catalogCode + '/role/reservedattributes', records);

			promise.then(function () {
				api.catalogs.roleBasedRestrictRetailWindows.isDirty = true;
			});
			return activityLogger.log(logData, promise);
		}

		function deleteRoleBaseAttributeRestriction(records, model, actionType, catalogCode) {
			var requestObj = [];
			if (!angular.isArray(records)) {
				records = crud.pushItemToArray(records);
			}
			requestObj = records.map(function(role) {
				return role['RoleId'];
			});
			var state = {};
			state.name = $state.current.name;
			state.params = $state.params;
			var isBulk = records.length > 1 ? true : false;
			var logData = activityLogger.createLogData(records, state, 'catalogs.roleBasedRestrictRetailWindows', actionType.toUpperCase(), isBulk, new Date(), null, null);
			var promise = api.webPut(api.baseUrl + '/catalogs/' + catalogCode + '/reservedattributes/remove/roles', requestObj);

			promise.then(function () {
				api.catalogs.roleBasedRestrictRetailWindows.isDirty = true;
			});
			return activityLogger.log(logData, promise);
		}
	}
})();
(function() {
		'use strict';

		angular
				.module('app.main.catalogs.restrict-bucket-attributes')
				.run(runBlock);

		/* @ngInject */
		function runBlock(api, activityLogger, $state, crud) {

			if (angular.isUndefined(api.catalogs)) {
					api.catalogs = {};
			}
			api.catalogs.restrictBucketAttributesRoles= {
					modelPath: 'catalogs.restrictBucketAttributesRoles',
					fields: [
							{ field: 'RoleId', type: 'int', displayLabel: 'RESTRICT_BUCKET_ATTRIBUTES.FIELDS.ROLE_ID', visible: true, creatable: false, editable: false, inputType: 'number',
									validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
							{ field: 'RoleName', type: 'text', displayLabel: 'RESTRICT_BUCKET_ATTRIBUTES.FIELDS.ROLE_NAME', visible: true, creatable: false, editable: false,  inputType: 'textArea',
									validation: {isRequired: true, maxLen: 2000, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
							{ field: 'AccountTypeId', type: 'int', displayLabel: 'RESTRICT_BUCKET_ATTRIBUTES.FIELDS.ACCOUNTTYPE_ID', visible: true, creatable: false, editable: false, inputType: 'number',
									validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
							{ field: 'AccountType', type: 'text', displayLabel: 'RESTRICT_BUCKET_ATTRIBUTES.FIELDS.ACCOUNT_TYPE', visible: true, creatable: false, editable: false, inputType: 'text',
									validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
							{ field: 'Status', type: 'text', displayLabel: 'RESTRICT_BUCKET_ATTRIBUTES.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
									validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
							],
					uniqueConstraints: [],
					title: 'RESTRICT_BUCKET_ATTRIBUTES.NAV',
					icon: 'icon-image-filter-black-white',
					idField: 'RoleId',
					lookupDisplayField: 'RoleName',
					isDirty: false,
					isCatalogSpecificModel: true,
					methods: {
							getList         :   getRestrictBucketAttributesRoles,
							update          :   updateRestrictBucketAttributesRoles,
							deleteBulk      :   deleteRestrictBucketRoles
					},
					views: {
							mainList: {
									columns         : [ 'RoleId', 'RoleName', 'AccountTypeId', 'AccountType'],
									columnFilter    : {},
									topIndex        : 0,
									showFilterRow   : false,
									sortColumn      : {},
									itemActions     : [
																			{ id: 'view', label: 'RESTRICT_BUCKET_ATTRIBUTES.ACTIONS.VIEW_BUCKET_ATTRIBUTES', icon: 'icon-magnify', privilege: 'GetRoleBasedCatalogBucketAttributes', disabled: '!itm.Status', visible: true },
																			{ id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UpdateRoleBasedCatalogBucketAttributes', disabled: '!itm.Status', visible: true },
																			{ id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'RemoveRoleRestrictionFromCatalogBucketAttributes', disabled: false, visible: 'itm.Status',
																					requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
																			],
									listActions     : [
																			{ id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'RemoveRoleRestrictionFromCatalogBucketAttributes', disabled: '{selected: true, Status: 1}',
																					visible: true, requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
																			],
									fabAction       : { id: 'add', label: 'ACTIONS.ADD', icon: 'icon-plus', privilege: 'UpdateRoleBasedCatalogBucketAttributes:true', visible: true }
							},
							mainDetails: {},
							privileges: {
									list    : 'GetRoleBasedCatalogBucketAttributes'
							}
					}
			};

			api.catalogs.restrictedBucketAttributes = {
				modelPath: 'catalogs.restrictedBucketAttributes',
				fields: [
						{ field: 'Id', type: 'int', displayLabel: 'RESTRICT_BUCKET_ATTRIBUTES.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
								validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
						{ field: 'AttributeDisplayName', type: 'text', displayLabel: 'RESTRICT_BUCKET_ATTRIBUTES.FIELDS.ATTRIBUTE_NAME', visible: true, creatable: false, editable: false,  inputType: 'text',
								validation: {isRequired: true, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
						{ field: 'AttributeSystemName', type: 'text', displayLabel: 'RESTRICT_BUCKET_ATTRIBUTES.FIELDS.SYSTEM_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
								validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
						{ field: 'NotEditable', type: 'int', displayLabel: 'RESTRICT_BUCKET_ATTRIBUTES.FIELDS.NOT_EDITABLE', visible: true, creatable: false, editable: false, inputType: 'bool-int',
								validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
						{ field: 'NotViewable', type: 'int', displayLabel: 'RESTRICT_BUCKET_ATTRIBUTES.FIELDS.NOT_VIEWABLE', visible: true, creatable: false, editable: false, inputType: 'bool-int',
								validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
						],
				uniqueConstraints: [],
				title: 'RESTRICT_BUCKET_ATTRIBUTES.TITLES',
				icon: 'icon-image-filter-black-white',
				idField: 'Id',
				lookupDisplayField: 'AttributeDisplayName',
				isDirty: false,
				isCatalogSpecificModel: true,
				methods: {},
				views: {
						mainList: {
								columns         : [ 'Id', 'AttributeSystemName', 'AttributeDisplayName', 'NotEditable', 'NotViewable'],
								columnFilter    : {},
								topIndex        : 0,
								showFilterRow   : false,
								sortColumn      : {},
								itemActions     : [],
								listActions     : [],
								fabAction       : {}
						},
						mainDetails: {},
						privileges: {
								list    : 'GetRoleBasedCatalogBucketAttributes'
						}
				}
			};

			function getRestrictBucketAttributesRoles(generalProperties, catalogId) {
					var promise;

					if (angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
							promise = api.webGet(api.baseUrl + '/catalogs/' + catalogId + '/role/bucketattributes', undefined, true, generalProperties.forceFetch);
					}
					else {
							promise = api.webGet(api.baseUrl + '/catalogs/' + catalogId + '/role/bucketattributes', undefined, true, generalProperties.forceFetch);
					}

					promise.then(function () {
							if (api.catalogs.restrictBucketAttributesRoles.isDirty) {
									//Invalidate lookupData
									api.catalogs.restrictBucketAttributesRoles.lookupData = undefined;
									api.catalogs.restrictBucketAttributesRoles.isDirty = false;
							}
					});
					return promise;
			}

			function updateRestrictBucketAttributesRoles(records, catalogCode) {
				var state = {};
				state.name = $state.current.name;
				state.params = $state.params;
				var logData = activityLogger.createLogData(records[api.catalogs.restrictBucketAttributesRoles.lookupDisplayField], state, 'catalogs.restrictBucketAttributes', 'EDIT', false, new Date(), null, null);
				var promise = api.webPut(api.baseUrl + '/catalogs/' + catalogCode + '/role/bucketattributes', records);
	
				promise.then(function () {
					api.catalogs.restrictBucketAttributesRoles.isDirty = true;
				});
				return activityLogger.log(logData, promise);
			}

			function deleteRestrictBucketRoles(records, actionType, catalogCode) {
				var requestObj = [];
				if (!angular.isArray(records)) {
					records = crud.pushItemToArray(records);
				}
				requestObj = records.map(function(role) {
					return role['RoleId'];
				});
				var state = {};
				state.name = $state.current.name;
				state.params = $state.params;
				var isBulk = records.length > 1 ? true : false;
				var logData = activityLogger.createLogData(records, state, 'catalogs.restrictBucketAttributesRoles', actionType.toUpperCase(), isBulk, new Date(), null, null);
				var promise = api.webPut(api.baseUrl + '/catalogs/' + catalogCode + '/bucketattributes/remove/roles', requestObj);
	
				promise.then(function () {
					api.catalogs.restrictBucketAttributesRoles.isDirty = true;
				});
				return activityLogger.log(logData, promise);
			}

	}
})();
(function() {
  'use strict';

  angular
      .module('app.main.catalogs.restrict-attributes')
      .run(runBlock);

  /* @ngInject */
  function runBlock(api, activityLogger, $state, crud) {

    if (angular.isUndefined(api.catalogs)) {
        api.catalogs = {};
    }
    api.catalogs.roleBaseRestrictAttributes = {
        modelPath: 'catalogs.roleBaseRestrictAttributes',
        fields: [
            { field: 'RoleId', type: 'int', displayLabel: 'RESTRICT_ATTRIBUTES.FIELDS.ROLE_ID', visible: true, creatable: false, editable: false, inputType: 'number',
                validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
            { field: 'RoleName', type: 'text', displayLabel: 'RESTRICT_ATTRIBUTES.FIELDS.ROLE_NAME', visible: true, creatable: false, editable: false,  inputType: 'textArea',
                validation: {isRequired: true, maxLen: 2000, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
            { field: 'AccountTypeId', type: 'int', displayLabel: 'RESTRICT_ATTRIBUTES.FIELDS.ACCOUNT_TYPE_ID', visible: true, creatable: false, editable: false, inputType: 'number',
                validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
            { field: 'AccountType', type: 'text', displayLabel: 'RESTRICT_ATTRIBUTES.FIELDS.ACCOUNT_TYPE', visible: true, creatable: false, editable: false, inputType: 'text',
                validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
            { field: 'Status', type: 'text', displayLabel: 'RESTRICT_ATTRIBUTES.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
                validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
        ],
        uniqueConstraints: [],
        title: 'RESTRICT_ATTRIBUTES.NAV',
        icon: 'icon-image-filter-black-white',
        idField: 'RoleId',
        lookupDisplayField: 'RoleName',
        isDirty: false,
        isCatalogSpecificModel: true,
        methods: {
            getList         :   getRolesBasedRestrictedAttributes,
            update          :   updateRoleBasedRestrictAttributes,
            deleteBulk      :   deleteRoleBaseAttributeRestriction
        },
        views: {
            mainList: {
                columns         : [ 'RoleId', 'RoleName', 'AccountTypeId', 'AccountType'],
                columnFilter    : {},
                topIndex        : 0,
                showFilterRow   : false,
                sortColumn      : {},
                itemActions     : [
                                    { id: 'view', label: 'RESTRICT_ATTRIBUTES.ACTIONS.VIEW_ATTRIBUTES', icon: 'icon-magnify', privilege: 'GetRoleBasedCatalogArticleAttributes', disabled: '!itm.Status', visible: true },
                                    { id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UpdateRoleBasedCatalogArticleAttributes', disabled: '!itm.Status', visible: true },
                                    { id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'RemoveRoleRestrictionFromCatalogArticleAttributes', disabled: false, visible: 'itm.Status',
                                        requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                                    ],
                listActions     : [
                                    { id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'RemoveRoleRestrictionFromCatalogArticleAttributes', disabled: '{selected: true, Status: 1}',
                                        visible: true, requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                                    ],
                fabAction       : { id: 'add', label: 'ACTIONS.ADD', icon: 'icon-plus', privilege: 'UpdateRoleBasedCatalogArticleAttributes', visible: true }
            },
            mainDetails: {},
            privileges: {
                list    : 'GetRoleBasedCatalogArticleAttributes'
            }
        }
    };

    api.catalogs.restrictedAttributes = {
      modelPath: 'catalogs.restrictedAttributes',
      fields: [
          { field: 'Id', type: 'int', displayLabel: 'RESTRICT_ATTRIBUTES.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
              validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
          { field: 'AttributeDisplayName', type: 'text', displayLabel: 'RESTRICT_ATTRIBUTES.FIELDS.ATTRIBUTE_NAME', visible: true, creatable: false, editable: false,  inputType: 'text',
              validation: {isRequired: true, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
          { field: 'AttributeSystemName', type: 'text', displayLabel: 'RESTRICT_ATTRIBUTES.FIELDS.ATTRIBUTE_SYSTEM_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
              validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
          { field: 'NotEditable', type: 'int', displayLabel: 'RESTRICT_ATTRIBUTES.FIELDS.NOT_EDITABLE', visible: true, creatable: false, editable: false, inputType: 'bool-int',
              validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
          { field: 'NotViewable', type: 'int', displayLabel: 'RESTRICT_ATTRIBUTES.FIELDS.NOT_VIEWABLE', visible: true, creatable: false, editable: false, inputType: 'bool-int',
              validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
          ],
      uniqueConstraints: [],
      title: 'RESTRICT_ATTRIBUTES.TITLES',
      icon: 'icon-image-filter-black-white',
      idField: 'Id',
      lookupDisplayField: 'AttributeDisplayName',
      isDirty: false,
      isCatalogSpecificModel: true,
      methods: {},
      views: {
          mainList: {
              columns         : ['AttributeSystemName', 'AttributeDisplayName', 'NotEditable', 'NotViewable'],
              columnFilter    : {},
              topIndex        : 0,
              showFilterRow   : false,
              sortColumn      : {},
              itemActions     : [],
              listActions     : [],
              fabAction       : {}
          },
          mainDetails: {},
          privileges: {
              list    : 'GetRoleBasedCatalogArticleAttributes'
          }
      }
    };

    function getRolesBasedRestrictedAttributes(generalProperties, catalogId) {
      var promise;

      if (angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
          promise = api.webGet(api.baseUrl + '/catalogs/' + catalogId + '/role/articleattributes', undefined, true, generalProperties.forceFetch);
      }
      else {
          promise = api.webGet(api.baseUrl + '/catalogs/' + catalogId + '/role/articleattributes', undefined, true, generalProperties.forceFetch);
      }

      promise.then(function () {
          if (api.catalogs.roleBaseRestrictAttributes.isDirty) {
              //Invalidate lookupData
              api.catalogs.roleBaseRestrictAttributes.lookupData = undefined;
              api.catalogs.roleBaseRestrictAttributes.isDirty = false;
          }
      });
      return promise;
    }

    function updateRoleBasedRestrictAttributes(records, catalogCode) {
      var state = {};
      state.name = $state.current.name;
      state.params = $state.params;
      var logData = activityLogger.createLogData(records[api.catalogs.roleBaseRestrictAttributes.lookupDisplayField], state, 'catalogs.roleBaseRestrictAttributes', 'EDIT', false, new Date(), null, null);
      var promise = api.webPut(api.baseUrl + '/catalogs/' + catalogCode + '/role/articleattributes', records);

      promise.then(function () {
        api.catalogs.roleBaseRestrictAttributes.isDirty = true;
      });
      return activityLogger.log(logData, promise);
    }

    function deleteRoleBaseAttributeRestriction(records, model, actionType, catalogCode) {
      var requestObj = [];
      if (!angular.isArray(records)) {
        records = crud.pushItemToArray(records);
      }
      requestObj = records.map(function(role) {
        return role['RoleId'];
      });
      var state = {};
      state.name = $state.current.name;
      state.params = $state.params;
      var isBulk = records.length > 1 ? true : false;
      var logData = activityLogger.createLogData(records, state, 'catalogs.roleBaseRestrictAttributes', actionType.toUpperCase(), isBulk, new Date(), null, null);
      var promise = api.webPut(api.baseUrl + '/catalogs/' + catalogCode + '/articleattributes/remove/roles', requestObj);

      promise.then(function () {
        api.catalogs.roleBaseRestrictAttributes.isDirty = true;
      });
      return activityLogger.log(logData, promise);
    }
  }
})();
(function() {
		'use strict';
		
		angular
				.module('app.main.catalogs.request-reasons', [])
				.config(config);

		/* @ngInject */
		function config($translatePartialLoaderProvider) {

				// Translation
				$translatePartialLoaderProvider.addPart('app/main/catalogs/details/tabs/request-reasons');
		}
})();
(function() {
		'use strict';

		angular
				.module('app.main.catalogs.request-reasons')
				.run(runBlock);

		/* @ngInject */
		function runBlock(api, activityLogger, $state, crud, jobsTracker, CONSTANTS) {

			if (angular.isUndefined(api.catalogs)) {
					api.catalogs = {};
			}
			api.catalogs.requestReasons= {
					modelPath: 'catalogs.requestReasons',
					fields: [
							{ field: 'Id', type: 'int', displayLabel: 'REQUEST_REASONS.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
									validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
							{ field: 'Type', type: 'int', displayLabel: 'REQUEST_REASONS.FIELDS.REASON_TYPE', visible: true, creatable: true, editable: true, inputType: 'lookup', lookupSource:'lists.reasonTypes',
									validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
							{ field: 'RequestType', type: 'text', displayLabel: 'REQUEST_REASONS.FIELDS.REQUEST_TYPE', visible: true, creatable: true, editable: true, inputType: 'lookup', lookupSource:'lists.requestReasonsTypes',
									validation: {isRequired: true, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
							{ field: 'Reason', type: 'text', displayLabel: 'REQUEST_REASONS.FIELDS.REASON', visible: true, creatable: true, editable: true,  inputType: 'textArea',
									validation: {isRequired: true, maxLen: 2000, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
							{ field: 'Status', type: 'text', displayLabel: 'REQUEST_REASONS.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
									validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
							{ field: 'CreatedDate', type: 'text', displayLabel: 'REQUEST_REASONS.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
									validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
							{ field: 'UpdatedDate', type: 'text', displayLabel: 'REQUEST_REASONS.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
									validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
							{ field: 'CreatedBy', type: 'text', displayLabel: 'REQUEST_REASONS.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
									validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
							{ field: 'UpdatedBy', type: 'text', displayLabel: 'REQUEST_REASONS.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
									validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
					],
					uniqueConstraints: [],
					title: 'REQUEST_REASONS.NAV',
					icon: 'icon-image-filter-black-white',
					idField: 'Id',
					lookupDisplayField: 'Reason',
					isDirty: false,
					isCatalogSpecificModel: true,
					methods: {
							getList         :   getRequestReasons,
							create          :   createRequestReason,
							update          :   updateRequestReason,
							activateBulk    :   activatRequestReasons,
							createBulk      :   createBulk
					},
					views: {
							mainList: {
									columns         : [ 'Id', 'Reason', 'Type', 'Status', 'UpdatedBy', 'UpdatedDate'],
									columnFilter    : {},
									topIndex        : 0,
									showFilterRow   : false,
									sortColumn      : {'UpdatedDate': false},
									itemActions     : [
																			{ id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UpdateRequestReason', disabled: '!itm.Status', visible: true },
																			{ id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateRequestReasonsStatuses', disabled: false, visible: 'itm.Status',
																					requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
																			{ id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateRequestReasonsStatuses', disabled: false, visible: '!itm.Status',
																					requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
																		],
									listActions     : [
																			{ id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateRequestReasonsStatuses', disabled: '{selected: true, Status: 1}',
																					visible: true, requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
																			{ id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateRequestReasonsStatuses', disabled: '{selected: true, Status: 0}',
																					visible: true, requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'},
																			{ id: 'import', label: 'ACTIONS.IMPORT', icon: 'icon-import', privilege: 'ImportRequestReasonsInBulk:true', disabled: false, visible: true, requiresConfirmation: false }
																		],
									fabAction       : { id: 'add', label: 'ACTIONS.ADD', icon: 'icon-plus', privilege: 'CreateRequestReason:true', visible: true }
							},
							mainDetails: {},
							privileges: {
									list    : 'GetRequestReasons'
							}
					}
			};

			function getRequestReasons(generalProperties, catalogId) {
					api.catalogs.requestReasons.isBulkActionCompleted = false;
					var promise;

					if (angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
							promise = api.webGet(api.baseUrl + '/catalogs/' + catalogId + '/requests/reasons', undefined, true, generalProperties.forceFetch);
					}
					else {
							promise = api.webGet(api.baseUrl + '/catalogs/' + catalogId + '/requests/reasons', undefined, true, generalProperties.forceFetch);
					}

					promise.then(function () {
							if (api.catalogs.requestReasons.isDirty) {
									//Invalidate lookupData
									api.catalogs.requestReasons.lookupData = undefined;
									api.catalogs.requestReasons.isDirty = false;
							}
					});
					return promise;
			}

			function createRequestReason(record, catalogCode) {
				var state = {};
				state.name = $state.current.name;
				state.params = $state.params;
				var logData = activityLogger.createLogData(record[api.catalogs.requestReasons.lookupDisplayField], state, 'catalogs.requestReasons', 'ADD', false, new Date(), null, null);
				var promise = api.webPost(api.baseUrl + '/catalogs/' + catalogCode + '/requests/reasons', record);

				promise.then(function () {
					api.catalogs.requestReasons.isDirty = true;
				});
				return activityLogger.log(logData, promise);
			}

			function createBulk(data, catalogCode, model) {
				var jobIndex = jobsTracker.addJob(model, 'REQUEST_REASONS.ACTIONS.IMPORT', 1);
				api.webPost(api.baseUrl + '/catalogs/' + catalogCode + '/requests/reasons/importbulk' + '?sourceapplication=' + CONSTANTS.SOURCE_APPLICATION + '&sourceaction=ImportRequestReasons', data).then(function (response) {
					jobsTracker.trackJob(jobIndex, response.data.Id);
					api.catalogs.requestReasons.isDirty = true;
				}).catch(function (error) {
					jobsTracker.setCriticlaFail(jobIndex, error);
				});
			}

			function updateRequestReason(Id, requestReason, catalogCode) {
				var state = {};
				state.name = $state.current.name;
				state.params = $state.params;
				var logData = activityLogger.createLogData(requestReason[api.catalogs.requestReasons.lookupDisplayField], state, 'catalogs.requestReasons', 'EDIT', false, new Date(), null, null);
				var promise = api.webPut(api.baseUrl + '/catalogs/' + catalogCode + '/requests/reasons/' + Id, requestReason);

				promise.then(function () {
					api.catalogs.requestReasons.isDirty = true;
				});
				return activityLogger.log(logData, promise);
			}

			function activatRequestReasons(records, model, actionType, catalogCode) {
				var result = crud.createRequestObject(records, model, actionType);
				var state = {};
				state.name = $state.current.name;
				state.params = $state.params;
				var isBulk = result.itemsNameList.length > 1 ? true : false;
				var logData = activityLogger.createLogData(result.itemsNameList, state, 'catalogs.requestReasons', actionType.toUpperCase(), isBulk, new Date(), null, null);
				var promise = api.webPut(api.baseUrl + '/catalogs/' + catalogCode + '/requests/reasons/status', result.requestObj);

				promise.then(function () {
					crud.onRecordStatusChange(records, model, actionType);
				});

				return activityLogger.log(logData, promise);
			}

	}
})();
(function() {
		'use strict';
		
		angular
				.module('app.main.catalogs.requestAttributes', [])
				.config(config);

		/* @ngInject */
		function config($translatePartialLoaderProvider) {

				// Translation
				$translatePartialLoaderProvider.addPart('app/main/catalogs/details/tabs/request-attributes');
		}
})();
(function() {
		'use strict';

		angular
				.module('app.main.catalogs.requestAttributes')
				.run(runBlock);

		/* @ngInject */
		function runBlock(api, utility) {

			if (angular.isUndefined(api.catalogs)) {
					api.catalogs = {};
			}
			api.catalogs.requestAttributes = {
					modelPath: 'catalogs.requestAttributes',
					fields: [
							{ field: 'Id', type: 'int', displayLabel: 'REQUEST_ATTRIBUTES.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
									validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
							{ field: 'AttributeId', type: 'int', displayLabel: 'REQUEST_ATTRIBUTES.FIELDS.ATTRIBUTE_ID', visible: true, creatable: false, editable: false, inputType: 'number',
									validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
							{ field: 'AttributeidsList', type: 'text', displayLabel: 'REQUEST_ATTRIBUTES.FIELDS.ATTRIBUTE_ID', visible: false, creatable: false, editable: true,  inputType: 'lookup-many', lookupSource: 'catalogs.availableAttributeForRequestAttribute',
									lookupFilter: {IsSeasonless: 0, IsSeasonlessModelAttribute: 0},validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
							{ field: 'AttributeDisplayName', type: 'text', displayLabel: 'REQUEST_ATTRIBUTES.FIELDS.ATTRIBUTE_NAME', visible: true, creatable: false, editable: false, inputType: 'textArea',
									validation: {isRequired: true, maxLen: 200, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
							{ field: 'AttributeSystemName', type: 'text', displayLabel: 'REQUEST_ATTRIBUTES.FIELDS.SYSTEM_NAME', visible: true, creatable: false, editable: false, inputType: 'textArea',
									validation: {isRequired: false, maxLen: 128, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
							{ field: 'AttributeTypeId', type: 'int', displayLabel: 'REQUEST_ATTRIBUTES.FIELDS.ATTRIBUTE_TYPE_ID', visible: true, creatable: false, editable: false, inputType: 'number',
									validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
							{ field: 'AttributeTypeName', type: 'text', displayLabel: 'REQUEST_ATTRIBUTES.FIELDS.ATTRIBUTE_TYPE_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
									validation: {isRequired: false, maxLen: 25, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
							{ field: 'Status', type: 'text', displayLabel: 'REQUEST_ATTRIBUTES.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
									validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
							{ field: 'CreatedDate', type: 'text', displayLabel: 'REQUEST_ATTRIBUTES.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
									validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
							{ field: 'UpdatedDate', type: 'text', displayLabel: 'REQUEST_ATTRIBUTES.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
									validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
							{ field: 'CreatedBy', type: 'text', displayLabel: 'REQUEST_ATTRIBUTES.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
									validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
							{ field: 'UpdatedBy', type: 'text', displayLabel: 'REQUEST_ATTRIBUTES.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
									validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
					],
					uniqueConstraints: [],
					title: 'REQUEST_ATTRIBUTES.NAV',
					icon: 'icon-image-filter-black-white',
					idField: 'AttributeId',
					lookupDisplayField: 'AttributeDisplayName',
					isDirty: false,
					isCatalogSpecificModel: true,
					methods: {
							getList         :   getAssignedRequestAttributes,
							update          :   assignRequestAttributes,
							activateBulk    :   activateRequestAttributes
					},
					views: {
							mainList: {
									columns         : [ 'Id', 'AttributeId', 'AttributeDisplayName', 'AttributeSystemName', 'AttributeTypeId', 'AttributeTypeName', 'UpdatedBy', 'UpdatedDate'],
									columnFilter    : {},
									topIndex        : 0,
									showFilterRow   : false,
									sortColumn      : {'UpdatedDate': false},
									itemActions     : [
																			{ id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'AssignRequestAttributes', disabled: false, visible: 'itm.Status',
																					requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
																			{ id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'AssignRequestAttributes', disabled: false, visible: '!itm.Status',
																					requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
																		],
									listActions     : [
																			{ id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'AssignRequestAttributes', disabled: '{selected: true, Status: 1}',
																					visible: true, requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
																			{ id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'AssignRequestAttributes', disabled: '{selected: true, Status: 0}',
																					visible: true, requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
																		],
									fabAction       : { id: 'add', label: 'ACTIONS.ADD', icon: 'icon-link', privilege: 'GetAttributeList:true', visible: true }
							},
							mainDetails: {},
							privileges: {
									list    : 'GetRequestAttributes'
							}
					}
			};

			function getAssignedRequestAttributes(generalProperties, catalogId) {
					var promise;
					if (angular.isUndefined(catalogId)) {
							if (angular.isDefined(generalProperties.idMap) && angular.isDefined(generalProperties.idMap.id1)) {
									catalogId = generalProperties.idMap.id1;
							}
					}

					if (angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
							promise = api.webGet(api.baseUrl + '/catalogs/' + catalogId + '/requestattributes', undefined, true, generalProperties.forceFetch);
					}
					else {
							promise = api.webGet(api.baseUrl + '/catalogs/' + catalogId + '/requestattributes', undefined, true, generalProperties.forceFetch);
					}

					promise.then(function () {
							if (api.catalogs.requestAttributes.isDirty) {
									//Invalidate lookupData
									api.catalogs.requestAttributes.lookupData = undefined;
									api.catalogs.requestAttributes.isDirty = false;
							}
					});
					return promise;
			}

			function assignRequestAttributes(undefined, record, catalogId) {
					var requestObj = {};
					requestObj['RequestAttributes'] = record.AttributeidsList;

					var promise = api.webPut(api.baseUrl + '/catalogs/' + catalogId + '/requestattributes', requestObj);
					promise.then(function() {
							api.catalogs.requestAttributes.isDirty = true;
					});
					return promise;
			}

			function activateRequestAttributes(records, allRequestAttributesList, actionType, parentId) {
					var requestObj = {};
					var activeRequestAttributes = utility.filterObject(allRequestAttributesList, {Status: 1}, true);
					requestObj.RequestAttributes = activeRequestAttributes.map(function(record) {
						return record['Attributeid'];
					});

					// pushing single item to array
					if(!angular.isArray(records)) {
						records = utility.pushItemToArray(records);
					}

					// as the API is same as assignRequestAttributes, we need to send all the active once to API for status change
					// add the records to Id list for activating
					if(actionType.toUpperCase() === 'ACTIVATE') {
						angular.forEach(records, function(record) {
							requestObj.RequestAttributes.push(record['Attributeid']);
						});
					} else { // remove the records from Id list for deactivating
						angular.forEach(records, function(record) {
							var index = requestObj.RequestAttributes.indexOf(record.Attributeid);
							delete requestObj.RequestAttributes.splice(index, 1);
						});
					}

					var promise = api.webPut(api.baseUrl + '/catalogs/'+ parentId +'/requestattributes', requestObj);
					promise.then(function() {
						api.catalogs.requestAttributes.isDirty = true;
					});

					return promise;
			}
	}
})();
(function() {
  'use strict';

  angular
      .module('app.main.catalogs.requestAttributes')
      .run(runBlock);

  /* @ngInject */
  function runBlock(api, SecurityFactory, CONSTANTS, errorDialog) {

    if (angular.isUndefined(api.catalogs)) {
        api.catalogs = {};
    }

    // a model that is use to lookup available attributes that can be add as request attributes
    api.catalogs.availableAttributeForRequestAttribute = {
      modelPath: 'catalogs.availableAttributeForRequestAttribute',
      fields: [
          { field: 'Id', type: 'int', displayLabel: 'REQUEST_ATTRIBUTES.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
              validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
          { field: 'Attributeid', type: 'int', displayLabel: 'REQUEST_ATTRIBUTES.FIELDS.ATTRIBUTE_ID', visible: true, creatable: false, editable: false, inputType: 'number',
              validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
          { field: 'AttributeDisplayName', type: 'text', displayLabel: 'REQUEST_ATTRIBUTES.FIELDS.ATTRIBUTE_NAME', visible: true, creatable: false, editable: false, inputType: 'textArea',
              validation: {isRequired: true, maxLen: 200, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
          { field: 'AttributeSystemName', type: 'text', displayLabel: 'REQUEST_ATTRIBUTES.FIELDS.SYSTEM_NAME', visible: true, creatable: false, editable: false, inputType: 'textArea',
              validation: {isRequired: false, maxLen: 128, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
          { field: 'AttributeTypeId', type: 'int', displayLabel: 'REQUEST_ATTRIBUTES.FIELDS.ATTRIBUTE_TYPE_ID', visible: true, creatable: false, editable: false, inputType: 'number',
              validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
          { field: 'AttributeTypeName', type: 'text', displayLabel: 'REQUEST_ATTRIBUTES.FIELDS.ATTRIBUTE_TYPE_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
              validation: {isRequired: false, maxLen: 25, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
          { field: 'Status', type: 'text', displayLabel: 'REQUEST_ATTRIBUTES.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
              validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
          { field: 'ValidationExpression', type: 'text', displayLabel: 'REQUEST_ATTRIBUTES.FIELDS.VALIDATION_EXPRESSION', visible: true, creatable: false, editable: false, inputType: 'textArea',
              validation: {isRequired: false, maxLen: 100, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
          { field: 'ValidationMessage', type: 'text', displayLabel: 'REQUEST_ATTRIBUTES.FIELDS.VALIDATION_MESSAGE', visible: true, creatable: false, editable: false, inputType: 'textArea',
              validation: {isRequired: false, maxLen: 200, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
          { field: 'CreatedDate', type: 'text', displayLabel: 'REQUEST_ATTRIBUTES.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
              validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
          { field: 'UpdatedDate', type: 'text', displayLabel: 'REQUEST_ATTRIBUTES.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
              validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
          { field: 'CreatedBy', type: 'text', displayLabel: 'REQUEST_ATTRIBUTES.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
              validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
          { field: 'UpdatedBy', type: 'text', displayLabel: 'REQUEST_ATTRIBUTES.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
              validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
      ],
      uniqueConstraints: [],
      title: 'REQUEST_ATTRIBUTES.NAV',
      icon: 'icon-image-filter-black-white',
      idField: 'Attributeid',
      lookupDisplayField: 'AttributeDisplayName',
      isDirty: false,
      methods: {
          getList         :   getAvailableAttributesForRequestAttribute,
      },
      views: {
          mainList: {},
          mainDetails: {},
          privileges: {}
      }
    };

    function getAvailableAttributesForRequestAttribute(generalProperties, catalogId) {
        if (angular.isUndefined(catalogId)) {
            if (angular.isDefined(generalProperties.idMap) && angular.isDefined(generalProperties.idMap.id1)) {
                catalogId = generalProperties.idMap.id1;
            }
        }
        if(SecurityFactory.isAuthorized({accessPrivileges: CONSTANTS.PRIVILEGES.VETTING_LIST.GET_AVAILABLE_ATTRIBUTES_FOR_REQUEST})) {
            var promise = api.webGet(api.baseUrl + '/catalogs/'+ catalogId +'/availablerequestattributes', undefined, true, generalProperties.forceFetch);
            promise.then(function (response) {
                //return api.webGet(api.baseUrl + '/catalogs/'+ catalogId +'/availablebucketattributes', undefined, true, generalProperties.forceFetch);
                if((angular.isDefined(api.articleLabelConfiguration) && api.articleLabelConfiguration !== '') || (angular.isDefined(api.modelLabelConfiguration) && api.modelLabelConfiguration !== '') || (angular.isDefined(api.segmentationLabelConfiguration) && api.segmentationLabelConfiguration !== '')) {
                    angular.forEach(response.data, function(attribute) {
                        if(api.articleLabelConfiguration.length && attribute.AttributeDisplayName.toLowerCase().includes('article')) {
                            attribute.AttributeDisplayName =  utility.replaceStringWithCase(attribute.AttributeDisplayName, 'article', api.articleLabelConfiguration);
                        }
                        if(api.modelLabelConfiguration.length && attribute.AttributeDisplayName.toLowerCase().includes('model')) {
                            attribute.AttributeDisplayName =  utility.replaceStringWithCase(attribute.AttributeDisplayName, 'model', api.modelLabelConfiguration);
                        }
                        if (api.segmentationLabelConfiguration.length && displayNameLower.includes('segmentation')) {
                            attribute.AttributeDisplayName = utility.replaceStringWithCase(attribute.AttributeDisplayName, 'segmentation', api.segmentationLabelConfiguration);
                        }
                    });
                }
            });
            return promise;
        } else {
            var privilege = {
                id: 763,
                description: 'Requests - Get available request attributes'
            };
            errorDialog.show('ERRORS.NO_PRIVILEGES', undefined, privilege);
        }
    }

  }
})();
(function() {
		'use strict';
		
		angular
				.module('app.main.catalogs.relation-types', [])
				.config(config);

		/* @ngInject */
		function config($translatePartialLoaderProvider) {

				// Translation
				$translatePartialLoaderProvider.addPart('app/main/catalogs/details/tabs/relation-types');
		}
})();
(function() {
		'use strict';

		angular
				.module('app.main.catalogs.relation-types')
				.run(runBlock);

		/* @ngInject */
		function runBlock(api, activityLogger, $state, crud, catalogFactory) {

			if (angular.isUndefined(api.catalogs)) {
					api.catalogs = {};
			}
			api.catalogs.relationTypes = {
					modelPath: 'catalogs.relationTypes',
					fields: [
							{ field: 'Id', type: 'int', displayLabel: 'RELATION_TYPES.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
									validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
							{ field: 'Name', type: 'text', displayLabel: 'RELATION_TYPES.FIELDS.NAME', visible: true, creatable: true, editable: true, inputType: 'text', checkIfUnique: true,
									validation: {isRequired: true, maxLen: 500, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
							{ field: 'ReversedName', type: 'text', displayLabel: 'RELATION_TYPES.FIELDS.RESERVED_NAME', visible: true, creatable: true, editable: true,  inputType: 'text',
									validation: {isRequired: false, maxLen: 500, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
							{ field: 'Status', type: 'text', displayLabel: 'RELATION_TYPES.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
									validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
							{ field: 'CreatedDate', type: 'text', displayLabel: 'RELATION_TYPES.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
									validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
							{ field: 'UpdatedDate', type: 'text', displayLabel: 'RELATION_TYPES.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
									validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
							{ field: 'CreatedBy', type: 'text', displayLabel: 'RELATION_TYPES.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
									validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
							{ field: 'UpdatedBy', type: 'text', displayLabel: 'RELATION_TYPES.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
									validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
					],
					uniqueConstraints: [],
					title: 'RELATION_TYPES.NAV',
					icon: 'icon-image-filter-black-white',
					idField: 'Id',
					lookupDisplayField: 'Name',
					isDirty: false,
					isCatalogSpecificModel: true,
					methods: {
							getList         :   getRelationTypes,
							create          :   createRelationTypes,
							update          :   updateRelationTypes,
							activateBulk    :   activatRelationTypes
					},
					views: {
							mainList: {
									columns         : [ 'Id', 'Name', 'ReversedName', 'Status', 'UpdatedBy', 'UpdatedDate'],
									columnFilter    : {},
									topIndex        : 0,
									showFilterRow   : false,
									sortColumn      : {'UpdatedDate': false},
									itemActions     : [
																			{ id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UpdateRelationType', disabled: '!itm.Status', visible: true },
																			{ id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateRelationTypeStatus', disabled: false, visible: 'itm.Status',
																					requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
																			{ id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateRelationTypeStatus', disabled: false, visible: '!itm.Status',
																					requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
																		],
									listActions     : [
																			{ id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateRelationTypeStatus', disabled: '{selected: true, Status: 1}',
																					visible: true, requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
																			{ id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateRelationTypeStatus', disabled: '{selected: true, Status: 0}',
																					visible: true, requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
																		],
									fabAction       : { id: 'add', label: 'ACTIONS.ADD', icon: 'icon-plus', privilege: 'CreateRelationType:true', visible: true }
							},
							mainDetails: {},
							privileges: {
									list    : 'GetRelationTypeList'
							}
					}
			};

			function getRelationTypes(generalProperties, catalogId) {
					var promise;
					catalogId = angular.isDefined(catalogId) ? catalogId : catalogFactory.getActiveCatalog().CatalogCode;

					if (angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
							promise = api.webGet(api.baseUrl + '/catalogs/' + catalogId + '/relationtypes', undefined, true, generalProperties.forceFetch);
					}
					else {
							promise = api.webGet(api.baseUrl + '/catalogs/' + catalogId + '/relationtypes', undefined, true, generalProperties.forceFetch);
					}

					promise.then(function () {
							if (api.catalogs.relationTypes.isDirty) {
									//Invalidate lookupData
									api.catalogs.relationTypes.lookupData = undefined;
									api.catalogs.relationTypes.isDirty = false;
							}
					});
					return promise;
			}

			function createRelationTypes(record, catalogCode) {
				var state = {};
				state.name = $state.current.name;
				state.params = $state.params;
				var logData = activityLogger.createLogData(record[api.catalogs.relationTypes.lookupDisplayField], state, 'catalogs.relationTypes', 'ADD', false, new Date(), null, null);
				var promise = api.webPost(api.baseUrl + '/catalogs/' + catalogCode + '/relationtypes', record);

				promise.then(function () {
					api.catalogs.relationTypes.isDirty = true;
				});
				return activityLogger.log(logData, promise);
			}

			function updateRelationTypes(Id, requestReason, catalogCode) {
				var state = {};
				state.name = $state.current.name;
				state.params = $state.params;
				var logData = activityLogger.createLogData(requestReason[api.catalogs.relationTypes.lookupDisplayField], state, 'catalogs.relationTypes', 'EDIT', false, new Date(), null, null);
				var promise = api.webPut(api.baseUrl + '/catalogs/' + catalogCode + '/relationtypes/' + Id, requestReason);

				promise.then(function () {
					api.catalogs.relationTypes.isDirty = true;
				});
				return activityLogger.log(logData, promise);
			}

			function activatRelationTypes(records, model, actionType, catalogCode) {
				var result = crud.createRequestObject(records, model, actionType);
				var state = {};
				state.name = $state.current.name;
				state.params = $state.params;
				var isBulk = result.itemsNameList.length > 1 ? true : false;
				var logData = activityLogger.createLogData(result.itemsNameList, state, 'catalogs.relationTypes', actionType.toUpperCase(), isBulk, new Date(), null, null);
				var promise = api.webPut(api.baseUrl + '/catalogs/' + catalogCode + '/relationtypes/status', result.requestObj);

				promise.then(function () {
					crud.onRecordStatusChange(records, model, actionType);
				});

				return activityLogger.log(logData, promise);
			}

	}
})();
(function() {
    'use strict';
    
    angular
        .module('app.main.catalogs.price-group',[]);  
})();
(function() {
    'use strict';

    angular
        .module('app.main.catalogs.price-group')
        .run(runBlock);

    /* @ngInject */
    function runBlock(api, activityLogger, $state, crud, catalogFactory) {

        if(angular.isUndefined(api.catalogs)) {
            api.catalogs = {};
        }
        api.catalogs.priceGroup = {
            modelPath: 'catalogs.priceGroup',
            fields: [
                { field: 'Id', type: 'int', displayLabel: 'PRICE_GROUP.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CatalogCode', type: 'text', displayLabel: 'PRICE_GROUP.FIELDS.CATALOG_CODE', visible: false, creatable: false, editable: false, inputType: 'lookup', lookupSource: 'catalogs.catalogs',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Name', type: 'text', displayLabel: 'PRICE_GROUP.FIELDS.NAME', visible: true, creatable: true, editable: true, inputType: 'text',
                    validation: {isRequired: true, maxLen: 50, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Description', type: 'text', displayLabel: 'PRICE_GROUP.FIELDS.DESCRIPTION', visible: true, creatable: true, editable: true, inputType: 'text',
                    validation: {isRequired: false, maxLen: 100, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CurrencyCode', type: 'text', displayLabel: 'PRICE_GROUP.FIELDS.CURRENCY_CODE', visible: true, creatable: true, editable: true, inputType: 'lookup', lookupSource: 'lists.currencies',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'IsEditable', type: 'int', displayLabel: 'PRICE_GROUP.FIELDS.IS_EDITABLE', visible: true, creatable: true, editable: true, inputType: 'bool-int',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'StateId', type: 'text', displayLabel: 'PRICE_GROUP.FIELDS.ARTICLE_STATE_TO_LOCK_PRICE_GROUP', visible: true, creatable: true, editable: true, inputType: 'lookup', lookupSource: 'catalogs.articleStates',
                    validation: {isRequired: false, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'AllowChangeRequestForPriceGroups', type: 'int', displayLabel: 'PRICE_GROUP.FIELDS.ALLOW_CHANGE_REQUEST_FOR_PRICE_GROUP', visible: true, creatable: true, editable: true, inputType: 'bool-int',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, disabledCriteria: 'vm.record.StateId === null || vm.record.StateId === undefined', pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'IsMandatory', type: 'int', displayLabel: 'PRICE_GROUP.FIELDS.IS_MANDATORY', visible: true, creatable: true, editable: true, inputType: 'bool-int',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'SortOrder', type: 'text', displayLabel: 'PRICE_GROUP.FIELDS.SORT_ORDER', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Status', type: 'text', displayLabel: 'PRICE_GROUP.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedDate', type: 'text', displayLabel: 'PRICE_GROUP.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}}  },
                { field: 'UpdatedDate', type: 'text', displayLabel: 'PRICE_GROUP.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}}  },
                { field: 'CreatedBy', type: 'text', displayLabel: 'PRICE_GROUP.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}}  },
                { field: 'UpdatedBy', type: 'text', displayLabel: 'PRICE_GROUP.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}}  }
            ],
            title: 'PRICE_GROUP.NAV',
            icon: 'icon-coin',
            idField: 'Id',
            lookupDisplayField: 'Name',
            isDirty: false,
            lastUpdatedOn : {},
            methods: {
                getList         :   getPriceGroup,
                activateBulk    :   activatePriceGroup,
                create          :   createPriceGroup,
                update          :   updatePriceGroup
            },
            views: {
                mainList: {
                    columns             : [ 'Name', 'CurrencyCode', 'Description', 'SortOrder', 'Status', 'UpdatedDate' ],
                    columnFilter        : {},
                    toggleFilterProps   : { toggleStatus:false, filterProp:'Status', trueVal:1, trueValTooltipMessage: 'ACTIONS.TOGGLE_ACTIVE', falseVal:'', falseValTooltipMessage:"ACTIONS.TOGGLE_ALL"},
                    topIndex            : 0,
                    showFilterRow       : false,
                    sortColumn          : {'UpdatedDate': false},
                    itemActions         : [
                                            { id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UpdatePriceGroup', disabled: '!itm.Status', visible: true },
                                            { id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateCatalogPriceGroupStatusBulk', disabled: false, visible: 'itm.Status',
                                                requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                                            { id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateCatalogPriceGroupStatusBulk', disabled: false, visible: '!itm.Status',
                                                requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
                                        ],
                    listActions         : [
                                            { id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateCatalogPriceGroupStatusBulk', disabled: '{selected: true, Status: 1}',
                                                visible: true, requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                                            { id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateCatalogPriceGroupStatusBulk', disabled: '{selected: true, Status: 0}',
                                                visible: true, requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
                                        ],
                    fabAction           : {id: 'add', label: 'ACTIONS.ADD', icon: 'icon-plus', privilege: 'CreatePriceGroup', visible: true}
                },
                mainDetails: {},
                privileges: {
                    list: 'GetCatalogPricegroupList'
                }
            }

        };

        function getPriceGroup(generalProperties, catalogId) {
            var promise;

            if(angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
                var state = {};
                state.name = $state.current.name;
                state.params = $state.params;
                var isBulk = true;
                var logData = activityLogger.createLogData(null, state, 'catalogs.priceGroup', 'VIEW', isBulk, new Date(), null, null);
                if (generalProperties.forceFetch) {
                    api.catalogs.priceGroup.lookupData = undefined;
                }
                promise = api.webGet(api.baseUrl + '/catalogs/' + catalogId + '/pricegroups',
                generalProperties.config || {}, true, generalProperties.forceFetch,
                generalProperties.supportIncrementalResult || true,
                generalProperties.modelIdField,
                generalProperties.isMajor || false,
                generalProperties.model || api.catalogs.priceGroup);
                promise = activityLogger.log(logData, promise);
            }
            else {
                catalogId = angular.isUndefined(catalogId) ? catalogFactory.getActiveCatalog().CatalogCode : catalogId;
                promise = api.webGet(api.baseUrl + '/catalogs/' + catalogId + '/pricegroups',
                generalProperties.config || {}, true, generalProperties.forceFetch,
                generalProperties.supportIncrementalResult || true,
                generalProperties.modelIdField,
                generalProperties.isMajor || false,
                generalProperties.model || api.catalogs.priceGroup);
            }

            promise.then(function() {
                api.catalogs.priceGroup.lastUpdatedOn[catalogId] = new Date().getTime();
                if (api.catalogs.priceGroup.isDirty) {
                    //Invalidate lookupData
                    api.catalogs.priceGroup.lookupData = undefined;
                    api.catalogs.priceGroup.isDirty = false;
                }
            });
            return promise;
		}

        function activatePriceGroup(records, model, actionType, parentId) {
            var result = crud.createRequestObject(records, model, actionType);
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var isBulk = result.itemsNameList.length > 1 ? true : false;
            var logData = activityLogger.createLogData(result.itemsNameList, state, 'catalogs.priceGroup', actionType.toUpperCase(), isBulk, new Date(), null, null);
			var promise = api.webPut(api.baseUrl + '/catalogs/'+ parentId +'/pricegroups/status', result.requestObj);

            promise.then(function() {
                crud.onRecordStatusChange(records, model, actionType);
            });
            return activityLogger.log(logData, promise);
        }

        function createPriceGroup(priceGroup, catalogId) {
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var logData = activityLogger.createLogData(priceGroup[api.catalogs.priceGroup.lookupDisplayField], state, 'catalogs.priceGroup', 'ADD', false, new Date(), null, null);
			var promise = api.webPost(api.baseUrl + '/catalogs/' + catalogId + '/pricegroups', priceGroup);

            promise.then(function() {
               api.catalogs.priceGroup.isDirty = true;
            });
            return activityLogger.log(logData, promise);
        }

		function updatePriceGroup(itemId, item, catalogId) {
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var logData = activityLogger.createLogData(item[api.catalogs.priceGroup.lookupDisplayField], state, 'catalogs.priceGroup', 'EDIT', false, new Date(), null, null);
			var promise = api.webPut(api.baseUrl + '/catalogs/' + catalogId + '/pricegroups/' + itemId, item);

            promise.then(function() {
               api.catalogs.priceGroup.isDirty = true;
            });
            return activityLogger.log(logData, promise);
		}

    }
})();
(function() {
		'use strict';

		angular
				.module('app.main.catalogs.modelLevelAttributes')
				.run(runBlock);

		/* @ngInject */
		function runBlock(api, activityLogger, $state) {

				if (angular.isUndefined(api.catalogs)) {
						api.catalogs = {};
				}
				 api.catalogs.modelLevelAttributes = {
						modelPath: 'catalogs.modelLevelAttributes',
						fields: [
								{ field: 'Id', type: 'int', displayLabel: 'MODEL_LEVEL_ATTRIBUTES.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
										validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'AttributeId', type: 'int', displayLabel: 'MODEL_LEVEL_ATTRIBUTES.FIELDS.ATTRIBUTE_ID', visible: true, creatable: false, editable: false, inputType: 'number',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'AttributeId', type: 'int', displayLabel: 'MODEL_LEVEL_ATTRIBUTES.FIELDS.ATTRIBUTE_ID', visible: false, creatable: true, editable: false,  inputType: 'lookup-many', lookupSource: 'catalogs.attributes',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'AttributeDisplayName', type: 'text', displayLabel: 'MODEL_LEVEL_ATTRIBUTES.FIELDS.ATTRIBUTE_NAME', visible: true, creatable: false, editable: false, showInEdit: true, inputType: 'textArea',
										validation: {isRequired: true, maxLen: 200, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'AttributeSystemName', type: 'text', displayLabel: 'MODEL_LEVEL_ATTRIBUTES.FIELDS.SYSTEM_NAME', visible: true, creatable: false, editable: false, inputType: 'textArea',
										validation: {isRequired: false, maxLen: 128, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'AttributeTypeId', type: 'int', displayLabel: 'MODEL_LEVEL_ATTRIBUTES.FIELDS.ATTRIBUTE_TYPE_ID', visible: true, creatable: false, editable: false, inputType: 'number',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'AttributeTypeName', type: 'text', displayLabel: 'MODEL_LEVEL_ATTRIBUTES.FIELDS.ATTRIBUTE_TYPE_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
										validation: {isRequired: false, maxLen: 25, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'Status', type: 'text', displayLabel: 'MODEL_LEVEL_ATTRIBUTES.FIELDS.STATUS', visible: false, creatable: false, editable: false, inputType: 'status',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'IsSeasonlessModelAttribute', type: 'text', displayLabel: 'MODEL_LEVEL_ATTRIBUTES.FIELDS.IS_SEASONLESS', visible: true, creatable: false, editable: false, inputType: 'bool-int',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'CreatedDate', type: 'text', displayLabel: 'MODEL_LEVEL_ATTRIBUTES.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'UpdatedDate', type: 'text', displayLabel: 'MODEL_LEVEL_ATTRIBUTES.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'DefaultValue', type: 'text', displayLabel: 'ATTRIBUTES.FIELDS.DEFAULT_VALUE', visible: true, creatable: false, editable: false, inputType: 'textArea',
										validation: {isRequired: false, maxLen: 4000, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'CreatedBy', type: 'text', displayLabel: 'MODEL_LEVEL_ATTRIBUTES.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'UpdatedBy', type: 'text', displayLabel: 'MODEL_LEVEL_ATTRIBUTES.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
						],
						uniqueConstraints: [],
						title: 'MODEL_LEVEL_ATTRIBUTES.NAV',
						icon: 'icon-image-filter-black-white',
						idField: 'AttributeId',
						lookupDisplayField: 'AttributeDisplayName',
						isDirty: false,
						isCatalogSpecificModel: true,
						methods: {
								create      : assignModelLevelAttributes
						},
						views: {
								mainList: {
										columns         : [ 'AttributeId', 'AttributeDisplayName', 'AttributeSystemName', 'IsSeasonless', 'AttributeTypeName', 'UpdatedBy', 'UpdatedDate'],
										columnFilter    : {},
										topIndex        : 0,
										showFilterRow   : false,
										sortColumn      : {'UpdatedDate': false},
										itemActions     : [],
										listActions     : [],
										fabAction       : {id: 'add', label: 'ACTIONS.ADD', icon: 'icon-link', privilege: 'AssignModelLevelAttributes:true', visible: true}
								 },
								 mainDetails: {},
								privileges: {
										list    : 'GetCatalogDetails'
								}
						}
				};

		function assignModelLevelAttributes(record) {
				var requestObj = {};
				requestObj['ModelLevelAttributeList'] = record.AttributeId;

				var state = {};
				state.name = $state.current.name;
				state.params = $state.params;
				var logData = activityLogger.createLogData(record[api.catalogs.modelLevelAttributes.lookupDisplayField], state, 'catalogs.modelLevelAttributes', 'ADD', false, new Date(), null, null);
				var promise = api.webPut(api.baseUrl + '/catalogs/' + record.activeCatalogId + '/modelattributes', requestObj);

				promise.then(function() {
						api.catalogs.modelLevelAttributes.isDirty = true;
						api.catalogs.models.isDirty = true;
				});
				return activityLogger.log(logData, promise);
		}
}
})();
(function() {
  'use strict';

  angular
      .module('app.main.catalogs.linkedCatalogs',[]);
})();
(function() {
  'use strict';

  angular
      .module('app.main.catalogs.linkedCatalogs')
      .run(runBlock);

  /* @ngInject */
  function runBlock(api, activityLogger, $state) {


      if (angular.isUndefined(api.catalogs)) {
        api.catalogs = {};
      }

      api.catalogs.linkedCatalogs = {
          modelPath: 'catalogs.linkedCatalogs',
          fields: [
              { field: 'Id', type: 'int', displayLabel: 'CATALOGS.FIELDS.ID', visible: false, creatable: false, editable: false, inputType: 'number',
                  validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
              { field: 'DataSourceTypeId', type: 'int', displayLabel: 'CATALOGS.FIELDS.DATA_SOURCE_TYPE', visible: false, creatable: true, editable: false, inputType: 'lookup',  lookupSource: 'lists.dataSourceTypes',
                  validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
              { field: 'DataSourceType', type: 'text', displayLabel: 'CATALOGS.FIELDS.DATA_SOURCE_TYPE', visible: true, creatable: false, editable: false, inputType: 'text',
                  validation: {isRequired: false, maxLen: 100, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
              { field: 'AccountId', type: 'int', displayLabel: 'CATALOGS.FIELDS.SELLER_ACCOUNT', visible: false, creatable: true, editable: true, inputType: 'lookup', lookupSource: 'accounts.sellers',
                  validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
              { field: 'CatalogCode', type: 'int', displayLabel: 'CATALOGS.FIELDS.CATALOG_CODE', visible: false, creatable: false, editable: false, inputType: 'number',
                  validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
              { field: 'CatalogName', type: 'text', displayLabel: 'CATALOGS.FIELDS.CATALOG_NAME', visible: true, creatable: true, editable: true, inputType: 'text',
                  validation: {isRequired: true, maxLen: 100, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
              { field: 'ReferenceCatalogCode', type: 'text', displayLabel: 'CATALOGS.FIELDS.REFERENCE_CATAOG_CODE', visible: true, creatable: true, editable: false, inputType: 'lookup', lookupSource: 'catalogs.catalogs',
                  validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', disabledCriteria: 'vm.record.DataSourceTypeId === 1', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
              { field: 'AttributeGroupId', type: 'int', displayLabel: 'CATALOGS.FIELDS.ATTRIBUTE_GROUP_NAME', visible: false, creatable: true, editable: false, inputType: 'lookup', lookupSource: 'attributes.attributeGroups',
                  validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', disabledCriteria: 'vm.record.DataSourceTypeId === 2 || vm.record.DataSourceTypeId === 3', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
              { field: 'AttributeGroupName', type: 'text', displayLabel: 'CATALOGS.FIELDS.ATTRIBUTE_GROUP_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
                  validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
              { field: 'AttributeIdsList', type: 'text', displayLabel: 'CATALOGS.FIELDS.ATTRIBUTE_IDS_LIST', visible: false, creatable: true, editable: true, inputType: 'lookup-many', lookupSource: 'attributes.attributes',
                  validation: {isRequired: 'vm.record.DataSourceTypeId === 3', maxLen: -1, minLen: 0, pattern: '', disabledCriteria: 'vm.record.DataSourceTypeId === 2', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
              { field: 'ImageName', type: 'text', displayLabel: 'CATALOGS.FIELDS.IMAGE_NAME', visible: false, creatable: false, editable: false, inputType: 'text',
                  validation: {isRequired: false, maxLen: 100, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
              { field: 'ImageFile', type: 'text', displayLabel: 'CATALOGS.FIELDS.IMAGE_FILE', visible: false, creatable: false, editable: false, inputType: 'text',
                  validation: {isRequired: false, maxLen: 100, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
              { field: 'ImagePath', type: 'text', displayLabel: 'CATALOGS.FIELDS.IMAGE_PATH', visible: false, creatable: false, editable: false, inputType: 'text',
                  validation: {isRequired: false, maxLen: 100, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
              { field: 'IsVasInUse', type: 'text', displayLabel: 'CATALOGS.FIELDS.IS_VAS_IN_USE', visible: true, creatable: false, editable: false, inputType: 'int-bool',
                  validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
              { field: 'IndependentSizes', type: 'text', displayLabel: 'CATALOGS.FIELDS.INDEPENDENT_SIZES', visible: true, creatable: false, editable: false, inputType: 'bool-int',
                  validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
              { field: 'Status', type: 'text', displayLabel: 'CATALOGS.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
                  validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
              { field: 'Season', type: 'text', displayLabel: 'CATALOGS.FIELDS.SEASON', visible: true, creatable: false, editable: false, inputType: 'text',
                  validation: {isRequired: false, maxLen: 100, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
              { field: 'Year', type: 'int', displayLabel: 'CATALOGS.FIELDS.YEAR', visible: true, creatable: false, editable: false, inputType: 'number',
                  validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
              { field: 'CatalogShared', type: 'text', displayLabel: 'CATALOGS.FIELDS.CATALOG_SHARED', visible: false, creatable: false, editable: false, inputType: 'text',
                  validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
              { field: 'CreatedDate', type: 'text', displayLabel: 'CATALOGS.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                  validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
              { field: 'UpdatedDate', type: 'text', displayLabel: 'CATALOGS.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                  validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
              { field: 'UserId', type: 'text', displayLabel: 'CATALOGS.FIELDS.USER_ID', visible: true, creatable: false, editable: false, inputType: 'text',
                  validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
              { field: 'CatalogCRDList', type: 'text', displayLabel: 'CATALOGS.FIELDS.CATALOG_CRD_LIST', visible: false, creatable: false, editable: false, inputType: 'text',
                  validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
              { field: 'CatalogSpecificConfigurationList', type: 'text', displayLabel: 'CATALOGS.FIELDS.CATALOG_SPECIFIC_CONFIGURATION_LIST', visible: false, creatable: false, editable: false, inputType: 'text',
                  validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
              { field: 'CatalogPriceGroupList', type: 'text', displayLabel: 'CATALOGS.FIELDS.CATALOG_PRICEGROUP_LIST', visible: false, creatable: false, editable: false, inputType: 'text',
                  validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
              { field: 'UpdatedBy', type: 'text', displayLabel: 'CATALOGS.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                  validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
              { field: 'ReceiveOrders', type: 'text', displayLabel: 'CATALOGS.FIELDS.RECEIVE_ORDERS', visible: true, creatable: false, editable: false, inputType: 'bool-int',
                  validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
              { field: 'ReceiveOrdersWithoutPrice', type: 'int', displayLabel: 'CATALOGS.FIELDS.RECEIVE_ORDERS_WITHOUT_PRICE', visible: true, creatable: false, editable: false, inputType: 'bool-int',
                  validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
              { field: 'ArticleCascading', type: 'text', displayLabel: 'CATALOGS.FIELDS.ARTICLE_CASCADING', visible: true, creatable: false, editable: false, inputType: 'bool-int',
                  validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
              { field: 'IsStockApply', type: 'text', displayLabel: 'CATALOGS.FIELDS.IS_STOCK_APPLY', visible: true, creatable: false, editable: false, inputType: 'bool-int',
                  validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
              { field: 'SegmentationCascading', type: 'text', displayLabel: 'CATALOGS.FIELDS.SEGMENTATION_CASCADING', visible: true, creatable: false, editable: false, inputType: 'bool-int',
                  validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
              { field: 'SegmentationPlanningEnable', type: 'text', displayLabel: 'CATALOGS.FIELDS.SEGMENTATION_PLANNING_ENABLE', visible: true, creatable: false, editable: false, inputType: 'bool-int',
                  validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
              { field: 'ArticleLocking', type: 'text', displayLabel: 'CATALOGS.FIELDS.ARTICLE_LOCKING', visible: true, creatable: false, editable: false, inputType: 'bool-int',
                  validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
              { field: 'State', type: 'text', displayLabel: 'CATALOGS.FIELDS.STATE', visible: true, creatable: false, editable: false, inputType: 'text',
                  validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
              { field: 'IsLinePlan', type: 'text', displayLabel: 'CATALOGS.FIELDS.IS_LINE_PLAN', visible: false, creatable: false, editable: false, inputType: 'bool-int',
                  validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
              { field: 'LinkedCatalogs', type: 'text', displayLabel: 'CATALOGS.FIELDS.LINKED_CATALOGS', visible: false, creatable: false, editable: false, inputType: 'text',
                  validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
              { field: 'LinkedAttributes', type: 'text', displayLabel: 'CATALOGS.FIELDS.LINKED_ATTRIBUTES', visible: false, creatable: false, editable: false, inputType: 'text',
                  validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
          ],
          uniqueConstraints: [
              {name: 'Constraint 1', fields: ['CatalogName']}
          ],
          title: 'CATALOGS.NAV',
          icon: 'icon-book-open',
          idField: 'CatalogCode',
          lookupDisplayField: 'CatalogName',
          isDirty: false,
          methods: {},
          views: {
               mainList: {
                  columns         : [ 'CatalogCode', 'CatalogName', 'ReferenceCatalogCode', 'Status', 'UpdatedDate' ],
                  columnFilter    : {},
                  toggleFilterProps: { toggleStatus:false, filterProp:'Status', trueVal:1, trueValTooltipMessage: 'ACTIONS.TOGGLE_ACTIVE', falseVal:'', falseValTooltipMessage:"ACTIONS.TOGGLE_ALL"},
                  topIndex        : 0,
                  showFilterRow   : false,
                  sortColumn      : {'UpdatedDate': false},
                  itemActions     : [
                                      { id: 'view', label: 'ACTIONS.VIEW', icon: 'icon-magnify', privilege: 'GetCatalogDetails', disabled: '!itm.Status', visible: true }
                                    ],
                  listActions     : [],
                  fabAction       : {}

               },
               mainDetails: {},
               privileges: {
                   list: 'GetCatalogList',
                   details: 'GetCatalogDetails',
               }
          }
      };



  }
})();
(function() {
  'use strict';

  angular
      .module('app.main.catalogs.linkedAttributes',[]);
})();
(function() {
  'use strict';

  angular
      .module('app.main.catalogs.linkedAttributes')
      .run(runBlock);

  /* @ngInject */
  function runBlock(api, crud) {

      if(angular.isUndefined(api.catalogs)) {
          api.catalogs = {};
      }

      api.catalogs.linkedAttributes = {
          modelPath: 'catalogs.linkedAttributes',
          fields: [
              { field: 'Id', type: 'int', displayLabel: 'ATTRIBUTES.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
                  validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
              { field: 'AttributeId', type: 'int', displayLabel: 'ATTRIBUTES.FIELDS.ATTRIBUTE_ID', visible: true, creatable: false, editable: false, inputType: 'number',
                  validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
              { field: 'AttributeDisplayName', type: 'text', displayLabel: 'ATTRIBUTES.FIELDS.NAME', visible: true, creatable: false, editable: false, inputType: 'textArea',
                  validation: {isRequired: true, maxLen: 200, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
              { field: 'AttributeSystemName', type: 'text', displayLabel: 'ATTRIBUTES.FIELDS.SYSTEM_NAME', visible: true, creatable: false, editable: false, inputType: 'textArea',
                  validation: {isRequired: false, maxLen: 128, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
              { field: 'AttributeTypeId', type: 'int', displayLabel: 'ATTRIBUTES.FIELDS.ATTRIBUTE_TYPE_ID', visible: true, creatable: false, editable: false, inputType: 'number',
                  validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
              { field: 'AttributeTypeName', type: 'text', displayLabel: 'ATTRIBUTES.FIELDS.ATTRIBUTE_TYPE_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
                  validation: {isRequired: false, maxLen: 25, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
              { field: 'AllowedValues', type: 'text', displayLabel: 'ATTRIBUTES.FIELDS.ALLOWED_VALUES', visible: true, creatable: false, editable: false, inputType: 'text',
                  validation: {isRequired: false, maxLen: 25, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
              { field: 'Status', type: 'text', displayLabel: 'ATTRIBUTES.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
                  validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
              { field: 'SortOrder', type: 'int', displayLabel: 'ATTRIBUTES.FIELDS.SORT_ORDER', visible: true, creatable: false, editable: false, inputType: 'number',
                  validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
              { field: 'Editable', type: 'text', displayLabel: 'ATTRIBUTES.FIELDS.EDITABLE', visible: true, creatable: false, editable: false, inputType: 'bool-int',
                  validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
              { field: 'CreatedDate', type: 'text', displayLabel: 'ATTRIBUTES.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                  validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
              { field: 'UpdatedDate', type: 'text', displayLabel: 'ATTRIBUTES.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                  validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
              { field: 'CreatedBy', type: 'text', displayLabel: 'ATTRIBUTES.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                  validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
              { field: 'UpdatedBy', type: 'text', displayLabel: 'ATTRIBUTES.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                  validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
          ],

          title: 'ATTRIBUTES.NAV',
          icon: 'icon-dice-1',
          idField: 'Id',
          lookupDisplayField: 'AttributeDisplayName',
          methods: {
            activateBulk : changeAttributeEditableStatus
          },
          views: {
              mainList: {
                  columns             : [ 'AttributeId', 'AttributeDisplayName', 'AttributeSystemName', 'UpdatedDate', 'AttributeTypeName', 'Editable' ],
                  columnFilter        : {},
                  topIndex            : 0,
                  showFilterRow       : false,
                  sortColumn          : {'UpdatedDate': false},
                  itemActions         : [
                                          { id: 'view', label: 'ACTIONS.VIEW', icon: 'icon-magnify', privilege: 'GetAttributeDetailsById', disabled: '', visible: true },
                                          { id: 'nonEditable', label: 'ACTIONS.NON_EDITABLE', icon: 'icon-delete', privilege: 'UpdateLinkedAttributesEditableFlag', disabled: false, visible: 'itm.Editable',
                                                requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_NON_EDITABLE'}, confirmationAction: 'ACTIONS.NON_EDITABLE'},
                                          { id: 'editable', label: 'ACTIONS.EDITABLE', icon: 'icon-undo-variant', privilege: 'UpdateLinkedAttributesEditableFlag', disabled: false, visible: '!itm.Editable',
                                                requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_EDITABLE'}, confirmationAction: 'ACTIONS.EDITABLE'}
                                        ],
                  listActions         : [
                                            { id: 'nonEditable', label: 'ACTIONS.NON_EDITABLE', icon: 'icon-delete', privilege: 'UpdateLinkedAttributesEditableFlag', disabled: '{selected: true, Editable: 1}',
                                                visible: true, requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_NON_EDITABLE'}, confirmationAction: 'ACTIONS.NON_EDITABLE'},
                                            { id: 'editable', label: 'ACTIONS.EDITABLE', icon: 'icon-undo-variant', privilege: 'UpdateLinkedAttributesEditableFlag', disabled: '{selected: true, Editable: 0}',
                                                visible: true, requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_EDITABLE'}, confirmationAction: 'ACTIONS.EDITABLE'}
                                        ],
                  fabAction           : {}
              },
              mainDetails: {},
              privileges: {}
          }
      };

      function changeAttributeEditableStatus(records, model, actionType, parentId) {
        var result = crud.createRequestObject(records, model, actionType);
        var promise = api.webPut(api.baseUrl + '/catalogs/'+ parentId +'/linkedattributes/editable', result.requestObj);

        promise.then(function() {
            api.catalogs.linkedAttributes.isDirty = true;
            crud.onRecordStatusChange(records, model, actionType, 'Editable');
        });

        return promise;
    }

  }
})();
(function() {
    'use strict';
    
    angular
        .module('app.main.catalogs.CRD',[]);  
})();
(function() {
    'use strict';

    angular
        .module('app.main.catalogs.CRD')
        .run(runBlock);

    /* @ngInject */
    function runBlock(api, activityLogger, $state, crud, catalogFactory, utility, jobsTracker, CONSTANTS) {

        if(angular.isUndefined(api.catalogs)) {
            api.catalogs = {};
        }
        api.catalogs.CRD = {
            modelPath: 'catalogs.CRD',
            fields: [
                { field: 'Id', type: 'int', displayLabel: 'CRD.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CatalogCode', type: 'int', displayLabel: 'CATALOGS.FIELDS.CATALOG_CODE', visible: false, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CustomerRequiredDate', type: 'text', displayLabel: 'CRD.FIELDS.CUSTOMER_REQUIRED_DATE', visible: true, creatable: true, editable: true, inputType: 'date-utc',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                // isCatalogCRD is used only for Description field
                { field: 'Description', type: 'text', displayLabel: 'CRD.FIELDS.DESCRIPTION', visible: true, creatable: true, editable: true, inputType: 'text',
                    validation: {isRequired: true, maxLen: 50, minLen: 1, pattern: '', dataExistConstraints: {modelPath: '', promise: null, data: null, shouldNotExist: true, isCatalogCRD: true}, messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Availability', type: 'text', displayLabel: 'CRD.FIELDS.AVAILABILITY', visible: true, creatable: true, editable: true, inputType: 'bool',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'SortOrder', type: 'int', displayLabel: 'CRD.FIELDS.SORT_ORDER', visible: true, creatable: true, editable: true, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Status', type: 'text', displayLabel: 'CRD.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedDate', type: 'text', displayLabel: 'CRD.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedDate', type: 'text', displayLabel: 'CRD.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedBy', type: 'text', displayLabel: 'CRD.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedBy', type: 'text', displayLabel: 'CRD.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
            ],
            uniqueConstraints: [
                {name: 'Constraint 1', fields: ['CustomerRequiredDate']},
                {name: 'Constraint 2', fields: ['Description']}
            ],
            title: 'CRD.NAV',
            icon: 'icon-calendar-blank',
            idField: 'Id',
            lookupDisplayField: 'CustomerRequiredDate',
            isDirty: false,
            lastUpdatedOn : {},
            methods: {
                getList         :   getCRD,
                activateBulk    :   activateCRD,
                create          :   createCRD,
                update          :   updateCRD,
                createBulk      :   createBulk
            },
            views: {
                mainList: {
                    columns             : [ 'CustomerRequiredDate', 'Description', 'Availability', 'SortOrder', 'Status', 'UpdatedDate' ],
                    columnFilter        : {},
                    toggleFilterProps   : { toggleStatus:false, filterProp:'Status', trueVal:1, trueValTooltipMessage: 'ACTIONS.TOGGLE_ACTIVE', falseVal:'', falseValTooltipMessage:"ACTIONS.TOGGLE_ALL"},
                    topIndex            : 0,
                    showFilterRow       : false,
                    sortColumn          : {'UpdatedDate': false},
                    itemActions         : [
                                            { id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UpdateCatalogCustomerRequiredDates', disabled: '!itm.Status', visible: true },
                                            { id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateCatalogCrdStatusBulk', disabled: false, visible: 'itm.Status',
                                                requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                                            { id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateCatalogCrdStatusBulk', disabled: false, visible: '!itm.Status',
                                                requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
                                        ],
                    listActions         : [
                                            { id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateCatalogCrdStatusBulk', disabled: '{selected: true, Status: 1}',
                                                visible: true, requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                                            { id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateCatalogCrdStatusBulk', disabled: '{selected: true, Status: 0}',
                                                visible: true, requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'},
                                            { id: 'import', label: 'ACTIONS.IMPORT', icon: 'icon-import', privilege: 'ImportCatalogCrds:true', disabled: false, visible: true, requiresConfirmation: false}
                                        ],
                    fabAction           : {id: 'add', label: 'ACTIONS.ADD', icon: 'icon-plus', privilege: 'CreateCatalogCustomerRequiredDates', visible: true}
                },
                mainDetails: {},
                privileges: {
                    list: 'GetCatalogCrdList'
                }
            }
        };


    //    api.catalogs.CRD.baseModel = api.catalogs.CRD;

        function getCRD(generalProperties, catalogId, model) {
            if (angular.isDefined(model)) {
                model.isBulkActionCompleted = false;
            }
            var promise;

            if(angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
                var state = {};
                state.name = $state.current.name;
                state.params = $state.params;
                var isBulk = true;
                var logData = activityLogger.createLogData(null, state, 'catalogs.CRD', 'VIEW', isBulk, new Date(), null, null);
                promise = api.webGet(api.baseUrl + '/catalogs/' + catalogId + '/crds',
                generalProperties.config || {}, true, generalProperties.forceFetch,
                generalProperties.supportIncrementalResult || true,
                generalProperties.modelIdField,
                generalProperties.isMajor || false,
                generalProperties.model || api.catalogs.CRD);
                promise = activityLogger.log(logData, promise);
            }
            else {
                catalogId = angular.isUndefined(catalogId) ? catalogFactory.getActiveCatalog().CatalogCode : catalogId;
                promise = api.webGet(api.baseUrl + '/catalogs/' + catalogId + '/crds',
                generalProperties.config || {}, true, generalProperties.forceFetch,
                generalProperties.supportIncrementalResult || true,
                generalProperties.modelIdField,
                generalProperties.isMajor || false,
                generalProperties.model || api.catalogs.CRD);
            }

            promise.then(function() {
                api.catalogs.CRD.lastUpdatedOn[catalogId] = new Date().getTime();
                if (api.catalogs.CRD.isDirty) {
                    //Invalidate lookupData
                    api.catalogs.CRD.lookupData = undefined;
                    api.catalogs.CRD.isDirty = false;
                }
            });
            return promise;
        }

        function activateCRD(records, model, actionType, parentId) {
            var result = crud.createRequestObject(records, model, actionType);
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var isBulk = result.itemsNameList.length > 1 ? true : false;
            var logData = activityLogger.createLogData(result.itemsNameList, state, 'catalogs.CRD', actionType.toUpperCase(), isBulk, new Date(), null, null);
            var promise = api.webPut(api.baseUrl + '/catalogs/'+ parentId +'/crds/status', result.requestObj);

            promise.then(function() {
                crud.onRecordStatusChange(records, model, actionType);
            });

            return activityLogger.log(logData, promise);
        }

        function createCRD(crd, catalogId) {
            // set date hour to 12 UTC time
            utility.setDateHourUTC(crd.CustomerRequiredDate, 12);

            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var logData = activityLogger.createLogData(crd[api.catalogs.CRD.lookupDisplayField], state, 'catalogs.CRD', 'ADD', false, new Date(), null, null);
            var promise = api.webPost(api.baseUrl + '/catalogs/' + catalogId + '/crds', crd);

            promise.then(function() {
                api.catalogs.CRD.isDirty = true;
                api.catalogs.crds.isDirty = true;
            });
            return activityLogger.log(logData, promise);
        }

        function updateCRD(itemId, item, catalogId) {
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var logData = activityLogger.createLogData(item[api.catalogs.CRD.lookupDisplayField], state, 'catalogs.CRD', 'EDIT', false, new Date(), null, null);
            var promise = api.webPut(api.baseUrl + '/catalogs/' + catalogId + '/crds/' + itemId, item);

            promise.then(function() {
                api.catalogs.CRD.isDirty = true;
                api.catalogs.crds.isDirty = true;
            });
            return activityLogger.log(logData, promise);
        }

        function createBulk(data, catalogId, model) {
            var jobIndex = jobsTracker.addJob(model, 'CRD.ACTIONS.IMPORT_CRDS', 1);
            api.webPut(api.baseUrl + '/catalogs/' + catalogId + '/crds?sourceapplication=' + CONSTANTS.SOURCE_APPLICATION + '&sourceaction=Import Delivery Dates', data).then(function(response) {
                jobsTracker.trackJob(jobIndex, response.data.Id);
            }).catch(function(error) {
                jobsTracker.setCriticlaFail(jobIndex, error);
            });
        }

    }
})();
(function() {
    'use strict';

    angular
        .module('app.main.catalogs.configurations')
        .run(runBlock);

    /* @ngInject */
    function runBlock(api, $state, activityLogger, catalogFactory, jobsTracker) {

        if(angular.isUndefined(api.catalogs)) {
            api.catalogs = {};
        }
        api.catalogs.configurations = {
            modelPath: 'catalogs.configurations',
            fields: [
                { field: 'ConfigId', type: 'int', displayLabel: 'CONFIGURATIONS.FIELDS.CONFIGURE_ID', visible: false, creatable: true, editable: true, inputType: 'lookup', lookupSource:'lists.configurations',
                    validation: {isRequired: true, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ConfigId', type: 'int', displayLabel: 'CONFIGURATIONS.FIELDS.CONFIGURE_ID', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: true, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Id', type: 'int', displayLabel: 'CONFIGURATIONS.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Name', type: 'text', displayLabel: 'CONFIGURATIONS.FIELDS.NAME', visible: true, creatable: false, editable: false, inputType: 'text', showTooltip: true,
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Value', type: 'text', displayLabel: 'CONFIGURATIONS.FIELDS.VALUE', visible: true, creatable: true, editable: true, inputType: 'text',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'DefaultValueType', type: 'text', displayLabel: 'CONFIGURATIONS.FIELDS.DEFAULT_VALUE_TYPE', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedDate', type: 'text', displayLabel: 'CONFIGURATIONS.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedDate', type: 'text', displayLabel: 'CONFIGURATIONS.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedBy', type: 'text', displayLabel: 'CONFIGURATIONS.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedBy', type: 'text', displayLabel: 'CONFIGURATIONS.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
            ],
            title: 'CONFIGURATIONS.NAV',
            detailsDialogTitle: 'PARTS.DETAILS',
            icon: 'icon-checkerboard',
            idField: 'Id',
            lookupDisplayField: 'Name',
            isDirty: false,
            methods: {
                getList         :   getConfigurations,
                create          :   createConfiguration,
                update          :   updateConfiguration,
                delete          :   deleteConfiguration,
                createBulk      :   createBulk
            },
            views: {
                mainList: {
                    columns             : [ 'Name', 'Value', 'DefaultValueType', 'UpdatedDate' ],
                    columnFilter        : {},
                    toggleFilterProps   : {},
                    topIndex            : 0,
                    showFilterRow       : false,
                    sortColumn          : {'UpdatedDate': false},
                    itemActions         : [
                                            { id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UpdateCatalogConfiguration', disabled: '', visible: true },
                                            { id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'HardDeleteCatalogConfiguration', disabled: false, visible: true,
                                                requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                                          ],
                    listActions         : [
                                            { id: 'delete', label: 'ACTIONS.DELETE_BULK', icon: 'icon-delete', privilege: 'HardDeleteCatalogConfiguration', disabled: '{selected: true}', visible: true,
                                                requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                                            { id: 'import', label: 'ACTIONS.IMPORT', icon: 'icon-import', privilege: 'UpdateCatalogBulkConfiguration', disabled: false, visible: true, requiresConfirmation: false}
                                          ],
                    fabAction           : {id: 'add', label: 'ACTIONS.ADD', icon: 'icon-plus', privilege: 'CreateCatalogConfiguration', visible: true}
                },
                mainDetails: {},
                privileges: {
                    list: 'GetCatalogSpecificConfigurations'
                }
            }

        };

        api.catalogs.importConfigurations = {
            modelPath: 'catalogs.importConfigurations',
            fields: [
                { field: 'ConfigId', type: 'int', displayLabel: 'CONFIGURATIONS.FIELDS.CONFIGURE_ID', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Id', type: 'int', displayLabel: 'CONFIGURATIONS.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Name', type: 'text', displayLabel: 'CONFIGURATIONS.FIELDS.NAME', visible: true, creatable: true, editable: false, inputType: 'text',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Value', type: 'text', displayLabel: 'CONFIGURATIONS.FIELDS.VALUE', visible: true, creatable: true, editable: false, inputType: 'text',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedDate', type: 'text', displayLabel: 'CONFIGURATIONS.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedDate', type: 'text', displayLabel: 'CONFIGURATIONS.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'DefaultValueType', type: 'text', displayLabel: 'CONFIGURATIONS.FIELDS.DEFAULT_VALUE_TYPE', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedBy', type: 'text', displayLabel: 'CONFIGURATIONS.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedBy', type: 'text', displayLabel: 'CONFIGURATIONS.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
            ],
            title: 'CONFIGURATIONS.NAV',
            icon: 'icon-checkerboard',
            idField: 'ConfigId',
            lookupDisplayField: 'Name',
            isDirty: false,
            isBulkActionCompleted: false,
            methods: {
            },
            views: {
                mainList: {},
                mainDetails: {},
                privileges: {
                    list: 'GetCatalogSpecificConfigurations'
                }
            }

        };

        function getConfigurations(generalProperties, catalogId, model) {
            if (angular.isDefined(model)) { // to skip this part for load lookup
                model.isBulkActionCompleted = false;
            }
            var promise;

            if(angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
                var state = {};
                state.name = $state.current.name;
                state.params = $state.params;
                var isBulk = true;
                var logData = activityLogger.createLogData(null, state, 'catalogs.configurations', 'VIEW', isBulk, new Date(), null, null);
                promise = api.webGet(api.baseUrl + '/catalogs/' + catalogId + '/catalogConfigurations', undefined, true, generalProperties.forceFetch);
                promise = activityLogger.log(logData, promise);
            }
            else {
                catalogId = angular.isUndefined(catalogId) ? catalogFactory.getActiveCatalog().CatalogCode : catalogId;
                promise = api.webGet(api.baseUrl + '/catalogs/' + catalogId + '/catalogConfigurations', undefined, true, generalProperties.forceFetch);
            }

            promise.then(function() {
                if (api.catalogs.configurations.isDirty) {
                    //Invalidate lookupData
                    api.catalogs.configurations.lookupData = undefined;
                    api.catalogs.configurations.isDirty = false;
                }
            });
            return promise;
		}

        function createConfiguration(item, catalogId) {
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var logData = activityLogger.createLogData(item[api.catalogs.configurations.lookupDisplayField], state, 'catalogs.configurations', 'ADD', false, new Date(), null, null);
			var promise = api.webPost(api.baseUrl + '/catalogs/' + catalogId + '/catalogConfigurations', item);
            promise.then(function() {
                api.catalogs.configurations.isDirty = true;
            });
            return activityLogger.log(logData, promise).then(function() {
                return catalogFactory.setActiveCatalogDetails();
            });
        }

        function updateConfiguration(item, itemId, catalogId) {
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var logData = activityLogger.createLogData(item[api.catalogs.configurations.lookupDisplayField], state, 'catalogs.configurations', 'EDIT', false, new Date(), null, null);
			var promise = api.webPut(api.baseUrl + '/catalogs/' + catalogId + '/catalogConfigurations/' + itemId, item);
            promise.then(function() {
                api.catalogs.configurations.isDirty = true;
            });
            return activityLogger.log(logData, promise).then(function() {
                return catalogFactory.setActiveCatalogDetails();
            });
		}

        function deleteConfiguration(records, actionType, catalogId) {
            var data = { requestObj: [], itemNameList: [] }
            var isBulk = true;
            if(!angular.isArray(records)) {
                records = [records];
                isBulk = false;
            }
            angular.forEach(records, function(record) {
                data.itemNameList.push(record[api.catalogs.configurations.lookupDisplayField]);
                data.requestObj.push( { CongigurationId: record[api.catalogs.configurations.idField] } );
            });
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var logData = activityLogger.createLogData(data.itemNameList, state, 'catalogs.configurations', actionType.toUpperCase(), isBulk, new Date(), null, null);
			var promise = api.webDelete(api.baseUrl + '/catalogs/' + catalogId + '/configurations', data.requestObj);
            promise.then(function() {
                api.catalogs.configurations.isDirty = true;
            });
            return activityLogger.log(logData, promise).then(function() {
                return catalogFactory.setActiveCatalogDetails();
            });

        }

        function createBulk(model, data, catalogCode) {
            var jobIndex = jobsTracker.addJob(model, 'CONFIGURATIONS.ACTIONS.IMPORT_CONFIGURATIONS', 1, api.catalogs.configurations);
            api.webPut(api.baseUrl + '/catalogs/' + catalogCode + '/catalogConfigurations', data).then(function(response) {
                jobsTracker.setCompleted(jobIndex, response);
            }).catch(function(error) {
                jobsTracker.setCriticlaFail(jobIndex, error);
            });

        }
    }
})();
(function () {
  'use strict';

  angular
    .module('app.main.catalogs.color-definition', [])
    .config(config);

  /* @ngInject */
  function config($translatePartialLoaderProvider) {

    // Translation
    $translatePartialLoaderProvider.addPart('app/main/catalogs/details/tabs/color-definition');
  }
})();
(function() {
  'use strict';

  angular
      .module('app.main.catalogs.color-definition')
      .run(runBlock);

  /* @ngInject */
  function runBlock(api, $state, catalogFactory, activityLogger, crud, jobsTracker) {

    if (angular.isUndefined(api.catalogs)) {
        api.catalogs = {};
    }
    api.catalogs.colorDefinition = {
        modelPath: 'catalogs.colorDefinition',
        fields: [
            { field: 'Id', type: 'int', displayLabel: 'COLOR_DEFINITION.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
                validation: {isRequired: false, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
            { field: 'ColorName', type: 'text', displayLabel: 'COLOR_DEFINITION.FIELDS.COLOR_NAME', visible: true, creatable: true, editable: false, inputType: 'text', checkIfUnique: true,
                validation: {isRequired: true, maxLen: 80, minLen: 0, pattern: '', dataExistConstraints: {modelPath: null, promise: null, data: null,  shouldNotExist: true}, messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
            { field: 'ColorCode', type: 'text', displayLabel: 'COLOR_DEFINITION.FIELDS.COLOR_CODE', visible: true, creatable: true, editable: true, inputType: 'color-picker',
                validation: {isRequired: true, maxLen: 7, minLen: 0, pattern: '^#(?:[0-9a-fA-F]{3}){2}$', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: 'COLOR_DEFINITION.VALIDATIONS.INVALID'}} },
            { field: 'Status', type: 'text', displayLabel: 'COLOR_DEFINITION.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
                validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
            { field: 'CreatedDate', type: 'text', displayLabel: 'COLOR_DEFINITION.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
            { field: 'UpdatedDate', type: 'text', displayLabel: 'COLOR_DEFINITION.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
            { field: 'CreatedBy', type: 'text', displayLabel: 'COLOR_DEFINITION.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
            { field: 'UpdatedBy', type: 'text', displayLabel: 'COLOR_DEFINITION.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
        ],
        uniqueConstraints: [],
        title: 'COLOR_DEFINITION.NAV',
        icon: 'icon-image-filter-black-white',
        idField: 'Id',
        lookupDisplayField: 'ColorName',
        isDirty: false,
        isCatalogSpecificModel: false,
        methods: {
            getList         :   getColorDefinitions,
            activateBulk    :   activateColorDefinitions,
            create          :   createColorDefinition,
            update          :   updateColorDefinition,
            createBulk      :   createBulk
        },
        views: {
            mainList: {
                columns         : [ 'Id', 'ColorName', 'ColorCode', 'Status', 'UpdatedBy', 'UpdatedDate' ],
                columnFilter    : {},
                topIndex        : 0,
                showFilterRow   : false,
                sortColumn      : {'UpdatedDate': false},
                itemActions     : [
                                    { id: 'edit', label: 'COLOR_DEFINITION.ACTIONS.UPDATE_COLOR_DEFINITION', icon: 'icon-pencil', privilege: 'UpdateColorDefinition', disabled: false, visible: true},
                                    { id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateColorDefinitionStatusBulk', disabled: false, visible: 'itm.Status',
                                        requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                                    { id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateColorDefinitionStatusBulk', disabled: false, visible: '!itm.Status',
                                        requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
                                  ],
                listActions     : [
                                    { id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateColorDefinitionStatusBulk', disabled: '{selected: true, Status: 1}',
                                        visible: true, requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                                    { id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateColorDefinitionStatusBulk', disabled: '{selected: true, Status: 0}',
                                        visible: true, requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'},
                                    { id: 'import', label: 'ACTIONS.IMPORT', icon: 'icon-import', privilege: 'AddEditColorDefinitionBulk', disabled: false, visible: true, requiresConfirmation: false}
                                  ],
                fabAction       : { id: 'add', label: 'ACTIONS.ADD', icon: 'icon-plus', privilege: 'CreateColorDefinition', visible: true }
            },
            mainDetails: {},
            privileges: {
                list    : 'GetColorDefinitions'
            }
        }
    };

    function getColorDefinitions(generalProperties, catalogId, model) {
      if (angular.isDefined(model)) {
          model.isBulkActionCompleted = false;
      }
      var promise;

      if (angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
          var state = {};
          state.name = $state.current.name;
          state.params = $state.params;
          var isBulk = true;
          var logData = activityLogger.createLogData(null, state, 'catalogs.colorDefinition', 'VIEW', isBulk, new Date(), null, null);
          promise = api.webGet(api.baseUrl + '/catalogs/' + catalogId + '/colordefinitions', generalProperties.config || {}, true, generalProperties.forceFetch);
          promise = activityLogger.log(logData, promise);
      }
      else {
          if (angular.isUndefined(catalogId)) {
              if (angular.isDefined(generalProperties.idMap) && angular.isDefined(generalProperties.idMap.id1)) {
                  catalogId = generalProperties.idMap.id1
              } else {
                  catalogId = catalogFactory.getActiveCatalog().CatalogCode
              }
          }
          promise = api.webGet(api.baseUrl + '/catalogs/' + catalogId + '/colordefinitions', generalProperties.config || {}, true, generalProperties.forceFetch);
      }

      promise.then(function () {
          if (api.catalogs.colorDefinition.isDirty) {
              //Invalidate lookupData
              api.catalogs.colorDefinition.lookupData = undefined;
              api.catalogs.colorDefinition.isDirty = false;
          }
      });
      return promise;
    }

    function activateColorDefinitions(records, model, actionType, parentId) {
      var result = crud.createRequestObject(records, model, actionType);
      var state = {};
      state.name = $state.current.name;
      state.params = $state.params;
      var isBulk = result.itemsNameList.length > 1 ? true : false;
      var logData = activityLogger.createLogData(result.itemsNameList, state, 'catalogs.colorDefinition', actionType.toUpperCase(), isBulk, new Date(), null, null);
      var promise = api.webPut(api.baseUrl + '/catalogs/'+ parentId +'/colordefinitions/status', result.requestObj);

      promise.then(function() {
          crud.onRecordStatusChange(records, model, actionType);
      });

      return activityLogger.log(logData, promise);
    }

    function createColorDefinition(requestChannel, catalogId) {
      var state = {};
      state.name = $state.current.name;
      state.params = $state.params;
      var logData = activityLogger.createLogData(requestChannel[api.catalogs.colorDefinition.lookupDisplayField], state, 'catalogs.colorDefinition', 'ADD', false, new Date(), null, null);
      var promise = api.webPost(api.baseUrl + '/catalogs/' + catalogId + '/colordefinitions', requestChannel);

      promise.then(function() {
         api.catalogs.colorDefinition.isDirty = true;
      });
      return activityLogger.log(logData, promise);
    }

    function updateColorDefinition(itemId, item, catalogId) {
      var state = {};
      state.name = $state.current.name;
      state.params = $state.params;
      var logData = activityLogger.createLogData(item[api.catalogs.colorDefinition.lookupDisplayField], state, 'catalogs.colorDefinition', 'EDIT', false, new Date(), null, null);
      var promise = api.webPut(api.baseUrl + '/catalogs/' + catalogId + '/colordefinitions/' + itemId, item);

      promise.then(function() {
         api.catalogs.colorDefinition.isDirty = true;
      });
      return activityLogger.log(logData, promise);
    }

    function createBulk(data, catalogId, model) {
      var jobIndex = jobsTracker.addJob(model, 'COLOR_DEFINITION.ACTIONS.IMPORT', 1);
      api.webPut(api.baseUrl + '/catalogs/' + catalogId + '/colordefinitions', data).then(function(response) {
          jobsTracker.setCompleted(jobIndex, response);
      }).catch(function(error) {
          jobsTracker.setCriticlaFail(jobIndex, error);
      });
    }

  }
})();
(function() {
		'use strict';

		angular
				.module('app.main.catalogs.catalog-color-palette')
				.run(runBlock);

		/* @ngInject */
		function runBlock(api, activityLogger, $state, crud, catalogFactory) {

		if(angular.isUndefined(api.catalogs)) {
			api.catalogs = {};
		}

		api.catalogs.colorPalette = {
					modelPath: 'catalogs.colorPalette',
					fields: [
							{ field: 'Id', type: 'int', displayLabel: 'CATALOG_COLOR_PALETTE.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
									validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
							{ field: 'Name', type: 'text', displayLabel: 'CATALOG_COLOR_PALETTE.FIELDS.NAME', visible: true, creatable: true, editable: false, showInEdit: true, inputType: 'text', checkIfUnique: true,
									validation: {isRequired: true, maxLen: 100, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
							{ field: 'SellerColorIds', type: 'text', displayLabel: 'CATALOG_COLOR_PALETTE.FIELDS.COLORS', visible: false, creatable: false, editable: false, inputType: 'lookup-many', lookupSource: 'sellers.sellerColors',
									validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
							{ field: 'ColorCriteria', type: 'text', displayLabel: 'CATALOG_COLOR_PALETTE.FIELDS.COLOR_CRITERIA', visible: true, creatable: false, editable: false, inputType: 'textArea',
									validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', checkIfValidJson: true, messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '', isValidJson: 'VALIDATIONS.INVALID_JSON'}} },
							{ field: 'Status', type: 'int', displayLabel: 'CATALOG_COLOR_PALETTE.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
									validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
							{ field: 'CreatedDate', type: 'text', displayLabel: 'CATALOG_COLOR_PALETTE.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
									validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
							{ field: 'UpdatedDate', type: 'text', displayLabel: 'CATALOG_COLOR_PALETTE.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
									validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
							{ field: 'CreatedBy', type: 'text', displayLabel: 'CATALOG_COLOR_PALETTE.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
									validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
							{ field: 'UpdatedBy', type: 'text', displayLabel: 'CATALOG_COLOR_PALETTE.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
									validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
					],
					uniqueConstraints: [
						{name: 'Constraint 1', fields: ['Name']}
					],
					title: 'CATALOG_COLOR_PALETTE.NAV',
					icon: 'icon-image-filter-black-white',
					idField: 'Id',
					lookupDisplayField: 'ColorName',
					isDirty: false,
					isCatalogSpecificModel: true,
					methods: {
							getList         :   getColorPalette,
							create          :   createColorPalette,
							update          :   updateColorPalette,
							createBulk      :   createBulkColors,
							activateBulk    :   activatColors
					},
					views: {
							mainList: {
									columns         : [ 'Id', 'Name', 'ColorCriteria', 'Status', 'UpdatedBy', 'UpdatedDate'],
									columnFilter    : {},
									topIndex        : 0,
									showFilterRow   : false,
									sortColumn      : {'UpdatedDate': false},
									itemActions     : [
																			{ id: 'viewColors', label: 'CATALOG_COLOR_PALETTE.ACTIONS.VIEW_COLORS', icon: 'icon-magnify', privilege: 'GetCatalogColorPalettes', disabled: false, visible: true },
																			{ id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UpdateCatalogColorPalettes', disabled: false, visible: true },
																			{ id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateCatalogColorsStatus', disabled: false, visible: 'itm.Status',
																				requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
																			{ id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateCatalogColorsStatus', disabled: false, visible: '!itm.Status',
																				requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
																		],
									listActions     : [
																			{ id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateCatalogColorsStatus', disabled: '{selected: true, Status: 1}',
																					visible: true, requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
																			{ id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateCatalogColorsStatus', disabled: '{selected: true, Status: 0}',
																					visible: true, requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'},
																			{ id: 'import', label: 'ACTIONS.IMPORT', icon: 'icon-import', privilege: 'CreateCatalogColorPalettes:true', disabled: false, visible: true, requiresConfirmation: false},
																		],
									fabAction       : 	{ id: 'add', label: 'ACTIONS.ADD', icon: 'icon-plus', privilege: 'CreateCatalogColorPalettes:true', visible: true }
							},
							mainDetails: {},
							privileges: {
									list    : 'GetCatalogColorPalettes'
							}
					}
			};

			api.catalogs.colorPaletteColors = {
				modelPath: 'catalogs.colorPaletteColors',
				fields: [
							{ field: 'ColorId', type: 'int', displayLabel: 'CATALOG_COLOR_PALETTE.FIELDS.COLOR_ID', visible: true, creatable: false, editable: false, inputType: 'number',
									validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
							{ field: 'ColorName', type: 'text', displayLabel: 'CATALOG_COLOR_PALETTE.FIELDS.COLOR_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
									validation: {isRequired: true, maxLen: 100, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
							{ field: 'Code', type: 'int', displayLabel: 'CATALOG_COLOR_PALETTE.FIELDS.CODE', visible: true, creatable: false, editable: true, inputType: 'number', prefixZeros: 3,
									validation: {isRequired: true, maxLen: -1, minLen: 0, pattern: '^[1-9][0-9]*$', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: 'VALIDATIONS.CODE_POSITIVE_NUMBER'}} },
							{ field: 'ColorType', type: 'text', displayLabel: 'SELLER_COLORS.FIELDS.COLOR_TYPE', visible: true, creatable: true, editable: true, inputType: 'lookup', lookupSource:'lists.ColorTypes',
									validation: {isRequired: false, maxLen: 10, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
							{ field: 'ColorAssetId', type: 'text', displayLabel: 'SELLER_COLORS.FIELDS.COLOR_ASSET_ID', visible: true, creatable: true, editable: true, inputType: 'text',
									validation: {isRequired: 'vm.record.ColorType === "Pattern"', maxLen: 36, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
							{ field: 'HexCode', type: 'text', displayLabel: 'CATALOG_COLOR_PALETTE.FIELDS.HEXCODE', visible: true, creatable: false, editable: false, inputType: 'color-picker',
									validation: {isRequired: false, maxLen: 7, minLen: 0, pattern: '^#(?:[0-9a-fA-F]{3}){2}$', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: 'COLOR_DEFINITION.VALIDATIONS.INVALID'}} },
							{ field: 'ColorGroup', type: 'text', displayLabel: 'CATALOG_COLOR_PALETTE.FIELDS.COLOR_GROUP', visible: true, creatable: false, editable: true, inputType: 'text',
									validation: {isRequired: false, maxLen: 250, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
						],
				uniqueConstraints: [],
				title: 'CATALOG_COLOR_PALETTE.TITLES.COLORS',
				icon: 'icon-image-filter-black-white',
				idField: 'ColorId',
				lookupDisplayField: 'ColorName',
				isDirty: false,
				isCatalogSpecificModel: true,
				methods: {},
				views: {
						mainList: {
								columns         : ['ColorId', 'ColorName', 'Code', 'ColorType', 'ColorAssetId','HexCode', 'ColorGroup'],
								columnFilter    : {},
								topIndex        : 0,
								showFilterRow   : false,
								sortColumn      : {},
								itemActions     : [],
								listActions     : [],
								fabAction       : {}
						},
						mainDetails: {},
						privileges: {
								list    : 'GetCatalogColorPalettes'
						}
				}
			};

			function getColorPalette(generalProperties, catalogCode) {
					var promise;
					var catalogCode = angular.isUndefined(catalogCode) ? catalogFactory.getActiveCatalog().CatalogCode : catalogCode;

					if (angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
							promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/colors', undefined, true, generalProperties.forceFetch);
					}
					else {
							promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/colors', undefined, true, generalProperties.forceFetch);
					}

					promise.then(function () {
							if (api.catalogs.colorPalette.isDirty) {
									//Invalidate lookupData
									api.catalogs.colorPalette.lookupData = undefined;
									api.catalogs.colorPalette.isDirty = false;
							}
					});
					return promise;
			}

			function createColorPalette(record, catalogCode) {
				var state = {};
				state.name = $state.current.name;
				state.params = $state.params;
				var logData = activityLogger.createLogData(record[api.catalogs.colorPalette.lookupDisplayField], state, 'catalogs.colorPalette', 'ADD', false, new Date(), null, null);
				var promise = api.webPost(api.baseUrl + '/catalogs/' + catalogCode + '/colors', record);

				promise.then(function () {
					api.catalogs.colorPalette.isDirty = true;
					api.catalogs.articles.isDirty = true;
				});
				return activityLogger.log(logData, promise);
			}

			function updateColorPalette(record, catalogCode) {
				var state = {};
				state.name = $state.current.name;
				state.params = $state.params;
				var logData = activityLogger.createLogData(record[api.catalogs.colorPalette.lookupDisplayField], state, 'catalogs.colorPalette', 'EDIT', false, new Date(), null, null);
				var promise = api.webPut(api.baseUrl + '/catalogs/' + catalogCode + '/colors', record);

				promise.then(function () {
					api.catalogs.colorPalette.isDirty = true;
					api.catalogs.articles.isDirty = true;
				});
				return activityLogger.log(logData, promise);
			}

			function createBulkColors(records, catalogCode) {
				var state = {};
				state.name = $state.current.name;
				state.params = $state.params;
				var logData = activityLogger.createLogData(null, state, 'catalogs.colorPalette', 'ADD', false, new Date(), null, null);
				var promise = api.webPost(api.baseUrl + '/catalogs/' + catalogCode + '/colors', records);

				promise.then(function () {
					api.catalogs.colorPalette.isDirty = true;
					api.catalogs.articles.isDirty = true;
				});
				return activityLogger.log(logData, promise);
			}

			function activatColors(records, model, actionType, catalogCode) {
				var result = crud.createRequestObject(records, model, actionType);
				var state = {};
				state.name = $state.current.name;
				state.params = $state.params;
				var isBulk = result.itemsNameList.length > 1 ? true : false;
				var logData = activityLogger.createLogData(result.itemsNameList, state, 'catalogs.colorPalette', actionType.toUpperCase(), isBulk, new Date(), null, null);
				var promise = api.webPut(api.baseUrl + '/catalogs/' + catalogCode + '/colors/status', result.requestObj);

				promise.then(function () {
					crud.onRecordStatusChange(records, model, actionType);
				});

				return activityLogger.log(logData, promise);
			}

	}
})();
(function() {
		'use strict';
		
		angular
				.module('app.main.catalogs.bucketLevelAttributes', [])
				.config(config);

		/* @ngInject */
		function config($translatePartialLoaderProvider) {

				// Translation
				$translatePartialLoaderProvider.addPart('app/main/catalogs/details/tabs/bucket-level-attributes');
		}
})();
(function() {
		'use strict';

		angular
				.module('app.main.catalogs.bucketLevelAttributes')
				.run(runBlock);

		/* @ngInject */
		function runBlock(api, utility, SecurityFactory, CONSTANTS, errorDialog) {

			if (angular.isUndefined(api.catalogs)) {
					api.catalogs = {};
			}
			api.catalogs.bucketLevelAttributes = {
					modelPath: 'catalogs.bucketLevelAttributes',
					fields: [
							{ field: 'Id', type: 'int', displayLabel: 'BUCKET_ATTRIBUTES.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
									validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
							{ field: 'Attributeid', type: 'int', displayLabel: 'BUCKET_ATTRIBUTES.FIELDS.ATTRIBUTE_ID', visible: true, creatable: false, editable: false, inputType: 'number',
									validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
							{ field: 'AttributeidsList', type: 'text', displayLabel: 'BUCKET_ATTRIBUTES.FIELDS.ATTRIBUTE_ID', visible: false, creatable: false, editable: false,  inputType: 'lookup-many', lookupSource: 'catalogs.bucketLevelAttributes',
									lookupFilter: {IsSeasonless: 0, IsSeasonlessModelAttribute: 0},validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
							{ field: 'AttributeDisplayName', type: 'text', displayLabel: 'BUCKET_ATTRIBUTES.FIELDS.ATTRIBUTE_NAME', visible: true, creatable: false, editable: false, inputType: 'textArea',
									validation: {isRequired: true, maxLen: 200, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
							{ field: 'AttributeSystemName', type: 'text', displayLabel: 'BUCKET_ATTRIBUTES.FIELDS.SYSTEM_NAME', visible: true, creatable: false, editable: false, inputType: 'textArea',
									validation: {isRequired: false, maxLen: 128, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
							{ field: 'AttributeTypeId', type: 'int', displayLabel: 'BUCKET_ATTRIBUTES.FIELDS.ATTRIBUTE_TYPE_ID', visible: true, creatable: false, editable: false, inputType: 'number',
									validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
							{ field: 'AttributeTypeName', type: 'text', displayLabel: 'BUCKET_ATTRIBUTES.FIELDS.ATTRIBUTE_TYPE_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
									validation: {isRequired: false, maxLen: 25, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
							{ field: 'Status', type: 'text', displayLabel: 'BUCKET_ATTRIBUTES.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
									validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
							{ field: 'AllowedValues', type: 'text', displayLabel: 'BUCKET_ATTRIBUTES.FIELDS.ALLOWED_VALUES', visible: true, creatable: false, editable: false, inputType: 'tags', tagSeparator: '|', importable:'true',
									validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: 'Invalid value, pipe ( | ) is not allowed'}} },
							{ field: 'Criteria', type: 'text', displayLabel: 'BUCKET_ATTRIBUTES.FIELDS.CRITERIA', visible: true, creatable: false, editable: false, inputType: 'textArea',
									validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
							{ field: 'CriteriaV2', type: 'text', displayLabel: 'BUCKET_ATTRIBUTES.FIELDS.CRITERIA_V2', visible: true, creatable: true, editable: true, inputType: 'textArea',
									validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', disabledCriteria: 'vm.record.AttributeTypeId === 12', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
							{ field: 'ValidationExpression', type: 'text', displayLabel: 'BUCKET_ATTRIBUTES.FIELDS.VALIDATION_EXPRESSION', visible: true, creatable: false, editable: false, inputType: 'textArea',
									validation: {isRequired: false, maxLen: 100, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
							{ field: 'ValidationMessage', type: 'text', displayLabel: 'BUCKET_ATTRIBUTES.FIELDS.VALIDATION_MESSAGE', visible: true, creatable: false, editable: false, inputType: 'textArea',
									validation: {isRequired: false, maxLen: 200, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
							{ field: 'CreatedDate', type: 'text', displayLabel: 'BUCKET_ATTRIBUTES.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
									validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
							{ field: 'UpdatedDate', type: 'text', displayLabel: 'BUCKET_ATTRIBUTES.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
									validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
							{ field: 'CreatedBy', type: 'text', displayLabel: 'BUCKET_ATTRIBUTES.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
									validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
							{ field: 'UpdatedBy', type: 'text', displayLabel: 'BUCKET_ATTRIBUTES.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
									validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
					],
					uniqueConstraints: [],
					title: 'BUCKET_ATTRIBUTES.NAV',
					icon: 'icon-image-filter-black-white',
					idField: 'Attributeid',
					lookupDisplayField: 'AttributeDisplayName',
					isDirty: false,
					isCatalogSpecificModel: true,
					methods: {
							getList         :   getAvailableBucketAttributes,
							update          :   assignBucketAttributes,
							activateBulk    :   activateBucketAttributes,
							getAssignedBucketAttributes : getAssignedBucketAttributes
					},
					views: {
							mainList: {
									columns         : [ 'Id', 'Attributeid', 'AttributeDisplayName', 'AttributeSystemName', 'AttributeTypeId', 'AttributeTypeName', 'UpdatedBy', 'UpdatedDate'],
									columnFilter    : {},
									topIndex        : 0,
									showFilterRow   : false,
									sortColumn      : {'UpdatedDate': false},
									itemActions     : [
																			{ id: 'edit', label: 'BUCKET_ATTRIBUTES.ACTIONS.MANAGE_VETTING_LIST', icon: 'icon-pencil', privilege: 'UpdateBucketAttributeVettingList', disabled: false, visible: true},
																			{ id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'AssignBucketAttributes', disabled: false, visible: 'itm.Status',
																					requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
																			{ id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'AssignBucketAttributes', disabled: false, visible: '!itm.Status',
																					requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
																		],
									listActions     : [
																			{ id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'AssignBucketAttributes', disabled: '{selected: true, Status: 1}',
																					visible: true, requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
																			{ id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'AssignBucketAttributes', disabled: '{selected: true, Status: 0}',
																					visible: true, requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
																		],
									fabAction       : { id: 'add', label: 'ACTIONS.ADD', icon: 'icon-link', privilege: 'AssignBucketAttributes:true', visible: true }
							},
							mainDetails: {},
							privileges: {
									list    : 'GetBucketAttributes'
							}
					}
			};

			function getAssignedBucketAttributes(generalProperties, catalogId) {
					var promise;

					if (angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
							promise = api.webGet(api.baseUrl + '/catalogs/' + catalogId + '/bucketattributes', undefined, true, generalProperties.forceFetch);
					}
					else {
							promise = api.webGet(api.baseUrl + '/catalogs/' + catalogId + '/bucketattributes', undefined, true, generalProperties.forceFetch);
					}

					promise.then(function (response) {
							if (api.catalogs.bucketLevelAttributes.isDirty) {
									//Invalidate lookupData
									api.catalogs.bucketLevelAttributes.lookupData = undefined;
									api.catalogs.bucketLevelAttributes.isDirty = false;
							}
							// replace "Article" and "Model" in attributes name with T1S-ArticleLabel and T1S-ModelLabel if configured
							if((angular.isDefined(api.articleLabelConfiguration) && api.articleLabelConfiguration !== '') || (angular.isDefined(api.modelLabelConfiguration) && api.modelLabelConfiguration !== '') || (angular.isDefined(api.segmentationLabelConfiguration) && api.segmentationLabelConfiguration !== '')) {
								angular.forEach(response.data, function(attribute) {
									if(api.articleLabelConfiguration.length && attribute.AttributeDisplayName.toLowerCase().includes('article')) {
										attribute.AttributeDisplayName =  utility.replaceStringWithCase(attribute.AttributeDisplayName, 'article', api.articleLabelConfiguration);
									}
									if(api.modelLabelConfiguration.length && attribute.AttributeDisplayName.toLowerCase().includes('model')) {
										attribute.AttributeDisplayName =  utility.replaceStringWithCase(attribute.AttributeDisplayName, 'model', api.modelLabelConfiguration);
									}
									if (api.segmentationLabelConfiguration.length && displayNameLower.includes('segmentation')) {
										attribute.AttributeDisplayName = utility.replaceStringWithCase(attribute.AttributeDisplayName, 'segmentation', api.segmentationLabelConfiguration);
									}
								});
							}
					});

					return promise;
			}

			function assignBucketAttributes(undefined, record, catalogId) {
					var requestObject = {};
					var promise;
					if(angular.isDefined(record.AttributeidsList) && (angular.isUndefined(record.Attributeid) || (angular.isDefined(record.Attributeid) && record.Attributeid === 0))) {
						requestObject['Attributes'] = record.AttributeidsList;
						promise = api.webPut(api.baseUrl + '/catalogs/' + catalogId + '/bucketattributes', requestObject);
					} else { // when assigning vetting list
						requestObject = {
							'AttributeId': record.Attributeid,
							'Values': record.AllowedValues,
							'Criteria': angular.isDefined(record.Criteria) ? record.Criteria : '',
							'CriteriaV2': angular.isDefined(record.CriteriaV2) ? record.CriteriaV2 : '',
						}
						promise = api.webPut(api.baseUrl + '/catalogs/' + catalogId + '/bucketattributes/vettinglist', requestObject);
					}

					promise.then(function() {
							api.catalogs.bucketLevelAttributes.isDirty = true;
					});

					return promise;
			}

			function activateBucketAttributes(records, allBucketAttributesList, actionType, parentId) {
					var requestObj = {};
					var activeBucketAttributes = utility.filterObject(allBucketAttributesList, {Status: 1}, true);
					requestObj.Attributes = activeBucketAttributes.map(function(record) {
						return record['AttributeId'];
					});

					// pushing single item to array
					if(!angular.isArray(records)) {
						records = utility.pushItemToArray(records);
					}

					// as the API is same as assignBucketAttributes, we need to send all the active once to API for status change
					// add the records to Id list for activating
					if(actionType.toUpperCase() === 'ACTIVATE') {
						angular.forEach(records, function(record) {
							requestObj.Attributes.push(record['AttributeId']);
						});
					} else { // remove the records from Id list for deactivating
						angular.forEach(records, function(record) {
							var index = requestObj.Attributes.indexOf(record.AttributeId);
							delete requestObj.Attributes.splice(index, 1);
						});
					}

					var promise = api.webPut(api.baseUrl + '/catalogs/'+ parentId +'/bucketattributes', requestObj);
					promise.then(function() {
						api.catalogs.bucketLevelAttributes.isDirty = true;
					});

					return promise;
			}

			function getAvailableBucketAttributes(generalProperties) {
					var catalogId = generalProperties.idMap.catalogId;
					if(SecurityFactory.isAuthorized({accessPrivileges: CONSTANTS.PRIVILEGES.VETTING_LIST.GET_AVAILABLE_ATTRIBUTES_FOR_BUCKET})) {
						var promise = api.webGet(api.baseUrl + '/catalogs/' + catalogId + '/availablebucketattributes', undefined, true, generalProperties.forceFetch);
						promise.then(function (response) {
							if((angular.isDefined(api.articleLabelConfiguration) && api.articleLabelConfiguration !== '') || (angular.isDefined(api.modelLabelConfiguration) && api.modelLabelConfiguration !== '')) {
								angular.forEach(response.data, function(attribute) {
									if(api.articleLabelConfiguration.length && attribute.AttributeDisplayName.toLowerCase().includes('article')) {
										attribute.AttributeDisplayName =  utility.replaceStringWithCase(attribute.AttributeDisplayName, 'article', api.articleLabelConfiguration);
									}
									if(api.modelLabelConfiguration.length && attribute.AttributeDisplayName.toLowerCase().includes('model')) {
										attribute.AttributeDisplayName =  utility.replaceStringWithCase(attribute.AttributeDisplayName, 'model', api.modelLabelConfiguration);
									}
									if (api.segmentationLabelConfiguration.length && attribute.AttributeDisplayName.toLowerCase().includes('segmentation')) {
										attribute.AttributeDisplayName = utility.replaceStringWithCase(attribute.AttributeDisplayName, 'segmentation', api.segmentationLabelConfiguration);
									}
								});
							}
						});
						return promise;
					} else {
						var privilege = {
							id: 762,
							description: 'Buckets - Get available bucket attributes'
						};
						errorDialog.show('ERRORS.NO_PRIVILEGES', undefined, privilege);
					}
			}

	}
})();
(function () {
  'use strict';

  angular
    .module('app.main.catalogs.attribute-vetting-list', []);
})();
(function() {
	'use strict';

	angular
			.module('app.main.catalogs.attribute-vetting-list')
			.run(runBlock);

	/* @ngInject */
	function runBlock(api, $state, activityLogger, catalogFactory, jobsTracker, $rootScope) {

		if (angular.isUndefined(api.catalogs)) {
			api.catalogs = {};
		}

		api.catalogs.attributeVettingList = {
			modelPath: 'catalogs.attributeVettingList',
					fields: [
							{ field: 'AttributeId', type: 'text', displayLabel: 'ATTRIBUTES.FIELDS.ATTRIBUTES', visible: false, creatable: true, editable: false, inputType: 'lookup', lookupSource: 'catalogs.attributes',
								lookupFilter: {IsSeasonless: 0, IsSeasonlessModelAttribute: 0}, validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', onChangeLookUpSetValue: 'AttributeTypeId,AttributeTypeId', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
							{ field: 'AttributeId', type: 'int', displayLabel: 'ATTRIBUTES.FIELDS.ATTRIBUTE_ID', visible: true, creatable: false, editable: false, inputType: 'number',
									validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
							{ field: 'AttributeDisplayName', type: 'text', displayLabel: 'ATTRIBUTES.FIELDS.NAME', visible: true, creatable: false, editable: false, inputType: 'textArea',
									validation: {isRequired: true, maxLen: 200, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
							{ field: 'AttributeSystemName', type: 'text', displayLabel: 'ATTRIBUTES.FIELDS.SYSTEM_NAME', visible: true, creatable: false, editable: false, inputType: 'textArea', importable:'true',
									validation: {isRequired: true, maxLen: 128, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
							{ field: 'Values', type: 'text', displayLabel: 'ATTRIBUTES.FIELDS.VALUES', visible: true, creatable: true, editable: true, inputType: 'tags', tagSeparator: '|', importable:'true',
									validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', disabledCriteria: 'vm.record.AttributeTypeId === 12', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: 'Invalid value, pipe ( | ) is not allowed'}} },
							{ field: 'Criteria', type: 'text', displayLabel: 'ATTRIBUTES.FIELDS.CRITERIA', visible: true, creatable: true, editable: true, inputType: 'textArea',
									validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', disabledCriteria: 'vm.record.AttributeTypeId === 12', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
							{ field: 'ValuesV2', type: 'text', displayLabel: 'ATTRIBUTES.FIELDS.VALUES_V2', visible: true, creatable: true, editable: true, inputType: 'textArea',
									validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', checkIfValidJson: true, disabledCriteria: 'vm.record.AttributeTypeId === 12', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '', isValidJson: 'VALIDATIONS.INVALID_JSON'}} },
							{ field: 'CriteriaV2', type: 'text', displayLabel: 'ATTRIBUTES.FIELDS.CRITERIA_V2', visible: true, creatable: true, editable: true, inputType: 'textArea',
									validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', disabledCriteria: 'vm.record.AttributeTypeId === 12', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
							{ field: 'AttributeTypeId', type: 'int', displayLabel: 'ATTRIBUTES.FIELDS.ATTRIBUTE_TYPE_ID', visible: false, creatable: false, editable: false, inputType: 'number',
									validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
					],

					title: 'ATTRIBUTES.NAV',
					icon: 'icon-dice-1',
					idField: 'AttributeId',
					lookupDisplayField: 'AttributeDisplayName',
					methods: {
							getList         :   getAttributeVettingList,
							create          :   createAttributeVettingList,
							update          :   updateAttributeVettingList,
							createBulk		  :   createBulkAttributeVettingList,
					},
					views: {
							mainList: {
									columns             : [ 'AttributeDisplayName', 'AttributeSystemName', 'Values'],
									columnFilter        : {},
									topIndex            : 0,
									showFilterRow       : false,
									sortColumn          : {},

									itemActions         : [
																					{ id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UpdateAttributeValues', disabled: false, visible: true}
																				],
									listActions         : [
																					{ id: 'import', label: 'ACTIONS.IMPORT', icon: 'icon-import', privilege: 'UpdateAttributeValuesBulk', disabled: false, visible: true},
																				],
									fabAction           : {id: 'add', label: 'ACTIONS.ADD', icon: 'icon-plus', privilege: 'UpdateAttributeValues:true', visible: true}

				},
				mainDetails: {},
				privileges: {
					list: 'GetAttributeValues'
				}
					}
			};

		function getAttributeVettingList(generalProperties, catalogCode, model) {
			if (angular.isDefined(model)) {
				model.isBulkActionCompleted = false;
			}
			var promise;

			if (angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
				var state = {};
				state.name = $state.current.name;
				state.params = $state.params;
				var isBulk = true;
				var logData = activityLogger.createLogData(null, state, 'catalogs.attributeVettingList', 'VIEW', isBulk, new Date(), null, null);
				promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/attributevalues', undefined, true, generalProperties.forceFetch);
				promise = activityLogger.log(logData, promise);
			}
			else {
				catalogCode = angular.isUndefined(catalogCode) ? catalogFactory.getActiveCatalog().CatalogCode : catalogCode;
				promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/attributevalues', undefined, true, generalProperties.forceFetch);
			}

			promise.then(function () {
				if (api.catalogs.attributeVettingList.isDirty) {
					//Invalidate lookupData
					api.catalogs.attributeVettingList.lookupData = undefined;
					api.catalogs.attributeVettingList.isDirty = false;
				}
			});
			return promise;
		}

		function createAttributeVettingList(attributeVettingListObj, catalogCode) {
			var state = {};
			state.name = $state.current.name;
			state.params = $state.params;
			var logData = activityLogger.createLogData(attributeVettingListObj[api.catalogs.attributeVettingList.lookupDisplayField], state, 'catalogs.attributeVettingList', 'ADD', false, new Date(), null, null);
			var promise = api.webPut(api.baseUrl + '/catalogs/' + catalogCode + '/attributevalues/' + attributeVettingListObj.AttributeId, attributeVettingListObj);

			promise.then(function () {
				$rootScope.$emit('CatalogsUpdatedEvent');
				api.catalogs.attributeVettingList.isDirty = true;
			});
			return activityLogger.log(logData, promise);
		}

		function updateAttributeVettingList(attributeId, attributeVettingListObj, catalogCode) {
			var state = {};
			state.name = $state.current.name;
			state.params = $state.params;
			var logData = activityLogger.createLogData(attributeVettingListObj[api.catalogs.attributeVettingList.lookupDisplayField], state, 'catalogs.attributeVettingList', 'EDIT', false, new Date(), null, null);
			var promise = api.webPut(api.baseUrl + '/catalogs/' + catalogCode + '/attributevalues/' + attributeVettingListObj.AttributeId, attributeVettingListObj);

			promise.then(function () {
				$rootScope.$emit('CatalogsUpdatedEvent');
				api.catalogs.attributeVettingList.isDirty = true;
			});
			return activityLogger.log(logData, promise);
		}

		function createBulkAttributeVettingList(model, attributeList, attributeVettingListData, catalogCode) {
			var attributeVettingListRequest = [];
			var attributeMap = {};
			angular.forEach(attributeList, function (attribute) {
				attributeMap[attribute.AttributeSystemName] = attribute.Attributeid;
			});
			angular.forEach(attributeVettingListData, function (vettingListAttribute) {
				var attributeObject = {};
				attributeObject['AttributeId'] = attributeMap[vettingListAttribute.AttributeSystemName];
				attributeObject['Values'] = vettingListAttribute.Values;
				attributeObject['Criteria'] = vettingListAttribute.Criteria;
				attributeVettingListRequest.push(attributeObject);
			})
			var jobIndex = jobsTracker.addJob(model, 'ACTIONS.IMPORT', 1);
			api.webPut(api.baseUrl + '/catalogs/' + catalogCode + '/attributevalues', attributeVettingListRequest).then(function (response) {
				jobsTracker.setCompleted(jobIndex, response);
			}).catch(function (error) {
				jobsTracker.setCriticlaFail(jobIndex, error);
			});
		}

	}
})();
(function() {
    'use strict';
    
    angular
        .module('app.main.catalogs.attributes',[]);  
})();
(function() {
    'use strict';

    angular
        .module('app.main.catalogs.attributes')
        .run(runBlock);

    /* @ngInject */
    function runBlock(api, $state, activityLogger, catalogFactory, crud, $rootScope, utility) {

        if(angular.isUndefined(api.catalogs)) {
            api.catalogs = {};
        }
        //TODO- Field Validation- privileges (Only get list is ready)
        api.catalogs.attributes = {
            modelPath: 'catalogs.attributes',
            fields: [
                { field: 'Attributeid', type: 'int', displayLabel: 'ATTRIBUTES.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'AttributeDisplayName', type: 'text', displayLabel: 'ATTRIBUTES.FIELDS.NAME', visible: true, creatable: false, editable: false, showInEdit: true, inputType: 'textArea',
                    validation: {isRequired: true, maxLen: 200, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'AttributeSystemName', type: 'text', displayLabel: 'ATTRIBUTES.FIELDS.SYSTEM_NAME', visible: true, creatable: false, editable: false, inputType: 'textArea',
                    validation: {isRequired: false, maxLen: 128, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'AttributeTypeId', type: 'int', displayLabel: 'ATTRIBUTES.FIELDS.ATTRIBUTE_TYPE_ID', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'InitialValueAttribute', type: 'text', displayLabel: 'ATTRIBUTES.FIELDS.INITIAL_VALUE_ATTRIBUTE', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: 100, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ValidationExpression', type: 'text', displayLabel: 'ATTRIBUTES.FIELDS.VALIDATION_EXPRESSION', visible: true, creatable: false, editable: false, inputType: 'textArea',
                    validation: {isRequired: false, maxLen: 100, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ValidationMessage', type: 'text', displayLabel: 'ATTRIBUTES.FIELDS.VALIDATION_MESSAGE', visible: true, creatable: false, editable: false, inputType: 'textArea',
                    validation: {isRequired: false, maxLen: 200, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'IsRequired', type: 'text', displayLabel: 'ATTRIBUTES.FIELDS.IS_REQUIRED', visible: true, creatable: false, editable: false, inputType: 'bool',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Editable', type: 'text', displayLabel: 'ATTRIBUTES.FIELDS.EDITABLE', visible: true, creatable: false, editable: false, inputType: 'bool',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Creatable', type: 'text', displayLabel: 'ATTRIBUTES.FIELDS.CREATEABLE', visible: true, creatable: false, editable: false, inputType: 'bool',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Visible', type: 'text', displayLabel: 'ATTRIBUTES.FIELDS.VISIBLE', visible: true, creatable: false, editable: false, inputType: 'bool',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'VisibleInListByDefault', type: 'text', displayLabel: 'ATTRIBUTES.FIELDS.VISIBLE_IN_LIST_DEFAULT', visible: true, creatable: false, editable: false, inputType: 'bool',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ShowInEdit', type: 'text', displayLabel: 'ATTRIBUTES.FIELDS.SHOW_IN_EDIT', visible: true, creatable: false, editable: false, inputType: 'bool',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'SupportFilterLookup', type: 'text', displayLabel: 'ATTRIBUTES.FIELDS.SUPPORT_FILTER_LOOKUP', visible: true, creatable: false, editable: false, inputType: 'bool',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedDate', type: 'text', displayLabel: 'ATTRIBUTES.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedDate', type: 'text', displayLabel: 'ATTRIBUTES.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'AttributeTypeName', type: 'text', displayLabel: 'ATTRIBUTES.FIELDS.ATTRIBUTE_TYPE_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: 25, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'AttributeSource', type: 'text', displayLabel: 'ATTRIBUTES.FIELDS.ATTRIBUTE_SOURCE', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'SortOrder', type: 'int', displayLabel: 'ATTRIBUTES.FIELDS.SORT_ORDER', visible: true, creatable: false, editable: true, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'IsSeasonless', type: 'text', displayLabel: 'ATTRIBUTES.FIELDS.IS_SEASONLESS_ARTICLE_ATTRIBUTES', visible: true, creatable: false, editable: false, inputType: 'bool-int',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'IsSeasonlessModelAttribute', type: 'text', displayLabel: 'ATTRIBUTES.FIELDS.IS_SEASONLESS_MODEL_ATTRIBUTES', visible: true, creatable: false, editable: false, inputType: 'bool-int',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedBy', type: 'text', displayLabel: 'ATTRIBUTES.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedBy', type: 'text', displayLabel: 'ATTRIBUTES.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Overridable', type: 'text', displayLabel: 'ATTRIBUTES.FIELDS.OVERRIDABLE', visible: true, creatable: false, editable: false, inputType: 'bool-int',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'DefaultValue', type: 'text', displayLabel: 'ATTRIBUTES.FIELDS.DEFAULT_VALUE', visible: true, creatable: false, editable: false, inputType: 'textArea',
                    validation: {isRequired: false, maxLen: 4000, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
            ],

            title: 'ATTRIBUTES.NAV',
            icon: 'icon-dice-1',
            idField: 'Attributeid',
            lookupDisplayField: 'AttributeDisplayName',
            methods: {
                getList         :   getAttributes,
                update          :   editAttributes,
                updateSeasonlessSortOrder: updateSeasonlessSortOrder,
                updateSeasonlessModelAttributeSortOrder: updateSeasonlessModelAttributeSortOrder
            },
            views: {
                mainList: {
                    columns             : [ 'AttributeDisplayName', 'AttributeSystemName', 'UpdatedDate', 'AttributeTypeName', 'AttributeSize', 'IsRequired' ],
                    columnFilter        : {},
                    topIndex            : 0,
                    showFilterRow       : false,
                    sortColumn          : {'SortOrder': true},
                    itemActions         : [
                                            { id: 'view', label: 'ACTIONS.VIEW', icon: 'icon-magnify', privilege: 'GetAttributeDetailsById', disabled: '', visible: true },
                                            { id: 'updateSorting', label: 'ATTRIBUTES.ACTIONS.UPDATE_SORTING', icon: 'icon-pencil', privilege: 'UpdateAttributeSortOrderBulk', disabled: false, visible: true },
                                          ],
                    listActions         : [
                                            { id: 'updateSorting', label: 'ATTRIBUTES.ACTIONS.UPDATE_SORTING', icon: 'icon-pencil', privilege: 'UpdateAttributeSortOrderBulk', disabled: '{selected: true}', visible: true, requiresConfirmation: false },
                                          ],
                    fabAction           : {}
                },
                mainDetails: {},
                privileges: {
                    list: 'GetCatalogSpecificAttributeList',
                    details: 'GetAttributeDetailsById'
                }
            }
        };

        function getAttributes(generalProperties, catalogId) {
            var promise;

            if (angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
                var state = {};
                state.name = $state.current.name;
                state.params = $state.params;
                var isBulk = true;
                var logData = activityLogger.createLogData(null, state, 'catalogs.attributes', 'VIEW', isBulk, new Date(), null, null);
                promise = api.webGet(api.baseUrl + '/catalogs/' + catalogId + '/catalogAttributes', undefined, true, generalProperties.forceFetch);
                promise = activityLogger.log(logData, promise);
            }
            else {
                if (angular.isUndefined(catalogId)) {
                    if (angular.isDefined(generalProperties.idMap) && angular.isDefined(generalProperties.idMap.id1)) {
                        catalogId = generalProperties.idMap.id1
                    } else {
                        catalogId = catalogFactory.getActiveCatalog().CatalogCode
                    }
                }
                promise = api.webGet(api.baseUrl + '/catalogs/' + catalogId + '/catalogAttributes', undefined, true, generalProperties.forceFetch);
            }

            promise.then(function (response) {
                if (api.catalogs.attributes.isDirty) {
                    //Invalidate lookupData
                    api.catalogs.attributes.lookupData = undefined;
                    api.catalogs.attributes.isDirty = false;
                }
                var hasArticleLabel = angular.isDefined(api.articleLabelConfiguration) && api.articleLabelConfiguration !== '';
                var hasModelLabel = angular.isDefined(api.modelLabelConfiguration) && api.modelLabelConfiguration !== '';
                var hasSegmentationLabel = angular.isDefined(api.segmentationLabelConfiguration) && api.segmentationLabelConfiguration !== '';

                if (hasArticleLabel || hasModelLabel) {
                    angular.forEach(response.data.AttributeList, function(attribute) {
                        var displayNameLower = attribute.AttributeDisplayName.toLowerCase();

                        if (hasArticleLabel && displayNameLower.includes('article')) {
                            attribute.AttributeDisplayName = utility.replaceStringWithCase(attribute.AttributeDisplayName, 'article', api.articleLabelConfiguration);
                        }
                        if (hasModelLabel && displayNameLower.includes('model')) {
                            attribute.AttributeDisplayName = utility.replaceStringWithCase(attribute.AttributeDisplayName, 'model', api.modelLabelConfiguration);
                        }
                        if (hasSegmentationLabel && displayNameLower.includes('segmentation')) {
                            attribute.AttributeDisplayName = utility.replaceStringWithCase(attribute.AttributeDisplayName, 'segmentation', api.segmentationLabelConfiguration);
                        }
                    });
                }
            });
            return promise;
        }

        function editAttributes(undefined, attributes, catalogCode, attributeGroupId) {
            var result = [];
            var obj = {};
            if (!angular.isArray(attributes)) {
                attributes = crud.pushItemToArray(attributes);
            }
            for (var index = 0; index < attributes.length; index++) {
                obj = {}
                obj['AttributeId'] = attributes[index]['Attributeid'];
                obj['AttributeGroupId'] = attributeGroupId;
                obj['SortOrder'] = attributes[index]['SortOrder'];
                result.push(obj);
            }
            var promise = api.webPut(api.baseUrl + '/catalogs/' + catalogCode + '/attributes/sortorder/update', result);
            promise.then(function () {
                $rootScope.$emit('CatalogsUpdatedEvent');
                api.catalogs.attributes.isDirty = true;
            });
            return promise;
        }

        function updateSeasonlessSortOrder(undefined, attributes, catalogCode, model, sellerAccountId) {
            var result = [];
            var obj = {};
            for (var index = 0; index < attributes.length; index++) {
                obj = {}
                obj['AttributeId'] = attributes[index]['Attributeid'];
                obj['AttributeGroupId'] = attributes[index]['AttributeGroupId'];
                obj['SortOrder'] = attributes[index]['SortOrder'];
                result.push(obj);
            }

            var promise = api.webPut(api.baseUrl + '/sellers/' + sellerAccountId + '/seasonlessattributes/sortorder/update', result);
            promise.then(function () {
                $rootScope.$emit('CatalogsUpdatedEvent');
                api.sellers.seasonlessAttributes.isDirty = true;
            });
            return promise;
        }

        function updateSeasonlessModelAttributeSortOrder(undefined, attributes, catalogCode, model, sellerAccountId) {
            var result = [];
            var obj = {};
            for (var index = 0; index < attributes.length; index++) {
                obj = {}
                obj['AttributeId'] = attributes[index]['Attributeid'];
                obj['AttributeGroupId'] = attributes[index]['AttributeGroupId'];
                obj['SortOrder'] = attributes[index]['SortOrder'];
                result.push(obj);
            }

            var promise = api.webPut(api.baseUrl + '/sellers/' + sellerAccountId + '/modellevelseasonlessattributes/sortorder/update', result);
            promise.then(function () {
                $rootScope.$emit('CatalogsUpdatedEvent');
                api.sellers.seasonlessModelAttributes.isDirty = true;
            });
            return promise;
        }

    }
})();
(function() {
  'use strict';

  angular
      .module('app.main.catalogs.aggregateAttributes',[]);
})();
(function() {
	'use strict';

	angular
			.module('app.main.catalogs.aggregateAttributes')
			.run(runBlock);

	/* @ngInject */
	function runBlock(api) {

			if(angular.isUndefined(api.catalogs)) {
					api.catalogs = {};
			}

			api.catalogs.aggregateAttributes = {
					modelPath: 'catalogs.aggregateAttributes',
					fields: [
							{ field: 'AttributeId', type: 'int', displayLabel: 'ATTRIBUTES.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
									validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
							{ field: 'AttributeDisplayName', type: 'text', displayLabel: 'ATTRIBUTES.FIELDS.NAME', visible: true, creatable: false, editable: false, inputType: 'textArea',
									validation: {isRequired: true, maxLen: 200, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
							{ field: 'AttributeSystemName', type: 'text', displayLabel: 'ATTRIBUTES.FIELDS.SYSTEM_NAME', visible: true, creatable: false, editable: false, inputType: 'textArea',
									validation: {isRequired: false, maxLen: 128, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
							{ field: 'AttributeTypeId', type: 'int', displayLabel: 'ATTRIBUTES.FIELDS.ATTRIBUTE_TYPE_ID', visible: true, creatable: false, editable: false, inputType: 'number',
									validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
							{ field: 'CreatedDate', type: 'text', displayLabel: 'ATTRIBUTES.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
									validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
							{ field: 'UpdatedDate', type: 'text', displayLabel: 'ATTRIBUTES.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
									validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
							{ field: 'AttributeTypeName', type: 'text', displayLabel: 'ATTRIBUTES.FIELDS.ATTRIBUTE_TYPE_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
									validation: {isRequired: false, maxLen: 25, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
							{ field: 'CreatedBy', type: 'text', displayLabel: 'ATTRIBUTES.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
									validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
							{ field: 'UpdatedBy', type: 'text', displayLabel: 'ATTRIBUTES.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
									validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
					],

					title: 'ATTRIBUTES.NAV',
					icon: 'icon-dice-1',
					idField: 'AttributeId',
					lookupDisplayField: 'AttributeDisplayName',
					methods: {},
					views: {
							mainList: {
									columns             : [ 'AttributeDisplayName', 'AttributeSystemName', 'UpdatedDate', 'AttributeTypeName'],
									columnFilter        : {},
									topIndex            : 0,
									showFilterRow       : false,
									sortColumn          : {'UpdatedDate': false},
									itemActions         : [
																					{ id: 'view', label: 'ACTIONS.VIEW', icon: 'icon-magnify', privilege: 'GetAttributeDetailsById', disabled: '', visible: true }
																				],
									listActions         : [],
									fabAction           : {}
							},
							mainDetails: {},
							privileges: {}
					}
			};



	}
})();
(function() {
	'use strict';

	angular
			.module('app.main.catalogs.article-states.state-required-attributes', [])
			.config(config);

		/* @ngInject */
		function config($translatePartialLoaderProvider) {

				// Translation
				$translatePartialLoaderProvider.addPart('app/main/article-states/details/tabs/state-required-attributes');
		}
})();
(function () {
	'use strict';

	angular
	.module('app.main.catalogs.article-states.state-required-attributes')
	.run(runBlock);

	/* @ngInject */
	function runBlock(api) {

		if (angular.isUndefined(api.articleStates)) {
			api.articleStates = {};
		}
		api.articleStates.requiredAttributes = {
			modelPath: 'articleStates.requiredAttributes',
			fields: [
				{ field: 'AttributeId', type: 'int', displayLabel: 'STATE_REQUIRED_ATTRIBUTES.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
						validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'AttributeDisplayName', type: 'text', displayLabel: 'STATE_REQUIRED_ATTRIBUTES.FIELDS.NAME', visible: true, creatable: false, editable: false, inputType: 'textArea',
						validation: {isRequired: true, maxLen: 200, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'AttributeSystemName', type: 'text', displayLabel: 'STATE_REQUIRED_ATTRIBUTES.FIELDS.SYSTEM_NAME', visible: true, creatable: false, editable: false, inputType: 'textArea',
						validation: {isRequired: false, maxLen: 128, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'Criteria', type: 'text', displayLabel: 'STATE_REQUIRED_ATTRIBUTES.FIELDS.CRITERIA', visible: true, creatable: false, editable: false, inputType: 'textArea',
						validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
			],
			uniqueConstraints: [],
			title: 'STATE_REQUIRED_ATTRIBUTES.NAV',
			icon: 'icon-alert-box',
			idField: 'AttributeId',
			lookupDisplayField: 'AttributeDisplayName',
			isDirty: false,
			methods: {},
			views: {
				mainList: {
					columns: [ 'AttributeId', 'AttributeDisplayName', 'AttributeSystemName', 'Criteria' ],
					columnFilter: {},
					toggleFilterProps: {},
					topIndex: 0,
					showFilterRow: false,
					sortColumn: {},
					sortDescending: true,
					itemActions: [],
					listActions: [],
					fabAction:{}
				},
				mainDetails: {},
				privileges: {
						list: 'GetArticleStatesList'
				}
			}
		};
	}
})();
(function() {
	'use strict';

	angular
			.module('app.main.catalogs.article-states.state-non-editable-attributes', [])
			.config(config);

		/* @ngInject */
		function config($translatePartialLoaderProvider) {

				// Translation
				$translatePartialLoaderProvider.addPart('app/main/article-states/details/tabs/state-non-editable-attributes');
		}
})();
(function () {
	'use strict';

	angular
	.module('app.main.catalogs.article-states.state-non-editable-attributes')
	.run(runBlock);

	/* @ngInject */
	function runBlock(api) {

		if (angular.isUndefined(api.articleStates)) {
			api.articleStates = {};
		}
		api.articleStates.nonEditableAttributes = {
			modelPath: 'articleStates.nonEditableAttributes',
			fields: [
				{ field: 'AttributeId', type: 'int', displayLabel: 'STATE_NON_EDITABLE_ATTRIBUTES.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
						validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'AttributeDisplayName', type: 'text', displayLabel: 'STATE_NON_EDITABLE_ATTRIBUTES.FIELDS.NAME', visible: true, creatable: false, editable: false, inputType: 'textArea',
						validation: {isRequired: true, maxLen: 200, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'AttributeSystemName', type: 'text', displayLabel: 'STATE_NON_EDITABLE_ATTRIBUTES.FIELDS.SYSTEM_NAME', visible: true, creatable: false, editable: false, inputType: 'textArea',
						validation: {isRequired: false, maxLen: 128, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'AllowChangeRequest', type: 'text', displayLabel: 'STATE_NON_EDITABLE_ATTRIBUTES.FIELDS.ALLOW_CHANGE_REQUEST', visible: true, creatable: false, editable: false, inputType: 'bool-int',
						validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
			],
			uniqueConstraints: [],
			title: 'STATE_NON_EDITABLE_ATTRIBUTES.NAV',
			icon: 'icon-alert-box',
			idField: 'AttributeId',
			lookupDisplayField: 'AttributeDisplayName',
			isDirty: false,
			methods: {},
			views: {
				mainList: {
					columns: [ 'AttributeId', 'AttributeDisplayName', 'AttributeSystemName', 'AllowChangeRequest' ],
					columnFilter: {},
					toggleFilterProps: {},
					topIndex: 0,
					showFilterRow: false,
					sortColumn: {},
					sortDescending: true,
					itemActions: [],
					listActions: [],
					fabAction:{}
				},
				mainDetails: {},
				privileges: {
						list: 'GetArticleStatesList'
				}
			}
		};
	}
})();
(function() {
	'use strict';

	angular.module('app.main.vetting-lists', [])
    .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // States
        $stateProvider.state('app.lists_account_types', {
            url    : '/lists/account-types',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/vetting-lists/vetting-list.html',
                    controller : 'vettingListController as vm'
                }
            },
            resolve: {
                APIListName : function(){
                    return 'accountTypes';
                }
            },
            data: {
                displayName: 'ACCOUNT_TYPES.NAV'
            },
            // accessPrivileges: ['GetCompanyAccountTypes']
            // accessPrivileges: ['nav_account_types']
            accessInfo: {
                accessPrivileges: ['nav_account_types']
            },
            visibleForLinePlan: true
        });

        $stateProvider.state('app.lists_attribute_types', {
            url    : '/lists/attribute-types',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/vetting-lists/vetting-list.html',
                    controller : 'vettingListController as vm'
                }
            },
            resolve: {
                APIListName : function(){
                    return 'attributeTypes';
                }
            },
            data: {
                displayName: 'ATTRIBUTE_TYPES.NAV'
            },
            // accessPrivileges: ['GetAttributeTypeList']
            // accessPrivileges: ['nav_attribute_types']
            accessInfo: {
                accessPrivileges: ['nav_attribute_types']
            },
            visibleForLinePlan: true
        });

        $stateProvider.state('app.lists_clients', {
            url    : '/lists/clients',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/vetting-lists/vetting-list.html',
                    controller : 'vettingListController as vm'
                }
            },
            resolve: {
                APIListName : function(){
                    return 'clients';
                }
            },
            data: {
                displayName: 'CLIENTS.NAV'
            },
            // accessPrivileges: ['GetClientList']
            // accessPrivileges: ['nav_clients']
            accessInfo: {
                accessPrivileges: ['nav_clients']
            },
            visibleForLinePlan: true
        });

        $stateProvider.state('app.lists_configurations', {
            url    : '/lists/configurations',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/vetting-lists/vetting-list.html',
                    controller : 'vettingListController as vm'
                }
            },
            resolve: {
                APIListName : function(){
                    return 'configurations';
                }
            },
            data: {
                displayName: 'CONFIGURATIONS.NAV'
            },
            // accessPrivileges: ['GetCatalogConfigurations']
            // accessPrivileges: ['nav_configurations']
            accessInfo: {
                accessPrivileges: ['nav_configurations']
            },
            visibleForLinePlan: true
        });

        $stateProvider.state('app.lists_consolidation_statuses', {
            url    : '/lists/consolidation-statuses',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/vetting-lists/vetting-list.html',
                    controller : 'vettingListController as vm'
                }
            },
            resolve: {
                APIListName : function(){
                    return 'consolidationStatuses';
                }
            },
            data: {
                displayName: 'CONSOLIDATION_STATUSES.NAV'
            },
            // accessPrivileges: ['GetOrderConsolidationStatusList']
            // accessPrivileges: ['nav_consolidation_statuses']
            accessInfo: {
                accessPrivileges: ['nav_consolidation_statuses']
            },
            visibleForLinePlan: true
        });

        $stateProvider.state('app.lists_countries', {
            url    : '/lists/countries',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/vetting-lists/vetting-list.html',
                    controller : 'vettingListController as vm'
                }
            },
            resolve: {
                APIListName : function(){
                    return 'countries';
                }
            },
            data: {
                displayName: 'COUNTRIES.NAV'
            },
            // accessPrivileges: ['GetCountryList']
            // accessPrivileges: ['nav_countries']
            accessInfo: {
                accessPrivileges: ['nav_countries']
            },
            visibleForLinePlan: true
        });

        $stateProvider.state('app.lists_currencies', {
            url    : '/lists/currencies',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/vetting-lists/vetting-list.html',
                    controller : 'vettingListController as vm'
                }
            },
            resolve: {
                APIListName : function(){
                    return 'currencies';
                }
            },
            data: {
                displayName: 'CURRENCIES.NAV'
            },
            // accessPrivileges: ['GetCurrencyList']
            // accessPrivileges: ['nav_currencies']
            accessInfo: {
                accessPrivileges: ['nav_currencies']
            },
            visibleForLinePlan: true
        });

        $stateProvider.state('app.lists_data_source_types', {
            url    : '/lists/data-source-types',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/vetting-lists/vetting-list.html',
                    controller : 'vettingListController as vm'
                }
            },
            resolve: {
                APIListName : function(){
                    return 'dataSourceTypes';
                }
            },
            data: {
                displayName: 'DATA_SOURCE_TYPES.NAV'
            },
            // accessPrivileges: ['GetDataSourceTypeList']
            // accessPrivileges: ['nav_data_source_types']
            accessInfo: {
                accessPrivileges: ['nav_data_source_types']
            },
            visibleForLinePlan: true
        });

        $stateProvider.state('app.lists_entity_types', {
            url    : '/lists/entity-types',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/vetting-lists/vetting-list.html',
                    controller : 'vettingListController as vm'
                }
            },
            resolve: {
                APIListName : function(){
                    return 'entityTypes';
                }
            },
            data: {
                displayName: 'ENTITY_TYPES.NAV'
            },
            // accessPrivileges: ['GetCatalogEntityList']
            // accessPrivileges: ['nav_entity_types']
            accessInfo: {
                accessPrivileges: ['nav_entity_types']
            },
            visibleForLinePlan: true
        });

        $stateProvider.state('app.lists_privacy_policy', {
            url    : '/lists/privacy-policy',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/vetting-lists/vetting-list.html',
                    controller : 'vettingListController as vm'
                }
            },
            resolve: {
                APIListName : function(){
                    return 'privacyPolicy';
                }
            },
            data: {
                displayName: 'PRIVACY_POLICY.NAV'
            },
            // accessPrivileges: ['GetPrivacyPolicyList']
            // accessPrivileges: ['nav_privacy_policy']
            accessInfo: {
                accessPrivileges: ['nav_privacy_policy']
            },
            visibleForLinePlan: true
        });


        $stateProvider.state('app.lists_privacy_policy.details', {
			url	 : '/:id',
            views: {
				'content@app': {
					templateUrl: 'app/main/vetting-lists/privacy-policy-details/privacy-policy-details.html',
					controller : 'privacyPolicyDetailsController as vm'
				}
			},
			data: {
                displayName: 'PRIVACY_POLICY.TABS.PRIVACY_POLICY',
				parentState: 'app.lists_privacy_policy'
			},
            resolve: {
            },
            //accessPrivileges: ['GetSellerAccountDetails']
            // accessPrivileges: ['GetPrivacyPolicyDetails']
            accessInfo: {
                accessPrivileges: ['GetPrivacyPolicyDetails']
            },
            visibleForLinePlan: true
		});

        $stateProvider.state('app.lists_resource_file_types', {
            url    : '/lists/resource-file-types',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/vetting-lists/vetting-list.html',
                    controller : 'vettingListController as vm'
                }
            },
            resolve: {
                APIListName : function(){
                    return 'resourceFileTypes';
                }
            },
            data: {
                displayName: 'RESOURCE_FILE_TYPES.NAV'
            },
            // accessPrivileges: ['GetImagesResourcesFileTypeList']
            // accessPrivileges: ['nav_resource_file_types']
            accessInfo: {
                accessPrivileges: ['nav_resource_file_types']
            },
            visibleForLinePlan: true
        });

        $stateProvider.state('app.lists_resource_types', {
            url    : '/lists/resource-types',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/vetting-lists/vetting-list.html',
                    controller : 'vettingListController as vm'
                }
            },
            resolve: {
                APIListName : function(){
                    return 'resourceTypes';
                }
            },
            data: {
                displayName: 'RESOURCE_TYPES.NAV'
            },
            // accessPrivileges: ['GetResourceTypeList']
            accessPrivileges: ['nav_resource_types']
        });

        $stateProvider.state('app.lists_file_types', {
            url    : '/lists/file-types',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/vetting-lists/vetting-list.html',
                    controller : 'vettingListController as vm'
                }
            },
            resolve: {
                APIListName : function(){
                    return 'fileTypes';
                }
            },
            data: {
                displayName: 'FILE_TYPES.NAV'
            },
            // accessPrivileges: ['GetFileTypes']
            // accessPrivileges: ['nav_file_types']
            accessInfo: {
                accessPrivileges: ['nav_file_types']
            },
            visibleForLinePlan: true
        });

        $stateProvider.state('app.lists_size_map', {
            url    : '/lists/size-map',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/vetting-lists/vetting-list.html',
                    controller : 'vettingListController as vm'
                }
            },
            resolve: {
                APIListName : function(){
                    return 'sizeMap';
                }
            },
            data: {
                displayName: 'SIZE_MAP.NAV'
            },
            // accessPrivileges: ['GetSizeMapList']
            // accessPrivileges: ['nav_size_map']
            accessInfo: {
                accessPrivileges: ['nav_size_map']
            },
            visibleForLinePlan: true
        });

        $stateProvider.state('app.lists_user_logs', {
            url    : '/lists/user-logs',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/vetting-lists/vetting-list.html',
                    controller : 'vettingListController as vm'
                }
            },
            resolve: {
                APIListName : function(){
                    return 'userLogs';
                }
            },
            data: {
                displayName: 'USER_LOGS.NAV'
            },
            // accessPrivileges: ['GetUserLogs']
            // accessPrivileges: ['nav_user_logs']
            accessInfo: {
                accessPrivileges: ['nav_user_logs']
            },
            visibleForLinePlan: true
        });

        // dune context
        $stateProvider.state('app.lists_dune_context', {
            url    : '/lists/dune-context',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/vetting-lists/vetting-list.html',
                    controller : 'vettingListController as vm'
                }
            },
            resolve: {
                APIListName : function(){
                    return 'duneContext';
                }
            },
            data: {
                displayName: 'DUNE_CONTEXT.NAV'
            },
            // accessPrivileges: ['nav_dune_context']
            accessInfo: {
                accessPrivileges: ['nav_dune_context']
            },
            visibleForLinePlan: true
        });

        // notification types
        $stateProvider.state('app.lists_notification_types', {
            url    : '/lists/notification-types',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/vetting-lists/vetting-list.html',
                    controller : 'vettingListController as vm'
                }
            },
            resolve: {
                APIListName : function() {
                    return 'notificationTypes';
                }
            },
            data: {
                displayName: 'NOTIFICATION_TYPES.NAV'
            },
            // accessPrivileges: ['GetNotificationTypes']
            accessInfo: {
                accessPrivileges: ['nav_notification_type']
            },
            visibleForLinePlan: true
        });


        $stateProvider.state('app.lists_license_types', {
            url    : '/lists/license-types',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/vetting-lists/vetting-list.html',
                    controller : 'vettingListController as vm'
                }
            },
            resolve: {
                APIListName : function() {
                    return 'licenseTypes';
                }
            },
            data: {
                displayName: 'LICENSE_TYPES.NAV'
            },
            accessInfo: {
                accessPrivileges: ['LicenseTypesNavigation']
            },
            visibleForLinePlan: true
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/vetting-lists');

        //Navigation
        msNavigationServiceProvider.saveItem('configuration', {
            title : 'Configuration',
            translate: 'NAV.CONFIGURATION',
            group : true,
            weight: 3
        });

        //Navigation
        msNavigationServiceProvider.saveItem('configuration.vettingList', {
            title : 'Vetting List',
            icon  : 'icon-format-list-bulleted',
            translate: 'NAV.VETTING_LIST',
            weight: 30,
            // accessPrivileges: ['nav_account_types', 'nav_attribute_types', 'nav_configurations',
            // 'nav_consolidation_statuses', 'nav_countries', 'nav_currencies', 'nav_data_source_types',
            //  'nav_entity_types', 'nav_resource_file_types', 'nav_file_types', 'nav_size_map'],
             //  accessPrivileges: ['GetCompanyAccountTypes', 'GetAttributeTypeList', 'GetCatalogConfigurations', 'GetFileTypes'
             // 'GetOrderConsolidationStatusList', 'GetCountryList', 'GetCurrencyList', 'GetDataSourceTypeList', 'GetCatalogEntityList', 'GetImagesResourcesFileTypeList', 'GetSizeMapList']
             accessInfo: {
                accessPrivileges: ['nav_account_types', 'nav_attribute_types', 'nav_configurations',
                'nav_consolidation_statuses', 'nav_countries', 'nav_currencies', 'nav_data_source_types',
                 'nav_entity_types', 'nav_resource_file_types', 'nav_file_types', 'nav_size_map']
             },
             visibleForLinePlan: true

        });

        msNavigationServiceProvider.saveItem('configuration.vettingList.accountTypes', {
            title      : 'Account Types',
            subTitle   : 'Vetting List',
            icon       : 'icon-tile-four',
            state      : 'app.lists_account_types',
            translate: 'ACCOUNT_TYPES.NAV',
            weight     : 1,
            // accessPrivileges: ['GetCompanyAccountTypes']
            // accessPrivileges: ['nav_account_types'],
            accessInfo: {
                accessPrivileges: ['nav_account_types']
            },
            visibleForLinePlan: true
        });

        msNavigationServiceProvider.saveItem('configuration.vettingList.attributeTypes', {
            title      : 'Attribute Types',
            subTitle   : 'Vetting List',
            icon       : 'icon-tile-four',
            state      : 'app.lists_attribute_types',
            translate: 'ATTRIBUTE_TYPES.NAV',
            weight     : 2,
            // accessPrivileges: ['GetAttributeTypeList']
            // accessPrivileges: ['nav_attribute_types'],
            accessInfo: {
                accessPrivileges: ['nav_attribute_types']
            },
            visibleForLinePlan: true
        });

        msNavigationServiceProvider.saveItem('configuration.vettingList.clients', {
            title      : 'Clients',
            subTitle   : 'Vetting List',
            icon       : 'icon-tile-four',
            state      : 'app.lists_clients',
            translate: 'CLIENTS.NAV',
            weight     : 2.5,
            // accessPrivileges: ['GetClientList']
            // accessPrivileges: ['nav_clients'],
            accessInfo: {
                accessPrivileges: ['nav_clients']
            },
            visibleForLinePlan: true
        });

        msNavigationServiceProvider.saveItem('configuration.vettingList.configurations', {
            title      : 'Configurations',
            subTitle   : 'Vetting List',
            icon       : 'icon-tile-four',
            state      : 'app.lists_configurations',
            translate: 'CONFIGURATIONS.NAV',
            weight     : 3,
            // accessPrivileges: ['GetCatalogConfigurations']
            // accessPrivileges: ['nav_configurations'],
            accessInfo: {
                accessPrivileges: ['nav_configurations']
            },
            visibleForLinePlan: true
        });

        msNavigationServiceProvider.saveItem('configuration.vettingList.consolidationStatuses', {
            title      : 'Consolidation Statuses',
            subTitle   : 'Vetting List',
            icon       : 'icon-tile-four',
            state      : 'app.lists_consolidation_statuses',
            translate: 'CONSOLIDATION_STATUSES.NAV',
            weight     : 4,
            // accessPrivileges: ['GetOrderConsolidationStatusList']
            // accessPrivileges: ['nav_consolidation_statuses'],
            accessInfo: {
                accessPrivileges: ['nav_consolidation_statuses']
            },
            visibleForLinePlan: true
        });

        msNavigationServiceProvider.saveItem('configuration.vettingList.countries', {
            title      : 'Countries',
            subTitle   : 'Vetting List',
            icon       : 'icon-tile-four',
            state      : 'app.lists_countries',
            /*stateParams: {
                'param1': 'page'
            },*/
            translate: 'COUNTRIES.NAV',
            weight     : 5,
            // accessPrivileges: ['GetCountryList']
            // accessPrivileges: ['nav_countries'],
            accessInfo: {
                accessPrivileges: ['nav_countries']
            },
            visibleForLinePlan: true
        });

        msNavigationServiceProvider.saveItem('configuration.vettingList.currencies', {
            title      : 'Currencies',
            subTitle   : 'Vetting List',
            icon       : 'icon-tile-four',
            state      : 'app.lists_currencies',
            translate: 'CURRENCIES.NAV',
            weight     : 6,
            // accessPrivileges: ['GetCurrencyList']
            // accessPrivileges: ['nav_currencies'],
            accessInfo: {
                accessPrivileges: ['nav_currencies']
            },
            visibleForLinePlan: true
        });

        msNavigationServiceProvider.saveItem('configuration.vettingList.dataSourceTypes', {
            title      : 'Data Source Types',
            subTitle   : 'Vetting List',
            icon       : 'icon-tile-four',
            state      : 'app.lists_data_source_types',
            translate: 'DATA_SOURCE_TYPES.NAV',
            weight     : 7,
            // accessPrivileges: ['GetDataSourceTypeList']
            // accessPrivileges: ['nav_data_source_types'],
            accessInfo: {
                accessPrivileges: ['nav_data_source_types']
            },
            visibleForLinePlan: true
        });

        msNavigationServiceProvider.saveItem('configuration.vettingList.entityTypes', {
            title      : 'Entity Types',
            subTitle   : 'Vetting List',
            icon       : 'icon-tile-four',
            state      : 'app.lists_entity_types',
            translate: 'ENTITY_TYPES.NAV',
            weight     : 8,
            // accessPrivileges: ['GetCatalogEntityList']
            // accessPrivileges: ['nav_entity_types'],
            accessInfo: {
                accessPrivileges: ['nav_entity_types']
            },
            visibleForLinePlan: true
        });

        msNavigationServiceProvider.saveItem('configuration.vettingList.privacyPolicy', {
            title      : 'Privacy Policy',
            subTitle   : 'Vetting List',
            icon       : 'icon-file-document',
            state      : 'app.lists_privacy_policy',
            translate: 'PRIVACY_POLICY.NAV',
            weight     : 9,
            //accessPrivileges: ['GetPrivacyPolicyList']
            // accessPrivileges: ['nav_privacy_policy'],
            accessInfo: {
                accessPrivileges: ['nav_privacy_policy']
            },
            visibleForLinePlan: true
        });

        msNavigationServiceProvider.saveItem('configuration.vettingList.resourceFileTypes', {
            title      : 'Resource File Types',
            subTitle   : 'Vetting List',
            icon       : 'icon-tile-four',
            state      : 'app.lists_resource_file_types',
            translate: 'RESOURCE_FILE_TYPES.NAV',
            weight     : 10,
            // accessPrivileges: ['GetImagesResourcesFileTypeList']
            // accessPrivileges: ['nav_resource_file_types'],
            accessInfo: {
                accessPrivileges: ['nav_resource_file_types']
            },
            visibleForLinePlan: true
        });

        msNavigationServiceProvider.saveItem('configuration.vettingList.resourceTypes', {
            title      : 'Resource Types',
            subTitle   : 'Vetting List',
            icon       : 'icon-tile-four',
            state      : 'app.lists_resource_types',
            translate: 'RESOURCE_TYPES.NAV',
            weight     : 10.5,
            accessPrivileges: ['nav_resource_types'],
            // accessPrivileges: ['GetResourceTypeList']
            visibleForLinePlan: true
        });

        msNavigationServiceProvider.saveItem('configuration.vettingList.fileTypes', {
            title      : 'File Types',
            subTitle   : 'Vetting List',
            icon       : 'icon-tile-four',
            state      : 'app.lists_file_types',
            translate: 'FILE_TYPES.NAV',
            weight     : 11,
            // accessPrivileges: ['GetFileTypes']
            // accessPrivileges: ['nav_file_types'],
            accessInfo: {
                accessPrivileges: ['nav_file_types']
            },
            visibleForLinePlan: true
        });

        msNavigationServiceProvider.saveItem('configuration.vettingList.sizeMap', {
            title      : 'Size Map',
            subTitle   : 'Vetting List',
            icon       : 'icon-tile-four',
            state      : 'app.lists_size_map',
            translate: 'SIZE_MAP.NAV',
            weight     : 12,
            // accessPrivileges: ['GetSizeMapList']
            // accessPrivileges: ['nav_size_map'],
            accessInfo: {
                accessPrivileges: ['nav_size_map']
            },
            visibleForLinePlan: true
        });

        msNavigationServiceProvider.saveItem('configuration.vettingList.userLogs', {
            title      : 'User Logs',
            subTitle   : 'Vetting List',
            icon       : 'icon-tile-four',
            state      : 'app.lists_user_logs',
            translate: 'USER_LOGS.NAV',
            weight     : 13,
            // accessPrivileges: ['GetUserLogs']
            // accessPrivileges: ['nav_user_logs'],
            accessInfo: {
                accessPrivileges: ['nav_user_logs']
            },
            visibleForLinePlan: true
        });

        msNavigationServiceProvider.saveItem('configuration.vettingList.duneContext', {
            title      : 'Dune Context',
            subTitle   : 'Vetting List',
            icon       : 'icon-tile-four',
            state      : 'app.lists_dune_context',
            translate  : 'DUNE_CONTEXT.NAV',
            weight     : 14,
            // accessPrivileges: ['nav_dune_context']
            accessInfo: {
                accessPrivileges: ['nav_dune_context']
            },
            visibleForLinePlan: true
        });

        msNavigationServiceProvider.saveItem('configuration.vettingList.notificationTypes', {
            title      : 'Notification Types',
            subTitle   : 'Vetting List',
            icon       : 'icon-tile-four',
            state      : 'app.lists_notification_types',
            translate  : 'NOTIFICATION_TYPES.NAV',
            weight     : 15,
            // accessPrivileges: ['GetNotificationTypes']
            accessInfo: {
                accessPrivileges: ['nav_notification_type']
            },
            visibleForLinePlan: true
        });

        msNavigationServiceProvider.saveItem('configuration.vettingList.licenseTypes', {
            title      : 'License Types',
            subTitle   : 'Vetting List',
            icon       : 'icon-tile-four',
            state      : 'app.lists_license_types',
            translate  : 'LICENSE_TYPES.NAV',
            weight     : 15,
            accessInfo: {
                accessPrivileges: ['LicenseTypesNavigation']
            },
            visibleForLinePlan: true
        });
    }

})();
(function () {
  'use strict';

  angular
    .module('app.main.vetting-lists')
    .controller('createResourceTypesController', createResourceTypesController);

  /* @ngInject */
  function createResourceTypesController($scope, $mdDialog, $filter, toast, utility, hotkeys, model, resourceTypeListData, record, isNew, api) {
    /* jshint validthis: true */
    var vm = this;

    //Data
    vm.model = model;
    vm.isLoading = false;
    vm.record = record;
    vm.isNew = isNew;
    //If resource file types are present in app.config file we will not use the hard coded values
    var allowedFileTypesList = ['pdf', 'jpg', 'jpeg', 'png', 'mp4', 'mpeg', 'mpg', 'avi'];
    vm.searchText = '';
    vm.isDataDirty = false;
    vm.acSelectedItem = [];
    vm.acSearchText = [];
    vm.existingRecords = angular.copy(resourceTypeListData);
    if(isNew) {
      vm.record.AllowedFileTypes = [];
      vm.record.VisibleInResourcesList = 1;
    } else {
      //for edit resourcetypes remove current record from existing list for unique value check
      var typeList = [];
      angular.forEach(vm.existingRecords, function(existingRecord) {
        if(existingRecord.Type !== vm.record.Type) {
          typeList.push(existingRecord);
        }
      });
      vm.existingRecords = typeList;
    }

    //Methods
    vm.saveRecord = saveRecord;
    vm.closeDialog = closeDialog;
    vm.allowedFileTypesQuerySearch = allowedFileTypesQuerySearch;
    vm.transformChip = transformChip;

    activate();

    ////////////////

    function activate() {
      //Hotkeys
      hotkeys.bindTo($scope).add({
        combo: 'ctrl+enter',
        description: $filter('translate')('ACTIONS.SAVE'),
        allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
        callback: function (event) {
          if (!vm.isLoading && !vm.editForm.$invalid) {
            vm.saveRecord();
          }
        }
      });

      hotkeys.bindTo($scope).add({
        combo: 'ctrl+shift+enter',
        description: $filter('translate')('ACTIONS.SAVE_AND_NEW'),
        allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
        callback: function (event) {
          if (!vm.isLoading && !vm.editForm.$invalid) {
            vm.saveRecord(true);
          }
        }
      });

      if(!isNew){
        vm.preview = vm.record.Icon;
      }

      //Load WebAPI resource types and file types
			api.webGet('/app/app.config.json')
      .then(function (response) {
        if (angular.isDefined(response) && angular.isDefined(response.data)) {
          if (angular.isDefined(response.data.resourcesAllowedFileTypes) && response.data.resourcesAllowedFileTypes.length > 0) {
            allowedFileTypesList = [];
            angular.forEach(response.data.resourcesAllowedFileTypes,function(resourceFileType) {
              allowedFileTypesList.push(resourceFileType.fileType);
            });
          }
          //If resource file types are not present in app.config we will use hardcoded values
          allowedFileTypesList = $filter('orderBy')(allowedFileTypesList);
        }
      });
    }

    function saveRecord(saveAndNew) {
      var file = document.querySelector('#icon').files[0];
      if (file) {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
          vm.record.Icon = reader.result;
          resourseTypeCreateOrUpdate(saveAndNew);
        };
      } else if(!isNew) {
        vm.model.methods.update(vm.record).then(function () {
          if (angular.isDefined(saveAndNew) && saveAndNew) {
            vm.editForm.$setPristine();
            vm.editForm.$setUntouched();
            resourceTypeListData.push({Type: vm.record.Type});
            vm.record = {};
            vm.record.AllowedFileTypes = [];
            vm.record.VisibleInResourcesList = 0;
            vm.searchText = '';
            vm.isDataDirty = true;
          }
          else {
            closeDialog(true);
          }
          toast.success('SUCCESS.UPDATE', '', '');
        }, function (err) {
          closeDialog(vm.isDataDirty);
        }).finally(function () {
          vm.isLoading = false;
        });
      } else {
        vm.record.Icon = null;
        resourseTypeCreateOrUpdate(saveAndNew);
      }
    }

    function transformChip(chip) {
      return chip;
    }

    function allowedFileTypesQuerySearch(query, selectedItems) {
      var searchQueryResult = [];
      var searchQueryResult = utility.filterObject(allowedFileTypesList, query);
      if (selectedItems && selectedItems.length > 0) {
        for (var index = searchQueryResult.length - 1; index >= 0; index--) {
          if (selectedItems.indexOf(searchQueryResult[index]) !== -1) {
            searchQueryResult.splice(index, 1);
          }
        }
      }
      return searchQueryResult;
    }

    function resourseTypeCreateOrUpdate(saveAndNew) {
      vm.isLoading = true;
      var promise = undefined;
      if(isNew) {
        promise = vm.model.methods.create(vm.record);
      } else {
        promise = vm.model.methods.update(vm.record);
      }
      promise.then(function () {
        if (angular.isDefined(saveAndNew) && saveAndNew) {
          vm.editForm.$setPristine();
          vm.editForm.$setUntouched();
          resourceTypeListData.push({Type: vm.record.Type});
          vm.record = {};
          vm.record.AllowedFileTypes = [];
          vm.record.VisibleInResourcesList = 1;
          vm.searchText = '';
          vm.isDataDirty = true;
        }
        else {
          closeDialog(true);
        }
        toast.success('SUCCESS.CREATE', '', '');
      }, function (err) {
        closeDialog(vm.isDataDirty);
      }).finally(function () {
        vm.isLoading = false;
      });
    }

    function closeDialog(saved) {
      $mdDialog.hide(saved);
    }

  }
})();
(function () {
  'use strict';

  angular
    .module('app.main.vetting-lists')
    .controller('createPrivacyPolicyController', createPrivacyPolicyController);

  /* @ngInject */
  function createPrivacyPolicyController($state, $scope, $window, $mdDialog, $filter, toast, hotkeys, event, model, record, isCopyPrivacyPolicy) {
    /* jshint validthis: true */
    var vm = this;

    //Data
    vm.model = model;
    vm.isLoading = false;
    vm.record = {};
    vm.isDataDirty = false;
    vm.isCopyPrivacyPolicy = isCopyPrivacyPolicy;
    vm.loadingContent = false

    if (vm.isCopyPrivacyPolicy) {
      vm.record = record;
      if(angular.isUndefined(vm.record.Content) || vm.record.Content == null ||  vm.record.Content === '') {
        vm.loadingContent = true
        getContent()
        .then(function(content) {
          vm.record.Content = content
        })
        .finally(function() {
          vm.loadingContent = false
        })
      }
    }

    //Methods
    vm.saveRecord = saveRecord;
    vm.closeDialog = closeDialog;

    activate();

    ////////////////

    function activate() {
      //Hotkeys
      hotkeys.bindTo($scope).add({
        combo: 'ctrl+enter',
        description: $filter('translate')('ACTIONS.SAVE'),
        allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
        callback: function (event) {
          if (!vm.isLoading && !vm.editForm.$invalid) {
            vm.saveRecord();
          }
        }
      });
    }

    function saveRecord(saveAndNew) {
      vm.isLoading = true;
      vm.model.methods.create(vm.record).then(function (response) {
        if (isCopyPrivacyPolicy) {
          var id = response.data[vm.model.idField];
          var stateParams = { id: id };
          $state.go($state.current.name, stateParams);
        }
        closeDialog(true);
        toast.success('SUCCESS.CREATE', '', '');
      }, function (err) {
        closeDialog(vm.isDataDirty);
      }).finally(function () {
        vm.isLoading = false;
      });
    }

    function closeDialog(saved) {
      $mdDialog.hide(saved);
    }

    function getContent() {
      return vm.model.methods.getDetails(false, vm.record[vm.model.idField])
        .then(function(response) {
          return response.data.Content
        })
    }


  }
})();
(function() {
    'use strict';

    angular
        .module('app.main.vetting-lists')
        .controller('createConfigurationController', createConfigurationController);

    /* @ngInject */
    function createConfigurationController($scope, $window, $mdDialog, $filter, toast, utility, hotkeys, event, model) {
        /* jshint validthis: true */
        var vm = this;

        //Data
        vm.model = model;

        vm.isLoading = false;
        vm.record = {};
        vm.defaultValueTypes = [
            {Id: 'nvarchar', value: 'Text'},
            {Id: 'int', value: 'Number'},
            {Id: 'datetime', value: 'Date'},
            {Id: 'bool', value: 'Boolean'}
        ];
        vm.record.DefaultValueType = 'nvarchar';
        vm.searchText = '';
        vm.isDataDirty = false;


        //Methods
        vm.saveRecord = saveRecord;
        vm.closeDialog = closeDialog;
        vm.onTypeChange = onTypeChange;

        activate();

        ////////////////

        function activate() {
            //Hotkeys
            hotkeys.bindTo($scope).add({
                combo: 'ctrl+enter',
                description: $filter('translate')('ACTIONS.SAVE'),
                allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
                callback: function(event) {
                    if (!vm.isLoading && !vm.editForm.$invalid) {
                        vm.saveRecord();
                    }
                }
            });

            hotkeys.bindTo($scope).add({
                combo: 'ctrl+shift+enter',
                description: $filter('translate')('ACTIONS.SAVE_AND_NEW'),
                allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
                callback: function(event) {
                    if (!vm.isLoading && !vm.editForm.$invalid) {
                        vm.saveRecord(true);
                    }
                }
            });
        }

        function saveRecord(saveAndNew) {
            vm.isLoading = true;
            vm.model.methods.create(vm.record).then(function() {
                if (angular.isDefined(saveAndNew) && saveAndNew) {
                    vm.editForm.$setPristine();
                    vm.editForm.$setUntouched();
                    vm.record = {};
                    vm.record.DefaultValueType = 'nvarchar';
                    vm.searchText = '';
                    vm.isDataDirty = true;
                    var el = $window.document.getElementById('dialog_input_first');
                    if (el) {
                        el.focus();
                    }
                }
                else {
                    closeDialog(true);
                }
                toast.success('SUCCESS.CREATE', '', '');
            }, function(err) {
                closeDialog(vm.isDataDirty);
            }).finally(function () {
                vm.isLoading = false;
            });
        }

        function closeDialog(saved) {
            $mdDialog.hide(saved);
        }

        function onTypeChange(type) {
            vm.record.Value = undefined;
            if(type  === 'bool') {
                vm.record.Value = false;
            }
        }
    }
})();
(function() {
	'use strict';

	angular
        .module('app.main.plugins-consolidation', [])
        .config(config);

    /* @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
        // State
        $stateProvider.state('app.plugins-consolidation', {
            url    : '/plugins',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/plugins-consolidation/list/plugins-consolidation-list.html',
                    controller : 'pluginsListController as vm'
                }
            },
            resolve: {

            },
            data: {
                displayName: 'PLUGINS.NAV'
            },
            //only users with following accessPrivileges in their role access list can access this route
            // accessPrivileges: ['GetPlugins']
            accessInfo: {
                accessPrivileges: ['nav_plugins']
            },
            visibleForLinePlan: true
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/plugins-consolidation');


        msNavigationServiceProvider.saveItem('configuration.plugins-consolidation', {
            title      : 'Plugins',
            icon       : 'icon-arrow-all',
            state      : 'app.plugins-consolidation',
            translation: 'PLUGINS.NAV',
            weight     : 16,
            // accessPrivileges: ['GetPlugins']
            // accessPrivileges: ['nav_plugins'],
            accessInfo: {
                accessPrivileges: ['nav_plugins']
            },
            visibleForLinePlan: true
        });
    }
})();
(function() {
	'use strict';

	angular
			.module('app.main.plugins-consolidation')
			.controller('uploadPluginController', uploadPluginController);

	/* @ngInject */
	function uploadPluginController($mdDialog, $scope, $window, $filter, hotkeys, $rootScope,
			$auth, toast, model, record, isNew, event, $localStorage) {
			var vm = this;

			// Data
			vm.model = model;
			vm.isFileValid = true;
			vm.isLoading = false;
			vm.isNew = isNew;
			vm.record = record || {};
			vm.isDataDirty = false;

			if (angular.isUndefined($rootScope.flowObj)) {
					$rootScope.flowObj = {};
			}
			vm.obj = $rootScope.flowObj;

			vm.flowInit = {
				target      : $localStorage.baseUrl + '/UploadFileChunk',
				headers     : { Authorization: 'Bearer ' + $auth.getToken()},
				singleFile  : true
			};

			// Methods
			vm.saveRecord = saveRecord;
			vm.closeDialog = closeDialog;
			vm.validateFile = validateFile;
			vm.upload = upload;
			vm.onSuccessUpload = onSuccessUpload;

			activate();

			function activate() {
					// Hotkeys
					hotkeys.bindTo($scope).add({
							combo: 'ctrl+enter',
							description: $filter('translate')('ACTIONS.SAVE'),
							allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
							callback: function(event) {
									if (!vm.isLoading && !vm.editForm.$invalid && vm.obj.flow.files.length > 0 && vm.isFileValid && !vm.obj.flow.isUploading()) {
											vm.saveRecord();
									}
							}
					});
			}

			function saveRecord() {
					vm.isLoading = true;
					var promise=  vm.model.methods.create(vm.record);
					promise.then(function() {
							vm.editForm.$setPristine();
							vm.editForm.$setUntouched();
							vm.record = {};
							vm.obj.flow.files.length = 0;
							vm.isDataDirty = true;

							var el = $window.document.getElementById('dialog_input_first');
							if (el) {
									el.focus();
							}
							toast.success(vm.isNew ? 'SUCCESS.CREATE' : 'SUCCESS.UPDATE', '', '');
					}, function(err) {
							closeDialog(vm.isDataDirty);
					}).finally(function() {
							closeDialog(true);
							vm.isLoading = false;
					});
			}

			function closeDialog(saved, cancelUpload) {
					if (angular.isDefined(cancelUpload) && cancelUpload === true) {
							vm.obj.flow.cancel();
					}
					$mdDialog.hide(saved);
			}

			function validateFile(file, message, flow) {
					if (angular.isDefined(file) && !file.name.match(/\.(dll)$/i)) {
							vm.isFileValid = false;
					} else {
							vm.isFileValid = true;
					}
			}

			function upload() {
				if(vm.isFileValid) {
					vm.obj.flow.upload();
				} else {
					vm.obj.flow.removeFile(vm.obj.flow.files[vm.obj.flow.files.length - 1]);
				}
			}

			function onSuccessUpload(file, message) {
					message = message.replace(/\"/g, "");
					vm.record.FileId = message;
			}
	}
})();
(function() {
    'use strict';

    angular
        .module('app.main.customers.locations')
        .controller('LocationDetailsController', LocationDetailsController);

    /* @ngInject */
    function LocationDetailsController(api, $stateParams, $state, $rootScope) {
        /* jshint validthis: true */
        var vm = this;
        var locationId   = $stateParams.id;
        vm.customerId   = $stateParams.customerId;
        var sellerId = $stateParams.accountId;

        vm.model = api.customers.locations;
        vm.location = {};
        vm.isLoading = false;
        vm.parentId = {};
        vm.parentId.customerId = vm.customerId;
        vm.parentId.sellerId = sellerId;

        vm.doItemAction = doItemAction;
        vm.refreshRecord = refreshRecord;

        activate();

        ////////////////

        function activate() {
            refreshRecord(true);
        }

        function refreshRecord(isLogRequired) {
            vm.isLoading = true;

            vm.model.methods.getDetails(isLogRequired, locationId, vm.customerId, sellerId)
                .then(function (response) {
                    vm.location = response.data;
                    vm.title = vm.location[vm.model.lookupDisplayField];

                    //Update Breadcrumb
                    $state.current.data.displayName = vm.title;
                    $rootScope.$broadcast('breadcrumb-updated');
                })
                .finally(function () {
                    vm.isLoading = false;
                });
        }

        function doItemAction(action, record) {
            if (action) {
                switch (action.id) {
                    case 'delete':
					case 'activate':
                        vm.model.methods.activateBulk(record, vm.model, action.id, vm.customerId, sellerId);
                        break;
                }
            }
        }
    }
})();
(function() {
		'use strict';

		angular
				.module('app.main.catalogs.tree-list')
				.run(runBlock);

		/* @ngInject */
		function runBlock(api, utility, $state, activityLogger, treeFactory) {

				if (angular.isUndefined(api.catalogs)) {
						api.catalogs = {};
				}
				api.catalogs.treeNodesList = {
						modelPath: 'catalogs.treeNodesList',
						fields: [
								{ field: 'Category', type: 'text', displayLabel: 'CATALOG_TREE.FIELDS.CATEGORY', visible: true, creatable: false, editable: false, inputType: 'text'},
								{ field: 'Path', type: 'text', displayLabel: 'CATALOG_TREE.FIELDS.PATH', visible: true, creatable: false, editable: false, inputType: 'text'},
								{ field: 'SortOrder', type: 'int', displayLabel: 'CATALOG_TREE.FIELDS.SORT_ORDER', visible: true, creatable: true, editable: true, inputType: 'number' }
						],
						uniqueConstraints: [],
						title: 'CATALOG_TREE.NAV',
						icon: 'icon-sitemap',
						idField: '',
						lookupDisplayField: '',
						isDirty: false,
						isCatalogSpecificModel: true,
						methods: {
								getList   :   getTreeNodes,
								update    :   updateSortOrder
						},
						views: {
								mainList: {
										columns         : ['Category', 'Path', 'SortOrder'],
										columnFilter    : {},
										topIndex        : 0,
										showFilterRow   : false,
										sortColumn      : {},
										itemActions     : [
												{ id: 'edit', label: 'CATALOG_TREE.ACTIONS.EDIT_SORT_ORDER', icon: 'icon-pencil', privilege: 'CreateCatalogTreeNodes:true', disabled: false, visible: true }
										],
										listActions     : [],
										fabAction       : {}
								 },
								 mainDetails: {},
								 privileges: {
										list    : 'GetCatalogTreeNodes'
								}
						}
				};

				function getTreeNodes(generalProperties, catalogCode, catalogTreeId) {
					var promise;

					if(angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
							var state = {};
							state.name = $state.current.name;
							state.params = $state.params;
							var isBulk = true;
							var logData = activityLogger.createLogData(null, state, 'catalogs.treeNodes', 'VIEW', isBulk, new Date(), null, null);

							promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/trees/'+ catalogTreeId + '/treenodes', undefined, true, generalProperties.forceFetch);
							promise = activityLogger.log(logData, promise);
					}
					else {
							catalogCode = angular.isUndefined(catalogCode) ? catalogFactory.getActiveCatalog().CatalogCode : catalogCode;
							promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/trees/'+ catalogTreeId + '/treenodes', undefined, true, generalProperties.forceFetch);
					}

					promise.then(function() {
							if (api.catalogs.treeNodes.isDirty) {
									//Invalidate lookupData
									api.catalogs.treeNodes.lookupData = undefined;
									api.catalogs.treeNodes.isDirty = false;
							}
					});
					return promise;
			}

				function updateSortOrder(record, activeCatalogCode, currentTreeNodeProperties, catalogTreeId) {
						api.catalogs.treeNodes.isDirty = true;
						//update currentTree nodes sort order according to updated sort order.
						var records = transformDataToRequiredForm(record, currentTreeNodeProperties);

						var itemNameList = [];
						angular.forEach(records, function(record) {
								itemNameList.push(record.AttributeDisplayName);
						});
						var state = {};
						state.name = $state.current.name;
						state.params = $state.params;
						var logData = activityLogger.createLogData(itemNameList, state, 'catalogs.treeNodes', 'ADD', false, new Date(), null, null);
						var promise = api.webPost(api.baseUrl + '/catalogs/' + activeCatalogCode + '/trees/' + catalogTreeId + '/treenodes', records);

						promise.then(function() {
								api.catalogs.treeNodes.isDirty = true;
						});
						return activityLogger.log(logData, promise);
				}

				/**
				 * 
				 * @param {*} record : current record
				 * @param {*} currentTreeNodeProperties : existing node properties
				 * this method will update the sort order of node to updated sort order
				 */
				function transformDataToRequiredForm(record, currentTreeNodeProperties) {
						var result = [];
						var path = record.Path.replace(/\\/g, ',')
						var sameLevelNodes = treeFactory.getSameLevelNodes(record, currentTreeNodeProperties);
						var moveUp = false;
						var moveDown = false;
						var previousSortOrder = 0;

						var node = utility.filterObject(sameLevelNodes, { TreeNode: path })[0];

						if(record.SortOrder < node.SortOrder) {
							moveUp = true;
							previousSortOrder = node.SortOrder;
						} else {
							moveDown = true;
							previousSortOrder = record.SortOrder;
						}
						node.SortOrder = record.SortOrder;

						angular.forEach(sameLevelNodes, function(node) {
								if(path !== node.TreeNode) {
										if(moveUp && node.SortOrder < previousSortOrder && node.SortOrder >= record.SortOrder) {
											node.SortOrder += 1;
										} else if(moveDown && node.SortOrder <= previousSortOrder){
											node.SortOrder -= 1;
										}
								}
						});

						for (var i=0; i< currentTreeNodeProperties.length; i++) {
								result.push({
										TreeNode: currentTreeNodeProperties[i].TreeNode,
										SortOrder: currentTreeNodeProperties[i].SortOrder
								});
						}
						return result;
				}
		}
})();
(function() {
    'use strict';

    angular
        .module('app.main.catalogs.tree')
        .run(runBlock);

    /* @ngInject */
    function runBlock(api, activityLogger, $state, catalogFactory) {

        if (angular.isUndefined(api.catalogs)) {
            api.catalogs = {};
        }
         api.catalogs.treeNodes = {
            modelPath: 'catalogs.treeNodes',
            fields: [
                { field: 'Name', type: 'text', displayLabel: 'CATALOG_TREE.FIELDS.NAME', visible: true, creatable: false, editable: false, inputType: 'text' },
                { field: 'totalArticles', type: 'int', displayLabel: 'CATALOG_TREE.FIELDS.TOTAL_ARTICLES', visible: true, creatable: false, editable: false, inputType: 'number' },
                { field: 'sortOrder', type: 'int', displayLabel: 'CATALOG_TREE.FIELDS.SORT_ORDER', visible: false, creatable: false, editable: false, inputType: 'number' }
            ],
            uniqueConstraints: [],
            title: 'CATALOG_TREE.NAV',
            icon: 'icon-sitemap',
            idField: '',
            lookupDisplayField: 'Name',
            isDirty: false,
            isCatalogSpecificModel: true,
            methods: {
                getList   :   getTreeNodes,
                create    :   createTreeNodes
            },
            views: {
                mainList: {
                    columns         : ['Name', 'totalArticles'],
                    columnFilter    : {},
                    topIndex        : 0,
                    showFilterRow   : false,
                    sortColumn      : {'sortOrder': false},
                    itemActions     : [],
                    listActions     : [
                                        {id: 'save', label: 'ACTIONS.SAVE', icon: 'icon-content-save', privilege: 'CreateCatalogTreeNodes:true', visible: true, disabled: true}
                                      ],
                    fabAction           : {}
                 },
                 mainDetails: {},
                 privileges: {
                    list    : 'GetCatalogTreeNodes'
                }
            }
        };

        function getTreeNodes(generalProperties, catalogCode, catalogTreeId) {
            var promise;

            if(angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
                var state = {};
                state.name = $state.current.name;
                state.params = $state.params;
                var isBulk = true;
                var logData = activityLogger.createLogData(null, state, 'catalogs.treeNodes', 'VIEW', isBulk, new Date(), null, null);

                promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/trees/'+ catalogTreeId + '/treenodes', undefined, true, generalProperties.forceFetch);
                promise = activityLogger.log(logData, promise);
            }
            else {
                catalogCode = angular.isUndefined(catalogCode) ? catalogFactory.getActiveCatalog().CatalogCode : catalogCode;
                promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/trees/'+ catalogTreeId + '/treenodes', undefined, true, generalProperties.forceFetch);
            }

            promise.then(function() {
                if (api.catalogs.treeNodes.isDirty) {
                    //Invalidate lookupData
                    api.catalogs.treeNodes.lookupData = undefined;
                    api.catalogs.treeNodes.isDirty = false;
                }
            });
            return promise;
		}

        function createTreeNodes(catalogCode, records, catalogTreeId) {
            api.catalogs.treeNodes.isDirty = true;
            var itemNameList = [];
            angular.forEach(records, function(record) {
                itemNameList.push(record.AttributeDisplayName);
            });
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var logData = activityLogger.createLogData(itemNameList, state, 'catalogs.treeNodes', 'ADD', false, new Date(), null, null);
            var promise = api.webPost(api.baseUrl + '/catalogs/' + catalogCode + '/trees/'+ catalogTreeId + '/treenodes', records);

            promise.then(function() {
                api.catalogs.treeNodes.isDirty = true;
            });
            return activityLogger.log(logData, promise);
        }

    }
})();
(function() {
  'use strict';

  angular
		.module('app.main.catalogs.targets')
		.run(runBlock);

  /* @ngInject */
  function runBlock(api, activityLogger, $state, catalogFactory, crud, jobsTracker, CONSTANTS) {

		if (angular.isUndefined(api.catalogs)) {
				api.catalogs = {};
		}
		api.catalogs.targets = {
			modelPath: 'catalogs.targets',
			fields: [
				{ field: 'Id',  type: 'int', displayLabel: 'TARGETS.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
						validation: {isRequired: false, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'Attributes',  type: 'text', displayLabel: 'TARGETS.FIELDS.TARGETED_ATTRIBUTES', visible: true, creatable: false, editable: false, inputType: 'target-attributes-json-str',
						validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'SkuTargets', type: 'int', displayLabel: 'TARGETS.FIELDS.SKU_TARGETS', visible: true, creatable: true, editable: true, inputType: 'number',
						validation: {isRequired: false, maxLen: -1, minLen: 1, pattern: '[0-9]\d*', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'ModelTargets', type: 'int', displayLabel: 'TARGETS.FIELDS.MODEL_TARGETS', visible: true, creatable: true, editable: true, inputType: 'number',
						validation: {isRequired: false, maxLen: -1, minLen: 1, pattern: '[0-9]\d*', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'AggregateAttributes',  type: 'text', displayLabel: 'TARGETS.FIELDS.AGGREGATE_ATTRIBUTES', visible: true, creatable: false, editable: false, inputType: 'target-attributes-json-str',
						validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'Status', type: 'text', displayLabel: 'TARGETS.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
						validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'CreatedDate', type: 'text', displayLabel: 'TARGETS.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
						validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'UpdatedDate', type: 'text', displayLabel: 'TARGETS.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
						validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'CreatedBy', type: 'text', displayLabel: 'TARGETS.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
						validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'UpdatedBy', type: 'text', displayLabel: 'TARGETS.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
						validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
			],
			uniqueConstraints: [
				{ name: 'Constraint 1', fields: [] },
				{ name: 'Constraint 2', fields: [] }
			],
			atLeastOneRequiredConstraints: [
				{ name: 'Constraint 1', fields: [] },
				{ name: 'Constraint 2', fields: [] }
			],
			title: 'TARGETS.NAV',
			icon: 'icon-album',
			idField: 'Id',
			lookupDisplayField: undefined,
			isDirty: false,
			isBulkActionCompleted: false,
			isCatalogSpecificModel: true,
			methods: {
				getList     : getTargetsList,
				create      : createTarget,
				update      : updateTarget,
				activate    : activateTarget,
				import			: createBulk,
				getReports  : getReports,
				copyTargets : copyTargets
			},
			views: {
				mainList: {
					columns         	: [ 'Attributes', 'SkuTargets', 'ModelTargets', 'AggregateAttributes', 'Status', 'UpdatedDate' ],
					columnFilter    	: {},
					toggleFilterProps	: { toggleStatus:false, filterProp:'Status', trueVal:1, trueValTooltipMessage: 'ACTIONS.TOGGLE_ACTIVE', falseVal:'', falseValTooltipMessage:"ACTIONS.TOGGLE_ALL"},
					topIndex        	: 0,
					showFilterRow   	: false,
					sortColumn      	: {'UpdatedDate': false},
					sortDescending  	: true,
					itemActions     	: [
																{ id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UpdateTarget:true', disabled: false, visible: true },
																{ id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateTargetStatusBulk:true', disabled: false, visible: 'itm.Status',
																		requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
																{ id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateTargetStatusBulk:true', disabled: false, visible: '!itm.Status',
																		requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
																],
					listActions     	: [
																{ id: 'delete', label: 'ACTIONS.DELETE_BULK', icon: 'icon-delete', privilege: 'UpdateTargetStatusBulk:true', disabled: '{selected: true, Status: 1}', visible: true,
																		requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
																{ id: 'activate', label: 'ACTIONS.ACTIVATE_BULK', icon: 'icon-undo-variant', privilege: 'UpdateTargetStatusBulk:true', disabled: '{selected: true, Status: 0}', visible: true,
																		requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'},
																{ id: 'import', label: 'ACTIONS.IMPORT', icon: 'icon-import', privilege: 'CreateUpdateBulkTarget:true', disabled: false, visible: true, requiresConfirmation: false},
															],
					fabAction       	: {id: 'add', label: 'ACTIONS.ADD', icon: 'icon-plus', privilege: 'CreateTarget:true', visible: true}
				},
				mainDetails: {},
				privileges: {
					list    					: 'GetTargetList'
				}
      }
		};


		function getTargetsList(generalProperties, model, catalogCode) {
			if (angular.isDefined(model)) {
				model.isBulkActionCompleted = false;
			}
			var promise;
			var state = {};
      catalogCode = angular.isUndefined(catalogCode) ? catalogFactory.getActiveCatalog().CatalogCode : catalogCode;
      state.name = $state.current.name;
      state.params = $state.params;
      var isBulk = true;
      var logData = activityLogger.createLogData(null, state, 'catalogs.targets', 'VIEW', isBulk, new Date(), null, null);
      promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/targets', undefined, true, generalProperties.forceFetch);
      promise = activityLogger.log(logData, promise);

      promise.then(function () {
        if (api.catalogs.targets.isDirty) {
          //Invalidate lookupData
          api.catalogs.targets.lookupData = undefined;
          api.catalogs.targets.isDirty = false;
        }
      });
      return promise;
    }

    function createTarget(record, catalogCode) {
      var state = {};
      state.name = $state.current.name;
      state.params = $state.params;
      var logData = activityLogger.createLogData(record[api.catalogs.targets.lookupDisplayField], state, 'catalogs.targets', 'ADD', false, new Date(), null, null);
      var promise = api.webPost(api.baseUrl + '/catalogs/' + catalogCode + '/targets', record);

      promise.then(function () {
        api.catalogs.targets.isDirty = true;
      });
      return activityLogger.log(logData, promise);
    }

    function updateTarget(record, catalogCode, targetId) {
      var state = {};
      state.name = $state.current.name;
      state.params = $state.params;
      var logData = activityLogger.createLogData(record[api.catalogs.targets.lookupDisplayField], state, 'catalogs.targets', 'EDIT', false, new Date(), null, null);
      var promise = api.webPut(api.baseUrl + '/catalogs/' + catalogCode + '/targets/' + targetId, record);

      promise.then(function () {
        api.catalogs.targets.isDirty = true;
      });
      return activityLogger.log(logData, promise);
    }

    function activateTarget(records, model, actionType, catalogCode) {
        var result = crud.createRequestObject(records, model, actionType);
        var state = {};
        state.name = $state.current.name;
        state.params = $state.params;
        var isBulk = result.itemsNameList.length > 1 ? true : false;
        var logData = activityLogger.createLogData(result.itemsNameList, state, 'catalogs.targets', actionType.toUpperCase(), isBulk, new Date(), null, null);
        var promise = api.webPut(api.baseUrl + '/catalogs/' + catalogCode + '/targets/status', result.requestObj);

        promise.then(function() {
            crud.onRecordStatusChange(records, api.catalogs.targets, actionType);
        });
        return activityLogger.log(logData, promise);
    }

    function createBulk(model, data, catalogCode, targetedAttributes, aggregateAttributes) {
			var jobIndex = jobsTracker.addJob(model, 'ACTIONS.SAVE', 1);
			angular.forEach(data, function(d) {
				var attributeValues = {}
				var aggregateAttributeValues = {}
				angular.forEach(targetedAttributes, function(targetedAttribute) {
					if(angular.isDefined(d[targetedAttribute.AttributeSystemName]) &&
						d[targetedAttribute.AttributeSystemName] !== null &&
						d[targetedAttribute.AttributeSystemName].toString().trim() !== '') {
							attributeValues[targetedAttribute.AttributeId] = d[targetedAttribute.AttributeSystemName];
						}
					delete d[targetedAttribute.AttributeSystemName];
				});
				angular.forEach(aggregateAttributes, function(aggregateAttribute) {
					if(angular.isDefined(d[aggregateAttribute.AttributeSystemName]) &&
						d[aggregateAttribute.AttributeSystemName] !== null &&
						d[aggregateAttribute.AttributeSystemName].toString().trim() !== '') {
							aggregateAttributeValues[aggregateAttribute.AttributeId] = parseInt(d[aggregateAttribute.AttributeSystemName]);
						}
					delete d[aggregateAttribute.AttributeSystemName];
				});
				d.Attributes = angular.toJson(attributeValues);
				d.AggregateAttributes = angular.toJson(aggregateAttributeValues);
			});
			api.webPut(api.baseUrl + '/catalogs/' + catalogCode + '/targets?sourceapplication=' + CONSTANTS.SOURCE_APPLICATION + '&sourceaction=Import Targets', data).then(function (response) {
					jobsTracker.trackJob(jobIndex, response.data.Id);
			}).catch(function (error) {
					jobsTracker.setCriticlaFail(jobIndex, error);
			});
		}

		function getReports(generalProperties, catalogCode) {
			var promise;
			var state = {};
			catalogCode = angular.isUndefined(catalogCode) ? catalogFactory.getActiveCatalog().CatalogCode : catalogCode;
			state.name = $state.current.name;
			state.params = $state.params;
			var isBulk = true;
			var logData = activityLogger.createLogData(null, state, 'catalogs.targets', 'VIEW', isBulk, new Date(), null, null);
			promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/targets/reports', undefined, false, generalProperties.forceFetch);
			promise = activityLogger.log(logData, promise);

			promise.then(function () {
				if (api.catalogs.targets.isDirty) {
					api.catalogs.targets.isDirty = false;
				}
			});
			return promise;
		}


		function copyTargets(targetCatalog, catalogCode) {
			var state = {};
			state.name = $state.current.name;
			state.params = $state.params;
			var logData = activityLogger.createLogData(null, state, 'catalogs.targets', 'EDIT', false, new Date(), null, null);
			var promise = api.webPut(api.baseUrl + '/catalogs/' + catalogCode + '/targets/copy', targetCatalog);

			promise.then(function() {
				api.catalogs.targets.isDirty = true;
			});
			return activityLogger.log(logData, promise);
		}

	}
})();
(function() {
	'use strict';

	angular
			.module('app.main.catalogs.stock-linear')
			.run(runBlock);

	/* @ngInject */
	function runBlock(api, activityLogger, $state, catalogFactory, jobsTracker, CONSTANTS) {

			if (angular.isUndefined(api.catalogs)) {
					api.catalogs = {};
			}
			api.catalogs.stockLinear = {
				modelPath: 'catalogs.stockLinear',
				fields: [
					  { field: 'ArticleId', map:'Id', type: 'int', displayLabel: 'STOCK_LINEAR.FIELDS.ARTICLE_ID', visible: true, creatable: false, editable: false, inputType: 'number',
                validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
						{ field: 'ArticleNumber', type: 'text', displayLabel: 'STOCK_LINEAR.FIELDS.ARTICLE_NUMBER', visible: true, creatable: true, editable: true, inputType: 'text',
								validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
						{ field: 'ArticleName', type: 'text', displayLabel: 'ARTICLES.FIELDS.MODEL_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
								validation: {isRequired: false , maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
						{ field: 'SizeName', type: 'text', displayLabel: 'STOCK_LINEAR.FIELDS.SIZE_NAME', visible: true, creatable: true, editable: true, inputType: 'text',
								validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
						{ field: 'StockDefinitionId', type: 'int', displayLabel: 'STOCK_LINEAR.FIELDS.STOCK_DEFINITION_ID', visible: false, creatable: false, editable: false, inputType: 'number',
								validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
						{ field: 'StockCode', type: 'text', displayLabel: 'STOCK_LINEAR.FIELDS.STOCK_CODE', visible: true, creatable: true, editable: false, inputType: 'text',
								validation: {isRequired: true, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
						{ field: 'Actual', type: 'int', displayLabel: 'STOCK_LINEAR.FIELDS.ACTUAL', visible: true, creatable: true, editable: false, inputType: 'number',
								validation: {isRequired: true, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
						{ field: 'Reserved', type: 'int', displayLabel: 'STOCK_LINEAR.FIELDS.RESERVED', visible: true, creatable: false, editable: false, inputType: 'number',
								validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
						{ field: 'CreatedDate', type: 'text', displayLabel: 'STOCK_LINEAR.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
								validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
						{ field: 'UpdatedDate', type: 'text', displayLabel: 'STOCK_LINEAR.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
								validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
						{ field: 'CreatedBy', type: 'text', displayLabel: 'STOCK_LINEAR.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
								validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
						{ field: 'UpdatedBy', type: 'text', displayLabel: 'STOCK_LINEAR.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
								validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
						{ field: 'Status', type: 'text', displayLabel: 'STOCK_LINEAR.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
								validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
						{ field: 'StockName', type: 'text', displayLabel: 'STOCK_LINEAR.FIELDS.STOCK_NAME', visible: true, creatable: false, editable: true, inputType: 'text',
								validation: {isRequired: false, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
				],
				title: 'STOCK_LINEAR.NAV',
				icon: 'icon-cube-unfolded',
				idField: 'StockId',
				lookupDisplayField: 'StockCode',
				isDirty: false,
				isBulkActionCompleted: false,
				isCatalogSpecificModel: true,
				methods: {
						getList     : getStockList,
						createBulk  : createBulk
				},
				views: {
						mainList: {
								columns         : ['ArticleId', 'ArticleNumber', 'SizeName', 'StockCode', 'Actual', 'UpdatedBy', 'UpdatedDate'],
								columnFilter    : {},
								topIndex        : 0,
								showFilterRow   : false,
								sortColumn      : {'UpdatedDate': false},
								itemActions     : [],
								listActions     : [
																		{ id: 'import', label: 'ACTIONS.IMPORT', icon: 'icon-import', privilege: 'BulkImportStock:true', disabled: false, visible: true, requiresConfirmation: false }
																	],
								fabAction       : {}
							},
							mainDetails: {},
						privileges: {
								list    : 'GetStockList'
						}
				}
		};


		function getStockList(generalProperties, model, catalogId) {
			if (angular.isDefined(model)) { // to skip this part for load lookup
				model.isBulkActionCompleted = false;
			}
			var promise;

			if (angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
				var state = {};
				state.name = $state.current.name;
				state.params = $state.params;
				var isBulk = true;
				var logData = activityLogger.createLogData(null, state, 'catalogs.stock', 'VIEW', isBulk, new Date(), null, null);

				promise = api.webGet(api.baseUrl + '/catalogs/' + catalogId + '/stocks',
					generalProperties.config || {}, true, generalProperties.forceFetch,
					generalProperties.supportIncrementalResult || true,
					generalProperties.modelIdField,
					generalProperties.isMajor || false,
					model || api.catalogs.stockLinear);

				promise = activityLogger.log(logData, promise);
			}
			else {
				catalogId = angular.isUndefined(catalogId) ? catalogFactory.getActiveCatalog().CatalogCode : catalogId;
				promise = api.webGet(api.baseUrl + '/catalogs/' + catalogId + '/stocks',
					generalProperties.config || {}, true, generalProperties.forceFetch,
					generalProperties.supportIncrementalResult || true,
					generalProperties.modelIdField,
					generalProperties.isMajor || false,
					model || api.catalogs.stockLinear);
			}

			promise.then(function () {
				if (api.catalogs.stockLinear.isDirty) {
					//Invalidate lookupData
					api.catalogs.stockLinear.lookupData = undefined;
					api.catalogs.stockLinear.isDirty = false;
				}
			});
			return promise;
		}

		function createBulk(dataImporterResult, activeCatalog, model) {
			var data = dataImporterResult.data;
			var secondaryModel = api.catalogs.stock; // when stocks updated from linear module make tabular module model dirty
			var jobIndex = jobsTracker.addJob(model, 'STOCK_LINEAR.ACTIONS.IMPORT_STOCK', 1, secondaryModel);

			var transformedData = [];
			var nameIndexes = {};
			for (var i = 0; i < data.length; i++) {
				var ind = -1;
				if (angular.isUndefined(nameIndexes[data[i].ArticleNumber.toUpperCase()+data[i].SizeName.toUpperCase()])) {
					var requestObj = { 'ArticleNumber': data[i].ArticleNumber, 'SizeName': data[i].SizeName, 'ArticleSizeStocks': [] };
					ind = transformedData.length;
					nameIndexes[data[i].ArticleNumber.toUpperCase()+data[i].SizeName.toUpperCase()] = ind;
					transformedData.push(requestObj);
				} else {
					ind = nameIndexes[data[i].ArticleNumber.toUpperCase()+data[i].SizeName.toUpperCase()];
				}
				if (data[i].StockCode && (angular.isDefined(data[i].Actual))) {
					transformedData[ind].ArticleSizeStocks.push({ StockCode: data[i]['StockCode'], Actual: data[i]['Actual'] });
				}
			}
			nameIndexes = undefined;

			api.webPut(api.baseUrl + '/catalogs/' + activeCatalog.CatalogCode + '/bulkstocks?sourceapplication=' + CONSTANTS.SOURCE_APPLICATION + '&sourceaction=Import Stocks', transformedData)
				.then(function (response) {
					jobsTracker.trackJob(jobIndex, response.data.Id);
				}).catch(function (error) {
					jobsTracker.setCriticlaFail(jobIndex, error);
				});
		}

	}
})();
(function() {
	'use strict';

	angular
			.module('app.main.catalogs.stock')
			.run(runBlock);

	/* @ngInject */
	function runBlock(api, activityLogger, $state, catalogFactory, jobsTracker, CONSTANTS) {

			if (angular.isUndefined(api.catalogs)) {
					api.catalogs = {};
			}
			api.catalogs.stock = {
				modelPath: 'catalogs.stock',
				fields: [
						{ field: 'ArticleNumber', map: 'ArticleNumber', type: 'text', displayLabel: 'STOCK.FIELDS.ARTICLE_NUMBER', visible: true, creatable: true, editable: true, inputType: 'text',
								validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
						{ field: 'ArticleName', map: 'ArticleName', type: 'text', displayLabel: 'ARTICLES.FIELDS.MODEL_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
								validation: {isRequired: false , maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
						{ field: 'SizeName',map: 'SizeName', type: 'text', displayLabel: 'STOCK.FIELDS.SIZE_NAME', visible: true, creatable: true, editable: true, inputType: 'text',
								validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
						{ field: 'StockDefinitionId', map:'Stocks.StockDefinitionId',type: 'int', displayLabel: 'STOCK.FIELDS.STOCK_DEFINITION_ID', visible: false, creatable: false, editable: false, inputType: 'number',
								validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
						{ field: 'StockCode', map:'Stocks.StockCode', type: 'text', displayLabel: 'STOCK.FIELDS.STOCK_CODE', visible: false, creatable: false, editable: false, inputType: 'text',
								validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
						{ field: 'Actual', map: 'Stocks.Actual', type: 'int', displayLabel: 'STOCK.FIELDS.ACTUAL', visible: false, creatable: false, editable: false, inputType: 'number',
								validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
						{ field: 'Reserved', map: 'Stocks.Reserved', type: 'int', displayLabel: 'STOCK.FIELDS.RESERVED', visible: false, creatable: false, editable: false, inputType: 'number',
								validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
				],
				uniqueConstraints: [
						{name: 'Constraint 1', fields: ['ArticleNumber', 'SizeName']}
				],
				title: 'STOCK.NAV',
				icon: 'icon-cube-unfolded',
				idField: 'StockId',
				lookupDisplayField: 'StockCode',
				isDirty: false,
				isBulkActionCompleted: false,
				isCatalogSpecificModel: true,
				methods: {
						getList     : getStockList,
						createBulk  : createBulk,
						getCustomerAssignedStocks: getCustomerAssignedStocks
				},
				views: {
						mainList: {
								columns         : [ 'ArticleNumber', 'SizeName'],
								columnFilter    : {},
								topIndex        : 0,
								showFilterRow   : false,
								sortColumn      : {'ArticleNumber': true},
								itemActions     : [],
								listActions     : [
													{ id: 'import', label: 'ACTIONS.IMPORT', icon: 'icon-import', privilege: 'BulkImportStock:true', disabled: false, visible: true, requiresConfirmation: false }
												],
								fabAction       : {}
							},
							mainDetails: {},
						privileges: {
								list    : 'GetStockList'
						}
				}
		};


		function getStockList(generalProperties, model, catalogId) {
			if (angular.isDefined(model)) { // to skip this part for load lookup
				model.isBulkActionCompleted = false;
			}
			var promise;

			if (angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
				var state = {};
				state.name = $state.current.name;
				state.params = $state.params;
				var isBulk = true;
				var logData = activityLogger.createLogData(null, state, 'catalogs.stock', 'VIEW', isBulk, new Date(), null, null);

				promise = api.webGet(api.baseUrl + '/catalogs/' + catalogId + '/stocks',
					generalProperties.config || {}, true, generalProperties.forceFetch,
					generalProperties.supportIncrementalResult || true,
					generalProperties.modelIdField,
					generalProperties.isMajor || false,
					model || api.catalogs.stock, false, undefined, 'Stocks',
					generalProperties.nestedDataIdField || 'Id');

				promise = activityLogger.log(logData, promise);
			}
			else {
				catalogId = angular.isUndefined(catalogId) ? catalogFactory.getActiveCatalog().CatalogCode : catalogId;
				promise = api.webGet(api.baseUrl + '/catalogs/' + catalogId + '/stocks',
					generalProperties.config || {}, true, generalProperties.forceFetch,
					generalProperties.supportIncrementalResult || true,
					generalProperties.modelIdField,
					generalProperties.isMajor || false,
					model || api.catalogs.stock, false, undefined, 'Stocks',
					generalProperties.nestedDataIdField || 'Id');
			}

			promise.then(function () {
				if (api.catalogs.stock.isDirty) {
					//Invalidate lookupData
					api.catalogs.stock.lookupData = undefined;
					api.catalogs.stock.isDirty = false;
				}
			});
			return promise;
		}

		function createBulk(dataImporterResult, activeCatalog, model) { //to do along with API
			var data = dataImporterResult.data;
			var result = [];
			var stockIndexes = {};
			var secondaryModel = api.catalogs.stockLinear; // when stocks updated from tabular module make linear module model dirty
			var jobIndex = jobsTracker.addJob(model, 'STOCK.ACTIONS.IMPORT_STOCK', 1, secondaryModel);
			for (var i = 0; i < data.length; i++) {
				var ind = -1;
				ind = result.length;
				var dataKey;
				var articleSizeStocks = [];
				for (dataKey in data[i]) {
					if (data[i].hasOwnProperty(dataKey) && dataKey != "ArticleNumber" && dataKey != "SizeName") {
						articleSizeStocks.push({ StockCode: dataKey, Actual: data[i][dataKey] });
					}
				}
				stockIndexes[data[i].ArticleNumber] = ind;
				result.push({ ArticleNumber: data[i].ArticleNumber, SizeName: data[i].SizeName, ArticleSizeStocks: [] });
				result[ind].ArticleSizeStocks = articleSizeStocks;
			}
			api.webPut(api.baseUrl + '/catalogs/' + activeCatalog.CatalogCode + '/bulkstocks?sourceapplication=' + CONSTANTS.SOURCE_APPLICATION + '&sourceaction=Import Stocks', result)
				.then(function (response) {
					jobsTracker.trackJob(jobIndex, response.data.Id);
				}).catch(function (error) {
					jobsTracker.setCriticlaFail(jobIndex, error);
				});
		}

		function getCustomerAssignedStocks(generalProperties, catalogCode, customerId, articleId) {
			var promise;
			var url = api.baseUrl + '/catalogs/' + catalogCode + '/stocks?customerId=' + customerId;
			if(angular.isDefined(articleId)) {
					url = url + '&articleId=' + articleId;
			}

			if(angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
					var state = {};
					state.name = $state.current.name;
					state.params = $state.params;
					var isBulk = false;
					var logData = activityLogger.createLogData(null, state, 'catalogs.stock', 'VIEW', isBulk, new Date(), null, null);
					promise = api.webGet(url, undefined, true, generalProperties.forceFetch);
					promise = activityLogger.log(logData, promise);
			}
			else {
					promise = api.webGet(url, undefined, true, generalProperties.forceFetch);
			}
			return promise;
		}

	}
})();
(function() {
    'use strict';

    angular
        .module('app.main.catalogs.sizes')
        .run(runBlock);

    /* @ngInject */
    function runBlock(api, activityLogger, $state, $document, $filter, catalogFactory, utility, dialog, crud, jobsTracker, CONSTANTS) {

        if (angular.isUndefined(api.catalogs)) {
            api.catalogs = {};
        }
         api.catalogs.sizes = {
            modelPath: 'catalogs.sizes',
            fields: [
                { field: 'Id', map: 'Sizes.Id', type: 'int', displayLabel: 'SIZES.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ArticleId', map:'Id', type: 'int', displayLabel: 'SIZES.FIELDS.ARTICLE_ID', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ArticleNumber', map: 'ArticleNumber', type: 'text', displayLabel: 'SIZES.FIELDS.ARTICLE_NUMBER', visible: true, creatable: true, editable: false, inputType: 'text',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ModelNumber',  map: 'ModelNumber', type: 'text', displayLabel: 'SIZES.FIELDS.MODEL_NUMBER', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: { isRequired: false, maxLen: 200, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } } },
                { field: 'ArticleName', map: 'ArticleName', type: 'text', displayLabel: 'ARTICLES.FIELDS.MODEL_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'SizeIndex', map: 'Sizes.SizeIndex', type: 'text', displayLabel: 'SIZES.FIELDS.SIZE_INDEX', visible: true, creatable: true, editable: false, inputType: 'text',
                    validation: {isRequired: true, maxLen: 25, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'NewSizeIndex', map: 'Sizes.NewSizeIndex', type: 'text', displayLabel: 'SIZES.FIELDS.SIZE_INDEX', visible: false, creatable: false, editable: true, inputType: 'text',
                    validation: {isRequired: false, maxLen: 25, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'SizeName', map: 'Sizes.SizeName', type: 'text', displayLabel: 'SIZES.FIELDS.SIZE_NAME', visible: true, creatable: true, editable: false, inputType: 'text',
                    validation: {isRequired: true, maxLen: 50, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'NewSizeName', map: 'Sizes.NewSizeName', type: 'text', displayLabel: 'SIZES.FIELDS.SIZE_NAME', visible: false, creatable: false, editable: true, inputType: 'text',
                    validation: {isRequired: false, maxLen: 50, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Upc', map:'Sizes.Upc', type: 'text', displayLabel: 'SIZES.FIELDS.UPC', visible: true, creatable: true, editable: true, inputType: 'text',
                    validation: {isRequired: false, maxLen: 25, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Status', map:'Sizes.Status', type: 'text', displayLabel: 'SIZES.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'SortOrder', map: 'Sizes.SortOrder', type: 'int', displayLabel: 'SIZES.FIELDS.SORT_ORDER', visible: true, creatable: true, editable: true, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedDate', map: 'Sizes.CreatedDate', type: 'text', displayLabel: 'SIZES.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedDate', map: 'Sizes.UpdatedDate', type: 'text', displayLabel: 'SIZES.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Created_By', map: 'Sizes.Created_By', type: 'text', displayLabel: 'SIZES.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Updated_By', map: 'Sizes.Updated_By', type: 'text', displayLabel: 'SIZES.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
            ],
            uniqueConstraints: [
                {name: 'Constraint 1', fields: ['ArticleNumber', 'SizeIndex']},
                {name: 'Constraint 2', fields: ['ArticleNumber', 'SizeName']}
            ],
            title: 'SIZES.NAV',
            icon: 'icon-layers',
            idField: 'Id',
            lookupDisplayField: 'SizeName',
            isDirty: false,
            isBulkActionCompleted: false,
            isCatalogSpecificModel: true,
            methods: {
                getList     : getSizes,
                activateBulk: activateSizes,
                update      : updateSize,
                createBulk  : createBulk
            },
            views: {
                mainList: {
                    columns         : [ 'ArticleNumber', 'ModelNumber', 'SizeName', 'SizeIndex', 'SortOrder', 'Status', 'UpdatedDate' ],
                    columnFilter    : {},
                    toggleFilterProps: { toggleStatus:false, filterProp:'Status', trueVal:1, trueValTooltipMessage: 'ACTIONS.TOGGLE_ACTIVE', falseVal:'', falseValTooltipMessage:"ACTIONS.TOGGLE_ALL"},
                    topIndex        : 0,
                    showFilterRow   : false,
                    sortColumn      : {'UpdatedDate': false},
                    itemActions     : [
                                        { id: 'view', label: 'ACTIONS.VIEW', icon: 'icon-magnify', privilege: 'GetArticleSizes', disabled: '!itm.Status', visible: true },
                                        // Need API for edit single size
                                        { id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UpdateCatalogArticleSizes:true', disabled: '!itm.Status', visible: true },
                                        { id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateSizeStatusBulk:true', disabled: false, visible: 'itm.Status',
                                            requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                                        { id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateSizeStatusBulk:true', disabled: false, visible: '!itm.Status',
                                            requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
                                      ],
                    listActions     : [
                                        { id: 'delete', label: 'ACTIONS.DELETE_BULK', icon: 'icon-delete', privilege: 'UpdateSizeStatusBulk:true', disabled: '{selected: true, Status: 1}', visible: true,
                                            requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                                        { id: 'activate', label: 'ACTIONS.ACTIVATE_BULK', icon: 'icon-undo-variant', privilege: 'UpdateSizeStatusBulk:true', disabled: '{selected: true, Status: 0}', visible: true,
                                            requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'},
                                        { id: 'importSizes', label: 'SIZES.ACTIONS.IMPORT_SIZES', icon: 'icon-import', privilege: 'UI_ImportSizes:true', disabled: false, visible: true, requiresConfirmation: false },
                                        { id: 'importSizeIndexes', label: 'SIZES.ACTIONS.IMPORT_SIZE_INDEXES', icon: 'icon-import', privilege: 'UpdateCatalogArticleSizeIndexesBulk:true', disabled: false, visible: true, requiresConfirmation: false }
                                      ],
                    fabAction       : {}

                 },
                 mainDetails: {},
                privileges: {
                    list    : 'GetListArticleSizes'
                }
            }
        };

        // Not supported for lookup (getLookupData implementation need to be modified)
        function getSizes(generalProperties, model, catalogId) {
            if(angular.isDefined(model)) { // to skip this part for load lookup
                model.isBulkActionCompleted = false;
            }
            var promise;

            if(angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
                var state = {};
                state.name = $state.current.name;
                state.params = $state.params;
                var isBulk = true;
                var logData = activityLogger.createLogData(null, state, 'catalogs.sizes', 'VIEW', isBulk, new Date(), null, null);

                promise = api.webGet(api.baseUrl + '/catalogs/' + catalogId + '/articlesizes',
                                        generalProperties.config || {}, true, generalProperties.forceFetch,
                                        generalProperties.supportIncrementalResult || true,
                                        generalProperties.modelIdField,
                                        generalProperties.isMajor || false,
                                        api.catalogs.sizes, false, undefined, 'Sizes',
                                        generalProperties.nestedDataIdField || 'Id');
                promise = activityLogger.log(logData, promise);
            }
            else {
                catalogId = angular.isUndefined(catalogId) ? catalogFactory.getActiveCatalog().CatalogCode : catalogId;
                promise = api.webGet(api.baseUrl + '/catalogs/' + catalogId + '/articlesizes',
                                        generalProperties.config || {}, true, generalProperties.forceFetch,
                                        generalProperties.supportIncrementalResult || true,
                                        generalProperties.modelIdField,
                                        generalProperties.isMajor || false,
                                        api.catalogs.sizes, false, undefined, 'Sizes',
                                        generalProperties.nestedDataIdField || 'Id');
            }

            promise.then(function() {
                if (api.catalogs.sizes.isDirty) {
                    //Invalidate lookupData
                    api.catalogs.sizes.lookupData = undefined;
                    api.catalogs.sizes.isDirty = false;
                }
            });
            return promise;
		}

        function activateSizes(records, model, actionType, catalogCode, additionalInfo) {
            var requestBody = {
                Sizes: [],
            };
            var result = crud.createRequestObject(records, model, actionType);

            requestBody.Sizes = result.requestObj;

            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var isBulk = result.itemsNameList.length > 1 ? true : false;
            var logData = activityLogger.createLogData(result.itemsNameList, state, 'catalogs.sizes', actionType.toUpperCase(), isBulk, new Date(), null, null);
			var promise = api.webPut(api.baseUrl + '/catalogs/' + catalogCode + '/sizes/status', requestBody);

            promise.then(function(response) {
                if(response.status === 202) {
                    dialog.showAlertDialog(
                        angular.element($document.body),
                        $filter('translate')('MESSAGES.TITLE.ALERT'),
                        $filter('translate')('MESSAGES.CONTENT.CHANGE_REQUEST_ALERT'),
                        $filter('translate')('MESSAGES.TITLE.ALERT'),
                        $filter('translate')('ACTIONS.DIALOG_CLOSE'),
                        false,
                        null);
                }
                else {
                    crud.onRecordStatusChange(records, model, actionType);
                }
            });

            return activityLogger.log(logData, promise);
		}

        function updateSize(recordId, record, parentId) {
            var requestBody = {
                Sizes: []
            };
            // If there is no changes in SizeIndex or SizeName discard NewSizeIndex and NewSizeName since API is not accepting
            if(record.SizeIndex === record.NewSizeIndex){
                delete record.NewSizeIndex;
            }
            if(record.SizeName === record.NewSizeName){
                delete record.NewSizeName;
            }

            requestBody.Sizes = utility.pushItemToArray(record);

            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var logData = activityLogger.createLogData(record[api.catalogs.sizes.lookupDisplayField], state, 'catalogs.sizes', 'EDIT', false, new Date(), null, null);
			var promise = api.webPut(api.baseUrl + '/catalogs/' + parentId.activeCatalogId + '/articles/' + parentId.ArticleId + '/sizes', requestBody);

            promise.then(function() {
                // api.catalogs.articles.isDirty = true;
                api.catalogs.sizes.isDirty = true;
            });
            return activityLogger.log(logData, promise);
        }

        function createBulk(dataImporterResult, activeCatalog, model, actionType) {
            var requestBody = {
                ArticleSizes: []
            };
            var data = dataImporterResult.data;
            //Transform data into required format
            var transformedData = [];
            var articleIndexes = {};

            for(var i=0; i<data.length; i++) {
                var ind = -1;
                if (angular.isUndefined(articleIndexes[data[i].ArticleNumber])) {
                    ind = transformedData.length;
                    articleIndexes[data[i].ArticleNumber] = ind;
                    transformedData.push({ArticleNumber: data[i].ArticleNumber, Sizes: [] });
                } else {
                    ind = articleIndexes[data[i].ArticleNumber];
                }
                transformedData[ind].Sizes.push({ SizeIndex: data[i].SizeIndex, Size: data[i].SizeName, SortOrder: data[i].SortOrder, Upc: data[i].Upc});
            }

            articleIndexes = undefined;
            var jobIndex = -1,
                promise;
            requestBody.ArticleSizes = transformedData;

            if(actionType.toUpperCase() === 'IMPORTSIZES') {
                jobIndex = jobsTracker.addJob(model, 'SIZES.ACTIONS.IMPORT_SIZES', 1);
                if(activeCatalog.IndependentSizes == 1) {
                    promise = api.webPut(api.baseUrl + '/catalogs/' + activeCatalog.CatalogCode + '/independentarticlesizes?sourceapplication=' + CONSTANTS.SOURCE_APPLICATION + '&sourceaction=Import Sizes', requestBody);
                }
                else {
                    promise = api.webPut(api.baseUrl + '/catalogs/' + activeCatalog.CatalogCode + '/articleSizes?sourceapplication=' + CONSTANTS.SOURCE_APPLICATION + '&sourceaction=Import Sizes', requestBody);
                }
            }
            else if(actionType.toUpperCase() === 'IMPORTSIZEINDEXES') {
                jobIndex = jobsTracker.addJob(model, 'SIZES.ACTIONS.IMPORT_SIZE_INDEXES', 1);
                if(activeCatalog.IndependentSizes == 1) {
                    promise = api.webPut(api.baseUrl + '/catalogs/' + activeCatalog.CatalogCode + '/independentarticlesizeindexes?sourceapplication=' + CONSTANTS.SOURCE_APPLICATION + '&sourceaction=Import Size Indexes', requestBody)
                }
                else {
                    promise = api.webPut(api.baseUrl + '/catalogs/' + activeCatalog.CatalogCode + '/articleSizeIndexes?sourceapplication=' + CONSTANTS.SOURCE_APPLICATION + '&sourceaction=Import Size Indexes', requestBody)
                }
            }
            promise.then(function(response) {
                jobsTracker.trackJob(jobIndex, response.data.Id);
            }).catch(function(error) {
                jobsTracker.setCriticlaFail(jobIndex, error);
            });
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.main.catalogs.size-curves')
        .run(runBlock);

    /* @ngInject */
    function runBlock(api, activityLogger, $state, crud, jobsTracker, catalogFactory) {

        if(angular.isUndefined(api.catalogs)) {
            api.catalogs = {};
        }
        api.catalogs.sizeCurves = {
            modelPath: 'catalogs.sizeCurves',
            fields: [
                { field: 'Id', type: 'int', displayLabel: 'SIZE_CURVES.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Name', type: 'text', displayLabel: 'SIZE_CURVES.FIELDS.NAME', visible: true, creatable: true, editable: false, inputType: 'text',
                    validation: {isRequired: true, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Sizes', type: 'text', displayLabel: 'SIZE_CURVES.FIELDS.SIZES', visible: true, creatable: false, editable: false, inputType: 'size-curve-size',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'AllocationType', type: 'text', displayLabel: 'SIZE_CURVES.FIELDS.ALLOCATION_TYPE', visible: true, creatable: true, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Level', type: 'text', displayLabel: 'SIZE_CURVES.FIELDS.LEVEL', visible: true, creatable: true, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CustomerCode', type: 'text', displayLabel: 'SIZE_CURVES.FIELDS.CUSTOMER_CODE', visible: true, creatable: true, editable: false, inputType: 'text', validateCusomerCode: true,
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Size', type: 'text', displayLabel: 'SIZE_CURVES.FIELDS.SIZE', visible: false, creatable: true, editable: false, inputType: 'text',
                    validation: {isRequired: true, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Quantity', type: 'int', displayLabel: 'SIZE_CURVES.FIELDS.QUANTITY', visible: false, creatable: true, editable: false, inputType: 'number',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '^[1-9][0-9]*$', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: 'Quantity must be non-negative integer'}} },
                { field: 'Status', type: 'text', displayLabel: 'SIZE_CURVES.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Criteria', type: 'text', displayLabel: 'SIZE_CURVES.FIELDS.CRITERIA', visible: true, creatable: false, editable: false, inputType: 'textArea',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedDate', type: 'text', displayLabel: 'STOCK_DEFINITION.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedDate', type: 'text', displayLabel: 'STOCK_DEFINITION.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedBy', type: 'text', displayLabel: 'STOCK_DEFINITION.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup', lookupSource:'accounts.users',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedBy', type: 'text', displayLabel: 'STOCK_DEFINITION.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup', lookupSource:'accounts.users',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
            ],
            uniqueConstraints: [
                {name: 'Constraint 1', fields: ['Name', 'Size']}
            ],
            validateTotalPercentage: true,
            title: 'SIZE_CURVES.NAV',
            icon: 'icon-layers',
            idField: 'Id',
            lookupDisplayField: 'Name',
            isDirty: false,
            methods: {
                getList     :   getSizeCurves,
                create      :   createSizeCurves,
                update      :   updateSizeCurves,
                activateBulk:   activateBulk,
                createBulk  :   createBulk
            },
            views: {
                mainList: {
                    columns             : [ 'Id', 'Name', 'Sizes', 'AllocationType', 'Level', 'CustomerCode', 'Criteria', 'Status', 'UpdatedBy', 'UpdatedDate'],
                    columnFilter        : {},
                    toggleFilterProps   : {},
                    topIndex            : 0,
                    showFilterRow       : false,
                    sortColumn          : {'UpdatedDate': false},
                    itemActions         : [
                        { id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UpdateSizeCurve', disabled: '!itm.Status', visible: true },
                        { id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateSizeCurveStatus', disabled: false, visible: 'itm.Status',
                            requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                        { id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateSizeCurveStatus', disabled: false, visible: '!itm.Status',
                            requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
                    ],
                    listActions         : [
                        { id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateSizeCurveStatus', disabled: '{selected: true, Status: 1}',
                            visible: true, requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                        { id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateSizeCurveStatus', disabled: '{selected: true, Status: 0}',
                            visible: true, requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'},
                        { id: 'import', label: 'ACTIONS.IMPORT', icon: 'icon-import', privilege: 'ImportSizeCurve', disabled: false, visible: true, requiresConfirmation: false},
                        { id: 'export', label: 'SIZE_CURVES.ACTIONS.EXPORT_SIZECURVES', icon: 'icon-export', privilege: 'GetSizeCurves', visible: true }
                    ],
                    fabAction           : {id: 'add', label: 'ACTIONS.ADD', icon: 'icon-plus', privilege: 'CreateSizeCurve', visible: true}
                },
                mainDetails: {},
                privileges: {
                    list: 'GetSizeCurves',
                }
            }
        };

        function getSizeCurves(generalProperties, catalogCode, model) {
            if (angular.isDefined(model)) {
                model.isBulkActionCompleted = false;
            }
            var promise;
            if(angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
                var state = {};
                state.name = $state.current.name;
                state.params = $state.params;
                var isBulk = true;
                var logData = activityLogger.createLogData(null, state, 'catalogs.sizeCurves', 'VIEW', isBulk, new Date(), null, null);
                promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/sizecurves', undefined, true, generalProperties.forceFetch);
                promise = activityLogger.log(logData, promise);
            }
            else {
                catalogCode = angular.isDefined(catalogCode) ? catalogCode : catalogFactory.getActiveCatalog().CatalogCode;
                promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/sizecurves', undefined, true, generalProperties.forceFetch);
            }
            return promise;
        }

        function createSizeCurves(record, catalogCode) {
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var logData = activityLogger.createLogData(record[api.catalogs.sizeCurves.lookupDisplayField], state, 'catalogs.sizeCurves', 'ADD', false, new Date(), null, null);
            var promise = api.webPost(api.baseUrl + '/catalogs/' + catalogCode + '/sizecurves', record);

            promise.then(function () {
              api.catalogs.sizeCurves.isDirty = true;
            });
            return activityLogger.log(logData, promise);
        }

        function updateSizeCurves(recordId, record, catalogCode) {
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var logData = activityLogger.createLogData(record[api.catalogs.sizeCurves.lookupDisplayField], state, 'catalogs.sizeCurves', 'EDIT', false, new Date(), null, null);
            var promise = api.webPut(api.baseUrl + '/catalogs/' + catalogCode + '/sizecurves/' + recordId, record);

            promise.then(function () {
                api.catalogs.sizeCurves.isDirty = true;
            });
            return activityLogger.log(logData, promise);
        }

        function activateBulk(records, model, actionType, catalogCode) {
            var result = crud.createRequestObject(records, model, actionType);
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var isBulk = result.itemsNameList.length > 1 ? true : false;
            var logData = activityLogger.createLogData(result.itemsNameList, state, 'catalogs.sizeCurves', actionType.toUpperCase(), isBulk, new Date(), null, null);
            var promise = api.webPut(api.baseUrl + '/catalogs/'+ catalogCode +'/sizecurves/status', result.requestObj);

            promise.then(function() {
                api.catalogs.sizeCurves.isDirty = true;
                crud.onRecordStatusChange(records, model, actionType);
            });

            return activityLogger.log(logData, promise);
        }

        function createBulk(model, data, catalogCode, isSizeCurveByCriteria, sizeCurveCriteriaAttributes) {
            // transform data into required format
            // as the data is going to be repeated we will take Name and Criteria from the first row.
            var transformedData = [];
            var nameIndexes = {};
            var itemsNameList = [];
            for (var i = 0; i < data.length; i++) {
                var ind = -1;
                if (angular.isUndefined(nameIndexes[data[i].Name.toUpperCase()])) {
                    var requestObj = {
                        Name: data[i].Name,
                        Sizes: [],
                        AllocationType: angular.isDefined(data[i].AllocationType) && data[i].AllocationType !== '' ? data[i].AllocationType : 'Quantity',
                        Level: angular.isDefined(data[i].Level) && data[i].Level !== '' ? data[i].Level : 'Catalog',
                    };
                    if(angular.isDefined(data[i].CustomerCode) && data[i].CustomerCode !== '') {
                        requestObj['CustomerCode'] = data[i].CustomerCode;
                    }
                    if (!isSizeCurveByCriteria) {
                        // create criteria
                        if(sizeCurveCriteriaAttributes.length) {
                            var criteriaObject = {};
                            angular.forEach(sizeCurveCriteriaAttributes, function(attributeSystemName) {
                                if(angular.isDefined(data[i][attributeSystemName]) && data[i][attributeSystemName] !== '') {
                                    criteriaObject[attributeSystemName] = data[i][attributeSystemName].split(',');
                                }
                            })
                            requestObj['Criteria'] = angular.toJson(criteriaObject)
                        }
                    }
                    else {
                        if(data[i].Criteria) {
                            requestObj['Criteria'] = data[i].Criteria;
                        }
                    }

                    ind = transformedData.length;
                    nameIndexes[data[i].Name.toUpperCase()] = ind;
                    transformedData.push(requestObj);
                    itemsNameList.push(data[i].Name);
                } else {
                    ind = nameIndexes[data[i].Name.toUpperCase()];
                }
                if (data[i].Size && data[i].Quantity) {
                    var size = {
                        Size: data[i].Size,
                        Quantity: data[i].Quantity,
                    }
                    transformedData[ind].Sizes.push(size);
                }
            }
            nameIndexes = undefined;
            var jobIndex = jobsTracker.addJob(model, 'SIZE_CURVES.ACTIONS.IMPORT_SIZE_CURVES', 1);
            api.webPut(api.baseUrl + '/catalogs/'+ catalogCode +'/bulksizecurves', transformedData).then(function(response) {
                jobsTracker.trackJob(jobIndex, response.data.Id);
            }).catch(function(error) {
                jobsTracker.setCriticlaFail(jobIndex, error);
            });
        }

    }
})();
(function () {
	'use strict';

	angular
		.module('app.main.catalogs.shared-folders-tree')
		.run(runBlock);

	/* @ngInject */
	function runBlock(api, activityLogger, $state, crud, utility) {

		if (angular.isUndefined(api.catalogs)) {
			api.catalogs = {};
		}
		// NOTE: what ever changes we do in this module needs to be added to the shared folders tree module as well
		api.catalogs.sharedFoldersTree = {
			modelPath: 'catalogs.sharedFoldersTree',
			fields: [
				{ field: 'Id', type: 'int', displayLabel: 'SHARED_FOLDERS.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
					validation: { isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
				{ field: 'ParentFolderId', type: 'int', displayLabel: 'SHARED_FOLDERS.FIELDS.PARENT_FOLDER_ID', visible: true, creatable: false, editable: false, inputType: 'number',
					validation: { isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
				{ field: 'Name', type: 'text', displayLabel: 'SHARED_FOLDERS.FIELDS.NAME', visible: true, creatable: true, editable: true, inputType: 'text', checkIfUnique: true,
					validation: { isRequired: true, maxLen: 500, minLen: 1, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
				{ field: 'Entity', type: 'int', displayLabel: 'SHARED_FOLDERS.FIELDS.ENTITY', visible: true, creatable: true, editable: false, inputType: 'lookup', lookupSource: 'lists.entityList',
					validation: { isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
				{ field: 'Users', type: 'int', displayLabel: 'SHARED_FOLDERS.FIELDS.USERS', visible: false, creatable: true, editable: true, inputType: 'lookup-many', lookupSource: 'lists.accessibleUsers', dontShowAssignedRecordsInChip: true,
					lookupFilter: {Status: 1}, validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
				{ field: 'Status', type: 'text', displayLabel: 'SHARED_FOLDERS.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
					validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
				{ field: 'CreatedBy', type: 'text', displayLabel: 'SHARED_FOLDERS.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
					validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
				{ field: 'CreatedDate', type: 'text', displayLabel: 'SHARED_FOLDERS.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
					validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
				{ field: 'UpdatedBy', type: 'text', displayLabel: 'SHARED_FOLDERS.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
					validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
				{ field: 'UpdatedDate', type: 'text', displayLabel: 'SHARED_FOLDERS.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
					validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }}
				],
			uniqueConstraints: [],
			title: 'SHARED_FOLDERS.NAV',
			icon: 'icon-folder-move',
			idField: 'Id',
			lookupDisplayField: 'Name',
			isDirty: false,
			isCatalogSpecificModel: true,
			methods: {
				getList      : getSharedFolders,
				getDetails   : getSharedFolder,
				create       : createSharedFolder,
				update       : updateSharedFolder,
				activateBulk : activateSharedFolders,
				createBulk   : createBulk
			},
			views: {
				mainList: {
					columns: ['Id', 'Name', 'Entity', 'Status', 'ParentFolderId', 'UpdatedBy', 'UpdatedDate'],
					columnFilter: {},
					toggleFilterProps: {},
					topIndex: 0,
					showFilterRow: false,
					sortColumn: { 'UpdatedDate': false },
					itemActions: [
						{ id: 'view', label: 'ACTIONS.VIEW', icon: 'icon-magnify', privilege: 'GetSharingFolderDetails', disabled: '!node.Status', visible: true },
						{ id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UpdateSharingFolder', disabled: '!node.Status', visible: true },
						{ id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateSharingFolderStatus:true', disabled: 'node._disabled', visible: 'node.Status',
								requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
						{ id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateSharingFolderStatus:true', disabled: false, visible: '!node.Status',
								requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'},
						{ id: 'addSubFolder', label: 'SHARED_FOLDERS.ACTIONS.ADD_SUB_FOLDER', icon: 'icon-plus', privilege: 'CreateSharingFolder', disabled: false, visible: true }
					],
					listActions: [
						{ id: 'import', label: 'SHARED_FOLDERS.ACTIONS.IMPORT_USERS', icon: 'icon-import', privilege: 'ImportSharingFolderUsers', disabled: false, visible: true, requiresConfirmation: false }
					],
					fabAction       :
						{id: 'add', label: 'ACTIONS.ADD', icon: 'icon-plus', privilege: 'CreateSharingFolder', visible: true}
				},
				mainDetails: {
				 selectedTabIndex   : 0,
				 itemActions        : [
						{ id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateBuyWindowStatus:true', disabled: '{selected: true, Status: 1}',
								visible: true, requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
						{ id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateBuyWindowStatus:true', disabled: '{selected: true, Status: 0}',
								visible: true, requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
					],
					fab           : {id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UpdateSharingFolder', visible: true}
			 },
			 privileges: {
					 list    : 'GetSharingFolderList',
					 details : 'GetSharingFolderDetails'
			 }
			}
		};

		api.catalogs.importSharedFolderUsers = {
			modelPath: 'catalogs.sharedFolderUsers',
			fields: [
				{ field: 'FolderName', type: 'text', displayLabel: 'SHARED_FOLDERS.FIELDS.FOLDER_NAME', visible: true, creatable: true, editable: true, inputType: 'text', checkIfUnique: true,
					validation: { isRequired: true, maxLen: 500, minLen: 1, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
				{ field: 'UserName', type: 'text', displayLabel: 'SHARED_FOLDERS.FIELDS.USER_NAME', visible: true, creatable: true, editable: false, inputType: 'text',
					validation: { isRequired: true, maxLen: 50, minLen: 1, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } } },
				{ field: 'Status', type: 'text', displayLabel: 'SHARED_FOLDERS.FIELDS.STATUS', visible: true, creatable: true, editable: false, inputType: 'status',
					validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
				{ field: 'AllowSharing', type: 'text', displayLabel: 'SHARED_FOLDERS.FIELDS.ALLOW_SHARING', visible: true, creatable: true, editable: false, inputType: 'bool-int',
					validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
				],
			uniqueConstraints: [{ name: 'Constraint 1', fields: ['FolderName', 'UserName'] }],
			title: '',
			icon: '',
			idField: '',
			lookupDisplayField: '',
			isDirty: false,
			methods: {},
			views: {
				mainList: {
					columns: [],
					columnFilter: {},
					toggleFilterProps: {},
					topIndex: 0,
					showFilterRow: false,
					sortColumn: {},
					itemActions: [],
					listActions: []
				},
				mainDetails: {},
				privileges: {}
			}
		};

		function getSharedFolders(generalProperties, model, catalogId) {
			if (angular.isDefined(model)) { // to skip this part for load lookup
				model.isBulkActionCompleted = false;
			}
			var promise;

			if (angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
				var state = {};
				state.name = $state.current.name;
				state.params = $state.params;
				var isBulk = true;
				var logData = activityLogger.createLogData(null, state, 'catalogs.sharedFolders', 'VIEW', isBulk, new Date(), null, null);
				promise = api.webGet(api.baseUrl + '/catalogs/' + catalogId + '/sharingfolders', undefined, true, generalProperties.forceFetch);
				promise.then(function(response) {
					// return only the current catalog folders
					response.data = utility.filterObject(response.data, {CatalogCode: catalogId}, true);
				});
				promise = activityLogger.log(logData, promise);
			}
			else {
				catalogId = angular.isUndefined(catalogId) ? catalogFactory.getActiveCatalog().CatalogCode : catalogId;
				promise = api.webGet(api.baseUrl + '/catalogs/' + catalogId + '/sharingfolders', undefined, true, generalProperties.forceFetch);
				promise.then(function(response) {
					// return only the current catalog folders
					response.data = utility.filterObject(response.data, {CatalogCode: catalogId}, true);
				});
			}

			promise.then(function () {
				if (api.catalogs.sharedFoldersTree.isDirty) {
					//Invalidate lookupData
					api.catalogs.sharedFoldersTree.lookupData = undefined;
					api.catalogs.sharedFoldersTree.isDirty = false;
				}
			});
			return promise;
		}

		function getSharedFolder(isLogRequired, adjustmentId, catalogCode) {
			var promise;
			if (angular.isDefined(isLogRequired) && isLogRequired === true) {
			  var state = {};
			  state.name = $state.current.name;
			  state.params = $state.params;
			  var isBulk = false;
			  var items = [];
			  promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/sharingfolders/' + adjustmentId);
			  var logData = activityLogger.createLogData(items, state, 'catalogs.sharedFolders', 'VIEW', isBulk, new Date(), null, null);
			  promise = activityLogger.log(logData, promise);
			}
			else {
			  promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/sharingfolders/' + adjustmentId);
			}
			return promise;
		}

		function createSharedFolder(record, catalogCode) {
			 // dont send users array to sub folder
				if(angular.isDefined(record.ParentFolderId) && record.ParentFolderId != null && record.ParentFolderId !== 0) {
					delete record['Users'];
				}
				var state = {};
				state.name = $state.current.name;
				state.params = $state.params;
				var logData = activityLogger.createLogData(record[api.catalogs.sharedFoldersTree.lookupDisplayField], state, 'catalogs.sharedFolders', 'ADD', false, new Date(), null, null);
				var promise = api.webPost(api.baseUrl + '/catalogs/' + catalogCode + '/sharingfolders', record);

				promise.then(function() {
					api.catalogs.sharedFoldersTree.isDirty = true;
				});
				return activityLogger.log(logData, promise);
		}

		function updateSharedFolder(recordId, record, catalogCode) {
				// dont send users array to sub folder
				if(angular.isDefined(record.ParentFolderId) && record.ParentFolderId != null && record.ParentFolderId !== 0) {
					delete record['Users'];
				} else if(angular.isDefined(record.AssignedRecords) && record.AssignedRecords.length) {
					angular.forEach(record.AssignedRecords, function(assignedRecord) {
						var userIdExists = record.Users.some(function(user) {
								return user.UserId === assignedRecord.UserId;
						});

						if (!userIdExists) {
								record.Users.push(assignedRecord);
						}
					});
				}
				var state = {};
				state.name = $state.current.name;
				state.params = $state.params;
				var logData = activityLogger.createLogData(record[api.catalogs.sharedFoldersTree.lookupDisplayField], state, 'catalogs.sharedFolders', 'ADD', false, new Date(), null, null);
				var promise = api.webPut(api.baseUrl + '/catalogs/' + catalogCode + '/sharingfolders/' + recordId, record);

				promise.then(function () {
					api.catalogs.sharedFoldersTree.isDirty = true;
				});
				return activityLogger.log(logData, promise);
		}

		function activateSharedFolders(records, model, actionType, catalogCode) {
				var result = crud.createRequestObject(records, model, actionType);
				var state = {};
				state.name = $state.current.name;
				state.params = $state.params;
				var isBulk = result.itemsNameList.length > 1 ? true : false;
				var logData = activityLogger.createLogData(result.itemsNameList, state, 'catalogs.sharedFolders', actionType.toUpperCase(), isBulk, new Date(), null, null);
				var promise = api.webPut(api.baseUrl + '/catalogs/' + catalogCode + '/sharingfolders/status', result.requestObj);

				promise.then(function () {
						crud.onRecordStatusChange(records, api.catalogs.sharedFoldersTree, actionType);
				});

				return activityLogger.log(logData, promise);
		}

		function createBulk(model, data, catalogCode) {
				// transform data into required format
				var transformedData = [];
				var folderNameIndexes = {};
				var itemsNameList = [];
				for (var i = 0; i < data.length; i++) {
					var ind = -1;
					if (angular.isUndefined(folderNameIndexes[data[i].FolderName.toUpperCase()])) {
						var requestObj = { 'FolderName': data[i].FolderName, 'Users': [] };
						ind = transformedData.length;
						folderNameIndexes[data[i].FolderName.toUpperCase()] = ind;
						transformedData.push(requestObj);
						itemsNameList.push(data[i].FolderName);
					} else {
						ind = folderNameIndexes[data[i].FolderName.toUpperCase()];
					}
					if(data[i].UserName) {
						var userObj = {
							UserName: data[i].UserName
						}
						if(angular.isDefined(data[i].Status)) {
							userObj['Status'] = data[i].Status;
						}
						if(angular.isDefined(data[i].AllowSharing)) {
							userObj['AllowSharing'] = data[i].AllowSharing;
						}
						transformedData[ind].Users.push(userObj);
					}
				}
				var state = {};
				state.name = $state.current.name;
				state.params = $state.params;
				var logData = activityLogger.createLogData(null, state, 'catalogs.sharedFolders', 'ADD', false, new Date(), null, null);
				var promise = api.webPut(api.baseUrl + '/catalogs/' + catalogCode + '/sharingfolders/users', transformedData);

				promise.then(function () {
					api.catalogs.sharedFoldersTree.isDirty = true;
				});
				return activityLogger.log(logData, promise);
		}

	}
})();
(function () {
	'use strict';

	angular
		.module('app.main.catalogs.shared-folders')
		.run(runBlock);

	/* @ngInject */
	function runBlock(api, activityLogger, $state, crud, utility) {

		if (angular.isUndefined(api.catalogs)) {
			api.catalogs = {};
		}
		api.catalogs.sharedFolders = {
			modelPath: 'catalogs.sharedFolders',
			fields: [
				{ field: 'Id', type: 'int', displayLabel: 'SHARED_FOLDERS.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
					validation: { isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
				{ field: 'ParentFolderId', type: 'int', displayLabel: 'SHARED_FOLDERS.FIELDS.PARENT_FOLDER_ID', visible: true, creatable: false, editable: false, inputType: 'number',
					validation: { isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
				{ field: 'Name', type: 'text', displayLabel: 'SHARED_FOLDERS.FIELDS.NAME', visible: true, creatable: true, editable: true, inputType: 'text', checkIfUnique: true,
					validation: { isRequired: true, maxLen: 500, minLen: 1, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
				{ field: 'Entity', type: 'int', displayLabel: 'SHARED_FOLDERS.FIELDS.ENTITY', visible: true, creatable: true, editable: false, inputType: 'lookup', lookupSource: 'lists.entityList',
					validation: { isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
				{ field: 'Users', type: 'int', displayLabel: 'SHARED_FOLDERS.FIELDS.USERS', visible: false, creatable: true, editable: true, inputType: 'lookup-many', lookupSource: 'lists.accessibleUsers',
					lookupFilter: {Status: 1}, validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
				{ field: 'Status', type: 'text', displayLabel: 'SHARED_FOLDERS.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
					validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
				{ field: 'CreatedBy', type: 'text', displayLabel: 'SHARED_FOLDERS.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
					validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
				{ field: 'CreatedDate', type: 'text', displayLabel: 'SHARED_FOLDERS.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
					validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
				{ field: 'UpdatedBy', type: 'text', displayLabel: 'SHARED_FOLDERS.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
					validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
				{ field: 'UpdatedDate', type: 'text', displayLabel: 'SHARED_FOLDERS.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
					validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
				],
			uniqueConstraints: [],
			title: 'SHARED_FOLDERS.NAV',
			icon: 'icon-folder-move',
			idField: 'Id',
			lookupDisplayField: 'Name',
			isDirty: false,
			isCatalogSpecificModel: true,
			methods: {
				getList      : getSharedFolders,
				getDetails   : getSharedFolder,
				create       : createSharedFolder,
				update       : updateSharedFolder,
				activateBulk : activateSharedFolders,
				createBulk   : createBulk
			},
			views: {
				mainList: {
					columns: ['Id', 'Name', 'Entity', 'Status', 'ParentFolderId', 'UpdatedBy', 'UpdatedDate'],
					columnFilter: {},
					toggleFilterProps: {},
					topIndex: 0,
					showFilterRow: false,
					sortColumn: { 'UpdatedDate': false },
					itemActions: [
						{ id: 'view', label: 'ACTIONS.VIEW', icon: 'icon-magnify', privilege: 'GetSharingFolderDetails', disabled: '!itm.Status', visible: true },
						{ id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UpdateSharingFolder', disabled: '!itm.Status', visible: true },
						{ id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateSharingFolderStatus:true', disabled: 'itm._disabled', visible: 'itm.Status',
								requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
						{ id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateSharingFolderStatus:true', disabled: false, visible: '!itm.Status',
								requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'},
						{ id: 'addSubFolder', label: 'SHARED_FOLDERS.ACTIONS.ADD_SUB_FOLDER', icon: 'icon-plus', privilege: 'CreateSharingFolder', disabled: false, visible: true }
					],
					listActions: [
						{ id: 'delete', label: 'ACTIONS.DELETE_BULK', icon: 'icon-delete', privilege: 'UpdateSharingFolderStatus:true', disabled: '{selected: true, Status: 1}', visible: true,
								requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
						{ id: 'activate', label: 'ACTIONS.ACTIVATE_BULK', icon: 'icon-undo-variant', privilege: 'UpdateSharingFolderStatus:true', disabled: '{selected: true, Status: 0}', visible: true,
								requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'},
						{ id: 'import', label: 'SHARED_FOLDERS.ACTIONS.IMPORT_USERS', icon: 'icon-import', privilege: 'ImportSharingFolderUsers', disabled: false, visible: true, requiresConfirmation: false }
					],
					fabAction       :
						{id: 'add', label: 'ACTIONS.ADD', icon: 'icon-plus', privilege: 'CreateSharingFolder', visible: true}
				},
				mainDetails: {
				 selectedTabIndex   : 0,
				 itemActions        : [
						{ id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateBuyWindowStatus:true', disabled: '{selected: true, Status: 1}',
								visible: true, requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
						{ id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateBuyWindowStatus:true', disabled: '{selected: true, Status: 0}',
								visible: true, requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
					],
					fab           : {id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UpdateSharingFolder', visible: true}
			 },
			 privileges: {
					 list    : 'GetSharingFolderList',
					 details : 'GetSharingFolderDetails'
			 }
			}
		};

		api.catalogs.importSharedFolderUsers = {
			modelPath: 'catalogs.importSharedFolderUsers',
			fields: [
				{ field: 'FolderName', type: 'text', displayLabel: 'SHARED_FOLDERS.FIELDS.FOLDER_NAME', visible: true, creatable: true, editable: true, inputType: 'text', checkIfUnique: true,
					validation: { isRequired: true, maxLen: 500, minLen: 1, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
				{ field: 'UserName', type: 'text', displayLabel: 'SHARED_FOLDERS.FIELDS.USER_NAME', visible: true, creatable: true, editable: false, inputType: 'text',
					validation: { isRequired: true, maxLen: 50, minLen: 1, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } } },
				{ field: 'Status', type: 'text', displayLabel: 'SHARED_FOLDERS.FIELDS.STATUS', visible: true, creatable: true, editable: false, inputType: 'status',
					validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
				{ field: 'AllowSharing', type: 'text', displayLabel: 'SHARED_FOLDERS.FIELDS.ALLOW_SHARING', visible: true, creatable: true, editable: false, inputType: 'bool-int',
					validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
				],
			uniqueConstraints: [{ name: 'Constraint 1', fields: ['FolderName', 'UserName'] }],
			title: '',
			icon: '',
			idField: '',
			lookupDisplayField: '',
			isDirty: false,
			methods: {},
			views: {
				mainList: {
					columns: [],
					columnFilter: {},
					toggleFilterProps: {},
					topIndex: 0,
					showFilterRow: false,
					sortColumn: {},
					itemActions: [],
					listActions: []
				},
				mainDetails: {},
				privileges: {}
			}
		};

		function getSharedFolders(generalProperties, model, catalogId) {
			if (angular.isDefined(model)) { // to skip this part for load lookup
				model.isBulkActionCompleted = false;
			}
			var promise;

			if (angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
				var state = {};
				state.name = $state.current.name;
				state.params = $state.params;
				var isBulk = true;
				var logData = activityLogger.createLogData(null, state, 'catalogs.sharedFolders', 'VIEW', isBulk, new Date(), null, null);
				promise = api.webGet(api.baseUrl + '/catalogs/' + catalogId + '/sharingfolders', undefined, true, generalProperties.forceFetch);
				promise.then(function(response) {
					// return only the current catalog folders
					response.data = utility.filterObject(response.data, {CatalogCode: catalogId}, true);
				});
				promise = activityLogger.log(logData, promise);
			}
			else {
				catalogId = angular.isUndefined(catalogId) ? catalogFactory.getActiveCatalog().CatalogCode : catalogId;
				promise = api.webGet(api.baseUrl + '/catalogs/' + catalogId + '/sharingfolders', undefined, true, generalProperties.forceFetch);
				promise.then(function(response) {
					// return only the current catalog folders
					response.data = utility.filterObject(response.data, {CatalogCode: catalogId}, true);
				});
			}

			promise.then(function () {
				if (api.catalogs.sharedFolders.isDirty) {
					//Invalidate lookupData
					api.catalogs.sharedFolders.lookupData = undefined;
					api.catalogs.sharedFolders.isDirty = false;
				}
			});
			return promise;
		}

		function getSharedFolder(isLogRequired, adjustmentId, catalogCode) {
			var promise;
			if (angular.isDefined(isLogRequired) && isLogRequired === true) {
			  var state = {};
			  state.name = $state.current.name;
			  state.params = $state.params;
			  var isBulk = false;
			  var items = [];
			  promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/sharingfolders/' + adjustmentId);
			  var logData = activityLogger.createLogData(items, state, 'catalogs.sharedFolders', 'VIEW', isBulk, new Date(), null, null);
			  promise = activityLogger.log(logData, promise);
			}
			else {
			  promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/sharingfolders/' + adjustmentId);
			}
			return promise;
		}

		function createSharedFolder(record, catalogCode) {
				// dont send users array to sub folder
				if(angular.isDefined(record.ParentFolderId) && record.ParentFolderId != null && record.ParentFolderId !== 0) {
					delete record['Users'];
				}
				var state = {};
				state.name = $state.current.name;
				state.params = $state.params;
				var logData = activityLogger.createLogData(record[api.catalogs.sharedFolders.lookupDisplayField], state, 'catalogs.sharedFolders', 'ADD', false, new Date(), null, null);
				var promise = api.webPost(api.baseUrl + '/catalogs/' + catalogCode + '/sharingfolders', record);

				promise.then(function() {
					api.catalogs.sharedFolders.isDirty = true;
				});
				return activityLogger.log(logData, promise);
		}

		function updateSharedFolder(recordId, record, catalogCode) {
				// dont send users array to sub folder
				if(angular.isDefined(record.ParentFolderId) && record.ParentFolderId != null && record.ParentFolderId !== 0) {
					delete record['Users'];
				} else if(angular.isDefined(record.AssignedRecords) && record.AssignedRecords.length) {
					angular.forEach(record.AssignedRecords, function(assignedRecord) {
						var userIdExists = record.Users.some(function(user) {
								return user.UserId === assignedRecord.UserId;
						});

						if (!userIdExists) {
								record.Users.push(assignedRecord);
						}
					});
				}
				var state = {};
				state.name = $state.current.name;
				state.params = $state.params;
				var logData = activityLogger.createLogData(record[api.catalogs.sharedFolders.lookupDisplayField], state, 'catalogs.sharedFolders', 'ADD', false, new Date(), null, null);
				var promise = api.webPut(api.baseUrl + '/catalogs/' + catalogCode + '/sharingfolders/' + recordId, record);

				promise.then(function () {
					api.catalogs.sharedFolders.isDirty = true;
				});
				return activityLogger.log(logData, promise);
		}

		function activateSharedFolders(records, model, actionType, catalogCode) {
				var result = crud.createRequestObject(records, model, actionType);
				var state = {};
				state.name = $state.current.name;
				state.params = $state.params;
				var isBulk = result.itemsNameList.length > 1 ? true : false;
				var logData = activityLogger.createLogData(result.itemsNameList, state, 'catalogs.sharedFolders', actionType.toUpperCase(), isBulk, new Date(), null, null);
				var promise = api.webPut(api.baseUrl + '/catalogs/' + catalogCode + '/sharingfolders/status', result.requestObj);

				promise.then(function () {
						crud.onRecordStatusChange(records, api.catalogs.sharedFolders, actionType);
				});

				return activityLogger.log(logData, promise);
		}

		function createBulk(model, data, catalogCode) {
				// transform data into required format
				var transformedData = [];
				var folderNameIndexes = {};
				var itemsNameList = [];
				for (var i = 0; i < data.length; i++) {
					var ind = -1;
					if (angular.isUndefined(folderNameIndexes[data[i].FolderName.toUpperCase()])) {
						var requestObj = { 'FolderName': data[i].FolderName, 'Users': [] };
						ind = transformedData.length;
						folderNameIndexes[data[i].FolderName.toUpperCase()] = ind;
						transformedData.push(requestObj);
						itemsNameList.push(data[i].FolderName);
					} else {
						ind = folderNameIndexes[data[i].FolderName.toUpperCase()];
					}
					if(data[i].UserName) {
						var userObj = {
							UserName: data[i].UserName
						}
						if(angular.isDefined(data[i].Status)) {
							userObj['Status'] = data[i].Status;
						}
						if(angular.isDefined(data[i].AllowSharing)) {
							userObj['AllowSharing'] = data[i].AllowSharing;
						}
						transformedData[ind].Users.push(userObj);
					}
				}
				var state = {};
				state.name = $state.current.name;
				state.params = $state.params;
				var logData = activityLogger.createLogData(null, state, 'catalogs.sharedFolders', 'ADD', false, new Date(), null, null);
				var promise = api.webPut(api.baseUrl + '/catalogs/' + catalogCode + '/sharingfolders/users', transformedData);

				promise.then(function () {
					api.catalogs.sharedFolders.isDirty = true;
				});
				return activityLogger.log(logData, promise);
		}

	}
})();
(function() {
	'use strict';

	angular
		.module('app.main.catalog-articles.segmentation-linear')
		.run(runBlock);

	/* @ngInject */
	function runBlock(api, utility, activityLogger, $state, catalogFactory, jobsTracker, CONSTANTS) {

		if (angular.isUndefined(api.catalogArticles)) {
			api.catalogArticles = {};
		}
		api.catalogArticles.segmentationLinear = {
			modelPath: 'catalogArticles.segmentationLinear',
			fields: [
				{ field: 'ArticleId', type: 'int', displayLabel: 'SEGMENTATION_LINEAR.FIELDS.ARTICLE_ID', visible: true, creatable: false, editable: false, inputType: 'number',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'ArticleId', type: 'text', displayLabel: 'FAVORITES.FIELDS.ARTICLE_ID', visible: false, creatable: false, editable: true, inputType: 'lookup', lookupSource: 'catalogs.articles',
					lookupFilter: {Status: 1}, validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'ArticleNumber', type: 'text', displayLabel: 'SEGMENTATION_LINEAR.FIELDS.ARTICLE_NUMBER', visible: true, creatable: true, editable: false, inputType: 'text',
					validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'ArticleName', type: 'text', displayLabel: 'ARTICLES.FIELDS.MODEL_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
					validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'LastUpdatedOn', map: 'LastUpdatedOn', type: 'date', displayLabel: 'SEGMENTATION_LINEAR.FIELDS.LAST_UPDATED_ON', visible: true, creatable: false, editable: false, inputType: 'date',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: ''} },
				{ field: 'ModelNumber', type: 'text', displayLabel: 'SEGMENTATION_LINEAR.FIELDS.MODEL_NUMBER', visible: true, creatable: true, editable: false, inputType: 'text',
					validation: { isRequired: true, maxLen: 200, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } } },
				{ field: 'PlanningValue', type: 'text', displayLabel: 'SEGMENTATION_LINEAR.FIELDS.PLANNING_VALUE', visible: false, creatable: false, editable: false, inputType: 'text',
					validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'SegmentationId', type: 'int', displayLabel: 'SEGMENTATION_LINEAR.FIELDS.SEGMENTATION_NAME', visible: true, creatable: false, editable: true, inputType: 'lookup', lookupSource: 'catalogs.segmentations',
					validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'SegmentationName', type: 'text', displayLabel: 'SEGMENTATION_LINEAR.FIELDS.SEGMENTATION_NAME', visible: false, creatable: true, editable: true, inputType: 'text',
					validation: {isRequired: true, maxLen: 100, minLen: 1, pattern: '^[^!*]+$', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: 'VALIDATIONS.INVALID_CHARACTER'}} },
				{ field: 'SegmentationStatus', type: 'text', displayLabel: 'SEGMENTATION_LINEAR.FIELDS.SEGMENTATION_STATUS', visible: true, creatable: true, editable: false, inputType: 'status-segmentation',
					validation: {isRequired: true, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'IsOutOfParentSegmentation', type: 'text', displayLabel: 'SEGMENTATION_LINEAR.FIELDS.OUT_OF_PARENT_SEGMENTATION', visible: true, creatable: false, editable: false, inputType: 'bool-int',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'Status',  map:'Status', type: 'text', displayLabel: 'SEGMENTATION_LINEAR.FIELDS.ARTICLE_STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
			],
			title: 'SEGMENTATION_LINEAR.NAV',
			icon: 'icon-cube-unfolded',
			idField: 'ArticleId',
			lookupDisplayField: '',
			isDirty: false,
			isBulkActionCompleted: false,
			isCatalogSpecificModel: true,
			methods: {
				getList     												: getSegmentation,
				createBulk  												: createBulk,
				updateBulk  												: updateBulk,
				updateSegmentationViaImportModel    : updateSegmentationViaImportModel,
				activateBulk												: activateSegmentation
			},
			views: {
				mainList: {
					columns         : [ 'ArticleNumber', 'ArticleName', 'SegmentationId', 'SegmentationStatus', 'LastUpdatedOn'],
					columnFilter    : {},
					topIndex        : 0,
					showFilterRow   : false,
					sortColumn      : {'LastUpdatedOn': false},
					itemActions     : [
										{ id: 'view', label: 'ACTIONS.VIEW', icon: 'icon-magnify', privilege: 'GetCatalogArticleSegmentationList', disabled: false, visible: true },
										{ id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateArticleBulkSegmentationStatus:true', disabled: false, visible: 'itm.SegmentationStatus',
											requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'}
									  ],
					listActions     : [
										{ id: 'import', label: 'ACTIONS.IMPORT', icon: 'icon-import', privilege: 'UpdateCatalogBulkArticlesSegmentations:true', disabled: false, visible: true, requiresConfirmation: false },
										{ id: 'importBySegmentationGroup', label: 'SEGMENTATION_LINEAR.ACTIONS.IMPORT_BY_SEGMENTATION_GROUP', icon: 'icon-cube-unfolded', privilege: 'UI_ImportBySegmentationGroup:true', disabled: false, visible: true, requiresConfirmation: false },
										{ id: 'updateSegmentationViaImportModel', label: 'SEGMENTATION_LINEAR.ACTIONS.UPDATE_SEGMENTATION_VIA_IMPORT_MODEL', icon: 'icon-import', privilege: 'ImportArticleSegmentationByModelNumbers:true', disabled: false, visible: true, requiresConfirmation: false}
									],
					fabAction       : { id: 'add', label: 'ACTIONS.ADD', icon: 'icon-link', privilege: 'UpdateCatalogBulkArticlesSegmentations:true', visible: true }

				 },
				 mainDetails: {},
				privileges: {
					list    : 'GetCatalogListArticleSegmentations'
				}
			}
		};

		api.catalogs.importBySegmentationGroup = {
			modelPath: 'catalogs.importBySegmentationGroup',
			fields: [
			  { field: 'ArticleNumber', map: 'ArticleNumber', type: 'text', displayLabel: 'SEGMENTATION_LINEAR.FIELDS.ARTICLE_NUMBER', visible: false, creatable: true, editable: false, inputType: 'text',
				validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
			  { field: 'SegmentationGroup', type: 'text', displayLabel: 'SEGMENTATION_LINEAR.FIELDS.SEGMENTATION_GROUP', visible: false, creatable: true, editable: false, inputType: 'text',
				validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
			],
			uniqueConstraints: [
			  { name: 'Constraint 1', fields: ['ArticleNumber', 'SegmentationGroup'] }
			],
		  };

		// Not supported for lookup (getLookupData implemention need to be modified)
		function getSegmentation(generalProperties, model, catalogId) {
			if(angular.isDefined(model)) { // to skip this part for load lookup
				model.isBulkActionCompleted = false;
			}
			var promise;

			if(angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
				var state = {};
				state.name = $state.current.name;
				state.params = $state.params;
				var isBulk = true;
				var logData = activityLogger.createLogData(null, state, 'catalogArticles.segmentation', 'VIEW', isBulk, new Date(), null, null);

				promise = api.webGet(api.baseUrl + '/catalogs/' + catalogId + '/articlesegmentations',
										generalProperties.config || {}, true, generalProperties.forceFetch,
										generalProperties.supportIncrementalResult || true,
										generalProperties.modelIdField,
										generalProperties.isMajor || false,
										model || api.catalogArticles.segmentationLinear);
				promise = activityLogger.log(logData, promise);
			}
			else {
				catalogId = angular.isUndefined(catalogId) ? catalogFactory.getActiveCatalog().CatalogCode : catalogId;
				promise = api.webGet(api.baseUrl + '/catalogs/' + catalogId + '/articlesegmentations',
										generalProperties.config || {}, true, generalProperties.forceFetch,
										generalProperties.supportIncrementalResult || true,
										generalProperties.modelIdField,
										generalProperties.isMajor || false,
										model || api.catalogArticles.segmentationLinear);
			}

			promise.then(function() {
				if (api.catalogArticles.segmentationLinear.isDirty) {
					//Invalidate lookupData
					api.catalogArticles.segmentationLinear.lookupData = undefined;
					api.catalogArticles.segmentationLinear.isDirty = false;
				}
			});
			return promise;
		}

		function createBulk(data, activeCatalog, model, action) {
			var secondaryModel = api.catalogArticles.segmentation;
			//Transform data into required format
			var transformedData = [];
			var nameIndexes = {};
			var itemsNameList = [];
			if (action === 'import') {
				for (var i = 0; i < data.length; i++) {
					var ind = -1;
					if (angular.isUndefined(nameIndexes[data[i].ArticleNumber.toUpperCase()])) {
						var requestObj = { AN: data[i].ArticleNumber, S: [] };
						ind = transformedData.length;
						nameIndexes[data[i].ArticleNumber.toUpperCase()] = ind;
						transformedData.push(requestObj);
						itemsNameList.push(data[i].ArticleNumber);
					} else {
						ind = nameIndexes[data[i].ArticleNumber.toUpperCase()];
					}
					if (angular.isDefined(data[i].SegmentationName) && angular.isDefined(data[i].SegmentationStatus)) {
						if (activeCatalog.SegmentationPlanningEnable !== 1) {
							var segmentationInfoMap = { SID: data[i].SegmentationName, S: 0 };
							if (data[i].SegmentationStatus !== '' && data[i].SegmentationStatus != '0' && data[i].SegmentationStatus.toString().toUpperCase() !== 'NO' && data[i].SegmentationStatus.toString().toUpperCase() !== 'FALSE' && data[i].SegmentationStatus.toString().toUpperCase() !== 'NOT AVAILABLE') {
								segmentationInfoMap.S = 1;
							}
							transformedData[ind].S.push(segmentationInfoMap);
						} else {
							var segmentationInfoMap = { SID: data[i].SegmentationName, S: 0, PlanningValue: "" };
							// import accepts configured planning values only; store the matched value verbatim.
							// A blank cell or a non-configured value (e.g. 'No') leaves the segmentation unassigned.
							var planningValue = api.matchSegmentationPlanningValue(data[i].SegmentationStatus);
							if (planningValue) {
								segmentationInfoMap.S = 1;
								segmentationInfoMap.PlanningValue = planningValue;
							}
							transformedData[ind].S.push(segmentationInfoMap);
						}
					}
				}
			}
			else if (action === 'importBySegmentationGroup') {
				var SegmentationGroupList = utility.filterObject(catalogFactory.getActiveCatalogDetails().SegmentationGroupList, { Status: 1 });
				for (var i = 0; i < data.length; i++) {
					var ind = -1;
					if (angular.isUndefined(nameIndexes[data[i].ArticleNumber.toUpperCase()])) {
						var requestObj = { AN: data[i].ArticleNumber, S: [] };
						ind = transformedData.length;
						nameIndexes[data[i].ArticleNumber.toUpperCase()] = ind;
						transformedData.push(requestObj);
						itemsNameList.push(data[i].ArticleNumber);
					} else {
						ind = nameIndexes[data[i].ArticleNumber.toUpperCase()];
					}
					if (angular.isDefined(data[i].SegmentationGroup)) {
						if (SegmentationGroupList && SegmentationGroupList.length > 0) {
							angular.forEach(SegmentationGroupList, function (segmentationGroup) {
								if (segmentationGroup.SegmentationGroup.toString().toUpperCase() === data[i].SegmentationGroup.toString().trim().toUpperCase()) {
									var segmentations = segmentationGroup.Segmentations.split(',');
									if (segmentations && segmentations.length > 0) {
										for (var index = 0; index < segmentations.length; index++) {
											var segmentationInfoMap = { SID: segmentations[index], S: 1 };
											// group import has no planning-value column; apply the configured default to each assignment
											if (activeCatalog.SegmentationPlanningEnable === 1) {
												segmentationInfoMap.PlanningValue = api.getSegmentationPlanningDefault();
											}
											transformedData[ind].S.push(segmentationInfoMap);
										}
									}
								}
							});
						}
					}
				}
			}
			nameIndexes = undefined;

			var jobIndex = jobsTracker.addJob(model, 'SEGMENTATION_LINEAR.ACTIONS.IMPORT_SEGMENTATIONS', 1, secondaryModel);
			api.webPut(api.baseUrl + '/catalogs/' + activeCatalog.CatalogCode + '/articlesSegmentations?sourceapplication=' + CONSTANTS.SOURCE_APPLICATION + '&sourceaction=Import Article Segmentations', transformedData).then(function (response) {
				jobsTracker.trackJob(jobIndex, response.data.Id);
			}).catch(function (error) {
				jobsTracker.setCriticlaFail(jobIndex, error);
			});
		}

		function updateBulk(records, model) {
			var model = api.catalogArticles.segmentationLinear;
			var secondaryModel = api.catalogArticles.segmentation;
			var catalogId = catalogFactory.getActiveCatalog().CatalogCode;
			var transformedData = [];
			for (var i = 0; i < records.ArticleId.length; i++) {
				var articleSegmentations = {
					AN: records.ArticleId[i],
					S: []
				}
				for(var j = 0; j < records.SegmentationId.length; j++) {
					var linearSegmentationInfo = { SID: records.SegmentationId[j], S: 1 };
					// linear bulk-assign has no planning-value column; apply the configured default when planning is enabled
					if (catalogFactory.getActiveCatalog().SegmentationPlanningEnable === 1) {
						linearSegmentationInfo.PlanningValue = api.getSegmentationPlanningDefault();
					}
					articleSegmentations.S.push(linearSegmentationInfo);
				}
				transformedData.push(articleSegmentations);
			}

			var jobIndex = jobsTracker.addJob(model, 'SEGMENTATION_LINEAR.ACTIONS.UPDATE_SEGMENTATIONS', 1, secondaryModel);
			api.webPut(api.baseUrl + '/catalogs/' + catalogId + '/articlesSegmentations?sourceapplication=' + CONSTANTS.SOURCE_APPLICATION + '&sourceaction=Update Article Segmentations', transformedData).then(function(response) {
				jobsTracker.trackJob(jobIndex, response.data.Id);
			}).catch(function(error) {
				jobsTracker.setCriticlaFail(jobIndex, error);
			});
		}

		function updateSegmentationViaImportModel(model, data, activeCatalog) {
			var secondaryModel = api.catalogArticles.segmentation;
			//Transform data into required format
			var transformedData = [];
			var nameIndexes = {};
			var itemsNameList = [];
			for (var i = 0; i < data.length; i++) {
				var ind = -1;
				if (angular.isUndefined(nameIndexes[data[i].ModelNumber.toUpperCase()])) {
					var requestObj = { ModelNumber: data[i].ModelNumber, S: [] };
					ind = transformedData.length;
					nameIndexes[data[i].ModelNumber.toUpperCase()] = ind;
					transformedData.push(requestObj);
					itemsNameList.push(data[i].ModelNumber);
				} else {
					ind = nameIndexes[data[i].ModelNumber.toUpperCase()];
				}
				if (angular.isDefined(data[i].SegmentationName) && angular.isDefined(data[i].SegmentationStatus)) {
					if (activeCatalog.SegmentationPlanningEnable !== 1) {
						var segmentationInfoMap = { SID: data[i].SegmentationName, S: 0 };
						if (data[i].SegmentationStatus !== '' && data[i].SegmentationStatus != '0' && data[i].SegmentationStatus !== 'NO' && data[i].SegmentationStatus !== 'FALSE') {
							segmentationInfoMap.S = 1;
						}
						transformedData[ind].S.push(segmentationInfoMap);
					} else {
						var segmentationInfoMap = { SID: data[i].SegmentationName, S: 0, PlanningValue: "" };
						// import accepts configured planning values only; store the matched value verbatim.
						// A blank cell or a non-configured value (e.g. 'No') leaves the segmentation unassigned.
						var planningValue = api.matchSegmentationPlanningValue(data[i].SegmentationStatus);
						if (planningValue) {
							segmentationInfoMap.S = 1;
							segmentationInfoMap.PlanningValue = planningValue;
						}
						transformedData[ind].S.push(segmentationInfoMap);
					}
				}
			}
			nameIndexes = undefined;

			var jobIndex = jobsTracker.addJob(model, 'SEGMENTATION_LINEAR.ACTIONS.UPDATE_SEGMENTATION_VIA_IMPORT_MODEL', 1, secondaryModel);
			api.webPut(api.baseUrl + '/catalogs/' + activeCatalog.CatalogCode + '/importarticlesegmentationbymodels?sourceapplication=' + CONSTANTS.SOURCE_APPLICATION + '&sourceaction=Update Article Segmentation Via Import(Model)', transformedData).then(function(response) {
				jobsTracker.trackJob(jobIndex, response.data.Id);
			}).catch(function(error) {
				jobsTracker.setCriticlaFail(jobIndex, error);
			});
		}

		function activateSegmentation(record, actionType, activeCatalogId, articleId) {
			var requestObj = [{
				SegmentationId: record.SegmentationId,
				status: 0
			}];
			var state = {};
			state.name = $state.current.name;
			state.params = $state.params;
			var isBulk = false;
			var logData = activityLogger.createLogData(record, state, 'articles.segmentation', actionType.toUpperCase(), isBulk, new Date(), null, null);
			var promise = api.webPut(api.baseUrl + '/catalogs/' + activeCatalogId + '/articles/' + articleId + '/segmentations/status', requestObj);

			promise.then(function() {
					api.catalogArticles.segmentation.isDirty = true;
					api.catalogArticles.segmentationLinear.isDirty = true;
			});

			return activityLogger.log(logData, promise);
		}
	}
})();
(function() {
	'use strict';

	angular
		.module('app.main.catalog-articles.segmentation')
		.run(runBlock);

	/* @ngInject */
	function runBlock(api, utility, activityLogger, $state, catalogFactory, jobsTracker, CONSTANTS) {

		if (angular.isUndefined(api.catalogArticles)) {
			api.catalogArticles = {};
		}
		 api.catalogArticles.segmentation = {
			modelPath: 'catalogArticles.segmentation',
			fields: [
				{ field: 'Id', map:'Id', type: 'int', displayLabel: 'SEGMENTATION.FIELDS.ARTICLE_ID', visible: true, creatable: false, editable: false, inputType: 'number',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'ArticleNumber', map: 'ArticleNumber', type: 'text', displayLabel: 'SEGMENTATION.FIELDS.ARTICLE_NUMBER', visible: true, creatable: true, editable: false, inputType: 'text',
					validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'ArticleName', map: 'ArticleName',type: 'text', displayLabel: 'ARTICLES.FIELDS.MODEL_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
					validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'LastUpdatedOn', map: 'LastUpdatedOn', type: 'date', displayLabel: 'SEGMENTATION.FIELDS.LAST_UPDATED_ON', visible: true, creatable: false, editable: false, inputType: 'date',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: ''} },
				{ field: 'ModelNumber',  map: 'ModelNumber', type: 'text', displayLabel: 'ARTICLES.FIELDS.MODEL_NUMBER', visible: true, creatable: true, editable: false, inputType: 'text',
					validation: { isRequired: true, maxLen: 200, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } } },
				{ field: 'IsOutOfParentSegmentation', map: 'IsOutOfParentSegmentation', type: 'text', displayLabel: 'SEGMENTATION.FIELDS.OUT_OF_PARENT_SEGMENTATION', visible: true, creatable: false, editable: false, inputType: 'bool-int',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'Status',  map:'Status', type: 'text', displayLabel: 'SEGMENTATION_LINEAR.FIELDS.ARTICLE_STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
						validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
					// used internally to support virtual segmentations
				{ field: 'Open', type: 'text', displayLabel: 'SEGMENTATION.FIELDS.OPEN', visible: true, creatable: false, editable: false, inputType: 'bool-int',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}}  }
				],
			uniqueConstraints: [
				{name: 'Constraint 1', fields: ['ArticleNumber']}
			],
			title: 'SEGMENTATION.NAV',
			icon: 'icon-cube-unfolded',
			idField: 'Id',
			lookupDisplayField: '',
			isDirty: false,
			isBulkActionCompleted: false,
			isCatalogSpecificModel: true,
			methods: {
				getList     : getSegmentation,
				update      : updateArticleSegmentations,
				createBulk  : createBulk,
				updateBulk  : updateBulk,
				updateSegmentationViaImportModel    :   updateSegmentationViaImportModel
			},
			views: {
				mainList: {
					columns         : [ 'ArticleNumber', 'ModelNumber', 'LastUpdatedOn', 'Open'],
					columnFilter    : {},
					topIndex        : 0,
					showFilterRow   : false,
					sortColumn      : {'ArticleNumber': true},
					itemActions     : [
										{ id: 'view', label: 'ACTIONS.VIEW', icon: 'icon-magnify', privilege: 'GetCatalogArticleSegmentationList', disabled: false, visible: true },
										// saves through the partial update API, which is guarded by UpdateCatalogArticleSegmentations (4074)
										{ id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UpdateCatalogArticleSegmentations:true', disabled: false, visible: true }
									  ],
					listActions     : [
										{ id: 'updateBulk', label: 'ACTIONS.UPDATE_BULK', icon: 'icon-pencil', privilege: 'UpdateCatalogBulkArticlesSegmentations:true', disabled: '{selected: true}', visible: true, requiresConfirmation: false },
										{ id: 'import', label: 'ACTIONS.IMPORT', icon: 'icon-import', privilege: 'UpdateCatalogBulkArticlesSegmentations:true', disabled: false, visible: true, requiresConfirmation: false },
										{ id: 'importBySegmentationGroup', label: 'SEGMENTATION.ACTIONS.IMPORT_BY_SEGMENTATION_GROUP', icon: 'icon-cube-unfolded', privilege: 'UI_ImportBySegmentationGroup:true', disabled: false, visible: true, requiresConfirmation: false },
										{ id: 'updateSegmentationViaImportModel', label: 'SEGMENTATION.ACTIONS.UPDATE_SEGMENTATION_VIA_IMPORT_MODEL', icon: 'icon-import', privilege: 'ImportArticleSegmentationByModelNumbers:true', disabled: false, visible: true, requiresConfirmation: false}
									],
					fabAction       : {}

				 },
				 mainDetails: {},
				privileges: {
					list    : 'GetCatalogListArticleSegmentations'
				}
			}
		};

		api.catalogs.importBySegmentationGroup = {
			modelPath: 'catalogs.importBySegmentationGroup',
			fields: [
			  { field: 'ArticleNumber', map: 'ArticleNumber', type: 'text', displayLabel: 'SEGMENTATION.FIELDS.ARTICLE_NUMBER', visible: false, creatable: true, editable: false, inputType: 'text',
				validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
			  { field: 'SegmentationGroup', type: 'text', displayLabel: 'SEGMENTATION.FIELDS.SEGMENTATION_GROUP', visible: false, creatable: true, editable: false, inputType: 'text',
				validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
			],
			uniqueConstraints: [
			  { name: 'Constraint 1', fields: ['ArticleNumber', 'SegmentationGroup'] }
			],
		  };

		// Not supported for lookup (getLookupData implemention need to be modified)
		function getSegmentation(generalProperties, model, catalogId) {
			if(angular.isDefined(model)) { // to skip this part for load lookup
				model.isBulkActionCompleted = false;
			}
			var promise;

			if(angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
				var state = {};
				state.name = $state.current.name;
				state.params = $state.params;
				var isBulk = true;
				var logData = activityLogger.createLogData(null, state, 'catalogArticles.segmentation', 'VIEW', isBulk, new Date(), null, null);

				promise = api.webGet(api.baseUrl + '/catalogs/' + catalogId + '/articlesegmentations',
										generalProperties.config || {}, true, generalProperties.forceFetch,
										generalProperties.supportIncrementalResult || false,
										generalProperties.modelIdField,
										generalProperties.isMajor || false,
										model || api.catalogArticles.segmentation,
										generalProperties.isArticleRelatedData || true,
										catalogId, generalProperties.nestedArrayName || 'Segmentations',
										generalProperties.nestedDataIdField || 'Id');
				promise = activityLogger.log(logData, promise);
			}
			else {
				catalogId = angular.isUndefined(catalogId) ? catalogFactory.getActiveCatalog().CatalogCode : catalogId;
				promise = api.webGet(api.baseUrl + '/catalogs/' + catalogId + '/articlesegmentations',
										generalProperties.config || {}, true, generalProperties.forceFetch,
										generalProperties.supportIncrementalResult || false,
										generalProperties.modelIdField,
										generalProperties.isMajor || false,
										model || api.catalogArticles.segmentation,
										generalProperties.isArticleRelatedData || true,
										catalogId, generalProperties.nestedArrayName || 'Segmentations',
										generalProperties.nestedDataIdField || 'Id');
			}

			promise.then(function() {
				if (api.catalogArticles.segmentation.isDirty) {
					//Invalidate lookupData
					api.catalogArticles.segmentation.lookupData = undefined;
					api.catalogArticles.segmentation.isDirty = false;
				}
			});
			return promise;
		}

		/**
		 * Partial save of one article's segmentations (PUT .../articlesegmentations/update).
		 *
		 * `record` is a delta, not the article's whole set: only the segmentations the user added, changed
		 * or removed are sent, each with an explicit Status (1 = assign/update, 0 = unassign). Anything
		 * omitted is left untouched by the backend.
		 *
		 * Server-side rules the caller must satisfy: the list must not be empty, SegmentationId must be
		 * unique across it, and PlanningValue is capped at 20 chars - null/blank leaves the stored planning
		 * value unchanged. `updateSegmentationsController.getRequestObj` builds a payload that respects these.
		 */
		function updateArticleSegmentations(record, articleId, activeCatalogId) {
			var state = {};
			state.name = $state.current.name;
			state.params = $state.params;
			var logData = activityLogger.createLogData(articleId, state, 'catalogArticles.segmentation', 'EDIT', false, new Date(), null, null);
			var promise = api.webPut(api.baseUrl + '/catalogs/' + activeCatalogId + '/articles/' + articleId + '/articlesegmentations/update', record);

			promise.then(function() {
				// api.catalogs.prices.isDirty = true;
				api.catalogArticles.segmentation.isDirty = true;
				api.catalogArticles.segmentationLinear.isDirty = true;
			});
			return activityLogger.log(logData, promise);
		}

		function createBulk(data, activeCatalog, model, action) {
			var secondaryModel = api.catalogArticles.segmentationLinear;
			//Transform data into required format
			var transformedData = [];
			angular.forEach(data, function (element) {
				var newElement = { AN: element.ArticleNumber, S: [] };

				if (action === 'import') {
					angular.forEach(model.fields, function (field) {
						if (field.isCatalogProperty) {
							var segSheetVal = element[field.field];
							if (angular.isDefined(segSheetVal)) {
								var upperCaseValue = segSheetVal.toString().trim().toUpperCase();
								if (activeCatalog.SegmentationPlanningEnable !== 1) {
									var segmentationInfoMap = { SID: field.importField, S: 0 };

									if (upperCaseValue !== '' && upperCaseValue !== '0' && upperCaseValue !== 'NO' && upperCaseValue !== 'FALSE' && upperCaseValue !== 'NOT AVAILABLE') {
										segmentationInfoMap.S = 1;
									}
									newElement.S.push(segmentationInfoMap);
								} else {
									var segmentationInfoMap = { SID: field.importField, S: 0, PlanningValue: "" };
									// The import validator (dataImporter) has already normalized the cell to a configured planning
									// value, '' (blank) or an unassign token: exported 'Yes' cells become the configured default there.
									// Assign with the matched configured value; anything else leaves the segmentation unassigned.
									var planningValue = api.matchSegmentationPlanningValue(segSheetVal);
									if (planningValue) {
										segmentationInfoMap.S = 1;
										segmentationInfoMap.PlanningValue = planningValue;
									}
									newElement.S.push(segmentationInfoMap);
								}
							}
						}
					});
				}
				else if (action === 'importBySegmentationGroup') {
					var SegmentationGroupList = utility.filterObject(catalogFactory.getActiveCatalogDetails().SegmentationGroupList, { Status: 1 });
					if (SegmentationGroupList && SegmentationGroupList.length > 0) {
						angular.forEach(SegmentationGroupList, function (segmentationGroup) {
							if (segmentationGroup.SegmentationGroup.toString().toUpperCase() === element.SegmentationGroup.toString().trim().toUpperCase()) {
								var segmentations = segmentationGroup.Segmentations.split(',');
								if (segmentations && segmentations.length > 0) {
									for (var index = 0; index < segmentations.length; index++) {
										var segmentationInfoMap = { SID: segmentations[index], S: 1 };
											// group import has no planning-value column; apply the configured default to each assignment
											if (activeCatalog.SegmentationPlanningEnable === 1) {
												segmentationInfoMap.PlanningValue = api.getSegmentationPlanningDefault();
											}
										newElement.S.push(segmentationInfoMap);
									}
								}
							}
						})
					}
				}

				transformedData.push(newElement);
			});

			var jobIndex = jobsTracker.addJob(model, 'SEGMENTATION.ACTIONS.IMPORT_SEGMENTATIONS', 1, secondaryModel);
			api.webPut(api.baseUrl + '/catalogs/' + activeCatalog.CatalogCode + '/articlesSegmentations?sourceapplication=' + CONSTANTS.SOURCE_APPLICATION + '&sourceaction=Import Article Segmentations', transformedData).then(function (response) {
				jobsTracker.trackJob(jobIndex, response.data.Id);
			}).catch(function (error) {
				jobsTracker.setCriticlaFail(jobIndex, error);
			});

		}

		function updateBulk(model, records, updateRecord, idMap, parentModel) {
			var secondaryModel = api.catalogArticles.segmentationLinear;
			//Transform data into required format
			var transformedData = [];
			angular.forEach(records, function(record) {
				var newRecord = { AN: record.ArticleNumber, S: [] };
				angular.forEach(model.fields, function(field) {
					if (field.isCatalogProperty) {
						if(angular.isDefined(updateRecord[field.field])) {
							if (idMap.isSegmentationPlanningEnable !== 1) {

								var segmentationInfoMap = { SID: field.importField, S: 0 };

								if (updateRecord[field.field].toString().toUpperCase() === 'YES') {
									segmentationInfoMap.S = 1;
								}
								newRecord.S.push(segmentationInfoMap);
							} else {
								var segmentationInfoMap = { SID: field.importField, S: 0, PlanningValue: '' };
								if (updateRecord[field.field].toString().toUpperCase() === 'YES') {
									segmentationInfoMap.S = 1;
									// the bulk updater stores the selected planning value; send it verbatim
									segmentationInfoMap.PlanningValue = updateRecord[field.field+'PlanningValue'] || api.getSegmentationPlanningDefault();

								}
								newRecord.S.push(segmentationInfoMap);
							}
						}
					}
				});
				if(newRecord.S.length) {
					transformedData.push(newRecord);
				}
			});

			if( angular.isDefined(parentModel)) {
				model = parentModel;
			}

			var jobIndex = jobsTracker.addJob(model, 'SEGMENTATION.ACTIONS.UPDATE_SEGMENTATIONS', 1, secondaryModel);
			api.webPut(api.baseUrl + '/catalogs/' + idMap.catalogId + '/articlesSegmentations?sourceapplication=' + CONSTANTS.SOURCE_APPLICATION + '&sourceaction=Update Article Segmentations', transformedData).then(function(response) {
				api.catalogArticles.segmentation.isDirty = true;
				jobsTracker.trackJob(jobIndex, response.data.Id);
			}).catch(function(error) {
				jobsTracker.setCriticlaFail(jobIndex, error);
			});
		}

		function updateSegmentationViaImportModel(model, data, activeCatalog) {
			var secondaryModel = api.catalogArticles.segmentationLinear;
			//Transform data into required format
			var transformedData = [];
			angular.forEach(data, function (element) {
				var newElement = { ModelNumber: element.ModelNumber, S: [] };

				angular.forEach(model.fields, function (field) {
					if (field.isCatalogProperty) {
						var segSheetVal = element[field.field];
						if (angular.isDefined(segSheetVal)) {
							var upperCaseValue = segSheetVal.toString().trim().toUpperCase();
							if (activeCatalog.SegmentationPlanningEnable !== 1) {
								var segmentationInfoMap = { SID: field.importField, S: 0 };

								if (upperCaseValue !== '' && upperCaseValue !== '0' && upperCaseValue !== 'NO' && upperCaseValue !== 'FALSE' && upperCaseValue !== 'NOT AVAILABLE') {
									segmentationInfoMap.S = 1;
								}
								newElement.S.push(segmentationInfoMap);
							} else {
								var segmentationInfoMap = { SID: field.importField, S: 0, PlanningValue: "" };
								// The import validator (dataImporter) has already normalized the cell to a configured planning
								// value, '' (blank) or an unassign token: exported 'Yes' cells become the configured default there.
								// Assign with the matched configured value; anything else leaves the segmentation unassigned.
								var planningValue = api.matchSegmentationPlanningValue(segSheetVal);
								if (planningValue) {
									segmentationInfoMap.S = 1;
									segmentationInfoMap.PlanningValue = planningValue;
								}
								newElement.S.push(segmentationInfoMap);
							}
						}
					}
				});

				if (newElement.S.length) {
					transformedData.push(newElement);
				}
			});
			var jobIndex = jobsTracker.addJob(model, 'SEGMENTATION.ACTIONS.UPDATE_SEGMENTATION_VIA_IMPORT_MODEL', 1, secondaryModel);

			api.webPut(api.baseUrl + '/catalogs/' + activeCatalog.CatalogCode + '/importarticlesegmentationbymodels?sourceapplication=' + CONSTANTS.SOURCE_APPLICATION + '&sourceaction=Update Article Segmentation Via Import(Model)', transformedData).then(function(response) {
				jobsTracker.trackJob(jobIndex, response.data.Id);
			}).catch(function(error) {
				jobsTracker.setCriticlaFail(jobIndex, error);
			});
		}
	}
})();
(function () {
	'use strict';

	angular
		.module('app.main.catalogs.saved-views')
		.run(runBlock);

	/* @ngInject */
	function runBlock(api, activityLogger, $state, jobsTracker, $localStorage, crud, CONSTANTS) {

		if (angular.isUndefined(api.catalogs)) {
			api.catalogs = {};
		}
		api.catalogs.savedViews = {
			modelPath: 'catalogs.savedViews',
			fields: [
				{ field: 'Id', type: 'int', displayLabel: 'SAVED_VIEWS.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
					validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } } },
				{ field: 'Name', type: 'text', displayLabel: 'SAVED_VIEWS.FIELDS.NAME', visible: true, creatable: true, editable: true, inputType: 'text',
					validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'IsCatalogLevel', type: 'text', displayLabel: 'SAVED_VIEWS.FIELDS.IS_CATALOG_LEVEL', visible: true, creatable: false, editable: false, inputType: 'bool',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'RowDivider', type: 'text', displayLabel: 'SAVED_VIEWS.FIELDS.ROW_DIVIDER', visible: true, creatable: true, editable: true, inputType: 'text',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'ColumnDivider', type: 'text', displayLabel: 'SAVED_VIEWS.FIELDS.COLUMN_DIVIDER', visible: true, creatable: true, editable: true, inputType: 'text',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'ColumnWidth', type: 'text', displayLabel: 'SAVED_VIEWS.FIELDS.COLUMN_WIDTH', visible: true, creatable: true, editable: true, inputType: 'text',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'ImageType', type: 'text', displayLabel: 'SAVED_VIEWS.FIELDS.IMAGE_TYPE', visible: true, creatable: true, editable: true, inputType: 'text',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'BrowseByAttribute', type: 'text', displayLabel: 'SAVED_VIEWS.FIELDS.BROWSE_BY_ATTRIBUTE', visible: true, creatable: true, editable: true, inputType: 'text',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'SeasonFilterApplied', type: 'text', displayLabel: 'SAVED_VIEWS.FIELDS.SEASON_FILTER_APPLIED', visible: true, creatable: true, editable: true, inputType: 'bool',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'SortOrderList', type: 'text', displayLabel: 'SAVED_VIEWS.FIELDS.SORT_ORDER_LIST', visible: true, creatable: true, editable: true, inputType: 'text',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'CustomSort', type: 'text', displayLabel: 'SAVED_VIEWS.FIELDS.CUSTOM_SORT', visible: true, creatable: true, editable: true, inputType: 'textArea',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'FavoriteTags', type: 'text', displayLabel: 'SAVED_VIEWS.FIELDS.FAVORITE_TAGS', visible: true, creatable: true, editable: true, inputType: 'textArea',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'Filter', type: 'text', displayLabel: 'SAVED_VIEWS.FIELDS.FILTER', visible: true, creatable: true, editable: true, inputType: 'textArea',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'Json', type: 'text', displayLabel: 'SAVED_VIEWS.FIELDS.JSON', visible: true, creatable: true, editable: true, inputType: 'textArea',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', checkIfValidJson: true, messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '', isValidJson: 'VALIDATIONS.INVALID_JSON'}} },
				{ field: 'Version', type: 'int', displayLabel: 'SAVED_VIEWS.FIELDS.VERSION', visible: true, creatable: false, editable: false, inputType: 'number',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'Status', type: 'text', displayLabel: 'SAVED_VIEWS.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'CreatedDate', type: 'text', displayLabel: 'SAVED_VIEWS.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
					validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } } },
				{ field: 'UpdatedDate', type: 'text', displayLabel: 'SAVED_VIEWS.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
					validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } } },
				{ field: 'CreatedBy', type: 'text', displayLabel: 'SAVED_VIEWS.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
					validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } } },
				{ field: 'UpdatedBy', type: 'text', displayLabel: 'SAVED_VIEWS.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
					validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } } },
				{ field: 'isMySavedView', type: 'text', displayLabel: '', visible: false, creatable: false, editable: false, inputType: 'text',
					validation: {isRequired: true, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
			],
			uniqueConstraints: [{name: 'Constraint 1', fields: ['Name']}],
			title: 'SAVED_VIEWS.NAV',
			icon: 'icon-bookmark',
			idField: 'Id',
			lookupDisplayField: 'Name',
			isDirty: false,
			methods: {
				getList       : getSavedViewsList,
				createBulk    : createBulk,
				getDetails    : getSavedViewDetails,
				update        : updateSavedView,
				activateBulk  : activateBulk
			},
			views: {
				mainList: {
					columns: ['Name', 'CatalogName', 'IsCatalogLevel', 'RowDivider', 'Status', 'UpdatedBy', 'UpdatedDate'],
					columnFilter: {},
					toggleFilterProps: {},
					topIndex: 0,
					showFilterRow: false,
					sortColumn: {'UpdatedDate': false},
					sortDescending: true,
					itemActions: [
												{ id: 'view', label: 'ACTIONS.VIEW', icon: 'icon-magnify', privilege: 'GetSavedViewDetails', disabled: false, visible: true },
												{ id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UpdateSavedViews:true', disabled: '!itm.isMySavedView', visible: true },
												{ id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateSavedViewsStatus', disabled: '!itm.isMySavedView', visible: 'itm.Status',
													requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
												{ id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateSavedViewsStatus', disabled: '!itm.isMySavedView', visible: '!itm.Status',
													requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
					],
					listActions: [
												{ id: 'import', label: 'ACTIONS.IMPORT', icon: 'icon-import', privilege: 'ImportSavedViews:true', disabled: false, visible: true, requiresConfirmation: false},
												{ id: 'delete', label: 'ACTIONS.DELETE_BULK', icon: 'icon-delete', privilege: 'UpdateSavedViewsStatus', disabled: '{selected: true, Status: 1, isMySavedView: true}', visible: true,
													requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
												{ id: 'activate', label: 'ACTIONS.ACTIVATE_BULK', icon: 'icon-undo-variant', privilege: 'UpdateSavedViewsStatus', disabled: '{selected: true, Status: 0, isMySavedView: true}', visible: true,
													requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
											],
					fabAction   :     {}
				},
				mainDetails: {
					selectedTabIndex : 0,
					itemActions : [
													{ id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateSavedViewsStatus', disabled: '{selected: true, Status: 1, isMySavedView: true}',
															visible: true, requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'},confirmationAction: 'ACTIONS.DELETE'},
													{ id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateSavedViewsStatus', disabled: '{selected: true, Status: 0, isMySavedView: true}',
															visible: true, requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
												],
					fab           : {id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UpdateSavedViews:true', visible: true}
				},
				privileges: {
					list: 'GetAllSavedViews',
					details : 'GetSavedViewDetails'
				}
			}
		};

		function getSavedViewsList(generalProperties, model, catalogCode) {
			if (angular.isDefined(model)) { // to skip this part for load lookup
				model.isBulkActionCompleted = false;
			}
			var promise;

			if (angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
				var state = {};
				state.name = $state.current.name;
				state.params = $state.params;
				var isBulk = true;
				var logData = activityLogger.createLogData(null, state, 'catalogs.savedViews', 'VIEW', isBulk, new Date(), null, null);

				promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/savedviews', undefined, true, generalProperties.forceFetch);
				promise = activityLogger.log(logData, promise);
			}
			else {
				promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/savedviews', undefined, true, generalProperties.forceFetch);
			}

			promise.then(function (response) {
				if(response.data && response.data.length > 0) {
					angular.forEach(response.data, function(response) {
						if((response.CreatedBy === $localStorage.UserId) || (angular.isDefined($localStorage.account) && $localStorage.account.accountType == 1)) {
							response.isMySavedView = true;
						} else {
							response.isMySavedView = false;
						}
					});
				}
				if (api.catalogs.savedViews.isDirty) {
					//Invalidate lookupData
					api.catalogs.savedViews.lookupData = undefined;
					api.catalogs.savedViews.isDirty = false;
				}
			});
			return promise;
		}

		function createBulk(model, data, catalogCode) {
			var jobIndex = jobsTracker.addJob(model, 'SAVED_VIEWS.ACTIONS.IMPORT_SAVED_VIEWS', 1);
			api.webPut(api.baseUrl + '/catalogs/' + catalogCode + '/savedviews?sourceapplication=' + CONSTANTS.SOURCE_APPLICATION + '&sourceaction=Import Saved Views', data).then(function(response) {
				jobsTracker.trackJob(jobIndex, response.data.Id);
			}).catch(function(error) {
				jobsTracker.setCriticlaFail(jobIndex, error);
			});
		}

		function getSavedViewDetails(isLogRequired, savedViewId, catalogCode) {
			var promise;
			if(angular.isDefined(isLogRequired) && isLogRequired === true) {
				var state = {};
				state.name = $state.current.name;
				state.params = $state.params;
				var isBulk = false;
				var items = [];
				promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/savedviews/' + savedViewId);
				promise.then(function(response) {
					items.push(response.data[api.catalogs.savedViews.lookupDisplayField]);
				});
				var logData = activityLogger.createLogData(items, state, 'catalogs.savedViews', 'VIEW', isBulk, new Date(), null, null);
				promise = activityLogger.log(logData, promise);
			}
			else {
				promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/savedviews/' + savedViewId);
			}

			promise.then(function (response) {
				if(response.data) {
						// enable edit and delete for admin users
						if((response.data.CreatedBy === $localStorage.UserId) || (angular.isDefined($localStorage.account) && $localStorage.account.accountType == 1)) {
							response.data.isMySavedView = true;
						} else {
							response.data.isMySavedView = false;
						}
				}
			});

			return promise;
		}

		function updateSavedView(savedViewId, record, catalogCode) {
			var state = {};
			state.name = $state.current.name;
			state.params = $state.params;
			var logData = activityLogger.createLogData(record[api.catalogs.savedViews.lookupDisplayField], state, 'catalogs.savedViews', 'EDIT', false, new Date(), null, null);
			var promise = api.webPut(api.baseUrl + '/catalogs/' + catalogCode + '/savedviews/' + savedViewId, record);

			promise.then(function () {
				api.catalogs.savedViews.isDirty = true;
			});
			return activityLogger.log(logData, promise);
		}

		function activateBulk(records, model, actionType, catalogCode) {
			var result = crud.createRequestObject(records, model, actionType);
			var state = {};
			state.name = $state.current.name;
			state.params = $state.params;
			var isBulk = result.itemsNameList.length > 1 ? true : false;
			var logData = activityLogger.createLogData(result.itemsNameList, state, 'catalogs.savedViews', actionType.toUpperCase(), isBulk, new Date(), null, null);
			var promise = api.webPut(api.baseUrl + '/catalogs/' + catalogCode + '/savedviews/status', result.requestObj);

			promise.then(function () {
				crud.onRecordStatusChange(records, api.catalog.favorites, actionType);
			});

			return activityLogger.log(logData, promise);
		}

	}
})();
(function() {
    'use strict';

    angular
        .module('app.main.catalogs.resources')
        .run(runBlock);

    /* @ngInject */
    function runBlock(api, activityLogger, $state, catalogFactory, crud, jobsTracker, utility, CONSTANTS) {

        if (angular.isUndefined(api.catalogs)) {
            api.catalogs = {};
        }
         api.catalogs.resources = {
            modelPath: 'catalogs.resources',
            fields: [
                { field: 'IsModelLevel', type: 'text', displayLabel: 'RESOURCES.FIELDS.IS_MODEL_LEVEL', visible: false, creatable: true, editable: false, inputType: 'bool-int',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ArticleIds', type: 'int', displayLabel: 'RESOURCES.FIELDS.ARTICLE_NUMBER', visible: false, creatable: true, editable: true, inputType: 'lookup-many', lookupSource: 'catalogs.articles',
                    lookupFilter: {Status: 1}, validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ModelIds', type: 'int', displayLabel: 'RESOURCES.FIELDS.MODEL_NUMBER', visible: false, creatable: true, editable: true, inputType: 'lookup-many', lookupSource: 'catalogs.models',
                    lookupFilter: {Status: 1}, validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ResourceId', type: 'int', displayLabel: 'RESOURCES.FIELDS.RESOURCE_ID', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Resource', type: 'int', displayLabel: 'RESOURCES.FIELDS.RESOURCE', visible: true, creatable: false, editable: false, inputType: 'calculated-url', calculatedExpression: 'data["Resource"]',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'RefResourceId', type: 'int', displayLabel: 'RESOURCES.FIELDS.REF_RESOURCE_ID', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'TypeId', type: 'text', displayLabel: 'RESOURCES.FIELDS.RESOURCE_TYPE_ID', visible: true, creatable: true, editable: true, inputType: 'lookup', lookupSource: 'lists.resourceTypes',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ResourceName', type: 'text', displayLabel: 'RESOURCES.FIELDS.RESOURCE_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: 50, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'FileName', type: 'text', displayLabel: 'RESOURCES.FIELDS.FILE_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'FilePath', type: 'text', displayLabel: 'RESOURCES.FIELDS.FILE_PATH', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: ' Icon', type: 'text', displayLabel: 'RESOURCES.FIELDS.ICON', visible: true, creatable: true, editable: true, inputType: 'calculated-url', calculatedExpression: 'data["Icon"]',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Description', type: 'text', displayLabel: 'RESOURCES.FIELDS.DESCRIPTION', visible: true, creatable: true, editable: true, inputType: 'text',
                    validation: {isRequired: false, maxLen: 2000, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Category', type: 'text', displayLabel: 'RESOURCES.FIELDS.CATEGORY', visible: true, creatable: true, editable: true, inputType: 'text',
                    validation: {isRequired: false, maxLen: 1000, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Cascading', type: 'text', displayLabel: 'RESOURCES.FIELDS.CASCADING', visible: true, creatable: true, editable: true, inputType: 'bool-int',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Status', type: 'text', displayLabel: 'RESOURCES.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'SortOrder', type: 'int', displayLabel: 'RESOURCES.FIELDS.SORT_ORDER', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '[0-9]+', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: 'VALIDATIONS.INVALID_SORT_ORDER'}} },
                { field: 'CreatedDate', type: 'text', displayLabel: 'RESOURCES.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedDate', type: 'text', displayLabel: 'RESOURCES.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedBy', type: 'text', displayLabel: 'RESOURCES.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedBy', type: 'text', displayLabel: 'RESOURCES.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
            ],
            uniqueConstraints: [],
            title: 'RESOURCES.NAV',
            icon: 'icon-image-filter-black-white',
            idField: 'ResourceId',
            lookupDisplayField: 'ResourceName',
            isDirty: false,
            isCatalogSpecificModel: true,
            methods: {
            getList                         :   getResources,
                getDetails                  :   getResource,
                activateBulk                :   activateResources,
                create                      :   createResource,
                update                      :   updateResource,
                uploadBulk                  :   uploadBulkResources,
                createBulk                  :   createBulkResources,
                getMasterCatalogResources   :   getMasterCatalogResources,
                copyResources               :   copyResources,
                editSortOrder               :   editSortOrder
            },
            views: {
                mainList: {
                    columns         : [ 'ResourceName', 'ResourceId', 'ResourceTypeId', 'Status', 'UpdatedDate' ],
                    columnFilter    : {},
                    toggleFilterProps: { toggleStatus:false, filterProp:'Status', trueVal:1, trueValTooltipMessage: 'ACTIONS.TOGGLE_ACTIVE', falseVal:'', falseValTooltipMessage:"ACTIONS.TOGGLE_ALL"},
                    topIndex        : 0,
                    showFilterRow   : false,
                    sortColumn      : {'UpdatedDate': false},
                    itemActions     : [
                                        { id: 'view', label: 'ACTIONS.VIEW', icon: 'icon-magnify', privilege: 'GetCatalogResourceList', disabled: '!itm.Status', visible: true },
                                        { id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UpdateCataloResource:true', disabled: '!itm.Status || !itm.ResourceId', visible: true },
                                        { id: 'editSortOrder', label: 'RESOURCES.ACTIONS.EDIT_SORTORDER', icon: 'icon-pencil', privilege: 'UpdateBulkCatalogResourceSortOrder:true', disabled: '!itm.Status', visible: true },
                                        { id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateBulkCatalogResourceStatus:true', disabled: false, visible: 'itm.Status',
                                            requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                                        { id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateBulkCatalogResourceStatus:true', disabled: false, visible: '!itm.Status',
                                            requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
                                      ],
                    listActions     : [
                                        { id: 'delete', label: 'ACTIONS.DELETE_BULK', icon: 'icon-delete', privilege: 'UpdateBulkCatalogResourceStatus:true', disabled: '{selected: true, Status: 1}', visible: true,
                                            requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                                        { id: 'activate', label: 'ACTIONS.ACTIVATE_BULK', icon: 'icon-undo-variant', privilege: 'UpdateBulkCatalogResourceStatus:true', disabled: '{selected: true, Status: 0}', visible: true,
                                            requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'},
                                        { id: 'upload', label: 'RESOURCES.ACTIONS.UPLOAD', icon: 'icon-upload', privilege: 'CreateBulkResource:true', disabled: false, visible: true, requiresConfirmation: false},
                                        { id: 'import', label: 'RESOURCES.ACTIONS.MAP', icon: 'icon-import', privilege: 'UpdateBulkResource:true', disabled: false, visible: true, requiresConfirmation: false},
                                        { id: 'copyResources', label: 'RESOURCES.ACTIONS.COPY_RESOURCES', icon: 'icon-content-copy', privilege: 'UpdateBulkResource', disabled: false, visible: false, requiresConfirmation: false},
                                        { id: 'editBulkSortOrder', label: 'RESOURCES.ACTIONS.EDIT_BULK_SORTORDER_CATEGORY', icon: 'icon-pencil', privilege: 'UpdateBulkCatalogResourceSortOrder:true', disabled: '{selected: true, Status: 1}', visible: true, requiresConfirmation: false }
                                      ],
                    fabAction       : {id: 'add', label: 'ACTIONS.ADD', icon: 'icon-plus', privilege: 'CreateResourceWithArticlesOptional:true', visible: true}
                 },
                 mainDetails: {
                     selectedTabIndex   : 0,
                     itemActions        : [
                                            { id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateBulkCatalogResourceStatus:true', disabled: '{selected: true, Status: 1}',
                                                visible: true, requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                                            { id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateBulkCatalogResourceStatus:true', disabled: '{selected: true, Status: 0}',
                                                visible: true, requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
                                          ],
                    fab                 : {id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UpdateCataloResource:true', visible: 'true'}

                 },
                privileges: {
                    list    : 'GetCatalogResourceList',
                    details : 'GetCatalogResourceDetails'
                }
            }
        };

        //dataExistConstraints will validate excel data with existing data in database
        api.resources.mapToArticles = {
            modelPath: 'resources.mapToArticles',
            fields: [
                {field: 'ArticleNumber', type: 'test', displayLabel: 'RESOURCES.FIELDS.ARTICLE_NUMBER', visible: true, creatable: true, editable: false, inputType: 'lookup',
                    lookupSource: 'catalogs.articles', lookupFilter: {Status: 1}, useLookupName: true, validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '' } },
                { field: 'FileName', type: 'text', displayLabel: 'RESOURCES.FIELDS.FILE_NAME', visible: true, creatable: true, editable: false, inputType: 'text',
                    validation: {isRequired: true, maxLen: 250, minLen: 1, pattern: '', dataExistConstraints:{modelPath: 'catalogs.resources', data: []} } },
                { field: 'ResourceName', type: 'text', displayLabel: 'RESOURCES.FIELDS.RESOURCE_NAME', visible: true, creatable: true, editable: false, inputType: 'text',
                    validation: {isRequired: true, maxLen: 250, minLen: 1, pattern: '' } },
                { field: 'TypeId', type: 'text', displayLabel: 'RESOURCES.FIELDS.RESOURCE_TYPE_ID', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '' } }

            ],
            uniqueConstraints: [
                {name: 'Constraint 1', fields: ['FileName','ArticleNumber']}
            ],
            title: 'RESOURCES.NAV',
            icon: 'icon-image-filter-black-white',
            idField: 'ResourceId',
            lookupDisplayField: 'ResourceName',
            isDirty: false,
            isCatalogSpecificModel: true,
            methods: {},
            views: {
                mainList: {},
                mainDetails: {},
                privileges: {
                    list    : 'GetCatalogResourceList',
                    details : 'GetCatalogResourceDetails'
                }
            }
        };

        //dataExistConstraints will validate excel data with existing data in database
        api.resources.mapToModels = {
            modelPath: 'resources.mapToModels',
            fields: [
                {field: 'ModelNumber', type: 'text', displayLabel: 'SELLER_MODELS.FIELDS.MODEL_NUMBER', visible: true, creatable: true, editable: false, inputType: 'lookup',
                    lookupSource: 'catalogs.models', lookupFilter: {Status: 1}, useLookupName: true, validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '' } },
                { field: 'FileName', type: 'text', displayLabel: 'RESOURCES.FIELDS.FILE_NAME', visible: true, creatable: true, editable: false, inputType: 'text',
                    validation: {isRequired: true, maxLen: 250, minLen: 1, pattern: '', dataExistConstraints:{modelPath: 'catalogs.resources', data: []} } },
                { field: 'ResourceName', type: 'text', displayLabel: 'RESOURCES.FIELDS.RESOURCE_NAME', visible: true, creatable: true, editable: false, inputType: 'text',
                    validation: {isRequired: true, maxLen: 250, minLen: 1, pattern: '' } },
                { field: 'TypeId', type: 'text', displayLabel: 'RESOURCES.FIELDS.RESOURCE_TYPE_ID', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '' } }
            ],
            uniqueConstraints: [
                {name: 'Constraint 1', fields: ['FileName','ModelNumber']}
            ],
            title: 'RESOURCES.NAV',
            icon: 'icon-image-filter-black-white',
            idField: 'ResourceId',
            lookupDisplayField: 'ResourceName',
            isDirty: false,
            isCatalogSpecificModel: true,
            methods: {},
            views: {
                mainList: {},
                mainDetails: {},
                privileges: {
                    list    : 'GetCatalogResourceList',
                    details : 'GetCatalogResourceDetails'
                }
            }
        };

        function getResources(generalProperties, model, catalogId) {
            if(angular.isDefined(model)) { // to skip this part for load lookup
                model.isBulkActionCompleted = false;
            }
            var promise;

            if(angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
                var state = {};
                state.name = $state.current.name;
                state.params = $state.params;
                var isBulk = true;
                var logData = activityLogger.createLogData(null, state, 'catalogs.resources', 'VIEW', isBulk, new Date(), null, null);

                promise = api.webGet(api.baseUrl + '/catalogs/' + catalogId + '/resources', undefined, true, generalProperties.forceFetch);
                promise = activityLogger.log(logData, promise);
            }
            else {
                catalogId = angular.isUndefined(catalogId) ? catalogFactory.getActiveCatalog().CatalogCode : catalogId;
                promise = api.webGet(api.baseUrl + '/catalogs/' + catalogId + '/resources', undefined, true, true);
            }

            promise.then(function() {
                if (api.catalogs.resources.isDirty) {
                    //Invalidate lookupData
                    api.catalogs.resources.lookupData = undefined;
                    api.catalogs.resources.isDirty = false;
                }
            });
            return promise;
		}

        function getResource(isLogRequired, resourceId, catalogId) {
            var promise;
            if(angular.isDefined(isLogRequired) && isLogRequired === true) {
                var state = {};
                state.name = $state.current.name;
                state.params = $state.params;
                var isBulk = false;
                var items = [];
                promise = api.webGet(api.baseUrl + '/catalogs/' + catalogId + '/resources/' + resourceId + '?status=0');
                promise.then(function(response) {
                    items.push(response.data[api.catalogs.resources.lookupDisplayField]);
                });
                var logData = activityLogger.createLogData(items, state, 'catalogs.resources', 'VIEW', isBulk, new Date(), null, null);
                promise = activityLogger.log(logData, promise);
            }
            else {
                promise = api.webGet(api.baseUrl + '/catalogs/' + catalogId + '/resources/' + resourceId + '?status=0');
            }
            return promise;
		}

		function activateResources(records, model, actionType, parentId) {
            //when resourceId is 0 and it has refResourceId then send refResourceId
            var resourceRecords = angular.copy(records);
            if(angular.isArray(resourceRecords)) {
                angular.forEach(resourceRecords, function(record) {
                    if(record.ResourceId === 0 && record.RefResourceId > 0) {
                        record.ResourceId = record.RefResourceId;
                    }
                })
            } else {
                if(resourceRecords.ResourceId === 0 && resourceRecords.RefResourceId > 0) {
                    resourceRecords.ResourceId = resourceRecords.RefResourceId;
                }
            }

            var result = crud.createRequestObject(resourceRecords, model, actionType);
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var isBulk = result.itemsNameList.length > 1 ? true : false;
            var logData = activityLogger.createLogData(result.itemsNameList, state, 'catalogs.resources', actionType.toUpperCase(), isBulk, new Date(), null, null);
            var promise = api.webPut(api.baseUrl + '/catalogs/' + parentId + '/resources/status', result.requestObj);

             promise.then(function() {
                crud.onRecordStatusChange(records, model, actionType);
            });

            return activityLogger.log(logData, promise);
        }

		function createResource(record, catalogId) {
            // Derive IsModelLevel: 1 (models), 0 (articles), null (neither)
            var hasModels = angular.isArray(record.ModelIds) && record.ModelIds.length > 0;
            var hasArticles = angular.isArray(record.ArticleIds) && record.ArticleIds.length > 0;
            record.IsModelLevel = hasModels ? 1 : (hasArticles ? 0 : null);
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var logData = activityLogger.createLogData(record[api.catalogs.resources.lookupDisplayField], state, 'catalogs.resources', 'ADD', false, new Date(), null, null);
            var promise = api.webPost(api.baseUrl + '/catalogs/' + catalogId + '/resources', record);

            promise.then(function() {
                api.catalogs.resources.isDirty = true;
            });
            return activityLogger.log(logData, promise);
		}

        function updateResource(recordId, record, catalogId) {
            // Map response lists back to IDs for the API
            if(record.ArticleResponseList) {
                record.ArticleIds = record.ArticleResponseList.map(function(a) { return a.ArticleId || a.Id; });
                delete record.ArticleResponseList;
            }
            if(record.ModelResponseList) {
                record.ModelIds = record.ModelResponseList.map(function(m) { return m.ModelId || m.Id; });
                delete record.ModelResponseList;
            }
            var hasModels = angular.isArray(record.ModelIds) && record.ModelIds.length > 0;
            var hasArticles = angular.isArray(record.ArticleIds) && record.ArticleIds.length > 0;
            record.IsModelLevel = hasModels ? 1 : (hasArticles ? 0 : null);
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var logData = activityLogger.createLogData(record[api.catalogs.resources.lookupDisplayField], state, 'catalogs.resources', 'EDIT', false, new Date(), null, null);
            var promise = api.webPut(api.baseUrl + '/catalogs/' + catalogId + '/resources/' + recordId, record);

            promise.then(function() {
                api.catalogs.resources.isDirty = true;
            });
            return activityLogger.log(logData, promise);
		}

        function uploadBulkResources(data, resourceType, catalogId, model) {
            var requestObj ={};
            requestObj.FileId = data;
            for(var prop in resourceType) {
                requestObj[prop] = resourceType[prop];
            }
            var jobIndex = jobsTracker.addJob(model, 'RESOURCES.ACTIONS.UPLOAD', 1);
            //TODO: Temporary using POST! Must use PUT instead
            return api.webPost(api.baseUrl + '/catalogs/' + catalogId + '/processresources?sourceapplication=' + CONSTANTS.SOURCE_APPLICATION + '&sourceaction=Upload Resources', requestObj).then(function(response) {
                jobsTracker.trackJob(jobIndex, response.data.Id);
            });
        }

        function createBulkResources(model, records, catalogCode, isModelLevel) {
            var requestArray = [];
            var fileNameIndexObj = {};
            angular.forEach(records, function(record) {
                var entityValue = isModelLevel ? record.ModelNumber : record.ArticleNumber;
                var entityField = isModelLevel ? 'Models' : 'Articles';
                var groupKey = record.FileName;

                if(angular.isDefined(fileNameIndexObj[groupKey])) {
                    requestArray[fileNameIndexObj[groupKey]][entityField].push(entityValue);
                }
                else {
                    var requestObj = {
                        FileName: record.FileName,
                        ResourceName: record.ResourceName,
                        Articles: [],
                        Models: []
                    };
                    fileNameIndexObj[groupKey] = requestArray.length;
                    requestObj[entityField].push(entityValue);
                    requestArray.push(requestObj);
                }
            });
            var jobIndex = jobsTracker.addJob(model, 'RESOURCES.ACTIONS.IMPORT', 1);

            return api.webPut(api.baseUrl + '/catalogs/' + catalogCode + '/assignresources?sourceapplication=' + CONSTANTS.SOURCE_APPLICATION + '&sourceaction=Map Resources to Colorways', requestArray).then(function(response) {
                jobsTracker.trackJob(jobIndex, response.data.Id);
            });
        }

        function getMasterCatalogResources(generalProperties, catalogId) {
            var promise;
            catalogId = angular.isUndefined(catalogId) ? catalogFactory.getActiveCatalog().CatalogCode : catalogId;
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var isBulk = true;
            var logData = activityLogger.createLogData(null, state, 'catalogs.resources', 'VIEW', isBulk, new Date(), null, null);
            promise = api.webGet(api.baseUrl + '/catalogs/' + catalogId + '/availablecatalogresources', undefined, true, generalProperties.forceFetch);
            promise = activityLogger.log(logData, promise);
            promise.then(function () {
                if (api.catalogs.resources.isDirty) {
                    //Invalidate lookupData
                    api.catalogs.resources.lookupData = undefined;
                    api.catalogs.resources.isDirty = false;
                }
            });
            return promise;
        }

        function copyResources(records, catalogId) {
            var promise = api.webPost(api.baseUrl + '/catalogs/' + catalogId + '/copycatalogresources', records);
            promise.then(function() {
                api.catalogs.resources.isDirty = true;
            });
        }

        function editSortOrder(records, updateRecord) {
            var catalogId = catalogFactory.getActiveCatalog().CatalogCode;
            // pushing single item to array
            if(!angular.isArray(records)) {
                records = utility.pushItemToArray(records);
            }
            var requestObj = [];
            angular.forEach(records, function (record) {
                if(record.ResourceId === 0 && record.RefResourceId > 0) {
                    record.ResourceId = record.RefResourceId;
                }
                if(angular.isDefined(updateRecord)) {
                    record.SortOrder = updateRecord['SortOrder'];
                    record.Category = updateRecord['Category'];
                }
                var resourceObj = {
                    ResourceId : record.ResourceId,
                    SortOrder: record.SortOrder,
                    Category : record.Category
                };
                requestObj.push(resourceObj);
            });

            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var logData = activityLogger.createLogData(records, state, 'catalogs.resources', 'EDIT', false, new Date(), null, null);
            var promise = api.webPut(api.baseUrl + '/catalogs/' + catalogId + '/resources/sortorder', requestObj);

            promise.then(function() {
               api.accounts.users.isDirty = true;
            });
            return activityLogger.log(logData, promise);
        }
    }
})();
(function () {
	'use strict';

	angular
		.module('app.main.catalogs.requests')
		.factory('requestsFactory', requestsFactory);

	/* @ngInject */
	function requestsFactory($q, utility, api, catalogFactory, CONSTANTS) {
		var dynamicModel = {};
		var assignedCatalogAttributes = catalogFactory.getActiveCatalogDetails().AssignedCatalogAttributes;
		var assignedCatalogRequestAttributes = catalogFactory.getActiveCatalogDetails().RequestAttributeList;
		var attributesFieldsList = generateAttributeFields(assignedCatalogAttributes);
		var sizeScaleIdNameMap = getAndGenerateSizeScaleIdNameMap();
		var articleStateIdNameMap = getAndGenerateArticleStateIdNameMap();
		var hasArticleLabel = angular.isDefined(api.articleLabelConfiguration) && api.articleLabelConfiguration !== '';
		var hasModelLabel = angular.isDefined(api.modelLabelConfiguration) && api.modelLabelConfiguration !== '';
		var service = {
			createRequestDetailsModel: createRequestDetailsModel,
			transformRequestDetailsResponse: transformRequestDetailsResponse,
			createParticipantsModel: createParticipantsModel,
			transformParticipantsResponse: transformParticipantsResponse,
			generateRequestIdsArray: generateRequestIdsArray,
			generateExportRequestData: generateExportRequestData,
			formatAuditTrailHistoryData: formatAuditTrailHistoryData,
			getRequestHistoryDisplayLabels: getRequestHistoryDisplayLabels,
			transformRequestResponse: transformRequestResponse
		};
		return service;

		function createRequestDetailsModel(requestId, activeCatalogCode) {
			var deferred = $q.defer();
			var requestDetailsModel = angular.copy(api.catalogs.requests);
			var requestDetailsPromise = {};
			var requestAttributeList = catalogFactory.getActiveCatalogDetails().RequestAttributeList;
			var requestAttributeFieldsList = generateAttributeFields(requestAttributeList);
			var allAttributes = attributesFieldsList.concat(requestAttributeFieldsList);
			var modelLevelAttributes = generateAttributeFields(catalogFactory.getActiveCatalogDetails().ModelLevelAttributeList);

			if (angular.isUndefined(dynamicModel['catalogs.requestDetails']) || angular.isUndefined(dynamicModel['catalogs.requestDetails'][requestId])) {
				dynamicModel['catalogs.requestDetails'] = {}; // remove any previously cached model as requested to recreate request details model every time
				dynamicModel['catalogs.requestDetails'][requestId] = requestDetailsModel;
			}

			var dynamicRequestDetailsModel = angular.copy(dynamicModel['catalogs.requestDetails'][requestId]);
			dynamicRequestDetailsModel.fields = requestDetailsModel.fields;// reassign pristine model fields if model is cached
			dynamicRequestDetailsModel.seasonlessModelfields = [];
			dynamicRequestDetailsModel.seasonalModelfields = [];
			dynamicRequestDetailsModel.articleFields = [];
			dynamicRequestDetailsModel.views.mainList.columns = requestDetailsModel.views.mainList.columns; // reassign pristine model default columns if model is cached

			var fieldTemplate = {
				field: '', map: '', type: 'text', displayLabel: '', visible: true, creatable: false, editable: false, inputType: '', isRequestField: true,
				validation: {
					isRequired: false, maxLen: -1, minLen: 1, pattern: '',
					messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' }
				}
			};
			angular.forEach(dynamicRequestDetailsModel.fields, function(field) {
				if(field.field === 'Reason' || field.field === 'Comment') {
					field.isRequestReasonField = true;
				}
			})

			var requestDetailsPromise = requestDetailsModel.methods.getDetails(false, requestId, activeCatalogCode);
			requestDetailsPromise.then(function (responses) {
				var request = responses.data;
				var requestContent = angular.fromJson(request.Content);
				if(request.RequestVersion === 2) {
					if (request.IsCreateArticleRequest) {
						// create the seasonless and seasonal model level attributes conside the first article for ref
						var firstRequestArticle = requestContent;
						// push ModelName and Model Number to model attributes
						// push request article number field
						fieldTemplate.field = 'ModelNumber';
						fieldTemplate.displayLabel = 'Model Number';
						fieldTemplate.map = 'ModelNumber';
						dynamicRequestDetailsModel.seasonlessModelfields.push(angular.copy(fieldTemplate));
						fieldTemplate.field = 'ModelName';
						fieldTemplate.displayLabel = 'Model Name';
						fieldTemplate.map = 'ModelName';
						dynamicRequestDetailsModel.seasonlessModelfields.push(angular.copy(fieldTemplate));
						angular.forEach(modelLevelAttributes, function(modelAttr) {
							if(angular.isDefined(firstRequestArticle[modelAttr.field]) && firstRequestArticle[modelAttr.field] !== null) {
								fieldTemplate.field = modelAttr.field;
								fieldTemplate.displayLabel = modelAttr.displayLabel;
								fieldTemplate.map = modelAttr.field;
								fieldTemplate.inputType = modelAttr.inputType;
								var modelAttribute = utility.filterObject(catalogFactory.getActiveCatalogDetails().ModelLevelAttributeList, { AttributeSystemName: fieldTemplate.field }, true)[0];
								if(modelAttribute.IsSeasonlessModelAttribute) {
									var fieldIndex = dynamicRequestDetailsModel.seasonlessModelfields.indexOf(utility.filterObject(dynamicRequestDetailsModel.seasonlessModelfields, { field: fieldTemplate.field }, true)[0]);
									if (fieldIndex === -1) {
										dynamicRequestDetailsModel.seasonlessModelfields.push(angular.copy(fieldTemplate));
									}
								} else {
									var fieldIndex = dynamicRequestDetailsModel.seasonalModelfields.indexOf(utility.filterObject(dynamicRequestDetailsModel.seasonalModelfields, { field: fieldTemplate.field }, true)[0]);
									if (fieldIndex === -1) {
										dynamicRequestDetailsModel.seasonalModelfields.push(angular.copy(fieldTemplate));
									}
								}
							}
						})

						// push request article number field
						fieldTemplate.field = 'ArticleNumber';
						fieldTemplate.displayLabel = 'Article Number';
						fieldTemplate.map = 'ArticleNumber';
						dynamicRequestDetailsModel.articleFields.push(angular.copy(fieldTemplate));

						angular.forEach(allAttributes, function(attribute) {
							// article properties
							if(angular.isDefined(attribute) && !attribute.isModelLevelAttribute && angular.isDefined(firstRequestArticle[attribute.field]) && firstRequestArticle[attribute.field] !== null) {
								fieldTemplate.field = attribute.field;
								fieldTemplate.displayLabel = attribute.displayLabel;
								fieldTemplate.map = attribute.field;
								fieldTemplate.inputType = attribute.inputType;
								var fieldIndex = dynamicRequestDetailsModel.articleFields.indexOf(utility.filterObject(dynamicRequestDetailsModel.articleFields, { field: fieldTemplate.field }, true)[0]);
								if (fieldIndex === -1) {
									dynamicRequestDetailsModel.articleFields.push(angular.copy(fieldTemplate));
								}
							}
						})
					}
					else { // edit attribute request
						var requestFields = utility.filterObject(dynamicRequestDetailsModel.fields, {isRequestField: true}, true);
						angular.forEach(requestFields, function(field) {
							field.visible = true;
						})
					}
				} else {
					for (var key in requestContent) {
						if(key !== 'carryForwardProps') {
							var attribute = utility.filterObject(allAttributes, {field: key}, true)[0];
							if(angular.isDefined(attribute)) {
								if(attribute.inputType === 'articlenumber') {
									fieldTemplate.inputType = attribute.inputType;
									fieldTemplate.lookupSource = 'catalogs.articles';
									fieldTemplate.lookupFilter = {'Status': 1};
								} else if(attribute.inputType === 'linkedcatalogarticlenumber') {
									fieldTemplate.inputType = attribute.inputType;
									fieldTemplate.lookupSource = 'lists.linkedCatalogArticles';
									fieldTemplate.lookupFilter = {'Status': 1};
								}
							}
							fieldTemplate.field = key;
							fieldTemplate.displayLabel = key;
							fieldTemplate.map = key;
							var fieldIndex = dynamicRequestDetailsModel.fields.indexOf(utility.filterObject(dynamicRequestDetailsModel.fields, { field: fieldTemplate.field }, true)[0]);
							if (fieldIndex === -1) {
								dynamicRequestDetailsModel.fields.push(angular.copy(fieldTemplate));
							}
						}
					}
				}
				deferred.resolve(dynamicRequestDetailsModel);
			});
			return deferred.promise;
		}

		/**
		 * @description
		 *
		 * @param {array}sourceData: source object (response of get request details)
		 * @param {array} fields: model fields
		 * @return {array}: List of transformed objects
		 */
		function transformRequestDetailsResponse(sourceData, model) {
			var result = {};
			for (var key in sourceData) {
				if (key.toUpperCase() === 'CONTENT') {
					if(sourceData.RequestVersion === 2) {
						var requestContent = angular.fromJson(sourceData.Content);
						if (sourceData.IsCreateArticleRequest) {
							var requestArticles = [];
							// fill model level attributes from first article
							var firstArticle = requestContent;
							// fill model.seasonlessModelfields and model.seasonalModelfields
							if(model.seasonlessModelfields && model.seasonlessModelfields.length) {
								angular.forEach(model.seasonlessModelfields, function(seasonlessAttr) {
									result[seasonlessAttr.field] = firstArticle[seasonlessAttr.field];
								})
							}

							if(model.seasonalModelfields && model.seasonalModelfields.length) {
								angular.forEach(model.seasonalModelfields, function(seasonalsAttr) {
									result[seasonalsAttr.field] = firstArticle[seasonalsAttr.field];
								})
							}

							var articleObj = {}
							for (var requestKey in requestContent) {
								if (requestContent.hasOwnProperty(requestKey)) {
									articleObj[requestKey] = requestContent[requestKey];
								}
							}
							requestArticles.push(articleObj);
							if(requestArticles.length) {
								result['requestArticles'] = requestArticles;
							}
						}
						else if (sourceData.RequestSource === 5) { // edit attribute requests
							var requestInitialContent = angular.fromJson(sourceData.InitialContent);
							var contentKey = Object.keys(requestContent)[0];
							var currentValue = requestInitialContent[contentKey];
							var requestedValue = requestContent[contentKey];
							var contentAttribute = utility.filterObject(attributesFieldsList, { field: contentKey }, true)[0];
							if (sourceData.RequestType === 'EditAttribute' && (contentAttribute && contentAttribute.inputType !== 'color-palette')) {
								result.ImpactedAttribute = contentAttribute.displayLabel;
								result.CurrentValue = utility.getAttributeTypeSpecificValue(contentAttribute, currentValue);
								result.RequestedValue = utility.getAttributeTypeSpecificValue(contentAttribute, requestedValue);
							}
							else { // static properties
								if (contentKey === CONSTANTS.REQUESTS.KEYS.PRICES) {
									result.ImpactedAttribute = CONSTANTS.REQUESTS.KEYS.PRICES;
									if (currentValue && Array.isArray(currentValue)) {
										result.CurrentValue = '';
										for (var i = 0; i < currentValue.length; i++) {
											var priceData = currentValue[i];
											if (priceData && priceData.hasOwnProperty('Name') && priceData.hasOwnProperty('Price')) {
												if (i !== 0) {
													result.CurrentValue += ', ';
												}
												result.CurrentValue += priceData.Name + ': ' + priceData.Price;
											}
										}
									}
									if (requestedValue && Array.isArray(requestedValue)) {
										result.RequestedValue = '';
										for (var i = 0; i < requestedValue.length; i++) {
											var priceData = requestedValue[i];
											if (priceData && priceData.hasOwnProperty('Name') && priceData.hasOwnProperty('Price')) {
												if (i !== 0) {
													result.RequestedValue += ', ';
												}
												result.RequestedValue += priceData.Name + ': ' + priceData.Price;
											}
										}
									}
								}
								else if(contentKey === CONSTANTS.REQUESTS.KEYS.STATUS) {
									result.ImpactedAttribute = CONSTANTS.REQUESTS.KEYS.STATUS;
									result.CurrentValue = currentValue === 1 ? 'Active' : 'Inactive';
									result.RequestedValue = requestedValue === 1 ? 'Active' : 'Inactive';
								}
								else if(contentKey === CONSTANTS.REQUESTS.KEYS.COLORID || (contentAttribute && contentAttribute.inputType === 'color-palette')) {
									result.ImpactedAttribute = contentKey === CONSTANTS.REQUESTS.KEYS.COLORID ? 'Primary Color' : contentAttribute.displayLabel;
									result.CurrentValue = currentValue ? currentValue : '';
									result.RequestedValue = requestedValue && Object.keys(requestedValue).length ? requestedValue[Object.keys(requestedValue)[0]] : '';
								}
								else if(contentKey === CONSTANTS.REQUESTS.KEYS.MODELNAME) {
									result.ImpactedAttribute = hasModelLabel ? api.modelLabelConfiguration + ' Name' : 'Model Name';
									result.CurrentValue = currentValue;
									result.RequestedValue = requestedValue;
								}
								else if(contentKey === CONSTANTS.REQUESTS.KEYS.SIZESCALE) {
									result.ImpactedAttribute = 'Size Scale';
									result.CurrentValue = currentValue;
									result.RequestedValue = sizeScaleIdNameMap[requestedValue] ? sizeScaleIdNameMap[requestedValue] : requestedValue;
								}
								else if(contentKey === CONSTANTS.REQUESTS.KEYS.STATENAME) {
									result.ImpactedAttribute = hasArticleLabel ? api.articleLabelConfiguration + ' State' : 'Article State';
									result.CurrentValue = currentValue;
									result.RequestedValue = articleStateIdNameMap[requestedValue] ? articleStateIdNameMap[requestedValue] : requestedValue;
								}
								result.disableAction = result.CatalogCode !== catalogFactory.getActiveCatalog().CatalogCode ? true : false;
							}
							// impacted seasons for prices
							if (sourceData.ImpactedCatalogs && sourceData.ImpactedCatalogs.length) {
								var uniqueSeasons = new Set(
									sourceData.ImpactedCatalogs.map(function(catalogItem) {
										return catalogItem.Season;
									})
								);
								result.ImpactedSeasons = Array.from(uniqueSeasons).join(',');
							}
						}
					} else {
						var requestContent = angular.fromJson(sourceData.Content);
						for (var requestKey in requestContent) {
							if (requestContent.hasOwnProperty(requestKey)) {
								result[requestKey] = requestContent[requestKey];
							}
						}
					}
				} else {
					if (sourceData.hasOwnProperty(key)) {
						result[key] = sourceData[key];
					}
					// if the request type is empty then check the flag IsCreateArticleRequest for requested article creation, if true then it is createArticleRequest else updateArticleRequest
					if(key.toLowerCase() === 'requesttype') {
						if(sourceData[key] === null || sourceData[key] === '') {
							result[key] = sourceData['IsCreateArticleRequest'] ? 'createArticleRequest' : 'updateArticleRequest';
						}
					}

					if(sourceData.RequestVersion === 2) {
						if(key.toLowerCase() === 'objectid') {
							if(sourceData[key]!= null && sourceData[key] !== '') {
								result['ArticleNumber'] = parseInt(sourceData[key]);
							} else {
								result['ArticleNumber'] = sourceData[key];
							}
						}
					}
				}
			}
			return result;
		}


		function createParticipantsModel(activeCatalogCode) {
			var participantsModel = api.requests.participants;
			var activeCatalogRequestAttributeList = catalogFactory.getActiveCatalogDetails().RequestAttributeList;
			if (activeCatalogRequestAttributeList.length > 0) {
				if (angular.isUndefined(dynamicModel['requests.participants']) || angular.isUndefined(dynamicModel['requests.participants'][activeCatalogCode])) {
					dynamicModel['requests.participants'] = {}; // remove any previously cached model as requested to recreate articleStatus model every time
					dynamicModel['requests.participants'][activeCatalogCode] = participantsModel;
				}

				var dynamicParticipantsDetailsModel = dynamicModel['requests.participants'][activeCatalogCode];
				dynamicParticipantsDetailsModel.fields = participantsModel.fields;
				dynamicParticipantsDetailsModel.views.mainList.columns = participantsModel.views.mainList.columns;
				var attributeFieldTemplate = {
					field: '', map: '', type: 'text', displayLabel: '', visible: true, creatable: false, editable: false, showInEdit: false, inputType: 'text', reportable: false,
					validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }
				};

				angular.forEach(activeCatalogRequestAttributeList, function (attribute) {
					var attributeField = angular.copy(attributeFieldTemplate);
					attributeField.isDynamicProperty = false;
					attributeField.isAttribute = true;
					attributeField.field = attribute.AttributeSystemName;
					attributeField.map = attribute.AttributeSystemName;
					attributeField.displayLabel = attribute.AttributeDisplayName;
					attributeField.supportFilterLookup = (attribute.SupportFilterLookup == true);
					attributeField.initialValue = attribute.InitialValueAttribute;
					attributeField.validation.pattern = attribute.ValidationExpression != '{}' ? attribute.ValidationExpression : '';
					attributeField.validation.messages.pattern = attribute.ValidationMessage;

					//To avoid creating dulpicate attributes.
					var isAttributeExists = false;
					for (var i = 0; i < dynamicParticipantsDetailsModel.fields.length; i++) {
						if (dynamicParticipantsDetailsModel.fields[i].field === attributeField.field) {
							isAttributeExists = true;
							break;
						}
					}

					if (!isAttributeExists) {
						//insert additional attributes fields before 'UpdatedDate' property in prices model
						var index = dynamicParticipantsDetailsModel.fields.indexOf(utility.filterObject(dynamicParticipantsDetailsModel.fields, { field: 'UpdatedDate' }, true)[0]);
						dynamicParticipantsDetailsModel.fields.splice(index, 0, angular.copy(attributeField));
					}
				});
				return dynamicParticipantsDetailsModel;
			} else {
				return participantsModel;
			}
		}

		/**
		* @description
		* transform request participants response object
		*
		* @param {array} sourceData source object
		* @param {string} nestedArrayName name of the nested array in sourceData
		* @param {array} fields model fields
		* @return {array} List of transformed objects
		*/
		function transformParticipantsResponse(sourceData, nestedArrayName, fields) {
			var result = [];
			//Create blank record
			var sameLevelFields = [];
			var flattenedRecord = {};

			angular.forEach(fields, function (field) {
				if (angular.isDefined(field.map)) {
					if (field.map.indexOf('.') === -1) {
						sameLevelFields.push(field);
						flattenedRecord[field.field] = undefined;
					} else {
						flattenedRecord[field.field] = '';
					}
				}
			});

			angular.forEach(sourceData, function (record) {
				var newRecord = angular.copy(flattenedRecord);
				angular.forEach(sameLevelFields, function (field) {
					if (record[field.map]) {
						newRecord[field.field] = record[field.map];
					} else {
						newRecord[field.field] = record[field.map];
					}
				});

				for (var key in record[nestedArrayName]) {
					if (record[nestedArrayName].hasOwnProperty(key)) {
						newRecord[key] = record[nestedArrayName][key];
					}
				}

				result.push(newRecord);
			});
			return result;
		}

		function generateRequestIdsArray(requests) {
			var requestIds = [];
			angular.forEach(requests, function(request) {
					requestIds.push(request.Id);
			})
			return requestIds;
		}

		function generateExportRequestData(articleList, requestData, colsList) {
			var requestObject = [];
			var requestAttributeList = catalogFactory.getActiveCatalogDetails().RequestAttributeList;
			var requestAttributeFieldsList = generateAttributeFields(requestAttributeList);

			angular.forEach(requestData, function(request) {
					try {
							var requestContent = angular.fromJson(request.Content);
							requestContent = angular.isArray(requestContent) ? requestContent : !utility.isObjectEmpty(requestContent) ? [requestContent] : [];
							var currectRequestArticle = utility.filterObject(articleList, { Id: parseInt(request.ObjectId) }, true)[0];
							angular.forEach(requestContent, function(article) {
									var result = {};

									for (var key in request) {
											if (key.toUpperCase() === 'REQUESTATTRIBUTES') {
													var requestAttributes = angular.fromJson(request.RequestAttributes);
													for (var requestKey in requestAttributes) {
															if (requestAttributes.hasOwnProperty(requestKey)) {
																	var attributeField = utility.filterObject(requestAttributeFieldsList, { field: requestKey }, true)[0];
																	if (angular.isDefined(attributeField)) {
																			result[attributeField.field] = requestAttributes[requestKey];
																			var index = colsList.indexOf(utility.filterObject(colsList, { field: 'ParticipantType' }, true)[0]);
																			var requestAttrIndex = colsList.indexOf(utility.filterObject(colsList, { field: attributeField.field }, true)[0]);
																			if (requestAttrIndex === -1) {
																					colsList.splice(index, 0, angular.copy(attributeField));
																			}
																	}
															}
													}
											} else {
													if (request.hasOwnProperty(key)) {
														if(key === 'ObjectId') {
																result['ArticleNumber'] = angular.isDefined(currectRequestArticle) ? currectRequestArticle['ArticleNumber'] : '';
																result['ArticleName'] = angular.isDefined(currectRequestArticle) ? currectRequestArticle['ArticleName'] : '';
														} else {
																	result[key] = request[key];
															}
													}
											}
									}

									if (request.RequestSource === 5) { // edit request
										var requestInitialContent = angular.fromJson(request.InitialContent);
										var contentKey = Object.keys(article)[0];
										var currentValue = requestInitialContent[contentKey];
										var requestedValue = article[contentKey];
										var contentAttribute = utility.filterObject(attributesFieldsList, { field: contentKey }, true)[0];
										if (request.RequestType === 'EditAttribute' && (contentAttribute && contentAttribute.inputType !== 'color-palette')) {
											result.ImpactedAttribute = contentAttribute.displayLabel;
											result.CurrentValue = utility.getAttributeTypeSpecificValue(contentAttribute, currentValue);
											result.RequestedValue = utility.getAttributeTypeSpecificValue(contentAttribute, requestedValue);
										}
										else { // static properties
											if (contentKey === CONSTANTS.REQUESTS.KEYS.PRICES) {
												result.ImpactedAttribute = CONSTANTS.REQUESTS.KEYS.PRICES;
												if (currentValue && Array.isArray(currentValue)) {
													result.CurrentValue = '';
													for (var i = 0; i < currentValue.length; i++) {
														var priceData = currentValue[i];
														if (priceData && priceData.hasOwnProperty('Name') && priceData.hasOwnProperty('Price')) {
															if (i !== 0) {
																result.CurrentValue += ', ';
															}
															result.CurrentValue += priceData.Name + ': ' + priceData.Price;
														}
													}
												}
												if (requestedValue && Array.isArray(requestedValue)) {
													result.RequestedValue = '';
													for (var i = 0; i < requestedValue.length; i++) {
														var priceData = requestedValue[i];
														if (priceData && priceData.hasOwnProperty('Name') && priceData.hasOwnProperty('Price')) {
															if (i !== 0) {
																result.RequestedValue += ', ';
															}
															result.RequestedValue += priceData.Name + ': ' + priceData.Price;
														}
													}
												}
											}
											else if(contentKey === CONSTANTS.REQUESTS.KEYS.STATUS) {
												result.ImpactedAttribute = CONSTANTS.REQUESTS.KEYS.STATUS;
												result.CurrentValue = currentValue === 1 ? 'Active' : 'Inactive';
												result.RequestedValue = requestedValue === 1 ? 'Active' : 'Inactive';
											}
											else if(contentKey === CONSTANTS.REQUESTS.KEYS.COLORID || (contentAttribute && contentAttribute.inputType === 'color-palette')) {
												result.ImpactedAttribute = contentKey === CONSTANTS.REQUESTS.KEYS.COLORID ? 'Primary Color' : contentAttribute.displayLabel;
												result.CurrentValue = currentValue ? currentValue : '';
												result.RequestedValue = requestedValue && Object.keys(requestedValue).length ? requestedValue[Object.keys(requestedValue)[0]] : '';
											}
											else if(contentKey === CONSTANTS.REQUESTS.KEYS.MODELNAME) {
												result.ImpactedAttribute = hasModelLabel ? api.modelLabelConfiguration + ' Name' : 'Model Name';
												result.CurrentValue = currentValue;
												result.RequestedValue = requestedValue;
											}
											else if(contentKey === CONSTANTS.REQUESTS.KEYS.SIZESCALE) {
												result.ImpactedAttribute = 'Size Scale';
												result.CurrentValue = currentValue;
												result.RequestedValue = sizeScaleIdNameMap[requestedValue] ? sizeScaleIdNameMap[requestedValue] : requestedValue;
											}
											else if(contentKey === CONSTANTS.REQUESTS.KEYS.STATENAME) {
												result.ImpactedAttribute = hasArticleLabel ? api.articleLabelConfiguration + ' State' : 'Article State';
												result.CurrentValue = currentValue;
												result.RequestedValue = articleStateIdNameMap[requestedValue] ? articleStateIdNameMap[requestedValue] : requestedValue;
											}
										}
									}

									// Add article attributes to request export model
									var attributesFieldsListCopy = angular.copy(attributesFieldsList);
									var sourceArticle = utility.filterObject(api.currentCatalogArticleList, { Id: request.SourceArticleId }, true)[0];
									angular.forEach(attributesFieldsListCopy, function(attribute) {
											var index = colsList.indexOf(utility.filterObject(colsList, { fieldForFilter: attribute.field }, true)[0]);
											if (angular.isUndefined(index) || index === -1) {
													result['article_' + attribute.field] = angular.isDefined(sourceArticle) ? sourceArticle[attribute.field] : '';
													attribute.field = 'article_' + attribute.field;
													attribute['fieldForFilter'] = attribute.field;
													colsList.push(attribute);
											}
									});

									// assign selected: true to each record for export
									result['Status'] = 1; // as API returns only active requests
									result.selected = true;
									requestObject.push(result);
							});
					} catch(error) {
							console.warn("Request Content : Invalid JSON format");
					}
			});

			return { requestObject: requestObject, colsList: colsList };
		}

		function generateAttributeFields(attributeList) {
			var modelLevelAttributes = catalogFactory.getActiveCatalogDetails().ModelLevelAttributeList;
			var attributeFields = [];
			var attributeFieldTemplate = {
				field: '', type: 'text', displayLabel: 'ARTICLES.FIELDS.ID', visible: true, creatable: false, editable: false, showInEdit: false, inputType: 'text', reportable: true, values: '',
				validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }
			};

			//add catalog specific attributes to article's model fields
			angular.forEach(attributeList, function (attribute) {
				var attributeField = angular.copy(attributeFieldTemplate);
				var modelLevelAttributeIndex = modelLevelAttributes.indexOf(utility.filterObject(modelLevelAttributes, { AttributeId: attribute.Attributeid, Status: 1 }, true)[0]);
				attributeField.isDynamicProperty = true;
				attributeField.isAttribute = true;
				attributeField.field = attribute.AttributeSystemName;
				attributeField.map = attribute.AttributeSystemName;
				attributeField.displayLabel = attribute.AttributeDisplayName;
				attributeField.visible = true; // always visible true
				attributeField.supportFilterLookup = (attribute.SupportFilterLookup == true);
				attributeField.initialValue = attribute.InitialValueAttribute;
				attributeField.validation.minLen = attribute.IsRequired ? 1 : 0;

				// for attributes other than calc type if validation expression is a valid regex we will add to pattern else we will add it to tx-pattern
				if(attribute.AttributeTypeName.toUpperCase() !== 'CALC') {
					if(!utility.isValidJSON(attribute.ValidationExpression)) {
						attributeField.validation.pattern = attribute.ValidationExpression != '{}' ? attribute.ValidationExpression : '';
						attributeField.validation['tx-pattern'] = false;
					} else {
						attributeField.validation.pattern = '';
						attributeField.validation['tx-pattern'] = attribute.ValidationExpression != null && attribute.ValidationExpression !== '' ?
						attribute.ValidationExpression : false;
					}
				}
				attributeField.validation.messages.pattern = attribute.ValidationMessage;
				attributeField.reportable = true;
				//set data type to list for attributes having values added in attributeVettingList
				if (attribute.AttributeTypeName.toUpperCase() !== 'CALC' && attribute.AllowedValues && attribute.AllowedValues !== null && (angular.isArray(attribute.AllowedValues) && attribute.AllowedValues.length)) {
					attributeField.inputType = 'list';
					// for multi value attributes with vetting list inputtype will be multi-value
					if (attribute.AttributeTypeName.toUpperCase() === 'MULTIVALUE') {
						attributeField.inputType = 'multi-value';
						attributeField.tagSeparator = '|';
						if(!attributeField.editable) {
							attributeField.nonRemovableChips = true;
						}
					}
					if (attribute.AttributeTypeName.toUpperCase() === 'INT') {
						attributeField.type = 'int';
					} else {
						attributeField.type = 'text';
					}
				}
				else {
					if (attribute.AttributeTypeName.toUpperCase() === 'INT') {
						attributeField.inputType = 'number';
					}
					else if (attribute.AttributeTypeName.toUpperCase() === 'NVARCHAR') {
						attributeField.inputType = 'textArea';
					}
					else if (attribute.AttributeTypeName.toUpperCase() === 'DATE') {
						attributeField.inputType = 'date-without-time';
					}
					else if (attribute.AttributeTypeName.toUpperCase() === 'DATETIME') {
						attributeField.inputType = 'date';
					}
					else if (attribute.AttributeTypeName.toUpperCase() === 'BOOL') {
						attributeField.inputType = 'bool-str';
					}
					else if (attribute.AttributeTypeName.toUpperCase() === 'MULTIVALUE') {
						attributeField.inputType = 'tags';
						attributeField.tagSeparator = '|';
						attributeField.inputSubType = 'multi-value';
					}
					else if(attribute.AttributeTypeName.toUpperCase() === 'CALC'){
						attributeField.inputType = 'calculated';
						attributeField.validation.pattern = '';
						attributeField.calculatedExpression = attribute.ValidationExpression;
						//Adding try catch if JSON parse fails
						try {
							attributeField.parsedExpressionObject = JSON.parse(attribute.ValidationExpression);
							if(angular.isDefined(attributeField.parsedExpressionObject.calculatedRegexExpression)) {
								var calculatedRegexExpression = attributeField.parsedExpressionObject.calculatedRegexExpression;
								if(angular.isDefined(calculatedRegexExpression.fieldRegex) && calculatedRegexExpression.fieldRegex.length > 0) {
									angular.forEach(calculatedRegexExpression.fieldRegex, function(fieldRegex) {
										var convertedRegEx = convertStringToRegex(fieldRegex.regEx);
										if(convertedRegEx != null) {
												fieldRegex.regEx = convertedRegEx;
										} else {
												console.warn("invalid Regex for : " + fieldRegex.field);
										}
									})
								}
								attributeField.calcType = calculatedRegexExpression.type;
							}
						} catch(error) {
							console.warn(attribute.AttributeDisplayName + " - Attribute Validation Expression : Invalid JSON format");
						}
					}
					else if (attribute.AttributeTypeName.toUpperCase() === 'DATEOPTION') {
						attributeField.inputType = 'date-option';
					}
					else if (attribute.AttributeTypeName.toUpperCase() === 'DECIMAL') {
						attributeField.inputType = 'decimal';
						attributeField.validation.pattern = '^[+]?\\d+([.]\\d{0,4})?$';
						attributeField.validation.messages.pattern = 'VALIDATIONS.POSITIVE_DECIMAL_4PONTS';
					}
					else if (attribute.AttributeTypeName.toUpperCase() === 'ARTICLENUMBER') {
						attributeField.inputType = 'articlenumber';
						attributeField.lookupSource = 'catalogs.articles';
						attributeField.lookupFilter = {'Status': 1};
					}
					else if (attribute.AttributeTypeName.toUpperCase() === 'LINKEDCATALOGARTICLENUMBER') {
						attributeField.inputType = 'linkedcatalogarticlenumber';
						attributeField.lookupSource = 'lists.linkedCatalogArticles';
						attributeField.lookupFilter = {'Status': 1};
					}
					else if (attribute.AttributeTypeName.toUpperCase() === 'COLORPALETTE') {
						attributeField.inputType = 'color-palette';
						attributeField.lookupSource ='lists.sellerColorsFromColorPalette';
						attributeField.isfilterCriteria = true;
						attributeField.lookupFilter = {'Status': 1};
					}
					else if (attribute.AttributeTypeName.toUpperCase() === 'MODELNUMBER') {
						attributeField.inputType = 'modelnumber';
						attributeField.lookupSource = 'lists.sellerModelsWithoutAttributes';
					}
					else if (attribute.AttributeTypeName.toUpperCase() === 'LOOKUPTABLE') {
						attributeField.inputType = 'lookup-table';
					}
					else if (attribute.AttributeTypeName.toUpperCase() === 'DATASET') {
						attributeField.inputType = 'dataset';
						attributeField.datasetId = attribute.DatasetId;
					}
					else if (attribute.AttributeTypeName.toUpperCase() === 'DATATABLE') {
						attributeField.inputType = 'datatable';
						attributeField.DataTableAttributes = attribute.DataTableAttributes
						if(attribute.AllowedValuesV2 && attribute.AllowedValuesV2.length) {
							try {
								attributeField.valuesV2 = JSON.parse(attribute.AllowedValuesV2)
							} catch(error) {
								console.warn(attribute.AttributeDisplayName + " - Allowed Values Version 2 : Invalid JSON format");
							}
						}
						if(attribute.CriteriaV2 && attribute.CriteriaV2.length) {
							try {
								attributeField.criteriaV2 = JSON.parse(attribute.CriteriaV2)
							} catch(error) {
								console.warn(attribute.AttributeDisplayName + " - Criteria Version 2 : Invalid JSON format");
							}
						}
						if(api.allAttributesListMap && Object.keys(api.allAttributesListMap).length > 0) {
								attributeField.dataTableAttributesDetails = attributeField.DataTableAttributes.map(function(attrId) {
										return api.allAttributesListMap[attrId];
								}).filter(function(attr) {
										return attr !== undefined;
								})
						}
					}
				}

				if(modelLevelAttributeIndex !== -1) {
					attributeField.isModelLevelAttribute = true;
				} else {
					attributeField.isModelLevelAttribute = false;
				}

				attributeFields.push(attributeField);
			});
			return attributeFields;
		}

		//to convert regex in string to regex format
		function convertStringToRegex(regexString) {
			var regex;
			if (regexString[0] !== '/') {
				return null;
			}
			var i = regexString.lastIndexOf('/');
			if ( i <= 0 ) {
				return null;
			}
			try {
				regex = new RegExp(regexString.slice(1, i), regexString.slice(i+1));
			} catch(error) {
				console.warn("Error : " + error);
				return null;
			}
			return regex;
		}

		function formatAuditTrailHistoryData(records) {
			var auditTrail = [];
			angular.forEach(records, function(record) {
				var data = {};
				data.ChangeMaker = record.ChangeMaker;
				data.ChangeDate = record.ChangeDate;
				data.Changes = [];
				Object.keys(record.New).forEach(function (key) {
					if(key !== '_requestedAttributes' && key !== '_endorsed' && key !== '_requestState') {
						var oldValue = record.Old[key];
						var newValue = record.New[key];
						var obj = {FieldName: getRequestHistoryDisplayLabels(key), Old: oldValue, New: newValue}
						data.Changes.push(obj);
					} else if(key === '_requestedAttributes') {
						var obj = {FieldName: getRequestHistoryDisplayLabels('_requestedAttributes'), NestedValues: []};
						Object.keys(record.Old['_requestedAttributes']).forEach(function (requestAttribute) {
								var requestAttributeObj = {FieldName: getRequestHistoryDisplayLabels(requestAttribute), Old: record.Old._requestedAttributes[requestAttribute], New: record.New._requestedAttributes[requestAttribute]};
								obj.NestedValues.push(requestAttributeObj);
						});
						data.Changes.push(obj);
					} else if(key === '_endorsed') {
						var obj = {FieldName: getRequestHistoryDisplayLabels('_endorsed'), NestedValues: []};
						Object.keys(record.New['_endorsed']).forEach(function (key) {
							var endorsedObj = {FieldName: getRequestHistoryDisplayLabels(key), Old: record.Old._endorsed[key], New: record.New._endorsed[key]};
							obj.NestedValues.push(endorsedObj);
						});
						data.Changes.push(obj);
					}  else if(key === '_requestState') {
						var obj = {FieldName: getRequestHistoryDisplayLabels('_requestState'), NestedValues: []};
						Object.keys(record.New['_requestState']).forEach(function (key) {
							var requestStateObj = {FieldName: key, Old: record.Old._requestState[key], New: record.New._requestState[key]};
							obj.NestedValues.push(requestStateObj);
						});
						data.Changes.push(obj);
					}
				});
				auditTrail.push(data);
			});
			return utility.orderBy(auditTrail, 'ChangeDate', true);
		}

		function getRequestHistoryDisplayLabels(key) {
			var label = '';
			switch(key) {
				case '_requestedAttributes' :
					label = 'Request Attributes';
					break;
				case '_endorsed' :
					label = 'Request Endorsed';
					break;
				case '_withdraw' :
					label = 'Request Withdrawn';
					break;
				case '_requestState' :
					label = 'Request state';
					break;
			}
			// check for attributes
			if (label === '') {
				var attribute = utility.filterObject(assignedCatalogAttributes, { AttributeSystemName: key}, true)[0];
				if(angular.isDefined(attribute)) {
					label = attribute.AttributeDisplayName;
				}
			}
			// check for request attributes
			if (label === '') {
				var reqAttribute = utility.filterObject(assignedCatalogRequestAttributes, { AttributeSystemName: key}, true)[0];
				if(angular.isDefined(reqAttribute)) {
					label = reqAttribute.AttributeDisplayName;
				}
			}
			// if no value present then assign the key
			if (label === '') {
				label = key;
			}
			return label;
		}

		function getAndGenerateSizeScaleIdNameMap() {
			api.catalogs.sizeScaleGroups.methods.getList({
				forceFetch: true,
				isLogRequired: true
			}, catalogFactory.getActiveCatalog().CatalogCode)
				.then(function (response) {
					sizeScaleIdNameMap = response.data.reduce(function(map, sizeScale) {
						map[sizeScale.Id] = sizeScale.SizeScale;
						return map;
					}, {})
				})
		}

		function getAndGenerateArticleStateIdNameMap() {
			api.catalogs.articleStates.methods.getList({
				forceFetch: true,
				isLogRequired: true
			}, catalogFactory.getActiveCatalog().AccountId, catalogFactory.getActiveCatalog().AttributeGroupId)
				.then(function (response) {
					articleStateIdNameMap = response.data.reduce(function(map, state) {
						map[state.StateId] = state.StateName;
						return map;
					}, {})
				})
		}

		function transformRequestResponse(requests) {
				var results = [];
				if (requests.length) {
						angular.forEach(requests, function(request) {
								var requestObject = request;
								if (requestObject.ImpactedCatalogs && requestObject.ImpactedCatalogs.length) {
									var uniqueSeasons = new Set(
											requestObject.ImpactedCatalogs.map(function(catalogItem) {
													return catalogItem.Season;
											})
									);
									requestObject.ImpactedSeasons = Array.from(uniqueSeasons).join(',');
								}
								// disable actions if request from different catalog
								requestObject.disableAction = request.CatalogCode !== catalogFactory.getActiveCatalog().CatalogCode ? true : false;
								results.push(requestObject);
						});
				}
				return results;
		}

	}
})();
(function () {
	'use strict';

	angular
		.module('app.main.catalogs.requests')
		.run(runBlock);

	/* @ngInject */
	function runBlock(api, activityLogger, $state, crud, catalogFactory, toast) {

		if (angular.isUndefined(api.catalogs)) {
			api.catalogs = {};
		}
		api.catalogs.requests = {
			modelPath: 'catalogs.requests',
			fields: [
				{ field: 'Id', type: 'int', displayLabel: 'REQUESTS.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
					validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'ObjectId', type: 'text', displayLabel: 'REQUESTS.FIELDS.OBJECT_ID', visible: true, creatable: false, editable: false, inputType: 'text',
					validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'RequestChannelId', type: 'int', displayLabel: 'REQUESTS.FIELDS.CHANNEL_ID', visible: true, creatable: false, editable: false, inputType: 'number',
					validation: {isRequired: false, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'RequestChannel', type: 'text', displayLabel: 'REQUESTS.FIELDS.CHANNEL', visible: true, creatable: false, editable: false, inputType: 'text',
					validation: {isRequired: false, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'ArticleNumber', type: 'text', displayLabel: 'REQUESTS.FIELDS.ARTICLE_NUMBER', visible: true, creatable: false, editable: false, inputType: 'text',
					validation: {isRequired: true, maxLen: 20, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'SourceArticleId', type: 'int', displayLabel: 'REQUESTS.FIELDS.SOURCE_ARTICLE_NUMBER', visible: true, creatable: true, editable: true, inputType: 'lookup', lookupSource: 'catalogs.articles',
					validation: {isRequired: true, maxLen: 20, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'SourceModelId', type: 'text', displayLabel: 'REQUESTS.FIELDS.SOURCE_MODEL_NUMBER', visible: true, creatable: true, editable: true, inputType: 'lookup', lookupSource: 'catalogs.models',
					validation: {isRequired: true, maxLen: 20, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				// { field: 'StateName', map:'StateName', type: 'text', displayLabel: 'REQUESTS.FIELDS.STATE_NAME', visible: true, creatable: true, editable: true, inputType: 'text',
				// 	validation: {isRequired: true, maxLen: 20, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'RequestNumber', map:'RequestNumber', type: 'text', displayLabel: 'REQUESTS.FIELDS.REQUEST_NUMBER', visible: true, creatable: true, editable: true, inputType: 'text',
					validation: {isRequired: true, maxLen: 20, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'RequestVersion', map:'RequestVersion', type: 'int', displayLabel: 'REQUESTS.FIELDS.REQUEST_VERSION', visible: true, creatable: true, editable: true, inputType: 'text',
					validation: {isRequired: true, maxLen: 20, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'ImpactedAttribute', type: 'text', displayLabel: 'REQUESTS.FIELDS.IMPACTED_ATTRIBUTES', visible: false, creatable: false, editable: false, inputType: 'text', isRequestField: true,
					validation: {isRequired: false, maxLen: 200, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'CurrentValue', type: 'text', displayLabel: 'REQUESTS.FIELDS.CURRENT_VALUE', visible: false, creatable: false, editable: false, inputType: 'text', isRequestField: true,
					validation: {isRequired: false, maxLen: 200, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'RequestedValue', type: 'text', displayLabel: 'REQUESTS.FIELDS.REQUESTED_VALUE', visible: false, creatable: false, editable: false, inputType: 'text', isRequestField: true,
					validation: {isRequired: false, maxLen: 200, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'Status', type: 'text', displayLabel: 'REQUESTS.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'State', type: 'int', displayLabel: 'REQUESTS.FIELDS.REQUEST_STATE', visible: true, creatable: false, editable: false, inputType: 'lookup', lookupSource:'lists.RequestStates',
					validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'Reason', type: 'text', displayLabel: 'REQUESTS.FIELDS.REASON', visible: true, creatable: false, editable: false,  inputType: 'textArea',
					validation: {isRequired: false, maxLen: 2000, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'Comment', type: 'text', displayLabel: 'REQUESTS.FIELDS.COMMENT', visible: true, creatable: false, editable: false,  inputType: 'textArea',
					validation: {isRequired: false, maxLen: 2000, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'CatalogCode', type: 'int', displayLabel: 'CATALOGS.FIELDS.CATALOG_CODE', visible: true, creatable: false, editable: false, inputType: 'number',
					validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'CatalogName', type: 'text', displayLabel: 'CATALOGS.FIELDS.CATALOG_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
					validation: {isRequired: true, maxLen: 100, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'RequestType', type: 'text', displayLabel: 'REQUESTS.FIELDS.REQUEST_TYPE', visible: true, creatable: false, editable: false, inputType: 'lookup', lookupSource:'lists.RequestTypes',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				// internally used
				{ field: 'ImpactedSeasons', type: 'text', displayLabel: 'REQUESTS.FIELDS.IMPACTED_SEASONS', visible: true, creatable: false, editable: false, inputType: 'text',
					validation: {isRequired: true, maxLen: 100, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'CreatedDate', type: 'text', displayLabel: 'REQUESTS.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'UpdatedDate', type: 'text', displayLabel: 'REQUESTS.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'CreatedBy', type: 'int', displayLabel: 'REQUESTS.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'number',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'UpdatedBy', type: 'int', displayLabel: 'REQUESTS.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'number',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'CreatedByUserName', type: 'text', displayLabel: 'REQUESTS.FIELDS.CREATED_BY_USER_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'UpdatedByUserName', type: 'text', displayLabel: 'REQUESTS.FIELDS.UPDATED_BY_USER_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'disableAction', type: 'text', displayLabel: 'REQUESTS.FIELDS.IMPACTED_SEASONS', visible: false, creatable: false, editable: false, inputType: 'bool',
					validation: {isRequired: true, maxLen: 100, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
			],
			uniqueConstraints: [],
			title: 'REQUESTS.NAV',
			icon: 'icon-plus-box',
			idField: 'Id',
			lookupDisplayField: 'ObjectId',
			isDirty: false,
			isBulkActionCompleted: false,
			isCatalogSpecificModel: true,
			methods: {
				 getList: getRequests,
				 getDetails: getRequestDetails,
				 updateCreateRequestsStatus: updateCreateRequestsStatus,
				 activateBulk: activateRequests
			},
			views: {
				mainList: {
					columns           : ['ObjectId', 'RequestNumber', 'ArticleNumber', 'Status', 'CreatedDate', 'CreatedByUserName', 'UpdatedDate', 'UpdatedByUserName'],
					columnFilter      : {},
					toggleFilterProps : {},
					topIndex          : 0,
					showFilterRow     : false,
					sortColumn        : { 'UpdatedDate': false },
					sortDescending    : true,
					itemActions       : [
																{ id: 'view', label: 'ACTIONS.VIEW', icon: 'icon-magnify', privilege: 'GetRequestDetails', disabled: '!itm.Status', visible: true },
																{ id: 'deactivate', label: 'ACTIONS.DEACTIVATE', icon: 'icon-delete', privilege: 'UpdateRequestStatuses', disabled: 'itm.State !== 1', visible: 'itm.Status && !itm.disableAction',
																	requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DEACTIVATE'}, confirmationAction: 'ACTIONS.DEACTIVATE'},
																{ id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateRequestStatuses', disabled: 'itm.State !== 1 || itm.disableAction', visible: '!itm.Status && !itm.disableAction',
																	requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
															],
					listActions       : [
																{ id: 'deactivate', label: 'ACTIONS.DEACTIVATE_BULK', icon: 'icon-delete', privilege: 'UpdateRequestStatuses', disabled: '{selected: true, Status: 1, State: ["!2", "!3"], disableAction: ["!true"]}', visible: true,
																	requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DEACTIVATE'}, confirmationAction: 'ACTIONS.DEACTIVATE'},
																{ id: 'activate', label: 'ACTIONS.ACTIVATE_BULK', icon: 'icon-undo-variant', privilege: 'UpdateRequestStatuses', disabled: '{selected: true, Status: 0, State: ["!2", "!3"], disableAction: ["!true"]}', visible: true,
																	requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'},
																{ id: 'stopRequests', label: 'REQUESTS.ACTIONS.STOP_REQUESTS', icon: 'icon-close', privilege: 'AllowNewRequests', disabled: false, visible: '',
																	requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'REQUESTS.MESSAGES.CONTENT.CONFIRM_STOP_REQUESTS'}, confirmationAction: 'REQUESTS.ACTIONS.STOP_REQUESTS'},
																{ id: 'acceptRequests', label: 'REQUESTS.ACTIONS.ACCEPT_REQUESTS', icon: 'icon-check', privilege: 'AllowNewRequests', disabled: false, visible: '',
																	requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'REQUESTS.MESSAGES.CONTENT.CONFIRM_ACCEPT_REQUESTS'}, confirmationAction: 'REQUESTS.ACTIONS.ACCEPT_REQUESTS'}
															]
				},
				mainDetails: {
					selectedTabIndex  : 0,
					itemActions       : [
																{ id: 'deactivate', label: 'ACTIONS.DEACTIVATE', icon: 'icon-delete', privilege: 'UpdateRequestStatuses', disabled: '{selected: true, Status: 1, State: ["!2", "!3"], disableAction: ["!true"]}', visible: true,
																	requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DEACTIVATE'}, confirmationAction: 'ACTIONS.DEACTIVATE'},
																{ id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateRequestStatuses', disabled: '{selected: true, Status: 0, State: ["!2", "!3"], disableAction: ["!true"]}', visible: true,
																	requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
															],
					fab               : {}
				},
				privileges: {
					list: 'GetRequests',
					details: 'GetRequestDetails'
				}
			}
		};

		api.catalogs.exportRequests = {
			fields: [
				{ field: 'Id', type: 'int', displayLabel: 'REQUESTS.FIELDS.REQUEST_ID', visible: true, creatable: false, editable: false, inputType: 'number',
					validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'RequestNumber', map:'RequestNumber', type: 'text', displayLabel: 'REQUESTS.FIELDS.REQUEST_NUMBER', visible: true, creatable: true, editable: true, inputType: 'text',
					validation: {isRequired: true, maxLen: 20, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'Status', type: 'text', displayLabel: 'REQUESTS.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'State', type: 'int', displayLabel: 'REQUESTS.FIELDS.REQUEST_STATE', visible: true, creatable: false, editable: false, inputType: 'lookup', lookupSource:'lists.RequestStates',
					validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'ArticleNumber', map:'ArticleNumber', type: 'text', displayLabel: 'REQUESTS.FIELDS.ARTICLE_NUMBER', visible: true, creatable: false, editable: false, inputType: 'text',
					validation: {isRequired: true, maxLen: 20, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'SourceArticleNumber', map:'SourceArticleNumber', type: 'text', displayLabel: 'REQUESTS.FIELDS.SOURCE_ARTICLE_NUMBER', visible: true, creatable: true, editable: true, inputType: 'text',
					validation: {isRequired: true, maxLen: 20, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'SourceModelNumber', map:'SourceArticleNumber', type: 'text', displayLabel: 'REQUESTS.FIELDS.SOURCE_MODEL_NUMBER', visible: true, creatable: true, editable: true, inputType: 'text',
					validation: {isRequired: true, maxLen: 20, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'StateName', map:'StateName', type: 'text', displayLabel: 'REQUESTS.FIELDS.STATE_NAME', visible: true, creatable: true, editable: true, inputType: 'text',
					validation: {isRequired: true, maxLen: 20, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'RequestVersion', map:'RequestVersion', type: 'int', displayLabel: 'REQUESTS.FIELDS.REQUEST_VERSION', visible: true, creatable: true, editable: true, inputType: 'text',
					validation: {isRequired: true, maxLen: 20, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'ImpactedAttribute', type: 'text', displayLabel: 'REQUESTS.FIELDS.IMPACTED_ATTRIBUTES', visible: true, creatable: false, editable: false, inputType: 'text',
					validation: {isRequired: false, maxLen: 200, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'CurrentValue', type: 'text', displayLabel: 'REQUESTS.FIELDS.CURRENT_VALUE', visible: true, creatable: false, editable: false, inputType: 'text',
					validation: {isRequired: false, maxLen: 200, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'RequestedValue', type: 'text', displayLabel: 'REQUESTS.FIELDS.REQUESTED_VALUE', visible: true, creatable: false, editable: false, inputType: 'text',
					validation: {isRequired: false, maxLen: 200, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'UserAccountName', type: 'text', displayLabel: 'REQUESTS.FIELDS.ACCOUNT_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'CreatedByUserName', type: 'text', displayLabel: 'REQUESTS.FIELDS.CREATED_BY_USER_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'CatalogName', type: 'text', displayLabel: 'CATALOGS.FIELDS.CATALOG_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
					validation: {isRequired: true, maxLen: 100, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'CreatedDate', type: 'text', displayLabel: 'REQUESTS.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'UpdatedByUserName', type: 'text', displayLabel: 'REQUESTS.FIELDS.UPDATED_BY_USER_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'UpdatedDate', type: 'text', displayLabel: 'REQUESTS.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'ParticipantType', type: 'text', displayLabel: 'REQUESTS.FIELDS.PARTICIPANT_TYPE', visible: true, creatable: false, editable: false, inputType: 'text',
					validation: {isRequired: false, maxLen: 200, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'Participants', type: 'int', displayLabel: 'REQUESTS.FIELDS.PARTICIPANTS', visible: true, creatable: false, editable: false, inputType: 'number',
					validation: {isRequired: false, maxLen: 200, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'ReferenceId', type: 'int', displayLabel: 'REQUESTS.FIELDS.REFERENCE_ID', visible: true, creatable: false, editable: false, inputType: 'number',
					validation: {isRequired: false, maxLen: 200, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
			],
			uniqueConstraints: [],
			commonConstraints: [],
			title: 'REQUESTS.NAV',
			icon: '',
			idField: '',
			lookupDisplayField: '',
			isDirty: false,
			isBulkActionCompleted: false,
			methods: {
				getRequestsExportData: getRequestsExportData
		  },
			views: {
					mainList: {},
					mainDetails: {},
					privileges: {
							list    : 'GetRequestsForExport'
					}
			}
		};

		function getRequests(generalProperties, model, catalogCode) {
			if (angular.isDefined(model)) { // to skip this part for load lookup
				model.isBulkActionCompleted = false;
			}
			var promise;

			if (angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
				var state = {};
				state.name = $state.current.name;
				state.params = $state.params;
				var isBulk = true;
				var logData = activityLogger.createLogData(null, state, 'catalogs.requests', 'VIEW', isBulk, new Date(), null, null);

				promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/requests?requestversion=0', undefined, true, generalProperties.forceFetch);
				promise = activityLogger.log(logData, promise);
			}
			else {
				catalogCode = angular.isUndefined(catalogCode) ? catalogFactory.getActiveCatalog().CatalogCode : catalogCode;
				promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/requests?requestversion=0', undefined, true, generalProperties.forceFetch);
			}

			promise.then(function () {
				if (api.catalogs.requests.isDirty) {
					//Invalidate lookupData
					api.catalogs.requests.lookupData = undefined;
					api.catalogs.requests.isDirty = false;
				}
			});
			return promise;
		}

		function getRequestDetails(isLogRequired, requestId, catalogCode) {
			var promise;
			var catalogCode = angular.isUndefined(catalogCode) ? catalogFactory.getActiveCatalog().CatalogCode : catalogCode;
			if (angular.isDefined(isLogRequired) && isLogRequired === true) {
				var state = {};
				state.name = $state.current.name;
				state.params = $state.params;
				var isBulk = false;
				var items = [];
				promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/requests/' + requestId);
				promise.then(function (response) {
					items.push(response.data[api.catalogs.requests.lookupDisplayField]);
				}, function (response) {
					items.push(response.data[api.catalogs.requests.lookupDisplayField]);
				});
				var logData = activityLogger.createLogData(items, state, 'catalogs.requests', 'VIEW', isBulk, new Date(), null, null);
				promise = activityLogger.log(logData, promise);
			}
			else {
				promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/requests/' + requestId);
			}
			return promise;
		}

		function updateCreateRequestsStatus(catalogCode, actionType) {
			var status = 0;
			var state = {};
			var actionToPerform;
			var toastMessageKey = '';
			if(actionType.toUpperCase() === 'ACCEPTREQUESTS') {
					status = 1;
					actionToPerform = 'ACCEPT_REQUESTS';
					toastMessageKey = 'SUCCESS.ACCEPT_REQUESTS';
			} else {
				actionToPerform = 'STOP_REQUESTS';
				toastMessageKey = 'SUCCESS.STOP_REQUESTS';
			}

			state.name = $state.current.name;
			state.params = $state.params
			var logData = activityLogger.createLogData(catalogCode, state, 'catalogs.requests', actionToPerform, false, new Date(), null, null)
			var promise;
			promise = api.webPut(api.baseUrl + '/catalogs/' + catalogCode + '/requests/allow/' + status);
			promise.then(function() {
				api.catalogs.catalogs.isDirty = true;
				toast.success(toastMessageKey, '', '');
			});
			return activityLogger.log(logData, promise).then(function() {
				return catalogFactory.setActiveCatalogDetails();
			});
		}

		function activateRequests(records, model, actionType, parentId) {
			var result = crud.createRequestObject(records, model, actionType);
			var state = {};
			state.name = $state.current.name;
			state.params = $state.params;
			var isBulk = result.itemsNameList.length > 1 ? true : false;
			var logData = activityLogger.createLogData(result.itemsNameList, state, 'catalogs.requests', actionType.toUpperCase(), isBulk, new Date(), null, null);
			var promise = api.webPut(api.baseUrl + '/catalogs/' + parentId + '/requests/status', result.requestObj);

			promise.then(function() {
				crud.onRecordStatusChange(records, model, actionType);
			});

			return activityLogger.log(logData, promise);
		}

		// get request module export data
		function getRequestsExportData(request) {
			var requestObj = {
				Ids : request
			}
			var catalogCode = catalogFactory.getActiveCatalog().CatalogCode;
			var promise = api.webPut(api.baseUrl + '/catalogs/' + catalogCode + '/exportrequests?requestversion=0', requestObj);
			return promise;
		}

	}
})();
(function() {
    'use strict';

    angular
        .module('app.main.catalogs.reports')
        .run(runBlock);

    /* @ngInject */
    function runBlock(api, activityLogger, $state, catalogFactory) {

        if (angular.isUndefined(api.catalogs)) {
            api.catalogs = {};
        }
         api.catalogs.articlesWithoutCrds = {
            modelPath: 'catalogs.articlesWithoutCrds',
            fields: [
                { field: 'Id', type: 'int', displayLabel: 'ARTICLES_WITHOUT_CRDS.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ArticleNumber', type: 'text', displayLabel: 'ARTICLES_WITHOUT_CRDS.FIELDS.ARTICLE_NUMBER', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ArticleName', type: 'text', displayLabel: 'ARTICLES.FIELDS.MODEL_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'AttributeGroupID', type: 'int', displayLabel: 'ARTICLES_WITHOUT_CRDS.FIELDS.ATTRIBUTE_GROUP_ID', visible: true, creatable: false, editable: false, inputType: 'lookup', lookupSource:'attributes.attributeGroups',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Status', type: 'text', displayLabel: 'ARTICLES_WITHOUT_CRDS.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ArticleSource', type: 'text', displayLabel: 'ARTICLES_WITHOUT_CRDS.FIELDS.ARTICLE_SOURCE', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedDate', type: 'text', displayLabel: 'ARTICLES_WITHOUT_CRDS.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedDate', type: 'text', displayLabel: 'ARTICLES_WITHOUT_CRDS.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedBy', type: 'text', displayLabel: 'ARTICLES_WITHOUT_CRDS.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedBy', type: 'text', displayLabel: 'ARTICLES_WITHOUT_CRDS.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
            ],
            uniqueConstraints: [],
            title: 'ARTICLES_WITHOUT_CRDS.NAV',
            icon: 'icon-tile-four',
            idField: 'Id',
            lookupDisplayField: 'ArticleNumber',
            isDirty: false,
            isCatalogSpecificModel: true,
            methods: {
                getList             :   getArticles
            },
            views: {
                mainList: {
                    columns         : [ 'ArticleNumber', 'ArticleName', 'UpdatedDate' ],
                    columnFilter    : {},
                    toggleFilterProps: { toggleStatus:false, filterProp:'Status', trueVal:1, trueValTooltipMessage: 'ACTIONS.TOGGLE_ACTIVE', falseVal:'', falseValTooltipMessage:"ACTIONS.TOGGLE_ALL"},
                    topIndex        : 0,
                    showFilterRow   : false,
                    sortColumn      : {'UpdatedDate': false},
                    itemActions     : [
                                        { id: 'view', label: 'ACTIONS.VIEW', icon: 'icon-magnify', privilege: 'GetCatalogArticleDetails', disabled: '!itm.Status', visible: true }
                                      ],
                    listActions     : [],
                    fabAction       : {}

                 },
                 mainDetails: {},
                privileges: {
                    list    : 'GetArticleListWithMissingCrds',
                    details : 'GetCatalogArticleDetails'
                }
            }
        };

        function getArticles(generalProperties, catalogCode) {
            var promise;

            if(angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
                var state = {};
                state.name = $state.current.name;
                state.params = $state.params;
                var isBulk = true;
                var logData = activityLogger.createLogData(null, state, 'catalogs.articlesWithoutCrds', 'VIEW', isBulk, new Date(), null, null);

                promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/articleswithoutcrds', undefined, true, generalProperties.forceFetch);
                promise = activityLogger.log(logData, promise);
            }
            else {
                catalogCode = angular.isUndefined(catalogCode) ? catalogFactory.getActiveCatalog().CatalogCode : catalogCode;
                promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/articleswithoutcrds', undefined, true, generalProperties.forceFetch);
            }

            promise.then(function() {
                if (api.catalogs.articles.isDirty) {
                    //Invalidate lookupData
                    api.catalogs.articles.lookupData = undefined;
                    api.catalogs.articles.isDirty = false;
                }
            });
            return promise;
		}

    }
})();
(function() {
    'use strict';

    angular
        .module('app.main.catalogs.reports')
        .run(runBlock);

    /* @ngInject */
    function runBlock(api, activityLogger, $state, catalogFactory) {

        if (angular.isUndefined(api.catalogs)) {
            api.catalogs = {};
        }
         api.catalogs.articlesWithoutSizes = {
            modelPath: 'catalogs.articlesWithoutSizes',
            fields: [
                { field: 'Id', type: 'int', displayLabel: 'ARTICLES_WITHOUT_SIZES.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ArticleNumber', type: 'text', displayLabel: 'ARTICLES_WITHOUT_SIZES.FIELDS.ARTICLE_NUMBER', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ArticleName', type: 'text', displayLabel: 'ARTICLES.FIELDS.MODEL_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'AttributeGroupID', type: 'int', displayLabel: 'ARTICLES_WITHOUT_SIZES.FIELDS.ATTRIBUTE_GROUP_ID', visible: true, creatable: false, editable: false, inputType: 'lookup', lookupSource:'attributes.attributeGroups',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Status', type: 'text', displayLabel: 'ARTICLES_WITHOUT_SIZES.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ArticleSource', type: 'text', displayLabel: 'ARTICLES_WITHOUT_SIZES.FIELDS.ARTICLE_SOURCE', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedDate', type: 'text', displayLabel: 'ARTICLES_WITHOUT_SIZES.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedDate', type: 'text', displayLabel: 'ARTICLES_WITHOUT_SIZES.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedBy', type: 'text', displayLabel: 'ARTICLES_WITHOUT_SIZES.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedBy', type: 'text', displayLabel: 'ARTICLES_WITHOUT_SIZES.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
            ],
            uniqueConstraints: [],
            title: 'ARTICLES_WITHOUT_SIZES.NAV',
            icon: 'icon-tile-four',
            idField: 'Id',
            lookupDisplayField: 'ArticleNumber',
            isDirty: false,
            isCatalogSpecificModel: true,
            methods: {
                getList             :   getArticles
            },
            views: {
                mainList: {
                    columns         : [ 'ArticleNumber', 'ArticleName', 'UpdatedDate' ],
                    columnFilter    : {},
                    toggleFilterProps: { toggleStatus:false, filterProp:'Status', trueVal:1, trueValTooltipMessage: 'ACTIONS.TOGGLE_ACTIVE', falseVal:'', falseValTooltipMessage:"ACTIONS.TOGGLE_ALL"},
                    topIndex        : 0,
                    showFilterRow   : false,
                    sortColumn      : {'UpdatedDate': false},
                    itemActions     : [
                                        { id: 'view', label: 'ACTIONS.VIEW', icon: 'icon-magnify', privilege: 'GetCatalogArticleDetails', disabled: '!itm.Status', visible: true }
                                      ],
                    listActions     : [],
                    fabAction       : {}

                 },
                 mainDetails: {},
                privileges: {
                    list    : 'GetArticleListWithMissingSizes',
                    details : 'GetCatalogArticleDetails'
                }
            }
        };

        function getArticles(generalProperties, catalogCode) {
            var promise;

            if(angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
                var state = {};
                state.name = $state.current.name;
                state.params = $state.params;
                var isBulk = true;
                var logData = activityLogger.createLogData(null, state, 'catalogs.articlesWithoutSizes', 'VIEW', isBulk, new Date(), null, null);

                promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/articleswithoutsizes', undefined, true, generalProperties.forceFetch);
                promise = activityLogger.log(logData, promise);
            }
            else {
                catalogCode = angular.isUndefined(catalogCode) ? catalogFactory.getActiveCatalog().CatalogCode : catalogCode;
                promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/articleswithoutsizes', undefined, true, generalProperties.forceFetch);
            }

            promise.then(function() {
                if (api.catalogs.articles.isDirty) {
                    //Invalidate lookupData
                    api.catalogs.articles.lookupData = undefined;
                    api.catalogs.articles.isDirty = false;
                }
            });
            return promise;
		}

    }
})();
(function() {
    'use strict';

    angular
        .module('app.main.catalogs.reports')
        .run(runBlock);

    /* @ngInject */
    function runBlock(api, activityLogger, $state, catalogFactory) {

        if (angular.isUndefined(api.catalogs)) {
            api.catalogs = {};
        }
         api.catalogs.articlesWithoutImages = {
            modelPath: 'catalogs.articlesWithoutImages',
            fields: [
                { field: 'Id', type: 'int', displayLabel: 'ARTICLES_WITHOUT_IMAGES.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ArticleNumber', type: 'text', displayLabel: 'ARTICLES_WITHOUT_IMAGES.FIELDS.ARTICLE_NUMBER', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ArticleName', type: 'text', displayLabel: 'ARTICLES.FIELDS.MODEL_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'AttributeGroupID', type: 'int', displayLabel: 'ARTICLES_WITHOUT_IMAGES.FIELDS.ATTRIBUTE_GROUP_ID', visible: true, creatable: false, editable: false, inputType: 'lookup', lookupSource:'attributes.attributeGroups',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Status', type: 'text', displayLabel: 'ARTICLES_WITHOUT_IMAGES.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ArticleSource', type: 'text', displayLabel: 'ARTICLES_WITHOUT_IMAGES.FIELDS.ARTICLE_SOURCE', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedDate', type: 'text', displayLabel: 'ARTICLES_WITHOUT_IMAGES.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedDate', type: 'text', displayLabel: 'ARTICLES_WITHOUT_IMAGES.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedBy', type: 'text', displayLabel: 'ARTICLES_WITHOUT_IMAGES.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedBy', type: 'text', displayLabel: 'ARTICLES_WITHOUT_IMAGES.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
            ],
            uniqueConstraints: [],
            title: 'ARTICLES_WITHOUT_IMAGES.NAV',
            icon: 'icon-tile-four',
            idField: 'Id',
            lookupDisplayField: 'ArticleNumber',
            isDirty: false,
            isCatalogSpecificModel: true,
            methods: {
                getList             :   getArticles
            },
            views: {
                mainList: {
                    columns         : [ 'ArticleNumber', 'ArticleName', 'UpdatedDate' ],
                    columnFilter    : {},
                    toggleFilterProps: { toggleStatus:false, filterProp:'Status', trueVal:1, trueValTooltipMessage: 'ACTIONS.TOGGLE_ACTIVE', falseVal:'', falseValTooltipMessage:"ACTIONS.TOGGLE_ALL"},
                    topIndex        : 0,
                    showFilterRow   : false,
                    sortColumn      : {'UpdatedDate': false},
                    itemActions     : [
                                        { id: 'view', label: 'ACTIONS.VIEW', icon: 'icon-magnify', privilege: 'GetCatalogArticleDetails', disabled: '!itm.Status', visible: true }
                                      ],
                    listActions     : [],
                    fabAction       : {}

                 },
                 mainDetails: {},
                privileges: {
                    list    : 'GetArticleListWithMissingImages',
                    details : 'GetCatalogArticleDetails'
                }
            }
        };

        api.catalogs.articlesWithoutDuneImages = {
            modelPath: 'catalogs.articlesWithoutDuneImages',
            fields: [
                { field: 'Id', type: 'int', displayLabel: 'ARTICLES_WITHOUT_IMAGES.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ArticleNumber', type: 'text', displayLabel: 'ARTICLES_WITHOUT_IMAGES.FIELDS.ARTICLE_NUMBER', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ArticleName', type: 'text', displayLabel: 'ARTICLES.FIELDS.MODEL_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Status', type: 'text', displayLabel: 'ARTICLES_WITHOUT_IMAGES.FIELDS.ARTICLE_STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedDate', type: 'text', displayLabel: 'ARTICLES_WITHOUT_IMAGES.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedDate', type: 'text', displayLabel: 'ARTICLES_WITHOUT_IMAGES.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Created_By', type: 'text', displayLabel: 'ARTICLES_WITHOUT_IMAGES.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Updated_By', type: 'text', displayLabel: 'ARTICLES_WITHOUT_IMAGES.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
            ],
            uniqueConstraints: [],
            title: 'ARTICLES_WITHOUT_IMAGES.NAV',
            icon: 'icon-tile-four',
            idField: 'Id',
            lookupDisplayField: 'ArticleNumber',
            isDirty: false,
            isCatalogSpecificModel: true,
            methods: {},
            views: {
                mainList: {
                    columns         : [ 'Id', 'ArticleNumber', 'ArticleName', 'Status', 'UpdatedDate' ],
                    columnFilter    : {},
                    toggleFilterProps: { toggleStatus:false, filterProp:'Status', trueVal:1, trueValTooltipMessage: 'ACTIONS.TOGGLE_ACTIVE', falseVal:'', falseValTooltipMessage:"ACTIONS.TOGGLE_ALL"},
                    topIndex        : 0,
                    showFilterRow   : false,
                    sortColumn      : {'UpdatedDate': false},
                    itemActions     : [],
                    listActions     : [],
                    fabAction       : {}
                 },
                 mainDetails: {},
                privileges: {
                    list    : 'GetArticleListWithMissingImages',
                    details : 'GetCatalogArticleDetails'
                }
            }
        };

        function getArticles(generalProperties, catalogCode) {
            var promise;

            if(angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
                var state = {};
                state.name = $state.current.name;
                state.params = $state.params;
                var isBulk = true;
                var logData = activityLogger.createLogData(null, state, 'catalogs.articlesWithoutImages', 'VIEW', isBulk, new Date(), null, null);

                promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/articleswithoutimages', undefined, true, generalProperties.forceFetch);
                promise = activityLogger.log(logData, promise);
            }
            else {
                catalogCode = angular.isUndefined(catalogCode) ? catalogFactory.getActiveCatalog().CatalogCode : catalogCode;
                promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/articleswithoutimages', undefined, true, generalProperties.forceFetch);
            }

            promise.then(function() {
                if (api.catalogs.articles.isDirty) {
                    //Invalidate lookupData
                    api.catalogs.articles.lookupData = undefined;
                    api.catalogs.articles.isDirty = false;
                }
            });
            return promise;
		}

    }
})();
(function() {
  'use strict';

  angular
      .module('app.main.catalogs.reports')
      .run(runBlock);

  /* @ngInject */
  function runBlock(api, activityLogger, $state, catalogFactory) {

      if (angular.isUndefined(api.catalogs)) {
          api.catalogs = {};
      }
       api.catalogs.articlesWithDpAccount = {
          modelPath: 'catalogs.articlesWithDpAccount',
          fields: [
              { field: 'DPAccountGroup', type: 'text', displayLabel: 'ARTICLES_WITH_DP_ACCOUNT.FIELDS.DP_ACCOUNT_GROUP', visible: true, creatable: false, editable: false, inputType: 'text',
                  validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
              { field: 'CustomerCode', type: 'text', displayLabel: 'ARTICLES_WITH_DP_ACCOUNT.FIELDS.CUSTOMER_CODE', visible: true, creatable: false, editable: false, inputType: 'text',
                  validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
              { field: 'ArticleNumber', type: 'text', displayLabel: 'ARTICLES_WITH_DP_ACCOUNT.FIELDS.ARTICLE_NUMBER', visible: true, creatable: false, editable: false, inputType: 'text',
                  validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
          ],
          uniqueConstraints: [],
          title: 'ARTICLES_WITH_DP_ACCOUNT',
          icon: 'icon-tile-four',
          idField: 'ArticleNumber',
          lookupDisplayField: 'DPAccountGroup',
          isDirty: false,
          isCatalogSpecificModel: true,
          methods: {
              getList             :   getArticles
          },
          views: {
              mainList: {
                  columns         : [ 'ArticleNumber', 'DPAccountGroup', 'CustomerCode' ],
                  columnFilter    : {},
                  toggleFilterProps: {},
                  topIndex        : 0,
                  showFilterRow   : false,
                  sortColumn      : {},
                  itemActions     : [],
                  listActions     : [],
                  fabAction       : {}

               },
               mainDetails: {},
              privileges: {
                  list    : 'GetArticlesWithDPAccount'
              }
          }
      };

      function getArticles(generalProperties, catalogCode) {
          var promise;

          if(angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
              var state = {};
              state.name = $state.current.name;
              state.params = $state.params;
              var isBulk = true;
              var logData = activityLogger.createLogData(null, state, 'catalogs.articlesWithoutSizes', 'VIEW', isBulk, new Date(), null, null);

              promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/articleswithdpaccount', undefined, true, generalProperties.forceFetch);
              promise = activityLogger.log(logData, promise);
          }
          else {
              catalogCode = angular.isUndefined(catalogCode) ? catalogFactory.getActiveCatalog().CatalogCode : catalogCode;
              promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/articleswithdpaccount', undefined, true, generalProperties.forceFetch);
          }

          promise.then(function() {
              if (api.catalogs.articlesWithoutSizes.isDirty) {
                  //Invalidate lookupData
                  api.catalogs.articlesWithoutSizes.lookupData = undefined;
                  api.catalogs.articlesWithoutSizes.isDirty = false;
              }
          });
          return promise;
  }

  }
})();
(function () {
	'use strict';

	angular
		.module('app.main.catalogs.prices-linear')
		.run(runBlock);

	/* @ngInject */
	function runBlock(api, activityLogger, $state, catalogFactory, jobsTracker, dialog, $document, $filter, CONSTANTS) {

		if (angular.isUndefined(api.catalogs)) {
			api.catalogs = {};
		}
		 api.catalogs.pricesLinear = {
			modelPath: 'catalogs.pricesLinear',
			fields: [
				{ field: 'ArticleId', map:'Id', type: 'int', displayLabel: 'PRICES_LINEAR.FIELDS.ARTICLE_ID', visible: true, creatable: false, editable: false, inputType: 'number',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'ArticleNumber', map: 'ArticleNumber', type: 'text', displayLabel: 'PRICES_LINEAR.FIELDS.ARTICLE_NUMBER', visible: true, creatable: true, editable: false, inputType: 'text',
					validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'ModelNumber', map: 'ModelNumber', type: 'text', displayLabel: 'PRICES_LINEAR.FIELDS.MODEL_NUMBER', visible: true, creatable: false, editable: false, inputType: 'text',
					validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'ArticleName', map: 'ArticleName', type: 'text', displayLabel: 'ARTICLES.FIELDS.MODEL_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
					validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'Locked', map:'Locked', type: 'int', displayLabel: 'PRICES_LINEAR.FIELDS.ARTICLE_LOCK_STATUS', visible: true, creatable: false, editable: false, inputType: 'bool-int',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'isEditDisable', type: 'text', visible: false, creatable: false, editable: false, inputType: 'status' },
				{ field: 'Id', type: 'int', displayLabel: 'PRICES_LINEAR.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'PriceGroupId', type: 'int', displayLabel: 'PRICES_LINEAR.FIELDS.PRICEGROUP_ID', visible: true, creatable: true, editable: false, inputType: 'lookup', lookupSource:'catalogs.priceGroup',
				   lookupFilter: {Status: 1}, validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'CreatedDate', type: 'text', displayLabel: 'PRICES_LINEAR.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
				   validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'UpdatedDate', type: 'text', displayLabel: 'PRICES_LINEAR.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
				   validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'Status', type: 'text', displayLabel: 'PRICES_LINEAR.FIELDS.ARTICLE_STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
				   validation: { isRequired: true, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
				{ field: 'Price', type: 'int', displayLabel: 'PRICES_LINEAR.FIELDS.PRICE', visible: true, creatable: true, editable: true, inputType: 'decimal',
				   validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '^[+]?\\d+([.]\\d{0,2})?$', checkIfPriceGroupLockedAtArticleState: true, messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: 'VALIDATIONS.PRICE'}} },
				{ field: 'IsEditable', type: 'int', displayLabel: 'PRICES_LINEAR.FIELDS.IS_EDITABLE', visible: true, creatable: false, editable: false, inputType: 'bool-int',
				   validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'StateId', map:'StateId', type: 'int', displayLabel: 'PRICES_LINEAR.FIELDS.STATE_NAME', visible: true, creatable: false, editable: false, inputType: 'lookup', lookupSource:'catalogs.articleStates',
					 validation: {isRequired: false, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
			 	{ field: 'StateRank', map:'StateRank', type: 'int', displayLabel: 'PRICES_LINEAR.FIELDS.STATE_RANK', visible: false, creatable: false, editable: false, inputType: 'number',
					 validation: {isRequired: false, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
			],
			title: 'PRICES_LINEAR.NAV',
			icon: 'icon-coin',
			idField: 'PriceGroupId',
			lookupDisplayField: 'Name',
			isDirty: false,
			isBulkActionCompleted: false,
			isCatalogSpecificModel: true,
			validateStateEditableFields: true,
			methods: {
				getList     : getPrices,
				update      : updateArticlePrices,
				createBulk  : createBulk
			},
			views: {
				mainList: {
					columns         : ['ArticleId', 'ArticleNumber', 'ArticleName', 'ModelNumber', 'PriceGroupId', 'Price', 'UpdatedDate'],
					columnFilter    : {},
					topIndex        : 0,
					showFilterRow   : false,
					sortColumn      : {'UpdatedDate': false},
					itemActions     : [
										{ id: 'view', label: 'ACTIONS.VIEW', icon: 'icon-magnify', privilege: 'GetCatalogArticlePricesList', disabled: false, visible: true },
										{ id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UpdateCatalogArticleBulkPrices:true', disabled: 'itm.isEditDisable', visible: true }
									  ],
					listActions     : [
										{ id: 'import', label: 'ACTIONS.IMPORT', icon: 'icon-import', privilege: 'UI_ImportPrices:true', disabled: false, visible: true, requiresConfirmation: false }
									  ],
					fabAction       : {}

				 },
				 mainDetails: {},
				privileges: {
					list    : 'GetCatalogAllArticlePrices'
				}
			}
		};


		function getPrices(generalProperties, model, catalogId) {
			if (angular.isDefined(model)) { // to skip this part for load lookup
				model.isBulkActionCompleted = false;
			}
			var promise;

			if (angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
				var state = {};
				state.name = $state.current.name;
				state.params = $state.params;
				var isBulk = true;
				var logData = activityLogger.createLogData(null, state, 'catalogs.prices', 'VIEW', isBulk, new Date(), null, null);

				promise = api.webGet(api.baseUrl + '/catalogs/' + catalogId + '/articleprices',
						generalProperties.config || {}, true, generalProperties.forceFetch,
						generalProperties.supportIncrementalResult || true,
						generalProperties.modelIdField,
						generalProperties.isMajor || false,
						model || api.catalogs.pricesLinear);
				promise = activityLogger.log(logData, promise);
			}
			else {
					catalogId = angular.isUndefined(catalogId) ? catalogFactory.getActiveCatalog().CatalogCode : catalogId;
					promise = api.webGet(api.baseUrl + '/catalogs/' + catalogId + '/articleprices',
							generalProperties.config || {}, true, generalProperties.forceFetch,
							generalProperties.supportIncrementalResult || true,
							generalProperties.modelIdField,
							generalProperties.isMajor || false,
							model || api.catalogs.pricesLinear);
			}

			promise.then(function () {
				if (api.catalogs.pricesLinear.isDirty) {
					//Invalidate lookupData
					api.catalogs.pricesLinear.lookupData = undefined;
					api.catalogs.pricesLinear.isDirty = false;
				}
			});
			return promise;
		}

		function updateArticlePrices(record, article, activeCatalog) {
			//Transform data into required format
			var requestObj = { 'Prices': [] };
			if (angular.isDefined(record.Price) && angular.isDefined(record.PriceGroupId)) {
				requestObj.Prices.push( { Price: record.Price, PriceGroupId: record.PriceGroupId } );
			}

			var state = {};
			state.name = $state.current.name;
			state.params = $state.params;
			var logData = activityLogger.createLogData(article, state, 'catalogs.prices', 'EDIT', false, new Date(), null, null);
			var url = '';
			if (activeCatalog.IsPriceByStyleApply === 0) {
				url = api.baseUrl + '/catalogs/' + activeCatalog.CatalogCode + '/articles/' + article + '/articleprices';
			}
			else {
				url = api.baseUrl + '/catalogs/' + activeCatalog.CatalogCode + '/modelnumber/' + article + '/prices';
			}
			var promise = api.webPut(url, requestObj);

			promise.then(function () {
				api.catalogs.pricesLinear.isDirty = true;
				api.catalogs.prices.isDirty =  true;
			});
			return activityLogger.log(logData, promise);
		}

		function createBulk(dataImporterResult, activeCatalog, model) {
			var secondaryModel = api.catalogs.prices;
			//Transform data into required format
			var transformedData = [];
			var nameIndexes = {};
			var itemsNameList = [];
			var data = dataImporterResult.data;
			var requestObj = {};
			var newElement = {};
			for (var i = 0; i < data.length; i++) {
				var mainParameter = '';
				if (activeCatalog.IsPriceByStyleApply === 1) {
					mainParameter = 'ModelNumber';
					newElement = { ModelNumber: data[i][mainParameter], Prices: [] };
				}
				else {
					mainParameter = 'ArticleNumber';
					newElement = { ArticleNumber: data[i][mainParameter], Prices: [] };
				}
				var ind = -1;
				if (angular.isUndefined(nameIndexes[data[i][mainParameter].toUpperCase()])) {
					ind = transformedData.length;
					nameIndexes[data[i][mainParameter].toUpperCase()] = ind;
					transformedData.push(newElement);
					itemsNameList.push(data[i][mainParameter]);
				} else {
					ind = nameIndexes[data[i][mainParameter].toUpperCase()];
				}
				if (angular.isDefined(data[i].Price) && angular.isDefined(data[i].PriceGroupId)) {
					var prices = {
						Price: data[i].Price,
						PriceGroupId: data[i].PriceGroupId
					}
					transformedData[ind].Prices.push(prices);
				}
			}
			nameIndexes = undefined;

			requestObj.ArticlePrices = transformedData;

			// if there is no priceGroup editable ArticlePrices will be empty array
			if (requestObj.ArticlePrices.length) {
				var promise;
				var jobIndex = jobsTracker.addJob(model, 'PRICES_LINEAR.ACTIONS.IMPORT_PRICES', 1, secondaryModel);
				if (activeCatalog.IsPriceByStyleApply === 1) {
					promise = api.webPut(api.baseUrl + '/catalogs/' + activeCatalog.CatalogCode + '/modelprices?sourceapplication=' + CONSTANTS.SOURCE_APPLICATION + '&sourceaction=Import Prices', requestObj);
				}
				else {
					promise = api.webPut(api.baseUrl + '/catalogs/' + activeCatalog.CatalogCode + '/articlePrices?sourceapplication=' + CONSTANTS.SOURCE_APPLICATION + '&sourceaction=Import Prices', requestObj);
				}
				promise.then(function (response) {
					jobsTracker.trackJob(jobIndex, response.data.Id);
				}).catch(function (error) {
					jobsTracker.setCriticlaFail(jobIndex, error);
				});
			}
			else {
				dialog.showAlertDialog(
					angular.element($document[0].body),
					$filter('translate')('MESSAGES.TITLE.ALERT'),
					$filter('translate')('PRICES_LINEAR.MESSAGES.NO_EDITABLE_PRICE_GROUPS'),
					$filter('translate')('MESSAGES.TITLE.ALERT'),
					$filter('translate')('ACTIONS.DIALOG_CLOSE'),
					true,
					null
				);
			}
		}

	}
})();
(function() {
    'use strict';

    angular
        .module('app.main.catalogs.prices')
        .run(runBlock);

    /* @ngInject */
    function runBlock(api, activityLogger, $state, catalogFactory, jobsTracker, dialog, $document, $filter, CONSTANTS) {

        if (angular.isUndefined(api.catalogs)) {
            api.catalogs = {};
        }
         api.catalogs.prices = {
            modelPath: 'catalogs.prices',
            fields: [
                { field: 'ArticleId', map:'Id', type: 'int', displayLabel: 'PRICES.FIELDS.ARTICLE_ID', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ArticleNumber', map: 'ArticleNumber', type: 'text', displayLabel: 'PRICES.FIELDS.ARTICLE_NUMBER', visible: true, creatable: true, editable: false, inputType: 'text',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ModelNumber', map: 'ModelNumber', type: 'text', displayLabel: 'PRICES.FIELDS.MODEL_NUMBER', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                // used for importing prices using licencee model number from articles
                { field: 'LicenseeModelNumber', type: 'text', displayLabel: 'ARTICLES.FIELDS.LICENCEE_MODEL_NUMBER', visible: false, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: true, maxLen: 200, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ArticleName', map: 'ArticleName', type: 'text', displayLabel: 'ARTICLES.FIELDS.MODEL_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Locked', map:'Locked', type: 'int', displayLabel: 'PRICES.FIELDS.ARTICLE_LOCK_STATUS', visible: true, creatable: false, editable: false, inputType: 'bool-int',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Status',  map:'Status', type: 'text', displayLabel: 'PRICES_LINEAR.FIELDS.ARTICLE_STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'StateId', map:'StateId', type: 'int', displayLabel: 'ARTICLES.FIELDS.STATE_NAME', visible: true, creatable: false, editable: false, inputType: 'lookup', lookupSource:'catalogs.articleStates',
                    validation: {isRequired: false, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'StateRank', map:'StateRank', type: 'int', displayLabel: 'SELLER_MODELS.FIELDS.STATE_RANK', visible: false, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ModelStateId', map:'ModelStateId', type: 'int', displayLabel: 'ARTICLES.FIELDS.MODEL_STATE_NAME', visible: true, creatable: false, editable: false, inputType: 'lookup', lookupSource:'catalogs.articleStates',
                    validation: {isRequired: false, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ModelStateRank', map:'ModelStateRank', type: 'int', displayLabel: 'SELLER_MODELS.FIELDS.MODEL_STATE_RANK', visible: false, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'LastUpdatedOn', map: 'Prices._nestedData.UpdatedDate', type: 'date', displayLabel: 'PRICES.FIELDS.LAST_UPDATED_ON', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: ''}},
                { field: 'isEditDisable', type: 'text', visible: false, creatable: false, editable: false, inputType: 'status' }
            ],
            uniqueConstraints: [
                {name: 'Constraint 1', fields: ['ArticleNumber']}
            ],
            title: 'PRICES.NAV',
            icon: 'icon-coin',
            idField: 'PriceGroupId',
            lookupDisplayField: 'Name',
            isDirty: false,
            isBulkActionCompleted: false,
            isCatalogSpecificModel: true,
            validateStateEditableFields: true,
            methods: {
                getList     : getPrices,
                update      : updateArticlePrices,
                createBulk  : createBulk,
                updateBulk  : updateBulk
            },
            views: {
                mainList: {
                    columns         : [ 'ArticleNumber', 'ModelNumber', 'LastUpdatedOn'],
                    columnFilter    : {},
                    topIndex        : 0,
                    showFilterRow   : false,
                    sortColumn      : {'ArticleNumber': true},
                    itemActions     : [
                                        { id: 'view', label: 'ACTIONS.VIEW', icon: 'icon-magnify', privilege: 'GetCatalogArticlePricesList', disabled: false, visible: true },
                                        { id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UpdateCatalogArticleBulkPrices:true', disabled: 'itm.isEditDisable', visible: true }
                                      ],
                    listActions     : [
                                        { id: 'updateBulk', label: 'ACTIONS.UPDATE_BULK', icon: 'icon-pencil', privilege: 'UpdateCatalogBulkArticlePrices:true', disabled: '{selected: true, isEditDisable: ["!1"]}', visible: true, requiresConfirmation: false },
                                        { id: 'import', label: 'ACTIONS.IMPORT', icon: 'icon-import', privilege: 'UI_ImportPrices:true', disabled: false, visible: true, requiresConfirmation: false }
                                      ],
                    fabAction       : {}

                 },
                 mainDetails: {},
                privileges: {
                    list    : 'GetCatalogAllArticlePrices'
                }
            }
        };


        function getPrices(generalProperties, model, catalogId) {
            if (angular.isDefined(model)) { // to skip this part for load lookup
                model.isBulkActionCompleted = false;
            }
            var promise;

            if (angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
                var state = {};
                state.name = $state.current.name;
                state.params = $state.params;
                var isBulk = true;
                var logData = activityLogger.createLogData(null, state, 'catalogs.prices', 'VIEW', isBulk, new Date(), null, null);

                promise = api.webGet(api.baseUrl + '/catalogs/' + catalogId + '/articleprices',
                    generalProperties.config || {}, true, generalProperties.forceFetch,
                    generalProperties.supportIncrementalResult || false,
                    generalProperties.modelIdField,
                    generalProperties.isMajor || false,
                    model || api.catalogs.prices,
                    generalProperties.isArticleRelatedData,
                    catalogId, generalProperties.nestedArrayName || 'Prices',
                    generalProperties.nestedDataIdField || 'Id');
                promise = activityLogger.log(logData, promise);
            }
            else {
                catalogId = angular.isUndefined(catalogId) ? catalogFactory.getActiveCatalog().CatalogCode : catalogId;
                promise = api.webGet(api.baseUrl + '/catalogs/' + catalogId + '/articleprices',
                    generalProperties.config || {}, true, generalProperties.forceFetch,
                    generalProperties.supportIncrementalResult || false,
                    generalProperties.modelIdField,
                    generalProperties.isMajor || false,
                    model || api.catalogs.prices,
                    generalProperties.isArticleRelatedData,
                    catalogId, generalProperties.nestedArrayName || 'Prices',
                    generalProperties.nestedDataIdField || 'Id');
            }

            promise.then(function () {
                if (api.catalogs.prices.isDirty) {
                    //Invalidate lookupData
                    api.catalogs.prices.lookupData = undefined;
                    api.catalogs.prices.isDirty = false;
                }
            });
            return promise;
        }

        function updateArticlePrices(record, article, activeCatalog) {
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var logData = activityLogger.createLogData(article, state, 'catalogs.prices', 'EDIT', false, new Date(), null, null);
            var url = '';
            if(activeCatalog.IsPriceByStyleApply === 0) {
                url = api.baseUrl + '/catalogs/' + activeCatalog.CatalogCode + '/articles/' + article + '/articleprices';
            }
            else {
                url = api.baseUrl + '/catalogs/' + activeCatalog.CatalogCode + '/modelnumber/' + article + '/prices';
            }
			var promise = api.webPut(url, record);

            promise.then(function() {
                api.catalogs.prices.isDirty = true;
                api.catalogs.pricesLinear.isDirty = true;
            });
            return activityLogger.log(logData, promise);
		}

        function createBulk(dataImporterResult, activeCatalog, model) {
            var requestObj = {};
            var data = dataImporterResult.data;
            var secondaryModel = api.catalogs.pricesLinear;
            //Transform data into required format
            var transformedData = [];
            var newElement = {};
            angular.forEach(data, function(element) {
                if(activeCatalog.IsPriceByStyleApply === 1) {
                    newElement = { ModelNumber: element.ModelNumber, Prices: [] };
                }
                else {
                    newElement = { ArticleNumber: element.ArticleNumber, Prices: [] };
                }
                angular.forEach(model.fields,function(field) {
                    if (field.isCatalogProperty) {
                        // skip if there is no price for the price-group, since made price-groups non mandatory it could not be send from excel
                        if(angular.isDefined(element[field.field]) && element[field.field] != null) {
                            newElement.Prices.push({PriceGroupId: field.priceGroupId, Price: element[field.field]});
                        }
                    }
                });
                // skip article entry if there is no price group sent
                if(newElement.Prices.length) {
                    transformedData.push(newElement);
                }
            });

            requestObj.ArticlePrices = transformedData;

            // if there is no priceGroup editable ArticlePrices will be empty array
            if(requestObj.ArticlePrices.length) {
                var promise;
                var jobIndex = jobsTracker.addJob(model, 'PRICES.ACTIONS.IMPORT_PRICES', 1, secondaryModel);
                if(activeCatalog.IsPriceByStyleApply === 1) {
                    promise = api.webPut(api.baseUrl + '/catalogs/' + activeCatalog.CatalogCode + '/modelprices?sourceapplication=' + CONSTANTS.SOURCE_APPLICATION + '&sourceaction=Import Prices', requestObj);
                }
                else {
                    promise = api.webPut(api.baseUrl + '/catalogs/' + activeCatalog.CatalogCode + '/articlePrices?sourceapplication=' + CONSTANTS.SOURCE_APPLICATION + '&sourceaction=Import Prices', requestObj);
                }
                promise.then(function(response) {
                    jobsTracker.trackJob(jobIndex, response.data.Id);
                }).catch(function(error) {
                    jobsTracker.setCriticlaFail(jobIndex, error);
                });
            }
            else {
                dialog.showAlertDialog(
                    angular.element($document[0].body),
                    $filter('translate')('MESSAGES.TITLE.ALERT'),
                    $filter('translate')('PRICES.MESSAGES.NO_EDITABLE_PRICE_GROUPS'),
                    $filter('translate')('MESSAGES.TITLE.ALERT'),
                    $filter('translate')('ACTIONS.DIALOG_CLOSE'),
                    true,
                    null
                );
            }
        }

        function updateBulk(model, records, updateRecord, idMap) {
            var secondaryModel = api.catalogs.pricesLinear;
            //Transform data into required format
            var requestObj = {};
            var transformedData = [];
            angular.forEach(records, function(record) {
                var newRecord = { ArticleNumber: record.ArticleNumber, Prices: [] };
                angular.forEach(model.fields, function(field) {

                    if (field.isCatalogProperty) {
                        // if record needed to be update with new value
                        if(angular.isDefined(updateRecord[field.field])) {
                            updateRecord[field.field] = (updateRecord[field.field] === null || updateRecord[field.field] === '') ? 0 : updateRecord[field.field];
                            newRecord.Prices.push({PriceGroupId: field.priceGroupId, Price: updateRecord[field.field]});
                        }
                    }
                });
                if(newRecord.Prices.length) {
                    transformedData.push(newRecord);
                }
            });
            requestObj.ArticlePrices = transformedData;
            var jobIndex = jobsTracker.addJob(model, 'PRICES.ACTIONS.UPDATE_PRICES', 1, secondaryModel);
            api.webPut(api.baseUrl + '/catalogs/' + idMap.catalogId + '/articlePrices?sourceapplication=' + CONSTANTS.SOURCE_APPLICATION + '&sourceaction=Update Prices', requestObj).then(function(response) {
                jobsTracker.trackJob(jobIndex, response.data.Id);
            }).catch(function(error) {
                jobsTracker.setCriticlaFail(jobIndex, error);
            });
        }

    }
})();
(function() {
		'use strict';

		angular
				.module('app.main.catalogs.packages')
				.run(runBlock);

		/* @ngInject */
		function runBlock(api, activityLogger, $state, catalogFactory, jobsTracker) {

				if (angular.isUndefined(api.catalogs)) {
						api.catalogs = {};
				}
				 api.catalogs.packages = {
						modelPath: 'catalogs.packages',
						fields: [
								{ field: 'Id', type: 'int', displayLabel: 'PACKAGES.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'Version', type: 'text', displayLabel: 'PACKAGES.FIELDS.VERSION', visible: true, creatable: false, editable: false, inputType: 'text',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'FileName', type: 'text', displayLabel: 'PACKAGES.FIELDS.FILE_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'FilePath', type: 'text', displayLabel: 'PACKAGES.FIELDS.FILE_PATH', visible: true, creatable: false, editable: false, inputType: 'text',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'ImagesFileName', type: 'text', displayLabel: 'PACKAGES.FIELDS.IMAGES_FILE_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'SellerAccountId', type: 'text', displayLabel: 'PACKAGES.FIELDS.SELLER_ID', visible: true, creatable: false, editable: false, inputType: 'text',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'PackageStatusId', type: 'text', displayLabel: 'PACKAGES.FIELDS.PACKAGE_STATUS', visible: false, creatable: false, editable: false, inputType: 'text',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'PackageStatus', type: 'text', displayLabel: 'PACKAGES.FIELDS.PACKAGE_STATUS', visible: true, creatable: false, editable: false, inputType: 'text',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'Status', type: 'text', displayLabel: 'PACKAGES.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'CreatedDate', type: 'text', displayLabel: 'PACKAGES.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'UpdatedDate', type: 'text', displayLabel: 'PACKAGES.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'CreatedBy', type: 'text', displayLabel: 'PACKAGES.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'UpdatedBy', type: 'text', displayLabel: 'PACKAGES.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }

						],
						uniqueConstraints: [],
						title: 'PACKAGES.NAV',
						icon: 'icon-package-variant',
						idField: 'Id',
						lookupDisplayField: 'Version',
						isDirty: false,
						isCatalogSpecificModel: true,
						methods: {
								getList             :   getPackages,
								publish             :   publishPackage,
								getDetails          :   getPackage
						},
						views: {
								mainList: {
										columns         : [ 'FileName', 'Version', 'PackageStatus', 'Status', 'UpdatedDate' ],
										columnFilter    : {},
										toggleFilterProps: { toggleStatus:false, filterProp:'Status', trueVal:1, trueValTooltipMessage: 'ACTIONS.TOGGLE_ACTIVE', falseVal:'', falseValTooltipMessage:"ACTIONS.TOGGLE_ALL"},
										topIndex        : 0,
										showFilterRow   : false,
										sortColumn      : {'UpdatedDate': false},
										itemActions     : [
																				{ id: 'view', label: 'ACTIONS.VIEW', icon: 'icon-magnify', privilege: 'GetCatalogDataUpdateDetails', disabled: '!itm.Status', visible: true },
																				{ id: 'download', label: 'ACTIONS.DOWNLOAD', icon: 'icon-download', privilege: 'GetCatalogDataUpdateList:true', disabled: 'false', visible: true , url: true}
																			],
										listActions     : [],
										fabAction       : {id: 'add', label: 'ACTIONS.ADD', icon: 'icon-plus', privilege: 'CreateCatalogDataUpdates:true', visible: true,
																				confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_PUBLISH'}, confirmationAction: 'ACTIONS.PUBLISH_CATALOG'}
								 },
								 mainDetails: {
										 selectedTabIndex   : 0,
										 itemActions        : [
																						{ id: 'download', label: 'ACTIONS.DOWNLOAD', icon: 'icon-download', privilege: 'GetCatalogDataUpdateDetails:true', disabled: false, visible: true , url: true}
																					],
										 fabAction          : {}
								 },
								privileges: {
										list    : 'GetCatalogDataUpdateList',
										details : 'GetCatalogDataUpdateDetails'
								}
						}
				};

				function getPackages(generalProperties, model, catalogId) {
						if(angular.isDefined(model)) { // to skip this part for load lookup
								model.isBulkActionCompleted = false;
						}
						var promise;

						if(angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
								var state = {};
								state.name = $state.current.name;
								state.params = $state.params;
								var isBulk = true;
								var logData = activityLogger.createLogData(null, state, 'catalogs.packages', 'VIEW', isBulk, new Date(), null, null);

								promise = api.webGet(api.baseUrl + '/catalogs/' + catalogId + '/updates', undefined, true, generalProperties.forceFetch);
								promise = activityLogger.log(logData, promise);
						}
						else {
								catalogId = angular.isUndefined(catalogId) ? catalogFactory.getActiveCatalog().CatalogCode : catalogId;
								promise = api.webGet(api.baseUrl + '/catalogs/' + catalogId + '/updates', undefined, true, generalProperties.forceFetch);
						}

						promise.then(function() {
								if (api.catalogs.packages.isDirty) {
										//Invalidate lookupData
										api.catalogs.packages.lookupData = undefined;
										api.catalogs.packages.isDirty = false;
								}
						});
						return promise;
				}

				function publishPackage(model, record, catalog, catalogId) {
						var jobIndex = jobsTracker.addJob(model, 'PACKAGES.ACTIONS.PUBLISH_PACKAGE', 4);
						var state = {};
						state.name = $state.current.name;
						state.params = $state.params;
						var logData = activityLogger.createLogData(catalog[api.catalogs.catalogs.lookupDisplayField], state, 'catalogs.packages', 'ADD', false, new Date(), null, null);
						var promise = api.webPost(api.baseUrl + '/catalogs/' + catalogId + '/updates', record);

						promise.then(function(response) {
								jobsTracker.trackJob(jobIndex, response.data.Id);
								// api.catalogs.packages.isDirty = true;
						}).catch(function(error) {
								jobsTracker.setCriticlaFail(jobIndex, error);
						});
						return activityLogger.log(logData, promise);
				}

				function getPackage(packageId, isLogRequired) {
					var promise;
					if(angular.isDefined(isLogRequired) && isLogRequired === true) {
						var state = {};
						state.name = $state.current.name;
						state.params = $state.params;
						var isBulk = false;

						promise = api.webGet(api.baseUrl + '/backgroundjobs/packages/' + packageId);
						var logData = activityLogger.createLogData(null, state, 'catalogs.packages', 'VIEW', isBulk, new Date(), null, null);
						promise = activityLogger.log(logData, promise);
					}
					else {
						promise = api.webGet(api.baseUrl + '/backgroundjobs/packages/' + packageId);
					}
					return promise;
				}
		}

})();
(function() {
    'use strict';

    angular
        .module('app.main.catalogs.overview',[])
        .config(config);

    /* @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
        // State
        $stateProvider.state('app.overview', {
            url    : '/overview',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/catalogs/sub-modules/overview/overview.html',
                    controller : 'overviewController as vm'
                }
            },
            data: {
                displayName: 'OVERVIEW.NAV'
            },
            //only users with following accessPrivileges in their role access list can access this route
            // accessPrivileges: ['GetCatalogActiveDeActiveRecordsStatics']
            // accessPrivileges: ['nav_overview']
            accessInfo: {
                accessPrivileges: ['nav_overview']
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/catalogs/sub-modules/overview');

        msNavigationServiceProvider.saveItem('catalogs.overview', {
            title      : 'Overview',
            icon       : 'icon-chart-pie',
            state      : 'app.overview',
            translate  : 'OVERVIEW.NAV',
            weight     : 10,
            // accessPrivileges: ['GetCatalogActiveDeActiveRecordsStatics']
            // accessPrivileges: ['nav_overview']
            accessInfo: {
                accessPrivileges: ['nav_overview']
            }
        });
    }
})();
(function() {
    'use strict';

    angular
        .module('app.main.catalogs.overview')
        .controller('overviewController', overviewController);

    /* @ngInject */
    function overviewController(api, $scope, $filter, $rootScope, catalogFactory, utility) {
       /* jshint validthis: true */
        var vm = this;

        // Data
        var activeCatalog = catalogFactory.getActiveCatalog();
        var activeCatalogCode = activeCatalog.CatalogCode;

        vm.data = {};



        // Methods
        vm.refresh = refreshRecord;

        activate();

        ////////////////

        function activate() {
            vm.charts = {};
            refreshRecord(true);
        }

        function refreshRecord() {
            vm.isLoading = true;

            api.webGet(api.baseUrl + '/catalogs/' + activeCatalogCode + '/stats').then(function(response) {
                if (angular.isDefined(response) && angular.isDefined(response.data)) {
                    vm.data = response.data;
                }
                if(vm.data.TotalArticles > 0) {
                    generateChartData(vm.data);
                }
            }).finally(function () {
                vm.isLoading = false;
            });
        }

        function generateChartData() {
            var articleStatusData = vm.data.Statuses;
            var activeArticlesCountData = utility.filterObject(articleStatusData, {Status: 1})[0];
            var inActiveArticlesCountData = utility.filterObject(articleStatusData, {Status: 0})[0];
            if(angular.isUndefined(activeArticlesCountData)) {
                activeArticlesCountData = {
                    Count: 0
                }
            }
            if(angular.isUndefined(inActiveArticlesCountData)) {
                inActiveArticlesCountData = {
                    Count: 0
                }
            }
            var stateChartData = [];
            vm.charts.articles = {
                config : {
                    refreshDataOnly: true,
                    deepWatchData  : true
                },
                options: {
                    chart: {
                        type        : 'pieChart',
                        color       : ['#03A9F4', '#F44336'],
                        height      : 350,
                        margin      : {
                            top   : 0,
                            right : 0,
                            bottom: 0,
                            left  : 0
                        },
                        donut       : true,
                        clipEdge    : true,
                        cornerRadius: 0,
                        labelType   : 'value',
                        padAngle    : 0,
                        x           : function (d)
                        {
                            return d.label;
                        },
                        y           : function (d)
                        {
                            return d.value;
                        },
                        tooltip     : {
                            gravity: 's',
                            classes: 'gravity-s'
                        },
                        valueFormat: function(n) { if (angular.isDefined(n)) { return $filter('number')(n, 0); } }
                    }
                },
                data   : [
                    { label: 'Active', value: activeArticlesCountData.Count },
                    { label: 'Inactive', value: inActiveArticlesCountData.Count }
                ]
            }

            angular.forEach(vm.data.States, function(state) {
                var stateObject = { label: state.State, value: state.Count };
                stateChartData.push(stateObject);
            });
            vm.charts.states = {
                config : {
                    refreshDataOnly: true,
                    deepWatchData  : true
                },
                options: {
                    chart: {
                        type        : 'pieChart',
                        color       : ['#03A9F4', '#F44336', '#65C400', '#8c581b', '#4933FF', '#ff7f0e', '#1f77b4'],
                        height      : 350,
                        margin      : {
                            top   : 0,
                            right : 0,
                            bottom: 0,
                            left  : 0
                        },
                        donut       : true,
                        clipEdge    : true,
                        cornerRadius: 0,
                        labelType   : 'value',
                        padAngle    : 0,
                        x           : function (d)
                        {
                            return d.label;
                        },
                        y           : function (d)
                        {
                            return d.value;
                        },
                        tooltip     : {
                            gravity: 's',
                            classes: 'gravity-s'
                        },
                        valueFormat: function(n) { if (angular.isDefined(n)) { return $filter('number')(n, 0); } }
                    }
                },
                data   : stateChartData
            }
        }

        var catalogChangedEventCleanup = $rootScope.$on('ActiveCatalogChangedEvent', function(e) {
            if(activeCatalogCode !== catalogFactory.getActiveCatalog().CatalogCode) {
                activeCatalog = catalogFactory.getActiveCatalog();
                activeCatalogCode = activeCatalog.CatalogCode;
                refreshRecord();
            }
        });
        $scope.$on('$destroy', function () {
            catalogChangedEventCleanup();
        });
    }
})();
(function() {
	'use strict';

	angular
		.module('app.main.catalogs.orders-terms-conditons')
		.run(runBlock);

	/* @ngInject */
	function runBlock(api, $state, activityLogger, crud) {

		if (angular.isUndefined(api.catalogs)) {
			api.catalogs = {};
		}
		 api.catalogs.ordersTermsConditions = {
			modelPath: 'catalogs.ordersTermsConditions',
			fields: [
				{ field: 'Id', type: 'int', displayLabel: 'ORDERS_T&C.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
						validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'Version', type: 'int', displayLabel: 'ORDERS_T&C.FIELDS.VERSION', visible: true, creatable: false, editable: false, inputType: 'number',
						validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'Title', type: 'text', displayLabel: 'ORDERS_T&C.FIELDS.TITLE', visible: true, creatable: true, editable: true, inputType: 'text',
						validation: {isRequired: true, maxLen: 250, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'Content', type: 'text', displayLabel: 'ORDERS_T&C.FIELDS.CONTENT', visible: false, creatable: true, editable: true, inputType: 'text',
						validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'Status', type: 'text', displayLabel: 'ORDERS_T&C.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
						validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'CreatedBy', type: 'text', displayLabel: 'ORDERS_T&C.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
						validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'UpdatedBy', type: 'text', displayLabel: 'ORDERS_T&C.FIELDS.UPDATED_BY', visible: true, creatable: true, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
						validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'CreatedDate', type: 'text', displayLabel: 'ORDERS_T&C.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
						validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'UpdatedDate', type: 'text', displayLabel: 'ORDERS_T&C.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
						validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
		],
		title: 'ORDERS_T&C.NAV',
		icon: 'icon-tile-four',
		idField: 'Id',
		lookupDisplayField: 'Title',
		isDirty: false,
		methods: {
				getList     : getTermsAndConditionsList,
				getDetails  : getTermsAndConditionsDetails,
				create      : createTermsAndConditions,
				activate    : activateTermsAndConditions
		},
		views: {
				mainList: {
						columns             : [ 'Title', 'Version', 'Status', 'CreatedDate', 'UpdatedDate'],
						columnFilter        : {},
						toggleFilterProps   : { toggleStatus:false, filterProp:'Status', trueVal:1, trueValTooltipMessage: 'ACTIONS.TOGGLE_ACTIVE', falseVal:'', falseValTooltipMessage:"ACTIONS.TOGGLE_ALL"},
						topIndex            : 0,
						showFilterRow       : false,
						sortColumn          : {'Version': false},
						sortDescending      : true,
						itemActions         : [
																		{ id: 'view', label: 'ACTIONS.VIEW', icon: 'icon-magnify', privilege: 'GetDetailsOrderTermsAndConditions', disabled: '!itm.Status', visible: true },
																		{ id: 'copyFrom', label: 'ORDERS_T&C.ACTIONS.COPY_FROM', icon: 'icon-content-copy', privilege: 'CreateOrderTermsAndConditions', disabled: '!itm.Status', visible: true },
																		{ id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateStatusBulkOrderTermsAndConditions', disabled: false, visible: 'itm.Status',
																				requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
																		{ id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateStatusBulkOrderTermsAndConditions', disabled: false, visible: '!itm.Status',
																				requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
																],
						listActions         : [
																		{ id: 'delete', label: 'ACTIONS.DELETE_BULK', icon: 'icon-delete', privilege: 'UpdateStatusBulkOrderTermsAndConditions', disabled: '{selected: true, Status: 1}', visible: true,
																		requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
																		{ id: 'activate', label: 'ACTIONS.ACTIVATE_BULK', icon: 'icon-undo-variant', privilege: 'UpdateStatusBulkOrderTermsAndConditions', disabled: '{selected: true, Status: 0}', visible: true,
																		requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
																],
						fabAction           : {id: 'add', label: 'ACTIONS.ADD', icon: 'icon-plus', privilege: 'CreateOrderTermsAndConditions', visible: true}
				},
				mainDetails: {
						selectedTabIndex    : 0,
						itemActions         : [
																		{ id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateStatusBulkOrderTermsAndConditions', disabled: '{selected: true, Status: 1}',
																				visible: true, requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
																		{ id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateStatusBulkOrderTermsAndConditions', disabled: '{selected: true, Status: 0}',
																				visible: true, requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
																		],
						fabAction           : {id: 'copyFrom', label: 'ORDERS_T&C.ACTIONS.COPY_FROM', icon: 'icon-content-copy', privilege: 'CreateOrderTermsAndConditions', visible: true}
				},
				privileges: {
						list    : 'GetListOrderTermsAndConditions',
						details : 'GetDetailsOrderTermsAndConditions'
				}
		}
};

		function getTermsAndConditionsList(generalProperties, model, catalogCode) {
			var promise;
			if (generalProperties.forceFetch) {
					api.catalogs.ordersTermsConditions.lookupData = undefined;
			}

			if (angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
					var state = {};
					state.name = $state.current.name;
					state.params = $state.params;
					var isBulk = true;
					var logData = activityLogger.createLogData(null, state, 'catalogs.ordersTermsConditions', 'VIEW', isBulk, new Date(), null, null);
					promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/ordertermsconditions', undefined, true, generalProperties.forceFetch);
					promise = activityLogger.log(logData, promise);
			}
			else {
					promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/ordertermsconditions', undefined, true, generalProperties.forceFetch);
			}

			promise.then(function () {
					if (api.catalogs.ordersTermsConditions.isDirty) {
							//Invalidate lookupData
							api.catalogs.ordersTermsConditions.lookupData = undefined;
							api.catalogs.ordersTermsConditions.isDirty = false;
					}
			});
			return promise;
	}

	function getTermsAndConditionsDetails(isLogRequired, Id, catalogCode) {
			var promise;
			if (angular.isDefined(isLogRequired) && isLogRequired === true) {
					var state = {};
					state.name = $state.current.name;
					state.params = $state.params;
					var isBulk = false;
					var items = [];
					promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/ordertermsconditions/' + Id);
					promise.then(function (response) {
							items.push(response.data[api.catalogs.ordersTermsConditions.lookupDisplayField]);
					}, function (response) {
							items.push(response.data[api.catalogs.ordersTermsConditions.lookupDisplayField]);
					});
					var logData = activityLogger.createLogData(items, state, 'catalogs.ordersTermsConditions', 'VIEW', isBulk, new Date(), null, null);
					promise = activityLogger.log(logData, promise);
			}
			else {
					promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/ordertermsconditions/' + Id);
			}
			return promise;
	}

	function createTermsAndConditions(record, catalogCode){
			var state = {};
			state.name = $state.current.name;
			state.params = $state.params;
			var logData = activityLogger.createLogData(record[api.catalogs.ordersTermsConditions.lookupDisplayField], state, 'catalogs.ordersTermsConditions', 'ADD', false, new Date(), null, null);
			var promise = api.webPost(api.baseUrl + '/catalogs/' + catalogCode + '/ordertermsconditions', record);

			promise.then(function() {
					api.catalogs.ordersTermsConditions.isDirty = true;
			});
			return activityLogger.log(logData, promise);
	}



	function activateTermsAndConditions(records, model, actionType, catalogCode){
			var result = crud.createRequestObject(records, model, actionType);
			var state = {};
			state.name = $state.current.name;
			state.params = $state.params;
			var isBulk = result.itemsNameList.length > 1 ? true : false;
			var logData = activityLogger.createLogData(result.itemsNameList, state, 'catalogs.ordersTermsConditions', actionType.toUpperCase(), isBulk, new Date(), null, null);
			var promise = api.webPut(api.baseUrl + '/catalogs/' + catalogCode + '/ordertermsconditions/status', result.requestObj);

			promise.then(function() {
					crud.onRecordStatusChange(records, model, actionType);
			});

			return activityLogger.log(logData, promise);
	}

	}
})();
(function() {
    'use strict';

    angular
        .module('app.main.catalogs.orders')
        .run(runBlock);

    /* @ngInject */
    function runBlock(api, activityLogger, $state, crud, utility, catalogFactory, jobsTracker, ordersDialog, toast, $q, CONSTANTS) {

        if(angular.isUndefined(api.orders)) {
            api.orders = {};
        }
        api.catalogs.orders = {
            modelPath: 'catalogs.orders',
            fields: [
                { field: 'Id', type: 'int', displayLabel: 'ORDERS.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'OrderReference', type: 'text', displayLabel: 'ORDERS.FIELDS.ORDER_REFERENCE', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'OrderTypeId', type: 'int', displayLabel: 'ORDERS.FIELDS.ORDER_TYPE_ID', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'OrderType', type: 'text', displayLabel: 'ORDERS.FIELDS.ORDER_TYPE', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'SellerAccountid', type: 'int', displayLabel: 'ORDERS.FIELDS.SELLER_ID', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CustomerId', type: 'int', displayLabel: 'ORDERS.FIELDS.CUSTOMER_ID', visible: false, creatable: true, editable: true, inputType: 'lookup', lookupSource: 'catalogs.customers',
                    lookupFilter: {Status: 1}, validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CustomerReference', type: 'text', displayLabel: 'ORDERS.FIELDS.CUSTOMER_REFERENCE', visible: true, creatable: true, editable: true, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CustomerName', type: 'text', displayLabel: 'ORDERS.FIELDS.CUSTOMER_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CustomerNumber', type: 'text', displayLabel: 'ORDERS.FIELDS.CUSTOMER_NUMBER', visible: true, creatable: false, editable: false, inputType: 'text', reportable: true,
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'LocationId', type: 'int', displayLabel: 'ORDERS.FIELDS.LOCATION_ID', visible: true, creatable: true, editable: true, inputType: 'number', lookupSource: '', reportable: true,
                    lookupFilter: {Status: 1}, validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'LocationName', type: 'text', displayLabel: 'ORDERS.FIELDS.LOCATION_NAME', visible: true, creatable: false, editable: false, inputType: 'text', reportable: true,
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'LocationCode', type: 'text', displayLabel: 'ORDERS.FIELDS.LOCATION_CODE', visible: true, creatable: false, editable: false, inputType: 'text', reportable: true,
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'PriceGroupName', type: 'text', displayLabel: 'ORDERS.FIELDS.PRICEGROUP_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CurrencyCode', type: 'text', displayLabel: 'ORDERS.FIELDS.CURRENCY_CODE', visible: true, creatable: false, editable: false, inputType: 'lookup', lookupSource: 'lists.currencies',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'OrderProcessStatusId', type: 'int', displayLabel: 'ORDERS.FIELDS.ORDER_PROCESS_STATUS_ID', visible: false, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'OrderProcessStatus', type: 'text', displayLabel: 'ORDERS.FIELDS.ORDER_PROCESS_STATUS', visible: true, creatable: false, editable: false, inputType: 'text', reportable: true,
                    validation: {isRequired: false, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'SourceId', type: 'int', displayLabel: 'ORDERS.FIELDS.SOURCE_ID', visible: false, creatable: false, editable: false, inputType: 'static', fieldDefaultValue: 2,
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Source', type: 'text', displayLabel: 'ORDERS.FIELDS.SOURCE', visible: true, creatable: false, editable: false, inputType: 'text', reportable: true,
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'RevisionNumber', type: 'text', displayLabel: 'ORDERS.FIELDS.REVISION_NUMBER', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Comment', type: 'text', displayLabel: 'ORDERS.FIELDS.COMMENT', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'TotalInitialValue', type: 'int', displayLabel: 'ORDERS.FIELDS.TOTAL_INITIAL_VALUE', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'TotalCurrentValue', type: 'int', displayLabel: 'ORDERS.FIELDS.TOTAL_CURRENT_VALUE', visible: true, creatable: false, editable: false, inputType: 'number', reportable: true,
                    validation: {isRequired: false, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'TotalQuantity', type: 'int', displayLabel: 'ORDERS.FIELDS.TOTAL_QUANTITY', visible: true, creatable: false, editable: false, inputType: 'number', reportable: true,
                    validation: {isRequired: false, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'RejectedQuantity', type: 'int', displayLabel: 'ORDERS.FIELDS.REJECTED_QUANTITY', visible: true, creatable: false, editable: false, inputType: 'number', reportable: true,
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'InactiveQuantity', type: 'int', displayLabel: 'ORDERS.FIELDS.INACTIVE_QUANTITY', visible: true, creatable: false, editable: false, inputType: 'number', reportable: true,
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Status', type: 'text', displayLabel: 'ORDERS.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status', reportable: true,
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedBy', type: 'text', displayLabel: 'ORDERS.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap', reportable: true,
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedBy', type: 'text', displayLabel: 'ORDERS.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap', reportable: true,
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedDate', type: 'text', displayLabel: 'ORDERS.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date', reportable: true,
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedDate', type: 'text', displayLabel: 'ORDERS.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date', reportable: true,
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'GFRValue', type: 'text', displayLabel: 'ORDERS.FIELDS.GFR_BY_VALUE', visible: false, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'GFRQuantity', type: 'text', displayLabel: 'ORDERS.FIELDS.GFR_BY_QUANTITY', visible: false, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Alias', type: 'text', displayLabel: 'ORDERS.FIELDS.ALIAS', visible: true, creatable: true, editable: true, inputType: 'text',
                    validation: {isRequired: false, maxLen: 300, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'OrderContent', type: 'text', displayLabel: 'ORDERLINE.FIELDS.CONTENT', visible: false, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                // used internally
                { field: 'isUnSavedOrdersPresent', type: 'text', displayLabel: '', visible: false, creatable: false, editable: false, inputType: 'bool'},
                { field: 'StockDefinitionId', type: 'int', displayLabel: 'ORDERS.FIELDS.STOCK', visible: false, creatable: false, editable: false, inputType: 'lookup', lookupSource: 'catalogs.stockDefinition',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'StockCode', type: 'text', displayLabel: 'STOCK_DEFINITION.FIELDS.STOCK_CODE', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'StockName', type: 'text', displayLabel: 'STOCK_DEFINITION.FIELDS.STOCK_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
            ],
            uniqueConstraints: [
                {name: 'Constraint 1', fields: ['OrderReference']}
            ],
            title: 'ORDERS.NAV',
            icon: 'icon-cart-outline',
            idField: 'Id',
            lookupDisplayField: 'OrderReference',
            isDirty: false,
            isBulkActionCompleted: false,
            isCatalogSpecificModel: true,
            methods: {
                getList                     :   getOrders,
                getDetails                  :   getOrder,
                activateBulk                :   activateOrders,
                create                      :   createOrder,
                update                      :   updateOrder,
                // updateProcessStatus         :   updateProcessStatus,
                submitOrders                :   submitOrders,
                reopenOrders                :   reopenOrders,
                approveOrders               :   approveOrders,
                rejectOrders                :   rejectOrders,
                confirmOrders               :   confirmOrders,
                createBulk                  :   createBulk,
                unlockOrders                :   unlockOrders,
            },
            views: {
                mainList: {
                    columns             : [ 'OrderReference', 'CustomerNumber', 'CustomerName', 'LocationName', 'OrderProcessStatus', 'Source', 'TotalCurrentValue', 'TotalQuantity', 'InactiveQuantity', 'RevisionNumber', 'UpdatedDate' ],
                    columnFilter        : {},
                    toggleFilterProps   : { toggleStatus:false, filterProp:'Status', trueVal:1, trueValTooltipMessage: 'ACTIONS.TOGGLE_ACTIVE', falseVal:'', falseValTooltipMessage:"ACTIONS.TOGGLE_ALL"},
                    topIndex            : 0,
                    showFilterRow       : false,
                    sortColumn          : {'UpdatedDate': false},
                    itemActions         : [
                                            { id: 'view', label: 'ACTIONS.VIEW', icon: 'icon-magnify', privilege: 'GetOrderDetails', disabled: '!itm.Status', visible: true },
                                            { id: 'export', label: 'ORDERS.ACTIONS.EXPORT_ORDERLINE', icon: 'icon-export', privilege: 'GetOrderlineList', disabled: 'itm.OrderProcessStatusId === 1', visible: true },
                                            { id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UpdateOrder:true', disabled: '!itm.Status || !(itm.OrderProcessStatusId == 1 || itm.OrderProcessStatusId == 5)', visible: true },
                                            { id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateOrderStatusBulk:true', disabled: 'itm.OrderProcessStatusId === 6 || itm.OrderProcessStatusId === 8', visible: 'itm.Status',
                                                requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                                            { id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateOrderStatusBulk:true', disabled: 'itm.OrderProcessStatusId === 6 || itm.OrderProcessStatusId === 8', visible: '!itm.Status',
                                                requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
                                          ],
                    listActions         : [
                                            { id: 'delete', label: 'ACTIONS.DELETE_BULK', icon: 'icon-delete', privilege: 'UpdateOrderStatusBulk:true', disabled: '{selected: true, Status: 1, OrderProcessStatusId: ["!6", "!8"]}', visible: true,
                                                requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                                            { id: 'activate', label: 'ACTIONS.ACTIVATE_BULK', icon: 'icon-undo-variant', privilege: 'UpdateOrderStatusBulk:true', disabled: '{selected: true, Status: 0, OrderProcessStatusId: ["!6", "!8"]}', visible: true,
                                                requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'},
                                            { id: 'import', label: 'ACTIONS.IMPORT', icon: 'icon-import', privilege: 'ProcessOrder:true', disabled: false, visible: true, requiresConfirmation: false }
                                          ],
                    processOrdersItemActions: [
                                                { id: 'submit', status: 2, label: 'ACTIONS.SUBMIT_ORDER', icon: 'icon-send', privilege: 'SubmitOrderBulk:true', disabled: '!itm.Status || !(itm.OrderProcessStatusId == 1 || itm.OrderProcessStatusId == 5)', visible: true },
                                                { id: 'approve', status: 4, label: 'ACTIONS.APPROVE_ORDER', icon: 'icon-thumb-up-outline', privilege: 'ApproveOrderBulk:true', disabled: '!itm.Status || itm.OrderProcessStatusId !== 2', visible: true,
                                                    requiresConfirmation: false, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_APPROVE'}, confirmationAction: 'ACTIONS.APPROVE_ORDER' },
                                                { id: 'reject', status: 3, label: 'ACTIONS.REJECT_ORDER', icon: 'icon-thumb-down-outline', privilege: 'DisapproveOrderBulk:true', disabled: '!itm.Status || itm.OrderProcessStatusId !== 2', visible: true,
                                                    requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_REJECT'}, confirmationAction: 'ACTIONS.REJECT_ORDER' },
                                                { id: 'reopen', status: 5, label: 'ACTIONS.REOPEN_ORDER', icon: 'icon-backup-restore', privilege: 'ReOpenOrderBulk:true', disabled: 'itm.isReopenOrderDisable', visible: true },
                                                { id: 'confirm', status: 8, label: 'ACTIONS.CONFIRM_ORDER', icon: 'icon-checkbox-marked', privilege: 'ConfirmOrderBulk:true', disabled: '!itm.Status || itm.OrderProcessStatusId !== 4 || itm.UseConfirmOrder != 1', visible: true,
                                                    requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ORDER'}, confirmationAction: 'ACTIONS.CONFIRM_ORDER' },
                                                { id: 'unlock', status: -1, label: 'ACTIONS.UNLOCK_ORDER', icon: 'icon-lock-unlocked', privilege: 'UnlockOrderBulk:true', disabled: false, visible: 'itm.Status && itm.OrderProcessStatusId == 6',
                                                    requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.UNLOCK_ORDER'}, confirmationAction: 'ACTIONS.UNLOCK_ORDER' }
                                              ],
                    processOrdersListActions: [
                                                // { id: 'submit', status: 2, label: 'ACTIONS.SUBMIT_ORDERS', icon: 'icon-send', privilege: 'SubmitOrderBulk:true', enabled: '{1: true, 5: true}', visible: true },
                                                { id: 'reopen', status: 5, label: 'ACTIONS.REOPEN_ORDERS', icon: 'icon-backup-restore', privilege: 'ReOpenOrderBulk:true', enabled: '{4: true, 3: true}', visible: true },
                                                { id: 'approve', status: 4, label: 'ACTIONS.APPROVE_ORDERS', icon: 'icon-thumb-up-outline', privilege: 'ApproveOrderBulk:true', enabled: '{2: true}', visible: true,
                                                    requiresConfirmation: false, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_APPROVE'}, confirmationAction: 'ACTIONS.APPROVE_ORDERS' },
                                                { id: 'reject', status: 3, label: 'ACTIONS.REJECT_ORDERS', icon: 'icon-thumb-down-outline', privilege: 'DisapproveOrderBulk:true', enabled: '{2: true}', visible: true,
                                                    requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_REJECT'}, confirmationAction: 'ACTIONS.REJECT_ORDER' },
                                                { id: 'confirm', status: 8, label: 'ACTIONS.CONFIRM_ORDERS', icon: 'icon-checkbox-marked', privilege: 'ConfirmOrderBulk:true', enabled: '{4: true}', visible: true,
                                                    requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ORDER'}, confirmationAction: 'ACTIONS.CONFIRM_ORDERS' },
                                                { id: 'unlock', status: -1, label: 'ACTIONS.UNLOCK_ORDER', icon: 'icon-lock-unlocked', privilege: 'UnlockOrderBulk:true', enabled: '{6: true}', visible: true,
                                                    requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.UNLOCK_ORDER'}, confirmationAction: 'ACTIONS.UNLOCK_ORDER' }
                                              ],
                    fabAction           : {id: 'add', label: 'ACTIONS.ADD', icon: 'icon-plus', privilege: 'CreateOrder:true', visible: true}
                },
                mainDetails: {
                    selectedTabIndex    : 0,
                    itemActions         : [
                                            { id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateOrderStatusBulk:true', disabled: '{selected: true, Status: 1, OrderProcessStatusId: ["!6", "!8"]}',
                                                visible: true, requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                                            { id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateOrderStatusBulk:true', disabled: '{selected: true, Status: 0, OrderProcessStatusId: ["!6", "!8"]}',
                                                visible: true, requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'},
                                            { id: 'saveOrders', label: 'ORDERS.ACTIONS.SAVE_ORDERS', icon: 'icon-content-save', privilege: 'ProcessOrder:true', disabled: '{selected: true, Status: 1}', visible: true,
                                                requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'ORDERS.MESSAGES.CONTENT.CONFIRM_SAVE_ORDERS'}, confirmationAction: 'ORDERS.ACTIONS.SAVE_ORDERS'}
                                          ],
                    processOrdersItemActions: [
                                                { id: 'submit', status: 2, label: 'ACTIONS.SUBMIT_ORDERS', icon: 'icon-send', privilege: 'SubmitOrderBulk:true', enabled: '{1: true, 5: true}', visible: true },
                                                { id: 'reopen', status: 5, label: 'ACTIONS.REOPEN_ORDERS', icon: 'icon-backup-restore', privilege: 'ReOpenOrderBulk:true', enabled: '{4: true, 3: true, 2: true}', visible: true },
                                                { id: 'approve', status: 4, label: 'ACTIONS.APPROVE_ORDERS', icon: 'icon-thumb-up-outline', privilege: 'ApproveOrderBulk:true', enabled: '{2: true}', visible: true,
                                                    requiresConfirmation: false, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_APPROVE'}, confirmationAction: 'ACTIONS.APPROVE_ORDERS' },
                                                { id: 'reject', status: 3, label: 'ACTIONS.REJECT_ORDERS', icon: 'icon-thumb-down-outline', privilege: 'DisapproveOrderBulk:true', enabled: '{2: true}', visible: true,
                                                    requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_REJECT'}, confirmationAction: 'ACTIONS.REJECT_ORDER' },
                                                { id: 'confirm', status: 8, label: 'ACTIONS.CONFIRM_ORDER', icon: 'icon-checkbox-marked', privilege: 'ConfirmOrderBulk:true', enabled: '{4: true}', visible: true,
                                                    requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ORDER'}, confirmationAction: 'ACTIONS.CONFIRM_ORDER' },
                                                { id: 'unlock', status: -1, label: 'ACTIONS.UNLOCK_ORDER', icon: 'icon-lock-unlocked', privilege: 'UnlockOrderBulk:true', enabled: '{6: true}', visible: true,
                                                    requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.UNLOCK_ORDER'}, confirmationAction: 'ACTIONS.UNLOCK_ORDER' }
                                              ],
                    fab                 : {id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UpdateOrder:true', visible: true}
                },
                privileges: {
                    list    : 'GetOrderList',
                    details : 'GetOrderDetails'
                }
            }

        };

        api.catalogs.importOrders = {
            fields: [
                { field: 'Id', type: 'int', displayLabel: 'ORDERS.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'OrderReference', type: 'text', displayLabel: 'ORDERS.FIELDS.ORDER_REFERENCE', visible: true, creatable: true, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: 50, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CustomerCode', type: 'text', displayLabel: 'ORDERS.FIELDS.CUSTOMER_CODE', visible: true, creatable: true, editable: true, inputType: 'lookup', lookupSource: 'catalogs.customers',
                    lookupFilter: {Status: 1}, validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'LocationCode', type: 'int', displayLabel: 'ORDERS.FIELDS.LOCATION_CODE', visible: true, creatable: true, editable: true, inputType: 'text', lookupSource: '',
                    lookupFilter: {Status: 1}, validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Alias', type: 'text', displayLabel: 'ORDERS.FIELDS.ALIAS', visible: true, creatable: true, editable: true, inputType: 'text',
                    validation: {isRequired: false, maxLen: 300, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'SellerAccountid', type: 'int', displayLabel: 'ORDERS.FIELDS.SELLER_ID', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CustomerId', type: 'int', displayLabel: 'ORDERS.FIELDS.CUSTOMER_ID', visible: true, creatable: false, editable: true, inputType: 'lookup', lookupSource: 'catalogs.customers',
                    lookupFilter: {Status: 1}, validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CustomerReference', type: 'text', displayLabel: 'ORDERS.FIELDS.CUSTOMER_REFERENCE', visible: true, creatable: true, editable: true, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'LocationName', type: 'text', displayLabel: 'ORDERS.FIELDS.LOCATION_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'OrderProcessStatusId', type: 'int', displayLabel: 'ORDERS.FIELDS.ORDER_PROCESS_STATUS_ID', visible: false, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'OrderProcessStatus', type: 'text', displayLabel: 'ORDERS.FIELDS.ORDER_PROCESS_STATUS', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'SourceId', type: 'int', displayLabel: 'ORDERS.FIELDS.SOURCE_ID', visible: false, creatable: false, editable: false, inputType: 'static', fieldDefaultValue: 2,
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Source', type: 'text', displayLabel: 'ORDERS.FIELDS.SOURCE', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'RevisionNumber', type: 'text', displayLabel: 'ORDERS.FIELDS.REVISION_NUMBER', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Comment', type: 'text', displayLabel: 'ORDERS.FIELDS.COMMENT', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Status', type: 'text', displayLabel: 'ORDERS.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedBy', type: 'text', displayLabel: 'ORDERS.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedBy', type: 'text', displayLabel: 'ORDERS.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedDate', type: 'text', displayLabel: 'ORDERS.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedDate', type: 'text', displayLabel: 'ORDERS.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'StockDefinitionId', type: 'int', displayLabel: 'ORDERS.FIELDS.STOCK', visible: false, creatable: false, editable: false, inputType: 'lookup', lookupSource: 'catalogs.stockDefinition',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
            ],
            uniqueConstraints: [
                // {name: 'Constraint 1', fields: ['OrderReference']} - its wont be unique in excel but singular
            ],
            commonConstraints: [
                {name: 'Constraint 1', fields:['CustomerCode', 'CustomerReference','LocationCode']}
            ],
            title: 'ORDERS.NAV',
            icon: '',
            idField: 'Id',
            lookupDisplayField: 'OrderReference',
            isDirty: false,
            isBulkActionCompleted: false,
            methods: {},
            views: {
                mainList: {},
                mainDetails: {},
                privileges: {
                    list    : 'GetOrderList',
                    details : 'GetOrderDetails'
                }
            }
        };

        function getOrders(generalProperties, model, catalogCode) {
            if(angular.isDefined(model)) { // to skip this part for load lookup
                model.isBulkActionCompleted = false;
            }
            var promise;

            if(angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
                var state = {};
                state.name = $state.current.name;
                state.params = $state.params;
                var isBulk = true;
                var logData = activityLogger.createLogData(null, state, 'catalogs.orders', 'VIEW', isBulk, new Date(), null, null);

                promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/orders', undefined, true, generalProperties.forceFetch,
                    false, undefined, false, model, false, undefined, undefined, undefined);
                promise = activityLogger.log(logData, promise);
            }
            else {
                if(angular.isUndefined(catalogCode)) {
                    var activeCatalog = catalogFactory.getActiveCatalog();
                    catalogCode = activeCatalog.CatalogCode;
                }
                promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/orders', undefined, true, generalProperties.forceFetch,
                    false, undefined, false, model, false, undefined, undefined, undefined);
            }

            promise.then(function() {
                if (api.catalogs.orders.isDirty) {
                    //Invalidate lookupData
                    api.catalogs.orders.lookupData = undefined;
                    api.catalogs.orders.isDirty = false;
                }
            });
            return promise;
        }

        function getOrder(isLogRequired, orderId, catalogCode, model) {
            if(angular.isDefined(model)) { // to skip this part for load lookup
                model.isBulkActionCompleted = false;
            }
            var promise;
            if(angular.isDefined(isLogRequired) && isLogRequired === true) {
                var state = {};
                state.name = $state.current.name;
                state.params = $state.params;
                var isBulk = false;
                var items = [];

                promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/orders/' + orderId + '?status=0', undefined, true, true);
                promise.then(function(response) {
                    items.push(response.data[api.catalogs.orders.lookupDisplayField]);
                });

                var logData = activityLogger.createLogData(items, state, 'catalogs.orders', 'VIEW', isBulk, new Date(), null, null);
                promise = activityLogger.log(logData, promise);
            }
            else {
                promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/orders/' + orderId + '?status=0', undefined, true, true);
            }
            return promise;
        }

        function activateOrders(records, model, actionType, parentId) {
            var result = crud.createRequestObject(records, model, actionType);
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var isBulk = result.itemsNameList.length > 1 ? true : false;
            var logData = activityLogger.createLogData(result.itemsNameList, state, 'catalogs.orders', actionType.toUpperCase(), isBulk, new Date(), null, null);
			var promise = api.webPut(api.baseUrl + '/catalogs/' + parentId + '/orders/status', result.requestObj);

             promise.then(function() {
                crud.onRecordStatusChange(records, model, actionType);
                api.catalogs.orders.isDirty = true;
            });

            return activityLogger.log(logData, promise);
        }

		function createOrder(order, catalogCode) {
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var logData = activityLogger.createLogData(order[api.catalogs.orders.lookupDisplayField], state, 'catalogs.orders', 'ADD', false, new Date(), null, null);
            var promise = api.webPost(api.baseUrl + '/catalogs/' + catalogCode + '/orders', order);

            promise.then(function() {
                api.catalogs.orders.isDirty = true;
            });
            return activityLogger.log(logData, promise);
		}

        function updateOrder(orderId, order, catalogCode) {
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var logData = activityLogger.createLogData(order[api.catalogs.orders.lookupDisplayField], state, 'catalogs.orders', 'EDIT', false, new Date(), null, null);
            var promise = api.webPut(api.baseUrl + '/catalogs/' + catalogCode  + '/orders/' + orderId, order);

            promise.then(function() {
                api.catalogs.orders.isDirty = true;
            });
            return activityLogger.log(logData, promise);
		}

        // function updateProcessStatus(records, model, actionType, status, parentId) {
        //     var result = crud.createProcessOrderRequestObject(records, model, actionType, status);
        //     var state = {};
        //     state.name = $state.current.name;
        //     state.params = $state.params;
        //     var isBulk = result.itemsNameList.length > 1 ? true : false;
        //     var logData = activityLogger.createLogData(result.itemsNameList, state, 'catalogs.orders', actionType.toUpperCase(), isBulk, new Date(), null, null);
		// 	var promise = api.webPut(api.baseUrl + '/catalogs/' + parentId + '/orders/processStatus', result.requestObj);

        //     promise.then(function() {
        //         crud.onOrderProcessStatusChange(records, model, actionType, status);
        //     });

        //     return activityLogger.log(logData, promise);
        // }

        function submitOrders(record, model, actionType, status, parentId, isCustomerRequiredDateValidationAdded) {
            var requestObj = {
                OrderReference: record.OrderReference,
                CustomerId: record.CustomerId,
                LocationId: record.LocationId,
                CustomerReference: record.CustomerReference,
                Alias: record.Alias,
                SourceId: 2,
                ProcessingStatus: 2,
                Orderlines: []
            }

            if(catalogFactory.getActiveCatalog().IsStockApply) {
                requestObj['StockDefinitionId'] = record.StockDefinitionId;
            }

            /**
             * since we are not refreshing data after changing order process status its quite possible even order is reopen to have orderContent instead in orderlineResponse
             * or in case of order updated to draft to have data orderlineResponse instead of orderContent
             * and as confirmed with API team orderContent and orderlineResponse wont be having data at same time
             * */
            var orderContent = undefined;
            if(angular.isDefined(record.OrderContent) && record.OrderContent !== '') {
                orderContent = JSON.parse(record.OrderContent);
            }

            if(angular.isDefined(orderContent) && orderContent !== null) {
                angular.forEach(orderContent.Orderlines, function(orderline) {
                    var orderLineObj = {
                        ArticleId : orderline.ArticleId,
                        CrdId : orderline.CrdId,
                        OrderlineSize : orderline.OrderlineSize,
                        OrderlineVas : orderline.OrderlineVas
                    };
                    if(isCustomerRequiredDateValidationAdded) {
                        orderLineObj['DeliveryDate'] = orderline.DeliveryDate;
                    }
                    angular.forEach(orderLineObj.OrderlineVas, function(vas) {
                        delete vas['Code'];
                    });
                    requestObj.Orderlines.push(orderLineObj);
                });
            } else if(angular.isDefined(record.orderlineResponse)) {
                angular.forEach(record.orderlineResponse, function(orderline) {
                    if(orderline.IsActive) {
                        var orderLineObj = {
                            ArticleId : orderline.ArticleId,
                            CrdId : orderline.CrdId,
                            OrderlineSize: [],
                            OrderlineVas : []
                        };
                        if(isCustomerRequiredDateValidationAdded) {
                            orderLineObj['DeliveryDate'] = orderline.DeliveryDate;
                        }
                        angular.forEach(orderline.orderLineSizeResponse, function(size) {
                            orderLineObj.OrderlineSize.push({ SizeId: size.SizeId, Quantity: size.Quantity });
                        })
                        angular.forEach(orderLineObj.orderLineVasResponse, function(vas) {
                            orderLineObjOrderlineVas.push({ VasId: vas.VasId , AdditionalInfo: vas.AdditionalInfo })
                        });
                        requestObj.Orderlines.push(orderLineObj);
                    }
                });
            }

            // return activityLogger.log(logData, promise);
            var jobIndex = jobsTracker.addJob(model, 'ORDERS.ACTIONS.SUBMIT_ORDERS', 1, api.catalogs.orders);
            return api.webPut(api.baseUrl + '/catalogs/' + parentId + '/orderprocess?sourceapplication=' + CONSTANTS.SOURCE_APPLICATION + '&sourceaction=Submit Orders', utility.pushItemToArray(requestObj)).then(function(response) {
                jobsTracker.trackJob(jobIndex, response.data.Id);
            }).catch(function(error) {
                jobsTracker.setCriticlaFail(jobIndex, error);
            });
        }

        function reopenOrders(records, model, actionType, status, parentId) {
            var result = crud.createProcessOrderRequestObject(records, model, actionType, status);
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var isBulk = result.itemsNameList.length > 1 ? true : false;
            var logData = activityLogger.createLogData(result.itemsNameList, state, 'catalogs.orders', actionType.toUpperCase(), isBulk, new Date(), null, null);
			var promise = api.webPut(api.baseUrl + '/catalogs/' + parentId + '/orders/reopen', result.requestObj);

            promise.then(function() {
                crud.onOrderProcessStatusChange(records, model, actionType, status);
            });

            return activityLogger.log(logData, promise);
        }

        function approveOrders(records, model, actionType, status, parentId, orderType) {
            var result = crud.createProcessOrderRequestObject(records, model, actionType, status);
            if(angular.isDefined(orderType) && orderType !== null) {
                result.requestObj['OrderTypeId'] = orderType;
            }
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var isBulk = result.itemsNameList.length > 1 ? true : false;
            var logData = activityLogger.createLogData(result.itemsNameList, state, 'catalogs.orders', actionType.toUpperCase(), isBulk, new Date(), null, null);
			var promise = api.webPut(api.baseUrl + '/catalogs/' + parentId + '/orders/approve', result.requestObj);

            promise.then(function() {
                crud.onOrderProcessStatusChange(records, model, actionType, status);
            });

            return activityLogger.log(logData, promise);
        }

        function rejectOrders(records, model, actionType, status, parentId) {
            var result = crud.createProcessOrderRequestObject(records, model, actionType, status);
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var isBulk = result.itemsNameList.length > 1 ? true : false;
            var logData = activityLogger.createLogData(result.itemsNameList, state, 'catalogs.orders', actionType.toUpperCase(), isBulk, new Date(), null, null);
			var promise = api.webPut(api.baseUrl + '/catalogs/' + parentId + '/orders/disapprove', result.requestObj);

            promise.then(function() {
                crud.onOrderProcessStatusChange(records, model, actionType, status);
            });

            return activityLogger.log(logData, promise);
        }

        function confirmOrders(records, model, actionType, status, parentId) {
            var result = crud.createProcessOrderRequestObject(records, model, actionType, status);
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var isBulk = result.itemsNameList.length > 1 ? true : false;
            var logData = activityLogger.createLogData(result.itemsNameList, state, 'catalogs.orders', actionType.toUpperCase(), isBulk, new Date(), null, null);
			var promise = api.webPut(api.baseUrl + '/catalogs/' + parentId + '/orders/confirm', result.requestObj);

            promise.then(function() {
                crud.onOrderProcessStatusChange(records, model, actionType, status);
            });

            return activityLogger.log(logData, promise);
        }

        function createBulk(data, catalogCode) {
            var deferred = $q.defer();
            var activeCatalog = catalogFactory.getActiveCatalog();
            var catalogCode = activeCatalog.CatalogCode;
            var pricesModel = api.catalogs.prices;
            var sizesModel = api.catalogs.sizes;
            var generalProperties = {
                forceFetch: true,
                isLogRequired: false,
                config: {},
                supportIncrementalResult: true,
                modelIdField: 'Id',
                isMajor: false,
                isArticleRelatedData: false,
                nestedArrayName: 'Prices',
                nestedDataIdField:'Id'
            }
            var pricesPromise = pricesModel.methods.getList(generalProperties, pricesModel, catalogCode);
            var generalSizesProperties = {
                forceFetch: true,
                isLogRequired: false,
                config: {},
                supportIncrementalResult: true,
                modelIdField: sizesModel.idField,
                isMajor: false,
                isArticleRelatedData: false,
                nestedArrayName: 'Sizes',
                nestedDataIdField:'Id'
            }
            var sizesPromise = sizesModel.methods.getList(generalSizesProperties, sizesModel, catalogCode);
            var lookupExtras = {};
            lookupExtras['customers.locations'] = {};
            lookupExtras['customers.locations']['customerId'] = data[0].CustomerCode;
            lookupExtras['customers.locations']['sellerId'] = activeCatalog.AccountId;
            var locationsPromise = api.getLookupData(api.customers.locations, lookupExtras);
            var customersPromise = api.getLookupData(api.catalogs.customers);
            $q.all({
                pricesPromise: pricesPromise,
                sizesPromise: sizesPromise,
                locationsPromise: locationsPromise,
                customersPromise: customersPromise
            }).then(function (responses) {
                var locationId = 0;
                var orderlines = [];
                var requestObj = {};
                var orderLocation = utility.filterObject(responses.locationsPromise.data, {Code: data[0].LocationCode}, true)[0];
                locationId = orderLocation.id;
                var orderReference = '';
                var orderLineIndexes = {};
                var ind = -1;
                var quantity = 0;
                var currentPriceGroupId = 0;
                var selectedCustomer = utility.filterObject(responses.customersPromise.data, {id: data[0].CustomerCode}, true)[0];
                currentPriceGroupId = selectedCustomer.OrderPriceGroupId;
                var custCode = selectedCustomer.value;
                // for updating reopned/existing draft orders
                // for existing orders we will send the new data fetched from excel file and API is going to overwrite the existing data
                if(angular.isDefined(data[0].OrderReference) && data[0].OrderReference.length > 0) {
                    orderReference = data[0].OrderReference;
                } else {
                    orderReference = ordersDialog.generateOrderReference(custCode, data[0].LocationCode);
                }

                for(var index=0, len=data.length; index<len; index++) {
                    var articlePriceData = utility.filterObject(responses.pricesPromise.data, {Id: data[index].ArticleNumber}, true)[0];
                    var priceData = utility.filterObject(articlePriceData.Prices, {PriceGroupId: currentPriceGroupId}, true)[0];
                    data[index]['InitialPrice'] = priceData.Price;
                    var articleSizeData = utility.filterObject(responses.sizesPromise.data, {Id: data[index].ArticleNumber}, true)[0];
                    var sizeData = utility.filterObject(articleSizeData.Sizes, {SizeName: data[index].Size}, true)[0]
                    data[index]['SizeId'] = sizeData.Id;
                    if(angular.isUndefined(orderLineIndexes[data[index].ArticleNumber]) || angular.isUndefined(orderLineIndexes[data[index].ArticleNumber][data[index].Crd])){
                        ind += 1;
                        orderLineIndexes[data[index].ArticleNumber] = orderLineIndexes[data[index].ArticleNumber] ? orderLineIndexes[data[index].ArticleNumber] : {};
                        orderLineIndexes[data[index].ArticleNumber][data[index].Crd] = ind;
                        orderlines[ind] = {
                            ArticleId: data[index].ArticleNumber,
                            DeliveryDate: data[index].DeliveryDate,
                            CrdId: data[index].Crd,
                            InitialPrice: data[index].InitialPrice,
                            CurrentPriceGroupId: currentPriceGroupId,
                            TotalQuantity: 0,
                            TotalCurrentValue: 0,
                            TotalInitialValue: 0,
                            OrderlineSize: [],
                            OrderlineVas: []
                        }
                    }
                    orderlines[orderLineIndexes[data[index].ArticleNumber][data[index].Crd]].OrderlineSize.push({SizeId: data[index].SizeId, Quantity: data[index].Quantity});
                    quantity += data[index].Quantity;
                    orderlines[orderLineIndexes[data[index].ArticleNumber][data[index].Crd]].TotalQuantity = quantity;
                    orderlines[orderLineIndexes[data[index].ArticleNumber][data[index].Crd]].TotalCurrentValue += (data[index].Quantity * data[index].InitialPrice);
                    orderlines[orderLineIndexes[data[index].ArticleNumber][data[index].Crd]].TotalInitialValue += (data[index].Quantity * data[index].InitialPrice);
                }
                var totalQty = 0;
                var totalIP = 0;
                var totalCP = 0;
                if(orderlines.length > 0) {
                    angular.forEach(orderlines, function(orderline) {
                        totalQty += orderline.TotalQuantity;
                        totalIP += orderline.TotalInitialValue;
                        totalCP += orderline.TotalCurrentValue;
                    });
                }
                var orderContent = {
                    Orderlines: orderlines
                }
                // store draft order's orderline data to sessions storage
                requestObj = {
                    OrderReference: orderReference,
                    CustomerId: data[0].CustomerCode,
                    LocationId: locationId,
                    CustomerReference: data[0].CustomerReference,
                    Alias: data[0].Alias,
                    SourceId: 2,
                    TotalQuantity: totalQty,
                    TotalCurrentValue: totalCP,
                    TotalInitialValue: totalIP,
                    OrderContent: angular.toJson(orderContent)
                }

                if(catalogFactory.getActiveCatalog().IsStockApply) {
                    requestObj['StockDefinitionId'] = data[0].StockDefinitionId;
                }
                api.webPut(api.baseUrl + '/catalogs/' + catalogCode + '/orders/draft', requestObj).then(function() {
                    api.catalogs.orders.isDirty = true;
                    var toastMessage = 'SUCCESS.ORDER_IMPORTED';
                    toast.success(toastMessage, '', '');
                    deferred.resolve();
                });
            });
            return deferred.promise;
        }

        function unlockOrders(records, model, actionType, status, parentId) {
            var result = crud.createProcessOrderRequestObject(records, model, actionType, status);
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var isBulk = result.itemsNameList.length > 1 ? true : false;
            var logData = activityLogger.createLogData(result.itemsNameList, state, 'catalogs.orders', actionType.toUpperCase(), isBulk, new Date(), null, null);
			var promise = api.webPut(api.baseUrl + '/catalogs/' + parentId + '/orders/unlock', result.requestObj);

            promise.then(function() {
                crud.onOrderProcessStatusChange(records, model, actionType, status);
            });

            return activityLogger.log(logData, promise);
        }

    }
})();
(function () {
	'use strict';

	angular
		.module('app.main.catalogs.order-adjustments')
		.run(runBlock);

	/* @ngInject */
	function runBlock(api, activityLogger, $state, jobsTracker, utility) {

		if (angular.isUndefined(api.catalogs)) {
			api.catalogs = {};
		}
		api.catalogs.orderAdjustments = {
			modelPath: 'catalogs.orderAdjustments',
			fields: [
				{ field: 'Id', type: 'int', displayLabel: 'ORDER_ADJUSTMENTS.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
					validation: { isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
				{ field: 'Name', type: 'text', displayLabel: 'ORDER_ADJUSTMENTS.FIELDS.NAME', visible: true, creatable: false, editable: true, inputType: 'text',
					validation: { isRequired: true, maxLen: 50, minLen: 1, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
				{ field: 'Status', type: 'text', displayLabel: 'ORDER_ADJUSTMENTS.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'text',
					validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
				{ field: 'JobId', type: 'text', displayLabel: 'ORDER_ADJUSTMENTS.FIELDS.JOB_ID', visible: true, creatable: false, editable: false, inputType: 'text',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'CreatedBy', type: 'text', displayLabel: 'ORDER_ADJUSTMENTS.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
					validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
				{ field: 'CreatedDate', type: 'text', displayLabel: 'ORDER_ADJUSTMENTS.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
					validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
				{ field: 'UpdatedBy', type: 'text', displayLabel: 'ORDER_ADJUSTMENTS.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
					validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
				{ field: 'UpdatedDate', type: 'text', displayLabel: 'ORDER_ADJUSTMENTS.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
					validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }}
				],
			uniqueConstraints: [],
			title: 'ORDER_ADJUSTMENTS.NAV',
			icon: 'icon-cart-outline',
			idField: 'Id',
			lookupDisplayField: 'Name',
			isDirty: false,
			isCatalogSpecificModel: true,
			methods: {
				getList      : getOrderAdjustments,
				getDetails   : getOrderAdjustment,
				createBulk   : createBulk,
				adjustWithoutOrderReference : adjustWithoutOrderReference
			},
			views: {
				mainList: {
					columns: ['Id', 'Name', 'Status', 'JobId', 'CreatedBy', 'CreatedDate'],
					columnFilter: {},
					toggleFilterProps: {},
					topIndex: 0,
					showFilterRow: false,
					sortColumn: { 'UpdatedDate': false },
					itemActions: [
						{ id: 'view', label: 'ACTIONS.VIEW', icon: 'icon-magnify', privilege: 'GetOrderDetails', disabled: '!itm.viewAdjustment', visible: true }
					],
					listActions: [
						{ id: 'import', label: 'ORDER_ADJUSTMENTS.ACTIONS.IMPORT_ORDER_ADJUSTMENTS', icon: 'icon-import', privilege: 'ImportOrderAdjustments:true', disabled: false, visible: true, requiresConfirmation: false },
						{ id: 'importAdjustments', label: 'ORDER_ADJUSTMENTS.ACTIONS.ADJUST_WITHOUT', icon: 'icon-import', privilege: 'ImportCatalogOrderAdjustments:true', disabled: false, visible: true, requiresConfirmation: false }
					]
				},
				mainDetails: {},
				privileges: {
					list: 'GetOrderAdjustments'
				}
			}

		};

		//For order adjustment details list
		api.catalogs.orderAdjustmentDetailList = {
			modelPath: 'catalogs.orderAdjustmentDetailList',
			fields: [
				{ field: 'Id', type: 'int', displayLabel: 'ORDER_ADJUSTMENTS.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
					validation: { isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
				{ field: 'OrderId', type: 'int', displayLabel: 'ORDER_ADJUSTMENTS.FIELDS.ORDER_ID', visible: true, creatable: false, editable: false, inputType: 'number',
					validation: { isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
				{ field: 'AdjustmentsName', type: 'text', displayLabel: 'ORDER_ADJUSTMENTS.FIELDS.ADJUSTMENTS_NAME', visible: false, creatable: true, editable: false, inputType: 'text',
					validation: { isRequired: true, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
				{ field: 'OrderReference', type: 'text', displayLabel: 'ORDER_ADJUSTMENTS.FIELDS.ORDER_REFERENCE', visible: true, creatable: true, editable: false, inputType: 'text',
					validation: { isRequired: true, maxLen: 50, minLen: 1, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
				{ field: 'ArticleId', type: 'int', displayLabel: 'ORDER_ADJUSTMENTS.FIELDS.ARTICLE_ID', visible: true, creatable: false, editable: false, inputType: 'number',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'ArticleNumber', type: 'text', displayLabel: 'ORDER_ADJUSTMENTS.FIELDS.ARTICLE_NUMBER', visible: true, creatable: true, editable: false, inputType: 'text',
					validation: {isRequired: true, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'CrdId', type: 'int', displayLabel: 'ORDER_ADJUSTMENTS.FIELDS.DELIVERY_DATE_ID', visible: true, creatable: false, editable: false, inputType: 'lookup', lookupSource:'catalogs.CRD',
					lookupFilter: {'Status': 1}, validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'Crd', type: 'text', displayLabel: 'ORDER_ADJUSTMENTS.FIELDS.DELIVERY_DATE', visible: true, creatable: true, editable: false, inputType: 'date-utc',
					validation: {isRequired: true, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'NewCrdId', type: 'int', displayLabel: 'ORDER_ADJUSTMENTS.FIELDS.NEW_DELIVERY_DATE_ID', visible: true, creatable: false, editable: false, inputType: 'number',
					validation: { isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
				{ field: 'Size', type: 'text', displayLabel: 'ORDER_ADJUSTMENTS.FIELDS.SIZE', visible: true, creatable: true, editable: false, inputType: 'text',
					validation: {isRequired: true, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'Quantity', type: 'int', displayLabel: 'ORDER_ADJUSTMENTS.FIELDS.QUANTITY', visible: true, creatable: true, editable: false, inputType: 'number',
					validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '^[0-9]\\d*$', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: 'Quantity must be non-negative integer'}} },
				{ field: 'NewCrd', type: 'text', displayLabel: 'ORDER_ADJUSTMENTS.FIELDS.NEW_DELIVERY_DATE', visible: true, creatable: true, editable: false, inputType: 'date-utc',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', isOptional: true, messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'NewQuantity', type: 'int', displayLabel: 'ORDER_ADJUSTMENTS.FIELDS.NEW_QUANTITY', visible: true, creatable: true, editable: false, inputType: 'number',
					validation: {isRequired: false, maxLen: -1, minLen: 1, pattern: '^[0-9]\\d*$', isOptional: true, messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: 'New Quantity must be non-negative integer'}} },
				{ field: 'NewSize', type: 'text', displayLabel: 'ORDER_ADJUSTMENTS.FIELDS.NEW_SIZE', visible: true, creatable: false, editable: false, inputType: 'text',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'CustomerReference', type: 'text', displayLabel: 'ORDER_ADJUSTMENTS.FIELDS.CUSTOMER_REFERENCE', visible: false, creatable: false, editable: false, inputType: 'text',
					validation: {isRequired: 'data.CustomerCode || data.LocationCode', maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'CustomerCode', type: 'text', displayLabel: 'ORDER_ADJUSTMENTS.FIELDS.CUSTOMER_CODE', visible: false, creatable: false, editable: false, inputType: 'text',
					validation: {isRequired: 'data.CustomerReference || data.LocationCode', maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'LocationCode', type: 'text', displayLabel: 'ORDER_ADJUSTMENTS.FIELDS.LOCATION_CODE', visible: false, creatable: false, editable: false, inputType: 'text',
					validation: {isRequired: 'data.CustomerReference || data.CustomerCode', maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'CreatedDate', type: 'text', displayLabel: 'ORDER_ADJUSTMENTS.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
					validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
				{ field: 'UpdatedDate', type: 'text', displayLabel: 'ORDER_ADJUSTMENTS.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
					validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
				{ field: 'CreatedBy', type: 'text', displayLabel: 'ORDER_ADJUSTMENTS.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
					validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
				{ field: 'UpdatedBy', type: 'text', displayLabel: 'ORDER_ADJUSTMENTS.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
					validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }}
				],
			uniqueConstraints: [],
			commonConstraints: [
				{ name: 'Constraint 1', fields:['AdjustmentsName'] }
			],
			atLeastOneRequiredConstraints: [ // for non mandatory fields to have at least 1 value
				{ name: 'Constraint 1', fields:['NewCrd', 'NewQuantity'] }
			],
			conditionalRequired: [
				{ name: 'Constraint 1', criteria: 'data.Quantity > 0', requiredFields: ['CustomerReference', 'CustomerCode', 'LocationCode'] }
			],
			title: 'ORDER_ADJUSTMENTS.NAV',
			idField: 'Id',
			lookupDisplayField: 'Id',
			isDirty: false,
			isCatalogSpecificModel: true,
			methods: {
				getList      : getOrderAdjustment
			},
			views: {
				mainList: {
					columns: ['Id', 'OrderId', 'OrderReference', 'ArticleId', 'ArticleNumber', 'UpdatedBy'],
					columnFilter: {},
					toggleFilterProps: {},
					topIndex: 0,
					showFilterRow: false,
					sortColumn: { 'UpdatedDate': false },
					itemActions: [],
					listActions: []
				},
				mainDetails: {},
				privileges: {
					list: 'GetOrderAdjustmentDetails'
				}
			}
		};

		function getOrderAdjustments(generalProperties, model, catalogId) {
			if (angular.isDefined(model)) { // to skip this part for load lookup
				model.isBulkActionCompleted = false;
			}
			var promise;

			if (angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
				var state = {};
				state.name = $state.current.name;
				state.params = $state.params;
				var isBulk = true;
				var logData = activityLogger.createLogData(null, state, 'catalogs.orderAdjustments', 'VIEW', isBulk, new Date(), null, null);
				promise = api.webGet(api.baseUrl + '/catalogs/' + catalogId + '/orderadjustments', undefined, true, generalProperties.forceFetch);
				promise = activityLogger.log(logData, promise);
			}
			else {
				catalogId = angular.isUndefined(catalogId) ? catalogFactory.getActiveCatalog().CatalogCode : catalogId;
				promise = api.webGet(api.baseUrl + '/catalogs/' + catalogId + '/orderadjustments', undefined, true, generalProperties.forceFetch);
			}

			promise.then(function (response) {
				//creating a field to disable item actions if status is not fail/complete
				angular.forEach(response.data, function(adjustment) {
					if(adjustment.Status.toLowerCase() !== 'fail' && adjustment.Status.toLowerCase() !== 'complete') {
						adjustment.viewAdjustment = false;
					} else {
						adjustment.viewAdjustment = true;
					}
				});

				if (api.catalogs.orderAdjustments.isDirty) {
					//Invalidate lookupData
					api.catalogs.orderAdjustments.lookupData = undefined;
					api.catalogs.orderAdjustments.isDirty = false;
				}
			});
			return promise;
		}

		function getOrderAdjustment(isLogRequired, adjustmentId, catalogCode) {
			var promise;
			if (angular.isDefined(isLogRequired) && isLogRequired === true) {
			  var state = {};
			  state.name = $state.current.name;
			  state.params = $state.params;
			  var isBulk = false;
			  var items = [];
			  promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/orderadjustments/' + adjustmentId);
			  var logData = activityLogger.createLogData(items, state, 'catalogs.customerAllocations', 'VIEW', isBulk, new Date(), null, null);
			  promise = activityLogger.log(logData, promise);
			}
			else {
			  promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/orderadjustments/' + adjustmentId);
			}
			return promise;
		}

		function createBulk(data, catalogId, model) {
			var jobIndex = jobsTracker.addJob(model, 'ORDER_ADJUSTMENTS.ACTIONS.IMPORT_ORDER_ADJUSTMENTS', 1);
			api.webPut(api.baseUrl + '/catalogs/' + catalogId + '/orderadjustments', data).then(function (response) {
				jobsTracker.setCompleted(jobIndex, response);
			}).catch(function (error) {
				jobsTracker.setCriticlaFail(jobIndex, error);
			});
		}

		function adjustWithoutOrderReference(data, catalogId, model) {
			//Transform data into required format
			var requestObj = {};
			var adjustments = [];
			var name = '';
			var orderReferenceTracker = {}
			angular.forEach(data, function(record) {
				name = record.AdjustmentsName;
				delete data['AdjustmentsName'];
				if(record.Quantity > 0 &&
					angular.isDefined(record.CustomerCode) && record.CustomerCode.toString().trim() != '' &&
					angular.isDefined(record.LocationCode) && record.LocationCode.toString().trim() != '') {
					var orderReferenceTrackerKey = record.CustomerCode + '/' + (angular.isDefined(record.CustomerReference)? record.CustomerReference: '') + '/' + record.LocationCode
					if(!orderReferenceTracker.hasOwnProperty(orderReferenceTrackerKey)) {
						orderReferenceTracker[orderReferenceTrackerKey] = utility.generateOrderReference(record.CustomerCode, record.LocationCode)
					}
					record.OrderReference = orderReferenceTracker[orderReferenceTrackerKey]
				}
				adjustments.push(record);
			});
			requestObj['Name'] = name;
			requestObj['Adjustments'] = adjustments;
			var jobIndex = jobsTracker.addJob(model, 'ORDER_ADJUSTMENTS.ACTIONS.ADJUST_WITHOUT', 1);
			api.webPut(api.baseUrl + '/catalogs/' + catalogId + '/catalogorderadjustments', requestObj).then(function (response) {
				jobsTracker.setCompleted(jobIndex, response);
			}).catch(function (error) {
				jobsTracker.setCriticlaFail(jobIndex, error);
			});
		}
	}
})();
(function() {
  'use strict';

  angular
      .module('app.main.catalogs.merch-boards')
      .run(runBlock);

  /* @ngInject */
  function runBlock(api, activityLogger, $state, catalogFactory, crud, utility, $localStorage) {

      if (angular.isUndefined(api.catalogs)) {
        api.catalogs = {};
      }
       api.catalogs.merchBoards = {
          modelPath: 'catalogs.merchBoards',
          fields: [
              { field: 'Id', type: 'int', displayLabel: 'MERCH_BOARDS.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
                validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
              { field: 'SlideId', type: 'text', displayLabel: 'MERCH_BOARDS.FIELDS.SLIDE_ID', visible: true, creatable: false, editable: false, inputType: 'text',
                validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
              { field: 'SlideName', type: 'text', displayLabel: 'MERCH_BOARDS.FIELDS.SLIDE_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
                validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: ''}},
              { field: 'FolderId', type: 'text', displayLabel: 'MERCH_BOARDS.FIELDS.FOLDER_ID', visible: true, creatable: false, editable: false, inputType: 'text',
                validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
              { field: 'FolderName', type: 'text', displayLabel: 'MERCH_BOARDS.FIELDS.FOLDER_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
                validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
              { field: 'Status', type: 'text', displayLabel: 'MERCH_BOARDS.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
                validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
              { field: 'CustomerId', type: 'int', displayLabel: 'MERCH_BOARDS.FIELDS.CUSTOMER_ID', visible: true, creatable: false, editable: false, inputType: 'number',
                validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
              { field: 'SortOrder', type: 'int', displayLabel: 'MERCH_BOARDS.FIELDS.SORT_ORDER', visible: true, creatable: false, editable: false, inputType: 'number',
                validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
              { field: 'Version', type: 'text', displayLabel: 'MERCH_BOARDS.FIELDS.VERSION', visible: true, creatable: false, editable: false, inputType: 'text',
                validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
              { field: 'FolderIdSortOrder', type: 'int', displayLabel: 'MERCH_BOARDS.FIELDS.FOLDER_ID_SORT_ORDER', visible: true, creatable: false, editable: false, inputType: 'number',
                validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
              { field: 'CreatedDate', type: 'text', displayLabel: 'MERCH_BOARDS.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
              { field: 'UpdatedDate', type: 'text', displayLabel: 'MERCH_BOARDS.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
              { field: 'CreatedBy', type: 'text', displayLabel: 'MERCH_BOARDS.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
              { field: 'UpdatedBy', type: 'text', displayLabel: 'MERCH_BOARDS.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
              { field: 'isMySlide', type: 'text', displayLabel: '', visible: false, creatable: false, editable: false, inputType: 'text',
                validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
              { field: 'userid', type: 'text', displayLabel: 'MERCH_BOARDS.FIELDS.USER', visible: false, creatable: false, editable: false, inputType: 'lookup', lookupSource:'lists.usersWithCatalogAccess',
                validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
          ],
          uniqueConstraints: [],
          title: 'MERCH_BOARDS.NAV',
          icon: 'icon-view-dashboard',
          idField: 'SlideId',
          lookupDisplayField: 'SlideName',
          isDirty: false,
          isBulkActionCompleted: false,
          isCatalogSpecificModel: true,
          methods: {
              getList     : getMerchSlides,
              getDetails  : getMerchSlide,
              activate    : activate,
              getSharedByOrWithSlides: getSharedByOrWithSlides
          },
          views: {
              mainList: {
                  columns         : [ 'SlideName', 'FolderName', 'CustomerId', 'Version', 'Status', 'CreatedBy', 'SortOrder', 'UpdatedDate'],
                  columnFilter    : {},
                  topIndex        : 0,
                  showFilterRow   : false,
                  sortColumn      : {'UpdatedDate': false},
                  toggleFilterProps: { toggleStatus:false, filterProp:'Status', trueVal:1, trueValTooltipMessage: 'ACTIONS.TOGGLE_ACTIVE', falseVal:'', falseValTooltipMessage:"ACTIONS.TOGGLE_ALL"},
                  itemActions     : [
                                      { id: 'view', label: 'ACTIONS.VIEW', icon: 'icon-magnify', privilege: 'GetMerchSlideDetails', disabled: '!itm.Status', visible: true },
                                      { id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateMerchSlidesStatus', disabled: '!itm.isMySlide', visible: 'itm.Status',
                                          requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                                      { id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateMerchSlidesStatus', disabled: '!itm.isMySlide', visible: '!itm.Status',
                                          requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'},
                                    ],
                  listActions     : [
                                      { id: 'delete', label: 'ACTIONS.DELETE_BULK', icon: 'icon-delete', privilege: 'UpdateMerchSlidesStatus', disabled: '{selected: true, Status: 1, isMySlide: true}', visible: true,
                                        requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                                      { id: 'activate', label: 'ACTIONS.ACTIVATE_BULK', icon: 'icon-undo-variant', privilege: 'UpdateMerchSlidesStatus', disabled: '{selected: true, Status: 0, isMySlide: true}', visible: true,
                                        requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'},
                                    ],
                  merchBoradViews: [
                                      { id: 'merchBorads', label: 'MERCH_BOARDS.ACTIONS.MERCH_BOARDS', privilege: 'GetMyMerchSlides', disabled: false, visible: true},
                                      { id: 'sharedBy', label: 'MERCH_BOARDS.ACTIONS.SHARED_BY', privilege: 'GetSharedSlides', disabled: false, visible: true},
                                      { id: 'sharedWith', label: 'MERCH_BOARDS.ACTIONS.SHARED_WITH', privilege: 'GetSharedSlides', disabled: false, visible: true}
                  ],
                  fabAction       :   {id: 'add', label: 'ACTIONS.ADD', icon: 'icon-plus', privilege: 'CreateUserFavorites', visible: true}
               },
               mainDetails: {
                  selectedTabIndex: 0,
                  itemActions     : [
                                      { id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateMerchSlidesStatus', disabled: '{selected: true, Status: 1, isMySlide: true}',
                                          visible: true, requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'},confirmationAction: 'ACTIONS.DELETE'},
                                      { id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateMerchSlidesStatus', disabled: '{selected: true, Status: 0, isMySlide: true}',
                                          visible: true, requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
                                    ]
                },
                privileges: {
                  list    : 'GetMyMerchSlides',
                  details : 'GetMerchSlideDetails'
                }
          }
      };


    function getMerchSlides(generalProperties, catalogId) {
      var promise;
      if (angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
        var state = {};
        state.name = $state.current.name;
        state.params = $state.params;
        var isBulk = true;
        var logData = activityLogger.createLogData(null, state, 'catalogs.merchBoards', 'VIEW', isBulk, new Date(), null, null);

        promise = api.webGet(api.baseUrl + '/catalogs/' + catalogId + '/mymerchslides?version=0', undefined, true, generalProperties.forceFetch);
        promise = activityLogger.log(logData, promise);
      }
      else {
        if (angular.isUndefined(catalogId)) {
          catalogId = catalogFactory.getActiveCatalog().CatalogCode;
        }
        promise = api.webGet(api.baseUrl + '/catalogs/' + catalogId + '/mymerchslides?version=0', undefined, true, generalProperties.forceFetch);
      }
      promise.then(function (response) {
        if(response.data && response.data.length > 0) {
          angular.forEach(response.data, function(response) {
            if((response.CreatedBy === $localStorage.UserId) || (angular.isDefined($localStorage.account) && $localStorage.account.accountType == 1)) {
              response.isMySlide = true;
            } else {
              response.isMySlide = false;
            }
          });
        }
        if (api.catalogs.merchBoards.isDirty) {
          //Invalidate lookupData
          api.catalogs.merchBoards.lookupData = undefined;
          api.catalogs.merchBoards.isDirty = false;
        }
      });
      return promise;
    }

    function getMerchSlide(isLogRequired, slideId, catalogId) {
      var promise;
      if (angular.isDefined(isLogRequired) && isLogRequired === true) {
        var state = {};
        state.name = $state.current.name;
        state.params = $state.params;
        var isBulk = false;
        var items = [];
        promise = api.webGet(api.baseUrl + '/catalogs/' + catalogId + '/merchslides/' + slideId, undefined, true, true);
        promise.then(function (response) {
          items.push(response.data[api.catalogs.merchBoards.lookupDisplayField]);
        });
        var logData = activityLogger.createLogData(items, state, 'catalogs.merchBoards', 'VIEW', isBulk, new Date(), null, null);
        promise = activityLogger.log(logData, promise);
      }
      else {
        promise = api.webGet(api.baseUrl + '/catalogs/' + catalogId + '/merchslides/' + slideId, undefined, true, true);
      }

      promise.then(function (response) {
        if(response.data) {
            // enable edit and delete for admin users
            if((response.data.CreatedBy === $localStorage.UserId) || (angular.isDefined($localStorage.account) && $localStorage.account.accountType == 1)) {
              response.data.isMySlide = true;
            } else {
              response.data.isMySlide = false;
            }
        }
      });

      return promise;
    }

    function activate(records, model, actionType, parentId) {
      var result = crud.createRequestObject(records, model, actionType);
      var indexedRecords = {}
      if(!angular.isArray(records)) {
        records = utility.pushItemToArray(records);
      }
      angular.forEach(records, function(record) {
        indexedRecords[record[model.idField]]= record;
      });
      angular.forEach(result.requestObj, function(requestObject) {
        requestObject.CustomerId = indexedRecords[requestObject[model.idField]].CustomerId;
      });
      var state = {};
      state.name = $state.current.name;
      state.params = $state.params;
      var isBulk = result.itemsNameList.length > 1 ? true : false;
      var logData = activityLogger.createLogData(result.itemsNameList, state, 'catalogs.merchBoards', actionType.toUpperCase(), isBulk, new Date(), null, null);
      var promise = api.webPut(api.baseUrl + '/catalogs/' + parentId + '/merchslides/status', result.requestObj);

      promise.then(function () {
        crud.onRecordStatusChange(records, api.catalogs.merchBoards, actionType);// it should be base model for dynamic models since base model isDirty is being change in all actions
      });

      return activityLogger.log(logData, promise);
    }

    function getSharedByOrWithSlides(generalProperties, catalogCode, action, userId) {
      var promise;
      var state = {};
      state.name = $state.current.name;
      state.params = $state.params;
      var isBulk = true;
      var logData = activityLogger.createLogData(null, state, 'catalogs.merchBoards', 'VIEW', isBulk, new Date(), null, null);

      var sharedType = (action === 'sharedBy') ? 'by' : 'with';

      promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/sharedslides?version=0&sharetype=' + sharedType + '&userid=' + userId, undefined, true, generalProperties.forceFetch);
      promise = activityLogger.log(logData, promise);
      promise.then(function (response) {
        if(response.data && response.data.length > 0) {
          angular.forEach(response.data, function(response) {
            if((response.CreatedBy === $localStorage.UserId) || (angular.isDefined($localStorage.account) && $localStorage.account.accountType == 1)) {
              response.isMySlide = true;
            } else {
              response.isMySlide = false;
            }
          });
        }
        if (api.catalogs.merchBoards.isDirty) {
          //Invalidate lookupData
          api.catalogs.merchBoards.lookupData = undefined;
          api.catalogs.merchBoards.isDirty = false;
        }
      });
      return promise;
    }

  }
})();
(function () {
  'use strict';

  angular
    .module('app.main.catalogs.linked-buyers')
    .run(runBlock);

  /* @ngInject */
  function runBlock(api, activityLogger, $state, catalogFactory) {

    if (angular.isUndefined(api.catalogs)) {
      api.catalogs = {};
    }
    api.catalogs.linkedBuyers = {
      modelPath: 'catalogs.linkedBuyers',
      fields: [
        { field: 'CustomerId', type: 'int', displayLabel: 'LINKED_BUYERS.FIELDS.CUSTOMER_ID', visible: true, creatable: false, editable: false, inputType: 'number',
          validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
        { field: 'CustomerCode', type: 'text', displayLabel: 'LINKED_BUYERS.FIELDS.CUSTOMER_CODE', visible: true, creatable: false, editable: false, inputType: 'text',
          validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
        { field: 'CustomerName', type: 'text', displayLabel: 'LINKED_BUYERS.FIELDS.CUSTOMER_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
          validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
        { field: 'BuyerUserId', type: 'int', displayLabel: 'LINKED_BUYERS.FIELDS.BUYER_USER_ID', visible: true, creatable: false, editable: false, inputType: 'number',
          validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
        { field: 'BuyerUserEmail', type: 'text', displayLabel: 'LINKED_BUYERS.FIELDS.BUYER_USER_EMAIL', visible: true, creatable: false, editable: false, inputType: 'text',
          validation: {isRequired: false, maxLen: 500, minLen: 0, pattern: '^[A-Za-z]+[A-Za-z0-9._+-]+@{1}[A-Za-z0-9._-]+\.[A-Za-z.]{2,}$', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: 'VALIDATIONS.INVALID_EMAIL'}} },
        { field: 'BuyerUserFirstName', type: 'text', displayLabel: 'LINKED_BUYERS.FIELDS.BUYER_USER_FIRST_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
          validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
        { field: 'BuyerUserLastName', type: 'text', displayLabel: 'LINKED_BUYERS.FIELDS.BUYER_USER_LAST_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
          validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
        { field: 'BuyerUserAccountId', type: 'int', displayLabel: 'LINKED_BUYERS.FIELDS.BUYER_USER_ACCOUNT_ID', visible: true, creatable: false, editable: false, inputType: 'number',
          validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
        { field: 'BuyerUserAccount', type: 'text', displayLabel: 'LINKED_BUYERS.FIELDS.BUYER_USER_ACCOUNT', visible: true, creatable: false, editable: false, inputType: 'text',
          validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
        { field: 'CreatedDate', type: 'text', displayLabel: 'LINKED_BUYERS.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
          validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
        { field: 'UpdatedDate', type: 'text', displayLabel: 'LINKED_BUYERS.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
          validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
        { field: 'CreatedBy', type: 'text', displayLabel: 'LINKED_BUYERS.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'text',
          validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
        { field: 'UpdatedBy', type: 'text', displayLabel: 'LINKED_BUYERS.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'text',
          validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
        { field: 'CustomerStatus', type: 'text', displayLabel: 'LINKED_BUYERS.FIELDS.CUSTOMER_STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
          validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
        { field: 'CatalogCustomerStatus', type: 'text', displayLabel: 'LINKED_BUYERS.FIELDS.CATALOG_CUSTOMER_STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
          validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
        { field: 'BuyerUserStatus', type: 'text', displayLabel: 'LINKED_BUYERS.FIELDS.BUYER_USER_STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
          validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
        { field: 'BuyerAccountStatus', type: 'text', displayLabel: 'LINKED_BUYERS.FIELDS.BUYER_ACCOUNT_STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
          validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
        { field: 'Status', type: 'text', displayLabel: 'LINKED_BUYERS.FIELDS.STATUS', visible: true, creatable: true, editable: false, inputType: 'status',
          validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
      ],
      uniqueConstraints: [],
      title: 'LINKED_BUYERS.NAV',
      icon: 'icon-source-fork',
      idField: 'BuyerUserId',
      lookupDisplayField: 'BuyerUserEmail',
      isDirty: false,
      isBulkActionCompleted: false,
      isCatalogSpecificModel: true,
      methods: {
         getList      : getLinkedBuyers
      },
      views: {
        mainList: {
          columns           : ['CustomerName', 'BuyerUserFirstName', 'BuyerUserLastName', 'BuyerUserAccount', 'CustomerStatus', 'BuyerUserStatus'],
          columnFilter      : {},
          toggleFilterProps : {},
          topIndex          : 0,
          showFilterRow     : false,
          sortColumn        : { 'UpdatedDate': false },
          sortDescending    : true,
          itemActions       : [],
          listActions       : [],
          fabAction         : {}
        },
        mainDetails: {},
        privileges: {
          list: 'GetCatalogBuyerUsers'
        }
      }
    };

    function getLinkedBuyers(generalProperties, model, catalogCode) {
      if (angular.isDefined(model)) { // to skip this part for load lookup
        model.isBulkActionCompleted = false;
      }
      var promise;

      if (angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
        var state = {};
        state.name = $state.current.name;
        state.params = $state.params;
        var isBulk = true;
        var logData = activityLogger.createLogData(null, state, 'catalogs.linkedBuyers', 'VIEW', isBulk, new Date(), null, null);

        promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/buyerusers', undefined, true, generalProperties.forceFetch);
        promise = activityLogger.log(logData, promise);
      }
      else {
        catalogCode = angular.isUndefined(catalogCode) ? catalogFactory.getActiveCatalog().CatalogCode : catalogCode;
        promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/buyerusers', undefined, true, generalProperties.forceFetch);
      }

      promise.then(function () {
        if (api.catalogs.linkedBuyers.isDirty) {
          //Invalidate lookupData
          api.catalogs.linkedBuyers.lookupData = undefined;
          api.catalogs.linkedBuyers.isDirty = false;
        }
      });
      return promise;
    }

  }
})();
(function () {
	'use strict';

	angular
		.module('app.main.catalogs.images')
		.run(runBlock);

	/* @ngInject */
	function runBlock(api) {

		if (angular.isUndefined(api.catalogs)) {
			api.catalogs = {};
		}
		api.catalogs.duneImages = {
			modelPath: 'catalogs.duneImages',
			fields: [
				{ field: 'Id', type: 'text', displayLabel: 'T1_DUNE.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'text',
						validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'ImageSet', type: 'text', displayLabel: 'T1_DUNE.FIELDS.IMAGE_SET', visible: true, creatable: false, editable: false, inputType: 'text',
						validation: {isRequired: true, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'ContextId', type: 'text', displayLabel: 'T1_DUNE.FIELDS.CONTEXT_ID', visible: true, creatable: false, editable: false, inputType: 'text',
						validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'Key', type: 'text', displayLabel: 'T1_DUNE.FIELDS.KEY', visible: true, creatable: false, editable: false, inputType: 'text',
						validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'FileName', type: 'text', displayLabel: 'T1_DUNE.FIELDS.FILE_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
						validation: {isRequired: true, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'FilePath', type: 'text', displayLabel: 'T1_DUNE.FIELDS.FILE_PATH', visible: true, creatable: false, editable: false, inputType: 'text',
						validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'SortOrder', type: 'int', displayLabel: 'T1_DUNE.FIELDS.SORT_ORDER', visible: true, creatable: false, editable: false, inputType: 'number',
						validation: {isRequired: true, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'Status', type: 'text', displayLabel: 'T1_DUNE.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'bool',
						validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'AssetHash', type: 'text', displayLabel: 'T1_DUNE.FIELDS.ASSET_HASH', visible: true, creatable: false, editable: false, inputType: 'text',
						validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'ReferenceAssetId', type: 'text', displayLabel: 'T1_DUNE.FIELDS.REF_ASSET_ID', visible: true, creatable: false, editable: false, inputType: 'text',
						validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'Format', type: 'text', displayLabel: 'T1_DUNE.FIELDS.FORMAT', visible: true, creatable: false, editable: false, inputType: 'text',
						validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'Width', type: 'int', displayLabel: 'T1_DUNE.FIELDS.WIDTH', visible: true, creatable: false, editable: false, inputType: 'number',
						validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'Height', type: 'int', displayLabel: 'T1_DUNE.FIELDS.HEIGHT', visible: true, creatable: false, editable: false, inputType: 'number',
						validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'Density', type: 'int', displayLabel: 'T1_DUNE.FIELDS.DENSITY', visible: true, creatable: false, editable: false, inputType: 'number',
						validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'Size', type: 'text', displayLabel: 'T1_DUNE.FIELDS.SIZE', visible: true, creatable: false, editable: false, inputType: 'text',
						validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'StorageFile', type: 'text', displayLabel: 'T1_DUNE.FIELDS.STORAGE_FILE', visible: true, creatable: false, editable: false, inputType: 'text',
						validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'CreatedOn', type: 'text', displayLabel: 'T1_DUNE.FIELDS.CREATED_ON', visible: true, creatable: false, editable: false, inputType: 'date',
						validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'UpdatedOn', type: 'text', displayLabel: 'T1_DUNE.FIELDS.UPDATED_ON', visible: true, creatable: false, editable: false, inputType: 'date',
						validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'CreatedBy', type: 'text', displayLabel: 'T1_DUNE.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'text',
						validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'UpdatedBy', type: 'text', displayLabel: 'T1_DUNE.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'text',
						validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'AssetTypeId', type: 'text', displayLabel: 'T1_DUNE.FIELDS.ASSET_TYPE', visible: false, creatable: false, editable: false, inputType: 'text',
						validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'AssetTypeName', type: 'text', displayLabel: 'T1_DUNE.FIELDS.ASSET_TYPE', visible: true, creatable: false, editable: false, inputType: 'text',
						validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
			],
			uniqueConstraints: [
				{name: 'Constraint 1', fields: ['ImageSet', 'FileName']}
			],
			title: 'IMAGES.NAV',
			icon: 'icon-image-filter',
			idField: 'Id',
			lookupDisplayField: 'Id',
			isBulkActionCompleted: false,
			isDirty: false,
			isCatalogSpecificModel: true,
			methods: {},
			views: {
					mainList: {
							columns         : [ 'Id', 'ImageSet', 'Context', 'Key', 'FilePath', 'FileName', 'SortOrder', 'AssetTypeName', 'Status', 'UpdatedOn' ],
							columnFilter    : {},
							imagesSize      : 'large',
							topIndex        : 0,
							showFilterRow   : false,
							sortColumn      : {'UpdatedOn': false},
							itemActions     : [
																	{ id: 'view', label: 'ACTIONS.VIEW', icon: 'icon-magnify', privilege: 'UI_T1DuneReadAccess:true', disabled: '!itm.Status', visible: true },
																	{ id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UI_T1DuneReadWriteAccess:true', disabled: '!itm.Status', visible: true },
																	{ id: 'editSortOrder', label: 'T1_DUNE.ACTIONS.EDIT_SORTORDER', icon: 'icon-pencil', privilege: 'UI_T1DuneReadWriteAccess:true', disabled: '!itm.Status', visible: true },
																	{ id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UI_T1DuneReadWriteAccess:true', disabled: false, visible: 'itm.Status',
																			requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
																	{ id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UI_T1DuneReadWriteAccess:true', disabled: false, visible: '!itm.Status',
																			requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}],
							listActions     : [
																	{ id: 'delete', label: 'ACTIONS.DELETE_BULK', icon: 'icon-delete', privilege: 'UI_T1DuneReadWriteAccess:true', disabled: '{selected: true, Status: true}', visible: true,
																			requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
																	{ id: 'activate', label: 'ACTIONS.ACTIVATE_BULK', icon: 'icon-undo-variant', privilege: 'UI_T1DuneReadWriteAccess:true', disabled: '{selected: true, Status: false}', visible: true,
																			requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'},
																	{ id: 'updateBulkSortOrder', label: 'T1_DUNE.ACTIONS.UPADATE_SORTORDER_BULK', icon: 'icon-import', privilege: 'UI_T1DuneReadWriteAccess:true', disabled: false, visible: true, requiresConfirmation: false }
																],
							fabAction       : {id: 'add', label: 'ACTIONS.ADD', icon: 'icon-plus', privilege: 'UI_T1DuneReadWriteAccess:true', visible: true}
					 },
					 mainDetails: {
							 selectedTabIndex   : 0,
							 itemActions        : [
																		{ id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UI_T1DuneReadWriteAccess:true', disabled: '{selected: true, Status: true}', visible: true,
																				requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
																		{ id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UI_T1DuneReadWriteAccess:true', disabled: '{selected: true, Status: false}', visible: true,
																				requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
							 ],
							 fab                 : {id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UI_T1DuneReadWriteAccess:true', visible: true}

					 },
					privileges: {
							list    : 'UI_T1DuneReadAccess',
							details : 'UI_T1DuneReadAccess'
					}
				}
		};

	}
})();
(function() {
    'use strict';

    angular
        .module('app.main.catalogs.forecast')
        .run(runBlock);

    /* @ngInject */
    function runBlock(api, activityLogger, $state, crud, catalogFactory, jobsTracker, CONSTANTS) {

        if (angular.isUndefined(api.catalogs)) {
            api.catalogs = {};
        }
         api.catalogs.forecast = {
            modelPath: 'catalogs.forecast',
            fields: [
                { field: 'Id', type: 'int', displayLabel: 'FORECAST.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CatalogCode', type: 'int', displayLabel: 'FORECAST.FIELDS.CATALOG_CODE', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Name', type: 'text', displayLabel: 'FORECAST.FIELDS.NAME', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CustomerId', type: 'int', displayLabel: 'FORECAST.FIELDS.CUSTOMER_ID', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CustomerId', type: 'int', displayLabel: 'FORECAST.FIELDS.CUSTOMER_ID', visible: false, creatable: true, editable: true, inputType: 'lookup', lookupSource: 'customers.customers',
                    lookupFilter: {Status: 1}, validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CustomerCode', type: 'int', displayLabel: 'FORECAST.FIELDS.CUSTOMER_CODE', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CustomerName', type: 'text', displayLabel: 'FORECAST.FIELDS.CUSTOMER_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'LocationId', type: 'int', displayLabel: 'FORECAST.FIELDS.LOCATION_ID', visible: true, creatable: false, editable: false, inputType: 'int',
                     validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'LocationCode', type: 'int', displayLabel: 'FORECAST.FIELDS.LOCATION_CODE', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'LocationName', type: 'text', displayLabel: 'FORECAST.FIELDS.LOCATION_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'PublishStatusId', type: 'int', displayLabel: 'FORECAST.FIELDS.PUBLISH_STATUS_ID', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'PublishStatus', type: 'text', displayLabel: 'FORECAST.FIELDS.PUBLISH_STATUS', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'TypeId', type: 'int', displayLabel: 'FORECAST.FIELDS.TYPE_ID', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Type', type: 'text', displayLabel: 'FORECAST.FIELDS.TYPE', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Status', type: 'text', displayLabel: 'FORECAST.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedDate', type: 'text', displayLabel: 'FORECAST.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedDate', type: 'text', displayLabel: 'FORECAST.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedBy', type: 'text', displayLabel: 'FORECAST.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedBy', type: 'text', displayLabel: 'FORECAST.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'BuyWindowId', type: 'int', displayLabel: 'FORECAST.FIELDS.BY_WINDOW_ID', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'BuyWindowName', type: 'text', displayLabel: 'FORECAST.FIELDS.BY_WINDOW', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: true, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
            ],
            title: 'FORECAST.NAV',
            icon: 'icon-sigma',
            idField: 'Id',
            lookupDisplayField: 'Name',
            isDirty: false,
            isBulkActionCompleted: false,
            isCatalogSpecificModel: true,
            methods: {
                getList                   :   getForecastList,
                getDetails                :   getForecast,
                activateBulk              :   activateForecast,
                updatePublishStatusBulk   :   updatePublishStatusBulk,
                createBulk                :   createBulk
            },
            views: {
                mainList: {
                    columns         : [ 'Name', 'CustomerName', 'LocationName', 'PublishStatus', 'Status', 'UpdatedDate' ],
                    columnFilter    : {},
                    toggleFilterProps: { toggleStatus:false, filterProp:'Status', trueVal:1, trueValTooltipMessage: 'ACTIONS.TOGGLE_ACTIVE', falseVal:'', falseValTooltipMessage:"ACTIONS.TOGGLE_ALL"},
                    topIndex        : 0,
                    showFilterRow   : false,
                    sortColumn      : {'UpdatedDate': false},
                    itemActions     : [
                                          { id: 'view', label: 'ACTIONS.VIEW', icon: 'icon-magnify', privilege: 'GetForecastDetails', disabled: '!itm.Status', visible: true },
                                          { id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateForecastStatusBulk:true', disabled: 'itm.disableAction', visible: 'itm.Status',
                                              requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                                          { id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateForecastStatusBulk:true', disabled: 'itm.disableAction', visible: '!itm.Status',
                                              requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'},
                                          { id: 'publish', label: 'FORECAST.ACTIONS.PUBLISH', icon: 'icon-package-variant', privilege: 'UpdateForecastPublishStatusBulk:true', disabled: 'itm.disableAction', visible: 'itm.PublishStatusId === 1',
                                              requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'FORECAST.MESSAGES.CONTENT.CONFIRM_PUBLISH'}, confirmationAction: 'FORECAST.ACTIONS.PUBLISH'},
                                          { id: 'draft', label: 'FORECAST.ACTIONS.DRAFT', icon: 'icon-lock', privilege: 'UpdateForecastPublishStatusBulk:true', disabled: 'itm.disableAction', visible: 'itm.PublishStatusId === 2',
                                              requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'FORECAST.MESSAGES.CONTENT.CONFIRM_DRAFT'}, confirmationAction: 'FORECAST.ACTIONS.DRAFT'}
                                      ],
                    listActions     : [
                                          { id: 'delete', label: 'ACTIONS.DELETE_BULK', icon: 'icon-delete', privilege: 'UpdateForecastStatusBulk:true', disabled: '{selected: true, Status: 1, disableAction: 0}', visible: true,
                                              requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                                          { id: 'activate', label: 'ACTIONS.ACTIVATE_BULK', icon: 'icon-undo-variant', privilege: 'UpdateForecastStatusBulk:true', disabled: '{selected: true, Status: 0, disableAction: 0}', visible: true,
                                              requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'},
                                          { id: 'publish', label: 'FORECAST.ACTIONS.PUBLISH_BULK', icon: 'icon-package-variant', privilege: 'UpdateForecastPublishStatusBulk:true', disabled: '{selected: true, PublishStatusId: 1, disableAction: 0}', visible: true,
                                              requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'FORECAST.MESSAGES.CONTENT.CONFIRM_PUBLISH'}, confirmationAction: 'FORECAST.ACTIONS.PUBLISH'},
                                          { id: 'draft', label: 'FORECAST.ACTIONS.DRAFT_BULK', icon: 'icon-lock', privilege: 'UpdateForecastPublishStatusBulk:true', disabled: '{selected: true, PublishStatusId: 2, disableAction: 0}', visible: true,
                                              requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'FORECAST.MESSAGES.CONTENT.CONFIRM_DRAFT'}, confirmationAction: 'FORECAST.ACTIONS.DRAFT'},
                                          { id: 'import', label: 'ACTIONS.IMPORT', icon: 'icon-import', privilege: 'ImportForecast:true', disabled: false, visible: true, requiresConfirmation: false }
                                      ]
                 },
                 mainDetails: {
                  selectedTabIndex   : 0,
                  itemActions        : [
                                          { id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateForecastStatusBulk:true', disabled: '{selected: true, Status: 1, disableAction: 0}',
                                            visible: true, requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                                          { id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateForecastStatusBulk:true', disabled: '{selected: true, Status: 0, disableAction: 0}',
                                            visible: true, requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'},
                                          { id: 'publish', label: 'FORECAST.ACTIONS.PUBLISH', icon: 'icon-package-variant', privilege: 'UpdateForecastPublishStatusBulk:true', disabled: '{selected: true, PublishStatusId: 1, disableAction: 0}',
                                            visible: true, requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'FORECAST.MESSAGES.CONTENT.CONFIRM_PUBLISH'}, confirmationAction: 'FORECAST.ACTIONS.PUBLISH'},
                                          { id: 'draft', label: 'FORECAST.ACTIONS.DRAFT', icon: 'icon-lock', privilege: 'UpdateForecastPublishStatusBulk:true', disabled: '{selected: true, PublishStatusId: 2, disableAction: 0}',
                                            visible: true, requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'FORECAST.MESSAGES.CONTENT.CONFIRM_DRAFT'}, confirmationAction: 'FORECAST.ACTIONS.DRAFT'}
                                      ],
                  fabAction           : {}

                 },
                privileges: {
                    list    : 'GetForecastList',
                    details : 'GetForecastDetails'
                }
            }
        };


        api.catalogs.importForecast = {
          modelPath: 'catalogs.importForecast',
          fields: [
            { field: 'CustomerCode', type: 'int', displayLabel: 'FORECAST.FIELDS.CUSTOMER_CODE', visible: false, creatable: true, editable: false, inputType: 'text',
              validation: {isRequired: true, maxLen: 50, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
            { field: 'LocationCode', type: 'int', displayLabel: 'FORECAST.FIELDS.LOCATION_CODE', visible: false, creatable: true, editable: false, inputType: 'text',
              validation: {isRequired: false, maxLen: 50, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
            { field: 'ArticleNumber', type: 'int', displayLabel: 'FORECAST.FIELDS.ARTICLE_NUMBER', visible: false, creatable: true, editable: false, inputType: 'text',
              validation: {isRequired: true, maxLen: 20, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
            { field: 'Quantity', type: 'int', displayLabel: 'FORECAST.FIELDS.QUANTITY', visible: false, creatable: true, editable: false, inputType: 'number',
              validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '^[1-9][0-9]*|0$', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: 'of non-negative integers'}} },
            { field: 'BuyWindowName', type: 'text', displayLabel: 'FORECAST.FIELDS.BY_WINDOW', visible: false, creatable: false, editable: false, inputType: 'text',
                validation: {isRequired: true, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
          ],
          title: 'FORECAST.NAV',
          icon: 'icon-source-fork',
        };

        function getForecastList(generalProperties, model, catalogCode) {
            var promise;
            if (angular.isDefined(model)) { // to skip this part for load lookup
                model.isBulkActionCompleted = false;
            }

            if (angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
                var state = {};
                state.name = $state.current.name;
                state.params = $state.params;
                var isBulk = true;
                var logData = activityLogger.createLogData(null, state, 'catalogs.forecast', 'VIEW', isBulk, new Date(), null, null);

                promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/forecasts', undefined, true, generalProperties.forceFetch);
                promise = activityLogger.log(logData, promise);
            }
            else {
                catalogCode = angular.isUndefined(catalogCode) ? catalogFactory.getActiveCatalog().CatalogCode : catalogCode;
                promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/forecasts', undefined, true, generalProperties.forceFetch);
            }

            promise.then(function () {
                if (api.catalogs.forecast.isDirty) {
                    //Invalidate lookupData
                    api.catalogs.forecast.lookupData = undefined;
                    api.catalogs.forecast.isDirty = false;
                }
            });
            return promise;
        }

        function getForecast(isLogRequired, id, catalogCode) {
            var promise;
            if (angular.isDefined(isLogRequired) && isLogRequired === true) {
                var state = {};
                state.name = $state.current.name;
                state.params = $state.params;
                var isBulk = false;
                var items = [];
                promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/forecasts/' + id + '?status=0');
                promise.then(function (response) {
                    items.push(response.data[api.catalogs.forecast.lookupDisplayField]);
                }, function (response) {
                    items.push(response.data[api.catalogs.forecast.lookupDisplayField]);
                });
                var logData = activityLogger.createLogData(items, state, 'catalogs.forecast', 'VIEW', isBulk, new Date(), null, null);
                promise = activityLogger.log(logData, promise);
            }
            else {
                promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/forecasts/' + id + '?status=0');
            }
            return promise;
        }

        function activateForecast(records, model, actionType, catalogCode) {
            var result = crud.createRequestObject(records, model, actionType);
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var isBulk = result.itemsNameList.length > 1 ? true : false;
            var logData = activityLogger.createLogData(result.itemsNameList, state, 'catalogs.forecast', actionType.toUpperCase(), isBulk, new Date(), null, null);
            var promise = api.webPut(api.baseUrl + '/catalogs/' + catalogCode + '/forecasts/status', result.requestObj);

            promise.then(function () {
                crud.onRecordStatusChange(records, api.catalogs.forecast, actionType);
            });

            return activityLogger.log(logData, promise);
        }

        function updatePublishStatusBulk(records, model, actionType, catalogCode) {
            var result = {
                requestObj: [],
                itemsNameList: []
            };

            var obj;
            var index = 0;
            var PublishStatus = -1;
            if (actionType.toUpperCase() === 'PUBLISH') {
                PublishStatus = 2;
            }
            else {
                PublishStatus = 1;
            }

            if (!angular.isArray(records)) {
                records = crud.pushItemToArray(records);
            }

            for (index; index < records.length; index++) {
                obj = {}
                obj[model.idField] = records[index][model.idField];
                obj.PublishStatus = PublishStatus;
                result.requestObj.push(obj);
                result.itemsNameList.push(records[index][model.lookupDisplayField]);
            }

            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var isBulk = result.itemsNameList.length > 1 ? true : false;
            var logData = activityLogger.createLogData(result.itemsNameList, state, 'catalogs.forecast', actionType.toUpperCase(), isBulk, new Date(), null, null);
            var promise = api.webPut(api.baseUrl + '/catalogs/' + catalogCode + '/forecasts/publishstatus', result.requestObj);

            promise.then(function () {
                crud.onRecordStatusChange(records, api.catalogs.forecast, actionType);
            });

            return activityLogger.log(logData, promise);
        }

        function createBulk(model, data, catalogCode) {
            var jobIndex = jobsTracker.addJob(model, 'FORECAST.ACTIONS.IMPORT_FORECASTS', 1);
            var result = [];
            var forecastIndexes = {};
            angular.forEach(data, function (d) {
                var name = 'SellerForecast';
                if(angular.isDefined(d.LocationCode) && d.LocationCode !== '' && angular.isDefined(d.CustomerCode) && d.CustomerCode !== '') {
                    name = name + '-' + d.CustomerCode + '-' + d.LocationCode;
                } else if(angular.isDefined(d.LocationCode) && d.LocationCode !== '' && (angular.isUndefined(d.CustomerCode) ||d.CustomerCode === '')) {
                    name = name + '-' + d.LocationCode;
                } else {
                    name = name + '-' + d.CustomerCode;
                }

                var article = { ArticleNumber: d.ArticleNumber, Quantity: d.Quantity };
                if (angular.isDefined(forecastIndexes[name]) && result[forecastIndexes[name]].CustomerCode === d.CustomerCode && result[forecastIndexes[name]].LocationCode === d.LocationCode) {
                    result[forecastIndexes[name]].ArticleList.push(article);
                }
                else {
                    var transformedObj = {
                        Name          : name,
                        CustomerCode  : d.CustomerCode,
                        LocationCode  : d.LocationCode,
                        ArticleList   : [article]
                    };
                    if(angular.isDefined(d.BuyWindowName)) {
                        transformedObj.BuyWindowName = d.BuyWindowName;
                    }
                    result.push(transformedObj);
                    forecastIndexes[name] = result.length - 1;
                }
            });
            api.webPut(api.baseUrl + '/catalogs/' + catalogCode + '/forecasts?sourceapplication=' + CONSTANTS.SOURCE_APPLICATION + '&sourceaction=Import Forecasts', result)
                .then(function (response) {
                    jobsTracker.trackJob(jobIndex, response.data.Id);
                }).catch(function (error) {
                    jobsTracker.setCriticlaFail(jobIndex, error);
                });
        }

    }
})();
(function() {
  'use strict';

  angular
      .module('app.main.catalogs.favorites')
      .run(runBlock);

  /* @ngInject */
  function runBlock(api, activityLogger, $state, catalogFactory, crud, $localStorage) {

      if (angular.isUndefined(api.catalog)) {
          api.catalog = {};
      }
       api.catalog.favorites = {
          modelPath: 'catalog.favorites',
          fields: [
              { field: 'Id', type: 'int', displayLabel: 'FAVORITES.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
                  validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
              { field: 'Tag', type: 'text', displayLabel: 'FAVORITES.FIELDS.TAG', visible: true, creatable: true, editable: true, inputType: 'text', checkIfUnique: true,
                  validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
              { field: 'Color', type: 'text', displayLabel: 'FAVORITES.FIELDS.COLOR', visible: true, creatable: false, editable: true, inputType: 'color',
                  validation: {isRequired: true, maxLen: 7, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
              { field: 'Articles', type: 'text', displayLabel: 'FAVORITES.FIELDS.ARTICLES', visible: true, creatable: true, editable: true, inputType: 'lookup-many', lookupSource:'catalogs.articles',
                  lookupFilter: {'Status': 1}, validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: ''}},
              { field: 'SharedUsers', type: 'text', displayLabel: 'FAVORITES.FIELDS.SHARED_USERS', visible: true, creatable: true, editable: true, inputType: 'lookup-many', lookupSource:'accounts.users',
                  lookupFilter: {'Status': 1}, validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
              { field: 'Status', type: 'text', displayLabel: 'FAVORITES.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
                  validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
              { field: 'CustomerId', type: 'int', displayLabel: 'FAVORITES.FIELDS.CUSTOMER_ID', visible: true, creatable: true, editable: true, inputType: 'lookup', lookupSource: 'catalogs.customers',
                  lookupFilter: {Status: 1}, validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } } },
              { field: 'CreatedDate', type: 'text', displayLabel: 'FAVORITES.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                  validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
              { field: 'UpdatedDate', type: 'text', displayLabel: 'FAVORITES.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                  validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
              { field: 'CreatedBy', type: 'text', displayLabel: 'FAVORITES.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                  validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
              { field: 'UpdatedBy', type: 'text', displayLabel: 'FAVORITES.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                  validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
              { field: 'isMyFavorite', type: 'text', displayLabel: '', visible: false, creatable: false, editable: false, inputType: 'text',
                  validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
              ],
          uniqueConstraints: [],
          title: 'FAVORITES.NAV',
          icon: 'icon-star-circle',
          idField: 'Id',
          lookupDisplayField: 'Tag',
          isDirty: false,
          isBulkActionCompleted: false,
          isCatalogSpecificModel: true,
          methods: {
              getList     : getFavorites,
              getDetails  : getFavorite,
              create      : create,
              update      : update,
              activate    : activate
          },
          views: {
              mainList: {
                  columns         : [ 'Tag', 'Articles', 'Color', 'SharedUsers', 'Status', 'UpdatedDate'],
                  columnFilter    : {},
                  topIndex        : 0,
                  showFilterRow   : false,
                  sortColumn      : {'UpdatedDate': false},
                  toggleFilterProps: { toggleStatus:false, filterProp:'Status', trueVal:1, trueValTooltipMessage: 'ACTIONS.TOGGLE_ACTIVE', falseVal:'', falseValTooltipMessage:"ACTIONS.TOGGLE_ALL"},
                  itemActions     : [
                                      { id: 'view', label: 'ACTIONS.VIEW', icon: 'icon-magnify', privilege: 'GetUserFavoriteDetails', disabled: '!itm.Status', visible: true },
                                      { id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UpdateUserFavorites', disabled: '!itm.Status || !itm.isMyFavorite', visible: true },
                                      { id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateUserFavoritesStatus', disabled: '!itm.isMyFavorite', visible: 'itm.Status',
                                          requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                                      { id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateUserFavoritesStatus', disabled: '!itm.isMyFavorite', visible: '!itm.Status',
                                          requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'},
                                    ],
                  listActions     : [
                                      { id: 'delete', label: 'ACTIONS.DELETE_BULK', icon: 'icon-delete', privilege: 'UpdateUserFavoritesStatus', disabled: '{selected: true, Status: 1, isMyFavorite: true}', visible: true,
                                        requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                                      { id: 'activate', label: 'ACTIONS.ACTIVATE_BULK', icon: 'icon-undo-variant', privilege: 'UpdateUserFavoritesStatus', disabled: '{selected: true, Status: 0, isMyFavorite: true}', visible: true,
                                        requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'},
                                    ],
                  fabAction       :   {id: 'add', label: 'ACTIONS.ADD', icon: 'icon-plus', privilege: 'CreateUserFavorites', visible: true}
               },
               mainDetails: { selectedTabIndex   : 0,
                              itemActions        : [
                                                    { id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateUserFavoritesStatus', disabled: '{selected: true, Status: 1, isMyFavorite: true}',
                                                        visible: true, requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'},confirmationAction: 'ACTIONS.DELETE'},
                                                    { id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateUserFavoritesStatus', disabled: '{selected: true, Status: 0, isMyFavorite: true}',
                                                        visible: true, requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
                                                  ],},
                privileges: {
                  list    : 'GetMyUserFavorites',
                  details : 'GetUserFavoriteDetails'
                }
          }
      };


    function getFavorites(generalProperties, model, catalogId) {
      if (angular.isDefined(model)) { // to skip this part for load lookup
        model.isBulkActionCompleted = false;
      }
      var promise;

      if (angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
        var state = {};
        state.name = $state.current.name;
        state.params = $state.params;
        var isBulk = true;
        var logData = activityLogger.createLogData(null, state, 'catalog.favorites', 'VIEW', isBulk, new Date(), null, null);

        promise = api.webGet(api.baseUrl + '/catalogs/' + catalogId + '/myfavorites', undefined, true, generalProperties.forceFetch);
        promise = activityLogger.log(logData, promise);
      }
      else {
        if (angular.isUndefined(catalogId)) {
          catalogId = catalogFactory.getActiveCatalog().CatalogCode;
        }
        promise = api.webGet(api.baseUrl + '/catalogs/' + catalogId + '/myfavorites', undefined, true, generalProperties.forceFetch);
      }

      promise.then(function (response) {
        if(response.data && response.data.length > 0) {
          angular.forEach(response.data, function(response) {
            if((response.CreatedBy === $localStorage.UserId) || (angular.isDefined($localStorage.account) && $localStorage.account.accountType == 1)) {
              response.isMyFavorite = true;
            } else {
              response.isMyFavorite = false;
            }
          });
        }

        if (api.catalog.favorites.isDirty) {
          //Invalidate lookupData
          api.catalog.favorites.lookupData = undefined;
          api.catalog.favorites.isDirty = false;
        }
      });
      return promise;
    }

    function getFavorite(isLogRequired, favoriteId, catalogId) {
      var promise;
      if (angular.isDefined(isLogRequired) && isLogRequired === true) {
        var state = {};
        state.name = $state.current.name;
        state.params = $state.params;
        var isBulk = false;
        var items = [];
        promise = api.webGet(api.baseUrl + '/catalogs/' + catalogId + '/favorites/' + favoriteId, undefined, true, true);
        promise.then(function (response) {
          items.push(response.data[api.catalog.favorites.lookupDisplayField]);
        });
        var logData = activityLogger.createLogData(items, state, 'catalog.favorites', 'VIEW', isBulk, new Date(), null, null);
        promise = activityLogger.log(logData, promise);
      }
      else {
        promise = api.webGet(api.baseUrl + '/catalogs/' + catalogId + '/favorites/' + favoriteId, undefined, true, true);
      }

      promise.then(function (response) {
        if(response.data) {
            // enable edit and delete for admin users
            if((response.data.CreatedBy === $localStorage.UserId) || (angular.isDefined($localStorage.account) && $localStorage.account.accountType == 1)) {
              response.data.isMyFavorite = true;
            } else {
              response.data.isMyFavorite = false;
            }
        }
      });

      return promise;
    }

    function create(record, catalogId) {
      var state = {};
      state.name = $state.current.name;
      state.params = $state.params;
      var logData = activityLogger.createLogData(record[api.catalog.favorites.lookupDisplayField], state, 'catalog.favorites', 'ADD', false, new Date(), null, null);
      var promise = api.webPost(api.baseUrl + '/catalogs/' + catalogId + '/favorites', record);

      promise.then(function () {
        api.catalog.favorites.isDirty = true;
      });
      return activityLogger.log(logData, promise);
    }

    function update(favoriteId, record, catalogId) {
      var state = {};
      state.name = $state.current.name;
      state.params = $state.params;
      var logData = activityLogger.createLogData(record[api.catalog.favorites.lookupDisplayField], state, 'catalog.favorites', 'EDIT', false, new Date(), null, null);
      var promise = api.webPut(api.baseUrl + '/catalogs/' + catalogId + '/favorites/' + favoriteId, record);

      promise.then(function () {
        api.catalog.favorites.isDirty = true;
      });
      return activityLogger.log(logData, promise);
    }

    function activate(records, model, actionType, parentId) {
      var result = crud.createRequestObject(records, model, actionType);
      var state = {};
      state.name = $state.current.name;
      state.params = $state.params;
      var isBulk = result.itemsNameList.length > 1 ? true : false;
      var logData = activityLogger.createLogData(result.itemsNameList, state, 'catalog.favorites', actionType.toUpperCase(), isBulk, new Date(), null, null);
      var promise = api.webPut(api.baseUrl + '/catalogs/' + parentId + '/favorites/status', result.requestObj);

      promise.then(function () {
        crud.onRecordStatusChange(records, api.catalog.favorites, actionType);// it should be base model for dynamic models since base model isDirty is being change in all actions
      });

      return activityLogger.log(logData, promise);
    }
  }
})();
(function () {
	'use strict';

	angular
		.module('app.main.catalogs.dune-images')
		.run(runBlock);

	/* @ngInject */
	function runBlock(api, activityLogger, $state, crud, mockFactory, utility, $http, jobsTracker) {

		if (angular.isUndefined(api.catalogs)) {
			api.catalogs = {};
		}
		api.catalogs.t1Dune = {
			modelPath: 'catalogs.t1Dune',
			fields: [
					{ field: 'Id', type: 'text', displayLabel: 'T1_DUNE.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'text',
							validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
					{ field: 'ImageSet', type: 'text', displayLabel: 'T1_DUNE.FIELDS.IMAGE_SET', visible: true, creatable: false, editable: false, inputType: 'text',
							validation: {isRequired: true, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
					{ field: 'ContextId', type: 'text', displayLabel: 'T1_DUNE.FIELDS.CONTEXT_ID', visible: true, creatable: false, editable: false, inputType: 'text',
							validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
					{ field: 'Key', type: 'text', displayLabel: 'T1_DUNE.FIELDS.KEY', visible: true, creatable: false, editable: false, inputType: 'text',
							validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
					{ field: 'FileName', type: 'text', displayLabel: 'T1_DUNE.FIELDS.FILE_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
							validation: {isRequired: true, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
					{ field: 'FilePath', type: 'text', displayLabel: 'T1_DUNE.FIELDS.FILE_PATH', visible: true, creatable: false, editable: false, inputType: 'text',
							validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
					{ field: 'SortOrder', type: 'int', displayLabel: 'T1_DUNE.FIELDS.SORT_ORDER', visible: true, creatable: false, editable: false, inputType: 'number',
							validation: {isRequired: true, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
					{ field: 'Status', type: 'text', displayLabel: 'T1_DUNE.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'bool',
							validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
					{ field: 'AssetHash', type: 'text', displayLabel: 'T1_DUNE.FIELDS.ASSET_HASH', visible: true, creatable: false, editable: false, inputType: 'text',
							validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
					{ field: 'ReferenceAssetId', type: 'text', displayLabel: 'T1_DUNE.FIELDS.REF_ASSET_ID', visible: true, creatable: false, editable: false, inputType: 'text',
							validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
					{ field: 'Format', type: 'text', displayLabel: 'T1_DUNE.FIELDS.FORMAT', visible: true, creatable: false, editable: false, inputType: 'text',
							validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
					{ field: 'Width', type: 'int', displayLabel: 'T1_DUNE.FIELDS.WIDTH', visible: true, creatable: false, editable: false, inputType: 'number',
							validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
					{ field: 'Height', type: 'int', displayLabel: 'T1_DUNE.FIELDS.HEIGHT', visible: true, creatable: false, editable: false, inputType: 'number',
							validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
					{ field: 'Density', type: 'int', displayLabel: 'T1_DUNE.FIELDS.DENSITY', visible: true, creatable: false, editable: false, inputType: 'number',
							validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
					{ field: 'Size', type: 'text', displayLabel: 'T1_DUNE.FIELDS.SIZE', visible: true, creatable: false, editable: false, inputType: 'text',
							validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
					{ field: 'StorageFile', type: 'text', displayLabel: 'T1_DUNE.FIELDS.STORAGE_FILE', visible: true, creatable: false, editable: false, inputType: 'text',
							validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
					{ field: 'CreatedOn', type: 'text', displayLabel: 'T1_DUNE.FIELDS.CREATED_ON', visible: true, creatable: false, editable: false, inputType: 'date',
							validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
					{ field: 'UpdatedOn', type: 'text', displayLabel: 'T1_DUNE.FIELDS.UPDATED_ON', visible: true, creatable: false, editable: false, inputType: 'date',
							validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
					{ field: 'CreatedBy', type: 'text', displayLabel: 'T1_DUNE.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'text',
							validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
					{ field: 'UpdatedBy', type: 'text', displayLabel: 'T1_DUNE.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'text',
							validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
					{ field: 'AssetTypeId', type: 'text', displayLabel: 'T1_DUNE.FIELDS.ASSET_TYPE', visible: false, creatable: false, editable: false, inputType: 'text',
							validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
					{ field: 'AssetTypeName', type: 'text', displayLabel: 'T1_DUNE.FIELDS.ASSET_TYPE', visible: true, creatable: false, editable: false, inputType: 'text',
							validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
					// tags
					{ field: 'Tag', type: 'text', displayLabel: 'T1_DUNE.FIELDS.TAG', visible: false, creatable: true, editable: false, inputType: 'text',
							validation: {isRequired: true, maxLen: 25, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
					{ field: 'Tags', type: 'text', displayLabel: 'T1_DUNE.FIELDS.TAGS', visible: true, creatable: false, editable: true, inputType: 'array-tags', tagSeparator: ',',
							validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
			],
			uniqueConstraints: [
				{name: 'Constraint 1', fields: ['ImageSet', 'FileName']}
			],
			title: 'T1_DUNE.NAV',
			icon: 'icon-image-filter',
			idField: 'Id',
			lookupDisplayField: 'Id',
			isBulkActionCompleted: false,
			isDirty: false,
			isCatalogSpecificModel: true,
			methods: {
					getList             :   getImages,
					getDetails          :   getImageDetails,
					create              :   createImage,
					update              :   updateImage,
					activateBulk        :   activateImages,
					downloadDuneImage   :   downloadDuneImage,
					getListByFilter     :   getImagesByFilter,
					queryAssets         :   queryAssets,
					assignTag           :   assignTag,
					removeTag           :   removeTag,
					updateBulkSortOrder :   updateBulkSortOrder,
				    getAssetTypes       :   getAssetTypes
			},
			views: {
					mainList: {
							columns         : [ 'Id', 'ImageSet', 'ContextId', 'Key', 'FilePath', 'FileName', 'SortOrder', 'AssetTypeName', 'Status', 'UpdatedOn' ],
							columnFilter    : {},
							imagesSize      : 'large',
							topIndex        : 0,
							showFilterRow   : false,
							sortColumn      : {'UpdatedOn': false},
							itemActions     : [
																	{ id: 'view', label: 'ACTIONS.VIEW', icon: 'icon-magnify', privilege: 'UI_T1DuneReadAccess:true', disabled: '!itm.Status', visible: true },
																	{ id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UI_T1DuneReadWriteAccess:true', disabled: '!itm.Status', visible: true },
																	{ id: 'editSortOrder', label: 'T1_DUNE.ACTIONS.EDIT_SORTORDER', icon: 'icon-pencil', privilege: 'UI_T1DuneReadWriteAccess:true', disabled: '!itm.Status', visible: true },
																	{ id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UI_T1DuneReadWriteAccess:true', disabled: false, visible: 'itm.Status',
																			requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
																	{ id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UI_T1DuneReadWriteAccess:true', disabled: false, visible: '!itm.Status',
																			requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'},
																	{ id: 'assignTag', label: 'T1_DUNE.ACTIONS.ASSIGN_TAG', icon: 'icon-bookmark', privilege: 'UI_T1DuneReadWriteAccess:true', disabled: false, visible: true },
																	{ id: 'removeTag', label: 'T1_DUNE.ACTIONS.REMOVE_TAG', icon: 'icon-bookmark-remove', privilege: 'UI_T1DuneReadWriteAccess:true', disabled: false, visible: true }
																],
							listActions     : [
																	{ id: 'delete', label: 'ACTIONS.DELETE_BULK', icon: 'icon-delete', privilege: 'UI_T1DuneReadWriteAccess:true', disabled: '{selected: true, Status: true}', visible: true,
																			requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
																	{ id: 'activate', label: 'ACTIONS.ACTIVATE_BULK', icon: 'icon-undo-variant', privilege: 'UI_T1DuneReadWriteAccess:true', disabled: '{selected: true, Status: false}', visible: true,
																			requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'},
																	{ id: 'updateBulkSortOrder', label: 'T1_DUNE.ACTIONS.UPADATE_SORTORDER_BULK', icon: 'icon-import', privilege: 'UI_T1DuneReadWriteAccess:true', disabled: false, visible: true, requiresConfirmation: false },
																	{ id: 'assignTag', label: 'T1_DUNE.ACTIONS.ASSIGN_TAG_BULK', icon: 'icon-bookmark', privilege: 'UI_T1DuneReadWriteAccess:true', disabled: '{selected: true}', visible: true, requiresConfirmation: false},
																	{ id: 'removeTag', label: 'T1_DUNE.ACTIONS.REMOVE_TAG_BULK', icon: 'icon-bookmark-remove', privilege: 'UI_T1DuneReadWriteAccess:true', disabled: '{selected: true}', visible: true, requiresConfirmation: false}
																],
							fabAction       : {id: 'add', label: 'ACTIONS.ADD', icon: 'icon-plus', privilege: 'UI_T1DuneReadWriteAccess:true', visible: true}
					 },
					 mainDetails: {
							 selectedTabIndex   : 0,
							 itemActions        : [
																		{ id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UI_T1DuneReadWriteAccess:true', disabled: '{selected: true, Status: true}', visible: true,
																				requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
																		{ id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UI_T1DuneReadWriteAccess:true', disabled: '{selected: true, Status: false}', visible: true,
																				requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'},
																		{ id: 'assignTag', label: 'T1_DUNE.ACTIONS.ASSIGN_TAG', icon: 'icon-bookmark', privilege: 'UI_T1DuneReadWriteAccess:true', disabled: false, visible: true },
																		{ id: 'removeTag', label: 'T1_DUNE.ACTIONS.REMOVE_TAG', icon: 'icon-bookmark-remove', privilege: 'UI_T1DuneReadWriteAccess:true', disabled: false, visible: true }
							 ],
							 fab                 : {id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UI_T1DuneReadWriteAccess:true', visible: true}

					 },
					privileges: {
							list    : 'UI_T1DuneReadAccess',
							details : 'UI_T1DuneReadAccess'
					}
				}
		};

		function getImages(generalProperties, model, params) {
			if (angular.isDefined(model)) { // to skip this part for load lookup
				model.isBulkActionCompleted = false;
			}
			var promise;

			var isPaginated = angular.isDefined(params.page) && angular.isDefined(params.pageSize);
			var url = api.t1DuneBaseUrl + '/assets?Context=' + params.Context + '&ContextKey=' + params.ContextKey;
			if (isPaginated) {
				url += '&page=' + params.page + '&pageSize=' + params.pageSize;
			}

			// For paginated requests skip caching to get clean responses (with headers)
			var useCache = !isPaginated;
			var useIncremental = !isPaginated && (generalProperties.supportIncrementalResult || true);
			var modelForCache = isPaginated ? undefined : (model || api.catalogs.t1Dune);

			if (angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
				var state = {};
				state.name = $state.current.name;
				state.params = $state.params;
				var isBulk = true;
				var logData = activityLogger.createLogData(null, state, 'catalogs.t1Dune', 'VIEW', isBulk, new Date(), null, null);

				promise = api.webGet(url,
					generalProperties.config || {}, useCache, generalProperties.forceFetch,
					useIncremental,
					generalProperties.modelIdField,
					generalProperties.isMajor || false,
					modelForCache);
					promise = activityLogger.log(logData, promise);
			}
			else {
				promise = api.webGet(url,
					generalProperties.config || {}, useCache, generalProperties.forceFetch,
					useIncremental,
					generalProperties.modelIdField,
					generalProperties.isMajor || false,
					modelForCache);
			}

			promise.then(function () {
				if (api.catalogs.t1Dune.isDirty) {
					//Invalidate lookupData
					api.catalogs.t1Dune.lookupData = undefined;
					api.catalogs.t1Dune.isDirty = false;
				}
			});
			return promise;
		}

		function getImageDetails(isLogRequired, imageId, assignedContextKey) {
			var promise;
			if (angular.isDefined(isLogRequired) && isLogRequired === true) {
				var state = {};
				state.name = $state.current.name;
				state.params = $state.params;
				var isBulk = false;
				var items = [];
				promise = api.webGet(api.t1DuneBaseUrl + '/assets/' + imageId + '?ContextKey=' + assignedContextKey, undefined, true, true);
				var logData = activityLogger.createLogData(items, state, 'catalogs.t1Dune', 'VIEW', isBulk, new Date(), null, null);
				promise = activityLogger.log(logData, promise);
			}
			else {
				promise = api.webGet(api.t1DuneBaseUrl + '/assets/' + imageId + '?ContextKey=' + assignedContextKey, undefined, true, true);
			}
			return promise;
		}

		function createImage(record) {
			var fd = new FormData();
			for(var key in record) {
				fd.append(key, record[key]);
			}
			var state = {};
			state.name = $state.current.name;
			state.params = $state.params;
			var logData = activityLogger.createLogData(record[api.catalogs.t1Dune.lookupDisplayField], state, 'catalogs.t1Dune', 'ADD', false, new Date(), null, null);
			var promise = $http.post(api.t1DuneBaseUrl + '/assets', fd, {
				transformRequest : angular.identity,
				headers: {
					'Content-Type': undefined
				}
			});
			promise.then(function () {
				api.catalogs.t1Dune.isDirty = true;
			});
			return activityLogger.log(logData, promise);
		}

		function updateImage(recordId, record) {
			var state = {};
			state.name = $state.current.name;
			state.params = $state.params;
			var logData = activityLogger.createLogData(record[api.catalogs.t1Dune.lookupDisplayField], state, 'catalogs.t1Dune', 'EDIT', false, new Date(), null, null);
			var promise;
			// If the image file was replaced, send as FormData (multipart) via POST like createImage does
			if(record.file) {
				var fd = new FormData();
				for(var key in record) {
					if(record[key] !== null && record[key] !== undefined && !angular.isArray(record[key])) {
						fd.append(key, record[key]);
					}
				}
				promise = $http.post(api.t1DuneBaseUrl + '/assets', fd, {
					transformRequest : angular.identity,
					headers: {
						'Content-Type': undefined
					}
				});
			} else {
				promise = api.webPut(api.t1DuneBaseUrl + '/assets/' + recordId, record);
			}

			promise.then(function () {
				api.catalogs.t1Dune.isDirty = true;
			});
			return activityLogger.log(logData, promise);
		}

		function activateImages(records, model, actionType, contextKey) {
			var result = crud.createDuneRequestObject(records, model, actionType, contextKey);

			var state = {};
			state.name = $state.current.name;
			state.params = $state.params;
			var isBulk = result.requestObj.length > 1 ? true : false;
			var logData = activityLogger.createLogData(result.itemsNameList, state, 'catalogs.t1Dune', actionType.toUpperCase(), isBulk, new Date(), null, null);
			var promise = api.webPut(api.t1DuneBaseUrl + '/assets/status', result.requestObj);
			promise.then(function () {
				crud.onDuneRecordStatusChange(records, model, actionType);
			});

			return activityLogger.log(logData, promise);
		}

		function downloadDuneImage(assetStorageFile, contextKey) {
			// download dune images with large image view width and height
			// response is coming as raw binary data buffer so converting it to base64 string and the response content type and sending it to UI
			var largeImagesSize = mockFactory.getSupportedImageSizes().large;
			return api.webGet(api.t1DuneAssetDownloadBaseUrl + '/assets/content/' + assetStorageFile +'?ContextKey='+ contextKey + '&w=' + largeImagesSize.imgWidth +
			'&h=' + largeImagesSize.imgHeight + '&trim=0&f=webp', {responseType: 'arraybuffer'}).then(function(response) {
				var contentType = response.headers()['content-type'];
				var dataUrl =  utility.arrayBufferToBase64(response.data);
				var imageDataUrl = {
					contentType: 'data:'+ contentType +';base64',
					imageDataUri: dataUrl
				};
				return imageDataUrl;
			});
		}

		// this method will pass all the articles numbers of the catalogs as array of string
		function getImagesByFilter(generalProperties, model, requestObj) {
			if (angular.isDefined(model)) { // to skip this part for load lookup
				model.isBulkActionCompleted = false;
			}

			var promise = api.webPost(api.t1DuneBaseUrl + '/assets/q', requestObj,
					generalProperties.config || {}, generalProperties.cache || false,
					generalProperties.supportIncrementalResult || false,
					generalProperties.modelIdField,
					generalProperties.isMajor || false,
					model || api.catalogs.t1Dune);

			promise.then(function () {
				if (api.catalogs.t1Dune.isDirty) {
					//Invalidate lookupData
					api.catalogs.t1Dune.lookupData = undefined;
					api.catalogs.t1Dune.isDirty = false;
				}
			});
			return promise;
		}

		function assignTag(record) {
			var state = {};
			state.name = $state.current.name;
			state.params = $state.params;
			var logData = activityLogger.createLogData(record[api.catalogs.t1Dune.lookupDisplayField], state, 'catalogs.t1Dune', 'ADD', false, new Date(), null, null);
			var promise = api.webPut(api.t1DuneBaseUrl + '/assets/tags/assign', record);

			promise.then(function () {
				api.catalogs.t1Dune.isDirty = true;
			});
			return activityLogger.log(logData, promise);
		}

		function removeTag(record) {
			var state = {};
			state.name = $state.current.name;
			state.params = $state.params;
			var logData = activityLogger.createLogData(record[api.catalogs.t1Dune.lookupDisplayField], state, 'catalogs.t1Dune', 'DELETE', false, new Date(), null, null);
			var promise = api.webPut(api.t1DuneBaseUrl + '/assets/tags/remove', record);

			promise.then(function () {
				api.catalogs.t1Dune.isDirty = true;
			});
			return activityLogger.log(logData, promise);
		}


		function updateBulkSortOrder(data, context, contextKey) {
			// add context and contextKey in the request
			var requestObject = {
				Context : context,
				ContextKey : contextKey,
				Images: data
			}

			var state = {};
			state.name = $state.current.name;
			state.params = $state.params;
			var logData = activityLogger.createLogData(null, state, 'catalogs.t1Dune', 'EDIT', false, new Date(), null, null);
			var promise = api.webPut(api.t1DuneBaseUrl + '/assets/sortorders', requestObject);

			promise.then(function () {
				api.catalogs.t1Dune.isDirty = true;
			});
			return activityLogger.log(logData, promise);
		}

		function getAssetTypes(context, contextKey) {
			return api.webGet(api.t1DuneBaseUrl + '/asset-types?Context=' + context + '&ContextKey=' + contextKey, undefined, true, true);
		}

		function queryAssets(requestBody) {
			var promise = $http.post(api.t1DuneBaseUrl + '/assets/qa', requestBody);
			promise.then(function () {
				if (api.catalogs.t1Dune.isDirty) {
					api.catalogs.t1Dune.lookupData = undefined;
					api.catalogs.t1Dune.isDirty = false;
				}
			});
			return promise;
		}

	}
})();
(function () {
	'use strict';

	angular
		.module('app.main.catalogs.dune-images')
		.factory('duneImagesPaginationCache', duneImagesPaginationCache);

	/* @ngInject */
	function duneImagesPaginationCache() {
		var cache = null;

		var service = {
			save: save,
			get: get,
			clear: clear,
			hasCachedState: hasCachedState
		};
		return service;

		/**
		 * Save pagination state before navigating to details.
		 * @param {Object} state
		 * @param {Object} state.pagesMap - Map of pageIndex -> items[]
		 * @param {number} state.currentPage - Last loaded page index
		 * @param {number} state.clickedPage - Page index of the clicked item
		 * @param {number} state.topIndex - Scroll position (virtual repeat top index)
		 * @param {number} state.totalCount - Total records count from API
		 * @param {boolean} state.hasMorePages - Whether more pages are available
		 */
		function save(state) {
			cache = angular.copy(state);
		}

		function get() {
			return cache;
		}

		function clear() {
			cache = null;
		}

		function hasCachedState() {
			return cache !== null;
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('app.main.catalog-customers.segmentation-linear')
		.run(runBlock);

	/* @ngInject */
	function runBlock(api, activityLogger, $state, jobsTracker, catalogFactory, CONSTANTS) {

		if (angular.isUndefined(api.catalogCustomers)) {
				api.catalogCustomers = {};
		}
		api.catalogCustomers.segmentationLinear = {
				modelPath: 'catalogCustomers.segmentationLinear',
				fields: [
						{ field: 'CustomerId', type: 'int', displayLabel: 'CUSTOMERS_SEGMENTATION_LINEAR.FIELDS.ID', visible: false, creatable: false, editable: false, inputType: 'number',
								validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
						{ field: 'CustomerNumber', type: 'text', displayLabel: 'CUSTOMERS_SEGMENTATION_LINEAR.FIELDS.CUSTOMER_NUMBER', visible: true, creatable: true, editable: false, inputType: 'text',
								validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
						{ field: 'DPAccountGroup', type: 'text', displayLabel: 'CUSTOMERS_SEGMENTATION_LINEAR.FIELDS.DP_ACCOUNT_GROUP', visible: false, creatable: false, editable: false, inputType: 'text',
								validation: {isRequired: false, maxLen: 500, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
						{ field: 'CustomerName', type: 'text', displayLabel: 'CUSTOMERS_SEGMENTATION_LINEAR.FIELDS.CUSTOMER_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
								validation: {isRequired: false, maxLen: 100, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
						{ field: 'SegmentationId', type: 'int', displayLabel: 'CUSTOMERS_SEGMENTATION_LINEAR.FIELDS.SEGMENTATION_NAME', visible: true, creatable: false, editable: true, inputType: 'lookup', lookupSource: 'catalogs.segmentations',
								validation: {isRequired: false, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
						{ field: 'SegmentationName', type: 'text', displayLabel: 'CUSTOMERS_SEGMENTATION_LINEAR.FIELDS.SEGMENTATION_NAME', visible: false, creatable: true, editable: true, inputType: 'text',
								validation: {isRequired: true, maxLen: 100, minLen: 1, pattern: '^[^!*]+$', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: 'VALIDATIONS.INVALID_CHARACTER'}} },
						{ field: 'CreatedDate', type: 'text', displayLabel: 'CUSTOMERS_SEGMENTATION_LINEAR.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
								validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
						{ field: 'UpdatedDate', type: 'text', displayLabel: 'CUSTOMERS_SEGMENTATION_LINEAR.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
								validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
						{ field: 'Status', type: 'text', displayLabel: 'CUSTOMERS_SEGMENTATION_LINEAR.FIELDS.STATUS', visible: true, creatable: true, editable: false, inputType: 'status',
							validation: { isRequired: true, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
				],
				uniqueConstraints: [],
				title: 'CUSTOMERS_SEGMENTATION_LINEAR.NAV',
				icon: 'icon-account-key',
				idField: 'CustomerId',
				lookupDisplayField: '',
				isDirty: false,
				isBulkActionCompleted: false,
				isCatalogSpecificModel: true,
				methods: {
						getList     : getSegmentation,
						createBulk  : createBulk,
						updateBulk  : updateBulk, // used for assigning segmentations
						activateBulk: activateSegmentation
				},
				views: {
						mainList: {
								columns         : [ 'CustomerId', 'CustomerNumber', 'CustomerName', 'SegmentationId', 'Status', 'CreatedDate', 'UpdatedDate'],
								columnFilter    : {},
								topIndex        : 0,
								showFilterRow   : false,
								sortColumn      : {'UpdatedDate': false},
								itemActions     : [
																		{ id: 'view', label: 'ACTIONS.VIEW', icon: 'icon-magnify', privilege: 'GetSellerCustomerSegmentations', disabled: false, visible: true },
																		{ id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateCustomerSegmentationStatusBulk:true', disabled: false, visible: 'itm.Status',
																			requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
																	],
								listActions     : [
																		{ id: 'import', label: 'ACTIONS.IMPORT', icon: 'icon-import', privilege: 'UpdateCatalogBulkCustomersSegmentations:true', disabled: false, visible: true, requiresConfirmation: false } ],
								fabAction       : { id: 'add', label: 'ACTIONS.ADD', icon: 'icon-link', privilege: 'UpdateCatalogBulkCustomersSegmentations:true', visible: true }
						},
						mainDetails: {},
						privileges: {
								list    : 'GetSellerCatalogBulkCustomerSegmentations'
						}
				}
		};

		function getSegmentation(generalProperties, model, catalogId, sellerId) {
			if (angular.isDefined(model)) { // to skip this part for load lookup
				model.isBulkActionCompleted = false;
			}
			var promise;

			if (angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
				var state = {};
				state.name = $state.current.name;
				state.params = $state.params;
				var isBulk = true;
				var logData = activityLogger.createLogData(null, state, 'catalogCustomers.segmentation', 'VIEW', isBulk, new Date(), null, null);

				promise = api.webGet(api.baseUrl + '/sellers/' + sellerId + '/catalogs/' + catalogId + '/customerSegmentations', undefined, true, generalProperties.forceFetch);
				promise = activityLogger.log(logData, promise);
			}
			else {
				if (angular.isUndefined(catalogId) || angular.isUndefined(sellerId)) {
					var activeCatalog = catalogFactory.getActiveCatalog();
					sellerId = activeCatalog.AccountId;
					catalogId = activeCatalog.CatalogCode;
				}
				promise = api.webGet(api.baseUrl + '/sellers/' + sellerId + '/catalogs/' + catalogId + '/customerSegmentations', undefined, true, generalProperties.forceFetch);
			}

			promise.then(function () {
				if (api.catalogCustomers.segmentationLinear.isDirty) {
					//Invalidate lookupData
					api.catalogCustomers.segmentationLinear.lookupData = undefined;
					api.catalogCustomers.segmentationLinear.isDirty = false;
				}
			});
			return promise;
		}

		function createBulk(data, catalogId, model) {
			var secondaryModel = api.catalogCustomers.segmentation; // when customers segmentation updated from linear module make tabular module model dirty
			//Transform data into required format
			var transformedData = [];
			var nameIndexes = {};
			var itemsNameList = [];
			for (var i = 0; i < data.length; i++) {
				var ind = -1;
				if (angular.isUndefined(nameIndexes[data[i].CustomerNumber.toUpperCase()])) {
					var requestObj = { 'CustomerNumber': data[i].CustomerNumber, 'Segmentations': [] };
					ind = transformedData.length;
					nameIndexes[data[i].CustomerNumber.toUpperCase()] = ind;
					transformedData.push(requestObj);
					itemsNameList.push(data[i].CustomerNumber);
				} else {
					ind = nameIndexes[data[i].CustomerNumber.toUpperCase()];
				}
				var segmentationInfoMap = { SID: data[i].SegmentationName, S: 0 };
				if (data[i].SegmentationName && data[i].Status) {
					segmentationInfoMap.S = 1;
				}
				transformedData[ind].Segmentations.push(segmentationInfoMap);
			}
			nameIndexes = undefined;
			var jobIndex = jobsTracker.addJob(model, 'CUSTOMERS_SEGMENTATION_LINEAR.ACTIONS.IMPORT_SEGMENTATIONS', 1, secondaryModel);
				api.webPut(api.baseUrl + '/catalogs/' + catalogId + '/customersSegmentations?sourceapplication=' + CONSTANTS.SOURCE_APPLICATION + '&sourceaction=Import Customer Segmentations', transformedData).then(function (response) {
					jobsTracker.trackJob(jobIndex, response.data.Id);
				}).catch(function (error) {
				jobsTracker.setCriticlaFail(jobIndex, error);
			});
		}

		function updateBulk(records, model) {
			var catalogId = catalogFactory.getActiveCatalog().CatalogCode;
			var secondaryModel = api.catalogCustomers.segmentation; // when customers segmentation updated from linear module make tabular module model dirty
			//Transform data into required format
			var transformedData = [];
			for (var i = 0; i < records.CustomerNumber.length; i++) {
				var customerSegmentations = {
					CustomerNumber: records.CustomerNumber[i],
					Segmentations: []
				}
				for (var j = 0; j < records.SegmentationId.length; j++) {
					var segmentationInfoMap = { SID: records.SegmentationId[j], S: 0 };
					if (records.SegmentationId[j]) {
						segmentationInfoMap.S = 1;
					}
					customerSegmentations.Segmentations.push(segmentationInfoMap);
				}
				transformedData.push(customerSegmentations);
			}

			var jobIndex = jobsTracker.addJob(model, 'CUSTOMERS_SEGMENTATION_LINEAR.ACTIONS.UPDATE_SEGMENTATIONS', 1, secondaryModel);
			api.webPut(api.baseUrl + '/catalogs/' + catalogId + '/customersSegmentations?sourceapplication=' + CONSTANTS.SOURCE_APPLICATION + '&sourceaction=Update Customer Segmentations', transformedData).then(function (response) {
				jobsTracker.trackJob(jobIndex, response.data.Id);
			}).catch(function (error) {
				jobsTracker.setCriticlaFail(jobIndex, error);
			});
		}

		function activateSegmentation(record, model, actionType, sellerId, catalogId, customerId) {
			var requestObj = [{
				SegmentationId: record.SegmentationId,
				status: 0
			}];
			var state = {};
			state.name = $state.current.name;
			state.params = $state.params;
			var isBulk = false;
			var logData = activityLogger.createLogData(record, state, 'customers.segmentations', actionType.toUpperCase(), isBulk, new Date(), null, null);
			var promise = api.webPut(api.baseUrl + '/sellers/' + sellerId + '/catalogs/' + catalogId + '/customers/' + customerId + '/customersegmentations/status', requestObj);

			promise.then(function () {
				api.catalogCustomers.segmentationLinear.isDirty = true;
				api.catalogCustomers.segmentation.isDirty = true;
			});

			return activityLogger.log(logData, promise);
		}

	}
})();
(function() {
    'use strict';

    angular
        .module('app.main.catalog-customers.segmentation')
        .run(runBlock);

    /* @ngInject */
    function runBlock(api, activityLogger, $state, jobsTracker, catalogFactory, CONSTANTS) {

        if (angular.isUndefined(api.catalogCustomers)) {
            api.catalogCustomers = {};
        }
         api.catalogCustomers.segmentation = {
            modelPath: 'catalogCustomers.segmentation',
            fields: [
                { field: 'Id', map:'Id', type: 'int', displayLabel: 'CUSTOMERS_SEGMENTATION.FIELDS.ID', visible: false, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CustomerNumber', map: 'CustomerNumber', type: 'text', displayLabel: 'CUSTOMERS_SEGMENTATION.FIELDS.CUSTOMER_NUMBER', visible: true, creatable: true, editable: false, inputType: 'text',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'LastUpdatedOn', map: 'LastUpdatedOn', type: 'date', displayLabel: 'CUSTOMERS_SEGMENTATION.FIELDS.LAST_UPDATED_ON', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: ''}},
                { field: 'DPAccountGroup', map: 'DPAccountGroup', type: 'text', displayLabel: 'CUSTOMERS_SEGMENTATION.FIELDS.DP_ACCOUNT_GROUP', visible: false, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: 500, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CustomerName', map: 'CustomerName', type: 'text', displayLabel: 'CUSTOMERS_SEGMENTATION.FIELDS.CUSTOMER_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: 100, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
            ],
            uniqueConstraints: [
                {name: 'Constraint 1', fields: [ 'CustomerNumber' ]}
            ],
            title: 'CUSTOMERS_SEGMENTATION.NAV',
            icon: 'icon-account-key',
            idField: 'Id',
            lookupDisplayField: '',
            isDirty: false,
            isBulkActionCompleted: false,
            isCatalogSpecificModel: true,
            methods: {
                getList     : getSegmentation,
                createBulk  : createBulk,
                updateBulk  : updateBulk
            },
            views: {
                mainList: {
                    columns         : [ 'CustomerNumber', 'CustomerName', 'LastUpdatedOn'],
                    columnFilter    : {},
                    topIndex        : 0,
                    showFilterRow   : false,
                    sortColumn      : {'CustomerNumber': true},
                    itemActions     : [
                                        { id: 'view', label: 'ACTIONS.VIEW', icon: 'icon-magnify', privilege: 'GetSellerCustomerSegmentations', disabled: false, visible: true }
                                      ],
                    listActions     : [
                                        { id: 'updateBulk', label: 'ACTIONS.UPDATE_BULK', icon: 'icon-pencil', privilege: 'UpdateCatalogBulkCustomersSegmentations:true', disabled: '{selected: true}', visible: true, requiresConfirmation: false },
                                        { id: 'import', label: 'ACTIONS.IMPORT', icon: 'icon-import', privilege: 'UpdateCatalogBulkCustomersSegmentations:true', disabled: false, visible: true, requiresConfirmation: false } ],
                    fabAction       : {}

                 },
                 mainDetails: {},
                privileges: {
                    list    : 'GetSellerCatalogBulkCustomerSegmentations'
                }
            }
        };


        function getSegmentation(generalProperties, model, catalogId, sellerId) {
            if(angular.isDefined(model)) { // to skip this part for load lookup
                model.isBulkActionCompleted = false;
            }
            var promise;

            if(angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
                var state = {};
                state.name = $state.current.name;
                state.params = $state.params;
                var isBulk = true;
                var logData = activityLogger.createLogData(null, state, 'catalogCustomers.segmentation', 'VIEW', isBulk, new Date(), null, null);

                promise = api.webGet(api.baseUrl + '/sellers/' + sellerId + '/catalogs/' + catalogId + '/customerSegmentations', undefined, true, generalProperties.forceFetch);
                promise = activityLogger.log(logData, promise);
            }
            else {
                if(angular.isUndefined(catalogId) || angular.isUndefined(sellerId)) {
                    var activeCatalog = catalogFactory.getActiveCatalog();
                    sellerId = activeCatalog.AccountId;
                    catalogId = activeCatalog.CatalogCode;
                }
                promise = api.webGet(api.baseUrl + '/sellers/' + sellerId + '/catalogs/' + catalogId + '/customerSegmentations', undefined, true, generalProperties.forceFetch);
            }

            promise.then(function() {
                if (api.catalogCustomers.segmentation.isDirty) {
                    //Invalidate lookupData
                    api.catalogCustomers.segmentation.lookupData = undefined;
                    api.catalogCustomers.segmentation.isDirty = false;
                }
            });
            return promise;
        }

        function createBulk(data, catalogId, model) {
            var secondaryModel = api.catalogCustomers.segmentationLinear; // when customers segmentation updated from tabular module make linear module model dirty
            //Transform data into required format
            var transformedData = [];
            angular.forEach(data, function(element) {
                var newElement = { CustomerNumber: element.CustomerNumber, Segmentations: [] };
                angular.forEach(model.fields, function(field) {
                    var segSheetVal = element[field.field];
                    if (angular.isDefined(segSheetVal)) {
                        if (field.field !== 'Id' && field.field !== 'CustomerId' && field.field !== 'CustomerNumber' && field.field !== 'Name' && field.field !== 'LastUpdatedOn' && field.field !== 'DPAccountGroup' && field.field !== 'CustomerName') {
                            var seg = angular.isDefined(element[field.field]) ? element[field.field].toString().trim().toUpperCase(): '';
                            var segmentationInfoMap = { SID: field.field, S: 0 };
                            if (seg !== '' && seg !== '0' && seg !== 'NO' && seg !== 'FALSE') {
                                segmentationInfoMap.S = 1;
                            }
                            newElement.Segmentations.push(segmentationInfoMap);
                        }
                    }
                });
                transformedData.push(newElement);
            });

            var jobIndex = jobsTracker.addJob(model, 'CUSTOMERS_SEGMENTATION.ACTIONS.IMPORT_SEGMENTATIONS', 1, secondaryModel);
            api.webPut(api.baseUrl + '/catalogs/' + catalogId + '/customersSegmentations?sourceapplication=' + CONSTANTS.SOURCE_APPLICATION + '&sourceaction=Import Customer Segmentations', transformedData).then(function(response) {
                jobsTracker.trackJob(jobIndex, response.data.Id);
            }).catch(function(error) {
                jobsTracker.setCriticlaFail(jobIndex, error);
            });
        }

        function updateBulk(model, records, updateRecord, idMap) {
            //Transform data into required format
            var transformedData = [];
            var secondaryModel = api.catalogCustomers.segmentationLinear; // when customers segmentation updated from tabular module make linear module model dirty
            angular.forEach(records, function(record) {
                var newRecord = { CustomerNumber: record.CustomerNumber, Segmentations: [] };
                angular.forEach(model.fields, function(field) {
                    if(angular.isDefined(updateRecord[field.field])) {
                        if (field.field !== 'Id' && field.field !== 'CustomerId' && field.field !== 'CustomerNumber' && field.field !== 'Name' && field.field !== 'LastUpdatedOn' && field.field !== 'DPAccountGroup' && field.field !== 'CustomerName') {
                            var segmentationInfoMap = { SID: field.field, S: 0 };
                            if( (angular.isDefined(updateRecord[field.field]) && updateRecord[field.field].toUpperCase() === 'YES')
                            || (angular.isUndefined(updateRecord[field.field]) && record[field.field].toUpperCase() === 'YES') ) {
                                segmentationInfoMap.S = 1;
                            }
                            newRecord.Segmentations.push(segmentationInfoMap);
                        }
                    }
                });
                transformedData.push(newRecord);
            });

            var jobIndex = jobsTracker.addJob(model, 'CUSTOMERS_SEGMENTATION.ACTIONS.UPDATE_SEGMENTATIONS', 1, secondaryModel);
            api.webPut(api.baseUrl + '/catalogs/' + idMap.catalogId + '/customersSegmentations?sourceapplication=' + CONSTANTS.SOURCE_APPLICATION + '&sourceaction=Update Customer Segmentations', transformedData).then(function(response) {
                jobsTracker.trackJob(jobIndex, response.data.Id);
            }).catch(function(error) {
                jobsTracker.setCriticlaFail(jobIndex, error);
            });
        }

    }
})();
(function () {
	'use strict';

	angular
		.module('app.main.catalogs.customers-locations')
		.run(runBlock);

	/* @ngInject */
	function runBlock(api, activityLogger, $state, jobsTracker, CONSTANTS) {

		if (angular.isUndefined(api.catalogs)) {
			api.catalogs = {};
		}
		api.catalogs.locations = {
			modelPath: 'catalogs.locations',
			fields: [
				{ field: 'Id', type: 'int', displayLabel: 'CUSTOMERS_LOCATIONS.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
					validation: { isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
				{ field: 'Name', type: 'text', displayLabel: 'CUSTOMERS_LOCATIONS.FIELDS.NAME', visible: true, creatable: true, editable: true, inputType: 'text',
					validation: { isRequired: true, maxLen: 50, minLen: 1, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
				{ field: 'Code', type: 'text', displayLabel: 'CUSTOMERS_LOCATIONS.FIELDS.CODE', visible: true, creatable: true, editable: true, inputType: 'text',
					validation: { isRequired: true, maxLen: 50, minLen: 1, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
				{ field: 'Address', type: 'text', displayLabel: 'CUSTOMERS_LOCATIONS.FIELDS.ADDRESS', visible: true, creatable: true, editable: true, inputType: 'textArea',
					validation: { isRequired: false, maxLen: 100, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
				{ field: 'City', type: 'text', displayLabel: 'CUSTOMERS_LOCATIONS.FIELDS.CITY', visible: true, creatable: true, editable: true, inputType: 'text',
					validation: { isRequired: false, maxLen: 25, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
				{ field: 'State', type: 'text', displayLabel: 'CUSTOMERS_LOCATIONS.FIELDS.STATE', visible: true, creatable: true, editable: true, inputType: 'text',
					validation: { isRequired: false, maxLen: 25, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
				{ field: 'Zip', type: 'text', displayLabel: 'CUSTOMERS_LOCATIONS.FIELDS.ZIP', visible: true, creatable: true, editable: true, inputType: 'text',
					validation: { isRequired: false, maxLen: 7, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
				{ field: 'CountryCode', type: 'text', displayLabel: 'CUSTOMERS_LOCATIONS.FIELDS.COUNTRY', visible: false, creatable: true, editable: true, inputType: 'lookup', lookupSource: 'lists.countries',
					validation: { isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
				{ field: 'CountryCode', type: 'text', displayLabel: 'CUSTOMERS_LOCATIONS.FIELDS.COUNTRY_CODE', visible: true, creatable: false, editable: false, inputType: 'text',
					validation: { isRequired: false, maxLen: -1, minLen: 1, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
				{ field: 'CountryName', type: 'text', displayLabel: 'CUSTOMERS_LOCATIONS.FIELDS.COUNTRY', visible: true, creatable: false, editable: false, inputType: 'text',
					validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
				{ field: 'LocationReference', type: 'text', displayLabel: 'CUSTOMERS_LOCATIONS.FIELDS.LOCATION_REFERENCE', visible: true, creatable: true, editable: true, inputType: 'text',
					validation: { isRequired: false, maxLen: 200, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
				{ field: 'Phone', type: 'text', displayLabel: 'CUSTOMERS_LOCATIONS.FIELDS.PHONE', visible: true, creatable: true, editable: true, inputType: 'text',
					validation: { isRequired: false, maxLen: 15, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
				{ field: 'CreateDate', type: 'text', displayLabel: 'CUSTOMERS_LOCATIONS.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
					validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
				{ field: 'UpdateDate', type: 'text', displayLabel: 'CUSTOMERS_LOCATIONS.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
					validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
				{ field: 'CreatedBy', type: 'text', displayLabel: 'CUSTOMERS_LOCATIONS.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
					validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
				{ field: 'UpdatedBy', type: 'text', displayLabel: 'CUSTOMERS_LOCATIONS.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
					validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
				{ field: 'Status', type: 'text', displayLabel: 'CUSTOMERS_LOCATIONS.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
					validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
				{ field: 'CustomerNumber', type: 'int', displayLabel: 'CUSTOMERS_LOCATIONS.FIELDS.CUSTOMER_NUMBER', visible: true, creatable: true, editable: false, inputType: 'text',
					validation: { isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
				{ field: 'CustomerName', type: 'text', displayLabel: 'CUSTOMERS_LOCATIONS.FIELDS.CUSTOMER_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
					validation: { isRequired: false, maxLen: 100, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
			],
			uniqueConstraints: [],
			title: 'CUSTOMERS_LOCATIONS.NAV',
			idField: 'Id',
			lookupDisplayField: 'Name',
			isDirty: false,
			isCatalogSpecificModel: true,
			methods: {
				getList: getLocations,
				createBulk: createBulk
			},
			views: {
				mainList: {
					columns: ['CustomerNumber', 'CustomerName', 'LocationReference', 'Name', 'Status', 'UpdateDate'],
					columnFilter: {},
					toggleFilterProps: { toggleStatus: false, filterProp: 'Status', trueVal: 1, trueValTooltipMessage: 'ACTIONS.TOGGLE_ACTIVE', falseVal: '', falseValTooltipMessage: "ACTIONS.TOGGLE_ALL" },
					topIndex: 0,
					showFilterRow: false,
					sortColumn: { 'UpdateDate': false },
					itemActions: [],
					listActions: [
						{ id: 'import', label: 'ACTIONS.IMPORT', icon: 'icon-import', privilege: 'CreateUpdateCatalogBulkCustomersLocations:true', disabled: false, visible: true, requiresConfirmation: false }
					]
				},
				mainDetails: {},
				privileges: {
					list: 'GetAllActiveCustomersAllLocations'
				}
			}

		};

		function getLocations(generalProperties, model, catalogId) {
			if (angular.isDefined(model)) { // to skip this part for load lookup
				model.isBulkActionCompleted = false;
			}
			var promise;

			if (angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
				var state = {};
				state.name = $state.current.name;
				state.params = $state.params;
				var isBulk = true;
				var logData = activityLogger.createLogData(null, state, 'catalogs.locations', 'VIEW', isBulk, new Date(), null, null);

				promise = api.webGet(api.baseUrl + '/catalogs/' + catalogId + '/customerlocations', undefined, true, generalProperties.forceFetch);
				promise = activityLogger.log(logData, promise);
			}
			else {
				catalogId = angular.isUndefined(catalogId) ? catalogFactory.getActiveCatalog().CatalogCode : catalogId;
				promise = api.webGet(api.baseUrl + '/catalogs/' + catalogId + '/customerlocations', undefined, true, generalProperties.forceFetch);
			}

			promise.then(function () {
				if (api.catalogs.locations.isDirty) {
					//Invalidate lookupData
					api.catalogs.locations.lookupData = undefined;
					api.catalogs.locations.isDirty = false;
				}
			});
			return promise;
		}

		function createBulk(data, catalogId, model) {
			//Transform data into required format
			var transformedData = [];
			var nameIndexes = {};
			var itemsNameList = [];
			for (var i = 0; i < data.length; i++) {
				var ind = -1;
				if (angular.isUndefined(nameIndexes[data[i].CustomerNumber.toUpperCase()])) {
					var requestObj = { 'CustomerNumber': data[i].CustomerNumber, 'Locations': [] };
					ind = transformedData.length;
					nameIndexes[data[i].CustomerNumber.toUpperCase()] = ind;
					transformedData.push(requestObj);
					itemsNameList.push(data[i].CustomerNumber);
				} else {
					ind = nameIndexes[data[i].CustomerNumber.toUpperCase()];
				}
				if (data[i].Code && data[i].Name && data[i].CountryCode) {
					var locations = {
						LocationCode: data[i].Code,
						AddressName: data[i].Name,
						Address: data[i].Address,
						City: data[i].City,
						State: data[i].State,
						Zip: data[i].Zip,
						CountryCode: data[i].CountryCode,
						Phone: data[i].Phone,
						LocationReference: data[i].LocationReference
					}
					transformedData[ind].Locations.push(locations);
				}
			}
			nameIndexes = undefined;

			var jobIndex = jobsTracker.addJob(model, 'CUSTOMERS_LOCATIONS.ACTIONS.IMPORT_LOCATIONS', 1);

			api.webPut(api.baseUrl + '/catalogs/' + catalogId + '/customerlocations?sourceapplication=' + CONSTANTS.SOURCE_APPLICATION + '&sourceaction=Import Locations', transformedData).then(function (response) {
				jobsTracker.trackJob(jobIndex, response.data.Id);
			}).catch(function (error) {
				jobsTracker.setCriticlaFail(jobIndex, error);
			});
		}
	}
})();
(function() {
    'use strict';

    angular
        .module('app.main.catalogs.customers')
        .run(runBlock);

    /* @ngInject */
    function runBlock(api, activityLogger, $state, crud, utility, catalogFactory, jobsTracker) {

        if(angular.isUndefined(api.catalogs)) {
            api.catalogs = {};
        }
        api.catalogs.customers = {
            modelPath: 'catalogs.customers',
            fields: [
                { field: 'CustomerId', type: 'int', displayLabel: 'LINKED_CUSTOMERS.FIELDS.CUSTOMER_ID', visible: false, creatable: true, editable: true, inputType: 'lookup', lookupSource: 'customers.customers',
                    lookupFilter: {Status: 1}, validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CustomerId', type: 'int', displayLabel: 'LINKED_CUSTOMERS.FIELDS.CUSTOMER_ID', visible: true, creatable: false, editable: false, inputType: 'number',
                    lookupFilter: {Status: 1}, validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CustomerNumber', type: 'int', displayLabel: 'LINKED_CUSTOMERS.FIELDS.CUSTOMER_NUMBER', visible: true, creatable: true, editable: false, inputType: 'text',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Name', type: 'text', displayLabel: 'LINKED_CUSTOMERS.FIELDS.NAME', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: 50, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'EmailAddress', type: 'text', displayLabel: 'LINKED_CUSTOMERS.FIELDS.EMAIL', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: 500, minLen: 0, pattern: '^[A-Za-z]+[A-Za-z0-9._+-]+@{1}[A-Za-z0-9._-]+\.[A-Za-z.]{2,}$', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: 'VALIDATIONS.INVALID_EMAIL'}} },
                { field: 'CustomerChannel', type: 'text', displayLabel: 'LINKED_CUSTOMERS.FIELDS.CUSTOMER_CHANNEL', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CustomerCategory', type: 'text', displayLabel: 'LINKED_CUSTOMERS.FIELDS.CUSTOMER_CATEGORY', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: 25, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'BuyerAccountId', type: 'int', displayLabel: 'LINKED_CUSTOMERS.FIELDS.BUYER_ACCOUNT_Id', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'BuyerAccountName', type: 'text', displayLabel: 'LINKED_CUSTOMERS.FIELDS.BUYER_ACCOUNT_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Discount', type: 'int', displayLabel: 'LINKED_CUSTOMERS.FIELDS.DISCOUNT', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Address', type: 'text', displayLabel: 'LINKED_CUSTOMERS.FIELDS.ADDRESS', visible: true, creatable: false, editable: false, inputType: 'textArea',
                    validation: {isRequired: false, maxLen: 100, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'LeadTime', type: 'int', displayLabel: 'LINKED_CUSTOMERS.FIELDS.LEAD_TIME', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Token', type: 'text', displayLabel: 'LINKED_CUSTOMERS.FIELDS.ACTIVATION_CODE', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CatalogCode', type: '', displayLabel: 'LINKED_CUSTOMERS.FIELDS.CATALOG_CODE', visible: true, creatable: false, editable: false, inputType: '',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'WholesalePriceGroupId', type: 'text', displayLabel: 'LINKED_CUSTOMERS.FIELDS.WHOLESALE_PRICE_GROUP', visible: true, creatable: true, editable: true, inputType: 'lookup', lookupSource: 'catalogs.priceGroup',
                    lookupFilter: {Status: 1}, validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'WholesaleAltPriceGroupId', type: 'text', displayLabel: 'LINKED_CUSTOMERS.FIELDS.WHOLESALE_ALT_PRICE_GROUP', visible: true, creatable: true, editable: true, inputType: 'lookup', lookupSource: 'catalogs.priceGroup',
                    lookupFilter: {Status: 1}, validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'RetailPriceGroupId', type: 'text', displayLabel: 'LINKED_CUSTOMERS.FIELDS.RETAIL_PRICE_GROUP', visible: true, creatable: true, editable: true, inputType: 'lookup', lookupSource: 'catalogs.priceGroup',
                    lookupFilter: {Status: 1}, validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'RetailAltPriceGroupId', type: 'text', displayLabel: 'LINKED_CUSTOMERS.FIELDS.RETAIL_ALT_PRICE_GROUP', visible: true, creatable: true, editable: true, inputType: 'lookup', lookupSource: 'catalogs.priceGroup',
                    lookupFilter: {Status: 1}, validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'AccountManager1', type: 'text', displayLabel: 'LINKED_CUSTOMERS.FIELDS.ACCOUNT_MANAGER_1', visible: true, creatable: true, editable: true, inputType: 'lookup', lookupSource: 'sellers.users',
                    lookupFilter: {Status: 1}, validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'AccountManager2', type: 'text', displayLabel: 'LINKED_CUSTOMERS.FIELDS.ACCOUNT_MANAGER_2', visible: true, creatable: true, editable: true, inputType: 'lookup', lookupSource: 'sellers.users',
                    lookupFilter: {Status: 1}, validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'AccountManager3', type: 'text', displayLabel: 'LINKED_CUSTOMERS.FIELDS.ACCOUNT_MANAGER_3', visible: true, creatable: true, editable: true, inputType: 'lookup', lookupSource: 'sellers.users',
                    lookupFilter: {Status: 1}, validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'AccountManager4', type: 'text', displayLabel: 'LINKED_CUSTOMERS.FIELDS.ACCOUNT_MANAGER_4', visible: true, creatable: true, editable: true, inputType: 'lookup', lookupSource: 'sellers.users',
                    lookupFilter: {Status: 1}, validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'AccountManager5', type: 'text', displayLabel: 'LINKED_CUSTOMERS.FIELDS.ACCOUNT_MANAGER_5', visible: true, creatable: true, editable: true, inputType: 'lookup', lookupSource: 'sellers.users',
                    lookupFilter: {Status: 1}, validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'AccountManager6', type: 'text', displayLabel: 'LINKED_CUSTOMERS.FIELDS.ACCOUNT_MANAGER_6', visible: true, creatable: true, editable: true, inputType: 'lookup', lookupSource: 'sellers.users',
                    lookupFilter: {Status: 1}, validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'AccountManager7', type: 'text', displayLabel: 'LINKED_CUSTOMERS.FIELDS.ACCOUNT_MANAGER_7', visible: true, creatable: true, editable: true, inputType: 'lookup', lookupSource: 'sellers.users',
                    lookupFilter: {Status: 1}, validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'LegacyPassword', type: 'text', displayLabel: 'LINKED_CUSTOMERS.FIELDS.LEGACY_PASSWORD', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'OrderPriceGroupId', type: 'text', displayLabel: 'LINKED_CUSTOMERS.FIELDS.ORDER_PRICE_GROUP', visible: true, creatable: true, editable: true, inputType: 'lookup', lookupSource: 'catalogs.priceGroup',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'AutoApproveOrders', type: 'text', displayLabel: 'CUSTOMERS.FIELDS.AUTO_APPROVE_ORDERS', visible: true, creatable: false, editable: false, inputType: 'int-bool',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Division', type: 'text', displayLabel: 'CUSTOMERS.FIELDS.DIVISION', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: 250, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedBy', type: 'text', displayLabel: 'LINKED_CUSTOMERS.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedBy', type: 'text', displayLabel: 'LINKED_CUSTOMERS.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedDate', type: 'text', displayLabel: 'LINKED_CUSTOMERS.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedDate', type: 'text', displayLabel: 'LINKED_CUSTOMERS.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Status', type: 'text', displayLabel: 'LINKED_CUSTOMERS.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'SalesOrg', type: 'text', displayLabel: 'LINKED_CUSTOMERS.FIELDS.SALES_ORG', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: 100, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'DPAccountGroup',  type: 'text', displayLabel: 'LINKED_CUSTOMERS.FIELDS.DP_ACCOUNT_GROUP', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: 500, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'OrderQtyMultipleOfRatio', type: 'text', displayLabel: 'LINKED_CUSTOMERS.FIELDS.ORDER_QTY_MULTIPLE_OF_RATIO', visible: true, creatable: true, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '^([0-9])([.]\\d{0,2})?$', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: 'LINKED_CUSTOMERS.VALIDATIONS.INVALID_DECIMAL_POINTS'}} },
                { field: 'StockDefinitionIds', type: 'text', displayLabel: 'LINKED_CUSTOMERS.FIELDS.STOCKS', visible: false, creatable: true, editable: false, inputType: 'lookup-many', lookupSource: 'catalogs.stockDefinition',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'StockCodes', type: 'text', displayLabel: 'LINKED_CUSTOMERS.FIELDS.STOCK_CODES', visible: true, creatable: false, editable: false, inputType: 'array-tags', tagSeparator: ',',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'StockNames', type: 'text', displayLabel: 'LINKED_CUSTOMERS.FIELDS.STOCK_NAMES', visible: true, creatable: false, editable: false, inputType: 'array-tags', tagSeparator: ',',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CapacityNames', type: 'text', displayLabel: 'LINKED_CUSTOMERS.FIELDS.CAPACITY_NAMES', visible: true, creatable: false, editable: false, inputType: 'array-tags', tagSeparator: ',',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'StockThreshold', type: 'int', displayLabel: 'LINKED_CUSTOMERS.FIELDS.STOCK_THRESHOLD', visible: true, creatable: true, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'HideZeroStock', type: 'text', displayLabel: 'LINKED_CUSTOMERS.FIELDS.HIDE_ZERO_STOCK', visible: true, creatable: true, editable: false, inputType: 'bool',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'MoqEnabled', type: 'int', displayLabel: 'LINKED_CUSTOMERS.FIELDS.MOQ_ENABLED', visible: true, creatable: true, editable: false, inputType: 'bool',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'MultipleOfEnabled', type: 'int', displayLabel: 'LINKED_CUSTOMERS.FIELDS.MULTIPLE_OF_ENABLED', visible: true, creatable: true, editable: false, inputType: 'bool',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CustomerCriteria', type: 'text', displayLabel: 'LINKED_CUSTOMERS.FIELDS.CUSTOMER_CRITERIA', visible: true, creatable: true, editable: true, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
            ],
            uniqueConstraints: [
                {name: 'Constraint 1', fields: ['CustomerNumber']}
            ],
            title: 'LINKED_CUSTOMERS.NAV',
            icon: 'icon-account-multiple',
            idField: 'CustomerId',
            lookupDisplayField: 'CustomerNumber',
            isDirty: false,
            isBulkActionCompleted: false,
            isCatalogSpecificModel: true,
            methods: {
                getList                     :   getCatalogCustomers,
                unlinkCustomerFromCatalog   :   unlinkCustomerFromCatalog,
                create                      :   linkCustomerToCatalog,
                update                      :   updateCatalogCustomer,
                createBulk                  :   createBulk
            },
            views: {
                mainList: {
                    columns             : [ 'CustomerNumber', 'Name', 'BuyerAccountName', 'WholesalePriceGroupId', 'RetailPriceGroupId', 'OrderPriceGroupId', 'CapacityNames', 'Status', 'UpdatedDate' ],
                    columnFilter        : {},
                    topIndex            : 0,
                    showFilterRow       : false,
                    sortColumn          : {'UpdatedDate': false},
                    itemActions         : [
                                            { id: 'view', label: 'ACTIONS.VIEW', icon: 'icon-magnify', privilege: 'GetSellerCatalogCustomers', disabled: '!itm.Status', visible: true },
                                            { id: 'viewDetails', label: 'ACTIONS.VIEW_CUSTOMER_DETAILS', icon: 'icon-magnify', privilege: 'GetSellerCustomerDetails:true', disabled: '!itm.Status', visible: true },
                                            { id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'AssignCatalogAndPriceGroupToSellerCustomer:true', disabled: '!itm.Status', visible: true },
                                            { id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'RemoveCatalogFromSellerCustomers:true', disabled: false, visible: 'itm.Status',
                                                requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                                            // DTCR link-capacities action — LinkCustomerToCapacity (backend id 4044), catalog-scoped (`:true`).
                                            { id: 'linkCapacities', label: 'LINKED_CUSTOMERS.ACTIONS.LINK_CAPACITIES', icon: 'icon-link', privilege: 'LinkCustomerToCapacity:true', disabled: '!itm.Status', visible: true }
                                          ],
                    listActions         : [
                                            { id: 'delete', label: 'ACTIONS.DELETE_BULK', icon: 'icon-delete', privilege: 'RemoveCatalogFromSellerCustomers:true', disabled: '{selected: true, Status: 1}', visible: true,
                                                requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                                            { id: 'import', label: 'ACTIONS.IMPORT', icon: 'icon-import', privilege: 'AssignCustomersToCatalog:true', disabled: false, visible: true, requiresConfirmation: false }
                                          ],
                    fabAction           : {id: 'add', label: 'ACTIONS.ADD', icon: 'icon-link', privilege: 'AssignCatalogAndPriceGroupToSellerCustomer:true', visible: true}
                },
                mainDetails: {
                    selectedTabIndex    : 0,
                    itemActions         : [
                                            { id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateSellerAccountStatusBulk:true', disabled: '{selected: true, Status: 1}',
                                                visible: true, requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'}
                                          ],
                    fab                 : {id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'AssignCatalogAndPriceGroupToSellerCustomer:true', visible: true}
                },
                privileges: {
                    list    : 'GetCatalogLinkedSellerCustomers',
                    details : 'GetCatalogLinkedSellerCustomers'// there is no get details API
                }
            }
        };

        function getCatalogCustomers(generalProperties, model, catalogId) {
            if(angular.isDefined(model)) { // to skip this part for load lookup
                model.isBulkActionCompleted = false;
            }
            var promise;

            if(angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
                var state = {};
                state.name = $state.current.name;
                state.params = $state.params;
                var isBulk = true;
                var logData = activityLogger.createLogData(null, state, 'catalogs.customers', 'VIEW', isBulk, new Date(), null, null);

                promise = api.webGet(api.baseUrl + '/catalogs/' + catalogId + '/customers',
                generalProperties.config || {}, true, generalProperties.forceFetch,
                generalProperties.supportIncrementalResult || false,
                generalProperties.modelIdField,
                generalProperties.isMajor || false,
                generalProperties.model || api.catalogs.customers);
                promise = activityLogger.log(logData, promise);
            }
            else {
                catalogId = angular.isUndefined(catalogId) ? catalogFactory.getActiveCatalog().CatalogCode : catalogId;
                promise = api.webGet(api.baseUrl + '/catalogs/' + catalogId + '/customers',
                generalProperties.config || {}, true, generalProperties.forceFetch,
                generalProperties.supportIncrementalResult || false,
                generalProperties.modelIdField,
                generalProperties.isMajor || false,
                generalProperties.model || api.catalogs.customers);
            }

            promise.then(function() {
                if (api.catalogs.customers.isDirty) {
                    //Invalidate lookupData
                    api.catalogs.customers.lookupData = undefined;
                    api.catalogs.customers.isDirty = false;
                }
            });
            return promise;
        }

        function getCatalogCustomer(isLogRequired, customerId, catalogId) {
            var promise;
            if(angular.isDefined(isLogRequired) && isLogRequired === true) {
                var state = {};
                state.name = $state.current.name;
                state.params = $state.params;
                var isBulk = false;
                var items = [];

                promise = api.webGet(api.baseUrl + '/catalogs/' + catalogId + '/customers', undefined, true, true);
                promise.then(function(response) {
                    response.data = utility.filterObject(response.data, {CustomerId: customerId}, true)[0];
                    items.push(response.data[api.catalogs.customers.lookupDisplayField]);
                });

                var logData = activityLogger.createLogData(items, state, 'catalogs.customers', 'VIEW', isBulk, new Date(), null, null);
                promise = activityLogger.log(logData, promise);
            }
            else {
                promise = api.webGet(api.baseUrl + '/catalogs/' + catalogId + '/customers', undefined, true, true);
                promise.then(function(response) {
                    response.data = utility.filterObject(response.data, {CustomerId: customerId}, true)[0];
                });
            }
            return promise;
        }

        // function activateCustomers(records, model, actionType, parentId) {
        //     var result = crud.createRequestObject(records, model, actionType);
        //     var state = {};
        //     state.name = $state.current.name;
        //     state.params = $state.params;
        //     var isBulk = result.itemsNameList.length > 1 ? true : false;
        //     var logData = activityLogger.createLogData(result.itemsNameList, state, 'catalogs.customers', actionType.toUpperCase(), isBulk, new Date(), null, null);
		// 	var promise = api.webPut(api.baseUrl + '/sellers/' + parentId + '/customers/status', result.requestObj);

        //      promise.then(function(response) {
        //         crud.onRecordStatusChange(records, model, actionType);
        //     });

        //     return activityLogger.log(logData, promise);
		// }

		function unlinkCustomerFromCatalog(records, model, actionType, catalogCode, parentId) {
            //var result = crud.createRequestObject(records, model, actionType);
            var result = {
                requestObj: [],
                itemsNameList: []
            };
            // pushing single item to array
            if(!angular.isArray(records)) {
                records = utility.pushItemToArray(records);
            }
            for(var index=0; index < records.length ; index++) {
                var obj = {};
                obj[model.idField] = records[index][model.idField];
                result.requestObj.push(obj);
                result.itemsNameList.push(records[index][model.lookupDisplayField]);
            }
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var isBulk = result.itemsNameList.length > 1 ? true : false;
            var logData = activityLogger.createLogData(result.itemsNameList, state, 'catalogs.customers', actionType.toUpperCase(), isBulk, new Date(), null, null);
			var promise = api.webDelete(api.baseUrl + '/sellers/' + parentId + '/catalogs/' + catalogCode + '/customers', result.requestObj);

             promise.then(function() {
                crud.onRecordStatusChange(records, model, actionType);
            });

            return activityLogger.log(logData, promise);
		}

		function linkCustomerToCatalog(record, sellerId, customerId) {
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var logData = activityLogger.createLogData(record[api.catalogs.customers.lookupDisplayField], state, 'catalogs.customers', 'ADD', false, new Date(), null, null);
            var promise = api.webPut(api.baseUrl + '/sellers/' + sellerId + '/customers/' + customerId + '/catalogs', utility.pushItemToArray(record));

            promise.then(function() {
                api.catalogs.customers.isDirty = true;
            });
            return activityLogger.log(logData, promise);
		}

        function updateCatalogCustomer(record, sellerId, customerId) {
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var logData = activityLogger.createLogData(record[api.catalogs.customers.lookupDisplayField], state, 'catalogs.customers', 'EDIT', false, new Date(), null, null);
            var promise = api.webPut(api.baseUrl + '/sellers/' + sellerId + '/customers/' + customerId + '/catalogs', utility.pushItemToArray(record));

            promise.then(function() {
                api.catalogs.customers.isDirty = true;
            });
            return activityLogger.log(logData, promise);
		}

        function createBulk(data, sellerId, catalogId, model) {
            var jobIndex = jobsTracker.addJob(model, 'LINKED_CUSTOMERS.ACTIONS.IMPORT_CUSTOMERS', 1);
            api.webPut(api.baseUrl + '/sellers/' + sellerId + '/catalogs/' + catalogId + '/bulkcustomers', data).then(function(response) {
                jobsTracker.trackJob(jobIndex, response.data.Id);
            }).catch(function(error) {
                jobsTracker.setCriticlaFail(jobIndex, error);
            });
        }

    }
})();
(function() {
  'use strict';

  angular
    .module('app.main.catalogs.customer-allocations', [
        'app.main.catalogs.customer-allocations.allocation-groups'
    ])
    .config(config);

    /* @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
      // State
      $stateProvider.state('app.customer_allocations', {
        url: '/customer-allocations',
        views: {
          'content@app': {
            templateUrl: 'app/main/catalogs/sub-modules/customer-allocations/list/customer-allocations-list.html',
            controller: 'customerAllocationsListController as vm'
          }
        },
        data: {
          displayName: 'CUSTOMER_ALLOCATIONS.NAV'
        },
        //only users with following accessPrivileges in their role access list can access this route
        // accessPrivileges: ['GetAssignAllocationGroupsToCustomers']
        // accessPrivileges: ['nav_customer_allocations']
        accessInfo: {
          accessPrivileges: ['nav_customer_allocations']
        }
      });

      $stateProvider.state('app.customer_allocations.details', {
        url	 : '/:id',
        views: {
          'content@app': {
            templateUrl: 'app/main/catalogs/sub-modules/customer-allocations/details/customer-allocations-details.html',
            controller : 'customerAllocationsDetailsController as vm'
          }
        },
        data: {
           parentState: 'app.customer_allocations',
           displayName: 'CUSTOMER_ALLOCATIONS.TABS.CUSTOMER_ALLOCATION'
        },
        //only users with following accessPrivileges in their role access list can access this route
        // accessPrivileges: ['GetAssignAllocationGroupsToCustomerDetails']
        accessInfo: {
          accessPrivileges: ['GetAssignAllocationGroupsToCustomerDetails']
        }
      });

      // Translation
      $translatePartialLoaderProvider.addPart('app/main/catalogs/sub-modules/customer-allocations');

      msNavigationServiceProvider.saveItem('orders.customerAllocations', {
        title: 'Customer Allocations',
        icon: 'icon-source-fork',
        state: 'app.customer_allocations',
        translate: 'CUSTOMER_ALLOCATIONS.NAV',
        weight: 123,
        // accessPrivileges: ['GetAssignAllocationGroupsToCustomers']
        // accessPrivileges: ['nav_customer_allocations']
        accessInfo: {
          accessPrivileges: ['nav_customer_allocations']
        }
      });
    }
})();
(function () {
  'use strict';

  angular
    .module('app.main.catalogs.customer-allocations')
    .run(runBlock);

  /* @ngInject */
  function runBlock(api, activityLogger, $state, CONSTANTS, jobsTracker, catalogFactory) {

    if (angular.isUndefined(api.catalogs)) {
      api.catalogs = {};
    }
    api.catalogs.customerAllocations = {
      modelPath: 'catalogs.customerAllocations',
      fields: [
        { field: 'CustomerId', type: 'int', displayLabel: 'CUSTOMER_ALLOCATIONS.FIELDS.CUSTOMER_ID', visible: true, creatable: false, editable: false, inputType: 'number',
          validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
        { field: 'CustomerCode', type: 'text', displayLabel: 'CUSTOMER_ALLOCATIONS.FIELDS.CUSTOMER_CODE', visible: true, creatable: false, editable: false, inputType: 'text',
          validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
        { field: 'Name', type: 'text', displayLabel: 'CUSTOMER_ALLOCATIONS.FIELDS.NAME', visible: true, creatable: false, editable: false, inputType: 'text',
          validation: {isRequired: false, maxLen: 20, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
        { field: 'EmailAddress', type: 'text', displayLabel: 'CUSTOMER_ALLOCATIONS.FIELDS.EMAIL_ADDRESS', visible: true, creatable: false, editable: false, inputType: 'text',
          validation: {isRequired: false, maxLen: 500, minLen: 1, pattern: '^[A-Za-z]+[A-Za-z0-9._+-]+@{1}[A-Za-z0-9._-]+\.[A-Za-z.]{2,}$', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: 'VALIDATIONS.INVALID_EMAIL'}} },
        { field: 'Status', type: 'text', displayLabel: 'CUSTOMER_ALLOCATIONS.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
          validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
        { field: 'CreatedDate', type: 'text', displayLabel: 'CUSTOMER_ALLOCATIONS.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
          validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
        { field: 'UpdatedDate', type: 'text', displayLabel: 'CUSTOMER_ALLOCATIONS.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
          validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
        { field: 'CreatedBy', type: 'text', displayLabel: 'CUSTOMER_ALLOCATIONS.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
          validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
        { field: 'UpdatedBy', type: 'text', displayLabel: 'CUSTOMER_ALLOCATIONS.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
          validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
      ],
      uniqueConstraints: [
        { name: 'Constraint 1', fields: ['CustomerCode', 'AllocationGroup'] }
      ],
      title: 'CUSTOMER_ALLOCATIONS.NAV',
      icon: 'icon-source-fork',
      idField: 'CustomerId',
      lookupDisplayField: 'Name',
      isDirty: false,
      isBulkActionCompleted: false,
      isCatalogSpecificModel: true,
      methods: {
         getList: getCustomerAllocations,
         getDetails: getCustomerAllocation,
         update: updateCustomerAllocation,
         createBulk: createBulk
      },
      views: {
        mainList: {
          columns           : ['Name', 'EmailAddress', 'Status', 'UpdatedDate'],
          columnFilter      : {},
          toggleFilterProps : { toggleStatus: false, filterProp: 'Status', trueVal: 1, trueValTooltipMessage: 'ACTIONS.TOGGLE_ACTIVE', falseVal: '', falseValTooltipMessage: "ACTIONS.TOGGLE_ALL" },
          topIndex          : 0,
          showFilterRow     : false,
          sortColumn        : { 'UpdatedDate': false },
          sortDescending    : true,
          itemActions       : [
                                { id: 'view', label: 'ACTIONS.VIEW', icon: 'icon-magnify', privilege: 'GetAssignAllocationGroupsToCustomerDetails', disabled: '!itm.Status', visible: true },
                                { id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'AssignAllocationGroupsToCustomer:true', disabled: '!itm.Status', visible: true }
                              ],
          listActions       : [
                                { id: 'import', label: 'ACTIONS.IMPORT', icon: 'icon-import', privilege: 'AssignAllocationGroupsToCustomerBulk:true', disabled: false, visible: true, requiresConfirmation: false }
                              ],
          fabAction         : { id: 'add', label: 'ACTIONS.ADD', icon: 'icon-plus', privilege: 'AssignAllocationGroupsToCustomer:true', visible: true }
        },
        mainDetails: {
          selectedTabIndex  : 0,
          itemActions       : [],
          // fabAction          : { id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'AssignAllocationGroupsToCustomer:true', visible: true }
          //PROXY FAB FOR DETAIL PAGE
          fab               : { id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'AssignAllocationGroupsToCustomer:true', visible: true }
        },
        privileges: {
          list: 'GetAssignAllocationGroupsToCustomers',
          details: 'GetAssignAllocationGroupsToCustomerDetails'
        }
      }
    };

    api.catalogs.importAllocationsGroups = {
      modelPath: 'catalogs.customerAllocations',
      fields: [
        { field: 'CustomerCode', type: 'text', displayLabel: 'CUSTOMER_ALLOCATIONS.FIELDS.CUSTOMER_CODE', visible: false, creatable: true, editable: false, inputType: 'text',
          validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
        { field: 'AllocationGroup', type: 'text', displayLabel: 'CUSTOMER_ALLOCATIONS.FIELDS.ALLOCATION_GROUP_NAME', visible: false, creatable: true, editable: false, inputType: 'text',
          validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
        { field: 'Quantity', type: 'int', displayLabel: 'CUSTOMER_ALLOCATIONS.FIELDS.QUANTITY', visible: false, creatable: true, editable: false, inputType: 'number', allowEmptyValue: true, // specific for customer allocation module, this will send value as "null" to API if value is undefined
          validation: {isRequired: true, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
        { field: 'MinQuantity', type: 'int', displayLabel: 'CUSTOMER_ALLOCATIONS.FIELDS.MIN_QUANTITY', visible: false, creatable: true, editable: false, inputType: 'number', allowEmptyValue: true,
          validation: {isRequired: true, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
        { field: 'Status', type: 'int', displayLabel: 'CUSTOMER_ALLOCATIONS.FIELDS.STATUS', visible: false, creatable: true, editable: false, inputType: 'bool-int',
          validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
      ],
      uniqueConstraints: [
        { name: 'Constraint 1', fields: ['CustomerCode', 'AllocationGroup'] }
      ],
      atLeastOneRequiredConstraints: [ // fields should have at least 1 value
        { name: 'Constraint 1', fields:['Quantity', 'MinQuantity'] }
      ],
      title: 'CUSTOMER_ALLOCATIONS.NAV',
      icon: 'icon-source-fork',
    };

    function getCustomerAllocations(generalProperties, model, catalogCode) {
      if (angular.isDefined(model)) { // to skip this part for load lookup
        model.isBulkActionCompleted = false;
      }
      var promise;

      if (angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
        var state = {};
        state.name = $state.current.name;
        state.params = $state.params;
        var isBulk = true;
        var logData = activityLogger.createLogData(null, state, 'catalogs.customerAllocations', 'VIEW', isBulk, new Date(), null, null);

        promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/assignallocationgroupstocustomers', undefined, true, generalProperties.forceFetch);
        promise = activityLogger.log(logData, promise);
      }
      else {
        catalogCode = angular.isUndefined(catalogCode) ? catalogFactory.getActiveCatalog().CatalogCode : catalogCode;
        promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/assignallocationgroupstocustomers', undefined, true, generalProperties.forceFetch);
      }

      promise.then(function () {
        if (api.catalogs.customerAllocations.isDirty) {
          //Invalidate lookupData
          api.catalogs.customerAllocations.lookupData = undefined;
          api.catalogs.customerAllocations.isDirty = false;
        }
      });
      return promise;
    }

    function getCustomerAllocation(isLogRequired, customerId, catalogCode) {
      var promise;
      if (angular.isDefined(isLogRequired) && isLogRequired === true) {
        var state = {};
        state.name = $state.current.name;
        state.params = $state.params;
        var isBulk = false;
        var items = [];
        promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/customers/' + customerId + '/assignallocationgroupstocustomers');
        promise.then(function (response) {
          items.push(response.data[api.catalogs.customerAllocations.lookupDisplayField]);
        }, function (response) {
          items.push(response.data[api.catalogs.customerAllocations.lookupDisplayField]);
        });
        var logData = activityLogger.createLogData(items, state, 'catalogs.customerAllocations', 'VIEW', isBulk, new Date(), null, null);
        promise = activityLogger.log(logData, promise);
      }
      else {
        promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/customers/' + customerId + '/assignallocationgroupstocustomers');
      }
      return promise;
    }

    function updateCustomerAllocation(customerId, records, catalogCode, actionType) {
      var state = {};
      state.name = $state.current.name;
      state.params = $state.params;
      var logData = activityLogger.createLogData(customerId, state, 'catalogs.customerAllocations', actionType.toUpperCase(), false, new Date(), null, null);

      var promise = api.webPut(api.baseUrl + '/catalogs/' + catalogCode + '/customers/' + customerId + '/assignallocationgroupstocustomers', records);

      promise.then(function() {
          api.catalogs.customerAllocations.isDirty = true;
          api.catalogCustomers.segmentationLinear.isDirty = true;
      });
      return activityLogger.log(logData, promise);
    }

    function createBulk(model, data, catalogCode) {
      var secondaryModel = api.catalogCustomers.segmentationLinear.isDirty;
      var jobIndex = jobsTracker.addJob(model, 'CUSTOMER_ALLOCATIONS.ACTIONS.IMPORT', 1, secondaryModel);
      var result = [];
      var customerIndexes = {};
      angular.forEach(data, function(d) {
        var AllocationGroup = { AllocationGroup: d.AllocationGroup, Quantity: d.Quantity, MinQuantity: d.MinQuantity, Status: angular.isDefined(d.Status) ? d.Status : 1 }
        if(customerIndexes[d.CustomerCode]) {
          result[customerIndexes[d.CustomerCode]].AllocationGroups.push(AllocationGroup);
        }
        else {
          var transformedObj = {
            CustomerCode: d.CustomerCode,
            AllocationGroups: [AllocationGroup]
          };
          result.push(transformedObj);
          customerIndexes[d.CustomerCode] = result.length - 1;
        }
      });

      api.webPut(api.baseUrl + '/catalogs/' + catalogCode + '/assignallocationgroupstocustomersbulk?sourceapplication=' + CONSTANTS.SOURCE_APPLICATION + '&sourceaction=Assign Allocation Groups', result)
        .then(function (response) {
          jobsTracker.trackJob(jobIndex, response.data.Id);
        }).catch(function (error) {
          jobsTracker.setCriticlaFail(jobIndex, error);
        });
    }
  }
})();
(function() {
	'use strict';

	angular
		.module('app.main.catalogs.crds-linear')
		.run(runBlock);

	/* @ngInject */
	function runBlock(api, activityLogger, $state, catalogFactory, jobsTracker, utility, CONSTANTS) {

		if (angular.isUndefined(api.catalogs)) {
			api.catalogs = {};
		}
		api.catalogs.crdsLinear = {
			modelPath: 'catalogs.crdsLinear',
			fields: [
				{ field: 'ArticleId', type: 'int', displayLabel: 'CRD_LINEAR.FIELDS.ARTICLE_ID', visible: true, creatable: false, editable: false, inputType: 'number',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'ArticleNumber', type: 'text', displayLabel: 'CRD_LINEAR.FIELDS.ARTICLE_NUMBER', visible: true, creatable: true, editable: false, inputType: 'text',
					validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'ModelNumber', type: 'text', displayLabel: 'CRD_LINEAR.FIELDS.MODEL_NUMBER', visible: true, creatable: true, editable: false, inputType: 'text',
					validation: { isRequired: true, maxLen: 200, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } } },
				{ field: 'ArticleId', type: 'text', displayLabel: 'CRD_LINEAR.FIELDS.ARTICLE_ID', visible: false, creatable: false, editable: true, inputType: 'lookup', lookupSource: 'catalogs.articles',
					lookupFilter: {Status: 1}, validation: {isRequired: false, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'CrdId', type: 'int', displayLabel: 'CRD_LINEAR.FIELDS.CRD', visible: true, creatable: true, editable: false, inputType: 'lookup', lookupSource:'catalogs.CRD',
					lookupFilter: {'Status': 1}, validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'CrdId', type: 'int', displayLabel: 'CRD_LINEAR.FIELDS.CRD_ID', visible: true, creatable: false, editable: false, inputType: 'number',
					lookupFilter: {'Status': 1}, validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'Status', type: 'text', displayLabel: 'CRD_LINEAR.FIELDS.ARTICLE_STATUS', visible: true, creatable: true, editable: false, inputType: 'status',
					validation: {isRequired: true, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'CreatedDate', type: 'text', displayLabel: 'CRD_LINEAR.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'UpdatedDate', type: 'text', displayLabel: 'CRD_LINEAR.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'Description', type: 'text', displayLabel: 'CRD_LINEAR.FIELDS.DESCRIPTION', visible: true, creatable: false, editable: false, inputType: 'text',
					validation: {isRequired: false, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
			],
			title: 'CRD_LINEAR.NAV',
			icon: 'icon-calendar-clock',
			idField: 'ArticleId',
			lookupDisplayField: '',
			isDirty: false,
			isBulkActionCompleted: false,
			isCatalogSpecificModel: true,
			methods: {
				getList     : getCRDs,
				createBulk  : createBulk,
				updateBulk  : updateBulk,
				shiftCrds   : shiftCrds,
				activateBulk: activateCRDs,
			},
			views: {
				mainList: {
					columns             : [ 'ArticleId', 'ArticleNumber', 'Status', 'CrdId', 'Crd', 'Description', 'UpdatedDate'],
					columnFilter        : {},
					topIndex            : 0,
					toggleFilterProps   : {},
					showFilterRow       : false,
					sortColumn          : {'UpdatedDate': false},
					itemActions         : [
																	{ id: 'view', label: 'ACTIONS.VIEW', icon: 'icon-magnify', privilege: 'GetCatalogArticleCRD', disabled: false, visible: true },
																	{ id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateArticleBulkCRD:true', disabled: '!itm.Status', visible: 'itm.Status',
																		requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
																	],
					listActions         : [
																	{ id: 'import', label: 'CRD_LINEAR.ACTIONS.IMPORT', icon: 'icon-import', privilege: 'UI_ImportCRDs:true', disabled: false, visible: true, requiresConfirmation: false },
																	{ id: 'shiftCrd', label: 'SHIFT_CRDS.ACTIONS.SHIFT_CRDS', icon: 'icon-folder-move', privilege: 'ArticleShiftCrdsBulk:true', disabled: false, visible: true, requiresConfirmation: false },
																	],
					fabAction           : { id: 'add', label: 'ACTIONS.ADD', icon: 'icon-link', privilege: 'UpdateCatalogBulkArticlesCrds:true', visible: true }

				},
				mainDetails : {},
				privileges  : {
					list    : 'GetCatalogAllArticlePrices'
				}
			}
		};

		function getCRDs(generalProperties, model, catalogId) {
			if(angular.isDefined(model)) { // to skip this part for load lookup
				model.isBulkActionCompleted = false;
			}
			var promise;

			if(angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
					var state = {};
					state.name = $state.current.name;
					state.params = $state.params;
					var isBulk = true;
					var logData = activityLogger.createLogData(null, state, 'catalogs.crds', 'VIEW', isBulk, new Date(), null, null);

					promise = api.webGet(api.baseUrl + '/catalogs/' + catalogId + '/articlecrds',
					generalProperties.config || {}, true, generalProperties.forceFetch,
					generalProperties.supportIncrementalResult || true,
					generalProperties.modelIdField,
					generalProperties.isMajor || false,
					api.catalogs.crdsLinear);
					promise = activityLogger.log(logData, promise);
			}
			else {
					catalogId = angular.isUndefined(catalogId) ? catalogFactory.getActiveCatalog().CatalogCode : catalogId;
					promise = api.webGet(api.baseUrl + '/catalogs/' + catalogId + '/articlecrds',
					generalProperties.config || {}, true, generalProperties.forceFetch,
					generalProperties.supportIncrementalResult || true,
					generalProperties.modelIdField,
					generalProperties.isMajor || false,
					api.catalogs.crdsLinear);
			}

			promise.then(function() {
				if (api.catalogs.crdsLinear.isDirty) {
					//Invalidate lookupData
					api.catalogs.crdsLinear.lookupData = undefined;
					api.catalogs.crdsLinear.isDirty = false;
				}
			});
			return promise;
		}

		function createBulk(data, catalogId, model) {
			var secondaryModel = api.catalogs.crds;
			// transform data into required format
			var transformedData = [];
			var nameIndexes = {};
			var itemsNameList = [];
			for (var i = 0; i < data.length; i++) {
				var ind = -1;
				if (angular.isUndefined(nameIndexes[data[i].ArticleNumber.toUpperCase()])) {
					var requestObj = { 'ArticleNumber': data[i].ArticleNumber, 'CRDs': [] };
					ind = transformedData.length;
					nameIndexes[data[i].ArticleNumber.toUpperCase()] = ind;
					transformedData.push(requestObj);
					itemsNameList.push(data[i].ArticleNumber);
				} else {
					ind = nameIndexes[data[i].ArticleNumber.toUpperCase()];
				}
				if (data[i].CrdId && data[i].Status && data[i].Status === 1) {
					transformedData[ind].CRDs.push({Id: data[i].CrdId});
				}
			}
			nameIndexes = undefined;

			var jobIndex = jobsTracker.addJob(model, 'CRD_LINEAR.ACTIONS.IMPORT_ARTICLES_CRDS', 1, secondaryModel);
			api.webPut(api.baseUrl + '/catalogs/' + catalogId + '/articlesCrds?sourceapplication=' + CONSTANTS.SOURCE_APPLICATION + '&sourceaction=Import Articles Delivery Dates', transformedData).then(function(response) {
				jobsTracker.trackJob(jobIndex, response.data.Id);
			}).catch(function(error) {
				jobsTracker.setCriticlaFail(jobIndex, error);
			});

		}

		function shiftCrds(model, data, catalogCode) {
			var secondaryModel = api.catalogs.crds;
			var jobIndex = jobsTracker.addJob(model, 'SHIFT_CRDS.ACTIONS.SHIFT_CRDS', 1, secondaryModel);
				api.webPut(api.baseUrl + '/catalogs/' + catalogCode + '/shiftcrds?sourceapplication=' + CONSTANTS.SOURCE_APPLICATION + '&sourceaction=Shift Delivery Dates', data).then(function(response) {
					jobsTracker.trackJob(jobIndex, response.data.Id);
				}).catch(function(error) {
					jobsTracker.setCriticlaFail(jobIndex, error);
				});
		}

		function updateBulk(records) {
			var model = api.catalogs.crdsLinear;
			var secondaryModel = api.catalogs.crds;
			var catalogId = catalogFactory.getActiveCatalog().CatalogCode;
			//Transform data into required format
			var transformedData = [];
			for (var i = 0; i < records.ArticleId.length; i++) {
				var crds = {
					ArticleNumber: records.ArticleId[i],
					CRDs: []
				}
				for(var j = 0; j < records.CrdId.length; j++) {
					crds.CRDs.push({'Id' : records.CrdId[j]});
				}
				transformedData.push(crds);
			}

			var jobIndex = jobsTracker.addJob(model, 'CRD_LINEAR.ACTIONS.UPDATE_ARTICLES_CRDS', 1, secondaryModel);
			api.webPut(api.baseUrl + '/catalogs/' + catalogId + '/articlesCrds?sourceapplication=' + CONSTANTS.SOURCE_APPLICATION + '&sourceaction=Update Articles Delivery Dates', transformedData).then(function(response) {
				jobsTracker.trackJob(jobIndex, response.data.Id);
			}).catch(function(error) {
				jobsTracker.setCriticlaFail(jobIndex, error);
			});
		}

		function activateCRDs(record, allRecords, model, actionType, parentId, activeCatalogId) {
			utility.filterObject(allRecords, {CrdId: record.CrdId}, true)[0].Status = 0;
			var activeRecords = utility.filterObject(allRecords, {Status: 1});
			var state = {};
			state.name = $state.current.name;
			state.params = $state.params;
			var isBulk = false;
			var logData = activityLogger.createLogData(record, state, 'articles.crds', actionType.toUpperCase(), isBulk, new Date(), null, null);
			var promise = api.webPut(api.baseUrl + '/catalogs/' + activeCatalogId + '/articles/' + parentId + '/crds', activeRecords);

			promise.then(function() {
				api.catalogs.crds.isDirty	= true;
				api.catalogs.crdsLinear.isDirty = true;
			});

			return activityLogger.log(logData, promise);
		}

	}
})();
(function() {
  'use strict';

  angular
      .module('app.main.catalogs.crds')
      .run(runBlock);

  /* @ngInject */
  function runBlock(api) {

      if (angular.isUndefined(api.catalogs)) {
          api.catalogs = {};
      }
       api.catalogs.shiftCrds = {
          modelPath: 'catalogs.shiftCrds',
          fields: [
              { field: 'ArticleNumber', type: 'text', displayLabel: 'SHIFT_CRDS.FIELDS.ARTICLE_NUMBER', visible: true, creatable: true, editable: false, inputType: 'text',
                  validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
              { field: 'CurrentDeliveryDate', type: 'text', displayLabel: 'SHIFT_CRDS.FIELDS.CURRENT_DELIVERY_DATE', visible: true, creatable: true, editable: false, inputType: 'date-utc',
                  validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
              { field: 'NewDeliveryDate', type: 'date', displayLabel: 'SHIFT_CRDS.FIELDS.NEW_DELIVERY_DATE', visible: true, creatable: true, editable: false, inputType: 'date-utc',
                  validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: ''}}
          ],
          uniqueConstraints: [
              {name: 'Constraint 1', fields: ['ArticleNumber', 'CurrentDeliveryDate']}
          ],
          shouldNotHaveSameValueConstraints: [ // when multiple fields should not have same value
            {name: 'Constraint 1', fields: ['CurrentDeliveryDate', 'NewDeliveryDate']}
          ],
          title: 'CRD.NAV',
          icon: 'icon-calendar-clock',
          idField: 'ArticleNumber',
          lookupDisplayField: '',
          isDirty: false,
          isBulkActionCompleted: false,
          isCatalogSpecificModel: true,
          methods: {},
          views: {
              mainList: {},
              mainDetails: {},
              privileges: {
                  list    : ''
              }
          }
      };

  }
})();
(function() {
    'use strict';

    angular
        .module('app.main.catalogs.crds')
        .run(runBlock);

    /* @ngInject */
    function runBlock(api, activityLogger, $state, $filter, catalogFactory, jobsTracker, utility, CONSTANTS) {

        if (angular.isUndefined(api.catalogs)) {
            api.catalogs = {};
        }
         api.catalogs.crds = {
            modelPath: 'catalogs.crds',
            fields: [
                { field: 'ArticleId', map:'Id', type: 'int', displayLabel: 'CRD.FIELDS.ARTICLE_ID', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ArticleNumber', map: 'ArticleNumber', type: 'text', displayLabel: 'CRD.FIELDS.ARTICLE_NUMBER', visible: true, creatable: true, editable: false, inputType: 'text',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ModelNumber', map: 'ModelNumber', type: 'text', displayLabel: 'CRD.FIELDS.MODEL_NUMBER', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Status', map: 'Status', type: 'text', displayLabel: 'CRD.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'LastUpdatedOn', map: 'LastUpdatedOn', type: 'date', displayLabel: 'CRD.FIELDS.LAST_UPDATED_ON', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: ''}}
            ],
            uniqueConstraints: [
                {name: 'Constraint 1', fields: ['ArticleNumber']}
            ],
            title: 'CRD.NAV',
            icon: 'icon-calendar-clock',
            idField: 'ArticleId',
            lookupDisplayField: '',
            isDirty: false,
            isBulkActionCompleted: false,
            isCatalogSpecificModel: true,
            methods: {
                getList     : getCRDs,
                createBulk  : createBulk,
                updateBulk  : updateBulk,
                shiftCrds   : shiftCrds
            },
            views: {
                mainList: {
                    columns             : [ 'ArticleNumber', 'ModelNumber', 'LastUpdatedOn'],
                    columnFilter        : {},
                    topIndex            : 0,
                    toggleFilterProps   : { toggleStatus:true, filterProp:'Status', trueVal:1, trueValTooltipMessage: 'ACTIONS.TOGGLE_ACTIVE', falseVal:'', falseValTooltipMessage:"ACTIONS.TOGGLE_ALL"},
                    showFilterRow       : false,
                    sortColumn          : {'ArticleNumber': true},
                    itemActions         : [
                                        { id: 'view', label: 'ACTIONS.VIEW', icon: 'icon-magnify', privilege: 'GetCatalogArticleCRD', disabled: false, visible: true }
                                        ],
                    listActions         : [
                                            { id: 'updateBulk', label: 'ACTIONS.UPDATE_BULK', icon: 'icon-pencil', privilege: 'UpdateCatalogBulkArticlesCrds:true', disabled: '{selected: true}', visible: true, requiresConfirmation: false },
                                            { id: 'importTabular', label: 'CRD.ACTIONS.IMPORT_TABULAR', icon: 'icon-import', privilege: 'UI_ImportCRDs:true', disabled: false, visible: true, requiresConfirmation: false },
                                            { id: 'importLinear', label: 'CRD.ACTIONS.IMPORT_LINEAR', icon: 'icon-file-document', privilege: 'UI_ImportCRDs:true', disabled: false, visible: true, requiresConfirmation: false },
                                            { id: 'shiftCrd', label: 'SHIFT_CRDS.ACTIONS.SHIFT_CRDS', icon: 'icon-folder-move', privilege: 'ArticleShiftCrdsBulk:true', disabled: false, visible: true, requiresConfirmation: false }
                                        ],
                    fabAction           : {}

                },
                mainDetails : {},
                privileges  : {
                    list    : 'GetCatalogAllArticlePrices'
                }
            }
        };

        api.catalogs.importLinear = {
            modelPath: 'catalogs.importLinear',
            fields: [
                { field: 'ArticleNumber', type: 'text', displayLabel: 'CRD.FIELDS.ARTICLE_NUMBER', visible: false, creatable: true, editable: false, inputType: 'text',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'DeliveryDate', type: 'text', displayLabel: 'SHIFT_CRDS.FIELDS.CURRENT_DELIVERY_DATE', visible: false, creatable: true, editable: false, inputType: 'date-utc',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'AvailabilityFrom', type: 'date', displayLabel: 'CRD.FIELDS.AVAILABILITY_FROM', visible: false, creatable: true, editable: false, inputType: 'date-utc',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: ''}},
                { field: 'AvailabilityTo', type: 'date', displayLabel: 'CRD.FIELDS.AVAILABILITY_TO', visible: false, creatable: true, editable: false, inputType: 'date-utc',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: ''}}
            ],
            uniqueConstraints: [
                {name: 'Constraint 1', fields: ['ArticleNumber', 'DeliveryDate']}
            ]
        };

        function getCRDs(generalProperties, model, catalogId) {
            if(angular.isDefined(model)) { // to skip this part for load lookup
                model.isBulkActionCompleted = false;
            }
            var promise;

            if(angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
                var state = {};
                state.name = $state.current.name;
                state.params = $state.params;
                var isBulk = true;
                var logData = activityLogger.createLogData(null, state, 'catalogs.crds', 'VIEW', isBulk, new Date(), null, null);

                promise = api.webGet(api.baseUrl + '/catalogs/' + catalogId + '/articlecrds',
                generalProperties.config || {}, true, generalProperties.forceFetch,
                generalProperties.supportIncrementalResult || true,
                generalProperties.modelIdField,
                generalProperties.isMajor || false,
                api.catalogs.crds,
                generalProperties.isArticleRelatedData || true,
                catalogId, generalProperties.nestedArrayName || 'Crds',
                generalProperties.nestedDataIdField || 'Id');
                promise = activityLogger.log(logData, promise);
            }
            else {
                catalogId = angular.isUndefined(catalogId) ? catalogFactory.getActiveCatalog().CatalogCode : catalogId;
                promise = api.webGet(api.baseUrl + '/catalogs/' + catalogId + '/articlecrds',
                generalProperties.config || {}, true, generalProperties.forceFetch,
                generalProperties.supportIncrementalResult || true,
                generalProperties.modelIdField,
                generalProperties.isMajor || false,
                api.catalogs.crds, generalProperties.isArticleRelatedData || true,
                catalogId, generalProperties.nestedArrayName || 'Crds',
                generalProperties.nestedDataIdField || 'Id');
            }


            promise.then(function() {
                if (api.catalogs.crds.isDirty) {
                    //Invalidate lookupData
                    api.catalogs.crds.lookupData = undefined;
                    api.catalogs.crds.isDirty = false;
                }
            });
            return promise;
		}

        function createBulk(data, catalogId, model, action) {
            var secondaryModel = api.catalogs.crdsLinear;
            //Transform data into required format
            var transformedData = [];
            var articleIndexes = {};
            angular.forEach(data, function(element) {
                var ind = -1;
                if (angular.isUndefined(articleIndexes[element.ArticleNumber])) {
                    ind = transformedData.length;
                    articleIndexes[element.ArticleNumber] = ind;
                    transformedData.push({ArticleNumber: element.ArticleNumber, CRDs: [] });
                } else {
                    ind = articleIndexes[element.ArticleNumber];
                }
                angular.forEach(model.fields, function(field) {
                    if( field.isCatalogProperty ){
                        if(action === "importLinear"){
                            var deliveryDate = $filter('date')(element.DeliveryDate, 'mediumDate');
                            if(deliveryDate === field.importField){
                                var index = transformedData[ind].CRDs.indexOf(utility.filterObject(transformedData[ind].CRDs, {Id: field.crdId}, true)[0]);
                                if(index === -1) {
                                    if(element.AvailabilityFrom && element.AvailabilityTo){
                                        transformedData[ind].CRDs.push({ Id: field.crdId, AvailabilityFrom: element.AvailabilityFrom, AvailabilityTo: element.AvailabilityTo});
                                    } else if(element.AvailabilityFrom && !element.AvailabilityTo){
                                        transformedData[ind].CRDs.push({ Id: field.crdId, AvailabilityFrom: element.AvailabilityFrom});
                                    } else if(!element.AvailabilityFrom && element.AvailabilityTo){
                                        transformedData[ind].CRDs.push({ Id: field.crdId, AvailabilityTo: element.AvailabilityTo});
                                    } else {
                                        transformedData[ind].CRDs.push({ Id: field.crdId });
                                    }
                                }
                            }
                        }
                        if (action === "importTabular") {
                            var crdStatus = angular.isDefined(element[field.field]) ? element[field.field].toString().trim().toUpperCase() : '';
                            if (crdStatus !== '' && crdStatus !== '0' && crdStatus !== 'NO' && crdStatus !== 'FALSE') {
                                transformedData[ind].CRDs.push({ Id: field.crdId});
                            }
                        }
                    }
                });
            });

            var jobIndex = jobsTracker.addJob(model, 'CRD.ACTIONS.IMPORT_ARTICLES_CRDS', 1, secondaryModel);
            api.webPut(api.baseUrl + '/catalogs/' + catalogId + '/articlesCrds?sourceapplication=' + CONSTANTS.SOURCE_APPLICATION + '&sourceaction=Import Articles Delivery Dates', transformedData).then(function(response) {
                jobsTracker.trackJob(jobIndex, response.data.Id);
            }).catch(function(error) {
                jobsTracker.setCriticlaFail(jobIndex, error);
            });
        }

        function shiftCrds(model, data, catalogCode) {
            var secondaryModel = api.catalogs.crdsLinear;
            var jobIndex = jobsTracker.addJob(model, 'SHIFT_CRDS.ACTIONS.SHIFT_CRDS', 1, secondaryModel);
                api.webPut(api.baseUrl + '/catalogs/' + catalogCode + '/shiftcrds?sourceapplication=' + CONSTANTS.SOURCE_APPLICATION + '&sourceaction=Shift Delivery Dates', data).then(function(response) {
                    jobsTracker.trackJob(jobIndex, response.data.Id);
                }).catch(function(error) {
                    jobsTracker.setCriticlaFail(jobIndex, error);
                });
        }

        function updateBulk(model, records, updateRecord, idMap) {
            var secondaryModel = api.catalogs.crdsLinear;
            //Transform data into required format
            var transformedData = [];
            angular.forEach(records, function(record) {
                var newRecord = { ArticleNumber: record.ArticleNumber, CRDs: [] };
                angular.forEach(model.fields, function(field) {
                    if (field.isCatalogProperty) {
                        if( (angular.isDefined(updateRecord[field.field]) && updateRecord[field.field].toString().toUpperCase() === 'YES')
                         || (angular.isUndefined(updateRecord[field.field]) && record[field.field].toString().toUpperCase() === 'YES') ) {
                             newRecord.CRDs.push({ Id: field.crdId});
                        }
                    }
                });
                transformedData.push(newRecord);
            });

            var jobIndex = jobsTracker.addJob(model, 'CRD.ACTIONS.UPDATE_ARTICLES_CRDS', 1, secondaryModel);
            api.webPut(api.baseUrl + '/catalogs/' + idMap.catalogId + '/articlesCrds?sourceapplication=' + CONSTANTS.SOURCE_APPLICATION + '&sourceaction=Update Articles Delivery Dates', transformedData).then(function(response) {
                jobsTracker.trackJob(jobIndex, response.data.Id);
            }).catch(function(error) {
                jobsTracker.setCriticlaFail(jobIndex, error);
            });
        }

    }
})();
(function() {
    'use strict';

    angular
        .module('app.main.catalogs.consolidations')
        .run(runBlock);

    /* @ngInject */
    function runBlock(api, activityLogger, $state, crud, catalogFactory) {

        if (angular.isUndefined(api.catalogs)) {
            api.catalogs = {};
        }
         api.catalogs.consolidations = {
            modelPath: 'catalogs.consolidations',
            fields: [
                { field: 'Id', type: 'int', displayLabel: 'CONSOLIDATIONS.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CatalogCode', type: 'int', displayLabel: 'CONSOLIDATIONS.FIELDS.CATALOG_CODE', visible: true, creatable: false, editable: false, inputType: 'lookup', lookupSource:'catalogs.catalogs',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'AccountId', type: 'int', displayLabel: 'CONSOLIDATIONS.FIELDS.ACCOUNT_ID', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Name', type: 'text', displayLabel: 'CONSOLIDATIONS.FIELDS.NAME', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'TotalQuantity', type: 'int', displayLabel: 'CONSOLIDATIONS.FIELDS.TOTAL_QUANTITY', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'TemplateId', type: 'text', displayLabel: 'CONSOLIDATIONS.FIELDS.TEMPLATE_ID', visible: false, creatable: true, editable: true, inputType: 'lookup', lookupSource: 'catalogs.consolidationTemplates',
                    lookupFilter: {Status: 1}, validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'TemplateName', type: 'text', displayLabel: 'CONSOLIDATIONS.FIELDS.TEMPLATE_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'FileName', type: 'text', displayLabel: 'CONSOLIDATIONS.FIELDS.FILE_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'FilePath', type: 'text', displayLabel: 'CONSOLIDATIONS.FIELDS.FILE_PATH', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'DownloadURL', type: 'text', displayLabel: 'CONSOLIDATIONS.FIELDS.DOWNLOAD_URL', visible: false, creatable: false, editable: false, inputType: 'calculated-url', calculatedExpression: 'data["FilePath"] + "/" + data["FileName"]',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'IncludeLockedOrders', type: 'text', displayLabel: 'CONSOLIDATIONS.FIELDS.INCLUDE_LOCKED_ORDERS', visible: true, creatable: false, editable: false, inputType: 'int-bool',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'LockOrders', type: 'text', displayLabel: 'CONSOLIDATIONS.FIELDS.LOCK_ORDERS', visible: true, creatable: false, editable: false, inputType: 'int-bool',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'IncludeRejectedOrders', type: 'text', displayLabel: 'CONSOLIDATIONS.FIELDS.CONSOLIDATE_UNAPPROVED_ORDERS', visible: true, creatable: false, editable: false, inputType: 'int-bool',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'IncludeChildCatalogs', type: 'text', displayLabel: 'CONSOLIDATIONS.FIELDS.INCLUDE_CHILD_CATALOGS', visible: true, creatable: false, editable: false, inputType: 'int-bool',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ConsolidationStatusId', type: 'int', displayLabel: 'CONSOLIDATIONS.FIELDS.CONSOLIDATION_STATUS_ID', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ConsolidationStatus', type: 'text', displayLabel: 'CONSOLIDATIONS.FIELDS.CONSOLIDATION_STATUS', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Status', type: 'text', displayLabel: 'CONSOLIDATIONS.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedDate', type: 'text', displayLabel: 'CONSOLIDATIONS.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedDate', type: 'text', displayLabel: 'CONSOLIDATIONS.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedBy', type: 'text', displayLabel: 'CONSOLIDATIONS.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedBy', type: 'text', displayLabel: 'CONSOLIDATIONS.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'PluginSource', type: 'text', displayLabel: 'CONSOLIDATIONS.FIELDS.PLUGIN_SOURCE', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'PluginVersion', type: 'text', displayLabel: 'CONSOLIDATIONS.FIELDS.PLUGIN_VERSION', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
            ],
            uniqueConstraints: [
            ],
            title: 'CONSOLIDATIONS.NAV',
            icon: 'icon-sigma',
            idField: 'Id',
            lookupDisplayField: 'Name',
            isDirty: false,
            isBulkActionCompleted: false,
            isCatalogSpecificModel: true,
            methods: {
                getList             :   getConsolidations,
                getDetails          :   getConsolidation,
                create              :   createConsolidation
            },
            views: {
                mainList: {
                    columns         : [ 'Name', 'ConsolidationStatus', 'FileName', 'TemplateName', 'Status', 'UpdatedDate' ],
                    columnFilter    : {},
                    toggleFilterProps: { toggleStatus:false, filterProp:'Status', trueVal:1, trueValTooltipMessage: 'ACTIONS.TOGGLE_ACTIVE', falseVal:'', falseValTooltipMessage:"ACTIONS.TOGGLE_ALL"},
                    topIndex        : 0,
                    showFilterRow   : false,
                    sortColumn      : {'UpdatedDate': false},
                    itemActions     : [
                                        { id: 'view', label: 'ACTIONS.VIEW', icon: 'icon-magnify', privilege: 'GetOrderConsolidationDetails', disabled: '!itm.Status', visible: true },
                                        { id: 'download', label: 'ACTIONS.DOWNLOAD', icon: 'icon-download', privilege: 'GetOrderConsolidationList:true', disabled: 'false', visible: true , url: true},
                                        { id: 'reRun', label: 'CONSOLIDATIONS.ACTIONS.RE_RUN', icon: 'icon-refresh', privilege: 'CreateOrderConsolidation,CreateOrderConsolidation_LockOrders:true', disabled: '!itm.Status', visible: true }
                                      ],
                    listActions     : [],
                    fabAction       :
                                        {id: 'add', label: 'CONSOLIDATIONS.ACTIONS.RUN', icon: 'icon-plus', privilege: 'CreateOrderConsolidation,CreateOrderConsolidation_LockOrders:true', visible: true}

                 },
                 mainDetails: {
                     selectedTabIndex   : 0,
                     itemActions        : [
                                                { id: 'download', label: 'ACTIONS.DOWNLOAD', icon: 'icon-download', privilege: 'GetOrderConsolidationDetails:true', disabled: 'false', visible: true , url: true},
                                          ],
                    fabAction           : {}

                 },
                privileges: {
                    list    : 'GetOrderConsolidationList',
                    details : 'GetOrderConsolidationDetails'
                }
            }
        };

        function getConsolidations(generalProperties, catalogCode) {
            var promise;

            if(angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
                var state = {};
                state.name = $state.current.name;
                state.params = $state.params;
                var isBulk = true;
                var logData = activityLogger.createLogData(null, state, 'catalogs.consolidations', 'VIEW', isBulk, new Date(), null, null);

                promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/consolidations', undefined, true, generalProperties.forceFetch);
                promise = activityLogger.log(logData, promise);
            }
            else {
                catalogCode = angular.isUndefined(catalogCode) ? catalogFactory.getActiveCatalog().CatalogCode : catalogCode;
                promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/consolidations', undefined, true, generalProperties.forceFetch);
            }

            promise.then(function() {
                if (api.catalogs.consolidations.isDirty) {
                    //Invalidate lookupData
                    api.catalogs.consolidations.lookupData = undefined;
                    api.catalogs.consolidations.isDirty = false;
                }
            });
            return promise;
		}

        function getConsolidation(isLogRequired, consolidationId, catalogCode) {
            var promise;
            if(angular.isDefined(isLogRequired) && isLogRequired === true) {
                 var state = {};
                state.name = $state.current.name;
                state.params = $state.params;
                var isBulk = false;
                var items= [];
                promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/consolidations/' + consolidationId + '?status=0');
                promise.then(function(response) {
                    items.push(response.data[api.catalogs.consolidations.lookupDisplayField]);
                }, function(response) {
                    items.push(response.data[api.catalogs.consolidations.lookupDisplayField]);
                });
                var logData = activityLogger.createLogData(items, state, 'catalogs.consolidations', 'VIEW', isBulk, new Date(), null, null);
                promise = activityLogger.log(logData, promise);
            }
            else {
                promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/consolidations/' + consolidationId + '?status=0');
            }
            return promise;
		}

		function createConsolidation(consolidation, catalogCode, canLockOrders) {
            var promise;
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var logData = activityLogger.createLogData(consolidation[api.catalogs.consolidations.lookupDisplayField], state, 'catalogs.consolidations', 'ADD', false, new Date(), null, null);
            if(canLockOrders) {
                if(angular.isDefined(consolidation) && angular.isDefined(consolidation.IncludeRejectedOrders)) {
                    delete consolidation.IncludeRejectedOrders;
                }
                promise = api.webPost(api.baseUrl + '/catalogs/' + catalogCode + '/consolidations/lockorders', consolidation);
            }
            else {
                promise = api.webPost(api.baseUrl + '/catalogs/' + catalogCode + '/consolidations', consolidation);
            }

            promise.then(function() {
                api.catalogs.consolidations.isDirty = true;
                if (canLockOrders) {
                    api.catalogs.orders.isDirty = true;
                }
            });
            return activityLogger.log(logData, promise);
		}

    }
})();
(function() {
    'use strict';

    angular
        .module('app.main.catalogs.consolidation-templates')
        .run(runBlock);

    /* @ngInject */
    function runBlock(api, activityLogger, $state, catalogFactory, toast) {

        if (angular.isUndefined(api.catalogs)) {
            api.catalogs = {};
        }
         api.catalogs.consolidationTemplates = {
            modelPath: 'catalogs.consolidationTemplates',
            fields: [
                { field: 'Id', type: 'int', displayLabel: 'CONSOLIDATION_TEMPLATES.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CatalogCode', type: 'int', displayLabel: 'CONSOLIDATION_TEMPLATES.FIELDS.CATALOG_CODE', visible: true, creatable: false, editable: false, inputType: 'lookup', lookupSource:'catalogs.catalogs',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'SellerAccountId', type: 'int', displayLabel: 'CONSOLIDATION_TEMPLATES.FIELDS.ACCOUNT_ID', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Name', type: 'text', displayLabel: 'CONSOLIDATION_TEMPLATES.FIELDS.NAME', visible: true, creatable: true, editable: true, inputType: 'text',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'TotalConsolidation', type: 'int', displayLabel: 'CONSOLIDATION_TEMPLATES.FIELDS.TOTAL_CONSOLIDATION', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ConsolidationPluginSource', type: 'text', displayLabel: 'CONSOLIDATION_TEMPLATES.FIELDS.CONSOLIDATION_PLUGIN', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ConsolidationPluginId', type: 'text', displayLabel: 'CONSOLIDATION_TEMPLATES.FIELDS.CONSOLIDATION_PLUGIN', visible: false, creatable: true, editable: true, inputType: 'lookup', lookupSource: 'plugins.consolidationPlugins',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ConsolidationPluginVersion', type: 'text', displayLabel: 'CONSOLIDATION_TEMPLATES.FIELDS.CONSOLIDATION_PLUGIN_VERSION', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Status', type: 'text', displayLabel: 'CONSOLIDATION_TEMPLATES.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedDate', type: 'text', displayLabel: 'CONSOLIDATION_TEMPLATES.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedDate', type: 'text', displayLabel: 'CONSOLIDATION_TEMPLATES.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedBy', type: 'text', displayLabel: 'CONSOLIDATION_TEMPLATES.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedBy', type: 'text', displayLabel: 'CONSOLIDATION_TEMPLATES.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
            ],
            uniqueConstraints: [
            ],
            title: 'CONSOLIDATION_TEMPLATES.NAV',
            icon: 'icon-table-column-width',
            idField: 'Id',
            lookupDisplayField: 'Name',
            isDirty: false,
            isBulkActionCompleted: false,
            isCatalogSpecificModel: true,
            methods: {
                getList             :   getConsolidationTemplates,
                getDetails          :   getConsolidationTemplate,
                activateBulk        :   activateConsolidationTemplates,
                create              :   createConsolidationTemplate,
                update              :   updateConsolidationTemplate,
                copyTemplates       :   copyTemplates
            },
            views: {
                mainList: {
                    columns         : [ 'Name', 'Status', 'UpdatedDate' ],
                    columnFilter    : {},
                    toggleFilterProps: { toggleStatus:false, filterProp:'Status', trueVal:1, trueValTooltipMessage: 'ACTIONS.TOGGLE_ACTIVE', falseVal:'', falseValTooltipMessage:"ACTIONS.TOGGLE_ALL"},
                    topIndex        : 0,
                    showFilterRow   : false,
                    sortColumn      : {'UpdatedDate': false},
                    itemActions     : [
                                        { id: 'view', label: 'ACTIONS.VIEW', icon: 'icon-magnify', privilege: 'GetOrderConsolidationTemplateDetails', disabled: '!itm.Status', visible: true },
                                        { id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UpdateOrderConsolidationTemplate:true', disabled: '!itm.Status || itm.TotalConsolidation > 0', visible: true },
                                        { id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'OrderConsolidationTemplateStatus:true', disabled: false, visible: 'itm.Status',
                                            requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                                        { id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'OrderConsolidationTemplateStatus:true', disabled: false, visible: '!itm.Status',
                                            requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
                                      ],
                    listActions     : [
                                        { id: 'delete', label: 'ACTIONS.DELETE_BULK', icon: 'icon-delete', privilege: 'OrderConsolidationTemplateStatus:true', disabled: '{selected: true, Status: 1}', visible: false,
                                            requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                                        { id: 'activate', label: 'ACTIONS.ACTIVATE_BULK', icon: 'icon-undo-variant', privilege: 'OrderConsolidationTemplateStatus:true', disabled: '{selected: true, Status: 0}', visible: false,
                                            requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
                                      ],
                    fabAction       :
                                        {id: 'add', label: 'ACTIONS.ADD', icon: 'icon-plus', privilege: 'CreateOrderConsolidationTemplate:true', visible: true}

                 },
                 mainDetails: {
                     selectedTabIndex   : 0,
                     itemActions        : [
                                            { id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'OrderConsolidationTemplateStatus:true', disabled: '{selected: true, Status: 1}',
                                                visible: true, requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                                            { id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'OrderConsolidationTemplateStatus:true', disabled: '{selected: true, Status: 0}',
                                                visible: true, requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
                                          ],
                    fab           : {id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UpdateOrderConsolidationTemplate:true', visible: true, disabled: '{Status: 1, TotalConsolidation: 0}'}

                 },
                privileges: {
                    list    : 'GetOrderConsolidationTemplateList',
                    details : 'GetOrderConsolidationTemplateDetails'
                }
            }
        };

        if (angular.isUndefined(api.consolidationTemplates)) {
            api.consolidationTemplates = {};
        }
        api.consolidationTemplates.templateFields = {
            fields: [
                { field: 'Id', type: 'text', displayLabel: 'DATA_SOURCE_TYPES.FIELDS.ID', visible: false, creatable: true, editable: true, inputType: 'text', isRequired: true, maxLen: -1 },
                { field: 'DatasetName', type: 'text', displayLabel: 'CURRENCIES.FIELDS.NAME', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: true, maxLen: -1 },
                { field: 'ColumnName', type: 'text', displayLabel: 'CURRENCIES.FIELDS.NAME', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: true, maxLen: -1 },
                { field: 'ColumnDatatype', type: 'text', displayLabel: 'CURRENCIES.FIELDS.NAME', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: true, maxLen: -1 },
                { field: 'ColumnMapping', type: 'text', displayLabel: 'CURRENCIES.FIELDS.NAME', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: true, maxLen: -1 },
                { field: 'Status', type: 'text', displayLabel: 'CURRENCIES.FIELDS.NAME', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: true, maxLen: -1 },

            ],
            idField: 'Id',
            lookupDisplayField: 'ColumnName',
            methods: {
                getList: getTemplateFields
            }
        };
        function getTemplateFields(generalProperties, catalogCode) {
            var promiss;

            if(angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
                var state = {};
                state.name = $state.current.name;
                state.params = $state.params;
                var isBulk = false;
                var logData = activityLogger.createLogData(null, state, 'consolidationTemplates.templateFields', 'VIEW', isBulk, new Date(), null, null);
                promiss = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/consolidationdataset', undefined, true, generalProperties.forceFetch);
                promiss = activityLogger.log(logData, promiss);
            }
            else {
                catalogCode = angular.isUndefined(catalogCode) ? catalogFactory.getActiveCatalog().CatalogCode : catalogCode;
                return api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/consolidationdataset', undefined, true, generalProperties.forceFetch);
            }
            return promiss;
        }

        function getConsolidationTemplates(generalProperties, catalogCode, sellerId) {
            var promise;

            if(angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
                var state = {};
                state.name = $state.current.name;
                state.params = $state.params;
                var isBulk = true;
                var logData = activityLogger.createLogData(null, state, 'catalogs.consolidationTemplates', 'VIEW', isBulk, new Date(), null, null);

                promise = api.webGet(api.baseUrl + '/sellers/' + sellerId + '/catalogs/' + catalogCode + '/consolidationtemplates', undefined, true, generalProperties.forceFetch);
                promise = activityLogger.log(logData, promise);
            }
            else {
                var activeCatalog = catalogFactory.getActiveCatalog();
                sellerId = activeCatalog.AccountId;
                catalogCode = angular.isUndefined(catalogCode) ? activeCatalog.CatalogCode : catalogCode;
                promise = api.webGet(api.baseUrl + '/sellers/' + sellerId + '/catalogs/' + catalogCode + '/consolidationtemplates', undefined, true, generalProperties.forceFetch);
            }

            promise.then(function() {
                if (api.catalogs.consolidationTemplates.isDirty) {
                    //Invalidate lookupData
                    api.catalogs.consolidationTemplates.lookupData = undefined;
                    api.catalogs.consolidationTemplates.isDirty = false;
                }
            });
            return promise;
		}

        function getConsolidationTemplate(isLogRequired, templateId, catalogCode, sellerId) {
            var promise;
            if(angular.isDefined(isLogRequired) && isLogRequired === true) {
                 var state = {};
                state.name = $state.current.name;
                state.params = $state.params;
                var isBulk = false;
                var items= [];
                promise = api.webGet(api.baseUrl + '/sellers/' + sellerId + '/catalogs/' + catalogCode + '/consolidationtemplates/' + templateId + '?status=0');
                promise.then(function(response) {
                    items.push(response.data[api.catalogs.consolidationTemplates.lookupDisplayField]);
                }, function(response) {
                    items.push(response.data[api.catalogs.consolidationTemplates.lookupDisplayField]);
                });
                var logData = activityLogger.createLogData(items, state, 'catalogs.consolidationTemplates', 'VIEW', isBulk, new Date(), null, null);
                promise = activityLogger.log(logData, promise);
            }
            else {
                promise = api.webGet(api.baseUrl + '/sellers/' + sellerId + '/catalogs/' + catalogCode + '/consolidationtemplates/' + templateId + '?status=0');
            }
            return promise;
		}

        function activateConsolidationTemplates(record, model, actionType, catalogCode, sellerId, consolidationTemplateId) {
            var requestObj = {status: -1};
            var toastMessageKey ="";
            if(actionType.toUpperCase() === 'DELETE') {
                requestObj.status = 0;
                toastMessageKey = 'SUCCESS.DELETE';
            }
            else if(actionType.toUpperCase() === 'ACTIVATE') {
                requestObj.status = 1;
                toastMessageKey = 'SUCCESS.ACTIVATE';
            }
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var isBulk = false;
            var logData = activityLogger.createLogData(record[api.catalogs.consolidationTemplates.lookupDisplayField], state, 'catalogs.consolidationTemplates', actionType.toUpperCase(), isBulk, new Date(), null, null);
            var promise = api.webPut(api.baseUrl + '/sellers/' + sellerId + '/catalogs/' + catalogCode + '/consolidationtemplates/' + consolidationTemplateId + '/status', requestObj);

             promise.then(function() {
                record.Status = requestObj.status;
                record.selected = false;
                api.catalogs.consolidationTemplates.isDirty = true;
                toast.success(toastMessageKey, '', '');
            });

            return activityLogger.log(logData, promise);
		}

		function createConsolidationTemplate(consolidationTemplate, catalogCode, sellerId) {
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var logData = activityLogger.createLogData(consolidationTemplate[api.catalogs.consolidationTemplates.lookupDisplayField], state, 'catalogs.consolidationTemplates', 'ADD', false, new Date(), null, null);
            var promise = api.webPost(api.baseUrl + '/sellers/' + sellerId + '/catalogs/' + catalogCode + '/consolidationtemplates', consolidationTemplate);

            promise.then(function() {
                api.catalogs.consolidationTemplates.isDirty = true;
            });
            return activityLogger.log(logData, promise);
		}

        function updateConsolidationTemplate(consolidationTemplateId, consolidationTemplate, catalogCode, sellerId) {
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var logData = activityLogger.createLogData(consolidationTemplate[api.catalogs.consolidationTemplates.lookupDisplayField], state, 'catalogs.consolidationTemplates', 'EDIT', false, new Date(), null, null);
            var promise = api.webPut(api.baseUrl + '/sellers/' + sellerId + '/catalogs/' + catalogCode + '/consolidationtemplates/' + consolidationTemplateId, consolidationTemplate);

            promise.then(function() {
                api.catalogs.consolidationTemplates.isDirty = true;
            });
            return activityLogger.log(logData, promise);
		}

        function copyTemplates(templates, catalogCode, sellerId) {
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var logData = activityLogger.createLogData(null, state, 'catalogs.consolidationTemplates', 'EDIT', false, new Date(), null, null);
            var promise = api.webPut(api.baseUrl + '/sellers/' + sellerId + '/catalogs/' + catalogCode + '/consolidationtemplates/copy', templates);

            promise.then(function() {
                api.catalogs.consolidationTemplates.isDirty = true;
            });
            return activityLogger.log(logData, promise);
		}

    }
})();
(function() {
    'use strict';

	angular
		.module('app.main.catalogs.change-logs')
		.controller('changeLogsController', changeLogsController);

	/* @ngInject */
	function changeLogsController(api, $rootScope, $scope, $state, $q, $document, $mdDialog, $timeout, catalogFactory) {
		/* jshint validthis: true */
		var vm = this;

        //Data
        var activeCatalog = catalogFactory.getActiveCatalog();
		var activeCatalogCode = activeCatalog.CatalogCode;

        vm.model = api.catalogs.changeLogs;

		vm.changeLogs = [];
		vm.filteredChangeLogs = [];

		vm.isLoading = false;


        //Methods
		vm.refreshItems = refreshItems;
        vm.viewChanges = viewChanges;


        activate();


		////////////////

        function activate() {
            refreshItems(vm.model.isDirty, true);
		}

		function refreshItems(forceFetch, isLogRequired) {
            var generalProperties = {
                forceFetch: forceFetch,
                isLogRequired: isLogRequired,
                filterByDate: vm.model.views.mainList.filterByDate
            }
            vm.isLoading = true;
            vm.model.methods.getList(generalProperties, activeCatalogCode).then(function (response) {
                processData(response.data, 0).then(function(data) {
                    vm.changeLogs = data;
                }).finally(function () {
                    vm.isLoading = false;
                });
            }).finally(function () {
                vm.isLoading = false;
            });
		}

        function processData(data, startFrom, promise) {
            var q = promise;
            var chunkSize = 500;

            if (angular.isUndefined(q)) {
                q = $q.defer();
            }

            for (var i=startFrom; i<data.length; i++) {
                if (i > startFrom+chunkSize) {
                    $timeout(function() {
                        processData(data, i, q);
                    }, 0);
                    return q.promise;
                }

                var j =  angular.fromJson(data[i].AC);
                data[i]['ChangeType'] = getChangeType(data[i].AC);
                data[i]['Changes'] = '';

                if (angular.isDefined(j)) {
                    data[i]['Changes'] = getChangesList(j);
                }
            }
            q.resolve(data);
            return q.promise;
        }

        function getChangesList(obj) {
            var c = [];

            angular.forEach(obj, function(o) {
                c.push(o.F);
            });

            return c.join(', ');
        }


        function viewChanges(item) {
            if(item['ChangeType'] !== 'new') {
                $mdDialog.show({
                    controller         : 'changesDialogController',
                    controllerAs       : 'vm',
                    templateUrl        : 'app/main/catalogs/sub-modules/change-logs/dialogs/changes.dialog.html',
                    parent             : angular.element($document.body),
                    targetEvent        : null,
                    clickOutsideToClose: true,
                    locals             : {
                        model : vm.model,
                        record: item
                    }
                });
            }
        }

        function getChangeType(changes) {
            if(changes == null) {
                return 'new';//new
            }
            else if(changes.indexOf("[{\"F\":\"Status\",\"O\":\"1\"") !== -1) {
                return 'dropped';//dropped
            }
            else if(changes.indexOf("[{\"F\":\"Status\",\"O\":\"0\",\"N\":\"1\"},{") !== -1){
                return 'reactivated with change'//reactivate with change
            }
            else if(changes.indexOf("[{\"F\":\"Status\",\"O\":\"0\",\"N\":\"1\"}") !== -1){
                return 'reactivated' //reacitvated
            }
            else {
                return 'changed';
            }
        }


        var catalogChangedEventCleanup = $rootScope.$on('ActiveCatalogChangedEvent', function(e) {
            if(activeCatalogCode !== catalogFactory.getActiveCatalog().CatalogCode) {
                $state.reload('app.change_logs');
            }
        });

        $scope.$on('$destroy', function () {
            catalogChangedEventCleanup();
        });

	}
})();
(function() {
    'use strict';

    angular
        .module('app.main.catalogs.change-logs')
        .run(runBlock);

    /* @ngInject */
    function runBlock(api, activityLogger, $state) {

        if (angular.isUndefined(api.catalogs)) {
            api.catalogs = {};
        }
        api.catalogs.changeLogs = {
            modelPath: 'catalogs.changeLogs',
            fields: [
                { field: 'Id', type: 'int', displayLabel: 'CHANGE_LOGS.FIELDS.ID', visible: false, creatable: false, editable: false, inputType: 'number' },
                { field: 'AId', type: 'int', displayLabel: 'CHANGE_LOGS.FIELDS.ARTICLE_ID', visible: false, creatable: false, editable: false, inputType: 'number'},
                { field: 'AN', type: 'text', displayLabel: 'CHANGE_LOGS.FIELDS.ARTICLE_NUMBER', visible: true, creatable: false, editable: false, inputType: 'text' },
                { field: 'PackageId', type: 'text', displayLabel: 'CHANGE_LOGS.FIELDS.PACKAGE_ID', visible: false, creatable: false, editable: false, inputType: 'lookup', lookupSource:'accounts.users'},
                { field: 'ChangeType', type: 'text', displayLabel: 'CHANGE_LOGS.FIELDS.CHANGE_TYPE', visible: true, creatable: false, editable: false, inputType: 'changedType' },
                { field: 'Changes', type: 'text', displayLabel: 'CHANGE_LOGS.FIELDS.CHANGES', visible: true, creatable: false, editable: false, inputType: 'text' },
                { field: 'PVId', type: 'text', displayLabel: 'CHANGE_LOGS.FIELDS.PACKAGE_VERSION', visible: true, creatable: false, editable: false, inputType: 'text'},
                { field: 'AC', type: 'text', displayLabel: 'CHANGE_LOGS.FIELDS.CHANGES', visible: false, creatable: false, editable: false, inputType: 'text' },
                { field: 'CB', type: 'text', displayLabel: 'CHANGE_LOGS.FIELDS.CHANGED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup', lookupSource:'accounts.users'},
                { field: 'CD', type: 'text', displayLabel: 'CHANGE_LOGS.FIELDS.CHANGED_DATE', visible: true, creatable: false, editable: false, inputType: 'date'}
            ],
            uniqueConstraints: [],
            title: 'CHANGE_LOGS.NAV',
            icon: 'icon-cube-outline',
            idField: 'Id',
            lookupDisplayField: 'PackageId',
            isDirty: false,
            isBulkActionCompleted: false,
            isCatalogSpecificModel: true,
            methods: {
                getList: getChangeLog,
            },
            views: {
                mainList: {
                    columns         : [ 'AN', 'ChangeType', 'Changes', 'PVId' ],
                    columnFilter    : {},
                    filterByDate    : {},
                    toggleFilterProps: undefined,
                    topIndex        : 0,
                    showFilterRow   : false,
                    sortColumn      : {'CD': false},
                    itemActions     : [],
                    listActions     : [],
                    fabAction       : {}

                },
                mainDetails: {},
                privileges: {
                    list    : 'GetCatalogChangeLogList'
                }
            }
        };

        function getChangeLog(generalProperties, catalogCode) {
            var promise;
            var url = api.baseUrl + '/catalogs/' + catalogCode + '/changelogs';
            if(generalProperties.filterByDate && angular.isDefined(generalProperties.filterByDate.startDate) && angular.isDefined(generalProperties.filterByDate.endDate)) {
                url = url + '?s=' + generalProperties.filterByDate.startDate + '&e=' + generalProperties.filterByDate.endDate;
            }

            if(angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
                var state = {};
                state.name = $state.current.name;
                state.params = $state.params;
                var isBulk = true;
                var logData = activityLogger.createLogData(null, state, 'catalogs.changeLogs', 'VIEW', isBulk, new Date(), null, null);

                promise = api.webGet(url, undefined, false, generalProperties.forceFetch);
                promise = activityLogger.log(logData, promise);
            }
            else {
                promise = api.webGet(url, undefined, false, generalProperties.forceFetch);
            }
            return promise;
		}

    }
})();
(function () {
	'use strict';

	angular
		.module('app.main.catalogs.models')
		.run(runBlock);

	/* @ngInject */
	function runBlock(api, activityLogger, $state, crud, jobsTracker, $q, $log, catalogFactory, utility, CONSTANTS) {

		if (angular.isUndefined(api.catalogs)) {
			api.catalogs = {};
		}
		api.catalogs.models = {
			modelPath: 'catalogs.models',
			fields: [
				{ field: 'ModelId', map:'ModelId', type: 'int', displayLabel: 'MODELS.FIELDS.MODEL_ID', visible: true, creatable: false, editable: false, inputType: 'number',
					validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'ModelId', type: 'int', displayLabel: 'MODELS.FIELDS.MODEL_NUMBER', visible: false, creatable: true, editable: false, inputType: 'lookup', lookupSource:'lists.availableCatalogModelList',
					validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'ModelNumber', map:'ModelNumber', type: 'text', displayLabel: 'MODELS.FIELDS.MODEL_NUMBER', visible: true, creatable: true, editable: false, showInEdit: true, inputType: 'text',
					validation: {isRequired: true, maxLen: 200, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'ModelName', map:'ModelName', type: 'text', displayLabel: 'MODELS.FIELDS.MODEL_NAME', visible: true, creatable: true, editable: false, inputType: 'text',
					validation: {isRequired: true, maxLen: 100, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'Status', map:'Status', type: 'text', displayLabel: 'MODELS.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'ModelLifecycle', map:'ModelLifecycle', type: 'text', displayLabel: 'MODELS.FIELDS.MODEL_LIFE_CYCLE', visible: true, creatable: false, editable: false, inputType: 'text',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'MasterModelId', map:'MasterModelId', type: 'int', displayLabel: 'MODELS.FIELDS.PARENT_MODEL_NUMBER', visible: false, creatable: false, editable: false, inputType: 'number',
					validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'ParentModelName', map:'ParentModelName', type: 'text', displayLabel: 'MODELS.FIELDS.PARENT_MODEL_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'ParentModelNumber', map:'ParentModelNumber', type: 'text', displayLabel: 'MODELS.FIELDS.PARENT_MODEL_NUMBER', visible: true, creatable: false, editable: false, inputType: 'text',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'LySkus', map:'LySkus', type: 'int', displayLabel: 'MODELS.FIELDS.LY_SKUS', visible: true, creatable: false, editable: false, inputType: 'number',
					validation: {isRequired: false, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'TySkus', map:'TySkus', type: 'int', displayLabel: 'MODELS.FIELDS.TY_SKUS', visible: true, creatable: false, editable: false, inputType: 'number',
					validation: {isRequired: false, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'ModelStateId', map:'ModelStateId', type: 'int', displayLabel: 'MODELS.FIELDS.MODEL_STATE', visible: true, creatable: false, editable: false, inputType: 'lookup', lookupSource:'catalogs.articleStates',
					validation: {isRequired: false, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'ModelStateRank', map:'ModelStateRank', type: 'int', displayLabel: 'MODELS.FIELDS.MODEL_STATE_RANK', visible: true, creatable: false, editable: false, inputType: 'number',
					validation: {isRequired: false, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'ModelSourceSeason', map:'ModelSourceSeason', type: 'text', displayLabel: 'MODELS.FIELDS.SEASON_MODEL_CARRIED_OVER_FROM', visible: true, creatable: false, editable: false, inputType: 'text',
					validation: {isRequired: false, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
					// following fields SizeScaleId, SizeScale properties like creatable visible etc will be set dynamically and they need to remain false in model
				{ field: 'SizeScaleId',  map:'SizeScaleId', type: 'int', displayLabel: 'SELLER_MODELS.FIELDS.SIZE_SCALE_ID', visible: false, creatable: false, editable: false, inputType: 'number',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'SizeScaleId', map:'SizeScaleId', type: 'int', displayLabel: 'SELLER_MODELS.FIELDS.SIZE_SCALE', visible: false, creatable: false, editable: false, inputType: 'lookup', lookupSource: 'lists.availableSizeScaleForModel',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'MasterSizeScale',  map:'MasterSizeScale', type: 'text', displayLabel: 'MODELS.FIELDS.MASTER_SIZE_SCALE', visible: false, creatable: false, editable: false, inputType: 'text',
						validation: {isRequired: true, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'SizeScale', map:'SizeScale', type: 'text', displayLabel: 'SELLER_MODELS.FIELDS.SIZE_SCALE', visible: false, creatable: false, editable: false, inputType: 'text',
					validation: {isRequired: true, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'MasterSizeScaleId', map:'MasterSizeScaleId',type: 'int', displayLabel: 'SELLER_MODELS.FIELDS.MASTER_SIZE_SCALE_ID', visible: false, creatable: false, editable: false, inputType: 'number',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
					// above fields SizeScaleId, SizeScale properties like creatable visible etc will be set dynamically and they need to remain false in model
				{ field: 'CreatedDate', map:'CreatedDate', type: 'text', displayLabel: 'MODELS.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'UpdatedDate', map:'UpdatedDate', type: 'text', displayLabel: 'MODELS.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'CreatedBy', map:'CreatedBy', type: 'text', displayLabel: 'MODELS.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'UpdatedBy', map:'UpdatedBy', type: 'text', displayLabel: 'MODELS.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'ActivationDate', map:'ActivationDate', type: 'text', displayLabel: 'MODELS.FIELDS.REACTIVATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'DropDate', map:'DropDate', type: 'text', displayLabel: 'MODELS.FIELDS.DROP_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				],
			uniqueConstraints: [],
			title: 'MODELS.NAV',
			idField: 'ModelId',
			lookupDisplayField: 'ModelNumber',
			isDirty: false,
			isCatalogSpecificModel: true,
			validateStateEditableFields: true,
			methods: {
				getList   : getCatalogModelsList,
				getDetails: getCatalogModelDetails,
				create    : createCatalogModel,
				update    : updateCatalogModel,
				activateBulk : activateCatalogModels,
				setSizeScaleBulk: setSizeScaleBulk,
				updateBulk           : updateBulk,
				updateViaImport      : updateViaImport
			},
			views: {
				mainList: {
					columns: ['ModelId', 'ModelNumber', 'ModelName'],
					columnFilter: {},
					toggleFilterProps: {},
					topIndex: 0,
					showFilterRow: false,
					sortColumn: {'UpdatedDate': false},
					itemActions: [
						{ id: 'view', label: 'ACTIONS.VIEW', icon: 'icon-magnify', privilege: 'GetCatalogTrueModelDetails', disabled: false, visible: true },
						{ id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UpdateCatalogTrueModel', disabled: false, visible: true},
						// { id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateCatalogTrueModelStatus:true', disabled: false, visible: 'itm.Status',
						// 	requiresConfirmation: false, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
						// { id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateCatalogTrueModelStatus:true', disabled: false, visible: '!itm.Status',
						// 	requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'},
						{ id: 'SetSizes', label: 'MODELS.ACTIONS.SET_SIZES', icon: 'icon-layers', privilege: 'AssignCatalogModelSizeScale:true', disabled: false, visible: false }
						// SetSizes will be visible dynamically
					],
					listActions: [
							// { id: 'delete', label: 'ACTIONS.DELETE_BULK', icon: 'icon-delete', privilege: 'UpdateCatalogTrueModelStatus:true', disabled: '{selected: true, Status: 1}', visible: true,
							// 	requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
							// { id: 'activate', label: 'ACTIONS.ACTIVATE_BULK', icon: 'icon-undo-variant', privilege: 'UpdateCatalogTrueModelStatus:true', disabled: '{selected: true, Status: 0}', visible: true,
							// 	requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'},
							{ id: 'SetSizes', label: 'MODELS.ACTIONS.SET_SIZES_BULK', icon: 'icon-layers', privilege: 'BulkAssignCatalogModelSizeScale:true', disabled: false, emptyListDisabled: true, visible: false, requiresConfirmation: false},
								// SetSizes will be visible dynamically
							{ id: 'updateBulk', label: 'ACTIONS.UPDATE_BULK', icon: 'icon-pencil', privilege: 'UpdateBulkModels:true', disabled: '{selected: true}', visible: true, requiresConfirmation: false },
							{ id: 'updateViaImport', label: 'ACTIONS.UPDATE_VIA_IMPORT', icon: 'icon-import', privilege: 'UpdateBulkModels:true', disabled: false, visible: true, requiresConfirmation: false}
					],
					fabAction: {id: 'add', label: 'ACTIONS.ADD', icon: 'icon-plus', privilege: 'CreateCatalogTrueModel:true', visible: true}
				},
				mainDetails: {
					selectedTabIndex   : 0,
					itemActions        : [
						// { id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateCatalogTrueModelStatus:true', disabled: '{selected: true, Status: 1}',
						// 	visible: true, requiresConfirmation: false, confirmationContent: {title: 'ARTICLES.TITLES.DELETE_ALERT', message: 'ARTICLES.MESSAGES.CONFIRM_DROP'},
						// 	confirmationAction: 'ACTIONS.DELETE'},
						// { id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateCatalogTrueModelStatus:true', disabled: '{selected: true, Status: 0}',
						// 	visible: true, requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'},
					],
					fab               : {id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UpdateCatalogTrueModel', visible: true}
				},
				privileges: {
					list: 'GetCatalogTrueModels',
					details : 'GetCatalogTrueModelDetails'
				}
			}

		};

		function getCatalogModelsList(generalProperties, model, catalogId) {
			if (angular.isDefined(model)) { // to skip this part for load lookup
				model.isBulkActionCompleted = false;
			}
			var promise;

			if (angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
				var state = {};
				state.name = $state.current.name;
				state.params = $state.params;
				var isBulk = true;
				var logData = activityLogger.createLogData(null, state, 'catalogs.models', 'VIEW', isBulk, new Date(), null, null);

				promise = api.webGet(api.baseUrl + '/catalogs/' + catalogId + '/true/models',
				generalProperties.config || {}, true, generalProperties.forceFetch,
				generalProperties.supportIncrementalResult || true,
				generalProperties.modelIdField,
				generalProperties.isMajor || false,
				model || api.catalogs.models);
				promise = activityLogger.log(logData, promise);
				promise = activityLogger.log(logData, promise);
			}
			else {
				catalogId = angular.isUndefined(catalogId) ? catalogFactory.getActiveCatalog().CatalogCode : catalogId;
				promise = api.webGet(api.baseUrl + '/catalogs/' + catalogId + '/true/models',
				generalProperties.config || {}, true, generalProperties.forceFetch,
				generalProperties.supportIncrementalResult || true,
				generalProperties.modelIdField,
				generalProperties.isMajor || false,
				model || api.catalogs.models);
			}

			promise.then(function () {
				if (api.catalogs.models.isDirty) {
					//Invalidate lookupData
					api.catalogs.models.lookupData = undefined;
					api.catalogs.models.isDirty = false;
				}
			});
			return promise;
		}

		function getCatalogModelDetails(isLogRequired, modelId, catalogCode) {
			var promise;
			if (angular.isDefined(isLogRequired) && isLogRequired === true) {
				var state = {};
				state.name = $state.current.name;
				state.params = $state.params;
				var isBulk = false;
				var items = [];
				promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/true/models/' + modelId);
				promise.then(function (response) {
					items.push(response.data[api.catalogs.models.lookupDisplayField]);
				}, function (response) {
					items.push(response.data[api.catalogs.models.lookupDisplayField]);
				});
				var logData = activityLogger.createLogData(items, state, 'catalogs.models', 'VIEW', isBulk, new Date(), null, null);
				promise = activityLogger.log(logData, promise);
			}
			else {
				promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/true/models/' + modelId);
			}
			return promise;
		}

		function createCatalogModel(record, catalogCode, model) {
			var state = {};
			state.name = $state.current.name;
			state.params = $state.params;
			angular.forEach(model.fields, function(item) {
				var isDefaultValueAssigned = angular.isDefined(item.DefaultValue) && item.DefaultValue != null && item.DefaultValue !== '' ? true : false;
				if(!item.creatable && !isDefaultValueAssigned) {
					delete record[item.field];
				}
			});
			var logData = activityLogger.createLogData(record[api.catalogs.models.lookupDisplayField], state, 'catalogs.models', 'ADD', false, new Date(), null, null);
			var promise = api.webPost(api.baseUrl + '/catalogs/' + catalogCode + '/true/models', record);

			promise.then(function() {
				api.catalogs.models.isDirty = true;
			});
			return activityLogger.log(logData, promise);
		}

		function updateCatalogModel(modelId, record, catalogCode, model, oldRecord) {
			var state = {};
			state.name = $state.current.name;
			state.params = $state.params;
			var updatedRecord = {};
			// remove non edited properties from request
			angular.forEach(model.fields, function(field) {
				if(!(angular.isDefined(field.catalogEntityId) || field.inputType === 'calculated' || (record[field.field] === oldRecord[field.field]) || ((field.inputType === 'tags' || field.inputType === 'multi-value') && isArraysAreEqual(record[field.field], oldRecord[field.field])))) {
					updatedRecord[field.field] = record[field.field];
				}
			});
			var logData = activityLogger.createLogData(record[api.catalogs.models.lookupDisplayField], state, 'catalogs.models', 'ADD', false, new Date(), null, null);
			var promise = api.webPut(api.baseUrl + '/catalogs/' + catalogCode + '/true/models/' + modelId + '?clientapp=t1ui', updatedRecord);

			promise.then(function () {
				api.catalogs.models.isDirty = true;
			});
			return activityLogger.log(logData, promise);
		}

		function isArraysAreEqual(arr1, arr2) {
			if (arr1.length !== arr2.length) {
					return false;
			}
			for (var i = 0; i < arr1.length; i++) {
					if (arr1[i] !== arr2[i]) {
							return false;
					}
			}
			return true;
		}

		function activateCatalogModels(records, model, actionType, parentId) {
			var result = crud.createRequestObject(records, model, actionType);
			var state = {};
			state.name = $state.current.name;
			state.params = $state.params;
			var isBulk = result.itemsNameList.length > 1 ? true : false;
			var logData = activityLogger.createLogData(result.itemsNameList, state, 'catalogs.models', actionType.toUpperCase(), isBulk, new Date(), null, null);
			var promise = api.webPut(api.baseUrl + '/catalogs/' + parentId + '/true/models/status', result.requestObj);

			promise.then(function() {
				crud.onRecordStatusChange(records, api.catalogs.models.isDirty, actionType);
			});

			return activityLogger.log(logData, promise);
		}

		function setSizeScaleBulk(model, results, sellerId, attributeGroupId, sellerModels, sizeScaleGroupsPromise, masterSizeScalesPromise) {
			var deferred = $q.defer();
			var promise = deferred.promise;
			var requestbody = [];
			var modelsMap = {};
			// create models map
			angular.forEach(sellerModels, function(model) {
					if(angular.isUndefined(modelsMap[model.ModelNumber])) {
						modelsMap[model.ModelNumber] = model;
					}
			});

			masterSizeScalesPromise.then(function(masterSizeScaleResponse) {
				var masterSizeScales = masterSizeScaleResponse.data;
				var masterSizeScaleMap = {};

				// create masterSizeScales map
				angular.forEach(masterSizeScales, function(masterSizeScale) {
					masterSizeScaleMap[masterSizeScale.SizeScale] = masterSizeScale.Id;
				});

				sizeScaleGroupsPromise.then(function(sizeScaleGroupsResponse) {
					var sizeScaleGroups = sizeScaleGroupsResponse.data;

					for (var i = 0; i < results.length; i++) {
						var masterSizeScaleName = '';
						var masterSizeScaleId = '';
						if(results[i].MasterSizeScale != null) { // from import we get MAsterSizeScaleName
							masterSizeScaleName = results[i].MasterSizeScale;
							masterSizeScaleId = masterSizeScaleMap[masterSizeScaleName];
						} else {
							// from set sizes we get the MasterSizeScaleID
							masterSizeScaleId = results[i].MasterSizeScaleId;
						}
						var sizeScaleName = results[i].SizeScale;
						var sizeScaleId = utility.getSizeScaleIdByMasterSizeScaleIdAndSizeScaleName(masterSizeScaleId, sizeScaleName, sizeScaleGroups);

						if (sizeScaleId) {
							var requestObject = {
								SizeScaleId: sizeScaleId,
								ModelId: modelsMap[results[i].ModelNumber].ModelId
							};
							requestbody.push(requestObject);
						} else {
							console.log('Size scale not found for MasterSizeScaleName: ' + masterSizeScaleName + ' and SizeScale: ' + sizeScaleName);
						}
					}

					var jobIndex = jobsTracker.addJob(model, 'SELLER_MODELS.ACTIONS.SET_SIZES_BULK', 1);
					api.webPut(api.baseUrl + '/sellers/' + sellerId + '/' + attributeGroupId + '/models/bulkassignsizescale?sourceapplication=' + CONSTANTS.SOURCE_APPLICATION + '&sourceaction=Set Catalog Models Sizes(Bulk)', requestbody).then(function(response) {
							jobsTracker.trackJob(jobIndex, response.data.Id);
					}).catch(function(error) {
							jobsTracker.setCriticlaFail(jobIndex, error);
					});
				}).catch(function(error) {
					$log.error('Error in set sizes bulk', error);
					deferred.reject(error);
				});
			}).catch(function(error) {
				$log.error('Error in retrieving master size scales', error);
				deferred.reject(error);
			});
			return promise;
		}

		function updateBulk(model, records, updateRecord, idMap) {
			var requestBody = [];
			angular.forEach(records, function (record) {
					var requestObject = {ModelNumber: record.ModelNumber}
					for (var prop in updateRecord) {
						if(record[prop] !== updateRecord[prop]) {
							requestObject[prop] = updateRecord[prop];
						}
						// add ParentModelNumber is present
						if(prop === 'ParentModelNumber' && updateRecord[prop] != null) {
							requestObject[prop] = updateRecord[prop];
						}
					}
					requestBody.push(requestObject);
			});

			var jobIndex = jobsTracker.addJob(model, 'MODELS.ACTIONS.UPDATE_BULK', 1);
			api.webPut(api.baseUrl + '/catalogs/' + idMap.catalogId + '/updatebulkmodels?sourceapplication=' + CONSTANTS.SOURCE_APPLICATION + '&sourceaction=Update Bulk Catalog Models', requestBody).then(function(response) {
				jobsTracker.trackJob(jobIndex, response.data.Id);
			}).catch(function(error) {
				jobsTracker.setCriticlaFail(jobIndex, error);
			});
		}

		function updateViaImport(model, data, activeCatalog) {
			angular.forEach(data, function(model) {
				// remove parent model number field. if type is parent we should not send this field to API
				if(angular.isDefined(model.parent_model_type) && model.parent_model_type.toString().toLowerCase() === 'parent') {
					delete model['ParentModelNumber']
				}
			});
			var jobIndex = jobsTracker.addJob(model, 'MODELS.ACTIONS.UPDATE_VIA_IMPORT', 1);
			api.webPut(api.baseUrl + '/catalogs/' + activeCatalog.CatalogCode + '/updatebulkmodels?sourceapplication=' + CONSTANTS.SOURCE_APPLICATION + '&sourceaction=Update via Import Catalog Models', data).then(function(response) {
				jobsTracker.trackJob(jobIndex, response.data.Id);
			}).catch(function(error) {
				jobsTracker.setCriticlaFail(jobIndex, error);
			});
		}

	}
})();
(function() {
	'use strict';

	angular
		.module('app.main.catalogs.buyer-limits')
		.run(runBlock);

	/* @ngInject */
	function runBlock(api, catalogFactory, crud) {

		if (angular.isUndefined(api.catalogs)) {
				api.catalogs = {};
		}
		api.catalogs.buyerLimits = {
			modelPath: 'catalogs.buyerLimits',
			fields: [
				{ field: 'Id',  type: 'int', displayLabel: 'BUYER_LIMITS.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
						validation: {isRequired: false, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'Name',  type: 'text', displayLabel: 'BUYER_LIMITS.FIELDS.NAME', visible: true, creatable: true, editable: true, inputType: 'text', checkIfUnique: true,
						validation: {isRequired: true, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'Status',  map:'Status', type: 'text', displayLabel: 'BUYER_LIMITS.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
						validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'CreatedDate', type: 'text', displayLabel: 'BUYER_LIMITS.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
						validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'UpdatedDate', type: 'text', displayLabel: 'BUYER_LIMITS.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
						validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'CreatedBy', type: 'text', displayLabel: 'BUYER_LIMITS.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
						validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'UpdatedBy', type: 'text', displayLabel: 'BUYER_LIMITS.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
						validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				],
			uniqueConstraints: [],
			atLeastOneRequiredConstraints: [],
			title: 'BUYER_LIMITS.NAV',
			icon: 'icon-file-delimited',
			idField: 'Id',
			lookupDisplayField: 'Name',
			isDirty: false,
			isBulkActionCompleted: false,
			isCatalogSpecificModel: true,
			methods: {
				getList     : getBuyerLimits,
				getDetails  : getBuyerLimit,
				create      : createBuyerLimit,
				update      : updateBuyerLimit,
				activate    : activateBuyerLimits
			},
			views: {
				mainList: {
					columns         	: [ 'Id', 'Name', 'Status', 'UpdatedDate', 'UpdatedBy' ],
					columnFilter    	: {},
					toggleFilterProps	: {},
					topIndex        	: 0,
					showFilterRow   	: false,
					sortColumn      	: {'UpdatedDate': false},
					sortDescending  	: true,
					itemActions     	: [
																{ id: 'view', label: 'ACTIONS.VIEW', icon: 'icon-magnify', privilege: 'GetBuyerAccountDetails', disabled: '!itm.Status', visible: true },
																{ id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UpdateTarget:true', disabled: false, visible: true },
																{ id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateBuyerLimitStatuses:true', disabled: false, visible: 'itm.Status',
																		requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
																{ id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateBuyerLimitStatuses:true', disabled: false, visible: '!itm.Status',
																		requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
															],
					listActions       : [
																{ id: 'delete', label: 'ACTIONS.DELETE_BULK', icon: 'icon-delete', privilege: 'UpdateBuyerLimitStatuses:true', disabled: '{selected: true, Status: 1}', visible: true,
																		requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
																{ id: 'activate', label: 'ACTIONS.ACTIVATE_BULK', icon: 'icon-undo-variant', privilege: 'UpdateBuyerLimitStatuses:true', disabled: '{selected: true, Status: 0}', visible: true,
																		requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'},
															],
					fabAction         : {id: 'add', label: 'ACTIONS.ADD', icon: 'icon-plus', privilege: 'CreateBuyerLimit:true', visible: true}
				},
				mainDetails: {
					selectedTabIndex   : 0,
					itemActions        : [
																{ id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateBuyerLimitStatuses', disabled: '{selected: true, Status: 1}',
																		visible: true, requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'},confirmationAction: 'ACTIONS.DELETE'},
																{ id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateBuyerLimitStatuses', disabled: '{selected: true, Status: 0}',
																		visible: true, requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
															],
					fabAction          : {id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UpdateBuyerLimit', visible: true}
				},
				privileges: {
					list    : 'GetBuyerLimits',
					details : 'GetBuyerLimitDetails'
				}
			}
		};


		function getBuyerLimits(generalProperties, model, catalogCode) {
			if (angular.isDefined(model)) {
				model.isBulkActionCompleted = false;
			}
			var promise;
			catalogCode = angular.isUndefined(catalogCode) ? catalogFactory.getActiveCatalog().CatalogCode : catalogCode;
			promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/buyerlimits', undefined, true, generalProperties.forceFetch);

			promise.then(function () {
				if (api.catalogs.buyerLimits.isDirty) {
					//Invalidate lookupData
					api.catalogs.buyerLimits.lookupData = undefined;
					api.catalogs.buyerLimits.isDirty = false;
				}
			});
			return promise;
		}

		function getBuyerLimit(buyerLimitId, catalogCode) {
			var promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/buyerlimits/' + buyerLimitId);
			return promise;
		}

		function createBuyerLimit(record, catalogCode) {
			var promise = api.webPost(api.baseUrl + '/catalogs/' + catalogCode + '/buyerlimits', record);

			promise.then(function () {
				api.catalogs.buyerLimits.isDirty = true;
			});
			return promise;
		}

		function updateBuyerLimit(recordId, record, catalogCode) {
			var promise = api.webPut(api.baseUrl + '/catalogs/' + catalogCode + '/buyerlimits/' + recordId, record);

			promise.then(function () {
				api.catalogs.buyerLimits.isDirty = true;
			});
			return promise;
		}

		function activateBuyerLimits(records, model, actionType, catalogCode) {
				var result = crud.createRequestObject(records, model, actionType);
				var promise = api.webPut(api.baseUrl + '/catalogs/' + catalogCode + '/buyerlimits/status', result.requestObj);

				promise.then(function() {
						crud.onRecordStatusChange(records, api.catalogs.buyerLimits, actionType);
				});
				return promise;
		}

	}
})();
(function() {
		'use strict';

		angular
				.module('app.main.catalogs.buy-windows')
				.run(runBlock);

		/* @ngInject */
		function runBlock(api, activityLogger, $state, crud, catalogFactory) {

				if (angular.isUndefined(api.catalogs)) {
						api.catalogs = {};
				}

				api.catalogs.buyWindows = {
						modelPath: 'catalogs.buyWindows',
						fields: [
								{ field: 'Id', type: 'int', displayLabel: 'BUY_WINDOWS.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'Name', type: 'text', displayLabel: 'BUY_WINDOWS.FIELDS.NAME', visible: true, creatable: true, editable: true, inputType: 'text', checkIfUnique: true,
										validation: {isRequired: true, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'Description', type: 'text', displayLabel: 'BUY_WINDOWS.FIELDS.DESCRIPTION', visible: true, creatable: true, editable: true, inputType: 'text',
										validation: {isRequired: true, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'CatalogCode', type: 'int', displayLabel: 'BUY_WINDOWS.FIELDS.CATALOG_CODE', visible: true, creatable: false, editable: false, inputType: 'text',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'SortOrder', type: 'int', displayLabel: 'BUY_WINDOWS.FIELDS.SORT_ORDER', visible: true, creatable: true, editable: true, inputType: 'number',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'AcceptForecasts', type: 'text', displayLabel: 'BUY_WINDOWS.FIELDS.ACCEPT_FORECASTS', visible: true, creatable: true, editable: true, inputType: 'bool-int',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'Status', type: 'text', displayLabel: 'BUY_WINDOWS.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'CreatedBy', type: 'text', displayLabel: 'BUY_WINDOWS.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'UpdatedBy', type: 'text', displayLabel: 'BUY_WINDOWS.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'CreatedDate', type: 'text', displayLabel: 'BUY_WINDOWS.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'UpdatedDate', type: 'text', displayLabel: 'BUY_WINDOWS.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
						],
						title: 'BUY_WINDOWS.NAV',
						icon: 'icon-view-carousel',
						idField: 'Id',
						lookupDisplayField: 'Name',
						isDirty: false,
						isBulkActionCompleted: false,
						isCatalogSpecificModel: true,
						methods: {
								getList       :   getBuyWindowList,
								create        :   createBuyWindow,
								update        :   updateBuyWindow,
								activateBulk  :   activateBuyWindows
						},
						views: {
								mainList: {
										columns         : [ 'Name', 'Description', 'AcceptForecasts', 'SortOrder', 'Status', 'UpdatedDate', 'UpdatedBy' ],
										columnFilter    : {},
										toggleFilterProps: { toggleStatus:false, filterProp:'Status', trueVal:1, trueValTooltipMessage: 'ACTIONS.TOGGLE_ACTIVE', falseVal:'', falseValTooltipMessage:"ACTIONS.TOGGLE_ALL"},
										topIndex        : 0,
										showFilterRow   : false,
										sortColumn      : {'UpdatedDate': false},
										itemActions     : [
																					{ id: 'view', label: 'ACTIONS.VIEW', icon: 'icon-magnify', privilege: 'GetBuyWindowsList', disabled: '!itm.Status', visible: true },
																					{ id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UpdateBuyWindow', disabled: '!itm.Status', visible: true },
																					{ id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateBuyWindowStatus:true', disabled: 'itm._disabled', visible: 'itm.Status',
																							requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
																					{ id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateBuyWindowStatus:true', disabled: false, visible: '!itm.Status',
																							requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
																			],
										listActions     : [		 // isKeepAtleastOneActiveEnabled is to disable delete button when user selects all the records atleast one should be always enabled
																					{ id: 'delete', label: 'ACTIONS.DELETE_BULK', icon: 'icon-delete', privilege: 'UpdateBuyWindowStatus:true', disabled: '{selected: true, Status: 1}', visible: true, isKeepAtleastOneActiveEnabled: true,
																							requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
																					{ id: 'activate', label: 'ACTIONS.ACTIVATE_BULK', icon: 'icon-undo-variant', privilege: 'UpdateBuyWindowStatus:true', disabled: '{selected: true, Status: 0}', visible: true,
																							requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
																			],
										fabAction       :
																			{id: 'add', label: 'ACTIONS.ADD', icon: 'icon-plus', privilege: 'CreateBuyWindow', visible: true}
								 },
								 mainDetails: {
									selectedTabIndex   : 0,
									itemActions        : [
																					{ id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateBuyWindowStatus:true', disabled: '{selected: true, Status: 1}',
																							visible: true, requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
																					{ id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateBuyWindowStatus:true', disabled: '{selected: true, Status: 0}',
																							visible: true, requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
																				]
								},
								privileges: {
										list    : 'GetBuyWindowsList',
										details : 'GetBuyWindowsList'
								}
						}
				};

				function getBuyWindowList(generalProperties, catalogCode) {
						var promise;
						if (angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
								var state = {};
								state.name = $state.current.name;
								state.params = $state.params;
								var isBulk = true;
								var logData = activityLogger.createLogData(null, state, 'catalogs.buyWindows', 'VIEW', isBulk, new Date(), null, null);

								promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/buywindows', undefined, true, generalProperties.forceFetch);
								promise = activityLogger.log(logData, promise);
						}
						else {
								catalogCode = angular.isUndefined(catalogCode) ? catalogFactory.getActiveCatalog().CatalogCode : catalogCode;
								promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/buywindows', undefined, true, generalProperties.forceFetch);
						}

						promise.then(function () {
								if (api.catalogs.buyWindows.isDirty) {
										//Invalidate lookupData
										api.catalogs.buyWindows.lookupData = undefined;
										api.catalogs.buyWindows.isDirty = false;
								}
						});
						return promise;
				}

				function createBuyWindow(record, catalogCode) {
						var state = {};
						state.name = $state.current.name;
						state.params = $state.params;
						var logData = activityLogger.createLogData(record[api.catalogs.buyWindows.lookupDisplayField], state, 'catalogs.buyWindows', 'ADD', false, new Date(), null, null);
						var promise = api.webPost(api.baseUrl + '/catalogs/' + catalogCode + '/buywindows', record);

						promise.then(function() {
							api.catalogs.buyWindows.isDirty = true;
						});
						return activityLogger.log(logData, promise);
				}

				function updateBuyWindow(recordId, record, catalogCode) {
						var state = {};
						state.name = $state.current.name;
						state.params = $state.params;
						var logData = activityLogger.createLogData(record[api.catalogs.buyWindows.lookupDisplayField], state, 'catalogs.buyWindows', 'ADD', false, new Date(), null, null);
						var promise = api.webPut(api.baseUrl + '/catalogs/' + catalogCode + '/buywindows/' + recordId, record);

						promise.then(function () {
							api.catalogs.buyWindows.isDirty = true;
						});
						return activityLogger.log(logData, promise);
				}

				function activateBuyWindows(records, model, actionType, catalogCode) {
						var result = crud.createRequestObject(records, model, actionType);
						var state = {};
						state.name = $state.current.name;
						state.params = $state.params;
						var isBulk = result.itemsNameList.length > 1 ? true : false;
						var logData = activityLogger.createLogData(result.itemsNameList, state, 'catalogs.buyWindows', actionType.toUpperCase(), isBulk, new Date(), null, null);
						var promise = api.webPut(api.baseUrl + '/catalogs/' + catalogCode + '/buywindows/status', result.requestObj);

						promise.then(function () {
								crud.onRecordStatusChange(records, api.catalogs.buyWindows, actionType);
						});

						return activityLogger.log(logData, promise);
				}

		}
})();
(function() {
    'use strict';

    angular
        .module('app.main.catalogs.assortments')
        .run(runBlock);

    /* @ngInject */
    function runBlock(api, activityLogger, $state, crud) {

        if (angular.isUndefined(api.catalogs)) {
            api.catalogs = {};
        }
         api.catalogs.folders = {
            modelPath: 'catalogs.folders',
            fields: [
                { field: 'Id', type: 'int', displayLabel: 'FOLDERS.FIELDS.ID', visible: false, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ParentFolderId', type: 'int', displayLabel: 'FOLDERS.FIELDS.PARENT_FOLDER_ID', visible: false, creatable: false, editable: false, inputType: 'lookup',  lookupSource: 'lists.dataSourceTypes',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CatalogCode', type: 'int', displayLabel: 'FOLDERS.FIELDS.CATALOG_CODE', visible: false, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Name', type: 'text', displayLabel: 'FOLDERS.FIELDS.NAME', visible: false, creatable: true, editable: true, inputType: 'text',
                    validation: {isRequired: true, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'SortOrder', type: 'text', displayLabel: 'FOLDERS.FIELDS.SORT_ORDER', visible: false, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Status', type: 'text', displayLabel: 'FOLDERS.FIELDS.STATUS', visible: false, creatable: false, editable: false, inputType: 'status',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedDate', type: 'text', displayLabel: 'FOLDERS.FIELDS.CREATED_DATE', visible: false, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedDate', type: 'text', displayLabel: 'FOLDERS.FIELDS.UPDATED_DATE', visible: false, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedBy', type: 'text', displayLabel: 'FOLDERS.FIELDS.CREATED_BY', visible: false, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedBy', type: 'text', displayLabel: 'FOLDERS.FIELDS.UPDATED_BY', visible: false, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
            ],
            title: 'FOLDERS.NAV',
            icon: 'icon-folder',
            idField: 'Id',
            lookupDisplayField: 'Name',
            isDirty: false,
            isBulkActionCompleted: false,
            isCatalogSpecificModel: true,
            methods: {
                getList         :   getFolders,
                getDetails      :   getFolder,
                activateBulk    :   activateFolders,
                create          :   createFolder,
                update          :   updateFolder,
                updateBulk      :   updateFolders
            },
            views: {
                mainList: {
                    columns         : [ 'CatalogCode', 'CatalogName', 'DataSourceType', 'ReferenceCatalogCode', 'Status', 'UpdatedDate' ],
                    columnFilter    : {},
                    topIndex        : 0,
                    showFilterRow   : false,
                    sortColumn      : {'UpdatedDate': false},
                    itemActions     : [
                                        { id: 'addFolder', label: 'FOLDERS.ACTIONS.ADD_FOLDER', icon: 'icon-plus', privilege: 'CreateAssortmentFolder:true', disabled: '!node.Status || !node.ancestorDisabledStatus', visible: true },
                                        { id: 'addAssortment', label: 'FOLDERS.ACTIONS.ADD_ASSORTMENT', icon: 'icon-plus', privilege: 'CreateAssortmentDefination:true', disabled: '!node.Status || !node.ancestorDisabledStatus', visible: true },
                                        { id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UpdateAssortmentFolder:true', disabled: '!node.Status || !node.ancestorDisabledStatus', visible: true },
                                        { id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateBulkCatalogStatus:true', disabled: '!node.ancestorDisabledStatus', visible: 'node.Status',
                                            requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE' },
                                        { id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateBulkCatalogStatus:true', disabled: '!node.ancestorDisabledStatus', visible: '!node.Status',
                                            requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE' }
                                      ],
                    fabAction         : { id: 'add', label: 'ACTIONS.ADD', icon: 'icon-plus', privilege: 'CreateAssortmentFolder:true', visible: true }

                 }
            }
        };

        function getFolders(generalProperties, model, catalogId) {
            if(angular.isDefined(model)) { // to skip this part for load lookup
                model.isBulkActionCompleted = false;
            }
            var promise;

            if(angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
                var state = {};
                state.name = $state.current.name;
                state.params = $state.params;
                var isBulk = true;
                var logData = activityLogger.createLogData(null, state, 'catalogs.folders', 'VIEW', isBulk, new Date(), null, null);

                promise = api.webGet(api.baseUrl + '/catalogs/' + catalogId + '/assortmentfolders', undefined, true, generalProperties.forceFetch);
                promise = activityLogger.log(logData, promise);
            }
            else {
                promise = api.webGet(api.baseUrl + '/catalogs/' + catalogId + '/assortmentfolders', undefined, true, generalProperties.forceFetch);
            }

            promise.then(function() {
                if (api.catalogs.folders.isDirty) {
                    //Invalidate lookupData
                    api.catalogs.folders.lookupData = undefined;
                    api.catalogs.folders.isDirty = false;
                }
            });
            return promise;
		}

        function getFolder(isLogRequired, catalogId, folderId) {
            var promise;
            if(angular.isDefined(isLogRequired) && isLogRequired === true) {
                var state = {};
                state.name = $state.current.name;
                state.params = $state.params;
                var isBulk = false;
                var items= [];
                promise = api.webGet(api.baseUrl + '/catalogs/' + catalogId + '/assortmentfolders/' + folderId + '?status=0');
                promise.then(function(response) {
                    items.push(response.data[api.accounts.sellers.lookupDisplayField]);
                }, function(response) {
                    items.push(response.data[api.accounts.sellers.lookupDisplayField]);
                });
                var logData = activityLogger.createLogData(items, state, 'catalogs.folders', 'VIEW', isBulk, new Date(), null, null);
                promise = activityLogger.log(logData, promise);
            }
            else {
                promise = api.webGet(api.baseUrl + '/catalogs/' + catalogId + '/assortmentfolders/' + folderId + '?status=0');
            }
            return promise;
		}

        function activateFolders(records, model, actionType, parentId) {
            var result = crud.createRequestObject(records, model, actionType);
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var isBulk = result.itemsNameList.length > 1 ? true : false;
            var logData = activityLogger.createLogData(result.itemsNameList, state, 'catalogs.folders', actionType.toUpperCase(), isBulk, new Date(), null, null);
			var promise = api.webPut(api.baseUrl + '/catalogs/'+ parentId +'/assortmentfolders/status', result.requestObj);

             promise.then(function() {
                crud.onRecordStatusChange(records, model, actionType);
            });

            return activityLogger.log(logData, promise);
        }

        function createFolder(folder, catalogId) {
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var logData = activityLogger.createLogData(folder[api.catalogs.folders.lookupDisplayField], state, 'catalogs.folders', 'ADD', false, new Date(), null, null);
			var promise = api.webPost(api.baseUrl + '/catalogs/' + catalogId + '/assortmentfolders', folder);

            promise.then(function() {
                api.catalogs.folders.isDirty = true;
            });
            return activityLogger.log(logData, promise);
        }

		function updateFolder(itemId, item, catalogId) {
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var logData = activityLogger.createLogData(item[api.catalogs.folders.lookupDisplayField], state, 'catalogs.folders', 'EDIT', false, new Date(), null, null);
			var promise = api.webPut(api.baseUrl + '/catalogs/' + catalogId + '/assortmentfolders/' + itemId, item);
            promise.then(function() {
                api.catalogs.folders.isDirty = true;
            });
            return activityLogger.log(logData, promise);
		}

        function updateFolders(records, catalogId) {
            var itemNameList = [];
            angular.forEach(records, function(record) {
                itemNameList.push(record[api.catalogs.folders.lookupDisplayField]);
            });
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var logData = activityLogger.createLogData(itemNameList, state, 'catalogs.folders', 'RE_ORDER', true, new Date(), null, null);
			var promise = api.webPut(api.baseUrl + '/catalogs/' + catalogId + '/assortmentfolders', records);

            promise.then(function() {
                api.catalogs.folders.isDirty = true;
            });
            return activityLogger.log(logData, promise);
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.main.catalogs.assortments')
        .run(runBlock);

    /* @ngInject */
    function runBlock(api, activityLogger, $state, crud, jobsTracker, catalogFactory, CONSTANTS) {

        if (angular.isUndefined(api.catalogs)) {
            api.catalogs = {};
        }
         api.catalogs.assortments = {
            modelPath: 'catalogs.assortments',
            fields: [
                { field: 'Id', type: 'int', displayLabel: 'ASSORTMENTS.FIELDS.ID', visible: false, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'FolderId', type: 'int', displayLabel: 'ASSORTMENTS.FIELDS.FOLDER_ID', visible: false, creatable: false, editable: false, inputType: 'lookup',  lookupSource: 'catalogs.folders',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'FolderName', type: 'text', displayLabel: 'ASSORTMENTS.FIELDS.FOLDER_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CatalogCode', type: 'int', displayLabel: 'ASSORTMENTS.FIELDS.CATALOG_CODE', visible: false, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Name', type: 'text', displayLabel: 'ASSORTMENTS.FIELDS.NAME', visible: true, creatable: true, editable: true, inputType: 'text',
                    validation: {isRequired: true, maxLen: 50, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'SortOrder', type: 'text', displayLabel: 'ASSORTMENTS.FIELDS.SORT_ORDER', visible: true, creatable: true, editable: true, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Status', type: 'text', displayLabel: 'ASSORTMENTS.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedDate', type: 'text', displayLabel: 'ASSORTMENTS.FIELDS.CREATED_DATE', visible: false, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedDate', type: 'text', displayLabel: 'ASSORTMENTS.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedBy', type: 'text', displayLabel: 'ASSORTMENTS.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedBy', type: 'text', displayLabel: 'ASSORTMENTS.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ArticleNumber', type: 'text', displayLabel: 'ASSORTMENTS.FIELDS.ARTICLE_NUMBER', visible: false, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'FilterCriteria', type: 'text', displayLabel: 'ASSORTMENTS.FIELDS.CRITERIA', visible: false, creatable: false, editable: false, inputType: 'textArea',
                    validation: {isRequired: true, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'DunesImageSet', type: 'text', displayLabel: 'ASSORTMENTS.FIELDS.DUNES_IMAGES_SET', visible: false, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
            ],
             uniqueConstraints: [
                // {name: 'Constraint 1', fields: ['Name']} // not needed since transformed request obj will merge articles of records having same name property and it will always be unique
            ],
            title: 'ASSORTMENTS.NAV',
            icon: 'icon-arrange-bring-to-front',
            idField: 'Id',
            lookupDisplayField: 'Name',
            isDirty: false,
            isBulkActionCompleted: false,
            isCatalogSpecificModel: true,
            methods: {
                getList         :   getAssortments,
                getDetails      :   getAssortment,
                activateBulk    :   activateAssortments,
                create          :   createAssortment,
                update          :   updateAssortment,
                updateBulk      :   updateAssortments,
                createBulk      :   importAssortments,
                createCustomersBulk: createCustomersBulk,
                createBulkTabular: createBulkTabular,
                createCustomersBulkTabular: createCustomersBulkTabular
            },
            views: {
                mainList: {
                    columns         : [],
                    columnFilter    : {},
                    topIndex        : 0,
                    showFilterRow   : false,
                    sortColumn      : {'UpdatedDate': false},
                    itemActions     : [
                                        // { id: 'view', label: 'ACTIONS.VIEW', icon: 'icon-magnify', privilege: 'GetAssortmentDetails', disabled: '!node.Status || !node.ancestorDisabledStatus', visible: true },
                                        // { id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UpdateAssortmentDefination:true', disabled: '!node.Status || !node.ancestorDisabledStatus', visible: true },
                                        // { id: 'setArticles', label: 'ASSORTMENTS.ACTIONS.SET_ARTICLES', icon: 'icon-link', privilege: 'CreateArticleAssortment:true', disabled: '!node.Status || !node.ancestorDisabledStatus', visible: true },
                                        // { id: 'setCustomers', label: 'ASSORTMENTS.ACTIONS.SET_CUSTOMERS', icon: 'icon-link', privilege: 'UpdateCustomereAssortment:true', disabled: '!node.Status || !node.ancestorDisabledStatus', visible: true },
                                        // { id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateBulkAssortmentStatus:true', disabled: '!node.ancestorDisabledStatus', visible: 'node.Status',
                                        //     requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                                        // { id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateBulkAssortmentStatus:true', disabled: '!node.ancestorDisabledStatus', visible: '!node.Status',
                                        //     requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
                                    ],
                    listActions     : [
                                        { id: 'import', label: 'ASSORTMENTS.ACTIONS.IMPORT_ASSORTMENTS', icon: 'icon-import', privilege: 'CreateBulkArticlesAssortMents:true', disabled: false, visible: true },
                                        { id: 'importCustomers', label: 'ASSORTMENTS.ACTIONS.IMPORT_CUSTOMERS', icon: 'icon-import', privilege: 'CreateBulkCustomerAssortMents:true', disabled: false, visible: true },
                                        { id: 'importTabular', label: 'ASSORTMENTS.ACTIONS.IMPORT_ASSORTMENTS_TABULAR', icon: 'icon-table-column-plus-after', privilege: 'CreateBulkArticlesAssortMents:true', disabled: false, visible: true },
                                        { id: 'importCustomersTabular', label: 'ASSORTMENTS.ACTIONS.IMPORT_CUSTOMERS_TABULAR', icon: 'icon-table-column-plus-after', privilege: 'CreateBulkCustomerAssortMents:true', disabled: false, visible: true }
                                    ],
                    fab             : {}

                 },
                 mainDetails: {
                     selectedTabIndex   : 0,
                     itemActions        : [
                                            { id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateBulkAssortmentStatus:true', disabled: '{selected: true, Status: 1}',
                                                visible: true, requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                                            { id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateBulkAssortmentStatus:true', disabled: '{selected: true, Status: 0}',
                                                visible: true, requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
                                          ],
                    fab                 : {id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UpdateAssortmentDefination:true', visible: true}
                 },
                 privileges: {
                     list: 'GetAssortmentList',
                     details: 'GetAssortmentDetails'
                 }
            }
        };

        api.catalogs.importAssortments = {
            modelPath: 'catalogs.assortments',
            fields: [
                { field: 'Id', type: 'int', displayLabel: 'ASSORTMENTS.FIELDS.ID', visible: false, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'FolderId', type: 'int', displayLabel: 'ASSORTMENTS.FIELDS.FOLDER_ID', visible: false, creatable: false, editable: false, inputType: 'lookup',  lookupSource: 'catalogs.folders',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'FolderName', type: 'text', displayLabel: 'ASSORTMENTS.FIELDS.FOLDER_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CatalogCode', type: 'int', displayLabel: 'ASSORTMENTS.FIELDS.CATALOG_CODE', visible: false, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Name', type: 'text', displayLabel: 'ASSORTMENTS.FIELDS.NAME', visible: true, creatable: true, editable: true, inputType: 'text',
                    validation: {isRequired: true, maxLen: 50, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Path', type: 'text', displayLabel: 'ASSORTMENTS.FIELDS.PATH', visible: true, creatable: true, editable: true, inputType: 'text',
                    validation: {isRequired: true, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'SortOrder', type: 'text', displayLabel: 'ASSORTMENTS.FIELDS.SORT_ORDER', visible: true, creatable: true, editable: true, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'FolderSortOrder', type: 'text', displayLabel: 'ASSORTMENTS.FIELDS.FOLDER_SORT_ORDER', visible: true, creatable: true, editable: true, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Status', type: 'text', displayLabel: 'ASSORTMENTS.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'FilterCriteria', type: 'text', displayLabel: 'ASSORTMENTS.FIELDS.CRITERIA', visible: true, creatable: true, editable: true, inputType: 'textArea',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedDate', type: 'text', displayLabel: 'ASSORTMENTS.FIELDS.CREATED_DATE', visible: false, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedDate', type: 'text', displayLabel: 'ASSORTMENTS.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedBy', type: 'text', displayLabel: 'ASSORTMENTS.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedBy', type: 'text', displayLabel: 'ASSORTMENTS.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ArticleNumber', type: 'text', displayLabel: 'ASSORTMENTS.FIELDS.ARTICLE_NUMBER', visible: false, creatable: true, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
            ],
             uniqueConstraints: [
                {name: 'Constraint 1', fields: ['Name', 'Path', 'ArticleNumber']}
            ],
            title: 'ASSORTMENTS.NAV',
            icon: 'icon-arrange-bring-to-front',
            idField: 'Id',
            lookupDisplayField: 'Name',
            isDirty: false,
            isCatalogSpecificModel: true,
            methods: {},
            views: {
                mainList: {},
                 mainDetails: {},
                 privileges: {
                     list: 'GetAssortmentList',
                     details: 'GetAssortmentDetails'
                 }
            }
        };

        api.catalogs.importAssortmentsTabular = {
            modelPath: 'catalogs.importAssortmentsTabular',
            fields: [
                { field: 'Name', type: 'text', displayLabel: 'ASSORTMENTS.FIELDS.NAME', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: true, maxLen: 50, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ArticleNumber', type: 'text', displayLabel: 'ASSORTMENTS.FIELDS.ARTICLE_NUMBER', visible: false, creatable: true, editable: false, inputType: 'text',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CustomerNumber', type: 'text', displayLabel: 'ASSORTMENTS.FIELDS.CUSTOMER_NUMBER', visible: false, creatable: true, editable: false, inputType: 'text',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
            ],
             uniqueConstraints: [
                {name: 'Constraint 1', fields: ['ArticleNumber']}
            ],
            title: 'ASSORTMENTS.NAV',
            icon: 'icon-arrange-bring-to-front',
            idField: 'Name',
            lookupDisplayField: '',
            isDirty: false,
            isCatalogSpecificModel: true,
            methods: {},
            views: {
                mainList: {},
                 mainDetails: {},
                 privileges: {
                     list: 'GetAssortmentList',
                     details: 'GetAssortmentDetails'
                 }
            }
        };

        function getAssortments(generalProperties, catalogId, model) {
            var promise;

            if(angular.isDefined(model)) { // to skip this part for load lookup
                model.isBulkActionCompleted = false;
            }

            if(angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
                var state = {};
                state.name = $state.current.name;
                state.params = $state.params;
                var isBulk = true;
                var logData = activityLogger.createLogData(null, state, 'catalogs.assortments', 'VIEW', isBulk, new Date(), null, null);

                promise = api.webGet(api.baseUrl + '/catalogs/' + catalogId + '/assortments',
                generalProperties.config || {}, true, generalProperties.forceFetch,
                generalProperties.supportIncrementalResult || true,
                generalProperties.modelIdField,
                generalProperties.isMajor || false,
                generalProperties.model || api.catalogs.assortments);
                promise = activityLogger.log(logData, promise);
            }
            else {
                promise = api.webGet(api.baseUrl + '/catalogs/' + catalogId + '/assortments',
                generalProperties.config || {}, true, generalProperties.forceFetch,
                generalProperties.supportIncrementalResult || true,
                generalProperties.modelIdField,
                generalProperties.isMajor || false,
                generalProperties.model || api.catalogs.assortments);
            }

            promise.then(function() {
                if (api.catalogs.assortments.isDirty) {
                    //Invalidate lookupData
                    api.catalogs.assortments.lookupData = undefined;
                    api.catalogs.assortments.isDirty = false;
                }
            });
            return promise;
		}

        function getAssortment(isLogRequired, catalogId, assortmentId) {
            var promise;
            if(angular.isDefined(isLogRequired) && isLogRequired === true) {
                var state = {};
                state.name = $state.current.name;
                state.params = $state.params;
                var isBulk = false;
                var items= [];
                promise = api.webGet(api.baseUrl + '/catalogs/' + catalogId + '/assortments/' + assortmentId + '?status=0');
                promise.then(function(response) {
                    items.push(response.data[api.accounts.sellers.lookupDisplayField]);
                }, function(response) {
                    items.push(response.data[api.accounts.sellers.lookupDisplayField]);
                });
                var logData = activityLogger.createLogData(items, state, 'catalogs.assortments', 'VIEW', isBulk, new Date(), null, null);
                promise = activityLogger.log(logData, promise);
            }
            else {
                promise = api.webGet(api.baseUrl + '/catalogs/' + catalogId + '/assortments/' + assortmentId + '?status=0');
            }
             return promise;
		}

        function activateAssortments(records, model, actionType, parentId) {
            var result = crud.createRequestObject(records, model, actionType);
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var isBulk = result.itemsNameList.length > 1 ? true : false;
            var logData = activityLogger.createLogData(result.itemsNameList, state, 'catalogs.assortments', actionType.toUpperCase(), isBulk, new Date(), null, null);
			var promise = api.webPut(api.baseUrl + '/catalogs/'+ parentId +'/assortments/status', result.requestObj);

            promise.then(function() {
                crud.onRecordStatusChange(records, model, actionType);
            });

            return activityLogger.log(logData, promise);
        }

        function createAssortment(assortment, catalogId) {
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var logData = activityLogger.createLogData(assortment[api.catalogs.assortments.lookupDisplayField], state, 'catalogs.assortments', 'ADD', false, new Date(), null, null);
			var promise = api.webPost(api.baseUrl + '/catalogs/' + catalogId + '/assortments', assortment);

            promise.then(function() {
                api.catalogs.assortments.isDirty = true;
            });
            return activityLogger.log(logData, promise);
        }

		function updateAssortment(itemId, item, catalogId) {
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var logData = activityLogger.createLogData(item[api.catalogs.assortments.lookupDisplayField], state, 'catalogs.assortments', 'EDIT', false, new Date(), null, null);
			var promise = api.webPut(api.baseUrl + '/catalogs/' + catalogId + '/assortments/' + itemId, item);

            promise.then(function() {
                api.catalogs.assortments.isDirty = true;
            });
            return activityLogger.log(logData, promise);
		}

        function updateAssortments(records, catalogId) {
            var itemNameList = [];
            angular.forEach(records, function(record) {
                itemNameList.push(record[api.catalogs.folders.lookupDisplayField]);
            });
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var logData = activityLogger.createLogData(itemNameList, state, 'catalogs.assortments', 'RE_ORDER', true, new Date(), null, null);
			var promise = api.webPut(api.baseUrl + '/catalogs/' + catalogId + '/assortments/', records);

            promise.then(function() {
                api.catalogs.assortments.isDirty = true;
            });
            return activityLogger.log(logData, promise);
        }

        function importAssortments(model, data, catalogCode, secondaryModel) {
            var catalogCollectionType = catalogFactory.getActiveCatalog().CollectionsType;
            //Transform data into required format
            var transformedData = [];
            var nameIndexes = {};
            var itemsNameList = [];
            for (var i = 0; i < data.length; i++) {
                var ind = -1;
                var _namePathString = data[i].Name.trim() + data[i].Path.trim();
                if (angular.isUndefined(nameIndexes[_namePathString.toUpperCase()])) {
                    var requestObj = { 'Name': data[i].Name, 'Path': data[i].Path, 'SortOrder': data[i].SortOrder, FolderSortOrder: data[i].FolderSortOrder, 'Articles': [] };
                    ind = transformedData.length;
                    nameIndexes[_namePathString.toUpperCase()] = ind;
                    transformedData.push(requestObj);
                    itemsNameList.push(data[i].Name);
                } else {
                    ind = nameIndexes[_namePathString.toUpperCase()];
                }

                if(catalogCollectionType === 1) {
                    //'Name', 'Path', 'ArticleNumber' are unique constraints, and ArticleNumber is a non mandatory field.Handle when user select ArticleNumber and send article number as null/""
                    //send only those record which having valid article number to API if the aricle number is "" or null ignore article only when a valid record already exist with same 'Name' and 'Path'
                    //'' will be handled in dataImporter as null will be considered as a valid entry in data importer so we are handling it here
                    if (data[i].ArticleNumber && transformedData[ind].Articles.indexOf(data[i].ArticleNumber) === -1 && data[i].ArticleNumber !== '' && data[i].ArticleNumber !== 'null') {
                        transformedData[ind].Articles.push(data[i].ArticleNumber);
                    }
                }
            }
            nameIndexes = undefined;

            var jobIndex = jobsTracker.addJob(model, 'ASSORTMENTS.ACTIONS.IMPORT_ASSORTMENTS', 1, secondaryModel);

            api.webPut(api.baseUrl + '/catalogs/' + catalogCode + '/bulkarticlesassortment?sourceapplication=' + CONSTANTS.SOURCE_APPLICATION + '&sourceaction=Import Collections', transformedData).then(function (response) {
                jobsTracker.trackJob(jobIndex, response.data.Id);
            }).catch(function (error) {
                jobsTracker.setCriticlaFail(jobIndex, error);
            });
        }

        function createCustomersBulk(model, data, catalogCode) {
            //Transform data into required format
            var transformedData = [];
            var nameIndexes = {};
            var itemsNameList = [];

            for (var i = 0; i < data.length; i++) {
                var ind = -1;
                var _namePathString = data[i].Name.trim() + data[i].Path.trim();
                if (angular.isUndefined(nameIndexes[_namePathString.toUpperCase()])) {
                    var requestObj = { 'Name': data[i].Name, 'Path': data[i].Path, 'Customers': [] };
                    ind = transformedData.length;
                    nameIndexes[_namePathString.toUpperCase()] = ind;
                    transformedData.push(requestObj);
                    itemsNameList.push(data[i].Name);
                } else {
                    ind = nameIndexes[_namePathString.toUpperCase()];
                }
                if (data[i].CustomerNumber && transformedData[ind].Customers.indexOf(data[i].CustomerNumber) === -1 && data[i].CustomerNumber !== '' && data[i].CustomerNumber !== "null") {
                    transformedData[ind].Customers.push(data[i].CustomerNumber);
                }
            }
            nameIndexes = undefined;

            var jobIndex = jobsTracker.addJob(model, 'ASSORTMENTS.ACTIONS.IMPORT_CUSTOMERS', 1);

            api.webPut(api.baseUrl + '/catalogs/' + catalogCode + '/bulkcustomersassortment?sourceapplication=' + CONSTANTS.SOURCE_APPLICATION + '&sourceaction=Import Customers', transformedData).then(function (response) {
                jobsTracker.trackJob(jobIndex, response.data.Id);
            }).catch(function (error) {
                jobsTracker.setCriticlaFail(jobIndex, error);
            });
        }

        function createBulkTabular(model, data, catalogCode) {
            var transformedData = [];
            angular.forEach(data, function(entry) {
                var articleNumber = entry.ArticleNumber;
                var pathFields = Object.keys(entry).filter(function(key) {
                    return key !== 'ArticleNumber';
                });

                angular.forEach(pathFields, function(pathField) {
                    var value = entry[pathField].toLowerCase();
                        if (value === 'yes' || value === 'true' || value === '1') {
                        var splitPath = pathField.split('__');
                        var name = splitPath.pop();
                        // Remove the name from the split paths array
                        var paths = splitPath[0].replace('/' + name, '').split('/');
                        var path = paths.join('/');
                        var dataExistsIndex = transformedData.findIndex(function(item) {
                            return item.Name === name && item.Path === path;
                        });

                        if (dataExistsIndex !== -1) {
                            transformedData[dataExistsIndex].Articles.push(articleNumber);
                        } else {
                            transformedData.push({ Name: name, Path: path, Articles: [articleNumber] });
                        }
                    }
                });
            });

            var jobIndex = jobsTracker.addJob(model, 'ASSORTMENTS.ACTIONS.IMPORT_ASSORTMENTS', 1);

            api.webPut(api.baseUrl + '/catalogs/' + catalogCode + '/bulkarticlesassortment', transformedData).then(function (response) {
                jobsTracker.trackJob(jobIndex, response.data.Id);
            }).catch(function (error) {
                jobsTracker.setCriticlaFail(jobIndex, error);
            });
        }

        function createCustomersBulkTabular(model, data, catalogCode) {
            var transformedData = [];
            angular.forEach(data, function(entry) {
                var customerNumber = entry.CustomerNumber;
                var pathFields = Object.keys(entry).filter(function(key) {
                    return key !== 'CustomerNumber';
                });

                angular.forEach(pathFields, function(pathField) {
                    var value = entry[pathField].toLowerCase();
                    if (value === 'yes' || value === 'true' || value === '1') {
                        var splitPath = pathField.split('__');
                        var name = splitPath.pop();
                        // Remove the name from the split paths array
                        var paths = splitPath[0].replace('/' + name, '').split('/');
                        var path = paths.join('/');
                        var existingEntryIndex = transformedData.findIndex(function(item) {
                            return item.Name === name && item.Path === path;
                        });

                        if (existingEntryIndex !== -1) {
                            transformedData[existingEntryIndex].Customers.push(customerNumber);
                        } else {
                            transformedData.push({ Name: name, Path: path, Customers: [customerNumber] });
                        }
                    }
                });
            });

            var jobIndex = jobsTracker.addJob(model, 'ASSORTMENTS.ACTIONS.IMPORT_CUSTOMERS', 1);

            api.webPut(api.baseUrl + '/catalogs/' + catalogCode + '/bulkcustomersassortment', transformedData).then(function (response) {
                jobsTracker.trackJob(jobIndex, response.data.Id);
            }).catch(function (error) {
                jobsTracker.setCriticlaFail(jobIndex, error);
            });
        }
    }
})();
(function() {
	'use strict';

	angular
			.module('app.main.catalogs.assortments')
			.run(runBlock);

	/* @ngInject */
	function runBlock(api, activityLogger, $state, crud) {

			if (angular.isUndefined(api.catalogs)) {
					api.catalogs = {};
			}
			 api.catalogs.assortmentsCustomers = {
						modelPath: 'catalogs.assortmentsCustomers',
						fields: [
								{ field: 'Name', type: 'text', displayLabel: 'ASSORTMENTS.FIELDS.NAME', visible: true, creatable: true, editable: false, inputType: 'text',
										validation: {isRequired: true, maxLen: 50, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'Path', type: 'text', displayLabel: 'ASSORTMENTS.FIELDS.PATH', visible: true, creatable: true, editable: false, inputType: 'text',
										validation: {isRequired: true, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'CustomerNumber', type: 'text', displayLabel: 'ASSORTMENTS.FIELDS.CUSTOMER_NUMBER', visible: true, creatable: true, editable: false, inputType: 'text',
										validation: {isRequired: true, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'CustomerId', type: 'int', displayLabel: 'ASSORTMENTS.FIELDS.CUSTOMER_ID', visible: true, creatable: false, editable: false, inputType: 'number',
										validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' }} },
								{ field: 'AssortmentId', type: 'int', displayLabel: 'ASSORTMENTS.FIELDS.ASSORTMENT_ID', visible: true, creatable: false, editable: false, inputType: 'number',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'Status', type: 'text', displayLabel: 'ASSORTMENTS.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
						],
						uniqueConstraints: [
							{name: 'Constraint 1', fields: ['Name', 'Path', 'Status', 'AssortmentId', 'CustomerId', 'CustomerNumber']}
						],
						title: 'ASSORTMENTS.NAV',
						icon: 'icon-arrange-bring-to-front',
						idField: 'Name',
						lookupDisplayField: 'Name',
						isDirty: false,
						isCatalogSpecificModel: true,
						methods: {
								getList : getAssortmentsCustomers,
								activate: activateAssortmentsWithCustomers
						},
						views: {
								mainList: {
										columns         : [ 'CustomerNumber', 'Name', 'Path' ],
										columnFilter    : {},
										topIndex        : 0,
										showFilterRow   : false,
										sortColumn      : {'Name': true},
										itemActions     : [
											{ id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateCustomerAssortmentStatus', disabled: false, visible: 'itm.Status',
													requiresConfirmation: false, confirmationContent: {title: 'ARTICLES.TITLES.DELETE_ALERT', message: 'ARTICLES.MESSAGES.CONFIRM_DROP'}, confirmationAction: 'ACTIONS.DELETE'},
											{ id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateCustomerAssortmentStatus', disabled: false, visible: '!itm.Status',
													requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'},
										],
										listActions     : [
											{ id: 'delete', label: 'ACTIONS.DELETE_BULK', icon: 'icon-delete', privilege: 'UpdateCustomerAssortmentStatus', disabled: '{selected: true, Status: 1}', visible: true,
												requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
											{ id: 'activate', label: 'ACTIONS.ACTIVATE_BULK', icon: 'icon-undo-variant', privilege: 'UpdateCustomerAssortmentStatus', disabled: '{selected: true, Status: 0}', visible: true,
												requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'},
										],
								},
								mainDetails: {},
								privileges: {
										list: 'GetAssortmentListWithCustomers'
								}
						}
		};

		function getAssortmentsCustomers(generalProperties, catalogId) {
				var promise;

				if(angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
						var state = {};
						state.name = $state.current.name;
						state.params = $state.params;
						var isBulk = true;
						var logData = activityLogger.createLogData(null, state, 'catalogs.assortmentsCustomers', 'VIEW', isBulk, new Date(), null, null);

						promise = api.webGet(api.baseUrl + '/catalogs/' + catalogId + '/customerassortmentlist', undefined, true, generalProperties.forceFetch);
						promise = activityLogger.log(logData, promise);
				}
				else {
						promise = api.webGet(api.baseUrl + '/catalogs/' + catalogId + '/customerassortmentlist', undefined, true, generalProperties.forceFetch);
				}

				promise.then(function() {
						if (api.catalogs.assortmentsCustomers.isDirty) {
								//Invalidate lookupData
								api.catalogs.assortmentsCustomers.lookupData = undefined;
								api.catalogs.assortmentsCustomers.isDirty = false;
						}
				});
				return promise;
		}

		function activateAssortmentsWithCustomers(records, model, actionType, parentId) {
			var requestObj = [];
			var status = 0;
			if(!angular.isArray(records)) {
					records = crud.pushItemToArray(records);
			}
			if(actionType.toUpperCase() === 'ACTIVATE') {
					status = 1;
			}
			for(var index = 0; index < records.length ; index++) {
					var obj = {}
					obj.Status = status;
					obj.CustomerId = records[index].CustomerId;
					obj.AssortmentId = records[index].AssortmentId;
					requestObj.push(obj);
			}
			var state = {};
			state.name = $state.current.name;
			state.params = $state.params;
			var isBulk = records.length > 1 ? true : false;
			var logData = activityLogger.createLogData(null, state, 'catalogs.assortmentsCustomers', actionType.toUpperCase(), isBulk, new Date(), null, null);
			var promise = api.webPut(api.baseUrl + '/catalogs/' + parentId + '/customerassortments/status', requestObj);

			promise.then(function () {
					api.catalogs.assortments.isDirty = true;
					crud.onRecordStatusChange(records, model, actionType);
			});

			return activityLogger.log(logData, promise);
		}
	}
})();
(function() {
  'use strict';

  angular
      .module('app.main.catalogs.assortments')
      .run(runBlock);

  /* @ngInject */
  function runBlock(api, activityLogger, $state, crud) {

      if (angular.isUndefined(api.catalogs)) {
          api.catalogs = {};
      }
       api.catalogs.assortmentsWithArticles = {
          modelPath: 'catalogs.assortmentsWithArticles',
          fields: [
              { field: 'Path', type: 'text', displayLabel: 'ASSORTMENTS.FIELDS.PATH', visible: true, creatable: false, editable: false, inputType: 'text',
                  validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
              { field: 'Name', type: 'text', displayLabel: 'ASSORTMENTS.FIELDS.NAME', visible: true, creatable: false, editable: false, inputType: 'text',
                  validation: {isRequired: true, maxLen: 50, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
              { field: 'SortOrder', type: 'text', displayLabel: 'ASSORTMENTS.FIELDS.SORT_ORDER', visible: true, creatable: false, editable: false, inputType: 'number',
                  validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
              { field: 'ArticleNumber', type: 'text', displayLabel: 'ASSORTMENTS.FIELDS.ARTICLE_NUMBER', visible: true, creatable: false, editable: false, inputType: 'text',
                  validation: {isRequired: false, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
              { field: 'ArticleId', type: 'int', displayLabel: 'ASSORTMENTS.FIELDS.ARTICLE_ID', visible: true, creatable: false, editable: false, inputType: 'number',
                  validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
              { field: 'AssortmentId', type: 'int', displayLabel: 'ASSORTMENTS.FIELDS.ASSORTMENT_ID', visible: false, creatable: false, editable: false, inputType: 'number',
                  validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
              { field: 'Status', type: 'text', displayLabel: 'ASSORTMENTS.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
                  validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
          ],
           uniqueConstraints: [],
          title: 'ASSORTMENTS.NAV',
          icon: 'icon-arrange-bring-to-front',
          idField: 'Id',
          lookupDisplayField: 'Name',
          isDirty: false,
          isBulkActionCompleted: false,
          isCatalogSpecificModel: true,
          methods: {
              getList : getAssortmentsWithArticles,
              activate: activateAssortmentsWithArticles
          },
          views: {
              mainList: {
                  columns         : [ 'ArticleId', 'ArticleNumber', 'Name', 'Path', 'Status', 'SortOrder' ],
                  columnFilter    : {},
                  topIndex        : 0,
                  showFilterRow   : false,
                  sortColumn      : {'SortOrder': true},
                  itemActions     : [
                    { id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateAssortmentsArticleStatus', disabled: false, visible: 'itm.Status',
                        requiresConfirmation: false, confirmationContent: {title: 'ARTICLES.TITLES.DELETE_ALERT', message: 'ARTICLES.MESSAGES.CONFIRM_DROP'}, confirmationAction: 'ACTIONS.DELETE'},
                    { id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateAssortmentsArticleStatus', disabled: false, visible: '!itm.Status',
                        requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'},
                  ],
                  listActions     : [
                    { id: 'delete', label: 'ACTIONS.DELETE_BULK', icon: 'icon-delete', privilege: 'UpdateAssortmentsArticleStatus', disabled: '{selected: true, Status: 1}', visible: true,
                      requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                    { id: 'activate', label: 'ACTIONS.ACTIVATE_BULK', icon: 'icon-undo-variant', privilege: 'UpdateAssortmentsArticleStatus', disabled: '{selected: true, Status: 0}', visible: true,
                      requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'},
                  ],
                  fabAction       : {}

               },
               mainDetails: {
                   selectedTabIndex   : 0,
                   itemActions        : [ ],
                  fabAction           : {}
               },
               privileges: {
                   list: 'GetAssortmentListWithArticles'
               }
          }

      };

      function getAssortmentsWithArticles(generalProperties, catalogId) {
        var promise;

        if(angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var isBulk = true;
            var logData = activityLogger.createLogData(null, state, 'catalogs.assortmentsWithArticles', 'VIEW', isBulk, new Date(), null, null);

            promise = api.webGet(api.baseUrl + '/catalogs/' + catalogId + '/assortmentlist', undefined, true, generalProperties.forceFetch);
            promise = activityLogger.log(logData, promise);
        }
        else {
            promise = api.webGet(api.baseUrl + '/catalogs/' + catalogId + '/assortmentlist', undefined, true, generalProperties.forceFetch);
        }

        promise.then(function() {
            if (api.catalogs.assortmentsWithArticles.isDirty) {
                //Invalidate lookupData
                api.catalogs.assortmentsWithArticles.lookupData = undefined;
                api.catalogs.assortmentsWithArticles.isDirty = false;
            }
        });
        return promise;
    }

    function activateAssortmentsWithArticles(records, model, actionType, parentId) {
        var requestObj = [];
        var status = 0;
        if(!angular.isArray(records)) {
            records = crud.pushItemToArray(records);
        }
        if(actionType.toUpperCase() === 'ACTIVATE') {
            status = 1;
        }
        for(var index = 0; index < records.length ; index++) {
            var obj = {}
            obj.Status = status;
            obj.ArticleId = records[index].ArticleId;
            obj.AssortmentId = records[index].AssortmentId;
            requestObj.push(obj);
        }
        var promise = api.webPut(api.baseUrl + '/catalogs/' + parentId + '/assortmentarticles/status', requestObj);
  
        promise.then(function () {
            api.catalogs.assortments.isDirty = true;
            crud.onRecordStatusChange(records, model, actionType);
        });
  
        return promise;
      }
  }
})();
(function() {
    'use strict';

    angular
        .module('app.main.catalogs.articles-replacement')
        .run(runBlock);

    /* @ngInject */
    function runBlock(api, activityLogger, $state, catalogFactory, toast) {

        if (angular.isUndefined(api.catalogs)) {
            api.catalogs = {};
        }
        api.catalogs.articlesReplacement = {
            modelPath: 'catalogs.articlesReplacement',
            fields: [
                { field: 'ArticleIdDropped', type: 'int', displayLabel: 'ARTICLES_REPLACEMENT.FIELDS.DROPPED_ARTICLE', visible: false, creatable: true, editable: true, inputType: 'lookup', lookupSource:'catalogs.articles',
                //lookupSource used to resolve article number in get list
                    validation: {isRequired: true, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ArticleNumberDropped', type: 'text', displayLabel: 'ARTICLES_REPLACEMENT.FIELDS.DROPPED_ARTICLE', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ArticleNameDropped', type: 'text', displayLabel: 'ARTICLES_REPLACEMENT.FIELDS.DROPPED_ARTICLE_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ArticleIdAlt', type: 'int', displayLabel: 'ARTICLES_REPLACEMENT.FIELDS.ALTERNATE_ARTICLE', visible: false, creatable: false, editable: true, inputType: 'lookup', lookupSource:'catalogs.articles',
                //lookupSource used to resolve article number in get list
                    validation: {isRequired: true, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ArticleNumberAlt', type: 'text', displayLabel: 'ARTICLES_REPLACEMENT.FIELDS.ALTERNATE_ARTICLE', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ArticleNameAlt', type: 'text', displayLabel: 'ARTICLES_REPLACEMENT.FIELDS.ALTERNATE_ARTICLE_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Status', type: 'text', displayLabel: 'ARTICLES_REPLACEMENT.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedDate', type: 'text', displayLabel: 'ARTICLES_REPLACEMENT.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Updateddate', type: 'text', displayLabel: 'ARTICLES_REPLACEMENT.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedBy', type: 'text', displayLabel: 'ARTICLES_REPLACEMENT.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedBy', type: 'text', displayLabel: 'ARTICLES_REPLACEMENT.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }

            ],
            uniqueConstraints: [],
            title: 'ARTICLES_REPLACEMENT.NAV',
            icon: 'icon-tile-four',
            idField: 'ArticleIdDropped',
            lookupDisplayField: 'ArticleIdDropped',
            isDirty: false,
            isBulkActionCompleted: false,
            isCatalogSpecificModel: true,
            methods: {
                getList             :   getReplacementArticles,
                activate            :   activateReplacementArticles,
                create              :   createReplacementArticle,
                update              :   updateReplacementArticle
            },
            views: {
                mainList: {
                    columns         : [ 'ArticleNumberdDropped', 'ArticleNumberAlt', 'Status', 'Updateddate' ],
                    columnFilter    : {},
                    toggleFilterProps: { toggleStatus:false, filterProp:'Status', trueVal:1, trueValTooltipMessage: 'ACTIONS.TOGGLE_ACTIVE', falseVal:'', falseValTooltipMessage:"ACTIONS.TOGGLE_ALL"},
                    topIndex        : 0,
                    showFilterRow   : false,
                    sortColumn      : {'Updateddate': false},
                    itemActions     : [
                                        { id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UpdateArticleReplacement:true', disabled: '!itm.Status', visible: true },
                                        { id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateCatalogArticleReplacementStatus:true', disabled: false, visible: 'itm.Status',
                                            requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                                        { id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateCatalogArticleReplacementStatus:true', disabled: false, visible: '!itm.Status',
                                            requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
                                      ],
                    fabAction       : { id: 'add', label: 'ACTIONS.ADD', icon: 'icon-plus', privilege: 'CreateArticleReplacement:true', visible: true}

                },
                mainDetails: {},
                privileges: {
                    list    : 'GetCatalogArticleReplacementList'
                }
            }
        };

        function getReplacementArticles(generalProperties, catalogCode) {
            var promise;

            if(angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
                var state = {};
                state.name = $state.current.name;
                state.params = $state.params;
                var isBulk = true;
                var logData = activityLogger.createLogData(null, state, 'catalogs.articlesReplacement', 'VIEW', isBulk, new Date(), null, null);

                promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/replacement', undefined, true, generalProperties.forceFetch);
                promise = activityLogger.log(logData, promise);
            }
            else {
                catalogCode = angular.isUndefined(catalogCode) ? catalogFactory.getActiveCatalog().CatalogCode : catalogCode;
                promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/replacement', undefined, true, generalProperties.forceFetch);
            }

            promise.then(function() {
                if (api.catalogs.articlesReplacement.isDirty) {
                    //Invalidate lookupData
                    api.catalogs.articlesReplacement.lookupData = undefined;
                    api.catalogs.articlesReplacement.isDirty = false;
                }
            });
            return promise;
		}

		function activateReplacementArticles(record, model, actionType, catalogCode) {
            var requestObj = {Status: -1};
            if(actionType.toUpperCase() === 'DELETE') {
                requestObj.Status = 0;
            }
            else {
                requestObj.Status = 1;
            }
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var isBulk = false;
            var logData = activityLogger.createLogData(record['ArticleIdDropped'], state, 'catalogs.articlesReplacement', actionType.toUpperCase(), isBulk, new Date(), null, null);
            var promise = api.webPut(api.baseUrl + '/catalogs/' + catalogCode + '/articles/' + record['ArticleIdDropped'] + '/replacement/status', requestObj);

             promise.then(function() {
                 var toastMsg = '';
                 if(actionType.toUpperCase() === 'DELETE') {
                     toastMsg = 'SUCCESS.DELETE';
                     record['Status'] = 0;
                 }
                 else {
                     record['Status'] = 1;
                     toastMsg = 'SUCCESS.ACTIVATE';
                 }
                 toast.success(toastMsg, '', '');
            });

            return activityLogger.log(logData, promise);
		}

		function createReplacementArticle(record, catalogCode) {
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var logData = activityLogger.createLogData(record['ArticleIdDropped'], state, 'catalogs.articlesReplacement', 'ADD', false, new Date(), null, null);
            var promise = api.webPut(api.baseUrl + '/catalogs/' + catalogCode + '/replacement', [record]);

            promise.then(function() {
                api.catalogs.articlesReplacement.isDirty = true;
            });
            return activityLogger.log(logData, promise);
		}

        function updateReplacementArticle(record, catalogCode) {
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var logData = activityLogger.createLogData(record['ArticleIdDropped'], state, 'catalogs.articlesReplacement', 'EDIT', false, new Date(), null, null);
            var promise = api.webPut(api.baseUrl + '/catalogs/' + catalogCode + '/replacement', [record]);

            promise.then(function() {
                api.catalogs.articlesReplacement.isDirty = true;
            });
            return activityLogger.log(logData, promise);
		}

    }
})();
(function() {
  'use strict';

  angular
      .module('app.main.catalogs.articles-blocking')
      .run(runBlock);

  /* @ngInject */
  function runBlock(api, activityLogger, $state, crud, jobsTracker, utility, catalogFactory, CONSTANTS) {

      if (angular.isUndefined(api.catalogs)) {
          api.catalogs = {};
      }
       api.catalogs.articlesBlocking = {
          modelPath: 'catalogs.articlesBlocking',
          fields: [
            { field: 'Id', type: 'int', displayLabel: 'ARTICLES_BLOCKING.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
              validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
            { field: 'AttributeId', type: 'int', displayLabel: 'ARTICLES_BLOCKING.FIELDS.ATTRIBUTE_ID', visible: false, creatable: true, editable: true, inputType: 'lookup', lookupSource: 'catalogs.attributes',
               lookupFilter: {IsSeasonless: 0},validation: {isRequired: true, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
            { field: 'AttributeSystemName', type: 'text', displayLabel: 'ARTICLES_BLOCKING.FIELDS.ATTRIBUTE_SYSTEM_NAME', visible: false, creatable: false, editable: false, inputType: 'text',
              validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
            { field: 'AttributeDisplayName', type: 'text', displayLabel: 'ARTICLES_BLOCKING.FIELDS.ATTRIBUTE_DISPLAY_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
              validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
            { field: 'AttributeValue', type: 'text', displayLabel: 'ARTICLES_BLOCKING.FIELDS.ATTRIBUTE_VALUE', visible: true, creatable: true, editable: true, inputType: 'text',
              validation: {isRequired: true, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
            { field: 'BlockedCatalogs', type: 'int', displayLabel: 'ARTICLES_BLOCKING.FIELDS.BLOCKED_CATALOGS', visible: false, creatable: true, editable: true, inputType: 'lookup-many', lookupSource: 'catalogs.catalogs',
              lookupFilter: {'Status': 1}, validation: {isRequired: true, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
            { field: 'Reason', type: 'text', displayLabel: 'ARTICLES_BLOCKING.FIELDS.REASON', visible: true, creatable: true, editable: true, inputType: 'text',
              validation: {isRequired: false, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
            { field: 'Status', type: 'int', displayLabel: 'ARTICLES_BLOCKING.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
              validation: {isRequired: true, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
            { field: 'CreatedDate', type: 'text', displayLabel: 'ARTICLES_BLOCKING.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
              validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
            { field: 'UpdatedDate', type: 'text', displayLabel: 'ARTICLES_BLOCKING.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
              validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
            { field: 'CreatedBy', type: 'text', displayLabel: 'ARTICLES_BLOCKING.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
              validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
            { field: 'UpdatedBy', type: 'text', displayLabel: 'ARTICLES_BLOCKING.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
              validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
          ],
          uniqueConstraints: [],
          title: 'ARTICLES_BLOCKING.NAV',
          icon: 'icon-block-helper',
          idField: 'Id',
          lookupDisplayField: 'AttributeDisplayName',
          isDirty: false,
          isBulkActionCompleted: false,
          isCatalogSpecificModel: true,
          methods: {
            getList                 :   getArticles,
            activateBulk            :   activateArticlesBlocking,
            create                  :   createArticlesBlocking,
            update        					:   updateArticlesBlocking,
						createBulk    					:   createBulk
          },
          views: {
            mainList: {
              columns         : [ 'AttributeDisplayName', 'AttributeValue', 'Reason', 'Status', 'UpdatedDate', 'UpdatedBy' ],
              columnFilter    : {},
              toggleFilterProps: { toggleStatus:false, filterProp:'Status', trueVal:1, trueValTooltipMessage: 'ACTIONS.TOGGLE_ACTIVE', falseVal:'', falseValTooltipMessage:"ACTIONS.TOGGLE_ALL"},
              topIndex        : 0,
              showFilterRow   : false,
              sortColumn      : {'UpdatedDate': false},
              sortDescending  : true,
              itemActions     : [
                                  // { id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UpdateBlockArticle:true', disabled: false, visible: true },
                                  { id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateBlockArticleStatusBulk:true', disabled: false, visible: 'itm.Status',
                                      requiresConfirmation: false, confirmationContent: {title: 'ARTICLES.TITLES.DELETE_ALERT', message: 'ARTICLES.MESSAGES.CONFIRM_DROP'},
                                        confirmationAction: 'ACTIONS.DELETE'},
                                  { id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateBlockArticleStatusBulk:true', disabled: false, visible: '!itm.Status',
                                      requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'},
                                ],
              listActions     : [
                                  { id: 'delete', label: 'ACTIONS.DELETE_BULK', icon: 'icon-delete', privilege: 'UpdateBlockArticleStatusBulk:true', disabled: '{selected: true, Status: 1}', visible: true,
                                      requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                                  { id: 'activate', label: 'ACTIONS.ACTIVATE_BULK', icon: 'icon-undo-variant', privilege: 'UpdateBlockArticleStatusBulk:true', disabled: '{selected: true, Status: 0}', visible: true,
                                      requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'},
																	{ id: 'import', label: 'ACTIONS.IMPORT', icon: 'icon-import', privilege: 'CreateUpdateBlockArticleBulk:true', disabled: true, visible: true, requiresConfirmation: false},
																	{ id: 'blockedArticles', label: 'ARTICLES_BLOCKING.ACTIONS.BLOCKED_ARTICLES', icon: 'icon-block-helper', privilege: 'GetBlockedArticleList:true', disabled: '{selected: true, Status: 1}', visible: true, requiresConfirmation: false},
                                ],
              fabAction       : {id: 'add', label: 'ACTIONS.ADD', icon: 'icon-plus', privilege: 'CreateBlockArticle:true', visible: true}
            },
            mainDetails: {},
            privileges: {
                list    : 'GetBlockedArticleList'
            }
          }
      };

		function getArticles(generalProperties, model, catalogCode) {
			if (angular.isDefined(model)) { // to skip this part for load lookup
				model.isBulkActionCompleted = false;
			}
			var promise;
			catalogCode = angular.isUndefined(catalogCode) ? catalogFactory.getActiveCatalog().CatalogCode : catalogCode;
			if (angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
				var state = {};
				state.name = $state.current.name;
				state.params = $state.params;
				var isBulk = true;
				var logData = activityLogger.createLogData(null, state, 'catalogs.articlesBlocking', 'VIEW', isBulk, new Date(), null, null);
				promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/blockarticles', undefined, true, generalProperties.forceFetch);
				promise = activityLogger.log(logData, promise);
			} else {
				promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/blockarticles', undefined, true, generalProperties.forceFetch);
			}

			promise.then(function () {
				if (api.catalogs.articlesBlocking.isDirty) {
					//Invalidate lookupData
					api.catalogs.articlesBlocking.lookupData = undefined;
					api.catalogs.articlesBlocking.isDirty = false;
				}
			});
			return promise;
		}

		function activateArticlesBlocking(records, model, actionType, parentId) {
			var result = crud.createRequestObject(records, model, actionType);
			var state = {};
			state.name = $state.current.name;
			state.params = $state.params;
			var isBulk = result.itemsNameList.length > 1 ? true : false;
			var logData = activityLogger.createLogData(result.itemsNameList, state, 'catalogs.articlesBlocking', actionType.toUpperCase(), isBulk, new Date(), null, null);
			var promise = api.webPut(api.baseUrl + '/catalogs/' + parentId + '/blockarticles/status', result.requestObj);

			promise.then(function () {
				crud.onRecordStatusChange(records, api.catalogs.articlesBlocking, actionType);// it should be base model for dynamic models since base model isDirty is being change in all actions
			});

			return activityLogger.log(logData, promise);
		}

		function createArticlesBlocking(record, catalogCode) {
			var state = {};
			state.name = $state.current.name;
			state.params = $state.params;
			var logData = activityLogger.createLogData(record[api.catalogs.articlesBlocking.lookupDisplayField], state, 'catalogs.articlesBlocking', 'ADD', false, new Date(), null, null);
			var promise = api.webPost(api.baseUrl + '/catalogs/' + catalogCode + '/blockarticles', record);
			promise.then(function () {
				api.catalogs.articlesBlocking.isDirty = true;
			});
			return activityLogger.log(logData, promise);
		}

		function updateArticlesBlocking(recordId, record, catalogCode) {
			var state = {};
			state.name = $state.current.name;
			state.params = $state.params;
			var logData = activityLogger.createLogData(record[api.catalogs.articlesBlocking.lookupDisplayField], state, 'catalogs.articlesBlocking', 'EDIT', false, new Date(), null, null);

			var promise = api.webPut(api.baseUrl + '/catalogs/' + catalogCode + '/blockarticles/' + recordId, record);

			promise.then(function () {
				api.catalogs.articlesBlocking.isDirty = true;
			});
			return activityLogger.log(logData, promise);
		}

		function createBulk(model, records, catalogCode, assignedAttributes) {
			var transformedData = [];
			var catalogFields = utility.filterObject(model.fields, { isDynamicProperty: true }, true);
			angular.forEach(records, function (record) {
				record.BlockedCatalogs = [];
				angular.forEach(catalogFields, function (catalogField) {
					if (record[catalogField.field] != null && angular.isDefined(record[catalogField.field])) {
						var uppercaseCatalogFieldValue = record[catalogField.field].toString().trim().toUpperCase();
						if (uppercaseCatalogFieldValue !== '' && uppercaseCatalogFieldValue !== '0' && uppercaseCatalogFieldValue !== 'NO' && uppercaseCatalogFieldValue !== 'FALSE') {
							record.BlockedCatalogs.push(catalogField.catalogCode);
						}
						delete record[catalogField.field];
					}
				});

				if (record.AttributeDisplayName.toString().trim().toUpperCase() === 'MODELNUMBER') {
					record['AttributeSystemName'] = 'ModelNumber';
				} else if (record.AttributeDisplayName.toString().trim().toUpperCase() === 'ARTICLENUMBER') {
					record['AttributeSystemName'] = 'ArticleNumber';
				} else {
					record['AttributeSystemName'] = utility.filterObject(assignedAttributes, { AttributeDisplayName: record.AttributeDisplayName }, true)[0].AttributeSystemName;
				}

				delete record['AttributeDisplayName'];

				transformedData.push(record);
			});
			var jobIndex = jobsTracker.addJob(model, 'ARTICLES_BLOCKING.ACTIONS.IMPORT_ARTICLES', 1);
			api.webPut(api.baseUrl + '/catalogs/' + catalogCode + '/blockarticles?sourceapplication=' + CONSTANTS.SOURCE_APPLICATION + '&sourceaction=Import Articles Blocking', transformedData).then(function (response) {
				jobsTracker.trackJob(jobIndex, response.data.Id);
			}).catch(function (error) {
				jobsTracker.setCriticlaFail(jobIndex, error);
			});
		}
  }
})();
(function() {
  'use strict';

  angular
      .module('app.main.catalogs.articles-blocking')
      .run(runBlock);

  /* @ngInject */
  function runBlock(api, activityLogger, $state, catalogFactory) {

      if (angular.isUndefined(api.catalogs)) {
          api.catalogs = {};
      }
       api.catalogs.affectedArticles = {
          modelPath: 'catalogs.affectedArticles',
          fields: [
            { field: 'ArticleId', type: 'int', displayLabel: 'AFFECTED_ARTICLES.FIELDS.ARTICLE_ID', visible: true, creatable: false, editable: false, inputType: 'number',
              validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
            { field: 'ArticleNumber', type: 'text', displayLabel: 'AFFECTED_ARTICLES.FIELDS.ARTICLE_NUMBER', visible: true, creatable: false, editable: false, inputType: 'text',
              validation: {isRequired: true, maxLen: 20, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
            { field: 'ArticleName', type: 'text', displayLabel: 'ARTICLES.FIELDS.MODEL_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
              validation: {isRequired: false, maxLen: 200, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
            { field: 'ModelNumber', type: 'text', displayLabel: 'AFFECTED_ARTICLES.FIELDS.MODEL_NUMBER', visible: true, creatable: false, editable: false, inputType: 'text',
              validation: {isRequired: true, maxLen: 20, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
            { field: 'AffectedCatalogs', type: 'text', displayLabel: 'AFFECTED_ARTICLES.FIELDS.AFFECTED_CATALOGS', visible: true, creatable: false, editable: false, inputType: 'lookup-many', lookupSource: 'catalogs.catalogs',
              validation: {isRequired: true, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
            { field: 'Reason', type: 'text', displayLabel: 'ARTICLES_BLOCKING.FIELDS.REASON', visible: false, creatable: false, editable: false, inputType: 'text',
              validation: {isRequired: false, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
            // { field: 'BlockedCatalogs', type: 'text', displayLabel: 'AFFECTED_ARTICLES.FIELDS.BLOCKED_CATALOGS', visible: false, creatable: false, editable: false, inputType: 'lookup-many', lookupSource: 'catalogs.catalogs',
            //   validation: {isRequired: true, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} } // as per Saad for Blocked Articles use the affected catalogs filed as API do not send blocked catalogs in its response
          ],
          uniqueConstraints: [],
          title: 'AFFECTED_ARTICLES.NAV',
          icon: 'icon-block-helper',
          idField: 'ArticleId',
          lookupDisplayField: 'ArticleName',
          isDirty: false,
          isCatalogSpecificModel: true,
          methods: {
            getList             :   getAffectedArticles,
            getBlockedArticles  :   getBlockedArticles
          },
          views: {
            mainList: {
              columns         : [ 'ArticleNumber', 'ArticleName', 'ModelNumber', 'AffectedCatalogs', 'Reason' ],
              columnFilter    : {},
              toggleFilterProps: {},
              topIndex        : 0,
              showFilterRow   : false,
              sortColumn      : {'ArticleNumber': false},
              sortDescending  : true,
              itemActions     : [],
              listActions     : [],
              fabAction       : {}
            },
            mainDetails: {},
            privileges: {
                list    : 'GetAffectedArticleList'
            }
          }
      };

    function getAffectedArticles(catalogCode, record) {
      var promise;
      catalogCode = angular.isUndefined(catalogCode) ? catalogFactory.getActiveCatalog().CatalogCode : catalogCode;
      var state = {};
      state.name = $state.current.name;
      state.params = $state.params;
      var isBulk = true;
      var logData = activityLogger.createLogData(null, state, 'catalogs.affectedArticles', 'VIEW', isBulk, new Date(), null, null);
      promise = api.webPost(api.baseUrl + '/catalogs/' + catalogCode + '/affectedarticles', record);
      promise = activityLogger.log(logData, promise);
      promise.then(function () {
        if (api.catalogs.affectedArticles.isDirty) {
          //Invalidate lookupData
          api.catalogs.affectedArticles.lookupData = undefined;
          api.catalogs.affectedArticles.isDirty = false;
        }
      });
      return promise;
    }

    function getBlockedArticles(catalogCode, records) {
      var promise;
      var requestObject = {
        'ArticleBlockingIds' :[]
      };
      angular.forEach(records, function(record){
        requestObject.ArticleBlockingIds.push(record.Id);
      })

      catalogCode = angular.isUndefined(catalogCode) ? catalogFactory.getActiveCatalog().CatalogCode : catalogCode;
      var state = {};
      state.name = $state.current.name;
      state.params = $state.params;
      var isBulk = true;
      var logData = activityLogger.createLogData(null, state, 'catalogs.affectedArticles', 'VIEW', isBulk, new Date(), null, null);
      promise = api.webPost(api.baseUrl + '/catalogs/' + catalogCode + '/blockedarticlesbyids', requestObject);
      promise = activityLogger.log(logData, promise);
      promise.then(function () {
        if (api.catalogs.affectedArticles.isDirty) {
          //Invalidate lookupData
          api.catalogs.affectedArticles.lookupData = undefined;
          api.catalogs.affectedArticles.isDirty = false;
        }
      });
      return promise;
    }

  }
})();
(function() {
  'use strict';

  angular
      .module('app.main.catalogs.articles')
      .run(runBlock);

  /* @ngInject */
  function runBlock(api, $state, activityLogger) {

    if (angular.isUndefined(api.catalogs)) {
        api.catalogs = {};
    }
    api.catalogs.linkedCatalogArticleModel = {
      modelPath: 'catalogs.linkedCatalogArticleModel',
      fields: [
        { field: 'Id', type: 'int', displayLabel: 'ARTICLES.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
            validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
        { field: 'ArticleNumber', type: 'text', displayLabel: 'ARTICLES.FIELDS.ARTICLE_NUMBER', visible: true, creatable: false, editable: false, inputType: 'text',
            validation: {isRequired: true, maxLen: 20, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
        { field: 'ModelNumber', type: 'text', displayLabel: 'ARTICLES.FIELDS.MODEL_NUMBER', visible: true, creatable: false, editable: false, inputType: 'text',
            validation: {isRequired: false, maxLen: 200, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
        { field: 'ArticleName', type: 'text', displayLabel: 'ARTICLES.FIELDS.ARTICLE_NAME', visible: true, creatable: true, editable: true, inputType: 'text',
            validation: {isRequired: true, maxLen: 100, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
        { field: 'Season', type: 'text', displayLabel: 'ARTICLES.FIELDS.SEASON', visible: true, creatable: true, editable: true, inputType: 'text',
            validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
        { field: 'Status', type: 'text', displayLabel: 'ARTICLES.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
            validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
        { field: 'SortOrder', type: 'int', displayLabel: 'ARTICLES.FIELDS.SORT_ORDER', visible: true, creatable: false, editable: false, inputType: 'number',
            validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
        { field: 'CreatedDate', type: 'text', displayLabel: 'ARTICLES.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
            validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
        { field: 'UpdatedDate', type: 'text', displayLabel: 'ARTICLES.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
            validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
        { field: 'Created_By', type: 'text', displayLabel: 'ARTICLES.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
            validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
        { field: 'Updated_By', type: 'text', displayLabel: 'ARTICLES.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
            validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
        { field: 'BlockImage', type: 'int', displayLabel: 'ARTICLES.FIELDS.BLOCK_IMAGE', visible: false, creatable: false, editable: false, inputType: 'bool-int',
            validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
      ],
      uniqueConstraints: [],
      title: 'ARTICLES.NAV',
      icon: 'icon-cube-outline',
      idField: 'Id',
      lookupDisplayField: 'ArticleNumber',
      isDirty: false,
      isBulkActionCompleted: false,
      isCatalogSpecificModel: true,
      methods: {
        getLinkedCatalogModelsData  :   getLinkedCatalogModelsData
      },
      views: {
          mainList: {
              columns         : [ 'ModelNumber', 'ArticleName'],
              columnFilter    : {},
              imagesSize      : 'large',
              toggleFilterProps: {},
              topIndex        : 0,
              showFilterRow   : false,
              sortColumn      : {},
              sortDescending  : true,
              itemActions     : [],
              listActions     : [
                                  { id: 'save', label: 'ACTIONS.SAVE', icon: 'icon-content-save', privilege: 'UI_ImportArticles:true', disabled: '{selected: true}', visible: true, requiresConfirmation: false}
                                ],
              fabAction       : {}

            },
            mainDetails: {},
          privileges: { }
      }
    };

    function getLinkedCatalogModelsData(generalProperties, catalogCode) {
        var promise;
        catalogCode = angular.isUndefined(catalogCode) ? catalogFactory.getActiveCatalog().CatalogCode : catalogCode;
        var state = {};
        state.name = $state.current.name;
        state.params = $state.params;
        var isBulk = true;
        var logData = activityLogger.createLogData(null, state, 'catalogs.linkedCatalogArticleModel', 'VIEW', isBulk, new Date(), null, null);
        promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/linkcatalogmodels',
          generalProperties.config || {}, true, generalProperties.forceFetch,
          generalProperties.supportIncrementalResult || true,
          generalProperties.modelIdField || api.catalogs.linkedCatalogArticleModel.idField,
          generalProperties.isMajor || false);
        promise = activityLogger.log(logData, promise);

        promise.then(function () {
          if (api.catalogs.linkedCatalogArticleModel.isDirty) {
            //Invalidate lookupData
            api.catalogs.linkedCatalogArticleModel.lookupData = undefined;
            api.catalogs.linkedCatalogArticleModel.isDirty = false;
          }
        });
        return promise;
      }

  }
})();
(function() {
  'use strict';

  angular
	  .module('app.main.catalogs.articles')
	  .run(runBlock);

  /* @ngInject */
  function runBlock(api, activityLogger, $state, crud, jobsTracker, catalogFactory, articlesFactory, utility, CONSTANTS) {

	if (angular.isUndefined(api.catalogs)) {
		api.catalogs = {};
	}
	api.catalogs.linePlanArticles = {
		modelPath: 'catalogs.linePlanArticles',
		fields: [
		  { field: 'Id', type: 'int', displayLabel: 'ARTICLES.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
			validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
		  { field: 'ArticleNumber', type: 'text', displayLabel: 'ARTICLES.FIELDS.ARTICLE_NUMBER', visible: true, creatable: false, editable: false, inputType: 'text',
			  validation: {isRequired: true, maxLen: 20, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
		  { field: 'ModelNumber', type: 'text', displayLabel: 'ARTICLES.FIELDS.MODEL_NUMBER', visible: true, creatable: false, editable: false, inputType: 'text',
			  validation: {isRequired: false, maxLen: 200, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
		  { field: 'ArticleName', type: 'text', displayLabel: 'ARTICLES.FIELDS.ARTICLE_NAME', visible: true, creatable: true, editable: true, inputType: 'text',
			  validation: {isRequired: true, maxLen: 100, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
		  { field: 'RAID', type: 'int', displayLabel: 'ARTICLES.FIELDS.RAID', visible: false, creatable: false, editable: false, inputType: 'number',
			  validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
		  { field: 'RAN', type: 'text', displayLabel: 'ARTICLES.FIELDS.RAN', visible: true, creatable: false, editable: false, inputType: 'text',
			  validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
		  { field: 'PRAID', type: 'int', displayLabel: 'ARTICLES.FIELDS.PRAID', visible: false, creatable: false, editable: false, inputType: 'number',
			  validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
		  { field: 'PRAN', type: 'text', displayLabel: 'ARTICLES.FIELDS.PRAN', visible: true, creatable: false, editable: false, inputType: 'text',
			  validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
		  { field: 'Status', type: 'text', displayLabel: 'ARTICLES.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
			  validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
		  { field: 'PS', type: 'text', displayLabel: 'ARTICLES.FIELDS.PARENT_STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
			  validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
		  { field: 'Locked', type: 'int', displayLabel: 'ARTICLES.FIELDS.LOCKED', visible: true, creatable: false, editable: false, inputType: 'bool-int',
			  validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
		  { field: 'ArticleSource', type: 'text', displayLabel: 'ARTICLES.FIELDS.ARTICLE_SOURCE', visible: true, creatable: false, editable: false, inputType: 'text',
			  validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
		  { field: 'ImageSource', type: 'text', displayLabel: 'ARTICLES.FIELDS.IMAGE_SOURCE', visible: false, creatable: false, editable: false, inputType: 'url',
			  validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
		  { field: 'SortOrder', type: 'int', displayLabel: 'ARTICLES.FIELDS.SORT_ORDER', visible: true, creatable: false, editable: false, inputType: 'number',
			  validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
		  { field: 'CreatedDate', type: 'text', displayLabel: 'ARTICLES.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
			  validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
		  { field: 'UpdatedDate', type: 'text', displayLabel: 'ARTICLES.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
			  validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
		  { field: 'Created_By', type: 'text', displayLabel: 'ARTICLES.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
			  validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
		  { field: 'Updated_By', type: 'text', displayLabel: 'ARTICLES.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
			  validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
		  { field: 'BlockImage', type: 'int', displayLabel: 'ARTICLES.FIELDS.BLOCK_IMAGE', visible: false, creatable: false, editable: false, inputType: 'bool-int',
			  validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
		],
		uniqueConstraints: [],
		title: 'ARTICLES.NAV',
		icon: 'icon-cube-outline',
		idField: 'Id',
		lookupDisplayField: 'ArticleNumber',
		isDirty: false,
		isGenerateReport: false,
		isBulkActionCompleted: false,
		isCatalogSpecificModel: true,
		methods: {
			getList                             :   getArticles,
			getDetails                          :   getArticle,
			activateBulk                        :   activateArticles,
			create                              :   createArticle,
			update                              :   updateArticle,
			createBulk                          :   createBulk,
			updateBulkLinePlans                 :   updateBulkLinePlans,
			importLinePlans                     :   importLinePlans,
			updateViaImport                     :   updateViaImport,
		},
		views: {
			mainList: {
				columns         : [ 'ArticleNumber', 'ArticleName', 'Status', 'UpdatedDate' ],
				columnFilter    : {},
				imagesSize      : 'large',
				toggleFilterProps: { toggleStatus:false, filterProp:'Status', trueVal:1, trueValTooltipMessage: 'ACTIONS.TOGGLE_ACTIVE', falseVal:'', falseValTooltipMessage:"ACTIONS.TOGGLE_ALL"},
				topIndex        : 0,
				showFilterRow   : false,
				sortColumn      : {'UpdatedDate': false},
				sortDescending  : true,
				itemActions     : [
									{ id: 'view', label: 'ACTIONS.VIEW', icon: 'icon-magnify', privilege: 'GetCatalogArticleDetails', disabled: '!itm.Status', visible: true },
									{ id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UpdateCatalogArticleDetails:true', disabled: false, visible: true },
									{ id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateArticleStatusBulk:true', disabled: false, visible: 'itm.Status',
										requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'},
										  confirmationAction: 'ACTIONS.DELETE'},
									{ id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateArticleStatusBulk:true', disabled: false, visible: '!itm.Status',
										requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
								  ],
				listActions     : [
									{ id: 'delete', label: 'ACTIONS.DELETE_BULK', icon: 'icon-delete', privilege: 'UpdateArticleStatusBulk:true', disabled: '{selected: true, Status: 1}', visible: true,
										requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
									{ id: 'activate', label: 'ACTIONS.ACTIVATE_BULK', icon: 'icon-undo-variant', privilege: 'UpdateArticleStatusBulk:true', disabled: '{selected: true, Status: 0}', visible: true,
										requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'},
									{ id: 'updateBulkLinePlan', label: 'ACTIONS.UPDATE_BULK', icon: 'icon-pencil', privilege: 'UI_ImportLinePlans:true', disabled: '{selected: true}', visible: true, requiresConfirmation: false },
									{ id: 'importLinePlan', label: 'ACTIONS.IMPORT', icon: 'icon-import', privilege: 'UI_ImportLinePlans:true', disabled: false, visible: true, requiresConfirmation: false},
									{ id: 'updateViaImportLinePlan', label: 'ACTIONS.UPDATE_VIA_IMPORT', icon: 'icon-pencil-box-outline', privilege: 'UpdateOnlyCatalogBulkArticle:true', disabled: false, visible: true, requiresConfirmation: false},
									{ id: 'generateReport', label: 'ARTICLES.ACTIONS.REPORT_SLIDER', icon: 'icon-chart-bar', privilege: 'GetTargetsReport:true', disabled: 'false', visible: true}
								  ],
				fabAction       :
									{id: 'add', label: 'ACTIONS.ADD', icon: 'icon-menu', privilege: 'UI_CreateLinePlan:true', visible: true}

			  },
			  mainDetails: {
				  selectedTabIndex   : 0,
				  itemActions        : [
										{ id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateArticleStatusBulk:true', disabled: '{selected: true, Status: 1}',
											visible: true, requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'},confirmationAction: 'ACTIONS.DELETE'},
										{ id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateArticleStatusBulk:true', disabled: '{selected: true, Status: 0}',
											visible: true, requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
									  ],

				//PROXY FAB FOR DETAIL PAGE
				fab                 : {id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UpdateCatalogArticleDetails:true', visible: true}

			  },
			privileges: {
				list    : 'GetCatalogArticleList',
				details : 'GetCatalogArticleDetails'
			}
		}
	};

	function getArticles(generalProperties, model, catalogCode) {
	  if (angular.isDefined(model)) { // to skip this part for load lookup
		model.isBulkActionCompleted = false;
	  }
	  var promise;
	  catalogCode = angular.isUndefined(catalogCode) ? catalogFactory.getActiveCatalog().CatalogCode : catalogCode;
	  var url = api.baseUrl + '/catalogs/' + catalogCode + '/articles';
	  var state = {};
	  state.name = $state.current.name;
	  state.params = $state.params;
	  var isBulk = true;
	  var logData = activityLogger.createLogData(null, state, 'catalogs.linePlanArticles', 'VIEW', isBulk, new Date(), null, null);
	  promise = api.webGet(url,
		generalProperties.config || {}, true, generalProperties.forceFetch,
		generalProperties.supportIncrementalResult || true,
		generalProperties.modelIdField || api.catalogs.linePlanArticles.idField,
		generalProperties.isMajor || false, model || api.catalogs.linePlanArticles, false);
	  promise = activityLogger.log(logData, promise);
	  promise.then(function () {
		if (api.catalogs.linePlanArticles.isDirty) {
		  //Invalidate lookupData
		  api.catalogs.linePlanArticles.lookupData = undefined;
		  api.catalogs.linePlanArticles.isDirty = false;
		}
	  });
	  return promise;
	}

	function getArticle(isLogRequired, articleId, catalogCode) {
	  var promise;
	  if (angular.isDefined(isLogRequired) && isLogRequired === true) {
		var state = {};
		state.name = $state.current.name;
		state.params = $state.params;
		var isBulk = false;
		var items = [];
		promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/articles/' + articleId + '?status=0');
		promise.then(function (response) {
		  items.push(response.data[api.catalogs.linePlanArticles.lookupDisplayField]);
		});
		var logData = activityLogger.createLogData(items, state, 'catalogs.linePlanArticles', 'VIEW', isBulk, new Date(), null, null);
		promise = activityLogger.log(logData, promise);
	  }
	  else {
		promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/articles/' + articleId + '?status=0');
	  }
	  return promise;
	}

	function activateArticles(records, model, actionType, parentId) {
	  var result = crud.createRequestObject(records, model, actionType);
	  var state = {};
	  state.name = $state.current.name;
	  state.params = $state.params;
	  var isBulk = result.itemsNameList.length > 1 ? true : false;
	  var logData = activityLogger.createLogData(result.itemsNameList, state, 'catalogs.linePlanArticles', actionType.toUpperCase(), isBulk, new Date(), null, null);
	  var promise = api.webPut(api.baseUrl + '/catalogs/' + parentId + '/articles/status', result.requestObj);

	  promise.then(function () {
		crud.onRecordStatusChange(records, api.catalogs.linePlanArticles, actionType);// it should be base model for dynamic models since base model isDirty is being change in all actions
	  });

	  return activityLogger.log(logData, promise);
	}

	function createArticle(article, catalogCode, model, articleType) {
		var requestObj = angular.copy(article);
		var catalogAssignedAttributes = catalogFactory.getActiveCatalogDetails().AssignedCatalogAttributes;
		// article number will be generated or assigned from create-single-line-plan-article controller
	  if(angular.isDefined(articleType) && articleType.toLowerCase() === 'carryover') {
			requestObj.article_type = articleType;
			requestObj.ArticleNumber = article['ModelNumber'];
	  } else {
			requestObj.article_type = 'new';
			requestObj.ArticleNumber = articlesFactory.generateArticleNumber();
		}

		// if attribute value is empty remove those from the request object to avoid issue of sending "" for interger attributes
		for(var key in requestObj) {
			var isAttributeIndex = catalogAssignedAttributes.indexOf(utility.filterObject(catalogAssignedAttributes, { AttributeSystemName: key}, true)[0]);
			if(isAttributeIndex !== -1 && requestObj[key] === "") {
				delete requestObj[key];
			}
		}
	  var state = {};
	  state.name = $state.current.name;
	  state.params = $state.params;
	  var logData = activityLogger.createLogData(requestObj[api.catalogs.articles.lookupDisplayField], state, 'catalogs.articles', 'ADD', false, new Date(), null, null);
	  var promise = api.webPost(api.baseUrl + '/catalogs/' + catalogCode + '/article', requestObj);
	  promise.then(function () {
		api.catalogs.articles.isDirty = true;
	  });
	  return activityLogger.log(logData, promise);
	}

	function updateArticle(articleId, article, catalogCode, model) {
		var requestObj = angular.copy(article);
		var state = {};
		state.name = $state.current.name;
		state.params = $state.params;
		// remove restricted attributes from list
		// hide attributes which are restricted as not viewable and disable when restricted as not editable
		var roleBasedRestrictedAttributes = (angular.isDefined(api.roleBasedRestrictions) && angular.isDefined(api.roleBasedRestrictions.restrictedAttributesArray) && api.roleBasedRestrictions.restrictedAttributesArray.length > 0) ? api.roleBasedRestrictions.restrictedAttributesArray : [];
		if(roleBasedRestrictedAttributes.length > 0) {
			angular.forEach(roleBasedRestrictedAttributes, function(attribute) {
				if(attribute.notEditable) {
					delete requestObj[attribute.Name];
				}
			});
		}

		// temporary fix for ua prod bug Bug 46627: UA PROD: Articles can NOT be modified from T1 UI
		if(angular.isDefined(article['id'])) {
			delete requestObj['id'];
		}

		var logData = activityLogger.createLogData(article[api.catalogs.articles.lookupDisplayField], state, 'catalogs.articles', 'EDIT', false, new Date(), null, null);
		var promise = api.webPut(api.baseUrl + '/catalogs/' + catalogCode + '/articles/' + articleId, requestObj);
		promise.then(function () {
			api.catalogs.articles.isDirty = true;
		});
		return activityLogger.log(logData, promise);
	}

	function createBulk(model, data, catalogCode) {
		var jobIndex = jobsTracker.addJob(model, 'ACTIONS.SAVE', 1);
		api.webPut(api.baseUrl + '/catalogs/' + catalogCode + '/articles?sourceapplication=' + CONSTANTS.SOURCE_APPLICATION + '&sourceaction=Import Articles', data).then(function (response) {
			jobsTracker.trackJob(jobIndex, response.data.Id);
		}).catch(function (error) {
			jobsTracker.setCriticlaFail(jobIndex, error);
		});
	}

	function updateBulkLinePlans(model, records, updateRecord, catalogId) {
		angular.forEach(records, function (record) {
			for (var prop in updateRecord) {
				record[prop] = updateRecord[prop];
			}
			// temporary fix for ua prod bug Bug 46627: UA PROD: Articles can NOT be modified from T1 UI
			if(angular.isDefined(record['id'])) {
				delete record['id'];
			}
		});

		var jobIndex = jobsTracker.addJob(model, 'ARTICLES.ACTIONS.UPDATE_ARTICLES', 1);
		api.webPut(api.baseUrl + '/catalogs/' + catalogId + '/articles?sourceapplication=' + CONSTANTS.SOURCE_APPLICATION + '&sourceaction=Update Bulk Articles', records).then(function (response) {
			jobsTracker.trackJob(jobIndex, response.data.Id);
		}).catch(function (error) {
			jobsTracker.setCriticlaFail(jobIndex, error);
		});
	}

	function importLinePlans(model, data, catalogCode, existingLinePlans, linkedAttributeList) {
		var existingLinePlansMap = {};
		angular.forEach(existingLinePlans, function(existingLinePlan) {
			existingLinePlansMap[existingLinePlan.ArticleNumber] = existingLinePlan;
		})
		angular.forEach(data, function(d) {
			if(angular.isDefined(existingLinePlansMap[d.ArticleNumber])) {
				//If model number exist send model number to api
				if(angular.isDefined(existingLinePlansMap[d.ArticleNumber].ModelNumber)) {
					d.ModelNumber = existingLinePlansMap[d.ArticleNumber].ModelNumber;
				}

				if(angular.isDefined(existingLinePlansMap[d.ArticleNumber].article_type) && existingLinePlansMap[d.ArticleNumber].article_type &&
				 existingLinePlansMap[d.ArticleNumber].article_type.toString().trim().toLowerCase() === 'carryover') { // carryover
					//remove linked attributes from comp and carryover records which are not editable
					angular.forEach(linkedAttributeList, function(linkedAttribute) {
						if(linkedAttribute.Editable === 0) {
							delete d[linkedAttribute.AttributeSystemName];
						} else if(linkedAttribute.Editable === 1) {
							var articleModelLinkedAttribute = utility.filterObject(model.fields,{field: linkedAttribute.AttributeSystemName} , true)[0];
							if(angular.isDefined(articleModelLinkedAttribute.isLinkedAttributeEditable) && !articleModelLinkedAttribute.isLinkedAttributeEditable) {
								delete d[linkedAttribute.AttributeSystemName];
							}
						}
					});
					d.article_type = 'carryover';
					d['ArticleName'] = existingLinePlansMap[d.ArticleNumber].ArticleName; // ignore updating the article name for carryover article while importing
				} else { // comp
					d.article_type = 'new';
				}
			} else { // new
				d.article_type = 'new';
				d.ArticleNumber = articlesFactory.generateArticleNumber();
			}
		});

		var jobIndex = jobsTracker.addJob(model, 'ACTIONS.SAVE', 1);
		api.webPut(api.baseUrl + '/catalogs/' + catalogCode + '/articles?sourceapplication=' + CONSTANTS.SOURCE_APPLICATION + '&sourceaction=Import Articles', data).then(function (response) {
			jobsTracker.trackJob(jobIndex, response.data.Id);
		}).catch(function (error) {
			jobsTracker.setCriticlaFail(jobIndex, error);
		});
	}

	function updateViaImport(model, data, activeCatalog) {
		var jobIndex = jobsTracker.addJob(model, 'ARTICLES.ACTIONS.UPDATE_VIA_IMPORT', 1);
		api.webPut(api.baseUrl + '/catalogs/' + activeCatalog.CatalogCode + '/updatearticles?sourceapplication=' + CONSTANTS.SOURCE_APPLICATION + '&sourceaction=Update via Import', data).then(function(response) {
			jobsTracker.trackJob(jobIndex, response.data.Id);
		}).catch(function(error) {
			jobsTracker.setCriticlaFail(jobIndex, error);
		});
	}

  }
})();
(function() {
  'use strict';

  angular
    .module('app.main.catalogs.articles')
    .factory('articlesFactory', articlesFactory);

    /* @ngInject */
    function articlesFactory($q, utility, api, $filter, $translate, catalogFactory) {
      var articleNumbersMap = {};
      var service = {
        validateArticleShippingRange: validateArticleShippingRange,
        createArticleNumberMap      : createArticleNumberMap,
        generateArticleNumber       : generateArticleNumber,
        cleanArticleNumbersMap      : cleanArticleNumbersMap,
        formatAuditTrailData        : formatAuditTrailData,
        doesArticlesMeetSelectedStateRequirement: doesArticlesMeetSelectedStateRequirement,
        getHighestArticleStateRankStateId     : getHighestArticleStateRankStateId,
        getHighestModelStateRankStateId       : getHighestModelStateRankStateId
      }
      return service;

      /**
       * @description: return true if any one record have a property IsOutOfShippingRange set to 1
       * @param {array|object} articles
       */
      function validateArticleShippingRange(articles) {
        var records = articles;
        if(!angular.isArray(articles)) {
          records = utility.pushItemToArray(articles)
        }
        var containInvalid = false;
        for(var index=0; index<records.length; index++) {
          if(records[index]['Status'] === 1 && records[index]['IsOutOfShippingRange'] === 1) {
            records[index]['warn'] = true;
            containInvalid = true;
          }
        }
        return containInvalid;
      }

      /**
       * @description: It creates the ArticleNumberMap inorder to check if the generated article number using function generateArticleNumber() is unique or not
       * @param {array|object} articles
       */
      function createArticleNumberMap(articles) {
        angular.forEach(articles, function(article) {
          articleNumbersMap[article.ArticleNumber] = 1;
        })
        return articleNumbersMap;
      }

      /**
       * @description: return unique Article Number (like NN-123456) for creating articles for Line Plan Catalog
       */
      function generateArticleNumber() {
        var generatedArticleNumber = 'NN-'+(Math.floor(Math.random() * 899999) + 100000);
        if(articleNumbersMap[generatedArticleNumber]) {
          return generateArticleNumber();
        } else {
          articleNumbersMap[generatedArticleNumber] = 1;
          return generatedArticleNumber;
        }
      }

      function cleanArticleNumbersMap() {
        articleNumbersMap = {};
      }

      // helper method to format audit trail data to required format
      function formatAuditTrailData(segmentations, priceGroups, records, articleModel, lookupData, createdByInfo) {
        var isRoleBasedRestrictedSegmentationsAdded = (angular.isDefined(api.roleBasedRestrictions) && angular.isDefined(api.roleBasedRestrictions.restrictedSegmentationsArray) && api.roleBasedRestrictions.restrictedSegmentationsArray.length > 0) ? true : false;
        var auditTrail = [];
        angular.forEach(records, function(record) {
            var data = {};
            data.ChangeMaker = record.ChangeMaker;
            data.ChangeDate = record.ChangeDate;
            data.Changes = [];
            Object.keys(record.New).forEach(function (key) {
              if(key !== '_segmentations' && key !== '_prices' && key !== '_sizes') {
                var field = utility.filterObject(articleModel.fields, {field: key}, true)[0];
                var oldValue = record.Old[key];
                var newValue = record.New[key];
                var obj = {};
                var ignoreChange = false
                if(angular.isDefined(field)) {
                    if(field.inputType === 'articlenumber' || field.inputType === 'modelnumber') {
                        oldValue = $filter('recordRenderer')(oldValue, lookupData, field);
                        newValue = $filter('recordRenderer')(newValue, lookupData, field);
                    }
                    else if(field.inputType === 'color-palette') {
                        oldValue = $filter('colorPaletteRenderer')(oldValue, field);
                        newValue = $filter('colorPaletteRenderer')(newValue, field);
                    }
                    else if(field.inputType === 'dataset') {
                      var parsedNewVal
                      var parsedOldVal

                      try {
                        parsedNewVal = newValue ? JSON.parse(newValue) : null
                      }
                      catch(e) {
                        parsedNewVal = null
                      }

                      try {
                        parsedOldVal = oldValue ? JSON.parse(oldValue) : null
                      }
                      catch(e) {
                        parsedOldVal = null
                      }

                      var isOldEmpty = !parsedOldVal || Object.keys(parsedOldVal).length === 0
                      var isNewEmpty = !parsedNewVal || Object.keys(parsedNewVal).length === 0
                      var oldHasNoDisplay = parsedOldVal && !parsedOldVal.DisplayValue
                      var newHasNoDisplay = parsedNewVal && !parsedNewVal.DisplayValue

                      // igore if PreviousValue is empty and NewValue has data but "DisplayValue" property is NOT present
                      // ingore if PreviousValue and NewValue both do not have "DisplayValue"
                      if ((isOldEmpty && !isNewEmpty && newHasNoDisplay) || (!isOldEmpty && !isNewEmpty && newHasNoDisplay && oldHasNoDisplay)) {
                        ignoreChange = true
                      }

                      if (!ignoreChange) {
                        if (parsedOldVal && !parsedOldVal.DisplayValue && parsedNewVal && parsedNewVal.DisplayValue) {
                          oldValue = '';
                          if (parsedNewVal && parsedNewVal.DisplayValue) {
                            newValue = parsedNewVal.DisplayValue
                          }
                        }
                        else {
                          if (parsedNewVal && parsedNewVal.DisplayValue) {
                            newValue = parsedNewVal.DisplayValue
                          }
                          if (parsedOldVal && parsedOldVal.DisplayValue) {
                            oldValue = parsedOldVal.DisplayValue
                          }
                        }
                      }
                    }
                    if(field.inputType === 'linkedcatalogarticlenumber') {
                        oldValue = utility.getLinkedArticleNumberAttributeTypeValue(oldValue, true);
                        newValue = utility.getLinkedArticleNumberAttributeTypeValue(newValue, true);
                    }
                    var displayLabel = field.displayLabel.includes('.') ? $filter('translate')(field.displayLabel) : field.displayLabel;
                    obj = {FieldName: displayLabel, Old: oldValue, New: newValue};
                } else {
                  obj = {FieldName: key, Old: oldValue, New: newValue}
                }
                if (!ignoreChange) {
                  data.Changes.push(obj);
                }
              } else if(key === '_segmentations') {
                var translatedLabel = $translate.instant('Segmentations');
                var obj = {FieldName: translatedLabel, NestedValues: []};
                Object.keys(record.Old['_segmentations']).forEach(function (segmentationKey) {
                  var segmentationName = getSegmentationDisplayName(segmentationKey, segmentations);
                  // check if any restricted segmentations
                  if(isRoleBasedRestrictedSegmentationsAdded) {
                    var restrictedSegmentation = utility.filterObject(api.roleBasedRestrictions.restrictedSegmentationsArray, { Name: segmentationName}, true)[0];
                    if(angular.isDefined(restrictedSegmentation) && !restrictedSegmentation.notViewable) {
                      var segmentationObj = {FieldName: segmentationName, Old: translateToCommaSepratedString(record.Old._segmentations[segmentationKey]), New: translateToCommaSepratedString(record.New._segmentations[segmentationKey])};
                      obj.NestedValues.push(segmentationObj);
                    } else if(angular.isUndefined(restrictedSegmentation)){
                      var segmentationObj = {FieldName: segmentationName, Old: translateToCommaSepratedString(record.Old._segmentations[segmentationKey]), New: translateToCommaSepratedString(record.New._segmentations[segmentationKey])};
                      obj.NestedValues.push(segmentationObj);
                    }
                  } else {
                    var segmentationObj = {FieldName: segmentationName, Old: translateToCommaSepratedString(record.Old._segmentations[segmentationKey]), New: translateToCommaSepratedString(record.New._segmentations[segmentationKey])};
                    obj.NestedValues.push(segmentationObj);
                  }
                });
                data.Changes.push(obj);
              } else if(key === '_prices') {
                var obj = {FieldName: 'Prices', NestedValues: []};
                Object.keys(record.Old['_prices']).forEach(function (priceKey) {
                  var priceGroupName = getPriceGroupDisplayName(priceKey, priceGroups);
                  var pricesObj = {FieldName: priceGroupName, Old: record.Old._prices[priceKey], New: record.New._prices[priceKey]};
                  obj.NestedValues.push(pricesObj);
                });
                data.Changes.push(obj);
              } else if(key === '_sizes') {
                  var sizeAdded = '';
                  var sizeRemoved = '';
                  if(angular.isDefined(record.New._sizes.SizeAdded)) {
                    sizeAdded = 'Added: ' + record.New._sizes.SizeAdded;
                  }
                  if(angular.isDefined(record.New._sizes.SizeRemoved)) {
                    sizeRemoved = 'Removed: ' +record.New._sizes.SizeRemoved;
                  }
                  var obj = {FieldName: 'Sizes', Old: sizeRemoved, New: sizeAdded};
                  data.Changes.push(obj);
              }
            });
            if(data.Changes.length) {
              auditTrail.push(data);
            }
        });
        auditTrail.push({
          CreatedBy: createdByInfo.CreatedBy,
          ChangeDate: createdByInfo.CreatedDate
        })
        return utility.orderBy(auditTrail, 'ChangeDate', true);
      }

      function getSegmentationDisplayName(segmentationKey, segmentations) {
        var segmentation = utility.filterObject(segmentations, {SegmentationId : parseInt(segmentationKey)}, true)[0];
        if(angular.isDefined(segmentation) && angular.isDefined(segmentation.Name)) {
          return segmentation.Name;
        } else {
          return segmentationKey; // if segmentation is not avaialable
        }
      }

      function translateToCommaSepratedString(historyObject) {
        // planning values are rendered verbatim (the value returned by the API)
        var commaSepratedValues = Object.keys(historyObject).map(function(key) {
          return (key === 'PlanningValue' ? 'Planning Value' : key) +': '+ historyObject[key];
        }).join(', ');
        return commaSepratedValues;
      }

      function getPriceGroupDisplayName(priceKey, priceGroups) {
        var price = utility.filterObject(priceGroups, {PriceGroupId : parseInt(priceKey)}, true)[0];
        if(angular.isDefined(price) && angular.isDefined(price.Name)) {
          return price.Name;
        } else {
          return priceKey; // if price group is not avaialable
        }
      }

    function doesArticlesMeetSelectedStateRequirement(articles, requiredAttributesList, isSizeScaleRequired, isPrimaryColorRequired, isFromDataImporter) {
        var articlesRequiredAttributes = {};
        var doesArticlesMeetSelectedStateRequirement = true;
        var requiredAttributes = requiredAttributesList || [];
        for(var i = 0; i < articles.length; i++) {
          var currentArticle = articles[i];
          articlesRequiredAttributes[currentArticle.ArticleNumber] = { doesArticleMeetSelectedStateRequirement: true, articlesRequiredAttributesList: [], stateLevelValidRequiredAttributesList: [] }
          for(var j = 0; j < requiredAttributes.length; j++) {
            var requiredAttribute = requiredAttributes[j];
            var isRequiredAttributeValid = true;
            if(requiredAttribute.Criteria && requiredAttribute.Criteria.toString().trim() !== '') {
              var criteria = {};
              try {
                var criteriaJSON = JSON.parse(requiredAttribute.Criteria);
                var key = Object.keys(criteriaJSON)[0];
                criteria = { key : key, value: !Array.isArray(criteriaJSON[key]) ? [criteriaJSON[key]] : criteriaJSON[key] };
              } catch(error) {
                console.log("Criteria : Invalid JSON format for ",requiredAttribute.AttributeSystemName);
              }
              if(criteria.value && criteria.value.length) {
                var matchedValue = criteria.value.filter(function(value) {
                  if(currentArticle[criteria.key] != null) {
                    return value.toString().toLowerCase().trim() === currentArticle[criteria.key].toString().toLowerCase().trim();
                  } else {
                    return false;
                  }
                })
                isRequiredAttributeValid = matchedValue.length > 0;
              }
            }

            if (isRequiredAttributeValid) {
              // when single article we need to show all the criteria valid required attributes with sizescale and primary color
              articlesRequiredAttributes[currentArticle.ArticleNumber].stateLevelValidRequiredAttributesList.push(requiredAttribute.AttributeSystemName);
              if (currentArticle[requiredAttribute.AttributeSystemName] == null || (currentArticle[requiredAttribute.AttributeSystemName] != null && !currentArticle[requiredAttribute.AttributeSystemName].toString().trim().length)) {
                articlesRequiredAttributes[currentArticle.ArticleNumber].articlesRequiredAttributesList.push(requiredAttribute.AttributeSystemName)
                articlesRequiredAttributes[currentArticle.ArticleNumber].doesArticleMeetSelectedStateRequirement = false
                doesArticlesMeetSelectedStateRequirement = false
              }
            }
          }

          // check for sizeScale
          if(isSizeScaleRequired) {
            // when single article we need to show all the criteria valid required attributes with sizescale and primary color
            articlesRequiredAttributes[currentArticle.ArticleNumber].stateLevelValidRequiredAttributesList.push('SizeScaleId');
            var isSizeScaleNotAvailable = !isFromDataImporter ? (currentArticle['SizeScaleId'] == null || currentArticle['SizeScaleId'] === 0) : (currentArticle['SizeScale'] == null || currentArticle['SizeScale'] === '');
            if(isSizeScaleNotAvailable) {
              articlesRequiredAttributes[currentArticle.ArticleNumber].articlesRequiredAttributesList.push('SizeScaleId')
              articlesRequiredAttributes[currentArticle.ArticleNumber].doesArticleMeetSelectedStateRequirement = false
              doesArticlesMeetSelectedStateRequirement = false
            }
          }

          // check for Primary Color
          if(isPrimaryColorRequired) {
            // when single article we need to show all the criteria valid required attributes with sizescale and primary color
            articlesRequiredAttributes[currentArticle.ArticleNumber].stateLevelValidRequiredAttributesList.push('ColorId');
            var isPrimaryColorNotAvailable = !isFromDataImporter ? (currentArticle['ColorId'] == null || currentArticle['ColorId'] === 0) : (currentArticle['ColorId'] == null || currentArticle['ColorId'] === '');
            if(isPrimaryColorNotAvailable) {
              articlesRequiredAttributes[currentArticle.ArticleNumber].articlesRequiredAttributesList.push('ColorId')
              articlesRequiredAttributes[currentArticle.ArticleNumber].doesArticleMeetSelectedStateRequirement = false
              doesArticlesMeetSelectedStateRequirement = false
            }
          }
        }
        return {
          doesArticlesMeetSelectedStateRequirement: doesArticlesMeetSelectedStateRequirement,
          articlesRequiredAttributes: articlesRequiredAttributes
        }
      }

      // get heighest article state ranked state id
      function getHighestArticleStateRankStateId(articles) {
        var highestStateRankStateId = 0;
        var articleWithHeightStateRank = articles.reduce(function(prev, current) {
          return (prev.StateRank > current.StateRank) ? prev : current;
        });
        if(articleWithHeightStateRank.StateId != null) {
          highestStateRankStateId = articleWithHeightStateRank.StateId;
        }
        return highestStateRankStateId;
      }

      // get heighest model state ranked state id
      function getHighestModelStateRankStateId(articles) {
        var highestStateRankStateId = 0;
        var articleWithHeightModelStateRank = articles.reduce(function(prev, current) {
          return (prev.ModelStateRank > current.ModelStateRank) ? prev : current;
        });
        if(articleWithHeightModelStateRank.ModelStateId != null) {
          highestStateRankStateId = articleWithHeightModelStateRank.ModelStateId;
        }
        return highestStateRankStateId;
      }

    }
})();
(function() {
'use strict';

angular
		.module('app.main.catalogs.articles')
		.run(runBlock);

/* @ngInject */
function runBlock(api, activityLogger, $state, crud, jobsTracker, catalogFactory, CONSTANTS, $log, utility, $q, SecurityFactory, $localStorage, errorDialog, dialog, $document, $filter) {

	if (angular.isUndefined(api.catalogs)) {
		api.catalogs = {};
	}
	api.catalogs.articles = {
		modelPath: 'catalogs.articles',
		fields: [
			{ field: 'Id', map:'Id', type: 'int', displayLabel: 'ARTICLES.FIELDS.ARTICLE_ID', visible: true, creatable: false, editable: false, inputType: 'number',
				validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
			{ field: 'ArticleId', type: 'int', displayLabel: 'ARTICLES.FIELDS.ARTICLE_ID', visible: false, creatable: false, editable: false, inputType: 'number',
				validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
			{ field: 'ArticleNumber', map:'ArticleNumber', type: 'text', displayLabel: 'ARTICLES.FIELDS.ARTICLE_NUMBER', visible: true, creatable: true, editable: true, inputType: 'text',
				validation: {isRequired: true, maxLen: 20, minLen: 1, pattern: '^[^ ]*(?: [^ ]+)* ?$', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: 'VALIDATIONS.CONSECUTIVE_WHITE_SPACE_NOT_ALLOWED'}} },
			// allowEnterNewValue is used to allow user to enter new model number from articles.
			// for articles we want to send model number as the entred value so setting this field as allowEnterNewValue: "ModelNumber".
			// we will support allowEnterNewValue: "true" for fields to use it for same field with string true value
			// onChangeLookUpSetValue is used to set the Model Name to Article Name fields( If we completely change the article name to model name )
			{ field: 'ModelId', map:'ModelId', type: 'int', displayLabel: 'ARTICLES.FIELDS.MODEL_NUMBER', visible: false, creatable: true, editable: false, inputType: 'lookup', lookupSource:'lists.catalogModelList', allowEnterNewValue: "ModelNumber",
				validation: {isRequired: false, maxLen: -1, minLen: 1, pattern: '', onChangeLookUpSetValue: 'ArticleName,ModelName', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
			{ field: 'ModelId', map:'ModelId', type: 'int', displayLabel: 'ARTICLES.FIELDS.MODEL_ID', visible: false, creatable: false, editable: false, inputType: 'number',
				validation: {isRequired: false, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
			{ field: 'ModelNumber',  map:'ModelNumber', type: 'text', displayLabel: 'ARTICLES.FIELDS.MODEL_NUMBER', visible: true, creatable: true, editable: false, showInEdit: true, inputType: 'text',
				validation: {isRequired: false, maxLen: 200, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
			{ field: 'ArticleName',  map:'ArticleName', type: 'text', displayLabel: 'ARTICLES.FIELDS.MODEL_NAME', visible: true, creatable: true, editable: false, inputType: 'text',
				validation: {isRequired: true, maxLen: 100, minLen: 1, pattern: '',  disabledCriteria: 'vm.record.ModelId !== null', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
			{ field: 'MasterModelId', map:'MasterModelId', type: 'int', displayLabel: 'ARTICLES.FIELDS.MODEL_ID', visible: false, creatable: false, editable: false, inputType: 'number',
				validation: {isRequired: false, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
			// used for importing sizescales using licencee model number
			{ field: 'LicenseeModelNumber', type: 'text', displayLabel: 'ARTICLES.FIELDS.LICENCEE_MODEL_NUMBER', visible: false, creatable: false, editable: false, inputType: 'text',
				validation: {isRequired: false, maxLen: 200, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
			{ field: 'ParentModelNumber',  map:'ParentModelNumber', type: 'text', displayLabel: 'ARTICLES.FIELDS.PARENT_MODEL_NUMBER', visible: true, creatable: false, editable: false, inputType: 'text',
				validation: {isRequired: false, maxLen: 200, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
			{ field: 'ParentModelName',  map:'ParentModelName', type: 'text', displayLabel: 'ARTICLES.FIELDS.PARENT_MODEL_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
				validation: {isRequired: false, maxLen: 200, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
			{ field: 'ColorCode',  map:'ColorCode', type: 'int', displayLabel: 'ARTICLES.FIELDS.COLOR_CODE', visible: false, creatable: false, editable: false, inputType: 'number', prefixZeros: 3,
				validation: {isRequired: false, maxLen: -1, minLen: 1, pattern: '^(0*[1-9][0-9]{0,2}|100|999)$', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: 'VALIDATIONS.CODE_POSITIVE_NUMBER'}} },
			{ field: 'ColorName',  map:'ColorName', type: 'text', displayLabel: 'ARTICLES.FIELDS.PRIMARY_COLOR_NAME', visible: false, creatable: false, editable: false, inputType: 'text',
				validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
			{ field: 'HexCode',  map:'HexCode', type: 'text', displayLabel: 'ARTICLES.FIELDS.HEXCODE', visible: false, creatable: false, editable: false, inputType: 'color-picker',
				validation: {isRequired: false, maxLen: 7, minLen: 0, pattern: '^#(?:[0-9a-fA-F]{3}){2}$', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: 'COLOR_DEFINITION.VALIDATIONS.INVALID'}} },
			{ field: 'ColorGroup',  map:'ColorGroup', type: 'text', displayLabel: 'ARTICLES.FIELDS.COLOR_GROUP', visible: true, creatable: false, editable: false, inputType: 'text',
				validation: {isRequired: false, maxLen: 250, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
			{ field: 'ColorType',  map:'ColorType', type: 'text', displayLabel: 'ARTICLES.FIELDS.COLOR_TYPE', visible: true, creatable: false, editable: false, inputType: 'text',
				validation: {isRequired: false, maxLen: 250, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
			{ field: 'ColorAssetId',  map:'ColorAssetId', type: 'text', displayLabel: 'ARTICLES.FIELDS.COLOR_ASSET_ID', visible: true, creatable: false, editable: false, inputType: 'text',
				validation: {isRequired: false, maxLen: 250, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
			{ field: 'RAID',  map:'RAID', type: 'int', displayLabel: 'ARTICLES.FIELDS.RAID', visible: false, creatable: false, editable: false, inputType: 'number',
				validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
			{ field: 'RAN',  map:'RAN', type: 'text', displayLabel: 'ARTICLES.FIELDS.RAN', visible: true, creatable: false, editable: false, inputType: 'text',
				validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
			{ field: 'PRAID',  map:'PRAID', type: 'int', displayLabel: 'ARTICLES.FIELDS.PRAID', visible: false, creatable: false, editable: false, inputType: 'number',
				validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
			{ field: 'PRAN',  map:'PRAN', type: 'text', displayLabel: 'ARTICLES.FIELDS.PRAN', visible: false, creatable: false, editable: false, inputType: 'text',
				validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
			{ field: 'Status',  map:'Status', type: 'text', displayLabel: 'ARTICLES.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'article-status', parentField: 'PS', // parent field is added to show status based on parent status(for master catalog PS and Status are same)
				validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
			{ field: 'DropReason',  map:'DropReason', type: 'text', displayLabel: 'ARTICLES.FIELDS.DROP_REASON', visible: true, creatable: false, editable: false, inputType: 'text',
				validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
			{ field: 'PS',  map:'PS', type: 'text', displayLabel: 'ARTICLES.FIELDS.PARENT_STATUS', visible: false, creatable: false, editable: false, inputType: 'status',
				validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
			{ field: 'Locked',  map:'Locked', type: 'int', displayLabel: 'ARTICLES.FIELDS.LOCKED', visible: true, creatable: false, editable: false, inputType: 'bool-int',
				validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
			{ field: 'ArticleSource',  map:'ArticleSource', type: 'text', displayLabel: 'ARTICLES.FIELDS.ARTICLE_SOURCE', visible: true, creatable: false, editable: false, inputType: 'text',
				validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
			{ field: 'ImageSource',  map:'ImageSource', type: 'text', displayLabel: 'ARTICLES.FIELDS.IMAGE_SOURCE', visible: false, creatable: false, editable: false, inputType: 'url',
				validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },

				// following fields SizeScaleId, SizeScale properties like creatable visible etc will be set dynamically and they need to remain false in model
			{ field: 'PSizeScale',  map:'PSizeScale', type: 'text', displayLabel: 'ARTICLES.FIELDS.PARENT_SIZE_SCALE', visible: false, creatable: false, editable: false, showInEdit: false, inputType: 'text',
				validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
			{ field: 'PSizeScaleId',  map:'PSizeScaleId', type: 'text', displayLabel: 'ARTICLES.FIELDS.PARENT_SIZE_SCALE_ID', visible: false, creatable: false, editable: false, inputType: 'text',
				validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
			{ field: 'SizeScaleId',  map:'SizeScaleId', type: 'int', displayLabel: 'ARTICLES.FIELDS.SIZE_SCALE_ID', visible: false, creatable: false, editable: false, inputType: 'number',
				validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
			{ field: 'SizeScaleId',  map:'SizeScaleId', type: 'int', displayLabel: 'ARTICLES.FIELDS.SIZE_SCALE', visible: false, creatable: false, editable: false, inputType: 'lookup', lookupSource: 'catalogs.sizeScaleGroups',
				validation: {isRequired: true, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
			{ field: 'MasterSizeScale',  map:'MasterSizeScale', type: 'text', displayLabel: 'ARTICLES.FIELDS.MASTER_SIZE_SCALE', visible: false, creatable: false, editable: false, inputType: 'text',
				validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
			{ field: 'SizeScale',  map:'SizeScale', type: 'text', displayLabel: 'ARTICLES.FIELDS.SIZE_SCALE', visible: false, creatable: false, editable: false, inputType: 'text',
				validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
			{ field: 'MasterSizeScaleId',  map:'MasterSizeScaleId',type: 'int', displayLabel: 'ARTICLES.FIELDS.MASTER_SIZE_SCALE_ID', visible: false, creatable: false, editable: false, inputType: 'number',
				validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
			// used on the manage article state
			{ field: 'MasterSizeScaleId',  map:'MasterSizeScaleId',type: 'int', displayLabel: 'ARTICLES.FIELDS.MASTER_SIZE_SCALE', visible: false, creatable: false, editable: false, inputType: 'lookup', lookupSource:'sellers.masterSizeScales',
				validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				// above fields SizeScaleId, SizeScale properties like creatable visible etc will be set dynamically and they need to remain false in model

			{ field: 'SortOrder',  map:'SortOrder', type: 'int', displayLabel: 'ARTICLES.FIELDS.SORT_ORDER', visible: true, creatable: true, editable: true, inputType: 'number', skipEmptyValue: true,
				validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
			{ field: 'CreatedDate',  map:'CreatedDate', type: 'text', displayLabel: 'ARTICLES.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
				validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
			{ field: 'UpdatedDate',  map:'UpdatedDate', type: 'text', displayLabel: 'ARTICLES.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
				validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
			{ field: 'Created_By',  map:'Created_By', type: 'text', displayLabel: 'ARTICLES.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
				validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
			{ field: 'Updated_By',  map:'Updated_By', type: 'text', displayLabel: 'ARTICLES.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
				validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
			{ field: 'isArticleLockingDisable',  map:'isArticleLockingDisable', type: 'text', visible: false, creatable: false, editable: false, inputType: 'status', // used internally
				validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
			{ field: 'isPriceUpdateLocked',  map:'isPriceUpdateLocked', type: 'text', visible: false, creatable: false, editable: false, inputType: 'status', // used internally
				validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
			{ field: 'BlockImage',  map:'BlockImage', type: 'int', displayLabel: 'ARTICLES.FIELDS.BLOCK_IMAGE', visible: true, creatable: true, editable: true, inputType: 'bool-int',
				validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },

			// retail window fileds
			{ field: 'PShipmentStartDate',  map:'PShipmentStartDate', type: 'text', displayLabel: 'ARTICLES.FIELDS.PARENT_SHIPMENT_START_DATE', visible: false, creatable: false, editable: false, showInEdit: false, inputType: 'date-utc',
				validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
			{ field: 'PShipmentEndDate',  map:'PShipmentEndDate', type: 'text', displayLabel: 'ARTICLES.FIELDS.PARENT_SHIPMENT_END_DATE', visible: false, creatable: false, editable: false, showInEdit: false, inputType: 'date-utc',
				validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
			{ field: 'PRetailIntroMonth',  map:'PRetailIntroMonth', type: 'text', displayLabel: 'ARTICLES.FIELDS.PARENT_RETAIL_INTRO_MONTH', visible: false, creatable: false, editable: false, showInEdit: false, inputType: 'text',
				validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
			{ field: 'PRetailExitMonth',  map:'PRetailExitMonth', type: 'text', displayLabel: 'ARTICLES.FIELDS.PARENT_RETAIL_EXIT_MONTH', visible: false, creatable: false, editable: false, showInEdit: false, inputType: 'text',
				validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
			{ field: 'PPeriod',  map:'PPeriod', type: 'text', displayLabel: 'ARTICLES.FIELDS.PARENT_PERIOD', visible: false, creatable: false, editable: false, inputType: 'text',
				validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
			{ field: 'PShipmentWindowRangeId',  map:'PShipmentWindowRangeId', type: 'text', displayLabel: 'ARTICLES.FIELDS.PARENT_RETAIL_WINDOW_ID', visible: false, creatable: false, editable: false, inputType: 'text',
				validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },

			{ field: 'RetailIntroMonth',  map:'RetailIntroMonth', type: 'text', displayLabel: 'ARTICLES.FIELDS.RETAIL_INTRO_MONTH', visible: true, creatable: false, editable: false, inputType: 'text',
				validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
			{ field: 'RetailExitMonth',  map:'RetailExitMonth', type: 'text', displayLabel: 'ARTICLES.FIELDS.RETAIL_EXIT_MONTH', visible: true, creatable: false, editable: false, inputType: 'text',
				validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
			{ field: 'Period',  map:'Period', type: 'text', displayLabel: 'ARTICLES.FIELDS.PERIOD', visible: true, creatable: false, editable: false, inputType: 'text',
				validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
			{ field: 'RetailIntroMonthId',  map:'ShipmentWindowRangeId', type: 'text', displayLabel: 'ARTICLES.FIELDS.RETAIL_INTRO_MONTH', visible: false, creatable: false, editable: false, inputType: 'lookup', lookupSource:'catalogs.retailIntroMonthsForArticle',
				lookupFilter: {'Status': 1}, useLookupName: true, validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
			{ field: 'RetailExitMonthId',  map:'ShipmentWindowRangeId', type: 'text', displayLabel: 'ARTICLES.FIELDS.RETAIL_EXIT_MONTH', visible: false, creatable: false, editable: false, inputType: 'lookup', lookupSource:'catalogs.retailExitMonthsForArticle',
				lookupFilter: {'Status': 1}, useLookupName: true, validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', disabledCriteria: 'vm.record.RetailIntroMonthId == null', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
			// { field: 'ShipmentWindowRangeId',  map:'ShipmentWindowRangeId', type: 'text', displayLabel: 'ARTICLES.FIELDS.RETAIL_WINDOW_ID', visible: false, creatable: false, editable: false, inputType: 'text',
			// 	validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
			{ field: 'ShipmentStartDate',  map:'ShipmentStartDate', type: 'text', displayLabel: 'ARTICLES.FIELDS.SHIPMENT_START_DATE', visible: true, creatable: false, editable: false, inputType: 'date-utc',
				validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
			{ field: 'ShipmentEndDate',  map:'ShipmentEndDate', type: 'text', displayLabel: 'ARTICLES.FIELDS.SHIPMENT_END_DATE', visible: true, creatable: false, editable: false, inputType: 'date-utc',
				validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
			{ field: 'IsOutOfShippingRange',  map:'IsOutOfShippingRange', type: 'text', displayLabel: 'ARTICLES.FIELDS.OUT_OF_RETAIL_WINDOW', visible: true, creatable: false, editable: false, inputType: 'bool-int',
				validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },

			// state level fields
			{ field: 'StateRank',  map:'StateRank', type: 'int', displayLabel: 'ARTICLES.FIELDS.STATE_RANK', visible: false, creatable: false, editable: false, inputType: 'number',
				validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
			{ field: 'ModelStateId',  map:'ModelStateId', type: 'text', displayLabel: 'ARTICLES.FIELDS.MODEL_STATE_ID', visible: true, creatable: false, editable: false, inputType: 'text',
				validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
			{ field: 'ModelStateName',  map:'ModelStateName', type: 'text', displayLabel: 'ARTICLES.FIELDS.MODEL_STATE_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
				validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
			{ field: 'ModelStateRank',  map:'ModelStateRank', type: 'int', displayLabel: 'ARTICLES.FIELDS.MODEL_STATE_RANK', visible: false, creatable: false, editable: false, inputType: 'number',
				validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },

			{ field: 'AllowRetailWindowUpdateOnChild',  map:'AllowRetailWindowUpdateOnChild', type: 'text', displayLabel: 'ARTICLES.FIELDS.ALLOW_RETAIL_WINDOW_UPDATE_ON_CHILD', visible: false, creatable: false, editable: false, inputType: 'bool-int',
				validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
			{ field: 'AllowRetailWindowUpdate',  map:'AllowRetailWindowUpdate', type: 'text', displayLabel: 'ARTICLES.FIELDS.ALLOW_RETAIL_WINDOW_UPDATE', visible: false, creatable: false, editable: false, inputType: 'bool-int',
				validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
			{ field: 'SeasonalSequence',  map:'SeasonalSequence', type: 'int', displayLabel: 'ARTICLES.FIELDS.SEASONAL_SEQUENCE', visible: true, creatable: false, editable: false, inputType: 'number',
				validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
			{ field: 'ArticleLifecycle',  map:'ArticleLifecycle', type: 'text', displayLabel: 'ARTICLES.FIELDS.ARTICLE_LIFE_CYCLE', visible: true, creatable: false, editable: false, inputType: 'text',
				validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
			{ field: 'ModelLifecycle',  map:'ModelLifecycle', type: 'text', displayLabel: 'ARTICLES.FIELDS.MODEL_LIFE_CYCLE', visible: true, creatable: false, editable: false, inputType: 'text',
				validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
			{ field: 'ModelSourceSeason', map:'ModelSourceSeason', type: 'text', displayLabel: 'ARTICLES.FIELDS.SEASON_MODEL_CARRIED_OVER_FROM', visible: true, creatable: false, editable: false, inputType: 'text',
				validation: {isRequired: false, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
			{ field: 'ArticleSourceSeason', map:'ArticleSourceSeason', type: 'text', displayLabel: 'ARTICLES.FIELDS.SEASON_ARTICLE_CARRIED_OVER_FROM', visible: true, creatable: false, editable: false, inputType: 'text',
				validation: {isRequired: false, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
			{ field: 'ActivationDate', map:'ActivationDate', type: 'text', displayLabel: 'ARTICLES.FIELDS.REACTIVATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
				validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
			{ field: 'DropDate', map:'DropDate', type: 'text', displayLabel: 'ARTICLES.FIELDS.DROP_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
				validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
			{ field: 'ModelCreatedDate', map:'ModelCreatedDate', type: 'text', displayLabel: 'ARTICLES.FIELDS.MODEL_CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
				validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
			{ field: 'ModelDropDate', map:'ModelDropDate', type: 'text', displayLabel: 'ARTICLES.FIELDS.MODEL_DROP_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
				validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
			{ field: 'ModelActivationDate', map:'ModelActivationDate', type: 'text', displayLabel: 'ARTICLES.FIELDS.MODEL_REACTIVATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
				validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
			{ field: 'SourceRequestId', map:'SourceRequestId', type: 'text', displayLabel: 'ARTICLES.FIELDS.SOURCE_REQUEST_ID', visible: true, creatable: false, editable: false, inputType: 'text',
				validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
			{ field: 'SourceRequestNumber', map:'SourceRequestNumber', type: 'text', displayLabel: 'ARTICLES.FIELDS.SOURCE_REQUEST_NUMBER', visible: true, creatable: false, editable: false, inputType: 'text',
				validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
			{ field: 'ColoredUpBy',  map:'ColoredUpBy', type: 'text', displayLabel: 'ARTICLES.FIELDS.COLORED_UP_BY', visible: true, creatable: false, editable: false, inputType: 'text',
				validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
			{ field: 'ColoredUpDate',  map:'ColoredUpDate', type: 'text', displayLabel: 'ARTICLES.FIELDS.COLORED_UP_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
				validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				// isfilterCriteria is used to filter colors based on the criteria, adding color at the end to validate the color criteria.
			{ field: 'ColorId', map:'ColorId', type: 'int', displayLabel: 'ARTICLES.FIELDS.PRIMARY_COLOR_NAME', visible: false, creatable: false, editable: false, inputType: 'lookup', lookupSource: 'lists.sellerColorsFromColorPalette', isfilterCriteria: true,
				showReadOnlyTextWhenValueAssigned: {field: 'ColorName'}, // this is to show the ColorName instead of ColorId dropdown when primary color exists.
				lookupFilter: {'Status': 1}, validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
			{ field: 'StateId',  map:'StateId', type: 'text', displayLabel: 'ARTICLES.FIELDS.STATE_NAME', visible: false, creatable: false, editable: false, inputType: 'lookup', lookupSource:'catalogs.articleStates',
				// sort by uses orderBy(sourceArray, predicate, reverse) method
				lookupFilter: {'Status': 1}, sortBy: {'StateRank': false},validation: {isRequired: true, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
			{ field: 'StateId',  map:'StateId', type: 'text', displayLabel: 'ARTICLES.FIELDS.STATE_ID', visible: true, creatable: false, editable: false, inputType: 'text',
				validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
			{ field: 'StateName',  map:'StateName', type: 'text', displayLabel: 'ARTICLES.FIELDS.STATE_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
				validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
		],
		uniqueConstraints: [
			{name: 'Constraint 1', fields: ['ArticleNumber']}
		],
		validateStateEditableFields: true,
		title: 'ARTICLES.NAV',
		icon: 'icon-cube-outline',
		idField: 'Id',
		lookupDisplayField: 'ArticleNumber',
		isDirty: false,
		isBulkActionCompleted: false,
		isCatalogSpecificModel: true,
		// imagesLimit: 25, not required anymore
		methods: {
			getList                             :   getArticles,
			getDetails                          :   getArticle,
			activateBulk                        :   activateArticles,
			updateLockStatus                    :   updateLockStatus,
			create                              :   createArticle,
			update                              :   updateArticle,
			getAvailableArticles                :   getAvailableArticles,
			createBulk                          :   createBulk,
			updateBulk                          :   updateBulk,
			assignArticles                      :   assignArticles,
			unAssignArticles                    :   unAssignArticles,
			swapArticle                         :   swapArticle,
			getArticlesWithSameSizes            :   getArticlesWithSameSizes,
			updateViaImport                     :   updateViaImport,
			updateViaImportModel                :   updateViaImportModel,
			editModelAttributes                 :   editModelAttributes,
			assignArticlesToMasterCatalog       :   assignArticlesToMasterCatalog,
			assignArtcleStates                  :   assignArtcleStates,
			createBulkByLicensee                :   createBulkByLicensee,
			setSizeScaleByLicenceeModelNumberBulk:  setSizeScaleByLicenceeModelNumberBulk,
			setPricesByLicenseeModelNumberBulk  :   setPricesByLicenseeModelNumberBulk,
			overwriteColor                      :   overwriteColor,
			overwriteColorBulk                  :   overwriteColorBulk
		},
		views: {
			mainList: {
				/**
				 * if any issue happening in staging,production etc related to column chooser, list of columns do check
				 * in the app.config.json of that environment as articles model is injected through it.
				 */
				columns         : [ 'ArticleNumber', 'ModelNumber', 'ArticleName', 'Status', 'UpdatedDate' ], // sort order and Id field is removed from default column list as UA dont want sortorder and Id in their list
				columnFilter    : {},
				imagesSize      : 'large',
				toggleFilterProps: { toggleStatus:false, filterProp:'Status', trueVal:1, trueValTooltipMessage: 'ACTIONS.TOGGLE_ACTIVE', falseVal:'', falseValTooltipMessage:"ACTIONS.TOGGLE_ALL"},
				topIndex        : 0,
				showFilterRow   : false,
				sortColumn      : {'UpdatedDate': false},
				sortDescending  : true,
				itemActions     : [
					{ id: 'view', label: 'ACTIONS.VIEW', icon: 'icon-magnify', privilege: 'GetCatalogArticleDetails', disabled: '!itm.Status', visible: true },
					{ id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UpdateCatalogArticleDetails:true', disabled: false, visible: true },
					{ id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateArticleStatusBulk:true', disabled: false, visible: 'itm.Status',
							requiresConfirmation: false, confirmationContent: {title: 'ARTICLES.TITLES.DELETE_ALERT', message: 'ARTICLES.MESSAGES.CONFIRM_DROP'},
								confirmationAction: 'ACTIONS.DELETE'},
					{ id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateArticleStatusBulk:true', disabled: false, visible: '!itm.Status',
							requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'},
					{ id: 'unAssign', label: 'ARTICLES.ACTIONS.UNASSIGN_ARTICLE', icon: 'icon-minus', privilege: 'UpdateArticleStatusBulk:true', disabled: false, visible: false,
							requiresConfirmation: false, confirmationContent: {title: 'ARTICLES.TITLES.UN_ASSIGN_SUGGEST_REPLACEMENT', message: 'ARTICLES.MESSAGES.CONFIRM_DROP'}, confirmationAction: 'ACTIONS.UN_ASSIGN'},
					{ id: 'assign', label: 'ARTICLES.ACTIONS.ASSIGN_ARTICLE', icon: 'icon-plus', privilege: 'UpdateCatalogBulkArticle:true', disabled: false, visible: false,
							requiresConfirmation: false, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'ARTICLES.MESSAGES.CONFIRM_ASSIGN'}, confirmationAction: 'ACTIONS.ASSIGN'},
					{ id: 'lock', label: 'ARTICLES.ACTIONS.LOCK_PRICES', icon: 'icon-lock', privilege: 'LockArticles:true', disabled: 'itm.isArticleLockingDisable', visible: true,
							requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'ARTICLES.MESSAGES.CONFIRM_LOCK_PRICES'}, confirmationAction: 'ARTICLES.ACTIONS.LOCK_PRICES'},
					{ id: 'unlock', label: 'ARTICLES.ACTIONS.UNLOCK_PRICES', icon: 'icon-lock-unlocked', privilege: 'UnLockArticles:true', disabled: '!itm.Locked || !itm.Status', visible: true,
							requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'ARTICLES.MESSAGES.CONFIRM_UNLOCK_PRICES'}, confirmationAction: 'ARTICLES.ACTIONS.UNLOCK_PRICES'},
					{ id: 'editReplacement', label: 'ARTICLES.ACTIONS.UPDATE_REPLACEMENT', icon: 'icon-tile-four', privilege: 'UpdateArticleReplacement:true', disabled: false, visible: true },
					// assigns through the partial update API, which is guarded by UpdateCatalogArticleSegmentations (4074)
					{ id: 'addSegmentation', label: 'ARTICLES.ACTIONS.CREATE_SEGMENTATION', icon: 'icon-cube-unfolded', privilege: 'UpdateCatalogArticleSegmentations:true', disabled: '!itm.Status', visible: true },
					{ id: 'AddPrice', label: 'ARTICLES.ACTIONS.CREATE_PRICE', icon: 'icon-coin', privilege: 'CreateCatalogArticlePrice:true', disabled: 'itm.isPriceUpdateLocked || !itm.Status', visible: true },
					{ id: 'manageArticleStates', label: 'ARTICLES.ACTIONS.MANAGE_STATE', icon: 'icon-compare', privilege: 'AssignArticleStateToArticles:true', disabled: false, visible: true },
					{ id: 'overwriteColor', label: 'ARTICLES.ACTIONS.OVERWRITE_ARTICLE_CODE', icon: 'icon-pencil', privilege: 'AssignArticleColors:true', disabled: false, visible: 'itm.isOverwriteColorDisable' }
				],
				listActions     : [
					{ id: 'delete', label: 'ACTIONS.DELETE_BULK', icon: 'icon-delete', privilege: 'UpdateArticleStatusBulk:true', disabled: '{selected: true, Status: 1}', visible: true,
						requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
					{ id: 'activate', label: 'ACTIONS.ACTIVATE_BULK', icon: 'icon-undo-variant', privilege: 'UpdateArticleStatusBulk:true', disabled: '{selected: true, Status: 0}', visible: true,
						requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'},
					{ id: 'unAssign', label: 'ARTICLES.ACTIONS.UNASSIGN_ARTICLES_BULK', icon: 'icon-minus', privilege: 'UpdateArticleStatusBulk:true', disabled: '{selected: true, Status: 1}', visible: false,
						requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'ARTICLES.MESSAGES.CONFIRM_UNASSIGN'}, confirmationAction: 'ACTIONS.UN_ASSIGN'},
					{ id: 'assign', label: 'ARTICLES.ACTIONS.ASSIGN_ARTICLES_BULK', icon: 'icon-plus', privilege: 'UpdateCatalogBulkArticle:true', disabled: '{selected: true, Status: ["!1"], PS: 1}', visible: false,
						requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'ARTICLES.MESSAGES.CONFIRM_ASSIGN'}, confirmationAction: 'ACTIONS.ASSIGN'},
					{ id: 'lock', label: 'ARTICLES.ACTIONS.LOCK_PRICES', icon: 'icon-lock', privilege: 'LockArticles:true', disabled: '{selected: true, isArticleLockingDisable: 0}', visible: true,
						requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'ARTICLES.MESSAGES.CONFIRM_LOCK_PRICES'}, confirmationAction: 'ARTICLES.ACTIONS.LOCK_PRICES'},
					{ id: 'unlock', label: 'ARTICLES.ACTIONS.UNLOCK_PRICES', icon: 'icon-lock-unlocked', privilege: 'UnLockArticles:true', disabled: '{selected: true, Locked: 1, Status: 1}', visible: true,
						requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'ARTICLES.MESSAGES.CONFIRM_UNLOCK_PRICES'}, confirmationAction: 'ARTICLES.ACTIONS.UNLOCK_PRICES'},
					{ id: 'updateBulk', label: 'ACTIONS.UPDATE_BULK', icon: 'icon-pencil', privilege: 'UpdateCatalogBulkArticle:true', disabled: '{selected: true}', visible: true, requiresConfirmation: false },
					{ id: 'updateViaImport', label: 'ACTIONS.UPDATE_VIA_IMPORT', icon: 'icon-pencil-box-outline', privilege: 'UpdateOnlyCatalogBulkArticle:true', disabled: true, visible: true, requiresConfirmation: false},
					{ id: 'import', label: 'ACTIONS.IMPORT', icon: 'icon-import', privilege: 'UI_ImportArticles:true', disabled: false, visible: true, requiresConfirmation: false},
					{ id: 'setSegmentations', label: 'ARTICLES.ACTIONS.SET_SEGMENTATIONS', icon: 'icon-cube-unfolded', privilege: 'UpdateCatalogBulkArticlesSegmentations:true', disabled: '{selected: true, Status: 1}', visible: true, requiresConfirmation: false},
					{ id: 'updateViaImportModel', label: 'ARTICLES.ACTIONS.UPDATE_VIA_IMPORT_MODEL', icon: 'icon-import', privilege: 'UpdateBulkAttributesByModelNumbers:true', disabled: false, visible: true, requiresConfirmation: false},
					{ id: 'editModelAttributes', label: 'ARTICLES.ACTIONS.EDIT_MODEL_ATTRIBUTES', icon: 'icon-android-studio', privilege: 'UpdateBulkAttributesByModelNumbers:true', disabled: '{selected: true}', visible: true, requiresConfirmation: false},
					{ id: 'manageArticleStates', label: 'ARTICLES.ACTIONS.MANAGE_STATES_BULK', icon: 'icon-compare', privilege: 'AssignArticleStateToArticles:true', disabled: '{selected: true}', visible: true, requiresConfirmation: false },
					{ id: 'importByLicensee', label: 'ARTICLES.ACTIONS.IMPORT_BY_LICENSEE', icon: 'icon-import', privilege: 'ImportArticlesByLicenseeInfo:true', disabled: false, visible: true, requiresConfirmation: false},
					{ id: 'setSizesByLicenseeModelNumber', label: 'ARTICLES.ACTIONS.SET_SIZES_BY_LICENCEE_MODEL_NUMBER', icon: 'icon-layers', privilege: 'UpdateSizeScaleByLicensee:true', disabled: false, visible: true, requiresConfirmation: false},
					{ id: 'setPricesByLicenseeModelNumber', label: 'ARTICLES.ACTIONS.SET_PRICES_BY_LICENSEE_MODEL_NUMBER', icon: 'icon-import', privilege: 'UpdatePricesByLicensee:true', disabled: false, visible: false, requiresConfirmation: false},
					{ id: 'overwriteColorBulk', label: 'ARTICLES.ACTIONS.OVERWRITE_ARTICLE_CODE_BULK', icon: 'icon-import', privilege: 'BulkAssignArticleColors:true', disabled: false, visible: true, requiresConfirmation: false},
					{ id: 'generateReport', label: 'ARTICLES.ACTIONS.REPORT_SLIDER', icon: 'icon-chart-bar', privilege: 'GetTargetsReport:true', disabled: 'false', visible: true}
				],
				fabAction       :
					{id: 'add', label: 'ACTIONS.ADD', icon: 'icon-menu', privilege: 'CreateCatalogArticle:true', visible: true}
			},
			mainDetails: {
				selectedTabIndex   : 0,
				itemActions        : [
					{ id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateArticleStatusBulk:true', disabled: '{selected: true, Status: 1}',
						visible: true, requiresConfirmation: false, confirmationContent: {title: 'ARTICLES.TITLES.DELETE_ALERT', message: 'ARTICLES.MESSAGES.CONFIRM_DROP'},
						confirmationAction: 'ACTIONS.DELETE'},
					{ id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateArticleStatusBulk:true', disabled: '{selected: true, Status: 0}',
						visible: true, requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'},
					{ id: 'unAssign', label: 'ARTICLES.ACTIONS.UNASSIGN_ARTICLES_BULK', icon: 'icon-minus', privilege: 'UpdateArticleStatusBulk:true', disabled: '{selected: true, Status: 1}',
						visible: false, requiresConfirmation: false, confirmationContent: {title: 'ARTICLES.TITLES.UN_ASSIGN_SUGGEST_REPLACEMENT', message: 'ARTICLES.MESSAGES.CONFIRM_DROP'}, confirmationAction: 'ACTIONS.UN_ASSIGN'},
					{ id: 'assign', label: 'ARTICLES.ACTIONS.ASSIGN_ARTICLES_BULK', icon: 'icon-plus', privilege: 'UpdateArticleStatusBulk:true', disabled: '{selected: true, Status: ["!1"], PS: 1}',
						visible: false, requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'ARTICLES.MESSAGES.CONFIRM_ASSIGN'}, confirmationAction: 'ACTIONS.ASSIGN'},
					{ id: 'manageArticleStates', label: 'ARTICLES.ACTIONS.MANAGE_STATE', icon: 'icon-compare', privilege: 'AssignArticleStateToArticles:true', disabled: false, visible: true }
				],
				// fabAction           : {id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UpdateCatalogArticleDetails:true', visible: true}
				//PROXY FAB FOR DETAIL PAGE
				fab                 : {id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UpdateCatalogArticleDetails:true', visible: true}

			},
			privileges: {
				list    : 'GetCatalogArticleList',
				details : 'GetCatalogArticleDetails'
			}
		}
	};

	function getArticles(generalProperties, model, catalogCode, dataSourceTypeId) {
			if(angular.isUndefined(dataSourceTypeId)) {
				dataSourceTypeId = catalogFactory.getActiveCatalog().DataSourceTypeId
			}
			if (angular.isDefined(model)) { // to skip this part for load lookup
				model.isBulkActionCompleted = false;
			}
			var promise;
			catalogCode = angular.isUndefined(catalogCode) ? catalogFactory.getActiveCatalog().CatalogCode : catalogCode;
			var url = api.baseUrl + '/catalogs/' + catalogCode + '/articles';
			//call assortableArticles only when it is an inherited catalog, user have access and catalog and user belongs to same account
			if (dataSourceTypeId === 3 && SecurityFactory.isAuthorized({accessPrivileges: CONSTANTS.PRIVILEGES.ARTICLES.LIST.ASSORTABLE_ARTICLES}) && (catalogFactory.getActiveCatalog().AccountId === $localStorage.account.accountId || $localStorage.account.accountType == 1)) {
				url = api.baseUrl + '/catalogs/' + catalogCode + '/assortableArticles';
			}
			var state = {};
			state.name = $state.current.name;
			state.params = $state.params;
			var isBulk = true;
			var logData = activityLogger.createLogData(null, state, 'catalogs.articles', 'VIEW', isBulk, new Date(), null, null);
			promise = api.webGet(url,
				generalProperties.config || {}, true, generalProperties.forceFetch,
				generalProperties.supportIncrementalResult || true,
				generalProperties.modelIdField || api.catalogs.articles.idField,
				generalProperties.isMajor || false, model || api.catalogs.articles, generalProperties.isArticleRelatedData || false, undefined, undefined, undefined);
			promise = activityLogger.log(logData, promise);

			return promise.then(function (response) {
				if (api.catalogs.articles.isDirty) {
					//Invalidate lookupData
					api.catalogs.articles.lookupData = undefined;
					api.catalogs.articles.isDirty = false;
				}
				api.setCurrentCatalogArticleList(response.data)
				//if prices and segmentations not present in articles list call prices and segmentations api else return articles response
				if(generalProperties.hasOwnProperty('articlesPricesModel') && generalProperties.hasOwnProperty('articlesSegmentationsModel') &&
					generalProperties.hasOwnProperty('isLinePlan') && generalProperties.isLinePlan !== 1 && response.data.length) {
					//Check if article reesponse contain Prices
					if(!response.data[0].hasOwnProperty('Prices') || generalProperties.articlesPricesModel.isDirty ||
					(angular.isDefined(generalProperties.articlesPricesModel.baseModel) && generalProperties.articlesPricesModel.baseModel.isDirty)) {
						var pricesGeneralProperties = {
							forceFetch: true,
							isLogRequired: false,
							config: {},
							modelIdField: 'Id',// it should be outerObject Id
							isMajor: false,
							isArticleRelatedData: true,
							nestedArrayName: 'Prices',
							nestedDataIdField: 'Id',//it should be nestedObject Id
							supportIncrementalResult: true
						}
						var pricesPromise = generalProperties.articlesPricesModel.methods.getList(pricesGeneralProperties, generalProperties.articlesPricesModel, catalogCode);
					}
					//Check if article reesponse contain Segmentations
					if(!response.data[0].hasOwnProperty('Segmentations') || generalProperties.articlesSegmentationsModel.isDirty ||
					(angular.isDefined(generalProperties.articlesSegmentationsModel.baseModel) && generalProperties.articlesSegmentationsModel.baseModel.isDirty)) {
						var segmentationsGeneralProperties = {
							forceFetch: true,
							isLogRequired: false,
							config: {},
							modelIdField: 'Id',// it should be outerObject Id
							isMajor: false,
							isArticleRelatedData: true,
							nestedArrayName: 'Segmentations',
							nestedDataIdField: 'Id',//it should be nestedObject Id
							supportIncrementalResult: true
						}
						var segmentationsPromise = generalProperties.articlesSegmentationsModel.methods.getList(segmentationsGeneralProperties, generalProperties.articlesSegmentationsModel, catalogCode);
					}
					return $q.all([pricesPromise, segmentationsPromise])
					.then(function() {
						return response;
					})
				} else {
					return response;
				}
			});
		}

		function getArticle(isLogRequired, articleId, catalogCode) {
			var promise;
			if(angular.isDefined(isLogRequired) && isLogRequired === true) {
				var state = {};
				state.name = $state.current.name;
				state.params = $state.params;
				var isBulk = false;
				var items = [];
				promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/articles/' + articleId + '?status=0');
				promise.then(function(response) {
					items.push(response.data[api.catalogs.articles.lookupDisplayField]);
				});
				var logData = activityLogger.createLogData(items, state, 'catalogs.articles', 'VIEW', isBulk, new Date(), null, null);
				promise = activityLogger.log(logData, promise);
			}
			else {
				promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/articles/' + articleId + '?status=0');
			}
			return promise;
		}

		//using for lookup incase of inherited catalog
		function getAvailableArticles(forceFetch, isLogRequired, catalogCode) {
			catalogCode = angular.isUndefined(catalogCode) ?  catalogFactory.getActiveCatalog().CatalogCode : catalogCode;
			if(SecurityFactory.isAuthorized({accessPrivileges: CONSTANTS.PRIVILEGES.VETTING_LIST.GET_PARENT_CATALOG_ARTICLE_LIST})) {
				return api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/availableArticles');
			} else {
				var privilege = {
					id: 257,
					description: 'Catalog Articles - Available Articles - Get List'
				};
				errorDialog.show('ERRORS.NO_PRIVILEGES', undefined, privilege);
			}
		}

		function activateArticles(records, model, actionType, parentId, articleDropReason) {
			var result = crud.createRequestObject(records, model, actionType);
			var dropReason = '';
			if(angular.isDefined(articleDropReason) && angular.isDefined(articleDropReason.DropReason)) {
				// add article drop reason to request
				var replacementsMap = {};
				if(angular.isDefined(articleDropReason.replacements) && angular.isArray(articleDropReason.replacements)) {
					angular.forEach(articleDropReason.replacements, function(r) {
						replacementsMap[r.ArticleId] = r.ReplacementArticleId;
					});
				}
				angular.forEach(result.requestObj, function(article) {
					article['DropReasonId'] = articleDropReason.DropReason;
					if(articleDropReason.DropComment) {
						article['DropComment'] = articleDropReason.DropComment;
					}
					// ReplacementArticleId from confirm-drop dialog (single article)
					if(articleDropReason.ReplacementArticleId) {
						article['ReplacementArticleId'] = articleDropReason.ReplacementArticleId;
					}
					// Per-article replacements from select-drop-reason dialog (bulk)
					// requestObj uses model.idField ('Id'), replacementsMap keyed by ArticleId/Id
					else if(replacementsMap[article[model.idField]]) {
						article['ReplacementArticleId'] = replacementsMap[article[model.idField]];
					}
				});
				dropReason = articleDropReason.Reason;
			}
			var state = {};
			state.name = $state.current.name;
			state.params = $state.params;
			var isBulk = result.itemsNameList.length > 1 ? true : false;
			var logData = activityLogger.createLogData(result.itemsNameList, state, 'catalogs.articles', actionType.toUpperCase(), isBulk, new Date(), null, null);
			var promise = api.webPut(api.baseUrl + '/catalogs/' + parentId + '/articles/status', result.requestObj);

			promise.then(function() {
				api.catalogs.models.isDirty = true;
				crud.onRecordStatusChange(records, api.catalogs.articles, actionType, undefined, undefined, dropReason);// it should be base model for dynamic models since base model isDirty is being change in all actions
			});

			return activityLogger.log(logData, promise);
		}

		function updateLockStatus(records, model, actionType, parentId) {
			var result = crud.createRequestObject(records, model, actionType);
			var state = {};
			state.name = $state.current.name;
			state.params = $state.params;
			var isBulk = result.itemsNameList.length > 1 ? true : false;
			var logData = activityLogger.createLogData(result.itemsNameList, state, 'catalogs.articles', actionType.toUpperCase(), isBulk, new Date(), null, null);
			var promise;
			if(actionType.toUpperCase() === 'LOCK') {
				promise = api.webPut(api.baseUrl + '/catalogs/' + parentId + '/articles/lock', result.requestObj);
			}
			else {
				promise = api.webPut(api.baseUrl + '/catalogs/' + parentId + '/articles/unlock', result.requestObj);
			}


			promise.then(function() {
				crud.onRecordStatusChange(records, api.catalogs.articles, actionType);// it should be base model for dynamic models since base model isDirty is being change in all actions
				api.catalogs.prices.isDirty = true;
				api.catalogs.pricesLinear.isDirty = true;
			});

			return activityLogger.log(logData, promise);
		}

		function createArticle(article, catalogCode, model) {
			var activeCatalog = catalogFactory.getActiveCatalog();
			var requestObject = article;
			var isRestrictedRetailWindowOnRole = (angular.isDefined(api.roleBasedRestrictions.restrictedRetailWindow) && !utility.isObjectEmpty(api.roleBasedRestrictions.restrictedRetailWindow)) ? true : false;

			angular.forEach(model.fields, function(item) {
				// remove non required model level attributes
				if(item.isModelLevelAttribute && !item.validation.isRequired) {
					delete requestObject[item.field];
				}
			});
			// remove shipmentWindowRangeId if its null
			if(angular.isDefined(requestObject['ShipmentWindowRangeId']) && requestObject['ShipmentWindowRangeId'] == null) {
				delete requestObject['ShipmentWindowRangeId'];
				delete requestObject['IsShippingWindowUpdatable'];
			} else if(requestObject['ShipmentWindowRangeId'] != null) {
				// Send IsShippingWindowUpdatable as 1 when "DummyArticleApplyRetailWindow" privilege is assigned and IsShippingWindowApply is 1
				// if retail window is restricted on role send IsShippingWindowUpdatable as 0
				if(SecurityFactory.isAuthorized({accessPrivileges: CONSTANTS.PRIVILEGES.ARTICLES.UPDATE_ARTICLE_SHIPMENT_WINDOW}) && activeCatalog.IsShippingWindowApply === 1 && !isRestrictedRetailWindowOnRole) {
					requestObject.IsShippingWindowUpdatable = 1;
				} else {
					requestObject.IsShippingWindowUpdatable = 0;
				}
			}

			// if automatic numbering is enabled remove ArticleNumber as it is generated from API
			if(catalogFactory.getAutomaticNumbering()) {
				delete requestObject['ArticleNumber'];
			}

			var state = {};
			state.name = $state.current.name;
			state.params = $state.params;
			var logData = activityLogger.createLogData(article[api.catalogs.articles.lookupDisplayField], state, 'catalogs.articles', 'ADD', false, new Date(), null, null);
			var promise = api.webPost(api.baseUrl + '/catalogs/' + catalogCode + '/article', requestObject);
			promise.then(function() {
				api.catalogs.articles.isDirty = true;
				api.catalogs.prices.isDirty = true;
				api.catalogArticles.segmentation.isDirty = true;
				api.catalogs.crds.isDirty = true;
				api.catalogs.stock.isDirty = true;
				api.catalogArticles.segmentationLinear.isDirty = true;
				api.catalogs.crdsLinear.isDirty = true;
				api.catalogs.stockLinear.isDirty = true;
				api.catalogs.pricesLinear.isDirty = true;
				api.catalogs.models.isDirty = true;
				api.lists.catalogModelList.isDirty = true;
				api.sellerModels.sellerModels.isDirty = true;
			});
			return activityLogger.log(logData, promise);
		}

		function updateArticle(articleId, article, catalogCode, model, oldArticleCopy, isUpdateModelAtributes) {
			var activeCatalog = catalogFactory.getActiveCatalog();
			var articleCopy = angular.copy(article);
			var isRestrictedRetailWindowOnRole = (angular.isDefined(api.roleBasedRestrictions.restrictedRetailWindow) && !utility.isObjectEmpty(api.roleBasedRestrictions.restrictedRetailWindow)) ? true : false;
			// check the special privilege is assigned to the user for updating the state. if then does not vaidate editable fields
			var isSpecialPermissionToIgnoreArticleStateIsAssigned = SecurityFactory.isAuthorized({accessPrivileges: CONSTANTS.PRIVILEGES.ARTICLES.SPECIAL_PRIVILEGE_TO_SKIP_STATE_VALIDATION});

			// remove non edited fields
			// TODO: This needs to be implemented generic
			// Due to time crunch adding specific conditions
			if(!isUpdateModelAtributes) {
				angular.forEach(model.fields, function(field) {
					if(field.field !== 'ModelNumber' && field.field !== 'ArticleName' && field.field !== 'ArticleNumber' && (field.isCatalogProperty || !oldArticleCopy.hasOwnProperty(field.field) || (article[field.field] == null && oldArticleCopy[field.field] == null) || article[field.field] === oldArticleCopy[field.field] || ((field.inputType === 'tags' || field.inputType === 'multi-value') && isArraysAreEqual(article[field.field], oldArticleCopy[field.field])))) {
						delete article[field.field];
					}
				});
			}

			// remove restricted attributes from list
			var roleBasedRestrictedAttributes = (angular.isDefined(api.roleBasedRestrictions) && angular.isDefined(api.roleBasedRestrictions.restrictedAttributesArray) && api.roleBasedRestrictions.restrictedAttributesArray.length > 0) ? api.roleBasedRestrictions.restrictedAttributesArray : [];
			if(roleBasedRestrictedAttributes.length > 0) {
				angular.forEach(roleBasedRestrictedAttributes, function(attribute) {
					if(attribute.notEditable) {
						delete article[attribute.Name];
					}
				});
			}

			// remove state level non editable attributes from request
			if(!isSpecialPermissionToIgnoreArticleStateIsAssigned && article.StateId != null) {
					var assignedState = utility.filterObject(api.articleStatesList, {StateId: article.StateId}, true)[0];
					if(assignedState && assignedState.NonEditableAttributes.length) {
							angular.forEach(assignedState.NonEditableAttributes, function(attribute) {
								delete article[attribute.AttributeSystemName];
							});
					}
			}

			// send inactive article status as 0 for inherited catalogs
			if(activeCatalog.DataSourceTypeId === 3 && angular.isDefined(article.Status)) {
				article.Status = article.Status === 1 ? 1 : 0;
			}

			// remove shipmentWindowRangeId if its null
			if(angular.isDefined(article['ShipmentWindowRangeId']) && article['ShipmentWindowRangeId'] === oldArticleCopy['RetailExitMonthId']) {
				delete article['ShipmentWindowRangeId'];
			} else if(article['ShipmentWindowRangeId'] != null) {
				// Send IsShippingWindowUpdatable as 1 when "DummyArticleApplyRetailWindow" privilege is assigned and IsShippingWindowApply is 1
				// if retail window is restricted on role send IsShippingWindowUpdatable as 0
				if(SecurityFactory.isAuthorized({accessPrivileges: CONSTANTS.PRIVILEGES.ARTICLES.UPDATE_ARTICLE_SHIPMENT_WINDOW}) && activeCatalog.IsShippingWindowApply === 1 && !isRestrictedRetailWindowOnRole && articleCopy.AllowRetailWindowUpdate && article.ShipmentWindowRangeId != null) {
					article.IsShippingWindowUpdatable = 1;
				} else {
					article.IsShippingWindowUpdatable = 0;
				}
			}
			// remove LastUpdatedOn
			delete article['LastUpdatedOn'];

			var state = {};
			state.name = $state.current.name;
			state.params = $state.params;
			var logData = activityLogger.createLogData(article[api.catalogs.articles.lookupDisplayField], state, 'catalogs.articles', 'EDIT', false, new Date(), null, null);
			var url = api.baseUrl + '/catalogs/' + catalogCode + '/articles/' + articleId;
			if (isUpdateModelAtributes) {
				url = url + '?updateModelLevelAttributes=true';
			}

			var promise = api.webPut(url, article);

			promise.then(function() {
				api.catalogs.articles.isDirty = true;
				api.catalogs.models.isDirty = true;
				api.lists.catalogModelList.isDirty = true;
				api.sellerModels.sellerModels.isDirty = true;
			});
			return activityLogger.log(logData, promise);
		}

		function isArraysAreEqual(arr1, arr2) {
			if (arr1 && arr2 && arr1.length !== arr2.length) {
					return false;
			}
			for (var i = 0; i < arr1.length; i++) {
					if (arr1[i] !== arr2[i]) {
							return false;
					}
			}
			return true;
		}

		function createBulk(model, data, catalogCode) {
			var activeCatalog = catalogFactory.getActiveCatalog();
			// make prices, segmentations, crds and stocks model dirty when creating new articles to get updated data in all these modules.
			var pricesModel	= api.catalogs.prices;
			var segmentationModel = api.catalogArticles.segmentation;
			var crdsModel = api.catalogs.crds;
			var stocksModel = api.catalogs.stock;
			var pricesLinearModel	= api.catalogs.pricesLinear;
			var segmentationLinearModel = api.catalogArticles.segmentationLinear;
			var crdsLinearModel = api.catalogs.crdsLinear;
			var stocksLinearModel = api.catalogs.stockLinear;
			var isApplyRetailWindowPrivilegeIsAssigned = SecurityFactory.isAuthorized({accessPrivileges: CONSTANTS.PRIVILEGES.ARTICLES.UPDATE_ARTICLE_SHIPMENT_WINDOW});
			var isRestrictedRetailWindowOnRole = (angular.isDefined(api.roleBasedRestrictions.restrictedRetailWindow) && !utility.isObjectEmpty(api.roleBasedRestrictions.restrictedRetailWindow)) ? true : false;
			angular.forEach(data, function(article) {
				// Send IsShippingWindowUpdatable as 1 when "DummyArticleApplyRetailWindow" privilege is assigned and IsShippingWindowApply is 1
				// if retail window is restricted on role send IsShippingWindowUpdatable as 0
				var isUpdatable = isApplyRetailWindowPrivilegeIsAssigned && catalogFactory.getActiveCatalog().IsShippingWindowApply === 1 && !isRestrictedRetailWindowOnRole;
				article.IsShippingWindowUpdatable = isUpdatable ? 1 : 0;
				if(article.RetailExitMonthId != null && article.RetailExitMonthId !== '') {
					article['ShipmentWindowRangeId'] = article.RetailExitMonthId;
				}
				// if ArticleId or ModelId is empty then remove it
				if(article.ArticleNumber === '') {
					delete article['ArticleNumber'];
				}
				if(article.ModelNumber === '') {
					delete article['ModelNumber'];
				}
				// remove parent model number field. if type is parent we should not send this field to API
				if(angular.isDefined(article.parent_model_type) && article.parent_model_type.toString().toLowerCase() === 'parent') {
					delete article['ParentModelNumber']
				}
			});
			var modelArray = [pricesModel, segmentationModel, crdsModel, stocksModel, segmentationLinearModel, crdsLinearModel, stocksLinearModel, pricesLinearModel];
			// sending all the affected models as an array to secondary model
			var jobIndex = jobsTracker.addJob(model, 'ARTICLES.ACTIONS.IMPORT_ARTICLES', 1, modelArray);

			// article numbers are supplied in the import file when custom numbering is enabled on seller level
			var customNumbersParam = catalogFactory.getCustomNumbering() ? '&customNumbers=true' : '';

			api.webPut(api.baseUrl + '/catalogs/' + catalogCode + '/articles?sourceapplication=' + CONSTANTS.SOURCE_APPLICATION + '&sourceaction=Import Articles' + customNumbersParam, data).then(function(response) {
				api.sellerModels.sellerModels.isDirty = true;
				jobsTracker.trackJob(jobIndex, response.data.Id);
			}).catch(function(error) {
				jobsTracker.setCriticlaFail(jobIndex, error);
			});
		}

		function updateBulk(model, records, updateRecord, idMap) {
			var activeCatalog = catalogFactory.getActiveCatalog();
			var requestBody = [];
			angular.forEach(records, function (record) {
					var requestObject = {ArticleNumber: record.ArticleNumber}
					var hasUpdates = false;
					for (var prop in updateRecord) {
						if(record[prop] !== updateRecord[prop]) {
							requestObject[prop] = updateRecord[prop];
							hasUpdates = true;
						}
					}
					// send inactive article status as 0 for inherited catalogs
					if(activeCatalog.DataSourceTypeId === 3 && hasUpdates) {
						requestObject.Status = record.Status === 1 ? 1 : 0;
					}

					// Only add the requestObject if there are updates
					if (hasUpdates) {
						requestBody.push(requestObject);
					}
			});

			if (requestBody.length) {
				var jobIndex = jobsTracker.addJob(model, 'ARTICLES.ACTIONS.UPDATE_ARTICLES', 1);
				api.webPut(api.baseUrl + '/catalogs/' + idMap.catalogId + '/updatearticles?sourceapplication=' + CONSTANTS.SOURCE_APPLICATION + '&sourceaction=Update Bulk Articles', requestBody).then(function (response) {
					jobsTracker.trackJob(jobIndex, response.data.Id);
				}).catch(function (error) {
					jobsTracker.setCriticlaFail(jobIndex, error);
				});
			}
		}

		function updateViaImport(model, data, activeCatalog) {
			var isApplyRetailWindowPrivilegeIsAssigned = SecurityFactory.isAuthorized({accessPrivileges: CONSTANTS.PRIVILEGES.ARTICLES.UPDATE_ARTICLE_SHIPMENT_WINDOW});
			var isRestrictedRetailWindowOnRole = (angular.isDefined(api.roleBasedRestrictions.restrictedRetailWindow) && !utility.isObjectEmpty(api.roleBasedRestrictions.restrictedRetailWindow)) ? true : false;
			angular.forEach(data, function(article) {
				// Send IsShippingWindowUpdatable as 1 when "DummyArticleApplyRetailWindow" privilege is assigned and IsShippingWindowApply is 1
				// if retail window is restricted on role send IsShippingWindowUpdatable as 0
				var isUpdatable = isApplyRetailWindowPrivilegeIsAssigned && catalogFactory.getActiveCatalog().IsShippingWindowApply === 1 && !isRestrictedRetailWindowOnRole;
				article.IsShippingWindowUpdatable = isUpdatable ? 1 : 0;
				if(article.RetailExitMonthId != null && article.RetailExitMonthId !== '') {
					article['ShipmentWindowRangeId'] = article.RetailExitMonthId;
				}

				// remove parent model number field. if type is parent we should not send this field to API
				if(angular.isDefined(article.parent_model_type) && article.parent_model_type.toString().toLowerCase() === 'parent') {
					delete article['ParentModelNumber']
				}
			});
			var jobIndex = jobsTracker.addJob(model, 'ARTICLES.ACTIONS.UPDATE_VIA_IMPORT', 1);
			api.webPut(api.baseUrl + '/catalogs/' + activeCatalog.CatalogCode + '/updatearticles?sourceapplication=' + CONSTANTS.SOURCE_APPLICATION + '&sourceaction=Update via Import', data).then(function(response) {
				jobsTracker.trackJob(jobIndex, response.data.Id);
			}).catch(function(error) {
				jobsTracker.setCriticlaFail(jobIndex, error);
			});
		}

		function assignArticles(articlesData, model, activeCatalog) {
				var isApplyRetailWindowPrivilegeIsAssigned = SecurityFactory.isAuthorized({accessPrivileges: CONSTANTS.PRIVILEGES.ARTICLES.UPDATE_ARTICLE_SHIPMENT_WINDOW});
				var data = angular.copy(articlesData);
				var actionType ='ARTICLES.ACTIONS.ASSIGN_ARTICLES';
				if(!angular.isArray(data)) {
						data = utility.pushItemToArray(data);
						actionType ='ARTICLES.ACTIONS.ASSIGN_ARTICLE';
				}
				var jobIndex = jobsTracker.addJob(model, actionType, 1);
				// to initialize attributes having value null and having `initialValue` in their model fields
				var initializableFields = [];
				var calcAttributes = [];
				angular.forEach(model.fields, function(field) {
						if(field.initialValue) {
								initializableFields.push(field);
						}
						// create calculated fields map
						if(field.inputType === 'calculated') {
							calcAttributes.push(field.field);
						}
				});
				angular.forEach(data, function(d) {
						d.Status = 1;
						angular.forEach(initializableFields, function(initializableField) {
								if(d[initializableField.field] === null || angular.isUndefined(d[initializableField.field]) || d[initializableField.field] === 'null') {
										if(angular.isDefined(initializableField.initialValue)
												&& initializableField.initialValue !== null
												&& initializableField.initialValue !== "") {
														d[initializableField.field] = d[initializableField.initialValue];
										}
								}
						});
						// remove calculated fields from request
						if(calcAttributes.length) {
							angular.forEach(calcAttributes, function(calcAttr) {
								delete d[calcAttr];
							});
						}
				});

				// Send IsShippingWindowUpdatable as 1 when "DummyArticleApplyRetailWindow" privilege is assigned and IsShippingWindowApply is 1
				if(isApplyRetailWindowPrivilegeIsAssigned && activeCatalog.IsShippingWindowApply === 1) {
					angular.forEach(data, function (article) {
						article.IsShippingWindowUpdatable = 1;
					});
				}

				api.webPut(api.baseUrl + '/catalogs/' + activeCatalog.CatalogCode + '/articles?sourceapplication=' + CONSTANTS.SOURCE_APPLICATION + '&sourceaction=Assign Articles', data).then(function(response) {
						jobsTracker.trackJob(jobIndex, response.data.Id);
				}).catch(function(error) {
						jobsTracker.setCriticlaFail(jobIndex, error);
				});
		}

		// can be remove after removing assort article page
		function unAssignArticles(actionType, model, data, catalogCode) {
				var result = crud.createRequestObject(data, model, 'delete');
				var state = {};
				state.name = $state.current.name;
				state.params = $state.params;
				var isBulk = result.itemsNameList.length > 1 ? true : false;
				var logData = activityLogger.createLogData(result.itemsNameList, state, 'catalogs.articles', actionType.toUpperCase(), isBulk, new Date(), null, null);
				var promise = api.webPut(api.baseUrl + '/catalogs/' + catalogCode + '/articles/status', result.requestObj);

					promise.then(function() {
						crud.onRecordStatusChange(data, api.catalogs.articles, 'delete');
				});

				return activityLogger.log(logData, promise);
		}

		function swapArticle(record, catalogCode) {
				var promise = api.webPut(api.baseUrl + '/catalogs/' + catalogCode + '/replacement', record);

				promise.then(function() {
						api.catalogs.articles.isDirty = true;
				});
				return promise;
		}

		function getArticlesWithSameSizes(catalogCode, articleId, articleReplacementAttributeId) {
			if(SecurityFactory.isAuthorized({accessPrivileges: CONSTANTS.PRIVILEGES.VETTING_LIST.GET_SAMESIZE_ARTICLES})) {
				return api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/articles/' + articleId + '/samesizearticles' + '?attributeId=' + articleReplacementAttributeId);
			} else {
				var privilege = {
					id: 342,
					description: 'GetSameSizeArticles - GetSameSizeArticles'
				};
				errorDialog.show('ERRORS.NO_PRIVILEGES', undefined, privilege);
			}
		}

		function updateViaImportModel(model, data, activeCatalog, secondaryModel) {
			angular.forEach(data, function(article) {
				// remove parent model number field. if type is parent we should not send this field to API
				if(angular.isDefined(article.parent_model_type) && article.parent_model_type.toString().toLowerCase() === 'parent') {
					delete article['ParentModelNumber']
				}
			});
			var jobIndex = jobsTracker.addJob(model, 'ARTICLES.ACTIONS.UPDATE_VIA_IMPORT_MODEL', 1, secondaryModel);
			api.webPut(api.baseUrl + '/catalogs/' + activeCatalog.CatalogCode + '/importbymodels?sourceapplication=' + CONSTANTS.SOURCE_APPLICATION + '&sourceaction=Update Via Import(Model)', data).then(function (response) {
				jobsTracker.trackJob(jobIndex, response.data.Id);
			}).catch(function (error) {
				jobsTracker.setCriticlaFail(jobIndex, error);
			});
		}

		function editModelAttributes(model, records, updateRecord, idMap, secondaryModel) {
			var catalogModelLevelAttributes = utility.filterObject(catalogFactory.getActiveCatalogDetails().ModelLevelAttributeList, {Status: 1});
			// transform data into required format
			var transformedData = [];
			var nameIndexes = {};
			for (var i = 0; i < records.length; i++) {
				if(records[i].ModelNumber !== '' && records[i].ModelNumber != null) {
					var ind = -1;
					if(angular.isUndefined(nameIndexes[records[i].ModelNumber.toUpperCase()])) {
						var requestObj = {'ModelNumber': records[i].ModelNumber};
						ind = transformedData.length;
						nameIndexes[records[i].ModelNumber.toUpperCase()] = ind;
						transformedData.push(requestObj);
					} else {
						ind = nameIndexes[records[i].ModelNumber.toUpperCase()];
					}
					if(catalogModelLevelAttributes.length > 0) {
						for(var key in updateRecord) {
							var index = catalogModelLevelAttributes.indexOf(utility.filterObject(catalogModelLevelAttributes, { AttributeSystemName: key, Status: 1 }, true)[0]);
							if(index !== -1) {
								transformedData[ind][key] = updateRecord[key];
							}
							// add ParentModelNumber is present
							if(key === 'ParentModelNumber' && updateRecord[key] != null) {
								transformedData[ind][key] = updateRecord[key];
							}
						}
					}
				}
			}
			nameIndexes = undefined;

			var jobIndex = jobsTracker.addJob(model, 'ARTICLES.ACTIONS.EDIT_MODEL_ATTRIBUTES', 1, secondaryModel);
			api.webPut(api.baseUrl + '/catalogs/' + idMap.catalogId + '/importbymodels?sourceapplication=' + CONSTANTS.SOURCE_APPLICATION + '&sourceaction=Edit Model Attributes', transformedData).then(function (response) {
				jobsTracker.trackJob(jobIndex, response.data.Id);
			}).catch(function (error) {
				jobsTracker.setCriticlaFail(jobIndex, error);
			});
		}

		function assignArticlesToMasterCatalog(article, catalogCode, model) {
			var state = {};
			state.name = $state.current.name;
			state.params = $state.params;

			var activeCatalog = catalogFactory.getActiveCatalog();
			var isRestrictedRetailWindowOnRole = (angular.isDefined(api.roleBasedRestrictions.restrictedRetailWindow) && !utility.isObjectEmpty(api.roleBasedRestrictions.restrictedRetailWindow)) ? true : false;

			angular.forEach(model.fields, function(item) {
				// remove non required model level attributes enabled
				if(item.isModelLevelAttribute && !item.validation.isRequired) {
					delete article[item.field];
				}
			});

			// remove shipmentWindowRangeId if its null
			if(angular.isDefined(article['ShipmentWindowRangeId']) && article['ShipmentWindowRangeId'] == null) {
				delete article['ShipmentWindowRangeId'];
			} else if(article['ShipmentWindowRangeId'] != null) {
				// Send IsShippingWindowUpdatable as 1 when "DummyArticleApplyRetailWindow" privilege is assigned and IsShippingWindowApply is 1
				// if retail window is restricted on role send IsShippingWindowUpdatable as 0
				if(SecurityFactory.isAuthorized({accessPrivileges: CONSTANTS.PRIVILEGES.ARTICLES.UPDATE_ARTICLE_SHIPMENT_WINDOW}) && activeCatalog.IsShippingWindowApply === 1 && !isRestrictedRetailWindowOnRole) {
					article.IsShippingWindowUpdatable = 1;
				} else {
					article.IsShippingWindowUpdatable = 0;
				}
			}

			var logData = activityLogger.createLogData(article[api.catalogs.articles.lookupDisplayField], state, 'catalogs.articles', 'ADD', false, new Date(), null, null);
			var promise = api.webPost(api.baseUrl + '/catalogs/' + catalogCode + '/true/models/assign/articles', [article]);

			promise.then(function() {
				api.catalogs.articles.isDirty = true;
				api.catalogs.prices.isDirty = true;
				api.catalogArticles.segmentation.isDirty = true;
				api.catalogs.crds.isDirty = true;
				api.catalogs.stock.isDirty = true;
				api.catalogArticles.segmentationLinear.isDirty = true;
				api.catalogs.crdsLinear.isDirty = true;
				api.catalogs.stockLinear.isDirty = true;
				api.catalogs.pricesLinear.isDirty = true;
				api.catalogs.models.isDirty = true;
				api.lists.catalogModelList.isDirty = true;
				api.sellerModels.sellerModels.isDirty = true;
				api.lists.availableArticlesFromModel.isDirty = true;
			});
			return activityLogger.log(logData, promise);
		}

		function assignArtcleStates(updatedRecord, catalogCode, model, articles, isRequiredAttributesChanged, isSizeScaleChanged) {
			var promises = [];
			var stateArray = [];
			angular.forEach(articles, function(record) {
				var requestObj = {
					ArticleId: record.Id,
					StateId: updatedRecord.StateId
				};
				stateArray.push(requestObj);

				if (isRequiredAttributesChanged) {
					var requestObjectForUpdateArticles = {
						ArticleNumber: record.ArticleNumber,
						ArticleName: record.ArticleName,
						ModelNumber: record.ModelNumber
					};
					for (var prop in updatedRecord) {
						if (prop !== 'StateId' && prop !== 'SizeScaleId' && prop !== 'MasterSizeScaleId' && articles[0][prop] !== updatedRecord[prop]) {
							requestObjectForUpdateArticles[prop] = updatedRecord[prop];
						}
					}
					promises.push(updateArticle(record.Id, requestObjectForUpdateArticles, catalogCode, model, null, true));
				}
			});
			var promise;
			if (isRequiredAttributesChanged) {
				promise = $q.all(promises).then(function() {
					if (isSizeScaleChanged && angular.isDefined(updatedRecord.SizeScaleId) && updatedRecord.SizeScaleId !== null) {
						var sizeScaleReqObj = {
							SizeScaleId: updatedRecord.SizeScaleId
						};
						return setSizeScaleOnArticles(sizeScaleReqObj, articles[0].ModelId, catalogCode)
						.then(function() {
							return api.webPut(api.baseUrl + '/catalogs/' + catalogCode + '/articles/articlestates', stateArray)
								.then(function() {
									api.catalogs.articles.isDirty = true;
									api.sellerModels.sellerModels.isDirty = true;
									api.catalogs.models.isDirty = true;
								});
						});
					} else {
						return api.webPut(api.baseUrl + '/catalogs/' + catalogCode + '/articles/articlestates', stateArray)
						.then(function() {
							api.catalogs.articles.isDirty = true;
							api.sellerModels.sellerModels.isDirty = true;
							api.catalogs.models.isDirty = true;
						});
					}
				});
			} else if (isSizeScaleChanged && angular.isDefined(updatedRecord.SizeScaleId) && updatedRecord.SizeScaleId !== null) {
				var sizeScaleReqObj = {
					SizeScaleId: updatedRecord.SizeScaleId
				};
				promise = setSizeScaleOnArticles(sizeScaleReqObj, articles[0].ModelId, catalogCode)
					.then(function() {
						return api.webPut(api.baseUrl + '/catalogs/' + catalogCode + '/articles/articlestates', stateArray)
							.then(function() {
								api.catalogs.articles.isDirty = true;
								api.sellerModels.sellerModels.isDirty = true;
								api.catalogs.models.isDirty = true;
							});
					});
			} else {
				promise = api.webPut(api.baseUrl + '/catalogs/' + catalogCode + '/articles/articlestates', stateArray)
					.then(function() {
						api.catalogs.articles.isDirty = true;
						api.sellerModels.sellerModels.isDirty = true;
						api.catalogs.models.isDirty = true;
					});
			}
			return promise;
		}

		function createBulkByLicensee(model, data, catalogCode) {
			// make prices, segmentations, crds and stocks model dirty when creating new articles to get updated data in all these modules.
			var pricesModel	= api.catalogs.prices;
			var segmentationModel = api.catalogArticles.segmentation;
			var crdsModel = api.catalogs.crds;
			var stocksModel = api.catalogs.stock;
			var pricesLinearModel	= api.catalogs.pricesLinear;
			var segmentationLinearModel = api.catalogArticles.segmentationLinear;
			var crdsLinearModel = api.catalogs.crdsLinear;
			var stocksLinearModel = api.catalogs.stockLinear;
			var modelArray = [pricesModel, segmentationModel, crdsModel, stocksModel, segmentationLinearModel, crdsLinearModel, stocksLinearModel, pricesLinearModel];
			var isApplyRetailWindowPrivilegeIsAssigned = SecurityFactory.isAuthorized({accessPrivileges: CONSTANTS.PRIVILEGES.ARTICLES.UPDATE_ARTICLE_SHIPMENT_WINDOW});
			var isRestrictedRetailWindowOnRole = (angular.isDefined(api.roleBasedRestrictions.restrictedRetailWindow) && !utility.isObjectEmpty(api.roleBasedRestrictions.restrictedRetailWindow)) ? true : false;
			angular.forEach(data, function(article) {
				// Send IsShippingWindowUpdatable as 1 when "DummyArticleApplyRetailWindow" privilege is assigned and IsShippingWindowApply is 1
				// if retail window is restricted on role send IsShippingWindowUpdatable as 0
				var isUpdatable = isApplyRetailWindowPrivilegeIsAssigned && catalogFactory.getActiveCatalog().IsShippingWindowApply === 1 && !isRestrictedRetailWindowOnRole;
				article.IsShippingWindowUpdatable = isUpdatable ? 1 : 0;
				if(article.RetailExitMonthId != null && article.RetailExitMonthId !== '') {
					article['ShipmentWindowRangeId'] = article.RetailExitMonthId;
				}
				// remove parent model number field. if type is parent we should not send this field to API
				if(angular.isDefined(article.parent_model_type) && article.parent_model_type.toString().toLowerCase() === 'parent') {
					delete article['ParentModelNumber']
				}
			});
			// sending all the affected models as an array to secondary model
			var jobIndex = jobsTracker.addJob(model, 'ARTICLES.ACTIONS.IMPORT_BY_LICENSEE', 1, modelArray);

			// article numbers are supplied in the import file when custom numbering is enabled on seller level
			var customNumbersParam = catalogFactory.getCustomNumbering() ? '&customNumbers=true' : '';

			api.webPut(api.baseUrl + '/catalogs/' + catalogCode + '/articles?importbylicensee=true&sourceapplication=' + CONSTANTS.SOURCE_APPLICATION + '&sourceaction=Import By Licensee' + customNumbersParam, data).then(function(response) {
				api.sellerModels.sellerModels.isDirty = true;
				jobsTracker.trackJob(jobIndex, response.data.Id);
			}).catch(function(error) {
					jobsTracker.setCriticlaFail(jobIndex, error);
			});
		}

		function setSizeScaleByLicenceeModelNumberBulk(model, results, catalogCode, sizeScaleGroupsPromise, masterSizeScalesPromise) {
			var deferred = $q.defer();
			var promise = deferred.promise;
			var requestbody = [];

			masterSizeScalesPromise.then(function(masterSizeScaleResponse) {
				var masterSizeScales = masterSizeScaleResponse.data;
				var masterSizeScaleMap = {};

				// create masterSizeScales map
				angular.forEach(masterSizeScales, function(masterSizeScale) {
					masterSizeScaleMap[masterSizeScale.SizeScale] = masterSizeScale.Id;
				});

				sizeScaleGroupsPromise.then(function(sizeScaleGroupsResponse) {
					var sizeScaleGroups = sizeScaleGroupsResponse.data;

					for (var i = 0; i < results.length; i++) {
						var masterSizeScaleName = results[i].MasterSizeScale;
						var sizeScaleName = results[i].SizeScale;

						var masterSizeScaleId = masterSizeScaleMap[masterSizeScaleName];
						var sizeScaleId = utility.getSizeScaleIdByMasterSizeScaleIdAndSizeScaleName(masterSizeScaleId, sizeScaleName, sizeScaleGroups);

						if (sizeScaleId) {
							var requestObject = {
								SizeScaleId: sizeScaleId,
								LicenseeModelNumber: results[i].LicenseeModelNumber
							};
							requestbody.push(requestObject);
						} else {
							console.log('Size scale not found for MasterSizeScaleName: ' + masterSizeScaleName + ' and SizeScale: ' + sizeScaleName);
						}
					}

					var jobIndex = jobsTracker.addJob(model, 'ARTICLES.ACTIONS.SET_SIZES_BY_LICENCEE_MODEL_NUMBER', 1);
					api.webPut(api.baseUrl + '/catalogs/' + catalogCode + '/licenseemodels/assignsizescales?sourceapplication=' + CONSTANTS.SOURCE_APPLICATION + '&sourceaction=Set Sizes(Bulk) By Licensee Model Number', requestbody).then(function(response) {
						jobsTracker.trackJob(jobIndex, response.data.Id);
						deferred.resolve(response);
					}).catch(function(error) {
						jobsTracker.setCriticlaFail(jobIndex, error);
						deferred.reject(error);
					});
				}).catch(function(error) {
					$log.error('Error in set sizes bulk', error);
					deferred.reject(error);
				});
			}).catch(function(error) {
				$log.error('Error in retrieving master size scales', error);
				deferred.reject(error);
			});

			return promise;
		}

		function setSizeScaleOnArticles(requestObject, modelId, catalogCode) {
			return api.webPut(api.baseUrl + '/catalogs/' + catalogCode + '/models/' + modelId + '/assignsizescale', requestObject);
		}

		function setPricesByLicenseeModelNumberBulk(dataImporterResult, activeCatalog, model, secondaryModel) {
			var requestObj = {};
			var data = dataImporterResult.data;
			//Transform data into required format
			var transformedData = [];
			var newElement = {};
			angular.forEach(data, function(element) {
					newElement = { LicenseeModelNumber: element.LicenseeModelNumber, Prices: [] };
					angular.forEach(model.fields,function(field) {
							if (field.isCatalogProperty) {
									// skip if there is no price for the price-group, since made price-groups non mandatory it could not be send from excel
									if(angular.isDefined(element[field.field]) && element[field.field] != null) {
											newElement.Prices.push({PriceGroupId: field.priceGroupId, Price: element[field.field]});
									}
							}
					});
					// skip article entry if there is no price group sent
					if(newElement.Prices.length) {
							transformedData.push(newElement);
					}
			});

			requestObj.ArticlePrices = transformedData;

			// if there is no priceGroup editable ArticlePrices will be empty array
			if(requestObj.ArticlePrices.length) {
					var promise;
					var jobIndex = jobsTracker.addJob(model, 'ARTICLES.ACTIONS.SET_PRICES_BY_LICENSEE_MODEL_NUMBER', 1, secondaryModel);
					var promise = api.webPut(api.baseUrl + '/catalogs/' + activeCatalog.CatalogCode + '/licenseemodels/assignprices?sourceapplication=' + CONSTANTS.SOURCE_APPLICATION + '&sourceaction=Set Prices(Bulk) By Licensee Model Number', requestObj);

					promise.then(function(response) {
							api.catalogs.prices.isDirty = true;
							jobsTracker.trackJob(jobIndex, response.data.Id);
					}).catch(function(error) {
							jobsTracker.setCriticlaFail(jobIndex, error);
					});
			}
			else {
					dialog.showAlertDialog(
							angular.element($document[0].body),
							$filter('translate')('MESSAGES.TITLE.ALERT'),
							$filter('translate')('PRICES.MESSAGES.NO_EDITABLE_PRICE_GROUPS'),
							$filter('translate')('MESSAGES.TITLE.ALERT'),
							$filter('translate')('ACTIONS.DIALOG_CLOSE'),
							true,
							null
					);
			}
		}

		function overwriteColor(articleId, record, catalogCode) {
			var state = {};
			state.name = $state.current.name;
			state.params = $state.params;
			var logData = activityLogger.createLogData(articleId, state, 'catalogs.articles', 'EDIT', false, new Date(), null, null);

			var promise = api.webPut(api.baseUrl + '/catalogs/' + catalogCode + '/articles/' + articleId + '/assignarticlecolors' , record);

			promise.then(function() {
				api.catalogs.articles.isDirty = true;
			});
			return activityLogger.log(logData, promise);
		}

		function overwriteColorBulk(model, data, catalogCode) {
			var jobIndex = jobsTracker.addJob(model, 'ARTICLES.ACTIONS.OVERWRITE_ARTICLE_CODE_BULK', 1);
			api.webPut(api.baseUrl + '/catalogs/' + catalogCode + '/bulkassignarticlecolors?sourceapplication=' + CONSTANTS.SOURCE_APPLICATION + '&sourceaction=Overwrite Article Code(Bulk)', data).then(function(response) {
				jobsTracker.trackJob(jobIndex, response.data.Id);
			}).catch(function(error) {
					jobsTracker.setCriticlaFail(jobIndex, error);
			});
		}
	}
})();
(function () {
	'use strict';

	angular
		.module('app.main.catalogs.watch-filters')
		.run(runBlock);

	/* @ngInject */
	function runBlock(api, activityLogger, $state, crud, $localStorage) {

		if (angular.isUndefined(api.catalogs)) {
			api.catalogs = {};
		}
		api.catalogs.watchFilters = {
			modelPath: 'catalogs.watchFilters',
			fields: [
				{ field: 'Id', type: 'int', displayLabel: 'WATCH_FILTERS.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
					validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
				{ field: 'Name', type: 'text', displayLabel: 'WATCH_FILTERS.FIELDS.NAME', visible: true, creatable: true, editable: true, inputType: 'text', checkIfUnique: true,
					validation: { isRequired: true, maxLen: 500, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
				{ field: 'UserId', type: 'int', displayLabel: 'WATCH_FILTERS.FIELDS.USER_NAME', visible: false, creatable: false, editable: false, inputType: 'lookup', lookupSource: 'lists.usersWithCatalogAccess',
					validation: { isRequired: true, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } } },
				{ field: 'UserId', type: 'int', displayLabel: 'WATCH_FILTERS.FIELDS.USER_ID', visible: true, creatable: false, editable: false, inputType: 'number',
					validation: { isRequired: true, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } } },
				{ field: 'UserName', type: 'text', displayLabel: 'USERS.FIELDS.USER_NAME', visible: true, creatable: false, editable: true, inputType: 'text',
					validation: {isRequired: true, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'Filter', type: 'text', displayLabel: 'WATCH_FILTERS.FIELDS.FILTER', visible: true, creatable: true, editable: true, inputType: 'textArea',
					validation: { isRequired: true, maxLen: -1, minLen: 0, pattern: '', checkIfValidJson: true, messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '', isValidJson: 'VALIDATIONS.INVALID_JSON' } }},
				{ field: 'PriceGroups', type: 'text', displayLabel: 'WATCH_FILTERS.FIELDS.PRICE_GROUPS', visible: true, creatable: true, editable: false, inputType: 'lookup-many', lookupSource:'catalogs.priceGroup',
					lookupFilter: {Status: 1}, validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'Segmentations', type:'text', displayLabel: 'WATCH_FILTERS.FIELDS.SEGMENTATIONS', visible: true, creatable: true, editable: true, inputType: 'lookup-many', lookupSource: 'catalogs.segmentations',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'UpdatedByUserName', type: 'text', displayLabel: 'WATCH_FILTERS.FIELDS.UPDATED_BY_USERNAME', visible: true, creatable: false, editable: true, inputType: 'text',
					validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
				{ field: 'CreatedByUserName', type: 'text', displayLabel: 'WATCH_FILTERS.FIELDS.CREATED_BY_USERNAME', visible: true, creatable: false, editable: true, inputType: 'text',
					validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
				{ field: 'Status', type: 'text', displayLabel: 'WATCH_FILTERS.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
					validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
				{ field: 'CreatedDate', type: 'text', displayLabel: 'WATCH_FILTERS.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
					validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
				{ field: 'UpdatedDate', type: 'text', displayLabel: 'WATCH_FILTERS.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
					validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
				{ field: 'CreatedBy', type: 'int', displayLabel: 'WATCH_FILTERS.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'number',
					validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }},
				{ field: 'UpdatedBy', type: 'int', displayLabel: 'WATCH_FILTERS.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'number',
					validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }}
			],
			uniqueConstraints: [],
			title: 'WATCH_FILTERS.NAV',
			idField: 'Id',
			lookupDisplayField: 'Name',
			isDirty: false,
			isCatalogSpecificModel: true,
			methods: {
				getList      : getWatchFilters,
				getDetails   : getWatchFilter,
				create       : createWatchFilter,
				activateBulk : activateBulk,
				createBulk   : createBulk
			},
			views: {
				mainList: {
					columns: ['Name', 'PriceGroups', 'Segmentations', 'Filter', 'UserName', 'UpdatedDate', 'UpdatedBy'],
					columnFilter: {},
					toggleFilterProps: { toggleStatus: false, filterProp: 'Status', trueVal: 1, trueValTooltipMessage: 'ACTIONS.TOGGLE_ACTIVE', falseVal: '', falseValTooltipMessage: "ACTIONS.TOGGLE_ALL" },
					topIndex: 0,
					showFilterRow: false,
					sortColumn: { 'UpdatedDate': false },
					itemActions: [
						{ id: 'view', label: 'ACTIONS.VIEW', icon: 'icon-magnify', privilege: 'GetAllCatalogWatchedFilters', disabled: false, visible: true },
						{ id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateWatchedFilterStatuses:true', disabled: false, visible: 'itm.Status',
								requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
						{ id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateWatchedFilterStatuses:true', disabled: false, visible: '!itm.Status',
								requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
					],
					listActions: [
						{ id: 'delete', label: 'ACTIONS.DELETE_BULK', icon: 'icon-delete', privilege: 'UpdateWatchedFilterStatuses:true', disabled: '{selected: true, Status: 1}', visible: true,
								requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
						{ id: 'activate', label: 'ACTIONS.ACTIVATE_BULK', icon: 'icon-undo-variant', privilege: 'UpdateWatchedFilterStatuses:true', disabled: '{selected: true, Status: 0}', visible: true,
								requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'},
						{ id: 'import', label: 'ACTIONS.IMPORT', icon: 'icon-import', privilege: 'ImportWatchedFilters:true', disabled: false, visible: true, requiresConfirmation: false }
					],
					fabAction       : {id: 'add', label: 'ACTIONS.ADD', icon: 'icon-plus', privilege: 'CreateWatchedFilters', visible: true}
				},
				mainDetails: {},
				privileges: {
					list: 'GetAllCatalogWatchedFilters',
					details: 'GetAllCatalogWatchedFilters'
				}
			}

		};

		function getWatchFilters(generalProperties, model, catalogId) {
			if (angular.isDefined(model)) { // to skip this part for load lookup
				model.isBulkActionCompleted = false;
			}
			var promise;
			var url = api.baseUrl + '/catalogs/' + catalogId + '/watchedfilters';
			// admin user have access to all watch filters and seller users have access to only own filters
			if ($localStorage.account && $localStorage.account.accountType !== '1') {
				url = url + '?userId=' + $localStorage.UserId;
			}

			if (angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
				var state = {};
				state.name = $state.current.name;
				state.params = $state.params;
				var isBulk = true;
				var logData = activityLogger.createLogData(null, state, 'catalogs.watchFilters', 'VIEW', isBulk, new Date(), null, null);

				promise = api.webGet(url, undefined, true, generalProperties.forceFetch);
				promise = activityLogger.log(logData, promise);
			}
			else {
				catalogId = angular.isUndefined(catalogId) ? catalogFactory.getActiveCatalog().CatalogCode : catalogId;
				promise = api.webGet(url, undefined, true, generalProperties.forceFetch);
			}

			promise.then(function () {
				if (api.catalogs.watchFilters.isDirty) {
					//Invalidate lookupData
					api.catalogs.watchFilters.lookupData = undefined;
					api.catalogs.watchFilters.isDirty = false;
				}
			});
			return promise;
		}

		function getWatchFilter(isLogRequired, watchFilterID, catalogCode) {
			var promise;
			if(angular.isDefined(isLogRequired) && isLogRequired === true) {
				var state = {};
				state.name = $state.current.name;
				state.params = $state.params;
				var isBulk = false;
				var items = [];
				promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/watchedfilters?filterId=' + watchFilterID);
				promise.then(function(response) {
					items.push(response.data[api.catalogs.watchFilters.lookupDisplayField]);
				});
				var logData = activityLogger.createLogData(items, state, 'catalogs.watchFilters', 'VIEW', isBulk, new Date(), null, null);
				promise = activityLogger.log(logData, promise);
			}
			else {
				promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/watchedfilters?filterId=' + watchFilterID);
			}
			return promise;
		}

		function createWatchFilter(record, catalogCode) {
			var state = {};
			state.name = $state.current.name;
			state.params = $state.params;
			if($localStorage.account && $localStorage.account.accountType !== '1') {
				record.UserId = $localStorage.UserId;
			}
			var logData = activityLogger.createLogData(record[api.catalogs.watchFilters.lookupDisplayField], state, 'catalogs.watchFilters', 'ADD', false, new Date(), null, null);
			var promise = api.webPost(api.baseUrl + '/catalogs/' + catalogCode + '/watchedfilters', record);

			promise.then(function () {
				api.catalogs.watchFilters.isDirty = true;
			});
			return activityLogger.log(logData, promise);
		}
		
		function activateBulk(records, model, actionType, parentId) {
			var result = crud.createRequestObject(records, model, actionType);
			var state = {};
			state.name = $state.current.name;
			state.params = $state.params;
			var isBulk = result.itemsNameList.length > 1 ? true : false;
			var logData = activityLogger.createLogData(result.itemsNameList, state, 'catalogs.watchFilters', actionType.toUpperCase(), isBulk, new Date(), null, null);
			var promise = api.webPut(api.baseUrl + '/catalogs/' + parentId + '/watchedfilters/status', result.requestObj);

			promise.then(function () {
				crud.onRecordStatusChange(records, api.catalogs.watchFilters, actionType);// it should be base model for dynamic models since base model isDirty is being change in all actions
			});

			return activityLogger.log(logData, promise);
		}

		function createBulk(data, catalogId) {
			//Transform data into required format
			var transformedData = [];
			angular.forEach(data, function(record) {
				var requestObj = {
					Name: record.Name,
					Filter: record.Filter
				} 
				requestObj.Username = ($localStorage.account && $localStorage.account.accountType !== '1') ? $localStorage.profileInformation.UserName : record.UserName;
				requestObj.PriceGroups = record.PriceGroups.length > 0 ? record.PriceGroups.split(',') : record.PriceGroups;
				requestObj.Segmentations = record.Segmentations.length > 0 ? record.Segmentations.split(',') : record.Segmentations;
				transformedData.push(requestObj);
			});

			var promise = api.webPut(api.baseUrl + '/catalogs/' + catalogId + '/watchedfilters/import', transformedData);

			promise.then(function() {
				api.account.adminUsers.isDirty = true;
			});
			return promise;
		}
	}
})();
(function() {
  'use strict';

  angular
      .module('app.main.catalogs.article-color')
      .run(runBlock);

  /* @ngInject */
  function runBlock(api, activityLogger, $state, catalogFactory, jobsTracker, crud) {

      if (angular.isUndefined(api.catalogs)) {
          api.catalogs = {};
      }
       api.catalogs.articleColor = {
          modelPath: 'catalogs.articleColor',
          fields: [
            { field: 'Id', type: 'int', displayLabel: 'ARTICLE_COLOR.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
              validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
            { field: 'ArticleId', type: 'int', displayLabel: 'ARTICLE_COLOR.FIELDS.ARTICLE_NUMBER', visible: true, creatable: true, editable: false, showInEdit: true, inputType: 'lookup', lookupSource: 'catalogs.articles', isConditionalColorVettingListArticle: true,
              lookupFilter: {'Status': 1}, validation: {isRequired: true, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
            { field: 'ColorId', type: 'text', displayLabel: 'ARTICLE_COLOR.FIELDS.COLOR_NAME', visible: true, creatable: true, editable: true, inputType: 'lookup', lookupSource: 'catalogs.colorDefinition', showColorBox: true, conditionalColorVettingListEnabled: true,
              lookupFilter: {'Status': 1}, useLookupName: true, validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', disabledCriteria: 'vm.record.ArticleId == null', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
            // following 2 fields are used only for import
            { field: 'ArticleNumber', type: 'text', displayLabel: 'ARTICLE_COLOR.FIELDS.ARTICLE_NUMBER', visible: false, creatable: false, editable: false, inputType: 'text',
              validation: {isRequired: true, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
            { field: 'ColorName', type: 'text', displayLabel: 'ARTICLE_COLOR.FIELDS.COLOR_NAME', visible: false, creatable: false, editable: false, inputType: 'text', isConditionalColorVettingListArticle: true,
              useLookupName: true, validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', dataExistConstraints: {modelPath: 'catalogs.colorDefinition', promise: null, data: null,  shouldNotExist: false}, messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },

            { field: 'Print', type: 'text', displayLabel: 'ARTICLE_COLOR.FIELDS.PRINT', visible: true, creatable: true, editable: true, inputType: 'bool-int',
              validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
            { field: 'Status', type: 'text', displayLabel: 'ARTICLE_COLOR.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
                validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
            { field: 'CreatedDate', type: 'text', displayLabel: 'ARTICLE_COLOR.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
            { field: 'UpdatedDate', type: 'text', displayLabel: 'ARTICLE_COLOR.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
            { field: 'CreatedBy', type: 'text', displayLabel: 'ARTICLE_COLOR.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
            { field: 'UpdatedBy', type: 'text', displayLabel: 'ARTICLE_COLOR.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
          ],
          uniqueConstraints: [
            {name: 'Constraint 1', fields: ['ArticleNumber', 'ColorName']}
          ],
          title: 'ARTICLE_COLOR.NAV',
          icon: 'icon-format-paint',
          idField: 'Id',
          lookupDisplayField: 'Id',
          isDirty: false,
          isCatalogSpecificModel: true,
          methods: {
            getList            : getArticleColorList,
            activateBulk       : updateStatus,
            create             : linkColorToArticle,
            update             : updateArticleColor,
            createBulk         : createBulk,
            updateBulk         : updateBulk
          },
          views: {
            mainList: {
              columns         : [ 'ArticleId', 'ColorId', 'Print', 'Status', 'UpdatedDate' ],
              columnFilter    : {},
              toggleFilterProps: {},
              topIndex        : 0,
              showFilterRow   : false,
              sortColumn      : {'UpdatedDate': false},
              sortDescending  : true,
              itemActions     : [
                { id: 'view', label: 'ACTIONS.VIEW', icon: 'icon-magnify', privilege: 'nav_articles', disabled: '!itm.Status', visible: true },
                { id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'AssignArticleColorBulk:true', disabled: false, visible: true },
                { id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateArticleColorStatusBulk:true', disabled: false, visible: 'itm.Status',
                    requiresConfirmation: false, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                { id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateArticleColorStatusBulk:true', disabled: false, visible: '!itm.Status',
                    requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
              ],
              listActions     : [
                { id: 'delete', label: 'ACTIONS.DELETE_BULK', icon: 'icon-delete', privilege: 'UpdateArticleColorStatusBulk:true', disabled: '{selected: true, Status: 1}', visible: true,
                  requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                { id: 'activate', label: 'ACTIONS.ACTIVATE_BULK', icon: 'icon-undo-variant', privilege: 'UpdateArticleColorStatusBulk:true', disabled: '{selected: true, Status: 0}', visible: true,
                  requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'},
                { id: 'updateBulk', label: 'ACTIONS.UPDATE_BULK', icon: 'icon-pencil', privilege: 'AssignArticleColorBulk:true', disabled: '{selected: true}', visible: true, requiresConfirmation: false },
                { id: 'import', label: 'ACTIONS.IMPORT', icon: 'icon-import', privilege: 'ImportArticleColorBulk:true', disabled: false, visible: true, requiresConfirmation: false}
              ],
              fabAction       :
                {id: 'add', label: 'ACTIONS.ADD', icon: 'icon-plus', privilege: 'AssignArticleColorBulk:true', visible: true}
            },
            mainDetails: {},
            privileges: {
                list    : 'GetAllArticlesColor'
            }
          }
      };

    function getArticleColorList(generalProperties, model, catalogId) {
      if (angular.isDefined(model)) { // to skip this part for load lookup
          model.isBulkActionCompleted = false;
      }
      var promise;

      if (angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
          var state = {};
          state.name = $state.current.name;
          state.params = $state.params;
          var isBulk = true;
          var logData = activityLogger.createLogData(null, state, 'catalogs.articleColor', 'VIEW', isBulk, new Date(), null, null);

          promise = api.webGet(api.baseUrl + '/catalogs/' + catalogId + '/articleColors', undefined, true, generalProperties.forceFetch);
          promise = activityLogger.log(logData, promise);
      }
      else {
          catalogId = angular.isUndefined(catalogId) ? catalogFactory.getActiveCatalog().CatalogCode : catalogId;
          promise = api.webGet(api.baseUrl + '/catalogs/' + catalogId + '/articleColors', undefined, true, generalProperties.forceFetch);
      }

      promise.then(function () {
          if (api.catalogs.articleColor.isDirty) {
              //Invalidate lookupData
              api.catalogs.articleColor.lookupData = undefined;
              api.catalogs.articleColor.isDirty = false;
          }
      });
      return promise;
    }

    function updateStatus(records, model, actionType, parentId) {
			var result = crud.createRequestObject(records, model, actionType);
			var state = {};
			state.name = $state.current.name;
			state.params = $state.params;
			var isBulk = result.itemsNameList.length > 1 ? true : false;
			var logData = activityLogger.createLogData(result.itemsNameList, state, 'catalogs.articleColor', actionType.toUpperCase(), isBulk, new Date(), null, null);
			var promise = api.webPut(api.baseUrl + '/catalogs/' + parentId + '/articlecolors/status', result.requestObj);

			promise.then(function() {
				crud.onRecordStatusChange(records, api.catalogs.articleColor, actionType);
			});

			return activityLogger.log(logData, promise);
    }

    function linkColorToArticle(record, catalogCode) {
			var state = {};
			state.name = $state.current.name;
			state.params = $state.params;
			var logData = activityLogger.createLogData(record[api.catalogs.articleColor.lookupDisplayField], state, 'catalogs.articleColor', 'ADD', false, new Date(), null, null);
      var promise = api.webPut(api.baseUrl + '/catalogs/' + catalogCode + '/articlecolors', [record]);
      promise.then(function() {
        api.catalogs.articleColor.isDirty = true;
      });
      return activityLogger.log(logData, promise);
    }

    function updateArticleColor(itemId, item, catalogId) {
      var state = {};
      state.name = $state.current.name;
      state.params = $state.params;
      var logData = activityLogger.createLogData(item[api.catalogs.articleColor.lookupDisplayField], state, 'catalogs.articleColor', 'EDIT', false, new Date(), null, null);
      var promise = api.webPut(api.baseUrl + '/catalogs/' + catalogId + '/articlecolors/', [item]);

      promise.then(function() {
         api.catalogs.articleColor.isDirty = true;
      });
      return activityLogger.log(logData, promise);
    }

    function createBulk(data, catalogId, model) {
      var jobIndex = jobsTracker.addJob(model, 'ARTICLE_COLOR.ACTIONS.IMPORT', 1);
      api.webPut(api.baseUrl + '/catalogs/' + catalogId + '/importarticlecolors', data).then(function(response) {
          jobsTracker.setCompleted(jobIndex, response);
      }).catch(function(error) {
          jobsTracker.setCriticlaFail(jobIndex, error);
      });
    }

    function updateBulk(model, records, updateRecord, idMap) {
      angular.forEach(records, function (record) {
        for (var prop in updateRecord) {
          record[prop] = updateRecord[prop];
        }
      });
      var promise = api.webPut(api.baseUrl + '/catalogs/' + idMap.id1 + '/articlecolors', records);

      promise.then(function() {
         api.catalogs.articleColor.isDirty = true;
      });
    }

  }
})();
(function () {
	'use strict';

	angular
		.module('app.main.catalogs.article-change-logs')
		.run(runBlock);

	/* @ngInject */
	function runBlock(api, activityLogger, $state, $localStorage) {

		if (angular.isUndefined(api.catalogs)) {
			api.catalogs = {};
		}
		api.catalogs.articleChangeLogs = {
			modelPath: 'catalogs.articleChangeLogs',
			fields: [
				{ field: 'Id', type: 'int', displayLabel: 'ARTICLE_CHANGE_LOGS.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number' },
				{ field: 'FilterId', type: 'int', displayLabel: 'ARTICLE_CHANGE_LOGS.FIELDS.FILTER_ID', visible: true, creatable: false, editable: false, inputType: 'number' },
				{ field: 'ArticleId', type: 'int', displayLabel: 'ARTICLE_CHANGE_LOGS.FIELDS.ARTICLE_ID', visible: true, creatable: false, editable: false, inputType: 'text' },
				{ field: 'UserId', type: 'int', displayLabel: 'ARTICLE_CHANGE_LOGS.FIELDS.USER_ID', visible: true, creatable: false, editable: false, inputType: 'number' },
				{ field: 'UserName', type: 'text', displayLabel: 'ARTICLE_CHANGE_LOGS.FIELDS.USER_NAME', visible: true, creatable: false, editable: false, inputType: 'text' },
				{ field: 'NewValue', type: 'text', displayLabel: 'ARTICLE_CHANGE_LOGS.FIELDS.NEW_VALUE', visible: true, creatable: false, editable: false, inputType: 'text' },
				{ field: 'ChangeType', type: 'int', displayLabel: 'ARTICLE_CHANGE_LOGS.FIELDS.CHANGE_TYPE', visible: true, creatable: false, editable: false, inputType: 'lookup', lookupSource: 'lists.articleChangeTypes' },
				{ field: 'Status', type: 'text', displayLabel: 'ARTICLE_CHANGE_LOGS.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status' },
				{ field: 'CreatedBy', type: 'text', displayLabel: 'ARTICLE_CHANGE_LOGS.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup', lookupSource: 'accounts.users' },
				{ field: 'UpdatedBy', type: 'text', displayLabel: 'ARTICLE_CHANGE_LOGS.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup', lookupSource: 'accounts.users' },
				{ field: 'CreatedDate', type: 'text', displayLabel: 'ARTICLE_CHANGE_LOGS.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date' },
				{ field: 'UpdatedDate', type: 'text', displayLabel: 'ARTICLE_CHANGE_LOGS.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date' }
			],
			uniqueConstraints: [],
			title: 'ARTICLE_CHANGE_LOGS.NAV',
			icon: 'icon-cube-outline',
			idField: 'Id',
			lookupDisplayField: 'FilterId',
			isDirty: false,
			isBulkActionCompleted: false,
			isCatalogSpecificModel: true,
			methods: {
				getList: getArticleChangeLogs,
			},
			views: {
				mainList: {
					columns: ['FilterId', 'ArticleId', 'UserName', 'NewValue', 'ChangeType', 'Status', 'UpdatedBy', 'UpdatedDate'],
					columnFilter: {},
					filterByDate: {},
					toggleFilterProps: undefined,
					topIndex: 0,
					showFilterRow: false,
					sortColumn: { 'UpdatedDate': false },
					itemActions: [],
					listActions: [],
					fabAction: {}
				},
				mainDetails: {},
				privileges: {
					list: 'GetAllCatalogWatchedFiltersNotifications'
				}
			}
		};

		function getArticleChangeLogs(generalProperties, catalogCode) {
			var promise;
			var url = api.baseUrl + '/catalogs/' + catalogCode + '/watchedfilters/notifications';
			if (generalProperties.filterByDate && angular.isDefined(generalProperties.filterByDate.startDate) && angular.isDefined(generalProperties.filterByDate.endDate)) {
				url = url + '?fromDate=' + generalProperties.filterByDate.startDate + '&toDate=' + generalProperties.filterByDate.endDate;
			} else {
				var currDate = new Date();
				var toDate = currDate.toISOString().replace(":", "%3A");
				var yesterdaysDate = new Date(currDate.setDate(currDate.getDate() - 1));
				var fromDate = yesterdaysDate.toISOString().replace(":", "%3A");
				url = url + '?fromDate=' + fromDate + '&toDate=' + toDate;
			}
			// admin user have access to all notifications and seller users have access to only subscribed notifications
			if ($localStorage.account && $localStorage.account.accountType !== '1') {
				url = url + '&userId=' + $localStorage.UserId;
			}

			if (angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
				var state = {};
				state.name = $state.current.name;
				state.params = $state.params;
				var isBulk = true;
				var logData = activityLogger.createLogData(null, state, 'catalogs.articleChangeLogs', 'VIEW', isBulk, new Date(), null, null);

				promise = api.webGet(url, undefined, false, generalProperties.forceFetch);
				promise = activityLogger.log(logData, promise);
			}
			else {
				promise = api.webGet(url, undefined, false, generalProperties.forceFetch);
			}
			return promise;
		}

	}
})();
(function () {
  'use strict';

  angular
    .module('app.main.catalogs.allocation-groups')
    .run(runBlock);

  /* @ngInject */
  function runBlock(api, activityLogger, $state, crud, jobsTracker, catalogFactory, CONSTANTS) {

    if (angular.isUndefined(api.catalogs)) {
      api.catalogs = {};
    }
    api.catalogs.allocationGroups = {
      modelPath: 'catalogs.allocationGroups',
      fields: [
        { field: 'Id', type: 'int', displayLabel: 'ALLOCATION_GROUPS.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
          validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
        { field: 'AllocationGroupName', type: 'text', displayLabel: 'ALLOCATION_GROUPS.FIELDS.ALLOCATION_GROUP_NAME', visible: true, creatable: true, editable: true, inputType: 'text',
          validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
        { field: 'ArticleNumber', type: 'text', displayLabel: 'ALLOCATION_GROUPS.FIELDS.ARTICLE_NUMBER', visible: false, creatable: true, editable: true, inputType: 'text',
          validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
        { field: 'Status', type: 'text', displayLabel: 'ALLOCATION_GROUPS.FIELDS.STATUS', visible: true, creatable: true, editable: false, inputType: 'status',
          validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
        { field: 'CreatedDate', type: 'text', displayLabel: 'ALLOCATION_GROUPS.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
          validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
        { field: 'UpdatedDate', type: 'text', displayLabel: 'ALLOCATION_GROUPS.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
          validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
        { field: 'CreatedBy', type: 'text', displayLabel: 'ALLOCATION_GROUPS.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
          validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
        { field: 'UpdatedBy', type: 'text', displayLabel: 'ALLOCATION_GROUPS.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
          validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
      ],
      uniqueConstraints: [
        {name: 'Constraint 1', fields: ['ArticleNumber']}
      ],
      title: 'ALLOCATION_GROUPS.NAV',
      icon: 'icon-source-fork',
      idField: 'Id',
      lookupDisplayField: 'AllocationGroupName',
      isDirty: false,
      isBulkActionCompleted: false,
      isCatalogSpecificModel: true,
      methods: {
         getList      : getAllocationGroups,
         getDetails   : getAllocationGroup,
         activateBulk : activateAllocationGroups,
         update       : updateAllocationGroup,
         createBulk   : createBulk
      },
      views: {
        mainList: {
          columns           : ['AllocationGroupName', 'Status', 'UpdatedDate'],
          columnFilter      : {},
          toggleFilterProps : { toggleStatus: false, filterProp: 'Status', trueVal: 1, trueValTooltipMessage: 'ACTIONS.TOGGLE_ACTIVE', falseVal: '', falseValTooltipMessage: "ACTIONS.TOGGLE_ALL" },
          topIndex          : 0,
          showFilterRow     : false,
          sortColumn        : { 'UpdatedDate': false },
          sortDescending    : true,
          itemActions       : [
                                { id: 'view', label: 'ACTIONS.VIEW', icon: 'icon-magnify', privilege: 'GetAllocationGroupDetails', disabled: '!itm.Status', visible: true },
                                { id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'CreateUpdateAllocationGroup:true', disabled: '!itm.Status', visible: true },
                                { id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateAllocationGroupStatusBulk:true', disabled: false, visible: 'itm.Status',
                                    requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                                { id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateAllocationGroupStatusBulk:true', disabled: false, visible: '!itm.Status',
                                    requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
                              ],
          listActions       : [
                                { id: 'delete', label: 'ACTIONS.DELETE_BULK', icon: 'icon-delete', privilege: 'UpdateAllocationGroupStatusBulk:true', disabled: '{selected: true, Status: 1}', visible: true,
                                  requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                                { id: 'activate', label: 'ACTIONS.ACTIVATE_BULK', icon: 'icon-undo-variant', privilege: 'UpdateAllocationGroupStatusBulk:true', disabled: '{selected: true, Status: 0}', visible: true,
                                  requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'},
                                { id: 'import', label: 'ACTIONS.IMPORT', icon: 'icon-import', privilege: 'CreateUpdateAllocationGroupBulk:true', disabled: false, visible: true, requiresConfirmation: false }
                              ],
          fabAction         : { id: 'add', label: 'ACTIONS.ADD', icon: 'icon-plus', privilege: 'CreateUpdateAllocationGroup:true', visible: true }
        },
        mainDetails: {
          selectedTabIndex  : 0,
          itemActions       : [
                                { id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateAllocationGroupStatusBulk:true', disabled: '{selected: true, Status: 1}',
                                    visible: true, requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                                { id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateAllocationGroupStatusBulk:true', disabled: '{selected: true, Status: 0}',
                                    visible: true, requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
                              ],
          // fabAction          : { id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'CreateUpdateAllocationGroup:true', visible: true }
          //PROXY FAB FOR DETAIL PAGE
          fab               : { id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'CreateUpdateAllocationGroup:true', visible: true }
        },
        privileges: {
          list: 'GetAllocationGroupList',
          details: 'GetAllocationGroupDetails'
        }
      }
    };

    function getAllocationGroups(generalProperties, model, catalogCode) {
      if (angular.isDefined(model)) { // to skip this part for load lookup
        model.isBulkActionCompleted = false;
      }
      var promise;

      if (angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
        var state = {};
        state.name = $state.current.name;
        state.params = $state.params;
        var isBulk = true;
        var logData = activityLogger.createLogData(null, state, 'catalogs.allocationGroups', 'VIEW', isBulk, new Date(), null, null);

        promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/allocationgroups', undefined, true, generalProperties.forceFetch);
        promise = activityLogger.log(logData, promise);
      }
      else {
        catalogCode = angular.isUndefined(catalogCode) ? catalogFactory.getActiveCatalog().CatalogCode : catalogCode;
        promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/allocationgroups', undefined, true, generalProperties.forceFetch);
      }

      promise.then(function () {
        if (api.catalogs.allocationGroups.isDirty) {
          //Invalidate lookupData
          api.catalogs.allocationGroups.lookupData = undefined;
          api.catalogs.allocationGroups.isDirty = false;
        }
      });
      return promise;
    }

    function getAllocationGroup(isLogRequired, allocationGroupId, catalogCode) {
      var promise;
      if (angular.isDefined(isLogRequired) && isLogRequired === true) {
        var state = {};
        state.name = $state.current.name;
        state.params = $state.params;
        var isBulk = false;
        var items = [];
        promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/allocationgroups/' + allocationGroupId + '?status=0');
        promise.then(function (response) {
          items.push(response.data[api.catalogs.allocationGroups.lookupDisplayField]);
        }, function (response) {
          items.push(response.data[api.catalogs.allocationGroups.lookupDisplayField]);
        });
        var logData = activityLogger.createLogData(items, state, 'catalogs.allocationGroups', 'VIEW', isBulk, new Date(), null, null);
        promise = activityLogger.log(logData, promise);
      }
      else {
        promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/allocationgroups/' + allocationGroupId + '?status=0');
      }
      return promise;
    }

    function activateAllocationGroups(records, model, actionType, catalogCode) {
      var result = crud.createRequestObject(records, model, actionType);
      var state = {};
      state.name = $state.current.name;
      state.params = $state.params;
      var isBulk = result.itemsNameList.length > 1 ? true : false;
      var logData = activityLogger.createLogData(result.itemsNameList, state, 'catalogs.allocationGroups', actionType.toUpperCase(), isBulk, new Date(), null, null);
      var promise = api.webPut(api.baseUrl + '/catalogs/' + catalogCode + '/allocationgroups/status', result.requestObj);

      promise.then(function () {
        crud.onRecordStatusChange(records, api.catalogs.allocationGroups, actionType);
      });

      return activityLogger.log(logData, promise);
    }

    function updateAllocationGroup(record, catalogCode, actionType) {
      var state = {};
      state.name = $state.current.name;
      state.params = $state.params;
      var logData = activityLogger.createLogData(record[api.catalogs.allocationGroups.lookupDisplayField], state, 'catalogs.allocationGroups', actionType.toUpperCase(), false, new Date(), null, null);
      var promise = api.webPut(api.baseUrl + '/catalogs/' + catalogCode + '/allocationgroups', record);

      promise.then(function() {
          api.catalogs.allocationGroups.isDirty = true;
      });
      return activityLogger.log(logData, promise);
    }

    function createBulk(model, data, catalogCode) {
      var jobIndex = jobsTracker.addJob(model, 'ALLOCATION_GROUPS.ACTIONS.IMPORT', 1);
      var result = [];
      var allocationGroupsIndexes = {};
      angular.forEach(data, function (d) {
        var article = { ArticleNumber: d.ArticleNumber, Status: angular.isDefined(d.Status) ? d.Status : 1 };

        if (allocationGroupsIndexes[d.AllocationGroupName]) {
          result[allocationGroupsIndexes[d.AllocationGroupName]].Articles.push(article);
        }
        else {
          var transformedObj = {
            AllocationGroupName: d.AllocationGroupName,
            Articles: [article]
          };
          result.push(transformedObj);
          allocationGroupsIndexes[d.AllocationGroupName] = result.length - 1;
        }
      });
      api.webPut(api.baseUrl + '/catalogs/' + catalogCode + '/allocationgroupsbulk?sourceapplication=' + CONSTANTS.SOURCE_APPLICATION + '&sourceaction=Import Allocation Groups', result)
        .then(function (response) {
          jobsTracker.trackJob(jobIndex, response.data.Id);
        }).catch(function (error) {
          jobsTracker.setCriticlaFail(jobIndex, error);
        });
    }

  }
})();
(function() {
    'use strict';

    angular
        .module('app.main.attributes.attributes-list', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
        // State
        $stateProvider.state('app.attributes_list', {
            url    : '/attributes/list',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/attributes/attributes-list/list/attributes-list.html',
                    controller : 'attributesListController as vm'
                }
            },
            resolve: {

            },
            data : {
                displayName: 'ATTRIBUTES.NAV'
            },
            //only users with following accessPrivileges in their role access list can access this route
			// accessPrivileges: ['GetAttributeList']
            // accessPrivileges: ['nav_attributes']
            accessInfo: {
                accessPrivileges: ['nav_attributes']
            }
        });

        $stateProvider.state('app.attributes_list.details', {
			url	 : '/:id',
            params: {attributeTypeId: null},
            resolve: {
                attributeDetailsModel: function(api, $q, $stateParams, $localStorage, utility) {
                    var attributeTypesProxyGetList = function(currentValueId) {
                        return function(generalProperties) {
                            var result = {
                                data: []
                            };
                            return api.lists.attributeTypes.methods.getList(generalProperties)
                            .then(function(response) {
                                angular.forEach(response.data, function(record) {
                                    var valueLower = record.AttributeTypeName.toString().trim().toLowerCase();
                                    if(currentValueId ===  record.ID || valueLower == 'calc') {
                                        result.data.push(record);
                                    }
                                })
                                return result;
                            })
                        }
                    }
                    var modelCopy = angular.copy(api.getModel('attributes.attributes'));
                    var fields = utility.filterObject(modelCopy.fields, {field: 'InitialValueAttribute'});

                    var InitialValueAttributeField = {};
                    //dynamically change InitialValueAttributeField input type for create/update only to avoid creating custom dialog or creating new dataType across system
                    if(fields.length) {
                        InitialValueAttributeField = fields[0];
                        InitialValueAttributeField.inputType = 'custom-lookup';
                        InitialValueAttributeField.lookupSource = 'attributes.attributes';
                        InitialValueAttributeField.customLookupInfo = {value: 'AttributeSystemName'};
                    }

                    if($localStorage.account && $localStorage.account.accountType == '1') {
                        var attributeTypesProxyModel = api.getModel('lists.attributeTypesProxy');
                        delete attributeTypesProxyModel.lookupData; //clear previous lookup result if any
                        attributeTypesProxyModel.methods.getList = attributeTypesProxyGetList($stateParams.attributeTypeId);
                        var attributeTypeIdField = utility.filterObject(modelCopy.fields, {field: 'AttributeTypeId', inputType: 'lookup'})[0];
                        attributeTypeIdField.editable = true;
                        attributeTypeIdField.lookupSource = 'lists.attributeTypesProxy';
                    }
                    return $q.when(modelCopy)
                }
            },
            views: {
				'content@app': {
					templateUrl: 'app/main/attributes/attributes-list/details/attributes-details.html',
					controller : 'attributesDetailsController as vm'
				}
			},
			data: {
				parentState: 'app.attributes_list',
                displayName: 'ATTRIBUTES.TABS.ATTRIBUTE'
			},
            //only users with following accessPrivileges in their role access list can access this route
            // accessPrivileges: ['GetAttributeDetailsById']
            accessInfo: {
                accessPrivileges: ['GetAttributeDetailsById']
            }
		});

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/attributes/attributes-list');

        // Navigation
        msNavigationServiceProvider.saveItem('configuration.attributes', {
            title : 'Attributes',
            icon  : 'icon-android-studio',
            translate: 'ATTRIBUTES.NAV',
            weight: 20,
            // accessPrivileges: ['GetAttributeList', 'GetAttributeGroupList']
            // accessPrivileges: ['nav_attributes', 'nav_attribute_groups'],
            accessInfo: {
                accessPrivileges: ['nav_attributes', 'nav_attribute_groups']
            },
            visibleForLinePlan: true
        });

        msNavigationServiceProvider.saveItem('configuration.attributes.attributes-list', {
            title      : 'Attributes',
            icon       : 'icon-dice-1',
            state      : 'app.attributes_list',
            /*stateParams: {
                'param1': 'page'
            },*/
            translate  : 'ATTRIBUTES.NAV',
            weight     : 10,
            // accessPrivileges: ['GetAttributeList']
            // accessPrivileges: ['nav_attributes'],
            accessInfo: {
                accessPrivileges: ['nav_attributes']
            },
            visibleForLinePlan: true
        });
    }
})();
(function() {
    'use strict';
    angular
        .module('app.main.attributes.attributes-list')
        .controller('attributesListController', attributesListController);

    /* @ngInject */
	function attributesListController(api, $state, $document, $localStorage, settingsFactory, utility) {
		/* jshint validthis: true */
		var vm = this;

        //Data
		vm.model = api.attributes.attributes;
		settingsFactory.applyPersistedListViewLayout(vm.model);

		vm.attributes = [];
		vm.filteredAttributes = [];
		vm.isLoading = false;


        //Methods
		vm.refreshItems = refreshItems;
		vm.doItemAction = doItemAction;
		vm.viewItem = viewItem;
		vm.addRecord = addRecord;
		vm.editItem = editItem;

		activate();

		////////////////

		function activate() {
			refreshItems(vm.model.isDirty, true);
		}

		function refreshItems(forceFetch, isLogRequired) {
            var generalProperties = {
                forceFetch: forceFetch,
                isLogRequired: isLogRequired
            }
			vm.isLoading = true;

			vm.model.methods.getList(generalProperties)
			.then(function (response) {
				vm.attributes = response.data;
			})
			.finally(function () {
				vm.isLoading = false;
			});
		}

        //Item Action button pressed event
		function doItemAction(action, item) {
			if (action && item) {
				switch (action.id) {
					case 'view':
						viewItem(item);
						break;
					case 'edit':
						vm.model.methods.getDetails(true, item[vm.model.idField])
						.then(function (response) {
							editItem(response.data, null);
						})
						break;
				}
			}
		}

		function viewItem(item) {
			var stateParams = {id: item[vm.model.idField], attributeTypeId: item.AttributeTypeId};
			$state.go('app.attributes_list.details', stateParams);
		}

		function addRecord(ev) {
			var modelCopy = angular.copy(vm.model);
			var fields = utility.filterObject(modelCopy.fields, {field: 'InitialValueAttribute'});
			var InitialValueAttributeField = {};
			//dynamically change InitialValueAttributeField input type for create/update only to avoid creating custom dialog or creating new dataType across system
			if(fields.length) {
				InitialValueAttributeField = fields[0];
				InitialValueAttributeField.inputType = 'custom-lookup';
				InitialValueAttributeField.lookupSource = 'attributes.attributes';
				InitialValueAttributeField.customLookupInfo = {value: 'AttributeSystemName'};
			}
			var existingRecordsForUniqueValue = angular.copy(vm.attributes);
            api.showCreateRecordDialog(angular.element($document.body), ev, modelCopy, undefined, undefined, undefined, undefined, undefined, existingRecordsForUniqueValue)
            .then(function(saved) {
                if (saved) {
                    refreshItems(true);
                }
            });
		}

		function editItem(item, ev) {
			var modelCopy = angular.copy(vm.model);
			var fields = utility.filterObject(modelCopy.fields, {field: 'InitialValueAttribute'});
			var generalProperties = {
				forceFetch: false,
				isLogRequired: false
			}

			var InitialValueAttributeField = {};
			//dynamically change InitialValueAttributeField input type for create/update only to avoid creating custom dialog or creating new dataType across system
			if(fields.length) {
				InitialValueAttributeField = fields[0];
				InitialValueAttributeField.inputType = 'custom-lookup';
				InitialValueAttributeField.lookupSource = 'attributes.attributes';
				InitialValueAttributeField.customLookupInfo = {value: 'AttributeSystemName'};
			}

			if($localStorage.account && $localStorage.account.accountType == '1') {
				var attributeTypesProxyModel = api.getModel('lists.attributeTypesProxy');
				delete attributeTypesProxyModel.lookupData; //clear previous lookup result if any
				attributeTypesProxyModel.methods.getList = attributeTypesProxyGetList(item.AttributeTypeId);

				// there is a delay resolving API so delay in rendering attribute type
				attributeTypesProxyModel.methods.getList(generalProperties)
					.then(function(response) {
						var attributeTypeIdField = utility.filterObject(modelCopy.fields, { field: 'AttributeTypeId', inputType: 'lookup' })[0];
						attributeTypeIdField.editable = true;
						attributeTypeIdField.setValueForOtherProperties = { field: 'AttributeTypeId', value: 6, props: { Creatable: false, Editable: false } };
						attributeTypeIdField.lookupSource = 'lists.attributeTypesProxy';

						// Now call the dialog after API data is ready
						api.showEditRecordDialog(angular.element($document.body), ev, modelCopy, item)
							.then(function(saved) {
								if (saved) {
									refreshItems(true);
								}
							});
					});
			} else {
				api.showEditRecordDialog(angular.element($document.body), ev, modelCopy, item)
					.then(function(saved) {
						if (saved) {
							refreshItems(true);
						}
					});
			}
		}

		function attributeTypesProxyGetList(currentValueId) {
			return function(generalProperties) {
				var result = {
					data: []
				};
				return api.lists.attributeTypes.methods.getList(generalProperties)
					.then(function(response) {
						angular.forEach(response.data, function(record) {
							var valueLower = record.AttributeTypeName.toString().trim().toLowerCase();
							if (currentValueId === record.ID || valueLower == 'calc') {
								result.data.push(record);
							}
						});
						return result;
					});
			};
		}

	}

})();
(function() {
    'use strict';

    angular
        .module('app.main.attributes.attributes-list')
        .controller('attributesDetailsController', attributesDetailsController);

    /* @ngInject */
    function attributesDetailsController(api, $stateParams, $state, $rootScope, settingsFactory, attributeDetailsModel, utility, $localStorage, $document) {
        var vm = this;
        var attributeId = $stateParams.id;

        //Data
        vm.model = attributeDetailsModel;
        vm.attributeGroupsModel = api.attributes.attributeGroups;
        settingsFactory.applyPersistedListViewLayout(vm.attributeGroupsModel);

        vm.isLoading = false;
        vm.isAttributeGroupsLoading = false;
        vm.attribute = {};
        vm.attributeGroups = [];
        vm.filteredAttributeGroups = [];
        vm.showAtributeGroupsFilterRow = false;


        //Methods
        vm.refreshRecord = refreshRecord;
        vm.refreshAttributeGroups = refreshAttributeGroups;
        vm.editItem = editItem;

        activate();

        ////////////////

        function activate() {
            refreshRecord(true);
        }

        function refreshRecord(isLogRequired) {
            vm.isLoading = true;
            vm.isAttributeGroupsLoading = true;

            vm.model.methods.getDetails(isLogRequired, attributeId)
                .then(function (response) {
                    vm.attribute = response.data;
                    vm.title = angular.copy(vm.attribute[vm.model.lookupDisplayField]);

                    //Update Breadcrumb
                    $state.current.data.displayName = vm.title;
                    $rootScope.$broadcast('breadcrumb-updated');

                    refreshAttributeGroups(vm.attributeGroupsModel.isDirty, isLogRequired);
                })
                .finally(function () {
                    vm.isLoading = false;
                });
        }

        function refreshAttributeGroups(forceFetch, isLogRequired) {
            var generalProperties = {
                forceFetch: forceFetch,
                isLogRequired: isLogRequired
            }
            vm.isAttributeGroupsLoading = true;

            vm.attributeGroupsModel.methods.getListByEntity(generalProperties, attributeId)
                .then(function (response) {
                    vm.attributeGroups = response.data;
                })
                .finally(function() {
                    vm.isAttributeGroupsLoading = false;
                });
        }

        function editItem(item, ev) {
            var modelCopy = angular.copy(vm.model);
            var fields = utility.filterObject(modelCopy.fields, {field: 'InitialValueAttribute'});
            var generalProperties = {
                forceFetch: false,
                isLogRequired: false
            }

            var InitialValueAttributeField = {};
            //dynamically change InitialValueAttributeField input type for create/update only to avoid creating custom dialog or creating new dataType across system
            if(fields.length) {
                InitialValueAttributeField = fields[0];
                InitialValueAttributeField.inputType = 'custom-lookup';
                InitialValueAttributeField.lookupSource = 'attributes.attributes';
                InitialValueAttributeField.customLookupInfo = {value: 'AttributeSystemName'};
            }

            if($localStorage.account && $localStorage.account.accountType == '1') {
                var attributeTypesProxyModel = api.getModel('lists.attributeTypesProxy');
                delete attributeTypesProxyModel.lookupData; //clear previous lookup result if any
                attributeTypesProxyModel.methods.getList = attributeTypesProxyGetList(item.AttributeTypeId);

                // there is a delay resolving API so delay in rendering attribute type
                attributeTypesProxyModel.methods.getList(generalProperties)
                    .then(function(response) {
                        var attributeTypeIdField = utility.filterObject(modelCopy.fields, { field: 'AttributeTypeId', inputType: 'lookup' })[0];
                        attributeTypeIdField.editable = true;
                        attributeTypeIdField.setValueForOtherProperties = { field: 'AttributeTypeId', value: 6, props: { Creatable: false, Editable: false } };
                        attributeTypeIdField.lookupSource = 'lists.attributeTypesProxy';

                        // Now call the dialog after API data is ready
                        api.showEditRecordDialog(angular.element($document.body), ev, modelCopy, item)
                            .then(function(saved) {
                                if (saved) {
                                    refreshRecord(true);
                                }
                            });
                    });
            } else {
                api.showEditRecordDialog(angular.element($document.body), ev, modelCopy, item)
                    .then(function(saved) {
                        if (saved) {
                            refreshRecord(true);
                        }
                    });
            }
        }

        function attributeTypesProxyGetList(currentValueId) {
            return function(generalProperties) {
                var result = {
                    data: []
                };
                return api.lists.attributeTypes.methods.getList(generalProperties)
                    .then(function(response) {
                        angular.forEach(response.data, function(record) {
                            var valueLower = record.AttributeTypeName.toString().trim().toLowerCase();
                            if (currentValueId === record.ID || valueLower == 'calc') {
                                result.data.push(record);
                            }
                        });
                        return result;
                    });
            };
        }

    }
})();
(function() {
    'use strict';

    angular.module('app.main.attributes.attribute-groups',[])
    .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
        // State
        $stateProvider.state('app.attribute_groups', {
            url    : '/attributes/attribute-groups',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/attributes/attribute-groups/list/attribute-groups.html',
                    controller : 'attributeGroupsController as vm'
                }
            },
            resolve: {

            },
            data : {
                displayName: 'ATTRIBUTE_GROUPS.NAV'
            },
            //only users with following accessPrivileges in their role access list can access this route
			// accessPrivileges: ['GetAttributeGroupList']
            // accessPrivileges: ['nav_attribute_groups']
            accessInfo: {
                accessPrivileges: ['nav_attribute_groups']
            },
            visibleForLinePlan: true
        });

        $stateProvider.state('app.attribute_groups.details', {
			url	 : '/:id',
            views: {
				'content@app': {
					templateUrl: 'app/main/attributes/attribute-groups/details/attribute-group-details.html',
					controller : 'attributeGroupDetailsController as vm'
				}
			},
			data: {
				parentState: 'app.attribute_groups',
                displayName: 'ATTRIBUTE_GROUPS.TABS.ATTRIBUTE_GROUP'
			},
            //only users with following accessPrivileges in their role access list can access this route
            // accessPrivileges: ['GetAttributeGroupDetails']
            accessInfo: {
                accessPrivileges: ['GetAttributeGroupDetails']
            },
            visibleForLinePlan: true
		});

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/attributes/attribute-groups');

        // Navigation
        msNavigationServiceProvider.saveItem('configuration.attributes.attribute-groups', {
            title      : 'Attribute Groups',
            icon       : 'icon-bulletin-board',
            state      : 'app.attribute_groups',
            /*stateParams: {
                'param1': 'page'
            },*/
            translate  : 'ATTRIBUTE_GROUPS.NAV',
            weight     : 20,
            // accessPrivileges: ['GetAttributeGroupList'],
            // accessPrivileges: ['nav_attribute_groups'],
            accessInfo: {
                accessPrivileges: ['nav_attribute_groups']
            },
            visibleForLinePlan: true
        });
    }

})();
(function() {
    'use strict';
    angular.module('app.main.attributes.attribute-groups')
    .controller('attributeGroupsController', attributeGroupsController);

    /* @ngInject */
	function attributeGroupsController(api, $state, $document, settingsFactory) {
		/* jshint validthis: true */
		var vm = this;

        //Data
        vm.model = api.attributes.attributeGroups;
		settingsFactory.applyPersistedListViewLayout(vm.model);

		vm.attributeGroups = [];
		vm.filteredAttributeGroup = [];
		vm.isLoading = false;


        //Methods
		vm.refreshItems = refreshItems;
        vm.doItemAction = doItemAction;
		vm.viewItem = viewItem;
		vm.addRecord = addRecord;
		vm.editItem = editItem;


		activate();

		////////////////

		function activate() {
			refreshItems(vm.model.isDirty, true);
		}

		function refreshItems(forceFetch, isLogRequired) {
            var generalProperties = {
                forceFetch: forceFetch,
                isLogRequired: isLogRequired
            }
			vm.isLoading = true;

			vm.model.methods.getList(generalProperties)
			.then(function (response) {
				vm.attributeGroups = response.data;
			})
			.finally(function () {
				vm.isLoading = false;
			});
		}

		function doItemAction(action, item) {
			if (action && item) {
                switch (action.id) {
                    case 'view':
                        viewItem(item);
                        break;
                    case 'edit':
                        editItem(item, null);
                        break;
                }
			}
		}

		function viewItem(item) {
				var id = item[vm.model.idField];
				var stateParams = {id: id};
				$state.go('app.attribute_groups.details', stateParams);
		}

		function addRecord(ev) {
            api.showCreateRecordDialog(angular.element($document.body), ev, vm.model)
            .then(function(saved) {
                if (saved) {
                    refreshItems(true);
                }
            });
		}

		function editItem(item, ev) {
			var record = {};
			vm.model.methods.getDetails(false, item[vm.model.idField]).then(function(response) {
				record = response.data;
				record.AttributeidsList = response.data.ListAttributeResponse.map(function(record) {
					return record[api.attributes.attributes.idField];
				});
				delete record.ListAttributeResponse;
				api.showEditRecordDialog(angular.element($document.body), ev, vm.model, record).then(function(saved) {
					if (saved) {
						refreshItems(true);
					}
				});
			});
		}

	}
})();
(function() {
	'use strict';

	angular
		.module('app.main.attributes.attribute-groups')
		.controller('attributeGroupDetailsController', attributeGroupDetailsController);

	/* @ngInject */
	function attributeGroupDetailsController($document, api, $stateParams, $state, $rootScope, settingsFactory, utility) {
		 var vm = this;

		//Data
		vm.attributeId = $stateParams.id;
		vm.model = api.attributes.attributeGroups;
		vm.attListModel = api.attributes.attributes;
		settingsFactory.applyPersistedListViewLayout(vm.attListModel);

		vm.isLoading = false;
		vm.attributeGroup = {};
		vm.attributes = [];
		vm.filteredAttributes = [];
		vm.showAtributesFilterRow = false;

		//Methods
		vm.refreshRecord = refreshRecord;
		vm.doAttributesListItemAction = doAttributesListItemAction;
		vm.viewAttribute = viewAttribute;
		vm.editItem = editItem;

		activate();

		////////////////

		function activate() {
			refreshRecord(true);
		}

		function refreshRecord(isLogRequired) {
			vm.isLoading = true;

			vm.model.methods.getDetails(isLogRequired, vm.attributeId)
				.then(function (response) {
					vm.attributeGroup = response.data;
					vm.title = angular.copy(vm.attributeGroup[vm.model.lookupDisplayField]);

					//Update Breadcrumb
					$state.current.data.displayName = vm.title;
					$rootScope.$broadcast('breadcrumb-updated');

					vm.attributes = response.data.ListAttributeResponse;
				})
				.finally(function () {
					vm.isLoading = false;
				});
		}

		function doAttributesListItemAction(action, item) {
			if (action && item) {
				switch (action.id) {
					case "view":
						viewAttribute(item);
					break;
					case 'edit':
						editAttributeItem(item, null);
						break;
				}
			}
		}

		function viewAttribute(item) {
			var id = item[vm.attListModel.idField];
			$state.go('app.attributes_list.details', {id: id});
		}

		function editItem(item, ev) {
			var record = {};
			vm.model.methods.getDetails(false, item[vm.model.idField]).then(function(response) {
				record = response.data;
				record.AttributeidsList = response.data.ListAttributeResponse.map(function(record) {
					return record[api.attributes.attributes.idField];
				});
				delete record.ListAttributeResponse;
				api.showEditRecordDialog(angular.element($document.body), ev, vm.model, record).then(function(saved) {
					if (saved) {
						refreshRecord(false);
					}
				});
			});
		}

		function editAttributeItem(item, ev) {
			var modelCopy = angular.copy(vm.attListModel);
			var fields = utility.filterObject(modelCopy.fields, {field: 'InitialValueAttribute'});
			var InitialValueAttributeField = {};
			//dynamically change InitialValueAttributeField input type for create/update only to avoid creating custom dialog or creating new dataType across system
			if(fields.length) {
				InitialValueAttributeField = fields[0];
				InitialValueAttributeField.inputType = 'custom-lookup';
				InitialValueAttributeField.lookupSource = 'attributes.attributes';
				InitialValueAttributeField.customLookupInfo = {value: 'AttributeSystemName'};
			}
			api.showEditRecordDialog(angular.element($document.body), ev, modelCopy, item)
			.then(function(saved) {
				if (saved) {
					refreshRecord(false);
				}
			});
		}

		// function addRecord(ev){
		//     api.showCreateRecordDialog(angular.element($document.body), ev, vm.model)
		//     .then(function(saved) {
		//         if (saved) {
		//             refreshRecord();
		//         }
		//     });
		// }

	}
})();
(function() {
	'use strict';

	angular
				.module('app.main.catalogs.article-states', [
						'app.main.catalogs.article-states.state-required-attributes',
						'app.main.catalogs.article-states.state-non-editable-attributes',
				])
				.config(config);

				/* @ngInject */
				function config($stateProvider, msNavigationServiceProvider, $translatePartialLoaderProvider) {
						$stateProvider.state('app.article_states', {
								url    : '/article-states',
								views  : {
										'content@app': {
												templateUrl: 'app/main/article-states/list/article-states-lists.html',
												controller : 'articleStatesListController as vm'
										}
								},
								data: {
										displayName: 'ARTICLE_STATES.NAV'
								},
								resolve: {
								},
								// accessPrivileges: ['GetArticleStatesList']
								accessInfo: {
										accessPrivileges: ['nav_article_states']
								},
								visibleForLinePlan: true
						});
						$stateProvider.state('app.article_states_details', {
								url  : '/article-states/:id',
								views: {
										'content@app': {
												templateUrl: 'app/main/article-states/details/article-states-details.html',
												controller : 'articleStateDetailsController as vm'
										}
								},
								data : {
										displayName: 'ARTICLE_STATES.NAV'
								},
								// accessPrivileges: ['GetArticleStatesList']
								accessInfo: {
										accessPrivileges: ['nav_article_states']
								},
								visibleForLinePlan: true
						});

						// Translation
						$translatePartialLoaderProvider.addPart('app/main/article-states');

						// Navigation
						msNavigationServiceProvider.saveItem('main.article-states', {
								title      : 'Article States',
								icon       : 'icon-compare',
								state      : 'app.article_states',
								translate  : 'ARTICLE_STATES.NAV',
								weight     : 14.5,
								// accessPrivileges: ['GetArticleStatesList'],
								accessInfo: {
										accessPrivileges: ['nav_article_states']
								},
								visibleForLinePlan: true
						});
				}

})();
(function () {
	'use strict';

	angular
		.module('app.main.catalogs.article-states')
		.controller('addOrUpdateArticleStatesController', addOrUpdateArticleStatesController);

	/* @ngInject */
	function addOrUpdateArticleStatesController($mdDialog, $scope, $filter, toast, hotkeys, utility, record, isNew, model, existingRecordsForUniqueValue, lookupPromises, sellerId, attributeGroupId, api, event) {
		/* jshint validthis: true */
		var vm = this;

		//Data
		vm.isLoading = false;
		vm.isDataDirty = false;
		vm.isNew = isNew;
		vm.record = (angular.isDefined(record) && record != null) ? angular.copy(record) : {};
		vm.record.RequiredAttributes = [],
		vm.record.NonEditableAttributes = [];
		var sellerId = sellerId;
		var attributeGroupId = attributeGroupId;
		vm.searchText = [];
		vm.lookupModel = [];
		vm.acSelectedItem = [];
		vm.acSearchText = [];
		var assignedAttributesMap = {};
		var assignedRequiredAttributesMap = {};
		vm.existingRecordsForUniqueValue = existingRecordsForUniqueValue;
		vm.disableAssignFinalArticleModelNumber = false;
		vm.isLookupLoading = false;
		if(vm.isNew) {
			vm.record.IsSizeScaleEditable = 1;
			vm.record.IsModelNameEditable = 1;
		}


		//Methods
		vm.saveRecord = saveRecord;
		vm.closeDialog = closeDialog;

		vm.lookupSearch = lookupSearch;
		vm.lookupChange = lookupChange;
		vm.getLookupDisplayValue = getLookupDisplayValue;
		vm.selectText = selectText;
		vm.getDateObj = getDateObj;

		vm.acQuerySearch = acQuerySearch;
		vm.transformChip = transformChip;
		vm.getChipDisplayValue = getChipDisplayValue;
		vm.multiValueQuerySearch = multiValueQuerySearch;

		vm.stateRankChange = stateRankChange;


		activate();

		////////////////

		function activate() {
			if (!isNew) {
				populateEditDialog();
			}
			else {
				createEmptyrequiredAttributeRow();
				createEmptyNonEditableAttributeRow();
			}
			//Hotkeys
			hotkeys.bindTo($scope).add({
				combo: 'ctrl+enter',
				description: $filter('translate')('ACTIONS.SAVE'),
				allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
				callback: function (event) {
					if (!vm.isLoading && !vm.editForm.$invalid) {
						vm.saveRecord();
					}
				}
			});
		}

		function saveRecord() {
			vm.isLoading = true;
			// remove empty non editable attribute entry
			var nonEditableAttributes = [];
			angular.forEach(vm.record.NonEditableAttributes, function(attribute) {
				if(attribute.AttributeId != null) {
					nonEditableAttributes.push(attribute);
				}
			});
			vm.record.NonEditableAttributes = nonEditableAttributes;

			// remove empty required attribute entry and transform it to required form
			var requiredAttributes = [];
			angular.forEach(vm.record.RequiredAttributes, function(attribute) {
				if(attribute.RequiredAttributeId != null) {
					var deptAttribute = {
						AttributeId: attribute.RequiredAttributeId,
					}
					if(angular.isDefined(attribute.DependentAttributeSystemName) && attribute.DependentAttributeSystemName !== '') {
						deptAttribute['Criteria'] = {};
						deptAttribute['Criteria'][attribute.DependentAttributeSystemName] = angular.isArray(attribute.Value) ? attribute.Value : [attribute.Value];
						deptAttribute['Criteria'] = angular.toJson(deptAttribute.Criteria);
					}
					requiredAttributes.push(deptAttribute);
				}
			});
			vm.record.RequiredAttributes = requiredAttributes;

			var p;
			if (vm.isNew)
			{
					p = model.methods.create(vm.record, sellerId, attributeGroupId);
			} else {
					p = model.methods.update(vm.record.StateId, vm.record, sellerId, attributeGroupId);
			}

			p.then(function(response) {
					closeDialog(true);
					var toastMessage;
					toastMessage = response.config.method.toUpperCase() === 'POST' ? 'SUCCESS.CREATE': 'SUCCESS.UPDATE';
					toast.success(toastMessage, '', '');
			}, function() {
					closeDialog(vm.isDataDirty);
			}).finally(function () {
					vm.isLoading = false;
			});
		}

		function closeDialog(saved) {
			$mdDialog.hide(saved);
		}

		function lookupSearch(query, field, lookupSource, lookupFilter) {
			var results = [];
			var predicate = angular.isDefined(lookupFilter) ? angular.copy(lookupFilter) : {};
			predicate.value = query;
			var lookupModel = api.getModel(lookupSource);

			if (angular.isDefined(lookupModel.lookupData) && angular.isDefined(lookupModel.lookupData.data) && lookupModel.lookupData.data.length) {
				results = query ? utility.filterObject(lookupModel.lookupData.data, predicate) : utility.filterObject(lookupModel.lookupData.data, lookupFilter, true);
				var availableAttributes = [];
				if(field === 'AttributeId') {
					angular.forEach(results, function(attr) {
						if(!assignedAttributesMap[attr.id] && attr.AttributeTypeId !== 6) {
							availableAttributes.push(attr);
						}
					})
				} else if(field === 'RequiredAttributeId') {
					angular.forEach(results, function(attr) {
						if(!assignedRequiredAttributesMap[attr.id] && attr.AttributeTypeId !== 6) {
							availableAttributes.push(attr);
						}
					})
				} else {
					availableAttributes = results;
				}
				return availableAttributes;
			}
			else {
				return lookupPromises[field].then(function (lookupData) {
					results = query ? utility.filterObject(lookupData.data, predicate) : utility.filterObject(lookupData.data, lookupFilter, true);
					var availableAttributes = [];
					if(field === 'AttributeId') {
						angular.forEach(results, function(attr) {
							if(!assignedAttributesMap[attr.id] && attr.AttributeTypeId !== 6) {
								availableAttributes.push(attr);
							}
						})
					} else if(field === 'RequiredAttributeId') {
						angular.forEach(results, function(attr) {
							if(!assignedRequiredAttributesMap[attr.id] && attr.AttributeTypeId !== 6) {
								availableAttributes.push(attr);
							}
						})
					} else {
						availableAttributes = results;
					}
					return availableAttributes;
				});
			}
		}

		// convert dropdown scope value form object(lookup record) to id property of lookup record
		function lookupChange(selectedObj, field, rowIndex) {
			if (angular.isObject(selectedObj)) {
				if(field === 'AttributeId') {
					vm.record.NonEditableAttributes[rowIndex].AttributeId = selectedObj.id;
					assignedAttributesMap[selectedObj.id] = 1;
				} else if(field === 'RequiredAttributeId') {
					vm.record.RequiredAttributes[rowIndex].RequiredAttributeId = selectedObj.id;
					assignedRequiredAttributesMap[selectedObj.id] = 1;
				} else if(field === 'DependentAttributeId') { // dependent attribute
					var attribute = utility.changeAttributeType(selectedObj);
					vm.record.RequiredAttributes[rowIndex].inputType = attribute.inputType;
					vm.record.RequiredAttributes[rowIndex].DependentAttributeId = attribute.id;
					vm.record.RequiredAttributes[rowIndex].DependentAttributeSystemName = attribute.AttributeSystemName;
					vm.record.RequiredAttributes[rowIndex].allowedValues = attribute.values;
					vm.record.RequiredAttributes[rowIndex].Value = '';
					if(vm.record.RequiredAttributes[rowIndex].inputType === 'tags' || vm.record.RequiredAttributes[rowIndex].inputType === 'multi-value') {
						vm.record.RequiredAttributes[rowIndex].Value = [];
					}
				}
			}
			else if (angular.isUndefined(selectedObj) || selectedObj === null) {
				if(field === 'AttributeId') {
					delete assignedAttributesMap[vm.record.NonEditableAttributes[rowIndex].Id];
					vm.record.NonEditableAttributes[rowIndex].AttributeId = undefined;
				} else if(field === 'RequiredAttributeId') {
					delete assignedRequiredAttributesMap[vm.record.RequiredAttributes[rowIndex].Id];
					vm.record.RequiredAttributes[rowIndex].RequiredAttributeId = undefined;
					vm.record.RequiredAttributes[rowIndex].DependentAttributeId = undefined;
				} else if(field === 'DependentAttributeId') { // dependent attribute
					vm.record.RequiredAttributes[rowIndex].DependentAttributeId = undefined
					vm.record.RequiredAttributes[rowIndex].inputType = null;
					vm.record.RequiredAttributes[rowIndex].DependentAttributeSystemName = '';
					vm.record.RequiredAttributes[rowIndex].allowedValues = '';
					vm.record.RequiredAttributes[rowIndex].Value = '';
				}
			}
			// if adding data to last row and quantity is added create new row
			if(field === 'AttributeId' && rowIndex === vm.record.NonEditableAttributes.length-1) {
				createEmptyNonEditableAttributeRow();
			} else if(field === 'RequiredAttributeId' && rowIndex === vm.record.RequiredAttributes.length-1) {
				createEmptyrequiredAttributeRow();
			}
		}


		function getLookupDisplayValue(item, field, lookupSource) {
			var lookupModel = api.getModel(lookupSource);

			if (angular.isDefined(lookupModel.lookupData) && angular.isDefined(lookupModel.lookupData.data) && lookupModel.lookupData.data.length) {
				return getLookupDisplayVal(item, lookupModel.lookupData);
			}
			else {
				return lookupPromises[field].then(function (lookupData) {
					return getLookupDisplayVal(item, lookupData);
				});
			}
		}

		//helper method
		function getLookupDisplayVal(item, lookupData) {
			var result;
			if (lookupData) {
				// since autocomplte return object
				if (angular.isObject(item)) {
					result = utility.filterObject(lookupData.data, { id: item.id }, true);
				}
				// to initialize field value if any (when open update record dialog)
				else {
					result = utility.filterObject(lookupData.data, { id: item }, true);
				}

				if (angular.isArray(result) && result.length > 0) {
					return result[0].value;
				}
				else {
					return result.value;
				}
			}
		}

		function selectText(event) {
			utility.selectInputText(event);
		}

		function getDateObj(dateString, fromUTC) {
			if (dateString) {
				return utility.createDateObject(dateString, fromUTC);
			}
		}

		function transformChip(chip) {
			if (angular.isObject(chip)) {
				return chip.id;
			}
			return undefined;
		}

		function acQuerySearch(query, selectedRecords, fieldName) {
			var results = [];
			var field = utility.filterObject(model.fields, { field: fieldName }, true)[0];
			var lookupFilter = angular.isDefined(field.lookupFilter) ? field.lookupFilter : {};
			var predicate = angular.copy(lookupFilter);
			predicate.value = query;

			var lookupModel = api.getModel(field.lookupSource);
			if (angular.isDefined(lookupModel.lookupData) && angular.isDefined(lookupModel.lookupData.data) && lookupModel.lookupData.data.length) {
				results = query ? utility.filterObject(lookupModel.lookupData.data, predicate) : utility.filterObject(lookupModel.lookupData.data, lookupFilter);
				results = removeSelectedChips(selectedRecords, results);
				return results;
			}
			else {
				return lookupPromises[field.field].then(function (lookupData) {
					results = query ? utility.filterObject(lookupData.data, predicate) : utility.filterObject(lookupData.data, lookupFilter);
					results = removeSelectedChips(selectedRecords, results);
					return results;
				});
			}
		}

		/**
		 * @description
		 * This method will remove selected chips form records (helper method)
		 * @param {array} selectedRecords: list of selected chips
		 * @param {array} records: data property of lookup-data
		 * @returns {array}: list of available chips (chips which are not selected) // it does not really need to return a value but for readability returning modified value
		 */
		function removeSelectedChips(selectedRecords, records) {
			if (angular.isDefined(selectedRecords) && selectedRecords.length > 0) {
				for (var index = records.length - 1; index >= 0; index--) {
					if (selectedRecords.indexOf(records[index].id) !== -1) {
						records.splice(index, 1);
					}
				}
			}
			return records;
		}

		function getChipDisplayValue(chip, fieldName) {
			var field = utility.filterObject(model.fields, { field: fieldName }, true)[0];
			var lookupModel = api.getModel(field.lookupSource);
			if (angular.isDefined(lookupModel.lookupData) && angular.isDefined(lookupModel.lookupData.data) && lookupModel.lookupData.data.length) {
				return getChipDisplayVal(lookupModel.lookupData, chip);
			}
			else {
				return lookupPromises[field.field].then(function (lookupData) {
					return getChipDisplayVal(lookupData, chip);
				});
			}
		}

		function multiValueQuerySearch(query, selectedItems, field) {
			var values = field.values;
			var searchQueryResult = [];
			var searchQueryResult = utility.filterObject(values, query);
			if (selectedItems && selectedItems.length > 0) {
				for (var index = searchQueryResult.length - 1; index >= 0; index--) {
					if (selectedItems.indexOf(searchQueryResult[index]) !== -1) {
						searchQueryResult.splice(index, 1);
					}
				}
			}
			return searchQueryResult;
		}

		//helper method
		function getChipDisplayVal(lookupData, chip) {
			var res = utility.filterObject(lookupData.data, { id: chip }, true);
			if (angular.isArray(res) && res.length > 0) {
				return res[0].value;
			}
			else {
				$log.warn('viewCreator controller: Unable to resolve chip display value!');
				return "";
			}
		}

		function populateEditDialog() {
			angular.forEach(record.NonEditableAttributes, function(attribute) {
				var recordsLength = vm.record.NonEditableAttributes.push({ AttributeId: attribute.AttributeId, AllowChangeRequest: attribute.AllowChangeRequest});
				if(angular.isUndefined(vm.lookupModel[recordsLength-1])) {
					vm.lookupModel[recordsLength-1] = {};
				}
				vm.lookupModel[recordsLength-1].AttributeId = attribute.AttributeId;
				assignedAttributesMap[attribute.AttributeId] = 1;
			});
			lookupPromises['RequiredAttributes'].then(function (lookupData) {
				angular.forEach(record.RequiredAttributes, function(attribute) {
					var criteria = attribute.Criteria;
					var dependentAttributeId = null;
					var value = '';
					var inputType = 'textArea';
					if(criteria != null && criteria !== '' && criteria.length) {
						// call the required attributes lookup for edit
						// we need to get the dependent attributes ID from the list
						vm.isLookupLoading = true;
						var allowedValues = [];
						var dependentAttributeSystemName = '';
						try {
								var criteriaJSON = JSON.parse(criteria);
								for(var key in criteriaJSON) {
									var seasonlessAttribute = utility.filterObject(lookupData.data, {AttributeSystemName: key})[0];
									if(angular.isDefined(seasonlessAttribute)) {
										var seasonlessAttribute = utility.changeAttributeType(seasonlessAttribute);
										inputType = seasonlessAttribute.inputType;
										dependentAttributeId = seasonlessAttribute.id;
										allowedValues = seasonlessAttribute.values;
										dependentAttributeSystemName = seasonlessAttribute.AttributeSystemName;
										if(criteriaJSON.hasOwnProperty(key)) {
											if(inputType === 'multi-value' || inputType === 'tags') {
												value = criteriaJSON[key];
											} else {
												value = criteriaJSON[key][0]; // single value
											}
										}
									}
								}
						} catch(error) {
								console.warn("Criteria : Invalid JSON format");
						}
						var recordsLength = vm.record.RequiredAttributes.push({ RequiredAttributeId: attribute.AttributeId, DependentAttributeId: dependentAttributeId, Value: value, inputType: inputType, allowedValues: allowedValues, DependentAttributeSystemName:dependentAttributeSystemName});
						if(angular.isUndefined(vm.lookupModel[recordsLength-1])) {
							vm.lookupModel[recordsLength-1] = {};
						}
						vm.lookupModel[recordsLength-1].RequiredAttributeId = attribute.AttributeId;
						vm.lookupModel[recordsLength-1].DependentAttributeId = dependentAttributeId;
						assignedRequiredAttributesMap[attribute.AttributeId] = 1;
					} else {
						var recordsLength = vm.record.RequiredAttributes.push({ RequiredAttributeId: attribute.AttributeId, DependentAttributeId: dependentAttributeId, Value: value});
						if(angular.isUndefined(vm.lookupModel[recordsLength-1])) {
							vm.lookupModel[recordsLength-1] = {};
						}
						vm.lookupModel[recordsLength-1].RequiredAttributeId = attribute.AttributeId;
						vm.lookupModel[recordsLength-1].DependentAttributeId = dependentAttributeId;
						assignedRequiredAttributesMap[attribute.AttributeId] = 1;
					}
				});
				if(angular.isUndefined(vm.lookupModel)) {
					vm.lookupModel = {};
				}
				createEmptyNonEditableAttributeRow();
				createEmptyrequiredAttributeRow();
				vm.isLookupLoading = false;
			});
		}

		function createEmptyNonEditableAttributeRow() {
			vm.searchText.push({});
			vm.lookupModel.push({});
			vm.record.NonEditableAttributes.push({ AttributeId: null, AllowChangeRequest: 0});
		}

		function createEmptyrequiredAttributeRow() {
			vm.searchText.push({});
			vm.lookupModel.push({});
			vm.record.RequiredAttributes.push({ RequiredAttributeId: null, DependentAttributeId: null});
		}

		// find the lowest state with AssignFinalArticleModelNumber enabled and make the AssignFinalArticleModelNumber field enabled for all the new states whose rank is higher than this
		function stateRankChange() {
			var stateWithLowestRankAndAssignFinalArticleModelNumberEnabled = existingRecordsForUniqueValue.reduce(function(prev, current) {
				if(prev.AssignFinalArticleModelNumber && current.AssignFinalArticleModelNumber) {
					return (prev.StateRank < current.StateRank) ? prev : current;
				}
				return prev;
			});
			if(stateWithLowestRankAndAssignFinalArticleModelNumberEnabled.StateRank < vm.record.StateRank) {
				vm.record.AssignFinalArticleModelNumber = 1;
				vm.disableAssignFinalArticleModelNumber = true;
			} else {
				vm.record.AssignFinalArticleModelNumber = 0;
				vm.disableAssignFinalArticleModelNumber = false;
			}
		}

	}
})();
(function() {
	'use strict';

	angular
        .module('app.main.accounts.users', [
            'app.main.accounts.users.notifications',
            'app.main.accounts.users.catalog-access',
            'app.main.accounts.users.privacy-policy',
            'app.main.accounts.users.customers',
            'app.main.accounts.users.notification-types'
        ])
        .config(config);

        /* @ngInject */
        function config($stateProvider, msNavigationServiceProvider, $translatePartialLoaderProvider) {
            $stateProvider.state('app.accounts_users', {
                url    : '/accounts/users',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/accounts/users/list/users-list.html',
                        controller : 'usersListController as vm'
                    }
                },
                data: {
                    displayName: 'USERS.NAV'
                },
                resolve: {
                },
                // accessPrivileges: ['UI_AllUsersList']
                accessInfo: {
                    accessPrivileges: ['UI_AllUsersList']
                },
                visibleForLinePlan: true
            });
            $stateProvider.state('app.accounts_user_details', {
                url  : '/accounts/:account/:accountId/user/:id',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/accounts/users/details/user-details.html',
                        controller : 'userDetailsController as vm'
                    }
                },
                data : {
                    displayName: 'USERS.NAV'
                },
                // accessPrivileges: ['GetUserDetails']
                accessInfo: {
                    accessPrivileges: ['GetUserDetails']
                },
                visibleForLinePlan: true
            });

            // Translation
            $translatePartialLoaderProvider.addPart('app/main/accounts/users');

            // Navigation
            msNavigationServiceProvider.saveItem('main.users', {
                title      : 'Users',
                icon       : 'icon-account',
                state      : 'app.accounts_users',
                translate  : 'USERS.NAV',
                weight     : 7,
                // accessPrivileges: ['UI_AllUsersList'],
                accessInfo: {
                    accessPrivileges: ['UI_AllUsersList']
                },
                visibleForLinePlan: true
            });
        }

})();
(function() {
    'use strict';

	angular
		.module('app.main.accounts.users')
		.controller('usersListController', usersListController);

	/* @ngInject */
	function usersListController(api, $state, $document, $mdDialog, settingsFactory, crud, bulkUpdater, toast) {
		/* jshint validthis: true */
		var vm = this;

        vm.model = api.accounts.users;
        settingsFactory.applyPersistedListViewLayout(vm.model);

        vm.updateBulkUsersModel = api.accounts.updateBulkUsers;

		vm.users = [];
		vm.filteredUsers = [];
		vm.isLoading = false;


		vm.refreshItems = refreshItems;
		vm.doListAction = doListAction;
		vm.doItemAction = doItemAction;
		vm.viewItem = viewItem;

		activate();

		////////////////

		function activate() {
			refreshItems(vm.model.isDirty, true);
		}

		function refreshItems(forceFetch, isLogRequired) {
            var generalProperties = {
                forceFetch: forceFetch,
                isLogRequired: isLogRequired
            }
			vm.isLoading = true;

			vm.model.methods.getList(generalProperties)
			.then(function (response) {
				vm.users = response.data;
				api.setArticleAccountUsersList(response.data); // update the users list when ever there is change in users
			})
			.finally(function () {
				vm.isLoading = false;
			});
		}

		//Item Action button pressed event
		function doItemAction(action, record) {
			if (action && record) {
                switch (action.id) {
                    case 'view':
                        viewItem(record);
                        break;
                    case 'edit':
                        vm.model.methods.getDetails(true, record[vm.model.idField])
                        .then(function (response) {
                            editItem(response.data, null);
                        })
                        break;
                    case 'delete':
                    case 'activate':
                        vm.model.methods.activateBulk(record, vm.model, action.id);
                        break;
                    case 'assignNotificationTypes':
                        var modelCopy = angular.copy(vm.model);
                        // make creatable false to all fields except duneContext
                        angular.forEach(modelCopy.fields, function( field) {
                            if(field.field !== 'NotificationSubscribeTypes' && field.editable) {
                                field.editable = false;
                            } else if(field.field === 'NotificationSubscribeTypes') {
                                field.editable = true;
                            }
                        });
                        // change dialog title to "Assign Notification Types"
                        modelCopy.title = 'USERS.TITLES.NOTIFICATION_TYPES';
                        record.selected = true;
                        var lookupPromises = {};
                        lookupPromises = crud.createLookupPromise(modelCopy, undefined , 'edit');
                        bulkUpdater.showDialog(modelCopy, [record], null, lookupPromises)
                        .then(function(response) {
                            if(angular.isDefined(response) && response.toString() != 'false') {
                                vm.model.methods.assignNotificationTypes(response.selectedRecords, response.propertiesToUpdate).then(function() {
                                    toast.success('USERS.UPDATE_SUCCESS', '', '');
                                    refreshItems(true, false);
                                });
                            }
                        });
                }
			}
		}

        //List Action button pressed event
        function doListAction(action, records) {
            if (action) {
                switch (action.id) {
                    case 'delete':
                    case 'activate':
                        vm.model.methods.activateBulk(records, vm.model, action.id);
                        break;
                    case 'updateBulk':
                        var modelCopy = angular.copy(vm.updateBulkUsersModel);
                        var lookupPromises = {};
                        lookupPromises = crud.createLookupPromise(modelCopy, undefined , 'edit');
                        bulkUpdater.showDialog(modelCopy, vm.users, null, lookupPromises)
                            .then(function(response) {
                                if(angular.isDefined(response) && response.toString() != 'false') {
                                    vm.model.methods.updateBulk(response.selectedRecords, response.propertiesToUpdate).then(function() {
                                        toast.success('USERS.UPDATE_SUCCESS', '', '');
                                        refreshItems(true, false);
                                    })
                                }
                            });
                        break;
                    case 'assignNotificationTypes':
                        var modelCopy = angular.copy(vm.model);
                        // make creatable false to all fields except duneContext
                        angular.forEach(modelCopy.fields, function( field) {
                            if(field.field !== 'NotificationSubscribeTypes' && field.editable) {
                                field.editable = false;
                            } else if(field.field === 'NotificationSubscribeTypes') {
                                field.editable = true;
                            }
                        });
                        // change dialog title to "Assign Notification Types"
                        modelCopy.title = 'USERS.TITLES.NOTIFICATION_TYPES';
                        var lookupPromises = {};
                        lookupPromises = crud.createLookupPromise(modelCopy, undefined , 'edit');
                        bulkUpdater.showDialog(modelCopy, vm.users, null, lookupPromises)
                        .then(function(response) {
                            if(angular.isDefined(response) && response.toString() != 'false') {
                                vm.model.methods.assignNotificationTypes(response.selectedRecords, response.propertiesToUpdate).then(function() {
                                    toast.success('USERS.UPDATE_SUCCESS', '', '');
                                    refreshItems(true, false);
                                });
                            }
                        });
                        break;
                    case 'changeAccount':
                        $mdDialog.show({
                            controller: 'changeAccountController',
                            controllerAs: 'vm',
                            templateUrl: 'app/main/accounts/users/list/dialogs/change-user-account/change-user-account.html',
                            parent: angular.element($document.body),
                            targetEvent: null,
                            clickOutsideToClose: false,
                            locals: {
                                model: vm.model,
                                selectedRecords: records,
                                event: null
                            }
                        }).then(function (saved) {
                            if (saved) {
                                refreshItems(true, false);
                            }
                        });
                        break;
                }
            }
        }

         function viewItem(record) {
            var id = record[vm.model.idField];
            var account = 'trasix';
            if(record.AccountTypeId === 1) {
                account = 'trasix';
            }
            else if(record.AccountTypeId === 2) {
                account = 'sellers'
            }
            else if(record.AccountTypeId === 3) {
                account = 'buyers'
            }
            var stateParams = {account: account, accountId: record['AccountId'], id:id};
            $state.go('app.accounts_user_details', stateParams);
		}

		function editItem(record, ev) {
            var lookupPromises = {};
            lookupPromises = crud.createLookupPromise(vm.model, undefined , 'edit');
            $mdDialog.show({
                controller         : 'updateUserController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/accounts/users/list/dialogs/update-user/update-user.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: false,
                locals             : {
                    model: vm.model,
                    record: record,
                    isNew: false,
                    lookupPromises: lookupPromises,
                    event: ev
                }
            }).then(function(saved) {
                if (saved) {
                    refreshItems(true, false);
                }
            });
		}
	}
})();
(function() {
    'use strict';

    angular
        .module('app.main.accounts.users')
        .controller('userDetailsController', userDetailsController);

    /* @ngInject */
    function userDetailsController(api, $stateParams, $state, $rootScope, dialog, settingsFactory, $document, $mdDialog, utility, SecurityFactory, CONSTANTS, crud) {
        /* jshint validthis: true */
        var vm = this;
        var accountId = $stateParams.accountId;
        var userId = $stateParams.id;
        vm.account = $stateParams.account;

        vm.model = api.accounts.users;

        vm.notificationModel = api.users.notifications;
        settingsFactory.applyPersistedListViewLayout(vm.notificationModel);

        vm.catalogAccessModel = api.users.catalogAccess;
        settingsFactory.applyPersistedListViewLayout(vm.catalogAccessModel);

        vm.privacyPolicyModel = api.users.privacyPolicy;
        settingsFactory.applyPersistedListViewLayout(vm.privacyPolicyModel);

        vm.customersModel = api.users.customers;
        settingsFactory.applyPersistedListViewLayout(vm.customersModel);

        vm.notificationTypesModel = api.users.notificationTypes;
        settingsFactory.applyPersistedListViewLayout(vm.notificationTypesModel);

        vm.user = {};

        vm.notifications = [];
        vm.filteredNotifications = [];

        vm.catalogAccess = [];
        vm.filteredCatalogAccess = [];

        vm.privacyPolicy = [];
        vm.filteredPrivacyPolicy = [];

        vm.customers = [];
        vm.filteredCustomers = [];

        vm.notificationTypes = [];
        vm.filteredNotificationTypes = [];

        vm.isLoading = false;
        vm.isNotificationsLoading = false;
        vm.isCatalogAccessLoading = false;
        vm.isPrivacyPolicyLoading = false;
        vm.isCustomersLoading = false;

        var isTabDataInitialized = false;
        vm.refreshRecord = refreshRecord;
        vm.refreshNotifications = refreshNotifications;
        vm.refreshCatalogAccess = refreshCatalogAccess;
        vm.refreshPrivacyPolicy = refreshPrivacyPolicy;
        vm.refreshCustomers = refreshCustomers;
        vm.doItemAction = doItemAction;
        vm.editUser = editUser;

        vm.doNotificationsItemAction = doNotificationsItemAction;
        vm.viewNotification = viewNotification;

        vm.doCatalogAccessItemAction = doCatalogAccessItemAction;
        vm.doCatalogAccessListAction = doCatalogAccessListAction;
        vm.linkCatalogs = linkCatalogs;

        vm.doCustomersItemAction = doCustomersItemAction;
        vm.doCustomersListAction = doCustomersListAction;
        vm.linkCustomers = linkCustomers;

        vm.assignNotificationTypes = assignNotificationTypes;

        activate();

        ////////////////

        function activate() {
            refreshRecord(true);
        }

        function refreshRecord(isLogRequired) {
            vm.isLoading = true;

            vm.model.methods.getDetails(isLogRequired, userId)
                .then(function (response) {
                    vm.user = response.data;
                    var restrictFullRangeField = utility.filterObject(vm.model.fields, {field: 'RestrictFullRange'}, true)[0];
                    if(vm.user.AccountTypeId === 2){ // restrict full range is visible only for seller user
                        restrictFullRangeField.visible = true;
                    } else {
                        restrictFullRangeField.visible = false;
                    }
                    vm.notificationTypes = vm.user.NotificationSubscribeTypes;
                    // Add typeIds as the records notification types and API is sending the notification object
                    vm.user.NotificationSubscribeTypes = [];
                    vm.user.NotificationSubscribeTypes = vm.notificationTypes.map(function(record) {
                        var notificationTypeId = record['TypeId'];
                        return notificationTypeId;
                    });
                    vm.title = angular.copy(vm.user.FirstName).concat(' ' + angular.copy(vm.user.LastName));

                    initializedTabData(isLogRequired, vm.user);

                    //Update Breadcrumb
                    $state.current.data.displayName = 'User: ' + vm.title; //TODO: need to review the route of this view
                    $rootScope.$broadcast('breadcrumb-updated');
                })
                .finally(function () {
                    vm.isLoading = false;
                });
        }

        function refreshNotifications(forceFetch, isLogRequired) {
            var generalProperties = {
                forceFetch: forceFetch,
                isLogRequired: isLogRequired
            }
            vm.isNotificationsLoading = true;

            vm.notificationModel.methods.getList(generalProperties, userId)
                .then(function (response) {
                    vm.notifications = response.data;
                })
                .finally(function () {
                    vm.isNotificationsLoading = false;
                });

        }

        function refreshCatalogAccess(forceFetch, isLogRequired) {
            var generalProperties = {
                forceFetch: forceFetch,
                isLogRequired: isLogRequired
            }
            vm.isCatalogAccessLoading = true;

            vm.catalogAccessModel.methods.getList(generalProperties, accountId, userId)
                .then(function (response) {
                    vm.catalogAccess = utility.filterObject(response.data, {Status: 1});
                })
                .finally(function () {
                    vm.isCatalogAccessLoading = false;
                });
        }

        function refreshPrivacyPolicy (forceFetch, isLogRequired){
            var generalProperties = {
                forceFetch: forceFetch,
                isLogRequired: isLogRequired
            }
            vm.isPrivacyPolicyLoading = true;

            vm.privacyPolicyModel.methods.getList(generalProperties, accountId, userId)
                .then(function (response) {
                    vm.privacyPolicy = response.data;
                })
                .finally(function () {
                    vm.isPrivacyPolicyLoading = false;
                });
        }

        function refreshCustomers(forceFetch, isLogRequired) {
            var generalProperties = {
                forceFetch: forceFetch,
                isLogRequired: isLogRequired
            }
            vm.isCustomersLoading = true;

            vm.customersModel.methods.getList(generalProperties, accountId, userId, vm.customersModel)
                .then(function (response) {
                    vm.customers = response.data; // as discussed will display all the linked customers irrespective of there status
                })
                .finally(function () {
                    vm.isCustomersLoading = false;
                });
        }

        // opens the same edit dialog as the users list view, so that fields like roles are filtered on the user's account type
        function editUser(ev, record) {
            var lookupPromises = crud.createLookupPromise(vm.model, undefined, 'edit');
            $mdDialog.show({
                controller         : 'updateUserController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/accounts/users/list/dialogs/update-user/update-user.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: false,
                locals             : {
                    model: vm.model,
                    record: record,
                    isNew: false,
                    lookupPromises: lookupPromises,
                    event: ev
                }
            }).then(function(saved) {
                if (saved) {
                    refreshRecord(false);
                }
            });
        }

        function doItemAction(action, record) {
            if (action) {
                switch (action.id) {
                    case 'delete':
					case 'activate':
                        vm.model.methods.activateBulk(record, vm.model, action.id, accountId)
                        .then(function() {
                            if(!isTabDataInitialized && action.id == 'activate') {
                                initializedTabData(false, record);
                            }
                        });
                    break;
                case 'assignNotificationTypes':
                    vm.model.methods.activateBulk(record, vm.model, action.id);
                    break;
                }
            }
        }

        function doNotificationsItemAction(action, record) {
            if (action) {
                switch (action.id) {
                    case 'view':
                        viewNotification(record);
					break;
                }
            }
        }

        function doCatalogAccessItemAction(action, record) {
            if (action) {
                switch (action.id) {
                    case 'delete':
                        vm.catalogAccessModel.methods.activateBulk(record, vm.catalogAccessModel, action.id, accountId, userId)
                            .then(function() {
                                refreshCatalogAccess(true, false);
                            });
                        break;
                }
            }
        }

        function doCatalogAccessListAction(action, records) {
            if (action) {
                switch (action.id) {
                    case 'delete':
                        vm.catalogAccessModel.methods.activateBulk(records, vm.catalogAccessModel, action.id, accountId, userId)
                        .then(function() {
                            refreshCatalogAccess(true, false);
                        });
                        break;

                }
            }
        }

        function linkCatalogs(ev) {
            $mdDialog.show({
                controller         : 'assignCatalogToSellerUserController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/accounts/users/details/tabs/catalog-access/dialogs/assign-catalogs-to-user.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: false,
                locals             : {
                    model: vm.catalogAccessModel,
                    assignedCatalogs: vm.catalogAccess,
                    accountId: accountId,
                    userId: userId,
                    event: ev
                }
            }).then(function(saved) {
                if (saved) {
                    refreshCatalogAccess(true, false);
                }
            });
        }

        function doCustomersItemAction(action, record) {
            if (action) {
                switch (action.id) {
                    case 'delete':
                    case 'activate':
                        vm.customersModel.methods.activateBulk(record, vm.customersModel, action.id, accountId, userId)
                            .then(function () {
                                refreshCustomers(true, false);
                            });
                        break;
                }
            }
        }

        function doCustomersListAction(action, records) {
            if (action) {
                switch (action.id) {
                    case 'delete':
                    case 'activate':
                        vm.customersModel.methods.activateBulk(records, vm.customersModel, action.id, accountId, userId)
                            .then(function () {
                                refreshCustomers(true, false);
                            });
                        break;
                }
            }
        }

        function linkCustomers(ev) {
            api.showCreateRecordDialog(angular.element($document.body), ev, vm.customersModel, {'buyerId': accountId, 'userId':userId})
                .then(function (saved) {
                    if (saved) {
                        refreshCustomers(true, false);
                    }
                });
        }

        function assignNotificationTypes(ev) {
            // add assigned notification type id's to NotificationTypeIdsList
            var record = {};
            var activeNotificationTypes= utility.filterObject(vm.notificationTypes, {'Status': 1}, true);

            record.NotificationTypeIdsList = activeNotificationTypes.map(function(record) {
                var notificationTypeId = record['TypeId'];
                return notificationTypeId;
            });
            api.showEditRecordDialog(angular.element($document.body), ev, vm.notificationTypesModel, record, parseInt(userId))
            .then(function(saved) {
                if (saved) {
                    refreshRecord(true, false);
                }
            });
        }

        function viewNotification(record) {
            var id = record[vm.notificationModel.idField];
            var stateParams = { id: id };
            $state.go('app.notifications.details', stateParams);
        }

        function initializedTabData(isLogRequired, user) {
            if (vm.user.Status !== 0) {
                isTabDataInitialized = true;
                if (SecurityFactory.isAuthorized({accessPrivileges: CONSTANTS.PRIVILEGES.USERS.DETAIL.NOTIFICATIONS_LIST})) {
                    refreshNotifications(true, isLogRequired);
                }
                if (SecurityFactory.isAuthorized({accessPrivileges: CONSTANTS.PRIVILEGES.USERS.DETAIL.CATALOG_ACCESS_LIST})
                    && user.AccountTypeId === 2) {
                    refreshCatalogAccess(true, isLogRequired);
                }
                if (SecurityFactory.isAuthorized({accessPrivileges: CONSTANTS.PRIVILEGES.USERS.DETAIL.PRIVACY_POLICY_LIST})
                    && user.AccountTypeId !== 1) {
                    refreshPrivacyPolicy(true, isLogRequired);
                }
                if (SecurityFactory.isAuthorized({accessPrivileges: CONSTANTS.PRIVILEGES.USERS.DETAIL.CUSTOMERS_LIST})
                    && user.AccountTypeId === 3) {
                    refreshCustomers(true, isLogRequired);
                }
            }
        }

    }
})();
(function() {
	'use strict';

	angular
        .module('app.main.accounts.user-groups', [
            'app.main.accounts.user-groups.user-group-users'
        ])
        .config(config);

        /* @ngInject */
        function config($stateProvider, msNavigationServiceProvider, $translatePartialLoaderProvider) {
            $stateProvider.state('app.accounts_user_groups', {
                url    : '/accounts/user-groups',
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/accounts/user-groups/list/user-groups-lists.html',
                        controller : 'userGroupsListController as vm'
                    }
                },
                data: {
                    displayName: 'USER_GROUPS.NAV'
                },
                resolve: {
                },
                // accessPrivileges: ['GetAccountGroups']
                accessInfo: {
                    accessPrivileges: ['nav_user_groups']
                },
                visibleForLinePlan: true
            });
            $stateProvider.state('app.accounts_user_groups_details', {
                url  : '/accounts/user-groups/:id',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/accounts/user-groups/details/user-groups-details.html',
                        controller : 'userGroupDetailsController as vm'
                    }
                },
                data : {
                    displayName: 'USER_GROUPS.NAV'
                },
                // accessPrivileges: ['GetAccountGroupDetails']
                accessInfo: {
                    accessPrivileges: ['nav_user_groups']
                },
                visibleForLinePlan: true
            });

            // Translation
            $translatePartialLoaderProvider.addPart('app/main/accounts/user-groups');

            // Navigation
            msNavigationServiceProvider.saveItem('main.user-groups', {
                title      : 'User Groups',
                icon       : 'icon-account-multiple',
                state      : 'app.accounts_user_groups',
                translate  : 'USER_GROUPS.NAV',
                weight     : 8,
                // accessPrivileges: ['GetAccountGroups'],
                accessInfo: {
                    accessPrivileges: ['nav_user_groups']
                },
                visibleForLinePlan: true
            });
        }

})();
(function () {
	'use strict';

	angular
		.module('app.main.accounts.user-groups')
		.controller('userGroupsListController', userGroupsListController);

	/* @ngInject */
	function userGroupsListController(api, $state, $document, $mdDialog, settingsFactory, crud, bulkUpdater, toast) {
		/* jshint validthis: true */
		var vm = this;

		vm.model = api.accounts.userGroups;
		settingsFactory.applyPersistedListViewLayout(vm.model);

		vm.updateBulkUsersModel = api.accounts.updateBulkUsers;

		vm.userGroups = [];
		vm.filteredUserGroups = [];
		vm.isLoading = false;


		vm.refreshItems = refreshItems;
		vm.doListAction = doListAction;
		vm.doItemAction = doItemAction;
		vm.viewItem = viewItem;
		vm.addRecord = addRecord;

		activate();

		////////////////

		function activate() {
			refreshItems(vm.model.isDirty, true);
		}

		function refreshItems(forceFetch, isLogRequired) {
			var generalProperties = {
				forceFetch: forceFetch,
				isLogRequired: isLogRequired
			}
			vm.isLoading = true;

			vm.model.methods.getList(generalProperties)
				.then(function (response) {
					vm.userGroups = response.data;
					angular.forEach(vm.userGroups, function(group) {
						group.Criteria = group.Criteria != null && group.Criteria !== '' ? group.Criteria.split(',') : group.Criteria;
						group.Actions = group.Actions != null && group.Actions !== '' ? group.Actions.split(',') : group.Actions;
					});
				})
				.finally(function () {
					vm.isLoading = false;
				});
		}

		//Item Action button pressed event
		function doItemAction(action, record) {
			if (action && record) {
				switch (action.id) {
					case 'view':
						viewItem(record);
						break;
					case 'edit':
						vm.model.methods.getDetails(true, record[vm.model.idField])
						.then(function (response) {
								editItem(response.data, null);
						})
						break;
					case 'delete':
					case 'activate':
						vm.model.methods.activateBulk(record, vm.model, action.id);
						break;
				}
			}
		}

		//List Action button pressed event
		function doListAction(action, records) {
			if (action) {
				switch (action.id) {
					case 'delete':
					case 'activate':
						vm.model.methods.activateBulk(records, vm.model, action.id);
						break;
				}
			}
		}

		function viewItem(record) {
			var id = record[vm.model.idField];
			var stateParams = { id: id };
			$state.go('app.accounts_user_groups_details', stateParams);
		}

		function addRecord(ev) {
			var lookupPromises = {};
			lookupPromises = crud.createLookupPromise(vm.model, undefined, 'create');
			$mdDialog.show({
				controller: 'updateUserGroupsController',
				controllerAs: 'vm',
				templateUrl: 'app/main/accounts/user-groups/list/dialogs/update-user-groups/update-user-groups.html',
				parent: angular.element($document.body),
				targetEvent: ev,
				clickOutsideToClose: false,
				locals: {
					model: vm.model,
					record: null,
					isNew: true,
					existingRecordsForUniqueValue: angular.copy(vm.userGroups),
					lookupPromises: lookupPromises,
					event: ev
				}
			}).then(function (saved) {
				if (saved) {
					refreshItems(true, false);
				}
			});
		}

		function editItem(record, ev) {
			var lookupPromises = {};
			lookupPromises = crud.createLookupPromise(vm.model, undefined, 'edit');
			var existingRecordsForUniqueValue = angular.copy(vm.userGroups);
			for (var i = 0; i < existingRecordsForUniqueValue.length; i++) {
				if (existingRecordsForUniqueValue[i].Id === record.Id) {
					existingRecordsForUniqueValue.splice(i, 1);
				}
			}
			$mdDialog.show({
				controller: 'updateUserGroupsController',
				controllerAs: 'vm',
				templateUrl: 'app/main/accounts/user-groups/list/dialogs/update-user-groups/update-user-groups.html',
				parent: angular.element($document.body),
				targetEvent: ev,
				clickOutsideToClose: false,
				locals: {
					model: vm.model,
					record: record,
					isNew: false,
					existingRecordsForUniqueValue: existingRecordsForUniqueValue,
					lookupPromises: lookupPromises,
					event: ev
				}
			}).then(function (saved) {
				if (saved) {
					refreshItems(true, false);
				}
			});
		}
	}
})();
(function() {
    'use strict';

    angular
        .module('app.main.accounts.user-groups')
        .controller('userGroupDetailsController', userGroupDetailsController);

    /* @ngInject */
    function userGroupDetailsController(api, $stateParams, $state, $rootScope, crud, settingsFactory, $document, $mdDialog, utility, SecurityFactory, CONSTANTS) {
        /* jshint validthis: true */
        var vm = this;
        var userGroupId = $stateParams.id;

        vm.model = api.accounts.userGroups;

        vm.userGroupUsersModel = api.userGroups.userGroupUsers;
        settingsFactory.applyPersistedListViewLayout(vm.userGroupUsersModel);

        vm.userGroup = {};

        vm.userGroupUsers = [];
        vm.filteredUserGroupUsers = [];

        vm.isLoading = false;

        vm.refreshRecord = refreshRecord;
        vm.doItemAction = doItemAction;
        vm.assignUsers = assignUsers;
        vm.editItem = editItem;

        activate();

        ////////////////

        function activate() {
            refreshRecord(true);
        }

        function refreshRecord(isLogRequired) {
            vm.isLoading = true;

            vm.model.methods.getDetails(isLogRequired, userGroupId)
                .then(function (response) {
                    vm.userGroup = response.data;
                    vm.userGroup.Criteria = vm.userGroup.Criteria != null && vm.userGroup.Criteria !== '' ? vm.userGroup.Criteria.split(',') : vm.userGroup.Criteria;
                    vm.userGroup.Actions = vm.userGroup.Actions != null && vm.userGroup.Actions !== '' ? vm.userGroup.Actions.split(',') : vm.userGroup.Actions;

                    vm.userGroupUsers = vm.userGroup.Users;
                    vm.title = angular.copy(vm.userGroup[vm.model.lookupDisplayField]);

                    //Update Breadcrumb
                    $state.current.data.displayName = vm.title;
                    $rootScope.$broadcast('breadcrumb-updated');
                })
                .finally(function () {
                    vm.isLoading = false;
                });
        }

        function doItemAction(action, record) {
            if (action) {
                switch (action.id) {
                    case 'delete':
                    case 'activate':
                        vm.model.methods.activateBulk(record, vm.model, action.id, userGroupId);
                    break;
                }
            }
        }

        function assignUsers(ev) {
            // add assigned User id's to Users
            var record = {};
            var activeUsers= utility.filterObject(vm.userGroupUsers, {'Status': 1}, true);

            record.Users = activeUsers.map(function(record) {
                var userId = record['UserId'];
                return userId;
            });
            //lookupFilter
            var usersField = utility.filterObject(vm.userGroupUsersModel.fields, {field: 'Users'}, true)[0];
            usersField.lookupFilter['AccountId'] = vm.userGroup.AccountId;
            api.showEditRecordDialog(angular.element($document.body), ev, vm.userGroupUsersModel, record, parseInt(userGroupId))
            .then(function(saved) {
                if (saved) {
                    refreshRecord(true, false);
                }
            });
        }

        function editItem(record, ev) {
            var lookupPromises = {};
            lookupPromises = crud.createLookupPromise(vm.model, undefined, 'edit');

            // Fetch all user groups to build the uniqueness check list, excluding the current record
            vm.model.methods.getList({ forceFetch: false, isLogRequired: false })
                .then(function (response) {
                    var allUserGroups = response.data || [];
                    var existingRecordsForUniqueValue = [];
                    for (var i = 0; i < allUserGroups.length; i++) {
                        if (allUserGroups[i].Id !== record.Id) {
                            existingRecordsForUniqueValue.push(allUserGroups[i]);
                        }
                    }

                    return $mdDialog.show({
                        controller: 'updateUserGroupsController',
                        controllerAs: 'vm',
                        templateUrl: 'app/main/accounts/user-groups/list/dialogs/update-user-groups/update-user-groups.html',
                        parent: angular.element($document.body),
                        targetEvent: ev,
                        clickOutsideToClose: false,
                        locals: {
                            model: vm.model,
                            record: record,
                            isNew: false,
                            existingRecordsForUniqueValue: existingRecordsForUniqueValue,
                            lookupPromises: lookupPromises,
                            event: ev
                        }
                    });
                }).then(function (saved) {
                    if (saved) {
                        refreshRecord(true, false);
                    }
                });
        }
    }

})();
(function() {
    'use strict';

    angular
        .module('app.main.accounts.sellers', [
            'app.main.accounts.sellers.users',
            'app.main.accounts.sellers.catalogs',
            'app.main.accounts.sellers.resource-types',
            'app.main.accounts.sellers.vas',
            'app.main.accounts.sellers.order-types',
            'app.main.accounts.sellers.size-scale-groups',
            'app.main.accounts.sellers.seasonless-attributes',
            'app.main.accounts.sellers.seasonless-model-attributes',
            'app.main.accounts.sellers.article-drop-reasons',
            'app.main.accounts.sellers.master-size-scales',
            'app.main.accounts.sellers.seller-lookup-table',
            'app.main.accounts.sellers.seller-configurations',
            'app.main.accounts.sellers.seller-colors',
            'app.main.accounts.sellers.seller-datasets',
            'app.main.accounts.sellers.seller-resources',
            'app.main.accounts.sellers.capacities',
            'app.main.accounts.sellers.design-option-attributes'
        ])
        .config(config);

    /* @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {

        $stateProvider.state('app.accounts_sellers', {
            url    : '/accounts/sellers',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/accounts/sellers/list/sellers-list.html',
                    controller : 'sellersListController as vm'
                }
            },
            data: {
                displayName: 'SELLERS.NAV'
            },
            resolve: {
            },
			// accessPrivileges: ['GetSellerAccountList']
            // accessPrivileges: ['nav_sellers']
            accessInfo: {
                accessPrivileges: ['nav_sellers']
            },
            visibleForLinePlan: true
        });

        $stateProvider.state('app.accounts_sellers.details', {
			url	 : '/:id',
            views: {
				'content@app': {
					templateUrl: 'app/main/accounts/sellers/details/sellers-details.html',
					controller : 'sellerDetailsController as vm'
				}
			},
			data: {
                displayName: 'SELLERS.TABS.SELLER',
				parentState: 'app.accounts_sellers'
			},
            resolve: {
            },
            // accessPrivileges: ['GetSellerAccountDetails']
            accessInfo: {
                accessPrivileges: ['GetSellerAccountDetails']
            },
            visibleForLinePlan: true
		});

        // lookup table details
        $stateProvider.state('app.lookup_table_details', {
            url  : '/sellerId/:sellerId/id/:id',
            params: {lookup : {}},
            views: {
                'content@app': {
                    templateUrl: 'app/main/accounts/sellers/details/tabs/seller-lookup-table/details/seller-lookup-table-details.html',
                    controller : 'lookupTableDetailsController as vm'
                }
            },
            data: {
                displayName: 'SELLER_LOOKUP_TABLE.NAV'
            },
            resolve: {// stateParams
                createLookupValuesModelWithSourceAndDestAttributes: function(catalogFactory, $stateParams, api, utility, $q) {
                    var lookup = $stateParams.lookup;
                    if(angular.isDefined(lookup) && !utility.isObjectEmpty(lookup)) {
                        return catalogFactory.createLookupValuesModelWithSourceAndDestAttributes(lookup);
                    } else {
                        var deferred = $q.defer();
                        var lookupId = $stateParams.id;
                        var sellerId = $stateParams.sellerId;
                        api.sellers.sellerLookups.methods.getDetails(true, lookupId, sellerId)
                        .then(function (response) {
                            // transform data
                            catalogFactory.createLookupValuesModelWithSourceAndDestAttributes(response.data).then(function (resolvedModel) {
                                deferred.resolve(resolvedModel);
                            });
                        });
                        return deferred.promise;
                    }
                }
            },
            // accessPrivileges: ['GetLookupDefinitionDetails']
            accessInfo: {
                accessPrivileges: ['GetLookupDefinitionDetails']
            }
          });

        // Dataset Definition details
        $stateProvider.state('app.dataset_details', {
            url  : '/sellerId/:sellerId/datasetId/:id',
            params: {dataset : {}},
            views: {
                'content@app': {
                    templateUrl: 'app/main/accounts/sellers/details/tabs/seller-datasets/details/seller-datasets-details.html',
                    controller : 'datasetsDetailsController as vm'
                }
            },
            data: {
                displayName: 'SELLER_DATASETS.NAV'
            },
            resolve: { // stateParams
                createDatasetValuesModelWithAttributes: function(catalogFactory, $stateParams, api, utility, $q) {
                    var dataset = $stateParams.dataset;
                    var sellerId = $stateParams.sellerId;
                    var deferred = $q.defer();
                    
                    function hideValueActionsForChildSeller(valuesModel) {
                        return api.accounts.sellers.methods.getDetails(false, sellerId).then(function (sellerResponse) {
                            var seller = sellerResponse.data;
                            if (seller && angular.isDefined(seller.ParentAccountId) && seller.ParentAccountId !== null) {
                                var importAction = utility.filterObject(valuesModel.views.mainList.listActions, {id: 'import'}, true)[0];
                                if (importAction) { importAction.visible = false; }
                                var updateBulkAction = utility.filterObject(valuesModel.views.mainList.listActions, {id: 'updateBulk'}, true)[0];
                                if (updateBulkAction) { updateBulkAction.visible = false; }
                            }
                            return valuesModel;
                        });
                    }

                    if(angular.isDefined(dataset) && !utility.isObjectEmpty(dataset)) {
                        catalogFactory.createDatasetValuesModelWithAttributes(dataset).then(function (resolvedModel) {
                            hideValueActionsForChildSeller(resolvedModel).then(function (m) { deferred.resolve(m); });
                        });
                    } else {
                        api.sellers.datasets.methods.getDetails(true, $stateParams.id, sellerId)
                        .then(function (response) {
                            catalogFactory.createDatasetValuesModelWithAttributes(response.data).then(function (resolvedModel) {
                                hideValueActionsForChildSeller(resolvedModel).then(function (m) { deferred.resolve(m); });
                            });
                        });
                    }
                    return deferred.promise;
                }
            },
            // accessPrivileges: ['GetDatasetDefinitionDetails']
            accessInfo: {
                accessPrivileges: ['GetDatasetDefinitionDetails']
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/accounts/sellers');

        // Navigation
        msNavigationServiceProvider.saveItem('main.sellers', {
            title      : 'Sellers',
            icon       : 'icon-account',
            state      : 'app.accounts_sellers',
            translate  : 'SELLERS.NAV',
            weight     : 3,
            // accessPrivileges: ['GetSellerAccountList']
            // accessPrivileges: ['nav_sellers'],
            accessInfo: {
                accessPrivileges: ['nav_sellers']
            },
            visibleForLinePlan: true
        });
    }

})();
(function() {
    'use strict';

	angular
		.module('app.main.accounts.sellers')
		.controller('sellersListController', sellersListController);

	/* @ngInject */
	function sellersListController(api, $state, $document, settingsFactory, $localStorage, $sessionStorage, catalogFactory, utility) {
		/* jshint validthis: true */
		var vm = this;

        vm.model = api.accounts.sellers;
        settingsFactory.applyPersistedListViewLayout(vm.model);

		vm.sellers = [];
		vm.filteredSellers = [];
		vm.isLoading = false;


		vm.refreshItems = refreshItems;
		vm.doListAction = doListAction;
		vm.doItemAction = doItemAction;
		vm.viewItem = viewItem;
		vm.addRecord = addRecord;

		activate();

		////////////////

		function activate() {
			refreshItems(vm.model.isDirty, true);
		}

		function refreshItems(forceFetch, isLogRequired) {
            var generalProperties = {
                forceFetch: forceFetch,
                isLogRequired: isLogRequired
            }
			vm.isLoading = true;

			return vm.model.methods.getList(generalProperties)
			.then(function (response) {
				vm.sellers = response.data;
			})
			.finally(function () {
				vm.isLoading = false;
			});
		}

		//Item Action button pressed event
		function doItemAction(action, record) {
			if (action && record) {
                switch (action.id) {
                    case 'view':
                        viewItem(record);
                        break;
                    case 'edit':
                        vm.model.methods.getDetails(true, record[vm.model.idField])
                        .then(function (response) {
                            editItem(response.data, null);
                        })
                        break;
                    case 'delete':
                    case 'activate':
                        vm.model.methods.activateBulk(record, vm.model, action.id, undefined);
                        break;
                    case 'manageContext':
                        var modelCopy = angular.copy(vm.model);
                        // make creatable false to all fields except duneContext
                        angular.forEach(modelCopy.fields, function( field) {
                            if(field.field !== 'DuneContext' && field.editable) {
                                field.editable = false;
                            } else if(field.field === 'DuneContext' && !field.visible) {
                                field.editable = true;
                            }
                        });
                        var additionalInfo = { 'additionalAction': 'manageSellerDuneContext'};

                        api.showEditRecordDialog(angular.element($document.body), null, modelCopy, record, undefined, undefined, additionalInfo)
                            .then(function (saved) {
                                if (saved) {
                                    refreshItems(true, false);
                                }
                            });
                        break;
                }
			}
		}

        //List Action button pressed event
        function doListAction(action, records) {
            if (action) {
                switch (action.id) {
                    case 'delete':
                    case 'activate':
                        vm.model.methods.activateBulk(records, vm.model, action.id, undefined);
                        break;
                }
            }
        }

         function viewItem(record) {
            var id = record[vm.model.idField];
            var stateParams = {id: id};
            $state.go('app.accounts_sellers.details', stateParams);
		}

        function addRecord(ev) {
            var defaultValues = {ModelNameLength: 100};
            api.showCreateRecordDialog(angular.element($document.body), ev, vm.model, {}, defaultValues)
            .then(function(saved) {
                if (saved) {
                    refreshItems(true, false);
                }
            });
		}

		function editItem(record, ev) {
            var modelCopy = vm.model;
            // if child seller dont show model name length field
            var modelNameField = utility.filterObject(modelCopy.fields, {field: 'ModelNameLength'}, true)[0];
            if(angular.isDefined(record.ParentAccountId) && record.ParentAccountId !== null) {
                modelNameField.editable = false;
            } else {
                modelNameField.editable = true;
            }
            var campaignField = utility.filterObject(modelCopy.fields, {field: 'CampaignLaunchDateAttribute'}, true)[0];
            if(record.CampaignLaunchDateAttribute == null || record.CampaignLaunchDateAttribute === '') {
                campaignField.editable = true;
            }
            else {
                campaignField.editable = false;
            }
            api.showEditRecordDialog(angular.element($document.body), ev, modelCopy, record)
            .then(function(saved) {
                if (saved) {
                    //if active catalog belong to updated seller, update `UseConfirmOrder` and `UseOrderType` property if their value got changed localy
                    refreshItems(true, false).then(function() {
                        var activeCatalog = catalogFactory.getActiveCatalog();
                        if(angular.isDefined(activeCatalog) && activeCatalog.AccountId == record.AccountId) {
                            var updatedSeller = utility.filterObject(vm.sellers, {AccountId: record.AccountId}, true)[0];
                            if($sessionStorage.UseOrderTypeSession != updatedSeller.UseOrderType) {
                                $localStorage.UseOrderType = updatedSeller.UseOrderType;
                                $sessionStorage.UseOrderTypeSession = angular.copy(updatedSeller.UseOrderType);
                            }
                            if($sessionStorage.UseConfirmOrderSession != updatedSeller.UseConfirmOrder) {
                                $localStorage.UseConfirmOrder = updatedSeller.UseConfirmOrder;
                                $sessionStorage.UseConfirmOrderSession = angular.copy(updatedSeller.UseConfirmOrder);
                            }
                            if($sessionStorage.ModelNameLength != updatedSeller.ModelNameLength) {
                                $localStorage.ModelNameLength = updatedSeller.ModelNameLength;
                                $sessionStorage.ModelNameLength = angular.copy(updatedSeller.ModelNameLength);
                            }
                        }
                    });
                }
            });
		}

	}
})();
(function() {
	'use strict';

	angular
		.module('app.main.accounts.sellers')
		.controller('sellerDetailsController', sellerDetailsController);

	/* @ngInject */
	function sellerDetailsController($document, api, $state, $rootScope, $stateParams, $mdDialog, utility, dataImporter, settingsFactory,
		SecurityFactory, CONSTANTS, $scope, $localStorage, $sessionStorage, catalogFactory, crud, toast, bulkUpdater, uploadsTracker, $timeout, $q,
		attributeGroupSelector) {
		/* jshint validthis: true */
		var vm = this;

		// Data
		var sellerId = $stateParams.id;

		var activeCatalog = catalogFactory.getActiveCatalog();
		// seasonless model attributes are seller level records that can be assigned to any attribute group, the
		// active catalog only provides the default scope. The user switches it from the list toolbar dropdown.
		vm.seasonlessModelAttributeGroupId = attributeGroupSelector.getSelectedId('sellers.seasonlessModelAttributes', sellerId, activeCatalog.AttributeGroupId);
		vm.attributeGroups = [];

		vm.model = api.accounts.sellers;
		vm.usersModel = api.sellers.users;
		settingsFactory.applyPersistedListViewLayout(vm.usersModel);
		vm.catalogsModel = api.sellers.catalogs;
		settingsFactory.applyPersistedListViewLayout(vm.catalogsModel);
		vm.customersModel = api.customers.customers;
		settingsFactory.applyPersistedListViewLayout(vm.customersModel);
		vm.resourceTypesModel = api.sellers.resourceTypes;
		settingsFactory.applyPersistedListViewLayout(vm.resourceTypesModel);
		vm.orderTypesModel = api.sellers.orderTypes;
		settingsFactory.applyPersistedListViewLayout(vm.orderTypesModel);
		vm.VASModel = api.sellers.vas;
		settingsFactory.applyPersistedListViewLayout(vm.VASModel);
		vm.sizeScaleGroupsModel = api.sellers.sizeScaleGroups;
		vm.sizeScaleGroupsModelCopy = angular.copy(vm.sizeScaleGroupsModel);
		settingsFactory.applyPersistedListViewLayout(vm.sizeScaleGroupsModel);
		vm.seasonlessAttributesModel = api.sellers.seasonlessAttributes;
		settingsFactory.applyPersistedListViewLayout(vm.seasonlessAttributesModel);
		vm.seasonlessModelAttributesModel = api.sellers.seasonlessModelAttributes;
		settingsFactory.applyPersistedListViewLayout(vm.seasonlessModelAttributesModel);
		vm.articleDropReasonsModel = api.sellers.articleDropReasons;
		vm.articleDropReasonsModelCopy = angular.copy(vm.articleDropReasonsModel);
		settingsFactory.applyPersistedListViewLayout(vm.articleDropReasonsModel);
		vm.masterSizeScalesModel = api.sellers.masterSizeScales;
		vm.masterSizeScalesModelCopy = angular.copy(vm.masterSizeScalesModel);
		settingsFactory.applyPersistedListViewLayout(vm.masterSizeScalesModel);
		vm.lookupDefinitionsModel = api.sellers.sellerLookups;
		settingsFactory.applyPersistedListViewLayout(vm.lookupDefinitionsModel);
		vm.sellerConfigurationsModel = api.sellers.configurations;
		settingsFactory.applyPersistedListViewLayout(vm.sellerConfigurationsModel);
		vm.sellerColorsModel = api.sellers.sellerColors;
		vm.sellerColorsModelCopy = angular.copy(vm.sellerColorsModel);
		settingsFactory.applyPersistedListViewLayout(vm.sellerColorsModel);
		vm.dataSetDefinitionsModel = api.sellers.datasets;
		vm.dataSetDefinitionsModelCopy = angular.copy(vm.dataSetDefinitionsModel);
		settingsFactory.applyPersistedListViewLayout(vm.dataSetDefinitionsModel);
		vm.sellerResourcesModel = api.sellers.sellerResources;
		settingsFactory.applyPersistedListViewLayout(vm.sellerResourcesModel);
		vm.capacitiesModel = api.sellers.capacities;
		settingsFactory.applyPersistedListViewLayout(vm.capacitiesModel);
		vm.designOptionAttributesModel = api.sellers.designOptionAttributes;
		vm.designOptionAttributesModelCopy = angular.copy(vm.designOptionAttributesModel);
		settingsFactory.applyPersistedListViewLayout(vm.designOptionAttributesModel);

		// Create seller articles lookup model upfront so dataImporter can reference it
		if(angular.isUndefined(api.sellers.sellerArticlesLookup)) {
			api.sellers.sellerArticlesLookup = {
				modelPath: 'sellers.sellerArticlesLookup',
				idField: 'Id',
				lookupDisplayField: 'ArticleNumber',
				lookupData: undefined,
				methods: {
					getList: function() {
						// Data is loaded by prepareSellerImportModel
						return $q.when({data: []});
					}
				}
			};
		}

		// Create seller models lookup model upfront so dataImporter can reference it
		if(angular.isUndefined(api.sellers.sellerModelsLookup)) {
			api.sellers.sellerModelsLookup = {
				modelPath: 'sellers.sellerModelsLookup',
				idField: 'Id',
				lookupDisplayField: 'ModelNumber',
				lookupData: undefined,
				methods: {
					getList: function() {
						// Data is loaded by prepareSellerImportModel
						return $q.when({data: []});
					}
				}
			};
		}

		vm.seller = {};
		vm.sellerUsers = [];
		vm.filteredSellerUsers = [];

		vm.sellerCatalogs = [];
		vm.filteredSellerCatalogs = [];

		vm.sellerCustomers = [];
		vm.filteredSellerCustomers = [];

		vm.resourceTypes = [];
		vm.filteredResourceTypes = [];

		vm.orderTypes = [];
		vm.filteredOrderTypes = [];

		vm.sellerVAS = [];
		vm.filteredSellerVAS = [];

		vm.sizeScaleGroups = [];
		vm.filteredSizeScaleGroups = [];

		vm.seasonlessAttributes = [];
		vm.filteredSeasonlessAttributes = [];

		vm.seasonlessModelAttributes = [];
		vm.filteredSeasonlessModelAttributes = [];

		vm.articleDropReasons = [];
		vm.filteredArticleDropReasons = [];

		vm.masterSizeScales = [];
		vm.filteredMasterSizeScales = [];

		vm.capacities = [];
		vm.filteredCapacities = [];
		vm.isCapacitiesLoading = false;

		vm.lookupDefinitions = [];
		vm.filteredLookupDefinitions = [];

		vm.sellerConfigurations = [];
		vm.filteredSellerConfigurations = [];

		vm.sellerColors = [];
		vm.filteredSellerColors = [];

		vm.datasetDefinitions = [];
		vm.filteredDataSetsDefinitionModel = [];

		vm.sellerResources = [];
		vm.filteredSellerResources = [];

		vm.designOptionAttributes = [];
		vm.filteredDesignOptionAttributes = [];

		vm.isLoading = false;
		vm.isUsersLoading = false;
		vm.isCatalogsLoading = false;
		vm.isCustomersLoading = false;
		vm.isResourceTypesLoading = false;
		vm.isOrderTypesLoading = false;
		vm.isVASLoading = false;
		vm.isSizeScaleGroupsLoading = false;
		vm.isSeasonlessAttributesLoading = false;
		vm.isSeasonlessModelAttributesLoading = false;
		vm.isArticleDropReasonsLoading = false;
		vm.isMasterSizeScalesLoading = false;
		vm.isLookupDefinitionsLoading = false;
		vm.isSellerConfigurationLoading = false;
		vm.isSellerColorsLoading = false;
		vm.isDatasetDefinitionsLoading = false;
		vm.isSellerResourcesLoading = false;
		vm.isDesignOptionAttributesLoading = false;

		var isTabDataInitialized = false;

		// Restore last active tab for this seller.
		// NOTE: tabs are removed from the DOM by tx-access for unauthorized roles, so md-tabs'
		// selectedIndex is a *positional* index (vm.selectedTabPosition) that md-tabs owns and
		// two-way binds. vm.tabIndex is the *logical* tab index, set only by md-on-select and used
		// by tx-is-active. Keeping these separate prevents the $rootScope:infdig loop that occurred
		// when md-tabs clamped a logical index (e.g. 14) to a smaller positional range and wrote it
		// back, re-triggering md-on-select. See bug: seller Colors tab for restricted roles.
		var savedTabPosition = ($sessionStorage.sellerDetailsActiveTab && $sessionStorage.sellerDetailsActiveSellerId === sellerId)
			? $sessionStorage.sellerDetailsActiveTab : 0;
		vm.tabIndex = 0; // logical index (set by md-on-select)
		vm.selectedTabPosition = 0; // positional index bound to md-tabs md-selected

		// Methods
		vm.refreshRecord = refreshRecord;
		vm.refreshUsers = refreshUsers;
		vm.refreshCatalogs = refreshCatalogs;
		vm.refreshCustomers = refreshCustomers;
		vm.refreshResourceTypes = refreshResourceTypes;
		vm.refreshOrderTypes = refreshOrderTypes;
		vm.refreshVAS = refreshVAS;
		vm.refreshSizeScaleGroups = refreshSizeScaleGroups;
		vm.refreshSeasonlessAttributes = refreshSeasonlessAttributes;
		vm.refreshSeasonlessModelAttributes = refreshSeasonlessModelAttributes;
		vm.refreshArticleDropReasons = refreshArticleDropReasons;
		vm.refreshMasterSizeScales = refreshMasterSizeScales;
		vm.refreshLookupDefinitions = refreshLookupDefinitions;
		vm.refreshSellerConfigurations = refreshSellerConfigurations;
		vm.refreshSellerColors = refreshSellerColors;
		vm.refreshDatasetDefinitions = refreshDatasetDefinitions;

		vm.doSellerItemAction = doSellerItemAction;
		vm.editSeller = editSeller;

		vm.doUsersItemAction = doUsersItemAction;
		vm.doUsersListAction = doUsersListAction;
		vm.viewUser = viewUser;

		vm.doCatalogItemAction = doCatalogItemAction;
		vm.viewCatalog = viewCatalog;

		vm.doCustomersItemAction = doCustomersItemAction;
		vm.doCustomersListAction = doCustomersListAction;
		vm.viewCustomer = viewCustomer;
		vm.addCustomer = addCustomer;

		vm.doResourceTypeItemAction = doResourceTypeItemAction;
		vm.addResourceType = addResourceType;

		vm.doOrderTypesItemAction = doOrderTypesItemAction;
		vm.doOrderTypesListAction = doOrderTypesListAction;
		vm.addOrderType = addOrderType;

		vm.doVASItemAction = doVASItemAction;
		vm.viewVAS = viewVAS;
		vm.addVAS = addVAS;

		vm.doSizeScaleGroupsItemAction = doSizeScaleGroupsItemAction;
		vm.doSizeScaleGroupsListAction = doSizeScaleGroupsListAction;
		vm.addSizeScales = addSizeScales;

		vm.doSeasonlessAttributesItemAction = doSeasonlessAttributesItemAction;
		vm.doSeasonlessAttributesListAction = doSeasonlessAttributesListAction;
		vm.addSeasonlessAttributes = addSeasonlessAttributes;

		vm.doSeasonlessModelAttributesItemAction = doSeasonlessModelAttributesItemAction;
		vm.doSeasonlessModelAttributesListAction = doSeasonlessModelAttributesListAction;
		vm.addSeasonlessModelAttributes = addSeasonlessModelAttributes;
		vm.onSeasonlessModelAttributeGroupChange = onSeasonlessModelAttributeGroupChange;

		vm.doArticleDropReasonsItemAction = doArticleDropReasonsItemAction;
		vm.doArticleDropReasonsListAction = doArticleDropReasonsListAction;
		vm.addArticleDropReasons = addArticleDropReasons;

		vm.doMasterSizeScalesItemAction = doMasterSizeScalesItemAction;
		vm.doMasterSizeScalesListAction = doMasterSizeScalesListAction;
		vm.addMasterSizeScales = addMasterSizeScales;

		vm.doLookupDefinitionsItemAction = doLookupDefinitionsItemAction;
		vm.addLookupDefinition = addLookupDefinition;
		vm.viewLookupDefinition = viewLookupDefinition;

		vm.doSellerConfigurationsItemAction = doSellerConfigurationsItemAction;
		vm.doSellerConfigurationsListAction = doSellerConfigurationsListAction;
		vm.addSellerConfiguration = addSellerConfiguration;

		vm.doSellerColorsItemAction = doSellerColorsItemAction;
		vm.doSellerColorsListAction = doSellerColorsListAction;
		vm.addSellerColor = addSellerColor;

		vm.doDatasetDefinitionItemAction = doDatasetDefinitionItemAction;
		vm.doDatasetDefinitionListAction = doDatasetDefinitionListAction;
		vm.addDatasetDefinition = addDatasetDefinition;
		vm.viewDatasetDefinition = viewDatasetDefinition;

		vm.refreshSellerResources = refreshSellerResources;
		vm.doSellerResourcesItemAction = doSellerResourcesItemAction;
		vm.doSellerResourcesListAction = doSellerResourcesListAction;
		vm.addSellerResource = addSellerResource;
		vm.viewSellerResource = viewSellerResource;

		vm.refreshCapacities = refreshCapacities;
		vm.doCapacitiesItemAction = doCapacitiesItemAction;
		vm.doCapacitiesListAction = doCapacitiesListAction;
		vm.addCapacity = addCapacity;
		vm.viewCapacity = viewCapacity;

		vm.refreshDesignOptionAttributes = refreshDesignOptionAttributes;
		vm.doDesignOptionAttributesItemAction = doDesignOptionAttributesItemAction;
		vm.doDesignOptionAttributesListAction = doDesignOptionAttributesListAction;
		vm.addDesignOptionAttribute = addDesignOptionAttribute;

		vm.onActiveTabChange = onActiveTabChange;

		activate();

		////////////////

		function activate() {
			utility.filterObject(vm.usersModel.fields, {field: 'Roles'})[0].lookupFilter = {'AccountTypeId': 2};// modify user model dynamically to filter roles based on account type id
			refreshRecord(true);
			// feeds the attribute group dropdown on the seasonless model attributes list
			attributeGroupSelector.getGroups().then(function(attributeGroups) {
				vm.attributeGroups = attributeGroups;
			});
			// Restore saved tab after DOM renders (positional index owned by md-tabs)
			if(savedTabPosition > 0) {
				$timeout(function() {
					vm.selectedTabPosition = savedTabPosition;
				}, 500);
			}

			// Sync the bulk-action banner from the underlying datasets model to the view copy
			// when a background dataset definition update completes.
			var deregisterJobCompleted = $rootScope.$on('jobCompletedEvent', function() {
				if (api.sellers.datasets.isBulkActionCompleted) {
					vm.dataSetDefinitionsModelCopy.isBulkActionCompleted = true;
				}
			});
			$scope.$on('$destroy', deregisterJobCompleted);
		}

		// opens the edit dialog with the same field rules as the sellers list view
		function editSeller(ev, record) {
			var modelCopy = vm.model;
			// if child seller dont show model name length field
			var modelNameField = utility.filterObject(modelCopy.fields, {field: 'ModelNameLength'}, true)[0];
			if(angular.isDefined(record.ParentAccountId) && record.ParentAccountId !== null) {
				modelNameField.editable = false;
			} else {
				modelNameField.editable = true;
			}
			var campaignField = utility.filterObject(modelCopy.fields, {field: 'CampaignLaunchDateAttribute'}, true)[0];
			if(record.CampaignLaunchDateAttribute == null || record.CampaignLaunchDateAttribute === '') {
				campaignField.editable = true;
			}
			else {
				campaignField.editable = false;
			}
			api.showEditRecordDialog(angular.element($document.body), ev, modelCopy, record)
				.then(function (saved) {
					if (saved) {
						//if active catalog belong to updated seller, update `UseConfirmOrder` and `UseOrderType` property if their value got changed localy
						refreshRecord(true).then(function () {
							var activeCatalog = catalogFactory.getActiveCatalog();
							if(angular.isDefined(activeCatalog) && activeCatalog.AccountId == vm.seller.AccountId) {
								if($sessionStorage.UseOrderTypeSession != vm.seller.UseOrderType) {
									$localStorage.UseOrderType = vm.seller.UseOrderType;
									$sessionStorage.UseOrderTypeSession = angular.copy(vm.seller.UseOrderType);
								}
								if($sessionStorage.UseConfirmOrderSession != vm.seller.UseConfirmOrder) {
									$localStorage.UseConfirmOrder = vm.seller.UseConfirmOrder;
									$sessionStorage.UseConfirmOrderSession = angular.copy(vm.seller.UseConfirmOrder);
								}
								if($sessionStorage.ModelNameLength != vm.seller.ModelNameLength) {
									$localStorage.ModelNameLength = vm.seller.ModelNameLength;
									$sessionStorage.ModelNameLength = angular.copy(vm.seller.ModelNameLength);
								}
							}
						});
					}
				});
		}

		function refreshRecord(isLogRequired) {
			vm.isLoading = true;

			return vm.model.methods.getDetails(isLogRequired, sellerId)
				.then(function (response) {
					vm.seller = response.data;
					if(angular.isUndefined(vm.seller.ParentAccountId)) {
						vm.seller['ParentAccountId'] = null;
					}
					vm.title = angular.copy(vm.seller[vm.model.lookupDisplayField]);

					initializeTabData(isLogRequired);

					if(vm.seller.ParentAccountId !== null) {
						catalogFactory.modifyModelActions(vm.sizeScaleGroupsModelCopy);
						catalogFactory.modifyModelActions(vm.masterSizeScalesModelCopy);
						catalogFactory.modifyModelActions(vm.sellerColorsModelCopy);
						catalogFactory.modifyModelActions(vm.articleDropReasonsModelCopy);
						catalogFactory.modifyModelActions(vm.dataSetDefinitionsModelCopy);
						catalogFactory.modifyModelActions(vm.designOptionAttributesModelCopy);
					}

					//Update Breadcrumb
					$state.current.data.displayName = vm.title;
					$rootScope.$broadcast('breadcrumb-updated');
				})
				.finally(function () {
					vm.isLoading = false;
				});
		}

		function refreshUsers(forceFetch, isLogRequired) {
			var generalProperties = {
				forceFetch: forceFetch,
				isLogRequired: isLogRequired
			}
			vm.isUsersLoading = true;

			vm.usersModel.methods.getList(generalProperties, sellerId)
				.then(function (response) {
					vm.sellerUsers = response.data;
				})
				.finally(function() {
					vm.isUsersLoading = false;
				});
		}

		function refreshCatalogs(forceFetch, isLogRequired) {
			var generalProperties = {
				forceFetch: forceFetch,
				isLogRequired: isLogRequired
			}
			vm.isCatalogsLoading = true;

			vm.catalogsModel.methods.getList(generalProperties, sellerId)
				.then(function (response) {
					vm.sellerCatalogs = response.data;
					// Extract attributeGroupId from first catalog for seller-level resource APIs
					if(vm.sellerCatalogs.length > 0 && !vm.sellerAttributeGroupId) {
						vm.sellerAttributeGroupId = vm.sellerCatalogs[0].AttributeGroupId;
						refreshSellerResources(true, false);
						// Pre-load seller articles and models lookups for Map Resources to Colorways
						preloadSellerLookups();
					}
					//UPDATE catalog data-source properties for line plan catalog
					angular.forEach(vm.sellerCatalogs, function (catalog) {
						if (catalog.IsLinePlan == 1) {
							catalog.DataSourceType = CONSTANTS.LINE_PLAN_CATALOG;
							catalog.DataSourceTypeId = CONSTANTS.LINE_PLAN_ID;
						}
					})
				})
				.finally(function() {
					vm.isCatalogsLoading = false;
				});
		}

		function refreshCustomers(forceFetch, isLogRequired) {
			var generalProperties = {
				forceFetch: forceFetch,
				isLogRequired: isLogRequired,
				config: {},
				supportIncrementalResult: true,
				modelIdField: 'CustomerId',
				isMajor: false,
				model: vm.customersModel
			}
			vm.isCustomersLoading = true;
			vm.customersModel.methods.getList(generalProperties, vm.customersModel, sellerId)
			.then(function(response) {
				vm.sellerCustomers = response.data;
				utility.addCustomProperty(vm.sellerCustomers, 'UseOrderType', vm.seller.UseOrderType);
				if (angular.isDefined(vm.tableControl) && angular.isDefined(vm.tableControl.updateData)) {
					vm.tableControl.updateData();
				}
			})
			.finally(function() {
				vm.isCustomersLoading = false;
			});
		}

		function refreshResourceTypes(forceFetch, isLogRequired) {
			var generalProperties = {
				forceFetch: forceFetch,
				isLogRequired: isLogRequired
			}
			vm.isResourceTypesLoading = true;
			vm.resourceTypesModel.methods.getList(generalProperties, sellerId)
				.then(function(response) {
					vm.resourceTypes = response.data;
				})
				.finally(function() {
					vm.isResourceTypesLoading = false;
				});
		}

		function refreshOrderTypes(forceFetch, isLogRequired) {
			var generalProperties = {
				forceFetch: forceFetch,
				isLogRequired: isLogRequired
			}
			vm.isOrderTypesLoading = true;
			vm.orderTypesModel.methods.getList(generalProperties, sellerId)
				.then(function(response) {
					vm.orderTypes = response.data;
				})
				.finally(function() {
					vm.isOrderTypesLoading = false;
				});
		}

		function refreshVAS(forceFetch, isLogRequired) {
			var generalProperties = {
				forceFetch: forceFetch,
				isLogRequired: isLogRequired
			}
			vm.isVASLoading = true;
			vm.VASModel.methods.getList(generalProperties, vm.VASModel, sellerId)
				.then(function(response) {
					vm.sellerVAS = response.data;
				})
				.finally(function() {
					vm.isVASLoading = false;
				});
		}

		function refreshSizeScaleGroups(forceFetch, isLogRequired) {
			var generalProperties = {
				forceFetch: forceFetch,
				isLogRequired: isLogRequired
			}
			vm.isSizeScaleGroupsLoading = true;
			vm.sizeScaleGroupsModel.methods.getList(vm.sizeScaleGroupsModelCopy, generalProperties, sellerId)
				.then(function(response) {
					vm.sizeScaleGroups = response.data;
				})
				.finally(function() {
					vm.isSizeScaleGroupsLoading = false;
				});
		}

		function refreshSeasonlessAttributes(forceFetch, isLogRequired) {
			var generalProperties = {
				forceFetch: forceFetch,
				isLogRequired: isLogRequired
			}
			vm.isSeasonlessAttributesLoading = true;
			vm.seasonlessAttributesModel.methods.getList(generalProperties, sellerId)
				.then(function(response) {
					vm.seasonlessAttributes = response.data;
				})
				.finally(function() {
					vm.isSeasonlessAttributesLoading = false;
			});
		}

		function refreshSeasonlessModelAttributes(forceFetch, isLogRequired) {
			var generalProperties = {
				forceFetch: forceFetch,
				isLogRequired: isLogRequired
			}
			vm.isSeasonlessModelAttributesLoading = true;
			vm.seasonlessModelAttributesModel.methods.getList(generalProperties, sellerId, vm.seasonlessModelAttributeGroupId)
				.then(function(response) {
					vm.seasonlessModelAttributes = response.data;
				})
				.finally(function() {
					vm.isSeasonlessModelAttributesLoading = false;
			});
		}

		function refreshArticleDropReasons(forceFetch, isLogRequired) {
			var generalProperties = {
				forceFetch: forceFetch,
				isLogRequired: isLogRequired
			}
			vm.isArticleDropReasonsLoading = true;
			vm.articleDropReasonsModel.methods.getList(generalProperties, sellerId)
				.then(function(response) {
					vm.articleDropReasons = response.data;
					api.setArticleDropReasonsList(utility.filterObject(vm.articleDropReasons, {Status: 1}));
				})
				.finally(function() {
					vm.isArticleDropReasonsLoading = false;
			});
		}

		function refreshMasterSizeScales(forceFetch, isLogRequired) {
			var generalProperties = {
				forceFetch: forceFetch,
				isLogRequired: isLogRequired
			}
			vm.isMasterSizeScalesLoading = true;
			vm.masterSizeScalesModel.methods.getList(vm.masterSizeScalesModelCopy, generalProperties, sellerId)
				.then(function(response) {
					vm.masterSizeScales = response.data;
				})
				.finally(function() {
					vm.isMasterSizeScalesLoading = false;
				});
		}

		function refreshCapacities(forceFetch, isLogRequired) {
			var generalProperties = {
				forceFetch: forceFetch,
				isLogRequired: isLogRequired
			}
			vm.isCapacitiesLoading = true;
			vm.capacitiesModel.methods.getList(generalProperties, sellerId)
				.then(function(response) {
					vm.capacities = response.data;
					// render Criteria as the raw JSON string (mirrors the Master Size Scale Criteria column)
					angular.forEach(vm.capacities, function(capacity) {
						capacity.Criteria = angular.isString(capacity.Criteria) ? capacity.Criteria : angular.toJson(capacity.Criteria);
					});
				})
				.finally(function() {
					vm.isCapacitiesLoading = false;
				});
		}

		function refreshLookupDefinitions(forceFetch, isLogRequired) {
			var generalProperties = {
				forceFetch: forceFetch,
				isLogRequired: isLogRequired
			}
			vm.isLookupDefinitionsLoading = true;
			vm.lookupDefinitionsModel.methods.getList(generalProperties, sellerId)
				.then(function(response) {
					vm.lookupDefinitions = response.data;
				})
				.finally(function() {
					vm.isLookupDefinitionsLoading = false;
			});
		}

		function refreshSellerConfigurations(forceFetch, isLogRequired) {
			var generalProperties = {
				forceFetch: forceFetch,
				isLogRequired: isLogRequired
			}
			vm.isSellerConfigurationLoading = true;
			vm.sellerConfigurationsModel.methods.getList(generalProperties, sellerId, vm.sellerConfigurationsModel).then(function (response) {
				vm.sellerConfigurations = response.data;
			}).finally(function () {
				vm.isSellerConfigurationLoading = false;
			});
		}

		function refreshSellerColors(forceFetch, isLogRequired) {
			var generalProperties = {
				forceFetch: forceFetch,
				isLogRequired: isLogRequired
			}
			vm.isSellerColorsLoading = true;
			vm.sellerColorsModel.methods.getList(generalProperties, sellerId, vm.sellerColorsModel).then(function (response) {
				vm.sellerColors = response.data;
			}).finally(function () {
				vm.isSellerColorsLoading = false;
			});
		}

		function refreshDatasetDefinitions(forceFetch, isLogRequired) {
			var generalProperties = {
				forceFetch: forceFetch,
				isLogRequired: isLogRequired
			}
			vm.isDatasetDefinitionsLoading = true;
			vm.dataSetDefinitionsModel.methods.getList(generalProperties, sellerId)
				.then(function(response) {
					vm.datasetDefinitions = response.data;
					// map attributeids
					angular.forEach(vm.datasetDefinitions, function(dataset) {
						if(dataset.Attributes && dataset.Attributes.length) {
							dataset['AttributesIds'] = dataset.Attributes.map(function(attr) {
								return attr.AttributeId;
							})
						}
					});
					vm.dataSetDefinitionsModelCopy.isBulkActionCompleted = false;
				})
				.finally(function() {
					vm.isDatasetDefinitionsLoading = false;
			});
		}

		function doSellerItemAction(action, record) {
			if (action) {
				switch (action.id) {
					case 'delete':
					case 'activate':
						vm.model.methods.activateBulk(record, vm.model, action.id, undefined)
							.then(function() {
								if(!isTabDataInitialized && action.id === 'activate') {
									initializeTabData(true);
								}
							});
						break;
					case 'importBuyerUserCustomers':
						dataImporter.importExcel(api.accounts.customers, true).then(function(result) {
							api.accounts.customers.methods.createBulk(api.accounts.customers, result.data, sellerId);
						});
						break;
					case 'manageContext':
						var modelCopy = angular.copy(vm.model);
						// make creatable false to all fields except duneContext
						angular.forEach(modelCopy.fields, function( field) {
							if(field.field !== 'DuneContext' && field.editable) {
								field.editable = false;
							} else if(field.field === 'DuneContext' && !field.visible) {
								field.editable = true;
							}
						});
						var additionalInfo = { 'additionalAction': 'manageSellerDuneContext'};

						api.showEditRecordDialog(angular.element($document.body), null, modelCopy, record, undefined, undefined, additionalInfo)
							.then(function (saved) {
								if (saved) {
									refreshRecord();
								}
							});
						break;
				}
			}
		}

		function doUsersItemAction(action, record) {
			if (action && record) {
				switch (action.id) {
					case 'view':
						vm.viewUser(record);
						break;
					case 'edit':
						editUser(record, null);
						break;
					case 'delete':
					case 'activate':
						vm.usersModel.methods.activateBulk(record, vm.usersModel, action.id, undefined);
						break;
				}
			}
		}

		function doUsersListAction(action, records) {
			if (action) {
				switch (action.id) {
					case 'delete':
					case 'activate':
						vm.usersModel.methods.activateBulk(records, vm.usersModel, action.id, undefined);
						break;
					case 'changeAccount':
						$mdDialog.show({
								controller: 'changeAccountController',
								controllerAs: 'vm',
								templateUrl: 'app/main/accounts/users/list/dialogs/change-user-account/change-user-account.html',
								parent: angular.element($document.body),
								targetEvent: null,
								clickOutsideToClose: false,
								locals: {
										model: api.accounts.users,
										selectedRecords: records,
										event: null
								}
						}).then(function (saved) {
								if (saved) {
									refreshUsers(true, false);
								}
						});
						break;
				}
			}
		}

		function viewUser(record) {
			var id = record[vm.usersModel.idField];
			var stateParams = {account: 'sellers', accountId: sellerId, id:id};
			$state.go('app.accounts_user_details', stateParams);
		}

		function editUser(record, ev) {
			api.showEditRecordDialog(angular.element($document.body), ev, vm.usersModel, record)
			.then(function(saved) {
				if (saved) {
					refreshUsers(true, false);
				}
			});
		}

		function doCatalogItemAction(action, record) {
			if (action && record) {
				switch (action.id) {
					case 'view':
						vm.viewCatalog(record);
						break;
					case 'edit':
						editCatalog(record, null);
						break;
					case 'delete':
					case 'activate':
						vm.catalogsModel.methods.activateBulk(record, vm.catalogsModel, action.id, sellerId);
						break;
				}
			}
		}

		function viewCatalog(record) {
			var id = record[vm.catalogsModel.idField];
			var stateParams = {id:id, dataSourceTypeId: record.DataSourceTypeId};
			$state.go('app.catalogs.details', stateParams);
		}

		function editCatalog(record, ev) {
			api.showEditRecordDialog(angular.element($document.body), ev, vm.catalogsModel, record, sellerId)
			.then(function(saved) {
				if (saved) {
					refreshCatalogs(true, false);
				}
			});
		}

		function doCustomersItemAction(action, record) {
			if (action && record) {
				switch (action.id) {
					case 'view':
						viewCustomer(record);
						break;
					case 'edit':
						editCustomer(record, null);
						break;
					case 'delete':
					case 'activate':
						vm.customersModel.methods.activateBulk(record, vm.customersModel, action.id, sellerId);
						break;
				}
			}
		}

		function doCustomersListAction(action, records) {
			if (action) {
				switch (action.id) {
					case 'delete':
					case 'activate':
						vm.customersModel.methods.activateBulk(records, vm.customersModel, action.id, sellerId);
						break;
					case 'import':
						// use OrderTypesValue_string for import rather than OrderTypes field
						var modelCopy = angular.copy(vm.customersModel);
						var orderTypesField = utility.filterObject(modelCopy.fields, {field: 'OrderTypes'}, true)[0];
						orderTypesField.creatable = false;
						var orderTypesValueField = utility.filterObject(modelCopy.fields, {field: 'OrderTypesValue_string'}, true)[0];
						orderTypesValueField.creatable = true;
						dataImporter.importExcel(modelCopy, true).then(function(result) {
							vm.customersModel.methods.createBulk(result.data, sellerId, vm.customersModel);
						});
						break;
					case 'import_loc':
						dataImporter.importExcel(api.customers.customersLocations, true).then(function(result) {
							api.customers.customersLocations.methods.createBulk(result.data, sellerId, api.customers.customersLocations);
						});
						break;
				}
			}
		}

		 function viewCustomer(item) {
			var id = item[vm.customersModel.idField];
			var stateParams = {id: id, sellerId: sellerId, UseOrderType: vm.seller.UseOrderType};
			$state.go('app.customer_details', stateParams);
		}

		function addCustomer(ev) {
			var lookupExtras = {};
			lookupExtras['sellers.orderTypes'] = {};
			lookupExtras['sellers.orderTypes']['id1'] = sellerId;
			//{UseOrderType: vm.seller.UseOrderType} argument is used to populate record with UseOrderType value used in disabledCriteria of orderType field
			api.showCreateRecordDialog(angular.element($document.body), ev, vm.customersModel, sellerId, {UseOrderType: vm.seller.UseOrderType}, lookupExtras)
			.then(function(saved) {
				if (saved) {
					refreshCustomers(true, false);
				}
			});
		}

		function editCustomer(item, ev) {
			var lookupExtras = {};
			lookupExtras['sellers.orderTypes'] = {};
			lookupExtras['sellers.orderTypes']['id1'] = sellerId;
			api.showEditRecordDialog(angular.element($document.body), ev, vm.customersModel, item, sellerId, lookupExtras)
			.then(function(saved) {
				if (saved) {
					refreshCustomers(true, false);
				}
			});
		}

		function doResourceTypeItemAction(action, record) {
			if (action && record) {
				switch (action.id) {
					case 'edit':
						editResourceType(record, null);
					break;
				}
			}
		}

		function editResourceType(record, ev) {
			var lookupModel = api.getModel('lists.entityTypes');
			api.getLookupData(lookupModel).then(function() {
				$mdDialog.show({
				controller         : 'createResourceTypeController',
				controllerAs       : 'vm',
				templateUrl        : 'app/main/accounts/sellers/details/tabs/resource-types/dialogs/create-resource-type.html',
				parent             : angular.element($document.body),
				targetEvent        : ev,
				clickOutsideToClose: false,
				locals             : {
					isNew: false,
					record: angular.copy(record),
					sellerId : sellerId,
					event: ev,
					model: vm.resourceTypesModel
				}
				}).then(function(saved) {
					if (saved) {
						refreshResourceTypes(true, false);
					}
				});
			});

		}

		function addResourceType(ev) {
			var lookupModel = api.getModel('lists.entityTypes');
			api.getLookupData(lookupModel).then(function() {
				$mdDialog.show({
					controller         : 'createResourceTypeController',
					controllerAs       : 'vm',
					templateUrl        : 'app/main/accounts/sellers/details/tabs/resource-types/dialogs/create-resource-type.html',
					parent             : angular.element($document.body),
					targetEvent        : ev,
					clickOutsideToClose: false,
					locals             : {
						isNew: true,
						record: null,
						sellerId : sellerId,
						event: ev,
						model: vm.resourceTypesModel
					}
				}).then(function(saved) {
					if (saved) {
						refreshResourceTypes(true, false);
					}
				});
			});
		}

		function doOrderTypesItemAction(action, record) {
			if (action && record) {
				switch (action.id) {
					case 'edit':
						editOrderType(record, null);
						break;
					case 'delete':
					case 'activate':
						vm.orderTypesModel.methods.activateBulk(record, vm.orderTypesModel, action.id, sellerId);
						break;
				}
			}
		}

		function doOrderTypesListAction(action, records) {
			if (action) {
				switch (action.id) {
					case 'delete':
					case 'activate':
						vm.orderTypesModel.methods.activateBulk(records, vm.orderTypesModel, action.id, sellerId);
						break;
				}
			}
		}

		function addOrderType(ev) {
			api.showCreateRecordDialog(angular.element($document.body), ev, vm.orderTypesModel, sellerId, undefined)
			.then(function(saved) {
				if (saved) {
					refreshOrderTypes(true, false);
				}
			});
		}

		function editOrderType(record, ev) {
			api.showEditRecordDialog(angular.element($document.body), ev, vm.orderTypesModel, record, sellerId)
			.then(function(saved) {
				if (saved) {
					refreshOrderTypes(true, false);
				}
			});
		}

		function doVASItemAction(action, record) {
			if (action && record) {
				switch (action.id) {
					case 'view':
						viewVAS(record);
						break;
					case 'edit':
						editVAS(record, null);
						break;
					case 'delete':
					case 'activate':
						vm.VASModel.methods.updateStatus(record, vm.VASModel, action.id, record[vm.VASModel.idField] , sellerId);
						break;
				}
			}
		}

		function addVAS(ev) {
			// As Discussed with Omar `AdditionalInfoType` hard coded to 2
			api.showCreateRecordDialog(angular.element($document.body), ev, vm.VASModel, null, {'AdditionalInfoType': 2, 'SellerAccountId': sellerId})
			.then(function(saved) {
				if (saved) {
					refreshVAS(true, false);
				}
			});
		}

		function viewVAS(record) {
			var id = record[vm.VASModel.idField];
			var stateParams = {id: id, sellerId: sellerId};
			$state.go('app.vas_details', stateParams);
		}

		function editVAS(record, ev) {
			api.showEditRecordDialog(angular.element($document.body), ev, vm.VASModel, record)
			.then(function(saved) {
				if (saved) {
					refreshVAS(true, false);
				}
			});
		}

		function doSizeScaleGroupsItemAction(action, record) {
			if (action && record) {
				switch (action.id) {
					case 'edit':
							editSizeScales(record, null);
							break;
					case 'delete':
					case 'activate':
							vm.sizeScaleGroupsModel.methods.activateBulk(record, vm.sizeScaleGroupsModel, action.id, sellerId);
							break;
				}
			}
		}

		function doSizeScaleGroupsListAction(action, records) {
			if (action) {
				switch (action.id) {
					case 'import':
						var modelCopy = angular.copy(vm.sizeScaleGroupsModel);
						utility.filterObject(modelCopy.fields, {field: 'Status'}, true)[0].creatable = true;
						utility.filterObject(modelCopy.fields, {field: 'MasterSizeScaleId'}, true)[0].creatable = false;
						utility.filterObject(modelCopy.fields, {field: 'MasterSizeScale'}, true)[0].creatable = true;
						dataImporter.importExcel(modelCopy, true).then(function(result) {
							vm.sizeScaleGroupsModel.methods.createBulk(vm.sizeScaleGroupsModelCopy, result.data, sellerId);
						});
						break;
					case 'delete':
					case 'activate':
						vm.sizeScaleGroupsModel.methods.activateBulk(records, vm.sizeScaleGroupsModel, action.id, sellerId);
						break;
				}
			}
		}

		function addSizeScales(ev) {
			var promises = {};
			var generalProperties = {
				forceFetch: true,
				isLogRequired: false
			}
			promises['masterSizeScalePromise'] = vm.masterSizeScalesModel.methods.getList(vm.masterSizeScalesModel, generalProperties, sellerId);
			$mdDialog.show({
				controller: 'addUpdateSizeScaleController',
				controllerAs: 'vm',
				templateUrl: 'app/main/accounts/sellers/details/tabs/size-scale-groups/dialogs/add-update-size-scale.html',
				parent: angular.element($document.body),
				targetEvent: ev,
				clickOutsideToClose: false,
				locals: {
					record: null,
					isNew: true,
					model: vm.sizeScaleGroupsModel,
					promises: promises,
					existingRecordsForUniqueValue: angular.copy(vm.sizeScaleGroups),
					sellerId: sellerId,
					event: ev
				}
			}).then(function(saved) {
				if (saved) {
					refreshSizeScaleGroups(true, false);
				}
			});
		}

		function editSizeScales(record, ev) {
			var promises = {};
			var generalProperties = {
				forceFetch: true,
				isLogRequired: false
			}
			var existingRecordsForUniqueValue = utility.filterObject(vm.sizeScaleGroups, {MasterSizeScaleId: record.MasterSizeScaleId}, true);
			for (var i = 0; i < existingRecordsForUniqueValue.length; i++) {
				if(existingRecordsForUniqueValue[i].Id === record.Id) {
					existingRecordsForUniqueValue.splice(i, 1);
				}
			}
			promises['masterSizeScalePromise'] = vm.masterSizeScalesModel.methods.getList(vm.masterSizeScalesModel, generalProperties, sellerId);
			$mdDialog.show({
				controller: 'addUpdateSizeScaleController',
				controllerAs: 'vm',
				templateUrl: 'app/main/accounts/sellers/details/tabs/size-scale-groups/dialogs/add-update-size-scale.html',
				parent: angular.element($document.body),
				targetEvent: ev,
				clickOutsideToClose: false,
				locals: {
					record: record,
					isNew: angular.isDefined(record)? false: true,
					model: vm.sizeScaleGroupsModel,
					promises: promises,
					existingRecordsForUniqueValue: angular.copy(existingRecordsForUniqueValue),
					sellerId: sellerId,
					event: ev
				}
			}).then(function(saved) {
				if (saved) {
					refreshSizeScaleGroups(true, false);
				}
			});
		}

		function doSeasonlessAttributesItemAction(action, record) {
			if (action && record) {
				switch (action.id) {
					case 'edit':
							editSeasonlessAttributes(record, null);
							break;
					case 'delete':
					case 'activate':
							vm.seasonlessAttributesModel.methods.activateBulk(record, vm.seasonlessAttributesModel, action.id, sellerId).then(function() {
								refreshSeasonlessAttributes(true, false);
							});
							break;
				}
			}
		}

		function doSeasonlessAttributesListAction(action, records) {
			if (action) {
					switch (action.id) {
							case 'delete':
							case 'activate':
									vm.seasonlessAttributesModel.methods.activateBulk(records, vm.seasonlessAttributesModel, action.id, sellerId).then(function() {
										refreshSeasonlessAttributes(true, false);
									})
									break;
					}
			}
		}

		function addSeasonlessAttributes(ev) {
			var lookupExtras = {};
			lookupExtras['lists.availableSeasonlessAttributeList'] = {};
			lookupExtras['lists.availableSeasonlessAttributeList']['sellerId'] = sellerId;
			api.showCreateRecordDialog(angular.element($document.body), ev, vm.seasonlessAttributesModel, sellerId, undefined, lookupExtras, undefined)
				.then(function (saved) {
					if (saved) {
						refreshSeasonlessAttributes(true, false);
					}
				});
		}

		function editSeasonlessAttributes(record, ev) {
			var lookupExtras = {};
			lookupExtras['lists.availableSeasonlessAttributeList'] = {};
			lookupExtras['lists.availableSeasonlessAttributeList']['sellerId'] = sellerId;
			api.showEditRecordDialog(angular.element($document.body), ev, vm.seasonlessAttributesModel, record, sellerId, lookupExtras)
			.then(function(saved) {
					if (saved) {
							refreshSeasonlessAttributes(true, false);
					}
			});
		}

		function doSeasonlessModelAttributesItemAction(action, record) {
			if (action && record) {
				switch (action.id) {
					case 'edit':
							editSeasonlessModelAttributes(record, null);
							break;
					case 'delete':
					case 'activate':
							vm.seasonlessModelAttributesModel.methods.activateBulk(record, vm.seasonlessModelAttributesModel, action.id, sellerId);
							break;
				}
			}
		}

		function doSeasonlessModelAttributesListAction(action, records) {
			if (action) {
					switch (action.id) {
							case 'delete':
							case 'activate':
									vm.seasonlessModelAttributesModel.methods.activateBulk(records, vm.seasonlessModelAttributesModel, action.id, sellerId);
									break;
					}
			}
		}

		// take the id from the event rather than from vm.seasonlessModelAttributeGroupId: the dropdown's two way
		// binding has not synced back yet at this point, so the property still holds the previously shown group
		function onSeasonlessModelAttributeGroupChange(attributeGroupId) {
			vm.seasonlessModelAttributeGroupId = attributeGroupId;
			attributeGroupSelector.setSelectedId('sellers.seasonlessModelAttributes', sellerId, attributeGroupId);
			refreshSeasonlessModelAttributes(true, false);
		}

		function addSeasonlessModelAttributes(ev) {
			var lookupExtras = {};
			lookupExtras['lists.availableSeasonlessModelAttributeList'] = {};
			lookupExtras['lists.availableSeasonlessModelAttributeList']['sellerId'] = sellerId;
			api.showCreateRecordDialog(angular.element($document.body), ev, vm.seasonlessModelAttributesModel, sellerId, undefined, lookupExtras)
				.then(function (saved) {
					if (saved) {
						refreshSeasonlessModelAttributes(true, false);
					}
				});
		}

		function editSeasonlessModelAttributes(record, ev) {
			var lookupExtras = {};
			lookupExtras['lists.availableSeasonlessModelAttributeList'] = {};
			lookupExtras['lists.availableSeasonlessModelAttributeList']['sellerId'] = sellerId;
			api.showEditRecordDialog(angular.element($document.body), ev, vm.seasonlessModelAttributesModel, record, sellerId, lookupExtras)
			.then(function(saved) {
					if (saved) {
							refreshSeasonlessModelAttributes(true, false);
					}
			});
		}

		function doArticleDropReasonsItemAction(action, record) {
			if (action && record) {
				switch (action.id) {
					case 'edit':
						editArticleDropReasons(record, null);
						break;
					case 'delete':
					case 'activate':
						vm.articleDropReasonsModel.methods.activateBulk(record, vm.articleDropReasonsModel, action.id, sellerId).then(function() {
							refreshArticleDropReasons(true, false);
						});
						break;
				}
			}
		}

		function doArticleDropReasonsListAction(action, records) {
			if (action) {
				switch (action.id) {
					case 'delete':
					case 'activate':
						vm.articleDropReasonsModel.methods.activateBulk(records, vm.articleDropReasonsModel, action.id, sellerId).then(function() {
							refreshArticleDropReasons(true, false);
						});
						break;
				}
			}
		}

		function addArticleDropReasons(ev) {
			var existingRecordsForUniqueValue = angular.copy(vm.articleDropReasons);
			api.showCreateRecordDialog(angular.element($document.body), ev, vm.articleDropReasonsModel, sellerId, undefined, undefined, undefined, undefined, existingRecordsForUniqueValue)
				.then(function (saved) {
					if (saved) {
						refreshArticleDropReasons(true, false);
					}
				});
		}

		function editArticleDropReasons(record, ev) {
			var existingRecordsForUniqueValue = angular.copy(vm.articleDropReasons);
			for (var i = 0; i < existingRecordsForUniqueValue.length; i++) {
				if(existingRecordsForUniqueValue[i].Id === record.Id) {
					existingRecordsForUniqueValue.splice(i, 1);
				}
			}
			api.showEditRecordDialog(angular.element($document.body), ev, vm.articleDropReasonsModel, record, sellerId, undefined, undefined, undefined, existingRecordsForUniqueValue)
			.then(function(saved) {
					if (saved) {
							refreshArticleDropReasons(true, false);
					}
			});
		}

		// -------------------- Design Option Attributes --------------------
		function refreshDesignOptionAttributes(forceFetch, isLogRequired) {
			var generalProperties = {
				forceFetch: forceFetch,
				isLogRequired: isLogRequired
			};
			vm.isDesignOptionAttributesLoading = true;
			vm.designOptionAttributesModel.methods.getList(generalProperties, sellerId).then(function (response) {
				vm.designOptionAttributes = response.data;
			}).finally(function () {
				vm.isDesignOptionAttributesLoading = false;
			});
		}

		function doDesignOptionAttributesItemAction(action, record) {
			if (action && record) {
				switch (action.id) {
					case 'edit':
						editDesignOptionAttribute(record, null);
						break;
					case 'editSortOrder':
						editDesignOptionAttributeSortOrder(record, null);
						break;
					case 'delete':
					case 'activate':
						vm.designOptionAttributesModel.methods.activateBulk(record, vm.designOptionAttributesModel, action.id, sellerId).then(function () {
							refreshDesignOptionAttributes(true, false);
						});
						break;
				}
			}
		}

		function doDesignOptionAttributesListAction(action, records) {
			if (action) {
				switch (action.id) {
					case 'delete':
					case 'activate':
						vm.designOptionAttributesModel.methods.activateBulk(records, vm.designOptionAttributesModel, action.id, sellerId).then(function () {
							refreshDesignOptionAttributes(true, false);
						});
						break;
					case 'editBulkSortOrder':
						openDesignOptionAttributeSortOrderDialog(vm.designOptionAttributes);
						break;
				}
			}
		}

		function addDesignOptionAttribute(ev) {
			var lookupExtras = {};
			lookupExtras['lists.availableDesignOptionAttributeList'] = {};
			lookupExtras['lists.availableDesignOptionAttributeList']['sellerId'] = sellerId;
			api.showCreateRecordDialog(angular.element($document.body), ev, vm.designOptionAttributesModel, sellerId, undefined, lookupExtras, undefined)
				.then(function (saved) {
					if (saved) {
						refreshDesignOptionAttributes(true, false);
					}
				});
		}

		function editDesignOptionAttribute(record, ev) {
			// Base model already restricts edit to Allowed Values + Sort Order (Name/Type are read-only).
			// Seed sellerId for the attribute picker's lookup: the dialog still pre-loads it (the
			// picker field is creatable) even though it is not shown in edit mode.
			var lookupExtras = {};
			lookupExtras['lists.availableDesignOptionAttributeList'] = {};
			lookupExtras['lists.availableDesignOptionAttributeList']['sellerId'] = sellerId;
			api.showEditRecordDialog(angular.element($document.body), ev, vm.designOptionAttributesModel, record, sellerId, lookupExtras)
			.then(function (saved) {
				if (saved) {
					refreshDesignOptionAttributes(true, false);
				}
			});
		}

		// Single-row sort order reuses the bulk-updater dialog (one pre-selected record) so it
		// always issues PUT .../designoptions/attributes/sortorder with the correct sellerId.
		function editDesignOptionAttributeSortOrder(record, ev) {
			openDesignOptionAttributeSortOrderDialog([angular.extend({}, record, { selected: true })]);
		}

		function openDesignOptionAttributeSortOrderDialog(records) {
			var modelCopy = angular.copy(vm.designOptionAttributesModel);
			angular.forEach(modelCopy.fields, function (field) {
				if (field.field !== 'SortOrder' && field.editable) {
					field.editable = false;
				} else if (field.field === 'SortOrder') {
					field.editable = true;
				}
			});
			bulkUpdater.showDialog(modelCopy, records, null, {})
			.then(function (response) {
				if (angular.isDefined(response) && response.toString() != 'false') {
					vm.designOptionAttributesModel.methods.editSortOrder(response.selectedRecords, response.propertiesToUpdate, sellerId).then(function () {
						toast.success('DESIGN_OPTION_ATTRIBUTES.MESSAGES.UPDATE_SUCCESS', '', '');
						refreshDesignOptionAttributes(true, false);
					});
				}
			});
		}

		function doMasterSizeScalesItemAction(action, record) {
			if (action && record) {
				switch (action.id) {
					case 'edit':
							editMasterSizeScales(record, null, false);
							break;
					case 'delete':
					case 'activate':
							vm.masterSizeScalesModel.methods.activateBulk(record, vm.masterSizeScalesModel, action.id, sellerId);
							break;
					case 'editCriteria':
						editMasterSizeScales(record, null, true);
						break;
				}
			}
		}

		function doMasterSizeScalesListAction(action, records) {
			if (action) {
				switch (action.id) {
					case 'import':
						var modelCopy = angular.copy(vm.masterSizeScalesModel);
						utility.filterObject(modelCopy.fields, {field: 'Status'}, true)[0].creatable = true;
						var sizesImportField = utility.filterObject(modelCopy.fields, {field: 'Sizes', inputType: 'text'}, true)[0];
						sizesImportField.creatable = true;
						sizesImportField.duplicateCheckSeparator = ','; // Sizes imports as free text; reject cells that contain duplicate sizes
						utility.filterObject(modelCopy.fields, {field: 'Sizes', inputType: 'tags'}, true)[0].creatable = false;
						dataImporter.importExcel(modelCopy, true).then(function(result) {
							vm.masterSizeScalesModel.methods.createBulk(vm.masterSizeScalesModelCopy, result.data, sellerId);
						});
						break;
					case 'delete':
					case 'activate':
						vm.masterSizeScalesModel.methods.activateBulk(records, vm.masterSizeScalesModel, action.id, sellerId);
						break;
					case 'updateBulkCriteria':
						editMasterSizeScales(records, null, true);
						break;
				}
			}
		}

		function addMasterSizeScales(ev) {
			$mdDialog.show({
				controller: 'addUpdateMasterSizeScaleController',
				controllerAs: 'vm',
				templateUrl: 'app/main/accounts/sellers/details/tabs/master-size-scales/dialogs/add-update-master-size-scale.html',
				parent: angular.element($document.body),
				targetEvent: ev,
				clickOutsideToClose: false,
				locals: {
					record: null,
					isNew: true,
					model: vm.masterSizeScalesModel,
					existingRecordsForUniqueValue: angular.copy(vm.masterSizeScales),
					sellerId: sellerId,
					// seasonless model attributes can be in different attribute groups resulting in duplicate entries. Filter to the
					// ACTIVE CATALOG's group, not the group the attributes tab happens to be showing: a master size scale's criteria
					// is evaluated against articles of the active catalog, so criteria built from another group could never resolve.
					availableSeasonlessModelAttributes: utility.filterObject(vm.seasonlessModelAttributes, {AttributeGroupId : activeCatalog.AttributeGroupId}, true),
					isEditCriteria: false,
					event: ev
				}
			}).then(function(saved) {
				if (saved) {
					refreshMasterSizeScales(true, false);
				}
			});
		}

		function editMasterSizeScales(record, ev, isEditCriteria) {
			var existingRecordsForUniqueValue = angular.copy(vm.masterSizeScales);
			for (var i = 0; i < existingRecordsForUniqueValue.length; i++){
				if(existingRecordsForUniqueValue[i].Id === record.Id) {
					existingRecordsForUniqueValue.splice(i, 1);
				}
			}
			$mdDialog.show({
				controller: 'addUpdateMasterSizeScaleController',
				controllerAs: 'vm',
				templateUrl: 'app/main/accounts/sellers/details/tabs/master-size-scales/dialogs/add-update-master-size-scale.html',
				parent: angular.element($document.body),
				targetEvent: ev,
				clickOutsideToClose: false,
				locals: {
					record: record,
					isNew: angular.isDefined(record)? false: true,
					model: vm.masterSizeScalesModel,
					existingRecordsForUniqueValue: existingRecordsForUniqueValue,
					sellerId: sellerId,
					// seasonless model attributes can be in different attribute groups resulting in duplicate entries. Filter to the
					// ACTIVE CATALOG's group, not the group the attributes tab happens to be showing: a master size scale's criteria
					// is evaluated against articles of the active catalog, so criteria built from another group could never resolve.
					availableSeasonlessModelAttributes: utility.filterObject(vm.seasonlessModelAttributes, {AttributeGroupId : activeCatalog.AttributeGroupId}, true),
					isEditCriteria: isEditCriteria,
					event: ev
				}
			}).then(function(saved) {
				if (saved) {
					refreshMasterSizeScales(true, false);
				}
			});
		}

		// Capacities -----------------------------------------------------------

		function doCapacitiesItemAction(action, record) {
			if (action && record) {
				switch (action.id) {
					case 'view':
						viewCapacity(record);
						break;
					case 'edit':
						openCapacityDialog(record, null);
						break;
					case 'delete':
					case 'activate':
						// dropped capacities stay visible in the list (Status flips in place via onRecordStatusChange)
						vm.capacitiesModel.methods.activateBulk(record, vm.capacitiesModel, action.id, sellerId);
						break;
				}
			}
		}

		function doCapacitiesListAction(action, records) {
			if (action) {
				switch (action.id) {
					case 'import':
						var modelCopy = angular.copy(vm.capacitiesModel);
						// Import-level validations:
						//  - Name: present (isRequired) + unique WITHIN the file (uniqueConstraints). Not checked against
						//    existing capacities on purpose — the backend import upserts by Name (a matching name updates).
						//  - Criteria: present (required, non-empty) + valid JSON (checkIfValidJson).
						// NOTE(relaxed): attribute system-names inside the Criteria JSON are intentionally NOT validated
						//    against the real attribute list on import — only JSON validity is enforced. Any condition whose
						//    Attribute is unknown is skipped when the record is later edited (see populateEditDialog in
						//    create-capacity.controller.js).
						utility.filterObject(modelCopy.fields, {field: 'Name'}, true)[0].creatable = true;
						var criteriaField = utility.filterObject(modelCopy.fields, {field: 'Criteria'}, true)[0];
						criteriaField.creatable = true;
						criteriaField.validation.isRequired = true;
						criteriaField.validation.minLen = 1;
						modelCopy.uniqueConstraints = [{ name: 'Constraint 1', fields: ['Name'] }];
						dataImporter.importExcel(modelCopy, true).then(function(result) {
							vm.capacitiesModel.methods.createBulk(vm.capacitiesModel, result.data, sellerId);
						});
						break;
					case 'delete':
					case 'activate':
						vm.capacitiesModel.methods.activateBulk(records, vm.capacitiesModel, action.id, sellerId);
						break;
				}
			}
		}

		function addCapacity(ev) {
			openCapacityDialog(null, ev);
		}

		function openCapacityDialog(record, ev) {
			// global attributes list feeds the criteria builder's attribute autocomplete
			api.attributes.attributes.methods.getList({ forceFetch: false, isLogRequired: false }).then(function(response) {
				var availableAttributes = response.data;
				var existingRecordsForUniqueValue = angular.copy(vm.capacities);
				if (record && record.CapacityId) {
					for (var i = 0; i < existingRecordsForUniqueValue.length; i++) {
						if (existingRecordsForUniqueValue[i].CapacityId === record.CapacityId) {
							existingRecordsForUniqueValue.splice(i, 1);
							break;
						}
					}
				}
				$mdDialog.show({
					controller: 'createCapacityController',
					controllerAs: 'vm',
					templateUrl: 'app/main/accounts/sellers/details/tabs/capacities/dialogs/create-capacity/create-capacity.html',
					parent: angular.element($document.body),
					targetEvent: ev,
					clickOutsideToClose: false,
					locals: {
						record: record || null,
						isNew: !(record && record.CapacityId),
						model: vm.capacitiesModel,
						existingRecordsForUniqueValue: existingRecordsForUniqueValue,
						sellerId: sellerId,
						availableAttributes: availableAttributes,
						event: ev
					}
				}).then(function(saved) {
					if (saved) {
						refreshCapacities(true, false);
					}
				});
			});
		}

		function viewCapacity(record) {
			$state.go('app.seller_capacity_details', { sellerId: sellerId, capacityId: record.CapacityId, capacity: record });
		}

		function doLookupDefinitionsItemAction(action, record) {
			if (action && record) {
				switch (action.id) {
					case 'view':
							viewLookupDefinition(record);
							break;
					case 'delete':
						vm.lookupDefinitionsModel.methods.delete(record, sellerId, record[vm.lookupDefinitionsModel.idField]).then(function () {
								refreshLookupDefinitions(true, false);
							});
							break;
				}
			}
		}

		function addLookupDefinition(ev) {
			return $mdDialog.show({
				controller: 'createLookupTable',
				controllerAs: 'vm',
				templateUrl: 'app/main/accounts/sellers/details/tabs/seller-lookup-table/dialogs/create-seller-lookup/create-seller-lookup.html',
				parent: angular.element($document.body),
				targetEvent: ev,
				clickOutsideToClose: false,
				locals: {
					model: angular.copy(vm.lookupDefinitionsModel),
					sellerId: sellerId,
					existingRecordsForUniqueValue: angular.copy(vm.lookupDefinitions),
					event: ev
				}
			}).then(function (saved) {
				if (saved) {
					refreshLookupDefinitions(true, false);
				}
			});
		}

		function viewLookupDefinition(record) {
			var stateParams = { id: record[vm.lookupDefinitionsModel.idField], sellerId: sellerId, lookup: record};
			$state.go('app.lookup_table_details', stateParams);
		}

		function doSellerConfigurationsItemAction(action, item) {
			if (action && item) {
				switch (action.id) {
					case 'edit':
						editSellerConfiguration(item, null);
						break;
					case 'delete':
						vm.sellerConfigurationsModel.methods.delete(item, action.id, sellerId)
							.then(function () {
								refreshSellerConfigurations(true, false);
							});
						break;
				}
			}
		}

		function doSellerConfigurationsListAction(action, items) {
			if (action) {
				switch (action.id) {
					case 'delete':
						vm.sellerConfigurationsModel.methods.delete(items, action.id, sellerId)
							.then(function () {
								refreshSellerConfigurations(true, false);
							});
						break;
					case 'import':
						dataImporter.importExcel(api.sellers.importConfigurations, true).then(function (result) {
							vm.sellerConfigurationsModel.methods.createBulk(api.sellers.importConfigurations, result.data, sellerId);
						});
						break;
				}
			}
		}

		function addSellerConfiguration(ev) {
			$mdDialog.show({
				controller: 'createSellerConfigurationController',
				controllerAs: 'vm',
				templateUrl: 'app/main/catalogs/details/tabs/configurations/dialogs/update-configuration.html',
				parent: angular.element($document.body),
				targetEvent: ev,
				clickOutsideToClose: false,
				locals: {
					model: vm.sellerConfigurationsModel,
					record: {},
					sellerId: sellerId,
					isNew: true,
					event: ev
				}
			}).then(function (saved) {
				if (saved) {
					refreshSellerConfigurations(true, false);
				}
			});
		}

		function editSellerConfiguration(record, ev) {
			$mdDialog.show({
				controller: 'createSellerConfigurationController',
				controllerAs: 'vm',
				templateUrl: 'app/main/catalogs/details/tabs/configurations/dialogs/update-configuration.html',
				parent: angular.element($document.body),
				targetEvent: ev,
				clickOutsideToClose: false,
				locals: {
					model: vm.sellerConfigurationsModel,
					record: record,
					sellerId: sellerId,
					isNew: false,
					event: ev
				}
			}).then(function (saved) {
				if (saved) {
					refreshSellerConfigurations(true, false);
				}
			});
		}

		function doSellerColorsItemAction(action, record) {
			if (action && record) {
				switch (action.id) {
					case 'edit':
							var existingRecordsForUniqueValue = angular.copy(vm.sellerColors);
							for (var i = 0; i < existingRecordsForUniqueValue.length; i++){
								if(existingRecordsForUniqueValue[i].Id === record.Id) {
									existingRecordsForUniqueValue.splice(i, 1);
								}
							}
							api.showEditRecordDialog(angular.element($document.body), null, vm.sellerColorsModel, record, sellerId, undefined, undefined, undefined, undefined, existingRecordsForUniqueValue)
							.then(function(saved) {
									if (saved) {
										refreshSellerColors(true, false);
									}
							});
							break;
				}
			}
		}

		function doSellerColorsListAction(action) {
			if (action) {
				switch (action.id) {
					case 'import':
						dataImporter.importExcel(vm.sellerColorsModel, true).then(function (result) {
							vm.sellerColorsModel.methods.createBulk(result.data, sellerId).then(function() {
								refreshSellerColors(true, false);
							})
						});
						break;
				}
			}
		}

		function addSellerColor(ev) {
			 var defaultValues = {ColorType: 'Solid'};
			api.showCreateRecordDialog(angular.element($document.body), ev, vm.sellerColorsModel, sellerId, defaultValues)
				.then(function (saved) {
					if (saved) {
						refreshSellerColors(true, false);
					}
				});
		}

		function doDatasetDefinitionItemAction(action, record) {
			if (action && record) {
				switch (action.id) {
					case 'view':
							viewDatasetDefinition(record);
							break;
					case 'edit':
						editDatasetDefinition(record, null);
						break;
					case 'delete':
					case 'activate':
						vm.dataSetDefinitionsModel.methods.activateBulk(record, vm.dataSetDefinitionsModel, action.id, sellerId).then(function() {
							refreshDatasetDefinitions(true, false);
						});
						break;
				}
			}
		}

		function doDatasetDefinitionListAction(action, records) {
			if (action) {
				switch (action.id) {
					case 'delete':
					case 'activate':
						vm.dataSetDefinitionsModel.methods.activateBulk(records, vm.dataSetDefinitionsModel, action.id, sellerId).then(function() {
							refreshDatasetDefinitions(true, false);
						});
						break;
				}
			}
		}

		function addDatasetDefinition(ev) {
			var lookupPromises = {};
			lookupPromises = crud.createLookupPromise(vm.dataSetDefinitionsModel, undefined, 'create');
			return $mdDialog.show({
				controller: 'createUpdateDatasets',
				controllerAs: 'vm',
				templateUrl: 'app/main/accounts/sellers/details/tabs/seller-datasets/dialogs/create-seller-datasets/create-seller-datasets.html',
				parent: angular.element($document.body),
				targetEvent: ev,
				clickOutsideToClose: false,
				locals: {
					model: angular.copy(vm.dataSetDefinitionsModel),
					sellerId: sellerId,
					record: null,
					isNew: true,
					existingRecordsForUniqueValue: angular.copy(vm.datasetDefinitions),
					lookupPromises: lookupPromises,
					event: ev
				}
			}).then(function (saved) {
				if (saved) {
					refreshDatasetDefinitions(true, false);
				}
			});
		}

		function editDatasetDefinition(record, ev) {
			var lookupPromises = {};
			lookupPromises = crud.createLookupPromise(vm.dataSetDefinitionsModel, undefined, 'edit');
			var existingRecordsForUniqueValue = angular.copy(vm.datasetDefinitions);
			for (var i = 0; i < existingRecordsForUniqueValue.length; i++) {
				if(existingRecordsForUniqueValue[i].Id === record.Id) {
					existingRecordsForUniqueValue.splice(i, 1);
				}
			}
			return $mdDialog.show({
				controller: 'createUpdateDatasets',
				controllerAs: 'vm',
				templateUrl: 'app/main/accounts/sellers/details/tabs/seller-datasets/dialogs/create-seller-datasets/create-seller-datasets.html',
				parent: angular.element($document.body),
				targetEvent: ev,
				clickOutsideToClose: false,
				locals: {
					model: angular.copy(vm.dataSetDefinitionsModel),
					sellerId: sellerId,
					record: angular.copy(record),
					isNew: false,
					existingRecordsForUniqueValue: existingRecordsForUniqueValue,
					lookupPromises: lookupPromises,
					event: ev
				}
			}).then(function () {
				// Edit triggers a background job; the banner appears when the job completes
				// and the list refreshes when the user clicks the banner.
			});
		}

		function viewDatasetDefinition(record) {
			var stateParams = { id: record[vm.dataSetDefinitionsModel.idField], sellerId: sellerId, dataset: record};
			$state.go('app.dataset_details', stateParams);
		}

		// assign tab index for each tab
		function onActiveTabChange(tabIndex) {
			vm.tabIndex = tabIndex;
		}

		// Persist active tab (positional index) whenever it changes via md-selected two-way binding
		$scope.$watch('vm.selectedTabPosition', function(newVal) {
			if(angular.isDefined(newVal) && newVal !== null) {
				$sessionStorage.sellerDetailsActiveTab = newVal;
				$sessionStorage.sellerDetailsActiveSellerId = sellerId;
			}
		});

		function initializeTabData(isLogRequired) {
			if(vm.seller.Status !== 0) {
				isTabDataInitialized = true;
				if(SecurityFactory.isAuthorized({accessPrivileges: CONSTANTS.PRIVILEGES.SELLERS.DETAIL.USERS_LIST})) {
					refreshUsers(vm.usersModel.isDirty, isLogRequired);
				}
				if(SecurityFactory.isAuthorized({accessPrivileges: CONSTANTS.PRIVILEGES.SELLERS.DETAIL.CATALOGS_LIST})) {
					refreshCatalogs(vm.catalogsModel.isDirty, isLogRequired);
				}
				if(SecurityFactory.isAuthorized({accessPrivileges: CONSTANTS.PRIVILEGES.SELLERS.DETAIL.CUSTOMERS_LIST})) {
					refreshCustomers(vm.customersModel.isDirty, isLogRequired);
				}
				if(SecurityFactory.isAuthorized({accessPrivileges: CONSTANTS.PRIVILEGES.SELLERS.DETAIL.RESOURCE_TYPES_LIST})) {
					refreshResourceTypes(vm.resourceTypesModel.isDirty, isLogRequired);
				}
				if(SecurityFactory.isAuthorized({accessPrivileges: CONSTANTS.PRIVILEGES.SELLERS.DETAIL.ORDER_TYPES_LIST})) {
					refreshOrderTypes(vm.orderTypesModel.isDirty, isLogRequired);
				}
				if(SecurityFactory.isAuthorized({accessPrivileges: CONSTANTS.PRIVILEGES.SELLERS.DETAIL.VAS_LIST})) {
					refreshVAS(vm.VASModel.isDirty, isLogRequired);
				}
				if(SecurityFactory.isAuthorized({accessPrivileges: CONSTANTS.PRIVILEGES.SELLERS.DETAIL.SIZE_SCALE_GROUPS_LIST})) {
					refreshSizeScaleGroups(vm.sizeScaleGroupsModel.isDirty, isLogRequired);
				}
				if(SecurityFactory.isAuthorized({accessPrivileges: CONSTANTS.PRIVILEGES.SELLERS.DETAIL.SEASONLESS_ATTRIBUTES_LIST})) {
					refreshSeasonlessAttributes(vm.seasonlessAttributesModel.isDirty, isLogRequired);
				}
				if(SecurityFactory.isAuthorized({accessPrivileges: CONSTANTS.PRIVILEGES.SELLERS.DETAIL.SEASONLESS_MODEL_ATTRIBUTES_LIST})) {
					refreshSeasonlessModelAttributes(vm.seasonlessModelAttributesModel.isDirty, isLogRequired);
				}
				if(SecurityFactory.isAuthorized({accessPrivileges: CONSTANTS.PRIVILEGES.SELLERS.DETAIL.ARTICLE_DROP_REASONS_LIST})) {
					refreshArticleDropReasons(vm.articleDropReasonsModel.isDirty, isLogRequired);
				}
				if(SecurityFactory.isAuthorized({accessPrivileges: CONSTANTS.PRIVILEGES.SELLERS.DETAIL.MASTER_SIZE_SCALE_GROUPS_LIST})) {
					refreshMasterSizeScales(vm.masterSizeScalesModel.isDirty, isLogRequired);
				}
				if(SecurityFactory.isAuthorized({accessPrivileges: CONSTANTS.PRIVILEGES.SELLERS.DETAIL.SELLER_LOOKUP_TABLE})) {
					refreshLookupDefinitions(vm.lookupDefinitionsModel.isDirty, isLogRequired);
				}
				if(SecurityFactory.isAuthorized({accessPrivileges: CONSTANTS.PRIVILEGES.SELLERS.DETAIL.CONFIGURATIONS})) {
					refreshSellerConfigurations(vm.lookupDefinitionsModel.isDirty, isLogRequired);
				}
				if(SecurityFactory.isAuthorized({accessPrivileges: CONSTANTS.PRIVILEGES.SELLERS.DETAIL.SELLER_COLORS})) {
					refreshSellerColors(vm.lookupDefinitionsModel.isDirty, isLogRequired);
				}
				if(SecurityFactory.isAuthorized({accessPrivileges: CONSTANTS.PRIVILEGES.SELLERS.DETAIL.GET_DATASET_DEFINITIONS})) {
					refreshDatasetDefinitions(vm.lookupDefinitionsModel.isDirty, isLogRequired);
				}
				if(SecurityFactory.isAuthorized({accessPrivileges: CONSTANTS.PRIVILEGES.SELLERS.DETAIL.CAPACITIES_LIST})) {
					refreshCapacities(vm.capacitiesModel.isDirty, isLogRequired);
				}
				if(SecurityFactory.isAuthorized({accessPrivileges: CONSTANTS.PRIVILEGES.SELLERS.DETAIL.DESIGN_OPTION_ATTRIBUTES})) {
					refreshDesignOptionAttributes(vm.designOptionAttributesModel.isDirty, isLogRequired);
				}
			}
		}

		// Seller Resources methods
		function refreshSellerResources(forceFetch, isLogRequired) {
			if(!vm.sellerAttributeGroupId) return;
			var generalProperties = {
				forceFetch: forceFetch,
				isLogRequired: isLogRequired
			};
			vm.isSellerResourcesLoading = true;
			// Ensure global resource types lookup is loaded for TypeId column display
			if(!api.lists.resourceTypes.lookupData) {
				api.getLookupData(api.lists.resourceTypes);
			}
			vm.sellerResourcesModel.methods.getList(generalProperties, sellerId, vm.sellerAttributeGroupId)
			.then(function(response) {
				vm.sellerResources = response.data;
			})
			.finally(function() {
				vm.isSellerResourcesLoading = false;
			});
		}

		function doSellerResourcesItemAction(action, record) {
			if(action && record) {
				switch (action.id) {
					case 'view':
						viewSellerResource(record);
						break;
					case 'edit':
						vm.sellerResourcesModel.methods.getDetails(true, record[vm.sellerResourcesModel.idField], sellerId, vm.sellerAttributeGroupId)
						.then(function(response) {
							editSellerResource(response.data, null);
						});
						break;
					case 'editSortOrder':
						editSellerResourceSortOrder(record, null);
						break;
					case 'delete':
					case 'activate':
						vm.sellerResourcesModel.methods.activateBulk(record, vm.sellerResourcesModel, action.id, sellerId, vm.sellerAttributeGroupId);
						break;
				}
			}
		}

		function doSellerResourcesListAction(action, records) {
			if(action && records) {
				switch (action.id) {
					case 'delete':
					case 'activate':
						vm.sellerResourcesModel.methods.activateBulk(records, vm.sellerResourcesModel, action.id, sellerId, vm.sellerAttributeGroupId);
						break;
					case 'upload':
						uploadSellerResources();
						break;
					case 'import':
						prepareSellerImportModel();
						dataImporter.importExcel(api.sellers.mapResourcesToArticles, true).then(function(result) {
							vm.sellerResourcesModel.methods.createBulk(vm.sellerResourcesModel, result.data, sellerId, vm.sellerAttributeGroupId, result.isModelLevelImport);
						});
						break;
					case 'editBulkSortOrder':
						var modelCopy = angular.copy(vm.sellerResourcesModel);
						angular.forEach(modelCopy.fields, function(field) {
							if(field.field !== 'SortOrder' && field.field !== 'Category' && field.editable) {
								field.editable = false;
							} else if(field.field === 'SortOrder' || field.field === 'Category') {
								field.editable = true;
							}
						});
						bulkUpdater.showDialog(modelCopy, vm.sellerResources, null, {})
						.then(function(response) {
							if(angular.isDefined(response) && response.toString() != 'false') {
								vm.sellerResourcesModel.methods.editSortOrder(response.selectedRecords, response.propertiesToUpdate, sellerId, vm.sellerAttributeGroupId).then(function() {
									toast.success('RESOURCES.MESSAGES.UPDATE_SUCCESS', '', '');
									refreshSellerResources(true, false);
								});
							}
						});
						break;
				}
			}
		}

		function viewSellerResource(record) {
			if(record.Status === 1) {
				var id = record[vm.sellerResourcesModel.idField];
				$state.go('app.seller-resources.details', {id: id});
			}
		}

		function editSellerResource(record, ev) {
			$mdDialog.show({
				controller         : 'createSellerResourceController',
				controllerAs       : 'vm',
				templateUrl        : 'app/main/accounts/sellers/details/tabs/seller-resources/dialogs/create-seller-resource.html',
				parent             : angular.element($document.body),
				targetEvent        : ev,
				clickOutsideToClose: false,
				locals             : {
					model: vm.sellerResourcesModel,
					sellerId: sellerId,
					attributeGroupId: vm.sellerAttributeGroupId,
					record: angular.copy(record),
					isNew: false,
					event: ev
				}
			}).then(function(saved) {
				if (saved) {
					refreshSellerResources(true, false);
				}
			});
		}

		function editSellerResourceSortOrder(record, ev) {
			var modelCopy = angular.copy(vm.sellerResourcesModel);
			var additionalInfo = { 'additionalAction': 'resourcesEditSortOrder'};
			angular.forEach(modelCopy.fields, function(field) {
				if(field.field !== 'SortOrder' && field.editable) {
					field.editable = false;
				} else if(field.field === 'SortOrder') {
					field.editable = true;
				}
			});
			api.showEditRecordDialog(angular.element($document.body), ev, modelCopy, record, undefined, undefined, additionalInfo)
			.then(function(saved) {
				if (saved) {
					refreshSellerResources(true, false);
				}
			});
		}

		function uploadSellerResources() {
			var lookupPromises = {};
			$mdDialog.show({
				controller         : 'uploadResourcesController',
				controllerAs       : 'vm',
				templateUrl        : 'app/main/catalogs/sub-modules/resources/dialogs/upload-resources.html',
				parent             : angular.element($document.body),
				targetEvent        : null,
				clickOutsideToClose: false,
				closeTo            : '#quick-panel-toggle',
				locals             : {
					lookupPromises: lookupPromises,
					model : vm.sellerResourcesModel
				}
			}).then(function (data) {
				if (angular.isDefined(data) && angular.isDefined(data.flowObj)) {
					var index = uploadsTracker.addUpload('Bulk Resources', data.flowObj);
					uploadsTracker.uploads[index].defer.promise.then(function() {
						for (var fileIndex=0, len=uploadsTracker.uploads[index].flow.files.length; fileIndex< len ; fileIndex++) {
							vm.sellerResourcesModel.methods.uploadBulk(uploadsTracker.uploads[index].flow.files[fileIndex].fileId, data.resourceType, sellerId, vm.sellerAttributeGroupId, vm.sellerResourcesModel);
						}
					});
				}
			});
		}

		function addSellerResource(ev) {
			$mdDialog.show({
				controller         : 'createSellerResourceController',
				controllerAs       : 'vm',
				templateUrl        : 'app/main/accounts/sellers/details/tabs/seller-resources/dialogs/create-seller-resource.html',
				parent             : angular.element($document.body),
				targetEvent        : ev,
				clickOutsideToClose: false,
				locals             : {
					model: vm.sellerResourcesModel,
					sellerId: sellerId,
					attributeGroupId: vm.sellerAttributeGroupId,
					record: null,
					isNew: true,
					event: ev
				}
			}).then(function(saved) {
				if (saved) {
					refreshSellerResources(true, false);
				}
			});
		}

		// Pre-load seller articles and models lookups (first page) and store base URLs for server-side search
		function preloadSellerLookups() {
			var articlesBaseUrl = api.baseUrl + '/sellers/' + sellerId + '/attributegroups/' + vm.sellerAttributeGroupId + '/articles?getSimplifiedSellerArticles=1';
			var modelsBaseUrl = api.baseUrl + '/sellers/' + sellerId + '/' + vm.sellerAttributeGroupId + '/models';

			// Store base URLs so dialogs can make filtered requests
			api.sellers.sellerArticlesLookup._baseUrl = articlesBaseUrl;
			api.sellers.sellerModelsLookup._baseUrl = modelsBaseUrl;

			// Load first page for initial display
			api.sellers.sellerArticlesLookup._loadPromise = api.webGet(articlesBaseUrl + '&page=1&pageSize=100', undefined, true, true)
			.then(function(response) {
				var lookupData = (response.data || []).map(function(item) {
					return { id: item.Id || item.ArticleId, value: item.ArticleNumber, Status: item.Status || 1 };
				});
				api.sellers.sellerArticlesLookup.lookupData = { data: lookupData, indexArray: [] };
				return api.sellers.sellerArticlesLookup.lookupData;
			});
			api.sellers.sellerModelsLookup._loadPromise = api.webGet(modelsBaseUrl + '?page=1&pageSize=100', undefined, true, true)
			.then(function(response) {
				var lookupData = (response.data || []).map(function(item) {
					return { id: item.Id || item.ModelId, value: item.ModelNumber, Status: item.Status || 1 };
				});
				api.sellers.sellerModelsLookup.lookupData = { data: lookupData, indexArray: [] };
				return api.sellers.sellerModelsLookup.lookupData;
			});
		}

		// Prepare import model fields and load resources for FileName validation
		function prepareSellerImportModel() {
			var importModel = api.sellers.mapResourcesToArticles;
			var articlesField = utility.filterObject(importModel.fields, {field: 'ArticleNumber'}, true)[0];
			var fileNameField = utility.filterObject(importModel.fields, {field: 'FileName'}, true)[0];

			// Set up ArticleNumber field as lookup (data already cached by preloadSellerLookups)
			articlesField.inputType = 'lookup';
			articlesField.lookupSource = 'sellers.sellerArticlesLookup';
			articlesField.lookupFilter = {Status: 1};
			articlesField.useLookupName = true;

			// Load seller resources for FileName dataExistConstraints
			var resourcesPromise = vm.sellerResourcesModel.methods.getList({forceFetch: true, isLogRequired: false}, sellerId, vm.sellerAttributeGroupId)
			.then(function(response) {
				var resourcesData = (response.data || []).map(function(item) {
					return { FileName: item.FileName, ResourceName: item.ResourceName };
				});
				fileNameField.validation.dataExistConstraints = {data: resourcesData};
			});

			return resourcesPromise;
		}

		var sellerWatchCleanup = $scope.$watch('vm.seller', function(newVal, oldVal) {
			if(newVal && oldVal) {
				var activeCatalog = catalogFactory.getActiveCatalog();
				if(angular.isDefined(activeCatalog) && activeCatalog.AccountId === newVal.AccountId) {
					if(newVal.UseOrderType != oldVal.UseOrderType) {
						$localStorage.UseOrderType = newVal.UseOrderType;
						$sessionStorage.UseOrderTypeSession = angular.copy(newVal.UseOrderType);
					}
					if(newVal.UseConfirmOrder != oldVal.UseConfirmOrder) {
						$localStorage.UseConfirmOrder = newVal.UseConfirmOrder;
						$sessionStorage.UseOrderTypeSession = angular.copy(newVal.UseConfirmOrder);
					}
				}
			}
		});

		$scope.$on('$destroy', function() {
			sellerWatchCleanup();
		})

	}
})();
(function () {
	'use strict';

	angular
		.module('app.main.accounts.interface-users', [])
		.config(config);

	/* @ngInject */
	function config($stateProvider, msNavigationServiceProvider, $translatePartialLoaderProvider) {
		$stateProvider.state('app.accounts_interface_users', {
			url: '/accounts/interface-users',
			views: {
				'content@app': {
					templateUrl: 'app/main/accounts/interface-users/list/interface-users-list.html',
					controller: 'interfaceUsersListController as vm'
				}
			},
			data: {
				displayName: 'INTERFACE_USERS.NAV'
			},
			resolve: {
			},
			// accessPrivileges: ['GetInterfaceUserList']
			accessInfo: {
				accessPrivileges: ['nav_interface_users']
			},
			visibleForLinePlan: true
		});

		// Translation
		$translatePartialLoaderProvider.addPart('app/main/accounts/interface-users');

		// Navigation
		msNavigationServiceProvider.saveItem('main.interfaceUsers', {
			title: 'Interface Users',
			icon: 'icon-account',
			state: 'app.accounts_interface_users',
			translate: 'INTERFACE_USERS.NAV',
			weight: 6,
			// accessPrivileges: ['GetInterfaceUserList'],
			accessInfo: {
				accessPrivileges: ['nav_interface_users']
			},
			visibleForLinePlan: true
		});
	}

})();
(function() {
	'use strict';

	angular
		.module('app.main.accounts.interface-users')
		.controller('interfaceUsersListController', interfaceUsersListController);

	/* @ngInject */
	function interfaceUsersListController(api, $document, $mdDialog, settingsFactory, crud) {
		/* jshint validthis: true */
		var vm = this;

		vm.model = api.accounts.interfaceUsers;
		settingsFactory.applyPersistedListViewLayout(vm.model);

		vm.interfaceUsers = [];
		vm.filteredUsers = [];
		vm.isLoading = false;

		vm.refreshItems = refreshItems;
		vm.doItemAction = doItemAction;
		vm.addRecord = addRecord;
		vm.doListAction = doListAction;

		activate();

		////////////////

		function activate() {
			refreshItems(vm.model.isDirty, true);
		}

		function refreshItems(forceFetch, isLogRequired) {
			//Load WebAPI Environments
			vm.isLoading = true;
			var generalProperties = {
				forceFetch: forceFetch,
				isLogRequired: isLogRequired
			}
			vm.model.methods.getList(generalProperties)
			.then(function(response) {
				vm.interfaceUsers = response.data;
			})
			.finally(function() {
				vm.isLoading = false;
			});
		}

		//Item Action button pressed event
		function doItemAction(action, record) {
			if (action && record) {
				switch (action.id) {
					case 'delete':
					case 'activate':
						vm.model.methods.activateBulk(record, vm.model, action.id);
						break;
				}
			}
		}

		//List Action button pressed event
		function doListAction(action, records) {
			if (action) {
				switch (action.id) {
					case 'delete':
					case 'activate':
						vm.model.methods.activateBulk(records, vm.model, action.id);
						break;
				}
			}
		}

		function addRecord(ev) {
			var lookupPromises = {};
			lookupPromises = crud.createLookupPromise(vm.model, undefined , 'create');
			$mdDialog.show({
				controller: 'createInterfaceUserController',
				controllerAs: 'vm',
				templateUrl: 'app/main/accounts/interface-users/list/dialogs/create-interface-users/create-interface-user.html',
				parent: angular.element($document.body),
				targetEvent: ev,
				clickOutsideToClose: false,
				locals: {
					model: vm.model,
					record: null,
					isNew: true,
					lookupPromises: lookupPromises,
					event: ev
				}
			}).then(function (saved) {
				if (saved) {
					refreshItems(true, false);
				}
			});
		}

	}
})();
(function ()
{
    'use strict';

    angular
        .module('app.main.accounts.buyers', [
            'app.main.accounts.buyers.users',
            'app.main.accounts.buyers.catalogs',
            'app.main.accounts.buyers.customers'
        ])
        .config(config);

    /* @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.accounts_buyers', {
            url    : '/accounts/buyers',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/accounts/buyers/list/buyers-list.html',
                    controller : 'buyersListController as vm'
                }
            },
            data   : {
                displayName: 'BUYERS.NAV'
            },
            resolve: {

            },
            //only users with following accessPrivileges in their role access list can access this route
			// accessPrivileges: ['GetBuyerAccountList']
            // accessPrivileges: ['nav_buyers']
            accessInfo: {
                accessPrivileges: ['nav_buyers']
            },
            visibleForLinePlan: true
        });
        $stateProvider.state('app.accounts_buyers.details', {
			url	 : '/:id',
            views: {
				'content@app': {
					templateUrl: 'app/main/accounts/buyers/details/buyers-details.html',
					controller : 'buyersDetailsController as vm'
				}
			},
			data: {
				parentState: 'app.accounts_buyers',
                displayName: 'BUYERS.TABS.BUYER'
			},
            //only users with following accessPrivileges in their role access list can access this route
            // accessPrivileges: ['GetBuyerAccountDetails']
            accessInfo: {
                accessPrivileges: ['GetBuyerAccountDetails']
            },
            visibleForLinePlan: true
		});

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/accounts/buyers');

        // Navigation
        msNavigationServiceProvider.saveItem('main', {
            title : 'Main',
            translate: 'NAV.MAIN',
            group : true,
            weight: 1
        });

        msNavigationServiceProvider.saveItem('main.buyers', {
            title      : 'Buyers',
            icon       : 'icon-account-outline',
            state      : 'app.accounts_buyers',
            /*stateParams: {
                'param1': 'page'
            },*/
            translate: 'BUYERS.NAV',
            weight     : 2,
            // accessPrivileges: ['GetBuyerAccountList']
            // accessPrivileges: ['nav_buyers'],
            accessInfo: {
                accessPrivileges: ['nav_buyers']
            },
            visibleForLinePlan: true
        });
    }
})();
(function() {
    'use strict';

	angular
		.module('app.main.accounts.buyers')
		.controller('buyersListController', buyersListController);

	/* @ngInject */
	function buyersListController(api, $state, $document, $mdDialog,settingsFactory) {
		/* jshint validthis: true */
		var vm = this;

        vm.model = api.accounts.buyers;
        settingsFactory.applyPersistedListViewLayout(vm.model);

		vm.buyers = [];
		vm.filteredBuyers = [];
		vm.isLoading = false;


		vm.refreshItems = refreshItems;
		vm.doListAction = doListAction;
		vm.doItemAction = doItemAction;
		vm.viewItem = viewItem;
		vm.addRecord = addRecord;

		activate();

		////////////////

		function activate() {
			refreshItems(vm.model.isDirty, true);
		}

		function refreshItems(forceFetch, isLogRequired) {
            var generalProperties = {
                forceFetch: forceFetch,
                isLogRequired: isLogRequired
            }
			vm.isLoading = true;

			vm.model.methods.getList(generalProperties)
			.then(function (buyers) {
				vm.buyers = buyers.data;
			})
			.finally(function () {
				vm.isLoading = false;
			});
		}

		//Item Action button pressed event
		function doItemAction(action, record) {
			if (action && record) {
                switch (action.id) {
                    case 'view':
                        viewItem(record);
                        break;
                    case 'edit':
                        vm.model.methods.getDetails(true, record[vm.model.idField])
                        .then(function (response) {
                            editItem(response.data, null);
                        })
                        break;
                    case 'delete':
                    case 'activate':
                        vm.model.methods.activateBulk(record, vm.model, action.id, undefined);
                    break;
                    case 'merge':
                        mergeItem(record);
                        break;
                }
			}
		}

        //List Action button pressed event
        function doListAction(action, records) {
            if (action) {
                switch (action.id) {
                    case 'delete':
                    case 'activate':
                        vm.model.methods.activateBulk(records, vm.model, action.id, undefined);
                        break;
                }
            }
        }

         function viewItem(record) {
             var id = record[vm.model.idField];
             var stateParams = {id: id};
             $state.go('app.accounts_buyers.details', stateParams);
		}

        function addRecord(ev){
            api.showCreateRecordDialog(angular.element($document.body), ev, vm.model)
            .then(function(saved) {
                if (saved) {
                    refreshItems(true, false);
                }
            });
		}

		function editItem(record, ev) {
            api.showEditRecordDialog(angular.element($document.body), ev, vm.model, record)
            .then(function(saved) {
                if (saved) {
                    refreshItems(true, false);
                }
            });
        }

        function mergeItem(record, ev) {
            return $mdDialog.show({
                controller: 'mergeBuyersController',
                controllerAs: 'vm',
                templateUrl: 'app/main/accounts/buyers/dialogs/merge-buyers.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose: false,
                locals: {
                    record: record,
                    buyers: vm.buyers,
                    model: vm.model,
                    event: ev
                }
            }).then(function (saved) {
                if (saved) {
                    refreshItems(true, false);
                }
            });
        }
	}
})();
(function () {
  'use strict';

  angular
    .module('app.main.accounts.buyers')
    .controller('mergeBuyersController', mergeBuyersController);

  /* @ngInject */
  function mergeBuyersController($scope, $filter, $mdDialog, toast, hotkeys, utility, record, event, buyers, model) {
    /* jshint validthis: true */
    var vm = this;

    //Data
    vm.isLoading = false;
    vm.isDataDirty = false;

    vm.record = {};
    vm.mergeIntoBuyer = {};
    vm.buyersList = [];
    vm.searchText = [];
    vm.lookupModel = [];

    var accountId;

    //Methods
    vm.saveRecord = saveRecord;
    vm.closeDialog = closeDialog;

    vm.loadBuyers = loadBuyers;
    vm.searchBuyer = searchBuyer;
    vm.getBuyerDisplayValue = getBuyerDisplayValue;
    vm.onBuyerChange = onBuyerChange;

    activate();

    ////////////////

    function activate() {
      vm.record = record;
      //Hotkeys
      hotkeys.bindTo($scope).add({
        combo: 'ctrl+enter',
        description: $filter('translate')('ACTIONS.MERGE'),
        allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
        callback: function (event) {
          if (!vm.isLoading && !vm.editForm.$invalid) {
            vm.mergeRecord();
          }
        }
      });
    }

    function saveRecord() {
      vm.isLoading = true;
      // request object for merge buyer api
      var requestObj = {};
      requestObj.FromBuyerAccountId = record.AccountId;
      requestObj.ToBuyerAccountId = vm.mergeIntoBuyer.AccountId;

      model.methods.merge(requestObj, model, 'MERGE')
        .then(function () {
          closeDialog(true);
          var toastMessage = 'SUCCESS.MERGE_BUYER';
          toast.success(toastMessage, '', '');
        }, function () {
          closeDialog(vm.isDataDirty);
        }).finally(function () {
          vm.isLoading = false;
        })
    }

    function closeDialog(saved) {
      $mdDialog.hide(saved);
    }

    function searchBuyer(query) {
      vm.buyersList = loadBuyers();
      var predicate = { AccountName: query };
      return query ? utility.filterObject(vm.buyersList, predicate) : vm.buyersList;
    }

    function getBuyerDisplayValue(item) {
      vm.buyersList = loadBuyers();
      var result;
      if (angular.isObject(item)) {
        result = utility.filterObject(vm.buyersList, { AccountId: item.AccountId }, true)[0];
      }
      else {
        result = utility.filterObject(vm.buyersList, { AccountId: item }, true)[0];
      }
      if (result) {
        return result.AccountName;
      }
    }

    //on lookup value change the account id and email field is populated
    function onBuyerChange(selectedObj) {
      if (angular.isObject(selectedObj)) {
        accountId = selectedObj.AccountId;
        vm.mergeIntoBuyer.AccountId = selectedObj.AccountId;
        vm.mergeIntoBuyer.Email = selectedObj.Email;
      }
      else if (angular.isUndefined(selectedObj) || selectedObj === null) {
        accountId = undefined;
        vm.mergeIntoBuyer.AccountId = undefined;
        vm.mergeIntoBuyer.Email = undefined;
      }
    }

    function loadBuyers() {
      buyers = utility.filterObject(buyers, { Status: 1 });
      var index = buyers.indexOf(utility.filterObject(buyers, { AccountId: record.AccountId }, true)[0]);
      if (index !== -1) {
        buyers.splice(index, 1);
      }
      vm.buyersList = buyers;
      return vm.buyersList;
    }

  }
})();
(function() {
'use strict';

    angular
        .module('app.main.accounts.buyers')
        .controller('buyersDetailsController', buyersDetailsController);

    /* @ngInject */
    function buyersDetailsController($document,$mdDialog, api, $state, $rootScope, $stateParams, dialog, utility, settingsFactory, SecurityFactory, CONSTANTS) {
        /* jshint validthis: true */
        var vm = this;

        // Data
        var buyerId = $stateParams.id;

        vm.model = api.accounts.buyers;
        vm.usersModel = api.buyers.users;
        settingsFactory.applyPersistedListViewLayout(vm.usersModel);
        vm.catalogsModel = api.buyers.catalogs;
        settingsFactory.applyPersistedListViewLayout(vm.catalogsModel);
        vm.customersModel = api.buyers.customers;
        settingsFactory.applyPersistedListViewLayout(vm.customersModel);

        vm.buyer = {};
        vm.buyerUsers = [];
        vm.filteredBuyerUsers = [];

        vm.buyerCatalogs = [];
        vm.filteredBuyerCatalogs = [];

        vm.buyerCustomers = [];
        vm.filteredBuyerCustomers = [];

        var isTabDataInitialized = false;


        // Methods
        vm.isLoading = false;
        vm.isUsersLoading = false;
        vm.isCatalogsLoading = false;
        vm.isCustomersLoading = false;

        vm.refreshRecord = refreshRecord;
        vm.refreshUsers = refreshUsers;
        vm.refreshCatalogs = refreshCatalogs;
        vm.refreshCustomers = refreshCustomers;

        vm.doBuyerItemAction = doBuyerItemAction;

        vm.doUsersItemAction = doUsersItemAction;
        vm.doUsersListAction = doUsersListAction;
        vm.viewUser = viewUser;

        vm.doCatalogItemAction = doCatalogItemAction;
        vm.viewCatalog = viewCatalog;


        activate();

        ////////////////

        function activate() {
            utility.filterObject(vm.usersModel.fields, {field: 'Roles'})[0].lookupFilter = {'AccountTypeId': 3};// modify user model dynamically to filter roles based on account type id
            refreshRecord(true);
        }

        function refreshRecord(isLogRequired) {
            vm.isLoading = true;

            vm.model.methods.getDetails(isLogRequired, buyerId)
                .then(function (buyer) {
                    vm.buyer = buyer.data;
                    vm.title = angular.copy(vm.buyer[vm.model.lookupDisplayField]);

                    initializeTabData(isLogRequired);

                    //Update Breadcrumb
                    $state.current.data.displayName = vm.title;
                    $rootScope.$broadcast('breadcrumb-updated');
                })
                .finally(function () {
                    vm.isLoading = false;
                });
        }

        function refreshUsers(forceFetch, isLogRequired) {
            var generalProperties = {
                forceFetch: forceFetch,
                isLogRequired: isLogRequired
            }
            vm.isUsersLoading = true;

            vm.usersModel.methods.getList(generalProperties, buyerId)
                .then(function (response) {
                    vm.buyerUsers = response.data;
                })
                .finally(function() {
                    vm.isUsersLoading = false;
                });
        }

        function refreshCatalogs(forceFetch, isLogRequired) {
            var generalProperties = {
                forceFetch: forceFetch,
                isLogRequired: isLogRequired
            }
            vm.isCatalogsLoading = true;

            vm.catalogsModel.methods.getList(generalProperties, buyerId)
            .then(function (response) {
                    vm.buyerCatalogs = response.data;
                    //UPDATE catalog data-source properties for line plan catalog
                    angular.forEach(vm.buyerCatalogs, function (catalog) {
                        if (catalog.IsLinePlan == 1) {
                            catalog.DataSourceType = CONSTANTS.LINE_PLAN_CATALOG;
                            catalog.DataSourceTypeId = CONSTANTS.LINE_PLAN_ID;
                        }
                    })
                })
                .finally(function() {
                    vm.isCatalogsLoading = false;
                });
        }

        function refreshCustomers(forceFetch, isLogRequired) {
            var generalProperties = {
                forceFetch: forceFetch,
                isLogRequired: isLogRequired
            }
            vm.isCustomersLoading = true;
            vm.customersModel.methods.getList(generalProperties, buyerId)
                .then(function (response) {
                    vm.buyerCustomers = response.data;
                })
                .finally(function () {
                    vm.isCustomersLoading = false;
                });
        }

        function doBuyerItemAction(action, record) {
            if (action) {
                switch (action.id) {
                    case 'delete':
                    case 'activate':
                        vm.model.methods.activateBulk(record, vm.model, action.id, undefined)
                            .then(function() {
                                if(!isTabDataInitialized && action.id === 'activate') {
                                    initializeTabData(true);
                                }
                            })
                        break;
                    case 'merge':
                    mergeItem(record);
                    break;
                }
            }
        }

		function doUsersItemAction(action, record) {
			if (action && record) {
				switch (action.id) {
					case 'view':
						viewUser(record);
                        break;
					case 'edit':
						editUser(record, null);
                        break;
					case 'delete':
                    case 'activate':
                        vm.usersModel.methods.activateBulk(record, vm.usersModel, action.id, undefined);
                        break;
				}
			}
		}

        function doUsersListAction(action, records) {
            if (action) {
                switch (action.id) {
                    case 'delete':
                    case 'activate':
                        vm.usersModel.methods.activateBulk(records, vm.usersModel, action.id, undefined);
                        break;
                    case 'changeAccount':
                        $mdDialog.show({
                                controller: 'changeAccountController',
                                controllerAs: 'vm',
                                templateUrl: 'app/main/accounts/users/list/dialogs/change-user-account/change-user-account.html',
                                parent: angular.element($document.body),
                                targetEvent: null,
                                clickOutsideToClose: false,
                                locals: {
                                    model: api.accounts.users,
                                    selectedRecords: records,
                                    event: null
                                }
                        }).then(function (saved) {
                                if (saved) {
                                    refreshUsers(true, false);
                                }
                        });
                        break;
                }
            }
        }

        function viewUser(record) {
            var id = record[vm.usersModel.idField];
            var stateParams = {account: 'buyers', accountId: buyerId, id:id};
            $state.go('app.accounts_user_details', stateParams);
        }

        function editUser(record, ev) {
            api.showEditRecordDialog(angular.element($document.body), ev, vm.usersModel, record)
            .then(function(saved) {
                if (saved) {
                    refreshUsers(true, false);
                }
            });
		}

        function doCatalogItemAction(action, record) {
            if (action && record) {
				switch (action.id) {
					case 'view':
						vm.viewCatalog(record);
                        break;
					case 'edit':
						editCatalog(record, null);
                        break;
					case 'delete':
					case 'activate':
                        vm.catalogsModel.methods.activateBulk(record, vm.catalogsModel, action.id, buyerId);
                        break;
				}
			}
        }

        function viewCatalog(record) {
            var id = record[vm.model.idField];
            var stateParams = {id:id, dataSourceTypeId: record.DataSourceTypeId};
            $state.go('app.catalogs.details', stateParams);
        }

        function editCatalog(record, ev) {
            api.showEditRecordDialog(angular.element($document.body), ev, vm.catalogsModel, record, buyerId)
            .then(function(saved) {
                if (saved) {
                    refreshCatalogs(true, false);
                }
            });
        }

        function mergeItem(record, ev) {
            var generalProperties = {
                forceFetch: true,
                isLogRequired: false
            }
		    vm.model.methods.getList(generalProperties)
			.then(function (buyers) {
                return $mdDialog.show({
                    controller: 'mergeBuyersController',
                    controllerAs: 'vm',
                    templateUrl: 'app/main/accounts/buyers/dialogs/merge-buyers.html',
                    parent: angular.element($document.body),
                    targetEvent: ev,
                    clickOutsideToClose: false,
                    locals: {
                        record: record,
                        buyers: buyers.data,
                        model: vm.model,
                        event: ev
                    }
                }).then(function (saved) {
                    if (saved) {
                        refreshRecord(false);
                    }
                });
            })
        }

        function initializeTabData(isLogRequired) {
            if(vm.buyer.Status !== 0) {
                isTabDataInitialized = true;
                if(SecurityFactory.isAuthorized({accessPrivileges: CONSTANTS.PRIVILEGES.BUYERS.DETAIL.USERS_LIST})) {
                    refreshUsers(vm.usersModel.isDirty, isLogRequired);
                }
                if(SecurityFactory.isAuthorized({accessPrivileges: CONSTANTS.PRIVILEGES.BUYERS.DETAIL.CATALOGS_LIST})) {
                    refreshCatalogs(vm.catalogsModel.isDirty, isLogRequired);
                }
                if(SecurityFactory.isAuthorized({accessPrivileges: CONSTANTS.PRIVILEGES.BUYERS.DETAIL.CUSTOMERS_LIST})) {
                    refreshCustomers(vm.customersModel.isDirty, isLogRequired);
                }
            }
        }
    }
})();
(function () {
	'use strict';

	angular
		.module('app.main.accounts.auth-users', [
			'app.main.accounts.auth-users.auth-environments'
		])
		.config(config);

	/* @ngInject */
	function config($stateProvider, msNavigationServiceProvider, $translatePartialLoaderProvider) {
		$stateProvider.state('app.accounts_auth_users', {
			url: '/accounts/auth-users',
			views: {
				'content@app': {
					templateUrl: 'app/main/accounts/auth-users/list/auth-users-list.html',
					controller: 'authUsersListController as vm'
				}
			},
			data: {
				displayName: 'AUTH_USERS.NAV'
			},
			resolve: {
			},
			// accessPrivileges: ['UI_AllUsersList']
			accessInfo: {
				accessPrivileges: ['nav_auth_users']
			},
			visibleForLinePlan: true
		});

		$stateProvider.state('app.accounts_auth_users_details', {
			url  : '/accounts/user/:id',
			views: {
				'content@app': {
					templateUrl: 'app/main/accounts/auth-users/details/auth-users-details.html',
					controller : 'authUsersDetailsController as vm'
				}
			},
			data : {
				displayName: 'AUTH_USERS.NAV'
			},
			// accessPrivileges: ['UI_AllUsersList']
			accessInfo: {
				accessPrivileges: ['nav_auth_users']
			},
			visibleForLinePlan: true
		});

		// Translation
		$translatePartialLoaderProvider.addPart('app/main/accounts/auth-users');

		// Navigation
		msNavigationServiceProvider.saveItem('main.authUsers', {
			title: 'Auth Users',
			icon: 'icon-account',
			state: 'app.accounts_auth_users',
			translate: 'AUTH_USERS.NAV',
			weight: 5,
			// accessPrivileges: ['UI_AllUsersList'],
			accessInfo: {
				accessPrivileges: ['nav_auth_users']
			},
			visibleForLinePlan: true
		});
	}

})();
(function() {
	'use strict';

	angular
		.module('app.main.accounts.auth-users')
		.controller('authUsersListController', authUsersListController);

	/* @ngInject */
	function authUsersListController(api, $document, $mdDialog, settingsFactory, crud, alertDialog, $state, utility) {
		/* jshint validthis: true */
		var vm = this;

		vm.model = api.accounts.authUsers;
		settingsFactory.applyPersistedListViewLayout(vm.model);

		vm.authUsers = [];
		vm.filteredUsers = [];
		vm.isLoading = false;

		vm.refreshItems = refreshItems;
		vm.doItemAction = doItemAction;
		vm.addRecord = addRecord;
		vm.doListAction = doListAction;
		vm.viewItem = viewItem;

		activate();

		////////////////

		function activate() {
			refreshItems(vm.model.isDirty, true);
		}

		function refreshItems(forceFetch, isLogRequired) {
			//Load WebAPI Environments
			vm.isLoading = true;
			var generalProperties = {
				forceFetch: forceFetch,
				isLogRequired: isLogRequired
			}
			vm.model.methods.getList(generalProperties)
			.then(function(response) {
				vm.authUsers = response.data;
			})
			.finally(function() {
				vm.isLoading = false;
			});
		}

		//Item Action button pressed event
		function doItemAction(action, record) {
			if (action && record) {
				switch (action.id) {
					case 'resetPassword':
						resetUserPassword(record, vm.model);
						break;
					case 'edit':
						editItem(record, null);
						break;
					case 'delete':
					case 'activate':
						vm.model.methods.activateBulk(record, vm.model, action.id);
						break;
				}
			}
		}

		//List Action button pressed event
		function doListAction(action, records) {
			if (action) {
				switch (action.id) {
					case 'delete':
					case 'activate':
						vm.model.methods.activateBulk(records, vm.model, action.id);
						break;
				}
			}
		}

		function resetUserPassword(record, model) {
			model.methods.resetPassword(record).then(function () {
				alertDialog.show('AUTH_USERS.FIELDS.RESET_PASSWORD_SUCCESS');
			});
		}

		function addRecord(ev) {
			var lookupPromises = {};
			lookupPromises = crud.createLookupPromise(vm.model, undefined , 'create');
			$mdDialog.show({
				controller: 'createAuthUserController',
				controllerAs: 'vm',
				templateUrl: 'app/main/accounts/auth-users/list/dialogs/create-auth-user/create-auth-user.html',
				parent: angular.element($document.body),
				targetEvent: ev,
				clickOutsideToClose: false,
				locals: {
					model: vm.model,
					record: null,
					isNew: true,
					lookupPromises: lookupPromises,
					event: ev,
					masterUsersList: angular.copy(utility.filterObject(vm.authUsers, { masterUser: -1, status: true }, true)),
					masterUserName: undefined,
					existingUsers: angular.copy(vm.authUsers)
				}
			}).then(function (saved) {
				if (saved) {
					refreshItems(true, false);
				}
			});
		}

		function editItem(record, ev) {
			var masterUserName = '';
			if(record.masterUser >= 1) {
				masterUserName = getMasterUserName(record.masterUser);
			}
			var lookupPromises = {};
			lookupPromises = crud.createLookupPromise(vm.model, undefined , 'edit');
			$mdDialog.show({
					controller         : 'createAuthUserController',
					controllerAs       : 'vm',
					templateUrl        : 'app/main/accounts/auth-users/list/dialogs/create-auth-user/create-auth-user.html',
					parent             : angular.element($document.body),
					targetEvent        : ev,
					clickOutsideToClose: false,
					locals             : {
							model: vm.model,
							record: record,
							isNew: false,
							lookupPromises: lookupPromises,
							event: ev,
							masterUsersList: angular.copy(utility.filterObject(vm.authUsers, { masterUser: -1, status: true }, true)),
							masterUserName: masterUserName,
							existingUsers: angular.copy(vm.authUsers)
					}
			}).then(function(saved) {
					if (saved) {
						refreshItems(true, false);
					}
			});
		}

		function getMasterUserName(userId) {
			var masterUser = utility.filterObject(vm.authUsers, { id: userId })[0];
			return masterUser.username;
		}

		function viewItem(record) {
			var id = record[vm.model.idField];
			var stateParams = {id:id, authUser: record};
			$state.go('app.accounts_auth_users_details', stateParams);
		}
	}
})();
(function() {
    'use strict';

    angular
        .module('app.main.accounts.auth-users')
        .controller('authUsersDetailsController', authUsersDetailsController);

    /* @ngInject */
    function authUsersDetailsController(api, $stateParams, $state, $rootScope, settingsFactory, $document, $mdDialog, utility, SecurityFactory) {
        /* jshint validthis: true */
        var vm = this;
        var record = $stateParams.authUser;
        var userId = $stateParams.id;
        var assignedEnvironments = [];

        vm.model = api.accounts.authUsers;

        vm.environmentsModel = api.authUsers.authEnvironments;
        settingsFactory.applyPersistedListViewLayout(vm.environmentsModel);

        vm.authEnvironments = [];
        vm.filteredAuthEnvironments = [];
        vm.unAssignedEnvironments = [];

        vm.isLoading = false;
        vm.isAuthEnvironmentsLoading = false;

        vm.refreshRecord = refreshRecord;
        vm.refreshEnvironments = refreshEnvironments;

        vm.doItemAction = doItemAction;
        vm.doEnvironmentsItemAction = doEnvironmentsItemAction;
        vm.addEnvironment = addEnvironment;

        activate();

        ////////////////

        function activate() {
            refreshRecord(true);
        }

        function refreshRecord(isLogRequired) {
            vm.isLoading = true;
            if(angular.isDefined(record)) {
                vm.user = record;
                updateUserData(vm.user);
                vm.isLoading = false;
            } else if(angular.isUndefined(record)) {
                var generalProperties = {
                    forceFetch: true,
                    isLogRequired: isLogRequired
                }
                vm.model.methods.getList(generalProperties)
                .then(function(response) {
                    vm.user = utility.filterObject(response.data, { id: userId })[0];
                    updateUserData(vm.user);
                })
                .finally(function() {
                    vm.isLoading = false;
                });
            }
        }

        function refreshEnvironments(forceFetch, isLogRequired) {
            var environmentArrayList = [];
            var generalProperties = {
                forceFetch: forceFetch,
                isLogRequired: isLogRequired
            }
            vm.isAuthEnvironmentsLoading = true;

            vm.environmentsModel.methods.getList(generalProperties)
            .then(function (response) {
                if(response.data.length > 0) {
                    angular.forEach(response.data, function(environmentData) {
                        angular.forEach(assignedEnvironments, function(assignedEnvironment) {
                            if(environmentData.code === assignedEnvironment) {
                                environmentArrayList.push(environmentData);
                            }
                        });
                    })
                    vm.authEnvironments = environmentArrayList;
                    vm.unAssignedEnvironments = response.data.filter(function(item) {//Keeping list of unAssigned environments
                        return assignedEnvironments.indexOf(item.code) === -1;
                    });
                }
            })
            .finally(function () {
                vm.isAuthEnvironmentsLoading = false;
            });
        }

        function doItemAction(action, record) {
            if (action) {
                switch (action.id) {
                    case 'delete':
					case 'activate':
						vm.model.methods.activateBulk(record, vm.model, action.id);
						break;
                }
            }
        }

        function doEnvironmentsItemAction(action, record) {
            if (action) {
                switch (action.id) {
                    case 'delete':
                        $mdDialog.show({
                            controller         : 'addEnvironmentToAuthUserController',
                            controllerAs       : 'vm',
                            templateUrl        : 'app/main/accounts/auth-users/details/tabs/user-environments/dialogs/add-environment-to-auth-user.html',
                            parent             : angular.element($document.body),
                            targetEvent        : null,
                            clickOutsideToClose: false,
                            locals             : {
                                model: vm.environmentsModel,
                                userId: userId,
                                unAssignedEnvironments: vm.unAssignedEnvironments,
                                event: null,
                                isNew: false,
                                record: record
                            }
                        }).then(function(saved) {
                            if (saved) {
                                record = undefined;
                                refreshRecord(true, false);
                            }
                        });
					break;
                }
            }
        }

        function addEnvironment(ev) {
            $mdDialog.show({
                controller         : 'addEnvironmentToAuthUserController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/accounts/auth-users/details/tabs/user-environments/dialogs/add-environment-to-auth-user.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: false,
                locals             : {
                    model: vm.environmentsModel,
                    userId: userId,
                    unAssignedEnvironments: vm.unAssignedEnvironments,
                    event: ev,
                    isNew: true,
                    record: null
                }
            }).then(function(saved) {
                if (saved) {
                    record = undefined;
                    refreshRecord(true, false);
                }
            });
        }

        function updateUserData(user) {
            assignedEnvironments = user.allowedEnvironments;//List assigned environments in the list
            refreshEnvironments(true, false);
            vm.title = angular.copy(user.firstName).concat(' ' + angular.copy(user.lastName));
            //Update Breadcrumb
            $state.current.data.displayName = 'Auth User: ' + vm.title;
            $rootScope.$broadcast('breadcrumb-updated');
        }

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.main.accounts.admin.users', [])
        .config(config);

    /* @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.accounts_admin_users', {
            url    : '/accounts/admin-users',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/accounts/admin-users/list/admin-users-list.html',
                    controller : 'adminUsersListController as vm'
                }
            },
            data   : {
                displayName: 'ADMIN_USERS.NAV'
            },
            //only users with following accessPrivileges in their role access list can access this route
			// accessPrivileges: ['GetTrasixUsersList']
            // accessPrivileges: ['nav_admin_users']
            accessInfo: {
                accessPrivileges: ['nav_admin_users']
            },
            visibleForLinePlan: true
        });
        // $stateProvider.state('app.accounts_admin_users.details', {
		// 	url	 : '/:id',
        //     views: {
		// 		'content@app': {
		// 			templateUrl: 'app/main/accounts/admin-users/details/admin-users-details.html',
		// 			controller : 'adminUsersDetailsController as vm'
		// 		}
		// 	},
		// 	data: {
		// 		parentState: 'app.accounts_admin_users',
        //         displayName: 'ADMIN_USERS.TABS.ADMIN_USER'
		// 	},
        //     //only users with following accessPrivileges in their role access list can access this route
        // 	accessPrivileges: ['GetTrasixAccountUserDetailsByAccIdAndUserId']
        // accessInfo: {
        //     accessPrivileges: ['GetTrasixAccountUserDetailsByAccIdAndUserId']
        // }
		// });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/accounts/admin-users');

        msNavigationServiceProvider.saveItem('main.adminUsers', {
            title      : 'Admin Users',
            icon       : 'icon-account-outline',
            state      : 'app.accounts_admin_users',
            translate  : 'ADMIN_USERS.NAV',
            weight     : 9,
            // accessPrivileges: ['GetTrasixUsersList']
            // accessPrivileges: ['nav_admin_users'],
            accessInfo: {
                accessPrivileges: ['nav_admin_users']
            },
            visibleForLinePlan: true
        });
    }
})();
(function() {
	'use strict';

	angular
		.module('app.main.accounts.admin.users')
		.controller('adminUsersListController', adminUsersListController);

	/* @ngInject */
	function adminUsersListController(api, $state, $document, settingsFactory, dialog) {
		/* jshint validthis: true */
		var vm = this;

		vm.model = api.account.adminUsers;
		settingsFactory.applyPersistedListViewLayout(vm.model);

		vm.adminUsers = [];
		vm.filteredAdminUsers = [];
		vm.isLoading = false;


		vm.refreshItems = refreshItems;
		vm.doListAction = doListAction;
		vm.doItemAction = doItemAction;
		vm.viewItem = viewItem;

		activate();

		////////////////

		function activate() {
			refreshItems(vm.model.isDirty, true);
		}

		function refreshItems(forceFetch, isLogRequired) {
			var generalProperties = {
				forceFetch: forceFetch,
				isLogRequired: isLogRequired
			}
			vm.isLoading = true;

			vm.model.methods.getList(generalProperties)
			.then(function (response) {
				vm.adminUsers = response.data;
			})
			.finally(function () {
				vm.isLoading = false;
			});
		}

		//Item Action button pressed event
		function doItemAction(action, record) {
			if (action && record) {
				switch (action.id) {
					case 'view':
						viewItem(record);
						break;
					case 'edit':
						api.accounts.users.methods.getDetails(true, record.Id)
							.then(function (response) {
									editItem(response.data, null);
							})
						break;
					case 'delete':
					case 'activate':
						vm.model.methods.activateBulk(record, vm.model, action.id, undefined);
						break;
				}
			}
		}

		//List Action button pressed event
		function doListAction(action, records) {
			if (action) {
				switch (action.id) {
					case 'delete':
					case 'activate':
						vm.model.methods.activateBulk(records, vm.model, action.id, undefined);
						break;
				}
			}
		}

		 function viewItem(record) {
			var id = record[vm.model.idField];
			var stateParams = {account: 'trasix', accountId: 1, id:id};
			$state.go('app.accounts_user_details', stateParams);
		}

		function editItem(record, ev) {
			api.showEditRecordDialog(angular.element($document.body), ev, vm.model, record)
			.then(function(saved) {
				if (saved) {
					refreshItems(true, false);
				}
			});
		}

	}
})();
(function() {
	'use strict';

	angular.module('app.main', [
        'app.main.landing',
        'app.main.organizations',
		'app.main.accounts',
		'app.main.auth',
        'app.main.vetting-lists',
        'app.main.attributes',
        'app.main.catalogs',
        'app.main.profile',
        'app.main.customers',
        'app.main.jobs',
        'app.main.errors',
        'app.main.error404',
        'app.main.roles',
        'app.main.vas',
        'app.main.plugins',
        'app.main.notifications',
        'app.main.maintenance',
        'app.main.unsupported-browser',
        'app.main.hangfire-dashboard',
        'app.main.data-containers',
        'app.main.seller-models',
        'app.main.catalogs.article-states',
        'app.main.plugins-consolidation',
        'ui.grid',
        'ui.grid.edit',
        'ui.grid.cellNav',
        'ui.grid.selection',
        'ui.grid.pinning',
        'ui.grid.resizeColumns',
        'ui.grid.moveColumns',
        'ui.grid.validate',
        'ui.grid.rowEdit'
	]);
})();
(function() {
'use strict';

  angular
    .module('app.main')
    .controller('detailsDialogController', detailsDialogController);

  /* @ngInject */
  function detailsDialogController($mdDialog, api, event, model, data , lookupData, statusField, SecurityFactory) {
    var vm = this;

    vm.data = data;
    vm.model = model;
    vm.lookupData = lookupData;
    vm.statusField = statusField;

    vm.closeDialog = closeDialog;

    activate();

    ////////////////

    function activate() {
      loadLookupData();
    }

    function closeDialog() {
      $mdDialog.hide();
    }


     function loadLookupData() {
      for (var i=0; i<vm.model.fields.length; i++) {
        if ((vm.model.fields[i].inputType === 'lookup' || vm.model.fields[i].inputType === 'lookup-many' || vm.model.fields[i].inputType === 'articlenumber' || vm.model.fields[i].inputType === 'modelnumber' || vm.model.fields[i].inputType === 'linkedcatalogarticlenumber') && vm.model.fields[i].visible) {
          if (!vm.lookupData[vm.model.fields[i].lookupSource] || angular.isUndefined(vm.lookupData[vm.model.fields[i].lookupSource])) {
            loadLookup(vm.model.fields[i].lookupSource);
          }
        }
      }
    }

    function loadLookup(lookupSource) {

      vm.lookupData[lookupSource] = {};

      api.getLookupData(api.getModel(lookupSource)).then(function(result) {
        vm.lookupData[lookupSource] = result;
      });
    }

  }
})();
(function() {
'use strict';

    angular
        .module('app.main')
        .controller('txDataTableFilterSaverController', txDataTableFilterSaverController);

    /* @ngInject */
    function txDataTableFilterSaverController($scope, $mdDialog, utility, catalogFactory, settingsFactory,
                                                isCatalogModule, moduleName, filterObj, sortObj, isTrasix, event) {
        /* jshint validthis: true */
        var vm = this;
        var cat = catalogFactory.getActiveCatalogDetails();
        var catalogFiltersChanged = false;
        var myFiltersChanged = false;

        vm.moduleName = moduleName;
        vm.myFilters = { };
        vm.catalogFilters = { };
        vm.isCatalogModule = isCatalogModule;
        vm.filterForCatalog = false;
        vm.isTrasix = isTrasix;
        vm.filterName = '';
        vm.filterObjectArray = []

        vm.doSave = doSave;
        vm.doDeleteMyFilter = doDeleteMyFilter;
        vm.doDeleteCatalogFilter = doDeleteCatalogFilter;
        vm.closeDialog = closeDialog;
        activate();

        ////////////////

        function activate() {
            if (isCatalogModule && angular.isDefined(moduleName)) {
                //Load catalog filters
                if (cat && angular.isDefined(cat.ImportMapping) && cat.ImportMapping) {
                    vm.catalogFilters = angular.fromJson(cat.ImportMapping);
                }
                if (angular.isUndefined(vm.catalogFilters)) {
                    vm.catalogFilters = {};
                }
                if (angular.isUndefined(vm.catalogFilters.filters)) {
                    vm.catalogFilters.filters = {};
                }
                if (angular.isUndefined(vm.catalogFilters.filters[moduleName])) {
                    vm.catalogFilters.filters[moduleName] = [];
                }
                else {
                    angular.forEach(vm.catalogFilters.filters[moduleName], function (catalogFilterObject) {
                        vm.filterObjectArray.push(catalogFilterObject);
                    })
                }
            }
            var mySettings = settingsFactory.getSettings();
            if (angular.isDefined(mySettings.viewFilters)) {
                vm.myFilters = mySettings.viewFilters;
            }
            if (angular.isUndefined(vm.myFilters[moduleName])) {
                vm.myFilters[moduleName] = [];
            }
            else {
                angular.forEach(vm.myFilters[moduleName], function (myFilterObject) {
                    vm.filterObjectArray.push(myFilterObject);
                })
              }
        }

        function doSave() {
            if (vm.filterName.length > 0) {
                if (vm.filterForCatalog) {
                    vm.catalogFilters.filters[vm.moduleName].push({
                        name: vm.filterName,
                        filter: filterObj,
                        sort: sortObj
                    });
                    catalogFiltersChanged = true;
                } else {
                    vm.myFilters[vm.moduleName].push({
                        name: vm.filterName,
                        filter: filterObj,
                        sort: sortObj
                    });
                    myFiltersChanged = true;
                }

            }
            if (myFiltersChanged) {
                settingsFactory.updateViewFilters(vm.myFilters);
            }

            if (catalogFiltersChanged) {
                catalogFactory.setCatalogImportMapping(cat.Id, vm.catalogFilters);
            }

            closeDialog(true);
        }

        function doDeleteMyFilter(filterIndex) {
            vm.myFilters[moduleName].splice(filterIndex, 1);
            settingsFactory.updateViewFilters(vm.myFilters);
            myFiltersChanged = true;
        }

        function doDeleteCatalogFilter(filterIndex) {
            vm.catalogFilters.filters[moduleName].splice(filterIndex, 1);
            catalogFactory.setCatalogImportMapping(cat.Id, vm.catalogFilters);
            catalogFiltersChanged = true;
        }

        function closeDialog(res) {
            $mdDialog.hide(res);
        }
    }
})();
(function () {
  'use strict';

  angular
    .module('app.main')
    .controller('filterByDateController', filterByDateController);
  /* @ngInject */
  function filterByDateController($mdDialog, model) {
    /* jshint validthis: true */
    var vm = this;
    vm.record = {
      startDate: undefined,
      endDate: undefined
    };
    vm.today = new Date();

    vm.filterData = filterData;
    vm.closeDialog = closeDialog;
    vm.startDateFilter = startDateFilter;
    vm.endDateFilter = endDateFilter;

    activate();


    ////////////////

    function activate() {
      var cachedStartDate;
      var cachedEndDate;

      if(model.views.mainList.filterByDate && angular.isDefined(model.views.mainList.filterByDate)) {

        // convert cached start date string to date object
        if(model.views.mainList.filterByDate.startDate && angular.isDefined(model.views.mainList.filterByDate.startDate)) {
          cachedStartDate = new Date(model.views.mainList.filterByDate.startDate);
          if(angular.isDate(cachedStartDate)) {
            vm.record.startDate = cachedStartDate;
          }
        }

        // convert cached end date string to date object
        if(model.views.mainList.filterByDate.endDate && angular.isDefined(model.views.mainList.filterByDate.endDate)) {
          cachedEndDate = new Date(model.views.mainList.filterByDate.endDate);
          if(angular.isDate(cachedEndDate)) {
            vm.record.endDate = new Date(cachedEndDate);
          }
        }

      }

      // if endDate is not persisted in model initialize endDate with today
      if(angular.isUndefined(vm.record.endDate)) {
          vm.record.endDate = new Date();
      }

      if(model.modelPath === 'catalogs.articleChangeLogs' && angular.isUndefined(vm.record.startDate)) {
        var currDate = angular.copy(vm.record.endDate);
        vm.record.startDate = new Date(currDate.setDate(currDate.getDate() - 1));
      }
    }

    function filterData(record) {
      if(!angular.isDate(record.endDate)) {
        record.endDate = new Date();
      }
      model.views.mainList.filterByDate.startDate = record.startDate.toISOString();
      model.views.mainList.filterByDate.endDate = record.endDate.toISOString();
      closeDialog(record);
    }

    function closeDialog(dates) {
      $mdDialog.hide(dates);
    }

    function startDateFilter(startDate) {
      if(vm.record.endDate) {
        return startDate <= vm.record.endDate;
      }
      else {
        return true;
      }
    }

    function endDateFilter(endDate) {
      if(vm.record.startDate) {
        return vm.record.startDate <= endDate;
      }
      else {
        return true;
      }
    }

  }
})();
(function () {
  'use strict';

  angular
    .module('app.main')
    .controller('txDataTableColumnSaverController', txDataTableColumnSaverController);

  /* @ngInject */
  function txDataTableColumnSaverController($scope, $mdDialog, utility, catalogFactory, settingsFactory,
    isCatalogModule, modelPath, columnObj, isTrasix, event) {
    /* jshint validthis: true */
    var vm = this;

    var activeCatalogDetails = catalogFactory.getActiveCatalogDetails();
    var mySettings = settingsFactory.getSettings();
    var catalogColumnsChanged = false;
    var myColumnsChanged = false;

    vm.modelPath = modelPath;
    vm.myColumns = {};
    vm.catalogImportMapping = {};
    vm.isCatalogModule = isCatalogModule;
    vm.columnForCatalog = false;
    vm.isTrasix = isTrasix;
    vm.name = '';
    vm.columnObjArray = [];

    vm.doSave = doSave;
    vm.doDeleteMyColumn = doDeleteMyColumn;
    vm.doDeleteCatalogColumn = doDeleteCatalogColumn;
    vm.closeDialog = closeDialog;

    activate();

    ////////////////

    function activate() {
      if (isCatalogModule && angular.isDefined(modelPath)) {
        //Load catalog columns
        if (activeCatalogDetails.ImportMapping) {
          vm.catalogImportMapping = angular.fromJson(activeCatalogDetails.ImportMapping);
        }
        if (angular.isUndefined(vm.catalogImportMapping)) {
          vm.catalogImportMapping = {};
        }
        if (angular.isUndefined(vm.catalogImportMapping.columns)) {
          vm.catalogImportMapping.columns = {};
        }

        if (angular.isUndefined(vm.catalogImportMapping.columns[modelPath])) {
          vm.catalogImportMapping.columns[modelPath] = [];
        }
        else {
          angular.forEach(vm.catalogImportMapping.columns[modelPath], function (catalogColumnObj) {
            vm.columnObjArray.push(catalogColumnObj);
          })
        }
      }

      if (mySettings.viewColumns) {
        vm.myColumns = mySettings.viewColumns;
      }

      if (angular.isUndefined(vm.myColumns[modelPath])) {
        vm.myColumns[modelPath] = [];
      }
      else {
        angular.forEach(vm.myColumns[modelPath], function (myColumnObj) {
          vm.columnObjArray.push(myColumnObj);
        })
      }
      vm.isInputRequired = true;
    }


    function doSave() {
      if (vm.name.length > 0) {
        if (vm.columnForCatalog) {
          vm.catalogImportMapping.columns[vm.modelPath].push({
            name: vm.name,
            column: columnObj
          });
          catalogColumnsChanged = true;
        } else {
          vm.myColumns[vm.modelPath].push({
            name: vm.name,
            column: columnObj
          });
          myColumnsChanged = true;
        }
      }
      if (myColumnsChanged) {
        settingsFactory.updateViewColumns(vm.myColumns);
      }

      if (catalogColumnsChanged) {
        catalogFactory.setCatalogImportMapping(activeCatalogDetails.CatalogCode, vm.catalogImportMapping);
      }
      closeDialog(true);
    }

    function doDeleteMyColumn(columnIndex) {
      vm.myColumns[modelPath].splice(columnIndex, 1);
      settingsFactory.updateViewColumns(vm.myColumns);
      myColumnsChanged = true;
    }

    function doDeleteCatalogColumn(columnIndex) {
      vm.catalogImportMapping.columns[modelPath].splice(columnIndex, 1);
      catalogFactory.setCatalogImportMapping(activeCatalogDetails.CatalogCode, vm.catalogImportMapping);
      catalogColumnsChanged = true;
    }

    function closeDialog(res) {
      $mdDialog.hide(res);
    }

  }
})();
(function() {
'use strict';

    angular
        .module('app.main')
        .controller('txDataTableColumnChooserController', txDataTableColumnChooserController);

    /**
     * @description this controller will allow users to add or remove fields to data table,
     * vm.filteredAvailableFields and vm.filteredSelectedFields use as dragula model and any changes while dragging and dropping will affect them
     * above mentioned variables are used due to dragula's disability to work with filtered list
     * any visual changes happen on column chooser is due to changes in vm.filteredAvailableFields or vm.filteredSelectedFields
     * however it is required to keep their counter part vm.availableFields and vm.selectedFields in sync with them
     * also to avoid using watch where ever there are changes on filtered list or actual list sync operation taken care manually
     */
    /* @ngInject */
        function txDataTableColumnChooserController($scope, $mdDialog, $timeout, $document, $log, $filter, $q, dragulaService, utility,
            availableFields, selectedFields, defaultColumnList, event) {
        /* jshint validthis: true */
        var vm = this;

        var availableFieldsCopy = [];
        var selectedFieldsCopy = [];
        var timeoutPromises = {};

        vm.ACFilter = {};
        vm.SCFilter = {};
        vm.availableFields = [];
        vm.selectedFields = [];

        var translatedFieldsClone = [];

        // filtered field are use only for display purpose since when filter data and drag and drop dragula could not find the correct index
        // vm.selectedFields will always be updated on double click on drag and drop
        vm.filteredAvailableFields = [];
        vm.filteredSelectedFields = [];
        var indexedAvailableFields = {}; // map of translated field name and model field used to resolve the result
        var indexedTranslatedFields = {}; // map of translated field name and fields with translated display label used while working with fields
        vm.isIndexedAvailableFieldsCreated = false; // use to disable save button until create available fields index
        vm.processing = false;

        // methods

        vm.onACFilterClick = onACFilterClick;
        vm.onSCFilterClick = onSCFilterClick;
        vm.applyChanges = applyChanges;
        vm.closeDialog = closeDialog;
        vm.modifyColumns = modifyColumns;

        vm.addItem = addItem;
        vm.remItem = remItem;
        vm.filterAvailableFields = filterAvailableFields;
        vm.filterSelectedFields = filterSelectedFields;

        activate();

        var availableFieldsWatchUnsubscribe = $scope.$watchCollection('vm.availableFields', function(newVal) {
            if(newVal.length === 0) {
                vm.isAvailableFieldsEmpty = true;
            }
            else {
                vm.isAvailableFieldsEmpty = false;
                // if need undo instead of default un comment this
                // availableFieldsCopy = angular.copy(vm.availableFields);
                // selectedFieldsCopy = angular.copy(vm.selectedFields);
            }
        });


        ////////////////

        function activate() {
            createTranslatedFieldsClone();
            // initialize vm.availableFields and vm.filteredAvailableFields
            populateAvailableFields();
            // initialize vm.selectedFields and vm.filteredSelectedFields
            populateSelectedFields();

            createIndexedAvailableFields().then(function() {
                vm.isIndexedAvailableFieldsCreated = true;
            });

            vm.isAvailableFieldsEmpty = vm.availableFields.length === 0 ? true : false;
            availableFieldsCopy = angular.copy(vm.availableFields);
            selectedFieldsCopy = angular.copy(vm.selectedFields);
            // modify columns action not require if there is no columns by default
            vm.isModifycolumnsActionRequired = !vm.isAvailableFieldsEmpty;
        }

        function onACFilterClick() {
            vm.showACFilter = !vm.showACFilter;
            timeoutPromises.ACFilterClick = $timeout(function() {
                if (vm.showACFilter) {
                    $document[0].querySelector('#ACFilter').focus();
                }
                else {
                    vm.ACFilter = {};
                    vm.filteredAvailableFields = vm.availableFields;
                }
            }, 0);
        }

        function onSCFilterClick() {
            vm.showSCFilter =! vm.showSCFilter;
            timeoutPromises.ACFilterClick = $timeout(function() {
                if (vm.showSCFilter) {
                    $document[0].querySelector('#SCFilter').focus();
                }
                else {
                    vm.SCFilter = {};
                    vm.filteredSelectedFields = vm.selectedFields;
                }
            }, 0);
        }

        function applyChanges() {
            // vm.selectedFields contains translated values, instead pass non translated values
            var result = [];
            // this promise will resolve immediately
            createIndexedAvailableFields().then(function(indexedFields) {
                for(var i=0,len=vm.selectedFields.length; i<len; i++) {
                    if(indexedFields[vm.selectedFields[i].field + '-' + vm.selectedFields[i].displayLabel]) {
                        result.push(indexedFields[vm.selectedFields[i].field + '-' + vm.selectedFields[i].displayLabel]);
                    }
                }
                closeDialog(result);
            })
        }

        function closeDialog(fields) {
            $mdDialog.hide(fields);
        }

        function modifyColumns() {
            if(vm.isAvailableFieldsEmpty === true) {
                vm.availableFields = angular.copy(availableFieldsCopy);
                vm.selectedFields = angular.copy(selectedFieldsCopy);
            }
            else if(vm.isAvailableFieldsEmpty === false) {
                for(var i=vm.availableFields.length-1; i>=0; i--) {
                    vm.selectedFields.push(vm.availableFields[i]);
                    vm.availableFields.splice(i,1);
                }
            }
            vm.filteredAvailableFields = vm.availableFields;
            vm.filteredSelectedFields = vm.selectedFields;
        }

        function addItem(col) {
            //vm.availableFields.indexOf(col); wont work since col (elem of filteredList) is copy of availableFields and not one of it's elements
            var index = vm.availableFields.indexOf(utility.filterObject(vm.availableFields, {field: col.field}, true)[0]);
            if (index >= 0) {
                vm.selectedFields.push(vm.availableFields[index]);
                vm.availableFields.splice(index, 1);

                // update both side with updated fields
                // remove from filteredList as well since its filtered list is what being displayed
                var filteredIndex = vm.filteredAvailableFields.indexOf(col);
                if(filteredIndex !== -1) {
                    vm.filteredAvailableFields.splice(filteredIndex, 1);
                }
                filterSelectedFields(); // once added to selected fields apply filter on updated data (call explicitly to avoid watch)
            }
        }

        function remItem(col) {
            //vm.selectedFields.indexOf(col); wont work since col (elem of filteredList) is copy of selectedFields and not one of it's elements
            var index = vm.selectedFields.indexOf(utility.filterObject(vm.selectedFields, {field: col.field}, true)[0]);
            if (index >= 0) {
                vm.availableFields.push(vm.selectedFields[index]);
                vm.selectedFields.splice(index, 1);

                // update both side with updated fields
                // remove from filteredList as well since its filtered list is what being displayed
                var filteredIndex = vm.filteredSelectedFields.indexOf(col);
                if(filteredIndex !== -1) {
                    vm.filteredSelectedFields.splice(filteredIndex, 1);
                }
                filterAvailableFields(); //once add to available fields apply filter on updated data (call explicitly to avoid watch)
            }
        }

        function filterAvailableFields() {
            vm.availableFields = $filter('orderBy')(vm.availableFields, 'displayLabel');
            timeoutPromises.filterAvailableFields = $timeout(function() {
                vm.filteredAvailableFields = utility.filterObject(vm.availableFields, {displayLabel: vm.ACFilter.displayLabel});
            }, 100);
        }

        function filterSelectedFields() {
            timeoutPromises.filterSelectedFields = $timeout(function() {
                vm.filteredSelectedFields = utility.filterObject(vm.selectedFields, {displayLabel: vm.SCFilter.displayLabel});
            }, 100);
        }

        function createTranslatedFieldsClone() {
            translatedFieldsClone = angular.copy(availableFields);
            // translate display labels of translatedFieldsClone fields
            for(var j=0; j<translatedFieldsClone.length; j++) {
                translatedFieldsClone[j].displayLabel = $filter('translate')(translatedFieldsClone[j].displayLabel);
                translatedFieldsClone[j].displayLabel = $filter('ampersand')(translatedFieldsClone[j].displayLabel);
                indexedTranslatedFields[translatedFieldsClone[j].displayLabel] = translatedFieldsClone[j];
            }
            translatedFieldsClone = $filter('orderBy')(translatedFieldsClone, 'displayLabel')
        }

        function populateAvailableFields() {
            for (var i=0; i<translatedFieldsClone.length; i++) {
                if (translatedFieldsClone[i].visible && utility.filterObject(selectedFields, {field: translatedFieldsClone[i].field}, true).length == 0) {
                    vm.availableFields.push(translatedFieldsClone[i]);
                }
            }
            vm.filteredAvailableFields = angular.copy(vm.availableFields);
        }

        function populateSelectedFields() {
            vm.selectedFields = angular.copy(selectedFields);
            for(var i=0, len=vm.selectedFields.length; i<len; i++) {
                vm.selectedFields[i].displayLabel = $filter('ampersand')($filter('translate')(vm.selectedFields[i].displayLabel));
            }
            vm.filteredSelectedFields = angular.copy(vm.selectedFields);
        }

        // contains map of translated field name and model fields
        function createIndexedAvailableFields() {
            if(indexedAvailableFields && !utility.isObjectEmpty(indexedAvailableFields)) {
                return $q.when(indexedAvailableFields);
            }

            var deferred = $q.defer();
            angular.forEach(availableFields, function(availableField) {
                indexedAvailableFields[availableField.field + '-' + $filter('ampersand')($filter('translate')(availableField.displayLabel))] = availableField;
            });
            deferred.resolve(indexedAvailableFields);
            return deferred.promise;
        }

        // since dragula is in sync with filteredSelectedFields and filteredAvailableFields arrays, update selectedFields and availableFields accordingly
        // could not found a way to determine exact drop location in target array, hence dragged element will always be placed at the end of list
        var unSubscribeDropEvent = $scope.$on('bag-column-choose.drop-model', function(el, targetElem, destination, source) {
            var dragEndContainerId, dragStartContainerId;
            if(destination && destination[0] && destination[0].id) {
                dragEndContainerId = destination[0].id;
            }
            if(source && source[0] && source[0].id) {
                dragStartContainerId = source[0].id;
            }
            // if drag and drop happened between availableFields and SelectedFields
            if(dragEndContainerId !== dragStartContainerId) {
                var draggedElement = angular.element(targetElem[0].querySelector('.dragged-element-selector-tag'))[0];

                if(draggedElement) {
                    var draggedElementText = draggedElement.innerText.trim();

                    // remove field from vm.selectedFields and push to vm.availableFields
                    if(dragEndContainerId === 'availableColumns') {
                        var draggedSelectedField = utility.filterObject(vm.selectedFields, {displayLabel: draggedElementText}, true)[0];
                        if(draggedSelectedField) {
                            var indexOfSelectedField = vm.selectedFields.indexOf(draggedSelectedField);
                            vm.availableFields.push(draggedSelectedField);
                            vm.selectedFields.splice(indexOfSelectedField, 1);
                        }
                        else {
                             $log.warn('Could not find the dragged element in selected fields list');
                        }
                    }
                    // add field to selected columns
                    else if(dragEndContainerId === 'selectedColumns') {
                        var draggedAvailableField = utility.filterObject(vm.availableFields , {displayLabel: draggedElementText}, true)[0];
                        if(draggedAvailableField) {
                            var indexOfAvailableField = vm.availableFields.indexOf(draggedAvailableField);
                            vm.selectedFields.push(draggedAvailableField);
                            $timeout(function() {
                                syncOrder(destination[0]);
                            });
                            vm.availableFields.splice(indexOfAvailableField, 1);
                        }
                        else {
                            $log.warn('Could not find the dragged element in available fields list');
                        }
                    }

                }
                else {
                    $log.warn('Could not find the dragged element');
                }
            }
            // if re-ordering selected columns
            // re-ordering columns will not execute code above hence if re-order selected columns it will change the order of element in filtered array and wont affect actual array which will be passed to directive
            // user can apply re-ordering only if he is not using filter feature to avoid complex computation hence this condition (!vm.SCFilter.displayLabel || vm.SCFilter.displayLabel === '') required
            else if(dragEndContainerId === 'selectedColumns' && (!vm.SCFilter.displayLabel || vm.SCFilter.displayLabel === '') ) {
                syncOrder(source[0]);
            }

            // if reordering filtered selectedFields should affect final result
            // else if(dragEndContainerId === 'selectedColumns') {
            //     if(source[0] && source[0].innerText) {
            //         var selectedColumnsDisplayLabel = source[0].innerText.match(/[^\r\n]+/g);
            //         TODO: indexedFields keys has been updated to {field} - {displayLabel}
            //         createIndexedAvailableFields().then(function(indexedFields) {
            //             if(selectedColumnsDisplayLabel.length) {
            //                 var reorderedFilteredSelectedFields = [];
            //                 angular.forEach(selectedColumnsDisplayLabel, function(selectedColumnDisplayLabel) {
            //                     reorderedFilteredSelectedFields.push(indexedFields[selectedColumnDisplayLabel]);
            //                 });
            //                 reorder(vm.selectedFields, reorderedFilteredSelectedFields);
            //             }
            //         });
            //     }
            //     else {
            //         $log.warn('Columns Chooser Controller - Could not fetch selected columns label');
            //     }
            // }
        });

        // function reorder(selectedFields, reorderedFilteredSelectedFields) {
        //    for(var i=0; i<selectedFields.length; i++) {
        //         var indexInReorderedFilteredSelectedFields = reorderedFilteredSelectedFields.indexOf(utility.filterObject(reorderedFilteredSelectedFields, {field: selectedFields[i].field}, true)[0]);
        //         if(indexInReorderedFilteredSelectedFields !== -1) {
        //             // field does not required to be re-ordered, remove it form reorderedFilteredSelectedFields
        //             if(indexInReorderedFilteredSelectedFields === 0) {
        //                 reorderedFilteredSelectedFields.shift();
        //             }
        //             // need to be re-ordered
        //             else if(indexInReorderedFilteredSelectedFields > 0) {
        //                 //swap field at indexInReorderedFilteredSelectedFields and field rest one position upper in reorderedFilteredSelectedFields in selectedFields
        //                 var swapFieldIndex = selectedFieldsCopy.indexOf(utility.filterObject(selectedFieldsCopy, {field: reorderedFilteredSelectedFields[indexInReorderedFilteredSelectedFields-1].field}, true)[0]);
        //                 var temp = selectedFields[swapFieldIndex];
        //                 selectedFields[swapFieldIndex] = selectedFields[i];
        //                 selectedFields[i] = temp;
        //                 break;
        //             }
        //         }
        //     }
        //     // does not visit all the elements
        //     if(i !== selectedFields.length) {
        //         return reorder(selectedFields, reorderedFilteredSelectedFields);
        //     }
        // }

        /**
         * @desc will sync order of elements in vm.selectedFields to match DOM
         * @param {DOM} selectedFieldsContainer
         */
        function syncOrder(selectedFieldsContainer) {
            vm.processing = true;
            if(selectedFieldsContainer && selectedFieldsContainer.innerText) {
                var selectedColumnsDisplayLabel = selectedFieldsContainer.innerText.match(/[^\r\n]+/g);
                if(selectedColumnsDisplayLabel.length) {
                    vm.selectedFields = [];
                    angular.forEach(selectedColumnsDisplayLabel, function(selectedColumnDisplayLabel) {
                        vm.selectedFields.push(indexedTranslatedFields[selectedColumnDisplayLabel]);
                    });
                    vm.processing = false;
                }
            }
            else {
                $log.warn('Columns Chooser Controller - Could not fetch selected columns label');
            }
        }

        $scope.$on('$destroy', function() {
            availableFieldsWatchUnsubscribe();
            unSubscribeDropEvent();
            //cancel all timeout promises
            for(var key in timeoutPromises) {
                $timeout.cancel(timeoutPromises[key]);
            }
            dragulaService.destroy($scope, 'bag-column-choose');
        });
    }
})();
(function() {
'use strict';

	angular
		.module('app.main')
		.controller('txDataTableChartsEditorController', txDataTableChartsEditorController);

	/* @ngInject */
	function txDataTableChartsEditorController($mdDialog, $document, $scope, $filter, hotkeys, utility, mockFactory, record, model, isNew, isCatalogModule, isTrasix, event) {
		/* jshint validthis: true */
		var vm = this;

		// chart info structure
		// {r1: (data range 1), o: (operator), r2: (data range 2), t: (chart title), g: (isGlobal), m: (mode, include inactive record)}

		vm.record = record ? record : {};
		var chartsInfo = [];
		vm.lookupModel = angular.copy(vm.record);
		vm.searchText = {};
		vm.dataRange1Fields = [];
		vm.dataRange2Fields = [];
		vm.types = [];

		vm.isCatalogModule = isCatalogModule;
		vm.isTrasix = isTrasix;
		vm.isNew = isNew;

		vm.saveRecord = saveRecord;
		vm.closeDialog = closeDialog;

		vm.lookupSearch = lookupSearch;
		vm.lookupChange = lookupChange;
		vm.getLookupDisplayValue = getLookupDisplayValue;
		vm.selectText = selectText;
		vm.isFormValid = isFormValid;

		activate();

		////////////////

		function activate() {
			populateDefaultValues();
			vm.dataRange1Fields = utility.filterObject(model.fields, { reportable: true });
			//for static columns of order & orderLine model, below for loop will translate its displayLabel
			for (var index = 0; index < vm.dataRange1Fields.length; index++) {
				vm.dataRange1Fields[index].displayLabel = $filter('translate')(vm.dataRange1Fields[index].displayLabel);
			}
			vm.dataRange2Fields = utility.filterObject(vm.dataRange1Fields, { inputType: 'number'});
			vm.types = mockFactory.getChartViewTypes();

			//Hotkeys
			hotkeys.bindTo($scope)
				.add({
					combo: 'ctrl+enter',
					description: $filter('translate')('ACTIONS.SAVE'),
					allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
					callback: function (event) {
						if (!vm.editForm.$invalid && isFormValid()) {
							vm.saveRecord();
						}
					}
				});

			if (vm.isNew) {

				hotkeys.bindTo($scope)
					.add({
						combo: 'ctrl+shift+enter',
						description: $filter('translate')('ACTIONS.SAVE_AND_NEW'),
						allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
						callback: function (event) {
							if (!vm.editForm.$invalid && isFormValid()) {
								vm.saveRecord(true);
							}
						}
					});
			}
		}

		function saveRecord(saveAndNew) {
			addChartTitle();
			chartsInfo.push({ displayLabel: vm.record.t, data: [], isGlobal: vm.record.g, meta: vm.record, isLoading: true });
			// when click on save and new while creating record
			if (vm.isNew && angular.isDefined(saveAndNew) && saveAndNew) {
				vm.editForm.$setPristine();
				vm.editForm.$setUntouched();
				vm.record = {};
				populateDefaultValues();
				vm.searchText = {};
				var el = $document[0].querySelector('#dialog_input_first');
				if (el) {
					el.focus();
				}
			}
			else {
				closeDialog();
			}
		}

		function closeDialog() {
			$mdDialog.hide(chartsInfo);
		}

		function lookupSearch(query, data, lookupPropertyName) {
			var results = [];
			var predicate = {};
			predicate[lookupPropertyName] = query;
			results = query ? utility.filterObject(data, predicate) : data;
			return results;
		}

		// convert drop down scope value form object(lookup record) to id property of lookup record
		function lookupChange(selectedObj, recordPropertyName, lookupPropertyName) {
			if (angular.isObject(selectedObj)) {
				vm.record[recordPropertyName] = selectedObj[lookupPropertyName];
			}
			else if (angular.isUndefined(selectedObj) || selectedObj === null) {
				vm.record[recordPropertyName] = undefined; // on record removal make field undefined or the property can be deleted using delete keyword
			}
		}

		function getLookupDisplayValue(item, sourceData, lookupProperty) {
			var result;
			var predicate = {};
			// since autocomplete return object
			if (angular.isObject(item)) {
				predicate[lookupProperty] = item[lookupProperty];
				result = utility.filterObject(sourceData, predicate, true);
			}
			// to initialize field value if any (when open update record dialog)
			else {
				predicate[lookupProperty] = item;
				result = utility.filterObject(sourceData, predicate, true);
			}

			if (angular.isArray(result) && result.length > 0) {
				return result[0].displayLabel;
			}
			else {
				return result.displayLabel;
			}
		}

		function selectText(event) {
      utility.selectInputText(event);
		}

		// since auto complete have issue with require validation a quick way to validate the form
		function isFormValid() {
			if(angular.isUndefined(vm.record.r1) || vm.record.r1 === null || angular.isUndefined(vm.record.o) || vm.record.o === null) {
				return false;
			}
			else if(vm.record.o === 2 && (angular.isUndefined(vm.record.r2) || vm.record.r2 === null)) {
				return false;
			}
			else return true;
		}


		// helper methods
		function populateDefaultValues() {
			if(angular.isUndefined(vm.record.m)) {
				vm.record.m = '0';
			}
			if(angular.isUndefined(vm.record.g)) {
				vm.record.g = '0';
			}
		}

		function addChartTitle() {
			vm.record.t = vm.lookupModel.r1.displayLabel + ' ( ';
			if(vm.record.o === 1) {
				vm.record.t += 'Count )';
			}
			else if(vm.record.o === 2) {
				vm.record.t += (' Sum of ' + vm.lookupModel.r2.displayLabel) + ' )';
			}
		}
	}
})();
(function() {
    'use strict';

    angular
        .module('app.main')
        .controller('activeCatalogDialogController', activeCatalogDialogController);

    /* @ngInject */
    function activeCatalogDialogController($mdDialog, $timeout, $window, utility, availableCatalogs, currentCatalog, sellersLookup, $scope) {
        var vm = this;

        vm.catalogs = availableCatalogs;
        vm.currentCatalog = undefined; //angular.copy(currentCatalog);
        var timeoutPromise;

        vm.applyChanges = applyChanges;
        vm.cancelDialog = cancelDialog;
        vm.querySearch = querySearch;
        vm.getSellerName = getSellerName;
        activate();

        ////////////////

        function activate() {
            timeoutPromise = $timeout(function() {
                var element = $window.document.getElementById('autocomplete-active-catalog');
                if (element && element.children[0] && element.children[0].children[0])
                    element.children[0].children[0].focus();
            }, 500);
        }

        function applyChanges() {
            $mdDialog.hide(vm.currentCatalog);
        }

        function cancelDialog() {
            $mdDialog.cancel();
        }

        function getSellerName(catalog) {
            var res = utility.filterObject(sellersLookup, { id: catalog.AccountId }, true);
            if (res && res.length > 0) {
                return '' + res[0].value;
            } else {
                return 'Unknown';
            }
        }

        function querySearch(search) {
            if (!search || search == '') {
                return availableCatalogs;
            } else {
                return utility.filterObject(availableCatalogs, { CatalogName: search });
            }
        }

        $scope.$on('$destroy', function() {
            $timeout.cancel(timeoutPromise);
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.dataExporter', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider)
    {
        $translatePartialLoaderProvider.addPart('app/services/dataExporter');
    }

})();
(function () {
  'use strict';

  angular
    .module('app.dataExporter')
    .controller('confirmationController', confirmationController);

  /** @ngInject */
  function confirmationController($mdDialog, orderlineExporter, ordersModel, orderlinesModel, orderId) {
    /* jshint validthis: true */
    var vm = this;

    //Methods
    vm.cancel = cancel;
    vm.exportOrderline = exportOrderline;


    //Methods Implementation

    function cancel() {
      $mdDialog.cancel();
    }

    function exportOrderline(confirmation) {
      vm.processing = true;
      var shouldIncludeInactiveOrderlines = false;
      if(confirmation.toLowerCase() === 'yes') {
        shouldIncludeInactiveOrderlines = true;
      }

      orderlineExporter.exportData(orderlinesModel, ordersModel, orderId, shouldIncludeInactiveOrderlines).finally(function() {
        vm.processing = false;
        $mdDialog.hide();
      });
    }

  }
})();
(function ()
{
    'use strict';

    angular
        .module('app.quick-panel', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider)
    {
        $translatePartialLoaderProvider.addPart('app/quick-panel');
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('ChatTabController', ChatTabController);

    /** @ngInject */
    function ChatTabController(api, $timeout)
    {
        var vm = this;

        // Data
        vm.chat = {};
        vm.chatActive = false;
        vm.replyMessage = '';

        api.quickPanel.contacts.get({}, function (response)
        {
            vm.contacts = response.data;
        });

        // Methods
        vm.toggleChat = toggleChat;
        vm.reply = reply;

        //////////

        function toggleChat(contact)
        {
            vm.chatActive = !vm.chatActive;

            if ( vm.chatActive )
            {
                vm.replyMessage = '';
                vm.chat.contact = contact;
                scrollToBottomOfChat(0);
            }
        }

        function reply()
        {
            if ( vm.replyMessage === '' )
            {
                return;
            }

            if ( !vm.chat.contact.dialog )
            {
                vm.chat.contact.dialog = [];
            }

            vm.chat.contact.dialog.push({
                who    : 'user',
                message: vm.replyMessage,
                time   : 'Just now'
            });

            vm.replyMessage = '';

            scrollToBottomOfChat(400);
        }

        function scrollToBottomOfChat(speed)
        {
            var chatDialog = angular.element('#chat-dialog');

            $timeout(function ()
            {
                chatDialog.animate({
                    scrollTop: chatDialog[0].scrollHeight
                }, speed);
            }, 0);

        }
    }

})();
(function () {
  'use strict';

  angular
    .module('app.main.vetting-lists')
    .controller('privacyPolicyDetailsController', privacyPolicyDetailsController);

  /* @ngInject */
  function privacyPolicyDetailsController($document, api, $state, $rootScope, $stateParams, dialog, $mdDialog) {
    /* jshint validthis: true */
    var vm = this;


    // the page was crashed on copying content from wiki
    // Data
    var Id = $stateParams.id;
    vm.model = api.lists.privacyPolicy;
    vm.record = {};
    vm.isLoading = false;

    // Methods
    vm.refreshRecord = refreshRecord;
    vm.copyPrivacyPolicy = copyPrivacyPolicy;
    activate();

    vm.editorConfig = {
      toolbar: false
    }

    ////////////////

    function activate() {
      refreshRecord(true);
    }

    function refreshRecord(isLogRequired) {
      vm.isLoading = true;

      vm.model.methods.getDetails(isLogRequired, Id)
        .then(function (response) {
          vm.record = response.data;
          vm.title = angular.copy(vm.record[vm.model.lookupDisplayField]);

          //Update Breadcrumb
          $state.current.data.displayName = vm.title;
          $rootScope.$broadcast('breadcrumb-updated');
        })
        .finally(function () {
          vm.isLoading = false;
        });
    }

    function copyPrivacyPolicy(ev) {
      $mdDialog.show({
        controller: 'createPrivacyPolicyController',
        controllerAs: 'vm',
        templateUrl: 'app/main/vetting-lists/dialogs/create-privacy-policy/create-privacy-policy.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: false,
        locals: {
          event: ev,
          model: vm.model,
          record: vm.record,
          isCopyPrivacyPolicy: true
        }
      }).then(function (saved) {
        if (saved) {
          refreshRecord(false);
        }
      });
    }

  }
})();
(function() {
	'use strict';

	angular
        .module('app.main.vas', [])
        .config(config);

        /* @ngInject */
        function config($stateProvider, $translatePartialLoaderProvider) {
            $stateProvider.state('app.vas_details', {
                url  : '/seller/:sellerId/vas/:id',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/vas/details/vas-details.html',
                        controller : 'vasDetailsController as vm'
                    }
                },
                data: {
                    displayName: 'VAS.TABS.VAS'
                },
                // accessPrivileges: ['GetVasDetails']
                accessInfo: {
                    accessPrivileges: ['GetVasDetails']
                }
            });

            // Translation
            $translatePartialLoaderProvider.addPart('app/main/vas');
        }
})();
(function() {
    'use strict';

    angular
        .module('app.main.vas')
        .controller('vasDetailsController', vasDetailsController);

    /* @ngInject */
    function vasDetailsController(api, $state, $stateParams, $rootScope, catalogFactory) {
       /* jshint validthis: true */
        var vm = this;

        var vasId = $stateParams.id;
        var activeCatalog = catalogFactory.getActiveCatalog();
        vm.sellerId = angular.isDefined($stateParams.sellerId) ? $stateParams.sellerId: activeCatalog.AccountId;

        vm.model = api.vas.vas;

        vm.vas = {};

        vm.isLoading = false;

        vm.refreshRecord = refreshRecord;
        vm.doVASItemAction = doVASItemAction;

        activate();

        ////////////////

        function activate() {
            refreshRecord(true);
        }

        function refreshRecord(isLogRequired) {
            vm.isLoading = true;

            vm.model.methods.getDetails(isLogRequired, vasId, vm.sellerId)
                .then(function (response) {
                    vm.vas = response.data;
                    vm.title = angular.copy(vm.vas[vm.model.lookupDisplayField]);

                    //Update Breadcrumb
                    $state.current.data.displayName = vm.title;
                    $rootScope.$broadcast('breadcrumb-updated');
                })
                .finally(function () {
                    vm.isLoading = false;
                });
        }

        function doVASItemAction(action, record) {
            if (action) {
                switch (action.id) {
                    case 'delete':
                    case 'activate':
                        vm.model.methods.updateStatus(record, vm.model, action.id, record[vm.model.idField], vm.sellerId);
                        break;
                }
            }
        }
    }
})();
(function () {
	'use strict';

	angular
		.module('app.main.seller-models')
		.controller('sellerModelsListController', sellerModelsListController);

	/* @ngInject */
	function sellerModelsListController(api, $rootScope, $scope, $state, catalogFactory, settingsFactory, sellerModelAttributesModel, $document, utility, dataImporter, $mdDialog, SecurityFactory, dialog, CONSTANTS
		, $filter, alertDialog, crud, bulkUpdater) {
		/* jshint validthis: true */
		var vm = this;

		//Data
		var activeCatalog = catalogFactory.getActiveCatalog();
		var catalogCode = activeCatalog.CatalogCode;
		var sellerId = activeCatalog.AccountId;
		var attributeGroupId = activeCatalog.AttributeGroupId;
		var isAutomaticNumberingEnabled = catalogFactory.getAutomaticNumbering();

		// check the special privilege is assigned to the user for updating the state. if then does not restrict sizescale and model name update
		var isSpecialPermissionToIgnoreArticleStateIsAssigned = SecurityFactory.isAuthorized({accessPrivileges: CONSTANTS.PRIVILEGES.ARTICLES.SPECIAL_PRIVILEGE_TO_SKIP_STATE_VALIDATION});
		var updateSizeScaleChangeManagementExternalURL = '';
		var updateModelNameChangeManagementExternalURL = '';
		var updateArticleChangeManagementExternalURL = '';

		vm.model = sellerModelAttributesModel;
		settingsFactory.applyPersistedListViewLayout(vm.model);

		vm.sellerModels = [];
		vm.filteredSellerModels = [];
		vm.isLoading = false;


		//Methods
		vm.refreshItems = refreshItems;
		vm.doItemAction = doItemAction;
		vm.doListAction = doListAction;
		vm.viewItem = viewItem;
		vm.addRecord = addRecord;

		activate();

		////////////////

		function activate() {
			refreshItems(api.sellerModels.sellerModels.isDirty, true);
			api.webGet('/app/app.config.json').then(function(response) {
				if (angular.isDefined(response) && angular.isDefined(response.data)) {
						if(angular.isDefined(response.data['updateSizeScaleChangeManagementExternalURL']) && response.data['updateSizeScaleChangeManagementExternalURL'].length) {
							updateSizeScaleChangeManagementExternalURL = response.data['updateSizeScaleChangeManagementExternalURL'];
						}
						if(angular.isDefined(response.data['updateModelNameChangeManagementExternalURL']) && response.data['updateModelNameChangeManagementExternalURL'].length) {
							updateModelNameChangeManagementExternalURL = response.data['updateModelNameChangeManagementExternalURL'];
						}
						if(angular.isDefined(response.data['updateArticleChangeManagementExternalURL']) && response.data['updateArticleChangeManagementExternalURL'].length) {
							updateArticleChangeManagementExternalURL = response.data['updateArticleChangeManagementExternalURL'];
						}
				}
			});
		}

		function refreshItems(forceFetch, isLogRequired) {
			vm.isLoading = true;
			var generalProperties = {
				forceFetch: forceFetch,
				isLogRequired: isLogRequired,
				config: {},
				supportIncrementalResult: true,
				modelIdField: 'ModelId',
				isMajor: false,
				model: vm.model
			}
			vm.model.methods.getList(generalProperties, vm.model, sellerId, attributeGroupId)
				.then(function (response) {
					vm.sellerModels = response.data;
					if (angular.isDefined(vm.tableControl) && angular.isDefined(vm.tableControl.updateData)) {
						vm.tableControl.updateData();
					}
				})
				.finally(function () {
					vm.isLoading = false;
				});
		}

		//Item Action button pressed event
		function doItemAction(action, record) {
			if (action && record) {
				switch (action.id) {
					case 'view':
						viewItem(record);
						break;
					case 'edit':
						vm.model.methods.getDetails(true, record.ModelId, sellerId, attributeGroupId).then(function (response) {
							editItem(response.data[0], null);
						});
						break;
					case 'SetSizes':
						// if state is assigned for the modeland size scale is not editable at state level then restrict updating sizescales
						if(!isSpecialPermissionToIgnoreArticleStateIsAssigned && record.ModelStateId != null) {
							var assignedState = utility.filterObject(api.articleStatesList, {StateId: record.ModelStateId}, true)[0];
							if(assignedState && !assignedState.IsSizeScaleEditable) {
								if(assignedState.AllowChangeRequestForSizeScale && updateSizeScaleChangeManagementExternalURL !== '') {
									alertDialog.show('ALERT.NOT_EDITABLE_SIZE_SCALE_AT_ARTICLE_STATE', updateSizeScaleChangeManagementExternalURL);
								} else {
									dialog.showAlertDialog(
										angular.element($document.body),
										$filter('translate')('MESSAGES.TITLE.ALERT'),
										$filter('translate')('SELLER_MODELS.MESSAGES.NOT_EDITABLE_SIZE_SCALE'),
										$filter('translate')('MESSAGES.TITLE.ALERT'),
										$filter('translate')('ACTIONS.DIALOG_CLOSE'),
										true,
										null
									);
								}
							} else {
								setSellerSizeScale(record, null);
							}
						} else {
							setSellerSizeScale(record, null);
						}
						break;
				}
			}
		}

		function doListAction(action, records) {
			if (action) {
				switch (action.id) {
					case 'SetSizes':
						var modelCopy = angular.copy(vm.model);
						var sizeScaleField = utility.filterObject(modelCopy.fields, { field: 'SizeScale' }, true)[0];
						sizeScaleField.editable = true;
						var sizeScaleGroupsPromise = api.sellers.sizeScaleGroups.methods.getList(undefined, { forceFetch: true, isLogRequired: false }, sellerId);
						sizeScaleField.validation.dataExistConstraints = { promise: sizeScaleGroupsPromise };

						var masterSizeScaleField = utility.filterObject(modelCopy.fields, { field: 'MasterSizeScale' }, true)[0];
						masterSizeScaleField.editable = true;
						var masterSizeScalesPromise = api.sellers.masterSizeScales.methods.getList(undefined, {forceFetch: true, isLogRequired: true}, sellerId);
						masterSizeScaleField.validation.dataExistConstraints = { promise: masterSizeScalesPromise, model: api.sellers.masterSizeScales };

						// make creatable false to all fields except SizeScaleId
						angular.forEach(modelCopy.fields, function( field) {
							if((field.field !== 'SizeScale' && field.field !== 'MasterSizeScale') && field.editable) {
								field.editable = false;
							}
						});

						var modelNumberField = utility.filterObject(modelCopy.fields, { field: 'ModelNumber' }, true)[0];
						modelNumberField.editable = true;
						modelNumberField.validation.dataExistConstraints = { checkinListData: true };
						//make model number as unique constraint
						modelCopy.uniqueConstraints = [{name: 'Constraint 1', fields: ['ModelNumber']}];
						dataImporter.importExcel(modelCopy, false, {}, action.id, vm.sellerModels).then(function (result) {
								modelCopy.methods.setSizeScaleBulk(vm.model, result.data, sellerId, attributeGroupId, vm.sellerModels, sizeScaleGroupsPromise, masterSizeScalesPromise);
						});
						break;
					case 'updateBulk':
						var isArticleCountWithinLimit = true;
						if(api.articlesLimitForBackgroundJobs > 0 && records.length > api.articlesLimitForBackgroundJobs) {
							isArticleCountWithinLimit = false;
						}
						if(isArticleCountWithinLimit) {
							modelCopy = angular.copy(vm.model);
							modelNumberField = utility.filterObject(modelCopy.fields, {field: 'ModelNumber'}, true)[0];
							modelNumberField.editable = false;
							var modelNameField = utility.filterObject(modelCopy.fields, {field: 'ModelName'}, true)[0];
							// if configured model name length then change the allowed max length to the configured value
							var configuredModelNameLength = catalogFactory.getModelNameLength();
							if(configuredModelNameLength !== 100) {
								modelNameField.validation.maxLen = configuredModelNameLength;
							}
							var lookupPromises = {};
							lookupPromises = crud.createLookupPromise(modelCopy, undefined , 'edit');
							bulkUpdater.showDialog(modelCopy, vm.sellerModels, {'sellerId': sellerId,'attributeGroupId': attributeGroupId}, lookupPromises)
								.then(function(response) {
										if(angular.isDefined(response) && response.toString() != 'false') {
												for(var key in response.propertiesToUpdate) {
														if(response.propertiesToUpdate.hasOwnProperty(key)) {
																var multiValueAttribute = utility.filterObject(modelCopy.fields, {field: key}, true)[0];
																if (angular.isDefined(multiValueAttribute) && multiValueAttribute.inputType === 'multi-value') {
																		var multiValue = response.propertiesToUpdate[key];
																		response.propertiesToUpdate[key] = multiValue;
																}
														}
												}

												vm.model.methods.updateBulk(vm.model, response.selectedRecords, response.propertiesToUpdate, response.idMap);
										}
								});
						}
						else {
							dialog.showAlertDialog(
									angular.element($document.body),
									$filter('translate')('MESSAGES.TITLE.ALERT'),
									$filter('translate')('ARTICLES.MESSAGES.SHOW_ARTICLE_BACKGROUND_JOB_LIMIT_WARNING'),
									$filter('translate')('MESSAGES.TITLE.ALERT'),
									$filter('translate')('ACTIONS.DIALOG_CLOSE'),
									true,
									null
							);
						}
						break;
					case 'updateViaImport':
						var modelCopy = angular.copy(vm.model);
						var modelNumberField = utility.filterObject(modelCopy.fields, {field: 'ModelNumber'}, true)[0];
						modelNumberField.editable = true;
						var modelNameField = utility.filterObject(modelCopy.fields, {field: 'ModelName'}, true)[0];
						modelNameField.editable = true;
						modelNameField.validation.isRequired = false;
						// if configured model name length then change the allowed max length to the configured value
						var configuredModelNameLength = catalogFactory.getModelNameLength();
						if(configuredModelNameLength !== 100) {
							modelNameField.validation.maxLen = configuredModelNameLength;
						}
						var attributeGroupField = utility.filterObject(modelCopy.fields, {field: 'AttributeGroupId', inputType: 'lookup'}, true)[0];
						attributeGroupField.editable = false;
						var parentModelTypeField = utility.filterObject(modelCopy.fields, {field: 'parent_model_type'}, true)[0];
						if(parentModelTypeField && parentModelTypeField.editable) {
								// make ParentModelNumber creatable
								var parentModelNumberField = utility.filterObject(modelCopy.fields, {field: 'ParentModelNumber'}, true)[0];
								if(angular.isDefined(parentModelNumberField)) {
										parentModelNumberField.editable = true;
								}
						}

						//make all attribute non mandatory for update
						angular.forEach(modelCopy.fields, function(field) {
								if(field.isAttribute && field.editable) {
										field.validation.isRequiredIfMapped = field.validation.isRequired;
										field.validation.isRequired = false;
								}
								if(field.inputType === 'linkedcatalogarticlenumber' || field.inputType === 'lookup-table') {
										field.editable = false;
								}
						});

						//make model number as unique constraint
						modelCopy.uniqueConstraints = [{name: 'Constraint 1', fields: ['ModelNumber']}];

						dataImporter.importExcel(modelCopy, false, {isUpdateArticlesByModel : true}, action.id, vm.sellerModels).then(function(result) {
								vm.model.methods.updateViaImport(vm.model, result.data, sellerId, attributeGroupId);
						});
						break;
				}
			}
		}

		function viewItem(item) {
			var stateParams = { id: item.ModelId};
			$state.go('app.seller_models.details', stateParams);
		}

		function addRecord(ev) {
			var modelCopy = angular.copy(vm.model);
			var lookupExtras = {};
			// if automatic article numbering is disabled Model Number is creatable
			if(!isAutomaticNumberingEnabled) {
				var modelNumberField = utility.filterObject(modelCopy.fields, {field: 'ModelNumber'}, true)[0];
				modelNumberField.creatable = true;
			}

			// if IsSizeScaleByStyle is enabled then make the size scale field creatable part of model
			// if(catalogFactory.getIsSizeScaleByStyle()) {
			// 	var sizeScaleField = utility.filterObject(modelCopy.fields, { field: 'SizeScaleId', inputType: 'lookup' }, true)[0];
			// 	sizeScaleField.creatable = true;
			// 	sizeScaleField.validation.isRequired = false;
			// 	lookupExtras['lists.availableSizeScaleForModel'] = {};
			// 	lookupExtras['lists.availableSizeScaleForModel']['sellerId'] = sellerId;
			// }

			// if configured model name length then change the allowed max length to the configured value
			var configuredModelNameLength = catalogFactory.getModelNameLength();
			if(configuredModelNameLength !== 100) {
				var modelNameField = utility.filterObject(modelCopy.fields, {field: 'ModelName'}, true)[0];
				modelNameField.validation.maxLen = configuredModelNameLength;
			}

			api.showCreateRecordDialog(angular.element($document.body), ev, modelCopy, sellerId, undefined, lookupExtras)
			.then(function(saved) {
					if (saved) {
							refreshItems(true, false);
					}
			});
		}

		function editItem(record, ev) {
			var modelCopy = angular.copy(vm.model);
			// if automatic article numbering is disabled Model Number is editable
			if(!isAutomaticNumberingEnabled) {
				var modelNumberField = utility.filterObject(modelCopy.fields, {field: 'ModelNumber'}, true)[0];
				modelNumberField.editable = true;
			}
			// if configured model name length then change the allowed max length to the configured value
			var configuredModelNameLength = catalogFactory.getModelNameLength();
			if(configuredModelNameLength !== 100) {
				var modelNameField = utility.filterObject(modelCopy.fields, {field: 'ModelName'}, true)[0];
				modelNameField.validation.maxLen = configuredModelNameLength;
			}
			// if state is assigned then make non editable attrbutes as non editable
			if(!isSpecialPermissionToIgnoreArticleStateIsAssigned && record.ModelStateId != null) {
				var assignedState = utility.filterObject(api.articleStatesList, {StateId: record.ModelStateId}, true)[0];
				if(assignedState && !assignedState.IsModelNameEditable) {
					var modelNameField = utility.filterObject(modelCopy.fields, {field: 'ModelName'}, true)[0];
					if(angular.isDefined(modelNameField)) {
							modelNameField.editable = false;
							modelNameField.showInEdit = true;
							modelNameField['isAllowChangeRequestEnabled'] = assignedState.AllowChangeRequestForModelName;
							if(assignedState.AllowChangeRequestForModelName && updateModelNameChangeManagementExternalURL !== '') {
								modelNameField['updateArticleChangeManagementExternalURL'] = updateModelNameChangeManagementExternalURL;
							}
					}
				}
				// if any non editable attribute set them as readonly
				if(assignedState && assignedState.NonEditableAttributes.length) {
					angular.forEach(assignedState.NonEditableAttributes, function(attribute) {
							var nonEditableAttrField = utility.filterObject(modelCopy.fields, {field: attribute.AttributeSystemName}, true)[0];
							if(angular.isDefined(nonEditableAttrField)) {
									nonEditableAttrField.editable = false;
									nonEditableAttrField.showInEdit = true;
									nonEditableAttrField['isAllowChangeRequestEnabled'] = attribute.AllowChangeRequest;
									if(attribute.AllowChangeRequest) {
											nonEditableAttrField['updateArticleChangeManagementExternalURL'] = updateArticleChangeManagementExternalURL;
									}
							}
					});
				}
			}
			api.showEditRecordDialog(angular.element($document.body), ev, modelCopy, record, sellerId)
			.then(function(saved) {
					if (saved) {
							refreshItems(true, false);
					}
			});
		}

		function setSellerSizeScale(record, ev) {
			$mdDialog.show({
					controller         : 'setModelSizeScaleController',
					controllerAs       : 'vm',
					templateUrl        : 'app/main/seller-models/list/dialogs/set-model-size-scales/set-model-size-scales.html',
					parent             : angular.element($document.body),
					targetEvent        : ev,
					clickOutsideToClose: false,
					locals             : {
							sellerId: sellerId,
							attributeGroupId: attributeGroupId,
							model: vm.model,
							record: record,
							currentModel: utility.filterObject(vm.sellerModels, {ModelNumber: record.ModelNumber}, true)[0],
							selectedModel: record,
							event: ev
					}
			});
		}

		var catalogChangedEventCleanup = $rootScope.$on('ActiveCatalogChangedEvent', function (e) {
			if (catalogCode !== catalogFactory.getActiveCatalog().CatalogCode) {
				$state.reload('app.seller-models');
			}
		});

		$scope.$on('$destroy', function () {
			catalogChangedEventCleanup();
		});

	}
})();
(function () {
	'use strict';

	angular
		.module('app.main.seller-models')
		.controller('sellerModelsDetailsController', sellerModelsDetailsController);

	/* @ngInject */
	function sellerModelsDetailsController($rootScope, $document, $state, $stateParams, catalogFactory,
		settingsFactory, sellerModelAttributesModel, SecurityFactory, articlesModel, api, CONSTANTS, utility, $mdDialog, crud) {
		/* jshint validthis: true */
		var vm = this;

		// Data
		var modelId = $stateParams.id;
		var activeCatalog = catalogFactory.getActiveCatalog();
		var sellerId = activeCatalog.AccountId;
		var attributeGroupId = activeCatalog.AttributeGroupId;
		var isAutomaticNumberingEnabled = catalogFactory.getAutomaticNumbering();
		// check the special privilege is assigned to the user for updating the state. if then does not restrict sizescale and model name update
		var isSpecialPermissionToIgnoreArticleStateIsAssigned = SecurityFactory.isAuthorized({accessPrivileges: CONSTANTS.PRIVILEGES.ARTICLES.SPECIAL_PRIVILEGE_TO_SKIP_STATE_VALIDATION});
		var updateModelNameChangeManagementExternalURL = '';

		vm.model = sellerModelAttributesModel;

		vm.catalogsModel = api.sellerModels.sellerModelCatalogs;
		settingsFactory.applyPersistedListViewLayout(vm.catalogsModel);

		vm.articlesModel = angular.copy(articlesModel);
		settingsFactory.applyPersistedListViewLayout(vm.articlesModel);

		vm.sizesModel = api.sellerModels.sellerModelSizes;
		settingsFactory.applyPersistedListViewLayout(vm.sizesModel);

		vm.sellerModelResourcesModel = api.sellerModels.sellerModelResources;
		settingsFactory.applyPersistedListViewLayout(vm.sellerModelResourcesModel);

		vm.modelDetails = {};
		vm.modelCatalogs = [];
		vm.filteredModelCatalogs = [];
		vm.modelArticles = [];
		vm.filteredModelArticles = [];
		vm.modelSizes = [];
		vm.filteredModelSizes = [];
		vm.modelResources = [];
		vm.filteredModelResources = [];

		vm.isLoading = false;
		vm.isModelCatalogsLoading = false;
		vm.isModelArticlesLoading = false;
		vm.isModelSizesLoading = false;
		vm.isModelResourcesLoading = false;

		// Methods
		vm.refreshRecord = refreshRecord;
		vm.editItem = editItem;
		vm.refreshModelCatalogs = refreshModelCatalogs;
		vm.refreshModelArticles = refreshModelArticles;
		vm.refreshModelResources = refreshModelResources;
		vm.doResourceItemAction = doResourceItemAction;
		vm.doResourceListAction = doResourceListAction;
		vm.assignResources = assignResources;
		vm.viewResource = viewResource;

		activate();

		////////////////

		function activate() {
			refreshRecord(true);
			api.webGet('/app/app.config.json').then(function(response) {
				if (angular.isDefined(response) && angular.isDefined(response.data)) {
						if(angular.isDefined(response.data['updateModelNameChangeManagementExternalURL']) && response.data['updateModelNameChangeManagementExternalURL'].length) {
							updateModelNameChangeManagementExternalURL = response.data['updateModelNameChangeManagementExternalURL'];
						}
				}
			});
		}

		function refreshRecord(isLogRequired) {
			vm.isLoading = true;
			vm.model.methods.getDetails(isLogRequired, modelId, sellerId, attributeGroupId)
			  .then(function (response) {
					vm.modelDetails = response.data[0];
					// if size scale is assigned create sizes data
					if(vm.modelDetails.SizeScaleId != null) {
						createSizesDataForListView();
					}
					vm.title = angular.copy(vm.modelDetails[vm.model.lookupDisplayField]);
					initializeTabData(isLogRequired);

					//Update Breadcrumb
					$state.current.data.displayName = vm.title;
					$rootScope.$broadcast('breadcrumb-updated');
				})
				.finally(function () {
					vm.isLoading = false;
				});
		}

		function createSizesDataForListView() {
			// seller sizesscales API
			vm.isModelSizesLoading = true;
			var generalProperties = {
				forceFetch: true,
				isLogRequired: true
			}
			api.sellers.sizeScaleGroups.methods.getList(api.sellers.sizeScaleGroups, generalProperties, sellerId).then(function(response) {
				// do we need to list obsolete and inactive sizes
				var sizeScales = response.data;
				vm.modelSizes = [];
				var assignedSizeScale = utility.filterObject(sizeScales, {Id: vm.modelDetails.SizeScaleId}, true)[0];
				if(assignedSizeScale) {
					var sizes = assignedSizeScale.Sizes.split(',').map(function(size) {
						return size.toString().trim();
					});
					// find the size index of assigned sizes from the SizesMap list
					api.lists.sizeMap.methods.getList(generalProperties).then(function(sizeMapsResponse) {
						var sizeMapsList = sizeMapsResponse.data;
						angular.forEach(sizes, function(size) {
							var sizeMap = utility.filterObject(sizeMapsList, {Size: size}, true)[0];
								if(sizeMap) {
								vm.modelSizes.push(
									{
										SizeName: sizeMap.Size,
										SizeIndex: sizeMap.SizeIndex,
										SortOrder: 0
									}
								);
							} else {
								vm.modelSizes.push(
									{
										SizeName: size,
										SizeIndex: 0,
										SortOrder: 0
									}
								);
							}
						})
						if(angular.isDefined(vm.tableSizesControl) && angular.isDefined(vm.tableSizesControl.updateData)) {
							vm.tableSizesControl.updateData();
						}
					})
				}
			})
			.finally(function () {
				vm.isModelSizesLoading = false;
			})
		}

		function refreshModelCatalogs(forceFetch, isLogRequired) {
			var generalProperties = {
				forceFetch: forceFetch,
				isLogRequired: isLogRequired
			}
			vm.isModelCatalogsLoading = true;

			vm.catalogsModel.methods.getList(generalProperties, sellerId, modelId)
				.then(function (response) {
					vm.modelCatalogs = response.data;
				})
				.finally(function() {
					vm.isModelCatalogsLoading = false;
				});
		}

		function refreshModelArticles(forceFetch, isLogRequired) {
			var generalProperties = {
				forceFetch: forceFetch,
				isLogRequired: isLogRequired
			}
			vm.isModelArticlesLoading = true;
			vm.articlesModel.methods.getList(generalProperties, sellerId, modelId)
			.then(function(response) {
				vm.modelArticles = response.data.Articles;
			})
			.finally(function() {
				vm.isModelArticlesLoading = false;
			});
		}

		function editItem(record, ev) {
			var modelCopy = angular.copy(vm.model);
			// if automatic article numbering is disabled Model Number is editable
			if(!isAutomaticNumberingEnabled) {
				var modelNumberField = utility.filterObject(modelCopy.fields, {field: 'ModelNumber'}, true)[0];
				modelNumberField.editable = true;
			}
			// if configured model name length then change the allowed max length to the configured value
			var configuredModelNameLength = catalogFactory.getModelNameLength();
			if(configuredModelNameLength !== 100) {
				var modelNameField = utility.filterObject(modelCopy.fields, {field: 'ModelName'}, true)[0];
				modelNameField.validation.maxLen = configuredModelNameLength;
			}
			// if state is assigned then make non editable attrbutes as non editable
			if(!isSpecialPermissionToIgnoreArticleStateIsAssigned && record.ModelStateId != null) {
				var assignedState = utility.filterObject(api.articleStatesList, {StateId: record.ModelStateId}, true)[0];
				if(assignedState && !assignedState.IsModelNameEditable) {
					var modelNameField = utility.filterObject(modelCopy.fields, {field: 'ModelName'}, true)[0];
					if(angular.isDefined(modelNameField)) {
							modelNameField.editable = false;
							modelNameField.showInEdit = true;
							modelNameField['isAllowChangeRequestEnabled'] = assignedState.AllowChangeRequestForModelName;
							if(assignedState.AllowChangeRequestForModelName && updateModelNameChangeManagementExternalURL !== '') {
								modelNameField['updateArticleChangeManagementExternalURL'] = updateModelNameChangeManagementExternalURL;
							}
					}
				}
			}
			api.showEditRecordDialog(angular.element($document.body), ev, modelCopy, record, sellerId)
			.then(function(saved) {
					if (saved) {
						refreshRecord(false);
					}
			});
		}

		function initializeTabData(isLogRequired) {
			if(SecurityFactory.isAuthorized({accessPrivileges: CONSTANTS.PRIVILEGES.SELLER_MODELS.DETAIL.MODEL_CATLOG_LIST})) {
				refreshModelCatalogs(vm.catalogsModel.isDirty, isLogRequired);
			}
			if(SecurityFactory.isAuthorized({accessPrivileges: CONSTANTS.PRIVILEGES.SELLER_MODELS.DETAIL.MODEL_ARTICLE_LIST})) {
				refreshModelArticles(vm.articlesModel.isDirty, isLogRequired);
			}
			refreshModelResources(true, isLogRequired);
		}

		function refreshModelResources(forceFetch, isLogRequired) {
			var generalProperties = {
				forceFetch: forceFetch,
				isLogRequired: isLogRequired
			};
			vm.isModelResourcesLoading = true;
			vm.sellerModelResourcesModel.methods.getList(generalProperties, sellerId, attributeGroupId, modelId)
			.then(function(response) {
				vm.modelResources = response.data || [];
			})
			.finally(function() {
				vm.isModelResourcesLoading = false;
			});
		}

		function doResourceItemAction(action, record) {
			if(action && record) {
				switch (action.id) {
					case 'view':
						viewResource(record);
						break;
					case 'delete':
						var resId = record[vm.sellerModelResourcesModel.idField];
						api.webPut(api.baseUrl + '/sellers/' + sellerId + '/' + attributeGroupId + '/models/' + modelId + '/resources/' + resId + '/status', {Status: 0})
						.then(function() { refreshModelResources(true, false); });
						break;
				}
			}
		}

		function doResourceListAction(action, records) {
			if(action && records) {
				switch (action.id) {
					case 'delete':
						unassignResources(records);
						break;
				}
			}
		}

		function unassignResources(recordsToRemove) {
			var deleteIds = recordsToRemove.map(function(r) { return r[vm.sellerModelResourcesModel.idField]; });
			var remainingIds = vm.modelResources
				.filter(function(r) { return r.Status !== 0 && deleteIds.indexOf(r[vm.sellerModelResourcesModel.idField]) === -1; })
				.map(function(r) { return r[vm.sellerModelResourcesModel.idField]; });
			var requestObj = { ResourceId: remainingIds };
			api.webPut(api.baseUrl + '/sellers/' + sellerId + '/' + attributeGroupId + '/models/' + modelId + '/assignresources', requestObj)
			.then(function() {
				refreshModelResources(true, false);
			});
		}

		function viewResource(record) {
			if(record.Status === 1) {
				var id = record[vm.sellerModelResourcesModel.idField];
				var stateParams = {id: id};
				$state.go('app.seller-resources.details', stateParams);
			}
		}

		function assignResources(ev) {
			$mdDialog.show({
				controller         : 'assignSellerModelResourcesController',
				controllerAs       : 'vm',
				templateUrl        : 'app/main/seller-models/details/tabs/seller-model-resources/dialogs/assign-seller-model-resources.html',
				parent             : angular.element($document.body),
				targetEvent        : ev,
				clickOutsideToClose: false,
				locals             : {
					model: vm.sellerModelResourcesModel,
					sellerId: sellerId,
					attributeGroupId: attributeGroupId,
					modelId: modelId,
					assignedResources: vm.modelResources
				}
			}).then(function(saved) {
				if (saved) {
					refreshModelResources(true, false);
				}
			});
		}

	}
})();
(function() {
    'use strict';

    angular
        .module('app.main.roles', [
            'app.main.roles.privileges',
            'app.main.roles.linkedCatalogs'
        ])
        .config(config);

    /* @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {

        $stateProvider.state('app.roles', {
            url    : '/roles',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/roles/list/roles-list.html',
                    controller : 'rolesListController as vm'
                }
            },
            data: {
                displayName: 'ROLES.NAV'
            },
            resolve: {},
			// accessPrivileges: ['GetAccountTypeRolesList']
            // accessPrivileges: ['nav_roles']
            accessInfo: {
                accessPrivileges: ['nav_roles']
            },
            visibleForLinePlan: true
        });

        $stateProvider.state('app.roles.details', {
			url	 : '/:id',
            views: {
				'content@app': {
					templateUrl: 'app/main/roles/details/roles-details.html',
					controller : 'roleDetailsController as vm'
				}
			},
			data: {
                displayName: 'ROLES.TABS.ROLE',
				parentState: 'app.roles'
			},
            resolve: {},
            // accessPrivileges: ['GetAccountTypeRolesDetails']
            accessInfo: {
                accessPrivileges: ['GetAccountTypeRolesDetails']
            },
            visibleForLinePlan: true
		});

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/roles');

        // Navigation
        msNavigationServiceProvider.saveItem('configuration.roles', {
            title      : 'Roles',
            icon       : 'icon-account',
            state      : 'app.roles',
            translate  : 'ROLES.NAV',
            weight     : 10,
            // accessPrivileges: ['GetAccountTypeRolesList']
            // accessPrivileges: ['nav_roles'],
            accessInfo: {
                accessPrivileges: ['nav_roles']
            },
            visibleForLinePlan: true
        });
    }

})();
(function() {
    'use strict';

	angular
		.module('app.main.roles')
		.controller('rolesListController', rolesListController);

	/* @ngInject */
	function rolesListController(api, $state, $document, settingsFactory) {
		/* jshint validthis: true */
		var vm = this;

        vm.model = api.roles.roles;
        settingsFactory.applyPersistedListViewLayout(vm.model);

		vm.roles = [];
		vm.filteredRoles = [];
		vm.isLoading = false;


		vm.refreshItems = refreshItems;
		vm.doListAction = doListAction;
		vm.doItemAction = doItemAction;
		vm.viewItem = viewItem;
		vm.addRecord = addRecord;

		activate();

		////////////////

		function activate() {
			refreshItems(vm.model.isDirty, true);
		}

		function refreshItems(forceFetch, isLogRequired) {
			vm.isLoading = true;
            var generalProperties = {
                forceFetch: forceFetch,
                isLogRequired: isLogRequired
            }

			vm.model.methods.getList(generalProperties)
			.then(function (response) {
				vm.roles = response.data;
			})
			.finally(function () {
				vm.isLoading = false;
			});
		}

		//Item Action button pressed event
		function doItemAction(action, record) {
			if (action && record) {
                switch (action.id) {
                    case 'view':
                        viewItem(record);
                        break;
                    case 'edit':
                        vm.model.methods.getDetails(true, record[vm.model.idField])
                        .then(function (response) {
                            var details = response.data;
                            details.Catalogs = response.data.Catalogs.map(function(catalog) {
                                return catalog.Id
                            })
                            editItem(details, null);
                        })
                        break;
                    case 'delete':
                    case 'activate':
                        vm.model.methods.activateBulk(record, vm.model, action.id, undefined);
                        break;
                }
			}
		}

        //List Action button pressed event
        function doListAction(action, records) {
            if (action) {
                switch (action.id) {
                    case 'delete':
                    case 'activate':
                        vm.model.methods.activateBulk(records, vm.model, action.id, undefined);
                        break;
                }
            }
        }

         function viewItem(record) {
            var id = record[vm.model.idField];
            var stateParams = {id: id};
            $state.go('app.roles.details', stateParams);
		}

        function addRecord(ev) {
            api.showCreateRecordDialog(angular.element($document.body), ev, vm.model)
            .then(function(saved) {
                if (saved) {
                    refreshItems(true, false);
                }
            });
		}

		function editItem(record, ev) {
            api.showEditRecordDialog(angular.element($document.body), ev, vm.model, record)
            .then(function(saved) {
                if (saved) {
                    refreshItems(true, false);
                }
            });
		}

	}
})();
(function() {
    'use strict';

    angular
        .module('app.main.roles')
        .controller('roleDetailsController', roleDetailsController);

    /* @ngInject */
    function roleDetailsController($document, api, $state, $rootScope, $stateParams, $mdDialog, settingsFactory, SecurityFactory, CONSTANTS) {
       /* jshint validthis: true */
        var vm = this;

        // Data
        var roleId = $stateParams.id;
        vm.model = api.roles.roles;
        vm.role = {};
        vm.isLoading = false;

        vm.privilegesModel = api.roles.privileges;
        settingsFactory.applyPersistedListViewLayout(vm.privilegesModel);

        vm.linkedCatalogsModel = api.roles.linkedCatalogs;
        settingsFactory.applyPersistedListViewLayout(vm.linkedCatalogsModel);

        vm.rolePrivileges = [];
        vm.filteredRolePrivileges = [];
        vm.isPrivilegesLoading = false;

        vm.linkedCatalogs = [];
        vm.filteredLinkedCatalogs = [];

        var isTabDataInitialized = false;


        // Methods
        vm.refreshRecord = refreshRecord;
        vm.doRoleItemAction = doRoleItemAction;
        vm.refreshPrivileges = refreshPrivileges;
        vm.managePrivileges = managePrivileges;

        activate();

        ////////////////

        function activate() {
            refreshRecord(true);
        }

        function refreshRecord(isLogRequired) {
            vm.isLoading = true;

            vm.model.methods.getDetails(isLogRequired, roleId)
                .then(function (response) {
                    vm.role = response.data;
                    vm.title = angular.copy(vm.role[vm.model.lookupDisplayField]);
                    //populate Linked Catalogs Data
                    vm.linkedCatalogs = angular.copy(response.data.Catalogs);

                    response.data.Catalogs = [];
                    //update Catalogs property of response for proper display of catalog in edit role dialog
                    angular.forEach(vm.linkedCatalogs, function(catalog) {
                        response.data.Catalogs.push(catalog.CatalogCode);
                    })

                    //Update Breadcrumb
                    $state.current.data.displayName = vm.title;
                    $rootScope.$broadcast('breadcrumb-updated');

                    initializeTabData(isLogRequired);
                })
                .finally(function () {
                    vm.isLoading = false;
                });
        }

        function refreshPrivileges(forceFetch, isLogRequired) {
            vm.isPrivilegesLoading = true;
            var generalProperties = {
                forceFetch: forceFetch,
                isLogRequired: isLogRequired
            }

            vm.privilegesModel.methods.getList(generalProperties, roleId)
                .then(function (response) {
                    vm.rolePrivileges = response.data;
                })
                .finally(function() {
                    vm.isPrivilegesLoading = false;
                });
        }

        function doRoleItemAction(action, record) {
            if (action) {
                switch (action.id) {
                    case 'delete':
                    case 'activate':
                        vm.model.methods.activateBulk(record, vm.model, action.id, undefined)
                            .then(function() {
                                if(!isTabDataInitialized && action.id === 'activate') {
                                    initializeTabData(true);
                                }
                            });
                        break;
                }
            }
        }

        function managePrivileges(ev) {
            $mdDialog.show({
            controller         : 'managePrivilegesController',
            controllerAs       : 'vm',
            templateUrl        : 'app/main/roles/details/tabs/privileges/dialogs/manage-privileges.html',
            parent             : angular.element($document.body),
            targetEvent        : ev,
            clickOutsideToClose: false,
            escapeToClose      : false,
            locals             : {
                model: angular.copy(vm.privilegesModel),
                assignedPrivileges : vm.rolePrivileges,
                roleId: roleId,
                event: ev
            }
            }).then(function(saved) {
                if (saved) {
                    refreshRecord(false);
                }
            });
        }

        function initializeTabData(isLogRequired) {
            if(vm.role.Status !== 0 && SecurityFactory.isAuthorized({accessPrivileges: CONSTANTS.PRIVILEGES.ROLES.DETAIL.PRIVILEGES_LIST})) {
                isTabDataInitialized = true;
                refreshPrivileges(vm.privilegesModel.isDirty, isLogRequired);
            }
        }

    }
})();
(function() {
	'use strict';

angular
	.module('app.main.plugins-consolidation')
	.controller('pluginsListController', pluginsListController);

/* @ngInject */
function pluginsListController(api, settingsFactory, $mdDialog, $document) {
	/* jshint validthis: true */
	var vm = this;

	//Data
	vm.model = api.plugin.plugins;
	settingsFactory.applyPersistedListViewLayout(vm.model);

	vm.plugins = [];
	vm.filteredPlugins = [];
	vm.isLoading = false;


	//Methods
	vm.refreshItems = refreshItems;
	vm.doItemAction = doItemAction;
	vm.addRecord = addRecord;

	activate();

	////////////////

	function activate() {
		refreshItems(vm.model.isDirty, true);
	}

	function refreshItems(forceFetch, isLogRequired) {
		vm.isLoading = true;
		var generalProperties = {
			forceFetch: forceFetch,
			isLogRequired: isLogRequired
		}

		vm.model.methods.getList(generalProperties)
			.then(function (response) {
				vm.plugins = response.data;
			})
			.finally(function () {
				vm.isLoading = false;
			});
	}

	function doItemAction(action, record) {
		if (action && record) {
			switch (action.id) {
				case 'edit':
					editRecord(record, null);
					break;
			}
		}
	}

	function addRecord(ev) {
		$mdDialog.show({
			controller         : 'uploadPluginController',
			controllerAs       : 'vm',
			templateUrl        : 'app/main/plugins-consolidation/dialogs/upload-plugin/upload-plugin.html',
			parent             : angular.element($document.body),
			targetEvent        : ev,
			clickOutsideToClose: false,
			locals             : {
				model: vm.model,
				record: null,
				isNew: true,
				event: ev
			}
		}).then(function(saved) {
			if (saved) {
				refreshItems(true, false);
			}
		});
	}

	function editRecord(record, ev) {
		$mdDialog.show({
			controller         : 'uploadPluginController',
			controllerAs       : 'vm',
			templateUrl        : 'app/main/plugins-consolidation/dialogs/upload-plugin/upload-plugin.html',
			parent             : angular.element($document.body),
			targetEvent        : ev,
			clickOutsideToClose: false,
			locals             : {
				model: vm.model,
				record: angular.copy(record),
				isNew: false,
				event: ev
			}
		}).then(function(saved) {
			if (saved) {
				refreshItems(true, false);
			}
		});
	}

}
})();
(function () {

    'use strict';

    angular
        .module('app.main.order-plugins', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider) {
        $translatePartialLoaderProvider.addPart('app/main/plugins/order-plugins');
    }
})();
(function() {
    'use strict';

    angular
        .module('app.main.order-plugins')
        .run(runBlock);

    /* @ngInject */
    function runBlock(api, SecurityFactory, CONSTANTS, errorDialog) {

        if(angular.isUndefined(api.plugins)) {
            api.plugins = {};
        }
        api.plugins.orderPlugins = {
            fields: [
                { field: 'Id', type: 'int', displayLabel: 'ORDER_PLUGINS.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number', isRequired: false, maxLen: -1 },
                { field: 'PluginSource', type: 'text', displayLabel: 'ORDER_PLUGINS.FIELDS.PLUGIN_SOURCE', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: false, maxLen: -1 },
                { field: 'CreatedDate', type: 'text', displayLabel: 'ORDER_PLUGINS.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date', isRequired: false, maxLen: -1 },
                { field: 'UpdatedDate', type: 'text', displayLabel: 'ORDER_PLUGINS.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date', isRequired: false, maxLen: -1 },

            ],
            title: 'ORDER_PLUGINS.FIELDS.NAV',
            icon: 'icon-cube-outline',
            idField: 'Id',
            lookupDisplayField: 'PluginSource',
            methods: {
                getList: getPlugins,
            }
        };

        function getPlugins(generalProperties) {
            if(SecurityFactory.isAuthorized({accessPrivileges: CONSTANTS.PRIVILEGES.VETTING_LIST.GET_ORDER_PLUGINS})) {
                return api.webGet(api.baseUrl + '/orderPlugins', undefined, true, generalProperties.forceFetch);
            } else {
                var privilege = {
                    id: 369,
                    description: 'OrderPlugins - Get List'
                };
                errorDialog.show('ERRORS.NO_PRIVILEGES', undefined, privilege);
            }
        }
    }
})();
(function () {

    'use strict';

    angular
        .module('app.main.consolidation-plugins', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider) {
        $translatePartialLoaderProvider.addPart('app/main/plugins/consolidation-plugins');
    }
})();
(function() {
    'use strict';

    angular
        .module('app.main.consolidation-plugins')
        .run(runBlock);

    /* @ngInject */
    function runBlock(api, SecurityFactory, CONSTANTS, errorDialog) {

        if(angular.isUndefined(api.plugins)) {
            api.plugins = {};
        }
        api.plugins.consolidationPlugins = {
            fields: [
                { field: 'Id', type: 'int', displayLabel: 'CONSOLIDATION_PLUGINS.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number', isRequired: false, maxLen: -1 },
                { field: 'PluginSource', type: 'text', displayLabel: 'CONSOLIDATION_PLUGINS.FIELDS.PLUGIN_SOURCE', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: false, maxLen: -1 },
                { field: 'CreatedDate', type: 'text', displayLabel: 'CONSOLIDATION_PLUGINS.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date', isRequired: false, maxLen: -1 },
                { field: 'UpdatedDate', type: 'text', displayLabel: 'CONSOLIDATION_PLUGINS.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date', isRequired: false, maxLen: -1 },

            ],
            title: 'CONSOLIDATION_PLUGINS.FIELDS.NAV',
            icon: 'icon-cube-outline',
            idField: 'Id',
            lookupDisplayField: 'PluginSource',
            methods: {
                getList: getPlugins,
            }
        };

        function getPlugins(generalProperties) {
            if(SecurityFactory.isAuthorized({accessPrivileges: CONSTANTS.PRIVILEGES.VETTING_LIST.GET_CONSOLIDATION_PLUGINS})) {
                return api.webGet(api.baseUrl + '/consolidationPlugins', undefined, true, generalProperties.forceFetch);
            } else {
                var privilege = {
                    id: 337,
                    description: 'Order Consolidation - Get Plugin List'
                };
                errorDialog.show('ERRORS.NO_PRIVILEGES', undefined, privilege);
            }
        }
    }
})();
(function() {
    'use strict';

    angular
    .module('app.main.organizations', [
        'app.main.organizations.sales-data'
    ])
    .config(config);

  /* @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {

        $stateProvider.state('app.organizations', {
            url    : '/organizations',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/organizations/list/organizations-list.html',
                    controller : 'organizationsListController as vm'
                }
            },
            data: {
                displayName: 'ORGANIZATIONS.NAV'
            },
            // accessPrivileges: ['GetOrganizationList']
            // accessPrivileges: ['nav_organizations']
            accessInfo: {
                accessPrivileges: ['nav_organizations']
            },
            visibleForLinePlan: true
        });

        $stateProvider.state('app.organizations.details', {
            url	 : '/:id',
            views: {
                'content@app': {
                    templateUrl: 'app/main/organizations/details/organization-details.html',
                    controller : 'organizationDetailsController as vm'
                }
            },
            data: {
                displayName: 'ORGANIZATIONS.TABS.ORGANIZATION',
                parentState: 'app.organizations'
            },
            resolve: {
            },
            // accessPrivileges: ['GetOrganizationDetails']
            accessInfo: {
                accessPrivileges: ['GetOrganizationDetails']
            },
            visibleForLinePlan: true
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/organizations');

        // Navigation
        msNavigationServiceProvider.saveItem('main.organizations', {
            title      : 'Organizations',
            icon       : 'icon-account',
            state      : 'app.organizations',
            translate  : 'ORGANIZATIONS.NAV',
            weight     : 1,
            // accessPrivileges: ['GetOrganizationList']
            // accessPrivileges: ['nav_organizations'],
            accessInfo: {
                accessPrivileges: ['nav_organizations']
            },
            visibleForLinePlan: true
        });
    }

})();
(function() {
    'use strict';

  angular
    .module('app.main.organizations')
    .controller('organizationsListController', organizationsListController);

  /* @ngInject */
  function organizationsListController(api, $state, $document, settingsFactory) {
    /* jshint validthis: true */
    var vm = this;

    vm.model = api.organizations.organizations;
    settingsFactory.applyPersistedListViewLayout(vm.model);

    vm.organizations = [];
    vm.filteredOrganizations = [];
    vm.isLoading = false;


    vm.refreshItems = refreshItems;
    vm.doItemAction = doItemAction;
    vm.viewItem = viewItem;
    vm.addRecord = addRecord;

    activate();

    ////////////////

    function activate() {
      refreshItems(vm.model.isDirty, true);
    }

    function refreshItems(forceFetch, isLogRequired) {
      vm.isLoading = true;
      var generalProperties = {
        forceFetch: forceFetch,
        isLogRequired: isLogRequired
      }

      vm.model.methods.getList(generalProperties)
      .then(function (response) {
        vm.organizations = response.data;
      })
      .finally(function () {
        vm.isLoading = false;
      });
    }

    //Item Action button pressed event
    function doItemAction(action, record) {
      if (action && record) {
        switch (action.id) {
          case 'view':
            viewItem(record);
            break;
          case 'edit':
            vm.model.methods.getDetails(true, record[vm.model.idField])
              .then(function (response) {
                editItem(response.data, null);
              })
            break;
        }
      }
    }

    function viewItem(record) {
      var id = record[vm.model.idField];
      var stateParams = {id: id};
      $state.go('app.organizations.details', stateParams);
    }

    function addRecord(ev) {
      var existingRecordsForUniqueValue = angular.copy(vm.organizations);
      api.showCreateRecordDialog(angular.element($document.body), ev, vm.model, undefined, undefined, undefined, undefined, undefined, existingRecordsForUniqueValue)
      .then(function(saved) {
        if (saved) {
          refreshItems(true, false);
        }
      });
    }

    function editItem(record, ev) {
      var existingRecordsForUniqueValue = angular.copy(vm.organizations);
      for (var i = 0; i < existingRecordsForUniqueValue.length; i++) {
        if(existingRecordsForUniqueValue[i].Id === record.Id) {
          existingRecordsForUniqueValue.splice(i, 1);
        }
      }
      api.showEditRecordDialog(angular.element($document.body), ev, vm.model, record, undefined, undefined, undefined, undefined, existingRecordsForUniqueValue)
      .then(function(saved) {
        if (saved) {
          refreshItems(true, false);
        }
      });
    }

  }
})();
(function() {
    'use strict';

    angular
        .module('app.main.organizations')
        .controller('organizationDetailsController', organizationDetailsController);

    /* @ngInject */
    function organizationDetailsController(api, $state, $rootScope, $stateParams, settingsFactory, $document, dataImporter) {
       /* jshint validthis: true */
        var vm = this;


        // Data
        var organizationId = $stateParams.id;
        vm.model = api.organizations.organizations;
        vm.organization = {};
        vm.isLoading = false;

        vm.salesDataModel = api.organizations.salesData;
        settingsFactory.applyPersistedListViewLayout(vm.salesDataModel);

        vm.salesData = [];
        vm.filteredSalesData = [];
        vm.isSalesDataLoading = false;

        vm.doSalesDataItemAction = doSalesDataItemAction;
        vm.doSalesDataListAction = doSalesDataListAction;
        vm.addSalesData = addSalesData;

        // Methods
        vm.refreshRecord = refreshRecord;
        vm.refreshSalesData = refreshSalesData;
        vm.editItem = editItem;


        activate();

        ////////////////

        function activate() {
          refreshRecord(true);
        }

        function refreshRecord(isLogRequired) {
          vm.isLoading = true;

          vm.model.methods.getDetails(isLogRequired, organizationId)
            .then(function (response) {
              vm.organization = response.data;
              vm.title = angular.copy(vm.organization[vm.model.lookupDisplayField]);

              //Update Breadcrumb
              $state.current.data.displayName = vm.title;
              $rootScope.$broadcast('breadcrumb-updated');
              refreshSalesData(true);
            })
            .finally(function () {
              vm.isLoading = false;
            });
        }

        // opens the same edit dialog as the organizations list view, so that the unique name validation is applied here as well
        function editItem(ev, record) {
          vm.model.methods.getList({forceFetch: false, isLogRequired: false})
            .then(function (response) {
              var organizations = response.data || [];
              var existingRecordsForUniqueValue = [];
              for (var i = 0; i < organizations.length; i++) {
                if (organizations[i].Id !== record.Id) {
                  existingRecordsForUniqueValue.push(organizations[i]);
                }
              }

              return api.showEditRecordDialog(angular.element($document.body), ev, vm.model, record, undefined, undefined, undefined, undefined, existingRecordsForUniqueValue);
            })
            .then(function (saved) {
              if (saved) {
                refreshRecord(false);
              }
            });
        }

        function refreshSalesData(isLogRequired) {
          vm.isSalesDataLoading = true;

          vm.salesDataModel.methods.getList(isLogRequired, vm.salesDataModel, organizationId)
            .then(function (response) {
              vm.salesData = response.data;
            })
            .finally(function () {
              vm.isSalesDataLoading = false;
            });
        }

        function doSalesDataItemAction(action, record) {
          if (action && record) {
            switch (action.id) {
              case 'delete':
                  vm.salesDataModel.methods.deleteBulk(record, action.id, organizationId);
                  refreshSalesData(true);
                  break;
            }
          }
        }

        function doSalesDataListAction(action, records) {
            if (action) {
                switch (action.id) {
                    case 'delete':
                        vm.salesDataModel.methods.deleteBulk(records, action.id, organizationId);
                        refreshSalesData(true);
                        break;
                    case 'import':
                        dataImporter.importExcel(vm.salesDataModel, true).then(function (result) {
                          vm.salesDataModel.methods.createBulk(vm.salesDataModel, result.data, organizationId);
                        });
                        break;
                }
            }
        }

        function addSalesData(ev) {
          api.showCreateRecordDialog(angular.element($document.body), ev, vm.salesDataModel, organizationId)
          .then(function (saved) {
              if (saved) {
                refreshSalesData(true);
              }
          });
        }

    }
})();
(function () {
  'use strict';

  angular
    .module('app.main.notifications')
    .controller('notificationsListController', notificationsListController);

  /* @ngInject */
  function notificationsListController(api, $state, settingsFactory) {
    /* jshint validthis: true */
    var vm = this;

    vm.model = api.notifications.notifications;
    settingsFactory.applyPersistedListViewLayout(vm.model);

    vm.notifications = [];
    vm.filteredNotifications = [];
    vm.isLoading = false;


    vm.refreshItems = refreshItems;
    vm.doItemAction = doItemAction;
    vm.viewItem = viewItem;

    activate();

    ////////////////

    function activate() {
      refreshItems(vm.model.isDirty, true);
    }

    function refreshItems(forceFetch, isLogRequired) {
      vm.isLoading = true;
      var generalProperties = {
          forceFetch: forceFetch,
          isLogRequired: isLogRequired
      }

      vm.model.methods.getList(generalProperties)
        .then(function (response) {
          vm.notifications = response.data;
        })
        .finally(function () {
          vm.isLoading = false;
        });
    }

    //Item Action button pressed event
    function doItemAction(action, record) {
      if (action && record) {
        switch (action.id) {
          case 'view':
            viewItem(record);
            break;
        }
      }
    }

    function viewItem(record) {
      var id = record[vm.model.idField];
      var stateParams = { id: id };
      $state.go('app.notifications.details', stateParams);
    }


  }
})();
(function () {
  'use strict';

  angular
    .module('app.main.notifications')
    .controller('notificationsDetailsController', notificationsDetailsController);

  /* @ngInject */
  function notificationsDetailsController(api, $state, $rootScope, $stateParams) {
    /* jshint validthis: true */
    var vm = this;

    // Data
    var notificationId = $stateParams.id;

    vm.model = api.notifications.notifications;
    vm.notification = {};
    vm.isLoading = false;


    // Methods
    vm.refreshRecord = refreshRecord;

    activate();

    ////////////////

    function activate() {
      refreshRecord(true);
    }

    function refreshRecord(isLogRequired) {
      vm.isLoading = true;

      vm.model.methods.getDetails(isLogRequired, notificationId)
        .then(function (response) {
          vm.notification = response.data;
          vm.title = angular.copy(vm.notification.Id) + ' : ' + angular.copy(vm.notification.Title);

          //Update Breadcrumb
          $state.current.data.displayName = vm.title;
          $rootScope.$broadcast('breadcrumb-updated');
        })
        .finally(function () {
          vm.isLoading = false;
        });
    }

  }
})();
(function() {
	'use strict';

	angular
        .module('app.main.jobs', [])
        .config(config);

    /* @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
        // State
        $stateProvider.state('app.jobs', {
            url    : '/jobs',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/jobs/list/jobs-list.html',
                    controller : 'jobsListController as vm'
                }
            },
            resolve: {

            },
            data: {
                displayName: 'JOBS.NAV'
            },
            //only users with following accessPrivileges in their role access list can access this route
            // accessPrivileges: ['GetJsonBackGroundJobList']
            accessInfo: {
                accessPrivileges: ['nav_jobs']
            },
            visibleForLinePlan: true
        });

        $stateProvider.state('app.jobs.details', {
            url	 : '/:id',
            params: {
                tab : 'details'
            },
            views: {
                'content@app': {
                    templateUrl: 'app/main/jobs/details/job-details.html',
                    controller : 'jobDetailsController as vm'
                }
            },
            data: {
                parentState: 'app.jobs',
                displayName: 'JOBS.TABS.JOB'
            },
            //only users with following accessPrivileges in their role access list can access this route
            // accessPrivileges: ['GetJsonBackGroundJobDetails']
            // accessPrivileges: ['nav_jobs']
            accessInfo: {
                accessPrivileges: ['GetJsonBackGroundJobDetails']
            },
            visibleForLinePlan: true
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/jobs');


        msNavigationServiceProvider.saveItem('configuration.jobs', {
            title      : 'Jobs',
            icon       : 'icon-clock-fast',
            state      : 'app.jobs',
            translate  : 'NAV.JOBS',
            weight     : 15,
            // accessPrivileges: ['GetJsonBackGroundJobList']
            // accessPrivileges: ['nav_jobs'],
            accessInfo: {
                accessPrivileges: ['nav_jobs']
            },
            visibleForLinePlan: true
        });
    }
})();
(function() {
		'use strict';

	angular
		.module('app.main.jobs')
		.controller('jobsListController', jobsListController);

	/* @ngInject */
	function jobsListController(api, $state, settingsFactory) {
		/* jshint validthis: true */
		var vm = this;

		//Data
		vm.model = api.jobs;
		settingsFactory.applyPersistedListViewLayout(vm.model);

		vm.jobs = [];
		vm.filteredJobs = [];
		vm.isLoading = false;


		//Methods
		vm.refreshItems = refreshItems;
		vm.doItemAction = doItemAction;
		vm.doListAction = doListAction;
		vm.viewItem = viewItem;

		activate();

		////////////////

		function activate() {
			refreshItems(vm.model.isDirty);
		}

		function refreshItems(forceFetch) {
			vm.isLoading = true;

			vm.model.methods.getList({ forceFetch: forceFetch })
				.then(function (response) {
					vm.jobs = response.data;
				})
				.finally(function () {
					vm.isLoading = false;
				});
		}

		function doItemAction(action, record) {
			if (action && record) {
				switch (action.id) {
					case 'view':
						viewItem(record);
						break;
				}
			}
		}

		function doListAction(action, records) {
			if (action) {
				switch (action.id) {
					case 'delete':
					case 'activate':
						break;
				}
			}
		}

		function viewItem(item) {
			var id = item[vm.model.idField],
			stateParams = { id: id };
			$state.go('app.jobs.details', stateParams);
		}

	}
})();
(function() {
	'use strict';

	angular
		.module('app.main.jobs')
		.controller('jobDetailsController', jobDetailsController);

	/* @ngInject */
	function jobDetailsController(api, $state, $stateParams, $rootScope, $mdDialog, $translate, $filter, CONSTANTS, settingsFactory, $http) {
	   /* jshint validthis: true */
		var vm = this;
		var jobId = $stateParams.id;
		var tabName = $stateParams.tab.toUpperCase();

		vm.model = api.jobs;
		vm.errorsModel = api.jobErrors;
		settingsFactory.applyPersistedListViewLayout(vm.errorsModel);

		vm.job = {};
		vm.filteredErrors = [];

		vm.isLoading = false;

		vm.refreshRecord = refreshRecord;
		vm.doErrorsItemAction = doErrorsItemAction;
		vm.viewError = viewError;
		vm.doItemAction = doItemAction;

		activate();

		////////////////

		function activate() {
			refreshRecord();
		}

		function refreshRecord(isRefreshFromTab) {
			vm.isLoading = true;

			vm.model.methods.getDetails(jobId)
				.then(function (response) {
					vm.job = response.data;
					if(!isRefreshFromTab) {
						vm.tabIndex = CONSTANTS.TABS.JOB[tabName] ? CONSTANTS.TABS.JOB[tabName] : 0;
					}
					vm.title = '';
					$translate('JOBS.TITLE').then(function (translation) {
						vm.title = translation + jobId;
						//Update Breadcrumb
						$state.current.data.displayName = vm.title;
						$rootScope.$broadcast('breadcrumb-updated');
					});
				})
				.finally(function () {
					vm.isLoading = false;
				});
		}

		function doItemAction(action, item) {
			if (action && item) {
				switch (action.id) {
					case 'downloadJobRequest':
						var URL = item.JobFileUrl;
						$http.get(URL, {
							responseType: 'arraybuffer',
							headers: {}
						})
						.then(function(response) {
							var blob = new Blob([response.data], { type: 'application/json' });
							var downloadLink = document.createElement('a');
							downloadLink.href = window.URL.createObjectURL(blob);
							downloadLink.download = item.Id + '.json';
							document.body.appendChild(downloadLink);
							downloadLink.click();
							document.body.removeChild(downloadLink);
						});
						break;
				}
			}
		}

		function doErrorsItemAction(action, item) {
			if (action && item) {
				switch (action.id) {
					case 'view':
						viewError(item);
						break;
				}
			}
		}

		function viewError(item) {
			$mdDialog.show(
				$mdDialog.confirm()
						.title($filter('translate')('JOBS.ERROR_MESSAGE'))
						.textContent(item.ErrorMessage)
						.ariaLabel($filter('translate')('JOBS.ERROR'))
						.ok('Ok')
			);
		}
	}
})();
(function() {
	'use strict';

	angular
        .module('app.main.hangfire-dashboard', ['ngSanitize'])
        .config(config);

    /* @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
        // State
        $stateProvider.state('app.hangfire_dashboard', {
            url    : '/hangfire-dashboard',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/hangfire-dashboard/list/hangfire-dashboard-list.html',
                    controller : 'hangfireDashboardListController as vm'
                }
            },
            resolve: {

            },
            data: {
                displayName: 'HANGFIRE DASHBOARD'
            },
            //only users with following accessPrivileges in their role access list can access this route
            // accessPrivileges: ['nav_hangfire_dashboard']
            accessInfo: {
                accessPrivileges: ['nav_hangfire_dashboard']
            },
            visibleForLinePlan: true
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/hangfire-dashboard');


        msNavigationServiceProvider.saveItem('configuration.hangfire_dashboard', {
            title      : 'Hangfire Dashboard',
            icon       : 'icon-clock-fast',
            state      : 'app.hangfire_dashboard',
            translate  : 'HANGFIRE_DASHBOARD.NAV',
            weight     : 18,
            // accessPrivileges: ['nav_hangfire_dashboard'],
            accessInfo: {
                accessPrivileges: ['nav_hangfire_dashboard']
            },
            visibleForLinePlan: true
        });
    }
})();
(function() {
  'use strict';

angular
  .module('app.main.hangfire-dashboard')
  .controller('hangfireDashboardListController', hangfireDashboardListController);

/* @ngInject */
function hangfireDashboardListController(api, $auth, settingsFactory) {
  /* jshint validthis: true */
  var vm = this;

  //Data
  vm.model = api.hangfireDashboard;
  settingsFactory.applyPersistedListViewLayout(vm.model);

  //Methods
  activate();

  ////////////////

  function activate() {
    document.querySelector('#hangfire-frame-id').src = api.baseUrl.substring(0,api.baseUrl.length-4) + '/hangfire/';
  }
}
})();
(function ()
{
    'use strict';

    angular
        .module('app.main.error404', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        $stateProvider.state('app.pages_error404', {
            url      : '/404',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/error-pages/404/error-404.html',
                    controller : 'error404Controller as vm'
                }
            },
            resolve  : {
            },
            data: {
                displayName: 'ERROR404.TITLE'
            },
            bodyClass: 'landing',
        });

        $translatePartialLoaderProvider.addPart('app/main/error-pages/404');
    }

})();
(function() {
    'use strict';

	angular
		.module('app.main.error404')
		.controller('error404Controller', error404Controller);

	/* @ngInject */
	function error404Controller($stateParams) {
		/* jshint validthis: true */
		var vm = this;

    }

})();

(function () {
	'use strict';

	angular
		.module('app.main.data-containers', [])
		.config(config);

	/* @ngInject */
	function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {

		$stateProvider.state('app.data_containers', {
			url: '/data-containers',
			views: {
				'content@app': {
					templateUrl: 'app/main/data-containers/list/data-containers-list.html',
					controller: 'dataContainersListController as vm'
				}
			},
			data: {
				displayName: 'DATA_CONTAINERS.NAV'
			},
			// accessPrivileges: ['nav_data_containers']
			// accessPrivileges: ['GetAllDataContainers']
			accessInfo: {
				accessPrivileges: ['nav_data_containers']
			},
			visibleForLinePlan: true
		});

		$stateProvider.state('app.data_containers.details', {
			url	 : '/:id',
			views: {
					'content@app': {
							templateUrl: 'app/main/data-containers/details/data-containers-details.html',
							controller : 'dataContainerDetailsController as vm'
					}
			},
			data: {
				parentState: 'app.data_containers',
				displayName: 'DATA_CONTAINERS.TABS.DATA_CONTAINER'
			},
			resolve: {
				dataContainerModel: function (api, utility) {
						var model = angular.copy(api.dataContainers.dataContainers);
						var containerNameField = utility.filterObject(model.fields, { field: 'ContainerName' }, true)[0];
						if(angular.isDefined(containerNameField)) {
							containerNameField.visible = false;
						}
						var containerValueField = utility.filterObject(model.fields, { field: 'ContainerValue' }, true)[0];
						if(angular.isDefined(containerValueField)) {
							containerValueField.visible = false;
						}
						var nameField = utility.filterObject(model.fields, { field: 'Name' }, true)[0];
						if(angular.isDefined(nameField)) {
							nameField.visible = true;
						}
						var valueField = utility.filterObject(model.fields, { field: 'Value' }, true)[0];
						if(angular.isDefined(valueField)) {
							valueField.visible = true;
						}
						return model;
				}
			},
			// accessPrivileges: ['GetDataContainer']
			accessInfo: {
					accessPrivileges: ['GetDataContainer']
			},
			visibleForLinePlan: true
		});

		// Translation
		$translatePartialLoaderProvider.addPart('app/main/data-containers');

		// Navigation
		msNavigationServiceProvider.saveItem('main.data_containers', {
			title: 'Data Containers',
			icon: 'icon-library-books',
			state: 'app.data_containers',
			translation: 'DATA_CONTAINERS.NAV',
			weight: 14,
			// accessPrivileges: ['nav_data_containers']
			// accessPrivileges: ['GetAllDataContainers'],
			accessInfo: {
				accessPrivileges: ['nav_data_containers']
			},
			visibleForLinePlan: true
		});
	}

})();
(function () {
	'use strict';

	angular
		.module('app.main.data-containers')
		.controller('dataContainersListController', dataContainersListController);

	/* @ngInject */
	function dataContainersListController(api, settingsFactory, dataImporter, $state, $document, utility) {
		/* jshint validthis: true */
		var vm = this;

		vm.model = api.dataContainers.dataContainers;
		settingsFactory.applyPersistedListViewLayout(vm.model);

		vm.dataContainers = [];
		vm.filteredDataContainers = [];
		vm.isLoading = false;

		vm.refreshItems = refreshItems;
		vm.doListAction = doListAction;
		vm.doItemAction = doItemAction;
		vm.viewItem = viewItem;

		activate();

		////////////////

		function activate() {
			refreshItems(vm.model.isDirty, true);
		}

		function refreshItems(forceFetch, isLogRequired) {
			var generalProperties = {
				forceFetch: forceFetch,
				isLogRequired: isLogRequired
			}
			vm.isLoading = true;

			return vm.model.methods.getList(generalProperties, vm.model)
				.then(function (response) {
					var records = response.data;
					vm.dataContainers = [];
					// we will show only catalog related data containers in T1 UI
					angular.forEach(records, function(record) {
						if(angular.isDefined(record.CatalogCode) && record.CatalogCode !== null) {
							record.CatalogName = record.CatalogCode;
							vm.dataContainers.push(record);
						}
					});
				})
				.finally(function () {
					vm.isLoading = false;
				});
		}

		//Item Action button pressed event
		function doItemAction(action, record) {
			if (action && record) {
				switch (action.id) {
					case 'edit':
						vm.model.methods.getDetails(true, record[vm.model.idField])
							.then(function (response) {
								editRecord(response.data, null);
							})
						break;
					case 'view':
						viewItem(record);
						break;
				}
			}
		}

		//List Action button pressed event
		function doListAction(action) {
			if (action) {
				switch (action.id) {
					case 'import':
						var modelCopy = angular.copy(vm.model);
						var containerValueField = utility.filterObject(modelCopy.fields, { field: 'ContainerValue' }, true)[0];
						if(angular.isDefined(containerValueField)) {
							containerValueField.creatable = true;
						}
						var valueField = utility.filterObject(modelCopy.fields, { field: 'Value' }, true)[0];
						if(angular.isDefined(valueField)) {
							valueField.creatable = false;
						}
						dataImporter.importExcel(modelCopy, true).then(function (result) {
							vm.model.methods.createBulk(vm.model, result.data);
						})
						break;
				}
			}
		}

		function editRecord(record, ev) {
			vm.model.methods.getDetails(true, record.Id)
			.then(function (response) {
				var dataContainer = response.data;
				api.showEditRecordDialog(angular.element($document.body), ev, vm.model, dataContainer)
				.then(function(saved) {
						if (saved) {
								refreshItems(true, false);
						}
				});
			});
		}

		function viewItem(record) {
			var stateParams = { id: record[vm.model.idField]};
			$state.go('app.data_containers.details', stateParams);
		}

	}
})();
(function () {
	'use strict';

	angular
		.module('app.main.data-containers')
		.controller('dataContainerDetailsController', dataContainerDetailsController);

	/* @ngInject */
	function dataContainerDetailsController(api, $state, $stateParams, $rootScope, dataContainerModel, $document) {
		/* jshint validthis: true */
		var vm = this;

		// Data
		var containerId = $stateParams.id;

		vm.model = dataContainerModel;

		vm.dataContainer = {};

		vm.isLoading = false;

		// Methods
		vm.refreshRecord = refreshRecord;
		vm.editItem = editItem;

		activate();

		////////////////

		function activate() {
			refreshRecord(true);
		}

		function refreshRecord(isLogRequired) {
			vm.isLoading = true;
			vm.model.methods.getDetails(isLogRequired, containerId)
			.then(function (response) {
				vm.dataContainer = response.data;
				vm.title = vm.dataContainer['Name'];

				//Update Breadcrumb
				$state.current.data.displayName = vm.title;
				$rootScope.$broadcast('breadcrumb-updated');
			})
			.finally(function () {
				vm.isLoading = false;
			});
		}

		function editItem(record, ev) {
			api.showEditRecordDialog(angular.element($document.body), ev, vm.model, record)
			.then(function(saved) {
					if (saved) {
							refreshItems(true, false);
					}
			});
		}

	}
})();
(function() {
    'use strict';

    angular
        .module('app.main.customers.locations')
        .run(runBlock);

    /* @ngInject */
    function runBlock(api, activityLogger, $state, crud) {

        if(angular.isUndefined(api.customers)) {
            api.customers = {};
        }
        api.customers.locations = {
            modelPath: 'customers.locations',
            fields: [
                { field: 'Id', type: 'int', displayLabel: 'LOCATIONS.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'BuyerAccountId', type: 'text', displayLabel: 'LOCATIONS.FIELDS.BUYER_ACCOUNT_ID', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Name', type: 'text', displayLabel: 'LOCATIONS.FIELDS.NAME', visible: true, creatable: true, editable: true, inputType: 'text',
                    validation: {isRequired: true, maxLen: 50, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Code', type: 'text', displayLabel: 'LOCATIONS.FIELDS.CODE', visible: true, creatable: true, editable: true, inputType: 'text',
                    validation: {isRequired: true, maxLen: 50, minLen: 1, pattern: '[A-Za-z0-9_-]+', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: 'VALIDATIONS.INVALID_CHARACTERS'}} },
                { field: 'Address', type: 'text', displayLabel: 'LOCATIONS.FIELDS.ADDRESS', visible: true, creatable: true, editable: true, inputType: 'textArea',
                    validation: {isRequired: false, maxLen: 100, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'City', type: 'text', displayLabel: 'LOCATIONS.FIELDS.CITY', visible: true, creatable: true, editable: true, inputType: 'text',
                    validation: {isRequired: false, maxLen: 25, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'State', type: 'text', displayLabel: 'LOCATIONS.FIELDS.STATE', visible: true, creatable: true, editable: true, inputType: 'text',
                    validation: {isRequired: false, maxLen: 25, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Zip', type: 'text', displayLabel: 'LOCATIONS.FIELDS.ZIP', visible: true, creatable: true, editable: true, inputType: 'text',
                    validation: {isRequired: false, maxLen: 7, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CountryCode', type: 'text', displayLabel: 'LOCATIONS.FIELDS.COUNTRY', visible: false, creatable: true, editable: true, inputType: 'lookup', lookupSource: 'lists.countries',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CountryCode', type: 'text', displayLabel: 'LOCATIONS.FIELDS.COUNTRY_CODE', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CountryName', type: 'text', displayLabel: 'LOCATIONS.FIELDS.COUNTRY', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'LocationReference', type: 'text', displayLabel: 'LOCATIONS.FIELDS.LOCATION_REFERENCE', visible: true, creatable: true, editable: true, inputType: 'text',
                    validation: {isRequired: false, maxLen: 200, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Phone', type: 'text', displayLabel: 'LOCATIONS.FIELDS.PHONE', visible: true, creatable: true, editable: true, inputType: 'text',
                    validation: {isRequired: false, maxLen: 15, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreateDate', type: 'text', displayLabel: 'LOCATIONS.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdateDate', type: 'text', displayLabel: 'LOCATIONS.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedBy', type: 'text', displayLabel: 'LOCATIONS.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedBy', type: 'text', displayLabel: 'LOCATIONS.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'SellerCustomerId', type: 'text', displayLabel: 'LOCATIONS.FIELDS.SELLER_CUSTOMER_ID', visible: false, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Status', type: 'text', displayLabel: 'LOCATIONS.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
            ],

            idField: 'Id',
            lookupDisplayField: 'Name',
            isDirty: false,
            methods: {
                getList         :   getLocations,
                getDetails      :   getLocation,
                activateBulk    :   activateLocations,
                create          :   createLocation,
                update          :   updateLocation
            },
            views: {
                mainList: {
                    columns             : [ 'Name', 'Code', 'CountryName', 'City', 'Status', 'UpdateDate'],
                    columnFilter        : {},
                    toggleFilterProps   : { toggleStatus:false, filterProp:'Status', trueVal:1, trueValTooltipMessage: 'ACTIONS.TOGGLE_ACTIVE', falseVal:'', falseValTooltipMessage:"ACTIONS.TOGGLE_ALL"},
                    topIndex            : 0,
                    showFilterRow       : false,
                    sortColumn          : {'UpdateDate': false},
                    itemActions         : [
                                            { id: 'view', label: 'ACTIONS.VIEW', icon: 'icon-magnify', privilege: 'GetLocationDetails', disabled: '!itm.Status', visible: true },
                                            { id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UpdateLocation', disabled: '!itm.Status', visible: true },
                                            { id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateCustomerLocationStatusBulk', disabled: false, visible: 'itm.Status',
                                                requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                                            { id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateCustomerLocationStatusBulk', disabled: false, visible: '!itm.Status',
                                                requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
                                        ],
                    listActions         : [
                                            { id: 'delete', label: 'ACTIONS.DELETE_BULK', icon: 'icon-delete', privilege: 'UpdateCustomerLocationStatusBulk', disabled: '{selected: true, Status: 1}', visible: true,
                                                requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                                            { id: 'activate', label: 'ACTIONS.ACTIVATE_BULK', icon: 'icon-undo-variant', privilege: 'UpdateCustomerLocationStatusBulk', disabled: '{selected: true, Status: 0}', visible: true,
                                                requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
                                        ],
                    fabAction           : {id: 'add', label: 'ACTIONS.ADD', icon: 'icon-plus', privilege: 'CreateLocation', visible: true}
                },
                mainDetails: {
                    selectedTabIndex    : 0,
                    itemActions         : [
                                            { id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateCustomerLocationStatusBulk', disabled: '{selected: true, Status: 1}',
                                                visible: true, requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                                            { id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateCustomerLocationStatusBulk', disabled: '{selected: true, Status: 0}',
                                                visible: true, requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
                                            ],
                    fabAction           : {id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UpdateLocation', visible: true}
                },
                privileges: {
                    list    : 'GetLocationList',
                    details : 'GetLocationDetails'
                }
            }

        };

        //lookup doesnt support for this module
        function getLocations(generalProperties, customerId, sellerId) {
            var promise;
            var customerId = angular.isUndefined(customerId) && angular.isDefined(generalProperties.idMap.customerId) ? generalProperties.idMap.customerId : customerId;;
            var sellerId = angular.isUndefined(sellerId) && angular.isDefined(generalProperties.idMap.sellerId) ? generalProperties.idMap.sellerId : sellerId;

            if(angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
                var state = {};
                state.name = $state.current.name;
                state.params = $state.params;
                var isBulk = true;
                var logData = activityLogger.createLogData(null, state, 'customers.locations', 'VIEW', isBulk, new Date(), null, null);
                promise = api.webGet(api.baseUrl + '/sellers/' + sellerId + '/customers/' + customerId + '/locations',
                generalProperties.config || {}, true, generalProperties.forceFetch,
                generalProperties.supportIncrementalResult || true,
                generalProperties.modelIdField,
                generalProperties.isMajor || false,
                generalProperties.model || api.customers.locations);
                promise = activityLogger.log(logData, promise);
            }
            else {
                promise = api.webGet(api.baseUrl + '/sellers/' + sellerId + '/customers/' + customerId + '/locations',
                generalProperties.config || {}, true, generalProperties.forceFetch,
                generalProperties.supportIncrementalResult || true,
                generalProperties.modelIdField,
                generalProperties.isMajor || false,
                generalProperties.model || api.customers.locations);
            }

            promise.then(function() {
                if (api.customers.locations.isDirty) {
                    //Invalidate lookupData
                    api.customers.locations.lookupData = undefined;
                    api.customers.locations.isDirty = false;
                }
            });
            return promise;
		}

		function getLocation(isLogRequired, recordId, customerId, sellerId) {
            var promise;
            if(angular.isDefined(isLogRequired) && isLogRequired === true) {
                var state = {};
                state.name = $state.current.name;
                state.params = $state.params;
                var isBulk = false;
                var items= [];
                promise = api.webGet(api.baseUrl + '/sellers/' + sellerId + '/customers/' + customerId + '/locations/' + recordId + '?status=0');
                promise.then(function(response) {
                    items.push(response.data[api.customers.locations.lookupDisplayField]);
                }, function(response) {
                    items.push(response.data[api.customers.locations.lookupDisplayField]);
                });
                var logData = activityLogger.createLogData(items, state, 'customers.locations', 'VIEW', isBulk, new Date(), null, null);
                promise = activityLogger.log(logData, promise);
            }
            else {
                promise = api.webGet(api.baseUrl + '/sellers/' + sellerId + '/customers/' + customerId + '/locations/' + recordId + '?status=0');
            }
            return promise;
		}


		function activateLocations(records, model, actionType, parentId, sellerId) {
            var result = crud.createRequestObject(records, model, actionType);
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var isBulk = result.itemsNameList.length > 1 ? true : false;
            var logData = activityLogger.createLogData(result.itemsNameList, state, 'customers.locations', actionType.toUpperCase(), isBulk, new Date(), null, null);
			var promise = api.webPut(api.baseUrl + '/sellers/' + sellerId + '/customers/' + parentId + '/locations/status', result.requestObj);

            promise.then(function() {
                crud.onRecordStatusChange(records, model, actionType);
            });

            return activityLogger.log(logData, promise);
		}
        //get sellerId from record
		function createLocation(record, customerId) {
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var logData = activityLogger.createLogData(record[api.customers.locations.lookupDisplayField], state, 'customers.locations', 'ADD', false, new Date(), null, null);
            //sellerId is added as a default value to record in api.showCreateRecordDialog
			var promise = api.webPost(api.baseUrl + '/sellers/' + record.sellerId + '/customers/' + customerId + '/locations', record);

            promise.then(function() {
                api.customers.locations.isDirty = true;
            });
            return activityLogger.log(logData, promise);
		}

		function updateLocation(recordId, record, parentId) {
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var logData = activityLogger.createLogData(record[api.customers.locations.lookupDisplayField], state, 'customers.locations', 'EDIT', false, new Date(), null, null);
			var promise = api.webPut(api.baseUrl + '/sellers/' + parentId.sellerId + '/customers/' + parentId.customerId + '/locations/' + recordId, record);

            promise.then(function() {
                api.customers.locations.isDirty = true;
            });
            return activityLogger.log(logData, promise);
		}

    }
})();
(function() {
	'use strict';

	angular
        .module('app.main.customers', [
            'app.main.customers.catalogs',
            'app.main.customers.locations'

        ])
        .config(config);

        /* @ngInject */
        function config($stateProvider, $translatePartialLoaderProvider) {
            $stateProvider.state('app.customer_details', {
                url  : '/seller/:sellerId/customer/:id',
                params: {
                    'UseOrderType': undefined
                },
                views: {
                    'content@app': {
                        templateUrl: 'app/main/customers/details/customers-details.html',
                        controller : 'customerDetailsController as vm'
                    }
                },
                data: {
                    displayName: 'CUSTOMERS.TABS.CUSTOMER'
                },
                resolve: {
                    UseOrderType: function($localStorage, $stateParams, $q, catalogFactory, api) {
                        //if customer belong to seller of active catalog use `UseOrderType` stored in localStorage
                        if(catalogFactory.getActiveCatalog().AccountId == $stateParams.sellerId) {
                            return $q.when(catalogFactory.getUseOrderType());
                        }
                        // if customer does not belong to seller of active catalog but UseOrderType is defined
                        else if(angular.isDefined($stateParams.UseOrderType)){
                            return $q.when($stateParams.UseOrderType);
                        }
                        // if customer does not belong to seller of active catalog but UseOrderType is un-defined (user refresh page on this page)
                        else {
                            return api.accounts.sellers.methods.getDetails(false, $stateParams.sellerId)
                                .then(function(response) {
                                    return response.data.UseOrderType;
                                });
                        }
                    }
                },
                // accessPrivileges: ['GetSellerCustomerDetails']
                accessInfo: {
                    accessPrivileges: ['GetSellerCustomerDetails']
                }
            });

            // Translation
            $translatePartialLoaderProvider.addPart('app/main/customers');
        }
})();
(function() {
    'use strict';

    angular
        .module('app.main.customers')
        .controller('customerDetailsController', customerDetailsController);

    /* @ngInject */
    function customerDetailsController($document, api, $state, $stateParams, $rootScope, catalogFactory, $mdDialog, utility, settingsFactory,
        SecurityFactory, CONSTANTS, UseOrderType) {
       /* jshint validthis: true */
        var vm = this;
        var customerId = $stateParams.id;
        var activeCatalog = catalogFactory.getActiveCatalog();
        vm.sellerId = angular.isDefined($stateParams.sellerId) ? $stateParams.sellerId: activeCatalog.AccountId;
        //if entry point is seller detail get the value from state param which denote the seller's customer value for UseOrderType
        //if entry point is from catalog data (linked customer or assortment) get the value from localStorage which is UseOrderType value of active catalog's seller
        // var UseOrderType = angular.isDefined($stateParams.UseOrderType) ? $stateParams.UseOrderType : $localStorage.UseOrderType;
        vm.model = api.customers.customers;

        vm.locationsModel = api.customers.locations;
        settingsFactory.applyPersistedListViewLayout(vm.locationsModel);

        vm.catalogsModel = api.customers.catalogs;
        settingsFactory.applyPersistedListViewLayout(vm.catalogsModel);

        vm.customer = {};
        vm.locations = [];
        vm.filteredLocations = [];
        vm.catalogs = [];
        vm.filteredCatalogs = [];

        vm.isLoading = false;
        vm.isCatalogLoading = false;
        vm.isLocationLoading = false;

        var isTabDataInitialized = false;

        vm.refreshRecord = refreshRecord;
        vm.refreshCatalogs = refreshCatalogs;
        vm.refreshLocations = refreshLocations;
        vm.doCustomerItemAction = doCustomerItemAction;
        vm.editCustomer = editCustomer;
        vm.doLocationsItemAction = doLocationsItemAction;
        vm.doLocationsListAction = doLocationsListAction;
        vm.viewLocation = viewLocation;
        vm.addLocation = addLocation;
        vm.doCatalogsItemAction = doCatalogsItemAction;
        vm.doCatalogsListAction = doCatalogsListAction;
        vm.addCatalog = addCatalog;
        vm.viewCatalog = viewCatalog;

        activate();

        ////////////////

        function activate() {
            refreshRecord(true);
        }

        function refreshRecord(isLogRequired) {
            vm.isLoading = true;

            vm.model.methods.getDetails(isLogRequired, customerId, vm.sellerId)
                .then(function (response) {
                    vm.customer = response.data;
                    // use to identify if ordertype field needs to be disabled in viewCreator
                    vm.customer['UseOrderType'] = UseOrderType;
                    vm.title = angular.copy(vm.customer[vm.model.lookupDisplayField]);

                    //Update Breadcrumb
                    $state.current.data.displayName = vm.title;
                    $rootScope.$broadcast('breadcrumb-updated');

                    vm.locations = response.data.LocationsResponses;
                    initializeTabData(isLogRequired);
                })
                .finally(function () {
                    vm.isLoading = false;
                });
        }

        function refreshCatalogs(forceFetch, isLogRequired) {
            vm.isCatalogLoading = true;
            var generalProperties = {
                forceFetch: forceFetch,
                isLogRequired: isLogRequired
            }
            vm.catalogsModel.methods.getList(generalProperties, customerId, vm.sellerId).then(function(response) {
                vm.catalogs = utility.filterObject(response.data, {Status: 1});
            })
            .finally(function () {
                vm.isCatalogLoading = false;
            });
        }

        function refreshLocations(forceFetch, isLogRequired) {
            vm.isLocationLoading = true;
            var generalProperties = {
                forceFetch: forceFetch,
                isLogRequired: isLogRequired,
                config: {},
                supportIncrementalResult: true,
                modelIdField: 'Id',
                isMajor: false,
                model: vm.locationsModel
            }
            vm.locationsModel.methods.getList(generalProperties, customerId, vm.sellerId).then(function(response) {
                vm.locations = response.data;
                if (angular.isDefined(vm.tableControl) && angular.isDefined(vm.tableControl.updateData)) {
                    vm.tableControl.updateData();
                }
            })
            .finally(function () {
                vm.isLocationLoading = false;
            });
        }

        function doCustomerItemAction(action, record) {
            if (action) {
                switch (action.id) {
                    case 'delete':
                    case 'activate':
                        vm.model.methods.activateBulk(record, vm.model, action.id, vm.sellerId)
                            .then(function() {
                                if(!isTabDataInitialized && action.id === 'activate') {
                                    initializeTabData(true);
                                }
                            });
                        break;
                }
            }
        }


		function editCustomer(item, ev) {
            var lookupExtras = {};
            lookupExtras['sellers.orderTypes'] = {};
            lookupExtras['sellers.orderTypes']['id1'] = vm.sellerId;
            api.showEditRecordDialog(angular.element($document.body), ev, vm.model, item, vm.sellerId, lookupExtras)
            .then(function(saved) {
                if (saved) {
                    refreshRecord(true, false);
                }
            });
		}

        function doLocationsItemAction(action, record) {
            if (action && record) {
				switch (action.id) {
					case 'view':
						viewLocation(record);
                        break;
					case 'edit':
						editLocation(record, null);
                        break;
					case 'delete':
                    case 'activate':
                        vm.locationsModel.methods.activateBulk(record, vm.locationsModel, action.id, customerId, vm.sellerId);
                        break;
				}
			}
		}

        function doLocationsListAction(action, records) {
            if (action) {
                switch (action.id) {
                    case 'delete':
                    case 'activate':
                        vm.locationsModel.methods.activateBulk(records, vm.locationsModel, action.id, customerId, vm.sellerId);
                        break;
                }
            }
        }

        function viewLocation(record) {
            var id = record[vm.locationsModel.idField];
            var stateParams = {accountId: vm.sellerId, customerId: customerId, id: id};
            $state.go('app.locations_details', stateParams);
        }

        function addLocation(ev) {
            api.showCreateRecordDialog(angular.element($document.body), ev, vm.locationsModel, customerId, {'sellerId': vm.sellerId})
            .then(function(saved) {
                if (saved) {
                    refreshLocations(true, false);
                }
            });
		}

        function editLocation(item, ev) {
            var parentId = {};
            parentId.customerId = customerId;
            parentId.sellerId = vm.sellerId;
            api.showEditRecordDialog(angular.element($document.body), ev, vm.locationsModel, item, parentId)
            .then(function(saved) {
                if (saved) {
                    refreshLocations(true, false);
                }
            });
		}

        function doCatalogsItemAction(action, record) {
            if (action && record) {
				switch (action.id) {
					case 'view':
						viewCatalog(record);
                        break;
					case 'edit':
						editCatalog(record, null);
                        break;
					case 'delete':
                        vm.catalogsModel.methods.unlinkCatalogFromCustomer(record, vm.catalogsModel, action.id, customerId , vm.sellerId).then(function() {
                            refreshCatalogs(true, false);
                        });
                        break;
                    case 'activate':
                        vm.catalogsModel.methods.linkCatalogToCustomer(record, vm.catalogsModel, action.id, customerId , vm.sellerId).then(function() {
                            refreshCatalogs(true, false);
                        });
                        break;
				}
			}
		}

        function  doCatalogsListAction(action, records) {
            if (action) {
                switch (action.id) {
                    case 'delete':
                        vm.catalogsModel.methods.unlinkCatalogFromCustomer(records, vm.catalogsModel, action.id, customerId , vm.sellerId).then(function() {
                            refreshCatalogs(true, false);
                        });
                        break;
                    case 'activate':
                        vm.catalogsModel.methods.linkCatalogToCustomer(records, vm.catalogsModel, action.id, customerId , vm.sellerId).then(function() {
                            refreshCatalogs(true, false);
                        });
                        break;
                }
            }
        }

        function addCatalog(ev) {
            $mdDialog.show({
                controller         : 'customerCatalogRelationController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/customers/details/tabs/catalogs/dialogs/update-customer-catalog-relation.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: false,
                locals             : {
                    isNew: true,
                    record: null,
                    sellerId : vm.sellerId,
                    customerId: customerId,
                    assignedRecords: angular.copy(vm.catalogs),
                    event: ev
                }
            }).then(function(saved) {
                if (saved) {
                    refreshCatalogs(true);
                }
            });
        }

        function editCatalog(record, ev) {
            $mdDialog.show({
                controller         : 'customerCatalogRelationController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/customers/details/tabs/catalogs/dialogs/update-customer-catalog-relation.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: false,
                locals             : {
                    isNew: false,
                    record: record,
                    sellerId : vm.sellerId,
                    customerId: customerId,
                    assignedRecords: angular.copy(vm.catalogs),
                    event: ev
                }
            }).then(function(saved) {
                if (saved) {
                    refreshCatalogs(true);
                }
            });
        }

        function viewCatalog(record) {
            var stateParams = {id: record[vm.catalogsModel.idField], dataSourceTypeId: record.DataSourceTypeId};
            $state.go('app.catalogs.details', stateParams);
        }

        function initializeTabData(isLogRequired) {
            if(vm.customer.Status != 0 && SecurityFactory.isAuthorized({accessPrivileges: CONSTANTS.PRIVILEGES.CUSTOMERS.DETAIL.CATALOGS_LIST})) {
                isTabDataInitialized = true;
                refreshCatalogs(vm.catalogsModel.isDirty, isLogRequired);
            }
        }

    }
})();
(function () {
	'use strict';

	angular
		.module('app.main.catalogs')
		.controller('catalogsController', catalogsController);

	/* @ngInject */
	function catalogsController(api, $state, $document, $mdDialog, settingsFactory, crud, CONSTANTS) {
		/* jshint validthis: true */
		var vm = this;

		//Data
		vm.model = api.catalogs.catalogs;
		settingsFactory.applyPersistedListViewLayout(vm.model);

		vm.catalogs = [];
		vm.filteredCatalogs = [];
		vm.isLoading = false;


		//Methods
		vm.refreshItems = refreshItems;
		vm.doItemAction = doItemAction;
		vm.doListAction = doListAction;
		vm.viewItem = viewItem;
		vm.addRecord = addRecord;
		vm.editItem = editItem;

		activate();

		////////////////

		function activate() {
			refreshItems(vm.model.isDirty, true);
		}

		function refreshItems(forceFetch, isLogRequired) {
			var generalProperties = {
				forceFetch: forceFetch,
				isLogRequired: isLogRequired
			}
			vm.isLoading = true;

			vm.model.methods.getList(generalProperties)
			.then(function (response) {
				vm.catalogs = response.data;

				angular.forEach(vm.catalogs, function (catalog) {
					if (catalog.IsLinePlan == 1) {
						catalog.DataSourceType = CONSTANTS.LINE_PLAN_CATALOG;
						catalog.DataSourceTypeId = CONSTANTS.LINE_PLAN_ID;
					}
				});
			})
			.finally(function () {
				vm.isLoading = false;
			});
		}

		function doItemAction(action, record) {
			if (action && record) {
				switch (action.id) {
					case 'view':
						viewItem(record);
						break;
					case 'edit':
						vm.model.methods.getDetails(true, record[vm.model.idField])
						.then(function (response) {
							editItem(response.data, null);
						})
						break;
					case 'copy':
						copyCatalog(record, null);
						break;
					case 'delete':
					case 'activate':
						vm.model.methods.activateBulk(record, vm.model, action.id, undefined);
						break;
					case 'stopOrders':
					case 'allowOrders':
						vm.model.methods.updateReceiveOrdersStatus(record, vm.model, action.id);
						break;
					case 'manageContext':
						var modelCopy = angular.copy(vm.model);
						// make creatable false to all fields except duneContext
						angular.forEach(modelCopy.fields, function( field) {
							if(field.field !== 'DuneContext' && field.editable) {
								field.editable = false;
							} else if(field.field === 'DuneContext' && !field.visible) {
								field.editable = true;
							}
						});
						var additionalInfo = { 'additionalAction': 'manageDuneContext'};

						api.showEditRecordDialog(angular.element($document.body), null, modelCopy, record, undefined, undefined, additionalInfo)
							.then(function (saved) {
								if (saved) {
									refreshItems(true, false);
								}
							});
						break;
					case 'disableRequests':
					case 'enableRequests':
						vm.model.methods.updateReceiveRequestsStatus(record, vm.model, action.id);
						break;
				}
			}
		}

		function doListAction(action, records) {
			if (action) {
				switch (action.id) {
					case 'delete':
					case 'activate':
						vm.model.methods.activateBulk(records, vm.model, action.id, undefined);
						break;
				}
			}
		}

		function viewItem(item) {
			var id = item[vm.model.idField],
				stateParams = {
					id: id, dataSourceTypeId: item.DataSourceTypeId, isShippingWindowApply: item.IsShippingWindowApply
				};
			$state.go('app.catalogs.details', stateParams);
		}

		function addRecord(ev) {
			var lookupPromises = {};
			lookupPromises = crud.createLookupPromise(vm.model, undefined, 'create');
			return $mdDialog.show({
				controller: 'createCatalogController',
				controllerAs: 'vm',
				templateUrl: 'app/main/catalogs/dialogs/create-catalog.html',
				parent: angular.element($document.body),
				targetEvent: ev,
				clickOutsideToClose: false,
				locals: {
					isCopyCatalog: false,
					model: angular.copy(vm.model),
					record: null,
					existingRecordsForUniqueValue: angular.copy(vm.catalogs),
					lookupPromises: lookupPromises,
					event: ev
				}
			}).then(function (saved) {
				if (saved) {
					refreshItems(true);
				}
			});
		}

		function editItem(item, ev) {
			var lookupPromises = {};
			lookupPromises = crud.createLookupPromise(vm.model, undefined, 'edit');
			var existingRecordsForUniqueValue = angular.copy(vm.catalogs);
			for (var i = 0; i < existingRecordsForUniqueValue.length; i++) {
				if(existingRecordsForUniqueValue[i].Id === item.Id) {
					existingRecordsForUniqueValue.splice(i, 1);
				}
			}
			// the list row does not carry LinkedCatalogList, so fetch full details first (same record shape the details
			// page passes) - this lets the edit dialog prepopulate the linked catalogs and post the correct set back
			return vm.model.methods.getDetails(false, item[vm.model.idField]).then(function (response) {
				return $mdDialog.show({
					controller: 'createCatalogController',
					controllerAs: 'vm',
					templateUrl: 'app/main/catalogs/dialogs/create-catalog.html',
					parent: angular.element($document.body),
					targetEvent: ev,
					clickOutsideToClose: false,
					locals: {
						isCopyCatalog: false,
						model: angular.copy(vm.model),
						record: angular.copy(response.data),
						existingRecordsForUniqueValue: existingRecordsForUniqueValue,
						lookupPromises: lookupPromises,
						event: ev
					}
				}).then(function (saved) {
					if (saved) {
						refreshItems(true);
					}
				});
			});
		}

		function copyCatalog(item, ev) {
			var lookupPromises = {};
			lookupPromises = crud.createLookupPromise(vm.model, undefined, 'create');
			return $mdDialog.show({
				controller: 'createCatalogController',
				controllerAs: 'vm',
				templateUrl: 'app/main/catalogs/dialogs/create-catalog.html',
				parent: angular.element($document.body),
				targetEvent: ev,
				clickOutsideToClose: false,
				locals: {
					isCopyCatalog: true,
					model: angular.copy(vm.model),
					record: angular.copy(item),
					existingRecordsForUniqueValue: angular.copy(vm.catalogs),
					lookupPromises: lookupPromises,
					event: ev
				}
			}).then(function (saved) {
				if (saved) {
					refreshItems(true);
				}
			});
		}

	}
})();
(function () {
  'use strict';

  angular
    .module('app.main.catalogs')
    .controller('sortAttributesController', sortAttributesController);

  /* @ngInject */
  function sortAttributesController($scope, $filter, $mdDialog, hotkeys, toast, model, records, catalogCode, sellerAccountId, attributeGroupId, $q, utility) {
    /* jshint validthis: true */
    var vm = this;

    //Data
    vm.isLoading = false;
    vm.records = records;

    //Methods
    vm.saveRecord = saveRecord;
    vm.closeDialog = closeDialog;
    activate();

    ////////////////

    function activate() {
      //Hotkeys
      hotkeys.bindTo($scope).add({
        combo: 'ctrl+enter',
        description: $filter('translate')('ACTIONS.SAVE'),
        allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
        callback: function (event) {
          if (!vm.isLoading && !vm.editForm.$invalid) {
            vm.saveRecord();
          }
        }
      });
    }

    function saveRecord(saveAndNew) {
      vm.isLoading = true;
      if (!angular.isArray(vm.records)) {
        vm.records = crud.pushItemToArray(vm.records);
      }
      var promises = {};
      var normalAttributes = utility.filterObject(vm.records, {IsSeasonless: 0, IsSeasonlessModelAttribute: 0}, true);
      if(normalAttributes.length > 0) {
        promises['normalAttributesPromise'] = model.methods.update(undefined, normalAttributes, catalogCode, attributeGroupId);
      }
      // seasonless article attributes
      var seasonlessAttributes = utility.filterObject(vm.records, {IsSeasonless: 1, IsSeasonlessModelAttribute: 0}, true);
      if(seasonlessAttributes.length > 0) {
        promises['seasonlessAttributesPromise'] = model.methods.updateSeasonlessSortOrder(undefined, seasonlessAttributes, catalogCode, model, sellerAccountId);
      }
      // seasonless model attributes
      var seasonlessAttributes = utility.filterObject(vm.records, {IsSeasonlessModelAttribute: 1}, true);
      if(seasonlessAttributes.length > 0) {
        promises['seasonlessModelAttributesPromise'] = model.methods.updateSeasonlessModelAttributeSortOrder(undefined, seasonlessAttributes, catalogCode, model, sellerAccountId);
      }
      $q.all(promises).then(function () {
        closeDialog(true);
        var toastMessage;
        toastMessage = 'SUCCESS.UPDATE';
        toast.success(toastMessage, '', '');
      }, function () {
        closeDialog(vm.isDataDirty);
      }).finally(function () {
        vm.isLoading = false;
      });
    }

    function closeDialog(saved) {
      $mdDialog.hide(saved);
  }

  }
})();
(function () {
    'use strict';

    angular
        .module('app.main.catalogs')
        .controller('createCatalogController', createCatalogController);

    /* @ngInject */
    function createCatalogController($mdDialog, $scope, $filter, $window, hotkeys, toast, api, utility, $q, $log, isCopyCatalog, model, record, existingRecordsForUniqueValue, event, CONSTANTS, catalogFactory) {
        /* jshint validthis: true */
        var vm = this;

        //Data
        vm.isCopyCatalog = isCopyCatalog;
        var catalogModel = api.catalogs.catalogs;
        // maps a linked catalog code -> catalog name, so seeded chips (incl. links to deactivated catalogs) can render a label
        var linkedCatalogNameMap = {};
        // parent account of the edited catalog's seller, resolved lazily on edit (record.AccountId is a plain id, not an object)
        var selectedSellerParentAccountId;
        vm.isLoading = false;
        vm.availableCatalogs = [];
        var articleReplacementAttributes = []
        var availableAttributes = [];
        var allAttributes = [];
        var allCopyPricesCatalogs = [];
        vm.isDataDirty = false;
        vm.masterCalatogIsShippingWindowApply = 0;
        vm.isSizeScaleByStyle = 0;
        //todo: on angular material update remember to update the maxLength, currently "max-length" = "max-length" +1 (issue on existing material version)
        vm.maxChips = 2;
        var buyerLimitPriceGroups = [];
        vm.existingRecordsForUniqueValue = existingRecordsForUniqueValue;
        var allAvailableAttributesForTargetAndAggregate = [];
        vm.isInheritedCatalog = false;

        vm.acSelectedItem = [];
        vm.acSearchText = [];
        vm.customerRequiredDateValidationOperators = ['<=', '>=', '>', '<', '===', '!=='];
        vm.customerRequiredDateValidationRangeOperators = ['<=', '>=', '>', '<'];
        vm.removedRelations = [];
        var modelLevelAttributes = [];
        vm.nonRemovableModelLevelAttributes = [];

        if (record === null) {
            vm.isNew = true;
            resetForm();
        }
        else if (record !== null && !isCopyCatalog) {
            vm.isNew = false;
            vm.record = record;
            vm.lookupModel = record;
            record.id = record.CatalogCode; // needed for loadAvailableAttributes when updating record since while creation it uses lookupdata but while update it uses actual record
            loadAvailableAttributes(record);
            loadCatalogAttributeList(record.CatalogCode);
            modelLevelAttributes = utility.filterObject(record.ModelLevelAttributeList, { Status: 1 }) || []; // consider only active model level attributes for making chips non removable
            if(vm.record.IsLinePlan !== 1) {
                loadBuyerLimitPriceGroups(record.CatalogCode);
            }
            if(vm.record.CustomerRequiredDateValidation != null && vm.record.CustomerRequiredDateValidation.toString().trim() !== '') {
                if(utility.isValidJSON(vm.record.CustomerRequiredDateValidation)) {
                    // validation string is in this format "[{\"relation\":\"<=\",\"numberOfDays\":5},{\"relation\":\">=\",\"numberOfDays\":5}]" convert it into required object
                    var parsedCRDValidation = JSON.parse(vm.record.CustomerRequiredDateValidation);
                    if(angular.isArray(parsedCRDValidation) && parsedCRDValidation.length) {
                        var crdValidationObject = {
                            relation: parsedCRDValidation[0].relation,
                            numberOfDays: parsedCRDValidation[0].numberOfDays
                        }
                        if(angular.isDefined(parsedCRDValidation[1])) {
                            crdValidationObject['rangeRelation'] = parsedCRDValidation[1].relation;
                            crdValidationObject['rangeNumberOfDays'] = parsedCRDValidation[1].numberOfDays;
                        }
                        vm.customerRequiredDateValidation = crdValidationObject;
                    } else {
                        vm.customerRequiredDateValidation = parsedCRDValidation;
                    }
                    updateRangeOperators();
                } else {
                    console.warn("Customer Required Date Validation : Invalid JSON format");
                }
            }
        }
        else if (isCopyCatalog) {
            vm.record = record;
            vm.record.SourceCatalog = vm.record.CatalogCode;
            //Copy Catalog Entities: assigning default values as 0
            vm.record.CopyAttributes = 0;
            vm.record.CopyConfiguration = 0;
            vm.record.CopyPriceGroups = 0;
            vm.record.CopySegmentation = 0;
            vm.record.CopyTreeDefinition = 0;

            vm.sourceCatalogDisplayVal = vm.record.CatalogName; // just for display purpose in UI
            vm.lookupModel = vm.record;
        }

        vm.record.AttributeIdsList = [];
        vm.record.ReferenceCatalogCode = [];
        vm.record.TargettedAttributes = [];
        vm.record.AggregateAttributes = [];
        vm.record.CopyPriceCatalogs = [];
        // on edit, seed the chips from the catalog's existing active links so the field is prepopulated and the full
        // set can be posted back (the API replaces the whole set). vm.isNew is true on create, false on edit, undefined on copy.
        vm.record.LinkedCatalogs = [];
        if (vm.isNew === false && !vm.isCopyCatalog && vm.record.LinkedCatalogList) {
            vm.record.LinkedCatalogs = getLinkedCatalogCodes(vm.record.LinkedCatalogList);
            vm.linkedCatalogsSeeded = true;
        }

        vm.searchText = {};
        vm.searchText.ReferenceCatalogCode = '';
        vm.searchText.AttributeGroupId = '';
        vm.searchText.AttributeIdsList = '';
        vm.searchText.LinkedCatalogs = ''

        //available attribute Calculation Process Promise is used to display loading bar for attributes chips while getting data from server and subtract already assigned attributes
        var attributesCPP;
        var attributesCalculationDeffered = $q.defer();
        attributesCalculationDeffered.resolve([]);
        // initialize promise in order to avoid error on console when select inherited catalog, since it will initiate call to `acQuerySearch`
        attributesCPP = attributesCalculationDeffered.promise;

        var availableReferenceCatalogMap = {};

        //Methods
        vm.saveRecord = saveRecord;
        vm.closeDialog = closeDialog;

        vm.lookupSearch = lookupSearch;
        vm.onLookupChange = onLookupChange;
        vm.getLookupDisplayValue = getLookupDisplayValue;

        vm.lookupSearchArticleReplacementAttribute = lookupSearchArticleReplacementAttribute;
        vm.getArticleReplecementAttributeLookupDisplayValue = getArticleReplecementAttributeLookupDisplayValue;
        vm.onArticleReplecementAttributeLookupChange = onArticleReplecementAttributeLookupChange

        vm.lookupSearchBuyerLimitPriceGroup = lookupSearchBuyerLimitPriceGroup;
        vm.getBuyerLimitPriceGroupLookupDisplayValue = getBuyerLimitPriceGroupLookupDisplayValue;
        vm.onBuyerLimitPriceGroupLookupChange = onBuyerLimitPriceGroupLookupChange

        vm.acQuerySearch = acQuerySearch;
        vm.transformChip = transformChip;
        vm.getChipDisplayValue = getChipDisplayValue;

        vm.onDataSourceChange = onDataSourceChange;
        vm.onSellerAccountChange = onSellerAccountChange;
        vm.refCatalogSearch = refCatalogSearch;
        vm.onRefCatalogChange = onRefCatalogChange;
        vm.copyPriceCatalogSearch = copyPriceCatalogSearch;

        vm.serachNewReferenceCatalog = serachNewReferenceCatalog;
        vm.onNewReferenceCatalogChange = onNewReferenceCatalogChange;

        vm.selectText = selectText;
        vm.validateJSON = validateJSON;

        vm.updateRangeOperators = updateRangeOperators;

        activate();

        ////////////////

        function activate() {
            //Hotkeys
            hotkeys.bindTo($scope).add({
                combo: 'ctrl+enter',
                description: $filter('translate')('ACTIONS.SAVE'),
                allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
                callback: function (event) {
                    if (!vm.isLoading && !vm.editForm.$invalid) {
                        vm.saveRecord();
                    }
                }
            });

            hotkeys.bindTo($scope).add({
                combo: 'ctrl+shift+enter',
                description: $filter('translate')('ACTIONS.SAVE_AND_NEW'),
                allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
                callback: function (event) {
                    if (!vm.isLoading && !vm.editForm.$invalid) {
                        vm.saveRecord(true);
                    }
                }
            });
        }

        function saveRecord(saveAndNew) {
            vm.isLoading = true;
            var p;

            transformRequest();

            if (vm.isCopyCatalog) {
                p = model.methods.copy(vm.record);
            }
            else if (vm.isNew) {
                p = model.methods.create(vm.record);
            }
            else {
                //linked catalogs are now editable on update: the API replaces the whole set, so post the edited list back.
                //if we could not seed the current links (e.g. LinkedCatalogList was unavailable), send null so the existing
                //links are left unchanged rather than wiped by an empty array.
                if (!vm.linkedCatalogsSeeded) {
                    vm.record.LinkedCatalogs = null;
                }
                //linked attributes remain non-editable on update; null signals "no change" ('[]' would wipe them)
                vm.record.LinkedAttributes = null;
                vm.record.TargettedAttributes = null;
                vm.record.AggregateAttributes = [];
                p = model.methods.update(vm.record[model.idField], vm.record);
            }
            p.then(function () {
                if (angular.isDefined(saveAndNew) && saveAndNew) {
                    vm.editForm.$setPristine();
                    vm.editForm.$setUntouched();
                    resetForm();
                    vm.searchText = {};
                    vm.isDataDirty = true;
                    var el = $window.document.getElementById('catalog_dialog_input_first');
                    if (el) {
                        el.focus();
                    }
                } else {
                    closeDialog(true);
                }
                var toastMessage;
                toastMessage = vm.isNew || vm.isCopyCatalog ? 'SUCCESS.CREATE' : 'SUCCESS.UPDATE';
                toast.success(toastMessage, '', '');
            }, function () {
                closeDialog(vm.isDataDirty);
            }).finally(function () {
                vm.isLoading = false;
            });
        }

        function transformRequest() {
            //transform request for Line Plan type of catalogs
            if (vm.record.IsLinePlan == 1) {
                vm.record.DataSourceTypeId = 1;
                vm.record.DataSourceType = 'master';
                vm.record.LinkedAttributes = vm.record.AttributeIdsList;
                vm.record.ReferenceCatalogCode = null;
                if(vm.isNew) {
                    vm.record.AttributeIdsList = null;
                }
            } else if (vm.record.DataSourceTypeId == 1) {
                vm.record.ReferenceCatalogCode = null;
                if(vm.isNew) {
                    vm.record.AttributeIdsList = null;
                }
            } else {
                vm.record.ReferenceCatalogCode = vm.record.ReferenceCatalogCode[0];
            }
            // stringify customerRequiredDateValidation when sending to API
            if(!utility.isObjectEmpty(vm.customerRequiredDateValidation)) {
                if(vm.customerRequiredDateValidation.relation !== '') {
                    var validationArray = [];
                    // check if rangeRelation and rangeNumberOfDays are defined and relation is not empty
                    if (angular.isDefined(vm.customerRequiredDateValidation.rangeRelation) && angular.isDefined(vm.customerRequiredDateValidation.rangeNumberOfDays) && vm.customerRequiredDateValidation.rangeRelation !== '') {
                        validationArray.push({
                            relation: vm.customerRequiredDateValidation.relation,
                            numberOfDays: vm.customerRequiredDateValidation.numberOfDays
                        });
                        validationArray.push({
                            relation: vm.customerRequiredDateValidation.rangeRelation,
                            numberOfDays: vm.customerRequiredDateValidation.rangeNumberOfDays
                        });
                    } else {
                        // add the first object to the array
                        validationArray.push({
                            relation: vm.customerRequiredDateValidation.relation,
                            numberOfDays: vm.customerRequiredDateValidation.numberOfDays
                        });
                    }
                    vm.record.CustomerRequiredDateValidation = JSON.stringify(validationArray);
                } else {
                    vm.record.CustomerRequiredDateValidation = null;
                }
            }
        }

        function closeDialog(saved) {
            $mdDialog.hide(saved);
        }

        function lookupSearch(query, fieldName) {
            var results = [];

            var field = utility.filterObject(model.fields, { field: fieldName }, true)[0];
            var lookupFilter = field.lookupFilter ? field.lookupFilter : {};
            var predicate = angular.copy(lookupFilter);
            predicate.value = query;
            var lookupModel = api.getModel(field.lookupSource);

            //Add fourth Catalog Data Source Type Line Plan
            if (fieldName === 'DataSourceTypeId' && lookupModel.lookupData && lookupModel.lookupData.data.length && lookupModel.lookupData.indexArray && lookupModel.lookupData.indexArray.indexOf(4) === -1) {
                lookupModel.lookupData.data.push({ id: CONSTANTS.LINE_PLAN_ID, value: CONSTANTS.LINE_PLAN_CATALOG });
                lookupModel.lookupData.indexArray.push(CONSTANTS.LINE_PLAN_ID);
            }

            if (angular.isDefined(lookupModel.lookupData)) {
                results = query ? utility.filterObject(lookupModel.lookupData.data, predicate) : utility.filterObject(lookupModel.lookupData.data, lookupFilter, true);
                return results;
            }
            else {
                return api.getLookupData(lookupModel).then(function () {
                    results = query ? utility.filterObject(lookupModel.lookupData.data, predicate) : utility.filterObject(lookupModel.lookupData.data, lookupFilter, true);
                    return results;
                });
            }
        }

        // convert drop down scope value form object(lookup record) to id property of lookup record
        function onLookupChange(selectedObj, field) {
            if (angular.isObject(selectedObj)) {
                vm.record[field] = selectedObj.id;
                if(field === 'AccountId') {
                    // set the isSizeScaleByStyle
                    vm.isSizeScaleByStyle = selectedObj.IsSizeScaleByStyle;
                }
            }
            else if (angular.isUndefined(selectedObj) || selectedObj === null) {
                vm.record[field] = undefined; // on record removal make field undefined or the property can be deleted using delete keyword
                if(field === 'AccountId') {
                    // set the isSizeScaleByStyle
                    vm.isSizeScaleByStyle = 0;
                }
            }
            //for line plan catalog the attributes List will have all attributes of the attribute group, therefore populate attribute list when Attribute Group is selected
            if (field === 'AttributeGroupId') {
                articleReplacementAttributes = [];
                if(vm.record.DataSourceTypeId == 4) {
                    loadAttributesForLinePlan(vm.record.AttributeGroupId);
                } else {
                    loadCatalogAttributeList();
                }
                loadAvailableAttributesForTargetAndAggregate(vm.record.AttributeGroupId);
            }
        }

        function getLookupDisplayValue(item, lookupSource) {
            var lookupModel = api.getModel(lookupSource);

            if (lookupModel.lookupData && angular.isDefined(lookupModel.lookupData.data) && lookupModel.lookupData.data.length) {
                return getLookupDisplayVal(item, lookupModel.lookupData);
            }
            else {
                return api.getLookupData(lookupModel).then(function (lookupData) {
                    return getLookupDisplayVal(item, lookupData);
                });
            }
        }

        function getLookupDisplayVal(item, lookupData) {
            var result;
            if (lookupData) {
                // since autocomplete return object
                if (angular.isObject(item)) {
                    result = utility.filterObject(lookupData.data, { id: item.id }, true);
                }
                // to initialize field value if any (when open update record dialog)
                else {
                    result = utility.filterObject(lookupData.data, { id: item }, true);
                }

                if (angular.isArray(result) && result.length > 0) {
                    return result[0].value;
                }
                else {
                    return result.value;
                }
            }
        }

        function lookupSearchArticleReplacementAttribute(query) {
            var results = [];
            return loadCatalogAttributeList().then(function (articleReplacementAttributes) {
                results = query ? utility.filterObject(articleReplacementAttributes, { value: query }) : articleReplacementAttributes;
                return results;
            });
        }

        function onArticleReplecementAttributeLookupChange(selectedObj) {
            if (angular.isObject(selectedObj)) {
                vm.record.ArticleReplacementAttributeId= selectedObj.id;
            }
            else if (angular.isUndefined(selectedObj) || selectedObj === null) {
                vm.record.ArticleReplacementAttributeId = undefined; // on record removal make field undefined or the property can be deleted using delete keyword
            }
        }

        function getArticleReplecementAttributeLookupDisplayValue(item) {
            return loadCatalogAttributeList().then(function (articleReplacementAttributes) {
                return getArticleReplecementAttributeLookupDisplayVal(item, articleReplacementAttributes);
            });
        }

        function getArticleReplecementAttributeLookupDisplayVal(item, articleReplacementAttributes) {
            var result;
            // since autocomplete return object
            if (angular.isObject(item)) {
                result = utility.filterObject(articleReplacementAttributes, { id: item.id }, true);
            }
            // to initialize field value if any (when open update record dialog)
            else {
                result = utility.filterObject(articleReplacementAttributes, { id: item }, true);
            }

            if (angular.isArray(result) && result.length > 0) {
                return result[0].value;
            }
            else {
                return result.value;
            }
        }

        function lookupSearchBuyerLimitPriceGroup(query) {
            var results = [];
            return loadBuyerLimitPriceGroups().then(function (buyerLimitPriceGroups) {
                results = query ? utility.filterObject(buyerLimitPriceGroups, { value: query }) : buyerLimitPriceGroups;
                return results;
            });
        }

        function onBuyerLimitPriceGroupLookupChange(selectedObj) {
            if (angular.isObject(selectedObj)) {
                vm.record.BuyerLimitPriceGroupId = selectedObj.id;
            }
            else if (angular.isUndefined(selectedObj) || selectedObj === null) {
                vm.record.BuyerLimitPriceGroupId = null; // on record removal make field undefined or the property can be deleted using delete keyword
            }
        }

        function getBuyerLimitPriceGroupLookupDisplayValue(item) {
            return loadBuyerLimitPriceGroups().then(function (buyerLimitPriceGroups) {
                return getBuyerLimitPriceGroupLookupDisplayVal(item, buyerLimitPriceGroups);
            });
        }

        function getBuyerLimitPriceGroupLookupDisplayVal(item, buyerLimitPriceGroups) {
            var result;
            // since autocomplete return object
            if (angular.isObject(item)) {
                result = utility.filterObject(buyerLimitPriceGroups, { id: item.id }, true);
            }
            // to initialize field value if any (when open update record dialog)
            else {
                result = utility.filterObject(buyerLimitPriceGroups, { id: item }, true);
            }

            if (angular.isArray(result) && result.length > 0) {
                return result[0].value;
            }
            else {
                return result.value;
            }
        }

        function acQuerySearch(query, selectedItems, attributeType) {
            var searchQueryResult = [];
            return attributesCPP.then(function () {
                var allAvailableAttributes = allAttributes; // targetted attributes will include all attributes including seasonless
                if(attributeType === 'aggregateAttributes') { // show only seasonal attributes with type int and decimal
                    var intAttributes = utility.filterObject(allAvailableAttributesForTargetAndAggregate, {IsSeasonless: 0,IsSeasonlessModelAttribute: 0, AttributeTypeId: 2}, true);
                    var decimalAttributes = utility.filterObject(allAvailableAttributesForTargetAndAggregate, {IsSeasonless: 0,IsSeasonlessModelAttribute: 0, AttributeTypeId: 9}, true);
                    allAvailableAttributes = intAttributes.concat(decimalAttributes);
                } else if(attributeType === 'targetedAttributes') {
                    allAvailableAttributes = allAvailableAttributesForTargetAndAggregate;
                }

                searchQueryResult = utility.filterObject(angular.copy(allAvailableAttributes), query);
                if (selectedItems && selectedItems.length > 0) {
                    for (var index = searchQueryResult.length - 1; index >= 0; index--) {
                        if (selectedItems.indexOf(searchQueryResult[index].Attributeid) !== -1) {
                            searchQueryResult.splice(index, 1);
                        }
                    }
                }
                return searchQueryResult;
            });
        }

        function transformChip(chip, field) {
            if (angular.isObject(chip)) {
                if (field === 'AttributeId') {
                    return chip.Attributeid;
                } else {
                    return chip.id;
                }
            }
            return undefined;
        }

        function getChipDisplayValue(chip, field) {
            if (field === 'AttributeId') {
                var res = utility.filterObject(allAttributes, { Attributeid: chip }, true);
                if (angular.isArray(res) && res.length > 0) {
                    return res[0].AttributeDisplayName;
                }
            } else if (field === 'ReferenceCatalogCode' || field === 'LinkedCatalogs') {
                var res = utility.filterObject(vm.availableCatalogs, { id: chip }, true);
                if (angular.isArray(res) && res.length > 0) {
                    return res[0].value;
                }
                //a seeded link may not be in vm.availableCatalogs yet (dropdown not loaded) or its catalog was deactivated
                //(availableCatalogs is filtered to Status 1) - fall back to the name captured from LinkedCatalogList
                return linkedCatalogNameMap[chip];
            } else if (field === 'CopyPriceCatalogs') {
                var res = utility.filterObject(allCopyPricesCatalogs, { id: chip }, true);
                if (angular.isArray(res) && res.length > 0) {
                    return res[0].value;
                }
            } else {
                var res = utility.filterObject(allAvailableAttributesForTargetAndAggregate, { Attributeid: chip }, true);
                if (angular.isArray(res) && res.length > 0) {
                    return res[0].AttributeDisplayName;
                }
            }
        }

        function onDataSourceChange(DataSourceType, field) {
            if (angular.isObject(DataSourceType)) {
                onLookupChange(DataSourceType, field);
                if (DataSourceType.id == 1) {
                    vm.record.ReferenceCatalogCode = undefined;
                    vm.searchText.ReferenceCatalogCode = '';
                    vm.record.AttributeIdsList = [];
                }
                else if (DataSourceType.id == 2) {
                    vm.record.AttributeGroupId = undefined;
                    vm.searchText.AttributeGroupId = '';
                    vm.record.AttributeIdsList = [];
                }
                else if (DataSourceType.id == 3) {
                    vm.record.AttributeGroupId = undefined;
                    vm.searchText.AttributeGroupId = '';
                    //todo: on angular material update remember to update the maxLength (issue on existing material version)
                    vm.maxChips = 2;
                }
                else if (DataSourceType.id == 4) {
                    //for Line Plan attribute list(will contain all the attributes from attribute group assigned) and reference catalog  (will contain all the active catalogs displayed in list view)
                    if (vm.availableCatalogs && vm.availableCatalogs.length > 0) {
                        vm.linkedCatalogMaxChips = vm.availableCatalogs.length + 1;
                    }
                    vm.record.IsLinePlan = 1;
                    refCatalogSearch();
                }
            }
        }

        // initialize vm.availableCatalogs with selected seller's and its immediate parent seller's catalog
        function onSellerAccountChange(sellerAccount, field) {
            onLookupChange(sellerAccount, field);
            //added dataSourceTypeId!==4 condition so as not to filter reference catalog list acc to seller for line plan catalog
            if (angular.isObject(sellerAccount) && vm.record.DataSourceTypeId !== 4) {
                // clean catalog drop down
                if (sellerAccount.id !== vm.record.AccountId) {
                    vm.record.ReferenceCatalogCode = '';
                    vm.searchText.ReferenceCatalogCode = '';
                    availableAttributes = [];
                    vm.record.AttributeIdsList = [];
                    vm.acSearchText.AttributeIdsList = '';
                }
                if (catalogModel.lookupData) {
                    populateCatalogsData(catalogModel.lookupData.data);
                }
                else {
                    vm.isCatalogsLoaded = false; // to disable ref catalog element
                    return api.getLookupData(catalogModel).then(function () {
                        populateCatalogsData(catalogModel.lookupData.data);
                    }).finally(function () {
                        vm.isCatalogsLoaded = true;
                    });
                }
            }
        }

        function refCatalogSearch(query, selectedRecords) {
            var results = [];
            if ((angular.isDefined(vm.record.AccountId) && vm.record.AccountId > 0) || (vm.record.DataSourceTypeId && vm.record.DataSourceTypeId == 4)) {
                // since while loading catalogs filtering them with Status: 1, no need to use lookupFilter on false condition of ternary
                if (vm.availableCatalogs && vm.availableCatalogs.length) {
                    results = query ? utility.filterObject(vm.availableCatalogs, { value: query }) : angular.copy(vm.availableCatalogs);
                    results = removeSelectedChips(selectedRecords, results);
                    return results;
                }
                else {
                    //resolve the seller's parent account first (edit only) so the dropdown option set is complete
                    return resolveSellerAccount()
                        .then(function () {
                            return api.getLookupData(catalogModel);
                        })
                        .then(function (result) {
                            populateCatalogsData(result.data);
                            results = query ? utility.filterObject(vm.availableCatalogs, { value: query }) : angular.copy(vm.availableCatalogs);
                            results = removeSelectedChips(selectedRecords, results);
                            return results;
                        });
                }

            }
            else {
                return results;
            }
        }

        function onRefCatalogChange(selectedRecords, isInheritedCatalog) {
            if (angular.isDefined(selectedRecords) && selectedRecords.length === 1 && vm.record.DataSourceTypeId === 3 && isInheritedCatalog) {
                // POPULATE DATA FOR INHERITED CATALOG LIKE attributes, catalog flags based on selected catalog
                // Filter selected catalogs in strict mode to avaoid calling API with wrong catalog code
                var refCatalog = utility.filterObject(vm.availableCatalogs, { id: selectedRecords[0] }, true);
                vm.record.IsVasInUse = refCatalog[0].IsVasInUse;
                vm.masterCalatogIsShippingWindowApply = refCatalog[0].IsShippingWindowApply;
                //when master's catalog retail window is enabled then child catalog must have same value and user can't edit this.
                if (vm.masterCalatogIsShippingWindowApply) {
                    vm.record.IsShippingWindowApply = vm.masterCalatogIsShippingWindowApply;
                }
                loadAvailableAttributes(refCatalog[0]);
                articleReplacementAttributes = [];
                loadCatalogAttributeList();
                if(isInheritedCatalog) {
                    vm.isInheritedCatalog = true;
                    loadAvailableAttributesForTargetAndAggregate(refCatalog[0].AttributeGroupId);
                }
            }
        }

        function serachNewReferenceCatalog(query) {
            var results = [];
            if (vm.record['SourceCatalog'] && angular.isDefined(vm.record['SourceCatalog'])) {
                return getAvailableReferenceCatalog(vm.record['SourceCatalog'])
                    .then(function (availableReferenceCatalog) {
                        results = query ? utility.filterObject(availableReferenceCatalog, { CatalogName: query }) : availableReferenceCatalog;
                        return results;
                    });
            }
            return results;
        }

        function onNewReferenceCatalogChange(selectedObj, field) {
            if (angular.isObject(selectedObj)) {
                vm.record[field] = selectedObj.CatalogCode;
            }
            else if (angular.isUndefined(selectedObj) || selectedObj === null) {
                vm.record[field] = undefined; // on record removal make field undefined or the property can be deleted using delete keyword
            }
        }

        function copyPriceCatalogSearch(query, selectedRecords) {
            var results = [];
            if (catalogModel.lookupData) {
                results = allCopyPricesCatalogs = utility.filterObject(catalogModel.lookupData.data, { Status: 1 }, true);
                results = query ? utility.filterObject(results, { value: query }) : angular.copy(results);
                results = removeSelectedChips(selectedRecords, results);
                return results;
            }
            else {
                return api.getLookupData(catalogModel).then(function () {
                    results = allCopyPricesCatalogs = utility.filterObject(catalogModel.lookupData.data, { Status: 1 }, true);
                    results = query ? utility.filterObject(results, { value: query }) : angular.copy(results);
                    results = removeSelectedChips(selectedRecords, results);
                    return results;
                });
            }
        }

        function selectText(event) {
            utility.selectInputText(event);
        }

        function validateJSON(field) {
            var valid = utility.isValidJSON(vm.record[field]);
            if(valid && utility.isObjectEmpty(JSON.parse(vm.record[field]))) {
                valid = false;
            }
            if(valid) {
                if(angular.isDefined(vm.editForm[field])) {
                    vm.editForm[field].$setValidity('checkIfValidJson', true);
                }
            } else {
                if(angular.isDefined(vm.editForm[field])) {
                    vm.editForm[field].$setValidity('checkIfValidJson', false);
                }
            }
        }

        function updateRangeOperators() {
            vm.customerRequiredDateValidationRangeOperatorsCopy = angular.copy(vm.customerRequiredDateValidationRangeOperators);
            if (vm.customerRequiredDateValidation.relation) {
                // If the relation was previously removed, add it back
                var index = vm.customerRequiredDateValidationRangeOperators.indexOf(vm.customerRequiredDateValidation.relation);
                if (index !== -1) {
                    vm.customerRequiredDateValidationRangeOperatorsCopy.splice(index, 1);
                }
            }
        }

        //Helper Methods

        // this method will load assignable attributes for inherited catalogs
        function loadAvailableAttributes(selectedCatalog, attributeGroupId) {
            allAttributes = [];
            availableAttributes = [];
            vm.record.AttributeIdsList = [];
            vm.acSearchText.AttributeIdsList = '';
            var attributesAssignedToCatalog = [];
            var actualAttributesAssignedToCatalog = [];
            var attributesAssignedToAttributeGroup = [];
            var assignedAttributesIdList = [];
            var seasonlessArticleModelAttributesArray = [];
            attributesCalculationDeffered = $q.defer();
            var dataLoadPromises = {};
            if (selectedCatalog) {
                //load attributes assigned to selected catalog
                dataLoadPromises['catalogAttrsPromise'] = api.catalogs.attributes.methods.getList({ forceFetch: true, isLogRequired: false }, selectedCatalog.id)
                    .then(function (response) {
                        attributesAssignedToCatalog = response.data['AttributeList'];
                        if (angular.isDefined(vm.record) && !vm.isNew) {
                            for (var i = 0; i < attributesAssignedToCatalog.length; i++) {
                                if (attributesAssignedToCatalog[i].AttributeSource.toLowerCase() === 'self' && !attributesAssignedToCatalog[i].IsSeasonless && !attributesAssignedToCatalog[i].IsSeasonlessModelAttribute) {
                                    assignedAttributesIdList.push(attributesAssignedToCatalog[i].Attributeid);
                                    if(!vm.isNew && modelLevelAttributes.length) {
                                        var modelAttribute = modelLevelAttributes.find(function (attribute) {
                                            return attribute.AttributeId === attributesAssignedToCatalog[i].Attributeid;
                                        })
                                        if (angular.isDefined(modelAttribute)) {
                                            vm.nonRemovableModelLevelAttributes.push(modelAttribute.AttributeId)
                                        }
                                    }
                                    actualAttributesAssignedToCatalog.push(attributesAssignedToCatalog[i]);
                                }
                                // assign seasonless attributes to seasonlessArticleModelAttributesArray
                                if(attributesAssignedToCatalog[i].IsSeasonless || attributesAssignedToCatalog[i].IsSeasonlessModelAttribute) {
                                    seasonlessArticleModelAttributesArray.push(attributesAssignedToCatalog[i].Attributeid);
                                }
                            }
                        }
                    });

                //load available attributes
                dataLoadPromises['availableCatalogAttrsPromise'] = catalogModel.methods.getAvailableAttributes(selectedCatalog.id)
                    .then(function (response) {
                        availableAttributes = response.data;
                    });

            }

            $q.all(dataLoadPromises).then(function () {
                if (angular.isDefined(vm.record) && !vm.isNew) {
                    vm.record.AttributeIdsList = assignedAttributesIdList;
                }
                var availableAttributesWithoutSeasonless = [];
                angular.forEach(availableAttributes, function(attribute) {
                    if(!seasonlessArticleModelAttributesArray.includes(attribute.Attributeid)) {
                        availableAttributesWithoutSeasonless.push(attribute);
                    }
                });
                allAttributes = availableAttributesWithoutSeasonless.concat(actualAttributesAssignedToCatalog);
                attributesCalculationDeffered.resolve(availableAttributesWithoutSeasonless);
                attributesCPP = attributesCalculationDeffered.promise; // will display loading bar on attributes chips in case of huge data
            });
        }

        function loadAttributesForLinePlan(attributeGroupId) {
            var attributesAssignedToAttributeGroup = [];
            allAttributes = [];
            api.attributes.attributeGroups.methods.getDetails(false, attributeGroupId)
            .then(function (response) {
                attributesAssignedToAttributeGroup = response.data.ListAttributeResponse;
                angular.forEach(attributesAssignedToAttributeGroup, function (attributeOfGroup) {
                    allAttributes.push(attributeOfGroup);
                });
            });
        }

        function getAvailableReferenceCatalog(sourceCatalog) {
            var deferred = $q.defer();
            var promise = deferred.promise;
            if (availableReferenceCatalogMap[sourceCatalog] && angular.isArray(availableReferenceCatalogMap[sourceCatalog])) {
                deferred.resolve(availableReferenceCatalogMap[sourceCatalog]);
            }
            else {
                model.methods.getAvailableReferenceCatalogs(sourceCatalog)
                    .then(function (response) {
                        availableReferenceCatalogMap[sourceCatalog] = response.data;
                        deferred.resolve(response.data);
                    }).catch(function (err) {
                        $log.warn('Error getting list of available Reference catalog', err);
                        deferred.resolve([]);
                    });
            }
            return promise;
        }

        function populateCatalogsData(catalogs) {
            //account may be an object (seller picked in the dropdown on create) or a plain id (loaded record on edit)
            var accountId = angular.isObject(vm.lookupModel.AccountId) ? vm.lookupModel.AccountId.id : vm.record.AccountId;
            var parentAccountId = angular.isObject(vm.lookupModel.AccountId) ? vm.lookupModel.AccountId.ParentAccountId : selectedSellerParentAccountId;
            //the details page normalises DataSourceTypeId to 4 for line plans, but the list does not - also key off IsLinePlan
            var isLinePlan = vm.record.DataSourceTypeId == 4 || vm.record.IsLinePlan == 1;

            if (isLinePlan) {
                vm.availableCatalogs = utility.filterObject(catalogs, { Status: 1, IsLinePlan : 0 }, true);
            } else if (accountId) {
                //filter catalogs assigned to selected seller account
                vm.availableCatalogs = utility.filterObject(catalogs, { AccountId: accountId, Status: 1 }, true);
                var parentCatalogs = utility.filterObject(catalogs, { AccountId: parentAccountId, Status: 1 }, true);
                angular.forEach(parentCatalogs, function (parentCatalog) {
                    if (utility.filterObject(vm.availableCatalogs, { id: parentCatalog.id }, true).length <= 0) {// prevent to push duplicate
                        vm.availableCatalogs.push(parentCatalog);
                    }
                });
            }

            //a catalog can not be linked to itself (only reachable on edit, where CatalogCode exists)
            if (!vm.isNew) {
                for (var i = vm.availableCatalogs.length - 1; i >= 0; i--) {
                    if (vm.availableCatalogs[i].id === vm.record.CatalogCode) {
                        vm.availableCatalogs.splice(i, 1);
                    }
                }
            }
            vm.linkedCatalogMaxChips = vm.availableCatalogs.length + 1;
        }

        function removeSelectedChips(selectedRecords, records) {
            if (angular.isDefined(selectedRecords) && selectedRecords.length > 0) {
                for (var index = records.length - 1; index >= 0; index--) {
                    if (selectedRecords.indexOf(records[index].id) !== -1) {
                        records.splice(index, 1);
                    }
                    if (selectedRecords.indexOf(records[index]) !== -1) {
                        records.splice(index, 1);
                    }
                }
            }
            return records;
        }

        // maps the get-catalog-details LinkedCatalogList to chip values (catalog codes), keeping only active links
        // (Status 1); unlinked associations return with Status 0 and must not be re-linked. Also caches the catalog
        // name so getChipDisplayValue can label the chip even when the linked catalog is not in vm.availableCatalogs.
        function getLinkedCatalogCodes(linkedCatalogList) {
            var codes = [];
            angular.forEach(linkedCatalogList, function (catalog) {
                if (catalog.Status == 1) {
                    codes.push(catalog[catalogModel.idField]);                                      // CatalogCode
                    linkedCatalogNameMap[catalog[catalogModel.idField]] = catalog[catalogModel.lookupDisplayField]; // CatalogName
                }
            });
            return codes;
        }

        // on edit the seller account on the record is a plain id, so resolve the seller from the lookup to get its parent
        // account (needed to build the dropdown option set). Must not write the resolved object back onto AccountId - the
        // update API expects a scalar id.
        function resolveSellerAccount() {
            if (vm.isNew || angular.isObject(vm.lookupModel.AccountId) || angular.isDefined(selectedSellerParentAccountId)) {
                return $q.when();
            }
            return api.getLookupData(api.accounts.sellers).then(function (lookupData) {
                var seller = utility.filterObject(lookupData.data, { id: vm.record.AccountId }, true);
                if (angular.isArray(seller) && seller.length) {
                    selectedSellerParentAccountId = seller[0].ParentAccountId;
                }
            });
        }

        // due to time crunch created separate function
        function loadCatalogAttributeList() {
            // it is important to empty the list when changing catalog type, attribute group, reference catalog
            if(angular.isDefined(articleReplacementAttributes) && articleReplacementAttributes.length) {
                return $q.when(articleReplacementAttributes);
            } else if(!vm.isNew) {
                return api.catalogs.attributes.methods.getList({ forceFetch: true, isLogRequired: false }, vm.record.CatalogCode)
                .then(function(response) {
                    articleReplacementAttributes = response.data.AttributeList.map(function(data) {
                        return {id: data[api.catalogs.attributes.idField], value: data[api.catalogs.attributes.lookupDisplayField]}
                    });
                    return articleReplacementAttributes;
                });
            } else if(vm.isNew && vm.record.DataSourceTypeId === 3 && vm.record.ReferenceCatalogCode[0]) { // for inherited catalogs
                return api.catalogs.attributes.methods.getList({ forceFetch: true, isLogRequired: false }, vm.record.ReferenceCatalogCode[0])
                .then(function(response) {
                    articleReplacementAttributes = response.data.AttributeList.map(function(data) {
                        return {id: data[api.catalogs.attributes.idField], value: data[api.catalogs.attributes.lookupDisplayField]}
                    });
                    return articleReplacementAttributes;
                });
            } else if(vm.isNew && vm.record.DataSourceTypeId !== 3 && vm.record.AttributeGroupId) { // for master or line plan catalogs
                return api.attributes.attributeGroups.methods.getDetails(false, vm.record.AttributeGroupId)
                .then(function(response) {
                    articleReplacementAttributes = response.data.ListAttributeResponse.map(function(data) {
                        return {id: data[api.attributes.attributes.idField], value: data[api.attributes.attributes.lookupDisplayField]}
                    });
                    return articleReplacementAttributes;
                });
            } else {
                return $q.when([])
            }
        }

        function loadBuyerLimitPriceGroups() {
            if(angular.isDefined(buyerLimitPriceGroups) && buyerLimitPriceGroups.length) {
                return $q.when(buyerLimitPriceGroups);
            } else if(!vm.isNew) {
                return api.catalogs.priceGroup.methods.getList({ forceFetch: true, isLogRequired: false }, vm.record.CatalogCode)
                .then(function(response) {
                    buyerLimitPriceGroups = response.data.map(function(data) {
                        return {id: data[api.catalogs.priceGroup.idField], value: data[api.catalogs.priceGroup.lookupDisplayField]}
                    });
                    return buyerLimitPriceGroups;
                });
            } else {
                return $q.when([])
            }
        }

        // initialize form to its initiate state
        function resetForm() {
            vm.record = {};
            vm.record.State = 'Draft';
            //set boolean fields to their default values
            vm.record.IsVasInUse = 0;
            vm.record.IsShippingWindowApply = 0;
            vm.record.IsPriceByStyleApply = 0;
            vm.record.IndependentSizes = 0;
            //set default value for ReceiveOrdersWithoutPrice to 1
            vm.record.ReceiveOrdersWithoutPrice = 1;
            vm.record.ArticleCascading = 0;
            vm.record.SegmentationCascading = 0;
            vm.record.SegmentationPlanningEnable = 0;
            vm.record.ArticleLocking = 0;
            vm.record.IsLinePlan = 0;
            vm.record.PriceCascading = 0;
            vm.record.ChangeLog = 0;
            vm.record.AllowRequestedArticleCreation = 0;
            vm.record.Visibility = 3; // default value is 3 (Both)
            vm.record.CollectionsType = 1; // default value is 1(Article)
            vm.record.IsLive = 0;
        }

        function loadAvailableAttributesForTargetAndAggregate(attributeGroupId) {
            api.attributes.attributeGroups.methods.getDetails(false, attributeGroupId)
            .then(function (response) {
                var generalProperties = {
                    idMap: {
                        sellerId: vm.record.AccountId
                    }
                }
                api.lists.seasonlessModelAndArticleLevelAttributesList.methods.getList(generalProperties).then(function (seasonlessAttributes) {
                    allAvailableAttributesForTargetAndAggregate = response.data.ListAttributeResponse;
                    var selectedAttributeGroupAttributes = utility.filterObject(seasonlessAttributes.data, {AttributeGroupId: attributeGroupId}, true);
                    allAvailableAttributesForTargetAndAggregate = allAvailableAttributesForTargetAndAggregate.concat(selectedAttributeGroupAttributes);
                });
            });
        }

    }
})();
(function () {
	'use strict';

	angular
		.module('app.main.catalogs')
		.controller('catalogDetailsController', catalogDetailsController);

	/* @ngInject */
	function catalogDetailsController($scope, $document, api, $state, $stateParams, $rootScope, utility, dataImporter,
		settingsFactory, $mdDialog, crud, CONSTANTS, SecurityFactory, catalogModel, shipmentWindowRangeModel, catalogFactory, $localStorage) {
		/* jshint validthis: true */
		var vm = this;


		// Data
		var catalogId = $stateParams.id;
		vm.dataSourceTypeId = $stateParams.dataSourceTypeId;
		vm.isShippingWindowApply = $stateParams.isShippingWindowApply;
		vm.isSizeScaleByStyle = catalogFactory.getIsSizeScaleByStyle();
		var watchUnsubscribe = {};
		var isTabDataInitialized = false;
		vm.isRetailWindowViewableRestrictedOnRole = false;
		var modelLabelConfiguration = '';
		var articleLabelConfiguration = '';
		var segmentationLabelConfiguration = '';

		vm.model = catalogModel;

		vm.configurationsModel = api.catalogs.configurations;
		settingsFactory.applyPersistedListViewLayout(vm.configurationsModel);

		vm.attributesModel = api.catalogs.attributes;
		settingsFactory.applyPersistedListViewLayout(vm.attributesModel);

		vm.roleBasedRestrictAttributesModel = api.catalogs.roleBaseRestrictAttributes;
		settingsFactory.applyPersistedListViewLayout(vm.roleBasedRestrictAttributesModel);

		vm.CRDModel = api.catalogs.CRD;
		settingsFactory.applyPersistedListViewLayout(vm.CRDModel);

		vm.shipmentWindowsModel = shipmentWindowRangeModel;
		settingsFactory.applyPersistedListViewLayout(vm.shipmentWindowsModel);

		vm.priceGroupModel = api.catalogs.priceGroup;
		settingsFactory.applyPersistedListViewLayout(vm.priceGroupModel);

		vm.segmentationsModel = api.catalogs.segmentations;
		settingsFactory.applyPersistedListViewLayout(vm.segmentationsModel);

		vm.sizeScaleGroupsModel = api.catalogs.sizeScaleGroups;
		settingsFactory.applyPersistedListViewLayout(vm.sizeScaleGroupsModel);

		vm.stockDefinitionModel = api.catalogs.stockDefinition;
		settingsFactory.applyPersistedListViewLayout(vm.stockDefinitionModel);

		vm.treeModel = api.catalogs.treeDefinition;
		settingsFactory.applyPersistedListViewLayout(vm.treeModel);

		vm.attributeVettingListModel = api.catalogs.attributeVettingList;
		settingsFactory.applyPersistedListViewLayout(vm.attributeVettingListModel);

		vm.segmentationGroupModel = api.catalogs.segmentationGroup;
		settingsFactory.applyPersistedListViewLayout(vm.segmentationGroupModel);

		vm.linkedCatalogsModel = api.catalogs.linkedCatalogs;
		settingsFactory.applyPersistedListViewLayout(vm.linkedCatalogsModel);

		vm.linkedAttributesModel = api.catalogs.linkedAttributes;
		settingsFactory.applyPersistedListViewLayout(vm.linkedAttributesModel);

		vm.targetedAttributesModel = api.catalogs.targetedAttributes;
		settingsFactory.applyPersistedListViewLayout(vm.targetedAttributesModel);

		vm.sellerUsersListModel = api.catalogs.sellerUsers;
		settingsFactory.applyPersistedListViewLayout(vm.sellerUsersListModel);

		vm.modelLevelAttributesModel = api.catalogs.modelLevelAttributes;
		settingsFactory.applyPersistedListViewLayout(vm.modelLevelAttributesModel);

		vm.requestAttributesModel = api.catalogs.requestAttributes;
		settingsFactory.applyPersistedListViewLayout(vm.requestAttributesModel);

		vm.requestReasonsModel = api.catalogs.requestReasons;
		settingsFactory.applyPersistedListViewLayout(vm.requestReasonsModel);

		vm.bucketLevelAttributesModel = api.catalogs.bucketLevelAttributes;
		settingsFactory.applyPersistedListViewLayout(vm.bucketLevelAttributesModel);

		vm.restrictBucketAttributesRolesModel = api.catalogs.restrictBucketAttributesRoles;
		settingsFactory.applyPersistedListViewLayout(vm.restrictBucketAttributesRolesModel);

		vm.colorDefinitionModel = api.catalogs.colorDefinition;
		settingsFactory.applyPersistedListViewLayout(vm.colorDefinitionModel);

		vm.relationTypesModel = api.catalogs.relationTypes;
		vm.relationTypesModelCopy = angular.copy(vm.relationTypesModel);
		settingsFactory.applyPersistedListViewLayout(vm.relationTypesModel);

		// Datasets are seller-scoped; reuse the seller definition model (same listing API) but read-only at catalog level.
		// The Datasets tab reuses the seller privileges (GetDatasetDefinitions / GetDatasetDefinitionDetails) since it calls the same API.
		vm.datasetDefinitionsModel = api.sellers.datasets;
		vm.datasetDefinitionsModelCopy = angular.copy(vm.datasetDefinitionsModel);
		settingsFactory.applyPersistedListViewLayout(vm.datasetDefinitionsModelCopy);
		// read-only at catalog level (dataset definitions are seller-global) - keep only the 'view' item action
		vm.datasetDefinitionsModelCopy.views.mainList.itemActions =
			utility.filterObject(vm.datasetDefinitionsModelCopy.views.mainList.itemActions, {id: 'view'});
		vm.datasetDefinitionsModelCopy.views.mainList.listActions = [];
		vm.datasetDefinitionsModelCopy.views.mainList.fabAction = {};

		vm.roleBasedRestrictSegmentationsModel = api.catalogs.roleBasedRestrictSegmentations;
		settingsFactory.applyPersistedListViewLayout(vm.roleBasedRestrictSegmentationsModel);

		vm.roleBasedRestrictRetailWindowsModel = api.catalogs.roleBasedRestrictRetailWindows;
		settingsFactory.applyPersistedListViewLayout(vm.roleBasedRestrictRetailWindowsModel);

		vm.colorPaletteModel = api.catalogs.colorPalette;
		vm.colorPaletteModelCopy = angular.copy(vm.colorPaletteModel);
		settingsFactory.applyPersistedListViewLayout(vm.colorPaletteModel);

		vm.aggregateAttributesModel = api.catalogs.aggregateAttributes;
		settingsFactory.applyPersistedListViewLayout(vm.aggregateAttributesModel);

		vm.catalog = {};
		vm.attributes = [];
		vm.filteredAttributes = [];
		vm.roleBasedRestrictedAttributes = [];
		vm.filteredRoleBasedRestrictedAttributes = [];
		vm.configurations = [];
		vm.filteredConfigurations = [];
		vm.CRD = [];
		vm.filteredCRD = [];
		vm.shipmentWindows = [];
		vm.filteredShipmentWindows = [];
		vm.priceGroup = [];
		vm.filteredPriceGroup = [];
		vm.segmentations = [];
		vm.allSegmentationsCopy = [];
		vm.filteredSegmentations = [];
		vm.sizeScaleGroups = [];
		vm.filteredSizeScaleGroups = [];
		vm.stockDefinition = [];
		vm.filteredStockDefinition = [];
		vm.treeAttributesLookupData = {};
		vm.treeAttributes = [];
		vm.treeUnUtilizedAttributes = [];
		vm.treeData = [];
		vm.filteredTreeData = [];
		var pristineActiveTreeAttributes = [];
		vm.attributeVettingList = [];
		vm.filteredAttributeVettingList = [];
		vm.segmentationGroup = [];
		vm.filteredSegmentationGroups = [];
		vm.linkedCatalogs = [];
		vm.filteredLinkedCatalogs = [];
		vm.linkedAttributes = [];
		vm.filteredLinkedAttributes = [];
		vm.targetedAttributes = [];
		vm.filteredTargetedAttributes = [];
		vm.sellerUserList = [];
		vm.filteredSellerUserList = [];
		vm.modelLevelAttributes = [];
		vm.filteredModelLevelAttributes = [];
		vm.requestAttributes = [];
		vm.filteredRequestAttributes = [];
		vm.bucketLevelAttributes = [];
		vm.filteredBucketLevelAttributes = [];
		vm.restrictBucketAttributes =[];
		vm.filteredRestrictBucketAttributes = [];
		vm.colorDefinitions = [];
		vm.filteredColorDefinitions = [];
		vm.relationTypes = [];
		vm.filteredRelationTypes = [];
		vm.datasetDefinitions = [];
		vm.filteredDatasetDefinitions = [];
		vm.roleBasedRestrictedSegmentations= [];
		vm.filteredRoleBasedRestrictedSegmentations = [];
		vm.roleBasedRestrictedRetailWindows= [];
		vm.filteredRoleBasedRestrictedRetailWindows = [];
		vm.colorPalette = [];
		vm.filteredColorPalette = [];
		vm.aggregateAttributes = [];
		vm.filteredAggregateAttributes = [];

		vm.isLoading = false;
		vm.isAttributeLoading = false;
		vm.isRoleBasedRestrictedAttributesLoading = false;
		vm.isConfigurationLoading = false;
		vm.isCRDLoading = false;
		vm.isShipmentWindowsLoading = false;
		vm.isPriceGroupLoading = false;
		vm.isSegmentationLoading = false;
		vm.isSizeScaleGroupsLoading = false;
		vm.isStockDefinitionLoading = false;
		vm.isTreeLoading = false;
		vm.isAttributeVettingListLoading = false;
		vm.isSegmentationGroupLoading = false;
		vm.isSellerUserListLoading = false;
		vm.isModelLevelAttributesLoading = false;
		vm.isRequestAttributesLoading = false;
		vm.isRequestReasonsLoading = false;
		vm.isBucketLevelAttributesLoading = false;
		vm.isRestrictBucketAttributesLoading = false;
		vm.isColorDefinitionsLoading = false;
		vm.isRelationTypesLoading = false;
		vm.isDatasetDefinitionsLoading = false;
		vm.isRoleBasedRestrictedSegmentationsLoading = false;
		vm.isRoleBasedRestrictedRetailWindowsLoading = false;
		vm.isColorPaletteLoading = false;
		vm.isSizeCurveListLoading = false;

		// Methods
		vm.refreshRecords = refreshRecords;
		vm.refreshAttributes = refreshAttributes;
		vm.refreshRoleBasedRestrictedAttributes = refreshRoleBasedRestrictedAttributes;
		vm.refreshConfigurations = refreshConfigurations;
		vm.refreshCRDs = refreshCRDs;
		vm.refreshShipmentWindows = refreshShipmentWindows;
		vm.refreshPriceGroups = refreshPriceGroups;
		vm.refreshSegmentations = refreshSegmentations;
		vm.refreshSizeScaleGroups = refreshSizeScaleGroups;
		vm.refreshStockDefinitions = refreshStockDefinitions;
		vm.refreshTree = refreshTree;
		vm.refreshAttributeVettingList = refreshAttributeVettingList;
		vm.refreshSegmentationGroup = refreshSegmentationGroup;
		vm.refreshSellerUserList = refreshSellerUserList;
		vm.refreshModelLevelAttributes = refreshModelLevelAttributes;
		vm.refreshRequestAttributes = refreshRequestAttributes;
		vm.refreshRequestReasons = refreshRequestReasons;
		vm.refreshBucketLevelAttributes = refreshBucketLevelAttributes;
		vm.refreshRestrictBucketAttributes = refreshRestrictBucketAttributes;
		vm.refreshColorDefinitions = refreshColorDefinitions;
		vm.refreshRelationTypes = refreshRelationTypes;
		vm.refreshDatasetDefinitions = refreshDatasetDefinitions;
		vm.refreshRoleBasedRestrictedSegmentations = refreshRoleBasedRestrictedSegmentations;
		vm.refreshRoleBasedRestrictedRetailWindows = refreshRoleBasedRestrictedRetailWindows;
		vm.refreshColorPalette  = refreshColorPalette;

		vm.doCatalogItemAction = doCatalogItemAction;
		vm.editItem = editItem;

		vm.doAttributesItemAction = doAttributesItemAction;
		vm.doAttributesListAction = doAttributesListAction;
		vm.viewAttribute = viewAttribute;

		vm.doRoleBasedRestrictedAttributesItemAction = doRoleBasedRestrictedAttributesItemAction;
		vm.doRoleBasedRestrictedAttributesListAction = doRoleBasedRestrictedAttributesListAction;
		vm.addOrUpdateAttributeRoleBasedRestriction = addOrUpdateAttributeRoleBasedRestriction;

		vm.doConfigurationsItemAction = doConfigurationsItemAction;
		vm.doConfigurationsListAction = doConfigurationsListAction;
		vm.addConfiguration = addConfiguration;

		vm.doCRDItemAction = doCRDItemAction;
		vm.doCRDListAction = doCRDListAction;
		vm.addCRD = addCRD;

		vm.doShipmentWindowsItemAction = doShipmentWindowsItemAction;
		vm.doShipmentWindowsListAction = doShipmentWindowsListAction;
		vm.addShipmentWindow = addShipmentWindow;

		vm.doPriceGroupItemAction = doPriceGroupItemAction;
		vm.doPriceGroupListAction = doPriceGroupListAction;
		vm.addPriceGroup = addPriceGroup;

		vm.doSegmentationsItemAction = doSegmentationsItemAction;
		vm.doSegmentationsListAction = doSegmentationsListAction;
		vm.addSegmentation = addSegmentation;

		vm.doSizeScaleGroupsListAction = doSizeScaleGroupsListAction;

		vm.doStockDefinitionItemAction = doStockDefinitionItemAction;
		vm.doStockDefinitionListAction = doStockDefinitionListAction;
		vm.addStockDefinition = addStockDefinition;

		vm.doTreeListAction = doTreeListAction;
		vm.doTreeItemAction = doTreeItemAction;
		vm.addTree = addTree;

		vm.doAttributeVettingListItemAction = doAttributeVettingListItemAction;
		vm.doAttributeVettingListAction = doAttributeVettingListAction;
		vm.addAttributeToAttributeVettingList = addAttributeToAttributeVettingList;

		vm.doSegmentationGroupItemAction = doSegmentationGroupItemAction;
		vm.doSegmentationGroupListAction = doSegmentationGroupListAction;
		vm.addSegmentationGroup = addSegmentationGroup;

		vm.doLinkedCatalogsItemAction = doLinkedCatalogsItemAction;
		vm.viewLinkedCatalog = viewLinkedCatalog;

		vm.doLinkedAttributesItemAction = doLinkedAttributesItemAction;
		vm.doLinkedAttributesListAction = doLinkedAttributesListAction;
		vm.viewLinkedAttribute = viewLinkedAttribute;

		vm.doTargetedAttributesItemAction = doTargetedAttributesItemAction;
		vm.viewTargetedAttribute = viewTargetedAttribute;
		vm.onActiveTabChange = onActiveTabChange;

		vm.assignModelLevelAttributes = assignModelLevelAttributes;

		vm.doRequestAttributeItemAction = doRequestAttributeItemAction;
		vm.doRequestAttributeListAction = doRequestAttributeListAction;
		vm.assignRequestAttributes = assignRequestAttributes;

		vm.doRequestReasonsItemAction = doRequestReasonsItemAction;
		vm.doRequestReasonsListAction = doRequestReasonsListAction;
		vm.addRequestReasons = addRequestReasons;

		vm.doBucketLevelAttributeItemAction = doBucketLevelAttributeItemAction;
		vm.doBucketLevelAttributeListAction = doBucketLevelAttributeListAction;
		vm.assignBucketLevelAttributes = assignBucketLevelAttributes;

		vm.doRestrictBucketAttributesItemAction = doRestrictBucketAttributesItemAction;
		vm.doRestrictBucketAttributesListAction = doRestrictBucketAttributesListAction;
		vm.addRestrictBucketAttributesRoles = addRestrictBucketAttributesRoles;

		vm.doColorDefinitionItemAction = doColorDefinitionItemAction;
		vm.doColorDefinitionListAction = doColorDefinitionListAction;
		vm.addColorDefinition = addColorDefinition;

		vm.doRelationTypesItemAction = doRelationTypesItemAction;
		vm.doRelationTypesListAction = doRelationTypesListAction;
		vm.addRelationTypes = addRelationTypes;

		vm.doDatasetDefinitionItemAction = doDatasetDefinitionItemAction;
		vm.viewDatasetDefinition = viewDatasetDefinition;

		vm.doRoleBasedRestrictedSegmentationsItemAction = doRoleBasedRestrictedSegmentationsItemAction;
		vm.doRoleBasedRestrictedSegmentationsListAction = doRoleBasedRestrictedSegmentationsListAction;
		vm.addOrUpdateSegmentationRoleBasedRestriction = addOrUpdateSegmentationRoleBasedRestriction;

		vm.doRoleBasedRestrictedRetailWindowsItemAction = doRoleBasedRestrictedRetailWindowsItemAction;
		vm.doRoleBasedRestrictedRetailWindowsListAction = doRoleBasedRestrictedRetailWindowsListAction;
		vm.addOrUpdateRetailWindowRoleBasedRestriction = addOrUpdateRetailWindowRoleBasedRestriction;

		vm.doColorPaletteItemAction = doColorPaletteItemAction;
		vm.doColorPaletteListAction = doColorPaletteListAction;
		vm.addUpdateColorPalette = addUpdateColorPalette;

		vm.doAggregateAttributesItemAction = doAggregateAttributesItemAction;
		vm.viewAggregateAttribute = viewAggregateAttribute;

		activate();

		////////////////

		function activate() {
			// set currently opened catalog
			api.setCatalogCodeFromCatalogDetails(catalogId);
			refreshRecords(true);
		}

		function refreshRecords(isLogRequired) {
			vm.isLoading = true;

			vm.model.methods.getDetails(isLogRequired, catalogId)
				.then(function (response) {
					vm.catalog = response.data;
					// set seller id
					vm.sellerId = vm.catalog.AccountId;
					//UPDATE catalog data-source properties for line plan catalog
					if (vm.catalog.IsLinePlan === 1) {
						vm.catalog.DataSourceTypeId = CONSTANTS.LINE_PLAN_ID;
						vm.catalog.DataSourceType = CONSTANTS.LINE_PLAN_CATALOG;
					}
					// adding this on top as we need to hide role based restricted Segmentations, retail windows, attributes and bucketattributes
					initializeTabData(isLogRequired);
					// to avoid UI jump when displaying shipment window tab conditionally
					vm.dataSourceTypeId = vm.catalog.DataSourceTypeId;
					vm.isShippingWindowApply = vm.catalog.IsShippingWindowApply;
					vm.title = angular.copy(vm.catalog[vm.model.lookupDisplayField]);

					if(vm.catalog.DataSourceTypeId === 3) {
						catalogFactory.modifyModelActions(vm.relationTypesModelCopy);
						catalogFactory.modifyModelActions(vm.colorPaletteModelCopy);
					}

					//Update Breadcrumb
					$state.current.data.displayName = vm.title;
					$rootScope.$broadcast('breadcrumb-updated');
					setArticleModelAndSegmentationLabelConfigurationInsideCatalog();
					// replace "Article", "Model" and "segmentation" in attributes name with T1S-ArticleLabel and T1S-ModelLabel if configured
					vm.attributes = replaceAttributeNames(response.data.AssignedCatalogAttributes);
					vm.CRD = response.data.CatalogCRDList;
					vm.priceGroup = response.data.CatalogPriceGroupList;
					vm.segmentationGroup = response.data.SegmentationGroupList;
					vm.linkedCatalogs = response.data.LinkedCatalogList;
					angular.forEach(vm.linkedCatalogs, function (catalog) {
						//UPDATE catalog data-source properties for line plan catalog
						if (catalog.IsLinePlan == 1) {
							catalog.DataSourceType = CONSTANTS.LINE_PLAN_CATALOG;
							catalog.DataSourceTypeId = CONSTANTS.LINE_PLAN_ID;
						}
					})
					vm.linkedAttributes = replaceAttributeNames(response.data.LinkedAttributeList);
					vm.targetedAttributes = replaceAttributeNames(response.data.TargettedAttributeList);
					vm.modelLevelAttributes = replaceAttributeNames(utility.filterObject(response.data.ModelLevelAttributeList, {Status: 1}));
					vm.bucketLevelAttributes = replaceAttributeNames(response.data.BucketAttributeList);
					vm.aggregateAttributes = response.data.AggregateAttributeList;
					// there is an inconsistancy in the API response of bucket attributes and getList of attributes assigning AttributeId to Attributeid
					angular.forEach(vm.bucketLevelAttributes, function(attribute) {
						attribute['Attributeid'] = attribute.AttributeId;
					});
				})
				.finally(function () {
					vm.isLoading = false;
				});
		}

		function refreshAttributes(forceFetch, isLogRequired) {
			var generalProperties = {
				forceFetch: forceFetch,
				isLogRequired: isLogRequired
			}
			vm.isAttributeLoading = true;
			vm.attributesModel.methods.getList(generalProperties, catalogId).then(function (response) {
				vm.attributes = replaceAttributeNames(response.data.AttributeList);
			}).finally(function () {
				vm.isAttributeLoading = false;
			});
		}

		function refreshRoleBasedRestrictedAttributes(forceFetch, isLogRequired) {
			var generalProperties = {
				forceFetch: forceFetch,
				isLogRequired: isLogRequired
			}
			vm.isRoleBasedRestrictedAttributesLoading = true;
			vm.roleBasedRestrictAttributesModel.methods.getList(generalProperties, catalogId).then(function (response) {
				vm.roleBasedRestrictedAttributes = response.data.Roles;
			}).finally(function () {
				vm.isRoleBasedRestrictedAttributesLoading = false;
			});
		}

		function refreshConfigurations(forceFetch, isLogRequired) {
			var generalProperties = {
				forceFetch: forceFetch,
				isLogRequired: isLogRequired
			}
			vm.isConfigurationLoading = true;
			vm.configurationsModel.methods.getList(generalProperties, catalogId, vm.configurationsModel).then(function (response) {
				vm.configurations = response.data;
			}).finally(function () {
				vm.isConfigurationLoading = false;
			});
		}

		function refreshCRDs(forceFetch, isLogRequired) {
			var generalProperties = {
				forceFetch: forceFetch,
				isLogRequired: isLogRequired,
				config: {},
				supportIncrementalResult: true,
				modelIdField: 'Id',
				isMajor: false,
				model: vm.CRDModel
			}
			vm.isCRDLoading = true;
			vm.CRDModel.methods.getList(generalProperties, catalogId, vm.CRDModel).then(function (response) {
				vm.CRD = response.data;
				if (angular.isDefined(vm.tableControl) && angular.isDefined(vm.tableControl.updateData)) {
					vm.tableControl.updateData();
				}
			}).finally(function () {
				vm.isCRDLoading = false;
			});
		}

		function refreshShipmentWindows(forceFetch, isLogRequired) {
			var generalProperties = {
				forceFetch: forceFetch,
				isLogRequired: isLogRequired
			}
			vm.isShipmentWindowsLoading = true;
			vm.shipmentWindowsModel.methods.getList(generalProperties, catalogId, vm.shipmentWindowsModel).then(function (response) {
				vm.shipmentWindows = response.data;
			}).finally(function () {
				vm.isShipmentWindowsLoading = false;
			});
		}

		function refreshPriceGroups(forceFetch, isLogRequired) {
			var generalProperties = {
				forceFetch: forceFetch,
				isLogRequired: isLogRequired,
				config: {},
				supportIncrementalResult: true,
				modelIdField: 'Id',
				isMajor: false,
				model: vm.priceGroupModel
			}
			vm.isPriceGroupLoading = true;
			vm.priceGroupModel.methods.getList(generalProperties, catalogId).then(function (response) {
				vm.priceGroup = response.data;
			}).finally(function () {
				vm.isPriceGroupLoading = false;
			});
		}

		function refreshSegmentations(forceFetch, isLogRequired) {
			var generalProperties = {
				forceFetch: forceFetch,
				isLogRequired: isLogRequired,
				config: {},
				supportIncrementalResult: true,
				modelIdField: 'Id',
				isMajor: false,
				model: vm.segmentationsModel
			}
			vm.isSegmentationLoading = true;
			vm.segmentationsModel.methods.getList(generalProperties, catalogId, vm.segmentationsModel).then(function (response) {
				// this is used for segmentations groups to add assigned segmentaions
				vm.allSegmentationsCopy = response.data;
				vm.segmentations = catalogFactory.removeRestrictedSegmentations(response.data, vm.roleBasedRestrictedSegmentations);
			}).finally(function () {
				vm.isSegmentationLoading = false;
			});
		}

		function refreshSizeScaleGroups(forceFetch, isLogRequired) {
			var generalProperties = {
				forceFetch: forceFetch,
				isLogRequired: isLogRequired
			}
			vm.isSizeScaleGroupsLoading = true;
			vm.sizeScaleGroupsModel.methods.getList(generalProperties, catalogId)
				.then(function (response) {
					vm.sizeScaleGroups = response.data;
				})
				.finally(function () {
					vm.isSizeScaleGroupsLoading = false;
				});
		}

		function refreshStockDefinitions(forceFetch, isLogRequired) {
			var generalProperties = {
				forceFetch: forceFetch,
				isLogRequired: isLogRequired
			}
			vm.isStockDefinitionLoading = true;
			vm.stockDefinitionModel.methods.getList(generalProperties, catalogId)
				.then(function (response) {
					vm.stockDefinition = response.data;
				})
				.finally(function () {
					vm.isStockDefinitionLoading = false;
				});
		}

		function refreshTree(forceFetch, isLogRequired) {
			var generalProperties = {
				forceFetch: forceFetch,
				isLogRequired: isLogRequired
			}
			vm.isTreeLoading = true;
			vm.treeModel.methods.getList(generalProperties, catalogId).then(function (response) {
				vm.treeData = response.data;
			}).finally(function () {
				vm.isTreeLoading = false;
			});
		}

		function refreshAttributeVettingList(forceFetch, isLogRequired) {
			var generalProperties = {
				forceFetch: forceFetch,
				isLogRequired: isLogRequired
			}
			vm.isAttributeVettingListLoading = true;
			vm.attributeVettingListModel.methods.getList(generalProperties, catalogId, vm.attributeVettingListModel).then(function (response) {
				vm.attributeVettingList = replaceAttributeNames(response.data);
			}).finally(function () {
				vm.isAttributeVettingListLoading = false;
			});
		}

		function refreshSegmentationGroup(forceFetch, isLogRequired) {
			var generalProperties = {
				forceFetch: forceFetch,
				isLogRequired: isLogRequired
			}
			vm.isSegmentationGroupLoading = true;
			vm.segmentationGroupModel.methods.getList(generalProperties, catalogId).then(function (response) {
				vm.segmentationGroup = response.data;
			}).finally(function () {
				vm.isSegmentationGroupLoading = false;
			});
		}

		function refreshSellerUserList(forceFetch, isLogRequired) {
			var generalProperties = {
				forceFetch: forceFetch,
				isLogRequired: isLogRequired
			}
			vm.isSellerUserListLoading = true;
			vm.sellerUsersListModel.methods.getList(generalProperties, catalogId).then(function (response) {
				vm.sellerUserList = response.data;
			}).finally(function () {
				vm.isSellerUserListLoading = false;
			});
		}

		function refreshModelLevelAttributes(isLogRequired) {
			vm.isModelLevelAttributesLoading = true;
			vm.model.methods.getDetails(isLogRequired, catalogId).then(function (response) {
				vm.modelLevelAttributes = replaceAttributeNames(utility.filterObject(response.data.ModelLevelAttributeList, {Status: 1}));
			}).finally(function () {
				vm.isModelLevelAttributesLoading = false;
			});
		}

		function refreshRequestAttributes(forceFetch, isLogRequired) {
			var generalProperties = {
				forceFetch: forceFetch,
				isLogRequired: isLogRequired
			}
			vm.isRequestAttributesLoading= true;
			vm.requestAttributesModel.methods.getList(generalProperties, catalogId).then(function (response) {
				vm.requestAttributes = replaceAttributeNames(response.data);
				// there is an inconsistancy in the API response of request attributes and getListOf attributes  assigning AttributeId to Attributeid
				angular.forEach(vm.requestAttributes, function(attribute) {
					attribute['Attributeid'] = attribute.AttributeId;
				});

			}).finally(function () {
				vm.isRequestAttributesLoading = false;
			});
		}

		function refreshRequestReasons(forceFetch, isLogRequired) {
			var generalProperties = {
				forceFetch: forceFetch,
				isLogRequired: isLogRequired
			}
			vm.isRequestReasonsLoading= true;
			vm.requestReasonsModel.methods.getList(generalProperties, catalogId).then(function (response) {
				vm.requestReasons = response.data;
			}).finally(function () {
				vm.isRequestReasonsLoading = false;
			});
		}

		function refreshBucketLevelAttributes(forceFetch, isLogRequired) {
			var generalProperties = {
				forceFetch: forceFetch,
				isLogRequired: isLogRequired
			}
			vm.isBucketLevelAttributesLoading = true;
			vm.bucketLevelAttributesModel.methods.getAssignedBucketAttributes(generalProperties, catalogId).then(function (response) {
				vm.bucketLevelAttributes = replaceAttributeNames(response.data);
				// there is an inconsistancy in the API response of bucket attributes and getList of attributes  assigning AttributeId to Attributeid
				angular.forEach(vm.bucketLevelAttributes, function(attribute) {
					attribute['Attributeid'] = attribute.AttributeId;
				});
			}).finally(function () {
				vm.isBucketLevelAttributesLoading = false;
			});
		}

		function refreshRestrictBucketAttributes(forceFetch, isLogRequired) {
			var generalProperties = {
				forceFetch: forceFetch,
				isLogRequired: isLogRequired
			}
			vm.isRestrictBucketAttributesLoading = true;
			vm.restrictBucketAttributesRolesModel.methods.getList(generalProperties, catalogId).then(function (response) {
				vm.restrictBucketAttributes = response.data.Roles;
			}).finally(function () {
				vm.isRestrictBucketAttributesLoading = false;
			});
		}

		function refreshColorDefinitions(forceFetch, isLogRequired) {
			var generalProperties = {
				forceFetch: forceFetch,
				isLogRequired: isLogRequired
			}
			vm.isColorDefinitionsLoading = true;
			vm.colorDefinitionModel.methods.getList(generalProperties, catalogId, vm.colorDefinitionModel).then(function (response) {
				vm.colorDefinitions = response.data;
			}).finally(function () {
				vm.isColorDefinitionsLoading = false;
			});
		}

		function refreshRelationTypes(forceFetch, isLogRequired) {
			var generalProperties = {
				forceFetch: forceFetch,
				isLogRequired: isLogRequired
			}
			vm.isRelationTypesLoading = true;
			vm.relationTypesModel.methods.getList(generalProperties, catalogId, vm.relationTypesModel).then(function (response) {
				vm.relationTypes = response.data;
			}).finally(function () {
				vm.isRelationTypesLoading = false;
			});
		}

		function refreshDatasetDefinitions(forceFetch, isLogRequired) {
			var generalProperties = {
				forceFetch: forceFetch,
				isLogRequired: isLogRequired
			}
			vm.isDatasetDefinitionsLoading = true;
			// Datasets are seller-scoped; list them for the catalog's seller (AccountId).
			vm.datasetDefinitionsModel.methods.getList(generalProperties, vm.sellerId).then(function (response) {
				vm.datasetDefinitions = response.data;
				angular.forEach(vm.datasetDefinitions, function (dataset) {
					if (dataset.Attributes && dataset.Attributes.length) {
						dataset.AttributesIds = dataset.Attributes.map(function (attr) {
							return attr.AttributeId;
						});
					}
				});
			}).finally(function () {
				vm.isDatasetDefinitionsLoading = false;
			});
		}

		function refreshRoleBasedRestrictedSegmentations(forceFetch, isLogRequired) {
			var generalProperties = {
				forceFetch: forceFetch,
				isLogRequired: isLogRequired
			}
			vm.isRoleBasedRestrictedSegmentationsLoading = true;
			vm.roleBasedRestrictSegmentationsModel.methods.getList(generalProperties, catalogId).then(function (response) {
				vm.roleBasedRestrictedSegmentations = response.data.Roles;
			}).finally(function () {
				vm.isRoleBasedRestrictedSegmentationsLoading = false;
			});
		}

		function refreshRoleBasedRestrictedRetailWindows(forceFetch, isLogRequired) {
			var generalProperties = {
				forceFetch: forceFetch,
				isLogRequired: isLogRequired
			}
			vm.isRoleBasedRestrictedRetailWindowsLoading = true;
			vm.roleBasedRestrictRetailWindowsModel.methods.getList(generalProperties, catalogId).then(function (response) {
				vm.roleBasedRestrictedRetailWindows = response.data.Roles;
				// add NotEditable and NotViewable for retail window we are adding one restrict so only one attribute will be available
				angular.forEach(vm.roleBasedRestrictedRetailWindows, function(retailWindow) {
					retailWindow['NotEditable'] = retailWindow.Attributes[0].NotEditable;
					retailWindow['NotViewable'] = retailWindow.Attributes[0].NotViewable;
				});
				// dont show retail windows tab when its restricted on role
				if(!vm.isRetailWindowViewableRestrictedOnRole) {
					var currentUserRoles = $localStorage.profileInformation.Roles;
					angular.forEach(currentUserRoles, function(role) {
							var restrictedRetailWindow = utility.filterObject(vm.roleBasedRestrictedRetailWindows, {RoleId: role.UserRoleId}, true)[0];
							if(angular.isDefined(restrictedRetailWindow) && restrictedRetailWindow.NotViewable) {
								vm.isRetailWindowViewableRestrictedOnRole = true;
							}
					});
				}
			}).finally(function () {
				vm.isRoleBasedRestrictedRetailWindowsLoading = false;
			});
		}

		function refreshColorPalette(forceFetch, isLogRequired) {
			var generalProperties = {
				forceFetch: forceFetch,
				isLogRequired: isLogRequired
			}
			vm.isColorPaletteLoading = true;
			vm.colorPaletteModel.methods.getList(generalProperties, catalogId)
				.then(function(response) {
					vm.colorPalette = response.data;
				})
				.finally(function() {
					vm.isColorPaletteLoading = false;
				});
		}

		function doCatalogItemAction(action, record) {
			if (action) {
				switch (action.id) {
					case 'delete':
					case 'activate':
						vm.model.methods.activateBulk(record, vm.model, action.id, undefined)
							.then(function () {
								if (!isTabDataInitialized && action.id === 'activate') {
									initializeTabData(true);
								}
							});
						break;
					case 'stopOrders':
					case 'allowOrders':
						vm.model.methods.updateReceiveOrdersStatus(record, vm.model, action.id);
						break;
					case 'manageContext':
						var modelCopy = angular.copy(vm.model);
						// make creatable false to all fields except duneContext
						angular.forEach(modelCopy.fields, function( field) {
							if(field.field !== 'DuneContext' && field.editable) {
								field.editable = false;
							} else if(field.field === 'DuneContext' && !field.visible) {
								field.editable = true;
							}
						});
						var additionalInfo = { 'additionalAction': 'manageDuneContext'};

						api.showEditRecordDialog(angular.element($document.body), null, modelCopy, record, undefined, undefined, additionalInfo)
							.then(function (saved) {
								if (saved) {
									refreshRecords();
								}
							});
						break;
					case 'disableRequests':
					case 'enableRequests':
						vm.model.methods.updateReceiveRequestsStatus(record, vm.model, action.id);
						break;
				}
			}
		}

		function editItem(record, ev) {
			var lookupPromises = {};
			lookupPromises = crud.createLookupPromise(vm.model, undefined, 'edit');
			return $mdDialog.show({
				controller: 'createCatalogController',
				controllerAs: 'vm',
				templateUrl: 'app/main/catalogs/dialogs/create-catalog.html',
				parent: angular.element($document.body),
				targetEvent: ev,
				clickOutsideToClose: false,
				locals: {
					isCopyCatalog: false,
					model: angular.copy(vm.model),
					record: angular.copy(record),
					existingRecordsForUniqueValue: [],
					lookupPromises: lookupPromises,
					event: ev
				}
			}).then(function (saved) {
				if (saved) {
					refreshRecords();
				}
			});
		}

		function doLinkedCatalogsItemAction(action, item) {
			if (action) {
				switch (action.id) {
					case 'view':
						vm.viewLinkedCatalog(item);
						break;
				}
			}
		}

		function viewLinkedCatalog(item) {
			var id = item[vm.linkedCatalogsModel.idField];
			var stateParams = { id: id, dataSourceTypeId: item.DataSourceTypeId };
			$state.go('app.catalogs.details', stateParams);
		}

		function doLinkedAttributesItemAction(action, item) {
			if (action) {
				switch (action.id) {
					case 'view':
						viewLinkedAttribute(item);
						break;
					case 'editable':
					case 'nonEditable':
						vm.linkedAttributesModel.methods.activateBulk(item, vm.linkedAttributesModel, action.id, catalogId).then(function () {
							refreshRecords();
							updateActiveCatalogInCatalogFactory();
						});
						break;
				}
			}
		}

		function doLinkedAttributesListAction(action, records) {
			if (action) {
				switch (action.id) {
					case 'editable':
					case 'nonEditable':
						vm.linkedAttributesModel.methods.activateBulk(records, vm.linkedAttributesModel, action.id, catalogId).then(function () {
							refreshRecords();
							updateActiveCatalogInCatalogFactory();
						});
						break;
				}
			}
		}

		function viewLinkedAttribute(item) {
			var id = item['AttributeId'];
			$state.go('app.attributes_list.details', { id: id });
		}

		function doTargetedAttributesItemAction(action, item) {
			if (action) {
				switch (action.id) {
					case 'view':
						viewTargetedAttribute(item);
						break;
				}
			}
		}

		function viewTargetedAttribute(item) {
			var id = item[vm.targetedAttributesModel.idField];
			$state.go('app.attributes_list.details', { id: id });
		}

		function doAttributesItemAction(action, record) {
			if (action) {
				switch (action.id) {
					case 'view':
						viewAttribute(record);
						break;
					case 'updateSorting':
						editAttributeSortOrder(record);
						break;
				}
			}
		}

		function viewAttribute(record) {
			var id = record[vm.attributesModel.idField];
			$state.go('app.attributes_list.details', { id: id });
		}

		function editAttributeSortOrder(record) {
			$mdDialog.show({
				controller: 'sortAttributesController',
				controllerAs: 'vm',
				templateUrl: 'app/main/catalogs/dialogs/sort-attributes.html',
				parent: angular.element($document.body),
				targetEvent: null,
				clickOutsideToClose: false,
				locals: {
					model: vm.attributesModel,
					records: [record],
					event: null,
					catalogCode: catalogId,
					sellerAccountId: vm.catalog.AccountId,
					attributeGroupId: vm.catalog.AttributeGroupId,
				}
			}).then(function (saved) {
				if (saved) {
					refreshRecords()
					refreshAttributes(true, false);
				}
			});
		}

		function doAttributesListAction(action, items) {
			if (action) {
				switch (action.id) {
					case 'updateSorting':
						return $mdDialog.show({
							controller: 'sortAttributesController',
							controllerAs: 'vm',
							templateUrl: 'app/main/catalogs/dialogs/sort-attributes.html',
							parent: angular.element($document.body),
							targetEvent: null,
							clickOutsideToClose: false,
							locals: {
								model: vm.attributesModel,
								records: items,
								event: null,
								catalogCode: catalogId,
								sellerAccountId: vm.catalog.AccountId,
								attributeGroupId: vm.catalog.AttributeGroupId,
							}
						}).then(function (saved) {
							if (saved) {
								refreshRecords()
								refreshAttributes(true, false);
							}
						});
						break;
				}
			}
		}

		function doRoleBasedRestrictedAttributesItemAction(action, record) {
			if (action && record) {
				switch (action.id) {
					case 'view':
						viewRoleBasedAttributeRestriction(record, null);
						break;
					case 'edit':
						addOrUpdateAttributeRoleBasedRestriction(null, record);
						break;
					case 'delete':
						vm.roleBasedRestrictAttributesModel.methods.deleteBulk(record, vm.roleBasedRestrictAttributesModel, action.id, catalogId).then(function () {
							refreshRoleBasedRestrictedAttributes(true, false);
							updateActiveCatalogInCatalogFactory();
						});
						break;
				}
			}
		}

		function doRoleBasedRestrictedAttributesListAction(action, records) {
			if (action) {
				switch (action.id) {
					case 'delete':
						vm.roleBasedRestrictAttributesModel.methods.deleteBulk(records, vm.roleBasedRestrictAttributesModel, action.id, catalogId).then(function () {
							refreshRoleBasedRestrictedAttributes(true, false);
							updateActiveCatalogInCatalogFactory();
						});
						break;
				}
			}
		}

		function viewRoleBasedAttributeRestriction(record, ev) {
			$mdDialog.show({
				controller         : 'viewRoleBasedAttributeRestrictionController',
				controllerAs       : 'vm',
				templateUrl        : 'app/main/catalogs/details/tabs/restrict-attributes/dialogs/view-restricted-attributes/view-restricted-attributes.html',
				parent             : angular.element($document.body),
				targetEvent        : null,
				clickOutsideToClose: false,
				locals             : {
						event : ev,
						model : api.catalogs.restrictedAttributes,
						data  : replaceAttributeNames(record.Attributes)
				}
			});
		}

		function addOrUpdateAttributeRoleBasedRestriction(ev, record) {
			var rolesModel = api.roles.roles;
			var promises = {};
			var generalProperties = {
				forceFetch: true,
				isLogRequired: false
			}
			promises['rolesPromise'] = rolesModel.methods.getList(generalProperties);
			promises['catalogAttributesPromise'] = vm.attributesModel.methods.getList(generalProperties, catalogId);
			$mdDialog.show({
				controller: 'addOrUpdateAttributeRestrictionController',
				controllerAs: 'vm',
				templateUrl: 'app/main/catalogs/details/tabs/restrict-attributes/dialogs/add-update-restricted-attributes/add-update-restricted-attributes.html',
				parent: angular.element($document.body),
				targetEvent: ev,
				clickOutsideToClose: false,
				locals: {
					record: record,
					isNew: angular.isDefined(record)? false: true,
					model: vm.roleBasedRestrictAttributesModel,
					promises: promises,
					assignedRolesList: vm.roleBasedRestrictedAttributes,
					activeCatalogCode: catalogId,
					event: ev
				}
			}).then(function(saved) {
				if (saved) {
					refreshRoleBasedRestrictedAttributes(true, false);
					updateActiveCatalogInCatalogFactory();
				}
			});
		}

		function doRoleBasedRestrictedSegmentationsItemAction(action, record) {
			if (action && record) {
				switch (action.id) {
					case 'view':
						viewRoleBasedSegmentationRestriction(record, null);
						break;
					case 'edit':
						addOrUpdateSegmentationRoleBasedRestriction(null, record);
						break;
					case 'delete':
						vm.roleBasedRestrictSegmentationsModel.methods.deleteBulk(record, vm.roleBasedRestrictSegmentationsModel, action.id, catalogId).then(function () {
							refreshRoleBasedRestrictedSegmentations(true, false);
							updateActiveCatalogInCatalogFactory();
						});
						break;
				}
			}
		}

		function doRoleBasedRestrictedSegmentationsListAction(action, records) {
			if (action) {
				switch (action.id) {
					case 'delete':
						vm.roleBasedRestrictSegmentationsModel.methods.deleteBulk(records, vm.roleBasedRestrictSegmentationsModel, action.id, catalogId).then(function () {
							refreshRoleBasedRestrictedSegmentations(true, false);
							updateActiveCatalogInCatalogFactory();
						});
						break;
				}
			}
		}

		function viewRoleBasedSegmentationRestriction(record, ev) {
			$mdDialog.show({
				controller         : 'viewRoleBasedSegmantationsRestrictionController',
				controllerAs       : 'vm',
				templateUrl        : 'app/main/catalogs/details/tabs/restrict-segmentations/dialogs/view-restricted-segmentations/view-restricted-segmentations.html',
				parent             : angular.element($document.body),
				targetEvent        : null,
				clickOutsideToClose: false,
				locals             : {
						event : ev,
						model : api.catalogs.restrictedSegmentations,
						data  : record.Segmentations
				}
			});
		}

		function addOrUpdateSegmentationRoleBasedRestriction(ev, record) {
			var rolesModel = api.roles.roles;
			var promises = {};
			var generalProperties = {
				forceFetch: true,
				isLogRequired: false
			}
			promises['rolesPromise'] = rolesModel.methods.getList(generalProperties);
			promises['catalogSegmentationsPromise'] = vm.segmentationsModel.methods.getList(generalProperties, catalogId);
			$mdDialog.show({
				controller: 'addUpdateRoleBasedSegmantationsRestrictionController',
				controllerAs: 'vm',
				templateUrl: 'app/main/catalogs/details/tabs/restrict-segmentations/dialogs/add-update-restricted-segmentations/add-update-restricted-segmentations.html',
				parent: angular.element($document.body),
				targetEvent: ev,
				clickOutsideToClose: false,
				locals: {
					record: record,
					isNew: angular.isDefined(record)? false: true,
					model: vm.roleBasedRestrictSegmentationsModel,
					promises: promises,
					assignedRolesList: vm.roleBasedRestrictedSegmentations,
					activeCatalogCode: catalogId,
					event: ev
				}
			}).then(function(saved) {
				if (saved) {
					refreshRoleBasedRestrictedSegmentations(true, false);
					updateActiveCatalogInCatalogFactory();
				}
			});
		}

		function doRoleBasedRestrictedRetailWindowsItemAction(action, record) {
			if (action && record) {
				switch (action.id) {
					case 'edit':
						addOrUpdateRetailWindowRoleBasedRestriction(null, record);
						break;
					case 'delete':
						vm.roleBasedRestrictRetailWindowsModel.methods.deleteBulk(record, vm.roleBasedRestrictRetailWindowsModel, action.id, catalogId).then(function () {
							refreshRoleBasedRestrictedRetailWindows(true, false);
							updateActiveCatalogInCatalogFactory();
						});
						break;
				}
			}
		}

		function doRoleBasedRestrictedRetailWindowsListAction(action, records) {
			if (action) {
				switch (action.id) {
					case 'delete':
						vm.roleBasedRestrictRetailWindowsModel.methods.deleteBulk(records, vm.roleBasedRestrictRetailWindowsModel, action.id, catalogId).then(function () {
							refreshRoleBasedRestrictedRetailWindows(true, false);
							updateActiveCatalogInCatalogFactory();
						});
						break;
				}
			}
		}

		function addOrUpdateRetailWindowRoleBasedRestriction(ev, record) {
			var rolesModel = api.roles.roles;
			var promises = {};
			var generalProperties = {
				forceFetch: true,
				isLogRequired: false
			}
			promises['rolesPromise'] = rolesModel.methods.getList(generalProperties);
			$mdDialog.show({
				controller: 'addOrUpdateRetailWindowsRestrictionController',
				controllerAs: 'vm',
				templateUrl: 'app/main/catalogs/details/tabs/restrict-retail-windows/dialogs/add-update-restricted-retail-windows/add-update-restricted-retail-windows.html',
				parent: angular.element($document.body),
				targetEvent: ev,
				clickOutsideToClose: false,
				locals: {
					record: record,
					isNew: angular.isDefined(record)? false: true,
					model: vm.roleBasedRestrictRetailWindowsModel,
					promises: promises,
					assignedRolesList: vm.roleBasedRestrictedRetailWindows,
					activeCatalogCode: catalogId,
					event: ev
				}
			}).then(function(saved) {
				if (saved) {
					refreshRoleBasedRestrictedRetailWindows(true, false);
					updateActiveCatalogInCatalogFactory();
				}
			});
		}

		function doConfigurationsItemAction(action, item) {
			if (action && item) {
				switch (action.id) {
					case 'edit':
						editConfiguration(item, null);
						break;
					case 'delete':
						vm.configurationsModel.methods.delete(item, action.id, catalogId)
							.then(function () {
								utility.substrateList(vm.configurations, item, vm.configurationsModel);
								if (vm.dataTableControles && vm.dataTableControles.updateData && angular.isFunction(vm.dataTableControles.updateData)) {
									vm.dataTableControles.updateData();
								}
							});
							updateActiveCatalogInCatalogFactory();
						break;
				}
			}
		}

		function doAttributeVettingListItemAction(action, item) {
			if (action && item) {
				switch (action.id) {
					case 'edit':
						editAttributeVettingList(item, null);
						break;
				}
			}
		}

		function doAttributeVettingListAction(action, items) {
			if (action) {
				switch (action.id) {
					case 'import':
						var modelCopy = angular.copy(vm.attributeVettingListModel);
						angular.forEach(modelCopy.fields, function (field) {
							if (field.field === 'AttributeSystemName') {
								field.validation.dataExistConstraints = { data: vm.attributes };
							}
							if (field.field === 'AttributeId') {
								field.creatable = false;
							}
							if (field.field === 'Values') {
								field.validation.isRequired = true;
								field.validation.minLen = 1;
							}
						});
						modelCopy.uniqueConstraints = [{ name: 'Constraint 1', fields: ['AttributeSystemName'] }];
						dataImporter.importExcel(modelCopy, true).then(function (result) {
							vm.attributeVettingListModel.methods.createBulk(vm.attributeVettingListModel, vm.attributes, result.data, catalogId);
						});
						break;
				}
			}
		}

		function addAttributeToAttributeVettingList(ev) {
			api.showCreateRecordDialog(angular.element($document.body), ev, vm.attributeVettingListModel, catalogId, undefined, { 'catalogs.attributes': { 'id1': catalogId } }, undefined, vm.attributeVettingList)
				.then(function (saved) {
					if (saved) {
						refreshAttributeVettingList(true, false);
					}
				});
		}


		function editAttributeVettingList(item, ev) {
			api.showEditRecordDialog(angular.element($document.body), ev, vm.attributeVettingListModel, item, catalogId)
				.then(function (saved) {
					if (saved) {
						refreshAttributeVettingList(true, false);
					}
				});
		}

		function doConfigurationsListAction(action, items) {
			if (action) {
				switch (action.id) {
					case 'delete':
						vm.configurationsModel.methods.delete(items, action.id, catalogId)
							.then(function () {
								utility.substrateList(vm.configurations, items, vm.configurationsModel);
								if (vm.dataTableControles && vm.dataTableControles.updateData && angular.isFunction(vm.dataTableControles.updateData)) {
									vm.dataTableControles.updateData();
								}
							});
							updateActiveCatalogInCatalogFactory();
						break;
					case 'import':
						dataImporter.importExcel(api.catalogs.importConfigurations, true).then(function (result) {
							vm.configurationsModel.methods.createBulk(api.catalogs.importConfigurations, result.data, catalogId);
						});
						updateActiveCatalogInCatalogFactory();
						break;
				}
			}
		}

		function addConfiguration(ev) {
			$mdDialog.show({
				controller: 'createCatalogConfigurationController',
				controllerAs: 'vm',
				templateUrl: 'app/main/catalogs/details/tabs/configurations/dialogs/update-configuration.html',
				parent: angular.element($document.body),
				targetEvent: ev,
				clickOutsideToClose: false,
				locals: {
					model: vm.configurationsModel,
					record: {},
					catalogCode: catalogId,
					isNew: true,
					event: ev
				}
			}).then(function (saved) {
				if (saved) {
					refreshConfigurations(true, false);
					updateActiveCatalogInCatalogFactory();
				}
			});
		}

		function editConfiguration(record, ev) {
			$mdDialog.show({
				controller: 'createCatalogConfigurationController',
				controllerAs: 'vm',
				templateUrl: 'app/main/catalogs/details/tabs/configurations/dialogs/update-configuration.html',
				parent: angular.element($document.body),
				targetEvent: ev,
				clickOutsideToClose: false,
				locals: {
					model: vm.configurationsModel,
					record: record,
					catalogCode: catalogId,
					isNew: false,
					event: ev
				}
			}).then(function (saved) {
				if (saved) {
					refreshConfigurations(true, false);
					updateActiveCatalogInCatalogFactory();
				}
			});
		}

		function doCRDItemAction(action, record) {
			if (action && record) {
				switch (action.id) {
					case 'edit':
						editCRD(record, null);
						break;
					case 'delete':
					case 'activate':
						vm.CRDModel.methods.activateBulk(record, vm.CRDModel, action.id, catalogId).then(function () {
							// refreshRecords();
							updateActiveCatalogInCatalogFactory();
						});
						break;
				}
			}
		}

		function doCRDListAction(action, records) {
			if (action) {
				switch (action.id) {
					case 'delete':
					case 'activate':
						vm.CRDModel.methods.activateBulk(records, vm.CRDModel, action.id, catalogId).then(function () {
							// refreshRecords();
							updateActiveCatalogInCatalogFactory();
						});
						break;
					case 'import':
						var modelCopy = angular.copy(vm.CRDModel);
						var descriptionField = utility.filterObject(modelCopy.fields, { field: 'Description' }, true)[0];
						descriptionField.validation.dataExistConstraints.data = vm.CRD;
						dataImporter.importExcel( modelCopy, true).then(function(result) {
							vm.CRDModel.methods.createBulk(result.data, catalogId, vm.CRDModel);
						});
						updateActiveCatalogInCatalogFactory();
						break;
				}
			}
		}

		function addCRD(ev) {
			api.showCreateRecordDialog(angular.element($document.body), ev, vm.CRDModel, catalogId, { Availability: 1 })
				.then(function (saved) {
					if (saved) {
						refreshCRDs(true, false);
						updateActiveCatalogInCatalogFactory();
					}
				});
		}

		function editCRD(item, ev) {
			//convert date string to date object to prepopulate date picker
			var itemCopy = angular.copy(item);
			itemCopy.CustomerRequiredDate = utility.createDateObject(itemCopy.CustomerRequiredDate);
			api.showEditRecordDialog(angular.element($document.body), ev, vm.CRDModel, itemCopy, catalogId)
				.then(function (saved) {
					if (saved) {
						refreshCRDs(true, false);
						updateActiveCatalogInCatalogFactory();
					}
				});
		}

		function doShipmentWindowsItemAction(action, record) {
			if (action && record) {
				switch (action.id) {
					case 'edit':
						editShipmentWindow(record, null);
						break;
					case 'delete':
					case 'activate':
						vm.shipmentWindowsModel.methods.activateBulk(record, vm.shipmentWindowsModel, action.id, catalogId).then(function () {
							refreshShipmentWindows(true);
							updateActiveCatalogInCatalogFactory();
						});
						break;
				}
			}
		}

		function doShipmentWindowsListAction(action, records) {
			if (action) {
				switch (action.id) {
					case 'import':
						var modelCopy = angular.copy(vm.shipmentWindowsModel);
						var retailIntroMonthField = utility.filterObject(modelCopy.fields, { field: 'RetailIntroMonth' }, true)[0];
						retailIntroMonthField.validation.maxLen = 30;
						retailIntroMonthField.validation.pattern = '';
						var retailExitMonthField = utility.filterObject(modelCopy.fields, { field: 'RetailExitMonth' }, true)[0];
						retailExitMonthField.validation.maxLen = 30;
						retailExitMonthField.validation.pattern = '';
						var statusField = utility.filterObject(modelCopy.fields, { field: 'Status' }, true)[0];
						statusField.creatable = true;
						dataImporter.importExcel(modelCopy, true).then(function (result) {
							vm.shipmentWindowsModel.methods.createBulk(vm.shipmentWindowsModel, result.data, catalogId);
						});
						break;
					case 'delete':
					case 'activate':
						vm.shipmentWindowsModel.methods.activateBulk(records, vm.shipmentWindowsModel, action.id, catalogId).then(function () {
							refreshShipmentWindows(true);
							updateActiveCatalogInCatalogFactory();
						});
						break;
				}
			}
		}

		function addShipmentWindow(ev) {
			api.showCreateRecordDialog(angular.element($document.body), ev, vm.shipmentWindowsModel, catalogId)
				.then(function (saved) {
					if (saved) {
						refreshShipmentWindows(true);
						updateActiveCatalogInCatalogFactory();
					}
				});
		}

		function editShipmentWindow(item, ev) {
			item.RetailIntroMonth = item.RetailIntroMonth.toString().trim().substring(0,3);
			item.RetailExitMonth = item.RetailExitMonth.toString().trim().substring(0,3);

			api.showEditRecordDialog(angular.element($document.body), ev, vm.shipmentWindowsModel, item, catalogId)
				.then(function (saved) {
					if (saved) {
						refreshShipmentWindows(true);
						updateActiveCatalogInCatalogFactory();
					}
				});
		}

		function doPriceGroupItemAction(action, record) {
			if (action && record) {
				switch (action.id) {
					case 'edit':
						editPriceGroup(record, null);
						break;
					case 'delete':
					case 'activate':
						vm.priceGroupModel.methods.activateBulk(record, vm.priceGroupModel, action.id, catalogId).then(function () {
							refreshRecords();
							updateActiveCatalogInCatalogFactory();
						});
						break;
				}
			}
		}

		function doPriceGroupListAction(action, records) {
			if (action) {
				switch (action.id) {
					case 'delete':
					case 'activate':
						vm.priceGroupModel.methods.activateBulk(records, vm.priceGroupModel, action.id, catalogId).then(function () {
							refreshRecords();
							updateActiveCatalogInCatalogFactory();
						});
						break;
				}
			}
		}

		function addPriceGroup(ev) {
			api.showCreateRecordDialog(angular.element($document.body), ev, vm.priceGroupModel, catalogId)
				.then(function (saved) {
					if (saved) {
						refreshRecords();
						updateActiveCatalogInCatalogFactory();
					}
				});
		}

		function editPriceGroup(item, ev) {
			api.showEditRecordDialog(angular.element($document.body), ev, vm.priceGroupModel, item, catalogId)
				.then(function (saved) {
					if (saved) {
						refreshRecords();
						updateActiveCatalogInCatalogFactory();
					}
				});
		}

		function doSegmentationsItemAction(action, record) {
			if (action && record) {
				switch (action.id) {
					case 'edit':
						editSegmentations(record, null);
						break;
					case 'delete':
					case 'activate':
						vm.segmentationsModel.methods.activateBulk(record, vm.segmentationsModel, action.id, catalogId).then(function () {
							refreshSegmentations();
							updateActiveCatalogInCatalogFactory();
						});
						break;
				}
			}
		}

		function doSegmentationsListAction(action, records) {
			if (action) {
				switch (action.id) {
					case 'delete':
					case 'activate':
						vm.segmentationsModel.methods.activateBulk(records, vm.segmentationsModel, action.id, catalogId).then(function () {
							refreshRecords();
							updateActiveCatalogInCatalogFactory();
						});
						break;
					case 'import':
						var modelCopy = angular.copy(vm.segmentationsModel);
						var parentSegmentationIdField = utility.filterObject(modelCopy.fields, {field: 'ParentSegmentationId'}, true)[0];
						parentSegmentationIdField.creatable = false;
						if(vm.catalog.DataSourceTypeId === 3) {
							var parentSegmentationNameField = utility.filterObject(modelCopy.fields, {field: 'ParentSegmentationName'}, true)[0];
							parentSegmentationNameField.creatable = true;
						}
						dataImporter.importExcel(modelCopy, true).then(function (result) {
							modelCopy.methods.createBulk(modelCopy, result.data, catalogId);
						});
						updateActiveCatalogInCatalogFactory();
						break;
				}
			}
		}

		function editSegmentations(item, ev) {
			var lookupExtras = {};
			var modelCopy = angular.copy(vm.segmentationsModel);
			if(vm.catalog.DataSourceTypeId === 3) {
				lookupExtras['catalogs.segmentations'] = {};
				lookupExtras['catalogs.segmentations']['id1'] = vm.catalog.ReferenceCatalogCode;
			} else {
				var parentSegmentationIdField = utility.filterObject(modelCopy.fields, {field: 'ParentSegmentationId'}, true)[0];
				parentSegmentationIdField.editable = false;
			}
			api.showEditRecordDialog(angular.element($document.body), ev, modelCopy, item, catalogId, lookupExtras)
				.then(function (saved) {
					if (saved) {
						refreshRecords();
						updateActiveCatalogInCatalogFactory();
					}
				});
		}

		function addSegmentation(ev) {
			var lookupExtras = {};
			var modelCopy = angular.copy(vm.segmentationsModel);
			if(vm.catalog.DataSourceTypeId === 3) {
				lookupExtras['catalogs.segmentations'] = {};
				lookupExtras['catalogs.segmentations']['id1'] = vm.catalog.ReferenceCatalogCode;
			} else {
				var parentSegmentationIdField = utility.filterObject(modelCopy.fields, {field: 'ParentSegmentationId'}, true)[0];
				parentSegmentationIdField.creatable = false;
			}
			api.showCreateRecordDialog(angular.element($document.body), ev, modelCopy, catalogId, undefined, lookupExtras)
				.then(function (saved) {
					if (saved) {
						refreshRecords();
						updateActiveCatalogInCatalogFactory();
					}
				});
		}

		function doSegmentationGroupItemAction(action, record) {
			if (action && record) {
				switch (action.id) {
					case 'edit':
						editSegmentationGroup(record, null);
						break;
					case 'delete':
					case 'activate':
						vm.segmentationGroupModel.methods.activateBulk(record, vm.segmentationGroupModel, action.id, catalogId).then(function () {
							refreshRecords();
							updateActiveCatalogInCatalogFactory();
						});
						break;
				}
			}
		}

		function doSegmentationGroupListAction(action, records) {
			if (action) {
				switch (action.id) {
					case 'delete':
					case 'activate':
						vm.segmentationGroupModel.methods.activateBulk(records, vm.segmentationGroupModel, action.id, catalogId).then(function () {
							refreshRecords();
							updateActiveCatalogInCatalogFactory();
						});
						break;
				}
			}

		}

		function editSegmentationGroup(item, ev) {
			//populate fields
			item['SegmentationidsList'] = [];
			var segmentationsList = item.Segmentations.split(',');
			if (vm.allSegmentationsCopy && vm.allSegmentationsCopy.length > 0) {
				angular.forEach(vm.allSegmentationsCopy, function (segmentation) {
					if (segmentationsList.indexOf(segmentation.Name) != -1) {
						item['SegmentationidsList'].push(segmentation.Id);
					}
				})
			}
			var existingRecordsForUniqueValue = angular.copy(vm.segmentationGroup);
			for (var i = 0; i < existingRecordsForUniqueValue.length; i++) {
				if (existingRecordsForUniqueValue[i].Id === item.Id) {
					existingRecordsForUniqueValue.splice(i, 1);
				}
			}
			$mdDialog.show({
				controller: 'updateSegmentationGroupsController',
				controllerAs: 'vm',
				templateUrl: 'app/main/catalogs/details/tabs/segmentation-group/dialogs/update-segmentation-groups/update-segmentation-groups.html',
				parent: angular.element($document.body),
				targetEvent: ev,
				clickOutsideToClose: false,
				locals: {
					model: vm.segmentationGroupModel,
					record: item,
					isNew: false,
					existingRecordsForUniqueValue: existingRecordsForUniqueValue,
					segmentations: vm.segmentations,
					roleBasedRestrictedSegmentations: catalogFactory.getCurrentRoleRestrictedSegmentationAndFormatToDesiredObjectArray(vm.roleBasedRestrictedSegmentations),
					catalogCode: catalogId,
					event: ev
				}
			}).then(function (saved) {
				if (saved) {
					refreshRecords();
					updateActiveCatalogInCatalogFactory();
				}
			});
		}

		function addSegmentationGroup(ev) {
			$mdDialog.show({
				controller: 'updateSegmentationGroupsController',
				controllerAs: 'vm',
				templateUrl: 'app/main/catalogs/details/tabs/segmentation-group/dialogs/update-segmentation-groups/update-segmentation-groups.html',
				parent: angular.element($document.body),
				targetEvent: ev,
				clickOutsideToClose: false,
				locals: {
					model: vm.segmentationGroupModel,
					record: null,
					isNew: true,
					existingRecordsForUniqueValue: angular.copy(vm.segmentationGroup),
					segmentations: vm.segmentations,
					roleBasedRestrictedSegmentations: catalogFactory.getCurrentRoleRestrictedSegmentationAndFormatToDesiredObjectArray(vm.roleBasedRestrictedSegmentations),
					catalogCode: catalogId,
					event: ev
				}
			}).then(function (saved) {
				if (saved) {
					refreshRecords();
					updateActiveCatalogInCatalogFactory();
				}
			});
		}

		function doSizeScaleGroupsListAction(action, records) {
			if (action) {
				switch (action.id) {
					case 'import':
						//TODO
						break;
				}
			}
		}

		function doStockDefinitionItemAction(action, record) {
			if (action) {
				switch (action.id) {
					case 'delete':
					case 'activate':
						vm.stockDefinitionModel.methods.activateBulk(record, vm.stockDefinitionModel, action.id, catalogId).then(function () {//to do check catalog Id and catalogCode diff
							refreshRecords();
						});
						break;
					case 'edit':
						editStockDefinition(record, null);
						break;
				}
			}
		}

		function doStockDefinitionListAction(action, records) {
			if (action) {
				switch (action.id) {
					case 'delete':
					case 'activate':
						vm.stockDefinitionModel.methods.activateBulk(records, vm.stockDefinitionModel, action.id, catalogId).then(function () {//to do check catalog Id and catalogCode diff
							refreshRecords();
						});
						break;
				}
			}
		}

		function editStockDefinition(record, ev) {
			api.showEditRecordDialog(angular.element($document.body), ev, vm.stockDefinitionModel, record, catalogId)
				.then(function (saved) {
					if (saved) {
						refreshStockDefinitions(true, false);
					}
				});
		}

		function addStockDefinition(ev) {
			api.showCreateRecordDialog(angular.element($document.body), ev, vm.stockDefinitionModel, catalogId)
				.then(function (saved) {
					if (saved) {
						refreshStockDefinitions(true, false);
					}
				});
		}

		function doTreeListAction(action, records) {
			switch (action.id) {
				case 'delete':
				case 'activate':
					vm.treeModel.methods.activateBulk(records, vm.treeModel, action.id, catalogId).then(function () {
						refreshTree();
					});
					break;
			}
		}

		function doTreeItemAction(action, record) {
			switch (action.id) {
				case 'delete':
				case 'activate':
					vm.treeModel.methods.activateBulk(record, vm.treeModel, action.id, catalogId).then(function () {
						refreshTree();
					});
					break;
				case 'edit':
					editTree(record, null);
					break;
				case 'view':
					viewCatalogTree(record);
					break;
			}
		}

		function addTree(ev) {
			$mdDialog.show({
				controller: 'createTreeController',
				controllerAs: 'vm',
				templateUrl: 'app/main/catalogs/details/tabs/tree-definition/dialogs/create-tree/create-tree.html',
				parent: angular.element($document.body),
				targetEvent: ev,
				clickOutsideToClose: false,
				locals: {
					model: vm.treeModel,
					record: null,
					isNew: true,
					event: ev,
					catalogAttributes: vm.attributes,
					catalogId: catalogId,
					existingRecordsForUniqueValue: angular.copy(vm.treeData)
				}
			}).then(function (saved) {
				if (saved) {
					refreshTree(true, false);
					updateActiveCatalogInCatalogFactory();
				}
			});
		}

		function editTree(record, ev) {
			var existingRecordsForUniqueValue = angular.copy(vm.treeData);
			for (var i = 0; i < existingRecordsForUniqueValue.length; i++) {
				if(existingRecordsForUniqueValue[i].Id === record.Id) {
					existingRecordsForUniqueValue.splice(i, 1);
				}
			}
			$mdDialog.show({
				controller         : 'createTreeController',
				controllerAs       : 'vm',
				templateUrl        : 'app/main/catalogs/details/tabs/tree-definition/dialogs/create-tree/create-tree.html',
				parent             : angular.element($document.body),
				targetEvent        : ev,
				clickOutsideToClose: false,
				locals             : {
						model: vm.treeModel,
						record: record,
						isNew: false,
						event: ev,
						catalogAttributes: vm.attributes,
						catalogId: catalogId,
						existingRecordsForUniqueValue: existingRecordsForUniqueValue
				}
			}).then(function(saved) {
					if (saved) {
						refreshTree(true, false);
						updateActiveCatalogInCatalogFactory();
					}
			});
		}

		function viewCatalogTree(record) {
			var stateParams = { treeDefinition: [record], catalog: vm.catalog };
			$state.go('app.tree', stateParams);
		}

		// assign tab index for each tab
		function onActiveTabChange(tabIndex) {
			vm.tabIndex = tabIndex;
		}

		function assignModelLevelAttributes(ev) {
			$mdDialog.show({
				controller         : 'assignModelLevelAttributesController',
				controllerAs       : 'vm',
				templateUrl        : 'app/main/catalogs/details/tabs/model-level-attributes/dialogs/assign-model-level-attributes.html',
				parent             : angular.element($document.body),
				targetEvent        : ev,
				clickOutsideToClose: false,
				locals             : {
					activeCatalogId: catalogId,
					model: vm.modelLevelAttributesModel,
					assignedAttributes: angular.copy(utility.filterObject(vm.modelLevelAttributes, {IsSeasonlessModelAttribute: 0})),
					allAttributes: angular.copy(utility.filterObject(vm.attributes, {AttributeSource: 'Self', IsSeasonlessModelAttribute: 0, IsSeasonless: 0})),
					event: ev
				}
			}).then(function(saved) {
				if (saved) {
					refreshModelLevelAttributes(false);
					updateActiveCatalogInCatalogFactory();
				}
			});
		}


		function doRequestAttributeItemAction(action, record) {
			if (action && record) {
				switch (action.id) {
					case 'delete':
					case 'activate':
						vm.requestAttributesModel.methods.activateBulk(record, vm.requestAttributes, action.id, catalogId).then(function () {
							refreshRequestAttributes(true, false);
							updateActiveCatalogInCatalogFactory();
						});
						break;
				}
			}
		}

		function doRequestAttributeListAction(action, records) {
			if (action) {
				switch (action.id) {
					case 'delete':
					case 'activate':
						vm.requestAttributesModel.methods.activateBulk(records, vm.requestAttributes, action.id, catalogId).then(function () {
							refreshRequestAttributes(true, false);
							updateActiveCatalogInCatalogFactory();
						});
						break;
				}
			}
		}

		function assignRequestAttributes(ev) {
			// add assigned request attribuites id's to AttributeidsList
			var record = {};
			var activeRequestAttributes = utility.filterObject(vm.requestAttributes, {'Status': 1}, true);

			var lookupExtras = {};
			lookupExtras['catalogs.availableAttributeForRequestAttribute'] = {};
			lookupExtras['catalogs.availableAttributeForRequestAttribute']['id1'] = catalogId;
			record.AttributeidsList = activeRequestAttributes.map(function(record) {
				var attributeId = angular.isDefined(record['Attributeid']) ? record['Attributeid'] : record['AttributeId'];
				return attributeId;
			});
			api.showEditRecordDialog(angular.element($document.body), ev, vm.requestAttributesModel, record, catalogId, lookupExtras)
			.then(function(saved) {
				if (saved) {
					refreshRequestAttributes(true, false);
					updateActiveCatalogInCatalogFactory();
				}
			});
		}

		function doRequestReasonsItemAction(action, record) {
			if (action && record) {
				switch (action.id) {
					case 'edit':
						editRequestReasons(record, null);
						break;
					case 'delete':
					case 'activate':
						vm.requestReasonsModel.methods.activateBulk(record, vm.requestReasonsModel, action.id, catalogId).then(function () {
							refreshRequestReasons(true, false);
							updateActiveCatalogInCatalogFactory();
						});
						break;
				}
			}
		}

		function doRequestReasonsListAction(action, records) {
			if (action) {
				switch (action.id) {
					case 'delete':
					case 'activate':
						vm.requestReasonsModel.methods.activateBulk(records, vm.requestReasonsModel, action.id, catalogId).then(function () {
							refreshRequestReasons(true, false);
							updateActiveCatalogInCatalogFactory();
						});
						break;
					case 'import':
						var modelCopy = angular.copy(vm.requestReasonsModel);
						// importer's required-empty check only fires when minLen > 0
						utility.filterObject(modelCopy.fields, { field: 'RequestType' }, true)[0].validation.minLen = 1;
						utility.filterObject(modelCopy.fields, { field: 'Reason' }, true)[0].validation.minLen = 1;
						// flag in-file duplicates on the (Reason, RequestType, Type) combination
						modelCopy.uniqueConstraints = [{ name: 'RequestReason combo', fields: ['Reason', 'RequestType', 'Type'] }];
						dataImporter.importExcel(modelCopy, true).then(function (result) {
							vm.requestReasonsModel.methods.createBulk(result.data, catalogId, vm.requestReasonsModel);
						});
						break;
				}
			}
		}

		function addRequestReasons(ev) {
			api.showCreateRecordDialog(angular.element($document.body), ev, vm.requestReasonsModel, catalogId)
				.then(function (saved) {
					if (saved) {
						refreshRequestReasons(true, false);
					}
				});
		}

		function editRequestReasons(record, ev) {
			api.showEditRecordDialog(angular.element($document.body), ev, vm.requestReasonsModel, record, catalogId)
				.then(function (saved) {
					if (saved) {
						refreshRequestReasons(true, false);
					}
				});
		}

		function doBucketLevelAttributeItemAction(action, record) {
			if (action && record) {
				switch (action.id) {
					case 'edit':
						editBucketLevelAttributes(record, null);
						break;
					case 'delete':
					case 'activate':
						vm.bucketLevelAttributesModel.methods.activateBulk(record, vm.bucketLevelAttributes, action.id, catalogId).then(function () {
							refreshBucketLevelAttributes(true, false);
							updateActiveCatalogInCatalogFactory();
						});
						break;
				}
			}
		}

		function doBucketLevelAttributeListAction(action, records) {
			if (action) {
				switch (action.id) {
					case 'delete':
					case 'activate':
						vm.bucketLevelAttributesModel.methods.activateBulk(records, vm.bucketLevelAttributes, action.id, catalogId).then(function () {
							refreshBucketLevelAttributes(true, false);
							updateActiveCatalogInCatalogFactory();
						});
						break;
				}
			}
		}

		function assignBucketLevelAttributes(ev) {
			var modelCopy = angular.copy(vm.bucketLevelAttributesModel);
			var lookupExtras = {};
			lookupExtras['catalogs.bucketLevelAttributes'] = {};
			lookupExtras['catalogs.bucketLevelAttributes']['catalogId'] = catalogId;
			var attributeIdsField = utility.filterObject(modelCopy.fields, {field: 'AttributeidsList', inputType: 'lookup-many'}, true)[0];
			attributeIdsField.editable = true;
			// change dialog title to "Assign Bucket Attributes"
			modelCopy.title = 'BUCKET_ATTRIBUTES.TITLES.ASSIGN_BUCKET_ATTRIBUTES';

			// add assigned bucket attribuites id's to AttributeidsList
			var record = {};
			var activeBucketAttributes = utility.filterObject(vm.bucketLevelAttributes, {'Status': 1}, true);

			if(angular.isDefined(activeBucketAttributes)) {
				record.AttributeidsList = activeBucketAttributes.map(function(record) {
					var attributeId = angular.isDefined(record['Attributeid']) ? record['Attributeid'] : record['AttributeId'];
					return attributeId;
				});
			}

			api.showEditRecordDialog(angular.element($document.body), ev, modelCopy, record, catalogId, lookupExtras)
			.then(function(saved) {
				if (saved) {
					refreshBucketLevelAttributes(true, false);
					updateActiveCatalogInCatalogFactory();
				}
			});
		}

		function editBucketLevelAttributes(record, ev) {
			var modelCopy = angular.copy(vm.bucketLevelAttributesModel);
			var attributeIdsField = utility.filterObject(modelCopy.fields, {field: 'AttributeDisplayName'}, true)[0];
			attributeIdsField.showInEdit = true;
			var allowedValuesField = utility.filterObject(modelCopy.fields, {field: 'AllowedValues'}, true)[0];
			allowedValuesField.editable = true;
			var criteriaField = utility.filterObject(modelCopy.fields, {field: 'Criteria'}, true)[0];
			criteriaField.editable = true;
			api.showEditRecordDialog(angular.element($document.body), ev, modelCopy, record, catalogId)
			.then(function(saved) {
				if (saved) {
					refreshBucketLevelAttributes(true, false);
					updateActiveCatalogInCatalogFactory();
				}
			});
		}

		function doRestrictBucketAttributesItemAction(action, record) {
			if (action && record) {
				switch (action.id) {
					case 'view':
						viewRestrictedBucketAttributes(record, null);
						break;
					case 'edit':
						editRestrictBucketAttributesRoles(record, null);
						break;
					case 'delete':
						vm.restrictBucketAttributesRolesModel.methods.deleteBulk(record, action.id, catalogId).then(function () {
							refreshRestrictBucketAttributes(true, false);
							updateActiveCatalogInCatalogFactory();
						});
						break;
				}
			}
		}

		function doRestrictBucketAttributesListAction(action, records) {
			if (action) {
				switch (action.id) {
					case 'delete':
						vm.restrictBucketAttributesRolesModel.methods.deleteBulk(records, action.id, catalogId).then(function () {
							refreshRestrictBucketAttributes(true, false);
							updateActiveCatalogInCatalogFactory();
						});
						break;
				}
			}
		}

		function addRestrictBucketAttributesRoles(ev) {
			var rolesModel = api.roles.roles;
			var bucketAttributesModel = api.catalogs.bucketLevelAttributes;
			var promises = {};
			var generalProperties = {
				forceFetch: true,
				isLogRequired: false
			}
			promises['rolesPromise'] = rolesModel.methods.getList(generalProperties);
			promises['bucketAttributesPromise'] = bucketAttributesModel.methods.getAssignedBucketAttributes(generalProperties, catalogId);
			$mdDialog.show({
				controller: 'updateRestrictBucketAttributeController',
				controllerAs: 'vm',
				templateUrl: 'app/main/catalogs/details/tabs/restrict-bucket-attributes/dialogs/update-restricted-bucket-attributes/update-restricted-bucket-attributes.html',
				parent: angular.element($document.body),
				targetEvent: ev,
				clickOutsideToClose: false,
				locals: {
					record: null,
					isNew: true,
					model: vm.restrictBucketAttributesRolesModel,
					promises: promises,
					assignedRolesList: vm.restrictBucketAttributesRoles,
					activeCatalogCode: catalogId,
					event: ev
				}
			}).then(function(saved) {
				if (saved) {
					refreshRestrictBucketAttributes(true, false);
					updateActiveCatalogInCatalogFactory();
				}
			});
		}

		function editRestrictBucketAttributesRoles(record, ev) {
			var rolesModel = api.roles.roles;
			var bucketAttributesModel = api.catalogs.bucketLevelAttributes;
			var promises = {};
			var generalProperties = {
				forceFetch: true,
				isLogRequired: false
			}
			promises['rolesPromise'] = rolesModel.methods.getList(generalProperties);
			promises['bucketAttributesPromise'] = bucketAttributesModel.methods.getAssignedBucketAttributes(generalProperties, catalogId);
			$mdDialog.show({
				controller: 'updateRestrictBucketAttributeController',
				controllerAs: 'vm',
				templateUrl: 'app/main/catalogs/details/tabs/restrict-bucket-attributes/dialogs/update-restricted-bucket-attributes/update-restricted-bucket-attributes.html',
				parent: angular.element($document.body),
				targetEvent: ev,
				clickOutsideToClose: false,
				locals: {
					record: record,
					isNew: false,
					model: vm.restrictBucketAttributesRolesModel,
					promises: promises,
					assignedRolesList: vm.restrictBucketAttributesRoles,
					activeCatalogCode: catalogId,
					event: ev
				}
			}).then(function(saved) {
				if (saved) {
					refreshRestrictBucketAttributes(true, false);
					updateActiveCatalogInCatalogFactory();
				}
			});
		}

		function viewRestrictedBucketAttributes(record, ev) {
			$mdDialog.show({
				controller         : 'viewRestrictedAttributesListController',
				controllerAs       : 'vm',
				templateUrl        : 'app/main/catalogs/details/tabs/restrict-bucket-attributes/dialogs/view-restricted-bucket-attributes/view-restricted-bucket-attributes.html',
				parent             : angular.element($document.body),
				targetEvent        : null,
				clickOutsideToClose: false,
				locals             : {
						event : ev,
						model : api.catalogs.restrictedBucketAttributes,
						data  : replaceAttributeNames(record.Attributes)
				}
			});
		}

		function doColorDefinitionItemAction(action, record) {
			if (action && record) {
				switch (action.id) {
					case 'edit':
						editColorDefinition(record, null);
						break;
					case 'delete':
					case 'activate':
						vm.colorDefinitionModel.methods.activateBulk(record, vm.colorDefinitionModel, action.id, catalogId).then(function () {
							refreshColorDefinitions(true, false);
							updateActiveCatalogInCatalogFactory();
						});
						break;
				}
			}
		}

		function doColorDefinitionListAction(action, records) {
			if (action) {
				switch (action.id) {
					case 'delete':
					case 'activate':
						vm.colorDefinitionModel.methods.activateBulk(records, vm.colorDefinitionModel, action.id, catalogId).then(function () {
							refreshColorDefinitions(true, false);
							updateActiveCatalogInCatalogFactory();
						});
						break;
					case 'import':
						var modelCopy = angular.copy(vm.colorDefinitionModel);
						var colorNameFiled = utility.filterObject(modelCopy.fields, { field: 'ColorName' }, true)[0];
						colorNameFiled.validation.dataExistConstraints.data = vm.colorDefinitions;
						dataImporter.importExcel(modelCopy, true).then(function (result) {
							vm.colorDefinitionModel.methods.createBulk(result.data, catalogId, vm.colorDefinitionModel);
						});
						break;
				}
			}
		}

		function addColorDefinition(ev) {
			var existingRecordsForUniqueValue = angular.copy(vm.colorDefinitions);
			api.showCreateRecordDialog(angular.element($document.body), ev, vm.colorDefinitionModel, catalogId, undefined, undefined, undefined, undefined, existingRecordsForUniqueValue)
			.then(function (saved) {
				if (saved) {
					refreshColorDefinitions(true, false);
					updateActiveCatalogInCatalogFactory();
				}
			});
		}

		function editColorDefinition(record, ev) {
			var existingRecordsForUniqueValue = angular.copy(vm.colorDefinitions);
			for (var i = 0; i < existingRecordsForUniqueValue.length; i++) {
				if(existingRecordsForUniqueValue[i].Id === record.Id) {
					existingRecordsForUniqueValue.splice(i, 1);
				}
			}
			api.showEditRecordDialog(angular.element($document.body), ev, vm.colorDefinitionModel, record, catalogId, undefined, undefined, undefined, existingRecordsForUniqueValue)
			.then(function(saved) {
				if (saved) {
					refreshColorDefinitions(true, false);
					updateActiveCatalogInCatalogFactory();
				}
			});
		}

		function doRelationTypesItemAction(action, record) {
			if (action && record) {
				switch (action.id) {
					case 'edit':
						editRelationTypes(record, null);
						break;
					case 'delete':
					case 'activate':
						vm.relationTypesModel.methods.activateBulk(record, vm.relationTypesModel, action.id, catalogId).then(function () {
							refreshRelationTypes(true, false);
							updateActiveCatalogInCatalogFactory();
						});
						break;
				}
			}
		}

		function doRelationTypesListAction(action, records) {
			if (action) {
				switch (action.id) {
					case 'delete':
					case 'activate':
						vm.relationTypesModel.methods.activateBulk(records, vm.relationTypesModel, action.id, catalogId).then(function () {
							refreshRelationTypes(true, false);
							updateActiveCatalogInCatalogFactory();
						});
						break;
				}
			}
		}

		function addRelationTypes(ev) {
			var existingRecordsForUniqueValue = angular.copy(vm.relationTypes);
			api.showCreateRecordDialog(angular.element($document.body), ev, vm.relationTypesModel, catalogId, undefined, undefined, undefined, undefined, existingRecordsForUniqueValue)
			.then(function (saved) {
				if (saved) {
					refreshRelationTypes(true, false);
					updateActiveCatalogInCatalogFactory();
				}
			});
		}

		function editRelationTypes(record, ev) {
			var existingRecordsForUniqueValue = angular.copy(vm.relationTypes);
			for (var i = 0; i < existingRecordsForUniqueValue.length; i++) {
				if(existingRecordsForUniqueValue[i].Id === record.Id) {
					existingRecordsForUniqueValue.splice(i, 1);
				}
			}
			api.showEditRecordDialog(angular.element($document.body), ev, vm.relationTypesModel, record, catalogId, undefined, undefined, undefined, existingRecordsForUniqueValue)
			.then(function(saved) {
				if (saved) {
					refreshRelationTypes(true, false);
					updateActiveCatalogInCatalogFactory();
				}
			});
		}

		function doDatasetDefinitionItemAction(action, record) {
			if (action && record && action.id === 'view') {
				viewDatasetDefinition(record);
			}
		}

		function viewDatasetDefinition(record) {
			$state.go('app.catalog_dataset_details', {
				id: record[vm.datasetDefinitionsModelCopy.idField],
				catalogCode: catalogId,
				accountId: vm.catalog.AccountId,
				dataset: record
			});
		}

		function doColorPaletteItemAction(action, record) {
			if (action && record) {
				switch (action.id) {
					case 'viewColors':
							viewColorPalatteColors(record, null);
							break;
					case 'edit':
							addUpdateColorPalette(null, record);
							break;
					case 'delete':
					case 'activate':
							vm.colorPaletteModel.methods.activateBulk(record, vm.colorPaletteModel, action.id, catalogId).then(function () {
								refreshColorPalette(true, false);
								updateActiveCatalogInCatalogFactory();
							});
							break;
				}
			}
		}

		function doColorPaletteListAction(action, records) {
			if (action) {
					switch (action.id) {
						case 'delete':
						case 'activate':
							vm.colorPaletteModel.methods.activateBulk(records, vm.colorPaletteModel, action.id, catalogId).then(function () {
								refreshColorPalette(true, false);
								updateActiveCatalogInCatalogFactory();
							});
							break;
						case 'import':
							var modelCopy = angular.copy(vm.colorPaletteModel);
							var colorsField = utility.filterObject(modelCopy.fields, { field: 'SellerColorIds' }, true)[0];
							colorsField.creatable = true;
							var colorCriteriaField = utility.filterObject(modelCopy.fields, { field: 'ColorCriteria' }, true)[0];
							colorCriteriaField.creatable = true;
							dataImporter.importExcel(modelCopy, true).then(function (result) {
								vm.colorPaletteModel.methods.createBulk(result.data, catalogId, vm.colorPaletteModel).then(function() {
									refreshColorPalette(true, false);
								});
							});
							break;
					}
			}
		}

		function viewColorPalatteColors(record, ev) {
			$mdDialog.show({
				controller         : 'viewColorsListController',
				controllerAs       : 'vm',
				templateUrl        : 'app/main/catalogs/details/tabs/catalog-color-palette/dialogs/view-colors/view-colors.html',
				parent             : angular.element($document.body),
				targetEvent        : null,
				clickOutsideToClose: false,
				locals             : {
						event : ev,
						model : api.catalogs.colorPaletteColors,
						data  : replaceAttributeNames(record.Colors)
				}
			});
		}

		function addUpdateColorPalette(ev, record) {
			var generalProperties = {
				forceFetch: true,
				isLogRequired: false
			}
			var promises = {};
			promises['catalogAttributesPromise'] = vm.attributesModel.methods.getList(generalProperties, catalogId);
			$mdDialog.show({
				controller: 'addOrUpdateColorPaletteController',
				controllerAs: 'vm',
				templateUrl: 'app/main/catalogs/details/tabs/catalog-color-palette/dialogs/add-update-catalog-color-palette/add-update-catalog-color-palette.html',
				parent: angular.element($document.body),
				targetEvent: ev,
				clickOutsideToClose: false,
				locals: {
					record: record,
					isNew: angular.isDefined(record)? false: true,
					model: vm.colorPaletteModel,
					promises: promises,
					activeCatalogCode: catalogId,
					sellerId: vm.sellerId,
					assignedCatalogAttributes: vm.attributes,
					existingRecordsForUniqueValue: vm.colorPalette,
					event: ev
				}
			}).then(function(saved) {
				if (saved) {
					refreshColorPalette(true, false);
					updateActiveCatalogInCatalogFactory();
				}
			});
		}

		function doAggregateAttributesItemAction(action, item) {
			if (action) {
				switch (action.id) {
					case 'view':
						viewAggregateAttribute(item);
						break;
				}
			}
		}

		function viewAggregateAttribute(item) {
			var id = item[vm.aggregateAttributesModel.idField];
			$state.go('app.attributes_list.details', { id: id });
		}

		watchUnsubscribe.treeAttributes = $scope.$watch('vm.treeAttributes', function (newValue, oldValue) {
			if (newValue.length > 0 && oldValue.length > 0) {
				vm.isTreeAttributeDirty = false;
				if (newValue.length !== pristineActiveTreeAttributes.length) {
					vm.isTreeAttributeDirty = true;
				}
				else {
					for (var index = 0; index < newValue.length; index++) {
						if (angular.isUndefined(pristineActiveTreeAttributes[index]) || newValue[index].Attributeid !== pristineActiveTreeAttributes[index].Attributeid) {
							vm.isTreeAttributeDirty = true;
						}
					}
				}
			}
		}, true);

		$scope.$on('$destroy', function () {
			for (var key in watchUnsubscribe) {
				watchUnsubscribe[key]();
			}
		});

		/**
		 * when ever user update or create records in any catalog details tab update the session storage activeCatalogDetails so that we will
		 * have the latest data in all other module
		 */
		function updateActiveCatalogInCatalogFactory() {
			if(angular.isDefined(catalogFactory.getActiveCatalog().CatalogCode) && catalogId == catalogFactory.getActiveCatalog().CatalogCode) {
				catalogFactory.updateListOfCatalogs();
				catalogFactory.setActiveCatalog(catalogFactory.getActiveCatalog());
			}
		}

		function initializeTabData(isLogRequired) {
			if (vm.catalog.Status !== 0) {
				isTabDataInitialized = true;
				if (SecurityFactory.isAuthorized({accessPrivileges: CONSTANTS.PRIVILEGES.CATALOGS.DETAIL.RESTRICT_SEGMENTATIONS})) {
					refreshRoleBasedRestrictedSegmentations(vm.roleBasedRestrictSegmentationsModel.isDirty, isLogRequired);
				}
				if (SecurityFactory.isAuthorized({accessPrivileges: CONSTANTS.PRIVILEGES.CATALOGS.DETAIL.RESTRICT_RETAIL_WINDOWS})) {
					refreshRoleBasedRestrictedRetailWindows(vm.roleBasedRestrictRetailWindowsModel.isDirty, isLogRequired);
				}
				if (SecurityFactory.isAuthorized({accessPrivileges: CONSTANTS.PRIVILEGES.CATALOGS.DETAIL.ATTRIBUTE_RESTRICTIONS})) {
					refreshRoleBasedRestrictedAttributes(vm.roleBasedRestrictAttributesModel.isDirty, isLogRequired);
				}
				if (SecurityFactory.isAuthorized({accessPrivileges: CONSTANTS.PRIVILEGES.CATALOGS.DETAIL.BUCKET_ATTRIBUTE_RESTRICTIONS})) {
					refreshRestrictBucketAttributes(vm.restrictBucketAttributesRolesModel.isDirty, isLogRequired);
				}
				if (SecurityFactory.isAuthorized({accessPrivileges: CONSTANTS.PRIVILEGES.CATALOGS.DETAIL.SIZE_SCALE_GROUPS_LIST})) {
					refreshSizeScaleGroups(vm.sizeScaleGroupsModel.isDirty, isLogRequired);
				}
				if (SecurityFactory.isAuthorized({accessPrivileges: CONSTANTS.PRIVILEGES.CATALOGS.DETAIL.CATALOG_TREE_DEFINITION_LIST})) {
					refreshTree(vm.treeModel.isDirty, isLogRequired);
				}
				if (SecurityFactory.isAuthorized({accessPrivileges: CONSTANTS.PRIVILEGES.CATALOGS.DETAIL.STOCK_DEFINITION_LIST})) {
					refreshStockDefinitions(vm.stockDefinitionModel.isDirty, isLogRequired);
				}
				if (SecurityFactory.isAuthorized({accessPrivileges: CONSTANTS.PRIVILEGES.CATALOGS.DETAIL.ATTRIBUTE_VETTING_LIST})) {
					refreshAttributeVettingList(vm.attributeVettingListModel.isDirty, isLogRequired);
				}
				if (SecurityFactory.isAuthorized({accessPrivileges: CONSTANTS.PRIVILEGES.CATALOGS.DETAIL.SELLER_USERS})) {
					refreshSellerUserList(vm.sellerUsersListModel.isDirty, isLogRequired);
				}
				if (SecurityFactory.isAuthorized({accessPrivileges: CONSTANTS.PRIVILEGES.CATALOGS.DETAIL.REQUEST_ATTRIBUTES}) && vm.catalog.RequestsEnabled === 1) {
					refreshRequestAttributes(vm.requestAttributesModel.isDirty, isLogRequired);
				}
				if (SecurityFactory.isAuthorized({accessPrivileges: CONSTANTS.PRIVILEGES.CATALOGS.DETAIL.REQUEST_REASONS}) && vm.catalog.RequestsEnabled === 1) {
					refreshRequestReasons(vm.requestReasonsModel.isDirty, isLogRequired);
				}
				if (SecurityFactory.isAuthorized({accessPrivileges: CONSTANTS.PRIVILEGES.CATALOGS.DETAIL.COLOR_DEFINITIONS}) && vm.catalog.DataSourceTypeId === 1) {
					refreshColorDefinitions(vm.colorDefinitionModel.isDirty, isLogRequired);
				}
				if (SecurityFactory.isAuthorized({accessPrivileges: CONSTANTS.PRIVILEGES.CATALOGS.DETAIL.RELATION_TYPES})) {
					refreshRelationTypes(vm.relationTypesModel.isDirty, isLogRequired);
				}
				if (SecurityFactory.isAuthorized({accessPrivileges: CONSTANTS.PRIVILEGES.SELLERS.DETAIL.GET_DATASET_DEFINITIONS})) {
					refreshDatasetDefinitions(vm.datasetDefinitionsModel.isDirty, isLogRequired);
				}
				if (SecurityFactory.isAuthorized({accessPrivileges: CONSTANTS.PRIVILEGES.CATALOGS.DETAIL.SEGMENTATIONS})) {
					refreshSegmentations(vm.segmentationsModel.isDirty, isLogRequired);
				}
				if (SecurityFactory.isAuthorized({accessPrivileges: CONSTANTS.PRIVILEGES.CATALOGS.DETAIL.RETAIL_WINDOWS}) && !vm.isRetailWindowViewableRestrictedOnRole) {
					refreshShipmentWindows(true, isLogRequired);
				}
				if(SecurityFactory.isAuthorized({accessPrivileges: CONSTANTS.PRIVILEGES.CATALOGS.DETAIL.CATALOG_COLOR_PALETTE})) {
					refreshColorPalette(vm.colorPaletteModel.isDirty, isLogRequired);
				}
				// CONFIGURATIONS
				if (SecurityFactory.isAuthorized({accessPrivileges: CONSTANTS.PRIVILEGES.CATALOGS.DETAIL.SIZE_CURVES})) {
					refreshConfigurations(vm.configurationsModel, isLogRequired);
				}
			}
		}

		// to avoid setting the configuration globally
		function setArticleModelAndSegmentationLabelConfigurationInsideCatalog() {
			var articleLabelConfig = utility.filterObject(vm.configurations, { Name: 'T1S-ArticleLabel' }, true)[0];
			if(angular.isDefined(articleLabelConfig) && articleLabelConfig.Value.length > 0) {
					articleLabelConfiguration = articleLabelConfig.Value;
			}
			var modelLabelConfig = utility.filterObject(vm.configurations, { Name: 'T1S-ModelLabel' }, true)[0];
			if(angular.isDefined(modelLabelConfig) && modelLabelConfig.Value.length > 0) {
					modelLabelConfiguration = modelLabelConfig.Value;
			}
			var segmentationLabelConfig = utility.filterObject(vm.configurations, { Name: 'T1S-ModelLabel' }, true)[0];
			if(angular.isDefined(segmentationLabelConfig) && segmentationLabelConfig.Value.length > 0) {
					segmentationLabelConfiguration = segmentationLabelConfig.Value;
			}
		}

		// replace "Article", "Model" and "segmentation" in attributes name with T1S-ArticleLabel and T1S-ModelLabel if configured
		function replaceAttributeNames(attributes) {
			if((angular.isDefined(articleLabelConfiguration) && articleLabelConfiguration !== '') || (angular.isDefined(modelLabelConfiguration) && modelLabelConfiguration !== '') || (angular.isDefined(segmentationLabelConfiguration) && segmentationLabelConfiguration !== '')) {
				angular.forEach(attributes, function(attribute) {
					if(articleLabelConfiguration.length && attribute.AttributeDisplayName.toLowerCase().includes('article')) {
						attribute.AttributeDisplayName =  utility.replaceStringWithCase(attribute.AttributeDisplayName, 'article', articleLabelConfiguration);
					}
					if(modelLabelConfiguration.length && attribute.AttributeDisplayName.toLowerCase().includes('model')) {
						attribute.AttributeDisplayName =  utility.replaceStringWithCase(attribute.AttributeDisplayName, 'model', modelLabelConfiguration);
					}
					if(segmentationLabelConfiguration.length && attribute.AttributeDisplayName.toLowerCase().includes('segmentation')) {
						attribute.AttributeDisplayName =  utility.replaceStringWithCase(attribute.AttributeDisplayName, 'segmentation', segmentationLabelConfiguration);
					}
				});
			}
			return attributes;
		}
	}
})();
(function () {
    'use strict';

    angular
        .module('app.main.auth.set-password', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        // State
        $stateProvider.state('app.auth_set_password', {
            url      : '/auth/set-password',
            views    : {
                'main@'                       : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.auth_set_password': {
                    templateUrl: 'app/main/auth/set-password/set-password.html',
                    controller : 'setPasswordController as vm'
                }
            },
            bodyClass: 'set-password',
            params: {
                userName: null
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/auth/set-password');
    }

})();
(function () {
    'use strict';

    angular
        .module('app.main.auth.set-password')
        .controller('setPasswordController', setPasswordController);

    /** @ngInject */
    function setPasswordController(api, toast, $localStorage, $state, $stateParams, $filter) {
        var vm = this;

        //Data
        vm.record = {};
        vm.processing = false;
        vm.record = {
            'Username': $stateParams.userName
        }

        //Methods
        vm.setPassword = setPassword;

        ////////////////

        function setPassword() {
            vm.record.otp = vm.record.otp;
            vm.record.newPassword = vm.record.newPassword;
            vm.record.env = $localStorage.env.code;
            vm.processing = true;
            api.webPost($localStorage.authBaseUrl + '/forgotcomplete', vm.record).then(function () {
                toast.success('SET_PASSWORD.RESET_SUCCESS', '', '');
                $state.go('app.auth_login');
            }).catch(function (error) {
                vm.processing = false;
                vm.responseError = true;

                var translatableKey;
                var errCode = angular.isDefined(error.data) && error.data && angular.isDefined(error.data[0]) && angular.isDefined(error.data[0].errorCode) ? error.data[0].errorCode : 999;
                switch (error.status) {
                    case 400:
                    case 401:
                        if (errCode === 10010) {
                            translatableKey = 'LOGIN.ERRORS.INVALID_CODE';
                        }
                        break;
                    case 429:
                        translatableKey = 'LOGIN.ERRORS.TOO_MANY_REQUESTS';
                        break;
                    default:
                        translatableKey = 'LOGIN.ERRORS.UNEXPECTED_ERROR';
                }

                vm.error = $filter('translate')(translatableKey);
                vm.errorCode = errCode;

            }).finally(function () {//10010: Invalid Credentials error handling
                vm.processing = false;
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.main.auth.login', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        // State
        $stateProvider.state('app.auth_login', {
            url      : '/auth/login',
            params: {
                shouldLogout: true,
                isSwitchUser: false
            },
            views    : {
                'main@'                       : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.auth_login': {
                    templateUrl: 'app/main/auth/login/login.html',
                    controller : 'LoginController as vm'
                }
            },
            bodyClass: 'login'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/auth/login');
    }

})();
(function () {
	'use strict';

	angular
		.module('app.main.auth.login')
		.controller('LoginController', LoginController);

	/** @ngInject */
	function LoginController($auth, $stateParams, toast, $localStorage, $filter, $interval, api, catalogFactory,
		jobsTracker, uploadsTracker, authFactory, $window, $scope, $log, $timeout, $state, CONSTANTS, $document, jwtHelper, utility, $sessionStorage) {

		/* jshint validthis: true */
		var vm = this;

		// Data
		var externalLoginWindowInterval;
		var externalLoginWindow = undefined;
		var externalLogoutWindowInterval;
		//var externalLogoutWindow = undefined;//logout functionality is not implemented for new auth
		var authBaseUrl = '';
		var configuredAuthBaseUrl = '';
		var setPasswordTimeoutPromise;

		var rolesModel = api.roles.roles;

		vm.user = {
			username: '',
			password: ''
		};
		vm.processing = false;
		vm.processingExternal = false;
		vm.isLogOutFromActiveDirect = false;
		vm.isLoading = true;
		vm.apiEnvs = [];
		vm.loginEnvironment = undefined;
		vm.custEnvURL = undefined;
		vm.responseError = false;
		var shouldLogout = $stateParams.shouldLogout;
		vm.isSwitchUser = $stateParams.isSwitchUser;

		vm.loginTypeId = undefined;
		vm.FirstName = undefined;
		vm.error = undefined;
		vm.isDisabled = false; // will disable the input fields while the api call is made on submitting the form, and enable the input fields after api returns the response
		vm.multipleUsers = false;
		vm.remainingTimeToRedirect;
		var totalSeconds = 20;
		vm.requireResetPassword = false;
		vm.masterUserName = '';
		vm.usersList = [];
		var clientId = 'T1U';// To check user has access to T1U
		var timeoutPromise;
		vm.activeDirectoryLoggingIn = false;
		var masterToken = ''; //To keep master token in memory

		// Methods
		vm.getMasterToken = getMasterToken;
		vm.doLogin = doLogin;
		vm.cancelExternalLoginWindow = cancelExternalLoginWindow;
		vm.getUserLoginType = getUserLoginType;
		vm.resetLoginTypeId = resetLoginTypeId;
		//vm.logout = logout;//  Active directory logout url is not ready, commenting related item
		vm.onKeyUp = onKeyUp;
		vm.changeUser = changeUser;
		vm.redirectToSetPassword = redirectToSetPassword;
		vm.onEnvironmentChange = onEnvironmentChange;

		activate();

		//////////

		function activate() {
			vm.isLoading = true;

			if ($auth.isAuthenticated() && shouldLogout) { // if user explicitly try to navigate to login state by changing URL, log him/her out
				$auth.logout();
				authFactory.onLogout();
				jobsTracker.clearCompleted();
				uploadsTracker.clearCompleted();
			}

			if(angular.isDefined($localStorage.user) && angular.isDefined($localStorage.user.masterUserName)) {
				vm.user.username = $localStorage.user.masterUserName;
			}

			// if switch user then redirect user to get users list
			if (vm.isSwitchUser) {
				getMyUsersListAndRedirectToUsersListPage($localStorage.user.loginType, vm.isSwitchUser);
			}

			//Load WebAPI Environments
			api.webGet('/app/app.config.json')
				.then(function (response) {
					if (angular.isDefined(response) && angular.isDefined(response.data)) {

						//setting up login auth engine url
						if (angular.isDefined(response.data.authBaseUrl)) {
							$localStorage.authBaseUrl = authBaseUrl = configuredAuthBaseUrl = response.data.authBaseUrl;
						}

						if (angular.isDefined(response.data.t1DuneBaseUrl)) {
							$localStorage.t1DuneBaseUrl = api.t1DuneBaseUrl = response.data.t1DuneBaseUrl;
						}

						if (angular.isDefined(response.data.t1DuneAssetDownloadBaseUrl)) {
							$localStorage.t1DuneAssetDownloadBaseUrl = api.t1DuneAssetDownloadBaseUrl = response.data.t1DuneAssetDownloadBaseUrl;
						}

						if (angular.isDefined(response.data.t1v2URL)) {
							$localStorage.t1v2URL = api.t1v2URL = response.data.t1v2URL;
						}

						if (angular.isDefined(response.data.apiEnv) && angular.isDefined(response.data.apiEnv.code) && angular.isDefined(response.data.apiEnv.baseUrl)) {
							$localStorage.isMultiEnv = false;
							vm.loginEnvironment = response.data.apiEnv
						} else {
							$localStorage.isMultiEnv = true;
							return getEnvironments();
						}
					}
				})
				.finally(function () {
					vm.isLoading = false;
				});
		}

		function getMasterToken() {
			//While login in check if the user is login in from the redirected state.go where shouldLogout was set as false in order to restrict login in to single user.
			//Thus on login in perform the same action which are performed on normal login.
			if (shouldLogout === false) {
				$auth.logout();
				authFactory.onLogout();
				jobsTracker.clearCompleted();
				uploadsTracker.clearCompleted();
			}
			vm.processing = true;
			vm.isDisabled = true;
			vm.user.env = vm.loginEnvironment.code;
			vm.user.grant_type = 'password';
			vm.user.client_code = clientId;
			vm.loginTypeId = 1;
			catalogFactory.setCatalogRequestDispatchStatus(false);

			authFactory.getMasterToken(vm.user)
				.then(function (response) {
					masterToken = response.data.access_token; //keep master token in memory
					var payload  = jwtHelper.decodeToken(masterToken);

					if(payload.envs.indexOf(vm.loginEnvironment.code) !== -1) {
						getMyUsersListAndRedirectToUsersListPage(vm.loginTypeId);
					} else {
						vm.processing = false;
						vm.responseError = true;
						vm.error = $filter('translate')('LOGIN.SERVER_ERROR.USERNAME_NOT_ALLOWED');
						vm.errorCode = 10100;
					}
				})
				.catch(function (error) {
					vm.processing = false;
					vm.responseError = true;

					var translatableKey;
					var errCode = angular.isDefined(error.data) && angular.isDefined(error.data.errorCode) ? error.data.errorCode : 999;
					switch (error.status) {
						case 400:
						case 401:
							if (errCode === 10010) {
								translatableKey = 'LOGIN.SERVER_ERROR.INVALID_CREDENTIAL';
							} else if (errCode === 10100) {
								translatableKey = 'LOGIN.SERVER_ERROR.USERNAME_NOT_ALLOWED';
							} else if (errCode === 10010) {
								translatableKey = 'LOGIN.SERVER_ERROR.INVALID_USERNAME';
							} else if (errCode === 10110) {
								translatableKey = 'LOGIN.ERRORS.UNEXPECTED_ERROR';
							} else if (errCode === 10140) {
								translatableKey = 'LOGIN.SERVER_ERROR.USERNAME_NOT_ALLOWED_IN_CURRENT_CLIENT';
							} else {
								translatableKey = 'LOGIN.ERRORS.UNEXPECTED_ERROR';
							}
							break;
						case 500:
							translatableKey = 'LOGIN.ERRORS.UNEXPECTED_ERROR';
							break;
						case 429:
							translatableKey = 'LOGIN.ERRORS.TOO_MANY_REQUESTS';
							break;
						default:
							translatableKey = 'LOGIN.ERRORS.UNEXPECTED_ERROR';
					}

					vm.error = $filter('translate')(translatableKey);
					vm.errorCode = errCode;
				}).finally(function () {
					vm.isDisabled = false;
				});

		}

		function doExternalLogin() {
			if (angular.isDefined(externalLoginWindow) && externalLoginWindow != null) {
				externalLoginWindow.close();
				externalLoginWindow = undefined;
				vm.processingExternal = false;
			} else {
				var externalLoginWindowUrl;
				externalLoginWindowUrl = authBaseUrl + '/gotologin?Username=' + vm.user.username + '&EnvCode=' + vm.loginEnvironment.code + '&ClientCode=' + clientId;
				vm.processingExternal = true;
				externalLoginWindow = $window.open(externalLoginWindowUrl, '_blank', 'width=500,height=500');
				externalLoginWindowInterval = $interval(function () {
					if (angular.isUndefined(externalLoginWindow) || externalLoginWindow === null || externalLoginWindow.closed) {
						vm.processingExternal = false;
						cancelExternalLoginWindow();
					}
				}, 1000);
			}
		}

		/**
		 * @description: closes the external login window once the users list call is answered. The window is
		 * only opened for the active directory login types and never while switching users
		 */
		function closeExternalLoginWindow(loginType) {
			if((loginType === 2 || loginType === 5) && !vm.isSwitchUser && angular.isDefined(externalLoginWindow) && externalLoginWindow !== null) {
				externalLoginWindow.close();
				externalLoginWindow = undefined;
			}
		}

		function cancelExternalLoginWindow() {
			if (angular.isDefined(externalLoginWindow)) {
				doExternalLogin();
			}
			if (externalLoginWindowInterval) {
				$interval.cancel(externalLoginWindowInterval);
				externalLoginWindowInterval = undefined;
			}
		}


		function receiveMessage(event) {
			if (!(event.origin)) {
				return
			}
			else if ((vm.loginTypeId === 2 || vm.loginTypeId === 5) && angular.fromJson(event.data).id_token) {
				masterToken = angular.fromJson(event.data).id_token; //Keep master token in memory
				$auth.setToken(masterToken);
				// set token in session storage so that when user hard refresh and try to switch user we will have token to get users list
				$localStorage.accessToken = $sessionStorage.accessToken = masterToken;
				var payload = $auth.getPayload();
				vm.processing = true;
				if (payload.envs.indexOf($localStorage.env.code) !== -1) {
					getMyUsersListAndRedirectToUsersListPage(vm.loginTypeId);
				} else {
					externalLoginWindow.close();
					externalLoginWindow = undefined;
					vm.processingExternal = false;
					vm.processing = false;
					vm.responseError = true;
					vm.error = $filter('translate')('LOGIN.SERVER_ERROR.USERNAME_NOT_ALLOWED');
					vm.errorCode = 10100;
				}
			} else if ((vm.loginTypeId === 2 || vm.loginTypeId === 5) && angular.fromJson(event.data).logout === 1) {
				externalLogoutWindow.close();
				externalLogoutWindow = undefined;
				vm.isLogOutFromActiveDirect = false;
				vm.responseError = false;
				vm.error = undefined;
				vm.errorCode = undefined;
				vm.loginTypeId = undefined;
			} else if ((vm.loginTypeId === 2 || vm.loginTypeId === 5) && angular.fromJson(event.data).error) {
				var errorDescription = angular.fromJson(event.data).error_description;
				externalLoginWindow.close();
				externalLoginWindow = undefined;
				vm.processingExternal = false;
				vm.processing = false;
				vm.responseError = true;
				if(errorDescription.indexOf('ClientNotAllowed') >= 0) {
					vm.error = $filter('translate')('LOGIN.SERVER_ERROR.USERNAME_NOT_ALLOWED_IN_CURRENT_CLIENT');
					vm.errorCode = 10140;
				} else {
					vm.error = $filter('translate')('LOGIN.ERRORS.UNEXPECTED_ERROR');
					vm.errorCode = 500;
				}
			}
		}

		function getUserLoginType() {
			vm.error = undefined;
			vm.isLogOutFromActiveDirect = false;
			vm.isDisabled = true;
			vm.masterUserName = vm.user.username.toLowerCase();
			if(angular.isUndefined($localStorage.user)) {
				$localStorage.user = {};
			}
			//assigning master user name to local storage
			$localStorage.user.masterUserName = vm.masterUserName;
			if (angular.isUndefined(vm.loginEnvironment)) {
				if (vm.apiEnvs.length === 1) {
					vm.loginEnvironment = vm.apiEnvs[0];
				} else {
					toast.error('LOGIN.ERRORS.ENV', '', '', '');
					return;
				}
			}
			$localStorage.baseUrl = api.baseUrl = vm.loginEnvironment.baseUrl;
			// use the selected environment's baseV2Url as t1v2URL (per environment), falling back to the configured value when not provided
			if (angular.isDefined(vm.loginEnvironment.baseV2Url) && vm.loginEnvironment.baseV2Url !== null) {
				$localStorage.t1v2URL = api.t1v2URL = vm.loginEnvironment.baseV2Url;
			}
			$localStorage.env = vm.loginEnvironment;

			api.webGet(authBaseUrl + '/logintype' + '?Username=' + vm.user.username + '&EnvCode=' + vm.loginEnvironment.code)
				.then(function (response) {
					if (response && response.data && response.data.loginType) {
						vm.loginTypeId = response.data.loginType;
						var requirePasswordReset = response.data.requirePasswordReset;

						if (requirePasswordReset === true) {
							totalSeconds = 20;
							redirectToSetPasswordWithDelay();
							vm.requireResetPassword = true;
							vm.loginTypeId ='';
						} else {
							vm.firstName = response.data.firstName;

							//redirect user as per loginType
							if (vm.loginTypeId === 2 || vm.loginTypeId === 5) {
								$window.addEventListener('message', receiveMessage, false);
								doExternalLogin();
							} else if (vm.loginTypeId !== 1) {
								$log.warn('Configuration Object activeDirectoryInfo is missing in config file');
							}
						}
					}
				})
				.catch(function (error) {
					vm.processing = false;
					vm.responseError = true;

					var translatableKey;
					var errCode = angular.isDefined(error.data) && error.data && angular.isDefined(error.data.errorCode) ? error.data.errorCode : 999;
					switch (error.status) {
						case 400:
						case 401:
							if (errCode === 10040 || errCode === 10020) {
								translatableKey = 'LOGIN.SERVER_ERROR.USER_NOT_EXIST_INVALID_CREDENTIAL';
							} else if(errCode === 10150) {
								translatableKey = 'LOGIN.SERVER_ERROR.USER_DEACTIVATED';
							} else {
								translatableKey = 'LOGIN.ERRORS.UNEXPECTED_ERROR';
							}
							break;
						case 500:
							translatableKey = 'LOGIN.ERRORS.UNEXPECTED_ERROR';
							break;
						case 429:
							translatableKey = 'LOGIN.ERRORS.TOO_MANY_REQUESTS';
							break;
						default:
							translatableKey = 'LOGIN.ERRORS.UNEXPECTED_ERROR';
					}

					vm.error = $filter('translate')(translatableKey);
					vm.errorCode = errCode;
				}).finally(function () {
					vm.isDisabled = false;
				});
		}

		function resetLoginTypeId() {
			vm.responseError = false;
			vm.loginTypeId = undefined;
		}
		//  Active directory logout url is not ready, commenting related item
		// function logout() {
		// 	if (angular.isDefined(externalLogoutWindow)) {
		// 		externalLogoutWindow.close();
		// 		externalLogoutWindow = undefined;
		// 		vm.isLogOutFromActiveDirect = false;
		// 		vm.responseError = false;
		// 		vm.error = undefined;
		// 		vm.errorCode = undefined;
		// 		vm.loginTypeId = undefined;
		// 	} else {
		// 		var externalLogoutWindowUrl = 'https://login.microsoftonline.com/common/oauth2/logout?post_logout_redirect_uri=https://trasixinternal.azurewebsites.net/api/Logout';
		// 		vm.isLogOutFromActiveDirect = true;
		// 		externalLogoutWindow = $window.open(externalLogoutWindowUrl, '_blank', 'width=500,height=500');
		// 		externalLogoutWindowInterval = $interval(function () {
		// 			if (angular.isUndefined(externalLogoutWindow) || externalLogoutWindow.closed) {
		// 				vm.isLogOutFromActiveDirect = false;
		// 				cancelExternalLogoutWindow();
		// 			}
		// 		}, 1000);
		// 	}
		// }

		// Active directory logout url is not ready, commenting related item
		// function cancelExternalLogoutWindow() {
		// 	if (angular.isDefined(externalLoginWindow)) {
		// 		externalLogoutWindow.close();
		// 		externalLogoutWindow = undefined;
		// 		vm.isLogOutFromActiveDirect = false;
		// 		vm.responseError = false;
		// 		vm.error = undefined;
		// 		vm.errorCode = undefined;
		// 		vm.loginTypeId = undefined;
		// 	}
		// 	if (externalLogoutWindowInterval) {
		// 		$interval.cancel(externalLogoutWindowInterval);
		// 		externalLogoutWindowInterval = undefined;
		// 	}
		// }

		function onKeyUp(event) {
			//when Enter key is pressed : after entering userName get userLoginType, after entering password get master token and after selecting user do login
			if (event.keyCode === 13 && vm.loginEnvironment && vm.user.username) {
				if (!vm.user.password) {
					getUserLoginType();
				} else if (vm.user.password && vm.loginTypeId === 1 && !vm.multipleUsers) {
					vm.getMasterToken();
				} else if (vm.multipleUsers) {
					vm.doLogin();
				}
			}
		}

		function redirectToSetPasswordWithDelay() {
			totalSeconds--;
			vm.remainingTimeToRedirect = totalSeconds;

			if (vm.remainingTimeToRedirect > 0) {
				setPasswordTimeoutPromise = $timeout(redirectToSetPasswordWithDelay, 1000);
			} else if (vm.remainingTimeToRedirect === 0) {
				redirectToSetPassword();
			}
		}

		function redirectToSetPassword() {
			//call forgot password api and once it is success redirect user to set password page
			vm.processing = true;
			var record = {
				Username: vm.masterUserName,
				env: $localStorage.env.code
			}
			$timeout.cancel(setPasswordTimeoutPromise);
			api.webPost($localStorage.authBaseUrl + '/forgot', record).then(function () {
				$state.go('app.auth_set_password', { userName: vm.user.username });
			}).catch(function (error) {
				vm.processing = false;
				vm.responseError = true;
				vm.requireResetPassword = false;

				var translatableKey;
				switch (error.status) {
					case 429:
						translatableKey = 'LOGIN.ERRORS.TOO_MANY_REQUESTS';
						break;
					default:
						translatableKey = 'LOGIN.ERRORS.UNEXPECTED_ERROR';
				}

				vm.error = $filter('translate')(translatableKey);
				vm.errorCode = error.status;
			})
			.finally(function () {
				vm.processing = false;
			});
		}

		function onEnvironmentChange(envCode) {
			// when environment dropdown is enabled we need to change authBaseUrl for Gen Prod, Demo, UA PROD & UA UAT
			// as discussed with Amardeep we will hard code https://auth.trasix.one for all other environments we will use the configured authBaseUrl
			if(envCode === 'GPR' || envCode === 'DEM' || envCode === 'UAP' || envCode === 'UAU' || envCode === 'UASTL') {
				authBaseUrl = CONSTANTS.AUTH_URL;
			} else {
				authBaseUrl = configuredAuthBaseUrl;
			}
			$localStorage.authBaseUrl = authBaseUrl;
		}

		//setting up environments
		function getEnvironments() {
			return api.webGet(authBaseUrl + '/environments')
				.then(function (response) {
					if (angular.isDefined(response) && angular.isDefined(response.data)) {
						vm.apiEnvs = $filter('orderBy')(response.data, 'name');
					}
				});
		}

		function changeUser(user) {
			vm.selectedUser = user;
		}

		function doLogin() {
			vm.processing = true;
			vm.isDisabled = true;
			// when user login after switch user the vm.loginEnvironment will be undefined
			var envCode = angular.isDefined(vm.loginEnvironment) && angular.isDefined(vm.loginEnvironment.code) ? vm.loginEnvironment.code : $localStorage.env.code;
			var user = {
				env      : envCode,
				username : vm.selectedUser.username
			}

			//pass master token to get child token
			authFactory.getChildToken(user, masterToken).then(function(childTokenResponse) {
				var childUserName= undefined; //we are setting child user name to undefined when calling setProfileInformation if it is master user
				if(childTokenResponse !== undefined) {
					childUserName = vm.selectedUser.username;
				}
				catalogFactory.setCatalogRequestDispatchStatus(false);
				if(vm.masterUserName === '') { // when loggin in after swtching to child user
					vm.masterUserName = $localStorage.user.masterUserName
				}

				callProfileInformationAndRedirectToLandingPage(rolesModel, vm.masterUserName, childUserName, vm.loginTypeId);

			}).catch(function (error) {
				vm.processing = false;
				vm.responseError = true;

				var translatableKey;
				var errCode = angular.isDefined(error.data) && error.data && angular.isDefined(error.data.errorCode) ? error.data.errorCode : 999;
				switch (error.status) {
					case 400:
					case 401:
						if (errCode === 10010) {
							translatableKey = 'LOGIN.SERVER_ERROR.INVALID_CREDENTIAL';
						} else if (errCode === 10100) {
							translatableKey = 'LOGIN.SERVER_ERROR.USERNAME_NOT_ALLOWED';
						} else if (errCode === 10010) {
							translatableKey = 'LOGIN.SERVER_ERROR.INVALID_USERNAME';
						} else if (errCode === 10110) {
							translatableKey = 'LOGIN.ERRORS.UNEXPECTED_ERROR';
						} else if(errCode === 10150) {
							translatableKey = 'LOGIN.SERVER_ERROR.USER_DEACTIVATED';
						} else if (errCode === 10140) {
							translatableKey = 'LOGIN.SERVER_ERROR.USERNAME_NOT_ALLOWED_IN_CURRENT_CLIENT';
						} else {
							translatableKey = 'LOGIN.ERRORS.UNEXPECTED_ERROR';
						}
						break;
					case 500:
						translatableKey = 'LOGIN.ERRORS.UNEXPECTED_ERROR';
						break;
					case 429:
						translatableKey = 'LOGIN.ERRORS.TOO_MANY_REQUESTS';
						break;
					default:
						translatableKey = 'LOGIN.ERRORS.UNEXPECTED_ERROR';
				}

				vm.error = $filter('translate')(translatableKey);
				vm.errorCode = errCode;
			}).finally(function () {
				vm.isDisabled = false;
			});
		}

		function redirectToLandingPage() {
			if (angular.isDefined($localStorage.lastState)) {
				$state.go($localStorage.lastState.name, $localStorage.lastState.params);
			}
			else {
				$state.go(CONSTANTS.LANDING_PAGE.STATE);
			}
		}

		function showInvalidUserAccountErrorMessage(responseError) {
			vm.responseError = true;
			if (angular.isDefined(responseError) && angular.isArray(responseError.data)) {
				if (responseError.status === 401) {
					angular.forEach(responseError.data, function (error) {
						if (error.ErrorCode === 1){
							vm.error = $filter('translate')('LOGIN.SERVER_ERROR.USER_NOT_EXIST_INVALID_CREDENTIAL');
							vm.errorCode =  error.ErrorCode;
						} else if(error.ErrorCode === 4) {
							vm.error = $filter('translate')('LOGIN.SERVER_ERROR.USER_DEACTIVATED');
							vm.errorCode =  error.ErrorCode;
						}
					});
				}
			}
		}

		function callProfileInformationAndRedirectToLandingPage(rolesModel, masterUserName, childUserName, loginType) {
			authFactory.setProfileInformation(rolesModel, masterUserName, childUserName, loginType)
			.then(function () {
				redirectToLandingPage();
			}).catch(function (error) {
				vm.processing = false;
				vm.processingExternal = false;
				showInvalidUserAccountErrorMessage(error);
			});
		}

		function getMyUsersListAndRedirectToUsersListPage(loginType, isSwitchUser) {
			var envCode = '';
			if(!isSwitchUser) {
				envCode = vm.loginEnvironment.code;
			} else { // get the env code from local storage
				envCode = $localStorage.env.code;
				masterToken = $auth.getToken();
				if(masterToken === null) {
					masterToken = $sessionStorage.accessToken ? $sessionStorage.accessToken : $localStorage.accessToken;
				}
			}
			authFactory.getMyUsersList(clientId, envCode, masterToken)
			.then(function (users) {
				vm.responseError = false;
				if(loginType === 2 || loginType === 5) {
					vm.activeDirectoryLoggingIn = true;
				}
				if (angular.isUndefined(users) || users.length !== 0) {
					// set token in session storage so that when user hard refresh and try to switch user we will have token to get users list
					$localStorage.accessToken = $sessionStorage.accessToken = masterToken;
					// set the users count which will be used to enable/disable switch user action
					$localStorage.allowedChildUsersCount = $sessionStorage.allowedChildUsersCount = users.length;
					if (users.length === 1) {
						if(users[0].username.toLowerCase() === vm.masterUserName) {
							$auth.setToken(masterToken);
							vm.selectedUser = users[0];
							// the master user has no child users, so the users list is skipped and the window has
							// to be closed here before redirecting to the landing page
							closeExternalLoginWindow(loginType);
							callProfileInformationAndRedirectToLandingPage(rolesModel, vm.selectedUser.username, undefined, vm.loginTypeId);
						} else {
							//only one user and it is a child user
							vm.usersList = users;
							vm.multipleUsers = true;
							vm.processing = false;
							vm.processingExternal = false;
							closeExternalLoginWindow(loginType);
						}
					} else {
						vm.usersList = users;
						if(!vm.isSwitchUser) { // scroll to master user and highlight it when login
							vm.selectedUser = utility.filterObject(vm.usersList, {masterUser : -1}, true)[0];
						} else { // scroll to switched user and highlight it when switch user
							// if child user name defined it a child user
							var userName = angular.isDefined($localStorage.user.childUserName) ? $localStorage.user.childUserName : $localStorage.user.masterUserName;
							vm.selectedUser = utility.filterObject(vm.usersList, {username : userName}, true)[0];
							vm.loginTypeId = loginType;
						}
						timeoutPromise = $timeout(function () {
							var el = $document[0].querySelector('[id="user-' + vm.selectedUser.username + '"]');
							el.parentNode.scrollTop = el.offsetTop;
						});

						vm.multipleUsers = true;
						vm.processing = false;
						vm.processingExternal = false;
						closeExternalLoginWindow(loginType);
					}
				} else {
					if(loginType === 2 || loginType === 5) {
						vm.activeDirectoryLoggingIn = false;
					}
					vm.processingExternal = false;
					vm.processing = false;
					vm.responseError = true;
					vm.error = $filter('translate')('LOGIN.SERVER_ERROR.USERNAME_NOT_ALLOWED_IN_CURRENT_CLIENT');
					vm.errorCode = 10100;
					closeExternalLoginWindow(loginType);
				}
			}).catch(function () {
				vm.processing = false;
				if(loginType === 2 || loginType === 5) {
					externalLoginWindow.close();
					externalLoginWindow = undefined;
					cancelExternalLoginWindow();
				}
				toast.error('Unable to fetch user accounts logging in with master user');
				callProfileInformationAndRedirectToLandingPage(rolesModel, vm.masterUserName, undefined, vm.loginTypeId);
			});
		}

		$scope.$on('$destroy', function () {
			$window.removeEventListener('message', receiveMessage);
			$interval.cancel(externalLoginWindowInterval);
			$interval.cancel(externalLogoutWindowInterval);
			$timeout.cancel(timeoutPromise);
		});

	}
})();
(function ()
{
    'use strict';

    angular
        .module('app.main.auth.lock', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        // State
        $stateProvider.state('app.auth_lock', {
            url      : '/auth/lock',
            views    : {
                'main@'                       : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.auth_lock': {
                    templateUrl: 'app/main/auth/lock/lock.html',
                    controller : 'LockController as vm'
                }
            },
            bodyClass: 'lock'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/auth/lock');
    }

})();
(function () {
	'use strict';

	angular
		.module('app.main.auth.lock')
		.controller('LockController', LockController);

	/** @ngInject */
	function LockController($auth, $state, toast, $localStorage, api, authFactory, $timeout, $scope, $window, $interval, $filter, CONSTANTS) {
		/* jshint validthis: true */
		var vm = this;

		// Data
		var timeoutPromise;
		var externalLoginWindowInterval;
		var externalLoginWindow = undefined;
		vm.user = {
			username: '',
			password: ''
		};
		vm.processing = false;
		vm.isLoading = true;
		vm.loginType = '';
		vm.loggedInUsingExternalSystem = false;
		var firstName = '';
		var	lastName = '';
		vm.activeDirectoryLoggingIn = false;
		var masterToken;//keep master token in memory
		var clientId = 'T1U';// To check user has access to T1U


		// Methods
		vm.doLogin = doLogin;
		vm.doExternalLogin = doExternalLogin;
		vm.cancelExternalLoginWindow = cancelExternalLoginWindow;
		vm.onKeyUp = onKeyUp;


		activate();

		//////////

		function activate() {
			if (angular.isDefined($localStorage.profileInformation) && angular.isDefined($localStorage.profileInformation.FirstName)) {
				firstName = $localStorage.profileInformation.FirstName;
			}
			if (angular.isDefined($localStorage.profileInformation) && angular.isDefined($localStorage.profileInformation.LastName)) {
				lastName = $localStorage.profileInformation.LastName;
			}
			vm.userFullname = firstName + ' ' + lastName;

			if ($localStorage.user && angular.isDefined($localStorage.user.childUserName)) {
				vm.user.username = $localStorage.user.childUserName;
			} else if(angular.isDefined($localStorage.user.masterUserName)) {
				vm.user.username = $localStorage.user.masterUserName;
			}

			if (angular.isDefined($localStorage.user) && $localStorage.user['loginType']) {
				vm.loginType = $localStorage.user['loginType'];
			}

			if (vm.loginType === 2 || vm.loginType === 5) {
				$window.addEventListener('message', receiveMessage, false);
				vm.loggedInUsingExternalSystem = true;
			}
		}

		function receiveMessage(event) {
			masterToken = angular.fromJson(event.data).id_token;
			$auth.setToken(masterToken);
			if (angular.isUndefined($localStorage.user.childUserName)) {
				authFactory.setProfileInformation(api.roles.roles, $localStorage.user.masterUserName, undefined, vm.loginType)
					.then(function () {
						vm.activeDirectoryLoggingIn = true;
						vm.processingExternal = false;
						redirectToLandingPage();
						doExternalLogin();
					})
					.catch(function (error) {
						vm.processing = false;
						externalLoginWindow.close();
						externalLoginWindow = undefined;
						cancelExternalLoginWindow();
						showInvalidUserAccountErrorMessage(error);
					});
			} else {
				var childUserParam = {
					env			: $localStorage.env.code,
					username	: $localStorage.user.childUserName
				}
				authFactory.getChildToken(childUserParam, masterToken)
				.then(function () {
					authFactory.setProfileInformation(api.roles.roles, $localStorage.user.masterUserName, $localStorage.user.childUserName, vm.loginType)
						.then(function () {
							vm.activeDirectoryLoggingIn = true;
							vm.processingExternal = false;
							redirectToLandingPage();
							doExternalLogin();
						})
						.catch(function (error) {
							vm.processing = false;
							externalLoginWindow.close();
							externalLoginWindow = undefined;
							cancelExternalLoginWindow();
							showInvalidUserAccountErrorMessage(error);
						});
				});
			}
		}

		function doExternalLogin() {
			if (angular.isDefined(externalLoginWindow) && externalLoginWindow !== null) {
				externalLoginWindow.close();
				externalLoginWindow = undefined;
				vm.processingExternal = false;
			} else {
				var externalLoginWindowUrl;
				if(vm.user.username === $localStorage.user.childUserName) {
					vm.user.username = $localStorage.user.masterUserName;
				}
				externalLoginWindowUrl =  $localStorage.authBaseUrl + '/gotologin?Username=' + vm.user.username + '&EnvCode=' + $localStorage.env.code + '&ClientCode=' + clientId;
				vm.processingExternal = true;
				externalLoginWindow = $window.open(externalLoginWindowUrl, '_blank', 'width=500,height=500');
				externalLoginWindowInterval = $interval(function () {
					if (angular.isUndefined(externalLoginWindow) || externalLoginWindow === null || externalLoginWindow.closed) {
						cancelExternalLoginWindow();
					}
				}, 1000);
			}
		}

		function cancelExternalLoginWindow() {
			if (angular.isDefined(externalLoginWindow)) {
				doExternalLogin();
			}
			if (externalLoginWindowInterval) {
				$interval.cancel(externalLoginWindowInterval);
				externalLoginWindowInterval = undefined;
			}
		}

		function doLogin() {
			vm.processing = true;
			if (angular.isUndefined($localStorage.baseUrl)) {
				toast.error('LOGIN.ERRORS.ENV', '', '', '');
				timeoutPromise = $timeout(function () {
					$state.go('app.auth_login');
				}, 1500);
			}
			vm.user.env = $localStorage.env.code;
			vm.user.grant_type = 'password';
			vm.user.client_code = clientId;
			vm.loginEnvironment = { url: $localStorage.baseUrl };
			if (angular.isUndefined($localStorage.user.childUserName)) {
				authFactory.getMasterToken(vm.user)
				.then(function (response) {
					masterToken = response.data.access_token;
					$auth.setToken(masterToken);
					authFactory.setProfileInformation(api.roles.roles, $localStorage.user.masterUserName, undefined , vm.loginType)
					.then(function () {
						redirectToLandingPage();
					})
					.catch(function (error) {
						vm.processing = false;
						showInvalidUserAccountErrorMessage(error);
					});
				})
				.catch(function (error) {
					vm.processing = false;
					vm.responseError = true;

					var translatableKey;
					var errCode = angular.isDefined(error.data) && angular.isDefined(error.data.errorCode) ? error.data.errorCode : 999;
					switch (error.status) {
						case 400:
						case 401:
							if (errCode === 10010) {
								translatableKey = 'LOGIN.SERVER_ERROR.INVALID_CREDENTIAL';
							} else if (errCode === 10100) {
								translatableKey = 'LOGIN.SERVER_ERROR.USERNAME_NOT_ALLOWED';
							} else if (errCode === 10010) {
								translatableKey = 'LOGIN.SERVER_ERROR.INVALID_USERNAME';
							} else if (errCode === 10110) {
								translatableKey = 'LOGIN.ERRORS.UNEXPECTED_ERROR';
							} else if (errCode === 10140) {
								translatableKey = 'LOGIN.SERVER_ERROR.USERNAME_NOT_ALLOWED_IN_CURRENT_CLIENT';
							} else {
								translatableKey = 'LOGIN.ERRORS.UNEXPECTED_ERROR';
							}
							break;
						case 500:
							translatableKey = 'LOGIN.ERRORS.UNEXPECTED_ERROR';
							break;
						default:
							translatableKey = 'LOGIN.ERRORS.UNEXPECTED_ERROR';
					}

					vm.error = $filter('translate')(translatableKey);
					vm.errorCode = errCode;
				});

			} else {
				vm.user.username = $localStorage.user.masterUserName;
				var childUserParam = {
					env			: $localStorage.env.code,
					username	: $localStorage.user.childUserName
				}
				authFactory.getMasterToken(vm.user)
				.then(function (response) {
					masterToken = response.data.access_token;
					$auth.setToken(masterToken);
					authFactory.getChildToken(childUserParam, masterToken)
						.then(function () {
							authFactory.setProfileInformation(api.roles.roles, $localStorage.user.masterUserName, $localStorage.user.childUserName, vm.loginType)
								.then(function () {
									redirectToLandingPage();
								})
								.catch(function (error) {
									vm.processing = false;
									showInvalidUserAccountErrorMessage(error);
								});
						});
				})
				.catch(function (error) {
					vm.processing = false;
					vm.responseError = true;

					var translatableKey;
					var errCode = angular.isDefined(error.data) && angular.isDefined(error.data.errorCode) ? error.data.errorCode : 999;
					switch (error.status) {
						case 400:
						case 401:
							if (errCode === 10010) {
								translatableKey = 'LOGIN.SERVER_ERROR.INVALID_CREDENTIAL';
							} else if (errCode === 10100) {
								translatableKey = 'LOGIN.SERVER_ERROR.USERNAME_NOT_ALLOWED';
							} else if (errCode === 10010) {
								translatableKey = 'LOGIN.SERVER_ERROR.INVALID_USERNAME';
							} else if (errCode === 10110) {
								translatableKey = 'LOGIN.ERRORS.UNEXPECTED_ERROR';
							} else if (errCode === 10140) {
								translatableKey = 'LOGIN.SERVER_ERROR.USERNAME_NOT_ALLOWED_IN_CURRENT_CLIENT';
							} else {
								translatableKey = 'LOGIN.ERRORS.UNEXPECTED_ERROR';
							}
							break;
						case 500:
							translatableKey = 'LOGIN.ERRORS.UNEXPECTED_ERROR';
							break;
						default:
							translatableKey = 'LOGIN.ERRORS.UNEXPECTED_ERROR';
					}

					vm.error = $filter('translate')(translatableKey);
					vm.errorCode = errCode;
				});

			}
		}

		function redirectToLandingPage() {
			if (angular.isDefined($localStorage.lastState)) {
				$state.go($localStorage.lastState.name, $localStorage.lastState.params);
			}
			else {
				$state.go(CONSTANTS.LANDING_PAGE.STATE);
			}
		}

		function showInvalidUserAccountErrorMessage(responseError) {
			vm.responseError = true;
			if (angular.isDefined(responseError) && angular.isArray(responseError.data)) {
				if (responseError.status === 401) {
					angular.forEach(responseError.data, function (error) {
						if (error.ErrorCode === 1){
							vm.error = $filter('translate')('LOGIN.SERVER_ERROR.USER_NOT_EXIST_INVALID_CREDENTIAL');
							vm.errorCode =  error.ErrorCode;
						} else if(error.ErrorCode === 4) {
							vm.error = $filter('translate')('LOGIN.SERVER_ERROR.USER_DEACTIVATED');
							vm.errorCode =  error.ErrorCode;
						}
					});
				}
			}
		}

		function onKeyUp(event) {
			//when Enter key is pressed after entering password do login
			if (event.keyCode === 13 && vm.user.password) {
				vm.doLogin();
			}
		}

		$scope.$on('$destroy', function () {
			if (angular.isFunction(timeoutPromise)) {
				$timeout.cancel(timeoutPromise);
			}
			$window.removeEventListener('message', receiveMessage);
			$interval.cancel(externalLoginWindowInterval);
		});
	}
})();
(function() {
    'use strict';

    angular
        .module('app.main.attributes.attributes-list')
        .run(runBlock);

    /** @ngInject */
    function runBlock(api, activityLogger, $state) {
       if (angular.isUndefined(api.attributes)) {
            api.attributes = {};
        }
        api.attributes.attributes = {
            modelPath: 'attributes.attributes',
            fields: [
                { field: 'Attributeid', type: 'int', displayLabel: 'ATTRIBUTES.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'AttributeDisplayName', type: 'text', displayLabel: 'ATTRIBUTES.FIELDS.NAME', visible: true, creatable: true, editable: true, inputType: 'text',
                    validation: {isRequired: true, maxLen: 200, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'AttributeSystemName', type: 'text', displayLabel: 'ATTRIBUTES.FIELDS.SYSTEM_NAME', visible: true, creatable: true, editable: false, inputType: 'text', checkIfUnique: true,
                    validation: {isRequired: true, maxLen: 128, minLen: 0, pattern: '(?!id|model_number|article_number|article_name|attribute_group_id|status|created_date|updated_date|created_by|updated_by|catalog_code|article_id|blocked|sort_order|locked|size_scale_id|shipment_window_range_id|block_image|shipmentstartdate|shipmentenddate|open)^[a-zA-Z][a-zA-Z0-9][a-zA-Z0-9_#@]*$', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: 'VALIDATIONS.PATTERN'}} },
                { field: 'AttributeTypeId', type: 'int', displayLabel: 'ATTRIBUTES.FIELDS.ATTRIBUTE_TYPE_ID', visible: false, creatable: true, editable: false, inputType: 'lookup', lookupSource: 'lists.attributeTypes',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'AttributeTypeId', type: 'int', displayLabel: 'ATTRIBUTES.FIELDS.ATTRIBUTE_TYPE_ID', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'DatasetId', type: 'int', displayLabel: 'ATTRIBUTES.FIELDS.DATASET_ID', visible: true, creatable: true, editable: true, inputType: 'lookup', lookupSource: 'sellers.datasets',
                    validation: {isRequired: 'vm.record.AttributeTypeId === 16', maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'DataTableAttributes', type: 'text', displayLabel: 'ATTRIBUTES.FIELDS.DATATABLE_ATTRIBUTES', visible: true, creatable: true, editable: true, inputType: 'lookup-many', lookupSource: 'attributes.attributes',
                    lookupFilterWithArray: {'AttributeTypeId': [1, 2, 3, 5, 9, 16 ]}, validation: {isRequired: 'vm.record.AttributeTypeId === 15', maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                    //due to time crunch this data type only will be use in view creator and this field's data type will be dynamically change at the time of create or update
                // { field: 'InitialValueAttribute', type: 'text', displayLabel: 'ATTRIBUTES.FIELDS.INITIAL_VALUE_ATTRIBUTE', visible: true, creatable: true, editable: true, inputType: 'custom-lookup', lookupSource: 'attributes.attributes', customLookupInfo: {value: 'value'},
                { field: 'InitialValueAttribute', type: 'text', displayLabel: 'ATTRIBUTES.FIELDS.INITIAL_VALUE_ATTRIBUTE', visible: true, creatable: true, editable: true, inputType: 'text',
                    validation: {isRequired: false, maxLen: 100, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'DefaultValue', type: 'text', displayLabel: 'ATTRIBUTES.FIELDS.DEFAULT_VALUE', visible: true, creatable: true, editable: true, inputType: 'textArea',
                    validation: {isRequired: false, maxLen: 4000, minLen: 0, pattern: '', disabledCriteria: 'vm.record.AttributeTypeId !== 1 && vm.record.AttributeTypeId !== 2 && vm.record.AttributeTypeId !== 3 && vm.record.AttributeTypeId !== 4 && vm.record.AttributeTypeId !== 5 && vm.record.AttributeTypeId !== 7 && vm.record.AttributeTypeId !== 8 && vm.record.AttributeTypeId !== 9',
                    messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ValidationExpression', type: 'text', displayLabel: 'ATTRIBUTES.FIELDS.VALIDATION_EXPRESSION', visible: true, creatable: true, editable: true, inputType: 'textArea',
                    validation: {isRequired: 'vm.record.AttributeTypeId === 6', maxLen: -1, minLen: 0, pattern: '', checkIfValidJson: true, disabledCriteria: 'vm.record.AttributeTypeId === 12', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '', isValidJson: 'VALIDATIONS.INVALID_JSON'}} },
                { field: 'ValidationMessage', type: 'text', displayLabel: 'ATTRIBUTES.FIELDS.VALIDATION_MESSAGE', visible: true, creatable: true, editable: true, inputType: 'textArea',
                    validation: {isRequired: false, maxLen: 200, minLen: 0, pattern: '', disabledCriteria: 'vm.record.AttributeTypeId === 12', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'IsRequired', type: 'text', displayLabel: 'ATTRIBUTES.FIELDS.IS_REQUIRED', visible: true, creatable: true, editable: true, inputType: 'bool',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Editable', type: 'text', displayLabel: 'ATTRIBUTES.FIELDS.EDITABLE', visible: true, creatable: true, editable: true, inputType: 'bool',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', disabledCriteria: 'vm.record.AttributeTypeId === 6', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Creatable', type: 'text', displayLabel: 'ATTRIBUTES.FIELDS.CREATEABLE', visible: true, creatable: true, editable: true, inputType: 'bool',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', disabledCriteria: 'vm.record.AttributeTypeId === 6', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Visible', type: 'text', displayLabel: 'ATTRIBUTES.FIELDS.VISIBLE', visible: true, creatable: true, editable: true, inputType: 'bool',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'VisibleInListByDefault', type: 'text', displayLabel: 'ATTRIBUTES.FIELDS.VISIBLE_IN_LIST_DEFAULT', visible: true, creatable: true, editable: true, inputType: 'bool',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ShowInEdit', type: 'text', displayLabel: 'ATTRIBUTES.FIELDS.SHOW_IN_EDIT', visible: true, creatable: true, editable: true, inputType: 'bool',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'SupportFilterLookup', type: 'text', displayLabel: 'ATTRIBUTES.FIELDS.SUPPORT_FILTER_LOOKUP', visible: true, creatable: true, editable: true, inputType: 'bool',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'IsSeasonless', type: 'text', displayLabel: 'ATTRIBUTES.FIELDS.IS_SEASONLESS_ARTICLE_ATTRIBUTES', visible: true, creatable: true, editable: false, showInEdit: true, inputType: 'bool-int',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', disabledCriteria: 'vm.record.Overridable === 1 || (!vm.isNew && !field.editable) || vm.record.IsSeasonlessModelAttribute === 1', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'IsSeasonlessModelAttribute', type: 'text', displayLabel: 'ATTRIBUTES.FIELDS.IS_SEASONLESS_MODEL_ATTRIBUTES', visible: true, creatable: true, editable: false, showInEdit: true, inputType: 'bool-int',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', disabledCriteria: 'vm.record.Overridable === 1 || (!vm.isNew && !field.editable) || vm.record.IsSeasonless === 1 || vm.record.AttributeTypeId === 13', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedDate', type: 'text', displayLabel: 'ATTRIBUTES.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedDate', type: 'text', displayLabel: 'ATTRIBUTES.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'AttributeTypeName', type: 'text', displayLabel: 'ATTRIBUTES.FIELDS.ATTRIBUTE_TYPE_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: 25, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'AttributeSource', type: 'text', displayLabel: 'ATTRIBUTES.FIELDS.ATTRIBUTE_SOURCE', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedBy', type: 'text', displayLabel: 'ATTRIBUTES.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedBy', type: 'text', displayLabel: 'ATTRIBUTES.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Overridable', type: 'text', displayLabel: 'ATTRIBUTES.FIELDS.OVERRIDABLE', visible: true, creatable: true, editable: false, showInEdit: true, inputType: 'bool-int',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', disabledCriteria: '(vm.record.AttributeTypeId === 10 || vm.record.AttributeTypeId === 11 || vm.record.AttributeTypeId === 13 || vm.record.AttributeTypeId === 15 || vm.record.IsSeasonless === 1 || vm.record.IsSeasonlessModelAttribute === 1) || (!vm.isNew && !field.editable)', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
            ],
            uniqueConstraints: [
                {name: 'Constraint 1', fields: ['AttributeSystemName']}
            ],
            title: 'ATTRIBUTES.NAV',
            icon: 'icon-dice-1',
            idField: 'Attributeid',
            lookupDisplayField: 'AttributeDisplayName',
            methods: {
                getList         :   getAttributes,
                getDetails      :   getAttribute,
                create          :   createAttribute,
                update          :   updateAttribute
            },
            views: {
                mainList: {
                    columns         : [ 'AttributeDisplayName', 'AttributeSystemName', 'UpdatedDate', 'AttributeTypeName', 'AttributeSize', 'IsRequired' ],
                    columnFilter    : {},
                    toggleFilterProps: {},
                    topIndex        : 0,
                    showFilterRow   : false,
                    sortColumn      : {'UpdatedDate': false},
                    itemActions     : [
                                        { id: 'view', label: 'ACTIONS.VIEW', icon: 'icon-magnify', privilege: 'GetAttributeDetailsById',  visible: true },
                                        { id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UpdateAttribute', visible: true }
                                      ],
                    listActions     : [],
                    fabAction       : {id: 'add', label: 'ACTIONS.ADD', icon: 'icon-plus', privilege: 'CreateAttribute', visible: true}
                 },
                 mainDetails: {
                     selectedTabIndex   : 0,
                     itemActions        : [],
                     fab                : {id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UpdateAttribute', visible: true}
                 },
                 privileges: {
                     list: 'GetAttributeList',
                     details: 'GetAttributeDetailsById'
                 }
            }
        };

        function getAttributes(generalProperties) {
            var promise;
            if(angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
                var state = {};
                state.name = $state.current.name;
                state.params = $state.params;
                var isBulk = true;
                var logData = activityLogger.createLogData(null, state, 'attributes.attributes', 'VIEW', isBulk, new Date(), null, null);
                promise = api.webGet(api.baseUrl + '/attributes', undefined, true, generalProperties.forceFetch);
                promise = activityLogger.log(logData, promise);
            }
            else{
                promise = api.webGet(api.baseUrl + '/attributes', undefined, true, generalProperties.forceFetch);
            }

            promise.then(function() {
                if (api.attributes.attributes.isDirty) {
                    //Invalidate lookupData
                    api.attributes.attributes.lookupData = undefined;
                    api.attributes.attributes.isDirty = false;
                }
            });
            return promise;
		}

		function getAttribute(isLogRequired, attributeId) {
            var promise;
            if(angular.isDefined(isLogRequired) && isLogRequired === true) {
                var state = {};
                state.name = $state.current.name;
                state.params = $state.params;
                var isBulk = false;
                var items= [];
                promise = api.webGet(api.baseUrl + '/attributes/'+ attributeId);
                promise.then(function(response) {
                    items.push(response.data[api.attributes.attributes.lookupDisplayField]);
                }, function(response) {
                    items.push(response.data[api.attributes.attributes.lookupDisplayField]);
                });
                var logData = activityLogger.createLogData(items, state, 'attributes.attributes', 'VIEW', isBulk, new Date(), null, null);
                promise = activityLogger.log(logData, promise);
            }
            else {
                promise = api.webGet(api.baseUrl + '/attributes/'+ attributeId);
            }
            return promise;
		}

		function createAttribute(attribute) {
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var logData = activityLogger.createLogData(attribute[api.attributes.attributes.lookupDisplayField], state, 'attributes.attributes', 'ADD', false, new Date(), null, null);
			var promise = api.webPost(api.baseUrl + '/attributes', attribute);

            promise.then(function() {
               api.attributes.attributes.isDirty = true;
               api.catalogs.requestAttributes.isDirty = true;
               api.catalogs.bucketLevelAttributes = true;
            });
            return activityLogger.log(logData, promise);
		}

		function updateAttribute(attributeId, attribute) {
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var logData = activityLogger.createLogData(attribute[api.attributes.attributes.lookupDisplayField], state, 'attributes.attributes', 'EDIT', false, new Date(), null, null);
			var promise = api.webPut(api.baseUrl + '/attributes/'+ attributeId, attribute);

            promise.then(function() {
               api.attributes.attributes.isDirty = true;
               api.catalogs.requestAttributes.isDirty = true;
               api.catalogs.bucketLevelAttributes = true;
            });
            return activityLogger.log(logData, promise);
		}

    }
})();
(function() {
    'use strict';

    angular
        .module('app.main.attributes.attribute-groups')
        .run(runBlock);

    /** @ngInject */
    function runBlock(api, activityLogger, $state, jobsTracker, CONSTANTS) {
       if (angular.isUndefined(api.attributes)) {
            api.attributes = {};
        }
        api.attributes.attributeGroups = {
            modelPath: 'attributes.attributeGroups',
            fields: [
                { field: 'AttributeGroupId', type: 'int', displayLabel: 'ATTRIBUTE_GROUPS.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'AttributeGroupName', type: 'text', displayLabel: 'ATTRIBUTE_GROUPS.FIELDS.NAME', visible: true, creatable: true, editable: true, inputType: 'text',
                    validation: {isRequired: true, maxLen: 100, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'AttributeGroupTable', type: 'text', displayLabel: 'ATTRIBUTE_GROUPS.FIELDS.GROUP_TABLE', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ListAttributeResponse', type: 'object-array', displayLabel: 'ATTRIBUTE_GROUPS.FIELDS.LIST_ATTRIBUTE_RESPONSE', visible: false, creatable: false, editable: false, inputType: 'object-array',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ServerErrors', type: 'text', displayLabel: 'ATTRIBUTE_GROUPS.FIELDS.SERVER_ERRORS', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedDate', type: 'text', displayLabel: 'ATTRIBUTE_GROUPS.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedDate', type: 'text', displayLabel: 'ATTRIBUTE_GROUPS.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'AttributeidsList', type:'text', displayLabel: 'ATTRIBUTE_GROUPS.FIELDS.ATTRIBUTES_LIST', visible: false, creatable: true, editable: true, inputType: 'lookup-many', lookupSource: 'attributes.attributes', nonRemovableChips: true,
                    lookupFilter: {IsSeasonless: 0, IsSeasonlessModelAttribute: 0},validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
            ],
            uniqueConstraints: [
                {name: 'Constraint 1', fields: ['AttributeGroupName']}
            ],
            title: 'ATTRIBUTE_GROUPS.NAV',
            icon: 'icon-bulletin-board',
            idField: 'AttributeGroupId',
            lookupDisplayField: 'AttributeGroupName',
            isBulkActionCompleted: false,
            restrictSaveWithoutChange: true, // block saving the edit dialog when nothing was changed
            methods: {
                getList         :   getAttributeGroups,
                getListByEntity :   getAttributeGroupsByAttributeId,
                getDetails      :   getAttributeGroup,
                create          :   createAttributeGroup,
                update          :   updateAttributeGroup
            },
            views: {
                mainList: {
                    columns         : [ 'AttributeGroupName', 'AttributeGroupTable', 'UpdatedDate', 'CreatedDate'],
                    columnFilter    : {},
                    toggleFilterProps: {},
                    topIndex        : 0,
                    showFilterRow   : false,
                    sortColumn      : {'UpdatedDate': false},
                    itemActions     : [
                                        { id: 'view', label: 'ACTIONS.VIEW', icon: 'icon-magnify', privilege: 'GetAttributeGroupDetails',  visible: true },
                                        { id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UpdateAttributeGroup', visible: true }
                                      ],
                    listActions     : [],
                    fabAction       : {id: 'add', label: 'ACTIONS.ADD', icon: 'icon-plus', privilege: 'CreateAttributeGroup', visible: true}
                 },
                 mainDetails: {
                     selectedTabIndex   : 0,
                     itemActions        : [],
                    //  fabAction          : {id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UpdateAttributeGroup', visible: true},
                     fab                : {id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UpdateAttributeGroup', visible: true}
                 },
                 privileges: {
                     list: 'GetAttributeGroupList',
                     details: 'GetAttributeGroupDetails'
                 }
            }
        };

		function getAttributeGroups(generalProperties) {
            // Clear the "records modified, please refresh" flag whenever the list is (re)fetched.
            api.attributes.attributeGroups.isBulkActionCompleted = false;
            var promise;

            if(angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
                var state = {};
                state.name = $state.current.name;
                state.params = $state.params;
                var isBulk = true;
                var logData = activityLogger.createLogData(null, state, 'attributes.attributeGroups', 'VIEW', isBulk, new Date(), null, null);

                promise = api.webGet(api.baseUrl + '/attributegroups', undefined, true, generalProperties.forceFetch);
                promise = activityLogger.log(logData, promise);
            }
            else {
                promise = api.webGet(api.baseUrl + '/attributegroups', undefined, true, generalProperties.forceFetch);
            }

            promise.then(function() {
                if (api.attributes.attributeGroups.isDirty) {
                    //Invalidate lookupData
                    api.attributes.attributeGroups.lookupData = undefined;
                    api.attributes.attributeGroups.isDirty = false;
                }
            });
            return promise;
		}

        function getAttributeGroupsByAttributeId(generalProperties, attributeId) {
            var promise;

            if(angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
                var state = {};
                state.name = $state.current.name;
                state.params = $state.params;
                var isBulk = true;
                var logData = activityLogger.createLogData(null, state, 'attributes.attributes', 'VIEW', isBulk, new Date(), null, null);
                if (generalProperties.forceFetch) {
                    api.attributes.attributeGroups.lookupData = undefined;
                }
                promise = api.webGet(api.baseUrl + '/attributes/' + attributeId + '/attributeGroups');
                promise = activityLogger.log(logData, promise);
            }
            else {
                promise = api.webGet(api.baseUrl + '/attributes/' + attributeId + '/attributeGroups');
            }
            return promise;
        }

        function getAttributeGroup(isLogRequired,  attributeGroupId) {
            // Clear the "record modified, please refresh" flag whenever the record is (re)fetched.
            api.attributes.attributeGroups.isBulkActionCompleted = false;
            var promise;
            if(angular.isDefined(isLogRequired) && isLogRequired === true) {
                var state = {};
                state.name = $state.current.name;
                state.params = $state.params;
                var isBulk = false;
                var items= [];
                promise = api.webGet(api.baseUrl + '/attributegroups/'+ attributeGroupId);
                promise.then(function(response) {
                    items.push(response.data[api.attributes.attributeGroups.lookupDisplayField]);
                }, function(response) {
                    items.push(response.data[api.attributes.attributeGroups.lookupDisplayField]);
                });
                var logData = activityLogger.createLogData(items, state, 'attributes.attributeGroups', 'VIEW', isBulk, new Date(), null, null);
                promise = activityLogger.log(logData, promise);
            }
            else {
                promise = api.webGet(api.baseUrl + '/attributegroups/'+ attributeGroupId);
            }
            return promise;
		}

		function createAttributeGroup(attributeGroup) {
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var logData = activityLogger.createLogData(attributeGroup[api.attributes.attributeGroups.lookupDisplayField], state, 'attributes.attributeGroups', 'ADD', false, new Date(), null, null);
			var promise = api.webPost(api.baseUrl + '/attributegroups', attributeGroup);

            promise.then(function() {
                api.attributes.attributeGroups.isDirty = true;
                api.catalogs.requestAttributes.isDirty = true;
                api.catalogs.bucketLevelAttributes = true;
            });
            return activityLogger.log(logData, promise);
		}

		function updateAttributeGroup(attributeGroupId, attributeGroup, parentId, model) {
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var logData = activityLogger.createLogData(attributeGroup[api.attributes.attributeGroups.lookupDisplayField], state, 'attributes.attributeGroups', 'EDIT', false, new Date(), null, null);
            // Updating an attribute group rebuilds its group table on the server, which is now a background job.
            // Enqueue + track it via jobsTracker (same pattern as submitOrders); the PUT returns the job Id.
            var jobModel = angular.isDefined(model) ? model : api.attributes.attributeGroups;
            var jobIndex = jobsTracker.addJob(jobModel, 'ATTRIBUTE_GROUPS.ACTIONS.UPDATE', 1);
			var promise = api.webPut(api.baseUrl + '/attributegroups/'+ attributeGroupId + '?sourceapplication=' + CONSTANTS.SOURCE_APPLICATION + '&sourceaction=Update Attribute Group', attributeGroup);

            promise.then(function(response) {
                // A falsy job Id (0) means the attribute(s) already exist in this group server-side,
                // so no background work was queued. Mark the job completed successfully instead of
                // polling; it keeps no serverId, so clicking it in the tracker opens no details
                // (quick-panel gotoJob() no-ops when the serverId is undefined).
                var backgroundJobId = response.data && response.data.Id;
                if (backgroundJobId) {
                    jobsTracker.trackJob(jobIndex, backgroundJobId);
                } else {
                    jobsTracker.setCompleted(jobIndex);
                }
                api.attributes.attributeGroups.isDirty = true;
                api.catalogs.requestAttributes.isDirty = true;
                api.catalogs.bucketLevelAttributes = true;
            }, function(error) {
                jobsTracker.setCriticlaFail(jobIndex, error);
            });
            return activityLogger.log(logData, promise);
		}

    }
})();
(function () {
	'use strict';

	angular
		.module('app.main.catalogs.article-states')
		.controller('articleStatesListController', articleStatesListController);

	/* @ngInject */
	function articleStatesListController(api, $state, $rootScope, $scope, $document, $mdDialog, settingsFactory, crud, catalogFactory, utility) {
		/* jshint validthis: true */
		var vm = this;
		var activeCatalog = catalogFactory.getActiveCatalog();
		var catalogCode = activeCatalog.CatalogCode;
		var sellerId = activeCatalog.AccountId;
		var attributeGroupId = activeCatalog.AttributeGroupId;

		vm.model = angular.copy(api.catalogs.articleStates);
		// hide all the actions for child catalog
		if(activeCatalog.DataSourceTypeId === 3) {
			hideStateActions();
		}
		settingsFactory.applyPersistedListViewLayout(vm.model);

		vm.articleStates = [];
		vm.filteredArticleStates = [];
		vm.isLoading = false;


		vm.refreshItems = refreshItems;
		vm.doListAction = doListAction;
		vm.doItemAction = doItemAction;
		vm.viewItem = viewItem;
		vm.addUpdateRecord = addUpdateRecord;

		activate();

		////////////////

		function activate() {
			refreshItems(vm.model.isDirty, true);
		}

		function refreshItems(forceFetch, isLogRequired) {
			var generalProperties = {
				forceFetch: forceFetch,
				isLogRequired: isLogRequired
			}
			vm.isLoading = true;

			vm.model.methods.getList(generalProperties, sellerId, attributeGroupId)
				.then(function (response) {
					vm.articleStates = response.data;
					// assign the updated list in the api.articleStatesList
					api.articleStatesList = vm.articleStates;
				})
				.finally(function () {
					vm.isLoading = false;
				});
		}

		//Item Action button pressed event
		function doItemAction(action, record) {
			if (action && record) {
				switch (action.id) {
					case 'view':
						viewItem(record);
						break;
					case 'edit':
						addUpdateRecord(null, record);
						break;
					case 'delete':
					case 'activate':
						vm.model.methods.activateBulk(record, vm.model, action.id, sellerId, attributeGroupId);
						break;
				}
			}
		}

		//List Action button pressed event
		function doListAction(action, records) {
			if (action) {
				switch (action.id) {
					case 'delete':
					case 'activate':
						vm.model.methods.activateBulk(records, vm.model, action.id, sellerId, attributeGroupId);
						break;
				}
			}
		}

		function viewItem(record) {
			var id = record[vm.model.idField];
			var stateParams = { id: id };
			$state.go('app.article_states_details', stateParams);
		}

		function addUpdateRecord(ev, record) {
			var modelCopy = angular.copy(vm.model);
			var lookupPromises = {};
			lookupPromises = crud.createLookupPromise(modelCopy, undefined, 'create');
			$mdDialog.show({
				controller: 'addOrUpdateArticleStatesController',
				controllerAs: 'vm',
				templateUrl: 'app/main/article-states/dialogs/add-update-article-states/add-update-article-states.html',
				parent: angular.element($document.body),
				targetEvent: ev,
				clickOutsideToClose: false,
				locals: {
					record: record,
					isNew: angular.isDefined(record) ? false: true,
					model: vm.model,
					existingRecordsForUniqueValue: angular.copy(vm.articleStates),
					lookupPromises: lookupPromises,
					sellerId: sellerId,
					attributeGroupId: attributeGroupId,
					event: ev
				}
			}).then(function(saved) {
				if (saved) {
					refreshItems(true, false);
				}
			});
		}

		function hideStateActions() {
			utility.filterObject(vm.model.views.mainList.itemActions, { id: 'edit' }, true)[0].visible = false;
			utility.filterObject(vm.model.views.mainList.itemActions, { id: 'delete' }, true)[0].visible = false;
			utility.filterObject(vm.model.views.mainList.itemActions, { id: 'activate' }, true)[0].visible = false;
			vm.model.views.mainList.listActions = [];
			vm.model.views.mainList.fabAction.visible = false;
			vm.model.views.mainDetails.itemActions = [];
			vm.model.views.mainDetails.fab.visible = false;
		}

		var catalogChangedEventCleanup = $rootScope.$on('ActiveCatalogChangedEvent', function (e) {
			if (catalogCode !== catalogFactory.getActiveCatalog().CatalogCode) {
				$state.reload('app.article_states');
			}
		});

		$scope.$on('$destroy', function () {
			catalogChangedEventCleanup();
		});
	}
})();
(function() {
	'use strict';

	angular
		.module('app.main.catalogs.article-states')
		.controller('articleStateDetailsController', articleStateDetailsController);

	/* @ngInject */
	function articleStateDetailsController(api, $stateParams, $state, $rootScope, settingsFactory, catalogFactory, utility, $document, $mdDialog, crud) {
		/* jshint validthis: true */
		var vm = this;
		var articleStateId = $stateParams.id;
		var activeCatalog = catalogFactory.getActiveCatalog();
		var sellerId = activeCatalog.AccountId;
		var attributeGroupId = activeCatalog.AttributeGroupId;

		vm.model = api.catalogs.articleStates;

		vm.stateRequiredAttributesModel = api.articleStates.requiredAttributes;
		settingsFactory.applyPersistedListViewLayout(vm.stateRequiredAttributesModel);

		vm.stateNonEditableAttributesModel = api.articleStates.nonEditableAttributes;
		settingsFactory.applyPersistedListViewLayout(vm.stateNonEditableAttributesModel);

		vm.articleState = {};

		vm.stateRequiredAttributes = [];
		vm.filteredStateRequiredAttributes = [];

		vm.stateNonEditableAttributes = [];
		vm.filteredStateNonEditableAttributes = [];

		vm.isLoading = false;

		vm.refreshRecord = refreshRecord;
		vm.doItemAction = doItemAction;
		vm.editItem = editItem;

		activate();

		////////////////

		function activate() {
			refreshRecord(true);
		}

		function refreshRecord(isLogRequired) {
			vm.isLoading = true;
			var generalProperties = {
				forceFetch: true,
				isLogRequired: isLogRequired
			}

			vm.model.methods.getList(generalProperties, sellerId, attributeGroupId)
				.then(function (response) {
					vm.articleState = utility.filterObject(response.data, {StateId: parseInt(articleStateId)}, true)[0];
					vm.stateRequiredAttributes = vm.articleState.RequiredAttributes;
					vm.stateNonEditableAttributes = vm.articleState.NonEditableAttributes;
					vm.title = angular.copy(vm.articleState[vm.model.lookupDisplayField]);

					// update Breadcrumb
					$state.current.data.displayName = vm.title;
					$rootScope.$broadcast('breadcrumb-updated');
				})
				.finally(function () {
					vm.isLoading = false;
				});
		}

		function doItemAction(action, record) {
			if (action) {
				switch (action.id) {
					case 'delete':
					case 'activate':
						vm.model.methods.activateBulk(record, vm.model, action.id, sellerId, attributeGroupId);
					break;
				}
			}
		}

		function editItem(record, ev) {
			var modelCopy = angular.copy(vm.model);
			var lookupPromises = {};
			lookupPromises = crud.createLookupPromise(modelCopy, undefined, 'create');
			$mdDialog.show({
				controller: 'addOrUpdateArticleStatesController',
				controllerAs: 'vm',
				templateUrl: 'app/main/article-states/dialogs/add-update-article-states/add-update-article-states.html',
				parent: angular.element($document.body),
				targetEvent: ev,
				clickOutsideToClose: false,
				locals: {
					record: record,
					isNew: false,
					model: vm.model,
					existingRecordsForUniqueValue: [],
					lookupPromises: lookupPromises,
					sellerId: sellerId,
					attributeGroupId: attributeGroupId,
					event: ev
				}
			}).then(function(saved) {
				if (saved) {
					refreshRecord(false);
				}
			});
		}
	}

})();
(function() {
    'use strict';

    angular
        .module('app.main.accounts.users')
        .run(runBlock);

    /* @ngInject */
    function runBlock(api, activityLogger, $state, crud) {

        if(angular.isUndefined(api.accounts)) {
            api.accounts = {};
        }
        api.accounts.users = {
            modelPath: 'accounts.users',
            fields: [
                { field: 'Id', type: 'int', displayLabel: 'USERS.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'AccountId', type: 'int', displayLabel: 'USERS.FIELDS.ACCOUNT_ID', visible: true, creatable: false, editable: false, inputType: 'static',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'AccountName', type: 'text', displayLabel: 'USERS.FIELDS.ACCOUNT_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'AccountTypeId', type: 'int', displayLabel: 'USERS.FIELDS.ACCOUNT_TYPE_ID', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'AccountType', type: 'text', displayLabel: 'USERS.FIELDS.ACCOUNT_TYPE', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'FirstName', type: 'text', displayLabel: 'USERS.FIELDS.FIRST_NAME', visible: true, creatable: false, editable: true, inputType: 'text',
                    validation: {isRequired: true, maxLen: 20, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'LastName', type: 'text', displayLabel: 'USERS.FIELDS.LAST_NAME', visible: true, creatable: false, editable: true, inputType: 'text',
                    validation: {isRequired: true, maxLen: 20, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Email', type: 'text', displayLabel: 'USERS.FIELDS.EMAIL', visible: true, creatable: false, editable: true, inputType: 'text',
                    validation: {isRequired: true, maxLen: 500, minLen: 1, pattern: '^[A-Za-z]+[A-Za-z0-9._+-]+@{1}[A-Za-z0-9._-]+\.[A-Za-z.]{2,}$', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: 'VALIDATIONS.INVALID_EMAIL'}} },
                { field: 'UserName', type: 'text', displayLabel: 'USERS.FIELDS.USER_NAME', visible: true, creatable: false, editable: true, inputType: 'text',
                    validation: {isRequired: true, maxLen: 50, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Phone', type: 'text', displayLabel: 'USERS.FIELDS.PHONE', visible: true, creatable: false, editable: true, inputType: 'tel',
                    validation: {isRequired: false, maxLen: 20, minLen: 0, pattern: '[0-9]*', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '',
                    invalidType: 'VALIDATIONS.INVALID_PHONE_NUMBER'}} },
                { field: 'CountryCode', type: 'text', displayLabel: 'USERS.FIELDS.COUNTRY', visible: false, creatable: false, editable: true, inputType: 'lookup', lookupSource: 'lists.countries',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CountryCode', type: 'text', displayLabel: 'USERS.FIELDS.COUNTRY_CODE', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Country', type: 'text', displayLabel: 'USERS.FIELDS.COUNTRY', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'City', type: 'text', displayLabel: 'USERS.FIELDS.CITY', visible: true, creatable: false, editable: true, inputType: 'text',
                    validation: {isRequired: false, maxLen: 25, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Designation', type: 'text', displayLabel: 'USERS.FIELDS.DESIGNATION', visible: true, creatable: false, editable: true, inputType: 'text',
                    validation: {isRequired: false, maxLen: 20, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Department', type: 'text', displayLabel: 'USERS.FIELDS.DEPARTMENT', visible: true, creatable: false, editable: true, inputType: 'text',
                    validation: {isRequired: false, maxLen: 20, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Status', type: 'text', displayLabel: 'USERS.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Roles', type: 'text', displayLabel: 'USERS.FIELDS.USER_ROLE', visible: true, creatable: false, editable: true, inputType: 'lookup-many', lookupSource: 'roles.roles',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'LicenseTypeIds', type: 'text', displayLabel: 'USERS.FIELDS.LICENSE_TYPES', visible: true, creatable: true, editable: true, inputType: 'lookup-many', lookupSource:'lists.licenseTypes',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'LastLoginTime', type: 'text', displayLabel: 'USERS.FIELDS.LAST_LOGIN_TIME', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: true, maxLen: 250, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'NotificationSubscribeTypes', type: 'text', displayLabel: 'USERS.FIELDS.NOTIFICATION_SUBSCRIBE_TYPES', visible: true, creatable: false, editable: false, inputType: 'lookup-many', lookupSource:'lists.notificationTypes',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: ''}},
                { field: 'CreateDate', type: 'text', displayLabel: 'USERS.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdateDate', type: 'text', displayLabel: 'USERS.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'RestrictFullRange', type: 'int', displayLabel: 'USERS.FIELDS.RESTRICT_FULL_RANGE', visible: true, creatable: false, editable: true, inputType: 'bool-int',
                    validation: {isRequired: false, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedBy', type: 'text', displayLabel: 'USERS.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedBy', type: 'text', displayLabel: 'USERS.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
               ],
            uniqueConstraints: [
                {name: 'Constraint 1', fields: ['AccountName']}
            ],
            title: 'USERS.NAV',
            icon: '',
            idField: 'Id',
            lookupDisplayField: 'UserName',
            isDirty: false,
            methods: {
                getList         :   getAllUsers,
                getDetails      :   getUser,
                activateBulk    :   activateUsers,
                update          :   updateUser,
                updateBulk      :   updateUsers,
                assignNotificationTypes: assignNotificationTypes,
                changeAccount   :   changeAccount
            },
            views: {
                mainList: {
                    columns             : [ 'UserName', 'AccountName', 'AccountType', 'Country', 'City', 'Status', 'UpdateDate' ],
                    columnFilter        : {},
                    toggleFilterProps   : { toggleStatus:false, filterProp:'Status', trueVal:1, trueValTooltipMessage: 'ACTIONS.TOGGLE_ACTIVE', falseVal:'', falseValTooltipMessage:"ACTIONS.TOGGLE_ALL"},
                    topIndex            : 0,
                    showFilterRow       : false,
                    sortColumn          : {'UpdateDate': false},
                    itemActions         : [
                                            { id: 'view', label: 'ACTIONS.VIEW', icon: 'icon-magnify', privilege: 'GetUserDetails', disabled: '!itm.Status', visible: true },
                                            { id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UpdateUser', disabled: '!itm.Status', visible: true },
                                            { id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateBulkUserStatus', disabled: false, visible: 'itm.Status',
                                                requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                                            { id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateBulkUserStatus', disabled: false, visible: '!itm.Status',
                                                requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'},
                                            { id: 'assignNotificationTypes', label: 'USERS.ACTIONS.ASSIGN_NOTIFICATION_TYPES', icon: 'icon-link', privilege: 'BulkSubscribeNotifications:true', disabled: false, visible: 'itm.AccountTypeId !== 1',
                                                requiresConfirmation: false, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'ARTICLES.MESSAGES.CONFIRM_ASSIGN'}, confirmationAction: 'ACTIONS.ASSIGN'}
                                            ],
                    listActions         : [
                                            { id: 'delete', label: 'ACTIONS.DELETE_BULK', icon: 'icon-delete', privilege: 'UpdateBulkUserStatus', disabled: '{selected: true, Status: 1}', visible: true,
                                                requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                                            { id: 'activate', label: 'ACTIONS.ACTIVATE_BULK', icon: 'icon-undo-variant', privilege: 'UpdateBulkUserStatus', disabled: '{selected: true, Status: 0}', visible: true,
                                                requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'},
                                            { id: 'updateBulk', label: 'ACTIONS.UPDATE_BULK', icon: 'icon-pencil', privilege: 'UpdateUserBulk:true', disabled: '{selected: true,  Status: 1}', visible: true, requiresConfirmation: false },
                                            { id: 'assignNotificationTypes', label: 'USERS.ACTIONS.ASSIGN_NOTIFICATION_TYPES', icon: 'icon-link', privilege: 'BulkSubscribeNotifications:true', disabled: '{selected: true, AccountTypeId: ["!1"]}', visible: true,
                                                requiresConfirmation: false, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'ARTICLES.MESSAGES.CONFIRM_ASSIGN'}, confirmationAction: 'ACTIONS.ASSIGN'},
                                            { id: 'changeAccount', label: 'USERS.ACTIONS.CHANGE_ACCOUNT', icon: 'icon-account-switch', privilege: 'ChangeUsersAccount:true', disabled: '{selected: true, AccountTypeId: ["!1"]}', visible: true,
                                                requiresConfirmation: false, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'ARTICLES.MESSAGES.CONFIRM_ASSIGN'}, confirmationAction: 'ACTIONS.ASSIGN'}
                                        ]
                },
                mainDetails: {
                    selectedTabIndex   : 0,
                    itemActions        : [
                                            { id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateSellerAccountStatusBulk', disabled: '{selected: true, Status: 1}',
                                                visible: true, requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                                            { id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateSellerAccountStatusBulk', disabled: '{selected: true, Status: 0}',
                                                visible: true, requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'},
                                        ],
                    fabAction           : {id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UpdateUser', visible: true}
                },
                privileges: {
                    list: 'GetUsersList',
                    details: 'GetUserDetails'
                }
            }
        };

        api.accounts.updateBulkUsers = {
            modelPath: 'accounts.updateBulkUsers',
            fields: [
                { field: 'CountryCode', type: 'text', displayLabel: 'USERS.FIELDS.COUNTRY', visible: false, creatable: false, editable: true, inputType: 'lookup', lookupSource: 'lists.countries',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'City', type: 'text', displayLabel: 'USERS.FIELDS.CITY', visible: false, creatable: false, editable: true, inputType: 'text',
                    validation: {isRequired: false, maxLen: 25, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Designation', type: 'text', displayLabel: 'USERS.FIELDS.DESIGNATION', visible: false, creatable: false, editable: true, inputType: 'text',
                    validation: {isRequired: false, maxLen: 20, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Department', type: 'text', displayLabel: 'USERS.FIELDS.DEPARTMENT', visible: false, creatable: false, editable: true, inputType: 'text',
                    validation: {isRequired: false, maxLen: 20, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
               ],
            uniqueConstraints: [],
            title: 'USERS.NAV',
            icon: '',
            isDirty: false,
            methods: {},
            views: {
                mainList: {
                    columns             : [],
                    columnFilter        : {},
                    toggleFilterProps   : {},
                    topIndex            : 0,
                    showFilterRow       : false,
                    sortColumn          : {},
                    itemActions         : [],
                    listActions         : []
                },
                mainDetails: {},
                privileges: {}
            }
        };

        function getAllUsers(generalProperties) {
            var promise;

            if(angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
                var state = {};
                state.name = $state.current.name;
                state.params = $state.params;
                var isBulk = true;
                var logData = activityLogger.createLogData(null, state, 'accounts.users', 'VIEW', isBulk, new Date(), null, null);
                promise = api.webGet(api.baseUrl + '/users', undefined, true, generalProperties.forceFetch);
                promise = activityLogger.log(logData, promise);
            }
            else {
                promise = api.webGet(api.baseUrl + '/users', undefined, true, generalProperties.forceFetch);
            }

            promise.then(function() {
                if (api.accounts.users.isDirty) {
                    //Invalidate lookupData
                    api.accounts.users.lookupData = undefined;
                    api.accounts.users.isDirty = false;
                }
            });
            return promise;
        }

        function getUser(isLogRequired, userId) {
            var promise;
            if(angular.isDefined(isLogRequired) && isLogRequired === true) {
                var state = {};
                state.name = $state.current.name;
                state.params = $state.params;
                var isBulk = false;
                var items= [];
                promise = api.webGet(api.baseUrl + '/users/' + userId + '?status=0');
                promise.then(function(response) {
                    items.push(response.data[api.accounts.users.lookupDisplayField]);
                }, function(response) {
                    items.push(response.data[api.accounts.users.lookupDisplayField]);
                });
                var logData = activityLogger.createLogData(items, state, 'accounts.users', 'VIEW', isBulk, new Date(), null, null);
                promise = activityLogger.log(logData, promise);
            }
            else{
                promise = api.webGet(api.baseUrl + '/users/' + userId + '?status=0');
            }
            return promise;
        }

        function activateUsers(records, model, actionType) {
            var result = crud.createRequestObject(records, model, actionType);
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var isBulk = result.itemsNameList.length > 1 ? true : false;
            var logData = activityLogger.createLogData(result.itemsNameList, state, 'accounts.users', actionType.toUpperCase(), isBulk, new Date(), null, null);
            var promise = api.webPut(api.baseUrl + '/users/status', result.requestObj);

            promise.then(function() {
                crud.onRecordStatusChange(records, model, actionType);
            });

            return activityLogger.log(logData, promise);
        }

        function updateUser(userId, user) {
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var logData = activityLogger.createLogData(user[api.accounts.users.lookupDisplayField], state, 'accounts.users', 'EDIT', false, new Date(), null, null);
            var promise = api.webPut(api.baseUrl + '/users/' + userId , user);

            promise.then(function() {
               api.accounts.users.isDirty = true;
            });
            return activityLogger.log(logData, promise);
        }

        function updateUsers(records, updateRecord) {
            angular.forEach(records, function (record) {
                for (var prop in updateRecord) {
                    record[prop] = updateRecord[prop];
                }
            });

            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var logData = activityLogger.createLogData(records, state, 'accounts.users', 'EDIT', false, new Date(), null, null);
            var promise = api.webPut(api.baseUrl + '/users', records);

            promise.then(function() {
               api.accounts.users.isDirty = true;
            });
            return activityLogger.log(logData, promise);
        }

        function assignNotificationTypes(records, updateRecord) {
            var requestObj = [];
            angular.forEach(records, function (record) {
                var userObj = {
                    UserId: record.Id,
                    Types: []
                };
                angular.forEach(updateRecord.NotificationSubscribeTypes, function(type) {
                    var types = {
                        TypeId: type
                    }
                    userObj.Types.push(types);
                });
                requestObj.push(userObj);
            });

            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var logData = activityLogger.createLogData(records, state, 'accounts.users', 'EDIT', false, new Date(), null, null);
            var promise = api.webPut(api.baseUrl + '/notifications/bulksubscribe', requestObj);

            promise.then(function() {
               api.accounts.users.isDirty = true;
            });
            return activityLogger.log(logData, promise);
        }

        // this method is reused in buyer and seller users module for logging purpose added modelPath
        function changeAccount(selectedRecords, accountId, model) {
            var requestObj = {};
            requestObj['UserIds'] = selectedRecords.map(function(user) {
                return user['Id'];
            });
            requestObj['AccountId'] = accountId;

            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var logData = activityLogger.createLogData(selectedRecords, state, model.modelPath, 'EDIT', false, new Date(), null, null);
            var promise = api.webPut(api.baseUrl + '/users/changeaccount', requestObj);

            promise.then(function() {
               api.accounts.users.isDirty = true;
               api.sellers.users.isDirty = true;
               api.buyers.users.isDirty = true;
            });
            return activityLogger.log(logData, promise);
        }

    }
})();
(function() {
    'use strict';

    angular
        .module('app.main.accounts.user-groups')
        .run(runBlock);

    /* @ngInject */
    function runBlock(api, activityLogger, $state, crud) {

        if(angular.isUndefined(api.accounts)) {
            api.accounts = {};
        }
        api.accounts.userGroups = {
            modelPath: 'accounts.userGroups',
            fields: [
                { field: 'Id', type: 'int', displayLabel: 'USER_GROUPS.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'AccountId', type: 'int', displayLabel: 'USER_GROUPS.FIELDS.ACCOUNT_ID', visible: true, creatable: false, editable: false, inputType: 'static',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'AccountName', type: 'text', displayLabel: 'USER_GROUPS.FIELDS.ACCOUNT_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Name', type: 'text', displayLabel: 'USER_GROUPS.FIELDS.NAME', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Source', type: 'text', displayLabel: 'USER_GROUPS.FIELDS.SOURCE', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'AttributeGroupId', type: 'int', displayLabel: 'USER_GROUPS.FIELDS.ATTRIBUTE_GROUP_NAME', visible: true, creatable: true, editable: false, inputType: 'lookup', lookupSource: 'attributes.attributeGroups',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', checkIfValidJson: true, messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '', isValidJson: 'VALIDATIONS.INVALID_JSON'}} },
                { field: 'Criteria', type: 'text', displayLabel: 'USER_GROUPS.FIELDS.CRITERIA', visible: true, creatable: true, editable: true, inputType: 'lookup-many', lookupSource:'lists.userGroupsCriteria',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Actions', type: 'text', displayLabel: 'USER_GROUPS.FIELDS.ACTIONS', visible: true, creatable: true, editable: true, inputType: 'lookup-many', lookupSource:'lists.userGroupsActions',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'AdditionalCriteria', type: 'text', displayLabel: 'USER_GROUPS.FIELDS.ADDITIONAL_CRITERIA', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Status', type: 'text', displayLabel: 'USER_GROUPS.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedDate', type: 'text', displayLabel: 'USER_GROUPS.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedDate', type: 'text', displayLabel: 'USER_GROUPS.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedBy', type: 'text', displayLabel: 'USER_GROUPS.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedBy', type: 'text', displayLabel: 'USER_GROUPS.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Users', type: 'text', displayLabel: 'USER_GROUPS.FIELDS.USERS', visible: false, creatable: true, editable: true, inputType: 'lookup-many', lookupSource: 'accounts.users',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
               ],
            uniqueConstraints: [],
            title: 'USER_GROUPS.NAV',
            icon: '',
            idField: 'Id',
            lookupDisplayField: 'Name',
            isDirty: false,
            methods: {
                getList         :   getUserGroups,
                getDetails      :   getUserGroup,
                activateBulk    :   activateUserGroups,
                create          :   createUserGroup,
                update          :   updateUserGroup
            },
            views: {
                mainList: {
                    columns             : [ 'Id', 'AccountId', 'AccountName', 'Name', 'Status', 'UpdatedDate' ],
                    columnFilter        : {},
                    toggleFilterProps   : {},
                    topIndex            : 0,
                    showFilterRow       : false,
                    sortColumn          : {'UpdatedDate': false},
                    itemActions         : [
                                            { id: 'view', label: 'ACTIONS.VIEW', icon: 'icon-magnify', privilege: 'GetAccountGroupDetails', disabled: '!itm.Status', visible: true },
                                            { id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UpdateAccountGroup', disabled: '!itm.Status', visible: true },
                                            { id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateAccountGroupStatuses', disabled: false, visible: 'itm.Status',
                                                requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                                            { id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateAccountGroupStatuses', disabled: false, visible: '!itm.Status',
                                                requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'},
                                            ],
                    listActions         : [
                                            { id: 'delete', label: 'ACTIONS.DELETE_BULK', icon: 'icon-delete', privilege: 'UpdateAccountGroupStatuses', disabled: '{selected: true, Status: 1}', visible: true,
                                                requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                                            { id: 'activate', label: 'ACTIONS.ACTIVATE_BULK', icon: 'icon-undo-variant', privilege: 'UpdateAccountGroupStatuses', disabled: '{selected: true, Status: 0}', visible: true,
                                                requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'},
                                            ],
                    fabAction           : {id: 'add', label: 'ACTIONS.ADD', icon: 'icon-plus', privilege: 'CreateAccountGroup', visible: true}
                },
                mainDetails: {
                    selectedTabIndex   : 0,
                    itemActions        : [
                                            { id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateAccountGroupStatuses', disabled: '{selected: true, Status: 1}',
                                                visible: true, requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                                            { id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateAccountGroupStatuses', disabled: '{selected: true, Status: 0}',
                                                visible: true, requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'},
                                        ],
                    fab                : {id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UpdateAccountGroup', visible: true}
                },
                privileges: {
                    list: 'GetAccountGroups',
                    details: 'GetAccountGroupDetails'
                }
            }
        };

        function getUserGroups(generalProperties) {
            var promise;

            if(angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
                var state = {};
                state.name = $state.current.name;
                state.params = $state.params;
                var isBulk = true;
                var logData = activityLogger.createLogData(null, state, 'accounts.userGroups', 'VIEW', isBulk, new Date(), null, null);
                promise = api.webGet(api.baseUrl + '/accountgroups', undefined, true, generalProperties.forceFetch);
                promise = activityLogger.log(logData, promise);
            }
            else {
                promise = api.webGet(api.baseUrl + '/accountgroups', undefined, true, generalProperties.forceFetch);
            }

            promise.then(function() {
                if (api.accounts.userGroups.isDirty) {
                    //Invalidate lookupData
                    api.accounts.userGroups.lookupData = undefined;
                    api.accounts.userGroups.isDirty = false;
                }
            });
            return promise;
        }

        function getUserGroup(isLogRequired, userGroupId) {
            var promise;
            if(angular.isDefined(isLogRequired) && isLogRequired === true) {
                var state = {};
                state.name = $state.current.name;
                state.params = $state.params;
                var isBulk = false;
                var items= [];
                promise = api.webGet(api.baseUrl + '/accountgroups/' + userGroupId);
                promise.then(function(response) {
                    items.push(response.data[api.accounts.userGroups.lookupDisplayField]);
                }, function(response) {
                    items.push(response.data[api.accounts.userGroups.lookupDisplayField]);
                });
                var logData = activityLogger.createLogData(items, state, 'accounts.userGroups', 'VIEW', isBulk, new Date(), null, null);
                promise = activityLogger.log(logData, promise);
            }
            else{
                promise = api.webGet(api.baseUrl + '/accountgroups/' + userGroupId);
            }
            return promise;
        }

        function activateUserGroups(records, model, actionType) {
            var result = crud.createRequestObject(records, model, actionType);
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var isBulk = result.itemsNameList.length > 1 ? true : false;
            var logData = activityLogger.createLogData(result.itemsNameList, state, 'accounts.userGroups', actionType.toUpperCase(), isBulk, new Date(), null, null);
            var promise = api.webPut(api.baseUrl + '/accountgroups/status', result.requestObj);

            promise.then(function() {
                crud.onRecordStatusChange(records, model, actionType);
            });

            return activityLogger.log(logData, promise);
        }

        function createUserGroup(userGroup) {
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            if(userGroup.Criteria) {
                userGroup.Criteria = userGroup.Criteria.length ? userGroup.Criteria.join(',') : '';
            }
            if(userGroup.Actions) {
                userGroup.Actions = userGroup.Actions.length ? userGroup.Actions.join(',') : '';
            }
            var logData = activityLogger.createLogData(userGroup[api.accounts.userGroups.lookupDisplayField], state, 'accounts.userGroups', 'ADD', false, new Date(), null, null);
            var promise = api.webPost(api.baseUrl + '/accountgroups', userGroup);

            promise.then(function() {
                api.accounts.userGroups.isDirty = true;
            });
            return activityLogger.log(logData, promise);
        }

        function updateUserGroup(userGroupId, userGroup) {
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            if(userGroup.Criteria) {
                userGroup.Criteria = Array.isArray(userGroup.Criteria) ? userGroup.Criteria.join(',') : userGroup.Criteria
            }
            if(userGroup.Actions) {
                userGroup.Actions = Array.isArray(userGroup.Actions) ? userGroup.Actions.join(',') : userGroup.Actions
            }
            var logData = activityLogger.createLogData(userGroup[api.accounts.userGroups.lookupDisplayField], state, 'accounts.userGroups', 'EDIT', false, new Date(), null, null);
            var promise = api.webPut(api.baseUrl + '/accountgroups/' + userGroupId , userGroup);

            promise.then(function() {
                api.accounts.userGroups.isDirty = true;
            });
            return activityLogger.log(logData, promise);
        }

    }
})();
(function() {
    'use strict';

    angular
        .module('app.main.accounts.sellers')
        .run(runBlock);

    /* @ngInject */
    function runBlock(api, activityLogger, $state, crud, utility, catalogFactory) {

        if(angular.isUndefined(api.accounts)) {
            api.accounts = {};
        }
        api.accounts.sellers = {
            modelPath: 'accounts.sellers',
            fields: [
                { field: 'AccountId', type: 'int', displayLabel: 'SELLERS.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'AccountName', type: 'text', displayLabel: 'SELLERS.FIELDS.NAME', visible: true, creatable: true, editable: true, inputType: 'text',
                    validation: {isRequired: true, maxLen: 50, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Email', type: 'text', displayLabel: 'SELLERS.FIELDS.EMAIL', visible: true, creatable: true, editable: true, inputType: 'text',
                    validation: {isRequired: true, maxLen: 500, minLen: 1, pattern: '^[A-Za-z]+[A-Za-z0-9._+-]+@{1}[A-Za-z0-9._-]+\.[A-Za-z.]{2,}$', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: 'VALIDATIONS.INVALID_EMAIL'}} },
                { field: 'ParentAccountId', type: 'int', displayLabel: 'SELLERS.FIELDS.PARENT_ID', visible: true, creatable: true, editable: false, inputType: 'lookup', lookupSource: 'accounts.sellers',
                    lookupFilter: {'Status': 1}, validation: {isRequired: false, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'OrganizationName', type: 'text', displayLabel: 'SELLERS.FIELDS.ORGANIZATION', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'OrganizationId', type: 'int', displayLabel: 'SELLERS.FIELDS.ORGANIZATION', visible: false, creatable: true, editable: true, inputType: 'lookup', lookupSource: 'organizations.organizations',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'OrganizationId', type: 'int', displayLabel: 'SELLERS.FIELDS.ORGANIZATION_ID', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'AccountTypeId', type: 'int', displayLabel: 'SELLERS.FIELDS.ACCOUNTTYPE_ID', visible: false, creatable: false, editable: false, inputType: 'static', fieldDefaultValue: 2,
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'AccountType', type: 'text', displayLabel: 'SELLERS.FIELDS.ACCOUNTTYPE', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CountryCode', type: 'text', displayLabel: 'SELLERS.FIELDS.COUNTRY', visible: false, creatable: true, editable: true, inputType: 'lookup', lookupSource: 'lists.countries',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CountryCode', type: 'text', displayLabel: 'SELLERS.FIELDS.COUNTRY_CODE', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Country', type: 'text', displayLabel: 'SELLERS.FIELDS.COUNTRY', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'State', type: 'text', displayLabel: 'SELLERS.FIELDS.STATE', visible: true, creatable: true, editable: true, inputType: 'text',
                    validation: {isRequired: false, maxLen: 25, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'City', type: 'text', displayLabel: 'SELLERS.FIELDS.CITY', visible: true, creatable: true, editable: true, inputType: 'text',
                    validation: {isRequired: true, maxLen: 25, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Zip', type: 'text', displayLabel: 'SELLERS.FIELDS.ZIP', visible: true, creatable: true, editable: true, inputType: 'text',
                    validation: {isRequired: false, maxLen: 7, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Address', type: 'text', displayLabel: 'SELLERS.FIELDS.ADDRESS', visible: true, creatable: true, editable: true, inputType: 'textArea',
                    validation: {isRequired: true, maxLen: 100, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Domain', type: 'text', displayLabel: 'SELLERS.FIELDS.DOMAIN', visible: true, creatable: true, editable: true, inputType: 'text',
                    validation: {isRequired: true, maxLen: 50, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Website', type: 'text', displayLabel: 'SELLERS.FIELDS.WEBSITE', visible: true, creatable: true, editable: true, inputType: 'url',
                    validation: {isRequired: true, maxLen: 50, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '', invalidType: 'VALIDATIONS.INVALID_URL'}} },
                { field: 'ConsolidationPluginIds', type: 'text', displayLabel: 'SELLERS.FIELDS.CONSOLIDATION_PLUGIN', visible: true, creatable: true, editable: true, inputType: 'lookup-many', lookupSource: 'plugins.consolidationPlugins',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ModelNameLength', type: 'int', displayLabel: 'SELLERS.FIELDS.MODEL_NAME_LENGTH', visible: true, creatable: true, editable: true, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 1, pattern: '^[0-9]$|^[1-9][0-9]$|^(100)$', disabledCriteria: 'vm.record.ParentAccountId !== null', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: 'VALIDATIONS.INVALID_DECIMAL_POINTS'}} },
                { field: 'ProcessQueue', type: 'text', displayLabel: 'SELLERS.FIELDS.PROCESSING_QUEUE', visible: true, creatable: true, editable: true, inputType: 'lookup', lookupSource: 'lists.processingQueues',
                    validation: {isRequired: false, maxLen: 20, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CampaignLaunchDateAttribute', type: 'text', displayLabel: 'SELLERS.FIELDS.CAMPAIGN_LAUNCH_DATE_ATTRIBUTE', visible: true, creatable: true, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: 128, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UseOrderType', type: 'int', displayLabel: 'SELLERS.FIELDS.USE_ORDER_TYPE', visible: true, creatable: true, editable: true, inputType: 'int-bool',
                    validation: {isRequired: false, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UseConfirmOrder', type: 'int', displayLabel: 'SELLERS.FIELDS.USE_CONFIRM_ORDER', visible: true, creatable: true, editable: true, inputType: 'int-bool',
                    validation: {isRequired: false, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'AllowSeasonlessAttributes', type: 'text', displayLabel: 'SELLERS.FIELDS.ALLOW_SEASONLESS_ARTICLE_ATTRIBUTES', visible: true, creatable: true, editable: true, inputType: 'bool-int',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', disabledCriteria: 'vm.record.ParentAccountId !== null', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'AllowSeasonlessModelAttributes', type: 'text', displayLabel: 'SELLERS.FIELDS.ALLOW_SEASONLESS_MODEL_ATTRIBUTES', visible: true, creatable: true, editable: true, inputType: 'bool-int',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', disabledCriteria: 'vm.record.ParentAccountId !== null', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'AutomaticNumbering', type: 'text', displayLabel: 'SELLERS.FIELDS.AUTOMATIC_NUMBERING', visible: true, creatable: true, editable: true, inputType: 'bool-int',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', disabledCriteria: 'vm.record.ParentAccountId !== null', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CustomNumbering', type: 'text', displayLabel: 'SELLERS.FIELDS.CUSTOM_NUMBERING', visible: true, creatable: true, editable: true, inputType: 'bool-int',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', disabledCriteria: 'vm.record.ParentAccountId !== null || vm.record.AutomaticNumbering === 0', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'IsSizeScaleByStyle', type: 'text', displayLabel: 'SELLERS.FIELDS.IS_SIZESCALE_BY_STYLE', visible: true, creatable: true, editable: false, inputType: 'bool-int',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', disabledCriteria: 'vm.record.ParentAccountId !== null', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Status', type: 'text', displayLabel: 'SELLERS.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
                    validation: {isRequired: false, maxLen: 25, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedDate', type: 'text', displayLabel: 'SELLERS.FIELDS.CREATEDDATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedDate', type: 'text', displayLabel: 'SELLERS.FIELDS.UPDATEDDATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedBy', type: 'text', displayLabel: 'SELLERS.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedBy', type: 'text', displayLabel: 'SELLERS.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'DuneContext', type: 'text', displayLabel: 'CATALOGS.FIELDS.CONTEXT', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'DuneContext', type: 'text', displayLabel: 'SELLERS.FIELDS.CONTEXT', visible: false, creatable: false, editable: false, inputType: 'custom-lookup', lookupSource: 'lists.duneContext', customLookupInfo: {value: 'value'},
                    lookupFilter: {Status: true}, validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ContextReadKey', type: 'text', displayLabel: 'SELLERS.FIELDS.CONTEXT_READ_KEY', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ContextReadWriteKey', type: 'text', displayLabel: 'SELLERS.FIELDS.CONTEXT_WRITE_KEY', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
            ],
            uniqueConstraints: [
                {name: 'Constraint 1', fields: ['AccountName']}
            ],
            title: 'SELLERS.NAV',
            icon: 'icon-account',
            idField: 'AccountId',
            lookupDisplayField: 'AccountName',
            isDirty: false,
            methods: {
                getList         :   getSellers,
                getDetails      :   getSeller,
                activateBulk    :   activateSellers,
                create          :   createSeller,
                update          :   updateSeller,
                assignSellerContext: assignSellerContext,
            },
            views: {
                mainList: {
                    columns             : [ 'AccountName', 'Domain', 'Country', 'City', 'Status', 'UpdatedDate' ],
                    columnFilter        : {},
                    toggleFilterProps   : { toggleStatus:false, filterProp:'Status', trueVal:1, trueValTooltipMessage: 'ACTIONS.TOGGLE_ACTIVE', falseVal:'', falseValTooltipMessage:"ACTIONS.TOGGLE_ALL"},
                    topIndex            : 0,
                    showFilterRow       : false,
                    sortColumn          : {'UpdatedDate': false},
                    sortDescending      : true,
                    itemActions         : [
                                            { id: 'view', label: 'ACTIONS.VIEW', icon: 'icon-magnify', privilege: 'GetSellerAccountDetails', disabled: '!itm.Status', visible: true },
                                            { id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UpdateSellerAccount', disabled: '!itm.Status', visible: true },
                                            { id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateSellerAccountStatusBulk', disabled: false, visible: 'itm.Status',
                                                requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                                            { id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateSellerAccountStatusBulk', disabled: false, visible: '!itm.Status',
                                                requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'},
                                            { id: 'manageContext', label: 'SELLERS.ACTIONS.MANAGE_CONTEXT', icon: 'icon-layers', privilege: 'AssignSellerDuneContext', disabled: false, visible: true},
                                        ],
                    listActions         : [
                                            { id: 'delete', label: 'ACTIONS.DELETE_BULK', icon: 'icon-delete', privilege: 'UpdateSellerAccountStatusBulk', disabled: '{selected: true, Status: 1}', visible: true,
                                                requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                                            { id: 'activate', label: 'ACTIONS.ACTIVATE_BULK', icon: 'icon-undo-variant', privilege: 'UpdateSellerAccountStatusBulk', disabled: '{selected: true, Status: 0}', visible: true,
                                                requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
                                        ],
                    fabAction           : {id: 'add', label: 'ACTIONS.ADD', icon: 'icon-plus', privilege: 'CreateSellerAccount', visible: true}
                },
                mainDetails: {
                    selectedTabIndex    : 0,
                    itemActions         : [
                                            { id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateSellerAccountStatusBulk', disabled: '{selected: true, Status: 1}',
                                                visible: true, requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                                            { id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateSellerAccountStatusBulk', disabled: '{selected: true, Status: 0}',
                                                visible: true, requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'},
                                            { id: 'importBuyerUserCustomers', label: 'SELLERS.ACTIONS.IMPORT_BUYER_USER_CUSTOMERS', icon: 'icon-import', privilege: 'LinkBuyerUserToCustomerBulk', disabled: '{selected: true, Status: 1}', visible: true, requiresConfirmation: false},
                                            { id: 'manageContext', label: 'CATALOGS.ACTIONS.MANAGE_CONTEXT', icon: 'icon-layers', privilege: 'AssignSellerDuneContext', disabled: false, visible: true},
                                            ],
                    fabAction           : {id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UpdateSellerAccount', visible: true}
                },
                privileges: {
                    list: 'GetSellerAccountList',
                    details: 'GetSellerAccountDetails'
                }
            }

        };

        function getSellers(generalProperties) {
            var promise;

            if(angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
                var state = {};
                state.name = $state.current.name;
                state.params = $state.params;
                var isBulk = true;
                var logData = activityLogger.createLogData(null, state, 'accounts.sellers', 'VIEW', isBulk, new Date(), null, null);

                promise = api.webGet(api.baseUrl + '/sellers', undefined, true, generalProperties.forceFetch);
                promise = activityLogger.log(logData, promise);
            }
            else {
                promise = api.webGet(api.baseUrl + '/sellers', undefined, true, generalProperties.forceFetch);
            }

            promise.then(function() {
                if (api.accounts.sellers.isDirty) {
                    //Invalidate lookupData
                    api.accounts.sellers.lookupData = undefined;
                    api.accounts.sellers.isDirty = false;
                }
            });
            return promise;
		}

        function getSeller(isLogRequired, sellerId) {
            var promise;

            if(angular.isDefined(isLogRequired) && isLogRequired === true) {
                var state = {};
                state.name = $state.current.name;
                state.params = $state.params;
                var isBulk = false;
                var items= [];
                promise = api.webGet(api.baseUrl + '/sellers/' + sellerId + '?status=0');
                promise.then(function(response) {
                    items.push(response.data[api.accounts.sellers.lookupDisplayField]);
                }, function(response) {
                    items.push(response.data[api.accounts.sellers.lookupDisplayField]);
                });
                var logData = activityLogger.createLogData(items, state, 'accounts.sellers', 'VIEW', isBulk, new Date(), null, null);
                promise = activityLogger.log(logData, promise);
            }
            else {
                promise = api.webGet(api.baseUrl + '/sellers/' + sellerId + '?status=0');
            }
            return promise;
		}

		function activateSellers(records, model, actionType) {
            var result = crud.createRequestObject(records, model, actionType);
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var isBulk = result.itemsNameList.length > 1 ? true : false;
            var logData = activityLogger.createLogData(result.itemsNameList, state, 'accounts.sellers', actionType.toUpperCase(), isBulk, new Date(), null, null);
			var promise = api.webPut(api.baseUrl + '/sellers/status', result.requestObj);

            promise.then(function() {
                crud.onRecordStatusChange(records, model, actionType);
            });

            return activityLogger.log(logData, promise);
		}

		function createSeller(seller) {
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var logData = activityLogger.createLogData(seller[api.accounts.sellers.lookupDisplayField], state, 'accounts.sellers', 'ADD', false, new Date(), null, null);
			var promise = api.webPost(api.baseUrl + '/sellers', seller);

            promise.then(function() {
                api.accounts.sellers.isDirty = true;
                api.catalogs.models.isDirty = true;
                api.sellerModels.sellerModels.isDirty = true;
                api.catalogs.articles.isDirty = true;
            });
            return activityLogger.log(logData, promise);
		}

        function updateSeller(sellerId, seller) {
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var logData = activityLogger.createLogData(seller[api.accounts.sellers.lookupDisplayField], state, 'accounts.sellers', 'EDIT', false, new Date(), null, null);
			var promise = api.webPut(api.baseUrl + '/sellers/' + sellerId, seller);

            promise.then(function() {
                api.accounts.sellers.isDirty = true;
                api.catalogs.models.isDirty = true;
                api.sellerModels.sellerModels.isDirty = true;
                api.catalogs.articles.isDirty = true;
                // the cached numbering settings belong to the active catalog's seller, refresh them so the
                // new values apply without reopening the catalog
                if(Number(catalogFactory.getActiveCatalog().AccountId) === Number(sellerId)) {
                    catalogFactory.setNumberingSettings(seller.AutomaticNumbering, seller.CustomNumbering);
                }
            });
            return activityLogger.log(logData, promise);
		}

        function assignSellerContext(sellerId, selectedContextId, contextList) {
            var state = {};
            var requestObj = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var actionToPerform = 'MANAGE_CONTEXT';
            if(angular.isUndefined(selectedContextId)) {
                requestObj.Context = '';
                requestObj.ContextReadKey = '';
                requestObj.ContextReadWriteKey = '';
            } else {
                var contextRecord = utility.filterObject(contextList, { value: selectedContextId }, true)[0];
                requestObj.Context = contextRecord.value;
                requestObj.ContextReadKey = contextRecord.ContextReadKey;
                requestObj.ContextReadWriteKey = contextRecord.ContextReadWriteKey;
            }

            var logData = activityLogger.createLogData(sellerId, state, 'accounts.sellers', actionToPerform, false, new Date(), null, null);
            var promise = api.webPut(api.baseUrl + '/sellers/' + sellerId + '/dunecontext', requestObj);

            promise.then(function() {
                api.accounts.sellers.isDirty = true;
                api.catalogs.models.isDirty = true;
                api.sellerModels.sellerModels.isDirty = true;
                api.catalogs.articles.isDirty = true;
            });
            return activityLogger.log(logData, promise);
        }
    }
})();
(function () {
  'use strict';

  angular
  .module('app.main.accounts.sellers')
  .run(runBlock);

  /* @ngInject */
  function runBlock(api, CONSTANTS, jobsTracker) {

    if (angular.isUndefined(api.accounts)) {
      api.accounts = {};
    }
    api.accounts.customers = {
      modelPath: 'accounts.customers',
      fields: [
          { field: 'CustomerCode', type: 'text', displayLabel: 'BUYER_USER_CUSTOMERS.FIELDS.CUSTOMER_CODE', visible: true, creatable: true, editable: false, inputType: 'text',
              validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
          { field: 'UserName', type: 'text', displayLabel: 'BUYER_USER_CUSTOMERS.FIELDS.USER_NAME', visible: true, creatable: true, editable: false, inputType: 'text',
              validation: {isRequired: true, maxLen: 0, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
          { field: 'Status', type: 'text', displayLabel: 'BUYER_USER_CUSTOMERS.FIELDS.STATUS', visible: true, creatable: true, editable: false, inputType: 'status',
              validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
          { field: 'Token', type: 'text', displayLabel: 'BUYER_USER_CUSTOMERS.FIELDS.TOKEN', visible: true, creatable: true, editable: false, inputType: 'text',
              validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
      ],
      uniqueConstraints: [
        { name: 'Constraint 1', fields: ['CustomerCode', 'UserName', 'Token'] }
      ],
      title: 'CUSTOMERS.NAV',
      icon: 'icon-alert-box',
      idField: 'CustomerCode',
      lookupDisplayField: 'UserName',
      isDirty: false,
      methods: {
        createBulk: createBulk
      },
      views: {
        mainList: {
          columns: [ 'CustomerCode', 'UserName', 'Token', 'Status' ],
          columnFilter: {},
          toggleFilterProps: {},
          topIndex: 0,
          showFilterRow: false,
          sortColumn: {},
          sortDescending: true,
          itemActions: [],
          listActions: [],
          fabAction:{}
        },
        mainDetails: { },
        privileges: {}
      }
    };

    function createBulk(model, data, sellerId) {
      var jobIndex = jobsTracker.addJob(model, 'ACTIONS.SAVE', 1, api.users.customers);
      api.webPut(api.baseUrl + '/sellers/' + sellerId + '/buyerusers/linkcustomers?sourceapplication=' + CONSTANTS.SOURCE_APPLICATION + '&sourceaction=Import Buyer User Customers', data).then(function (response) {
          jobsTracker.trackJob(jobIndex, response.data.Id);
      }).catch(function (error) {
          jobsTracker.setCriticlaFail(jobIndex, error);
      });
    }
  }
})();
(function() {
		'use strict';

		angular
				.module('app.main.accounts.interface-users')
				.run(runBlock);

		/* @ngInject */
		function runBlock(api, activityLogger, $state, crud, $localStorage) {

				if(angular.isUndefined(api.accounts)) {
						api.accounts = {};
				}
				api.accounts.interfaceUsers = {
						modelPath: 'accounts.interfaceUsers',
						fields: [
								{ field: 'id', type: 'int', displayLabel: 'INTERFACE_USERS.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
										validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'description', type: 'text', displayLabel: 'INTERFACE_USERS.FIELDS.DESCRIPTION', visible: true, creatable: true, editable: false, inputType: 'text',
										validation: {isRequired: true, maxLen: 200, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'allowedClient', type: 'text', displayLabel: 'INTERFACE_USERS.FIELDS.ALLOWED_CLIENT', visible: true, creatable: false, editable: false, inputType: 'text',
										validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'allowedEnvironment', type: 'text', displayLabel: 'INTERFACE_USERS.FIELDS.ALLOWED_ENVIRONMENT', visible: true, creatable: false, editable: false, inputType: 'text',
										validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'status', type: 'text', displayLabel: 'INTERFACE_USERS.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'bool',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'clientId', type: 'text', displayLabel: 'INTERFACE_USERS.FIELDS.CLIENT_ID', visible: true, creatable: false, editable: false, inputType: 'text',
										validation: {isRequired: true, maxLen: 10, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 't1Username', type: 'text', displayLabel: 'INTERFACE_USERS.FIELDS.T1_USER_NAME', visible: true, creatable: true, editable: false, inputType: 'text',
										validation: {isRequired: true, maxLen: 50, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'createdOn', type: 'text', displayLabel: 'INTERFACE_USERS.FIELDS.CREATED_ON', visible: true, creatable: false, editable: false, inputType: 'date',
									 	validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'updatedOn', type: 'text', displayLabel: 'INTERFACE_USERS.FIELDS.UPDATED_ON', visible: true, creatable: false, editable: false, inputType: 'date',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								//These are used in create interface user
								{ field: 'allowedClientCode', type: 'text', displayLabel: 'INTERFACE_USERS.FIELDS.ALLOWED_CLIENT', visible: false, creatable: true, editable: false, inputType: 'lookup-many', lookupSource: 'lists.authClients',
										validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'envCode', type: 'text', displayLabel: 'INTERFACE_USERS.FIELDS.ALLOWED_ENVIRONMENT', visible: false, creatable: true, editable: false, inputType: 'lookup-many', lookupSource: 'lists.environments',
										validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								],
						uniqueConstraints: [],
						title: 'INTERFACE_USERS.NAV',
						icon: '',
						idField: 'id',
						lookupDisplayField: 't1Username',
						isDirty: false,
						methods: {
								getList         :   getAllUsers,
								create          :   createUser,
								activateBulk    :   activateInterfaceUsers,
						},
						views: {
								mainList: {
										columns             : [ 'id', 't1Username', 'allowedClient', 'allowedEnvironment', 'clientId', 'status', 'description', 'createdOn', 'updatedOn'],
										columnFilter        : {},
										toggleFilterProps   : { toggleStatus:false, filterProp:'status', trueVal:true, trueValTooltipMessage: 'ACTIONS.TOGGLE_ACTIVE', falseVal:'', falseValTooltipMessage:"ACTIONS.TOGGLE_ALL"},
										topIndex            : 0,
										showFilterRow       : false,
										sortColumn          : {},
										itemActions         : [
											{ id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UI_UpdateInterfaceUsersStatus', disabled: false, visible: 'itm.status',
												requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
											{ id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UI_UpdateInterfaceUsersStatus', disabled: false, visible: '!itm.status',
												requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
										],
										listActions         : [
											{ id: 'delete', label: 'ACTIONS.DELETE_BULK', icon: 'icon-delete', privilege: 'UI_UpdateInterfaceUsersStatus', disabled: '{selected: true, status: true}', visible: true,
												requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
											{ id: 'activate', label: 'ACTIONS.ACTIVATE_BULK', icon: 'icon-undo-variant', privilege: 'UI_UpdateInterfaceUsersStatus', disabled: '{selected: true, status: false}', visible: true,
												requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
										],
										fabAction           : {id: 'add', label: 'ACTIONS.ADD', icon: 'icon-plus', privilege: 'UI_CreateInterfaceUser', visible: true}
								},
								mainDetails: {},
								privileges: {
										list: 'GetInterfaceUserList',
								}
						}
				};

				function getAllUsers(generalProperties) {
						var promise;
						if(angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
								var state = {};
								state.name = $state.current.name;
								state.params = $state.params;
								var isBulk = true;
								var logData = activityLogger.createLogData(null, state, 'accounts.interfaceUsers', 'VIEW', isBulk, new Date(), null, null);
								promise= api.webGet($localStorage.authBaseUrl + '/interfaceusers', undefined, true, generalProperties.forceFetch);
								promise = activityLogger.log(logData, promise);
						}
						else {
								promise= api.webGet($localStorage.authBaseUrl + '/interfaceusers', undefined, true, generalProperties.forceFetch);
						}
						promise.then(function() {
								if (api.accounts.authUsers.isDirty) {
										//Invalidate lookupData
										api.accounts.authUsers.lookupData = undefined;
										api.accounts.authUsers.isDirty = false;
								}
						});
						return promise;
				}

				function createUser(user) {
						var state = {};
						state.name = $state.current.name;
						state.params = $state.params;
						var promise;
						var logData = activityLogger.createLogData(user[api.accounts.users.lookupDisplayField], state, 'accounts.interfaceUsers', 'ADD', false, new Date(), null, null);
						promise = api.webPost($localStorage.authBaseUrl + '/interfaceusers', user);
						promise = activityLogger.log(logData, promise);

						return promise;
				}

				function activateInterfaceUsers(records, model, actionType) {
					//Convert records to required format {"ids": [0],"status": true} which is different from existing format
					var result = crud.createAuthRequestObject(records, model, actionType);
					var state = {};
					state.name = $state.current.name;
					state.params = $state.params;
					var isBulk = result.Ids.length > 1 ? true : false;
					var logData = activityLogger.createLogData(result, state, 'accounts.interfaceUsers', actionType.toUpperCase(), isBulk, new Date(), null, null);
					var promise = api.webPut($localStorage.authBaseUrl + '/interfaceusers/status', result);

					promise.then(function() {
							crud.onAuthRecordStatusChange(records, model, actionType);
					});

					return activityLogger.log(logData, promise);
				}

		}
})();
(function ()
{
    'use strict';

    angular
        .module('app.main.accounts.buyers')
        .run(runBlock);

    /** @ngInject */
    function runBlock(api, activityLogger, $state, crud) {

        if (angular.isUndefined(api.accounts)) {
            api.accounts = {};
        }
        api.accounts.buyers = {
            modelPath: 'accounts.buyers',
            fields: [
                { field: 'AccountId', type: 'int', displayLabel: 'BUYERS.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'AccountName', type: 'text', displayLabel: 'BUYERS.FIELDS.NAME', visible: true, creatable: true, editable: true, inputType: 'text',
                    validation: {isRequired: true, maxLen: 50, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'AccountTypeId', type: 'int', displayLabel: 'BUYERS.FIELDS.ACCOUNTTYPE_ID', visible: false, creatable: false, editable: false, inputType: 'static', fieldDefaultValue: 3,
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'AccountType', type: 'text', displayLabel: 'BUYERS.FIELDS.ACCOUNTTYPE', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'OrganizationName', type: 'text', displayLabel: 'BUYERS.FIELDS.ORGANIZATION', visible: false, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'OrganizationId', type: 'int', displayLabel: 'BUYERS.FIELDS.ORGANIZATION_ID', visible: false, creatable: false, editable: false, inputType: 'lookup', lookupSource: 'organizations.organizations',
                    validation: {isRequired: false, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Domain', type: 'text', displayLabel: 'BUYERS.FIELDS.DOMAIN', visible: true, creatable: true, editable: true, inputType: 'text',
                    validation: {isRequired: true, maxLen: 50, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Address', type: 'text', displayLabel: 'BUYERS.FIELDS.ADDRESS', visible: true, creatable: true, editable: true, inputType: 'textArea',
                    validation: {isRequired: true, maxLen: 100, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CountryCode', type: 'text', displayLabel: 'BUYERS.FIELDS.COUNTRY', visible: false, creatable: true, editable: true, inputType: 'lookup', lookupSource: 'lists.countries',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CountryCode', type: 'text', displayLabel: 'BUYERS.FIELDS.COUNTRY_CODE', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Country', type: 'text', displayLabel: 'BUYERS.FIELDS.COUNTRY', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'State', type: 'text', displayLabel: 'BUYERS.FIELDS.STATE', visible: true, creatable: true, editable: true, inputType: 'text',
                    validation: {isRequired: false, maxLen: 25, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'City', type: 'text', displayLabel: 'BUYERS.FIELDS.CITY', visible: true, creatable: true, editable: true, inputType: 'text',
                    validation: {isRequired: true, maxLen: 25, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Zip', type: 'text', displayLabel: 'BUYERS.FIELDS.ZIP', visible: true, creatable: true, editable: true, inputType: 'text',
                    validation: {isRequired: false, maxLen: 7, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Website', type: 'text', displayLabel: 'BUYERS.FIELDS.WEBSITE', visible: true, creatable: true, editable: true, inputType: 'url',
                    validation: {isRequired: true, maxLen: 50, minLen: 1, pattern: '',messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: 'VALIDATIONS.INVALID_URL',
                    invalidType: 'VALIDATIONS.INVALID_URL'}} },
                { field: 'Email', type: 'text', displayLabel: 'BUYERS.FIELDS.EMAIL', visible: true, creatable: true, editable: true, inputType: 'text',
                    validation: {isRequired: true, maxLen: 500, minLen: 1, pattern: '^[A-Za-z]+[A-Za-z0-9._+-]+@{1}[A-Za-z0-9._-]+\.[A-Za-z.]{2,}$', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: 'VALIDATIONS.INVALID_EMAIL'}} },
                { field: 'Status', type: 'text', displayLabel: 'BUYERS.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedDate', type: 'text', displayLabel: 'BUYERS.FIELDS.CREATEDDATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedDate', type: 'text', displayLabel: 'BUYERS.FIELDS.UPDATEDDATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedBy', type: 'text', displayLabel: 'BUYERS.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedBy', type: 'text', displayLabel: 'BUYERS.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
            ],
            uniqueConstraints: [
                {name: 'Constraint 1', fields: ['AccountName']}
            ],
            title: 'BUYERS.NAV',
            icon: 'icon-account-outline',
            idField: 'AccountId',
            lookupDisplayField: 'AccountName',
            isDirty: false,
            methods: {
                getList         :   getBuyers,
                getDetails      :   getBuyer,
                activateBulk    :   activateBuyers,
                create          :   createBuyer,
                update          :   updateBuyer,
                merge           :   mergeBuyer
            },
            views: {
                mainList: {
                    columns         : [ 'AccountName', 'Domain', 'Country', 'City', 'Status', 'UpdatedDate' ],
                    columnFilter    : {},
                    toggleFilterProps: { toggleStatus:false, filterProp:'Status', trueVal:1, trueValTooltipMessage: 'ACTIONS.TOGGLE_ACTIVE', falseVal:'', falseValTooltipMessage:"ACTIONS.TOGGLE_ALL"},
                    topIndex        : 0,
                    showFilterRow   : false,
                    sortColumn      : {'UpdatedDate': false},
                    itemActions     : [
                                        { id: 'view', label: 'ACTIONS.VIEW', icon: 'icon-magnify', privilege: 'GetBuyerAccountDetails', disabled: '!itm.Status', visible: true },
                                        { id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UpdateBuyerAccount', disabled: '!itm.Status', visible: true },
                                        { id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateBuyerAccountStatusBulk', disabled: false, visible: 'itm.Status',
                                            requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                                        { id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateBuyerAccountStatusBulk', disabled: false, visible: '!itm.Status',
                                            requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'},
                                        { id: 'merge', label: 'ACTIONS.MERGE', icon: 'icon-source-fork', privilege: 'MergeBuyers', disabled: false, visible: 'itm.Status'}
                                      ],
                    listActions     : [
                                        { id: 'delete', label: 'ACTIONS.DELETE_BULK', icon: 'icon-delete', privilege: 'UpdateBuyerAccountStatusBulk', disabled: '{selected: true, Status: 1}', visible: true,
                                            requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                                        { id: 'activate', label: 'ACTIONS.ACTIVATE_BULK', icon: 'icon-undo-variant', privilege: 'UpdateBuyerAccountStatusBulk', disabled: '{selected: true, Status: 0}', visible: true,
                                            requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
                                      ],
                    fabAction       : {id: 'add', label: 'ACTIONS.ADD', icon: 'icon-plus', privilege: 'CreateBuyerAccount', visible: true}
                 },
                 mainDetails: {
                     selectedTabIndex   : 0,
                     itemActions        : [
                                            { id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateBuyerAccountStatusBulk', disabled: '{selected: true, Status: 1}',
                                                visible: true, requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                                            { id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateBuyerAccountStatusBulk', disabled: '{selected: true, Status: 0}',
                                                visible: true, requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'},
                                            { id: 'merge', label: 'ACTIONS.MERGE', icon: 'icon-source-fork', privilege: 'MergeBuyers', disabled: '{selected: true, Status: 1}', visible: true}
                                          ],
                    fabAction       : {id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UpdateBuyerAccount', visible: true}
                 },
                 privileges: {
                     list: 'GetBuyerAccountList',
                     details: 'GetBuyerAccountDetails'
                 }
            }
        };

		function getBuyers(generalProperties) {
            var promise;

            if(angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
                var state = {};
                state.name = $state.current.name;
                state.params = $state.params;
                var isBulk = true;
                var logData = activityLogger.createLogData(null, state, 'accounts.buyers', 'VIEW', isBulk, new Date(), null, null);

                promise = api.webGet(api.baseUrl + '/buyers', undefined, true, generalProperties.forceFetch);
                promise = activityLogger.log(logData, promise);
            }
            else {
                promise = api.webGet(api.baseUrl + '/buyers', undefined, true, generalProperties.forceFetch);
            }

            promise.then(function() {
                if (api.accounts.buyers.isDirty) {
                    //Invalidate lookupData
                    api.accounts.buyers.lookupData = undefined;
                    api.accounts.buyers.isDirty = false;
                }
            });
            return promise;
		}

		function getBuyer(isLogRequired, buyerId) {
            var promise;
            if(angular.isDefined(isLogRequired) && isLogRequired === true) {
                var state = {};
                state.name = $state.current.name;
                state.params = $state.params;
                var isBulk = false;
                var items= [];
                promise = api.webGet(api.baseUrl + '/buyers/' + buyerId + '?status=0');
                promise.then(function(response) {
                    items.push(response.data[api.accounts.buyers.lookupDisplayField]);
                }, function(response) {
                    items.push(response.data[api.accounts.buyers.lookupDisplayField]);
                });
                var logData = activityLogger.createLogData(items, state, 'accounts.buyers', 'VIEW', isBulk, new Date(), null, null);
                promise = activityLogger.log(logData, promise);
            }
            else {
                promise = api.webGet(api.baseUrl + '/buyers/' + buyerId + '?status=0');
            }
            return promise;
		}

		function activateBuyers(records, model, actionType) {
            var result = crud.createRequestObject(records, model, actionType);
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var isBulk = result.itemsNameList.length > 1 ? true : false;
            var logData = activityLogger.createLogData(result.itemsNameList, state, 'accounts.buyers', actionType.toUpperCase(), isBulk, new Date(), null, null);
            var promise = api.webPut(api.baseUrl + '/buyers/status', result.requestObj);

            promise.then(function() {
                crud.onRecordStatusChange(records, model, actionType);
            });
            return activityLogger.log(logData, promise);
		}

		function createBuyer(buyer) {
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var logData = activityLogger.createLogData(buyer[api.accounts.buyers.lookupDisplayField], state, 'accounts.buyers', 'ADD', false, new Date(), null, null);
			var promise = api.webPost(api.baseUrl + '/buyers', buyer);

            promise.then(function() {
               api.accounts.buyers.isDirty = true;
            });
            return activityLogger.log(logData, promise);
		}

		function updateBuyer(buyerId, buyer) {
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var logData = activityLogger.createLogData(buyer[api.accounts.buyers.lookupDisplayField], state, 'accounts.buyers', 'EDIT', false, new Date(), null, null);
			var promise = api.webPut(api.baseUrl + '/buyers/' + buyerId, buyer);

            promise.then(function() {
                api.accounts.buyers.isDirty = true;
            });
            return activityLogger.log(logData, promise);
        }

        function mergeBuyer(requestObj, model, actionType) {
           var itemsNameList = [];
           var state = {};
           state.name = $state.current.name;
           state.params = $state.params;
           var isBulk = false;
           var logData = activityLogger.createLogData(itemsNameList, state, 'accounts.buyers', actionType, isBulk, new Date(), null, null);
           var promise = api.webPut(api.baseUrl + '/mergebuyers', requestObj);
           promise.then(function() {
            api.accounts.buyers.isDirty = true;
            });
            return activityLogger.log(logData, promise);
		}
    }
})();
(function() {
		'use strict';

		angular
				.module('app.main.accounts.auth-users')
				.run(runBlock);

		/* @ngInject */
		function runBlock(api, activityLogger, $state, crud, $localStorage) {

				if(angular.isUndefined(api.accounts)) {
						api.accounts = {};
				}
				api.accounts.authUsers = {
						modelPath: 'accounts.authUsers',
						fields: [
								{ field: 'id', type: 'int', displayLabel: 'AUTH_USERS.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
										validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'firstName', type: 'text', displayLabel: 'AUTH_USERS.FIELDS.FIRST_NAME', visible: true, creatable: true, editable: true, inputType: 'text',
										validation: {isRequired: true, maxLen: 20, minLen: 1, pattern: '^[A-Za-z]+$', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: 'VALIDATIONS.INVALID_NAME'}} },
								{ field: 'lastName', type: 'text', displayLabel: 'AUTH_USERS.FIELDS.LAST_NAME', visible: true, creatable: true, editable: true, inputType: 'text',
										validation: {isRequired: true, maxLen: 20, minLen: 1, pattern: '^[A-Za-z]+$', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: 'VALIDATIONS.INVALID_NAME'}} },
								{ field: 'email', type: 'text', displayLabel: 'AUTH_USERS.FIELDS.EMAIL', visible: true, creatable: true, editable: false, inputType: 'text',
										validation: {isRequired: true, maxLen: 500, minLen: 1, pattern: '^[A-Za-z]+[A-Za-z0-9._+-]+@{1}[A-Za-z0-9._-]+\.[A-Za-z.]{2,}$', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: 'VALIDATIONS.INVALID_EMAIL'}} },
								{ field: 'phone', type: 'text', displayLabel: 'AUTH_USERS.FIELDS.PHONE', visible: true, creatable: true, editable: true, inputType: 'tel',
										validation: {isRequired: false, maxLen: 20, minLen: 0, pattern: '[0-9]*', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '', invalidType: 'VALIDATIONS.INVALID_PHONE_NUMBER'}} },
								{ field: 'countryCode', type: 'text', displayLabel: 'AUTH_USERS.FIELDS.COUNTRY_CODE', visible: true, creatable: true, editable: true, inputType: 'lookup', lookupSource: 'lists.countries',
										validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'city', type: 'text', displayLabel: 'AUTH_USERS.FIELDS.CITY', visible: true, creatable: true, editable: true, inputType: 'text',
										validation: {isRequired: false, maxLen: 25, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'designation', type: 'text', displayLabel: 'AUTH_USERS.FIELDS.DESIGNATION', visible: true, creatable: true, editable: true, inputType: 'text',
										validation: {isRequired: false, maxLen: 20, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'department', type: 'text', displayLabel: 'AUTH_USERS.FIELDS.DEPARTMENT', visible: true, creatable: true, editable: true, inputType: 'text',
										validation: {isRequired: false, maxLen: 20, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'username', type: 'text', displayLabel: 'AUTH_USERS.FIELDS.USER_NAME', visible: true, creatable: true, editable: false, inputType: 'text',
										validation: {isRequired: true, maxLen: 50, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'restrictFullRange', type: 'int', displayLabel: 'AUTH_USERS.FIELDS.RESTRICT_FULL_RANGE', visible: false, creatable: true, editable: false, inputType: 'bool-int',
										validation: {isRequired: false, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'description', type: 'text', displayLabel: 'AUTH_USERS.FIELDS.DESCRIPTION', visible: true, creatable: true, editable: true, inputType: 'text',
										validation: {isRequired: true, maxLen: 200, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'userType', type: 'text', displayLabel: 'AUTH_USERS.FIELDS.USER_TYPE', visible: true, creatable: false, editable: false, inputType: 'lookup', lookupSource: 'lists.AuthUserTypes',
										validation: {isRequired: true, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'loginType', type: 'text', displayLabel: 'AUTH_USERS.FIELDS.LOGIN_TYPE', visible: true, creatable: true, editable: true, inputType: 'lookup', lookupSource: 'lists.AuthLoginTypes',
										validation: {isRequired: true, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'allowedClients', type: 'text', displayLabel: 'AUTH_USERS.FIELDS.ALLOWED_CLIENTS', visible: true, creatable: true, editable: true, inputType: 'lookup-many', lookupSource: 'lists.authClients',
										validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'allowedEnvironments', type: 'text', displayLabel: 'AUTH_USERS.FIELDS.ALLOWED_ENVIRONMENTS', visible: true, creatable: false, editable: false, inputType: 'lookup-many', lookupSource: 'lists.environments',
										validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'emailConfirmed', type: 'text', displayLabel: 'AUTH_USERS.FIELDS.EMAIL_CONFIRMED', visible: true, creatable: false, editable: false, inputType: 'bool',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'masterUser', type: 'text', displayLabel: 'AUTH_USERS.FIELDS.MASTER_USER', visible: true, creatable: true, editable: true, inputType: 'lookup', lookupSource:'accounts.authUsers',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'status', type: 'text', displayLabel: 'AUTH_USERS.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'bool',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'createdOn', type: 'text', displayLabel: 'AUTH_USERS.FIELDS.CREATED_ON', visible: true, creatable: false, editable: false, inputType: 'date',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'updatedOn', type: 'text', displayLabel: 'AUTH_USERS.FIELDS.UPDATED_ON', visible: true, creatable: false, editable: false, inputType: 'date',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'lastLogin', type: 'text', displayLabel: 'AUTH_USERS.FIELDS.LAST_LOGIN', visible: true, creatable: false, editable: false, inputType: 'date',
									validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
								],
						uniqueConstraints: [],
						title: 'AUTH_USERS.NAV',
						icon: '',
						idField: 'id',
						lookupDisplayField: 'username',
						isDirty: false,
						methods: {
								getList         :   getAllUsers,
								create          :   createUser,
								resetPassword   :   resetUserPassword,
								activateBulk    :   activateAuthUsers,
								update          :   updateAuthUser
						},
						views: {
								mainList: {
										columns             : [ 'id', 'username', 'firstName', 'userType', 'loginType', 'allowedClients', 'status', 'allowedEnvironments' ],
										columnFilter        : {},
										toggleFilterProps   : { toggleStatus:false, filterProp:'status', trueVal:true, trueValTooltipMessage: 'ACTIONS.TOGGLE_ACTIVE', falseVal:'', falseValTooltipMessage:"ACTIONS.TOGGLE_ALL"},
										topIndex            : 0,
										showFilterRow       : false,
										sortColumn          : {'updatedOn': false},
										itemActions         : [
											{ id: 'resetPassword', label: 'ACTIONS.RESET_PASSWORD', icon: 'icon-key', privilege: 'UI_ResetPassword',  visible: true,  disabled: '!itm.status || itm.masterUser !== -1 || itm.loginType === 2'},
											{ id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UI_EditAuthUser', disabled: '!itm.status', visible: true },
											{ id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UI_UpdateAuthUsersStatus', disabled: false, visible: 'itm.status',
												requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
											{ id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UI_UpdateAuthUsersStatus', disabled: false, visible: '!itm.status',
												requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
										],
										listActions         : [
											{ id: 'delete', label: 'ACTIONS.DELETE_BULK', icon: 'icon-delete', privilege: 'UI_UpdateAuthUsersStatus', disabled: '{selected: true, status: true}', visible: true,
												requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
											{ id: 'activate', label: 'ACTIONS.ACTIVATE_BULK', icon: 'icon-undo-variant', privilege: 'UI_UpdateAuthUsersStatus', disabled: '{selected: true, status: false}', visible: true,
												requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
										],
										fabAction           : {id: 'add', label: 'ACTIONS.ADD', icon: 'icon-plus', privilege: 'UI_CreateAuthUser', visible: true}
								},
								mainDetails: {},
								privileges: {
										list: 'nav_auth_users',
										details: 'UI_auth_user'
								}
						}
				};

				function getAllUsers(generalProperties) {
						var promise;
						if(angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
								var state = {};
								state.name = $state.current.name;
								state.params = $state.params;
								var isBulk = true;
								var logData = activityLogger.createLogData(null, state, 'accounts.auth.users', 'VIEW', isBulk, new Date(), null, null);
								promise= api.webGet($localStorage.authBaseUrl + '/users', undefined, true, generalProperties.forceFetch);
								promise = activityLogger.log(logData, promise);
						}
						else {
								promise= api.webGet($localStorage.authBaseUrl + '/users', undefined, true, generalProperties.forceFetch);
						}
						promise.then(function() {
								if (api.accounts.authUsers.isDirty) {
										//Invalidate lookupData
										api.accounts.authUsers.lookupData = undefined;
										api.accounts.authUsers.isDirty = false;
								}
						});
						return promise;
				}

				function createUser(user) {
						var state = {};
						state.name = $state.current.name;
						state.params = $state.params;
						var promise;
						var logData = activityLogger.createLogData(user[api.accounts.users.lookupDisplayField], state, 'accounts.authUsers', 'ADD', false, new Date(), null, null);
						promise = api.webPost($localStorage.authBaseUrl + '/users', user);
						promise = activityLogger.log(logData, promise);

						return promise;
				}

				function resetUserPassword(user) {
						var userId = user[api.accounts.authUsers.idField];
						var state = {};
						state.name = $state.current.name;
						state.params = $state.params;
						var promise;

						var logData = activityLogger.createLogData(user[api.accounts.users.lookupDisplayField], state, 'accounts.authUsers', 'EDIT', false, new Date(), null, null);
						promise = api.webPost($localStorage.authBaseUrl + '/users/' + userId + '/reset');
						promise = activityLogger.log(logData, promise);

						return promise;
				}

				function activateAuthUsers(records, model, actionType) {
					//Convert records to required format {"ids": [0],"status": true} which is different from existing format
					var result = crud.createAuthRequestObject(records, model, actionType);
					var state = {};
					state.name = $state.current.name;
					state.params = $state.params;
					var isBulk = result.Ids.length > 1 ? true : false;
					var logData = activityLogger.createLogData(result, state, 'accounts.authUsers', actionType.toUpperCase(), isBulk, new Date(), null, null);
					var promise = api.webPut($localStorage.authBaseUrl + '/users/status', result);

					promise.then(function() {
							crud.onAuthRecordStatusChange(records, model, actionType);
					});

					return activityLogger.log(logData, promise);
				}

				function updateAuthUser(userId, user) {
					var state = {};
					state.name = $state.current.name;
					state.params = $state.params;
					var logData = activityLogger.createLogData(user[api.accounts.users.lookupDisplayField], state, 'accounts.authUsers', 'EDIT', false, new Date(), null, null);
					var promise = api.webPut($localStorage.authBaseUrl + '/users?id=' + userId , user);

					promise.then(function() {
						 api.accounts.users.isDirty = true;
					});
					return activityLogger.log(logData, promise);
			}

		}
})();
(function() {
	'use strict';

	angular
		.module('app.main.accounts.admin.users')
		.run(runBlock);

	/* @ngInject */
	function runBlock(api, activityLogger, $state, crud) {

		if(angular.isUndefined(api.account)) {
			api.account = {};
		}
		api.account.adminUsers = {
			modelPath: 'account.adminUsers',
			fields: [
				{ field: 'Id', type: 'int', displayLabel: 'ADMIN_USERS.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'AccountId', type: 'int', displayLabel: 'ADMIN_USERS.FIELDS.ACCOUNT_ID', visible: false, creatable: false, editable: false, inputType: 'static',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'AccountName', type: 'text', displayLabel: 'ADMIN_USERS.FIELDS.ACCOUNT_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'FirstName', type: 'text', displayLabel: 'ADMIN_USERS.FIELDS.FIRST_NAME', visible: true, creatable: false, editable: true, inputType: 'text',
					validation: {isRequired: true, maxLen: 20, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'LastName', type: 'text', displayLabel: 'ADMIN_USERS.FIELDS.LAST_NAME', visible: true, creatable: false, editable: true, inputType: 'text',
					validation: {isRequired: true, maxLen: 20, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'Email', type: 'text', displayLabel: 'ADMIN_USERS.FIELDS.EMAIL', visible: true, creatable: false, editable: true, inputType: 'text',
					validation: {isRequired: true, maxLen: 500, minLen: 0, pattern: '^[A-Za-z]+[A-Za-z0-9._+-]+@{1}[A-Za-z0-9._-]+\.[A-Za-z.]{2,}$', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: 'VALIDATIONS.INVALID_EMAIL'}} },
				{ field: 'UserName', type: 'text', displayLabel: 'ADMIN_USERS.FIELDS.USER_NAME', visible: true, creatable: false, editable: true, inputType: 'text',
					validation: {isRequired: true, maxLen: 50, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'Phone', type: 'text', displayLabel: 'ADMIN_USERS.FIELDS.PHONE', visible: true, creatable: false, editable: true, inputType: 'tel',
					validation: {isRequired: false, maxLen: 20, minLen: 0, pattern: '[0-9]*', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '',
					invalidType: 'VALIDATIONS.INVALID_PHONE_NUMBER'}} },
				{ field: 'CountryCode', type: 'text', displayLabel: 'ADMIN_USERS.FIELDS.COUNTRY', visible: false, creatable: false, editable: true, inputType: 'lookup', lookupSource: 'lists.countries',
					validation: {isRequired: true, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'CountryCode', type: 'text', displayLabel: 'ADMIN_USERS.FIELDS.COUNTRY_CODE', visible: true, creatable: false, editable: false, inputType: 'text',
					validation: {isRequired: true, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'Country', type: 'text', displayLabel: 'ADMIN_USERS.FIELDS.COUNTRY', visible: true, creatable: false, editable: false, inputType: 'text',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'City', type: 'text', displayLabel: 'ADMIN_USERS.FIELDS.CITY', visible: true, creatable: false, editable: true, inputType: 'text',
					validation: {isRequired: false, maxLen: 25, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'Designation', type: 'text', displayLabel: 'ADMIN_USERS.FIELDS.DESIGNATION', visible: true, creatable: false, editable: true, inputType: 'text',
					validation: {isRequired: false, maxLen: 20, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'Department', type: 'text', displayLabel: 'ADMIN_USERS.FIELDS.DEPARTMENT', visible: true, creatable: false, editable: true, inputType: 'text',
					validation: {isRequired: false, maxLen: 20, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'Status', type: 'text', displayLabel: 'ADMIN_USERS.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'Roles', type: 'text', displayLabel: 'ADMIN_USERS.FIELDS.USER_ROLE', visible: true, creatable: false, editable: true, inputType: 'lookup-many', lookupSource: 'roles.roles',
					lookupFilter: {'AccountTypeId': 1}, validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'CreateDate', type: 'text', displayLabel: 'ADMIN_USERS.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'UpdateDate', type: 'text', displayLabel: 'ADMIN_USERS.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'CreatedBy', type: 'text', displayLabel: 'ADMIN_USERS.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'UpdatedBy', type: 'text', displayLabel: 'ADMIN_USERS.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
			],
			uniqueConstraints: [],
			title: 'USERS.NAV',
			icon: '',
			idField: 'Id',
			lookupDisplayField: 'Email',
			isDirty: false,
			methods: {
				getList         :   getUsers,
				activateBulk    :   activateUsers,
				update          :   updateUser
			},
			views: {
				mainList: {
					columns             : [ 'FirstName', 'Email', 'Designation', 'Status', 'UpdateDate' ],
					columnFilter        : {},
					toggleFilterProps   : { toggleStatus:false, filterProp:'Status', trueVal:1, trueValTooltipMessage: 'ACTIONS.TOGGLE_ACTIVE', falseVal:'', falseValTooltipMessage:"ACTIONS.TOGGLE_ALL"},
					topIndex            : 0,
					showFilterRow       : false,
					sortColumn          : {'UpdateDate': false},
					itemActions         : [
											{ id: 'view', label: 'ACTIONS.VIEW', icon: 'icon-magnify', privilege: 'GetUserDetails', disabled: '!itm.Status', visible: true },
											{ id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UpdateSellerAccountUserByAccountAndUserId', disabled: '!itm.Status', visible: true },
											{ id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateBulkSellerAccountUserstatus', disabled: false, visible: 'itm.Status',
												requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
											{ id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateBulkSellerAccountUserstatus', disabled: false, visible: '!itm.Status',
												requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
										],
					listActions         : [
											{ id: 'delete', label: 'ACTIONS.DELETE_BULK', icon: 'icon-delete', privilege: 'UpdateBulkSellerAccountUserstatus', disabled: '{selected: true, Status: 1}', visible: true,
												requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
											{ id: 'activate', label: 'ACTIONS.ACTIVATE_BULK', icon: 'icon-undo-variant', privilege: 'UpdateBulkSellerAccountUserstatus', disabled: '{selected: true, Status: 0}', visible: true,
												requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
										]
				},
				mainDetails: {
					selectedTabIndex   : 0,
					itemActions        : [],
					fabAction          : {}
				},
				privileges: {
					list: 'GetTrasixUsersList',
					details: 'GetUserDetails'
				}
			}
		};

		function getUsers(generalProperties) {
			var promise;
			if(angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
				var state = {};
				state.name = $state.current.name;
				state.params = $state.params;
				var isBulk = true;
				var logData = activityLogger.createLogData(null, state, 'account.adminUsers', 'VIEW', isBulk, new Date(), null, null);
				promise = api.webGet(api.baseUrl + '/trasix/' + 1 + '/users', undefined, true, generalProperties.forceFetch);
				promise = activityLogger.log(logData, promise);
			}
			else {
				promise = api.webGet(api.baseUrl + '/trasix/' + 1 + '/users', undefined, true, generalProperties.forceFetch);
			}
			return promise;
		}

		function activateUsers(records, model, actionType) {
			var result = crud.createRequestObject(records, model, actionType);
			var state = {};
			state.name = $state.current.name;
			state.params = $state.params;
			var isBulk = result.itemsNameList.length > 1 ? true : false;
			var logData = activityLogger.createLogData(result.itemsNameList, state, 'account.adminUsers', actionType.toUpperCase(), isBulk, new Date(), null, null);
			var promise = api.webPut(api.baseUrl + '/users/status', result.requestObj);

			promise.then(function() {
				crud.onRecordStatusChange(records, model, actionType);
			});

			return activityLogger.log(logData, promise);
		}

		function updateUser(userId, user) {
			var state = {};
			state.name = $state.current.name;
			state.params = $state.params;
			var logData = activityLogger.createLogData(user[api.account.adminUsers.lookupDisplayField], state, 'account.adminUsers', 'EDIT', false, new Date(), null, null);
			var promise = api.webPut(api.baseUrl + '/users/' + userId , user);

			promise.then(function() {
			   api.account.adminUsers.isDirty = true;
			});
			return activityLogger.log(logData, promise);
		}
	}
})();
(function() {
    'use strict';

    angular
        .module('app.main')
        .controller('dateRangeFilterController', dateRangeFilterController);

    /* @ngInject */
    function dateRangeFilterController(mdPanelRef) {
        /* jshint validthis: true */
        var vm = this;

        vm.closePanel = closePanel;
        vm.filterDateRange = filterDateRange;
        vm.unCheckCheckBox = unCheckCheckBox;

        function closePanel() {
            mdPanelRef.close();
        }

        function filterDateRange() {
            mdPanelRef.dateRange = vm.dateRange;
            mdPanelRef.filterTypeBlank = vm.filterTypeBlank;
            mdPanelRef.close();
        }

        function unCheckCheckBox(type) {
            if(type === 0) {
                vm.filterTypeDate = true;
                vm.filterTypeBlank = false;
            } else {
                vm.filterTypeDate = false;
                vm.filterTypeBlank = true;
                vm.dateRange = '';
            }
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.main')
        .controller('advanceFilterController', advanceFilterController);

    /* @ngInject */
    function advanceFilterController($mdDialog, $timeout, field, columnFilterData, $scope) {
        /* jshint validthis: true */
        var vm = this;

        vm.field = field;
        vm.columnFilterData = {
            filterValues: '',
            filterBlank: false,
            excludeMode: false
        };
        vm.isProcessing = false;
        var timeoutPromise;

        if(angular.isDefined(columnFilterData)) {
            vm.columnFilterData.filterBlank = angular.isDefined(columnFilterData.filterBlank) ? columnFilterData.filterBlank : false;
            vm.columnFilterData.excludeMode = angular.isDefined(columnFilterData.excludeMode) ? columnFilterData.excludeMode : false;
            if(angular.isDefined(columnFilterData.filterValues) && angular.isObject(columnFilterData.filterValues)){
                var filterValueList = [];
                for(var key in columnFilterData.filterValues) {
                    filterValueList.push(key);
                }
                vm.columnFilterData.filterValues = filterValueList.join('\n');
            }
        }

        vm.applyFilter = applyFilter;
        vm.closeDialog = closeDialog;

        function applyFilter() {
            vm.isProcessing = true;
            timeoutPromise = $timeout(function() {
                vm.columnFilterData.filterValues = vm.columnFilterData.filterValues.match(/[^\r\n]+/g);
                var filterMap = {};
                angular.forEach(vm.columnFilterData.filterValues, function(filterValue) {
                    filterMap[filterValue.trim().toLowerCase()] = '';
                });
                vm.columnFilterData.filterValues = filterMap;
                closeDialog(vm.columnFilterData);
            });
        }

        function closeDialog(values) {
            vm.isProcessing = false;
            $mdDialog.hide(values);
        }

        $scope.$on('$destroy', function() {
            $timeout.cancel(timeoutPromise);
        });

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core',
            [
                'ngAnimate',
                'ngAria',
                'ngCookies',
                'ngMessages',
                'ngResource',
                'ngSanitize',
                'ngMaterial',
                // 'angular-chartist',
                // 'chart.js',
                // 'datatables',
                // 'gridshore.c3js.chart',
                // 'nvd3',
                'pascalprecht.translate',
                // 'timer',
                'ui.router'
                // 'uiGmapgoogle-maps',
                // 'textAngular',
                // 'ui.sortable',
                // 'ng-sortable',
                // 'xeditable'
            ]);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsWidgetController', MsWidgetController)
        .directive('msWidget', msWidgetDirective)
        .directive('msWidgetFront', msWidgetFrontDirective)
        .directive('msWidgetBack', msWidgetBackDirective);

    /** @ngInject */
    function MsWidgetController($scope, $element)
    {
        var vm = this;

        // Data
        vm.flipped = false;

        // Methods
        vm.flip = flip;

        //////////

        /**
         * Flip the widget
         */
        function flip()
        {
            if ( !isFlippable() )
            {
                return;
            }

            // Toggle flipped status
            vm.flipped = !vm.flipped;

            // Toggle the 'flipped' class
            $element.toggleClass('flipped', vm.flipped);
        }

        /**
         * Check if widget is flippable
         *
         * @returns {boolean}
         */
        function isFlippable()
        {
            return (angular.isDefined($scope.flippable) && $scope.flippable === true);
        }
    }

    /** @ngInject */
    function msWidgetDirective()
    {
        return {
            restrict  : 'E',
            scope     : {
                flippable: '=?'
            },
            controller: 'MsWidgetController',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    //////////
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetFrontDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-front');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetBackDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-back');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsTimelineController', MsTimelineController)
        .directive('msTimeline', msTimelineDirective)
        .directive('msTimelineItem', msTimelineItemDirective);

    /** @ngInject */
    function MsTimelineController()
    {
        var vm = this;

        // Data
        vm.scrollEl = undefined;

        // Methods
        vm.setScrollEl = setScrollEl;
        vm.getScrollEl = getScrollEl;

        //////////

        /**
         * Set scroll element
         *
         * @param scrollEl
         */
        function setScrollEl(scrollEl)
        {
            vm.scrollEl = scrollEl;
        }

        /**
         * Get scroll element
         *
         * @returns {undefined|*}
         */
        function getScrollEl()
        {
            return vm.scrollEl;
        }
    }

    /** @ngInject */
    function msTimelineDirective()
    {
        return {
            scope     : {
                msTimeline: '=?',
                loadMore: '&?msTimelineLoadMore'
            },
            controller: 'MsTimelineController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-timeline');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    // Create an element for triggering the load more action and append it
                    var loadMoreEl = angular.element('<div class="ms-timeline-loader md-accent-bg md-whiteframe-4dp"><span class="spinner animate-rotate"></span></div>');
                    iElement.append(loadMoreEl);

                    // Default config
                    var config = {
                        scrollEl: '#content'
                    };

                    // Extend the configuration
                    config = angular.extend(config, scope.msTimeline, {});

                    // Grab the scrollable element and store it in the controller for general use
                    var scrollEl = angular.element(config.scrollEl);
                    MsTimelineCtrl.setScrollEl(scrollEl);

                    // Threshold
                    var threshold = 144;

                    // Register onScroll event for the first time
                    registerOnScroll();

                    /**
                     * onScroll Event
                     */
                    function onScroll()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() + threshold > loadMoreEl.position().top )
                        {
                            // Show the loader
                            loadMoreEl.addClass('show');

                            // Unregister scroll event to prevent triggering the function over and over again
                            unregisterOnScroll();

                            // Trigger load more event
                            scope.loadMore().then(
                                // Success
                                function ()
                                {
                                    // Hide the loader
                                    loadMoreEl.removeClass('show');

                                    // Register the onScroll event again
                                    registerOnScroll();
                                },

                                // Error
                                function ()
                                {
                                    // Remove the loader completely
                                    loadMoreEl.remove();
                                }
                            );
                        }
                    }

                    /**
                     * onScroll event registerer
                     */
                    function registerOnScroll()
                    {
                        scrollEl.on('scroll', onScroll);
                    }

                    /**
                     * onScroll event unregisterer
                     */
                    function unregisterOnScroll()
                    {
                        scrollEl.off('scroll', onScroll);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        unregisterOnScroll();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msTimelineItemDirective($timeout, $q)
    {
        return {
            scope  : true,
            require: '^msTimeline',
            compile: function (tElement)
            {
                tElement.addClass('ms-timeline-item').addClass('hidden');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    var threshold = 72,
                        itemLoaded = false,
                        itemInViewport = false,
                        scrollEl = MsTimelineCtrl.getScrollEl();

                    //////////

                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Check if the timeline item has ms-card
                        if ( iElement.find('ms-card') )
                        {
                            // If the ms-card template loaded...
                            scope.$on('msCard::cardTemplateLoaded', function (event, args)
                            {
                                var cardEl = angular.element(args[0]);

                                // Test the card to see if there is any image on it
                                testForImage(cardEl).then(function ()
                                {
                                    $timeout(function ()
                                    {
                                        itemLoaded = true;
                                    });
                                });
                            });
                        }
                        else
                        {
                            // Test the element to see if there is any image on it
                            testForImage(iElement).then(function ()
                            {
                                $timeout(function ()
                                {
                                    itemLoaded = true;
                                });
                            });
                        }

                        // Check if the loaded element also in the viewport
                        scrollEl.on('scroll', testForVisibility);

                        // Test for visibility for the first time without waiting for the scroll event
                        testForVisibility();
                    }

                    // Item ready watcher
                    var itemReadyWatcher = scope.$watch(
                        function ()
                        {
                            return itemLoaded && itemInViewport;
                        },
                        function (current, old)
                        {
                            if ( angular.equals(current, old) )
                            {
                                return;
                            }

                            if ( current )
                            {
                                iElement.removeClass('hidden').addClass('animate');

                                // Unbind itemReadyWatcher
                                itemReadyWatcher();
                            }
                        }, true);

                    /**
                     * Test the given element for image
                     *
                     * @param element
                     * @returns promise
                     */
                    function testForImage(element)
                    {
                        var deferred = $q.defer(),
                            imgEl = element.find('img');

                        if ( imgEl.length > 0 )
                        {
                            imgEl.on('load', function ()
                            {
                                deferred.resolve('Image is loaded');
                            });
                        }
                        else
                        {
                            deferred.resolve('No images');
                        }

                        return deferred.promise;
                    }

                    /**
                     * Test the element for visibility
                     */
                    function testForVisibility()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() > iElement.position().top + threshold )
                        {
                            $timeout(function ()
                            {
                                itemInViewport = true;
                            });

                            // Unbind the scroll event
                            scrollEl.off('scroll', testForVisibility);
                        }
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsStepperController', MsStepperController)
        .directive('msStepper', msStepperDirective)
        .directive('msStepperStep', msStepperStepDirective);

    /** @ngInject */
    function MsStepperController($timeout)
    {
        var vm = this;

        // Data
        vm.mainForm = undefined;

        vm.steps = [];
        vm.currentStep = undefined;
        vm.currentStepNumber = 1;

        // Methods
        vm.registerMainForm = registerMainForm;
        vm.registerStep = registerStep;
        vm.setupSteps = setupSteps;
        vm.resetForm = resetForm;

        vm.setCurrentStep = setCurrentStep;

        vm.gotoStep = gotoStep;
        vm.gotoPreviousStep = gotoPreviousStep;
        vm.gotoNextStep = gotoNextStep;
        vm.gotoFirstStep = gotoFirstStep;
        vm.gotoLastStep = gotoLastStep;

        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.isStepCurrent = isStepCurrent;
        vm.isStepDisabled = isStepDisabled;
        vm.isStepOptional = isStepOptional;
        vm.isStepHidden = isStepHidden;
        vm.filterHiddenStep = filterHiddenStep;
        vm.isStepValid = isStepValid;
        vm.isStepNumberValid = isStepNumberValid;

        vm.isFormValid = isFormValid;

        //////////

        /**
         * Register the main form
         *
         * @param form
         */
        function registerMainForm(form)
        {
            vm.mainForm = form;
        }

        /**
         * Register a step
         *
         * @param element
         * @param scope
         * @param form
         */
        function registerStep(element, scope, form)
        {
            var step = {
                element   : element,
                scope     : scope,
                form      : form,
                stepNumber: scope.step || (vm.steps.length + 1),
                stepTitle : scope.stepTitle,
                stepTitleTranslate: scope.stepTitleTranslate
            };

            // Push the step into steps array
            vm.steps.push(step);

            // Sort steps by stepNumber
            vm.steps.sort(function (a, b)
            {
                return a.stepNumber - b.stepNumber;
            });
        }

        /**
         * Setup steps for the first time
         */
        function setupSteps()
        {
            vm.setCurrentStep(vm.currentStepNumber);
        }

        /**
         * Reset steps and the main form
         */
        function resetForm()
        {
            // Timeout is required here because we need to
            // let form model to reset before setting the
            // statuses
            $timeout(function ()
            {
                // Reset all the steps
                for ( var x = 0; x < vm.steps.length; x++ )
                {
                    vm.steps[x].form.$setPristine();
                    vm.steps[x].form.$setUntouched();
                }

                // Reset the main form
                vm.mainForm.$setPristine();
                vm.mainForm.$setUntouched();

                // Go to first step
                gotoFirstStep();
            });
        }

        /**
         * Set current step
         *
         * @param stepNumber
         */
        function setCurrentStep(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return;
            }

            //Add callback for step changes
            if (angular.isFunction(vm.model.onStepChange)) {
                if (!vm.model.onStepChange(vm.currentStepNumber, stepNumber))
                {
                    return;
                }
            }

            // Update the current step number
            vm.currentStepNumber = stepNumber;

            // Hide all steps
            for ( var i = 0; i < vm.steps.length; i++ )
            {
                vm.steps[i].element.hide();
            }

            // Show the current step
            vm.steps[vm.currentStepNumber - 1].element.show();
        }

        /**
         * Go to a step
         *
         * @param stepNumber
         */
        function gotoStep(stepNumber)
        {
            // If the step we are about to go
            // is hidden, bail...
            if ( isStepHidden(stepNumber) )
            {
                return;
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the previous step
         */
        function gotoPreviousStep()
        {
            var stepNumber = vm.currentStepNumber - 1;

            // Test the previous steps and make sure
            // we will land to a one that is not hidden
            for ( var s = stepNumber; s >= 1; s-- )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the next step
         */
        function gotoNextStep()
        {
            var stepNumber = vm.currentStepNumber + 1;

            // Test the following steps and make sure
            // we will land to a one that is not hidden
            for ( var s = stepNumber; s <= vm.steps.length; s++ )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the first step
         */
        function gotoFirstStep()
        {
            vm.setCurrentStep(1);
        }

        /**
         * Go to the last step
         */
        function gotoLastStep()
        {
            vm.setCurrentStep(vm.steps.length);
        }

        /**
         * Check if the current step is the first step
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.currentStepNumber === 1;
        }

        /**
         * Check if the current step is the last step
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.currentStepNumber === vm.steps.length;
        }

        /**
         * Check if the given step is the current one
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepCurrent(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.currentStepNumber === stepNumber;
        }

        /**
         * Check if the given step should be disabled
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepDisabled(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            var disabled = false;

            for ( var i = 1; i < stepNumber; i++ )
            {
                if ( !isStepValid(i) )
                {
                    disabled = true;
                    break;
                }
            }

            return disabled;
        }

        /**
         * Check if the given step is optional
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepOptional(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.steps[stepNumber - 1].scope.optionalStep;
        }

        /**
         * Check if the given step is hidden
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepHidden(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return !!vm.steps[stepNumber - 1].scope.hideStep;
        }

        /**
         * Check if the given step is hidden as a filter
         *
         * @param step
         * @returns {boolean}
         */
        function filterHiddenStep(step)
        {
            return !isStepHidden(step.stepNumber);
        }

        /**
         * Check if the given step is valid
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepValid(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            // If the step is optional, always return true
            if ( isStepOptional(stepNumber) )
            {
                return true;
            }

            return vm.steps[stepNumber - 1].form.$valid;
        }

        /**
         * Check if the given step number is a valid step number
         *
         * @param stepNumber
         * @returns {boolean}
         */
        function isStepNumberValid(stepNumber)
        {
            return !(angular.isUndefined(stepNumber) || stepNumber < 1 || stepNumber > vm.steps.length);
        }

        /**
         * Check if the entire form is valid
         *
         * @returns {boolean}
         */
        function isFormValid()
        {
            return vm.mainForm.$valid;
        }
    }

    /** @ngInject */
    function msStepperDirective()
    {
        return {
            restrict        : 'A',
            require         : ['form', 'msStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/horizontal/horizontal.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time
                    MsStepperCtrl.registerMainForm(FormCtrl);
                    MsStepperCtrl.setupSteps();
                };
            }
        };
    }

    /** @ngInject */
    function msStepperStepDirective()
    {
        return {
            restrict: 'E',
            require : ['form', '^msStepper'],
            priority: 1000,
            scope   : {
                step        : '=?',
                stepTitle   : '=?',
                stepTitleTranslate: '=?',
                optionalStep: '=?',
                hideStep    : '=?'
            },
            compile : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Hide the step by default
                    iElement.hide();
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSplashScreen', msSplashScreenDirective);

    /** @ngInject */
    function msSplashScreenDirective($animate)
    {
        return {
            restrict: 'E',
            link    : function (scope, iElement)
            {
                var splashScreenRemoveEvent = scope.$on('msSplashScreen::remove', function ()
                {
                    $animate.leave(iElement).then(function ()
                    {
                        // De-register scope event
                        splashScreenRemoveEvent();

                        // Null-ify everything else
                        scope = iElement = null;
                    });
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSidenavHelper', msSidenavHelperDirective);

    /** @ngInject */
    function msSidenavHelperDirective()
    {
        return {
            restrict: 'A',
            require : '^mdSidenav',
            link    : function (scope, iElement, iAttrs, MdSidenavCtrl)
            {
                // Watch md-sidenav open & locked open statuses
                // and add class to the ".page-layout" if only
                // the sidenav open and NOT locked open
                scope.$watch(function ()
                {
                    return MdSidenavCtrl.isOpen() && !MdSidenavCtrl.isLockedOpen();
                }, function (current)
                {
                    if ( angular.isUndefined(current) )
                    {
                        return;
                    }

                    iElement.parent().toggleClass('full-height', current);
                    angular.element('html').toggleClass('sidenav-open', current);
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSearchBar', msSearchBarDirective);

    /** @ngInject */
    function msSearchBarDirective($document)
    {
        return {
            restrict   : 'E',
            scope      : true,
            templateUrl: 'app/core/directives/ms-search-bar/ms-search-bar.html',
            compile    : function (tElement)
            {
                // Add class
                tElement.addClass('ms-search-bar');

                return function postLink(scope, iElement)
                {
                    var expanderEl,
                        collapserEl;

                    // Initialize
                    init();

                    function init()
                    {
                        expanderEl = iElement.find('#ms-search-bar-expander');
                        collapserEl = iElement.find('#ms-search-bar-collapser');

                        expanderEl.on('click', expand);
                        collapserEl.on('click', collapse);
                    }

                    /**
                     * Expand
                     */
                    function expand()
                    {
                        iElement.addClass('expanded');

                        // Esc key event
                        $document.on('keyup', escKeyEvent);
                    }

                    /**
                     * Collapse
                     */
                    function collapse()
                    {
                        iElement.removeClass('expanded');
                    }

                    /**
                     * Escape key event
                     *
                     * @param e
                     */
                    function escKeyEvent(e)
                    {
                        if ( e.keyCode === 27 )
                        {
                            collapse();
                            $document.off('keyup', escKeyEvent);
                        }
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msScrollConfig', msScrollConfigProvider)
        .directive('msScroll', msScrollDirective);

    /** @ngInject */
    function msScrollConfigProvider()
    {
        // Default configuration
        var defaultConfiguration = {
            wheelSpeed            : 1,
            wheelPropagation      : false,
            swipePropagation      : true,
            minScrollbarLength    : null,
            maxScrollbarLength    : null,
            useBothWheelAxes      : false,
            useKeyboard           : true,
            suppressScrollX       : false,
            suppressScrollY       : false,
            scrollXMarginOffset   : 0,
            scrollYMarginOffset   : 0,
            stopPropagationOnClick: true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig
            };

            return service;

            //////////

            /**
             * Return the config
             */
            function getConfig()
            {
                return defaultConfiguration;
            }
        };
    }

    /** @ngInject */
    function msScrollDirective($timeout, msScrollConfig, msUtils, fuseConfig)
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                // Do not replace scrollbars if
                // 'disableCustomScrollbars' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbars') )
                {
                    return;
                }

                // Do not replace scrollbars on mobile devices
                // if 'disableCustomScrollbarsOnMobile' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbarsOnMobile') && msUtils.isMobile() )
                {
                    return;
                }

                // Add class
                tElement.addClass('ms-scroll');

                return function postLink(scope, iElement, iAttrs)
                {
                    var options = {};

                    // If options supplied, evaluate the given
                    // value. This is because we don't want to
                    // have an isolated scope but still be able
                    // to use scope variables.
                    // We don't want an isolated scope because
                    // we should be able to use this everywhere
                    // especially with other directives
                    if ( iAttrs.msScroll )
                    {
                        options = scope.$eval(iAttrs.msScroll);
                    }

                    // Extend the given config with the ones from provider
                    options = angular.extend({}, msScrollConfig.getConfig(), options);

                    // Initialize the scrollbar
                    $timeout(function ()
                    {
                        PerfectScrollbar.initialize(iElement[0], options);
                    }, 0);

                    // Update the scrollbar on element mouseenter
                    iElement.on('mouseenter', updateScrollbar);

                    // Watch scrollHeight and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollHeight');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    // Watch scrollWidth and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollWidth');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    /**
                     * Update the scrollbar
                     */
                    function updateScrollbar()
                    {
                        PerfectScrollbar.update(iElement[0]);
                    }

                    // Cleanup on destroy
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('mouseenter');
                        PerfectScrollbar.destroy(iElement[0]);
                    });
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msResponsiveTable', msResponsiveTableDirective);

    /** @ngInject */
    function msResponsiveTableDirective()
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement)
            {
                // Wrap the table
                var wrapper = angular.element('<div class="ms-responsive-table-wrapper"></div>');
                iElement.after(wrapper);
                wrapper.append(iElement);

                //////////
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msRandomClass', msRandomClassDirective);

    /** @ngInject */
    function msRandomClassDirective()
    {
        return {
            restrict: 'A',
            scope   : {
                msRandomClass: '='
            },
            link    : function (scope, iElement)
            {
                var randomClass = scope.msRandomClass[Math.floor(Math.random() * (scope.msRandomClass.length))];
                iElement.addClass(randomClass);
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msNavigationService', msNavigationServiceProvider)
        .controller('MsNavigationController', MsNavigationController)
        // Vertical
        .directive('msNavigation', msNavigationDirective)
        .controller('MsNavigationNodeController', MsNavigationNodeController)
        .directive('msNavigationNode', msNavigationNodeDirective)
        .directive('msNavigationItem', msNavigationItemDirective)
        //Horizontal
        .directive('msNavigationHorizontal', msNavigationHorizontalDirective)
        .controller('MsNavigationHorizontalNodeController', MsNavigationHorizontalNodeController)
        .directive('msNavigationHorizontalNode', msNavigationHorizontalNodeDirective)
        .directive('msNavigationHorizontalItem', msNavigationHorizontalItemDirective);

    /** @ngInject */
    function msNavigationServiceProvider()
    {
        // Inject $log service
        var $log = angular.injector(['ng']).get('$log');

        // Navigation array
        var navigation = [];
        var filteredNavigation = [];
        var service = this;

        // Methods
        service.saveItem = saveItem;
        service.deleteItem = deleteItem;
        service.sortByWeight = sortByWeight;
        service.filteredNavSortByWeight = filteredNavSortByWeight;

        //////////

        /**
         * Create or update the navigation item
         *
         * @param path
         * @param item
         */
        function saveItem(path, item)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            var parts = path.split('.');

            // Generate the object id from the parts
            var id = parts[parts.length - 1];

            // Get the parent item from the parts
            var parent = _findOrCreateParent(parts);

            // Decide if we are going to update or create
            var updateItem = false;

            for ( var i = 0; i < parent.length; i++ )
            {
                if ( parent[i]._id === id )
                {
                    updateItem = parent[i];

                    break;
                }
            }

            // Update
            if ( updateItem )
            {
                angular.extend(updateItem, item);

                // Add proper ui-sref
                updateItem.uisref = _getUiSref(updateItem);
            }
            // Create
            else
            {
                // Create an empty children array in the item
                item.children = [];

                // Add the default weight if not provided or if it's not a number
                if ( angular.isUndefined(item.weight) || !angular.isNumber(item.weight) )
                {
                    item.weight = 1;
                }

                // Add the item id
                item._id = id;

                // Add the item path
                item._path = path;

                // Add proper ui-sref
                item.uisref = _getUiSref(item);

                // Push the item into the array
                parent.push(item);
            }
        }

        /**
         * Delete navigation item
         *
         * @param path
         */
        function deleteItem(path)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            // Locate the item by using given path
            var item = navigation,
                parts = path.split('.');

            for ( var p = 0; p < parts.length; p++ )
            {
                var id = parts[p];

                for ( var i = 0; i < item.length; i++ )
                {
                    if ( item[i]._id === id )
                    {
                        // If we have a matching path,
                        // we have found our object:
                        // remove it.
                        if ( item[i]._path === path )
                        {
                            item.splice(i, 1);
                            return true;
                        }

                        // Otherwise grab the children of
                        // the current item and continue
                        item = item[i].children;
                        break;
                    }
                }
            }

            return false;
        }

        /**
         * Sort the navigation items by their weights
         *
         * @param parent
         */
        function sortByWeight(parent)
        {
            // If parent not provided, sort the root items
            if ( !parent )
            {
                parent = navigation;

            }
            parent.sort(_byWeight);
            // Sort the children
            for ( var i = 0; i < parent.length; i++ )
            {
                var children = parent[i].children;

                if ( children.length > 1 )
                {
                    children.sort(_byWeight);
                }

                if ( children.length > 0 )
                {
                    sortByWeight(children);
                }
            }
        }

        /**
        * Sort the filteredNavigation items by their weights
        *
        * @param parent
        */
        function filteredNavSortByWeight(parent) {
            // If parent not provided, sort the root items
            if (!parent) {
                parent = filteredNavigation;
            }
            parent.sort(_byWeight);
            // Sort the children
            for (var i = 0; i < parent.length; i++) {
                var children = parent[i].children;
                if (children.length > 1) {
                    children.sort(_byWeight);
                }
                if (children.length > 0) {
                    filteredNavSortByWeight(children);
                }
            }
        }

        /* ----------------- */
        /* Private Functions */
        /* ----------------- */

        /**
         * Find or create parent
         *
         * @param parts
         * @returns {Array|Boolean}
         * @private
         */
        function _findOrCreateParent(parts)
        {
            // Store the main navigation
            var parent = navigation;

            // If it's going to be a root item
            // return the navigation itself
            if ( parts.length === 1 )
            {
                return parent;
            }

            // Remove the last element from the parts as
            // we don't need that to figure out the parent
            parts.pop();

            // Find and return the parent
            for ( var i = 0; i < parts.length; i++ )
            {
                var _id = parts[i],
                    createParent = true;

                for ( var p = 0; p < parent.length; p++ )
                {
                    if ( parent[p]._id === _id )
                    {
                        parent = parent[p].children;
                        createParent = false;

                        break;
                    }
                }

                // If there is no parent found, create one, push
                // it into the current parent and assign it as a
                // new parent
                if ( createParent )
                {
                    var item = {
                        _id     : _id,
                        _path   : parts.join('.'),
                        title   : _id,
                        weight  : 1,
                        children: []
                    };

                    parent.push(item);
                    parent = item.children;
                }
            }

            return parent;
        }

        /**
         * Sort by weight
         *
         * @param x
         * @param y
         * @returns {number}
         * @private
         */
        function _byWeight(x, y)
        {
            return parseInt(x.weight) - parseInt(y.weight);
        }

        /**
         * Setup the ui-sref using state & state parameters
         *
         * @param item
         * @returns {string}
         * @private
         */
        function _getUiSref(item)
        {
            var uisref = '';

            if ( angular.isDefined(item.state) )
            {
                uisref = item.state;

                if ( angular.isDefined(item.stateParams) && angular.isObject(item.stateParams) )
                {
                    uisref = uisref + '(' + angular.toJson(item.stateParams) + ')';
                }
            }

            return uisref;
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */

        this.$get = function ()
        {
            var activeItem = null,
                navigationScope = null,
                folded = null,
                foldedOpen = null;

            var service = {
                saveItem                : saveItem,
                deleteItem              : deleteItem,
                sort                    : sortByWeight,
                clearNavigation         : clearNavigation,
                setActiveItem           : setActiveItem,
                getActiveItem           : getActiveItem,
                getNavigationObject     : getNavigationObject,
                setFilteredNavigation   : setFilteredNavigation,
                getFilteredNavigation   : getFilteredNavigation,
                setNavigationScope      : setNavigationScope,
                setFolded               : setFolded,
                getFolded               : getFolded,
                setFoldedOpen           : setFoldedOpen,
                getFoldedOpen           : getFoldedOpen,
                toggleFolded            : toggleFolded,
                filteredNavSort         : filteredNavSortByWeight
            };

            return service;

            //////////

             /**
             * Clear the entire navigation
             */
            function clearNavigation()
            {
                // Clear the navigation array
                navigation = [];

                // Clear the vm.navigation from main controller
                if ( navigationScope )
                {
                    navigationScope.vm.navigation = [];
                }
            }

            /**
             * Set active item
             *
             * @param node
             * @param scope
             */
            function setActiveItem(node, scope)
            {
                activeItem = {
                    node : node,
                    scope: scope
                };
            }

            /**
             * Return active item
             */
            function getActiveItem()
            {
                return activeItem;
            }

            /**
             * Return navigation object
             *
             * @param root
             * @returns {Array}
             */
            function getNavigationObject(root)
            {
                if ( root )
                {
                    for ( var i = 0; i < navigation.length; i++ )
                    {
                        if ( navigation[i]._id === root )
                        {
                            return [navigation[i]];
                        }
                    }

                    return null;
                }

                return navigation;
            }

            // /**
            //  * set filtered navigation object
            //  *
            //  * @param root
            //  */
            function setFilteredNavigation(navigationObject) {
                filteredNavigation = navigationObject;
            }

            //  /**
            //  * get filtered navigation object
            //  *
            //  * @returns {Array}
            //  */
            function getFilteredNavigation() {
                return filteredNavigation;
            }

            /**
             * Store navigation's scope for later use
             *
             * @param scope
             */
            function setNavigationScope(scope)
            {
                navigationScope = scope;
            }

            /**
             * Set folded status
             *
             * @param status
             */
            function setFolded(status)
            {
                folded = status;
            }

            /**
             * Return folded status
             *
             * @returns {*}
             */
            function getFolded()
            {
                return folded;
            }

            /**
             * Set folded open status
             *
             * @param status
             */
            function setFoldedOpen(status)
            {
                foldedOpen = status;
            }

            /**
             * Return folded open status
             *
             * @returns {*}
             */
            function getFoldedOpen()
            {
                return foldedOpen;
            }


            /**
             * Toggle fold on stored navigation's scope
             */
            function toggleFolded()
            {
                navigationScope.toggleFolded();
            }
        };
    }

    /** @ngInject */
    function MsNavigationController($scope, msNavigationService)
    {
        var vm = this;

        // Data
        if ( $scope.root )
        {
            vm.navigation = msNavigationService.getNavigationObject($scope.root);
        }
        else
        {
            vm.navigation =  msNavigationService.getFilteredNavigation();
            msNavigationService.sort(vm.navigation);
        }

       $scope.$on('updateFilteredNavigation', function() {
            vm.filteredNavigation = msNavigationService.getFilteredNavigation();
       });

        // Methods
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Sort the navigation before doing anything else
            msNavigationService.sort();
            vm.filteredNavigation = angular.copy(vm.navigation);
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            angular.element('body').toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }
    }

    /** @ngInject */
    function msNavigationDirective($rootScope, $timeout, $mdSidenav, msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                folded: '=',
                root  : '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/vertical.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation');

                return function postLink(scope, iElement)
                {
                    var bodyEl = angular.element('body'),
                        foldExpanderEl = angular.element('<div id="ms-navigation-fold-expander"></div>'),
                        foldCollapserEl = angular.element('<div id="ms-navigation-fold-collapser"></div>'),
                        sidenav = $mdSidenav('navigation');

                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Set the folded status for the first time.
                        // First, we have to check if we have a folded
                        // status available in the service already. This
                        // will prevent navigation to act weird if we already
                        // set the fold status, remove the navigation and
                        // then re-initialize it, which happens if we
                        // change to a view without a navigation and then
                        // come back with history.back() function.

                        // If the service didn't initialize before, set
                        // the folded status from scope, otherwise we
                        // won't touch anything because the folded status
                        // already set in the service...
                        if ( msNavigationService.getFolded() === null )
                        {
                            msNavigationService.setFolded(scope.folded);
                        }

                        if ( msNavigationService.getFolded() )
                        {
                            // Collapse everything.
                            // This must be inside a $timeout because by the
                            // time we call this, the 'msNavigation::collapse'
                            // event listener is not registered yet. $timeout
                            // will ensure that it will be called after it is
                            // registered.
                            $timeout(function ()
                            {
                                $rootScope.$broadcast('msNavigation::collapse');
                            });

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                    }

                    // Sidenav locked open status watcher
                    scope.$watch(function ()
                    {
                        return sidenav.isLockedOpen();
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        var folded = msNavigationService.getFolded();

                        if ( folded )
                        {
                            if ( current )
                            {
                                // Collapse everything
                                $rootScope.$broadcast('msNavigation::collapse');
                            }
                            else
                            {
                                // Expand the active one and its parents
                                var activeItem = msNavigationService.getActiveItem();
                                if ( activeItem )
                                {
                                    activeItem.scope.$emit('msNavigation::stateMatched');
                                }
                            }
                        }
                    });

                    // Folded status watcher
                    scope.$watch('folded', function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        setFolded(current);
                    });

                    /**
                     * Set folded status
                     *
                     * @param folded
                     */
                    function setFolded(folded)
                    {
                        // Store folded status on the service for global access
                        msNavigationService.setFolded(folded);

                        if ( folded )
                        {
                            // Collapse everything
                            $rootScope.$broadcast('msNavigation::collapse');

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                        else
                        {
                            // Expand the active one and its parents
                            var activeItem = msNavigationService.getActiveItem();
                            if ( activeItem )
                            {
                                activeItem.scope.$emit('msNavigation::stateMatched');
                            }

                            // Remove body class
                            bodyEl.removeClass('ms-navigation-folded ms-navigation-folded-open');

                            // Remove fold collapser
                            removeFoldCollapser();
                        }
                    }

                    /**
                     * Set fold expander
                     */
                    function setFoldExpander()
                    {
                        iElement.parent().append(foldExpanderEl);

                        // Let everything settle for a moment
                        // before registering the event listener
                        $timeout(function ()
                        {
                            foldExpanderEl.on('mouseenter touchstart', onFoldExpanderHover);
                        });
                    }

                    /**
                     * Set fold collapser
                     */
                    function setFoldCollapser()
                    {
                        bodyEl.find('#main').append(foldCollapserEl);
                        foldCollapserEl.on('mouseenter touchstart', onFoldCollapserHover);
                    }

                    /**
                     * Remove fold collapser
                     */
                    function removeFoldCollapser()
                    {
                        foldCollapserEl.remove();
                    }

                    /**
                     * onHover event of foldExpander
                     */
                    function onFoldExpanderHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(true);

                        // Expand the active one and its parents
                        var activeItem = msNavigationService.getActiveItem();
                        if ( activeItem )
                        {
                            activeItem.scope.$emit('msNavigation::stateMatched');
                        }

                        // Add class to the body
                        bodyEl.addClass('ms-navigation-folded-open');

                        // Remove the fold opener
                        foldExpanderEl.remove();

                        // Set fold collapser
                        setFoldCollapser();
                    }

                    /**
                     * onHover event of foldCollapser
                     */
                    function onFoldCollapserHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(false);

                        // Collapse everything
                        $rootScope.$broadcast('msNavigation::collapse');

                        // Remove body class
                        bodyEl.removeClass('ms-navigation-folded-open');

                        // Remove the fold collapser
                        foldCollapserEl.remove();

                        // Set fold expander
                        setFoldExpander();
                    }

                    /**
                     * Public access for toggling folded status externally
                     */
                    scope.toggleFolded = function ()
                    {
                        var folded = msNavigationService.getFolded();

                        setFolded(!folded);
                    };

                    /**
                     * On $stateChangeStart
                     */
                    scope.$on('$stateChangeStart', function ()
                    {
                        // Close the sidenav
                        sidenav.close();
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        foldCollapserEl.off('mouseenter touchstart');
                        foldExpanderEl.off('mouseenter touchstart');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationNodeController($scope, $element, $rootScope, $animate, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.collapsed = undefined;
        vm.collapsable = undefined;
        vm.group = undefined;
        vm.animateHeightClass = 'animate-height';

        // Methods
        vm.toggleCollapsed = toggleCollapsed;
        vm.collapse = collapse;
        vm.expand = expand;
        vm.getClass = getClass;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Is collapsable?
            if ( !vm.hasChildren || vm.group )
            {
                vm.collapsable = false;
            }
            else
            {
                vm.collapsable = !!(angular.isUndefined(vm.node.collapsable) || typeof vm.node.collapsable !== 'boolean' || vm.node.collapsable === true);
            }

            // Is collapsed?
            if ( !vm.collapsable )
            {
                vm.collapsed = false;
            }
            else
            {
                vm.collapsed = !!(angular.isUndefined(vm.node.collapsed) || typeof vm.node.collapsed !== 'boolean' || vm.node.collapsed === true);
            }

            // Expand all parents if we have a matching state or
            // the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Expand if the current scope is collapsable and is collapsed
                if ( vm.collapsable && vm.collapsed )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.collapsed = false;
                    });
                }
            });

            // Listen for collapse event
            $scope.$on('msNavigation::collapse', function (event, path)
            {
                if ( vm.collapsed || !vm.collapsable )
                {
                    return;
                }

                // If there is no path defined, collapse
                if ( angular.isUndefined(path) )
                {
                    vm.collapse();
                }
                // If there is a path defined, do not collapse
                // the items that are inside that path. This will
                // prevent parent items from collapsing
                else
                {
                    var givenPathParts = path.split('.'),
                        activePathParts = [];

                    var activeItem = msNavigationService.getActiveItem();
                    if ( activeItem )
                    {
                        activePathParts = activeItem.node._path.split('.');
                    }

                    // Test for given path
                    if ( givenPathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    // Test for active path
                    if ( activePathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    vm.collapse();
                }
            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Collapse everything except the one we're using
                    $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
                }
            });
        }

        /**
         * Toggle collapsed
         */
        function toggleCollapsed()
        {
            if ( vm.collapsed )
            {
                vm.expand();
            }
            else
            {
                vm.collapse();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Grab the element that we are going to collapse
            var collapseEl = vm.element.children('ul');

            // Grab the height
            var height = collapseEl[0].offsetHeight;

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = true;

                // Add collapsing class to the node
                vm.element.addClass('collapsing');

                // Animate the height
                $animate.animate(collapseEl,
                    {
                        'display': 'block',
                        'height' : height + 'px'
                    },
                    {
                        'height': '0px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        collapseEl.css({
                            'display': '',
                            'height' : ''
                        });

                        // Clear collapsing class from the node
                        vm.element.removeClass('collapsing');
                    }
                );

                // Broadcast the collapse event so child items can also be collapsed
                $scope.$broadcast('msNavigation::collapse');
            });
        }

        /**
         * Expand
         */
        function expand()
        {
            // Grab the element that we are going to expand
            var expandEl = vm.element.children('ul');

            // Move the element out of the dom flow and
            // make it block so we can get its height
            expandEl.css({
                'position'  : 'absolute',
                'visibility': 'hidden',
                'display'   : 'block',
                'height'    : 'auto'
            });

            // Grab the height
            var height = expandEl[0].offsetHeight;

            // Reset the style modifications
            expandEl.css({
                'position'  : '',
                'visibility': '',
                'display'   : '',
                'height'    : ''
            });

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = false;

                // Add expanding class to the node
                vm.element.addClass('expanding');

                // Animate the height
                $animate.animate(expandEl,
                    {
                        'display': 'block',
                        'height' : '0px'
                    },
                    {
                        'height': height + 'px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        expandEl.css({
                            'height': ''
                        });

                        // Clear expanding class from the node
                        vm.element.removeClass('expanding');
                    }
                );

                // If item expanded, broadcast the collapse event from rootScope so that the other expanded items
                // can be collapsed. This is necessary for keeping only one parent expanded at any time
                $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }
    }

    /** @ngInject */
    function msNavigationNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationNode'
            },
            controller      : 'MsNavigationNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationItemDirective()
    {
        return {
            restrict: 'A',
            require : '^msNavigationNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // If the item is collapsable...
                    if ( MsNavigationNodeCtrl.collapsable )
                    {
                        iElement.on('click', MsNavigationNodeCtrl.toggleCollapsed);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalDirective(msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                root   : '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/horizontal.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal');

                return function postLink(scope)
                {
                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationHorizontalNodeController($scope, $element, $rootScope, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.group = undefined;

        // Methods
        vm.getClass = getClass;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Is active
            vm.isActive = false;

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Mark all parents as active if we have a matching state
            // or the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Mark as active if has children
                if ( vm.hasChildren )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
            });

            // Listen for clearActive event
            $scope.$on('msNavigation::clearActive', function ()
            {
                if ( !vm.hasChildren )
                {
                    return;
                }

                var activePathParts = [];

                var activeItem = msNavigationService.getActiveItem();
                if ( activeItem )
                {
                    activePathParts = activeItem.node._path.split('.');
                }

                // Test for active path
                if ( activePathParts.indexOf(vm.node._id) > -1 )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
                else
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = false;
                    });
                }

            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Clear all active states everything except the one we're using
                    $rootScope.$broadcast('msNavigation::clearActive');
                }
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }
    }

    /** @ngInject */
    function msNavigationHorizontalNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationHorizontalNode'
            },
            controller      : 'MsNavigationHorizontalNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationHorizontalNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationHorizontalNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalItemDirective($mdMedia)
    {
        return {
            restrict: 'A',
            require : '^msNavigationHorizontalNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    iElement.on('click', onClick);

                    function onClick()
                    {
                        if ( !MsNavigationHorizontalNodeCtrl.hasChildren || $mdMedia('gt-md') )
                        {
                            return;
                        }

                        iElement.toggleClass('expanded');
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msNavFoldService', msNavFoldService)
        .directive('msNavIsFolded', msNavIsFoldedDirective)
        .controller('MsNavController', MsNavController)
        .directive('msNav', msNavDirective)
        .directive('msNavTitle', msNavTitleDirective)
        .directive('msNavButton', msNavButtonDirective)
        .directive('msNavToggle', msNavToggleDirective);

    /** @ngInject */
    function msNavFoldService()
    {
        var foldable = {};

        var service = {
            setFoldable    : setFoldable,
            isNavFoldedOpen: isNavFoldedOpen,
            toggleFold     : toggleFold,
            openFolded     : openFolded,
            closeFolded    : closeFolded
        };

        return service;

        //////////

        /**
         * Set the foldable
         *
         * @param scope
         * @param element
         */
        function setFoldable(scope, element)
        {
            foldable = {
                'scope'  : scope,
                'element': element
            };
        }

        /**
         * Is folded open
         */
        function isNavFoldedOpen()
        {
            return foldable.scope.isNavFoldedOpen();
        }

        /**
         * Toggle fold
         */
        function toggleFold()
        {
            foldable.scope.toggleFold();
        }

        /**
         * Open folded navigation
         */
        function openFolded()
        {
            foldable.scope.openFolded();
        }

        /**
         * Close folded navigation
         */
        function closeFolded()
        {
            foldable.scope.closeFolded();
        }
    }

    /** @ngInject */
    function msNavIsFoldedDirective($document, $rootScope, msNavFoldService)
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement, iAttrs)
            {
                var isFolded = (iAttrs.msNavIsFolded === 'true'),
                    isFoldedOpen = false,
                    body = angular.element($document[0].body),
                    openOverlay = angular.element('<div id="ms-nav-fold-open-overlay"></div>'),
                    closeOverlay = angular.element('<div id="ms-nav-fold-close-overlay"></div>'),
                    sidenavEl = iElement.parent();

                // Initialize the service
                msNavFoldService.setFoldable(scope, iElement, isFolded);

                // Set the fold status for the first time
                if ( isFolded )
                {
                    fold();
                }
                else
                {
                    unfold();
                }

                /**
                 * Is nav folded open
                 */
                function isNavFoldedOpen()
                {
                    return isFoldedOpen;
                }

                /**
                 * Toggle fold
                 */
                function toggleFold()
                {
                    isFolded = !isFolded;

                    if ( isFolded )
                    {
                        fold();
                    }
                    else
                    {
                        unfold();
                    }
                }

                /**
                 * Fold the navigation
                 */
                function fold()
                {
                    // Add classes
                    body.addClass('ms-nav-folded');

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    // Append the openOverlay to the element
                    sidenavEl.append(openOverlay);

                    // Event listeners
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Open folded navigation
                 */
                function openFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    body.addClass('ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Remove open overlay
                    sidenavEl.find(openOverlay).remove();

                    // Append close overlay and bind its events
                    sidenavEl.parent().append(closeOverlay);
                    closeOverlay.on('mouseenter touchstart', function (event)
                    {
                        closeFolded(event);
                        isFoldedOpen = false;
                    });
                }

                /**
                 * Close folded navigation
                 */
                function closeFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    body.removeClass('ms-nav-folded-open');

                    // Remove close overlay
                    sidenavEl.parent().find(closeOverlay).remove();

                    // Append open overlay and bind its events
                    sidenavEl.append(openOverlay);
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Unfold the navigation
                 */
                function unfold()
                {
                    body.removeClass('ms-nav-folded ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    iElement.off('mouseenter mouseleave');
                }

                // Expose functions to the scope
                scope.toggleFold = toggleFold;
                scope.openFolded = openFolded;
                scope.closeFolded = closeFolded;
                scope.isNavFoldedOpen = isNavFoldedOpen;

                // Cleanup
                scope.$on('$destroy', function ()
                {
                    openOverlay.off('mouseenter touchstart');
                    closeOverlay.off('mouseenter touchstart');
                    iElement.off('mouseenter mouseleave');
                });
            }
        };
    }


    /** @ngInject */
    function MsNavController()
    {
        var vm = this,
            disabled = false,
            toggleItems = [],
            lockedItems = [];

        // Data

        // Methods
        vm.isDisabled = isDisabled;
        vm.enable = enable;
        vm.disable = disable;
        vm.setToggleItem = setToggleItem;
        vm.getLockedItems = getLockedItems;
        vm.setLockedItem = setLockedItem;
        vm.clearLockedItems = clearLockedItems;

        //////////

        /**
         * Is navigation disabled
         *
         * @returns {boolean}
         */
        function isDisabled()
        {
            return disabled;
        }

        /**
         * Disable the navigation
         */
        function disable()
        {
            disabled = true;
        }

        /**
         * Enable the navigation
         */
        function enable()
        {
            disabled = false;
        }

        /**
         * Set toggle item
         *
         * @param element
         * @param scope
         */
        function setToggleItem(element, scope)
        {
            toggleItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Get locked items
         *
         * @returns {Array}
         */
        function getLockedItems()
        {
            return lockedItems;
        }

        /**
         * Set locked item
         *
         * @param element
         * @param scope
         */
        function setLockedItem(element, scope)
        {
            lockedItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Clear locked items list
         */
        function clearLockedItems()
        {
            lockedItems = [];
        }
    }

    /** @ngInject */
    function msNavDirective($rootScope, $mdComponentRegistry, msNavFoldService)
    {
        return {
            restrict  : 'E',
            scope     : {},
            controller: 'MsNavController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-nav');

                return function postLink(scope)
                {
                    // Update toggle status according to the ui-router current state
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Update toggles on state changes
                    var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
                    {
                        $rootScope.$broadcast('msNav::expandMatchingToggles');

                        // Close navigation sidenav on stateChangeSuccess
                        $mdComponentRegistry.when('navigation').then(function (navigation)
                        {
                            navigation.close();

                            if ( msNavFoldService.isNavFoldedOpen() )
                            {
                                msNavFoldService.closeFolded();
                            }
                        });
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        stateChangeSuccessEvent();
                    })
                };
            }
        };
    }

    /** @ngInject */
    function msNavTitleDirective()
    {
        return {
            restrict: 'A',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-title');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavButtonDirective()
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-button');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavToggleDirective($rootScope, $q, $animate, $state)
    {
        return {
            restrict: 'A',
            require : '^msNav',
            scope   : true,
            compile : function (tElement, tAttrs)
            {
                tElement.addClass('ms-nav-toggle');

                // Add collapsed attr
                if ( angular.isUndefined(tAttrs.collapsed) )
                {
                    tAttrs.collapsed = true;
                }

                tElement.attr('collapsed', tAttrs.collapsed);

                return function postLink(scope, iElement, iAttrs, MsNavCtrl)
                {
                    var classes = {
                        expanded         : 'expanded',
                        expandAnimation  : 'expand-animation',
                        collapseAnimation: 'collapse-animation'
                    };

                    // Store all related states
                    var links = iElement.find('a');
                    var states = [];
                    var regExp = /\(.*\)/g;

                    angular.forEach(links, function (link)
                    {
                        var state = angular.element(link).attr('ui-sref');

                        if ( angular.isUndefined(state) )
                        {
                            return;
                        }

                        // Remove any parameter definition from the state name before storing it
                        state = state.replace(regExp, '');

                        states.push(state);
                    });

                    // Store toggle-able element and its scope in the main nav controller
                    MsNavCtrl.setToggleItem(iElement, scope);

                    // Click handler
                    iElement.children('.ms-nav-button').on('click', toggle);

                    // Toggle function
                    function toggle()
                    {
                        // If navigation is disabled, do nothing...
                        if ( MsNavCtrl.isDisabled() )
                        {
                            return;
                        }

                        // Disable the entire navigation to prevent spamming
                        MsNavCtrl.disable();

                        if ( isCollapsed() )
                        {
                            // Clear the locked items list
                            MsNavCtrl.clearLockedItems();

                            // Emit pushToLockedList event
                            scope.$emit('msNav::pushToLockedList');

                            // Collapse everything but locked items
                            $rootScope.$broadcast('msNav::collapse');

                            // Expand and then...
                            expand().then(function ()
                            {
                                // Enable the entire navigation after animations completed
                                MsNavCtrl.enable();
                            });
                        }
                        else
                        {
                            // Collapse with all children
                            scope.$broadcast('msNav::forceCollapse');
                        }
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.children('.ms-nav-button').off('click');
                    });

                    /*---------------------*/
                    /* Scope Events        */
                    /*---------------------*/

                    /**
                     * Collapse everything but locked items
                     */
                    scope.$on('msNav::collapse', function ()
                    {
                        // Only collapse toggles that are not locked
                        var lockedItems = MsNavCtrl.getLockedItems();
                        var locked = false;

                        angular.forEach(lockedItems, function (lockedItem)
                        {
                            if ( angular.equals(lockedItem.scope, scope) )
                            {
                                locked = true;
                            }
                        });

                        if ( locked )
                        {
                            return;
                        }

                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Collapse everything
                     */
                    scope.$on('msNav::forceCollapse', function ()
                    {
                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Expand toggles that match with the current states
                     */
                    scope.$on('msNav::expandMatchingToggles', function ()
                    {
                        var currentState = $state.current.name;
                        var shouldExpand = false;

                        angular.forEach(states, function (state)
                        {
                            if ( currentState === state )
                            {
                                shouldExpand = true;
                            }
                        });

                        if ( shouldExpand )
                        {
                            expand();
                        }
                        else
                        {
                            collapse();
                        }
                    });

                    /**
                     * Add toggle to the locked list
                     */
                    scope.$on('msNav::pushToLockedList', function ()
                    {
                        // Set expanded item on main nav controller
                        MsNavCtrl.setLockedItem(iElement, scope);
                    });

                    /*---------------------*/
                    /* Internal functions  */
                    /*---------------------*/

                    /**
                     * Is element collapsed
                     *
                     * @returns {bool}
                     */
                    function isCollapsed()
                    {
                        return iElement.attr('collapsed') === 'true';
                    }

                    /**
                     * Is element expanded
                     *
                     * @returns {bool}
                     */
                    function isExpanded()
                    {
                        return !isCollapsed();
                    }

                    /**
                     * Expand the toggle
                     *
                     * @returns $promise
                     */
                    function expand()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already expanded, do nothing..
                        if ( isExpanded() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', false);

                        // Grab the element to expand
                        var elementToExpand = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Move the element out of the dom flow and
                        // make it block so we can get its height
                        elementToExpand.css({
                            'position'  : 'absolute',
                            'visibility': 'hidden',
                            'display'   : 'block',
                            'height'    : 'auto'
                        });

                        // Grab the height
                        var height = elementToExpand[0].offsetHeight;

                        // Reset the style modifications
                        elementToExpand.css({
                            'position'  : '',
                            'visibility': '',
                            'display'   : '',
                            'height'    : ''
                        });

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToExpand,
                                {
                                    'display': 'block',
                                    'height' : '0px'
                                },
                                {
                                    'height': height + 'px'
                                },
                                classes.expandAnimation
                            ).then(
                                function ()
                                {
                                    // Add expanded class
                                    elementToExpand.addClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToExpand.css({'height': ''});

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }

                    /**
                     * Collapse the toggle
                     *
                     * @returns $promise
                     */
                    function collapse()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already collapsed, do nothing..
                        if ( isCollapsed() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', true);

                        // Grab the element to collapse
                        var elementToCollapse = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Grab the height
                        var height = elementToCollapse[0].offsetHeight;

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToCollapse,
                                {
                                    'height': height + 'px'
                                },
                                {
                                    'height': '0px'
                                },
                                classes.collapseAnimation
                            ).then(
                                function ()
                                {
                                    // Remove expanded class
                                    elementToCollapse.removeClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToCollapse.css({
                                        'display': '',
                                        'height' : ''
                                    });

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMasonryController', msMasonryController)
        .directive('msMasonry', msMasonry)
        .directive('msMasonryItem', msMasonryItem);

    /** @ngInject */
    function msMasonryController($scope, $window, $mdMedia, $timeout)
    {
        var vm = this,
            defaultOpts = {
                columnCount     : 5,
                respectItemOrder: false,
                reLayoutDebounce: 400,
                responsive      : {
                    md: 3,
                    sm: 2,
                    xs: 1
                }
            },
            reLayoutTimeout = true;

        vm.options = null;
        vm.container = [];
        vm.containerPos = '';
        vm.columnWidth = '';
        vm.items = [];

        // Methods
        vm.reLayout = reLayout;
        vm.initialize = initialize;
        vm.waitImagesLoaded = waitImagesLoaded;

        function initialize()
        {
            vm.options = !vm.options ? defaultOpts : angular.extend(defaultOpts, vm.options);


            watchContainerResize();
        }

        $scope.$on('msMasonry:relayout', function ()
        {
            reLayout();
        });

        function waitImagesLoaded(element, callback)
        {
            if ( typeof imagesLoaded !== 'undefined' )
            {
                var imgLoad = $window.imagesLoaded(element);

                imgLoad.on('done', function ()
                {
                    callback();
                });
            }
            else
            {
                callback();
            }
        }

        function watchContainerResize()
        {
            $scope.$watch(
                function ()
                {
                    return vm.container.width();
                },
                function (newValue, oldValue)
                {
                    if ( newValue !== oldValue )
                    {
                        reLayout();
                    }
                }
            );
        }

        function reLayout()
        {
            // Debounce for relayout
            if ( reLayoutTimeout )
            {
                $timeout.cancel(reLayoutTimeout);
            }

            reLayoutTimeout = $timeout(function ()
            {
                start();

                $scope.$broadcast('msMasonry:relayoutFinished');

            }, vm.options.reLayoutDebounce);

            // Start relayout
            function start()
            {
                vm.containerPos = vm.container[0].getBoundingClientRect();

                updateColumnOptions();

                $scope.$broadcast('msMasonry:relayoutStarted');

                vm.items = vm.container.find('ms-masonry-item');

                //initialize lastRowBottomArr
                var referenceArr = Array.apply(null, new Array(vm.columnCount)).map(function ()
                {
                    return 0;
                });

                // set item positions
                for ( var i = 0; i < vm.items.length; i++ )
                {
                    var item = vm.items[i],
                        xPos, yPos, column, refTop;

                    item = angular.element(item);

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:startReLayout');
                    }

                    item.css({'width': vm.columnWidth});

                    if ( vm.options.respectItemOrder )
                    {
                        column = i % vm.columnCount;
                        refTop = referenceArr[column];
                    }
                    else
                    {
                        refTop = Math.min.apply(Math, referenceArr);
                        column = referenceArr.indexOf(refTop);
                    }

                    referenceArr[column] = refTop + item[0].getBoundingClientRect().height;

                    xPos = Math.round(column * vm.columnWidth);
                    yPos = refTop;

                    item.css({'transform': 'translate3d(' + xPos + 'px,' + yPos + 'px,0px)'});
                    item.addClass('placed');

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:finishReLayout');
                    }
                }
            }
        }

        function updateColumnOptions()
        {
            vm.columnCount = vm.options.columnCount;

            if ( $mdMedia('gt-md') )
            {
                vm.columnCount = vm.options.columnCount;
            }
            else if ( $mdMedia('md') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.md ? vm.options.responsive.md : vm.columnCount);
            }
            else if ( $mdMedia('sm') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.sm ? vm.options.responsive.sm : vm.columnCount);
            }
            else
            {
                vm.columnCount = vm.options.responsive.xs;
            }

            vm.columnWidth = vm.containerPos.width / vm.columnCount;

        }
    }

    /** @ngInject */
    function msMasonry($timeout)
    {
        return {
            restrict  : 'AEC',
            controller: 'msMasonryController',
            compile   : compile
        };
        function compile(element, attributes)
        {
            return {
                pre : function preLink(scope, iElement, iAttrs, controller)
                {
                    controller.options = angular.fromJson(attributes.options || '{}');
                    controller.container = element;
                },
                post: function postLink(scope, iElement, iAttrs, controller)
                {
                    $timeout(function ()
                    {
                        controller.initialize();
                    });
                }
            };
        }
    }

    /** @ngInject */
    function msMasonryItem()
    {
        return {
            restrict: 'AEC',
            require : '^msMasonry',
            priority: 1,
            link    : link
        };

        function link(scope, element, attributes, controller)
        {
            controller.waitImagesLoaded(element, function ()
            {
                controller.reLayout();

            });

            scope.$on('msMasonryItem:finishReLayout', function ()
            {
                scope.$watch(function ()
                {
                    return element.height();
                }, function (newVal, oldVal)
                {
                    if ( newVal !== oldVal )
                    {
                        controller.reLayout();
                    }
                });
            });

            element.on('$destroy', function ()
            {
                controller.reLayout();
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msInfoBar', msInfoBarDirective);

    /** @ngInject */
    function msInfoBarDirective($document)
    {
        return {
            restrict   : 'E',
            scope      : {},
            transclude : true,
            templateUrl: 'app/core/directives/ms-info-bar/ms-info-bar.html',
            link       : function (scope, iElement)
            {
                var body = $document.find('body'),
                    bodyClass = 'ms-info-bar-active';

                // Add body class
                body.addClass(bodyClass);

                /**
                 * Remove the info bar
                 */
                function removeInfoBar()
                {
                    body.removeClass(bodyClass);
                    iElement.remove();
                    scope.$destroy();
                }

                // Expose functions
                scope.removeInfoBar = removeInfoBar;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsFormWizardController', MsFormWizardController)
        .directive('msFormWizard', msFormWizardDirective)
        .directive('msFormWizardForm', msFormWizardFormDirective);

    /** @ngInject */
    function MsFormWizardController()
    {
        var vm = this;

        // Data
        vm.forms = [];
        vm.selectedIndex = 0;

        // Methods
        vm.registerForm = registerForm;

        vm.previousStep = previousStep;
        vm.nextStep = nextStep;
        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.currentStepInvalid = currentStepInvalid;
        vm.formsIncomplete = formsIncomplete;
        vm.resetForm = resetForm;

        //////////

        /**
         * Register form
         *
         * @param form
         */
        function registerForm(form)
        {
            vm.forms.push(form);
        }

        /**
         * Go to previous step
         */
        function previousStep()
        {
            vm.selectedIndex--;
        }

        /**
         * Go to next step
         */
        function nextStep()
        {
            vm.selectedIndex++;
        }

        /**
         * Is first step?
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.selectedIndex === 0;
        }

        /**
         * Is last step?
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.selectedIndex === vm.forms.length - 1;
        }

        /**
         * Is current step invalid?
         *
         * @returns {boolean|*}
         */
        function currentStepInvalid()
        {
            return angular.isDefined(vm.forms[vm.selectedIndex]) && vm.forms[vm.selectedIndex].$invalid;
        }

        /**
         * Check if there is any incomplete forms
         *
         * @returns {boolean}
         */
        function formsIncomplete()
        {
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                if ( vm.forms[x].$invalid )
                {
                    return true;
                }
            }

            return false;
        }

        /**
         * Reset form
         */
        function resetForm()
        {
            // Go back to first step
            vm.selectedIndex = 0;

            // Make sure all the forms are back in the $pristine & $untouched status
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                vm.forms[x].$setPristine();
                vm.forms[x].$setUntouched();
            }
        }
    }

    /** @ngInject */
    function msFormWizardDirective()
    {
        return {
            restrict  : 'E',
            scope     : true,
            controller: 'MsFormWizardController as msWizard',
            compile   : function (tElement)
            {
                tElement.addClass('ms-form-wizard');

                return function postLink()
                {

                };
            }
        }

    }

    /** @ngInject */
    function msFormWizardFormDirective()
    {
        return {
            restrict: 'A',
            require : ['form', '^msFormWizard'],
            compile : function (tElement)
            {
                tElement.addClass('ms-form-wizard-form');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var formCtrl = ctrls[0],
                        MsFormWizardCtrl = ctrls[1];

                    MsFormWizardCtrl.registerForm(formCtrl);
                }
            }
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msDatepickerFixConfig', msDatepickerFixConfigProvider)
        .directive('msDatepickerFix', msDatepickerFix);

    /** @ngInject */
    function msDatepickerFixConfigProvider()
    {

        var service = this;

        // Default configuration
        var defaultConfig = {
            // To view
            formatter: function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return val === '' ? val : new Date(val);
            },
            // To model
            parser   : function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return moment(val).add(moment(val).utcOffset(), 'm').toDate();
            }
        };

        // Methods
        service.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfig = angular.extend({}, defaultConfig, configuration);
        }

        /**
         * Service
         */
        service.$get = function ()
        {
            return defaultConfig;
        };
    }

    /** @ngInject */
    function msDatepickerFix(msDatepickerFixConfig)
    {
        return {
            require: 'ngModel',
            priority: 1,
            link   : function (scope, elem, attrs, ngModel)
            {
                ngModel.$formatters.push(msDatepickerFixConfig.formatter); // to view
                ngModel.$parsers.push(msDatepickerFixConfig.parser); // to model
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msCard', msCardDirective);

    /** @ngInject */
    function msCardDirective()
    {
        return {
            restrict: 'E',
            scope   : {
                templatePath: '=template',
                card        : '=ngModel'
            },
            template: '<div class="ms-card-content-wrapper" ng-include="templatePath" onload="cardTemplateLoaded()"></div>',
            compile : function (tElement)
            {
                // Add class
                tElement.addClass('ms-card');

                return function postLink(scope, iElement)
                {
                    // Methods
                    scope.cardTemplateLoaded = cardTemplateLoaded;

                    //////////

                    /**
                     * Emit cardTemplateLoaded event
                     */
                    function cardTemplateLoaded()
                    {
                        scope.$emit('msCard::cardTemplateLoaded', iElement);
                    }
                };
            }
        };
    }
})();
(function() {
    'use strict';

    angular
        .module('app.viewCreator')
        .controller('viewCreatorController', viewCreatorController);

    /* @ngInject */
    function viewCreatorController($mdDialog, $window, $scope, $filter, $document, scope, toast, hotkeys, $log, dialog, $translate,
                api, utility, editMode, model, record, defaultValues, parentId, additionalInfo, existingValues, existingRecordsForUniqueValue, lookupExtras, event, filterExpression, lookupPromises, $mdConstant, catalogFactory, mockFactory, crud, $timeout, $q) {
        var vm = this;

        vm.visibleFields = [];
        vm.isLoading = false;
        vm.model = model;
        vm.record = angular.copy(record);
        vm.filterExpression = filterExpression;
        vm.AllowExternalChangeManagement = false;
        vm.checkingForLockedArticles = false;
        vm.isNew = false;
        vm.isDataDirty = false;
        vm.maxTags;
        vm.ErrorMessage = "";
        vm.dateRangeStartError = false;
        vm.dateRangeEndError = false;
        vm.colors = [];
        vm.randomColorForFavoriteTag = '';
        var months = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];

        vm.dependingAttributesMap = [];
        vm.criteriaDeptAttributeMap = {};
        vm.vettingListCriteriaList = [];
        vm.criteriaV2Map = {}; // AttributeSystemName -> parsed CriteriaV2 rules array (preferred over OLD Criteria)
        vm.textareaValue = "";

        vm.acSelectedItem = [];
        vm.acSearchText = [];
        vm.searchText = {};
        vm.tagSeperatorKeys = {};
        vm.existingRecordsForUniqueValue = [];
        var isAdditionalActionAdded = angular.isDefined(additionalInfo) && angular.isDefined(additionalInfo.additionalAction) ? true : false;
        if(isAdditionalActionAdded) {
            var additionalAction = additionalInfo.additionalAction;
        }
        // this is to set a field with preselected value for lookup(used in shared folders module)
        // this have the field name and the value to be prepopulated for create(Entity with Merch as preselected)
        var isDefaultSelectedFieldValueAdded = (angular.isDefined(additionalInfo) && angular.isDefined(additionalInfo.isDefaultSelectedFieldValueAdded) && !utility.isObjectEmpty(additionalInfo.isDefaultSelectedFieldValueAdded)) ? true : false;
        vm.isNew = !editMode;
        if (!vm.record)
        {
            //Create empty object
            vm.record = {};
            vm.isNew = true;
            if(isDefaultSelectedFieldValueAdded) {
                var field = Object.keys(additionalInfo.isDefaultSelectedFieldValueAdded)[0];
                vm.record[field] = additionalInfo.isDefaultSelectedFieldValueAdded[field];
            }

            // model articles assign model number and model id. used for articles creating from catalog models module
            var isAdditionalModelData = angular.isDefined(additionalInfo) && angular.isDefined(additionalInfo.modelArticles) ? additionalInfo.modelArticles : null;
            if(isAdditionalModelData !== null && !utility.isObjectEmpty(isAdditionalModelData)) {
                for(var key in isAdditionalModelData) {
                    if(isAdditionalModelData.hasOwnProperty(key)) {
                        vm.record[key] = isAdditionalModelData[key];
                    }
                }
            }
        }
        vm.enteredNewValuesLookup = {};
        var dataSourceTypeId = catalogFactory.getActiveCatalogDetails().DataSourceTypeId;
        var retailWindowAttribute = catalogFactory.getActiveCatalog().RetailWindowAttribute;
        var existConstraintsData = [];
        vm.searchValue = {};
        var validSellerLookupsDestinationAttributesMap = api.validSellerLookupsDestinationAttributesMap;
        vm.lookupSourceAndDeptAttributeMap = {};
        vm.showColorTypeInColorPalatteDropdown = api.showColorTypeInColorPalatteDropdown

        vm.saveRecord = saveRecord;
        vm.closeDialog = closeDialog;

        vm.lookupSearch = lookupSearch;
        vm.lookupChange = lookupChange;
        vm.customLookupChange = customLookupChange;
        vm.getLookupDisplayValue = getLookupDisplayValue;
        vm.getCustomLookupDisplayValue = getCustomLookupDisplayValue;
        vm.selectText = selectText;
        vm.colorPaletteLookupChange = colorPaletteLookupChange;

        vm.transformChip = transformChip;
        vm.acQuerySearch = acQuerySearch;
        vm.getChipDisplayValue = getChipDisplayValue;
        vm.add = add;

        vm.isInputRequired = isInputRequired;
        vm.getDateObj = getDateObj;
        vm.validateTxPattern = validateTxPattern;
        vm.getConditionalVettingList = getConditionalVettingList;
        vm.multiValueQuerySearch = multiValueQuerySearch;
        vm.validateJSON = validateJSON;
        vm.sourceAttributeForValidationChanged = sourceAttributeForValidationChanged;
        vm.criteriaDependentCriteriaAttributeChanged = criteriaDependentCriteriaAttributeChanged;
        vm.clearSearchTerm = clearSearchTerm;
        vm.lookupSourceAttributeChanged = lookupSourceAttributeChanged;
        vm.isFormValid = isFormValid; // this to avoid enabling save button when filtering the fields and updating a value
        vm.handleFieldChange = handleFieldChange;
        vm.onSearchTextChanged = onSearchTextChanged;

        activate();

        ////////////////

        function activate() {
            vm.visibleFields = getVisibleFields(vm.model);
            populateDefaultValues(defaultValues);
            vm.filteredVisibleFields = angular.copy(vm.visibleFields)
            //Hotkeys
            hotkeys.bindTo($scope)
                .add({
                    combo: 'ctrl+enter',
                    description: $filter('translate')('ACTIONS.SAVE'),
                    allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
                    callback: function (event) {
                        if (!vm.isLoading && !vm.editForm.$invalid) {
                            vm.saveRecord();
                        }
                    }
                });

            if (vm.isNew) {
                hotkeys.bindTo($scope)
                    .add({
                        combo: 'ctrl+shift+enter',
                        description: $filter('translate')('ACTIONS.SAVE_AND_NEW'),
                        allowIn: ['INPUT', 'SELECT', 'TEXTAREA'],
                        callback: function (event) {
                            if (!vm.isLoading && !vm.editForm.$invalid) {
                                vm.saveRecord(true);
                            }
                        }
                    });
            }
        }

        //On addition of new tag it validates that the tag should not contain pipe
        function add(chip, chips, field) {
            if (chip) {
                if (chip.indexOf(field.tagSeparator) !== -1) {
                    vm.record[field.field].splice(vm.record[field.field].indexOf(chip), 1);
                    vm.record[field.field] = vm.record[field.field].concat(chip.split(field.tagSeparator));
                    vm.maxTags = vm.record[field.field].length + 1;
                } else {
                    vm.maxTags = field.maxLen;
                }
            }
            //for displaying error message
            if (angular.isDefined(field.maxLen) && vm.maxTags != field.maxLen) {
                vm.ErrorMessage = field.validation.messages.pattern;
                return true;
            } else {
                vm.ErrorMessage = "";
                return false;
            }
        }

        function saveRecord(saveAndNew) {
            vm.isLoading = true;
            angular.forEach(vm.model.fields, function(field) {
                if(angular.isDefined(field.validation) && field.validation['tx-pattern']) {
                    validateTxPattern(field);
                }
            });

            //Transform the fields of type dateUTC
            angular.forEach(vm.model.fields, function(itm) {
                // to avoid timezone issue
                if ((itm.inputType === 'date-utc' || itm.inputType === 'date') && angular.isDefined(vm.record[itm.field]) &&  angular.isDate(vm.record[itm.field])) {
                    var d = vm.record[itm.field];
                    vm.record[itm.field] = new Date(d.setHours(12-(d.getTimezoneOffset()/60),0,0));
                }

                // Normalise date-option / date-without-time attributes to a noon-UTC Date.
                // Keep a Date instance in the live model (bound to md-datepicker) so it renders the
                // correct calendar day in every timezone. The date-only "yyyy-MM-dd" string the
                // backend expects is produced from a payload copy in saveData(); the datepicker must
                // never be handed a bare date-only string because md-datepicker reparses it as
                // UTC-midnight and briefly shows the previous local day for west-of-UTC users while
                // the save request is in flight.
                if ((itm.inputType === 'date-option' || itm.inputType === 'date-without-time') && angular.isDefined(vm.record[itm.field]) &&  angular.isDate(vm.record[itm.field])) {
                    var d = vm.record[itm.field];
                    vm.record[itm.field] = new Date(d.setHours(12-(d.getTimezoneOffset()/60),0,0));
                }

                if (itm.inputType === 'calculated') {
                    delete vm.record[itm.field];
                }

                if ((itm.inputType === 'articlenumber' || itm.inputType === 'modelnumber') && angular.isDefined(vm.record[itm.field]) && vm.record[itm.field] != null && vm.record[itm.field].toString().length > 0) {
                    vm.record[itm.field] = vm.record[itm.field].toString();
                }

                if ((itm.inputType === 'color-palette') && angular.isDefined(vm.record[itm.field]) && vm.record[itm.field] != null && vm.record[itm.field] !== '' && angular.isObject(vm.record[itm.field])) {
                    var key = Object.keys(vm.record[itm.field])[0];
                    var val = vm.record[itm.field][key];
                    if (typeof val === 'string' && val.includes(':')) {
                        val = val.split(':')[1].trim();
                    }
                    vm.record[itm.field][key] = val;
                    vm.record[itm.field] = angular.toJson(vm.record[itm.field]);
                }

                if (itm.inputType !== 'lookup' && itm.inputType !== 'lookup-many' && itm.inputType !== 'decimal' && (itm.inputType === 'number' || itm.type === 'int') && vm.record[itm.field] != null) {
                    vm.record[itm.field] = parseInt(vm.record[itm.field]);
                }

                if(itm.dontShowAssignedRecordsInChip && angular.isDefined(vm.record.AssignedRecords) && vm.record.AssignedRecords.length) { // shared folders users
                    vm.record[itm.field] = vm.record[itm.field].concat(vm.record.AssignedRecords);
                }

                // remove all invisible special characters from strings
                if ((itm.inputType === 'text' || itm.inputType === 'textArea') && vm.record[itm.field] != null && vm.record[itm.field] !== '' && typeof vm.record[itm.field] === 'string') {
                    vm.record[itm.field] = vm.record[itm.field].replace(/[\u00A0\u00AD\u200B-\u200D\uFEFF\u2028\u2029\u2060]/g, '');
                }

                if ((itm.inputType === 'multi-value' || itm.inputSubType === 'multi-value') && vm.record[itm.field] != null && vm.record[itm.field] !== '' && vm.record[itm.field].length) {
                    angular.forEach(vm.record[itm.field], function(value, index) {
                        vm.record[itm.field][index] = value.replace(/[\u00A0\u00AD\u200B-\u200D\uFEFF\u2028\u2029\u2060]/g, '');
                    })
                }

                if ((itm.inputType === 'tags' && (itm.field === 'AllowedValues' || itm.field === 'Values')) && vm.textareaValue != null) {
                    vm.record[itm.field] = vm.textareaValue !== '' && vm.textareaValue.length ? Array.from(new Set(utility.splitString(vm.textareaValue, '\n'))) : [];
                }

                if (itm.inputType === 'dataset' && vm.record[itm.field] != null && vm.record[itm.field] !== '') {
                    if(typeof (vm.record[itm.field]) === 'object') {
                       vm.record[itm.field] = Object.keys(vm.record[itm.field])[0].toString()
                    }
                    else {
                        vm.record[itm.field] = vm.record[itm.field].toString();
                    }
                }

                if(itm.inputType === 'datatable' && vm.record[itm.field] != null && vm.record[itm.field] !== '') {
                    vm.record[itm.field] = (typeof vm.record[itm.field] === 'string') ? vm.record[itm.field] : angular.toJson(vm.record[itm.field]);
                }
            });

            // currently this validation only for retail windows module. just add new modules model name here for supporting other modules
            if(vm.model.modelPath === 'catalogs.shipmentWindows' && vm.isNew) {
                var dataExistsCombinationFld = utility.filterObject(vm.model.fields, {field: 'dataExistsCombinationField'}, true)[0];
                if(angular.isDefined(dataExistsCombinationFld)) {
                    var combinationFields = vm.model.dataExistsCombinationConstraints;
                    var combinedValue = '';
                    angular.forEach(combinationFields, function(field) {
                        var value = vm.record[field];
                        if(field === 'ShipmentStartDate' || field === 'ShipmentEndDate') {
                            var curValue = new Date(vm.record[field]);
                            curValue = curValue.setHours(0,0,0,0);
                            value = new Date(curValue);
                        }
                        combinedValue += value;
                    });

                    if(angular.isDefined(dataExistsCombinationFld.validation.dataExistConstraints.modelPath) && angular.isString(dataExistsCombinationFld.validation.dataExistConstraints.modelPath)
                        && dataExistsCombinationFld.validation.dataExistConstraints.modelPath.length > 0) {
                            if (angular.isDefined(existConstraintsData) && existConstraintsData.length > 0) {
                                var isDataExist = false;
                                for (var i=0; i < existConstraintsData.length; i++) {
                                    if (existConstraintsData[i]['value'].toString().toLowerCase() === combinedValue.toString().toLowerCase()) {
                                        isDataExist = true;
                                        break;
                                    }
                                }

                                if(isDataExist) {
                                    vm.editForm.$invalid = true;
                                    var confirmationContent = {};
                                    confirmationContent.title = 'MESSAGES.TITLE.ALERT';
                                    confirmationContent.message = 'MESSAGES.CONTENT.RECORD_EXISTS_WARNING';
                                    confirmationContent.isMultiple = true;
                                    var confirmationAction = 'ACTIONS.OK';
                                    dialog.confirm(confirmationContent, confirmationAction)
                                    .then(function(response) {
                                        if(response.userAction.toLowerCase() === 'ok') {
                                            $mdDialog.hide(false);
                                        }
                                    }, function () {
                                        $mdDialog.hide(false);
                                    });
                                }
                            }
                    }
                }
            }
            saveData(saveAndNew);
        }

        function saveData(saveAndNew) {
            var p;
            if(!vm.editForm.$invalid) {
                var doesArticleMeetSelectedStateRequirement = true;
                // if any felds with allowEnterNewValue for lookup is present
                if(!utility.isObjectEmpty(vm.enteredNewValuesLookup)) {
                    for(var key in vm.enteredNewValuesLookup) {
                        if(vm.enteredNewValuesLookup.hasOwnProperty(key)) {
                            vm.record[key] = vm.enteredNewValuesLookup[key];
                        }
                    }
                }

                // if retail window is applied then send the shipmentwindowrangeid frm selected intro and exit month
                if(catalogFactory.getActiveCatalogDetails().IsShippingWindowApply == 1 && vm.record.RetailExitMonthId != null) {
                    vm.record['ShipmentWindowRangeId'] = vm.record.RetailExitMonthId;
                }

                // Build the request payload on a copy so the live datepicker model is never mutated
                // to a bare date-only string. date-option / date-without-time fields are serialised
                // to "yyyy-MM-dd" here (backend contract unchanged) while vm.record keeps its Date
                // instances, so md-datepicker does not reparse and flash the previous local day.
                var payload = vm.record;
                var dateOnlyFields = [];
                angular.forEach(vm.model.fields, function(f) {
                    if ((f.inputType === 'date-option' || f.inputType === 'date-without-time') && angular.isDate(vm.record[f.field])) {
                        dateOnlyFields.push(f.field);
                    }
                });
                if (dateOnlyFields.length) {
                    payload = angular.copy(vm.record);
                    angular.forEach(dateOnlyFields, function(f) {
                        payload[f] = payload[f].toISOString().split('T', 1)[0];
                    });
                }

                if (vm.isNew && !isAdditionalActionAdded) {
                    // specific to favorites module assign random color when creating new favorites tag
                    if(vm.model.modelPath === 'catalog.favorites' && vm.randomColorForFavoriteTag !== '') {
                        payload.Color = vm.randomColorForFavoriteTag;
                    }
                    p = vm.model.methods.create(payload, parentId, vm.model);
                } else if(!vm.isNew && !isAdditionalActionAdded) {
                    p = vm.model.methods.update(payload[vm.model.idField], payload, parentId, vm.model, record);
                }

                // specific to manage dune context and resources edit sort order
                if(isAdditionalActionAdded) {
                    if(additionalAction === 'manageSellerDuneContext') {
                        var DuneContextField = utility.filterObject(vm.model.fields, {field: 'DuneContext', visible: false}, true)[0];
                        var contextList = lookupSearch('', DuneContextField);
                        p = vm.model.methods.assignSellerContext(vm.record[vm.model.idField], vm.record.DuneContext, contextList);
                    } else if(additionalAction === 'manageDuneContext') {
                        var DuneContextField = utility.filterObject(vm.model.fields, {field: 'DuneContext', visible: false}, true)[0];
                        var contextList = lookupSearch('', DuneContextField);
                        p = vm.model.methods.assignCatalogContext(vm.record[vm.model.idField], vm.record.DuneContext, contextList);
                    } else if(additionalAction === 'resourcesEditSortOrder') {
                        p = vm.model.methods.editSortOrder(vm.record);
                    } else if(additionalAction === 'assignTag') { // dune images module
                        var assignedContextKey = catalogFactory.getCatalogContextKey();
                        var selectedAssetsIds = defaultValues.map(function(record) {
                            var id = record.Id;
                            return id;
                        });
                        var requestObj = {
                            ContextKey: assignedContextKey,
                            Ids: selectedAssetsIds,
                            Tag: vm.record.Tag
                        }
                        p = vm.model.methods.assignTag(requestObj);
                    } else if( additionalAction === 'overwriteColor') {
                        var requestObj = {
                            ColorCode: vm.record.ColorCode
                        }
                        p = vm.model.methods.overwriteColor(vm.record[vm.model.idField], requestObj, parentId);
                    }
                }

                if(doesArticleMeetSelectedStateRequirement) { // when the required criteria doesnot match we show error message
                    p.then(function(response) {
                        // when click on save and new while creating record
                        if (vm.isNew && angular.isDefined(saveAndNew) && saveAndNew) {
                            vm.editForm.$setPristine();
                            vm.editForm.$setUntouched();
                            if(angular.isDefined(existingValues)) {
                                existingValues.push(vm.record);
                            }
                            vm.record = {};
                            populateDefaultValues(defaultValues);
                            vm.acSearchText = [];
                            vm.searchText = {};
                            // if isDataDirty is true keep it true otherwise make it true when response.status != 202
                            vm.isDataDirty = vm.isDataDirty || (response.status !== 202);

                            var el = $window.document.getElementById('dialog_input_first');
                            if (el) {
                                el.focus();
                            }
                        }
                        else {
                            closeDialog(true);
                        }

                        if(response && response.status === 202) {
                            dialog.showAlertDialog(
                                angular.element($document.body),
                                $filter('translate')('MESSAGES.TITLE.ALERT'),
                                $filter('translate')('MESSAGES.CONTENT.CHANGE_REQUEST_ALERT'),
                                $filter('translate')('MESSAGES.TITLE.ALERT'),
                                $filter('translate')('ACTIONS.DIALOG_CLOSE'),
                                !!saveAndNew,
                                event);
                        }
                        else {
                            var toastMessage;
                            var postSuccessMessage = additionalInfo && additionalInfo.postSuccessMessage ? additionalInfo.postSuccessMessage : 'SUCCESS.CREATE';
                            var putSuccessMessage = additionalInfo && additionalInfo.putSuccessMessage ? additionalInfo.putSuccessMessage : 'SUCCESS.UPDATE';
                            toastMessage = response.config.method.toUpperCase() === 'POST' ? postSuccessMessage : putSuccessMessage;
                            toast.success(toastMessage, '', '');
                        }
                    }, function() {
                        closeDialog(vm.isDataDirty);
                    }).finally(function () {
                        vm.isLoading = false;
                    });
                }
            } else {
                toast.error('Attribute validation failed, please correct the data and save again');
                vm.isLoading = false;
            }
        }

        function closeDialog(saved) {
            $mdDialog.hide(saved);
        }

        function lookupSearch(query, field) {
            var results = [];
            var lookupFilter = angular.isDefined(field.lookupFilter) ? field.lookupFilter : {};
            var sortBy = angular.isDefined(field.sortBy) ? field.sortBy : null;
            var predicate = angular.copy(lookupFilter);
            predicate.value = query;
            var lookupModel = api.getModel(field.lookupSource);
            var conditionalColorsCriteria = api.conditonalColorVettingList;

            // allowEnterNewValue is used to allow user to enter new value for the loopup field
            // if we want to send the entred value as a different field allowEnterNewValue will contain the field name
            // if allowEnterNewValue: 'true' then its for the same field
            if(angular.isDefined(field.allowEnterNewValue) && field.allowEnterNewValue.length && angular.isDefined(query) && query.trim().length > 0) {
                // assigning with same field
                var allowedField = field.field;
                if(field.allowEnterNewValue !== 'true') {
                    allowedField = field.allowEnterNewValue;
                }
                vm.enteredNewValuesLookup[allowedField] = query;
                vm.editForm[field.field].$setValidity('required', true);
            }

            if(lookupModel && angular.isDefined(lookupModel.lookupData) && angular.isDefined(lookupModel.lookupData.data) && lookupModel.lookupData.data.length) {
                var lookupDataList = lookupModel.lookupData.data;
                // conditionalColorVettingListEnabled filter the colors list based on the selected articles properties
                if(angular.isDefined(field.conditionalColorVettingListEnabled) && field.conditionalColorVettingListEnabled && conditionalColorsCriteria.length) {
                    var articlesList = api.getModel('catalogs.articles').lookupData.data;
                    var articleData = utility.filterObject(articlesList, {Id: vm.record.ArticleId}, true)[0];
                    if(angular.isDefined(articleData)) {
                        lookupDataList = utility.filterArticleColors(lookupDataList, [articleData], conditionalColorsCriteria);
                    }
                }
                //  if RetailIntroMonth/RetailExitMonth filter the retail window intro/exit month based on configured retailWindowAttribute and value
                if(field.field === 'RetailIntroMonthId' || field.field === 'RetailExitMonthId') {
                    var assignedRetailWindowAttributeValue = vm.record[retailWindowAttribute];
                    if(assignedRetailWindowAttributeValue != null) {
                        // filter intro month based on assignedRetailWindowAttributeValue
                        if(field.field === 'RetailIntroMonthId') {
                            lookupDataList = utility.getUniquieRetailIntroAndExitMonths(utility.filterObject(lookupDataList, {CriteriaAttributeValue: assignedRetailWindowAttributeValue, Status: 1}, true));
                            lookupDataList = lookupDataList.sort(function(a, b) {
                                return months.indexOf(a.RetailIntroMonth.toString().toLowerCase().trim().substring(0, 3)) - months.indexOf(b.RetailIntroMonth.toString().toLowerCase().trim().substring(0, 3))
                            })
                        }
                        // filter exit month based on selected retail intro month and assignedRetailWindowAttributeValue
                        if(field.field === 'RetailExitMonthId') {
                            var assignedRetailIntroMonth = {};
                            if(angular.isDefined(vm.record['RetailIntroMonthId'])) {
                                assignedRetailIntroMonth = utility.filterObject(lookupDataList, {id: vm.record['RetailIntroMonthId']}, true)[0];
                            } else { // filter with monthvalue
                                assignedRetailIntroMonth = utility.filterObject(lookupDataList, {value: vm.record['RetailIntroMonth']}, true)[0];
                            }
                            if(angular.isDefined(assignedRetailIntroMonth)) {
                                lookupDataList = utility.getUniquieRetailIntroAndExitMonths(utility.filterObject(lookupDataList, {RetailIntroMonth: assignedRetailIntroMonth.RetailIntroMonth, CriteriaAttributeValue: assignedRetailWindowAttributeValue, Status: 1}, true));
                                lookupDataList = lookupDataList.sort(function(a, b) {
                                    return months.indexOf(a.value.toString().toLowerCase().trim().substring(0, 3)) - months.indexOf(b.value.toString().toLowerCase().trim().substring(0, 3))
                                })
                            } else {
                                lookupDataList = [];
                            }
                        }
                    } else {
                        lookupDataList = [];
                    }
                }
                results = query ? utility.filterObject(lookupDataList, predicate) : utility.filterObject(lookupDataList, lookupFilter, true);
                results = filterExistingValues(results, existingValues, lookupModel, field);
                // this is to reduce the rendering time. It was very slow and was impacted overall page responsiveness
                // so while displaying we will display only the first 100 records and user can filter with any value
                var sortedList = results;
                if (sortBy !== null) {
                    var sortKey = Object.keys(sortBy)[0];
                    var isAscending = sortBy[sortKey];
                    sortedList = utility.orderBy(results, sortKey, isAscending);
                }
                field['isAboveDropDownLimit'] = sortedList.length > 100;
                return sortedList.slice(0, 100);
            }
            else {
                 return lookupPromises[field.field].then(function (lookupData) {
                   var lookupDataList = lookupData.data;
                    // conditionalColorVettingListEnabled filter the colors list based on the selected articles properties
                    if(angular.isDefined(field.conditionalColorVettingListEnabled) && field.conditionalColorVettingListEnabled && lookupDataList.length && conditionalColorsCriteria.length) {
                        var articlesList = api.getModel('catalogs.articles').lookupData.data;
                        var articleData = utility.filterObject(articlesList, {Id: vm.record.ArticleId}, true)[0];
                        if(angular.isDefined(articleData)) {
                            lookupDataList = utility.filterArticleColors(lookupDataList, [articleData], conditionalColorsCriteria);
                        }
                    }
                    // if RetailIntroMonth/RetailExitMonth filter the retail window intro/exit month based on configured retailWindowAttribute and value
                    if(field.field === 'RetailIntroMonthId' || field.field === 'RetailExitMonthId') {
                        var assignedRetailWindowAttributeValue = vm.record[retailWindowAttribute];
                        if(assignedRetailWindowAttributeValue != null) {
                            // filter intro month based on assignedRetailWindowAttributeValue
                            if(field.field === 'RetailIntroMonthId') {
                                lookupDataList = utility.getUniquieRetailIntroAndExitMonths(utility.filterObject(lookupDataList, {CriteriaAttributeValue: assignedRetailWindowAttributeValue, Status: 1}, true));
                                lookupDataList = lookupDataList.sort(function(a, b) {
                                    return months.indexOf(a.RetailIntroMonth.toString().toLowerCase().trim().substring(0, 3)) - months.indexOf(b.RetailIntroMonth.toString().toLowerCase().trim().substring(0, 3))
                                })
                            }
                            // filter exit month based on selected retail intro month and assignedRetailWindowAttributeValue
                            if(field.field === 'RetailExitMonthId') {
                                var assignedRetailIntroMonth = {};
                                if(angular.isDefined(vm.record['RetailIntroMonthId'])) {
                                    assignedRetailIntroMonth = utility.filterObject(lookupDataList, {id: vm.record['RetailIntroMonthId']}, true)[0];
                                } else { // filter with monthvalue
                                    assignedRetailIntroMonth = utility.filterObject(lookupDataList, {value: vm.record['RetailIntroMonth']}, true)[0];
                                }
                                if(angular.isDefined(assignedRetailIntroMonth)) {
                                    lookupDataList = utility.getUniquieRetailIntroAndExitMonths(utility.filterObject(lookupDataList, {RetailIntroMonth: assignedRetailIntroMonth.RetailIntroMonth, CriteriaAttributeValue: assignedRetailWindowAttributeValue, Status: 1}, true));
                                    lookupDataList = lookupDataList.sort(function(a, b) {
                                        return months.indexOf(a.value.toString().toLowerCase().trim().substring(0, 3)) - months.indexOf(b.value.toString().toLowerCase().trim().substring(0, 3))
                                    })
                                } else {
                                    lookupDataList = [];
                                }
                            }
                        } else {
                            lookupDataList = [];
                        }
                    }
                    results = query ? utility.filterObject(lookupDataList, predicate) : utility.filterObject(lookupDataList, lookupFilter, true);
                    results = filterExistingValues(results, existingValues, lookupModel, field);
                    // this is to reduce the rendering time. It was very slow and was impacted overall page responsiveness
                    // so while displaying we will display only the first 100 records and user can filter with any value
                    var sortedList = results;
                    if (sortBy !== null) {
                        var sortKey = Object.keys(sortBy)[0];
                        var isAscending = sortBy[sortKey];
                        sortedList = utility.orderBy(results, sortKey, isAscending);
                    }
                    field['isAboveDropDownLimit'] = sortedList.length > 100;
                    return sortedList.slice(0, 100);
                });
            }
        }

        function filterExistingValues(results, existingValues, lookupModel, field) {
            //remove already existing values from result
            if(lookupModel.modelPath && lookupModel.modelPath === 'catalogs.CRD') {
                var existingAssignedCRDs = utility.filterObject(existingValues, {Status: 1}, true);
                if (existingAssignedCRDs && existingAssignedCRDs.length > 0) {
                    angular.forEach(existingAssignedCRDs, function (existingValue) {
                        var index = results.indexOf(utility.filterObject(results, { value: utility.formatDate(existingValue[lookupModel.lookupDisplayField], 'MMM d, y', 'UTC') }, true)[0]);
                        if (index !== -1) {
                            results.splice(index, 1);
                        }
                    });
                }
            } else {
                if (existingValues && existingValues.length > 0) {
                    angular.forEach(existingValues, function (existingValue) {
                        if (existingValue[field.field] && angular.isDefined(existingValue[field.field])) {
                            var index = results.indexOf(utility.filterObject(results, { value: existingValue[lookupModel.lookupDisplayField] }, true)[0]);
                            if (index !== -1) {
                                results.splice(index, 1);
                            }
                        }
                    });
                }
            }
            // filter article colors based on the color palette conditions
            if(field.isfilterCriteria) {
                results = getFilteredCriteriaValues(results, field);
            }
            return results;
        }
        // convert dropdown scope value form object(lookup record) to id property of lookup record
        function lookupChange(selectedObj, field, fieldObject) {
            if(angular.isObject(selectedObj)) {
                vm.record[field] = selectedObj.id;
                // load data from server based on the lockup value
                if(angular.isDefined(fieldObject.validation.onChangeLookUp) && fieldObject.validation.onChangeLookUp.length > 0) {
                    var lookUpChangeValues = utility.splitString(fieldObject.validation.onChangeLookUp, ',');
                    if(angular.isDefined(lookupExtras[lookUpChangeValues[0]])) {
                        lookupExtras[lookUpChangeValues[0]][lookUpChangeValues[1]] = selectedObj.id;
                    }
                    lookupPromises[field] = crud.createLookupPromise(vm.model, lookupExtras, 'create');
                }
                // if onChangeLookUpSetValue is defined then add the value of configured field from the selectedobj(ArticleName-ModelName) and assign it to ModelName field
                // used in articles module
                if(angular.isDefined(fieldObject.validation.onChangeLookUpSetValue) && fieldObject.validation.onChangeLookUpSetValue.length > 0) {
                    var lookUpSetValues = utility.splitString(fieldObject.validation.onChangeLookUpSetValue, ',');
                    // make the dependant field disabled
                    var dependantField = utility.filterObject(vm.model.fields, {field: lookUpSetValues[0]}, true)[0];
                    dependantField.validation.disabledCriteria = true;
                    vm.record[lookUpSetValues[0]] = selectedObj[lookUpSetValues[1]];
                }

                // TODO need to find an optiomal solution for this
                if(!utility.isObjectEmpty(fieldObject.setValueForOtherProperties)) {
                    var setValueForOtherProperties = fieldObject.setValueForOtherProperties;
                    if(field === setValueForOtherProperties.field && selectedObj.id === setValueForOtherProperties.value) {
                        var props = setValueForOtherProperties.props;
                        for(var key in props) {
                            if(props.hasOwnProperty(key)) {
                                vm.record[key] = props[key];
                            }
                        }
                    }
                }
                // filter exit month based on assignedRetailWindowAttributeValue
                if(fieldObject.field === 'RetailIntroMonthId') {
                    vm.record['RetailExitMonthId'] = null;
                }
                // when sizescale criteria dept attribute change clear the size scale
                if(fieldObject.isCriteriaDeptAttribute) {
                    vm.criteriaDependentCriteriaAttributeChanged(field);
                }
                if(vm.model.modelPath === 'accounts.sellers') {
                    if(vm.record.ParentAccountId !== null) {
                        vm.record.AutomaticNumbering = 0;
                        vm.record.CustomNumbering = 0;
                    }
                }
            }
            else if(angular.isUndefined(selectedObj) || selectedObj === null) {
                vm.record[field] = undefined; // on record removal make field undefined or the property can be deleted using delete keywork
                if(angular.isDefined(fieldObject.validation.onChangeLookUpSetValue) && fieldObject.validation.onChangeLookUpSetValue.length > 0) {
                    var lookUpSetValues = utility.splitString(fieldObject.validation.onChangeLookUpSetValue, ',');
                    // make the dependant field disabled
                    var dependantField = utility.filterObject(vm.model.fields, {field: lookUpSetValues[0]}, true)[0];
                    dependantField.validation.disabledCriteria = false;
                    vm.record[lookUpSetValues[0]] = '';
                }
                // filter exit month based on assignedRetailWindowAttributeValue
                if(fieldObject.field === 'RetailIntroMonthId') {
                    vm.record['RetailExitMonthId'] = null;
                }
                // when sizescale criteria dept attribute change clear the size scale
                if(fieldObject.isCriteriaDeptAttribute) {
                    vm.criteriaDependentCriteriaAttributeChanged(field);
                }
            }
        }

        function customLookupChange(selectedObj, field) {
            if(angular.isObject(selectedObj)) {
                vm.record[field.field] = selectedObj[field.customLookupInfo.value];
            }
            else if(angular.isUndefined(selectedObj) || selectedObj === null){
                vm.record[field.field] = undefined; // on record removal make field undefined or the property can be deleted using delete keywork
            }
        }

        function colorPaletteLookupChange(selectedObj, field) {
            if(angular.isObject(selectedObj) && Object.keys(selectedObj)[0] != null && angular.isDefined(selectedObj.value)) {
                // color palette values are stores as key value pair
                var objectVal = {};
                objectVal[selectedObj.id] = selectedObj.value
                vm.record[field.field] = objectVal;
            }
            else if(angular.isUndefined(selectedObj) || selectedObj === null){
                vm.record[field.field] = undefined; // on record removal make field undefined or the property can be deleted using delete keywork
            }
        }

        // isArticleNumberType for converting article id from string to int
        function getLookupDisplayValue(item, field, isArticleNumberType) {
            var lookupModel = api.getModel(field.lookupSource);
            item = isArticleNumberType ? parseInt(item) : item;

            if(angular.isDefined(lookupModel.lookupData) && angular.isDefined(lookupModel.lookupData.data) && lookupModel.lookupData.data.length) {
                return getLookupDisplayVal(item, lookupModel.lookupData);
            }
            else {
                return lookupPromises[field.field].then(function(lookupData) {
                    return getLookupDisplayVal(item, lookupData);
                });
            }
        }

        function getCustomLookupDisplayValue(item, field) {
            //  show only color name for color palette attributes
            if(field.inputType === 'color-palette') {
                return $filter('colorPaletteRenderer')(item, field);
            } else {
                var lookupModel = api.getModel(field.lookupSource);

                if(angular.isDefined(lookupModel.lookupData) && angular.isDefined(lookupModel.lookupData.data) && lookupModel.lookupData.data.length) {
                    return getCustomLookupDisplayVal(item, lookupModel.lookupData, field);
                }
                else {
                    return lookupPromises[field.field].then(function(lookupData) {
                        return getCustomLookupDisplayVal(item, lookupData, field);
                    });
                }
            }
        }

        //helper method
        function getLookupDisplayVal(item, lookupData) {
            var result;
            if(lookupData) {
                // since autocomplte return object
                if(angular.isObject(item)) {
                    result = utility.filterObject(lookupData.data, {id: item.id}, true);
                }
                // to initialize field value if any (when open update record dialog)
                else {
                    result = utility.filterObject(lookupData.data, {id: item}, true);
                }

                if (angular.isArray(result) && result.length > 0) {
                    return result[0].value;
                }
                else {
                    return result.value;
                }
            }
        }

        function getCustomLookupDisplayVal(item, lookupData, field) {
            var result;
            var predicate = {};
            if(lookupData) {
                // since autocomplete return object
                if(angular.isObject(item)) {
                    predicate[field.customLookupInfo.value] = item[field.customLookupInfo.value];
                    result = utility.filterObject(lookupData.data, predicate, true);
                }
                // to initialize field value if any (when open update record dialog)
                else {
                    predicate[field.customLookupInfo.value] = item;
                    result = utility.filterObject(lookupData.data, predicate, true);
                }

                if (angular.isArray(result) && result.length > 0) {
                    return result[0].value;
                }
                else {
                    return result.value;
                }
            }
        }

        function selectText(event) {
            utility.selectInputText(event);
        }

        function transformChip(chip, isMultiValue) {
            if (angular.isObject(chip)) {
                return chip.id;
            } else if(isMultiValue) {
                return chip;
            }
            return undefined;
        }

        //TODO: Check performance impact on using nested filter
        function acQuerySearch(query, selectedRecords, field) {
            var results = [];
            var lookupFilter = angular.isDefined(field.lookupFilter) ? field.lookupFilter : {};
            var predicate = angular.copy(lookupFilter);
            predicate.value = query;

            var lookupModel = api.getModel(field.lookupSource);
            if(angular.isDefined(lookupModel.lookupData) && angular.isDefined(lookupModel.lookupData.data) && lookupModel.lookupData.data.length) {
                results = query ? utility.filterObject(lookupModel.lookupData.data, predicate) : utility.filterObject(lookupModel.lookupData.data, lookupFilter);
                if(angular.isDefined(field.lookupFilterWithArray)) {
                   angular.forEach(field.lookupFilterWithArray, function (allowedValues, key) {
                        results = results.filter(function (item) {
                            // item[key] must be inside allowedValues array
                            return allowedValues.indexOf(item[key]) !== -1;
                        });
                    });
                }
                results = removeSelectedChips(selectedRecords, results, field);
                results;
            }
            else {
                lookupPromises[field.field].then(function(lookupData) {
                    results = query ? utility.filterObject(lookupData.data , predicate) : utility.filterObject(lookupData.data, lookupFilter);
                    if(angular.isDefined(field.lookupFilterWithArray)) {
                    angular.forEach(field.lookupFilterWithArray, function (allowedValues, key) {
                            results = results.filter(function (item) {
                                // item[key] must be inside allowedValues array
                                return allowedValues.indexOf(item[key]) !== -1;
                            });
                        });
                    }
                    results = removeSelectedChips(selectedRecords, results, field);
                    results;
                });
            }

            if (existingValues && existingValues.length > 0) {
                angular.forEach(existingValues, function (existingValue) {
                    if (existingValue[field.field] && angular.isDefined(existingValue[field.field])) {
                        angular.forEach(existingValue[field.field], function (fieldId) {
                            var index = results.indexOf(utility.filterObject(results, { id: fieldId }, true)[0]);
                            if (index !== -1) {
                                results.splice(index, 1);
                            }
                        })
                    }
                });
            }
            return results;
        }

        /**
         * @description
         * This method will remove selected chips form records (helper method)
         * @param {array} selectedRecords: list of selected chips
         * @param {array} records: data property of lookup-data
         * @param {field} field: field
         * @returns {array}: list of available chips (chips which are not selected) // it does not really need to return a value but for readability returning modified value
         */
         function removeSelectedChips(selectedRecords, records, field) {
            // used in shared folders users chips to avoid loading 100's of assigned users while updating
            if(field.dontShowAssignedRecordsInChip && angular.isDefined(vm.record.AssignedRecords) && vm.record.AssignedRecords.length) {
                selectedRecords = selectedRecords.concat(vm.record.AssignedRecords);
            }
            if (angular.isDefined(selectedRecords) && selectedRecords != null && selectedRecords.length > 0) {
                for (var index = records.length-1; index >= 0; index--) {
                    if (selectedRecords.indexOf(records[index].id) !== -1) {
                        records.splice(index,1);
                    }
                    if (selectedRecords.indexOf(records[index]) !== -1) {
                        records.splice(index,1);
                    }
                }
            }
            return records;
        }

        function getChipDisplayValue(chip, field) {
            var lookupModel = api.getModel(field.lookupSource);
            if(angular.isDefined(lookupModel.lookupData) && angular.isDefined(lookupModel.lookupData.data) && lookupModel.lookupData.data.length) {
                return getChipDisplayVal(lookupModel.lookupData, chip);
            }
            else { // it will never go to else part since before try to load display value for selected chips, it always load lookup on focus of chips input element
                return lookupPromises[field.field].then(function(lookupData) {
                    return getChipDisplayVal(lookupData, chip);
                });
            }
        }

        //helper method
        function getChipDisplayVal(lookupData, chip) {
            var res = utility.filterObject(lookupData.data, {id: chip}, true);
            if (angular.isArray(res) && res.length > 0) {
                return res[0].value;
            }
            else {
                $log.warn('viewCreator controller: Unable to resolve chip display value!');
                return "";
            }
        }

        function isInputRequired(field) {
            if (angular.isString(field.validation.isRequired)) {
                return (scope.$eval(field.validation.isRequired) && (angular.isUndefined(field.validation.disabledCriteria) || !scope.$eval(field.validation.disabledCriteria)));
            } else {
                return (field.validation.isRequired && (angular.isUndefined(field.validation.disabledCriteria) || !scope.$eval(field.validation.disabledCriteria)));
            }
        }

        function getDateObj(dateString, field, fromUTC) {
            if(dateString) {
                return utility.createDateObject(dateString, field, fromUTC);
            }
        }

        function validateTxPattern(field) {
            var validationExpression = utility.isValidJSON(field.validation['tx-pattern']);
            if(validationExpression && angular.isDefined(validationExpression.F) && validationExpression.F.length > 0) {
                var parsedExpressionObjects = validationExpression.F;
                vm.isValidValue = true;
                angular.forEach(parsedExpressionObjects, function(parsedExpressionObject) {
                    if(vm.isValidValue) {
                        // skip validating overridable attribute with parent attributes for master catalog
                        if(angular.isDefined(parsedExpressionObject['SourceField']) && (dataSourceTypeId === 1 && field.Overridable && !parsedExpressionObject['SourceField'].startsWith('#')) || (dataSourceTypeId === 3)) {
                            // if SourceValueRequired is true then the source field should be required for this attribute to have value
                            if(parsedExpressionObject['SourceValueRequired']) {
                                if(vm.record[parsedExpressionObject['SourceField']] !== '' && vm.record[parsedExpressionObject['SourceField']] != null) {
                                    setAttributeFieldValidity(field, parsedExpressionObject);
                                } else if(vm.record[field.field] !== '' && vm.record[field.field] != null) {
                                    vm.editForm[field.field].$setValidity('pattern', false);
                                    vm.editForm[field.field].$touched = true;
                                    if(angular.isDefined(parsedExpressionObject.Message)) {
                                        field.validation.messages.pattern = parsedExpressionObject.Message;
                                    }
                                    vm.isValidValue = false;
                                }
                            } else {
                                if(vm.record[parsedExpressionObject['SourceField']] !== '' && vm.record[parsedExpressionObject['SourceField']] != null
                                    && vm.record[field.field] !== '' && vm.record[field.field] != null && parsedExpressionObject['SourceField'] !== 'ShipmentStartDate' && parsedExpressionObject['SourceField'] !== 'ShipmentEndDate') {
                                    setAttributeFieldValidity(field, parsedExpressionObject);
                                } else if((parsedExpressionObject['SourceField'] === 'ShipmentStartDate' || parsedExpressionObject['SourceField'] === 'ShipmentEndDate') && (vm.record['RetailIntroMonth'] != null && vm.record['RetailIntroMonth'] !== '') && (vm.record['RetailExitMonth'] != null && vm.record['RetailExitMonth'] !== '') && vm.record[field.field] !== '' && vm.record[field.field] != null) {
                                    // get the data from the mapped retail window and validate
                                    var retailWindowDataList = api.getModel('catalogs.retailExitMonthsForArticle').lookupData.data;
                                    var mappedRetailWindow = utility.filterObject(retailWindowDataList, {id: vm.record['RetailExitMonthId']}, true)[0];
                                    if(angular.isDefined(mappedRetailWindow)) {
                                        vm.record['ShipmentStartDate'] = mappedRetailWindow.ShipmentStartDate;
                                        vm.record['ShipmentEndDate'] = mappedRetailWindow.ShipmentEndDate;
                                        setAttributeFieldValidity(field, parsedExpressionObject);
                                    }
                                }
                                else if(vm.editForm[field.field]) {
                                    vm.editForm[field.field].$setValidity('pattern', true);
                                    vm.editForm[field.field].$touched = true;
                                }
                            }
                        }
                        if(angular.isUndefined(parsedExpressionObject['SourceField']) && angular.isDefined(parsedExpressionObject['Expression']) && angular.isDefined(parsedExpressionObject['ExpressionValue'])) {
                            if(vm.record[field.field] !== '' && vm.record[field.field] != null) {
                                setAttributeFieldValidity(field, parsedExpressionObject, true);
                            }
                            else if(vm.editForm[field.field]) {
                                vm.editForm[field.field].$setValidity('pattern', true);
                            }
                        }
                    }
                });
            }
        }

        function setAttributeFieldValidity(field, parsedExpressionObject, isExpressionValidation) {
            var valid = validateExpression(field, parsedExpressionObject, isExpressionValidation);
            if(!valid) {
                if(angular.isDefined(vm.editForm[field.field])) {
                    vm.editForm[field.field].$setValidity('pattern', false);
                    vm.editForm[field.field].$touched = true;
                    if(angular.isDefined(parsedExpressionObject.Message)) {
                       field.validation.messages.pattern = parsedExpressionObject.Message;
                    }
                    vm.isValidValue = false;
                }
            } else {
                if(angular.isDefined(vm.editForm[field.field])) {
                    vm.editForm[field.field].$setValidity('pattern', true);
                    vm.editForm[field.field].$touched = true;
                }
            }
        }

        function validateExpression(field, parsedExpressionObject, isExpressionValidation) {
            var Expression = parsedExpressionObject.Expression;
            var SourceField = parsedExpressionObject.SourceField;
            var currentAttributeValue = vm.record[field.field];
            var sourceAttributeValue = !isExpressionValidation ? vm.record[SourceField] : parsedExpressionObject.ExpressionValue;

            //Transform the date fields to type dateUTC
            angular.forEach(vm.model.fields, function(itm) {
                if(itm.field === field.field || itm.field === SourceField) {
                    // for date fields
                    if ((itm.inputType === 'date-utc' || itm.inputType === 'date-option' || itm.inputType === 'date-without-time' || itm.inputType === 'date')) {
                        if(itm.field === field.field) {
                            currentAttributeValue = new Date(vm.record[itm.field]);
                            currentAttributeValue = currentAttributeValue.setHours(0,0,0,0);
                            if(isExpressionValidation) {
                                sourceAttributeValue = new Date(sourceAttributeValue)
                                sourceAttributeValue = sourceAttributeValue.setHours(0,0,0,0);
                            }
                        } else if(itm.field === SourceField) {
                            sourceAttributeValue = new Date(vm.record[itm.field]);
                            sourceAttributeValue = sourceAttributeValue.setHours(0,0,0,0);
                        }
                    }
                    // for text input types
                    if (itm.inputType === 'textArea' || itm.inputType === 'text' || (angular.isDefined(itm.type) && itm.type === 'text' && itm.inputType === 'list')) {
                        if(itm.field === field.field) {
                            currentAttributeValue = vm.record[itm.field].toUpperCase();
                             if(isExpressionValidation) {
                                sourceAttributeValue = sourceAttributeValue.toString().toUpperCase();
                            }
                        } else if(itm.field === SourceField) {
                            sourceAttributeValue = vm.record[itm.field].toUpperCase();
                        }
                    }
                }
            });

            if(dataSourceTypeId === 3 && field.Overridable) {
                if(field.inputType === 'textArea' || field.inputType === 'text' || (angular.isDefined(field.type) && field.type === 'text' && field.inputType === 'list')) {
                    sourceAttributeValue = vm.record[SourceField].toUpperCase();
                }

                // for date fields
                if ((field.inputType === 'date-utc' || field.inputType === 'date-option' || field.inputType === 'date-without-time' || field.inputType === 'date')) {
                    sourceAttributeValue = new Date(vm.record[SourceField]);
                    sourceAttributeValue = sourceAttributeValue.setHours(0,0,0,0);
                }
            }

            var isValid = false;
            switch(Expression) {
                case '<':
                    isValid = currentAttributeValue < sourceAttributeValue ? true : false;
                    break;
                case '>':
                    isValid = currentAttributeValue > sourceAttributeValue ? true : false;
                    break;
                case '<=':
                    isValid = currentAttributeValue <= sourceAttributeValue ? true : false;
                    break;
                case '>=':
                    isValid = currentAttributeValue >= sourceAttributeValue ? true : false;
                    break;
                case '=':
                    isValid = currentAttributeValue === sourceAttributeValue ? true : false;
                    break;
                case '!=':
                    isValid = currentAttributeValue !== sourceAttributeValue ? true : false;
                    break;
            }
            return isValid;
        }

        function getConditionalVettingList(field) {
            var attribute = field.field;
            // CriteriaV2 (preferred): dropdown = matched rule's AllowedValues ([] when no rule matches)
            if (vm.criteriaV2Map[attribute]) {
                var getDependentValueForCriteriaV2 = function(dependentField) {
                    var depVal = vm.record[dependentField];
                    return (depVal && typeof depVal === 'object') ? (angular.isDefined(depVal.value) ? depVal.value : depVal) : depVal;
                };
                var criteriaV2Allowed = utility.getCriteriaV2AllowedValues(vm.criteriaV2Map[attribute], getDependentValueForCriteriaV2);
                var criteriaV2AttributeField = utility.filterObject(vm.filteredVisibleFields || vm.visibleFields, {field: attribute}, true)[0];
                if (angular.isDefined(criteriaV2AttributeField)) {
                    criteriaV2AttributeField.values = (criteriaV2Allowed || [])
                        .map(function(value) { return value.toString().trim(); })
                        .sort(function(a, b) { return a.toLowerCase().localeCompare(b.toLowerCase()); });
                }
                return;
            }
            var criteriaObj = {};
            var catalogAttribute = utility.filterObject(catalogFactory.getActiveCatalogDetails().AssignedCatalogAttributes,
                { AttributeSystemName: attribute }, true)[0];
            var catalogAttributeAllowedValues = (catalogAttribute.AllowedValues || []).map(function (v) {
                return v.toString().toLowerCase()
            })
            angular.forEach(vm.vettingListCriteriaList, function(criteriaAttr) {
                for(var key1 in criteriaAttr) {
                    if(criteriaAttr.hasOwnProperty(key1)) {
                        if(key1.toLocaleLowerCase() === attribute.toLowerCase()) {
                            criteriaObj = criteriaAttr[key1];
                            break;
                        }
                    }
                }
            });

            var validValues = [];
            var noMatch = true
            Object.keys(criteriaObj).forEach(function (key) {
                var item = criteriaObj[key];
                var subItems = Object.keys(item);
                var validItems = 0;
                subItems.forEach(function (key2) {
                    if (vm.record.hasOwnProperty(key2) && vm.record[key2] != null && vm.record[key2] !== '') {
                        var articleAttributeValue = typeof(vm.record[key2]) === 'object' ?
                            angular.isDefined(vm.record[key2]['value']) ? vm.record[key2]['value'] : vm.record[key2] :
                            vm.record[key2];
                        var isDate = validateDate(articleAttributeValue);
                        if(articleAttributeValue != null && articleAttributeValue.toString() != '') {
                            noMatch = false;
                            var lowerCaseValues = item[key2].map(function (value) {
                                return isDate == true ? new Date(value).getTime().toString().toLowerCase() : value.toString().toLowerCase();
                            });

                            if(isDate == true) {
                                // remove time while comparing date-without-time and date-option values
                                if(field.inputType === 'date-option' || field.inputType === 'date-without-time') {
                                    lowerCaseValues = lowerCaseValues.split('T', 1)[0];
                                }
                                if(lowerCaseValues.indexOf(new Date(articleAttributeValue).getTime().toString().toLowerCase()) !== -1) {
                                  validItems++;
                                }
                            } else {
                                if(lowerCaseValues.indexOf(articleAttributeValue.toString().toLowerCase()) !== -1) {
                                    validItems++;
                                }
                            }
                        }
                    } else {
                        validItems++;
                    }
                });

                if (subItems.length == validItems && catalogAttributeAllowedValues.indexOf(key.toLowerCase()) !== -1) {
                    validValues.push(key);
                }
            });
            var attributeField = utility.filterObject(vm.filteredVisibleFields, {field: attribute}, true)[0];
            if (!noMatch) {
                attributeField.values = (validValues || [])
                .map(function(value) {
                    return value.trim();
                })
                .sort(function(a, b) {
                    return a.toLowerCase().localeCompare(b.toLowerCase());
                })
            } else {
                attributeField.values = (catalogAttribute.AllowedValues || [])
                .map(function(value) {
                    return value.trim();
                })
                .sort(function(a, b) {
                    return a.toLowerCase().localeCompare(b.toLowerCase());
                })
            }
        }

        function validateDate(value, formats) {
            if(angular.isUndefined(formats)) {
                formats = [
                    moment.ISO_8601
                ];
            }
            return moment(value, formats, true).isValid();
        }

        function multiValueQuerySearch(query, selectedItems, field) {
            if(field.isCriteriaAdded) {
                getConditionalVettingList(field);
            }
            var values = field.values;
            var searchQueryResult = [];
            var searchQueryResult = utility.filterObject(values, query);
            if (selectedItems && selectedItems.length > 0) {
              for (var index = searchQueryResult.length - 1; index >= 0; index--) {
                if (selectedItems.indexOf(searchQueryResult[index]) !== -1) {
                  searchQueryResult.splice(index, 1);
                }
              }
            }
            return searchQueryResult;
        }

        function validateJSON(field) {
            var valid = utility.isValidJSON(vm.record[field.field]);
            if(valid && utility.isObjectEmpty(JSON.parse(vm.record[field.field]))) {
                valid = false;
            }
            if(valid) {
                if(angular.isDefined(vm.editForm[field.field])) {
                    vm.editForm[field.field].$setValidity('checkIfValidJson', true);
                }
            } else {
                if(angular.isDefined(vm.editForm[field.field])) {
                    vm.editForm[field.field].$setValidity('checkIfValidJson', false);
                }
            }
        }

        function sourceAttributeForValidationChanged(field) {
            var validationExpression = utility.isValidJSON(field.validation['tx-pattern']);
            if(validationExpression && angular.isDefined(validationExpression.F) && validationExpression.F.length > 0) {
                var parsedExpressionObjects = validationExpression.F;
                angular.forEach(parsedExpressionObjects, function(parsedExpressionObject) {
                    var sourceField = parsedExpressionObject['SourceField'];
                    var sourceAttributeField = utility.filterObject(vm.visibleFields, {field: sourceField}, true)[0];
                    if(angular.isDefined(sourceAttributeField)) {
                        validateTxPattern(sourceAttributeField);
                    }
                });
            }
        }

        // criteria dependentant attribute change method
        function criteriaDependentCriteriaAttributeChanged() {
            var filterCriteriaFields =  utility.filterObject(vm.visibleFields, {isfilterCriteria: true}, true);
            angular.forEach(filterCriteriaFields, function(filterCriteriaField) {
                vm.record[filterCriteriaField.field] = null;
            });
        }

        /**
         * Enable use Enter and any other seperator key defined on model to be use as a seperator key for chips
         */
        function updateSperatorKeys(field) {
            vm.tagSeperatorKeys[field.field] = [$mdConstant.KEY_CODE.ENTER];
            if(angular.isDefined(field.tagSeparator)) {
                var aditionalSeperator = field.tagSeparator.charCodeAt();
                if(angular.isDefined(aditionalSeperator) && aditionalSeperator !== 'NaN') {
                    vm.tagSeperatorKeys[field.field].push(aditionalSeperator);
                }
            }
        }

        function populateTags(record, field) {
            if(angular.isUndefined(record[field.field]) || record[field.field] === null || record[field.field] === '') {
                record[field.field] = [];
            }
            else if(angular.isDefined(field.tagSeparator)) {
                var stringVal = record[field.field];
                var tagSeparator = field.tagSeparator;
                if(!angular.isArray(stringVal) && stringVal !== null) {
                    record[field.field] = stringVal.split(tagSeparator);
                }
            }
            else {
                $log.warn('tagSeparator property is missing in model for ' + field.field);
            }
        }


        function populateDefaultValues(defaultVals) {
            if (angular.isDefined(defaultValues) && defaultValues !== null) {
                for(var prop in defaultVals) {
                    vm.record[prop] = defaultVals[prop];
                }
            }

            //Populate default values
            for (var i=0; i<vm.model.fields.length;i++) {
                // if default value assigned then assign it for creation
                var isDefaultValueAssigned = vm.isNew && angular.isDefined(vm.model.fields[i].DefaultValue) && vm.model.fields[i].DefaultValue != null && vm.model.fields[i].DefaultValue !== '' ? true : false;
                if (vm.isNew && (vm.model.fields[i].editable || vm.model.fields[i].inputType === 'static') && angular.isDefined(vm.model.fields[i].fieldDefaultValue)) {
                    vm.record[vm.model.fields[i].field] = vm.model.fields[i].fieldDefaultValue;
                }

                if (vm.model.fields[i].inputType === 'text' || vm.model.fields[i].inputType === 'textArea') {
                    if(angular.isUndefined(vm.record[vm.model.fields[i].field]) && vm.isNew) {
                        vm.record[vm.model.fields[i].field] = isDefaultValueAssigned ? vm.model.fields[i].DefaultValue : '';
                    }
                }

                else if (vm.model.fields[i].inputType === 'number') {
                    if(angular.isUndefined(vm.record[vm.model.fields[i].field]) && vm.isNew && vm.model.fields[i].creatable) {
                        vm.record[vm.model.fields[i].field] = isDefaultValueAssigned ? Number(vm.model.fields[i].DefaultValue) : 0;
                    }
                }

                else if (vm.model.fields[i].inputType === 'lookup-many' && ( angular.isUndefined(vm.record[vm.model.fields[i].field]) || vm.record[vm.model.fields[i].field] == null )) {
                    vm.record[vm.model.fields[i].field] = [];
                }

                else if(vm.model.fields[i].inputType === 'tags') {
                    if (vm.model.fields[i].field !== 'AllowedValues' && vm.model.fields[i].field !== 'Values') {
                        updateSperatorKeys(vm.model.fields[i]);
                        populateTags(vm.record, vm.model.fields[i]);
                    }
                    else {
                        if (vm.isNew) {
                            vm.textareaValue = '';
                        }
                        else {
                            vm.textareaValue = utility.joinArray(vm.record[vm.model.fields[i].field], '\n');
                        }
                    }
                }

                else if(vm.model.fields[i].inputType === 'bool' && !vm.isNew) {
                    if(angular.isUndefined(vm.record[vm.model.fields[i].field])) {
                        vm.record[vm.model.fields[i].field] = false;
                    }
                }

                //for listing populated values of attributes in active catalog's attributeVettingList
                else if (vm.model.fields[i].inputType === 'list' || (vm.model.fields[i].inputType === 'multi-value')) {
                    if (vm.isNew || angular.isUndefined(vm.record[vm.model.fields[i].field])) {
                        vm.record[vm.model.fields[i].field] = (vm.isNew && isDefaultValueAssigned) ? vm.model.fields[i].DefaultValue : vm.model.fields[i].type === 'int' ? 0 : '';
                    }
                    // for multivalue dropdown make the record as array
                    if(vm.model.fields[i].inputType === 'multi-value') {
                        if(vm.isNew) {
                            vm.record[vm.model.fields[i].field] = isDefaultValueAssigned ? utility.splitString(vm.model.fields[i].DefaultValue, '|') : [];
                        } else if((!vm.isNew && (vm.record[vm.model.fields[i].field] == null || vm.record[vm.model.fields[i].field] == ''))) {
                            vm.record[vm.model.fields[i].field] = [];
                        } if(!vm.isNew) {//Non Removable Existing Chips: send existingRecords only when action is edit and nonRemovableChips is true
                            if(angular.isDefined(vm.model.fields[i].nonRemovableChips) && vm.model.fields[i].nonRemovableChips === true) {
                                vm.existingRecords = angular.copy(vm.record[vm.model.fields[i].field]);
                            }
                        }
                    }
                    if (vm.model.modelPath === 'catalogs.articles' || vm.model.modelPath === 'catalogs.linePlanArticles' || vm.model.modelPath === 'sellerModels.sellerModels' || vm.model.modelPath === 'catalogs.models') {
                        var attributes = catalogFactory.getActiveCatalogDetails().AssignedCatalogAttributes;
                        if (attributes && attributes.length > 0) {
                            angular.forEach(attributes, function (attribute) {
                                if (attribute.AttributeSystemName === vm.model.fields[i].field) {
                                    vm.model.fields[i].values = (attribute.AllowedValues || [])
                                    .map(function(value) {
                                        return value.trim();
                                    })
                                    .sort(function(a, b) {
                                        return a.toLowerCase().localeCompare(b.toLowerCase());
                                    })
                                    // for attribute vetting list criteria — CriteriaV2 preferred over OLD Criteria
                                    if(vm.model.fields[i].isDynamicProperty && attribute.CriteriaV2 && attribute.CriteriaV2.length > 0) {
                                        try {
                                            vm.criteriaV2Map[attribute.AttributeSystemName] = JSON.parse(attribute.CriteriaV2);
                                        } catch(error) {
                                            console.warn(attribute.AttributeDisplayName + " - Attribute CriteriaV2: Invalid JSON Format");
                                        }
                                        vm.model.fields[i].isCriteriaAdded = true;
                                        var v2DependentDisplayNames = [];
                                        utility.getCriteriaV2DependentFields(vm.criteriaV2Map[attribute.AttributeSystemName]).forEach(function(depKey) {
                                            var v2DependentField = utility.filterObject(vm.visibleFields, {field: depKey}, true)[0];
                                            if(angular.isDefined(v2DependentField)) {
                                                if(!vm.criteriaDeptAttributeMap[depKey]) {
                                                    vm.criteriaDeptAttributeMap[depKey] = [];
                                                }
                                                if(vm.criteriaDeptAttributeMap[depKey].indexOf(attribute.AttributeSystemName) === -1) {
                                                    vm.criteriaDeptAttributeMap[depKey].push(attribute.AttributeSystemName);
                                                }
                                                v2DependentField.isDependentAttribute = true;
                                                v2DependentDisplayNames.push(utility.getAttributeDisplayNameUsingSystemName(catalogFactory.getActiveCatalogDetails().AssignedCatalogAttributes, depKey));
                                            }
                                        });
                                        vm.model.fields[i].criteriaDisplayMessage = 'Attribute '+ attribute.AttributeDisplayName +' is dependent on the attribute(s) ' + v2DependentDisplayNames + '.';
                                    } else if(vm.model.fields[i].isDynamicProperty && attribute.Criteria.length > 0) {
                                        // parse json
                                        try {
                                            var vettinglistCriteria = JSON.parse(attribute.Criteria);
                                        } catch(error) {
                                            console.warn(attribute.AttributeDisplayName + " - Attribute Criteria: Invalid JSON Format");
                                        }
                                        var dependentAttributesDisplayNames = [];
                                        vm.model.fields[i].isCriteriaAdded = true;
                                        var dependingAttributes = {};
                                        var obj2 = {};
                                        for(var key in vettinglistCriteria) {
                                            if(vettinglistCriteria.hasOwnProperty(key)) {
                                                var deptAttr = vettinglistCriteria[key];
                                                for(var key1 in deptAttr) {
                                                    var obj = {};
                                                    if(deptAttr.hasOwnProperty(key1)) {
                                                        var index = dependentAttributesDisplayNames.indexOf(utility.getAttributeDisplayNameUsingSystemName(catalogFactory.getActiveCatalogDetails().AssignedCatalogAttributes, key1));
                                                        if( index === -1 ) {
                                                            var dependentAttributeField = utility.filterObject(vm.visibleFields, {field: key1}, true)[0];
                                                            if(angular.isDefined(dependentAttributeField)) {
                                                                if(!vm.criteriaDeptAttributeMap[key1]) {
                                                                    vm.criteriaDeptAttributeMap[key1] = [];
                                                                }
                                                                vm.criteriaDeptAttributeMap[key1].push(attribute.AttributeSystemName);
                                                                dependentAttributesDisplayNames.push(utility.getAttributeDisplayNameUsingSystemName(catalogFactory.getActiveCatalogDetails().AssignedCatalogAttributes, key1));
                                                                dependentAttributeField.isDependentAttribute = true;
                                                            }
                                                        }
                                                        if(obj2[key1]) {
                                                            angular.forEach(deptAttr[key1], function(val) {
                                                                if(obj2[key1][val]) {
                                                                    if(obj2[key1][val].indexOf(key)) {
                                                                        obj2[key1][val].push(key);
                                                                    }
                                                                } else {
                                                                    obj2[key1][val] = [key];
                                                                }
                                                            });
                                                        } else {
                                                            angular.forEach(deptAttr[key1], function(val) {
                                                                obj[val] = [key];
                                                            });
                                                            obj2[key1] = obj;
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                        dependingAttributes[attribute.AttributeSystemName] = obj2;
                                        vm.dependingAttributesMap.push(dependingAttributes);
                                        var obj = {};
                                        obj[attribute.AttributeSystemName] = vettinglistCriteria;
                                        vm.vettingListCriteriaList.push(obj);
                                        var criteriaDisplayMessage = 'Attribute '+ attribute.AttributeDisplayName +' is dependent on the attribute(s) ' + dependentAttributesDisplayNames + '.';
                                        vm.model.fields[i].criteriaDisplayMessage = criteriaDisplayMessage;
                                    }
                                }
                            })
                        }
                    }
                }

                else if (vm.model.modelPath === 'catalogs.linePlanArticles' && vm.model.fields[i].inputType === 'text' && vm.model.fields[i].field.toLowerCase() === 'article_type') {
                    if(vm.isNew) {
                        vm.record[vm.model.fields[i].field] = 'new';
                    }
                    vm.model.fields[i].validation.disabledCriteria = true;
                }

                else if(vm.model.fields[i].inputType === 'int-bool') {
                    if(angular.isUndefined(vm.record[vm.model.fields[i].field])) {
                        vm.record[vm.model.fields[i].field] = '0';
                    }
                }

                else if(vm.model.fields[i].inputType === 'bool-int') {
                    if(angular.isUndefined(vm.record[vm.model.fields[i].field])) {
                        vm.record[vm.model.fields[i].field] = 0;
                    }
                }

                else if(vm.model.fields[i].inputType === 'bool-str') {
                    if(angular.isUndefined(vm.record[vm.model.fields[i].field])) {
                        vm.record[vm.model.fields[i].field] = isDefaultValueAssigned ? vm.model.fields[i].DefaultValue.toLowerCase() : 'false';
                    }
                }

                else if(vm.model.fields[i].inputType === 'date' || vm.model.fields[i].inputType === 'date-option') { // workaround for issue with interpolation on ng-disabled on md-datepicker
                    if(angular.isUndefined(vm.record[vm.model.fields[i].field]) && isDefaultValueAssigned) {
                        vm.record[vm.model.fields[i].field] = utility.formatDate(new Date(field.DefaultValue), 'yyyy-MM-dd');
                    }
                    if ($scope.$eval(vm.model.fields[i].validation.disabledCriteria) || (!vm.isNew && vm.model.fields[i].showInEdit && !vm.model.fields[i].editable)) {
                        //vm.disableDate =  true;
                        vm.model.fields[i].validation.disabled = true;
                    } else {
                        vm.model.fields[i].validation.disabled = false;
                    }
                }
                else if(vm.model.fields[i].inputType === 'date-utc') { // workaround for issue with interpolation on ng-disabled on md-datepicker
                    if ($scope.$eval(vm.model.fields[i].validation.disabledCriteria) || (!vm.isNew && vm.model.fields[i].showInEdit && !vm.model.fields[i].editable)) {
                        //vm.disableDateUTC =  true;
                        vm.model.fields[i].validation.disabled = true;
                    } else {
                        vm.model.fields[i].validation.disabled = false;
                    }
                }
                else if(vm.model.fields[i].inputType === 'date-without-time') { // workaround for issue with interpolation on ng-disabled on md-datepicker
                    if(angular.isUndefined(vm.record[vm.model.fields[i].field]) && isDefaultValueAssigned) {
                        vm.record[vm.model.fields[i].field] = utility.formatDate(new Date(field.DefaultValue), 'yyyy-MM-dd');
                    }
                    if ($scope.$eval(vm.model.fields[i].validation.disabledCriteria) || (!vm.isNew && vm.model.fields[i].showInEdit && !vm.model.fields[i].editable)) {
                        vm.model.fields[i].validation.disabled = true;
                    } else {
                        vm.model.fields[i].validation.disabled = false;
                    }
                }
                else if (vm.model.fields[i].inputType === 'calculated') { // calculated fields are neither creatable nor editable
                    vm.model.fields[i].creatable = false;
                    vm.model.fields[i].editable = false;
                }
                else if (vm.model.fields[i].inputType === 'color') {
                    vm.colors = mockFactory.getFavoritesColors();
                    if(vm.isNew) {
                        // assign color based on index when creating new favorite tag
                        vm.randomColorForFavoriteTag = vm.colors[existingRecordsForUniqueValue.length % vm.colors.length];
                    }
                }

                else if(vm.model.fields[i].inputType === 'color-picker') {
                    if(angular.isUndefined(vm.record[vm.model.fields[i].field])) {
                        vm.record[vm.model.fields[i].field] = '#969696';
                    }
                }

                else if(vm.model.fields[i].inputType === 'decimal') {
                    if(angular.isUndefined(vm.record[vm.model.fields[i].field])) {
                        vm.record[vm.model.fields[i].field] = isDefaultValueAssigned ? Number(vm.model.fields[i].DefaultValue) : 0;
                    }
                }

                else if (vm.model.fields[i].inputType === 'lookup-table') {
                    vm.model.fields[i].isLookupAdded = true;
                    if (angular.isDefined(validSellerLookupsDestinationAttributesMap[vm.model.fields[i].field])) {
                        var attributeLookupValues = validSellerLookupsDestinationAttributesMap[vm.model.fields[i].field];
                        var sourceAttributesDisplayNames = [];
                        var matched = false;
                        for (var j = 0; j < attributeLookupValues.length; j++) {
                            var allAttributesMatch = true;
                            var value = attributeLookupValues[j];
                            for (var attributeSystemName in value.Source) {
                                if (value.Source.hasOwnProperty(attributeSystemName)) {
                                    if(vm.record[attributeSystemName] == null || value.Source[attributeSystemName].toString().toLowerCase() !== vm.record[attributeSystemName].toString().toLowerCase()) {
                                        allAttributesMatch = false;
                                        break;
                                    }
                                }
                            }

                            if (allAttributesMatch) {
                                if(vm.record[vm.model.fields[i].field] !== value.Destination[vm.model.fields[i].field]) {
                                    vm.record[vm.model.fields[i].field] = value.Destination[vm.model.fields[i].field];
                                }
                                matched = true;
                                break;
                            }
                        }

                        // create source attributes map
                        if(attributeLookupValues.length) {
                            var firstSourceDestinationValue = attributeLookupValues[0];
                            for (var attributeSystemName in firstSourceDestinationValue.Source) {
                                var index = sourceAttributesDisplayNames.indexOf(utility.getAttributeDisplayNameUsingSystemName(catalogFactory.getActiveCatalogDetails().AssignedCatalogAttributes, attributeSystemName));
                                if (index === -1) {
                                    sourceAttributesDisplayNames.push(utility.getAttributeDisplayNameUsingSystemName(catalogFactory.getActiveCatalogDetails().AssignedCatalogAttributes, attributeSystemName));
                                    var sourceAttributeField = utility.filterObject(vm.visibleFields, { field: attributeSystemName }, true)[0];
                                    if (angular.isDefined(sourceAttributeField)) {
                                        sourceAttributeField.isLookupSourceAttribute = true;
                                    }
                                }
                                if (!vm.lookupSourceAndDeptAttributeMap[attributeSystemName]) {
                                    vm.lookupSourceAndDeptAttributeMap[attributeSystemName] = [];
                                }
                                if (vm.lookupSourceAndDeptAttributeMap[attributeSystemName].indexOf(vm.model.fields[i].field) === -1) {
                                    vm.lookupSourceAndDeptAttributeMap[attributeSystemName].push(vm.model.fields[i].field);
                                }
                            }
                        }
                        if (!matched) {
                            if(vm.record[vm.model.fields[i].field] != null) {
                                vm.record[vm.model.fields[i].field] = null;
                            }
                        }
                        vm.model.fields[i].lookupDisplayMessage = 'Attribute ' + vm.model.fields[i].displayLabel + ' is dependent on the attribute(s) ' + sourceAttributesDisplayNames.join(', ') + '.';
                    } else {
                        vm.model.fields[i].lookupDisplayMessage = 'Attribute ' + vm.model.fields[i].displayLabel + ' does not have any source attribute(s) assigned';
                    }
                }

                if(vm.model.fields[i].checkIfUnique) {
                    vm.existingRecordsForUniqueValue = existingRecordsForUniqueValue ? existingRecordsForUniqueValue : [];
                } else if(!vm.isNew) {//Non Removable Existing Chips: send existingRecords only when action is edit and nonRemovableChips is true
                    if(vm.model.fields[i].inputType === 'lookup-many' && angular.isDefined(vm.model.fields[i].nonRemovableChips) && vm.model.fields[i].nonRemovableChips === true) {
                        vm.existingRecords = angular.copy(vm.record[vm.model.fields[i].field]);
                    }
                }
                // validate dependant attributes on tx pattern attribute changes
                if(angular.isDefined(vm.model.fields[i].validation) && vm.model.fields[i].validation['tx-pattern']) {
                    var validationExpression = utility.isValidJSON(vm.model.fields[i].validation['tx-pattern']);
                    if(validationExpression && angular.isDefined(validationExpression.F) && validationExpression.F.length > 0) {
                        var parsedExpressionObjects = validationExpression.F;
                        angular.forEach(parsedExpressionObjects, function(parsedExpressionObject) {
                            var sourceField = parsedExpressionObject['SourceField'];
                            var sourceAttributeField = utility.filterObject(vm.visibleFields, {field: sourceField}, true)[0];
                            if(angular.isDefined(sourceAttributeField) && (!sourceAttributeField.validation.disabledCriteria)) {
                                // if source field is required then make the isRequired property true for that attribute
                                if(parsedExpressionObject.SourceValueRequired) {
                                    sourceAttributeField.validation.isRequired = true;
                                }
                                sourceAttributeField.isSourceAttributeForValidation = true;
                            }
                        });
                    }
                }
                if((vm.model.modelPath === 'catalogs.articles' || vm.model.modelPath === 'catalogs.linePlanArticles')) {

                    // show info message for retail intro and exit months
                    if (vm.model.fields[i].inputType === 'lookup') {
                        if(vm.model.fields[i].field === 'RetailIntroMonthId') {
                            vm.model.fields[i].retailMonthDisplayMessage = 'Retail Intro Month is dependent on the attribute ' + retailWindowAttribute + '.';
                        }

                        if(vm.model.fields[i].field === 'RetailExitMonthId') {
                            vm.model.fields[i].retailMonthDisplayMessage = 'Retail Exit Month is dependent on the attribute ' + retailWindowAttribute + ' and Retail Intro Month.';
                        }

                        if(vm.model.fields[i].field === 'ColorId' && !vm.isNew) {
                            // this is to show the ColorName instead of ColorId dropdown when primary color exists.
                            if(angular.isUndefined(vm.record[vm.model.fields[i].field]) || vm.record[vm.model.fields[i].field] == null || vm.record[vm.model.fields[i].field] === 0) {
                                vm.model.fields[i].showReadOnlyTextWhenValueAssigned = false;
                            } else {
                                vm.model.fields[i].showReadOnlyTextWhenValueAssigned = {field: 'ColorName'};
                            }
                        }
                    }
                }
            }

            if(vm.model.modelPath === 'catalogs.shipmentWindows') {
                var dataExistsCombinationFld = utility.filterObject(vm.model.fields, {field: 'dataExistsCombinationField'}, true)[0]
                if(angular.isDefined(dataExistsCombinationFld)) {
                    if(angular.isDefined(dataExistsCombinationFld.validation.dataExistConstraints.modelPath) && angular.isString(dataExistsCombinationFld.validation.dataExistConstraints.modelPath)
                        && dataExistsCombinationFld.validation.dataExistConstraints.modelPath.length > 0) {
                        api.getModel(dataExistsCombinationFld.validation.dataExistConstraints.modelPath).methods.getList( { forceFetch: true, isLogRequired: false } ).then(function(response) {
                            existConstraintsData = response.data;
                        });
                    }
                }
            }
        }

        function getVisibleFields(model) {
            return $filter('filterUnion')(model.fields, vm.filterExpression);
        }

        function getFilteredCriteriaValues(records, field) {
            var results = [];
            angular.forEach(records, function(record) {
                // size scales carry their conditions in Criteria, color palettes in ColorCriteria
                var criteria = field.field === 'SizeScaleId' ? record.Criteria : record.ColorCriteria;
                // conditions inside one criteria are AND'ed, several criteria on the same record are OR'ed
                var match = utility.matchesColorCriteria(utility.normalizeColorCriteria(criteria), getCriteriaRecordValue);
                if(match.isMatch) {
                    flagCriteriaDeptAttributes(match.matchedAttributes);
                    results.push(record);
                }
            });
            return results;
        }

        function getCriteriaRecordValue(attributeSystemName) {
            return vm.record[attributeSystemName];
        }

        // mark the attributes the matched criteria depends on, so changing one clears the dependent selection
        function flagCriteriaDeptAttributes(attributeSystemNames) {
            angular.forEach(attributeSystemNames, function(attributeSystemName) {
                var criteriaDeptAttributeField = utility.filterObject(vm.visibleFields, {field: attributeSystemName}, true)[0];
                if(angular.isDefined(criteriaDeptAttributeField)) {
                    criteriaDeptAttributeField.isCriteriaDeptAttribute = true;
                }
            });
        }

        function clearSearchTerm(field) {
            vm.searchValue[field] = '';
        };

        // when lookup source attribute changed
        function lookupSourceAttributeChanged(field) {
            var sourceAttributeName = field.field;
            if (vm.lookupSourceAndDeptAttributeMap.hasOwnProperty(sourceAttributeName)) {
                var dependentAttributeNames = vm.lookupSourceAndDeptAttributeMap[sourceAttributeName];
                for (var i = 0; i < dependentAttributeNames.length; i++) {
                    var dependentAttributeName = dependentAttributeNames[i];
                    if (angular.isDefined(validSellerLookupsDestinationAttributesMap[dependentAttributeName])) {
                        var attributeLookupValues = validSellerLookupsDestinationAttributesMap[dependentAttributeName];
                        var matched = false;
                        for (var j = 0; j < attributeLookupValues.length; j++) {
                            var allAttributesMatch = true;
                            var value = attributeLookupValues[j];
                            for (var attributeSystemName in value.Source) {
                                if (value.Source.hasOwnProperty(attributeSystemName)) {
                                    if(vm.record[attributeSystemName] == null || value.Source[attributeSystemName].toString().toLowerCase() !== vm.record[attributeSystemName].toString().toLowerCase()) {
                                        allAttributesMatch = false;
                                        break;
                                    }
                                }
                            }
                            if (allAttributesMatch) {
                                if(vm.record[dependentAttributeName] !== value.Destination[dependentAttributeName]) {
                                    vm.record[dependentAttributeName] = value.Destination[dependentAttributeName];
                                }
                                matched = true;
                                break;
                            }
                        }
                        if (!matched) {
                            vm.record[dependentAttributeName] = null;
                        }
                    }
                }
            }
        }

        function isFormValid() {
            var isRequiredFieldsValid = true;
            // check if any required fields are empty
            angular.forEach(vm.visibleFields, function (field) {
                if (field.validation && field.validation.isRequired && isInputRequired(field)) {
                    if (angular.isUndefined(vm.record[field.field]) || vm.record[field.field] === null || vm.record[field.field] === '') {
                        isRequiredFieldsValid = false;
                    }
                }
            });
            if (vm.dateRangeStartError || vm.dateRangeEndError) {
                return false;
            }
            return vm.editForm.$valid && isRequiredFieldsValid;
        }

        function handleFieldChange(field) {
            // Validate date range order if the model declares a dateRangeValidation config
            if (vm.model.dateRangeValidation) {
                var drv = vm.model.dateRangeValidation;
                if (field.field === drv.startDateField || field.field === drv.endDateField) {
                    vm.dateRangeStartError = false;
                    vm.dateRangeEndError = false;
                    var startDate = vm.record[drv.startDateField];
                    var endDate = vm.record[drv.endDateField];
                    if (startDate && endDate && moment(endDate).isSameOrBefore(startDate, 'day')) {
                        vm.dateRangeStartError = true;
                        vm.dateRangeEndError = true;
                    }
                }
            }

            // Validate tx-pattern
            if (field.validation['tx-pattern'] && vm.currentFocusedField === field.field) {
                vm.validateTxPattern(field);
            }

            // Handle source attribute changes
            if (field.isSourceAttributeForValidation) {
                vm.sourceAttributeForValidationChanged(field);
            }

            // Handle criteria dependent changes
            if (field.isCriteriaDeptAttribute) {
                vm.criteriaDependentCriteriaAttributeChanged(field);
            }

            // Handle lookup source attribute changes
            if (field.isLookupSourceAttribute) {
                vm.lookupSourceAttributeChanged(field);
            }

            if(vm.model.modelPath === 'accounts.sellers') {
                if(vm.record.AutomaticNumbering === 0) {
                    vm.record.CustomNumbering = 0;
                }
            }

            // if this attribute is a dependant attribute of any criteria attribute revalidat the values of criteria attributes
            var dependentAttributeField = field.field;
            if(vm.criteriaDeptAttributeMap[dependentAttributeField]) {
                var criteriaAttributes = vm.criteriaDeptAttributeMap[dependentAttributeField];
                angular.forEach(criteriaAttributes, function(criteriaAttribute) {
                    var criteriaField = utility.filterObject(vm.visibleFields, {field: criteriaAttribute}, true)[0];
                    if (!criteriaField) { return; } // target criteria attribute isn't a field in this dialog -> nothing to refresh/clear
                    var isMultiValueAttribute = (criteriaField.inputType === 'multi-value') ? true : false;
                    // CriteriaV2 (preferred): refresh dropdown + clear current value if not in matched rule's AllowedValues
                    if(vm.criteriaV2Map[criteriaAttribute]) {
                        getConditionalVettingList(criteriaField);
                        var getDependentValueForCriteriaV2 = function(dependentField) {
                            var depVal = vm.record[dependentField];
                            return (depVal && typeof depVal === 'object') ? (angular.isDefined(depVal.value) ? depVal.value : depVal) : depVal;
                        };
                        var criteriaV2AllowedLower = utility.getCriteriaV2AllowedValues(vm.criteriaV2Map[criteriaAttribute], getDependentValueForCriteriaV2)
                            .map(function(value) { return value.toString().toLowerCase(); });
                        var currentCriteriaValue = vm.record[criteriaAttribute];
                        var isCriteriaV2Valid;
                        if (isMultiValueAttribute) {
                            isCriteriaV2Valid = (Array.isArray(currentCriteriaValue) && currentCriteriaValue.length > 0)
                                ? currentCriteriaValue.every(function(value) { return criteriaV2AllowedLower.indexOf((value == null ? '' : value).toString().toLowerCase()) !== -1; })
                                : true;
                        } else {
                            isCriteriaV2Valid = (currentCriteriaValue === null || currentCriteriaValue === undefined || currentCriteriaValue === '')
                                ? true
                                : criteriaV2AllowedLower.indexOf(currentCriteriaValue.toString().toLowerCase()) !== -1;
                        }
                        if (!isCriteriaV2Valid) {
                            vm.record[criteriaAttribute] = isMultiValueAttribute ? [] : null;
                            vm.editForm[criteriaAttribute].$touched = true;
                        }
                        return; // skip OLD criteria path
                    }
                    var attributeCriteria = {};
                    angular.forEach(vm.dependingAttributesMap, function(criteriaAttr) {
                        for(var key in criteriaAttr) {
                            if(criteriaAttr.hasOwnProperty(key)) {
                                if(key.toLocaleLowerCase() === criteriaAttribute.toLowerCase()) {
                                    attributeCriteria = criteriaAttr[key];
                                    break;
                                }
                            }
                        }
                    });
                    if(angular.isDefined(attributeCriteria[dependentAttributeField][vm.record[dependentAttributeField]])) {
                        var index = attributeCriteria[dependentAttributeField][vm.record[dependentAttributeField]].indexOf(vm.record[criteriaAttribute]);
                        if (index === -1) {
                            vm.record[criteriaAttribute] = isMultiValueAttribute ? [] : null;
                            vm.editForm[criteriaAttribute].$touched = true;
                        }
                    } else {
                        vm.record[criteriaAttribute] = isMultiValueAttribute ? [] : null;
                        vm.editForm[criteriaAttribute].$touched = true;
                    }
                });
            }
        }

        function onSearchTextChanged() {
            if (!vm.searchPageText) {
                vm.filteredVisibleFields = angular.copy(vm.visibleFields);
                    return;
            }

            vm.filteredVisibleFields = vm.visibleFields.filter(function(item) {
                    if (!item || !item.displayLabel) return false;

                    var translatedLabel = $translate.instant(item.displayLabel);
                    return translatedLabel.toLowerCase().indexOf(vm.searchPageText.toLowerCase()) !== -1;
            });
        }
    }
})();
(function () {
    'use strict';
    
    angular
        .module('app.uploadsTracker', []);

})();
(function() {
'use strict';

    angular
        .module('app.uploadsTracker')
        .factory('uploadsTracker', uploadsTracker);

    /** @ngInject */
    function uploadsTracker($q, $interval, $mdSidenav) {
        
        /*
            Upload Status:
            0   = New
            10  = In progress
            90  = Completed Successfully
            95  = Completed with Warnings
            99  = Completed with critical errors 
        */
        
        
        var service = {
            addUpload       : addUpload,
            clearCompleted  : clearCompleted,
            uploads         : []
        };
        
        return service;

        ////////////////
        
        /** 
         * Adds an Upload Item that will be tracked by this factory
         * and return the index of the 'upload item' object which contains a promise 
         * that will resolve after completion of the upload
         * @returns {object} uploadItem
         * @param {object} jsFlow Item
         */
        function addUpload(name, flow) {
            $mdSidenav('quick-panel').open();
            flow.uploadIndex = service.uploads.length;
             
            var id = service.uploads.push({
                name: name,
                flow: flow,
                defer: $q.defer(),
                progress: 0,
                status: 0,
                createdOn   : new Date(),
                updatedOn   : new Date(),
                elapsed     : 0
            });
                      
            flow.on('fileSuccess', fileSuccess);

            //Start the timer
            if (angular.isUndefined(service.elapsedTimer)) {
                service.elapsedTimer = $interval(updateElapsed, 500);
            }
            
            flow.upload();
            
            return id-1;
        }
        
        
        function clearCompleted() {
            for (var i = service.uploads.length-1; i>=0;i--){
                if (service.uploads[i].status > 10)
                {
                    service.uploads.splice(i,1);
                }
            }
        }
        
        
        function fileSuccess(file, message, chunk) {
            message = message.replace(/\"/g,"");
            file.fileId = message;
        }
        
        function updateElapsed() {
            var updateCount = 0;
            
            angular.forEach(service.uploads, function(item) {   
                if (item.status < 90) {
                    item.elapsed = (new Date()) - item.createdOn;
                    updateCount++;
                    
                    item.progress = item.flow.progress();
                    if (item.flow.isUploading()) {
                        item.status = 10;
                    } else {
                        var failedFiles = 0;
                        for (var i=0; i<item.flow.files.length-1;i++) {
                            if (item.flow.files[i].error) {
                                failedFiles++; 
                            }
                        }
                        
                        if (failedFiles == item.flow.files.length) {
                            item.status = 99;
                        } else if(failedFiles == 0) {
                            item.status = 90;
                        } else {
                            item.status = 95;
                        }
                    }
                    
                    if (item.status == 90) {
                        item.defer.resolve();
                    } else if (item.status > 90) {
                        item.defer.reject();
                    }
                }
            });
            
            if (updateCount == 0) {
                //No more jobs needs updating, stop the interval
                if (angular.isDefined(service.elapsedTimer)) {
                    $interval.cancel(service.elapsedTimer);
                    service.elapsedTimer = undefined;
                }
            }
        }
    }
})();
(function ()
{
    'use strict';

    /**
     * Main module
     */
    angular
        .module('fuse', [

            // Core
            'app.core',

            'satellizer',
            'ngStorage',
            'ngFileSaver',
            'ui.tree',
            'as.sortable',
            'flow',
            'cfp.hotkeys',
            'infinite-scroll',
            'nvd3',
            'ngIdle',
            angularDragula(angular),

            // Navigation
            'app.navigation',

            // Toolbar
            'app.toolbar',

            // Quick panel
            'app.quick-panel',

            // Main
            'app.alertDialog',
            'app.errorDialog',
            'app.viewCreator',
            'app.attributeGroupSelector',
            'app.toast',
            'app.dialog',
            'app.dataImporter',
            'app.dataExporter',
            'app.jobsTracker',
            'app.uploadsTracker',
            'app.bulkUpdater',
            'app.main',
            'ngQuill',
            'angular-jwt'
        ]).config(function(treeConfig) {
            treeConfig.defaultCollapsed = true;
        });
})();
(function() {
'use strict';

	angular
		.module('fuse')
		.factory('toast', toast);

	/** @ngInject */
	function toast($mdToast, $document, $translate, $mdDialog) {

		//data
        var delay = 5000,
            position = 'top right';

		//methods
		var service = {
			show	:	show,
			success	:	success,
			error	:	error
		};

		return service;

		////////////////

		/**
		 * toast.show to show material built in toast
		 * @params
		 * message			:	translated message to display
		 * additionalMessage:	additional message like user info
		 */
		function show(message, prefixMessage, postfixMessage) {
			var displayMessage = '';
			$translate(message)
			.then(function (translatedMsg) {
				displayMessage = getMessage(prefixMessage, translatedMsg, postfixMessage);
				$mdToast.show( $mdToast.simple()
				.content(displayMessage)
				.position(position)
				.hideDelay(delay)
				);
			}).catch(function(){
				displayMessage = getMessage(prefixMessage, message, postfixMessage);
				$mdToast.show( $mdToast.simple()
				.content(displayMessage)
				.position(position)
				.hideDelay(delay)
				);
			});
		}

		/**
		 * toast.success, a method to display customized toast message for successful operations
		 *  @params
		 * message			:	translated message to display
		 * additionalMessage:	additional message like user info
		 */
		function success(message, prefixMessage,  postfixMessage) {
			$translate(message).then(function(translatedMsg){
				showToast('success', translatedMsg, prefixMessage, postfixMessage);
			}).catch(function(){
				showToast('success', message, prefixMessage, postfixMessage);
			});
		}

		/**
		 * toast.error, a method to display customized toast message for failure operations
		 * @params
		 * message			:	translated message to display
		 * additionalMessage:	additional message like user info
		 */
		function error(message, prefixMessage, postfixMessage, errorObj) {
            var p;

			$translate(message).then(function(translatedMsg){
				p = showToast('error', translatedMsg, prefixMessage, postfixMessage);
			}).catch(function(){
				p = showToast('error', message, prefixMessage, postfixMessage);
			}).finally(function(){
                p.then(function (action) {
                    if (action === 'details')
                    {
                        var parentEl = angular.element($document[0].body);
                        $mdDialog.show({
                            parent: parentEl,
                            targetEvent: null,
                            templateUrl: 'app/services/toast/error-details.html',
                            locals: {
                                errorObj: errorObj
                            },
                            controller: DialogController,
                            controllerAs: 'vm'
                        });
                    }
                });
            });
		}

		function DialogController($scope, $mdDialog, $translate, errorObj) {
			var vm = this;
			vm.errorObj = errorObj;
			vm.errorTxt = angular.toJson(errorObj, true);
			vm.closeDialog = function() {
				$mdDialog.hide();
			}
		}

		function showToast(type, message, prefixMessage,  postfixMessage) {
			var displayMessage = getMessage(prefixMessage, message, postfixMessage);
			var template = '';
			if(type === 'success'){
				template = 'app/services/toast/success.html';
			}else if(type === 'error') {
				template = 'app/services/toast/error.html';
			}
			return $mdToast.show({
				controller: 'toastController',
				controllerAs: 'vm',
				templateUrl: template,
				hideDelay: delay,
				position: position,
                parent   : '#content',
				locals: {
					toastLocal: displayMessage
					}
			});
		}

		function getMessage(prefixMessage, message, postfixMessage) {
			var msg = message;
			if(angular.isDefined(prefixMessage)) {
				msg = prefixMessage.concat(' ',msg);
			}
			if(angular.isDefined(postfixMessage)) {
				msg = msg.concat(' ',postfixMessage);
			}
			return msg;
		}

	}
})();
(function ()
{
    'use strict';

    angular
        .module('app.toast', []);
})();

(function ()
{
    'use strict';

    angular
        .module('app.toast')
        .controller('toastController', toastController);

    /** @ngInject */
    function toastController($mdToast, toastLocal){
        /* jshint validthis: true */
        var vm = this;
        vm.toastMessage = toastLocal;
        
        vm.closeToast = closeToast;


        function closeToast(action) {
            $mdToast.hide(action);
        }
    }

})();



(function ()
{
    'use strict';

    angular
        .module('app.jobsTracker', []);

})();
(function() {
'use strict';

    angular
        .module('app.jobsTracker')
        .factory('jobsTracker', jobsTracker);

    /** @ngInject */
    function jobsTracker($log, $interval, api, $mdSidenav, $rootScope) {

        /*
            Job Status:
            0   = New
            10  = In progress
            90  = Completed Successfully
            95  = Completed with Warnings
            99  = Completed with critical errors
            100 = Critical Failure, unable to start job
        */

        var service = {
            addJob          : addJob,
            trackJob        : trackJob,
            clearCompleted  : clearCompleted,
            getJobDetails   : getJobDetails,
            setCriticlaFail : setCriticlaFail,
            setCompleted    : setCompleted,
            jobs            : [],
            elapsedTimer    : undefined
        };

        return service;

        ////////////////


        /**
         * Adds a Job that will be tracked
         * @returns {number} The Id of the created job or -1 if error
         * @param {string} model The Model Path related to the job
         * @param {string} name A translatable string that describes the job
         * @param {number} jobType The type of the background job (1=JSON, 2=Images&Resources, 3=Consolidation, 4=Packages)
         * @param {object} secondaryModel used in scenarios where 2 model invove in background jobs and both need to be mark dirty(import order)
         */
        function addJob(model, name, jobType, secondaryModel) {
            $mdSidenav('quick-panel').open();

            var id = service.jobs.push(
                {
                    serverId    : undefined,
                    model       : model,
                    secondaryModel: secondaryModel,
                    name        : name,
                    jobType     : jobType,
                    status      : 0,
                    createdOn   : new Date(),
                    updatedOn   : new Date(),
                    elapsed     : 0,
                    lastPolled  : undefined,
                    result      : '',
                    promise     : undefined
                }
            );

            //Start the timer
            if (angular.isUndefined(service.elapsedTimer)) {
                service.elapsedTimer = $interval(updateElapsed, 500);
            }
            return id-1;
        }

        /**
         * Begins tracking a job progress using the serverId passed
         * @param {number} index The index of the job
         * @param {number} serverId The ID of the background job used by the API
         */
        function trackJob(index, serverId) {
            if (index < 0 || index >= service.jobs.length) {
                $log.warn('jobsTracker: trackJob(): The Id [' + index + '] is not a valid Job Index!');
                return;
            }

            service.jobs[index].serverId = serverId;
            service.jobs[index].status = 10;
            service.jobs[index].promise = $interval(function () { pollJob(index) }, 5000);

        }

        /**
         * Deletes all the completed jobs from the Job Tracker
         */
        function clearCompleted() {
            for (var i = service.jobs.length-1; i>=0;i--){
                if (service.jobs[i].status > 10)
                {
                    service.jobs.splice(i,1);
                }
            }
        }

        /**
         * Polls the server for the status of the Job
         * @param {number} index The index of the Job
         */
        function pollJob(index) {
            if (index < 0 || index >= service.jobs.length) {
                $log.warn('jobsTracker: pollJob(): The Id [' + index + '] is not a valid Job Index!');
                return;
            }
            var promise;

            if(service.jobs[index].jobType !== 4 && service.jobs[index].jobType !== 5) {// track everything other than packages
                promise = api.webPost(api.baseUrl + '/backgroundjob/' + service.jobs[index].serverId, { JobTypeId: service.jobs[index].jobType });
            }
            else if(service.jobs[index].jobType === 4) { //track packages
                promise = api.webGet(api.baseUrl + '/backgroundjobs/packages/' + service.jobs[index].serverId);
            }

            promise.then(function(response){
                    var switchVar;
                    var newStatus;
                    if(service.jobs[index].jobType !== 4 && service.jobs[index].jobType !== 5) {
                        switchVar = response.data;
                    }
                    else if(service.jobs[index].jobType === 4){
                        switchVar = response.data.PackageStatus;
                    }
                    else if(service.jobs[index].jobType === 5) {
                        switchVar = response.data.Status;
                    }
                    switch (switchVar) {
                        case 'NEW':
                            newStatus = 10;
                            break;
                        case 'INPROCESS':
                            newStatus = 10;
                            break;
                        case 'INPROGRESS':
                            newStatus = 10;
                            break;
                        case 'COMPLETE':
                            newStatus = 90;
                            break;
                        case 'COMPLETE WITH OUT CHANGES':
                            newStatus = 95;
                            break;
                        case 'FAIL':
                            newStatus = 99;
                            break;
                        default:
                            $log.warn('jobsTracker: pollJob(): Invalid API response: ' + response.data);
                    }

                    service.jobs[index].lastPolled = new Date();

                    if (newStatus != service.jobs[index].status) {
                        service.jobs[index].updatedOn = new Date();
                        service.jobs[index].status = newStatus;
                    }

                    if (service.jobs[index].status > 10) {
                        // if completed successfully set isBulkActionCompleted to true
                        if(service.jobs[index].status === 90) {
                            service.jobs[index].model.isBulkActionCompleted = true;
                            service.jobs[index].model.isDirty = true;
                            if(angular.isDefined(service.jobs[index].model.baseModel)) {
                                service.jobs[index].model.baseModel.isDirty = true;
                            }
                            // for all the import actions where 2 model are involved- like import orders to mark secondary model dirty as well
                            if(angular.isDefined(service.jobs[index].secondaryModel) && !angular.isArray(service.jobs[index].secondaryModel)) {
                                service.jobs[index].secondaryModel.isBulkActionCompleted = true;
                                service.jobs[index].secondaryModel.isDirty = true;
                                if(angular.isDefined(service.jobs[index].secondaryModel.baseModel)) {
                                    // since secondary model can be dynamic but at time of import it could be the base model that is beeing passed -not required for primary model
                                    service.jobs[index].secondaryModel.baseModel.isBulkActionCompleted = true;
                                    service.jobs[index].secondaryModel.baseModel.isDirty = true;
                                }
                            } else if(angular.isDefined(service.jobs[index].secondaryModel) && angular.isArray(service.jobs[index].secondaryModel)) {
                                //specific to articles module, when creating bulk articles make pricesModel, segmentationModel, crdsModel, stocksModel dirty to get updated data in all the module
                                angular.forEach(service.jobs[index].secondaryModel, function(model) {
                                    model.isBulkActionCompleted = true;
                                    model.isDirty = true;
                                    if(angular.isDefined(model.baseModel)) {
                                        model.baseModel.isBulkActionCompleted = true;
                                        model.baseModel.isDirty = true;
                                    }
                                })
                            }
                        }
                        $rootScope.$emit('jobCompletedEvent');
                        // Stop tracking
                        $interval.cancel(service.jobs[index].promise);
                    }
                });
        }

        /**
         * Retrieves the details of the background job
         * @param {number} index The index of the job
         */
        function getJobDetails(index) {
            if (index < 0 || index >= service.jobs.length) {
                $log.warn('jobsTracker: getJobDetails(): The Id [' + index + '] is not a valid Job Index!');
                return;
            }
            var jobUrl = api.baseURL + '/backgroundjob/';

            switch (service.jobs[index].jobType)
            {
                case 1:
                    jobUrl += 'json/';
                    break;
                case 2:
                    jobUrl += 'images/';
                    break;
                case 3:
                    jobUrl += 'consolidations/';
                    break;
                case 4:
                    jobUrl += 'packages/';
                    break;
                default:
                    $log.warn('jobsTracker: getJobDetails(): Invalid Job Type');
            }

            return api.webGet(jobUrl + service.jobs[index].serverId).then(function(response) {
                service.jobs[index].result = response.data;
            });
        }


        /**
         * Updates the elapsed time for each running job
         */
        function updateElapsed() {
            var updateCount = 0;

            angular.forEach(service.jobs, function(job) {
                if (job.status < 90) {
                    job.elapsed = (new Date()) - job.createdOn;
                    updateCount++;
                }
            });

            if (updateCount == 0) {
                //No more jobs needs updating, stop the interval
                if (angular.isDefined(service.elapsedTimer)) {
                    $interval.cancel(service.elapsedTimer);
                    service.elapsedTimer = undefined;
                }
            }
        }

        /**
         * Marks the job as a Critical Failure
         */
        function setCriticlaFail(index, result) {
            service.jobs[index].status = 100;
            service.jobs[index].result = result;
        }

        /**
         * Marks a job as completed successfully
         */
        function setCompleted(index, result) {
            service.jobs[index].model.isBulkActionCompleted = true;
            service.jobs[index].model.isDirty = true;
            if(angular.isDefined(service.jobs[index].model.baseModel)) {
                service.jobs[index].model.baseModel.isDirty = true;
            }
            // for all the import actions where 2 model are involved- like import orders to mark secondary model dirty as well
            if(angular.isDefined(service.jobs[index].secondaryModel)) {
                service.jobs[index].secondaryModel.isBulkActionCompleted = true;
                service.jobs[index].secondaryModel.isDirty = true;
                if(angular.isDefined(service.jobs[index].secondaryModel.baseModel)) {
                    // since secondary model can be dynamic but at time of import it could be the base model that is beeing passed -not required for primary model
                    service.jobs[index].secondaryModel.baseModel.isBulkActionCompleted = true;
                }
            }
            service.jobs[index].status = 90;
            service.jobs[index].result = result;
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.errorDialog', []);
})();
(function () {
  'use strict';

  angular.module('app.errorDialog')
    .factory('errorDialog', errorDialog);

  /** @ngInject */
  function errorDialog($mdDialog, $document) {

    //Methods
    var service = {
      show: show,
      showDetailsDialog: showDetailsDialog
    };

    return service;

    function show(message, errorObj, privilege, isArticleStateRequiredAttributesMessage) {
      return $mdDialog.show({
        parent: angular.element($document[0].body),
        controller: 'errorDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/services/errorDialog/errorDialog.html',
        clickOutsideToClose: false,
        targetEvent: null,
        locals: {
          message: message,
          errorObj: errorObj,
          privilege: privilege,
          isArticleStateRequiredAttributesMessage: isArticleStateRequiredAttributesMessage
        },
      });
    }

    function showDetailsDialog(errorObj) {
      $mdDialog.show({
        parent: angular.element($document[0].body),
        controller: DialogController,
        controllerAs: 'vm',
        targetEvent: null,
        templateUrl: 'app/services/toast/error-details.html',
        locals: {
          errorObj: errorObj
        }
      });
    }

    function DialogController($mdDialog, errorObj) {
      var vm = this;
      vm.errorObj = errorObj;
      vm.errorTxt = angular.toJson(errorObj, true);
      vm.closeDialog = function () {
        $mdDialog.hide();
      }
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.errorDialog')
    .controller('errorDialogController', errorDialogController);

  /** @ngInject */
  function errorDialogController($mdDialog, errorObj, message, privilege, isArticleStateRequiredAttributesMessage, utility) {
    /* jshint validthis: true */
    var vm = this;

    //Data
    vm.errObj = errorObj;
    vm.message = message;
    vm.showDetailsButton = angular.isDefined(vm.errObj) ? true : false;
    vm.showPrivilege = (angular.isDefined(privilege) && !utility.isObjectEmpty(privilege)) ? true : false;
    vm.privilege = privilege;
    vm.isArticleStateRequiredAttributesMessage = (angular.isDefined(isArticleStateRequiredAttributesMessage) && isArticleStateRequiredAttributesMessage) ? true : false;

    //Methods
    vm.showDetails = showDetails;
    vm.closeDialog = closeDialog;

    //Methods Implementation

    function showDetails() {
      closeDialog(true);
    }

    function closeDialog(showDetails) {
      $mdDialog.hide(showDetails);
    }
  }

})();

(function () {
    'use strict';
    
    angular
        .module('app.dialog', []);
})();

(function() {
    'use strict';

    angular.module('app.dialog')
    .factory('dialog',dialog);

    /** @ngInject */
	function dialog($mdDialog, $document) {

        //Data
		var dialogObj = {
                controller         : 'dialogController',
                controllerAs       : 'vm',
                templateUrl        : '',
                parent             : angular.element($document.body),
                targetEvent        : null,
                clickOutsideToClose: true,
                locals             : {

                }
            };
		//Methods
		var service = {
			confirm             : confirm,
            changePassword      : changePassword,
            showAlertDialog     : showAlertDialog
		};

		return service;


        //Methods implementation
        function confirm(content , action, items, model, actionObject, event) {
            var message = (angular.isDefined(content) && angular.isDefined(content.message) && content.message !== '') ? content.message : 'Are you sure you want to perform the action?';
            var title = (angular.isDefined(content) && angular.isDefined(content.title) && content.title !== '') ? content.title : 'Alert';
            var isMultiple = (angular.isDefined(content) && angular.isDefined(content.isMultiple)) ? content.isMultiple : false;
            var template = 'app/services/dialog/confirm-dialog.html';
            dialogObj.targetEvent= event ? event : null;
            dialogObj.templateUrl = template;
            dialogObj.locals['title'] = title;
            dialogObj.locals['message'] = message;
            dialogObj.locals['action'] = action;
            dialogObj.locals['items'] = items;
            dialogObj.locals['model'] = model;
            dialogObj.locals['actionObject'] = actionObject;
            dialogObj.multiple = isMultiple; // to make the parent dialoag active when closing the popup(do not remove it)
            return $mdDialog.show(dialogObj);
        }

        function changePassword() {
            var template = 'app/services/dialog/change-password.html';

            dialogObj.templateUrl = template;
            dialogObj.locals['title'] = '';
            dialogObj.locals['message'] = '';
            dialogObj.locals['action'] = null;
            dialogObj.locals['items'] = null;
            dialogObj.locals['model'] = undefined;
            dialogObj.locals['actionObject'] = undefined;
            return $mdDialog.show(dialogObj);
        }

        function showAlertDialog(parent, title, message, ariaLabel, actionLabel, isMultipleDialog, targetEvent) {
            $mdDialog.show(
                $mdDialog.alert()
                    .parent(parent)
                    .clickOutsideToClose(false)
                    .title(title)
                    .textContent(message)
                    .ariaLabel(ariaLabel)
                    .ok(actionLabel)
                    .multiple(isMultipleDialog)
                    .targetEvent(targetEvent)
            );
        }
    }
})();
(function(){
    'use strict';

    angular
        .module('app.dialog')
        .controller('dialogController',dialogController);

    /** @ngInject */
    function dialogController($mdDialog, title, message, action, items){
        /* jshint validthis: true */
        var vm = this;

        //Data
        vm.title = title;
        vm.message = message;
        vm.action = action;
        vm.items = [];
        vm.record = {};
        vm.AllowExternalChangeManagement = false;
        vm.checkingForLockedArticles = false;

        //Methods
        vm.cancel = cancel;
        vm.closeDialog = closeDialog;
        vm.changePassword = changePassword;

        // no more listing affected items
        // if(angular.isDefined(model)) {
        //     vm.model = model;
        //     // following code only used for confirm dialog
        //     var lookupDisplayField = utility.filterObject(vm.model.fields, {field: vm.model.lookupDisplayField}, true)[0];
        //     if(angular.isDefined(lookupDisplayField) && angular.isDefined(lookupDisplayField.inputType)) {
        //         vm.isDate = lookupDisplayField.inputType.toLowerCase() === 'date' ? true : false;
        //     }
        // }

        if(angular.isDefined(items)) {
            if(angular.isArray(items)) {
                vm.items = items;
            }
            else {
                vm.items.push(items);
            }
        }

        //Methods Implementation

        function cancel() {
           $mdDialog.cancel();
        }

        function closeDialog(confirmation) {
            vm.record.userAction = confirmation;
            $mdDialog.hide(vm.record);
        }

        function changePassword(record) {
            $mdDialog.hide(record);
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.dataImporter', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider)
    {
        $translatePartialLoaderProvider.addPart('app/services/dataImporter');
    }

})();
(function () {
    'use strict';
    angular
        .module('app.dataImporter')
        .directive('txFileRead', txFileRead);

    /** @ngInject */
    function txFileRead() {
        var directive = {
            require: 'ngModel',
            link: linkFunc,
            scope: {
                fileread: "=txFileRead"
            }
        };

        return directive;

        function linkFunc(scope, elem, attr, ngModel) {
            elem.bind('change', function (changeEvent) {
                if (!changeEvent.target.files || changeEvent.target.files.length == 0)
                {
                    return;
                }
                var reader = new FileReader();
                scope.$apply(function () {
                    scope.fileread.loaded = false;
                    scope.fileread.loading = true;
                    scope.fileread.fileName = changeEvent.target.files[0].name;
                });
                reader.onload = function (loadEvent) {
                    scope.$apply(function () {
                        scope.fileread.data = loadEvent.target.result;
                        try {
                            // Use Uint8Array (from ArrayBuffer) so SheetJS processes the file as a
                            // typed array rather than a JS binary string. Binary strings are stored as
                            // UTF-16 in V8, costing 2 bytes per character — doubling heap usage for
                            // the raw file bytes. Typed arrays use 1 byte per byte, cutting the
                            // initial memory footprint in half for large files.
                            //
                            // sheetRows: 1 — parse only the header row at upload time.
                            // For large files (300+ MB), parsing all rows upfront simultaneously
                            // decompresses the sheet XML (~1-2 GB) AND allocates cell objects
                            // (~1.3 GB for 8.7 M cells), exceeding the browser tab memory limit.
                            // Parsing just row 0 keeps the upload footprint near-zero.
                            // The full re-parse is deferred to validation time in validateData()
                            // (dataImporter.controller.js), where the header-only workBook is freed
                            // first so the GC can reclaim memory before the full allocation.
                            scope.fileread.workBook = XLSX.read(new Uint8Array(scope.fileread.data), {
                                type: 'array',
                                sheetRows: 1,       // header row only — data rows parsed at validation
                                cellFormula: false, // formula strings not used in import
                                cellHTML: false,    // HTML representation not used in import
                                cellNF: false,      // raw number-format strings not used in import
                                cellStyles: false   // cell style objects not used in import
                            });
                            scope.fileread.needsFullReparse = true; // signal validateData to re-parse

                            // SheetJS's safe_parse_sheet silently catches all sheet-parsing exceptions
                            // (e.g. OOM on very large files), leaving Sheets[name] as undefined while
                            // SheetNames is still populated. Detect this and surface a clear error
                            // instead of letting it crash later when the user proceeds to column mapping.
                            var wb = scope.fileread.workBook;
                            var hasUnparsedSheet = wb.SheetNames.some(function(name) {
                                return wb.Sheets[name] === undefined;
                            });
                            if (hasUnparsedSheet) {
                                throw new Error('The file could not be fully parsed. It may be too large to import in the browser.');
                            }

                            scope.fileread.loaded = true;
                            scope.fileread.hasError = false;
                        } catch (err) {
                            changeEvent.target.value = "";
                            scope.fileread.hasError = true;
                            scope.fileread.error = err.message;
                        }

                        scope.fileread.loading = false;
                        ngModel.$setViewValue(elem.val());
                        ngModel.$render();
                    });
                }
                // readAsArrayBuffer gives a Uint8Array-compatible ArrayBuffer.
                // readAsBinaryString (the previous approach) would create a JS string stored
                // as UTF-16, using 2× the file size in heap — bad for large xlsx files.
                reader.readAsArrayBuffer(changeEvent.target.files[0]);
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.main.catalogs.orders')
        .run(runBlock);

    /* @ngInject */
    function runBlock(api) {

        if(angular.isUndefined(api.orders)) {
            api.orders = {};
        }
        api.orders.invalidArticleStocks = {
            modelPath: 'orders.invalidArticleStocks',
            fields: [
                { field: 'ArticleNumber', type: 'text', displayLabel: 'INVALID_ARTICLE_STOCKS.FIELDS.ARTICLE_NUMBER', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Size', type: 'text', displayLabel: 'INVALID_ARTICLE_STOCKS.FIELDS.SIZE', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Quantity', type: 'int', displayLabel: 'INVALID_ARTICLE_STOCKS.FIELDS.QUANTITY', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Status', type: 'text', displayLabel: 'INVALID_ARTICLE_STOCKS.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
            ],
            uniqueConstraints: [],
            title: 'INVALID_ARTICLE_STOCKS.NAV',
            icon: 'icon-cart-outline',
            idField: 'ArticleNumber',
            lookupDisplayField: 'Size',
            isDirty: false,
            isBulkActionCompleted: false,
            isCatalogSpecificModel: true,
            methods: {},
            views: {
                mainList: {
                    columns             : [ 'ArticleNumber', 'Size', 'Quantity', 'Status'],
                    columnFilter        : {},
                    toggleFilterProps   : {},
                    topIndex            : 0,
                    showFilterRow       : false,
                    sortColumn          : {},
                    itemActions         : [],
                    listActions         : [],
                    processOrdersItemActions: [],
                    processOrdersListActions: [],
                    fabAction           : {}
                },
                mainDetails: {},
                privileges: {}
            }

        };

    }
})();
(function() {
    'use strict';

    angular.module('app.dataImporter')
    .factory('dataImporter',dataImporter);

    /** @ngInject */
	function dataImporter($mdDialog) {

        //Data
		var dialogObj = {
                controller         : 'dataImporterController',
                controllerAs       : 'vm',
                templateUrl        : '',
                parent             : angular.element(document.body),
                targetEvent        : null,
                clickOutsideToClose: false,
                fullscreen         : false,
                closeTo            : '#quick-panel-toggle',
                locals             : {

                }
            };

		//Methods
		var service = {
            importExcel           : importExcel,
            lastSheet             : undefined
		};

		return service;

        function importExcel(targetModel, isCreate, additionalInfo, action, listData) {
            var template = 'app/services/dataImporter/dataImporter.html';

            dialogObj.templateUrl = template;
            dialogObj.locals['title'] = '';
            dialogObj.locals['message'] = '';
            dialogObj.locals['action'] = action;
            dialogObj.locals['items'] = null;
            dialogObj.locals['targetModel'] = targetModel;
            dialogObj.locals['isCreate'] = isCreate;
            dialogObj.locals['additionalInfo'] = additionalInfo;
            dialogObj.locals['listData'] = listData;
            return $mdDialog.show(dialogObj);
        }
    }
})();





(function(){
    'use strict';

    angular.module('app.dataImporter')
    .controller('dataImporterController',dataImporterController);

    /** @ngInject */
    function dataImporterController(utility, $mdDialog, $q, $timeout, $filter, dataImporter, FileSaver, Blob, api, title, message, $translate,
                                    action, items, targetModel, isCreate, additionalInfo, listData, $scope, $localStorage, catalogFactory, SecurityFactory, CONSTANTS, articlesFactory, orderlineDialog) {
        /* jshint validthis: true */
        var vm = this;

        //Data
        vm.title = title;
        vm.message = message;
        vm.action = action;
        vm.items = [];
        vm.record = {};
        vm.fileData = {
            fileName: "",
            loaded: false
        };
        vm.fileResultsData = {
            fileName: "",
            loaded: false
        };
        //specific for articles module(import articles by model number)
        vm.isUpdateArticlesByModel = (angular.isDefined(additionalInfo) && angular.isDefined(additionalInfo.isUpdateArticlesByModel) && additionalInfo.isUpdateArticlesByModel === true);
        vm.isUpdateArticleSegmentationByModel = (angular.isDefined(additionalInfo) && angular.isDefined(additionalInfo.isUpdateArticleSegmentationByModel) && additionalInfo.isUpdateArticleSegmentationByModel === true);
        vm.reason = undefined;
        vm.skipInvalidRecords = false;
        vm.stepper = {
            onStepChange : onStepChange
        };
        vm.sheetFilterOpt = {
            state: 0,
            include: 0,
            column: undefined,
            contains: 0,
            specificValue: '',
            columnName: ''
        };
        var articleStatusColumFieldMap = {};
        // specific to orders module. show stocks dropdown based on selected customer
        vm.validateCustomerAssignedStocks = (angular.isDefined(additionalInfo) && angular.isDefined(additionalInfo.validateCustomerAssignedStocks) && additionalInfo.validateCustomerAssignedStocks === true);
        vm.stockDefinitionId = undefined;
        vm.searchStockText = {};
        vm.customerStocks = [];
        vm.stocks = [];
        vm.invalidArticleStocks = [];
        vm.articleIdNumberMap = {};
        vm.isLoading = false;
        vm.validateArticleLocking = (angular.isDefined(additionalInfo) && angular.isDefined(additionalInfo.validateArticleLocking) && additionalInfo.validateArticleLocking === true);
        vm.currentStep = 0;

        var timeoutPromise;

        vm.columns = [];// [{c: '', r:'', v:''}] {Column#, Row#, lable}
        vm.mapping = [];
        vm.isModelLevelImport = false;
        vm.onImportModelLevelToggle = onImportModelLevelToggle;
        vm.validationWorking = false; //false = done, true = validating
        vm.validationProgress = 0;
        vm.validationError = ''; //set when validation aborts on an unexpected error
        vm.totalValid = 0;
        vm.totalInvalid = 0;
        vm.totalSkipped = 0;
        vm.resultsLoading = false;
        vm.lookupData = {};
        vm.data = [];
        vm.acSearchText = {};
        vm.acModel = {};
        vm.isValidExcel = 1;
        vm.isArticleCountWithinLimit = true;
        var existConstraintsData = {};

        vm.dependingAttributesMap = [];
        vm.criteriaV2Map = {}; // AttributeSystemName -> parsed CriteriaV2 rules array (preferred over OLD Criteria)
        var catalogAttributes = catalogFactory.getActiveCatalogDetails().AssignedCatalogAttributes;
        var dataSourceTypeId = catalogFactory.getActiveCatalogDetails().DataSourceTypeId;
        var activeCatalogShipmentWindowRangeList = catalogFactory.getActiveCatalogDetails().ShipmentWindowRangeList;

        var lookupPromisesMap = {};
        var existConstraintsPromisesMap = {};
        var promises = {};
        var catalogImportMappings;
        var importMappings = undefined;
        var haveDataExistConstraints = false;

        vm.isTrasixUser = ($localStorage.account && $localStorage.account.accountType === '1') ? true : false;
        if(vm.isTrasixUser && vm.showReasonPage) {
            vm.skipChangeApproval = 0;
        }
        vm.nonEditableAttributesArticleStateLevel = [];
        vm.nonEditableAttributesModelStateLevel = [];
        // check the special privilege is assigned to the user for updating the state. if then does not vaidate editable fields
        var isSpecialPermissionToIgnoreArticleStateIsAssigned = SecurityFactory.isAuthorized({accessPrivileges: CONSTANTS.PRIVILEGES.ARTICLES.SPECIAL_PRIVILEGE_TO_SKIP_STATE_VALIDATION});
        var validSellerLookupsDestinationAttributesMap = api.validSellerLookupsDestinationAttributesMap;
        var attributesWithDefaultValue = []
        var articlesMap = {};

        //Methods
        vm.cancel = cancel;
        vm.closeDialog = closeDialog;
        vm.updateMappingValidation = updateMappingValidation;
        vm.saveResult = saveResult;
        vm.submitStepper = submitStepper;
        vm.acSearchColumns = acSearchColumns;
        vm.acChangeEvent = acChangeEvent;
        vm.acSelectText = acSelectText;
        vm.isInputRequired = isInputRequired;
        vm.skipInvalidRows = skipInvalidRows;
        vm.areAllRequiredColumnsMapped = areAllRequiredColumnsMapped;
        vm.onFilterColumnChange = onFilterColumnChange;
        vm.onSearchTextChanged = onSearchTextChanged;

        // stocks reated
        vm.stocksLookupSearch = stocksLookupSearch;
        vm.getStockLookupDisplayValue = getStockLookupDisplayValue;
        vm.lookupChange = lookupChange;


        activate();


        //Methods Implementation

        function activate() {
            if (angular.isUndefined(dataImporter.lastSheet)) {
                vm.lastSheetExists = false;
                vm.fileOpt = "1";
            } else {
                vm.lastSheetExists = true;
                vm.fileOpt = "0";
            }

            if (angular.isDefined(targetModel)) {
                vm.targetModel = angular.copy(targetModel);
                if (angular.isArray(targetModel.fields) && angular.isArray(vm.targetModel.fields)) {
                    for (var fi = 0; fi < targetModel.fields.length; fi++) {
                        var origField = targetModel.fields[fi];
                        var copyField = vm.targetModel.fields[fi];
                        var origPromise = origField && origField.validation
                            && origField.validation.dataExistConstraints
                            && origField.validation.dataExistConstraints.promise;
                        if (origPromise && copyField && copyField.validation
                            && copyField.validation.dataExistConstraints) {
                            copyField.validation.dataExistConstraints.promise = origPromise;
                        }
                    }
                }
            }

            //load model fields
            var modelFields = vm.targetModel.fields;
            for (var i = 0; i < modelFields.length; i++) {
                if ((isCreate && (modelFields[i].creatable || modelFields[i].importable)) || (!isCreate && modelFields[i].editable)) {
                    vm.mapping.push({
                        field: modelFields[i],
                        column: -1,
                        warn: false
                    });
                }
                // attributes with Default value
                if (angular.isDefined(modelFields[i].DefaultValue) && modelFields[i].DefaultValue != null && modelFields[i].DefaultValue !== '') {
                    attributesWithDefaultValue.push(modelFields[i])
                }
                // identify the attributes with tx-pattern added for validation
                if(angular.isDefined(modelFields[i].validation) && angular.isDefined(modelFields[i].validation['tx-pattern']) && modelFields[i].validation['tx-pattern'].length > 0) {
                    modelFields[i]['isTxPatternAdded'] = true;
                }
            }


            vm.filteredMapping = angular.copy(vm.mapping)

            if (angular.isDefined(items)) {
                if (angular.isArray(items)) {
                    vm.items = items;
                }
                else {
                    vm.items.push(items);
                }
            }

            loadLookupData();
            // dataExistsCombinationConstraints: this is to load the data before validating wether the record exists in DB. This is field is a combination of fields to validate
            if (angular.isDefined(vm.targetModel) && angular.isDefined(vm.targetModel.dataExistsCombinationConstraints)
            && angular.isArray(vm.targetModel.dataExistsCombinationConstraints)
            && vm.targetModel.dataExistsCombinationConstraints.length > 0) {
                var dataExistsCombinationFld = utility.filterObject(vm.targetModel.fields, {field: 'dataExistsCombinationField'}, true)[0];
                if(angular.isDefined(dataExistsCombinationFld)) {
                    haveDataExistConstraints = true;
                    existConstraintsPromisesMap[dataExistsCombinationFld.field] = loadExistConstraints(dataExistsCombinationFld);
                }
            }
            importMappings = getImportMappings();
        }

        function loadLookupData() {
            angular.forEach(vm.mapping, function(mappingObj) {
                if (mappingObj.field.inputType === 'lookup' || mappingObj.field.inputType === 'lookup-many' || mappingObj.field.inputType === 'color-palette' || mappingObj.field.inputType === 'modelnumber') {
                    var lookupKey = mappingObj.field.lookupSource;
                    if (angular.isUndefined(vm.lookupData[lookupKey])) {
                        var lookupModel = api.getModel(lookupKey);
                        if(lookupModel && lookupModel._loadPromise) {
                            lookupPromisesMap[lookupKey] = lookupModel._loadPromise.then(function(result) {
                                vm.lookupData[lookupKey] = result;
                            });
                        } else {
                            lookupPromisesMap[lookupKey] = loadLookup(mappingObj.field.lookupSource, mappingObj.field, lookupKey);
                        }
                    }

                    if (angular.isUndefined(vm.lookupData[lookupKey]) && angular.isUndefined(lookupPromisesMap[lookupKey])) {
                        lookupPromisesMap[lookupKey] = loadLookup(mappingObj.field.lookupSource, mappingObj.field);
                    }
                }
                if(angular.isDefined(mappingObj.field.validation.dataExistConstraints)) {
                    existConstraintsPromisesMap[mappingObj.field.field] = loadExistConstraints(mappingObj.field);
                }
            });
            // load retail windows for validation
            if(targetModel.modelPath === 'catalogs.articles') {
                lookupPromisesMap['ShipmentWindowRange'] = loadLookup('catalogs.retailExitMonthsForArticle');
            }
            promises = angular.extend({}, lookupPromisesMap, existConstraintsPromisesMap);
        }


        // create list of data against which data existance will be validated, return a promise
        function loadExistConstraints(field) {
            if(field.validation.dataExistConstraints && angular.isDefined(field.validation.dataExistConstraints.checkinListData) && field.validation.dataExistConstraints.checkinListData) {
                existConstraintsData[field.field] = listData = listData && listData.length ? listData : []
            }
            else if(angular.isUndefined(existConstraintsData[field.field]) && angular.isUndefined(existConstraintsPromisesMap[field.field])) {
                existConstraintsData[field.field] = [];

                if(angular.isDefined(field.validation.dataExistConstraints.modelPath) && angular.isString(field.validation.dataExistConstraints.modelPath)
                    && field.validation.dataExistConstraints.modelPath.length > 0) {
                    return api.getModel(field.validation.dataExistConstraints.modelPath).methods.getList( { forceFetch: true, isLogRequired: false } ).then(function(response) {
                        existConstraintsData[field.field] = response.data;
                    });
                }

                // for model that does not support lookup can pass data part of data proprty of dataExistConstraints of model
                else if(angular.isDefined(field.validation.dataExistConstraints.data && angular.isArray(field.validation.dataExistConstraints.data))) {
                    existConstraintsData[field.field] = field.validation.dataExistConstraints.data;
                    return $q.when({data: existConstraintsData[field.field]});
                }

                // for model that does not support lookup and needs to call an API before import its recommended to call the API in controller and pass promise object
                else if (angular.isDefined(field.validation.dataExistConstraints.promise) && angular.isObject(field.validation.dataExistConstraints.promise)
                        && angular.isFunction(field.validation.dataExistConstraints.promise.then)) {
                            return $q.when(field.validation.dataExistConstraints.promise).then(function(response) {
                                existConstraintsData[field.field] = response && response.data;
                                return response;
                            });
                }
            }
        }

        function loadLookup(lookupSource, field) {
            vm.lookupData[lookupSource] = [];
            vm.isLoading = true;
            var lookupKey = lookupSource;
            var lookupExtras = {};
            return api.getLookupData(api.getModel(lookupSource), lookupExtras).then(function(result) {
                vm.lookupData[lookupKey] = result;
            }).finally(function () {
                vm.isLoading = false;
            });
        }


        function cancel() {
           $mdDialog.cancel();
        }

        function closeDialog(confirmation) {
            // clean factory data
            // alternative way is to attach data to locals of dialog items{'FileName': [data]} then no need to inject data to model object and following method wont be required
            utility.clearModelExistConstraints(targetModel);
            persistImportMapping();
            var resolvedData = {};
            resolvedData.data = confirmation;
            resolvedData.updateReason = vm.reason;
            resolvedData.skipChangeApproval = vm.skipChangeApproval;
            resolvedData.isModelLevelImport = vm.isModelLevelImport;
            $mdDialog.hide(resolvedData);
        }

        function submitStepper() {
            // assign stock id to first record
            if(vm.validateCustomerAssignedStocks) {
                vm.data[0]['StockDefinitionId'] = vm.stockDefinitionId;
            }
            closeDialog(vm.data);
        }

        function acSearchColumns(columnsList, query) {
            if(angular.isDefined(columnsList) && angular.isArray(columnsList)) {
                return utility.filterObject(columnsList, {v: query});
            }
        }

        function acChangeEvent(selectedItem, mappingItem) {
            if(angular.isObject(selectedItem)) {
                mappingItem.column = selectedItem.c;
                importMappings.columnsMapping[mappingItem.field.field] = selectedItem.v; // cache seleced column
            }
            else if(angular.isUndefined(selectedItem) || selectedItem === null){
                selectedItem = undefined; // on record removal make field undefined or the property can be deleted using delete keywork
                mappingItem.column = -1;
            }

            var originalMappingItem = vm.mapping.filter(function(m) {
                return m.field.field === mappingItem.field.field;
            })[0];

            if (originalMappingItem) {
                originalMappingItem.column = mappingItem.column;
            }
            updateMappingValidation();
        }

        function acSelectText(event) {
            utility.selectInputText(event);
        }

        function isInputRequired(field, model) {
            if(angular.isString(field.validation.isRequired)) {
                return $scope.$eval(field.validation.isRequired, { data: model })
            } else {
                return field.validation.isRequired
            }
        }

        function skipInvalidRows() {
            // Never arm the step when validation aborted part-way: the counters and vm.data only
            // cover the rows processed before the error, so "skip the invalid ones" would submit a
            // silently truncated import.
            if(vm.skipInvalidRecords && !vm.validationError) {
                vm.tempValidation = 'ok';
            } else {
                vm.tempValidation = '';
            }
        }

        // this is to disable next button when user filtered fields using the search and still required coulmns are not mapped
        function areAllRequiredColumnsMapped () {
            if(vm.currentStep === 2) {
                for (var i = 0; i < vm.mapping.length; i++) {
                    var item = vm.mapping[i];
                    if (vm.isInputRequired(item.field, vm.acModel) && !vm.acModel[item.field.field]) {
                        return false;
                    }
                }
                return true;
            } else {
                return true;
            }
        }

        function onFilterColumnChange() {
            if (angular.isDefined(vm.sheetFilterOpt.column)) {
                var selectedColumn = utility.filterObject(vm.columns, {c: vm.sheetFilterOpt.column})[0];
                if(selectedColumn) {
                    vm.sheetFilterOpt.columnName = selectedColumn.v
                }
            }
        }

        // Toggle between Article Number and Model Number mapping for resource imports
        function onImportModelLevelToggle() {
            var isSeller = vm.targetModel.modelPath === 'sellers.mapResourcesToArticles';
            var fromField = vm.isModelLevelImport ? 'ArticleNumber' : 'ModelNumber';
            var toField = vm.isModelLevelImport ? 'ModelNumber' : 'ArticleNumber';
            var toLabel = vm.isModelLevelImport ? 'SELLER_MODELS.FIELDS.MODEL_NUMBER' : 'RESOURCES.FIELDS.ARTICLE_NUMBER';
            var toLookupSource = vm.isModelLevelImport
                ? (isSeller ? 'sellers.sellerModelsLookup' : 'catalogs.models')
                : (isSeller ? 'sellers.sellerArticlesLookup' : 'catalogs.articles');

            // Update the mapping field (preserve column mapping)
            angular.forEach(vm.mapping, function(item) {
                if(item.field.field === fromField) {
                    item.field.field = toField;
                    item.field.displayLabel = toLabel;
                    if(item.field.lookupSource) {
                        item.field.lookupSource = toLookupSource;
                    }
                }
            });

            // Also update in targetModel fields
            angular.forEach(vm.targetModel.fields, function(field) {
                if(field.field === fromField) {
                    field.field = toField;
                    field.displayLabel = toLabel;
                    if(field.lookupSource) {
                        field.lookupSource = toLookupSource;
                    }
                }
            });

            // Update unique constraints
            if(vm.targetModel.uniqueConstraints) {
                angular.forEach(vm.targetModel.uniqueConstraints, function(constraint) {
                    var idx = constraint.fields.indexOf(fromField);
                    if(idx !== -1) {
                        constraint.fields[idx] = toField;
                    }
                });
            }

            // Load lookup data for the new source if not already loaded, and add to promises so validation waits for it
            if(angular.isUndefined(vm.lookupData[toLookupSource])) {
                var lookupModel = api.getModel(toLookupSource);
                if(lookupModel && lookupModel._loadPromise) {
                    // Seller level: use pre-loaded promise from preloadSellerLookups
                    var sellerPromise = lookupModel._loadPromise.then(function(result) {
                        vm.lookupData[toLookupSource] = result;
                    });
                    promises[toLookupSource] = sellerPromise;
                } else {
                    // Catalog level: load via standard lookup
                    promises[toLookupSource] = loadLookup(toLookupSource);
                }
            }

            // Reset autocomplete state for the swapped field
            if(vm.acModel[fromField]) {
                vm.acModel[toField] = vm.acModel[fromField];
                delete vm.acModel[fromField];
            }
            if(vm.acSearchText[fromField]) {
                vm.acSearchText[toField] = vm.acSearchText[fromField];
                delete vm.acSearchText[fromField];
            }

            vm.filteredMapping = angular.copy(vm.mapping);
        }

        function onSearchTextChanged() {
            if (!vm.searchText) {
                vm.filteredMapping = angular.copy(vm.mapping);
                return;
            }

            vm.filteredMapping = vm.mapping.filter(function(item) {
                if (!item.field || !item.field.displayLabel) return false;

                var translatedLabel = $translate.instant(item.field.displayLabel);
                return translatedLabel.toLowerCase().indexOf(vm.searchText.toLowerCase()) !== -1;
            });

            vm.filteredMapping.forEach(function(filteredItem) {
                var originalItem = vm.mapping.filter(function(m) {
                    return m.field.field === filteredItem.field.field;
                })[0];

                if (originalItem) {
                    originalItem.column = filteredItem.column;
                }
            });
        }

        function onStepChange(currentStep, newStep) {
            vm.currentStep = currentStep;
            if (currentStep == 1 && newStep == 2) {
                if (vm.fileOpt === "0") {
                    vm.fileData = dataImporter.lastSheet;
                } else {
                    dataImporter.lastSheet = vm.fileData;
                }
                vm.sheetsList = vm.fileData.workBook.SheetNames;

                vm.selectedSheet = undefined;//TODO- is this required?
                if (vm.sheetsList.length > 0) {
                    if(importMappings && importMappings.selectedSheet && doesCachedSheetExist(vm.sheetsList, importMappings.selectedSheet)) {
                        vm.selectedSheet = importMappings.selectedSheet; // try to get form cached object in db
                    } else {
                        vm.selectedSheet = vm.sheetsList[0];
                    }
                } else {
                    vm.selectedSheet = -1;
                }
            }
            if (currentStep == 2 && newStep == 3) {
                importMappings.selectedSheet = vm.selectedSheet; //cache selected sheet
                vm.columns = getXlsColumns(vm.fileData.workBook.Sheets[vm.selectedSheet]);
                //Attempt to auto-match columns
                 for (var i=0; i<vm.mapping.length; i++) {
                     // try to map from cached values in db
                     if(mapColumnsFromCacheData(importMappings.columnsMapping, vm.acModel, vm.mapping[i].field.field, vm.columns)) {
                         continue;
                     }
                     for (var j=0; j<vm.columns.length; j++) {
                         if (columnMatchesField(vm.mapping[i].field, vm.columns[j])) {
                             vm.acModel[vm.mapping[i].field.field] = vm.columns[j];
                             break;
                         }
                     }
                 }

                 updateMappingValidation();
            }

            if (currentStep == 3 && newStep == 4) {
                if(importMappings && importMappings.FilterInfo && !utility.isObjectEmpty(importMappings.FilterInfo)) {
                    vm.sheetFilterOpt = importMappings.FilterInfo; // load filter criteria from cached value
                }
            }

            if (currentStep == 4 && newStep == 5) {
                // if articles job and exceeds the allowed articlesLimitForBackgroundJobs limit show validation error
                vm.isArticleCountWithinLimit = true;
                if(vm.action === 'import' || vm.action === 'updateViaImport' || vm.action === 'updateViaImportModel' || vm.action === 'importByLicensee') {
                    var sheet = vm.fileData.workBook.Sheets[vm.selectedSheet];
                    if (sheet && sheet['!ref']) {
                        var range = XLSX.utils.decode_range(sheet['!ref']);
                        var rowCount = range.e.r - range.s.r + 1;

                        if (api.articlesLimitForBackgroundJobs > 0 && rowCount > api.articlesLimitForBackgroundJobs) {
                            vm.isArticleCountWithinLimit = false;
                        }
                    }
                }

                if(vm.isArticleCountWithinLimit) {
                    // Show validation loader immediately while waiting for lookup data
                    vm.validationWorking = true;
                    vm.validationProgress = 0;
                    //specific to articles module and vm.isUpdateArticlesByModel will be true for list action - update articles by import model
                    if(vm.isUpdateArticlesByModel) {// Change for update articles by import model number
                        if(vm.mapping.length > 0) {
                            var count = 0;
                            angular.forEach(vm.mapping, function(map) {
                                if(map.column !== -1 && map.field.field !== 'ModelNumber') {
                                    count ++;
                                }
                            });
                            if (count > 0) {
                                importMappings.FilterInfo = vm.sheetFilterOpt; // cache filter criteria use by user
                                $q.all(promises).then(function() {
                                    validateDataWrapper();
                                });
                            } else {
                                vm.isValidExcel = 0;
                                vm.totalValid = 0;
                                vm.tempValidation = '';
                                vm.validationError = ''; // this branch never reaches validateData, which is where the banner is normally cleared
                            }
                        }
                    } else {
                        //Show error when no optional coulmns are mapped(atleast one optional coulumn should be mapped from the coulmns with isOptional flag true)
                        if(vm.mapping.length > 0) {
                            var totalOptional = 0;
                            var totalUnmapped = 0;
                            angular.forEach(vm.mapping, function(map) {
                                if (angular.isDefined(map.field.validation.isOptional) && map.field.validation.isOptional) {
                                    totalOptional++;
                                    if(map.column < 0) {
                                        totalUnmapped++;
                                    }
                                }
                            });
                            if (totalOptional > 0) {
                                if(totalOptional === totalUnmapped) {
                                    vm.totalInvalid = 0;
                                    vm.totalValid = 0;
                                    vm.tempValidation = '';
                                    vm.validationError = ''; // as above: no validateData call on this branch
                                } else {
                                    importMappings.FilterInfo = vm.sheetFilterOpt; // cache filter criteria use by user

                                    $q.all(promises).then(function() {
                                        validateData();
                                    });
                                }
                            } else {
                                importMappings.FilterInfo = vm.sheetFilterOpt; // cache filter criteria use by user

                                $q.all(promises).then(function() {
                                    validateDataWrapper();
                                });
                            }
                        }

                    }
                }
                else {
                    vm.totalInvalid = 0;
                    vm.totalValid = 0;
                    vm.tempValidation = '';
                    vm.validationError = ''; // article-count-over-limit exit: also never reaches validateData
                }
            }
            return true;
        }

        function getXlsColumns(ws)
        {
            var usedRange = XLSX.utils.decode_range(ws['!ref']);
            var firstRow = usedRange.s.r;
            var firstCol = usedRange.s.c;
            var lastCol = usedRange.e.c;
            var cols = [];

            for (var i = firstCol; i<= lastCol; i++)
            {
                if (angular.isDefined(ws[XLSX.utils.encode_cell({'c': i, 'r': firstRow})])) {
                    cols.push({c: i, r: firstRow, v: ws[XLSX.utils.encode_cell({'c': i, 'r': firstRow})].w});
                }

            }

            return $filter('orderBy')(cols, 'v');
        }

        /**
         * Launches xlsx-parser.worker.js to parse the full workbook in an isolated
         * V8 heap, then calls validateData() once the Worker posts back the
         * lightweight worksheet.
         *
         * Why a Worker instead of inline XLSX.read?
         *   A 300 MB xlsx decompresses to ~800 MB of sheet XML and produces ~1.3 GB
         *   of cell objects.  Running that in the main thread hits the browser tab's
         *   memory limit.  A Worker has its own fresh heap, and only the ~30-50 MB of
         *   cells the importer actually reads are transferred back.
         *
         * The Worker URL '/app/services/dataImporter/xlsx-parser.worker.js' is
         * served directly by BrowserSync in dev (baseDir includes src/) and copied
         * to dist/ by the gulp worker-scripts task for production.
         */
        function validateDataWrapper() {
            // Collect every column index the user mapped — the Worker only returns
            // cells for these columns (+ header row) to keep the payload small.
            var mappedColumnIndices = [];
            angular.forEach(vm.mapping, function (map) {
                if (map.column >= 0) {
                    mappedColumnIndices.push(map.column);
                }
            });

            // Include the filter column so filter logic inside validateData works.
            var filterColumn = -1;
            if (vm.sheetFilterOpt && vm.sheetFilterOpt.state == '1' &&
                    angular.isDefined(vm.sheetFilterOpt.column) && vm.sheetFilterOpt.column >= 0) {
                filterColumn = parseInt(vm.sheetFilterOpt.column, 10);
            }

            vm.validationWorking = true;
            vm.validationError = '';

            var worker = new Worker('/app/services/dataImporter/xlsx-parser.worker.js');

            // A parse failure must leave tempValidation EMPTY. It backs a hidden `required` input
            // in step-5.html, so putting the error text in it would mark the step valid and let the
            // user press Next and submit whatever vm.data still holds from a previous sheet.
            function failValidation(messageText) {
                $timeout(function () {
                    vm.validationWorking = false;
                    vm.validationError = messageText;
                    vm.tempValidation = '';
                    vm.data = [];
                    vm.totalValid = 0;
                    vm.totalInvalid = 0;
                    vm.totalSkipped = 0;
                }, 0);
            }

            worker.onmessage = function (e) {
                worker.terminate();
                if (e.data.type === 'success') {
                    // Build a plain worksheet object from the Worker result and
                    // inject it into the workBook so validateData's ws[cellRef]
                    // accesses work without any changes to that function.
                    var wsData      = e.data.result.cells;
                    wsData['!ref']  = e.data.result.ref;
                    vm.fileData.workBook.Sheets[vm.selectedSheet] = wsData;
                    vm.fileData.needsFullReparse = false;
                    // $timeout brings the callback into Angular's digest cycle.
                    $timeout(function () { validateData(); }, 0);
                } else {
                    failValidation(e.data.message || 'The file is too large to process in the browser.');
                }
            };

            worker.onerror = function (e) {
                worker.terminate();
                failValidation('Could not process the file: ' + (e.message || 'Worker error'));
            };

            // Pass the ArrayBuffer without transferring it so the main thread
            // keeps its copy (needed if the user re-tries validation).
            worker.postMessage({
                type:          'parseData',
                data:          vm.fileData.data,
                sheetName:     vm.selectedSheet,
                mappedColumns: mappedColumnIndices,
                filterColumn:  filterColumn
            });
        }

        // to notify or warn user if same column from sheet is selected for two different columns
        function updateMappingValidation() {
            var mappedCols = [];

            for (var i=0; i<vm.mapping.length; i++)
            {
                if (vm.mapping[i].column >= 0 && mappedCols.indexOf(vm.mapping[i].column) >= 0) {
                    vm.mapping[i].warn = true;
                } else {
                    if (vm.mapping[i].column >= 0)
                        mappedCols.push(vm.mapping[i].column);

                    vm.mapping[i].warn = false;
                }
            }
        }

        // create articles map
        listData = listData && listData.length ? listData : api.currentCatalogArticleList;
        var modelAttribute = catalogFactory.getActiveCatalogDetails().ModelAttribute;
        var articleAttribute = catalogFactory.getActiveCatalogDetails().ArticleAttribute;
        var columFieldMap = {};

        function createArticlesMap() {
            angular.forEach(vm.mapping, function(mappedField) {
                columFieldMap[mappedField.field.field] = mappedField.column;
                if(mappedField.field.field === 'Status' && (targetModel.modelPath === 'catalogs.articles' || targetModel.modelPath === 'catalogs.linePlanArticles')) {
                    articleStatusColumFieldMap[mappedField.field.field] = mappedField.column;
                }
            });
            return new Promise(function(resolve) {
                if(angular.isDefined(columFieldMap['ArticleNumber']) && columFieldMap['ArticleNumber'] !== -1) {
                    articlesMap = {};
                    listData
                        .filter(function(item) { return item.ArticleNumber; })
                        .forEach(function(item) {
                            articlesMap[item.ArticleNumber.toString()] = item;
                        });
                }
                else if((angular.isDefined(columFieldMap['ModelNumber']) && columFieldMap['ModelNumber'] !== -1)) {
                    articlesMap = {};
                    listData
                        .filter(function(item) { return item.ModelNumber; })
                        .forEach(function(item) {
                            articlesMap[item.ModelNumber.toString()] = item;
                        });
                }
                else if(angular.isDefined(columFieldMap['ArticleName']) && columFieldMap['ArticleName'] !== -1) {
                    articlesMap = {};
                    listData
                        .filter(function(item) { return item.ArticleName; })
                        .forEach(function(item) {
                            articlesMap[item.ArticleName.toString()] = item;
                        });
                }
                else if((vm.action === 'setSizesByLicenseeModelNumber' || vm.action === 'importByLicensee' || vm.action === 'setPricesByLicenseeModelNumber') &&
                        ((angular.isDefined(columFieldMap[modelAttribute]) && columFieldMap[modelAttribute] !== -1) || (angular.isDefined(columFieldMap['LicenseeModelNumber']) && columFieldMap['LicenseeModelNumber'] !== -1))) {
                    articlesMap = {};
                    listData
                    .filter(function(item) {
                        return item[modelAttribute];
                    })
                    .forEach(function(item) {
                        var key = item[modelAttribute].toString();

                        if (!articlesMap[key]) {
                            articlesMap[key] = [];
                        }

                        articlesMap[key].push(item);
                    });
                }

                resolve(articlesMap);
            });
        }

        function validateData() {
            if (vm.fileData.needsFullReparse && vm.fileData.data) {
                var fullWb = XLSX.read(new Uint8Array(vm.fileData.data), {
                    type:        'array',
                    cellFormula: false,
                    cellHTML:    false,
                    cellNF:      false,
                    cellStyles:  false
                });
                vm.fileData.workBook = fullWb;
                vm.fileData.needsFullReparse = false;
            }
            var ws = vm.fileData.workBook.Sheets[vm.selectedSheet];
            var usedRange = XLSX.utils.decode_range(ws['!ref']);

            // Excel often records a used range covering the whole sheet (e.g. A1:AS1048576) after
            // whole-column formatting or a row delete, even when only a few hundred rows hold data.
            // Taking !ref at face value makes the chunk loop below iterate ~1M empty rows, which
            // reads as a frozen import and pins validationProgress at 0%. Clamp to the last row
            // that actually holds a cell. The Worker applies the same clamp; this covers the
            // needsFullReparse path above, which reads the workbook on the main thread instead.
            var trueLastRow = usedRange.s.r;
            var trueLastCol = usedRange.s.c;
            Object.keys(ws).forEach(function (cellKey) {
                if (cellKey.charAt(0) === '!') { return; }
                var addr = XLSX.utils.decode_cell(cellKey);
                if (addr.r > trueLastRow) { trueLastRow = addr.r; }
                if (addr.c > trueLastCol) { trueLastCol = addr.c; }
            });
            if (trueLastRow < usedRange.e.r) { usedRange.e.r = trueLastRow; }
            if (trueLastCol < usedRange.e.c) { usedRange.e.c = trueLastCol; }

            var firstRow = usedRange.s.r;
            var lastRow = usedRange.e.r;
            var statusCol = usedRange.e.c+1;

            // Resolve a dependent attribute's value (lowercased) for criteria evaluation, from 3 sources:
            // 1) mapped excel column, 2) rowData, 3) existing article (update-by-model). Shared by OLD and CriteriaV2.
            function resolveDependentAttrValue(depField, rowIndex, rowData) {
                var dependentAttrValue = null;
                // try to get value from mapped column first
                if(angular.isDefined(columFieldMap[depField]) && columFieldMap[depField] !== -1) {
                    var attrCellRef = XLSX.utils.encode_cell({c: columFieldMap[depField], r: rowIndex});
                    if(ws[attrCellRef] && ws[attrCellRef].v != null) {
                        dependentAttrValue = ws[attrCellRef].v.toString().toLowerCase();
                    }
                }
                // fallback to rowData if column is not mapped (e.g. update via import by model)
                if(dependentAttrValue == null && angular.isDefined(rowData[depField]) && rowData[depField] != null) {
                    dependentAttrValue = rowData[depField].toString().toLowerCase();
                }
                // fallback to existing article data from articlesMap (e.g. update via import by model where dependent attributes are not editable)
                if(dependentAttrValue == null && angular.isDefined(rowData['ModelNumber']) && vm.isUpdateArticlesByModel) {
                    var existingArticleData = articlesMap[rowData['ModelNumber']];
                    if(angular.isDefined(existingArticleData) && existingArticleData[depField] != null) {
                        dependentAttrValue = existingArticleData[depField].toString().toLowerCase();
                    }
                }
                return dependentAttrValue;
            }
            // if conditionalColorsCriteria added for article colors
            var conditionalColorsCriteria = api.conditonalColorVettingList;

            vm.validationWorking = true;
            vm.validationProgress = 0;
            vm.validationError = '';
            vm.totalValid = 0;
            vm.totalInvalid = 0;
            vm.totalSkipped = 0;
            vm.tempValidation = '';
            var highestArticleStateRankArticleState = {};
            var highestModelStateRankArticleState = {};

            vm.data = [];

            // specific to articles module
            // we will find out the states with height article state rank and height model state rank
            // if the attribute is article level then apply the validation from height state ranked article state
            // if the attribute is model level then apply the validation from the height model state ranked article state
            // find the highestRankStateId of all the articles mapped and if the non editable attributes mapped then show the validation message
            // as these attributes are non editable to and make the excel invalid
            // load articles lookup data for validating states, specific to article module

            createArticlesMap().then(function() {
                // Once articlesMap is ready, start the validation
                if(angular.isDefined(targetModel.validateStateEditableFields) && targetModel.validateStateEditableFields && !isSpecialPermissionToIgnoreArticleStateIsAssigned) {
                    var articleStateList = api.articleStatesList;
                    var highestArticleAndModelStateIdObj = getHighestStateIdOfMappedArticles(ws, columFieldMap);
                    var highestArticleStateRankStateId = highestArticleAndModelStateIdObj.highestArticleStateRankStateId;
                    var highestModelStateRankStateId = highestArticleAndModelStateIdObj.highestModelStateRankStateId;
                    if(highestArticleStateRankStateId != 0) {
                        var selectedArticleState = utility.filterObject(articleStateList, {StateId: highestArticleStateRankStateId}, true)[0];
                        if(angular.isDefined(selectedArticleState)) {
                            highestArticleStateRankArticleState = selectedArticleState;
                            vm.nonEditableAttributesArticleStateLevel = selectedArticleState.NonEditableAttributes.map(function(attr) {
                                return attr['AttributeSystemName'];
                            });
                        }
                    }
                    if(highestModelStateRankStateId != 0) {
                        var selectedModelState = utility.filterObject(articleStateList, {StateId: highestModelStateRankStateId}, true)[0];
                        if(angular.isDefined(selectedModelState)) {
                            highestModelStateRankArticleState = selectedModelState;
                            vm.nonEditableAttributesModelStateLevel = selectedModelState.NonEditableAttributes.map(function(attr) {
                                return attr['AttributeSystemName'];
                            });
                        }
                    }
                }
            })

            //Attempt to skip fake rows
            for (var sr=lastRow; sr>=firstRow; sr--) {
                var skipRow = true;
                for (var sc=0; sc<=statusCol-1; sc++) {
                    var cellV = ws[XLSX.utils.encode_cell({c: sc, r: sr})];
                    if (cellV && angular.isDefined(cellV)) {
                        skipRow = false;
                        break;
                    }
                }
                if (skipRow) {
                    lastRow--;
                } else {
                    break;
                }
            }

            //Add status col
            usedRange.e.c++;
            // avoid adding status column multiple times
            var isStatusColumnPresent = checkIfStatusColumnPresent(ws);
            if(!isStatusColumnPresent) {
                // find the last used column (excluding 'Status ' column)
                var range = XLSX.utils.decode_range(ws['!ref']);
                var lastCol = range.e.c;
                var R = range.s.r;
                for (var C = range.s.c; C <= range.e.c; ++C) {
                    var cell = ws[XLSX.utils.encode_cell({ c: C, r: R })];
                    // Check if the cell is defined, the value is not 'Status ', and the type is 's' (string)
                    if (angular.isDefined(cell) && (cell.v !== 'Status ' && cell.t === 's')) {
                        lastCol = C;
                    }
                }
                statusCol = lastCol + 1;
                // ***Important adding the error status column header with a space 'Status ' to differentiate if the excel contains field Status.
                ws[XLSX.utils.encode_cell({c: statusCol, r: firstRow})] = { v: 'Status ', t: 's' };
            } else {
                statusCol = usedRange.e.c+1;
            }
            ws['!ref'] = XLSX.utils.encode_range(usedRange);
            var constraints = {};
            var commons = {};
            var atLeastOneRequiredConstraints = {}; // this means there should be at least one value per row for group of fields specified in atLeastOneRequiredConstraints
            var conditionalRequired = {};
            var haveConstraints = false;
            var haveCommons = false;
            var haveAtLeastOneRequiredConstraints = false;
            var haveConditionalRequired = false;
            var shouldNotHaveSameValueConstraintsPresent = false;
            var totalSizeCurvePercentage = {};

            //Load the unique constrains of the object
            if (angular.isDefined(vm.targetModel) && angular.isDefined(vm.targetModel.uniqueConstraints)
                && angular.isArray(vm.targetModel.uniqueConstraints)
                && vm.targetModel.uniqueConstraints.length > 0) {
                haveConstraints = true;
                angular.forEach(vm.targetModel.uniqueConstraints, function(item) {
                    constraints[item.name] = {};
                });
            }

            //Load the common constraints of the object
            if (angular.isDefined(vm.targetModel) && angular.isDefined(vm.targetModel.commonConstraints)
                && angular.isArray(vm.targetModel.commonConstraints) && vm.targetModel.commonConstraints.length > 0) {
                haveCommons = true;
                angular.forEach(vm.targetModel.commonConstraints, function(item) {
                    commons[item.name] = undefined;
                });
            }

            if(angular.isDefined(vm.targetModel) && angular.isDefined(vm.targetModel.atLeastOneRequiredConstraints) &&
                angular.isArray(vm.targetModel.atLeastOneRequiredConstraints) && vm.targetModel.atLeastOneRequiredConstraints.length > 0) {
                haveAtLeastOneRequiredConstraints = true;
                angular.forEach(vm.targetModel.atLeastOneRequiredConstraints, function(item) {
                    atLeastOneRequiredConstraints[item.name] = undefined;
                });
            }

            if(angular.isDefined(vm.targetModel) && angular.isDefined(vm.targetModel.conditionalRequired) &&
                angular.isArray(vm.targetModel.conditionalRequired) && vm.targetModel.conditionalRequired.length > 0) {
                angular.forEach(vm.targetModel.conditionalRequired, function(item) {
                    if(angular.isDefined(item.criteria) && angular.isDefined(item.requiredFields) && angular.isArray(item.requiredFields) && item.requiredFields.length) {
                        // validate only if all the required fields are mapped
                        var isValidConditionalRequiredCriteria = true;
                        for(var vcrci = 0; vcrci < item.requiredFields.length; vcrci++) {
                            if(columFieldMap[item.requiredFields[vcrci]] < 0) {
                                isValidConditionalRequiredCriteria = false;
                                break;
                            }
                        }
                        if(isValidConditionalRequiredCriteria) {
                            haveConditionalRequired = true;
                            conditionalRequired[item.name] = {};
                            conditionalRequired[item.name].criteria = item.criteria;
                            conditionalRequired[item.name].requiredFields = item.requiredFields;
                        }
                    }
                });
            }

            if(catalogAttributes && catalogAttributes.length) {
                // attribute criteria
                var dependingAttributes = {};
                angular.forEach(catalogAttributes, function(attribute) {
                    if(angular.isDefined(attribute.Criteria) && attribute.Criteria.length > 0) {
                        // parse json
                       try {
                           var vettinglistCriteria = JSON.parse(attribute.Criteria);
                       } catch(error) {
                           console.warn(attribute.AttributeDisplayName + " - Attribute Criteria: Invalid JSON Format");
                       }
                       var obj2 = {};
                       for(var key in vettinglistCriteria) {
                           if(vettinglistCriteria.hasOwnProperty(key)) {
                               var deptAttr = vettinglistCriteria[key];
                               for(var key1 in deptAttr) {
                                   var obj = {};
                                   if(deptAttr.hasOwnProperty(key1)) {
                                       if(obj2[key1]) {
                                           angular.forEach(deptAttr[key1], function(val) {
                                               if(obj2[key1][val.toString().toLowerCase()]) {
                                                   if(obj2[key1][val.toString().toLowerCase()].indexOf(key.toLowerCase())) {
                                                       obj2[key1][val.toString().toLowerCase()].push(key.toLowerCase());
                                                   }
                                               } else {
                                                   obj2[key1][val.toString().toLowerCase()] = [key.toLowerCase()];
                                               }
                                           });
                                       } else {
                                           angular.forEach(deptAttr[key1], function(val) {
                                               obj[val.toString().toLowerCase()] = [key.toLowerCase()];
                                           });
                                           obj2[key1] = obj;
                                       }
                                   }
                               }
                           }
                       }
                       dependingAttributes[attribute.AttributeSystemName] = obj2;
                       vm.dependingAttributesMap.push(dependingAttributes);
                   }
                   if(attribute.CriteriaV2 && attribute.CriteriaV2.length > 0) {
                       try {
                           vm.criteriaV2Map[attribute.AttributeSystemName] = JSON.parse(attribute.CriteriaV2);
                       } catch(error) {
                           console.warn(attribute.AttributeDisplayName + " - Attribute CriteriaV2: Invalid JSON Format");
                       }
                   }
               });
            }

            // load shouldNotHaveSameValueConstraints
            if (angular.isDefined(vm.targetModel) && angular.isDefined(vm.targetModel.shouldNotHaveSameValueConstraints)
                && angular.isArray(vm.targetModel.shouldNotHaveSameValueConstraints) && vm.targetModel.shouldNotHaveSameValueConstraints.length > 0) {
                shouldNotHaveSameValueConstraintsPresent = true;
            }

            var sourceAttributesMap = {};
            if (angular.isDefined(vm.targetModel) && vm.targetModel.validateRequiredLookupTableAttributes && !utility.isObjectEmpty(validSellerLookupsDestinationAttributesMap)) {
                Object.keys(validSellerLookupsDestinationAttributesMap).forEach(function (attributeSystemName) {
                    var attribute = utility.filterObject(catalogAttributes, { AttributeSystemName: attributeSystemName }, true)[0];
                    if (attribute && attribute.IsRequired) {
                        var attributeLookupValues = validSellerLookupsDestinationAttributesMap[attributeSystemName];
                        var value = attributeLookupValues[0];
                        for (var sourceAttributeSystemName in value.Source) {
                            var displayName = utility.getAttributeDisplayNameUsingSystemName(catalogAttributes, sourceAttributeSystemName);
                            var isMapped = false;
                            for (var s = 0; s < vm.mapping.length; s++) {
                                if (vm.mapping[s].column > 0 && vm.mapping[s].field.field === sourceAttributeSystemName) {
                                    isMapped = true;
                                    break;
                                }
                            }
                            // populate the sourceAttributesMap
                            if (!sourceAttributesMap[attributeSystemName]) {
                                sourceAttributesMap[attributeSystemName] = {
                                    attributeDisplayName: attribute.AttributeDisplayName,
                                    lookupSourceAttributesDisplayNameMap: {},
                                };
                            }
                            sourceAttributesMap[attributeSystemName].lookupSourceAttributesDisplayNameMap[displayName] = isMapped;
                        }
                    }
                });
            }
            var chunkSize = 100;  // chunk
            var totalRows = lastRow - firstRow;
            var startIndex = firstRow + 1;

            function processChunk(startIndex, endIndex) {
                // The body is wrapped so a single bad row can never kill the chunk chain (see the
                // catch below). Left un-indented deliberately to keep this diff reviewable.
                try {
                for (var i = startIndex; i <= endIndex; i++) {
                    var currentRowStatus = [];
                    var currentRowValid = true;
                    var rowData = {};
                    var mappedColumncRowValues = {};

                   //Skip filters
                    if (vm.sheetFilterOpt.state == '1') {
                        //Match rows
                        // vm.sheetFilterOpt.column comes from the md-select as a string ("14"). XLSX.utils.encode_cell
                        // does `cell.c + 1`, which string-concatenates a string column index ("14" -> "141") and yields
                        // a wrong cell reference, so coerce to an integer first.
                        var filterColRef = XLSX.utils.encode_cell({c: parseInt(vm.sheetFilterOpt.column, 10), r: i});
                        var filterColValue = undefined;

                        if (ws[filterColRef]) {
                            filterColValue = ws[filterColRef].v;
                        }

                        var matchFilterCriteria =   (vm.sheetFilterOpt.contains == '0' /* Any Value */ && angular.isDefined(filterColValue) && filterColValue.toString().trim().length > 0) ||
                                                    (vm.sheetFilterOpt.contains == '1' /* No Value */ && (angular.isUndefined(filterColValue) || filterColValue.toString().trim().length == 0)) ||
                                                    (vm.sheetFilterOpt.contains == '2' /* A Specific Value */ && angular.isDefined(filterColValue) && filterColValue.toString().trim().toLowerCase() === vm.sheetFilterOpt.specificValue.trim().toLowerCase());

                        if ((vm.sheetFilterOpt.include == '0' /*Include*/ && !matchFilterCriteria) || (vm.sheetFilterOpt.include == '1' /*Exclude*/ && matchFilterCriteria)) {
                            //Skip
                            vm.totalSkipped++;
                            continue;
                        }

                    }

                // create mapped field and column map
                // if(vm.targetModel.modelPath === 'catalogs.articles' || vm.targetModel.modelPath == 'catalogs.linePlanArticles') {
                //     var columFieldMap = {};
                //     angular.forEach(vm.mapping, function(mappedField) {
                //         columFieldMap[mappedField.field.field] = mappedField.column;
                //     });
                // }
                    Object.keys(columFieldMap).forEach(function (systemName) {
                        if (columFieldMap[systemName] !== -1) {
                            var cellRef = XLSX.utils.encode_cell({ c: columFieldMap[systemName], r: i });
                            var cellValue = angular.isDefined(ws[cellRef]) ? ws[cellRef].v : null;
                            mappedColumncRowValues[systemName] = cellValue;
                        }
                    });

                    //vm.mapping contains all creatable (editable) fields and column number for that field (column)
                    for (var j=0; j<vm.mapping.length; j++) {
                        var mappedField = vm.mapping[j];
                        var cellRef = XLSX.utils.encode_cell({c: mappedField.column, r: i});
                        var cellValue = undefined;
                        var cellFormattedValue = undefined;

                        if (ws[cellRef]) {
                            //ws[cellRef].t represents the cell type in the excel. If the cell contains some excel error types (#NULL!, #DIV/0!, #VALUE!, #REF!, #NAME?, #NUM!, #N/A )
                            //than we will show error message and invalidate the excel.
                            if (ws[cellRef].t === 'e') {
                                currentRowStatus.push((vm.acModel[mappedField.field.field].v || mappedField.field.displayLabel ) + " contains invalid value " + ws[cellRef].w);
                                ws[cellRef].c = mappedField.field.field + " contains invalid value " + ws[cellRef].w;
                                currentRowValid = false;
                                continue;
                            } // specific to articles module if any non editable attribute value mapped show error message
                            else if(mappedField.column >= 0 && angular.isDefined(targetModel.validateStateEditableFields) && targetModel.validateStateEditableFields && !isSpecialPermissionToIgnoreArticleStateIsAssigned) {
                                if((vm.nonEditableAttributesArticleStateLevel.length && vm.nonEditableAttributesArticleStateLevel.includes(mappedField.field.field))
                                || (vm.nonEditableAttributesModelStateLevel.length && vm.nonEditableAttributesModelStateLevel.includes(mappedField.field.field))
                                || (mappedField.field.field === 'SizeScale' && (!utility.isObjectEmpty(highestModelStateRankArticleState) && !highestModelStateRankArticleState.IsSizeScaleEditable))
                                || (mappedField.field.field === 'ColorCode' && (!utility.isObjectEmpty(highestArticleStateRankArticleState) && !highestArticleStateRankArticleState.IsArticleNumberEditable))) {
                                    currentRowStatus.push((vm.acModel[mappedField.field.field].v || mappedField.field.displayLabel) + " is set as non editable at state level. Please remove the mapping.");
                                    ws[cellRef].c = mappedField.field.field + " contains invalid value " + ws[cellRef].w;
                                    currentRowValid = false;
                                    continue;
                                } else {
                                    cellValue = ws[cellRef].v;
                                    cellFormattedValue = ws[cellRef].w; // to be used when user input date value in text fields(Places like catalogs delivery dates description field)
                                }
                            }
                            else {
                                cellValue = ws[cellRef].v;
                                cellFormattedValue = ws[cellRef].w; // to be used when user input date value in text fields(Places like catalogs delivery dates description field)
                            }
                        } else {
                            cellValue = undefined;
                            ws[cellRef] = {v: undefined};
                        }

                        if (angular.isDefined(cellValue) && angular.isString(cellValue)) {
                            cellValue = cellValue.toString().trim();
                        }

                        // if field of model mapped to column of excel
                        if (angular.isDefined(mappedField.column) && mappedField.column >= 0)
                        {
                            //Validate required
                            if (mappedField.field.inputType.toUpperCase() !== 'switch'.toUpperCase() // skip this check for modules having 'yes' and 'no' as column data (A/C segmentations and A crd)
                                && (mappedField.field.validation.isRequired || (angular.isDefined(mappedField.field.validation.isRequiredIfMapped) && mappedField.field.validation.isRequiredIfMapped))
                                && mappedField.field.validation.minLen > 0
                                && (angular.isUndefined(cellValue) || cellValue.toString().trim() === ''))
                            {
                                currentRowStatus.push((vm.acModel[mappedField.field.field].v || mappedField.field.displayLabel ) + ' is required and value cannot be empty');
                                currentRowValid = false;
                                continue;
                            }

                            // For empty values in excel, for not required field, do not update the values from api. As in case of int type (like Sort Order field in articles) default value is set to zero, hence we used flag skipEmptyValue which if true will skip updating its value and wont send the particular property in its request
                            if((!mappedField.field.validation.isRequired && angular.isUndefined(mappedField.field.validation.isRequiredIfMapped)) && angular.isDefined(mappedField.field.skipEmptyValue) && mappedField.field.skipEmptyValue.toString() === 'true' && (angular.isUndefined(cellValue) || cellValue == null || cellValue.toString().trim() === '')) {
                                cellValue = undefined;
                                continue;
                            }

                            // @Sohail, We need to remove this line in order to allow the empty cells to be valid values for non-required fields
                            // //Validate type
                            // if (angular.isUndefined(cellValue) ||  cellValue == null || cellValue.toString().trim() === "") {
                            //     continue;
                            // }

                            switch (mappedField.field.inputType) {
                                case 'date':
                                    if((angular.isUndefined(cellValue) || cellValue === null || cellValue.toString().trim() === '') && (!mappedField.field.validation.isRequired && angular.isUndefined(mappedField.field.validation.isRequiredIfMapped))){
                                        cellValue = '';
                                    }
                                    else if (!angular.isDate(cellValue) && !angular.isNumber(cellValue))
                                    {
                                        //validate if the date is ISO  string date
                                    var formats = [
                                            moment.ISO_8601,
                                            'MM-DD-YYYY',
                                            'MM/DD/YYYY',
                                            'MMM DD, YYYY'
                                        ];
                                        //The true argument is there so the Moment won't try to parse the input if it doesn't exactly conform to one of the formats provided
                                        if (!moment(cellValue, formats, true).isValid()) {
                                            currentRowStatus.push((vm.acModel[mappedField.field.field].v || mappedField.field.displayLabel ) + ' is not a valid date');
                                            ws[cellRef].c = 'Invalid date';
                                            currentRowValid = false;
                                            continue;
                                        }
                                    }
                                    if (angular.isNumber(cellValue)) {
                                        cellValue = (new Date((cellValue - (25567 + 2))*86400*1000)).toISOString();
                                    }
                                    break;
                                case 'date-without-time':
                                case 'date-option':
                                    if((angular.isUndefined(cellValue) || cellValue === null || cellValue.toString().trim() === '') && (!mappedField.field.validation.isRequired && angular.isUndefined(mappedField.field.validation.isRequiredIfMapped))){
                                        cellValue = '';
                                    }
                                    else if (!angular.isDate(cellValue) && !angular.isNumber(cellValue))
                                    {
                                        //validate if the date is ISO  string date
                                    var formats = [
                                            moment.ISO_8601,
                                            'MM-DD-YYYY',
                                            'MM/DD/YYYY',
                                            'MMM DD, YYYY'
                                        ];
                                        //The true argument is there so the Moment won't try to parse the input if it doesn't exactly conform to one of the formats provided
                                        if (!moment(cellValue, formats, true).isValid()) {
                                            currentRowStatus.push((vm.acModel[mappedField.field.field].v || mappedField.field.displayLabel ) + ' is not a valid date');
                                            ws[cellRef].c = 'Invalid date';
                                            currentRowValid = false;
                                            continue;
                                        }
                                    }
                                    if (angular.isNumber(cellValue)) {
                                        var date = new Date( ((cellValue - (25567 + 2))*86400*1000) + ((new Date(((cellValue - (25567 + 2))*86400*1000)).getTimezoneOffset())*60*1000) );
                                        var dateValueWithTime = new Date(date.setHours(12-(date.getTimezoneOffset()/60),0,0)).toISOString();
                                        cellValue = dateValueWithTime.split('T', 1)[0];
                                    }
                                    // specific to orders module, check if DeliveryDate(CRD) is valid based on customerrequireddatevalidation
                                    // when customerrequireddatevalidation is added the DeliveryDate field will be mandatory
                                    if(mappedField.field.field === 'DeliveryDate' && mappedField.field.validation.isRequired && mappedField.field.validation.validateCRD) {
                                        var customerRequiredDateValidation = catalogFactory.getActiveCatalogDetails().CustomerRequiredDateValidation;
                                        if(customerRequiredDateValidation != null && customerRequiredDateValidation != '') {
                                            var operators = ['<=', '>=', '>', '<', '===', '!=='];
                                            try {
                                                vm.customerRequiredDateValidation = JSON.parse(customerRequiredDateValidation);
                                                if(angular.isArray(vm.customerRequiredDateValidation) && vm.customerRequiredDateValidation.length > 0) {
                                                    var validDates = 0;
                                                    var crdValidationError = '';
                                                    for (var vl = 0; vl < vm.customerRequiredDateValidation.length; vl++) {
                                                        var validation = vm.customerRequiredDateValidation[vl];
                                                        if(validation.hasOwnProperty('relation') && validation.relation.toString().trim().length && operators.indexOf(validation.relation) !== -1) {
                                                            var catalogDeliveryDates = catalogFactory.getActiveCatalogDetails().CatalogCRDList;
                                                            var addedDeliveryDate = utility.filterObject(catalogDeliveryDates, {Id: rowData.Crd}, true)[0];
                                                            var CRDValue = new Date(addedDeliveryDate.CustomerRequiredDate);
                                                            CRDValue = CRDValue.setHours(0,0,0,0); // this is the customer required date as the labels are confusing)
                                                            var deliveryDateValue = new Date(cellValue);
                                                            deliveryDateValue = deliveryDateValue.setHours(0,0,0,0);
                                                            var expression = validation.relation;
                                                            switch(expression) {
                                                                case '<':
                                                                    crdValidationError = 'ORDERLINE.VALIDATIONS.CRD_LESSER_DELIVERY_DATE';
                                                                    break;
                                                                case '>':
                                                                    crdValidationError = 'ORDERLINE.VALIDATIONS.CRD_GREATER_DELIVERY_DATE';
                                                                    break;
                                                                case '<=':
                                                                    crdValidationError = 'ORDERLINE.VALIDATIONS.CRD_LESSER_EQUEAL_DELIVERY_DATE';
                                                                    break;
                                                                case '>=':
                                                                    crdValidationError = 'ORDERLINE.VALIDATIONS.CRD_GREATER_EQUAL_DELIVERY_DATE';
                                                                    break;
                                                                case '===':
                                                                    crdValidationError = 'ORDERLINE.VALIDATIONS.CRD_EQUAL_DELIVERY_DATE';
                                                                    break;
                                                                case '!==':
                                                                    crdValidationError = 'ORDERLINE.VALIDATIONS.CRD_NOT_EQUAL_DELIVERY_DATE';
                                                                    break;
                                                            }

                                                            if(eval(deliveryDateValue + expression + CRDValue)) {
                                                                if(validation.hasOwnProperty('numberOfDays') && validation.numberOfDays > 0) {
                                                                    // if value is valid based on relation and number of days configured validate number of days.
                                                                    var numberOfDays = validation.numberOfDays;
                                                                    var CRDDate = new Date(addedDeliveryDate.CustomerRequiredDate);
                                                                    CRDDate.setHours(0,0,0,0);
                                                                    var startDate = CRDDate.getTime() - numberOfDays * 24 * 60 * 60 * 1000;
                                                                    var endDate = CRDDate.getTime() + numberOfDays * 24 * 60 * 60 * 1000;
                                                                    if(((deliveryDateValue < endDate && deliveryDateValue > startDate) || deliveryDateValue === endDate || deliveryDateValue === startDate)) {
                                                                        validDates++;
                                                                    }
                                                                } else {
                                                                    validDates++;
                                                                }
                                                            }
                                                        }
                                                    }
                                                    if(validDates === 0) {
                                                        if(vm.customerRequiredDateValidation.length === 1) {
                                                            currentRowStatus.push((vm.acModel[mappedField.field.field].v || mappedField.field.displayLabel ) + ' : ' + $filter('translate')(crdValidationError));
                                                            ws[cellRef].c = 'Invalid date';
                                                            currentRowValid = false;
                                                            continue;
                                                        } else {
                                                            currentRowStatus.push((vm.acModel[mappedField.field.field].v || mappedField.field.displayLabel ) + ' value does not satisfy the Customer Required Date Validation.');
                                                            ws[cellRef].c = 'Invalid date';
                                                            currentRowValid = false;
                                                            continue;
                                                        }
                                                    }
                                                }
                                            } catch(error) {
                                                console.warn("Customer Required Date Validation : Invalid JSON format");
                                                continue;
                                            }
                                        }
                                    }
                                    break;

                                case 'date-utc':
                                    if((angular.isUndefined(cellValue) || cellValue === null || cellValue.toString().trim() === '') && (!mappedField.field.validation.isRequired && angular.isUndefined(mappedField.field.validation.isRequiredIfMapped))){
                                        cellValue = '';
                                    }
                                    else if ( (!angular.isString(cellValue) && !angular.isDate(cellValue) && !angular.isNumber(cellValue))
                                    || (angular.isString(cellValue) && !utility.isValidDate(cellValue, ['MM/DD/YYYY', 'MM/DD/YY'])))
                                    {
                                        if(cellValue != '' && angular.isString(cellValue)){
                                            var d  = new Date(cellValue);
                                            cellValue = new Date(d.setHours(12-(d.getTimezoneOffset()/60),0,0)).toISOString();
                                        } else {
                                            currentRowStatus.push((vm.acModel[mappedField.field.field].v || mappedField.field.displayLabel )+ ' is not a valid date');
                                            ws[cellRef].c = 'Invalid date';
                                            currentRowValid = false;
                                            continue;
                                        }
                                    }
                                    // if cell formated in date then get date from integer set time to 12 UTC and convert to ISO string
                                    else if (angular.isNumber(cellValue)) {
                                        var date = new Date( ((cellValue - (25567 + 2))*86400*1000) + ((new Date(((cellValue - (25567 + 2))*86400*1000)).getTimezoneOffset())*60*1000) );
                                        cellValue = new Date(date.setHours(12-(date.getTimezoneOffset()/60),0,0)).toISOString();
                                    }
                                    // if cell contain date in one of the valid format create date using Date(year, month, day, ...) constructor ans set time to 12 UTC
                                    else if(cellValue != '' && angular.isString(cellValue)) {
                                        var parts = cellValue.split('/');
                                        var year = parts[2].length > 2 ? parseInt(parts[2]) : parseInt(parts[2])+2000;
                                        cellValue = new Date(year, parseInt(parts[0])-1, parseInt(parts[1]), 12-(new Date().getTimezoneOffset()/60)).toISOString();
                                    }
                                    break;

                                case 'status':
                                    if ( cellValue != null && cellValue !== 1 && cellValue !== 0 &&  cellValue.toString().trim().toUpperCase() !== 'TRUE' && cellValue.toString().trim().toUpperCase() !== 'FALSE' && cellValue.toString().trim().toUpperCase() !== 'YES' && cellValue.toString().trim().toUpperCase() !== 'NO'
                                    && cellValue.toString().trim().toUpperCase() !== 'ACTIVE' && cellValue.toString().trim().toUpperCase() !== 'INACTIVE') {
                                        currentRowStatus.push((vm.acModel[mappedField.field.field].v || mappedField.field.displayLabel) + ' is not a valid status');
                                        ws[cellRef].c = 'Invalid status';
                                        currentRowValid = false;
                                        continue;
                                    } else if (cellValue == null) {
                                        cellValue = 1; //by default status is 1
                                    } else if (cellValue.toString().trim().toUpperCase() === 'TRUE' || cellValue.toString().trim().toUpperCase() === 'YES' || cellValue.toString().trim().toUpperCase() === 'ACTIVE') {
                                        cellValue = 1;
                                    } else if (cellValue.toString().trim().toUpperCase() === 'FALSE' || cellValue.toString().trim().toUpperCase() === 'NO' || cellValue.toString().trim().toUpperCase() === 'INACTIVE') {
                                        cellValue = 0;
                                    }
                                    break;

                                case 'article-status':
                                    if ( cellValue != null && cellValue !== 1 && cellValue !== 0 &&  cellValue.toString().trim().toUpperCase() !== 'TRUE' && cellValue.toString().trim().toUpperCase() !== 'FALSE' && cellValue.toString().trim().toUpperCase() !== 'YES' && cellValue.toString().trim().toUpperCase() !== 'NO'
                                    && cellValue.toString().trim().toUpperCase() !== 'GLOBALLY DROPPED' && cellValue.toString().trim().toUpperCase() !== 'NOT ASSORTED'
                                    && cellValue.toString().trim().toUpperCase() !== 'ACTIVE' && cellValue.toString().trim().toUpperCase() !== 'INACTIVE') {
                                        currentRowStatus.push((vm.acModel[mappedField.field.field].v || mappedField.field.displayLabel) + ' is not a valid status');
                                        ws[cellRef].c = 'Invalid status';
                                        currentRowValid = false;
                                        continue;
                                    } else if (cellValue == null) {
                                        cellValue = 1; //by default status is 1
                                    } else if (cellValue.toString().trim().toUpperCase() === 'TRUE' || cellValue.toString().trim().toUpperCase() === 'YES' || cellValue.toString().trim().toUpperCase() === 'ACTIVE') {
                                        cellValue = 1;
                                    } else if (cellValue.toString().trim().toUpperCase() === 'FALSE' || cellValue.toString().trim().toUpperCase() === 'NO' || cellValue.toString().trim().toUpperCase() !== 'GLOBALLY DROPPED' || cellValue.toString().trim().toUpperCase() !== 'NOT ASSORTED' || cellValue.toString().trim().toUpperCase() === 'INACTIVE') {
                                        cellValue = 0;
                                    }
                                    break;

                                case 'number':
                                    if (angular.isUndefined(cellValue) || cellValue == null || cellValue.toString().trim() === '') {
                                        if(angular.isDefined(mappedField.field.allowEmptyValue) && mappedField.field.allowEmptyValue) {
                                            cellValue = null; // specific for customer allocations module
                                        } else {
                                            cellValue = 0;
                                        }
                                    } else if (!angular.isNumber(cellValue)) {
                                        currentRowStatus.push((vm.acModel[mappedField.field.field].v || mappedField.field.displayLabel) + ' is not a valid number');
                                        ws[cellRef].c = 'Invalid number';
                                        currentRowValid = false;
                                        continue;
                                    } else if(!Number.isInteger(cellValue)) {
                                        currentRowStatus.push((vm.acModel[mappedField.field.field].v || mappedField.field.displayLabel) + ' value must be an integer (no decimals).');
                                        ws[cellRef].c = 'value must be an integer (no decimals).';
                                        currentRowValid = false;
                                        continue;
                                    }
                                    break;
                                case 'decimal':
                                    if (angular.isUndefined(cellValue) || cellValue == null || cellValue.toString().trim() === '') {
                                        if(angular.isDefined(mappedField.field.allowEmptyValue) && mappedField.field.allowEmptyValue) {
                                            cellValue = null; // specific for customer allocations module
                                        } else {
                                            cellValue = 0;
                                        }
                                    } else if (!angular.isNumber(cellValue)) {
                                        currentRowStatus.push((vm.acModel[mappedField.field.field].v || mappedField.field.displayLabel) + ' is not a valid number');
                                        ws[cellRef].c = 'Invalid number';
                                        currentRowValid = false;
                                        continue;
                                    }
                                    break;

                                case 'bool': // if export this data type data-exporter will create cell of type boolean hence need toString()
                                    if(angular.isUndefined(cellValue) || cellValue === null || cellValue.toString().trim() === '' || cellValue.toString().toUpperCase() === 'NO' || cellValue.toString().toUpperCase() === 'FALSE') {
                                        cellValue = false;
                                    }
                                    else {
                                        cellValue = true;
                                    }
                                break;

                                case 'bool-str': // if export this data type data-exporter will create cell of type boolean hence need toString()
                                    if(angular.isUndefined(cellValue) || cellValue === null || cellValue.toString().trim() === '' || cellValue.toString().toUpperCase() === 'NO' || cellValue.toString().toUpperCase() === 'FALSE') {
                                        cellValue = 'false';
                                    }
                                    else {
                                        cellValue = 'true';
                                    }
                                break;

                                case 'bool-int': // if export this data type data-exporter will create cell of type boolean hence need toString()
                                    if(!cellValue || cellValue.toString().trim() === '' || cellValue.toString().toUpperCase() === 'NO' || cellValue.toString().toUpperCase() === 'FALSE') {
                                        cellValue = 0;
                                    }
                                    else {
                                        cellValue = 1;
                                    }
                                break;

                                case 'int-bool': // if export this data type data-exporter will create cell of type boolean hence need toString()
                                    if(!cellValue || cellValue.toString().trim() === '' || cellValue.toString().toUpperCase() === 'NO' || cellValue.toString().toUpperCase() === 'FALSE') {
                                        cellValue = '0';
                                    }
                                    else {
                                        cellValue = '1';
                                    }
                                break;

                                case 'lookup':
                                case 'color-palette':
                                    if (angular.isDefined(cellValue) && cellValue !== '') {
                                        var res = findInLookup(mappedField.field, cellValue);
                                        var invalidMessage = (vm.acModel[mappedField.field.field].v || mappedField.field.displayLabel ) + ' contains a value that cannot be found in the list';
                                        // filter based on the color palette conditions
                                        if(angular.isDefined(res) && mappedField.field.isfilterCriteria) {
                                            res = validateCriteria(mappedField.field, cellValue, rowData);
                                            if (angular.isUndefined(res)) {
                                                invalidMessage = (vm.acModel[mappedField.field.field].v || mappedField.field.displayLabel) + ' value does not match the attribute criteria';
                                            }
                                        }
                                        if (angular.isUndefined(res)) {
                                            currentRowStatus.push(invalidMessage);
                                            ws[cellRef].c = 'Invalid value';
                                            currentRowValid = false;
                                            continue;
                                        }
                                        if(angular.isDefined(mappedField.field.useLookupName) && mappedField.field.useLookupName === true) {
                                            cellValue = String(cellValue);
                                            // for filtering the retail windows based on defined retail window attribute and assign the id as the value
                                            if(cellValue != null && cellValue !== '' && vm.targetModel.modelPath === 'catalogs.articles' && (mappedField.field.field === 'RetailIntroMonthId' || mappedField.field.field === 'RetailExitMonthId')) {
                                                var articleNumberCellRef = undefined;
                                                // import by licencee
                                                var articleNameCellRef = undefined;

                                                if(vm.isUpdateArticlesByModel) { // update via model number get model number value
                                                    articleNumberCellRef = XLSX.utils.encode_cell({c: columFieldMap['ModelNumber'], r: i});
                                                } else {
                                                    if(angular.isDefined(columFieldMap['ArticleNumber']) && columFieldMap['ArticleNumber'] !== -1) {
                                                        articleNumberCellRef = XLSX.utils.encode_cell({c: columFieldMap['ArticleNumber'], r: i});
                                                    }
                                                    if(angular.isUndefined(articleNumberCellRef) && (angular.isDefined(columFieldMap['ArticleName']) && columFieldMap['ArticleName'] !== -1)) { // import by licencee
                                                        articleNameCellRef = XLSX.utils.encode_cell({c: columFieldMap['ArticleName'], r: i});
                                                    }
                                                }
                                                var articleData = undefined;
                                                if ((angular.isDefined(articleNumberCellRef) && ws[articleNumberCellRef] && ws[articleNumberCellRef].v) || (angular.isDefined(articleNameCellRef) && ws[articleNameCellRef] && ws[articleNameCellRef].v)) {
                                                    //var articlesList = api.currentCatalogArticleList;
                                                    if(angular.isDefined(ws[articleNumberCellRef]) && angular.isDefined(ws[articleNumberCellRef].v)) {
                                                        var articleNumberForImport = ws[articleNumberCellRef].v.toString();
                                                        if(vm.isUpdateArticlesByModel) { // update via model number get model number value
                                                            articleData = articlesMap[articleNumberForImport];
                                                        } else if(angular.isDefined(articleNumberCellRef)) {
                                                            articleData = articlesMap[articleNumberForImport];
                                                        }
                                                    } else if(angular.isDefined(ws[articleNameCellRef].v)) { // import by licencee
                                                        var articleNameForImport = ws[articleNameCellRef].v.toString();
                                                        // filter article list with article name
                                                        articleData = articlesMap[articleNameForImport];
                                                    }
                                                }
                                                if(angular.isDefined(articleData) && !articleData.AllowRetailWindowUpdate) {
                                                    currentRowStatus.push('Retail Window Update is restricted on article. '+ (vm.acModel[mappedField.field.field].v || mappedField.field.displayLabel) + ' value cannot be updated.');
                                                    ws[cellRef].c = 'Invalid value';
                                                    currentRowValid = false;
                                                } else if((angular.isDefined(articleData) && articleData.AllowRetailWindowUpdate) || (angular.isUndefined(articleData))) {
                                                    var retailWindowAttribute = catalogFactory.getActiveCatalog().RetailWindowAttribute;
                                                    var retailWindowAttributeCellRef = XLSX.utils.encode_cell({ c: columFieldMap[retailWindowAttribute], r: i });
                                                    // if retail window is mapped then vaidate it if not check if article exists and retailwindow attributes value of that article
                                                    if(angular.isDefined(columFieldMap[retailWindowAttribute]) && columFieldMap[retailWindowAttribute] !== -1 && angular.isDefined(ws[retailWindowAttributeCellRef])) { // attribute mapped
                                                        if(ws[retailWindowAttributeCellRef].v) {
                                                            var retailWindowAttributeValue = ws[retailWindowAttributeCellRef].v.toString();
                                                            if (mappedField.field.field === 'RetailIntroMonthId') {
                                                                var lookupDataList = api.getModel('catalogs.retailIntroMonthsForArticle').lookupData.data;
                                                                var retailwindowsWithAttributeValue = utility.filterObject(lookupDataList, { CriteriaAttributeValue: retailWindowAttributeValue, Status: 1 }, true);
                                                                var retailIntroMonths = retailwindowsWithAttributeValue.map(function (record) {
                                                                    return record.RetailIntroMonth.toLowerCase();
                                                                });
                                                                if (retailIntroMonths.indexOf(cellValue.toLowerCase()) === -1) {
                                                                    currentRowStatus.push((vm.acModel[mappedField.field.field].v || mappedField.field.displayLabel) + ' value does not match the configured Criteria Attribute Value');
                                                                    ws[cellRef].c = 'Invalid value';
                                                                    currentRowValid = false;
                                                                } else {
                                                                    cellValue = utility.filterObject(retailwindowsWithAttributeValue, { RetailIntroMonth: cellValue })[0].Id;
                                                                }
                                                            } else if (mappedField.field.field === 'RetailExitMonthId') {
                                                                var lookupDataList = api.getModel('catalogs.retailExitMonthsForArticle').lookupData.data;
                                                                var retailIntroMonthCellRef = XLSX.utils.encode_cell({ c: columFieldMap['RetailIntroMonthId'], r: i });
                                                                // RetailIntroMonthId may be unmapped (column index -1) or blank on this row, in which
                                                                // case the cell object is absent. Reading .v off it used to throw and abort the whole run.
                                                                var retailIntroMonthValue = (ws[retailIntroMonthCellRef] && ws[retailIntroMonthCellRef].v != null) ? ws[retailIntroMonthCellRef].v.toString() : '';
                                                                var filterCriteria = { CriteriaAttributeValue: retailWindowAttributeValue, RetailIntroMonth: retailIntroMonthValue, Status: 1 }
                                                                // A blank RetailIntroMonth must NOT be passed to $filter('filter'): it compares with
                                                                // actual.indexOf(expected), and indexOf('') is 0, so an empty value matches EVERY window
                                                                // and the row would silently pass with an arbitrary RetailWindowId. No value = no match.
                                                                var retailwindowsWithAttributeValue = retailIntroMonthValue === '' ? [] : utility.filterObject(lookupDataList, filterCriteria);
                                                                var retailExitMonths = retailwindowsWithAttributeValue.map(function (record) {
                                                                    return record.RetailExitMonth.toLowerCase();
                                                                });
                                                                if (retailExitMonths.indexOf(cellValue.toLowerCase()) === -1) {
                                                                    currentRowStatus.push((vm.acModel[mappedField.field.field].v || mappedField.field.displayLabel) + ' value does not match the configured Criteria Attribute Value');
                                                                    ws[cellRef].c = 'Invalid value';
                                                                    currentRowValid = false;
                                                                } else {
                                                                    var retailWindowId = utility.filterObject(retailwindowsWithAttributeValue, { RetailExitMonth: cellValue })[0].Id;
                                                                    // validate if the asigned range is with in parent range for child catalog
                                                                    if (dataSourceTypeId == 3 && angular.isDefined(articleData)) {
                                                                        var assignedShipmentWindow = utility.filterObject(activeCatalogShipmentWindowRangeList, { Id: retailWindowId })[0];
                                                                        if ((angular.isDefined(articleData.PShipmentStartDate) && articleData.PShipmentStartDate != null && articleData.PShipmentStartDate.toString().trim() !== '')) {
                                                                            if (!(moment(assignedShipmentWindow['ShipmentStartDate']).isSameOrAfter(articleData.PShipmentStartDate, 'day'))) {
                                                                                currentRowStatus.push('Assigned Retail Window is out of Parent Retail Window Range');
                                                                                ws[cellRef].c = 'Invalid value';
                                                                                currentRowValid = false;
                                                                            } else {
                                                                                cellValue = retailWindowId;
                                                                            }
                                                                        } else {
                                                                            currentRowStatus.push('Parent Retail Window is not assigned. Can not assign Retail Window');
                                                                            ws[cellRef].c = 'Invalid value';
                                                                            currentRowValid = false;
                                                                        }
                                                                    } else {
                                                                        cellValue = retailWindowId;
                                                                    }
                                                                }
                                                            }
                                                        } else {
                                                            var displayName = utility.getAttributeDisplayNameUsingSystemName(catalogAttributes, retailWindowAttribute);
                                                            currentRowStatus.push('Retail Window Attribute(' + displayName  + ') does not have value for '+ (vm.acModel[mappedField.field.field].v || mappedField.field.displayLabel) + ' validation');
                                                            ws[cellRef].c = 'Invalid value';
                                                            currentRowValid = false;
                                                        }
                                                    } else {
                                                        if (angular.isDefined(articleData)) {
                                                            // for existing articles, check if the retail window attribute value is null
                                                            if (articleData[retailWindowAttribute] == null || articleData[retailWindowAttribute].toString().trim() === '') {
                                                                var displayName = utility.getAttributeDisplayNameUsingSystemName(catalogAttributes, retailWindowAttribute);
                                                                currentRowStatus.push('Retail Window Attribute(' + displayName  + ') does not have value for '+ (vm.acModel[mappedField.field.field].v || mappedField.field.displayLabel) + ' validation');
                                                                ws[cellRef].c = 'Invalid value';
                                                                currentRowValid = false;
                                                            } else { // validate with existing article
                                                                retailWindowAttributeValue = articleData[retailWindowAttribute];
                                                                if (mappedField.field.field === 'RetailIntroMonthId') {
                                                                    var lookupDataList = api.getModel('catalogs.retailIntroMonthsForArticle').lookupData.data;
                                                                    var retailwindowsWithAttributeValue = utility.filterObject(lookupDataList, { CriteriaAttributeValue: retailWindowAttributeValue, Status: 1 }, true);
                                                                    var retailIntroMonths = retailwindowsWithAttributeValue.map(function (record) {
                                                                        return record.RetailIntroMonth.toLowerCase();
                                                                    });
                                                                    if (retailIntroMonths.indexOf(cellValue.toLowerCase()) === -1) {
                                                                        currentRowStatus.push((vm.acModel[mappedField.field.field].v || mappedField.field.displayLabel) + ' value does not match the configured Criteria Attribute Value');
                                                                        ws[cellRef].c = 'Invalid value';
                                                                        currentRowValid = false;
                                                                    } else {
                                                                        cellValue = utility.filterObject(retailwindowsWithAttributeValue, { RetailIntroMonth: cellValue })[0].Id;
                                                                    }
                                                                } else if (mappedField.field.field === 'RetailExitMonthId') {
                                                                    var lookupDataList = api.getModel('catalogs.retailExitMonthsForArticle').lookupData.data;
                                                                    var retailIntroMonthCellRef = XLSX.utils.encode_cell({ c: columFieldMap['RetailIntroMonthId'], r: i });
                                                                    // RetailIntroMonthId may be unmapped (column index -1) or blank on this row, in which
                                                                    // case the cell object is absent. Reading .v off it used to throw and abort the whole run.
                                                                    var retailIntroMonthValue = (ws[retailIntroMonthCellRef] && ws[retailIntroMonthCellRef].v != null) ? ws[retailIntroMonthCellRef].v.toString() : '';
                                                                    var filterCriteria = { CriteriaAttributeValue: retailWindowAttributeValue, RetailIntroMonth: retailIntroMonthValue, Status: 1 }
                                                                    // A blank RetailIntroMonth must NOT be passed to $filter('filter'): it compares with
                                                                    // actual.indexOf(expected), and indexOf('') is 0, so an empty value matches EVERY window
                                                                    // and the row would silently pass with an arbitrary RetailWindowId. No value = no match.
                                                                    var retailwindowsWithAttributeValue = retailIntroMonthValue === '' ? [] : utility.filterObject(lookupDataList, filterCriteria);
                                                                    var retailExitMonths = retailwindowsWithAttributeValue.map(function (record) {
                                                                        return record.RetailExitMonth.toLowerCase();
                                                                    });
                                                                    if (retailExitMonths.indexOf(cellValue.toLowerCase()) === -1) {
                                                                        currentRowStatus.push((vm.acModel[mappedField.field.field].v || mappedField.field.displayLabel) + ' value does not match the configured Criteria Attribute Value');
                                                                        ws[cellRef].c = 'Invalid value';
                                                                        currentRowValid = false;
                                                                    } else {
                                                                        var retailWindowId = utility.filterObject(retailwindowsWithAttributeValue, { RetailExitMonth: cellValue, Status: 1 })[0].Id;
                                                                        // validate if the asigned range is with in parent range for child catalog
                                                                        if (dataSourceTypeId == 3 && angular.isDefined(articleData)) {
                                                                            var assignedShipmentWindow = utility.filterObject(activeCatalogShipmentWindowRangeList, { Id: retailWindowId })[0];
                                                                            if ((angular.isDefined(articleData.PShipmentStartDate) && articleData.PShipmentStartDate != null && articleData.PShipmentStartDate.toString().trim() !== '')) {
                                                                                if (!(moment(assignedShipmentWindow['ShipmentStartDate']).isSameOrAfter(articleData.PShipmentStartDate, 'day'))) {
                                                                                    currentRowStatus.push('Assigned Retail Window is out of Parent Retail Window Range');
                                                                                    ws[cellRef].c = 'Invalid value';
                                                                                    currentRowValid = false;
                                                                                } else {
                                                                                    cellValue = retailWindowId;
                                                                                }
                                                                            } else {
                                                                                currentRowStatus.push('Parent Retail Window is not assigned. Can not assign Retail Window');
                                                                                ws[cellRef].c = 'Invalid value';
                                                                                currentRowValid = false;
                                                                            }
                                                                        } else {
                                                                            cellValue = retailWindowId;
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        } else {
                                                            var displayName = utility.getAttributeDisplayNameUsingSystemName(catalogAttributes, retailWindowAttribute);
                                                            currentRowStatus.push('Retail Window Attribute(' + displayName  + ') is not mapped for new article '+ (vm.acModel[mappedField.field.field].v || mappedField.field.displayLabel) + ' validation');
                                                            ws[cellRef].c = 'Invalid value';
                                                            currentRowValid = false;
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                        else {
                                            // if stocks enabled store article numbers
                                            if(vm.validateCustomerAssignedStocks) {
                                                vm.articleIdNumberMap[res.id] = cellValue;
                                            }
                                            if(mappedField.field.inputType === 'color-palette') {
                                                // color palette values are stores as key value pair
                                                var objectVal = {};
                                                objectVal[res.id] = res.ColorName
                                                cellValue = angular.toJson(objectVal);// for color palette type attribute save the values as json object {color id: color value}
                                            }
                                            else {
                                                cellValue = res.id;
                                            }
                                        }
                                    }
                                    break;
                                case 'lookup-many':
                                    if (angular.isDefined(cellValue)) {
                                        var lookupValues = cellValue.split(',');
                                        var cellValueArray = [];
                                        for (var index = 0; index < lookupValues.length; index++) {
                                            var res = findInLookup(mappedField.field, lookupValues[index]);
                                            if (angular.isUndefined(res)) {
                                                currentRowStatus.push((vm.acModel[mappedField.field.field].v || mappedField.field.displayLabel ) + ' contains a value (' + lookupValues[index] + ') that cannot be found in the list');
                                                ws[cellRef].c = 'Invalid value';
                                                currentRowValid = false;
                                                break;
                                            }
                                            if(angular.isDefined(mappedField.field.useLookupName) && mappedField.field.useLookupName === true) {
                                                cellValueArray.push(cellValue);
                                            }
                                            else {
                                                cellValueArray.push(res.id);
                                            }
                                        }
                                        cellValue = cellValueArray;
                                    } else {
                                        cellValue = [];
                                    }
                                    break;

                                case 'articlenumber':
                                if (angular.isDefined(cellValue)) {
                                    var res = findInLookup(mappedField.field, cellValue);
                                    if (angular.isUndefined(res)) {
                                        currentRowStatus.push((vm.acModel[mappedField.field.field].v || mappedField.field.displayLabel ) + ' contains a value that cannot be found in the list');
                                        ws[cellRef].c = 'Invalid value';
                                        currentRowValid = false;
                                        continue;
                                    }
                                    if(angular.isDefined(mappedField.field.useLookupName) && mappedField.field.useLookupName === true) {
                                        cellValue = String(cellValue);
                                    }
                                    else {
                                        cellValue = String(res.Id);
                                    }
                                }
                                break;

                                case 'tags':
                                case 'list':
                                case 'multi-value':
                                case 'parent-model-type':
                                    if(mappedField.field.inputType === 'tags' && mappedField.field.inputSubType !== 'multi-value' && mappedField.field.tagSeparator === '|') {
                                        if (angular.isDefined(cellValue)) {
                                            cellValue = cellValue.toString().replace(/[\r\n]+/gm,'');
                                            // remove trailing spaces
                                            var tagsArray = cellValue.split(mappedField.field.tagSeparator).map(function(tag) {
                                                return tag.trim();
                                            });
                                            var counts = [];
                                            var uniqueValues = [];
                                            for (var index = 0; index < tagsArray.length; index++) {
                                                if(counts[tagsArray[index]] === undefined) {
                                                    counts[tagsArray[index]] = 1;
                                                    uniqueValues.push(tagsArray[index])
                                                } else {
                                                    currentRowStatus.push((vm.acModel[mappedField.field.field].v || mappedField.field.displayLabel ) + ' contains a duplicate value');
                                                    ws[cellRef].c = 'Duplicate value';
                                                    currentRowValid = false;
                                                    break;
                                                }
                                            }
                                            cellValue = uniqueValues;
                                        } else {
                                            cellValue = [];
                                        }
                                    } else {
                                        if(mappedField.field.type === 'int') {
                                            if (angular.isUndefined(cellValue) || cellValue == null || cellValue.toString().trim() === '') {
                                                cellValue = 0;
                                            } else if (!angular.isNumber(cellValue)) {
                                                currentRowStatus.push((vm.acModel[mappedField.field.field].v || mappedField.field.displayLabel) + ' is not a valid number');
                                                ws[cellRef].c = 'Invalid number';
                                                currentRowValid = false;
                                                continue;
                                            }
                                        } else if(mappedField.field.type === 'text' && mappedField.field.inputSubType !== 'multi-value') {
                                            if(angular.isUndefined(cellValue) || cellValue == null) {
                                                cellValue = '';
                                            } else {
                                                cellValue = String(cellValue).trim().replace(/[\u00A0\u00AD\u200B-\u200D\uFEFF\u2028\u2029\u2060]/g, ''); // remove all invisible special characters
                                            }
                                        }
                                        var valuesArray = [cellValue];
                                        if(mappedField.field.inputType === 'multi-value' || mappedField.field.inputSubType === 'multi-value') {
                                            var valuesArray = cellValue.toString().trim().split('|').map(function(value) {
                                                return value.trim().replace(/[\u00A0\u00AD\u200B-\u200D\uFEFF\u2028\u2029\u2060]/g, ''); // remove all invisible special characters
                                            });
                                            cellValue = valuesArray;
                                        }
                                        if(cellValue !== '' && cellValue !== null) {
                                            var replacedValues = [];
                                            angular.forEach(valuesArray, function(cValue) {
                                                var attribute = utility.filterObject(catalogAttributes, {AttributeSystemName: mappedField.field.field}, true)[0];
                                                if(angular.isDefined(attribute.AllowedValues) && attribute.AllowedValues !== null && (angular.isArray(attribute.AllowedValues) && attribute.AllowedValues.length)) {
                                                    var attributeAllowedValues = attribute.AllowedValues.map(function(value) {
                                                        return value.toLowerCase();
                                                    });
                                                    if(angular.isDefined(cValue) && cValue !== null && cValue !== '' && cValue !== 0) {
                                                        var valueIndex = attributeAllowedValues.indexOf(cValue.toString().toLowerCase());
                                                        if (valueIndex === -1) {
                                                            currentRowStatus.push((vm.acModel[mappedField.field.field].v || mappedField.field.displayLabel) + ' value('+ cValue +') is not part of attribute vetting list');
                                                            ws[cellRef].c = 'Invalid value';
                                                            currentRowValid = false;
                                                        } else if(vm.criteriaV2Map[mappedField.field.field]) {
                                                            // CriteriaV2 (preferred over OLD Criteria): value must be in the matched rule's AllowedValues; [] (no rule matched) => reject
                                                            var getDependentValueForCriteriaV2 = function(dependentField) {
                                                                return resolveDependentAttrValue(dependentField, i, rowData);
                                                            };
                                                            var criteriaV2AllowedValues = utility.getCriteriaV2AllowedValues(vm.criteriaV2Map[mappedField.field.field], getDependentValueForCriteriaV2);
                                                            var criteriaV2AllowedLower = criteriaV2AllowedValues.map(function(value) { return value.toString().toLowerCase(); });
                                                            if(criteriaV2AllowedLower.indexOf(cValue.toString().toLowerCase()) === -1) {
                                                                currentRowStatus.push((vm.acModel[mappedField.field.field].v || mappedField.field.displayLabel) + ' value does not match the attribute criteria');
                                                                ws[cellRef].c = 'Invalid value';
                                                                currentRowValid = false;
                                                            } else { // set the value from the vetting list
                                                                replacedValues.push(attribute.AllowedValues[valueIndex]);
                                                            }
                                                        } else if(attribute.Criteria.length > 0 && vm.dependingAttributesMap.length > 0) {
                                                            var attributeCriteria = {};
                                                            angular.forEach(vm.dependingAttributesMap, function(criteriaAttr) {
                                                                for(var key2 in criteriaAttr) {
                                                                    if(criteriaAttr.hasOwnProperty(key2)) {
                                                                        if(key2.toLocaleLowerCase() === mappedField.field.field.toLowerCase()) {
                                                                            attributeCriteria = criteriaAttr[key2];
                                                                            break;
                                                                        }
                                                                    }
                                                                }
                                                            });
                                                            var isCriteriaNotSatisfied = false;
                                                            for(var key1 in attributeCriteria) {
                                                                var dependentAttributeField = key1;
                                                                if(attributeCriteria.hasOwnProperty(key1)) {
                                                                    var dependentAttrValue = resolveDependentAttrValue(key1, i, rowData);
                                                                    if(dependentAttrValue != null) {
                                                                        if(angular.isDefined(attributeCriteria[dependentAttributeField][dependentAttrValue])) {
                                                                            var index = attributeCriteria[dependentAttributeField][dependentAttrValue].indexOf(cValue.toString().toLowerCase());
                                                                            if (index === -1) {
                                                                                isCriteriaNotSatisfied = true;
                                                                            }
                                                                        } else {
                                                                            isCriteriaNotSatisfied = true;
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                            if(isCriteriaNotSatisfied) {
                                                                currentRowStatus.push((vm.acModel[mappedField.field.field].v || mappedField.field.displayLabel) + ' value does not match the attribute criteria');
                                                                ws[cellRef].c = 'Invalid value';
                                                                currentRowValid = false;
                                                            } else { // set the value from the vetting list
                                                                replacedValues.push(attribute.AllowedValues[valueIndex]);
                                                            }
                                                        } else {
                                                            replacedValues.push(attribute.AllowedValues[valueIndex]);
                                                        }
                                                    }
                                                } else {
                                                    replacedValues.push(cValue);
                                                }
                                            });
                                            // to avoid case sensitivity issue
                                            if (currentRowValid) {
                                                cellValue = (mappedField.field.inputType === 'multi-value' || mappedField.field.inputSubType === 'multi-value') ? replacedValues : replacedValues[0];
                                            }
                                        }
                                    }
                                    break;

                                case 'target-attributes-json-str':
                                    if (angular.isDefined(cellValue)) {
                                        cellValue =  String(cellValue);
                                    } else {
                                        cellValue = '';
                                    }

                                    break;

                                case 'array':
                                    if (angular.isDefined(cellValue)) {
                                        cellValue =  String(cellValue);
                                    } else {
                                        cellValue = '';
                                    }

                                    break;

                                case 'icon':
                                    // not implemented for icon
                                    break;

                                case 'switch':
                                case 'status-segmentation':
                                    if (catalogFactory.getActiveCatalog().SegmentationPlanningEnable === 1 && (mappedField.field.inputType === 'status-segmentation' || vm.targetModel.modelPath === 'catalogArticles.segmentation')) {
                                        // Segmentation planning import. Covers BOTH the linear view ('status-segmentation' field)
                                        // AND the matrix/tabular view, whose per-segmentation columns use inputType 'switch' (model
                                        // 'catalogArticles.segmentation'). Accept configured planning values only; the matched value is
                                        // stored verbatim. A blank cell or 'No' leaves the segmentation unassigned. This must run before
                                        // the generic boolean-switch logic below, which would otherwise convert/reject these values
                                        // (e.g. RECOMMENDED->Assorted, None->invalid) and then fail the configured allowed-values check.
                                        // Note: customer segmentation ('catalogCustomers.segmentation') has no planning and is intentionally
                                        // excluded here, so it continues through the generic Yes/No switch unchanged.
                                        var trimmedPlanningValue = (cellValue == null) ? '' : cellValue.toString().trim();
                                        var upperPlanningValue = trimmedPlanningValue.toUpperCase();
                                        var matchedPlanningValue = api.matchSegmentationPlanningValue(trimmedPlanningValue);
                                        if (trimmedPlanningValue === '' || upperPlanningValue === 'NO' || matchedPlanningValue) {
                                            cellValue = matchedPlanningValue || trimmedPlanningValue;
                                        } else if (upperPlanningValue === 'YES' || upperPlanningValue === 'TRUE' || upperPlanningValue === '1') {
                                            // Assigned without a specific planning value (e.g. an exported 'Yes' cell, or legacy assignment).
                                            // Normalize to the configured default so it re-imports as an assignment instead of being rejected.
                                            cellValue = api.getSegmentationPlanningDefault();
                                        } else {
                                            currentRowStatus.push((vm.acModel[mappedField.field.field].v || mappedField.field.displayLabel ) + " contains invalid value " + ws[cellRef].w);
                                            ws[cellRef].c = mappedField.field.field + " contains invalid value " + ws[cellRef].w;
                                            currentRowValid = false;
                                            continue;
                                        }
                                        break;
                                    }
                                    if ( cellValue != '' && cellValue != null && cellValue !== 1 && cellValue !== 0 &&  cellValue.toString().trim().toUpperCase() !== 'TRUE' && cellValue.toString().trim().toUpperCase() !== 'FALSE' && cellValue.toString().trim().toUpperCase() !== 'YES' && cellValue.toString().trim().toUpperCase() !== 'NO'
                                    && cellValue.toString().trim().toUpperCase() !== 'ASSORTED' && cellValue.toString().trim().toUpperCase() !== 'PLANNED' && cellValue.toString().trim().toUpperCase() !== 'RECOMMENDED' && cellValue.toString().trim().toUpperCase() !== 'AVAILABLE' && cellValue.toString().trim().toUpperCase() !== 'NOT AVAILABLE'
                                    && cellValue.toString().trim().toUpperCase() !== 'ACTIVE' && cellValue.toString().trim().toUpperCase() !== 'INACTIVE') {
                                        currentRowStatus.push((vm.acModel[mappedField.field.field].v || mappedField.field.displayLabel ) + " contains invalid value " + ws[cellRef].w);
                                        ws[cellRef].c = mappedField.field.field + " contains invalid value " + ws[cellRef].w;
                                        currentRowValid = false;
                                        continue;
                                    } else if (cellValue == null || cellValue == '') {
                                        cellValue = 'FALSE';
                                    } else if (cellValue === 1 || cellValue.toString().trim().toUpperCase() === 'TRUE' || cellValue.toString().trim().toUpperCase() === 'YES' || cellValue.toString().trim().toUpperCase() === 'ASSORTED' || cellValue.toString().trim().toUpperCase() === 'PLANNED' || cellValue.toString().trim().toUpperCase() === 'RECOMMENDED' || cellValue.toString().trim().toUpperCase() === 'AVAILABLE' || cellValue.toString().trim().toUpperCase() === 'ACTIVE') {
                                        cellValue = cellValue.toString().trim().toUpperCase() === 'ASSORTED' || cellValue.toString().trim().toUpperCase() === 'PLANNED' ? cellValue : cellValue.toString().trim().toUpperCase() === 'RECOMMENDED' ? 'Assorted' : cellValue.toString().trim().toUpperCase() === 'AVAILABLE' ? 'Planned' : 'TRUE';
                                    } else if (cellValue === 0 || cellValue.toString().trim().toUpperCase() === 'FALSE' || cellValue.toString().trim().toUpperCase() === 'INACTIVE' || cellValue.toString().trim().toUpperCase() === 'NO' || cellValue.toString().trim().toUpperCase() !== 'NOT AVAILABLE') {
                                        cellValue = 'FALSE';
                                    }
                                    break;

                                default:
                                    if (angular.isDefined(cellValue)) {
                                        //When date value assigned to text field we will display the date value in UI.
                                        if(isNaN(cellFormattedValue) && !isNaN(cellValue)) { //Checked if cellFormattedValue is not a number and cellValue is number which is the converted number
                                            var formattedDate = new Date(cellFormattedValue);
                                            if(isNaN(formattedDate.getTime())) { //Check date or not
                                                cellValue = String(cellValue).trim().replace(/[\u00A0\u00AD\u200B-\u200D\uFEFF\u2028\u2029\u2060]/g, ''); // remove all invisible special characters, Return string if not date
                                            } else {
                                                cellValue = $filter('date')(formattedDate,'MM-dd-yyyy'); // return date
                                                ws[cellRef].t = 'd';
                                            }
                                        } else {
                                            cellValue = String(cellValue).trim().replace(/[\u00A0\u00AD\u200B-\u200D\uFEFF\u2028\u2029\u2060]/g, ''); // remove all invisible special characters, Return string as it is
                                            // for checking conditional color
                                            if(vm.targetModel.modelPath === 'catalogs.articleColor' && conditionalColorsCriteria.length && angular.isDefined(mappedField.field.isConditionalColorVettingListArticle) && mappedField.field.isConditionalColorVettingListArticle) {
                                                var articleNumberCellRef = XLSX.utils.encode_cell({c: columFieldMap['ArticleNumber'], r: i});
                                                if(ws[articleNumberCellRef] && ws[articleNumberCellRef].v) {
                                                    var articleNumberForColor = ws[articleNumberCellRef].v.toString();
                                                    var lookupDataList = api.getModel('catalogs.colorDefinition').lookupData.data;
                                                    var articleData =  articlesMap[articleNumberForColor]
                                                    if(angular.isDefined(articleData)) {
                                                        lookupDataList = utility.filterArticleColors(lookupDataList, [articleData], conditionalColorsCriteria);
                                                        var colorsArray = lookupDataList.map(function(color) {
                                                            return color['value'].toLowerCase();
                                                        });
                                                        if(colorsArray.indexOf(cellValue.toLowerCase()) === -1) {
                                                            currentRowStatus.push((vm.acModel[mappedField.field.field].v || mappedField.field.displayLabel) + ' value does not match the configured color criteria');
                                                            ws[cellRef].c = 'Invalid value';
                                                            currentRowValid = false;
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    } else {
                                        cellValue = '';
                                    }
                                    break;
                            }

                            // Reject cells whose delimited value contains duplicates. Some fields
                            // (e.g. master size scales' Sizes) are imported as free text, so the tag
                            // de-dupe above never runs for them; enforce uniqueness here when a field
                            // opts in via 'duplicateCheckSeparator'.
                            if (mappedField.field.duplicateCheckSeparator && angular.isDefined(cellValue) && cellValue !== null && cellValue.toString().trim() !== '') {
                                var dupCheckValues = cellValue.toString().split(mappedField.field.duplicateCheckSeparator);
                                var dupCheckSeen = [];
                                var dupCheckHasDuplicate = false;
                                for (var dupCheckIndex = 0; dupCheckIndex < dupCheckValues.length; dupCheckIndex++) {
                                    var dupCheckValue = dupCheckValues[dupCheckIndex].trim();
                                    if (dupCheckValue === '') {
                                        continue;
                                    }
                                    if (dupCheckSeen.indexOf(dupCheckValue) !== -1) {
                                        dupCheckHasDuplicate = true;
                                        break;
                                    }
                                    dupCheckSeen.push(dupCheckValue);
                                }
                                if (dupCheckHasDuplicate) {
                                    currentRowStatus.push((vm.acModel[mappedField.field.field].v || mappedField.field.displayLabel) + ' contains a duplicate value');
                                    ws[cellRef].c = 'Duplicate value';
                                    currentRowValid = false;
                                    continue;
                                }
                            }

                            //Validate max length
                            if (mappedField.field.validation.maxLen > 0 && cellValue && cellValue.length > mappedField.field.validation.maxLen)
                            {
                                currentRowStatus.push((vm.acModel[mappedField.field.field].v || mappedField.field.displayLabel ) + ' exceeds the maximum allowed length of ' + mappedField.field.validation.maxLen);
                                ws[cellRef].c = 'Exceeds the maximum allowed length of ' + mappedField.field.validation.maxLen;
                                currentRowValid = false;
                                continue;
                            }

                            //Validate min length
                            if (mappedField.field.validation.minLen > 0 && cellValue && cellValue.length < mappedField.field.validation.minLen)
                            {
                                currentRowStatus.push((vm.acModel[mappedField.field.field].v || mappedField.field.displayLabel ) + ' must be of minimum ' + mappedField.field.validation.minLen + ' characters');
                                ws[cellRef].c = 'Must be of minimum ' + mappedField.field.validation.minLen + ' characters';
                                currentRowValid = false;
                                continue;
                            }

                            //Validate regex pattern
                            if (mappedField.field.validation.pattern && mappedField.field.validation.pattern.length > 0)
                            {
                                var patt = new RegExp(mappedField.field.validation.pattern);
                                if (!patt.test(cellValue)) {
                                    currentRowStatus.push((vm.acModel[mappedField.field.field].v || mappedField.field.displayLabel ) + ' does not match the required format: ' + $filter('translate')(mappedField.field.validation.messages.pattern));
                                    ws[cellRef].c = 'Does not match the required format: ' + mappedField.field.validation.pattern;
                                    currentRowValid = false;
                                    continue;
                                }
                            }

                            // check if locked at article state level
                            if (mappedField.field.validation.checkIfPriceGroupLockedAtArticleState) {
                                var catalogPriceGroupList = catalogFactory.getActiveCatalogDetails().CatalogPriceGroupList;
                                var assignedPriceGroup = {};
                                if(angular.isDefined(mappedField.field.priceGroupId)) {
                                    assignedPriceGroup = utility.filterObject(catalogPriceGroupList, {Id: mappedField.field.priceGroupId}, true)[0];
                                } else if(angular.isDefined(rowData['PriceGroupId'])) { // prices linear module
                                    assignedPriceGroup = utility.filterObject(catalogPriceGroupList, {Id: rowData['PriceGroupId']}, true)[0];
                                }
                                // IsPriceByStyleApply is enabled check the article state with height model state rank
                                if(catalogFactory.getActiveCatalog().IsPriceByStyleApply) {
                                    if(highestModelStateRankArticleState && (assignedPriceGroup && angular.isDefined(assignedPriceGroup.StateRank) && assignedPriceGroup.StateRank !== null)) {
                                        if(!utility.isObjectEmpty(highestModelStateRankArticleState) && (highestModelStateRankArticleState.StateRank >= assignedPriceGroup.StateRank)) {
                                            currentRowStatus.push((vm.acModel[mappedField.field.field].v || mappedField.field.displayLabel) + " is set as non editable at state level. Please remove the mapping.");
                                            ws[cellRef].c = mappedField.field.field + " contains invalid value " + ws[cellRef].w;
                                            currentRowValid = false;
                                        }
                                    }
                                } else { // IsPriceByStyleApply is disabled check the article state with height article state rank
                                    if(highestArticleStateRankArticleState && (assignedPriceGroup && angular.isDefined(assignedPriceGroup.StateRank) && assignedPriceGroup.StateRank !== null)) {
                                        if(!utility.isObjectEmpty(highestArticleStateRankArticleState) && (highestArticleStateRankArticleState.StateRank >= assignedPriceGroup.StateRank)) {
                                            currentRowStatus.push((vm.acModel[mappedField.field.field].v || mappedField.field.displayLabel) + " is set as non editable at state level. Please remove the mapping.");
                                            ws[cellRef].c = mappedField.field.field + " contains invalid value " + ws[cellRef].w;
                                            currentRowValid = false;
                                        }
                                    }
                                }

                                // check the pattern validaion for price groups if its IsMandatory
                                if(assignedPriceGroup) {
                                    var pattern = '^[+]?\\d+([.]\\d{0,'+ api.numberOfDecimalsForPrices +'})?$';
                                    var patternMessage = 'Invalid price value, Should be a positive number and not contain more than '+ api.numberOfDecimalsForPrices +' decimals.';
                                    if(assignedPriceGroup.IsMandatory) {
                                        pattern = '^[+]?((\\d*[1-9]\\d*)([.]\\d{0,' + api.numberOfDecimalsForPrices + '})?)$'
                                        patternMessage = 'Invalid price value, Should be greater than 0 with no more than '+ api.numberOfDecimalsForPrices +' decimals.';
                                    }
                                    var patt = new RegExp(pattern);
                                    if (!patt.test(cellValue)) {
                                        currentRowStatus.push((vm.acModel[mappedField.field.field].v || mappedField.field.displayLabel ) + ' does not match the required format: ' + patternMessage);
                                        ws[cellRef].c = 'Does not match the required format: ' + patternMessage;
                                        currentRowValid = false;
                                        continue;
                                    }
                                }
                            }

                            listData = listData && listData.length ? listData : api.currentCatalogArticleList;
                            var modelData = undefined;
                            var modelAttribute = catalogFactory.getActiveCatalogDetails().ModelAttribute;
                            var articleAttribute = catalogFactory.getActiveCatalogDetails().ArticleAttribute;
                            var articleNumberCellRef = undefined;
                            if(angular.isDefined(columFieldMap['ArticleNumber']) && columFieldMap['ArticleNumber'] !== -1) {
                                articleNumberCellRef = XLSX.utils.encode_cell({c: columFieldMap['ArticleNumber'], r: i});
                                if(ws[articleNumberCellRef] && ws[articleNumberCellRef].v) {
                                    var articleNumberForImport = ws[articleNumberCellRef].v.toString();
                                    modelData = articlesMap[articleNumberForImport]
                                }
                            }
                            else if(angular.isUndefined(articleNumberCellRef) && (angular.isDefined(columFieldMap['ModelNumber']) && columFieldMap['ModelNumber'] !== -1)) { // import by licencee
                                articleNumberCellRef = XLSX.utils.encode_cell({c: columFieldMap['ModelNumber'], r: i});
                                if(ws[articleNumberCellRef] && ws[articleNumberCellRef].v) {
                                    var articleNumberForImport = ws[articleNumberCellRef].v.toString();
                                    modelData = articlesMap[articleNumberForImport]
                                }
                            }
                            else if((vm.action === 'setSizesByLicenseeModelNumber' || vm.action === 'importByLicensee') && (angular.isDefined(columFieldMap[modelAttribute])) && columFieldMap[modelAttribute] !== -1) {
                                articleNumberCellRef = XLSX.utils.encode_cell({c: columFieldMap[modelAttribute], r: i});
                                if(ws[articleNumberCellRef] && ws[articleNumberCellRef].v) {
                                    var licenseeNumberForImport = ws[articleNumberCellRef].v.toString();
                                    var licenseeArticles = articlesMap[licenseeNumberForImport];
                                    if(licenseeArticles && licenseeArticles.length) {
                                        modelData = licenseeArticles[0];
                                    }
                                }
                            }

                            //Validate for exist constraints
                            if(mappedField.field.validation.dataExistConstraints) {
                                if (angular.isDefined(cellValue)) {
                                    var rslt = findInExistConstraintsData(mappedField.field, cellValue, rowData);
                                    if (angular.isUndefined(rslt) && !mappedField.field.validation.dataExistConstraints.shouldNotExist) {
                                        var errorMessage = angular.isDefined(mappedField.field.validation.dataExistConstraints.errorMessage)
                                            ? mappedField.field.validation.dataExistConstraints.errorMessage
                                            :  'contains a value that cannot be found in database';
                                        currentRowStatus.push((vm.acModel[mappedField.field.field].v || mappedField.field.displayLabel) + ' ' +errorMessage);
                                        ws[cellRef].c = 'Invalid value';
                                        currentRowValid = false;
                                        continue;
                                    } else if(angular.isDefined(rslt) && mappedField.field.validation.dataExistConstraints.shouldNotExist) {
                                        var validRecord = true;
                                        //Specific for catalogs delivery dates module.
                                        //when description already exist in db and its delivery date is same then we need to allow the record
                                        if(angular.isDefined(mappedField.field.validation.dataExistConstraints.isCatalogCRD) && mappedField.field.validation.dataExistConstraints.isCatalogCRD) {
                                            var deliveryDateEntered = rowData['CustomerRequiredDate'];
                                            //if the imported delivery date and db record's delivery date is same then its a valid entry for update
                                            if(rslt.CustomerRequiredDate === deliveryDateEntered) {
                                                validRecord = false;
                                            }
                                        }

                                        if(validRecord) {
                                            var errorMessage = 'already exist in database';//Show error message if value already exists in DB
                                            currentRowStatus.push((vm.acModel[mappedField.field.field].v || mappedField.field.displayLabel ) + ' ' +errorMessage);
                                            ws[cellRef].c = 'Invalid value';
                                            currentRowValid = false;
                                        }
                                    }
                                    if(vm.action === 'setSizesByLicenseeModelNumber' || vm.action === 'importByLicensee' || mappedField.field.field === 'MasterSizeScale' || mappedField.field.field === 'SizeScale' || mappedField.field.field === 'StateName') {
                                        // validate size scales and check for obsolete size scales
                                        if(mappedField.field.field === 'MasterSizeScale' || mappedField.field.field === 'SizeScale') {
                                            // check if the assigned Size Scale is same as the Excel Size Scale, id its same and SizeScale is obsolete we need to keep as it is else show error
                                            if (vm.action === 'SetSizes' || vm.action === 'setSizesByLicenseeModelNumber') {
                                                if(modelData) {
                                                    // check if the MasterSizeScale's criteria
                                                    if (mappedField.field.field === 'MasterSizeScale') {
                                                        if (angular.isDefined(rslt) && angular.isDefined(rslt.Criteria) && rslt.Criteria !== '' && rslt.Criteria.length) {
                                                            try {
                                                                var criteriaJSON = JSON.parse(rslt.Criteria);
                                                                var validItemsCount = 0;
                                                                for (var key in criteriaJSON) {
                                                                    if (criteriaJSON.hasOwnProperty(key)) {
                                                                        var crts = criteriaJSON[key];
                                                                        var isValid = false;
                                                                        if (!angular.isArray(criteriaJSON[key])) {
                                                                            crts = [criteriaJSON[key]];
                                                                        }
                                                                        angular.forEach(crts, function (crt) {
                                                                            if (crt.toString().toLowerCase() === modelData[key].toString().toLowerCase()) {
                                                                                isValid = true;
                                                                            }
                                                                        });
                                                                        if (isValid) {
                                                                            validItemsCount++;
                                                                        }
                                                                    }
                                                                }
                                                                if (validItemsCount !== Object.keys(criteriaJSON).length) {
                                                                    currentRowStatus.push((vm.acModel[mappedField.field.field].v || mappedField.field.displayLabel ) + ' value does not match the configured Criteria');
                                                                    ws[cellRef].c = 'Invalid Master Size Scale';
                                                                    currentRowValid = false;
                                                                }
                                                            } catch (error) {
                                                                console.warn("Criteria : Invalid JSON format");
                                                                continue;
                                                            }
                                                        }
                                                    }
                                                    if((mappedField.field.field === 'MasterSizeScale' && modelData.MasterSizeScale !== String(cellValue) && rslt.IsObsolete) ||
                                                    (mappedField.field.field === 'SizeScale' && modelData.SizeScale !== String(cellValue) && rslt.IsObsolete)) {
                                                        currentRowStatus.push((vm.acModel[mappedField.field.field].v || mappedField.field.displayLabel ) + ' value is obsolete.');
                                                        ws[cellRef].c = 'Obsolete Size Scale';
                                                        currentRowValid = false;
                                                        continue;
                                                    }
                                                }
                                            }
                                            else { // import/import by licensee
                                                if (angular.isUndefined(modelData)) {
                                                    // check if the MasterSizeScale's criteria
                                                    if (mappedField.field.field === 'MasterSizeScale' || mappedField.field.field === 'SizeScale') {
                                                        if (angular.isDefined(rslt) && angular.isDefined(rslt.Criteria) && rslt.Criteria !== '' && rslt.Criteria.length) {
                                                            try {
                                                                var criteriaJSON = JSON.parse(rslt.Criteria);
                                                                var validItemsCount = 0;
                                                                for (var key in criteriaJSON) {
                                                                    if (criteriaJSON.hasOwnProperty(key)) {
                                                                        var crts = criteriaJSON[key];
                                                                        var isValid = false;
                                                                        if (!angular.isArray(criteriaJSON[key])) {
                                                                            crts = [criteriaJSON[key]];
                                                                        }
                                                                        angular.forEach(crts, function (crt) {
                                                                            var attrValue = rowData[key]
                                                                            if(!rowData[key]) {
                                                                                var attrCellRef = XLSX.utils.encode_cell({c: columFieldMap[key], r: i});
                                                                                attrValue = ws[attrCellRef].v;
                                                                            }
                                                                            if (crt.toString().toLowerCase() === attrValue.toString().toLowerCase()) {
                                                                                isValid = true;
                                                                            }
                                                                        });
                                                                        if (isValid) {
                                                                            validItemsCount++;
                                                                        }
                                                                    }
                                                                }
                                                                if (validItemsCount !== Object.keys(criteriaJSON).length) {
                                                                    currentRowStatus.push((vm.acModel[mappedField.field.field].v || mappedField.field.displayLabel ) + ' value does not match the configured Criteria');
                                                                    ws[cellRef].c = 'Invalid Master Size Scale';
                                                                    currentRowValid = false;
                                                                }
                                                            } catch (error) {
                                                                console.warn("Criteria : Invalid JSON format");
                                                                continue;
                                                            }
                                                        }
                                                    }
                                                    if((mappedField.field.field === 'MasterSizeScale' && rslt.IsObsolete) || (mappedField.field.field === 'SizeScale' && rslt.IsObsolete)) {
                                                        currentRowStatus.push((vm.acModel[mappedField.field.field].v || mappedField.field.displayLabel ) + ' value is obsolete.');
                                                        ws[cellRef].c = 'Obsolete Size Scale';
                                                        currentRowValid = false;
                                                        continue;
                                                    }
                                                }
                                            }
                                        }
                                        else if(mappedField.field.field === 'StateName') { // validate state required properties
                                            if(angular.isUndefined(modelData)) {
                                                if(angular.isDefined(cellValue) && cellValue !== '') {
                                                    if (rslt.Status !== 1 || (api.allowedStatesForCreateArticleConfig.length !== 0 && !api.allowedStatesForCreateArticleConfig.includes(rslt.StateName.toLowerCase()))) {
                                                        if(rslt.Status !== 1) {
                                                            currentRowStatus.push('Cannot create article in the selected state, as creating an article is not allowed in the deactivated ' + rslt.StateName + ' state.');
                                                        }
                                                        else {
                                                            currentRowStatus.push('Cannot create article in the selected state, as it is not allowed to create article in ' + rslt.StateName + ' state.');
                                                        }
                                                        ws[cellRef].c = 'In valid state';
                                                        currentRowValid = false;
                                                        continue
                                                    }
                                                    else {
                                                        // if article doesnot exists check if the state request attributes are added
                                                        var selectedState = utility.filterObject(api.articleStatesList, { StateId: rslt.StateId }, true)[0];
                                                        var requiredAttributes = selectedState.RequiredAttributes;
                                                        var isSizeScaleRequired = selectedState.IsSizeScaleRequired;
                                                        var isPrimaryColorRequired = selectedState.IsPrimaryColorRequired;

                                                        var articlesRequiredAttributes = [];
                                                        var doesArticleMeetSelectedStateRequirement = true;

                                                        if (requiredAttributes.length || isSizeScaleRequired || isPrimaryColorRequired) {
                                                            var requiredAttibutesWithIsValid = articlesFactory.doesArticlesMeetSelectedStateRequirement([mappedColumncRowValues], requiredAttributes, isSizeScaleRequired, isPrimaryColorRequired, true);
                                                            doesArticleMeetSelectedStateRequirement = requiredAttibutesWithIsValid.doesArticlesMeetSelectedStateRequirement;
                                                            articlesRequiredAttributes = requiredAttibutesWithIsValid.articlesRequiredAttributes;
                                                        }
                                                        if (!doesArticleMeetSelectedStateRequirement) {
                                                            var requiredAttributesErrorMessages = 'Can not create article in selected state,';
                                                            for (var reqKey in articlesRequiredAttributes) {
                                                                var reqAttributeDisplayNames = [];
                                                                if (!articlesRequiredAttributes[reqKey].doesArticleMeetSelectedStateRequirement) {
                                                                    angular.forEach(articlesRequiredAttributes[reqKey]['articlesRequiredAttributesList'], function(attrSystemName) {
                                                                        if(attrSystemName !== 'ColorId' && attrSystemName !== 'SizeScaleId') {
                                                                            reqAttributeDisplayNames.push(utility.getAttributeDisplayNameUsingSystemName(catalogFactory.getActiveCatalogDetails().AssignedCatalogAttributes, attrSystemName));
                                                                        } else {
                                                                            var staticAttributeDisplayName = attrSystemName === 'ColorId' ? 'Primary Color' : attrSystemName === 'SizeScaleId' ? 'Size Scale' : '';
                                                                            reqAttributeDisplayNames.push(staticAttributeDisplayName);
                                                                        }
                                                                    });
                                                                    requiredAttributesErrorMessages = requiredAttributesErrorMessages + ' article does not have value for required attribute(s) ' + reqAttributeDisplayNames.join(', ');
                                                                }
                                                            }
                                                            currentRowStatus.push(requiredAttributesErrorMessages);
                                                            ws[cellRef].c = 'Existing Article';
                                                            currentRowValid = false;
                                                            continue;
                                                        }
                                                    }
                                                }
                                                else if(api.defaultCreateArticleState !== '') { // set default state if its configured
                                                    var defaultState = utility.filterObject(api.articleStatesList, {StateName: api.defaultCreateArticleState, Status: 1}, true)[0];
                                                    if(defaultState) {
                                                        if(api.allowedStatesForCreateArticleConfig.length !== 0) {
                                                            if(api.allowedStatesForCreateArticleConfig.includes(api.defaultCreateArticleState.toLowerCase())) {
                                                                cellValue = defaultState.StateName;
                                                            }
                                                        }
                                                        else { // asign default value
                                                            cellValue = defaultState.StateName;
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                    cellValue = String(cellValue);
                                }
                            }

                            // check valid JSON or not
                            if(mappedField.field.validation.checkIfValidJson) {
                                if ((angular.isDefined(cellValue) && cellValue !== '' && !utility.isValidJSON(cellValue)) ||
                                (angular.isDefined(cellValue) && utility.isValidJSON(cellValue) && utility.isObjectEmpty(JSON.parse(cellValue)))) {
                                    currentRowStatus.push((vm.acModel[mappedField.field.field].v || mappedField.field.displayLabel ) + ' value is not a valid JSON');
                                    ws[cellRef].c = 'Invalid JSON Format';
                                    currentRowValid = false;
                                    continue;
                                }
                            }

                            // specific to size curve module
                            if(mappedField.field.validateCusomerCode) {
                                if (rowData.Level && rowData.Level.toLowerCase() === 'customer' && (angular.isUndefined(cellValue) || cellValue === '')) {
                                    currentRowStatus.push((vm.acModel[mappedField.field.field].v || mappedField.field.displayLabel ) + ' is required when Level is Customer');
                                    ws[cellRef].c = 'Invalid JSON Format';
                                    currentRowValid = false;
                                    continue;
                                }
                            }

                            // set default value for non mapped fields for create article
                            if (!modelData && (vm.action === 'import' || vm.action === 'importByLicensee')) { // new article
                                if (attributesWithDefaultValue && attributesWithDefaultValue.length) {
                                    angular.forEach(attributesWithDefaultValue, function(field) {
                                        if (!angular.isDefined(rowData[field.field]) || rowData[field.field] === '') {
                                            rowData[field.field] = utility.setAttributeTypeSpecificValue(field, field.DefaultValue)
                                        }
                                    })
                                }
                            }

                            // NOTE: Not used any more for MasterSizeScale if any requirement in feature we can use this
                            // shuldNotChangeExistingValue used to restrict user from modifying existing value.
                            // if the value is assigning for first time we will allow else we will show excel error
                            // if (mappedField.field.validation.shuldNotChangeExistingValue) { // currently used in articles module "Set Sizes(Bulk) By Licensee Model Number" action
                            //     if(rowData['LicenseeModelNumber']) {
                            //         var articlesList = api.currentCatalogArticleList;
                            //         // when the column is 'LicenseeModelNumber', use catalog model attributes to filter articles
                            //         // filtering and considering first article of that licensee model number
                            //         var modelAttribute = catalogFactory.getActiveCatalogDetails().ModelAttribute;
                            //         var licenseeArticles = filterArticleByModelAttribute(articlesList, rowData['LicenseeModelNumber'], modelAttribute);
                            //         if (licenseeArticles.length) {
                            //             var firstArticle = licenseeArticles[0];
                            //             if(firstArticle[mappedField.field.field] != null && firstArticle[mappedField.field.field] !== cellValue) {
                            //                 currentRowStatus.push('Assigned ' + (vm.acModel[mappedField.field.field].v || mappedField.field.displayLabel ) + ' value can not be changed.');
                            //                 ws[cellRef].c = 'Invalid value';
                            //                 currentRowValid = false;
                            //                 continue;
                            //             }
                            //         }
                            //     }
                            // }

                            ws[cellRef].c = undefined;

                            rowData[mappedField.field.field] = cellValue;
                        }

                    }// row data is created for row 'i'

                    //Validate Constraints
                    if (haveConstraints) {
                        angular.forEach(vm.targetModel.uniqueConstraints, function(item) {
                            var ucv = [];
                            for (var uci=0; uci<item.fields.length; uci++) {
                                ucv.push(rowData[item.fields[uci]]);
                            }
                            var ucvStr = ucv.join("//");
                            if (angular.isUndefined(constraints[item.name][ucvStr])) {
                                constraints[item.name][ucvStr] = 1;
                            } else {
                                //Duplicate detected
                                currentRowValid = false;
                                currentRowStatus.push('This row contains a duplicate record (must be unique on: ' + item.fields.join(', ') + ')');
                            }
                        });
                    }

                    //Validate commons
                    if (haveCommons) {
                        angular.forEach(vm.targetModel.commonConstraints, function(item) {
                            var commonConstraintsVal = [];
                            for (var cci=0; cci<item.fields.length; cci++) {
                                var val = rowData[item.fields[cci]];
                                if(angular.isDefined(val) && val !== null){
                                    val = val.toString().trim();
                                }
                                commonConstraintsVal.push(val);
                            }
                            var cccStr = commonConstraintsVal.join("//");
                            cccStr = cccStr.toLowerCase();
                            if (angular.isDefined(commons[item.name]) && commons[item.name] != cccStr) {
                                //Common field violated
                                currentRowValid = false;
                                currentRowStatus.push('This row contains non-common values (all rows must have same values on: ' + item.fields.join(', ') + ')');
                            } else {
                                commons[item.name] = cccStr;
                            }
                        });
                    }

                    if(haveAtLeastOneRequiredConstraints) {
                        angular.forEach(vm.targetModel.atLeastOneRequiredConstraints, function(constraints) {
                            var containsAtLeastOneValue = false
                            var displayNames = [];
                            for(var ovi=0; ovi<constraints.fields.length; ovi++) {
                                var field = utility.filterObject(vm.targetModel.fields, { field: constraints.fields[ovi] }, true)[0];
                                displayNames.push(field.displayLabel);
                                var columnValue = rowData[constraints.fields[ovi]];
                                if(angular.isDefined(columnValue) && columnValue !== null && columnValue.toString().trim() !== '') {
                                    containsAtLeastOneValue = true;
                                    break;
                                }
                            }
                            if(!containsAtLeastOneValue) {
                                // row is invalid
                                currentRowValid = false;
                                currentRowStatus.push('This row missing a required value (there should be at least one value on either of: ' + displayNames.join(', ') + ') fields');
                            }
                        })
                    }

                    // validates the fields to be required based on a criteria (if they are mapped)
                    if(haveConditionalRequired) {
                        for(var key in conditionalRequired) {
                            var crConstraints = conditionalRequired[key];
                            var matchCriteria = false;
                            if(angular.isString(crConstraints.criteria)) {
                                matchCriteria = $scope.$eval(crConstraints.criteria, { data: rowData });
                            } else {
                                matchCriteria = crConstraints.criteria;
                            }
                            if(matchCriteria) { // check if required filed is not empty only if matchCriteria is true
                                for(var crci = 0; crci < crConstraints.requiredFields.length; crci++) {
                                    var conditionalRequiredField = crConstraints.requiredFields[crci];
                                    if(angular.isUndefined(rowData[conditionalRequiredField]) || rowData[conditionalRequiredField].toString().trim() === '') {
                                        // row is invalid
                                        currentRowValid = false;
                                        currentRowStatus.push('This row missing a required value (' + conditionalRequiredField + ' can not be empty)');
                                        break;
                                    }
                                }
                            }
                        }
                    }

                    // check the record exists in DB with cobination of fields
                    if(haveDataExistConstraints) {
                        var dataExistsCombinationFld = utility.filterObject(vm.targetModel.fields, {field: 'dataExistsCombinationField'}, true)[0]
                        if(angular.isDefined(dataExistsCombinationFld)) {
                            var combinationFields = vm.targetModel.dataExistsCombinationConstraints;
                            var combinedValue = '';
                            // specific for retail window module date needs to be changed to common format
                            if(vm.targetModel.modelPath === 'catalogs.shipmentWindows') {
                                var shipmentStartDate = rowData['ShipmentStartDate'].split('T', 1)[0];
                                var shipmentEndDate = rowData['ShipmentEndDate'].split('T', 1)[0];
                                shipmentStartDate = new Date(shipmentStartDate).setHours(0,0,0,0);
                                shipmentEndDate = new Date(shipmentEndDate).setHours(0,0,0,0);
                                if (shipmentEndDate <= shipmentStartDate) {
                                    currentRowValid = false;
                                    currentRowStatus.push('Shipment End Date must be later than Shipment Start Date');
                                } else {
                                    combinedValue = new Date(shipmentStartDate) + new Date(shipmentEndDate) + rowData['CriteriaAttributeValue'];
                                }
                            } else {
                                angular.forEach(combinationFields, function(field) {
                                    combinedValue += rowData[field];
                                });
                            }

                            if(angular.isDefined(dataExistsCombinationFld.validation.dataExistConstraints.modelPath) && angular.isString(dataExistsCombinationFld.validation.dataExistConstraints.modelPath)
                                && dataExistsCombinationFld.validation.dataExistConstraints.modelPath.length > 0) {
                                var existConstraintsDataList = existConstraintsData[dataExistsCombinationFld.field];
                                if (angular.isDefined(existConstraintsDataList) && existConstraintsDataList.length > 0) {
                                    for (var m=0; m < existConstraintsDataList.length; m++) {
                                        if (existConstraintsDataList[m]['value'].toString().toLowerCase() === combinedValue.toString().toLowerCase()) {
                                            // row is invalid
                                            currentRowValid = false;
                                            currentRowStatus.push('Record already exist in database');
                                            break;
                                        }
                                    }
                                }
                            }
                        }
                    }

                    // validate tx pattern (attribute validation expression)
                    var attributesWithTxPattern = utility.filterObject(vm.targetModel.fields, {isTxPatternAdded: true}, true);
                    for (var l=0; l<attributesWithTxPattern.length; l++) {
                        // only validate if its part of the mapping
                        if(columFieldMap[attributesWithTxPattern[l].field] && columFieldMap[attributesWithTxPattern[l].field] !== -1 && attributesWithTxPattern[l].validation['tx-pattern'] && attributesWithTxPattern[l].validation['tx-pattern'].length > 0) {
                            var isValidCellValue = true;
                            // this is to ignore invalid dates getting validated against tx-pattern
                            if(attributesWithTxPattern[l].inputType === 'date-utc' || attributesWithTxPattern[l].inputType === 'date-option' || attributesWithTxPattern[l].inputType === 'date-without-time' || attributesWithTxPattern[l].inputType === 'date') {
                                if (!angular.isDate(rowData[attributesWithTxPattern[l].field]) && !angular.isNumber(rowData[attributesWithTxPattern[l].field])) {
                                    //validate if the date is ISO  string date
                                    var formats = [
                                        moment.ISO_8601,
                                        'MM-DD-YYYY',
                                        'MM/DD/YYYY'
                                    ];
                                    if (!moment(rowData[attributesWithTxPattern[l].field], formats, true).isValid()) {
                                        isValidCellValue = false;
                                    }
                                }
                            }
                            if(isValidCellValue) {
                                var isValid = validateTxPattern(attributesWithTxPattern[l], rowData);
                                if(angular.isDefined(isValid) && !isValid) {
                                    currentRowStatus.push($filter('translate')(attributesWithTxPattern[l].validation.messages.pattern));
                                    ws[cellRef].c = attributesWithTxPattern[l].validation.messages.pattern;
                                    currentRowValid = false;
                                }
                            }
                        }
                    }

                    // check if shouldNotHaveSameValueConstraints are present
                    if (shouldNotHaveSameValueConstraintsPresent) {
                        angular.forEach(vm.targetModel.shouldNotHaveSameValueConstraints, function (constraint) {
                            var constraintFields = constraint.fields;
                            var fieldValues = [];

                            angular.forEach(constraintFields, function (field) {
                                fieldValues.push(rowData[field]);
                            });

                            // check if all values in the array are the same
                            var allValuesSame = fieldValues.every(function (value, index, array) {
                                return value === array[0];
                            });

                            if (allValuesSame) {
                                // row is invalid
                                currentRowValid = false;
                                currentRowStatus.push('This row contains same value for ' + constraintFields.join(', ') + '. values should be different.');
                            }
                        });
                    }

                    // validate Article Locking
                    if(angular.isDefined(vm.validateArticleLocking) && vm.validateArticleLocking) {
                        // currently its implemented for IsPriceByStyleApply
                        if(catalogFactory.getActiveCatalog().IsPriceByStyleApply) {
                            // Import by Article Number
                            if(vm.action === 'setPricesByLicenseeModelNumber') {
                                // find the model number of mapped LicenseeModelNumber
                                var modelAttribute = catalogFactory.getActiveCatalogDetails().ModelAttribute;
                                // todo change here
                                var licenseeArticles = articlesMap[rowData.LicenseeModelNumber]
                                if (licenseeArticles && licenseeArticles.length) {
                                    // if any of the article is locked then set showReasonPage flag true and break
                                    var lockedLicenseeArticles = utility.filterObject(licenseeArticles, {Locked: 1}, true);
                                    if(lockedLicenseeArticles.length) {
                                        currentRowStatus.push('The article or one of the articles in the model is locked. The price values cannot be updated.');
                                        ws[cellRef].c = mappedField.field.field + " contains invalid value " + ws[cellRef].w;
                                        currentRowValid = false;
                                    }
                                }
                            }
                            else if(vm.action === 'import') { // prices module import
                                // if any of the article is locked then set showReasonPage flag true and break
                                var modelArticle = articlesMap[rowData.ModelNumber]
                                if (modelArticle && modelArticle.Locked === 1) {
                                    currentRowStatus.push('The article or one of the articles in the model is locked. The price values cannot be updated.');
                                    ws[cellRef].c = mappedField.field.field + " contains invalid value " + ws[cellRef].w;
                                    currentRowValid = false;
                                }
                            }
                        } else {
                            if(vm.action === 'import') { // prices module import
                                // if any of the mapped article is locked
                                var article = articlesMap[rowData.ArticleNumber]
                                if (article && article.Locked === 1) {
                                    currentRowStatus.push('The article is locked. The price values cannot be updated.');
                                    ws[cellRef].c = mappedField.field.field + " contains invalid value " + ws[cellRef].w;
                                    currentRowValid = false;
                                }
                            }
                        }
                    }

                    // show error message for the required lookuptable attribute if the source attributes are not mapped
                    if (!utility.isObjectEmpty(sourceAttributesMap)) {
                        for (var requiredLookuptableAttribute in sourceAttributesMap) {
                            if (sourceAttributesMap.hasOwnProperty(requiredLookuptableAttribute)) {
                                var errorMessages = [];
                                var attributeInfo = sourceAttributesMap[requiredLookuptableAttribute];
                                for (var displayName in attributeInfo.lookupSourceAttributesDisplayNameMap) {
                                if (attributeInfo.lookupSourceAttributesDisplayNameMap.hasOwnProperty(displayName) && !attributeInfo.lookupSourceAttributesDisplayNameMap[displayName]) {
                                    var errorMessage = 'Unable to lookup value for ' + attributeInfo.attributeDisplayName + ', as the following Source Attribute(s) ' + displayName + ' not mapped.';
                                    errorMessages.push(errorMessage);
                                }
                                }
                                if (errorMessages.length && !currentRowStatus.includes(errorMessages.join('\n'))) {
                                currentRowStatus.push(errorMessages.join('\n'));
                                ws[cellRef].c = 'Missing Source Attributes mapping.';
                                currentRowValid = false;
                                }
                            }
                        }
                        // validate the lookup values and assign valid values and show error message if source attribute values are not valid
                        var lookupTableAttributes = utility.filterObject(vm.targetModel.fields, { inputType: 'lookup-table' }, true);
                        if (lookupTableAttributes.length) {
                            angular.forEach(lookupTableAttributes, function(attribute) {
                                if (angular.isDefined(api.validSellerLookupsDestinationAttributesMap[attribute.field])) {
                                    var attributeLookupValues = api.validSellerLookupsDestinationAttributesMap[attribute.field];
                                    var matched = false;
                                    for (var j = 0; j < attributeLookupValues.length; j++) {
                                        var allAttributesMatch = true;
                                        var value = attributeLookupValues[j];
                                        for (var attributeSystemName in value.Source) {
                                            if (value.Source.hasOwnProperty(attributeSystemName)) {
                                                if(rowData[attributeSystemName] == null || value.Source[attributeSystemName].toString().toLowerCase() !== rowData[attributeSystemName].toString().toLowerCase()) {
                                                    allAttributesMatch = false;
                                                    break;
                                                }
                                            }
                                        }

                                        if (allAttributesMatch) {
                                            rowData[attribute.field] = value.Destination[attribute.field];
                                            matched = true;
                                            break;
                                        }
                                    }
                                    var attribute = utility.filterObject(catalogAttributes, { AttributeSystemName: attribute.field }, true)[0];
                                    var attributeInfo = sourceAttributesMap[attribute.AttributeSystemName];
                                    if (!matched && attribute && attribute.IsRequired) {
                                        var sourceAttributes = [];
                                        for (var displayName in attributeInfo.lookupSourceAttributesDisplayNameMap) {
                                            if (attributeInfo.lookupSourceAttributesDisplayNameMap.hasOwnProperty(displayName)) {
                                                sourceAttributes.push(displayName);
                                            }
                                        }
                                        // show error message for required attributes
                                        // do not set the value if the attribute is optional
                                        currentRowStatus.push('Did not find any valid match for Lookup table attribute ' + attribute.AttributeDisplayName + ', please provide the correct values for the source attribute(s) ' + sourceAttributes.join(', ') + '.');
                                        ws[cellRef].c = 'Invalid Lookup value for lookuptable attribute';
                                        currentRowValid = false;
                                    }
                                }
                            });
                        }
                    }

                    // specific to size curves module
                    if(vm.targetModel.validateTotalPercentage && rowData.AllocationType && rowData.AllocationType.toLowerCase() === 'percentage') {
                        if (!totalSizeCurvePercentage[rowData.Name]) {
                            totalSizeCurvePercentage[rowData.Name] = {
                                totalPercentage: parseFloat(rowData.Quantity) || 0,
                                rowIndex: i
                            };
                        } else {
                            totalSizeCurvePercentage[rowData.Name].totalPercentage += parseFloat(rowData.Quantity) || 0;
                            totalSizeCurvePercentage[rowData.Name].rowIndex = i
                        }
                    }

                    if (currentRowValid) {
                        vm.data.push(rowData);
                        vm.totalValid++;
                    } else {
                        vm.totalInvalid++;
                    }

                    // Update the worksheet with validation result
                    ws[XLSX.utils.encode_cell({c: statusCol, r: i})] = {
                        t: 's',
                        v: currentRowStatus.join()
                    };
                    vm.validationProgress = Math.round((i * 100) / totalRows);
                    if (i % 10 === 0) {
                        $scope.$applyAsync();
                    }
                }

                // next chunk
                if (endIndex < lastRow) {
                    setTimeout(function () {
                        processChunk(endIndex + 1, Math.min(endIndex + chunkSize, lastRow));
                    }, 0);
                } else {
                    // validate for total percentage for each size curve
                    if(!utility.isObjectEmpty(totalSizeCurvePercentage)) {
                        for (var curveName in totalSizeCurvePercentage) {
                            var sizeCurveData = totalSizeCurvePercentage[curveName];
                            if (sizeCurveData.totalPercentage !== 100) {
                                vm.totalInvalid++;
                                // remove this size curve from the vm.data
                                vm.data = vm.data.filter(function(row) {
                                    return row.Name !== curveName;
                                });
                                currentRowValid = false;
                                // Find the row index of the size curve column
                                var rowIndexForError = sizeCurveData.rowIndex;
                                var statusCellRef = XLSX.utils.encode_cell({ c: statusCol, r: rowIndexForError });
                                ws[statusCellRef] = { t: 's', v: 'Total of all sizes percentage for Size Curve ' + curveName + ' should be equal to 100%' };
                            }
                        }
                    }

                    vm.validationWorking = false;
                    // !vm.validationError matters when a run is superseded: a second validation can
                    // be started (Back then Next) while this chunk chain is still ticking through
                    // setTimeout. If the other run failed and tore state down, this chain must not
                    // arm the step afterwards - that would submit a truncated import.
                    if (!vm.validationError &&
                        ((vm.totalInvalid == 0 && vm.totalValid > 0) || (vm.totalValid > 0 && vm.skipInvalidRecords))) {
                        vm.tempValidation = 'ok';
                        if (vm.validateCustomerAssignedStocks && vm.data.length) {
                            var customerId = vm.data[0].CustomerCode;
                            loadCustomerStocks(customerId);
                            getStockData();
                        }
                    } else {
                        vm.tempValidation = '';
                    }
                    $scope.$applyAsync();
                }
                } catch (chunkError) {
                    // Without this, a throw here escapes through the setTimeout above: the chunk
                    // chain stops, the remaining rows are never validated, and validationWorking
                    // is never cleared (it is only reset in the terminal branch above), so the
                    // dialog spins forever with no error shown. Fail loudly and stop instead.
                    // i is var-scoped, so after the loop finishes normally it sits at endIndex + 1.
                    // Only name a row when the throw actually came from inside the loop.
                    var failedInsideRowLoop = i <= endIndex;
                    console.error('Import validation stopped (row index ' + i + ')', chunkError);
                    vm.validationWorking = false;
                    vm.validationError = failedInsideRowLoop
                        ? 'Validation stopped unexpectedly at row ' + (i + 1) + '. Please check that row in your file, then try again.'
                        : 'Validation stopped unexpectedly after processing all rows. Please try again.';
                    // Leave tempValidation empty so the wizard's hidden required input stays
                    // invalid, drop the partial rows, and untick skip-invalid so no combination of
                    // those can submit a truncated import.
                    vm.tempValidation = '';
                    vm.data = [];
                    vm.skipInvalidRecords = false;
                    // Zero the counters too, matching failValidation. Leaving them set would render
                    // the "ready to be submitted" block and the Get Result button (both gated only on
                    // the counters) right next to the abort banner.
                    vm.totalValid = 0;
                    vm.totalInvalid = 0;
                    vm.totalSkipped = 0;
                    vm.validationProgress = 0;
                    $scope.$applyAsync();
                }
            }

            processChunk(startIndex, Math.min(startIndex + chunkSize, lastRow))
        }

        function checkIfStatusColumnPresent(sheet) {
            var range = XLSX.utils.decode_range(sheet['!ref']);
            var C, R = range.s.r; /* start in the first row */
            var isStatusColumnPresent = false;
            /* walk every column in the range */
            for(C = range.s.c; C <= range.e.c; ++C) {
                var cell = sheet[XLSX.utils.encode_cell({c:C, r:R})] /* find the cell in the first row */
                //*** checking the status name with space 'Status '
                if(angular.isDefined(cell) && cell.v === 'Status ' && cell.t === 's') {
                    isStatusColumnPresent = true;
                    break;
                }
            }
            return isStatusColumnPresent;
        }

        // this method is to get the stateid's of the highest stateranked article and model
        // as we have multiple imports and the mapping fields are different here we will filter the articles based on the mapped fields
        function getHighestStateIdOfMappedArticles(sheet, columFieldMap) {
            var mappedArticles = [];
            var ws = vm.fileData.workBook.Sheets[vm.selectedSheet];
            var usedRange = XLSX.utils.decode_range(ws['!ref']);
            var firstRow = usedRange.s.r;
            var lastRow = usedRange.e.r;

            angular.forEach(vm.mapping, function(field) {
                var columnName = field.field.field;
                var columnData = [];
                // Loop through the sheet to collect data from the specific column
                for (var R = firstRow + 1; R <= lastRow; ++R) {
                    var cell = sheet[XLSX.utils.encode_cell({ c: field.column, r: R })];
                    if (cell && angular.isDefined(cell.v)) {
                        columnData.push(cell.v);
                    }
                }

                if (columnName === 'ModelNumber' &&
                (angular.isUndefined(columFieldMap['ArticleNumber']) || columFieldMap['ArticleNumber'] === -1) &&
                (angular.isUndefined(columFieldMap['LicenseeModelNumber']) || columFieldMap['LicenseeModelNumber'] === -1) &&
                (angular.isUndefined(columFieldMap['ArticleName']) || columFieldMap['ArticleName'] === -1)) {
                    angular.forEach(columnData, function(mappedValue) {
                        var articleWithModelNumber = articlesMap[mappedValue];
                        if (angular.isDefined(articleWithModelNumber)) {
                            mappedArticles.push(articleWithModelNumber);
                        }
                    });
                } else if (columnName === 'ArticleNumber' &&
                (angular.isUndefined(columFieldMap['ModelNumber']) || columFieldMap['ModelNumber'] === -1) &&
                (angular.isUndefined(columFieldMap['LicenseeModelNumber']) || columFieldMap['LicenseeModelNumber'] === -1) &&
                (angular.isUndefined(columFieldMap['ArticleName']) || columFieldMap['ArticleName'] === -1)) {
                    // when the column is 'ArticleNumber', use ArticleNumber to filter articles
                    angular.forEach(columnData, function(mappedValue) {
                        var article = articlesMap[mappedValue];
                        if (angular.isDefined(article)) {
                            mappedArticles.push(article);
                        }
                    });
                } else if (columnName === 'LicenseeModelNumber' &&
                (angular.isUndefined(columFieldMap['ArticleNumber']) || columFieldMap['ArticleNumber'] === -1) &&
                (angular.isUndefined(columFieldMap['ModelNumber']) || columFieldMap['ModelNumber'] === -1) &&
                (angular.isUndefined(columFieldMap['ArticleName']) || columFieldMap['ArticleName'] === -1)) {
                    // when the column is 'LicenseeModelNumber', use catalog model attributes to filter articles
                    angular.forEach(columnData, function(mappedValue) {
                        var licenseeArticles = articlesMap[mappedValue]
                        if (licenseeArticles && licenseeArticles.length) {
                            mappedArticles = mappedArticles.concat(licenseeArticles);
                        }
                    });
                } else if (columnName === 'ArticleName' &&
                (angular.isUndefined(columFieldMap['ArticleNumber']) || columFieldMap['ArticleNumber'] === -1) &&
                (angular.isUndefined(columFieldMap['ModelNumber']) || columFieldMap['ModelNumber'] === -1) &&
                (angular.isUndefined(columFieldMap['LicenseeModelNumber']) || columFieldMap['LicenseeModelNumber'] === -1)) {
                    // articles can have different licenseenumber
                    angular.forEach(columnData, function(mappedValue) {
                        var articlesWithArticleName = articlesMap[mappedValue]
                        if (articlesWithArticleName && articlesWithArticleName.length > 0) {
                            mappedArticles = mappedArticles.concat(articlesWithArticleName);
                        }
                    });
                } else if((angular.isDefined(columFieldMap['ArticleNumber']) && columFieldMap['ArticleNumber'] !== -1) && (angular.isDefined(columFieldMap['ModelNumber']) &&  columFieldMap['ModelNumber'] !== -1)) { // when both ArticleNumber and Model Number mapped through import
                    // when import and both ArticleNUmber and ModelNumber Mapped filter article using ArticleNumber
                    angular.forEach(columnData, function(mappedValue) {
                        var article = articlesMap[mappedValue]
                       // utility.filterObject(dataList, { ArticleNumber: mappedValue }, true)[0];
                        if (angular.isDefined(article)) {
                            mappedArticles.push(article);
                        }
                    });
                }
            });
            var highestArticleStateRankStateId = mappedArticles.length ? articlesFactory.getHighestArticleStateRankStateId(mappedArticles) : 0;
            var highestModelStateRankStateId = mappedArticles.length ? articlesFactory.getHighestModelStateRankStateId(mappedArticles) : 0;
            return { highestArticleStateRankStateId: highestArticleStateRankStateId, highestModelStateRankStateId: highestModelStateRankStateId };
        }

        function saveResult() {
            vm.resultsLoading = true;
            generateResultsFile().finally(function() {
                vm.resultsLoading = false;
            });
        }

        function generateResultsFile() {

            var defer = $q.defer();

            timeoutPromise = $timeout(function() {
                //By default, Excel stores dates as numbers with a format code that specifies date
                // processing. For example, the date 19-Feb-17 is stored as the number 42785 with a
                // number format of d-mmm-yy . The SSF module understands number formats and
                // performs the appropriate conversion.
                // XLSX also supports a special date type d where the data is an ISO 8601 date
                // string. The formatter converts the date back to a number.
                // The default behavior for all parsers is to generate number cells. Setting cellDates
                // to true will force the generators to store dates. link : https://sheetjs.com/docs.pdf
                // as "cellDates" property is not working UI will convert the converted numbers back to date and display in results.xlsx file.
                var tempFileData = vm.fileData.workBook.Sheets[vm.selectedSheet];
                var ws = tempFileData;
                var usedRange = XLSX.utils.decode_range(ws['!ref']);
                var firstRow = usedRange.s.r;
                var lastRow = usedRange.e.r;
                usedRange.e.c++;
                ws['!ref'] = XLSX.utils.encode_range(usedRange);

                for (var i=firstRow+1; i<=lastRow; i++)
                {
                    for (var j=0; j<vm.mapping.length; j++) {
                        var mappedField = vm.mapping[j];
                        var cellRef = XLSX.utils.encode_cell({c: mappedField.column, r: i});
                        var cellValue = undefined;
                        var cellFormattedValue = undefined;

                        if (ws[cellRef]) {
                            cellValue = ws[cellRef].v;
                            cellFormattedValue = ws[cellRef].w;
                        } else {
                            cellValue = undefined;
                            ws[cellRef] = {v: undefined};
                        }

                        if (angular.isDefined(mappedField.column) && mappedField.column >= 0)
                        {
                            switch (mappedField.field.inputType) {
                                case 'date':
                                    if(cellValue !== null && cellValue !== '') {
                                        var date = utility.formatDate(cellValue, 'MM/dd/yyyy h:mm a');
                                        cellValue = date;
                                    }
                                    ws[cellRef].t = 's';
                                    break;
                                case 'date-without-time':
                                case 'date-option':
                                    if(cellValue !== null && cellValue !== '') {
                                        if (angular.isNumber(cellValue)) {
                                            var date = new Date( ((cellValue - (25567 + 2))*86400*1000) + ((new Date(((cellValue - (25567 + 2))*86400*1000)).getTimezoneOffset())*60*1000) );
                                            var dateValueWithTime = new Date(date.setHours(12-(date.getTimezoneOffset()/60),0,0)).toISOString();
                                            cellValue = utility.formatDate(dateValueWithTime, 'MM/dd/yyyy');
                                        } else {
                                            var dateWithoutTime = utility.formatDate(cellValue, 'MM/dd/yyyy');
                                            cellValue = dateWithoutTime;
                                        }
                                    }
                                    break;
                                case 'date-utc':
                                    if(angular.isUndefined(cellValue) && (!mappedField.field.validation.isRequired && angular.isUndefined(mappedField.field.validation.isRequiredIfMapped))){
                                        cellValue = '';
                                    }
                                    else if( (!angular.isString(cellValue) && !angular.isDate(cellValue) && !angular.isNumber(cellValue))
                                    || (angular.isString(cellValue) && !utility.isValidDate(cellValue, ['MM/DD/YYYY', 'MM/DD/YY'])))
                                    {
                                        if(cellValue != '' && angular.isString(cellValue)){
                                            var d  = new Date(cellValue);
                                            cellValue = new Date(d.setHours(12-(d.getTimezoneOffset()/60),0,0)).toISOString();
                                        }
                                    } else if(angular.isNumber(cellValue)) {
                                        var date = new Date( ((cellValue - (25567 + 2))*86400*1000) + ((new Date(((cellValue - (25567 + 2))*86400*1000)).getTimezoneOffset())*60*1000) );
                                        cellValue = new Date(date.setHours(12-(date.getTimezoneOffset()/60),0,0)).toISOString();
                                    } else if(cellValue != '' && angular.isString(cellValue)) {
                                        var parts = cellValue.split('/');
                                        var year = parts[2].length > 2 ? parseInt(parts[2]) : parseInt(parts[2])+2000;
                                        cellValue = new Date(year, parseInt(parts[0])-1, parseInt(parts[1]), 12-(new Date().getTimezoneOffset()/60)).toISOString();
                                    }
                                    var dateUTC = utility.formatDate(cellValue, 'MM/dd/yyyy', 'UTC');
                                    cellValue = dateUTC;
                                    ws[cellRef].t = 's';
                                    break;
                                case 'number':
                                case 'decimal':
                                    // avoid assigning number values as string.
                                    // To avoid issue when user try to import through last used file(with invalid rows) in which the saved number values(string) will give not a valid number error.
                                    if(ws[cellRef].t !== 's') { // ignore the status values
                                        if (angular.isUndefined(cellValue) || cellValue == null || cellValue.toString().trim() === '') {
                                            if(angular.isDefined(mappedField.field.allowEmptyValue) && mappedField.field.allowEmptyValue) {
                                                cellValue = null; // specific for customer allocations module
                                            } else {
                                                cellValue = 0;
                                            }
                                        } else if (!angular.isNumber(cellValue)) {
                                            cellValue = 0;
                                        }
                                        ws[cellRef].t = 'n';
                                    }
                                    break;
                                default:
                                    if(angular.isDefined(cellValue)) {
                                        if(isNaN(cellFormattedValue) && !isNaN(cellValue)) {
                                            var formattedDate = new Date(cellFormattedValue);
                                            if(isNaN(formattedDate.getTime())) {
                                                cellValue =  String(cellValue);
                                            } else {
                                                cellValue = $filter('date')(formattedDate,'MM-dd-yyyy');
                                                ws[cellRef].t = 'd';
                                            }
                                        } else{
                                            cellValue = String(cellValue);
                                        }
                                    } else {
                                        cellValue = '';
                                    }
                                    break;
                            }

                            ws[cellRef].v = cellValue;
                            ws[cellRef].t = 's';//Assigning the cell type as string for all values
                        }
                    }
                }

                var wopts = { bookType: 'xlsx', bookSST: true, type: 'binary' };

                // Sanitize cells before writing: XLSX.write in v0.16 expects every
                // cell to have a valid {t, v} pair.  The loop above can leave cells
                // with v:undefined (line 2598) or stale .w properties from the Worker
                // parse.  Cells with undefined values are removed; the rest are
                // stripped down to only t and v so the SST builder never encounters
                // non-array entries that cause "e[1].forEach is not a function".
                var ref = XLSX.utils.decode_range(ws['!ref']);
                for (var r = ref.s.r; r <= ref.e.r; r++) {
                    for (var c = ref.s.c; c <= ref.e.c; c++) {
                        var addr = XLSX.utils.encode_cell({r: r, c: c});
                        var cell = ws[addr];
                        if (!cell) continue;
                        if (cell.v === undefined || cell.v === null) {
                            delete ws[addr];
                        } else {
                            // Keep only t and v — drop .w, .r, .h and any other
                            // metadata carried over from the Worker-parsed sheet.
                            ws[addr] = { t: cell.t || 's', v: cell.t === 's' ? String(cell.v) : cell.v };
                        }
                    }
                }

                // Build a fresh workbook — the original from sheetRows:1 carries
                // incomplete internal metadata that causes XLSX.write() to crash.
                var resultWb = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(resultWb, ws, vm.selectedSheet);
                vm.fileResultsData.workBook = resultWb;
                var wbout = XLSX.write(resultWb, wopts);

                function s2ab(s) {
                    var buf = new ArrayBuffer(s.length);
                    var view = new Uint8Array(buf);
                    for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
                    return buf;
                }

                /* the saveAs call downloads a file on the local machine */
                FileSaver.saveAs(new Blob([s2ab(wbout)], { type: "" }), "results.xlsx")

                defer.resolve(true);
            });

            return defer.promise;
        }

        function doesCachedSheetExist(sheetList, cachedSheetName) {
            for(var i=0, len=sheetList.length; i<len; i++) {
                if(sheetList[i].replace(' ', '').toLowerCase() === cachedSheetName.replace(' ', '').toLowerCase()) {
                    return true
                }
            }
            return false;
        }

        /**
         * @description: this method will map autocomplete map to the one selected by user for the module on previous import action
         * @param {Object} cachedColumnsMapping : map of field name and assigned excel column object
         * @param {Object} acModel : auto complete model
         * @param {String} field : model's field name
         * @param {Array} availableSheetColumns: list of excel sheet columns
         */
        function mapColumnsFromCacheData(cachedColumnsMapping, acModel, field, availableSheetColumns) {
            if(cachedColumnsMapping && cachedColumnsMapping[field]) {
                for(var i=0, len=availableSheetColumns.length; i<len; i++) {
                    if(angular.isString(cachedColumnsMapping[field]) &&
                    (angular.isDefined(availableSheetColumns[i].v)) &&
                    cachedColumnsMapping[field].replace(' ', '').toLowerCase() === availableSheetColumns[i].v.replace(' ', '').toLowerCase()) {
                        acModel[field] = availableSheetColumns[i];
                        return true;
                    }
                }
            }
            else return false;
        }

        function columnMatchesField(field, column) {

            if (angular.isUndefined(field) || angular.isUndefined(column) || angular.isUndefined(field.field) || angular.isUndefined(column.v)) {
                return false;
            }

            var noSpaceField = field.field.replace(' ', '').toLowerCase().trim();
            var noSpaceColumn = column.v.replace(' ', '').toLowerCase().trim();

            if (noSpaceColumn === noSpaceField) {
                importMappings.columnsMapping[field.field] = column;// cache mapped column
                return true;
            }

            if (angular.isDefined(field.displayLabel)) {
                var noSpaceDisplayLabel = $filter('translate')(field.displayLabel);

                if (angular.isDefined(noSpaceDisplayLabel)) {
                    noSpaceDisplayLabel = noSpaceDisplayLabel.replace(' ', '').toLowerCase();
                    if (noSpaceDisplayLabel === noSpaceColumn) {
                        importMappings.columnsMapping[field.field] = column;// cache mapped column
                        return true;
                    }
                }
            }

            if (angular.isDefined(field.possibleColumnNames) && angular.isArray(field.possibleColumnNames)) {
                for (var i=0; i<field.possibleColumnNames.length; i++) {
                    if (field.possibleColumnNames[i].toLowerCase() === column.v.toLowerCase) {
                        importMappings.columnsMapping[field.field] = column;// cache mapped column
                        return true;
                    }
                }
            }

            return false;
        }

        /**
         * Utility function to find the Lookup value using case-insensitive strict matching
         */
        function findInLookup(field, value) {
            var lookupKey = field.lookupSource;
            var lu = vm.lookupData[lookupKey];
            if(field.lookupSource === 'catalogs.articles') {
                if(!lu) {
                    lu = {};
                }
                lu.data = api.currentCatalogArticleList;
            }
            if(field.lookupSource === 'catalogs.retailIntroMonthsForArticle' || field.lookupSource === 'catalogs.retailExitMonthsForArticle') {
                if(!lu) {
                    lu = {};
                }
                lu.data = activeCatalogShipmentWindowRangeList;
            }
            var v = String(value).toLowerCase();
            // convert the crd date to 'MMM d, y' format
            if(field.lookupSource === 'catalogs.CRD') {
                var d  = new Date(v);
                var d = new Date(d.setHours(12-(d.getTimezoneOffset()/60),0,0)).toISOString();
                v = String(utility.formatDate(d, 'MMM d, y', 'UTC')).toLowerCase();
            }

            if (angular.isDefined(lu) && angular.isDefined(lu.data) && lu.data.length > 0) {
                for (var i=0; i < lu.data.length; i++) {
                    if (lu.data[i].value && lu.data[i].value.toLowerCase() === v) {
                        return lu.data[i];
                    } else if(lu.data[i]['ArticleNumber'] && lu.data[i]['ArticleNumber'].toLowerCase() === v) { // when lookup source is articles
                        return lu.data[i];
                    } else if(field.lookupSource === 'catalogs.retailIntroMonthsForArticle' && lu.data[i]['RetailIntroMonth'] && lu.data[i]['RetailIntroMonth'].toLowerCase() === v) {
                        return lu.data[i];
                    } else if(field.lookupSource === 'catalogs.retailExitMonthsForArticle' && lu.data[i]['RetailExitMonth'] && lu.data[i]['RetailExitMonth'].toLowerCase() === v) {
                        return lu.data[i];
                    } else if (field.lookupSource === 'lists.sellerColorsFromColorPalette' && lu.data[i].value) {
                        var colorName = lu.data[i].ColorName
                        if (colorName.toLowerCase() === v) {
                            return lu.data[i];
                        }
                    }
                }
            }

            return undefined;
        }

        // to validate the color criteria: conditions inside one criteria are AND'ed, several criteria
        // on the same palette are OR'ed. Returns the first color whose criteria the row satisfies.
        function validateCriteria(field, cellValue, rowData) {
            var lookupKey = field.lookupSource;
            var lookupDataList = vm.lookupData[lookupKey].data;
            var sameNameDataList =  utility.filterObject(lookupDataList, {ColorName: cellValue}, true);
            var getRowValue = function(attributeSystemName) {
                return rowData[attributeSystemName];
            };

            for(var i=0, len=sameNameDataList.length; i<len; i++) {
                var criteriaGroups = utility.normalizeColorCriteria(sameNameDataList[i].ColorCriteria);
                if(utility.matchesColorCriteria(criteriaGroups, getRowValue).isMatch) {
                    return sameNameDataList[i];
                }
            }

            return undefined;
        }

        function findInExistConstraintsData(field, cellValue, rowData) {
            // skip validation for non mandatory fields when cell value is empty
            if( (angular.isUndefined(cellValue) || cellValue === null || cellValue.toString().trim() === '') && field.validation.isRequired === false && angular.isUndefined(field.validation.isRequiredIfMapped) && angular.isUndefined(field.validation.isRequiredWhileValidating)) {
                return true;
            }
            // for article drop reason skip validation for activating articles
            if(angular.isDefined(field.validation.isRequiredWhileValidating)) {
                var status = rowData.Status;
                if (status != null && (status === 1 || status.toString().toUpperCase() === 'ACTIVE' || status.toString().toUpperCase() === 'TRUE' || status.toString().toUpperCase() === 'YES')) {
                    return true;
                }
            }

            var existConstraintsDataForField = existConstraintsData[field.field];
            var existConstraintsDataForFieldLookupPropertyName;
            var cellVal = String(cellValue).toLowerCase();

            // if validating against lookup data
            if(field.inputType === 'lookup' && field.lookupSource) {
                var lookupModel = api.getModel(field.lookupSource);
                if(field.useLookupName) {
                    existConstraintsDataForFieldLookupPropertyName = lookupModel.lookupDisplayField;
                } else {
                    existConstraintsDataForFieldLookupPropertyName = lookupModel.idField;
                }
            }
            else if(angular.isDefined(field.validation.dataExistConstraints.model) && angular.isDefined(field.validation.dataExistConstraints.model.lookupDisplayField)) {
                // when the lookup field name is different in both models
                existConstraintsDataForFieldLookupPropertyName = field.validation.dataExistConstraints.model.lookupDisplayField;
            }
            else {
                existConstraintsDataForFieldLookupPropertyName = field.field;
            }
            if (angular.isDefined(existConstraintsDataForField) && angular.isArray(existConstraintsDataForField) && existConstraintsDataForField.length > 0) {
                // size scale import when filtering the size scales filter with master size scale name also as sizescales can be mmultiple
                if(field.field !== 'SizeScale') {
                    for (var i=0; i < existConstraintsDataForField.length; i++) {
                        if (existConstraintsDataForField[i][existConstraintsDataForFieldLookupPropertyName].toString().toLowerCase() === cellVal) {
                            return existConstraintsDataForField[i];
                        }
                    }
                } else {
                    for (var i=0; i < existConstraintsDataForField.length; i++) {
                        if (existConstraintsDataForField[i][existConstraintsDataForFieldLookupPropertyName].toString().toLowerCase() === cellVal && (angular.isDefined(rowData['MasterSizeScale']) && existConstraintsDataForField[i]['MasterSizeScale'].toString().toLowerCase() === rowData['MasterSizeScale'].toString().toLowerCase())) {
                            return existConstraintsDataForField[i];
                        }
                    }
                }
            }
            else if(angular.isDefined(existConstraintsDataForField) && angular.isObject(existConstraintsDataForField) && !utility.isObjectEmpty(existConstraintsDataForField)) {
                if (existConstraintsDataForField[cellVal]) {
                    return existConstraintsDataForField[cellVal];
                }
            }
            return undefined;
        }


        function getImportMappings() {
            var importMapping = {
                selectedSheet: '',
                columnsMapping: {},
                FilterInfo: undefined
            };
            var activeCatalogDetails = catalogFactory.getActiveCatalogDetails();
            if(activeCatalogDetails && activeCatalogDetails.ImportMapping) {
                catalogImportMappings = angular.fromJson(activeCatalogDetails.ImportMapping);
                if(catalogImportMappings && catalogImportMappings['importMappings'] && catalogImportMappings['importMappings'][targetModel.modelPath]) {
                    importMapping = catalogImportMappings['importMappings'][targetModel.modelPath];
                }
            }
            return importMapping;
        }

        function persistImportMapping() {
            var activeCatalog = catalogFactory.getActiveCatalog();
            if(activeCatalog) {
                if(!catalogImportMappings) {
                    catalogImportMappings = {};
                }
                catalogImportMappings['importMappings'] = catalogImportMappings['importMappings'] ? catalogImportMappings['importMappings'] : {};
                catalogImportMappings['importMappings'][targetModel.modelPath] = catalogImportMappings['importMappings'][targetModel.modelPath]
                    ? catalogImportMappings['importMappings'][targetModel.modelPath]
                    : {};
                catalogImportMappings['importMappings'][targetModel.modelPath] = importMappings;
                if(targetModel.isCatalogSpecificModel) { // only should work for catalog data modules
                    catalogFactory.setCatalogImportMapping(activeCatalog.CatalogCode, catalogImportMappings);
                }
            }
        }

        function stocksLookupSearch(query, fieldName, customerStocks) {
            var results = [];
            var field = utility.filterObject(vm.targetModel.fields, { field: fieldName })[0];
            var lookupFilter = angular.isDefined(field.lookupFilter) ? field.lookupFilter : {};
            var predicate = angular.copy(lookupFilter);
            predicate.value = query;

            if (angular.isDefined(customerStocks) && angular.isArray(customerStocks) && customerStocks.length > 0) {
                results = query ? utility.filterObject(customerStocks, predicate) : utility.filterObject(customerStocks, lookupFilter, true);
                return results;
            }
            else {
                return stocksPromise.then(function () {
                    results = query ? utility.filterObject(vm.customerStocks, predicate) : utility.filterObject(vm.customerStocks, lookupFilter, true);
                    return results;
                });
            }
        }

        function lookupChange(selectedObj) {
            if(angular.isObject(selectedObj)) {
                vm.stockDefinitionId = selectedObj.StockDefinitionId;
                vm.stockName = selectedObj.StockName;
                // validate data
                validateArticleSizeStockQuantity();
            } else if(angular.isUndefined(selectedObj) || selectedObj === null){
                vm.stockDefinitionId = undefined;
            }
        }

        function getStockLookupDisplayValue(item, customerStocks) {
            var stockDefinitionId = '';
            if(angular.isObject(item)) {
                stockDefinitionId = item.StockDefinitionId;
            } else {
                stockDefinitionId = item;
            }
            var res = utility.filterObject(customerStocks, {StockDefinitionId: stockDefinitionId}, true);
            if (angular.isArray(res) && res.length > 0) {
                    return res[0].StockName;
            }
        }

        function loadCustomerStocks(customerId) {
            var catalogCode  = catalogFactory.getActiveCatalog().CatalogCode;
            return api.catalogs.customers.methods.getList({forceFetch: true, isLogRequired: false}, vm.customersModel, catalogCode).then(function(response) {
                var customer = utility.filterObject(angular.copy(response.data), {CustomerId: customerId}, true)[0];
                vm.customerStocks = customer.Stocks;
            });
        }

        function getStockData() {
            var catalogCode  = catalogFactory.getActiveCatalog().CatalogCode;
            return api.catalogs.stock.methods.getList({forceFetch: true, isLogRequired: false}, api.catalogs.stock, catalogCode).then(function(response) {
                vm.stocks = orderlineDialog.transforArticleStockResponse(response.data, 'Stocks');
            });
        }

        function validateArticleSizeStockQuantity() {
            vm.invalidArticleStocksModel = api.orders.invalidArticleStocks;
            vm.filteredInvalidArticleStocks = [];
            var customerAssignedArticleStokData = utility.filterObject(vm.stocks, {StockDefinitionId: vm.stockDefinitionId, StockName: vm.stockName}, true);
            angular.forEach(vm.data, function (data) {
                var articleStocks = utility.filterObject(customerAssignedArticleStokData, {ArticleId: data.ArticleNumber, SizeName: data.Size}, true)[0];
                if(articleStocks) {
                    if(data.Quantity > articleStocks.Available) {
                        var obj = {
                            ArticleNumber : vm.articleIdNumberMap[data.ArticleNumber], // data.ArticleNumber contains article id
                            Size : data.Size,
                            Quantity : data.Quantity,
                            Status : 'Invalid quantity for ' + data.Size + ', exceeding available stock of ' + articleStocks.Available
                        }
                        vm.invalidArticleStocks.push(obj);
                        vm.tempValidation = '';
                    }
                } else {
                    if(data.Quantity !== 0) {
                        var obj = {
                            ArticleNumber : vm.articleIdNumberMap[data.ArticleNumber], // data.ArticleNumber contains article id
                            Size : data.Size,
                            Quantity : data.Quantity,
                            Status : 'Invalid quantity for ' + data.Size + ', no stocks available'
                        }
                        vm.invalidArticleStocks.push(obj);
                        vm.tempValidation = '';
                    }
                }
            });
        }

        function validateTxPattern(field, rowData) {
            var isValid = true;
            var validationExpression = utility.isValidJSON(field.validation['tx-pattern']);
            if(validationExpression && angular.isDefined(validationExpression.F) && validationExpression.F.length > 0) {
                // validate with overridable attributes
                var articleData = {};
                if(vm.isUpdateArticlesByModel) {
                    articleData = articlesMap[rowData['ModelNumber']]
                } else {
                    articleData = articlesMap[rowData['ArticleNumber']]
                }
                var parsedExpressionObjects = validationExpression.F;
                for(var i = 0; i < parsedExpressionObjects.length; i++) {
                    var parsedExpressionObject = parsedExpressionObjects[i];
                    if(angular.isDefined(parsedExpressionObject.Message)) {
                        field.validation.messages.pattern = parsedExpressionObject.Message;
                    }
                    // skip validating overridable attribute with parent attributes for master catalog
                    if(angular.isDefined(parsedExpressionObject['SourceField']) && (dataSourceTypeId === 1 && field.Overridable && !parsedExpressionObject['SourceField'].startsWith('#')) || (dataSourceTypeId === 3)) {
                        // if SourceValueRequired is true then the source field should be required for this attribute to have value
                        if(parsedExpressionObject['SourceValueRequired']) {
                            if(rowData[parsedExpressionObject['SourceField']] !== '' && rowData[parsedExpressionObject['SourceField']] != null) {
                                isValid = validateExpression(field, parsedExpressionObject, rowData);
                            } else if(rowData[field.field] !== '' && rowData[field.field] != null) {
                                isValid = true;
                            }
                        } else {
                            // support validating for shipment start and end date. these are not part of mapping
                            if(rowData[parsedExpressionObject['SourceField']] !== '' && rowData[parsedExpressionObject['SourceField']] != null
                            && rowData[field.field] !== '' && rowData[field.field] != null && parsedExpressionObject['SourceField'] !== 'ShipmentStartDate' && parsedExpressionObject['SourceField'] !== 'ShipmentEndDate' && parsedExpressionObject['SourceField'].startsWith('#')) {
                                isValid = validateExpression(field, parsedExpressionObject, rowData);
                            } else if((parsedExpressionObject['SourceField'] === 'ShipmentStartDate' || parsedExpressionObject['SourceField'] === 'ShipmentEndDate') && (rowData['RetailIntroMonthId'] != null && rowData['RetailIntroMonthId'] !== '') && (rowData['RetailExitMonthId'] != null && rowData['RetailExitMonthId'] !== '') && rowData[field.field] !== '' && rowData[field.field] != null) {
                                // get the data from the mapped retail window and validate
                                var retailWindowAttribute = catalogFactory.getActiveCatalog().RetailWindowAttribute;
                                var retailWindowDataList = api.getModel('catalogs.retailExitMonthsForArticle').lookupData.data;
                                var mappedRetailWindow = utility.filterObject(retailWindowDataList, {value: rowData['RetailExitMonthId'], CriteriaAttributeValue: rowData[retailWindowAttribute], RetailIntroMonth: rowData['RetailIntroMonthId']}, true)[0];
                                if(angular.isDefined(mappedRetailWindow)) {
                                    var rowDataCopy = angular.copy(rowData);
                                    rowDataCopy['ShipmentStartDate'] = mappedRetailWindow.ShipmentStartDate;
                                    rowDataCopy['ShipmentEndDate'] = mappedRetailWindow.ShipmentEndDate;
                                    isValid = validateExpression(field, parsedExpressionObject, rowDataCopy);
                                }
                            }  else if(((parsedExpressionObject['SourceField'] && parsedExpressionObject['SourceField'].startsWith('#')) || dataSourceTypeId === 3) && rowData[field.field] !== '' && rowData[field.field] != null) {
                                if(angular.isDefined(articleData) && articleData[parsedExpressionObject['SourceField']] != null && articleData[parsedExpressionObject['SourceField']] !== '' && rowData[field.field] !== '' && rowData[field.field] != null) {
                                    var rowDataCopy = angular.copy(rowData);
                                    rowDataCopy[parsedExpressionObject['SourceField']] = articleData[parsedExpressionObject['SourceField']];
                                    isValid = validateExpression(field, parsedExpressionObject, rowDataCopy);
                                }
                            }
                        }
                    }

                    if(angular.isUndefined(parsedExpressionObject['SourceField']) && angular.isDefined(parsedExpressionObject['Expression']) && angular.isDefined(parsedExpressionObject['ExpressionValue'])) {
                        if(rowData[field.field] !== '' && rowData[field.field] != null) {
                            isValid = validateExpression(field, parsedExpressionObject, angular.copy(rowData), true);
                        }
                    }
                    if(!isValid) {
                        break;
                    }
                }
            }
            return isValid;
        }

        function validateExpression(field, parsedExpressionObject, rowData, isExpressionValidation) {
            var Expression = parsedExpressionObject.Expression;
            var SourceField = parsedExpressionObject.SourceField;
            var currentAttributeValue = angular.copy(rowData[field.field]);
            var sourceAttributeValue = !isExpressionValidation ? angular.copy(rowData[SourceField]) : parsedExpressionObject.ExpressionValue;

            //Transform the date fields to type dateUTC
            angular.forEach(vm.targetModel.fields, function(itm) {
                if(itm.field === field.field || itm.field === SourceField) {
                    // for date fields
                    if ((itm.inputType === 'date-utc' || itm.inputType === 'date-option' || itm.inputType === 'date-without-time' || itm.inputType === 'date')) {
                        if(itm.field === field.field) {
                            currentAttributeValue = utility.formatDate(angular.copy(rowData[itm.field]), 'MM/dd/yyyy')
                            currentAttributeValue = new Date(currentAttributeValue);
                            currentAttributeValue = currentAttributeValue.setHours(0,0,0,0);
                            if(isExpressionValidation) {
                                sourceAttributeValue = utility.formatDate(angular.copy(sourceAttributeValue.split('T', 1)[0]), 'MM/dd/yyyy')
                                sourceAttributeValue = new Date(sourceAttributeValue)
                                sourceAttributeValue = sourceAttributeValue.setHours(0,0,0,0);
                            }
                        } else if(itm.field === SourceField) {
                            sourceAttributeValue = utility.formatDate(angular.copy(rowData[itm.field].split('T', 1)[0]), 'MM/dd/yyyy')
                            sourceAttributeValue = new Date(sourceAttributeValue);
                            sourceAttributeValue = sourceAttributeValue.setHours(0,0,0,0);
                        }
                    }
                    // for text input types
                    if (itm.inputType === 'textArea' || itm.inputType === 'text' || (angular.isDefined(itm.type) && itm.type === 'text' && itm.inputType === 'list')) {
                        if(itm.field === field.field) {
                            currentAttributeValue = rowData[itm.field].toUpperCase();
                            if(isExpressionValidation) {
                                sourceAttributeValue = sourceAttributeValue.toString().toUpperCase();
                            }
                        } else if(itm.field === SourceField) {
                            sourceAttributeValue = rowData[itm.field].toUpperCase();
                        }
                    }
                }
            });

            if(dataSourceTypeId === 3 && field.Overridable) {
                if(field.inputType === 'textArea' || field.inputType === 'text' || (angular.isDefined(field.type) && field.type === 'text' && field.inputType === 'list')) {
                    sourceAttributeValue = rowData[SourceField].toUpperCase();
                }

                // for date fields
                if ((field.inputType === 'date-utc' || field.inputType === 'date-option' || field.inputType === 'date-without-time' || field.inputType === 'date')) {
                    sourceAttributeValue = new Date(angular.copy(rowData[SourceField]));
                    sourceAttributeValue = sourceAttributeValue.setHours(0,0,0,0);
                }
            }

            var isValid = false;
            switch(Expression) {
                case '<':
                    isValid = currentAttributeValue < sourceAttributeValue ? true : false;
                    break;
                case '>':
                    isValid = currentAttributeValue > sourceAttributeValue ? true : false;
                    break;
                case '<=':
                    isValid = currentAttributeValue <= sourceAttributeValue ? true : false;
                    break;
                case '>=':
                    isValid = currentAttributeValue >= sourceAttributeValue ? true : false;
                    break;
                case '=':
                    isValid = currentAttributeValue === sourceAttributeValue ? true : false;
                    break;
                case '!=':
                    isValid = currentAttributeValue !== sourceAttributeValue ? true : false;
                    break;
            }
            return isValid;
        }

        $scope.$on('$destroy', function() {
            if(angular.isFunction(timeoutPromise)) {
                $timeout.cancel(timeoutPromise);
            }
        });
    }
})();
(function () {
  'use strict';

  angular.module('app.dataExporter')
    .factory('visualLinePlanReportExporter', visualLinePlanReportExporterFactory);

  /** @ngInject */
  function visualLinePlanReportExporterFactory($rootScope, $q, $timeout, $filter, FileSaver, Blob) {

    //Data
    var timeoutPromise;

    //Methods
    var service = {
      exportReport: exportReport
    };

    return service;

    function exportReport(reportData, model, activeCatalog) {

      var defer = $q.defer();
      timeoutPromise = $timeout(function () {
        var wopts = { bookType: 'xlsx', bookSST: false, type: 'binary' };
        var data;
        var wb = { SheetNames: [], Sheets: {} };

        var ws1 = {};
        var ws2 = {};
        var ws3 = {};
        var ws4 = {};
        var ws5 = {};
        var ws6 = {};

        var i = 0;
        var col = 0;
        var row = 0;

        // s is the first cell and e is the last cell
        var range1 = { s: { c: 0, r: 0 }, e: { c: 0, r: 0 } };
        var range2 = { s: { c: 0, r: 0 }, e: { c: 0, r: 0 } };
        var range3 = { s: { c: 0, r: 0 }, e: { c: 0, r: 0 } };
        var range4 = { s: { c: 0, r: 0 }, e: { c: 0, r: 0 } };
        var range5 = { s: { c: 0, r: 0 }, e: { c: 0, r: 0 } };
        var range6 = { s: { c: 0, r: 0 }, e: { c: 0, r: 0 } };

        var cell = { t: 's' };
        var cell_ref = XLSX.utils.encode_cell({ c: 0, r: 0 });

        //write excel

        // SHEET1 - STYLE INTRO FLOW
        cell = { t: 's' };
        cell_ref = XLSX.utils.encode_cell({ c: 0, r: 0 });
        cell.v = $filter('translate')('ARTICLES.REPORT.TITLES.STYLE_INTRO_FLOW'); // add sheet heading
        ws1[cell_ref] = cell;

        cell = { t: 's' };
        cell_ref = XLSX.utils.encode_cell({ c: 1, r: 0 });
        cell.v = $filter('translate')('ARTICLES.REPORT.ATTRIBUTES.INTRO_MONTH'); // add x-axis attribute label
        ws1[cell_ref] = cell;
        range1.e.c = 1;

        cell = { t: 's' };
        cell_ref = XLSX.utils.encode_cell({ c: 0, r: 1 });
        cell.v = $filter('translate')('ARTICLES.REPORT.ATTRIBUTES.STYLE_N/CO'); // add y-axis attribute label
        ws1[cell_ref] = cell;
        range1.e.r = 1;

        // populate data in sheet
        col = 1;
        row = 2;
        angular.forEach(reportData.monthArray, function (month) {
          cell = { t: 's' };
          cell_ref = XLSX.utils.encode_cell({ c: col, r: 1 });
          col++
          cell.v = month;
          ws1[cell_ref] = cell;
        });

        angular.forEach(reportData.sheet1yAxisSortedValues, function (value) {
          col = 1;
          cell = { t: 's' };
          cell_ref = XLSX.utils.encode_cell({ c: 0, r: row });
          cell.v = value;
          ws1[cell_ref] = cell;
          for (var key in reportData.sheet1RowToColumnMap[value].columnMap) {
            cell = { t: 'n' };
            cell_ref = XLSX.utils.encode_cell({ c: col, r: row });
            cell.v = reportData.sheet1RowToColumnMap[value].columnMap[key];
            ws1[cell_ref] = cell;
            col++;
          }
          row++
        });
        range1.e.r = row;
        range1.e.c = col;

        // SHEET2 - ARTICLE LIFECYCLE
        cell = { t: 's' };
        cell_ref = XLSX.utils.encode_cell({ c: 0, r: 0 });
        cell.v = $filter('translate')('ARTICLES.REPORT.TITLES.ARTICLE_LIFECYCLE'); // add sheet heading
        ws2[cell_ref] = cell;

        cell = { t: 's' };
        cell_ref = XLSX.utils.encode_cell({ c: 0, r: 2 });
        cell.v = $filter('translate')('ARTICLES.REPORT.ATTRIBUTES.ALL'); // add y-axis attribute label
        ws2[cell_ref] = cell;
        range2.e.r = 2;

        col = 1;
        // populate data in sheet
        for (var key in reportData.sheet2RowToColumnMap) {
          cell = { t: 's' };
          cell_ref = XLSX.utils.encode_cell({ c: col, r: 1 });
          cell.v = reportData.sheet2RowToColumnMap[key].displayLabel;
          ws2[cell_ref] = cell;

          cell = { t: 'n' };
          cell_ref = XLSX.utils.encode_cell({ c: col, r: 2 });
          cell.v = reportData.sheet2RowToColumnMap[key].valueSum;
          ws2[cell_ref] = cell;
          col++;

        }
        range2.e.c = col;

        // SHEET3 - PRODUCT RANKING, PLATFORM AND CLASS DISTRIBUTION
        cell = { t: 's' };
        cell_ref = XLSX.utils.encode_cell({ c: 0, r: 0 });
        cell.v = $filter('translate')('ARTICLES.REPORT.TITLES.PRODUCT_RANKING_PLATFORM_AND_CLASS_DISTRIBUTION'); // add sheet heading
        ws3[cell_ref] = cell;

        cell = { t: 's' };
        cell_ref = XLSX.utils.encode_cell({ c: 2, r: 0 });
        cell.v = $filter('translate')('ARTICLES.REPORT.ATTRIBUTES.CLASS'); // add x-axis attribute label
        ws3[cell_ref] = cell;
        range3.e.c = 2;

        cell = { t: 's' };
        cell_ref = XLSX.utils.encode_cell({ c: 0, r: 1 });
        cell.v = $filter('translate')('ARTICLES.REPORT.ATTRIBUTES.PRODUCT_RANKING'); // add y-axis first attribute label
        ws3[cell_ref] = cell;
        range3.e.r = 1;

        cell = { t: 's' };
        cell_ref = XLSX.utils.encode_cell({ c: 1, r: 1 });
        cell.v = $filter('translate')('ARTICLES.REPORT.ATTRIBUTES.PLATFORM'); // add y-axis second attribute label
        ws3[cell_ref] = cell;

        // populate data in sheet
        col = 2;
        angular.forEach(reportData.sheet3Data.xAxisSortedValues, function (key) {
          cell = { t: 's' };
          cell_ref = XLSX.utils.encode_cell({ c: col, r: 1 });
          cell.v = reportData.sheet3Data.xAxisAttributeUniqueValue[key];
          ws3[cell_ref] = cell;
          col++;
        });

        range3.e.c = col;
        row = 2;
        var row1 = 2;

        angular.forEach(reportData.sheet3Data.yAxisFirstAttributeSortedValues, function (yAxisFirstAttributeKey) {
          row = row1;
          cell = { t: 's' };
          cell_ref = XLSX.utils.encode_cell({ c: 0, r: row });
          cell.v = reportData.sheet3Data.yAxisFirstAttributeUniqueValue[yAxisFirstAttributeKey];
          ws3[cell_ref] = cell;

          angular.forEach(reportData.sheet3Data.yAxisSecondAttributeSortedValues, function (yAxisSecondAttributeKey) {
            cell = { t: 's' };
            cell_ref = XLSX.utils.encode_cell({ c: 0, r: row1 });
            cell.v = reportData.sheet3Data.yAxisFirstAttributeUniqueValue[yAxisFirstAttributeKey];
            ws3[cell_ref] = cell;
            cell = { t: 's' };

            cell_ref = XLSX.utils.encode_cell({ c: 1, r: row1 });
            cell.v = reportData.sheet3Data.yAxisSecondAttributeUniqueValue[yAxisSecondAttributeKey];
            ws3[cell_ref] = cell;
            col = 2;

            angular.forEach(reportData.sheet3Data.xAxisSortedValues, function (xAxisAttributeKey) {
              cell = { t: 'n' };
              cell_ref = XLSX.utils.encode_cell({ c: col, r: row1 });
              cell.v = reportData.sheet3Data.sheet3RowToColumnMap[yAxisFirstAttributeKey + '/' + yAxisSecondAttributeKey] && reportData.sheet3Data.sheet3RowToColumnMap[yAxisFirstAttributeKey + '/' + yAxisSecondAttributeKey][xAxisAttributeKey] ? reportData.sheet3Data.sheet3RowToColumnMap[yAxisFirstAttributeKey + '/' + yAxisSecondAttributeKey][xAxisAttributeKey] : 0;
              ws3[cell_ref] = cell;
              col++;
            });
            row1++;
          });
        });
        range3.e.r = row1;

        // SHEET4 - PRODUCT SEGMENTATION
        cell = { t: 's' };
        cell_ref = XLSX.utils.encode_cell({ c: 0, r: 0 });
        cell.v = $filter('translate')('ARTICLES.REPORT.TITLES.PRODUCT_SEGMENTATION'); // add sheet heading
        ws4[cell_ref] = cell;

        cell = { t: 's' };
        cell_ref = XLSX.utils.encode_cell({ c: 1, r: 0 });
        cell.v = $filter('translate')('ARTICLES.REPORT.ATTRIBUTES.PRODUCT_SEGMENTATION'); // add x-axis attribute label
        ws4[cell_ref] = cell;
        range4.e.c = 2;

        cell = { t: 's' };
        cell_ref = XLSX.utils.encode_cell({ c: 0, r: 1 });
        cell.v = $filter('translate')('ARTICLES.REPORT.ATTRIBUTES.PRODUCT_RANKING'); // add y-axis attribute label
        ws4[cell_ref] = cell;
        range4.e.r = 1;

        // populate data in sheet
        col = 1;
        angular.forEach(reportData.sheet4Data.xAxisSortedValues, function (key) {
          cell = { t: 's' };
          cell_ref = XLSX.utils.encode_cell({ c: col, r: 1 });
          cell.v = reportData.sheet4Data.xAxisAttributeUniqueValue[key];
          ws4[cell_ref] = cell;
          col++;
        });
        range4.e.c = col;
        row = 2;

        angular.forEach(reportData.sheet4Data.yAxisSortedValues, function (yAxisAttributeKey) {
          cell = { t: 's' };
          cell_ref = XLSX.utils.encode_cell({ c: 0, r: row });
          cell.v = reportData.sheet4Data.yAxisAttributeUniqueValue[yAxisAttributeKey];
          ws4[cell_ref] = cell;
          col = 1;
          angular.forEach( reportData.sheet4Data.xAxisSortedValues, function (xAxisAttributeKey){
            cell = { t: 'n' };
            cell_ref = XLSX.utils.encode_cell({ c: col, r: row });
            cell.v = reportData.sheet4Data.sheet4RowToColumnMap[yAxisAttributeKey + '/' + xAxisAttributeKey] ? reportData.sheet4Data.sheet4RowToColumnMap[yAxisAttributeKey + '/' + xAxisAttributeKey]: 0 ;
            ws4[cell_ref] = cell;
            col++;
          });
          row++
        });
        range4.e.r = row;

        // SHEET5 - PRODUCT RANKING, PLATFORM, AND SEGMENT DISTRIBUTION
        cell = { t: 's' };
        cell_ref = XLSX.utils.encode_cell({ c: 0, r: 0 });
        cell.v = $filter('translate')('ARTICLES.REPORT.TITLES.PRODUCT_RANKING_PLATFORM_AND_SEGMENT_DISTRIBUTION'); // add sheet heading
        ws5[cell_ref] = cell;

        cell = { t: 's' };
        cell_ref = XLSX.utils.encode_cell({ c: 2, r: 0 });
        cell.v = $filter('translate')('ARTICLES.REPORT.ATTRIBUTES.CUSTOMER_SEGMENTATION'); // add x-axis attribute label
        ws5[cell_ref] = cell;
        range5.e.c = 2;

        cell = { t: 's' };
        cell_ref = XLSX.utils.encode_cell({ c: 0, r: 1 });
        cell.v = $filter('translate')('ARTICLES.REPORT.ATTRIBUTES.PRODUCT_RANKING'); // add y-axis first attribute label
        ws5[cell_ref] = cell;
        range5.e.r = 1;

        cell = { t: 's' };
        cell_ref = XLSX.utils.encode_cell({ c: 1, r: 1 });
        cell.v = $filter('translate')('ARTICLES.REPORT.ATTRIBUTES.PLATFORM'); // add y-axis second attribute label
        ws5[cell_ref] = cell;

        // populate data in sheet
        col = 2;
        angular.forEach(reportData.sheet5Data.xAxisSortedValues, function (key) {
          cell = { t: 's' };
          cell_ref = XLSX.utils.encode_cell({ c: col, r: 1 });
          cell.v = reportData.sheet5Data.xAxisAttributeUniqueValue[key];
          ws5[cell_ref] = cell;
          col++;
        });

        range5.e.c = col;
        row = 2;
        var row1 = 2;

        angular.forEach(reportData.sheet5Data.yAxisFirstAttributeSortedValues, function (yAxisFirstAttributeKey) {
          row = row1;
          cell = { t: 's' };
          cell_ref = XLSX.utils.encode_cell({ c: 0, r: row });
          cell.v = reportData.sheet5Data.yAxisFirstAttributeUniqueValue[yAxisFirstAttributeKey];
          ws5[cell_ref] = cell;

          angular.forEach(reportData.sheet5Data.yAxisSecondAttributeSortedValues, function (yAxisSecondAttributeKey) {
            cell = { t: 's' };
            cell_ref = XLSX.utils.encode_cell({ c: 0, r: row1 });
            cell.v = reportData.sheet5Data.yAxisFirstAttributeUniqueValue[yAxisFirstAttributeKey];
            ws5[cell_ref] = cell;
            cell = { t: 's' };

            cell_ref = XLSX.utils.encode_cell({ c: 1, r: row1 });
            cell.v = reportData.sheet5Data.yAxisSecondAttributeUniqueValue[yAxisSecondAttributeKey];
            ws5[cell_ref] = cell;
            col = 2;

            angular.forEach(reportData.sheet5Data.xAxisSortedValues, function (xAxisAttributeKey) {
              cell = { t: 'n' };
              cell_ref = XLSX.utils.encode_cell({ c: col, r: row1 });
              cell.v = reportData.sheet5Data.rowToColumnMap[yAxisFirstAttributeKey + '/' + yAxisSecondAttributeKey] && reportData.sheet5Data.rowToColumnMap[yAxisFirstAttributeKey + '/' + yAxisSecondAttributeKey][xAxisAttributeKey] ? reportData.sheet5Data.rowToColumnMap[yAxisFirstAttributeKey + '/' + yAxisSecondAttributeKey][xAxisAttributeKey] : 0;
              ws5[cell_ref] = cell;
              col++;
            });
            row1++;
          });
        });
        range5.e.r = row1;

        // SHEET6 - ARCHITECTURE SUMMARY
        cell = { t: 's' };
        cell_ref = XLSX.utils.encode_cell({ c: 0, r: 0 });
        cell.v = $filter('translate')('ARTICLES.REPORT.TITLES.ARCHITECTURE_SUMMARY'); // add sheet heading
        ws6[cell_ref] = cell;

        col = 1;
        // populate data in sheet
        angular.forEach(reportData.sheet6Data.xAxisLabels, function(xAxisLabel) {
          cell = { t: 's' };
          cell_ref = XLSX.utils.encode_cell({ c: col, r: 1 });
          cell.v = xAxisLabel;
          ws6[cell_ref] = cell;
          col++;
        });
        range6.e.c = col;
        range6.e.r = 1;
        row = 2;
        angular.forEach(reportData.sheet6Data.yAxisLabels, function(yAxisLabel) {
          cell = { t: 's' };
          cell_ref = XLSX.utils.encode_cell({ c: 0, r: row });
          cell.v = yAxisLabel;
          ws6[cell_ref] = cell;

          col = 1;
          angular.forEach(reportData.sheet6Data.xAxisLabels, function(xAxisLabel) {
            cell = { t: 's' };
            cell_ref = XLSX.utils.encode_cell({ c: col, r: row });
            cell.v = reportData.sheet6Data.rowToColumnMap[yAxisLabel + '/' + xAxisLabel] ? reportData.sheet6Data.rowToColumnMap[yAxisLabel + '/' + xAxisLabel] : 0;
            ws6[cell_ref] = cell;
            col++;
          });
          row++;
        });
        range6.e.r = row;

        //Save sheet
        ws1['!ref'] = XLSX.utils.encode_range(range1);
        ws2['!ref'] = XLSX.utils.encode_range(range2);
        ws3['!ref'] = XLSX.utils.encode_range(range3);
        ws4['!ref'] = XLSX.utils.encode_range(range4);
        ws5['!ref'] = XLSX.utils.encode_range(range5);
        ws6['!ref'] = XLSX.utils.encode_range(range6);

        var sheetTitle1 = $filter('translate')('ARTICLES.REPORT.TITLES.STYLE_INTRO_FLOW');
        var sheetTitle2 = $filter('translate')('ARTICLES.REPORT.TITLES.ARTICLE_LIFECYCLE');
        var sheetTitle3 = $filter('translate')('ARTICLES.REPORT.TITLES.PROD_RANK_PLATFORM_AND_CLASS');
        var sheetTitle4 = $filter('translate')('ARTICLES.REPORT.TITLES.PRODUCT_SEGMENTATION');
        var sheetTitle5 = $filter('translate')('ARTICLES.REPORT.TITLES.PROD_RANK_PLATFORM_AND_SEGMENT');
        var sheetTitle6 = $filter('translate')('ARTICLES.REPORT.TITLES.ARCHITECTURE_SUMMARY');

        wb.SheetNames.push(sheetTitle1);
        wb.SheetNames.push(sheetTitle2);
        wb.SheetNames.push(sheetTitle3);
        wb.SheetNames.push(sheetTitle4);
        wb.SheetNames.push(sheetTitle5);
        wb.SheetNames.push(sheetTitle6);

        wb.Sheets[sheetTitle1] = ws1;
        wb.Sheets[sheetTitle2] = ws2;
        wb.Sheets[sheetTitle3] = ws3;
        wb.Sheets[sheetTitle4] = ws4;
        wb.Sheets[sheetTitle5] = ws5;
        wb.Sheets[sheetTitle6] = ws6;

        var wbout = XLSX.write(wb, wopts);

        function s2ab(s) {
          var buf = new ArrayBuffer(s.length);
          var view = new Uint8Array(buf);
          for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
          return buf;
        }

        /* the saveAs call downloads a file on the local machine */
        FileSaver.saveAs(new Blob([s2ab(wbout)], { type: "application/octet-stream" }), 'report' + '.xlsx')
      }, 500);

      return defer.promise;
    }

    $rootScope.$on('$destroy', function () {
      if (angular.isFunction(timeoutPromise)) {
        $timeout.cancel(timeoutPromise);
      }
    });

  }

})();
(function() {
    'use strict';

    angular.module('app.dataExporter')
    .factory('orderlineExporter',orderlineExporterFactory);

    /** @ngInject */
	function orderlineExporterFactory($mdDialog, $document, $q, $timeout, $filter, $rootScope, api, utility, catalogFactory, FileSaver) {

        //Data
        var isVasInUse = false;
        var sellerVASList = []; //will be always empty after getting used (will never be persist in memory)
        var timeoutPromise;
        var dataSourceTypeId = catalogFactory.getActiveCatalogDetails().DataSourceTypeId;

		//Methods
		var service = {
            exportOrderline : exportOrderline, // public method
            exportData      : exportData// should not get called from outside of `app.dataExporter` module (made it public to be accessible by modules controller)
		};

		return service;


        //Implementation

        function exportOrderline(orderlinesModel, ordersModel, orderId) {
            // modify orderline model to add additional fields or remove unwanted fields
            modifyOrderlinesModel(orderlinesModel);
            var dialogObj = {
                controller         : 'confirmationController',
                controllerAs       : 'vm',
                templateUrl        : 'app/services/dataExporter/dialogs/confirmation.html',
                parent             : angular.element($document.body),
                targetEvent        : null,
                clickOutsideToClose: false,
                fullscreen         : false,
                locals: {
                    ordersModel: ordersModel,
                    orderlinesModel: orderlinesModel,
                    orderId: orderId
                }
            };
            $mdDialog.show(dialogObj);
        }

        /**
         * @description: a private method which use to get called internally exportOrderline method to export data
         * @param {object} model: model object for module
         * @param {object} lookupData: lookup data for visible columns
         * @param {boolean} shouldIncludeInactiveOrderlines: if sets to true it will export records with inactive orderlines or sizes or orderlines with Status!=0
         */
        function exportData(model, ordersModel, orderId, shouldIncludeInactiveOrderlines) {
            // declare them inside exportOrderline but not on factory level to save memory (cost will be assignment)
            var sizesFields = [
                { field: 'SizeId', type: 'int', displayLabel: 'DATAEXPORTER.ORDERLINE.FIELDS.SIZE_ID', visible: true, inputType: 'number'},
                { field: 'Size', type: 'text', displayLabel: 'DATAEXPORTER.ORDERLINE.FIELDS.SIZE', visible: true, inputType: 'text'},
                { field: 'SizeIndex', type: 'text', displayLabel: 'DATAEXPORTER.ORDERLINE.FIELDS.SIZE_INDEX',
                    exportHeader: 'DATAEXPORTER.ORDERLINE.EXPORT_HEADER.SIZE_INDEX',  visible: true, inputType: 'text'},
                { field: 'SortOrder', type: 'int', displayLabel: 'DATAEXPORTER.ORDERLINE.FIELDS.SIZES_SORT_ORDER', visible: true, inputType: 'number'},
                { field: 'Quantity', type: 'int', displayLabel: 'DATAEXPORTER.ORDERLINE.FIELDS.QUANTITY', visible: true, inputType: 'number'},
                { field: 'InitialValue', type: 'int', displayLabel: 'DATAEXPORTER.ORDERLINE.FIELDS.INITIAL_VALUE', visible: true, inputType: 'calculated',
                    calculatedExpression: 'data["Quantity"]*data["InitialPrice"]'},
                { field: 'CurrentValue', type: 'int', displayLabel: 'DATAEXPORTER.ORDERLINE.FIELDS.CURRENT_VALUE', visible: true, inputType: 'calculated',
                    calculatedExpression: 'data["Quantity"]*data["CurrentPrice"]'},
                { field: 'Status', type: 'text', displayLabel: 'DATAEXPORTER.ORDERLINE.FIELDS.SIZES_STATUS', visible: true, inputType: 'status'}
            ],
            VASFields = [
                { field: 'VasId', type: 'int', displayLabel: 'DATAEXPORTER.ORDERLINE.FIELDS.VAS_ID', visible: true, inputType: 'number'},
                { field: 'VasCode', type: 'text', displayLabel: 'DATAEXPORTER.ORDERLINE.FIELDS.VAS_CODE', visible: true, inputType: 'text'},
                { field: 'AdditionalInfo', type: 'text', displayLabel: 'DATAEXPORTER.ORDERLINE.FIELDS.ADITIONAL_INFO', visible: true, inputType: 'text'},
                { field: 'Status', type: 'text', displayLabel: 'DATAEXPORTER.ORDERLINE.FIELDS.VAS_STATUS', visible: true, inputType: 'status'}
            ];

            var orderlines, data, additionalInfoMap, lookupData = {};

            var deferred = $q.defer();
            var loadOrderLineDeferred = $q.defer();
            var loadVASDeferred = $q.defer();

            var loadDataPromises = [];
            loadDataPromises.push(loadOrderLineDeferred.promise);
            loadDataPromises.push(loadVASDeferred.promise);

            var activeCatalog = catalogFactory.getActiveCatalog();
            ordersModel.methods.getDetails(false, orderId, activeCatalog.CatalogCode).then(function(response) {
                var orderDetail = response.data;
                orderlines = response.data.orderlineResponse;
                additionalInfoMap = {};

                additionalInfoMap.OrderProcessStatusId = orderDetail['OrderProcessStatusId'];
                additionalInfoMap.CustomerNumber = orderDetail['CustomerNumber'];
                additionalInfoMap.LocationCode = orderDetail['LocationCode'];
                additionalInfoMap.orderReference = orderDetail['OrderReference']; // use for file name in case there is no orderline
                additionalInfoMap.Alias = orderDetail['Alias'];

                // use redundant code to avoid additional check on each loop iteration
                if(shouldIncludeInactiveOrderlines === false) {
                    data = flattenOrderlineAttributesAndFilterOutInactiveOrderlines(orderlines, additionalInfoMap);
                } else {
                    data = flattenOrderlineAttributes(orderlines, additionalInfoMap);
                }
                loadOrderLineDeferred.resolve();
            }).catch(function(err) {
                loadOrderLineDeferred.reject('Unable to load order details: ', err);
            });

            //load VAS if in use by catalog
            isVasInUse = (angular.isDefined(activeCatalog) && angular.isDefined(activeCatalog.IsVasInUse) && activeCatalog.IsVasInUse == 1)? true: false;
            if(isVasInUse) {
                api.sellers.vas.methods.getList( { forceFetch: true, isLogRequired: false } ).then(function(response) {
                    sellerVASList = response.data;
                    loadVASDeferred.resolve();
                });
            }
            else {
                loadVASDeferred.resolve();
            }

            //call lookup data to load lookup data for invisible fields in UI
            var lookupPromises = updateLookupData(lookupData, model.fields);
            angular.forEach(lookupPromises, function(lookupPromise) {
                loadDataPromises.push(lookupPromise);
            });

            timeoutPromise = $timeout(function() {
                var wopts = { bookType: 'xlsx', bookSST: false, type: 'binary' };

                var wb = { SheetNames: [], Sheets: {} };
                var ws = {};
                var lastColumnIndex = 0;
                var col = 0;
                var range = {s: {c: 0, r: 0}, e: {c: 0, r: 0} };
                var cell = {};
                var cell_ref = {};
                var field = {};
                var flatFieldsLastColumnIndex = 0;

                //Write Headers Row
                for (var i=0; i<model.fields.length; i++) {
                    field = model.fields[i];

                    if (field.visible) {
                        cell = {t: 's'};
                        cell_ref = XLSX.utils.encode_cell({c:col,r:0});
                        col++;

                        cell.v = angular.isUndefined(field.exportHeader) ? $filter('translate')(field.displayLabel) : $filter('translate')(field.exportHeader);

                        ws[cell_ref] = cell;
                    }

                }
                lastColumnIndex = flatFieldsLastColumnIndex = col-1;

                lastColumnIndex = createNestedColumnsHeader(flatFieldsLastColumnIndex+1, ws, sizesFields, VASFields);

                range.e.c = lastColumnIndex;

                //Write all data after all lookups loaded
                $q.all(loadDataPromises).then(function() {
                    for (var i=0; i<data.length; i++) {
                        range.e.r++;
                        col = 0;
                        for (var j=0; j<model.fields.length; j++) {
                            field = model.fields[j];

                            if (field.visible) {
                                cell = {t: 's'};
                                cell_ref = XLSX.utils.encode_cell({c:col,r:range.e.r});
                                col++;

                                ws[cell_ref] = writeData(field, data[i], cell, lookupData);
                            }
                        }

                        //add the sizes lines
                        for(var sizesIndex=0; sizesIndex<data[i]['orderLineSizeResponse'].length; sizesIndex++) {

                            //Add orderline InitialPrice and CurrentPrice to each size object to be use in calculated expression (initial and current values)
                            data[i]['orderLineSizeResponse'][sizesIndex]['InitialPrice'] = data[i]['InitialPrice'];
                            data[i]['orderLineSizeResponse'][sizesIndex]['CurrentPrice'] = data[i]['CurrentPrice'];

                            if(sizesIndex !== 0) { // copy previous row flatten data to next row
                                range.e.r++;
                                for(var c=0; c<= flatFieldsLastColumnIndex; c++) {
                                    cell_ref = XLSX.utils.encode_cell({c:c,r:range.e.r});
                                    var previousRowCell_ref = XLSX.utils.encode_cell({c:c,r:range.e.r-1});
                                    ws[cell_ref] = ws[previousRowCell_ref];
                                    col = c+1;
                                }
                            }
                            for(var sizesFieldIndex=0; sizesFieldIndex<sizesFields.length; sizesFieldIndex++) {
                                if (sizesFields[sizesFieldIndex].visible) {
                                    cell = {t: 's'};
                                    cell_ref = XLSX.utils.encode_cell({c:col,r:range.e.r});
                                    col++;

                                    ws[cell_ref] = writeData(sizesFields[sizesFieldIndex], data[i]['orderLineSizeResponse'][sizesIndex], cell, lookupData);
                                }
                            }
                            //if VAS exists add VAS line
                            if(isVasInUse) {
                                for(var vasIndex=0; vasIndex<data[i]['orderLineVasResponse'].length; vasIndex++) {
                                    for(var vasFieldIndex=0; vasFieldIndex<VASFields.length; vasFieldIndex++) {
                                        if (VASFields[vasFieldIndex].visible) {
                                            cell = {t: 's'};
                                            cell_ref = XLSX.utils.encode_cell({c:col,r:range.e.r});
                                            col++;

                                            ws[cell_ref] = writeData(VASFields[vasFieldIndex], data[i]['orderLineVasResponse'][vasIndex], cell, lookupData);
                                        }
                                    }
                                }
                            }
                        }
                    }

                    //Save sheet
                    ws['!ref'] = XLSX.utils.encode_range(range);

                    var ws_name = angular.isUndefined(model.exportTitle) ? $filter('translate')(model.title) : $filter('translate')(model.exportTitle);
                    if (angular.isUndefined(ws_name) || !angular.isString(ws_name) || ws_name.length <= 0) {
                        ws_name = "export";
                    }

                    var fileName = ws_name;
                    if(angular.isDefined(additionalInfoMap) && angular.isDefined(additionalInfoMap.orderReference) && angular.isString(additionalInfoMap.orderReference)) {
                        fileName = fileName + '_' + additionalInfoMap.orderReference;
                    }
                    else {
                        if(data.length > 0) {
                            fileName = fileName + '_' + $filter('recordRenderer')(data[0]['OrderId'], lookupData, field);
                        }
                    }

                    wb.SheetNames.push(ws_name);
                    wb.Sheets[ws_name] = ws;
                    var wbout = XLSX.write(wb, wopts);

                    function s2ab(s) {
                        var buf = new ArrayBuffer(s.length);
                        var view = new Uint8Array(buf);
                        for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
                        return buf;
                    }

                    /* the saveAs call downloads a file on the local machine */
                    FileSaver.saveAs(new Blob([s2ab(wbout)], { type: "application/octet-stream" }), fileName + '.xlsx');

                    deferred.resolve(true);
                    cleanFactoryData();
                });

            }, 500);

            return deferred.promise;
        }


        // private methods

        function createNestedColumnsHeader(index, workSheet, sizesFields, VASFields) {
            for (var i=0; i<sizesFields.length; i++) {
                if (sizesFields[i].visible) {
                    var cell = {t: 's'};
                    var cell_ref = XLSX.utils.encode_cell({c:index,r:0});
                    index++;

                    cell.v = angular.isUndefined(sizesFields[i].exportHeader) ? $filter('translate')(sizesFields[i].displayLabel) : $filter('translate')(sizesFields[i].exportHeader);

                    workSheet[cell_ref] = cell;
                }
            }
            if(isVasInUse) {
                for(var m=1, len=sellerVASList.length; m<=len ;m++) {
                    for (var j=0; j<VASFields.length; j++) {
                        if (VASFields[j].visible) {
                            cell = {t: 's'};
                            cell_ref = XLSX.utils.encode_cell({c:index,r:0});
                            index++;

                            cell.v = angular.isUndefined(VASFields[j].exportHeader) ? $filter('translate')(VASFields[j].displayLabel) + '(' + m + ')' : $filter('translate')(VASFields[j].exportHeader) + '(' + m + ')';

                            workSheet[cell_ref] = cell;
                        }
                    }
                }
            }
            return index-1;
        }

        function writeData(field, data, cell, lookupData) {
            switch(field.inputType) {
                case 'lookup':
                    cell.v = $filter('recordRenderer')(data[field.field], lookupData, field);
                    break;

                case 'lookup-many':
                    cell.v = $filter('lookupManyRenderer')(data[field.field], lookupData, field);
                    break;

                // Dates are written as real Excel dates (numeric serial + date number-format)
                // instead of strings, so Excel sorts them chronologically. The z format mirrors
                // the display the string export used. Empty/invalid values leave cell.v unset.
                case 'date':
                    cell.t = 'n';
                    cell.z = 'mm/dd/yyyy h:mm AM/PM';
                    var date = utility.dateToExcelSerial(data[field.field], false);
                    if(angular.isDefined(date)) {
                        cell.v = date;
                    }
                    break;

                case 'date-without-time':
                case 'date-option':
                    cell.t = 'n';
                    cell.z = 'mm/dd/yyyy';
                    var dateWithoutTime = utility.dateToExcelSerial(data[field.field], false);
                    if(angular.isDefined(dateWithoutTime)) {
                        cell.v = dateWithoutTime;
                    }
                    break;

                case 'date-utc':
                    cell.t = 'n';
                    cell.z = 'mmm d, yyyy h:mm:ss AM/PM';
                    var dateUTC = utility.dateToExcelSerial(data[field.field], true);
                    if(angular.isDefined(dateUTC)) {
                        cell.v = dateUTC;
                    }
                    break;

                case 'number':
                case 'decimal':
                    cell.t = 'n';
                    cell.v = data[field.field];
                    break;

                case 'bool':
                case 'bool-int':
                case 'int-bool':
                    cell.t = 'b';
                    cell.v = (data[field.field] == 1 || data[field.field] == true);
                    break;

                case 'bool-str':
                    cell.t = 's';
                    var val;
                    val = (data[field.field] == 'true') ? 'true' : 'false';
                    cell.v = val;
                    break;

                case 'status':
                    cell.t = 's';
                    cell.v = '';
                    if(data[field.field] === 0) {
                        cell.v = 'Inactive';
                    }
                    if(data[field.field] === 1) {
                        cell.v = 'Active';
                    }

                case 'article-status':
                    cell.t = 's';
                    cell.v = '';
                    var articleStatus = utility.getArticleStatusValue(data, field, dataSourceTypeId);
                    if(articleStatus === 0) {
                        cell.v = 'Inactive';
                    }
                    if(articleStatus === 1) {
                        cell.v = 'Active';
                    }
                    if(articleStatus === 2) {
                        cell.v = 'Globally Dropped';
                    }
                    if(articleStatus === 3) {
                        cell.v = 'Not Assorted';
                    }
                    break;

                case 'notificationStatus':
                    cell.t = 's';
                    cell.v = '';
                    if(data[field.field] === 0 || data[field.field] === '0'){
                        cell.v = 'Pending';
                    }
                    else if(data[field.field] === 10 || data[field.field] === '10') {
                        cell.v = 'Sent Successfully';
                    }
                    break;

                case 'calculated':
                    if(field.type === 'int') {
                        cell.t = 'n';
                    }
                    else if(field.type === 'text') {
                        cell.t = 's';
                    }
                    var cellVal = data[field.field];
                    if(cell.t === 's' || (cell.t === 'n' && angular.isDefined(cellVal) && cellVal != null)) {
                        cell.v = cellVal;
                    }
                    break;

                case 'list':
                    cell.t = 's';
                    cell.v = data[field.field];
                    break;

                case 'target-attributes-json-str':
                    cell.t = 's';
                    cell.v = angular.toJson($filter('targetAndAggregateAttributesRenderer')(data[field.field], false));
                    break;

                case 'array':
                    cell.t = 's';
                    cell.v = data[field.field];
                    break;

                case 'color-palette':
                    cell.t = 's';
                    cell.v = $filter('colorPaletteRenderer')(data[field.field], field);
                    break;

                case 'icon':
                    // not implemented for icon
                    break;

                case 'lookup-from-map':
                    cell.t = 's';
                    var lookupSource = field.lookupSource;
                    // remove the "vm.api." prefix from the lookupSource
                    // lookup-from-map should be from the index.api file
                    if (lookupSource.startsWith('vm.api.')) {
                        lookupSource = lookupSource.substring(7);
                    }
                    cell.v = api[lookupSource][data[field.field]];
                    break;

                default:
                    cell.t = 's';
                    cell.v = data[field.field];
            }
            return cell;
        }

        // will only get calls when user opt to export all columns
        function updateLookupData(lookupData, allColumns) {
            var lookupPromises = [];
            for (var i=0; i<allColumns.length; i++) {
                if (allColumns[i].inputType === 'lookup') {
                    if (!lookupData[allColumns[i].lookupSource] || angular.isUndefined(lookupData[allColumns[i].lookupSource])) {
                        lookupPromises.push(loadLookup(lookupData, allColumns[i].lookupSource));
                    }
                }
            }
            return lookupPromises;
        }

        function loadLookup(lookupData, lookupSource) {
            lookupData[lookupSource] = {};

            return api.getLookupData(api.getModel(lookupSource)).then(function(result) {
                lookupData[lookupSource] = result;
            });
        }

        function cleanFactoryData() {
            isVasInUse = false;
            sellerVASList.length = 0;
            $timeout.cancel(timeoutPromise);
            timeoutPromise = undefined;
        }

        function flattenOrderlineAttributes(orderLines, additionalInfoMap) {
            angular.forEach(orderLines, function (orderLine) {
                for (var prop in orderLine.Attributes) {
                    orderLine[prop] = orderLine.Attributes[prop];
                }
                delete orderLine.Attributes;
                orderLine['CustomerNumber'] = additionalInfoMap.CustomerNumber;
                orderLine['LocationCode'] = additionalInfoMap.LocationCode;
                orderLine['OrderProcessStatusId'] = additionalInfoMap.OrderProcessStatusId;
                orderLine['Alias'] = additionalInfoMap.Alias;
            });
            return orderLines;
        }

        function flattenOrderlineAttributesAndFilterOutInactiveOrderlines(orderLines, additionalInfoMap) {
            var filteredData = [];
            var orderlineSizesIndex, orderlineSizesLen, validOrderline;
            for(var i=0, len=orderLines.length; i<len; i++) {
                if(orderLines[i].IsActive == 0 || orderLines[i].Status != 0) {
                    continue;
                }
                // validOrderline = angular.copy(orderLines[i]); //TODO- could be a performance hit
                validOrderline = orderLines[i];

                // flatten orderline attributes
                for (var prop in validOrderline.Attributes) {
                    validOrderline[prop] = validOrderline.Attributes[prop];
                }
                delete validOrderline.Attributes;
                validOrderline['CustomerNumber'] = additionalInfoMap.CustomerNumber;
                validOrderline['LocationCode'] = additionalInfoMap.LocationCode;
                validOrderline['OrderProcessStatusId'] = additionalInfoMap.OrderProcessStatusId;
                validOrderline['Alias'] = additionalInfoMap.Alias;
                var orderLineSizes = orderLines[i].orderLineSizeResponse;
                // filter out inactive sizes
                validOrderline.orderLineSizeResponse = [];
                for(orderlineSizesIndex=0, orderlineSizesLen=orderLineSizes.length; orderlineSizesIndex<orderlineSizesLen; orderlineSizesIndex++) {
                    if(orderLineSizes[orderlineSizesIndex].Status != 0) {
                        validOrderline.orderLineSizeResponse.push(orderLineSizes[orderlineSizesIndex]);
                    }
                }
                filteredData.push(validOrderline);
            }
            return filteredData;
        }

        function modifyOrderlinesModel(orderlinesModel) {
            var customerCodeField = {
                field: 'CustomerNumber', type: 'text', displayLabel: 'ORDERLINE.FIELDS.CUSTOMER_CODE',
                exportHeader: 'ORDERLINE.EXPORT_HEADER.CUSTOMER_CODE', visible: true, inputType: 'text'
            };
            var locationCodeField = {
                field: 'LocationCode', type: 'text', displayLabel: 'ORDERLINE.EXPORT_HEADER.LOCATION_CODE',
                exportHeader: 'ORDERLINE.EXPORT_HEADER.LOCATION_CODE', visible: true, inputType: 'text'
            };
            var aliasField = {
                field: 'Alias', type: 'text', displayLabel: 'ORDERLINE.EXPORT_HEADER.ALIAS',
                exportHeader: 'ORDERLINE.EXPORT_HEADER.ALIAS', visible: true, inputType: 'text'
            };

            orderlinesModel.fields.push(customerCodeField);
            orderlinesModel.fields.push(locationCodeField);
            orderlinesModel.fields.push(aliasField);

            // remove 'TotalQuantity' field from export file
            orderlinesModel.fields.splice(orderlinesModel.fields.indexOf(utility.filterObject(orderlinesModel.fields, {field: 'TotalQuantity'}, true)[0]), 1);
        }


    }

})();
(function() {
    'use strict';

    angular.module('app.dataExporter')
    .factory('dataExporter',dataExporterFactory);

    /** @ngInject */
	function dataExporterFactory($mdDialog, $document) {

        //Data
		var dialogObj = {
                controller         : 'dataExporterController',
                controllerAs       : 'vm',
                templateUrl        : '',
                parent             : angular.element($document.body),
                targetEvent        : null,
                clickOutsideToClose: false,
                fullscreen         : true,
                locals             : {

                }
            };

		//Methods
		var service = {
            exportExcel           : exportExcel
		};

		return service;

        function exportExcel(model, allData, filteredData, lookupData, colsList, defaultSelection, isRequestModule) {
            var template = 'app/services/dataExporter/dataExporter.html';

            dialogObj.templateUrl = template;
            dialogObj.locals['title'] = '';
            dialogObj.locals['message'] = '';
            dialogObj.locals['action'] = null;
            dialogObj.locals['items'] = null;
            dialogObj.locals['allData'] = allData;
            dialogObj.locals['filteredData'] = filteredData;
            dialogObj.locals['lookupData'] = lookupData;
            dialogObj.locals['model'] = model;
            dialogObj.locals['colsList'] = colsList;
            dialogObj.locals['defaultSelection'] = defaultSelection;
            dialogObj.locals['isRequestModule'] = isRequestModule;

            return $mdDialog.show(dialogObj);
        }
    }
})();





(function(){
    'use strict';

    angular.module('app.dataExporter')
    .controller('dataExporterController', dataExporterController);

    /** @ngInject */
    function dataExporterController(utility, $mdDialog, $q, $timeout, $filter, FileSaver, Blob, api, model,
        allData, filteredData, lookupData, colsList, defaultSelection, isRequestModule, $scope, $rootScope, requestsFactory, catalogFactory){
        /* jshint validthis: true */
        var vm = this;
        //TODO: Maybe combining this functionality inside the tx-data-table would be better since it can only be used from there!

        vm.processing = false;
        vm.selection = defaultSelection;
        vm.columnsOption = isRequestModule ? 0 : 1; //for request module always all columns else visible columns
        vm.model = model;
        vm.isRequestModule = isRequestModule;
        var exportRequestData = [];
        var visibleColumnList = colsList;
        var allcolumns;
        var timeoutPromise;
        var dataSourceTypeId = catalogFactory.getActiveCatalogDetails().DataSourceTypeId;

        vm.onColumnsOptionChange = onColumnsOptionChange;
        vm.closeDialog = closeDialog;
        vm.doOk = doOk;


        ////////////////

        function onColumnsOptionChange(columnsOption) {
            if(columnsOption == 0) {// all columns
                if(angular.isUndefined(allcolumns)) {
                    allcolumns = angular.copy(visibleColumnList);
                    angular.forEach(model.fields, function(field) {
                        if(angular.isUndefined(utility.filterObject(visibleColumnList, {field: field.field}, true)[0])) {
                            allcolumns.push(field);
                        }
                    });
                }
                colsList = allcolumns;
            }
            else if(columnsOption == 1) { //visible columns
                colsList = visibleColumnList;
                closeDialog(true);
            }
        }

        function closeDialog(confirmation) {
            $mdDialog.hide(confirmation);
        }

        function doOk() {
            vm.processing = true;
            var promise = $q.when();
            if(vm.model.modelPath === 'catalogs.colorPalette') { // specific to color palette module. export colors when exporting color palette
                var colorsField = utility.filterObject(vm.model.fields, {field: 'SellerColorIds'}, true)[0];
                colorsField.visible = true;
                if (!colsList.some(function(existingField) {
                    return existingField.field === colorsField.field;
                })) {
                    colsList.push(colorsField);
                }
            }
            //lookup data is loaded in case of all columns
            promise = loadLookupData();
            if (vm.columnsOption == 0) {
                if(!vm.isRequestModule) {
                    promise.then(function () {
                        saveData().finally(function () {
                            vm.processing = false;
                            closeDialog(true);
                        });
                    });
                } else { // specific to request module
                    var requestIdsArray = [];
                    var articleList = api.currentCatalogArticleList;
                    if (vm.selection == '0') {
                        requestIdsArray = requestsFactory.generateRequestIdsArray(allData);
                    } else if(vm.selection == '2') {
                        // selected data only send selected : true records
                        requestIdsArray = requestsFactory.generateRequestIdsArray(utility.filterObject(allData, { selected: true }, true))
                    } else {
                        requestIdsArray = requestsFactory.generateRequestIdsArray(filteredData);
                    }
                    vm.model.methods.getRequestsExportData(requestIdsArray).then(function(response) {
                        var requestData = response.data;
                        var requestObj = requestsFactory.generateExportRequestData(articleList, requestData, colsList);
                        exportRequestData = requestObj.requestObject;
                        colsList = requestObj.colsList;
                        promise.then(function () {
                            saveData().finally(function () {
                                vm.processing = false;
                                closeDialog(true);
                            });
                        });
                    })

                }

            } else {
                saveData().finally(function () {
                    vm.processing = false;
                    closeDialog(true);
                });
            }
        }

        function saveData() {
            var defer = $q.defer();
            var CHUNK_SIZE = 3000;
            // bookSST: true — use the Shared String Table instead of inline strings.
            // With SST, the sheet XML stores integer indices (<v>42</v>) rather than the
            // raw string values per cell, shrinking the sheet XML by ~50% for typical
            // business data with repeated values (brand, status, season, etc.).
            // On import, the SST also deduplicates string objects in memory, so repeated
            // values cost one allocation instead of one per cell — critical for large files.
            var wopts = { bookType: 'xlsx', bookSST: true, type: 'binary' };
            var data;

            if(!vm.isRequestModule) {
                if (vm.selection == '0' || vm.selection == '2') {
                    data = allData;
                } else {
                    data = filteredData;
                }
            } else {
                data = exportRequestData;
            }

            // specific to targets module. export targeted attributes and aggregate attributes as indevedual attribute
            if(vm.model.modelPath === 'catalogs.targets') {
                // add targetd and aggregate attributes to the column list
                var targetedAttributes = catalogFactory.getActiveCatalogDetails().TargettedAttributeList;
                var aggregateAttributes = catalogFactory.getActiveCatalogDetails().AggregateAttributeList;
                if(targetedAttributes.length) {
                    angular.forEach(targetedAttributes, function(targetedAttribute) {
                        targetedAttribute.visible = true;
                        targetedAttribute.displayLabel = targetedAttribute.AttributeDisplayName;
                        targetedAttribute.isTargetAttribute = true;
                        colsList.push(targetedAttribute);
                    });
                }
                if(aggregateAttributes.length) {
                    angular.forEach(aggregateAttributes, function(aggregateAttribute) {
                        aggregateAttribute.visible = true;
                        aggregateAttribute.displayLabel = aggregateAttribute.AttributeDisplayName;
                        aggregateAttribute.isAggregateAttribute = true;
                        colsList.push(aggregateAttribute);
                    });
                }
            }

            // Pre-compute visible columns
            var visibleCols = [];
            for (var k = 0; k < colsList.length; k++) {
                if (colsList[k].visible) {
                    visibleCols.push(colsList[k]);
                }
            }

            // Filter selected-only data upfront
            var exportData;
            if (vm.selection == '2') {
                exportData = [];
                for (var k = 0; k < data.length; k++) {
                    if (data[k].selected) exportData.push(data[k]);
                }
            } else {
                exportData = data;
            }

            var ws_name = $filter('translate')(model.title);
            if (angular.isUndefined(ws_name) || !angular.isString(ws_name) || ws_name.length <= 0) {
                ws_name = "export";
            }
            
            var sheetName = ws_name.replace(/[:\\\/?*\[\]]/g, ' ');
            if (sheetName.length > 31) {
                sheetName = sheetName.substring(0, 31);
            }

            // The worksheet is backed by a Map to avoid V8's per-object property limit,
            // which throws RangeError when a plain object accumulates millions of string keys.
            // SheetJS accesses cells by direct key lookup (ws[cellRef]) rather than property
            // enumeration, so the Proxy transparently routes cell reads/writes to the Map
            // while keeping sheet metadata properties (!ref, !cols, etc.) on the target object.
            var _cellMap = new Map();
            var ws = new Proxy({}, {
                get: function(target, prop) {
                    if (typeof prop !== 'string' || prop.charAt(0) === '!') return target[prop];
                    return _cellMap.get(prop);
                },
                set: function(target, prop, value) {
                    if (typeof prop !== 'string' || prop.charAt(0) === '!') {
                        target[prop] = value;
                    } else {
                        _cellMap.set(prop, value);
                    }
                    return true;
                }
            });
            var dataIndex = 0;
            var wsRowIndex = 1; // row 0 = headers, data rows start at 1

            for (var h = 0; h < visibleCols.length; h++) {
                var hLabel = $filter('translate')(visibleCols[h].displayLabel).replace(/&amp;/, '&');
                ws[XLSX.utils.encode_cell({r: 0, c: h})] = {t: 's', v: hLabel};
            }

            // Cells are written to the worksheet in fixed-size chunks with a $timeout
            // between each chunk to yield control back to the browser event loop,
            // preventing the UI from freezing during large exports.
            function processDataChunk() {
                var end = Math.min(dataIndex + CHUNK_SIZE, exportData.length);
                for (var i = dataIndex; i < end; i++) {
                    var r = wsRowIndex++;
                    for (var j = 0; j < visibleCols.length; j++) {
                        var field = visibleCols[j];
                        var cell = {t: 's'};
                        if(vm.model.modelPath !== 'catalogs.targets') {
                            setCellTypeAndData(field, exportData[i], cell);
                        } else {
                            if(!field.isTargetAttribute && !field.isAggregateAttribute) {
                                setCellTypeAndData(field, exportData[i], cell);
                            } else {
                                // show the targeted and aggregate attributes as indevedual seprate columns
                                if(field.isTargetAttribute && exportData[i]['Attributes'] != null && exportData[i]['Attributes'].length) {
                                    var targetedAttributeValue = angular.fromJson(exportData[i]['Attributes']);
                                    cell.v = targetedAttributeValue[field.AttributeId];
                                } else if(exportData[i]['AggregateAttributes'] != null && exportData[i]['AggregateAttributes'].length) {
                                    var aggregateAttributeValue = angular.fromJson(exportData[i]['AggregateAttributes']);
                                    cell.t = 'n'; // aggregate attributes are always number type
                                    cell.v = aggregateAttributeValue[field.AttributeId];
                                }
                            }
                        }
                        // Cells with undefined/null are omitted from the sheet (importer treats
                        // missing cells as null). Empty string '' is written explicitly to
                        // preserve round-trip fidelity — the importer distinguishes '' from null.
                        if (cell.v !== undefined && cell.v !== null) {
                            // bookSST: true requires string-typed cells to carry actual JS strings.
                            // With bookSST: false, SheetJS's stringify_value() did this coercion
                            // automatically. Several input types (array, calculated, targeted
                            // attributes) can produce non-string values for t:'s' cells, so we
                            // replicate the same coercion here before adding the cell to the SST.
                            if (cell.t === 's' && typeof cell.v !== 'string') {
                                cell.v = String(cell.v);
                            }
                            ws[XLSX.utils.encode_cell({r: r, c: j})] = cell;
                        }
                    }
                }
                dataIndex = end;

                if (dataIndex < exportData.length) {
                    timeoutPromise = $timeout(processDataChunk, 0);
                } else {
                    finalizeWorkbook();
                }
            }

            function finalizeWorkbook() {
                timeoutPromise = $timeout(function() {
                    ws['!ref'] = XLSX.utils.encode_range({r: 0, c: 0}, {r: wsRowIndex - 1, c: visibleCols.length - 1});
                    var wb = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(wb, ws, sheetName);
                    ws = null;
                    var wbout = XLSX.write(wb, wopts);
                    wb = null;
                    downloadFile(wbout);
                    defer.resolve(true);
                }, 0);
            }

            function downloadFile(wbout) {
                function s2ab(s) {
                    var buf = new ArrayBuffer(s.length);
                    var view = new Uint8Array(buf);
                    for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
                    return buf;
                }
                FileSaver.saveAs(new Blob([s2ab(wbout)], {type: "application/octet-stream"}), ws_name + '.xlsx');
            }

            processDataChunk();

            return defer.promise;
        }

        function loadLookupData() {
            var promises = []
            var p
            for (var i=0; i<colsList.length; i++) {
                if (colsList[i].inputType === 'lookup' || colsList[i].inputType === 'lookup-many' || colsList[i].inputType === 'articlenumber' || colsList[i].inputType === 'modelnumber' || colsList[i].inputType === 'linkedcatalogarticlenumber') {
                    if (!lookupData[colsList[i].lookupSource] || angular.isUndefined(lookupData[colsList[i].lookupSource])) {
                        p = loadLookup(colsList[i].lookupSource);
                        promises.push(p)
                    }
                }
            }
            return $q.all(promises)
        }

        function loadLookup(lookupSource) {
            lookupData[lookupSource] = {};
            return api.getLookupData(api.getModel(lookupSource)).then(function(result) {
                lookupData[lookupSource] = result;
            });
        }

        function setCellTypeAndData(field, data, cell) {
            switch(field.inputType) {
                case 'lookup':
                case 'articlenumber':
                case 'linkedcatalogarticlenumber':
                    cell.t = 's';
                    cell.v = $filter('recordRenderer')(data[field.field], lookupData, field);
                    break;

                case 'lookup-many':
                    cell.t = 's';
                    // catalog color palette
                    if(field.field === 'SellerColorIds') {
                        if(data.Colors && data.Colors.length) {
                            data[field.field] = data.Colors.map(function(color) {
                                return color.ColorId;
                            })
                        } else {
                            data[field.field] = [];
                        }
                    }
                    cell.v = $filter('lookupManyRenderer')(data[field.field], lookupData, field);
                    break;

                // Dates are written as real Excel dates (numeric serial + date number-format)
                // instead of strings, so Excel sorts them chronologically. The z format mirrors
                // the display the string export used. Empty/invalid values leave cell.v unset so
                // the cell is omitted (same as before).
                case 'date':
                    cell.t = 'n';
                    cell.z = 'mm/dd/yyyy h:mm AM/PM';
                    var date = utility.dateToExcelSerial(data[field.field], false);
                    if(angular.isDefined(date)) {
                        cell.v = date;
                    }
                    break;

                case 'date-without-time':
                case 'date-option':
                    cell.t = 'n';
                    cell.z = 'mm/dd/yyyy';
                    var dateWithoutTime = utility.dateToExcelSerial(data[field.field], false);
                    if(angular.isDefined(dateWithoutTime)) {
                        cell.v = dateWithoutTime;
                    }
                    break;

                case 'date-utc':
                    cell.t = 'n';
                    cell.z = 'mm/dd/yyyy';
                    var dateUTC = utility.dateToExcelSerial(data[field.field], true);
                    if(angular.isDefined(dateUTC)) {
                        cell.v = dateUTC;
                    }
                    break;

                case 'number':
                case 'decimal':
                    cell.t = 'n';
                    if(angular.isDefined(data[field.field]) && data[field.field] != null) {
                        cell.v = data[field.field];
                    }
                    break;

                case 'bool':
                case 'bool-int':
                case 'int-bool':
                    cell.t = 'b';
                    if(angular.isDefined(data[field.field]) && data[field.field] != null) {
                        cell.v = (data[field.field] == 1 || data[field.field] == true);
                    }
                    break;

                case 'bool-str':
                    cell.t = 'b';
                    var val;
                    if(angular.isDefined(data[field.field]) && data[field.field] != null) {
                        val = (data[field.field] == 'true') ? true : false;
                        cell.v = val;
                    }
                    break;

                case 'status':
                case 'status-segmentation':
                    cell.t = 's';
                    cell.v = '';
                    if(data[field.field] === 0) {
                        cell.v = 'Inactive';
                    }
                    if(data[field.field] === 1) {
                        cell.v = 'Active';
                    }

                case 'article-status':
                    cell.t = 's';
                    cell.v = '';
                    var articleStatus = utility.getArticleStatusValue(data, field, dataSourceTypeId);
                    if(articleStatus === 0) {
                        cell.v = 'Inactive';
                    }
                    if(articleStatus === 1) {
                        cell.v = 'Active';
                    }
                    if(articleStatus === 2) {
                        cell.v = 'Globally Dropped';
                    }
                    if(articleStatus === 3) {
                        cell.v = 'Not Assorted';
                    }
                    break;

                case 'notificationStatus':
                    cell.t = 's';
                    cell.v = '';
                    if(data[field.field] === 0 || data[field.field] === '0'){
                        cell.v = 'Pending';
                    }
                    else if(data[field.field] === 10 || data[field.field] === '10') {
                        cell.v = 'Sent Successfully';
                    }
                    break;

                case 'calculated':
                    if(field.type === 'int') {
                        cell.t = 'n';
                    }
                    else if(field.type === 'text') {
                        cell.t = 's';
                    }
                    var cellVal = data[field.field];
                    if(angular.isDefined(cellVal) && cellVal != null) {
                        cell.v = cellVal;
                    }
                    break;

                case 'calculated-url':
                    var value = $rootScope.$eval(field.calculatedExpression, { data: data });
                    cell.l = { Target: value, Tooltip: value };
                    cell.t = 's';
                    cell.v = value;
                    break;

                case 'list':
                    cell.t = field.type === 'int' ? 'n' : 's';
                    if(field.type === 'int') {
                        if (angular.isDefined(data[field.field]) && data[field.field] != null) {
                            cell.v = data[field.field];
                        }
                    } else if(field.type === 'text') {
                        if(angular.isUndefined(data[field.field]) || data[field.field] == null) {
                            cell.v = '';
                        } else {
                            cell.v = String(data[field.field]);
                        }
                    }
                    break;

                case 'target-attributes-json-str':
                    cell.t = 's';
                    cell.v = angular.toJson($filter('targetAndAggregateAttributesRenderer')(data[field.field], false));
                    break;

                case 'dynamic-attribute-value':
                    var attributeOrder = field.field.match(/\d/)[0];
                    var assignedCatalogAttributes = catalogFactory.getActiveCatalogDetails().AssignedCatalogAttributes;
                    var attribute = utility.changeAttributeType(utility.filterObject(assignedCatalogAttributes, {AttributeDisplayName: data['Attribute_' + attributeOrder + '_Name']}, true)[0]);
                    field.inputType = attribute.inputType;
                    setCellTypeAndData(field, data, cell);
                    break;

                case 'icon':
                    // not implemented for icon
                    break;
                case 'array':
                    cell.t = 's';
                    cell.v = data[field.field];
                    break;

                case 'color-palette':
                case 'dataset':
                    cell.t = 's';
                    var colorPaletteValue = $filter('colorPaletteRenderer')(data[field.field], field);
                    if(colorPaletteValue !== null && colorPaletteValue !== '') {
                        cell.v = colorPaletteValue;
                    } else {
                        cell.v = '';
                    }
                    break;

                case 'datatable':
                     cell.t = 's';
                    var colorPaletteValue = $filter('datatableCellRenderer')(data[field.field]);
                    if(colorPaletteValue !== null && colorPaletteValue !== '') {
                        cell.v = colorPaletteValue;
                    } else {
                        cell.v = '';
                    }
                    break;

                case 'multi-value':
                case 'tags':
                    cell.t = 's';
                    if((angular.isDefined(data[field.field]) || data[field.field] !== null || data[field.field] !== '') && angular.isArray(data[field.field])) {
                        cell.v = utility.joinArray(data[field.field], '|');
                    } else {
                        cell.v = '';
                    }
                    break;

                case 'size-curve-size':
                    cell.t = 's';
                    cell.v = angular.toJson($filter('sizeCurveSizesRenderer')(data[field.field]));
                    break;

                case 'size-curve-size':
                    cell.t = 's';
                    cell.v = angular.toJson($filter('sizeCurveSizesRenderer')(data[field.field]));

                case 'lookup-from-map':
                    cell.t = 's';
                    var lookupSource = field.lookupSource;
                    // remove the "vm.api." prefix from the lookupSource
                    // lookup-from-map should be from the index.api file
                    if (lookupSource.startsWith('vm.api.')) {
                        lookupSource = lookupSource.substring(7);
                    }
                    cell.v = api[lookupSource][data[field.field]];
                    break;

                default:
                    cell.t = 's';
                    if(angular.isUndefined(data[field.field]) || data[field.field] == null) {
                        cell.v = '';
                    } else {
                        cell.v = data[field.field];
                    }
            }
        }

        $scope.$on('$destroy', function() {
            if(timeoutPromise) {
                $timeout.cancel(timeoutPromise);
            }
        });

    }
})();
(function() {
    'use strict';

    angular
        .module('app.bulkUpdater', []);
})();

(function() {
    'use strict';

    angular
        .module('app.bulkUpdater')
        .factory('bulkUpdater', bulkUpdater);

    /** @ngInject */
    function bulkUpdater($mdDialog, $document) {
        //Data
		var dialogObj = {
                controller         : 'bulkUpdaterController',
                controllerAs       : 'vm',
                templateUrl        : 'app/services/bulkUpdater/bulkUpdater.html',
                parent             : angular.element($document.body),
                targetEvent        : null,
                clickOutsideToClose: false,
                fullscreen         : false,
                closeTo            : '#quick-panel-toggle',
                locals             : {}
            };

		//Methods
		var service = {
            showDialog           : showDialog
		};

		return service;

        function showDialog(model, records, idMap, lookupPromises, additionalInfo) {
            //logic behind differentiating normal views and transformed view which have dynamic model
            //all the dynamic model have property map, and map values containing dot (.) will be having switch in UI
            dialogObj.locals['model'] = model;
            dialogObj.locals['records'] = records;
            dialogObj.locals['idMap'] = idMap;
            dialogObj.locals['lookupPromises'] = lookupPromises;
            dialogObj.locals['additionalInfo'] = additionalInfo;
            return $mdDialog.show(dialogObj);
        }


    }
})();
(function() {
    'use strict';

    angular
        .module('app.bulkUpdater')
        .controller('bulkUpdaterController', bulkUpdaterController);

    /** @ngInject */
    function bulkUpdaterController(api, $rootScope, scope, $mdDialog, $translate, utility, model, records, idMap, lookupPromises, additionalInfo, catalogFactory, CONSTANTS, $scope, $filter, $mdConstant, $timeout) {
        /* jshint validthis: true */
        var vm = this;

        //Data
        var selectedRecords = [];
        var activeCatalogDetail = catalogFactory.getActiveCatalogDetails();
        var linkedAttributes = activeCatalogDetail.LinkedAttributeList ;
        var attributes = activeCatalogDetail.AssignedCatalogAttributes;
        var dataSourceTypeId = activeCatalogDetail.DataSourceTypeId;
        vm.isLoading = false;
        vm.model = model;
        vm.isSegmentationGroup = false;
        vm.isSegmentationPlanningEnable = false;
        vm.planningValue = api.getSegmentationPlanningValues();
        vm.AllowExternalChangeManagement = false;
        vm.checkingForLockedArticles = false;
        // apply role based attribute restrictions to model fields before filtering
        var roleBasedRestrictedAttributes = (angular.isDefined(api.roleBasedRestrictions) && angular.isDefined(api.roleBasedRestrictions.restrictedAttributesArray) && api.roleBasedRestrictions.restrictedAttributesArray.length > 0) ? api.roleBasedRestrictions.restrictedAttributesArray : [];
        if(roleBasedRestrictedAttributes.length > 0) {
            angular.forEach(model.fields, function(field) {
                var roleBasedRestrictedAttribute = utility.filterObject(roleBasedRestrictedAttributes, { Name: field.field }, true)[0];
                if(angular.isDefined(roleBasedRestrictedAttribute)) {
                    if(roleBasedRestrictedAttribute.notViewable) {
                        field.visible = false;
                        field.showInEdit = false;
                        field.editable = false;
                    } else if(roleBasedRestrictedAttribute.notEditable) {
                        field.editable = false;
                        field.creatable = false;
                        field.showInEdit = true;
                        field.isBulkEditable = false;
                    }
                }
            });
        }

        vm.editableFields = utility.filterObject(model.fields, {editable: true, field: '!ArticleNumber'}, true);
        // show non editable attributes with show in edit property true
        var nonEditableFieldsWithShowInEdit = utility.filterObject(model.fields, {editable: false, showInEdit: true, isBulkEditable: false, field: '!ArticleNumber'});
        // concat editableFields and nonEditableFieldsWithShowInEdit
        if(angular.isDefined(nonEditableFieldsWithShowInEdit) && nonEditableFieldsWithShowInEdit.length > 0) {
            vm.editableFields = vm.editableFields.concat(nonEditableFieldsWithShowInEdit);
        }
        var editableFieldsCopy = angular.copy(vm.editableFields);
        vm.filteredEditableFields = angular.copy(vm.editableFields);


        vm.record = {};
        vm.checked = {};
        vm.lookupData = {};
        vm.acSelectedItem = [];
        vm.acSearchText = [];
        // used for article colors module
        vm.articleColors = [];
        var isAdditionalActionAdded = angular.isDefined(additionalInfo) && angular.isDefined(additionalInfo.additionalAction) ? true : false;
        if(isAdditionalActionAdded) {
            var additionalAction = additionalInfo.additionalAction;
        }
        vm.dropdownLimit = 100; // Show only first 100 records to improve page rendering

        vm.dependingAttributesMap = [];
        vm.criteriaDeptAttributeMap = {};
        vm.vettingListCriteriaList = [];
        vm.criteriaV2Map = {}; // AttributeSystemName -> parsed CriteriaV2 rules array (preferred over OLD Criteria)
        vm.maxTags;
        vm.tagSeperatorKeys = {};
        var validSellerLookupsDestinationAttributesMap = api.validSellerLookupsDestinationAttributesMap;
        vm.lookupSourceAndDeptAttributeMap = {};
        vm.isSaveButtonClicked = false;
        vm.isFormDirty = false;
        var commonValueObject = {};
        vm.showColorTypeInColorPalatteDropdown = api.showColorTypeInColorPalatteDropdown

        //Methods
        vm.saveRecord = saveRecord;
        vm.closeDialog = closeDialog;
        vm.isInputRequired = isInputRequired;
        vm.transformChip = transformChip;
        vm.acQuerySearch = acQuerySearch;
        vm.getChipDisplayValue = getChipDisplayValue;
        vm.isElementDirty = isElementDirty;
        vm.isAnyFieldChecked = isAnyFieldChecked;
        vm.getDateObj = getDateObj;
        vm.onSegmentationGroupChange = onSegmentationGroupChange;
        vm.getConditionalVettingList = getConditionalVettingList;
        vm.multiValueQuerySearch = multiValueQuerySearch;
        vm.onOpenSegmentationsChange = onOpenSegmentationsChange;
        vm.onPlanningValueChange = onPlanningValueChange;
        vm.sourceAttributeForValidationChanged = sourceAttributeForValidationChanged;
        vm.validateTxPattern = validateTxPattern;
        vm.lookupSearch = lookupSearch;
        vm.customLookupChange = customLookupChange;
        vm.getCustomLookupDisplayValue = getCustomLookupDisplayValue;
        vm.colorDependentCriteriaAttributeChanged = colorDependentCriteriaAttributeChanged;
        vm.colorPaletteLookupChange = colorPaletteLookupChange;
        vm.add = add;
        vm.lookupChange = lookupChange;
        vm.getLookupDisplayValue = getLookupDisplayValue;
        vm.lookupSourceAttributeChanged = lookupSourceAttributeChanged;
        vm.handleFieldChange = handleFieldChange;
        vm.checkBoxChanged = checkBoxChanged;
        vm.onSearchTextChanged= onSearchTextChanged;
        vm.isFormValid = isFormValid;

        activate();
        $timeout(function () {
            validateCriteriaAttributesOnOpen();
        });

        ////////////////

        function activate() {
            //This will open a Alert dialog to redirect to external change management
            // if (angular.isDefined(model) && (model.modelPath === 'catalogs.sizes' || model.modelPath === 'articles.sizes' || model.modelPath === 'catalogs.prices' || model.modelPath === 'articles.prices') && catalogFactory.getActiveCatalogDetails().ArticleLocking) {
            //     vm.checkingForLockedArticles = true;
            //     catalogFactory.getCatalogArticleLockedStatus().then(function (response) {
            //         if (response.data.Locked) {
            //             vm.AllowExternalChangeManagement = true;
            //             if (model.modelPath === 'catalogs.sizes' || model.modelPath === 'articles.sizes') {
            //                 catalogFactory.showExternalChangeManagementDialog('SizeUpdate');
            //             } else {
            //                 catalogFactory.showExternalChangeManagementDialog('PriceUpdate');
            //             }
            //         }
            //     })
            //     .finally(function() {
            //         vm.checkingForLockedArticles = false;
            //     })
            // }
            if(idMap){
                vm.SegmentationGroupList = idMap.segmentationGroupList;
                if(idMap.isSegmentationPlanningEnable && idMap.isSegmentationPlanningEnable == 1){
                    vm.isSegmentationPlanningEnable = true;
                }
                vm.parentModel = idMap.parentModel;
            }

            if(vm.SegmentationGroupList && vm.SegmentationGroupList.length>0){
                vm.isSegmentationGroup = true;
            }
            selectedRecords = utility.filterObject(records, {selected: true});

            if (angular.isUndefined(selectedRecords) || !angular.isArray(selectedRecords) || selectedRecords.length == 0) {
                return ;
            }

            var containCarryoverArticle = false;
            var linkedAttributesMap = {};

            // for virtual segmentation open
            if(model.modelPath && angular.isString(model.modelPath) && ( model.modelPath === 'catalogArticles.segmentation')) {
                vm.isSegmentations = true;
                var openField = utility.filterObject(model.fields, {editable: false, field: CONSTANTS.OPEN_SEGMENTATION}, true)[0];
                editableFieldsCopy.push(openField);
            }

            // if selected articles contain carryover article then set containCarryoverFlag
            for (var index = 0; index < selectedRecords.length; index++) {
                if (selectedRecords[index].article_type && selectedRecords[index].article_type.toLowerCase() === 'carryover') {
                    containCarryoverArticle = true;
                    break;
                }
            }

            // if containCarryoverArticle is true then create the linkedAttributesMap for linked attributes of line plan catalogs
            if( containCarryoverArticle === true && catalogFactory.getActiveCatalog().IsLinePlan
            && linkedAttributes && linkedAttributes.length > 0) {
                angular.forEach(linkedAttributes, function(linkedAttribute) {
                    linkedAttributesMap[linkedAttribute.AttributeSystemName] = 1;
                    var modelLinkedAttribute = utility.filterObject(model.fields,{field: linkedAttribute.AttributeSystemName} , true)[0];
                    var index = vm.editableFields.indexOf(utility.filterObject(vm.editableFields, {field: modelLinkedAttribute.field}, true)[0]);
                    if(index === -1) {
                        vm.editableFields.push(modelLinkedAttribute);
                    }
                })
            }

            //set potential default values and load lookup data
            for (var i=0; i<vm.editableFields.length; i++) {
                if(selectedRecords[0][vm.editableFields[i].field]) { // if not null of undefined
                    vm.record[vm.editableFields[i].field] = selectedRecords[0][vm.editableFields[i].field];
                    if(vm.model.modelPath === 'catalogs.crds'){
                        vm.record[vm.editableFields[i].field + 'Description']= selectedRecords[0][vm.editableFields[i].field + 'Description'];
                    }
                    if( vm.model.modelPath === 'catalogArticles.segmentation' ) {
                        // assign virtual segmentation open with default value
                        vm.record[CONSTANTS.OPEN_SEGMENTATION] = selectedRecords[0][CONSTANTS.OPEN_SEGMENTATION];
                        // Detect an assignment robustly: a configured planning value (which may legitimately be 'No')
                        // or a legacy 'Yes' means assigned; seed the switch ON and carry the planning value across.
                        var seededSegValue = selectedRecords[0][vm.editableFields[i].field];
                        var seededPlanningValue = api.matchSegmentationPlanningValue(seededSegValue);
                        if(vm.isSegmentationPlanningEnable && (seededPlanningValue || seededSegValue.toString().toUpperCase() === 'YES')) {
                            vm.record[vm.editableFields[i].field] = 'Yes';
                            var resolvedPlanningValue = seededPlanningValue || api.getSegmentationPlanningDefault();
                            vm.record[vm.editableFields[i].field + 'PlanningValue']= resolvedPlanningValue;
                            vm.record[vm.editableFields[i].importField + 'PlanningValue']= resolvedPlanningValue;
                        }
                    }
                }
                else {
                    vm.record[vm.editableFields[i].field] = getFieldDefaultValue(vm.editableFields[i].inputType);
                }

                // for overridable attributes and Article static properties like ArticleNUmber, ModelNumber etc if validation expression present add source field value to vm.record
                if(angular.isDefined(vm.editableFields[i].validation) && vm.editableFields[i].validation['tx-pattern']) {
                    var validationExpression = utility.isValidJSON(vm.editableFields[i].validation['tx-pattern']);
                    if(validationExpression && angular.isDefined(validationExpression.F) && validationExpression.F.length > 0) {
                        var parsedExpressionObjects = validationExpression.F;
                        angular.forEach(parsedExpressionObjects, function(parsedExpressionObject) {
                            var sourceField = parsedExpressionObject['SourceField'];
                            if(angular.isUndefined(vm.record[sourceField])) {
                                vm.record[sourceField] = selectedRecords[0][sourceField];
                            }
                        });
                    }
                }

                if(vm.editableFields[i].inputType === 'tags') {
                    updateSperatorKeys(vm.editableFields[i]);
                    populateTags(vm.record, vm.editableFields[i]);
                }

                if ((vm.model.modelPath === 'catalogs.articles' || vm.model.modelPath == 'catalogs.linePlanArticles' || vm.model.modelPath === 'catalogs.models' || vm.model.modelPath === 'sellerModels.sellerModels')  && (vm.editableFields[i].inputType === 'list' || vm.editableFields[i].inputType === 'multi-value') && attributes ) {
                    if (attributes.length > 0) {
                        angular.forEach(attributes, function (attribute) {
                            if (attribute.AttributeSystemName === vm.editableFields[i].field) {
                                vm.editableFields[i].values = (attribute.AllowedValues || [])
                                .map(function(value) {
                                    return value.trim();
                                })
                                .sort(function(a, b) {
                                    return a.toLowerCase().localeCompare(b.toLowerCase());
                                })
                                // for multivalue dropdown make the record as array
                                if(vm.editableFields[i].inputType === 'multi-value') {
                                    if(selectedRecords[0][vm.editableFields[i].field] === null || selectedRecords[0][vm.editableFields[i].field].length === 0) {
                                        vm.record[vm.editableFields[i].field] = [];
                                    }
                                }
                                // for attribute vetting list criteria — CriteriaV2 preferred over OLD Criteria
                                if(vm.editableFields[i].isDynamicProperty && attribute.CriteriaV2 && attribute.CriteriaV2.length > 0) {
                                    try {
                                        vm.criteriaV2Map[attribute.AttributeSystemName] = JSON.parse(attribute.CriteriaV2);
                                    } catch(error) {
                                        console.warn(attribute.AttributeDisplayName + " - Attribute CriteriaV2: Invalid JSON Format");
                                    }
                                    vm.editableFields[i].isCriteriaAdded = true;
                                    getConditionalVettingList(vm.editableFields[i]);
                                    var v2DependentDisplayNames = [];
                                    utility.getCriteriaV2DependentFields(vm.criteriaV2Map[attribute.AttributeSystemName]).forEach(function(depKey) {
                                        var v2DependentField = utility.filterObject(vm.editableFields, {field: depKey}, true)[0];
                                        if(angular.isDefined(v2DependentField)) {
                                            if(!vm.criteriaDeptAttributeMap[depKey]) {
                                                vm.criteriaDeptAttributeMap[depKey] = [];
                                            }
                                            if(vm.criteriaDeptAttributeMap[depKey].indexOf(attribute.AttributeSystemName) === -1) {
                                                vm.criteriaDeptAttributeMap[depKey].push(attribute.AttributeSystemName);
                                            }
                                            v2DependentField.isDependentAttribute = true;
                                            v2DependentDisplayNames.push(utility.getAttributeDisplayNameUsingSystemName(catalogFactory.getActiveCatalogDetails().AssignedCatalogAttributes, depKey));
                                        }
                                    });
                                    vm.editableFields[i].criteriaDisplayMessage = 'Attribute '+ attribute.AttributeDisplayName +' is dependent on the attribute(s) ' + v2DependentDisplayNames + '.';
                                } else if(vm.editableFields[i].isDynamicProperty && attribute.Criteria.length > 0) {
                                    // parse json
                                    try {
                                        var vettinglistCriteria = JSON.parse(attribute.Criteria);
                                    } catch(error) {
                                        console.warn(attribute.AttributeDisplayName + " - Attribute Criteria: Invalid JSON Format");
                                    }
                                    var dependentAttributesDisplayNames = [];
                                    vm.editableFields[i].isCriteriaAdded = true;
                                    getConditionalVettingList(vm.editableFields[i]);
                                    var dependingAttributes = {};
                                    var obj2 = {};
                                    for(var key in vettinglistCriteria) {
                                        if(vettinglistCriteria.hasOwnProperty(key)) {
                                            var deptAttr = vettinglistCriteria[key];
                                            for(var key1 in deptAttr) {
                                                var obj = {};
                                                if(deptAttr.hasOwnProperty(key1)) {
                                                    var index = dependentAttributesDisplayNames.indexOf(utility.getAttributeDisplayNameUsingSystemName(catalogFactory.getActiveCatalogDetails().AssignedCatalogAttributes, key1));
                                                    if( index === -1 ) {
                                                        var dependentAttributeField = utility.filterObject(vm.editableFields, {field: key1}, true)[0];
                                                        if(angular.isDefined(dependentAttributeField)) {
                                                            if(!vm.criteriaDeptAttributeMap[key1]) {
                                                                vm.criteriaDeptAttributeMap[key1] = [];
                                                            }
                                                            vm.criteriaDeptAttributeMap[key1].push(attribute.AttributeSystemName);
                                                            dependentAttributesDisplayNames.push(utility.getAttributeDisplayNameUsingSystemName(catalogFactory.getActiveCatalogDetails().AssignedCatalogAttributes, key1));
                                                            dependentAttributeField.isDependentAttribute = true;
                                                        }
                                                    }
                                                    if(obj2[key1]) {
                                                        angular.forEach(deptAttr[key1], function(val) {
                                                            if(obj2[key1][val]) {
                                                                if(obj2[key1][val].indexOf(key)) {
                                                                    obj2[key1][val].push(key);
                                                                }
                                                            } else {
                                                                obj2[key1][val] = [key];
                                                            }
                                                        });
                                                    } else {
                                                        angular.forEach(deptAttr[key1], function(val) {
                                                            obj[val] = [key];
                                                        });
                                                        obj2[key1] = obj;
                                                    }
                                                }
                                            }
                                        }
                                    }
                                    dependingAttributes[attribute.AttributeSystemName] = obj2;
                                    vm.dependingAttributesMap.push(dependingAttributes);
                                    var obj = {};
                                    obj[attribute.AttributeSystemName] = vettinglistCriteria;
                                    vm.vettingListCriteriaList.push(obj);
                                    var criteriaDisplayMessage = 'Attribute '+ attribute.AttributeDisplayName +' is dependent on the attribute(s) ' + dependentAttributesDisplayNames + '.';
                                    vm.editableFields[i].criteriaDisplayMessage = criteriaDisplayMessage;
                                }
                            }
                        })
                    }
                }

                // for line plan catalog articles and at least one carryover article selected, disable the linked attributes
                if (catalogFactory.getActiveCatalog().IsLinePlan && containCarryoverArticle === true && linkedAttributesMap[vm.editableFields[i].field]) {
                    if(angular.isDefined(vm.editableFields[i].isLinkedAttributeEditable)) {
                        if(vm.editableFields[i].isLinkedAttributeEditable) {
                            vm.editableFields[i].editable = true;
                            vm.editableFields[i].showInEdit = true;
                            vm.editableFields[i].validation.disabledCriteria = false;
                        } else if(!vm.editableFields[i].isLinkedAttributeEditable) {
                            vm.editableFields[i].validation.disabledCriteria = true;
                        }
                    } else {
                        var isLinkedAttributeEditable = angular.isDefined(utility.filterObject(linkedAttributes,{AttributeSystemName: vm.editableFields[i].field} , true)[0]) ?
                            utility.filterObject(linkedAttributes,{AttributeSystemName: vm.editableFields[i].field} , true)[0].Editable : false;
                        if(isLinkedAttributeEditable === 0) {
                            vm.editableFields[i].validation.disabledCriteria = true;
                        } else if(isLinkedAttributeEditable === 1) {
                            vm.editableFields[i].editable = true;
                            vm.editableFields[i].showInEdit = true;
                            vm.editableFields[i].validation.disabledCriteria = false;
                        }
                    }
                }
                // for line plan catalog articles and at least one carryover article selected, disable the ArticleName
                if (catalogFactory.getActiveCatalog().IsLinePlan && containCarryoverArticle === true && vm.editableFields[i].field === 'ArticleName') {
                    vm.editableFields[i].validation.disabledCriteria = true;
                }
                if(vm.editableFields[i].inputType === 'date' || vm.editableFields[i].inputType === 'date-option') { // workaround for issue with interpolation on ng-disabled on md-datepicker
                    if($scope.$eval(vm.editableFields[i].validation.disabledCriteria) || (vm.editableFields[i].showInEdit && !vm.editableFields[i].editable)) {
                        //vm.disableDate =  true;
                        vm.editableFields[i].validation.disabled = true;
                    } else {
                        vm.editableFields[i].validation.disabled = false;
                    }
                }
                else if(vm.editableFields[i].inputType === 'date-utc') { // workaround for issue with interpolation on ng-disabled on md-datepicker
                    if($scope.$eval(vm.editableFields[i].validation.disabledCriteria) || (vm.editableFields[i].showInEdit && !vm.editableFields[i].editable)) {
                        //vm.disableDateUTC =  true;
                        vm.editableFields[i].validation.disabled = true;
                    } else {
                        vm.editableFields[i].validation.disabled = false;
                    }
                }
                else if(vm.editableFields[i].inputType === 'date-without-time') { // workaround for issue with interpolation on ng-disabled on md-datepicker
                    if($scope.$eval(vm.editableFields[i].validation.disabledCriteria) || (vm.editableFields[i].showInEdit && !vm.editableFields[i].editable)) {
                        vm.editableFields[i].validation.disabled = true;
                    } else {
                        vm.editableFields[i].validation.disabled = false;
                    }
                }
                else if (vm.editableFields[i].inputType === 'lookup-table') {
                    vm.editableFields[i].isLookupAdded = true;
                    if (angular.isDefined(validSellerLookupsDestinationAttributesMap[vm.editableFields[i].field])) {
                        var attributeLookupValues = validSellerLookupsDestinationAttributesMap[vm.editableFields[i].field];
                        var sourceAttributesDisplayNames = [];
                        var matched = false;
                        for (var j = 0; j < attributeLookupValues.length; j++) {
                            var allAttributesMatch = true;
                            var value = attributeLookupValues[j];
                            for (var attributeSystemName in value.Source) {
                                if (value.Source.hasOwnProperty(attributeSystemName)) {
                                    if(vm.record[attributeSystemName] == null || value.Source[attributeSystemName].toString().toLowerCase() !== vm.record[attributeSystemName].toString().toLowerCase()) {
                                        allAttributesMatch = false;
                                        break;
                                    }
                                }
                            }

                            if (allAttributesMatch) {
                                if(vm.record[vm.editableFields[i].field] !== value.Destination[vm.editableFields[i].field]) {
                                    vm.record[vm.editableFields[i].field] = value.Destination[vm.editableFields[i].field];
                                }
                                matched = true;
                                break;
                            }
                        }

                        // create source attributes map
                        if(attributeLookupValues.length) {
                            var firstSourceDestinationValue = attributeLookupValues[0];
                            for (var attributeSystemName in firstSourceDestinationValue.Source) {
                                var index = sourceAttributesDisplayNames.indexOf(utility.getAttributeDisplayNameUsingSystemName(catalogFactory.getActiveCatalogDetails().AssignedCatalogAttributes, attributeSystemName));
                                if (index === -1) {
                                    sourceAttributesDisplayNames.push(utility.getAttributeDisplayNameUsingSystemName(catalogFactory.getActiveCatalogDetails().AssignedCatalogAttributes, attributeSystemName));
                                    var sourceAttributeField = utility.filterObject(vm.editableFields, { field: attributeSystemName }, true)[0];
                                    if (angular.isDefined(sourceAttributeField)) {
                                        sourceAttributeField.isLookupSourceAttribute = true;
                                    }
                                }
                                if (!vm.lookupSourceAndDeptAttributeMap[attributeSystemName]) {
                                    vm.lookupSourceAndDeptAttributeMap[attributeSystemName] = [];
                                }
                                if (vm.lookupSourceAndDeptAttributeMap[attributeSystemName].indexOf(vm.editableFields[i].field) === -1) {
                                    vm.lookupSourceAndDeptAttributeMap[attributeSystemName].push(vm.editableFields[i].field);
                                }
                            }
                        }
                        if (!matched) {
                            vm.record[vm.editableFields[i].field] = null;
                        }
                        vm.editableFields[i].lookupDisplayMessage = 'Attribute ' + vm.editableFields[i].displayLabel + ' is dependent on the attribute(s) ' + sourceAttributesDisplayNames.join(', ') + '.';
                    } else {
                        vm.editableFields[i].lookupDisplayMessage = 'Attribute ' + vm.editableFields[i].displayLabel + ' does not have any source attribute(s) assigned';
                    }
                }

                // validate dependant attributes on tx pattern attribute changes
                if((vm.model.modelPath === 'catalogs.articles' || vm.model.modelPath === 'catalogs.linePlanArticles')) {
                    if(angular.isDefined(vm.editableFields[i].validation) && vm.editableFields[i].validation['tx-pattern']) {
                        var validationExpression = utility.isValidJSON(vm.editableFields[i].validation['tx-pattern']);
                        if(validationExpression && angular.isDefined(validationExpression.F) && validationExpression.F.length > 0) {
                            var parsedExpressionObjects = validationExpression.F;
                            angular.forEach(parsedExpressionObjects, function(parsedExpressionObject) {
                                var sourceField = parsedExpressionObject['SourceField'];
                                var sourceAttributeField = utility.filterObject(vm.editableFields, {field: sourceField}, true)[0];
                                if(angular.isDefined(sourceAttributeField)) {
                                    // if source field is required then make the isRequired property true for that attribute
                                    if(parsedExpressionObject.SourceValueRequired) {
                                        sourceAttributeField.validation.isRequired = true;
                                    }
                                    sourceAttributeField.isSourceAttributeForValidation = true;
                                }
                            });
                        }
                    }
                }
            }

            //set editable fields default values
            for (var j=1; j<selectedRecords.length; j++) {
                for (var k=editableFieldsCopy.length-1; k>=0; k--) {
                    if (!isSameVal(selectedRecords[j-1][editableFieldsCopy[k].field], selectedRecords[j][editableFieldsCopy[k].field], editableFieldsCopy[k].inputType)) {
                            //set default value
                            switch(editableFieldsCopy[k].inputType) {
                                case 'switch':
                                    vm.record[editableFieldsCopy[k].field] = 'No';
                                    break;

                                case 'lookup-many':
                                    vm.record[editableFieldsCopy[k].field] = [];
                                    break;

                                case 'bool':
                                    vm.record[editableFieldsCopy[k].field] = false;
                                    break;

                                case 'bool-str':
                                    vm.record[editableFieldsCopy[k].field] = 'false';
                                    break;

                                case 'bool-int':
                                    vm.record[editableFieldsCopy[k].field] = 0;
                                    break;

                                case 'int-bool':
                                    vm.record[editableFieldsCopy[k].field] = '0';
                                    break;

                                case 'list':
                                    vm.record[editableFieldsCopy[k].field] = '';
                                    break;

                                case 'number':
                                case 'decimal':
                                    vm.record[editableFieldsCopy[k].field] = 0;
                                    break;

                                case 'multi-value':
                                case 'tags':
                                    vm.record[editableFieldsCopy[k].field] = [];
                                    break;
                                case 'color-picker':
                                    vm.record[editableFieldsCopy[k].field] = '#969696';
                                    break;

                                default:
                                    vm.record[editableFieldsCopy[k].field] = '';
                            }
                            // disable attributes with validation if the selected values are different
                            if(angular.isDefined(editableFieldsCopy[k].validation) && editableFieldsCopy[k].validation['tx-pattern']) {
                                var validationExpression = utility.isValidJSON(editableFieldsCopy[k].validation['tx-pattern']);
                                if(validationExpression && angular.isDefined(validationExpression.F) && validationExpression.F.length > 0) {
                                    var parsedExpressionObjects = validationExpression.F;
                                    angular.forEach(parsedExpressionObjects, function(parsedExpressionObject) {
                                        if(angular.isDefined(parsedExpressionObject['SourceField']) ) {
                                            if (!isSameVal(selectedRecords[j-1][editableFieldsCopy[k].field], selectedRecords[j][editableFieldsCopy[k].field], editableFieldsCopy[k].inputType)) {
                                                var attributeWithValidation = utility.filterObject(vm.editableFields, {field: editableFieldsCopy[k].field}, true)[0];
                                                attributeWithValidation.validation.disabledCriteria = true;
                                            }
                                        }
                                    })

                                }
                            }
                            editableFieldsCopy.splice(k, 1);// remove fields that have their default value set to avoid re-checking
                    }
                }
            }

            // check if 'parent_model_type' is editable and if additional fields have the same value
            if (vm.record['parent_model_type'] !== '') {
                var masterModelIdSame = true;
                var parentModelNumberSame = true;
                var parentModelNameSame = true;

                for (var i = 1; i < selectedRecords.length; i++) {
                    if (!isSameVal(selectedRecords[0]['MasterModelId'], selectedRecords[i]['MasterModelId'])) {
                        masterModelIdSame = false;
                    }
                    if (!isSameVal(selectedRecords[0]['ParentModelNumber'], selectedRecords[i]['ParentModelNumber'])) {
                        parentModelNumberSame = false;
                    }
                    if (!isSameVal(selectedRecords[0]['ParentModelName'], selectedRecords[i]['ParentModelName'])) {
                        parentModelNameSame = false;
                    }
                }

                if (masterModelIdSame && parentModelNumberSame && parentModelNameSame) {
                    vm.record['MasterModelId'] = selectedRecords[0]['MasterModelId'];
                    vm.record['ParentModelNumber'] = selectedRecords[0]['ParentModelNumber'];
                    vm.record['ParentModelName'] = selectedRecords[0]['ParentModelName'];
                } else {
                    vm.record['MasterModelId'] = null;
                    vm.record['ParentModelNumber'] = '';
                    vm.record['ParentModelName'] = '';
                }
            }

            commonValueObject = angular.copy(vm.record)
            vm.filteredEditableFields = angular.copy(vm.editableFields);
        }

        //On addition of new tag it validates that the tag should not contain pipe
        function add(chip, chips, field) {
            if (chip) {
                if (chip.indexOf(field.tagSeparator) !== -1) {
                    vm.record[field.field].splice(vm.record[field.field].indexOf(chip), 1);
                    vm.record[field.field] = vm.record[field.field].concat(chip.split(field.tagSeparator));
                    vm.maxTags = vm.record[field.field].length + 1;
                } else {
                    vm.maxTags = field.maxLen;
                }
            }
            //for displaying error message
            if (angular.isDefined(field.maxLen) && vm.maxTags != field.maxLen) {
                vm.ErrorMessage = field.validation.messages.pattern;
                return true;
            } else {
                vm.ErrorMessage = "";
                return false;
            }
        }

        function saveRecord() {
            if (vm.isSaveButtonClicked) {
                return
            }
            angular.forEach(vm.model.fields, function(field) {
                if(angular.isDefined(field.validation) && field.validation['tx-pattern']) {
                    validateTxPattern(field);
                }
            });
            var calcAttributesSystemNamesArray = [];
            angular.forEach(vm.model.fields, function(field) {
                // only keep record's property that needs to be updated (checked)
                if(angular.isDefined(vm.record[field.field]) && (angular.isUndefined(vm.checked[field.field]) || vm.checked[field.field] === false) && field.field !== 'ParentModelNumber' && field.field !== 'MasterModelId' && field.inputType !== 'lookup-table') {
                    delete vm.record[field.field];
                }

                if (field.inputType === 'calculated') {
                    delete vm.record[field.field];
                    calcAttributesSystemNamesArray.push(field.field);
                }

                if(angular.isDefined(vm.checked[field.field]) && angular.isDefined(vm.record[field.field]) && field.inputType === 'list') {
                    if(field.type === 'int') {
                        vm.record[field.field] = parseInt(vm.record[field.field]);
                    }
                }

                if (angular.isDefined(vm.checked[field.field]) && (field.inputType === 'articlenumber' ||field.inputType === 'modelnumber' ) && angular.isDefined(vm.record[field.field]) && vm.record[field.field] != null && vm.record[field.field].toString().length > 0) {
                    vm.record[field.field] = vm.record[field.field].toString();
                }

                // avoid timezone issue
                if ((field.inputType === 'date-utc' || field.inputType === 'date') && angular.isDefined(vm.record[field.field]) &&  angular.isDate(vm.record[field.field])) {
                    var d = vm.record[field.field];
                    vm.record[field.field] = new Date(d.setHours(12-(d.getTimezoneOffset()/60),0,0));
                }

                // remove time from date-option and date type attributes
                if ((field.inputType === 'date-without-time' || field.inputType === 'date-option') && angular.isDefined(vm.record[field.field]) &&  angular.isDate(vm.record[field.field])) {
                    var d = vm.record[field.field];
                    var dateValueWithTime = new Date(d.setHours(12-(d.getTimezoneOffset()/60),0,0)).toISOString();
                    vm.record[field.field] = dateValueWithTime.split('T', 1)[0];
                }

                if ((field.inputType === 'color-palette') && angular.isDefined(vm.record[field.field]) && vm.record[field.field] != null && vm.record[field.field] !== '' && angular.isObject(vm.record[field.field])) {
                    var key = Object.keys(vm.record[field.field])[0];
                    var val = vm.record[field.field][key];
                    if (typeof val === 'string' && val.includes(':')) {
                        val = val.split(':')[1].trim();
                    }
                    vm.record[field.field][key] = val;
                    vm.record[field.field] = angular.toJson(vm.record[field.field]);
                }

                // remove all invisible special characters from strings
                if ((field.inputType === 'text' || field.inputType === 'textArea') && vm.record[field.field] != null && vm.record[field.field] !== '' && typeof vm.record[field.field] === 'string') {
                    vm.record[field.field] = vm.record[field.field].replace(/[\u00A0\u00AD\u200B-\u200D\uFEFF\u2028\u2029\u2060]/g, '');
                }

                if ((field.inputType === 'multi-value' || field.inputSubType === 'multi-value') && vm.record[field.field] != null && vm.record[field.field] !== '' && vm.record[field.field].length) {
                    angular.forEach(vm.record[field.field], function(value, index) {
                        vm.record[field.field][index] = value.replace(/[\u00A0\u00AD\u200B-\u200D\uFEFF\u2028\u2029\u2060]/g, '');
                    })
                }

                if (field.inputType === 'dataset' && angular.isDefined(vm.checked[field.field]) && angular.isDefined(vm.record[field.field]) && vm.record[field.field] != null) {
                    if(typeof (vm.record[field.field]) === 'object') {
                        vm.record[field.field] = Object.keys(vm.record[field.field])[0].toString()
                    }
                    else {
                        vm.record[field.field] = vm.record[field.field].toString();
                    }
                }

                // currently not supported
                if(field.inputType === 'datatable' && angular.isDefined(vm.checked[field.field]) && vm.record[field.field] != null && vm.record[field.field] !== '') {
                    vm.record[field.field] = (typeof vm.record[field.field] === 'string') ? vm.record[field.field] : angular.toJson(vm.record[field.field]);
                }

                // if the field is not checked dont send the value to API
                if (angular.isUndefined(vm.checked[field.field]) && field.field !== 'MasterModelId' && field.field !== 'ParentModelNumber') {
                    delete vm.record[field.field];
                    if(field.field === 'parent_model_type') { // if parent model type is not changed remove the parent model related fields
                        delete vm.record['MasterModelId']
                        delete vm.record['ParentModelNumber'];
                        delete vm.record['ParentModelName'];
                    }
                }
            });

            // remove calculated fields from selected records
            if(calcAttributesSystemNamesArray.length) {
                angular.forEach(selectedRecords, function(article) {
                    angular.forEach(calcAttributesSystemNamesArray, function(calcAttribute) {
                        delete article[calcAttribute];
                    });
                });
            }
            var propertiesToUpdate = angular.copy(vm.record);

            if(!vm.editForm.$invalid) {
                vm.isSaveButtonClicked = true;
                //To show bulk update successfull button in articles page
                if (angular.isDefined(vm.parentModel) && vm.model.modelPath === 'catalogArticles.segmentation') {
                    vm.model.methods.updateBulk(vm.model, angular.copy(selectedRecords), propertiesToUpdate, idMap, vm.parentModel);
                } else if (vm.model.modelPath !== 'catalogs.articles' && vm.model.modelPath !== 'catalogs.linePlanArticles'
                    && vm.model.modelPath !== 'accounts.updateBulkUsers' && vm.model.modelPath !== 'catalogs.models' && vm.model.modelPath !== 'accounts.users' && vm.model.modelPath !== 'catalogs.resources' && vm.model.modelPath !== 'sellerModels.sellerModels' && vm.model.modelPath !== 'sellers.sellerResources' && vm.model.modelPath !== 'sellers.designOptionAttributes') {
                    vm.model.methods.updateBulk(vm.model, angular.copy(selectedRecords), propertiesToUpdate, idMap);
                }
                closeDialog({selectedRecords: angular.copy(selectedRecords), propertiesToUpdate: propertiesToUpdate, idMap: idMap});
            }
        }


        function closeDialog(response) {
            $mdDialog.hide(response);
        }

        function validateCriteriaAttributesOnOpen() {
            angular.forEach(vm.editableFields, function(field) {
                var dependentAttributeField = field.field;
                if(vm.criteriaDeptAttributeMap[dependentAttributeField]) {
                    var criteriaAttributes = vm.criteriaDeptAttributeMap[dependentAttributeField];
                    angular.forEach(criteriaAttributes, function(criteriaAttribute) {
                        var criteriaField = utility.filterObject(vm.editableFields, {field: criteriaAttribute}, true)[0];
                        if (!criteriaField) { return; } // target criteria attribute isn't a field in this dialog -> nothing to refresh/clear
                        var isMultiValueAttribute = (criteriaField.inputType === 'multi-value') ? true : false;
                        // CriteriaV2 (preferred): clear the value if it is not in the matched rule's AllowedValues ([] when no rule matches)
                        if(vm.criteriaV2Map[criteriaAttribute]) {
                            var getDependentValueForCriteriaV2 = function(dependentField) {
                                var depVal = vm.record[dependentField];
                                return (depVal && typeof depVal === 'object') ? (angular.isDefined(depVal.value) ? depVal.value : depVal) : depVal;
                            };
                            var criteriaV2AllowedLower = utility.getCriteriaV2AllowedValues(vm.criteriaV2Map[criteriaAttribute], getDependentValueForCriteriaV2)
                                .map(function(value) { return value.toString().toLowerCase(); });
                            var currentCriteriaValue = vm.record[criteriaAttribute];
                            var isCriteriaV2Valid;
                            if (isMultiValueAttribute) {
                                isCriteriaV2Valid = (Array.isArray(currentCriteriaValue) && currentCriteriaValue.length > 0)
                                    ? currentCriteriaValue.every(function(value) { return criteriaV2AllowedLower.indexOf((value == null ? '' : value).toString().toLowerCase()) !== -1; })
                                    : true;
                            } else {
                                isCriteriaV2Valid = (currentCriteriaValue === null || currentCriteriaValue === undefined || currentCriteriaValue === '')
                                    ? true
                                    : criteriaV2AllowedLower.indexOf(currentCriteriaValue.toString().toLowerCase()) !== -1;
                            }
                            if (!isCriteriaV2Valid) {
                                vm.record[criteriaAttribute] = isMultiValueAttribute ? [] : null;
                            }
                            return; // skip OLD criteria path
                        }
                        var attributeCriteria = {};
                        angular.forEach(vm.dependingAttributesMap, function(criteriaAttr) {
                            for(var key in criteriaAttr) {
                                if(criteriaAttr.hasOwnProperty(key)) {
                                    if(key.toLocaleLowerCase() === criteriaAttribute.toLowerCase()) {
                                        attributeCriteria = criteriaAttr[key];
                                        break;
                                    }
                                }
                            }
                        });
                        if(angular.isDefined(attributeCriteria[dependentAttributeField][vm.record[dependentAttributeField]])) {
                            var allowedValues = attributeCriteria[dependentAttributeField][vm.record[dependentAttributeField]];
                            var currentValue = vm.record[criteriaAttribute];
                            var isValid = false;
                            if (isMultiValueAttribute) {
                                if (Array.isArray(currentValue) && currentValue.length > 0) {
                                    isValid = currentValue.every(function(value) {
                                        return allowedValues.indexOf(value) !== -1;
                                    });
                                } else {
                                    isValid = true;
                                }
                            } else {
                                isValid = allowedValues.indexOf(currentValue) !== -1;
                            }
                            if (!isValid) {
                                vm.record[criteriaAttribute] = isMultiValueAttribute ? [] : null;
                            }
                        } else if(vm.record[dependentAttributeField]) {
                            vm.record[criteriaAttribute] = isMultiValueAttribute ? [] : null;
                        }
                    });
                }
            });
        }

        /**
         * Enable use Enter and any other seperator key defined on model to be use as a seperator key for chips
         */
        function updateSperatorKeys(field) {
            vm.tagSeperatorKeys[field.field] = [$mdConstant.KEY_CODE.ENTER];
            if(angular.isDefined(field.tagSeparator)) {
                var aditionalSeperator = field.tagSeparator.charCodeAt();
                if(angular.isDefined(aditionalSeperator) && aditionalSeperator !== 'NaN') {
                    vm.tagSeperatorKeys[field.field].push(aditionalSeperator);
                }
            }
        }

        function populateTags(record, field) {
            if(angular.isUndefined(record[field.field]) || record[field.field] === null || record[field.field] === '') {
                record[field.field] = [];
            }
            else if(angular.isDefined(field.tagSeparator)) {
                var stringVal = record[field.field];
                var tagSeparator = field.tagSeparator;
                if(!angular.isArray(stringVal) && stringVal !== null) {
                    record[field.field] = stringVal.split(tagSeparator);
                }
            }
            else {
                $log.warn('tagSeparator property is missing in model for ' + field.field);
            }
        }


        function transformChip(chip) {
            if (angular.isObject(chip)) {
                return chip.id;
            }
            return undefined;
        }


        //TODO: Check performance impact on using nested filter
        function acQuerySearch(query, lookupSource, selectedItems) {
            var lookupModel = api.getModel(lookupSource);

            var searchQueryResult = [];
            if (lookupModel && lookupModel.lookupData && lookupModel.lookupData.data && lookupModel.lookupData.data.length) {
                searchQueryResult = utility.filterObject(lookupModel.lookupData.data, query);
            }

            if (selectedItems && selectedItems.length > 0) {
                for (var index = searchQueryResult.length - 1; index >= 0; index--) {
                    if (selectedItems.indexOf(searchQueryResult[index].id) !== -1) {
                        searchQueryResult.splice(index, 1);
                    }
                }
            }
            return searchQueryResult;
        }


        function getChipDisplayValue(chip, lookupSource) {
            var lookupModel = api.getModel(lookupSource);
            var res = utility.filterObject(lookupModel.lookupData.data, {id: chip}, true);

            if (angular.isArray(res) && res.length > 0) {
                return res[0].value;
            }
        }

        var parentModelTypeChangedEventCleanup = $rootScope.$on('parentModelTypeChanged', function(event, field) {
            isElementDirty(field)
        })
         var datasetAttributeChangedEventCleanup = $rootScope.$on('datasetAttributeChanged', function(event, field) {
            isElementDirty(field)
        })

        // checked the check box if corresponding element is dirty(not empty)
        function isElementDirty(field) {
            var planningValue = api.getSegmentationPlanningDefault();
            if (vm.isSegmentationGroup && vm.record[field]) {
                //unselect segmentation group if segmentations do not fall under group
                if (vm.SegmentationGroup) {
                    var selectedSegmentationGroup = utility.filterObject(vm.SegmentationGroupList, { SegmentationGroup: vm.SegmentationGroup }, true);
                    if (selectedSegmentationGroup.length > 0) {
                        var segmentations = selectedSegmentationGroup[0].Segmentations.split(',');
                        if (segmentations.indexOf(vm.record[field]) == -1) {
                            vm.SegmentationGroup = {};
                        }
                    }
                }
                vm.record[field+'PlanningValue'] = planningValue;
                // vm.record[field] may hold a configured planning value; detect an assignment
                var fieldPlanningValue = api.matchSegmentationPlanningValue(vm.record[field]);
                if (vm.record[field].toUpperCase() === 'YES') {
                    vm.record[field+'PlanningValue'] = planningValue;
                    vm.checked[field] = true;
                } else if (fieldPlanningValue && vm.record[field].toUpperCase() !== 'NO') {
                    vm.record[field+'PlanningValue'] = fieldPlanningValue;
                    vm.checked[field] = true;
                }
            }

            if (angular.isDefined(vm.record[field]) && ((angular.isArray(vm.record[field]) && vm.record[field].length > 0) || (vm.record[field] !== null && vm.record[field].toString().trim() !== ""))) {
                if (vm.model.modelPath === 'catalogArticles.segmentation' && vm.isSegmentationPlanningEnable && vm.record[field].toUpperCase() === 'YES' && !vm.record[field + 'PlanningValue']) {
                    vm.record[field + 'PlanningValue'] = planningValue; //add default value
                }
            }

            // if there is no value change
            if ((vm.model.modelPath !== 'catalogArticles.segmentation' && vm.model.modelPath !== 'catalogCustomers.segmentation') && commonValueObject[field] === vm.record[field] && vm.checked[field]) {
                vm.isFormDirty = false;
            } else if(vm.checked[field]) {
                vm.isFormDirty = true;
            }
        }

        function checkBoxChanged(field) {
            // if there is no value change
            if ((vm.model.modelPath !== 'catalogArticles.segmentation' && vm.model.modelPath !== 'catalogCustomers.segmentation') && commonValueObject[field] === vm.record[field] && vm.checked[field]) {
                vm.isFormDirty = false;
            } else if(vm.checked[field]) {
                vm.isFormDirty = true;
            }
        }

        function onSegmentationGroupChange(selectedGroup) {
            var selectedSegmentationGroup = utility.filterObject(vm.SegmentationGroupList, { SegmentationGroup: selectedGroup }, true);
            var segmentations = selectedSegmentationGroup[0].Segmentations.split(',');
            var planningValue = api.getSegmentationPlanningDefault();
            //on segmentation group change, segmentations which do not belongs to group will be set to false.
            angular.forEach(vm.editableFields, function (field) {
                if (segmentations.indexOf(field.importField) != -1) {
                    vm.record[field.field] = 'Yes';
                    vm.record[field.field+'PlanningValue'] = planningValue;
                    vm.record[field.importField+'PlanningValue'] = planningValue;
                    vm.checked[field.field] = true;
                } else {
                    vm.record[field.field] = 'No';
                    vm.checked[field.field] = false;
                    vm.record[field.field+'PlanningValue'] = '';
                    vm.record[field.importField+'PlanningValue'] ='';
                }
            })
        }

        function getConditionalVettingList(field) {
            var attribute = field.field;
            // CriteriaV2 (preferred): dropdown = matched rule's AllowedValues ([] when no rule matches)
            if (vm.criteriaV2Map[attribute]) {
                var getDependentValueForCriteriaV2 = function(dependentField) {
                    var depVal = vm.record[dependentField];
                    return (depVal && typeof depVal === 'object') ? (angular.isDefined(depVal.value) ? depVal.value : depVal) : depVal;
                };
                var criteriaV2Allowed = utility.getCriteriaV2AllowedValues(vm.criteriaV2Map[attribute], getDependentValueForCriteriaV2);
                var criteriaV2AttributeField = utility.filterObject(vm.filteredEditableFields || vm.editableFields, {field: attribute}, true)[0];
                if (angular.isDefined(criteriaV2AttributeField)) {
                    criteriaV2AttributeField.values = (criteriaV2Allowed || [])
                        .map(function(value) { return value.toString().trim(); })
                        .sort(function(a, b) { return a.toLowerCase().localeCompare(b.toLowerCase()); });
                }
                return;
            }
            var criteriaObj = {};
            var catalogAttribute = utility.filterObject(catalogFactory.getActiveCatalogDetails().AssignedCatalogAttributes,
            { AttributeSystemName: attribute }, true)[0];
            var catalogAttributeAllowedValues = (catalogAttribute.AllowedValues || []).map(function (v) {
                return v.toString().toLowerCase()
            })
            angular.forEach(vm.vettingListCriteriaList, function(criteriaAttr) {
                for(var key1 in criteriaAttr) {
                    if(criteriaAttr.hasOwnProperty(key1)) {
                        if(key1.toLocaleLowerCase() === attribute.toLowerCase()) {
                            criteriaObj = criteriaAttr[key1];
                            break;
                        }
                    }
                }
            });

            var validValues = [];
            var noMatch = true
            Object.keys(criteriaObj).forEach(function (key) {
                var item = criteriaObj[key];
                var subItems = Object.keys(item);
                var validItems = 0;
                subItems.forEach(function (key2) {
                    if (vm.record.hasOwnProperty(key2) && vm.record[key2] != null && vm.record[key2] !== '') {
                        var articleAttributeValue = typeof(vm.record[key2]) === 'object' ?
                            angular.isDefined(vm.record[key2]['value']) ? vm.record[key2]['value'] : vm.record[key2] :
                            vm.record[key2];
                        var isDate = validateDate(articleAttributeValue);
                        if(articleAttributeValue != null && articleAttributeValue.toString() != '') {
                            noMatch = false;
                            var lowerCaseValues = item[key2].map(function (value) {
                                return isDate == true ? new Date(value).getTime().toString().toLowerCase() : value.toString().toLowerCase();
                            });

                            if(isDate == true) {
                                // remove time while comparing date-without-time and date-option values
                                if(field.inputType === 'date-option' || field.inputType === 'date-without-time') {
                                    lowerCaseValues = lowerCaseValues.split('T', 1)[0];
                                }
                                if(lowerCaseValues.indexOf(new Date(articleAttributeValue).getTime().toString().toLowerCase()) !== -1) {
                                  validItems++;
                                }
                            } else {
                                if(lowerCaseValues.indexOf(articleAttributeValue.toString().toLowerCase()) !== -1) {
                                    validItems++;
                                }
                            }
                        }
                    } else {
                        validItems++;
                    }
                });

                if (subItems.length == validItems && catalogAttributeAllowedValues.indexOf(key.toLowerCase()) !== -1) {
                    validValues.push(key);
                }
            });
            var attributeField = utility.filterObject(vm.filteredEditableFields, {field: attribute}, true)[0];
            if (!noMatch) {
                attributeField.values = (validValues || [])
                .map(function(value) {
                    return value.trim();
                })
                .sort(function(a, b) {
                    return a.toLowerCase().localeCompare(b.toLowerCase());
                })
            } else {
                attributeField.values = (catalogAttribute.AllowedValues || [])
                .map(function(value) {
                    return value.trim();
                })
                .sort(function(a, b) {
                    return a.toLowerCase().localeCompare(b.toLowerCase());
                })
            }
        }

        function validateDate(value, formats) {
            if(angular.isUndefined(formats)) {
                formats = [
                    moment.ISO_8601
                ];
            }
            return moment(value, formats, true).isValid();
        }

        function multiValueQuerySearch(query, selectedItems, field) {
            if(field.isCriteriaAdded) {
                getConditionalVettingList(field);
            }
            var values = field.values;
            var searchQueryResult = [];
            var searchQueryResult = utility.filterObject(values, query);
            if (selectedItems && selectedItems.length > 0) {
              for (var index = searchQueryResult.length - 1; index >= 0; index--) {
                if (selectedItems.indexOf(searchQueryResult[index]) !== -1) {
                  searchQueryResult.splice(index, 1);
                }
              }
            }
            return searchQueryResult;
        }

        function isAnyFieldChecked() {
            for(var prop in vm.checked) {
                if(vm.checked[prop]) {
                    return true
                }
            }
            return false;
        }

        function getDateObj(dateString, field, fromUTC) {
            return utility.createDateObject(dateString, field, fromUTC);
        }

        function isInputRequired(field) {
            // check only if check box is checked
            if(vm.checked[field.field]) {
                if (angular.isString(field.validation.isRequired)) {
                    return (scope.$eval(field.validation.isRequired) && (angular.isUndefined(field.validation.disabledCriteria) || !scope.$eval(field.validation.disabledCriteria)));
                }
                else {
                    return (field.validation.isRequired && (angular.isUndefined(field.validation.disabledCriteria) || !scope.$eval(field.validation.disabledCriteria)));
                }
            }
            else {
                return false;
            }
        }

        function getFieldDefaultValue(inputType) {
            switch(inputType) {
                case 'switch':
                    return 'No';
                case 'lookup-many':
                    return [];
                case 'bool':
                    return false;
                case 'bool-str':
                    return 'false';
                case 'bool-int':
                    return 0;
                case 'int-bool':
                    return '0';
                case 'multi-value':
                    return [];
                case 'decimal':
                case 'number':
                    return 0;
                default:
                    return '';
            }
        }

        function isSameVal(val1, val2, inputType) {
            if(inputType !== 'date' && inputType !== 'date-utc') {
                if (Array.isArray(val1) && Array.isArray(val2)) {
                    return JSON.stringify(val1) === JSON.stringify(val2);
                }
                return (val1 === val2);
            }
            else {
                if(utility.isValidDate(val1) && utility.isValidDate(val2)) {
                    var date1 = new Date(val1);
                    var date2 = new Date(val2);
                    date1.setHours(0,0,0,0);
                    date2.setHours(0,0,0,0);

                    return (date1.getTime() === date2.getTime());
                }
                else {
                    return false;
                }
            }
        }

        function onOpenSegmentationsChange(isOpen) {
            var planningValue = api.getSegmentationPlanningDefault();
            // when Open is enabled, all the segmentations will be set to true
            if(isOpen) {
                angular.forEach(vm.editableFields, function (field) {
                    vm.record[field.field] = 'Yes';
                    vm.record[field.field+'PlanningValue'] = planningValue;
                    vm.record[field.importField+'PlanningValue'] = planningValue;
                    vm.checked[field.field] = true;
                    checkBoxChanged(field)
                })
            } else {
                angular.forEach(vm.editableFields, function (field) {
                    vm.record[field.field] = 'No';
                    vm.checked[field.field] = true;
                    vm.record[field.field+'PlanningValue'] = '';
                    vm.record[field.importField+'PlanningValue'] ='';
                    checkBoxChanged(field)
                })
            }
        }

        // on editing segmentation enable check box on planning value change
        function onPlanningValueChange(field) {
            if(!vm.checked[field]) {
                vm.checked[field] = true;
            }
            checkBoxChanged(field)
        }

        // attribute validation
        function sourceAttributeForValidationChanged(field) {
            var validationExpression = utility.isValidJSON(field.validation['tx-pattern']);
            if(validationExpression && angular.isDefined(validationExpression.F) && validationExpression.F.length > 0) {
                var parsedExpressionObjects = validationExpression.F;
                angular.forEach(parsedExpressionObjects, function(parsedExpressionObject) {
                    var sourceField = parsedExpressionObject['SourceField'];
                    var sourceAttributeField = utility.filterObject(vm.editableFields, {field: sourceField}, true)[0];
                    if(angular.isDefined(sourceAttributeField)) {
                        validateTxPattern(sourceAttributeField);
                    }
                });
            }
        }

        function validateTxPattern(field) {
            var validationExpression = utility.isValidJSON(field.validation['tx-pattern']);
            if(validationExpression && angular.isDefined(validationExpression.F) && validationExpression.F.length > 0) {
                var parsedExpressionObjects = validationExpression.F;
                vm.isValidValue = true;
                angular.forEach(parsedExpressionObjects, function(parsedExpressionObject) {
                    if(vm.isValidValue) {
                        // skip validating overridable attribute with parent attributes for master catalog
                        if(angular.isDefined(parsedExpressionObject['SourceField']) && (dataSourceTypeId === 1 && field.Overridable && !parsedExpressionObject['SourceField'].startsWith('#')) || (dataSourceTypeId === 3)) {
                            // if SourceValueRequired is true then the source field should be required for this attribute to have value
                            if(parsedExpressionObject['SourceValueRequired']) {
                                if(vm.record[parsedExpressionObject['SourceField']] !== '' && vm.record[parsedExpressionObject['SourceField']] != null) {
                                    setAttributeFieldValidity(field, parsedExpressionObject);
                                } else if(vm.record[field.field] !== '' && vm.record[field.field] != null) {
                                    vm.editForm[field.field].$setValidity('pattern', false);
                                    vm.editForm[field.field].$touched = true;
                                    if(angular.isDefined(parsedExpressionObject.Message)) {
                                        field.validation.messages.pattern = parsedExpressionObject.Message;
                                    }
                                    vm.isValidValue = false;
                                }
                            } else {
                                if(vm.record[parsedExpressionObject['SourceField']] !== '' && vm.record[parsedExpressionObject['SourceField']] != null
                                && vm.record[field.field] !== '' && vm.record[field.field] != null) {
                                    setAttributeFieldValidity(field, parsedExpressionObject);
                                }
                            }
                        }
                        if(angular.isUndefined(parsedExpressionObject['SourceField']) && angular.isDefined(parsedExpressionObject['Expression']) && angular.isDefined(parsedExpressionObject['ExpressionValue'])) {
                            if(vm.record[field.field] !== '' && vm.record[field.field] != null) {
                                setAttributeFieldValidity(field, parsedExpressionObject, true);
                            }
                            else if(vm.editForm[field.field]) {
                                vm.editForm[field.field].$setValidity('pattern', true);
                                vm.editForm[field.field].$touched = true;
                            }
                        }
                    }
                });
            }
        }

        function setAttributeFieldValidity(field, parsedExpressionObject, isExpressionValidation) {
            var valid = validateExpression(field, parsedExpressionObject, isExpressionValidation);
            if(!valid) {
                if(angular.isDefined(vm.editForm[field.field])) {
                    vm.editForm[field.field].$setValidity('pattern', false);
                    vm.editForm[field.field].$touched = true;
                    if(angular.isDefined(parsedExpressionObject.Message)) {
                       field.validation.messages.pattern = parsedExpressionObject.Message;
                    }
                    vm.isValidValue = false;
                }
            } else {
                if(angular.isDefined(vm.editForm[field.field])) {
                    vm.editForm[field.field].$setValidity('pattern', true);
                    vm.editForm[field.field].$touched = true;
                }
            }
        }

        function validateExpression(field, parsedExpressionObject, isExpressionValidation) {
            var Expression = parsedExpressionObject.Expression;
            var SourceField = parsedExpressionObject.SourceField;
            var currentAttributeValue = vm.record[field.field];
            var sourceAttributeValue = !isExpressionValidation ? vm.record[SourceField] : parsedExpressionObject.ExpressionValue;

            //Transform the date fields to type dateUTC
            angular.forEach(vm.model.fields, function(itm) {
                if(itm.field === field.field || itm.field === SourceField) {
                    // for date fields
                    if ((itm.inputType === 'date-utc' || itm.inputType === 'date-option' || itm.inputType === 'date-without-time' || itm.inputType === 'date')) {
                        if(itm.field === field.field) {
                            currentAttributeValue = new Date(vm.record[itm.field]);
                            currentAttributeValue = currentAttributeValue.setHours(0,0,0,0);
                            if(isExpressionValidation) {
                                sourceAttributeValue = new Date(sourceAttributeValue)
                                sourceAttributeValue = sourceAttributeValue.setHours(0,0,0,0);
                            }
                        } else if(itm.field === SourceField) {
                            sourceAttributeValue = new Date(vm.record[itm.field]);
                            sourceAttributeValue = sourceAttributeValue.setHours(0,0,0,0);
                        }
                    }
                    // for text input types
                    if (itm.inputType === 'textArea' || itm.inputType === 'text' || (angular.isDefined(itm.type) && itm.type === 'text' && itm.inputType === 'list')) {
                        if(itm.field === field.field) {
                            currentAttributeValue = vm.record[itm.field].toUpperCase();
                            if(isExpressionValidation) {
                                sourceAttributeValue = sourceAttributeValue.toString().toUpperCase();
                            }
                        } else if(itm.field === SourceField) {
                            sourceAttributeValue = vm.record[itm.field].toUpperCase();
                        }
                    }
                }
            });

            if(dataSourceTypeId === 3 && field.Overridable) {
                if(field.inputType === 'textArea' || field.inputType === 'text' || (angular.isDefined(field.type) && field.type === 'text' && field.inputType === 'list')) {
                    sourceAttributeValue = vm.record[SourceField].toUpperCase();
                }

                // for date fields
                if ((field.inputType === 'date-utc' || field.inputType === 'date-option' || field.inputType === 'date-without-time' || field.inputType === 'date')) {
                    sourceAttributeValue = new Date(vm.record[SourceField]);
                    sourceAttributeValue = sourceAttributeValue.setHours(0,0,0,0);
                }
            }

            var isValid = false;
            switch(Expression) {
                case '<':
                    isValid = currentAttributeValue < sourceAttributeValue ? true : false;
                    break;
                case '>':
                    isValid = currentAttributeValue > sourceAttributeValue ? true : false;
                    break;
                case '<=':
                    isValid = currentAttributeValue <= sourceAttributeValue ? true : false;
                    break;
                case '>=':
                    isValid = currentAttributeValue >= sourceAttributeValue ? true : false;
                    break;
                case '=':
                    isValid = currentAttributeValue === sourceAttributeValue ? true : false;
                    break;
                case '!=':
                    isValid = currentAttributeValue !== sourceAttributeValue ? true : false;
                    break;
            }
            return isValid;
        }

        function lookupSearch(query, field) {
            var results = [];
            var lookupFilter = angular.isDefined(field.lookupFilter) ? field.lookupFilter : {};
            var sortBy = angular.isDefined(field.sortBy) ? field.sortBy : null;
            var predicate = angular.copy(lookupFilter);
            predicate.value = query;
            var lookupModel = api.getModel(field.lookupSource);

            if(lookupModel && angular.isDefined(lookupModel.lookupData) && angular.isDefined(lookupModel.lookupData.data) && lookupModel.lookupData.data.length) {
                results = query ? utility.filterObject(lookupModel.lookupData.data, predicate) : utility.filterObject(lookupModel.lookupData.data, lookupFilter, true);
                // this is to reduce the rendering time. It was very slow and was impacted overall page responsiveness
                // so while displaying we will display only the first 100 records and user can filter with any value
                // filter article colors based on the color palette conditions
                var filteredList = getFilteredCriteriaValues(results);
                var sortedList = filteredList;
                if (sortBy !== null) {
                    var sortKey = Object.keys(sortBy)[0];
                    var isAscending = sortBy[sortKey];
                    sortedList = utility.orderBy(filteredList, sortKey, isAscending);
                }
                field['isAboveDropDownLimit'] = sortedList.length > 100;
                return sortedList.slice(0, 100);
            }
            else {
                lookupPromises[field.field].then(function (lookupData) {
                    results = query ? utility.filterObject(lookupData.data, predicate) : utility.filterObject(lookupData.data, lookupFilter, true);
                });
                // this is to reduce the rendering time. It was very slow and was impacted overall page responsiveness
                // so while displaying we will display only the first 100 records and user can filter with any value
                // filter article colors based on the color palette conditions
                var filteredList = getFilteredCriteriaValues(results);
                var sortedList = filteredList;
                if (sortBy !== null) {
                    var sortKey = Object.keys(sortBy)[0];
                    var isAscending = sortBy[sortKey];
                    sortedList = utility.orderBy(filteredList, sortKey, isAscending);
                }
                field['isAboveDropDownLimit'] = sortedList.length > 100;
                return sortedList.slice(0, 100);
            }
        }

        function lookupChange(selectedObj, field) {
            if (angular.isObject(selectedObj)) {
                vm.record[field] = selectedObj.id;
                vm.checked[field] = true;
            }
            else if (angular.isUndefined(selectedObj) || selectedObj === null) {
                vm.record[field] = undefined;
                vm.checked[field] = false;
            }
        }

        function getLookupDisplayValue(item, field, isArticleNumberType) {
            var lookupModel = api.getModel(field.lookupSource);
            item = isArticleNumberType ? parseInt(item) : item;

            if(angular.isDefined(lookupModel.lookupData) && angular.isDefined(lookupModel.lookupData.data) && lookupModel.lookupData.data.length) {
                return getLookupDisplayVal(item, lookupModel.lookupData);
            }
            else {
                return lookupPromises[field.field].then(function(lookupData) {
                    return getLookupDisplayVal(item, lookupData);
                });
            }
        }

        //helper method
        function getLookupDisplayVal(item, lookupData) {
            var result;
            if(lookupData) {
                // since autocomplte return object
                if(angular.isObject(item)) {
                    result = utility.filterObject(lookupData.data, {id: item.id}, true);
                }
                // to initialize field value if any (when open update record dialog)
                else {
                    result = utility.filterObject(lookupData.data, {id: item}, true);
                }

                if (angular.isArray(result) && result.length > 0) {
                    return result[0].value;
                }
                else {
                    return result.value;
                }
            }
        }

        function getFilteredCriteriaValues(colors) {
            var results = [];
            angular.forEach(colors, function(color) {
                // conditions inside one criteria are AND'ed, several criteria on the same palette are OR'ed
                var match = utility.matchesColorCriteria(utility.normalizeColorCriteria(color.ColorCriteria), getCriteriaRecordValue);
                if(match.isMatch) {
                    flagColorDeptAttributes(match.matchedAttributes);
                    results.push(color);
                }
            });
            return results;
        }

        function getCriteriaRecordValue(attributeSystemName) {
            return vm.record[attributeSystemName];
        }

        // mark the attributes the matched criteria depends on, so changing one clears the selected color
        function flagColorDeptAttributes(attributeSystemNames) {
            angular.forEach(attributeSystemNames, function(attributeSystemName) {
                var colorDeptAttributeField = utility.filterObject(vm.editableFields, {field: attributeSystemName}, true)[0];
                if(angular.isDefined(colorDeptAttributeField)) {
                    colorDeptAttributeField.isColorDeptAttribute = true;
                }
            });
        }

        function customLookupChange(selectedObj, field) {
            if(angular.isObject(selectedObj)) {
                vm.record[field.field] = selectedObj[field.customLookupInfo.value];
                vm.checked[field.field] = true;
            }
            else if(angular.isUndefined(selectedObj) || selectedObj === null){
                vm.record[field.field] = undefined; // on record removal make field undefined or the property can be deleted using delete keywork
                vm.checked[field.field] = false;
            }
        }

        function colorPaletteLookupChange(selectedObj, field) {
            if(angular.isObject(selectedObj) && Object.keys(selectedObj)[0] != null && angular.isDefined(selectedObj.value)) {
                // color palette values are stores as key value pair
                var objectVal = {};
                objectVal[selectedObj.id] = selectedObj.value
                vm.record[field.field] = objectVal;
                vm.checked[field.field] = true;
            }
            else if(angular.isUndefined(selectedObj) || selectedObj === null){
                vm.record[field.field] = undefined; // on record removal make field undefined or the property can be deleted using delete keywork
                vm.checked[field.field] = false;
            }
        }

        function getCustomLookupDisplayValue(item, field) {
            //  show only color name for color palette attributes
            if(field.inputType === 'color-palette') {
                return $filter('colorPaletteRenderer')(item, field);
            } else {
                var lookupModel = api.getModel(field.lookupSource);

                if(angular.isDefined(lookupModel.lookupData) && angular.isDefined(lookupModel.lookupData.data) && lookupModel.lookupData.data.length) {
                    return getCustomLookupDisplayVal(item, lookupModel.lookupData, field);
                }
                else {
                    return lookupPromises[field.field].then(function(lookupData) {
                        return getCustomLookupDisplayVal(item, lookupData, field);
                    });
                }
            }
        }

        function getCustomLookupDisplayVal(item, lookupData, field) {
            var result;
            var predicate = {};
            if(lookupData) {
                // since autocomplete return object
                if(angular.isObject(item)) {
                    predicate[field.customLookupInfo.value] = item[field.customLookupInfo.value];
                    result = utility.filterObject(lookupData.data, predicate, true);
                }
                // to initialize field value if any (when open update record dialog)
                else {
                    predicate[field.customLookupInfo.value] = item;
                    result = utility.filterObject(lookupData.data, predicate, true);
                }

                if (angular.isArray(result) && result.length > 0) {
                    return result[0].value;
                }
                else {
                    return result.value;
                }
            }
        }

        // color palette dependentant attribute change method
        function colorDependentCriteriaAttributeChanged() {
            var colorPaletteAttributes =  utility.filterObject(vm.editableFields, {inputType: 'color-palette'}, true);
            angular.forEach(colorPaletteAttributes, function(colorAttr) {
                vm.record[colorAttr.field] = null;
            });
            // empty parimary color field as well
            var primaryColorField =  utility.filterObject(vm.editableFields, {field: 'ColorId'}, true)[0];
            if(angular.isDefined(primaryColorField) && primaryColorField.editable) {
                vm.record[primaryColorField.field] = null;
            }
        }

        // when lookup source attribute changed
        function lookupSourceAttributeChanged(field) {
            var sourceAttributeName = field.field;
            if (vm.lookupSourceAndDeptAttributeMap.hasOwnProperty(sourceAttributeName)) {
                var dependentAttributeNames = vm.lookupSourceAndDeptAttributeMap[sourceAttributeName];
                for (var i = 0; i < dependentAttributeNames.length; i++) {
                    var dependentAttributeName = dependentAttributeNames[i];
                    if (angular.isDefined(validSellerLookupsDestinationAttributesMap[dependentAttributeName])) {
                        var attributeLookupValues = validSellerLookupsDestinationAttributesMap[dependentAttributeName];
                        var matched = false;
                        for (var j = 0; j < attributeLookupValues.length; j++) {
                            var allAttributesMatch = true;
                            var value = attributeLookupValues[j];
                            for (var attributeSystemName in value.Source) {
                                if (value.Source.hasOwnProperty(attributeSystemName)) {
                                    if(vm.record[attributeSystemName] == null) {
                                        allAttributesMatch = false;
                                        break;
                                    } else if (value.Source[attributeSystemName].toString().toLowerCase() !== vm.record[attributeSystemName].toString().toLowerCase()) {
                                        allAttributesMatch = false;
                                        break;
                                    }
                                }
                            }
                            if (allAttributesMatch) {
                                if(vm.record[dependentAttributeName] !== value.Destination[dependentAttributeName]) {
                                    vm.record[dependentAttributeName] = value.Destination[dependentAttributeName];
                                }
                                matched = true;
                                break;
                            }
                        }
                        if (!matched) {
                            vm.record[dependentAttributeName] = null;
                        }
                    }
                }
            }
        }

        function handleFieldChange(field, skipCurrentFieldCheck) {
            if (!skipCurrentFieldCheck && vm.currentFocusedField !== field.field) {
                return;
            }
            vm.isElementDirty(field.field);
            
            if (!isSameVal(commonValueObject[field.field], vm.record[field.field], field.inputType)) {
                vm.checked[field.field] = true;
            }
            // Validate tx-pattern
            if (field.validation['tx-pattern'] && vm.currentFocusedField === field.field) {
                vm.validateTxPattern(field);
            }

            // Handle source attribute changes
            if (field.isSourceAttributeForValidation) {
                vm.sourceAttributeForValidationChanged(field);
            }

            if (field.isColorDeptAttribute) {
                vm.colorDependentCriteriaAttributeChanged(field);
            }

            // Handle lookup source attribute changes
            if (field.isLookupSourceAttribute) {
                vm.lookupSourceAttributeChanged(field);
            }

            // if this attribute is a dependant attribute of any criteria attribute revalidat the values of criteria attributes
            var dependentAttributeField = field.field;
            if(vm.criteriaDeptAttributeMap[dependentAttributeField]) {
                var criteriaAttributes = vm.criteriaDeptAttributeMap[dependentAttributeField];
                angular.forEach(criteriaAttributes, function(criteriaAttribute) {
                    var criteriaField = utility.filterObject(vm.editableFields, {field: criteriaAttribute}, true)[0];
                    if (!criteriaField) { return; } // target criteria attribute isn't a field in this dialog -> nothing to refresh/clear
                    var isMultiValueAttribute = (criteriaField.inputType === 'multi-value') ? true : false;
                    // CriteriaV2 (preferred): refresh dropdown + clear current value if not in matched rule's AllowedValues
                    if(vm.criteriaV2Map[criteriaAttribute]) {
                        getConditionalVettingList(criteriaField);
                        var getDependentValueForCriteriaV2 = function(dependentField) {
                            var depVal = vm.record[dependentField];
                            return (depVal && typeof depVal === 'object') ? (angular.isDefined(depVal.value) ? depVal.value : depVal) : depVal;
                        };
                        var criteriaV2AllowedLower = utility.getCriteriaV2AllowedValues(vm.criteriaV2Map[criteriaAttribute], getDependentValueForCriteriaV2)
                            .map(function(value) { return value.toString().toLowerCase(); });
                        var currentCriteriaValue = vm.record[criteriaAttribute];
                        var isCriteriaV2Valid;
                        if (isMultiValueAttribute) {
                            isCriteriaV2Valid = (Array.isArray(currentCriteriaValue) && currentCriteriaValue.length > 0)
                                ? currentCriteriaValue.every(function(value) { return criteriaV2AllowedLower.indexOf((value == null ? '' : value).toString().toLowerCase()) !== -1; })
                                : true;
                        } else {
                            isCriteriaV2Valid = (currentCriteriaValue === null || currentCriteriaValue === undefined || currentCriteriaValue === '')
                                ? true
                                : criteriaV2AllowedLower.indexOf(currentCriteriaValue.toString().toLowerCase()) !== -1;
                        }
                        if (!isCriteriaV2Valid) {
                            vm.record[criteriaAttribute] = isMultiValueAttribute ? [] : null;
                            vm.editForm[criteriaAttribute].$touched = true;
                            if(criteriaField.validation.isRequired) {
                                vm.checked[criteriaField.field] = true;
                            }
                            vm.isElementDirty(criteriaAttribute, true);
                        }
                        return; // skip OLD criteria path
                    }
                    var attributeCriteria = {};
                    angular.forEach(vm.dependingAttributesMap, function(criteriaAttr) {
                        for(var key in criteriaAttr) {
                            if(criteriaAttr.hasOwnProperty(key)) {
                                if(key.toLocaleLowerCase() === criteriaAttribute.toLowerCase()) {
                                    attributeCriteria = criteriaAttr[key];
                                    break;
                                }
                            }
                        }
                    });

                    if(angular.isDefined(attributeCriteria[dependentAttributeField][vm.record[dependentAttributeField]])) {
                        var allowedValues = attributeCriteria[dependentAttributeField][vm.record[dependentAttributeField]];
                        var currentValue = vm.record[criteriaAttribute];
                        var isValid = false;
                        if (isMultiValueAttribute) {
                            if (Array.isArray(currentValue) && currentValue.length > 0) {
                                isValid = currentValue.every(function(value) {
                                    return allowedValues.indexOf(value) !== -1;
                                });
                            } else {
                                isValid = true;
                            }
                        } else {
                            isValid = allowedValues.indexOf(currentValue) !== -1;
                        }
                        if (!isValid) {
                            vm.record[criteriaAttribute] = isMultiValueAttribute ? [] : null;
                            vm.editForm[criteriaAttribute].$touched = true;
                            if(criteriaField.validation.isRequired) {
                                vm.checked[criteriaField.field] = true;
                            }
                            vm.isElementDirty(criteriaAttribute, true);
                        }
                    } else {
                        vm.record[criteriaAttribute] = isMultiValueAttribute ? [] : null;
                        vm.editForm[criteriaAttribute].$touched = true;
                        if(criteriaField.validation.isRequired) {
                            vm.checked[criteriaField.field] = true;
                        }
                        vm.isElementDirty(criteriaAttribute);
                    }
                });
            }
        }

        function onSearchTextChanged() {
            if (!vm.searchPageText) {
                vm.filteredEditableFields = angular.copy(vm.editableFields);
                return;
            }

            vm.filteredEditableFields = vm.editableFields.filter(function(item) {
                if (!item || !item.displayLabel) return false;

                var translatedLabel = $translate.instant(item.displayLabel);
                return translatedLabel.toLowerCase().indexOf(vm.searchPageText.toLowerCase()) !== -1;
            });
        }

        function isFormValid() {
            var isRequiredFieldsValid = true;
            // check if any required fields are empty
            angular.forEach(vm.editableFields, function (field) {
                if (field.validation && field.validation.isRequired && isInputRequired(field)) {
                    if (angular.isUndefined(vm.record[field.field]) || vm.record[field.field] === null || vm.record[field.field] === '') {
                        isRequiredFieldsValid = false;
                    }
                }
            });
            return vm.editForm.$valid && isRequiredFieldsValid;
        }

        $scope.$on('$destroy', function () {
            parentModelTypeChangedEventCleanup();
            datasetAttributeChangedEventCleanup();
        })

    }
})();
(function () {
    'use strict';

    angular
        .module('app.attributeGroupSelector', []);
})();

(function() {
    'use strict';

    angular.module('app.attributeGroupSelector')
        .factory('attributeGroupSelector', attributeGroupSelector);

    /**
     * Shared attribute group scope for lists whose GET endpoint embeds an attribute group id.
     *
     * Those lists used to derive the id implicitly from the active catalog. Records belonging to any other
     * attribute group were therefore invisible even though the assign/create dialogs happily write into
     * any group.
     *
     * Every affected module feeds `getGroups()` into the tx-data-table attribute group dropdown and
     * refreshes when it changes. The selection is kept per module in session storage so it survives
     * drill-outs to details views. A stored selection is discarded when the active catalog changes (the
     * default is derived from it) or when a different seller is opened.
     */

    /* @ngInject */
    function attributeGroupSelector($q, $log, $sessionStorage, api, utility, catalogFactory, SecurityFactory) {

        var STORE_KEY = 'attributeGroupContext';

        var service = {
            getGroups    : getGroups,
            getSelectedId: getSelectedId,
            setSelectedId: setSelectedId
        };

        return service;

        //Methods implementation

        /**
         * Attribute groups to offer in the dropdown. All of them, so anything the assign/create dialogs can
         * write into can also be read back.
         *
         * Resolves with an empty list when the user cannot read attribute groups, which keeps the dropdown
         * hidden instead of firing a request that would only raise a no-privilege dialog.
         *
         * @return {promise} resolves with the attribute group records ordered by name
         */
        function getGroups() {
            var model = api.attributes.attributeGroups;
            if (!SecurityFactory.isAuthorized({accessPrivileges: [model.views.privileges.list]})) {
                return $q.when([]);
            }
            return model.methods.getList({forceFetch: false, isLogRequired: false}).then(function(response) {
                return utility.orderBy(response.data, model.lookupDisplayField);
            }, function(error) {
                // swallow so the caller is not left with an unhandled rejection. The dropdown stays hidden, which is
                // the same outcome as no privilege, and the list keeps working on its default group.
                $log.warn('attributeGroupSelector: could not load attribute groups, the group dropdown will be hidden', error);
                return [];
            });
        }

        /**
         * @param  {string} modulePath  identifies the list (eg 'sellers.seasonlessModelAttributes')
         * @param  {int}    sellerId    seller the list belongs to, pass undefined from a drill-out to inherit
         *                              whatever scope the list that navigated there was using
         * @param  {int}    defaultId   attribute group id to fall back on (the implicit, catalog derived one)
         * @return {int}    the stored selection when still applicable, else defaultId
         */
        function getSelectedId(modulePath, sellerId, defaultId) {
            var entry = getStore()[modulePath];

            if (angular.isUndefined(entry) || angular.isUndefined(entry.attributeGroupId)) {
                return defaultId;
            }
            // the default is derived from the active catalog, so a catalog switch invalidates the selection
            if (entry.catalogCode !== catalogFactory.getActiveCatalog().CatalogCode) {
                clearSelectedId(modulePath);
                return defaultId;
            }
            // never carry a selection over to another seller
            if (angular.isDefined(sellerId) && entry.sellerId !== sellerId) {
                clearSelectedId(modulePath);
                return defaultId;
            }
            return entry.attributeGroupId;
        }

        function setSelectedId(modulePath, sellerId, attributeGroupId) {
            var store = getStore();
            store[modulePath] = {
                attributeGroupId: attributeGroupId,
                catalogCode     : catalogFactory.getActiveCatalog().CatalogCode,
                sellerId        : sellerId
            };
            $sessionStorage[STORE_KEY] = store;
        }

        function clearSelectedId(modulePath) {
            var store = getStore();
            delete store[modulePath];
            $sessionStorage[STORE_KEY] = store;
        }

        function getStore() {
            if (angular.isUndefined($sessionStorage[STORE_KEY]) || $sessionStorage[STORE_KEY] === null) {
                $sessionStorage[STORE_KEY] = {};
            }
            return $sessionStorage[STORE_KEY];
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.alertDialog', []);
})();
(function () {
  'use strict';

  angular.module('app.alertDialog')
    .factory('alertDialog', alertDialog);

  /** @ngInject */
  function alertDialog($mdDialog, $document) {

    //Methods
    var service = {
      show: show
    };

    return service;

    function show(message, url) {
      return $mdDialog.show({
        parent: angular.element($document[0].body),
        controller: 'alertDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/services/alertDialog/alertDialog.html',
        clickOutsideToClose: false,
        targetEvent: null,
        locals: {
          message: message,
          url: url
        },
      });
    }


    function DialogController($mdDialog) {
      var vm = this;
      vm.closeDialog = function () {
        $mdDialog.hide();
      }
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.alertDialog')
    .controller('alertDialogController', alertDialogController);

  /** @ngInject */
  function alertDialogController($mdDialog, $document,  message, url) {
    /* jshint validthis: true */
    var vm = this;

    //Data
    vm.message = message;
    vm.url = url;

    //Methods
    vm.closeDialog = closeDialog;

    //Methods Implementation
    function closeDialog(showDetails) {
      $mdDialog.hide(showDetails);
    }
  }

})();

(function () {
	'use strict';

	angular
		.module('app.main.vetting-lists')
		.controller('vettingListController', vettingListController);

	/* @ngInject */
	function vettingListController(api, APIListName, settingsFactory, toast, $mdDialog, $document, $state, $scope) {
		/* jshint validthis: true */
		var vm = this;

		vm.model = api.lists[APIListName];
		settingsFactory.applyPersistedListViewLayout(vm.model);

		vm.data = [];
		vm.filteredData = [];

		vm.allSelected = false;
		vm.isLoading = false;
		vm.toolbarVisible = false;

		if (APIListName === 'userLogs') {
			vm.toolbarVisible = true;
			vm.toolbarValue = 3; //userLogs default duration is of 3 months
			vm.toolbarOptions = [{ "value": 3, "displayLabel": "USER_LOGS.DISPLAY_LABELS.LAST_3_MONTHS" }, { "value": 6, "displayLabel": "USER_LOGS.DISPLAY_LABELS.LAST_6_MONTHS" },
													 { "value": 9, "displayLabel": "USER_LOGS.DISPLAY_LABELS.LAST_9_MONTHS" }, { "value": 12, "displayLabel": "USER_LOGS.DISPLAY_LABELS.LAST_12_MONTHS" },
													 { "value": 0, "displayLabel": "USER_LOGS.DISPLAY_LABELS.ALL" }];
		}

		vm.refreshItems = refreshItems;
		vm.doItemAction = doItemAction;
		vm.doListAction = doListAction;
		// vm.viewItem = viewItem;
		vm.addRecord = addRecord;

		activate();

		////////////////

		function activate() {
			refreshItems(true, false);
		}

		function refreshItems(forceFetch, isLogRequired) {
			vm.isLoading = true;
			var generalProperties = {
				forceFetch: forceFetch,
				isLogRequired: isLogRequired
			}
			vm.model.methods.getList(generalProperties, vm.toolbarValue).then(function (response) {
				vm.data = response.data;
			}).finally(function () {
				vm.isLoading = false;
			});
		}

		function doItemAction(action, record) {
			if (action && record) {
				switch (action.id) {
					case 'view':
						viewItem(record);
						break;
					case 'delete':
					case 'activate':
						if (APIListName === 'configurations') {
							deleteItem(record);
						} else if (APIListName === 'privacyPolicy' || APIListName === 'duneContext') {
							vm.model.methods.activate(record, vm.model, action.id, undefined);
						}
						break;
					case 'copyFrom':
						if (APIListName === 'privacyPolicy') {
							doCopyFrom(record);
						}
						break;
					case 'edit':
						if (APIListName === 'resourceTypes') {
							editResourceType(record);
						} else if(APIListName === 'duneContext') {
							editDuneContext(record, null);
						} else if(APIListName === 'licenseTypes') {
							editLicenseType(record, null);
						}
						break;
					case 'subscribe':
					case 'unsubscribe':
						vm.model.methods.UpdateNotificationTypeAutosubscribe(record, vm.model, action.id, undefined);
						break;
				}
			}
		}

		function doListAction(action, records) {
			if (action) {
				switch (action.id) {
					case 'delete':
					case 'activate':
						vm.model.methods.activate(records, vm.model, action.id, undefined);
						break;
					case 'subscribe':
					case 'unsubscribe':
						vm.model.methods.UpdateNotificationTypeAutosubscribe(records, vm.model, action.id, undefined);
						break;
				}
			}
		}

		function viewItem(record) {
			var id = record[vm.model.idField];
			var stateParams = { id: id };
			$state.go($state.current.name + '.details', stateParams);
		}

		function deleteItem(record) {
			vm.model.methods.remove(record).then(function () {
				toast.success('SUCCESS.DELETE', '', '');
				refreshItems(true, false);
			});
		}

		function addRecord(ev) {
			if (APIListName === 'configurations') {
				$mdDialog.show({
					controller: 'createConfigurationController',
					controllerAs: 'vm',
					templateUrl: 'app/main/vetting-lists/dialogs/create-configuration/create-configuration.html',
					parent: angular.element($document.body),
					targetEvent: ev,
					clickOutsideToClose: false,
					locals: {
						event: ev,
						model: vm.model
					}
				}).then(function (saved) {
					if (saved) {
						refreshItems(true, false);
					}
				});
			} else if (APIListName === 'privacyPolicy') {
				$mdDialog.show({
					controller: 'createPrivacyPolicyController',
					controllerAs: 'vm',
					templateUrl: 'app/main/vetting-lists/dialogs/create-privacy-policy/create-privacy-policy.html',
					parent: angular.element($document.body),
					targetEvent: ev,
					clickOutsideToClose: false,
					locals: {
						event: ev,
						model: vm.model,
						record: undefined,
						isCopyPrivacyPolicy: false
					}
				}).then(function (saved) {
					if (saved) {
						refreshItems(true, false);
					}
				});
			} else if (APIListName === 'resourceTypes') {
				$mdDialog.show({
					controller: 'createResourceTypesController',
					controllerAs: 'vm',
					templateUrl: 'app/main/vetting-lists/dialogs/create-resource-types/create-resource-types.html',
					parent: angular.element($document.body),
					targetEvent: ev,
					clickOutsideToClose: false,
					locals: {
						event: ev,
						model: vm.model,
						resourceTypeListData: vm.data,
						record: {},
						isNew: true
					}
				}).then(function (saved) {
					if (saved) {
						refreshItems(true, false);
					}
				});
			} else if(APIListName === 'duneContext' || APIListName === 'licenseTypes') {
				var modelCopy = angular.copy(vm.model);
				var existingRecordsForUniqueValue = angular.copy(vm.data);
				api.showCreateRecordDialog(angular.element($document.body), ev, modelCopy, undefined, undefined, undefined, undefined, undefined, existingRecordsForUniqueValue)
				.then(function(saved) {
					if (saved) {
						refreshItems(true);
					}
				});
			} 
		}

		function doCopyFrom(record) {
			$mdDialog.show({
				controller: 'createPrivacyPolicyController',
				controllerAs: 'vm',
				templateUrl: 'app/main/vetting-lists/dialogs/create-privacy-policy/create-privacy-policy.html',
				parent: angular.element($document.body),
				targetEvent: null,
				clickOutsideToClose: false,
				locals: {
					event: null,
					model: vm.model,
					record: angular.copy(record),
					isCopyPrivacyPolicy: true
				}
			}).then(function (saved) {
				if (saved) {
					refreshItems(true, false);
				}
			});
		}

		function editResourceType(record) {
			var resourceRecord = angular.copy(record);
			$mdDialog.show({
				controller: 'createResourceTypesController',
				controllerAs: 'vm',
				templateUrl: 'app/main/vetting-lists/dialogs/create-resource-types/create-resource-types.html',
				parent: angular.element($document.body),
				targetEvent: null,
				clickOutsideToClose: false,
				locals: {
					event: null,
					model: vm.model,
					resourceTypeListData: vm.data,
					record: resourceRecord,
					isNew: false
				}
			}).then(function (saved) {
				if (saved) {
					refreshItems(true, false);
				}
			});
		}

		function editDuneContext(record, ev) {
			var modelCopy = angular.copy(vm.model);
			var existingRecordsForUniqueValue = angular.copy(vm.data);
			for (var i = 0; i < existingRecordsForUniqueValue.length; i++) {
				if(existingRecordsForUniqueValue[i].Id === record.Id) {
					existingRecordsForUniqueValue.splice(i, 1);
				}
			}
			api.showEditRecordDialog(angular.element($document.body), ev, modelCopy, record, undefined, undefined, undefined, undefined, existingRecordsForUniqueValue)
			.then(function(saved) {
				if (saved) {
					refreshItems(true);
				}
			});
		}

		function editLicenseType(record, ev) {
			var modelCopy = angular.copy(vm.model);
			var existingRecordsForUniqueValue = angular.copy(vm.data);
			for (var i = 0; i < existingRecordsForUniqueValue.length; i++) {
				if(existingRecordsForUniqueValue[i].Id === record.Id) {
					existingRecordsForUniqueValue.splice(i, 1);
				}
			}
			api.showEditRecordDialog(angular.element($document.body), ev, modelCopy, record, undefined, undefined, undefined, undefined, existingRecordsForUniqueValue)
			.then(function(saved) {
				if (saved) {
					refreshItems(true);
				}
			});
		}

		var userLogsWatchCleanup = $scope.$watch('vm.toolbarValue', function () {
			refreshItems(true, false);
		});

		$scope.$on('$destroy', function () {
			userLogsWatchCleanup();
		})


	}
})();
(function ()
{
    'use strict';

    angular
        .module('app.main.vetting-lists')
        .run(runBlock);

    /** @ngInject */
    function runBlock(api, $state, activityLogger, catalogFactory, $q, crud, $localStorage, utility, SecurityFactory, CONSTANTS, errorDialog)
    {
        if (angular.isUndefined(api.lists)) {
            api.lists = {};
        }

        api.lists.accountTypes = {
            modelPath: 'lists.accountTypes',
            fields: [
                { field: 'ID', type: 'text', displayLabel: 'ACCOUNT_TYPES.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: true, maxLen: -1 },
                { field: 'AccountTypeName', type: 'text', displayLabel: 'ACCOUNT_TYPES.FIELDS.NAME', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: true, maxLen: -1 }
            ],
            title: 'ACCOUNT_TYPES.NAV',
            icon: 'icon-tile-four',
            idField: 'ID',
            lookupDisplayField: 'AccountTypeName',
            methods: {
                getList: getAccountTypesList
            },
            views: {
                mainList: {
                    columns: [ 'ID', 'AccountTypeName' ],
                    columnFilter: {},
                    topIndex: 0,
                    showFilterRow: false,
                    sortColumn   : {'AccountTypeName': true},
                 }
            }
        };

        api.lists.attributeTypes = {
            modelPath: 'lists.attributeTypes',
            fields: [
                { field: 'ID', type: 'text', displayLabel: 'ATTRIBUTE_TYPES.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: true, maxLen: -1 },
                { field: 'AttributeTypeName', type: 'text', displayLabel: 'ATTRIBUTE_TYPES.FIELDS.NAME', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: true, maxLen: -1 },
                { field: 'AttributeTypeSize', type: 'text', displayLabel: 'ATTRIBUTE_TYPES.FIELDS.SIZE', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: true, maxLen: -1 }
            ],
            title: 'ATTRIBUTE_TYPES.NAV',
            icon: 'icon-tile-four',
            idField: 'ID',
            lookupDisplayField: 'AttributeTypeName',
            methods: {
                getList: getAttributeTypeList
            },
            views: {
                mainList: {
                    columns: [ 'ID', 'AttributeTypeName', 'AttributeTypeSize' ],
                    columnFilter: {},
                    topIndex: 0,
                    showFilterRow: false,
                    sortColumn   : {'AttributeTypeName': true},
                 }
            }
        };

        api.lists.attributeTypesProxy = {
            modelPath: 'lists.attributeTypesProxy',
            fields: [
                { field: 'ID', type: 'text', displayLabel: 'ATTRIBUTE_TYPES.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: true, maxLen: -1 },
                { field: 'AttributeTypeName', type: 'text', displayLabel: 'ATTRIBUTE_TYPES.FIELDS.NAME', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: true, maxLen: -1 },
                { field: 'AttributeTypeSize', type: 'text', displayLabel: 'ATTRIBUTE_TYPES.FIELDS.SIZE', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: true, maxLen: -1 }
            ],
            title: 'ATTRIBUTE_TYPES.NAV',
            icon: 'icon-tile-four',
            idField: 'ID',
            lookupDisplayField: 'AttributeTypeName',
            methods: {
                getList: function() {
                    return $q.when({data:[]})
                }
            },
            views: {
                mainList: {
                    columns: [ 'ID', 'AttributeTypeName', 'AttributeTypeSize' ],
                    columnFilter: {},
                    topIndex: 0,
                    showFilterRow: false,
                    sortColumn   : {'AttributeTypeName': true},
                 }
            }
        };

        api.lists.authClients = {
            modelPath: 'lists.authClients',
            fields: [
                { field: 'id', type: 'int', displayLabel: 'CLIENTS.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number', isRequired: true, maxLen: -1 },
                { field: 'code', type: 'text', displayLabel: 'CLIENTS.FIELDS.CODE', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: true, maxLen: -1 },
                { field: 'name', type: 'text', displayLabel: 'CLIENTS.FIELDS.NAME', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: true, maxLen: -1 },
                { field: 'details', type: 'text', displayLabel: 'CLIENTS.FIELDS.DETAILS', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: true, maxLen: -1 }
            ],
            title: 'CLIENTS.NAV',
            icon: 'icon-tile-four',
            idField: 'code',
            lookupDisplayField: 'name',
            methods: {
                getList: getClientList
            },
            views: {
                mainList: {
                    columns: [ 'id', 'name'],
                    columnFilter: {},
                    topIndex: 0,
                    showFilterRow: false,
                    sortColumn   : {'name': true},
                 }
            }
        };

        api.lists.clients = {
            modelPath: 'lists.clients',
            fields: [
                { field: 'id', type: 'int', displayLabel: 'CLIENTS.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number', isRequired: true, maxLen: -1 },
                { field: 'code', type: 'text', displayLabel: 'CLIENTS.FIELDS.CODE', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: true, maxLen: -1 },
                { field: 'name', type: 'text', displayLabel: 'CLIENTS.FIELDS.NAME', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: true, maxLen: -1 },
                { field: 'details', type: 'text', displayLabel: 'CLIENTS.FIELDS.DETAILS', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: true, maxLen: -1 }
            ],
            title: 'CLIENTS.NAV',
            icon: 'icon-tile-four',
            idField: 'code',
            lookupDisplayField: 'name',
            methods: {
                getList: getClientList
            },
            views: {
                mainList: {
                    columns: [ 'id', 'name'],
                    columnFilter: {},
                    topIndex: 0,
                    showFilterRow: false,
                    sortColumn   : {'name': true},
                 }
            }
        };

        api.lists.environments = {
            modelPath: 'lists.environments',
            fields: [
                { field: 'id', type: 'int',  visible: true, creatable: false, editable: false, inputType: 'number', isRequired: true, maxLen: -1 },
                { field: 'code', type: 'text', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: true, maxLen: -1 },
                { field: 'name', type: 'text', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: true, maxLen: -1 },
                { field: 'details', type: 'text', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: true, maxLen: -1 },
                { field: 'templateOtp', type: 'text',visible: true, creatable: false, editable: false, inputType: 'text', isRequired: true, maxLen: -1 }
            ],
            icon: 'icon-tile-four',
            idField: 'code',
            lookupDisplayField: 'name',
            methods: {
                getList: getEnvironmentList
            },
            views: {
                mainList: {
                    columns: [ 'id', 'name'],
                    columnFilter: {},
                    topIndex: 0,
                    showFilterRow: false,
                    sortColumn   : {'name': true},
                 }
            }
        };

        api.lists.configurations = {
            modelPath: 'lists.configurations',
            fields: [
                { field: 'Id', type: 'text', displayLabel: 'CONFIGURATIONS.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Name', type: 'text', displayLabel: 'CONFIGURATIONS.FIELDS.NAME', visible: true, creatable: true, editable: false, inputType: 'text', showTooltip: true,
                    validation: {isRequired: true, maxLen: 250, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Description', type: 'text', displayLabel: 'CONFIGURATIONS.FIELDS.DESCRIPTION', visible: true, creatable: true, editable: false, inputType: 'textArea', showTooltip: true,
                    validation: {isRequired: false, maxLen: 500, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'DefaultValueType', type: 'text', displayLabel: 'CONFIGURATIONS.FIELDS.VALUE_TYPE', visible: true, creatable: true, editable: false, inputType: 'text',
                    validation: {isRequired: true, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Value', type: 'text', displayLabel: 'CONFIGURATIONS.FIELDS.DEFAULT_VALUE', visible: true, creatable: true, editable: false, inputType: 'text',
                    validation: {isRequired: true, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'InUse', type: 'text', displayLabel: 'CONFIGURATIONS.FIELDS.IN_USE', visible: true, creatable: false, editable: false, inputType: 'int-bool',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'SortOrder', type: 'text', displayLabel: 'CONFIGURATIONS.FIELDS.SORTORDER', visible: true, creatable: true, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedDate', type: 'text', displayLabel: 'CONFIGURATIONS.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedDate', type: 'text', displayLabel: 'CONFIGURATIONS.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
            ],
            title: 'CONFIGURATIONS.NAV',
            detailsDialogTitle: 'PARTS.DETAILS',
            icon: 'icon-tile-four',
            idField: 'Id',
            lookupDisplayField: 'Name',
            isDirty: false,
            methods: {
                getList: getConfigurationsList,
                create : createConfiguration,
                remove : removeConfiguration

            },
            views: {
                mainList: {
                    columns: [ 'Name', 'Description', 'Value', 'InUse', 'UpdatedDate'],
                    columnFilter: {},
                    topIndex: 0,
                    showFilterRow: false,
                    sortColumn   : {'UpdatedDate': false},
                    itemActions         : [
                                            { id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'DeleteConfiguration', disabled: 'itm.InUse', visible: true,
                                                requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'}
                                        ],
                    fabAction           : {id: 'add', label: 'ACTIONS.ADD', icon: 'icon-plus', privilege: 'CreateConfiguration', visible: true}
                }
            }
        };

        api.lists.consolidationStatuses = {
            modelPath: 'lists.consolidationStatuses',
            fields: [
                { field: 'Id', type: 'text', displayLabel: 'CONSOLIDATION_STATUSES.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: true, maxLen: -1 },
                { field: 'Status', type: 'text', displayLabel: 'CONSOLIDATION_STATUSES.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: true, maxLen: -1 }
            ],
            title: 'CONSOLIDATION_STATUSES.NAV',
            icon: 'icon-tile-four',
            idField: 'Id',
            lookupDisplayField: 'Status',
            methods: {
                getList: getConsolidationStatuses
            },
            views: {
                mainList: {
                    columns: ['Id', 'Status'],
                    columnFilter: {},
                    topIndex: 0,
                    showFilterRow: false,
                    sortColumn   : {'Id': true},
                 }
            }
        };

        api.lists.countries = {
            modelPath: 'lists.countries',
            fields: [
                { field: 'CountryCode', type: 'text', displayLabel: 'COUNTRIES.FIELDS.CODE', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: true, maxLen: -1 },
                { field: 'CountryName', type: 'text', displayLabel: 'COUNTRIES.FIELDS.NAME', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: true, maxLen: -1 }
            ],
            title: 'COUNTRIES.NAV',
            icon: 'icon-tile-four',
            idField: 'CountryCode',
            lookupDisplayField: 'CountryName',
            methods: {
                getList: getCountriesList
            },
            views: {
                mainList: {
                    columns: [ 'CountryCode', 'CountryName' ],
                    columnFilter: {},
                    topIndex: 0,
                    showFilterRow: false,
                    sortColumn   : {'CountryCode': true},
                 }
            }
        };

        api.lists.currencies = {
            modelPath: 'lists.currencies',
            fields: [
                { field: 'Code', type: 'text', displayLabel: 'CURRENCIES.FIELDS.CODE', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: true, maxLen: -1 },
                { field: 'Name', type: 'text', displayLabel: 'CURRENCIES.FIELDS.NAME', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: true, maxLen: -1 },
                { field: 'Symbol', type: 'text', displayLabel: 'CURRENCIES.FIELDS.SYMBOL', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: true, maxLen: -1 }
            ],
            title: 'CURRENCIES.NAV',
            icon: 'icon-tile-four',
            idField: 'Code',
            lookupDisplayField: 'Name',
            methods: {
                getList: getCurrenciesList
            },
            views: {
                mainList: {
                    columns: [ 'Code', 'Name', 'Symbol' ],
                    columnFilter: {},
                    topIndex: 0,
                    showFilterRow: false,
                    sortColumn   : {'Code': true},
                 }
            }
        };

        api.lists.dataSourceTypes = {
            modelPath: 'lists.dataSourceTypes',
            fields: [
                { field: 'Id', type: 'text', displayLabel: 'DATA_SOURCE_TYPES.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: true, maxLen: -1 },
                { field: 'Type', type: 'text', displayLabel: 'DATA_SOURCE_TYPES.FIELDS.TYPE', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: true, maxLen: -1 },
                { field: 'Description', type: 'text', displayLabel: 'DATA_SOURCE_TYPES.FIELDS.DESCRIPTION', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: true, maxLen: -1 }
            ],
            title: 'DATA_SOURCE_TYPES.NAV',
            icon: 'icon-tile-four',
            idField: 'Id',
            lookupDisplayField: 'Type',
            methods: {
                getList: getDataSourceTypesList
            },
            views: {
                mainList: {
                    columns: [ 'Id', 'Type', 'Description' ],
                    columnFilter: {},
                    topIndex: 0,
                    showFilterRow: false,
                    sortColumn   : {'Type': true},
                 }
            }
        };

        api.lists.entityTypes = {
            modelPath: 'lists.entityTypes',
            fields: [
                { field: 'Id', type: 'text', displayLabel: 'ENTITY_TYPES.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: true, maxLen: -1 },
                { field: 'Entity', type: 'text', displayLabel: 'ENTITY_TYPES.FIELDS.ENTITY', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: true, maxLen: -1 }
            ],
            title: 'ENTITY_TYPES.NAV',
            icon: 'icon-tile-four',
            idField: 'Id',
            lookupDisplayField: 'Entity',
            methods: {
                getList: getEntityTypesList
            },
            views: {
                mainList: {
                    columns: [ 'Id', 'Entity'],
                    columnFilter: {},
                    topIndex: 0,
                    showFilterRow: false,
                    sortColumn   : {'Entity': true},
                 }
            }
        };

        api.lists.privacyPolicy = {
            modelPath: 'lists.privacyPolicy',
            fields: [
                { field: 'Id', type: 'int', displayLabel: 'PRIVACY_POLICY.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Version', type: 'int', displayLabel: 'PRIVACY_POLICY.FIELDS.VERSION', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Title', type: 'text', displayLabel: 'PRIVACY_POLICY.FIELDS.TITLE', visible: true, creatable: true, editable: true, inputType: 'text',
                    validation: {isRequired: true, maxLen: 250, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Content', type: 'text', displayLabel: 'PRIVACY_POLICY.FIELDS.CONTENT', visible: false, creatable: true, editable: true, inputType: 'text',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Status', type: 'text', displayLabel: 'PRIVACY_POLICY.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedBy', type: 'text', displayLabel: 'PRIVACY_POLICY.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedBy', type: 'text', displayLabel: 'PRIVACY_POLICY.FIELDS.UPDATED_BY', visible: true, creatable: true, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedDate', type: 'text', displayLabel: 'PRIVACY_POLICY.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedDate', type: 'text', displayLabel: 'PRIVACY_POLICY.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
            ],
            title: 'PRIVACY_POLICY.NAV',
            icon: 'icon-tile-four',
            idField: 'Id',
            lookupDisplayField: 'Title',
            isDirty: false,
            methods: {
                getList     : getPrivacyPoliciesList,
                getDetails  : getPrivacyPolicyDetails,
                create      : createPrivacyPolicy,
                activate    : activatePrivacyPolicy
            },
            views: {
                mainList: {
                    columns             : [ 'Title', 'Version', 'Status', 'CreatedDate', 'UpdatedDate'],
                    columnFilter        : {},
                    toggleFilterProps   : { toggleStatus:false, filterProp:'Status', trueVal:1, trueValTooltipMessage: 'ACTIONS.TOGGLE_ACTIVE', falseVal:'', falseValTooltipMessage:"ACTIONS.TOGGLE_ALL"},
                    topIndex            : 0,
                    showFilterRow       : false,
                    sortColumn          : {'Version': false},
                    sortDescending      : true,
                    itemActions         : [
                                            { id: 'view', label: 'ACTIONS.VIEW', icon: 'icon-magnify', privilege: 'GetPrivacyPolicyDetails', disabled: '!itm.Status', visible: true },
                                            { id: 'copyFrom', label: 'PRIVACY_POLICY.ACTIONS.COPY_FROM', icon: 'icon-content-copy', privilege: 'CreatePrivacyPolicy', disabled: '!itm.Status', visible: true },
                                            { id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdatePrivacyPolicyStatusBulk', disabled: false, visible: 'itm.Status',
                                                requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                                            { id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdatePrivacyPolicyStatusBulk', disabled: false, visible: '!itm.Status',
                                                requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
                                        ],
                    listActions         : [
                                            { id: 'delete', label: 'ACTIONS.DELETE_BULK', icon: 'icon-delete', privilege: 'UpdatePrivacyPolicyStatusBulk', disabled: '{selected: true, Status: 1}', visible: true,
                                            requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                                            { id: 'activate', label: 'ACTIONS.ACTIVATE_BULK', icon: 'icon-undo-variant', privilege: 'UpdatePrivacyPolicyStatusBulk', disabled: '{selected: true, Status: 0}', visible: true,
                                            requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
                                        ],
                    fabAction           : {id: 'add', label: 'ACTIONS.ADD', icon: 'icon-plus', privilege: 'CreatePrivacyPolicy', visible: true}
                },
                mainDetails: {
                    selectedTabIndex    : 0,
                    itemActions         : [
                                            { id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdatePrivacyPolicyStatusBulk', disabled: '{selected: true, Status: 1}',
                                                visible: true, requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                                            { id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdatePrivacyPolicyStatusBulk', disabled: '{selected: true, Status: 0}',
                                                visible: true, requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
                                            ],
                    fabAction           : {id: 'add', label: 'ACTIONS.ADD', icon: 'icon-plus', privilege: 'CreatePrivacyPolicy', visible: true}
                },
                privileges: {
                    list    : 'GetPrivacyPolicyList',
                    details : 'GetPrivacyPolicyDetails'
                }
            }
        };

        api.lists.resourceFileTypes = {
            modelPath: 'lists.resourceFileTypes',
            fields: [
                { field: 'Id', type: 'text', displayLabel: 'RESOURCE_FILE_TYPES.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: true, maxLen: -1 },
                { field: 'CatalogEntityID', type: 'text', displayLabel: 'RESOURCE_FILE_TYPES.FIELDS.CATALOG_ENTITY_ID', visible: true, creatable: false, editable: false, inputType: 'lookup', isRequired: true, maxLen: -1, lookupSource: 'lists.entityTypes' },
                { field: 'FileExtension', type: 'text', displayLabel: 'RESOURCE_FILE_TYPES.FIELDS.FILE_EXTENSION', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: true, maxLen: -1 },
                { field: 'Entity', type: 'text', displayLabel: 'RESOURCE_FILE_TYPES.FIELDS.ENTITY', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: true, maxLen: -1 }
            ],
            title: 'RESOURCE_FILE_TYPES.NAV',
            icon: 'icon-tile-four',
            idField: 'ID',
            lookupDisplayField: 'FileExtension',
            methods: {
                getList: getResourceFileTypesTypesList
            },
            views: {
                mainList: {
                    columns: [ 'ID', 'CatalogEntityID', 'FileExtension', 'Entity'],
                    columnFilter: {},
                    topIndex: 0,
                    showFilterRow: false,
                    sortColumn   : {'CatalogEntityID': true},
                 }
            }
        };

        api.lists.resourceTypes = {
            modelPath: 'lists.resourceTypes',
            fields: [
                { field: 'Id', type: 'text', displayLabel: 'RESOURCE_TYPES.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: true, maxLen: -1 },
                { field: 'Type', type: 'text', displayLabel: 'RESOURCE_TYPES.FIELDS.TYPE', visible: true, creatable: true, editable: true, inputType: 'text', isRequired: true, maxLen: -1 },
                { field: 'AllowedFileTypes', type: 'text', displayLabel: 'RESOURCE_TYPES.FIELDS.ALLOWED_FILE_TYPES', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: true, maxLen: -1 },
                { field: 'Icon', type: 'text', displayLabel: 'RESOURCE_TYPES.FIELDS.ICON', visible: true, creatable: true, editable: true, inputType: 'icon', isRequired: true, maxLen: -1 },
                { field: 'VisibleInResourcesList', type: 'int', displayLabel: 'RESOURCE_TYPES.FIELDS.VISIBLE_IN_RESOURCE_LIST', visible: true, creatable: true, editable: true, inputType: 'bool-int', isRequired: true, maxLen: -1 },
                { field: 'CreatedBy', type: 'text', displayLabel: 'RESOURCE_TYPES.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedBy', type: 'text', displayLabel: 'RESOURCE_TYPES.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedDate', type: 'text', displayLabel: 'RESOURCE_TYPES.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedDate', type: 'text', displayLabel: 'RESOURCE_TYPES.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
            ],
            title: 'RESOURCE_TYPES.NAV',
            icon: 'icon-tile-four',
            idField: 'Id',
            lookupDisplayField: 'Type',
            isDirty: false,
            methods: {
                getList: getResourceTypesList,
                create : createResourceTypes,
                update : updateResourceTypes
            },
            views: {
                mainList: {
                    columns: ['Type', 'AllowedFileTypes', 'Icon', 'VisibleInResourcesList'],
                    columnFilter: {},
                    topIndex: 0,
                    showFilterRow: false,
                    sortColumn: {'UpdatedDate': false},
                    itemActions: [{ id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UpdateResourceType', disabled: 'false', visible: true}],
                    fabAction: {id: 'add', label: 'ACTIONS.ADD', icon: 'icon-plus', privilege: 'CreateResourceType', visible: true}
                 }
            }
        };

        api.lists.fileTypes = {
            modelPath: 'lists.fileTypes',
            fields: [
                { field: 'Id', type: 'text', displayLabel: 'FILE_TYPES.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: false, maxLen: -1 },
                { field: 'Name', type: 'text', displayLabel: 'FILE_TYPES.FIELDS.NAME', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: false, maxLen: -1 },
                { field: 'Description', type: 'text', displayLabel: 'FILE_TYPES.FIELDS.DESCRIPTION', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: false, maxLen: -1 },
                { field: 'Extension', type: 'text', displayLabel: 'FILE_TYPES.FIELDS.EXTENSION', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: false, maxLen: -1 }
            ],
            title: 'FILE_TYPES.NAV',
            icon: 'icon-tile-four',
            idField: 'Id',
            lookupDisplayField: 'Name',
            methods: {
                getList: getFileTypesList
            },
            views: {
                mainList: {
                    columns: [ 'Id', 'Name', 'Extension', 'Description'],
                    columnFilter: {},
                    topIndex: 0,
                    showFilterRow: false,
                    sortColumn   : {'Name': true},
                 }
            }
        };

        api.lists.sizeMap = {
            modelPath: 'lists.sizeMap',
            fields: [
                { field: 'Id', type: 'text', displayLabel: 'SIZE_MAP.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: false, maxLen: -1 },
                { field: 'Size', type: 'text', displayLabel: 'SIZE_MAP.FIELDS.SIZE', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: false, maxLen: -1 },
                { field: 'SizeIndex', type: 'text', displayLabel: 'SIZE_MAP.FIELDS.SIZE_INDEX', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: false, maxLen: -1 },
                { field: 'CreatedDate', type: 'text', displayLabel: 'SIZE_MAP.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date', isRequired: false, maxLen: -1 },
                { field: 'UpdatedDate', type: 'text', displayLabel: 'SIZE_MAP.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date', isRequired: false, maxLen: -1 },
                { field: 'CreatedBy', type: 'text', displayLabel: 'SIZE_MAP.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap', isRequired: false, maxLen: -1 },
                { field: 'UpdatedBy', type: 'text', displayLabel: 'SIZE_MAP.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap', isRequired: false, maxLen: -1 }
            ],
            title: 'SIZE_MAP.NAV',
            icon: 'icon-tile-four',
            idField: 'Id',
            lookupDisplayField: 'Size',
            methods: {
                getList: getSizeMapList
            },
            views: {
                mainList: {
                    columns: [ 'Size', 'SizeIndex', 'UpdatedDate'],
                    columnFilter: {},
                    topIndex: 0,
                    showFilterRow: false,
                    sortColumn   : {'SizeIndex': true},
                 }
            }
        };

        api.lists.userLogs = {
            modelPath: 'lists.userLogs',
            fields: [
                { field: 'Id', type: 'int', displayLabel: 'USER_LOGS.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number', isRequired: false, maxLen: -1 },
                { field: 'UserId', type: 'int', displayLabel: 'USER_LOGS.FIELDS.USER_ID', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: false, maxLen: -1 },
                { field: 'UserName', type: 'text', displayLabel: 'USER_LOGS.FIELDS.USER_NAME', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: false, maxLen: -1 },
                { field: 'LoginDatetime', type: 'date', displayLabel: 'USER_LOGS.FIELDS.LOGIN_DATE_TIME', visible: true, creatable: false, editable: false, inputType: 'date', isRequired: false, maxLen: -1 },
                { field: 'LoginIP', type: 'text', displayLabel: 'USER_LOGS.FIELDS.LOGIN_IP', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: false, maxLen: -1 },
                { field: 'LoginMachineName', type: 'text', displayLabel: 'USER_LOGS.FIELDS.LOGIN_MACHINE_NAME', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: false, maxLen: -1 },
                { field: 'BrowserType', type: 'text', displayLabel: 'USER_LOGS.FIELDS.BROWSER_TYPE', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: false, maxLen: -1 },
                { field: 'BrowserName', type: 'text', displayLabel: 'USER_LOGS.FIELDS.BROWSER_NAME', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: false, maxLen: -1 },
                { field: 'BrowserVersion', type: 'text', displayLabel: 'USER_LOGS.FIELDS.BROWSER_VERSION', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: false, maxLen: -1 },
                { field: 'OS', type: 'text', displayLabel: 'USER_LOGS.FIELDS.OS', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: false, maxLen: -1 },
            ],
            title: 'USER_LOGS.NAV',
            icon: 'icon-tile-four',
            idField: 'Id',
            lookupDisplayField: 'UserName',
            methods: {
                getList: getUserLogsList
            },
            views: {
                mainList: {
                    columns: [ 'UserName', 'LoginDatetime', 'LoginIP'],
                    columnFilter: {},
                    topIndex: 0,
                    showFilterRow: false,
                    sortColumn   : {'LoginDatetime': false},
                 }
            }
        };

        api.lists.duneContext = {
            modelPath: 'lists.duneContext',
            fields: [
                { field: 'Id', type: 'text', displayLabel: 'DUNE_CONTEXT.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: true, maxLen: 250, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Name', type: 'text', displayLabel: 'DUNE_CONTEXT.FIELDS.NAME', visible: true, creatable: true, editable: true, inputType: 'text', checkIfUnique: true,
                    validation: {isRequired: true, maxLen: 250, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ReadKey', type: 'text', displayLabel: 'DUNE_CONTEXT.FIELDS.READ_KEY', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: true, maxLen: 250, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'WriteKey', type: 'text', displayLabel: 'DUNE_CONTEXT.FIELDS.WRITE_KEY', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: true, maxLen: 250, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Status', type: 'text', displayLabel: 'DUNE_CONTEXT.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'bool',
                    validation: {isRequired: true, maxLen: 250, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}}  },
                { field: 'CreatedOn', type: 'text', displayLabel: 'DUNE_CONTEXT.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: true, maxLen: 250, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedOn', type: 'text', displayLabel: 'DUNE_CONTEXT.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: true, maxLen: 250, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedBy', type: 'text', displayLabel: 'DUNE_CONTEXT.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: true, maxLen: 250, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedBy', type: 'text', displayLabel: 'DUNE_CONTEXT.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: true, maxLen: 250, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
            ],
            title: 'DUNE_CONTEXT.NAV',
            icon: 'icon-tile-four',
            idField: 'Id',
            lookupDisplayField: 'Name',
            methods: {
                getList: getDuneContext,
                create : createDuneContext,
                update : updateDuneContext,
                activate: activateDuneContext
            },
            views: {
                mainList: {
                    columns: [ 'Id', 'Name', 'ReadKey', 'WriteKey', 'Status', 'UpdatedOn', 'UpdatedDate' ],
                    columnFilter: {},
                    topIndex: 0,
                    showFilterRow: false,
                    sortColumn   : {'UpdatedOn': false},
                    itemActions  : [
                        { id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'nav_dune_context', disabled: '!itm.Status', visible: true},
                        { id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'nav_dune_context', disabled: false, visible: 'itm.Status',
                            requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                        { id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'nav_dune_context', disabled: false, visible: '!itm.Status',
                            requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
                    ],
                    listActions  : [
                        // obsolete
                        // { id: 'delete', label: 'ACTIONS.DELETE_BULK', icon: 'icon-delete', privilege: 'nav_dune_context', disabled: '{selected: true, Status: 1}', visible: true,
                        // requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                        // { id: 'activate', label: 'ACTIONS.ACTIVATE_BULK', icon: 'icon-undo-variant', privilege: 'nav_dune_context', disabled: '{selected: true, Status: 0}', visible: true,
                        // requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
                    ],
                    fabAction: {id: 'add', label: 'ACTIONS.ADD', icon: 'icon-plus', privilege: 'nav_dune_context', visible: true}
                 },
                 privileges: {
                     list    : 'nav_dune_context'
                 }
            }
        };

        api.lists.notificationTypes = {
            modelPath: 'lists.notificationTypes',
            fields: [
                { field: 'Id', type: 'text', displayLabel: 'NOTIFICATION_TYPES.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: true, maxLen: 250, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Type', type: 'text', displayLabel: 'NOTIFICATION_TYPES.FIELDS.TYPE', visible: true, creatable: true, editable: true, inputType: 'text',
                    validation: {isRequired: true, maxLen: 250, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'AutoSubscribe', type: 'text', displayLabel: 'NOTIFICATION_TYPES.FIELDS.AUTOSUBSCRIBE', visible: true, creatable: false, editable: false, inputType: 'status',
                    validation: {isRequired: true, maxLen: 250, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
            ],
            title: 'NOTIFICATION_TYPES.NAV',
            icon: 'icon-tile-four',
            idField: 'Id',
            lookupDisplayField: 'Type',
            methods: {
                getList: getNotificationTypes,
                UpdateNotificationTypeAutosubscribe : UpdateNotificationTypeAutosubscribeStatus
            },
            views: {
                mainList: {
                    columns: [ 'Id', 'Type', 'AutoSubscribe'],
                    columnFilter: {},
                    topIndex: 0,
                    showFilterRow: false,
                    sortColumn   : {},
                    itemActions  : [
                        { id: 'unsubscribe', label: 'ACTIONS.UNSUBSCRIBE', icon: 'icon-thumb-down', privilege: 'BulkSubscribeNotifications', disabled: false, visible: 'itm.AutoSubscribe',
                            requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_UNSUBSCRIBE'}, confirmationAction: 'ACTIONS.UNSUBSCRIBE'},
                        { id: 'subscribe', label: 'ACTIONS.SUBSCRIBE', icon: 'icon-thumb-up', privilege: 'BulkSubscribeNotifications', disabled: false, visible: '!itm.AutoSubscribe',
                            requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_SUBSCRIBE'}, confirmationAction: 'ACTIONS.SUBSCRIBE'}
                    ],
                    listActions  : [
                        { id: 'unsubscribe', label: 'ACTIONS.UNSUBSCRIBE_BULK', icon: 'icon-thumb-down', privilege: 'BulkSubscribeNotifications', disabled: '{selected: true, AutoSubscribe: 1}', visible: true,
                        requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_UNSUBSCRIBE'}, confirmationAction: 'ACTIONS.UNSUBSCRIBE'},
                        { id: 'subscribe', label: 'ACTIONS.SUBSCRIBE_BULK', icon: 'icon-thumb-up', privilege: 'BulkSubscribeNotifications', disabled: '{selected: true, AutoSubscribe: 0}', visible: true,
                        requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_SUBSCRIBE'}, confirmationAction: 'ACTIONS.SUBSCRIBE'}
                    ],
                    fabAction: {}
                 },
                 privileges: {
                     list    : 'GetNotificationTypes'
                 }
            }
        };


        api.lists.licenseTypes = {
            modelPath: 'lists.licenseTypes',
            fields: [
                { field: 'Id', type: 'text', displayLabel: 'LICENSE_TYPES.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'text'},
                { field: 'Name', type: 'text', displayLabel: 'LICENSE_TYPES.FIELDS.NAME', visible: true, creatable: true, editable: true, inputType: 'text', checkIfUnique: true, 
                    validation: {isRequired: true, maxLen: 500, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedBy', type: 'text', displayLabel: 'LICENSE_TYPES.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap' },
                { field: 'CreatedDate', type: 'text', displayLabel: 'LICENSE_TYPES.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: true, maxLen: 250, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedBy', type: 'text', displayLabel: 'LICENSE_TYPES.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap' },
                { field: 'UpdatedDate', type: 'text', displayLabel: 'LICENSE_TYPES.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: true, maxLen: 250, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
            ],
            title: 'LICENSE_TYPES.NAV',
            icon: 'icon-tile-four',
            idField: 'Id',
            lookupDisplayField: 'Name',
            methods: {
                getList: getLicenseTypes,
                create : createLicenseType,
                update : updateLicenseType,
            },
            views: {
                mainList: {
                    columns: ['Id', 'Name', 'CreatedBy', 'CreatedDate', 'UpdatedBy', 'UpdatedDate'],
                    columnFilter: {},
                    topIndex: 0,
                    showFilterRow: false,
                    sortColumn   : {'UpdatedDate': false},
                    itemActions  : [
                        { id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UpdateLicenseType', disabled: false, visible: true},
                    ],
                    listActions  : [],
                    fabAction: {id: 'add', label: 'ACTIONS.ADD', icon: 'icon-plus', privilege: 'CreateLicenseType', visible: true}
                 },
                 privileges: {
                     list    : 'GetLicenseTypes'
                 }
            }
        };


        //TODO: temporary until we develop VAS module
        api.lists.VAS = {
            modelPath: 'lists.VAS',
            fields: [
                { field: 'Id', type: 'text', displayLabel: 'DATA_SOURCE_TYPES.FIELDS.ID', visible: false, creatable: true, editable: true, inputType: 'text', isRequired: true, maxLen: -1 },
                { field: 'Name', type: 'text', displayLabel: 'CURRENCIES.FIELDS.NAME', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: true, maxLen: -1 }
            ],
            idField: 'Id',
            lookupDisplayField: 'Name',
            methods: {
                getList: getVAS
            }
        };

        api.lists.processingQueues = {
            modelPath: 'lists.processingQueues',
            fields: [
                { field: 'Id', type: 'text', displayLabel: 'DATA_SOURCE_TYPES.FIELDS.ID', visible: false, creatable: true, editable: true, inputType: 'text', isRequired: true, maxLen: -1 },
                { field: 'Name', type: 'text', displayLabel: 'CURRENCIES.FIELDS.NAME', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: true, maxLen: -1 }
            ],
            idField: 'Id',
            lookupDisplayField: 'Name',
            methods: {
                getList: getProcessingQueues
            }
        }

        api.lists.loginTypes = {
            modelPath: 'lists.loginTypes',
            fields: [
                { field: 'Id', type: 'text', displayLabel: 'GENERAL.ID', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: false, maxLen: -1 },
                { field: 'Value', type: 'text', displayLabel: 'GENERAL.VALUE', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: false, maxLen: -1 }
            ],
            idField: 'Id',
            lookupDisplayField: 'Value',
            methods: {
                getList: getLoginTypes
            }
        }

        api.lists.AuthLoginTypes = {
            modelPath: 'lists.AuthLoginTypes',
            fields: [
                { field: 'Id', type: 'text', displayLabel: 'GENERAL.ID', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: false, maxLen: -1 },
                { field: 'Value', type: 'text', displayLabel: 'GENERAL.VALUE', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: false, maxLen: -1 }
            ],
            idField: 'Id',
            lookupDisplayField: 'Value',
            methods: {
                getList: getAuthLoginTypes
            }
        }

        api.lists.AuthUserTypes = {
            modelPath: 'lists.AuthUserTypes',
            fields: [
                { field: 'Id', type: 'text', displayLabel: 'GENERAL.ID', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: false, maxLen: -1 },
                { field: 'Value', type: 'text', displayLabel: 'GENERAL.VALUE', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: false, maxLen: -1 }
            ],
            idField: 'Id',
            lookupDisplayField: 'Value',
            methods: {
                getList: getAuthUserTypes
            }
        }

        api.lists.reasonTypes = {
            modelPath: 'lists.reasonTypes',
            fields: [
                { field: 'Id', type: 'text', displayLabel: 'GENERAL.ID', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: false, maxLen: -1 },
                { field: 'Value', type: 'text', displayLabel: 'GENERAL.VALUE', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: false, maxLen: -1 }
            ],
            idField: 'Id',
            lookupDisplayField: 'Value',
            methods: {
                getList: getReasonTypes
            }
        }

        api.lists.RequestStates = {
            modelPath: 'lists.RequestStates',
            fields: [
                { field: 'Id', type: 'text', displayLabel: 'GENERAL.ID', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: false, maxLen: -1 },
                { field: 'Value', type: 'text', displayLabel: 'GENERAL.VALUE', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: false, maxLen: -1 }
            ],
            idField: 'Id',
            lookupDisplayField: 'Value',
            methods: {
                getList: getRequestStates
            }
        }

        api.lists.RequestTypes = {
            modelPath: 'lists.RequestTypes',
            fields: [
                { field: 'Id', type: 'text', displayLabel: 'GENERAL.ID', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: false, maxLen: -1 },
                { field: 'Value', type: 'text', displayLabel: 'GENERAL.VALUE', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: false, maxLen: -1 }
            ],
            idField: 'Id',
            lookupDisplayField: 'Value',
            methods: {
                getList: getRequestTypes
            }
        }

        api.lists.catalogVisibilities = {
            modelPath: 'lists.catalogVisibilities',
            fields: [
                { field: 'Id', type: 'text', displayLabel: 'GENERAL.ID', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: false, maxLen: -1 },
                { field: 'Value', type: 'text', displayLabel: 'GENERAL.VALUE', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: false, maxLen: -1 }
            ],
            idField: 'Id',
            lookupDisplayField: 'Value',
            methods: {
                getList: getCatalogVisibilities
            }
        }

        api.lists.catalogCollectionTypes = {
            modelPath: 'lists.catalogCollectionTypes',
            fields: [
                { field: 'Id', type: 'text', displayLabel: 'GENERAL.ID', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: false, maxLen: -1 },
                { field: 'Value', type: 'text', displayLabel: 'GENERAL.VALUE', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: false, maxLen: -1 }
            ],
            idField: 'Id',
            lookupDisplayField: 'Value',
            methods: {
                getList: getCatalogCollectionTypes
            }
        }

        api.lists.articleChangeTypes = {
            modelPath: 'lists.articleChangeTypes',
            fields: [
                { field: 'Id', type: 'text', displayLabel: 'GENERAL.ID', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: false, maxLen: -1 },
                { field: 'Value', type: 'text', displayLabel: 'GENERAL.VALUE', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: false, maxLen: -1 }
            ],
            idField: 'Id',
            lookupDisplayField: 'Value',
            methods: {
                getList: getArticleChangeTypes
            }
        }

        // users who have access to the current catalog
        api.lists.usersWithCatalogAccess = {
            modelPath: 'lists.usersWithCatalogAccess',
            fields: [
                { field: 'Id', type: 'text', displayLabel: 'GENERAL.ID', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: false, maxLen: -1 },
                { field: 'UserName', type: 'text', displayLabel: 'GENERAL.VALUE', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: false, maxLen: -1 },
                { field: 'AccountName', type: 'text', displayLabel: 'GENERAL.VALUE', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: false, maxLen: -1 },
                { field: 'UserNameWithAccount', type: 'text', displayLabel: 'GENERAL.VALUE', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: false, maxLen: -1 }
            ],
            idField: 'Id',
            lookupDisplayField: 'UserNameWithAccount',
            methods: {
                getList: getUsersWithCatalogAccess
            }
        };

        // available seasonless article attributes that can be assigned to a seller
        api.lists.availableSeasonlessAttributeList = {
            modelPath: 'lists.availableSeasonlessAttributeList',
            fields: [
                { field: 'Attributeid', type: 'text', displayLabel: 'GENERAL.ID', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: false, maxLen: -1 },
                { field: 'AttributeSystemName', type: 'text', displayLabel: 'GENERAL.VALUE', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: false, maxLen: -1 },
                { field: 'AttributeDisplayName', type: 'text', displayLabel: 'GENERAL.VALUE', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: false, maxLen: -1 },
            ],
            idField: 'Attributeid',
            lookupDisplayField: 'AttributeDisplayName',
            methods: {
                getList: getAvailableSeasonlessAttributeList
            }
        };

        // catalog request reasons module
        api.lists.requestReasonsTypes = {
            modelPath: 'lists.requestReasonsTypes',
            fields: [
                { field: 'Id', type: 'text', displayLabel: 'GENERAL.ID', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: false, maxLen: -1 },
                { field: 'Value', type: 'text', displayLabel: 'GENERAL.VALUE', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: false, maxLen: -1 }
            ],
            idField: 'Id',
            lookupDisplayField: 'Value',
            methods: {
                getList: getRequestReasonTypes
            }
        }

        // available seasonless model attributes that can be assigned to a seller
        api.lists.availableSeasonlessModelAttributeList = {
            modelPath: 'lists.availableSeasonlessModelAttributeList',
            fields: [
                { field: 'Attributeid', type: 'text', displayLabel: 'GENERAL.ID', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: false, maxLen: -1 },
                { field: 'AttributeSystemName', type: 'text', displayLabel: 'GENERAL.VALUE', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: false, maxLen: -1 },
                { field: 'AttributeDisplayName', type: 'text', displayLabel: 'GENERAL.VALUE', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: false, maxLen: -1 },
            ],
            idField: 'Attributeid',
            lookupDisplayField: 'AttributeDisplayName',
            methods: {
                getList: getAvailableSeasonlessModelAttributeList
            }
        };

        // shared folders entity list
        api.lists.entityList = {
            modelPath: 'lists.entityList',
            fields: [
                { field: 'Id', type: 'text', displayLabel: 'GENERAL.ID', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: false, maxLen: -1 },
                { field: 'Value', type: 'text', displayLabel: 'GENERAL.VALUE', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: false, maxLen: -1 }
            ],
            idField: 'Id',
            lookupDisplayField: 'Value',
            methods: {
                getList: getEntityList
            }
        }

        // relations entity list
        api.lists.relationsEntityList = {
            modelPath: 'lists.relationsEntityList',
            fields: [
                { field: 'Id', type: 'text', displayLabel: 'GENERAL.ID', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: false, maxLen: -1 },
                { field: 'Value', type: 'text', displayLabel: 'GENERAL.VALUE', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: false, maxLen: -1 }
            ],
            idField: 'Id',
            lookupDisplayField: 'Value',
            methods: {
                getList: getRelationsEntityList
            }
        }

        // get available catalog models for assigning to catalog
        api.lists.availableCatalogModelList = {
            modelPath: 'lists.availableCatalogModelList',
            fields: [
                { field: 'ModelId', type: 'text', displayLabel: 'GENERAL.ID', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: false, maxLen: -1 },
                { field: 'ModelNumber', type: 'text', displayLabel: 'GENERAL.VALUE', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: false, maxLen: -1 },
                { field: 'SizeScaleId', type: 'text', displayLabel: 'GENERAL.VALUE', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: false, maxLen: -1 }
            ],
            idField: 'ModelId',
            lookupDisplayField: 'ModelNumber',
            methods: {
                getList: getAvailableCatalogModelList
            }
        };

        // get available catalog models articles list
        api.lists.availableCatalogModelArticles = {
            modelPath: 'lists.availableCatalogModelArticles',
            fields: [
                { field: 'Id', type: 'text', displayLabel: 'GENERAL.ID', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: false, maxLen: -1 },
                { field: 'ArticleNumber', type: 'text', displayLabel: 'GENERAL.VALUE', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: false, maxLen: -1 },
            ],
            idField: 'Id',
            lookupDisplayField: 'ArticleNumber',
            methods: {
                getList: getAvailableCatalogModelArticlesList
            }
        };

        // accessibleUsers list for shared folder module
        api.lists.accessibleUsers = {
            modelPath: 'lists.accessibleUsers',
            fields: [
                { field: 'Id', type: 'text', displayLabel: 'GENERAL.ID', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: false, maxLen: -1 },
                { field: 'UserName', type: 'text', displayLabel: 'GENERAL.VALUE', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: false, maxLen: -1 },
                { field: 'AccountName', type: 'text', displayLabel: 'GENERAL.VALUE', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: false, maxLen: -1 },
                { field: 'UserNameWithAccount', type: 'text', displayLabel: 'GENERAL.VALUE', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: false, maxLen: -1 }
            ],
            idField: 'Id',
            lookupDisplayField: 'UserNameWithAccount',
            methods: {
                getList: getAccessibleUsers
            }
        };

        // linked catalog articles
        api.lists.linkedCatalogArticles = {
            modelPath: 'lists.linkedCatalogArticles',
            fields: [
                { field: 'Id', type: 'text', displayLabel: 'GENERAL.ID', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: false, maxLen: -1 },
                { field: 'ArticleNumber', type: 'text', displayLabel: 'GENERAL.VALUE', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: false, maxLen: -1 },
            ],
            idField: 'Id',
            lookupDisplayField: 'ArticleNumber',
            methods: {
                getList: getLinkedCatalogArticles
            }
        };

        // get catalog model list
        api.lists.catalogModelList = {
            modelPath: 'lists.catalogModelList',
            fields: [
                { field: 'ModelId', type: 'text', displayLabel: 'GENERAL.ID', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: false, maxLen: -1 },
                { field: 'ModelNumber', type: 'text', displayLabel: 'GENERAL.VALUE', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: false, maxLen: -1 },
            ],
            idField: 'ModelId',
            lookupDisplayField: 'ModelNumber',
            methods: {
                getList: getCatalogModelList
            }
        };

        // Get available articles from models/assigned
        api.lists.availableArticlesFromModel = {
            modelPath: 'lists.availableArticlesFromModel',
            fields: [
                { field: 'ArticleId', type: 'text', displayLabel: 'GENERAL.ID', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: false, maxLen: -1 },
                { field: 'ArticleNumber', type: 'text', displayLabel: 'GENERAL.VALUE', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: false, maxLen: -1 },
            ],
            idField: 'ArticleId',
            lookupDisplayField: 'ArticleNumber',
            methods: {
                getList: getAvailableArticlesFromModel
            }
        }


        api.lists.userGroupsCriteria = {
            modelPath: 'lists.userGroupsCriteria',
            fields: [
                { field: 'Id', type: 'text', displayLabel: 'GENERAL.ID', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: false, maxLen: -1 },
                { field: 'Value', type: 'text', displayLabel: 'GENERAL.VALUE', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: false, maxLen: -1 }
            ],
            idField: 'Id',
            lookupDisplayField: 'Value',
            methods: {
                getList: getUserGroupsCriteria
            }
        }


        api.lists.userGroupsActions = {
            modelPath: 'lists.userGroupsActions',
            fields: [
                { field: 'Id', type: 'text', displayLabel: 'GENERAL.ID', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: false, maxLen: -1 },
                { field: 'Value', type: 'text', displayLabel: 'GENERAL.VALUE', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: false, maxLen: -1 }
            ],
            idField: 'Id',
            lookupDisplayField: 'Value',
            methods: {
                getList: getUserGroupsActions
            }
        }


        // Get list of available sizescale on Catalog model
        // obselute
        // api.lists.availableSizeScaleForCatalog = {
        //   modelPath: 'lists.availableSizeScaleForCatalog',
        //   fields: [
        //       { field: 'Id', type: 'text', displayLabel: 'GENERAL.ID', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: false, maxLen: -1 },
        //       { field: 'SizeScale', type: 'text', displayLabel: 'GENERAL.VALUE', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: false, maxLen: -1 },
        //   ],
        //   idField: 'Id',
        //   lookupDisplayField: 'SizeScale',
        //   methods: {
        //       getList: getAvailableSizeScaleForCatalog
        //   }
        // }

        // Get list of seasonless model/article level attributes
        // we dont have single api to get the list so will combine two API's
        api.lists.seasonlessModelAndArticleLevelAttributesList = {
            modelPath: 'lists.seasonlessModelAndArticleLevelAttributesList',
            fields: [
                { field: 'Attributeid', type: 'text', displayLabel: 'GENERAL.ID', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: false, maxLen: -1 },
                { field: 'AttributeDisplayName', type: 'text', displayLabel: 'GENERAL.VALUE', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: false, maxLen: -1 },
                { field: 'AttributeGroupId', type: 'int', displayLabel: 'SEASONLESS_MODEL_ATTRIBUTES.FIELDS.ATTRIBUTE_GROUP_NAME', visible: true, creatable: true, editable: false, inputType: 'number'},
                { field: 'AttributeTypeId', type: 'int', displayLabel: 'SEASONLESS_ARTICLE_ATTRIBUTES.FIELDS.ATTRIBUTE_TYPE_ID', visible: true, creatable: false, editable: false, inputType: 'number'},
            ],
            idField: 'Attributeid',
            lookupDisplayField: 'AttributeDisplayName',
            methods: {
                getList: getSeasonlessModelAndArticleLevelAttributesList
            }
        }

        // Get list of available sizescale for seller
        api.lists.availableSizeScaleForModel = {
            modelPath: 'lists.availableSizeScaleForModel',
            fields: [
                { field: 'Id', type: 'text', displayLabel: 'GENERAL.ID', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: false, maxLen: -1 },
                { field: 'SizeScale', type: 'text', displayLabel: 'GENERAL.VALUE', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: false, maxLen: -1 },
            ],
            idField: 'Id',
            lookupDisplayField: 'SizeScale',
            methods: {
                getList: getAvailableSizeScaleForModel
            }
        }

        // current catalog retail windows
        api.lists.retailWindows = {
            modelPath: 'lists.retailWindows',
            fields: [
                { field: 'Id', type: 'text', displayLabel: 'GENERAL.ID', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: false, maxLen: -1 },
                { field: 'Value', type: 'text', displayLabel: 'GENERAL.VALUE', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: false, maxLen: -1 }
            ],
            idField: 'Id',
            lookupDisplayField: 'Value',
            methods: {
                getList: getCatalogRetailWindows
            }
        }

        // get all the attribute(seasonless article/model and seasonal attributes) from an attribute group
        api.lists.allAttributesFromAGroup = {
            modelPath: 'lists.allAttributesFromAGroup',
            fields: [
                { field: 'Id', type: 'text', displayLabel: 'GENERAL.ID', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: false, maxLen: -1 },
                { field: 'Value', type: 'text', displayLabel: 'GENERAL.VALUE', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: false, maxLen: -1 }
            ],
            idField: 'Id',
            lookupDisplayField: 'Value',
            methods: {
                getList: getAllAttributesFromAGroup
            }
        }

        // get list of seller models without attribute for the model number attribute types
        api.lists.sellerModelsWithoutAttributes = {
            modelPath: 'lists.sellerModelsWithoutAttributes',
            fields: [
                { field: 'ModelId', type: 'text', displayLabel: 'GENERAL.ID', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: false, maxLen: -1 },
                { field: 'ModelNumber', type: 'text', displayLabel: 'GENERAL.VALUE', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: false, maxLen: -1 },
            ],
            idField: 'ModelId',
            lookupDisplayField: 'ModelNumber',
            methods: {
                getList: getSellerModelsWithoutAttributes
            }
        };

        // get list of seller models lis for lookup
        api.lists.sellerModelsListForLookup = {
            modelPath: 'lists.sellerModelsListForLookup',
            fields: [
                { field: 'ModelId', type: 'text', displayLabel: 'GENERAL.ID', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: false, maxLen: -1 },
                { field: 'ModelNumber', type: 'text', displayLabel: 'GENERAL.VALUE', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: false, maxLen: -1 },
                { field: 'ModelName', type: 'text', displayLabel: 'GENERAL.VALUE', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: false, maxLen: -1 }
            ],
            idField: 'ModelId',
            lookupDisplayField: 'ModelNumber',
            methods: {
                getList: getSellerModelsListForLookup
            }
        };

        // get listseller colors from colorpalette
        api.lists.sellerColorsFromColorPalette = {
            modelPath: 'lists.sellerColorsFromColorPalette',
            fields: [
                { field: 'ColorId', type: 'text', displayLabel: 'GENERAL.ID', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: false, maxLen: -1 },
                { field: 'ColorName', type: 'text', displayLabel: 'GENERAL.VALUE', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: false, maxLen: -1 },
                { field: 'ColorTypeName', type: 'text', displayLabel: 'GENERAL.VALUE', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: false, maxLen: -1 },
                { field: 'ColorCriteria', type: 'text', displayLabel: 'GENERAL.VALUE', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: false, maxLen: -1 }
            ],
            idField: 'ColorId',
            lookupDisplayField: 'ColorName',
            methods: {
                getList: getSellerColorsFromColorPalette
            }
        };

        api.lists.ColorTypes = {
            modelPath: 'lists.ColorTypes',
            fields: [
                { field: 'Id', type: 'text', displayLabel: 'GENERAL.ID', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: false, maxLen: -1 },
                { field: 'Value', type: 'text', displayLabel: 'GENERAL.VALUE', visible: true, creatable: false, editable: false, inputType: 'text', isRequired: false, maxLen: -1 }
            ],
            idField: 'Id',
            lookupDisplayField: 'Value',
            methods: {
                getList: getColorTypes
            }
        }

        function getVAS(generalProperties, sellerId){
            var promise;

            if(angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
                var state = {};
                state.name = $state.current.name;
                state.params = $state.params;
                var isBulk = false;
                var logData = activityLogger.createLogData(null, state, 'lists.VAS', 'VIEW', isBulk, new Date(), null, null);
                promise = api.webGet(api.baseUrl + '/sellers/' + sellerId + '/vas', undefined, true, generalProperties.forceFetch);
                promise = activityLogger.log(logData, promise);
            }
            else {
                return api.webGet(api.baseUrl + '/sellers/' + catalogFactory.getActiveCatalog().AccountId + '/vas', undefined, true, generalProperties.forceFetch);
            }
            return promise;
        }


        function getAccountTypesList(generalProperties) {
            var promise;
            if (generalProperties.forceFetch) {
                api.lists.accountTypes.lookupData = undefined;
            }

            if(angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
                var state = {};
                state.name = $state.current.name;
                state.params = $state.params;
                var isBulk = false;
                var logData = activityLogger.createLogData(null, state, 'lists.accountTypes', 'VIEW', isBulk, new Date(), null, null);
                promise = api.webGet(api.baseUrl + '/accountTypes', undefined, true, generalProperties.forceFetch);
                promise = activityLogger.log(logData, promise);
            }
            else {
                promise = api.webGet(api.baseUrl + '/accountTypes', undefined, true, generalProperties.forceFetch);
            }
            return promise;
		}

        function getAttributeTypeList(generalProperties) {
            var promise;
            if (generalProperties.forceFetch) {
                api.lists.attributeTypes.lookupData = undefined;
            }

            if(angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
                var state = {};
                state.name = $state.current.name;
                state.params = $state.params;
                var isBulk = false;
                var logData = activityLogger.createLogData(null, state, 'lists.attributeTypes', 'VIEW', isBulk, new Date(), null, null);
                promise = api.webGet(api.baseUrl + '/attributeTypes', undefined, true, generalProperties.forceFetch);
                promise = activityLogger.log(logData, promise);
            }
            else{
                promise = api.webGet(api.baseUrl + '/attributeTypes', undefined, true, generalProperties.forceFetch);
            }

            return promise;
        }

        function getClientList(generalProperties) {
            var promise;
            if (generalProperties.forceFetch) {
                api.lists.clients.lookupData = undefined;
            }
            if(angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
                var state = {};
                state.name = $state.current.name;
                state.params = $state.params;
                var isBulk = false;
                var logData = activityLogger.createLogData(null, state, 'lists.clients', 'VIEW', isBulk, new Date(), null, null);
                promise = api.webGet($localStorage.authBaseUrl + '/clients', undefined, true, generalProperties.forceFetch);
                promise = activityLogger.log(logData, promise);
            }
            else {
                promise = api.webGet($localStorage.authBaseUrl + '/clients', undefined, true, generalProperties.forceFetch);
            }
            return promise;
        }

        function getEnvironmentList(generalProperties) {
            var promise;
            if (generalProperties.forceFetch) {
                api.lists.environments.lookupData = undefined;
            }

            if(angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
                var state = {};
                state.name = $state.current.name;
                state.params = $state.params;
                var isBulk = false;
                var logData = activityLogger.createLogData(null, state, 'lists.environments', 'VIEW', isBulk, new Date(), null, null);
                promise = api.webGet($localStorage.authBaseUrl + '/environments', undefined, true, generalProperties.forceFetch);
                promise = activityLogger.log(logData, promise);
            }
            else{
                promise = api.webGet($localStorage.authBaseUrl + '/environments', undefined, true, generalProperties.forceFetch);
            }
            return promise;
        }

        function getConfigurationsList(generalProperties) {
            var promise;
            if (generalProperties.forceFetch) {
                api.lists.configurations.lookupData = undefined;
            }

            if(angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
                var state = {};
                state.name = $state.current.name;
                state.params = $state.params;
                var isBulk = false;
                var logData = activityLogger.createLogData(null, state, 'lists.configurations', 'VIEW', isBulk, new Date(), null, null);
                promise = api.webGet(api.baseUrl + '/configurations', undefined, true, generalProperties.forceFetch);
                promise = activityLogger.log(logData, promise);
            }
            else {
                promise = api.webGet(api.baseUrl + '/configurations', undefined, true, generalProperties.forceFetch);
            }
            return promise;
		}

        function createConfiguration(config) {
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var logData = activityLogger.createLogData(config[api.lists.configurations.lookupDisplayField], state, 'lists.configurations', 'ADD', false, new Date(), null, null);
            var promise = api.webPost(api.baseUrl + '/configurations', config);

            promise.then(function() {
               api.lists.configurations.isDirty = true;
            });
            return activityLogger.log(logData, promise);
        }

        function removeConfiguration(config) {
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var logData = activityLogger.createLogData(config[api.lists.configurations.lookupDisplayField], state, 'lists.configurations', 'DELETE', false, new Date(), null, null);
            var promise = api.webDelete(api.baseUrl + '/configurations/' + config[api.lists.configurations.idField]);

            promise.then(function() {
               api.lists.configurations.isDirty = true;
            });
            return activityLogger.log(logData, promise);
        }

        function getConsolidationStatuses(generalProperties) {
            var promise;
            if (generalProperties.forceFetch) {
                api.lists.consolidationStatuses.lookupData = undefined;
            }
            if(angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
                var state = {};
                state.name = $state.current.name;
                state.params = $state.params;
                var isBulk = false;
                var logData = activityLogger.createLogData(null, state, 'lists.consolidationStatuses', 'VIEW', isBulk, new Date(), null, null);
                promise = api.webGet(api.baseUrl + '/consolidationStatuses', undefined, true, generalProperties.forceFetch);
                promise = activityLogger.log(logData, promise);
            }
            else {
                promise = api.webGet(api.baseUrl + '/consolidationStatuses', undefined, true, generalProperties.forceFetch);
            }
            return promise;
		}

		function getCountriesList(generalProperties) {
            var promise;
            if (generalProperties.forceFetch) {
                api.lists.countries.lookupData = undefined;
            }

            if(angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
                var state = {};
                state.name = $state.current.name;
                state.params = $state.params;
                var isBulk = false;
                var logData = activityLogger.createLogData(null, state, 'lists.countries', 'VIEW', isBulk, new Date(), null, null);
                promise = api.webGet(api.baseUrl + '/countries', undefined, true, generalProperties.forceFetch);
                promise = activityLogger.log(logData, promise);
            }
            else {
                promise = api.webGet(api.baseUrl + '/countries', undefined, true, generalProperties.forceFetch);
            }
            return promise;
		}

        function getCurrenciesList(generalProperties) {
            var promise;
            if (generalProperties.forceFetch) {
                api.lists.currencies.lookupData = undefined;
            }

            if(angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
                var state = {};
                state.name = $state.current.name;
                state.params = $state.params;
                var isBulk = false;
                var logData = activityLogger.createLogData(null, state, 'lists.currencies', 'VIEW', isBulk, new Date(), null, null);
                promise = api.webGet(api.baseUrl + '/currencies', undefined, true, generalProperties.forceFetch);
                return activityLogger.log(logData, promise);
            }
            else {
                promise = api.webGet(api.baseUrl + '/currencies', undefined, true, generalProperties.forceFetch);
            }
            return promise;
		}

        function getDataSourceTypesList(generalProperties) {
            var promise;
            if (generalProperties.forceFetch) {
                api.lists.dataSourceTypes.lookupData = undefined;
            }

            if(angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
                var state = {};
                state.name = $state.current.name;
                state.params = $state.params;
                var isBulk = false;
                var logData = activityLogger.createLogData(null, state, 'lists.dataSourceTypes', 'VIEW', isBulk, new Date(), null, null);
                promise = api.webGet(api.baseUrl + '/datasourcetypes', undefined, true, generalProperties.forceFetch);
                promise = activityLogger.log(logData, promise);
            }
            else {
                promise = api.webGet(api.baseUrl + '/datasourcetypes', undefined, true, generalProperties.forceFetch);
            }
            return promise;
		}

        function getEntityTypesList(generalProperties) {
            var promise;
            if (generalProperties.forceFetch) {
                api.lists.entityTypes.lookupData = undefined;
            }

            if(angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
                var state = {};
                state.name = $state.current.name;
                state.params = $state.params;
                var isBulk = false;
                var logData = activityLogger.createLogData(null, state, 'lists.entityTypes', 'VIEW', isBulk, new Date(), null, null);
                promise = api.webGet(api.baseUrl + '/entityTypes', undefined, true, generalProperties.forceFetch);
                promise = activityLogger.log(logData, promise);
            }
            else {
                promise = api.webGet(api.baseUrl + '/entityTypes', undefined, true, generalProperties.forceFetch);
            }
            return promise;
        }

        //ToDo: All functions for privacyPolicies

        function getPrivacyPoliciesList(generalProperties) {
            var promise;
            if (generalProperties.forceFetch) {
                api.lists.privacyPolicy.lookupData = undefined;
            }

            if (angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
                var state = {};
                state.name = $state.current.name;
                state.params = $state.params;
                var isBulk = true;
                var logData = activityLogger.createLogData(null, state, 'lists.privacyPolicy', 'VIEW', isBulk, new Date(), null, null);
                promise = api.webGet(api.baseUrl + '/privacypolicies', undefined, true, generalProperties.forceFetch);
                promise = activityLogger.log(logData, promise);
            }
            else {
                promise = api.webGet(api.baseUrl + '/privacypolicies', undefined, true, generalProperties.forceFetch);
            }

            promise.then(function () {
                if (api.lists.privacyPolicy.isDirty) {
                    //Invalidate lookupData
                    api.lists.privacyPolicy.lookupData = undefined;
                    api.lists.privacyPolicy.isDirty = false;
                }
            });
            return promise;
        }

        function getPrivacyPolicyDetails(isLogRequired, Id) {
            var promise;
            if (angular.isDefined(isLogRequired) && isLogRequired === true) {
                var state = {};
                state.name = $state.current.name;
                state.params = $state.params;
                var isBulk = false;
                var items = [];
                promise = api.webGet(api.baseUrl + '/privacypolicies/' + Id + '?status=0');
                promise.then(function (response) {
                    items.push(response.data[api.lists.privacyPolicy.lookupDisplayField]);
                }, function (response) {
                    items.push(response.data[api.lists.privacyPolicy.lookupDisplayField]);
                });
                var logData = activityLogger.createLogData(items, state, 'lists.privacyPolicy', 'VIEW', isBulk, new Date(), null, null);
                promise = activityLogger.log(logData, promise);
            }
            else {
                promise = api.webGet(api.baseUrl + '/privacypolicies/' + Id + '?status=0');
            }
            return promise;
        }

        function createPrivacyPolicy(record){
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var logData = activityLogger.createLogData(record[api.lists.privacyPolicy.lookupDisplayField], state, 'lists.privacyPolicy', 'ADD', false, new Date(), null, null);
            var promise = api.webPost(api.baseUrl + '/privacypolicies', record);

            promise.then(function() {
                api.lists.privacyPolicy.isDirty = true;
            });
            return activityLogger.log(logData, promise);
        }



        function activatePrivacyPolicy(records, model, actionType){
            var result = crud.createRequestObject(records, model, actionType);
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var isBulk = result.itemsNameList.length > 1 ? true : false;
            var logData = activityLogger.createLogData(result.itemsNameList, state, 'lists.privacyPolicy', actionType.toUpperCase(), isBulk, new Date(), null, null);
			var promise = api.webPut(api.baseUrl + '/privacypolicies/status', result.requestObj);

            promise.then(function() {
                crud.onRecordStatusChange(records, model, actionType);
            });

            return activityLogger.log(logData, promise);
        }

        function getResourceFileTypesTypesList(generalProperties) {
            var promise;
            if (generalProperties.forceFetch) {
                api.lists.resourceFileTypes.lookupData = undefined;
            }

            if(angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
                var state = {};
                state.name = $state.current.name;
                state.params = $state.params;
                var isBulk = false;
                var logData = activityLogger.createLogData(null, state, 'lists.resourceFileTypes', 'VIEW', isBulk, new Date(), null, null);
                promise = api.webGet(api.baseUrl + '/resourcefileTypes', undefined, true, generalProperties.forceFetch);
                promise = activityLogger.log(logData, promise);
            }
            else {
                promise = api.webGet(api.baseUrl + '/resourcefileTypes', undefined, true, generalProperties.forceFetch);
            }
            return promise;
        }

        function getResourceTypesList(generalProperties) {
            var promise;
            if (generalProperties.forceFetch) {
                api.lists.resourceTypes.lookupData = undefined;
            }

            if(angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
                var state = {};
                state.name = $state.current.name;
                state.params = $state.params;
                var isBulk = false;
                var logData = activityLogger.createLogData(null, state, 'lists.resourceTypes', 'VIEW', isBulk, new Date(), null, null);
                promise = api.webGet(api.baseUrl + '/resourceTypes', undefined, true, generalProperties.forceFetch);
                promise = activityLogger.log(logData, promise);
            }
            else {
                promise = api.webGet(api.baseUrl + '/resourceTypes', undefined, true, generalProperties.forceFetch);
            }
            return promise;
        }

        function createResourceTypes(config) {
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var logData = activityLogger.createLogData(config[api.lists.resourceTypes.lookupDisplayField], state, 'lists.resourceTypes', 'ADD', false, new Date(), null, null);
            var promise = api.webPost(api.baseUrl + '/resourceTypes', config);

            promise.then(function() {
                api.lists.resourceTypes.isDirty = true;
            });
            return activityLogger.log(logData, promise);
        }

        function updateResourceTypes(record) {
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var logData = activityLogger.createLogData(record[api.lists.resourceTypes.lookupDisplayField], state, 'lists.resourceTypes', 'EDIT', false, new Date(), null, null);
            var promise = api.webPut(api.baseUrl + '/resourceTypes/' + record.Id, record);

            promise.then(function () {
                api.lists.resourceTypes.isDirty = true;
            });
            return activityLogger.log(logData, promise);
        }

        function createDuneContext(record) {
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var logData = activityLogger.createLogData(record[api.lists.duneContext.lookupDisplayField], state, 'lists.duneContext', 'ADD', false, new Date(), null, null);
            var promise = api.webPost(api.t1DuneBaseUrl + '/contexts', record);

            promise.then(function() {
                api.lists.duneContext.isDirty = true;
            });
            return activityLogger.log(logData, promise);
        }

        function updateDuneContext(id, record) {
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var logData = activityLogger.createLogData(record[api.lists.duneContext.lookupDisplayField], state, 'lists.duneContext', 'EDIT', false, new Date(), null, null);
            var promise = api.webPut(api.t1DuneBaseUrl + '/contexts/' + id, record);

            promise.then(function () {
                api.lists.duneContext.isDirty = true;
            });
            return activityLogger.log(logData, promise);
        }

        function activateDuneContext(record, model, actionType){
            //var result = crud.createRequestObject(records, model, actionType);
            var status = false;
            if(actionType.toUpperCase() === 'ACTIVATE') {
                status = true;
            }

            var reqObj = {
                Status : status
            }
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var isBulk = false;
            var logData = activityLogger.createLogData(record[model.lookupDisplayField], state, 'lists.duneContext', actionType.toUpperCase(), isBulk, new Date(), null, null);
            var promise = api.webPut(api.t1DuneBaseUrl + '/contexts/'+ record.Id + '/status', reqObj);

            promise.then(function() {
                api.lists.duneContext.isDirty = true;
                crud.onDuneRecordStatusChange(record, model, actionType);
            });

            return activityLogger.log(logData, promise);
        }

        function getFileTypesList(generalProperties) {
            var promise;
            if (generalProperties.forceFetch) {
                api.lists.fileTypes.lookupData = undefined;
            }

            if(angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
                var state = {};
                state.name = $state.current.name;
                state.params = $state.params;
                var isBulk = false;
                var logData = activityLogger.createLogData(null, state, 'lists.fileTypes', 'VIEW', isBulk, new Date(), null, null);
                promise = api.webGet(api.baseUrl + '/fileTypes', undefined, true, generalProperties.forceFetch);
                promise = activityLogger.log(logData, promise);
            }
            else {
                promise = api.webGet(api.baseUrl + '/fileTypes', undefined, true, generalProperties.forceFetch);
            }
            return promise;
		}

        function getSizeMapList(generalProperties) {
            var promise;
            if (generalProperties.forceFetch) {
                api.lists.sizeMap.lookupData = undefined;
            }

            if(angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
                var state = {};
                state.name = $state.current.name;
                state.params = $state.params;
                var isBulk = false;
                var logData = activityLogger.createLogData(null, state, 'lists.sizeMap', 'VIEW', isBulk, new Date(), null, null);
                promise = api.webGet(api.baseUrl + '/sizemaps', undefined, true, generalProperties.forceFetch);
                promise = activityLogger.log(logData, promise);
            }
            else {
                promise = api.webGet(api.baseUrl + '/sizemaps', undefined, true, generalProperties.forceFetch);
            }
            return promise;
        }

        function getUserLogsList(generalProperties, months){
            var promise;
            if (generalProperties.forceFetch) {
                api.lists.userLogs.lookupData = undefined;
            }
            var url = api.baseUrl + '/userlogs/'+ months;
            if(months === 0){
                url = api.baseUrl + '/userlogs';
            }

            if(angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
                var state = {};
                state.name = $state.current.name;
                state.params = $state.params;
                var isBulk = false;
                var logData = activityLogger.createLogData(null, state, 'lists.userLogs', 'VIEW', isBulk, new Date(), null, null);
                promise = api.webGet(url, undefined, true, generalProperties.forceFetch);
                promise = activityLogger.log(logData, promise);
            }
            else {
                promise = api.webGet(url, undefined, true, generalProperties.forceFetch);
            }
            return promise;
        }

        function getDuneContext(generalProperties){
            var promise;
            if (generalProperties.forceFetch) {
                api.lists.duneContext.lookupData = undefined;
            }

            if(angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
                var state = {};
                state.name = $state.current.name;
                state.params = $state.params;
                var isBulk = false;
                var logData = activityLogger.createLogData(null, state, 'lists.duneContext', 'VIEW', isBulk, new Date(), null, null);
                promise = api.webGet(api.t1DuneBaseUrl + '/contexts', undefined, true, generalProperties.forceFetch);
                promise = activityLogger.log(logData, promise);
            }
            else {
                promise = api.webGet(api.t1DuneBaseUrl + '/contexts', undefined, true, generalProperties.forceFetch);
            }
            return promise;
        }

        function getNotificationTypes(generalProperties) {
            var promise;
            if (generalProperties.forceFetch) {
                api.lists.duneContext.lookupData = undefined;
            }

            if(angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
                var state = {};
                state.name = $state.current.name;
                state.params = $state.params;
                var isBulk = false;
                var logData = activityLogger.createLogData(null, state, 'list.notificationTypes', 'VIEW', isBulk, new Date(), null, null);
                promise = api.webGet(api.baseUrl + '/notificationtypes', undefined, true, generalProperties.forceFetch);
                promise = activityLogger.log(logData, promise);
            }
            else {
                promise = api.webGet(api.baseUrl + '/notificationtypes', undefined, true, generalProperties.forceFetch);
            }
            return promise;
        }

        function UpdateNotificationTypeAutosubscribeStatus(records, model, actionType) {
            var result = crud.createRequestObject(records, model, actionType);
            var promise = api.webPut(api.baseUrl + '/notificationtypes/autosubscribe', result.requestObj);

            promise.then(function() {
                api.lists.notificationTypes.isDirty = true;
                crud.onRecordStatusChange(records, model, actionType, 'AutoSubscribe');
            });
            return promise;
        }

        function getLicenseTypes(generalProperties) {
            var promise;
            if (generalProperties.forceFetch) {
                api.lists.licenseTypes.lookupData = undefined;
            }

            if(angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
                var state = {};
                state.name = $state.current.name;
                state.params = $state.params;
                var isBulk = false;
                var logData = activityLogger.createLogData(null, state, 'lists.licenseTypes', 'VIEW', isBulk, new Date(), null, null);
                promise = api.webGet(api.baseUrl + '/licenseTypes', undefined, true, generalProperties.forceFetch);
                promise = activityLogger.log(logData, promise);
            }
            else {
                promise = api.webGet(api.baseUrl + '/licenseTypes', undefined, true, generalProperties.forceFetch);
            }
            return promise;
        }

        function createLicenseType(record) {
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var logData = activityLogger.createLogData(record[api.lists.licenseTypes.lookupDisplayField], state, 'lists.licenseTypes', 'ADD', false, new Date(), null, null);
            var promise = api.webPost(api.baseUrl + '/licenseTypes', record);

            promise.then(function() {
                api.lists.licenseTypes.isDirty = true;
            });
            return activityLogger.log(logData, promise);
        }

        function updateLicenseType(id, record) {
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var logData = activityLogger.createLogData(record[api.lists.licenseTypes.lookupDisplayField], state, 'lists.licenseTypes', 'EDIT', false, new Date(), null, null);
            var promise = api.webPut(api.baseUrl + '/licenseTypes/' + id, record);

            promise.then(function () {
                api.lists.licenseTypes.isDirty = true;
            });
            return activityLogger.log(logData, promise);
        }

        function getProcessingQueues() {
            var deferred = $q.defer();
            var list= [
                {Id:'q1' , Name: 'Q1'},
                {Id:'q2' , Name: 'Q2'},
                {Id:'q3' , Name: 'Q3'},
                {Id:'q4' , Name: 'Q4'},
                {Id:'prio' , Name: 'Priority'},
                {Id:'low' , Name: 'Low'},
                {Id:'none' , Name: 'None'},
            ];
            deferred.resolve({ data: list});
            return deferred.promise;
        }

        function getLoginTypes() {
            var deferred = $q.defer();
            var list= [
                {Id:1 , Value: 'Password'},
                {Id:2 , Value: 'UA SSO'},
                {Id:3 , Value: 'Active Directory'}
            ];
            deferred.resolve({ data: list});
            return deferred.promise;
        }

        function getAuthLoginTypes() {
            var deferred = $q.defer();
            var list= [
                {Id:1 , Value: 'Password'},
                {Id:2 , Value: 'Azure Active Directory'},
                {Id:5 , Value: 'Okta Active Directory'},
            ];
            deferred.resolve({ data: list});
            return deferred.promise;
        }

        function getAuthUserTypes() {
            var deferred = $q.defer();
            var list= [
                {Id:90 , Value: 'Admin'},
                {Id:0 , Value: 'User'},
            ];
            deferred.resolve({ data: list});
            return deferred.promise;
        }

        function getReasonTypes() {
            var deferred = $q.defer();
            var list= [
                {Id:1 , Value: 'Approval'},
                {Id:2 , Value: 'Rejection'},
            ];
            deferred.resolve({ data: list});
            return deferred.promise;
        }

        function getRequestStates() {
            var deferred = $q.defer();
            var list= [
                {Id:1 , Value: 'New'},
                {Id:2 , Value: 'Approved'},
                {Id:3 , Value: 'Rejected'},
                {Id:5 , Value: 'Confirmed'}
            ];
            deferred.resolve({ data: list});
            return deferred.promise;
        }

        function getRequestTypes() {
            var hasArticleLabel = angular.isDefined(api.articleLabelConfiguration) && api.articleLabelConfiguration !== '';
            var hasModelLabel = angular.isDefined(api.modelLabelConfiguration) && api.modelLabelConfiguration !== '';
            var hasSegmentationLabel = angular.isDefined(api.segmentationLabelConfiguration) && api.segmentationLabelConfiguration !== '';
            var deferred = $q.defer();
            var list= [
                {Id:'createArticleRequest' , Value: hasArticleLabel? 'Add New ' + api.articleLabelConfiguration : 'Add New Article'},
                {Id:'updateArticleRequest' , Value: hasArticleLabel? 'Edit ' + api.articleLabelConfiguration : 'Edit Article'},
                {Id:'updatearticlestatus' , Value: hasArticleLabel? 'Reactivate ' + api.articleLabelConfiguration : 'Reactivate Article'},
                {Id:'updatearticlesegmentation' , Value:  hasArticleLabel? api.articleLabelConfiguration + ' ' + (hasSegmentationLabel ? api.segmentationLabelConfiguration : 'Segmentation') : 'Article Segmentation'},
                {Id:'updatearticleretailwindow' , Value:  hasArticleLabel? api.articleLabelConfiguration + ' Retail Window' : 'Article Retail Window'},
                {Id:'NewArticle', Value: hasArticleLabel? 'Add Request for a New ' + api.articleLabelConfiguration : 'Add Request for a New Article'},
                {Id:'AddColorway', Value:  hasArticleLabel? 'Request to Add/Carryover ' + api.articleLabelConfiguration : 'Request to Add/Carryover Colorway'},
                {Id:'CarryoverArticle' , Value: hasArticleLabel? 'Request to Carryover ' + api.articleLabelConfiguration : 'Request to Carryover Article'},
                {Id:'SimilarStyle', Value: hasModelLabel ? 'Request to Add Similar ' + api.modelLabelConfiguration + ' Name' : 'Request to Add Similar Style'},
                {Id:'EditAttribute', Value: 'Request to Edit Attribute'},
                {Id:'EditStatus', Value: 'Request to Edit Status'},
                {Id:'EditArticleState', Value: hasArticleLabel? 'Request to Edit ' + api.articleLabelConfiguration + ' State': 'Request to Edit Article State'},
                {Id:'EditSizeScale', Value: 'Request to Edit Size Scale'},
                {Id:'EditModelName', Value: hasModelLabel ? 'Request to Edit ' + api.modelLabelConfiguration + ' Name' : 'Request to Edit Model Name'},
                {Id:'EditPrimaryColor', Value: 'Request to Edit Primary Color'},
                {Id:'EditPrices', Value: 'Request to Edit Prices'},
            ];
            deferred.resolve({ data: list});
            return deferred.promise;
        }

        function getCatalogVisibilities() {
            var deferred = $q.defer();
            var list= [
                {Id:1 , Value: 'T1 Studio'},
                {Id:2 , Value: 'Launcher'},
                {Id:3 , Value: 'Both'}
            ];
            deferred.resolve({ data: list});
            return deferred.promise;
        }

        function getCatalogCollectionTypes() {
            var deferred = $q.defer();
            var list= [
                {Id:1 , Value: 'Article'},
                {Id:2 , Value: 'Criteria'}
            ];
            deferred.resolve({ data: list});
            return deferred.promise;
        }

        function getArticleChangeTypes() {
            var deferred = $q.defer();
            var list= [
                {Id:0 , Value: 'Add'},
                {Id:1 , Value: 'Change'},
                {Id:2 , Value: 'Drop'}
            ];
            deferred.resolve({ data: list});
            return deferred.promise;
        }

        function getUsersWithCatalogAccess() {
            var promise;
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var isBulk = false;
            var items = [];
            var catalogId = catalogFactory.getActiveCatalog().CatalogCode;
            if(SecurityFactory.isAuthorized({accessPrivileges: CONSTANTS.PRIVILEGES.VETTING_LIST.CATALOG_ACCESSIBLE_USERS})) {
                promise = api.webGet(api.baseUrl + '/catalogs/' + catalogId + '/catalogAccessibleUsers');
                promise.then(function (response) {
                    angular.forEach(response.data, function(record) {
                        record['UserNameWithAccount'] = record.UserName + '(' + record.AccountName + ')';
                    });
                });
                var logData = activityLogger.createLogData(items, state, 'lists.usersWithCatalogAccess', 'VIEW', isBulk, new Date(), null, null);
                promise = activityLogger.log(logData, promise);
                return promise;
            } else {
                var privilege = {
                    id: 736,
                    description: 'Get Catalog Specific Accessible Users List'
                };
                errorDialog.show('ERRORS.NO_PRIVILEGES', undefined, privilege);
            }
        }

        function getAvailableSeasonlessAttributeList(generalProperties) {
            var promise;
            var sellerId = generalProperties.idMap.sellerId;
            var attributeGroupId = angular.isDefined(generalProperties.idMap.AttributeGroupId) ? generalProperties.idMap.AttributeGroupId : catalogFactory.getActiveCatalog().AttributeGroupId;
            if(SecurityFactory.isAuthorized({accessPrivileges: CONSTANTS.PRIVILEGES.VETTING_LIST.GET_AVAILABLE_SEASONLESS_ATTRIBUTE_LIST})) {
                if(angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
                    var state = {};
                    state.name = $state.current.name;
                    state.params = $state.params;
                    var isBulk = false;
                    var logData = activityLogger.createLogData(null, state, 'lists.availableSeasonlessAttributeList', 'VIEW', isBulk, new Date(), null, null);
                    promise = api.webGet(api.baseUrl + '/sellers/' + sellerId + '/' + attributeGroupId + '/availableattributes', undefined, true, generalProperties.forceFetch);
                    promise = activityLogger.log(logData, promise);
                }
                else {
                    promise = api.webGet(api.baseUrl + '/sellers/' + sellerId + '/' + attributeGroupId + '/availableattributes', undefined, true, generalProperties.forceFetch);
                }
                return promise;
            } else {
                var privilege = {
                    id: 746,
                    description: 'Seasonless Attributes - Get Available Seasonless Attributes for Seller'
                };
                errorDialog.show('ERRORS.NO_PRIVILEGES', undefined, privilege);
            }
        }

        // this is for the request reasons module
        function getRequestReasonTypes() {
            var hasArticleLabel = angular.isDefined(api.articleLabelConfiguration) && api.articleLabelConfiguration !== '';
            var hasModelLabel = angular.isDefined(api.modelLabelConfiguration) && api.modelLabelConfiguration !== '';
            var hasSegmentationLabel = angular.isDefined(api.segmentationLabelConfiguration) && api.segmentationLabelConfiguration !== '';
            var catalogCode = api.currentSeletedCatalogCode;
            var list= [
                {Id:'NewArticle' , Value: hasArticleLabel? 'Add Request for a New ' + api.articleLabelConfiguration : 'Add Request for a New Article'},
                {Id:'AddColorway' , Value: hasArticleLabel? 'Request to Add/Carryover ' + api.articleLabelConfiguration : 'Request to Add/Carryover Colorway'},
                {Id:'CarryoverArticle' , Value: hasArticleLabel? 'Request to Carryover ' + api.articleLabelConfiguration : 'Request to Carryover Article'},
                {Id:'SimilarStyle' , Value: hasModelLabel ? 'Request to Add Similar ' + api.modelLabelConfiguration : 'Request to Add Similar Style'},
                {Id:'ArticleSegmentations' , Value: hasArticleLabel ? 'Request to modify ' + api.articleLabelConfiguration + ' ' + (hasSegmentationLabel ? api.segmentationLabelConfiguration + 's' : 'Segmentations') : 'Request to modify Article Segmentations'},
                {Id:'ArticleRetailWindow' , Value: hasArticleLabel ? 'Request to modify ' + api.articleLabelConfiguration + ' Retail Window' : 'Request to modify Article Retail Window'},
                {Id:'EditModelName' , Value: hasModelLabel ? 'Request To Modify ' + api.modelLabelConfiguration + ' Name' : 'Request To Modify Model Name'},
                {Id:'EditStatus' , Value: hasArticleLabel ? 'Request to modify ' + api.articleLabelConfiguration + ' Status' : 'Request To Modify Article Status'},
                {Id:'EditArticleState' , Value: hasArticleLabel ? 'Request to modify ' + api.articleLabelConfiguration + ' State' : 'Request To Modify Article State'},
                {Id:'EditPrimaryColor' , Value: 'Request To Modify Primary Color'},
                {Id:'EditPrices' , Value: 'Request To Modify Prices'},
                {Id:'EditSizeScale' , Value: 'Request To Modify Size Scale'},
            ];
            var generalProperties = {
                forceFetch: true,
                isLogRequired: false
            }
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var logData = activityLogger.createLogData('', state, 'lists.requestReasonsTypes', 'EDIT', false, new Date(), null, null);
            var promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/catalogAttributes', undefined, true, generalProperties.forceFetch);

            promise.then(function (response) {
                if(angular.isDefined(response.data.AttributeList) && response.data.AttributeList.length > 0) {
                    var edutableAttributes = utility.filterObject(response.data.AttributeList, {Editable: true}, true);
                    angular.forEach(edutableAttributes, function(attribute) {
                        var object = {
                            Id: attribute.AttributeSystemName,
                            Value: 'Request to Modify ' + attribute.AttributeDisplayName
                        }
                        list.push(object);
                    });
                }
                response.data = list;
            });
            return activityLogger.log(logData, promise);
        }

        function getAvailableSeasonlessModelAttributeList(generalProperties) {
            var promise;
            var sellerId = generalProperties.idMap.sellerId;
            var attributeGroupId = angular.isDefined(generalProperties.idMap.AttributeGroupId) ? generalProperties.idMap.AttributeGroupId : catalogFactory.getActiveCatalog().AttributeGroupId;
            if(angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
                var state = {};
                state.name = $state.current.name;
                state.params = $state.params;
                var isBulk = false;
                var logData = activityLogger.createLogData(null, state, 'lists.availableSeasonlessModelAttributeList', 'VIEW', isBulk, new Date(), null, null);
                promise = api.webGet(api.baseUrl + '/sellers/' + sellerId + '/' + attributeGroupId + '/availableseasonlessmodelattributes', undefined, true, generalProperties.forceFetch);
                promise = activityLogger.log(logData, promise);
            }
            else {
                promise = api.webGet(api.baseUrl + '/sellers/' + sellerId + '/' + attributeGroupId + '/availableseasonlessmodelattributes', undefined, true, generalProperties.forceFetch);
            }
            return promise;
        }

        // shared folder entity list
        function getEntityList() {
            var deferred = $q.defer();
            var list= [
                {Id:1 , Value: 'Merch'},
                {Id:2 , Value: 'Favorites'}
            ];
            deferred.resolve({ data: list});
            return deferred.promise;
        }

        // relations entity list
        function getRelationsEntityList() {
            var deferred = $q.defer();
            var list= [
                {Id:1 , Value: 'Articles'}
            ];
            deferred.resolve({ data: list});
            return deferred.promise;
        }

        function getAvailableCatalogModelList(generalProperties) {
            var promise;
            var catalogCode = catalogFactory.getActiveCatalog().CatalogCode;
            if(angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
                var state = {};
                state.name = $state.current.name;
                state.params = $state.params;
                var isBulk = false;
                var logData = activityLogger.createLogData(null, state, 'lists.availableCatalogModelList', 'VIEW', isBulk, new Date(), null, null);
                promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/true/models/available', undefined, true, generalProperties.forceFetch);
                promise = activityLogger.log(logData, promise);
            }
            else {
                promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/true/models/available', undefined, true, generalProperties.forceFetch);
            }
            return promise;
        }

        function getAvailableCatalogModelArticlesList(generalProperties) {
            var promise;
            var catalogCode = catalogFactory.getActiveCatalog().CatalogCode;
            if(angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
                var state = {};
                state.name = $state.current.name;
                state.params = $state.params;
                var isBulk = false;
                var logData = activityLogger.createLogData(null, state, 'lists.availableCatalogModelArticles', 'VIEW', isBulk, new Date(), null, null);
                promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/articles/info', undefined, true, generalProperties.forceFetch);
                promise = activityLogger.log(logData, promise);
            }
            else {
                promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/articles/info', undefined, true, generalProperties.forceFetch);
            }
            return promise;
        }

        function getAccessibleUsers() {
            var promise;
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var isBulk = false;
            var items = [];
            var catalogId = catalogFactory.getActiveCatalog().CatalogCode;
            if(SecurityFactory.isAuthorized({accessPrivileges: CONSTANTS.PRIVILEGES.VETTING_LIST.ACCESSIBLE_USERS})) {
                promise = api.webGet(api.baseUrl + '/catalogs/' + catalogId + '/accessibleUsers');
                promise.then(function (response) {
                    angular.forEach(response.data, function(record) {
                        record['UserNameWithAccount'] = record.UserName + '(' + record.AccountName + ')';
                    });
                });
                var logData = activityLogger.createLogData(items, state, 'lists.accessibleUsers', 'VIEW', isBulk, new Date(), null, null);
                promise = activityLogger.log(logData, promise);
                return promise;
            } else {
                var privilege = {
                    id: 564,
                    description: 'Users - AccessibleUsers'
                };
                errorDialog.show('ERRORS.NO_PRIVILEGES', undefined, privilege);
            }
        }

        function getLinkedCatalogArticles(generalProperties, catalogCode) {
            var promise;
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var isBulk = false;
            var items = [];
            if(angular.isDefined(catalogCode)) {
                promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/articlenumbers?status=1', generalProperties.config || {}, true, generalProperties.forceFetch);
                var logData = activityLogger.createLogData(items, state, 'lists.linkedCatalogArticles', 'VIEW', isBulk, new Date(), null, null);
                promise = activityLogger.log(logData, promise);
                return promise;
            } else {
                // used when looking up values from articles get list.
                var linkedCatalogs = catalogFactory.getActiveCatalogDetails().LinkedCatalogList;
                var deferred = $q.defer();
                //return deferred.promise
                var promises = {};
                angular.forEach(linkedCatalogs, function(catalog) {
                    promises[catalog.Season] = api.webGet(api.baseUrl + '/catalogs/' + catalog.CatalogCode + '/articlenumbers?status=1', undefined, true, generalProperties.forceFetch);
                });
                $q.all(promises)
                .then(function(response) {
                    var concatedArticleList = [];
                    angular.forEach(linkedCatalogs, function(catalog) {
                        promises[catalog.Season] = api.webGet(api.baseUrl + '/catalogs/' + catalog.CatalogCode + '/articlenumbers?status=1', undefined, true, generalProperties.forceFetch);
                        concatedArticleList = concatedArticleList.concat(response[catalog.Season].data);
                    });
                    var responseObject = {};
                    responseObject['data'] = concatedArticleList;
                    deferred.resolve(responseObject);
                });
                return deferred.promise;
            }
        }

        function getCatalogModelList(generalProperties) {
            var promise;
            var catalogCode = catalogFactory.getActiveCatalog().CatalogCode;
            if(angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
                var state = {};
                state.name = $state.current.name;
                state.params = $state.params;
                var isBulk = false;
                var logData = activityLogger.createLogData(null, state, 'lists.catalogModelList', 'VIEW', isBulk, new Date(), null, null);
                promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/true/models/assigned', undefined, true, generalProperties.forceFetch);
                promise = activityLogger.log(logData, promise);
            }
            else {
                promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/true/models/assigned', undefined, true, generalProperties.forceFetch);
            }
            return promise;
        }

        function getAvailableArticlesFromModel(generalProperties, catalogCode, modelId) {
            var promise;
            if(angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
                var state = {};
                state.name = $state.current.name;
                state.params = $state.params;
                var isBulk = false;
                var logData = activityLogger.createLogData(null, state, 'lists.availableArticlesFromModel', 'VIEW', isBulk, new Date(), null, null);
                promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/true/models/' + modelId + '/available/articles', undefined, true, generalProperties.forceFetch);
                promise = activityLogger.log(logData, promise);
            }
            else {
                promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/true/models/' + modelId + '/available/articles', undefined, true, generalProperties.forceFetch);
            }
            return promise;
        }

        // function getAvailableSizeScaleForCatalog(generalProperties, catalogCode, modelId) {
        //     var catalogCode = angular.isUndefined(catalogCode) ? catalogFactory.getActiveCatalog().CatalogCode : catalogCode;
        //     var modelId = angular.isUndefined(modelId) ? generalProperties.idMap.modelId : modelId;
        //     var promise;
        //     if(angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
        //         var state = {};
        //         state.name = $state.current.name;
        //         state.params = $state.params;
        //         var isBulk = false;
        //         var logData = activityLogger.createLogData(null, state, 'lists.availableSizeScaleForCatalog', 'VIEW', isBulk, new Date(), null, null);
        //         promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/models/' + modelId + '/availablesizescales', undefined, true, generalProperties.forceFetch);
        //         promise = activityLogger.log(logData, promise);
        //     }
        //     else {
        //         promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/models/' + modelId + '/availablesizescales', undefined, true, generalProperties.forceFetch);
        //     }
        //     return promise;
        // }

        function getSeasonlessModelAndArticleLevelAttributesList(generalProperties) {
            var deferred = $q.defer();
            var sellerId = (generalProperties.idMap && generalProperties.idMap.sellerId) ? generalProperties.idMap.sellerId : catalogFactory.getActiveCatalog().AccountId;
            var attributeGroupId =(generalProperties.idMap && generalProperties.idMap.attributeGroupId) ? generalProperties.idMap.attributeGroupId : catalogFactory.getActiveCatalog().AttributeGroupId;

            var seasonlessArticleAttributesPromise = api.webGet(api.baseUrl + '/sellers/' + sellerId + '/seasonlessattributes', undefined, true, generalProperties.forceFetch);
            var seasonlessModelAttributesPromise = api.webGet(api.baseUrl + '/sellers/' + sellerId + '/' + attributeGroupId + '/modellevelseasonlessattributes', undefined, true, generalProperties.forceFetch);
            $q.all({seasonlessArticleAttributesPromise: seasonlessArticleAttributesPromise, seasonlessModelAttributesPromise: seasonlessModelAttributesPromise})
            .then(function(response) {
                var seasonlessArticleAttributesList = utility.filterObject(response.seasonlessArticleAttributesPromise.data, {Status: 1}, true);
                var seasonlessModelAttributesList = utility.filterObject(response.seasonlessModelAttributesPromise.data, {Status: 1}, true);
                var responseObject = {};
                responseObject['data'] = seasonlessArticleAttributesList.concat(seasonlessModelAttributesList);
                deferred.resolve(responseObject);
            })
            return deferred.promise;
        }

        function getAvailableSizeScaleForModel(generalProperties, sellerId) {
            var promise;
            if(angular.isUndefined(sellerId)) {
                sellerId = (generalProperties.idMap && generalProperties.idMap.sellerId) ? generalProperties.idMap.sellerId : catalogFactory.getActiveCatalog().AccountId;
            }
            if(angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
                var state = {};
                state.name = $state.current.name;
                state.params = $state.params;
                var isBulk = false;
                var logData = activityLogger.createLogData(null, state, 'lists.availableSizeScaleForModel', 'VIEW', isBulk, new Date(), null, null);
                promise = api.webGet(api.baseUrl + '/sellers/' + sellerId + '/sizescales', undefined, true, generalProperties.forceFetch);
                promise = activityLogger.log(logData, promise);
            }
            else {
                promise = api.webGet(api.baseUrl + '/sellers/' + sellerId + '/sizescales', undefined, true, generalProperties.forceFetch);
            }
            return promise;
        }

        function getCatalogRetailWindows() {
            var catalogCode = api.currentSeletedCatalogCode;
            var promise;
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var isBulk = false;
            var items = [];
            promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/shipmentwindows');
            promise.then(function (response) {
                angular.forEach(response.data, function(record) {
                    var shipmentStartDate = record.ShipmentStartDate.split('T', 1)[0];
                    var shipmentEndDate = record.ShipmentEndDate.split('T', 1)[0];
                    shipmentStartDate = new Date(shipmentStartDate).setHours(0,0,0,0);
                    shipmentEndDate = new Date(shipmentEndDate).setHours(0,0,0,0);
                    record['value'] = new Date(shipmentStartDate) + new Date(shipmentEndDate) + record.CriteriaAttributeValue;
                });
            });
            var logData = activityLogger.createLogData(items, state, 'lists.retailWindows', 'VIEW', isBulk, new Date(), null, null);
            promise = activityLogger.log(logData, promise);
            return promise;
        }

        function getAllAttributesFromAGroup(generalProperties, sellerId, attributeGroupId) {
            var promise;
            if(angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
                var state = {};
                state.name = $state.current.name;
                state.params = $state.params;
                var isBulk = false;
                var logData = activityLogger.createLogData(null, state, 'lists.allAttributesFromAGroup', 'VIEW', isBulk, new Date(), null, null);
                promise = api.webGet(api.baseUrl + '/sellers/' + sellerId + '/attributegroups/' + attributeGroupId + '/attributes', undefined, true, generalProperties.forceFetch);
                promise = activityLogger.log(logData, promise);
            }
            else {
                promise = api.webGet(api.baseUrl + '/sellers/' + sellerId + '/attributegroups/' + attributeGroupId + '/attributes', undefined, true, generalProperties.forceFetch);
            }
            return promise;
        }

        function getSellerModelsWithoutAttributes(generalProperties, sellerId, attributeGroupId) {
            var promise;
            if(angular.isUndefined(sellerId)) {
                sellerId = catalogFactory.getActiveCatalog().AccountId;
            }
            if(angular.isUndefined(attributeGroupId)) {
                attributeGroupId = catalogFactory.getActiveCatalog().AttributeGroupId;
            }
            if(angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
                var state = {};
                state.name = $state.current.name;
                state.params = $state.params;
                var isBulk = false;
                var logData = activityLogger.createLogData(null, state, 'lists.sellerModelsWithoutAttributes', 'VIEW', isBulk, new Date(), null, null);
                promise = api.webGet(api.baseUrl + '/sellers/' + sellerId + '/attributegroups/' + attributeGroupId + '/modelswithoutattributes', undefined, true, generalProperties.forceFetch);
                promise = activityLogger.log(logData, promise);
            }
            else {
                promise = api.webGet(api.baseUrl + '/sellers/' + sellerId + '/attributegroups/' + attributeGroupId + '/modelswithoutattributes', undefined, true, generalProperties.forceFetch);
            }
            return promise;
        }

        function getSellerModelsListForLookup(generalProperties, sellerId, attributeGroupId) {
            var promise;
            if(angular.isUndefined(sellerId)) {
                sellerId = catalogFactory.getActiveCatalog().AccountId;
            }
            if(angular.isUndefined(attributeGroupId)) {
                attributeGroupId = catalogFactory.getActiveCatalog().AttributeGroupId;
            }
            if(angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
                var state = {};
                state.name = $state.current.name;
                state.params = $state.params;
                var isBulk = false;
                var logData = activityLogger.createLogData(null, state, 'lists.sellerModelsListForLookup', 'VIEW', isBulk, new Date(), null, null);
                promise = api.webGet(api.baseUrl + '/sellers/' + sellerId + '/' + attributeGroupId + '/models', undefined, true, generalProperties.forceFetch);
                promise = activityLogger.log(logData, promise);
            }
            else {
                promise = api.webGet(api.baseUrl + '/sellers/' + sellerId + '/' + attributeGroupId + '/models', undefined, true, generalProperties.forceFetch);
            }
            return promise;
        }

        function getSellerColorsFromColorPalette(generalProperties, catalogCode) {
            var promise;
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var isBulk = false;
            var catalogCode = angular.isUndefined(catalogCode) ? catalogFactory.getActiveCatalog().CatalogCode : catalogCode;
            var logData = activityLogger.createLogData('', state, 'lists.sellerColorsFromColorPalette', 'VIEW', isBulk, new Date(), null, null);

            promise = api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/colors', undefined, true, generalProperties.forceFetch);
            promise.then(function (response) {
                var uniqueColors = [];
                var isColorAdded = {};       // ColorId -> true once the color is in uniqueColors
                var criteriaByColorId = {};  // ColorId -> {isUnconditional, groups}

                for (var i = 0; i < response.data.length; i++) {
                    var palette = response.data[i];
                    if(palette.Status) { // consider active palette only
                        var paletteGroups = utility.normalizeColorCriteria(palette.ColorCriteria);

                        for (var j = 0; j < palette.Colors.length; j++) {
                            var colorId = palette.Colors[j].ColorId;

                            if (angular.isUndefined(isColorAdded[colorId])) {
                                var color = angular.copy(palette.Colors[j]);
                                color['ColorTypeName'] = color.ColorType+ ': '  +color.ColorName;
                                uniqueColors.push(color);
                                isColorAdded[colorId] = true;
                                criteriaByColorId[colorId] = { isUnconditional: false, groups: [], invalidCriteria: null };
                            }

                            // the same color can sit in several palettes: it is valid when ANY of their criteria
                            // matches, so collect the criteria of every palette holding it instead of keeping only
                            // the first one. A palette with no criteria makes the color unconditionally available;
                            // one whose criteria cannot be parsed contributes nothing but is remembered, so a color
                            // reachable only through such a palette keeps its (unusable) criteria rather than
                            // disappearing from the list - it stays resolvable by name and is left out of the
                            // pickers by the criteria filtering, exactly as before.
                            if (paletteGroups === null) {
                                if (criteriaByColorId[colorId].invalidCriteria === null) {
                                    criteriaByColorId[colorId].invalidCriteria = palette.ColorCriteria;
                                }
                            } else if (paletteGroups.length === 0) {
                                criteriaByColorId[colorId].isUnconditional = true;
                            } else {
                                addCriteriaGroups(criteriaByColorId[colorId].groups, paletteGroups);
                            }
                        }
                    }
                }

                angular.forEach(uniqueColors, function (color) {
                    var criteria = criteriaByColorId[color.ColorId];
                    if (criteria.isUnconditional) {
                        color['ColorCriteria'] = '';
                    } else if (criteria.groups.length) {
                        color['ColorCriteria'] = angular.toJson(criteria.groups);
                    } else {
                        color['ColorCriteria'] = criteria.invalidCriteria;
                    }
                });
                response.data = uniqueColors;
            })
            promise = activityLogger.log(logData, promise);
            return promise;
        }

        // Append criteria groups, skipping ones already collected so a color shared by identical
        // palettes does not accumulate duplicates.
        function addCriteriaGroups(groups, groupsToAdd) {
            angular.forEach(groupsToAdd, function (group) {
                var serialized = angular.toJson(group);
                var isDuplicate = groups.some(function (existingGroup) {
                    return angular.toJson(existingGroup) === serialized;
                });
                if (!isDuplicate) {
                    groups.push(group);
                }
            });
        }

        function getUserGroupsCriteria() {
            var hasArticleLabel = angular.isDefined(api.articleLabelConfiguration) && api.articleLabelConfiguration !== '';
            var hasModelLabel = angular.isDefined(api.modelLabelConfiguration) && api.modelLabelConfiguration !== '';
            var deferred = $q.defer();
            var list= [
                {Id:'AddColorway', Value: hasArticleLabel? 'Add ' + api.articleLabelConfiguration : 'Add Article'},
                {Id:'CarryoverArticle' , Value: hasArticleLabel? 'Carryover ' + api.articleLabelConfiguration : 'Carryover Article'},
                {Id:'SimilarStyle', Value: hasModelLabel? 'Similar ' + api.articleLabelConfiguration : 'Similar Model'},
                {Id:'EditArticleState', Value: hasArticleLabel? 'Edit ' + api.articleLabelConfiguration + ' State' : 'Edit Article State'},
                {Id:'EditAttribute', Value: 'Edit Attribute'},
                {Id:'EditModelName', Value: hasModelLabel? 'Edit ' + api.articleLabelConfiguration + ' Name' : 'Edit Model Name'},
                {Id:'EditPrices', Value: 'Edit Prices'},
                {Id:'EditPrimaryColor', Value: 'Edit Primary Color'},
                {Id:'EditSizeScale', Value: 'Edit Size Scale'},
                {Id:'EditStatus', Value: 'Edit Status'},
            ];
            deferred.resolve({ data: list});
            return deferred.promise;
        }

        function getUserGroupsActions() {
            var deferred = $q.defer();
            var list= [
                {Id:'Approve/Reject' , Value: 'Approve/Reject'},
                {Id:'Confirm' , Value: 'Confirm'},
            ];
            deferred.resolve({ data: list});
            return deferred.promise;
        }

        function getColorTypes() {
            var deferred = $q.defer();
            var list= [
                {Id:'Solid' , Value: 'Solid'},
                {Id:'Heather' , Value: 'Heather'},
                {Id:'Pattern' , Value: 'Pattern'},
            ];
            deferred.resolve({ data: list});
            return deferred.promise;
        }
    }

})();
(function() {
    'use strict';

    angular
        .module('app.main.vas')
        .run(runBlock);

    /* @ngInject */
    function runBlock(api, activityLogger, $state, crud) {

        if(angular.isUndefined(api.vas)) {
            api.vas = {};
        }
        api.vas.vas = {
            modelPath: 'vas.vas',
            fields: [
                { field: 'Id', type: 'int', displayLabel: 'VAS.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Name', type: 'text', displayLabel: 'VAS.FIELDS.NAME', visible: true, creatable: true, editable: true, inputType: 'text',
                    validation: {isRequired: true, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'VasCode', type: 'text', displayLabel: 'VAS.FIELDS.VAS_CODE', visible: true, creatable: true, editable: true, inputType: 'text',
                    validation: {isRequired: true, maxLen: 50, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Description', type: 'text', displayLabel: 'VAS.FIELDS.DESCRIPTION', visible: true, creatable: true, editable: true, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'RequiredAdditionalInfo', type: 'int', displayLabel: 'VAS.FIELDS.REQUIRED_ADDITIONAL_INFO', visible: true, creatable: true, editable: true, inputType: 'int-bool',
                    validation: {isRequired: true, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'AdditionalInfoType', type: 'int', displayLabel: 'VAS.FIELDS.ADDITIONAL_INFO_TYPE', visible: false, creatable: false, editable: false, inputType: 'static',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'SellerAccountId', type: 'int', displayLabel: 'VAS.FIELDS.SELLER_ACCOUNT_ID', visible: false, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Status', type: 'text', displayLabel: 'VAS.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedDate', type: 'text', displayLabel: 'VAS.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedDate', type: 'text', displayLabel: 'VAS.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedBy', type: 'text', displayLabel: 'VAS.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedBy', type: 'text', displayLabel: 'VAS.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
            ],
            uniqueConstraints: [],
            title: 'VAS.NAV',
            icon: '',
            idField: 'Id',
            lookupDisplayField: 'VasCode',
            isDirty: false,
            methods: {
                getDetails   :   getVAS,
                updateStatus :   updateStatus,
                update       :   updateVAS
            },
            views: {
                mainList: {},
                mainDetails: {
                    selectedTabIndex    : 0,
                    itemActions         : [
                                            { id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateVasStatus', disabled: '{selected: true, Status: 1}',
                                                visible: true, requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                                            { id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateVasStatus', disabled: '{selected: true, Status: 0}',
                                                visible: true, requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
                                            ],
                    fabAction           : {id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UpdateVas', visible: true}
                },
                privileges: {
                    list: 'GetVasList',
                    details: 'GetVasDetails'
                }
            }
        };

        function getVAS(isLogRequired, recordId, parentId) {
            var promise;

            if(angular.isDefined(isLogRequired) && isLogRequired === true) {
                var state = {};
                state.name = $state.current.name;
                state.params = $state.params;
                var isBulk = false;
                var items= [];
                promise = api.webGet(api.baseUrl + '/sellers/' + parentId + '/vas/' + recordId + '?status=0');
                promise.then(function(response) {
                    items.push(response.data[api.vas.vas.lookupDisplayField]);
                }, function(response) {
                    items.push(response.data[api.vas.vas.lookupDisplayField]);
                });
                var logData = activityLogger.createLogData(items, state, 'vas.vas', 'VIEW', isBulk, new Date(), null, null);
                promise = activityLogger.log(logData, promise);
            }
            else {
                promise = api.webGet(api.baseUrl + '/sellers/'  + parentId + '/vas/' + recordId + '?status=0');
            }
            return promise;
        }

        function updateStatus(record, model, actionType, vasId, sellerId) {
            // var result = crud.createRequestObject(records, model, actionType);
            var result = {
                itemsNameList: [],
                requestObj: {}
            }
            result.itemsNameList.push(record[api.vas.vas.lookupDisplayField]);
            if(record.Status == 1) {
                result.requestObj['Status'] = 0;
            }
            else {
                result.requestObj['Status'] = 1;
            }
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var isBulk = result.itemsNameList.length > 1 ? true : false;
            var logData = activityLogger.createLogData(result.itemsNameList, state, 'vas.vas', actionType.toUpperCase(), isBulk, new Date(), null, null);
            var promise = api.webPut(api.baseUrl + '/sellers/' + sellerId + '/vas/' + vasId + '/status', result.requestObj);

            promise.then(function() {
                crud.onRecordStatusChange(record, model, actionType);
            });

            return activityLogger.log(logData, promise);
        }

        function updateVAS(vasId, vas) {
            vas.AdditionalInfoType = 2;// As Discussed with Omar `AdditionalInfoType` hard coded to 2
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var logData = activityLogger.createLogData(vas[api.vas.vas.lookupDisplayField], state, 'vas.vas', 'EDIT', false, new Date(), null, null);
            var promise = api.webPut(api.baseUrl + '/sellers/' + vas.SellerAccountId + '/vas/' + vasId , vas);

            promise.then(function() {
               api.vas.vas.isDirty = true;
            });
            return activityLogger.log(logData, promise);
        }

    }
})();
(function () {
	'use strict';

	angular
		.module('app.main.seller-models')
		.run(runBlock);

	/* @ngInject */
	function runBlock(api, activityLogger, $state, jobsTracker, $q, catalogFactory, utility, CONSTANTS, SecurityFactory) {

		if (angular.isUndefined(api.sellerModels)) {
			api.sellerModels = {};
		}
		api.sellerModels.sellerModels = {
			modelPath: 'sellerModels.sellerModels',
			fields: [
				{ field: 'ModelId', map:'ModelId', type: 'int', displayLabel: 'SELLER_MODELS.FIELDS.MODEL_ID', visible: true, creatable: false, editable: false, inputType: 'number',
					validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'ModelNumber', map:'ModelNumber', type: 'text', displayLabel: 'SELLER_MODELS.FIELDS.MODEL_NUMBER', visible: true, creatable: false, editable: false, showInEdit: true, inputType: 'text',
					validation: {isRequired: true, maxLen: 200, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'ModelName', map:'ModelName', type: 'text', displayLabel: 'SELLER_MODELS.FIELDS.MODEL_NAME', visible: true, creatable: true, editable: true, inputType: 'text',
					validation: {isRequired: true, maxLen: 100, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'AttributeGroupId', map:'AttributeGroupId', type: 'int', displayLabel: 'SELLER_MODELS.FIELDS.ATTRIBUTE_GROUP_NAME', visible: false, creatable: true, editable: false, inputType: 'lookup', lookupSource: 'attributes.attributeGroups',
					validation: {isRequired: true, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'Status', map:'Status', type: 'text', displayLabel: 'SELLER_MODELS.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'ParentModelName', map:'ParentModelName', type: 'text', displayLabel: 'SELLER_MODELS.FIELDS.PARENT_MODEL_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'ParentModelNumber', map:'ParentModelNumber', type: 'text', displayLabel: 'SELLER_MODELS.FIELDS.PARENT_MODEL_NUMBER', visible: true, creatable: false, editable: false, inputType: 'text',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				// above fields SizeScaleId, SizeScale properties like creatable visible etc will be set dynamically and they need to remain false in model
				{ field: 'CreatedDate', map:'CreatedDate', type: 'text', displayLabel: 'SELLER_MODELS.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'UpdatedDate', map:'UpdatedDate', type: 'text', displayLabel: 'SELLER_MODELS.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'CreatedBy', map:'CreatedBy', type: 'text', displayLabel: 'SELLER_MODELS.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'UpdatedBy', map:'UpdatedBy', type: 'text', displayLabel: 'SELLER_MODELS.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'ModelStateId', type: 'int', displayLabel: 'SELLER_MODELS.FIELDS.MODEL_STATE', visible: true, creatable: false, editable: false, inputType: 'lookup', lookupSource:'catalogs.articleStates',
					validation: {isRequired: false, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'ModelStateRank', type: 'int', displayLabel: 'SELLER_MODELS.FIELDS.MODEL_STATE_RANK', visible: true, creatable: false, editable: false, inputType: 'number',
					validation: {isRequired: false, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				// as now sizescale is dependent on attributes will add it after all the attributes rendered
				// following fields SizeScaleId, SizeScale properties like creatable visible etc will be set dynamically and they need to remain false in model
				{ field: 'SizeScaleId',  map:'SizeScaleId', type: 'int', displayLabel: 'SELLER_MODELS.FIELDS.SIZE_SCALE_ID', visible: false, creatable: false, editable: false, inputType: 'number',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'MasterSizeScale',  map:'MasterSizeScale', type: 'text', displayLabel: 'SELLER_MODELS.FIELDS.MASTER_SIZE_SCALE', visible: false, creatable: false, editable: false, inputType: 'text',
					validation: {isRequired: true, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'SizeScale', map:'SizeScale', type: 'text', displayLabel: 'SELLER_MODELS.FIELDS.SIZE_SCALE', visible: false, creatable: false, editable: false, inputType: 'text',
					validation: {isRequired: true, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'MasterSizeScaleId',  map:'MasterSizeScaleId',type: 'int', displayLabel: 'SELLER_MODELS.FIELDS.MASTER_SIZE_SCALE_ID', visible: false, creatable: false, editable: false, inputType: 'number',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				// above fields SizeScaleId, SizeScale properties like creatable visible etc will be set dynamically and they need to remain false in model
				],
			uniqueConstraints: [],
			title: 'SELLER_MODELS.NAV',
			idField: 'ModelId',
			lookupDisplayField: 'ModelNumber',
			isDirty: false,
			isCatalogSpecificModel: true,
			validateStateEditableFields: true,
			methods: {
				getList   : getModelsList,
				getDetails: getModelsDetails,
				create    : createSellerModel,
				update    : updateSellerModel,
				setSizeScaleBulk : setSizeScaleBulk,
				updateBulk:   updateBulk,
				updateViaImport      : updateViaImport
			},
			views: {
				mainList: {
					columns: ['ModelId', 'ModelNumber', 'ModelName'],
					columnFilter: {},
					toggleFilterProps: {},
					topIndex: 0,
					showFilterRow: false,
					sortColumn: {'UpdatedDate': false},
					itemActions: [
						{ id: 'view', label: 'ACTIONS.VIEW', icon: 'icon-magnify', privilege: 'GetSellerModelDetails', disabled: false, visible: true },
						{ id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UpdateSellerModel', disabled: false, visible: true},
						{ id: 'SetSizes', label: 'SELLER_MODELS.ACTIONS.SET_SIZES', icon: 'icon-layers', privilege: 'BulkAssignSellerSizeScale:true', disabled: false, visible: false }
						// SetSizes will be visible dynamically
					],
					listActions: [
						{ id: 'SetSizes', label: 'SELLER_MODELS.ACTIONS.SET_SIZES_BULK', icon: 'icon-layers', privilege: 'BulkAssignSellerSizeScale:true', disabled: false, emptyListDisabled: true, visible: false, requiresConfirmation: false},
						// SetSizes will be visible dynamically
						{ id: 'updateBulk', label: 'ACTIONS.UPDATE_BULK', icon: 'icon-pencil', privilege: 'UpdateSellerModelsBulk:true', disabled: '{selected: true}', visible: true, requiresConfirmation: false },
						{ id: 'updateViaImport', label: 'ACTIONS.UPDATE_VIA_IMPORT', icon: 'icon-import', privilege: 'UpdateSellerModelsBulk:true', disabled: false, visible: true, requiresConfirmation: false},
					],
					fabAction: {id: 'add', label: 'ACTIONS.ADD', icon: 'icon-plus', privilege: 'CreateSellerModel:true', visible: true}
				},
				mainDetails: {
					selectedTabIndex    : 0,
					itemActions         : [],
					fab                 : {id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UpdateSellerModel', visible: true}
		 		},
				privileges: {
					list: 'GetSellerModels',
					details : 'GetSellerModelDetails'
				}
			}

		};

		function getModelsList(generalProperties, model, sellerId, attributeGroupId) {
			if (angular.isDefined(model)) { // to skip this part for load lookup
				model.isBulkActionCompleted = false;
			}
			sellerId = angular.isDefined(sellerId) ? sellerId : catalogFactory.getActiveCatalog().AccountId;
			attributeGroupId = angular.isDefined(attributeGroupId) ? attributeGroupId : catalogFactory.getActiveCatalog().AttributeGroupId;
			var promise;

			if (angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
				var state = {};
				state.name = $state.current.name;
				state.params = $state.params;
				var isBulk = true;
				var logData = activityLogger.createLogData(null, state, 'sellerModels.sellerModels', 'VIEW', isBulk, new Date(), null, null);

				promise = api.webGet(api.baseUrl + '/sellers/' + sellerId + '/' + attributeGroupId + '/models',
				generalProperties.config || {}, true, generalProperties.forceFetch,
				generalProperties.supportIncrementalResult || true,
				generalProperties.modelIdField,
				generalProperties.isMajor || false,
				model || api.sellerModels.sellerModels);
				promise = activityLogger.log(logData, promise);
			}
			else {
				promise = api.webGet(api.baseUrl + '/sellers/' + sellerId + '/' + attributeGroupId + '/models',
				generalProperties.config || {}, true, generalProperties.forceFetch,
				generalProperties.supportIncrementalResult || true,
				generalProperties.modelIdField,
				generalProperties.isMajor || false,
				model || api.sellerModels.sellerModels);
			}

			promise.then(function () {
				if (api.sellerModels.sellerModels.isDirty) {
					//Invalidate lookupData
					api.sellerModels.sellerModels.lookupData = undefined;
					api.sellerModels.sellerModels.isDirty = false;
				}
			});
			return promise;
		}

		function getModelsDetails(isLogRequired, modelId, sellerId, attributeGroupId) {
			var promise;
			if (angular.isDefined(isLogRequired) && isLogRequired === true) {
				var state = {};
				state.name = $state.current.name;
				state.params = $state.params;
				var isBulk = false;
				var items = [];
				promise = api.webGet(api.baseUrl + '/sellers/' + sellerId + '/' + attributeGroupId + '/models/' + modelId);
				promise.then(function (response) {
					items.push(response.data[api.sellerModels.sellerModels.lookupDisplayField]);
				}, function (response) {
					items.push(response.data[api.sellerModels.sellerModels.lookupDisplayField]);
				});
				var logData = activityLogger.createLogData(items, state, 'sellerModels.sellerModels', 'VIEW', isBulk, new Date(), null, null);
				promise = activityLogger.log(logData, promise);
			}
			else {
				promise = api.webGet(api.baseUrl + '/sellers/' + sellerId + '/' + attributeGroupId + '/models/' + modelId);
			}
			return promise;
		}

		function createSellerModel(record, sellerId) {
			var state = {};
			state.name = $state.current.name;
			state.params = $state.params;
			var logData = activityLogger.createLogData(record[api.sellerModels.sellerModels.lookupDisplayField], state, 'sellerModels.sellerModels', 'ADD', false, new Date(), null, null);
			var promise = api.webPost(api.baseUrl + '/sellers/' + sellerId + '/' + record.AttributeGroupId + '/models', record);

			promise.then(function() {
				api.sellerModels.sellerModels.isDirty = true;
				api.lists.availableCatalogModelList.isDirty = true;
			});
			return activityLogger.log(logData, promise);
		}

		function updateSellerModel(modelId, record, sellerId, model) {
				// check the special privilege is assigned to the user for updating the state. if then does not vaidate editable fields
				var isSpecialPermissionToIgnoreArticleStateIsAssigned = SecurityFactory.isAuthorized({accessPrivileges: CONSTANTS.PRIVILEGES.ARTICLES.SPECIAL_PRIVILEGE_TO_SKIP_STATE_VALIDATION});
				var state = {};
				state.name = $state.current.name;
				state.params = $state.params;
				// remove restricted attributes from list
				var roleBasedRestrictedAttributes = (angular.isDefined(api.roleBasedRestrictions) && angular.isDefined(api.roleBasedRestrictions.restrictedAttributesArray) && api.roleBasedRestrictions.restrictedAttributesArray.length > 0) ? api.roleBasedRestrictions.restrictedAttributesArray : [];
				if(roleBasedRestrictedAttributes.length > 0) {
					angular.forEach(roleBasedRestrictedAttributes, function(attribute) {
						if(attribute.notEditable) {
							delete record[attribute.Name];
						}
					});
				}

				// remove state level non editable attributes from request
				if(!isSpecialPermissionToIgnoreArticleStateIsAssigned && record.ModelStateId != null) {
						var assignedState = utility.filterObject(api.articleStatesList, {StateId: record.ModelStateId}, true)[0];
						if(assignedState) {
							if(assignedState.NonEditableAttributes.length) {
								angular.forEach(assignedState.NonEditableAttributes, function(attribute) {
									delete record[attribute.AttributeSystemName];
								});
							}
							if(!assignedState.IsModelNameEditable) {
								delete record.ModelName;
							}
						}
				}

				// remove role restricted attributes from list
				var roleBasedRestrictedAttributes = (angular.isDefined(api.roleBasedRestrictions) && angular.isDefined(api.roleBasedRestrictions.restrictedAttributesArray) && api.roleBasedRestrictions.restrictedAttributesArray.length > 0) ? api.roleBasedRestrictions.restrictedAttributesArray : [];
				if(roleBasedRestrictedAttributes.length > 0) {
					angular.forEach(roleBasedRestrictedAttributes, function(attribute) {
						if(attribute.notEditable) {
							delete record[attribute.Name];
						}
					});
				}

				var logData = activityLogger.createLogData(record[api.sellerModels.sellerModels.lookupDisplayField], state, 'sellerModels.sellerModels', 'ADD', false, new Date(), null, null);
				var promise = api.webPut(api.baseUrl + '/sellers/' + sellerId + '/' + record.AttributeGroupId + '/models/' + modelId + '?clientapp=t1ui', record);

				promise.then(function () {
					api.sellerModels.sellerModels.isDirty = true;
					api.catalogs.models.isDirty = true;
					api.catalogs.articles.isDirty = true;
				});
				return activityLogger.log(logData, promise);
		}

		function setSizeScaleBulk(model, results, sellerId, attributeGroupId, sellerModels, sizeScaleGroupsPromise, masterSizeScalesPromise) {
				var deferred = $q.defer();
				var promise = deferred.promise;
				var requestbody = [];
				var modelsMap = {};
				// create models map
				angular.forEach(sellerModels, function(model) {
						if(angular.isUndefined(modelsMap[model.ModelNumber])) {
							modelsMap[model.ModelNumber] = model;
						}
				});

				masterSizeScalesPromise.then(function(masterSizeScaleResponse) {
					var masterSizeScales = masterSizeScaleResponse.data;
					var masterSizeScaleMap = {};

					// create masterSizeScales map
					angular.forEach(masterSizeScales, function(masterSizeScale) {
						masterSizeScaleMap[masterSizeScale.SizeScale] = masterSizeScale.Id;
					});

					sizeScaleGroupsPromise.then(function(sizeScaleGroupsResponse) {
						var sizeScaleGroups = sizeScaleGroupsResponse.data;

						for (var i = 0; i < results.length; i++) {
							var masterSizeScaleName = '';
							var masterSizeScaleId = '';
							if(results[i].MasterSizeScale != null) { // from import we get MAsterSizeScaleName
								masterSizeScaleName = results[i].MasterSizeScale;
								masterSizeScaleId = masterSizeScaleMap[masterSizeScaleName];
							} else {
								// from set sizes we get the MasterSizeScaleID
								masterSizeScaleId = results[i].MasterSizeScaleId;
							}
							var sizeScaleName = results[i].SizeScale;
							var sizeScaleId = utility.getSizeScaleIdByMasterSizeScaleIdAndSizeScaleName(masterSizeScaleId, sizeScaleName, sizeScaleGroups);

							if (sizeScaleId) {
								var requestObject = {
									SizeScaleId: sizeScaleId,
									ModelId: modelsMap[results[i].ModelNumber].ModelId
								};
								requestbody.push(requestObject);
							} else {
								console.log('Size scale not found for MasterSizeScaleName: ' + masterSizeScaleName + ' and SizeScale: ' + sizeScaleName);
							}
						}

						var secondaryModel = api.catalogs.models; // when seller model sizescales updated make catalog models model dirty
						var jobIndex = jobsTracker.addJob(model, 'SELLER_MODELS.ACTIONS.SET_SIZES_BULK', 1, secondaryModel);
						api.webPut(api.baseUrl + '/sellers/' + sellerId + '/' + attributeGroupId + '/models/bulkassignsizescale?sourceapplication=' + CONSTANTS.SOURCE_APPLICATION + '&sourceaction=Set Models Sizes(Bulk)', requestbody).then(function(response) {
								jobsTracker.trackJob(jobIndex, response.data.Id);
						}).catch(function(error) {
								jobsTracker.setCriticlaFail(jobIndex, error);
						});
					}).catch(function(error) {
						$log.error('Error in set sizes bulk', error);
						deferred.reject(error);
					});
				}).catch(function(error) {
					$log.error('Error in retrieving master size scales', error);
					deferred.reject(error);
				});
				return promise;
		}

		function updateBulk(model, records, updateRecord, idMap) {
			var requestBody = [];
			angular.forEach(records, function (record) {
					var requestObject = {ModelNumber: record.ModelNumber}
					for (var prop in updateRecord) {
						if(record[prop] !== updateRecord[prop]) {
							requestObject[prop] = updateRecord[prop];
						}
						// add ParentModelNumber is present
						if(prop === 'ParentModelNumber' && updateRecord[prop] != null) {
							requestObject[prop] = updateRecord[prop];
						}
					}
					requestBody.push(requestObject);
			});

			var jobIndex = jobsTracker.addJob(model, 'MODELS.ACTIONS.UPDATE_BULK', 1);
			api.webPut(api.baseUrl + '/sellers/' + idMap.sellerId + '/' + idMap.attributeGroupId + '/updatebulksellermodels?sourceapplication=' + CONSTANTS.SOURCE_APPLICATION + '&sourceaction=Update Bulk Seller Models', requestBody).then(function(response) {
				jobsTracker.trackJob(jobIndex, response.data.Id);
			}).catch(function(error) {
				jobsTracker.setCriticlaFail(jobIndex, error);
			});
		}

		function updateViaImport(model, data, sellerId, attributeGroupId) {
			angular.forEach(data, function(model) {
				// remove parent model number field. if type is parent we should not send this field to API
				if(angular.isDefined(model.parent_model_type) && model.parent_model_type.toString().toLowerCase() === 'parent') {
					delete model['ParentModelNumber']
				}
			});
			var jobIndex = jobsTracker.addJob(model, 'MODELS.ACTIONS.UPDATE_VIA_IMPORT', 1);
			api.webPut(api.baseUrl + '/sellers/' + sellerId + '/' + attributeGroupId + '/updatebulksellermodels?sourceapplication=' + CONSTANTS.SOURCE_APPLICATION + '&sourceaction=Update via Import Seller Models', data).then(function(response) {
				jobsTracker.trackJob(jobIndex, response.data.Id);
			}).catch(function(error) {
				jobsTracker.setCriticlaFail(jobIndex, error);
			});
		}

	}
})();
(function() {
    'use strict';

    angular
        .module('app.main.roles')
        .run(runBlock);

    /* @ngInject */
    function runBlock(api, activityLogger, $state, crud) {

        if(angular.isUndefined(api.roles)) {
            api.roles = {};
        }
        api.roles.roles = {
            modelPath: 'roles.roles',
            fields: [
                { field: 'Id', type: 'int', displayLabel: 'ROLES.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UserRole', type: 'text', displayLabel: 'ROLES.FIELDS.NAME', visible: true, creatable: true, editable: true, inputType: 'text',
                    validation: {isRequired: true, maxLen: 20, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'AccountTypeId', type: 'int', displayLabel: 'ROLES.FIELDS.ACCOUNTTYPE', visible: true, creatable: true, editable: true, inputType: 'lookup', lookupSource: 'lists.accountTypes',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Catalogs', type: 'int', displayLabel: 'ROLES.FIELDS.CATALOGS', visible: false, creatable: true, editable: true, inputType: 'lookup-many', lookupSource: 'catalogs.catalogs',
                    lookupFilter: {Status: 1}, validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'IsDefaultRole', type: 'text', displayLabel: 'ROLES.FIELDS.IS_DEFAULT_ACCOUNT', visible: true, creatable: true, editable: true, inputType: 'bool',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'IsApplyCustomerSellerUserRestriction', type: 'text', displayLabel: 'ROLES.FIELDS.APPLY_OWNERSHIP', visible: true, creatable: true, editable: true, inputType: 'bool-int',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '',  disabledCriteria: 'vm.record.AccountTypeId !== 2', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Status', type: 'text', displayLabel: 'ROLES.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
                    validation: {isRequired: false, maxLen: 25, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedDate', type: 'text', displayLabel: 'ROLES.FIELDS.CREATEDDATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedDate', type: 'text', displayLabel: 'ROLES.FIELDS.UPDATEDDATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedBy', type: 'text', displayLabel: 'ROLES.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedBy', type: 'text', displayLabel: 'ROLES.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
            ],
            uniqueConstraints: [],
            title: 'ROLES.NAV',
            icon: 'icon-account',
            idField: 'Id',
            lookupDisplayField: 'UserRole',
            isDirty: false,
            methods: {
                getList                 :   getRoles,
                getDetails              :   getRole,
                activateBulk            :   activateRoles,
                create                  :   createRole,
                update                  :   updateRole,
                getProfileInformation   :   getProfileInformation
            },
            views: {
                mainList: {
                    columns             : [ 'UserRole', 'AccountTypeId', 'Status', 'UpdatedDate' ],
                    columnFilter        : {},
                    toggleFilterProps   : { toggleStatus:false, filterProp:'Status', trueVal:1, trueValTooltipMessage: 'ACTIONS.TOGGLE_ACTIVE', falseVal:'', falseValTooltipMessage:"ACTIONS.TOGGLE_ALL"},
                    topIndex            : 0,
                    showFilterRow       : false,
                    sortColumn          : {'UpdatedDate': false},
                    itemActions         : [
                                            { id: 'view', label: 'ACTIONS.VIEW', icon: 'icon-magnify', privilege: 'GetAccountTypeRolesDetails', disabled: '!itm.Status', visible: true },
                                            { id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UpdateAccountTypeUserRole', disabled: '!itm.Status', visible: true },
                                            { id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateBulkAccountTypeRoleStatus', disabled: 'itm.IsDefaultRole', visible: 'itm.Status',
                                                requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                                            { id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateBulkAccountTypeRoleStatus', disabled: 'itm.IsDefaultRole', visible: '!itm.Status',
                                                requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
                                        ],
                    listActions         : [
                                            { id: 'delete', label: 'ACTIONS.DELETE_BULK', icon: 'icon-delete', privilege: 'UpdateBulkAccountTypeRoleStatus', disabled: '{selected: true, Status: 1, IsDefaultRole: false}', visible: true,
                                                requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                                            { id: 'activate', label: 'ACTIONS.ACTIVATE_BULK', icon: 'icon-undo-variant', privilege: 'UpdateBulkAccountTypeRoleStatus', disabled: '{selected: true, Status: 0, IsDefaultRole: false}', visible: true,
                                                requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
                                        ],
                    fabAction           : {id: 'add', label: 'ACTIONS.ADD', icon: 'icon-plus', privilege: 'CreateAccountTypeRole', visible: true}
                },
                mainDetails: {
                    selectedTabIndex    : 0,
                    itemActions         : [
                                            { id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateBulkAccountTypeRoleStatus', disabled: '{selected: true, Status: 1, IsDefaultRole: false}',
                                                visible: true, requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                                            { id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateBulkAccountTypeRoleStatus', disabled: '{selected: true, Status: 0, IsDefaultRole: false}',
                                                visible: true, requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
                                            ],
                    fabAction           : {id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UpdateAccountTypeUserRole', visible: true}
                },
                privileges: {
                    list: 'GetAccountTypeRolesList',
                    details: 'GetAccountTypeRolesDetails'
                }
            }
        };

        function getRoles(generalProperties) {
            var promise;

            if(angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
                var state = {};
                state.name = $state.current.name;
                state.params = $state.params;
                var isBulk = true;
                var logData = activityLogger.createLogData(null, state, 'roles.roles', 'VIEW', isBulk, new Date(), null, null);

                promise = api.webGet(api.baseUrl + '/roles', undefined, true, generalProperties.forceFetch);
                promise = activityLogger.log(logData, promise);
            }
            else {
                promise = api.webGet(api.baseUrl + '/roles', undefined, true, generalProperties.forceFetch);
            }

            promise.then(function() {
                if (api.roles.roles.isDirty) {
                    //Invalidate lookupData
                    api.roles.roles.lookupData = undefined;
                    api.roles.roles.isDirty = false;
                }
            });
            return promise;
		}

        function getRole(isLogRequired, roleId) {
            var promise;

            if(angular.isDefined(isLogRequired) && isLogRequired === true) {
                var state = {};
                state.name = $state.current.name;
                state.params = $state.params;
                var isBulk = false;
                var items= [];
                promise = api.webGet(api.baseUrl + '/roles/' + roleId + '?status=0');
                promise.then(function(response) {
                    items.push(response.data[api.roles.roles.lookupDisplayField]);
                }, function(response) {
                    items.push(response.data[api.roles.roles.lookupDisplayField]);
                });
                var logData = activityLogger.createLogData(items, state, 'roles.roles', 'VIEW', isBulk, new Date(), null, null);
                promise = activityLogger.log(logData, promise);
            }
            else {
                promise = api.webGet(api.baseUrl + '/roles/' + roleId + '?status=0');
            }
            return promise;
		}

		function activateRoles(records, model, actionType) {
            var result = crud.createRequestObject(records, model, actionType);
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var isBulk = result.itemsNameList.length > 1 ? true : false;
            var logData = activityLogger.createLogData(result.itemsNameList, state, 'roles.roles', actionType.toUpperCase(), isBulk, new Date(), null, null);
			var promise = api.webPut(api.baseUrl + '/roles/status', result.requestObj);

            promise.then(function() {
                crud.onRecordStatusChange(records, model, actionType);
            });

            return activityLogger.log(logData, promise);
		}

		function createRole(role) {
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var logData = activityLogger.createLogData(role[api.roles.roles.lookupDisplayField], state, 'roles.roles', 'ADD', false, new Date(), null, null);
			var promise = api.webPost(api.baseUrl + '/roles', role);

            promise.then(function() {
                api.roles.roles.isDirty = true;
            });
            return activityLogger.log(logData, promise);
		}

        function updateRole(roleId, role) {
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var logData = activityLogger.createLogData(role[api.roles.roles.lookupDisplayField], state, 'roles.roles', 'EDIT', false, new Date(), null, null);
			var promise = api.webPut(api.baseUrl + '/roles/' + roleId, role);

            promise.then(function() {
                api.roles.roles.isDirty = true;
            });
            return activityLogger.log(logData, promise);
		}

        function getProfileInformation(forceFetch, isLogRequired) {
            var promise;

            if(angular.isDefined(isLogRequired) && isLogRequired === true) {
                var state = {};
                state.name = $state.current.name;
                state.params = $state.params;
                var isBulk = true;
                var logData = activityLogger.createLogData(null, state, 'roles.roles', 'VIEW', isBulk, new Date(), null, null);

                promise = api.webGet(api.baseUrl + '/profile', undefined, true, forceFetch);
                promise = activityLogger.log(logData, promise);
            }
            else {
                promise = api.webGet(api.baseUrl + '/profile', undefined, true, forceFetch);
            }
            return promise;
        }

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.main.profile', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        $stateProvider.state('app.pages_profile', {
            url      : '/profile',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/profile/profile.html',
                    controller : 'ProfileController as vm'
                }
            },
            resolve  : {
            },
            data: {
                displayName: 'PROFILE.TITLE'
            },
            bodyClass: 'profile'
        });

        $translatePartialLoaderProvider.addPart('app/main/profile');
    }

})();
(function()
{
    'use strict';

    angular
        .module('app.main.profile')
        .controller('ProfileController', ProfileController);

    /** @ngInject */
    function ProfileController($q, api, toast, dialog, $localStorage, $document, $translate, $filter, $mdDialog, $state, $log, mockFactory, CONSTANTS,
        $scope, $timeout, $rootScope, settingsFactory, Idle) {
        /* jshint validthis: true */
        var vm = this;

        // Data
        var UPDATE_INTERVAL_TIME_MILI = 500;
        // var dataUpadeSliderTimeoutPromise;
        var appLockSliderTimeoutPromise;

        vm.model = api.accounts.profile;
        vm.profile = $localStorage.profileInformation;
        vm.logItems = [];
        vm.logCurrentPage = 0;
        vm.settings = {};
        var watchUnsubscriber = {};
        vm.activeDirectoryInfo = $localStorage.user.loginType;
        vm.loginTypeEnums = CONSTANTS.LOGIN_TYPE;

        //TODO: REPLACE THIS with the actual logs
        vm.tempLogs = mockFactory.getTempLogs();

        // Methods
        vm.editProfile = editProfile;
        vm.changePassword = changePassword;
        vm.logLoadNextPage = logLoadNextPage;
        //vm.switchDataUpdate = switchDataUpdate;
        vm.switchAutoLock = switchAutoLock;
        vm.resetLayout = resetLayout;
        vm.resetFilters = resetFilters;
        vm.resetColumns = resetColumns;

        vm.changeLanguage = changeLanguage;

        logLoadNextPage();

        activate();

        //////////


        function activate() {
            loadSettings();
            vm.languages = mockFactory.getSupportedLanguages();
            vm.selectedLanguage = vm.languages[$translate.preferredLanguage(vm.settings.preferredLanguage)];

            if(angular.isUndefined(vm.profile)) {
                refreshRecord();
            }
        }

        function refreshRecord() {
            api.roles.roles.methods.getProfileInformation({isLogRequired: false, forceFetch:true}).then(function(response) {
                vm.profile = $localStorage.profileInformation = response.data;
            }).catch(function(){
                $log.warn('#login.ProfileController: could not update profileInformation in localStorage');
            });
        }

        function editProfile(ev, item) {
            var settings = angular.copy(vm.settings);
            item.Settings = angular.toJson(settings);
            api.showEditRecordDialog(angular.element($document.body), ev, vm.model, item)
            .then(function(saved) {
                if (saved) {
                    refreshRecord();
                    toast.success('SUCCESS.UPDATE', '', '');
                }
            });
        }

        function changePassword() {
            dialog.changePassword()
             .then(function(record) {
                 if(record) {
                     vm.model.methods.changePassword(record)
                      .then(function() {
                          toast.success('SUCCESS.UPDATE', '', '');
                      }).catch(function(response) {
                        vm.responseError = true;
        
                        var translatableKey;
                        var errCode = angular.isDefined(response.data) && response.data && angular.isDefined(response.data.errorCode) ? response.data.errorCode : 999;
                        switch (response.status) {
                            case 400:
                            case 401:
                                if(errCode === 10010) {
                                    translatableKey = 'LOGIN.ERRORS.INVALID_CURRENT_PASSWORD';
                                }                        
                                break;
                            case 429 :
                                translatableKey = 'LOGIN.ERRORS.TOO_MANY_REQUESTS';
                                break;
                            default:
                                translatableKey = 'LOGIN.ERRORS.UNEXPECTED_ERROR';
                        }
        
                        vm.error = $filter('translate')(translatableKey);
                        vm.errorCode = errCode;
                        
                    });
                 }
             })
        }

        function logLoadNextPage() {
            // Create a new deferred object
            var deferred = $q.defer();
            var pageSize = 10;
            var totalPages = 0;

            if (angular.isDefined($localStorage.logs)) {
                totalPages = Math.ceil($localStorage.logs.length / pageSize);
            }

            // Increase the current page number
            vm.logCurrentPage = vm.logCurrentPage + 1;

            // Check if we still have pages that we can load
            if ( vm.logCurrentPage > totalPages )
            {
                // Reject the promise
                deferred.reject('No more pages');
            }
            else
            {
                var maxItem = vm.logCurrentPage * pageSize;

                if (maxItem > vm.tempLogs.length)
                {
                    maxItem = vm.tempLogs.length;
                }

                var allItems = $filter('orderBy')($localStorage.logs, 'date', true);

                for (var i = (vm.logCurrentPage-1) * pageSize; i < maxItem; i++)
                {
                    var tempItem = allItems[i];
                    if(angular.isDefined(tempItem)) {
                        var model = api.getModel(tempItem.module);

                        vm.logItems.push({
                            card: {
                                title: $filter('translate')(model.title), //'Hello World!', //$translate(model.title),
                                event: $filter('translate')(tempItem.isBulk ? CONSTANTS.LOG.ACTIONS[tempItem.actionType].displayNameBulk : CONSTANTS.LOG.ACTIONS[tempItem.actionType].displayName), //tempItem.record,
                                media: {
                                    image: {
                                        src: model.icon,
                                        alt: model.title
                                    }
                                },

                                record: tempItem.record,
                                state: tempItem.state,
                                result: tempItem.result,
                                resultMessage: tempItem.resultMessage,
                                isBulk: tempItem.isBulk,

                                navigate: navigateTo,
                                showDetails: showLogDetails
                            },

                            icon: tempItem.isBulk ? CONSTANTS.LOG.ACTIONS[tempItem.actionType].iconBulk : CONSTANTS.LOG.ACTIONS[tempItem.actionType].icon,
                            time: tempItem.date,
                            event: $filter('translate')(CONSTANTS.LOG.ACTIONS[tempItem.actionType].displayVerb)
                        });
                    }
                }

                deferred.resolve();
            }
            return deferred.promise;
        }

        function switchAutoLock(switchVal) {
            if(switchVal === true) {
                Idle.setIdle((vm.settings.autoLockInterval*60)-Idle.getTimeout());
                Idle.watch();
            }
            else {
                Idle.unwatch();
            }
            settingsFactory.updateAppLockerSettings(switchVal, vm.settings.autoLockInterval);
        }

        function resetLayout() {
            dialog.confirm(undefined, 'PARTS.YES').then(function(response) {
                if(response.userAction === 'confirm') {
                    settingsFactory.resetModulesLayout();
                }
            });
        }

        function resetFilters() {
            dialog.confirm(undefined, 'PARTS.YES').then(function(response) {
                if(response.userAction === 'confirm') {
                    settingsFactory.updateViewFilters({});
                }
            });
        }

        function resetColumns() {
            dialog.confirm(undefined, 'PARTS.YES').then(function(response) {
                if(response.userAction === 'confirm') {
                    settingsFactory.updateViewColumns({});
                }
            });
        }


        /**
         * Change Language
         */
        function changeLanguage(lang) {
            $rootScope.$emit('preferredLangaugeChangedEvent', lang.code);
            settingsFactory.updatePreferredLanguage(lang.code);

            //Change the language
            $translate.use(lang.code);
        }

        function navigateTo(card) {
            $state.go(card.state.name, card.state.params);
        }

        function showLogDetails(card) {
            var parentEl = angular.element($document.body);
            $mdDialog.show({
                parent: parentEl,
                targetEvent: null,
                templateUrl: 'app/services/toast/error-details.html',
                locals: {
                    errorObj: card.result
                },
                controller: DialogController,
                controllerAs: 'vm'
            });
            function DialogController($scope, $mdDialog, $translate, errorObj) {
                var vm = this;
                vm.errorObj = errorObj;
                vm.errorTxt = angular.toJson(errorObj, true);
                vm.closeDialog = function() {
                    $mdDialog.hide();
                }
            }
        }

        function loadSettings() {
            if(vm.profile.Settings !== '') {
                vm.settings = angular.fromJson(vm.profile.Settings);
            }
            var configSettigns;
            api.webGet('/app/app.config.json').then(function(response) {
                if(angular.isDefined(response) && angular.isDefined(response.data) && angular.isDefined(response.data.settingsConfig) ) {
                    configSettigns = response.data.settingsConfig;
                }
            }).finally(function() {
                // initialize appLocker if no value in server
                if(angular.isUndefined(vm.settings) || angular.isUndefined(vm.settings.autoLock)) {
                    // by default (if not override by config) auto lock is enabled
                    vm.settings.autoLock = (angular.isDefined(configSettigns) && angular.isDefined(configSettigns.autoLock)
                        && configSettigns.autoLock.autoLock) ? configSettigns.autoLock.autoLock : true;

                    vm.settings.autoLockInterval = (angular.isDefined(configSettigns) && angular.isDefined(configSettigns.autoLock)
                        && configSettigns.autoLock.autoLockInterval) ? configSettigns.autoLock.autoLockInterval : (Idle.getIdle() + Idle.getTimeout())/60;
                }

                watchUnsubscriber.autoLockInterval = $scope.$watch('vm.settings.autoLockInterval', autoLockIntervalChange);
            });
        }

        function autoLockIntervalChange(newVal, oldVal) {
            if(angular.isDefined(newVal) && newVal !== oldVal) {
                $timeout.cancel(appLockSliderTimeoutPromise);
                appLockSliderTimeoutPromise = $timeout(function() {
                    Idle.setIdle((newVal*60)-Idle.getTimeout());
                    Idle.watch();
                    settingsFactory.updateAppLockerSettings(vm.settings.autoLock, vm.settings.autoLockInterval);
                }, UPDATE_INTERVAL_TIME_MILI);
            }
        }

        var langaugeChangedEventCleanup = $rootScope.$on('preferredLangaugeChangedEvent', function(event, languageCode) {
            vm.selectedLanguage = vm.languages[$translate.preferredLanguage(languageCode)];
        });
        $scope.$on('$destroy', function() {
            langaugeChangedEventCleanup();
            // if(angular.isFunction(dataUpadeSliderTimeoutPromise)) {
            //     $timeout.cancel(dataUpadeSliderTimeoutPromise);
            // }
            if(angular.isFunction(appLockSliderTimeoutPromise)) {
                $timeout.cancel(appLockSliderTimeoutPromise);
            }
            for(var key in watchUnsubscriber) {
                watchUnsubscriber[key]();
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('app.main.profile')
        .run(runBlock);

    /* @ngInject */
    function runBlock(api, $localStorage) {

        if(angular.isUndefined(api.accounts)) {
            api.accounts = {};
        }
        api.accounts.profile = {
            fields: [
                { field: 'Id', type: 'int', displayLabel: 'PROFILE.ID', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'AccountId', type: 'int', displayLabel: 'PROFILE.ACCOUNT_ID', visible: true, creatable: false, editable: false, inputType: 'static',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'AccountName', type: 'text', displayLabel: 'PROFILE.ACCOUNT_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'FirstName', type: 'int', displayLabel: 'PROFILE.FIRST_NAME', visible: true, creatable: false, editable: true, inputType: 'text',
                    validation: {isRequired: true, maxLen: 20, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'LastName', type: 'text', displayLabel: 'PROFILE.LAST_NAME', visible: true, creatable: false, editable: true, inputType: 'text',
                    validation: {isRequired: true, maxLen: 20, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'FullName', type: 'text', displayLabel: 'PROFILE.FULL_NAME', visible: true, creatable: false, editable: false, inputType: 'calculated', calculatedExpression: 'data["FirstName"] + " " + data["LastName"]',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Email', type: 'text', displayLabel: 'PROFILE.EMAILS', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: true, maxLen: 500, minLen: 1, pattern: '^[A-Za-z]+[A-Za-z0-9._+-]+@{1}[A-Za-z0-9._-]+\.[A-Za-z.]{2,}$', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: 'VALIDATIONS.INVALID_EMAIL'}}  },
                { field: 'Phone', type: 'text', displayLabel: 'PROFILE.PHONE', visible: true, creatable: false, editable: true, inputType: 'text',
                    validation: {isRequired: false, maxLen: 20, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}}},
                { field: 'CountryCode', type: 'text', displayLabel: 'PROFILE.COUNTRY', visible: false, creatable: false, editable: true, inputType: 'lookup', lookupSource: 'lists.countries',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Country', type: 'text', displayLabel: 'PROFILE.COUNTRY', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'City', type: 'text', displayLabel: 'PROFILE.CITY', visible: true, creatable: false, editable: true, inputType: 'text',
                    validation: {isRequired: false, maxLen: 25, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Designation', type: 'text', displayLabel: 'PROFILE.DESIGNATION', visible: true, creatable: false, editable: true, inputType: 'text',
                    validation: {isRequired: false, maxLen: 20, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Department', type: 'text', displayLabel: 'PROFILE.DEPARTMENT', visible: true, creatable: false, editable: true, inputType: 'text',
                    validation: {isRequired: false, maxLen: 20, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Status', type: 'text', displayLabel: 'PROFILE.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreateDate', type: 'text', displayLabel: 'PROFILE.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdateDate', type: 'text', displayLabel: 'PROFILE.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedBy', type: 'text', displayLabel: 'PROFILE.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedBy', type: 'text', displayLabel: 'PROFILE.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Settings', type: 'text', displayLabel: 'PROFILE.SETTINGS', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Gender', type: 'text', displayLabel: 'PROFILE.GENDER', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'DOB', type: 'text', displayLabel: 'PROFILE.DOB', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}}},
                { field: 'Nationality', type: 'text', displayLabel: 'PROFILE.NATIONALITY', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Address', type: 'text', displayLabel: 'PROFILE.ADDRESS', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Website', type: 'text', displayLabel: 'PROFILE.WEBSITE', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
            ],

            idField: 'Id',
            lookupDisplayField: '',
            methods: {
                update: updateUser,
                changePassword: changePassword
            }
        };

        function updateUser(id, userProfile) {
            return api.webPut(api.baseUrl + '/profile' , userProfile);
        }


        function changePassword(password) {
            return api.webPost($localStorage.authBaseUrl + '/changepassword' , password);
        }
    }
})();
(function() {
  'use strict';

  angular
      .module('app.main.plugins-consolidation')
      .run(runBlock);

  /* @ngInject */
  function runBlock(api, $state, activityLogger) {

      if(angular.isUndefined(api.plugin)) {
          api.plugin = {};
      }
      api.plugin.plugins = {
          modelPath: 'plugin.plugins',
          fields: [
              { field: 'Id', type: 'int', displayLabel: 'PLUGINS.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
                  validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
              { field: 'PluginPath', type: 'int', displayLabel: 'PLUGINS.FIELDS.PLUGIN_PATH', visible: true, creatable: false, editable: false, inputType: 'text',
                  validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
              { field: 'PluginSource', type: 'text', displayLabel: 'PLUGINS.FIELDS.PLUGIN_SOURCE', visible: true, creatable: false, editable: false, inputType: 'text',
                  validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
              { field: 'PluginType', type: 'text', displayLabel: 'PLUGINS.FIELDS.PLUGIN_TYPE', visible: true, creatable: false, editable: false, inputType: 'text',
                  validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
              { field: 'Version', type: 'text', displayLabel: 'PLUGINS.FIELDS.VERSION', visible: true, creatable: false, editable: false, inputType: 'text',
                  validation: {isRequired: false, maxLen: 50, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
              { field: 'CreatedDate', type: 'text', displayLabel: 'PLUGINS.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                  validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
              { field: 'UpdatedDate', type: 'text', displayLabel: 'PLUGINS.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                  validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
          ],
          uniqueConstraints: [],
          idField: 'Id',
          lookupDisplayField: 'PluginSource',
          isDirty: false,
          methods: {
              getList         :   getPlugins,
              create          :   createPlugin
          },
          views: {
              mainList: {
                  columns             : [ 'Id', 'PluginSource', 'PluginType', 'PluginPath', 'Version', 'CreatedDate', 'UpdatedDate' ],
                  columnFilter        : {},
                  topIndex            : 0,
                  showFilterRow       : false,
                  sortColumn          : {'UpdatedDate': false},
                  itemActions         : [
                                          { id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UploadPlugin', visible: true }
                                      ],
                  listActions         : [],
                  fabAction       : {id: 'add', label: 'ACTIONS.ADD', icon: 'icon-plus', privilege: 'UploadPlugin', visible: true}
              },
              privileges: {
                  list    : 'GetPlugins',
              }
          }
      };

      function getPlugins(generalProperties) {
          var promise;

          if(angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
              var state = {};
              state.name = $state.current.name;
              state.params = $state.params;
              var isBulk = true;
              var logData = activityLogger.createLogData(null, state, 'plugin.plugins', 'VIEW', isBulk, new Date(), null, null);

              promise = api.webGet(api.baseUrl + '/plugins', undefined, true, generalProperties.forceFetch);
              promise = activityLogger.log(logData, promise);
          }
          else {
              promise = api.webGet(api.baseUrl + '/plugins', undefined, true, generalProperties.forceFetch);
          }

          promise.then(function() {
              api.plugin.plugins.isDirty = false
          });
          return promise;
      }

      function createPlugin(record) {
          var state = {};
          state.name = $state.current.name;
          state.params = $state.params;
          var logData = activityLogger.createLogData(null, state, 'plugin.plugins', 'ADD', false, new Date(), null, null);
          var promise = api.webPut(api.baseUrl + '/plugins', record);

          promise.then(function() {
              api.plugin.plugins.isDirty = true;
          });
          return activityLogger.log(logData, promise);
      }

  }
})();
(function() {
    'use strict';

    angular
        .module('app.main.organizations')
        .run(runBlock);

    /* @ngInject */
    function runBlock(api, activityLogger, $state) {

      if(angular.isUndefined(api.organizations)) {
        api.organizations = {};
      }
      api.organizations.organizations = {
        modelPath: 'organizations.organizations',
        fields: [
          { field: 'Id', type: 'int', displayLabel: 'ORGANIZATIONS.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
            validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
          { field: 'Name', type: 'text', displayLabel: 'ORGANIZATIONS.FIELDS.NAME', visible: true, creatable: true, editable: true, inputType: 'text', checkIfUnique: true,
            validation: {isRequired: true, maxLen: 100, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
          { field: 'ContactPersonName', type: 'text', displayLabel: 'ORGANIZATIONS.FIELDS.CONTACT_PERSON_NAME', visible: true, creatable: true, editable: true, inputType: 'text',
            validation: {isRequired: false, maxLen: 50, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
          { field: 'Phone', type: 'int', displayLabel: 'ORGANIZATIONS.FIELDS.PHONE', visible: true, creatable: true, editable: true, inputType: 'tel',
            validation: {isRequired: false, maxLen: 20, minLen: 0, pattern: '[0-9]*', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: 'VALIDATIONS.INVALID_PHONE_NUMBER'}} },
          { field: 'EmailAddress', type: 'text', displayLabel: 'ORGANIZATIONS.FIELDS.EMAIL', visible: true, creatable: true, editable: true, inputType: 'text',
            validation: {isRequired: false, maxLen: 500, minLen: 0, pattern: '^[A-Za-z]+[A-Za-z0-9._+-]+@{1}[A-Za-z0-9._-]+\.[A-Za-z.]{2,}$', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: 'VALIDATIONS.INVALID_EMAIL'}} },
          { field: 'Website', type: 'text', displayLabel: 'ORGANIZATIONS.FIELDS.WEBSITE', visible: true, creatable: true, editable: true, inputType: 'url',
            validation: {isRequired: false, maxLen: 50, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '',
            invalidType: 'VALIDATIONS.INVALID_URL'}} },
          { field: 'CreatedDate', type: 'text', displayLabel: 'ORGANIZATIONS.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
            validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
          { field: 'UpdatedDate', type: 'text', displayLabel: 'ORGANIZATIONS.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
            validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
          { field: 'CreatedBy', type: 'text', displayLabel: 'ORGANIZATIONS.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
            validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
          { field: 'UpdatedBy', type: 'text', displayLabel: 'ORGANIZATIONS.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
            validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
        ],
        uniqueConstraints: [],
        title: 'ORGANIZATIONS.NAV',
        icon: 'icon-account',
        idField: 'Id',
        lookupDisplayField: 'Name',
        isDirty: false,
        methods: {
          getList         :   getOrganizations,
          getDetails      :   getOrganization,
          create          :   createOrganization,
          update          :   updateOrganization
        },
        views: {
          mainList: {
            columns             : [ 'Name', 'ContactPersonName', 'Phone', 'EmailAddress', 'Website', 'UpdatedDate' ],
            columnFilter        : {},
            toggleFilterProps   : {},
            topIndex            : 0,
            showFilterRow       : false,
            sortColumn          : {'UpdatedDate': false},
            sortDescending      : true,
            itemActions         : [
                                    { id: 'view', label: 'ACTIONS.VIEW', icon: 'icon-magnify', privilege: 'GetOrganizationDetails', disabled: false, visible: true },
                                    { id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UpdateOrganization', disabled: false, visible: true }
                                ],
            listActions         : [],
            fabAction           : { id: 'add', label: 'ACTIONS.ADD', icon: 'icon-plus', privilege: 'CreateOrganization', visible: true }
          },
          mainDetails: {
            selectedTabIndex    : 0,
            itemActions         : [],
            fabAction           : { id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UpdateOrganization', visible: true }
          },
          privileges: {
            list: 'GetOrganizationList',
            details: 'GetOrganizationDetails'
          }
        }
      };

      function getOrganizations(generalProperties) {
              var promise;

              if(angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
                  var state = {};
                  state.name = $state.current.name;
                  state.params = $state.params;
                  var isBulk = true;
                  var logData = activityLogger.createLogData(null, state, 'organizations.organizations', 'VIEW', isBulk, new Date(), null, null);

                  promise = api.webGet(api.baseUrl + '/organizations', undefined, true, generalProperties.forceFetch);
                  promise = activityLogger.log(logData, promise);
              }
              else {
                  promise = api.webGet(api.baseUrl + '/organizations', undefined, true, generalProperties.forceFetch);
              }

              promise.then(function() {
                  if (api.organizations.organizations.isDirty) {
                      //Invalidate lookupData
                      api.organizations.organizations.lookupData = undefined;
                      api.organizations.organizations.isDirty = false;
                  }
              });
              return promise;
      }

      function getOrganization(isLogRequired, organizationId) {
              var promise;

              if(angular.isDefined(isLogRequired) && isLogRequired === true) {
                  var state = {};
                  state.name = $state.current.name;
                  state.params = $state.params;
                  var isBulk = false;
                  var items= [];
                  promise = api.webGet(api.baseUrl + '/organizations/' + organizationId + '?status=0');
                  promise.then(function(response) {
                      items.push(response.data[api.organizations.organizations.lookupDisplayField]);
                  }, function(response) {
                      items.push(response.data[api.organizations.organizations.lookupDisplayField]);
                  });
                  var logData = activityLogger.createLogData(items, state, 'organizations.organizations', 'VIEW', isBulk, new Date(), null, null);
                  promise = activityLogger.log(logData, promise);
              }
              else {
                  promise = api.webGet(api.baseUrl + '/organizations/' + organizationId + '?status=0');
              }
              return promise;
      }

      function createOrganization(organization) {
              var state = {};
              state.name = $state.current.name;
              state.params = $state.params;
              var logData = activityLogger.createLogData(organization[api.organizations.organizations.lookupDisplayField], state, 'organizations.organizations', 'ADD', false, new Date(), null, null);
        var promise = api.webPost(api.baseUrl + '/organizations', organization);

              promise.then(function() {
                  api.organizations.organizations.isDirty = true;
              });
              return activityLogger.log(logData, promise);
      }

      function updateOrganization(organizationId, organization) {
          var state = {};
          state.name = $state.current.name;
          state.params = $state.params;
          var logData = activityLogger.createLogData(organization[api.organizations.organizations.lookupDisplayField], state, 'organizations.organizations', 'EDIT', false, new Date(), null, null);
          var promise = api.webPut(api.baseUrl + '/organizations/' + organizationId, organization);

          promise.then(function() {
              api.organizations.organizations.isDirty = true;
          });
          return activityLogger.log(logData, promise);
      }

    }
})();
(function () {
  'use strict';

  angular
    .module('app.main.notifications')
    .run(runBlock);

  /* @ngInject */
  function runBlock(api, activityLogger, $state) {

    if (angular.isUndefined(api.notifications)) {
      api.notifications = {};
    }
    api.notifications.notifications = {
      modelPath: 'notifications.notifications',
      fields: [
        { field: 'Id', type: 'int', displayLabel: 'NOTIFICATIONS.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
          validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } } },
        { field: 'UserId', type: 'int', displayLabel: 'NOTIFICATIONS.FIELDS.USER_ID', visible: true, creatable: false, editable: false, inputType: 'lookup', lookupSource: 'accounts.users',
          validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } } },
        { field: 'CustomerId', type: 'int', displayLabel: 'NOTIFICATIONS.FIELDS.CUSTOMER_ID', visible: true, creatable: false, editable: false, inputType: 'number',
          validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } } },
        {  field: 'Content', type: 'text', displayLabel: 'NOTIFICATIONS.FIELDS.CONTENT', visible: true, creatable: false, editable: false, inputType: 'text',
          validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } } },
        { field: 'Email', type: 'text', displayLabel: 'NOTIFICATIONS.FIELDS.EMAIL', visible: true, creatable: false, editable: false, inputType: 'text',
            validation: {isRequired: false, maxLen: 500, minLen: 0, pattern: '^[A-Za-z]+[A-Za-z0-9._+-]+@{1}[A-Za-z0-9._-]+\.[A-Za-z.]{2,}$', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: 'VALIDATIONS.INVALID_EMAIL'}} },
        { field: 'EntityId', type: 'int', displayLabel: 'NOTIFICATIONS.FIELDS.ENTITY_ID', visible: true, creatable: false, editable: false, inputType: 'number',
          validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } } },
        {  field: 'Channel', type: 'text', displayLabel: 'NOTIFICATIONS.FIELDS.CHANNEL', visible: true, creatable: false, editable: false, inputType: 'text',
          validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } } },
        { field: 'NotificationTypeId', type: 'int', displayLabel: 'NOTIFICATIONS.FIELDS.NOTIFICATION_TYPE_ID', visible: true, creatable: false, editable: false, inputType: 'number',
          validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } } },
        { field: 'NotificationType', type: 'text', displayLabel: 'NOTIFICATIONS.FIELDS.NOTIFICATION_TYPE', visible: true, creatable: false, editable: false, inputType: 'text',
          validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } } },
        { field: 'Title', type: 'text', displayLabel: 'NOTIFICATIONS.FIELDS.TITLE', visible: true, creatable: false, editable: false, inputType: 'text',
          validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } } },
        { field: 'Status', type: 'text', displayLabel: 'NOTIFICATIONS.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'notificationStatus',
          validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } } },
        { field: 'CreatedDateTime', type: 'text', displayLabel: 'NOTIFICATIONS.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
          validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } } },
        { field: 'SentDateTime', type: 'text', displayLabel: 'NOTIFICATIONS.FIELDS.SENT_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
          validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } } },
        { field: 'EmailStatus', type: 'text', displayLabel: 'NOTIFICATIONS.FIELDS.EMAIL_STATUS', visible: true, creatable: false, editable: false, inputType: 'text',
          validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } } },
        { field: 'ErrorReason', type: 'text', displayLabel: 'NOTIFICATIONS.FIELDS.ERROR_REASON', visible: true, creatable: false, editable: false, inputType: 'text',
          validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } } },
      ],
      uniqueConstraints: [],
      title: 'NOTIFICATIONS.NAV',
      icon: 'icon-alert-box',
      idField: 'Id',
      lookupDisplayField: '',
      isDirty: false,
      methods: {
        getList: getNotifications,
        getDetails: getNotification,
      },
      views: {
        mainList: {
          columns: ['Email', 'Channel', 'NotificationType', 'Title', 'Content', 'Status', 'SentDateTime'],
          columnFilter: {},
          toggleFilterProps: {},
          topIndex: 0,
          showFilterRow: false,
          sortColumn: {'SentDateTime': false},
          sortDescending: true,
          itemActions: [
            { id: 'view', label: 'ACTIONS.VIEW', icon: 'icon-magnify', privilege: 'GetNotificationDetails', disabled: false, visible: true }
          ],
          listActions: [ ],
          fabAction: {}
        },
        mainDetails: {
          selectedTabIndex: 0,
          itemActions: [],
          fabAction: {}
        },
        privileges: {
          list: 'GetAllNotification',
          details: 'GetNotificationDetails'
        }
      }

    };

    function getNotifications(generalProperties) {
      var promise;

      if (angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
        var state = {};
        state.name = $state.current.name;
        state.params = $state.params;
        var isBulk = true;
        var logData = activityLogger.createLogData(null, state, 'notifications.notifications', 'VIEW', isBulk, new Date(), null, null);

        promise = api.webGet(api.baseUrl + '/notifications', undefined, true, generalProperties.forceFetch);
        promise = activityLogger.log(logData, promise);
      }
      else {
        promise = api.webGet(api.baseUrl + '/notifications', undefined, true, generalProperties.forceFetch);
      }

      promise.then(function () {
        if (api.notifications.notifications.isDirty) {
          //Invalidate lookupData
          api.notifications.notifications.lookupData = undefined;
          api.notifications.notifications.isDirty = false;
        }
      });
      return promise;
    }

    function getNotification(isLogRequired, notificatoinId) {
      var promise;

      if (angular.isDefined(isLogRequired) && isLogRequired === true) {
        var state = {};
        state.name = $state.current.name;
        state.params = $state.params;
        var isBulk = false;
        var items = [];
        promise = api.webGet(api.baseUrl + '/notifications/' + notificatoinId + '?status=0');
        promise.then(function (response) {
          items.push(response.data[api.notifications.notifications.lookupDisplayField]);
        }, function (response) {
          items.push(response.data[api.notifications.notifications.lookupDisplayField]);
        });
        var logData = activityLogger.createLogData(items, state, 'notifications.notifications', 'VIEW', isBulk, new Date(), null, null);
        promise = activityLogger.log(logData, promise);
      }
      else {
        promise = api.webGet(api.baseUrl + '/notifications/' + notificatoinId + '?status=0');
      }
      return promise;
    }

  }
})();
(function ()
{
    'use strict';

    angular
        .module('app.main.landing', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        $stateProvider.state('app.pages_landing', {
            url      : '/',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/landing/landing.html',
                    controller : 'LandingController as vm'
                }
            },
            resolve  : {
            },
            data: {
                displayName: 'LANDING.TITLE'
            },
            bodyClass: 'landing',
            visibleForLinePlan: true
        });

        $translatePartialLoaderProvider.addPart('app/main/landing');

        msNavigationServiceProvider.saveItem('main.welcome', {
            title      : 'Welcome',
            icon       : 'icon-coffee',
            state      : 'app.pages_landing',
            translate  : 'LANDING.NAV',
            weight     : 0,
            visibleForLinePlan: true
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.main.landing')
        .controller('LandingController', LandingController);

    /** @ngInject */
    function LandingController(api, $localStorage, $state, $log, catalogFactory, $scope, $rootScope, SecurityFactory, CONSTANTS) {
        /* jshint validthis: true */
        var vm = this;

        vm.profile = $localStorage.profileInformation;
        vm.catalogs = [];
        vm.activeCatalog = {};

        // Methods
        vm.gotoProfile = gotoProfile;
        vm.activateCatalog = activateCatalog;

        activate();

        //////////


        function activate() {
            if(angular.isUndefined(vm.profile)) {
                refreshProfile();
            }
            refreshCatalogs(false);
        }

        function refreshProfile() {
            api.roles.roles.methods.getProfileInformation().then(function(response) {
                vm.profile = $localStorage.profileInformation = response.data;
            }).catch(function(){
                $log.warn('#landing.ProfileController: could not update profileInformation in localStorage');
            });
        }

        function refreshCatalogs(forceFetch) {
            if(angular.isDefined(vm.activeCatalog) && SecurityFactory.isAuthorized({accessPrivileges: CONSTANTS.PRIVILEGES.CATALOGS.LIST.CATALOG_GET_LIST})) {
                api.catalogs.catalogs.methods.getList( { forceFetch: forceFetch, isLogRequired: false}).then(function (response) {
                    vm.catalogs = [];
                    angular.forEach(response.data, function(item) {
                        if (item.Id !== vm.activeCatalog.Id && item.Status == 1) {
                            vm.catalogs.push(item);
                        }
                    });
                });
            }

            vm.activeCatalog = $localStorage['ActiveCatalog'];
        }

        function gotoProfile() {
            $state.go('app.pages_profile')
        }

        function activateCatalog(catalog) {
            catalogFactory.setActiveCatalog(catalog).then(function () {
                refreshCatalogs(true);
                vm.activeCatalog = catalogFactory.getActiveCatalog();
                for (var path in api.catalogs) { // invalidate catalog's sub-entities lookup data on active catalog change
                    if (path.indexOf('catalogs') !== 0 && api.catalogs[path].lookupData) {
                        api.catalogs[path].lookupData = undefined;
                    }
                }
                //Following are the modules which refer to active catalog for load lookup if any
                if (api.customers.customers.lookupData) {
                    api.customers.customers.lookupData = undefined;
                }
                if (api.sellers.resourceTypes.lookupData) {
                    api.sellers.resourceTypes.lookupData = undefined;
                }
                if (api.sellers.users.lookupData) {
                    api.sellers.users.lookupData = undefined;
                }
                if (api.sellers.vas.lookupData) {
                    api.sellers.vas.lookupData = undefined;
                }
                if (api.customers.favorites.lookupData) {
                    api.customers.favorites.lookupData = undefined;
                }
                if (api.customers.segmentations.lookupData) {
                    api.customers.segmentations.lookupData = undefined;
                }
                if (api.catalogCustomers.segmentation.lookupData) {
                    api.catalogCustomers.segmentation.lookupData = undefined;
                }
                if (api.consolidationTemplates.templateFields) {
                    api.consolidationTemplates.templateFields.lookupData = undefined;
                }

                $scope.$emit('ActiveCatalogChangedEvent', vm.activeCatalog);
                $rootScope.$emit('CatalogActivationEvent'); // to change toolbar background color according to catalog
                if(vm.activeCatalog.IsLinePlan === 1 && $state.current.name != 'app.articles'){ // if line plan catalog and current state is not article, then navigate to articles list page
                    $state.go('app.articles');
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.main.jobs')
        .run(runBlock);

    /* @ngInject */
    function runBlock(api) {

        if(angular.isUndefined(api.jobs)) {
            api.jobs = {};
        }
        api.jobs = {
            modelPath: 'jobs',
            fields: [
                { field: 'Id', type: 'int', displayLabel: 'JOBS.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'StatusId', type: 'int', displayLabel: 'JOBS.FIELDS.STATUS_ID', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Status', type: 'text', displayLabel: 'JOBS.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'EntityName', type: 'text', displayLabel: 'JOBS.FIELDS.ENTITY_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'FileName', type: 'text', displayLabel: 'JOBS.FIELDS.FILE_NAME', visible: false, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: 50, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'SourceApplication', type: 'text', displayLabel: 'JOBS.FIELDS.SOURCE_APPLICATION', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: 50, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'SourceAction', type: 'text', displayLabel: 'JOBS.FIELDS.SOURCE_ACTION', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: 50, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'SellerAccountId', type: 'int', displayLabel: 'JOBS.FIELDS.SELLER_ACCOUNT_ID', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CustomerCode', type: 'int', displayLabel: 'JOBS.FIELDS.CUSTOMER_CODE', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Reference', type: 'text', displayLabel: 'JOBS.FIELDS.REFERENCE', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CatalogCode', type: 'text', displayLabel: 'JOBS.FIELDS.CATALOG', visible: true, creatable: false, editable: false, inputType: 'lookup', lookupSource:'catalogs.catalogs',
                    validation: {isRequired: false, maxLen: 100, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UploadedBy', type: 'text', displayLabel: 'JOBS.FIELDS.UPLOADED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedDate', type: 'text', displayLabel: 'JOBS.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedDate', type: 'text', displayLabel: 'JOBS.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ImportErrorList', type: 'text', displayLabel: 'JOBS.FIELDS.IMPORT_ERROR_LIST', visible: false, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
            ],
            uniqueConstraints: [

            ],
            idField: 'Id',
            lookupDisplayField: 'EntityName',
            isDirty: false,
            methods: {
                getList         :   getJobs,
                getDetails      :   getJob
            },
            views: {
                mainList: {
                    columns             : [ 'Id', 'EntityName', 'Status', 'CatalogCode', 'SourceApplication', 'SourceAction', 'CreatedDate', 'UpdatedDate' ],
                    columnFilter        : {},
                    topIndex            : 0,
                    showFilterRow       : false,
                    sortColumn          : {'CreatedDate': false},
                    itemActions         : [
                                            { id: 'view', label: 'ACTIONS.VIEW', icon: 'icon-magnify', privilege: 'GetJsonBackGroundJobDetails', disabled: '', visible: true }
                                        ],
                    listActions         : [
                                        ],
                    fabAction           : undefined
                },
                mainDetails: {
                    selectedTabIndex    : 0,
                    itemActions         : [
                        { id: 'downloadJobRequest', label: 'JOBS.ACTIONS.DOWNLOAD_REQUEST', icon: 'icon-download', privilege: 'SpecialPermissionToDownloadJobFile:true', disabled: 'false', visible: 'true'}
                    ],
                    fabAction           : undefined
                },
                privileges: {
                    list    : 'GetJsonBackGroundJobList',
                    details : 'GetJsonBackGroundJobDetails'
                }
            }

        };

        api.jobErrors = {
            fields: [
                { field: 'Id', type: 'int', displayLabel: 'JOBS.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Operation', type: 'text', displayLabel: 'JOBS.FIELDS.OPERATION', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Key', type: 'text', displayLabel: 'JOBS.FIELDS.KEY', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ErrorType', type: 'text', displayLabel: 'JOBS.FIELDS.ERROR_TYPE', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'ErrorMessage', type: 'text', displayLabel: 'JOBS.FIELDS.ERROR_MESSAGE', visible: true, creatable: false, editable: false, inputType: 'textArea',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'RecordLineNumber', type: 'text', displayLabel: 'JOBS.FIELDS.RECORD_LINE_NUMBER', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: 50, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreateDate', type: 'text', displayLabel: 'JOBS.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
            ],
            uniqueConstraints: [

            ],
            idField: 'Id',
            lookupDisplayField: 'Id',
            isDirty: false,
            methods: {
                getList         :   getJobs
            },
            views: {
                mainList: {
                    columns             : [ 'Id', 'Operation', 'Key', 'ErrorType', 'ErrorMessage', 'RecordLineNumber', 'CreateDate' ],
                    columnFilter        : {},
                    topIndex            : 0,
                    showFilterRow       : false,
                    sortColumn          : {'CreateDate': false},
                    sortDescending      : true,
                    itemActions         : [
                                            { id: 'view', label: 'ACTIONS.VIEW', icon: 'icon-magnify', privilege: 'GetJsonBackGroundJobDetails', disabled: '', visible: true }
                                        ],
                    listActions         : [
                                        ],
                    fabAction           : undefined
                },
                mainDetails: {
                    selectedTabIndex    : 0,
                    itemActions         : [],
                    fabAction           : undefined
                },
                privileges: {
                    list    : 'GetJsonBackGroundJobList'
                }
            }

        };

        function getJobs(generalProperties) {
            if (generalProperties.forceFetch) {
                api.jobs.lookupData = undefined;
                api.jobs.isDirty = false;
            }

            return api.webGet(api.baseUrl + '/backgroundjobs/json', undefined, true, generalProperties.forceFetch);
		}

		function getJob(jobId) {
			return api.webGet(api.baseUrl + '/backgroundjobs/json/' + jobId);
		}

    }
})();
(function() {
  'use strict';

  angular
      .module('app.main.hangfire-dashboard')
      .run(runBlock);

  /* @ngInject */
  function runBlock(api) {

      if(angular.isUndefined(api.hangfireDashboard)) {
          api.hangfireDashboard = {};
      }
      api.hangfireDashboard = {
          modelPath: 'hangfireDashboard',
          fields: [],
          uniqueConstraints: [],
          idField: 'Id',
          lookupDisplayField: '',
          isDirty: false,
          methods: {},
          views: {
              mainList: {
                  columns             : [],
                  columnFilter        : {},
                  topIndex            : 0,
                  showFilterRow       : false,
                  sortColumn          : {},
                  itemActions         : [],
                  listActions         : [
                                      ],
                  fabAction           : undefined
              },
              mainDetails: {
                  selectedTabIndex    : 0,
                  itemActions         : [],
                  fabAction           : undefined
              },
              privileges: {
                  list    : 'AllowHangfireDashboardAccess'
              }
          }

      };
  }
})();
(function() {
	'use strict';

	angular
        .module('app.main.errors', [])
        .config(config);

    /* @ngInject */
    function config($stateProvider) {
        // State
        $stateProvider.state('app.errors', {
            url    : '/error',
            params : {message: 'Sorry for the inconvenience caused, please contact application administrator regarding this issue.'},
            views  : {
                'content@app': {
                    templateUrl: 'app/main/errors/errors.html',
                    controller : 'errorsController as vm'
                }
            },
            resolve: {
            },
            data: {
                displayName: ''
            },
        });
    }
})();
(function() {
    'use strict';

	angular
		.module('app.main.errors')
		.controller('errorsController', errorsController);

	/* @ngInject */
	function errorsController($stateParams) {
		/* jshint validthis: true */
		var vm = this;
        
        vm.message = $stateParams.message;
        
    }
    
})();
        
(function () {
	'use strict';

	angular
		.module('app.main.data-containers')
		.run(runBlock);

	/* @ngInject */
	function runBlock(api, activityLogger, $state, jobsTracker, CONSTANTS) {

		if (angular.isUndefined(api.dataContainers)) {
			api.dataContainers = {};
		}
		api.dataContainers.dataContainers = {
			modelPath: 'dataContainers.dataContainers',
			fields: [
				{ field: 'Id', type: 'int', displayLabel: 'DATA_CONTAINERS.FIELDS.ID', visible: true, creatable: false, editable: false, inputType: 'number',
					validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } } },
				{ field: 'CatalogCode', type: 'int', displayLabel: 'DATA_CONTAINERS.FIELDS.CATALOG_CODE', visible: true, creatable: true, editable: false, inputType: 'number',
					validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'CatalogName', type: 'int', displayLabel: 'DATA_CONTAINERS.FIELDS.CATALOG_NAME', visible: true, creatable: false, editable: false, inputType: 'lookup', lookupSource: 'catalogs.catalogs',
					validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', disabledCriteria: 'vm.record.DataSourceTypeId === 1', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'Status',  map:'Status', type: 'text', displayLabel: 'DATA_CONTAINERS.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
					validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'ContainerName', type: 'text', displayLabel: 'DATA_CONTAINERS.FIELDS.CONTAINER_NAME', visible: true, creatable: true, editable: false, inputType: 'text',
					validation: {isRequired: true, maxLen: 1000, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'ContainerValue', type: 'text', displayLabel: 'DATA_CONTAINERS.FIELDS.CONTAINER_VALUE', visible: false, creatable: true, editable: false, inputType: 'textArea',
					validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', checkIfValidJson: true, messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '', isValidJson: 'VALIDATIONS.INVALID_JSON'}} },
					// we are calling different api for get details ContainerName field is Name
				{ field: 'Name', type: 'text', displayLabel: 'DATA_CONTAINERS.FIELDS.CONTAINER_NAME', visible: false, creatable: false, editable: false, showInEdit: true, inputType: 'text',
					validation: {isRequired: true, maxLen: 1000, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
				{ field: 'Value', type: 'text', displayLabel: 'DATA_CONTAINERS.FIELDS.CONTAINER_VALUE', visible: false, creatable: false, editable: true, inputType: 'textArea',
					validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', checkIfValidJson: true, messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '', isValidJson: 'VALIDATIONS.INVALID_JSON'}} },
				{ field: 'CreatedDate', type: 'text', displayLabel: 'DATA_CONTAINERS.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
					validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } } },
				{ field: 'UpdatedDate', type: 'text', displayLabel: 'DATA_CONTAINERS.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
					validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } } },
				{ field: 'CreatedBy', type: 'text', displayLabel: 'DATA_CONTAINERS.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
					validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } } },
				{ field: 'UpdatedBy', type: 'text', displayLabel: 'DATA_CONTAINERS.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
					validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } } },
			],
			uniqueConstraints: [{name: 'Constraint 1', fields: ['CatalogCode', 'ContainerName']}],
			title: 'DATA_CONTAINERS.NAV',
			icon: 'icon-library-books',
			idField: 'Id',
			lookupDisplayField: 'ContainerName',
			isDirty: false,
			methods: {
				getList       : getDataContainersList,
				createBulk    : createBulk,
				getDetails    : getDataContainerDetails,
				update        : updateDataContainer
			},
			views: {
				mainList: {
					columns: ['CatalogCode', 'CatalogName', 'ContainerName', 'ContainerValue', 'Status', 'UpdatedBy', 'UpdatedDate'],
					columnFilter: {},
					toggleFilterProps: {},
					topIndex: 0,
					showFilterRow: false,
					sortColumn: {'UpdatedDate': false},
					sortDescending: true,
					itemActions: [
												{ id: 'view', label: 'ACTIONS.VIEW', icon: 'icon-magnify', privilege: 'GetUserDataContainers', disabled: false, visible: true },
												{ id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'ModifyDataContainerValue:true', disabled: false, visible: true }
					],
					listActions: [
												{ id: 'import', label: 'ACTIONS.IMPORT', icon: 'icon-import', privilege: 'ImportDataContainers:true', disabled: false, visible: true, requiresConfirmation: false}
											],
					fabAction :     {}
				},
				mainDetails: {
					selectedTabIndex   : 0,
					itemActions         : [],
					fab                 : {id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'ModifyDataContainerValue:true', visible: true}
				},
				privileges: {
					list: 'GetAllDataContainers',
					details : 'GetDataContainer'
				}
			}
		};

		function getDataContainersList(generalProperties, model) {
			if (angular.isDefined(model)) { // to skip this part for load lookup
				model.isBulkActionCompleted = false;
			}
			var promise;

			if (angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
				var state = {};
				state.name = $state.current.name;
				state.params = $state.params;
				var isBulk = true;
				var logData = activityLogger.createLogData(null, state, 'dataContainers.dataContainers', 'VIEW', isBulk, new Date(), null, null);

				promise = api.webGet(api.baseUrl + '/datacontainers', undefined, true, generalProperties.forceFetch);
				promise = activityLogger.log(logData, promise);
			}
			else {
				promise = api.webGet(api.baseUrl + '/datacontainers', undefined, true, generalProperties.forceFetch);
			}

			promise.then(function () {
				if (api.dataContainers.dataContainers.isDirty) {
					//Invalidate lookupData
					api.dataContainers.dataContainers.lookupData = undefined;
					api.dataContainers.dataContainers.isDirty = false;
				}
			});
			return promise;
		}

		function createBulk(model, data) {
			var jobIndex = jobsTracker.addJob(model, 'DATA_CONTAINERS.ACTIONS.IMPORT_DATA_CONTAINERS', 1);
			api.webPut(api.baseUrl + '/datacontainers/import?sourceapplication=' + CONSTANTS.SOURCE_APPLICATION + '&sourceaction=Import Data Containers', data).then(function(response) {
				jobsTracker.trackJob(jobIndex, response.data.Id);
			}).catch(function(error) {
				jobsTracker.setCriticlaFail(jobIndex, error);
			});
		}

		function getDataContainerDetails(isLogRequired, containerId) {
			var promise;
			if(angular.isDefined(isLogRequired) && isLogRequired === true) {
				var state = {};
				state.name = $state.current.name;
				state.params = $state.params;
				var isBulk = false;
				var items = [];
				promise = api.webGet(api.baseUrl + '/mydatacontainers/' + containerId);
				promise.then(function(response) {
					items.push(response.data[api.dataContainers.dataContainers.lookupDisplayField]);
				});
				var logData = activityLogger.createLogData(items, state, 'dataContainers.dataContainers', 'VIEW', isBulk, new Date(), null, null);
				promise = activityLogger.log(logData, promise);
			}
			else {
				promise = api.webGet(api.baseUrl + '/mydatacontainers/' + containerId);
			}
			return promise;
		}

		function updateDataContainer(containerId, record) {
			var requestIObj = angular.copy(record);
			requestIObj['ContainerValue'] = requestIObj.Value;
			delete requestIObj['Value'];
			var state = {};
			state.name = $state.current.name;
			state.params = $state.params;
			var logData = activityLogger.createLogData(record[api.dataContainers.dataContainers.lookupDisplayField], state, 'dataContainers.dataContainers', 'EDIT', false, new Date(), null, null);
			var promise = api.webPut(api.baseUrl + '/datacontainers/' + containerId, requestIObj);

			promise.then(function () {
				api.dataContainers.dataContainers.isDirty = true;
			});
			return activityLogger.log(logData, promise);
		}

	}
})();
(function() {
    'use strict';

    angular
        .module('app.main.customers')
        .run(runBlock);

    /* @ngInject */
    function runBlock(api, activityLogger, $state, $filter, crud, catalogFactory, jobsTracker, CONSTANTS) {

        if(angular.isUndefined(api.customers)) {
            api.customers = {};
        }
        api.customers.customers = {
            modelPath: 'customers.customers',
            fields: [
                { field: 'CustomerId', type: 'int', displayLabel: 'CUSTOMERS.FIELDS.CUSTOMER_ID', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Name', type: 'text', displayLabel: 'CUSTOMERS.FIELDS.NAME', visible: true, creatable: true, editable: true, inputType: 'text',
                    validation: {isRequired: false, maxLen: 50, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CustomerNumber', type: 'text', displayLabel: 'CUSTOMERS.FIELDS.CUSTOMER_NUMBER', visible: true, creatable: true, editable: true, inputType: 'text',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '[A-Za-z0-9_-]+', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: 'VALIDATIONS.INVALID_CHARACTERS'}} },
                { field: 'EmailAddress', type: 'text', displayLabel: 'CUSTOMERS.FIELDS.EMAIL', visible: true, creatable: true, editable: true, inputType: 'text',
                    validation: {isRequired: false, maxLen: 500, minLen: 0, pattern: '^[A-Za-z]+[A-Za-z0-9._+-]+@{1}[A-Za-z0-9._-]+\.[A-Za-z.]{2,}$', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: 'VALIDATIONS.INVALID_EMAIL'}} },
                { field: 'SalesOrg', type: 'text', displayLabel: 'CUSTOMERS.FIELDS.SALES_ORG', visible: true, creatable: true, editable: true, inputType: 'text',
                    validation: {isRequired: false, maxLen: 100, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Division', type: 'text', displayLabel: 'CUSTOMERS.FIELDS.DIVISION', visible: true, creatable: true, editable: true, inputType: 'text',
                    validation: {isRequired: false, maxLen: 250, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'SellerAccountId', type: 'text', displayLabel: 'CUSTOMERS.FIELDS.SELLER_ID', visible: true, creatable: false, editable: false, inputType: 'lookup', lookupSource:'accounts.sellers',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'SellerAccountName', type: 'text', displayLabel: 'CUSTOMERS.FIELDS.SELLER_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CustomerCategory', type: 'text', displayLabel: 'CUSTOMERS.FIELDS.CUSTOMER_CATEGORY', visible: true, creatable: true, editable: true, inputType: 'text',
                    validation: {isRequired: false, maxLen: 250, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CustomerChannel', type: 'text', displayLabel: 'CUSTOMERS.FIELDS.CUSTOMER_CHANNEL', visible: true, creatable: true, editable: true, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Discount', type: 'int', displayLabel: 'CUSTOMERS.FIELDS.DISCOUNT', visible: true, creatable: true, editable: true, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'LeadTime', type: 'int', displayLabel: 'CUSTOMERS.FIELDS.LEAD_TIME', visible: true, creatable: true, editable: true, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'AutoApproveOrders', type: 'text', displayLabel: 'CUSTOMERS.FIELDS.AUTO_APPROVE_ORDERS', visible: true, creatable: true, editable: true, inputType: 'bool-int',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Address', type: 'text', displayLabel: 'CUSTOMERS.FIELDS.ADDRESS', visible: true, creatable: true, editable: true, inputType: 'textArea',
                    validation: {isRequired: false, maxLen: 100, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'OrderTypes', type: 'text', displayLabel: 'CUSTOMERS.FIELDS.ORDER_TYPES', visible: false, creatable: true, editable: true, inputType: 'lookup-many', lookupSource:'sellers.orderTypes',
                    lookupFilter: {Status: 1}, validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', disabledCriteria: 'vm.record.UseOrderType == 0', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'OrderTypesValue', type: 'text', displayLabel: 'CUSTOMERS.FIELDS.ORDER_TYPES', visible: true, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'OrderTypesValue_string', type: 'text', displayLabel: 'CUSTOMERS.FIELDS.ORDER_TYPES', visible: false, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: 3000, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Status', type: 'text', displayLabel: 'CUSTOMERS.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedDate', type: 'text', displayLabel: 'CUSTOMERS.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedDate', type: 'text', displayLabel: 'CUSTOMERS.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CreatedBy', type: 'text', displayLabel: 'CUSTOMERS.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'UpdatedBy', type: 'text', displayLabel: 'CUSTOMERS.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'LocationsResponses', type: 'text', displayLabel: 'CUSTOMERS.FIELDS.LOCATIONS_RESPONSES', visible: false, creatable: false, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'DPAccountGroup',  type: 'text', displayLabel: 'CUSTOMERS.FIELDS.DP_ACCOUNT_GROUP', visible: true, creatable: true, editable: true, inputType: 'text',
                    validation: {isRequired: false, maxLen: 500, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
            ],
            uniqueConstraints: [
                {name: 'Constraint 1', fields: ['CustomerNumber']}
            ],
            idField: 'CustomerId',
            lookupDisplayField: 'CustomerNumber',
            isDirty: false,
            methods: {
                getList         :   getCustomers,
                getDetails      :   getCustomer,
                activateBulk    :   activateCustomers,
                create          :   createCustomer,
                update          :   updateCustomer,
                createBulk      :   createBulk
            },
            views: {
                mainList: {
                    columns             : [ 'CustomerNumber', 'Name', 'SellerAccountName', 'Status', 'UpdatedDate' ],
                    columnFilter        : {},
                    toggleFilterProps   : { toggleStatus:false, filterProp:'Status', trueVal:1, trueValTooltipMessage: 'ACTIONS.TOGGLE_ACTIVE', falseVal:'', falseValTooltipMessage:"ACTIONS.TOGGLE_ALL"},
                    topIndex            : 0,
                    showFilterRow       : false,
                    sortColumn          : {'UpdatedDate': false},
                    itemActions         : [
                                            { id: 'view', label: 'ACTIONS.VIEW', icon: 'icon-magnify', privilege: 'GetSellerCustomerDetails', disabled: '!itm.Status', visible: true },
                                            { id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UpdateSellerCustomer', disabled: '!itm.Status', visible: true },
                                            { id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateCustomerStatusBulk', disabled: false, visible: 'itm.Status',
                                                requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                                            { id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateCustomerStatusBulk', disabled: false, visible: '!itm.Status',
                                                requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
                                        ],
                    listActions         : [
                                            { id: 'delete', label: 'ACTIONS.DELETE_BULK', icon: 'icon-delete', privilege: 'UpdateCustomerStatusBulk', disabled: '{selected: true, Status: 1}', visible: true,
                                                requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                                            { id: 'activate', label: 'ACTIONS.ACTIVATE_BULK', icon: 'icon-undo-variant', privilege: 'UpdateCustomerStatusBulk', disabled: '{selected: true, Status: 0}', visible: true,
                                                requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'},
                                            { id: 'import', label: 'ACTIONS.IMPORT', icon: 'icon-import', privilege: 'CreateUpdateSellerBulkCustomers', disabled: false, visible: true, requiresConfirmation: false },
                                            { id: 'import_loc', label: 'LOCATIONS.ACTIONS.IMPORT_LOC', icon: 'icon-stackoverflow', privilege: 'UpdateSellerBulkCustomersCustomersLocations', disabled: false, visible: true, requiresConfirmation: false }
                                        ],
                    fabAction           : {id: 'add', label: 'ACTIONS.ADD', icon: 'icon-plus', privilege: 'CreateSellerCustomer', visible: true}
                },
                mainDetails: {
                    selectedTabIndex    : 0,
                    itemActions         : [
                                            { id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateCustomerStatusBulk', disabled: '{selected: true, Status: 1}',
                                                visible: true, requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
                                            { id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateCustomerStatusBulk', disabled: '{selected: true, Status: 0}',
                                                visible: true, requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
                                            ],
                    fab           : {id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UpdateSellerCustomer', visible: true}
                },
                privileges: {
                    list    : 'GetSellerCustomerList',
                    details : 'GetSellerCustomerDetails'
                }
            }

        };

        //Model used for bulk import of locations (temporary ?)
        api.customers.customersLocations = {
            fields: [
                { field: 'Id', type: 'int', displayLabel: 'LOCATIONS.FIELDS._ID', visible: true, creatable: false, editable: false, inputType: 'number',
                    validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'CustomerNumber', type: 'int', displayLabel: 'LOCATIONS.FIELDS.CUSTOMER_NUMBER', visible: true, creatable: true, editable: true, inputType: 'text',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'LocationCode', type: 'text', displayLabel: 'LOCATIONS.FIELDS.LOCATATION_CODE', visible: true, creatable: true, editable: false, inputType: 'text',
                    validation: {isRequired: true, maxLen: 50, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'AddressName', type: 'text', displayLabel: 'LOCATIONS.FIELDS.NAME', visible: true, creatable: true, editable: false, inputType: 'text',
                    validation: {isRequired: true, maxLen: 50, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Address', type: 'text', displayLabel: 'LOCATIONS.FIELDS.ADDRESS', visible: true, creatable: true, editable: true, inputType: 'text',
                    validation: {isRequired: false, maxLen: 100, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'City', type: 'text', displayLabel: 'LOCATIONS.FIELDS.CITY', visible: true, creatable: true, editable: true, inputType: 'text',
                    validation: {isRequired: false, maxLen: 25, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'State', type: 'text', displayLabel: 'LOCATIONS.FIELDS.STATE', visible: false, creatable: true, editable: true, inputType: 'text',
                    validation: {isRequired: false, maxLen: 25, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Zip', type: 'text', displayLabel: 'LOCATIONS.FIELDS.ZIP', visible: true, creatable: true, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: 7, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Country', type: 'lookup', displayLabel: 'LOCATIONS.FIELDS.COUNTRY', visible: true, creatable: true, editable: false, inputType: 'lookup', lookupSource: 'lists.countries',
                    validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'LocationReference', type: 'text', displayLabel: 'LOCATIONS.FIELDS.LOCATION_REFERENCE', visible: true, creatable: true, editable: true, inputType: 'text',
                    validation: {isRequired: false, maxLen: 200, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
                { field: 'Phone', type: 'text', displayLabel: 'LOCATIONS.FIELDS.PHONE', visible: true, creatable: true, editable: false, inputType: 'text',
                    validation: {isRequired: false, maxLen: 15, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
            ],
            uniqueConstraints: [
                {name: 'Constraint 1', fields: ['CustomerNumber', 'LocationCode']}
            ],
            idField: 'Id',
            lookupDisplayField: 'LocationCode',
            isDirty: false,
            methods: {
                createBulk      :   createBulkLocations
            },
            views: {
                mainList: {

                },
                mainDetails: {

                },
                privileges: {
                    list    : 'GetSellerCustomerList',
                    details : 'GetSellerCustomerDetails'
                }
            }
        };

        function getCustomers(generalProperties, model, sellerId) {
            if(angular.isDefined(model)) { // to skip this part for load lookup
                model.isBulkActionCompleted = false;
            }
            var promise;

            if(angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
                var state = {};
                state.name = $state.current.name;
                state.params = $state.params;
                var isBulk = true;
                var logData = activityLogger.createLogData(null, state, 'customers.customers', 'VIEW', isBulk, new Date(), null, null);

                promise = api.webGet(api.baseUrl + '/sellers/' + sellerId + '/customers',
                generalProperties.config || {}, true, generalProperties.forceFetch,
                generalProperties.supportIncrementalResult || true,
                generalProperties.modelIdField,
                generalProperties.isMajor || false,
                generalProperties.model || api.customers.customers);
                promise = activityLogger.log(logData, promise);
            }
            else {
                sellerId = angular.isUndefined(sellerId) ? catalogFactory.getActiveCatalog().AccountId : sellerId;
                promise = api.webGet(api.baseUrl + '/sellers/' + sellerId + '/customers',
                generalProperties.config || {}, true, generalProperties.forceFetch,
                generalProperties.supportIncrementalResult || true,
                generalProperties.modelIdField,
                generalProperties.isMajor || false,
                generalProperties.model || api.customers.customers);
            }

            promise.then(function() {
                if (api.customers.customers.isDirty) {
                    //Invalidate lookupData
                    api.customers.customers.lookupData = undefined;
                    api.customers.customers.isDirty = false;
                }
            });
            return promise;
		}

		function getCustomer(isLogRequired, recordId, parentId) {
            var promise;
            if(angular.isDefined(isLogRequired) && isLogRequired === true) {
                var state = {};
                state.name = $state.current.name;
                state.params = $state.params;
                var isBulk = false;
                var items= [];
                promise = api.webGet(api.baseUrl + '/sellers/' + parentId + '/customers/' + recordId + '?status=0');
                promise.then(function(response) {
                    items.push(response.data[api.customers.customers.lookupDisplayField]);
                }, function(response) {
                    items.push(response.data[api.customers.customers.lookupDisplayField]);
                });
                var logData = activityLogger.createLogData(items, state, 'customers.customers', 'VIEW', isBulk, new Date(), null, null);
                promise = activityLogger.log(logData, promise);
            }
            else {
                promise = api.webGet(api.baseUrl + '/sellers/' + parentId + '/customers/' + recordId + '?status=0');
            }
            return promise;
		}

		function activateCustomers(records, model, actionType, parentId) {
            var result = crud.createRequestObject(records, model, actionType);
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var isBulk = result.itemsNameList.length > 1 ? true : false;
            var logData = activityLogger.createLogData(result.itemsNameList, state, 'customers.customers', actionType.toUpperCase(), isBulk, new Date(), null, null);
			var promise = api.webPut(api.baseUrl + '/sellers/' + parentId + '/customers/status', result.requestObj);

             promise.then(function() {
                crud.onRecordStatusChange(records, model, actionType);
                api.catalogs.customers.isDirty = true;
            });

            return activityLogger.log(logData, promise);
		}

		function createCustomer(record, parentId) {
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var logData = activityLogger.createLogData(record[api.customers.customers.lookupDisplayField], state, 'customers.customers', 'ADD', false, new Date(), null, null);
			var promise = api.webPost(api.baseUrl + '/sellers/' + parentId + '/customers', record);

            promise.then(function() {
                api.customers.customers.isDirty = true;
                api.catalogs.customers.isDirty = true;
            });
            return activityLogger.log(logData, promise);
		}

		function updateCustomer(recordId, record, parentId) {
            var state = {};
            state.name = $state.current.name;
            state.params = $state.params;
            var logData = activityLogger.createLogData(record[api.customers.customers.lookupDisplayField], state, 'customers.customers', 'EDIT', false, new Date(), null, null);
			var promise = api.webPut(api.baseUrl + '/sellers/' + parentId + '/customers/' + recordId, record);

            promise.then(function() {
                api.customers.customers.isDirty = true;
                api.catalogs.customers.isDirty = true;
            });
            return activityLogger.log(logData, promise);
		}

        function createBulk(data, sellerId, model) {
            var jobIndex = jobsTracker.addJob(model, 'CUSTOMERS.ACTIONS.IMPORT_CUSTOMERS', 1);
            api.webPut(api.baseUrl + '/sellers/' + sellerId + '/bulkcustomers?sourceapplication=' + CONSTANTS.SOURCE_APPLICATION + '&sourceaction=Import Customers', data).then(function(response) {
                jobsTracker.trackJob(jobIndex, response.data.Id);
            }).catch(function(error) {
                jobsTracker.setCriticlaFail(jobIndex, error);
            });
        }

        function createBulkLocations(data, sellerId, model) {
            //Transform the data
            var sortedData = $filter('orderBy')(data, 'CustomerNumber');
            var transformedData = [];
            var curIndex = -1;

            for (var i = 0; i<sortedData.length; i++) {
                if (curIndex <0 || i == 0 || sortedData[i-1].CustomerNumber.toLowerCase() !== sortedData[i].CustomerNumber.toLowerCase()) {
                    transformedData.push({CustomerNumber: sortedData[i].CustomerNumber, Locations: []});
                    curIndex++;
                }
                transformedData[curIndex].Locations.push({
                    LocationCode: sortedData[i].LocationCode,
                    AddressName: sortedData[i].AddressName,
                    Address: sortedData[i].Address,
                    City: sortedData[i].City,
                    State: sortedData[i].State,
                    Zip: sortedData[i].Zip,
                    CountryCode: sortedData[i].Country,
                    Phone: sortedData[i].Phone,
                    LocationReference: sortedData[i].LocationReference
                });
            }

            var jobIndex = jobsTracker.addJob(model, 'LOCATIONS.ACTIONS.IMPORT_LOC', 1);
            api.webPut(api.baseUrl + '/sellers/' + sellerId + '/customersLocations?sourceapplication=' + CONSTANTS.SOURCE_APPLICATION + '&sourceaction=Import Locations', transformedData).then(function(response) {
                jobsTracker.trackJob(jobIndex, response.data.Id);
            }).catch(function(error) {
                jobsTracker.setCriticlaFail(jobIndex, error);
            });
        }
    }
})();
(function () {
  'use strict';

  angular
    .module('app.main.catalogs')
    .factory('catalogFactory', catalogFactory);

  /* @ngInject */
  function catalogFactory(api, utility, $localStorage, $sessionStorage, $log, $q, $rootScope, $filter, alertDialog, CONSTANTS, SecurityFactory, errorDialog) {
    var _isActiveCatalogInitialized = false;
    var _listOfCatalogs = [];
    var _dispatchedRequestForCatalogs;
    var dynamicModel = {};
    var catalogContextKey = '';
    var activeCatalogTree = '';
    var catalogArticlesList = [];

    var service = {
      createDynamicModel                      : createDynamicModel,
      createArticleModel                      : createArticleModel,
      createLinePlanArticleModel              : createLinePlanArticleModel,
      createArticlesBlockingModel             : createArticlesBlockingModel,
      createOrderlineModel                    : createOrderlineModel,
      setActiveCatalog                        : setActiveCatalog,
      getActiveCatalog                        : getActiveCatalog,
      getUseOrderType                         : getUseOrderType,
      getUseConfirmOrder                      : getUseConfirmOrder,
      getActiveCatalogDetails                 : getActiveCatalogDetails,
      updateListOfCatalogs                    : updateListOfCatalogs,
      getListOfCatalogs                       : getListOfCatalogs,
      getAllArticleCRDs                       : getAllArticleCRDs,
      getAllArticleSegmentations              : getAllArticleSegmentations,
      transform                               : transform,
      transformPricesResponse                 : transformPricesResponse,
      transformCRDsResponse                   : transformCRDsResponse,
      transformSegmentationsResponse          : transformSegmentationsResponse,
      transformCustomerSegmentationsResponse  : transformCustomerSegmentationsResponse,
      transformArticlesBlockingResponse				: transformArticlesBlockingResponse,
      assignAssortmentsToFolder               : assignAssortmentsToFolder,
      transformFolders                        : transformFolders,
      createUiTreeBranchPath                  : createUiTreeBranchPath,
      addAncestorDisabledStatusToAssortment   : addAncestorDisabledStatusToAssortment,
      setCatalogRequestDispatchStatus         : setCatalogRequestDispatchStatus,
      getCatalogRequestDispatchStatus         : getCatalogRequestDispatchStatus,
      setCatalogImportMapping                 : setCatalogImportMapping,
      transformStockResponse                  : transformStockResponse,
      getCatalogArticleLockedStatus           : getCatalogArticleLockedStatus,
      modifySegmentationActions               : modifySegmentationActions,
      transformArticlesResponse               : transformArticlesResponse,
      setActiveCatalogDetails                 : setActiveCatalogDetails,
      isActiveCatalogInitialized              : isActiveCatalogInitialized,
      setIsActiveCatalogInitialized           : setIsActiveCatalogInitialized,
      createArticleStatusReportModel          : createArticleStatusReportModel,
      transformArticleStatusReportResponse    : transformArticleStatusReportResponse,
      createSellerModelAttributesModel        : createSellerModelAttributesModel,
      createArticlePricesReportModel          : createArticlePricesReportModel,
      getCatalogContextKey                    : getCatalogContextKey,
      createCatalogArticleNumbersArray        : createCatalogArticleNumbersArray,
      getCatalogArticleNumbersWithDuneImagesArray : getCatalogArticleNumbersWithDuneImagesArray,
      setActiveCatalogTree                    : setActiveCatalogTree,
      getActiveCatalogTree                    : getActiveCatalogTree,
      setActiveCatalogArticles                : setActiveCatalogArticles,
      getUnsavedDraftOrders                   : getUnsavedDraftOrders,
      doesUserHaveAccessToBlockedImagesForActiveCatalog: doesUserHaveAccessToBlockedImagesForActiveCatalog,
      modifyModelActions                      : modifyModelActions,
      createCatalogModelsModel                : createCatalogModelsModel,
      removeRestrictedSegmentations           : removeRestrictedSegmentations,
      getCurrentRoleRestrictedSegmentationAndFormatToDesiredObjectArray: getCurrentRoleRestrictedSegmentationAndFormatToDesiredObjectArray,
      getAutomaticNumbering                   : getAutomaticNumbering,
      getCustomNumbering                      : getCustomNumbering,
      setNumberingSettings                    : setNumberingSettings,
      getIsSizeScaleByStyle                   : getIsSizeScaleByStyle,
      transformSharedFolders                  : transformSharedFolders,
      transformDunesResponse                  : transformDunesResponse,
      createLookupValuesModelWithSourceAndDestAttributes: createLookupValuesModelWithSourceAndDestAttributes,
      getModelNameLength                      : getModelNameLength,
      transformCatalogModelsResponse          : transformCatalogModelsResponse,
      createSummaryReportModel                : createSummaryReportModel,
      getActiveCatalogPersisted               : getActiveCatalogPersisted,
      transformRetailIntroAndRetailExitMonth  : transformRetailIntroAndRetailExitMonth,
      generateImportTabularFields: generateImportTabularFields,
      getAndSetAppVersion: getAndSetAppVersion,
      createDatasetValuesModelWithAttributes: createDatasetValuesModelWithAttributes
    };

    return service;

    function setCatalogRequestDispatchStatus(flag) {
      _dispatchedRequestForCatalogs = flag;
    }

    function getCatalogRequestDispatchStatus() {
      return _dispatchedRequestForCatalogs;
    }

    function isActiveCatalogInitialized() {
      return _isActiveCatalogInitialized;
    }

    function setIsActiveCatalogInitialized(value) {
      _isActiveCatalogInitialized = value;
    }

    //Service method implementation

    /**
    * @description
    *  Creates model dynamically based on getList result of parentModel and propertiesMapper array
    *
    * @param  {string} targetModelPath: path of the model which is used to create dynamic model
    * @param  {string} parentModelPath: path of the model based on result of its 'getList' method the target model gets created
    * @param  {array}  propertiesMapper: a mapping array denotes which property of http request response mapped to which field of target model
    * @param  {string} inputType: target model's dynamic field's input type
    * @param  {string} nestedArrayName: name of nested array of corresponding model data (use for flattening response data)
    * @param  {string} valueMapper : denotes which property of corresponding model data will be used for value of fields (use for flattening response data)
    * @return {object} a dynamic model specific to a catalog of specific module (Segmentations, CRDs, Prices)
    */

    function createDynamicModel(targetModelPath, parentModelPath, propertiesMapper, inputType, nestedArrayName, valueMapper, isCRD) {
      var activeCatalog = getActiveCatalogDetails();
      var activeCatalogCode = activeCatalog.CatalogCode;
      var catalogTypeId = activeCatalog.DataSourceTypeId;
      var mirrorSegmentation = activeCatalog.MirrorSegmentation;
      var isRoleBasedRestrictedSegmentationsAdded = false;
      if((targetModelPath === 'catalogArticles.segmentation' || targetModelPath === 'catalogCustomers.segmentation')
        && angular.isDefined(api.roleBasedRestrictions) && angular.isDefined(api.roleBasedRestrictions.restrictedSegmentationsArray) && api.roleBasedRestrictions.restrictedSegmentationsArray.length) {
        isRoleBasedRestrictedSegmentationsAdded = true;
      }

      var fieldTemplate = {
        catalogEntityId: '', field: '', map: '', type: 'text', displayLabel: '', visible: true, creatable: true, editable: true, inputType: '',
        validation: {
          isRequired: true, maxLen: -1, minLen: 1, pattern: '',
          messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' }
        }
      };

      var attributeFieldTemplate = {
        field: '', map: '', type: 'text', displayLabel: '', visible: true, creatable: false, editable: false, showInEdit: false, inputType: 'text', reportable: false,
        validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }
      };



      fieldTemplate.inputType = inputType;
      if (targetModelPath === 'catalogArticles.segmentation' || targetModelPath === 'catalogs.prices' || targetModelPath === 'catalogs.stock' || targetModelPath === 'catalogCustomers.segmentation') { // mark article segmentations model's dynamic field non mandatory
        fieldTemplate.validation.isRequired = false;
        fieldTemplate.validation.minLen = 0;
      }

      // make segmentaions atleast one optional for importing
      if(targetModelPath === 'catalogArticles.segmentation' || targetModelPath === 'catalogCustomers.segmentation') {
        fieldTemplate.validation.isOptional = true;
      }

      // validate segmentation planning value while importing if catalog planning value enabled
      if(targetModelPath === 'catalogArticles.segmentation' && activeCatalog.SegmentationPlanningEnable === 1) {
        // Allowed import values: the configured planning values (a configured value assigns the segmentation
        // with that value, e.g. 'No' when 'No' is configured), plus 'No'/blank to unassign. The dataImporter
        // planning-value gate normalizes other tokens (e.g. an exported 'Yes' -> the configured default) before
        // this check, so only configured values, 'No' and '' reach it. Duplicates are skipped so a configured
        // token (e.g. 'No') is not added twice.
        var allowedPlanningValues = api.getSegmentationPlanningValues().map(function(value) {
          return {Name: value};
        });
        angular.forEach(['No', ''], function(token) {
          if (!api.matchSegmentationPlanningValue(token)) {
            allowedPlanningValues.push({Name: token});
          }
        });
        fieldTemplate.validation.dataExistConstraints = { data: allowedPlanningValues };
        fieldTemplate.validation.dataExistConstraints['model'] = {};
        fieldTemplate.validation.dataExistConstraints['model']['lookupDisplayField'] = 'Name';
      }

      var parentModel = api.getModel(parentModelPath);
      var targetModel = angular.copy(api.getModel(targetModelPath));
      targetModel.baseModel = api.getModel(targetModelPath);

      dynamicModel[targetModelPath] = angular.isUndefined(dynamicModel[targetModelPath]) ? {} : dynamicModel[targetModelPath];
      var maxDefaultColumnCounter = 4;
      var isParentRecordDirty = false; // indicate possibilities of parent model's record being dirty despite of parent model isDirty being false due to refresh in parent model after changes

      if (parentModelPath !== 'catalogs.stockDefinition') {
        // parent model last updated time for specific catalog
        var pLastUpdatedOn = angular.isDefined(parentModel.lastUpdatedOn[activeCatalogCode]) ? parentModel.lastUpdatedOn[activeCatalogCode] : undefined;
        if (angular.isUndefined(pLastUpdatedOn) || angular.isUndefined(dynamicModel[targetModelPath][activeCatalogCode])
          || angular.isUndefined(dynamicModel[targetModelPath][activeCatalogCode].lastUpdatedOn)
          || pLastUpdatedOn !== dynamicModel[targetModelPath][activeCatalogCode].lastUpdatedOn
        ) {
          isParentRecordDirty = true;
        }
      } else { isParentRecordDirty = true; }

      if (!dynamicModel[targetModelPath][activeCatalogCode] || parentModel.isDirty || isParentRecordDirty) {

        if (dynamicModel[targetModelPath][activeCatalogCode]) {
          maxDefaultColumnCounter = 0; // if model exit do not recalculate default columns
        }
        else {
          dynamicModel[targetModelPath][activeCatalogCode] = targetModel;
        }

        // if parent model is dirty recalculate columns and default columns
        if (parentModel.isDirty || isParentRecordDirty) {
          dynamicModel[targetModelPath][activeCatalogCode].fields = targetModel.fields;
          dynamicModel[targetModelPath][activeCatalogCode].views.mainList.columns = targetModel.views.mainList.columns;
          maxDefaultColumnCounter = 4;
        }
        var catalogAttributesPromise = undefined;
        var parentDataPromise = parentModel.methods.getList({ forceFetch: true, isLogRequired: false }, activeCatalogCode);
        if (targetModelPath === 'catalogs.prices' || targetModelPath === 'catalogs.crds'|| targetModelPath === 'catalogArticles.segmentation') {
          catalogAttributesPromise = api.catalogs.attributes.methods.getList({ forceFetch: true, isLogRequired: false }, activeCatalogCode);
        }

        //hide segmentation related actions for child catalog if mirrorSegmentation is enabled
        if(targetModelPath === 'catalogArticles.segmentation' && catalogTypeId === 3 && mirrorSegmentation === 1) {
          modifyArticleSegmentationActions(dynamicModel[targetModelPath][activeCatalogCode]);
        }

        return $q.all({parentDataPromise: parentDataPromise, catalogAttributesPromise: catalogAttributesPromise}).then(function (responses) {
          if (parentModelPath != 'catalogs.stockDefinition') {
            dynamicModel[targetModelPath][activeCatalogCode].lastUpdatedOn = parentModel.lastUpdatedOn[activeCatalogCode];
          }

          var fieldList = responses.parentDataPromise.data;

          //filedList represent the columns in transformed data
          angular.forEach(fieldList, function (field) {
            //do not show the inactive record as a column
            if (angular.isDefined(field.Status) && field.Status === 1) {

              //map response source property to fields target property (propertiesMapper is array of object containing source and target)
              if (isCRD) {//using isCRD flag to avoid extra processing for other entities
                angular.forEach(propertiesMapper, function (property) {
                  if (angular.isDefined(property.formatDate)) {
                    fieldTemplate[property.target] = utility.formatDate(field[property.source], property.formatDate, 'UTC');
                    fieldTemplate[property.target] = fieldTemplate[property.target];
                  }
                  else {
                    fieldTemplate[property.target] = field[property.source];
                  }
                  if(property.target === 'field'){
                    fieldTemplate['importField'] = fieldTemplate[property.target];
                    fieldTemplate[property.target] = field[valueMapper] + fieldTemplate[property.target];
                  }
                  if(property.target === 'displayLabel') {
                    fieldTemplate[property.target] = fieldTemplate[property.target] + ' (' + field[property.description]+ ')';
                  }
                });
              }
              else {
                angular.forEach(propertiesMapper, function (property) {
                  fieldTemplate[property.target] = $rootScope.$eval(property.source, { field: field });
                });
              }
              if (targetModelPath === 'catalogs.prices') {
                fieldTemplate.readOnly = field.IsEditable === 0 ? true : false;
                fieldTemplate.isMandatory = field.IsMandatory === 1 ? true : false;
                fieldTemplate.validation.disabledCriteria = fieldTemplate.readOnly;
                fieldTemplate.validation.pattern = '^[+]?\\d+([.]\\d{0,'+ api.numberOfDecimalsForPrices +'})?$';
                fieldTemplate.validation.messages.pattern = 'Invalid price value, Should be a positive number and not contain more than '+ api.numberOfDecimalsForPrices +' decimals.';
                fieldTemplate.validation.checkIfPriceGroupLockedAtArticleState = true;
              }

              fieldTemplate.map = nestedArrayName + '.' + valueMapper;//add map property to model's field use for flattening the response
              fieldTemplate.catalogEntityId = field[parentModel.idField];//add catalogEntityId property to model's field use for flattening the response (to search record)
              fieldTemplate.isCatalogProperty = true;
              var fieldIndex = dynamicModel[targetModelPath][activeCatalogCode].fields.indexOf(utility.filterObject(dynamicModel[targetModelPath][activeCatalogCode].fields, { field: fieldTemplate.field }, true)[0]);
              if( fieldIndex === -1) {
                if(!isRoleBasedRestrictedSegmentationsAdded) {
                  dynamicModel[targetModelPath][activeCatalogCode].fields.push(angular.copy(fieldTemplate));
                } else {
                  var segmentation = utility.filterObject(api.roleBasedRestrictions.restrictedSegmentationsArray, { Id: fieldTemplate.catalogEntityId }, true)[0];
                  if(angular.isDefined(segmentation)){
                    if (!segmentation.notViewable && !segmentation.notEditable) {
                      dynamicModel[targetModelPath][activeCatalogCode].fields.push(angular.copy(fieldTemplate));
                    } else if(!segmentation.notViewable && segmentation.notEditable) {
                      var fieldTemplateClone = angular.copy(fieldTemplate);
                      fieldTemplateClone.creatable = false
                      fieldTemplateClone.editable = false
                      dynamicModel[targetModelPath][activeCatalogCode].fields.push(angular.copy(fieldTemplateClone));
                    }
                  } else {
                    dynamicModel[targetModelPath][activeCatalogCode].fields.push(angular.copy(fieldTemplate));
                  }
                }
              }
              if (maxDefaultColumnCounter > 0) {
                var columnList = dynamicModel[targetModelPath][activeCatalogCode].views.mainList.columns;
                var existInCoulmList = false;
                if(columnList.length) {
                  for (var i = 0; i < columnList.length ; i++) {
                    if(columnList[i].indexOf(fieldTemplate.field) !== -1) {
                      existInCoulmList = true;
                      break;
                    }
                  }
                }

                if(!existInCoulmList) {
                  dynamicModel[targetModelPath][activeCatalogCode].views.mainList.columns.push(angular.copy(fieldTemplate.field));
                  maxDefaultColumnCounter -= 1;
                }
              }
            }
          });
          //add catalog specific attributes to prices,crds and segmentations model fields
          if(targetModelPath === 'catalogs.prices' || targetModelPath === 'catalogs.crds'|| targetModelPath === 'catalogArticles.segmentation'){
            angular.forEach(responses.catalogAttributesPromise.data.AttributeList, function (attribute) {
              var attributeField = angular.copy(attributeFieldTemplate);
              attributeField.isDynamicProperty = false;
              attributeField.isAttribute = true;
              attributeField.field = attribute.AttributeSystemName;
              attributeField.map = attribute.AttributeSystemName;
              attributeField.displayLabel = 'A: '+ attribute.AttributeDisplayName;
              attributeField.visible = (attribute.Visible == true);
              attributeField.supportFilterLookup = (attribute.SupportFilterLookup == true);
              attributeField.initialValue = attribute.InitialValueAttribute;
              attributeField.IsSeasonless = attribute.IsSeasonless;
              attributeField.IsSeasonlessModelAttribute = attribute.IsSeasonlessModelAttribute;// seasonless model level attributes
              attributeField.Overridable = attribute.Overridable;
              attributeField.DefaultValue = attribute.DefaultValue;

              // for attributes other than calc type if validation expression is a valid regex we will add to pattern else we will add it to tx-pattern
              if(attribute.AttributeTypeName.toUpperCase() !== 'CALC') {
                if(!utility.isValidJSON(attribute.ValidationExpression)) {
                  attributeField.validation.pattern = attribute.ValidationExpression != '{}' ? attribute.ValidationExpression : '';
                  attributeField.validation['tx-pattern'] = false;
                } else {
                  attributeField.validation.pattern = '';
                  attributeField.validation['tx-pattern'] = attribute.ValidationExpression != null && attribute.ValidationExpression !== '' && attribute.ValidationExpression != '{}' ?
                  attribute.ValidationExpression : false;
                }
              }
              attributeField.validation.messages.pattern = (attribute.ValidationMessage !== '') ? attribute.ValidationMessage : 'VALIDATIONS.PATTERN';

              //set data type to list for attributes having values added in attributeVettingList
              if (attribute.AttributeTypeName.toUpperCase() !== 'CALC' && attribute.AllowedValues && attribute.AllowedValues !== null && (angular.isArray(attribute.AllowedValues) && attribute.AllowedValues.length)) {
                // this attribute will be displyed with parent model number dropdown
                if(attributeField.field === 'parent_model_type') {
                  attributeField.inputType = 'parent-model-type';
                  attributeField.values = attribute.AllowedValues
                  .map(function(value) {
                    return value.trim();
                  })
                  .sort(function(a, b) {
                    return a.toLowerCase().localeCompare(b.toLowerCase());
                  });
                } else {
                  attributeField.inputType = 'list';
                  // for multi value attributes with vetting list inputtype will be multi-value
                  if (attribute.AttributeTypeName.toUpperCase() === 'MULTIVALUE') {
                    attributeField.inputType = 'multi-value';
                    attributeField.tagSeparator = '|';
                    if(!attributeField.editable) {
                      attributeField.nonRemovableChips = true;
                    }
                  }
                  if (attribute.AttributeTypeName.toUpperCase() === 'INT' || attribute.AttributeTypeName.toUpperCase() === 'DECIMAL') {
                    attributeField.type = 'int';
                  } else {
                    attributeField.type = 'text';
                  }
                  if (attribute.AttributeTypeName.toUpperCase() === 'DECIMAL') {
                    attributeField.validation.pattern = '^[+]?\\d+([.]\\d{0,4})?$';
                    attributeField.validation.messages.pattern = 'VALIDATIONS.POSITIVE_DECIMAL_4PONTS';
                  }
                }
              }
              else {
                if (attribute.AttributeTypeName.toUpperCase() === 'INT') {
                  attributeField.inputType = 'number';
                }
                else if (attribute.AttributeTypeName.toUpperCase() === 'NVARCHAR') {
                  attributeField.inputType = 'textArea';
                }
                else if (attribute.AttributeTypeName.toUpperCase() === 'MULTIVALUE') {
                  attributeField.inputType = 'tags';
                  attributeField.tagSeparator = '|';
                  attributeField.inputSubType = 'multi-value';
                }
                else if (attribute.AttributeTypeName.toUpperCase() === 'DATE') {
                  attributeField.inputType = 'date-without-time';
                }
                else if (attribute.AttributeTypeName.toUpperCase() === 'DATETIME') {
                  attributeField.inputType = 'date';
                }
                else if (attribute.AttributeTypeName.toUpperCase() === 'BOOL') {
                  attributeField.inputType = 'bool-str';
                }
                else if(attribute.AttributeTypeName.toUpperCase() === 'CALC') {
                  attributeField.creatable = false;
                  attributeField.editable = false;
                  attributeField.isBulkEditable = false;
                  attributeField.inputType = 'calculated';
                  attributeField.validation.pattern = '';
                  attributeField.calculatedExpression = attribute.ValidationExpression;
                  //Adding try catch if JSON parse fails
                  try {
                    attributeField.parsedExpressionObject = JSON.parse(attribute.ValidationExpression);
                    if(angular.isDefined(attributeField.parsedExpressionObject.calculatedRegexExpression)) {
                      var calculatedRegexExpression = attributeField.parsedExpressionObject.calculatedRegexExpression;
                      if(angular.isDefined(calculatedRegexExpression.fieldRegex) && calculatedRegexExpression.fieldRegex.length > 0) {
                        angular.forEach(calculatedRegexExpression.fieldRegex, function(fieldRegex) {
                          var convertedRegEx = convertStringToRegex(fieldRegex.regEx);
                          if(convertedRegEx != null) {
                              fieldRegex.regEx = convertedRegEx;
                          } else {
                              console.warn("invalid Regex for : " + fieldRegex.field);
                          }
                        })
                      }
                    }
                  } catch(error) {
                    console.warn(attribute.AttributeDisplayName + " - Attribute Validation Expression : Invalid JSON format");
                  }
                }
                else if (attribute.AttributeTypeName.toUpperCase() === 'DATEOPTION') {
                  attributeField.inputType = 'date-option';
                }
                else if (attribute.AttributeTypeName.toUpperCase() === 'DECIMAL') {
                  attributeField.inputType = 'decimal';
                  attributeField.validation.pattern = '^[+]?\\d+([.]\\d{0,4})?$';
                  attributeField.validation.messages.pattern = 'VALIDATIONS.POSITIVE_DECIMAL_4PONTS';
                }
                else if (attribute.AttributeTypeName.toUpperCase() === 'ARTICLENUMBER') {
                  attributeField.inputType = 'articlenumber';
                  attributeField.lookupSource = 'catalogs.articles';
                  attributeField.lookupFilter = {'Status': 1};
                }
                else if (attribute.AttributeTypeName.toUpperCase() === 'LINKEDCATALOGARTICLENUMBER') {
                  attributeField.inputType = 'linkedcatalogarticlenumber';
                  attributeField.lookupSource = 'lists.linkedCatalogArticles';
                  attributeField.lookupFilter = {'Status': 1};
                }
                else if (attribute.AttributeTypeName.toUpperCase() === 'COLORPALETTE') {
                  attributeField.inputType = 'color-palette';
                  attributeField.lookupSource = 'lists.sellerColorsFromColorPalette';
                  attributeField.isfilterCriteria = true;
                  attributeField.lookupFilter = {'Status': 1};
                  attributeField.customLookupInfo = {value: 'value'}
                }
                else if (attribute.AttributeTypeName.toUpperCase() === 'MODELNUMBER') {
                  attributeField.inputType = 'modelnumber';
                  attributeField.lookupSource = 'lists.sellerModelsWithoutAttributes';
                }
                else if (attribute.AttributeTypeName.toUpperCase() === 'LOOKUPTABLE') {
                  attributeField.inputType = 'lookup-table';
                }
                else if (attribute.AttributeTypeName.toUpperCase() === 'DATASET') {
                  attributeField.inputType = 'dataset';
                  attributeField.datasetId = attribute.DatasetId;
                }
                else if (attribute.AttributeTypeName.toUpperCase() === 'DATATABLE') {
                  attributeField.inputType = 'datatable';
                  attributeField.dataTableAttributes = attribute.DataTableAttributes;
                  if(attribute.AllowedValuesV2 && attribute.AllowedValuesV2.length) {
                    try {
                      attributeField.valuesV2 = JSON.parse(attribute.AllowedValuesV2)
                    } catch(error) {
                      console.warn(attribute.AttributeDisplayName + " - Allowed Values Version 2 : Invalid JSON format");
                    }
                  }
                  if(attribute.CriteriaV2 && attribute.CriteriaV2.length) {
                    try {
                      attributeField.criteriaV2 = JSON.parse(attribute.CriteriaV2)
                    } catch(error) {
                      console.warn(attribute.AttributeDisplayName + " - Criteria Version 2 : Invalid JSON format");
                    }
                  }
                  if(api.allAttributesListMap && Object.keys(api.allAttributesListMap).length > 0) {
                      attributeField.dataTableAttributesDetails = attributeField.dataTableAttributes.map(function(attrId) {
                          return api.allAttributesListMap[attrId];
                      }).filter(function(attr) {
                          return attr !== undefined;
                      })
                  }
                }
              }

              //insert additional attributes fields before 'LastUpdatedOn' property in prices model
              var index = dynamicModel[targetModelPath][activeCatalogCode].fields.indexOf(utility.filterObject(dynamicModel[targetModelPath][activeCatalogCode].fields, { field: 'LastUpdatedOn' }, true)[0]);
              dynamicModel[targetModelPath][activeCatalogCode].fields.splice(index, 0, angular.copy(attributeField));

            });
          }
          return applyRoleBasedAttributeRestrictions(dynamicModel[targetModelPath][activeCatalogCode]);
        });
      }
      return $q.when(dynamicModel[targetModelPath][activeCatalogCode]);
    }

    /**
    * @description
    *  Applies the current user's role based attribute restrictions to the fields of a dynamic model.
    *  This has to run as the LAST step of a model builder, once all attribute fields are added: every
    *  rule that grants edit rights (attribute source, overridable attributes, app.config.json overrides)
    *  would otherwise switch a restricted attribute back to editable. Safe to call more than once.
    *  @param {object} model: dynamic model whose fields have to be restricted
    *  @returns {object} the same model
    */
    function applyRoleBasedAttributeRestrictions(model) {
      var roleBasedRestrictedAttributes = (angular.isDefined(api.roleBasedRestrictions) && angular.isDefined(api.roleBasedRestrictions.restrictedAttributesArray)) ? api.roleBasedRestrictions.restrictedAttributesArray : [];
      if (angular.isUndefined(model) || !angular.isArray(model.fields) || !roleBasedRestrictedAttributes.length) {
        return model;
      }

      angular.forEach(model.fields, function (field) {
        var roleBasedRestrictedAttribute = utility.filterObject(roleBasedRestrictedAttributes, { Name: field.field }, true)[0];
        if (angular.isUndefined(roleBasedRestrictedAttribute)) {
          return;
        }
        // not viewable: the attribute is hidden everywhere, so it can neither be created nor edited
        if (roleBasedRestrictedAttribute.notViewable) {
          field.visible = false;
          field.showInEdit = false;
          field.creatable = false;
          field.editable = false;
          field.isBulkEditable = false;
        }
        // not editable only: the value can still be set while creating the record, it just cannot be changed
        // afterwards, isBulkEditable keeps the bulk edit dialogs in sync
        else if (roleBasedRestrictedAttribute.notEditable) {
          field.editable = false;
          field.isBulkEditable = false;
        }
      });

      return model;
    }

    /**
    * @description
    *  Creates Article model dynamically based on active catalog attributes, type
    *  @param {object} catalog: catalog, if passed dynamic model will be created for the passed catalog otherwise
    *  @param {array} articlesDynamicProperties: array of dynamic properties which used to create dynamic fields
    *  @param {object} model: modelsArticlesModel, if passed it will create dynamic model for Models module
    */
    function createArticleModel(catalog, articlesDynamicProperties, model) {
      var model = angular.isDefined(model) ? model : api.catalogs.articles;
      var deferred = $q.defer();
      var activeCatalog = {};
      var articlePromises = {};
      var activeCatalogModelLevelAttributes = utility.filterObject(getActiveCatalogDetails().ModelLevelAttributeList, {Status: 1});
      var restrictedRetailWindow = angular.isDefined(api.roleBasedRestrictions.restrictedRetailWindow) ? api.roleBasedRestrictions.restrictedRetailWindow : undefined;
      // article number field will be non creatable and editable when AutomaticNumbering flag is enabled on seller level
      var isAutomaticNumberingEnabled = getAutomaticNumbering();

      //model for active catalog
      if (angular.isUndefined(catalog)) {
        activeCatalog = getActiveCatalog();
      }
      // model for requested catalog
      else {
        activeCatalog = catalog;
      }

      var activeCatalogCode = activeCatalog.CatalogCode;
      var catalogTypeId = activeCatalog.DataSourceTypeId;

      var pristineArticleModel = angular.copy(model);
      pristineArticleModel.baseModel = api.getModel(model.modelPath);


      // if no catalog specific articleModel or catalogSpecificArticle model does not belong to active catalog
      if (angular.isUndefined(dynamicModel[model.modelPath]) || angular.isUndefined(dynamicModel[model.modelPath][activeCatalogCode])) {
        dynamicModel[model.modelPath] = {}; // remove any previously cached model as requested to recreate article model every time
        dynamicModel[model.modelPath][activeCatalogCode] = pristineArticleModel;
      }

      var dynamicArticleModel = dynamicModel[model.modelPath][activeCatalogCode];
      dynamicArticleModel.fields = pristineArticleModel.fields;// reassign pristine model fields if model is cached
      dynamicArticleModel.views.mainList.columns = pristineArticleModel.views.mainList.columns; // reassign pristine model default columns if model is cached

      //set ArticleNumber & ArticleName editable & creatable property false for Inherited & Direct catalog articles
      if (catalogTypeId == 3 || catalogTypeId == 2) {
        var field = {};
        field = utility.filterObject(dynamicArticleModel.fields, { field: 'ArticleNumber' })[0];
        field.creatable = field.editable = false;
        field = utility.filterObject(dynamicArticleModel.fields, { field: 'ArticleName' })[0];
        field.creatable = field.editable = false;
        field = utility.filterObject(dynamicArticleModel.fields, { field: 'ModelNumber' })[0];
        if(angular.isDefined(field)) {
          field.creatable = field.editable = false;
        }

        //Disable Edit for Directed catalog articles
        if (catalogTypeId == 2) {
          var itemActions = dynamicArticleModel.views.mainList.itemActions;
          var itemAction = utility.filterObject(itemActions, { id: 'edit' }, true)[0];
          if (angular.isDefined(itemAction)) {
            itemAction.disabled = true;
            itemAction.visible = false;
          }
          dynamicArticleModel.views.mainDetails.fabAction.disabled = true;
        }
        if (catalogTypeId == 3 && dynamicArticleModel.modelPath !== 'catalogs.modelArticles' && dynamicArticleModel.modelPath !== 'sellerModels.sellerModelArticles') {
          // modifies item actions, list actions and add fad dial
          modifyInheritedArticlesActions(dynamicArticleModel);
          modifyInheritedArticlesFields(dynamicArticleModel, activeCatalog);
        }
      }

      // if auto numbering enabled article number and model number fields will be not creatable and ColorId will be enabled for create and edit
      if(isAutomaticNumberingEnabled) {
        var articleNumberField = utility.filterObject(dynamicArticleModel.fields, { field: 'ArticleNumber' })[0];
        if(angular.isDefined(articleNumberField)) {
          articleNumberField.creatable = false;
          articleNumberField.editable = false;
        }
        var modelNumberField = utility.filterObject(dynamicArticleModel.fields, { field: 'ModelNumber' })[0];
        if(angular.isDefined(modelNumberField)) {
          modelNumberField.creatable = false;
          modelNumberField.editable = false;
        }
        var colorIdField = utility.filterObject(dynamicArticleModel.fields, { field: 'ColorId' })[0];
        if(angular.isDefined(colorIdField)) {
          colorIdField.creatable = true;
          colorIdField.editable = true;
          colorIdField.showInEdit = true;
        }
        var colorCodeField = utility.filterObject(dynamicArticleModel.fields, { field: 'ColorCode' })[0];
        if(angular.isDefined(colorCodeField)) {
          colorCodeField.visible = true;
        }
        var hexCodeField = utility.filterObject(dynamicArticleModel.fields, { field: 'HexCode' })[0];
        if(angular.isDefined(hexCodeField)) {
          hexCodeField.visible = true;
        }
        var colorNameField = utility.filterObject(dynamicArticleModel.fields, { field: 'ColorName' })[0];
        if(angular.isDefined(colorNameField)) {
          colorNameField.visible = true;
        }
        var colorGroupField = utility.filterObject(dynamicArticleModel.fields, { field: 'ColorGroup' })[0];
        if(angular.isDefined(colorGroupField)) {
          colorGroupField.visible = true;
        }
        var colorTypeField = utility.filterObject(dynamicArticleModel.fields, { field: 'ColorType' })[0];
        if(angular.isDefined(colorTypeField)) {
          colorTypeField.visible = true;
        }
        var assetIdField = utility.filterObject(dynamicArticleModel.fields, { field: 'ColorAssetId' })[0];
        if(angular.isDefined(assetIdField)) {
          assetIdField.visible = true;
        }
      }

      if (activeCatalog.IsShippingWindowApply === 1) {
        var allowRetailWindowUpdateField = utility.filterObject(dynamicArticleModel.fields, {field: 'AllowRetailWindowUpdate'}, true)[0];
        if(angular.isDefined(allowRetailWindowUpdateField)) {
          allowRetailWindowUpdateField.visible = true;
        }

        var allowRetailWindowUpdateOnChild = utility.filterObject(dynamicArticleModel.fields, {field: 'AllowRetailWindowUpdateOnChild'}, true)[0];
        if(angular.isDefined(allowRetailWindowUpdateOnChild)) {
          allowRetailWindowUpdateOnChild.visible = true;
          allowRetailWindowUpdateOnChild.creatable = true;
          allowRetailWindowUpdateOnChild.editable = true;
        }
      }

      if(angular.isDefined(restrictedRetailWindow) && restrictedRetailWindow.notViewable) {
        modifyArticleRetailWindowAndRelatedFields(dynamicArticleModel);
      }

      // make setSizes itemAction and listAction visible if IsSizeScaleByStyle is enabled at seller(as discussed this will not editable at catalog level)
      if (getIsSizeScaleByStyle() && dynamicArticleModel.modelPath !== 'sellerModels.sellerModelArticles') {
          // make SizeScale field visible
          var SizeScaleFields = utility.filterObject(dynamicArticleModel.fields, { field: 'SizeScale' }, true)[0];
          SizeScaleFields.visible = true;
          var masterSizeScaleIdField = utility.filterObject(dynamicArticleModel.fields, { field: 'MasterSizeScaleId', inputType: 'number' }, true)[0];
          masterSizeScaleIdField.visible = true;
          var masterSizeScaleField = utility.filterObject(dynamicArticleModel.fields, { field: 'MasterSizeScale' }, true)[0];
          masterSizeScaleField.visible = true;
          SizeScaleFields = utility.filterObject(dynamicArticleModel.fields, { field: 'SizeScaleId' }, true)[0];
          SizeScaleFields.visible = true;
      }

      if (activeCatalog.IsPriceByStyleApply === 1) {
        if(!isAutomaticNumberingEnabled) {
          var modelNumberField = utility.filterObject(dynamicArticleModel.fields, { field: 'ModelNumber' }, true)[0];
          if(angular.isDefined(modelNumberField)) {
            modelNumberField.validation.isRequired = true;
          }
        } else {
          // if auto numbering enabled modelId field will be mandatory
          var modelIdField = utility.filterObject(dynamicArticleModel.fields, { field: 'ModelId', inputType: 'lookup'}, true)[0];
          if(angular.isDefined(modelIdField)) {
            modelIdField.validation.isRequired = true;
          }
          // if auto numbering enabled modelId field will be visible
          var modelIdNumberField = utility.filterObject(dynamicArticleModel.fields, { field: 'ModelId', inputType: 'number'}, true)[0];
          if(angular.isDefined(modelIdNumberField)) {
            modelIdNumberField.visible = true;
          }
        }

        // hide create price action
        var action = utility.filterObject(dynamicArticleModel.views.mainList.itemActions, { id: 'AddPrice' }, true)[0];
        if(action) {
          action.visible = false;
        }
        // show setPricesByLicenseeModelNumberAction action
        var setPricesByLicenseeModelNumberAction = utility.filterObject(dynamicArticleModel.views.mainList.listActions, { id: 'setPricesByLicenseeModelNumber' }, true)[0];
        if (setPricesByLicenseeModelNumberAction) {
            setPricesByLicenseeModelNumberAction.visible = true;
        }
      }

      // disable block image edit/create for child catalog as this flag is now cascaded from master catalog
      if (catalogTypeId == 3) {
        var blockImageField = utility.filterObject(dynamicArticleModel.fields, { field: 'BlockImage' }, true)[0];
        if(angular.isDefined(blockImageField)) {
          blockImageField.creatable = false;
          blockImageField.editable = false;
        }
      }

      var attributeFieldTemplate = {
        field: '', type: 'text', displayLabel: 'ARTICLES.FIELDS.ID', visible: true, creatable: false, editable: false, showInEdit: false, inputType: 'text', reportable: true, values: '',
        validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }
      };

      // importByLicensee and setSizesByLicenseeModelNumber actions is only for master catalog
      if(dynamicArticleModel.modelPath !== 'sellerModels.sellerModelArticles') {
        var importByLicenseeAction = utility.filterObject(dynamicArticleModel.views.mainList.listActions, { id: 'importByLicensee' }, true)[0];
        if(importByLicenseeAction && catalogTypeId !== 1) {
          importByLicenseeAction.visible = false;
        }
        var setPricesByLicenseeAction = utility.filterObject(dynamicArticleModel.views.mainList.listActions, { id: 'setPricesByLicenseeModelNumber' }, true)[0];
        if(setPricesByLicenseeAction && catalogTypeId !== 1) {
          setPricesByLicenseeAction.visible = false;
        }
        var setSizesByLicenceeModelNumberAction = utility.filterObject(dynamicArticleModel.views.mainList.listActions, { id: 'setSizesByLicenseeModelNumber' }, true)[0];
        if(setSizesByLicenceeModelNumberAction) {
          if(catalogTypeId !== 1) {
            setSizesByLicenceeModelNumberAction.visible = false;
          }

          // if ArticleAttribute and ModelAttribute is not assigned then disable the importByLicensee action
          var articleAttribute = activeCatalog.ArticleAttribute;
          var modelAttribute = activeCatalog.ModelAttribute;
          if(angular.isUndefined(modelAttribute) || modelAttribute === null || modelAttribute.toString().trim() === '') {
            // disable the set sizes action if model attribute is not configured
            setSizesByLicenceeModelNumberAction.disabled = 'true === true';
            if(angular.isUndefined(articleAttribute) || articleAttribute === null || articleAttribute.toString().trim() === '') {
              importByLicenseeAction.disabled = 'true === true';
            }
          }
        }
      }

      // for seller models articles we will use sellers seasonless article attribiutes list
      if(dynamicArticleModel.modelPath !== 'sellerModels.sellerModelArticles') {
        var articlesDataPromise = api.catalogs.attributes.methods.getList({ forceFetch: true, isLogRequired: false }, activeCatalogCode);
        articlePromises[api.catalogs.attributes.modelPath] = articlesDataPromise;
      } else if(dynamicArticleModel.modelPath === 'sellerModels.sellerModelArticles') {
        var sellerId = getActiveCatalog().AccountId;
        var articlesDataPromise = api.sellers.seasonlessAttributes.methods.getList({ forceFetch: true, isLogRequired: false }, sellerId);
        articlePromises[api.sellers.seasonlessAttributes.modelPath] = articlesDataPromise;
      }

      articlesDataPromise.then(function (response) {
          response.data.AttributeList = dynamicArticleModel.modelPath !== 'sellerModels.sellerModelArticles' ?  $filter('orderBy')(response.data.AttributeList, 'SortOrder') : $filter('orderBy')(response.data, 'SortOrder');
          var attributesList = response.data.AttributeList;
          //add catalog specific attributes to article's model fields
          angular.forEach(attributesList, function (attribute) {
            var modelLevelAttributeIndex = activeCatalogModelLevelAttributes.indexOf(utility.filterObject(activeCatalogModelLevelAttributes, { AttributeId: attribute.Attributeid, Status: 1 }, true)[0]);
            var attributeField = angular.copy(attributeFieldTemplate);
            attributeField.isDynamicProperty = true;
            attributeField.isAttribute = true;
            attributeField.field = attribute.AttributeSystemName;
            attributeField.map = attribute.AttributeSystemName;
            attributeField.displayLabel = attribute.AttributeDisplayName;
            attributeField.visible = (attribute.Visible == true);
            attributeField.showInEdit = (attribute.ShowInEdit == true);
            attributeField.supportFilterLookup = (attribute.SupportFilterLookup == true);
            attributeField.initialValue = attribute.InitialValueAttribute;

            attributeField.validation.isRequired = attribute.IsRequired;
            attributeField.validation.minLen = attribute.IsRequired ? 1 : 0;
            attributeField.IsSeasonless = attribute.IsSeasonless;
            attributeField.IsSeasonlessModelAttribute = attribute.IsSeasonlessModelAttribute;// seasonless model level attributes
            attributeField.Overridable = attribute.Overridable;
            attributeField.DefaultValue = attribute.DefaultValue;
            attributeField.AttributeSource = attribute.AttributeSource;

            // for attributes other than calc type if validation expression is a valid regex we will add to pattern else we will add it to tx-pattern
            if(attribute.AttributeTypeName.toUpperCase() !== 'CALC') {
              if(!utility.isValidJSON(attribute.ValidationExpression)) {
                attributeField.validation.pattern = attribute.ValidationExpression != '{}' ? attribute.ValidationExpression : '';
                attributeField.validation['tx-pattern'] = false;
              } else {
                attributeField.validation.pattern = '';
                attributeField.validation['tx-pattern'] = attribute.ValidationExpression != null && attribute.ValidationExpression !== '' && attribute.ValidationExpression != '{}' ?
                attribute.ValidationExpression : false;
              }
            }
            attributeField.validation.messages.pattern = (attribute.ValidationMessage !== '') ? attribute.ValidationMessage : 'VALIDATIONS.PATTERN';
            attributeField.reportable = true;

            // make Overridable attributes editable and creatable for inherited catalogs
            if(catalogTypeId === 3 && attribute.Overridable) {
              if (attribute.Editable || attribute.IsRequired) {
                attributeField.editable = true;
              }
              if (attribute.Creatable || attribute.IsRequired) {
                attributeField.creatable = true;
              }
            }

            //set data type to list for attributes having values added in attributeVettingList
            if (attribute.AttributeTypeName.toUpperCase() !== 'CALC' && attribute.AttributeTypeName.toUpperCase() !== 'DATATABLE' && attribute.AttributeTypeName.toUpperCase() !== 'DATASET' && attribute.AllowedValues && attribute.AllowedValues !== null && (angular.isArray(attribute.AllowedValues) && attribute.AllowedValues.length)) {
              if(attributeField.field === 'parent_model_type') {
                attributeField.inputType = 'parent-model-type';
                attributeField.values = attribute.AllowedValues
                .map(function(value) {
                  return value.trim();
                })
                .sort(function(a, b) {
                  return a.toLowerCase().localeCompare(b.toLowerCase());
                });
              } else {
                attributeField.inputType = 'list';
                // for multi value attributes with vetting list inputtype will be multi-value
                if (attribute.AttributeTypeName.toUpperCase() === 'MULTIVALUE') {
                  attributeField.inputType = 'multi-value';
                  attributeField.tagSeparator = '|';
                  if(!attributeField.editable) {
                    attributeField.nonRemovableChips = true;
                  }
                }
                if (attribute.AttributeTypeName.toUpperCase() === 'INT' || attribute.AttributeTypeName.toUpperCase() === 'DECIMAL') {
                  attributeField.type = 'int';
                } else {
                  attributeField.type = 'text';
                }
                if (attribute.AttributeTypeName.toUpperCase() === 'DECIMAL') {
                  attributeField.validation.pattern = '^[+]?\\d+([.]\\d{0,4})?$';
                  attributeField.validation.messages.pattern = 'VALIDATIONS.POSITIVE_DECIMAL_4PONTS';
                }
              }
            }
            else {
              if (attribute.AttributeTypeName.toUpperCase() === 'INT') {
                attributeField.inputType = 'number';
              }
              else if (attribute.AttributeTypeName.toUpperCase() === 'NVARCHAR') {
                attributeField.inputType = 'textArea';
              }
              else if (attribute.AttributeTypeName.toUpperCase() === 'MULTIVALUE') {
                attributeField.inputType = 'tags';
                attributeField.tagSeparator = '|';
                attributeField.inputSubType = 'multi-value';
              }
              else if (attribute.AttributeTypeName.toUpperCase() === 'DATE') {
                attributeField.inputType = 'date-without-time';
              }
              else if (attribute.AttributeTypeName.toUpperCase() === 'DATETIME') {
                attributeField.inputType = 'date';
              }
              else if (attribute.AttributeTypeName.toUpperCase() === 'BOOL') {
                attributeField.inputType = 'bool-str';
              }
              else if(attribute.AttributeTypeName.toUpperCase() === 'CALC') {
                attributeField.creatable = false;
                attributeField.editable = false;
                attributeField.isBulkEditable = false;
                attributeField.inputType = 'calculated';
                attributeField.validation.pattern = '';
                attributeField.calculatedExpression = attribute.ValidationExpression;
                //Adding try catch if JSON parse fails
                try {
                  attributeField.parsedExpressionObject = JSON.parse(attribute.ValidationExpression);
                  if(angular.isDefined(attributeField.parsedExpressionObject.calculatedRegexExpression)) {
                    var calculatedRegexExpression = attributeField.parsedExpressionObject.calculatedRegexExpression;
                    if(angular.isDefined(calculatedRegexExpression.fieldRegex) && calculatedRegexExpression.fieldRegex.length > 0) {
                      angular.forEach(calculatedRegexExpression.fieldRegex, function(fieldRegex) {
                        var convertedRegEx = convertStringToRegex(fieldRegex.regEx);
                        if(convertedRegEx != null) {
                            fieldRegex.regEx = convertedRegEx;
                        } else {
                            console.warn("invalid Regex for : " + fieldRegex.field);
                        }
                      })
                    }
                    attributeField.calcType = calculatedRegexExpression.type;
                  }
                } catch(error) {
                  console.warn(attribute.AttributeDisplayName + " - Attribute Validation Expression : Invalid JSON format");
                }
              }
              else if (attribute.AttributeTypeName.toUpperCase() === 'DATEOPTION') {
                attributeField.inputType = 'date-option';
              }
              else if (attribute.AttributeTypeName.toUpperCase() === 'DECIMAL') {
                attributeField.inputType = 'decimal';
                attributeField.validation.pattern = '^[+]?\\d+([.]\\d{0,4})?$';
                attributeField.validation.messages.pattern = 'VALIDATIONS.POSITIVE_DECIMAL_4PONTS';
              }
              else if (attribute.AttributeTypeName.toUpperCase() === 'ARTICLENUMBER') {
                attributeField.inputType = 'articlenumber';
                attributeField.lookupSource = 'catalogs.articles';
                attributeField.lookupFilter = {'Status': 1};
              }
              else if (attribute.AttributeTypeName.toUpperCase() === 'LINKEDCATALOGARTICLENUMBER') {
                attributeField.inputType = 'linkedcatalogarticlenumber';
                attributeField.lookupSource = 'lists.linkedCatalogArticles';
                attributeField.lookupFilter = {'Status': 1};
              }
              else if (attribute.AttributeTypeName.toUpperCase() === 'COLORPALETTE') {
                attributeField.inputType = 'color-palette';
                attributeField.lookupSource = 'lists.sellerColorsFromColorPalette';
                attributeField.isfilterCriteria = true;
                attributeField.lookupFilter = {'Status': 1};
                attributeField.customLookupInfo = {value: 'value'}
              }
              else if (attribute.AttributeTypeName.toUpperCase() === 'MODELNUMBER') {
                attributeField.inputType = 'modelnumber';
                attributeField.lookupSource = 'lists.sellerModelsWithoutAttributes';
              }
              else if (attribute.AttributeTypeName.toUpperCase() === 'LOOKUPTABLE') {
                attributeField.inputType = 'lookup-table';
              }
              else if (attribute.AttributeTypeName.toUpperCase() === 'DATASET') {
                attributeField.inputType = 'dataset';
                attributeField.datasetId = attribute.DatasetId;
                // Catalog article/model editing scopes dataset values to the catalog; exclude seller-model articles (same builder).
                attributeField.isCatalogScoped = (model.modelPath !== 'sellerModels.sellerModelArticles');
              }
              else if (attribute.AttributeTypeName.toUpperCase() === 'DATATABLE') {
                attributeField.inputType = 'datatable';
                attributeField.DataTableAttributes = attribute.DataTableAttributes
                if(attribute.AllowedValuesV2 && attribute.AllowedValuesV2.length) {
                  try {
                    attributeField.valuesV2 = JSON.parse(attribute.AllowedValuesV2)
                  } catch(error) {
                    console.warn(attribute.AttributeDisplayName + " - Allowed Values Version 2 : Invalid JSON format");
                  }
                }
                if(attribute.CriteriaV2 && attribute.CriteriaV2.length) {
                  try {
                    attributeField.criteriaV2 = JSON.parse(attribute.CriteriaV2)
                  } catch(error) {
                    console.warn(attribute.AttributeDisplayName + " - Criteria Version 2 : Invalid JSON format");
                  }
                }
                if(api.allAttributesListMap && Object.keys(api.allAttributesListMap).length > 0) {
                    attributeField.dataTableAttributesDetails = attributeField.DataTableAttributes.map(function(attrId) {
                        return api.allAttributesListMap[attrId];
                    }).filter(function(attr) {
                        return attr !== undefined;
                    })
                }
              }
            }

            // create all model level attributes creatable as false
            if(modelLevelAttributeIndex !== -1) {
              attributeField.creatable = false;
              attributeField.editable = false;
              if(isAutomaticNumberingEnabled) { // show model level attributes as readonly for validating color
                attributeField.creatable = attribute.AttributeTypeName.toUpperCase() !== 'CALC' ? attribute.Creatable : false;
                attributeField.editable = attribute.AttributeTypeName.toUpperCase() !== 'CALC' ? attribute.Editable : false;
                attributeField.validation.disabledCriteria = true;
              }
              // new feature "Edit Model Attributes" list action to edit model attributes for bulk articles
              attributeField.isBulkEditable = attributeField.editable;
              attributeField.isModelLevelAttribute = true;
            } else {
              attributeField.isModelLevelAttribute = false;
            }

            // make article_type attributes as creatable and editable false as we are handling this internally, no need to show in create/edit page
            // this attribute is assigned normally for line plan catalogs.
            if(attributeField.field.toLowerCase() === 'article_type') {
              attributeField.creatable = false;
              attributeField.editable = false;
              attributeField.isBulkEditable = false;
            }

            if(catalogTypeId == 3 && attributeField.field.toLowerCase() === 'parent_model_type') {
              attributeField.creatable = false;
              attributeField.editable = false;
            }

            // make self attribute creatable or editable if they are required attributes or creatable and editable respectively
            // and if source is parent disable create and edit — EXCEPT Overridable attributes in an inherited
            // (child) catalog (catalogTypeId === 3), which the child may override inline; keep the editable/creatable
            // set by the Overridable gate above (#42185) so the blanket parent-lockdown rule (#50695) doesn't defeat it.
            if (attribute.AttributeSource.toUpperCase() === 'SELF' && attribute.AttributeTypeName.toUpperCase() !== 'CALC') {
              if (attribute.Editable || attribute.IsRequired) {
                attributeField.editable = true;
              }
              if (attribute.Creatable || attribute.IsRequired) {
                attributeField.creatable = true;
              }
            } else if (!(catalogTypeId === 3 && attribute.Overridable)) {
              attributeField.editable = false;
              attributeField.creatable = false;
            }

            //To avoid creating dulpicate attributes when calling articles details page from different module.
            var isAttributeExists = false;
            for( var i = 0; i < dynamicArticleModel.fields.length; i++) {
              if(dynamicArticleModel.fields[i].field === attributeField.field) {
                isAttributeExists = true;
                break;
              }
            }

            if(!isAttributeExists) {
              //insert additional attributes fields before 'CreatedDate' property in model
              var index = dynamicArticleModel.fields.indexOf(utility.filterObject(dynamicArticleModel.fields, { field: 'CreatedDate' }, true)[0]);
              dynamicArticleModel.fields.splice(index, 0, angular.copy(attributeField));
            }

            //adding up to 5 attributes to default articles view default column list (views.mainList.columns)
            if (attribute.VisibleInListByDefault) {
              if(dynamicArticleModel.views.mainList.columns.indexOf(attributeField.field) === -1) {
                var columnsIndex = dynamicArticleModel.views.mainList.columns.indexOf(
                utility.filterObject(dynamicArticleModel.views.mainList.columns, 'UpdatedDate', true)[0]);
                dynamicArticleModel.views.mainList.columns.splice(columnsIndex, 0, attributeField.field);
              }
            }
          });

          api.webGet('/app/app.config.json').then(function (response) {
            if (angular.isDefined(response) && angular.isDefined(response.data) && angular.isDefined(response.data.model)
              && angular.isDefined(response.data.model[model.modelPath]) && angular.isArray(response.data.model[model.modelPath].fields)
              && response.data.model[model.modelPath].fields.length) {
              var configFields = response.data.model[model.modelPath].fields;
              var configFieldsMap = {};
              angular.forEach(configFields, function (configField) {
                configFieldsMap[configField.field] = configField;
              });
              angular.forEach(dynamicArticleModel.fields, function (dynamicModelField) {
                if (angular.isDefined(configFieldsMap[dynamicModelField.field])) {
                  dynamicModelField = Object.assign(dynamicModelField, configFieldsMap[dynamicModelField.field]);
                }
              });
            }
            applyRoleBasedAttributeRestrictions(dynamicArticleModel);
          });
        });

        // create dataset attribute columns
        var datasetDetailsCache = {};
        var assignedCatalogAttributes = getActiveCatalogDetails().AssignedCatalogAttributes
        if(assignedCatalogAttributes && SecurityFactory.isAuthorized({accessPrivileges: CONSTANTS.PRIVILEGES.SELLERS.DETAIL.GET_DATASET_DEFINITIONS_DETAILS})) {
          var datasetAttributes = utility.filterObject(assignedCatalogAttributes, {AttributeTypeId: 16}, true)
          angular.forEach(datasetAttributes, function(dtAttribute) {
              var datasetPromiseKey = 'dataset_' + dtAttribute.DatasetId;
              if (datasetDetailsCache[dtAttribute.DatasetId]) {
                articlePromises[datasetPromiseKey] = datasetDetailsCache[dtAttribute.DatasetId];
              } else {
                var datasetDetailsPromise = api.sellers.datasets.methods.getDetails(true, dtAttribute.DatasetId, getActiveCatalog().AccountId);
                datasetDetailsCache[dtAttribute.DatasetId] = datasetDetailsPromise;
                articlePromises[datasetPromiseKey] = datasetDetailsPromise;
              }
              // fetch the dataset attributes and create the columns
              datasetDetailsCache[dtAttribute.DatasetId].then(function (response) {
                var datasetAttributes = response.data.Attributes;
                if(datasetAttributes.length) {
                  angular.forEach(datasetAttributes, function (datasetAttr) {
                    var datasetAttributeField = angular.copy(attributeFieldTemplate);
                    datasetAttributeField.isDynamicProperty = true;
                    datasetAttributeField.isAttribute = true;
                    datasetAttributeField.field = dtAttribute.AttributeSystemName + '-' + datasetAttr.AttributeSystemName;
                    datasetAttributeField.map = dtAttribute.AttributeSystemName + '-' + datasetAttr.AttributeSystemName;
                    datasetAttributeField.displayLabel = dtAttribute.AttributeDisplayName + '-' + datasetAttr.AttributeDisplayName;
                    datasetAttributeField.visible = true;
                    datasetAttributeField.supportFilterLookup = (dtAttribute.SupportFilterLookup == true);
                    var index = dynamicArticleModel.fields.indexOf(utility.filterObject(dynamicArticleModel.fields, { field: 'CreatedDate' }, true)[0]);
                    dynamicArticleModel.fields.splice(index, 0, angular.copy(datasetAttributeField));
                  })
                }
              })
          })
        }

        //Create dynamic fields (Prices and segmentations)
        if(angular.isDefined(articlesDynamicProperties) && articlesDynamicProperties.length > 0) {
          angular.forEach(articlesDynamicProperties, function(properties) {
            var targetModelPath = 'catalogs.articles';
            var parentModelPath = properties.sourceModel;
            var propertiesMapper = properties.propertiesMapper;
            var inputType = properties.inputType;
            var nestedArrayName = properties.nestedArrayName;
            var valueMapper = properties.valueMapper;

            var fieldTemplate = { // default visible: false
              catalogEntityId: '', field: '', map: '', type: 'text', displayLabel: '', visible: true, creatable: false, editable: false, inputType: '',
              validation: {
                isRequired: false, maxLen: -1, minLen: 1, pattern: '',
                messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' }
              }
            };

            fieldTemplate.inputType = inputType;

            var parentModel = api.getModel(parentModelPath);
            var targetModel = angular.copy(api.getModel(targetModelPath));
            targetModel.baseModel = api.getModel(targetModelPath);

            var parentDataPromise = parentModel.methods.getList({ forceFetch: true, isLogRequired: false }, activeCatalogCode);
            articlePromises[parentModel.modelPath] = parentDataPromise;

            parentDataPromise.then(function (responses) {
              dynamicArticleModel.lastUpdatedOn = parentModel.lastUpdatedOn[activeCatalogCode];

              var fieldList = responses.data;
              //filedList represent the columns in transformed data
              angular.forEach(fieldList, function (field) {
                //do not show the inactive record as a column
                if (angular.isDefined(field.Status) && field.Status === 1) {
                    angular.forEach(propertiesMapper, function (property) {
                      fieldTemplate[property.target] = $rootScope.$eval(property.source, { field: field });
                    });

                  fieldTemplate.map = nestedArrayName + '.' + valueMapper;//add map property to model's field use for flattening the response
                  fieldTemplate.catalogEntityId = field[parentModel.idField];//add catalogEntityId property to model's field use for flattening the response (to search record)
                  fieldTemplate.nestedArrayName = nestedArrayName;//to differentiate prices and segmentation when transorming articles data
                  fieldTemplate.isCatalogProperty = true;
                  var exists = false;
                  for (var i = 0; i < dynamicArticleModel.fields.length; i++) {
                      var existingField = dynamicArticleModel.fields[i];
                      if (existingField.catalogEntityId === fieldTemplate.catalogEntityId &&
                          existingField.map === fieldTemplate.map &&
                          existingField.nestedArrayName === fieldTemplate.nestedArrayName) {
                          exists = true;
                          break;
                      }
                  }

                  if (!exists) {
                      dynamicArticleModel.fields.push(angular.copy(fieldTemplate));
                  }
                }
              });
            });
          });
        }
        // article states api
        if(api.articleStatesList.length) {
          var activeArticleStates = utility.filterObject(api.articleStatesList, {Status: 1});
          var fieldTemplate = {
            catalogEntityId: '', field: '', map: '', type: 'text', displayLabel: '', visible: true, creatable: false, editable: false, inputType: 'date',
            validation: {
              isRequired: false, maxLen: -1, minLen: 1, pattern: '',
              messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' }
            }
          };

          angular.forEach(activeArticleStates, function (state) {
            fieldTemplate.field = 'articleState'+state.StateId;
            fieldTemplate.displayLabel = 'State Timestamp: '+ state.StateName;
            fieldTemplate.map = 'StatesTimestamp.StateId';//add map property to model's field use for flattening the response
            fieldTemplate.catalogEntityId = state[api.catalogs.articleStates.idField];//add catalogEntityId property to model's field use for flattening the response (to search record)
            fieldTemplate.nestedArrayName = 'StatesTimestamp'; // to differentiate StatesTimestamp when transorming articles data
            dynamicArticleModel.fields.push(angular.copy(fieldTemplate));
          });
        }

        $q.all(articlePromises).then(function () {
          applyRoleBasedAttributeRestrictions(dynamicArticleModel);
          deferred.resolve(dynamicArticleModel);
          datasetDetailsCache = {};
        });

        return deferred.promise;
    }

    function createArticleStatusReportModel() {
      var deferred = $q.defer();
      var activeCatalog = getActiveCatalog();;
      var articleStatusPromise = {};
      var activeCatalogCode = activeCatalog.CatalogCode;
      var nestedArrayName = 'Catalogs';
      var articlesStatusModel = api.catalogs.articleStatus;
      var maxDefaultColumnCounter = 4;
      var pristineArticleStatusModel = angular.copy(articlesStatusModel);
      pristineArticleStatusModel.baseModel = api.getModel('catalogs.articleStatus');

      if (angular.isUndefined(dynamicModel['catalogs.articleStatus']) || angular.isUndefined(dynamicModel['catalogs.articleStatus'][activeCatalogCode])) {
        dynamicModel['catalogs.articleStatus'] = {}; // remove any previously cached model as requested to recreate articleStatus model every time
        dynamicModel['catalogs.articleStatus'][activeCatalogCode] = pristineArticleStatusModel;
        maxDefaultColumnCounter = 4;
      }

      var dynamicArticleStatusModel = dynamicModel['catalogs.articleStatus'][activeCatalogCode];
      dynamicArticleStatusModel.fields = pristineArticleStatusModel.fields;// reassign pristine model fields if model is cached
      dynamicArticleStatusModel.views.mainList.columns = pristineArticleStatusModel.views.mainList.columns; // reassign pristine model default columns if model is cached

      var fieldTemplate = {
        catalogEntityId: '', field: '', map: '', type: 'text', displayLabel: '', visible: true, creatable: false, editable: false, inputType: 'status',
        validation: {
          isRequired: false, maxLen: -1, minLen: 1, pattern: '',
          messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' }
        }
      };

      var articleStatusPromise = articlesStatusModel.methods.getList({ forceFetch: true, isLogRequired: false }, activeCatalogCode);
      var propertiesMapper = [{target: 'field', source: 'field["CatalogId"]+field["CatalogName"]'}, {target: 'displayLabel', source: 'field["CatalogName"]'}];
      articleStatusPromise.then(function (responses) {
        var fieldList = responses.data;
        angular.forEach(fieldList, function (field) {
          angular.forEach(field[nestedArrayName], function(catalog) {
            angular.forEach(propertiesMapper, function (property) {
              fieldTemplate[property.target] = $rootScope.$eval(property.source, { field: catalog });
            });

            fieldTemplate.map = nestedArrayName + '.ArticleStatus';//add map property to model's field use for flattening the response
            fieldTemplate.catalogEntityId = catalog.CatalogId;//add catalogEntityId property to model's field use for flattening the response (to search record)

            var fieldIndex = dynamicArticleStatusModel.fields.indexOf(utility.filterObject(dynamicArticleStatusModel.fields, { field: fieldTemplate.field })[0]);
            if( fieldIndex === -1) {
              dynamicArticleStatusModel.fields.push(angular.copy(fieldTemplate));
            }
            if (maxDefaultColumnCounter > 0) {
              var columnList = dynamicArticleStatusModel.views.mainList.columns;
              var existInCoulmList = false;
              if(columnList.length) {
                for (var i = 0; i < columnList.length ; i++) {
                  if(columnList[i].indexOf(fieldTemplate.field) !== -1) {
                    existInCoulmList = true;
                    break;
                  }
                }
              }

              if(!existInCoulmList) {
                dynamicArticleStatusModel.views.mainList.columns.push(angular.copy(fieldTemplate.field));
                maxDefaultColumnCounter -= 1;
              }
            }

          })
        });
        deferred.resolve(dynamicArticleStatusModel);
      });
      return deferred.promise;
    }

    /**
    * @description
    *  Creates Article Prices Report model dynamically
    *  @param {object} catalog: catalog, if passed dynamic model will be created for the passed catalog otherwise
    */
    function createArticlePricesReportModel(catalog) {
      var deferred = $q.defer();
      var activeCatalog = catalog || getActiveCatalog();
      var activeCatalogCode = activeCatalog.CatalogCode;
      var articlePricesModel = api.catalogs.articlePricesReport;
      var pristineArticlePricesModel = angular.copy(articlePricesModel);
      pristineArticlePricesModel.baseModel = api.getModel('catalogs.articlePricesReport');
      var maxDefaultColumnCounter = 4;

      if (angular.isUndefined(dynamicModel['catalogs.articlePricesReport']) || angular.isUndefined(dynamicModel['catalogs.articlePricesReport'][activeCatalogCode])) {
        dynamicModel['catalogs.articlePricesReport'] = {};
        dynamicModel['catalogs.articlePricesReport'][activeCatalogCode] = pristineArticlePricesModel;
        maxDefaultColumnCounter = 4;
      }

      var dynamicArticlePricesModel = dynamicModel['catalogs.articlePricesReport'][activeCatalogCode];
      dynamicArticlePricesModel.fields = pristineArticlePricesModel.fields;
      dynamicArticlePricesModel.views.mainList.columns = pristineArticlePricesModel.views.mainList.columns;

      var fieldTemplate = {
        catalogEntityId: '', field: '', map: '', type: 'text', displayLabel: '', visible: true, creatable: false, editable: false, inputType: 'text',
        validation: {
          isRequired: false, maxLen: -1, minLen: 1, pattern: '',
          messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' }
        }
      };

      articlePricesModel.methods.getList({ forceFetch: true, isLogRequired: false }, activeCatalogCode).then(function (response) {
        var articlePrices = response.data;
        angular.forEach(articlePrices, function(articlePrice) {
          for(var key in articlePrice) {
            if(articlePrice.hasOwnProperty(key) && key !== 'ArticleNumber' && key !== 'ArticleId' && key !== 'ModelNumber' && key !== 'ArticleName') {
              fieldTemplate.field = key;
              fieldTemplate.displayLabel = key;
              fieldTemplate.map = key;
              fieldTemplate.catalogEntityId = articlePrice.ArticleId + key;
              fieldTemplate.isCatalogProperty = true;
              var fieldIndex = dynamicArticlePricesModel.fields.indexOf(utility.filterObject(dynamicArticlePricesModel.fields, { field: fieldTemplate.field })[0]);
              if( fieldIndex === -1) {
                dynamicArticlePricesModel.fields.push(angular.copy(fieldTemplate));
              }
              if (maxDefaultColumnCounter > 0) {
                var columnList = dynamicArticlePricesModel.views.mainList.columns;
                var existInCoulmList = false;
                if(columnList.length) {
                  for (var i = 0; i < columnList.length ; i++) {
                    if(columnList[i].indexOf(fieldTemplate.field) !== -1) {
                      existInCoulmList = true;
                      break;
                    }
                  }
                }
                if(!existInCoulmList) {
                  dynamicArticlePricesModel.views.mainList.columns.push(angular.copy(fieldTemplate.field));
                  maxDefaultColumnCounter -= 1;
                }
              }
            }
          }
        });
        deferred.resolve(dynamicArticlePricesModel);
      });
      return deferred.promise;
    }

    /**
    * @description
    *  Creates Line plan Catalog's  Article model dynamically based on active catalog attributes, type
    *  @param {object} catalog: catalog, if passed dynamic model will be created for the passed catalog otherwise based on active catalog
    */
    function createLinePlanArticleModel(catalog, model) {
      var deferred = $q.defer();
      var activeCatalog = {};
      var linkedAttributes = getActiveCatalogDetails().LinkedAttributeList;
      var restrictedRetailWindow = angular.isDefined(api.roleBasedRestrictions.restrictedRetailWindow) ? api.roleBasedRestrictions.restrictedRetailWindow : undefined;

      //model for active catalog
      if (angular.isUndefined(catalog)) {
        activeCatalog = getActiveCatalog();
      }
      // model for requested catalog
      else {
        activeCatalog = catalog;
      }

      var activeCatalogCode = activeCatalog.CatalogCode;
      var catalogTypeId = activeCatalog.DataSourceTypeId;

      var pristineArticleModel = angular.copy(model);
      pristineArticleModel.baseModel = api.getModel(model.modelPath);


      // if no catalog specific articleModel or catalogSpecificArticle model does not belong to active catalog
      if (angular.isUndefined(dynamicModel[model.modelPath]) || angular.isUndefined(dynamicModel[model.modelPath][activeCatalogCode])) {
        dynamicModel[model.modelPath] = {}; // remove any previously cached model as requested to recreate article model every time
        dynamicModel[model.modelPath][activeCatalogCode] = pristineArticleModel;
      }

      var dynamicArticleModel = dynamicModel[model.modelPath][activeCatalogCode];
      dynamicArticleModel.fields = pristineArticleModel.fields;// reassign pristine model fields if model is cached
      dynamicArticleModel.views.mainList.columns = pristineArticleModel.views.mainList.columns; // reassign pristine model default columns if model is cached

      var attributeFieldTemplate = {
        field: '', type: 'text', displayLabel: 'ARTICLES.FIELDS.ID', visible: true, creatable: false, editable: false, showInEdit: false, inputType: 'text', reportable: true, values: '',
        validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }
      };

      var attributeList = [];

      if (model.modelPath === 'catalogs.linePlanArticles') {
        attributeList = getActiveCatalogDetails().AssignedCatalogAttributes;
        attributeList = $filter('orderBy')(attributeList, 'SortOrder');
      } else {
        attributeList = getActiveCatalogDetails().LinkedAttributeList;
      }

      if(angular.isDefined(restrictedRetailWindow) && restrictedRetailWindow.notViewable) {
        modifyArticleRetailWindowAndRelatedFields(dynamicArticleModel);
      }

      //add catalog specific attributes to article's model fields
      angular.forEach(attributeList, function (attribute) {
        var attributeField = angular.copy(attributeFieldTemplate);
        attributeField.isDynamicProperty = true;
        attributeField.field = attribute.AttributeSystemName;
        attributeField.displayLabel = attribute.AttributeDisplayName;
        if (model.modelPath === 'catalogs.linePlanArticles') {
          attributeField.visible = (attribute.Visible == true);
          attributeField.showInEdit = (attribute.ShowInEdit == true);
          attributeField.supportFilterLookup = (attribute.SupportFilterLookup == true);
          attributeField.initialValue = attribute.InitialValueAttribute;

          attributeField.validation.isRequired = attribute.IsRequired;
          attributeField.validation.minLen = attribute.IsRequired ? 1 : 0;
          attributeField.IsSeasonless = attribute.IsSeasonless;
          attributeField.IsSeasonlessModelAttribute = attribute.IsSeasonlessModelAttribute;// seasonless model level attributes
          attributeField.Overridable = attribute.Overridable;
          attributeField.DefaultValue = attribute.DefaultValue;

          // for attributes other than calc type if validation expression is a valid JSON we will add to tx-pattern else we will add it to pattern
          if(attribute.AttributeTypeName.toUpperCase() !== 'CALC') {
            if(!utility.isValidJSON(attribute.ValidationExpression)) {
              attributeField.validation.pattern = attribute.ValidationExpression != '{}' ? attribute.ValidationExpression : '';
              attributeField.validation['tx-pattern'] = false;
            } else {
              attributeField.validation.pattern = '';
              attributeField.validation['tx-pattern'] = attribute.ValidationExpression != null && attribute.ValidationExpression !== '' && attribute.ValidationExpression != '{}' ?
              attribute.ValidationExpression : false;
            }
          }
          attributeField.validation.messages.pattern = (attribute.ValidationMessage !== '') ? attribute.ValidationMessage : 'VALIDATIONS.PATTERN';
          attributeField.reportable = true;

          // make Overridable attributes editable and creatable for inherited catalogs
          if(catalogTypeId === 3 && attribute.Overridable) {
            if (attribute.Editable || attribute.IsRequired) {
              attributeField.editable = true;
            }
            if (attribute.Creatable || attribute.IsRequired) {
              attributeField.creatable = true;
            }
          }
        } else { //linkedAttributes will always be visible while creating comp and carryover articles
          attributeField.visible = true;
          attributeField.showInEdit = false;
          attributeField.supportFilterLookup = true;
          attributeField.initialValue = '';
          attributeField.validation.isRequired = false;
          attributeField.validation.minLen = 0;
          attributeField.validation.pattern = '';
          attributeField.validation.messages.pattern = '';
          attributeField.editable = false;
          attributeField.creatable = false;
        }

        //set data type to list for attributes having values added in attributeVettingList
        if (attribute.AttributeTypeName.toUpperCase() !== 'CALC' && attribute.AllowedValues && attribute.AllowedValues !== null && (angular.isArray(attribute.AllowedValues) && attribute.AllowedValues.length)) {
          if(attributeField.field === 'parent_model_type') {
            attributeField.inputType = 'parent-model-type';
            attributeField.values = attribute.AllowedValues
            .map(function(value) {
              return value.trim();
            })
            .sort(function(a, b) {
              return a.toLowerCase().localeCompare(b.toLowerCase());
            });
          } else {
            attributeField.inputType = 'list';
            // for multi value attributes with vetting list inputtype will be multi-value
            if (attribute.AttributeTypeName.toUpperCase() === 'MULTIVALUE') {
              attributeField.inputType = 'multi-value';
              attributeField.tagSeparator = '|';
              if(!attributeField.editable) {
                attributeField.nonRemovableChips = true;
              }
            }
            if (attribute.AttributeTypeName.toUpperCase() === 'INT' || attribute.AttributeTypeName.toUpperCase() === 'DECIMAL') {
              attributeField.type = 'int';
            } else {
              attributeField.type = 'text';
            }
            if (attribute.AttributeTypeName.toUpperCase() === 'DECIMAL') {
              attributeField.validation.pattern = '^[+]?\\d+([.]\\d{0,4})?$';
              attributeField.validation.messages.pattern = 'VALIDATIONS.POSITIVE_DECIMAL_4PONTS';
            }
          }
        }
        else {
          if (attribute.AttributeTypeName.toUpperCase() === 'INT') {
            attributeField.inputType = 'number';
          }
          else if (attribute.AttributeTypeName.toUpperCase() === 'NVARCHAR') {
            attributeField.inputType = 'textArea';
          }
          else if (attribute.AttributeTypeName.toUpperCase() === 'MULTIVALUE') {
            attributeField.inputType = 'tags';
            attributeField.tagSeparator = '|';
            attributeField.inputSubType = 'multi-value';
          }
          else if (attribute.AttributeTypeName.toUpperCase() === 'DATE') {
            attributeField.inputType = 'date-without-time';
          }
          else if (attribute.AttributeTypeName.toUpperCase() === 'DATETIME') {
            attributeField.inputType = 'date';
          }
          else if (attribute.AttributeTypeName.toUpperCase() === 'BOOL') {
            attributeField.inputType = 'bool-str';
          }
          else if (attribute.AttributeTypeName.toUpperCase() === 'CALC') {
            attributeField.inputType = 'calculated';
            attributeField.validation.pattern = '';
            attributeField.calculatedExpression = attribute.ValidationExpression;
            //Adding try catch if JSON parse fails
            try {
              attributeField.parsedExpressionObject = JSON.parse(attribute.ValidationExpression);
              if(angular.isDefined(attributeField.parsedExpressionObject.calculatedRegexExpression)) {
                var calculatedRegexExpression = attributeField.parsedExpressionObject.calculatedRegexExpression;
                if(angular.isDefined(calculatedRegexExpression.fieldRegex) && calculatedRegexExpression.fieldRegex.length > 0) {
                  angular.forEach(calculatedRegexExpression.fieldRegex, function(fieldRegex) {
                    var convertedRegEx = convertStringToRegex(fieldRegex.regEx);
                    if(convertedRegEx != null) {
                        fieldRegex.regEx = convertedRegEx;
                    } else {
                        console.warn("invalid Regex for : " + fieldRegex.field);
                    }
                  })
                }
                attributeField.calcType = calculatedRegexExpression.type;
              }
            } catch(error) {
              console.warn(attribute.AttributeDisplayName + " - Attribute Validation Expression : Invalid JSON format");
            }
          }
          else if (attribute.AttributeTypeName.toUpperCase() === 'DATEOPTION') {
            attributeField.inputType = 'date-option';
          }
          else if (attribute.AttributeTypeName.toUpperCase() === 'DECIMAL') {
            attributeField.inputType = 'decimal';
            attributeField.validation.pattern = '^[+]?\\d+([.]\\d{0,4})?$';
            attributeField.validation.messages.pattern = 'VALIDATIONS.POSITIVE_DECIMAL_4PONTS';
          }
          else if (attribute.AttributeTypeName.toUpperCase() === 'ARTICLENUMBER') {
            attributeField.inputType = 'articlenumber';
            attributeField.lookupSource = 'catalogs.articles';
            attributeField.lookupFilter = {'Status': 1};
          }
          else if (attribute.AttributeTypeName.toUpperCase() === 'LINKEDCATALOGARTICLENUMBER') {
            attributeField.inputType = 'linkedcatalogarticlenumber';
            attributeField.lookupSource = 'lists.linkedCatalogArticles';
            attributeField.lookupFilter = {'Status': 1};
          }
          else if (attribute.AttributeTypeName.toUpperCase() === 'COLORPALETTE') {
            attributeField.inputType = 'color-palette';
            attributeField.lookupSource = 'lists.sellerColorsFromColorPalette';
            attributeField.isfilterCriteria = true;
            attributeField.lookupFilter = {'Status': 1};
            attributeField.customLookupInfo = {value: 'value'};
          }
          else if (attribute.AttributeTypeName.toUpperCase() === 'MODELNUMBER') {
            attributeField.inputType = 'modelnumber';
            attributeField.lookupSource = 'lists.sellerModelsWithoutAttributes';
          }
          else if (attribute.AttributeTypeName.toUpperCase() === 'LOOKUPTABLE') {
            attributeField.inputType = 'lookup-table';
          }
          else if (attribute.AttributeTypeName.toUpperCase() === 'DATASET') {
            attributeField.inputType = 'dataset';
            attributeField.datasetId = attribute.DatasetId;
            // Line-plan articles are catalog articles; scope dataset values to the catalog.
            attributeField.isCatalogScoped = true;
          }
          else if (attribute.AttributeTypeName.toUpperCase() === 'DATATABLE') {
            attributeField.inputType = 'datatable';
            attributeField.DataTableAttributes = attribute.DataTableAttributes
            if(attribute.AllowedValuesV2 && attribute.AllowedValuesV2.length) {
              try {
                attributeField.valuesV2 = JSON.parse(attribute.AllowedValuesV2)
              } catch(error) {
                console.warn(attribute.AttributeDisplayName + " - Allowed Values Version 2 : Invalid JSON format");
              }
            }
            if(attribute.CriteriaV2 && attribute.CriteriaV2.length) {
              try {
                attributeField.criteriaV2 = JSON.parse(attribute.CriteriaV2)
              } catch(error) {
                console.warn(attribute.AttributeDisplayName + " - Criteria Version 2 : Invalid JSON format");
              }
            }
            if(api.allAttributesListMap && Object.keys(api.allAttributesListMap).length > 0) {
                attributeField.dataTableAttributesDetails = attributeField.DataTableAttributes.map(function(attrId) {
                    return api.allAttributesListMap[attrId];
                }).filter(function(attr) {
                    return attr !== undefined;
                })
            }
          }
        }

        // make article_type attributes as creatable and editable false as we are handling this internally, no need to show in create/edit page
        if(attributeField.field.toLowerCase() === 'article_type') {
          attributeField.creatable = false;
          attributeField.editable = false;
        }

        // make self attribute creatable or editable if they are required attributes or creatable and editable respectively
        // and if source is parent disable create and edit — EXCEPT Overridable attributes in an inherited
        // (child) catalog (catalogTypeId === 3), which the child may override inline; keep the editable/creatable
        // set by the Overridable gate above (#42185) so the blanket parent-lockdown rule (#50695) doesn't defeat it.
        if (attribute.AttributeSource.toUpperCase() === 'SELF') {
          if (attribute.Editable || attribute.IsRequired) {
            attributeField.editable = true;
          }
          if (attribute.Creatable || attribute.IsRequired) {
            attributeField.creatable = true;
          }
        } else if (!(catalogTypeId === 3 && attribute.Overridable)) {
          attributeField.editable = false;
          attributeField.creatable = false;
        }

        //insert additional attributes fields before 'CreatedDate' property in model
        var index = dynamicArticleModel.fields.indexOf(utility.filterObject(dynamicArticleModel.fields, { field: 'CreatedDate' }, true)[0]);
        dynamicArticleModel.fields.splice(index, 0, angular.copy(attributeField));

        //adding up to 5 attributes to default articles view default column list (views.mainList.columns)
        if (attribute.VisibleInListByDefault) {
          var columnsIndex = dynamicArticleModel.views.mainList.columns.indexOf(utility.filterObject(dynamicArticleModel.views.mainList.columns, 'UpdatedDate', true)[0]);
          dynamicArticleModel.views.mainList.columns.splice(columnsIndex, 0, attributeField.field);
        }
      });

      api.webGet('/app/app.config.json').then(function (response) {
        if (angular.isDefined(response) && angular.isDefined(response.data) && angular.isDefined(response.data.model)
          && angular.isDefined(response.data.model[model.modelPath]) && angular.isArray(response.data.model[model.modelPath].fields)
          && response.data.model[model.modelPath].fields.length) {
          var configFields = response.data.model[model.modelPath].fields;
          var configFieldsMap = {};
          angular.forEach(configFields, function (configField) {
            configFieldsMap[configField.field] = configField;
          });
          angular.forEach(dynamicArticleModel.fields, function (dynamicModelField) {
            if (angular.isDefined(configFieldsMap[dynamicModelField.field])) {
              dynamicModelField = Object.assign(dynamicModelField, configFieldsMap[dynamicModelField.field]);
              // specific for carryover linked attribute
              var articleLinkedAttrubute = utility.filterObject(linkedAttributes, { AttributeSystemName: dynamicModelField.field }, true)[0];
              if(angular.isDefined(articleLinkedAttrubute)) {
                dynamicModelField.isLinkedAttributeCreatable = articleLinkedAttrubute.Editable === 0 ? false :
                (articleLinkedAttrubute.Editable === 1 && !dynamicModelField.creatable) ? false :
                dynamicModelField.creatable;
                dynamicModelField.isLinkedAttributeEditable = articleLinkedAttrubute.Editable === 0 ? false :
                (articleLinkedAttrubute.Editable === 1 && !dynamicModelField.editable) ? false :
                dynamicModelField.editable;
              }
            }
          });
        }
      }).finally(function () {
        applyRoleBasedAttributeRestrictions(dynamicArticleModel);
        deferred.resolve(dynamicArticleModel);
      });
      return deferred.promise;
    }

    function createArticlesBlockingModel(targetModelPath, parentModelPath, propertiesMapper, inputType) {
      var activeCatalog = getActiveCatalog();
      var activeCatalogCode = activeCatalog.CatalogCode;

      var fieldTemplate = {catalogCode: '', field: '', map: '', type: 'text', displayLabel: '', visible: true, creatable: false, editable: false, inputType: '',
                            validation: { isRequired: false, maxLen: -1, minLen: -1, pattern: '',
                                          messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}
                                        }
                          };
      fieldTemplate.inputType = inputType;

      var parentModel = api.getModel(parentModelPath);
      var targetModel = angular.copy(api.getModel(targetModelPath));
      targetModel.baseModel = api.getModel(targetModelPath);

      dynamicModel[targetModelPath] = angular.isUndefined(dynamicModel[targetModelPath]) ? {} : dynamicModel[targetModelPath];
      var maxDefaultColumnCounter = 4;
      var isParentRecordDirty = false; // indicate possibilities of parent model's record being dirty despite of parent model isDirty being false due to refresh in parent model after changes
      var importButton = utility.filterObject(targetModel.views.mainList.listActions, { id: 'import' }, true)[0];

      if (activeCatalog.DataSourceTypeId === 3) {
        targetModel.views.mainList.fabAction.visible = false;
        importButton.disabled = 'true';
      } else {
        targetModel.views.mainList.fabAction.visible = true;
        importButton.disabled = 'false';
      }

      //TODO: add lastUpdatedOn to catalog model
       // parent model last updated time for specific catalog
      var pLastUpdatedOn = angular.isDefined(parentModel.lastUpdatedOn) ? parentModel.lastUpdatedOn : undefined;
      if(angular.isUndefined(pLastUpdatedOn) || angular.isUndefined(dynamicModel[targetModelPath][activeCatalogCode])
      || angular.isUndefined(dynamicModel[targetModelPath][activeCatalogCode].lastUpdatedOn)
      || pLastUpdatedOn !== dynamicModel[targetModelPath][activeCatalogCode].lastUpdatedOn ) {
          isParentRecordDirty = true;
      }


      if( !dynamicModel[targetModelPath][activeCatalogCode] || parentModel.isDirty || isParentRecordDirty ) {

        if(dynamicModel[targetModelPath][activeCatalogCode]) {
          maxDefaultColumnCounter = 0; // if model exit do not recalculate default columns
        }
        else {
          dynamicModel[targetModelPath][activeCatalogCode] = targetModel;
        }

        // if parent model is dirty recalculate columns and default columns
        if(parentModel.isDirty || isParentRecordDirty) {
          dynamicModel[targetModelPath][activeCatalogCode].fields = targetModel.fields;
          dynamicModel[targetModelPath][activeCatalogCode].views.mainList.columns = targetModel.views.mainList.columns;
          maxDefaultColumnCounter = 4;
        }

        return parentModel.methods.getList( { forceFetch: true, isLogRequired: false }).then(function(response) {
          dynamicModel[targetModelPath][activeCatalogCode].lastUpdatedOn = parentModel.lastUpdatedOn;
          var childCatalogsList = [];
          getAllChildCatalogs(response.data, activeCatalogCode, childCatalogsList);
          angular.forEach(childCatalogsList, function(field) {
              angular.forEach(propertiesMapper, function(property) {
                fieldTemplate[property.target] = $rootScope.$eval(property.source, {field: field});
              });
              fieldTemplate.field = fieldTemplate.field.toString(); // to convert the field value which is catalogCode to string
              fieldTemplate.catalogCode = field[parentModel.idField];//add catalogCode to model's field use for flattening the response (to search record)
              fieldTemplate.isDynamicProperty = true;
              dynamicModel[targetModelPath][activeCatalogCode].fields.push(angular.copy(fieldTemplate));
              if(maxDefaultColumnCounter > 0) {
                  dynamicModel[targetModelPath][activeCatalogCode].views.mainList.columns.push(angular.copy(fieldTemplate.field));
                  maxDefaultColumnCounter -= 1;
              }
          });
          return dynamicModel[targetModelPath][activeCatalogCode];
        });
      }
      return $q.when(dynamicModel[targetModelPath][activeCatalogCode]);
    }

    function getAllChildCatalogs(catalogList, catalogCode, childCatalogsList) {
      angular.forEach(catalogList, function(field) {
        if(catalogCode === field.ReferenceCatalogCode && angular.isDefined(field.Status) && field.Status === 1) {// only active child catalog
          childCatalogsList.push(field);
          getAllChildCatalogs(catalogList, field.CatalogCode, childCatalogsList);
        }
      });
    }

    /**
    * @description
    * this method will modify copy of article model for assort article view for inherited catalogs
    * it will modify the the `temActions`, `listActions`, it will hide the Status field and add IsAssigned field as Status field for directive
    * it will add `IsAssigned` as default column right before `UpdatedDate` field if exist or if not it will append to last column
    */
    function createOrderlineModel() {
      var activeCatalog = getActiveCatalog();
      var activeCatalogId = activeCatalog.CatalogCode;

      var catalogModel = api.catalogs.catalogs;
      var pristineOrderlineModel = angular.copy(api.orders.orderlines);

      var attributeField = { field: '', type: 'text', displayLabel: '', visible: true, creatable: false, editable: false, inputType: 'text', reportable: false,
      validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' }} };

      dynamicModel['orders.orderlines'] = angular.isDefined(dynamicModel['orders.orderlines']) ? dynamicModel['orders.orderlines'] : {};

      if (!dynamicModel['orders.orderlines'][activeCatalogId] || catalogModel.isDirty) {
        if (!dynamicModel['orders.orderlines'][activeCatalogId]) {
          dynamicModel['orders.orderlines'][activeCatalogId] = pristineOrderlineModel;
          var orderlineModelAlias = dynamicModel['orders.orderlines'][activeCatalogId];
          orderlineModelAlias.baseModel = api.getModel('orders.orderlines');
        }
        // if parent model is dirty recalculate columns
        if (catalogModel.isDirty) {
          // if dynamicModel['orders.orderlines'][activeCatalogId] defined but catalog model is dirty > orderlineModelAlias will be undefined
          orderlineModelAlias = dynamicModel['orders.orderlines'][activeCatalogId];
          orderlineModelAlias.fields = pristineOrderlineModel.fields;
        }

        var attributes = getActiveCatalogDetails().AssignedCatalogAttributes;

        //Create catalog specific attributes for articles
        angular.forEach(attributes, function (attribute) {

          attributeField.field = attribute.AttributeSystemName;
          attributeField.displayLabel = attribute.AttributeDisplayName;
          attributeField.isDynamicProperty = true;
          attributeField.reportable = true;

          //assign input type based on AttributeTypeName
          if (attribute.AttributeTypeName.toUpperCase() === 'INT') {
            attributeField.inputType = 'number';
          }
          else if (attribute.AttributeTypeName.toUpperCase() === 'NVARCHAR') {
            attributeField.inputType = 'textArea';
          }
          else if (attribute.AttributeTypeName.toUpperCase() === 'MULTIVALUE') {
            attributeField.inputType = 'tags';
            attributeField.tagSeparator = '|';
            attributeField.inputSubType = 'multi-value';
          }
          else if (attribute.AttributeTypeName.toUpperCase() === 'DATE') {
            attributeField.inputType = 'date-without-time';
          }
          else if (attribute.AttributeTypeName.toUpperCase() === 'DATETIME') {
            attributeField.inputType = 'date';
          }
          else if (attribute.AttributeTypeName.toUpperCase() === 'BOOL') {
            attributeField.inputType = 'bool-str';
          }
          else if(attribute.AttributeTypeName.toUpperCase() === 'CALC') {
            attributeField.creatable = false;
            attributeField.editable = false;
            attributeField.isBulkEditable = false;
            attributeField.inputType = 'calculated';
            attributeField.validation.pattern = '';
            attributeField.calculatedExpression = attribute.ValidationExpression;
            //Adding try catch if JSON parse fails
            try {
              attributeField.parsedExpressionObject = JSON.parse(attribute.ValidationExpression);
              if(angular.isDefined(attributeField.parsedExpressionObject.calculatedRegexExpression)) {
                var calculatedRegexExpression = attributeField.parsedExpressionObject.calculatedRegexExpression;
                if(angular.isDefined(calculatedRegexExpression.fieldRegex) && calculatedRegexExpression.fieldRegex.length > 0) {
                  angular.forEach(calculatedRegexExpression.fieldRegex, function(fieldRegex) {
                     var convertedRegEx = convertStringToRegex(fieldRegex.regEx);
                     if(convertedRegEx !== null) {
                        fieldRegex.regEx = convertedRegEx;
                     } else {
                        console.warn("invalid Regex for : " + fieldRegex.field);
                     }
                  })
                }
                attributeField.calcType = calculatedRegexExpression.type;
              }
            } catch(error) {
              console.warn(attribute.AttributeDisplayName + " - Attribute Validation Expression : Invalid JSON format");
            }
          }
          else if (attribute.AttributeTypeName.toUpperCase() === 'DATEOPTION') {
            attributeField.inputType = 'date-option';
          }
          else if (attribute.AttributeTypeName.toUpperCase() === 'DECIMAL') {
            attributeField.inputType = 'decimal';
            attributeField.validation.pattern = '^[+]?\\d+([.]\\d{0,4})?$';
            attributeField.validation.messages.pattern = 'VALIDATIONS.POSITIVE_DECIMAL_4PONTS';
          }
          else if (attribute.AttributeTypeName.toUpperCase() === 'ARTICLENUMBER') {
            attributeField.inputType = 'articlenumber';
            attributeField.lookupSource = 'catalogs.articles';
            attributeField.lookupFilter = {'Status': 1};
          }
          else if (attribute.AttributeTypeName.toUpperCase() === 'LINKEDCATALOGARTICLENUMBER') {
            attributeField.inputType = 'linkedcatalogarticlenumber';
            attributeField.lookupSource = 'lists.linkedCatalogArticles';
            attributeField.lookupFilter = {'Status': 1};
          }
          else if (attribute.AttributeTypeName.toUpperCase() === 'COLORPALETTE') {
            attributeField.inputType = 'color-palette';
            attributeField.lookupSource = 'lists.sellerColorsFromColorPalette';
            attributeField.isfilterCriteria = true;
            attributeField.lookupFilter = {'Status': 1};
            attributeField.customLookupInfo = {value: 'value'}
          }
          else if (attribute.AttributeTypeName.toUpperCase() === 'MODELNUMBER') {
            attributeField.inputType = 'modelnumber';
            attributeField.lookupSource = 'lists.sellerModelsWithoutAttributes';
          }
          else if (attribute.AttributeTypeName.toUpperCase() === 'LOOKUPTABLE') {
            attributeField.inputType = 'lookup-table';
          }
          else if (attribute.AttributeTypeName.toUpperCase() === 'DATASET') {
            attributeField.inputType = 'dataset';
            attributeField.datasetId = attribute.DatasetId;
          }
          else if (attribute.AttributeTypeName.toUpperCase() === 'DATATABLE') {
            attributeField.inputType = 'datatable';
            attributeField.DataTableAttributes = attribute.DataTableAttributes
            if(attribute.AllowedValuesV2 && attribute.AllowedValuesV2.length) {
              try {
                attributeField.valuesV2 = JSON.parse(attribute.AllowedValuesV2)
              } catch(error) {
                console.warn(attribute.AttributeDisplayName + " - Allowed Values Version 2 : Invalid JSON format");
              }
            }
            if(attribute.CriteriaV2 && attribute.CriteriaV2.length) {
              try {
                attributeField.criteriaV2 = JSON.parse(attribute.CriteriaV2)
              } catch(error) {
                console.warn(attribute.AttributeDisplayName + " - Criteria Version 2 : Invalid JSON format");
              }
            }
            if(api.allAttributesListMap && Object.keys(api.allAttributesListMap).length > 0) {
                attributeField.dataTableAttributesDetails = attributeField.DataTableAttributes.map(function(attrId) {
                    return api.allAttributesListMap[attrId];
                }).filter(function(attr) {
                    return attr !== undefined;
                })
            }
          }

          //insert additional attributes fields before 'CreatedDate' property in model
          var index = orderlineModelAlias.fields.indexOf(utility.filterObject(orderlineModelAlias.fields, { field: 'CreatedDate' })[0]);
          orderlineModelAlias.fields.splice(index, 0, angular.copy(attributeField));
        });
        return orderlineModelAlias;
      }
      return dynamicModel['orders.orderlines'][activeCatalogId];
    }

    /**
    * Storing active catalog in local storage and session storage
    */
    function setActiveCatalog(catalog) {
      var deferred = $q.defer();
      var promise = deferred.promise;

      var activeCatalog = $localStorage.ActiveCatalog;
      var changedActive = false;

      if (angular.isUndefined(catalog)) {
        if (angular.isUndefined(_listOfCatalogs)) {
          $log.warn('setActiveCatalog(): Invalid Call');
          $localStorage.ActiveCatalog = {}; // to prevent unlimited request from initialize application in index.run when there are no catalog created
          $sessionStorage.ActiveCatalogSession = {};
        } else if (_listOfCatalogs.length > 0) {
          $localStorage.ActiveCatalog = angular.copy(_listOfCatalogs[0]);
          $sessionStorage.ActiveCatalogSession = angular.copy(_listOfCatalogs[0]);

          changedActive = true;
        }
        // return; // when app initialize or setting up active catalog for first time this return statement prevent creation of activeCatalogDetails
      } else {
        if (activeCatalog &&  catalog && catalog.CatalogCode != activeCatalog.CatalogCode) {
          api.ownCache.removeAll();
          changedActive = true;
        }

        if (utility.filterObject(_listOfCatalogs, { CatalogCode: catalog.CatalogCode }, true).length === 0) {
          if (_listOfCatalogs && _listOfCatalogs.length > 0) {
            $localStorage.ActiveCatalog = angular.copy(_listOfCatalogs[0]);
            $sessionStorage.ActiveCatalogSession = angular.copy(_listOfCatalogs[0]);
            changedActive = true;
          } else {
            $log.warn('setActiveCatalog(): No catalog found!');
            $localStorage.ActiveCatalog = {};
            $sessionStorage.ActiveCatalogSession = {};
          }
        }
        else {
          $localStorage.ActiveCatalog = angular.copy(catalog);
          $sessionStorage.ActiveCatalogSession = angular.copy(catalog);
          changedActive = true;
        }
      }

      if (changedActive) {
        _updatePrivileges($localStorage.ActiveCatalog);
        // specific to dune images module : add contextKey in catalog data based on active catalogs assigned context and assigned user privileges
        if(!utility.isObjectEmpty($localStorage.ActiveCatalog) && !utility.isObjectEmpty($sessionStorage.ActiveCatalogSession)) {
          var assignedContextKey = setDuneContextKeyInCatalogFactory();
          setCatalogContextKey(assignedContextKey);
        }
        //UPDATE catalog data-source properties for line plan catalog
        if ($localStorage.ActiveCatalog.IsLinePlan === 1 && $sessionStorage.ActiveCatalogSession.IsLinePlan === 1) {
          $localStorage.ActiveCatalog.DataSourceTypeId =CONSTANTS.LINE_PLAN_ID;
          $sessionStorage.ActiveCatalogSession.DataSourceTypeId = CONSTANTS.LINE_PLAN_ID;
          $localStorage.ActiveCatalog.DataSourceType = CONSTANTS.LINE_PLAN_CATALOG;
          $sessionStorage.ActiveCatalogSession.DataSourceType = CONSTANTS.LINE_PLAN_CATALOG;
        }

        var catalogDetailsPromise = setActiveCatalogDetails();
        //setting UseOrderType, UseConfirmOrder and AutomaticNumbering values in localStorage and sessionStorage for active catalog so as to fetch value from sessionStorage and updating localStorage Data
        var sellerDetailsPromise = api.accounts.sellers.methods.getDetails(false, getActiveCatalog().AccountId).then(function (response) {
          $localStorage.UseOrderType = response.data.UseOrderType;
          $localStorage.UseConfirmOrder = response.data.UseConfirmOrder;
          $sessionStorage.UseOrderTypeSession = angular.copy(response.data.UseOrderType);
          $sessionStorage.UseConfirmOrderSession = angular.copy(response.data.UseConfirmOrder);
          setNumberingSettings(response.data.AutomaticNumbering, response.data.CustomNumbering);
          $localStorage.IsSizeScaleByStyle = response.data.IsSizeScaleByStyle;
          $sessionStorage.IsSizeScaleByStyleSession = angular.copy(response.data.IsSizeScaleByStyle);
          $localStorage.ModelNameLength = response.data.ModelNameLength;
          $sessionStorage.ModelNameLength = angular.copy(response.data.ModelNameLength);
        });

        // Resolve seller-level segmentation planning values (T1S-SegmentationPlanningValues) as a
        // fallback. Catalog config always wins, so only fetch the seller config when segmentation
        // planning is enabled and the catalog itself does not define the config. Best-effort:
        // failures (e.g. user lacks seller-config read privilege) leave catalog/fallback values intact.
        catalogDetailsPromise.then(function () {
          if (getActiveCatalog().SegmentationPlanningEnable === 1 && !api._segmentationPlanningCatalogRaw &&
              angular.isDefined(api.sellers) && angular.isDefined(api.sellers.configurations)) {
            api.sellers.configurations.methods.getList({ forceFetch: false, isLogRequired: false }, getActiveCatalog().AccountId, api.sellers.configurations)
              .then(function (response) {
                api.setSellerConfigValues(response.data);
              })
              .catch(function () {});
          }
        });

        // the role based restrictions have to be in place before any dynamic model is built, so the catalog
        // is not considered active until they are loaded. A failing call must not block the catalog, hence the catch.
        var roleBasedRestrictionPromises = [];

        if(SecurityFactory.isAuthorized({accessPrivileges: CONSTANTS.PRIVILEGES.CATALOG_RESTRICT_MODULES.RESTRICT_SEGMENTATIONS})) {
          // role based restricted segmentations
          roleBasedRestrictionPromises.push(api.catalogs.roleBasedRestrictSegmentations.methods.getList({ forceFetch: true, isLogRequired: false }, getActiveCatalog().CatalogCode).then(function(response) {
            var roleBasedRestrictedSegmentations = response.data.Roles;
            var segmentationsArray = getCurrentRoleRestrictedSegmentationAndFormatToDesiredObjectArray(roleBasedRestrictedSegmentations);
            api.roleBasedRestrictions['restrictedSegmentationsArray'] = segmentationsArray;
          }).catch(function () {}));
        }

        if(SecurityFactory.isAuthorized({accessPrivileges: CONSTANTS.PRIVILEGES.CATALOG_RESTRICT_MODULES.ATTRIBUTE_RESTRICTIONS})) {
          // role based restricted attributes
          roleBasedRestrictionPromises.push(api.catalogs.roleBaseRestrictAttributes.methods.getList({ forceFetch: true, isLogRequired: false }, getActiveCatalog().CatalogCode).then(function(response) {
            var roleBasedRestrictedAttributes = response.data.Roles;
            var attributesArray = [];
            var currentUserRoles = getCurrentUserRoles();
            // filterout the restriction for current user's role
            angular.forEach(currentUserRoles, function(role) {
                var restrictedAttributes = utility.filterObject(roleBasedRestrictedAttributes, {RoleId: role.UserRoleId}, true)[0];
                if(angular.isDefined(restrictedAttributes)) {
                    angular.forEach(restrictedAttributes.Attributes, function(attribute) {
                        if(angular.isUndefined(attributesArray[attribute.AttributeSystemName])) {
                            attributesArray.push({Id: attribute.Id, Name: attribute.AttributeSystemName, notViewable: attribute.NotViewable, notEditable: attribute.NotEditable});
                        }
                    });
                }
            });
            api.roleBasedRestrictions['restrictedAttributesArray'] = attributesArray;
          }).catch(function () {}));
        }

        if(SecurityFactory.isAuthorized({accessPrivileges: CONSTANTS.PRIVILEGES.CATALOG_RESTRICT_MODULES.RESTRICT_RETAIL_WINDOWS})) {
          // role based restricted retailwindow
          roleBasedRestrictionPromises.push(api.catalogs.roleBasedRestrictRetailWindows.methods.getList({ forceFetch: true, isLogRequired: false }, getActiveCatalog().CatalogCode).then(function(response) {
            var roleBasedRestrictedRetailWindows = response.data.Roles;
            var retailWindowObject = {};
            var currentUserRoles = getCurrentUserRoles();
            // filterout the restriction for current user's role
            angular.forEach(currentUserRoles, function(role) {
                var restrictedRetailWindows = utility.filterObject(roleBasedRestrictedRetailWindows, {RoleId: role.UserRoleId}, true)[0];
                if(angular.isDefined(restrictedRetailWindows)) {
                    angular.forEach(restrictedRetailWindows.Attributes, function(retailWindow) {
                        if(angular.isDefined(retailWindow.Name)) {
                          retailWindowObject = {Name: retailWindow.Name, notViewable: retailWindow.NotViewable, notEditable: retailWindow.NotEditable};
                        }
                    });
                }
            });
            api.roleBasedRestrictions['restrictedRetailWindow'] = retailWindowObject;
          }).catch(function () {}));
        }

        // get article drop reasons
        if(SecurityFactory.isAuthorized({accessPrivileges: CONSTANTS.PRIVILEGES.SELLERS.DETAIL.ARTICLE_DROP_REASONS_LIST})) {
          api.sellers.articleDropReasons.methods.getList({ forceFetch: true, isLogRequired: false }, getActiveCatalog().AccountId).then(function(response) {
            api.setArticleDropReasonsList(utility.filterObject(response.data, {Status: 1}));
          });
        }

        // get users list
        if(SecurityFactory.isAuthorized({accessPrivileges: CONSTANTS.PRIVILEGES.USERS.LIST.USERS_LIST})) {
          api.accounts.users.methods.getList({ forceFetch: true, isLogRequired: false }).then(function(response) {
            api.setArticleAccountUsersList(response.data);
          });
        }

        $q.all([catalogDetailsPromise, sellerDetailsPromise].concat(roleBasedRestrictionPromises)).then(function () {
          deferred.resolve();
        });
      }
      else {
        deferred.resolve();
      }
      return promise;
    }

    function setActiveCatalogDetails() {
      return api.catalogs.catalogs.methods.getDetails(false, getActiveCatalog().CatalogCode)
      .then(function (response) {
        $localStorage.activeCatalogDetails = response.data;
        $sessionStorage.activeCatalogDetailsSession = angular.copy(response.data);
        api.setCatalogConfigValues(response.data.CatalogSpecificConfigurationList);

        if (SecurityFactory.isAuthorized({accessPrivileges: CONSTANTS.PRIVILEGES.SELLERS.ARTICLE_STATES_LIST})) {
          api.getAndSetArticleStateList(response.data.AccountId, response.data.AttributeGroupId);
        }
        // skip validation BGJobSpecialPermissionToSkipArticlesLimit is assigned
        if (!SecurityFactory.isAuthorized({accessPrivileges: CONSTANTS.PRIVILEGES.ARTICLES.ARTICLES_LIMIT_FOR_BG_JOB})) {
          api.setArticlesLimitForBackgroundJobs(response.data.CatalogSpecificConfigurationList);
        }
        else {
          api.articlesLimitForBackgroundJobs = 0;
        }

        if (SecurityFactory.isAuthorized({accessPrivileges: CONSTANTS.PRIVILEGES.GET_ALL_ATTRIBUTES_LIST})) {
          api.getAndSetAttributesList();
        }

        //UPDATE catalog data-source properties for line plan catalog
        if ($localStorage.activeCatalogDetails.IsLinePlan === 1 && $sessionStorage.activeCatalogDetailsSession.IsLinePlan === 1) {
          $sessionStorage.activeCatalogDetailsSession.DataSourceTypeId = CONSTANTS.LINE_PLAN_ID;
          $localStorage.activeCatalogDetails.DataSourceTypeId = CONSTANTS.LINE_PLAN_ID;
          $sessionStorage.activeCatalogDetailsSession.DataSourceType = CONSTANTS.LINE_PLAN_CATALOG;
          $localStorage.activeCatalogDetails.DataSourceType = CONSTANTS.LINE_PLAN_CATALOG;
        }

        // get seller lookups and filter the valid lookups which are part of current catalog AttributeGroupId
        // if all the source attributes and destination attributes are part of catalog then only we will add it to valid lookups
        if(SecurityFactory.isAuthorized({accessPrivileges: CONSTANTS.PRIVILEGES.SELLERS.DETAIL.SELLER_LOOKUP_TABLE})) {
          api.sellers.sellerLookups.methods.getList({ forceFetch: true, isLogRequired: false }, getActiveCatalog().AccountId).then(function(response) {
            if(response.data.length) {
              var sellerLookups = utility.filterObject(response.data, {AttributeGroupId: getActiveCatalog().AttributeGroupId});
              getValidLookupDetailsAndGenerateMap(sellerLookups).then(function (mergedData) {
                api.setValidSellerLookupsDestinationAttributesMap(mergedData);
              });
            }
          });
        }
      });
    }

    // if all the source and destination attributes are part of current catalog then only we will consider it
    // if for one destination attribute mutiple lookup found then we will consider the first entry and will ignore other entries
    function getValidLookupDetailsAndGenerateMap(sellerLookups) {
      var catalogAssignAttributes = getActiveCatalogDetails().AssignedCatalogAttributes;
      var lookupPromises = [];
      angular.forEach(sellerLookups, function(lookup) {
        var isAllSourceAndDestinationAttributesPresnt = true;
        var sourceAttributes = lookup.SourceAttributes.split('|');
        var destinationAttributes = lookup.DestinationAttributes.split('|');
        var mergedAttributesArray = sourceAttributes.concat(destinationAttributes);
        for(var i = 0; i<= mergedAttributesArray.length; i++) {
          var index = catalogAssignAttributes.indexOf(utility.filterObject(catalogAssignAttributes, { AttributeSystemName: mergedAttributesArray[i] })[0]);
          if(index === -1) {
            isAllSourceAndDestinationAttributesPresnt = false;
            break;
          }
        }

        if(isAllSourceAndDestinationAttributesPresnt) {
          // get the lookup details
          var promise = api.sellers.sellerLookups.methods.getDetails(true, lookup.Id, getActiveCatalog().AccountId).then(function(response) {
            var lookupValues = response.data.Values;
            // create a destination attribute map with source attributes and its values
            var transformedData = {};
            lookupValues.forEach(function(value) {
              Object.keys(value.Destination).forEach(function(destinationKey) {
                if (!transformedData[destinationKey]) {
                  transformedData[destinationKey] = lookupValues;
                }
              });
            });
            return transformedData;
          });
          lookupPromises.push(promise)
        }
      });

      return Promise.all(lookupPromises).then(function(results) {
        // merge the data from all promises into one object
        var mergedData = {};
        results.forEach(function (data) {
            mergedData = Object.assign({}, mergedData, data);
        });
        return mergedData;
      });
    }

    // for dunes modele : assigned context key is based on the user privileges and the context keys assigned to catalog
    // if user have both read,wrtie privileges and both read, write keys assigned in catalog then contextKey will be the catalogs ContextReadWriteKey
    // else we the contextKey will be ContextReadKey
    function setDuneContextKeyInCatalogFactory() {
      var readWriteAccess = '';
      var assignedContextKey = '';
      var userReadPrivilege = SecurityFactory.isAuthorized({accessPrivileges: CONSTANTS.PRIVILEGES.T1_DUNE.READ_ACCESS});
      var userWritePrivilege = SecurityFactory.isAuthorized({accessPrivileges: CONSTANTS.PRIVILEGES.T1_DUNE.READ_WRITE_ACCESS});

      readWriteAccess = ((userReadPrivilege && userWritePrivilege) ?
        CONSTANTS.PRIVILEGES.T1_DUNE.ACCESS.WRITE :
        (userReadPrivilege && !userWritePrivilege) ? CONSTANTS.PRIVILEGES.T1_DUNE.ACCESS.READ : '');

      if(readWriteAccess !== '') {
        if(readWriteAccess === CONSTANTS.PRIVILEGES.T1_DUNE.ACCESS.READ) {
          assignedContextKey = getActiveCatalog().ContextReadKey;
        } else if(readWriteAccess === CONSTANTS.PRIVILEGES.T1_DUNE.ACCESS.WRITE) {
          assignedContextKey = getActiveCatalog().ContextReadWriteKey;
        }
      }
      return assignedContextKey;
    }

    function getActiveCatalogPersisted() {
      return $localStorage['ActiveCatalog']
    }

    function getActiveCatalog() {
       var catalog = $sessionStorage['ActiveCatalogSession'];

      if (catalog) {
        return catalog;
      }

      // fallback dummy catalog
      return {
        CatalogCode: 0,
        CatalogName: 'Dummy Catalog',
        Id: 0,
        AccountId: 0,
        AttributeGroupId: 0,
        DataSourceTypeId: 0,
        catalogSeasonalSequence: 0,
        RetailWindowAttribute: '',
      };
    }

    function getActiveCatalogDetails() {
       var catalogDetails = $sessionStorage['activeCatalogDetailsSession'];

      if (catalogDetails) {
        return catalogDetails;
      }

      // fallback dummy catalog
      return {
        CatalogCode: 0,
        CatalogName: 'Dummy Catalog',
        Id: 0,
        AccountId: 0,
        AttributeGroupId: 0,
        DataSourceTypeId: 0,
        catalogSeasonalSequence: 0,
        RetailWindowAttribute: '',
      };
    }

    function getUseOrderType() {
      return $sessionStorage['UseOrderTypeSession'];
    }

    function getUseConfirmOrder() {
      return $sessionStorage['UseConfirmOrderSession'];
    }

    function getListOfCatalogs() {
      return _listOfCatalogs;
    }

    function setCatalogContextKey(contextKey) {
      catalogContextKey = contextKey;
    }

    function getCatalogContextKey() {
      return catalogContextKey;
    }

    function getUnsavedDraftOrders() {
      return $sessionStorage['UnSavedDraftOrders'];
    }

    // checks if logged in user has access to see the blocked image for active catalog
    function doesUserHaveAccessToBlockedImagesForActiveCatalog() {
      return SecurityFactory.isAuthorized({accessPrivileges: ['AllowBlockedArticleImages']})
    }

    // hide actions for child catalogs/sellers ( used in relation types, seller colors)
    function modifyModelActions(model) {
      model.views.mainList.itemActions = [];
      model.views.mainList.listActions = [];
      model.views.mainList.fabAction.visible = false;
    }

    function getCurrentRoleRestrictedSegmentationAndFormatToDesiredObjectArray(roleBasedRestrictedSegmentations) {
      var segmentationsArray = [];
      var currentUserRoles = getCurrentUserRoles();
      // filterout the restriction for current user's role
      angular.forEach(currentUserRoles, function(role) {
          var restrictedSegmentations = utility.filterObject(roleBasedRestrictedSegmentations, {RoleId: role.UserRoleId}, true)[0];
          if(angular.isDefined(restrictedSegmentations)) {
              angular.forEach(restrictedSegmentations.Segmentations, function(segmentation) {
                  if(angular.isUndefined(segmentationsArray[segmentation.Name])) {
                      segmentationsArray.push({Id: segmentation.Id, Name: segmentation.Name, notViewable: segmentation.NotViewable, notEditable: segmentation.NotEditable});
                  }
              });
          }
      });
      return segmentationsArray;
    }

    function removeRestrictedSegmentations(records, restrictedSegmentations) {
      var restrictedSegmentationsList = getCurrentRoleRestrictedSegmentationAndFormatToDesiredObjectArray(restrictedSegmentations);
      var nonRestrictedSegmentations = [];
      angular.forEach(records, function(segmentation) {
        var segmentationObj = utility.filterObject(restrictedSegmentationsList, { Id: segmentation.Id}, true)[0];
        if (angular.isDefined(segmentationObj) && !segmentationObj.notViewable) {
          nonRestrictedSegmentations.push(segmentation);
        } else if(angular.isUndefined(segmentationObj)) {
          nonRestrictedSegmentations.push(segmentation);
        }
      });
      return nonRestrictedSegmentations;
    }

    function transformSharedFolders(directories, allDirectories) {
      var folders = [];
      if (angular.isDefined(allDirectories) && angular.isArray(allDirectories) && allDirectories.length > 0) {
        angular.forEach(directories, function (directory) {
          directory['nodes'] = [];
          directory['title'] = directory.Name;
          directory['type'] = 'folder';
          directory['ancestorDisabledStatus'] = directory.Status;
          var subDirectories = utility.filterObject(allDirectories, { ParentFolderId: directory[api.catalogs.sharedFoldersTree.idField] }, true);
          angular.forEach(subDirectories, function (subDirectory) {
            subDirectory['title'] = subDirectory.Name;
            subDirectory['type'] = 'folder';
            subDirectory['ancestorDisabledStatus'] = subDirectory.Status;
            directory.nodes.push(subDirectory);
            allDirectories.splice(allDirectories.indexOf(subDirectory), 1);
          });
          folders.push(directory);
          transformSharedFolders(subDirectories, allDirectories);
        });
      } else { // when there are no parent folders
        angular.forEach(allDirectories, function (directory) {
          directory['nodes'] = [];
          directory['title'] = directory.Name;
          directory['type'] = 'folder';
          directory['ancestorDisabledStatus'] = directory.Status;
          var subDirectories = utility.filterObject(allDirectories, { ParentFolderId: directory[api.catalogs.sharedFoldersTree.idField] }, true);
          angular.forEach(subDirectories, function (subDirectory) {
            subDirectory['title'] = subDirectory.Name;
            subDirectory['type'] = 'folder';
            subDirectory['ancestorDisabledStatus'] = subDirectory.Status;
            directory.nodes.push(subDirectory);
            allDirectories.splice(allDirectories.indexOf(subDirectory), 1);
          });
          folders.push(directory);
        });
      }
      return folders;
    }

    // show the tags as comma seprated in ui and resolve AssetTypeId to AssetTypeName
    function transformDunesResponse(sourceData, assetTypesMap) {
      var result = [];
      angular.forEach(sourceData, function (record) {
        if(angular.isDefined(record.Tags) && record.Tags.length) {
          var tagNames = [];
          angular.forEach(record.Tags, function(tag) {
            if(angular.isDefined(tag.Tag) && tag.Status) {
              tagNames.push(tag.Tag);
            }
          });
          delete record['Tags'];
          record['Tags'] = tagNames;
        }
        // Resolve AssetTypeId to AssetTypeName
        if(assetTypesMap && angular.isDefined(record.AssetTypeId)) {
          record.AssetTypeName = assetTypesMap[record.AssetTypeId] || record.AssetTypeId;
        }
        result.push(record);
      });
      return result;
    }

    function createLookupValuesModelWithSourceAndDestAttributes(lookupData) {
      var deferred = $q.defer();
      var valuesModel = angular.copy(api.sellers.lookupValues);
      valuesModel.baseModel = api.getModel(valuesModel.modelPath);
      var sourceAttributes = lookupData.SourceAttributes.split('|');
      var destinationAttributes = lookupData.DestinationAttributes.split('|');
      var validSourceAttributeSystemName = [];
      var attributeFieldTemplate = {
        field: '', type: 'text', displayLabel: '', visible: true, creatable: true, editable: false, inputType: 'text', reportable: false,
        validation: { isRequired: true, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }
      };
      api.attributes.attributes.methods.getList({ forceFetch: true, isLogRequired: false })
      .then(function (response) {
        var attributes = response.data;
        //Create catalog specific attributes for lookup values model
        angular.forEach(attributes, function (attribute) {
          if(sourceAttributes.includes(attribute.AttributeSystemName) || destinationAttributes.includes(attribute.AttributeSystemName)) {
            var attributeField = angular.copy(attributeFieldTemplate);
            attributeField.field = attribute.AttributeSystemName;
            if (sourceAttributes.includes(attribute.AttributeSystemName)) {
              attributeField.displayLabel = 'S:' + attribute.AttributeDisplayName
              validSourceAttributeSystemName.push(attribute.AttributeSystemName)
            } else if (destinationAttributes.includes(attribute.AttributeSystemName)) {
              attributeField.displayLabel = 'D:' + attribute.AttributeDisplayName
            } else {
              attributeField.displayLabel = attribute.AttributeDisplayName
            }
            attributeField.isDynamicProperty = true;
            attributeField.reportable = true;

            //assign input type based on AttributeTypeName
            if (attribute.AttributeTypeName.toUpperCase() === 'INT') {
              attributeField.inputType = 'number';
            }
            else if (attribute.AttributeTypeName.toUpperCase() === 'NVARCHAR') {
              attributeField.inputType = 'textArea';
            }
            else if (attribute.AttributeTypeName.toUpperCase() === 'MULTIVALUE') {
              attributeField.inputType = 'multi-value';
            }
            else if (attribute.AttributeTypeName.toUpperCase() === 'DATE') {
              attributeField.inputType = 'date-without-time';
            }
            else if (attribute.AttributeTypeName.toUpperCase() === 'DATETIME') {
              attributeField.inputType = 'date';
            }
            else if (attribute.AttributeTypeName.toUpperCase() === 'BOOL') {
              attributeField.inputType = 'bool-str';
            }
            else if (attribute.AttributeTypeName.toUpperCase() === 'CALC') {
              attributeField.editable = false;
              attributeField.isBulkEditable = false;
              attributeField.inputType = 'calculated';
              attributeField.validation.pattern = '';
              attributeField.calculatedExpression = attribute.ValidationExpression;
              //Adding try catch if JSON parse fails
              try {
                attributeField.parsedExpressionObject = JSON.parse(attribute.ValidationExpression);
                if(angular.isDefined(attributeField.parsedExpressionObject.calculatedRegexExpression)) {
                  var calculatedRegexExpression = attributeField.parsedExpressionObject.calculatedRegexExpression;
                  if(angular.isDefined(calculatedRegexExpression.fieldRegex) && calculatedRegexExpression.fieldRegex.length > 0) {
                    angular.forEach(calculatedRegexExpression.fieldRegex, function(fieldRegex) {
                        var convertedRegEx = convertStringToRegex(fieldRegex.regEx);
                        if(convertedRegEx !== null) {
                          fieldRegex.regEx = convertedRegEx;
                        } else {
                          console.warn("invalid Regex for : " + fieldRegex.field);
                        }
                    })
                  }
                  attributeField.calcType = calculatedRegexExpression.type;
                }
              } catch(error) {
                console.warn(attribute.AttributeDisplayName + " - Attribute Validation Expression : Invalid JSON format");
              }
            }
            else if (attribute.AttributeTypeName.toUpperCase() === 'DATEOPTION') {
              attributeField.inputType = 'date-option';
            }
            else if (attribute.AttributeTypeName.toUpperCase() === 'DECIMAL') {
              attributeField.inputType = 'decimal';
              attributeField.validation.pattern = '^[+]?\\d+([.]\\d{0,4})?$';
              attributeField.validation.messages.pattern = 'VALIDATIONS.POSITIVE_DECIMAL_4PONTS';
            }
            else if (attribute.AttributeTypeName.toUpperCase() === 'ARTICLENUMBER') {
              attributeField.inputType = 'articlenumber';
              attributeField.lookupSource = 'catalogs.articles';
              attributeField.lookupFilter = {'Status': 1};
            }
            else if (attribute.AttributeTypeName.toUpperCase() === 'LINKEDCATALOGARTICLENUMBER') {
              attributeField.inputType = 'linkedcatalogarticlenumber';
              attributeField.lookupSource = 'lists.linkedCatalogArticles';
              attributeField.lookupFilter = {'Status': 1};
            }
            else if (attribute.AttributeTypeName.toUpperCase() === 'COLORPALETTE') {
              attributeField.inputType = 'color-palette';
              attributeField.lookupSource = 'lists.sellerColorsFromColorPalette';
              attributeField.isfilterCriteria = true;
              attributeField.lookupFilter = {'Status': 1};
              attributeField.customLookupInfo = {value: 'value'}
            }
            else if (attribute.AttributeTypeName.toUpperCase() === 'MODELNUMBER') {
              attributeField.inputType = 'modelnumber';
              attributeField.lookupSource = 'lists.sellerModelsWithoutAttributes';
            }
            else if (attribute.AttributeTypeName.toUpperCase() === 'LOOKUPTABLE') {
              attributeField.inputType = 'lookup-table';
            }
            else if (attribute.AttributeTypeName.toUpperCase() === 'DATASET') {
              attributeField.inputType = 'dataset';
              attributeField.datasetId = attribute.DatasetId;
            }
            else if (attribute.AttributeTypeName.toUpperCase() === 'DATATABLE') {
              attributeField.inputType = 'datatable';
              attributeField.DataTableAttributes = attribute.DataTableAttributes
              if(attribute.AllowedValuesV2 && attribute.AllowedValuesV2.length) {
                try {
                  attributeField.valuesV2 = JSON.parse(attribute.AllowedValuesV2)
                } catch(error) {
                  console.warn(attribute.AttributeDisplayName + " - Allowed Values Version 2 : Invalid JSON format");
                }
              }
              if(attribute.CriteriaV2 && attribute.CriteriaV2.length) {
                try {
                  attributeField.criteriaV2 = JSON.parse(attribute.CriteriaV2)
                } catch(error) {
                  console.warn(attribute.AttributeDisplayName + " - Criteria Version 2 : Invalid JSON format");
                }
              }
              if(api.allAttributesListMap && Object.keys(api.allAttributesListMap).length > 0) {
                  attributeField.dataTableAttributesDetails = attributeField.DataTableAttributes.map(function(attrId) {
                      return api.allAttributesListMap[attrId];
                  }).filter(function(attr) {
                      return attr !== undefined;
                  })
              }
            }

            //insert additional attributes fields before 'CreatedDate' property in model
            var index = valuesModel.fields.indexOf(utility.filterObject(valuesModel.fields, { field: 'CreatedDate' })[0]);
            valuesModel.fields.splice(index, 0, angular.copy(attributeField));

            if(valuesModel.views.mainList.columns.indexOf(attributeField.field) === -1) {
              var columnsIndex = valuesModel.views.mainList.columns.indexOf('CreatedBy');
              valuesModel.views.mainList.columns.splice(columnsIndex, 0, attributeField.field);
            }
          }
        });
        if (validSourceAttributeSystemName.length) {
          valuesModel.uniqueConstraints.push({ name: 'Constraint 1', fields: validSourceAttributeSystemName })
        }
        deferred.resolve(valuesModel);
      });
      return deferred.promise;
    }

    function createDatasetValuesModelWithAttributes(dataset, baseModelPath) {
      baseModelPath = baseModelPath || 'sellers.datasetValues';
      var deferred = $q.defer();
      var valuesModel = angular.copy(api.getModel(baseModelPath));
      valuesModel.baseModel = api.getModel(baseModelPath);
      var validAttributeSystemNames = [];
      var datasetAttributeIds = dataset.AttributesIds ? dataset.AttributesIds : dataset.Attributes.map(function(attr) {
        return attr.AttributeId;
      });
      var attributeFieldTemplate = {
        field: '', type: 'text', displayLabel: '', visible: true, creatable: true, editable: true, inputType: 'text', reportable: false,
        validation: { isRequired: true, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }
      };
      api.attributes.attributes.methods.getList({ forceFetch: true, isLogRequired: false })
      .then(function (response) {
        var attributes = response.data;
        //Create catalog specific attributes for lookup values model
        angular.forEach(attributes, function (attribute) {
          if(datasetAttributeIds.includes(attribute.Attributeid)) {
            var attributeField = angular.copy(attributeFieldTemplate);
            attributeField.field = attribute.AttributeSystemName;
            attributeField.displayLabel = attribute.AttributeDisplayName
            validAttributeSystemNames.push(attribute.AttributeSystemName)
            attributeField.isDynamicProperty = true;
            attributeField.reportable = true;

            //assign input type based on AttributeTypeName
            if (attribute.AttributeTypeName.toUpperCase() === 'INT') {
              attributeField.inputType = 'number';
            }
            else if (attribute.AttributeTypeName.toUpperCase() === 'NVARCHAR') {
              attributeField.inputType = 'textArea';
            }
            else if (attribute.AttributeTypeName.toUpperCase() === 'DATE') {
              attributeField.inputType = 'date-without-time';
            }
            else if (attribute.AttributeTypeName.toUpperCase() === 'DATETIME') {
              attributeField.inputType = 'date';
            }
            else if (attribute.AttributeTypeName.toUpperCase() === 'BOOL') {
              attributeField.inputType = 'bool-str';
            }
            else if (attribute.AttributeTypeName.toUpperCase() === 'DATEOPTION') {
              attributeField.inputType = 'date-option';
            }
            else if (attribute.AttributeTypeName.toUpperCase() === 'DECIMAL') {
              attributeField.inputType = 'decimal';
              attributeField.validation.pattern = '^[+]?\\d+([.]\\d{0,4})?$';
              attributeField.validation.messages.pattern = 'VALIDATIONS.POSITIVE_DECIMAL_4PONTS';
            }

            //insert additional attributes fields before 'CreatedDate' property in model
            var index = valuesModel.fields.indexOf(utility.filterObject(valuesModel.fields, { field: 'CreatedDate' })[0]);
            valuesModel.fields.splice(index, 0, angular.copy(attributeField));

            if(valuesModel.views.mainList.columns.indexOf(attributeField.field) === -1) {
              var columnsIndex = valuesModel.views.mainList.columns.indexOf('UpdatedBy');
              valuesModel.views.mainList.columns.splice(columnsIndex, 0, attributeField.field);
            }
          }
        });
        if (validAttributeSystemNames.length) {
          valuesModel.uniqueConstraints.push({ name: 'Constraint 1', fields: validAttributeSystemNames })
        }
        deferred.resolve(valuesModel);
      });
      return deferred.promise;
    }

    //A method which gets called when a new catalog added buy user to update _listOfCatalogs
    function updateListOfCatalogs() {
        if(SecurityFactory.isAuthorized({accessPrivileges: CONSTANTS.PRIVILEGES.CATALOGS.LIST.CATALOG_GET_LIST})) {
          return api.catalogs.catalogs.methods.getList({ forceFetch: true, isLogRequired: false }).then(function (response) {
            _listOfCatalogs = utility.filterObject(response.data, { Status: 1 });
            var activeCatalog = getActiveCatalogPersisted();
            if (angular.isDefined(activeCatalog)) {
              activeCatalog = utility.filterObject(_listOfCatalogs, { CatalogCode: activeCatalog.CatalogCode }, true)[0]; // to replace the old version with the values fetched from server
            }
            return setActiveCatalog(activeCatalog);
          })
        } else {
            var privilege = {
                id: 130,
                description: 'Catalog - Get List'
            };
            errorDialog.show('ERRORS.NO_PRIVILEGES', undefined, privilege);
            return setActiveCatalog(undefined);
        }
    }

    function _updatePrivileges(activeCatalog) {
        // updateArticleNavObjectTitle(activeCatalog);
        //update the privileges on active catalog change.
        SecurityFactory.setPrivileges($localStorage.ActiveCatalog.CatalogCode);
        // remove navigation items that are not allowed since privileges now are catalog dependant
        SecurityFactory.removeUnauthorizedNav(($localStorage.ActiveCatalog.IsLinePlan === 1 && $sessionStorage.ActiveCatalogSession.IsLinePlan === 1));
    }


    // function updateArticleNavObjectTitle(activeCatalog) {
    //   var filteredResult = utility.getTreeNodes(msNavigationService.getNavigationObject(), ['articles', 'line plan']);
    //   if(filteredResult != null && filteredResult.length) {
    //     if(activeCatalog.IsLinePlan == 0) {
    //       var linePlanNavObject = utility.filterObject(filteredResult, {title: 'Line Plan'}, true);
    //       if(linePlanNavObject.length) {
    //         linePlanNavObject[0].title = 'Articles';
    //         linePlanNavObject[0].translation = 'ARTICLES.NAV';
    //       }
    //     } else if(activeCatalog.IsLinePlan == 1) {
    //       var articleNavObject = utility.filterObject(filteredResult, {title: 'Articles'}, true);
    //       if(articleNavObject.length) {
    //         articleNavObject[0].title = 'Line Plan';
    //         articleNavObject[0].translation = 'LINE_PLANE.NAV';
    //       }
    //     }
    //   }
    // }

    /**
    * This method will modify article CRDs so that all the article CRDs will be having an extra field call CatalogCRDStatus and if the article missing
    * any CRDs which are available in it's catalog(active catalog) it will add the extra record(CRD) with empty availabilityFrom and availabilityTo
    * @params availableArticleCRDs: all the article CRDs
    * @params catalogCRDs: all the catalog CRDs
    */
    function getAllArticleCRDs(availableArticleCRDs, catalogCRDs) {
      var articleCRDs = angular.copy(availableArticleCRDs);
      angular.forEach(catalogCRDs, function (catalogCRD) {
        var isCatalogCRDExist = false;
        for (var index = 0, len = availableArticleCRDs.length; index < len; index++) {
          //If catalog CRD exist in availableArticleCRDs
          if (catalogCRD[api.catalogs.CRD.idField] === availableArticleCRDs[index][api.articles.crds.idField]) {
            articleCRDs[index].CatalogCRDStatus = catalogCRD.Status;
            isCatalogCRDExist = true;
            break;
          }
        }
        //If catalogCRD does not exist create empty Article CRD with Status 0
        if (!isCatalogCRDExist) {
          articleCRDs.push(createArticleCRDObject(catalogCRD));
        }
      });
      return articleCRDs;
    }

    /**
    * This method will modify article Segmentations so that all the article Segmentations will be having an extra field call CatalogSegmentationStatus
    * and if the article missing any Segmentation which are available in it's catalog(active catalog), it will add the extra record(Segmentation) with status = 0
    * @params availableArticleSegmentations: all the article segmentations
    * @params catalogSegmentations: all the catalog segmentations
    */
    function getAllArticleSegmentations(availableArticleSegmentations, catalogSegmentations) {
      var articleSegmentations = angular.copy(availableArticleSegmentations);
      var articleSegmentationsWithoutRestricted = [];
      var isRoleBasedRestrictedSegmentationsAdded = (angular.isDefined(api.roleBasedRestrictions) && angular.isDefined(api.roleBasedRestrictions.restrictedSegmentationsArray) && api.roleBasedRestrictions.restrictedSegmentationsArray.length > 0) ? true : false;
      var countOfUnrestrictedArticleSegmentations = 0;
      var countOfUnrestrictedCatalogSegmentations = catalogSegmentations.length;
      angular.forEach(catalogSegmentations, function (catalogSegmentation) {
        var isCatalogSegmentationExist = false;
        for (var index = 0, len = availableArticleSegmentations.length; index < len; index++) {
          //If catalog Segmentation exist in availableArticleSegmentations
          if (catalogSegmentation[api.catalogs.segmentations.idField] === availableArticleSegmentations[index][api.articles.segmentation.idField]) {
            articleSegmentations[index].CatalogSegmentationStatus = catalogSegmentation.Status;
            if(!isRoleBasedRestrictedSegmentationsAdded) {
              articleSegmentationsWithoutRestricted.push(articleSegmentations[index]);
              if(articleSegmentations[index].Status === 1) {
                countOfUnrestrictedArticleSegmentations++;
              }
            } else { // if role based segmentations hide if restricted as not viewable
              var segmentation = utility.filterObject(api.roleBasedRestrictions.restrictedSegmentationsArray, { Id: availableArticleSegmentations[index][api.articles.segmentation.idField]}, true)[0];
              if (angular.isDefined(segmentation) && !segmentation.notViewable && !segmentation.notEditable) {
                articleSegmentationsWithoutRestricted.push(articleSegmentations[index]);
                if(articleSegmentations[index].Status === 1) {
                  countOfUnrestrictedArticleSegmentations++;
                }
              } else if(angular.isDefined(segmentation) && segmentation.notViewable && segmentation.notEditable) {
                countOfUnrestrictedCatalogSegmentations--;
              } else if (angular.isDefined(segmentation) && !segmentation.notViewable && segmentation.notEditable) {
                // restricted segmentation is not updatable to disable the delete button adding this property
                articleSegmentations[index]['_nonEditable'] = 1;
                articleSegmentationsWithoutRestricted.push(articleSegmentations[index]);
              } else if (angular.isUndefined(segmentation)) {
                articleSegmentationsWithoutRestricted.push(articleSegmentations[index]);
                if(articleSegmentations[index].Status === 1) {
                  countOfUnrestrictedArticleSegmentations++;
                }
              }
            }
            isCatalogSegmentationExist = true;
            break;
          }
        }
        //If catalog segmentation does not exist create empty article segmentation with Status 0
        if (!isCatalogSegmentationExist) {
          if(catalogSegmentation.Status === 0) { // if parent segmentation is inactive then reduce count
            countOfUnrestrictedCatalogSegmentations--;
          }
          if(!isRoleBasedRestrictedSegmentationsAdded) {
            articleSegmentationsWithoutRestricted.push(createArticleSegmentationObject(catalogSegmentation));
          } else { // dont show segmentations if it is restricted on role
            var segmentation = utility.filterObject(api.roleBasedRestrictions.restrictedSegmentationsArray, { Id: catalogSegmentation[api.catalogs.segmentations.idField]}, true)[0];
            if (angular.isDefined(segmentation) && !segmentation.notViewable) {
              articleSegmentationsWithoutRestricted.push(createArticleSegmentationObject(catalogSegmentation));
            } else {
              articleSegmentationsWithoutRestricted.push(createArticleSegmentationObject(catalogSegmentation));
            }
          }
        }
      });
      // add open segmentation record
      var openObject = {
        CatalogSegmentationStatus: 1,
        CreatedBy: $localStorage.UserId,
        CreatedDate: new Date().toISOString(),
        IsOutOfParentSegmentation: 0,
        Name: CONSTANTS.OPEN_SEGMENTATION,
        PlanningValue: '',
        SegmentationId: 0,
        Status: 0,
        UpdatedBy: $localStorage.UserId,
        UpdatedDate: new Date().toISOString()
      }
      if(countOfUnrestrictedArticleSegmentations === countOfUnrestrictedCatalogSegmentations) {
        openObject.Status = 1;
      }
      articleSegmentationsWithoutRestricted.push(openObject);
      return articleSegmentationsWithoutRestricted;
    }

    /**
    * will flatten sourceData and map them to fields
    * @param {array} sourceData: source object (response of get articles sizes)
    * @param {string} nestedArrayName: name of the nested array in sourceData
    * @param {array} fields: model fields
    * @param {object} indexedArticles map of key value pair key being articleModel.lookupDisplayField (ArticleNumber) with it respective record as value
    * @param {object} articleModel article model
    * @return: List of transformed objects
    */
    function transform(sourceData, nestedArrayName) {
      var result = [];
      angular.forEach(sourceData, function (obj) {
          angular.forEach(obj[nestedArrayName], function (nestedObj) {
            var record = {
              ArticleId       : obj.Id,
              ArticleNumber   : obj.ArticleNumber,
              ModelNumber     : obj.ModelNumber,
              ArticleName     : obj.ArticleName,
              Locked          : obj.Locked,
              Id              : nestedObj.Id,
              SizeIndex       : nestedObj.SizeIndex,
              NewSizeIndex    : nestedObj.NewSizeIndex,
              SizeName        : nestedObj.SizeName,
              NewSizeName     : nestedObj.NewSizeName,
              Upc             : nestedObj.Upc,
              Status          : nestedObj.Status,
              SortOrder       : nestedObj.SortOrder,
              CreatedDate     : nestedObj.CreatedDate,
              UpdatedDate     : nestedObj.UpdatedDate,
              Created_By      : nestedObj.Created_By,
              Updated_By      : nestedObj.Updated_By
            };
            result.push(record);
          });
      });
      return result;
    }

    /**
    * @description
    * transform response object and create one record per articles (transform horizontally)
    *
    * @param {array} sourceData source object (response of get articles Prices)
    * @param {string} nestedArrayName name of the nested array in sourceData
    * @param {array} fields model fields
    * @return {array} List of transformed objects
    */
    function transformPricesResponse(sourceData, nestedArrayName, fields) {
      var result = [];

      //Create blank record
      var sameLevelFields = [];
      var nestedFields = {};
      var flattenedRecord = {};
      var modelNumberMap = {};

      // Define the basic structure of a blank record with fields and mappings
      angular.forEach(fields, function (field) {
        if (angular.isDefined(field.map)) {
          if (field.map.indexOf('.') === -1) {
            sameLevelFields.push(field);
            flattenedRecord[field.field] = undefined;
          } else {
            nestedFields[field.catalogEntityId] = field.field;
            flattenedRecord[field.field] = 0.0;
          }
        }
      });

      // Transform each record in sourceData
      angular.forEach(sourceData, function (record) {
        //For child catalog record[nestedArrayName] is defined only for assorted articles, hence we will display only assorted articles those return from server.
        // And ignoring the unassorted articles from the articleRelatedData cache for which the record[nestedArrayName] is undefined
        if (record[nestedArrayName] && (getActiveCatalog().DataSourceTypeId !== 3 || record.Status === 1)) {
          var newRecord = angular.copy(flattenedRecord);

          // Populate fields from the same level
          angular.forEach(sameLevelFields, function (field) {
            if (record[field.map]) {
              newRecord[field.field] = record[field.map];
            } else {
              newRecord[field.field] = record[nestedArrayName]._outerData[field.map];
            }
          });

          // Populate nested data and calculate the last updated date
          angular.forEach(record[nestedArrayName]._nestedData, function (nestedRecord) {
            newRecord[nestedFields[nestedRecord.PriceGroupId]] = nestedRecord.Price;
            var newDate = new Date(nestedRecord.UpdatedDate);
            if (angular.isUndefined(newRecord.LastUpdatedOn) || newDate > newRecord.LastUpdatedOn) {
              newRecord.LastUpdatedOn = newDate;
            }
          });

          newRecord.isEditDisable = 0; // Default to editable
          if (newRecord.Locked && getActiveCatalog().ArticleLocking === 1) {
            newRecord.isEditDisable = 1;
          } else if (getActiveCatalog().IsPriceByStyleApply === 1) {
            if (!newRecord.ModelNumber) {
              newRecord.isEditDisable = 1;
            } else {
              if (modelNumberMap[newRecord.ModelNumber] === undefined) {
                var modelNumberArticleList = utility.filterObject(sourceData, { ModelNumber: newRecord.ModelNumber, Locked: 1 }, true);
                modelNumberMap[newRecord.ModelNumber] = modelNumberArticleList.length && getActiveCatalog().ArticleLocking === 1 ? 1 : 0;
              }
              newRecord.isEditDisable = modelNumberMap[newRecord.ModelNumber];
            }
          }

          result.push(newRecord);
        }
      });
      return result;
    }

    /**
    * @description
    * transform response object and create one record per articles (transform horizontally)
    *
    * @param {array}sourceData: source object (response of get articles CRDs)
    * @param {string} nestedArrayName: name of the nested array in sourceData
    * @param {array} fields: model fields
    * @return {array}: List of transformed objects
    */
    function transformCRDsResponse(sourceData, nestedArrayName, fields) {
      var result = [];

      //Create blank record
      var sameLevelFields = [];
      var nestedFields = {};
      var flattenedRecord = {};
      var catalogCRDMap = {}
      //get delivery dates list for active catalog
      var activeCatalogCRDList = getActiveCatalogDetails()['CatalogCRDList'];
      if (angular.isDefined(activeCatalogCRDList)) {
        angular.forEach(activeCatalogCRDList, function (activeCatalogCRD) {
          var formatedCRD = utility.formatDate(activeCatalogCRD.CustomerRequiredDate, CONSTANTS.CRD_DATE_FORMAT, 'UTC')
          if (angular.isDefined(formatedCRD)) {
            catalogCRDMap[formatedCRD] = activeCatalogCRD
          }
        })
      }

      angular.forEach(fields, function (field) {
        if (angular.isDefined(field.map)) {
          if (field.map.indexOf('.') === -1) {
            sameLevelFields.push(field);
            flattenedRecord[field.field] = undefined;
          } else {
            nestedFields[field.catalogEntityId] = field.field;
            flattenedRecord[field.field] = 'No';
            //add property description and its value so as to display description in update bulk dialog
            flattenedRecord[field.field + 'Description'] = catalogCRDMap[field.importField] ? catalogCRDMap[field.importField].Description : '';
          }
        }
      });

      angular.forEach(sourceData, function (record) {
        //For child catalog record[nestedArrayName] is defined only for assorted articles, hence we will display only assorted articles those return from server.
        // And ignoring the unassorted articles from the articleRelatedData cache for which the record[nestedArrayName] is undefined
        if (record[nestedArrayName]) {
          var newRecord = angular.copy(flattenedRecord);

          angular.forEach(sameLevelFields, function (field) {
            if (record[field.map]) {
              newRecord[field.field] = record[field.map];
            } else {
              newRecord[field.field] = record[nestedArrayName]._outerData[field.map];
            }
          });

          angular.forEach(record[nestedArrayName]._nestedData, function (nestedRecord) {
            newRecord[nestedFields[nestedRecord.CrdId]] = "Yes";

          });

          result.push(newRecord);
        }
      });
      return result;
    }

    /**
    * @description
    * transform response object and create one record per articles/customers (transform horizontally)
    *
    * @param {array}sourceData: source object  (response of get articles Segmentation)
    * @param {string} nestedArrayName: name of the nested array in sourceData
    * @param {array} fields: model fields
    * @return {array}: List of transformed objects
    */
    function transformSegmentationsResponse(sourceData, nestedArrayName, fields) {
      var result = [];

      //Create blank record
      var sameLevelFields = [];
      var nestedFields = {};
      var flattenedRecord = {};
      var segmentationsCount = 0;
      var assingedSegmentationCount = 0;
      var segmentationIdArray = [];
      // When planning values are enabled, an unassigned segmentation has no planning value, so its grid cell
      // must be blank. A literal 'No' would be indistinguishable from a segmentation assigned the configured
      // planning value 'No'. Without planning, the grid is a Yes/No membership grid where 'No' is the correct value.
      var unassignedSegmentationValue = getActiveCatalog().SegmentationPlanningEnable === 1 ? '' : 'No';

      angular.forEach(fields, function (field) {
        if (angular.isDefined(field.map)) {
          if (field.map.indexOf('.') === -1) {
            sameLevelFields.push(field);
            flattenedRecord[field.field] = undefined;
          } else {
            nestedFields[field.catalogEntityId] = field.field;
            flattenedRecord[field.field] = unassignedSegmentationValue;
            segmentationIdArray.push(field.catalogEntityId);
            segmentationsCount++;
          }
        }
      });

      angular.forEach(sourceData, function (record) {
        //For child catalog record[nestedArrayName] is defined only for assorted articles, hence we will display only assorted articles those return from server.
        // And ignoring the unassorted articles from the articleRelatedData cache for which the record[nestedArrayName] is undefined
        if (record[nestedArrayName] && (getActiveCatalog().DataSourceTypeId !== 3 || record.Status === 1)) {
          var newRecord = angular.copy(flattenedRecord);
          var outOfParentSegmentationsArray = [];
          angular.forEach(sameLevelFields, function (field) {
            if (record[field.map]) {
              newRecord[field.field] = record[field.map];
            } else {
              newRecord[field.field] = record[nestedArrayName]._outerData[field.map];
            }
          });

          if (getActiveCatalog().SegmentationPlanningEnable === 1) {
            angular.forEach(record[nestedArrayName]._nestedData, function (Segmentation) {
              if(segmentationIdArray.includes(Segmentation.Id)) {
                if (Segmentation.PlanningValue) {
                  // render the planning value returned by the API verbatim
                  newRecord[nestedFields[Segmentation.Id]] = Segmentation.PlanningValue;
                  assingedSegmentationCount++;
                } else {
                  newRecord[nestedFields[Segmentation.Id]] = 'Yes';
                  assingedSegmentationCount++;
                }
                newRecord['IsOutOfParentSegmentation'] = Segmentation['IsOutOfParentSegmentation'];
                if(Segmentation['IsOutOfParentSegmentation'] === 1) {
                  outOfParentSegmentationsArray.push(nestedFields[Segmentation.Id]);
                }
              }
            });
          } else {
              angular.forEach(record[nestedArrayName]._nestedData, function (Segmentation) {
                if(segmentationIdArray.includes(Segmentation.Id)) {
                  newRecord[nestedFields[Segmentation.Id]] = 'Yes';
                  assingedSegmentationCount++;
                  newRecord['IsOutOfParentSegmentation'] = Segmentation['IsOutOfParentSegmentation'];
                  if(Segmentation['IsOutOfParentSegmentation'] === 1) {
                    outOfParentSegmentationsArray.push(nestedFields[Segmentation.Id]);
                  }
                }
              });
          }
          newRecord['outOfParentSegmentationsArray'] = outOfParentSegmentationsArray;
          // make virtual segmentation field
          newRecord[CONSTANTS.OPEN_SEGMENTATION] = segmentationsCount === assingedSegmentationCount ? 1 : 0;
          assingedSegmentationCount = 0;
          result.push(newRecord);
        }
      });
      return result;
    }

    /**
    * @description
    * transform response object and create one record per articles/customers (transform horizontally)
    *
    * @param {array}sourceData: source object  (response of get articles Segmentation)
    * @param {array} fields: model fields
    * @param {array} nestedArray: nestedarray names
    * @return {array}: List of transformed objects
    */
    function transformArticlesResponse(sourceData, fields) {
      var result = [];

      //Create blank record
      var sameLevelFields = [];
      var nestedFields = {};
      var flattenedRecord = {};
      var nestedArrayNamesList = ['Prices', 'Segmentations', 'StatesTimestamp'];
      var segmentationPlanningEnable = getActiveCatalog().SegmentationPlanningEnable;

      angular.forEach(fields, function (field) {
        if (angular.isDefined(field.map)) {
          if (field.map.indexOf('.') === -1) {
            sameLevelFields.push(field);
            flattenedRecord[field.field] = undefined;
          } else {
            //Since more than one nested array present catalogEntityId is repeated so concatinating with nestedarrayname to avoid overriding restedfields
            nestedFields[field.nestedArrayName + field.catalogEntityId] = field.field;
            if(field.nestedArrayName === 'Prices' && api.enablePricesSegmentationsInArticlesList) {
              flattenedRecord[field.field] = 0.0;
            } else if(field.nestedArrayName === 'Segmentations' && api.enablePricesSegmentationsInArticlesList) {
              // blank for unassigned when planning values are enabled (see transformSegmentationsResponse); else 'No'
              flattenedRecord[field.field] = segmentationPlanningEnable === 1 ? '' : 'No';
            } else if(field.nestedArrayName === 'StatesTimestamp') {
              flattenedRecord[field.field] = '';
            }
          }
        }
      });

      angular.forEach(sourceData, function (record) {
        if((angular.isUndefined(record[nestedArrayNamesList[0]]) && angular.isUndefined(record[nestedArrayNamesList[1]]) && angular.isUndefined(record[nestedArrayNamesList[2]]))||
          (angular.isDefined(record[nestedArrayNamesList[0]]) && record[nestedArrayNamesList[0]]._nestedData.length <= 0)
          && (angular.isDefined(record[nestedArrayNamesList[1]] && record[nestedArrayNamesList[1]]._nestedData.length <= 0))
          && (angular.isDefined(record[nestedArrayNamesList[2]]) && utility.isObjectEmpty(record[nestedArrayNamesList[2]]))) {
          result.push(record);
        } else if (angular.isDefined(record[nestedArrayNamesList[0]]) || angular.isDefined(record[nestedArrayNamesList[1]]) || angular.isDefined(record[nestedArrayNamesList[2]])) {
          var newRecord = angular.copy(flattenedRecord);
          angular.forEach(sameLevelFields, function (field) {
            if (angular.isDefined(record[field.map])) {
              newRecord[field.field] = record[field.map];
            }
          });

          // add parent overridable attrbute values if any presnt
          for(var key in record) {
            if(key.startsWith('#')) {
              newRecord[key] = record[key];
            }
          }

          if(angular.isDefined(record[nestedArrayNamesList[0]]) && record[nestedArrayNamesList[0]]._nestedData.length > 0 && nestedArrayNamesList[0] === 'Prices' && api.enablePricesSegmentationsInArticlesList) {
            var pricesNestedArrayList = record['Prices']._nestedData;
            angular.forEach(pricesNestedArrayList, function (nestedRecord) {
              //nestedfields are a combination of nested array name and Id
              newRecord[nestedFields['Prices'+nestedRecord.PriceGroupId]] = nestedRecord.Price;

              //Set the latest Updated Date
              var newDate = new Date(nestedRecord.UpdatedDate);
              if (angular.isUndefined(newRecord.LastUpdatedOn) || newDate > newRecord.LastUpdatedOn) {
                newRecord.LastUpdatedOn = newDate;
              }
            });
          }
          if(angular.isDefined(record[nestedArrayNamesList[1]]) && record[nestedArrayNamesList[1]]._nestedData.length > 0 && nestedArrayNamesList[1] === 'Segmentations' && api.enablePricesSegmentationsInArticlesList) {
            var segmentationsNestedArrayList = record['Segmentations']._nestedData;
            if (segmentationPlanningEnable === 1) {
              //nestedfields are a combination of nested array name and Id
              angular.forEach(segmentationsNestedArrayList, function (Segmentation) {
                if (angular.isUndefined(Segmentation.PlanningValue)) {
                  newRecord[nestedFields['Segmentations'+Segmentation.Id]] = 'Yes';
                } else {
                  newRecord[nestedFields['Segmentations'+Segmentation.Id]] = Segmentation.PlanningValue;
                }
              });
            } else {
              angular.forEach(segmentationsNestedArrayList, function (Segmentation) {
                newRecord[nestedFields['Segmentations'+Segmentation.Id]] = 'Yes';
              });
            }
          }
          if(angular.isDefined(record[nestedArrayNamesList[2]]) && !utility.isObjectEmpty(record[nestedArrayNamesList[2]]) && nestedArrayNamesList[2] === 'StatesTimestamp') {
            var stateTimestamps = record['StatesTimestamp'];
            // nestedfields are a combination of nested array name and Id
            for(var key in stateTimestamps) {
              newRecord[nestedFields['StatesTimestamp'+key]] = stateTimestamps[key];
            }
          }
          result.push(newRecord);
        }
      });
      return result;
    }

    /**
    * @description
    * transform response object and create one record per articles (transform horizontally)
    *
    * @param {array} sourceData: source object  (response of get articles Status)
    * @param {array} fields: model fields
    * @param {array} nestedArrayName: nestedarray name
    * @return {array}: List of transformed objects
    */
    function transformArticleStatusReportResponse(sourceData, nestedArrayName, fields) {
      var result = [];
      var sameLevelFields = [];
      var nestedFields = {};
      var flattenedRecord = {};

      angular.forEach(fields, function (field) {
        if (angular.isDefined(field.map)) {
          if (field.map.indexOf('.') === -1) {
            sameLevelFields.push(field);
            flattenedRecord[field.field] = undefined;
          } else {
            nestedFields[field.catalogEntityId] = field.field;
            flattenedRecord[field.field] = 0;
          }
        }
      });

      angular.forEach(sourceData, function (record) {
        if (record[nestedArrayName]) {
          var newRecord = angular.copy(flattenedRecord);

          angular.forEach(sameLevelFields, function (field) {
            if (record[field.map]) {
              newRecord[field.field] = record[field.map];
            } else {
              newRecord[field.field] = record[nestedArrayName][field.map];
            }
          });

          angular.forEach(record[nestedArrayName], function (nestedRecord) {
            newRecord[nestedFields[nestedRecord.CatalogId]] = nestedRecord.ArticleStatus;
          });

          result.push(newRecord);
        }
      });
      return result;
    }

    /**
    * @description
    *  Creates Seller Models model dynamically based on active catalog attributes
    */
   function createSellerModelAttributesModel(model) {
    var deferred = $q.defer();
    var modelPromises = {};
    var activeCatalogCode = getActiveCatalog().CatalogCode;
    var maxDefaultColumnCounter = 4;
    var activeCatalogModelLevelAttributes = utility.filterObject(getActiveCatalogDetails().ModelLevelAttributeList, {Status: 1});

    var pristineArticleModel = angular.copy(model);
    pristineArticleModel.baseModel = api.getModel(model.modelPath);

    if (angular.isUndefined(dynamicModel[model.modelPath]) || angular.isUndefined(dynamicModel[model.modelPath][activeCatalogCode]) || model.isDirty ) {
      dynamicModel[model.modelPath] = {};
      dynamicModel[model.modelPath][activeCatalogCode] = pristineArticleModel;
      maxDefaultColumnCounter = 4;
    }

    var dynamicArticleModel = dynamicModel[model.modelPath][activeCatalogCode];
    dynamicArticleModel.fields = pristineArticleModel.fields;
    dynamicArticleModel.views.mainList.columns = pristineArticleModel.views.mainList.columns;

    // if size scale by model is enabled show set sizes actions
    if (getIsSizeScaleByStyle()) {
        //item action
        var setSizesAction = utility.filterObject(dynamicArticleModel.views.mainList.itemActions, { id: 'SetSizes' }, true)[0];
        setSizesAction.visible = true;
        //list action
        setSizesAction = utility.filterObject(dynamicArticleModel.views.mainList.listActions, { id: 'SetSizes' }, true)[0];
        setSizesAction.visible = true;

        // make SizeScale field visible
        var sizeScaleField = utility.filterObject(dynamicArticleModel.fields, { field: 'SizeScale' }, true)[0];
        sizeScaleField.visible = true;

        var sizeScaleIdField = utility.filterObject(dynamicArticleModel.fields, { field: 'SizeScaleId', inputType: 'number' }, true)[0];
        sizeScaleIdField.visible = true;

        var masterSizeScaleIdField = utility.filterObject(dynamicArticleModel.fields, { field: 'MasterSizeScaleId' }, true)[0];
        masterSizeScaleIdField.visible = true;

        var masterSizeScaleField = utility.filterObject(dynamicArticleModel.fields, { field: 'MasterSizeScale' }, true)[0];
        masterSizeScaleField.visible = true;
    }

    var attributeFieldTemplate = {
      field: '', type: 'text', displayLabel: 'ARTICLES.FIELDS.ID', visible: true, creatable: false, editable: false, showInEdit: false, inputType: 'text', reportable: true, values: '',
      validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }
    };

    var attributesDataPromise = api.catalogs.attributes.methods.getList({ forceFetch: true, isLogRequired: false }, activeCatalogCode);
    modelPromises[api.catalogs.attributes.modelPath] = attributesDataPromise;


    attributesDataPromise.then(function (response) {
      response.data.AttributeList = $filter('orderBy')(response.data.AttributeList, 'SortOrder');
      angular.forEach(response.data.AttributeList, function (attribute) {
        var modelLevelAttributeIndex = activeCatalogModelLevelAttributes.indexOf(utility.filterObject(activeCatalogModelLevelAttributes, { AttributeId: attribute.Attributeid, Status: 1, IsSeasonlessModelAttribute: 1 }, true)[0]);
        // create only model level attributes as fields
        if((modelLevelAttributeIndex !== -1)) {
          var attributeField = angular.copy(attributeFieldTemplate);
          attributeField.isDynamicProperty = true;
          attributeField.isAttribute = true;
          attributeField.field = attribute.AttributeSystemName;
          attributeField.map = attribute.AttributeSystemName;
          attributeField.displayLabel = attribute.AttributeDisplayName;
          attributeField.visible = (attribute.Visible == true);
          attributeField.showInEdit = (attribute.ShowInEdit == true);
          attributeField.supportFilterLookup = (attribute.SupportFilterLookup == true);
          attributeField.initialValue = attribute.InitialValueAttribute;

          attributeField.validation.isRequired = attribute.IsRequired;
          attributeField.validation.minLen = attribute.IsRequired ? 1 : 0;
          attributeField.IsSeasonless = attribute.IsSeasonless;
          attributeField.IsSeasonlessModelAttribute = attribute.IsSeasonlessModelAttribute;// seasonless model level attributes
          attributeField.Overridable = attribute.Overridable;
          attributeField.DefaultValue = attribute.DefaultValue;

          // for attributes other than calc type if validation expression is a valid JSON we will add to tx-pattern else we will add it to pattern
          if(attribute.AttributeTypeName.toUpperCase() !== 'CALC') {
            if(!utility.isValidJSON(attribute.ValidationExpression)) {
              attributeField.validation.pattern = attribute.ValidationExpression != '{}' ? attribute.ValidationExpression : '';
              attributeField.validation['tx-pattern'] = false;
            } else {
              attributeField.validation.pattern = '';
              attributeField.validation['tx-pattern'] = attribute.ValidationExpression != null && attribute.ValidationExpression !== '' && attribute.ValidationExpression != '{}' ?
              attribute.ValidationExpression : false;
            }
          }
          attributeField.validation.messages.pattern = (attribute.ValidationMessage !== '') ? attribute.ValidationMessage : 'VALIDATIONS.PATTERN';;

          attributeField.reportable = false;
          attributeField.creatable = attribute.Creatable;
          attributeField.editable = attribute.Editable;
          attributeField.isBulkEditable  = attribute.Editable;
          attributeField.isModelLevelAttribute = true;

          //set data type to list for attributes having values added in attributeVettingList
          if (attribute.AttributeTypeName.toUpperCase() !== 'CALC' && attribute.AllowedValues && attribute.AllowedValues !== null && (angular.isArray(attribute.AllowedValues) && attribute.AllowedValues.length)) {
            // this attribute will be displyed with parent model number dropdown
            if(attributeField.field === 'parent_model_type') {
              attributeField.inputType = 'parent-model-type';
              attributeField.values = attribute.AllowedValues
              .map(function(value) {
                return value.trim();
              })
              .sort(function(a, b) {
                return a.toLowerCase().localeCompare(b.toLowerCase());
              });
            } else {
              attributeField.inputType = 'list';
              // for multi value attributes with vetting list inputtype will be multi-value
              if (attribute.AttributeTypeName.toUpperCase() === 'MULTIVALUE') {
                attributeField.inputType = 'multi-value';
                attributeField.tagSeparator = '|';
                if(!attributeField.editable) {
                  attributeField.nonRemovableChips = true;
                }
              }
              if (attribute.AttributeTypeName.toUpperCase() === 'INT' || attribute.AttributeTypeName.toUpperCase() === 'DECIMAL') {
                attributeField.type = 'int';
              } else {
                attributeField.type = 'text';
              }
              if (attribute.AttributeTypeName.toUpperCase() === 'DECIMAL') {
                attributeField.validation.pattern = '^[+]?\\d+([.]\\d{0,4})?$';
                attributeField.validation.messages.pattern = 'VALIDATIONS.POSITIVE_DECIMAL_4PONTS';
              }
            }
          }
          else {
            if (attribute.AttributeTypeName.toUpperCase() === 'INT') {
              attributeField.inputType = 'number';
            }
            else if (attribute.AttributeTypeName.toUpperCase() === 'NVARCHAR') {
              attributeField.inputType = 'textArea';
            }
            else if (attribute.AttributeTypeName.toUpperCase() === 'MULTIVALUE') {
              attributeField.inputType = 'tags';
              attributeField.tagSeparator = '|';
              attributeField.inputSubType = 'multi-value';
            }
            else if (attribute.AttributeTypeName.toUpperCase() === 'DATE') {
              attributeField.inputType = 'date-without-time';
            }
            else if (attribute.AttributeTypeName.toUpperCase() === 'DATETIME') {
              attributeField.inputType = 'date';
            }
            else if (attribute.AttributeTypeName.toUpperCase() === 'BOOL') {
              attributeField.inputType = 'bool-str';
            }
            else if(attribute.AttributeTypeName.toUpperCase() === 'CALC') {
              attributeField.creatable = false;
              attributeField.editable = false;
              attributeField.isBulkEditable = false;
              attributeField.inputType = 'calculated';
              attributeField.validation.pattern = '';
              attributeField.calculatedExpression = attribute.ValidationExpression;
              //Adding try catch if JSON parse fails
              try {
                attributeField.parsedExpressionObject = JSON.parse(attribute.ValidationExpression);
                if(angular.isDefined(attributeField.parsedExpressionObject.calculatedRegexExpression)) {
                  var calculatedRegexExpression = attributeField.parsedExpressionObject.calculatedRegexExpression;
                  if(angular.isDefined(calculatedRegexExpression.fieldRegex) && calculatedRegexExpression.fieldRegex.length > 0) {
                    angular.forEach(calculatedRegexExpression.fieldRegex, function(fieldRegex) {
                      var convertedRegEx = convertStringToRegex(fieldRegex.regEx);
                      if(convertedRegEx != null) {
                          fieldRegex.regEx = convertedRegEx;
                      } else {
                          console.warn("invalid Regex for : " + fieldRegex.field);
                      }
                    })
                  }
                  attributeField.calcType = calculatedRegexExpression.type;
                }
              } catch(error) {
                console.warn(attribute.AttributeDisplayName + " - Attribute Validation Expression : Invalid JSON format");
              }
            }
            else if (attribute.AttributeTypeName.toUpperCase() === 'DATEOPTION') {
              attributeField.inputType = 'date-option';
            }
            else if (attribute.AttributeTypeName.toUpperCase() === 'DECIMAL') {
              attributeField.inputType = 'decimal';
              attributeField.validation.pattern = '^[+]?\\d+([.]\\d{0,4})?$';
              attributeField.validation.messages.pattern = 'VALIDATIONS.POSITIVE_DECIMAL_4PONTS';
            }
            else if (attribute.AttributeTypeName.toUpperCase() === 'ARTICLENUMBER') {
              attributeField.inputType = 'articlenumber';
              attributeField.lookupSource = 'catalogs.articles';
              attributeField.lookupFilter = {'Status': 1};
            }
            else if (attribute.AttributeTypeName.toUpperCase() === 'LINKEDCATALOGARTICLENUMBER') {
              attributeField.inputType = 'linkedcatalogarticlenumber';
              attributeField.lookupSource = 'lists.linkedCatalogArticles';
              attributeField.lookupFilter = {'Status': 1};
            }
            // seller mdoels color palette will be a text box not dropdown
            else if (attribute.AttributeTypeName.toUpperCase() === 'COLORPALETTE') {
              attributeField.inputType = 'text';
            }
            else if (attribute.AttributeTypeName.toUpperCase() === 'MODELNUMBER') {
              attributeField.inputType = 'modelnumber';
              attributeField.lookupSource = 'lists.sellerModelsWithoutAttributes';
            }
            else if (attribute.AttributeTypeName.toUpperCase() === 'LOOKUPTABLE') {
              attributeField.inputType = 'lookup-table';
            }
            else if (attribute.AttributeTypeName.toUpperCase() === 'DATASET') {
              attributeField.inputType = 'dataset';
              attributeField.datasetId = attribute.DatasetId;
            }
            else if (attribute.AttributeTypeName.toUpperCase() === 'DATATABLE') {
              attributeField.inputType = 'datatable';
              attributeField.DataTableAttributes = attribute.DataTableAttributes
              if(attribute.AllowedValuesV2 && attribute.AllowedValuesV2.length) {
                try {
                  attributeField.valuesV2 = JSON.parse(attribute.AllowedValuesV2)
                } catch(error) {
                  console.warn(attribute.AttributeDisplayName + " - Allowed Values Version 2 : Invalid JSON format");
                }
              }
              if(attribute.CriteriaV2 && attribute.CriteriaV2.length) {
                try {
                  attributeField.criteriaV2 = JSON.parse(attribute.CriteriaV2)
                } catch(error) {
                  console.warn(attribute.AttributeDisplayName + " - Criteria Version 2 : Invalid JSON format");
                }
              }
              if(api.allAttributesListMap && Object.keys(api.allAttributesListMap).length > 0) {
                  attributeField.dataTableAttributesDetails = attributeField.DataTableAttributes.map(function(attrId) {
                      return api.allAttributesListMap[attrId];
                  }).filter(function(attr) {
                      return attr !== undefined;
                  })
              }
            }
          }

          // make self attribute creatable or editable if they are required attributes or creatable and editable respectively
          // and if source is parent disable create and edit
          if (attribute.AttributeSource.toUpperCase() === 'SELF' && attribute.AttributeTypeName.toUpperCase() !== 'CALC') {
            if (attribute.Editable || attribute.IsRequired) {
              attributeField.editable = true;
            }
            if (attribute.Creatable || attribute.IsRequired) {
              attributeField.creatable = true;
            }
          } else {
            attributeField.editable = false;
            attributeField.creatable = false;
          }

          //To avoid creating dulpicate attributes when calling articles details page from different module.
          var isAttributeExists = false;
          for( var i = 0; i < dynamicArticleModel.fields.length; i++) {
            if(dynamicArticleModel.fields[i].field === attributeField.field) {
              isAttributeExists = true;
              break;
            }
          }

          if(!isAttributeExists) {
            dynamicArticleModel.fields.push(attributeField);
          }

          if(maxDefaultColumnCounter > 0) {
            var columnList = dynamicArticleModel.views.mainList.columns;
            var existInCoulmList = false;
            if(columnList.length) {
              for (var i = 0; i < columnList.length ; i++) {
                if(columnList[i].indexOf(attributeField.field) !== -1) {
                  existInCoulmList = true;
                  break;
                }
              }
            }

            if(!existInCoulmList) {
              dynamicArticleModel.views.mainList.columns.push(angular.copy(attributeField.field));
              maxDefaultColumnCounter -= 1;
            }
          }
          //adding up to 4 attributes to default articles view default column list (views.mainList.columns)
          if (attribute.VisibleInListByDefault) {
            if(dynamicArticleModel.views.mainList.columns.indexOf(attributeField.field) === -1) {
              dynamicArticleModel.views.mainList.columns.push(attributeField.field);
            }
          }
        }
      });
    });

    // create dataset attribute columns
    var datasetDetailsCache = {};
    if(activeCatalogModelLevelAttributes && SecurityFactory.isAuthorized({accessPrivileges: CONSTANTS.PRIVILEGES.SELLERS.DETAIL.GET_DATASET_DEFINITIONS_DETAILS})) {
      var datasetAttributes = utility.filterObject(activeCatalogModelLevelAttributes, {AttributeTypeId: 16}, true)
      angular.forEach(datasetAttributes, function(dtAttribute) {
          var datasetPromiseKey = 'dataset_' + dtAttribute.DatasetId;
          if (datasetDetailsCache[dtAttribute.DatasetId]) {
            modelPromises[datasetPromiseKey] = datasetDetailsCache[dtAttribute.DatasetId];
          } else {
            var datasetDetailsPromise = api.sellers.datasets.methods.getDetails(true, dtAttribute.DatasetId, getActiveCatalog().AccountId);
            datasetDetailsCache[dtAttribute.DatasetId] = datasetDetailsPromise;
            modelPromises[datasetPromiseKey] = datasetDetailsPromise;
          }
          // fetch the dataset attributes and create the columns
          datasetDetailsCache[dtAttribute.DatasetId].then(function (response) {
            var datasetAttributes = response.data.Attributes;
            if(datasetAttributes.length) {
              angular.forEach(datasetAttributes, function (datasetAttr) {
                var datasetAttributeField = angular.copy(attributeFieldTemplate);
                datasetAttributeField.isDynamicProperty = true;
                datasetAttributeField.isAttribute = true;
                datasetAttributeField.field = dtAttribute.AttributeSystemName + '-' + datasetAttr.AttributeSystemName;
                datasetAttributeField.map = dtAttribute.AttributeSystemName + '-' + datasetAttr.AttributeSystemName;
                datasetAttributeField.displayLabel = dtAttribute.AttributeDisplayName + '-' + datasetAttr.AttributeDisplayName;
                datasetAttributeField.visible = true;
                datasetAttributeField.supportFilterLookup = (dtAttribute.SupportFilterLookup == true);
                var index = dynamicArticleModel.fields.indexOf(utility.filterObject(dynamicArticleModel.fields, { field: 'CreatedDate' }, true)[0]);
                dynamicArticleModel.fields.splice(index, 0, angular.copy(datasetAttributeField));
              })
            }
          })
      })
    }

    $q.all(modelPromises).then(function () {
      applyRoleBasedAttributeRestrictions(dynamicArticleModel);
      deferred.resolve(dynamicArticleModel);
      datasetDetailsCache = {};
    });

    return deferred.promise;
  }

    /**
    * @description
    *  Creates catalog Models model dynamically based on active catalog model level attributes
    */
   function createCatalogModelsModel(model) {
    var deferred = $q.defer();
    var modelPromises = {};
    var activeCatalogCode = getActiveCatalog().CatalogCode;
    var catalogAssignedModelLevelAttributes = $filter('orderBy')(utility.filterObject(getActiveCatalogDetails().ModelLevelAttributeList, {Status: 1}), 'SortOrder');
    var maxDefaultColumnCounter = 4;

    var pristineArticleModel = angular.copy(model);
    pristineArticleModel.baseModel = api.getModel(model.modelPath);

    if (angular.isUndefined(dynamicModel[model.modelPath]) || angular.isUndefined(dynamicModel[model.modelPath][activeCatalogCode]) || model.isDirty ) {
      dynamicModel[model.modelPath] = {};
      dynamicModel[model.modelPath][activeCatalogCode] = pristineArticleModel;
      maxDefaultColumnCounter = 4;
    }

    var dynamicArticleModel = dynamicModel[model.modelPath][activeCatalogCode];
    dynamicArticleModel.fields = pristineArticleModel.fields;
    dynamicArticleModel.views.mainList.columns = pristineArticleModel.views.mainList.columns;

    var attributeFieldTemplate = {
      field: '', type: 'text', displayLabel: 'ARTICLES.FIELDS.ID', visible: true, creatable: false, editable: false, showInEdit: false, inputType: 'text', reportable: true, values: '',
      validation: { isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' } }
    };

    // if size scale by model is enabled show set sizes actions
    if (getIsSizeScaleByStyle()) {
      //item action
      var setSizesAction = utility.filterObject(dynamicArticleModel.views.mainList.itemActions, { id: 'SetSizes' }, true)[0];
      setSizesAction.visible = true;
      //list action
      setSizesAction = utility.filterObject(dynamicArticleModel.views.mainList.listActions, { id: 'SetSizes' }, true)[0];
      setSizesAction.visible = true;

      // make SizeScale field visible
      var sizeScaleField = utility.filterObject(dynamicArticleModel.fields, { field: 'SizeScale' }, true)[0];
      sizeScaleField.visible = true;

      var sizeScaleIdField = utility.filterObject(dynamicArticleModel.fields, { field: 'SizeScaleId', inputType: 'number' }, true)[0];
      sizeScaleIdField.visible = true;

      var masterSizeScaleIdField = utility.filterObject(dynamicArticleModel.fields, { field: 'MasterSizeScaleId'}, true)[0];
      masterSizeScaleIdField.visible = true;

      var masterSizeScaleField = utility.filterObject(dynamicArticleModel.fields, { field: 'MasterSizeScale'}, true)[0];
      masterSizeScaleField.visible = true;
    }

    if (getActiveCatalog().DataSourceTypeId === 3) { // if active catalog is inherited catalog
      dynamicArticleModel.views.mainList.fabAction.visible = false;
      dynamicArticleModel.views.mainDetails.fab.visible = false;
    }

    // model level attributes list is having model level attributes and the seasonless model level attributes, so for getting the properties of these attributes calling the main attributes getlist
    var attributesDataPromise = api.attributes.attributes.methods.getList({ forceFetch: true, isLogRequired: false });
    modelPromises[api.attributes.attributes.modelPath] = attributesDataPromise;

    attributesDataPromise.then(function (response) {
      var catalogAttributesList = response.data;
      var assignedCatalogAttributes = getActiveCatalogDetails().AssignedCatalogAttributes;
      angular.forEach(catalogAssignedModelLevelAttributes, function (attribute) {
        var filteredAttribute = utility.filterObject(catalogAttributesList, { Attributeid: attribute.AttributeId }, true)[0];
        // vetting list is not presnt in the attribute list so get it from catalog attributes
        var filteredCatalogAttribute = utility.filterObject(assignedCatalogAttributes, { Attributeid: attribute.AttributeId }, true)[0];
        filteredAttribute['AllowedValues'] = filteredCatalogAttribute.AllowedValues != null ?
        filteredCatalogAttribute.AllowedValues.sort(function(a, b) {
          return a.toLowerCase().localeCompare(b.toLowerCase());
        }) : [];
        if(angular.isDefined(filteredAttribute)) {
          var attributeField = angular.copy(attributeFieldTemplate);
          attributeField.isDynamicProperty = true;
          attributeField.isAttribute = true;
          attributeField.field = filteredAttribute.AttributeSystemName;
          attributeField.map = filteredAttribute.AttributeSystemName;
          attributeField.displayLabel = filteredAttribute.AttributeDisplayName;
          attributeField.visible = (filteredAttribute.Visible == true);
          attributeField.showInEdit = (filteredAttribute.ShowInEdit == true);
          attributeField.supportFilterLookup = (filteredAttribute.SupportFilterLookup == true);
          attributeField.initialValue = filteredAttribute.InitialValueAttribute;

          attributeField.validation.isRequired = filteredAttribute.IsRequired;
          attributeField.validation.minLen = filteredAttribute.IsRequired ? 1 : 0;
          attributeField.IsSeasonless = filteredAttribute.IsSeasonless;
          attributeField.IsSeasonlessModelAttribute = filteredAttribute.IsSeasonlessModelAttribute;// seasonless model level attributes
          attributeField.Overridable = filteredAttribute.Overridable;
          attributeField.DefaultValue = filteredAttribute.DefaultValue;
          // for attributes other than calc type if validation expression is a valid JSON we will add to tx-pattern else we will add it to pattern
          if(filteredAttribute.AttributeTypeName.toUpperCase() !== 'CALC') {
            if(!utility.isValidJSON(filteredAttribute.ValidationExpression)) {
              attributeField.validation.pattern = filteredAttribute.ValidationExpression != '{}' ? filteredAttribute.ValidationExpression : '';
              attributeField.validation['tx-pattern'] = false;
            } else {
              attributeField.validation.pattern = '';
              attributeField.validation['tx-pattern'] = filteredAttribute.ValidationExpression != null && filteredAttribute.ValidationExpression !== '' && filteredAttribute.ValidationExpression != '{}' ?
              filteredAttribute.ValidationExpression : false;
            }
          }
          attributeField.validation.messages.pattern = filteredAttribute.ValidationMessage;

          attributeField.reportable = false;
          attributeField.creatable = filteredAttribute.Creatable;
          attributeField.editable = filteredAttribute.Editable;
          attributeField.isModelLevelAttribute = true;

          //set data type to list for attributes having values added in attributeVettingList
          if (filteredAttribute.AttributeTypeName.toUpperCase() !== 'CALC' && filteredAttribute.AllowedValues && filteredAttribute.AllowedValues !== null && (angular.isArray(filteredAttribute.AllowedValues) && filteredAttribute.AllowedValues.length)) {
            // this attribute will be displyed with parent model number dropdown
            if(attributeField.field === 'parent_model_type') {
              attributeField.inputType = 'parent-model-type';
              attributeField.values = filteredAttribute.AllowedValues
              .map(function(value) {
                return value.trim();
              })
              .sort(function(a, b) {
                return a.toLowerCase().localeCompare(b.toLowerCase());
              });
            } else {
              attributeField.inputType = 'list';
              // for multi value attributes with vetting list inputtype will be multi-value
              if (filteredAttribute.AttributeTypeName.toUpperCase() === 'MULTIVALUE') {
                attributeField.inputType = 'multi-value';
                attributeField.tagSeparator = '|';
                if(!attributeField.editable) {
                  attributeField.nonRemovableChips = true;
                }
              }
              if (filteredAttribute.AttributeTypeName.toUpperCase() === 'INT' || filteredAttribute.AttributeTypeName.toUpperCase() === 'DECIMAL') {
                attributeField.type = 'int';
              } else {
                attributeField.type = 'text';
              }
              if (filteredAttribute.AttributeTypeName.toUpperCase() === 'DECIMAL') {
                attributeField.validation.pattern = '^[+]?\\d+([.]\\d{0,4})?$';
                attributeField.validation.messages.pattern = 'VALIDATIONS.POSITIVE_DECIMAL_4PONTS';
              }
            }
          }
          else {
            if (filteredAttribute.AttributeTypeName.toUpperCase() === 'INT') {
              attributeField.inputType = 'number';
            }
            else if (filteredAttribute.AttributeTypeName.toUpperCase() === 'NVARCHAR') {
              attributeField.inputType = 'textArea';
            }
            else if (filteredAttribute.AttributeTypeName.toUpperCase() === 'MULTIVALUE') {
              attributeField.inputType = 'tags';
              attributeField.tagSeparator = '|';
              attributeField.inputSubType = 'multi-value';
            }
            else if (filteredAttribute.AttributeTypeName.toUpperCase() === 'DATE') {
              attributeField.inputType = 'date-without-time';
            }
            else if (filteredAttribute.AttributeTypeName.toUpperCase() === 'DATETIME') {
              attributeField.inputType = 'date';
            }
            else if (filteredAttribute.AttributeTypeName.toUpperCase() === 'BOOL') {
              attributeField.inputType = 'bool-str';
            }
            else if(filteredAttribute.AttributeTypeName.toUpperCase() === 'CALC') {
              attributeField.inputType = 'calculated';
              attributeField.validation.pattern = '';
              attributeField.calculatedExpression = filteredAttribute.ValidationExpression;
              //Adding try catch if JSON parse fails
              try {
                attributeField.parsedExpressionObject = JSON.parse(filteredAttribute.ValidationExpression);
                if(angular.isDefined(attributeField.parsedExpressionObject.calculatedRegexExpression)) {
                  var calculatedRegexExpression = attributeField.parsedExpressionObject.calculatedRegexExpression;
                  if(angular.isDefined(calculatedRegexExpression.fieldRegex) && calculatedRegexExpression.fieldRegex.length > 0) {
                    angular.forEach(calculatedRegexExpression.fieldRegex, function(fieldRegex) {
                      var convertedRegEx = convertStringToRegex(fieldRegex.regEx);
                      if(convertedRegEx != null) {
                          fieldRegex.regEx = convertedRegEx;
                      } else {
                          console.warn("invalid Regex for : " + fieldRegex.field);
                      }
                    })
                  }
                }
              } catch(error) {
                console.warn("Attribute Validation Expression : Invalid JSON format");
              }
            }
            else if (filteredAttribute.AttributeTypeName.toUpperCase() === 'DATEOPTION') {
              attributeField.inputType = 'date-option';
            }
            else if (filteredAttribute.AttributeTypeName.toUpperCase() === 'DECIMAL') {
              attributeField.inputType = 'decimal';
              attributeField.validation.pattern = '^[+]?\\d+([.]\\d{0,4})?$';
              attributeField.validation.messages.pattern = 'VALIDATIONS.POSITIVE_DECIMAL_4PONTS';
            }
            else if (filteredAttribute.AttributeTypeName.toUpperCase() === 'COLORPALETTE') {
              attributeField.inputType = 'color-palette';
              attributeField.lookupSource = 'lists.sellerColorsFromColorPalette';
              attributeField.isfilterCriteria = true;
              attributeField.lookupFilter = {'Status': 1};
              attributeField.customLookupInfo = {value: 'value'}
            }
            else if (filteredAttribute.AttributeTypeName.toUpperCase() === 'MODELNUMBER') {
              attributeField.inputType = 'modelnumber';
              attributeField.lookupSource = 'lists.sellerModelsWithoutAttributes';
            }
            else if (filteredAttribute.AttributeTypeName.toUpperCase() === 'LOOKUPTABLE') {
              attributeField.inputType = 'lookup-table';
            }
            else if (filteredAttribute.AttributeTypeName.toUpperCase() === 'DATASET') {
              attributeField.inputType = 'dataset';
              attributeField.datasetId = filteredAttribute.DatasetId;
              // Catalog model editing scopes dataset values to the catalog.
              attributeField.isCatalogScoped = true;
            }
            else if (filteredAttribute.AttributeTypeName.toUpperCase() === 'DATATABLE') {
              attributeField.inputType = 'datatable';
              attributeField.DataTableAttributes = filteredAttribute.DataTableAttributes
              if(filteredAttribute.AllowedValuesV2 && filteredAttribute.AllowedValuesV2.length) {
                try {
                  attributeField.valuesV2 = JSON.parse(filteredAttribute.AllowedValuesV2)
                } catch(error) {
                  console.warn(filteredAttribute.AttributeDisplayName + " - Allowed Values Version 2 : Invalid JSON format");
                }
              }
              if(attribute.CriteriaV2 && attribute.CriteriaV2.length) {
                try {
                  attributeField.criteriaV2 = JSON.parse(attribute.CriteriaV2)
                } catch(error) {
                  console.warn(attribute.AttributeDisplayName + " - Criteria Version 2 : Invalid JSON format");
                }
              }
              if(api.allAttributesListMap && Object.keys(api.allAttributesListMap).length > 0) {
                  attributeField.dataTableAttributesDetails = attributeField.DataTableAttributes.map(function(attrId) {
                      return api.allAttributesListMap[attrId];
                  }).filter(function(attr) {
                      return attr !== undefined;
                  })
              }
            }
          }

          // make self attribute creatable or editable if they are required attributes or creatable and editable respectively
          // and if source is parent disable create and edit
          if (filteredCatalogAttribute.AttributeSource.toUpperCase() === 'SELF') {
            if (filteredCatalogAttribute.Editable || filteredCatalogAttribute.IsRequired) {
              attributeField.editable = true;
            }
            if (filteredCatalogAttribute.Creatable || filteredCatalogAttribute.IsRequired) {
              attributeField.creatable = true;
            }
          } else {
            attributeField.editable = false;
            attributeField.creatable = false;
          }

          if (filteredAttribute.AttributeTypeName.toUpperCase() === 'CALC') {
            attributeField.editable = false;
            attributeField.creatable = false;
          }

          //To avoid creating dulpicate attributes when calling articles details page from different module.
          var isAttributeExists = false;
          for( var i = 0; i < dynamicArticleModel.fields.length; i++) {
            if(dynamicArticleModel.fields[i].field === attributeField.field) {
              isAttributeExists = true;
              break;
            }
          }

          if(!isAttributeExists) {
            dynamicArticleModel.fields.push(attributeField);
          }

          if(maxDefaultColumnCounter > 0) {
            var columnList = dynamicArticleModel.views.mainList.columns;
            var existInCoulmList = false;
            if(columnList.length) {
              for (var i = 0; i < columnList.length ; i++) {
                if(columnList[i].indexOf(attributeField.field) !== -1) {
                  existInCoulmList = true;
                  break;
                }
              }
            }

            if(!existInCoulmList) {
              dynamicArticleModel.views.mainList.columns.push(angular.copy(attributeField.field));
              maxDefaultColumnCounter -= 1;
            }
          }
          //adding up to 4 attributes to default articles view default column list (views.mainList.columns)
          if (filteredAttribute.VisibleInListByDefault) {
            if(dynamicArticleModel.views.mainList.columns.indexOf(attributeField.field) === -1) {
              dynamicArticleModel.views.mainList.columns.push(attributeField.field);
            }
          }
        }
      });

      // add periods columns
      var shipmentWindowRangeList = getActiveCatalogDetails().ShipmentWindowRangeList;
      if(shipmentWindowRangeList.length) {
        var shipmentWindowsWithUniquePeriod = utility.shipmentWindowRangeWithUniquePeriods(shipmentWindowRangeList);
        var fieldTemplate = {
          catalogEntityId: '', field: '', map: '', type: 'text', displayLabel: '', visible: true, creatable: false, editable: false, inputType: 'number',
          validation: {
            isRequired: false, maxLen: -1, minLen: 1, pattern: '',
            messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' }
          }
        };

        angular.forEach(shipmentWindowsWithUniquePeriod, function (shipmentWindow) {
          fieldTemplate.field = shipmentWindow.Period;
          fieldTemplate.displayLabel = shipmentWindow.Period;
          fieldTemplate.map = 'AggregatedPeriods.Period';//add map property to model's field use for flattening the response
          fieldTemplate.catalogEntityId = shipmentWindow.Period;//add catalogEntityId property to model's field use for flattening the response (to search record)
          fieldTemplate.nestedArrayName = 'AggregatedPeriods'; // to differentiate StatesTimestamp when transorming articles data
          dynamicArticleModel.fields.push(angular.copy(fieldTemplate));
        });

      }
    });
    // create dataset attribute columns
    var datasetDetailsCache = {};
    if(catalogAssignedModelLevelAttributes && SecurityFactory.isAuthorized({accessPrivileges: CONSTANTS.PRIVILEGES.SELLERS.DETAIL.GET_DATASET_DEFINITIONS_DETAILS})) {
      var datasetAttributes = utility.filterObject(catalogAssignedModelLevelAttributes, {AttributeTypeId: 16}, true)
      angular.forEach(datasetAttributes, function(dtAttribute) {
          var datasetPromiseKey = 'dataset_' + dtAttribute.DatasetId;
          if (datasetDetailsCache[dtAttribute.DatasetId]) {
            modelPromises[datasetPromiseKey] = datasetDetailsCache[dtAttribute.DatasetId];
          } else {
            var datasetDetailsPromise = api.sellers.datasets.methods.getDetails(true, dtAttribute.DatasetId, getActiveCatalog().AccountId);
            datasetDetailsCache[dtAttribute.DatasetId] = datasetDetailsPromise;
            modelPromises[datasetPromiseKey] = datasetDetailsPromise;
          }
          // fetch the dataset attributes and create the columns
          datasetDetailsCache[dtAttribute.DatasetId].then(function (response) {
            var datasetAttributes = response.data.Attributes;
            if(datasetAttributes.length) {
              angular.forEach(datasetAttributes, function (datasetAttr) {
                var datasetAttributeField = angular.copy(attributeFieldTemplate);
                datasetAttributeField.isDynamicProperty = true;
                datasetAttributeField.isAttribute = true;
                datasetAttributeField.field = dtAttribute.AttributeSystemName + '-' + datasetAttr.AttributeSystemName;
                datasetAttributeField.map = dtAttribute.AttributeSystemName + '-' + datasetAttr.AttributeSystemName;
                datasetAttributeField.displayLabel = dtAttribute.AttributeDisplayName + '-' + datasetAttr.AttributeDisplayName;
                datasetAttributeField.visible = true;
                datasetAttributeField.supportFilterLookup = (dtAttribute.SupportFilterLookup == true);
                var index = dynamicArticleModel.fields.indexOf(utility.filterObject(dynamicArticleModel.fields, { field: 'CreatedDate' }, true)[0]);
                dynamicArticleModel.fields.splice(index, 0, angular.copy(datasetAttributeField));
              })
            }
          })
      })
    }

    $q.all(modelPromises).then(function () {
      applyRoleBasedAttributeRestrictions(dynamicArticleModel);
      deferred.resolve(dynamicArticleModel);
      datasetDetailsCache = {};
    });

    return deferred.promise;
  }

    //TODO- until API make it similar to articles segmentation
    function transformCustomerSegmentationsResponse(sourceData, nestedArrayName, fields) {
      var result = [];

      //Create blank record
      var sameLevelFields = [];
      var nestedFields = {};
      var flattenedRecord = {};

      angular.forEach(fields, function (field) {
        if (angular.isDefined(field.map)) {
          if (field.map.indexOf('.') === -1) {
            sameLevelFields.push(field);
            flattenedRecord[field.field] = undefined;
          } else {
            nestedFields[field.catalogEntityId] = field.field;
            flattenedRecord[field.field] = 'No';
          }
        }
      });

      angular.forEach(sourceData, function (record) {
        //changed the if condition as per API request(instead of 0 and 1, api is sending string values 'True' or 'False')
        if (record.Status.toUpperCase() === 'TRUE' || record.Status === 1) {
          var newRecord = angular.copy(flattenedRecord);

          angular.forEach(sameLevelFields, function (field) {
            newRecord[field.field] = record[field.map];
          });

          angular.forEach(record[nestedArrayName], function (nestedRecord) {
            newRecord[nestedFields[nestedRecord.SegmentationId]] = 'Yes';
          });

          result.push(newRecord);
        }
      });
      return result;
    }

    function transformArticlesBlockingResponse(sourceData, fields) {
      var result = [];
      var sameLevelFields = [];
      var catalogFields = [];
      var flattenedRecord = {};
      angular.forEach(fields, function (field) {
        if (field.isDynamicProperty) {
          catalogFields.push(field);
          flattenedRecord[field.field] = 'No';
        } else {
          sameLevelFields.push(field);
          flattenedRecord[field.field] = undefined;
        }
      });

      angular.forEach(sourceData, function (record) {
        var newRecord = angular.copy(flattenedRecord);

        angular.forEach(sameLevelFields, function (field) {
          newRecord[field.field] = record[field.field];
        });

        angular.forEach(catalogFields, function(catalogField) {
          if(record.BlockedCatalogs.indexOf(catalogField.catalogCode) >= 0) {
            newRecord[catalogField.field] = 'Yes';
          }
        });
        result.push(newRecord);
      });

      return result;
    }

    function transformStockResponse(sourceData, nestedArrayName, fields) {
      var result = [];
      //Create blank record
      var sameLevelFields = [];
      var dynamicFields = {};
      var flattenedRecord = {};

      //to separate out dynamic fields and sameLevelFields
      angular.forEach(fields, function (field) {
        if (angular.isDefined(field.map)) {
          if (field.map.indexOf('.') === -1) {
            sameLevelFields.push(field);
            flattenedRecord[field.field] = undefined;
          } else if (angular.isDefined(field.catalogEntityId)) {
            dynamicFields[field.catalogEntityId] = field.field;
            flattenedRecord[field.field] = null;
          }
        }
      });

      angular.forEach(sourceData, function (record) {
        if (record.Status !== 0) {
          var newRecord = angular.copy(flattenedRecord);

          angular.forEach(sameLevelFields, function (field) {
            newRecord[field.field] = record[field.map];
          });

          angular.forEach(record[nestedArrayName], function (Stock) {
            newRecord[dynamicFields[Stock.StockDefinitionId]] = Stock.Actual;
          });

          result.push(newRecord);
        }
      });
      return result;
    }

    /**
    * This method will assign assortments to their respective folders and if folder is deactivated it will make the assortment deactivated as well
    * @Param assortments: list of active catalog assortments
    * @Param folders: list of folders for active catalog
    * @Return: list containing folders with their respective assortment(s) in their nodes property
    */
    function assignAssortmentsToFolder(assortments, folders) {
      //Sort assortments by SortOrder property in ascending order
      assortments = utility.orderBy(assortments, 'SortOrder', false);
      //Sort folders by SortOrder property in ascending order
      //folders = utility.orderBy(folders, 'SortOrder', false);
      angular.forEach(assortments, function (assortment) {
        var targetFolder = utility.filterObject(folders, { Id: assortment.FolderId }, true)[0];

        //Changing Status of assortment to 0 if folder is deactivated
        if (targetFolder.Status === 0 || targetFolder.parentStatus === 0) {
          assortment.folderStatus = 0;
        }
        targetFolder.nodes.push(assortment);
      });
      return folders;
    }

    /**
    * This method will transform flat structure directory to desire structure needed for ui.tree library
    *  and will add ancestorDisabledStatus value to each subdirectory based on parent folder Status and its ancestorDisabledStatus
    * @Param directories: flat structure folders with their files
    * @Param allDirectories: flat structure folders with their files which will point to all directories in subsequent recursive call
    * @Return : list of directory required by ui.tree library
    */
    function transformFolders(directories, allDirectories) {
      if (angular.isDefined(directories) && angular.isArray(directories) && directories.length > 0) {

        angular.forEach(directories, function (directory) {
          var subDirectories = utility.filterObject(allDirectories, { ParentFolderId: directory[api.catalogs.folders.idField] }, true);
          //var ancestorDisabledStatus;
          //if directory is root- ancestorDisabledStatus will be 1 so the buttons of root wont get disabled according to model's disable conditions
          if (angular.isUndefined(directory.ancestorDisabledStatus)) {
            directory.ancestorDisabledStatus = 1;
          }
          //Sort subdirectory ascending order-> object with lower sort order will be inserted on top
          angular.forEach(subDirectories, function (subDirectory) {
            //ancestorDisabledStatus will indicates if any folder in hierarchy is disabled or not (it might possible immediate parent is active but one of ancestor is inactive)
            subDirectory.ancestorDisabledStatus = directory.Status && directory.ancestorDisabledStatus;
            directory.nodes.push(subDirectory);
            allDirectories.splice(allDirectories.indexOf(subDirectory), 1);
          });

          //Sort each node (folders and assortment) under nodes based on their sortOrders
          directory.nodes = utility.orderBy(directory.nodes, 'SortOrder', false);
          transformFolders(subDirectories, allDirectories);
        });

      }
      return allDirectories;
    }

    function createUiTreeBranchPath(node, parentPath) {
      angular.forEach(node, function (nodeObj) {
        if (nodeObj.type === 'folder') {
          nodeObj.branch = angular.isUndefined(parentPath) ? nodeObj[api.catalogs.folders.lookupDisplayField] : parentPath + ',' + nodeObj[api.catalogs.folders.lookupDisplayField];
          if (angular.isDefined(nodeObj.nodes) && angular.isArray(nodeObj.nodes) && nodeObj.nodes.length > 0) {
            return createUiTreeBranchPath(nodeObj.nodes, nodeObj.branch);
          }
        }
        else if (nodeObj.type === 'assortment') {
          nodeObj.branch = angular.isUndefined(parentPath) ? nodeObj[api.catalogs.assortments.lookupDisplayField] : parentPath + ',' + nodeObj[api.catalogs.assortments.lookupDisplayField];
        }
      });
    }

    /**
    * Add ancestorDisabledStatus to assortments
    * @param uiTreeFoldersAndAssortments: transformed list of folders and assortments
    * @param ancestorDisabledStatus: parent ancestorDisabledStatus value (initially can be set to -1 since all root folders have this property)
    */
    function addAncestorDisabledStatusToAssortment(uiTreeFoldersAndAssortments, ancestorDisabledStatus) {
      angular.forEach(uiTreeFoldersAndAssortments, function (parentNode) {
        //if leaf node
        if (angular.isUndefined(parentNode.nodes)) {
          parentNode.ancestorDisabledStatus = ancestorDisabledStatus;
        }
        angular.forEach(parentNode.nodes, function (node) {
          //This portion is not really required since all the folders have already got their ancestorDisabledStatus but assignment of ancestorDisabledStatus for folders as well can be moved here
          if (angular.isUndefined(node.ancestorDisabledStatus)) {
            node.ancestorDisabledStatus = parentNode.Status && parentNode.ancestorDisabledStatus;
          }
          if (angular.isDefined(node.nodes) && angular.isArray(node.nodes) && node.nodes.length > 0) {
            return addAncestorDisabledStatusToAssortment(node.nodes, node.Status && node.ancestorDisabledStatus);
          }
        });
      });
    }


    //Helper Methods

    function createArticleCRDObject(catalogCRD) {
      var articleCRD = {
        'CrdId': -1,
        'CustomerRequiredDate': '',
        'AvailabilityFrom': '',
        'AvailabilityTo': '',
        'CatalogCRDStatus': -1,
        'Status': 0
      };
      articleCRD.CrdId = catalogCRD[api.catalogs.CRD.idField];
      articleCRD.CustomerRequiredDate = catalogCRD[api.catalogs.CRD.lookupDisplayField];
      articleCRD.CatalogCRDStatus = catalogCRD.Status;
      return articleCRD;
    }

    function createArticleSegmentationObject(catalogSegmentation) {
      var articleSegmentation = {
        'SegmentationId': -1,
        'Name': '',
        'Status': 0,
        'CatalogSegmentationStatus': -1
      };
      articleSegmentation.Name = catalogSegmentation.Name;
      articleSegmentation.SegmentationId = catalogSegmentation[api.catalogs.segmentations.idField];
      articleSegmentation.CatalogSegmentationStatus = catalogSegmentation.Status;
      return articleSegmentation;
    }

    function setCatalogImportMapping(catalogId, newSettings) {
      $localStorage['activeCatalogDetails'].ImportMapping = angular.copy(newSettings);
      $sessionStorage['activeCatalogDetailsSession'].ImportMapping = angular.copy(newSettings);
      return api.webPut(api.baseUrl + '/catalogs/' + catalogId + '/importmapping', { ImportMapping: angular.toJson(newSettings, 0) });
    }

    /**
    * @description modify inherited articles list view and details view item actions and list actions
    */
    function modifyInheritedArticlesActions(inheritedArticlesModel) {
      // to have them in model, so it will be more readable code and to avoid splicing
      var action = utility.filterObject(inheritedArticlesModel.views.mainList.itemActions, { id: 'delete' }, true)[0];
      action.visible = false;
      action = utility.filterObject(inheritedArticlesModel.views.mainList.itemActions, { id: 'activate' }, true)[0];
      action.visible = false;
      action = utility.filterObject(inheritedArticlesModel.views.mainList.itemActions, { id: 'unAssign' }, true)[0];
      action.visible = 'itm.Status === 1';
      action = utility.filterObject(inheritedArticlesModel.views.mainList.itemActions, { id: 'assign' }, true)[0];
      action.visible = 'itm.Status !== 1';
      action.disabled = '!itm.PS';
      action = utility.filterObject(inheritedArticlesModel.views.mainList.itemActions, { id: 'addSegmentation' }, true)[0];
      action.disabled = 'itm.Status !== 1';
      action = utility.filterObject(inheritedArticlesModel.views.mainList.itemActions, { id: 'AddPrice' }, true)[0];
      action.disabled = 'itm.Status !== 1 || (itm.Locked === 1 && activeCatalog.ArticleLocking === 1)';
      // only assigned catalog or globally droped catalog is allowed to edit
      // article yet to assign are not editable
      action = utility.filterObject(inheritedArticlesModel.views.mainList.itemActions, { id: 'edit' }, true)[0];
      action.disabled = 'itm.IsAccessible === 1';
      action = utility.filterObject(inheritedArticlesModel.views.mainList.itemActions, { id: 'manageArticleStates' }, true)[0];
      action.visible = false;
      action = utility.filterObject(inheritedArticlesModel.views.mainList.itemActions, { id: 'overwriteColor' }, true)[0];
      action.visible = false;

      action = utility.filterObject(inheritedArticlesModel.views.mainList.listActions, { id: 'delete' }, true)[0];
      action.visible = false;
      action = utility.filterObject(inheritedArticlesModel.views.mainList.listActions, { id: 'activate' }, true)[0];
      action.visible = false;
      action = utility.filterObject(inheritedArticlesModel.views.mainList.listActions, { id: 'unAssign' }, true)[0];
      action.visible = true;
      action = utility.filterObject(inheritedArticlesModel.views.mainList.listActions, { id: 'assign' }, true)[0];
      action.visible = true;
      action = utility.filterObject(inheritedArticlesModel.views.mainList.listActions, { id: 'updateBulk' }, true)[0];
      action.disabled = '{selected: true, IsAccessible: ["!1"]}';
      action = utility.filterObject(inheritedArticlesModel.views.mainList.listActions, { id: 'manageArticleStates' }, true)[0];
      action.visible = false;
      action = utility.filterObject(inheritedArticlesModel.views.mainList.listActions, { id: 'overwriteColorBulk' }, true)[0];
      action.visible = false;

      action = utility.filterObject(inheritedArticlesModel.views.mainDetails.itemActions, { id: 'delete' }, true)[0];
      action.visible = false;
      action = utility.filterObject(inheritedArticlesModel.views.mainDetails.itemActions, { id: 'activate' }, true)[0];
      action.visible = false;
      action = utility.filterObject(inheritedArticlesModel.views.mainDetails.itemActions, { id: 'unAssign' }, true)[0];
      action.visible = true;
      action = utility.filterObject(inheritedArticlesModel.views.mainDetails.itemActions, { id: 'assign' }, true)[0];
      action.visible = true;
      action = utility.filterObject(inheritedArticlesModel.views.mainDetails.itemActions, { id: 'manageArticleStates' }, true)[0];
      action.visible = false;

      //create fab dial for inherited articles
      inheritedArticlesModel.isInherited = true;
      inheritedArticlesModel.views.mainList.fabAction = {};
    }

    function modifyArticleSegmentationActions(articleSegmentations) {
      var action = utility.filterObject(articleSegmentations.views.mainList.listActions, { id: 'updateBulk' }, true)[0];
      action.visible = false;
      action = utility.filterObject(articleSegmentations.views.mainList.listActions, { id: 'import' }, true)[0];
      action.visible = false;
      action = utility.filterObject(articleSegmentations.views.mainList.listActions, { id: 'importBySegmentationGroup' }, true)[0];
      action.visible = false;

      action = utility.filterObject(articleSegmentations.views.mainList.itemActions, { id: 'edit' }, true)[0];
      action.visible = false;
    }

    function modifySegmentationActions(model) {
      model.views.mainList.itemActions = [];
      model.views.mainList.listActions = [];
      model.views.mainList.fabAction.visible = false;
    }

    function modifyInheritedArticlesFields(inheritedArticlesModel, activeCatalog) {
      var modelFields = inheritedArticlesModel.fields;
      var field;

      modelFields.push(
        { field: 'IsAccessible', type: 'int', displayLabel: 'ARTICLES.FIELDS.IS_ASSIGNED', visible: false, creatable: false, editable: false, inputType: 'int-bool',
          validation: {
            isRequired: false, maxLen: -1, minLen: 1, pattern: '',
            messages: { isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: '' }
          }
        }
      );

      var PRANfield = utility.filterObject(modelFields, { field: 'PRAN' }, true)[0];
      PRANfield.visible = true;
      var PSfield = utility.filterObject(modelFields, { field: 'PS' }, true)[0];
      PSfield.visible = true;

      if (activeCatalog.IsShippingWindowApply === 1) {
        // make parent shipping range visible and read only properties on edit dialog for inherited articles
        field = utility.filterObject(modelFields, { field: 'PRetailIntroMonth' }, true)[0];
        field.visible = true;
        field.showInEdit = true;

        field = utility.filterObject(modelFields, { field: 'PRetailExitMonth' }, true)[0];
        field.visible = true;
        field.showInEdit = true;

        // make parent shipping start date visible and read only properties on edit dialog for inherited articles
        field = utility.filterObject(modelFields, { field: 'PShipmentStartDate' }, true)[0];
        field.visible = true;
        field.showInEdit = true;

        // make parent shipping end date visible and read only properties on edit dialog for inherited articles
        field = utility.filterObject(modelFields, { field: 'PShipmentEndDate' }, true)[0];
        field.visible = true;
        field.showInEdit = true;

        field = utility.filterObject(modelFields, { field: 'PPeriod' }, true)[0];
        field.visible = true;
        field.showInEdit = true;
      }
      if (getIsSizeScaleByStyle()) {
        // make parent size scale visible and read only properties on edit dialog for inherited articles
        field = utility.filterObject(modelFields, { field: 'PSizeScale' }, true)[0];
        field.visible = true;

        // make parent size scale visible for inherited articles
        field = utility.filterObject(modelFields, { field: 'PSizeScaleId' }, true)[0];
        field.visible = true;
      }
    }

    function modifyArticleRetailWindowAndRelatedFields(articleModel) {
      var retailIntroMonthField = utility.filterObject(articleModel.fields, {field: 'RetailIntroMonth'}, true)[0];
      retailIntroMonthField.visible = false;
      var retailExitMonthField = utility.filterObject(articleModel.fields, {field: 'RetailExitMonth'}, true)[0];
      retailExitMonthField.visible = false;
      var periodField = utility.filterObject(articleModel.fields, {field: 'Period'}, true)[0];
      periodField.visible = false;
      var shipmentStartDateField = utility.filterObject(articleModel.fields, {field: 'ShipmentStartDate'}, true)[0];
      shipmentStartDateField.visible = false;
      var shipmentEndDateField = utility.filterObject(articleModel.fields, {field: 'ShipmentEndDate'}, true)[0];
      shipmentEndDateField.visible = false;
    }

    //to convert regex in string to regex format
    function convertStringToRegex(regexString) {
      var regex;
      if (regexString[0] !== '/') {
        return null;
      }
      var i = regexString.lastIndexOf('/');
      if ( i <= 0 ) {
        return null;
      }
      try {
        regex = new RegExp(regexString.slice(1, i), regexString.slice(i+1));
      } catch(error) {
        return null;
      }
      return regex;
    }

    //check if any article in the active catalog is locked and active
    function getCatalogArticleLockedStatus() {
      return api.webGet(api.baseUrl + '/catalogs/' + getActiveCatalog().CatalogCode + '/lockedarticle/status', undefined, true, true);
    }

    function createCatalogArticleNumbersArray(articles, isCatalogArticles) {
      var articleNumbers = [];
      // checks if logged in user has access to see the blocked image for active catalog
      // if user doesnt have access then call dune images with BlockImage flag disabled articles
      if(!doesUserHaveAccessToBlockedImagesForActiveCatalog()) {
        angular.forEach(articles, function(article) {
          if(!article.BlockImage) {
            if(isCatalogArticles) {
              articleNumbers.push(article.ArticleNumber);
            } else {
              if(article.Status && !articleNumbers.includes(article.ImageSet)) {
                articleNumbers.push(article.ImageSet);
              }
            }
          }
        });
      } else {
        if(isCatalogArticles) {
          articleNumbers = articles.map(function(article) {
            return article.ArticleNumber
          });
        } else {
          articleNumbers = articles.map(function(article) {
            if(article.Status && !articleNumbers.includes(article.ImageSet)) {
              return article.ImageSet
            }
          });
        }
      }

      return articleNumbers;
    }

    function getCatalogArticleNumbersWithDuneImagesArray(articlesList) {
      if(articlesList.length < catalogArticlesList.length) {
        articlesList = catalogArticlesList;
      }
      var deferred = $q.defer();
      var generalProperties = {
          forceFetch: false,
          isLogRequired: false,
          cache: false,
          config: {},
          supportIncrementalResult: false,
          modelIdField: 'Id',
          isMajor: false,
      }
      var articleNumberArray = [];
      var requestObjet = {
        Context: getActiveCatalog().DuneContext,
        ContextKey: getCatalogContextKey(),
        FirstImage: true,
        Status: true,
        Op: 'equals',
        Type: 'ImageSet'
      };
      if($localStorage.activeCatalogDetails.IsLinePlan === 1) {
          // only for the carry over articles we will show the images
          var carryoverArticles = utility.filterObject(articlesList, {article_type: 'carryover'});
          articleNumberArray = createCatalogArticleNumbersArray(carryoverArticles, true);
      } else {
          articleNumberArray = createCatalogArticleNumbersArray(articlesList, true);
      }
      requestObjet.Filter = articleNumberArray;
      if(articleNumberArray.length > 0) {
        api.catalogs.t1Dune.methods.getListByFilter(generalProperties, undefined, requestObjet).then(function (response) {
          var articleDuneImages = utility.filterObject(response.data, {Status: true});
          var articlesWithAssets = [];
          var carryOverArticleAssetsArray = articleNumberArray.map(function(carryOverArticle) {
            var articleObj = {};
            var sortedAssetsByImagest = $filter('orderBy')($filter('txStartsWith')(articleDuneImages, 'ImageSet', carryOverArticle), 'ImageSet');
            var lowestArticleAssets = [];
            if(angular.isDefined(sortedAssetsByImagest) && sortedAssetsByImagest.length > 0) {
              lowestArticleAssets = utility.filterObject(sortedAssetsByImagest, {ImageSet: sortedAssetsByImagest[0].ImageSet});
              angular.forEach(lowestArticleAssets, function(asset) {
                asset['_sortOrder'] = asset.SortOrder + asset.FileName.toLowerCase();
              });
            }
            if(lowestArticleAssets.length > 0) {
              articlesWithAssets.push(carryOverArticle);
            }
            articleObj['articleNumber'] = carryOverArticle;
            articleObj['assetStorageFile'] = lowestArticleAssets.length > 0 ? $filter('txOrderBy')(lowestArticleAssets, '_sortOrder')[0].StorageFile : undefined;
            return articleObj;
          });

          deferred.resolve({articlesWithAssets: articlesWithAssets, carryOverArticleAssetsArray: carryOverArticleAssetsArray});
        });
      } else {
        deferred.resolve();
      }
      return deferred.promise;
    }

    function setActiveCatalogTree(tree) {
      activeCatalogTree = tree;
    }

    function setActiveCatalogArticles(articleList) {
      catalogArticlesList = articleList;
    }

    function getActiveCatalogTree() {
      return activeCatalogTree;
    }

    function getAutomaticNumbering() {
      return $sessionStorage['AutomaticNumberingSession'];
    }

    function getCustomNumbering() {
      return $sessionStorage['CustomNumberingSession'];
    }

    /**
     * @description: caches the seller level numbering settings so they can be read without refetching the seller
     */
    function setNumberingSettings(automaticNumbering, customNumbering) {
      $localStorage.AutomaticNumbering = automaticNumbering;
      $sessionStorage.AutomaticNumberingSession = angular.copy(automaticNumbering);
      $localStorage.CustomNumbering = customNumbering;
      $sessionStorage.CustomNumberingSession = angular.copy(customNumbering);
    }

    function getIsSizeScaleByStyle() {
      return $sessionStorage['IsSizeScaleByStyleSession'];
    }

    function getCurrentUserRoles() {
      var userRoles = angular.isDefined($localStorage.profileInformation) && angular.isDefined($localStorage.profileInformation.Roles) ? $localStorage.profileInformation.Roles : [];
      return userRoles;
    }

    function getModelNameLength() {
      return $sessionStorage['ModelNameLength'];
    }

    /**
    * @description
    * transform response object and create one record per model(transform horizontally)
    *
    * @param {array}sourceData: source object  (response of get catalog models)
    * @param {array} fields: model fields
    * @param {array} nestedArray: nestedarray names
    * @return {array}: List of transformed objects
    */
    function transformCatalogModelsResponse(sourceData, fields) {
      var result = [];

      //Create blank record
      var sameLevelFields = [];
      var nestedFields = {};
      var flattenedRecord = {};
      var nestedArrayNamesList = ['AggregatedPeriods'];

      angular.forEach(fields, function (field) {
        if (angular.isDefined(field.map)) {
          if (field.map.indexOf('.') === -1) {
            sameLevelFields.push(field);
            flattenedRecord[field.field] = undefined;
          } else {
            nestedFields[field.catalogEntityId] = field.field;
            if(field.nestedArrayName === 'AggregatedPeriods') {
              flattenedRecord[field.field] = '';
            }
          }
        }
      });

      angular.forEach(sourceData, function (record) {
        if((angular.isUndefined(record[nestedArrayNamesList[0]])) ||
          (angular.isDefined(record[nestedArrayNamesList[0]]) && (record[nestedArrayNamesList[0]] == null || (record[nestedArrayNamesList[0]] != null && record[nestedArrayNamesList[0]].length <= 0)))) {
            var newRecord = angular.copy(flattenedRecord); // lookup parent model number and parent model name using MasterModelId
            angular.forEach(sameLevelFields, function (field) {
              if (angular.isDefined(record[field.map])) {
                newRecord[field.field] = record[field.map];
              }
            })
            // assign zero to all the periods when AggregatedPeriods is null or empty to sort columns correctly
            angular.forEach(nestedFields, function(period) {
              newRecord[period] = 0;
            });
            result.push(newRecord);
        } else if (angular.isDefined(record[nestedArrayNamesList[0]])) {
          var newRecord = angular.copy(flattenedRecord);
          angular.forEach(sameLevelFields, function (field) {
            if (angular.isDefined(record[field.map])) {
              newRecord[field.field] = record[field.map];
            }
          });
          // assign zero to all the periods when AggregatedPeriods is null or empty to sort columns correctly
          angular.forEach(nestedFields, function(period) {
            newRecord[period] = 0;
          });

          // add parent overridable attrbute values if any presnt
          for(var key in record) {
            if(key.startsWith('#')) {
              newRecord[key] = record[key];
            }
          }

          if(angular.isDefined(record[nestedArrayNamesList[0]]) && !utility.isObjectEmpty(record[nestedArrayNamesList[0]]) && nestedArrayNamesList[0] === 'AggregatedPeriods') {
            var aggregatedPeriods = record['AggregatedPeriods'];
            angular.forEach(aggregatedPeriods, function(period) {
              newRecord[period['Period']] = period['ActiveArticles'];
            });
          }
          result.push(newRecord);
        }
      });
      return result;
    }

    /**
    * @description
    *  Creates summary reports model dynamically based api response
    */
    function createSummaryReportModel(report) {
      // return api.catalogs.targets.methods.getReports({forceFetch: false, isLogRequired: false}, getActiveCatalog().CatalogCode)
      // .then(function (response) {
        var model = api.catalogs.summaryReport;
        model.fields = [];
        model.views.mainList.columns = [];
        var fieldTemplate = {
          catalogEntityId: '', field: '', map: '', type: 'text', displayLabel: '', visible: true, creatable: false, editable: false, inputType: 'text',
        };

        for(var key in report) {
          fieldTemplate.field = key;
          fieldTemplate.displayLabel = key.replace(/\|/g," ");
          fieldTemplate.map = key;//add map property to model's field use for flattening the response
          fieldTemplate.catalogEntityId = key;//add catalogEntityId property to model's field use for flattening the response (to search record)
          model.fields.push(angular.copy(fieldTemplate));
          model.views.mainList.columns.push(key);
        }
        return model;
    }
    /**
    * @description
    * transform RetailIntroMonth and RetailExitMonth in the required format as
    * Intro Month: [Month] ([Shipment Start Date Month]/[Shipment Start Date Day] Start Ship)
    * Exit Month: [Month] ([Shipment End Date Month]/[Shipment End Date Day] End Ship)
    * @param isImport if import then consider first three letters of intro and exit month
    * returns transformed retail windows
    */
    function transformRetailIntroAndRetailExitMonth(retailWindows, isImport) {
      var transformedRetailWindows = [];
      angular.forEach(retailWindows, function(retailWindow) {
        var startDate = new Date(retailWindow.ShipmentStartDate);
        var endDate = new Date(retailWindow.ShipmentEndDate);
        var introMonth = retailWindow.RetailIntroMonth;
        var exitMonth = retailWindow.RetailExitMonth;
        if(angular.isDefined(isImport) && isImport) {
          // find the find three characters
          introMonth = introMonth.toString().trim().substring(0, 3);
          exitMonth = exitMonth.toString().trim().substring(0, 3);
        }

        var introMonthWithShipment = (startDate.getMonth() + 1) + '/' + startDate.getDate() + ' Start Ship';
        var exitMonthWithShipment = (endDate.getMonth() + 1) + '/' + endDate.getDate() + ' End Ship';
        retailWindow.RetailIntroMonth = introMonth + ' (' + introMonthWithShipment + ')';
        retailWindow.RetailExitMonth = exitMonth + ' (' + exitMonthWithShipment + ')';
        transformedRetailWindows.push(retailWindow);
      })
      return transformedRetailWindows;
    }


    function generateImportTabularFields(folders, parentPath) {
      parentPath = parentPath ? parentPath : '';
      var pathFields = [];
      var fieldTemplate = { field: '', type: 'text', displayLabel: '', visible: true, creatable: true, editable: true, inputType: 'switch',
      validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', isOptional: true, messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} };

      angular.forEach(folders, function(folder) {
        var newPath = parentPath + (parentPath ? '/' : '') + folder.Name;

        if (folder.Status === 1 && folder.nodes && folder.nodes.length > 0) {
            var subPaths = generateImportTabularFields(folder.nodes, newPath);
            pathFields = pathFields.concat(subPaths);
        } else if (folder.Status === 1 && folder.type === 'assortment') {
            var pathField = angular.copy(fieldTemplate);
            pathField.field = newPath + '__' + folder.Name; // Add the path name at the end again to split it correctly as assortment name can have slash in it
            pathField.displayLabel = newPath;
            pathFields.push(pathField);
        }
      });

      return pathFields;
    }

    // update the application version
    function getAndSetAppVersion() {
      api.webGet('/app/app.config.json').then(function(response) {
        if (angular.isDefined(response) && angular.isDefined(response.data) && angular.isDefined(response.data.appVersion)) {
            $localStorage.version = response.data.appVersion.version;
            $localStorage.release = response.data.appVersion.release;
        }
      });
    }

  }

})();
(function() {
		'use strict';

		angular
				.module('app.main.catalogs')
				.run(runBlock);

		/* @ngInject */
		function runBlock(api, activityLogger, $state, crud, catalogFactory, $rootScope, utility, SecurityFactory, CONSTANTS, errorDialog) {

				if (angular.isUndefined(api.catalogs)) {
						api.catalogs = {};
				}
				 api.catalogs.catalogs = {
						modelPath: 'catalogs.catalogs',
						fields: [
								{ field: 'Id', type: 'int', displayLabel: 'CATALOGS.FIELDS.ID', visible: false, creatable: false, editable: false, inputType: 'number',
										validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'Season', type: 'text', displayLabel: 'CATALOGS.FIELDS.SEASON', visible: true, creatable: true, editable: true, inputType: 'text',
										validation: {isRequired: true, maxLen: 100, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'Year', type: 'int', displayLabel: 'CATALOGS.FIELDS.YEAR', visible: true, creatable: true, editable: true, inputType: 'number',
										validation: {isRequired: true, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'DataSourceTypeId', type: 'int', displayLabel: 'CATALOGS.FIELDS.DATA_SOURCE_TYPE', visible: false, creatable: true, editable: false, inputType: 'lookup',  lookupSource: 'lists.dataSourceTypes',
										validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'DataSourceType', type: 'text', displayLabel: 'CATALOGS.FIELDS.DATA_SOURCE_TYPE', visible: true, creatable: false, editable: false, inputType: 'text',
										validation: {isRequired: false, maxLen: 100, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'AccountId', type: 'int', displayLabel: 'CATALOGS.FIELDS.SELLER_ACCOUNT', visible: true, creatable: true, editable: true, inputType: 'lookup', lookupSource: 'accounts.sellers',
										lookupFilter: {Status: 1}, validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'CatalogCode', type: 'int', displayLabel: 'CATALOGS.FIELDS.CATALOG_CODE', visible: true, creatable: false, editable: false, inputType: 'number',
										validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'CatalogName', type: 'text', displayLabel: 'CATALOGS.FIELDS.CATALOG_NAME', visible: true, creatable: true, editable: true, inputType: 'text',
										validation: {isRequired: true, maxLen: 100, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'OrderPluginSource', type: 'text', displayLabel: 'CATALOGS.FIELDS.ORDER_PLUGIN', visible: true, creatable: false, editable: false, inputType: 'text',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'OrderPluginId', type: 'text', displayLabel: 'CATALOGS.FIELDS.ORDER_PLUGIN', visible: false, creatable: true, editable: true, inputType: 'lookup', lookupSource: 'plugins.orderPlugins',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'IsVasInUse', type: 'text', displayLabel: 'CATALOGS.FIELDS.IS_VAS_IN_USE', visible: true, creatable: true, editable: true, inputType: 'int-bool',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'IsShippingWindowApply', type: 'text', displayLabel: 'CATALOGS.FIELDS.APPLY_RETAIL_WINDOW', visible: true, creatable: true, editable: false, inputType: 'bool-int',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'IsPriceByStyleApply', type: 'text', displayLabel: 'CATALOGS.FIELDS.APPLY_PRICE_BY_STYLE', visible: true, creatable: true, editable: true, inputType: 'bool-int',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'IndependentSizes', type: 'text', displayLabel: 'CATALOGS.FIELDS.INDEPENDENT_SIZES', visible: true, creatable: true, editable: true, inputType: 'bool-int',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'AllowRequestedArticleCreation', type: 'text', displayLabel: 'CATALOGS.FIELDS.ALLOW_REQUESTED_ARTICLE_CREATION', visible: true, creatable: true, editable: true, inputType: 'bool-int',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'ReferenceCatalogCode', type: 'text', displayLabel: 'CATALOGS.FIELDS.REFERENCE_CATAOG_CODE', visible: true, creatable: true, editable: false, inputType: 'lookup', lookupSource: 'catalogs.catalogs',
										lookupFilter: {Status: 1}, validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', disabledCriteria: 'vm.record.DataSourceTypeId === 1', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'MasterCatalogCode', type: 'text', displayLabel: 'CATALOGS.FIELDS.MASTER_CATALOG_CODE', visible: true, creatable: false, editable: false, inputType: 'lookup', lookupSource: 'catalogs.catalogs',
										validation: {isRequired: false, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'AttributeGroupId', type: 'int', displayLabel: 'CATALOGS.FIELDS.ATTRIBUTE_GROUP_NAME', visible: false, creatable: true, editable: false, inputType: 'lookup', lookupSource: 'attributes.attributeGroups',
										validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', disabledCriteria: 'vm.record.DataSourceTypeId === 2 || vm.record.DataSourceTypeId === 3', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'AttributeGroupName', type: 'text', displayLabel: 'CATALOGS.FIELDS.ATTRIBUTE_GROUP_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'AttributeIdsList', type: 'text', displayLabel: 'CATALOGS.FIELDS.ATTRIBUTE_IDS_LIST', visible: false, creatable: true, editable: true, inputType: 'lookup-many', lookupSource: 'attributes.attributes',
										validation: {isRequired: 'vm.record.DataSourceTypeId === 3', maxLen: -1, minLen: 0, pattern: '', disabledCriteria: 'vm.record.DataSourceTypeId === 2', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'ImageName', type: 'text', displayLabel: 'CATALOGS.FIELDS.IMAGE_NAME', visible: false, creatable: false, editable: false, inputType: 'text',
										validation: {isRequired: false, maxLen: 100, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'ImageFile', type: 'text', displayLabel: 'CATALOGS.FIELDS.IMAGE_FILE', visible: false, creatable: false, editable: false, inputType: 'text',
										validation: {isRequired: false, maxLen: 100, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'ImagePath', type: 'text', displayLabel: 'CATALOGS.FIELDS.IMAGE_PATH', visible: false, creatable: false, editable: false, inputType: 'text',
										validation: {isRequired: false, maxLen: 100, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'Status', type: 'text', displayLabel: 'CATALOGS.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'CatalogShared', type: 'text', displayLabel: 'CATALOGS.FIELDS.CATALOG_SHARED', visible: false, creatable: false, editable: false, inputType: 'text',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'CreatedDate', type: 'text', displayLabel: 'CATALOGS.FIELDS.CREATED_DATE', visible: false, creatable: false, editable: false, inputType: 'date',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'UpdatedDate', type: 'text', displayLabel: 'CATALOGS.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'UserId', type: 'text', displayLabel: 'CATALOGS.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
										validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'CatalogCRDList', type: 'text', displayLabel: 'CATALOGS.FIELDS.CATALOG_CRD_LIST', visible: false, creatable: false, editable: false, inputType: 'text',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'CatalogSpecificConfigurationList', type: 'text', displayLabel: 'CATALOGS.FIELDS.CATALOG_SPECIFIC_CONFIGURATION_LIST', visible: false, creatable: false, editable: false, inputType: 'text',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'CatalogPriceGroupList', type: 'text', displayLabel: 'CATALOGS.FIELDS.CATALOG_PRICEGROUP_LIST', visible: false, creatable: false, editable: false, inputType: 'text',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'UpdatedBy', type: 'text', displayLabel: 'CATALOGS.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'SourceCatalog', type: 'int', displayLabel: 'CATALOGS.FIELDS.SOURCE_CATALOG', visible: false, creatable: true, editable: false, inputType: 'number',
										validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'ReceiveOrders', type: 'text', displayLabel: 'CATALOGS.FIELDS.RECEIVE_ORDERS', visible: true, creatable: false, editable: false, inputType: 'bool-int',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'ReceiveOrdersWithoutPrice', type: 'int', displayLabel: 'CATALOGS.FIELDS.RECEIVE_ORDERS_WITHOUT_PRICE', visible: true, creatable: true, editable: true, inputType: 'bool-int',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'ArticleCascading', type: 'text', displayLabel: 'CATALOGS.FIELDS.ARTICLE_CASCADING', visible: true, creatable: true, editable: true, inputType: 'bool-int',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'IsStockApply', type: 'text', displayLabel: 'CATALOGS.FIELDS.IS_STOCK_APPLY', visible: true, creatable: true, editable: true, inputType: 'bool-int',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'SegmentationCascading', type: 'text', displayLabel: 'CATALOGS.FIELDS.SEGMENTATION_CASCADING', visible: true, creatable: true, editable: true, inputType: 'bool-int',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'SegmentationPlanningEnable', type: 'text', displayLabel: 'CATALOGS.FIELDS.SEGMENTATION_PLANNING_ENABLE', visible: true, creatable: true, editable: true, inputType: 'bool-int',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'ArticleLocking', type: 'text', displayLabel: 'CATALOGS.FIELDS.ARTICLE_LOCKING', visible: true, creatable: true, editable: true, inputType: 'bool-int',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'State', type: 'text', displayLabel: 'CATALOGS.FIELDS.STATE', visible: true, creatable: true, editable: true, inputType: 'text',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'IsLinePlan', type: 'text', displayLabel: 'CATALOGS.FIELDS.IS_LINE_PLAN', visible: false, creatable: false, editable: false, inputType: 'bool-int',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'LinkedCatalogs', type: 'text', displayLabel: 'CATALOGS.FIELDS.LINKED_CATALOGS', visible: false, creatable: false, editable: false, inputType: 'text',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'LinkedAttributes', type: 'text', displayLabel: 'CATALOGS.FIELDS.LINKED_ATTRIBUTES', visible: false, creatable: false, editable: false, inputType: 'text',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'TargettedAttributes', type: 'text', displayLabel: 'CATALOGS.FIELDS.TARGETED_ATTRIBUTE', visible: false, creatable: false, editable: false, inputType: 'text',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'AggregateAttributes', type: 'text', displayLabel: 'CATALOGS.FIELDS.AGGREGATED_ATTRIBUTE', visible: false, creatable: false, editable: false, inputType: 'text',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'PriceCascading', type: 'text', displayLabel: 'CATALOGS.FIELDS.PRICE_CASCADING', visible: true, creatable: true, editable: false, inputType: 'bool-int',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'CopyPriceCatalogs', type: 'text', displayLabel: 'CATALOGS.FIELDS.COPY_PRICE_CATALOGS', visible: false, creatable: true, editable: false, inputType: 'lookup-many', lookupSource: 'catalogs.catalogs',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'ChangeLog', type: 'text', displayLabel: 'CATALOGS.FIELDS.CHANGE_LOG', visible: true, creatable: true, editable: true, inputType: 'bool-int',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'ArticleReplacementAttributeId', type: 'text', displayLabel: 'CATALOGS.FIELDS.ARTICLE_REPLACEMENT_ATTRIBUTE', visible: true, creatable: true, editable: true, inputType: 'lookup', lookupSource: 'attributes.attributes',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'MirrorSegmentation', type: 'text', displayLabel: 'CATALOGS.FIELDS.MIRROR_SEGMENTATION', visible: true, creatable: true, editable: true, inputType: 'bool-int',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'DuneContext', type: 'text', displayLabel: 'CATALOGS.FIELDS.CONTEXT', visible: true, creatable: false, editable: false, inputType: 'text',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'DuneContext', type: 'text', displayLabel: 'CATALOGS.FIELDS.CONTEXT', visible: false, creatable: false, editable: false, inputType: 'custom-lookup', lookupSource: 'lists.duneContext', customLookupInfo: {value: 'value'},
										lookupFilter: {Status: true}, validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'ContextReadKey', type: 'text', displayLabel: 'CATALOGS.FIELDS.CONTEXT_READ_KEY', visible: true, creatable: false, editable: false, inputType: 'text',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'ContextReadWriteKey', type: 'text', displayLabel: 'CATALOGS.FIELDS.CONTEXT_WRITE_KEY', visible: true, creatable: false, editable: false, inputType: 'text',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'RequestsEnabled', type: 'text', displayLabel: 'CATALOGS.FIELDS.REQUEST_ENABLED', visible: true, creatable: false, editable: false, inputType: 'bool-int',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'AcceptRequests', type: 'text', displayLabel: 'CATALOGS.FIELDS.ACCEPT_REQUEST', visible: true, creatable: false, editable: false, inputType: 'bool-int',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'BuyerLimitPriceGroupId', type: 'int', displayLabel: 'CATALOGS.FIELDS.BUYER_LIMIT_PRICE_GROUP_ID', visible: true, creatable: false, editable: false, inputType: 'number',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'BuyerLimitPriceGroupName', type: 'text', displayLabel: 'CATALOGS.FIELDS.BUYER_LIMIT_PRICE_GROUP_NAME', visible: true, creatable: false, editable: false, inputType: 'text',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'ReferenceLineArchCatalog', type: 'text', displayLabel: 'CATALOGS.FIELDS.REFERENCE_LINE_ARCH_CATALOG', visible: true, creatable: true, editable: false, inputType: 'lookup', lookupSource: 'catalogs.catalogs',
										lookupFilter: {Status: 1, IsLinePlan: 1}, validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'Visibility', type: 'int', displayLabel: 'CATALOGS.FIELDS.VISIBILITY', visible: true, creatable: true, editable: false, inputType: 'lookup',  lookupSource: 'lists.catalogVisibilities',
										validation: {isRequired: false, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'CollectionsType', type: 'int', displayLabel: 'CATALOGS.FIELDS.COLLECTION_TYPE', visible: true, creatable: true, editable: false, inputType: 'lookup',  lookupSource: 'lists.catalogCollectionTypes',
										validation: {isRequired: false, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'IsLive', type: 'text', displayLabel: 'CATALOGS.FIELDS.IS_LIVE', visible: true, creatable: true, editable: true, inputType: 'bool-int',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'AssignAllSegmentation', type: 'text', displayLabel: 'CATALOGS.FIELDS.ASSIGN_ALL_SEGMENTATION', visible: true, creatable: true, editable: true, inputType: 'bool-int',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'SeasonalSequence', type: 'int', displayLabel: 'CATALOGS.FIELDS.SEASONAL_SEQUENCE', visible: true, creatable: true, editable: true, inputType: 'number',
										validation: {isRequired: false, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'SyncSizes', type: 'text', displayLabel: 'CATALOGS.FIELDS.SYNC_SIZES', visible: true, creatable: true, editable: true, inputType: 'bool-int',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'RetailWindowAttribute', type: 'text', displayLabel: 'CATALOGS.FIELDS.RETAIL_WINDOW_ATTRIBUTE', visible: true, creatable: true, editable: true, inputType: 'text',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'ModelAttribute', type: 'text', displayLabel: 'CATALOGS.FIELDS.MODEL_ATTRIBUTE', visible: true, creatable: false, editable: false, inputType: 'text',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'ArticleAttribute', type: 'text', displayLabel: 'CATALOGS.FIELDS.ARTICLE_ATTRIBUTE', visible: true, creatable: false, editable: false, inputType: 'text',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'CustomerRequiredDateValidation', type: 'text', displayLabel: 'CATALOGS.FIELDS.CUSTOMER_REQUIRED_DATE_VALIDATION', visible: true, creatable: true, editable: true, inputType: 'textArea',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'OrderBySizeCurve', type: 'text', displayLabel: 'CATALOGS.FIELDS.ORDER_BY_SIZE_CURVE', visible: true, creatable: true, editable: true, inputType: 'bool-int',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
						],
						uniqueConstraints: [
								{name: 'Constraint 1', fields: ['CatalogName']}
						],
						title: 'CATALOGS.NAV',
						icon: 'icon-book-open',
						idField: 'CatalogCode',
						lookupDisplayField: 'CatalogName',
						isDirty: false,
						methods: {
								getList         :   getCatalogs,
								getDetails      :   getCatalog,
								activateBulk    :   activateCatalogs,
								create          :   createCatalog,
								update          :   updateCatalog,
								copy            :   copyCatalog,
								getAvailableReferenceCatalogs: getAvailableReferenceCatalogs,
								updateReceiveOrdersStatus: updateReceiveOrdersStatus,
								getAvailableAttributes: getAvailableAttributes,
								assignCatalogContext : assignCatalogContext,
								updateReceiveRequestsStatus: updateReceiveRequestsStatus
						},
						views: {
								mainList: {
										columns         : [ 'CatalogCode', 'CatalogName', 'DataSourceType', 'ReferenceCatalogCode', 'AccountId' , 'Status', 'UpdatedDate' ],
										columnFilter    : {},
										toggleFilterProps: { toggleStatus:false, filterProp:'Status', trueVal:1, trueValTooltipMessage: 'ACTIONS.TOGGLE_ACTIVE', falseVal:'', falseValTooltipMessage:"ACTIONS.TOGGLE_ALL"},
										topIndex        : 0,
										showFilterRow   : false,
										sortColumn      : {'UpdatedDate': false},
										itemActions     : [
																				{ id: 'view', label: 'ACTIONS.VIEW', icon: 'icon-magnify', privilege: 'GetCatalogDetails', disabled: '!itm.Status', visible: true },
																				{ id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UpdateCatalogDefination', disabled: '!itm.Status', visible: true },
																				{ id: 'copy', label: 'CATALOGS.ACTIONS.COPY_CATALOG', icon: 'icon-content-copy', privilege: 'CopyCatalogDefination', disabled: '!itm.Status', visible: true },
																				{ id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateBulkCatalogStatus', disabled: false, visible: 'itm.Status',
																						requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
																				{ id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateBulkCatalogStatus', disabled: false, visible: '!itm.Status',
																						requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'},
																				{ id: 'stopOrders', label: 'CATALOGS.ACTIONS.STOP_ORDERS', icon: 'icon-close', privilege: 'UpdateCatalogReceivingOrderStatus', disabled: false, visible: 'itm.ReceiveOrders',
																						requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'CATALOGS.MESSAGES.CONTENT.CONFIRM_STOP_ORDERS'}, confirmationAction: 'CATALOGS.ACTIONS.STOP_ORDERS'},
																				{ id: 'allowOrders', label: 'CATALOGS.ACTIONS.ALLOW_ORDERS', icon: 'icon-check', privilege: 'UpdateCatalogReceivingOrderStatus', disabled: false, visible: '!itm.ReceiveOrders',
																						requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'CATALOGS.MESSAGES.CONTENT.CONFIRM_ALLOW_ORDERS'}, confirmationAction: 'CATALOGS.ACTIONS.ALLOW_ORDERS'},
																				{ id: 'manageContext', label: 'CATALOGS.ACTIONS.MANAGE_CONTEXT', icon: 'icon-layers', privilege: 'AssignDuneContext', disabled: false, visible: true},
																				{ id: 'disableRequests', label: 'CATALOGS.ACTIONS.DISABLE_REQUESTS', icon: 'icon-close', privilege: 'EnableRequests', disabled: false, visible: 'itm.RequestsEnabled',
																								requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'CATALOGS.MESSAGES.CONTENT.CONFIRM_DISABLE_REQUESTS'}, confirmationAction: 'CATALOGS.ACTIONS.DISABLE_REQUESTS'},
																				{ id: 'enableRequests', label: 'CATALOGS.ACTIONS.ENABLE_REQUESTS', icon: 'icon-check', privilege: 'EnableRequests', disabled: false, visible: '!itm.RequestsEnabled',
																						requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'CATALOGS.MESSAGES.CONTENT.CONFIRM_ENABLE_REQUESTS'}, confirmationAction: 'CATALOGS.ACTIONS.ENABLE_REQUESTS'}
																			],
										listActions     : [
																				{ id: 'delete', label: 'ACTIONS.DELETE_BULK', icon: 'icon-delete', privilege: 'UpdateBulkCatalogStatus', disabled: '{selected: true, Status: 1}', visible: true,
																						requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
																				{ id: 'activate', label: 'ACTIONS.ACTIVATE_BULK', icon: 'icon-undo-variant', privilege: 'UpdateBulkCatalogStatus', disabled: '{selected: true, Status: 0}', visible: true,
																						requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'}
																			],
										fabAction       :
																				{id: 'add', label: 'ACTIONS.ADD', icon: 'icon-plus', privilege: 'CreateCatalogDefination', visible: true}

								 },
								 mainDetails: {
										 selectedTabIndex   : 0,
										 itemActions        : [
																						{ id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateBulkCatalogStatus', disabled: '{selected: true, Status: 1}',
																								visible: true, requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
																						{ id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateBulkCatalogStatus', disabled: '{selected: true, Status: 0}',
																								visible: true, requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'},
																					 { id: 'stopOrders', label: 'CATALOGS.ACTIONS.STOP_ORDERS', icon: 'icon-close', privilege: 'UpdateCatalogReceivingOrderStatus', disabled: '{selected: true, ReceiveOrders: 1}',
																								visible: true, requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'CATALOGS.MESSAGES.CONTENT.CONFIRM_STOP_ORDERS'}, confirmationAction: 'CATALOGS.ACTIONS.STOP_ORDERS'},
																						{ id: 'allowOrders', label: 'CATALOGS.ACTIONS.ALLOW_ORDERS', icon: 'icon-check', privilege: 'UpdateCatalogReceivingOrderStatus', disabled: '{selected: true, ReceiveOrders: 0}',
																								visible: true, requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'CATALOGS.MESSAGES.CONTENT.CONFIRM_ALLOW_ORDERS'}, confirmationAction: 'CATALOGS.ACTIONS.ALLOW_ORDERS'},
																						{ id: 'manageContext', label: 'CATALOGS.ACTIONS.MANAGE_CONTEXT', icon: 'icon-layers', privilege: 'AssignDuneContext', disabled: false, visible: true},
																						{ id: 'disableRequests', label: 'CATALOGS.ACTIONS.DISABLE_REQUESTS', icon: 'icon-close', privilege: 'EnableRequests', disabled: '{selected: true, RequestsEnabled: 1}', visible: true,
																								requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'CATALOGS.MESSAGES.CONTENT.CONFIRM_DISABLE_REQUESTS'}, confirmationAction: 'CATALOGS.ACTIONS.DISABLE_REQUESTS'},
																						{ id: 'enableRequests', label: 'CATALOGS.ACTIONS.ENABLE_REQUESTS', icon: 'icon-check', privilege: 'EnableRequests', disabled: '{selected: true, RequestsEnabled: 0}', visible: true,
																								requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'CATALOGS.MESSAGES.CONTENT.CONFIRM_ENABLE_REQUESTS'}, confirmationAction: 'CATALOGS.ACTIONS.ENABLE_REQUESTS'}
																					],
										// fabAction           : {id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UpdateCatalogDefination', visible: true}
										//PROXY FAB FOR DETAIL PAGE
										fab                 : {id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UpdateCatalogDefination', visible: true}

								 },
								 privileges: {
										 list: 'CatalogList',
										 details: 'GetCatalogDetails'
								 }
						}
				};

				function getCatalogs(generalProperties) {
						var promise;

						if(angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
								var state = {};
								state.name = $state.current.name;
								state.params = $state.params;
								var isBulk = true;
								var logData = activityLogger.createLogData(null, state, 'catalogs.catalogs', 'VIEW', isBulk, new Date(), null, null);

								promise = api.webGet(api.baseUrl + '/catalogs', undefined, true, generalProperties.forceFetch);
								promise = activityLogger.log(logData, promise);
						}
						else {
								promise = api.webGet(api.baseUrl + '/catalogs', undefined, true, generalProperties.forceFetch);
						}

						promise.then(function() {
								if (api.catalogs.catalogs.isDirty) {
										//Invalidate lookupData
										api.catalogs.catalogs.lookupData = undefined;
										api.catalogs.catalogs.isDirty = false;
								}
						});
						return promise;
		}

				function getCatalog(isLogRequired, catalogId) {
						var promise;
						if(angular.isDefined(isLogRequired) && isLogRequired === true) {
								var state = {};
								state.name = $state.current.name;
								state.params = $state.params;
								var isBulk = false;
								var items= [];
								promise = api.webGet(api.baseUrl + '/catalogs/' + catalogId + '?status=0');
								promise.then(function(response) {
										items.push(response.data[api.accounts.sellers.lookupDisplayField]);
								}, function(response) {
										items.push(response.data[api.accounts.sellers.lookupDisplayField]);
								});
								var logData = activityLogger.createLogData(items, state, 'catalogs.catalogs', 'VIEW', isBulk, new Date(), null, null);
								promise = activityLogger.log(logData, promise);
						}
						else {
								promise = api.webGet(api.baseUrl + '/catalogs/' + catalogId + '?status=0');
						}
						return promise;
		}

		function activateCatalogs(records, model, actionType) {
						var result = crud.createRequestObject(records, model, actionType);
						var state = {};
						state.name = $state.current.name;
						state.params = $state.params;
						var isBulk = result.itemsNameList.length > 1 ? true : false;
						var logData = activityLogger.createLogData(result.itemsNameList, state, 'catalogs.catalogs', actionType.toUpperCase(), isBulk, new Date(), null, null);
						var promise = api.webPut(api.baseUrl + '/catalogs/status', result.requestObj);

						promise.then(function() {
								$rootScope.$emit('CatalogsUpdatedEvent');
								crud.onRecordStatusChange(records, model, actionType);
						});

						return activityLogger.log(logData, promise);
		}

		function createCatalog(catalog) {
						var state = {};
						state.name = $state.current.name;
						state.params = $state.params;
						var logData = activityLogger.createLogData(catalog[api.catalogs.catalogs.lookupDisplayField], state, 'catalogs.catalogs', 'ADD', false, new Date(), null, null);
						var promise = api.webPost(api.baseUrl + '/catalogs', catalog);

						promise.then(function() {
								$rootScope.$emit('CatalogsUpdatedEvent');
								api.catalogs.catalogs.isDirty = true;
						});
						return activityLogger.log(logData, promise);
		}

				function updateCatalog(catalogId, catalog) {
						// to update the catalog details stored in localstorage, so if user updated any catalog's attribute activeCatalogDetails will get updated and
						// it will include that changes in article model(why I did here, to avoide making http request at the time of building model)
						catalogFactory.updateListOfCatalogs();
						var state = {};
						state.name = $state.current.name;
						state.params = $state.params;
						var logData = activityLogger.createLogData(catalog[api.catalogs.catalogs.lookupDisplayField], state, 'catalogs.catalogs', 'EDIT', false, new Date(), null, null);
						var promise = api.webPut(api.baseUrl + '/catalogs/'+ catalogId, catalog);

						promise.then(function() {
								$rootScope.$emit('CatalogsUpdatedEvent');
								api.catalogs.catalogs.isDirty = true;
								//while updating catalog user can add attributes. In this case the lookup data for creating consolidationTemplate must be reset when reloading the lookup data.
								api.consolidationTemplates.templateFields.lookupData = undefined;
						});
						return activityLogger.log(logData, promise);
		}

				function copyCatalog(catalog) {
						var state = {};
						state.name = $state.current.name;
						state.params = $state.params;
						var logData = activityLogger.createLogData(catalog[api.catalogs.catalogs.lookupDisplayField], state, 'catalogs.catalogs', 'ADD', false, new Date(), null, null);
						var promise = api.webPost(api.baseUrl + '/catalogs/copy', catalog);

						promise.then(function() {
							 api.catalogs.catalogs.isDirty = true;
						});
						return activityLogger.log(logData, promise);
				}

				function getAvailableReferenceCatalogs(baseCatalogCode) {
						return api.webGet(api.baseUrl + '/catalogs/' + baseCatalogCode + '/availablereferencecatalogs', undefined, true, true);
				}

				function updateReceiveOrdersStatus(catalog, model, actionType) {
						var requestObj = {
								Status: -1
						};
						var state = {};
						var additionalInfo = {};
						var actionToPerform;
						var updateAffectedField = 'ReceiveOrders';

						if(actionType.toUpperCase() === 'STOPORDERS') {
								requestObj.Status = 0;
								additionalInfo.customMessage = 'CATALOGS.MESSAGES.CONTENT.STOP_ORDERS';
								actionToPerform = 'STOP_ORDERS';
						}
						else if(actionType.toUpperCase() === 'ALLOWORDERS') {
								requestObj.Status = 1;
								additionalInfo.customMessage = 'CATALOGS.MESSAGES.CONTENT.ALLOW_ORDERS';
								actionToPerform = 'ALLOW_ORDERS';
						}

						state.name = $state.current.name;
						state.params = $state.params;
						var logData = activityLogger.createLogData(catalog[api.catalogs.catalogs.lookupDisplayField], state, 'catalogs.catalogs', actionToPerform, false, new Date(), null, null)

						var promise;
						promise = api.webPut(api.baseUrl + '/catalogs/' + catalog[api.catalogs.catalogs.idField] + '/receiveorders/status', requestObj);
						promise.then(function() {
								$rootScope.$emit('CatalogsUpdatedEvent');
								crud.onRecordStatusChange(catalog, model, actionType, updateAffectedField, additionalInfo);
						});

						return activityLogger.log(logData, promise);
				}

				function updateReceiveRequestsStatus(catalog, model, actionType) {
					var status = 0;
					var state = {};
					var additionalInfo = {};
					var actionToPerform;
					var updateAffectedField = 'RequestsEnabled';

					if(actionType.toUpperCase() === 'DISABLEREQUESTS') {
							additionalInfo.customMessage = 'CATALOGS.MESSAGES.CONTENT.DISABLE_REQUESTS';
							actionToPerform = 'DISABLE_REQUESTS';
					}
					else if(actionType.toUpperCase() === 'ENABLEREQUESTS') {
							status = 1;
							additionalInfo.customMessage = 'CATALOGS.MESSAGES.CONTENT.ENABLE_REQUESTS';
							actionToPerform = 'ENABLE_REQUESTS';
					}

					state.name = $state.current.name;
					state.params = $state.params;
					var logData = activityLogger.createLogData(catalog[api.catalogs.catalogs.lookupDisplayField], state, 'catalogs.catalogs', actionToPerform, false, new Date(), null, null)
					var promise;
					promise = api.webPut(api.baseUrl + '/catalogs/' + catalog[api.catalogs.catalogs.idField] + '/requests/enable/' + status);
					promise.then(function() {
							$rootScope.$emit('CatalogsUpdatedEvent');
							crud.onRecordStatusChange(catalog, model, actionType, updateAffectedField, additionalInfo);
							api.catalogs.requests.isDirty = true;
					});

					return activityLogger.log(logData, promise);
				}

				function getAvailableAttributes(catalogCode) {
					if(SecurityFactory.isAuthorized({accessPrivileges: CONSTANTS.PRIVILEGES.VETTING_LIST.GET_CATALOG_AVAILBALE_ATTRIBUTE_LIST})) {
						return api.webGet(api.baseUrl + '/catalogs/' + catalogCode + '/availableattributes', undefined, true, true);
					} else {
						var privilege = {
							id: 545,
							description: 'Attribute - GetCatalogAvailbaleAttributeList'
						};
						errorDialog.show('ERRORS.NO_PRIVILEGES', undefined, privilege);
					}
				}

				function assignCatalogContext(activeCatalogId, selectedContextId, contextList) {
					var state = {};
					var requestObj = {};
					state.name = $state.current.name;
					state.params = $state.params;
					var actionToPerform = 'MANAGE_CONTEXT';
					if(angular.isUndefined(selectedContextId)) {
						requestObj.Context = '';
						requestObj.ContextReadKey = '';
						requestObj.ContextReadWriteKey = '';
					} else {
						var contextRecord = utility.filterObject(contextList, { value: selectedContextId }, true)[0];
						requestObj.Context = contextRecord.value;
						requestObj.ContextReadKey = contextRecord.ContextReadKey;
						requestObj.ContextReadWriteKey = contextRecord.ContextReadWriteKey;
					}

					var logData = activityLogger.createLogData(activeCatalogId, state, 'catalogs.catalogs', actionToPerform, false, new Date(), null, null);
					var promise = api.webPut(api.baseUrl + '/catalogs/' + activeCatalogId + '/dunecontext', requestObj);

					promise.then(function() {
							$rootScope.$emit('CatalogsUpdatedEvent');
							api.catalogs.catalogs.isDirty = true;
					});
					return activityLogger.log(logData, promise);
				}
		}
})();
(function() {
	'use strict';

	angular.module('app.main.auth', [
		'app.main.auth.login',
		'app.main.auth.lock',
		'app.main.auth.set-password'
	]);
})();
(function () {
	'use strict';

	angular
		.module('app.main.auth')
		.factory('authFactory', authFactory);

	/**
	 * @description all reusable functions related to applicaion can be placed in this factory
	 */
	/* @ngInject */
	function authFactory($localStorage, $auth, SecurityFactory, $http, $sessionStorage, $q, utility) {
		var service = {
			onLogout: onLogout,
			getMasterToken: getMasterToken,
			getChildToken: getChildToken,
			getMyUsersList: getMyUsersList,
			setProfileInformation: setProfileInformation
		};

		return service;

		function onLogout() {
			delete $localStorage.profileInformation;
			delete $localStorage.logs;
			delete $localStorage.version;
			delete $localStorage.release;
			SecurityFactory.factoryState.isPrivilegeSetUp = false; // set isPrivilegeSetUp flag to false, so that on login new user privileges are applied
		}

		//get master token
		function getMasterToken(user) {
			var url = $localStorage.authBaseUrl + '/token';
			return $http.post(url, user)
			.then(function(response) {
				return response;
			});
		}


		//get child token
		function getChildToken(user, masterToken) {
			//To call child token with master token
			$auth.setToken(masterToken);
			var deferred = $q.defer();
			//if it is a master user then we will not call the child token
			// when user is switching between child user and master user we will not call the child token api
			if($localStorage.user.masterUserName.toLowerCase() === user.username.toLowerCase()
			&& ((angular.isDefined($localStorage.user.childUserName) && $localStorage.user.childUserName !== user.username.toLowerCase()) || angular.isUndefined($localStorage.user.childUserName))) {
				deferred.resolve();
			} else {
				$auth.login(user, { url: $localStorage.authBaseUrl + '/childtoken' },{ headers :{ "Authorization": "Bearer " + masterToken}})
				.then(function (response) {
					deferred.resolve(response);
				}).catch(function(error) {
					deferred.reject(error);
				})
			}
			return deferred.promise;
		}

		//get myuser list
		function getMyUsersList(clientId, envCode, masterToken) {
			return $http.get($localStorage.authBaseUrl + '/myusers',{ headers :{ "Authorization": "Bearer " + masterToken}})
			.then(function(response) {
				return utility.filterObject(response.data, { allowedClients: clientId, allowedEnvironments: envCode, status: true }, true);
			});
		}

		function setProfileInformation(rolesModel, masterUserName, childUserName, loginType) {
			return rolesModel.methods.getProfileInformation(true, false)
				.then(function (response) {

					if (angular.isUndefined(response.data.Settings) || response.data.Settings === null) {
						response.data.Settings = '';
					}

					if (angular.isUndefined($localStorage.account)) {
						$localStorage.account = {};
					}

					if(angular.isUndefined($localStorage.user) || $localStorage.user.masterUserName !== masterUserName || $localStorage.user.childUserName !== childUserName || angular.isUndefined($localStorage.account) || angular.isUndefined($localStorage.account.accountId)) {
						cleanLocalAndSessionStorageOnNewUserLogin();
						$localStorage.account = {};
						$localStorage.account.accountId = response.data.AccountDetails.AccountId;
						$localStorage.account.accountType = response.data.AccountDetails.AccountTypeId.toString();
						$localStorage.user = {};
						$localStorage.user.masterUserName = masterUserName;
						$localStorage.user.loginType = loginType;
						// while calling this method after getting the master token, child user will be undefined
						if(angular.isDefined(childUserName)) {
							$localStorage.user['childUserName'] = childUserName;
						} else {
							$localStorage.user['childUserName'] = undefined;
						}
						localStorage.UserId = null;
					}

					$localStorage.account.organizationId = response.data.AccountDetails.OrganizationId;
					$localStorage.profileInformation = response.data;
					$localStorage.lastKeepAlive = new Date();
					if (angular.isUndefined($localStorage.user) || $localStorage.user === null) {
						$localStorage.user = {};
					}
					$localStorage.user['userId'] = response.data.Id;
					if ($localStorage.UserId != response.data.Id) {
						$localStorage.UserId = response.data.Id;
					}
					return response;
				});
		}

		//private methods
		function cleanLocalAndSessionStorageOnNewUserLogin() {
			// these are the values set in local storage before call to doLogin inside controller
			var skipValues = ['isMultiEnv', 'baseUrl', 'env', 'authBaseUrl', 't1DuneBaseUrl', 't1v2URL', 't1DuneAssetDownloadBaseUrl', 'allowedChildUsersCount', 'accessToken', 'switchUser', 'ActiveCatalog'];
			// when switching between users we need to keep the child users count and master user token
			var skipSessionStorageValues = ['accessToken', 'allowedChildUsersCount'];

			for (var key in $sessionStorage) {
				if (!angular.isFunction($sessionStorage[key]) && skipSessionStorageValues.indexOf(key) === -1) {
					delete $sessionStorage[key];
				}
			}

			for (var key in $localStorage) {
				if (!angular.isFunction($localStorage[key]) && skipValues.indexOf(key) === -1) {
					delete $localStorage[key];
				}
			}
		}

		//set isPrivilegeSetUp flag to false, so that on login new user privileges are applied
		SecurityFactory.factoryState.isPrivilegeSetUp = false;
	}
})();
(function() {
		'use strict';

		angular
				.module('app.main.catalogs.article-states')
				.run(runBlock);

		/* @ngInject */
		function runBlock(api, activityLogger, $state, crud, catalogFactory) {

				if(angular.isUndefined(api.catalogs)) {
						api.catalogs = {};
				}
				api.catalogs.articleStates = {
						modelPath: 'catalogs.articleStates',
						fields: [
								{ field: 'StateId', type: 'int', displayLabel: 'ARTICLE_STATES.FIELDS.STATE_ID', visible: true, creatable: false, editable: false, inputType: 'number',
										validation: {isRequired: false, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'StateName', type: 'text', displayLabel: 'ARTICLE_STATES.FIELDS.STATE_NAME', visible: true, creatable: true, editable: false, inputType: 'text',
										validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'StateRank', type: 'int', displayLabel: 'ARTICLE_STATES.FIELDS.STATE_RANK', visible: true, creatable: true, editable: false, inputType: 'number', checkIfUnique: true,
										validation: {isRequired: true, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'Status', type: 'text', displayLabel: 'ARTICLE_STATES.FIELDS.STATUS', visible: true, creatable: false, editable: false, inputType: 'status',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'IsModelLevel', type: 'text', displayLabel: 'ARTICLE_STATES.FIELDS.IS_MODEL_LEVEL', visible: true, creatable: false, editable: false, inputType: 'bool-int',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'IsDefault', type: 'text', displayLabel: 'ARTICLE_STATES.FIELDS.IS_DEFAULT', visible: true, creatable: false, editable: false, inputType: 'bool-int',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'AssignFinalArticleModelNumber', type: 'text', displayLabel: 'ARTICLE_STATES.FIELDS.ASSIGN_FINAL_ARTICLE_MODEL_NUMBER', visible: true, creatable: false, editable: false, inputType: 'bool-int',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'IsSizeScaleRequired', type: 'text', displayLabel: 'ARTICLE_STATES.FIELDS.IS_SIZESCALE_REQUIRED', visible: true, creatable: false, editable: false, inputType: 'bool-int',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'RequiredAttributes', type:'text', displayLabel: 'ARTICLE_STATES.FIELDS.REQUIRED_ATTRIBUTES', visible: false, creatable: true, editable: true, inputType: 'lookup-many', lookupSource: 'lists.seasonlessModelAndArticleLevelAttributesList',
										validation: {isRequired: false, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'NonEditableAttributes', type:'text', displayLabel: 'ARTICLE_STATES.FIELDS.NON_EDITABLE_ATTRIBUTES', visible: false, creatable: true, editable: true, inputType: 'lookup-many', lookupSource: 'lists.seasonlessModelAndArticleLevelAttributesList',
										validation: {isRequired: false, maxLen: -1, minLen: 1, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'AllowChangeRequest', type: 'text', displayLabel: 'ARTICLE_STATES.FIELDS.ALLOW_CHANGE_REQUEST', visible: false, creatable: false, editable: false, inputType: 'bool-int',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'IsModelNameEditable', type: 'text', displayLabel: 'ARTICLE_STATES.FIELDS.IS_MODEL_NAME_EDITABLE', visible: true, creatable: false, editable: false, inputType: 'bool-int',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'AllowChangeRequestForModelName', type: 'text', displayLabel: 'ARTICLE_STATES.FIELDS.ALLOW_CHANGE_REQUEST_FOR_MODEL_NAME', visible: true, creatable: false, editable: false, inputType: 'bool-int',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'IsSizeScaleEditable', type: 'text', displayLabel: 'ARTICLE_STATES.FIELDS.IS_SIZESCALE_EDITABLE', visible: true, creatable: false, editable: false, inputType: 'bool-int',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'AllowChangeRequestForSizeScale', type: 'text', displayLabel: 'ARTICLE_STATES.FIELDS.ALLOW_CHANGE_REQUEST_FOR_SIZESCALE', visible: true, creatable: false, editable: false, inputType: 'bool-int',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'IsArticleNumberEditable', type: 'text', displayLabel: 'ARTICLE_STATES.FIELDS.IS_ARTICLE_NUMBER_EDITABLE', visible: true, creatable: false, editable: false, inputType: 'bool-int',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'CreatedDate', type: 'text', displayLabel: 'ARTICLE_STATES.FIELDS.CREATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'UpdatedDate', type: 'text', displayLabel: 'ARTICLE_STATES.FIELDS.UPDATED_DATE', visible: true, creatable: false, editable: false, inputType: 'date',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'CreatedBy', type: 'text', displayLabel: 'ARTICLE_STATES.FIELDS.CREATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'UpdatedBy', type: 'text', displayLabel: 'ARTICLE_STATES.FIELDS.UPDATED_BY', visible: true, creatable: false, editable: false, inputType: 'lookup-from-map', lookupSource:'vm.api.accountUsersListMap',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} },
								{ field: 'IsPrimaryColorRequired', type: 'text', displayLabel: 'ARTICLE_STATES.FIELDS.IS_PRIMARY_COLOR_REQUIRED', visible: true, creatable: false, editable: false, inputType: 'bool-int',
										validation: {isRequired: false, maxLen: -1, minLen: 0, pattern: '', messages: {isRequired: 'VALIDATIONS.REQUIRED', maxLen: 'VALIDATIONS.MAXLEN', minLen: '', pattern: ''}} }
								],
						uniqueConstraints: [],
						title: 'ARTICLE_STATES.NAV',
						icon: 'icon-compare',
						idField: 'StateId',
						lookupDisplayField: 'StateName',
						isDirty: false,
						methods: {
								getList         :   getArticleStates,
								activateBulk    :   activateArticleStates,
								create          :   createArticleState,
								update          :   updateArticleState
						},
						views: {
								mainList: {
										columns             : [ 'StateId', 'StateName', 'StateRank', 'Name', 'Status', 'IsModelLevel', 'IsDefault', 'UpdatedDate' ],
										columnFilter        : {},
										toggleFilterProps   : {},
										topIndex            : 0,
										showFilterRow       : false,
										sortColumn          : {'UpdatedDate': false},
										itemActions         : [
																						{ id: 'view', label: 'ACTIONS.VIEW', icon: 'icon-magnify', privilege: 'GetArticleStatesList', disabled: false, visible: true },
																						{ id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UpdateArticleState', disabled: false, visible: true },
																						{ id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateArticleStateStatus', disabled: false, visible: 'itm.Status',
																								requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
																						{ id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateArticleStateStatus', disabled: false, visible: '!itm.Status',
																								requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'},
																						],
										listActions         : [
																						{ id: 'delete', label: 'ACTIONS.DELETE_BULK', icon: 'icon-delete', privilege: 'UpdateArticleStateStatus', disabled: '{selected: true, Status: 1}', visible: true,
																								requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
																						{ id: 'activate', label: 'ACTIONS.ACTIVATE_BULK', icon: 'icon-undo-variant', privilege: 'UpdateArticleStateStatus', disabled: '{selected: true, Status: 0}', visible: true,
																								requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'},
																						],
										fabAction           : {id: 'add', label: 'ACTIONS.ADD', icon: 'icon-plus', privilege: 'CreateNewArticleState', visible: true}
								},
								mainDetails: {
										selectedTabIndex   : 0,
										itemActions        : [
																						{ id: 'delete', label: 'ACTIONS.DELETE', icon: 'icon-delete', privilege: 'UpdateArticleStateStatus', disabled: '{selected: true, Status: 1}',
																								visible: true, requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, confirmationAction: 'ACTIONS.DELETE'},
																						{ id: 'activate', label: 'ACTIONS.ACTIVATE', icon: 'icon-undo-variant', privilege: 'UpdateArticleStateStatus', disabled: '{selected: true, Status: 0}',
																								visible: true, requiresConfirmation: true, confirmationContent: {title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_ACTIVATE'}, confirmationAction: 'ACTIONS.ACTIVATE'},
																				],
										fab                 : {id: 'edit', label: 'ACTIONS.EDIT', icon: 'icon-pencil', privilege: 'UpdateArticleState', visible: true}
								},
								privileges: {
										list: 'GetArticleStatesList',
										details: 'GetArticleStatesList'
								}
						}
				};

				function getArticleStates(generalProperties, sellerId, attributeGroupId) {
						var promise;
						var activeCatalog = catalogFactory.getActiveCatalog();
						var sellerId = angular.isDefined(sellerId) ? sellerId : activeCatalog.AccountId;
						var attributeGroupId = angular.isDefined(attributeGroupId) ? attributeGroupId : activeCatalog.AttributeGroupId;

						if(angular.isDefined(generalProperties.isLogRequired) && generalProperties.isLogRequired === true) {
								var state = {};
								state.name = $state.current.name;
								state.params = $state.params;
								var isBulk = true;
								var logData = activityLogger.createLogData(null, state, 'catalogs.articleStates', 'VIEW', isBulk, new Date(), null, null);
								promise = api.webGet(api.baseUrl + '/sellers/' + sellerId + '/attributegroups/' + attributeGroupId +'/articlestates', undefined, true, generalProperties.forceFetch);
								promise = activityLogger.log(logData, promise);
						}
						else {
								promise = api.webGet(api.baseUrl + '/sellers/' + sellerId + '/attributegroups/' + attributeGroupId +'/articlestates', undefined, true, generalProperties.forceFetch);
						}

						promise.then(function() {
								if (api.catalogs.articleStates.isDirty) {
										//Invalidate lookupData
										api.catalogs.articleStates.lookupData = undefined;
										api.catalogs.articleStates.isDirty = false;
								}
						});
						return promise;
				}

				function activateArticleStates(records, model, actionType, sellerId, attributeGroupId) {
						var result = crud.createRequestObject(records, model, actionType);
						var state = {};
						state.name = $state.current.name;
						state.params = $state.params;
						var isBulk = result.itemsNameList.length > 1 ? true : false;
						var logData = activityLogger.createLogData(result.itemsNameList, state, 'catalogs.articleStates', actionType.toUpperCase(), isBulk, new Date(), null, null);
						var promise = api.webPut(api.baseUrl + '/sellers/' + sellerId + '/attributegroups/' + attributeGroupId +'/articlestates/status', result.requestObj);

						promise.then(function() {
								crud.onRecordStatusChange(records, model, actionType);
						});

						return activityLogger.log(logData, promise);
				}

				function createArticleState(articleState, sellerId, attributeGroupId) {
						var state = {};
						state.name = $state.current.name;
						state.params = $state.params;
						var logData = activityLogger.createLogData(state[api.catalogs.articleStates.lookupDisplayField], state, 'catalogs.articleStates', 'ADD', false, new Date(), null, null);
						var promise = api.webPost(api.baseUrl + '/sellers/' + sellerId + '/attributegroups/' + attributeGroupId +'/articlestates', articleState);

						promise.then(function() {
								api.catalogs.articleStates.isDirty = true;
						});
						return activityLogger.log(logData, promise);
				}

				function updateArticleState(stateId, articleState, sellerId, attributeGroupId) {
						var state = {};
						state.name = $state.current.name;
						state.params = $state.params;
						var logData = activityLogger.createLogData(state[api.catalogs.articleStates.lookupDisplayField], state, 'catalogs.articleStates', 'EDIT', false, new Date(), null, null);
						var promise = api.webPut(api.baseUrl + '/sellers/' + sellerId + '/attributegroups/' + attributeGroupId +'/articlestates/' + stateId , articleState);

						promise.then(function() {
								api.catalogs.articleStates.isDirty = true;
						});
						return activityLogger.log(logData, promise);
				}

		}
})();
(function() {
    'use strict';

    angular
        .module('app.main')
        .directive('txVirtualRepeater', virtualRepeaterDirective);

    function virtualRepeaterDirective() {
        var directive = {
            bindToController: true,
            controller: txVirtualRepeaterController,
            controllerAs: 'vm',
            restrict: 'E',
            transclude: true,
            scope: {
                dataSource: '=txDataSource',
                scrollableContainer: '@txScrollableContainer',
                containerHeight: '=?txStyle',
                itemWidthStr: '=txItemWidth',
                itemHeightStr: '=txItemHeight',
                itemMarginStr: '=txItemMargin',
                onLoadMore: '&?txOnLoadMore'
            },
            templateUrl: 'app/directives/txVirtualRepeater/tx-virtual-repeater.html'
        };
        return directive;
    }

    /* @ngInject */
    function txVirtualRepeaterController ($window, $scope, $log, $timeout) {
        var vm = this;

        var container = angular.element(vm.scrollableContainer);
        if (angular.isUndefined(container) || container.length == 0) {
            $log.error('Unable to find the specified scrollableContainer: ' + vm.scrollableContainer);
            return;
        }


        var scrollableContainer = container[0];
        var resizeTimeoutPromise;
        var scrollTimeoutPromise;
        var updateImageSizeTimoutPromise;

        vm.itemWidth = parseInt(vm.itemWidthStr, 10);
        vm.itemHeight = parseInt(vm.itemHeightStr, 10);
        vm.itemMargin = parseInt(vm.itemMarginStr, 10);

        $window.addEventListener('resize', onResize);
        scrollableContainer.addEventListener('scroll', onScroll);

        var watchUnsubscriber = $scope.$watch('vm.dataSource', onDataSourceChange);

        var initialTimeout = $timeout(function() {
            onResize();
            onScroll();
        },500);

        function onResize() {
            // $timeout.cancel(resizeTimeoutPromise);
            // resizeTimeoutPromise = $timeout(function() {
                vm.pageHeight = scrollableContainer.offsetHeight;
                vm.pageWidth = scrollableContainer.offsetWidth;

                vm.itemsPerRow = Math.floor(vm.pageWidth / (vm.itemWidth + vm.itemMargin*2));
                vm.rowsPerPage = Math.floor(vm.pageHeight / (vm.itemHeight + vm.itemMargin*2));
                vm.itemsPerPage = (vm.itemsPerRow * vm.rowsPerPage);

                // Use content-based height (actual rows × row height) instead of viewport height
                // to avoid blank space within each page div
                vm.contentPageHeight = vm.rowsPerPage * (vm.itemHeight + vm.itemMargin * 2);
                vm.pageStyle = 'width: ' + vm.pageWidth + 'px; height: ' + vm.contentPageHeight + 'px;';
                vm.itemStyle = 'width: ' + vm.itemWidth + 'px; height: ' + vm.itemHeight + 'px; margin: ' + vm.itemMargin + 'px;';
                $timeout.cancel(resizeTimeoutPromise);
                resizeTimeoutPromise = $timeout(function() {
                    onDataSourceChange();
                },100);
            // }, 500);
        }

        function onScroll() {
            var newPage = Math.floor(scrollableContainer.scrollTop / (vm.contentPageHeight || vm.pageHeight)) + 1;
            if (newPage != vm.currentPage) {

                $timeout.cancel(scrollTimeoutPromise);
                scrollTimeoutPromise = $timeout(function() {
                    vm.currentPage = newPage;
                },100);
            }

            // Near-bottom detection for load-more (works even when all items fit in one page)
            if (vm.onLoadMore && !vm.isLoadingMore) {
                var scrollBottom = scrollableContainer.scrollTop + scrollableContainer.clientHeight;
                if (scrollBottom >= scrollableContainer.scrollHeight - 200) {
                    vm.isLoadingMore = true;
                    $scope.$apply(function() {
                        vm.onLoadMore();
                    });
                }
            }
        }

        function onDataSourceChange() {
            if(vm.itemsPerPage && vm.itemsPerPage != 0) {
                var newTotalItems = (angular.isDefined(vm.dataSource) && angular.isArray(vm.dataSource) ? vm.dataSource.length : 0);
                var newTotalPages = Math.ceil(newTotalItems / vm.itemsPerPage);

                // Skip duplicate calls where data hasn't changed
                if (angular.isDefined(vm.totalItems) && newTotalItems === vm.totalItems) {
                    vm.isLoadingMore = false;
                    return;
                }

                var isAppending = angular.isDefined(vm.totalItems) && vm.totalItems > 0 && newTotalItems > vm.totalItems && vm.pages && vm.pages.length > 0;

                if (isAppending) {
                    var currentItemIndex = vm.totalItems;

                    // Fill remaining slots in the last existing page
                    var oldLastPage = vm.pages[vm.pages.length - 1];
                    if (oldLastPage && oldLastPage.items.length < vm.itemsPerPage) {
                        var filledItems = oldLastPage.items.slice();
                        while (filledItems.length < vm.itemsPerPage && currentItemIndex < newTotalItems) {
                            filledItems.push(vm.dataSource[currentItemIndex]);
                            currentItemIndex++;
                        }
                        vm.pages[vm.pages.length - 1] = {items: filledItems};
                    }

                    // Add new pages for remaining items
                    while (currentItemIndex < newTotalItems) {
                        var pageItems = [];
                        for (var k = 0; k < vm.itemsPerPage && currentItemIndex < newTotalItems; k++, currentItemIndex++) {
                            pageItems.push(vm.dataSource[currentItemIndex]);
                        }
                        vm.pages.push({items: pageItems});
                    }
                } else {
                    var newPages = [];
                    for (var i = 0; i < newTotalPages; i++) {
                        var items = [];
                        for (var j = 0; j < vm.itemsPerPage; j++) {
                            var data = vm.dataSource[i*vm.itemsPerPage+j];
                            if(data) {
                                items.push(data);
                            }
                        }
                        newPages.push({items: items});
                    }
                    vm.pages = newPages;
                }

                vm.totalItems = newTotalItems;
                vm.totalPages = newTotalPages;
                vm.isLoadingMore = false;

                var lastPage = vm.pages[vm.pages.length - 1];
                var lastPageRows = lastPage ? Math.ceil(lastPage.items.length / vm.itemsPerRow) : 0;
                vm.lastPageStyle = 'width: ' + vm.pageWidth + 'px; height: ' + (lastPageRows * (vm.itemHeight + vm.itemMargin * 2)) + 'px;';
            }
            else {
                $log.warn('Inside trasix virtual repeater, itemsPerPage cannot be 0');
            }
        }

        var ImageSizeChangeEventCleanup = $scope.$on('ImageSizeChangeEvent', function() {
            updateImageSizeTimoutPromise = $timeout(function(){
                vm.itemWidth = parseInt(vm.itemWidthStr, 10);
                vm.itemHeight = parseInt(vm.itemHeightStr, 10);
                vm.itemMargin = parseInt(vm.itemMarginStr, 10);
                onResize();
            });
        });

        $scope.$on('$destroy', function () {
            $window.removeEventListener('resize', onResize);
            scrollableContainer.removeEventListener('scroll', onScroll);
            watchUnsubscriber();
            $timeout.cancel(resizeTimeoutPromise);
            $timeout.cancel(scrollTimeoutPromise);
            $timeout.cancel(initialTimeout);
            $timeout.cancel(updateImageSizeTimoutPromise);
            ImageSizeChangeEventCleanup();

        });
    }
})();
    (function () {
        'use strict';

        angular
            .module('app.main')
            .directive('txUiGrid', txUiGridDirective);

        function txUiGridDirective() {
            var directive = {
                bindToController: true,
                controller: txUiGridController,
                controllerAs: 'vm',
                restrict: 'E',
                scope: {
                    field: '=txField',
                    data: '=txData',
                    isNew: '=txNew',
                    editable: '=txEditable'
                },
                templateUrl: 'app/directives/txUiGrid/tx-ui-grid.html'
            };
            return directive;
        }

        /* @ngInject */
        function txUiGridController($scope, $element, $timeout, $compile, uiGridConstants, $q, api, utility) {
            var vm = this;
            vm.gridOptions = {};
            vm.existingData = angular.copy(vm.data)

            $scope.$parent.boolFilter = function(value) {
                if (value === true || value === 'true' || value === '1' || value === 1) {
                    return 'True';
                } else if (value === false || value === 'false' || value === '0' || value === 0) {
                    return 'False';
                }
                return value;
            };


            vm.getOptionsForDropdown = function(fieldName, rowEntity) {
                var options = getVettingListOptions(fieldName, rowEntity);
                var dropdownOptions = [];
                var isRequired = false;
                var columnDef = null;
                if (vm.gridOptions && vm.gridOptions.columnDefs) {
                    columnDef = vm.gridOptions.columnDefs.find(function(col) {
                        return col.field === fieldName;
                    });
                    if (columnDef) {
                        isRequired = columnDef.isRequired === true;
                    }
                }
                if (!isRequired) {
                    dropdownOptions.push({
                        value: '',
                        label: ''
                    });
                }

                if (angular.isArray(options)) {
                    options.forEach(function(item) {
                        if (typeof item === 'object' && item !== null) {
                            dropdownOptions.push({
                                value: item.Id || item.Value || item.value,
                                label: item.DisplayValue || item.Value || item.value || item.Id || item.id
                            });
                        }
                        else {
                            dropdownOptions.push({
                                value: item,
                                label: item
                            });
                        }
                    });
                }
                return dropdownOptions;
            };

            vm.getDisplayValue = function(fieldName, value, rowEntity) {
                var options = vm.getOptionsForDropdown(fieldName, rowEntity);

                if (options && options.length > 0) {
                    var found = options.find(function(item) {
                        return item.value == value;
                    });
                    return found ? found.label : value;
                }
                if (value && typeof value === 'object') {
                    return value.DisplayValue || value.Value || value.value || JSON.stringify(value);
                }
                return value;
            };

            function getVettingListOptions(fieldName, rowEntity) {
                var criteriaList = vm.criteriaV2[fieldName];
                var defaultOptions = vm.field.valuesV2 ? vm.field.valuesV2[fieldName] || [] : [];
                var getDependentValue = function(dependentField) {
                    return rowEntity ? rowEntity[dependentField] : null;
                };
                if (criteriaList && criteriaList.length && rowEntity) {
                    // CriteriaV2 (preferred): AllowedValues of the matched rule, or [] (strict) when no rule matches
                    return utility.getCriteriaV2AllowedValues(criteriaList, getDependentValue);
                }
                if (vm.oldCriteriaMap[fieldName] && rowEntity) {
                    // OLD Criteria fallback (when CriteriaV2 is absent)
                    return utility.getOldCriteriaAllowedValues(vm.oldCriteriaMap[fieldName], defaultOptions, getDependentValue);
                }
                return defaultOptions;
            }

            // Handle criteria change and validation for the specific row and changed attribute.
            vm.handleDependentAttributeChange = function(rowEntity, changedColField) {
                var attributesToUpdate = [];
                dataTableAttributesDetails.forEach(function(attr) {
                    var fieldName = attr.AttributeSystemName;
                    var criteriaList = vm.criteriaV2[fieldName];

                    if (criteriaList) {
                        criteriaList.forEach(function(criteria) {
                            if (criteria[changedColField]) {
                                if (attributesToUpdate.indexOf(fieldName) === -1) {
                                    attributesToUpdate.push(fieldName);
                                }
                            }
                        });
                    }
                });

                attributesToUpdate.forEach(function(depField) {
                    var currentValue = rowEntity[depField];
                    var allowedOptions = getVettingListOptions(depField, rowEntity);
                    var allowedValues = allowedOptions.map(function(opt) {
                        return (typeof opt === 'object' && opt !== null) ? (opt.Id || opt.Value || opt.value) : opt;
                    });
                    if (currentValue !== undefined && currentValue !== null && allowedValues.indexOf(currentValue) === -1) {
                        rowEntity[depField] = '';
                    }
                });

                if (attributesToUpdate.length > 0) {
                    vm.gridApi.core.notifyDataChange(uiGridConstants.dataChange.EDIT);
                }
            };


            vm.gridApi = null;
            vm.gridData = [];
            vm.form = {};

            vm.datasetFieldConfigs = {};
            vm.criteriaV2 = vm.field.criteriaV2 || {};
            vm.oldCriteriaMap = {}; // AttributeSystemName -> parsed OLD Criteria (fallback when CriteriaV2 absent)
            var dataTableAttributesDetails = vm.field.dataTableAttributesDetails;

            activate();

            function activate() {
                initGrid();
            }

            function initGrid() {
                if(!dataTableAttributesDetails && vm.field.DataTableAttributes.length) {
                    if(api.allAttributesListMap && Object.keys(api.allAttributesListMap).length > 0) {
                        dataTableAttributesDetails = vm.field.DataTableAttributes.map(function(attrId) {
                            return api.allAttributesListMap[attrId];
                        }).filter(function(attr) {
                            return attr !== undefined;
                        })
                    }
                }
                if (!dataTableAttributesDetails || !dataTableAttributesDetails.length) {
                    console.warn('txUiGrid: No dataTableAttributesDetails found');
                    return;
                }

                // parse OLD Criteria for data-table attributes that have it but no CriteriaV2 (fallback)
                dataTableAttributesDetails.forEach(function(attr) {
                    if (attr && angular.isDefined(attr.Criteria) && attr.Criteria && attr.Criteria.length > 0 &&
                        !(attr.CriteriaV2 && attr.CriteriaV2.length > 0)) {
                        try {
                            vm.oldCriteriaMap[attr.AttributeSystemName] = JSON.parse(attr.Criteria);
                        } catch (e) {
                            console.warn((attr.AttributeDisplayName || attr.AttributeSystemName) + ' - Attribute Criteria: Invalid JSON format');
                        }
                    }
                });

                createGridOptions();
                loadGridData();
                $timeout(setupRowWatchers, 0);
            }

            function createGridOptions() {
                vm.gridOptions = {
                    onRegisterApi: function(gridApi) {
                        vm.gridApi = gridApi;

                        gridApi.core.on.rowsRendered($scope, function() {
                            setupRowWatchers();
                        });

                        gridApi.core.on.filterChanged($scope, function() {
                            $timeout(function() {
                                gridApi.core.notifyDataChange(uiGridConstants.dataChange.ALL);
                            });
                        });

                        gridApi.edit.on.afterCellEdit($scope, function(rowEntity, colDef, newValue, oldValue) {
                            if (!vm.editable) {
                                return;
                            }
                            vm.handleDependentAttributeChange(rowEntity, colDef.field);
                            saveGridData();
                        });

                        gridApi.core.on.rowsRendered($scope, function() {
                            $timeout(function() {
                                if (vm.gridApi && vm.gridApi.core) {
                                    vm.gridApi.core.handleWindowResize();
                                }
                            });
                        });

                        $timeout(function() {
                            if (vm.gridApi && vm.gridApi.grid) {
                                vm.gridApi.grid.refresh();
                            }
                        }, 200);
                    },
                    enableCellEdit: vm.editable === true,
                    enableCellEditOnFocus: vm.editable === true,
                    enableColumnMenus: false,
                    enableSorting: true,
                    enableFiltering: true,
                    enableGridMenu: false,
                    enableRowSelection: false,
                    enableRowHeaderSelection: false,
                    enableFullRowSelection: false,
                    enableHorizontalScrollbar: 2,
                    enableVerticalScrollbar: 2,
                    rowHeight: 35,
                    columnDefs: createColumnDefs(),
                    data: vm.gridData,
                    enablePinning: true,
                    useExternalSorting: false,
                    useExternalFiltering: false,
                };
            }

            function setupRowWatchers() {
                if (!vm.gridData) return;
                if (vm._watchInitialized) return;

                vm.gridData.forEach(function (row, index) {
                    $scope.$watchCollection(
                        function () { return vm.gridData[index]; },
                        function (newVal, oldVal) {
                            if (newVal !== oldVal) {
                                saveGridData();
                            }
                        }
                    );
                });

                vm._watchInitialized = true;
            }

            function createColumnDefs() {
                var columnDefs = [];

                if (!dataTableAttributesDetails) {
                    return columnDefs;
                }

                dataTableAttributesDetails.forEach(function(attribute, index) {
                    if (!attribute.AttributeSystemName) {
                        console.warn('Attribute missing AttributeSystemName:', attribute);
                        return;
                    }

                    var inputType = getInputTypeForAttribute(attribute);
                    var filterConfig = getFilterConfig(inputType, attribute);
                    var isRequired = !!attribute.IsRequired;
                    var fieldName = attribute.AttributeSystemName;
                    var displayName = attribute.AttributeDisplayName || attribute.AttributeSystemName;
                    if (isRequired) {
                        displayName = displayName + ' *';;
                    }

                    var columnDef = {
                        name: attribute.AttributeSystemName,
                        displayName: displayName,
                        field: attribute.AttributeSystemName,
                        enableCellEdit: vm.editable === true,
                        enableCellEditOnFocus: vm.editable === true,
                        width: attribute.MaxLength && attribute.MaxLength > 50 ? 250 : 150,
                        minWidth: 100,
                        maxWidth: 400,
                        cellTemplate: getCellTemplate(inputType, attribute),
                        editableCellTemplate: getEditableCellTemplate(inputType, attribute),
                        cellFilter: getCellFilter(inputType),
                        type: getColumnType(inputType),
                        enableSorting: true,
                        suppressRemoveSort: true,
                        sortDirectionCycle: [null, 'asc', 'desc'],
                        enableFiltering: true,
                        enableColumnMenu: false,
                        filter: filterConfig,
                        attribute: angular.copy(attribute),
                        isRequired: isRequired,
                        cellClass: function(grid, row, col, rowRenderIndex, colRenderIndex) {
                            var classes = [];
                            if (inputType === 'bool-str') {
                                classes.push('text-center');
                            }
                            if (isRequired && row && row.entity) {
                                var value = row.entity[fieldName];
                                var isEmpty = false;
                                if (value === null || value === undefined || value === '') {
                                    isEmpty = true;
                                } else if (inputType === 'bool-str') {
                                    if (value === false) {
                                        isEmpty = true;
                                    }
                                } else if (inputType === 'number' || inputType === 'decimal') {
                                    if (value === 0 || value === 0.0) {
                                        isEmpty = true;
                                    }
                                }

                                if (isEmpty) {
                                    classes.push('required-cell-invalid');
                                }
                            }
                            return classes.join(' ');
                        }
                    };

                    if (inputType === 'list') {
                        columnDef.editDropdownOptionsFunction = function(rowEntity, colDef) {
                            return vm.getOptionsForDropdown(colDef.field, rowEntity);
                        };
                        columnDef.editableCellTemplate = 'ui-grid/dropdownEditor';
                        columnDef.editDropdownIdLabel = 'value';
                        columnDef.editDropdownValueLabel = 'label';

                    } else if (inputType === 'bool-str') {
                        columnDef.cellClass = 'text-center';
                        columnDef.type = 'boolean';
                        columnDef.cellFilter = 'boolFilter';
                        columnDef.editableCellTemplate = 'ui-grid/dropdownEditor';
                        columnDef.editDropdownOptionsArray = [
                            { value: true, label: 'True' },
                            { value: false, label: 'False' }
                        ];
                        columnDef.editDropdownIdLabel = 'value';
                        columnDef.editDropdownValueLabel = 'label';

                    } else if (inputType === 'number' || inputType === 'decimal') {
                        columnDef.type = 'number';
                        columnDef.cellFilter = 'number';
                    } else if (inputType === 'dataset') {
                        vm.datasetFieldConfigs[attribute.AttributeSystemName] = createDatasetFieldConfig(attribute);

                        columnDef.filter = {
                            term: '',
                            placeholder: 'Filter...',
                            type: uiGridConstants.filter.INPUT,
                            condition: function(searchTerm, cellValue, row, col) {
                                if (!searchTerm || searchTerm.trim() === '') return true;
                                if (!cellValue) return false;

                                var displayValue = '';
                                if (cellValue && typeof cellValue === 'object') {
                                    displayValue = cellValue.DisplayValue || cellValue.Value ||
                                                cellValue.display || cellValue.value ||
                                                JSON.stringify(cellValue);
                                } else if (cellValue) {
                                    displayValue = cellValue.toString();
                                }

                                return displayValue.toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1;
                            }
                        };
                        delete columnDef.filterValueGetter;
                    }

                    columnDefs.push(columnDef);
                });

                // actions column
                if(vm.editable) {
                    columnDefs.push({
                        name: 'actions',
                        displayName: 'Actions',
                        field: 'actions',
                        enableCellEdit: false,
                        enableSorting: false,
                        enableFiltering: false,
                        width: 80,
                        minWidth: 80,
                        cellClass: 'text-center',
                        pinnedRight: true,
                        enableColumnMenu: false,
                        cellTemplate:
                            '<div class="ui-grid-cell-contents action-buttons">' +
                            '  <md-button class="md-secondary" ' +
                            '             ng-click="grid.appScope.vm.deleteRow(row)" ' +
                            '             title="Delete Row">' +
                            '    <md-icon md-font-icon="icon-delete"></md-icon>' +
                            '  </md-button>' +
                            '</div>'
                    });
                }

                return columnDefs;
            }

            function getFilterConfig(inputType, attribute) {
                switch (inputType) {
                    case 'bool-str':
                        return {
                            term: '',
                            placeholder: 'Select...',
                            type: uiGridConstants.filter.SELECT,
                            selectOptions: [
                                { value: true, label: 'True' },
                                { value: false, label: 'False' }
                            ],
                            condition: uiGridConstants.filter.EXACT
                        };

                    case 'number':
                    case 'decimal':
                        return {
                            term: '',
                            placeholder: 'Filter...',
                            type: uiGridConstants.filter.INPUT,
                            condition: uiGridConstants.filter.EXACT
                        };

                    default:
                        return {
                            term: '',
                            placeholder: 'Filter...',
                            type: uiGridConstants.filter.INPUT,
                            condition: uiGridConstants.filter.CONTAINS
                        };
                }
            }

            vm.sortColumn = function(col) {
                if (!vm.gridApi) return;
                var currentDirection = col.sort && col.sort.direction;
                var newDirection = null;

                if (!currentDirection) {
                    newDirection = 'asc';
                } else if (currentDirection === 'asc') {
                    newDirection = 'desc';
                } else {
                    newDirection = null;
                }

                vm.gridApi.core.clearAllSorting();

                if (newDirection) {
                    vm.gridApi.sort.sortColumn(col, newDirection);
                }
            };

            function getInputTypeForAttribute(attribute) {
                if (!attribute.AttributeTypeName) {
                    return 'text';
                }

                var attributeType = attribute.AttributeTypeName.toUpperCase();
                var fieldName = attribute.AttributeSystemName;

                if (vm.criteriaV2 && vm.criteriaV2[fieldName]) {
                    return 'list';
                }
                if (vm.field.valuesV2 && vm.field.valuesV2[fieldName]) {
                    return 'list';
                }
                if (attributeType === 'INT') {
                    return 'number';
                }
                else if (attributeType === 'BOOL') {
                    return 'bool-str';
                }
                else if (attributeType === 'DECIMAL') {
                    return 'decimal';
                }
                else if (attributeType === 'NVARCHAR') {
                    if (attribute.MaxLength && attribute.MaxLength > 100) {
                        return 'textarea';
                    }
                    return 'text';
                }
                else if (attributeType === 'DATE' || attributeType === 'DATETIME') {
                    return 'date';
                }
                else if (attributeType === 'DATASET') {
                    return 'dataset';
                }

                return 'text';
            }

            function createDatasetFieldConfig(attribute) {
                return {
                    field: attribute.AttributeSystemName,
                    displayLabel: attribute.AttributeDisplayName || attribute.AttributeSystemName,
                    AttributeSystemName: attribute.AttributeSystemName,
                    AttributeDisplayName: attribute.AttributeDisplayName || attribute.AttributeSystemName,
                    AttributeTypeName: 'DATASET',
                    datasetId: attribute.DatasetId,
                    // tx-ui-grid is only used by catalog article/model grids (never seller-models),
                    // so dataset values from the inline grid editor are always catalog-scoped.
                    isCatalogScoped: true,
                    validation: {
                        isRequired: false,
                        disabledCriteria: false
                    }
                };
            }

            function getCellTemplate(inputType, attribute) {
                if (inputType === 'dataset') {
                    return '<div class="ui-grid-cell-contents dataset-cell">' +
                        '  <span ng-if="row.entity[col.field] && row.entity[col.field].DisplayValue">' +
                        '    {{row.entity[col.field].DisplayValue}}' +
                        '  </span>' +
                        '  <span ng-if="!row.entity[col.field] || !row.entity[col.field].DisplayValue" class="text-muted">' +
                        '    Click to select...' +
                        '  </span>' +
                        '</div>';
                }
                else if (inputType === 'bool-str') {
                    return '<div class="ui-grid-cell-contents text-center">' +
                        '  <span ng-if="row.entity[col.field]">True</span>' +
                        '  <span ng-if="!row.entity[col.field]">False</span>' +
                        '</div>';
                }
                else if (inputType === 'list') {
                    return '<div class="ui-grid-cell-contents">' +
                        '{{grid.appScope.vm.getDisplayValue(col.field, row.entity[col.field], row.entity)}}' +
                        '</div>';
                }

                return null;
            }

            function getEditableCellTemplate(inputType, attribute) {
                switch(inputType) {
                    case 'bool-str':
                        return 'ui-grid/dropdownEditor';
                    case 'number':
                    case 'decimal':
                        return '<div><input ui-grid-editor type="number" ng-class="\'colt\' + col.uid" ng-model="MODEL_COL_FIELD" style="width: 100%;"></div>';
                    case 'date':
                        return '<div><input ui-grid-editor type="date" ng-class="\'colt\' + col.uid" ng-model="MODEL_COL_FIELD" style="width: 100%;"></div>';
                    case 'list':
                        return 'ui-grid/dropdownEditor';
                    case 'dataset':
                        return '<div class="dataset-cell-editor" style="width: 100%; height: 100%; padding: 5px 0;">' +
                            '  <div dataset-editor-handler class="ui-grid-editor"></div>' +
                            '</div>';
                    case 'textarea':
                        return '<div><textarea ui-grid-editor ng-class="\'colt\' + col.uid" ' +
                                'ng-model="MODEL_COL_FIELD" ' +
                                'style="width: 100%; height: 60px; resize: vertical; padding: 5px;">' +
                                '</textarea></div>';
                    default:
                        return '<div><input ui-grid-editor type="text" ng-class="\'colt\' + col.uid" ng-model="MODEL_COL_FIELD" style="width: 100%;"></div>';
                }
            }

            function getCellFilter(inputType) {
                switch(inputType) {
                    case 'bool-str':
                        return null;
                    case 'number':
                    case 'decimal':
                        return 'number';
                    case 'date':
                        return 'date:"MMM d, y"';
                    default:
                        return null;
                }
            }

            function getColumnType(inputType) {
                switch(inputType) {
                    case 'bool-str':
                        return 'boolean';
                    case 'number':
                    case 'decimal':
                        return 'number';
                    case 'date':
                        return 'date';
                    case 'dataset':
                        return 'object';
                    default:
                        return 'string';
                }
            }

            function loadGridData() {
                vm.gridData = [];

                if (vm.existingData && vm.existingData[vm.field.field]) {
                    try {
                        var existingDataTable = angular.isString(vm.existingData[vm.field.field])
                            ? JSON.parse(vm.existingData[vm.field.field])
                            : vm.existingData[vm.field.field];

                        if (angular.isArray(existingDataTable)) {
                            existingDataTable.forEach(function(row, index) {
                                var rowDataItem = angular.copy(row);
                                rowDataItem.id = index + 1;

                                dataTableAttributesDetails.forEach(function(attribute) {
                                    var fieldName = attribute.AttributeSystemName;
                                    if (fieldName && rowDataItem[fieldName] !== undefined) {
                                        var inputType = getInputTypeForAttribute(attribute);
                                        if (inputType === 'bool-str') {
                                            var val = rowDataItem[fieldName];
                                            rowDataItem[fieldName] =
                                                (val === true || val === 'true' || val === '1' || val === 1);
                                        }
                                        else if (inputType === 'dataset') {
                                            rowDataItem[fieldName] = normalizeDatasetValue(rowDataItem[fieldName]);
                                            vm.datasetFieldConfigs[attribute.AttributeSystemName] = createDatasetFieldConfig(attribute);
                                        }
                                        else if (inputType === 'date') {
                                            rowDataItem[fieldName] = parseDateValue(rowDataItem[fieldName]);
                                        }
                                    }
                                });

                                vm.gridData.push(rowDataItem);
                            });
                        }
                    } catch(error) {
                        console.warn("Unable to parse datatable data:", error);
                        vm.gridData.push(createEmptyRow());
                    }
                }

                if (vm.isNew || vm.gridData.length === 0) {
                    vm.gridData.push(createEmptyRow());
                }

                if (vm.gridOptions) {
                    vm.gridOptions.data = vm.gridData;
                }

                if (vm.gridApi) {
                    vm.gridApi.core.notifyDataChange(uiGridConstants.dataChange.ALL);
                }
            }

            function normalizeDatasetValue(value) {
                if (!value) return '';

                if (typeof value === 'string') {
                    try {
                        var parsed = JSON.parse(value);
                        if (parsed && (parsed.Id || parsed.DisplayValue)) {
                            return parsed;
                        } else {
                            return { DisplayValue: value };
                        }
                    } catch (e) {
                        return { DisplayValue: value };
                    }
                }
                else if (value && typeof value === 'object') {
                    if (!value.DisplayValue) {
                        var displayValue = value.DisplayValue || value.display ||
                            value.Value || value.value ||
                            Object.values(value)[0] || '';
                        return {
                            Id: value.Id || value.id || Object.keys(value)[0],
                            DisplayValue: displayValue
                        };
                    }
                    return value;
                }
                return '';
            }

            // convert a stored date value into a Date object the date editor/filter can use
            function parseDateValue(value) {
                if (value === null || value === undefined || value === '') {
                    return '';
                }
                if (angular.isDate(value)) {
                    return value;
                }
                if (angular.isString(value)) {
                    // treat a plain "yyyy-MM-dd" as a local date to avoid a timezone day-shift
                    var dateOnly = /^(\d{4})-(\d{2})-(\d{2})/.exec(value);
                    if (dateOnly) {
                        return new Date(+dateOnly[1], (+dateOnly[2]) - 1, +dateOnly[3]);
                    }
                    var parsed = new Date(value);
                    return isNaN(parsed.getTime()) ? '' : parsed;
                }
                return '';
            }

            // serialize a date cell the same way the rest of the app handles date-without-time
            // attributes: noon-adjust for timezone and keep only the date part ("yyyy-MM-dd")
            function formatDateForSave(value) {
                if (!angular.isDate(value)) {
                    return value || '';
                }
                var d = new Date(value.getTime());
                return new Date(d.setHours(12 - (d.getTimezoneOffset() / 60), 0, 0)).toISOString().split('T', 1)[0];
            }

            function createEmptyRow() {
                var newRow = {
                    id: Date.now() + Math.random(),
                    isNew: true
                };

                dataTableAttributesDetails.forEach(function(attribute) {
                    if (attribute.AttributeSystemName) {
                        var inputType = getInputTypeForAttribute(attribute);
                        var defaultValue = '';

                        switch(inputType) {
                            case 'bool-str':
                                defaultValue = false;
                                break;
                            case 'number':
                                defaultValue = 0;
                                break;
                            case 'decimal':
                                defaultValue = 0.0;
                                break;
                            case 'date':
                                // keep empty so an untouched date column isn't treated as a
                                // non-default value (which would force an otherwise-empty row to save)
                                defaultValue = '';
                                break;
                            case 'dataset':
                                defaultValue = '';
                                break;
                            default:
                                defaultValue = '';
                        }

                        newRow[attribute.AttributeSystemName] = defaultValue;
                    }
                });

                return newRow;
            }

            vm.getOptions = function(fieldName) {
                return vm.field.valuesV2 ? vm.field.valuesV2[fieldName] || [] : [];
            };


            vm.deleteRow = function(row) {
                if (!vm.gridData) return;
                var index = vm.gridData.indexOf(row.entity);
                if (index > -1) {
                    vm.gridData.splice(index, 1);
                    if (vm.gridData.length === 0) {
                        vm.gridData.push(createEmptyRow());
                    }
                    saveGridData();
                    if (vm.gridApi) {
                        vm.gridApi.core.notifyDataChange(uiGridConstants.dataChange.ALL);
                    }
                }
            };

            vm.addRow = function() {
                if (!vm.gridData) {
                    vm.gridData = [];
                }
                vm.gridData.push(createEmptyRow());
                saveGridData();
                if (vm.gridApi) {
                    vm.gridApi.core.notifyDataChange(uiGridConstants.dataChange.ALL);
                    $timeout(function() {
                        if (vm.gridApi && vm.gridApi.grid) {
                            vm.gridApi.grid.renderContainers.body.grid.element[0].scrollTop =
                                vm.gridApi.grid.renderContainers.body.grid.element[0].scrollHeight;
                        }
                    }, 100);
                }
            };

            function isDefaultValue(inputType, value) {
                if (value === null || value === undefined || value === '') return true;

                switch (inputType) {
                    case 'bool-str':
                        return value === false;
                    case 'number':
                    case 'decimal':
                        return value === 0 || value === 0.0;
                    case 'dataset':
                        return !value;
                    default:
                        return value === '';
                }
            }

            function saveGridData() {
                if (!vm.gridData || !vm.data || !vm.field) return;

                var cleanedRows = [];
                vm.gridData.forEach(function(row) {
                    var rowHasAnyNonDefault = false;
                    var rowIsValid = true;
                    var gridRow = {};
                    dataTableAttributesDetails.forEach(function(attribute) {
                        var fieldName = attribute.AttributeSystemName;
                        if (!fieldName) return;
                        var inputType = getInputTypeForAttribute(attribute);
                        var val = row[fieldName];
                        if (!isDefaultValue(inputType, val)) {
                            rowHasAnyNonDefault = true;
                        }
                        if (attribute.IsRequired) {
                            if (val === null || val === undefined || val === '') {
                                rowIsValid = false;
                            }
                        }
                        if (val !== undefined) {
                            if (inputType === 'bool-str') {
                                gridRow[fieldName] = val ? 'true' : 'false';
                            } else if (inputType === 'dataset' && val) {
                                if (typeof val === 'object') {
                                    gridRow[fieldName] = val.Id ? val.Id.toString() : null;
                                } else {
                                    gridRow[fieldName] = val.toString() || '';
                                }
                            } else if (inputType === 'date') {
                                gridRow[fieldName] = formatDateForSave(val);
                            } else {
                                gridRow[fieldName] = val;
                            }
                        }
                    });
                    if (rowHasAnyNonDefault && rowIsValid) {
                        cleanedRows.push(gridRow);
                    }
                });

                vm.data[vm.field.field] = cleanedRows;
            }

            $scope.$watch('vm.field.dataTableAttributesDetails', function(newVal) {
                if (newVal && newVal.length) {
                    $timeout(function() {
                        initGrid();
                    }, 50);
                }
            }, true);

            $scope.$watch('vm.data[vm.field.field]', function(newVal, oldVal) {
                if (newVal !== oldVal && vm.gridApi && vm.gridApi.grid &&
                    vm.gridApi.grid.options.data.length === 0) {
                    loadGridData();
                }
            });

            angular.element(window).on('resize', function() {
                if (vm.gridApi) {
                    $timeout(function() {
                        vm.gridApi.core.handleWindowResize();
                    });
                }
            });

            $scope.$on('$destroy', function() {
                angular.element(window).off('resize');
            });
        }
    })();
(function () {
    'use strict';

    angular
        .module('app.main')
        .directive('datasetEditorHandler', datasetEditorHandler);

    /* @ngInject */
    function datasetEditorHandler($timeout, $compile) {
        var directive = {
            link: link,
            restrict: 'A', // Attribute
            require: '^?uiGrid' // Require UI-Grid
        };
        return directive;

        function link(scope, element, attrs, uiGridCtrl) {
            var vm = scope.grid.appScope.vm;
            var fieldName = scope.col.field;
            var datasetFieldConfig = vm.datasetFieldConfigs[fieldName];
            var modelAccessor = 'row.entity["' + fieldName + '"]';
            var template = '<tx-dataset-autocomplete ' +
                'tx-field="datasetFieldConfig" ' +
                'tx-data="row.entity" ' +
                'tx-form="vm.form"' +
                'tx-grid-view="true"'+
                '></tx-dataset-autocomplete>';
            var newScope = scope.$new(false);
            newScope.datasetFieldConfig = datasetFieldConfig;

            newScope.row.entity.tempDatasetValue = scope.row.entity[fieldName];

            var unwatch = newScope.$watch('row.entity.tempDatasetValue', function(newValue) {
                if (newValue !== undefined) {
                    scope.row.entity[fieldName] = newValue;
                    $timeout(function() {
                        if (scope.edit) {
                            scope.edit.endEdit();
                        }
                    }, 0);
                }
            }, true);

             var unbindEvent = scope.$on('datasetAttributeChanged', function(event, changedField) {
                 vm.handleDependentAttributeChange(scope.row.entity, changedField);
            });

            element.append($compile(template)(newScope));

            scope.$on('$destroy', function() {
                unwatch();
                unbindEvent();
                newScope.$destroy();
            });

            $timeout(function() {
                var selectElement = element.find('md-select');
                if (selectElement.length) {
                    selectElement[0].click();
                }
            }, 100);
        }
    }
})();
(function() {
	'use strict';

	angular
		.module('app.main')
		.directive('txParentModelTypeViewer', txParentModelTypeViewer);

	//Directive.$inject = ['dependency1'];
	function txParentModelTypeViewer() {
		var directive = {
			bindToController: true,
			controller: txParentModelTypeController,
			controllerAs: 'vm',
			restrict: 'E',
			scope: {
				field: '=txField',
				data: '=txData',
				isNew: '=txNew',
				visibleFields: '=txVisibleFields',
				isUpdateBulk: '=?txIsUpdateBulk'
			},
			templateUrl: 'app/directives/txParentModelTypeViewer/tx-parent-model-type-viewer.html'
		};
		return directive;
	}
	/* @ngInject */
	function txParentModelTypeController ($scope, utility, catalogFactory, api, $q) {
		var vm = this;
		vm.scope = $scope;
		vm.record = vm.data;
		vm.parentModelTypeField = utility.filterObject(vm.visibleFields, {field: 'parent_model_type'}, true)[0];
		var sellerId = catalogFactory.getActiveCatalog().AccountId;
		var attributeGroupId = catalogFactory.getActiveCatalog().AttributeGroupId;
		var sellerModels = [];
		vm.isAboveDropDownLimit = false;

		vm.searchText = '';
		vm.isLoading = false;

		vm.onParentModelTypeChange = onParentModelTypeChange;

		vm.lookupSearch = lookupSearch;
		vm.lookupChange = lookupChange;
		vm.getLookupDisplayValue = getLookupDisplayValue;
		vm.selectText = selectText;

		activate();

		function activate() {}

		function onParentModelTypeChange(modelType) {
			if(modelType.toLowerCase() !== 'parent' && !sellerModels.length) {
				loadSellerModels().then(function (sellerModelResponse) {
					sellerModels = sellerModelResponse;
				});
			} else {
				vm.record['MasterModelId'] = null;
				vm.record['ParentModelName'] = '';
			}
			$scope.$emit('parentModelTypeChanged', vm.parentModelTypeField.field)
		}

		function lookupSearch(query) {
			var results = [];
			var predicate = {};
			predicate['ModelNumber'] = query;

			if(sellerModels.length) {
					results = query ? utility.filterObject(sellerModels , predicate) :  sellerModels;
					// this is to reduce the rendering time. It was very slow and was impacted overall page responsiveness
					// so while displaying we will display only the first 100 records and user can filter with any value
					if(results.length > 100) {
							vm.isAboveDropDownLimit = true;
							return results.slice(0, 100);
					} else {
							vm.isAboveDropDownLimit = false;
							return results;
					}
			}
			else {
				return loadSellerModels().then(function() {
						results = query ? utility.filterObject(sellerModels , predicate) : sellerModels;
						// this is to reduce the rendering time. It was very slow and was impacted overall page responsiveness
						// so while displaying we will display only the first 100 records and user can filter with any value
						if(results.length > 100) {
								vm.isAboveDropDownLimit = true;
								return results.slice(0, 100);
						} else {
								vm.isAboveDropDownLimit = false;
								return results;
						}
				});
			}
	}

	function lookupChange(selectedValue) {
			if(angular.isObject(selectedValue)) {
					vm.record['MasterModelId'] = selectedValue['ModelId'];
					vm.record['ParentModelName'] = selectedValue['ModelName'];
					if(vm.isUpdateBulk) {
						vm.record['ParentModelNumber'] = selectedValue['ModelNumber'];
					}
			}
			else if(angular.isUndefined(selectedValue) || selectedValue === null) {
					vm.record['MasterModelId'] = undefined;
					vm.record['ParentModelName'] = '';
					if(vm.isUpdateBulk) {
						vm.record['ParentModelNumber'] = null;
					}
			}
			$scope.$emit('parentModelTypeChanged', vm.parentModelTypeField.field)
	}

	function getLookupDisplayValue(item) {
			if(sellerModels.length) {
					return getLookupDisplayVal(item);
			}
			else {
					return loadSellerModels().then(function() {
							return getLookupDisplayVal(item);
					});
			}
	}

	function getLookupDisplayVal(item) {
			var result;
			var predicate = {};
			if(angular.isObject(item)) {
					predicate['ModelId'] = item['ModelId'];
			}
			else {
					predicate['ModelId'] = item;
			}
			result = utility.filterObject(sellerModels, predicate, true)[0];

			if (angular.isArray(result) && result.length > 0) {
				return result[0].ModelNumber;
			}
			else {
				return result.ModelNumber;
			}
	}

		function loadSellerModels() {
			vm.isLoading = true;
			var generalProperties = {
				forceFetch: true,
				isLogRequired: false
			}
			var deferred = $q.defer();
			var promise = deferred.promise;
			api.lists.sellerModelsWithoutAttributes.methods.getList(generalProperties, sellerId, attributeGroupId)
				.then(function(response) {
					sellerModels = response.data;
					deferred.resolve(sellerModels);
				}).finally(function () {
					vm.isLoading = false;
				})
			return promise;
		}

		function selectText(event) {
			utility.selectInputText(event);
		}

	}
})();
(function() {
    'use strict';
     angular
        .module('app.main')
        .directive('txMatch', txMatch);

     /**
      * txMatch will compare value of 2 models
      */
    /** @ngInject */
    function txMatch() {
        var directive = {
             require: 'ngModel',
            scope: {
                otherModelValue: '=txMatch'
            },
            restrict: 'A',
            link: linkFunc,
        };

        return directive;

        function linkFunc(scope, element, attributes, ngModel) {
            ngModel.$validators.compareTo = function(modelValue) {
                return modelValue == scope.otherModelValue;
            };

            var watchUnsubscriber = scope.$watch("otherModelValue", function() {
                ngModel.$validate();
            });

            scope.$on('$destroy', function() {
                watchUnsubscriber();
            });
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('app.main')
        .directive('txLongTouch', txLongTouch);

    /**
     * @description: simulate long press for touch screens
     * its an attribute direcitve can be set on element as tx-long-touch which will register a call back method and if user hold the element for more than 500ms
     * it will execute the call back registered on tx-long-touch its can have optional attribute on-short-touch which will execute the registered method if user
     * release the touch before 500ms
     */
    /**ngInject */
    function txLongTouch($timeout) {
        var directive = {
            link: linkFunc,
            restrict: 'A'
        };
        return directive;

        function linkFunc(scope, element, attrs) {
            var longTouch;
            var shortTouch = true;
            var timeoutPromise;

            element.on('touchstart', function(ev) {
                ev.preventDefault();// stop click event
                longTouch = true
                timeoutPromise = $timeout(function() {
                    if (longTouch) {
                        shortTouch = false; // Prevent the tx-short-touch event from firing

                        // If the touchend event hasn't fired, apply the function given in on the element's tx-long-touch attribute
                        scope.$apply(function() {
                            scope.$eval(attrs.txLongTouch); // to avoid use of isolated scope
                        });
                    }
                }, 500);
            });

            element.on('touchend', function() {
                longTouch = false; // Prevent the tx-long-touch event from firing

                if(shortTouch) {
                    // If the touchend event has fired before executnig method registered on txLongTouch, apply the function given in on the element's tx-short-touch attribute
                    scope.$apply(function() {
                        scope.$eval(attrs.txShortTouch); // to avoid use of isolated scope
                    });
                }
                shortTouch = true;// to reinitialize shortTouch to true if it became false when user long touches
            });


            element.on('$destroy', function() {
                element.off('touchstart');
                element.off('touchend');
                $timeout.cancel(timeoutPromise);
            });
        }
    }
})();

(function() {
	'use strict';

	angular
		.module('app.main')
		.directive('txLinkedArticleViewer', txLinkedArticleViewerDirective);

	//Directive.$inject = ['dependency1'];
	function txLinkedArticleViewerDirective() {
		// Usage:
		//
		// Creates:
		//
		var directive = {
			bindToController: true,
			controller: txLinkedArticleViewerController,
			controllerAs: 'vm',
			restrict: 'E',
			scope: {
				field: '=txField',
				data: '=txData',
				isNew: '=txNew'
			},
			templateUrl: 'app/directives/txLinkedArticleViewer/tx-linked-article-viewer.html'
		};
		return directive;
	}
	/* @ngInject */
	function txLinkedArticleViewerController ($scope, utility, catalogFactory, api, $q) {
		var vm = this;
		vm.scope = $scope;
		vm.record = vm.data;
		vm.linkedArticleNumberAttribute = '';
		vm.linkedCatalogSeasons = [];
		var activeCatalog = catalogFactory.getActiveCatalogDetails();
		var catalogCode = activeCatalog.CatalogCode;
		getLinkedCatalogSeasons();
		var linkedCatalogArticles = [];
		if(vm.isNew) {
			vm.linkedCatalogSeason = '';
		} else {
			vm.linkedCatalogSeason = utility.getLinkedArticleNumberAttributeSeasonValue(vm.data[vm.field.field]);
			vm.linkedArticleNumberAttribute = utility.getLinkedArticleNumberAttributeTypeValue(vm.data[vm.field.field]);
		}
		vm.searchText = '';
		vm.isSeasonsAboveDropDownLimit = false;

		vm.seasonsLookupSearch = seasonsLookupSearch;
		vm.onLinkedCatalogSeasonChange = onLinkedCatalogSeasonChange;
		vm.getSeasonsLookupDisplayValue = getSeasonsLookupDisplayValue;
		vm.lookupSearch = lookupSearch;
		vm.lookupChange = lookupChange;
		vm.getLookupDisplayValue = getLookupDisplayValue;

		function getLinkedCatalogSeasons() {
			var linkedCatalogs = activeCatalog.LinkedCatalogList;
			angular.forEach(linkedCatalogs, function(catalog) {
				var seasonObject = {
					id: catalog.Season+catalog.CatalogCode,
					value: catalog.Season,
					catalogCode: catalog.CatalogCode
				}
				vm.linkedCatalogSeasons.push(seasonObject);
			});
		}

		function seasonsLookupSearch(query, lookupPropertyName) {
			var results = [];
			var predicate = {};
			predicate[lookupPropertyName] = query;
			results = query ? utility.filterObject(vm.linkedCatalogSeasons, predicate) : vm.linkedCatalogSeasons;
			// this is to reduce the rendering time. It was very slow and was impacted overall page responsiveness
			// so while displaying we will display only the first 100 records and user can filter with any value
			if(results.length > 100) {
				vm.isSeasonsAboveDropDownLimit = true;
				return results.slice(0, 100);
			} else {
				vm.isSeasonsAboveDropDownLimit = false;
				return results;
			}
		}

		function onLinkedCatalogSeasonChange(selectedObj) {
			if (angular.isObject(selectedObj)) {
				vm.linkedCatalogSeason = selectedObj;
				catalogCode = selectedObj.catalogCode;
				loadLinkedArticlesBasedOnSeason(selectedObj.catalogCode).then(function (availableArticlesResponse) {
					linkedCatalogArticles = availableArticlesResponse;
				});
			}
			else if (angular.isUndefined(selectedObj) || selectedObj === null) {
				vm.linkedCatalogSeason = '';
				linkedCatalogArticles = [];
			}
			vm.linkedArticleNumberAttribute = null;
		}

		function getSeasonsLookupDisplayValue(item, lookupPropertyName) {
			var result;
			var predicate = {};
			// since autocomplete return object
			if (angular.isObject(item)) {
					predicate[lookupPropertyName] = item[lookupPropertyName];
					result = utility.filterObject(vm.linkedCatalogSeasons, predicate, true)[0];
			}
			else {
					predicate[lookupPropertyName] = item;
					result = utility.filterObject(vm.linkedCatalogSeasons, predicate, true)[0];
			}

			if (angular.isArray(result) && result.length > 0) {
					return result[0].value;
			}
			else {
					return result.value;
			}
		}

		function lookupSearch(query, field) {
			var results = [];
			var predicate = {};
			predicate['ArticleNumber'] = query;
			if (angular.isDefined(linkedCatalogArticles) && linkedCatalogArticles.length) {
				results = query ? utility.filterObject(linkedCatalogArticles, predicate) : angular.copy(linkedCatalogArticles);
			}
			else {
				loadLinkedArticlesBasedOnSeason(catalogCode).then(function (availableArticlesResult) {
					results = query ? utility.filterObject(availableArticlesResult, predicate) : availableArticlesResult;
				});
			}
			// this is to reduce the rendering time. It was very slow and was impacted overall page responsiveness
			// so while displaying we will display only the first 100 records and user can filter with any value
			if(results.length > 100) {
				field['isAboveDropDownLimit'] = true;
				return results.slice(0, 100);
			} else {
				field['isAboveDropDownLimit'] = false;
				return results;
			}
		}

		function lookupChange(selectedObj, recordPropertyName) {
			if (angular.isObject(selectedObj)) {
				// assign the formatted result Eg - Summer33//257655//1005684-390
				if(angular.isObject(vm.linkedCatalogSeason)) {
					vm.linkedCatalogSeason = vm.linkedCatalogSeason.id;
				}
				var formattedString = vm.linkedCatalogSeason +'//'+ selectedObj.Id + '//' + selectedObj.ArticleNumber;
				vm.record[recordPropertyName] = formattedString;
				vm.linkedArticleNumberAttribute = selectedObj.ArticleNumber;
			}
			else if (angular.isUndefined(selectedObj) || selectedObj === null) {
				vm.linkedArticleNumberAttribute = undefined;
			}
		}

		function getLookupDisplayValue(item) {
			var result;
			var predicate = {};
			// since autocomplete return object
			if (angular.isObject(item)) {
					predicate['Id'] = item['Id'];
					result = utility.filterObject(linkedCatalogArticles, predicate, true)[0];
			}
			else {
					predicate['Id'] = item;
					result = utility.filterObject(linkedCatalogArticles, predicate, true)[0];
			}

			if (angular.isArray(result) && result.length > 0) {
					return result[0].ArticleNumber;
			}
			else if(angular.isDefined(result)) {
					return result.ArticleNumber;
			}
		}

		// helper method
		function loadLinkedArticlesBasedOnSeason(catalogCode) {
			var generalProperties = {
				forceFetch: true,
				isLogRequired: false
			}
			var deferred = $q.defer();
			var promise = deferred.promise;
			api.lists.linkedCatalogArticles.methods.getList(generalProperties, catalogCode).then(function (response) {
				linkedCatalogArticles = response.data;
				deferred.resolve(linkedCatalogArticles);
			});
			return promise;
		}

	}
})();
(function() {
    'use strict';

    angular
        .module('app.main')
        .directive('txImageDraggable', txImageDraggableDirective);

    function txImageDraggableDirective() {
        var directive = {
            bindToController: true,
            controller: txImageDraggableController,
            controllerAs: 'vm',
            link: link,
            restrict: 'E',
            scope: {
                data: '=txData',
                selectedData: '=?txSelectedData',
                model: '=txModel',
				isLoading: '=?txIsLoading',
				itemClickEvent: '&?txItemClickEvent'
            },
			templateUrl: 'app/directives/txImageDraggable/tx-image-draggable.html'
        };
        return directive;

        function link(scope, element, attrs) {

            if (angular.isUndefined(scope.vm.isLoading)) {
				scope.vm.isLoading = false;
			}

            if(angular.isUndefined(scope.vm.data)) {
                scope.vm.data = [];
            }
        }
    }

    /* @ngInject */
    function txImageDraggableController ($scope, $timeout, $window, utility) {
        var vm = this;

        //data
        vm.selectedData = [];
        var timeoutPromises = {};

        vm.listStyle = {
            height: ($window.innerHeight - (64+10+40)) + 'px'
        }
        $window.addEventListener('resize', onResize);

        //methods
        vm.doItemClick = doItemClick;
        vm.addImages = addImages;


        activate();
        /////////////

        function activate() {
            if (angular.isUndefined(vm.model.imagesLimit)) {
                vm.model.imagesLimit = 25;
            }
            timeoutPromises.bLazy = $timeout(function() {
                vm.bLazy = new Blazy({
                    container: '#images-view', // Default is window
                    src: 'data-blazy'
                });
            }, 3000);
            // registerDataWatchers();
        }

        function doItemClick(item) {
            if( !(angular.isDefined(item.txAssigned) && item.txAssigned == true) ) { // to avoid selecting already assigned element (merchandinsing)
                item.selected = !item.selected;
                onSelectionChange();
            }
            if (angular.isFunction(vm.itemClickEvent)) { // out of if to display preview even if it's assigned
                vm.itemClickEvent({item: item});
            }
        }

        function addImages() {
            if (vm.model.imagesLimit < vm.data.length) {
                if (vm.model.imagesLimit + 10 > vm.data.length) {
                    vm.model.imagesLimit = vm.data.length;
                } else {
                    vm.model.imagesLimit += 10;
                }
                timeoutPromises.addImages = $timeout(function(){
                    vm.bLazy.revalidate();
                }, 2000);
            }
        }

        //helper methods
        // function registerDataWatchers() {
            // if use watch, unsbscribe when directive destroy
        //     $scope.$watch('vm.data', updateData);
        // }

        // function updateData(newVal) {
        //     if(angular.isDefined(newVal)) {
        //         vm.dataLength = vm.data.length;
        //     }
        // }

        function onSelectionChange() {
            vm.selectedData = utility.filterObject(vm.data, {selected: true});
        }

        function onResize() {
            var contentHeight = ($window.innerHeight - 114); //TODO- need to be calculated
            vm.listStyle.height = contentHeight + 'px';
            if (!$scope.$root.$$phase) $scope.$digest();
            $scope.$broadcast('$md-resize');
        }
        $scope.$on('$destroy', function () {
            $window.removeEventListener('resize', onResize);
            for(var key in timeoutPromises) {
                $timeout.cancel(timeoutPromises[key]);
            }
        });
    }
})();
(function() {
    'use strict';

     angular
        .module('app.main')
        .directive('txFocus', txFocus);

     /**
      * txFocus will focus on element when it's value evaluated to true
      */
    /** @ngInject */
    function txFocus($timeout, $parse) {
        var directive = {
            link: link,
            restrict: 'A',
        };
        return directive;

        function link(scope, element, attrs) {
            var timeoutPromise;
            var watchUnsubscriber;
            var model = $parse(attrs.txFocus);
            watchUnsubscriber = scope.$watch(model, function (value) {
                if (value === true) {
                    timeoutPromise = $timeout(function () {
                        element[0].focus();
                    });
                }
            });

            scope.$on('$destroy', function() {
                watchUnsubscriber();
                if(angular.isFunction(timeoutPromise)) {
                    $timeout.cancel(timeoutPromise);
                }
            });
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('app.main')
        .directive('txFilterInput', txFilterInputDirective);

    function txFilterInputDirective() {
        var directive = {
            bindToController: true,
            controller: txFilterInputController,
            controllerAs: 'vm',
            restrict: 'E',
            replace: true,
            scope: {
                inputId: '@txInputId',
                data: '=txData',
                columnFilter: '=txColumnFilter',
                col: '=txColumns',
                colWidth: '=?txColumnWidth',
                onFilterChange: '&?txOnFilterChange',
                embedLabel: '@?txEmbedLabel',
                filterRowVisible: '=txFilterRowVisible',
                lookupData: '=txLookupData'
            },
            templateUrl: 'app/directives/txFilterInput/tx-filter-input.html'
        }

        return directive;
    }

    /* @ngInject */
    function txFilterInputController($mdDialog, $document, $timeout, $filter, $q, $scope, utility, $mdPanel, catalogFactory) {
        /* jshint validthis: true */
        var vm = this;

        //Data
        var timeoutPromises = {};
        var cachedFilterValues = {};
        var filterTimeoutPromise;

        vm.searchText = '';
        vm.showDateRangeFilter = false;
        vm.col = angular.copy(vm.col);
        vm.dataSourceTypeId = catalogFactory.getActiveCatalogDetails().DataSourceTypeId; // used for articles status type

        // they are not used anywhere
        // vm.statusFilterValue = {};
        // vm.statusFilterValue[vm.col.field] = vm.columnFilter[vm.col.field] !=="" ? vm.columnFilter[vm.col.field] : ' ';

        if(angular.isObject(vm.columnFilter[vm.col.field]) && !utility.isObjectEmpty(vm.columnFilter[vm.col.field])) {
            vm.isAdvancedFilter = true;
        }

        // to reset advance filter when filter is closed
        var watchUnsubscribers = $scope.$watch('vm.filterRowVisible', function(txFilterRowVisible) {
            if(!txFilterRowVisible) {
                vm.removeAdvancedFilter(vm.col)
            }
        });

        //Methods
        vm.showAdvanceFilterDialog = showAdvanceFilterDialog;
        vm.removeAdvancedFilter = removeAdvancedFilter;
        vm.filterChange = filterChange;
        vm.loadUniqueValues = loadUniqueValues;
        vm.clearSearchText = clearSearchText;
        vm.onKeyDown = onKeyDown;
        vm.showDateRangeFilterPanel = showDateRangeFilterPanel;
        vm.onColorPickerUpdate = onColorPickerUpdate

        ////////////

        function loadUniqueValues(date) {
            vm.uniqueValues = [];
            var uniqueValuesIndex = {};
            angular.forEach(vm.data, function (data) {
                if(data[vm.col.field] == null) {
                    data[vm.col.field] = '';
                }
                if(angular.isDefined(date) && date === 'date' && date !== 0) {
                    data[vm.col.field] = $filter('date')(data[vm.col.field]);
                }
                if (angular.isUndefined(uniqueValuesIndex[data[vm.col.field]])) {
                    // list the multuvalue attribues as single values
                    if(angular.isDefined(vm.col) && (vm.col.inputType === 'multi-value' || vm.col.inputSubType === 'multi-value' || vm.col.calcType === 'multivalue')) {
                        var multiValueArray = data[vm.col.field];
                        if(multiValueArray.length) {
                            angular.forEach(multiValueArray, function(item) {
                                if(angular.isUndefined(uniqueValuesIndex[item])) {
                                    uniqueValuesIndex[item] = true;
                                    vm.uniqueValues.push(item);
                                }
                            });
                        } else {
                            if(angular.isUndefined(uniqueValuesIndex[''])) {
                                uniqueValuesIndex[''] = true;
                                vm.uniqueValues.push('');
                            }
                        }
                    } else if(angular.isDefined(vm.col) && (vm.col.inputType === 'color-palette')) {
                        var colorName = $filter('colorPaletteRenderer')(data[vm.col.field], vm.col);
                        if(colorName !== '') {
                            if(angular.isUndefined(uniqueValuesIndex[colorName])) {
                                uniqueValuesIndex[colorName] = true;
                                vm.uniqueValues.push(colorName);
                            }
                        }
                    } else if(angular.isDefined(vm.col) && (vm.col.inputType === 'articlenumber' || vm.col.inputType === 'modelnumber' || vm.col.inputType === 'linkedcatalogarticlenumber')) {
                        var lookupValue = $filter('recordRenderer')(data[vm.col.field], vm.lookupData, vm.col);
                        if(angular.isDefined(lookupValue)) {
                            if(angular.isUndefined(uniqueValuesIndex[lookupValue])) {
                                uniqueValuesIndex[lookupValue] = true;
                                vm.uniqueValues.push(lookupValue);
                            }
                        }
                    } else {
                        uniqueValuesIndex[data[vm.col.field]] = true;
                        vm.uniqueValues.push(data[vm.col.field]);
                    }
                }
            });
            vm.uniqueValues = $filter('orderBy')(vm.uniqueValues);
            return $q.when(vm.uniqueValues);
        }

        function showAdvanceFilterDialog(ev, field) {
            $mdDialog.show({
                controller         : 'advanceFilterController',
                controllerAs       : 'vm',
                templateUrl        : 'app/directives/txFilterInput/dialogs/advance-filter.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: false,
                multiple           : true,
                locals             : {
                    field: field,
                    columnFilterData: vm.columnFilter[field.field]
                }
            }).then(function(columnFilterData) {
                if(angular.isDefined(columnFilterData)) {
                    if (!vm.isAdvancedFilter) { //do not cache for advance filter
                        cachedFilterValues[field.field] = vm.columnFilter[field.field] ? angular.copy(vm.columnFilter[field.field]) : '';
                    }
                    vm.columnFilter[field.field] = columnFilterData;
                    vm.isAdvancedFilter = true;
                    filterChange();
                }
            });
        }

        function removeAdvancedFilter(fieldName) {
            vm.isAdvancedFilter = false;
            vm.columnFilter[fieldName] = "";
            filterChange();
        }

        function filterChange(event) {
            if (angular.isDefined(vm.onFilterChange) && angular.isFunction(vm.onFilterChange)) {
                if(filterTimeoutPromise) {
                    $timeout.cancel(filterTimeoutPromise);
                }
                if(event && !(event.which === 27 || event.which === 13)) {
                    filterTimeoutPromise = $timeout(function() {
                        if(angular.isDefined(event.startDate) || angular.isDefined(event.endDate)) {
                            vm.columnFilter[vm.col.field] = event.startDate + '_' + event.endDate;
                            // show the selected value in the filter input
                            vm.dateRange = (angular.isUndefined(event.startDate) ? '' : $filter('date')(event.startDate)) + '_' + (angular.isUndefined(event.endDate) ? '' : $filter('date')(event.endDate));
                        } else if(angular.isDefined(event.filterTypeBlank) && event.filterTypeBlank) {
                            vm.columnFilter[vm.col.field] = 'blank';
                            vm.dateRange = '[Blank]';
                        }
                        vm.onFilterChange({$event: event});
                    }, 500);
                }
                else {
                    vm.onFilterChange({$event: event});
                }
            }
        }

        function onColorPickerUpdate(event) {
            console.log(event)
            if(angular.isDefined(timeoutPromises.onColorPickerUpdate)) {
                $timeout.cancel(timeoutPromises.onColorPickerUpdate);
            }
            timeoutPromises.onColorPickerUpdate = $timeout(function() {
                vm.filterChange(event);
            }, 500)
        }

        function clearSearchText() {
            vm.searchText = '';
        }

        function onKeyDown(event) {
            event.stopPropagation();
        }

        function showDateRangeFilterPanel(event) {
            var position = $mdPanel.newPanelPosition()
            .relativeTo(event.target)
            .addPanelPosition($mdPanel.xPosition.ALIGN_START, $mdPanel.yPosition.BELOW);

            $mdPanel.open({
                controller         : 'dateRangeFilterController',
                controllerAs       : 'vm',
                templateUrl        : 'app/directives/txFilterInput/panels/date-range-filter.html',
                parent             : angular.element($document.body),
                targetEvent        : event,
                clickOutsideToClose: true,
                escapeToClose      : true,
                position           : position,
                onRemoving : dateFilterChange,
                zIndex: 2
            });
        }

        function dateFilterChange(mdPanelRef) {
            if(mdPanelRef.dateRange && mdPanelRef.dateRange !== '') {
                filterChange(mdPanelRef.dateRange);
            } else if(mdPanelRef.filterTypeBlank) {
                var filterObj = {'filterTypeBlank': true}
                filterChange(filterObj);
            }
        }

        $scope.$on('$destroy', function() {
            for(var key in timeoutPromises) {
                $timeout.cancel(timeoutPromises[key]);
            }
            $timeout.cancel(filterTimeoutPromise);
            watchUnsubscribers();
        });
    }
})();
(function() {
    'use strict';

    angular
        .module('app.main')
        .directive('txFieldViewer', txFieldViewerDirective);

    //Directive.$inject = ['dependency1'];
    function txFieldViewerDirective() {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            bindToController: true,
            controller: txFieldViewerController,
            controllerAs: 'vm',
            link: link,
            restrict: 'E',
            scope: {
                fields: '=txFields',
                field: '=txField',
                data: '=txData',
                lookupData: '=txLookupData',
                statusField: '@?txStatusField',
                hideTitle: '@?txHideTitle',
                showDatatableAsGrid: '@?txShowDatatableAsGrid'
            },
            templateUrl: 'app/directives/txFieldViewer/tx-field-viewer.html'
        };
        return directive;

        function link(scope, element, attrs) {
        }
    }
    /* @ngInject */
    function txFieldViewerController ($scope, utility, catalogFactory, api) {
        var vm = this;
        vm.scope = $scope;
        vm.getArticleStatusValue = getArticleStatusValue;
        var dataSourceTypeId = catalogFactory.getActiveCatalogDetails().DataSourceTypeId; // used for articles status type
        // catalog seasonal sequence
        vm.catalogSeasonalSequence = catalogFactory.getActiveCatalogDetails().SeasonalSequence;
        vm.api = api;

        function getArticleStatusValue(itm, field) {
            return utility.getArticleStatusValue(itm, field, dataSourceTypeId);
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('app.main')
        .directive('txDynamicValues', txDynamicValues);
    function txDynamicValues() {
        var directive = {
            bindToController: true,
            controller: txDynamicValuesController,
            controllerAs: 'vm',
            restrict: 'E',
            transclude: true,
            scope: {
                value: '=?txValue',
                item: '=?txItem',
                field: '=?txField'
            },
            templateUrl: 'app/directives/txDynamicValues/tx-dynamic-values.html'
        };
        return directive;
    }

    /* @ngInject */
    function txDynamicValuesController (catalogFactory, utility, $scope) {
        var vm = this;
        vm.value = vm.value;
        vm.item = vm.item;
        var field = vm.field;
        vm.inputType = '';
        var watchUnsubscriber;

        watchUnsubscriber = $scope.$watch('vm.item', watchDataChange, true);
        updateData(vm.item);

        function watchDataChange(newval, oldVal) {
            if(angular.isDefined(newval)) {
                updateData(newval);
            }
        }

        function updateData(item) {
            if(vm.value !== '' && vm.value != null) {
                // as we have 4 attributes and its values, extracting the digit from the field(Attribute_1_Id,Attribute_1_Name and Attribute_1_Value)
                var attributeOrder = field.match(/\d/)[0];
                var assignedCatalogAttributes = catalogFactory.getActiveCatalogDetails().AssignedCatalogAttributes;
                var attribute = utility.changeAttributeType(utility.filterObject(assignedCatalogAttributes, {AttributeDisplayName: item['Attribute_' + attributeOrder + '_Name']}, true)[0]);
                vm.inputType = angular.isDefined(attribute) ? attribute.inputType : vm.inputType;
            }
        }

        $scope.$on('$destroy', function () {
            watchUnsubscriber();
        });
    }
})();
(function() {
	'use strict';

	angular
		.module('app.main')
		.directive('txDataTree', txDataTreeDirective);

	//Directive.$inject = [''];
	function txDataTreeDirective() {
		// Usage:
		//
		// Creates:
		//
		var directive = {
			bindToController: true,
			controller: txDataTreeController,
			controllerAs: 'vm',
			link: link,
			restrict: 'E',
			scope: {
                data                    : '=txData',
				// cols            : '=txColumns', // is that required?
                branchTypes             : '=txBranchTypes',
                listActions             : '=?txListActions',
                filter                  : '=?txDataFilter',
                model                   : '=txModel',
                isLoading               : '=?txIsLoading',
				showFilterRow           : '=?txShowFilterRow',
                refreshActionEvent      : '&?txRefreshActionEvent',
                listActionEvent         : '&?txListActionEvent',
				itemActionEvent         : '&?txItemActionEvent',
				itemClickEvent          : '&?txItemClickEvent',
                treeEventHandler        : '=txTreeEventHandler',
                heightOffset            : '@?txHeightOffset',
                viewOptions             : '=?txViewOptions',
                preventFolderClick      : '@?txPreventFolderClick', // use for styling (mouse cursor, also prevent click callback if true, clickable callback can be removed and controll in controller)
                switchCollectionsViewActionEvent   : '&?txSwitchCollectionsViewActionEvent',
                treeViewOptions         : '=?txTreeViewOptions',
                showTreeListDropdown    : '=?txShowTreeList'
			},
			templateUrl: 'app/directives/txDataTree/tx-data-tree.html'
		};
		return directive;

		function link(scope, element, attrs) {
            scope.element = element;

			if (angular.isUndefined(scope.vm.isLoading)) {
				scope.vm.isLoading = false;
			}

			// if (angular.isUndefined(scope.vm.tabularData)) {
			// 	scope.vm.tabularData = [];
            // }

			// if (angular.isUndefined(scope.vm.filteredTabularData)) {
			// 	scope.vm.filteredTabularData = [];
            // }

			// if (angular.isUndefined(scope.vm.tabularModel)) {
			// 	scope.vm.tabularModel = {}; // scope.vm.model
            // }

            if (angular.isUndefined(scope.vm.heightOffset)) {
                scope.vm.heightOffset = 0;
            }
            if(angular.isUndefined(scope.vm.viewOptions)) {
                scope.vm.viewOptions = {};
            }
            // TODO- does it required here?
            // if (angular.isUndefined(scope.vm.cols)) {
            //     scope.vm.cols = [];
            // }
		}
	}
	/* @ngInject */
	function txDataTreeController($window, $scope, $rootScope, $localStorage, catalogFactory, utility, dialog) {
		var vm = this;
        var watchUnsubscribers = {};

        vm.doListAction = doListAction;
		vm.doItemAction = doItemAction;
		vm.doItemClick = doItemClick;
        vm.doRefreshAction = doRefreshAction;
        vm.toggleExpand = toggleExpand;
        vm.toggle = toggle;
        vm.doSwitchView = doSwitchView;
        vm.canUserModifyTreeForActiveCatalog = true;
        vm.expanded = true;
        vm.listActions = vm.model.views.mainList.listActions;
        vm.onActiveTreeChange = onActiveTreeChange;

        activate();

        function activate() {
            identifyUserAuthorityToModifyTreeForActiveCatalog();
            if(angular.isDefined(vm.itemClickEvent) && angular.isFunction(vm.itemClickEvent)) {
                vm.clickable = true;
            }

            if(angular.isDefined(vm.showTreeListDropdown) && vm.showTreeListDropdown) {
                vm.catalogTreeList = utility.filterObject(catalogFactory.getActiveCatalogDetails().TreeDefination, {Status: 1});
                vm.activeCatalogTree = catalogFactory.getActiveCatalogTree();
            }

            vm.treeStyle = {
                height: ($window.innerHeight - 201 - (vm.showFilterRow ? 85 : 0)) + 'px'
            }
            $window.addEventListener('resize', onResize);
            recalcBranches();
            reloadBranchTypesList();

            watchUnsubscribers.filter = $scope.$watch("vm.filter", doFilter);
            watchUnsubscribers.data = $scope.$watch("vm.data", recalcBranches);
            watchUnsubscribers.branchTypes = $scope.$watch("vm.branchTypes", reloadBranchTypesList);

            // disable drag and drop for shared folders tree and catalog tree module
            if(vm.model.modelPath === 'catalogs.sharedFoldersTree' || vm.model.modelPath === 'catalogs.treeNodes') {
                vm.canUserModifyTreeForActiveCatalog = false;
            }
        }


        //TODO: Add support for lookup data (future)
        //vm.lookupData = {};
        //loadLookupData();


        //TODO: Support Security priv for actions

		////////

        function doListAction(action) {
            if (angular.isFunction(vm.listActionEvent))
            {
                var selectedItems= [];
                selectedItems = utility.filterObject(vm.filteredData, {selected : true}, true);

                if(action.requiresConfirmation){
                    dialog.confirm(action.confirmationContent, action.confirmationAction, selectedItems, vm.model)
                    .then(function(response){
                        if(response.userAction.toLowerCase() === 'confirm') {
                            vm.listActionEvent({action: action, selectedItems: selectedItems, additionalInfo: response});
                        }
                    });
                }
                else{
                    vm.listActionEvent({action: action, additionalInfo: {}});
                }
            }
        }

		function doItemAction(action, item) {
            if(angular.isDefined(item.type)) {
                var model = vm.branchTypes[item.type].model;
            }
			if (angular.isFunction(vm.itemActionEvent))
			{
                if(action.requiresConfirmation) {
                    dialog.confirm(action.confirmationContent, action.confirmationAction, item, model)
                    .then(function(response) {
                        if(response.userAction.toLowerCase() === 'confirm') {
                            vm.itemActionEvent({action: action, item: item, additionalInfo: response});
                        }
                    });
                }
                else {
                    vm.itemActionEvent({action: action, item: item, additionalInfo: {}});
                }
			}
		}

		function doItemClick(item) {
			if (angular.isFunction(vm.itemClickEvent)
            && !(angular.isDefined(vm.preventFolderClick) && vm.preventFolderClick == 'true'
            && angular.isDefined(item.type) && item.type.toLowerCase() == 'folder')
            ) {
				vm.itemClickEvent({item: item});
			}
		}

        function doRefreshAction() {
            if (angular.isFunction(vm.refreshActionEvent)) {
                vm.refreshActionEvent({});
            }
        }


        function toggleExpand() {
            if(vm.expanded) {
                $scope.$broadcast('angular-ui-tree:collapse-all');
            } else {
                $scope.$broadcast('angular-ui-tree:expand-all');
            }
            vm.expanded = !vm.expanded;
        }

        function toggle(ev, scope) {
            ev.stopPropagation();
            scope.toggle();
        }

        function doSwitchView(id) {
            if(angular.isFunction(vm.switchCollectionsViewActionEvent)) {
                vm.switchCollectionsViewActionEvent({id: id});
            }
        }

        // helper methods

        function onResize() {
            if (angular.isDefined($scope.element) && $scope.element != null) {
                var toolbar = angular.element($scope.element[0].querySelector('.tree-toolbar'));
                var toolbarHeight = 0;
                var treeHeader = angular.element($scope.element[0].querySelector('.tree-header'));
                var listHeaderHeight = 0;

                if (toolbar) {
                    toolbarHeight = toolbar.outerHeight();
                }
                if (treeHeader) {
                    listHeaderHeight = treeHeader.outerHeight();
                }

                vm.listHeight = ($window.innerHeight - $scope.element.offset().top - $scope.vm.heightOffset - listHeaderHeight - (vm.showFilterRow ? 85 : 0) - toolbarHeight);
                vm.treeStyle.height = vm.listHeight + 'px';
                if (!$scope.$root.$$phase) $scope.$digest();
                $scope.$broadcast('$md-resize');
            }
        }

        function doFilter() {
            angular.forEach(vm.data, function(node) {
                node._hide = !nodeOrChildMatchesFilter(node, vm.filter);
            });
        }

        function nodeOrChildMatchesFilter(node, filter, found) {
            var isMatch = false;

            isMatch = found || (node.title.toLowerCase().indexOf(filter.toLowerCase()) >=0);

            for (var i=0; node.nodes && i<node.nodes.length; i++) {
                isMatch = nodeOrChildMatchesFilter(node.nodes[i], filter, isMatch) || isMatch;
            }

            node._hide = !isMatch;
            return isMatch;
        }

        function recalcBranches() {
            var currentTotal = {all:0};
            vm.totalBranches=getTotalBranches(vm.data, currentTotal);
        }

        function getTotalBranches(node, currentTotal) {
            var ttl = angular.copy(currentTotal);
            if (!node) {
                return ttl;
            }
            angular.forEach(node, function(childNode) {
                ttl.all ++;
                if (ttl[childNode.type]) {
                    ttl[childNode.type]++;
                } else {
                    ttl[childNode.type]=1;
                }

                ttl = getTotalBranches(childNode.nodes, ttl);
            });
            return ttl;
        }

        function reloadBranchTypesList() {
            vm.branchTypesList = [];
            for (var property in vm.branchTypes) {
                if (vm.branchTypes.hasOwnProperty(property)) {
                    vm.branchTypesList.push(property);
                }
            }
        }

        // prevent user to modify tree if active catalog does not belong to his/her account
        function identifyUserAuthorityToModifyTreeForActiveCatalog() {
            if($localStorage.account.accountType != 1 && catalogFactory.getActiveCatalog().AccountId != $localStorage.account.accountId) {
                vm.canUserModifyTreeForActiveCatalog = false;
            }
        }

        function onActiveTreeChange(tree) {
            if (angular.isDefined(tree)) {
              vm.activeCatalogTree = tree;
              catalogFactory.setActiveCatalogTree(tree);
              $scope.$emit('ActiveCatalogTreeChangedEvent', vm.activeCatalogTree);
            }
          }

        var catalogChangedEventCleanup = $rootScope.$on('ActiveCatalogChangedEvent', function(e) {
            if($localStorage.account.accountType != 1 && catalogFactory.getActiveCatalog.AccountId != $localStorage.account.accountId) {
                vm.canUserModifyTreeForActiveCatalog = false;
            }
        });
        $scope.$on('$destroy', function () {
            catalogChangedEventCleanup();
            for(var key in watchUnsubscribers) {
                watchUnsubscribers[key]();
            }
            $scope.element = null;
        });


	}
})();
(function() {
	'use strict';

	angular
		.module('app.main')
		.directive('txIncludeTree', txIncludeTree);

	//Directive.$inject = [''];
	function txIncludeTree() {
		return {
			restrict: 'E',
			templateUrl: 'app/directives/txDataTree/include-tree.html'
		}
	}
})();
(function() {
  'use strict';

  angular
    .module('app.main')
    .directive('txDataTable', txDataTableDirective);

  //Directive.$inject = [''];
  /* Updated  the directive dialogs (like column chooser, filter saver, column saver and doItemRightClick) with property "multiple : true" so that multiple dialogs
   * can be opened for creating carryover and comp articles for line plan type of catalogs.
   * It won't hamper existing data table as there is no scenario where the dialog will be already opened and then we need to open column chooser etc
   */
  function txDataTableDirective() {
    // Usage:
    //
    // Creates:
    //
    var directive = {
      bindToController: true,
      controller: txDataTableController,
      controllerAs: 'vm',
      link: link,
      restrict: 'E',
      scope: {
        data: '=txData',
        filteredData: '=?txFilteredData',
        model: '=txModel',
        viewName: '@txView',
        supportImagesView: '@?txSupportImagesView',
        supportFilterByDate: '@?txSupportFilterByDate',
        filter: '=?txDataFilter',
        isLoading: '=?txIsLoading',
        refreshActionEvent: '&?txRefreshActionEvent',
        listActionEvent: '&?txListActionEvent',
        itemActionEvent: '&?txItemActionEvent',
        itemClickEvent: '&?txItemClickEvent',
        processOrderListActionEvent: '&?txProcessOrderListActionEvent',
        processOrderItemActionEvent: '&?txProcessOrderItemActionEvent',
        heightOffset: '@?txHeightOffset',
        isActive: '&?txIsActive',
        internalControl: '=?txControl',
        disableSelection: '@?txDisableSelection', // #changeManagement (generic), charts view
        disableSelectionDropdown: '@?txDisableSelectionDropdown', // #changeManagement (generic), charts view
        disableExport: '@?txDisableExport',
        disableModuleListActions: '@?txDisableModuleListActions', // to hide list actions configure in modules model object
        changeManagementListActionEvent: '&?txChangeManagementListActionEvent', // #changeManagement
        changeManagementRecord: '=?txChangeManagementRecord', // #changeManagement
        toolbarVisible: '@?txToolbarVisible', //#vettingList:  user logs to show filter(drop-down)
        toolbarOptions: '=?txToolbarOptions', //#vettingList:  user logs filter options
        toolbarValue: '=?txToolbarValue', //#vettingList:  user logs value
        chartViewEnabled: '@?txChartViewEnabled', //This property will be checked to make sure chart should be enabled or not
        switchCollectionsViewActionEvent   : '&?txSwitchCollectionsViewActionEvent',//Collections view change
        currentCollectionView: '=?txCurrentCollectionView',
        isDuneImagesView: '@?txDuneImagesView',
        showTreeListDropdown: '=?txShowTreeList',
        merchBoradViewChangeEvent: '&?txMerchBoradViewChangeEvent',
        hideRefreshAndSaveButton: '=?txHideRefreshAndSaveButton',
        loadNextPageEvent: '&?txLoadNextPageEvent',
        hasMorePages: '=?txHasMorePages',
        totalRecordCount: '=?txTotalRecordCount',
        // attribute group scope selector, for lists whose GET endpoint embeds an attribute group id
        attributeGroups: '=?txAttributeGroups', // attribute group records to offer, dropdown is hidden while empty
        selectedAttributeGroupId: '=?txSelectedAttributeGroup', // attribute group the list is currently showing
        attributeGroupChangeEvent: '&?txAttributeGroupChangeEvent' // fired after the user switches group
      },
      templateUrl: 'app/directives/txDataTable/tx-data-table.html'
    };
    return directive;

    function link(scope, element) {
      var hotkeyWatchUnsubscriber;

      //scope.vm.internalControl = scope.vm.control || {};

      scope.element = element;

      if (angular.isUndefined(scope.vm.filteredData)) {
        scope.vm.filteredData = [];
      }

      if (angular.isUndefined(scope.vm.isLoading)) {
        scope.vm.isLoading = false;
      }

      if (angular.isUndefined(scope.vm.sortReverse)) {
        scope.vm.sortReverse = false;
      }

      if (angular.isUndefined(scope.vm.heightOffset)) {
        scope.vm.heightOffset = 0;
      }

      if (angular.isDefined(scope.vm.isActive)) {
        hotkeyWatchUnsubscriber = scope.$watch(function() { return scope.vm.isActive(); }, function() {
          scope.vm.registerHotkeys(scope.vm.isActive());
        });
      } else {
        scope.vm.registerHotkeys(true);
      }


      scope.$on('$destroy', function () {
        if(angular.isFunction(hotkeyWatchUnsubscriber)){
          hotkeyWatchUnsubscriber();
        }
      });
    }
  }
  /* @ngInject */
  function txDataTableController($window, $scope, $rootScope, $document, $timeout, $mdDialog, $localStorage, catalogFactory, dataExporter,
                  utility, api, dialog, SecurityFactory, $filter, hotkeys, settingsFactory, dragulaService, $log, mockFactory,toast, CONSTANTS) {

    /* jshint validthis: true */
    var vm = this;

    vm.scope = $scope;// for calculated expressions in template, should remove when no calculated expression being used in data table


    //data
    vm.fields = vm.model.fields;
    vm.view = vm.model.views[vm.viewName];
    vm.statusField = angular.isDefined(vm.model.customStatusField) ? vm.model.customStatusField : 'Status';
    vm.currentCollectionView = angular.isDefined(vm.currentCollectionView) ? vm.currentCollectionView : '';
    //filter visible fields
    vm.filteredFields = utility.filterObject(vm.fields, {visible: true});
    vm.colsList = api.getFields(vm.filteredFields, vm.view.columns);
    // filter only visible columns to hide dynamically removed columns or columns which removed from code base but their info persisted in database
    vm.colsList = utility.filterObject(vm.colsList, {visible: true});
    vm.colsWidth = {};
    vm.resizableColsContainerWidth = 0;
    vm.isDuneImagesModel = false;

    vm.dataLength = 0;
    vm.filteredDataLength = 0;
    vm.selectedRecordsLength = 0;
    vm.activeRow = 0;
    vm.lookupData = {};
    vm.allSelected = false;
    vm.imagesSizeInfo = {};
    vm.activeCatalogTree = undefined;
    // catalog seasonal sequence
    vm.catalogSeasonalSequence = angular.isDefined(vm.model.catalogSeasonalSequence) ? vm.model.catalogSeasonalSequence : catalogFactory.getActiveCatalogDetails().SeasonalSequence;

    /**
     * chartViewDataCount is a map of reportable properties(columns) which include map of unique values of that property and their count for active and total(active and inactive) records
     * if user perform any item action or list action regardless of data being change this will be reassign to empty object, to achieve that
     * it will be assigned to empty object (when data changes) inside data watch callback since in most of actions refresh will be called which will trigger the watch or if model is dirty
     * for those actions where refresh record method does not get called
     * drawback is even if user refresh record this information will be cleared
     */
    var chartViewDataCount = {};
    var isGlobalChartsDirty = false; // identify unsaved changes in charts view
    var isUserChartsDirty = false; // identify unsaved changes in charts view
    var beforeExitValues = {}; // values needs to be captured before directive exist event get called, (values which may differ after the event call)
    var timeoutPromises = {};
    var watchUnsubscribers = {};
    var supportedImageSizes; // will be initialize if view supports images view
    var selectedRowsIndices = [];
    // #changeManagement (generic)
    vm.enableSelectionDropdown = (angular.isUndefined(vm.disableSelectionDropdown) || vm.disableSelectionDropdown === 'false');
    // #changeManagement (generic)
    vm.enableSelection = (angular.isUndefined(vm.disableSelection) || vm.disableSelection === 'false');
    vm.enableExport = (angular.isUndefined(vm.disableExport) || vm.disableExport === 'false');
    vm.enableModuleListActions = (angular.isUndefined(vm.disableModuleListActions) || vm.disableModuleListActions === 'false');
    var assignedContextKey = catalogFactory.getCatalogContextKey();
    vm.duneImageSource = {};
    var virtualRepeatScroller = undefined;
    var resizableColumnsContainer = undefined;
    var filterResizableColumnsContainer = undefined
    var previousvirtualRepeatScrollerScrollLeftPosotion = 0
    var defaultColumnWidth = 175;
    var isLoadingNextPage = false;
    vm.isArticleAssetsLoading = false;
    var dataSourceTypeId = catalogFactory.getActiveCatalogDetails().DataSourceTypeId; // used for articles status type
    vm.api = api;
    vm.isLoadingNextPage = false;
    vm.onVirtualRepeaterNearBottom = function() { triggerLoadNextPage(); };

    //methods

    vm.internalControl = {
      selectAll: doSelectAll,
      export: doExport,
      updateData: updateData
    };

    //toolbar methods (left corner)
    vm.doSelectAll = doSelectAll;
    vm.doExport = doExport;
    vm.doListAction = doListAction;
    vm.doProcessOrderListAction = doProcessOrderListAction;
    vm.doChangeManagementListAction = doChangeManagementListAction;
    vm.doMerchBoradViewChange = doMerchBoradViewChange;

    //toolbar methods (right corner)
    vm.onActiveTreeChange = onActiveTreeChange;
    vm.onPredefinedFilterChange = onPredefinedFilterChange;
    vm.doSwitchView = doSwitchView;
    vm.changeImagesSize = changeImagesSize;
    vm.doShowCharts = doShowCharts;
    vm.updateColumnFilterBasedOnToggleVal = updateColumnFilterBasedOnToggleVal;
    vm.openFilterByDateDialog = openFilterByDateDialog;
    vm.switchToggleFilter = switchToggleFilter;
    vm.onFilterChange = onFilterChange;
    vm.doShowColumnChooser = doShowColumnChooser;
    vm.doRefreshAction = doRefreshAction;
    vm.doSaveColumn = doSaveColumn;
    vm.onPredefinedColumnsChange = onPredefinedColumnsChange;
    vm.onAttributeGroupChange = onAttributeGroupChange;

    //table header methods
    vm.doSort = doSort;
    vm.onSortIconClick = onSortIconClick;
    vm.onHeaderLongTouch = onHeaderLongTouch;
    vm.onHeaderShortTouch = onHeaderShortTouch;
    vm.persistColsWidth = persistColsWidthRatio;
    vm.doSaveFilter = doSaveFilter;

    // record level methods
    vm.onSelectChange = onSelectChange;
    vm.onCheckboxClick = onCheckboxClick;
    vm.doItemAction = doItemAction;
    vm.doItemClick = doItemClick;
    vm.doItemRightClick = doItemRightClick;
    vm.doOrderItemAction = doOrderItemAction;
    // vm.isActionDisabled = isActionDisabled; // not use in template/** */
    vm.registerHotkeys = registerHotkeys;
    // vm.gotoRecord = gotoRecord; // not use in template/** */

    // vm.getRecordValue = getRecordValue; // use nowhere/** */

    vm.doDeleteChart = doDeleteChart;
    vm.addChart = addChart;
    vm.doSwitchCollectionsView = doSwitchCollectionsView;
    vm.downloadDuneImage = downloadDuneImage;
    vm.virtualRepeatAddScrollEventListener = virtualRepeatAddScrollEventListener;
    vm.getArticleStatusValues = getArticleStatusValues;

    dragulaService.options($scope, 'bag-one', {
      direction: 'horizontal'
    });

    vm.dataProvider = {
      getItemAtIndex: dpGetItemAtIndex,
      getLength: dpGetLength,
      _count: 0,
      _refresh: function() {
        this._count++;
      }
    };

    //** */
    // vm.headerSortableOptions = { // not in use anymore
    //     orderChanged: function (ev) {
    //         updateCols();
    //     }
    // };

    // vm.applyAdvanceFilter = applyAdvanceFilter;

    // vm.addImages = addImages; //not required anymore, can dissolve dependency to infinite scroll


    //vm.view.columnFilter = {};
    //vm.view.showFilterRow = false;

    //Initialize Values
    activate();

    watchUnsubscribers.data = $scope.$watch('vm.data', function(newVal) {
      if(newVal && angular.isDefined(newVal)) {
        // Reset pagination loading flag when new data arrives
        isLoadingNextPage = false;
        vm.isLoadingNextPage = false;
        // #changeManagement
        calculateChangeManagementListActionStatus();
        var topIndex = vm.view.topIndex;

        vm.view.topIndex = 0;
        timeoutPromises.updateData = $timeout(
          function() {
            updateData(topIndex);
        });
      }
    });// can be remove
    watchUnsubscribers.colsList = $scope.$watchCollection('vm.colsList', updateCols);
    // watchUnsubscribers.filter = $scope.$watchCollection('vm.filter',updateFilteredData); // not required any more

    var stateChangeListener = $scope.$on('$stateChangeStart', onBeforeExit);
    $window.addEventListener('beforeunload', onBeforeExit);

    // get called from two different event listener hence the event object will be different
    function onBeforeExit(event) {
      // persist chart view data
      if(vm.supportChartsView && (isGlobalChartsDirty || isUserChartsDirty)) {
        event.returnValue = "Changes you made may not be saved.";
        // persist charts view details
        persistChartsView();
      }
    }

    $scope.$on('$destroy', function () {
      $window.removeEventListener('resize', onResize);
      $window.removeEventListener('beforeunload', onBeforeExit);
      virtualRepeatScroller.removeEventListener('scroll', onScroll);
      stateChangeListener();
      toggleFullScreenEventCleanup();
      //unsubscribe all watchers
      for (var prop in watchUnsubscribers) {
        watchUnsubscribers[prop]();
      }
      //cancel all timeout promises
      for(var key in timeoutPromises) {
        $timeout.cancel(timeoutPromises[key]);
      }
      dragulaService.destroy($scope, 'bag-one');
      $scope.element = null;
    });

    var toggleFullScreenEventCleanup = $rootScope.$on('toggleFullScreenResizeListEvent', defineToggleFullScreenVariable);

    ////////
    function activate() {
      vm.isChartLoading = false;
      vm.supportChartsView = false;
      beforeExitValues.isCatalogModule = vm.model.isCatalogSpecificModel;
      // store active catalog details for catalog modules use to get catalog details before active catalog changes while saving charts
      if(vm.model.isCatalogSpecificModel) {
        beforeExitValues.activeCatalogDetails = catalogFactory.getActiveCatalogDetails();
      }

      vm.listStyle = {
        height: ($window.innerHeight - 324 - (vm.view.showFilterRow ? 85 : 0)) + 'px'
      }

      vm.isTrasix = $localStorage.account.accountType === '1' ? true : false;

      vm.fields = vm.model.fields;

      if (vm.chartViewEnabled === "false") {
        vm.supportChartsView = false;
      } else {
        for (var i = 0, len = vm.fields.length; i < len; i++) {
          if (angular.isDefined(vm.fields[i].reportable) && vm.fields[i].reportable) {
            vm.supportChartsView = true;
            if (angular.isUndefined(vm.view.chartFilter)) { // just to make its existence declarative in controller
              vm.view.chartFilter = undefined;
            }
            initializeChartsView();
            break;
          }
        }
      }

      if (angular.isUndefined(vm.supportImagesView)) {
        vm.supportImagesView = false;
      } else {
        vm.supportImagesView = (vm.supportImagesView === 'true');
      }
      if (vm.supportImagesView) {
        if(!vm.view.imagesSize) {
          vm.view.imagesSize = 'large'; // if imagesSize not added for module support image view, add dynamically to model
        }
        if(!supportedImageSizes) {
          supportedImageSizes = mockFactory.getSupportedImageSizes();
        }
        vm.imagesSizeInfo = supportedImageSizes[vm.view.imagesSize];
      }
      // this is used for t1 dune images view in template
      if(angular.isDefined(vm.isDuneImagesView) && vm.isDuneImagesView) {
        vm.isDuneImagesView = true;
      } else {
        vm.isDuneImagesView = false;
      }
      if (angular.isUndefined(vm.supportFilterByDate)) {
        vm.supportFilterByDate = false;
      } else {
        vm.supportFilterByDate = (vm.supportFilterByDate === 'true');
      }
      if( vm.supportFilterByDate && (angular.isUndefined(vm.view.filterByDate) || !angular.isObject(vm.view.filterByDate)) ) {
        vm.view.filterByDate = {};
      }

      if(angular.isDefined(vm.showTreeListDropdown) && vm.showTreeListDropdown) {
        vm.catalogTreeList = utility.filterObject(catalogFactory.getActiveCatalogDetails().TreeDefination, {Status: 1});
        vm.activeCatalogTree = catalogFactory.getActiveCatalogTree();
      }

      // if (angular.isUndefined(vm.model.imagesLimit)) { note required anymore since no more limit on images
      //     vm.model.imagesLimit = 25;
      // }

      if (angular.isUndefined(vm.model.currentViewType)) {
        vm.model.currentViewType = 0;
      }
      // when navigating back to a page with chart view open
      else if(vm.model.currentViewType == 2) {
        modifyInterfaceForChartView(true);
        // since it is not being store in model and it store in directive local variable charts in chartConfigObj will be recreated after navigation between modules
        initializeChartData();
      }

      // vm.anyListActionAllowed = isAnyAction(vm.view.listActions);// use no where/** */
      vm.anyItemActionAllowed = isAnyAction(vm.view.itemActions);
      vm.isToggleFilterDefined = isToggleFilterDefined();
      loadLookupData();
      syncToggleStatusAndColumnFilterStatusProperty();
      updateColumnFilterBasedOnToggleVal();
      timeoutPromises.initializeColumnsWidth = $timeout(initializeColumnsWidth);
      $window.addEventListener('resize', onResize);
      timeoutPromises.resize = $timeout(onResize, 500);

      //Load Predefined filters
      loadPredefinedFilters();
      determineListActionsStatus();
      loadPredefinedColumns();
    }

    // add scroll event listener to virtual repeat scroller once when virtual repeat container loaded in DOM
    function virtualRepeatAddScrollEventListener() {
      virtualRepeatScroller =  $scope.element[0].querySelector('.md-virtual-repeat-container .md-virtual-repeat-scroller');
      // also initialize resizableColumnsContainer and filterResizableColumnsContainer to avoid searching DOM on scroll
      if(angular.isUndefined(resizableColumnsContainer)) {
        resizableColumnsContainer = $scope.element[0].querySelector('#resizable-cols-container'); // list view resizable columns header container
      }
      filterResizableColumnsContainer = $scope.element[0].querySelector('.filter-resizable-cols-container'); // list view filter column container
      virtualRepeatScroller.addEventListener('scroll', onScroll);
    }

    function triggerLoadNextPage() {
      if (isLoadingNextPage || !vm.hasMorePages || !vm.loadNextPageEvent) return;
      isLoadingNextPage = true;
      vm.isLoadingNextPage = true;
      vm.loadNextPageEvent();
    }

    function updateData(topIndex) {
      // vm.supportImagesView == true does not work
      if((vm.supportImagesView === 'true' || vm.supportImagesView === true)
        && angular.isDefined(vm.data) && vm.data.length > 0 && !vm.data[vm.data.length-1].hasOwnProperty('ImageSource')) {
          addImageSource(vm.data);
      }

      // to check if group selection based on Status field is possible
      vm.canSelectBasedOnStatusField = (angular.isDefined(vm.data) && angular.isDefined(vm.data[0])
        && angular.isDefined(vm.data[0][vm.statusField]) && (vm.data[0][vm.statusField] == 1 || vm.data[0][vm.statusField] == 0) )  ? true : false;

      // regardless of being in chart view or not empty out chartViewDataCount on refresh (and any action which makes data dirty and call refresh)
      // to make sure we have update data count if data being dirty
      chartViewDataCount = {};
      if(vm.model.currentViewType == 2) {
        createChartsData(vm.chartsConfigObj.charts, getChartViewDataCount(), true);
      }

      onSelectChange();
      vm.filteredData = $filter('dataTableFilter')(vm.data, vm.view.columnFilter, vm.model, vm.lookupData);
      // custom order by filter to filter
      vm.filteredData = $filter('txDataTableOrderBy')(vm.filteredData, generateSortPredicate(vm.view.sortColumn), vm.lookupData, vm.model);
      if (angular.isUndefined(vm.filteredData)) {
        return;
      }

      if(angular.isDefined(vm.model.modelPath) && (vm.model.modelPath === 'orders.orderlines' || vm.model.modelPath === 'orders.rejectedOrderlines')) { // to evaluate orderline Status value; inputType must be orderlineStatus
        evaluateOrderlineStatusValue(vm.filteredData);
      } else if(angular.isDefined(vm.model.modelPath) && vm.model.modelPath === 'forecast.articles') { // to evaluate forecast line Status value; inputType must be forecastLineStatus
        evaluateForecastLineStatusValue(vm.filteredData);
      }
      vm.filteredDataLength = vm.filteredData.length;
      // when there is no filtered data show scrollbar to scroll the column headers
      if(vm.filteredDataLength === 0) {
        assignTotalColumnWidthToVirtualReaptWhenNoFilteredValues();
      } else {
        // remove height class from md-virtual-repeat-sizer
        removeClassFromVirtualRepeatSizer();
      }
      vm.dataLength = vm.data.length;
      timeoutPromises.setTopIndex = $timeout(function() { vm.view.topIndex = topIndex; });

      vm.dataProvider._refresh();
      if((vm.supportImagesView === 'true' || vm.supportImagesView === true) && vm.model.currentViewType === 1) {
        if(!vm.isDuneImagesView) {
          vm.articlesWithAssets = undefined;
          vm.isArticleAssetsLoading = true;
          catalogFactory.getCatalogArticleNumbersWithDuneImagesArray(vm.filteredData).then(function(articleAssetsResponse) {
            vm.articlesWithAssets = angular.isDefined(articleAssetsResponse) ? articleAssetsResponse.articlesWithAssets : [];
            vm.articlesWithDuneImage = angular.isDefined(articleAssetsResponse) ? articleAssetsResponse.carryOverArticleAssetsArray : [];
          }).finally(function () {
            vm.isArticleAssetsLoading = false;
          });
        }
      }
    }

    function updateFilteredData() {
      if (angular.isUndefined(vm.data)) {
        return;
      }

      vm.filteredData = $filter('dataTableFilter')(vm.data, vm.view.columnFilter, vm.model, vm.lookupData);
      // custom order by filter to filter
      vm.filteredData = $filter('txDataTableOrderBy')(vm.filteredData, generateSortPredicate(vm.view.sortColumn), vm.lookupData, vm.model);
      if (angular.isUndefined(vm.filteredData)) {
        return;
      }

      vm.filteredDataLength = vm.filteredData.length;
      vm.dataLength = vm.data.length;
      // when there is no filtered data show scrollbar to scroll the column headers
      if(vm.filteredDataLength === 0) {
        assignTotalColumnWidthToVirtualReaptWhenNoFilteredValues();
      } else {
        // remove height class from md-virtual-repeat-sizer
        removeClassFromVirtualRepeatSizer();
      }

      // vm.model.imagesLimit = 25; not required

      vm.dataProvider._refresh();
    }

    function showFilterRowUpdated(isFilterRowOpen) {
      if (!isFilterRowOpen) {
        //remove all the filter property of columnFilter(expect toggle filter property) when filter row closed
        var columnFilterCopy = angular.copy(vm.view.columnFilter);
        for(var property in columnFilterCopy) {
          if(vm.isToggleFilterDefined && property == vm.view.toggleFilterProps.filterProp && columnFilterCopy[property] == vm.view.toggleFilterProps.trueVal) {
            continue;
          }
          delete columnFilterCopy[property];
        }
        vm.view.columnFilter = columnFilterCopy;
        vm.selectedFilter = undefined;
        updateFilteredData();
      }
    }

    function initializeColumnsWidth() {
      if(angular.isDefined(vm.view.columnsWidthRatioMap) && !utility.isObjectEmpty(vm.view.columnsWidthRatioMap)) {
        var colsContainer = null;
        var colsContainerWidth = null;
        if($scope.element && angular.isUndefined(resizableColumnsContainer)) {
          resizableColumnsContainer = $scope.element[0].querySelector('#resizable-cols-container');
        }
        if(angular.isDefined(resizableColumnsContainer)) {
          colsContainer = angular.element(resizableColumnsContainer)
        }

        if(angular.isDefined(colsContainer)) {
          colsContainerWidth = colsContainer.width();
          vm.resizableColsContainerWidth = colsContainerWidth;
          colsContainer = null;
        }
        else {
          $log.warn('Could not get columns container element');
          colsContainerWidth = 1000;
        }
        // initialize colsWidth for each column by converting col width to cols-container width ratio to width in pixel
        for(var key in vm.view.columnsWidthRatioMap) {
          vm.colsWidth[key] = vm.view.columnsWidthRatioMap[key] * colsContainerWidth;
        }
      }
      else {
        vm.view.columnsWidthRatioMap = {};
      }
    }

    function onResize(ev) {
      if (angular.isDefined($scope.element)) {
        var toolbar = angular.element($scope.element[0].querySelector('.table-toolbar'));
        var toolbarHeight = 0;
        var listHeader = angular.element($scope.element[0].querySelector('.list-header'));
        var listHeaderHeight = 0;
        if (toolbar) {
          toolbarHeight = toolbar.outerHeight();
        }
        if (listHeader) {
          listHeaderHeight = listHeader.outerHeight();
        }

        vm.listHeight = ($window.innerHeight - $scope.element.offset().top - $scope.vm.heightOffset - listHeaderHeight - (vm.view.showFilterRow ? 85 : 0) - toolbarHeight);
        // for setting list height when toggling btw fullscreen and normal view
        if(angular.isDefined(vm.isFullScreen)) {
          timeoutPromises.toggleFullScreen = $timeout(function() {
            var windowWidth = $window.innerWidth * $window.devicePixelRatio;
            var windowHeight = $window.innerHeight * $window.devicePixelRatio;
            var screenWidth = $window.screen.width;
            var screenHeight = $window.screen.height;
            if (((windowWidth/screenWidth) >= 0.95) && ((windowHeight/screenHeight) >= 0.95)) {
                console.log("Fullscreen");
                vm.listStyle.height = vm.listHeight + 64 + 'px';
            }
            else {
                console.log("Not Fullscreen");
                vm.listStyle.height = vm.listHeight - 64 + 'px';
            }
          }, 100);
        } else {
          vm.listStyle.height = vm.listHeight + 'px';
        }
        calculateColumnsWidth();

        if (!$scope.$root.$$phase) {
          $scope.$digest();
        }
        $scope.$broadcast('$md-resize');
      }
    }
    // set scroll left for resizableColumnsContainer and FilterResizableColumnsContainer when scrolling visrtual repeater horizontally
    function onScroll() {
      if(previousvirtualRepeatScrollerScrollLeftPosotion !== virtualRepeatScroller.scrollLeft) {
        // will restrict virtualRepeatScroller scroll above resizableColumnsContainer to avoid drag handler getting hidden behind actions label ||
        var maxScroll = resizableColumnsContainer.scrollWidth - resizableColumnsContainer.clientWidth;
        if(virtualRepeatScroller.scrollLeft <= maxScroll) {
          resizableColumnsContainer.scrollLeft = virtualRepeatScroller.scrollLeft;
          filterResizableColumnsContainer.scrollLeft = virtualRepeatScroller.scrollLeft;
          previousvirtualRepeatScrollerScrollLeftPosotion = virtualRepeatScroller.scrollLeft;
        } else {
          resizableColumnsContainer.scrollLeft = virtualRepeatScroller.scrollLeft;
          virtualRepeatScroller.scrollLeft = resizableColumnsContainer.scrollLeft;
          filterResizableColumnsContainer.scrollLeft = resizableColumnsContainer.scrollLeft;
          previousvirtualRepeatScrollerScrollLeftPosotion = resizableColumnsContainer.scrollLeft;
        }
      }

      // Detect near-bottom for list view pagination
      if (vm.loadNextPageEvent && vm.hasMorePages && !isLoadingNextPage) {
        var scrollBottom = virtualRepeatScroller.scrollTop + virtualRepeatScroller.clientHeight;
        if (scrollBottom >= virtualRepeatScroller.scrollHeight - 200) {
          $scope.$apply(function() {
            triggerLoadNextPage();
          });
        }
      }
    }

    function calculateColumnsWidth(resetColsWidth) {
      var resizableColsContainer = angular.element( $scope.element[0].querySelector( '#resizable-cols-container' ));
      if(resizableColsContainer) {
        vm.resizableColsContainerWidth = resizableColsContainer.width();
      }

      // if columns width ratio persisted on database & calculateColumnsWidth not being called from updateCols method(no new col added) or being called from onResize method retrieve the store columns width
      if(angular.isDefined(vm.view.columnsWidthRatioMap) && !utility.isObjectEmpty(vm.view.columnsWidthRatioMap) && !resetColsWidth) {
        var totalColumnWidth = 0;
        angular.forEach(vm.view.columns, function(itm) {
          totalColumnWidth += vm.view.columnsWidthRatioMap[itm] * vm.resizableColsContainerWidth;
        });
        if(totalColumnWidth < vm.resizableColsContainerWidth) {
          assignEqualColumnWidth();
        } else {
          angular.forEach(vm.view.columns, function(itm) {
            vm.colsWidth[itm] = vm.view.columnsWidthRatioMap[itm] * vm.resizableColsContainerWidth;
          });
        }
      }
      else {
        assignEqualColumnWidth();
      }
    }

    function assignEqualColumnWidth() {
      vm.colsWidth = {};
      vm.view.columnsWidthRatioMap = {};
      var totalColumnWidth = vm.view.columns.length * 175;
      // if total column width (number of columns * 175) is greater than 950 we will add default with as column width. else we will calculate based on resizableColsContainerWidth
      // initialize coulmn with for the columns that have never been rendered (there is no cache value) and also their width ratio according to current total width of coulmns

        if(totalColumnWidth < vm.resizableColsContainerWidth) {
          angular.forEach(vm.view.columns, function(itm) {
            vm.colsWidth[itm] = (vm.resizableColsContainerWidth) / vm.view.columns.length;
            vm.view.columnsWidthRatioMap[itm] = vm.colsWidth[itm] / vm.resizableColsContainerWidth;
          });
        } else {
          vm.resizableColsContainerWidth = 0;
          angular.forEach(vm.view.columns, function(column) {
            vm.colsWidth[column] = defaultColumnWidth;
            vm.resizableColsContainerWidth += vm.colsWidth[column];
            // to show always the drag handler reducing 5px from the width
            vm.resizableColsContainerWidth -= 5;
            vm.view.columnsWidthRatioMap[column] = .175;
          });
        }
    }

    function updateCols() {
      vm.view.columns.splice(0, vm.view.columns.length);
      for (var i = 0; i < vm.colsList.length; i++) {
        vm.view.columns.push(vm.colsList[i].field);
      }
      calculateColumnsWidthAndRatioForUnCachedColumns();

      // reset columns width if total width of all the redered columns are less then table width when updating columns
      var shouldResetColumnsWidth = vm.resizableColsContainerWidth < angular.element(resizableColumnsContainer).width();
      calculateColumnsWidth(shouldResetColumnsWidth);
      // set the total column width
      vm.model['totalTableColumnWidth'] = vm.resizableColsContainerWidth
      settingsFactory.persistListViewLayout(vm.model);
      loadLookupData();
      initializeFilterValueForBooleanFields(); // in order to display filters default label for boolean nature fields, they should be assigned to ''
    }

    /**
     * @description // initialize coulmn with for the columns that have never been rendered (there is no cache value) and also their width ratio according to current total width of coulmns
     */
    function calculateColumnsWidthAndRatioForUnCachedColumns() {
      if(angular.isUndefined(vm.view.columnsWidthRatioMap)) {
        vm.view.columnsWidthRatioMap = {}
      } else {
        vm.resizableColsContainerWidth = 0;
        // calculate total width occupied by columns which are currently rendered
        angular.forEach(vm.view.columns, function(column) {
          if(angular.isDefined(vm.colsWidth[column])) {
            vm.resizableColsContainerWidth += vm.colsWidth[column];
          }
        });
        // initialize coulmn with for the columns that have never been rendered (there is no cache value) and also their width ratio according to current total width of coulmns
        angular.forEach(vm.view.columns, function(column) {
          if((angular.isUndefined(vm.colsWidth[column]) || vm.colsWidth[column] === 0 ) && (angular.isUndefined(vm.view.columnsWidthRatioMap[column]) || vm.view.columnsWidthRatioMap[column] === null)) {
            vm.colsWidth[column] = defaultColumnWidth;
            vm.resizableColsContainerWidth += vm.colsWidth[column];
            vm.view.columnsWidthRatioMap[column] = .175;
          }
        });
      }
    }

    function onSelectChange(rowIndex) {
      if(angular.isDefined(rowIndex)) {
        vm.activeRow = rowIndex;
      }
      var c = 0;

      for (var i=0; i<vm.dataLength; i++) {
        if (vm.data[i] && vm.data[i].selected) {
          c++;
        }
      }
      determineListActionsStatus();
      vm.selectedRecordsLength = c;
    }

   /**
    * @description
    * This method will select multiple records.
    * @param {int} currentIndex: index of current row
    * @param {object} event: $event object
    * @returns {object} record: current selected record
    */
    function onCheckboxClick(currentIndex, event, record) {
      event.stopPropagation();
      var selectedRowsCount = 0;
      if (record.selected) {
        selectedRowsIndices.push(currentIndex);
        if (event.shiftKey) {
          var lastIndex = selectedRowsIndices[selectedRowsIndices.length - 2];
          if (lastIndex < currentIndex) {
            selectedRowsCount = currentIndex - lastIndex + 1;
            //select rows in between
            for (var indexOfRows = lastIndex; indexOfRows <= currentIndex; indexOfRows++) {
              vm.filteredData[indexOfRows].selected = true;
            }
            // deselect other rows
            for (var index = 0; index < vm.filteredData.length; index++) {
              if (index < lastIndex || index > currentIndex) {
                vm.filteredData[index].selected = false;
              }
            }
          } else {
            selectedRowsCount = lastIndex - currentIndex + 1;
            //select rows in between
            for (var indexOfRows = currentIndex; indexOfRows <= lastIndex; indexOfRows++) {
              vm.filteredData[indexOfRows].selected = true;
            }
            // deselect other rows
            for (var index = 0; index < vm.filteredData.length; index++) {
              if (index < currentIndex || index > lastIndex) {
                vm.filteredData[index].selected = false;
              }
            }
          }
          vm.selectedRecordsLength = selectedRowsCount;
        }
      } else {
        //remove current index if the checkbox is unchecked
        selectedRowsIndices = selectedRowsIndices.filter(function (item) {
          return item !== currentIndex;
        })
      }
    }

    function doSelectAll(filterString) {
      if(angular.isDefined(filterString) && !angular.isString(filterString)) { // since not in all the module (orlderlines) `Status` property represent Status of record
        var value = filterString;
        filterString = {};
        filterString[vm.statusField] = value;
      }

      vm.allSelected = utility.selectBasedOnFilterString(vm.filteredData, filterString, vm.allSelected);
      vm.onSelectChange();
    }

    function doExport() {
      var defaultOpt = '0';
      var isRequestModule = false;
      if (vm.selectedRecordsLength > 0) {
        //Set default to `Selections`
        defaultOpt = '2';
      } else if (vm.data.length != vm.filteredData.length) {
        //Set default to `Filtered Data`
        defaultOpt = '1';
      }
      // specific for request module
      if(angular.isDefined(vm.model) && vm.model.modelPath !== 'catalogs.requests') {
        dataExporter.exportExcel(vm.model, vm.data, vm.filteredData, vm.lookupData, vm.colsList, defaultOpt, isRequestModule);
      } else {
        isRequestModule = true;
        var requestExportModel = api.catalogs.exportRequests;
        var exportColumnList = requestExportModel.fields;
        dataExporter.exportExcel(requestExportModel, vm.data, vm.filteredData, vm.lookupData, exportColumnList, defaultOpt, isRequestModule);
      }
    }

    function doListAction(action) {
       if (angular.isFunction(vm.listActionEvent)) {
        var selectedItems = [];
        selectedItems = utility.filterObject(vm.filteredData, { selected: true }, true);
        if (action.requiresConfirmation) {
            dialog.confirm(action.confirmationContent, action.confirmationAction, selectedItems, vm.model, action)
              .then(function (response) {
                if (response.userAction.toLowerCase() === 'confirm') {
                  vm.listActionEvent({ action: action, selectedItems: selectedItems, additionalInfo: response });
                  // specific to dune images module if this is to activate/ deactivate we need to call the download dune images
                  if(vm.model.currentViewType === 1 && vm.isDuneImagesView && (action.id === 'delete' || action.id === 'activate')) {
                    timeoutPromises.duneImageStatusChange = $timeout(function() {
                      angular.forEach(selectedItems, function(item) {
                          item.Status = action.id === 'delete' ? 0 : 1;
                          downloadDuneImage(item, true);
                      });
                    }, 500);
                  }
                }
              });
          }
          else {
            vm.listActionEvent({ action: action, selectedItems: selectedItems, additionalInfo: {} });
          }
        }
      }

    function doProcessOrderListAction(action) {
      if (angular.isFunction(vm.processOrderListActionEvent)) {
        var selectedItems= [];
        selectedItems = utility.filterObject(vm.filteredData, {selected : true}, true);

        if(action.requiresConfirmation){
          dialog.confirm(action.confirmationContent, action.confirmationAction, selectedItems, vm.model)
          .then(function(response){
            if(response.userAction.toLowerCase() === 'confirm') {
              vm.processOrderListActionEvent({action: action, selectedItems: selectedItems});
            }
          });
        }
        else{
          vm.processOrderListActionEvent({action: action, selectedItems: selectedItems});
        }
      }
    }

    // #changeManagement
    function doChangeManagementListAction(action) {
      if (angular.isFunction(vm.changeManagementListActionEvent)) {

        if(action.requiresConfirmation){
          dialog.confirm(action.confirmationContent, action.confirmationAction, [], vm.model)
          .then(function(response){
            if(response.userAction.toLowerCase() === 'confirm') {
              vm.changeManagementListActionEvent({action: action});
            }
          });
        }
        else{
          vm.changeManagementListActionEvent({action: action});
        }
      }
    }

    // merch list view change
    function doMerchBoradViewChange(action) {
      if (angular.isFunction(vm.merchBoradViewChangeEvent)) {
        vm.merchBoradViewChangeEvent({action: action});
      }
    }

    function onActiveTreeChange(tree) {
      if (angular.isDefined(tree)) {
        vm.activeCatalogTree = tree;
        catalogFactory.setActiveCatalogTree(tree);
        $scope.$emit('ActiveCatalogTreeChangedEvent', vm.activeCatalogTree);
      }
    }

    function onPredefinedFilterChange() {
      if (angular.isDefined(vm.selectedFilter) && angular.isDefined(vm.selectedFilter.filter)) {
        vm.switchToggleFilter(true);
        vm.view.columnFilter = angular.copy(vm.selectedFilter.filter);
        vm.view.sortColumn = vm.selectedFilter.sort ? angular.copy(vm.selectedFilter.sort) : vm.view.sortColumn;
        updateFilteredData();
      }else{
        vm.switchToggleFilter(false);
      }
    }

    // the module owns the fetch, this only reports that the user picked another attribute group.
    // the new id must be handed over explicitly: ng-change runs before the two way binding has synced
    // selectedAttributeGroupId back to the module, so the module's own property is still the previous value here.
    function onAttributeGroupChange() {
      if (angular.isFunction(vm.attributeGroupChangeEvent)) {
        vm.attributeGroupChangeEvent({ attributeGroupId: vm.selectedAttributeGroupId });
      }
    }

    function doSwitchView() {
      if (vm.model.currentViewType === 4) { // currently list view changed from tree view
        vm.model.currentViewType = 3
      }  else if (vm.supportImagesView && vm.model.currentViewType !== 1) {
        vm.model.currentViewType = 1;
        // specific for articles  images view. We will call downloadDuneImages only if the article have asset in dune
        // for that we will first call the getAssets with filter
        vm.isDuneImagesModel = (angular.isDefined(vm.model) && vm.model.modelPath === 'catalogs.t1Dune') ? true : false;
        if(!vm.isDuneImagesView) {
          vm.isArticleAssetsLoading = true;
          catalogFactory.getCatalogArticleNumbersWithDuneImagesArray(vm.filteredData).then(function(articleAssetsResponse) {
            vm.articlesWithAssets = angular.isDefined(articleAssetsResponse) ? articleAssetsResponse.articlesWithAssets : [];
            vm.articlesWithDuneImage = angular.isDefined(articleAssetsResponse) ? articleAssetsResponse.carryOverArticleAssetsArray : [];
          }).finally(function () {
            vm.isArticleAssetsLoading = false;
          });
        }
      } else {
        vm.model.currentViewType = 0;
      }
      // if switching from chart view to any other view revert changes
      modifyInterfaceForChartView(false);
    }

    function doSwitchCollectionsView(id) {
      if(angular.isFunction(vm.switchCollectionsViewActionEvent)) {
          vm.switchCollectionsViewActionEvent({id: id});
      }
    }

    // we will download the dune image and create duneImageSource map to avaoid ng-src with infinte loops
    function downloadDuneImage(item, isImagesViewAction) {
      var assetStorageFile;
      if(!vm.isDuneImagesView) {
        if(angular.isDefined(vm.articlesWithAssets)) {
          // images will be downloaded with assetStorageFile
          var duneImageArticle = utility.filterObject(vm.articlesWithDuneImage, {articleNumber: item.ArticleNumber}, true)[0];
          if(angular.isDefined(duneImageArticle)) {
            assetStorageFile = duneImageArticle.assetStorageFile;
          }
          var isArticleHasDuneImage = vm.articlesWithAssets.includes(item.ArticleNumber);
          if (!isArticleHasDuneImage || angular.isUndefined(duneImageArticle)) {
            vm.duneImageSource[item.Id] = {
              contentType: 'data:image/png;base64',
              imageDataUri: CONSTANTS.IMAGE_NOT_AVAILABLE_DATA_URI
            };
            return;
          }
        }
      } else {
        // dune images will be downloaded with StorageFile
        assetStorageFile = item.StorageFile;
      }

      // for dune image which is edited, clear cache so the updated image is downloaded again
      if(angular.isDefined(vm.currentDuneImageForEdit) && (vm.currentDuneImageForEdit.Id === item.Id)) {
        delete vm.duneImageSource[item.Id];
        vm.currentDuneImageForEdit = undefined;
      }

      if(!utility.isObjectEmpty(vm.duneImageSource) && vm.duneImageSource[item.Id] && !isImagesViewAction) {
        if(item.Status || item.Status === 1) {
          return vm.duneImageSource[item.Id];
        } else {
          vm.duneImageSource[item.Id] = {
            contentType: 'data:image/png;base64',
            imageDataUri: CONSTANTS.IMAGE_NOT_AVAILABLE_DATA_URI
          };
        }
      } else {
        // Dune Images Module: download images only for active dune images as API is giving error as "ErrorMessage": "InValid Asset Id. Asset Id 1f0922eb-064c-ea11-a94c-000d3a211414 is not Active"
        if((vm.isDuneImagesView && item.Status) || !vm.isDuneImagesView) {
          delete vm.duneImageSource[item.Id];
          api.catalogs.t1Dune.methods.downloadDuneImage(assetStorageFile, assignedContextKey).then(function(response) {
            vm.duneImageSource[item.Id] = response;
          }).catch(function (error) {
            vm.duneImageSource[item.Id] = {
              contentType: 'data:image/png;base64',
              imageDataUri: CONSTANTS.IMAGE_NOT_AVAILABLE_DATA_URI
            };
          });
        } else {
          if(isImagesViewAction) {
            delete vm.duneImageSource[item.Id];
          }
          vm.duneImageSource[item.Id] = {
            contentType: 'data:image/png;base64',
            imageDataUri: CONSTANTS.IMAGE_NOT_AVAILABLE_DATA_URI
          };
        }
      }
    }

    //change images sizes and update the model to track the last images size selected value
    // show next and previous size buttons in menu to switch between sizes
    function changeImagesSize(currentSize) {
      vm.imagesSizeInfo =  supportedImageSizes[currentSize];
      vm.view.imagesSize = vm.imagesSizeInfo['size'];
      $scope.$broadcast('ImageSizeChangeEvent');
    }

    //if columnFilter is defined for the filter property of toggle filter then assign the same value to toggle filter's filter property. So that both filters remain in sync
    function syncToggleStatusAndColumnFilterStatusProperty(){
      if(vm.isToggleFilterDefined && angular.isDefined(vm.view.columnFilter[vm.view.toggleFilterProps.filterProp])) {
        vm.view.toggleFilterProps.toggleStatus = vm.view.columnFilter[vm.view.toggleFilterProps.filterProp] == vm.view.toggleFilterProps.trueVal
      }
    }

    function updateColumnFilterBasedOnToggleVal() {
      if(vm.isToggleFilterDefined) {// since on data load it will start to filter, check if toggle filter required at all or not
        if(vm.view.toggleFilterProps.toggleStatus === true) {
          vm.view.columnFilter[vm.view.toggleFilterProps.filterProp] = vm.view.toggleFilterProps.trueVal || '';
        }
        else {
          vm.view.columnFilter[vm.view.toggleFilterProps.filterProp] = vm.view.toggleFilterProps.falseVal || '';
        }
        updateFilteredData();
      }
    }

    function openFilterByDateDialog() {
      $mdDialog.show({
        controller         : 'filterByDateController',
        controllerAs       : 'vm',
        templateUrl        : 'app/directives/txDataTable/dialogs/filter-by-date-editor/filter-by-date-editor.html',
        parent             : angular.element($document[0].body),
        targetEvent        : event,
        clickOutsideToClose: false,
        locals             : {
          model: vm.model
        }
      }).then(function(dates) {
        if (dates) {
          doRefreshAction();
        }
      });
    }

    function switchToggleFilter(show) {
      if (angular.isUndefined(show)) {
        vm.view.showFilterRow = !vm.view.showFilterRow;
      } else {
        vm.view.showFilterRow = show;
      }
      timeoutPromises.switchToggleFilter = $timeout(function() {
        if (vm.view.showFilterRow) {
          filterResizableColumnsContainer.scrollLeft = virtualRepeatScroller.scrollLeft;
          var el = $document[0].querySelector('#filter_first')
          if(el && filterResizableColumnsContainer.scrollLeft === 0) { // focus only when scroller is at left most position, otherwise focus will scroll back the filter row back to left most
            el.focus()
          }
        }
      }, 300);
      onResize();
      showFilterRowUpdated(vm.view.showFilterRow);
    }

    function onFilterChange(keyEvent) {
      if (keyEvent && keyEvent.which === 13) {
        var el = keyEvent.target;
        if (el) {
          el.blur();
        }
      } else if (keyEvent && keyEvent.which === 27) {
        vm.switchToggleFilter(false);
      }
      syncToggleStatusAndColumnFilterStatusProperty();
      updateFilteredData();
    }

    function doShowColumnChooser(event) {
      return $mdDialog.show({
        controller         : 'txDataTableColumnChooserController',
        controllerAs       : 'vm',
        templateUrl        : 'app/directives/txDataTable/dialogs/column-chooser/column-chooser.html',
        parent             : angular.element($document[0].body),
        targetEvent        : event,
        clickOutsideToClose: false,
        multiple           : true,
        locals             : {
          availableFields: utility.filterObject(vm.fields, {visible: true}),
          selectedFields: vm.colsList,
          defaultColumnList: vm.view.columns,
          event: event
        }
      }).then(function(newCols) {
        if (newCols)
        {
          vm.colsList = newCols;
        }
      });
    }

    function doSaveColumn() {
      return $mdDialog.show({
        controller         : 'txDataTableColumnSaverController',
        controllerAs       : 'vm',
        templateUrl        : 'app/directives/txDataTable/dialogs/column-saver/column-saver.html',
        parent             : angular.element($document[0].body),
        targetEvent        : event,
        clickOutsideToClose: false,
        multiple           : true,
        locals             : {
          isCatalogModule: vm.model.isCatalogSpecificModel,
          modelPath: vm.model.modelPath,
          columnObj: angular.copy(vm.view.columns),
          isTrasix: $localStorage.account.accountType === '1' ? true : false,
          event: event
        }
      }).then(function(res) {
        if (res) {
          loadPredefinedColumns();
        }
      });
    }


    function loadPredefinedColumns() {
      var activeCatalog = catalogFactory.getActiveCatalogDetails();
      var catalogColumns = {};
      var myColumns = {};

      vm.selectedColumns = undefined;

      if (!$rootScope.isCatalogDropdownDisabled && angular.isDefined(vm.model.modelPath)) {
        //Load catalog columns
        if (activeCatalog && activeCatalog.ImportMapping) {
          catalogColumns = angular.fromJson(activeCatalog.ImportMapping);
        }
      }
      if (angular.isUndefined(catalogColumns.columns)) {
        catalogColumns.columns = {};
      }
      if (angular.isUndefined(catalogColumns.columns[vm.model.modelPath])) {
        catalogColumns.columns[vm.model.modelPath] = [];
      }
      var mySettings = settingsFactory.getSettings();
      if (angular.isDefined(mySettings.viewColumns)) {
        myColumns = mySettings.viewColumns;
      }
      if (angular.isUndefined(myColumns[vm.model.modelPath])) {
        myColumns[vm.model.modelPath] = [];
      }
      vm.predefinedColumns = {
        my: myColumns[vm.model.modelPath],
        catalog: catalogColumns.columns[vm.model.modelPath]
      };
    }

    function onPredefinedColumnsChange() {
      var finalColList = [];
      var visibleFields = utility.filterObject(vm.fields, { visible: true });
      if (angular.isDefined(vm.selectedColumns) && angular.isDefined(vm.selectedColumns.column)) {
        for (var i = 0; i < vm.selectedColumns.column.length; i++) {
          var tempResult = utility.filterObject(visibleFields, { field: vm.selectedColumns.column[i] }, true)[0];
          if (tempResult) {
            finalColList.push(tempResult);
          }
        }
      } else {
        var defaultColumns = vm.view.defaultColumns || vm.view.columns
        for (var i = 0; i < defaultColumns.length; i++) {
          var tempResult = utility.filterObject(visibleFields, { field: defaultColumns[i] }, true)[0];
          if (tempResult) {
            finalColList.push(tempResult);
          }
        }
      }
      vm.colsList = angular.copy(finalColList);
    }

    function doRefreshAction() {
      if (angular.isFunction(vm.refreshActionEvent)) {
        var p = vm.refreshActionEvent();
        if (p) {
          p.then(function() {
            var topIndex = vm.view.topIndex;
            vm.view.topIndex = 0;
            switchToggleFilter.doRefreshAction = $timeout(
              function() {
                updateData(topIndex);
            });
          })
        }
      }
    }

    function doSort(ev, col, islongTouch) {
      if (angular.isDefined(ev) && angular.isDefined(ev.target) && ev.target.innerText == "" && ev.target.tagName.toUpperCase() !== 'MD-ICON') {
        //We clicked on the resizer
        return ;
      }

      if((ev && ev.shiftKey || islongTouch) && angular.isDefined(vm.view.sortColumn[col.field])) {
        vm.view.sortColumn[col.field] = !vm.view.sortColumn[col.field];
      }
      else if((ev && ev.shiftKey || islongTouch) && angular.isUndefined(vm.view.sortColumn[col.field])) {
        vm.view.sortColumn[col.field] = true; // set default sort to ascending
      }
      else if(!(ev && ev.shiftKey || islongTouch) && angular.isDefined(vm.view.sortColumn[col.field])) {
        var sortAscending = vm.view.sortColumn[col.field];
        vm.view.sortColumn = {};
        vm.view.sortColumn[col.field] = !sortAscending;
      }
      else {
        vm.view.sortColumn = {};
        vm.view.sortColumn[col.field] = true; // set default sort to ascending
      }
      // custom order by filter to filter
      vm.filteredData = $filter('txDataTableOrderBy')(vm.filteredData, generateSortPredicate(vm.view.sortColumn), vm.lookupData, vm.model);
    }

    function onSortIconClick(ev, col) {
      ev.stopPropagation();
      doSort(ev, col);
    }

    function onHeaderLongTouch(ev, col) {
      doSort(undefined, col, true);
    }

    function onHeaderShortTouch(ev, col) {
      doSort(undefined, col, false);
    }

    function generateSortPredicate(sortColumn) {
      var predicate = [];
      for(var key in sortColumn) {
        if(!sortColumn[key]) {
          predicate.push("-'" + key + "'");
        }
        else {
          predicate.push("+'" + key + "'");
        }
      }
      return predicate;
    }

    function persistColsWidthRatio() {
      angular.forEach(vm.view.columns, function(itm) {
        vm.view.columnsWidthRatioMap[itm] = vm.colsWidth[itm] / vm.resizableColsContainerWidth;
      });
      // set the total column width
      vm.model['totalTableColumnWidth'] = vm.resizableColsContainerWidth
      settingsFactory.persistListViewLayout(vm.model, true);
    }

    function doSaveFilter() {
      return $mdDialog.show({
        controller         : 'txDataTableFilterSaverController',
        controllerAs       : 'vm',
        templateUrl        : 'app/directives/txDataTable/dialogs/filterSaver/filterSaver.html',
        parent             : angular.element($document[0].body),
        targetEvent        : event,
        clickOutsideToClose: false,
        multiple           : true,
        locals             : {
          isCatalogModule: vm.model.isCatalogSpecificModel,
          moduleName: vm.model.modelPath,
          filterObj: vm.view.columnFilter,
          sortObj: vm.view.sortColumn,
          isTrasix: $localStorage.account.accountType === '1' ? true : false,
          event: event
        }
      }).then(function(res) {
        if (res) {
          loadPredefinedFilters();
        }
      });
    }

    function doItemAction(action, item) {
      if (angular.isFunction(vm.itemActionEvent)) {
        if (action.requiresConfirmation) {
          dialog.confirm(action.confirmationContent, action.confirmationAction, item, vm.model, action)
          .then(function (response) {
            if (response.userAction.toLowerCase() === 'confirm') {
              vm.itemActionEvent({ action: action, item: item, additionalInfo: response });
              // specific to dune images module if this is to activate/ deactivate we need to call the download dune images
              if(vm.model.currentViewType === 1 && vm.isDuneImagesView && (action.id === 'delete' || action.id === 'activate')) {
                timeoutPromises.duneImageStatusChange = $timeout(function() {
                  item.Status = action.id === 'delete' ? 0 : 1;
                  downloadDuneImage(item, true);
                }, 500);
              }
            }
          });
        } else if (action.url) {//for download item action
          if (!item.FileName && !item.FilePath) {
            toast.error('', 'Download Failed', '', { message: 'You can not download without valid FileName and FilePath' });
          } else {
            var URL = item.FilePath + '/' + item.FileName;
            var downloadLink = angular.element('<a></a>');
            downloadLink.attr('href', URL);
            downloadLink.attr('download', item.FileName);
            downloadLink[0].click();
          }
        }
        else {
          vm.itemActionEvent({ action: action, item: item, additionalInfo: {} });
          // specific to dune images module id item is edited(Changed image) download the updated image from dune, for that keeping the previous item in memory
          if(vm.model.currentViewType === 1 && vm.isDuneImagesView && (action.id === 'edit')) {
            vm.currentDuneImageForEdit = item;
          }
        }
      }
    }

    function doItemClick(index) {
      event.preventDefault();
      vm.activeRow = index;
      timeoutPromises.itemClickedTimeout = $timeout(function() {
        if (angular.isFunction(vm.itemClickEvent)) {
          vm.itemClickEvent({item: vm.filteredData[index]});
        }
      });
    }

    function doItemRightClick(index, e) {
      $mdDialog.show({
          controller         : 'detailsDialogController',
          controllerAs       : 'vm',
          templateUrl        : 'app/directives/txDataTable/dialogs/record-details/record-details.html',
          parent             : angular.element($document.body),
          targetEvent        : e,
          clickOutsideToClose: true,
          multiple           : true,
          locals             : {
              event: e,
              model: vm.model,
              data : vm.filteredData[index],
              lookupData: vm.lookupData,
              statusField: vm.statusField,
          }
      });
    }

    function doOrderItemAction(action, item) {
      if (angular.isFunction(vm.processOrderItemActionEvent)){
        if(action.requiresConfirmation) {
          dialog.confirm(action.confirmationContent, action.confirmationAction, item, vm.model)
          .then(function(response) {
            if(response.userAction.toLowerCase() === 'confirm') {
              vm.processOrderItemActionEvent({action: action, item: item});
            }
          });
        }
        else {
          vm.processOrderItemActionEvent({action: action, item: item});
        }
      }
    }

    function isActionDisabled(data, matchingFilter, isKeepAtleastOneActiveEnabled) {
      var selectedItems = utility.filterObject(data, {selected: true});
       // isKeepAtleastOneActiveEnabled is to disable delete button when user selects all the records atleast one should be always enabled(Buy window module)
      if(isKeepAtleastOneActiveEnabled && (selectedItems.length === data.length)) {
        return true;
      }
      // (vm.filteredData | filter: {selected: true}).length == 0 || (vm.filteredData | filter: {selected: true}).length != (vm.filteredData | filter: listAct.disabled).length
      if(matchingFilter === true) {
        return true;
      }
      else if (data && matchingFilter) {
        // replacing dataTableFilter with utility filter hence updating matchingFilter to perform exact match if any performance impact then needs to create a custom filter
        for(var key in matchingFilter) {
          if(!angular.isArray(matchingFilter[key])) {
            matchingFilter[key] = '!' + matchingFilter[key];
          }
        }
        var matchingItems = $filter('dataTableFilter')(selectedItems, matchingFilter);

        return (selectedItems.length == 0 || selectedItems.length !== matchingItems.length);
      }
      else {
        return false;
      }
    }

    function gotoRecord(pos) {
      if ((pos < 0 && vm.activeRow == 0) || (pos > 0 && vm.activeRow == vm.filteredDataLength-1)) {
        return false;
      }

      vm.activeRow += pos;
      var itemsPerPage = Math.floor(vm.listHeight / 50) - 1;

      if (vm.activeRow < vm.view.topIndex) {
        vm.view.topIndex = vm.activeRow;
      } else if(vm.view.topIndex + itemsPerPage < vm.activeRow) {
        vm.view.topIndex = vm.activeRow - itemsPerPage;
      }
    }

    // not in use
    // function getRecordValue(record, col) {
    //     switch (col.inputType) {
    //         case 'lookup':
    //             if (angular.isDefined(vm.lookupData[col.lookupSource]) && angular.isDefined(vm.lookupData[col.lookupSource].indexArray) &&
    //             angular.isArray(vm.lookupData[col.lookupSource].indexArray) && vm.lookupData[col.lookupSource].indexArray.indexOf(record[col.field]) >= 0) {
    //                 return vm.lookupData[col.lookupSource].data[vm.lookupData[col.lookupSource].indexArray.indexOf(record[col.field])].value;
    //             } else {
    //                 return undefined;
    //             }
    //             break;

    //         default:
    //             return record[col.field];
    //     }
    // }

    function loadLookupData() {
      for (var i=0; i<vm.colsList.length; i++) {
        if (vm.colsList[i].inputType === 'lookup' || vm.colsList[i].inputType === 'lookup-many' || vm.colsList[i].inputType === 'articlenumber' || vm.colsList[i].inputType === 'modelnumber' || vm.colsList[i].inputType === 'linkedcatalogarticlenumber') {
          if (!vm.lookupData[vm.colsList[i].lookupSource] || angular.isUndefined(vm.lookupData[vm.colsList[i].lookupSource])) {
            loadLookup(vm.colsList[i].lookupSource, vm.colsList[i]);
          }
        }
      }
    }

    function loadLookup(lookupSource, field) {
      vm.lookupData[lookupSource] = {};
      var lookupExtras = {};
      api.getLookupData(api.getModel(lookupSource), lookupExtras, vm.model.modelPath).then(function(result) {
        vm.lookupData[lookupSource] = result;
      });
    }

    function dpGetItemAtIndex(index) {
      return vm.filteredData[index];
    }

    function dpGetLength() {
      return vm.filteredDataLength;
    }


    function loadPredefinedFilters() {
      var cat = catalogFactory.getActiveCatalogDetails();
      var catalogFilters = {};
      var myFilters = {};

      vm.selectedFilter = undefined;

      if (!$rootScope.isCatalogDropdownDisabled && angular.isDefined(vm.model.modelPath)) {
        //Load catalog filters
        if (angular.isDefined(cat) && angular.isDefined(cat.ImportMapping) && cat.ImportMapping) {
          catalogFilters = angular.fromJson(cat.ImportMapping);
        }
      }
      if (angular.isUndefined(catalogFilters.filters)) {
        catalogFilters.filters = {};
      }
      if (angular.isUndefined(catalogFilters.filters[vm.model.modelPath])) {
        catalogFilters.filters[vm.model.modelPath] = [];
      }
      var mySettings = settingsFactory.getSettings();
      if (angular.isDefined(mySettings.viewFilters)) {
        myFilters = mySettings.viewFilters;
      }
      if (angular.isUndefined(myFilters[vm.model.modelPath])) {
        myFilters[vm.model.modelPath] = [];
      }
      vm.predefinedFilters = {
        my: myFilters[vm.model.modelPath],
        catalog: catalogFilters.filters[vm.model.modelPath]
      };
    }

    // #changeManagement
    function calculateChangeManagementListActionStatus() {
      if(angular.isDefined(vm.view.changeManagementListActions)) {
        angular.forEach(vm.view.changeManagementListActions, function (listAction) {
          listAction._disabled = $scope.$eval(listAction.disabled, {itm: vm.changeManagementRecord});
          listAction._visible = $scope.$eval(listAction.visible, {itm: vm.changeManagementRecord});
        });
      }
    }

    /**
     * get article status values
    */
    function getArticleStatusValues(data, articleStatusField) {
      return utility.getArticleStatusValue(data, articleStatusField, dataSourceTypeId);
    }

    //not required anymore, can dissolve dependency to infinite scroll
    // function addImages() {
    //     if (vm.model.imagesLimit < vm.filteredData.length) {
    //         if (vm.model.imagesLimit + 10 > vm.filteredData.length) {
    //             vm.model.imagesLimit = vm.filteredData.length;
    //         } else {
    //             vm.model.imagesLimit += 10;
    //         }
    //         doRefreshAction.addImages = $timeout(function(){
    //             vm.bLazy.revalidate();
    //         }, 2000);
    //     }
    // }



    // identify if orderProcessAction needed to be disable or not
    function isProcessOrderActionDisabled(data, predicate, item) {
      if (data && predicate) {
        var selectedItems = utility.filterObject(data, {selected: true});
        var matchingItems = $filter('orderProcessStatusFilter')(selectedItems, predicate);

        return (selectedItems.length == 0 || selectedItems.length !== matchingItems.length);
      }
      else {
        return false;
      }
    }

    /**
     * To determine if any item or list action assign to user has privilege
     */
    function isAnyAction(actionList) {
      if(angular.isDefined(actionList)) {
        var accessInfo = {
          accessPrivileges: []
        };
        if(angular.isArray(actionList)) {
          for(var index=0 ; index < actionList.length ; index++) {
            if(angular.isDefined(actionList[index].privilege) && actionList[index].privilege !== '') {
              var privilegesString = actionList[index].privilege.split(':')[0];
              var privileges = privilegesString.split(',');
              angular.forEach(privileges, function(privilege) {
                accessInfo.accessPrivileges.push(privilege);
              });
            }
          }
        }
        else {
          accessInfo.accessPrivileges = actionList.privilege.split(':')[0].split(',');
        }
        return (SecurityFactory.isAuthorized(accessInfo));
      }
    }

    function doShowCharts() {
      if (!vm.supportChartsView) {
        return;
      }

      if(vm.model.currentViewType !== 2) {
        modifyInterfaceForChartView(true);
        vm.model.currentViewType = 2;

        if(vm.chartsConfigObj.charts.length === 0 ) {
          initializeChartData();
        }
        // if charts already created but data is dirty, recreate data for each chart, chartViewDataCount will be empty on each refresh
        // all the actions make model dirty, but some refreshes data immediately after data update which make model dirty=false
        // so on refresh (which triggers data update) explicitly make chartViewDataCount empty to make sure always have updated data count
        // based on these params (empty chartViewDataCount, and dirty model) we can identify charts data needs to be updated
        else if(utility.isObjectEmpty(chartViewDataCount) || vm.model.isDirty) {
          createChartsData(vm.chartsConfigObj.charts, getChartViewDataCount(), true);
        }
        // remove filter and enter hotkeys for chart-view
        hotkeys.del('/');
        hotkeys.del('enter');
      }
      else {
        vm.model.currentViewType = 0;
        registerEnterHotkey();
        registerFilterHotkey()
        modifyInterfaceForChartView(false);
        $timeout(calculateColumnsWidth);
      }
    }

    function isToggleFilterDefined() {
      return ( angular.isDefined(vm.view.toggleFilterProps)
      && angular.isDefined(vm.view.toggleFilterProps.filterProp)
      && (angular.isDefined(vm.view.toggleFilterProps.trueVal) || angular.isDefined(vm.view.toggleFilterProps.falseVal))
      );
    }

    /**
     * @description:
     *  this method will evaluate orderline Status value and will add array or translatable key denoting reason behind invalid orderline for each record
     * this method will called only from data watcher only for orderline and rejected orderline models (modelPath is used to identify)
     */
    function evaluateOrderlineStatusValue(records) {
      angular.forEach(records, function (record) {
        record.invalidOrderlineReason = [];
        if (record[vm.statusField] === 0) {
          record.invalidOrderlineReason.push($filter('translate')('ORDERLINE.INACTIVE_REASONS.DEACTIVATED_RECORD'));
        }
        if ((record.Status & 2) === 2) {
          record.invalidOrderlineReason.push($filter('translate')('ORDERLINE.INACTIVE_REASONS.DEACTIVATED_ARTICLES'));
        }
        if ((record.Status & 4) === 4) {
          record.invalidOrderlineReason.push($filter('translate')('ORDERLINE.INACTIVE_REASONS.DEACTIVATED_CATALOG_CRD'));
        }
        if ((record.Status & 8) === 8) {
          record.invalidOrderlineReason.push($filter('translate')('ORDERLINE.INACTIVE_REASONS.DEACTIVATED_CATALOG/CUSTOMER_SEGMENTATION'));
        }
        if ((record.Status & 16) === 16) {
          record.invalidOrderlineReason.push($filter('translate')('ORDERLINE.INACTIVE_REASONS.DEACTIVATED_PRICE_GROUP'));
        }
        if ((record.Status & 32) === 32) {
          record.invalidOrderlineReason.push($filter('translate')('ORDERLINE.INACTIVE_REASONS.DEACTIVATED_SIZE'));
        }
        if ((record.Status & 64) === 64) {
          record.invalidOrderlineReason.push($filter('translate')('ORDERLINE.INACTIVE_REASONS.DEACTIVATED_ARTICLE_CRD'));
        }
        if ((record.Status & 128) === 128) {
          record.invalidOrderlineReason.push($filter('translate')('ORDERLINE.INACTIVE_REASONS.DEACTIVATED_ARTICLE_SEGMENTATION'));
        }
        if ((record.Status & 256) === 256) {
          record.invalidOrderlineReason.push($filter('translate')('ORDERLINE.INACTIVE_REASONS.DEACTIVATED_ARTICLE_CRD_AVAILABILITY'));
        }
        if ((record.Status & 512) === 512) {
          record.invalidOrderlineReason.push($filter('translate')('ORDERLINE.INACTIVE_REASONS.DEACTIVATED_ALLOCATION_CRITERIA'));
        }
        if ((record.Status & 1024) === 1024) {
          record.invalidOrderlineReason.push($filter('translate')('ORDERLINE.INACTIVE_REASONS.INVALID_SEGMENTATION'));
        }
        if ((record.Status & 2048) === 2048) {
          record.invalidOrderlineReason.push($filter('translate')('ORDERLINE.INACTIVE_REASONS.UNLINKED_CUSTOMER'));
        }
      });
    }

    /**
     * @description:
     * this method will evaluate forecast line Status value and will add array of translatable key denoting reason behind invalid forecast line for each record
     * this method will called from data watcher only for forecast line model (modelPath is used to identify)
     */
    function evaluateForecastLineStatusValue(records) {
      angular.forEach(records, function (record) {
        record.invalidForecastLineReason = [];
        if (record[vm.statusField] === 0) {
          record.invalidForecastLineReason.push($filter('translate')('FORECAST.INACTIVE_REASONS.DEACTIVATED_RECORD'));
        }
        if ((record.ForecastLineStatus & 2) === 2) {
          record.invalidForecastLineReason.push($filter('translate')('FORECAST.INACTIVE_REASONS.DEACTIVATED_ARTICLES'));
        }
        if ((record.ForecastLineStatus & 4) === 4) {
          record.invalidForecastLineReason.push($filter('translate')('FORECAST.INACTIVE_REASONS.ARTICLE_SEGMENTATION'));
        }
      });
    }

    // initialize columnFilter object property for boolean type inputType in order the default label of filter to be display for these fields(Active and Inactive / True and False)
    function initializeFilterValueForBooleanFields() {
      angular.forEach(vm.model.fields, function(field) {
        if( (field.inputType.toUpperCase() === 'STATUS' && angular.isUndefined(vm.view.columnFilter[field.field]))
        || (field.inputType.toUpperCase() === 'BOOL' && angular.isUndefined(vm.view.columnFilter[field.field]))
        || (field.inputType.toUpperCase() === 'INT-BOOL' && angular.isUndefined(vm.view.columnFilter[field.field]))
        || (field.inputType.toUpperCase() === 'BOOL-INT' && angular.isUndefined(vm.view.columnFilter[field.field]))
        || (field.inputType.toUpperCase() === 'BOOL-STR' && angular.isUndefined(vm.view.columnFilter[field.field]))
        || (field.inputType.toUpperCase() === 'NOTIFICATIONSTATUS' && angular.isUndefined(vm.view.columnFilter[field.field]))
        || (field.inputType.toUpperCase() === 'ARTICLE-STATUS' && angular.isUndefined(vm.view.columnFilter[field.field]))) {
          vm.view.columnFilter[field.field] = '';
        }
      });

    }

    function addImageSource(data) {
      if(angular.isDefined(vm.model) && vm.model.modelPath !== 'catalogs.t1Dune') {
        angular.forEach(data, function(obj) {
          obj['ImageSource'] = obj.FilePath + '/' + obj.FileName;
        });
      }
    }

    //Implement Hotkeys (Keyboard Shortcuts)
    function registerHotkeys(register) {

      if (register) {
        hotkeys.del('ctrl+a');
        hotkeys.del('ctrl+shift+a');
        hotkeys.del('/');
        hotkeys.del('ctrl+r');
        hotkeys.del('ctrl+x');
        hotkeys.del('up');
        hotkeys.del('down');
        hotkeys.del('space');
        hotkeys.del('enter');

        var selTxt = $filter('translate')('ACTIONS.SELECT.SELECT');
        hotkeys.bindTo($scope)
          .add({
            combo: 'ctrl+a',
            description: selTxt + ' ' + $filter('translate')('ACTIONS.SELECT.ALL'),
            callback: function(event) {
              vm.doSelectAll('all');
              event.preventDefault();
            }
          })
          .add({
            combo: 'ctrl+shift+a',
            description: selTxt + ' ' + $filter('translate')('ACTIONS.SELECT.NONE'),
            callback: function(event) {
              vm.doSelectAll('none');
              event.preventDefault();
            }
          })
          .add({
            combo: 'ctrl+r',
            description: $filter('translate')('ACTIONS.REFRESH'),
            callback: function(event) {
              vm.doRefreshAction();
              event.preventDefault();
            }
          })
          .add({
            combo: 'ctrl+x',
            description: $filter('translate')('ACTIONS.EXPORT'),
            callback: function(event) {
              vm.doExport();
              event.preventDefault();
            }
          })
          .add({
            combo: 'up',
            description: $filter('translate')('ACTIONS.PREV_RECORD'),
            callback: function (event) {
              gotoRecord(-1);
              event.preventDefault();
            }
          })
          .add({
            combo: 'down',
            description: $filter('translate')('ACTIONS.NEXT_RECORD'),
            callback: function(event) {
              gotoRecord(1);
              event.preventDefault();
            }
          })
          .add({
            combo: 'space',
            description: selTxt + ' ' + $filter('translate')('ACTIONS.SELECT.CURRENT'),
            callback: function(event) {
              if (vm.activeRow >= 0 && angular.isDefined(vm.filteredData) && vm.activeRow < vm.filteredDataLength) {
                vm.filteredData[vm.activeRow].selected = !vm.filteredData[vm.activeRow].selected;
                vm.onSelectChange();
              }
              event.preventDefault();
            }
          });
          registerEnterHotkey();
          registerFilterHotkey();
      }
    }
    function registerEnterHotkey() {
      hotkeys.bindTo($scope)
      .add({
        combo: 'enter',
        description: $filter('translate')('ACTIONS.VIEW'),
        callback: function() {
          if (vm.activeRow >= 0 && angular.isDefined(vm.filteredData) && vm.activeRow < vm.filteredDataLength) {
            vm.doItemClick(vm.activeRow);
          }
        }
      });
    }
    function registerFilterHotkey() {
      hotkeys.bindTo($scope)
      .add({
        combo: '/',
        description: $filter('translate')('ACTIONS.FILTER'),
        callback: function(event) {
          vm.switchToggleFilter(true);
          event.preventDefault();
        }
      });
    }

    function addChart(ev) {
       $mdDialog.show({
        controller         : 'txDataTableChartsEditorController',
        controllerAs       : 'vm',
        templateUrl        : 'app/directives/txDataTable/dialogs/chartsEditor/chartsEditor.html',
        parent             : angular.element($document[0].body),
        targetEvent        : event,
        clickOutsideToClose: false,
        locals             : {
          record: null,
          model: vm.model,
          isNew: true,
          isCatalogModule: vm.model.isCatalogSpecificModel,
          isTrasix: vm.isTrasix,
          event: ev
        }
      }).then(function(chartsInfo) {
        if (chartsInfo && chartsInfo.length) {

          // add charts
          angular.forEach(chartsInfo, function(chartInfo) {
            vm.chartsConfigObj.charts.push(chartInfo);
          });

          isGlobalChartsDirty = utility.filterObject(chartsInfo, {isGlobal: '1'}, true).length ? true: false;
          isUserChartsDirty = utility.filterObject(chartsInfo, {isGlobal: '0'}, true).length ? true: false;

          // calculate chart data
          createChartsData(chartsInfo, getChartViewDataCount());
        }
      });
    }

    function doDeleteChart(chartInfoIndex, event) {
      dialog.confirm({title: 'MESSAGES.TITLE.ALERT', message: 'MESSAGES.CONTENT.CONFIRM_DELETE'}, 'ACTIONS.DELETE_CHART', {}, undefined, undefined, event)
      .then(function(response){
        if(response.userAction.toLowerCase() === 'confirm') {
          vm.chartsConfigObj.charts[chartInfoIndex].isGlobal === '1' ? (isGlobalChartsDirty = true) : (isUserChartsDirty = true);
          vm.chartsConfigObj.charts.splice(chartInfoIndex, 1);
        }
      });
    }

    function initializeChartsView() {
      vm.chartsConfigObj = {
        config: {
          refreshDataOnly: true,
          // deepWatchData: false// this will cause refresh not to work(if remove it will work but as per documentation can cause memory leak), use API to call refresh when recalculating chartsInfo data
        },
        options: {
          chart: {
            type: 'pieChart',
            height: 350,
            margin: {
              top: 0,
              right: 0,
              bottom: 20,
              left: 0
            },
            donut: false,
            clipEdge: true,
            cornerRadius: 2,
            labelType: 'value',
            labelThreshold: 0.04,
            labelSunbeamLayout: true,
            padAngle: 0.01,
            showLegend: false,
            // legend
            x: function (d) {
              return d.label;
            },
            // value on chart
            y: function (d) {
              return d.value;
            },
            tooltip: {
              gravity: 's',
              classes: 'gravity-s'
            },
            valueFormat: function (n) { if (angular.isDefined(n)) { return $filter('number')(n, 0); } }
          }
        },
        charts: [] //contains chartsInfo
      }
    }

    // loads cached charts and add them to charts array of chartsConfigObj
    function initializeChartData() {
      vm.isChartLoading = true;
      var dataCount = getChartViewDataCount();
      var allChartsMeta = getCachedChartsMeta();

      // sort charts based on data range1
      allChartsMeta = utility.orderBy(allChartsMeta, 'r1', false);

      // add charts
      angular.forEach(allChartsMeta, function (chartMeta) {
        var chartInfo = { displayLabel: '', data: [], isGlobal: chartMeta.g, meta: chartMeta, isLoading: true };
        if (angular.isDefined(chartMeta.t)) {
          chartInfo.displayLabel = chartMeta.t;
        }
        vm.chartsConfigObj.charts.push(chartInfo);
      });

      // if (charts.chartsInfo) {
      //   //Fields exists, start mapping
      //   angular.forEach(charts.chartsInfo, function (chartInfo, index) {
      //     var chartInfo = { DisplayLabel: '', info: chartInfo, data: [], isGlobal: false, isLoading: true };
      //     if (angular.isDefined(chartInfo.t)) {
      //       chartInfo.DisplayLabel = chartInfo.t;
      //     }
      //     vm.chartsConfigObj.charts[index] = chartInfo;
      //     // if (angular.isDefined(chartInfo.a)) {
      //     //   if (angular.isDefined(dataCount[itm.a])) {
      //     //     chartInfo.data = dataCount[itm.a];
      //     //   }
      //     // }
      //   });


      //   ///////############## ??????????
      //   // angular.forEach(chartFields[moduleName], function(itm) {
      //   //   var dataItm = { name: '', data: [] };
      //   //   if (angular.isDefined(itm.n)) {
      //   //     dataItm.name = itm.n;
      //   //   }
      //   //   if (angular.isDefined(itm.a)) {
      //   //     if (angular.isDefined(dataCount[itm.a])) {
      //   //       dataItm.data = dataCount[itm.a];
      //   //     }
      //   //   }
      //   // });
      // }
      vm.isChartLoading = false;
      createChartsData(vm.chartsConfigObj.charts, dataCount);
    }

    function getChartViewDataCount() {
      // chartViewDataCount will get emptied in data watch call back to clean it on actions which refreshes the list, for the actions where data not being refresh check for model being dirty
      if(!utility.isObjectEmpty(chartViewDataCount) && !vm.model.isDirty) {
        return chartViewDataCount;
      }
      else {
        chartViewDataCount = {};

        //Load list of attributes to report on
        angular.forEach(vm.model.fields, function (f) {
          if (f.reportable) {
            chartViewDataCount[f.field] = {};
          }
        });

        //Index data
        // chartViewDataCount is a map of reportable properties(columns) which include map of unique values of that property and their count for active and total(active and inactive) records
        angular.forEach(vm.data, function (data) {
          angular.forEach(chartViewDataCount, function (value, key) {
            if (angular.isDefined(data[key])) {
              var val = (data[key] !== null && data[key] !== '') ? data[key].toString() : '#No Value';
              if (val !== '#No Value') {
                if (((key.substring(key.length - 4, key.length)).toUpperCase() === 'DATE') || ((key.substring(0, 3)).toUpperCase() === 'CRD') ) {
                  val = $filter('date')(val, 'mediumDate');
                }
              }
              if (angular.isUndefined(chartViewDataCount[key][val])) {
                chartViewDataCount[key][val] = { 'total': 0, 'active': 0 };
              }
              chartViewDataCount[key][val]['total']++;

              if (angular.isDefined(data[vm.statusField]) && data[vm.statusField] !== null &&
                (data[vm.statusField] === true || data[vm.statusField] === 'true' || data[vm.statusField] == 1)) {
                chartViewDataCount[key][val]['active']++;
              }

              // if (angular.isDefined(chartViewDataCount[key][val])) {
              //   chartViewDataCount[key][val]++;
              // } else {
              //   chartViewDataCount[key][val] = 1;
              // }
            }
          });
        });
        return chartViewDataCount;
      }
    }

    function getCachedChartsMeta() {
      var chartsMeta = {
        global  : [],
        user    : []
      };

      // load globally cached charts
      if(vm.model.isCatalogSpecificModel && angular.isDefined(vm.model.modelPath)) {
        var activeCatalogDetails = catalogFactory.getActiveCatalogDetails();
        var moduleName = vm.model.modelPath;
        var activeCatalogSettings;
        if (activeCatalogDetails && angular.isDefined(activeCatalogDetails) && activeCatalogDetails.ImportMapping && angular.isDefined(activeCatalogDetails.ImportMapping)) {
          activeCatalogSettings = angular.fromJson(activeCatalogDetails.ImportMapping);
        }
        // if(angular.isUndefined(activeCatalogSettings.charts)) {
        //   activeCatalogSettings.charts = {};
        // }
        // else if(angular.isUndefined(activeCatalogSettings.charts[moduleName])) {
        //   activeCatalogSettings.charts[moduleName] = {};
        // }
        // else {
        //   charts.catalog = activeCatalogSettings.charts[moduleName];
        // }
        if(activeCatalogSettings && activeCatalogSettings.charts && activeCatalogSettings.charts[moduleName] && activeCatalogSettings.charts[moduleName].chartsMeta) {
          chartsMeta.global = activeCatalogSettings.charts[moduleName].chartsMeta;
        }
      }

      // load user cached charts
      var mySettings = settingsFactory.getSettings();
      var catalogCode = -9; // for modules other than catalog modules
      // if my chart belong to catalog module load chart for active catalog
      if(vm.model.isCatalogSpecificModel) {
          catalogCode = activeCatalogDetails.CatalogCode;
      }
      if (mySettings && mySettings.charts && mySettings.charts[moduleName] && mySettings.charts[moduleName][catalogCode] && mySettings.charts[moduleName][catalogCode].chartsMeta) {
        chartsMeta.user = mySettings.charts[moduleName][catalogCode].chartsMeta;
      }
      return chartsMeta.global.concat(chartsMeta.user);
    }

    /**
     * @description calculate data property of chartInfo(objects inside charts array of chartsConfigObj)
     * @param {array} charts array of charts info
     * @param {object} dataCount map of reportable fields value and their count for total and active records
     * @param {boolean} refreshChartData a boolean value indicating data is dirty and data of chart info needs to be recreated
     */
    function createChartsData(charts, dataCount, refreshChartData) {
      angular.forEach(charts, function(chartInfo) {
        if(refreshChartData) {
          chartInfo.data.length = 0;
          chartInfo.isLoading = true;
        }
        var chartData = {value: undefined, label: ''};
        // if operator is count
        if(chartInfo.meta && angular.isDefined(chartInfo.meta.o) && chartInfo.meta.o == 1 && angular.isDefined(chartInfo.meta.r1) && dataCount[chartInfo.meta.r1]) {
          var totalOrActive = chartInfo.meta.m === '1' ? 'total' : 'active';
          for(var propertyValue in dataCount[chartInfo.meta.r1]) { // based on number of values we need to create different number of colors
            chartData = {value: dataCount[chartInfo.meta.r1][propertyValue][totalOrActive], label: propertyValue};
            chartInfo.data.push(chartData);
          }
        }

        // if operator is sum
        else if (chartInfo.meta && angular.isDefined(chartInfo.meta.o) && chartInfo.meta.o == 2 && angular.isDefined(chartInfo.meta.r1) && angular.isDefined(chartInfo.meta.r2)) {
          var iterableData = vm.data;
          var report = {};

          if (chartInfo.meta.m === '0' && angular.isDefined(vm.data[0]) && angular.isDefined(vm.data[0][vm.statusField]) && vm.data[0][vm.statusField] !== null) {// only active record
            var predicate = {};
            predicate[vm.statusField] = 1;
            iterableData = utility.filterObject(vm.data, predicate);
          }

          angular.forEach(iterableData, function (data) {
            var val = chartInfo.meta.r1;
            if ((val.substring(val.length - 4, val.length)).toUpperCase() === 'DATE') {
              data[chartInfo.meta.r1] = $filter('date')(data[chartInfo.meta.r1], 'mediumDate');
            }
            if (angular.isUndefined(report[data[chartInfo.meta.r1]])) {
              report[data[chartInfo.meta.r1]] = 0;
            }
            report[data[chartInfo.meta.r1]] += data[chartInfo.meta.r2] ? data[chartInfo.meta.r2] : 0;// number attribute could be sent null from database
          });

          for (var propertyVal in report) { // based on number of values we need to create different number of colors
            chartData = { value: report[propertyVal], label: propertyVal };
            chartInfo.data.push(chartData);
          }
        }
        chartInfo.isLoading = false;
      });
    }

    function persistChartsView() {
      // use the catalog details initiated at directive initiation to avoid getting wrong catalog when persistChartsView get called due to active catalog change
      var chartsMeta = {
        global  : [],
        user    : []
      };
      var moduleName = vm.model.modelPath;
      angular.forEach(vm.chartsConfigObj.charts, function(chartInfo) {
        if(chartInfo.isGlobal === '1') {
          chartsMeta.global.push(chartInfo.meta);
        }
        else {
          chartsMeta.user.push(chartInfo.meta);
        }
      });
      // persist global chart
      if(isGlobalChartsDirty) {
        var activeCatalogSettings;
        if (beforeExitValues.activeCatalogDetails && angular.isDefined(beforeExitValues.activeCatalogDetails) &&
            beforeExitValues.activeCatalogDetails.ImportMapping && angular.isDefined(beforeExitValues.activeCatalogDetails.ImportMapping)) {
          activeCatalogSettings = angular.fromJson(beforeExitValues.activeCatalogDetails.ImportMapping);
        }
        if(!activeCatalogSettings || angular.isUndefined(activeCatalogSettings)) {
          activeCatalogSettings = {};
        }
        if(angular.isUndefined(activeCatalogSettings.charts)) {
          activeCatalogSettings.charts = {};
        }
        if(angular.isUndefined(activeCatalogSettings.charts[moduleName])) {
          activeCatalogSettings.charts[moduleName] = {};
        }
        activeCatalogSettings.charts[moduleName].chartsMeta = chartsMeta.global;
        catalogFactory.setCatalogImportMapping(beforeExitValues.activeCatalogDetails.CatalogCode, activeCatalogSettings);
        isGlobalChartsDirty = false;
      }

      // persist user charts
      if(isUserChartsDirty) {
        var mySettings = settingsFactory.getSettings();

        var catalogCode = -9; // for none catalog module
        // if my chart belong to catalog module create separate chart for each catalog
        if(beforeExitValues.isCatalogModule) {
            catalogCode = beforeExitValues.activeCatalogDetails.CatalogCode;
        }
        if(angular.isUndefined(mySettings.charts)) {
            mySettings.charts = {};
        }
        if(angular.isUndefined(mySettings.charts[moduleName])) {
            mySettings.charts[moduleName] = {};
        }
        if(angular.isUndefined(mySettings.charts[moduleName][catalogCode])) {
            mySettings.charts[moduleName][catalogCode] = {};
        }
        if(angular.isUndefined(mySettings.charts[moduleName][catalogCode].chartsMeta)) {
            mySettings.charts[moduleName][catalogCode].chartsMeta = {};
        }
        mySettings.charts[moduleName][catalogCode].chartsMeta = chartsMeta.user;
        settingsFactory.saveUserCharts(mySettings.charts);
        isUserChartsDirty = false;
      }
    }


    // determine if list action needs to be disabled
    function determineListActionsStatus() {
      if(angular.isDefined(vm.view.listActions)) {
        angular.forEach(vm.view.listActions, function (listAction) {
          // list action can be disabled if emptyListDisabled set to true in model (useful when action is dependent to existence of data and not to data selection, like setSizes in articles page)
          listAction._disabled = (listAction.emptyListDisabled && !vm.data.length) || isActionDisabled(vm.data, $scope.$eval(listAction.disabled), listAction.isKeepAtleastOneActiveEnabled); //isActionDisabled use filter to get selected can pass selected to avoid filtering
        });
      }
      if(angular.isDefined(vm.view.processOrdersListActions)) {
        vm.view.processOrdersListActions.forEach(function (item) {
          //hide confirm action if UseConfirmOrder is not set at seller level
          item._disabled = isProcessOrderActionDisabled(vm.data, $scope.$eval(item.enabled), item) || (item.id.toUpperCase() === 'CONFIRM' && catalogFactory.getUseConfirmOrder() != 1);
        });
      }
    }

    // toggle visibility of add record fab and add chart fab button, to avoid changing templates where this directive is in use and needs chart view, also it will toggle visibility
    // of parts of data table where not required to be display
    function modifyInterfaceForChartView(isChartView) {
      toggleFabVisibility(isChartView);
      vm.enableSelection = !isChartView;
      vm.enableSelectionDropdown = !isChartView;
      vm.enableExport = !isChartView;
      vm.enableModuleListActions = !isChartView;
      vm.hideWhenChartView = isChartView;
      vm.hidePredefinedFilter = isChartView;
      vm.hidePredefinedColumn = isChartView;
    }

    // programmatically hide add record fab and show add chart fab
    function toggleFabVisibility(isChartView) {
      var fabAddRecordButton = $document[0].querySelector('.add-rec-button');
      var fabAddChartButton = $document[0].querySelector('.add-chart-button');

      // use if else to avoid flicker when elements are already loaded in dom
      // if button exist in dom while transition between charts view and other views
      if(fabAddRecordButton && fabAddChartButton) {
        toggleFabBtnVisibility(isChartView, fabAddRecordButton, fabAddChartButton);
      }
      else {
        $timeout(function() {
          fabAddRecordButton = $document[0].querySelector('.add-rec-button');
          fabAddChartButton = $document[0].querySelector('.add-chart-button');
          toggleFabBtnVisibility(isChartView, fabAddRecordButton, fabAddChartButton);
        },0);
      }
    }

    function toggleFabBtnVisibility(isChartView, fabAddRecordButton, fabAddChartButton) {
      if(fabAddRecordButton) {
        if(isChartView) {
          fabAddRecordButton.classList.add('hidden');
        }else {
          fabAddRecordButton.classList.remove('hidden');
        }
      }
      if(fabAddChartButton) {
        if(isChartView) {
          fabAddChartButton.classList.remove('hidden');
        }else {
          fabAddChartButton.classList.add('hidden');
        }
      }
    }

    function defineToggleFullScreenVariable(ev, screenMode) {
      if(angular.isDefined(screenMode) && screenMode.toLowerCase() === 'fullscreen') {
          // add the main tool bar height
          vm.isFullScreen = true;
      } else if(angular.isDefined(screenMode) && screenMode.toLowerCase() === 'normalview') {
          // deduct the main tool bar height
          vm.isFullScreen = false;
      }
    }

    // assign the header columns total width to the sizer container to have horizontal scroll bar
    // assign height also to this container so that it will be visible
    function assignTotalColumnWidthToVirtualReaptWhenNoFilteredValues() {
      var colsContainer = null;
      var colsContainerWidth = null;
      if($scope.element && angular.isUndefined(resizableColumnsContainer)) {
        resizableColumnsContainer = $scope.element[0].querySelector('#resizable-cols-container');
      }
      if(angular.isDefined(resizableColumnsContainer)) {
        colsContainer = angular.element(resizableColumnsContainer)
      }

      if(angular.isDefined(colsContainer) && colsContainer !== null) {
        colsContainerWidth = colsContainer.width();
        if(angular.isDefined(vm.view.columnsWidthRatioMap) && !utility.isObjectEmpty(vm.view.columnsWidthRatioMap)) {
          var totalColumnWidth = 0;
          angular.forEach(vm.view.columns, function(itm) {
            totalColumnWidth += vm.view.columnsWidthRatioMap[itm] * colsContainerWidth;
          });
          // get the vrtual repeats md-virtual-repeat-sizer and assign the coulumns container width
          if($scope.element != null) {
            var virtualRepatSizer = $scope.element[0].querySelector('.md-virtual-repeat-sizer');
            if(virtualRepatSizer != null) {
              virtualRepatSizer.style.width = totalColumnWidth + 'px';
              $(virtualRepatSizer).addClass('md-virtual-repeat-sizer-height');
            }
          }
        }
      }
    }

    // remove height from sizer container to have the overflowed height
    function removeClassFromVirtualRepeatSizer() {
      if($scope.element != null) {
        var virtualRepatSizer = $scope.element[0].querySelector('.md-virtual-repeat-sizer');
        if(virtualRepatSizer != null) {
          $(virtualRepatSizer).removeClass('md-virtual-repeat-sizer-height');
        }
      }
    }

  }
})();
(function() {
  'use strict';

  angular
    .module('app.main')
    .directive('txDatasetAutocomplete', txDatasetAutocomplete);

  function txDatasetAutocomplete() {
    var directive = {
      bindToController: true,
      controller: txDatasetAutocompleteController,
      controllerAs: 'vm',
      restrict: 'E',
      scope: {
        field: '=txField',
        data: '=txData',
        form: '=txForm',
        isNew: '=txNew',
        isUpdateBulk: '=?txIsUpdateBulk',
        isFromGridView: '=?txGridView'
      },
      templateUrl: 'app/directives/txDatasetAutocomplete/tx-dataset-autocomplete.html'
    };
    return directive;
  }

  /* @ngInject */
  function txDatasetAutocompleteController($scope, $element, $timeout, api, utility, catalogFactory, $mdSelect) {
    var vm = this;
    var DEBOUNCE_DELAY = 300; // ms
    var PAGE_SIZE = 100;
    var SCROLL_THRESHOLD = 50; // px from bottom to trigger next page
    var searchTimeout;
    var scrollHandler = null;

    vm.scope = $scope;
    vm.record = vm.data;
    vm.selectedValue = vm.record[vm.field.field];
    vm.values = [];
    vm.searchText = '';
    vm.isLoading = false;
    vm.isLoadingMore = false;
    vm.showInitialMessage = true;
    vm.isDropdownOpen = false;
    vm.sellerId = catalogFactory.getActiveCatalog().AccountId;
    vm.catalogCode = catalogFactory.getActiveCatalog().CatalogCode;
    vm.datasetId = vm.field.datasetId;
    vm.displayValue = '';
    vm.currentPage = 1;
    vm.hasMorePages = false;
    vm.currentFilter = '';

    vm.onSearchTextChange = onSearchTextChange;
    vm.clearSearch = clearSearch;
    vm.clearSelectedValue = clearSelectedValue;
    vm.onDropdownOpen = onDropdownOpen;
    vm.onDropdownClose = onDropdownClose;
    vm.openDropdown = openDropdown;

    activate();

    function activate() {
      if (vm.selectedValue) {
        loadExistingValue(vm.selectedValue);
      }
    }

    $scope.$watch('vm.selectedValue', function(newValue, oldValue) {
      if (newValue !== oldValue) {
        if (newValue) {
          var selectedOption = vm.values.find(function(value) {
            return value.Id === newValue;
          });
          if (selectedOption) {
            vm.displayValue = selectedOption.DisplayValue;
            vm.searchText = selectedOption.DisplayValue;
            vm.record[vm.field.field] = selectedOption.Id;
            if(vm.isUpdateBulk) {
              vm.record[vm.field.field] = selectedOption.DisplayValue; // bg jobs expects the string display value
            }
            if(vm.isFromGridView) {
              // whe from ui grid save as value as object as disply value needed tere to disply as cell value
              vm.record[vm.field.field] = selectedOption;
            }
            $scope.$emit('datasetAttributeChanged', vm.field.field)
          } else {
            loadExistingValue(newValue);
            vm.record[vm.field.field] = newValue;
          }
        } else {
          vm.displayValue = '';
          vm.searchText = '';
          vm.record[vm.field.field] = null;
          $scope.$emit('datasetAttributeChanged', vm.field.field)
        }
      }
    })

    function openDropdown() {
      var select = $element.find('md-select')[0];
      if (select) {
        $mdSelect.show();
      }
    }

    function onDropdownOpen() {
      vm.isDropdownOpen = true;
      $timeout(function() {
        var searchInput = $element.find('#dataset_search_input');
        if (searchInput.length > 0) {
          searchInput[0].focus();
          searchInput[0].select();
        }
        attachScrollListener();
      }, 100);
    }

    function onDropdownClose() {
      vm.isDropdownOpen = false;
      vm.searchText = vm.displayValue || '';
      detachScrollListener();
    }

    function getSelectMenuContent() {
      return document.querySelector('.md-select-menu-container.md-active md-select-menu md-content');
    }

    function attachScrollListener() {
      detachScrollListener();
      // Use 200ms delay to ensure Angular Material has fully rendered and animated the dropdown
      $timeout(function() {
        var selectMenuContent = getSelectMenuContent();
        if (selectMenuContent) {
          scrollHandler = function() {
            var scrollTop = selectMenuContent.scrollTop;
            var scrollHeight = selectMenuContent.scrollHeight;
            var clientHeight = selectMenuContent.clientHeight;

            if (scrollTop + clientHeight >= scrollHeight - SCROLL_THRESHOLD) {
              $scope.$apply(function() {
                loadNextPage();
              });
            }
          };
          selectMenuContent.addEventListener('scroll', scrollHandler);
        }
      }, 200);
    }

    function detachScrollListener() {
      if (scrollHandler) {
        var selectMenuContent = getSelectMenuContent();
        if (selectMenuContent) {
          selectMenuContent.removeEventListener('scroll', scrollHandler);
        }
        scrollHandler = null;
      }
    }

    function loadNextPage() {
      if (vm.isLoadingMore || !vm.hasMorePages) {
        return;
      }
      vm.currentPage++;
      loadDatasetValues(vm.currentFilter, true);
    }

    function onSearchTextChange(searchText) {
      if (searchTimeout) {
        $timeout.cancel(searchTimeout);
      }

      if (!searchText || searchText.length === 0) {
        vm.values = [];
        vm.showInitialMessage = true;
        vm.currentPage = 1;
        vm.hasMorePages = false;
        vm.currentFilter = '';
        return;
      }

      if (searchText.length >= 3) {
        vm.showInitialMessage = false;
        vm.currentPage = 1;
        vm.hasMorePages = false;
        vm.currentFilter = searchText;

        searchTimeout = $timeout(function() {
          loadDatasetValues(searchText, false);
        }, DEBOUNCE_DELAY);
      } else {
        vm.values = [];
        vm.showInitialMessage = true;
        vm.currentPage = 1;
        vm.hasMorePages = false;
        vm.currentFilter = '';
      }
    }

    function loadDatasetValues(filter, isAppend) {
      if (!vm.sellerId || !vm.datasetId) {
        console.error('Seller ID or Dataset ID is missing');
        return [];
      }

      if (isAppend) {
        vm.isLoadingMore = true;
      } else {
        vm.isLoading = true;
      }

      var url = api.t1v2URL + '/sellers/' + vm.sellerId + '/datasets/' + vm.datasetId + '/values?page=' + vm.currentPage + '&pageSize=' + PAGE_SIZE + '&filter=' + filter;
      // Scope values to the catalog ONLY for catalog article/model editing (flag set by catalog builders);
      // seller-models and other shared contexts keep the seller-wide read (no catalogCode).
      if (vm.field.isCatalogScoped && vm.catalogCode) {
        url += '&catalogCode=' + vm.catalogCode;
      }

      api.webGet(url, { isLogRequired: true })
        .then(function(response) {
          if (response && response.data && response.data.length) {
            var newValues = response.data.map(function(item) {
              return {
                Id: item.Id,
                DisplayValue: item.DisplayValue
              };
            });

            if (isAppend) {
              vm.values = vm.values.concat(newValues);
            } else {
              vm.values = newValues;
            }

            vm.hasMorePages = response.data.length === PAGE_SIZE;
          } else {
            if (!isAppend) {
              vm.values = [];
            }
            vm.hasMorePages = false;
          }
        })
        .catch(function(error) {
          console.error('Error loading dataset values:', error);
          if (!isAppend) {
            vm.values = [];
          }
          vm.hasMorePages = false;
        })
        .finally(function() {
          vm.isLoading = false;
          vm.isLoadingMore = false;
          $scope.$applyAsync();
        });
    }

    function loadExistingValue() {
      if(angular.isObject(vm.selectedValue)) {
        var item = vm.selectedValue; // while assigning new values it will come as Object
        vm.values = [{
          Id: Object.keys(item)[0],
          DisplayValue: item[Object.keys(item)[0]]
        }];
        vm.selectedValue = Object.keys(item)[0];
      }
      else {
        vm.searchText = '';
      }
    }

    function clearSearch() {
      vm.searchText = '';
      vm.displayValue = '';
      vm.record[vm.field.field] = null;
      vm.values = [];
      vm.showInitialMessage = true;
      vm.currentPage = 1;
      vm.hasMorePages = false;
      vm.currentFilter = '';
      $scope.$emit('datasetAttributeChanged', vm.field.field)

      $timeout(function() {
        var searchInput = $element.find('#dataset_search_input');
        if (searchInput.length > 0) {
          searchInput[0].focus();
        }
      }, 0);
    }

    function clearSelectedValue($event) {
      $event.stopPropagation();
      vm.selectedValue = null;
      vm.displayValue = '';
      vm.searchText = '';
      vm.record[vm.field.field] = null;
      vm.values = [];
    }

    $scope.$on('$destroy', function() {
      if (searchTimeout) {
        $timeout.cancel(searchTimeout);
      }
      detachScrollListener();
    });
  }
})();
(function() {
	'use strict';

	angular
		.module('app.main')
		.directive('txDataGrid', txDataGridDirective);

	function txDataGridDirective() {
		var directive = {
			bindToController: true,
			controller: txDataGridController,
			controllerAs: 'vm',
            link: link,
			restrict: 'E',
			scope: {
				data: '=txData',
                assigendRecords: '=?txAssignedRecords',
                selectedRecords: '=?txSelectedRecords',
                model: '=txModel',
                filteredData: '=?txFilteredData',
				isLoading: '=?txIsLoading',
                viewType: '@?txViewType',
                secondaryProperty: '@?txSecondaryProperty',
                primaryProperty: '@?txPrimaryProperty',
                hoverProperty: '@?txHoverProperty',
                isAdvanceSearchEnabled: '@?txAdvancedSearch'

			},
			templateUrl: 'app/directives/txDataGrid/tx-data-grid.html'
		};
		return directive;

        function link(scope, element, attrs) {
            scope.element = element;

            if (angular.isUndefined(scope.vm.filteredData))
            {
                scope.vm.filteredData = [];
            }

			if (angular.isUndefined(scope.vm.isLoading))
			{
				scope.vm.isLoading = false;
			}
            if(angular.isUndefined(scope.vm.selectedRecords)) {
                scope.vm.selectedRecords = [];
            }
            if(angular.isUndefined(scope.vm.viewType)) {
                scope.vm.viewType = 'checklist';
            }
        }
	}
	/* @ngInject */
	function txDataGridController ($window, $scope, $timeout, utility, $filter, hotkeys) {
		var vm = this;

        // data

        var searchableProperties = [];
        var isChecklistViewInitialize = false;
        var advanceSearchDelayTimer;
        vm.isIndeterminate = false;
        vm.isAdvanceSearch = false;
        vm.advancedSearchValues = '';
        vm.searchPhrase = '';
        vm.filteredDataLength = 0;
        vm.dataLength = 0;
        vm.selectedRecordsLength = 0;
        vm.activeRow = 0;
        vm.topIndex = 0;
        vm.allSelected = false;
        var timeoutPromises = {};
        var watchUnsubscribers = {};


        // methods
        vm.doSelectAll = doSelectAll;
        vm.doItemClick = doItemClick;
        vm.onSelectChange= onSelectChange;
        vm.toggleAdvancedSearch = toggleAdvancedSearch;
        vm.advancedSearchKeyPress = advancedSearchKeyPress;
        vm.registerHotkeys = registerHotkeys;


        watchUnsubscribers.data = $scope.$watch('vm.data', updateData);
        watchUnsubscribers.searchPhrase = $scope.$watch('vm.searchPhrase', updateFilteredDataOnBasicSearch);
        $window.addEventListener('resize', onResize);
        // vm.dataProvider = {
        //     getItemAtIndex: dpGetItemAtIndex,
        //     getLength: dpGetLength,
        //     _count: 0,
        //     _refresh: function() {
        //         this._count++;
        //     }
        // };

        initialize();

        /////////////////////



        function initialize() {
            registerHotkeys(true);
            vm.listStyle = {
                height: ($window.innerHeight - 385) + 'px' //not accurate, just for initialization
            };
            vm.advancedSearchVDevider = { // for advanced search vertical devider
                height: ($window.innerHeight - 385) + 64 + 'px'//not accurate, just for initialization
            };
            vm.toolbarStyle ={ // for advanced search label
                height: 64 + 'px' //not accurate, just for initialization
            }
            vm.statusField = angular.isDefined(vm.model.customStatusField) ? vm.model.customStatusField : 'Status';// if needed by images
            vm.hoverProperty = angular.isDefined(vm.hoverProperty) ? vm.hoverProperty : vm.secondaryProperty;

            // create searchableProperties list used for search (to only search with thoese properties)
            if(angular.isDefined(vm.secondaryProperty) && vm.secondaryProperty !== null && vm.secondaryProperty !== '') {
                searchableProperties.push(vm.secondaryProperty);
            }
            if(angular.isDefined(vm.primaryProperty) && vm.primaryProperty !== null && vm.primaryProperty !== '') {
                searchableProperties.push(vm.primaryProperty);
            }
            if(angular.isDefined(vm.hoverProperty) && vm.hoverProperty !== null && vm.hoverProperty !== '' && vm.hoverProperty !== vm.secondaryProperty) {
                searchableProperties.push(vm.hoverProperty);
            }
            timeoutPromises.resize = $timeout(onResize, 500);
        }

        function doSelectAll(filterString) {
            if(angular.isDefined(filterString) && !angular.isString(filterString)) { // since not in all the module (orlderlines) `Status` property represent Status of record
                var value = filterString;
                filterString = {};
                filterString[vm.statusField] = value;
            }

            vm.allSelected = utility.selectBasedOnFilterString(vm.filteredData, filterString, vm.allSelected);
            onSelectChange();
        }

        /**
         * @description:
         * this methos will calculate selectedRecords and selectedRecordsLength
         */
        function onSelectChange() {
            vm.selectedRecords = [];
            for (var index=0; index<vm.dataLength; index++) {
                if (vm.data[index] && vm.data[index].selected) {
                    vm.selectedRecords.push(vm.data[index]);
                }
            }
            vm.selectedRecordsLength = vm.selectedRecords.length;
            calculateCheckAllStatus();
        }

        function doItemClick(item) {
            item.selected = !item.selected;
            onSelectChange();
        }

        function toggleAdvancedSearch() {
            vm.isAdvanceSearch = !vm.isAdvanceSearch;
            processData();
        }

        function advancedSearchKeyPress(keyEvent) {
            if (keyEvent.which === 27) {
                toggleAdvancedSearch();
            }
            else {
                if(angular.isDefined(advanceSearchDelayTimer)) {
                    $timeout.cancel(advanceSearchDelayTimer);
                }
                advanceSearchDelayTimer = $timeout(function() {
                    processData();
                }, 1000);
            }
        }

        //helper methods

        function updateData(newVal) {
            if(angular.isDefined(newVal) && angular.isArray(newVal)) {
                // to check if group selection based on Status field is possible
                processData();
                if( !isChecklistViewInitialize && angular.isDefined(vm.assigendRecords) && angular.isArray(vm.assigendRecords) && vm.dataLength > 0) {
                    vm.canSelectBasedOnStatusField = (angular.isDefined(newVal) && angular.isDefined(newVal[0]) && angular.isDefined(newVal[0][vm.statusField])) ? true : false;
                    initializeChecklistView(vm.data, vm.assigendRecords);
                }
                onSelectChange();
            }
        }

        function updateFilteredDataOnBasicSearch() {
           if (angular.isUndefined(vm.data)) {
                return;
            }
            processData();
        }

        function processData() {
            var searchValues;
            if(vm.isAdvanceSearch) {
                searchValues = getAdvancedSearchValues();
            }
            else {
                searchValues = vm.searchPhrase;
            }
            vm.filteredData = $filter('advancedSearch')(vm.data, searchValues, vm.model, searchableProperties);
            vm.filteredData = $filter('orderBy')(vm.filteredData, vm.model.views.mainList.sortColumn, vm.model.views.mainList.sortDescending);
            if (angular.isUndefined(vm.filteredData)) {
                return;
            }
            vm.filteredDataLength = vm.filteredData.length;
            vm.dataLength = vm.data.length;
            // vm.dataProvider._refresh();
        }

        /**
         * @description:
         * this method will only execute once when the directive get initialize and will loop through assigendRecords and set 'selected' property of respected record in data array to true
         * @param {array} data: data assigned to isolated scope vm.data
         * @param {array} assigendRecords: subset of vm.data
         */
        function initializeChecklistView(data, assigendRecords) {
            var filterCriteria = {};
            angular.forEach(assigendRecords, function(assigendRecord) {
                filterCriteria[vm.model.idField] = assigendRecord[vm.model.idField];
                utility.filterObject(data, filterCriteria, true)[0].selected = true; // check if return value of filter is reffering to the object in data (referencing same record)
            });
            isChecklistViewInitialize = true;
        }

        // function dpGetItemAtIndex(index) {
        //     return vm.filteredData[index];
        // }

        // function dpGetLength() {
        //     return vm.filteredDataLength;
        // }

        function calculateCheckAllStatus() {
            if(vm.selectedRecordsLength !== 0 && vm.selectedRecordsLength !== vm.filteredDataLength){
                vm.isIndeterminate = true;
            }
            else {
                vm.isIndeterminate = false;
            }
            if(vm.selectedRecordsLength === vm.filteredDataLength) {
                vm.allSelected = true;
            }
            else {
                vm.allSelected = false;
            }
        }

        function onResize() {
            timeoutPromises.calculateDialogHeight = $timeout(function() {
               calculateDialogHeight();
            }, 100);
        }

        function calculateDialogHeight() {
            if (angular.isDefined($scope.element)) {
                var toolbarHeight = 0;
                var actionbarHeight = 0;
                var titlebarHeight = 0;
                var toolbar = angular.element($scope.element[0].querySelector('.toolbar'));
                var actionbar = angular.element($scope.element[0].offsetParent.offsetParent.querySelector('#actionbar'));
                var titlebar = angular.element($scope.element[0].offsetParent.offsetParent.querySelector('#titlebar'));
                if (toolbar) {
                    toolbarHeight = toolbar.outerHeight();
                    vm.toolbarStyle.height = toolbarHeight +'px'; // for advanced search label
                }
                if (actionbar) {
                    actionbarHeight = actionbar.outerHeight();
                }
                if (titlebar) {
                    titlebarHeight = titlebar.outerHeight();
                }

                var dialogHeight =  $scope.element.offsetParent()[0].offsetParent.offsetHeight;
                var listHeight = dialogHeight - (titlebarHeight + toolbarHeight + actionbarHeight);
                vm.listStyle.height = listHeight + 'px';
                vm.advancedSearchVDevider.height = listHeight + toolbarHeight + 'px';

                if (!$scope.$root.$$phase) $scope.$digest();
                $scope.$broadcast('$md-resize');
            }
        }


        function registerHotkeys(register) {

            if (register) {
                hotkeys.del('ctrl+a');
                hotkeys.del('ctrl+shift+a');
                hotkeys.del('left');
                hotkeys.del('right');
                hotkeys.del('up');
                hotkeys.del('down');
                hotkeys.del('space');

                var selTxt = $filter('translate')('ACTIONS.SELECT.SELECT');
                hotkeys.bindTo($scope)
                    .add({
                        combo: 'ctrl+a',
                        description: selTxt + ' ' + $filter('translate')('ACTIONS.SELECT.ALL'),
                        callback: function(event) {
                            vm.doSelectAll('all');
                            event.preventDefault();
                        }
                    })
                    .add({
                        combo: 'ctrl+shift+a',
                        description: selTxt + ' ' + $filter('translate')('ACTIONS.SELECT.NONE'),
                        callback: function(event) {
                            vm.doSelectAll('none');
                            event.preventDefault();
                        }
                    })
                    .add({
                        combo: 'left',
                        description: $filter('translate')('ACTIONS.PREV_RECORD'),
                        callback: function (event) {
                            gotoRecord(-1);
                            event.preventDefault();
                        }
                    })
                    .add({
                        combo: 'right',
                        description: $filter('translate')('ACTIONS.NEXT_RECORD'),
                        callback: function(event) {
                            gotoRecord(1);
                            event.preventDefault();
                        }
                    })
                    .add({
                        combo: 'up',
                        description: $filter('translate')('ACTIONS.PREV_ROW'),
                        callback: function (event) {
                            var pos = calculatePosBasedScreen();
                            gotoRecord(-pos);
                            event.preventDefault();
                        }
                    })
                    .add({
                        combo: 'down',
                        description: $filter('translate')('ACTIONS.NEXT_ROW'),
                        callback: function(event) {
                            var pos = calculatePosBasedScreen();
                            gotoRecord(pos);
                            event.preventDefault();
                        }
                    })
                    .add({
                        combo: 'space',
                        description: selTxt + ' ' + $filter('translate')('ACTIONS.SELECT.CURRENT'),
                        callback: function(event) {
                            if (vm.activeRow >= 0 && angular.isDefined(vm.filteredData) && vm.activeRow < vm.filteredDataLength) {
                                vm.filteredData[vm.activeRow].selected = !vm.filteredData[vm.activeRow].selected;
                                onSelectChange();
                            }
                            event.preventDefault();
                        }
                    });
            }
        }

        function gotoRecord(pos) {
            if ((pos < 0 && vm.activeRow == 0) || (pos > 0 && vm.activeRow == vm.filteredDataLength-1)) {
                return false;
            }
            vm.activeRow += pos;
        }

        /**
         * description:
         * calculate number of records need to be skip when using arrow key based on screen size (calculated based on media query used to arrange data in columns)
         */
        function calculatePosBasedScreen() {
            if($window.innerWidth < 600){
                return 1;
            }
            else if($window.innerWidth >= 600 && $window.innerWidth < 960) {
                return 2;
            }
            else if($window.innerWidth >= 960 &&  $window.innerWidth < 1280) {
                return 3;
            }
            else if($window.innerWidth >= 1280 &&  $window.innerWidth < 1920) {
                return 4;
            }
            else if($window.innerWidth >= 1920) {
                return 5;
            }
        }

        function getAdvancedSearchValues() {
            var filterValues = vm.advancedSearchValues.match(/[^\r\n]+/g);
            filterValues = (filterValues === null && vm.advancedSearchValues === "") ? "" : filterValues; // removing all element result in "" and regex making it null
            if(angular.isDefined(filterValues) && angular.isArray(filterValues) && filterValues.length > 0) {
                for(var i=0, len=filterValues.length; i<len; i++) {
                    filterValues[i] = filterValues[i].trim();
                }
            }
            return filterValues;
        }

        $scope.$on('$destroy', function () {
            $window.removeEventListener('resize', onResize);
            for(var prop in watchUnsubscribers) {
                watchUnsubscribers[prop]();
            }
            for(var key in timeoutPromises) {
                $timeout.cancel(timeoutPromises[key]);
            }
            $timeout.cancel(advanceSearchDelayTimer);
            $scope.element = null;
        });
	}
})();
(function() {
	'use strict';

	angular
		.module('app.main')
		.directive('txDataDetails', txDataDetailsDirective);


	function txDataDetailsDirective() {
		// Usage:
		//
		// Creates:
		//
		var directive = {
			bindToController: true,
			controller: txDataDetailsController,
			controllerAs: 'vm',
			link: link,
			restrict: 'E',
			scope: {
				account: '=txAccount',
								parentId: '=?txParentId',
								title: '=txTitle',
								model: '=txModel',
								itemActions: '=?txItemActions',
								itemActionEvent: '&?txItemActionEvent',
								processOrderItemActionEvent: '&?txProcessOrderItemActionEvent',
								isLoading: '=?txIsLoading',
								refreshActionEvent: '&?txRefreshActionEvent',
								heightOffset: '@?txHeightOffset',
								isActive: '&?txIsActive',
								showRefreshRecordButton: '=?txRefreshRecordButton',
								editRecordEvent: '&?txEditRecordEvent', // to open a module specific edit dialog instead of the generic one
								isRequestModule:'=?txIsRequestModule' // specific for request module to show request content in details view
			},
			templateUrl: 'app/directives/txDataDetails/tx-data-details.html'
		};

		return directive;

		function link(scope, element, attrs) {
						scope.element = element;
						var watchUnsubscriber;

			if (angular.isUndefined(scope.vm.isLoading))
			{
				scope.vm.isLoading = false;
			}

						if (angular.isUndefined(scope.vm.heightOffset))
						{
								scope.vm.heightOffset = 0;
						}

						if (angular.isDefined(scope.vm.isActive)) {
								watchUnsubscriber = scope.$watch(function() { return scope.vm.isActive(); }, function() {
										scope.vm.registerHotkeys(scope.vm.isActive());
								});
						} else {
								scope.vm.registerHotkeys(true);
						}

						scope.$on('$destroy', function() {
								if(angular.isFunction(watchUnsubscriber)) {
										watchUnsubscriber();
								}
						});

		}
	}
	/* @ngInject */
	function txDataDetailsController ($window, $scope, $timeout, $log, $mdDialog, $document, utility, api, dialog, hotkeys, $filter, catalogFactory, toast) {
		var vm = this;
				vm.doItemAction = doItemAction;
				vm.doProcessOrderItemAction = doProcessOrderItemAction;
				vm.doRefreshAction = doRefreshAction;
				vm.editRecord = editRecord;
				vm.isActionDisabled = isActionDisabled;
				vm.isProcessOrderActionDisabled = isProcessOrderActionDisabled;
				vm.lookupData = {};
				vm.showRequestContent = false;
				vm.listStyle = {
						height: ($window.innerHeight - 324) + 'px'
				}
				vm.registerHotkeys = registerHotkeys;
				var timeoutPromise;
				var watchUnsubscriber;

				watchUnsubscriber = $scope.$watch('vm.account', watchDataChange, true);

				function watchDataChange(newval, oldVal) {
						if(angular.isDefined(newval)) {
								if(angular.isDefined(vm.model.modelPath) && (vm.model.modelPath === 'orders.orderlines' || vm.model.modelPath === 'orders.rejectedOrderlines')) { // to evaluate orderline Status value; inputType must be orderlineStatus
										evaluateOrderlineStatusValue(newval);
								} else if(angular.isDefined(vm.model.modelPath) && vm.model.modelPath === 'forecast.articles') { // to evaluate forecast line Status value; inputType must be forecastLineStatus
									evaluateForecastLineStatusValue(newval)
								}
						}
				}
				if(angular.isDefined(vm.isRequestModule) && vm.isRequestModule === true) {
					vm.showRequestContent = true;
				}

				loadLookupData();
				addIsRequestFieldStatus();

				timeoutPromise = $timeout(onResize, 500);
		////////

				vm.statusField = angular.isDefined(vm.model.customStatusField) ? vm.model.customStatusField : 'Status';

				$window.addEventListener('resize', onResize);
				function onResize() {
						$log.info('onResize');

						if (angular.isDefined($scope.element))
						{
								var viewToolbar = angular.element($scope.element[0].querySelector('.view-toolbar'));
								var viewToolbarHeight = 0;


								if (viewToolbar) {
										viewToolbarHeight = viewToolbar.outerHeight();
								}

								vm.listHeight = ($window.innerHeight - $scope.element.offset().top - $scope.vm.heightOffset - viewToolbarHeight - 0);
								vm.listStyle.height = vm.listHeight + 'px';
								if (!$scope.$root.$$phase) $scope.$digest();
								$scope.$broadcast('$md-resize');
						}
				}
				$scope.$on('$destroy', function () {
						$window.removeEventListener('resize', onResize);
						$timeout.cancel(timeoutPromise);
						watchUnsubscriber();
						$scope.element = null;
				});


				function registerHotkeys(register) {

						if (register) {
								hotkeys.del('ctrl+a');
								hotkeys.del('ctrl+shift+a');
								hotkeys.del('/');
								hotkeys.del('ctrl+r');
								hotkeys.del('ctrl+x');
								hotkeys.del('up');
								hotkeys.del('down');
								hotkeys.del('space');
								hotkeys.del('enter');

								hotkeys.bindTo($scope)
										.add({
												combo: 'ctrl+r',
												description: $filter('translate')('ACTIONS.REFRESH'),
												callback: function(event) {
														vm.doRefreshAction();
														event.preventDefault();
												}
										});
						}
				}

				function loadLookupData() {
						var fields = utility.filterObject(vm.model.fields, {visible:true});
						for (var i=0; i<fields.length; i++) {
								if (fields[i].inputType === 'lookup' || fields[i].inputType === 'lookup-many' || fields[i].inputType === 'articlenumber' || fields[i].inputType === 'modelnumber' || fields[i].inputType === 'linkedcatalogarticlenumber') {
										if (!vm.lookupData[fields[i].lookupSource] || angular.isUndefined(vm.lookupData[fields[i].lookupSource])) {
												loadLookup(fields[i].lookupSource);
										}
								}
						}
				}

				function loadLookup(lookupSource) {
						vm.lookupData[lookupSource] = {};

						api.getLookupData(api.getModel(lookupSource)).then(function(result) {
								vm.lookupData[lookupSource] = result;
						});
				}

				// adding isRequestField as false for all the visible fields(For request module added
				// isRequestField as true to display it under request content header in UI details screen).
				function addIsRequestFieldStatus() {
					var fields = utility.filterObject(vm.model.fields, {visible:true});
						for (var i=0; i<fields.length; i++) {
								if(angular.isUndefined(fields[i].isRequestField)) {
									fields[i].isRequestField = false;
								}
								if(angular.isUndefined(fields[i].isRequestReasonField)) {
									fields[i].isRequestReasonField = false;
								}
						}
				}

		function doItemAction(action, account) {
			if (angular.isFunction(vm.itemActionEvent))
			{
								if(action.requiresConfirmation) {
										dialog.confirm(action.confirmationContent, action.confirmationAction, account, vm.model, action)
										.then(function(response){
												if(response.userAction.toLowerCase() === 'confirm'){
														vm.itemActionEvent({action: action, account: account, additionalInfo: response});
												}
										});
								} else if (action.url) {//for download item action
										if (!account.FileName && !account.FilePath) {
												toast.error('', 'Download Failed', '', { message: 'You can not download without valid FileName and FilePath' });
										} else {
												var URL = account.FilePath + '/' + account.FileName;
												var downloadLink = angular.element('<a></a>');
												downloadLink.attr('href', URL);
												downloadLink.attr('download', account.FileName);
												downloadLink[0].click();
										}
								}
								else {
										vm.itemActionEvent({action: action, account: account, additionalInfo: {}});
								}
			}
		}

				function doProcessOrderItemAction(action, account) {
			if (angular.isFunction(vm.processOrderItemActionEvent)){
								if(action.requiresConfirmation) {
										dialog.confirm(action.confirmationContent, action.confirmationAction, account, vm.model)
										.then(function(response) {
												if(response.userAction.toLowerCase() === 'confirm') {
														vm.processOrderItemActionEvent({action: action, account: account});
												}
										});
								}
								else {
										vm.processOrderItemActionEvent({action: action, account: account});
								}
			}
				}

				function doRefreshAction() {
						if (angular.isFunction(vm.refreshActionEvent))
						{
								vm.refreshActionEvent({});
						}
				}

				function editRecord(ev, record) {
						// modules providing their own edit dialog (like users) handle the edit and the refresh themselves
						if (angular.isDefined(vm.editRecordEvent)) {
								vm.editRecordEvent({event: ev, record: record});
								return;
						}

						api.showEditRecordDialog(angular.element($document.body), ev, vm.model, record, vm.parentId)
						.then(function(saved) {
								if (saved)
								{
										vm.doRefreshAction();
								}
						});
				}

				function isActionDisabled(account, matchingFilter) {
						//If matching filter true then disable
						if(matchingFilter === true) {
								return true;
						}//disable/enable of delete and activate button
						else if (account && matchingFilter) {
								var selectedItems= [];
								selectedItems.push(account);
								// excludeProperties exclude selected portion of criteria defined in model.
								// replacing dataTableFilter with utility filter hence updating matchingFilter to perform exact match if any performance impact then needs to create a custom filter
								for(var key in matchingFilter) {
									if(!angular.isArray(matchingFilter[key])) {
										matchingFilter[key] = '!' + matchingFilter[key];
									}
								}
								var matchingItems = $filter('dataTableFilter')(selectedItems, utility.excludeProperties(matchingFilter,['selected']));

								return (selectedItems.length != matchingItems.length);
						}
						//Disbale edit button based on account status
						else if(account && angular.isDefined(account.Status)){
								return !account.Status;
						}
						else {
								return false;
						}
				}

				// identify if orderProcesAction needed to be disable or not
				function isProcessOrderActionDisabled(data, itemAction) {

						if(!itemAction.visible) {
							return true;
						}
						var predicateVal = $scope.$eval(itemAction.enabled);

						//hide confirm action if UseConfirmOrder is not set at seller level
						if(itemAction.id.toUpperCase() === 'CONFIRM' && catalogFactory.getUseConfirmOrder() != 1) {
								return true;
						}
						if (data && predicateVal) {
								var selectedItems= [];
								selectedItems.push(data);
								var matchingItems = $filter('orderProcessStatusFilter')(selectedItems, predicateVal);
								return (selectedItems.length == 0 || selectedItems.length !== matchingItems.length);
						}
						else {
								return false;
						}
				}

				/**
				 * @description:
				 *  this method will evaluate orderline Status value and will add array or translatable key denoting reason behind invalid orderline for each record
				 * this method will called only from data watcher only for orderline and rejected orderline models (modelPath is used to identify)
				 */
				function evaluateOrderlineStatusValue(record) {
						record.invalidOrderlineReason = [];
						if (record[vm.statusField] === 0) {
								record.invalidOrderlineReason.push($filter('translate')('ORDERLINE.INACTIVE_REASONS.DEACTIVATED_RECORD'));
						}
						if ((record.Status & 2) === 2) {
								record.invalidOrderlineReason.push($filter('translate')('ORDERLINE.INACTIVE_REASONS.DEACTIVATED_ARTICLES'));
						}
						if ((record.Status & 4) === 4) {
								record.invalidOrderlineReason.push($filter('translate')('ORDERLINE.INACTIVE_REASONS.DEACTIVATED_CATALOG_CRD'));
						}
						if ((record.Status & 8) === 8) {
								record.invalidOrderlineReason.push($filter('translate')('ORDERLINE.INACTIVE_REASONS.DEACTIVATED_CATALOG/CUSTOMER_SEGMENTATION'));
						}
						if ((record.Status & 16) === 16) {
								record.invalidOrderlineReason.push($filter('translate')('ORDERLINE.INACTIVE_REASONS.DEACTIVATED_PRICE_GROUP'));
						}
						if ((record.Status & 32) === 32) {
								record.invalidOrderlineReason.push($filter('translate')('ORDERLINE.INACTIVE_REASONS.DEACTIVATED_SIZE'));
						}
						if ((record.Status & 64) === 64) {
								record.invalidOrderlineReason.push($filter('translate')('ORDERLINE.INACTIVE_REASONS.DEACTIVATED_ARTICLE_CRD'));
						}
						if ((record.Status & 128) === 128) {
								record.invalidOrderlineReason.push($filter('translate')('ORDERLINE.INACTIVE_REASONS.DEACTIVATED_ARTICLE_SEGMENTATION'));
						}
						if ((record.Status & 256) === 256) {
								record.invalidOrderlineReason.push($filter('translate')('ORDERLINE.INACTIVE_REASONS.DEACTIVATED_ARTICLE_CRD_AVAILABILITY'));
						}
						if ((record.Status & 512) === 512) {
								record.invalidOrderlineReason.push($filter('translate')('ORDERLINE.INACTIVE_REASONS.DEACTIVATED_ALLOCATION_CRITERIA'));
						}
						if ((record.Status & 1024) === 1024) {
								record.invalidOrderlineReason.push($filter('translate')('ORDERLINE.INACTIVE_REASONS.INVALID_SEGMENTATION'));
						}
						if ((record.Status & 2048) === 2048) {
								record.invalidOrderlineReason.push($filter('translate')('ORDERLINE.INACTIVE_REASONS.UNLINKED_CUSTOMER'));
						}
				}

				/**
				 * @description:
				 * this method will evaluate forecast line Status value and will add array or translatable key denoting reason behind invalid forecast line for each record
				 * this method will called data watcher only for forecast line models (modelPath is used to identify)
				 */
				 function evaluateForecastLineStatusValue(record) {
					record.invalidForecastLineReason = [];
					if (record[vm.statusField] === 0) {
						record.invalidForecastLineReason.push($filter('translate')('FORECAST.INACTIVE_REASONS.DEACTIVATED_RECORD'));
					}
					if ((record.ForecastLineStatus & 2) === 2) {
						record.invalidForecastLineReason.push($filter('translate')('FORECAST.INACTIVE_REASONS.DEACTIVATED_ARTICLES'));
					}
					if ((record.ForecastLineStatus & 4) === 4) {
						record.invalidForecastLineReason.push($filter('translate')('FORECAST.INACTIVE_REASONS.ARTICLE_SEGMENTATION'));
					}
				}
	}
})();
(function () {
  'use strict';

  angular
    .module('app.main')
    .directive('txColResizer', txColResizerDirective);

  /* @ngInject */
  function txColResizerDirective($timeout, $document, $window) {
    // Usage:
    //
    // Creates:
    //
    var directive = {
      link: link,
      restrict: 'AE',
      scope: {
        txDirection: '=',
        // txFlex: '=',
        txContainerWidth: '=',
        txColsWidth: '=',
        txCols: '=',
        txColIndex: '@',
        txGrabber: '@',
        txDisabled: '@',
        txPersistColsWidth: '&?'
      }
    };
    return directive;

    function link(scope, element, attr) {
      element.addClass('resizable');

      var grabbers = [];
      var isLastColumnCurrentState = (parseInt(scope.txColIndex) <= scope.txCols.length);

      var watchCleanup = scope.$watchCollection('txCols', function() {
        var isLastColumnNewState = (parseInt(scope.txColIndex) <= scope.txCols.length);

        if (isLastColumnNewState != isLastColumnCurrentState) {
          isLastColumnCurrentState = isLastColumnNewState;
          if (isLastColumnNewState) {
            grabbers = addDraggers();
          }
          else {
            removeDraggers(grabbers);
          }
        }
      });

      if (isLastColumnCurrentState) {
        grabbers = addDraggers();
      }

      function removeDraggers() {
        angular.forEach(grabbers, function(itm) {
          itm.parentNode.removeChild(itm);
        });
        grabbers = [];
      }

      function addDraggers() {
        var dragger = [];
        var style = $window.getComputedStyle(element[0], null),
          w,
          h,
          dir = scope.txDirection,
          inner = scope.txGrabber ? scope.txGrabber : '<span></span>',
          start,
          dragDir,
          axis,
          info = {};

        var maxWidth, minWidth = 100;

        var dragStart = function (e, direction) {
          dragDir = direction;
          axis = dragDir === 'left' || dragDir === 'right' ? 'x' : 'y';
          start = axis === 'x' ? e.clientX : e.clientY;
          w = parseInt(style.getPropertyValue('width'));
          h = parseInt(style.getPropertyValue('height'));

          maxWidth = scope.txContainerWidth;

          //prevent transition while dragging
          element.addClass('no-transition');

          $document[0].addEventListener('mouseup', dragEnd, false);
          $document[0].addEventListener('mousemove', dragging, false);

          // Disable highlighting while dragging
          if (e.stopPropagation) e.stopPropagation();
          if (e.preventDefault) e.preventDefault();
          e.cancelBubble = true;
          e.returnValue = false;

          // updateInfo(e);
          // scope.$emit('angular-resizable.resizeStart', info);
          // scope.$apply();
        };

        var dragging = function (e) {
          // var prop;
          var offset, data = 0;
          offset = e.clientX - start;
          switch (dragDir) {
            case 'top':
              // prop = scope.txFlex ? flexBasis : 'height';
              // data = h - offset;
              // element[0].style[prop] = data + 'px';
              break;
            case 'bottom':
              // prop = scope.txFlex ? flexBasis : 'height';
              // data = h + offset;
              // element[0].style[prop] = data + 'px';
              break;
            case 'right':
              // prop = scope.txFlex ? flexBasis : 'width';
              data = w + offset;
              if (data > maxWidth) {
                data = maxWidth;
              }
              if (data < minWidth) {
                data = minWidth;
              }
              break;
            case 'left':
              // prop = scope.txFlex ? flexBasis : 'width';
              // data = w - offset;
              // element[0].style[prop] = data + 'px';
              break;
          }

          scope.txColsWidth[scope.txCols[scope.txColIndex].field] = data;
          // updateInfo(e);
          throttle(function () {
            // scope.$emit('angular-resizable.resizing', info);
          });
        };

        var dragEnd = function (e) {
          // updateInfo();
          // scope.$emit('angular-resizable.resizeEnd', info);
          // scope.$apply();
          if(angular.isFunction(scope.txPersistColsWidth)) {
            scope.txPersistColsWidth();
          }
          $document[0].removeEventListener('mouseup', dragEnd, false);
          $document[0].removeEventListener('mousemove', dragging, false);
          element.removeClass('no-transition');
        };

        angular.forEach(dir, function (direction) {
          var grabber = $document[0].createElement('div');

          // add class for styling purposes
          grabber.setAttribute('class', 'tx-r-' + direction);
          grabber.innerHTML = inner;
          element[0].appendChild(grabber);
          grabber.ondragstart = function () { return false; };
          grabber.addEventListener('mousedown', function (e) {
            var disabled = (scope.txDisabled === 'true');
            if (!disabled && e.which === 1) {
              // left mouse click
              dragStart(e, direction);
            }
          }, false);

          dragger.push(grabber);
        });

        return dragger;
      }

      scope.$on('$destroy', function() {
        removeDraggers(grabbers);
        watchCleanup();
      });
    }

    var toCall;
    function throttle(fun) {
      if (angular.isUndefined(toCall)) {
        toCall = fun;
        $timeout(function () {
          toCall();
          toCall = undefined;
        }, 50);
      } else {
        toCall = fun;
      }
    }
  }
})();
(function() {
    'use strict';

    angular
        .module('app.main')
        .directive('txClearAutocomplete', txClearAutocomplete);

    /** @ngInject */
    function txClearAutocomplete($parse, $compile) {

        var directive = {
            restrict: 'A',
            link: linkFunciton
        }
        return directive;

        function linkFunciton(scope, element, attrs) {
            var watchUnsubscribers = {};

            var ngDisabledModel = $parse(attrs.ngDisabled);

            var button = angular.element('<md-button>').attr('aria-label', 'Remove Selected Item');
            button.append('<md-icon md-font-icon="icon-close" class="material-icon md-font icon-close md-default-theme"></md-icon>');
            element.append(button);
            $compile(button)(scope);
            button.removeClass().addClass('tx-clear-autocomplete');

            var searchTextModel = $parse(attrs.mdSearchText);

            watchUnsubscribers.searchTextModel = scope.$watch(searchTextModel, function(searchText) {
                if (searchText && searchText !== '' && searchText !== null) {
                    if(ngDisabledModel(scope)){
                        button.addClass('disabled');
                    }
                    else {
                        button.addClass('visible');
                    }
                }
                else {
                    button.removeClass('visible');
                    button.removeClass('disabled');
                }
            });

            watchUnsubscribers.ngDisabledModel = scope.$watch(ngDisabledModel, function(isElementDisabled) {
                if(angular.isDefined(isElementDisabled)) {
                    button[0].disabled = isElementDisabled;
                    var searchText = angular.copy(searchTextModel(scope));
                    if(angular.isDefined(searchText) && searchText !== '' && searchText !== null) {
                        if(isElementDisabled) {
                            button.addClass('disabled');
                        }
                        else {
                            button.removeClass('disabled');
                        }
                    }
                }
            });

            button.on('click', function() {
                scope.$apply(function() {
                    searchTextModel.assign(scope, undefined);
                    element.find('input').focus();
                });
            });

            scope.$on('$destroy', function() {
                button.off('click');
                for(var key in watchUnsubscribers) {
                    watchUnsubscribers[key]();
                }
            });
        }
    }

})();
(function() {
		'use strict';
		 angular
				.module('app.main')
				.directive('txChip', txChip);

		/**
		* txChip will make existing records non removable
		*/
		/** @ngInject */
		function txChip($log, $parse) {
			return {
					restrict: 'A',
					link: function(scope, elem, attrs) {

						var directiveValue = attrs.txChip;
						var directiveValues = directiveValue.split(':');
						if(directiveValues.length < 2 || !directiveValues[2]) {
							$log.warn('wrong usage of tx-chip directive\nplease add list of existing records, chip value seperated by ":" as directive value');
							return;
						}
						var existingRecords= $parse(directiveValues[0])(scope);
						var chipId= $parse(directiveValues[1])(scope);

						var isExistingValue = false;
						var mdChip = elem.parent().parent();

						//Make sure existing values are defined only when field.nonRemovableChips is true(Check is done in viewcreator controller)
						if(angular.isDefined(existingRecords) && existingRecords.length > 0) {
							angular.forEach(existingRecords, function(record) {
								if(record === chipId) {
									isExistingValue = true;
								}
							})
							if(isExistingValue) {
								scope.$watch(function() {
									mdChip[0].querySelector('.md-chip-remove-container').style.display = "none";
									mdChip.addClass('disableChip');
									mdChip.attr('title', 'Model level attribute cannot be removed from here');
								});
							}
						} else {
							return
						}
					}
				}
		}

})();

(function() {
    'use strict';

    angular
        .module('app.main')
        .directive('txBreadcrumbs', txBreadcrumbsDirective);

    /** @ngInject */
    function txBreadcrumbsDirective($rootScope, $interpolate, $state, catalogFactory) {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            templateUrl: 'app/directives/txBreadcrumbs/tx-breadcrumbs.html',
            link: link,
            restrict: 'E',
            scope: {
                displaynameProperty: '@txDisplaynameProperty',
                abstractProxyProperty: '@?txAbstractProxyProperty'
            }
        };
        return directive;

        function link(scope, element, attrs) {
            scope.breadcrumbs = [];
            if ($state.$current.name !== '') {
                updateBreadcrumbsArray();
            }
            scope.$on('$stateChangeSuccess', function() {
                updateBreadcrumbsArray();
            });

            scope.$on('breadcrumb-updated', function () {
                updateBreadcrumbsArray();
            });

            scope.$on('ActiveCatalogChangedEvent', function() {
                updateBreadcrumbsArray();
            });

            /**
             * Start with the current state and traverse up the path to build the
             * array of breadcrumbs that can be used in an ng-repeat in the template.
             */
            function updateBreadcrumbsArray() {
                var workingState;
                var displayName;
                var breadcrumbs = [];
                var currentState = $state.$current;

                while(currentState && currentState.name !== '') {
                    workingState = getWorkingState(currentState);
                    if (workingState) {
                        displayName = getDisplayName(workingState);

                        if (displayName !== false && !stateAlreadyInBreadcrumbs(workingState, breadcrumbs)) {
                            breadcrumbs.push({
                                displayName: displayName,
                                route: workingState.name
                            });
                        }
                    }
                    currentState = currentState.parent;
                }
                breadcrumbs.reverse();
                scope.breadcrumbs = breadcrumbs;
                scope.activeCatalog = catalogFactory.getActiveCatalog();
            }

            /**
             * Get the state to put in the breadcrumbs array, taking into account that if the current state is abstract,
             * we need to either substitute it with the state named in the `scope.abstractProxyProperty` property, or
             * set it to `false` which means this breadcrumb level will be skipped entirely.
             * @param currentState
             * @returns {*}
             */
            function getWorkingState(currentState) {
                var proxyStateName;
                var workingState = currentState;
                if (currentState.abstract === true) {
                    if (angular.isDefined(scope.abstractProxyProperty)) {
                        proxyStateName = getObjectValue(scope.abstractProxyProperty, currentState);
                        if (proxyStateName) {
                            workingState = angular.copy($state.get(proxyStateName));
                            if (workingState) {
                                workingState.locals = currentState.locals;
                            }
                        } else {
                            workingState = false;
                        }
                    } else {
                        workingState = false;
                    }
                }
                return workingState;
            }

            /**
             * Resolve the displayName of the specified state. Take the property specified by the `displayname-property`
             * attribute and look up the corresponding property on the state's config object. The specified string can be interpolated against any resolved
             * properties on the state config object, by using the usual {{ }} syntax.
             * @param currentState
             * @returns {*}
             */
            function getDisplayName(currentState) {
                var interpolationContext;
                var propertyReference;
                var displayName;

                if (!scope.displaynameProperty) {
                    // if the displayname-property attribute was not specified, default to the state's name
                    return currentState.name;
                }
                propertyReference = getObjectValue(scope.displaynameProperty, currentState);

                if (propertyReference === false) {
                    return false;
                } else if (angular.isUndefined(propertyReference)) {
                    return currentState.name;
                } else {
                    // use the $interpolate service to handle any bindings in the propertyReference string.
                    interpolationContext =  (angular.isUndefined(currentState.locals)) ? currentState.locals.globals : currentState;
                    displayName = $interpolate(propertyReference.toString())(interpolationContext);
                    return displayName;
                }
            }

            /**
             * Given a string of the type 'object.property.property', traverse the given context (eg the current $state object) and return the
             * value found at that path.
             *
             * @param objectPath
             * @param context
             * @returns {*}
             */
            function getObjectValue(objectPath, context) {
                var i;
                var propertyArray = objectPath.split('.');
                var propertyReference = context;

                for (i = 0; i < propertyArray.length; i ++) {
                    if (angular.isDefined(propertyReference[propertyArray[i]])) {
                        propertyReference = propertyReference[propertyArray[i]];
                    } else {
                        // if the specified property was not found, default to the state's name
                        return undefined;
                    }
                }
                return propertyReference;
            }

            /**
             * Check whether the current `state` has already appeared in the current breadcrumbs array. This check is necessary
             * when using abstract states that might specify a proxy that is already there in the breadcrumbs.
             * @param state
             * @param breadcrumbs
             * @returns {boolean}
             */
            function stateAlreadyInBreadcrumbs(state, breadcrumbs) {
                var i;
                var alreadyUsed = false;
                for(i = 0; i < breadcrumbs.length; i++) {
                    if (breadcrumbs[i].route === state.name) {
                        alreadyUsed = true;
                    }
                }
                return alreadyUsed;
            }
        }
    }
})();
(function () {
  'use strict';

  angular.module('app.main').directive('txForceSelect', txForceSelect);

  /**
   * @description:
   * txForceSelect is a custom form validator that force user to select value from autocomplete list.
  */
  /** @ngInject */
  function txForceSelect($timeout) {

    function linkFunc(scope, element, attrs, autoComplete) {
      // we need to wait for the autocomplete directive
      // to be compiled
      function getInput() {
        return element.find('input').eq(0);
      }
      var listener = scope.$watch(getInput, function (input) {
        if (input.length) {
          listener(); // self release
          var ngModel = input.controller('ngModel');
          input.on('blur', function () {
            if (!autoComplete.scope.selectedItem) {
              scope.$applyAsync(ngModel.$setValidity('required', false));
            }
          });
          
          scope.$watch(function () {
            return autoComplete.scope.selectedItem;
          }, function (selectedItem) {
            if (selectedItem) {
              ngModel.$setValidity('required', true);
            }
          });
        }
      })
    }

    return {
      link: linkFunc,
      require: 'mdAutocomplete',
      restrict: 'A'
    };
  }

})();
(function() {
    'use strict';

    angular
        .module('app.main')
        .directive('txAutocomplete', txAutocompleteDirective);

    /** @ngInject */
    function txAutocompleteDirective() {
        // Usage: Wrapper of the md-auto-complete
        //
        // Creates:
        //
        var directive = {
            bindToController: true,
            controller: txAutocompleteController,
            controllerAs: 'vm',
            link: link,
            restrict: 'E',
            scope: {
                id: '@id',
                label: '@label',
                form: '=txFormName',
                isRequired: '&?txRequired',
                isDisabled: '&?txDisabled',
                listDataSource: '=txDataSource',
                dataSourceDisplayProperty: '@txDataSourceDisplayProperty',
                dataSourceValueProperty: '@txDataSourceValueProperty',
                destinationField: '=ngModel'
            },
            templateUrl: 'app/directives/txAutoComplete/tx-autocomplete.html'
        };
        return directive;

        function link(scope, element, attrs) {
            if (angular.isUndefined(scope.vm.isRequired))
            {
                scope.vm.isRequired = false;
            }
            if (angular.isUndefined(scope.vm.isDisabled)) {
                scope.vm.isDisabled = false;
            }
        }
    }
    /* @ngInject */
    function txAutocompleteController ($log, $scope) {
        var vm = this;

        if (angular.isUndefined(vm.isRequired)) {
            vm.isRequired = false;
        }

        //Vars
        vm.searchText = '';
        vm.hasDisplayProp = angular.isDefined(vm.dataSourceDisplayProperty) && vm.dataSourceDisplayProperty != '*';
        vm.hasValueProp = angular.isDefined(vm.dataSourceValueProperty) && vm.dataSourceValueProperty != '*';
        vm.displayPropCache = {};
        vm.valuePropChache = {};
        var watchUnsubscriber;
        //Watches
        if (vm.hasValueProp || vm.hasDisplayProp) {
            watchUnsubscriber = $scope.$watchCollection('vm.listDataSource', indexDataSource);
        }

        indexDataSource();

        //Methods
        vm.querySearch = querySearch;
        vm.getAutoCompleteDisplayValue = getAutoCompleteDisplayValue;
        vm.selectedItemChanged = selectedItemChanged;
        vm.getItemText = getItemText;

        //Methods Implementation
        function indexDataSource() {
            vm.displayPropCache = {};
            vm.valuePropChache = {};

            if (angular.isUndefined(vm.listDataSource) || !angular.isArray(vm.listDataSource))
                return;

            if (vm.hasDisplayProp) {
                angular.forEach(vm.listDataSource, function(item) {
                    vm.displayPropCache[item[vm.dataSourceDisplayProperty]] = item;
                });
            }

            if (vm.hasValueProp) {
                angular.forEach(vm.listDataSource, function(item) {
                    vm.valuePropChache[item[vm.dataSourceValueProperty]] = item;
                });
            }
        }

        function querySearch(text) {
            var results = [];
            var txt = '';

            if (angular.isDefined(text) && text) {
                txt = text.toString().toLowerCase();
            }

            angular.forEach(vm.listDataSource, function(item) {
                if (angular.isString(item)) {
                    if (txt.length == 0 || item.toLowerCase().indexOf(txt) !== -1) {
                        results.push(item);
                    }
                } else {
                    if (vm.hasDisplayProp) {
                        if (txt.length == 0 || (angular.isDefined(item[vm.dataSourceDisplayProperty]) && item[vm.dataSourceDisplayProperty].toString().toLowerCase().indexOf(txt) !== -1)) {
                            results.push(item[vm.dataSourceValueProperty]); //[vm.dataSourceValueProperty]);
                        }
                    }
                }
            });

            return results;
        }

        function getAutoCompleteDisplayValue(sourceItem) {
            if (!vm.hasValueProp) {
                return sourceItem;
            } else {
                if (angular.isDefined(vm.valuePropChache[sourceItem])) {
                    return vm.valuePropChache[sourceItem][vm.dataSourceDisplayProperty];
                } else {
                    return undefined;
                }
            }
        }

        function selectedItemChanged(newItem) {
            $log.info('selectedItemChanged(' + newItem + '): ' + vm.destinationField);
        }

        function getItemText(item) {
            if (angular.isDefined(item)) {
                if (!vm.hasValueProp) {
                    $log.info('getItemText(): ' + item);
                    return item;
                } else {
                    if (angular.isDefined(vm.valuePropChache[item])) {
                        return vm.valuePropChache[item][vm.dataSourceDisplayProperty];
                    } else {
                        return undefined;
                    }
                }
            }
            $log.info('getItemText('+ item + '): undefined');
            return undefined;
        }

        $scope.$on('$destroy', function() {
            if(watchUnsubscriber && angular.isFunction(watchUnsubscriber)) {
                watchUnsubscriber();
            }
        });
    }
})();
(function(){
  'use strict';

    angular
        .module('app.main')
        .directive('txAccess', txAccess);

    /**
     *@description: this directive restricted to be used as an attribute on any element.
     * element containing this directive will be validated against privilege(s) supplied as comma seperated string,
     * it will internally call isAuthorized method of SecurityFactory which is lenient authority validateor,
     * which means if user has any of the supplied priviliges the element will be accessible
     * (can pass another attribute say tx-access-strict to use strict validation which requires to implement strict validator in SecurityFactory).
     * presence of this directive without supplying any privilege will not grant access
     *
     * the string passed as value to tx-access attribute can have 2 parts seperated by colan `:` first part will be list of privileges
     * second part will indicate if action needs to be disable if active catalog does not belog to logged in user account
     * second part is optional and restriction will be applied if the value is `true` (case sensitive)
     */

    /** @ngInject */
    function txAccess(SecurityFactory, catalogFactory, $localStorage) {
        var directive = {
            restrict: 'A',
            link: linkFunc,
        };

        return directive;

        function linkFunc(scope, elem, attr) {
            var isAuthorized = false;
            var accessInfo = {
                accessPrivileges: []
            }
            var restrictCatalogDataBasedOnActions = false; // use to restrict access on action buttons if active catalog does not belong to logged in user

            var txAccessParts = attr.txAccess.split(':');
            accessInfo.accessPrivileges = txAccessParts[0].split(',');

            if(angular.isDefined(txAccessParts[1]) && txAccessParts[1].trim() == 'true' // determines if action needs to be disable/removed due to restriction of seller account on parent or descendants catalog regardless of having authority
                && ($localStorage.account.accountType != 1 && catalogFactory.getActiveCatalog().AccountId != $localStorage.account.accountId) // active catalog does not belong to loggin user account (except for admin users)
                // && (elem[0].tagName.toUpperCase() == 'BUTTON' || elem[0].tagName.toUpperCase() == 'MD-MENU-ITEM') { // not required but can be applied for safer behaviour
                ) {
                restrictCatalogDataBasedOnActions = true;
            }
            isAuthorized = SecurityFactory.isAuthorized(accessInfo);
            if(!isAuthorized || restrictCatalogDataBasedOnActions){
                elem.remove();
            }

            elem.on('$destroy', function() {
                scope.$destroy();
            });
        }
    }

})();

(function () {
  'use strict';

  angular
    .module('app.main')
    .directive('txRightClick', txRightClick);

    /**
     * @description capture right click
     */

    /** @ngInject */
    function txRightClick($parse) {
      var directive = {
        link: linkFunc,
        restrict: 'A'
      }

      return directive;

      function linkFunc(scope, element, attrs) {
        var listenerFunc = $parse(attrs.txRightClick);

        element.on('contextmenu', function (event) {
          scope.$apply(function () {
            event.preventDefault();
            listenerFunc(scope, { $event: event });
          });
        });

        element.on('$destroy', function() {
            element.off('contextmenu');
        });
      }

    }

})();
(function() {
    'use strict';

     angular
        .module('app.main')
        .directive('img', errSrc);

     /**
      * @description:
      * this directive will enhance the img element to display placeholder image when there is no image available
      */
    /** @ngInject */
    function errSrc() {
        var directive = {
            link: link,
            restrict: 'E',
            scope: { // this is specific for resources module
                txIsResourceFile: '=?txResourceFile',
            }
        };
        return directive;

        function link(scope, element, attrs) {
            element.bind('error', function() {
                if(!scope.txIsResourceFile) {
                    attrs.$set('src', "/assets/images/no-image-available.png");
                } else {
                    // when user upload files others than images like pdf, mp3 etc we will show the file icon placeholder
                    attrs.$set('src', "/assets/images/file-uploaded.png");
                }
            });
        }
    }

})();
(function() {
    'use strict';
     angular
        .module('app.main')
        .directive('txUniqueValue', txUniqueValue);

     /**
      * @description:
      * txUniqueValue is a custom form validator that validate for uniquness of value in existing records
      * this directive will take value as a string which contain list of existing records which the validation run against
      * and property-name of the record which suppose to be unique seperated by ':'
      *
      * this directive will run the validaiton in case insensitive way
      */
    /** @ngInject */
    function txUniqueValue($log, $parse) {
        var directive = {
            require: 'ngModel',
            restrict: 'A',
            link: linkFunc,
        };

        return directive;

        function linkFunc(scope, element, attrs, controller) {

            var directiveValue = attrs.txUniqueValue;
            var directiveValues = directiveValue.split(':');
            if(directiveValues.length < 3 || !directiveValues[2]) {
                $log.warn('wrong usage of tx-unique-value directive\nplease add list of existing records, unique-value property name seperated by ":" as directive value and also true (if u want to apply this filter) seperated by ":"');
                return;
            }
            var existingRecords= $parse(directiveValues[0])(scope);
            var uniquePropertyName = directiveValues[1];
            var existingValuesLowerCase = [];
            angular.forEach(existingRecords, function(existingRecord) {
                existingValuesLowerCase.push(existingRecord[uniquePropertyName].toString().toLowerCase());
            });
            controller.$validators['tx-unique-value'] = function(modelValue) {
                if(controller.$isEmpty(modelValue)) {
                    return true;
                }
                else if(existingValuesLowerCase.indexOf(modelValue.toString().toLowerCase()) >= 0) {
                    return false;
                }
                else {
                    return true;
                }
            };
        }
    }

})();

(function() {
    'use strict';
     angular
        .module('app.main')
        .directive('txMaxValues', txMaxValues);

     /**
      * @description:
      * txMaxValues is a custom form validator that validate maximum number of values allowed in control (text-area) seperated by next line
      */
    /** @ngInject */
    function txMaxValues() {
        var directive = {
            require: 'ngModel',
            restrict: 'A',
            link: linkFunc,
        };

        return directive;

        function linkFunc(scope, element, attrs, controller) {
            controller.$validators['tx-max-values'] = function(modelValue) {
                if(controller.$isEmpty(modelValue)) { // if control is empty
                    return true;
                }
                var maxValue = attrs.txMaxValues;
                var controlValues = modelValue.match(/[^\r\n]+/g);
                if(controlValues.length <= maxValue) {
                    return true;
                }
                else {
                    return false;
                }
            };
        }
    }

})();

(function() {
    'use strict';
     angular
        .module('app.main')
        .directive('txInvalidateFormForEmptySelect', txInvalidateFormForEmptySelect);

     /**
      * @description:
      * txInvalidateFormForEmptySelect is a custom form validator for md-select to mark it invalid when the field is required and user select none (ms-select value is undefined)
      */
    /** @ngInject */
    function txInvalidateFormForEmptySelect() {
        var directive = {
            require: 'ngModel',
            restrict: 'A',
            link: linkFunc,
        };

        return directive;

        function linkFunc(scope, element, attrs, controller) {
            controller.$validators['tx-invalidate-form-for-empty-select'] = function(modelValue) {
                if(controller.$isEmpty(modelValue)) { // if control is empty
                    return true;
                }
                if(attrs.txInvalidateFormForEmptySelect == 'true' && angular.isUndefined(modelValue)) {
                  return false;
                }
                else {
                    return true;
                }
            };
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('app.main')
        .directive('txIntegerValue', txIntegerValue);

    function txIntegerValue() {
        var directive = {
            require: 'ngModel',
            restrict: 'A',
            link: function(scope, element, attrs, ngModel) {
                ngModel.$validators['tx-integer-value'] = function(modelValue, viewValue) {
                    if (ngModel.$isEmpty(modelValue)) {
                        return true;
                    }
                    var value = viewValue !== undefined ? viewValue.toString() : '';
                    return /^-?(0|[1-9][0-9]*)$/.test(value);
                };
            }
        };
        return directive;
    }
})();
(function() {
    'use strict';
     angular
        .module('app.main')
        .directive('txExistValue', txExistValue);

     /**
      * @description:
      * txExistValue is a custom form validator that validate for existance of value in existing records
      * this directive will take value as a string seperated by |
      * first value will list of existing records which the validation run against
      * second value will be property-name of the record which use to validate input values agianst the property-name of record
      * third value will be optional and is promise to list of records, can be use if list of records are not available or huge and cant resolve before validation
      * fourth value will be optional and use as a predicate to filter data, the property of predicate object should be wrapped by single qoute " ' "
      * sample usage ==> tx-exist-value="vm.parentActiveArticles|ArticleNumber|vm.parentArticlesPromise|{'Status': 1}
      *
      * this directive will run the validaiton in case insensitive way
      */
    /** @ngInject */
    function txExistValue($log, $parse, $q, utility) {
        var directive = {
            require: 'ngModel',
            restrict: 'A',
            link: linkFunc,
        };

        return directive;

        function linkFunc(scope, element, attrs, controller) {

            var directiveValue = attrs.txExistValue;
            var directiveValues = directiveValue.split('|');
            if(directiveValues.length < 2) {
                $log.warn('wrong usage of tx-exist-value directive\nplease add list of existing records and exist-value property name seperated by "|" as directive value\n'
                +'you can also pass promise object for async validation as 3rd parameter seperated by |');
                return;
            }
            var existingRecords= $parse(directiveValues[0])(scope);
            var propertyName = directiveValues[1];
            var existingRecordsPromise = $parse(directiveValues[2])(scope);
            var filterPredicate = angular.isDefined(directiveValues[3]) ? angular.fromJson(directiveValues[3].split("'").join('"')) : '';

            var mapObj = {};

            controller.$asyncValidators['tx-exist-value'] = function(modelValue) {
                if(controller.$isEmpty(modelValue)) {
                    return $q.resolve();
                }
                var deferred = $q.defer();

                // if passed data contain records need to be validated against
                if(angular.isDefined(existingRecords) && existingRecords.length > 0) {
                    if(utility.isObjectEmpty(mapObj)) {
                        mapObj = createMapObj(utility.filterObject(existingRecords, filterPredicate, true), propertyName);
                    }
                   validate(modelValue, mapObj);
                }
                // if developper did not passed records or records are empty and passed promise object as third parameter to directive
                else if(angular.isDefined(existingRecordsPromise)) {

                    if(angular.isDefined(existingRecordsPromise.then())) {// if promise is valid
                        existingRecordsPromise.then(function(response) {
                            if(utility.isObjectEmpty(mapObj)) {
                                mapObj = createMapObj(utility.filterObject(response.data, filterPredicate, true), propertyName);
                            }
                            validate(modelValue, mapObj, deferred);
                        });
                    }
                    else {
                        $log.warn('invalid promise, \'tx-exist-value\' directive should contain valid promise as third parameter sperated by \':\'');
                    }
                }

                return deferred.promise;
            };
        }

        function validate(modelValue, mapObj, deferred) {
            modelValue = modelValue.match(/[^\r\n]+/g);
            if(angular.isArray(modelValue)) {
                var i, len;
                for(i=0, len=modelValue.length; i<len ;i++) {
                    if(angular.isUndefined(mapObj[modelValue[i].toLowerCase()])) {
                        return deferred.reject();
                    }
                }
                if(i === len) {
                    return deferred.resolve();
                }
            }
        }

        function createMapObj(data, propertyName) {
            var map = {};
            for(var i=0, len=data.length; i<len; i++) {
                map[data[i][propertyName].toLowerCase()] = 0;
            }
            return map;
        }
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('fuseTheming', fuseThemingProvider);

    /** @ngInject */
    function fuseThemingProvider()
    {
        // Inject Cookies Service
        var $cookies;

        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Inject $log service
        var $log = angular.injector(['ng']).get('$log');

        var registeredPalettes,
            registeredThemes;

        // Methods
        this.setRegisteredPalettes = setRegisteredPalettes;
        this.setRegisteredThemes = setRegisteredThemes;

        //////////

        /**
         * Set registered palettes
         *
         * @param _registeredPalettes
         */
        function setRegisteredPalettes(_registeredPalettes)
        {
            registeredPalettes = _registeredPalettes;
        }

        /**
         * Set registered themes
         *
         * @param _registeredThemes
         */
        function setRegisteredThemes(_registeredThemes)
        {
            registeredThemes = _registeredThemes;
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getRegisteredPalettes: getRegisteredPalettes,
                getRegisteredThemes  : getRegisteredThemes,
                setActiveTheme       : setActiveTheme,
                setThemesList        : setThemesList,
                themes               : {
                    list  : {},
                    active: {
                        'name' : '',
                        'theme': {}
                    }
                }
            };

            return service;

            //////////

            /**
             * Get registered palettes
             *
             * @returns {*}
             */
            function getRegisteredPalettes()
            {
                return registeredPalettes;
            }

            /**
             * Get registered themes
             *
             * @returns {*}
             */
            function getRegisteredThemes()
            {
                return registeredThemes;
            }

            /**
             * Set active theme
             *
             * @param themeName
             */
            function setActiveTheme(themeName)
            {
                // If theme does not exist, fallback to the default theme
                if ( angular.isUndefined(service.themes.list[themeName]) )
                {
                    // If there is no theme called "default"...
                    if ( angular.isUndefined(service.themes.list.default) )
                    {
                        $log.error('You must have at least one theme named "default"');
                        return;
                    }

                    $log.warn('The theme "' + themeName + '" does not exist! Falling back to the "default" theme.');

                    // Otherwise set theme to default theme
                    service.themes.active.name = 'default';
                    service.themes.active.theme = service.themes.list.default;
                    $cookies.put('selectedTheme', service.themes.active.name);

                    return;
                }

                service.themes.active.name = themeName;
                service.themes.active.theme = service.themes.list[themeName];
                $cookies.put('selectedTheme', themeName);
            }

            /**
             * Set available themes list
             *
             * @param themeList
             */
            function setThemesList(themeList)
            {
                service.themes.list = themeList;
            }
        };
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($mdThemingProvider, fusePalettes, fuseThemes, fuseThemingProvider)
    {
        // Inject Cookies Service
        var $cookies;
        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Check if custom theme exist in cookies
        var customTheme = $cookies.getObject('customTheme');
        if ( customTheme )
        {
            fuseThemes['custom'] = customTheme;
        }

        $mdThemingProvider.alwaysWatchTheme(true);

        // Define custom palettes
        angular.forEach(fusePalettes, function (palette)
        {
            $mdThemingProvider.definePalette(palette.name, palette.options);
        });

        // Register custom themes
        angular.forEach(fuseThemes, function (theme, themeName)
        {
            $mdThemingProvider.theme(themeName)
                .primaryPalette(theme.primary.name, theme.primary.hues)
                .accentPalette(theme.accent.name, theme.accent.hues)
                .warnPalette(theme.warn.name, theme.warn.hues)
                .backgroundPalette(theme.background.name, theme.background.hues);
        });

        // Store generated PALETTES and THEMES objects from $mdThemingProvider
        // in our custom provider, so we can inject them into other areas
        fuseThemingProvider.setRegisteredPalettes($mdThemingProvider._PALETTES);
        fuseThemingProvider.setRegisteredThemes($mdThemingProvider._THEMES);
    }

})();
(function ()
{
    'use strict';

    var fuseThemes = {
        default: {
            primary   : {
                name: 'fuse-pale-blue',
                hues: {
                    'default': '700',
                    'hue-1'  : '500',
                    'hue-2'  : '600',
                    'hue-3'  : '400'
                }
            },
            accent    : {
                name: 'light-blue',
                hues: {
                    'default': '600',
                    'hue-1'  : '400',
                    'hue-2'  : '700',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'red'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },
        pink   : {
            primary   : {
                name: 'blue-grey',
                hues: {
                    'default': '800',
                    'hue-1'  : '600',
                    'hue-2'  : '400',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'pink',
                hues: {
                    'default': '400',
                    'hue-1'  : '300',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'blue'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },
        teal   : {
            primary   : {
                name: 'fuse-blue',
                hues: {
                    'default': '900',
                    'hue-1'  : '600',
                    'hue-2'  : '500',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'teal',
                hues: {
                    'default': '500',
                    'hue-1'  : '400',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'deep-orange'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        }
    };

    angular
        .module('app.core')
        .constant('fuseThemes', fuseThemes);
})();
(function () {
    'use strict';

    var fusePalettes = [
        {
            name: 'fuse-blue',
            options: {
                '50': '#ebf1fa',
                '100': '#c2d4ef',
                '200': '#9ab8e5',
                '300': '#78a0dc',
                '400': '#5688d3',
                '500': '#3470ca',
                '600': '#2e62b1',
                '700': '#275498',
                '800': '#21467e',
                '900': '#1a3865',
                'A100': '#c2d4ef',
                'A200': '#9ab8e5',
                'A400': '#5688d3',
                'A700': '#275498',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
        {
            name: 'fuse-pale-blue',
            options: {
                '50': '#ececee',
                '100': '#c5c6cb',
                '200': '#9ea1a9',
                '300': '#7d818c',
                '400': '#5c616f',
                '500': '#3c4252',
                '600': '#353a48',
                '700': '#2d323e',
                '800': '#262933',
                '900': '#1e2129',
                'A100': '#c5c6cb',
                'A200': '#9ea1a9',
                'A400': '#5c616f',
                'A700': '#2d323e',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        }
    ];

    angular
        .module('app.core')
        .constant('fusePalettes', fusePalettes);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('fuseGenerator', fuseGeneratorService);

    /** @ngInject */
    function fuseGeneratorService($cookies, $log, fuseTheming)
    {
        // Storage for simplified themes object
        var themes = {};

        var service = {
            generate: generate,
            rgba    : rgba
        };

        return service;

        //////////

        /**
         * Generate less variables for each theme from theme's
         * palette by using material color naming conventions
         */
        function generate()
        {
            var registeredThemes = fuseTheming.getRegisteredThemes();
            var registeredPalettes = fuseTheming.getRegisteredPalettes();

            // First, create a simplified object that stores
            // all registered themes and their colors

            // Iterate through registered themes
            angular.forEach(registeredThemes, function (registeredTheme)
            {
                themes[registeredTheme.name] = {};

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(registeredTheme.colors, function (colorType, colorTypeName)
                {
                    themes[registeredTheme.name][colorTypeName] = {
                        'name'  : colorType.name,
                        'levels': {
                            'default': {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues.default].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 4)
                            },
                            'hue1'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 4)
                            },
                            'hue2'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 4)
                            },
                            'hue3'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 4)
                            }
                        }
                    };
                });
            });

            // Process themes one more time and then store them in the service for external use
            processAndStoreThemes(themes);

            // Iterate through simplified themes
            // object and create style variables
            var styleVars = {};

            // Iterate through registered themes
            angular.forEach(themes, function (theme, themeName)
            {
                styleVars = {};
                styleVars['@themeName'] = themeName;

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorTypes, colorTypeName)
                {
                    // Iterate through color levels (default, hue1, hue2 & hue3)
                    angular.forEach(colorTypes.levels, function (colors, colorLevelName)
                    {
                        // Iterate through color name (color, contrast1, contrast2, contrast3 & contrast4)
                        angular.forEach(colors, function (color, colorName)
                        {
                            styleVars['@' + colorTypeName + ucfirst(colorLevelName) + ucfirst(colorName)] = color;
                        });
                    });
                });

                // Render styles
                render(styleVars);
            });
        }

        // ---------------------------
        //  INTERNAL HELPER FUNCTIONS
        // ---------------------------

        /**
         * Process and store themes for global use
         *
         * @param _themes
         */
        function processAndStoreThemes(_themes)
        {
            // Here we will go through every registered theme one more time
            // and try to simplify their objects as much as possible for
            // easier access to their properties.
            var themes = angular.copy(_themes);

            // Iterate through themes
            angular.forEach(themes, function (theme)
            {
                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorType, colorTypeName)
                {
                    theme[colorTypeName] = colorType.levels;
                    theme[colorTypeName].color = colorType.levels.default.color;
                    theme[colorTypeName].contrast1 = colorType.levels.default.contrast1;
                    theme[colorTypeName].contrast2 = colorType.levels.default.contrast2;
                    theme[colorTypeName].contrast3 = colorType.levels.default.contrast3;
                    theme[colorTypeName].contrast4 = colorType.levels.default.contrast4;
                    delete theme[colorTypeName].default;
                });
            });

            // Store themes and set selected theme for the first time
            fuseTheming.setThemesList(themes);

            // Remember selected theme.
            var selectedTheme = $cookies.get('selectedTheme');

            if ( selectedTheme )
            {
                fuseTheming.setActiveTheme(selectedTheme);
            }
            else
            {
                fuseTheming.setActiveTheme('default');
            }
        }


        /**
         * Render css files
         *
         * @param styleVars
         */
        function render(styleVars)
        {
            var cssTemplate = '/* Content hack because they wont fix */\n/* https://github.com/angular/material/pull/8067 */\n[md-theme="@themeName"] md-content.md-hue-1,\nmd-content.md-@themeName-theme.md-hue-1 {\n    color: @backgroundHue1Contrast1;\n    background-color: @backgroundHue1Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-2,\nmd-content.md-@themeName-theme.md-hue-2 {\n    color: @backgroundHue2Contrast1;\n    background-color: @backgroundHue2Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-3,\n md-content.md-@themeName-theme.md-hue-3 {\n    color: @backgroundHue3Contrast1;\n    background-color: @backgroundHue3Color;\n}\n\n/* Text Colors */\n[md-theme="@themeName"] a {\n    color: @accentDefaultColor;\n}\n\n[md-theme="@themeName"] .secondary-text,\n[md-theme="@themeName"] .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .hint-text,\n[md-theme="@themeName"] .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .fade-text,\n[md-theme="@themeName"] .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Primary */\n[md-theme="@themeName"] .md-primary-bg {\n    background-color: @primaryDefaultColor;\n    color: @primaryDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg .secondary-text,\n[md-theme="@themeName"] .md-primary-bg .icon {\n    color: @primaryDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg .hint-text,\n[md-theme="@themeName"] .md-primary-bg .disabled-text {\n    color: @primaryDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg .fade-text,\n[md-theme="@themeName"] .md-primary-bg .divider {\n    color: @primaryDefaultContrast4;\n}\n\n/* Primary, Hue-1 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 {\n    background-color: @primaryHue1Color;\n    color: @primaryHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .icon {\n    color: @primaryHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .disabled-text {\n    color: @primaryHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .divider {\n    color: @primaryHue1Contrast4;\n}\n\n/* Primary, Hue-2 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 {\n    background-color: @primaryHue2Color;\n    color: @primaryHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .icon {\n    color: @primaryHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .disabled-text {\n    color: @primaryHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .divider {\n    color: @primaryHue2Contrast4;\n}\n\n/* Primary, Hue-3 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 {\n    background-color: @primaryHue3Color;\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .icon {\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .disabled-text {\n    color: @primaryHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .divider {\n    color: @primaryHue3Contrast4;\n}\n\n/* Primary foreground */\n[md-theme="@themeName"] .md-primary-fg {\n    color: @primaryDefaultColor !important;\n}\n\n/* Primary foreground, Hue-1 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-1 {\n    color: @primaryHue1Color !important;\n}\n\n/* Primary foreground, Hue-2 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-2 {\n    color: @primaryHue2Color !important;\n}\n\n/* Primary foreground, Hue-3 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-3 {\n    color: @primaryHue3Color !important;\n}\n\n/* Accent */\n[md-theme="@themeName"] .md-accent-bg {\n    background-color: @accentDefaultColor;\n    color: @accentDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg .secondary-text,\n[md-theme="@themeName"] .md-accent-bg .icon {\n    color: @accentDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg .hint-text,\n[md-theme="@themeName"] .md-accent-bg .disabled-text {\n    color: @accentDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg .fade-text,\n[md-theme="@themeName"] .md-accent-bg .divider {\n    color: @accentDefaultContrast4;\n}\n\n/* Accent, Hue-1 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 {\n    background-color: @accentHue1Color;\n    color: @accentHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .icon {\n    color: @accentHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .disabled-text {\n    color: @accentHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .divider {\n    color: @accentHue1Contrast4;\n}\n\n/* Accent, Hue-2 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 {\n    background-color: @accentHue2Color;\n    color: @accentHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .icon {\n    color: @accentHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .disabled-text {\n    color: @accentHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .divider {\n    color: @accentHue2Contrast4;\n}\n\n/* Accent, Hue-3 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 {\n    background-color: @accentHue3Color;\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .icon {\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .disabled-text {\n    color: @accentHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .divider {\n    color: @accentHue3Contrast4;\n}\n\n/* Accent foreground */\n[md-theme="@themeName"] .md-accent-fg {\n    color: @accentDefaultColor !important;\n}\n\n/* Accent foreground, Hue-1 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-1 {\n    color: @accentHue1Color !important;\n}\n\n/* Accent foreground, Hue-2 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-2 {\n    color: @accentHue2Color !important;\n}\n\n/* Accent foreground, Hue-3 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-3 {\n    color: @accentHue3Color !important;\n}\n\n/* Warn */\n[md-theme="@themeName"] .md-warn-bg {\n    background-color: @warnDefaultColor;\n    color: @warnDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg .secondary-text,\n[md-theme="@themeName"] .md-warn-bg .icon {\n    color: @warnDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg .hint-text,\n[md-theme="@themeName"] .md-warn-bg .disabled-text {\n    color: @warnDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg .fade-text,\n[md-theme="@themeName"] .md-warn-bg .divider {\n    color: @warnDefaultContrast4;\n}\n\n/* Warn, Hue-1 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 {\n    background-color: @warnHue1Color;\n    color: @warnHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .icon {\n    color: @warnHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .disabled-text {\n    color: @warnHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .divider {\n    color: @warnHue1Contrast4;\n}\n\n/* Warn, Hue-2 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 {\n    background-color: @warnHue2Color;\n    color: @warnHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .icon {\n    color: @warnHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .disabled-text {\n    color: @warnHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .divider {\n    color: @warnHue2Contrast4;\n}\n\n/* Warn, Hue-3 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 {\n    background-color: @warnHue3Color;\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .icon {\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .disabled-text {\n    color: @warnHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .divider {\n    color: @warnHue3Contrast4;\n}\n\n/* Warn foreground */\n[md-theme="@themeName"] .md-warn-fg {\n    color: @warnDefaultColor !important;\n}\n\n/* Warn foreground, Hue-1 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-1 {\n    color: @warnHue1Color !important;\n}\n\n/* Warn foreground, Hue-2 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-2 {\n    color: @warnHue2Color !important;\n}\n\n/* Warn foreground, Hue-3 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-3 {\n    color: @warnHue3Color !important;\n}\n\n/* Background */\n[md-theme="@themeName"] .md-background-bg {\n    background-color: @backgroundDefaultColor;\n    color: @backgroundDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg .secondary-text,\n[md-theme="@themeName"] .md-background-bg .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg .hint-text,\n[md-theme="@themeName"] .md-background-bg .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg .fade-text,\n[md-theme="@themeName"] .md-background-bg .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Background, Hue-1 */\n[md-theme="@themeName"] .md-background-bg.md-hue-1 {\n    background-color: @backgroundHue1Color;\n    color: @backgroundHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .icon {\n    color: @backgroundHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .disabled-text {\n    color: @backgroundHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .divider {\n    color: @backgroundHue1Contrast4;\n}\n\n/* Background, Hue-2 */\n[md-theme="@themeName"] .md-background-bg.md-hue-2 {\n    background-color: @backgroundHue2Color;\n    color: @backgroundHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .icon {\n    color: @backgroundHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .disabled-text {\n    color: @backgroundHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .divider {\n    color: @backgroundHue2Contrast4;\n}\n\n/* Background, Hue-3 */\n[md-theme="@themeName"] .md-background-bg.md-hue-3 {\n    background-color: @backgroundHue3Color;\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .icon {\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .disabled-text {\n    color: @backgroundHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .divider {\n    color: @backgroundHue3Contrast4;\n}\n\n/* Background foreground */\n[md-theme="@themeName"] .md-background-fg {\n    color: @backgroundDefaultColor !important;\n}\n\n/* Background foreground, Hue-1 */\n[md-theme="@themeName"] .md-background-fg.md-hue-1 {\n    color: @backgroundHue1Color !important;\n}\n\n/* Background foreground, Hue-2 */\n[md-theme="@themeName"] .md-background-fg.md-hue-2 {\n    color: @backgroundHue2Color !important;\n}\n\n/* Background foreground, Hue-3 */\n[md-theme="@themeName"] .md-background-fg.md-hue-3 {\n    color: @backgroundHue3Color !important;\n}'

            var regex = new RegExp(Object.keys(styleVars).join('|'), 'gi');
            var css = cssTemplate.replace(regex, function (matched)
            {
                return styleVars[matched];
            });

            var headEl = angular.element('head');
            var styleEl = angular.element('<style type="text/css"></style>');
            styleEl.html(css);
            headEl.append(styleEl);
        }

        /**
         * Convert color array to rgb/rgba
         * Also apply contrasts if needed
         *
         * @param color
         * @param _contrastLevel
         * @returns {string}
         */
        function rgba(color, _contrastLevel)
        {
            var contrastLevel = _contrastLevel || false;

            // Convert 255,255,255,0.XX to 255,255,255
            // According to Google's Material design specs, white primary
            // text must have opacity of 1 and we will fix that here
            // because Angular Material doesn't care about that spec
            if ( color.length === 4 && color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color.splice(3, 4);
            }

            // If contrast level provided, apply it to the current color
            if ( contrastLevel )
            {
                color = applyContrast(color, contrastLevel);
            }

            // Convert color array to color string (rgb/rgba)
            if ( color.length === 3 )
            {
                return 'rgb(' + color.join(',') + ')';
            }
            else if ( color.length === 4 )
            {
                return 'rgba(' + color.join(',') + ')';
            }
            else
            {
                $log.error('Invalid number of arguments supplied in the color array: ' + color.length + '\n' + 'The array must have 3 or 4 colors.');
            }
        }

        /**
         * Apply given contrast level to the given color
         *
         * @param color
         * @param contrastLevel
         */
        function applyContrast(color, contrastLevel)
        {
            var contrastLevels = {
                'white': {
                    '1': '1',
                    '2': '0.7',
                    '3': '0.3',
                    '4': '0.12'
                },
                'black': {
                    '1': '0.87',
                    '2': '0.54',
                    '3': '0.26',
                    '4': '0.12'
                }
            };

            // If white
            if ( color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color[3] = contrastLevels.white[contrastLevel];
            }
            // If black
            else if ( color[0] === 0 && color[1] === 0 && color[2] === 0 )
            {
                color[3] = contrastLevels.black[contrastLevel];
            }

            return color;
        }

        /**
         * Uppercase first
         */
        function ucfirst(string)
        {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsThemeOptionsController', MsThemeOptionsController)
        .directive('msThemeOptions', msThemeOptions);

    /** @ngInject */
    function MsThemeOptionsController($cookies, fuseTheming)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;
        vm.layoutMode = 'wide';
        vm.layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        // Methods
        vm.setActiveTheme = setActiveTheme;
        vm.updateLayoutMode = updateLayoutMode;
        vm.updateLayoutStyle = updateLayoutStyle;

        //////////

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            // Set active theme
            fuseTheming.setActiveTheme(themeName);
        }

        /**
         * Update layout mode
         */
        function updateLayoutMode()
        {
            var bodyEl = angular.element('body');

            // Update class on body element
            bodyEl.toggleClass('boxed', (vm.layoutMode === 'boxed'));
        }

        /**
         * Update layout style
         */
        function updateLayoutStyle()
        {
            // Update the cookie
            $cookies.put('layoutStyle', vm.layoutStyle);

            // Reload the page to apply the changes
            location.reload();
        }
    }

    /** @ngInject */
    function msThemeOptions()
    {
        return {
            restrict   : 'E',
            scope      : {
                panelOpen: '='
            },
            controller : 'MsThemeOptionsController as vm',
            templateUrl: 'app/core/theme-options/theme-options.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-theme-options');

                return function postLink(scope, iElement)
                {
                    var bodyEl = angular.element('body'),
                        backdropEl = angular.element('<div class="ms-theme-options-backdrop"></div>');

                    // Panel open status
                    scope.panelOpen = scope.panelOpen || false;

                    /**
                     * Toggle options panel
                     */
                    function toggleOptionsPanel()
                    {
                        if ( scope.panelOpen )
                        {
                            closeOptionsPanel();
                        }
                        else
                        {
                            openOptionsPanel();
                        }
                    }

                    function openOptionsPanel()
                    {
                        // Set panelOpen status
                        scope.panelOpen = true;

                        // Add open class
                        iElement.addClass('open');

                        // Append the backdrop
                        bodyEl.append(backdropEl);

                        // Register the event
                        backdropEl.on('click touch', closeOptionsPanel);
                    }

                    /**
                     * Close options panel
                     */
                    function closeOptionsPanel()
                    {
                        // Set panelOpen status
                        scope.panelOpen = false;

                        // Remove open class
                        iElement.removeClass('open');

                        // De-register the event
                        backdropEl.off('click touch', closeOptionsPanel);

                        // Remove the backdrop
                        backdropEl.remove();
                    }

                    // Expose the toggle function
                    scope.toggleOptionsPanel = toggleOptionsPanel;
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msUtils', msUtils);

    /** @ngInject */
    function msUtils($window)
    {
        // Private variables
        var mobileDetect = new MobileDetect($window.navigator.userAgent),
            browserInfo = null;

        var service = {
            exists       : exists,
            detectBrowser: detectBrowser,
            guidGenerator: guidGenerator,
            isMobile     : isMobile,
            toggleInArray: toggleInArray
        };

        return service;

        //////////

        /**
         * Check if item exists in a list
         *
         * @param item
         * @param list
         * @returns {boolean}
         */
        function exists(item, list)
        {
            return list.indexOf(item) > -1;
        }

        /**
         * Returns browser information
         * from user agent data
         *
         * Found at http://www.quirksmode.org/js/detect.html
         * but modified and updated to fit for our needs
         */
        function detectBrowser()
        {
            // If we already tested, do not test again
            if ( browserInfo )
            {
                return browserInfo;
            }

            var browserData = [
                {
                    string       : $window.navigator.userAgent,
                    subString    : "Edge",
                    versionSearch: "Edge",
                    identity     : "Edge"
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: "Chrome",
                    identity : "Chrome"
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : "OmniWeb",
                    versionSearch: "OmniWeb/",
                    identity     : "OmniWeb"
                },
                {
                    string       : $window.navigator.vendor,
                    subString    : "Apple",
                    versionSearch: "Version",
                    identity     : "Safari"
                },
                {
                    prop    : $window.opera,
                    identity: "Opera"
                },
                {
                    string   : $window.navigator.vendor,
                    subString: "iCab",
                    identity : "iCab"
                },
                {
                    string   : $window.navigator.vendor,
                    subString: "KDE",
                    identity : "Konqueror"
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: "Firefox",
                    identity : "Firefox"
                },
                {
                    string   : $window.navigator.vendor,
                    subString: "Camino",
                    identity : "Camino"
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: "Netscape",
                    identity : "Netscape"
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : "MSIE",
                    identity     : "Explorer",
                    versionSearch: "MSIE"
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : "Trident/7",
                    identity     : "Explorer",
                    versionSearch: "rv"
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : "Gecko",
                    identity     : "Mozilla",
                    versionSearch: "rv"
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : "Mozilla",
                    identity     : "Netscape",
                    versionSearch: "Mozilla"
                }
            ];

            var osData = [
                {
                    string   : $window.navigator.platform,
                    subString: "Win",
                    identity : "Windows"
                },
                {
                    string   : $window.navigator.platform,
                    subString: "Mac",
                    identity : "Mac"
                },
                {
                    string   : $window.navigator.platform,
                    subString: "Linux",
                    identity : "Linux"
                },
                {
                    string   : $window.navigator.platform,
                    subString: "iPhone",
                    identity : "iPhone"
                },
                {
                    string   : $window.navigator.platform,
                    subString: "iPod",
                    identity : "iPod"
                },
                {
                    string   : $window.navigator.platform,
                    subString: "iPad",
                    identity : "iPad"
                },
                {
                    string   : $window.navigator.platform,
                    subString: "Android",
                    identity : "Android"
                }
            ];

            var versionSearchString = '';

            function searchString(data)
            {
                for ( var i = 0; i < data.length; i++ )
                {
                    var dataString = data[i].string;
                    var dataProp = data[i].prop;

                    versionSearchString = data[i].versionSearch || data[i].identity;

                    if ( dataString )
                    {
                        if ( dataString.indexOf(data[i].subString) != -1 )
                        {
                            return data[i].identity;

                        }
                    }
                    else if ( dataProp )
                    {
                        return data[i].identity;
                    }
                }
            }

            function searchVersion(dataString)
            {
                var index = dataString.indexOf(versionSearchString);

                if ( index == -1 )
                {
                    return;
                }

                return parseInt(dataString.substring(index + versionSearchString.length + 1));
            }

            var browser = searchString(browserData) || "unknown-browser";
            var version = searchVersion($window.navigator.userAgent) || searchVersion($window.navigator.appVersion) || "unknown-version";
            var os = searchString(osData) || "unknown-os";

            // Prepare and store the object
            browser = browser.toLowerCase();
            version = browser + '-' + version;
            os = os.toLowerCase();

            browserInfo = {
                browser: browser,
                version: version,
                os     : os
            };

            return browserInfo;
        }

        /**
         * Generates a globally unique id
         *
         * @returns {*}
         */
        function guidGenerator()
        {
            var S4 = function ()
            {
                return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
            };
            return (S4() + S4() + S4() + S4() + S4() + S4());
        }

        /**
         * Return if current device is a
         * mobile device or not
         */
        function isMobile()
        {
            return mobileDetect.mobile();
        }

        /**
         * Toggle in array (push or splice)
         *
         * @param item
         * @param array
         */
        function toggleInArray(item, array)
        {
            if ( array.indexOf(item) == -1 )
            {
                array.push(item);
            }
            else
            {
                array.splice(array.indexOf(item), 1);
            }
        }
    }
}());
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('apiResolver', apiResolverService);

    /** @ngInject */
    function apiResolverService($q, $log, api)
    {
        var service = {
            resolve: resolve
        };

        return service;

        //////////
        /**
         * Resolve api
         * @param action
         * @param parameters
         */
        function resolve(action, parameters)
        {
            var actionParts = action.split('@'),
                resource = actionParts[0],
                method = actionParts[1],
                params = parameters || {};

            if ( !resource || !method )
            {
                $log.error('apiResolver.resolve requires correct action parameter (ResourceName@methodName)');
                return false;
            }

            // Create a new deferred object
            var deferred = $q.defer();

            // Get the correct api object from api service
            var apiObject = getApiObject(resource);

            if ( !apiObject )
            {
                $log.error('Resource "' + resource + '" is not defined in the api service!');
                deferred.reject('Resource "' + resource + '" is not defined in the api service!');
            }
            else
            {
                apiObject[method](params,

                    // Success
                    function (response)
                    {
                        deferred.resolve(response);
                    },

                    // Error
                    function (response)
                    {
                        deferred.reject(response);
                    }
                );
            }

            // Return the promise
            return deferred.promise;
        }

        /**
         * Get correct api object
         *
         * @param resource
         * @returns {*}
         */
        function getApiObject(resource)
        {
            // Split the resource in case if we have a dot notated object
            var resourceParts = resource.split('.'),
                apiObject = api;

            // Loop through the resource parts and go all the way through
            // the api object and return the correct one
            for ( var l = 0; l < resourceParts.length; l++ )
            {
                if ( angular.isUndefined(apiObject[resourceParts[l]]) )
                {
                    $log.error('Resource part "' + resourceParts[l] + '" is not defined!');
                    apiObject = false;
                    break;
                }

                apiObject = apiObject[resourceParts[l]];
            }

            if ( !apiObject )
            {
                return false;
            }

            return apiObject;
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByTags', filterByTags)
        .filter('filterSingleByTags', filterSingleByTags);

    /** @ngInject */
    function filterByTags()
    {
        return function (items, tags)
        {
            if ( items.length === 0 || tags.length === 0 )
            {
                return items;
            }

            var filtered = [];

            items.forEach(function (item)
            {
                var match = tags.every(function (tag)
                {
                    var tagExists = false;

                    item.tags.forEach(function (itemTag)
                    {
                        if ( itemTag.name === tag.name )
                        {
                            tagExists = true;
                            return;
                        }
                    });

                    return tagExists;
                });

                if ( match )
                {
                    filtered.push(item);
                }
            });

            return filtered;
        };
    }

    /** @ngInject */
    function filterSingleByTags()
    {
        return function (itemTags, tags)
        {
            if ( itemTags.length === 0 || tags.length === 0 )
            {
                return;
            }

            if ( itemTags.length < tags.length )
            {
                return [];
            }

            var filtered = [];

            var match = tags.every(function (tag)
            {
                var tagExists = false;

                itemTags.forEach(function (itemTag)
                {
                    if ( itemTag.name === tag.name )
                    {
                        tagExists = true;
                        return;
                    }
                });

                return tagExists;
            });

            if ( match )
            {
                filtered.push(itemTags);
            }

            return filtered;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('toTrusted', toTrustedFilter)
        .filter('htmlToPlaintext', htmlToPlainTextFilter)
        .filter('nospace', nospaceFilter)
        .filter('humanizeDoc', humanizeDocFilter);

    /** @ngInject */
    function toTrustedFilter($sce)
    {
        return function (value)
        {
            return $sce.trustAsHtml(value);
        };
    }

    /** @ngInject */
    function htmlToPlainTextFilter()
    {
        return function (text)
        {
            return String(text).replace(/<[^>]+>/gm, '');
        };
    }

    /** @ngInject */
    function nospaceFilter()
    {
        return function (value)
        {
            return (!value) ? '' : value.replace(/ /g, '');
        };
    }

    /** @ngInject */
    function humanizeDocFilter()
    {
        return function (doc)
        {
            if ( !doc )
            {
                return;
            }
            if ( doc.type === 'directive' )
            {
                return doc.name.replace(/([A-Z])/g, function ($1)
                {
                    return '-' + $1.toLowerCase();
                });
            }
            return doc.label || doc.name;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('hljs', hljsDirective);

    /** @ngInject */
    function hljsDirective($timeout, $q, $interpolate)
    {
        return {
            restrict: 'EA',
            compile : function (tElement, tAttrs)
            {
                var code;
                //No attribute? code is the content
                if ( !tAttrs.code )
                {
                    code = tElement.html();
                    tElement.empty();
                }

                return function (scope, iElement, iAttrs)
                {
                    if ( iAttrs.code )
                    {
                        // Attribute? code is the evaluation
                        code = scope.$eval(iAttrs.code);
                    }
                    var shouldInterpolate = scope.$eval(iAttrs.shouldInterpolate);

                    $q.when(code).then(function (code)
                    {
                        if ( code )
                        {
                            if ( shouldInterpolate )
                            {
                                code = $interpolate(code)(scope);
                            }

                            var contentParent = angular.element(
                                '<pre><code class="highlight" ng-non-bindable></code></pre>'
                            );

                            iElement.append(contentParent);

                            // Defer highlighting 1-frame to prevent GA interference...
                            $timeout(function ()
                            {
                                render(code, contentParent);
                            }, 34, false);
                        }
                    });

                    function render(contents, parent)
                    {
                        var codeElement = parent.find('code');
                        var lines = contents.split('\n');

                        // Remove empty lines
                        lines = lines.filter(function (line)
                        {
                            return line.trim().length;
                        });

                        // Make it so each line starts at 0 whitespace
                        var firstLineWhitespace = lines[0].match(/^\s*/)[0];
                        var startingWhitespaceRegex = new RegExp('^' + firstLineWhitespace);

                        lines = lines.map(function (line)
                        {
                            return line
                                .replace(startingWhitespaceRegex, '')
                                .replace(/\s+$/, '');
                        });

                        var highlightedCode = hljs.highlight(iAttrs.language || iAttrs.lang, lines.join('\n'), true);
                        highlightedCode.value = highlightedCode.value
                            .replace(/=<span class="hljs-value">""<\/span>/gi, '')
                            .replace('<head>', '')
                            .replace('<head/>', '');
                        codeElement.append(highlightedCode.value).addClass('highlight');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('fuseConfig', fuseConfigProvider);

    /** @ngInject */
    function fuseConfigProvider()
    {
        // Default configuration
        var fuseConfiguration = {
            'disableCustomScrollbars'        : false,
            'disableMdInkRippleOnMobile'     : true,
            'disableCustomScrollbarsOnMobile': true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            fuseConfiguration = angular.extend({}, fuseConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig,
                setConfig: setConfig
            };

            return service;

            //////////

            /**
             * Returns a config value
             */
            function getConfig(configName)
            {
                if ( angular.isUndefined(fuseConfiguration[configName]) )
                {
                    return false;
                }

                return fuseConfiguration[configName];
            }

            /**
             * Creates or updates config object
             *
             * @param configName
             * @param configValue
             */
            function setConfig(configName, configValue)
            {
                fuseConfiguration[configName] = configValue;
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.toolbar', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider)
    {
        $translatePartialLoaderProvider.addPart('app/toolbar');
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.toolbar')
        .controller('ToolbarController', ToolbarController);

    /** @ngInject */
    function ToolbarController(api, $rootScope, $scope, $mdSidenav, $translate, $mdToast, $localStorage, $filter, hotkeys, utility, mockFactory, settingsFactory,
        stateHistoryTracker, catalogFactory, $state, $mdDialog, $document, $window, $sessionStorage) {

        /* jshint validthis: true */
        var vm = this;

        // Data
        vm.catalogModel = api.catalogs.catalogs;
        vm.catalogs = [];
        vm.profile = $localStorage.profileInformation;
        vm.profileName = vm.profile.FirstName + ' ' + vm.profile.LastName;
        // when user hard refresh allowedChildUsersCount will be available in session storage. when user close the application and open it again without login count is available in local storage
        vm.allowedChildUsersCount = angular.isDefined($localStorage.allowedChildUsersCount) ? $localStorage.allowedChildUsersCount : angular.isDefined($sessionStorage.allowedChildUsersCount) ? $sessionStorage.allowedChildUsersCount : 0;

        vm.bodyEl = angular.element('body');
        $rootScope.global = {
            search: ''
        };
        vm.userStatusOptions = mockFactory.getUserStatusOptions();
        vm.languages = mockFactory.getSupportedLanguages();
        vm.isLinePlan = false;
        vm.titleBarBackgroundColor = '';

        // Methods
        vm.toggleSidenav = toggleSidenav;
        vm.logout = logout;
        vm.changeLanguage = changeLanguage;
        vm.setUserStatus = setUserStatus;
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;
        vm.goBack = goBack;
        vm.getGroups = getGroups;
        vm.historyExists = stateHistoryTracker.historyExists;
        vm.selectCatalog = selectCatalog;
        vm.showCurrentEnv = showCurrentEnv;
        vm.toggleFullScreen = toggleFullScreen;
        vm.switchUser = switchUser;

        activate();

        //Hotkeys
        hotkeys.bindTo($scope)
            .add({
                combo: 'ctrl+]',
                description: $filter('translate')('TOOLBAR.TOGGLE_QUICK_PANEL'),
                callback: function() {
                    vm.toggleSidenav('quick-panel');
                }
            })
            .add({
                combo: 'ctrl+`',
                description: $filter('translate')('TOOLBAR.SET_ACTIVE_CATALOG'),
                callback: function() {
                    if (!$rootScope.isCatalogDropdownDisabled) {
                        vm.selectCatalog();
                    }
                }
            });

        //////////

        function activate() {
            vm.activeCatalog = catalogFactory.getActiveCatalogPersisted();

            //Need to load lookup before iterating on catalogs list to create catalogs dropdown, since grouping catalogs based on accountId
            loadLookupData('accounts.sellers').then(function() {
                vm.catalogs = catalogFactory.getListOfCatalogs();
            });

            vm.userStatus = vm.userStatusOptions[0];
            vm.selectedLanguage = vm.languages[$translate.preferredLanguage(vm.profile.Settings.preferredLanguage)];

            vm.isMultiEnv = $localStorage.isMultiEnv;
            vm.env = $localStorage.env;
            if(angular.isDefined(vm.activeCatalog) && angular.isDefined(vm.activeCatalog.IsLinePlan)) {
                vm.isLinePlan = vm.activeCatalog.IsLinePlan === 1 ? true : false;
            }

            api.webGet('/app/app.config.json').then(function (response) {
                if (angular.isDefined(response) && angular.isDefined(response.data) && angular.isDefined(response.data.titleBarBackgroundColor) && response.data.titleBarBackgroundColor.toString().trim() !== '') {
                    vm.titleBarBackgroundColor = response.data.titleBarBackgroundColor;
                }
            });
        }

        function loadLookupData(lookupSource) {
            var lookupModel = api.getModel(lookupSource);
            return api.getLookupData(lookupModel)
                .then(function(data) {
                    vm.lookupData = data;
                });
        }

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            if(sidenavId.indexOf('quick-panel') === 0 && !$mdSidenav(sidenavId).isOpen()) {
                vm.showNotificationIcon = false;
            }
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Logout Function
         */
        function logout() {
            // $state.go('app.auth_login');
            $window.location.href = '/auth/login';
        }

        /**
         * Change Language
         */
        function changeLanguage(lang) {
            $rootScope.$emit('preferredLangaugeChangedEvent', lang.code);
            // Show temporary message if user selects a language other than English
            if ( lang.code !== 'en' )
            {
                var message = 'Fuse supports translations through angular-translate module, but currently we do not have any translations other than English language. If you want to help us, send us a message through ThemeForest profile page.';

                $mdToast.show({
                    template : '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content">' + message + '</div></md-toast>',
                    hideDelay: 7000,
                    position : 'top right',
                    parent   : '#content'
                });

                return;
            }
            settingsFactory.updatePreferredLanguage(lang.code);
            //Change the language
            $translate.use(lang.code);
        }

        /**
         * Sets User Status
         * @param status
         */
        function setUserStatus(status)
        {
            vm.userStatus = status;
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            vm.bodyEl.toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }

        /**
         * Go to the previous state
         */
        function goBack()
        {
            stateHistoryTracker.goBack();
        }

        function onActiveCatalogChange(catalog) {
            catalogFactory.setActiveCatalog(catalog).then(function() {
                vm.activeCatalog = catalogFactory.getActiveCatalog();
                for(var path in api.catalogs) { // invalidate catalog's sub-entities lookup data on active catalog change
                    if(path.indexOf('catalogs') !== 0 && api.catalogs[path].lookupData) {
                        api.catalogs[path].lookupData = undefined;
                    }
                }
                //Following are the modules which refer to active catalog for load lookup if any
                if(api.customers.customers.lookupData) {
                    api.customers.customers.lookupData = undefined;
                }
                if(api.sellers.resourceTypes.lookupData) {
                    api.sellers.resourceTypes.lookupData = undefined;
                }
                if(api.sellers.users.lookupData) {
                    api.sellers.users.lookupData = undefined;
                }
                if(api.sellers.vas.lookupData) {
                    api.sellers.vas.lookupData = undefined;
                }
                if(api.customers.favorites.lookupData) {
                    api.customers.favorites.lookupData = undefined;
                }
                if(api.customers.segmentations.lookupData) {
                    api.customers.segmentations.lookupData = undefined;
                }
                if(api.catalogCustomers.segmentation.lookupData) {
                    api.catalogCustomers.segmentation.lookupData = undefined;
                }
                if(api.consolidationTemplates.templateFields) {
                    api.consolidationTemplates.templateFields.lookupData = undefined;
                }

                $scope.$emit('ActiveCatalogChangedEvent', vm.activeCatalog);
                vm.isLinePlan = vm.activeCatalog.IsLinePlan === 1 ? true : false;
                if(vm.activeCatalog.IsLinePlan === 1 && !$state.current.visibleForLinePlan) {//if line plan catalog and current state is not article, then navigate to articles list page
                    vm.isLinePlan = true;
                    $state.go('app.articles');
                }

            });
        }

        function getGroups(catalogs) {
            if(angular.isDefined(catalogs) && catalogs.length > 0) {
                var groupList = [];
                angular.forEach(catalogs, function (catalog) {
                    if (utility.filterObject(groupList,{id :catalog.AccountId},true).length === 0) {
                        groupList.push( utility.filterObject(vm.lookupData.data, {id :catalog.AccountId},true)[0] );
                    }
                });
                return groupList.sort();
            }
        }

        /**
         * Show a dialog to select the active catalog
         */
        function selectCatalog(ev) {
            $mdDialog.show({
                controller: 'activeCatalogDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/toolbar/dialogs/active-catalog/activeCatalog.dialog.html',
                parent: angular.element($document.body),
                targetEvent: ev,
                clickOutsideToClose:true,
                focusOnOpen:false,
                locals: {
                    availableCatalogs: vm.catalogs,
                    currentCatalog: vm.activeCatalog,
                    sellersLookup: vm.lookupData.data
                }
            })
            .then(function(answer) {
                onActiveCatalogChange(answer);
            }, function() {
                //Canceled
            });
        }

        /**
         * Show the Details of the active Environment
         */
        function showCurrentEnv(ev) {
            $mdDialog.show(
                $mdDialog.alert()
                    .clickOutsideToClose(true)
                    .title('Active Environment')
                    .textContent(vm.env.name + ': ' + vm.env.url)
                    .ariaLabel('Active Environment')
                    .ok('Got it!')
                    .targetEvent(ev)
            );
        }

        function toggleFullScreen(screenMode) {
            $rootScope.$emit('toggleFullScreenEvent', screenMode);
            $rootScope.$emit('toggleFullScreenResizeListEvent', 'fullScreen');
        }

        function switchUser() {
            var stateParams = {isSwitchUser: true};
            $state.go('app.auth_login', stateParams);
        }

        var activeCatalogChangedEventCleanup = $rootScope.$on('ActiveCatalogChangedEvent', function(e, catalog) {
            if(angular.isDefined(catalog)) {
                vm.activeCatalog = catalog;
            }
        });

        function showNotification() {
            vm.showNotificationIcon = true;
        }

        var jobCompletedEventCleanup = $rootScope.$on('jobCompletedEvent', function(e) {
            if(!$mdSidenav('quick-panel').isOpen()) {
                showNotification();
            }
        });

        var CatalogsUpdatedEventCleanup = $rootScope.$on('CatalogsUpdatedEvent', function() {
            catalogFactory.updateListOfCatalogs().then(function() {
                vm.activeCatalog = catalogFactory.getActiveCatalog();
                vm.catalogs = catalogFactory.getListOfCatalogs();
            });
        });

        var langaugeChangedEventCleanup = $rootScope.$on('preferredLangaugeChangedEvent', function(event, languageCode) {
            vm.selectedLanguage = vm.languages[$translate.preferredLanguage(languageCode)];
        });

        /**
         * change toolbar background color when catalog is activated from welcome page
         */
        $rootScope.$on('CatalogActivationEvent', function() {
            vm.isLinePlan = vm.activeCatalog.IsLinePlan === 1 ? true : false;
        });

        $scope.$on('$destroy', function() {
            CatalogsUpdatedEventCleanup();
            jobCompletedEventCleanup();
            langaugeChangedEventCleanup();
            activeCatalogChangedEventCleanup();
        });
    }
})();
(function() {
'use strict';

	angular
		.module('fuse')
		.factory('utility', utility);

	/* @ngInject */
	function utility($filter, $translate, $log, $rootScope) {

		var service = {
			plunkObject                 : plunkObject,
            excludeProperties           : excludeProperties,
			filterObject                : filterObject,
            orderBy                     : orderBy,
            createDateObject            : createDateObject,
            setDateHourUTC              : setDateHourUTC,
            formatDate                  : formatDate,
            dateToExcelSerial           : dateToExcelSerial,
            isValidDate                 : isValidDate,
            isEqualDate                 : isEqualDate,
			selectBasedOnFilterString   : selectBasedOnFilterString,
			translate                   : translate,
            buildUrl                    : buildUrl,
            pushItemToArray             : pushItemToArray,
            isObjectEmpty               : isObjectEmpty,
            deepFind                    : deepFind,
            addPropertiesToObject       : addPropertiesToObject,
            addCustomProperty           : addCustomProperty,
            updateLookupDataIndexes     : updateLookupDataIndexes,
            checkRecordOrParentsPropertyValueRecursively    : checkRecordOrParentsPropertyValueRecursively,
            selectInputText             : selectInputText,
            flattenObject               : flattenObject,
            isIdenticalArrays           : isIdenticalArrays,
            clearModelExistConstraints  : clearModelExistConstraints,
            splitString                 : splitString,
            joinArray                   : joinArray,
            substrateList               : substrateList,
            transformToLookupData       : transformToLookupData,
            createIndexMap              : createIndexMap,
            getTreeNodes                : getTreeNodes,
            isValidPattern              : isValidPattern,
            isValidJSON                 : isValidJSON,
            arrayBufferToBase64         : arrayBufferToBase64,
            getCalculatedValue          : getCalculatedValue, // if not required we can remove it
            changeAttributeType         : changeAttributeType,
            generateOrderReference      : generateOrderReference,
            getArticleStatusValue       : getArticleStatusValue,
            getLinkedArticleNumberAttributeTypeValue: getLinkedArticleNumberAttributeTypeValue,
            getLinkedArticleNumberAttributeSeasonValue: getLinkedArticleNumberAttributeSeasonValue,
            filterArticleColors         : filterArticleColors,
            filterInheritedArticlesObject : filterInheritedArticlesObject,
            replaceStringWithCase       : replaceStringWithCase,
            getUniquieRetailIntroAndExitMonths : getUniquieRetailIntroAndExitMonths,
            shipmentWindowRangeWithUniquePeriods: shipmentWindowRangeWithUniquePeriods,
            getSizeScaleIdByMasterSizeScaleIdAndSizeScaleName: getSizeScaleIdByMasterSizeScaleIdAndSizeScaleName,
            getAttributeDisplayNameUsingSystemName: getAttributeDisplayNameUsingSystemName,
            removeDuplicatesFromVettingList: removeDuplicatesFromVettingList,
            getAttributeTypeSpecificValue: getAttributeTypeSpecificValue,
            setAttributeTypeSpecificValue: setAttributeTypeSpecificValue,
            coerceByAttributeType       : coerceByAttributeType,
            matchCriteriaV2Rule         : matchCriteriaV2Rule,
            getCriteriaV2AllowedValues  : getCriteriaV2AllowedValues,
            getOldCriteriaAllowedValues : getOldCriteriaAllowedValues,
            getCriteriaV2DependentFields: getCriteriaV2DependentFields,
            normalizeColorCriteria      : normalizeColorCriteria,
            matchesColorCriteria        : matchesColorCriteria,
            getColorCriteriaAttributes  : getColorCriteriaAttributes
		};

		return service;


		////////////////
		/**
         * @description:
		 *  A function to plunk subset of properties from object
         *
		 * @param {object} sourceObject : 	source object from which the roperties get plunked
		 * @param {array} keys		    :	list of properties to be plunked
         *
         * @returns {object}             :   plunked object with specified properties
		 */
		function plunkObject(sourceObject, keys) {
			var plunkedObject = {};
			angular.forEach(keys, function(key) {
				plunkedObject[key] = sourceObject[key]; });
			return plunkedObject;
		}

        /**
         * @description:
		 *  A function to remove specific properties form object
         *
		 * @param {objecr} sourceObject : 	source object
		 * @param {array} keys	        :	list of properties to be removed from source object
         *
         * @returns {object}             :   source object without properties specified in properties list
		 */
        function excludeProperties(sourceObject, properties) {
            var plunkedObject = angular.copy(sourceObject);
			angular.forEach(properties, function(prop) {
                if(angular.isDefined(plunkedObject[prop])) {
                    delete plunkedObject[prop];
                }
            });
			return plunkedObject;
        }


		function filterObject(sourceObj, filterQuery, stricktMatch){
			return $filter('filter')(sourceObj, filterQuery, stricktMatch);
		}

        function orderBy(sourceArray, predicate, reverse) {
            return $filter('orderBy')(sourceArray, predicate, reverse);
        }

        /**
         * @description:
         *  Creates a date object
         *
         * @param date: date string or date object
         * @param field: date field with properties
         * @param fromUTC: boolean if true then date is UTC and must be adjusted to local timezone
         *
         * @returns : date object
         */
        function createDateObject(date, field, fromUTC) {
            if(angular.isDate(date)) {
                if(fromUTC) {
                    return new Date(date.setHours(12+(date.getTimezoneOffset()/60),0,0));
                }
                else {
                    // Already a Date: return it unchanged so re-running this (e.g. a
                    // datepicker ng-init that re-fires when the attribute search box
                    // rebuilds the field list) is idempotent and keeps the saved value
                    // instead of resetting to today.
                    return date;
                }
            }
            else if(isValidDate(date)) {
                var d = new Date(date);
                if(fromUTC) {
                    return new Date(d.setHours(12+(d.getTimezoneOffset()/60),0,0));
                }
                else {
                    // fix date and date option selected different on date picker issue with timezone
                    if(angular.isDefined(field) && (field.inputType === 'date-option' || field.inputType === 'date-without-time')) {
                        d.setMinutes(d.getMinutes() + d.getTimezoneOffset());
                    }
                    return d;
                }
            }
            else {
                $log.warn('in utilities createDateObject method invalid date format');
                return null;
            }
        }

        /**
         * @description:
         *  Change date hour
         *
         * @param date: date object
         * @param hour: desired hour
         */
        function setDateHourUTC(date, hour) {
            if(angular.isDefined(date) &&  angular.isDate(date) && angular.isDefined(hour) && angular.isNumber(hour)) {
                var d = date.setHours(hour-(date.getTimezoneOffset()/60));
                return new Date(d)
            }
        }

        /**
         * @description:
         *  Formats date to a string based on the requested format
         *
         * @param date: date(object, string or number)
         * @param format: date format
         * @param timezone: if not specified converted date will be date in local timezone
         *
         * @returns : formated date
         */
        function formatDate(date, format, timezone) {
            return $filter('date')(date, format, timezone);
        }

        /**
         * @description
         *  Converts a date value into an Excel serial date number (days since the
         *  1899-12-30 epoch). Writing this as the numeric cell value (t:'n') with a date
         *  number-format makes Excel treat the cell as a real date, so it sorts
         *  chronologically instead of lexically like the previous string export.
         *
         *  The serial is built from the date's calendar components via UTC math so the
         *  result is independent of the browser's timezone. Pass useUtc = true to use the
         *  value's UTC components (mirrors the 'date-utc' string format), otherwise the
         *  browser-local components are used (mirrors the other date formats).
         *
         * @param value: date string / timestamp / Date object
         * @param useUtc: when true, use the UTC wall-clock components
         * @returns {number|undefined} Excel serial number, or undefined for empty/invalid input
         */
        function dateToExcelSerial(value, useUtc) {
            if (value === null || angular.isUndefined(value) || value === '') {
                return undefined;
            }
            var m = useUtc ? moment.utc(value) : moment(value);
            if (!m.isValid()) {
                return undefined;
            }
            var epoch = Date.UTC(1899, 11, 30);
            var componentsUtc = Date.UTC(m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second());
            return (componentsUtc - epoch) / 86400000;
        }


        /**
         * @description:
         *  Check date against format (Default format ISO_8601)
         *
         * @param date: date string
         * @param formats: list of acceptable formats
         */
        function isValidDate(date, formats) {
            if(angular.isUndefined(formats)) {
                formats = [
                    moment.ISO_8601
                ];
            }
            //The true argument is there so the Moment won't try to parse the input if it doesn't exactly conform to one of the formats provided
            if(moment(date, formats, true).isValid()) {
                return true;
            }
            else {
                return false
            }
        }

        /**
         * @description
         *  compare two date strings
         * @returns {boolean} true if both date are valid dates (ISO_8601 formated date) and indicating same date, else return false
         *  *log error if either of dates are not ISO_8601 formated date
         */
        function isEqualDate(date1, date2) {
            if(isValidDate(date1) && isValidDate(date2)) {
                var d1 = Date.parse(date1);
                var d2 = Date.parse(date2);
                if(d1 == d2) {
                    return true;
                }
            }
            else if((date1 === null || angular.isUndefined(date1) || date1 === '') && (date2 === null || angular.isUndefined(date2)|| date2 === '')) {
                return true;
            }
            else {
                $log.error('Invalid date formate returned by server!');
            }
            return false;
        }

		/**
         * @description:
		 *  this function will select items based on filterString user chose on select all toolbar
         *
		 * @param {array} items: list of records
		 * @param {string} filterString: a string indicate which items to be select
		 * @param {boolean} selectAllStatus: staus of selectAll checkbox
         *
		 * @returns {boolean} it will return selectAllStatus which will set buyer.selectAll scope variable
		 */
		function selectBasedOnFilterString(items,filterString, selectAllStatus){
			if (angular.isUndefined(filterString)) {
				selectAllStatus = !selectAllStatus;
				angular.forEach(items, function(item) {
					item.selected = selectAllStatus;
				});
			} else if(filterString === 'all'){
				selectAllStatus = true;
				angular.forEach(items, function(item) {
					item.selected = true;
				});
			} else if(filterString === 'none'){
				selectAllStatus = false;
				angular.forEach(items, function(item) {
					item.selected = false;
				});
			} else {
				selectAllStatus = false;
				var selectedEntity = [];
				selectedEntity = filterObject(items, filterString);
				angular.forEach(items, function(item){
					item.selected = false;
				});
				angular.forEach(selectedEntity, function(item) {
					item.selected = true;
				});
			}
			return selectAllStatus;
		}

		/**
         * @description:
		 *  a translator function
         *
		 * @param {string} name: a string which correspond a tranlate-id in translate table.
		 */
		function translate(name){
			$translate(name).then(function(translatedName){
				return translatedName;
			}).catch(function(){
				return name;
			});
		}

       /**
        * @name buildUrl
        * @description:
        *  Function that tranforms a URL and HTTP parameters into a fully qualified URL string.
        *
        * @param {string} url The HTTP URL
        * @param {object} params An object that contains all the URL parameters
        * @param {boolean} isArticleRelatedData
        *
        * @returns {string} The fully qualified URL string
       */
        function buildUrl(url, params, isArticleRelatedData) {
            //check if isArticleRelatedData is true, then return common cacheKey 'activeCatalogArticleDataKey'
            if(isArticleRelatedData) return 'activeCatalogArticleDataKey';
            if (!params) return url;
            var parts = [];
            angular.forEachSorted(params, function(value, key) {
                if (value === null || angular.isUndefined(value)) return;
                if (!angular.isArray(value)) value = [value];

                angular.forEach(value, function(v) {
                if (angular.isObject(v)) {
                    if (angular.isDate(v)) {
                    v = v.toISOString();
                    } else {
                    v = angular.toJson(v);
                    }
                }
                parts.push(angular.encodeUriQuery(key) + '=' +
                            angular.encodeUriQuery(v));
                });
            });
            if (parts.length > 0) {
                url += ((url.indexOf('?') == -1) ? '?' : '&') + parts.join('&');
            }
            return url;
        }

        /**
         * @description
         *  It will create a array of single object or convert object to array
         *
         * @param {object or primitive data type} item: single item
         *
         * @returns {array} converted array of item
         */
        function pushItemToArray(item) {
            if(angular.isDefined(item) && !angular.isArray(item)) {
                var array = [];
                array.push(item);
                return array;
            }
            else if(angular.isDefined(item) && angular.isArray(item)) {
                return item;
            }
            else {
                $log.warn('Method argumet can not be undefined');
            }
        }

        /**
         * Verify if object does not have any properties (empty object)
         */
        function isObjectEmpty(obj) {
            for(var property in obj) {
                return false;
            }
            return true;
        }

        function deepFind(obj, path)
        {
            var paths = path.split('.'),
                current = obj,
                i;

            for (i = 0; i < paths.length; ++i) {
                if (angular.isUndefined(current[paths[i]])) {
                    return undefined;
                } else {
                    current = current[paths[i]];
                }
            }
            return current;
        }


        /**
         * Add a custome property to each object of data
         */
        function addPropertiesToObject(records, propertyList, proprtyType) {
            if(!angular.isArray(records)){
                records = pushItemToArray(records);
            }
            angular.forEach(records, function(record) {
                for(var index=0, len=propertyList.length; index<len; index++){
                    if(proprtyType[index].toUpperCase() === 'OBJECT') {
                        record[propertyList[index]] = {};
                        break;
                    }
                    else if(proprtyType[index].toUpperCase() === 'ARRAY') {
                        record[propertyList[index]] = [];
                        break;
                    }
                    else if(proprtyType[index].toUpperCase() === 'STRING') {
                        record[propertyList[index]] = '';
                        break;
                    }
                    else if(proprtyType[index].toUpperCase() === 'NUMBER') {
                        record[propertyList[index]] = -1;
                        break;
                    }
                    else if(proprtyType[index].toUpperCase() === 'BOOLEAN') {
                        record[propertyList[index]] = false;
                        break;
                    }
                }
            });
        }

        /**
         * @description:
         *  check for property value of record or its parents recursivly right upto root
         *
         * @param record     : data for which property value will check upto its root
         * @param parentPath : a string denoting path of record's parent
         * @param properyPath: the property of record or its ancesstor that needs to be check
         * @param value      : desire value of property
         *
         * @returns boolean  : true if record or its ancesstors have property which desired value
         */
        function checkRecordOrParentsPropertyValueRecursively(record, parentPath, properyPath, value) {
            var parentObject, objectProperty;
            //if root
            if(record === null){
                return true;
            }
            parentObject = deepFind(record, parentPath);
            objectProperty = deepFind(record, properyPath);
            if(parentObject === null || angular.isUndefined(parentObject)) {
                //if root node is disable
                if(objectProperty === value) {
                    return false;
                }
                else {
                    return true;
                }
            }
            //if not root node
            else {
                // if node status is 0 return false (not dragable)
                 if(objectProperty === value) {
                    return false;
                 }
                 //else check parent
                 else {
                     return checkRecordOrParentsPropertyValueRecursively(parentObject, parentPath, properyPath, value);
                 }
            }
        }

        /**
         * @description:
         *  Will add custome property to object and initialize it with 'value'
         *
         * @param records: list of objects
         * @param property: property name
         * @param value: property value
         */
        function addCustomProperty(records, property, value) {
            angular.forEach(records, function(record){
                record[property] = value;
            });
        }

        /**
         * @description
         *  update indexArray for modified lookup object
         *
         * @param {object} lookup : modified lookup data
         */
        function updateLookupDataIndexes(lookup) {
            if(lookup && angular.isArray(lookup.data)) {
                lookup.indexArray = [];
                angular.forEach(lookup.data, function(data) {
                    lookup.indexArray.push(data.id);
                });
            }
        }

        /**
         * @description:
         *  will select text inside of input field
         *
         * @param {object}: javascript event object
         */
        function selectInputText(event) {
            if(angular.isDefined(event.target.select) && event.which !== 32) {
                event.target.select();
            }
        }

        /**
         *
         */
        function flattenObject(object) {
            var flattendObj = {};
            for(var prop in object) {
                if(angular.isArray(object[prop])) {
                    angular.forEach(object[prop], function(obj) {
                        var innerFlattendObj = flattenObject(obj);
                        flattendObj = Object.assign(flattendObj, innerFlattendObj);
                    });
                }
                else if(angular.isObject(object[prop])) {
                    for(var innerProp in object[prop]) {
                        flattendObj[innerProp] = object[prop][innerProp];
                    }
                }
                else {
                    flattendObj[prop] = object[prop];
                }
            }
            return flattendObj;
        }

        /**
         * @description
         * compare two arrys if they are identical, if both are undefined it will return false
         * @param {array} arr1: first array
         * @param {array} arr2: second array
         */
        function isIdenticalArrays(arr1, arr2) {
            if(angular.isUndefined(arr1) || angular.isUndefined(arr2) || !angular.isArray(arr1) || !angular.isArray(arr2)) {
                return false;
            }
            else if(arr1.length !== arr2.length) {
                return false;
            }
            for(var i=0, len=arr1.length; i<len; i++) {
                if(!angular.equals(arr1[i].toString(), arr2[i].toString())){
                    return false;
                }
            }
            return true;
        }

        /**
         * @description:
         * use to clean model's where data has been added to their field.validation.dataExistConstraints.data
         * and possible promise object being added
         */
        function clearModelExistConstraints(model) {
            angular.forEach(model.fields, function(field) {
                if(angular.isDefined(field.validation) && angular.isDefined(field.validation.dataExistConstraints)) {
                    if(angular.isDefined(field.validation.dataExistConstraints.data) && field.validation.dataExistConstraints.data > 0) {
                        field.validation.dataExistConstraints.data.length = 0;
                    }
                    if(angular.isDefined(field.validation.dataExistConstraints.promise)) {
                        field.validation.dataExistConstraints.promise = {};
                    }
                }
            });
        }

        function splitString(string, separator) {
            if(angular.isDefined(string) && angular.isString(string) && angular.isDefined(separator) && angular.isString(separator)) {
                return string.split(separator);
            }
            else {
                $log.warn('Wrong usage for utiliti\'s splitString method');
            }
        }

        function joinArray(array, separator) {
            if(angular.isDefined(array), angular.isDefined(separator) && angular.isArray(array) && angular.isString(separator)) {
                return array.join(separator);
            }
            else {
                $log.warn('Wrong usage for utiliti\'s joinArray method');
            }
        }

        /**
         * @description: this method will remvoe all the objects in targetList from sourceList, * targetList should be subset of sourceList
         * @param { Array } sourceList list of objects to be substract from
         * @param { Array } targetList list of objects/ids to be removed form sourceList
         * @param { Object } model module's model object used to identify object UID
         */
        function substrateList(sourceList, targetList, model) {
            if(angular.isDefined(targetList) && angular.isDefined(model) && angular.isDefined(model.idField)) {
                if(!angular.isArray(targetList)) {
                    targetList = [targetList];
                }
                var targetListIndexMap = createIndexMap(targetList, model.idField);

                for(var index=sourceList.length-1; index>=0; index--) {
                    if(angular.isDefined(targetListIndexMap[ sourceList[index][model.idField] ])) {
                        sourceList.splice(index, 1);
                    }
                }
            }
        }

        /**
         * @description this method will transform records into lookupdata format
         * @param {array} records list of data needs to be transformed
         * @param {object} model entity model
         * @param {array} propertyList list of properties needs to be part of lookup object structure apart from id and value
         * @return {object} an object containing list of data and list if indexArray
         */
        function transformToLookupData(records, model, propertyList) {
           var result = { indexArray: [], data: [] };

           // create structure of data in lookup data object
           var lookupDataStructure = {};
           if(propertyList && propertyList.length) {
               for(var index=0, len=propertyList.length; index<len; index++) {
                  lookupDataStructure[propertyList[index]] = undefined;
               }
           }

           for (var i=0; i<records.length; i++) {
               var lookupDataStructureCopy = angular.copy(lookupDataStructure);
               for(var key in lookupDataStructureCopy) {
                   lookupDataStructureCopy[key] = records[i][key];
               }
               lookupDataStructureCopy['id'] = records[i][model.idField];
               lookupDataStructureCopy['value'] = records[i][model.lookupDisplayField];
               result.indexArray.push(records[i][model.idField]);
               result.data.push(lookupDataStructureCopy);
           }
           return result;
        }


        function createIndexMap(targetList, idField) {
            var map = {};
            if(angular.isObject(targetList[0])) {
                angular.forEach(targetList, function(targetData) {
                    map[ targetData[idField] ] = 'True';
                });
            }
            else {
                angular.forEach(targetList, function(targetId) {
                    map[ targetId ] = 'True';
                });
            }
            return map;
        }

        function getTreeNodes(treeNode, nodeTitles, childPropertyName, filteredNodes) {
            if(angular.isUndefined(childPropertyName) || childPropertyName == null || childPropertyName.toString().trim() === '') {
                childPropertyName = 'children'
            }
            if(angular.isUndefined(filteredNodes)) {
                filteredNodes = [];
            }
            for(var i=0; i<treeNode.length; i++) {
                if(treeNode[i][childPropertyName] && treeNode[i][childPropertyName].length) {
                    filteredNodes = getTreeNodes(treeNode[i][childPropertyName], nodeTitles, childPropertyName, filteredNodes);
                }
                angular.forEach(nodeTitles, function(nodeTitle) {
                    if(treeNode[i].title.toString().toLowerCase().trim() === nodeTitle.toString().toLowerCase().trim()) {
                        filteredNodes.push(treeNode[i]);
                    }
                });
            }
            return filteredNodes;
        }

        function isValidPattern(pattern) {
            if(pattern !== '' && pattern != null) {
                if (pattern[0] !== '/') {
                    return false;
                }
                var i = pattern.lastIndexOf('/');
                if ( i <= 0 ) {
                    return false;
                }
                try {
                    new RegExp(pattern.slice(1, i), pattern.slice(i+1));
                    return true;
                } catch(error) {
                    return false;
                }
            } else {
                return false;
            }
        }

        function isValidJSON(text) {
            if(text === '' || text == null) {
                return false;
            }
            try{
                return JSON.parse(text);
            }
            catch (error){
                return false;
            }
        }

        // convert ArrayBuffer to a base64 string
		function arrayBufferToBase64(arrayBuffer) {
			var base64Binary = '';
			var bytes = new Uint8Array(arrayBuffer);
			var arrayLength = bytes.byteLength;
			for (var i=0; i<arrayLength; i++) {
				base64Binary += String.fromCharCode(bytes[i]);
			}
			return window.btoa(base64Binary);
		}

		function getCalculatedValue(itm, columnName, parsedExpressionObject) {
            if(angular.isObject(parsedExpressionObject)) {
                if (itm && columnName && angular.isDefined(parsedExpressionObject) && angular.isDefined(parsedExpressionObject.calculatedRegexExpression)) {
                    var calculatedValue = '';
                    var data = angular.copy(itm);
                    var calculatedExpression = parsedExpressionObject.calculatedRegexExpression;
                    var fieldRegexList = angular.isDefined(calculatedExpression.fieldRegex) ? calculatedExpression.fieldRegex : [];
                    var calculatedFormula = angular.isDefined(calculatedExpression.calculatedFormula) ? calculatedExpression.calculatedFormula : '';
                    var type = angular.isDefined(calculatedExpression.type) ? calculatedExpression.type : '';
                    if(type !== '' && calculatedFormula !== '') {
                        var regexValue = '';
                        if(type.toLowerCase() === 'number') {
                            var pattern = /\['(.*?)'\]/g;
                            var match;
                            var calcFieldList = [];
                            while ((match = pattern.exec(calculatedFormula)) != null) {
                                if(calcFieldList.indexOf(match[1]) === -1) {
                                    calcFieldList.push(match[1]);
                                }
                            }

                            if(calcFieldList.length > 0) {
                                for(var i = 0; i < calcFieldList.length; i++) {
                                    if(data[calcFieldList[i]] === undefined || data[calcFieldList[i]] === '') {
                                        calculatedValue = -1;
                                        break;
                                    } else if(data[calcFieldList[i]] === null) {
                                        data[calcFieldList[i]] = 0;
                                    } else if(data[calcFieldList[i]]) {
                                        var parsedValue = parseFloat(data[calcFieldList[i]]);
                                        if(parsedValue !== null && !isNaN(parsedValue)) {
                                            data[calcFieldList[i]] = parsedValue;
                                        } else {
                                            calculatedValue = -1;
                                            break;
                                        }
                                    }
                                }
                            }
                        } else if(type.toLowerCase() === 'string') {
                            if(fieldRegexList.length > 0) {
                                angular.forEach(fieldRegexList, function(fieldRegex) {
                                    if(fieldRegex.regEx !== null) {
                                        var field = fieldRegex.field;
                                        if (data[field] !== undefined) {
                                                if (data[field] === null || data[field] === '') {
                                                        regexValue = data[field];
                                                } else {
                                                    var matchValue = data[field].match(fieldRegex.regEx);
                                                    regexValue = matchValue !== null ? matchValue[0] : null;
                                                }
                                        } else {
                                                regexValue = undefined;
                                        }
                                        data[field] = regexValue;
                                    }
                                });
                            }
                        } else {
                            calculatedValue = -1;
                        }

                        //evaluate calculate formula
                        if(calculatedValue !== -1) {
                            // calculatedValue = $rootScope.$eval(calculatedFormula, { data: data });
                            // TODO: $rootScope.$eval is not evaluating current expression which is used to evaluate to sort intro month.
                            // If the validation expression is changed or implementation change we need to use the  $rootScope.$eval
                            calculatedValue = eval(calculatedFormula, { data: data });
                        }
                    } else {
                        calculatedValue = -1;
                    }

                    return itm[columnName] = calculatedValue;
                } else {
                    return -1;
                }
            } else {
                var data = angular.copy(itm);
                return $rootScope.$eval(parsedExpressionObject, { data: data });
            }
		}

        // this is to convert the assigned catalog attribute inputtypes as common types.
        function changeAttributeType(selectedAttribute) {
            var attribute = angular.copy(selectedAttribute);
            if(angular.isDefined(selectedAttribute)) {
                if (selectedAttribute.AllowedValues && selectedAttribute.AllowedValues !== null && (angular.isArray(selectedAttribute.AllowedValues) && selectedAttribute.AllowedValues.length)) {
                    attribute.inputType = 'list';
                    attribute.values = (selectedAttribute.AllowedValues || [])
                    .map(function(value) {
                        return value.trim();
                    })
                    .sort(function(a, b) {
                        return a.toLowerCase().localeCompare(b.toLowerCase());
                    })
                    // for multi value attributes with vetting list inputtype will be multi-value
                    if (attribute.AttributeTypeName.toUpperCase() === 'MULTIVALUE') {
                        attribute.inputType = 'multi-value';
                        attribute.tagSeparator = '|';
                    }
                    if (selectedAttribute.AttributeTypeName.toUpperCase() === 'INT') {
                        attribute.type = 'int';
                    } else {
                        attribute.type = 'text';
                    }
                }
                else {
                    if (selectedAttribute.AttributeTypeName.toUpperCase() === 'INT') {
                        attribute.inputType = 'number';
                    }
                    else if (selectedAttribute.AttributeTypeName.toUpperCase() === 'NVARCHAR') {
                        attribute.inputType = 'textArea';
                    }
                    else if (selectedAttribute.AttributeTypeName.toUpperCase() === 'DATE') {
                        attribute.inputType = 'date-without-time';
                    }
                    else if (selectedAttribute.AttributeTypeName.toUpperCase() === 'DATETIME') {
                        attribute.inputType = 'date';
                    }
                    else if (selectedAttribute.AttributeTypeName.toUpperCase() === 'BOOL') {
                        attribute.inputType = 'bool-str';
                    }
                    else if (attribute.AttributeTypeName.toUpperCase() === 'MULTIVALUE') {
                        attribute.inputType = 'tags';
                        attribute.tagSeparator = '|';
                        attribute.inputSubType = 'multi-value';
                    }
                    else if (selectedAttribute.AttributeTypeName.toUpperCase() === 'CALC') {
                        attribute.inputType = 'calculated';
                        attribute.calculatedExpression = selectedAttribute.ValidationExpression;
                        //Adding try catch if JSON parse fails
                        try {
                            attribute.parsedExpressionObject = JSON.parse(selectedAttribute.ValidationExpression);
                            if(angular.isDefined(attribute.parsedExpressionObject.calculatedRegexExpression)) {
                                var calculatedRegexExpression = attribute.parsedExpressionObject.calculatedRegexExpression;
                                if(angular.isDefined(calculatedRegexExpression.fieldRegex) && calculatedRegexExpression.fieldRegex.length > 0) {
                                    angular.forEach(calculatedRegexExpression.fieldRegex, function(fieldRegex) {
                                        var convertedRegEx = convertStringToRegex(fieldRegex.regEx);
                                        if(convertedRegEx != null) {
                                                fieldRegex.regEx = convertedRegEx;
                                        } else {
                                                console.warn("invalid Regex for : " + fieldRegex.field);
                                        }
                                    })
                                }
                                attribute.calcType = calculatedRegexExpression.type;
                            }
                        } catch(error) {
                            console.warn(attribute.AttributeDisplayName + " - Attribute Validation Expression : Invalid JSON format");
                        }
                    }
                    else if (selectedAttribute.AttributeTypeName.toUpperCase() === 'DATEOPTION') {
                        attribute.inputType = 'date-option';
                    }
                    else if (selectedAttribute.AttributeTypeName.toUpperCase() === 'DECIMAL') {
                        attribute.inputType = 'decimal';
                        attribute.validation = {};
                        attribute.validation.pattern = '^[+]?\\d+([.]\\d{0,4})?$';
                        attribute.validation.messages = {};
                        attribute.validation.messages.pattern = 'VALIDATIONS.POSITIVE_DECIMAL_4PONTS';
                    }
                    else if (selectedAttribute.AttributeTypeName.toUpperCase() === 'ARTICLENUMBER') {
                        attribute.inputType = 'articlenumber';
                        attribute.lookupSource = 'catalogs.articles';
                        attribute.lookupFilter = {'Status': 1};
                    }
                    else if (selectedAttribute.AttributeTypeName.toUpperCase() === 'LINKEDCATALOGARTICLENUMBER') {
                        attribute.inputType = 'linkedcatalogarticlenumber';
                        attribute.lookupSource = 'lists.linkedCatalogArticles';
                        attribute.lookupFilter = {'Status': 1};
                    }
                    else if (selectedAttribute.AttributeTypeName.toUpperCase() === 'COLORPALETTE') {
                        attribute.inputType = 'color-palette';
                        attribute.lookupSource = 'lists.sellerColorsFromColorPalette';
                        attribute.isfilterCriteria = true;
                        attribute.lookupFilter = {'Status': 1};
                        attribute.customLookupInfo = {value: 'value'}
                    }
                    else if (selectedAttribute.AttributeTypeName.toUpperCase() === 'MODELNUMBER') {
                        attribute.inputType = 'modelnumber';
                        attribute.lookupSource = 'lists.sellerModelsWithoutAttributes';
                    }
                    else if (selectedAttribute.AttributeTypeName.toUpperCase() === 'LOOKUPTABLE') {
                        attribute.inputType = 'lookup-table';
                    }
                    else if (selectedAttribute.AttributeTypeName.toUpperCase() === 'DATASET') {
                        attribute.inputType = 'dataset';
                        attributeField.datasetId = attribute.DatasetId;
                    }
                    else if (attribute.AttributeTypeName.toUpperCase() === 'DATATABLE') {
                        attributeField.inputType = 'datatable';
                        attributeField.DataTableAttributes = attribute.DataTableAttributes
                        if(attribute.AllowedValuesV2 && attribute.AllowedValuesV2.length) {
                            try {
                            attributeField.valuesV2 = JSON.parse(attribute.AllowedValuesV2)
                            } catch(error) {
                            console.warn(attribute.AttributeDisplayName + " - Allowed Values Version 2 : Invalid JSON format");
                            }
                        }
                        if(attribute.CriteriaV2 && attribute.CriteriaV2.length) {
                            try {
                            attributeField.criteriaV2 = JSON.parse(attribute.CriteriaV2)
                            } catch(error) {
                            console.warn(attribute.AttributeDisplayName + " - Criteria Version 2 : Invalid JSON format");
                            }
                        }
                        if(api.allAttributesListMap && Object.keys(api.allAttributesListMap).length > 0) {
                            attributeField.dataTableAttributesDetails = attributeField.DataTableAttributes.map(function(attrId) {
                                return api.allAttributesListMap[attrId];
                            }).filter(function(attr) {
                                return attr !== undefined;
                            })
                        }
                    }
                }
            }
            return attribute;
        }

        function generateOrderReference(customerCode, locationCode) {
            return customerCode+ '-' + locationCode + '-' + (Math.floor(Math.random() * 899999) + 100000)
        }

        function getArticleStatusValue(itm, field, dataSourceTypeId) {
            if(angular.isDefined(itm) && angular.isDefined(itm[field.field])) {
                if(dataSourceTypeId === 1) {
                    return itm[field.field];
                } else if(dataSourceTypeId !== 1) {
                    if(itm[field.parentField] === 0) {
                        return 2; // Globally Dropped
                    }
                    else if (itm[field.field] === 1 && itm[field.parentField] === 1) {
                        return 1;
                    } else if (itm[field.field] === 0 && itm[field.parentField] === 1) {
                        return 3; // Not Assorted
                    } else {
                        return itm[field.field];
                    }
                }
            }
          }

        /**
        * @description split the attribute value for linkedCatalogArticleNUmber type attribute and return the article id
        * @param {String} attributeValue Attribute Value
        * @param {boolean} returnArticleNumber if true then return the article number if false/undefined return article id
        * @returns article id
        */
        function getLinkedArticleNumberAttributeTypeValue(attributeValue, returnArticleNumber) {
            if(attributeValue != null && attributeValue.toString().trim() !== '') {
            var splittedValues = attributeValue.split('//');
            if(splittedValues.length && splittedValues.length === 3) {
                if(!returnArticleNumber) {
                    return parseInt(splittedValues[1]);
                } else {
                    return splittedValues[2];
                }
            } else {
                return '';
            }
            } else {
                return '';
            }
        }

        /**
        * @description split the attribute value for linkedCatalogArticleNUmber type attribute and return the season
        * @param {String} attributeValue Attribute Value
        * @returns season
        */
        function getLinkedArticleNumberAttributeSeasonValue(attributeValue) {
            if(attributeValue != null && attributeValue.toString().trim() !== '') {
            var splittedValues = attributeValue.split('//');
            if(splittedValues.length && splittedValues.length === 3) {
                return splittedValues[0];
            } else {
                return '';
            }
            } else {
                return '';
            }
        }

        /**
        * @description filter article colors based on conditional color vetting list
        * @param {Array} lookupData lookupData
        * @returns filtered colors
        */
        function filterArticleColors(lookupData, articles, conditionalColorsCriteria) {
            var indexedColorDefinitions = {};
            var indexedColorIdByColorName = {};
            angular.forEach(lookupData, function(colorDefinition) {
                indexedColorDefinitions[colorDefinition.id] = colorDefinition;
                indexedColorIdByColorName[colorDefinition.value.toLowerCase()] = colorDefinition.id;
            });

            var result = [];
            if(angular.isDefined(conditionalColorsCriteria) && conditionalColorsCriteria.length && articles.length) {
                var addAllColors = true;
                angular.forEach(conditionalColorsCriteria, function(conditionalColor) {
                    if(angular.isDefined(conditionalColor['Colors']) && angular.isDefined(conditionalColor['Condition'])) {
                        var isValidCriteria = false;
                        for (var i=0, len=articles.length; i<len; i++) {
                            isValidCriteria = false;
                            var validItems = 0;
                            for (var attributeSystemName in conditionalColor.Condition) {
                                if(angular.isDefined(articles[i][attributeSystemName]) && articles[i][attributeSystemName] != null
                                && (articles[i][attributeSystemName].toString().trim().toLowerCase() == conditionalColor.Condition[attributeSystemName].toString().trim().toLowerCase())) {
                                    isValidCriteria = true;
                                    validItems++;
                                    addAllColors = false;
                                } else {
                                    isValidCriteria = false;
                                    if(validItems > 0 && validItems !==  Object.keys(conditionalColor.Condition).length) {
                                        addAllColors = true;
                                    }
                                    break;
                                }
                            }
                            if(!isValidCriteria) {
                                addAllColors = true;
                                break;
                            }
                        }
                        if(isValidCriteria) {
                            angular.forEach(conditionalColor.Colors, function(colorName) {
                                if(angular.isDefined(indexedColorIdByColorName[colorName.trim().toLowerCase()])
                                && angular.isDefined(indexedColorDefinitions[indexedColorIdByColorName[colorName.trim().toLowerCase()]])) {
                                    var colorDefinition = indexedColorDefinitions[indexedColorIdByColorName[colorName.trim().toLowerCase()]]
                                    result.push(colorDefinition);
                                }
                            });
                        }
                    }
                });
                // Add all colors if not criteria is matching
                if(addAllColors && Object.keys(result).length === 0) {
                    result = lookupData;
                }
            } else {
                result = lookupData;
            }
            return result;
        }

        // filter inherited articles and remove un assorted article
        function filterInheritedArticlesObject(articles) {
            var filtredArticles = filterObject(articles, {Status: 1, PS: 1}, true);
            var filtredGloballyDroppedArticles = filterObject(articles, {PS: 0}, true);
            filtredArticles = filtredArticles.concat(filtredGloballyDroppedArticles);
            return filtredArticles;
        }

        /**
         * @description replace the word in a string with keeping the case intact
         * @param {string} string source string
         * @param {string} pattern a value to replace in the source string
         * @param {String} newString replace the pattern with this string
         * @returns {String} string replacing the word
         */
        function replaceStringWithCase(string, pattern, newString) {
            var rx = new RegExp(pattern, 'gi');
            var replacer = function (c, i) {
                return c.match(/[A-Z]/) ? newString[i] ? newString[i].toUpperCase() : '' : newString[i] ? newString[i] : '';
            };
            return string.replace(rx, function (oldString) {
                // if old string length is less that new string add dummy letters to make to equal
                if(pattern.length < newString.length) {
                    var count = newString.length - pattern.length;
                    // if the translated string is in all caps then add dumy letter in caps
                    var dummyLetter = oldString === oldString.toUpperCase() ? 'S' : 's';
                    for(var i = 0; i< count; i++) {
                        oldString = oldString + dummyLetter;
                    }
                }
                return oldString.replace(/./g, replacer);
            });
        }

        // method to get unique retail intro and exit months
        function getUniquieRetailIntroAndExitMonths(records) {
            var uniqueValues = [];
            var uniqueValuesIndex = {};
            angular.forEach(records, function (data) {
                if (angular.isUndefined(uniqueValuesIndex[data['value']])) {
                    uniqueValuesIndex[data['value']] = true;
                    uniqueValues.push(data);
                }
            });
            return uniqueValues;
        }

        // method to get unique retail intro and exit months
        function shipmentWindowRangeWithUniquePeriods(shipmentWindows) {
            var uniqueValues = [];
            var uniqueValuesIndex = {};
            angular.forEach(shipmentWindows, function (shipmentWindow) {
                if (angular.isUndefined(uniqueValuesIndex[shipmentWindow['Period']]) && shipmentWindow['Period'] != null && shipmentWindow['Period'] !== '') {
                    uniqueValuesIndex[shipmentWindow['Period']] = true;
                    uniqueValues.push(shipmentWindow);
                }
            });
            return uniqueValues;
        }

        function getSizeScaleIdByMasterSizeScaleIdAndSizeScaleName(masterSizeScaleId, sizeScaleName, sizeScaleGroups) {
            for (var i = 0; i < sizeScaleGroups.length; i++) {
                var sizeScaleGroup = sizeScaleGroups[i];
                if (sizeScaleGroup.MasterSizeScaleId === masterSizeScaleId && sizeScaleGroup.SizeScale === sizeScaleName) {
                    return sizeScaleGroup.Id;
                }
            }
            return null;
        }

        function getAttributeDisplayNameUsingSystemName(catalogAttributes, attributeSystemName) {
            var filteredAttribute = filterObject(catalogAttributes, { AttributeSystemName: attributeSystemName }, true)[0];
            if (angular.isDefined(filteredAttribute)) {
                return filteredAttribute.AttributeDisplayName;
            } else {
                return '';
            }
        }

        function removeDuplicatesFromVettingList(vettingList) {
            var uniqueValues = [];
            var addedListMap = {};

            angular.forEach(vettingList, function(item) {
                if(angular.isUndefined(addedListMap[item.toLowerCase()])) {
                    addedListMap[item.toLowerCase()] = true;
                    uniqueValues.push(item);
                }
            });

            return uniqueValues;
        }

        function getAttributeTypeSpecificValue(attribute, value) {
            if (attribute.field === 'Status') {
              var statusString = value
              switch (value) {
                case 1:
                  statusString = 'Active'
                  break
                case 2:
                  statusString = 'Not Assorted'
                  break
                case 3:
                  statusString = 'Globally Dropped'
                  break
                default:
                  statusString = 'Inactive'
              }
              return statusString
            }
            else if (attribute.inputType === 'date') {
              return formatDate(value, 'MM/dd/yyyy h:mm a')
            }
            else if (attribute.inputType === 'date-without-time' || attribute.inputType === 'date-option') {
              return formatDate(value, 'MM/dd/yyyy')
            }
            else if (attribute.inputType === 'bool-str') {
              if (typeof value === 'boolean') { return value ? 'True' : 'False'; }
              return (String(value).toLowerCase() == 'true') ? 'True' : 'False'
            }
            else if (Array.isArray(value) && attribute.inputType === 'multi-value') {
                return joinArray(value, '|');
            }
            else if (attribute.inputType === 'number' || attribute.inputType === 'decimal' || (attribute.inputType === 'list' && attribute.type === 'int')) {
                return Number(value)
            }
            return value
        }

        function setAttributeTypeSpecificValue(attribute, value) {
            if (attribute.inputType === 'date' || attribute.inputType === 'date-without-time' || attribute.inputType === 'date-option') {
                return formatDate(new Date(value), 'yyyy-MM-dd');
            }
            else if (attribute.inputType === 'bool-str') {
                if (typeof value === 'boolean') { return value ? 'True' : 'False'; }
                return (String(value).toLowerCase() == 'true') ? 'True' : 'False'
            }
            else if (value.length && attribute.inputType === 'multi-value') {
              if (Array.isArray(value)) {
                    return joinArray(value, '|');
                } else if (typeof value === 'string') {
                    return value.includes('|') ? value.split('|') : [value];
                } else {
                    return [value];
                }
            }
            else if (attribute.inputType === 'number' || attribute.inputType === 'decimal' || (attribute.inputType === 'list' && attribute.type === 'int')) {
                return Number(value)
            }
            return value
        }

        /**
         * Coerce a value to the native type implied by a dataset/model field's inputType.
         * Used to make request payloads type-correct now that the backend expects
         * Dictionary<string, object> for dataset attribute values.
         *
         * @param {*} value - the raw value (may already be typed, may be a string from a form/xlsx cell)
         * @param {object|string} fieldOrInputType - the model field config, or its inputType string
         * @returns {*} the value cast to its declared type, or the original value if no cast applies
         */
        function coerceByAttributeType(value, fieldOrInputType) {
            if (value === null || value === undefined || value === '') {
                return value;
            }
            var inputType = (typeof fieldOrInputType === 'string')
                ? fieldOrInputType
                : (fieldOrInputType && fieldOrInputType.inputType);

            if (inputType === 'number' || inputType === 'decimal') {
                if (typeof value === 'number') { return value; }
                var n = Number(value);
                return isNaN(n) ? value : n;
            }
            if (inputType === 'bool' || inputType === 'bool-str') {
                if (typeof value === 'boolean') { return value; }
                return String(value).toLowerCase() === 'true';
            }
            // string-like types (text, textArea, date, lookup, etc.) — leave unchanged
            return value;
        }

        /**
         * @description
         *  Evaluates whether a single CriteriaV2 rule is satisfied by the current record/row.
         *  A CriteriaV2 rule looks like: { "<DepField>": ["v1","v2"], ..., "AllowedValues": [...] }
         *  Every listed dependent field must hold one of its listed values (case-insensitive).
         *  Empty / non-array conditions are skipped (treated as satisfied), mirroring the grid.
         *
         * @param {object} rule              : a single CriteriaV2 rule object
         * @param {function} getDependentValue: fn(depFieldSystemName) -> current raw value (string) or null/undefined
         * @returns {boolean}                : true when all dependent conditions are met
         */
        function matchCriteriaV2Rule(rule, getDependentValue) {
            for (var dep in rule) {
                if (!rule.hasOwnProperty(dep) || dep === 'AllowedValues') { continue; }
                var required = rule[dep];
                if (!angular.isArray(required) || required.length === 0) { continue; }
                var actual = getDependentValue(dep);
                if (actual === null || actual === undefined || actual.toString() === '') { return false; }
                var reqLower = required.map(function (x) { return x.toString().toLowerCase(); });
                if (reqLower.indexOf(actual.toString().toLowerCase()) === -1) { return false; }
            }
            return true;
        }

        /**
         * @description
         *  CriteriaV2 resolution. Returns the AllowedValues of the FIRST rule whose dependent
         *  conditions are all satisfied, or [] when no rule matches ("allow nothing" — strict).
         *
         * @param {array} rules               : parsed CriteriaV2 (array of rule objects)
         * @param {function} getDependentValue: fn(depFieldSystemName) -> current raw value
         * @returns {array}                   : allowed values for the matching rule, or [] if none matches
         */
        function getCriteriaV2AllowedValues(rules, getDependentValue) {
            if (!angular.isArray(rules)) { return []; }
            for (var i = 0; i < rules.length; i++) {
                if (matchCriteriaV2Rule(rules[i], getDependentValue)) {
                    return (rules[i].AllowedValues || []).slice();
                }
            }
            return []; // no rule matched -> nothing allowed
        }

        /**
         * @description
         *  OLD-format criteria resolution (nested map), mirroring the legacy getConditionalVettingList:
         *  candidate allowed values are the criteria keys; a key is included when every dependent
         *  condition it lists is satisfied by the record. Falls back to fullAllowedValues when NO
         *  dependent value is present (legacy "noMatch" behavior). Used by the data-table grid, which
         *  has no inline OLD path of its own.
         *
         * @param {object} criteriaObj        : { "<AllowedValue>": { "<DepField>": ["depVal", ...] }, ... }
         * @param {array} fullAllowedValues    : fallback / candidate-validation list (strings or {value} objects)
         * @param {function} getDependentValue : fn(depFieldSystemName) -> current raw value
         * @returns {array}                    : filtered allowed values
         */
        function getOldCriteriaAllowedValues(criteriaObj, fullAllowedValues, getDependentValue) {
            var full = fullAllowedValues || [];
            var fullLower = full.map(function (v) {
                var raw = (v && typeof v === 'object') ? (v.value != null ? v.value : v) : v;
                return raw.toString().toLowerCase();
            });
            var validValues = [];
            var noMatch = true;
            Object.keys(criteriaObj || {}).forEach(function (key) {
                var item = criteriaObj[key];            // { depField: [depVals] }
                var depFields = Object.keys(item);
                var validCount = 0;
                depFields.forEach(function (depField) {
                    var actual = getDependentValue(depField);
                    if (actual !== null && actual !== undefined && actual.toString() !== '') {
                        noMatch = false;
                        var allowedDepLower = item[depField].map(function (v) { return v.toString().toLowerCase(); });
                        if (allowedDepLower.indexOf(actual.toString().toLowerCase()) !== -1) {
                            validCount++;
                        }
                    } else {
                        validCount++; // missing dependent value -> condition treated as satisfied (legacy)
                    }
                });
                if (depFields.length === validCount && fullLower.indexOf(key.toLowerCase()) !== -1) {
                    validValues.push(key);
                }
            });
            return noMatch ? full.slice() : validValues;
        }

        /**
         * @description
         *  Returns the unique list of dependent-attribute system names referenced across all
         *  CriteriaV2 rules (every rule key except 'AllowedValues'). Used to wire up the
         *  dependent-attribute / criteria maps in the dialog controllers.
         *
         * @param {array} rules : parsed CriteriaV2 (array of rule objects)
         * @returns {array}     : unique dependent field system names
         */
        function getCriteriaV2DependentFields(rules) {
            var deps = [];
            if (!angular.isArray(rules)) { return deps; }
            rules.forEach(function (rule) {
                for (var dep in rule) {
                    if (rule.hasOwnProperty(dep) && dep !== 'AllowedValues' && deps.indexOf(dep) === -1) {
                        deps.push(dep);
                    }
                }
            });
            return deps;
        }

        /**
         * @description
         *  Normalizes a stored ColorCriteria (color palette) value into a list of criteria groups.
         *  A palette may hold several criteria: they are OR'ed with each other, while the conditions
         *  inside one criteria are AND'ed. Both shapes are accepted so palettes saved before the
         *  multiple-criteria support keep working:
         *      LEGACY  {"Division": "Mens", "Season": "SS26"}            -> one group
         *      CURRENT [{"Division": "Mens"}, {"Division": "Kids"}]      -> one group per entry
         *  Every condition value is returned as an array, so a single value and a list of values
         *  (any of which may match) are evaluated the same way downstream.
         *
         * @param {object|array|string} raw : stored criteria (object, array, or the JSON string of either)
         * @returns {array|null}            : [ {AttributeSystemName: [value, ...]}, ... ]
         *                                    an empty array means "no criteria" (matches every record);
         *                                    null means the criteria cannot be evaluated (invalid JSON
         *                                    or an unexpected shape) and the record is left out, which
         *                                    is how such data has always been treated
         */
        function normalizeColorCriteria(raw) {
            var parsed = raw;

            if (angular.isString(parsed)) {
                if (parsed.trim() === '') { return []; }
                parsed = isValidJSON(parsed);
                if (parsed === false) {
                    $log.warn('Color criteria : Invalid JSON format');
                    return null;
                }
            }

            if (parsed === null || angular.isUndefined(parsed)) { return []; }

            var rawGroups = angular.isArray(parsed) ? parsed : [parsed];
            if (rawGroups.length === 0) { return []; }

            var groups = [];
            angular.forEach(rawGroups, function (rawGroup) {
                if (!angular.isObject(rawGroup) || angular.isArray(rawGroup)) { return; }
                var group = {};
                for (var attribute in rawGroup) {
                    if (rawGroup.hasOwnProperty(attribute)) {
                        group[attribute] = toCriteriaValueList(rawGroup[attribute]);
                    }
                }
                groups.push(group);
            });

            if (groups.length === 0) {
                $log.warn('Color criteria : Unexpected format');
                return null;
            }

            return groups;
        }

        /**
         * @description
         *  Evaluates normalized criteria groups against a record. A group matches when EVERY
         *  condition in it matches (AND); the criteria matches when ANY group matches (OR).
         *  Values are compared as case-insensitive strings, mirroring the comparison the color
         *  filtering has always used. A record value that is null, undefined or empty never
         *  matches (and never throws, so a color is not silently dropped because of it).
         *
         *  Criteria that could not be normalized (null) never match.
         *
         * @param {array} groups      : output of normalizeColorCriteria
         * @param {function} getValue : fn(attributeSystemName) -> current raw value on the record
         * @returns {object}          : {
         *                                isMatch          : boolean,
         *                                matchedAttributes: attribute system names satisfied by the
         *                                                   matching group (used to flag the fields
         *                                                   the color selection depends on)
         *                              }
         */
        function matchesColorCriteria(groups, getValue) {
            if (!angular.isArray(groups)) {
                return { isMatch: false, matchedAttributes: [] };
            }
            if (groups.length === 0) {
                return { isMatch: true, matchedAttributes: [] };
            }

            for (var i = 0; i < groups.length; i++) {
                var group = groups[i];
                var attributes = Object.keys(group);
                var matched = [];
                var isGroupMatch = true;

                for (var j = 0; j < attributes.length; j++) {
                    if (matchesCriteriaCondition(group[attributes[j]], getValue(attributes[j]))) {
                        matched.push(attributes[j]);
                    } else {
                        isGroupMatch = false;
                        break;
                    }
                }

                if (isGroupMatch) {
                    return { isMatch: true, matchedAttributes: matched };
                }
            }

            return { isMatch: false, matchedAttributes: [] };
        }

        /**
         * @description
         *  Unique attribute system names referenced across all criteria groups. A change to any of
         *  them can change which colors are valid, so this is the set worth watching in a form.
         *
         * @param {array} groups : output of normalizeColorCriteria
         * @returns {array}      : unique attribute system names
         */
        function getColorCriteriaAttributes(groups) {
            var attributes = [];
            if (!angular.isArray(groups)) { return attributes; }
            angular.forEach(groups, function (group) {
                for (var attribute in group) {
                    if (group.hasOwnProperty(attribute) && attributes.indexOf(attribute) === -1) {
                        attributes.push(attribute);
                    }
                }
            });
            return attributes;
        }

        // Coerce a stored condition value into a list of candidate values. null/undefined entries are
        // dropped: an attribute left without any value cannot be satisfied, which keeps the record out
        // of the results rather than letting the condition pass silently.
        function toCriteriaValueList(value) {
            var list = angular.isArray(value) ? value : [value];
            var values = [];
            angular.forEach(list, function (item) {
                if (item !== null && angular.isDefined(item)) {
                    values.push(item);
                }
            });
            return values;
        }

        /**
         * @description
         *  One condition of a criteria. A multi-value attribute carries several values at once - an array
         *  while a form is editing it, or the '|' delimited string it is stored and imported as - on the
         *  record as well as in the criteria, so both sides are read as lists and the condition holds when
         *  ANY of the record's values is one of the allowed values. Values are compared trimmed and
         *  case-insensitive.
         *
         * @param {array} allowedValues : the condition's values, as normalizeColorCriteria produced them
         * @param {*} actualValue       : the record's value for that attribute
         * @returns {boolean}
         */
        function matchesCriteriaCondition(allowedValues, actualValue) {
            var allowed = toComparableValueList(allowedValues);
            var actual = toComparableValueList(actualValue);
            if (allowed.length === 0 || actual.length === 0) { return false; }

            for (var i = 0; i < allowed.length; i++) {
                if (actual.indexOf(allowed[i]) !== -1) { return true; }
            }
            return false;
        }

        // Flatten a value into the list of values it carries, ready to compare: '|' is the separator
        // changeAttributeType assigns to every multi-value attribute, so a delimited string is read as the
        // list it represents. Blank entries are dropped, the rest trimmed and lower-cased.
        function toComparableValueList(value) {
            var items = angular.isArray(value) ? value : [value];
            var values = [];
            angular.forEach(items, function (item) {
                if (item === null || angular.isUndefined(item)) { return; }
                var text = item.toString();
                var parts = text.indexOf('|') === -1 ? [text] : text.split('|');
                angular.forEach(parts, function (part) {
                    var comparable = part.trim().toLowerCase();
                    if (comparable !== '') { values.push(comparable); }
                });
            });
            return values;
        }

	}
})();
(function() {
    'use strict';

    angular
        .module('fuse')
        .factory('treeFactory', treeFactory);

    /* @ngInject */
    function treeFactory(api, utility) {

        var service = {
            getUnUtilizedCatalogAttributes  : getUnUtilizedCatalogAttributes,
            isTreeAttributeDirty            : isTreeAttributeDirty,
            buildTreeNodes                  : buildTreeNodes,
            buildTreeProperties             : buildTreeProperties,
            getSameLevelNodes               : getSameLevelNodes
        };

        return service;

        //Service method implementation


        /**
         * will return list of active catalog attributres which are not utilized in catalog tree
         * @param activeCatalogAttributes: active catalog attributes list
         * @param treeAttributes: list of catalog attributes which are utlized for catalog tree
         * @return : list of active catalog attributres which are not utilized in catalog tree
         */
        function getUnUtilizedCatalogAttributes(activeCatalogAttributes, treeAttributes) {
            angular.forEach(treeAttributes, function(treeAttribute) {
                var utilizedCatalogAttribute = utility.filterObject(activeCatalogAttributes, {Attributeid: treeAttribute.Attributeid}, true)[0];
                if(angular.isDefined(utilizedCatalogAttribute)) {
                    activeCatalogAttributes.splice(activeCatalogAttributes.indexOf(utilizedCatalogAttribute), 1);
                }
            });
            return activeCatalogAttributes;
        }


        /**
         * Checks if there is a change in catalog tree definition (order chnages or removed any utilized attribute)
         * @param treeAttributes: list of attributes in catalog tree
         * @param pristineTreeAttributes: pristine list of attributes in catalog tree before any drag and drop operation
         * @returns {boolean} : true if identify a new attribute is added
         */
        function isTreeAttributeDirty(pristineActiveTreeAttributes, treeAttributes) {
            //if any item added or removed
            if(pristineActiveTreeAttributes.length !== treeAttributes.length) {
                return true;
            }
            for(var index = 0, len = pristineActiveTreeAttributes.length; index < len; index++) {
                //if order has been changed
                if(pristineActiveTreeAttributes[index].Attributeid !== treeAttributes[index].Attributeid) {
                    return true;
                }
            }
            return false;
        }

        /**
         * Will create list of nested node needed by ui.tree directive to be displayed in UI
         * @param treeDefinition: list of attributes of article with their levels in tree structure
         * @param articles: list of active catalog articles
         * @param treeNodeProperties: list of sortOrder and branches which use to define the initial state of tree
         * @param multiValueAttributeSystemNames: object with multi value attribute system names present in the tree
         */
        function buildTreeNodes(treeDefinition, articles, treeNodeProperties, multiValueAttributeSystemNames) {
            var sep = ',';
            var isMultiValueAttributePresent = (!utility.isObjectEmpty(multiValueAttributeSystemNames)) ? true : false;

            //Sort the Tree Definition array by Level
            treeDefinition = utility.orderBy(treeDefinition, 'Level', false);
            var sortArticlePredicates = [];
            //Create an array of the Tree attributes to be used for sorting the articles
            angular.forEach(treeDefinition, function(item) {
                sortArticlePredicates.push(item.AttributeSystemName);
            });

            //Sort the articles by the Tree attributes
            articles = utility.orderBy(articles, sortArticlePredicates, false);


            //Build the tree
            var i=0;
            var tree = [ { Name:'Root', title: 'Root', nodes:[], totalArticles: 0, Status: 1, ancestorDisabledStatus: 1, type: 'folder' }];
            do {
                var treeNode = tree[tree.length-1]; //Point treeNode to last node of tree
                var branch = '';
                // TODO - if there is no value set for any none mandetory property which are part of tree defination value of articles[i][sortArticlePredicates[j]] will be null
                // and nothing in catalog tree will be visible as lable and branch
                for (var j=0; j<sortArticlePredicates.length; j++) {
                    if (branch === '') {
                        branch = articles[i][sortArticlePredicates[j]];
                        var branchFilterPredicate = {};
                    }
                    else {
                        branch += sep + articles[i][sortArticlePredicates[j]];
                    }
                    branchFilterPredicate[sortArticlePredicates[j]] = articles[i][sortArticlePredicates[j]];
                    treeNode.totalArticles++;

                    if (i==0 || articles[i][sortArticlePredicates[j]] != articles[i-1][sortArticlePredicates[j]]) {
                        //New branch detected
                        //Create the new branch and all it's children (remaining tree levels)
                        do {
                            //Check if the sort order exists on the server for the current branch
                            var res = utility.filterObject(treeNodeProperties, { TreeNode: branch }, true);
                            var newNode = {
                                Name: articles[i][sortArticlePredicates[j]],
                                title: articles[i][sortArticlePredicates[j]],
                                nodes: [],
                                branch: branch,
                                branchFilterPredicate : angular.copy(branchFilterPredicate),
                                sortOrder: 0,
                                totalArticles: 1,
                                Status: 1,
                                ancestorDisabledStatus: 1,
                                field: sortArticlePredicates[j],
                                type: 'folder'
                            };
                            if (res && res.length>0) {
                                newNode.sortOrder = res[0].SortOrder;
                            }
                            treeNode.nodes.push(newNode);

                            treeNode = treeNode.nodes[treeNode.nodes.length-1]; //Moving the tree pointer to the last created node
                            j++; //j will be increased until it reaches total Tree Levels
                            branch += sep + articles[i][sortArticlePredicates[j]];
                            branchFilterPredicate[sortArticlePredicates[j]] = articles[i][sortArticlePredicates[j]];
                        } while (j<sortArticlePredicates.length);
                    }
                    treeNode = treeNode.nodes[treeNode.nodes.length-1];
                }
                if (treeNode) {
                    treeNode.totalArticles++;
                }

                i++;
            } while (i<articles.length);


            //Sort the tree
            if(isMultiValueAttributePresent) {
                var transformedTree = transformTreeNodes(tree[0], multiValueAttributeSystemNames);
                tree[0].nodes = sortNode(transformedTree);
            } else {
                tree[0].nodes = sortNode(tree[0]);
            }
            return tree;
        }

        function sortNode(node) {
            var newNodes;

            if (angular.isDefined(node) && angular.isDefined(node.nodes) && angular.isArray(node.nodes)) {
                newNodes = utility.orderBy(node.nodes, 'sortOrder');
                angular.forEach(newNodes, function(itm) {
                    itm.nodes = sortNode(itm);
                });
                return newNodes;
            } else {
                return [];
            }
        }

        /**
         * Will create catalog tree request objects to save state of tree (SortOrder and Branches)
         * @param treeStructure: list of nested nodes which defines ui.tree structure
         */
        function buildTreeProperties(treeStructure, isChild) {
            var result = [];

            for (var i=0; i< treeStructure.length; i++) {
                // assign sortorder as the order of child nodes
                if(angular.isDefined(isChild)) {
                    treeStructure[i].sortOrder = i;
                }
                result.push({
                    TreeNode: treeStructure[i].branch,
                    SortOrder: treeStructure[i].sortOrder
                });
                if (treeStructure[i].nodes && treeStructure[i].nodes.length > 0) {
                    var res = buildTreeProperties(treeStructure[i].nodes, 'child');
                    for(var index = 0, len = res.length; index < len; index++) {
                        result.push(res[index]);
                    }
                }
            }
            return result;
        }

        // Traversing through the tree and spliting multi values into same level nodes
        function transformTreeNodes(tree, multiValueAttributes) {
            var result = [];
            if(tree.nodes.length > 0) {
                var nameIndexes = {};
                angular.forEach(tree.nodes, function(node) {
                    var treeNodes = [];
                    if(multiValueAttributes[node.field] && node.Name !== null && node.Name !== '') {
                        var multiValues = node.Name;
                        angular.forEach(multiValues, function(value) {
                            if(nameIndexes[value]) {
                                var existingNode = utility.filterObject(result, {Name: value}, true)[0];
                                angular.forEach(node.nodes, function(childNode) {
                                    angular.forEach(existingNode.nodes, function(existingNode) {
                                        if(childNode.Name.includes(existingNode.nodes.Name)) {
                                            existingNode.nodes = existingNode.nodes.concat(childNode);
                                        }
                                    })
                                });
                                nameIndexes[value] = true;
                            } else {
                                var nodeCopy = angular.copy(node);
                                nodeCopy.Name = value;
                                nodeCopy.title = value;
                                nameIndexes[value] = true;
                                treeNodes.push(nodeCopy);
                            }
                        })
                    } else {
                        treeNodes.push(node);
                    }
                    result= result.concat(treeNodes);
                    if(node.nodes.length > 0) {
                        transformTreeNodes(node, multiValueAttributes);
                    }
                });
                var nameIndexes = undefined;
            }
            tree.nodes = [];
            tree.nodes = result;
            return tree;
        }

        function getSameLevelNodes(record, currentTreeNodeProperties) {
            var path = record.Path.replace(/\\/g, ',');
            path = path.slice(0, path.lastIndexOf(',') + 1);
            var sameLevelNodes = [];
            if(path !== '') {
                sameLevelNodes = utility.filterObject(currentTreeNodeProperties, { TreeNode: path });
            } else if(path === '') {
                angular.forEach(currentTreeNodeProperties, function(treeNodeProperty) {
                    if(treeNodeProperty.TreeNode.indexOf(',') === -1) {
                        sameLevelNodes.push(treeNodeProperty);
                    }
                });
            }
            return sameLevelNodes;
        }
    }
})();
(function() {
'use strict';

    angular
        .module('fuse')
        .factory('stateHistoryTracker', stateHistoryTracker);

    stateHistoryTracker.$inject = ['$state'];
    function stateHistoryTracker($state) {
        var service = {
            getHistory:getHistory,
            add:addItem,
            goBack:goBack,
            historyExists:historyExists
        };
        var history = [];
        var isBack = false;

        return service;

        ////////////////
        function getHistory() {
            return history;
        }

        function addItem(state, params) {
            if (state && angular.isDefined(state) && angular.isDefined(state.name) && state.name.length > 0 && state.name.indexOf('app.auth_') !== 0 ) {
                if (isBack) {
                    isBack = false;
                }
                else {
                    history.unshift({ name: state.name, params: params});

                    if (history.length > 10) {
                        history.splice(9, history.length-10);
                    }
                }
            }
            else if(state && angular.isDefined(state) && angular.isDefined(state.name) && state.name.length > 0 && state.name.indexOf('app.auth_') === 0 && historyExists()) {
                history.shift();// if navigatingfrom any of "auth states" (lock and login) remove most recent state from history since it will be by default navigated to that state using lastState in localstorage
            }
        }

        function goBack() {
            if (historyExists()) {
                isBack = true;
                var newState = history.shift();
                $state.go(newState.name, newState.params);
            }
        }

        function historyExists() {
            return (history.length > 0);
        }
    }
})();
(function() {
    'use strict';

	angular
		.module('fuse')
		.factory('settingsFactory', settingsFactory);

	/* @ngInject */
	function settingsFactory(api, $rootScope, $timeout, $localStorage, $log, $q, catalogFactory, utility) {
        var currentUserId = null;
        var settings = {
            persistedColumns: {
                listView: {},
                detailsView: {}
            }
        };
        var SAVE_SETTINGS_INTERVAL_MILI = 5000; // number of mili seconds it will take to store gerneral setting changes into database
        var SAVE_COLUMNS_INTERVAL_MILI = 5000; // number of mili seconds it will take to store default columns chnages into database
        var timeoutPromise;
        var catalogsQueueSize = 5;

		var service = {
            initializeSettingsFactory               : initializeSettingsFactory,
            persistListViewLayout                   : persistListViewLayout,
            applyPersistedListViewLayout            : applyPersistedListViewLayout,
            updatePreferredLanguage                 : updatePreferredLanguage,
            updateAppLockerSettings                 : updateAppLockerSettings,
            updateViewFilters                       : updateViewFilters,
            updateViewColumns                       : updateViewColumns,
            saveUserCharts                          : saveUserCharts,
            resetModulesLayout                      : resetModulesLayout,
            getSettings                             : getSettings
		};

		return service;

        //Service method implementation

        /**
         * @description
         * initialize factory's settings object
         * @param {object} appSettings: settings retrieved from server
         */
        function initializeSettingsFactory(appSettings, userId) {
            if(appSettings !== "") {
                settings = Object.assign(settings, angular.fromJson(appSettings));
            }
            currentUserId = userId;
        }

        /**
         * @description
         * being called when user changes table column layout and to persist the columns layout in database
         * @param {object} model: model object
         * @param {boolean} isResizing: identify if the call is result of column resizing
         */
        function persistListViewLayout(model, isResizing) {
            if(angular.isDefined(model.modelPath)) {
                // persist columns based on catalog code
                if(model.isCatalogSpecificModel) {
                    var isIdenticalLayout = persistColumnsAndMannageQueue(model, isResizing);
                    if(isIdenticalLayout === 1) {
                        return;
                    }
                }

                else {
                    //check if previous layout is same exit and prevent http request timeout
                    if(!isResizing && angular.isDefined(settings.persistedColumns.listView[model.modelPath])
                     && utility.isIdenticalArrays(Object.keys(settings.persistedColumns.listView[model.modelPath]), model.views.mainList.columns)) {
                        return;
                    }

                    if(!utility.isObjectEmpty(model.views.mainList.columnsWidthRatioMap)) {
                        var orderedColumnRation = {};
                        // re-order columnsWidthRatioMap based on the order of columns in `model.views.mainList.columns`
                        angular.forEach(model.views.mainList.columns, function(orderedColumnName) {
                            // to maintain the order of columns which is bonded to `model.views.mainList.columns`
                            orderedColumnRation[orderedColumnName] = model.views.mainList.columnsWidthRatioMap[orderedColumnName];
                        });
                        settings.persistedColumns.listView[model.modelPath] = orderedColumnRation;
                    }
                    else {//on first call form update cols columnsWidthRatioMap wont be available
                        //in this case system will automatically calculate the column width
                        settings.persistedColumns.listView[model.modelPath] = angular.copy(model.views.mainList.columns);
                    }

                    // Add totalTableColumnWidth to the persisted settings if it exists in the model
                    if (angular.isDefined(model.totalTableColumnWidth)) {
                        settings.persistedColumns.listView[model.modelPath].totalTableColumnWidth = model.totalTableColumnWidth;
                    }
                }

                $timeout.cancel(timeoutPromise);
                timeoutPromise = $timeout(saveSettings, SAVE_COLUMNS_INTERVAL_MILI);
            }
            else {
                $log.warn('Unable to save columns, modelPath for this module is undefined');
            }
        }

        /**
         * @description
         * this method will retrieve persisted default colums for model if existed and apply that on model
         * @param {object} model: model object
         */
        function applyPersistedListViewLayout(model) {
            var deferred = $q.defer();
            if(angular.isDefined(model.modelPath)) {

                // create model defaultColumns to preserve the default column layout
                if(angular.isUndefined(model.views.mainList.defaultColumns)) {
                    model.views.mainList.defaultColumns = angular.copy(model.views.mainList.columns);
                }
                var columns = model.views.mainList.defaultColumns,
                    columnsWidthRatioMap = undefined,
                    persistedDataExists = false;
                if(model.isCatalogSpecificModel) {
                    var activeCatalogCode = catalogFactory.getActiveCatalog().CatalogCode;
                    persistedDataExists = (angular.isDefined(settings.persistedColumns.listView[model.modelPath])
                        && angular.isDefined(settings.persistedColumns.listView[model.modelPath][activeCatalogCode])
                        && !angular.isArray(settings.persistedColumns.listView[model.modelPath][activeCatalogCode]))// since change the data structure to have them in object rather than array
                        ? true : false;
                    if(persistedDataExists) {
                        columns = Object.keys(settings.persistedColumns.listView[model.modelPath][activeCatalogCode]);
                        columnsWidthRatioMap = settings.persistedColumns.listView[model.modelPath][activeCatalogCode];
                    }
                }
                else {
                    persistedDataExists = angular.isDefined(settings.persistedColumns.listView[model.modelPath])
                    && !angular.isArray(settings.persistedColumns.listView[model.modelPath])// since change the data structure to have them in object rather than array
                    ? true : false;
                    if(persistedDataExists) {
                        columns = Object.keys(settings.persistedColumns.listView[model.modelPath]);
                        columnsWidthRatioMap = settings.persistedColumns.listView[model.modelPath];
                    }
                }
                model.views.mainList.columns = angular.copy(columns);
                model.views.mainList.columnsWidthRatioMap = columnsWidthRatioMap;
            }
            else {
                var errMsg = 'unable to retrieve columns, modelPath for this module is undefined';
                deferred.reject(errMsg);
                $log.warn(errMsg);
            }
            deferred.resolve(model);
            return deferred.promise;
        }

        function updatePreferredLanguage(languageCode) {
            settings.preferredLanguage = languageCode;
            $timeout.cancel(timeoutPromise);
            timeoutPromise = $timeout(saveSettings, SAVE_SETTINGS_INTERVAL_MILI);
        }

        function updateAppLockerSettings(isEnabled, intervalTime) {
            settings.autoLock = isEnabled;
            settings.autoLockInterval = intervalTime;
            $timeout.cancel(timeoutPromise);
            timeoutPromise = $timeout(saveSettings, SAVE_SETTINGS_INTERVAL_MILI);
        }

        function updateViewFilters(viewFilters) {
            settings.viewFilters = viewFilters;
            $timeout.cancel(timeoutPromise);
            saveSettings();
        }

        function updateViewColumns(viewColumns){
            settings.viewColumns = viewColumns;
            $timeout.cancel(timeoutPromise);
            saveSettings();
        }

        function saveUserCharts(userChartsMeta) {
            settings.charts = userChartsMeta;
            $timeout.cancel(timeoutPromise);
            saveSettings();
        }

        /**
         * @description
         * this method will reset the preserve module's layout, if view is not specified it will
         * reset both views layout
         * @param {String} view: view name
         */
        function resetModulesLayout(view) {
            if(angular.isUndefined(view)) {
                settings.persistedColumns.listView = {};
                settings.persistedColumns.detailsView = {};
            }
            else if(view.toUpperCase() === 'LISTVIEW') {
                settings.persistedColumns.listView = {};
            }
            else if(view.toUpperCase() === 'DETAILSVIEW') {
                settings.persistedColumns.detailsView = {};
            }
            $timeout.cancel(timeoutPromise);
            timeoutPromise = $timeout(saveSettings, SAVE_SETTINGS_INTERVAL_MILI);
        }

        function getSettings(path) {
            return settings;
        }


        //helper methods

        function saveSettings(showMessage) {
            $timeout.cancel(timeoutPromise); // to cancel timeout promise if saveSettings being called explicitly
            var userProfile = {}
            //since update profile does not allow updating profile partially
            for (var key in $localStorage.profileInformation) { // shallow copy profileInformation
                userProfile[key] = $localStorage.profileInformation[key];
            }
            delete userProfile.Email;
            userProfile.Settings = angular.toJson(settings, 0);

            //block the update of settings information when another user is logged in the same browser window
            if (currentUserId === $localStorage.UserId) {
                api.webPut(api.baseUrl + '/profile', userProfile).then(function () {
                    if (showMessage) {
                        //show toast
                    }
                    $localStorage.profileInformation = userProfile;
                });
            } else {
                $log.warn('Settings will not be save as other user is logged in ');
            }
        }

        /**
         * @description
         * this method being called by persistListViewLayout when it needs to persist columns per catalog
         * this method will create object for modelPath which contain per catalog columns list, an array(queue) to track last 'catalogsQueueSize' number
         * of module's columns that modelPath needs to have in settings (simulate circular queue functionality) and queueRearIndex is an integer indicating
         * rear index of queue where data last updated on
         * this method make sure there wont be more than 'catalogsQueueSize' number of column list per catalogSpecific module track by virtual queue
         * @param {object} model: model object
         * @param {boolean} isResizing: identify if the call is effect of column resizing
         * @return {integer} returns 1 if column layout is same with the previous layout
         */
        function persistColumnsAndMannageQueue(model, isResizing) {
            var rearIndex = -1;
            var activeCatalog = catalogFactory.getActiveCatalog();
            if(angular.isDefined(activeCatalog) && angular.isDefined(activeCatalog.CatalogCode)) {

                //initialize columns object for model path, queue and rearIndex of queue
                if(angular.isUndefined(settings.persistedColumns.listView[model.modelPath])) {// if first entry for this module
                    settings.persistedColumns.listView[model.modelPath] = {};
                    settings.persistedColumns.listView[model.modelPath].queue = [];
                    rearIndex = 0;
                }
                else { //track queue rear index
                    rearIndex = settings.persistedColumns.listView[model.modelPath].queueRearIndex + 1;
                    if(rearIndex > (catalogsQueueSize-1)) {
                        rearIndex = 0;
                    }
                }
                //check if previous layout is same exit and prevent http request timeout
                if(!isResizing && angular.isDefined(settings.persistedColumns.listView[model.modelPath][activeCatalog.CatalogCode])
                 && utility.isIdenticalArrays(Object.keys(settings.persistedColumns.listView[model.modelPath][activeCatalog.CatalogCode]), model.views.mainList.columns)) {
                    return 1;
                }

                var catalogIndex = settings.persistedColumns.listView[model.modelPath].queue.indexOf(activeCatalog.CatalogCode);

                //if eantry for catalogCode does not exist remove the persisted columns of catalogCode at rearIndex form settings(if any) and insert the new catalogCode entry to queue
                if(catalogIndex === -1) {
                    var catalogCodeAtRearIndex = settings.persistedColumns.listView[model.modelPath].queue[rearIndex];
                    if(angular.isDefined(catalogCodeAtRearIndex)) {// if queue is full and does not have empty cell, this condition will be true
                        delete settings.persistedColumns.listView[model.modelPath][catalogCodeAtRearIndex]; // remove persisted columns from settings
                    }
                    settings.persistedColumns.listView[model.modelPath].queue.splice(rearIndex, 1, activeCatalog.CatalogCode);// replace (or push) catalogCode at rear index
                    settings.persistedColumns.listView[model.modelPath].queueRearIndex = rearIndex;// update rear index in settings if push new item to queue
                }

                //if eantry for catalogCode already exist in queue bring it to rear of queue
                else {
                    settings.persistedColumns.listView[model.modelPath].queue.splice(catalogIndex, 1);
                    settings.persistedColumns.listView[model.modelPath].queue.push(activeCatalog.CatalogCode);
                }

                if(!utility.isObjectEmpty(model.views.mainList.columnsWidthRatioMap)) {
                    var orderedColumnRation = {};
                    // re-order columnsWidthRatioMap based on the order of columns in `model.views.mainList.columns`
                    angular.forEach(model.views.mainList.columns, function(orderedColumnName) {
                        // to maintain the order of columns which is bonded to `model.views.mainList.columns`
                        orderedColumnRation[orderedColumnName] = model.views.mainList.columnsWidthRatioMap[orderedColumnName];
                    });
                    settings.persistedColumns.listView[model.modelPath][activeCatalog.CatalogCode] = orderedColumnRation;
                }
                else {//on first call form update cols columnsWidthRatioMap wont be available
                    //in this case system will automatically calculate the column width
                    settings.persistedColumns.listView[model.modelPath][activeCatalog.CatalogCode] = angular.copy(model.views.mainList.columns);
                }

                // Add totalTableColumnWidth to the persisted settings if it exists in the model
                if (angular.isDefined(model.totalTableColumnWidth)) {
                    settings.persistedColumns.listView[model.modelPath][activeCatalog.CatalogCode].totalTableColumnWidth = model.totalTableColumnWidth;
                }
            }
            else {
                $log.warn('Settings Factory- methodName() Could not found any active catalog');
            }
        }

	}
})();
(function() {
'use strict';

	angular
		.module('fuse')
		.factory('SecurityFactory', SecurityFactory);

	SecurityFactory.$inject = ['utility', '$localStorage', 'msNavigationService', '$filter', '$rootScope'];
	function SecurityFactory(utility, $localStorage, msNavigationService, $filter, $rootScope) {

		//data
        var isSecured = false;
        var privileges = [];
        var factoryState = {
            isPrivilegeSetUp : false
        };


		//Methods
		var service = {
            removeUnauthorizedNav : removeUnauthorizedNav,
            isAuthorized          :	isAuthorized,
            factoryState          : factoryState,
            setPrivileges         : setPrivileges
		};

		return service;


		//Implementation

		/**
		 *@description:
         * Check if user is authorized against his/her role privileges,
         * this method is lenient version and will grant access if accessPrivileges and authorizeAccountTypes of accessInfo is undefined or
         * either of accessPrivilege in accessPrivileges list matches any privilege in SecurityFactory's privileges list
         *@param {Object} accessInfo : an object containing authorizeAccountTypes and accessPrivileges
            accessPrivileges: access privilege or list of access privileges associated with certain actions or routes or menu items
            authorizeAccountTypes: account type or list of account types that will allow the access of action to module for specified account types
         *@returns {Boolean} true if user have permission false if he/she is not authorized
		 */
		function isAuthorized(accessInfo) {
            var hasPrivilege = false;
            if(angular.isDefined(accessInfo) && (angular.isDefined(accessInfo.authorizeAccountTypes) || angular.isDefined(accessInfo.accessPrivileges))) {
                // if authorizeAccountTypes is set but the user does not belong to the set account type do not grant access permission
                if(angular.isDefined(accessInfo.authorizeAccountTypes)) {
                    if(!angular.isArray(accessInfo.authorizeAccountTypes)) {
                        accessInfo.authorizeAccountTypes = utility.pushItemToArray(accessInfo.authorizeAccountTypes);
                    }
                    if(accessInfo.authorizeAccountTypes.indexOf($localStorage.account.accountType) === -1) {
                        return false;
                    }
                }
                if(angular.isDefined(accessInfo.accessPrivileges)) {
                    if(!angular.isArray(accessInfo.accessPrivileges)) {
                        accessInfo.accessPrivileges = utility.pushItemToArray(accessInfo.accessPrivileges);
                    }
                    for(var index = 0; index < accessInfo.accessPrivileges.length; index++) {
                        if(utility.filterObject(privileges, {RouteName : accessInfo.accessPrivileges[index]}, true).length > 0) {
                            hasPrivilege = true;
                            break;
                        }
                    }
                }
            }
            else { // when accessPrivileges not mentioned on any action or page - Need to refactor once we gonna make 2 isAuthorized method (isAuthorizedLenient and isAuthorizedStrict)
                hasPrivilege = true;
            }
            return hasPrivilege
		}

        /**
         * Removes unauthorized navigation items from navigation bar
         *
         * @param navObj        : Object which contains all the menu items
         */
        function removeUnauthorizedNav(isLinePlan) {
            var navObj =  msNavigationService.getNavigationObject();
            var predicate = {
                isAuthorized: true
            };
            if(isLinePlan) {
                predicate.visibleForLinePlan = true;
            }
            _setNavObjectsAuthority(navObj);
            msNavigationService.setFilteredNavigation($filter('filterTree')(navObj, predicate, true));
			$rootScope.$broadcast('updateFilteredNavigation');
        }

        function _setNavObjectsAuthority(navObj) {
            for (var i = 0; i < navObj.length; i++) {
                if (angular.isDefined(navObj[i].accessInfo)) {
                    if(!isAuthorized(navObj[i].accessInfo)){
                        navObj[i].isAuthorized = false;
                    } else {
                        navObj[i].isAuthorized = true;
                    }
                } else {
                    navObj[i].isAuthorized = true;
                }
                if (navObj[i].children.length > 0) {
                    _setNavObjectsAuthority(navObj[i].children);
                    if (navObj[i].group === true && utility.filterObject(navObj[i].children, {isAuthorized: false}).length === navObj[i].children.length)
                    {
                        navObj[i].isAuthorized = false;
                    }
                }
            }
            msNavigationService.setFilteredNavigation($filter('filterTree')(navObj, { isAuthorized: true} ));
			$rootScope.$broadcast('updateFilteredNavigation');
        }

        function setPrivileges(activeCatalogCode) {
            privileges = [];
            var generalPrivileges = [];
            var activeCatalogPrivileges = [];
            if (angular.isDefined($localStorage.profileInformation)) {
                angular.forEach($localStorage.profileInformation.Permissions, function (permission) {
                    if (!permission.hasOwnProperty('Catalogs') || (angular.isArray(permission.Catalogs) && permission.Catalogs.length === 0)) {
                        generalPrivileges.push(permission);
                    }
                    else if (angular.isDefined(permission.Catalogs)) {
                        if(angular.isArray(permission.Catalogs) && permission.Catalogs.indexOf(activeCatalogCode) !== -1) {
                            activeCatalogPrivileges.push(permission);
                        }
                        else {
                            generalPrivileges = $localStorage.profileInformation.Permissions;
                        }
                    }
                });
                privileges = generalPrivileges.concat(activeCatalogPrivileges);
                factoryState.isPrivilegeSetUp = true;
            }
            return privileges;
        }
	}
})();
(function() {
		'use strict';

	angular
		.module('fuse')
		.factory('renameArticleModelAndSegmentationLabels', renameArticleModelAndSegmentationLabels);

	/* @ngInject */
	function renameArticleModelAndSegmentationLabels($localStorage) {
		return {

			// required method do not remove
			setLocale: function () {
			},

			getInterpolationIdentifier: function () {
				return 'custom';
			},

			interpolate: function (string, params) {
				if(angular.isDefined($localStorage.articleLabelConfiguration) && $localStorage.articleLabelConfiguration !== '' && $localStorage.articleLabelConfiguration.length && string.toLowerCase().includes('article')) {
					string = replaceStringWithCase(string, 'article', $localStorage.articleLabelConfiguration);
				}
				if(angular.isDefined($localStorage.modelLabelConfiguration) && $localStorage.modelLabelConfiguration !== '' && $localStorage.modelLabelConfiguration.length && string.toLowerCase().includes('model')) {
					string = replaceStringWithCase(string, 'model', $localStorage.modelLabelConfiguration);
				}
				if(angular.isDefined($localStorage.segmentationLabelConfiguration) && $localStorage.segmentationLabelConfiguration !== '' && $localStorage.segmentationLabelConfiguration.length && string.toLowerCase().includes('segmentation')) {
					string = replaceStringWithCase(string, 'segmentation', $localStorage.segmentationLabelConfiguration);
				}

				// Handle translate-values (params) replacements
				if (params) {
					angular.forEach(params, function(value, key) {
							string = string.replace(new RegExp('{{' + key + '}}', 'g'), value);
					});
				}

				return string;
			}
		};

		/**
		 * @description replace the word in a string with keeping the case intact
		 * @param {string} string source string
		 * @param {string} pattern a value to replace in the source string
		 * @param {String} newString replace the pattern with this string
		 * @returns {String} string replacing the word
		 */
		function replaceStringWithCase(string, pattern, newString) {
			var rx = new RegExp(pattern, 'gi');
			var replacer = function (c, i) {
				return c.match(/[A-Z]/) ? newString[i] ? newString[i].toUpperCase() : '' : newString[i] ? newString[i] : '';
			};
			return string.replace(rx, function (oldString) {
				// if old string length is less than new string add dummy letters to make to equal
				if(pattern.length < newString.length) {
					var count = newString.length - pattern.length;
					// if the translated string is in all caps then add dumy letter in caps
					var dummyLetter = oldString === oldString.toUpperCase() ? 'S' : 's';
					for(var i = 0; i< count; i++) {
						oldString = oldString + dummyLetter;
					}
				}
				return oldString.replace(/./g, replacer);
			});
		}
	}
})();
(function() {
    'use strict';

	angular
		.module('fuse')
		.factory('mockFactory', mockFactory);

    /**
     * @description: this is a temporary service used to return mock data that can be used when we are hard coding values in controller
     */
	/* @ngInject */
	function mockFactory($resource) {

		var service = {
            getSupportedLanguages   : getLanguages,
            getUserStatusOptions    : getUserStatusOptions,
            getTempLogs             : getTempLogs,
            getQuickPanelData       : getQuickPanelData,
            getUIPrivilegesMap      : getUIPrivilegesMap,
            getSupportedImageSizes  : getSupportedImageSizes,
            getChangeManagementApproversEntity: getChangeManagementApproversEntity,
            getChartViewTypes       : getChartViewTypes,
            getFavoritesColors      : getFavoritesColors
		};

		return service;

        //Service method implementation

        function getLanguages() {
            var languages = {
                en: {
                    'title'      : 'English',
                    'translation': 'TOOLBAR.ENGLISH',
                    'code'       : 'en',
                    'flag'       : 'us'
                },
                // es: {
                //     'title'      : 'Spanish',
                //     'translation': 'TOOLBAR.SPANISH',
                //     'code'       : 'es',
                //     'flag'       : 'es'
                // },
                // tr: {
                //     'title'      : 'Turkish',
                //     'translation': 'TOOLBAR.TURKISH',
                //     'code'       : 'tr',
                //     'flag'       : 'tr'
                // }
            };

            return languages;
        }

        function getUserStatusOptions() {
            var userStatusOptions = [
                {
                    'title': 'Online',
                    'icon' : 'icon-checkbox-marked-circle',
                    'color': '#4CAF50'
                },
                {
                    'title': 'Away',
                    'icon' : 'icon-clock',
                    'color': '#FFC107'
                },
                {
                    'title': 'Do not Disturb',
                    'icon' : 'icon-minus-circle',
                    'color': '#F44336'
                },
                {
                    'title': 'Invisible',
                    'icon' : 'icon-checkbox-blank-circle-outline',
                    'color': '#BDBDBD'
                },
                {
                    'title': 'Offline',
                    'icon' : 'icon-checkbox-blank-circle-outline',
                    'color': '#616161'
                }
            ];
            return userStatusOptions;
        }

        function getTempLogs() {
            var logs= [
                {
                    actionType : {
                        displayName: "ACTIONS.GET_LIST",
                        icon: "icon-format-list-bulleted"
                    },
                    isBulk : false,
                    module : "accounts.buyers",
                    record : "",
                    state : {
                        name: "app.accounts_buyers",
                        params:{}
                    },
                    result : "OK",
                    resultMessage: "response.data",
                    date : "2016-01-25T14:30:51.210Z"
                },
                {
                    actionType : {
                        displayName: "ACTIONS.GET_LIST",
                        icon: "icon-format-list-bulleted"
                    },
                    isBulk : false,
                    module : "accounts.buyers",
                    record : "",
                    state : {
                        name: "app.accounts_buyers",
                        params:{}
                    },
                    result : "OK",
                    resultMessage: "response.data",
                    date : "2016-01-25T14:30:51.210Z"
                },
                {
                    actionType : {
                        displayName: "ACTIONS.GET_LIST",
                        icon: "icon-format-list-bulleted"
                    },
                    isBulk : false,
                    module : "accounts.buyers",
                    record : "",
                    state : {
                        name: "app.accounts_buyers",
                        params:{}
                    },
                    result : "OK",
                    resultMessage: "response.data",
                    date : "2016-01-25T14:30:51.210Z"
                },
                {
                    actionType : {
                        displayName: "ACTIONS.GET_LIST",
                        icon: "icon-format-list-bulleted"
                    },
                    isBulk : false,
                    module : "accounts.buyers",
                    record : "",
                    state : {
                        name: "app.accounts_buyers",
                        params:{}
                    },
                    result : "OK",
                    resultMessage: "response.data",
                    date : "2016-01-25T14:30:51.210Z"
                }
            ];
            return logs;
        }

        function getQuickPanelData() {
            var quickPanelData = {
                activities: $resource('app/data/quick-panel/activities.json'),
                contacts  : $resource('app/data/quick-panel/contacts.json'),
                events    : $resource('app/data/quick-panel/events.json'),
                notes     : $resource('app/data/quick-panel/notes.json')
            };
            return quickPanelData;
        }

        function getUIPrivilegesMap() {
            // map of key value pair, key will be UI privilege id pair with its respective API privilege id
            var map = {
                345: {name: 'UI - ImportArticles', APIPrivilegeName: 'UpdateCatalogBulkArticle', APIPrivilegeId: 158},
                346: {name: 'UI - ImportSizes', APIPrivilegeName: 'AssignSizeScaleBulk', APIPrivilegeId: 526},
                347: {name: 'UI - ImportImages', APIPrivilegeName: 'CreateCataLogBulkImages', APIPrivilegeId: 292},
                348: {name: 'UI - ImportCRDs', APIPrivilegeName: 'UpdateCatalogBulkArticlesCrds', APIPrivilegeId: 237},
                349: {name: 'UI - ImportPrices', APIPrivilegeName: 'UpdateCatalogBulkArticlePrices', APIPrivilegeId: 167},
                350: {name: 'UI_AllUsersList', APIPrivilegeName: 'GetUsersList', APIPrivilegeId: 255},
                378: {name: 'nav - organizations', APIPrivilegeName: 'GetOrganizationList', APIPrivilegeId: 353},
                379: {name: 'nav - buyers', APIPrivilegeName: 'GetBuyerAccountList', APIPrivilegeId: 51},
                380: {name: 'nav - sellers', APIPrivilegeName: 'GetSellerAccountList', APIPrivilegeId: 50},
                381: {name: 'nav - admin-users', APIPrivilegeName: 'GetTrasixUsersList', APIPrivilegeId: 7},
                382: {name: 'nav - catalogs', APIPrivilegeName: 'CatalogList', APIPrivilegeId: 130},
                383: {name: 'nav - notifications', APIPrivilegeName: 'GetAllNotification', APIPrivilegeId: 356},
                384: {name: 'nav - overview', APIPrivilegeName: 'GetCatalogActiveDeActiveRecordsStatics', APIPrivilegeId: 310},
                385: {name: 'nav - change-logs', APIPrivilegeName: 'GetCatalogChangeLogList', APIPrivilegeId: 344},
                386: {name: 'nav - linked-customers', APIPrivilegeName: 'GetCatalogLinkedSellerCustomers', APIPrivilegeId: 335},
                387: {name: 'nav - customers-segmentation', APIPrivilegeName: 'GetSellerCatalogBulkCustomerSegmentations', APIPrivilegeId: 300},
                388: {name: 'nav - articles', APIPrivilegeName: 'GetCatalogArticleList', APIPrivilegeId: 154},
                389: {name: 'nav - articles-replacement', APIPrivilegeName: 'GetCatalogArticleReplacementList', APIPrivilegeId: 340},
                390: {name: 'nav - article-segmentation', APIPrivilegeName: 'GetCatalogListArticleSegmentations', APIPrivilegeId: 275},
                391: {name: 'nav - sizes', APIPrivilegeName: 'GetListArticleSizes', APIPrivilegeId: 263},
                392: {name: 'nav - delivery-dates', APIPrivilegeName: 'GetCatalogListArticleCRDs', APIPrivilegeId: 262},
                393: {name: 'nav - prices', APIPrivilegeName: 'GetCatalogAllArticlePrices', APIPrivilegeId: 234},
                394: {name: 'nav - collections', APIPrivilegeName: 'GetAssortmentList', APIPrivilegeId: 118},
                395: {name: 'nav - catalog-tree', APIPrivilegeName: 'GetCatalogTreeNodes', APIPrivilegeId: 231},
                396: {name: 'nav - resources', APIPrivilegeName: 'GetCatalogResourceList', APIPrivilegeId: 147},
                397: {name: 'nav - images', APIPrivilegeName: 'GetCatalogAllArticleImagesList', APIPrivilegeId: 242},
                399: {name: 'nav - packages', APIPrivilegeName: 'GetCatalogDataUpdateList', APIPrivilegeId: 194},
                400: {name: 'nav - articles-without-delivery-date', APIPrivilegeName: 'GetArticleListWithMissingCrds', APIPrivilegeId: 110},
                401: {name: 'nav - articles-without-images', APIPrivilegeName: 'GetArticleListWithMissingImages', APIPrivilegeId: 109},
                402: {name: 'nav - articles-without-sizes', APIPrivilegeName: 'GetArticleListWithMissingSizes', APIPrivilegeId: 108},
                403: {name: 'nav - allocations', APIPrivilegeName: 'GetCatalogAllocations', APIPrivilegeId: 371},
                404: {name: 'nav - orders', APIPrivilegeName: 'GetOrderList', APIPrivilegeId: 214},
                405: {name: 'nav - consolidation-templates', APIPrivilegeName: 'GetOrderConsolidationTemplateList', APIPrivilegeId: 201},
                406: {name: 'nav - consolidations', APIPrivilegeName: 'GetOrderConsolidationList', APIPrivilegeId: 204},
                407: {name: 'nav - roles', APIPrivilegeName: 'GetAccountTypeRolesList', APIPrivilegeId: 21},
                408: {name: 'nav - jobs', APIPrivilegeName: 'GetJsonBackGroundJobList', APIPrivilegeId: 265},
                409: {name: 'nav - attributes', APIPrivilegeName: 'GetAttributeList', APIPrivilegeId: 82},
                410: {name: 'nav - attribute-groups', APIPrivilegeName: 'GetAttributeGroupList', APIPrivilegeId: 84},
                411: {name: 'nav - account-types', APIPrivilegeName: 'GetCompanyAccountTypes', APIPrivilegeId: 59},
                412: {name: 'nav - attribute-types', APIPrivilegeName: 'GetAttributeTypeList', APIPrivilegeId: 86},
                413: {name: 'nav - configurations', APIPrivilegeName: 'GetCatalogConfigurations', APIPrivilegeId: 113},
                414: {name: 'nav - consolidation-statuses', APIPrivilegeName: 'GetOrderConsolidationStatusList', APIPrivilegeId: 125},
                415: {name: 'nav - countries', APIPrivilegeName: 'GetCountryList', APIPrivilegeId: 128},
                416: {name: 'nav - currencies', APIPrivilegeName: 'GetCurrencyList', APIPrivilegeId: 94},
                417: {name: 'nav - data-source-types', APIPrivilegeName: 'GetDataSourceTypeList', APIPrivilegeId: 89},
                418: {name: 'nav - entity-types', APIPrivilegeName: 'GetCatalogEntityList', APIPrivilegeId: 186},
                419: {name: 'nav - resource-file-types', APIPrivilegeName: 'GetImagesResourcesFileTypeList', APIPrivilegeId: 134},
                420: {name: 'nav - file-types', APIPrivilegeName: 'GetFileTypes', APIPrivilegeId: 372},
                437: {name: 'nav - size-map', APIPrivilegeName: 'GetSizeMapList', APIPrivilegeId: 426},
                467: {name: 'nav - allocation-groups', APIPrivilegeName: 'GetAllocationGroupList', APIPrivilegeId: 466 },
                468: {name: 'nav - customer-allocations', APIPrivilegeName: 'GetAssignAllocationGroupsToCustomers', APIPrivilegeId: 469},
                474: {name: 'nav - linked-buyers', APIPrivilegeName: 'GetCatalogBuyerUsers', APIPrivilegeId:  473},
                481: {name: 'nav - forecasts', APIPrivilegeName: 'GetForecastList', APIPrivilegeId: 480},
                492: {name: 'nav - stock', APIPrivilegeName: 'GetStockList', APIPrivilegeId:  493},
                503: {name: 'nav - articles-with-dp-account', APIPrivilegeName: 'GetArticlesWithDPAccount', APIPrivilegeId: 504},
                507: {name: 'nav - privacy-policy', APIPrivilegeName: 'GetPrivacyPolicyList', APIPrivilegeId: 508},
                515: {name: 'nav - user-logs', APIPrivilegeName: 'GetUserLogs', APIPrivilegeId: 516},
                519: {name: 'nav - targets', APIPrivilegeName: 'GetTargetList', APIPrivilegeId: 522},
                528: {name: 'UI - ImportLinePlans', APIPrivilegeName: 'UpdateCatalogBulkArticle', APIPrivilegeId: 158},
                529: {name: 'UI - CreateLinePlan', APIPrivilegeName: ['CreateCatalogArticle', 'UpdateCatalogBulkArticle'], APIPrivilegeId: [273, 158]},
                531: {name: 'nav - block-articles', APIPrivilegeName: 'GetBlockedArticleList', APIPrivilegeId: 534},
                538: {name: 'nav - hangfire-dashboard', APIPrivilegeName: 'AllowHangfireDashboardAccess', APIPrivilegeId: 537},
                544: {name: 'nav - clients', APIPrivilegeName: 'GetClientList', APIPrivilegeId: 543},
                552: {name: 'nav - resource-types', APIPrivilegeName: 'GetResourceTypeList', APIPrivilegeId: 551},
                559: {name: 'nav - favorites', APIPrivilegeName: 'GetMyUserFavorites', APIPrivilegeId: 557},
                570: {name: 'nav - merch-boards', APIPrivilegeName: 'GetMyMerchSlides', APIPrivilegeId: 569},
                579: {name: 'nav - Catalog Customers Locations', APIPrivilegeName: 'GetAllActiveCustomersAllLocations', APIPrivilegeId: 576},
                599: {name: 'nav - order-adjustments', APIPrivilegeName: 'GetOrderAdjustments', APIPrivilegeId: 598},
                607: {name: 'nav_interface_users', APIPrivilegeName: 'GetInterfaceUserList', APIPrivilegeId: 610},
                636: {name: 'nav_articles_status', APIPrivilegeName: 'ArticlesStatusReport', APIPrivilegeId: 635},
                643: {name: 'nav_models', APIPrivilegeName: 'GetCatalogTrueModels', APIPrivilegeId: 2008},
                640: {name: 'nav_requests', APIPrivilegeName: 'GetRequests', APIPrivilegeId: 627},
                645: {name: 'nav_articles_prices_report', APIPrivilegeName: 'ArticlesPriceReport', APIPrivilegeId: 644},
                661: {name: 'nav_buyer_limits', APIPrivilegeName: 'GetBuyerLimits', APIPrivilegeId: 653},
                682: {name: 'nav_user_groups', APIPrivilegeName: 'GetAccountGroups', APIPrivilegeId: 679},
                685: {name: 'nav_data_containers', APIPrivilegeName: 'GetAllDataContainers', APIPrivilegeId: 587},
                735: {name: 'nav_article_change_logs', APIPrivilegeName: 'GetAllCatalogWatchedFilters', APIPrivilegeId: 728},
                753: {name: 'nav_orders_terms_conditions', APIPrivilegeName: 'GetListOrderTermsAndConditions', APIPrivilegeId: 749},
                790: {name: 'nav_buy_windows', APIPrivilegeName: 'GetBuyWindowsList', APIPrivilegeId: 788},
                797: {name: 'nav_shared_folders', APIPrivilegeName: 'GetSharingFolderList', APIPrivilegeId: 794},
                2007: {name: 'nav_seller_models', APIPrivilegeName: 'GetSellerModels', APIPrivilegeId: 2001},
                2038: {name: 'nav_article_states', APIPrivilegeName: 'GetArticleStatesList', APIPrivilegeId: 2033},
                2051: {name: 'nav_saved_views', APIPrivilegeName: 'GetAllSavedViews', APIPrivilegeId: 2056},
                848: {name: 'nav_sizecurves', APIPrivilegeName: 'GetSizeCurves', APIPrivilegeId: 845}
            };
            return map;
        }

        function getSupportedImageSizes() {
            var imageSizes = {
                small: {icon: 'icon-restore', width: '110', height: '132', margin: '2', imgWidth: '110', imgHeight:'110', size:'small', next: 'medium', previous: 'large'},
                medium: {icon: 'icon-restore', width: '160', height: '192', margin: '4', imgWidth: '160', imgHeight:'160', size:'medium', next: 'large', previous: 'small'},
                large: {icon: 'icon-restore', width: '210', height: '252', margin: '5', imgWidth: '210', imgHeight:'210', size:'large', next: 'small', previous: 'medium'}
            }
            return imageSizes;
        }

        function getChangeManagementApproversEntity() {
            var changeManagementApproversEntity = [
                {id: 2, value: 'Articles'},
                {id: 3, value: 'Crds'},
                {id: 4, value: 'Sizes'},
                {id: 5, value: 'Prices'},
                {id: 10, value: 'ArticleSegmentation'},
                {id: 22, value: 'AssignSizeScales'}
            ];
            return changeManagementApproversEntity;
        }

        function getChartViewTypes() {
            var types = [
                {id: 1, displayLabel: 'Count'},
                {id: 2, displayLabel: 'Sum'}
            ];
            return types;
        }

        function getFavoritesColors() {
            var colors = ['#32C2E0', '#EB5A46', '#2779BF', '#61BD4F', '#51E898', '#FAAB49', '#FD80CE', '#C377E0', '#F2D600'];
            return colors;
        }

	}
})();

(function() {
		'use strict';

	angular
		.module('fuse')
		.factory('httpBlobInterceptor', httpBlobInterceptor);

	/* @ngInject */
	/* this interceptor is used to remove $http request header Authorization to download blob images.
	*/
	function httpBlobInterceptor() {
		return {
				request: function(config) {
						//Check for the host (.blob.core.windows.net)
						var regex = /\.blob\.core\.windows\.net/i;
						if(regex.test(config.url)) {
								//delete the header
								delete config.headers.Authorization;
						}
						return config;
				}
		}
	}
})();
(function() {
    'use strict';

	angular
		.module('fuse')
		.factory('crud', crud);

	/* @ngInject */
	function crud(api, toast, $log, catalogFactory) {

		var service = {
            createRequestObject : createRequestObject,
            createProcessOrderRequestObject: createProcessOrderRequestObject,
            onRecordStatusChange: onRecordStatusChange,
            onOrderProcessStatusChange: onOrderProcessStatusChange,
            trasnformToBulkRequest: trasnformToBulkRequest,
            removeDeletedRecords: removeDeletedRecords,
            createLookupPromise: createLookupPromise,
            pushItemToArray: pushItemToArray,
            createAuthRequestObject: createAuthRequestObject,
            onAuthRecordStatusChange: onAuthRecordStatusChange,
            createDuneRequestObject: createDuneRequestObject,
            onDuneRecordStatusChange: onDuneRecordStatusChange
		};

		return service;

        //Service method implementation


        /**
         * Create request object for bulk delete/un-delete lock/unlock
         * @param records: selected records need to be deleted or un-deleted
         * @param model: model object
         * @param actionType: denotes action type (delete or activate)
         * @param additionalInfo: when we need to send different id field insted of Id (Specific to request module participants api)
         * @return object: contain requestObj and list of records name on which action performed
         */
        function createRequestObject(records, model, actionType, additionalInfo) {
            var result = {
                requestObj: [],
                itemsNameList: []
            };
            var obj;
            var index = 0;
            var status = -1;
            var editable = -1; // specific to linked attributes module
            var autoSubscribe = -1; // specific to notification types
            var lockVal = -1;
            var isAdditionalInfo = false;
            var secondaryIdField = '';
            var isSeasonlessAttributes = false;
            if(angular.isDefined(additionalInfo)) {
                if(angular.isDefined(additionalInfo.secondaryIdField)) {
                    secondaryIdField = additionalInfo.secondaryIdField;
                }
                // for seasonless attributes and seasonless model attributes
                if(angular.isDefined(additionalInfo.isSeasonlessAttributes)) {
                    isSeasonlessAttributes = true;
                }
                isAdditionalInfo = true;
            }

            if(actionType.toUpperCase() === 'DELETE' || actionType.toUpperCase() === 'UNASSIGN' || actionType.toUpperCase() === 'DEACTIVATE') {
                status = 0;
            }
            else if(actionType.toUpperCase() === 'ACTIVATE' || actionType.toUpperCase() === 'ASSIGN') {
                status = 1;
            }
            else if(actionType.toUpperCase() === 'NONEDITABLE') {
                editable = 0;
            }
            else if(actionType.toUpperCase() === 'EDITABLE') {
                editable = 1;
            }
            else if(actionType.toUpperCase() === 'LOCK') {
                lockVal = 1;
            }
            else if(actionType.toUpperCase() === 'UNLOCK') {
                lockVal = 0;
            }
            else if(actionType.toUpperCase() === 'UNSUBSCRIBE') {
                autoSubscribe = 0;
            }
            else if(actionType.toUpperCase() === 'SUBSCRIBE') {
                autoSubscribe = 1;
            }

            // pushing single item to array
            if(!angular.isArray(records)) {
                records = pushItemToArray(records);
            }
            if(actionType.toUpperCase() === 'DELETE' || actionType.toUpperCase() === 'ACTIVATE' || actionType.toUpperCase() === 'UNASSIGN'
            || actionType.toUpperCase() === 'ASSIGN' || actionType.toUpperCase() === 'DEACTIVATE') {
                for(index ; index < records.length ; index++) {
                    obj = {}
                    if(!isAdditionalInfo) {
                        obj[model.idField] = records[index][model.idField];
                    } else if(secondaryIdField !== '') {
                        // specific to request module
                        obj[secondaryIdField] = records[index][secondaryIdField];
                    } else if(isSeasonlessAttributes) {
                        // send AttributeGroupId seasonless article and model attributes
                        obj[model.idField] = records[index][model.idField];
                        obj.AttributeGroupId = records[index]['AttributeGroupId'];
                    }
                    obj.status = status;
                    result.requestObj.push(obj);
                    result.itemsNameList.push(records[index][model.lookupDisplayField]);
                }
            }
            else if(actionType.toUpperCase() === 'LOCK' || actionType.toUpperCase() === 'UNLOCK') {
                for(index ; index < records.length ; index++) {
                    obj = {}
                    obj[model.idField] = records[index][model.idField];
                    obj.Lock = lockVal;
                    result.requestObj.push(obj);
                    result.itemsNameList.push(records[index][model.lookupDisplayField]);
                }
            } else if(actionType.toUpperCase() === 'NONEDITABLE' || actionType.toUpperCase() === 'EDITABLE') {
                for(index ; index < records.length ; index++) {
                    obj = {}
                    obj[model.idField] = records[index][model.idField];
                    obj.Editable = editable;
                    result.requestObj.push(obj);
                }
            } else if(actionType.toUpperCase() === 'UNSUBSCRIBE' || actionType.toUpperCase() === 'SUBSCRIBE') {
                for(index ; index < records.length ; index++) {
                    obj = {}
                    obj[model.idField] = records[index][model.idField];
                    obj.AutoSubscribe = autoSubscribe;
                    result.requestObj.push(obj);
                    result.itemsNameList.push(records[index][model.lookupDisplayField]);
                }
            }
            return result;
        }

        /**
         * Create request object for bulk delete/un-delete
         * @param records: selected records need to be deleted or un-deleted
         * @param model: model object
         * @param actionType: denotes action type (delete or activate)
         * @param status: denotes process order status
         * @return object: contain requestObj and list of records name on which action performed
         */
        function createProcessOrderRequestObject(records, model) {
            var result = {
                requestObj: {Orders: []},
                itemsNameList: []
            };
            // pushing single item to array
            if(!angular.isArray(records)) {
                records = pushItemToArray(records);
            }
            for(var index=0; index < records.length ; index++) {
                result.requestObj.Orders.push(records[index][model.idField]);
                result.itemsNameList.push(records[index][model.lookupDisplayField]);
            }
            return result;
        }

        /**
         * Change record status and mark the record dirty
         * @param records: selected records need to be deleted or un-deleted
         * @param model: model object
         * @param actionType: denotes action type (delete or activate)
         * @param statusProperty: if defined denotes record's property which is use to denote the status of record (for eg isActive in orderline)
         * @param {object} additionalInfo: map of additional information (optional)
         * @param dropReason: used in articles module to assign the drop reasons when article unassigned or deleted.
         */
        function onRecordStatusChange(records, model, actionType, statusProperty, additionalInfo, dropReason) {
            var status = -1;
            var lockVal = -1;
            var publishStatusId = -1;
            var publishStatus = '';
            var toastMessageKey = '';

             //For Stop Orders and Allow Orders action type, additionalInfo.customMessage will overwrite toastMessageKey.
            if(actionType.toUpperCase() === 'DELETE' || actionType.toUpperCase() === 'STOPORDERS') {
                status = 0;
                toastMessageKey = records.length > 1 ? 'SUCCESS.DELETE_BULK' : 'SUCCESS.DELETE';
            }
            else if(actionType.toUpperCase() === 'DISABLEREQUESTS') {
                status = 0;
                toastMessageKey = 'SUCCESS.DISABLE_REQUESTS';
            }
            else if(actionType.toUpperCase() === 'ENABLEREQUESTS') {
                status = 1;
                toastMessageKey = 'SUCCESS.ENABLE_REQUESTS';
            }
            else if(actionType.toUpperCase() === 'DEACTIVATE') {
                status = 0;
                toastMessageKey = records.length > 1 ? 'SUCCESS.DEACTIVATE_BULK' : 'SUCCESS.DEACTIVATE';
            }
            else if(actionType.toUpperCase() === 'ACTIVATE' || actionType.toUpperCase() === 'ALLOWORDERS') {
                status = 1;
                toastMessageKey = records.length > 1 ? 'SUCCESS.ACTIVATE_BULK' : 'SUCCESS.ACTIVATE';
            }
            else if(actionType.toUpperCase() === 'EDITABLE') {
                status = 0;
                toastMessageKey = records.length > 1 ? 'SUCCESS.EDITABLE_BULK' : 'SUCCESS.EDITABLE';
            }
            else if(actionType.toUpperCase() === 'NONEDITABLE') {
                status = 1;
                toastMessageKey = records.length > 1 ? 'SUCCESS.NON_EDITABLE_BULK' : 'SUCCESS.NON_EDITABLE';
            }
            else if(actionType.toUpperCase() === 'UNSUBSCRIBE') {
                status = 0;
                toastMessageKey = records.length > 1 ? 'SUCCESS.UNSUBSCRIBE_BULK' : 'SUCCESS.UNSUBSCRIBE';
            }
            else if(actionType.toUpperCase() === 'SUBSCRIBE') {
                status = 1;
                toastMessageKey = records.length > 1 ? 'SUCCESS.SUBSCRIBE_BULK' : 'SUCCESS.SUBSCRIBE';
            }
            else if(actionType.toUpperCase() === 'UNASSIGN') {
                status = 0;
                toastMessageKey = records.length > 1 ? 'SUCCESS.UNASSIGN_BULK' : 'SUCCESS.UNASSIGN';
            }
            else if(actionType.toUpperCase() === 'ASSIGN') {
                status = 1;
                toastMessageKey = records.length > 1 ? 'SUCCESS.ASSIGN_BULK' : 'SUCCESS.ASSIGN';
            }
            else if(actionType.toUpperCase() === 'LOCK') {
                lockVal = 1;
                toastMessageKey = records.length > 1 ? 'SUCCESS.LOCKED_BULK' : 'SUCCESS.LOCKED';
            }
            else if(actionType.toUpperCase() === 'UNLOCK') {
                lockVal = 0;
                toastMessageKey = records.length > 1 ? 'SUCCESS.UNLOCKED_BULK' : 'SUCCESS.UNLOCKED';
            }
            else if(actionType.toUpperCase() === 'PUBLISH') {
                publishStatusId = 2;
                publishStatus = "Published";
                toastMessageKey = records.length > 1 ? 'SUCCESS.PUBLISH_BULK' : 'SUCCESS.PUBLISH';
            }
            else if(actionType.toUpperCase() === 'DRAFT') {
                publishStatusId = 1;
                publishStatus = "Draft";
                toastMessageKey = records.length > 1 ? 'SUCCESS.DRAFT_BULK' : 'SUCCESS.DRAFT';
            }

            if(angular.isDefined(additionalInfo) && angular.isDefined(additionalInfo.customMessage) && angular.isString(additionalInfo.customMessage)) {
                toastMessageKey = additionalInfo.customMessage;
            }

            if(!angular.isArray(records)) {
                records = pushItemToArray(records);
            }
            if(actionType.toUpperCase() === 'DELETE' || actionType.toUpperCase() === 'ACTIVATE' || actionType.toUpperCase() === 'ASSIGN'
            ||  actionType.toUpperCase() === 'STOPORDERS' || actionType.toUpperCase() === 'ALLOWORDERS' || actionType.toUpperCase() === 'DISABLEREQUESTS' || actionType.toUpperCase() === 'ENABLEREQUESTS'
            || actionType.toUpperCase() === 'DEACTIVATE' || actionType.toUpperCase() === 'NONEDITABLE' || actionType.toUpperCase() === 'EDITABLE' || actionType.toUpperCase() === 'UNSUBSCRIBE' || actionType.toUpperCase() === 'SUBSCRIBE') {
                if(angular.isDefined(statusProperty)){
                    angular.forEach(records, function(selectedItem) {
                        selectedItem[statusProperty] = status;
                        selectedItem.selected = false;
                    });
                }
                else {
                    var isArticleStatusChange = model.modelPath === 'catalogs.articles' && (actionType.toUpperCase() === 'DELETE' || actionType.toUpperCase() === 'ACTIVATE' || actionType.toUpperCase() === 'ASSIGN');
                    angular.forEach(records, function(selectedItem) {
                        selectedItem.Status = status;
                        selectedItem.selected = false;
                        if(isArticleStatusChange) {
                            selectedItem.DropReason = dropReason;
                        }
                    });
                }
            }
            else if(actionType.toUpperCase() === 'LOCK' || actionType.toUpperCase() === 'UNLOCK') {
                angular.forEach(records, function(selectedItem) {
                    selectedItem.Locked = lockVal;
                    selectedItem.selected = false;
                });
            }
            else if(actionType.toUpperCase() === 'PUBLISH' || actionType.toUpperCase() === 'DRAFT') {
                angular.forEach(records, function(selectedItem) {
                    selectedItem.PublishStatusId = publishStatusId;
                    selectedItem.PublishStatus = publishStatus;
                    selectedItem.selected = false;
                });
            } else if(actionType.toUpperCase() === 'UNASSIGN') {
                // for articles show different inactive statuses based on parent status
                angular.forEach(records, function(selectedItem) {
                    if(status === 0 && selectedItem['PS'] === 0) {
                        selectedItem.Status = 2;
                    } else if(status === 0 && selectedItem['PS'] === 1) {
                        selectedItem.Status = 3;
                    }
                    selectedItem.selected = false;
                    if(model.modelPath === 'catalogs.articles') {
                        selectedItem.DropReason = dropReason;
                    }
                });
            }
            model.isDirty = true;
            if(angular.isDefined(model.baseModel)) {
                model.baseModel.isDirty = true;
            }
            toast.success(toastMessageKey, '', '');
        }

        /**
         * Create request object for bulk delete/un-delete
         * @param records: selected records need to be deleted or un-deleted
         * @param model: model object
         * @param actionType: denotes action type (delete or activate)
         * @return object: contain requestObj and list of records name on which action performed
         */
        function createAuthRequestObject(records, model, actionType) {
            var result = {};
            var items = {};
            var ids = [];
            var status;

            // pushing single item to array
            if(!angular.isArray(records)) {
                records = pushItemToArray(records);
            }

            if(actionType.toUpperCase() === 'DELETE') {
                status = false;
            } else if(actionType.toUpperCase() === 'ACTIVATE') {
                status = true;
            }

            for(var i = 0 ; i < records.length ; i++) {
                ids.push(records[i][model.idField]);
            }
            items.Ids = ids;
            items.status = status;
            result = items;

            return result;
        }

        /**
         * Change record status and mark the record dirty
         * @param records: selected records need to be deleted or un-deleted
         * @param model: model object
         * @param actionType: denotes action type (delete or activate)
         */
        function onAuthRecordStatusChange(records, model, actionType) {
            var status = '';
            var toastMessageKey ='';

            if(actionType.toUpperCase() === 'DELETE' || actionType.toUpperCase() === 'STOPORDERS') {
                status = false;
                toastMessageKey = records.length > 1 ? 'SUCCESS.DELETE_BULK' : 'SUCCESS.DELETE';
            }
            else if(actionType.toUpperCase() === 'ACTIVATE' || actionType.toUpperCase() === 'ALLOWORDERS') {
                status = true;
                toastMessageKey = records.length > 1 ? 'SUCCESS.ACTIVATE_BULK' : 'SUCCESS.ACTIVATE';
            }

            if(!angular.isArray(records)) {
                records = pushItemToArray(records);
            }
            if(actionType.toUpperCase() === 'DELETE' || actionType.toUpperCase() === 'ACTIVATE') {
                angular.forEach(records, function(selectedItem) {
                    selectedItem.status = status;
                    selectedItem.selected = false;
                });
            }

            model.isDirty = true;
            if(angular.isDefined(model.baseModel)) {
                model.baseModel.isDirty = true;
            }
            toast.success(toastMessageKey, '', '');
        }

         /**
         * Create request object for bulk delete/un-delete
         * @param records: selected records need to be deleted or un-deleted
         * @param model: model object
         * @param actionType: denotes action type (delete or activate)
         * @return object: contain requestObj and list of records name on which action performed
         */
          function createDuneRequestObject(records, model, actionType, contextKey) {
            var result = {
                requestObj: {},
                itemsNameList: []
            }
            var items = {
                Context: catalogFactory.getActiveCatalog().DuneContext,
                ContextKey: contextKey,
            };
            var ids = [];
            var status;

            // pushing single item to array
            if(!angular.isArray(records)) {
                records = pushItemToArray(records);
            }

            if(actionType.toUpperCase() === 'DELETE') {
                status = false;
            } else if(actionType.toUpperCase() === 'ACTIVATE') {
                status = true;
            }

            for(var i = 0 ; i < records.length ; i++) {
                ids.push(records[i][model.idField]);
                result.itemsNameList.push(records[i][model.lookupDisplayField])
            }
            items.AssetIds = ids;
            items.Status = status;
            result.requestObj = items;

            return result;
        }

        /**
         * Change record status and mark the record dirty
         * @param records: selected records need to be deleted or un-deleted
         * @param model: model object
         * @param actionType: denotes action type (delete or activate)
         */
        function onDuneRecordStatusChange(records, model, actionType) {
            var status = '';
            var toastMessageKey ='';

            if(actionType.toUpperCase() === 'DELETE') {
                status = false;
                toastMessageKey = records.length > 1 ? 'SUCCESS.DELETE_BULK' : 'SUCCESS.DELETE';
            }
            else if(actionType.toUpperCase() === 'ACTIVATE') {
                status = true;
                toastMessageKey = records.length > 1 ? 'SUCCESS.ACTIVATE_BULK' : 'SUCCESS.ACTIVATE';
            }

            if(!angular.isArray(records)) {
                records = pushItemToArray(records);
            }
            if(actionType.toUpperCase() === 'DELETE' || actionType.toUpperCase() === 'ACTIVATE') {
                angular.forEach(records, function(selectedItem) {
                    selectedItem.Status = status;
                    selectedItem.selected = false;
                });
            }

            model.isDirty = true;
            if(angular.isDefined(model.baseModel)) {
                model.baseModel.isDirty = true;
            }
            toast.success(toastMessageKey, '', '');
        }

        /**
         * @description:
         *  Change record status and mark the record dirty
         * @param records: selected records need to be deleted or un-deleted
         * @param model: model object
         * @param actionType: denotes action type (delete or activate)
         * @param status: denotes process order status
         */
        function onOrderProcessStatusChange(records, model, actionType, status) {
            var toastMessageKey = "";
            if(!angular.isArray(records)) {
                records = pushItemToArray(records);
            }

            angular.forEach(records, function(selectedItem) {
                selectedItem.OrderProcessStatusId = status;
                    switch (status) {
                        case 2:
                            selectedItem.OrderProcessStatus = 'Submitted';
                            selectedItem.OrderProcessStatusId = status;
                            toastMessageKey = 'SUCCESS.ORDER_SUBMITTED';
                            break;
                        case 3:
                            selectedItem.OrderProcessStatus = 'Disapproved';
                            selectedItem.OrderProcessStatusId = status;
                            toastMessageKey = 'SUCCESS.ORDER_REJECTED';
                            break;
                        case 4:
                            selectedItem.OrderProcessStatus = 'Approved';
                            selectedItem.OrderProcessStatusId = status;
                            toastMessageKey = 'SUCCESS.ORDER_APPROVED';
                            break;
                        case 5:
                            selectedItem.OrderProcessStatus = 'Reopened';
                            selectedItem.OrderProcessStatusId = status;
                            toastMessageKey = 'SUCCESS.ORDER_REOPENED';
                            break;
                        case 8:
                            selectedItem.OrderProcessStatus = 'Confirmed';
                            selectedItem.OrderProcessStatusId = status;
                            toastMessageKey = 'SUCCESS.ORDER_CONFIRMED';
                            break;
                        case -1:
                            selectedItem.OrderProcessStatus = 'Approved';
                            selectedItem.OrderProcessStatusId = 4;
                            toastMessageKey = 'SUCCESS.ORDER_UNLOCKED';
                            break;
                }
                selectedItem.selected = false;
            });
            model.isDirty = true;
            if(angular.isDefined(model.baseModel)) {
                model.baseModel.isDirty = true;
            }
            toast.success(toastMessageKey, '', '');
        }

        /**
         * @description
         * Will transform request object for single record to bulk records structure
         * @Param requestObj: request object
         * @Param transformedObjPropertyList: list of properties needs to be extracted from requestObject and use as fist level properties of transformed object
         * @Param nestedArrayName: name of property used as nested array name
         * @Param propertyMapper: an object use to change property name of source to property target
         */
        //OBSOLETE
        function trasnformToBulkRequest(requestObj, trasnformedObjPropertyList, nestedArrayName, propertyMapper) {
            var result = [];
            var obj = {};
            //converting property name from propertyMapper.source to propertyMapper.target
            if(angular.isDefined(propertyMapper) && angular.isDefined(requestObj[propertyMapper.source])) {
                requestObj[propertyMapper.target] = requestObj[propertyMapper.source];
                delete requestObj[propertyMapper.source];
            }

            angular.forEach(trasnformedObjPropertyList, function(property) {
                //looping through all request object properties
                for(var requestObjProperty in requestObj) {
                    if(requestObjProperty === property) {
                        obj[property] = requestObj[requestObjProperty];
                        delete requestObj[requestObjProperty];
                        break;
                    }
                }
            });
            obj[nestedArrayName] = requestObj;
            result.push(obj);
            return result;
        }

        /**
         * @description
         * This method will removed items which are intended to be removed form source record
         * if provided with target records it will remove all of targetRecords from sourceRecords
         * if target records is not provided it will remove all the deactivated records from source records
         *
         * @param {array} sourceRecords: the intended record who's items going to be removed
         * @param {array or object} targetRecords: record(s) needed to be remove from sourceRecords
         *
         */
        function removeDeletedRecords(sourceRecords, targetRecords) {
            //if target records not passed to this method search sourceRecords and remove deleted Items from it
            if(angular.isUndefined(targetRecords)) {
                if(angular.isDefined(sourceRecords)) {
                    for(var index=sourceRecords.length-1; index >=0; index--) {
                        if(sourceRecords[index].Status === 0){
                            sourceRecords.splice(index, 1);
                        }
                    }
                }
                else {
                    $log.warn('sourceRecords is undefined at removeDeletedRecords of crud');
                }
            }
            else {
                if(!angular.isArray(targetRecords)) {
                    targetRecords = pushItemToArray(targetRecords);
                }
                angular.forEach(targetRecords, function(targetRecord) {
                    var index = sourceRecords.indexOf(targetRecord);
                    if(index !== -1) {
                        sourceRecords.splice(index, 1);
                    }
                });
            }
        }

        /**
         * @description
         * This method will be called before update or create dialog to load lookup data for provided model's fields
         *  and create a lookup promise which is used by dialog to load data asynchronously
         * @param {object} model: model object containing field information
         * @param {object} lookupExtras: map containing ids for modelPath to be use to create lookup data where api needs ids
         * @param {string} action: contains action type like create and edit
         * @return {object}: a mapping between field name and promise object for its lookup API call
         */
        function createLookupPromise(model, lookupExtras, action) {
            var promises = {};
            var fieldsRequiringLookup = model.fields.filter(function (field) {
              return (
                ['lookup', 'lookup-many', 'articlenumber', 'modelnumber', 'linkedcatalogarticlenumber', 'color-palette'].indexOf(field.inputType) !== -1 &&
                angular.isDefined(field.lookupSource) &&
                (
                  (action === 'create' && field.creatable) ||
                  (action === 'edit' && (field.editable || field.showInEdit))
                )
              );
            });

            fieldsRequiringLookup.forEach(function (field) {
              var lookupModel = api.getModel(field.lookupSource);
              promises[field.field] = api.getLookupData(lookupModel, lookupExtras, undefined, field);
            });

            return promises;
        }

        /**
         * @description
         * It will create a array of single object or convert object to array (copy of utility method to remove the dependancy of crud factory to utility factory)
         * @param {object or primitive data type} item: single item
         * @return {array} converted array of items
         */
        function pushItemToArray(item) {
            if(!angular.isArray(item)) {
                var array = [];
                array.push(item);
                return array;
            }
        }

	}
})();
(function() {
    'use strict';

	angular
		.module('fuse')
		.factory('activityLogger', activityLogger);

	/* @ngInject */
	function activityLogger(CONSTANTS, $localStorage) {
        var logsMaxLength = 50;
        var LogIndex = 0;
        // log-severity selected for user
        var logSeverity = -1;// disable logging #10980

		var service = {
            log             : log,
            createLogData   : createLogData
		};

		return service;

        //Service method implementation

        /**
         * log will add the Log Objects to an array to be renderd on browser
         * @param logObj: Log Object to be added to 'log' list
         * @param promise: use to log the action result message
         */
        function log(logObj, promise) {
            if(angular.isDefined(logObj) && logSeverity >= CONSTANTS.LOG.ACTIONS[logObj.actionType].severity) {
                if(angular.isDefined(promise)) {
                    promise.then(function() {
                        logObj.result = "RESULT.SUCCESS";
                        //logObj.resultMessage = response.data;
                    }, function(response) {
                        logObj.result = "RESULT.FAIL";
                        logObj.resultMessage = response.data;
                    });
                }
                if(LogIndex !== logsMaxLength-1){
                    if (angular.isUndefined($localStorage.logs)) {
                        $localStorage.logs = [];
                    }
                    $localStorage.logs[LogIndex] = logObj;
                    LogIndex += 1;
                }
                else {
                    LogIndex = 0;
                }
            }
            return promise;
        }

        /**
         * createLogData will create the log object
         * @Param record: list of records on which action performed
         * @Param state: state information object on which the action performed
         * @Param actionType: type of action ('ADD', 'EDIT',etc)
         * @Param isBulk: boolean value indicating if actino was bulk or singular
         * @Param date: date object when the action happend
         * @Param result: a translatable string which indicate the status of action
         * @Param resultMessage: data property of response object
         */
        function createLogData(record, state, module, actionType, isBulk, date, result, resultMessage) {
            var logObj = {};
            logObj.record = record;
            logObj.state = state;
            logObj.module = module;
            logObj.actionType = actionType;
            logObj.isBulk = isBulk;
            logObj.date = date;
            logObj.result = result;
            logObj.resultMessage = resultMessage;
            return logObj;
        }
	}
})();
(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('QuickPanelController', QuickPanelController);

    /** @ngInject */
    function QuickPanelController(api, jobsTracker, $state, $mdDialog, uploadsTracker, $localStorage)
    {
        var vm = this;

        // Data
        vm.version = $localStorage.version;
        vm.release = $localStorage.release;
        vm.jobs = jobsTracker.jobs;
        vm.files = uploadsTracker.uploads;
        vm.date = new Date();
        vm.settings = {
            notify: true,
            cloud : false,
            retro : true
        };

        api.quickPanel.activities.get({}, function (response)
        {
            vm.activities = response.data;
        });

        api.quickPanel.events.get({}, function (response)
        {
            vm.events = response.data;
        });

        api.quickPanel.notes.get({}, function (response)
        {
            vm.notes = response.data;
        });
        if(angular.isUndefined(vm.version) || angular.isUndefined(vm.release)) {
            api.webGet('/app/app.config.json').then(function(response) {
                if (angular.isDefined(response) && angular.isDefined(response.data) && angular.isDefined(response.data.appVersion)) {
                    vm.version = $localStorage.version = response.data.appVersion.version;
                    vm.release = $localStorage.release = response.data.appVersion.release;
                }
            });
        }

        // Methods
        vm.getJobStatus = getJobStatus;
        vm.gotoJob = gotoJob;
        vm.cancelUpload= cancelUpload;

        //////////
        function getJobStatus(status) {
            switch (status) {
                case 0:
                    return 'QUICKPANEL.SUBMITTING';
                case 10:
                    return 'QUICKPANEL.PROCESSING';
                case 90:
                    return 'QUICKPANEL.COMPLETED';
                case 95:
                    return 'QUICKPANEL.COMPLETED';
                case 99:
                    return 'QUICKPANEL.ERRORS';
                case 100:
                    return 'QUICKPANEL.CRITICAL_ERROR';
            }
        }

        function gotoJob(job) {
            var id = job.serverId,
                stateParams = {id: id};

            if (job.status === 0) {
                return;
            } else if (job.status === 100) {
                var parentEl = angular.element(document.body);
                $mdDialog.show({
                    parent      : parentEl,
                    targetEvent : null,
                    templateUrl : 'app/services/toast/error-details.html',
                    locals      : {
                        errorObj: job.result
                    },
                    controller  : DialogController,
                    controllerAs: 'vm'
                });
                return;
            } else if (angular.isUndefined(id)) {
                return;
            }
            $state.go('app.jobs.details', stateParams);
        }

        //Cancel upload, stop interval for the file and remove file from factory
        function cancelUpload(file) {
            // flowObject.cancel(); //Also valid since restricting 1 file in 1 flowObject
            file.flow.cancel();
        }

        function DialogController($scope, $mdDialog, $translate, errorObj) {
            var vm = this;
            vm.errorObj = errorObj;
            vm.errorTxt = angular.toJson(errorObj, true);
            vm.closeDialog = function() {
                $mdDialog.hide();
            }
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider)
    {
        $translatePartialLoaderProvider.addPart('app/navigation');
    }

})();
(function () {
	'use strict';

	angular
		.module('app.navigation')
		.controller('NavigationController', NavigationController);

	/** @ngInject */
	function NavigationController($scope, hotkeys, $filter, $rootScope, catalogFactory, msNavigationService) {
		var vm = this;

		// Data
		var activeCatalog = catalogFactory.getActiveCatalog();
		vm.bodyEl = angular.element('body');
		vm.folded = false;
		vm.searchText = '';
		vm.msScrollOptions = {
			suppressScrollX: true
		};

		// Methods
		vm.toggleMsNavigationFolded = toggleMsNavigationFolded;
		vm.onKeyDown = onKeyDown;
		vm.search = search;

		//Hotkeys
		hotkeys.bindTo($scope)
			.add({
				combo: 'ctrl+[',
				description: $filter('translate')('NAVIGATION.SHOW_HIDE_NAV'),
				callback: function () {
					vm.toggleMsNavigationFolded();
				}
			});

		activate();

		//////////

		function activate() {
			search();
		}

		/**
		 * Toggle folded status
		 */
		function toggleMsNavigationFolded() {
			vm.folded = !vm.folded;
		}

		/**
		 * Search The Navigation Menu
		 */
		function search() {
			var navObj = msNavigationService.getNavigationObject();
      var results = [];
      var predicate = {
				title: vm.searchText,
				isAuthorized: true
			};
			if(angular.isDefined(activeCatalog) && activeCatalog != null && activeCatalog.IsLinePlan === 1) {
				predicate.visibleForLinePlan = true;
			}
			results = $filter('filterTree')(navObj, predicate, true);
			msNavigationService.setFilteredNavigation(results);
      $rootScope.$broadcast('updateFilteredNavigation');
		}

		function onKeyDown(event) {
			event.stopPropagation();
		}

		// Close the mobile menu on $stateChangeSuccess
		var stateChangeSuccessEventCleanup = $scope.$on('$stateChangeSuccess', function () {
			vm.bodyEl.removeClass('ms-navigation-horizontal-mobile-menu-active')
		});


		// since on updating active catalog nav menu will be rebuilt to remove the un-authorizes menu items, call the search function to persist search functionality
		var ActiveCatalogChangedEventCleanup = $rootScope.$on('ActiveCatalogChangedEvent', function(event, ac) {
			activeCatalog = ac;
			search();
		});

		$scope.$on('$destroy', function() {
			ActiveCatalogChangedEventCleanup();
			stateChangeSuccessEventCleanup();
		});
	}

})();
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .controller('MainController', MainController);

    /** @ngInject */
    function MainController($scope, $rootScope, $window)
    {
        // Data
        var vm = this;
        vm.isFullScreen = false;
        var windowDocument = $window.document;
        var documentEl = windowDocument.documentElement;
        var requestFullScreen = documentEl.requestFullscreen || documentEl.mozRequestFullScreen || documentEl.webkitRequestFullScreen || documentEl.msRequestFullscreen;
        var cancelFullScreen = windowDocument.exitFullscreen || windowDocument.mozCancelFullScreen || windowDocument.webkitExitFullscreen || windowDocument.msExitFullscreen;

        // methods
        vm.toggleFullScreen = toggleFullScreen;

        //////////

        // Remove the splash screen
        $scope.$on('$viewContentAnimationEnded', function (event)
        {
            if ( event.targetScope.$id === $scope.$id )
            {
                $rootScope.$broadcast('msSplashScreen::remove');
            }
        });

        var toggleFullScreenEventCleanup = $rootScope.$on('toggleFullScreenEvent', onFullScreen);

        function onFullScreen(ev, screenMode) {
            if(screenMode.toLowerCase() === 'fullscreen') {
                vm.isFullScreen = true;
                requestFullScreen.call(documentEl)
            }
            else {
                vm.isFullScreen = false;
            }
        }

        function toggleFullScreen() {
            cancelFullScreen.call(windowDocument);
            $rootScope.$emit('toggleFullScreenResizeListEvent', 'normalView');
        }

        $scope.$on('$destroy', function () {
            toggleFullScreenEventCleanup();
        });
    }
})();
(function() {
    'use strict';

    angular
        .module('fuse')
        .filter('txStartsWith', txStartsWith);
    
    /**
     * Filters array of object based on object-property 'property' whos value starts with the 'startsWith'
     * */
    function txStartsWith() {
        return function(items, property, startsWith) {
            return items.filter(function(item) {
                var lowerStr = (item[property] + "").toLowerCase();
                return lowerStr.indexOf(startsWith.toLowerCase()) === 0;
            });
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('fuse')
        .filter('txOrderBy', txOrderBy);
    /**
     * Filters array of object based on object-property 'property' 
     * */
    function txOrderBy() {
        return function (array, property, reverse) {
            var result = array.sort(function (object1, object2) {
                if (angular.isUndefined(property)) {
                    return object1.localeCompare(object2);
                }
                // spliting file name to avoid angular filter orderBy issue( when we have file names as abc.jpg and abc-l.jpg after sorting the result we are getting is
                // abc-l.jpg but the correct value is abc.jpg)
                return object1[property].split('.').slice(0,-1).join('.').localeCompare(object2[property].split('.').slice(0,-1).join('.'));
            });
            return reverse ? result.reverse() : result;
        };
    }
})();
(function() {
  'use strict';

  angular
      .module('fuse')
      .filter('txNumber', txNumberFilter);

  /**
   * @description
   * Wrapping angular number filter to limit the fractionSize to 2. Also to remove zeroes and decimal point for integers.
   * */
  function txNumberFilter($filter) {
      return function(input, col){
          var result =  $filter('number')(input, 2);
          return (result == null) ? result: formatNumber(result, col);
      }
  }

   /**
   * @description
   * All numbers here will be fractions, therefore numbers having ".00" at end will be converted to integers.
   * */
  function formatNumber(input, col) {
      // prefix zero's to color code
      if(angular.isDefined(col.prefixZeros)) {
          var inputValue = (angular.equals(input.substring(input.length-3, input.length),".00")) ? input.substring(0 ,input.length-3) : input;
          return inputValue.padStart(col.prefixZeros, '0');
      } else {
          return (angular.equals(input.substring(input.length-3, input.length),".00")) ? input.substring(0 ,input.length-3) : input;
      }
  }
})();
(function() {
	'use strict';

	angular
					.module('fuse')
					.filter('txDataTableOrderBy', txDataTableOrderBy);
	/**
	 * Filters array of object based on object-property 'property'
	 * this filter will sort all the columns based on the predicate
	 * this filter is created to fix issue sorting the lokkups. lookups were sorted with the id's and not with values before.
	 * with this filter we will compare the lookups values while sorting
	 * */
	function txDataTableOrderBy($filter, utility, api) {
					return function (array, predicate, lookupData, model) {
						var result = array;
						angular.forEach(predicate, function(column) {
							// replace +, - and ' and get the column
							var sortField = column.replace(/\-/g, '').replace(/\+/g, '').replace(/\'/g, '');
							var sortMultiplayer = column.includes('+') ? 1 : -1;
							var selectedfield = utility.filterObject(model.fields, {field: sortField, visible: true}, true)[0];
							if(selectedfield.inputType === 'lookup' || selectedfield.inputType === 'articlenumber' || selectedfield.inputType === 'modelnumber' || selectedfield.inputType === 'linkedcatalogarticlenumber') {
								result = result.sort(function (object1, object2) {
										if(angular.isDefined(selectedfield)) {
												// handling null and undefined
												var value1 = $filter('recordRenderer')(object1[selectedfield.field], lookupData, selectedfield) ? $filter('recordRenderer')(object1[selectedfield.field], lookupData, selectedfield) : '';
												var value2 = $filter('recordRenderer')(object2[selectedfield.field], lookupData, selectedfield) ? $filter('recordRenderer')(object2[selectedfield.field], lookupData, selectedfield) : '';
												return (sortMultiplayer * value1.localeCompare(value2));
										}
								});
							} else if(selectedfield.inputType === 'lookup-many') {
								result = result.sort(function (object1, object2) {
										if(angular.isDefined(selectedfield)) {
												// handling null and undefined
												var value1 = $filter('lookupManyRenderer')(object1[selectedfield.field], lookupData, selectedfield) ? $filter('lookupManyRenderer')(object1[selectedfield.field], lookupData, selectedfield) : '';
												var value2 = $filter('lookupManyRenderer')(object2[selectedfield.field], lookupData, selectedfield) ? $filter('lookupManyRenderer')(object2[selectedfield.field], lookupData, selectedfield) : '';
												return (sortMultiplayer * value1.localeCompare(value2));
										}
								});
							} else if(selectedfield.inputType === 'color-palette') {
								result = result.sort(function (object1, object2) {
										if(angular.isDefined(selectedfield)) {
												// handling null and undefined
												var value1 = $filter('colorPaletteRenderer')(object1[selectedfield.field], selectedfield) ? $filter('colorPaletteRenderer')(object1[selectedfield.field], selectedfield) : '';
												var value2 = $filter('colorPaletteRenderer')(object2[selectedfield.field], selectedfield) ? $filter('colorPaletteRenderer')(object2[selectedfield.field], selectedfield) : '';
												return (sortMultiplayer * value1.localeCompare(value2));
										}
								});
							} else if(selectedfield.inputType === 'lookup-from-map') {
								var lookupSource = selectedfield.lookupSource;
								// remove the "vm.api." prefix from the lookupSource
								// lookup-from-map should be from the index.api file
								if (lookupSource.startsWith('vm.api.')) {
										lookupSource = lookupSource.substring(7);
								}
								result = result.sort(function (object1, object2) {
										if(angular.isDefined(selectedfield)) {
												var value1 = api[lookupSource][object1[selectedfield.field]];
												var value2 = api[lookupSource][object2[selectedfield.field]];
												return (sortMultiplayer * value1.localeCompare(value2));
										}
								});
							} else {
								// all other fields other than lookup sort will use default orderby
								result = $filter('orderBy')(result, [column]);
							}
						});
						return result;
					};
	}
})();
(function() {
  'use strict';

      angular
          .module('fuse')
          .filter('targetAndAggregateAttributesRenderer', targetAndAggregateAttributesRenderer);
    /**
     * @description
     * This filter transforms the display value of property Attributes in Target Module. It transforms json string  of AttributeId:Value into string of AttributeDisplayName:Value
     * */
      function targetAndAggregateAttributesRenderer(catalogFactory) {
          return function(item, reportFlag) {
            var jsonObject = '';
            if(item != null && item !== '') {
              var jsonObject = angular.fromJson(item);
              var targetedAttributes = catalogFactory.getActiveCatalogDetails().TargettedAttributeList;
              var aggregateAttributes = catalogFactory.getActiveCatalogDetails().AggregateAttributeList;
              var mergedAttributes = targetedAttributes.concat(aggregateAttributes);
              angular.forEach(mergedAttributes, function (attribute) {
                if(jsonObject[attribute.AttributeId]) {
                    if(reportFlag) {
                      jsonObject[attribute.AttributeSystemName] = jsonObject[attribute.AttributeId];
                    } else {
                      jsonObject[attribute.AttributeDisplayName] = jsonObject[attribute.AttributeId];
                    }
                    delete jsonObject[attribute.AttributeId];
                }
              })
            }
            return jsonObject;
          }
      }
  })();
(function() {
	'use strict';

			angular
					.module('fuse')
					.filter('sizeCurveSizesRenderer', sizeCurveSizesRenderer);
		/**
		 * @description
		 * This filter transforms array of objects into comma seprated key: value string
		 * */
			function sizeCurveSizesRenderer() {
					return function(item) {
						if (angular.isArray(item) && item.length > 0) {
							return item.map(function (obj) {
								 return obj.Size + ' : ' + obj.Quantity;
							}).join(', ');
						} else {
							return '';
						}
					}
			}
	})();
(function() {
'use strict';

    angular
        .module('fuse')
        .filter('recordRenderer', recordRendererFilter);

    function recordRendererFilter(utility) {
        return function(input, lookupData, col) {
            switch (col.inputType) {
                case 'lookup':
                case 'lookup-many':
                case 'articlenumber':
                case 'modelnumber':
                    if(col.inputType === 'articlenumber' || col.inputType === 'modelnumber') {
                        input = parseInt(input);
                    }
                    if (angular.isDefined(lookupData[col.lookupSource]) && angular.isDefined(lookupData[col.lookupSource].indexArray) &&
                    angular.isArray(lookupData[col.lookupSource].indexArray) && lookupData[col.lookupSource].indexArray.indexOf(input) >= 0) {
                        // this is to support multiple lookup using same model
                        // NOTE - when we add lookupField add the same field in the index.api getLookupData response
                        if(angular.isDefined(col.lookupField) && col.lookupField !== '') {
                            return lookupData[col.lookupSource].data[lookupData[col.lookupSource].indexArray.indexOf(input)][col.lookupField];
                        } else {
                            return lookupData[col.lookupSource].data[lookupData[col.lookupSource].indexArray.indexOf(input)].value;
                        }
                    } else {
                        return undefined;
                    }
                    break;
                case 'linkedcatalogarticlenumber':
                    if(input != null && input.toString().trim() !== '') {
                        var splittedValues = input.split('//');
                        var splitedArticleNumber = splittedValues[2];
                        var splittedArticleId = splittedValues[1];
                        if(angular.isDefined(splitedArticleNumber)) {
                            return splitedArticleNumber;
                        } else if (angular.isDefined(lookupData[col.lookupSource]) && angular.isDefined(lookupData[col.lookupSource].indexArray) &&
                            angular.isArray(lookupData[col.lookupSource].indexArray) && lookupData[col.lookupSource].indexArray.indexOf(splittedArticleId) >= 0) {
                            // as we are sending the article number from the input this else case is not going to execute anytine. but in any case if the article number is not part of the json then we will lookup with article id
                            return lookupData[col.lookupSource].data[lookupData[col.lookupSource].indexArray.indexOf(splittedArticleId)].value;
                        } else {
                            return undefined;
                        }
                    } else {
                        return undefined;
                    }
                    break;
                default:
                    return input;
            }
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('fuse')
        .filter('orderProcessStatusFilter', orderProcessStatusFilter);
    
    /**
     * @description
     *  this filter use filter orders record base on predicate specified in orders model 
     *  predicate would look like following:
     *  {1: true, 2 true}, each object key denotes orderProcessStatusId
     */
    function orderProcessStatusFilter($log) {
        return function(records, predicateObj) {
            return records.filter(function(record) {
                if(angular.isDefined(record.OrderProcessStatusId) && angular.isDefined(record.Status) && predicateObj[record.OrderProcessStatusId] === true && (record.Status === true || record.Status === 1)){
                    return true;
                }
                else {
                    if(angular.isUndefined(record.OrderProcessStatusId) || angular.isUndefined(record.Status)) {// for debbugging purpose if Status and OrderProcessStatusId not part of response object
                        $log.warn('OrderProcessStatusId' + record.OrderProcessStatusId + 'Status' + record.Status);
                    }
                    return false;
                }
            });
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('fuse')
        .filter('mdSelectUniqueoptions', mdSelectUniqueoptions);

    /**
     * removes duplicates if any
     * */
    function mdSelectUniqueoptions() {
        return function(input) {
            if (angular.isArray(input)) {
                return Array.from(new Set(input));
            }
            return input;
        };
    }
})();
(function() {
'use strict';

    angular
      .module('fuse')
      .filter('lookupManyRenderer', lookupManyRendererFilter);

    function lookupManyRendererFilter() {
      return function(values, lookupData, col) {
        var result = [];
        if(!angular.isArray(values)) {
          values = [values];
        }
        angular.forEach(values, function(value) {
          if (angular.isDefined(lookupData[col.lookupSource]) && angular.isDefined(lookupData[col.lookupSource].indexArray) &&
          angular.isArray(lookupData[col.lookupSource].indexArray) && lookupData[col.lookupSource].indexArray.indexOf(value) >= 0) {
              result.push(lookupData[col.lookupSource].data[lookupData[col.lookupSource].indexArray.indexOf(value)].value);
          }
        });
        return result.join(', ');
      }
    }
})();
(function() {
    'use strict';

    angular
        .module('fuse')
        .filter('groupBy', groupBy);
    
    /**
     * Filters array of object based on object-property 'property' whos value is equels to 'group' 
     * */
    function groupBy() {
        return function(items, property, group){       
            return items.filter(function(item) {
                return item[property] === group;
            });        
        }        
    }
})();
(function() {
    'use strict';

    angular
        .module('fuse')
        .filter('filterUnion', filterUnion);

    /**
     * @description
     * filterUnion will filter array items based on predicate passed as object
     * the difference between filterUnion and normal filter is filterUnion will return result if either of the condition in predicate matches
     * @param {array} items list on which filter should apply
     * @param {object} predicate: predicate object
     * @param {boolean} strictMtc: optional param identifying if filter is strict match or not
     */
    function filterUnion() {
        return function(items, predicate, strictMtc) {
            var strictMatch = angular.isDefined(strictMtc) ? (strictMtc == true) : false;
            var result = [];
            var filterPredicateKeys = [];
            // create array of filter predicate keys
            // fo example if predicate is
            for(var key in predicate) {
                filterPredicateKeys.push(key);
            }
            if(strictMatch) {
                for(var i=0; i<items.length; i++) {
                    for(var j=0; j<filterPredicateKeys.length; j++) {
                        if(items[i][filterPredicateKeys[j]] === predicate[[filterPredicateKeys[j]]]) {
                            result.push(items[i]);
                            break;
                        }
                    }
                }
            }
            else {
                for(var k=0; k<items.length; k++) {
                    for(var l=0; l<filterPredicateKeys.length; l++) {
                        if(items[k][filterPredicateKeys[l]] && items[k][filterPredicateKeys[l]].toString().toLowerCase() === predicate[[filterPredicateKeys[l]]].toString().toLowerCase()) {
                            result.push(items[k]);
                            break;
                        }
                    }
                }
            }
            return result;
        }

    }
})();
(function () {
	'use strict';

	angular
		.module('fuse')
		.filter('filterTree', filterTree);

	function filterTree(api, utility) {
		return function (nodes, predicate, filterEmptyGroups, groupAttribute) {
			var groupAttr = angular.isDefined(groupAttribute) && groupAttribute != null && angular.isString(groupAttribute) ? groupAttribute : 'group';
			return filterMyTree(angular.copy(nodes), predicate, filterEmptyGroups, groupAttr);
		};

		// filter the tree base on the predicate passed, all the criteria in predicate must match in order for node to be included
		function filterMyTree(nodes, predicate, filterEmptyGroups, groupAttribute) {
			var result = nodes.filter(function (node) {
				// if articleLabelConfiguration and modelLabelConfiguration configuration present then replace "Article" and "Model" with configured value to filter it with new configured values
				if(angular.isDefined(api.articleLabelConfiguration) && api.articleLabelConfiguration !== '' && api.articleLabelConfiguration.length && node.title.toLowerCase().includes('article')) {
					node.title =  utility.replaceStringWithCase(node.title, 'article', api.articleLabelConfiguration);
				}
				if(angular.isDefined(api.modelLabelConfiguration) && api.modelLabelConfiguration !== '' && api.modelLabelConfiguration.length && node.title.toLowerCase().includes('model')) {
					node.title =  utility.replaceStringWithCase(node.title, 'model', api.modelLabelConfiguration);
				}
				if(angular.isDefined(api.segmentationLabelConfiguration) && api.segmentationLabelConfiguration !== '' && api.segmentationLabelConfiguration.length) {
					if(node.title.toLowerCase().includes('segmentation')) {
						node.title =  utility.replaceStringWithCase(node.title, 'segmentation', api.segmentationLabelConfiguration);
					}
					if(node.subTitle && node.subTitle.toLowerCase().includes('segmentation')) {
						node.subTitle =  utility.replaceStringWithCase(node.subTitle, 'segmentation', api.segmentationLabelConfiguration);
					}
				}

				if (node.children) {
					node.children = filterMyTree(node.children, predicate, filterEmptyGroups);
				}
				var match = true;
				for (var key in predicate) {
					if ((!node[groupAttribute] &&
						(node[key] == null || node[key].toString().toLowerCase().indexOf(predicate[key].toString().toLowerCase()) === -1) && (angular.isUndefined(node['subTitle']))) ||
						(filterEmptyGroups && node[groupAttribute] && !node.children.length)) { // filter out empty groups
						match = false;
						break;
					}
				}
				if(node['isAuthorized'] === true) {
					return match;
				} else {
					return false;
				}
			});
			return result;
		}
	};
})();
(function() {
    'use strict';

    angular
        .module('fuse')
        .filter('elapsed', elapsed);
    
    /**
     * Filters array of object based on object-property 'property' whos value is equels to 'group' 
     * */
    function elapsed($filter) {
        return function(difference) {
            if (!difference) return;
            //var time = Date.parse(date),
            //    difference = (new Date()) - time;
            
            // Seconds (e.g. 32s)
            difference /= 1000;
            if (difference < 60) return Math.floor(difference)+'s';

            // Minutes (e.g. 12m)
            difference /= 60;
            if (difference < 60) return Math.floor(difference)+'m';

            // Hours (e.g. 5h)
            difference /= 60;
            if (difference < 24) return Math.floor(difference)+'h';

            // Date (e.g. Dec 2)
            return $filter('date')(time, 'MMM d');
        }
    }
})();
(function() {
		'use strict';

		angular
				.module('fuse')
				.filter('dataTableFilter', dataTableFilter);

		/**
		 * @description:
		 * a custom filter which make filtering large date efficient, it support filtering string, date and boolean values
		 * it also supports exact match by prefixing `!` and can perform normal filtering by prefixing `*` or without prefixing any
		 * of these two special characters
		 * @param: {array }items: data to be filter
		 * @param: {object} filterObj: map of key value pair, key specify property/column to be filtered and value is filter data
		 * @param: {object} model: module's model object
		 * @param: {object} lookupData: (optional but recommended) lookup data of module's model
		 * @returns: filtered data
		 * */

		function dataTableFilter(api, $filter, catalogFactory, utility) {
				return function(items, filterObj, model, lookupData) {
						var modelInfo = {
								lookupFields: [],
								lookupFieldNames: [],
								lookupManyFieldNames: [],
								lookupManyFields: [],
								modelFieldsMap: {},
								fieldWithPrefixZerosEnabled: {},
								lookupFromMapNames: [],
								lookupFromMapFields: []
						};

						if(angular.isDefined(model)) {
								angular.forEach(model.fields, function(field, index) {
										modelInfo.modelFieldsMap[field.field] = index;
										if((field.inputType === 'lookup' || field.inputType === 'articlenumber' || field.inputType === 'modelnumber' || field.inputType === 'linkedcatalogarticlenumber') && field.visible) {
												modelInfo.lookupFieldNames.push(field.field);
												modelInfo.lookupFields.push(field);
										} else if(field.inputType === 'lookup-many' && field.visible) {
												modelInfo.lookupManyFieldNames.push(field.field);
												modelInfo.lookupManyFields.push(field);
										} else if(angular.isDefined(field.prefixZeros) && field.prefixZeros > 0) { // prefixZeros
												modelInfo.fieldWithPrefixZerosEnabled[field.field] = field.prefixZeros;
										} if(field.inputType === 'lookup-from-map') {
												modelInfo.lookupFromMapFields.push(field);
												modelInfo.lookupFromMapNames.push(field.field);
										}
								});
						}

						// if caller forget or did not pass lookupData (recommend to pass lookupdata)
						if(angular.isUndefined(lookupData) && angular.isDefined(model)) {
								api.getLookupDataForModel(model).then(function(lookupdta) {
										lookupData = lookupdta;
										return items.filter(createPredicateFn(filterObj, model, lookupData, modelInfo));
								});
						}
						else {
								return items.filter(createPredicateFn(filterObj, model, lookupData, modelInfo));
						}
				};


				function createPredicateFn(filterObj, model, lookupData, modelInfo) {
						return function(record) {
								var item = {};
								for(var key in record) { // remove angular.copy to improve performance, to prevent data value changes for lookup data
										item[key] = record[key];
								}
								var matches = true;

								for (var prop in filterObj) {
									// if lookup, articlenumber, modelnumber and linkedcatalogarticlenumber types
									if(modelInfo.lookupFieldNames.indexOf(prop) !== -1) {
											item[prop] = $filter('recordRenderer')(item[prop], lookupData, modelInfo.lookupFields[modelInfo.lookupFieldNames.indexOf(prop)]);
									}
									// if lookup-many field
									if(modelInfo.lookupManyFieldNames.indexOf(prop) !== -1) {
										item[prop] = $filter('lookupManyRenderer')(item[prop], lookupData, modelInfo.lookupManyFields[modelInfo.lookupManyFieldNames.indexOf(prop)]);
									}

									// look from map
									if(modelInfo.lookupFromMapNames.indexOf(prop) !== -1) {
											var lookupSource = modelInfo.lookupFromMapFields[modelInfo.lookupFromMapNames.indexOf(prop)].lookupSource;
											// remove the "vm.api." prefix from the lookupSource
											// lookup-from-map should be from the index.api file
											if (lookupSource.startsWith('vm.api.')) {
													lookupSource = lookupSource.substring(7);
											}
											item[prop] = api[lookupSource][item[prop]];
									}

									if (angular.isDefined(filterObj[prop]) && filterObj[prop] !== '' && filterObj[prop] !== null) {
											//filter array
											if (angular.isArray(filterObj[prop]) && filterObj[prop].length > 0) {
													for (var index = 0; index < filterObj[prop].length; index++) {
															var firstChar = filterObj[prop][index].toString().charAt(0);
															var searchPhrase = filterObj[prop][index].toString().substring(1).toLowerCase();
															var propInputType = '';
															if(angular.isDefined(modelInfo.modelFieldsMap[prop])) {
																propInputType = model.fields[modelInfo.modelFieldsMap[prop]].inputType;
																if(angular.isDefined(model.fields[modelInfo.modelFieldsMap[prop]].inputSubType) && model.fields[modelInfo.modelFieldsMap[prop]].inputSubType === 'multi-value') { // multivalue attributes without vetting list
																	propInputType = model.fields[modelInfo.modelFieldsMap[prop]].inputSubType;
																}
																// only for calculated multi value
																if(angular.isDefined(model.fields[modelInfo.modelFieldsMap[prop]].calcType)) {
																	propInputType = model.fields[modelInfo.modelFieldsMap[prop]].calcType.toLowerCase() === 'multivalue' ? 'multi-value': '';
																}
															}
															if(item[prop] == null) {
																	item[prop] = '';
															}
															var filterObjectValueCopy = angular.copy(filterObj[prop][index]);
															// this is to filter blanks with ''
															if(filterObj[prop][index] === 'blank') {
																filterObjectValueCopy = '';
															}
															if(propInputType === 'multi-value') {
																var attributeMultiValues = item[prop];
																if(filterObjectValueCopy !== '') {
																	var valueIndex = attributeMultiValues.indexOf(filterObjectValueCopy.toString());
																	if (item[prop] != null && valueIndex !== -1) {
																		matches = true;
																		break;
																	}
																} else { // blank
																	if (item[prop].length === 0) {
																		matches = true;
																		break;
																	}
																}
															}
															if(firstChar === '!') {
																	if (item[prop] != null && searchPhrase !== '' && item[prop].toString().toLowerCase() === searchPhrase) {
																			matches = false;
																			break;
																	}
															} else if (propInputType !== 'multi-value' && item[prop] != null && item[prop].toString().toLowerCase() === filterObjectValueCopy.toString().toLowerCase()) {
																	matches = true;
																	break;
															}
															else {
																	matches = false;
															}
													}
											}

											// advanced filter
											else if (angular.isObject(filterObj[prop]) && !angular.isDate(filterObj[prop])) {
													if(filterObj[prop].filterBlank === true && filterObj[prop].excludeMode === true) { // exclude blanks by enbling filter blank and exclude
															if(!(item[prop] !== '' && item[prop] !== null && angular.isDefined(item[prop]))) {
																matches = false;
															}
													} else if(filterObj[prop].filterBlank === true) { // filter blank
															if(!(item[prop] === '' || item[prop] === null || angular.isUndefined(item[prop]))) {
																	matches = false;
															}
													}
													else if(filterObj[prop].excludeMode === false) { // exclude
															if(item[prop] == null || angular.isUndefined(filterObj[prop].filterValues[item[prop].toString().toLowerCase()])) {
																	matches = false;
															}
													}
													else if(filterObj[prop].excludeMode === true) {
															matches = false;
															// if value is null, undefined or empty array or its un-defined in filterValues it matches
															if(item[prop] === '' || item[prop] === null || angular.isUndefined(item[prop]) || angular.isUndefined(filterObj[prop].filterValues[item[prop].toString().toLowerCase()])) {
																	matches = true;
															}
													}
											}

											//filter date
											else if (angular.isDefined(filterObj[prop]) && filterObj[prop] != null && angular.isDate(filterObj[prop])) {
													var date1 = new Date(item[prop]);
													var date2 = new Date(filterObj[prop]);

													date1.setHours(0,0,0,0);
													date2.setHours(0,0,0,0);

													matches = (date1.getTime() === date2.getTime());
													if (!matches) return false;
											}

											// filter string
											else {
													var propInputType = '';
													if(angular.isDefined(modelInfo.modelFieldsMap[prop])) {
														propInputType = model.fields[modelInfo.modelFieldsMap[prop]].inputType;
													}
													if(propInputType !== 'date' && propInputType !== 'date-utc' && propInputType !== 'date-without-time') {
														var firstChar = filterObj[prop].toString().charAt(0);
														var searchPhrase = filterObj[prop].toString().substring(1).toLowerCase();
														// calculate article status value
														if(propInputType === 'article-status') {
															var dataSourceTypeId = catalogFactory.getActiveCatalogDetails().DataSourceTypeId; // used for articles status type
															item[prop] = utility.getArticleStatusValue(item, model.fields[modelInfo.modelFieldsMap[prop]], dataSourceTypeId);
														}
														if(firstChar === '!') { // do exact match
																if (item[prop] == null || (searchPhrase !== '' && item[prop].toString().toLowerCase().indexOf(searchPhrase) !== 0) ) {
																		matches = false;
																}
														}
														else if(firstChar === '*') { //explicit normal filter by prefixing `*`
																if (item[prop] == null || (searchPhrase !== '' && item[prop].toString().toLowerCase().indexOf(searchPhrase) == -1) ) {
																		matches = false;
																}
														}
														else if(filterObj[prop] === 'blank') { // filter blank
															if(!(item[prop] === '' || item[prop] === null || angular.isUndefined(item[prop]))) {
																	matches = false;
															}
														}
														else { // normal filter
																// if prefix with zero assigned compare values with
																var itemValue = item[prop];
																if(modelInfo.fieldWithPrefixZerosEnabled[prop] && itemValue != null) {
																	var itemValueString = itemValue.toString();
																	itemValueString = (angular.equals(itemValueString.substring(itemValueString.length-3, itemValueString.length),".00")) ? itemValueString.substring(0 ,itemValueString.length-3) : itemValueString;
																	itemValue = itemValueString.toString().padStart(modelInfo.fieldWithPrefixZerosEnabled[prop], '0');
																}
																if (itemValue == null || (itemValue.toString().toLowerCase().indexOf(filterObj[prop].toString().toLowerCase()) == -1) ) {
																		matches = false;
																}
														}
													} else if(propInputType === 'date' || propInputType === 'date-utc' || propInputType === 'date-without-time') {
														if(filterObj[prop] === 'blank') { // filter blanks
															if(!(item[prop] === '' || item[prop] === null || angular.isUndefined(item[prop]))) {
																matches = false;
															}
														} else { // date range
															var dateRangeArray = filterObj[prop].split('_');
															var startDate = dateRangeArray[0] !== "undefined" ? new Date(dateRangeArray[0]) : '';
															var endDate = dateRangeArray[1] !== "undefined" ? new Date(dateRangeArray[1]) : '';
															var itmDate = new Date(item[prop]);

															itmDate.setHours(0,0,0,0);

															if(startDate !== '' &&  endDate !== '') {
																startDate.setHours(0,0,0,0);
																endDate.setHours(0,0,0,0);
																matches = (itmDate.getTime() >= startDate.getTime() && itmDate.getTime() <= endDate.getTime());
															} else if(startDate !== '' &&  endDate === '') {
																startDate.setHours(0,0,0,0);
																matches = (itmDate.getTime() >= startDate.getTime());
															} else if(startDate === '' &&  endDate !== '') {
																endDate.setHours(0,0,0,0);
																matches = (itmDate.getTime() <= endDate.getTime());
															}
														}
													}

											}

											if (!matches) return false;

									}
								}

								return matches;
						}
				}
		}

})();
(function() {
	'use strict';

			angular
					.module('fuse')
					.filter('datatableCellRenderer', datatableCellRenderer);
			function datatableCellRenderer() {
				return function (value) {
					var cellData = angular.isString(value)
						? JSON.parse(value)
						: value;
					if (!angular.isArray(cellData) || !cellData.length) {
						return '';
					}

					return cellData.map(function (row, rowIndex) {
						var parts = Object.keys(row)
							.filter(function (key) {
								return row[key] !== null && row[key] !== '';
							})
							.map(function (key) {
								var val = row[key];
								if (angular.isString(val) && val.includes('DisplayValue')) {
										try {
												var obj = JSON.parse(val);
												if (obj.DisplayValue) {
														return key + '=' + obj.DisplayValue;
												}
										} catch (e) {
												return key + '= '
										}
								}
								return key + '=' + val;
							});

						return '[' + (rowIndex + 1) + '] ' + parts.join(' | ');
					}).join(' ; ');
				};
			}
	})();
(function() {
	'use strict';

			angular
					.module('fuse')
					.filter('colorPaletteRenderer', colorPaletteRenderer);
		/**
		 * @description
		 * This filter will show the color name from the object
		 * */
			function colorPaletteRenderer() {
					return function(item, col) {
						if(angular.isDefined(item) && item !== null) {
							if(angular.isObject(item)) {
								item = angular.toJson(item); // while assigning new values it will come as Object
							}
							var isObject = item.includes('{');
							if(isObject) {
								try {
									var prsedObject = JSON.parse(item);
									if(Object.keys(prsedObject).length === 1) {
										var key = Object.keys(prsedObject)[0];
										return prsedObject[key];
									} else {
										return prsedObject['value'];
									}
								} catch(error) {
									console.warn(col.field + " - Color Palette value : Invalid JSON format");
									return '';
								}
							} else {
								return item;
							}
						} else {
							return item;
						}
					}
			}
	})();
(function() {
  'use strict';

  angular
      .module('fuse')
      .filter('changeConfiguredLabels', changeConfiguredLabels);

  /**
   * @description
   * replace configured labels with "Article" and "Model"
   * */
  function changeConfiguredLabels(api, utility) {
    return function(value){
      // if articleLabelConfiguration and modelLabelConfiguration configuration present then replace "Article" and "Model" with configured value to filter it with new configured values
      if((angular.isDefined(api.articleLabelConfiguration) && api.articleLabelConfiguration !== '') || (angular.isDefined(api.modelLabelConfiguration) && api.modelLabelConfiguration !== '') || (angular.isDefined(api.segmentationLabelConfiguration) && api.segmentationLabelConfiguration !== '')) {
        var count = 0;
        if(value.toLowerCase().includes('article')) {
          count ++;
          return utility.replaceStringWithCase(value, 'article', api.articleLabelConfiguration);
        }
        if(value.toLowerCase().includes('model')) {
          count ++;
          return utility.replaceStringWithCase(value, 'model', api.modelLabelConfiguration);
        }
        if(value.toLowerCase().includes('segmentation')) {
          count ++;
          return utility.replaceStringWithCase(value, 'segmentation', api.segmentationLabelConfiguration);
        }
        if(count === 0) {
          return value;
        }
      } else {
        return value;
      }
    }
  }
})();
(function() {
  'use strict';

      angular
          .module('fuse')
          .filter('catalogsRenderer', catalogsRenderer);
    /**
     * @description
     * This filter transforms the display value of property AffectedCatalogs/BlockedCatalogs in Article Blocking Module. It transforms array of CatalogCode into string of Catalog Names.
     * */
      function catalogsRenderer(catalogFactory) {
          return function(catalogsIdArray) {
              var catalogs = "";
              var catalogsMap = {};
              angular.forEach(catalogFactory.getListOfCatalogs(), function(catalog) {
                catalogsMap[catalog.CatalogCode] = catalog.CatalogName;
              });
              angular.forEach(catalogsIdArray, function (catalogId) {
                if(catalogsMap[catalogId]) {
                        catalogs = catalogs + catalogsMap[catalogId] + ', ';
                }
              })
              return  catalogs.trim().slice(0, -1);
          }
      }
  })();
(function() {
	'use strict';

	angular
		.module('fuse')
		.filter('arrayTagsRenderer', arrayTagsRenderer);

	/**
 * @description
	 * This filter transforms the array into a string with tags separated by the specified separator,
	 * trims each item, removes special characters, and sorts the array in alphabetical order.
	 */
	function arrayTagsRenderer() {
		return function(item, tagSeparator) {
			var value = undefined;
			if(item != null && angular.isArray(item) && item.length) {
				item = item.map(function(tag) {
					tag = tag.trim();
					return tag;
				});

				// Sort the array alphabetically case-insensitive
				item.sort(function(a, b) {
					return a.toLowerCase().localeCompare(b.toLowerCase());
				});

				// Join the sorted and cleaned array into a string with the specified separator
				value = item.join(tagSeparator);
			} else if(item != null && item.length) {
				value = item;
			}
			return value;
		}
	}
})();
(function() {
  'use strict';

  angular
      .module('fuse')
      .filter('ampersand', ampersand);
  /**
   * @description
   * convert &amp; to & in after translate
   * */
  function ampersand() {
    return function(value){
      return value ? value.replace(/&amp;/g, '&').replace(/&#232;/g, 'è') : '';
    }
  }
})();
(function() {
    'use strict';

    angular
        .module('fuse')
        .filter('advancedSearch', advancedSearch);

    /**
     * @description
     * this filter is used for advanced search where a user can search in record's specific properties with multiple values
     * @param {array} records: list of data to be filtered
     * @param {array} searchedValues: array of values to be search
     * @param {array} searchableProperties: properties of object to be seach on
     * @param {object} model: data model
     * @returns filtered data
     * */

    function advancedSearch(utility) {
        return function(records, searchedValues, model, searchableProperties) {
            var plunkedRecords = [];
            var redundantResultIds =[];
            var result = [];
            // plunk objects with searchableProperties
            if(searchableProperties.indexOf(model.idField) === -1) {
                searchableProperties.push(model.idField); // used for removing duplicates
            }
            angular.forEach(angular.copy(records), function(record) {
                plunkedRecords.push(utility.plunkObject(record, searchableProperties));
            });

            if(!angular.isArray(searchedValues)) { // to be able to use it for normal search without having condition
                searchedValues = utility.pushItemToArray(searchedValues);
            }

            // create possibly redundant search result
            angular.forEach(searchedValues, function(searchedValue) {
                var tempResult = utility.filterObject(plunkedRecords, searchedValue);
                //concatinate results for each search value
                angular.forEach(tempResult, function(tempRslt) {
                    redundantResultIds.push(tempRslt[model.idField]);
                });
            });
            result = createNonRedundatntResult(records, redundantResultIds, model, utility);
            return result;
        };
    }

    function createNonRedundatntResult(records, redundantResultIds, model, utility) {
        var result = [];
        angular.forEach(redundantResultIds, function(redundantRsltId) {
            var uniquePredicate = {};
            uniquePredicate[model.idField] = redundantRsltId;
            var matchedRecord = utility.filterObject(records, uniquePredicate, true)[0];
            if(result.indexOf(matchedRecord) === -1) {
                result.push(matchedRecord);
            }
        });
        return result;
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .run(runBlock);

    /** @ngInject */
    function runBlock(msUtils, fuseGenerator, fuseConfig)
    {
        /**
         * Generate extra classes based on registered themes so we
         * can use same colors with non-angular-material elements
         */
        fuseGenerator.generate();

        /**
         * Disable md-ink-ripple effects on mobile
         * if 'disableMdInkRippleOnMobile' config enabled
         */
        if ( fuseConfig.getConfig('disableMdInkRippleOnMobile') && msUtils.isMobile() )
        {
            var bodyEl = angular.element('body');
            bodyEl.attr('md-no-ink', true);
        }

        /**
         * Put isMobile() to the html as a class
         */
        if ( msUtils.isMobile() )
        {
            angular.element('html').addClass('is-mobile');
        }

        /**
         * Put browser information to the html as a class
         */
        var browserInfo = msUtils.detectBrowser();
        if ( browserInfo )
        {
            var htmlClass = browserInfo.browser + ' ' + browserInfo.version + ' ' + browserInfo.os;
            angular.element('html').addClass(htmlClass);
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($ariaProvider, $logProvider, msScrollConfigProvider, $translateProvider, fuseConfigProvider)
    {
        // ng-aria configuration
        $ariaProvider.config({
            tabindex: false
        });

        // Enable debug logging
        $logProvider.debugEnabled(true);

        // msScroll configuration
        msScrollConfigProvider.config({
            wheelPropagation: true
        });

        // toastr configuration
        toastr.options.timeOut = 3000;
        toastr.options.positionClass = 'toast-top-right';
        toastr.options.preventDuplicates = true;
        toastr.options.progressBar = true;

        // angular-translate configuration
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: '{part}/i18n/{lang}.json'
        });
        $translateProvider.preferredLanguage('en');
        $translateProvider.useSanitizeValueStrategy('sanitize');
        // custom interpolator to replace "Article", "Model" and "Segmentation" with configured values
        $translateProvider.useInterpolation('renameArticleModelAndSegmentationLabels');

        // Fuse theme configurations
        fuseConfigProvider.config({
            'disableCustomScrollbars'        : false,
            'disableCustomScrollbarsOnMobile': true,
            'disableMdInkRippleOnMobile'     : true
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .run(runBlock);

    /** @ngInject */
    function runBlock($rootScope, $timeout, $window, $state, $mdDialog, $auth, SecurityFactory, toast, settingsFactory, $log,
        msNavigationService, stateHistoryTracker, catalogFactory, $localStorage, Idle, CONSTANTS, Title, errorDialog)
    {
        var isAppInitialized;
        var factorySettings;
        Title.original('T1 - Admin'); //set original title of application so when user unlock application after idle lock original title can be restored
        // Watch for Idle
        var idleEvent = $rootScope.$on('IdleTimeout', function() {
            $mdDialog.cancel();
            $auth.logout();
            $state.go('app.auth_lock');
        });

        var keepAliveEvent = $rootScope.$on('Keepalive', function() {
            $localStorage.lastKeepAlive = new Date();
        });

        // Activate loading indicator
        var stateChangeStartEvent = $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {

            //remove storage event before login
            if(toState.name === 'app.auth_login'){
                $window.removeEventListener('storage', storageChange, false);
            }

            // block T1 access on IE browsers
           if( (/*@cc_on!@*/false || !!$window.document.documentMode) /*IE*/ && toState.name !== 'app.errors_unsupported_browser') {
               event.preventDefault();
               $state.go('app.errors_unsupported_browser')
           }
           else if(toState.name !== 'app.errors_unsupported_browser') {
                $rootScope.loadingProgress = true;


                //AUTH TOKEN HANDLING
                if (toState.name.indexOf('app.auth_') !== 0) {
                    // when the application is initialized for the first time, then set general privileges and (if catalogCode of active catalog is defined) catalog privileges .
                    if (!SecurityFactory.factoryState.isPrivilegeSetUp) {
                        var activeCatalogCode = (angular.isDefined($localStorage.ActiveCatalog) && $localStorage.ActiveCatalog != null) ? $localStorage.ActiveCatalog.CatalogCode : undefined;
                        SecurityFactory.setPrivileges(activeCatalogCode);
                    }

                    if(isAppInitialized === true) {
                        factorySettings = settingsFactory.getSettings();
                    }
                    else if(angular.isDefined($localStorage.profileInformation) && angular.isDefined($localStorage.profileInformation.Settings)
                            && $localStorage.profileInformation.Settings != null && $localStorage.profileInformation.Settings != "") {
                        factorySettings = angular.fromJson($localStorage.profileInformation.Settings);
                    }
                    var currentDate = new Date();
                    var lastDate = new Date(2000,1,1);

                    if (angular.isDefined($localStorage.lastKeepAlive)) {
                        lastDate = new Date($localStorage.lastKeepAlive);
                    }

                    $localStorage.lastState = { name: toState.name, params: toParams };

                    if (!$auth.isAuthenticated()) {
                        $log.info('DENY');
                        event.preventDefault();
                        $state.go('app.auth_login');
                    } else if (currentDate - lastDate > (60000 * 20) /* 20 mins*/ && (factorySettings == null || angular.isUndefined(factorySettings)
                                || angular.isUndefined(factorySettings.autoLock) || factorySettings.autoLock == true)) {
                        $log.info('SESSION TIMEOUT!');
                        event.preventDefault();
                        $state.go('app.auth_lock');
                    } else if(SecurityFactory.isAuthorized(toState.accessInfo)) { //Checks user authority to visit a url/state
                        $log.info('ALLOW');
                        // determine page refresh- only execute once for initialization purpose
                        if(angular.isUndefined(isAppInitialized) || isAppInitialized === false) {
                            InitializeApp();
                        }
                        isAppInitialized = true;
                        catalogFactory.getAndSetAppVersion()

                        //move to else of following if
                        // if(catalogFactory.getCatalogRequestDispatchStatus() === true) {// execute only if call to set active catalog dispatched (for consecutive calls)
                        //     setCatalogDropdownVisibility(toState, event);
                        // }
                        //if list of catalogs not been populated -- dispatchedRequestForCatalogs is used to prevent recursive call execute the block
                        if( (catalogFactory.getListOfCatalogs().length === 0 && !catalogFactory.getCatalogRequestDispatchStatus())
                            || (catalogFactory.getListOfCatalogs().length !== 0 && angular.isUndefined($localStorage.ActiveCatalog)
                            || catalogFactory.getListOfCatalogs().length !== 0 && !catalogFactory.getCatalogRequestDispatchStatus()) ) { // switch user
                            catalogFactory.setCatalogRequestDispatchStatus(true);
                            event.preventDefault();
                            initializeActiveCatalog().then(function() {
                                if (!SecurityFactory.isSecured) {
                                    //Remove navigation items that are not allowed
                                    SecurityFactory.removeUnauthorizedNav(angular.isDefined($localStorage.ActiveCatalog) && $localStorage.ActiveCatalog.IsLinePlan);
                                    SecurityFactory.isSecured = true;
                                }
                                setCatalogDropdownVisibility(toState, event);
                                catalogFactory.setIsActiveCatalogInitialized(true)
                                $state.go(toState, toParams);
                            }).catch(function (error) {
                                // when API fails with error
                                errorDialog.show('LOGIN.ERRORS.UNEXPECTED_ERROR', error).then(function (showDetails) {
                                    if (showDetails) {
                                        errorDialog.showDetailsDialog(error);
                                    }
                                });
                                $state.reload('app.auth_login');
                            });
                        }
                        else if(catalogFactory.getCatalogRequestDispatchStatus() === true) {
                            setCatalogDropdownVisibility(toState, event);
                        }

                        watchForIdle();

                        // Above code will get execute at least once and it will secure the navigation menu
                        // if (!SecurityFactory.isSecured) {
                        //     var navObj = msNavigationService.getNavigationObject();
                        //     //Remove navigation items that are not allowed
                        //     SecurityFactory.removeUnauthorizedNav(navObj);
                        //     SecurityFactory.isSecured = true;
                        // }
                    }

                    else {
                        event.preventDefault();
                        toast.show('','Not Authorized!','');
                        if(angular.isUndefined(fromState.name) || fromState.name === '') { // when trying to navigate to an unauthorized state by changing URL
                            $state.go(CONSTANTS.LANDING_PAGE.STATE);
                        }
                        else if(fromState.name.indexOf('app.auth_') === -1) { //when not in any of auth states- stay on same page
                            $state.go(fromState, fromParams);
                            $rootScope.loadingProgress = false;
                        }
                        //if user in one of the auth pages and not-authorized to go to preserve stage (lastState in local storage) navigate to default page
                        else if(fromState.name !== toState.name) {//check to avoid infinite loop, possible that user does not have privilege to navigate to landing page
                            $state.go(CONSTANTS.LANDING_PAGE.STATE);
                        }
                        else { // when do not have access to landing page send user to login page
                            $log.warn('No access to landing page');
                            $state.go('app.auth_login');
                        }
                    }
                }

                else {
                    //Stop watching for Idle
                    if (Idle.running()) {
                        Idle.unwatch();
                    }
                }
            }
        });

        // De-activate loading indicator
        var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams)
        {
            $timeout(function ()
            {
                $rootScope.loadingProgress = false;

                if (fromState) {
                    stateHistoryTracker.add(fromState, fromParams);
                }
            });
        });

        //$rootScope.$apply(function() {
        $rootScope.online = true;
        //});
        $window.addEventListener("offline", function() {
            $rootScope.$apply(function() {
                $rootScope.online = false;
            });
        }, false);

        $window.addEventListener("online", function() {
            $rootScope.$apply(function() {
                $rootScope.online = true;
            });
        }, false);

        function initializeActiveCatalog() {
            return catalogFactory.updateListOfCatalogs();
        }

        //display active catalog drop down if state is one of specified states
        function setCatalogDropdownVisibility(state, event) {
            var activeCatalog = catalogFactory.getActiveCatalog();
            // active catalog dropdown will be visible for all modules
            $rootScope.isCatalogDropdownDisabled = false;
            // for catalog related data details pages active catalog dropdown will be disabled
            if (state.name === 'app.articles.details' || state.name === 'app.customers.details'
                || state.name === 'app.assortments.details' || state.name === 'app.packages.details'
                || state.name === 'app.images.details' || state.name === 'app.resources.details'
                || state.name === 'app.orders.details' || state.name === 'app.consolidations.details' || state.name === 'app.consolidation-templates.details'
                || state.name === 'app.allocation_groups.details' || state.name === 'app.customer_allocations.details' || state.name === 'app.forecast.details'
                || state.name === 'app.favorites.details' || state.name === 'app.merch_boards.details' || state.name === 'app.order_adjustments.details'
                || state.name === 'app.dune-images.details' || state.name === 'app.requests.details'
                || state.name === 'app.catalog-models.details' || state.name === 'app.buyer_limits.details' || state.name === 'app.orders_terms_conditions.details' || state.name === 'app.buy_windows.details'
                || state.name === 'app.shared_folders.details' || state.name === 'app.shared_folders_tree.details') {
                if(angular.isUndefined(activeCatalog)) {
                    redirectToErrorState('ERRORS.NO_ACTIVE_CATALOG', event);
                }
                $rootScope.isCatalogDropdownDisabled = true;
            }
        }

        function redirectToErrorState(errorMessage, event) {
            event.preventDefault();
            var stateParam = {message: errorMessage};
            $state.go('app.errors', stateParam);
        }

        // get called when user is authenticated and app initialize for first time or page refreshed
        function InitializeApp() {
            if($localStorage.profileInformation.Settings == null) {
                $localStorage.profileInformation.Settings = "";
            }
             //save current user id in settings factory (in memory)
             settingsFactory.initializeSettingsFactory($localStorage.profileInformation.Settings, $localStorage.UserId);

             //add event listener storage so that when user logs out, he logs out from all the tabs
             $window.addEventListener('storage', storageChange, false);
        }

        function watchForIdle() {
            if (!Idle.running()) {
                if(angular.isDefined(factorySettings) && angular.isDefined(factorySettings.autoLock)) {
                    if(factorySettings.autoLock == true) {
                        if(factorySettings.autoLockInterval) {
                            Idle.setIdle((factorySettings.autoLockInterval*60)-Idle.getTimeout());
                        }
                        Idle.watch();
                        Title.restore(); // restore application title
                    }
                }
                else {
                    Idle.watch();
                    Title.restore(); // restore application title
                }
            }
        }

        function storageChange(event) {
            if(event.key === 'ngStorage-UserId' && event.newValue != event.oldValue) {
                var stateParams = { shouldLogout: false };
                $state.go('app.auth_login', stateParams); // navigate user to login without removing anything from localStorage
            }
            if(!$auth.isAuthenticated()) {
                $window.location.href = '/auth/login'; //navigate to login page on user log out
            }
        }


        // Store state in the root scope for easy access
        $rootScope.state = $state;

        // Cleanup
        $rootScope.$on('$destroy', function ()
        {
            stateChangeStartEvent();
            stateChangeSuccessEvent();
            idleEvent();
        });

    }
})();
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider, $locationProvider)
    {
        $locationProvider.html5Mode(true);

        $urlRouterProvider.otherwise('/404');

        // State definitions
        $stateProvider
            .state('app', {
                abstract: true,
                views   : {
                    'main@'         : {
                        templateUrl: 'app/core/layouts/vertical-navigation.html',
                        controller : 'MainController as vm'
                    },
                    'toolbar@app'   : {
                        templateUrl: 'app/toolbar/layouts/vertical-navigation/toolbar.html',
                        controller : 'ToolbarController as vm'
                    },
                    'navigation@app': {
                        templateUrl: 'app/navigation/layouts/vertical-navigation/navigation.html',
                        controller : 'NavigationController as vm'
                    },
                    'quickPanel@app': {
                        templateUrl: 'app/quick-panel/quick-panel.html',
                        controller : 'QuickPanelController as vm'
                    }
                }
            });
    }

})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .controller('IndexController', IndexController);

    /** @ngInject */
    function IndexController(fuseTheming)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .constant('CONSTANTS', {

            'CRD_DATE_FORMAT': 'MMM d, y',
            'LINE_PLAN_CATALOG': 'line plan',
            'LINE_PLAN_ID': 4,
            'OPEN_SEGMENTATION': 'Open',

            'LANDING_PAGE': {
                'STATE': 'app.pages_landing',
                'PARAM': ''
            },

            'LOG' : {
                'ACTIONS': {
                    'LOGIN': {
                        'id': 1,
                        'displayName': 'LOG.ACTIONS.LOGIN',
                        'icon' : '',
                        'severity': 30

                    },
                    'VIEW': {
                        'id': 2,
                        'displayVerb': 'LOG.ACTIONS.VIEW_VERB',
                        'displayName': 'LOG.ACTIONS.VIEW',
                        'displayNameBulk': 'LOG.ACTIONS.VIEW_BULK',
                        'icon' : 'icon-eye',
                        'iconBulk': 'icon-format-list-bulleted',
                        'severity': 30
                    },
                    'ADD': {
                        'id': 3,
                        'displayVerb': 'LOG.ACTIONS.ADD_VERB',
                        'displayName': 'LOG.ACTIONS.ADD',
                        'displayNameBulk': 'LOG.ACTIONS.ADD_BULK',
                        'icon' : 'icon-plus',
                        'iconBulk': 'icon-playlist-plus',
                        'severity': 20
                    },
                    'EDIT': {
                        'id': 4,
                        'displayVerb': 'LOG.ACTIONS.EDIT_VERB',
                        'displayName': 'LOG.ACTIONS.EDIT',
                        'displayNameBulk': 'LOG.ACTIONS.EDIT_BULK',
                        'icon' : 'icon-border-color',
                        'iconBulk': 'icon-table-edit',
                        'severity': 20
                    },
                    'DELETE': {
                        'id': 5,
                        'displayVerb': 'LOG.ACTIONS.DELETE_VERB',
                        'displayName': 'LOG.ACTIONS.DELETE',
                        'displayNameBulk': 'LOG.ACTIONS.DELETE_BULK',
                        'icon' : 'icon-delete',
                        'iconBulk': 'icon-delete-variant',
                        'severity': 10
                    },
                    'ACTIVATE': {
                        'id': 6,
                        'displayVerb': 'LOG.ACTIONS.UNDELETE_VERB',
                        'displayName': 'LOG.ACTIONS.UNDELETE',
                        'displayNameBulk': 'LOG.ACTIONS.UNDELETE_BULK',
                        'icon' : 'icon-undo',
                        'iconBulk': 'icon-undo-variant',
                        'severity': 10
                    },
                    'SUBMIT': {
                        'id': 7,
                        'displayVerb': 'LOG.ACTIONS.SUBMIT_VERB',
                        'displayName': 'LOG.ACTIONS.SUBMIT',
                        'displayNameBulk': 'LOG.ACTIONS.SUBMIT_BULK',
                        'icon' : 'icon-undo', //TODO- need to change icon
                        'iconBulk': 'icon-undo-variant',//TODO- need to change icon
                        'severity': 10
                    },
                    'APPROVE': {
                        'id': 8,
                        'displayVerb': 'LOG.ACTIONS.APPROVE_VERB',
                        'displayName': 'LOG.ACTIONS.APPROVE',
                        'displayNameBulk': 'LOG.ACTIONS.APPROVE_BULK',
                        'icon' : 'icon-undo',//TODO- need to change icon
                        'iconBulk': 'icon-undo-variant',//TODO- need to change icon
                        'severity': 10
                    },
                    'REJECT': {
                        'id': 9,
                        'displayVerb': 'LOG.ACTIONS.REJECT_VERB',
                        'displayName': 'LOG.ACTIONS.REJECT',
                        'displayNameBulk': 'LOG.ACTIONS.REJECT_BULK',
                        'icon' : 'icon-undo',//TODO- need to change icon
                        'iconBulk': 'icon-undo-variant',//TODO- need to change icon
                        'severity': 10
                    },
                    'REOPEN': {
                        'id': 10,
                        'displayVerb': 'LOG.ACTIONS.REOPEN_VERB',
                        'displayName': 'LOG.ACTIONS.REOPEN',
                        'displayNameBulk': 'LOG.ACTIONS.REOPEN_BULK',
                        'icon' : 'icon-undo',//TODO- need to change icon
                        'iconBulk': 'icon-undo-variant',//TODO- need to change icon
                        'severity': 10
                    },
                    'CONFIRM': {
                        'id': 11,
                        'displayVerb': 'LOG.ACTIONS.CONFIRM_VERB',
                        'displayName': 'LOG.ACTIONS.CONFIRM',
                        'displayNameBulk': 'LOG.ACTIONS.CONFIRM_BULK',
                        'icon' : 'icon-undo',//TODO- need to change icon
                        'iconBulk': 'icon-undo-variant',//TODO- need to change icon
                        'severity': 10
                    },
                    'RE_ORDER': {
                        'id': 13,
                        'displayVerb': 'LOG.ACTIONS.EDIT_VERB',
                        'displayName': 'LOG.ACTIONS.RE_ORDER',
                        'displayNameBulk': 'LOG.ACTIONS.RE_ORDER',
                        'icon' : 'icon-border-color',//TODO- need to change icon
                        'iconBulk': 'icon-table-edit',//TODO- need to change icon
                        'severity': 20
                    },
                     'IMPORT': {
                        'id': 14,
                        'displayVerb': 'LOG.ACTIONS.IMPORT_VERB',
                        'displayName': 'LOG.ACTIONS.IMPORT',
                        'displayNameBulk': 'LOG.ACTIONS.IMPORT',
                        'icon' : 'icon-import',
                        'iconBulk': 'icon-import',
                        'severity': 20
                    },
                    'RESENDACTIVATIONMAIL': {
                        'id': 15,
                        'displayVerb': 'LOG.ACTIONS.RESENDACTIVATIONMAILL_WERB',
                        'displayName': 'LOG.ACTIONS.RESENDACTIVATIONMAIL',
                        'displayNameBulk': 'LOG.ACTIONS.RESENDACTIVATIONMAIL',
                        'icon' : 'icon-border-color',//TODO- need to change icon
                        'iconBulk': 'icon-table-edit',//TODO- need to change icon
                        'severity': 20
                    },
                    'UNASSIGN':{
                        'id': 15,
                        'displayVerb': 'LOG.ACTIONS.UNASSIGN_WERB',
                        'displayName': 'LOG.ACTIONS.UNASSIGN',
                        'displayNameBulk': 'LOG.ACTIONS.UNASSIGN_BULK',
                        'icon' : 'icon-link-off',
                        'iconBulk': 'icon-link-off',
                        'severity': 10
                    },
                    'CANCEL': {
                        'id': 16,
                        'displayVerb': 'LOG.ACTIONS.CANCEL_VERB',
                        'displayName': 'LOG.ACTIONS.CANCEL',
                        'displayNameBulk': 'LOG.ACTIONS.CANCEL_BULK',
                        'icon' : 'icon-undo',//TODO- need to change icon
                        'iconBulk': 'icon-undo-variant',//TODO- need to change icon
                        'severity': 10
                    },
                    'LOCK': {
                        'id': 17,
                        'displayVerb': 'LOG.ACTIONS.LOCK_VERB',
                        'displayName': 'LOG.ACTIONS.LOCK_PRICES',
                        'displayNameBulk': 'LOG.ACTIONS.LOCK_PRICES',
                        'icon' : 'icon-undo',//TODO- need to change icon
                        'iconBulk': 'icon-undo-variant',//TODO- need to change icon
                        'severity': 10
                    },
                    'UNLOCK': {
                        'id': 18,
                        'displayVerb': 'LOG.ACTIONS.UNLOCK_VERB',
                        'displayName': 'LOG.ACTIONS.UNLOCK_PRICES',
                        'displayNameBulk': 'LOG.ACTIONS.UNLOCK_PRICES',
                        'icon' : 'icon-undo',//TODO- need to change icon
                        'iconBulk': 'icon-undo-variant',//TODO- need to change icon
                        'severity': 10
                    },
                    'SETSIZES': {
                        'id': 19,
                        'displayVerb': 'LOG.ACTIONS.SETSIZES_VERB',
                        'displayName': 'LOG.ACTIONS.SETSIZES',
                        'displayNameBulk': 'LOG.ACTIONS.SETSIZES_BULK',
                        'icon' : 'icon-undo',//TODO- need to change icon
                        'iconBulk': 'icon-undo-variant',//TODO- need to change icon
                        'severity': 10
                    },
                    'STOP_ORDERS': {
                        'id': 20,
                        'displayVerb': 'LOG.ACTIONS.STOP_ORDERS_VERB',
                        'displayName': 'LOG.ACTIONS.STOP_ORDERS',
                        'displayNameBulk': 'LOG.ACTIONS.STOP_ORDERS_BULK',
                        'icon' : 'icon-close',
                        'iconBulk': 'icon-close',
                        'severity': 10
                    },
                    'ALLOW_ORDERS': {
                        'id': 21,
                        'displayVerb': 'LOG.ACTIONS.ALLOW_ORDERS_VERB',
                        'displayName': 'LOG.ACTIONS.ALLOW_ORDERS',
                        'displayNameBulk': 'LOG.ACTIONS.ALLOW_ORDERS_BULK',
                        'icon' : 'icon-check',
                        'iconBulk': 'icon-check',
                        'severity': 10
                    },
                    'MERGE': {
                        'id': 22,
                        'displayVerb': 'LOG.ACTIONS.MERGE_BUYERS_VERB',
                        'displayName': 'LOG.ACTIONS.MERGE_BUYERS',
                        'displayNameBulk': 'LOG.ACTIONS.MERGE_BUYERS_BULK',
                        'icon' : 'icon-check',
                        'iconBulk': 'icon-check',
                        'severity': 10
                    },
                    'PUBLISH': {
                        'id': 23,
                        'displayVerb': 'LOG.ACTIONS.PUBLISH_VERB',
                        'displayName': 'LOG.ACTIONS.PUBLISH',
                        'displayNameBulk': 'LOG.ACTIONS.PUBLISH_BULK',
                        'icon' : 'icon-check',
                        'iconBulk': 'icon-check',
                        'severity': 10
                    },
                    'DRAFT': {
                        'id': 24,
                        'displayVerb': 'LOG.ACTIONS.DRAFT',
                        'displayName': 'LOG.ACTIONS.DRAFT_VERB',
                        'displayNameBulk': 'LOG.ACTIONS.DRAFT_BULK',
                        'icon' : 'icon-check',
                        'iconBulk': 'icon-check',
                        'severity': 10
                    },
                    'DISABLE_REQUESTS': {
                        'id': 25,
                        'displayVerb': 'LOG.ACTIONS.DISABLE_REQUESTS_VERB',
                        'displayName': 'LOG.ACTIONS.DISABLE_REQUESTS',
                        'displayNameBulk': 'LOG.ACTIONS.DISABLE_REQUESTS',
                        'icon' : 'icon-close',
                        'iconBulk': 'icon-close',
                        'severity': 10
                    },
                    'ENABLE_REQUESTS': {
                        'id': 26,
                        'displayVerb': 'LOG.ACTIONS.ENABLE_REQUESTS_VERB',
                        'displayName': 'LOG.ACTIONS.ENABLE_REQUESTS',
                        'displayNameBulk': 'LOG.ACTIONS.ENABLE_REQUESTS',
                        'icon' : 'icon-check',
                        'iconBulk': 'icon-check',
                        'severity': 10
                    },
                    'DEACTIVATE': {
                        'id': 27,
                        'displayVerb': 'LOG.ACTIONS.DEACTIVATE_VERB',
                        'displayName': 'LOG.ACTIONS.DELETE',
                        'displayNameBulk': 'LOG.ACTIONS.DELETE_BULK',
                        'icon' : 'icon-delete',
                        'iconBulk': 'icon-delete-variant',
                        'severity': 10
                    },
                    'STOP_REQUESTS': {
                        'id': 28,
                        'displayVerb': 'LOG.ACTIONS.STOP_REQUESTS_VERB',
                        'displayName': 'LOG.ACTIONS.STOP_REQUESTS',
                        'displayNameBulk': 'LOG.ACTIONS.STOP_REQUESTS',
                        'icon' : 'icon-close',
                        'iconBulk': 'icon-close',
                        'severity': 10
                    },
                    'ACCEPT_REQUESTS': {
                        'id': 29,
                        'displayVerb': 'LOG.ACTIONS.ACCEPT_REQUESTS_VERB',
                        'displayName': 'LOG.ACTIONS.ACCEPT_REQUESTS',
                        'displayNameBulk': 'LOG.ACTIONS.ACCEPT_REQUESTS',
                        'icon' : 'icon-check',
                        'iconBulk': 'icon-check',
                        'severity': 10
                    },
                    'MANAGE_CONTEXT': {
                        'id': 30,
                        'displayVerb': 'LOG.ACTIONS.MANAGE_CONTEXT_VERB',
                        'displayName': 'LOG.ACTIONS.MANAGE_CONTEXT',
                        'displayNameBulk': 'LOG.ACTIONS.MANAGE_CONTEXT',
                        'icon' : 'icon-layers',
                        'iconBulk': 'icon-layers',
                        'severity': 10
                    }
                },
                'RESULT': {
                    'SUCCESS': 'RESULT.SUCCESS',
                    'FAIL': 'RESULT.FAIL',
                    'PENDING': 'RESULT.PENDING'
                }
            },

            'TABS': {
                'ARTICLE': {
                    'DETAILS': 0,
                    'CRDS' : 1,
                    'RESOURCES' : 2,
                    'IMAGES' : 3,
                    'SIZES' : 4,
                    'PRICES' : 5,
                    'SEGMENTATION' : 6
                },
                'CUSTOMER': {
                    'DETAILS': 0,
                    'SEGMENTATION' : 1,
                    'CAPACITIES' : 5
                },
                'JOB': {
                    'DETAILS': 0,
                    'ERRORS' : 1
                }
            },

            'PRIVILEGES': {
                'BUYERS': {
                    'LIST': {},
                    'DETAIL': {
                        'USERS_LIST': 'GetBuyersUsersList',
                        'CATALOGS_LIST': 'GetBuyerCatalogList',
                        'CUSTOMERS_LIST': 'GetBuyerCustomerList'
                    }
                },
                'SELLERS': {
                    'LIST': {},
                    'DETAIL': {
                        'USERS_LIST': 'GetSellersUsersList',
                        'CATALOGS_LIST': 'GetCatalogList',
                        'CUSTOMERS_LIST': 'GetSellerCustomerList',
                        'RESOURCE_TYPES_LIST': 'GetImagesResourcesTypeList',
                        'ORDER_TYPES_LIST': 'GetOrderTypes',
                        'VAS_LIST': 'GetVasList',
                        'SIZE_SCALE_GROUPS_LIST': 'GetSellerSizeScaleList',
                        'SEASONLESS_ATTRIBUTES_LIST': 'GetSeasonlessAttributes',
                        'SEASONLESS_MODEL_ATTRIBUTES_LIST': 'GetSeasonlessModelAttributes',
                        'ARTICLE_DROP_REASONS_LIST': 'GetArticleDropReasonList',
                        'MASTER_SIZE_SCALE_GROUPS_LIST': 'GetSellerMasterSizeScaleList',
                        'SELLER_LOOKUP_TABLE': 'GetLookupDefinitions',
                        'CONFIGURATIONS': 'GetSellerSpecificConfigurations',
                        'SELLER_COLORS': 'GetSellerColors',
                        'GET_DATASET_DEFINITIONS': 'GetDatasetDefinitions',
                        'GET_DATASET_VALUES': 'GetDatasetValues',
                        'GET_DATASET_DEFINITIONS_DETAILS': 'GetDatasetDefinitionDetails',
                        // DTCR capacity list privilege (API 2 - GetCapacity, backend id 4040)
                        'CAPACITIES_LIST': 'GetCapacity',
                        // Design Option attribute definitions (API 2 - backend ids 4062/4063)
                        'DESIGN_OPTION_ATTRIBUTES': 'GetDesignOptionAttributes',
                        'GET_AVAILABLE_DESIGN_OPTION_ATTRIBUTES': 'GetAvailableDesignOptionAttributes'
                    },
                    'ARTICLE_STATES_LIST': 'GetArticleStatesList'
                },
                'SELLER_MODELS': {
                    'LIST': {},
                    'DETAIL': {
                        'MODEL_CATLOG_LIST': 'GetSellerModelAssociatedCatalogs',
                        'MODEL_ARTICLE_LIST': 'GetSellerModelAssociatedArticles'
                    }
                },
                'USERS': {
                    'LIST': {
                        'USERS_LIST': 'GetUsersList',
                    },
                    'DETAIL': {
                        'NOTIFICATIONS_LIST': 'GetUsersNotifications',
                        'CATALOG_ACCESS_LIST': 'GetSellerUserAssignedCatalogs',
                        'PRIVACY_POLICY_LIST': 'GetUserPrivacyPolicyList',
                        'CUSTOMERS_LIST': 'GetBuyerUserCustomerList'
                    }
                },
                'CATALOGS': {
                    'LIST': {
                        'CATALOG_GET_LIST': 'CatalogList'
                    },
                    'DETAIL': {
                        'SIZE_SCALE_GROUPS_LIST': 'GetSizeScaleList',
                        'CATALOG_TREE_DEFINITION_LIST': 'GetCatalogTreeDefinitionList',
                        'STOCK_DEFINITION_LIST': 'GetStockDefinitionList',
                        'ATTRIBUTE_VETTING_LIST':'GetAttributeValues',
                        'SELLER_USERS':'GetCatalogSellerUserList',
                        'REQUEST_ATTRIBUTES':'GetRequestAttributes',
                        'REQUEST_REASONS':'GetRequestReasons',
                        'COLOR_DEFINITIONS': 'GetColorDefinitions',
                        'ATTRIBUTE_RESTRICTIONS': 'GetRoleBasedCatalogArticleAttributes',
                        'RELATION_TYPES': 'GetRelationTypeList',
                        'RESTRICT_SEGMENTATIONS': 'GetRoleBasedSegmentations',
                        'RESTRICT_RETAIL_WINDOWS': 'GetRoleBasedInformation',
                        'SEGMENTATIONS': 'GetCatalogSegmentationList',
                        'RETAIL_WINDOWS': 'GetCatalogShipmentWindowList',
                        'BUCKET_ATTRIBUTE_RESTRICTIONS': 'GetRoleBasedCatalogBucketAttributes',
                        'CATALOG_COLOR_PALETTE': 'GetCatalogColorPalettes',
                        "CONFIGURATIONS": "GetCatalogSpecificConfigurations"
                    }
                },
                'CUSTOMERS': {
                    'LIST': {},
                    'DETAIL': {
                        'CATALOGS_LIST': 'GetSellerCustomerCatalogs'
                    }
                },
                'LINKED_CUSTOMERS': {
                    'LIST': {},
                    'DETAIL': {
                        'SEGMENTATION_LIST': 'GetSellerCustomerSegmentations',
                        'FAVORITES_LIST' : 'GetFavoriteList',
                        'LOCATIONS_LIST':'GetLocationList',
                        // Linked-customer Capacities tab read. No dedicated backend privilege was issued for this
                        // read (the data rides on the v1 catalog linked-customers detail, API 10), so it is gated on
                        // the general view-capacities privilege (API 2 - GetCapacity, backend id 4040).
                        'CAPACITIES_LIST':'GetCapacity'
                    }
                },
                'ORDERS': {
                    'LIST': {},
                    'DETAIL': {
                        'REJECTED_ORDERLINES_LIST': 'GetRejectedOrderlineList',
                        'NOTIFICATIONS': 'GetOrderNotifications',
                        'FILES': 'GetOrderFiles',
                        'ORDER_STATUS_HISTORY_LIST': 'GetOrderStatusHistory',
                        'IMPACTED_ADJUSTMENTS': 'GetOrderAdjustmentsByOrderId'
                    }
                },
                'CONSOLIDATIONS': {
                    'LIST': {},
                    'DETAIL': {
                        'ERRORS_LIST': 'GetConsolidationsBackGroundJobDetails'
                    }
                },
                'ROLES': {
                    'LIST': {},
                    'DETAIL': {
                        'PRIVILEGES_LIST': 'WebapisRoleGetList'
                    }
                },
                'ARTICLES': {
                    'LIST': {
                        'ASSORTABLE_ARTICLES': 'GetAssortableArticles',
                        'VIEW_UNASSORTED_ARTICLES': 'UI_ViewUnAssortedArticles'
                    },
                    'DETAIL': {
                        'ARTICLES_AUDIT_HISTORY': 'GetArticleHistory',
                        'ARTICLES_RELATIONS': 'GetObjectRelationDetails'
                    },
                    'UPDATE_ARTICLE_SHIPMENT_WINDOW': 'UpdateArticleShipmentWindowRange',
                    // if this priilege is assigned we will skip state level non editable attributes validation for update article
                    'SPECIAL_PRIVILEGE_TO_SKIP_STATE_VALIDATION': 'SpecialPermissionToIgnoreArticleState',
                    // if this priilege is assigned we will skip articles limit validation for bg jobs
                    'ARTICLES_LIMIT_FOR_BG_JOB': 'BGJobSpecialPermissionToSkipArticlesLimit'
                },
                'T1_DUNE': {
                    'READ_ACCESS': 'UI_T1DuneReadAccess',
                    'READ_WRITE_ACCESS': 'UI_T1DuneReadWriteAccess',
                    'ACCESS': {
                        'READ': 0,
                        'WRITE' : 1
                    }
                },
                'CATLOG_MODELS': {
                    'LIST': {},
                    'DETAIL': {
                        'CATALOG_MODEL_ARTICLE_LIST': 'GetCatalogModelAssociatedArticles'
                    }
                },
                'CATALOG_RESTRICT_MODULES': {
                    'ATTRIBUTE_RESTRICTIONS': 'GetRoleBasedCatalogArticleAttributes',
                    'RESTRICT_SEGMENTATIONS': 'GetRoleBasedSegmentations',
                    'RESTRICT_RETAIL_WINDOWS': 'GetRoleBasedInformation'
                },
                'REQUESTS': {
                    'DETAIL': {
                        'HISTORY': 'GetRequestHistory'
                    }
                },
                'PRICES': {
                    "UPDATE_CATALOG_MODEL_PRICES": "UpdateCatalogModelPrices"
                },
                'VETTING_LIST': {
                    "LINKED_CATALOG_ARTICLES": "GetLinkedCatalogsArticles",
                    "ACCESSIBLE_USERS": "AccessibleUsers",
                    "GET_AVAILABLE_SEASONLESS_ATTRIBUTE_LIST": "GetAvailableSeasonlessAttributeList",
                    "CATALOG_ACCESSIBLE_USERS": "CatalogAccessibleUsers",
                    "GET_CATALOG_AVAILBALE_ATTRIBUTE_LIST": "GetCatalogAvailbaleAttributeList",
                    "CHECK_IS_CATALOG_ARTICLE_LOCKED": "CheckIsCatalogArticleLocked",
                    "GET_AVAILABLE_ATTRIBUTES_FOR_BUCKET": "GetAvailableAttributesForBucket",
                    "GET_AVAILABLE_ATTRIBUTES_FOR_REQUEST": "GetAvailableAttributesForRequest",
                    "GET_PARENT_CATALOG_ARTICLE_LIST": "GetParentCatalogArticleList",
                    "GET_SAMESIZE_ARTICLES": "GetSameSizeArticles",
                    "GET_CONSOLIDATIONS_BACKGROUNDJOB_DETAILS": "GetConsolidationsBackGroundJobDetails",
                    "GET_CONSOLIDATION_PLUGINS": "GetConsolidationPlugins",
                    "GET_ORDER_PLUGINS": "GetOrderPlugins"
                },
                'GET_ALL_ATTRIBUTES_LIST': 'GetAttributeList'
            },

            'LOGIN_ISSUES_CODE_MAP' : {
                '999'   :   'LOGIN.SERVER_ERROR.INVALID_REQUEST',
                '1000'  :   'LOGIN.SERVER_ERROR.SERVER_SIDE_ISSUE',
                '1001'  :	'LOGIN.SERVER_ERROR.FIELD_VALIDATION',
                '1002'  :	'LOGIN.SERVER_ERROR.SERVER_SIDE_ISSUE',
                '1003'  :	'LOGIN.SERVER_ERROR.SERVER_SIDE_ISSUE',
                '1'     :	'LOGIN.SERVER_ERROR.INVALID_USERNAME',
                '2'     :	'LOGIN.SERVER_ERROR.INVALID_PASSWORD',
                '3'     :	'LOGIN.SERVER_ERROR.EMAIL_NOT_CONFIRMED',
                '4'     :	'LOGIN.SERVER_ERROR.DEACTIVATED_USER',
                '5'     :	'LOGIN.SERVER_ERROR.DEACTIVATED_ACCOUNT',
                '6'     :	'LOGIN.SERVER_ERROR.SERVER_SIDE_ISSUE',
                '7'     :	'LOGIN.SERVER_ERROR.E_CAT',
                '8'     :	'LOGIN.SERVER_ERROR.E_CAT',
                '9'     :	'LOGIN.SERVER_ERROR.E_CAT',
                '10'    :	'LOGIN.SERVER_ERROR.E_CAT',
                '11'    :	'LOGIN.SERVER_ERROR.INVALID_REQUEST'
            },

            'LOGIN_TYPE': {
                'PASSWORD': 1,
                'ACTIVE_DIRECTORY': 2
            },

            'REQUESTS': {
                'KEYS': {
                    'PRICES': 'Prices',
                    'COLORID': 'ColorId',
                    'STATUS': 'Status',
                    'MODELNAME': 'ModelName',
                    'SIZESCALE': 'SizeScale',
                    'STATENAME': 'StateName',
                }
            },

            'AUTH_URL': 'https://auth.trasix.one',
            'IMAGE_NOT_AVAILABLE_DATA_URI': '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',
            'SOURCE_APPLICATION': 'T1 UI'
        })
})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .config(config);

    /** @ngInject */
    function config($authProvider, $translatePartialLoaderProvider, $httpProvider, flowFactoryProvider, IdleProvider, KeepaliveProvider, $compileProvider)
    {
        // Put your custom configurations here
        // $authProvider.baseUrl = 'http://94.200.201.222:6070/api'; //'http://94.200.201.222:8086/api';  //'http://192.168.1.56:8080/api'; //
        // $authProvider.loginUrl = '/token';
        $authProvider.tokenName = 'access_token';

        // Translation
        $translatePartialLoaderProvider.addPart('app');

        flowFactoryProvider.defaults = {
            //target: $authProvider.baseUrl + '/UploadFileChunk',
            speedSmoothingFactor: 0.02,
            chunkSize : 5*1024*1024
        };

        IdleProvider.idle(240); // in seconds
        IdleProvider.timeout(60); // in seconds
        KeepaliveProvider.interval(5); // in seconds

        $httpProvider.useApplyAsync(true);
        $compileProvider.debugInfoEnabled(false);
        $httpProvider.interceptors.push('httpBlobInterceptor');
    }

})();
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .factory('api', apiService);

    /** @ngInject */
    function apiService($http, $state, $q, $cacheFactory, $mdDialog, errorDialog, utility, toast, $localStorage, authFactory, mockFactory)
    {
        var api = {};


        //TODO- to be remove before go live
        api.baseUrl = $localStorage.baseUrl;
        api.t1DuneBaseUrl = $localStorage.t1DuneBaseUrl;
        api.t1DuneAssetDownloadBaseUrl = $localStorage.t1DuneAssetDownloadBaseUrl;
        api.t1v2URL = $localStorage.t1v2URL;
        //TODO- to be remove before go live

        // Base Url
        //api.baseUrl = 'http://94.200.201.222:6070/api'; //'http://192.168.1.56:8080/api'; //
        api.ownCache = $cacheFactory('txApiCache');

        //Help functions
        api.webGet = webGet;
        api.webPut = webPut;
        api.webPost = webPost;
        api.webDelete = webDelete;
        api.getFields = getFields;
        api.getField = getField;
        api.getModel = getModel;
        api.getLookupData = getLookupData;
        api.showCreateRecordDialog = showCreateRecordDialog;
        api.showEditRecordDialog = showEditRecordDialog;
        api.cleanLookupData = cleanLookupData;
        api.getLookupDataForModel = getLookupDataForModel;
        api.setCatalogCodeFromCatalogDetails = setCatalogCodeFromCatalogDetails;
        api.setArticleDropReasonsList = setArticleDropReasonsList;
        api.getAndSetArticleStateList = getAndSetArticleStateList;
        api.setCurrentCatalogArticleList = setCurrentCatalogArticleList;
        api.setArticleAccountUsersList = setArticleAccountUsersList;
        api.setValidSellerLookupsDestinationAttributesMap = setValidSellerLookupsDestinationAttributesMap;
        api.setArticlesLimitForBackgroundJobs = setArticlesLimitForBackgroundJobs;
        api.setCatalogConfigValues = setCatalogConfigValues
        api.setSellerConfigValues = setSellerConfigValues
        api.resolveSegmentationPlanning = resolveSegmentationPlanning
        api.getSegmentationPlanningValues = getSegmentationPlanningValues
        api.getSegmentationPlanningDefault = getSegmentationPlanningDefault
        api.matchSegmentationPlanningValue = matchSegmentationPlanningValue
        api.getAndSetAttributesList = getAndSetAttributesList

        api.requestDates = {};

        //Sample data for Quick Panel
        api.quickPanel = mockFactory.getQuickPanelData();
        //To enable/disable showing prices and segmentations in articles listing page
        api.enablePricesSegmentationsInArticlesList = false;
        api.modelLevelImagesKeyConfig = undefined;
        api.majorGetPromise = undefined;
        api.currentSeletedCatalogCode = undefined; // this is store the current catalog code selected from catalogs list view
        api.roleBasedRestrictions = {};
        api.numberOfDecimalsForPrices = 2; // default value is 2
        api.conditonalColorVettingList = [];
        api.articleDropReasonsList = [];
        api.articleLabelConfiguration = '';
        api.modelLabelConfiguration = '';
        api.segmentationLabelConfiguration = '';
        api.articleStatesList = [];
        api.currentCatalogArticleList = [];
        api.accountUsersListMap = {};
        api.validSellerLookupsDestinationAttributesMap = {};
        api.allowedStatesForCreateArticleConfig = [];
        api.defaultCreateArticleState = '';
        api.articlesLimitForBackgroundJobs = 0;
        // Segmentation planning values (configurable display labels + default).
        // _segmentationPlanningCatalogRaw / _segmentationPlanningSellerRaw hold the parsed candidates
        // from catalog / seller level config; resolveSegmentationPlanning() merges them (catalog wins)
        // into api.segmentationPlanningConfig (always fully populated, even when no config exists).
        api._segmentationPlanningCatalogRaw = null;
        api._segmentationPlanningSellerRaw = null;
        api.segmentationPlanningConfig = getFallbackSegmentationPlanning();
        api.showColorTypeInColorPalatteDropdown = false;
        api.allAttributesListMap = {};

        return api;


        ///////////
        //Implementation

        /**
        * @name webGet
        * @desc Function that processes an $http GET request and manages the corresponding cache
        *
        * @param {string} url The URL of the $http GET request
        * @param {object} config Optional config object of the $http GET request
        * @param {bool} cache Boolean that specifies if the request can be cached
        * @param {bool} forceFetch Specifies if the request should force a server request and refresh the cache
        * @param {boolean} supportIncrementalResult
        * @param {string} idField id field of records, in case of nested structure like all article all prices it will be id filed of outer object
        * @param {boolean} isMajor
        * @param {object} model
        * @param {boolean} isArticleRelatedData It will be true for article, prices, delivery date and article segmentations module
        * @param {int} catalogId
        * @param {string} nestedArrayName, property name in each article record denoting entity value (like Prices) for that name, and all the entities mentioned in nestedArrayName
        *                 will be added to each article record
        *@param {string}  Id field for nested Data
        * @returns {promise} the $http.get promise
       */
        function webGet(url, config, cache, forceFetch, supportIncrementalResult, idField, isMajor, model, isArticleRelatedData, catalogId, nestedArrayName, nestedDataIdField) {
            var myConfig = {};
            var myUrl = url;
            var cacheKey = utility.buildUrl(url, myConfig.params, isArticleRelatedData);
            var currCache = cache ? api.ownCache.get(cacheKey) : undefined;
            var hasCache = false;
            //if data related to called api/model is already cached, then hasCache is true
            var existInCachedModelPathList = (angular.isDefined(currCache) && angular.isDefined(model)) ? currCache.cachedModelPathList.indexOf(utility.filterObject(currCache.cachedModelPathList, {model: model.modelPath}, true)[0]) : -1;
            if ((!isArticleRelatedData && currCache) ||
                (isArticleRelatedData && currCache && currCache.cachedModelPathList && model && existInCachedModelPathList !== -1)) {
                hasCache = true;
            }
            var isIncremental = false;
            var defer;
            var currDate = new Date();
            var indexes = {};
            var cachedModelPathList = []; // It will have modelPath's of model whose data is cached in common currCache(for cache key 'activeCatalogArticleDataKey') when isArticleRelatedData is true
            var nestedArrayList = []; // It will contain nestedArrayNames for articleRelatedData (when isArticleRelatedData is true)
            var getArticleListPromise = $q.when(); //articleList promise

            //add modelPath in cachedModelPathList for further verification of which models data is cached/loaded for isArticleRelatedData
            if(isArticleRelatedData) {
                if(currCache) {
                    cachedModelPathList = currCache.cachedModelPathList;
                    nestedArrayList = currCache.nestedArrayList;
                } else {
                    // we are creating cachedModelPathList with model and last request date to call each module from its last request date
                    if(model) {
                        var modelWithLastRequestDate = {
                            model: model.modelPath,
                            lastRequestDate: currDate.toISOString().replace(":", "%3A")
                        }
                        cachedModelPathList.push(modelWithLastRequestDate);
                    } else {
                        console.warn('this should never happen')
                    }
                }
                // if article model is dirty while calling other module like Prices, Crds, etc, or article has not been cached yet, call the updated article data and update the currCache since data for cached key activeCatalogArticleDataKey is build on article's data
                var existInCachedModelPathList = cachedModelPathList.indexOf(utility.filterObject(cachedModelPathList, {model: 'catalogs.articles'}, true)[0]);
                if(model && model.modelPath && model.modelPath != 'catalogs.articles' && (api.catalogs.articles.isDirty || existInCachedModelPathList === -1)) {
                    // promoted this code since previously even forceFetch was false if article model was dirty it retrieved data form server
                    getArticleListPromise = getArticlesList(catalogId);
                }
            } else {
                // load article prices and article sizes when moving to orders module
                if(model && model.modelPath && (model.modelPath === 'catalogs.orders')) {
                    getArticleListPromise = getArticlesList(catalogId);
                    getArticlePricesList(catalogId);
                    getArticleSizesList(catalogId);
                }
                // keep model which are not articles related data (isArticleRelatedData false/undefined) like stocks in cachedModelPathList
                if(model) {
                    var modelWithLastRequestDate = {
                        model: model.modelPath,
                        lastRequestDate: currDate.toISOString().replace(":", "%3A")
                    }
                    cachedModelPathList.push(modelWithLastRequestDate);
                }
            }

            if (angular.isDefined(config)) {
                myConfig = angular.copy(config);
                myConfig.cache = false;
            }

            if (hasCache) {
                if (!forceFetch) {
                    // TODO: if not forceFetch why we are retrieving articles from server? need to be review in dept
                    defer = $q.defer();
                    getArticleListPromise.then(function () {
                        defer.resolve(currCache.response);
                    })
                    return defer.promise;
                } else {
                    if (supportIncrementalResult) {
                        //Get Incremental
                        isIncremental = true;
                        var currentModelLastRequestDate = currDate.toISOString().replace(":", "%3A");
                        if(currCache.cachedModelPathList.length > 0) {
                            var currentModel = utility.filterObject(currCache.cachedModelPathList, {model: model.modelPath}, true)[0];
                            if(currentModel) {
                                currentModelLastRequestDate = currentModel.lastRequestDate;
                            }
                        }
                        /**
                         * we have sugegsted API to keep it consistant and as discussed with Amardeep
                         * they will plan it for later and will use the same parameter name for entire applications
                         * will add the task number when he creates a task for this as discussed he will create a task and will share the number with me
                         */
                        var lastUpdatedDateParam = 'u';
                        // specific for dune images module API is expecting LastModifiedDate as query param
                        if(angular.isDefined(model) && model.modelPath === 'catalogs.t1Dune') {
                            lastUpdatedDateParam = 'LastModifiedDate';
                        }

                        if (url.indexOf("?") >= 0) {
                            myUrl = url + "&" + lastUpdatedDateParam + "=" + currentModelLastRequestDate;
                        } else {
                            myUrl = url + "?" + lastUpdatedDateParam + "=" + currentModelLastRequestDate;
                        }
                        myUrl = decodeURIComponent(myUrl);

                    } else if (!isArticleRelatedData) { // will not invalidate articleRelatedData, since we always update that data
                        // Delete current Cache
                        api.ownCache.remove(cacheKey);
                    }
                }
            }

            // if isMajor is true it cancels the running major api and calls the api with isMajor true
            if (angular.isDefined(isMajor) && isMajor) {
                if (angular.isDefined(api.majorGetPromise)) {
                    api.majorGetPromise.resolve('canceled due to parallel major request');
                }
                api.majorGetPromise = $q.defer();
                myConfig.timeout = api.majorGetPromise.promise;
            }

            var currentPromise = $http.get(myUrl, myConfig);

            return $q.all({ getArticleListPromise: getArticleListPromise, currentPromise: currentPromise })
                .then(function (responses) {
                    //for isArticleRelatedData common caching, save the articleGetList response in currCache.
                    if (responses && responses.getArticleListPromise && responses.getArticleListPromise.data) {
                        currCache = {};
                        currCache.response = responses.getArticleListPromise;
                        setCurrentCatalogArticleList(currCache.response.data);
                        // add catalogs.articles modelPath in cachedModelPathList if not exist
                        var existInCachedModelPathList = cachedModelPathList.indexOf(utility.filterObject(cachedModelPathList, {model: 'catalogs.articles'}, true)[0]);
                        if (existInCachedModelPathList === -1) {
                            var modelWithLastRequestDate = {
                                model: 'catalogs.articles',
                                lastRequestDate: currDate.toISOString().replace(":", "%3A")
                            }
                            cachedModelPathList.push(modelWithLastRequestDate);
                        }
                    }

                    if (responses && responses.currentPromise && responses.currentPromise.data) {
                        if (cache) {

                            if(isIncremental || (isArticleRelatedData && model.modelPath != 'catalogs.articles' && currCache )) {
                                //Create index of current records
                                if (angular.isUndefined(currCache.indexes) || angular.isUndefined(currCache.indexes._len) || (responses.currentPromise.config.url.includes('assortableArticles')) || api.catalogs.articles.isDirty) {
                                    for (var i = 0; i < currCache.response.data.length; i++) {
                                        var indexKey = '';
                                        if(!angular.isArray(idField)) {
                                            indexKey = currCache.response.data[i][idField];
                                        } else if(angular.isArray(idField)) {
                                            // in places where there is no Id field in root object, create a virtual id field which can be combination of multiple properties
                                            var combinedIdField = '';
                                            angular.forEach(idField, function(idFld) {
                                                indexKey += currCache.response.data[i][idFld].toString();
                                                combinedIdField += idFld;
                                            });
                                            // in places where there is no Id field in root object, after indexing add the value to record as well
                                            currCache.response.data[i][combinedIdField] = indexKey;
                                        }
                                        indexes[indexKey] = i;
                                    }
                                    currCache.indexes = indexes;
                                    currCache.indexes._len = currCache.response.data.length;
                                } else {
                                    indexes = currCache.indexes;
                                }
                            }

                            if (isIncremental) {

                                // modify cached data based on the response from server
                                // in case of articles, only update articles own properties in cache, but keep article related data(CRD, Prices, Segmentations) as is
                                if (model && model.modelPath && model.modelPath === 'catalogs.articles') {
                                    /* forcefully set article's model isDirty to false for 2 reasons
                                     * 1- it reaches here because it is forcefully getting articles data from server
                                     * 2- it can be get dirty in module like segmentations (update article via import model)
                                     * and user can navigate to other articleRelated module without clicking on red refresh banner which will keep the article modrl dirty
                                     */
                                    model.isDirty = false
                                    angular.forEach(responses.currentPromise.data, function (record) {
                                        if (currCache.response.data[indexes[record[idField]]]) {
                                            if (nestedArrayList && nestedArrayList.length > 0) {
                                                // Update the articles record keeping other article entities data (like Prices[], Crds[] etc..) as it is
                                                var nestedArrayDataMap = {};
                                                for (var nestedArrayListIndexI = 0; nestedArrayListIndexI < nestedArrayList.length; nestedArrayListIndexI++) {
                                                    nestedArrayDataMap[nestedArrayList[nestedArrayListIndexI]] = currCache.response.data[indexes[record[idField]]][nestedArrayList[nestedArrayListIndexI]];
                                                }
                                                currCache.response.data[indexes[record[idField]]] = record;
                                                for (var nestedArrayListIndexJ = 0; nestedArrayListIndexJ < nestedArrayList.length; nestedArrayListIndexJ++) {
                                                    currCache.response.data[indexes[record[idField]]][nestedArrayList[nestedArrayListIndexJ]] = nestedArrayDataMap[nestedArrayList[nestedArrayListIndexJ]];
                                                }
                                            } else {
                                                currCache.response.data[indexes[record[idField]]] = record;
                                            }
                                        } else {//if new article is added then push new record and update the indexes
                                            indexes[record[idField]] = currCache.response.data.length;
                                            currCache.response.data.push(record);
                                            currCache.indexes._len = currCache.response.data.length;
                                        }
                                    });
                                } else if (nestedArrayName) {
                                    appendToCachedDataNested(responses.currentPromise, currCache, indexes, idField, nestedArrayName, model, nestedDataIdField, isArticleRelatedData);
                                }
                                else {
                                    // update the cache, replace existing cached data with response from server and append missing data
                                    angular.forEach(responses.currentPromise.data, function (record) {
                                        // if data is already cached replace it with what returned by api
                                        if (angular.isDefined(indexes[record[idField]])) {
                                            currCache.response.data[indexes[record[idField]]] = record;
                                        }
                                        // else append missing data
                                        else {
                                            // else update the index object and push the new value into cached response
                                            indexes[record[idField]] = currCache.response.data.length;
                                            currCache.response.data.push(record);
                                            currCache.indexes._len = currCache.response.data.length;
                                        }
                                    });
                                }
                                responses.currentPromise = currCache.response;
                            }
                            //When article related entities are called (like Prices, Crds etc) for the first time, their response is added to common cached article data.
                            else if (isArticleRelatedData && currCache && model.modelPath != 'catalogs.articles') {

                                //Merge response of isArticleRelatedData models into currCache corresponding to cache key 'activeCatalogArticleDataKey'
                                angular.forEach(responses.currentPromise.data, function (record) {
                                    if (angular.isDefined(indexes[record[idField]]) && currCache.response.data) {
                                        //_outerData is object and _nestedData is array
                                        //for example segmentation : _outerData will contain all data except Segmentations and _nestedData will contain only Segmentations
                                        currCache.response.data[indexes[record[idField]]][nestedArrayName] = {'_outerData':{},'_nestedData':record[nestedArrayName]};
                                        delete record[nestedArrayName];
                                        currCache.response.data[indexes[record[idField]]][nestedArrayName]._outerData = record;
                                    }
                                });

                                //check if the modelPath is added to cachedModelPathList, if not then add
                                var existInCachedModelPathList = cachedModelPathList.indexOf(utility.filterObject(cachedModelPathList, {model: model.modelPath}, true)[0]);
                                if (existInCachedModelPathList === -1) {
                                    var modelWithLastRequestDate = {
                                        model: model.modelPath,
                                        lastRequestDate: currDate.toISOString().replace(":", "%3A")
                                    }
                                    cachedModelPathList.push(modelWithLastRequestDate);
                                }
                                nestedArrayList.push(nestedArrayName);
                                responses.currentPromise = currCache.response;
                            }
                            // update last request date for current model
                            angular.forEach(cachedModelPathList, function(cachedModel) {
                                if(cachedModel.model === model.modelPath) {
                                    cachedModel.lastRequestDate = currDate.toISOString().replace(":", "%3A");
                                }
                            });

                            api.ownCache.put(cacheKey, { lastRequestDate: currDate.toISOString().replace(":", "%3A"), indexes: indexes, response: responses.currentPromise, cachedModelPathList: cachedModelPathList, nestedArrayList: nestedArrayList });
                        }
                    }
                    return responses.currentPromise;
                })
                .catch(function (error) {
                    if (error.status == 401) {
                        //dont show token expire popup for error codes 1(user not exist) and 4(user is deactivated)
                        if(angular.isArray(error.data)) {
                            angular.forEach(error.data, function (err) {
                                if (err.ErrorCode !== 1 && err.ErrorCode !== 4) {
                                    console.warn("Error: " + error.ErrorMessage);
                                    errorDialog.show('ERRORS.TOKEN_EXPIRED', error).then(function (showDetails) {
                                        if (showDetails) {
                                            errorDialog.showDetailsDialog(error);
                                        }
                                    });
                                }
                            });
                        } else {
                            console.warn("Error: " + error.data);
                            errorDialog.show('ERRORS.TOKEN_EXPIRED', error).then(function (showDetails) {
                                if (showDetails) {
                                    errorDialog.showDetailsDialog(error);
                                }
                            });
                        }
                        authFactory.onLogout();
                        $state.go('app.auth_login');
                        return $q.reject(error);
                    }
                    else if (error.status == 403) {
                        errorDialog.show('ERRORS.NO_PRIVILEGES', error).then(function (showDetails) {
                            if (showDetails) {
                                errorDialog.showDetailsDialog(error);
                            }
                        })
                        return $q.reject(error);
                    }
                    else if (error.status !== -1 && angular.isDefined(error.config) && error.config.responseType !== 'arraybuffer') { // rest of error but canceled
                        // specific to dune images, if images are not found toast messages will be shown for all the failed calls.
                        // as discussed with Amardeep we will not show toast messages for dune images download.
                        toast.error('ERRORS.GET', '', '', error);
                        return $q.reject(error);
                    }
                    else {
                        return $q.reject(error);
                    }
                });
        }

        /**
         * @name webPut
         * @desc Function that processes an $http PUT request
         *
         * @param {string} url The URL of the $http PUT request
         * @param {object} data The data object that will be submitted in the PUT request
         * @param {object} config Optional config object of the $http PUT request
         *
         * @returns {promise} the $http.put promise
         */
        function webPut(url, data, config)
        {
            return $http.put(url, data, config)
                .catch(function(error) {
                    if(error.status == 401) {
                        //dont show token expire popup for error codes 1(user not exist) and 4(user is deactivated)
                        if(angular.isArray(error.data)) {
                            angular.forEach(error.data, function (err) {
                                if (err.ErrorCode !== 1 && err.ErrorCode !== 4) {
                                    console.warn("Error: " + error.ErrorMessage);
                                    errorDialog.show('ERRORS.TOKEN_EXPIRED', error).then(function (showDetails) {
                                        if (showDetails) {
                                            errorDialog.showDetailsDialog(error);
                                        }
                                    });
                                }
                            });
                        } else {
                            console.warn("Error: " + error.data);
                            errorDialog.show('ERRORS.TOKEN_EXPIRED', error).then(function (showDetails) {
                                if (showDetails) {
                                    errorDialog.showDetailsDialog(error);
                                }
                            });
                        }
                        authFactory.onLogout();
                        $state.go('app.auth_login');
                    }
                    else if(error.status == 403) {
                        errorDialog.show('ERRORS.NO_PRIVILEGES', error).then(function (showDetails) {
                            if (showDetails) {
                                errorDialog.showDetailsDialog(error);
                            }
                        })
                        return $q.reject(error);
                    }
                    else {
                        toast.error('ERRORS.PUT', '', '', error);
                        //TODO- Need to confirm with Andre if I can have the error object to be carried forward
                        return $q.reject(error);
                    }
                });
        }

        /**
         * @name webPost
         * @desc Function that processes an $http POST request
         *
         * @param {string} url The URL of the $http POST request
         * @param {object} data The data object that will be submitted in the POST request
         * @param {object} config Optional config object of the $http POST request
         *
         * @returns {promise} the $http.post promise
         */
        function webPost(url, data, config, cache, supportIncrementalResult, idField, isMajor, model)
        {
            var myConfig = {};
            var myUrl = url;
            var cacheKey = utility.buildUrl(url, myConfig.params, false);
            var currCache = cache ? api.ownCache.get(cacheKey) : undefined;
            var hasCache = false;
            if (currCache) {
                hasCache = true;
            }
            var isIncremental = false;
            var currDate = new Date();
            var indexes = {};
            var cachedModelPathList = []; // It will have modelPath's of model whose data is cached in common currCache(for cache key 'activeCatalogArticleDataKey') when isArticleRelatedData is true

            // keep model in cachedModelPathList
            if (cache) {
                if(currCache) {
                    var existInCachedModelPathList = (angular.isDefined(currCache) && angular.isDefined(model)) ? currCache.cachedModelPathList.indexOf(utility.filterObject(currCache.cachedModelPathList, {model: model.modelPath}, true)[0]) : -1;
                    if (existInCachedModelPathList === -1) {
                        var modelWithLastRequestDate = {
                            model: model.modelPath,
                            lastRequestDate: currDate.toISOString().replace(":", "%3A")
                        }
                        cachedModelPathList.push(modelWithLastRequestDate);
                    } else {
                        cachedModelPathList = currCache.cachedModelPathList;
                    }
                } else {
                    if(model) {
                        var modelWithLastRequestDate = {
                            model: model.modelPath,
                            lastRequestDate: currDate.toISOString().replace(":", "%3A")
                        }
                        cachedModelPathList.push(modelWithLastRequestDate);
                    }
                }
            }

            if (angular.isDefined(config)) {
                myConfig = angular.copy(config);
                myConfig.cache = false;
            }

            if (hasCache) {
                if (supportIncrementalResult) {
                    //Get Incremental
                    isIncremental = true;
                    var currentModelLastRequestDate = currDate.toISOString().replace(":", "%3A");
                    if(currCache.cachedModelPathList.length > 0) {
                        var currentModel = utility.filterObject(currCache.cachedModelPathList, {model: model.modelPath}, true)[0];
                        if(currentModel) {
                            currentModelLastRequestDate = currentModel.lastRequestDate;
                        }
                    }

                    data['LastModifiedDate'] = currentModelLastRequestDate.replace("%3A", ":");;

                    // not using for now. if any time we need to pass "LastModifiedDate" as query param we can uncomment this
                    // if (url.indexOf("?") >= 0) {
                    //     myUrl = url + "&LastModifiedDate=" + currentModelLastRequestDate;
                    // } else {
                    //     myUrl = url + "?LastModifiedDate=" + currentModelLastRequestDate;
                    // }
                    myUrl = decodeURIComponent(myUrl);
                }
            }

            // if isMajor is true it cancels the running major api and calls the api with isMajor true
            if (angular.isDefined(isMajor) && isMajor) {
                if (angular.isDefined(api.majorGetPromise)) {
                    api.majorGetPromise.resolve('canceled due to parallel major request');
                }
                api.majorGetPromise = $q.defer();
                myConfig.timeout = api.majorGetPromise.promise;
            }

            var currentPromise = $http.post(myUrl, data, config);

            return currentPromise.then(function (response) {
                if (response && response.data) {
                    if (cache) {
                        if(isIncremental || currCache ) {
                            //Create index of current records
                            if (angular.isUndefined(currCache.indexes) || angular.isUndefined(currCache.indexes._len)) {
                                for (var i = 0; i < currCache.response.data.length; i++) {
                                    var indexKey = '';
                                    if(!angular.isArray(idField)) {
                                        indexKey = currCache.response.data[i][idField];
                                    } else if(angular.isArray(idField)) {
                                        // in places where there is no Id field in root object, create a virtual id field which can be combination of multiple properties
                                        var combinedIdField = '';
                                        angular.forEach(idField, function(idFld) {
                                            indexKey += currCache.response.data[i][idFld].toString();
                                            combinedIdField += idFld;
                                        });
                                        // in places where there is no Id field in root object, after indexing add the value to record as well
                                        currCache.response.data[i][combinedIdField] = indexKey;
                                    }
                                    indexes[indexKey] = i;
                                }
                                currCache.indexes = indexes;
                                currCache.indexes._len = currCache.response.data.length;
                            } else {
                                indexes = currCache.indexes;
                            }
                        }

                        if (isIncremental) {
                            angular.forEach(response.data, function (record) {
                                // if data is already cached replace it with what returned by api
                                if (angular.isDefined(indexes[record[idField]])) {
                                    currCache.response.data[indexes[record[idField]]] = record;
                                }
                                // else append missing data
                                else {
                                    // else update the index object and push the new value into cached response
                                    indexes[record[idField]] = currCache.response.data.length;
                                    currCache.response.data.push(record);
                                    currCache.indexes._len = currCache.response.data.length;
                                }
                            });
                            response = currCache.response;
                        }
                        // update last request date for current model
                        angular.forEach(cachedModelPathList, function(cachedModel) {
                            if(cachedModel.model === model.modelPath) {
                                cachedModel.lastRequestDate = currDate.toISOString().replace(":", "%3A");
                            }
                        });

                        api.ownCache.put(cacheKey, { lastRequestDate: currDate.toISOString().replace(":", "%3A"), indexes: indexes, response: response, cachedModelPathList: cachedModelPathList});
                    }
                }
                return response;
            })
            .catch(function(error) {
                if(error.status == 401) {
                    //dont show token expire popup for error codes 1(user not exist) and 4(user is deactivated)
                    if(angular.isArray(error.data)) {
                        angular.forEach(error.data, function (err) {
                            if (err.ErrorCode !== 1 && err.ErrorCode !== 4) {
                                console.warn("Error: " + error.ErrorMessage);
                                errorDialog.show('ERRORS.TOKEN_EXPIRED', error).then(function (showDetails) {
                                    if (showDetails) {
                                        errorDialog.showDetailsDialog(error);
                                    }
                                });
                            }
                        });
                    } else {
                        console.warn("Error: " + error.data);
                        errorDialog.show('ERRORS.TOKEN_EXPIRED', error).then(function (showDetails) {
                            if (showDetails) {
                                errorDialog.showDetailsDialog(error);
                            }
                        });
                    }
                    authFactory.onLogout();
                    $state.go('app.auth_login');
                }
                else if(error.status == 403) {
                    errorDialog.show('ERRORS.NO_PRIVILEGES', error).then(function (showDetails) {
                        if (showDetails) {
                            errorDialog.showDetailsDialog(error);
                        }
                    })
                    return $q.reject(error);
                }
                else {
                    toast.error('ERRORS.POST', '', '', error);
                    return $q.reject(error);
                }
            });
        }

        /**
         * @name webDelete
         * @desc Function that processes an $http POST request
         *
         * @param {string} url The URL of the $http POST request
         * @param {object} data The data object that will be submitted in the POST request
         * @param {object} config Optional config object of the $http POST request
         *
         * @returns {promise} the $http.post promise
         */
        function webDelete(url, data, config)
        {
            var finalConfig = {};
            if (config) {
                finalConfig = angular.copy(config);
            }
            finalConfig.headers = { 'Content-Type': 'application/json' };
            finalConfig.data = data;

            return $http.delete(url, finalConfig)
                .catch(function(error) {
                    if(error.status == 401) {
                        //dont show token expire popup for error codes 1(user not exist) and 4(user is deactivated)
                        if(angular.isArray(error.data)) {
                            angular.forEach(error.data, function (err) {
                                if (err.ErrorCode !== 1 && err.ErrorCode !== 4) {
                                    console.warn("Error: " + error.ErrorMessage);
                                    errorDialog.show('ERRORS.TOKEN_EXPIRED', error).then(function (showDetails) {
                                        if (showDetails) {
                                            errorDialog.showDetailsDialog(error);
                                        }
                                    });
                                }
                            });
                        } else {
                            console.warn("Error: " + error.data);
                            errorDialog.show('ERRORS.TOKEN_EXPIRED', error).then(function (showDetails) {
                                if (showDetails) {
                                    errorDialog.showDetailsDialog(error);
                                }
                            });
                        }

                        authFactory.onLogout();
                        $state.go('app.auth_login');
                    }
                    else if(error.status == 403) {
                        errorDialog.show('ERRORS.NO_PRIVILEGES', error).then(function (showDetails) {
                            if (showDetails) {
                                errorDialog.showDetailsDialog(error);
                            }
                        })
                        return $q.reject(error);
                    }
                    else {
                        toast.error('ERRORS.DELETE', '', '', error);
                        return $q.reject(error);
                    }
                });
        }

        /**
         * @name getFields
         * @desc Function that returns a list of 'field' objects from a list of field id's
         *
         * @param {array} fields The source array of field objects to look into
         * @param {array} list The list of field id's to look for
         *
         * @returns {array} the new array of fields found
         */
        function getFields(fields, list)
        {
            var len=fields.length, listLen=list.length, finalList = [];
            for (var i=0; i<listLen; i++)
            {
                for (var j=0; j<len; j++)
                {
                    if (list[i] == fields[j].field) {
                        finalList.push(fields[j]);
                        break;
                    }
                }
            }
            return finalList;
        }

        /**
         * @name getField
         * @desc Function that returns the field have id:fieldId from the list of fields
         *
         * @param {array} fields The source array of fields to look into
         * @param {string} fieldId The ID of the field to search for
         *
         * @returns {object} The field object found
         */
        function getField(fields, fieldId)
        {
            return utility.filterObject(fields, {field: fieldId});
        }

        function cleanLookupData(obj) {
            if(!(angular.isDefined(obj) && angular.isObject(obj))) {
                obj = this;
            }
            for(var property in obj) { //loop through all the object properties
                if(angular.isDefined(obj[property]) && angular.isDefined(obj[property].lookupData)) {// search for lookupdata in objects inside api (starts one level deep from api)
                    obj[property].lookupData = undefined;
                    break;
                }
                else if(angular.isObject(obj[property])) {
                    cleanLookupData(obj[property]);
                }
            }
            return;
        }

        function getLookupDataForModel(model) {
            var deferred = $q.defer();
            var promises = {};
            var lookupData = {};
            angular.forEach(model.fields, function(field) {
                if(field.inputType === 'lookup' || field.inputType === 'lookup-many' || field.inputType === 'articlenumber' || field.inputType === 'modelnumber' || field.inputType === 'linkedcatalogarticlenumber') {
                    var lookupExtras = {};
                    promises[field.field] = getLookupData(getModel(field.lookupSource), lookupExtras, undefined, field).then(function(result) {
                        lookupData[lookupKey] = result;
                    });
                }
            });
            $q.all(promises).then(function() {
                deferred.resolve(lookupData);
            });

            return deferred.promise;
        }

        function setCatalogConfigValues(catalogConfigurationList) {
            if(angular.isDefined(catalogConfigurationList)) {
                // If T1-EnablePricesSegmentationsInArticlesList is configured for catalog assign this as enablePricesSegmentationsInArticlesList else assign false
                var enablePricesSegmentationsInArticlesListConfiguration = utility.filterObject(catalogConfigurationList, { Name: 'T1-EnablePricesSegmentationsInArticlesList' }, true)[0];
                if(angular.isDefined(enablePricesSegmentationsInArticlesListConfiguration) && (enablePricesSegmentationsInArticlesListConfiguration.Value === true || enablePricesSegmentationsInArticlesListConfiguration.Value === 'true')) {
                    api.enablePricesSegmentationsInArticlesList = true;
                } else {
                    api.enablePricesSegmentationsInArticlesList = false;
                }

                // check if T1S-ModelLevelImagesKey is present or not
                var modelLevelImagesKey = utility.filterObject(catalogConfigurationList, { Name: 'T1S-ModelLevelImagesKey' }, true)[0];
                if(angular.isDefined(modelLevelImagesKey) && modelLevelImagesKey.Value.length > 0) {
                    //Adding try catch if JSON parse fails
                    try {
                        api.modelLevelImagesKeyConfig = JSON.parse(modelLevelImagesKey.Value);
                    } catch(error) {
                        console.warn("T1S-ModelLevelImagesKey Configuration : Invalid JSON format");
                    }
                } else {
                    api.modelLevelImagesKeyConfig = undefined;
                }

                // If numberOfDecimalsForPrices is configured for catalog assign this as numberOfDecimalsForPrices if the value is <=4 and >=0 else assign default value 2
                var numberOfDecimalsForPricesConfiguration = utility.filterObject(catalogConfigurationList, { Name: 'T1S-NumberOfDecimalsForPrices' }, true)[0];
                if(angular.isDefined(numberOfDecimalsForPricesConfiguration) && (numberOfDecimalsForPricesConfiguration.Value >= 0 || numberOfDecimalsForPricesConfiguration.Value <= 4)) {
                    api.numberOfDecimalsForPrices = parseInt(numberOfDecimalsForPricesConfiguration.Value);
                } else {
                    api.numberOfDecimalsForPrices = 2;
                }

                // conditonal color vetting list
                var conditionalColorsCriteriaConfiguration = utility.filterObject(catalogConfigurationList, { Name: 'T1S-ConditionalColorsCriteria' }, true)[0];
                if(angular.isDefined(conditionalColorsCriteriaConfiguration) && conditionalColorsCriteriaConfiguration.Value.length > 0) {
                    //Adding try catch if JSON parse fails
                    try {
                        api.conditonalColorVettingList = JSON.parse(conditionalColorsCriteriaConfiguration.Value);
                    } catch(error) {
                        console.warn("T1S-ConditionalColorsCriteria Configuration : Invalid JSON format");
                    }
                } else {
                    api.conditonalColorVettingList = [];
                }

                // set article, model and segmentation label configuration
                var articleLabelConfiguration = utility.filterObject(catalogConfigurationList, { Name: 'T1S-ArticleLabel' }, true)[0];
                if(angular.isDefined(articleLabelConfiguration) && articleLabelConfiguration.Value.length > 0) {
                    api.articleLabelConfiguration = articleLabelConfiguration.Value;
                    $localStorage.articleLabelConfiguration = articleLabelConfiguration.Value;

                } else {
                    api.articleLabelConfiguration = '';
                    $localStorage.articleLabelConfiguration = '';
                }
                var modelLabelConfiguration = utility.filterObject(catalogConfigurationList, { Name: 'T1S-ModelLabel' }, true)[0];
                if(angular.isDefined(modelLabelConfiguration) && modelLabelConfiguration.Value.length > 0) {
                    api.modelLabelConfiguration = modelLabelConfiguration.Value;
                    $localStorage.modelLabelConfiguration = modelLabelConfiguration.Value;
                } else {
                    api.modelLabelConfiguration = '';
                    $localStorage.modelLabelConfiguration = '';
                }
                var segmentationLabelConfiguration = utility.filterObject(catalogConfigurationList, { Name: 'T1S-SegmentationLabel' }, true)[0];
                if(angular.isDefined(segmentationLabelConfiguration) && segmentationLabelConfiguration.Value.length > 0) {
                    api.segmentationLabelConfiguration = segmentationLabelConfiguration.Value;
                    $localStorage.segmentationLabelConfiguration = segmentationLabelConfiguration.Value;
                } else {
                    api.segmentationLabelConfiguration = '';
                    $localStorage.segmentationLabelConfiguration = '';
                }

                // sets allowedStatesForCreateArticleConfig and defaultCreateArticleState
                var allowedStatesForCreateArticleConfig = utility.filterObject(catalogConfigurationList, { Name: 'T1S-AllowedStatesForCreateArticle' }, true)[0];
                if (angular.isDefined(allowedStatesForCreateArticleConfig) && allowedStatesForCreateArticleConfig.Value.length > 0) {
                    try {
                        var states = JSON.parse(allowedStatesForCreateArticleConfig.Value);
                        api.allowedStatesForCreateArticleConfig = states.map(function(state) {
                            return state.toLowerCase();
                        });
                    } catch(error) {
                        console.warn("T1S-AllowedStatesForCreateArticle Configuration : Invalid JSON format");
                    }
                } else {
                    api.allowedStatesForCreateArticleConfig = [];
                }

                var defaultCreateArticleStateConfig = utility.filterObject(catalogConfigurationList, { Name: 'T1S-DefaultCreateArticleState' }, true)[0];
                if (angular.isDefined(defaultCreateArticleStateConfig) && defaultCreateArticleStateConfig.Value.length > 0) {
                    api.defaultCreateArticleState = defaultCreateArticleStateConfig.Value;
                } else {
                    api.defaultCreateArticleState = '';
                }

                // set segmentation planning values (catalog level candidate); catalog overrides seller
                api._segmentationPlanningCatalogRaw = parseSegmentationPlanningConfig(catalogConfigurationList);
                resolveSegmentationPlanning();

                // If T1S-ShowColorTypeInColorPalatteDropdown is configured show colortype in colorpalette dropdown
                var showColorTypeInColorPalatteDropdown = utility.filterObject(catalogConfigurationList, { Name: 'T1S-ShowColorTypeInColorPalatteDropdown' }, true)[0];
                if(angular.isDefined(showColorTypeInColorPalatteDropdown) && (showColorTypeInColorPalatteDropdown.Value.toString().toLowerCase() === 'true')) {
                    api.showColorTypeInColorPalatteDropdown = true;
                } else {
                    api.showColorTypeInColorPalatteDropdown = false;
                }
            } else {
                api.enablePricesSegmentationsInArticlesList = false;
                api.modelLevelImagesKeyConfig = undefined;
                api.numberOfDecimalsForPrices = 2;
                api.conditonalColorVettingList = [];
                api.articleLabelConfiguration = '';
                api.modelLabelConfiguration = '';
                api.segmentationLabelConfiguration = '';
                $localStorage.articleLabelConfiguration = '';
                $localStorage.modelLabelConfiguration = '';
                $localStorage.segmentationLabelConfiguration = '';
                api.allowedStatesForCreateArticleConfig = [];
                api.defaultCreateArticleState = '';
                api._segmentationPlanningCatalogRaw = null;
                resolveSegmentationPlanning();
                api.showColorTypeInColorPalatteDropdown = false;
            }
        }

        /**
         * Parses the seller level configuration list for T1S-SegmentationPlanningValues and
         * re-resolves the effective planning config. Catalog config always takes precedence,
         * so the seller candidate is only used when no catalog config is present.
         * @param {array} sellerConfigurationList: list of seller configuration rows ({Name, Value})
         */
        function setSellerConfigValues(sellerConfigurationList) {
            api._segmentationPlanningSellerRaw = parseSegmentationPlanningConfig(sellerConfigurationList);
            resolveSegmentationPlanning();
        }

        /**
         * @return {object} fallback planning config used when no configuration exists at either level:
         * values ['Assorted', 'Planned'] with default 'Assorted'.
         */
        function getFallbackSegmentationPlanning() {
            return {
                values: ['Assorted', 'Planned'],
                defaultValue: 'Assorted'
            };
        }

        /**
         * Parses a configuration list for the T1S-SegmentationPlanningValues row
         * ({ values: [string], defaultValue: string }) and returns a normalized config object,
         * or null when the config is absent / empty / invalid (caller falls back).
         * @param {array} configurationList
         * @return {object|null}
         */
        function parseSegmentationPlanningConfig(configurationList) {
            if (angular.isUndefined(configurationList)) {
                return null;
            }
            var configRow = utility.filterObject(configurationList, { Name: 'T1S-SegmentationPlanningValues' }, true)[0];
            if (angular.isUndefined(configRow) || !configRow.Value || !configRow.Value.toString().length) {
                return null;
            }
            try {
                var parsed = JSON.parse(configRow.Value);
                if (!parsed || !angular.isArray(parsed.values) || !parsed.values.length) {
                    console.warn("T1S-SegmentationPlanningValues Configuration : Invalid format, expected { values: [...], defaultValue }");
                    return null;
                }
                return normalizeSegmentationPlanning(parsed);
            } catch (error) {
                console.warn("T1S-SegmentationPlanningValues Configuration : Invalid JSON format");
                return null;
            }
        }

        /**
         * Normalizes a parsed config: keeps the values list as-is and ensures defaultValue is one of
         * the values (else falls back to the first value).
         */
        function normalizeSegmentationPlanning(parsed) {
            var values = parsed.values;
            var defaultValue = (parsed.defaultValue && values.indexOf(parsed.defaultValue) !== -1) ? parsed.defaultValue : values[0];
            return { values: values, defaultValue: defaultValue };
        }

        /**
         * Resolves the effective planning config with catalog-overrides-seller precedence, falling
         * back to the defaults when neither level defines the config. Result is stored on
         * api.segmentationPlanningConfig and is always fully populated.
         */
        function resolveSegmentationPlanning() {
            api.segmentationPlanningConfig = api._segmentationPlanningCatalogRaw || api._segmentationPlanningSellerRaw || getFallbackSegmentationPlanning();
        }

        /**
         * @return {array} the configured planning values, used directly as dropdown options
         * (vm.planningValue). e.g. ['Recommended', 'Available', 'None'].
         */
        function getSegmentationPlanningValues() {
            return api.segmentationPlanningConfig.values;
        }

        /**
         * @return {string} the configured default planning value, e.g. 'Recommended'.
         */
        function getSegmentationPlanningDefault() {
            return api.segmentationPlanningConfig.defaultValue;
        }

        /**
         * Returns the canonical configured planning value matching the given input (trimmed,
         * case-insensitive), or undefined when the input is empty / not a configured value.
         * Used to validate and normalize imported planning values.
         * @param {string} input
         * @return {string|undefined}
         */
        function matchSegmentationPlanningValue(input) {
            if (angular.isUndefined(input) || input === null) {
                return undefined;
            }
            var upper = input.toString().trim().toUpperCase();
            if (upper === '') {
                return undefined;
            }
            var values = api.segmentationPlanningConfig.values;
            for (var i = 0; i < values.length; i++) {
                if (values[i].toString().trim().toUpperCase() === upper) {
                    return values[i];
                }
            }
            return undefined;
        }

        // this is store the current catalog code selected from catalogs list view
        function setCatalogCodeFromCatalogDetails(catalogCode) {
            api.currentSeletedCatalogCode = catalogCode;
        }

        // ArticlesLimitForBackgroundJobs
        function setArticlesLimitForBackgroundJobs(catalogConfigurationList) {
            if (angular.isDefined(catalogConfigurationList)) {
                var articlesLimitForBackgroundJobs = utility.filterObject(catalogConfigurationList, { Name: 'T1S-ArticlesLimitForBackgroundJobs' }, true)[0];
                if (angular.isDefined(articlesLimitForBackgroundJobs) && articlesLimitForBackgroundJobs.Value.length && Number(articlesLimitForBackgroundJobs.Value) > 0) {
                    api.articlesLimitForBackgroundJobs = Number(articlesLimitForBackgroundJobs.Value);
                } else {
                    api.articlesLimitForBackgroundJobs = 0;
                }

            } else {
                api.articlesLimitForBackgroundJobs = 0;
            }
        }

        // get article states list and save it
        function getAndSetArticleStateList(sellerId, attributeGroupId) {
            api.catalogs.articleStates.methods.getList({ forceFetch: true, isLogRequired: false }, sellerId, attributeGroupId).then(function(response) {
                api.articleStatesList = response.data;
            });
        }

        // get attributes list and save it
        function getAndSetAttributesList() {
            api.attributes.attributes.methods.getList({ forceFetch: true, isLogRequired: false }).then(function(response) {
                api.allAttributesListMap = response.data.reduce(function(map, attr) {
                    map[attr.Attributeid] = attr;
                    return map;
                }, {});
            });
        }


        // set current catalog articles list
        function setCurrentCatalogArticleList(articleLIst) {
            api.currentCatalogArticleList = articleLIst;
        }

        /**
         * @name getModel
         * @desc Function that returns the Model object from a path string
         *
         * @param {string} modelPath The Path of the model to look for (ex: lists.countries)
         *
         * @return {object} The found model object
         */
        function getModel(modelPath)
        {
            if (angular.isUndefined(modelPath) || !angular.isString(modelPath)) {
                throw "Invalid parameter modelPath: " + modelPath;
            }

            var parts = modelPath.split(".");
            var model = api;
            for (var i=0; i<parts.length; i++) {
                if (angular.isUndefined(model[parts[i]] || !angular.isObject(model[parts[i]]))) {
                    throw "Unable to find requested model: " + modelPath;
                } else {
                    model = model[parts[i]];
                }
            }
            return model;
        }

        /**
         * Will load getList result of any module and store it in model's lookupData object
         * @Param model:  model object
         * @Param lookupExtras:  model object
         * @Param currentModelPath:  from which the lookup source is called
         */
        function getLookupData(model, lookupExtras, currentModelPath, field) {
            /** if lookup needs to be calculated based on different ids (other than CatalogCode) it means lookup needs to call api with more than 1 id always
             * then recalculate( lookupExtra is used sometime to load lookup based on record's properties and each record may have different property value) so always clean cached lookup when lookupExtras defined
             * but loadLookupIfLookupExtrasExist is undefined or false
             */
            if((angular.isDefined(lookupExtras) && angular.isDefined(lookupExtras[model.modelPath]))) {
                model.lookupData = undefined;
            }
            if (angular.isDefined(model.lookupData) && angular.isDefined(model.lookupData.indexArray) && angular.isDefined(model.lookupData.data) && !model.isDirty) {
                return $q.when(model.lookupData);
            } else {
                var generalProperties = {
                    forceFetch: true,
                    isLogRequired: false,
                    config: {},
                    supportIncrementalResult: true,
                    isMajor: false, //prevent canceling parallel major requests for lookups
                    modelIdField: model.idField,
                    idMap: undefined // helper map of ids to create conditional(dynamic) lookups where get list of api needs ids,
                    //this map contain those ids, which should be pass into lookupExtras map object while using showCreateRecordDialog/showEditRecordDialog api
                }
                // customize generalWebGetProperties by creating loadLookupCustomProperties inside any model to be model specific
                var generalWebGetProperties = Object.assign({}, generalProperties, model.loadLookupCustomProperties);
                if(lookupExtras && model.modelPath && lookupExtras[model.modelPath] && angular.isObject(lookupExtras[model.modelPath])) {
                    generalWebGetProperties.idMap = lookupExtras[model.modelPath];
                }
                generalWebGetProperties.isMajor = false; // always make it false to avoid canceling parallel major requests while loading lookups even if it is true in model's loadLookupCustomProperties

                //its has a limitation with dynamic model, and their lookup value should be invalidate on dropdown change
                //invalidate any dynamic model's lookup data in dropdown change event (since all articles dropdown going to be text box, it wont be required to invalidate article's model lookup)
                return model.methods.getList(generalWebGetProperties).then(function(response) {
                    var indexMapKey = '';
                    var indexedObj = {};
                    var result = { indexArray: [], data: [] };
                    if(model.modelPath === "catalogs.attributes"){
                        response.data = utility.orderBy(response.data.AttributeList, model.lookupDisplayField);
                    }else if(model.modelPath === "catalogs.segmentations"){
                        response.data = utility.filterObject(response.data, {Status: 1});
                    }
                    else {
                    response.data = utility.orderBy(response.data, model.lookupDisplayField);
                    }
                    // if CRDs (or any date strings)
                    if(response.data.length > 0 && model.modelPath === 'catalogs.CRD' && utility.isValidDate(response.data[0][model.lookupDisplayField])) {
                        var formatedDateString;
                        for (var i=0; i<response.data.length; i++) {

                            indexMapKey = response.data[i][model.idField].toString().concat(response.data[i][model.lookupDisplayField]);
                            // avoid adding data which combination of idField value and lookupDisplayField value repeated
                            if(angular.isUndefined(indexedObj[indexMapKey])) {
                                indexedObj[indexMapKey] = i;

                                // if any other lookup date then time zone should be conditional and make `utc` only for CRDs
                                formatedDateString = utility.formatDate(response.data[i][model.lookupDisplayField], 'MMM d, y', 'UTC');
                                result.indexArray.push(response.data[i][model.idField]);
                                result.data.push({id: response.data[i][model.idField], value: formatedDateString, Status: response.data[i].Status});
                            }
                        }
                    }
                    else {
                        for (var i=0; i<response.data.length; i++) {

                            indexMapKey = response.data[i][model.idField].toString().concat(response.data[i][model.lookupDisplayField]);
                            // avoid adding data which combination of idField value and lookupDisplayField value repeated
                            if(angular.isUndefined(indexedObj[indexMapKey])) {
                                indexedObj[indexMapKey] = i;

                                result.indexArray.push(response.data[i][model.idField]);
                                //Adding Status, EntityId and AccountTypeId filed to make lookup data filterable on these properties
                                result.data.push({
                                    id: response.data[i][model.idField], value: response.data[i][model.lookupDisplayField],
                                    Status: response.data[i].Status, EntityId: response.data[i].EntityId, AccountTypeId: response.data[i].AccountTypeId,
                                    AccountId: response.data[i].AccountId, AttributeGroupId: response.data[i].AttributeGroupId, IsInput: response.data[i].IsInput,
                                    IsVasInUse: response.data[i].IsVasInUse, IsShippingWindowApply: response.data[i].IsShippingWindowApply, IsSizeScaleByStyle:response.data[i].IsSizeScaleByStyle, ParentAccountId: response.data[i].ParentAccountId,
                                    ReferenceCatalogCode: response.data[i].ReferenceCatalogCode, Extension: response.data[i].Extension, IsEditable: response.data[i].IsEditable, AttributeSystemName: response.data[i].AttributeSystemName,
                                    // ContextReadKey and ContextReadWriteKey will be used in catalogs Manage context action
                                    ContextReadKey: response.data[i].ReadKey, ContextReadWriteKey: response.data[i].WriteKey, IsLinePlan: response.data[i].IsLinePlan, IsSeasonless: response.data[i].IsSeasonless, OrderPriceGroupId: response.data[i].OrderPriceGroupId,
                                    Code: response.data[i].Code,
                                    ColorCode: response.data[i].ColorCode,
                                    ColorName: response.data[i].ColorName,
                                    ColorType: response.data[i].ColorType,
                                    ColorTypeName: response.data[i].ColorTypeName,
                                    IsSeasonlessModelAttribute: response.data[i].IsSeasonlessModelAttribute,
                                    ModelName: response.data[i].ModelName, ColorCriteria: response.data[i].ColorCriteria, RequiredAttributes: response.data[i].RequiredAttributes, NonEditableAttributes: response.data[i].NonEditableAttributes, IsSizeScaleRequired: response.data[i].IsSizeScaleRequired,
                                    StateId: response.data[i].StateId, StateRank: response.data[i].StateRank, ModelStateRank: response.data[i].ModelStateRank, ModelNumber: response.data[i].ModelNumber,
                                    CriteriaAttributeValue: response.data[i].CriteriaAttributeValue, RetailIntroMonth: response.data[i].RetailIntroMonth, SizeScaleId: response.data[i].SizeScaleId, AttributeTypeId: response.data[i].AttributeTypeId,
                                    ShipmentStartDate: response.data[i].ShipmentStartDate, ShipmentEndDate: response.data[i].ShipmentEndDate, Criteria: response.data[i].Criteria, AllowRetailWindowUpdate: response.data[i].AllowRetailWindowUpdate,
                                    AllowChangeRequestForPriceGroups: response.data[i].AllowChangeRequestForPriceGroups, ModelStateId: response.data[i].ModelStateId, AttributeTypeName: response.data[i].AttributeTypeName, AllowedValues: response.data[i].AllowedValues,IsPrimaryColorRequired: response.data[i].IsPrimaryColorRequired,
                                    MasterSizeScaleId: response.data[i].MasterSizeScaleId, IsObsolete: response.data[i].IsObsolete, ColumnDatatype: response.data[i].ColumnDatatype, ColumnName: response.data[i].ColumnName, IsMandatory: response.data[i].IsMandatory
                                });
                                    // AccountId, ParentAccountId, AttributeGroupId & IsVasInUse only use in create catalog dialog to avoid additional api call, IsInput is used for consolidation templates only
                                    //ReferenceCatalogCode used in create inherited articles
                                    //IsEditable is used to filter out non editable price groups while creating price for article in article details

                                    // for article colors module returning the article response with all the data to filter based on conditional color vetting list
                                    // addng id and value for filtering
                                    // we need to validate article attributes while import so passing all the response
                                    if(model.modelPath === 'catalogs.articles' || (model.modelPath === 'catalogs.articles' && currentModelPath === 'catalogs.articleColor')) {
                                        response.data[i]['id'] = response.data[i][model.idField];
                                        response.data[i]['value'] = response.data[i][model.lookupDisplayField];
                                    }
                            }
                        }
                    }
                    model.lookupData = result;
                    if(angular.isUndefined(currentModelPath) || model.modelPath !== 'catalogs.articles') {
                        return result;
                    } else if(model.modelPath === 'catalogs.articles' || (model.modelPath === 'catalogs.articles' && currentModelPath === 'catalogs.articleColor')) {// we need to validate article attributes while import so passing all the response
                        model.lookupData = { indexArray: result.indexArray, data: response.data };
                        return { indexArray: result.indexArray, data: response.data };
                    }
                })
            }
        }

        //@param existingValues : array containing records displayed in list view (using this : existing values are removed from the lookup display in viewCreator controller)
        function showCreateRecordDialog(parent, event, model, parentId, defaultValues, lookupExtras, additionalInfo, existingValues, existingRecordsForUniqueValue) {
            var lookupPromises = {};
            // can't use crud since it will create circular dependency, I have already consume createLookupPromise which defined in crud factory in many places
            // lookupPromises = crud.createLookupPromise(model);
            lookupPromises = createLookupPromise(model, lookupExtras);
            return $mdDialog.show({
                controller         : 'viewCreatorController',
                controllerAs       : 'vm',
                templateUrl        : 'app/services/viewCreator/viewCreator.html',
                parent             : angular.element(parent),
                targetEvent        : event,
                clickOutsideToClose: false,
                locals             : {
                    editMode: false,
                    model: model,
                    record : null,
                    parentId : parentId,
                    event: event,
                    filterExpression: {creatable: true},
                    lookupPromises: lookupPromises,
                    defaultValues: defaultValues,
                    additionalInfo: additionalInfo,
                    existingValues: existingValues,
                    existingRecordsForUniqueValue: existingRecordsForUniqueValue,
                    lookupExtras:lookupExtras
                }
            });
        }

        function showEditRecordDialog(parent, event, model, record, parentId, lookupExtras, additionalInfo, existingValues, existingRecordsForUniqueValue) {
            var lookupPromises = {};
            // can't use crud since it will create circular dependency, I have already consume createLookupPromise which defined in crud factory in many places
            // lookupPromises = crud.createLookupPromise(model);
            lookupPromises = createLookupPromise(model, lookupExtras);
            return $mdDialog.show({
                controller         : 'viewCreatorController',
                controllerAs       : 'vm',
                templateUrl        : 'app/services/viewCreator/viewCreator.html',
                parent             : angular.element(parent),
                targetEvent        : event,
                clickOutsideToClose: false,
                locals             : {
                    editMode: true,
                    model: model,
                    record : record,
                    parentId : parentId,
                    event: event,
                    filterExpression: {showInEdit: true, editable: true},
                    lookupPromises: lookupPromises,
                    defaultValues: null,
                    additionalInfo: additionalInfo,
                    existingValues: existingValues,
                    existingRecordsForUniqueValue: existingRecordsForUniqueValue,
                    lookupExtras: lookupExtras
                }
            });
        }

        /**
         * @description
         * This method will be called before update or create dialog to load lookup data for provided model's fields
         *  and create a lookup promise which is used by dialog to load data asynchronously
         * @param {object} model: model object containing field information
         * @param {object} lookupExtras: map containing ids for modelPath to be use to create lookup data where api needs ids
         * @return {object}: a mapping between field name and promise object for its lookup API call
         */
        //custom-lookup only created for attribute model to prevent creating custom dialog and this datatype will be assign dynamically only for update and create
        function createLookupPromise(model, lookupExtras) {
            var promises = {};
            angular.forEach(model.fields, function(field) {
                if ((field.editable || field.creatable) && (field.inputType === 'lookup' || field.inputType === 'lookup-many' || field.inputType === 'custom-lookup' || field.inputType === 'articlenumber' || field.inputType === 'modelnumber' || field.inputType === 'linkedcatalogarticlenumber' || field.inputType === 'color-palette')
                 && angular.isDefined(field.lookupSource)) {
                    var lookupModel = api.getModel(field.lookupSource);
                    promises[field.field] = api.getLookupData(lookupModel, lookupExtras, model.modelPath, field);
                }
            });
            return promises;
        }

        /**
         * @description
         * This method will be called for updating cached nested data using response returned from Get api
         * @param {object}  response: response from the Get api
         * @param {object}  currCache: data cached for the respective Get api called
         * @param {array}   indexes: index list of the root data * @param {object} model
         * @param {int}     idField : Id of the root data
         * @param {string}  nestedArrayName: property name in each article record denoting entity value (like Prices) for that name, and all the entities mentioned in nestedArrayName will be added to each article record
         * @param {object}  model
         * @param {string}  nestedDataIdField:  Id field for nested Data
         * @param {boolean} isArticleRelatedData:  It will be true for article, prices, delivery date and article segmentations module
        */
        function appendToCachedDataNested(response, currCache, indexes, idField, nestedArrayName, model, nestedDataIdField, isArticleRelatedData) {
            var existingNestedRecordsIndexed = {};
            var idFieldPristine; // will be defined if idField is combination of multiple fields (when there is no id field on root(outer) object)
            if(angular.isArray(idField)) {
                idFieldPristine = idField;
                idField = idField.join('');
            }
            // loop through new response.
            angular.forEach(response.data, function (record) {
                if(angular.isDefined(idFieldPristine) && angular.isArray(idFieldPristine)) {
                    var combinedValue = '';
                    angular.forEach(idFieldPristine, function(idFld) {
                        combinedValue += record[idFld];
                    });
                    record[idField] = combinedValue;
                }
                // check if record exist in root level or not, if yes, replace the root level and for nested data replace if exist or append if missing
                if (angular.isDefined(indexes[record[idField]])) {
                    // create local indexed for each nested record
                    existingNestedRecordsIndexed = {};
                    if (isArticleRelatedData) {
                        //check whether required nestedData is present in cached data, if not present then add it in cache.
                        //TODO: For Segmentations and Crds we are replacing the cached data with the data returned from the server. Once discussed with Amardeep , after the consistent behavior
                        // implementation of API ie SIZES,PRICES,STOCK are similar to SEGMENTATION & CRD (or vice versa). The or condition for segmentation and crd will be removed from the code below
                        /* right now api for CRD and SEGMENTATION return only the record which are assigned, and if it is unassigned then it wont be part of nested record
                         * currently these are the only apis that remove the data rather then updating status, and our implementation is generally we update the existing data in cache with data return by api
                         * or append if missing, but in case of segmentation and CRD if its un-assigned using our general implementation it won't be removed hence the value even after removing will remain as `yes`
                         * in that case we will replace outer and nested data all together for these modules until we get an update from Amardeep.
                         */
                        if (!currCache.response.data[indexes[record[idField]]][nestedArrayName] || nestedArrayName === 'Crds' || nestedArrayName === 'Segmentations' ) {
                            currCache.response.data[indexes[record[idField]]][nestedArrayName] = { '_outerData': {}, '_nestedData': record[nestedArrayName] };
                            delete record[nestedArrayName];
                            currCache.response.data[indexes[record[idField]]][nestedArrayName]._outerData = record;
                        } else {
                            // update the outer data
                            currCache.response.data[indexes[record[idField]]][nestedArrayName]._outerData = record;
                            var tempAPIRecordNestedData = record[nestedArrayName]
                            // remove nested data from _outerData
                            delete currCache.response.data[indexes[record[idField]]][nestedArrayName]._outerData[nestedArrayName]

                            // index each article nested records
                            angular.forEach(currCache.response.data[indexes[record[idField]]][nestedArrayName]._nestedData, function (cachedNestedRecord, index) {
                                existingNestedRecordsIndexed[cachedNestedRecord[nestedDataIdField]] = index;
                            });

                            // loop through records returned by api
                            angular.forEach(tempAPIRecordNestedData, function (apiNestedRecord) {
                                // if nested data exist in cached data replace it with data returned by api
                                if (angular.isDefined(existingNestedRecordsIndexed[apiNestedRecord[nestedDataIdField]])) {
                                    currCache.response.data[indexes[record[idField]]][nestedArrayName]._nestedData[existingNestedRecordsIndexed[apiNestedRecord[nestedDataIdField]]] = apiNestedRecord;
                                }
                                // otherwise push new record
                                else {
                                    currCache.response.data[indexes[record[idField]]][nestedArrayName]._nestedData.push(apiNestedRecord);
                                }
                            });
                        }
                    } else {
                        if (!currCache.response.data[indexes[record[idField]]][nestedArrayName]) {
                            currCache.response.data[indexes[record[idField]]][nestedArrayName] = record[nestedArrayName];
                        } else {

                            // update only the outer data from data return by api and keep the nested data as it was
                            // create copy of `cached` nested data
                            var tempNestedCachedData = currCache.response.data[indexes[record[idField]]][nestedArrayName];
                            // replace the record
                            currCache.response.data[indexes[record[idField]]] = objectShallowCopy(record);
                            // reassign the cached nested record
                            currCache.response.data[indexes[record[idField]]][nestedArrayName] = tempNestedCachedData;

                            // index nested record
                            angular.forEach(currCache.response.data[indexes[record[idField]]][nestedArrayName], function (cachedNestedRecord, index) {
                                existingNestedRecordsIndexed[cachedNestedRecord[nestedDataIdField]] = index;
                            });
                            // loop through records returned by api
                            angular.forEach(record[nestedArrayName], function (apiNestedRecord) {
                                // if nested data exist in cached data replace it with data returned by api
                                if (angular.isDefined(existingNestedRecordsIndexed[apiNestedRecord[nestedDataIdField]])) {
                                    currCache.response.data[indexes[record[idField]]][nestedArrayName][existingNestedRecordsIndexed[apiNestedRecord[nestedDataIdField]]] = apiNestedRecord;
                                }
                                // otherwise push new record
                                else {
                                    currCache.response.data[indexes[record[idField]]][nestedArrayName].push(apiNestedRecord);
                                }
                            });
                        }
                    }
                } else {
                    // else update the index object and push the new value into cached response
                    indexes[record[idField]] = currCache.response.data.length;
                    currCache.response.data.push(record);
                    currCache.indexes._len = currCache.response.data.length;
                }
            });
        }


        function objectShallowCopy(sourceData) {
            var result = {};
            for(var key in sourceData) {
                if(sourceData.hasOwnProperty(key)) {
                    result[key] = sourceData[key];
                }
            }
            return result;
        }

        //helper function call articleGetList
        function getArticlesList(catalogId) {
            var articleModel = api.catalogs.articles
            var generalProperties = {
                forceFetch: true,
                isLogRequired: false,
                config: {},
                supportIncrementalResult: true,
                modelIdField: articleModel.idField,
                isMajor: false,
                isArticleRelatedData: true
            }
            return articleModel.methods.getList(generalProperties, articleModel, catalogId);
        }

        // helper function call articlePricesList
        function getArticlePricesList(catalogId) {
            var pricesModel = api.catalogs.prices;
            var generalProperties = {
                forceFetch: true,
                isLogRequired: false,
                config: {},
                supportIncrementalResult: true,
                modelIdField: 'Id',
                isMajor: false,
                isArticleRelatedData: false,
                nestedArrayName: 'Prices',
                nestedDataIdField:'Id'
            }
            return pricesModel.methods.getList(generalProperties, pricesModel, catalogId);
        }

        // helper function call articleSizesList
        function getArticleSizesList(catalogId) {
            var sizesModel = api.catalogs.sizes
            var generalProperties = {
                forceFetch: true,
                isLogRequired: false,
                config: {},
                supportIncrementalResult: true,
                modelIdField: sizesModel.idField,
                isMajor: false,
                isArticleRelatedData: false,
                nestedArrayName: 'Sizes',
                nestedDataIdField:'Id'
            }
            return sizesModel.methods.getList(generalProperties, sizesModel, catalogId);
        }

        function setArticleDropReasonsList(articleDropReasons) {
            api.articleDropReasonsList = articleDropReasons;
        }

        // this method will create map of user id and user name. this will be used instead of users lookup in list and details view
        function setArticleAccountUsersList(users) {
            if(users.length) {
                users.forEach(function(user) {
                    api.accountUsersListMap[user.Id] = user.UserName;
                });
            }
        }

        function setValidSellerLookupsDestinationAttributesMap(lookupData) {
            api.validSellerLookupsDestinationAttributesMap = lookupData;
        }
    }
})();
(function() {


  // Create all modules and define dependencies to make sure they exist
  // and are loaded in the correct order to satisfy dependency injection
  // before all nested files are concatenated by Grunt

  // Modules
  angular.module('angular-jwt',
      [
          'angular-jwt.options',
          'angular-jwt.interceptor',
          'angular-jwt.jwt',
          'angular-jwt.authManager'
      ]);

  angular.module('angular-jwt.authManager', [])
    .provider('authManager', function () {

      this.$get = ["$rootScope", "$injector", "$location", "jwtHelper", "jwtInterceptor", "jwtOptions", function ($rootScope, $injector, $location, jwtHelper, jwtInterceptor, jwtOptions) {

        var config = jwtOptions.getConfig();

        function invokeToken(tokenGetter) {
          var token = null;
          if (Array.isArray(tokenGetter)) {
            token = $injector.invoke(tokenGetter, this, {options: null});
          } else {
            token = tokenGetter();
          }
          return token;
        }

        function invokeRedirector(redirector) {
          if (Array.isArray(redirector) || angular.isFunction(redirector)) {
            return $injector.invoke(redirector, config, {});
          } else {
            throw new Error('unauthenticatedRedirector must be a function');
          }
        }

        function isAuthenticated() {
          var token = invokeToken(config.tokenGetter);
          if (token) {
            return !jwtHelper.isTokenExpired(token);
          }
        }

        $rootScope.isAuthenticated = false;

        function authenticate() {
          $rootScope.isAuthenticated = true;
        }

        function unauthenticate() {
          $rootScope.isAuthenticated = false;
        }

        function validateToken() {
          var token = invokeToken(config.tokenGetter);
          if (token) {
            if (!jwtHelper.isTokenExpired(token)) {
              authenticate();
            } else {
              $rootScope.$broadcast('tokenHasExpired', token);
            }
          }
        }

        function checkAuthOnRefresh() {
          if ($injector.has('$transitions')) {
            var $transitions = $injector.get('$transitions');
            $transitions.onStart({}, validateToken);
          } else {
            $rootScope.$on('$locationChangeStart', validateToken);
          }
        }

        function redirectWhenUnauthenticated() {
          $rootScope.$on('unauthenticated', function () {
            invokeRedirector(config.unauthenticatedRedirector);
            unauthenticate();
          });
        }

        function verifyRoute(event, next) {
          if (!next) {
            return false;
          }

          var routeData = (next.$$route) ? next.$$route : next.data;

          if (routeData && routeData.requiresLogin === true && !isAuthenticated()) {
            event.preventDefault();
            invokeRedirector(config.unauthenticatedRedirector);
          }
        }

        function verifyState(transition) {
          var route = transition.to();
          var $state = transition.router.stateService;
            if (route && route.data && route.data.requiresLogin === true && !isAuthenticated()) {
              return $state.target(config.loginPath);
            }
        }

        if ($injector.has('$transitions')) {
          var $transitions = $injector.get('$transitions');
          $transitions.onStart({}, verifyState);
        } else {
          var eventName = ($injector.has('$state')) ? '$stateChangeStart' : '$routeChangeStart';
          $rootScope.$on(eventName, verifyRoute);
        }



        return {
          authenticate: authenticate,
          unauthenticate: unauthenticate,
          getToken: function(){ return invokeToken(config.tokenGetter); },
          redirect: function() { return invokeRedirector(config.unauthenticatedRedirector); },
          checkAuthOnRefresh: checkAuthOnRefresh,
          redirectWhenUnauthenticated: redirectWhenUnauthenticated,
          isAuthenticated: isAuthenticated
        }
      }]
    });

  angular.module('angular-jwt.interceptor', [])
    .provider('jwtInterceptor', function() {

      this.urlParam;
      this.authHeader;
      this.authPrefix;
      this.whiteListedDomains;
      this.tokenGetter;

      var config = this;

      this.$get = ["$q", "$injector", "$rootScope", "urlUtils", "jwtOptions", function($q, $injector, $rootScope, urlUtils, jwtOptions) {

        var options = angular.extend({}, jwtOptions.getConfig(), config);

        function isSafe (url) {
          if (!urlUtils.isSameOrigin(url) && !options.whiteListedDomains.length) {
            throw new Error('As of v0.1.0, requests to domains other than the application\'s origin must be white listed. Use jwtOptionsProvider.config({ whiteListedDomains: [<domain>] }); to whitelist.')
          }
          var hostname = urlUtils.urlResolve(url).hostname.toLowerCase();
          for (var i = 0; i < options.whiteListedDomains.length; i++) {
            var domain = options.whiteListedDomains[i];
            if (domain instanceof RegExp) {
              if (hostname.match(domain)) {
                return true;
              }
            } else {
              if (hostname === domain.toLowerCase()) {
                return true;
              }
            }
          }

          if (urlUtils.isSameOrigin(url)) {
            return true;
          }

          return false;
        }

        return {
          request: function (request) {
            if (request.skipAuthorization || !isSafe(request.url)) {
              return request;
            }

            if (options.urlParam) {
              request.params = request.params || {};
              // Already has the token in the url itself
              if (request.params[options.urlParam]) {
                return request;
              }
            } else {
              request.headers = request.headers || {};
              // Already has an Authorization header
              if (request.headers[options.authHeader]) {
                return request;
              }
            }

            var tokenPromise = $q.when($injector.invoke(options.tokenGetter, this, {
              options: request
            }));

            return tokenPromise.then(function(token) {
              if (token) {
                if (options.urlParam) {
                  request.params[options.urlParam] = token;
                } else {
                  request.headers[options.authHeader] = options.authPrefix + token;
                }
              }
              return request;
            });
          },
          responseError: function (response) {
            // handle the case where the user is not authenticated
            if (response !== undefined && response.status === 401) {
              $rootScope.$broadcast('unauthenticated', response);
            }
            return $q.reject(response);
          }
        };
      }]
    });

   angular.module('angular-jwt.jwt', [])
    .service('jwtHelper', ["$window", function($window) {

      this.urlBase64Decode = function(str) {
        var output = str.replace(/-/g, '+').replace(/_/g, '/');
        switch (output.length % 4) {
          case 0: { break; }
          case 2: { output += '=='; break; }
          case 3: { output += '='; break; }
          default: {
            throw 'Illegal base64url string!';
          }
        }
        return $window.decodeURIComponent(escape($window.atob(output))); //polyfill https://github.com/davidchambers/Base64.js
      };


      this.decodeToken = function(token) {
        var parts = token.split('.');

        if (parts.length !== 3) {
          throw new Error('JWT must have 3 parts');
        }

        var decoded = this.urlBase64Decode(parts[1]);
        if (!decoded) {
          throw new Error('Cannot decode the token');
        }

        return angular.fromJson(decoded);
      };

      this.getTokenExpirationDate = function(token) {
        var decoded = this.decodeToken(token);

        if(typeof decoded.exp === "undefined") {
          return null;
        }

        var d = new Date(0); // The 0 here is the key, which sets the date to the epoch
        d.setUTCSeconds(decoded.exp);

        return d;
      };

      this.isTokenExpired = function(token, offsetSeconds) {
        var d = this.getTokenExpirationDate(token);
        offsetSeconds = offsetSeconds || 0;
        if (d === null) {
          return false;
        }

        // Token expired?
        return !(d.valueOf() > (new Date().valueOf() + (offsetSeconds * 1000)));
      };
    }]);

  angular.module('angular-jwt.options', [])
    .provider('jwtOptions', function() {
      var globalConfig = {};
      this.config = function(value) {
        globalConfig = value;
      };
      this.$get = function() {

        var options = {
          urlParam: null,
          authHeader: 'Authorization',
          authPrefix: 'Bearer ',
          whiteListedDomains: [],
          tokenGetter: function() {
            return null;
          },
          loginPath: '/',
          unauthenticatedRedirectPath: '/',
          unauthenticatedRedirector: ['$location', function($location) {
            $location.path(this.unauthenticatedRedirectPath);
          }]
        };

        function JwtOptions() {
          var config = this.config = angular.extend({}, options, globalConfig);
        }

        JwtOptions.prototype.getConfig = function() {
          return this.config;
        };

        return new JwtOptions();
      }
    });

   /**
    * The content from this file was directly lifted from Angular. It is
    * unfortunately not a public API, so the best we can do is copy it.
    *
    * Angular References:
    *   https://github.com/angular/angular.js/issues/3299
    *   https://github.com/angular/angular.js/blob/d077966ff1ac18262f4615ff1a533db24d4432a7/src/ng/urlUtils.js
    */

   angular.module('angular-jwt.interceptor')
    .service('urlUtils', function () {

      // NOTE:  The usage of window and document instead of $window and $document here is
      // deliberate.  This service depends on the specific behavior of anchor nodes created by the
      // browser (resolving and parsing URLs) that is unlikely to be provided by mock objects and
      // cause us to break tests.  In addition, when the browser resolves a URL for XHR, it
      // doesn't know about mocked locations and resolves URLs to the real document - which is
      // exactly the behavior needed here.  There is little value is mocking these out for this
      // service.
      var urlParsingNode = document.createElement("a");
      var originUrl = urlResolve(window.location.href);

      /**
       *
       * Implementation Notes for non-IE browsers
       * ----------------------------------------
       * Assigning a URL to the href property of an anchor DOM node, even one attached to the DOM,
       * results both in the normalizing and parsing of the URL.  Normalizing means that a relative
       * URL will be resolved into an absolute URL in the context of the application document.
       * Parsing means that the anchor node's host, hostname, protocol, port, pathname and related
       * properties are all populated to reflect the normalized URL.  This approach has wide
       * compatibility - Safari 1+, Mozilla 1+, Opera 7+,e etc.  See
       * http://www.aptana.com/reference/html/api/HTMLAnchorElement.html
       *
       * Implementation Notes for IE
       * ---------------------------
       * IE <= 10 normalizes the URL when assigned to the anchor node similar to the other
       * browsers.  However, the parsed components will not be set if the URL assigned did not specify
       * them.  (e.g. if you assign a.href = "foo", then a.protocol, a.host, etc. will be empty.)  We
       * work around that by performing the parsing in a 2nd step by taking a previously normalized
       * URL (e.g. by assigning to a.href) and assigning it a.href again.  This correctly populates the
       * properties such as protocol, hostname, port, etc.
       *
       * References:
       *   http://developer.mozilla.org/en-US/docs/Web/API/HTMLAnchorElement
       *   http://www.aptana.com/reference/html/api/HTMLAnchorElement.html
       *   http://url.spec.whatwg.org/#urlutils
       *   https://github.com/angular/angular.js/pull/2902
       *   http://james.padolsey.com/javascript/parsing-urls-with-the-dom/
       *
       * @kind function
       * @param {string} url The URL to be parsed.
       * @description Normalizes and parses a URL.
       * @returns {object} Returns the normalized URL as a dictionary.
       *
       *   | member name   | Description    |
       *   |---------------|----------------|
       *   | href          | A normalized version of the provided URL if it was not an absolute URL |
       *   | protocol      | The protocol including the trailing colon                              |
       *   | host          | The host and port (if the port is non-default) of the normalizedUrl    |
       *   | search        | The search params, minus the question mark                             |
       *   | hash          | The hash string, minus the hash symbol
       *   | hostname      | The hostname
       *   | port          | The port, without ":"
       *   | pathname      | The pathname, beginning with "/"
       *
       */
      function urlResolve(url) {
        var href = url;

        // Normalize before parse.  Refer Implementation Notes on why this is
        // done in two steps on IE.
        urlParsingNode.setAttribute("href", href);
        href = urlParsingNode.href;
        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/')
            ? urlParsingNode.pathname
            : '/' + urlParsingNode.pathname
        };
      }

      /**
       * Parse a request URL and determine whether this is a same-origin request as the application document.
       *
       * @param {string|object} requestUrl The url of the request as a string that will be resolved
       * or a parsed URL object.
       * @returns {boolean} Whether the request is for the same origin as the application document.
       */
      function urlIsSameOrigin(requestUrl) {
        var parsed = (angular.isString(requestUrl)) ? urlResolve(requestUrl) : requestUrl;
        return (parsed.protocol === originUrl.protocol &&
                parsed.host === originUrl.host);
      }

      return {
        urlResolve: urlResolve,
        isSameOrigin: urlIsSameOrigin
      };

    });

  }());
(function() {
    'use strict';

    angular
        .module('app.main.catalogs.customers.locations', []);
})();
(function() {
    'use strict';
    
    angular
        .module('app.main.assortments.users',[]);
})();
(function() {
    'use strict';

    angular
        .module('app.main.accounts.users.notifications', []);
})();
(function () {
  'use strict'

  angular
    .module('app.main.unsupported-browser', [])
    .config(config);

  /* @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider) {
    // State
    $stateProvider.state('app.errors_unsupported_browser', {
      url: '/unsupported-browser',
      views: {
        'main@': {
          templateUrl: 'app/core/layouts/content-only.html',
          controller : 'MainController as vm'
        },
        'content@app.errors_unsupported_browser': {
          templateUrl: 'app/main/error-pages/unsupported-browser/unsupported-browser.html'
        }
      }
    });
    $translatePartialLoaderProvider.addPart('app/main/error-pages/unsupported-browser');
  }
})();
(function () {

    'use strict';

    angular
        .module('app.main.plugins', [
            'app.main.consolidation-plugins',
            'app.main.order-plugins'
        ]);
})();
(function() {
    'use strict';
    
    angular.module('app.main.attributes', [
        'app.main.attributes.attributes-list',
        'app.main.attributes.attribute-groups'
    ]);
})();
(function () {
  'use strict'

  angular
    .module('app.main.maintenance', [])
    .config(config);

  /* @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider) {
    // State
    $stateProvider.state('app.maintenance', {
      url: '/maintenance',
      views: {
        'main@': {
          templateUrl: 'app/core/layouts/content-only.html',
          controller : 'MainController as vm'
        },
        'content@app.maintenance': {
          templateUrl: 'app/main/app-maintenance/app-maintenance.html'
        }
      }
    });
    $translatePartialLoaderProvider.addPart('app/main/app-maintenance');
  }
})();
(function() {
	'use strict';

	angular.module('app.main.accounts', [
		'app.main.accounts.admin.users',
		'app.main.accounts.buyers',
		'app.main.accounts.sellers',
		'app.main.accounts.users',
		'app.main.accounts.auth-users',
		'app.main.accounts.interface-users',
		'app.main.accounts.user-groups'
	]);

})();
angular.module('fuse').run(['$templateCache', function($templateCache) {$templateCache.put('app/quick-panel/quick-panel.html','<md-content><md-tabs md-no-pagination md-swipe-content md-stretch-tabs="always" md-no-ink><md-tab><md-tab-label><span \ntranslate="QUICKPANEL.TODAY">TODAY</span></md-tab-label><md-tab-body><md-content class="today-tab scrollable" \nms-scroll ng-include="\'app/quick-panel/tabs/today/today-tab.html\'"></md-content></md-tab-body></md-tab></md-tabs>\n</md-content>');
$templateCache.put('app/core/layouts/content-only.html','<div id="layout-content-only" class="template-layout" layout="column" flex><md-content id="content" \nclass="animate-slide-up md-hue-2" ui-view="content" flex></md-content></div>');
$templateCache.put('app/core/layouts/content-with-toolbar.html','<div id="layout-content-with-toolbar" class="template-layout" layout="column" flex><md-toolbar id="toolbar" \nclass="md-menu-toolbar md-whiteframe-1dp" ui-view="toolbar"></md-toolbar><md-content id="content" \nclass="animate-slide-up md-hue-2" ui-view="content" flex></md-content></div>');
$templateCache.put('app/core/layouts/horizontal-navigation.html','<div id="layout-horizontal-navigation" class="template-layout" layout="column" flex><md-toolbar id="toolbar" \nclass="md-menu-toolbar" ui-view="toolbar"></md-toolbar><div id="horizontal-navigation" class="md-whiteframe-1dp" \nui-view="navigation"></div><div id="content-container" flex layout="column"><md-content id="content" \nclass="animate-slide-up md-hue-2" ms-scroll ui-view="content" flex></md-content></div><md-sidenav id="quick-panel" \nclass="md-sidenav-right md-whiteframe-4dp" md-component-id="quick-panel" ms-scroll ui-view="quickPanel"></md-sidenav>\n</div>');
$templateCache.put('app/core/layouts/vertical-navigation.html','<div id="layout-vertical-navigation" class="template-layout" layout="row" flex><md-sidenav id="vertical-navigation" \nclass="md-primary-bg" md-is-locked-open="$mdMedia(\'gt-sm\')" md-component-id="navigation" ms-scroll \nui-view="navigation" ng-if="!vm.isFullScreen"></md-sidenav><div id="content-container" flex layout="column" \nng-class="{\'ml-0-i\': vm.isFullScreen}"><md-toolbar id="toolbar" class="md-menu-toolbar md-whiteframe-1dp" \nui-view="toolbar" ng-if="!vm.isFullScreen"></md-toolbar><div \nng-class="{\'md-content-top-position-0-i\': vm.isFullScreen}"><md-content id="content" \nclass="animate-fade-in-out md-hue-2" ms-scroll ui-view="content" flex></md-content></div></div><md-sidenav \nid="quick-panel" class="md-sidenav-right md-whiteframe-4dp" md-component-id="quick-panel" ms-scroll \nui-view="quickPanel"></md-sidenav></div><div class="full-screen-action-bar" ng-if="vm.isFullScreen" \nng-click="vm.isFullScreen = !vm.isFullScreen; vm.toggleFullScreen()"><md-button id="exit-full-screen" \nclass="md-icon-button exist-full-screen-icon" aria-label="Toggle full screen" translate \ntranslate-attr-aria-label="TOOLBAR.EXIT_FULL_SCREEN"><md-icon md-font-icon="icon-arrow-collapse" class="icon">\n</md-icon><md-tooltip><span translate="TOOLBAR.EXIT_FULL_SCREEN"></span></md-tooltip></md-button></div>');
$templateCache.put('app/core/theme-options/theme-options.html','<div class="ms-theme-options-panel" layout="row" layout-align="start start"><div \nclass="ms-theme-options-panel-button md-primary-bg" ng-click="toggleOptionsPanel()"><md-icon md-font-icon="icon-cog" \nclass="white-text"></md-icon></div><div class="ms-theme-options-list" layout="column"><div class="theme-option"><div \nclass="option-title">Layout Style:</div><md-radio-group layout="column" ng-model="vm.layoutStyle" \nng-change="vm.updateLayoutStyle()"><md-radio-button value="verticalNavigation">Vertical Navigation</md-radio-button>\n<md-radio-button value="horizontalNavigation">Horizontal Navigation</md-radio-button><md-radio-button \nvalue="contentOnly">Content Only</md-radio-button><md-radio-button value="contentWithToolbar">Content with Toolbar\n</md-radio-button></md-radio-group></div><md-divider></md-divider><div class="theme-option"><div class="option-title">\nLayout Mode:</div><md-radio-group layout="row" layout-align="start center" ng-model="vm.layoutMode" \nng-change="vm.updateLayoutMode()"><md-radio-button value="boxed">Boxed</md-radio-button><md-radio-button value="wide">\nWide</md-radio-button></md-radio-group></div><md-divider></md-divider><div class="theme-option"><div \nclass="option-title">Color Palette:</div><md-menu-item ng-repeat="(themeName, theme) in vm.themes.list" class="theme">\n<md-button class="md-raised theme-button" aria-label="{{themeName}}" ng-click="vm.setActiveTheme(themeName)" \nng-style="{\'background-color\': theme.primary.color,\'border-color\': theme.accent.color,\'color\': theme.primary.contrast1}" \nng-class="themeName"><span><md-icon ng-style="{\'color\': theme.primary.contrast1}" md-font-icon="icon-palette">\n</md-icon><span>{{themeName}}</span></span></md-button></md-menu-item></div></div></div>');
$templateCache.put('app/directives/txAutocomplete/tx-autocomplete.html','<md-autocomplete md-input-id="{{vm.id}}" md-input-name="{{vm.id}}" md-selected-item="vm.destinationField" \nng-disabled="vm.isDisabled" md-items="item in vm.querySearch(vm.searchText)" md-search-text="vm.searchText" \nmd-item-text="vm.getItemText(item)" md-min-length="0" md-floating-label="{{vm.label | translate}}" \nmd-selected-item-change="vm.selectedItemChanged(item)" ng-required="vm.isRequired" md-no-cache="true" \nmd-select-on-focus="true" md-menu-class="autocomplete-custom" md-require-match="true" md-match-case-insensitive="true" \nmd-select-on-match="true"><md-item-template><span class="autocomplete-item md-accent-fg" \nmd-highlight-text="vm.searchText" md-highlight-flags="i">{{vm.getAutoCompleteDisplayValue(item)}}</span>\n</md-item-template><md-not-found>No Record matching "{{vm.searchText}}" were found.</md-not-found><div \nng-messages="vm.form[vm.id].$error" role="alert"><div ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}\n</div><div ng-message="md-require-match">{{\'VALIDATIONS.REQUIRED\' | translate}}</div></div></md-autocomplete>');
$templateCache.put('app/directives/txBreadcrumbs/tx-breadcrumbs.html','<div class="tx-breadcrumbs" layout="row" flex layout-align="center center"><dl><dt><span>Home</span> <span \nng-repeat="crumb in breadcrumbs" ng-if="!$last">/ <a ui-sref="{{crumb.route}}" translate>{{ crumb.displayName }}</a>\n</span></dt><dd><span>{{breadcrumbs[breadcrumbs.length - 1].displayName | translate | changeConfiguredLabels}}</span>\n</dd></dl></div>');
$templateCache.put('app/directives/txDataDetails/tx-data-details.html','<md-button id="txfab" class="md-fab md-warn" ng-click="vm.editRecord($event, vm.account)" \naria-label="vm.model.views.mainDetails.fabAction.label" translate \ntx-access="{{::vm.model.views.mainDetails.fabAction.privilege}}" \nng-disabled="vm.isActionDisabled(vm.account, vm.model.views.mainDetails.fabAction.disabled)"><md-icon \nmd-font-icon="{{vm.model.views.mainDetails.fabAction.icon}}"></md-icon></md-button><div \nclass="tx-data-details detail-tab widget-group" layout="row" flex="100" layout-wrap><ms-widget layout="row" flex="100">\n<ms-widget-front class="white-bg"><div class="view-toolbar" layout="row" layout-align="space-between center"><div><span\n class="h2" ng-if="!vm.isLoading">{{vm.title}}</span> <span class="h2" ng-if="vm.isLoading" translate>TITLES.LOADING\n</span> <span class="ml-16 text-boxed white-fg" ng-class="vm.account[vm.statusField] === 1 ? \'green-bg\' : \'red-bg\'" \ntranslate \nng-if="!vm.isLoading && vm.account[vm.statusField] !== undefined && (vm.account[vm.statusField] === 1 || vm.account[vm.statusField] === 0 && (vm.account[vm.statusField] !== 2 || vm.account[vm.statusField] !== 3))">\n{{vm.account[vm.statusField] === 1 ? \'STATUS.ACTIVE\' : \'STATUS.INACTIVE\'}} </span><span \nclass="ml-16 text-boxed white-fg" ng-class="vm.account[vm.statusField] === 2 ? \'red-bg\' : \'tx-blue-bg\'" translate \nng-if="!vm.isLoading && vm.account[vm.statusField] !== undefined && (vm.account[vm.statusField] === 2 || vm.account[vm.statusField] === 3)">\n{{vm.account[vm.statusField] === 2 ? \'STATUS.GLOBALLY_DROPPED\' : \'STATUS.NOT_ASSORTED\'}} </span><span \nclass="ml-16 text-boxed white-fg" ng-class="vm.account[vm.statusField] !== \'FAIL\' ? \'green-bg\' : \'red-bg\'" translate \nng-if="!vm.isLoading && vm.account[vm.statusField] !== undefined && vm.account[vm.statusField] !== 1 && vm.account[vm.statusField] !== 0 && vm.account[vm.statusField] !== 2 && vm.account[vm.statusField] !== 3">\n{{vm.account[vm.statusField]}} </span><span ng-if="vm.showRefreshRecordButton && vm.model.isBulkActionCompleted" \nclass="alert md-warn-bg text-boxed" flex ng-click="vm.doRefreshAction()" translate="ALERT.REFRESH_RECORD">\nRecord have been modified, please refresh.</span><span class="alert md-warn-bg text-boxed" flex \nng-if="vm.model.isBulkActionCompleted === true" ng-click="vm.doRefreshAction()" translate="ALERT.BULK_COMPLETED">\nRecords have been modified, please refresh.</span></div><div ng-if="!vm.isLoading"><md-button \nng-if="vm.model.views.mainDetails.processOrdersItemActions" \nng-repeat="processOrderItemAct in vm.model.views.mainDetails.processOrdersItemActions track by processOrderItemAct.id" \nclass="md-icon-button" aria-label="{{processOrderItemAct.label}}" \ntranslate-attr-aria-label="{{processOrderItemAct.label}}" \nng-click="vm.doProcessOrderItemAction(processOrderItemAct, vm.account)" \nng-hide="vm.isProcessOrderActionDisabled(vm.account, processOrderItemAct)" \ntx-access="{{::processOrderItemAct.privilege}}"><md-icon md-font-icon="{{processOrderItemAct.icon}}"></md-icon>\n<md-tooltip><span translate>{{processOrderItemAct.label}}</span></md-tooltip></md-button><md-button \nng-repeat="itemAction in vm.itemActions track by itemAction.id" class="md-icon-button" \naria-label="{{itemAction.label}}" translate-attr-aria-label="{{itemAction.label}}" \nng-click="vm.doItemAction(itemAction, vm.account)" \nng-disabled="vm.isActionDisabled(vm.account, {{itemAction.disabled}})" ng-show="{{itemAction.visible}}" \ntx-access="{{::itemAction.privilege}}"><md-icon md-font-icon="{{itemAction.icon}}"></md-icon><md-tooltip><span \ntranslate>{{itemAction.label}}</span></md-tooltip></md-button><md-button class="md-icon-button" aria-label="Refresh" \ntranslate translate-attr-aria-label="ACTIONS.REFRESH" ng-click="vm.doRefreshAction()"><md-icon \nmd-font-icon="icon-refresh"></md-icon><md-tooltip><span translate="ACTIONS.REFRESH">Refresh</span></md-tooltip>\n</md-button></div></div><div ng-style="vm.listStyle" layout="row" layout-align="center center" ng-show="vm.isLoading">\n<md-progress-circular md-mode="indeterminate" class="md-accent"></md-progress-circular></div><md-content \nng-style="vm.listStyle" ng-hide="vm.isLoading" ms-scroll><div class="p-24" layout="row" layout-align="start start" \nlayout-wrap><div flex="100" flex-gt-xs="{{field.inputType === \'datatable\' ? 100 : 50}}" \nng-class="field.inputType !== \'datatable\' ? \'info-line\' : \'\'" \nng-repeat="field in vm.model.fields | filter:{visible:true, isRequestField: false, isRequestReasonField: false}">\n<tx-field-viewer tx-fields="vm.model.fields" tx-field="field" tx-data="vm.account" tx-lookup-data="vm.lookupData" \ntx-status-field="{{::vm.statusField}}" tx-show-datatable-as-grid="true"></tx-field-viewer></div><div \nng-if="vm.showRequestContent" class="request-content-container"><div class="view-toolbar" layout="row" \nlayout-align="space-between center"><div><span class="h3">{{ \'TITLES.REQUEST_CONTENT\' | translate }}</span></div></div>\n<md-content layout="row" layout-align="start start" layout-wrap ng-if="vm.model.fields && vm.model.fields.length"><div \nflex-gt-xs="50" flex="100" class="info-line" \nng-repeat="field in vm.model.fields | filter:{visible:true, isRequestField: true}"><tx-field-viewer \ntx-fields="vm.model.fields" tx-field="field" tx-data="vm.account" tx-lookup-data="vm.lookupData" \ntx-status-field="{{::vm.statusField}}"></tx-field-viewer></div></md-content><div class="request-content" \nng-if="vm.model.seasonlessModelfields && vm.model.seasonlessModelfields.length"><span class="h3">\n{{ \'TITLES.SEASONLESS_MODEL_ATTRIBUTES\' | translate }}:</span></div><md-content layout="row" \nlayout-align="start start" layout-wrap ng-if="vm.model.seasonlessModelfields && vm.model.seasonlessModelfields.length">\n<div flex-gt-xs="50" flex="100" class="info-line" \nng-repeat="field in vm.model.seasonlessModelfields | filter:{visible:true, isRequestField: true}" \nng-if="vm.model.seasonlessModelfields && vm.model.seasonlessModelfields.length"><tx-field-viewer \ntx-fields="vm.model.seasonlessModelfields" tx-field="field" tx-data="vm.account" tx-lookup-data="vm.lookupData" \ntx-status-field="{{::vm.statusField}}"></tx-field-viewer></div></md-content><div class="request-content" \nng-if="vm.model.seasonalModelfields && vm.model.seasonalModelfields.length"><span class="h3">\n{{ \'TITLES.SEASONAL_MODEL_ATTRIBUTES\' | translate }}:</span></div><md-content layout="row" layout-align="start start" \nlayout-wrap ng-if="vm.model.seasonalModelfields && vm.model.seasonalModelfields.length"><div flex-gt-xs="50" \nflex="100" class="info-line" \nng-repeat="field in vm.model.seasonalModelfields | filter:{visible:true, isRequestField: true}"><tx-field-viewer \ntx-fields="vm.model.seasonalModelfields" tx-field="field" tx-data="vm.account" tx-lookup-data="vm.lookupData" \ntx-status-field="{{::vm.statusField}}"></tx-field-viewer></div></md-content><div class="request-content" \nng-if="vm.model.articleFields && vm.model.articleFields.length"><span class="h3">\n{{ \'TITLES.REQUEST_ARTICLES\' | translate }}:</span></div><md-content layout-align="start start" layout-wrap \nng-if="vm.model.articleFields && vm.model.articleFields.length" ms-scroll><div \nng-if="vm.model.articleFields && vm.model.articleFields.length"><md-content layout-align="start start" layout-wrap \nng-if="vm.model.articleFields && vm.model.articleFields.length" ms-scroll><table class="request-articles-table"><thead>\n<tr><th class="header" ng-repeat="field in vm.model.articleFields | filter:{visible:true, isRequestField: true}">\n{{field.displayLabel}}</th></tr></thead><tbody><tr ng-repeat="requestArticle in vm.account.requestArticles"><td \nng-repeat="field in vm.model.articleFields | filter:{visible:true, isRequestField: true}"><tx-field-viewer \ntx-fields="vm.model.articleFields" tx-field="field" tx-data="requestArticle" tx-lookup-data="vm.lookupData" \ntx-status-field="{{::vm.statusField}}" tx-hide-title="true"></tx-field-viewer></td></tr></tbody></table></md-content>\n</div></md-content><div class="view-toolbar request-reason" layout="row" layout-align="space-between center"><div><span\n class="h3">{{ \'TITLES.REQUEST_REASON\' | translate }}</span></div></div><md-content layout="row" \nlayout-align="start start" layout-wrap><div flex-gt-xs="50" flex="100" class="info-line" \nng-repeat="field in vm.model.fields | filter:{visible:true, isRequestReasonField: true}"><tx-field-viewer \ntx-fields="vm.model.fields" tx-field="field" tx-data="vm.account" tx-lookup-data="vm.lookupData" \ntx-status-field="{{::vm.statusField}}"></tx-field-viewer></div></md-content></div></div></md-content></ms-widget-front>\n</ms-widget></div>');
$templateCache.put('app/directives/txDataGrid/tx-data-grid.html','<div class="tx-data-grid" layout="row"><div layout="column" flex><div id="toolbar" class="toolbar" layout="row" \nlayout-align="space-between center"><div layout="row" layout-align="start center"><div><md-checkbox class="no-label" \naria-label="{{vm.allSelected?\'Uncheck All\':\'Check All\'}}" ng-checked="vm.allSelected" \nmd-indeterminate="vm.isIndeterminate" \ntranslate-attr-aria-label="{{vm.allSelected? \'ACTIONS.SELECT_NONE\':\'ACTIONS.SELECT_ALL\'}}" ng-click="vm.doSelectAll()">\n</md-checkbox></div><div><md-menu><md-button class="md-icon-button" ng-click="$mdOpenMenu($event)" \naria-label="Filters" translate translate-attr-aria-label="ACTIONS.FILTERS"><md-icon md-font-icon="icon-menu-down">\n</md-icon></md-button><md-menu-content width="3"><md-menu-item><md-button aria-label="All" \ntranslate="ACTIONS.SELECT.ALL" translate-attr-aria-label="ACTIONS.SELECT.ALL" ng-click="vm.doSelectAll(\'all\')" \nng-disabled="!vm.data.length">All</md-button></md-menu-item><md-menu-item><md-button aria-label="None" \ntranslate="ACTIONS.SELECT.NONE" translate-attr-aria-label="ACTIONS.SELECT.NONE" ng-click="vm.doSelectAll(\'none\')" \nng-disabled="!vm.data.length">None</md-button></md-menu-item><md-menu-item><md-button aria-label="Active" \ntranslate="ACTIONS.SELECT.ACTIVE" translate-attr-aria-label="ACTIONS.SELECT.ACTIVE" ng-click="vm.doSelectAll(1)" \nng-disabled="!vm.data.length || !vm.canSelectBasedOnStatusField">Active</md-button></md-menu-item><md-menu-item>\n<md-button aria-label="Deleted" translate="ACTIONS.SELECT.INACTIVE" \ntranslate-attr-aria-label="ACTIONS.SELECT.INACTIVE" ng-click="vm.doSelectAll(0)" \nng-disabled="!vm.data.length || !vm.canSelectBasedOnStatusField">Deleted</md-button></md-menu-item></md-menu-content>\n</md-menu></div><div class="divider-vertical" hide show-gt-xs></div><span \nclass="ml-16 text-boxed md-accent-bg highlight" ng-if="vm.data.length" hide show-gt-xs>\n{{vm.selectedRecordsLength}} {{\'PARTS.OF\' | translate}} {{vm.dataLength}} {{\'PARTS.SELECTED\' | translate}}</span> <span\n class="ml-16 text-boxed md-accent-bg highlight" ng-hide="(vm.searchPhrase === \'\' || vm.searchPhrase === null)" hide \nshow-gt-xs>{{vm.filteredDataLength}} {{\'PARTS.FILTERED\' | translate}}</span></div><div layout="row" \nlayout-align="start center" flex="20" ng-hide="vm.isAdvanceSearch"><md-input-container md-no-float class="md-block" \nstyle="width: 100%"><input ng-model="vm.searchPhrase" type="text" placeholder="{{\'PARTS.SEARCH\' | translate}}" \nmd-autofocus tx-focus="!vm.isAdvanceSearch"></md-input-container><md-button class="md-icon-button" \nng-click="vm.toggleAdvancedSearch()" aria-label="Advance Search" ng-if="vm.isAdvanceSearchEnabled" translate \ntranslate-attr-aria-label="ACTIONS.FILTER_CLOSE"><md-tooltip>{{\'PARTS.ADVANCED_SEARCH\' | translate}}</md-tooltip>\n<md-icon md-font-icon="icon-playlist-plus"></md-icon></md-button></div></div><div class="grid-content"><div \nng-if="vm.viewType === \'checklistView\'" ng-include="\'app/directives/txDataGrid/views/checklist-view.html\'"></div><div \nng-if="vm.viewType === \'imageView\'" ng-include="\'app/directives/txDataGrid/views/image-view.html\'"></div><div \nlayout="row" ng-style="vm.listStyle" layout-align="center center" ng-show="vm.isLoading"><md-progress-circular \nmd-mode="indeterminate" class="md-accent"></md-progress-circular></div><div layout="row" ng-style="vm.listStyle" \nlayout-align="center center" layout-padding ng-show="!vm.filteredDataLength && !vm.isLoading"><div class="text-italic" \ntranslate="MESSAGES.LIST.NO_ITEMS">No items available...</div></div></div></div><div class="divider-vertical" \nng-style="vm.advancedSearchVDevider" ng-if="vm.isAdvanceSearch"></div><div layout="column" layout-align="start center" \nng-show="vm.isAdvanceSearch" ng-style="vm.advancedSearchVDevider" class="advanced-search" \nng-class="{\'show-advanced-search\': vm.isAdvanceSearch, \'hide-advanced-search\': !vm.isAdvanceSearch}"><div \nlayout="column" layout-align="center center" class="advanced-search-title" ng-style="vm.toolbarStyle"><span \ntranslate="PARTS.ADVANCED_SEARCH">Advanced Search</span></div><md-input-container class="md-block" ms-scroll><textarea \ntx-focus="vm.isAdvanceSearch" columns="1" rows="1" ng-model="vm.advancedSearchValues" \nng-keyup="vm.advancedSearchKeyPress($event)" aria-label="PARTS.ADVANCED_SEARCH"></textarea></md-input-container></div>\n</div>');
$templateCache.put('app/directives/txDatasetAutocomplete/tx-dataset-autocomplete.html','<div class="dataset-values-dropdown"><md-input-container class="md-block"><label>{{vm.field.displayLabel | translate}}\n</label><md-select id="dataset_values_select" name="{{vm.field.field}}" ng-model="vm.selectedValue" \naria-label="{{vm.field.displayLabel | translate}}" ng-required="vm.field.validation.isRequired" \nng-disabled="{{vm.field.validation.disabledCriteria}}" md-on-open="vm.onDropdownOpen()" \nmd-on-close="vm.onDropdownClose()"><md-select-header class="search-header"><div class="search-input-container" \nstyle="display: flex; align-items: center; position: relative"><input id="dataset_search_input" \nng-model="vm.searchText" type="search" placeholder="{{\'PARTS.SEARCH\' | translate}}" \nng-keydown="$event.stopPropagation()" ng-focus="focus=true" ng-change="vm.onSearchTextChange(vm.searchText)" \nstyle="flex: 1; padding-right: 40px; border: none; outline: none"><md-icon ng-if="vm.searchText.length > 0" \nclass="clear-search-button" ng-click="vm.clearSearch()" md-font-icon="icon-close" \nstyle="position: absolute; right: 8px; cursor: pointer; color: #666"></md-icon></div></md-select-header><md-option \nng-if="vm.isLoading" disabled="disabled"><div layout="row" layout-align="center center"><md-progress-circular \nmd-diameter="20" md-mode="indeterminate"></md-progress-circular></div></md-option><md-option \nng-if="!vm.isLoading && vm.showInitialMessage" disabled="disabled">{{\'MESSAGES.START_TYPING\' | translate}}</md-option>\n<md-option ng-if="!vm.isLoading && vm.searchText.length >= 3 && vm.values.length === 0" disabled="disabled">\n{{\'MESSAGES.NO_MATCHING_RECORDS\' | translate}}</md-option><md-option ng-repeat="value in vm.values track by $index" \nng-value="value.Id">{{ value.DisplayValue }}</md-option><md-option ng-if="vm.isLoadingMore" disabled="disabled"><div \nlayout="row" layout-align="center center"><md-progress-circular md-diameter="20" md-mode="indeterminate">\n</md-progress-circular></div></md-option></md-select><md-icon \nng-if="vm.selectedValue && !(vm.field.validation.disabledCriteria === true || vm.scope.$eval(vm.field.validation.disabledCriteria))" \nclass="clear-selected-button" ng-click="vm.clearSelectedValue($event)" md-font-icon="icon-close" \naria-label="Clear selected value" \nstyle="position: absolute; top: 8px; right: 52px; left: auto; width: 16px; height: 16px; min-width: 16px; min-height: 16px; font-size: 16px; line-height: 16px; cursor: pointer; color: #666; z-index: 2">\n</md-icon><div ng-messages="vm.field.$error" role="alert" multiple="multiple"><div ng-message="required">\n{{vm.field.validation.messages.isRequired | translate}}</div><div ng-message="pattern">\n{{vm.field.validation.messages.pattern | translate}}</div></div></md-input-container></div>');
$templateCache.put('app/directives/txDataTable/tx-data-table.html','<div class="tx-data-table"><div id="table-toolbar" class="table-toolbar" layout="row" \nlayout-align="space-between center"><div layout="row" layout-wrap layout-align="start center"><div \nng-show="vm.enableSelection"><md-checkbox class="no-label" aria-label="{{vm.allSelected?\'Uncheck All\':\'Check All\'}}" \nng-checked="vm.allSelected" translate-attr-aria-label="{{vm.allSelected? \'ACTIONS.SELECT_NONE\':\'ACTIONS.SELECT_ALL\'}}" \nng-click="vm.doSelectAll()"></md-checkbox></div><md-button class="md-icon-button" hide-xs aria-label="export" \ntranslate-attr-aria-label="ACTIONS.EXPORT" ng-click="vm.doExport()" ng-disabled="!vm.data.length" \nng-show="vm.enableExport"><md-icon md-font-icon="icon-export"></md-icon><md-tooltip><span translate="ACTIONS.EXPORT">\n</span></md-tooltip></md-button><md-button ng-show="listAct.visible && vm.enableModuleListActions" \nng-repeat="listAct in vm.view.listActions track by listAct.id" class="md-icon-button" aria-label="{{listAct.label}}" \ntranslate-attr-aria-label="{{listAct.label}}" ng-click="vm.doListAction(listAct)" ng-disabled="listAct._disabled" \ntx-access="{{::listAct.privilege}}" hide-xs><md-icon md-font-icon="{{listAct.icon}}"></md-icon><md-tooltip><span \ntranslate>{{listAct.label}}</span></md-tooltip></md-button><md-button ng-show="vm.view.processOrdersListActions" \nng-repeat="processOrderListAct in vm.view.processOrdersListActions track by processOrderListAct.id" \nclass="md-icon-button" aria-label="{{processOrderListAct.label}}" \ntranslate-attr-aria-label="{{processOrderListAct.label}}" ng-click="vm.doProcessOrderListAction(processOrderListAct)" \nng-hide="processOrderListAct._disabled || {{!processOrderListAct.visible}}" \ntx-access="{{::processOrderListAct.privilege}}" hide-xs><md-icon md-font-icon="{{processOrderListAct.icon}}"></md-icon>\n<md-tooltip><span translate>{{processOrderListAct.label}}</span></md-tooltip></md-button><md-button \nng-show="vm.view.changeManagementListActions && changeManagementListAct._visible" \nng-repeat="changeManagementListAct in vm.view.changeManagementListActions track by changeManagementListAct.id" \nclass="md-icon-button" aria-label="{{::changeManagementListAct.label}}" \ntranslate-attr-aria-label="{{::changeManagementListAct.label}}" \nng-click="vm.doChangeManagementListAction(changeManagementListAct)" hide-xs \nng-disabled="changeManagementListAct._disabled" tx-access="{{::changeManagementListAct.privilege}}"><md-icon \nmd-font-icon="{{::changeManagementListAct.icon}}"></md-icon><md-tooltip><span translate>\n{{::changeManagementListAct.label}}</span></md-tooltip></md-button><md-select ng-model="vm.activeCatalogTree" \nng-if="vm.showTreeListDropdown" ng-disabled="vm.catalogTreeList.length === 0" placeholder="Catalog Tree List" \nclass="md-no-underline m-0" ng-change="vm.onActiveTreeChange(vm.activeCatalogTree)"><md-option ng-value="tree" \nng-repeat="tree in vm.catalogTreeList">{{tree.Name}}</md-option></md-select><span \nclass="ml-16 text-boxed md-accent-bg highlight" ng-show="vm.data.length && vm.enableSelection && !vm.isLoading" hide \nshow-gt-xs>\n{{vm.selectedRecordsLength}} {{\'PARTS.OF\' | translate}} {{vm.totalRecordCount || vm.dataLength}} {{\'PARTS.SELECTED\' | translate}}\n</span> <span class="ml-16 text-boxed md-accent-bg highlight" \nng-show="vm.view.showFilterRow || vm.view.toggleFilterProps.toggleStatus" hide show-gt-xs>\n{{vm.filteredDataLength}} {{\'PARTS.FILTERED\' | translate}}</span><div class="alert-button-container"><span \nclass="alert-button md-warn-bg text-boxed" flex ng-if="vm.model.isBulkActionCompleted === true" \nng-click="vm.doRefreshAction()" translate="ALERT.BULK_COMPLETED">Records have been modified, please refresh.</span>\n</div></div><div layout="row" layout-wrap layout-align="end center"><button \nclass="ml-16 text-boxed md-accent-bg merch-view-buttons" ng-show="vm.view.merchBoradViews" \nng-repeat="merchBoradView in vm.view.merchBoradViews track by merchBoradView.id" \naria-label="{{::merchBoradView.label}}" translate-attr-aria-label="{{::merchBoradView.label}}" \nng-click="vm.doMerchBoradViewChange(merchBoradView)" hide-xs tx-access="{{::merchBoradView.privilege}}"><span \ntranslate>{{::merchBoradView.label}}</span><md-tooltip><span translate>{{::merchBoradView.label}}</span></md-tooltip>\n</button><md-select ng-model="vm.selectedFilter" hide-xs hide-sm \nng-if="(vm.predefinedFilters.my.length > 0 || vm.predefinedFilters.catalog.length) && !vm.hidePredefinedFilter" \nplaceholder="Pre-Defined Filter" class="md-no-underline m-0 predefined-column" \nng-change="vm.onPredefinedFilterChange()"><md-option><em>None</em></md-option><md-optgroup label="My Filters" \nng-if="vm.predefinedFilters.my.length > 0"><md-option ng-value="f" ng-repeat="f in vm.predefinedFilters.my">{{f.name}}\n</md-option></md-optgroup><md-optgroup label="Pre-defined Filters" ng-if="vm.predefinedFilters.catalog.length > 0">\n<md-option ng-value="f" ng-repeat="f in vm.predefinedFilters.catalog">{{f.name}}</md-option></md-optgroup></md-select>\n<md-select ng-model="vm.selectedColumns" hide-xs hide-sm \nng-if="(vm.predefinedColumns.my.length > 0 || vm.predefinedColumns.catalog.length) && !vm.hidePredefinedColumn" \nplaceholder="Pre-Defined Columns" class="md-no-underline m-0 predefined-column" \nng-change="vm.onPredefinedColumnsChange()"><md-option><em>None</em></md-option><md-optgroup label="My Columns" \nng-if="vm.predefinedColumns.my.length > 0"><md-option ng-value="column" ng-repeat="column in vm.predefinedColumns.my">\n{{column.name}}</md-option></md-optgroup><md-optgroup label="Catalog Columns" \nng-if="vm.predefinedColumns.catalog.length > 0"><md-option ng-value="column" \nng-repeat="column in vm.predefinedColumns.catalog">{{column.name}}</md-option></md-optgroup></md-select><md-select \nng-model="vm.selectedFilter" hide-gt-sm \nng-if="(vm.predefinedFilters.my.length > 0 || vm.predefinedFilters.catalog.length) && !vm.hidePredefinedFilter" \nplaceholder="Filters" class="md-no-underline m-0 predefined-column" ng-change="vm.onPredefinedFilterChange()">\n<md-option><em>None</em></md-option><md-optgroup label="My Filters" ng-if="vm.predefinedFilters.my.length > 0">\n<md-option ng-value="f" ng-repeat="f in vm.predefinedFilters.my">{{f.name}}</md-option></md-optgroup><md-optgroup \nlabel="Pre-defined Filters" ng-if="vm.predefinedFilters.catalog.length > 0"><md-option ng-value="f" \nng-repeat="f in vm.predefinedFilters.catalog">{{f.name}}</md-option></md-optgroup></md-select><md-select \nng-model="vm.selectedColumns" hide-gt-sm \nng-if="(vm.predefinedColumns.my.length > 0 || vm.predefinedColumns.catalog.length) && !vm.hidePredefinedColumn" \nplaceholder="Columns" class="md-no-underline m-0 predefined-column" ng-change="vm.onPredefinedColumnsChange()">\n<md-option><em>None</em></md-option><md-optgroup label="My Columns" ng-if="vm.predefinedColumns.my.length > 0">\n<md-option ng-value="column" ng-repeat="column in vm.predefinedColumns.my">{{column.name}}</md-option></md-optgroup>\n<md-optgroup label="Catalog Columns" ng-if="vm.predefinedColumns.catalog.length > 0"><md-option ng-value="column" \nng-repeat="column in vm.predefinedColumns.catalog">{{column.name}}</md-option></md-optgroup></md-select><md-select \nng-if="vm.hideWhenChartView" ng-model="vm.view.chartFilter" placeholder="{{\'ACTIONS.FILTER_CHARTS\' | translate}}" \nclass="md-no-underline m-0" style="width: 148px"><md-option ng-value="undefined">All Charts</md-option><md-option \nng-value="\'1\'">Global Charts</md-option><md-option ng-value="\'0\'">My Charts</md-option></md-select><md-select \nng-if="vm.toolbarVisible === \'true\'" ng-model="vm.toolbarValue" placeholder="{{\'ACTIONS.FILTER_TOOLBAR\' | translate}}" \nclass="md-no-underline m-0" hide show-gt-xs><md-option ng-repeat="option in vm.toolbarOptions" \nng-value="{{option.value}}">{{ option.displayLabel | translate }}</md-option></md-select><div \nclass="attribute-group-selector" flex="none" ng-if="vm.attributeGroups.length && !vm.hideWhenChartView"><md-tooltip \nmd-direction="bottom"><span translate>MESSAGES.CONTENT.ATTRIBUTE_GROUP_SWITCH_HINT</span></md-tooltip><md-select \nng-model="vm.selectedAttributeGroupId" class="md-no-underline m-0" ng-change="vm.onAttributeGroupChange()" \naria-label="{{\'FIELDS.ATTRIBUTE_GROUP\' | translate}}"><md-option ng-value="attributeGroup.AttributeGroupId" \nng-repeat="attributeGroup in vm.attributeGroups track by attributeGroup.AttributeGroupId">\n{{attributeGroup.AttributeGroupName}}</md-option></md-select></div><div class="actions" flex="none"><md-menu><md-button\n class="md-icon-button" ng-click="$mdOpenMenu($event)" aria-label="Action"><md-icon md-font-icon="icon-dots-vertical">\n</md-icon></md-button><md-menu-content width="3"><md-menu-item ng-show="vm.enableExport" hide-gt-xs><md-button \nng-disabled="!vm.data.length" aria-label="export" translate-attr-aria-label="ACTIONS.EXPORT" ng-click="vm.doExport()">\n<md-icon class="s18" md-font-icon="icon-export"></md-icon><span translate="ACTIONS.EXPORT"></span></md-button>\n</md-menu-item><md-menu-item ng-show="listAct.visible && vm.enableModuleListActions" hide-gt-xs \nng-repeat="listAct in vm.view.listActions track by listAct.id"><md-button aria-label="{{listAct.label}}" \ntranslate-attr-aria-label="{{listAct.label}}" ng-click="vm.doListAction(listAct)" ng-disabled="listAct._disabled" \ntx-access="{{::listAct.privilege}}"><md-icon class="s18" md-font-icon="{{listAct.icon}}"></md-icon><span translate>\n{{listAct.label}}</span></md-button></md-menu-item><md-menu-item ng-show="vm.view.processOrdersListActions" hide-gt-xs \nng-hide="processOrderListAct._disabled || {{!processOrderListAct.visible}}" \nng-repeat="processOrderListAct in vm.view.processOrdersListActions track by processOrderListAct.id"><md-button \naria-label="{{processOrderListAct.label}}" translate-attr-aria-label="{{processOrderListAct.label}}" \nng-click="vm.doProcessOrderListAction(processOrderListAct)" tx-access="{{::processOrderListAct.privilege}}"><md-icon \nclass="s18" md-font-icon="{{processOrderListAct.icon}}"></md-icon><span translate>{{processOrderListAct.label}}</span>\n</md-button></md-menu-item><md-menu-item \nng-show="vm.view.changeManagementListActions && changeManagementListAct._visible" hide-gt-xs \nng-repeat="changeManagementListAct in vm.view.changeManagementListActions track by changeManagementListAct.id">\n<md-button aria-label="{{::changeManagementListAct.label}}" \ntranslate-attr-aria-label="{{::changeManagementListAct.label}}" \nng-click="vm.doChangeManagementListAction(changeManagementListAct)" ng-disabled="changeManagementListAct._disabled" \ntx-access="{{::changeManagementListAct.privilege}}" hide-gt-xs><md-icon class="s18" \nmd-font-icon="{{::changeManagementListAct.icon}}"></md-icon><span translate>{{::changeManagementListAct.label}}</span>\n</md-button></md-menu-item><md-menu-item \nng-if="vm.supportImagesView && vm.model.currentViewType === 1 && vm.imagesSizeInfo"><md-button \naria-label="Change Images Size" ng-disabled="vm.data.length === 0" \nng-click="vm.changeImagesSize(vm.imagesSizeInfo.next)"><md-icon class="s18" md-font-icon="icon-restore"></md-icon><span\n class="capitalize">{{vm.imagesSizeInfo.next}}</span></md-button></md-menu-item><md-menu-item \nng-if="vm.supportImagesView && vm.model.currentViewType === 1 && vm.imagesSizeInfo"><md-button \naria-label="Change Images Size" ng-disabled="vm.data.length === 0" \nng-click="vm.changeImagesSize(vm.imagesSizeInfo.previous)"><md-icon class="s18" md-font-icon="icon-restore"></md-icon>\n<span class="capitalize">{{vm.imagesSizeInfo.previous}}</span></md-button></md-menu-item><md-menu-item \nng-if="vm.supportImagesView === true || vm.supportImagesView === \'true\'"><md-button \naria-label="{{vm.model.currentViewType !== 1 ? \'Images View\' : \'List View\'}}" \ntranslate-aria-label="{{vm.model.currentViewType !== 1 ? \'ACTIONS.IMAGES_VIEW\' : \'ACTIONS.LIST_VIEW\'}}" \nng-click="vm.doSwitchView()"><md-icon class="s18" ng-if="vm.model.currentViewType === 1" \nmd-font-icon="icon-format-list-bulleted"></md-icon><md-icon class="s18" ng-if="vm.model.currentViewType !== 1" \nmd-font-icon="icon-apps"></md-icon><span>\n{{vm.model.currentViewType !== 1 ? \'ACTIONS.IMAGES_VIEW\' : \'ACTIONS.LIST_VIEW\' | translate}}</span></md-button>\n</md-menu-item><md-menu-item ng-if="vm.supportChartsView"><md-button aria-label="Show Charts" \ntranslate-aria-label="{{vm.model.currentViewType !== 2 ? \'ACTIONS.CHARTS_VIEW\': \'ACTIONS.LIST_VIEW\'}}" \nng-click="vm.doShowCharts()"><md-icon class="s18" ng-if="vm.model.currentViewType === 2" \nmd-font-icon="icon-format-list-bulleted"></md-icon><md-icon class="s18" ng-if="vm.model.currentViewType !== 2" \nmd-font-icon="icon-chart-pie"></md-icon><span>\n{{vm.model.currentViewType !== 2 ? \'ACTIONS.CHARTS_VIEW\': \'ACTIONS.LIST_VIEW\' | translate}}</span></md-button>\n</md-menu-item><md-menu-item ng-if="vm.supportFilterByDate && !vm.hideWhenChartView"><md-button \naria-label="Filter by Date" translate-attr-aria-label="ACTIONS.FILTER_BY_DATE" ng-click="vm.openFilterByDateDialog()">\n<md-icon class="s18" md-font-icon="icon-calendar-clock"></md-icon><span ng-if="!vm.view.filterByDate.startDate" \ntranslate="ACTIONS.FILTER_BY_DATE">Filter by Date</span> <span ng-if="vm.view.filterByDate.startDate">\n{{\'FIELDS.START_DATE\' | translate}}: {{vm.view.filterByDate.startDate | date}} - </span><span \nng-if="vm.view.filterByDate.startDate">{{\'FIELDS.END_DATE\' | translate}}: {{vm.view.filterByDate.endDate | date}}\n</span></md-button></md-menu-item><md-menu-item \nng-show="vm.currentCollectionView === 1 || vm.currentCollectionView === 2 || vm.currentCollectionView === 3"><md-button\n aria-label="Tree View" translate-aria-label="ACTIONS.TREE_VIEW" ng-click="vm.doSwitchCollectionsView(0)"><md-icon \nclass="s18" md-font-icon="icon-sitemap"></md-icon><span>{{\'ACTIONS.TREE_VIEW\' | translate}}</span></md-button>\n</md-menu-item><md-menu-item ng-show="vm.currentCollectionView === 0 || vm.currentCollectionView === 2"><md-button \naria-label="List View\'" translate-aria-label="ACTIONS.ARTICLES_LIST" ng-click="vm.doSwitchCollectionsView(1)"><md-icon \nclass="s18" md-font-icon="icon-format-list-bulleted"></md-icon><span>{{\'ACTIONS.ARTICLES_LIST\' | translate}}</span>\n</md-button></md-menu-item><md-menu-item ng-show="vm.currentCollectionView === 0 || vm.currentCollectionView === 1">\n<md-button aria-label="Customers List View" translate-aria-label="ACTIONS.CUSTOMER_LIST" \nng-click="vm.doSwitchCollectionsView(2)"><md-icon class="s18" md-font-icon="icon-format-list-bulleted"></md-icon><span \ntranslate="ACTIONS.CUSTOMER_LIST">Customers List View</span></md-button></md-menu-item><md-menu-item \nng-hide="vm.hideWhenChartView"><md-button aria-label="Filter" translate-attr-aria-label="ACTIONS.FILTER" \nng-click="vm.switchToggleFilter()"><md-icon class="s18" md-font-icon="icon-filter"></md-icon><span \ntranslate="ACTIONS.FILTER">Filter</span></md-button></md-menu-item><md-menu-item ng-hide="vm.hideWhenChartView">\n<md-button aria-label="Choose Columns" translate-attr-aria-label="ACTIONS.COLUMN_CHOOSER" \nng-click="vm.doShowColumnChooser(event)"><md-icon class="s18" md-font-icon="icon-table-edit"></md-icon><span \ntranslate="ACTIONS.COLUMN_CHOOSER">Column Chooser</span></md-button></md-menu-item><md-menu-item \nng-hide="vm.hideWhenChartView || vm.hideRefreshAndSaveButton"><md-button aria-label="Save Column" \ntranslate-attr-aria-label="ACTIONS.SAVE_COLUMN" ng-click="vm.doSaveColumn()"><md-icon class="s18" \nmd-font-icon="icon-content-save"></md-icon><span translate="ACTIONS.SAVE_COLUMN">Save Column</span></md-button>\n</md-menu-item><md-menu-item ng-if="vm.isToggleFilterDefined && !vm.hideWhenChartView"><md-switch \nclass="toolbar-md-switch" ng-model="vm.view.toggleFilterProps.toggleStatus" aria-label="Toggle Filter" \nng-change="vm.updateColumnFilterBasedOnToggleVal()" ng-disabled="vm.dataLength === 0"></md-switch><span>\n{{vm.view.toggleFilterProps.toggleStatus=== true ? vm.view.toggleFilterProps.trueValTooltipMessage : vm.view.toggleFilterProps.falseValTooltipMessage | translate}}\n</span></md-menu-item></md-menu-content></md-menu></div><md-button ng-hide="vm.hideRefreshAndSaveButton" \nclass="md-icon-button" aria-label="Refresh" translate-attr-aria-label="ACTIONS.REFRESH" \nng-click="vm.doRefreshAction()"><md-icon md-font-icon="icon-refresh"></md-icon><md-tooltip><span \ntranslate="ACTIONS.REFRESH">Refresh</span></md-tooltip></md-button></div></div><div class="articles-content"><div \nclass="list-content"><div layout="row" layout-align="start center" class="list-header" layout-padding flex \nng-hide="vm.hideWhenChartView"><div flex="none" class="selection-col" layout-align="start center" \nng-if="vm.enableSelection"><md-icon md-font-icon="icon-filter" ng-show="vm.filter"></md-icon></div><div \nid="resizable-cols-container" layout="row" layout-align="start center" layout-padding flex dragula=\'"bag-one"\' \ndragula-model="vm.colsList"><div ng-repeat="col in vm.colsList track by $index" layout="row" \nlayout-align="start center" class="sortable-column text-nowrap column-width-for-devices" flex="none" \nstyle="width:{{vm.colsWidth[col.field]}}px" ng-click="vm.doSort($event, col)" \ntx-long-touch="vm.onHeaderLongTouch($event, col)" tx-short-touch="vm.onHeaderShortTouch($event, col)" tx-col-resizer \ntx-container-width="vm.resizableColsContainerWidth" tx-cols-width="vm.colsWidth" tx-cols="vm.colsList" \ntx-col-index="{{$index}}" tx-direction="[\'right\']" tx-persist-cols-width="vm.persistColsWidth()"><md-tooltip>\n{{col.displayLabel | translate | ampersand }}</md-tooltip><div class="text-truncate">\n{{ col.displayLabel | translate | ampersand }}</div><div ng-click="vm.onSortIconClick($event, col)"><md-icon \nclass="material-icons list-header-icon" md-font-icon="icon-chevron-down" \nng-show="vm.view.sortColumn[col.field] === false"></md-icon><md-icon class="material-icons list-header-icon" \nmd-font-icon="icon-chevron-up" ng-show="vm.view.sortColumn[col.field] === true"></md-icon><md-icon \nclass="material-icons list-header-icon" md-font-icon="icon-unfold-more" \nng-show="vm.view.sortColumn[col.field] !== false && vm.view.sortColumn[col.field] !== true"></md-icon></div></div>\n</div><div flex="none" class="actions" \nng-if="vm.view.itemActions && vm.view.itemActions.length && vm.anyItemActionAllowed">Actions</div></div><div \nlayout="row" class="filter-row" layout-align="start center" layout-padding ng-show="vm.view.showFilterRow" flex><div \nflex="none" layout-align="start center" class="selection-col filter-selection-col"><md-button class="md-icon-button" \nng-click="vm.doSaveFilter()" aria-label="Save Filters" translate translate-attr-aria-label="ACTIONS.FILTER_SAVE">\n<md-icon md-font-icon="icon-content-save"></md-icon></md-button></div><div class="filter-resizable-cols-container" \nlayout="row" layout-align="start center" layout-padding flex><div ng-repeat="col in vm.colsList track by $index" \nflex="none" style="width:{{vm.colsWidth[col.field]}}px" class="column-width-for-devices"><tx-filter-input \ntx-input-id="filter_{{$first?\'first\':$index}}" tx-column-filter="vm.view.columnFilter" tx-columns="col" \ntx-column-width="vm.colsWidth[col.field]" tx-on-filter-change="vm.onFilterChange($event)" tx-data="vm.data" \ntx-filter-row-visible="vm.view.showFilterRow" tx-lookup-data="vm.lookupData"></tx-filter-input></div></div><div \nflex="none" class="actions"><md-button class="md-icon-button" ng-click="vm.switchToggleFilter(false)" \naria-label="Close Filters" translate translate-attr-aria-label="ACTIONS.FILTER_CLOSE"><md-icon \nmd-font-icon="icon-close"></md-icon></md-button></div></div><div \nng-show="vm.model.currentViewType === 0 || vm.currentCollectionView === 1 || vm.currentCollectionView === 2" \nng-include="\'app/directives/txDataTable/list-views/table-view.html\'"></div><div ng-if="vm.model.currentViewType === 1" \nng-include="\'app/directives/txDataTable/list-views/images-view.html\'"></div><div \nng-if="vm.model.currentViewType === 2" ng-include="\'app/directives/txDataTable/list-views/charts-view.html\'"></div>\n</div><div ng-if="vm.isLoadingNextPage" layout="row" layout-align="center center" class="pagination-loading">\n<md-progress-circular md-mode="indeterminate" md-diameter="32" class="md-accent"></md-progress-circular></div></div>\n</div>');
$templateCache.put('app/directives/txDataTree/include-tree.html','<div layout="row" layout-align="start center" layout-padding flex class="tree-item" \nng-class="{\'disabled\' : !node.ancestorDisabledStatus || !node.Status,\r\n\'clickable\': vm.clickable && !(vm.preventFolderClick && vm.preventFolderClick == \'true\' && node.type && node.type == \'folder\'),\r\n\'selected\': node.selected}" \nng-click="vm.doItemClick(node)"><md-icon data-nodrag class="chevron" \nng-class="{ \'icon-chevron-right\' : collapsed , \'icon-chevron-down\'  : !collapsed }" ng-click="vm.toggle($event, this)" \nng-show="node.nodes"></md-icon><md-icon id="icon" ui-tree-handle class="s16 m-0 p-0" \nmd-font-icon="{{vm.branchTypes[node.type].icon}}" \nng-class="{\'cursor-pointer\': !vm.canUserModifyTreeForActiveCatalog && !node.nodes,\r\n                    \'cursor-auto\': !vm.canUserModifyTreeForActiveCatalog && node.nodes}">\n</md-icon><div flex="grow" class="text-truncate tree-item-title"><span md-highlight-text="vm.filter" \nmd-highlight-flags="i">{{::node.title}}</span></div><div class="actions" flex="none" \nng-click="$event.stopPropagation()" ng-if="vm.branchTypes[node.type].actions.length > 0 && node.type === \'folder\'">\n<md-menu><md-button class="md-icon-button" aria-label="Action"><md-icon data-nodrag md-font-icon="icon-dots-vertical" \nng-click="$mdOpenMenu($event)"></md-icon></md-button><md-menu-content width="3"><md-menu-item \ntx-access="{{::vm.branchTypes[node.type].actions[0].privilege}}" \nng-show="{{vm.branchTypes[node.type].actions[0].visible}}"><md-button \nng-click="vm.doItemAction(vm.branchTypes[node.type].actions[0], node)" \naria-label="{{vm.branchTypes[node.type].actions[0].label}}" \ntranslate-attr-aria-label="{{vm.branchTypes[node.type].actions[0].label}}" \nng-disabled="{{vm.branchTypes[node.type].actions[0].disabled}}"><md-icon \nmd-font-icon="{{vm.branchTypes[node.type].actions[0].icon}}" class="s18"></md-icon><span \ntranslate="{{vm.branchTypes[node.type].actions[0].label}}">{{::act.label}}</span></md-button></md-menu-item>\n<md-menu-item tx-access="{{::vm.branchTypes[node.type].actions[1].privilege}}" \nng-show="{{vm.branchTypes[node.type].actions[1].visible}}"><md-button \nng-click="vm.doItemAction(vm.branchTypes[node.type].actions[1], node)" \naria-label="{{vm.branchTypes[node.type].actions[1].label}}" \ntranslate-attr-aria-label="{{vm.branchTypes[node.type].actions[1].label}}" \nng-disabled="{{vm.branchTypes[node.type].actions[1].disabled}}"><md-icon \nmd-font-icon="{{vm.branchTypes[node.type].actions[1].icon}}" class="s18"></md-icon><span \ntranslate="{{vm.branchTypes[node.type].actions[1].label}}">{{::act.label}}</span></md-button></md-menu-item>\n<md-menu-item tx-access="{{::vm.branchTypes[node.type].actions[2].privilege}}" \nng-show="{{vm.branchTypes[node.type].actions[2].visible}}"><md-button \nng-click="vm.doItemAction(vm.branchTypes[node.type].actions[2], node)" \naria-label="{{vm.branchTypes[node.type].actions[2].label}}" \ntranslate-attr-aria-label="{{vm.branchTypes[node.type].actions[2].label}}" \nng-disabled="{{vm.branchTypes[node.type].actions[2].disabled}}"><md-icon \nmd-font-icon="{{vm.branchTypes[node.type].actions[2].icon}}" class="s18"></md-icon><span \ntranslate="{{vm.branchTypes[node.type].actions[2].label}}">{{::act.label}}</span></md-button></md-menu-item>\n<md-menu-item tx-access="{{::vm.branchTypes[node.type].actions[3].privilege}}" \nng-show="{{vm.branchTypes[node.type].actions[3].visible}}"><md-button \nng-click="vm.doItemAction(vm.branchTypes[node.type].actions[3], node)" \naria-label="{{vm.branchTypes[node.type].actions[3].label}}" \ntranslate-attr-aria-label="{{vm.branchTypes[node.type].actions[3].label}}" \nng-disabled="{{vm.branchTypes[node.type].actions[3].disabled}}"><md-icon \nmd-font-icon="{{vm.branchTypes[node.type].actions[3].icon}}" class="s18"></md-icon><span \ntranslate="{{vm.branchTypes[node.type].actions[3].label}}">{{::act.label}}</span></md-button></md-menu-item>\n<md-menu-item tx-access="{{::vm.branchTypes[node.type].actions[4].privilege}}" \nng-show="{{vm.branchTypes[node.type].actions[4].visible}}"><md-button \nng-click="vm.doItemAction(vm.branchTypes[node.type].actions[4], node)" \naria-label="{{vm.branchTypes[node.type].actions[4].label}}" \ntranslate-attr-aria-label="{{vm.branchTypes[node.type].actions[4].label}}" \nng-disabled="{{vm.branchTypes[node.type].actions[4].disabled}}"><md-icon \nmd-font-icon="{{vm.branchTypes[node.type].actions[4].icon}}" class="s18"></md-icon><span \ntranslate="{{vm.branchTypes[node.type].actions[4].label}}">{{::act.label}}</span></md-button></md-menu-item>\n</md-menu-content></md-menu></div></div><ol ui-tree-nodes ng-model="node.nodes" ng-show="!collapsed"><li \nng-repeat="node in node.nodes track by $index" ui-tree-node ng-hide="node._hide"><tx-include-tree></tx-include-tree>\n</li></ol>');
$templateCache.put('app/directives/txDataTree/tx-data-tree.html','<div><div class="tx-data-tree"><div id="tree-toolbar" class="tree-toolbar" layout="row" \nlayout-align="space-between center"><div layout="row" layout-align="start center"><md-button \nclass="md-icon-button toggle-expand" aria-label="Expand All" ng-hide="vm.expanded" \ntranslate-attr-aria-label="TREE.EXPAND_ALL" ng-click="vm.toggleExpand()"><md-icon md-font-icon="icon-arrow-expand">\n</md-icon><md-tooltip><span translate="TREE.EXPAND_ALL">Expand all</span></md-tooltip></md-button><md-button \nclass="md-icon-button toggle-expand" aria-label="Collapse All" ng-show="vm.expanded" \ntranslate-attr-aria-label="TREE.COLLAPSE_ALL" ng-click="vm.toggleExpand()"><md-icon md-font-icon="icon-arrow-collapse">\n</md-icon><md-tooltip><span translate="TREE.COLLAPSE_ALL">Collpase all</span></md-tooltip></md-button><div \nclass="divider-vertical" hide show-gt-xs></div><md-button ng-repeat="listAct in vm.listActions" class="md-icon-button" \naria-label="{{listAct.label}}" translate-attr-aria-label="{{listAct.label}}" ng-click="vm.doListAction(listAct)" \nng-disabled="listAct.disabled" ng-show="{{listAct.visible}}" tx-access="{{::listAct.privilege}}"><md-icon \nmd-font-icon="{{listAct.icon}}"></md-icon><md-tooltip><span translate>{{listAct.label}}</span></md-tooltip></md-button>\n<md-select ng-model="vm.activeCatalogTree" ng-if="vm.showTreeListDropdown" \nng-disabled="vm.catalogTreeList.length === 0" placeholder="Catalog Tree List" class="md-no-underline m-0" \nng-change="vm.onActiveTreeChange(vm.activeCatalogTree)"><md-option ng-value="tree" \nng-repeat="tree in vm.catalogTreeList">{{tree.Name}}</md-option></md-select><span \nclass="ml-16 text-boxed md-accent-bg highlight" hide show-gt-xs ng-hide="vm.viewOptions.hideBranchesInfo">\n{{vm.totalBranches.all}} {{\'TREE.BRANCHES\' | translate}}</span> <span class="ml-16 text-boxed md-accent-bg highlight" \nhide show-gt-xs ng-repeat="item in vm.branchTypesList" ng-hide="vm.viewOptions.hideCatalogTreeInfo">\n{{vm.totalBranches[item]}} {{vm.branchTypes[item].title | translate}}</span> <span class="alert md-warn-bg text-boxed" \nflex ng-if="vm.model.isBulkActionCompleted === true" ng-click="vm.doRefreshAction()" translate="ALERT.BULK_COMPLETED">\nRecords have been modified, please refresh.</span></div><div layout="row" layout-align="end center"><div \nclass="actions" flex="none"><md-menu><md-button class="md-icon-button" ng-click="$mdOpenMenu($event)" \naria-label="Action"><md-icon md-font-icon="icon-dots-vertical"></md-icon></md-button><md-menu-content width="3">\n<md-menu-item ng-if="vm.treeViewOptions.customersListView"><md-button aria-label="List View\'" \ntranslate-aria-label="ACTIONS.ARTICLES_LIST" ng-click="vm.doSwitchView(1)"><md-icon class="s18" \nmd-font-icon="icon-format-list-bulleted"></md-icon><span>{{\'ACTIONS.ARTICLES_LIST\' | translate}}</span></md-button>\n</md-menu-item><md-menu-item ng-if="vm.treeViewOptions.articleListVIew"><md-button aria-label="Customers List View" \ntranslate-aria-label="ACTIONS.CUSTOMER_LIST" ng-click="vm.doSwitchView(2)"><md-icon class="s18" \nmd-font-icon="icon-format-list-bulleted"></md-icon><span translate="ACTIONS.CUSTOMER_LIST">Customers List View</span>\n</md-button></md-menu-item><md-menu-item><md-button aria-label="Filter" translate-attr-aria-label="ACTIONS.FILTER" \nng-click="vm.showFilterRow = !vm.showFilterRow"><md-icon class="s18" md-font-icon="icon-filter"></md-icon><span \ntranslate="ACTIONS.FILTER">Filter</span></md-button></md-menu-item></md-menu-content></md-menu></div><md-button \nclass="md-icon-button" aria-label="Refresh" translate-attr-aria-label="ACTIONS.REFRESH" \nng-click="vm.doRefreshAction()"><md-icon md-font-icon="icon-refresh"></md-icon><md-tooltip><span \ntranslate="ACTIONS.REFRESH">Refresh</span></md-tooltip></md-button></div></div><div class="tree-content"><div \nlayout="row" layout-align="start center" class="tree-header" layout-padding flex><div layout="row" \nlayout-align="start center" flex><div flex="grow" class="text-truncate">{{\'TREE.BRANCH_TITLE\' | translate}}</div></div>\n<div flex="none" class="actions" translate="ACTIONS.ACTIONS">Actions</div></div><div layout="row" class="filter-row" \nlayout-align="start center" layout-padding ng-show="vm.showFilterRow" flex><div layout="row" \nlayout-align="start center" layout-padding flex><div flex="grow"><md-input-container style="width:100%"><label \ntranslate="ACTIONS.FILTER">Filter</label><input ng-model="vm.filter" type="text"></md-input-container></div></div><div \nflex="none" class="actions"><md-button class="md-icon-button" ng-click="vm.showFilterRow=false;vm.filter=\'\';" \naria-label="Close Filters" translate translate-attr-aria-label="ACTIONS.FILTER_CLOSE"><md-icon \nmd-font-icon="icon-close"></md-icon></md-button></div></div><div layout="row" layout-align="center center" \nng-show="vm.isLoading"><md-progress-circular md-mode="indeterminate" class="md-accent"></md-progress-circular></div>\n<div layout="row" layout-align="center center" layout-padding ng-show="!vm.data.length && !vm.isLoading"><div \nclass="text-italic" translate="MESSAGES.LIST.NO_ITEMS">No items available...</div></div><md-content class="tree-items" \nng-style="vm.treeStyle" ms-scroll><div ui-tree="vm.treeEventHandler" \ndata-drag-enabled="vm.canUserModifyTreeForActiveCatalog" id="tree-root" ng-if="!vm.isLoading" \ndata-empty-placeholder-enabled="false"><ol ui-tree-nodes="" ng-model="vm.data"><li \nng-repeat="node in vm.data track by $index" ui-tree-node ng-hide="node._hide"><tx-include-tree></tx-include-tree></li>\n</ol></div></md-content></div></div></div>');
$templateCache.put('app/directives/txDynamicValues/tx-dynamic-values.html','<div ng-switch="vm.inputType"><div ng-switch-when="date"><i class="icon s16 icon-calendar-clock"></i><md-tooltip>\n{{vm.value || \'Never\' | date:\'MMM d, y h:mm a\' }}</md-tooltip><span>{{vm.value || \'Never\' | date}}</span></div><div \nng-switch-when="date-without-time"><i class="icon s16 icon-calendar-clock"></i><md-tooltip>\n{{vm.value || \'Never\' | date:\'MMM d, y\' }}</md-tooltip><span>{{vm.value || \'Never\' | date}}</span></div><div \nng-switch-when="date-utc"><i class="icon s16 icon-calendar-clock"></i><md-tooltip>\n{{vm.value || \'Never\' | date:\'MMM d, y h:mm a\':\'UTC\'}}</md-tooltip><span>{{vm.value || \'Never\' | date:\'UTC\'}}</span>\n</div><div ng-switch-when="date-option"><i class="icon s16 icon-calendar-clock"></i><md-tooltip>\n{{vm.value || \'Never\' | date:\'MMM d, y h:mm a\' }}</md-tooltip><span>{{vm.value || \'Never\' | date}}</span></div><div \nng-switch-when="number"><span>{{vm.value | txNumber}}</span></div><div ng-switch-when="bool-str" layout="row"><div \nng-if="vm.value === \'true\'" class="tag" layout="row" layout-align="start center"><div class="tag-color tag-green">\n</div><div class="tag-label" translate>PARTS.TRUE</div></div><div ng-if="vm.value === \'false\'" class="tag" \nlayout="row" layout-align="start center"><div class="tag-color tag-red"></div><div class="tag-label" translate>\nPARTS.FALSE</div></div></div><div ng-switch-when="list">{{vm.value}}</div><div ng-switch-when="multi-value">\n{{vm.value | arrayTagsRenderer:\'|\'}}</div><div ng-switch-when="decimal"><span>{{vm.value}}</span></div><div \nng-switch-when="tags">{{vm.value | arrayTagsRenderer:\'|\'}}</div><div ng-switch-when="color-palette">{{vm.value}}</div>\n<div ng-switch-when="lookup-table"><span>{{vm.value}}</span></div><div ng-switch-default>{{vm.value}}</div></div>');
$templateCache.put('app/directives/txFieldViewer/tx-field-viewer.html','<div class="tx-field-viewer" flex><div \nng-if="vm.field.inputType !== \'datatable\' || (vm.field.inputType === \'datatable\' && !vm.showDatatableAsGrid)" \nclass="title" translate ng-if="!vm.hideTitle">{{vm.field.displayLabel}}</div><div \nng-class="vm.field.inputType !== \'datatable\' ? \'info\' : \'datatable-grid-wrapper\'" ng-switch="vm.field.inputType" \nlayout="row"><div ng-switch-when="lookup">{{vm.data[vm.field.field] | recordRenderer:vm.lookupData:vm.field}}</div><div\n ng-switch-when="lookup-from-map">{{ vm.scope.$eval(vm.field.lookupSource)[vm.data[vm.field.field]] }}</div><div \nng-switch-when="lookup-many"><md-chips ng-model="vm.data[vm.field.field]" readonly="true"><md-chip-template>\n{{$chip | recordRenderer:vm.lookupData:vm.field}}</md-chip-template></md-chips></div><div ng-switch-when="date"><i \nclass="icon s16 icon-calendar-clock"></i><md-tooltip>{{vm.data[vm.field.field] || \'Never\' | date:\'MMM d, y h:mm a\' }}\n</md-tooltip><span>{{vm.data[vm.field.field] || \'Never\' | date:vm.field.displayFormat}}</span></div><div \nng-switch-when="date-without-time"><i class="icon s16 icon-calendar-clock"></i><md-tooltip>\n{{vm.data[vm.field.field] || \'Never\' | date:\'MMM d, y\' }}</md-tooltip><span>\n{{vm.data[vm.field.field] || \'Never\' | date:vm.field.displayFormat}}</span></div><div ng-switch-when="date-option"><i \nclass="icon s16 icon-calendar-clock"></i><md-tooltip>{{vm.data[vm.field.field] || \'Never\' | date:\'MMM d, y h:mm a\' }}\n</md-tooltip><span>{{vm.data[vm.field.field] || \'Never\' | date:vm.field.displayFormat}}</span></div><div \nng-switch-when="date-utc"><i class="icon s16 icon-calendar-clock"></i><md-tooltip>\n{{vm.data[vm.field.field] || \'Never\' | date:\'MMM d, y h:mm a\':\'UTC\' }}</md-tooltip><span>\n{{vm.data[vm.field.field] || \'Never\' | date:vm.field.displayFormat:\'UTC\'}}</span></div><div \nng-switch-when="target-attributes-json-str"><md-tooltip>\n{{vm.data[vm.field.field] | targetAndAggregateAttributesRenderer}}</md-tooltip><span>\n{{vm.data[vm.field.field] | targetAndAggregateAttributesRenderer}}</span></div><div \nng-switch-when="dynamic-attribute-value"><tx-dynamic-values tx-value="vm.data[vm.field.field]" tx-item="vm.data" \ntx-field="vm.field.field"></tx-dynamic-values></div><div ng-switch-when="icon" class="iconImage"><img \nng-src="{{vm.data[vm.field.field]}}"></div><div ng-switch-when="array"><md-tooltip>\n{{vm.data[col.field] | catalogsRenderer}}</md-tooltip><span>{{vm.data[col.field] | catalogsRenderer}}</span></div><div \nng-switch-when="number"><span>{{vm.data[vm.field.field] | txNumber:vm.field}}</span></div><div ng-switch-when="email">\n<span><a href="mailto:{{vm.data[vm.field.field]}}">{{vm.data[vm.field.field]}}</a></span></div><div \nng-switch-when="url"><span><a href="{{vm.data[vm.field.field]}}" target="_blank">{{vm.data[vm.field.field]}}</a></span>\n</div><div ng-switch-when="calculated"><span>{{vm.data[vm.field.field]}}</span></div><div \nng-switch-when="calculated-url"><span><a href="{{vm.scope.$eval(vm.field.calculatedExpression, { data: vm.data }) }}" \ntarget="_blank">{{vm.scope.$eval(vm.field.calculatedExpression, { data: vm.data }) }}</a></span></div><div \nng-switch-when="bool" layout="row"><div ng-if="vm.data[vm.field.field] === 1 || vm.data[vm.field.field] === true" \nclass="tag" layout="row" layout-align="start center"><div class="tag-color tag-green"></div><div class="tag-label" \ntranslate>PARTS.TRUE</div></div><div ng-if="vm.data[vm.field.field] === 0 || vm.data[vm.field.field] === false" \nclass="tag" layout="row" layout-align="start center"><div class="tag-color tag-red"></div><div class="tag-label" \ntranslate>PARTS.FALSE</div></div></div><div ng-switch-when="bool-str" layout="row"><div \nng-if="vm.data[vm.field.field] === \'true\'" class="tag" layout="row" layout-align="start center"><div \nclass="tag-color tag-green"></div><div class="tag-label" translate>PARTS.TRUE</div></div><div \nng-if="vm.data[vm.field.field] === \'false\'" class="tag" layout="row" layout-align="start center"><div \nclass="tag-color tag-red"></div><div class="tag-label" translate>PARTS.FALSE</div></div></div><div \nng-switch-when="bool-int" layout="row"><div ng-if="vm.data[vm.field.field] == 1" class="tag" layout="row" \nlayout-align="start center"><div class="tag-color tag-green"></div><div class="tag-label" translate>PARTS.TRUE</div>\n</div><div ng-if="vm.data[vm.field.field] == 0" class="tag" layout="row" layout-align="start center"><div \nclass="tag-color tag-red"></div><div class="tag-label" translate>PARTS.FALSE</div></div></div><div \nng-switch-when="int-bool" layout="row"><div ng-if="vm.data[vm.field.field] == 1" class="tag" layout="row" \nlayout-align="start center"><div class="tag-color tag-green"></div><div class="tag-label" translate>PARTS.TRUE</div>\n</div><div ng-if="vm.data[vm.field.field] == 0" class="tag" layout="row" layout-align="start center"><div \nclass="tag-color tag-red"></div><div class="tag-label" translate>PARTS.FALSE</div></div></div><div \nng-switch-when="status" layout="row"><div ng-if="vm.data[vm.field.field] === 1" class="tag" layout="row" \nlayout-align="start center"><div class="tag-color tag-green"></div><div class="tag-label" translate>STATUS.ACTIVE</div>\n</div><div ng-if="vm.data[vm.field.field] === 0" class="tag" layout="row" layout-align="start center"><div \nclass="tag-color tag-red"></div><div class="tag-label" translate>STATUS.INACTIVE</div></div></div><div \nng-switch-when="article-status" layout="row"><div ng-switch="vm.getArticleStatusValue(vm.data, vm.field)" layout="row">\n<div ng-switch-when="1" layout="row" class="tag tx-active-inactive" layout-align="start center"><div \nclass="tag-color tag-green"></div><div class="tag-label" translate>STATUS.ACTIVE</div></div><div ng-switch-when="0" \nlayout="row" class="tag tx-active-inactive" layout-align="start center"><div class="tag-color tag-red"></div><div \nclass="tag-label" translate>STATUS.INACTIVE</div></div><div ng-switch-when="2" layout="row" \nclass="tag tx-active-inactive" layout-align="start center"><div class="tag-color tag-red"></div><div class="tag-label" \ntranslate>STATUS.GLOBALLY_DROPPED</div></div><div ng-switch-when="3" layout="row" class="tag tx-active-inactive" \nlayout-align="start center"><div class="tag-color tag-blue"></div><div class="tag-label" translate>STATUS.NOT_ASSORTED\n</div></div></div></div><div ng-switch-when="color" layout="row"><div class="color-palette"><span class="color-tag" \nng-style="{\'background-color\': vm.data[vm.field.field]}"></span></div></div><div ng-switch-when="color-picker" \nlayout="row"><div class="color-picker-viewer" layout="row"><span class="color-picker-value">{{vm.data[vm.field.field]}}\n</span> <span class="color-box" ng-style="{\'background-color\': vm.data[vm.field.field]}"></span></div></div><div \nng-switch-when="orderlineStatus" layout="row"><div \nng-if="vm.data[vm.field.field] === 0 && vm.data[vm.statusField] === 1" layout="row" layout-align="start center"><div \ntranslate>STATUS.ACTIVE</div></div><div ng-if="!(vm.data[vm.field.field] === 0 && vm.data[vm.statusField] === 1)" \nlayout="column" layout-align="start start"><div>{{vm.data.invalidOrderlineReason.join(\', \')}}</div></div></div><div \nng-switch-when="forecastLineStatus" layout="row"><div \nng-if="vm.data[vm.field.field] === 0 && vm.data[vm.statusField] === 1" layout="row" layout-align="start center"><div \ntranslate>STATUS.ACTIVE</div></div><div ng-if="!(vm.data[vm.field.field] === 0 && vm.data[vm.statusField] === 1)" \nlayout="column" layout-align="start start"><div>{{vm.data.invalidForecastLineReason.join(\', \')}}</div></div></div><div \nng-switch-when="notificationStatus" layout="row"><div \nng-if="vm.data[vm.field.field] === 0 || vm.data[vm.field.field] === \'0\'" class="tag" layout="row" \nlayout-align="start center"><div class="tag-color tag-amber"></div><div class="tag-label" translate>\nNOTIFICATION_TYPE.PENDING</div></div><div ng-if="vm.data[vm.field.field] === 10 || ivm.data[vm.field.field] === \'10\'" \nclass="tag" layout="row" layout-align="start center"><div class="tag-color tag-green"></div><div class="tag-label" \ntranslate>NOTIFICATION_TYPE.SENT_SUCCESSFULLY</div></div></div><div ng-switch-when="list"><span \nng-if="vm.data[vm.field.field]">{{vm.data[vm.field.field]}}</span> <span ng-if="!vm.data[vm.field.field]" \nclass="blank-field">(blank)</span></div><div ng-switch-when="multi-value">\n{{vm.data[vm.field.field] | arrayTagsRenderer:vm.field.tagSeparator}}</div><div ng-switch-when="decimal"><span>\n{{vm.data[vm.field.field]}}</span></div><div ng-switch-when="articlenumber">\n{{vm.data[vm.field.field] | recordRenderer:vm.lookupData:vm.field}}</div><div \nng-switch-when="linkedcatalogarticlenumber">{{vm.data[vm.field.field] | recordRenderer:vm.lookupData:vm.field}}</div>\n<div ng-switch-when="array-tags">{{vm.data[vm.field.field] | arrayTagsRenderer:vm.field.tagSeparator}}</div><div \nng-switch-when="tags">{{vm.data[vm.field.field] | arrayTagsRenderer:vm.field.tagSeparator}}</div><div \nng-switch-when="color-palette"><span ng-if="vm.data[vm.field.field]">\n{{vm.data[vm.field.field] | colorPaletteRenderer:vm.field}}</span> <span ng-if="!vm.data[vm.field.field]" \nclass="blank-field">(blank)</span></div><div ng-switch-when="dataset"><span ng-if="vm.data[vm.field.field]">\n{{vm.data[vm.field.field] | colorPaletteRenderer:vm.field}}</span> <span ng-if="!vm.data[vm.field.field]" \nclass="blank-field">(blank)</span></div><div ng-switch-when="datatable" flex><span ng-if="!vm.showDatatableAsGrid">\n{{ vm.data[vm.field.field] | datatableCellRenderer }}</span><tx-ui-grid \nng-if="vm.showDatatableAsGrid && vm.showDatatableAsGrid === \'true\'" tx-field="vm.field" tx-data="vm.data" \ntx-new="false" tx-editable="false"></tx-ui-grid></div><div ng-switch-when="modelnumber">\n{{vm.data[vm.field.field] | recordRenderer:vm.lookupData:vm.field}}</div><div ng-switch-when="size-curve-size">\n{{vm.data[vm.field.field] | sizeCurveSizesRenderer}}</div><div ng-switch-when="lookup-table"><span>\n{{vm.data[vm.field.field]}}</span></div><div ng-switch-default><span ng-if="vm.data[vm.field.field]">\n{{vm.data[vm.field.field]}}</span> <span ng-if="!vm.data[vm.field.field]" class="blank-field">(blank)</span></div>\n</div></div>');
$templateCache.put('app/directives/txFilterInput/tx-filter-input.html','<div ng-switch="vm.col.inputType" class="tx-filter-input"><div ng-switch-when="date" layout="row" flex><md-icon \nmd-font-icon="icon-calendar" class="date-range-icon" ng-click="vm.showDateRangeFilterPanel($event)"></md-icon>\n<md-input-container flex><input type="search" value="{{vm.columnFilter[vm.col.field] ? vm.dateRange: \'\'}}" \nng-click="vm.showDateRangeFilterPanel($event)" placeholder="{{vm.col.field}}" class="tx-filter-input-element md-text" \nreadonly="readonly"><md-tooltip ng-if="vm.columnFilter[vm.col.field]">{{vm.dateRange}}</md-tooltip>\n</md-input-container></div><div ng-switch-when="date-utc" layout="row" flex><md-icon md-font-icon="icon-calendar" \nclass="date-range-icon" ng-click="vm.showDateRangeFilterPanel($event)"></md-icon><md-input-container flex><input \ntype="search" value="{{vm.columnFilter[vm.col.field] ? vm.dateRange: \'\'}}" \nng-click="vm.showDateRangeFilterPanel($event)" placeholder="{{vm.col.field}}" class="tx-filter-input-element md-text" \nreadonly="readonly"><md-tooltip ng-if="vm.columnFilter[vm.col.field]">{{vm.dateRange}}</md-tooltip>\n</md-input-container></div><div ng-switch-when="date-without-time" layout="row" flex><md-icon \nmd-font-icon="icon-calendar" class="date-range-icon" ng-click="vm.showDateRangeFilterPanel($event)"></md-icon>\n<md-input-container flex><input type="search" value="{{vm.columnFilter[vm.col.field] ? vm.dateRange: \'\'}}" \nng-click="vm.showDateRangeFilterPanel($event)" placeholder="{{vm.col.field}}" class="tx-filter-input-element md-text" \nreadonly="readonly"><md-tooltip ng-if="vm.columnFilter[vm.col.field]">{{vm.dateRange}}</md-tooltip>\n</md-input-container></div><div ng-switch-when="icon" layout="row" flex></div><div ng-switch-when="date-option" \nlayout="row" flex><div layout="row" layout-align="start center"><md-input-container flex><md-select \nng-model="vm.columnFilter[vm.col.field]" ng-change="vm.filterChange({which: 1})" \nmd-on-open="vm.loadUniqueValues(\'date\', vm.col.inputType)" md-on-close="vm.clearSearchText()" \nclass="mt-5 tx-filter-input-element" aria-label="Date List Filter" multiple="multiple"><md-select-header flex><input \nng-model="vm.searchText" type="search" ng-keydown="vm.onKeyDown($event)" placeholder="{{vm.col.field}}" \nclass="tx-filter-input-element md-text"></md-select-header><md-option ng-value="item" \nng-repeat="item in vm.uniqueValues | filter:vm.searchText">{{item}}</md-option></md-select></md-input-container></div>\n</div><div ng-switch-when="status"><md-select ng-model="vm.columnFilter[vm.col.field]" ng-change="vm.filterChange()" \nclass="mt-5 tx-filter-input-element" flex aria-label="Status Filter"><md-option ng-value="\'\'">\n{{\'STATUS.ACTIVE\' | translate}} {{\'PARTS.AND\' | translate}} {{\'STATUS.INACTIVE\' | translate}}</md-option><md-option \nng-value="\'1\'">{{\'STATUS.ACTIVE\' | translate}} {{\'PARTS.ONLY\' | translate}}</md-option><md-option ng-value="\'0\'">\n{{\'STATUS.INACTIVE\' | translate}} {{\'PARTS.ONLY\' | translate}}</md-option></md-select></div><div \nng-switch-when="article-status"><md-select ng-model="vm.columnFilter[vm.col.field]" ng-change="vm.filterChange()" \nclass="mt-5 tx-filter-input-element" flex aria-label="Status Filter"><md-option ng-value="\'\'" \nng-if="vm.dataSourceTypeId === 1">\n{{\'STATUS.ACTIVE\' | translate}} {{\'PARTS.AND\' | translate}} {{\'STATUS.INACTIVE\' | translate}}</md-option><md-option \nng-value="\'\'" ng-if="vm.dataSourceTypeId !== 1">{{\'STATUS.ALL\' | translate}}</md-option><md-option ng-value="\'1\'">\n{{\'STATUS.ACTIVE\' | translate}} {{\'PARTS.ONLY\' | translate}}</md-option><md-option ng-value="\'0\'" \nng-if="vm.dataSourceTypeId === 1">{{\'STATUS.INACTIVE\' | translate}} {{\'PARTS.ONLY\' | translate}}</md-option><md-option \nng-value="\'2\'" ng-if="vm.dataSourceTypeId !== 1">{{\'STATUS.GLOBALLY_DROPPED\' | translate}} {{\'PARTS.ONLY\' | translate}}\n</md-option><md-option ng-value="\'3\'" ng-if="vm.dataSourceTypeId !== 1">\n{{\'STATUS.NOT_ASSORTED\' | translate}} {{\'PARTS.ONLY\' | translate}}</md-option></md-select></div><div \nng-switch-when="color"><div layout="row" layout-align="start center"><md-input-container flex><md-select \nng-model="vm.columnFilter[vm.col.field]" ng-change="vm.filterChange({which: 1})" \nmd-on-open="vm.loadUniqueValues(0, vm.col.inputType)" md-on-close="vm.clearSearchText()" \nclass="mt-5 tx-filter-input-element" aria-label="Color List Filter" multiple="multiple"><md-select-header flex><input \nng-model="vm.searchText" type="search" ng-keydown="vm.onKeyDown($event)" placeholder="{{vm.col.field}}" \nclass="tx-filter-input-element md-text"></md-select-header><md-option ng-value="item" class="color-dropdown-options" \nng-repeat="item in vm.uniqueValues | filter:vm.searchText"><div class="color-palette"><span \nng-model="vm.columnFilter[vm.col.field]" class="color-tag" ng-style="{\'background-color\': item}"></span></div>\n</md-option></md-select></md-input-container></div></div><div ng-switch-when="color-picker"><div class="color-picker" \nlayout="row" layout-align="start center"><md-input-container flex><input id="{{vm.inputId}}" \nng-model="vm.columnFilter[vm.col.field]" type="text" aria-label="{{vm.col.field}}" class="tx-filter-input-element" \nng-keyup="vm.filterChange($event)"></md-input-container><input id="colorPicker_{{vm.inputId}}" class="picker" \nname="colorPicker" ng-model="vm.columnFilter[vm.col.field]" type="color" aria-label="{{vm.col.field}}" \nng-change="vm.onColorPickerUpdate($event)" \nng-disabled="{{field.validation.disabledCriteria || (field.showInEdit && !field.editable && !vm.isNew)}}"><md-button \nclass="md-icon-button" ng-click="vm.showAdvanceFilterDialog($event, vm.col)" aria-label="Advance Filters" translate \ntranslate-attr-aria-label="ACTIONS.FILTER_CLOSE"><md-tooltip>{{\'PARTS.ADVANCED_FILTER\' | translate}}</md-tooltip>\n<md-icon md-font-icon="icon-playlist-plus"></md-icon></md-button></div></div><div ng-switch-when="changedType">\n<md-select ng-model="vm.columnFilter[vm.col.field]" ng-change="vm.filterChange()" class="mt-5 tx-filter-input-element" \nflex aria-label="Status Filter"><md-option ng-value="\'\'">{{\'PARTS.NO_FILTER\' | translate}}</md-option><md-option \nng-value="\'new\'">{{\'CHANGE_TYPES.NEW\' | translate}} {{\'PARTS.ONLY\' | translate}}</md-option><md-option \nng-value="\'dropped\'">{{\'CHANGE_TYPES.DROPPED\' | translate}} {{\'PARTS.ONLY\' | translate}}</md-option><md-option \nng-value="\'reactivated\'">{{\'CHANGE_TYPES.REACTIVATED\' | translate}} {{\'PARTS.ONLY\' | translate}}</md-option><md-option \nng-value="\'reactivated with change\'">\n{{\'CHANGE_TYPES.REACTIVATED_WITH_ATTRIBUTE_CHANGE\' | translate}} {{\'PARTS.ONLY\' | translate}}</md-option><md-option \nng-value="\'changed\'">{{\'CHANGE_TYPES.ATTRIBUTE_CHANGE\' | translate}} {{\'PARTS.ONLY\' | translate}}</md-option>\n</md-select></div><div ng-switch-when="notificationStatus"><md-select ng-model="vm.columnFilter[vm.col.field]" \nng-change="vm.filterChange()" class="mt-5 tx-filter-input-element" flex aria-label="Status Filter"><md-option \nng-value="\'\'">{{\'PARTS.NO_FILTER\' | translate}}</md-option><md-option ng-value="\'!0\'">\n{{\'NOTIFICATION_TYPE.PENDING\' | translate}} {{\'PARTS.ONLY\' | translate}}</md-option><md-option ng-value="\'!10\'">\n{{\'NOTIFICATION_TYPE.SENT_SUCCESSFULLY\' | translate}} {{\'PARTS.ONLY\' | translate}}</md-option></md-select></div><div \nng-switch-when="bool"><md-select ng-model="vm.columnFilter[vm.col.field]" ng-change="vm.filterChange()" \nclass="mt-5 tx-filter-input-element" flex aria-label="Boolean Filter"><md-option ng-value="\'\'">\n{{\'STATUS.ALL\' | translate}}</md-option><md-option ng-value="\'true\'">\n{{\'PARTS.TRUE\' | translate}} {{\'PARTS.ONLY\' | translate}}</md-option><md-option ng-value="\'false\'">\n{{\'PARTS.FALSE\' | translate}} {{\'PARTS.ONLY\' | translate}}</md-option><md-option ng-value="\'blank\'">\n{{\'PARTS.BLANK\' | translate}} {{\'PARTS.ONLY\' | translate}}</md-option></md-select></div><div ng-switch-when="bool-str">\n<md-select ng-model="vm.columnFilter[vm.col.field]" ng-change="vm.filterChange()" class="mt-5 tx-filter-input-element" \nflex aria-label="Boolean Filter"><md-option ng-value="\'\'">{{\'STATUS.ALL\' | translate}}</md-option><md-option \nng-value="\'true\'">{{\'PARTS.TRUE\' | translate}} {{\'PARTS.ONLY\' | translate}}</md-option><md-option ng-value="\'false\'">\n{{\'PARTS.FALSE\' | translate}} {{\'PARTS.ONLY\' | translate}}</md-option><md-option ng-value="\'blank\'">\n{{\'PARTS.BLANK\' | translate}} {{\'PARTS.ONLY\' | translate}}</md-option></md-select></div><div ng-switch-when="bool-int">\n<md-select ng-model="vm.columnFilter[vm.col.field]" ng-change="vm.filterChange()" class="mt-5 tx-filter-input-element" \nflex aria-label="Boolean Filter"><md-option ng-value="\'\'">{{\'STATUS.ALL\' | translate}}</md-option><md-option \nng-value="\'1\'">{{\'PARTS.TRUE\' | translate}} {{\'PARTS.ONLY\' | translate}}</md-option><md-option ng-value="\'0\'">\n{{\'PARTS.FALSE\' | translate}} {{\'PARTS.ONLY\' | translate}}</md-option><md-option ng-value="\'blank\'">\n{{\'PARTS.BLANK\' | translate}} {{\'PARTS.ONLY\' | translate}}</md-option></md-select></div><div ng-switch-when="int-bool">\n<md-select ng-model="vm.columnFilter[vm.col.field]" ng-change="vm.filterChange()" class="mt-5 tx-filter-input-element" \nflex aria-label="Boolean Filter"><md-option ng-value="\'\'">{{\'STATUS.ALL\' | translate}}</md-option><md-option \nng-value="\'1\'">{{\'PARTS.TRUE\' | translate}} {{\'PARTS.ONLY\' | translate}}</md-option><md-option ng-value="\'0\'">\n{{\'PARTS.FALSE\' | translate}} {{\'PARTS.ONLY\' | translate}}</md-option><md-option ng-value="\'blank\'">\n{{\'PARTS.BLANK\' | translate}} {{\'PARTS.ONLY\' | translate}}</md-option></md-select></div><div ng-switch-when="list"><div\n ng-if="!vm.isAdvancedFilter" layout="row" layout-align="start center"><md-input-container flex \nng-if="vm.col.supportFilterLookup"><md-select ng-model="vm.columnFilter[vm.col.field]" \nng-change="vm.filterChange({which: 1})" md-on-open="vm.loadUniqueValues(0, vm.col.inputType)" \nmd-on-close="vm.clearSearchText()" class="mt-5 tx-filter-input-element" aria-label="List Filter" multiple="multiple">\n<md-select-header flex><input ng-model="vm.searchText" type="search" ng-keydown="vm.onKeyDown($event)" \nplaceholder="{{vm.col.field}}" class="tx-filter-input-element md-text"></md-select-header><md-option ng-value="item" \nng-repeat="item in vm.uniqueValues | filter:vm.searchText">{{item}}</md-option></md-select></md-input-container>\n<md-input-container flex ng-if="!vm.col.supportFilterLookup"><input id="{{vm.inputId}}" \nng-model="vm.columnFilter[vm.col.field]" type="text" aria-label="{{vm.col.field}}" class="tx-filter-input-element" \nng-keyup="vm.filterChange($event)"></md-input-container><md-button class="md-icon-button" \nng-click="vm.showAdvanceFilterDialog($event, vm.col)" aria-label="Advance Filters" translate \ntranslate-attr-aria-label="ACTIONS.FILTER_CLOSE"><md-tooltip>{{\'PARTS.ADVANCED_FILTER\' | translate}}</md-tooltip>\n<md-icon md-font-icon="icon-playlist-plus"></md-icon></md-button></div><div ng-if="vm.isAdvancedFilter" layout="row" \nlayout-align="start center" class="advance-filter tx-filter-input-element"><span class="text-box" \nng-click="vm.showAdvanceFilterDialog($event, vm.col)" flex translate="PARTS.ADVANCED_FILTER">Advanced Filter<md-tooltip\n style="max-width:{{vm.colWidth}}px" ng-if="!vm.columnFilter[vm.col.field].filterBlank">\n{{vm.columnFilter[vm.col.field].filterValues}}</md-tooltip><md-tooltip style="max-width:{{vm.colWidth}}px" \nng-if="vm.columnFilter[vm.col.field].filterBlank">{{\'PARTS.FILTER_BLANK\' | translate}}</md-tooltip></span><md-button \nclass="md-icon-button" ng-click="vm.removeAdvancedFilter(vm.col.field)" aria-label="Close Advance Filter" translate \ntranslate-attr-aria-label="ACTIONS.FILTER_CLOSE"><md-icon md-font-icon="icon-close"></md-icon></md-button></div></div>\n<div ng-switch-when="articlenumber"><div ng-if="!vm.isAdvancedFilter" layout="row" layout-align="start center">\n<md-input-container flex ng-if="vm.col.supportFilterLookup"><md-select ng-model="vm.columnFilter[vm.col.field]" \nng-change="vm.filterChange({which: 1})" md-on-open="vm.loadUniqueValues(0, vm.col.inputType)" \nmd-on-close="vm.clearSearchText()" class="mt-5 tx-filter-input-element" aria-label="List Filter" multiple="multiple">\n<md-select-header flex><input ng-model="vm.searchText" type="search" ng-keydown="vm.onKeyDown($event)" \nplaceholder="{{vm.col.field}}" class="tx-filter-input-element md-text"></md-select-header><md-option \nng-value="\'blank\'"></md-option><md-option ng-value="item" ng-repeat="item in vm.uniqueValues | filter:vm.searchText">\n{{item}}</md-option></md-select></md-input-container><md-input-container flex ng-if="!vm.col.supportFilterLookup">\n<input id="{{vm.inputId}}" ng-model="vm.columnFilter[vm.col.field]" type="text" aria-label="{{vm.col.field}}" \nclass="tx-filter-input-element" ng-keyup="vm.filterChange($event)"></md-input-container><md-button \nclass="md-icon-button" ng-click="vm.showAdvanceFilterDialog($event, vm.col)" aria-label="Advance Filters" translate \ntranslate-attr-aria-label="ACTIONS.FILTER_CLOSE"><md-tooltip>{{\'PARTS.ADVANCED_FILTER\' | translate}}</md-tooltip>\n<md-icon md-font-icon="icon-playlist-plus"></md-icon></md-button></div><div ng-if="vm.isAdvancedFilter" layout="row" \nlayout-align="start center" class="advance-filter tx-filter-input-element"><span class="text-box" \nng-click="vm.showAdvanceFilterDialog($event, vm.col)" flex translate="PARTS.ADVANCED_FILTER">Advanced Filter<md-tooltip\n style="max-width:{{vm.colWidth}}px" ng-if="!vm.columnFilter[vm.col.field].filterBlank">\n{{vm.columnFilter[vm.col.field].filterValues}}</md-tooltip><md-tooltip style="max-width:{{vm.colWidth}}px" \nng-if="vm.columnFilter[vm.col.field].filterBlank">{{\'PARTS.FILTER_BLANK\' | translate}}</md-tooltip></span><md-button \nclass="md-icon-button" ng-click="vm.removeAdvancedFilter(vm.col.field)" aria-label="Close Advance Filter" translate \ntranslate-attr-aria-label="ACTIONS.FILTER_CLOSE"><md-icon md-font-icon="icon-close"></md-icon></md-button></div></div>\n<div ng-switch-when="linkedcatalogarticlenumber"><div ng-if="!vm.isAdvancedFilter" layout="row" \nlayout-align="start center"><md-input-container flex ng-if="vm.col.supportFilterLookup"><md-select \nng-model="vm.columnFilter[vm.col.field]" ng-change="vm.filterChange({which: 1})" \nmd-on-open="vm.loadUniqueValues(0, vm.col.inputType)" md-on-close="vm.clearSearchText()" \nclass="mt-5 tx-filter-input-element" aria-label="List Filter" multiple="multiple"><md-select-header flex><input \nng-model="vm.searchText" type="search" ng-keydown="vm.onKeyDown($event)" placeholder="{{vm.col.field}}" \nclass="tx-filter-input-element md-text"></md-select-header><md-option ng-value="\'blank\'"></md-option><md-option \nng-value="item" ng-repeat="item in vm.uniqueValues | filter:vm.searchText">{{item}}</md-option></md-select>\n</md-input-container><md-input-container flex ng-if="!vm.col.supportFilterLookup"><input id="{{vm.inputId}}" \nng-model="vm.columnFilter[vm.col.field]" type="text" aria-label="{{vm.col.field}}" class="tx-filter-input-element" \nng-keyup="vm.filterChange($event)"></md-input-container><md-button class="md-icon-button" \nng-click="vm.showAdvanceFilterDialog($event, vm.col)" aria-label="Advance Filters" translate \ntranslate-attr-aria-label="ACTIONS.FILTER_CLOSE"><md-tooltip>{{\'PARTS.ADVANCED_FILTER\' | translate}}</md-tooltip>\n<md-icon md-font-icon="icon-playlist-plus"></md-icon></md-button></div><div ng-if="vm.isAdvancedFilter" layout="row" \nlayout-align="start center" class="advance-filter tx-filter-input-element"><span class="text-box" \nng-click="vm.showAdvanceFilterDialog($event, vm.col)" flex translate="PARTS.ADVANCED_FILTER">Advanced Filter<md-tooltip\n style="max-width:{{vm.colWidth}}px" ng-if="!vm.columnFilter[vm.col.field].filterBlank">\n{{vm.columnFilter[vm.col.field].filterValues}}</md-tooltip><md-tooltip style="max-width:{{vm.colWidth}}px" \nng-if="vm.columnFilter[vm.col.field].filterBlank">{{\'PARTS.FILTER_BLANK\' | translate}}</md-tooltip></span><md-button \nclass="md-icon-button" ng-click="vm.removeAdvancedFilter(vm.col.field)" aria-label="Close Advance Filter" translate \ntranslate-attr-aria-label="ACTIONS.FILTER_CLOSE"><md-icon md-font-icon="icon-close"></md-icon></md-button></div></div>\n<div ng-switch-when="modelnumber"><div ng-if="!vm.isAdvancedFilter" layout="row" layout-align="start center">\n<md-input-container flex ng-if="vm.col.supportFilterLookup"><md-select ng-model="vm.columnFilter[vm.col.field]" \nng-change="vm.filterChange({which: 1})" md-on-open="vm.loadUniqueValues(0, vm.col.inputType)" \nmd-on-close="vm.clearSearchText()" class="mt-5 tx-filter-input-element" aria-label="List Filter" multiple="multiple">\n<md-select-header flex><input ng-model="vm.searchText" type="search" ng-keydown="vm.onKeyDown($event)" \nplaceholder="{{vm.col.field}}" class="tx-filter-input-element md-text"></md-select-header><md-option \nng-value="\'blank\'"></md-option><md-option ng-value="item" ng-repeat="item in vm.uniqueValues | filter:vm.searchText">\n{{item}}</md-option></md-select></md-input-container><md-input-container flex ng-if="!vm.col.supportFilterLookup">\n<input id="{{vm.inputId}}" ng-model="vm.columnFilter[vm.col.field]" type="text" aria-label="{{vm.col.field}}" \nclass="tx-filter-input-element" ng-keyup="vm.filterChange($event)"></md-input-container><md-button \nclass="md-icon-button" ng-click="vm.showAdvanceFilterDialog($event, vm.col)" aria-label="Advance Filters" translate \ntranslate-attr-aria-label="ACTIONS.FILTER_CLOSE"><md-tooltip>{{\'PARTS.ADVANCED_FILTER\' | translate}}</md-tooltip>\n<md-icon md-font-icon="icon-playlist-plus"></md-icon></md-button></div><div ng-if="vm.isAdvancedFilter" layout="row" \nlayout-align="start center" class="advance-filter tx-filter-input-element"><span class="text-box" \nng-click="vm.showAdvanceFilterDialog($event, vm.col)" flex translate="PARTS.ADVANCED_FILTER">Advanced Filter<md-tooltip\n style="max-width:{{vm.colWidth}}px" ng-if="!vm.columnFilter[vm.col.field].filterBlank">\n{{vm.columnFilter[vm.col.field].filterValues}}</md-tooltip><md-tooltip style="max-width:{{vm.colWidth}}px" \nng-if="vm.columnFilter[vm.col.field].filterBlank">{{\'PARTS.FILTER_BLANK\' | translate}}</md-tooltip></span><md-button \nclass="md-icon-button" ng-click="vm.removeAdvancedFilter(vm.col.field)" aria-label="Close Advance Filter" translate \ntranslate-attr-aria-label="ACTIONS.FILTER_CLOSE"><md-icon md-font-icon="icon-close"></md-icon></md-button></div></div>\n<div ng-switch-when="multi-value"><div ng-if="!vm.isAdvancedFilter" layout="row" layout-align="start center">\n<md-input-container flex ng-if="vm.col.supportFilterLookup"><md-select ng-model="vm.columnFilter[vm.col.field]" \nng-change="vm.filterChange({which: 1})" md-on-open="vm.loadUniqueValues(0)" md-on-close="vm.clearSearchText()" \nclass="mt-5 tx-filter-input-element" aria-label="List Filter" multiple="multiple"><md-select-header flex><input \nng-model="vm.searchText" type="search" ng-keydown="vm.onKeyDown($event)" placeholder="{{vm.col.field}}" \nclass="tx-filter-input-element md-text"></md-select-header><md-option ng-value="\'blank\'"></md-option><md-option \nng-value="item" ng-repeat="item in vm.uniqueValues | filter:vm.searchText">{{item}}</md-option></md-select>\n</md-input-container><md-input-container flex ng-if="!vm.col.supportFilterLookup"><input id="{{vm.inputId}}" \nng-model="vm.columnFilter[vm.col.field]" type="text" aria-label="{{vm.col.field}}" class="tx-filter-input-element" \nng-keyup="vm.filterChange($event)"></md-input-container><md-button class="md-icon-button" \nng-click="vm.showAdvanceFilterDialog($event, vm.col)" aria-label="Advance Filters" translate \ntranslate-attr-aria-label="ACTIONS.FILTER_CLOSE"><md-tooltip>{{\'PARTS.ADVANCED_FILTER\' | translate}}</md-tooltip>\n<md-icon md-font-icon="icon-playlist-plus"></md-icon></md-button></div><div ng-if="vm.isAdvancedFilter" layout="row" \nlayout-align="start center" class="advance-filter tx-filter-input-element"><span class="text-box" \nng-click="vm.showAdvanceFilterDialog($event, vm.col)" flex translate="PARTS.ADVANCED_FILTER">Advanced Filter<md-tooltip\n style="max-width:{{vm.colWidth}}px" ng-if="!vm.columnFilter[vm.col.field].filterBlank">\n{{vm.columnFilter[vm.col.field].filterValues}}</md-tooltip><md-tooltip style="max-width:{{vm.colWidth}}px" \nng-if="vm.columnFilter[vm.col.field].filterBlank">{{\'PARTS.FILTER_BLANK\' | translate}}</md-tooltip></span><md-button \nclass="md-icon-button" ng-click="vm.removeAdvancedFilter(vm.col.field)" aria-label="Close Advance Filter" translate \ntranslate-attr-aria-label="ACTIONS.FILTER_CLOSE"><md-icon md-font-icon="icon-close"></md-icon></md-button></div></div>\n<div ng-switch-when="color-palette"><div ng-if="!vm.isAdvancedFilter" layout="row" layout-align="start center">\n<md-input-container flex ng-if="vm.col.supportFilterLookup"><md-select ng-model="vm.columnFilter[vm.col.field]" \nng-change="vm.filterChange({which: 1})" md-on-open="vm.loadUniqueValues(0, vm.col.inputType)" \nmd-on-close="vm.clearSearchText()" class="mt-5 tx-filter-input-element" aria-label="List Filter" multiple="multiple">\n<md-select-header flex><input ng-model="vm.searchText" type="search" ng-keydown="vm.onKeyDown($event)" \nplaceholder="{{vm.col.field}}" class="tx-filter-input-element md-text"></md-select-header><md-option ng-value="item" \nng-repeat="item in vm.uniqueValues | filter:vm.searchText track by $index">{{item}}</md-option></md-select>\n</md-input-container><md-input-container flex ng-if="!vm.col.supportFilterLookup"><input id="{{vm.inputId}}" \nng-model="vm.columnFilter[vm.col.field]" type="text" aria-label="{{vm.col.field}}" class="tx-filter-input-element" \nng-keyup="vm.filterChange($event)"></md-input-container><md-button class="md-icon-button" \nng-click="vm.showAdvanceFilterDialog($event, vm.col)" aria-label="Advance Filters" translate \ntranslate-attr-aria-label="ACTIONS.FILTER_CLOSE"><md-tooltip>{{\'PARTS.ADVANCED_FILTER\' | translate}}</md-tooltip>\n<md-icon md-font-icon="icon-playlist-plus"></md-icon></md-button></div><div ng-if="vm.isAdvancedFilter" layout="row" \nlayout-align="start center" class="advance-filter tx-filter-input-element"><span class="text-box" \nng-click="vm.showAdvanceFilterDialog($event, vm.col)" flex translate="PARTS.ADVANCED_FILTER">Advanced Filter<md-tooltip\n style="max-width:{{vm.colWidth}}px" ng-if="!vm.columnFilter[vm.col.field].filterBlank">\n{{vm.columnFilter[vm.col.field].filterValues}}</md-tooltip><md-tooltip style="max-width:{{vm.colWidth}}px" \nng-if="vm.columnFilter[vm.col.field].filterBlank">{{\'PARTS.FILTER_BLANK\' | translate}}</md-tooltip></span><md-button \nclass="md-icon-button" ng-click="vm.removeAdvancedFilter(vm.col.field)" aria-label="Close Advance Filter" translate \ntranslate-attr-aria-label="ACTIONS.FILTER_CLOSE"><md-icon md-font-icon="icon-close"></md-icon></md-button></div></div>\n<div ng-switch-default><div ng-if="!vm.isAdvancedFilter" layout="row" layout-align="start center"><md-input-container \nflex ng-if="vm.col.supportFilterLookup"><md-select ng-model="vm.columnFilter[vm.col.field]" \nng-change="vm.filterChange({which: 1})" md-on-open="vm.loadUniqueValues(0, vm.col.inputType)" \nmd-on-close="vm.clearSearchText()" class="mt-5 tx-filter-input-element" aria-label="List Filter" multiple="multiple">\n<md-select-header flex><input ng-model="vm.searchText" type="search" ng-keydown="vm.onKeyDown($event)" \nplaceholder="{{vm.col.field}}" class="tx-filter-input-element md-text"></md-select-header><md-option ng-value="item" \nng-repeat="item in vm.uniqueValues | filter:vm.searchText">{{item}}</md-option></md-select></md-input-container>\n<md-input-container flex ng-if="!vm.col.supportFilterLookup"><input id="{{vm.inputId}}" \nng-model="vm.columnFilter[vm.col.field]" type="text" aria-label="{{vm.col.field}}" class="tx-filter-input-element" \nng-keyup="vm.filterChange($event)"></md-input-container><md-button class="md-icon-button" \nng-click="vm.showAdvanceFilterDialog($event, vm.col)" aria-label="Advance Filters" translate \ntranslate-attr-aria-label="ACTIONS.FILTER_CLOSE"><md-tooltip>{{\'PARTS.ADVANCED_FILTER\' | translate}}</md-tooltip>\n<md-icon md-font-icon="icon-playlist-plus"></md-icon></md-button></div><div ng-if="vm.isAdvancedFilter" layout="row" \nlayout-align="start center" class="advance-filter tx-filter-input-element"><span class="text-box" \nng-click="vm.showAdvanceFilterDialog($event, vm.col)" flex translate="PARTS.ADVANCED_FILTER">Advanced Filter<md-tooltip\n style="max-width:{{vm.colWidth}}px" ng-if="!vm.columnFilter[vm.col.field].filterBlank">\n{{vm.columnFilter[vm.col.field].filterValues}}</md-tooltip><md-tooltip style="max-width:{{vm.colWidth}}px" \nng-if="vm.columnFilter[vm.col.field].filterBlank">{{\'PARTS.FILTER_BLANK\' | translate}}</md-tooltip></span><md-button \nclass="md-icon-button" ng-click="vm.removeAdvancedFilter(vm.col.field)" aria-label="Close Advance Filter" translate \ntranslate-attr-aria-label="ACTIONS.FILTER_CLOSE"><md-icon md-font-icon="icon-close"></md-icon></md-button></div></div>\n</div>');
$templateCache.put('app/directives/txImageDraggable/tx-image-draggable.html','<div class="tx-image-draggable" style="height: inherit"><div layout="row" layout-align="center center" \nng-show="vm.isLoading" style="height: inherit"><md-progress-circular md-mode="indeterminate" class="md-accent">\n</md-progress-circular></div><div layout="row" layout-align="center center" layout-padding \nng-show="!vm.data.length && !vm.isLoading"><div class="text-italic" translate="MESSAGES.LIST.NO_ITEMS">\nNo items available...</div></div><md-content id="images-view" ng-style="vm.listStyle"><div \ninfinite-scroll-container="\'#images-view\'" infinite-scroll="vm.addImages()" infinite-scroll-distance="1"><div \nclass="grid-list" layout="row" layout-wrap layout-margin ng-show="!vm.isLoading && vm.data.length"><div \nclass="grid-tile" layout="column" layout-align="space-between stretch" \nng-class="{\'selected\': itm.selected, \'assigned\': itm.txAssigned == true}" \nng-repeat="itm in vm.data | limitTo: vm.model.imagesLimit" ng-click="vm.doItemClick(itm)"><div layout="column" flex \nlayout-align="center center" class="tile-img-container"><img class="b-lazy tile-img" \nsrc="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" data-blazy="{{itm.ImageSource}}">\n</div><md-divider></md-divider><div layout="column" layout-align="center center" class="tile-toolbar"><div \nclass="bar-info bold text-truncate pt5 lh13">{{itm.ArticleNumber}}<md-tooltip>{{itm.ArticleName}}</md-tooltip></div>\n</div></div></div></div></md-content></div>');
$templateCache.put('app/directives/txLinkedArticleViewer/tx-linked-article-viewer.html','<div class="tx-linked-article-viewer" layout="row" flex="100"><div layout="column" flex="100" class="lookup-element">\n<md-autocomplete md-input-name="Seasons" md-selected-item="vm.linkedCatalogSeason" \nmd-items="item in vm.seasonsLookupSearch(vm.searchText.Seasons)" md-search-text="vm.searchText.Seasons" \nmd-item-text="vm.getSeasonsLookupDisplayValue(item, \'id\')" md-min-length="0" \nmd-floating-label="{{\'ARTICLES.FIELDS.SEASONS\' | translate}}" \nmd-selected-item-change="vm.onLinkedCatalogSeasonChange(vm.linkedCatalogSeason)" md-no-cache="true" \ntx-clear-autocomplete ng-click="vm.selectText($event)" md-menu-class="autocomplete-custom" \nng-disabled="{{vm.field.validation.disabledCriteria || (vm.field.showInEdit && !vm.field.editable && !vm.isNew)}}">\n<md-item-template><span class="autocomplete-item md-accent-fg" md-highlight-text="vm.searchText.Seasons" \nmd-highlight-flags="i">{{item.value}}</span></md-item-template><md-not-found>\nNo Record matching "{{vm.searchText.Seasons}}" were found.</md-not-found><div class="info-for-first-100-records" \nng-if="vm.isSeasonsAboveDropDownLimit"><md-icon class="icon s14" md-font-icon="icon-information-outline"></md-icon>\n<span>{{\'MESSAGES.CONTENT.SHOW_FIRST_100\' | translate}}</span></div></md-autocomplete></div><div layout="column" \nflex="100" class="lookup-element"><md-autocomplete md-input-name="{{vm.field}}" \nmd-selected-item="vm.linkedArticleNumberAttribute" \nmd-items="item in vm.lookupSearch(vm.searchText[vm.field], vm.field)" md-search-text="vm.searchText[vm.field]" \nmd-item-text="vm.getLookupDisplayValue(item)" md-min-length="0" \nmd-floating-label="{{\'ARTICLES.FIELDS.ARTICLE_NUMBER\' | translate}}" \nmd-selected-item-change="vm.lookupChange(vm.linkedArticleNumberAttribute, vm.field.field)" \nng-required="vm.isInputRequired(vm.field)" md-no-cache="true" tx-clear-autocomplete ng-click="vm.selectText($event)" \nmd-menu-class="autocomplete-custom" \nng-disabled="{{vm.field.validation.disabledCriteria || (vm.field.showInEdit && !vm.field.editable && !vm.isNew)}} || !vm.linkedCatalogSeason">\n<md-item-template><span class="autocomplete-item md-accent-fg" md-highlight-text="vm.searchText[vm.field]" \nmd-highlight-flags="i">{{item.ArticleNumber}}</span></md-item-template><div ng-messages="vm.editForm[vm.field].$error" \nrole="alert" ng-show="vm.editForm[vm.field].$touched"><div ng-message="required">\n{{field.validation.messages.isRequired | translate}}</div></div><md-not-found>\nNo Record matching "{{vm.searchText[vm.field]}}" were found.</md-not-found><div class="info-for-first-100-records" \nng-if="vm.field.isAboveDropDownLimit && !(vm.field.validation.disabledCriteria || (vm.field.showInEdit && !vm.field.editable && !vm.isNew))">\n<md-icon class="icon s14" md-font-icon="icon-information-outline"></md-icon><span>\n{{\'MESSAGES.CONTENT.SHOW_FIRST_100\' | translate}}</span></div></md-autocomplete></div></div>');
$templateCache.put('app/directives/txParentModelTypeViewer/tx-parent-model-type-viewer.html','<div class="tx-parent-model-type-viewer"><div layout="row" flex="100"><div layout="column" flex="100" \nclass="lookup-element"><md-input-container class="md-block"><label>{{vm.parentModelTypeField.displayLabel | translate}}\n</label><md-select id="dialog_input_first" name="{{vm.parentModelTypeField.field}}" \nng-model="vm.record[vm.parentModelTypeField.field]" aria-label="{{vm.parentModelTypeField.displayLabel | translate}}" \nng-required="vm.parentModelTypeField.validation.isRequired && !vm.isUpdateBulk" \nng-disabled="{{vm.parentModelTypeField.validation.disabledCriteria || (vm.parentModelTypeField.showInEdit && !vm.parentModelTypeField.editable && !vm.isNew)}}" \npattern="{{vm.parentModelTypeField.validation.pattern}}" \nng-change="vm.onParentModelTypeChange(vm.record[vm.parentModelTypeField.field])" \nmd-on-close="vm.clearSearchTerm(vm.parentModelTypeField.field)"><md-select-header><input \nng-model="vm.searchValue[vm.parentModelTypeField.field]" type="search" placeholder="Search" \nng-keydown="$event.stopPropagation()"></md-select-header><md-option ng-value="option" \nng-repeat="option in vm.parentModelTypeField.values | filter:vm.searchValue[vm.parentModelTypeField.field] track by $index">\n{{ option }}</md-option></md-select><div ng-messages="vm.editForm[vm.parentModelTypeField.field].$error" role="alert" \nmultiple="multiple"><div ng-message="required">{{vm.parentModelTypeField.validation.messages.isRequired | translate}}\n</div><div ng-message="pattern">{{vm.parentModelTypeField.validation.messages.pattern | translate}}</div></div>\n</md-input-container></div><div layout="column" flex="100" class="lookup-element"><md-input-container \nng-if="vm.isLoading" class="md-block parent-model-number-container"><label \ntranslate="SELLER_MODELS.FIELDS.PARENT_MODEL_NUMBER">Parent Model Number</label><input \nng-model="vm.record[\'ParentModelNumber\']" name="ParentModelNumber" disabled="disabled"><md-progress-linear \nng-if="vm.isLoading" class="md-accent parent-model-loading"></md-progress-linear></md-input-container><md-autocomplete \nng-if="!vm.isLoading" id="dialog_input_{{$first ? \'first\' : $index}}" md-input-name="MasterModelId" \nmd-selected-item="vm.record[\'MasterModelId\']" md-items="item in vm.lookupSearch(vm.searchText[\'MasterModelId\'])" \nmd-search-text="vm.searchText[\'MasterModelId\']" md-item-text="vm.getLookupDisplayValue(item)" md-min-length="0" \nmd-floating-label="{{\'SELLER_MODELS.FIELDS.PARENT_MODEL_NUMBER\' | translate}}" \nmd-selected-item-change="vm.lookupChange(vm.record[\'MasterModelId\'])" \nng-required="vm.record[vm.parentModelTypeField.field].toLowerCase() !== \'parent\' && vm.record[vm.parentModelTypeField.field] != null && vm.record[vm.parentModelTypeField.field] !== \'\'" \nmd-no-cache="true" tx-clear-autocomplete ng-click="vm.selectText($event)" md-menu-class="autocomplete-custom" \nng-disabled="!vm.record[\'parent_model_type\'] || (vm.record[\'parent_model_type\'].toLowerCase() === \'parent\') || {{vm.parentModelTypeField.validation.disabledCriteria || (vm.parentModelTypeField.showInEdit && !vm.parentModelTypeField.editable && !vm.isNew)}}">\n<md-item-template><span class="autocomplete-item md-accent-fg" md-highlight-text="vm.searchText[\'MasterModelId\']" \nmd-highlight-flags="i">{{item.ModelNumber}}</span></md-item-template><div \nng-messages="vm.editForm[parentModelNumber].$error" role="alert" ng-show="vm.editForm[parentModelNumber].$touched"><div\n ng-message="required">{{field.validation.messages.isRequired | translate}}</div></div><md-not-found>\nNo Record matching "{{vm.searchText[\'MasterModelId\']}}" were found.</md-not-found><div \nclass="info-for-first-100-records" ng-if="vm.isAboveDropDownLimit"><md-icon class="icon s14" \nmd-font-icon="icon-information-outline"></md-icon><span>{{\'MESSAGES.CONTENT.SHOW_FIRST_100\' | translate}}</span></div>\n</md-autocomplete></div></div><div layout="row" flex="100"><div layout="column" flex="50" class="lookup-element">\n<md-input-container class="md-block"><label>{{\'SELLER_MODELS.FIELDS.PARENT_MODEL_NAME\' | translate}}</label><input \nid="dialog_input_{{$first ? \'first\' : $index}}" name="ParentModelName" ng-model="vm.record[\'ParentModelName\']" \ntype="text" disabled="true"></md-input-container></div></div></div>');
$templateCache.put('app/directives/txUiGrid/tx-ui-grid.html','<div class="custom-grid-wrapper"><div class="header-row"><span class="grid-label">{{vm.field.displayLabel | translate}}\n</span><md-button ng-if="vm.editable" class="send-button md-accent md-raised btn btn-primary add-row-btn" \nng-click="vm.addRow()">Add Row</md-button></div><div ui-grid="vm.gridOptions" ui-grid-edit ui-grid-cellnav \nui-grid-resize-columns ui-grid-pinning class="grid"></div></div>');
$templateCache.put('app/directives/txVirtualRepeater/tx-virtual-repeater.html','<div class="tx-virtual-repeater" layout="column"><div ng-repeat="(ipage, page) in vm.pages track by $index" \nstyle="{{ipage < vm.pages.length - 1 ? vm.pageStyle : vm.lastPageStyle}}" layout="row" layout-wrap><div \nng-if="vm.totalPages <= 30 || (ipage > vm.currentPage-4 && ipage < vm.currentPage+4)" \nng-repeat="itm in page.items track by $index" style="{{vm.itemStyle}}" ng-transclude></div></div></div>');
$templateCache.put('app/main/app-maintenance/app-maintenance.html','<div id="maintenance" class="flex-scrollable" layout="column" ms-scroll><div id="maintenance-form-wrapper" \nlayout="column" layout-align="center center"><div id="maintenance-form" class="md-whiteframe-8dp" layout="column" \nlayout-align="start start"><div class="logo md-accent-bg"><span>T1</span></div><div class="content" layout="column" \nlayout-align="start start"><div class="title" translate="MAINTENANCE.TITLE">T1 is temporarily unavailable.</div><div \ntranslate="MAINTENANCE.SUBTITLE">\nScheduled maintenance is currently in progress. Please check back soon. We apologize for any inconvenience.</div><div \nclass="subtitle pt-20" translate="MAINTENANCE.T1SUPPORT">T1 Support</div></div></div></div></div>');
$templateCache.put('app/main/errors/errors.html','<div class="error-page" layout="column"><label class="error-message">{{vm.message | translate}}</label></div>');
$templateCache.put('app/main/landing/landing.html','<div id="landing" class="page-layout simple tabbed"><div class="header md-accent-bg" layout="column" \nlayout-align="center center" layout-gt-sm="row" layout-align-gt-sm="space-between end"><div class="user-info" \nlayout="column" layout-align="center center" layout-gt-sm="row" layout-align-gt-sm="start center"><div class="name">\n{{\'LANDING.WELCOME\' | translate}} {{vm.profile.FirstName}}</div></div><div class="actions" layout="row" \nlayout-align="end center"><md-button class="md-raised md-accent" translate="LANDING.PROFILE" \ntranslate-attr-aria-label="LANDING.PROFILE" ng-click="vm.gotoProfile()">My Profile</md-button></div></div><div \nclass="content p-24" flex><div layout="row" layout-wrap><div layout="column" flex="100" flex-gt-sm="55" \nflex-gt-md="65" flex-order="1" flex-order-gt-sm="1"><div class="box info-box general md-whiteframe-1dp" \nlayout="column"><header class="md-accent-bg"><div class="title" translate="LANDING.CURRENT_CATALOG">Current Catalog\n</div></header><div class="content" flex layout="row" layout-wrap><div class="info-line" flex="50"><div class="title" \ntranslate="LANDING.CATALOG_NAME">Catalog Name</div><div class="info">{{ vm.activeCatalog.CatalogName }}</div></div><div\n class="info-line" flex="50"><div class="title" translate="LANDING.CATALOG_SEASON">Season</div><div class="info">\n{{ vm.activeCatalog.Season }}</div></div><div class="info-line" flex="50"><div class="title" \ntranslate="LANDING.LAST_UPDATED">Last Updated</div><div class="info">{{ vm.activeCatalog.UpdatedDate | date }}</div>\n</div><div class="info-line" flex="50"><div class="title" translate="LANDING.CATALOG_YEAR">Year</div><div class="info">\n{{ vm.activeCatalog.Year }}</div></div></div><footer><div class="info-box-footer" flex layout="row" layout-wrap \nlayout-align="start center"><md-button class="md-icon-button" ui-sref="app.overview"><md-icon \nmd-font-icon="icon-chart-pie"></md-icon><md-tooltip><span translate="OVERVIEW.NAV">Overview</span></md-tooltip>\n</md-button><md-button class="md-icon-button" ui-sref="app.articles"><md-icon md-font-icon="icon-cube-outline">\n</md-icon><md-tooltip><span translate="ARTICLES.NAV">Articles</span></md-tooltip></md-button><md-button \nclass="md-icon-button" ui-sref="app.sizes"><md-icon md-font-icon="icon-layers"></md-icon><md-tooltip><span \ntranslate="SIZES.NAV">Sizes</span></md-tooltip></md-button><md-button class="md-icon-button" ui-sref="app.crds">\n<md-icon md-font-icon="icon-calendar-clock"></md-icon><md-tooltip><span translate="CRD.NAV">Delivery Dates</span>\n</md-tooltip></md-button><md-button class="md-icon-button" ui-sref="app.prices"><md-icon md-font-icon="icon-coin">\n</md-icon><md-tooltip><span translate="PRICES.NAV">Prices</span></md-tooltip></md-button><md-button \nclass="md-icon-button" ui-sref="app.assortments"><md-icon md-font-icon="icon-folder-multiple"></md-icon><md-tooltip>\n<span translate="ASSORTMENTS.NAV">Collections</span></md-tooltip></md-button><md-button class="md-icon-button" \nui-sref="app.tree"><md-icon md-font-icon="icon-sitemap"></md-icon><md-tooltip><span translate="CATALOG_TREE.NAV">Tree\n</span></md-tooltip></md-button><md-button class="md-icon-button" ui-sref="app.images"><md-icon \nmd-font-icon="icon-image-filter"></md-icon><md-tooltip><span translate="IMAGES.NAV">Images</span></md-tooltip>\n</md-button><md-button class="md-icon-button" ui-sref="app.packages"><md-icon md-font-icon="icon-package-variant">\n</md-icon><md-tooltip><span translate="PACKAGES.NAV">Packages</span></md-tooltip></md-button></div></footer></div><div \nclass="box general md-whiteframe-1dp" layout="column" ng-if="vm.catalogs.length > 0"><header class="md-accent-bg"><div \nclass="title" translate="LANDING.CATALOGS_LIST">Available Catalogs</div></header><div class="content" flex \nlayout="row"><md-list flex><md-list-item class="md-2-line list-item-hover" ng-repeat="item in vm.catalogs"><md-icon \nmd-font-icon="icon-library-books"></md-icon><div class="md-list-item-text" layout="column"><h3>{{ item.CatalogName }}\n</h3><p>{{ item.Season }} {{ item.Year }}</p></div><md-button class="md-secondary md-icon-button" \nng-click="vm.activateCatalog(item)" aria-label="call"><md-icon md-font-icon="icon-check-circle"></md-icon><md-tooltip>\n<span translate="LANDING.ACTIVATE">Activate Catalog</span></md-tooltip></md-button></md-list-item></md-list></div>\n</div></div><div class="sidebar" layout="column" flex="100" flex-gt-sm="45" flex-gt-md="35" flex-order="2" \nflex-order-gt-sm="2"><div class="box general md-whiteframe-1dp" layout="column"><header class="md-accent-bg"><div \nclass="title" translate="LANDING.NEED_SUPPORT">Need Support?</div></header><div class="content" flex layout="row" \nlayout-wrap translate="LANDING.SUPPORT_DETAILS">Support</div><footer><div layout="row" layout-align="start center"><div\n translate="LANDING.SUPPORT_EMAIL" class="p-5">Support Email:</div><div><a href="mailto:support@trasix.com">\nsupport@trasix.com</a></div></div></footer></div></div></div></div></div>');
$templateCache.put('app/main/profile/profile.html','<div id="profile" class="page-layout simple tabbed"><div class="header md-accent-bg" layout="column" \nlayout-align="center center" layout-gt-sm="row" layout-align-gt-sm="space-between end"><div class="user-info" \nlayout="column" layout-align="center center" layout-gt-sm="row" layout-align-gt-sm="start center"><img \nclass="profile-image avatar huge" src="assets/images/avatars/profile.jpg"><div class="name">\n{{vm.profile.FirstName + " " + vm.profile.LastName}}</div></div><div class="actions" layout="row" \nlayout-align="end center"><md-button class="md-raised md-accent" aria-label="Change Password" \ntranslate="PROFILE.CHANGE_PWD" translate-attr-aria-label="PROFILE.CHANGE_PWD" ng-click="vm.changePassword()" \nng-if="vm.activeDirectoryInfo !== vm.loginTypeEnums.ACTIVE_DIRECTORY">Change Password</md-button><md-button \nclass="md-raised md-primary" translate="PROFILE.EDIT" translate-attr-aria-label="PROFILE.EDIT" \nng-click="vm.editProfile($event, vm.profile)">Edit</md-button></div></div><div class="content" flex><md-tabs \nmd-dynamic-height md-no-ink><md-tab><md-tab-label><span translate="PROFILE.ABOUT">About</span></md-tab-label>\n<md-tab-body><md-content class="about-tab" ng-include="\'app/main/profile/tabs/about/about.html\'"></md-content>\n</md-tab-body></md-tab><md-tab><md-tab-label><span translate="PROFILE.SETTINGS">Settings</span></md-tab-label>\n<md-tab-body><md-content class="settings-tab" ng-include="\'app/main/profile/tabs/settings/settings.html\'"></md-content>\n</md-tab-body></md-tab><md-tab ng-if="false"><md-tab-label><span translate="PROFILE.LOG">Log</span></md-tab-label>\n<md-tab-body><md-content class="log-tab" ng-include="\'app/main/profile/tabs/log/log.html\'"></md-content></md-tab-body>\n</md-tab></md-tabs></div></div>');
$templateCache.put('app/main/vetting-lists/vetting-list.html','<div id="buyers-list" class="page-layout carded fullwidth list-view" layout="row"><div class="center" layout="column" \nflex><div class="content-card" layout="column" flex><tx-data-table tx-data="vm.data" tx-model="vm.model" \ntx-view="mainList" tx-filtered-data="vm.filteredData" tx-data-filter="global.search" tx-is-loading="vm.isLoading" \ntx-item-action-event="vm.doItemAction(action, item)" tx-list-action-event="vm.doListAction(action, selectedItems)" \ntx-refresh-action-event="vm.refreshItems(true, false)" tx-toolbar-visible="{{vm.toolbarVisible}}" \ntx-toolbar-options="::vm.toolbarOptions" tx-toolbar-value="vm.toolbarValue"></tx-data-table><md-button \nclass="add-rec-button md-fab md-warn" ng-click="vm.addRecord($event)" \naria-label="vm.model.views.mainList.fabAction.label" translate \ntx-access="{{::vm.model.views.mainList.fabAction.privilege}}"><md-icon \nmd-font-icon="{{vm.model.views.mainList.fabAction.icon}}"></md-icon></md-button></div></div></div>');
$templateCache.put('app/services/alertDialog/alertDialog.html','<md-dialog aria-label="Alert"><md-toolbar class="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" \nlayout-align="space-between center"><span class="title" translate="MESSAGES.TITLE.ALERT">Alert</span><md-button \nclass="md-icon-button" ng-click="vm.closeDialog()" aria-label="Close dialog" tranlate \ntranslate-aria-label="ACTIONS.DIALOG_CLOSE"><md-icon md-font-icon="icon-close"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><p>{{ vm.message | translate }}</p><a href="{{vm.url}}">{{vm.url}}</a>\n</md-dialog-content><md-dialog-actions><md-button ng-click="vm.closeDialog()" class="send-button md-primary md-raised" \ntranslate="ACTIONS.DIALOG_CLOSE" aria-label="Close" translate-attr-aria-label="ACTIONS.DIALOG_CLOSE">Close</md-button>\n</md-dialog-actions></md-dialog>');
$templateCache.put('app/services/bulkUpdater/bulkUpdater.html','<md-dialog class="bulk-edit-dialog" aria-label="{{vm.model.title ? \'Update \'+vm.model.title : \'Update Records\'}}"><form\n name="vm.editForm" class="md-inline-form"><md-toolbar class="md-accent md-hue-2"><div class="md-toolbar-tools" \nlayout="row" layout-align="space-between center"><div><span class="title" ng-if="vm.model.title" \ntranslate="PARTS.EDIT"></span> <span class="title" \ntranslate="{{vm.model.title ? vm.model.title : \'TITLES.RECORD_EDIT\'}}">Edit Record</span></div><md-button \nclass="md-icon-button" ng-click="vm.closeDialog(false)" aria-label="Close dialog" tranlate \ntranslate-aria-label="ACTIONS.DIALOG_CLOSE"><md-icon md-font-icon="icon-close"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div class="import-search-container" layout="row"><md-input-container \nflex-gt-xs="100" flex="100"><md-icon class="s18" md-font-icon="icon-magnify"></md-icon><input \nng-model="vm.searchPageText" type="search" placeholder="Search" md-autofocus ng-change="vm.onSearchTextChanged()">\n</md-input-container></div><div flex="100" flex-gt-xs="50" class="p-5" ng-if="vm.isSegmentations"><md-switch \nng-model="vm.record[\'Open\']" aria-label="{{\'SEGMENTATION.ACTIONS.OPEN_ALL_SEGMENTAIONS\' | translate}}" \nng-true-value="1" ng-false-value="0" class="md-accent" ng-change="vm.onOpenSegmentationsChange(vm.record[\'Open\'])">\n{{\'SEGMENTATION.ACTIONS.OPEN_ALL_SEGMENTAIONS\' | translate}}</md-switch></div><div flex="100" flex-gt-xs="50" \nclass="p-5" ng-if="vm.isSegmentationGroup"><md-input-container ng-if="vm.isSegmentationGroup" class="md-block"><label \ntranslate>SEGMENTATION.FIELDS.SEGMENTATION_GROUP</label><md-select id="dialog_input_{{$first ? \'first\' : $index}}" \nname="SegmentationGroup" ng-model="vm.SegmentationGroup" \nplaceholder="{{\'SEGMENTATION.FIELDS.SEGMENTATION_GROUP\' | translate}}" \nng-change="vm.onSegmentationGroupChange(vm.SegmentationGroup)" md-autofocus="$first"><md-option \nng-value="option.SegmentationGroup" ng-repeat="option in vm.SegmentationGroupList">{{ option.SegmentationGroup }}\n</md-option></md-select></md-input-container></div><div layout="row" layout-wrap \nng-show="!(vm.AllowExternalChangeManagement || vm.checkingForLockedArticles)"><div \nng-repeat="field in vm.filteredEditableFields" flex="100" \nflex-gt-xs="{{field.inputType == \'textArea\' || field.inputType == \'lookup-many\' || vm.isSegmentationPlanningEnable || vm.model.modelPath === \'catalogs.crds\'\r\n                || field.inputType == \'date\' || field.inputType == \'date-option\' || field.inputType == \'date-utc\' || field.inputType == \'date-without-time\' || field.inputType == \'parent-model-type\' || field.inputType == \'linkedcatalogarticlenumber\' || field.inputType == \'datatable\' ? 100 : 50}}" \nclass="p-5" ng-switch="field.inputType"><div ng-switch-when="textArea" layout="row"><span \nng-if="field.IsSeasonless && field.editable" class="attribute-criteria-icon"><md-tooltip><span>\n{{ \'MESSAGES.CONTENT.SEASONLESS_ATTRIBUTE_INFO_MESSAGE\' | translate }}</span></md-tooltip></span><div \nclass="external-change-message" \nng-if="field.isAllowChangeRequestEnabled && !vm.isNew && field.updateArticleChangeManagementExternalURL !== \'\'"><span>\n{{ \'MESSAGES.CONTENT.NON_EDITABLE_STATE_ATTRIBUTE\' | translate }} <a \nhref="{{field.updateArticleChangeManagementExternalURL}}" target="_blank">here</a></span></div><md-checkbox \nng-model="vm.checked[field.field]" aria-label="field.field" \nng-hide="{{field.validation.disabledCriteria || (field.showInEdit && !field.editable)}}" \nng-change="vm.checkBoxChanged(field.field)"></md-checkbox><md-input-container class="md-block"><label translate>\n{{field.displayLabel}}</label><textarea name="{{field.field}}" ng-model="vm.record[field.field]" columns="1" rows="3" \nng-required="vm.isInputRequired(field)" md-maxlength="{{field.validation.maxLen}}" \nng-disabled="{{field.validation.disabledCriteria || (field.showInEdit && !field.editable)}}" md-autofocus="$first" \npattern="{{field.validation.pattern}}" ng-focus="vm.currentFocusedField = field.field" \nng-change="vm.handleFieldChange(field);"></textarea><div ng-messages="vm.editForm[field.field].$error" role="alert" \nmultiple="multiple"><div ng-message="required">{{field.validation.messages.isRequired | translate}}</div><div \nng-message="pattern">{{field.validation.messages.pattern | translate}}</div><div ng-message="md-maxlength">\n{{field.validation.messages.maxLen | translate}}</div></div></md-input-container></div><div ng-switch-when="date" \nlayout="column" flex><span ng-if="field.IsSeasonless && field.editable" class="attribute-criteria-icon"><md-tooltip>\n<span>{{ \'MESSAGES.CONTENT.SEASONLESS_ATTRIBUTE_INFO_MESSAGE\' | translate }}</span></md-tooltip></span><div \nclass="external-change-message" \nng-if="field.isAllowChangeRequestEnabled && !vm.isNew && field.updateArticleChangeManagementExternalURL !== \'\'"><span>\n{{ \'MESSAGES.CONTENT.NON_EDITABLE_STATE_ATTRIBUTE\' | translate }} <a \nhref="{{field.updateArticleChangeManagementExternalURL}}" target="_blank">here</a></span></div><md-checkbox \nng-model="vm.checked[field.field]" aria-label="field.field" ng-hide="field.validation.disabledCriteria" \nng-change="vm.checkBoxChanged(field.field)"></md-checkbox><div layout="column"><label class="md-caption" \nng-class="{{vm.isInputRequired(field) && vm.editForm[field.field].$invalid ? \'form-date-error\': \'\'}}">\n{{field.displayLabel | translate}}</label><md-datepicker name="{{field.field}}" ng-model="vm.record[field.field]" \nng-init="vm.record[field.field] = vm.getDateObj(vm.record[field.field], field)" md-placeholder="" \nng-required="vm.isInputRequired(field)" md-autofocus="$first" ng-focus="vm.currentFocusedField = field.field" \nng-change="vm.handleFieldChange(field);" ng-disabled="field.validation.disabledCriteria"></md-datepicker></div><div \nng-messages="vm.editForm[field.field].$error" class="form-date-error" role="alert" multiple="multiple"><div \nng-message="required">{{field.validation.messages.isRequired | translate}}</div><div ng-message="pattern">\n{{field.validation.messages.pattern | translate}}</div></div></div><div ng-switch-when="date-without-time" \nlayout="column" flex><span ng-if="field.IsSeasonless && field.editable" class="attribute-criteria-icon"><md-tooltip>\n<span>{{ \'MESSAGES.CONTENT.SEASONLESS_ATTRIBUTE_INFO_MESSAGE\' | translate }}</span></md-tooltip></span><div \nclass="external-change-message" \nng-if="field.isAllowChangeRequestEnabled && !vm.isNew && field.updateArticleChangeManagementExternalURL !== \'\'"><span>\n{{ \'MESSAGES.CONTENT.NON_EDITABLE_STATE_ATTRIBUTE\' | translate }} <a \nhref="{{field.updateArticleChangeManagementExternalURL}}" target="_blank">here</a></span></div><md-checkbox \nng-model="vm.checked[field.field]" aria-label="field.field" ng-hide="field.validation.disabledCriteria" \nng-change="vm.checkBoxChanged(field.field)"></md-checkbox><div layout="column"><label class="md-caption" \nng-class="vm.isInputRequired(field) && vm.editForm[field.field].$invalid ? \'form-date-error\': \'\'">\n{{field.displayLabel | translate}}</label><md-datepicker name="{{field.field}}" ng-model="vm.record[field.field]" \nng-init="vm.record[field.field] = vm.getDateObj(vm.record[field.field], field)" md-placeholder="" \nng-required="vm.isInputRequired(field)" md-autofocus="$first" ng-focus="vm.currentFocusedField = field.field" \nng-change="vm.handleFieldChange(field);" ng-disabled="field.validation.disabledCriteria"></md-datepicker></div><div \nng-messages="vm.editForm[field.field].$error" class="form-date-error" role="alert" multiple="multiple"><div \nng-message="required">{{field.validation.messages.isRequired | translate}}</div><div ng-message="pattern">\n{{field.validation.messages.pattern | translate}}</div></div></div><div ng-switch-when="date-utc" layout="column" flex>\n<md-checkbox ng-model="vm.checked[field.field]" aria-label="field.field" ng-hide="field.validation.disabledCriteria" \nng-change="vm.checkBoxChanged(field.field)"></md-checkbox><div layout="column"><label class="md-caption" \nng-class="vm.isInputRequired(field) && vm.editForm[field.field].$invalid ? \'form-date-error\': \'\'">\n{{field.displayLabel | translate}}</label><md-datepicker name="{{field.field}}" ng-model="vm.record[field.field]" \nng-init="vm.record[field.field] = vm.getDateObj(vm.record[field.field], field, true)" md-placeholder="" \nng-required="vm.isInputRequired(field)" md-autofocus="$first" ng-focus="vm.currentFocusedField = field.field" \nng-change="vm.handleFieldChange(field);" ng-disabled="field.validation.disabledCriteria"></md-datepicker></div><div \nng-messages="vm.editForm[field.field].$error" class="form-date-error" role="alert" multiple="multiple"><div \nng-message="required">{{field.validation.messages.isRequired | translate}}</div><div ng-message="pattern">\n{{field.validation.messages.pattern | translate}}</div></div></div><div ng-switch-when="date-option" layout="column" \nflex><span ng-if="field.IsSeasonless && field.editable" class="attribute-criteria-icon"><md-tooltip><span>\n{{ \'MESSAGES.CONTENT.SEASONLESS_ATTRIBUTE_INFO_MESSAGE\' | translate }}</span></md-tooltip></span><div \nclass="external-change-message" \nng-if="field.isAllowChangeRequestEnabled && !vm.isNew && field.updateArticleChangeManagementExternalURL !== \'\'"><span>\n{{ \'MESSAGES.CONTENT.NON_EDITABLE_STATE_ATTRIBUTE\' | translate }} <a \nhref="{{field.updateArticleChangeManagementExternalURL}}" target="_blank">here</a></span></div><md-checkbox \nng-model="vm.checked[field.field]" aria-label="field.field" ng-hide="field.validation.disabledCriteria" \nng-change="vm.checkBoxChanged(field.field)"></md-checkbox><div layout="column"><label class="md-caption" \nng-class="vm.editForm[field.field].$invalid ? \'form-date-error\': \'\'">{{field.displayLabel | translate}}</label>\n<md-datepicker name="{{field.field}}" ng-model="vm.record[field.field]" \nng-init="vm.record[field.field] = vm.getDateObj(vm.record[field.field], field)" md-placeholder="" \nng-required="vm.isInputRequired(field)" md-autofocus="$first" ng-focus="vm.currentFocusedField = field.field" \nng-change="vm.handleFieldChange(field);" ng-disabled="field.validation.disabledCriteria"></md-datepicker></div><div \nng-messages="vm.editForm[field.field].$error" class="form-date-error" role="alert" multiple="multiple"><div \nng-message="required">{{field.validation.messages.isRequired | translate}}</div><div ng-message="pattern">\n{{field.validation.messages.pattern | translate}}</div></div></div><div ng-switch-when="icon" layout="row"></div><div \nng-switch-when="bool" layout="row"><md-checkbox ng-model="vm.checked[field.field]" aria-label="field.field" \nng-hide="{{field.validation.disabledCriteria || (field.showInEdit && !field.editable)}}" \nng-change="vm.checkBoxChanged(field.field)"></md-checkbox><md-switch ng-model="vm.record[field.field]" \naria-label="{{field.displayLabel | translate}}" \nng-disabled="{{field.validation.disabledCriteria || (field.showInEdit && !field.editable)}}" ng-true-value="true" \nng-false-value="false" class="md-accent" md-autofocus="$first" ng-focus="vm.currentFocusedField = field.field" \nng-change="vm.handleFieldChange(field);">{{field.displayLabel | translate}}</md-switch></div><div \nng-switch-when="bool-str" layout="row"><span ng-if="field.IsSeasonless && field.editable" \nclass="attribute-criteria-icon"><md-tooltip><span>\n{{ \'MESSAGES.CONTENT.SEASONLESS_ATTRIBUTE_INFO_MESSAGE\' | translate }}</span></md-tooltip></span><div \nclass="external-change-message" \nng-if="field.isAllowChangeRequestEnabled && !vm.isNew && field.updateArticleChangeManagementExternalURL !== \'\'"><span>\n{{ \'MESSAGES.CONTENT.NON_EDITABLE_STATE_ATTRIBUTE\' | translate }} <a \nhref="{{field.updateArticleChangeManagementExternalURL}}" target="_blank">here</a></span></div><md-checkbox \nng-model="vm.checked[field.field]" aria-label="field.field" \nng-hide="{{field.validation.disabledCriteria || (field.showInEdit && !field.editable)}}" \nng-change="vm.checkBoxChanged(field.field)"></md-checkbox><md-switch ng-model="vm.record[field.field]" \naria-label="{{field.displayLabel | translate}}" \nng-disabled="{{field.validation.disabledCriteria || (field.showInEdit && !field.editable)}}" ng-true-value="\'true\'" \nng-false-value="\'false\'" class="md-accent" md-autofocus="$first" ng-focus="vm.currentFocusedField = field.field" \nng-change="vm.handleFieldChange(field);">{{field.displayLabel | translate}}</md-switch></div><div \nng-switch-when="bool-int" layout="row"><md-checkbox ng-model="vm.checked[field.field]" aria-label="field.field" \nng-hide="{{field.validation.disabledCriteria || (field.showInEdit && !field.editable)}}" \nng-change="vm.checkBoxChanged(field.field)"></md-checkbox><md-switch ng-model="vm.record[field.field]" \naria-label="{{field.displayLabel | translate}}" \nng-disabled="{{field.validation.disabledCriteria || (field.showInEdit && !field.editable)}}" ng-true-value="1" \nng-false-value="0" class="md-accent" md-autofocus="$first" ng-focus="vm.currentFocusedField = field.field" \nng-change="vm.handleFieldChange(field);">{{field.displayLabel | translate}}</md-switch></div><div \nng-switch-when="int-bool" layout="row"><md-checkbox ng-model="vm.checked[field.field]" aria-label="field.field" \nng-hide="{{field.validation.disabledCriteria || (field.showInEdit && !field.editable)}}" \nng-change="vm.checkBoxChanged(field.field)"></md-checkbox><md-switch ng-model="vm.record[field.field]" \naria-label="{{field.displayLabel | translate}}" \nng-disabled="{{field.validation.disabledCriteria || (field.showInEdit && !field.editable)}}" ng-true-value="\'1\'" \nng-false-value="\'0\'" class="md-accent" md-autofocus="$first" ng-focus="vm.currentFocusedField = field.field" \nng-change="vm.handleFieldChange(field);">{{field.displayLabel | translate}}</md-switch></div><div \nng-switch-when="list" layout="column"><span ng-if="field.IsSeasonless && field.editable" \nclass="attribute-criteria-icon"><md-tooltip><span>\n{{ \'MESSAGES.CONTENT.SEASONLESS_ATTRIBUTE_INFO_MESSAGE\' | translate }}</span></md-tooltip></span><div \nclass="external-change-message" \nng-if="field.isAllowChangeRequestEnabled && !vm.isNew && field.updateArticleChangeManagementExternalURL !== \'\'"><span>\n{{ \'MESSAGES.CONTENT.NON_EDITABLE_STATE_ATTRIBUTE\' | translate }} <a \nhref="{{field.updateArticleChangeManagementExternalURL}}" target="_blank">here</a></span></div><span \nng-if="field.isCriteriaAdded" class="attribute-criteria-icon"><md-tooltip><span>{{ field.criteriaDisplayMessage }}\n</span></md-tooltip></span><md-checkbox ng-model="vm.checked[field.field]" aria-label="field.field" \nng-hide="{{field.validation.disabledCriteria || (field.showInEdit && !field.editable)}}" \nng-change="vm.checkBoxChanged(field.field)"></md-checkbox><md-input-container class="md-block"><label translate>\n{{field.displayLabel}}</label><md-select name="{{field.field}}" placeholder="{{field.displayLabel | translate}}" \nng-model="vm.record[field.field]" style="min-width: 200px" ng-required="vm.isInputRequired(field)" \nng-disabled="{{field.validation.disabledCriteria || (field.showInEdit && !field.editable)}}" md-autofocus="$first" \nng-focus="vm.currentFocusedField = field.field; field.isCriteriaAdded ? vm.getConditionalVettingList(field) : \'\'" \nng-change="vm.handleFieldChange(field)"><md-option md-option-empty \nng-if="!field.validation.isRequired && field.type !== \'int\'" ng-value="\'\'"><em>None</em></md-option><md-option \nng-if="!field.validation.isRequired && field.type === \'int\'" ng-value="0"><em>0</em></md-option><md-option \nng-value="option" ng-repeat="option in (field.values | mdSelectUniqueoptions)">{{ option }}</md-option></md-select><div\n ng-messages="vm.editForm[field.field].$error" role="alert" multiple="multiple"><div ng-message="required">\n{{field.validation.messages.isRequired | translate}}</div></div></md-input-container></div><div \nng-switch-when="lookup" class="lookup-element"><md-checkbox ng-model="vm.checked[field.field]" \naria-label="field.field" ng-hide="{{field.validation.disabledCriteria || (field.showInEdit && !field.editable)}}" \nng-change="vm.checkBoxChanged(field.field)"></md-checkbox><md-autocomplete \nid="dialog_input_{{$first ? \'first\' : $index}}" md-input-name="{{field.field}}" \nmd-selected-item="vm.record[field.field]" md-items="item in vm.lookupSearch(vm.searchText[field.field], field)" \nmd-search-text="vm.searchText[field.field]" md-item-text="vm.getLookupDisplayValue(item, field)" md-min-length="0" \nmd-floating-label="{{field.displayLabel | translate}}" \nmd-selected-item-change="vm.lookupChange(vm.record[field.field], field.field, field)" \nng-required="vm.isInputRequired(field)" md-autofocus="$first" md-no-cache="true" tx-clear-autocomplete \nng-click="vm.selectText($event)" md-menu-class="autocomplete-custom" \nng-disabled="{{field.validation.disabledCriteria || (field.showInEdit && !field.editable && !vm.isNew)}}">\n<md-item-template><span class="autocomplete-item md-accent-fg" ng-if="field.field !== \'ColorId\'" \nmd-highlight-text="vm.searchText[field.field]" md-highlight-flags="i">{{item.value}}</span> <span \nclass="autocomplete-item md-accent-fg" ng-if="field.field === \'ColorId\'" \nmd-highlight-text="vm.searchText[field.field]" md-highlight-flags="i">\n{{ vm.showColorTypeInColorPalatteDropdown ? item.ColorTypeName : item.value}}</span> <span \nclass="autocomplete-item color-box" ng-show="item.ColorCode != null && field.showColorBox" \nng-style="{\'background-color\': item.ColorCode}"></span></md-item-template><div \nng-messages="vm.editForm[field.field].$error" role="alert" ng-show="vm.editForm[field.field].$touched"><div \nng-message="required">{{field.validation.messages.isRequired | translate}}</div></div><md-not-found>\nNo Record matching "{{vm.searchText[field.field]}}" were found.</md-not-found><div class="info-for-first-100-records" \nng-if="field.isAboveDropDownLimit && !(field.validation.disabledCriteria || (field.showInEdit && !field.editable && !vm.isNew))">\n<md-icon class="icon s14" md-font-icon="icon-information-outline"></md-icon><span>\n{{\'MESSAGES.CONTENT.SHOW_FIRST_100\' | translate}}</span></div></md-autocomplete></div><div \nng-switch-when="lookup-many" layout="row"><md-checkbox ng-model="vm.checked[field.field]" aria-label="field.field" \nng-hide="{{field.validation.disabledCriteria || (field.showInEdit && !field.editable)}}" \nng-change="vm.checkBoxChanged(field.field)"></md-checkbox><md-input-container class="md-block"><label translate>\n{{field.displayLabel}}</label><md-chips id="dialog_bulk_updater_{{$first ? \'first\' : $index}}" name="{{field.field}}" \nng-model="vm.record[field.field]" md-autocomplete-snap md-transform-chip="vm.transformChip($chip)" \nmd-require-match="true" ng-required="vm.isInputRequired(field)"><md-autocomplete \nmd-selected-item="vm.acSelectedItem[field.field]" md-search-text="vm.acSearchText[field.field]" \nmd-items="item in vm.acQuerySearch(vm.acSearchText[field.field], field.lookupSource, vm.record[field.field]) | filter: field.lookupFilter" \nmd-item-text="item.value" ng-disabled="{{field.validation.disabledCriteria || (field.showInEdit && !field.editable)}}" \nmd-min-length="0" md-no-cache="true" md-autofocus="$first" \nmd-selected-item-change="vm.handleFieldChange(field, true);" md-menu-class="autocomplete-custom"><md-item-template>\n<span class="autocomplete-item md-accent-fg" md-highlight-text="vm.acSearchText[field.field]">{{item.value}}</span>\n</md-item-template></md-autocomplete><md-chip-template><span><strong>\n{{vm.getChipDisplayValue($chip, field.lookupSource)}}</strong></span></md-chip-template></md-chips><div \nclass="md-chips-messages" ng-messages="vm.editForm[field.field].$error" \nng-show="vm.editForm[field.field].$dirty || vm.editForm[field.field].$submitted"><div ng-message="required">\n{{field.validation.messages.isRequired | translate}}</div></div></md-input-container></div><div \nng-switch-when="dataset" class="lookup-element"><md-checkbox ng-model="vm.checked[field.field]" \naria-label="field.field" ng-hide="{{field.validation.disabledCriteria || (field.showInEdit && !field.editable)}}" \nng-change="vm.checkBoxChanged(field.field)"></md-checkbox><tx-dataset-autocomplete tx-field="field" \ntx-data="vm.record" tx-new="vm.isNew" tx-is-update-bulk="true"></tx-dataset-autocomplete></div><div \nng-switch-when="datatable"><md-checkbox ng-model="vm.checked[field.field]" aria-label="field.field" \nng-hide="{{field.validation.disabledCriteria || (field.showInEdit && !field.editable)}}" \nng-change="vm.checkBoxChanged(field.field)"></md-checkbox><span ng-if="field.IsSeasonless && field.editable" \nclass="attribute-criteria-icon"><md-tooltip><span>\n{{ \'MESSAGES.CONTENT.SEASONLESS_ATTRIBUTE_INFO_MESSAGE\' | translate }}</span></md-tooltip></span><tx-ui-grid \ntx-field="field" tx-data="vm.record" tx-new="vm.isNew" tx-editable="vm.isNew || (!vm.isNew && field.editable)">\n</tx-ui-grid></div><div ng-switch-when="multi-value" layout="row"><span ng-if="field.IsSeasonless && field.editable" \nclass="attribute-criteria-icon"><md-tooltip><span>\n{{ \'MESSAGES.CONTENT.SEASONLESS_ATTRIBUTE_INFO_MESSAGE\' | translate }}</span></md-tooltip></span><span \nng-if="field.isCriteriaAdded" class="attribute-criteria-icon"><md-tooltip><span>{{ field.criteriaDisplayMessage }}\n</span></md-tooltip></span><div class="external-change-message" \nng-if="field.isAllowChangeRequestEnabled && !vm.isNew && field.updateArticleChangeManagementExternalURL !== \'\'"><span>\n{{ \'MESSAGES.CONTENT.NON_EDITABLE_STATE_ATTRIBUTE\' | translate }} <a \nhref="{{field.updateArticleChangeManagementExternalURL}}" target="_blank">here</a></span></div><md-checkbox \nng-model="vm.checked[field.field]" aria-label="field.field" \nng-hide="{{field.validation.disabledCriteria || (field.showInEdit && !field.editable)}}" \nng-change="vm.checkBoxChanged(field.field)"></md-checkbox><md-input-container class="md-block"><label translate>\n{{field.displayLabel}}<span ng-if="vm.isInputRequired(field)" md-colors="{color: \'red\'}">*</span></label><md-chips \nid="dialog_bulk_updater_{{$first ? \'first\' : $index}}" name="{{field.field}}" ng-model="vm.record[field.field]" \nmd-autocomplete-snap md-transform-chip="vm.transformChip($chip, true)" md-require-match="true" \nng-required="vm.isInputRequired(field)"><md-autocomplete md-selected-item="vm.acSelectedItem[field.field]" \nmd-search-text="vm.acSearchText[field.field]" \nmd-items="item in vm.multiValueQuerySearch(vm.acSearchText[field.field], vm.record[field.field], field)" \nmd-item-text="item" ng-disabled="{{field.validation.disabledCriteria || (field.showInEdit && !field.editable)}}" \nmd-min-length="0" md-no-cache="true" ng-focus="vm.currentFocusedField = field.field" \nmd-selected-item-change="vm.handleFieldChange(field);" md-menu-class="autocomplete-custom"><md-item-template><span \nclass="autocomplete-item md-accent-fg" md-highlight-text="vm.acSearchText[field.field]">{{item}}</span>\n</md-item-template><md-not-found>No Record matching "{{vm.acSearchText[field.field]}}" were found.</md-not-found>\n</md-autocomplete><md-chip-template><span><strong>{{$chip}}</strong></span></md-chip-template></md-chips>\n</md-input-container></div><div ng-switch-when="tags"><div class="external-change-message" \nng-if="field.isAllowChangeRequestEnabled && !vm.isNew && field.updateArticleChangeManagementExternalURL !== \'\'"><span>\n{{ \'MESSAGES.CONTENT.NON_EDITABLE_STATE_ATTRIBUTE\' | translate }} <a \nhref="{{field.updateArticleChangeManagementExternalURL}}" target="_blank">here</a></span></div><md-checkbox \nng-model="vm.checked[field.field]" aria-label="field.field" \nng-hide="{{field.validation.disabledCriteria || (field.showInEdit && !field.editable)}}" \nng-change="vm.checkBoxChanged(field.field)"></md-checkbox><label>{{field.displayLabel | translate}}<span \nng-if="vm.isInputRequired(field)" md-colors="{color: \'red\'}">*</span></label><md-input-container class="md-block">\n<md-chips name="{{field.field}}" id="dialog_input_{{$first ? \'first\' : $index}}" ng-model="vm.record[field.field]" \nplaceholder="{{\'ACTIONS.ADD_TAGS\' | translate}}" secondary-placeholder="{{\'ACTIONS.ADD_TAGS\' | translate}}" \nmd-enable-chip-edit="true" md-max-chips="{{vm.maxTags}}" \nmd-on-add="vm.add($chip, vm.record[field.field], field); vm.isElementDirty(field.field);" \nmd-separator-keys="vm.tagSeperatorKeys[field.field]" ng-required="vm.isInputRequired(field)" \nreadonly="field.validation.disabledCriteria || (field.showInEdit && !field.editable && !vm.isNew)" \nng-change="vm.handleFieldChange(field, true);"></md-chips><div class="md-chips-messages" \nng-messages="vm.editForm[field.field].$error" \nng-show="vm.editForm[field.field].$dirty || vm.editForm[field.field].$submitted" multiple="multiple"><div \nng-message="required">{{field.validation.messages.isRequired | translate}}</div><div ng-message="md-max-chips">\n{{field.validation.messages.maxLen | translate}}</div></div><div ng-if="vm.add($chip, vm.record[field.field], field)" \nclass="error-message display-error">{{ vm.ErrorMessage}}</div></md-input-container></div><div ng-switch-when="switch" \nlayout="row" layout-wrap layout-align="space-between center"><div layout="row" layout-wrap \nflex="{{ vm.isSegmentationPlanningEnable || vm.model.modelPath === \'catalogs.crds\'}} ? 50 : 100" flex-xs="100">\n<md-checkbox ng-model="vm.checked[field.field]" aria-label="field.field" \nng-hide="{{field.validation.disabledCriteria || (field.showInEdit && !field.editable)}}" \nng-change="vm.checkBoxChanged(field.field)"></md-checkbox><md-switch ng-model="vm.record[field.field]" \naria-label="{{field.displayLabel | translate}}" \nng-disabled="{{field.validation.disabledCriteria || (field.showInEdit && !field.editable)}}" ng-true-value="\'Yes\'" \nng-false-value="\'No\'" class="md-accent" md-autofocus="$first" ng-change="vm.handleFieldChange(field, true);">\n{{field.displayLabel | translate | ampersand }} <span class="switch-val" \nng-if="vm.checked[field.field] && !vm.isSegmentationPlanningEnable">{{vm.record[field.field]}}</span></md-switch></div>\n<md-input-container \nng-if="vm.isSegmentationPlanningEnable && vm.record[field.field] != \'No\' && vm.record[field.field] != \'Not Available\'" \nclass="md-block, p-5 no-margin" flex="50" flex-xs="100"><label translate>SEGMENTATION.FIELDS.PLANNING_VALUE</label>\n<md-select ng-model="vm.record[field.field+\'PlanningValue\']" \nplaceholder="{{\'SEGMENTATION.FIELDS.PLANNING_VALUE\' | translate}}" ng-change="vm.onPlanningValueChange(field.field)" \nrequired><md-option ng-repeat="planningValue in vm.planningValue" ng-value="planningValue">{{planningValue}}\n</md-option></md-select></md-input-container><div type="text" flex="50" ng-if="vm.model.modelPath === \'catalogs.crds\'" \nclass="md-block p-5 text-truncate">{{ vm.record[field.field + \'Description\'] }}<md-tooltip>\n{{ vm.record[field.field + \'Description\'] }}</md-tooltip></div></div><div ng-switch-when="target-attributes-json-str" \nlayout="row"><md-checkbox ng-model="vm.checked[field.field]" aria-label="field.field" \nng-hide="{{field.validation.disabledCriteria || (field.showInEdit && !field.editable)}}" \nng-change="vm.checkBoxChanged(field.field)"></md-checkbox><md-input-container class="md-block"><label translate>\n{{field.displayLabel}}</label><input name="{{field.field}}" ng-model="vm.record[field.field]" type="text" \nng-required="vm.isInputRequired(field)" md-maxlength="{{field.validation.maxLen}}" \nng-disabled="{{field.validation.disabledCriteria || (field.showInEdit && !field.editable)}}" md-autofocus="$first" \npattern="{{field.validation.pattern}}" ng-change="vm.handleFieldChange(field, true);"><div \nng-messages="vm.editForm[field.field].$error" role="alert" multiple="multiple"><div ng-message="required">\n{{field.validation.messages.isRequired | translate}}</div><div ng-message="pattern">\n{{field.validation.messages.pattern | translate}}</div><div ng-message="md-maxlength">\n{{field.validation.messages.maxLen | translate}}</div></div></md-input-container></div><div ng-switch-when="decimal">\n<span ng-if="field.IsSeasonless && field.editable" class="attribute-criteria-icon"><md-tooltip><span>\n{{ \'MESSAGES.CONTENT.SEASONLESS_ATTRIBUTE_INFO_MESSAGE\' | translate }}</span></md-tooltip></span><div \nclass="external-change-message" \nng-if="field.isAllowChangeRequestEnabled && !vm.isNew && field.updateArticleChangeManagementExternalURL !== \'\'"><span>\n{{ \'MESSAGES.CONTENT.NON_EDITABLE_STATE_ATTRIBUTE\' | translate }} <a \nhref="{{field.updateArticleChangeManagementExternalURL}}" target="_blank">here</a></span></div><md-checkbox \nng-model="vm.checked[field.field]" aria-label="field.field" \nng-hide="{{field.validation.disabledCriteria || (field.showInEdit && !field.editable)}}" \nng-change="vm.checkBoxChanged(field.field)"></md-checkbox><md-input-container class="md-block"><label translate>\n{{field.displayLabel}}</label><input name="{{field.field}}" ng-model="vm.record[field.field]" type="number" \nng-required="vm.isInputRequired(field)" md-maxlength="{{field.validation.maxLen}}" \nng-disabled="{{field.validation.disabledCriteria || (field.showInEdit && !field.editable)}}" md-autofocus="$first" \npattern="{{field.validation.pattern}}" ng-focus="vm.currentFocusedField = field.field" \nng-change="vm.handleFieldChange(field);"><div ng-messages="vm.editForm[field.field].$error" role="alert" \nmultiple="multiple"><div ng-message="required">{{field.validation.messages.isRequired | translate}}</div><div \nng-message="pattern">{{field.validation.messages.pattern | translate}}</div><div ng-message="md-maxlength">\n{{field.validation.messages.maxLen | translate}}</div></div></md-input-container></div><div \nng-switch-when="color-picker" layout="row" class="color-picker"><md-checkbox ng-model="vm.checked[field.field]" \naria-label="field.field" ng-hide="{{field.validation.disabledCriteria || (field.showInEdit && !field.editable)}}" \nng-change="vm.checkBoxChanged(field.field)"></md-checkbox><md-input-container class="md-block"><label translate>\n{{field.displayLabel}}</label><input name="{{field.field}}" ng-model="vm.record[field.field]" type="text" \nng-required="vm.isInputRequired(field)" \nng-disabled="{{field.validation.disabledCriteria || (field.showInEdit && !field.editable)}}" \nmd-maxlength="{{field.validation.maxLen}}" pattern="{{field.validation.pattern}}" \nng-change="vm.handleFieldChange(field);"><div ng-messages="vm.editForm[field.field].$error" role="alert" \nmultiple="multiple"><div ng-message="required">{{field.validation.messages.isRequired | translate}}</div><div \nng-message="pattern">{{field.validation.messages.pattern | translate}}</div><div ng-message="md-maxlength">\n{{field.validation.messages.maxLen | translate}}</div></div></md-input-container><input \nng-model="vm.record[field.field]" class="picker" name="colorPicker" type="color" \nng-disabled="{{field.validation.disabledCriteria || (field.showInEdit && !field.editable)}}"></div><div \nng-switch-when="articlenumber" class="lookup-element"><md-checkbox ng-model="vm.checked[field.field]" \naria-label="field.field" ng-hide="{{field.validation.disabledCriteria || (field.showInEdit && !field.editable)}}" \nng-change="vm.checkBoxChanged(field.field)"></md-checkbox><md-autocomplete \nid="dialog_input_{{$first ? \'first\' : $index}}" md-input-name="{{field.field}}" \nmd-selected-item="vm.record[field.field]" md-items="item in vm.lookupSearch(vm.searchText[field.field], field)" \nmd-search-text="vm.searchText[field.field]" md-item-text="vm.getLookupDisplayValue(item, field, true)" \nmd-min-length="0" md-floating-label="{{field.displayLabel | translate}}" \nmd-selected-item-change="vm.lookupChange(vm.record[field.field], field.field, field)" \nng-required="vm.isInputRequired(field)" md-autofocus="$first" md-no-cache="true" tx-clear-autocomplete \nng-click="vm.selectText($event)" md-menu-class="autocomplete-custom" \nng-disabled="{{field.validation.disabledCriteria || (field.showInEdit && !field.editable && !vm.isNew)}}">\n<md-item-template><span class="autocomplete-item md-accent-fg" md-highlight-text="vm.searchText[field.field]" \nmd-highlight-flags="i">{{item.value}}</span></md-item-template><div ng-messages="vm.editForm[field.field].$error" \nrole="alert" ng-show="vm.editForm[field.field].$touched"><div ng-message="required">\n{{field.validation.messages.isRequired | translate}}</div></div><md-not-found>\nNo Record matching "{{vm.searchText[field.field]}}" were found.</md-not-found><div class="info-for-first-100-records" \nng-if="field.isAboveDropDownLimit && !(field.validation.disabledCriteria || (field.showInEdit && !field.editable && !vm.isNew))">\n<md-icon class="icon s14" md-font-icon="icon-information-outline"></md-icon><span>\n{{\'MESSAGES.CONTENT.SHOW_FIRST_100\' | translate}}</span></div></md-autocomplete></div><div \nng-switch-when="linkedcatalogarticlenumber" layout="row" class="linked-article-attribute"><md-checkbox \nng-model="vm.checked[field.field]" aria-label="field.field" \nng-hide="{{field.validation.disabledCriteria || (field.showInEdit && !field.editable)}}" \nng-change="vm.checkBoxChanged(field.field)"></md-checkbox><din><label>{{field.displayLabel | translate}}</label>\n<tx-linked-article-viewer tx-field="field" tx-data="vm.record" tx-new="false"></tx-linked-article-viewer></din></div>\n<div ng-switch-when="color-palette" layout="column" class="lookup-element"><span \nng-if="field.IsSeasonless && field.editable" class="attribute-criteria-icon"><md-tooltip><span>\n{{ \'MESSAGES.CONTENT.SEASONLESS_ATTRIBUTE_INFO_MESSAGE\' | translate }}</span></md-tooltip></span><div \nclass="external-change-message" \nng-if="field.isAllowChangeRequestEnabled && !vm.isNew && field.updateArticleChangeManagementExternalURL !== \'\'"><span>\n{{ \'MESSAGES.CONTENT.NON_EDITABLE_STATE_ATTRIBUTE\' | translate }} <a \nhref="{{field.updateArticleChangeManagementExternalURL}}" target="_blank">here</a></span></div><span \nng-if="field.isCriteriaAdded" class="attribute-criteria-icon"><md-tooltip><span>{{ field.criteriaDisplayMessage }}\n</span></md-tooltip></span><md-checkbox ng-model="vm.checked[field.field]" aria-label="field.field" \nng-hide="{{field.validation.disabledCriteria || (field.showInEdit && !field.editable)}}" \nng-change="vm.checkBoxChanged(field.field)"></md-checkbox><md-autocomplete \nid="dialog_input_{{$first ? \'first\' : $index}}" md-input-name="{{field.field}}" \nmd-selected-item="vm.record[field.field]" md-items="item in vm.lookupSearch(vm.searchText[field.field], field)" \nmd-search-text="vm.searchText[field.field]" md-item-text="vm.getCustomLookupDisplayValue(item, field)" \nmd-min-length="0" md-floating-label="{{field.displayLabel | translate}}" \nmd-selected-item-change="vm.colorPaletteLookupChange(vm.record[field.field], field)" \nng-required="vm.isInputRequired(field)" md-autofocus="$first" md-no-cache="true" tx-clear-autocomplete \nng-click="vm.selectText($event)" md-menu-class="autocomplete-custom" \nng-disabled="{{field.validation.disabledCriteria || (field.showInEdit && !field.editable && !vm.isNew)}}">\n<md-item-template><span class="autocomplete-item md-accent-fg" md-highlight-text="vm.searchText[field.field]" \nmd-highlight-flags="i">{{ vm.showColorTypeInColorPalatteDropdown ? item.ColorTypeName : item.value}}</span>\n</md-item-template><div ng-messages="vm.editForm[field.field].$error" role="alert" \nng-show="vm.editForm[field.field].$touched"><div ng-message="required">\n{{field.validation.messages.isRequired | translate}}</div></div><md-not-found>\nNo Record matching "{{vm.searchText[field.field]}}" were found.</md-not-found><div class="info-for-first-100-records" \nng-if="field.isAboveDropDownLimit && !(field.validation.disabledCriteria || (field.showInEdit && !field.editable && !vm.isNew))">\n<md-icon class="icon s14" md-font-icon="icon-information-outline"></md-icon><span>\n{{\'MESSAGES.CONTENT.SHOW_FIRST_100\' | translate}}</span></div></md-autocomplete></div><div \nng-switch-when="modelnumber" class="lookup-element"><md-checkbox ng-model="vm.checked[field.field]" \naria-label="field.field" ng-hide="{{field.validation.disabledCriteria || (field.showInEdit && !field.editable)}}" \nng-change="vm.checkBoxChanged(field.field)"></md-checkbox><md-autocomplete \nid="dialog_input_{{$first ? \'first\' : $index}}" md-input-name="{{field.field}}" \nmd-selected-item="vm.record[field.field]" md-items="item in vm.lookupSearch(vm.searchText[field.field], field)" \nmd-search-text="vm.searchText[field.field]" md-item-text="vm.getLookupDisplayValue(item, field, true)" \nmd-min-length="0" md-floating-label="{{field.displayLabel | translate}}" \nmd-selected-item-change="vm.lookupChange(vm.record[field.field], field.field, field)" \nng-required="vm.isInputRequired(field)" md-autofocus="$first" md-no-cache="true" tx-clear-autocomplete \nng-click="vm.selectText($event)" md-menu-class="autocomplete-custom" \nng-disabled="{{field.validation.disabledCriteria || (field.showInEdit && !field.editable && !vm.isNew)}}">\n<md-item-template><span class="autocomplete-item md-accent-fg" md-highlight-text="vm.searchText[field.field]" \nmd-highlight-flags="i">{{item.value}}</span></md-item-template><div ng-messages="vm.editForm[field.field].$error" \nrole="alert" ng-show="vm.editForm[field.field].$touched"><div ng-message="required">\n{{field.validation.messages.isRequired | translate}}</div></div><md-not-found>\nNo Record matching "{{vm.searchText[field.field]}}" were found.</md-not-found><div class="info-for-first-100-records" \nng-if="field.isAboveDropDownLimit && !(field.validation.disabledCriteria || (field.showInEdit && !field.editable && !vm.isNew))">\n<md-icon class="icon s14" md-font-icon="icon-information-outline"></md-icon><span>\n{{\'MESSAGES.CONTENT.SHOW_FIRST_100\' | translate}}</span></div></md-autocomplete></div><div \nng-switch-when="parent-model-type"><md-checkbox ng-model="vm.checked[field.field]" aria-label="field.field" \nng-hide="{{field.validation.disabledCriteria || (field.showInEdit && !field.editable)}}" \nng-change="vm.checkBoxChanged(field.field)"></md-checkbox><tx-parent-model-type-viewer tx-field="field" \ntx-data="vm.record" tx-new="vm.isNew" tx-visible-fields="vm.editableFields" tx-is-update-bulk="true">\n</tx-parent-model-type-viewer></div><div ng-switch-when="lookup-table"><span ng-if="field.isLookupAdded" \nclass="attribute-criteria-icon"><md-tooltip><span>{{ field.lookupDisplayMessage }}</span></md-tooltip></span>\n<md-input-container class="md-block"><label>{{field.displayLabel | translate}}</label><input \nid="dialog_input_{{$first ? \'first\' : $index}}" name="{{field.field}}" ng-model="vm.record[field.field]" type="text" \nng-required="vm.isInputRequired(field)" ng-disabled="true" md-autofocus="$first"><div \nng-messages="vm.editForm[field.field].$error" role="alert" multiple="multiple"><div ng-message="required">\n{{field.validation.messages.isRequired | translate}}</div></div></md-input-container></div><div \nng-switch-when="number" layout="row" class="display-block"><span ng-if="field.IsSeasonless && field.editable" \nclass="attribute-criteria-icon"><md-tooltip><span>\n{{ \'MESSAGES.CONTENT.SEASONLESS_ATTRIBUTE_INFO_MESSAGE\' | translate }}</span></md-tooltip></span><div \nclass="external-change-message" \nng-if="field.isAllowChangeRequestEnabled && !vm.isNew && field.updateArticleChangeManagementExternalURL !== \'\'"><span>\n{{ \'MESSAGES.CONTENT.NON_EDITABLE_STATE_ATTRIBUTE\' | translate }} <a \nhref="{{field.updateArticleChangeManagementExternalURL}}" target="_blank">here</a></span></div><md-checkbox \nng-model="vm.checked[field.field]" aria-label="field.field" \nng-hide="{{field.validation.disabledCriteria || (field.showInEdit && !field.editable)}}" \nng-change="vm.checkBoxChanged(field.field)"></md-checkbox><md-input-container class="md-block"><label translate>\n{{field.displayLabel}}</label><input name="{{field.field}}" ng-model="vm.record[field.field]" \ntype="{{field.inputType}}" ng-required="vm.isInputRequired(field)" tx-integer-value \nmd-maxlength="{{field.validation.maxLen}}" \nng-disabled="{{field.validation.disabledCriteria || (field.showInEdit && !field.editable)}}" md-autofocus="$first" \npattern="{{field.validation.pattern}}" ng-focus="vm.currentFocusedField = field.field" \nng-change="vm.handleFieldChange(field);"><div ng-messages="vm.editForm[field.field].$error" role="alert" \nmultiple="multiple"><div ng-message="required">{{field.validation.messages.isRequired | translate}}</div><div \nng-message="pattern">{{field.validation.messages.pattern | translate}}</div><div ng-message="md-maxlength">\n{{field.validation.messages.maxLen | translate}}</div><div ng-message="tx-integer-value">\n{{\'VALIDATIONS.INVALID_INTEGER\' | translate}}</div></div></md-input-container></div><div ng-switch-default \nlayout="row" class="display-block"><span ng-if="field.IsSeasonless && field.editable" class="attribute-criteria-icon">\n<md-tooltip><span>{{ \'MESSAGES.CONTENT.SEASONLESS_ATTRIBUTE_INFO_MESSAGE\' | translate }}</span></md-tooltip></span><div\n class="external-change-message" \nng-if="field.isAllowChangeRequestEnabled && !vm.isNew && field.updateArticleChangeManagementExternalURL !== \'\'"><span>\n{{ \'MESSAGES.CONTENT.NON_EDITABLE_STATE_ATTRIBUTE\' | translate }} <a \nhref="{{field.updateArticleChangeManagementExternalURL}}" target="_blank">here</a></span></div><md-checkbox \nng-model="vm.checked[field.field]" aria-label="field.field" \nng-hide="{{field.validation.disabledCriteria || (field.showInEdit && !field.editable)}}" \nng-change="vm.checkBoxChanged(field.field)"></md-checkbox><md-input-container class="md-block"><label translate>\n{{field.displayLabel}}</label><input name="{{field.field}}" ng-model="vm.record[field.field]" \ntype="{{field.inputType}}" ng-required="vm.isInputRequired(field)" md-maxlength="{{field.validation.maxLen}}" \nng-disabled="{{field.validation.disabledCriteria || (field.showInEdit && !field.editable)}}" md-autofocus="$first" \npattern="{{field.validation.pattern}}" ng-focus="vm.currentFocusedField = field.field" \nng-change="vm.handleFieldChange(field);"><div ng-messages="vm.editForm[field.field].$error" role="alert" \nmultiple="multiple"><div ng-message="required">{{field.validation.messages.isRequired | translate}}</div><div \nng-message="pattern">{{field.validation.messages.pattern | translate}}</div><div ng-message="md-maxlength">\n{{field.validation.messages.maxLen | translate}}</div></div></md-input-container></div></div></div><div \nng-show="vm.checkingForLockedArticles" layout="column" layout-align="center center" flex="100"><md-progress-circular \nmd-mode="indeterminate" aria-label="Processing"></md-progress-circular></div></md-dialog-content><md-dialog-actions \nlayout="row" layout-align="end center"><div></div><div layout="row" layout-align="end center"><md-button \nng-click="vm.closeDialog()" class="send-button md-primary md-raised" aria-label="Cancel" \ntranslate="ACTIONS.DIALOG_CANCEL" translate-attr-aria-label="ACTIONS.DIALOG_CANCEL" ng-disabled="vm.isLoading">CANCEL\n</md-button><md-button ng-click="vm.saveRecord()" class="send-button md-accent md-raised" aria-label="Save" \ntranslate="ACTIONS.SAVE" translate-attr-aria-label="ACTIONS.SAVE" \nng-disabled="vm.isLoading || !vm.isFormValid() || !vm.isAnyFieldChecked()">SAVE</md-button></div></md-dialog-actions>\n</form></md-dialog>');
$templateCache.put('app/services/dataExporter/dataExporter.html','<md-dialog id="data-exporter" class="tx-dialog" aria-label="Details"><form name="editForm" class="md-inline-form">\n<md-toolbar class="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" layout-align="space-between center">\n<span class="title" translate="DATAEXPORTER.TITLE">Export Data</span><md-button class="md-icon-button" \nng-click="vm.closeDialog(false)" aria-label="Close dialog" tranlate translate-aria-label="ACTIONS.DIALOG_CLOSE">\n<md-icon md-font-icon="icon-close"></md-icon></md-button></div></md-toolbar><md-dialog-content layout="row" flex="100">\n<div ng-show="!vm.processing" flex layout="column"><span translate="DATAEXPORTER.SELECT"></span><md-select \nng-model="vm.selection" aria-label="Data Selection"><md-option value="0" aria-label="All" \ntranslate="DATAEXPORTER.SELECT_ALL" class="md-primary">All Records</md-option><md-option value="1" \naria-label="Filtered" translate="DATAEXPORTER.SELECT_FILTERED">Filtered Records</md-option><md-option value="2" \naria-label="Selected" translate="DATAEXPORTER.SELECT_SELECTED">Selected Records</md-option></md-select><md-select \nng-model="vm.columnsOption" aria-label="Column Selection" ng-change="vm.onColumnsOptionChange(vm.columnsOption)" \nng-if="!vm.isRequestModule"><md-option value="0" aria-label="All Columns" translate="DATAEXPORTER.ALL_COLUMNS" \nclass="md-primary">All Columns</md-option><md-option value="1" aria-label="Visible Columns" \ntranslate="DATAEXPORTER.VISIBLE_COLUMNS" class="md-primary">Visible Columns</md-option></md-select></div><div \nng-show="vm.processing" layout="column" layout-align="center center" flex="100"><span \ntranslate="DATAEXPORTER.PROCESSING"></span><md-progress-circular md-mode="indeterminate" aria-label="Processing">\n</md-progress-circular></div></md-dialog-content><md-dialog-actions layout="row" layout-align="end center"><div></div>\n<div layout="row" layout-align="end center"><md-button ng-click="vm.closeDialog(false)" \nclass="send-button md-primary md-raised" aria-label="Cancel" translate="ACTIONS.DIALOG_CANCEL" \ntranslate-attr-aria-label="ACTIONS.DIALOG_CANCEL" ng-disabled="vm.processing">CANCEL</md-button><md-button \nng-click="vm.doOk()" class="send-button md-accent md-raised" aria-label="Ok" translate="ACTIONS.OK" \ntranslate-attr-aria-label="ACTIONS.OK" ng-disabled="vm.processing">OK</md-button></div></md-dialog-actions></form>\n</md-dialog>');
$templateCache.put('app/services/dataImporter/dataImporter.html','<md-dialog id="data-importer" class="tx-dialog" aria-label="Details"><md-toolbar class="md-accent md-hue-2"><div \nclass="md-toolbar-tools" layout="row" layout-align="space-between center"><span class="title" \ntranslate="DATAIMPORTER.TITLE">Import Data</span><md-button class="md-icon-button" ng-click="vm.cancel()" \naria-label="Close dialog" tranlate translate-aria-label="ACTIONS.DIALOG_CLOSE"><md-icon md-font-icon="icon-close">\n</md-icon></md-button></div></md-toolbar><md-dialog-content><div layout="row" layout-align="center center" \nng-show="vm.isLoading"><md-progress-circular md-mode="indeterminate" class="md-accent"></md-progress-circular></div>\n<form name="stepper" ms-stepper ng-submit="vm.submitStepper()" ng-model="vm.stepper" novalidate \nng-show="!(vm.AllowExternalChangeManagement || vm.checkingForLockedArticles) && !vm.isLoading"><ms-stepper-step \nng-form="step1" step="1" step-title="\'File\'"><div ng-include="\'app/services/dataImporter/steps/step-1.html\'"></div>\n</ms-stepper-step><ms-stepper-step ng-form="step2" step="2" step-title="\'Sheet\'"><div \nng-include="\'app/services/dataImporter/steps/step-2.html\'"></div></ms-stepper-step><ms-stepper-step ng-form="step3" \nstep="3" step-title="\'Mapping\'"><div class="step3-div" ng-include="\'app/services/dataImporter/steps/step-3.html\'">\n</div></ms-stepper-step><ms-stepper-step ng-form="step4" step="4" step-title="\'Filter\'"><div \nng-include="\'app/services/dataImporter/steps/step-4.html\'"></div></ms-stepper-step><ms-stepper-step ng-form="step5" \nstep="5" step-title="\'Validation\'"><div ng-include="\'app/services/dataImporter/steps/step-5.html\'" \nclass="validation-height" ms-scroll></div></ms-stepper-step><ms-stepper-step ng-form="step6" step="6" \nstep-title="\'Information\'"><div ng-include="\'app/services/dataImporter/steps/step-6.html\'"></div></ms-stepper-step>\n</form><div ng-show="vm.checkingForLockedArticles" layout="column" layout-align="center center" flex="100">\n<md-progress-circular md-mode="indeterminate" aria-label="Processing"></md-progress-circular></div></md-dialog-content>\n</md-dialog>');
$templateCache.put('app/services/dialog/change-password.html','<md-dialog class="edit-dialog" aria-label="Details" flex="35"><form name="changePasswordForm" class="md-inline-form">\n<md-toolbar class="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" layout-align="space-between center">\n<span class="title" translate="MESSAGES.TITLE.CHANGE_PASSWORD">Change Password</span><md-button class="md-icon-button" \nng-click="vm.cancel()" aria-label="Close dialog" tranlate translate-aria-label="ACTIONS.DIALOG_CLOSE"><md-icon \nmd-font-icon="icon-close"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout="row" layout-wrap \nlayout-align="center space-around"><md-input-container class="md-block" flex="85"><label translate>FIELDS.OLD_PASSWORD\n</label><input name="oldPassword" ng-model="vm.record.oldPassword" type="password" required md-maxlength="20"><div \nng-messages="changePasswordForm.oldPassword.$error" role="alert" multiple="multiple"><div ng-message="required">\n{{\'VALIDATIONS.REQUIRED\' | translate}}</div><div ng-message="md-maxlength">{{\'VALIDATIONS.MAXLEN\' | translate}}</div>\n</div></md-input-container><md-input-container class="md-block" flex="85"><label translate>FIELDS.NEW_PASSWORD</label>\n<input name="password" ng-model="vm.record.newPassword" type="password" required md-maxlength="20"><div \nng-messages="changePasswordForm.password.$error" role="alert"><div ng-message="required">\n{{\'VALIDATIONS.REQUIRED\' | translate}}</div><div ng-message="md-maxlength">{{\'VALIDATIONS.MAXLEN\' | translate}}</div>\n</div></md-input-container><md-input-container class="md-block" flex="85"><label translate>FIELDS.CONFIRM_PASSWORD\n</label><input name="confirmPassword" ng-model="vm.record.confirmPassword" type="password" required md-maxlength="20" \ntx-match="vm.record.newPassword"><div ng-messages="changePasswordForm.confirmPassword.$error" role="alert"><div \nng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div><div ng-message="md-maxlength">\n{{\'VALIDATIONS.MAXLEN\' | translate}}</div><div ng-message="compareTo">{{\'VALIDATIONS.PASSWORD_MISMATCH\' | translate}}\n</div></div></md-input-container></div></md-dialog-content><md-dialog-actions layout="row" layout-align="end center">\n<div></div><div layout="row" layout-align="end center"><md-button ng-click="vm.cancel()" class="md-primary md-raised" \ntranslate="ACTIONS.DIALOG_CANCEL" aria-label="Cancel" translate-attr-aria-label="ACTIONS.DIALOG_CANCEL">CANCEL\n</md-button><md-button ng-click="vm.changePassword(vm.record)" class="md-accent md-raised" \nng-disabled="changePasswordForm.$invalid" translate="ACTIONS.CHANGE_PASSWORD" aria-label="Yes" \ntranslate-attr-aria-label="PARTS.YES">{{ACTIONS.CHANGE_PASSWORD | translate}}</md-button></div></md-dialog-actions>\n</form></md-dialog>');
$templateCache.put('app/services/dialog/confirm-dialog.html','<md-dialog class="edit-dialog confirm-dialogs" aria-label="Details" flex="35"><form name="editForm" \nclass="md-inline-form"><md-toolbar class="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" \nlayout-align="space-between center"><span class="title" translate="{{vm.title}}">{{vm.title}}</span><md-button \nclass="md-icon-button" ng-click="vm.cancel()" aria-label="Close dialog" tranlate \ntranslate-aria-label="ACTIONS.DIALOG_CLOSE"><md-icon md-font-icon="icon-close"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div layout="column"><h2>{{vm.message | translate}}</h2><h4 \nng-if="vm.items && vm.items.length">{{vm.items.length}} {{\'MESSAGES.CONTENT.AFFECT_RECORDS\' | translate}}</h4></div>\n</md-dialog-content><md-dialog-actions layout="row" layout-align="end center"><div></div><div layout="row" \nlayout-align="end center"><md-button ng-click="vm.cancel()" class="md-primary md-raised" \ntranslate="ACTIONS.DIALOG_CANCEL" aria-label="Cancel" translate-attr-aria-label="ACTIONS.DIALOG_CANCEL">CANCEL\n</md-button><md-button ng-click="vm.closeDialog(\'confirm\')" class="md-accent md-raised" translate="{{vm.action}}" \naria-label="Yes" translate-attr-aria-label="PARTS.YES">{{vm.action | translate}}</md-button></div></md-dialog-actions>\n</form></md-dialog>');
$templateCache.put('app/services/errorDialog/errorDialog.html','<md-dialog aria-label="Authorization Error"><md-toolbar class="md-accent md-hue-2"><div class="md-toolbar-tools" \nlayout="row" layout-align="space-between center"><span ng-if="vm.errObj != null" class="title" \ntranslate="TITLES.AUTH_ERROR">Authorization Error</span> <span ng-if="vm.errObj == null" class="title" \ntranslate="TITLES.TITLE_ERROR">Error</span><md-button class="md-icon-button" ng-click="vm.closeDialog()" \naria-label="Close dialog" tranlate translate-aria-label="ACTIONS.DIALOG_CLOSE"><md-icon md-font-icon="icon-close">\n</md-icon></md-button></div></md-toolbar><md-dialog-content><p ng-if="!vm.isArticleStateRequiredAttributesMessage">\n{{ vm.message | translate }}</p><div ng-if="vm.isArticleStateRequiredAttributesMessage"><p \nng-repeat="articleMessage in vm.message">{{ articleMessage | translate }}</p></div><p ng-if="vm.showPrivilege">\n{{vm.privilege.id}} &ensp; : &ensp; {{vm.privilege.description}}</p></md-dialog-content><md-dialog-actions><md-button \nng-click="vm.closeDialog()" class="send-button md-primary md-raised" translate="ACTIONS.DIALOG_CLOSE" \naria-label="Close" translate-attr-aria-label="ACTIONS.DIALOG_CLOSE">Close</md-button><md-button \nng-if="vm.errObj != null" ng-click="vm.showDetails()" class="md-accent md-raised" translate="ERRORS.DETAILS">Details\n</md-button></md-dialog-actions></md-dialog>');
$templateCache.put('app/services/toast/error-details.html','<md-dialog aria-label="Details"><md-toolbar class="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" \nlayout-align="space-between center"><span class="title" translate="TITLES.ERROR">Error</span><md-button \nclass="md-icon-button" ng-click="vm.closeDialog()" aria-label="Close dialog" tranlate \ntranslate-aria-label="ACTIONS.DIALOG_CLOSE"><md-icon md-font-icon="icon-close"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><h2 ng-if="vm.errorObj.status">\n{{\'ERRORS.ERROR_CODE\' | translate}}: {{vm.errorObj.status}}</h2><hljs lang="JSON" code="vm.errorTxt"></hljs>\n</md-dialog-content><md-dialog-actions><md-button ng-click="vm.closeDialog()" class="md-accent md-raised" \ntranslate="ACTIONS.DIALOG_CLOSE" aria-label="Close" translate-attr-aria-label="ACTIONS.DIALOG_CLOSE">Close</md-button>\n</md-dialog-actions></md-dialog>');
$templateCache.put('app/services/toast/error.html','<md-toast><div flex layout="row" lyout-align="space-between center"><span flex class="error-message">\n{{vm.toastMessage}}</span><md-button ng-click="vm.closeToast(\'details\')" class="error-button" \ntranslate="ERRORS.DETAILS">ERRORS.DETAILS</md-button></div></md-toast>');
$templateCache.put('app/services/toast/success.html','<md-toast><span class="text-center" flex>{{vm.toastMessage}}</span></md-toast>');
$templateCache.put('app/services/viewCreator/viewCreator.html','<md-dialog class="edit-dialog" aria-label="{{vm.isNew ? \'New Buyer\' : \'Edit Buyer\'}}"><form name="vm.editForm" \nclass="md-inline-form"><md-toolbar class="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" \nlayout-align="space-between center"><span class="title" \ntranslate="{{vm.isNew ? \'TITLES.RECORD_NEW\' : \'TITLES.RECORD_EDIT\'}}">Edit Record</span><md-button \nclass="md-icon-button" ng-click="vm.closeDialog(vm.isDataDirty)" aria-label="Close dialog" tranlate \ntranslate-aria-label="ACTIONS.DIALOG_CLOSE"><md-icon md-font-icon="icon-close"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div class="import-search-container" layout="row"><md-input-container \nflex-gt-xs="100" flex="100"><md-icon class="s18" md-font-icon="icon-magnify"></md-icon><input \nng-model="vm.searchPageText" type="search" ng-keydown="vm.onKeyDown($event)" placeholder="Search" md-autofocus \nng-change="vm.onSearchTextChanged()"></md-input-container></div><div layout="row" layout-wrap \nng-show="!(vm.AllowExternalChangeManagement || vm.checkingForLockedArticles)"><div \nng-repeat="field in vm.filteredVisibleFields" flex="100" \nflex-gt-xs="{{field.inputType == \'textArea\' || field.inputType == \'lookup-many\' || field.inputType == \'tags\' || field.inputType == \'color\' || field.inputType == \'parent-model-type\' || field.inputType == \'datatable\' || field.fullWidthInput ? 100 : 50}}" \nclass="p-5" ng-switch="field.inputType"><div ng-switch-when="textArea"><div class="external-change-message" \nng-if="field.isAllowChangeRequestEnabled && !vm.isNew && field.updateArticleChangeManagementExternalURL !== \'\'"><span>\n{{ \'MESSAGES.CONTENT.NON_EDITABLE_STATE_ATTRIBUTE\' | translate }} <a \nhref="{{field.updateArticleChangeManagementExternalURL}}" target="_blank">here</a></span></div><md-input-container \nclass="md-block" md-is-error="vm.editForm[field.field].$invalid" \nng-class="(field.isAllowChangeRequestEnabled && !vm.isNew && field.updateArticleChangeManagementExternalURL !== \'\') ? \'margin-0\' : \'\'">\n<span ng-if="field.IsSeasonless && field.editable && !vm.isNew" class="attribute-criteria-icon"><md-tooltip><span>\n{{ \'MESSAGES.CONTENT.SEASONLESS_ATTRIBUTE_INFO_MESSAGE\' | translate }}</span></md-tooltip></span><label>\n{{field.displayLabel | translate}}</label><textarea id="dialog_input_{{$first ? \'first\' : $index}}" \nname="{{field.field}}" ng-model="vm.record[field.field]" columns="1" rows="1" ng-required="vm.isInputRequired(field)" \nmd-maxlength="{{field.validation.maxLen}}" pattern="{{field.validation.pattern}}" \nng-focus="vm.currentFocusedField = field.field" \nng-change="vm.handleFieldChange(field); field.validation.checkIfValidJson ? vm.validateJSON(field) : \'\';" \nng-disabled="{{field.validation.disabledCriteria || (field.showInEdit && !field.editable && !vm.isNew)}}" \nmd-autofocus="$first"></textarea><div ng-messages="vm.editForm[field.field].$error" role="alert" multiple="multiple">\n<div ng-message="required">{{field.validation.messages.isRequired | translate}}</div><div ng-message="pattern">\n{{field.validation.messages.pattern | translate}}</div><div ng-message="md-maxlength">\n{{field.validation.messages.maxLen | translate}}</div><div ng-message="checkIfValidJson">\n{{field.validation.messages.isValidJson | translate}}</div></div></md-input-container></div><div ng-switch-when="date" \nlayout="column" flex><span ng-if="field.IsSeasonless && field.editable && !vm.isNew" class="attribute-criteria-icon">\n<md-tooltip><span>{{ \'MESSAGES.CONTENT.SEASONLESS_ATTRIBUTE_INFO_MESSAGE\' | translate }}</span></md-tooltip></span><div\n class="external-change-message" \nng-if="field.isAllowChangeRequestEnabled && !vm.isNew && field.updateArticleChangeManagementExternalURL !== \'\'"><span>\n{{ \'MESSAGES.CONTENT.NON_EDITABLE_STATE_ATTRIBUTE\' | translate }} <a \nhref="{{field.updateArticleChangeManagementExternalURL}}" target="_blank">here</a></span></div><label \nclass="md-caption" ng-class="vm.editForm[field.field].$invalid ? \'form-date-error\': \'\'">\n{{field.displayLabel | translate}}</label><md-datepicker id="dialog_input_{{$first ? \'first\' : $index}}" \nname="{{field.field}}" ng-model="vm.record[field.field]" \nng-init="vm.record[field.field] = vm.getDateObj(vm.record[field.field], field)" md-placeholder="" \nng-required="vm.isInputRequired(field)" ng-focus="vm.currentFocusedField = field.field" \nng-change="vm.handleFieldChange(field);\r\n                            field.isSourceAttributeForValidation ? vm.sourceAttributeForValidationChanged(field): \'\'; field.isCriteriaDeptAttribute ? vm.criteriaDependentCriteriaAttributeChanged(field): \'\';\r\n                            field.isLookupSourceAttribute ? vm.lookupSourceAttributeChanged(field): \'\';" \nmd-autofocus="$first" ng-disabled="field.validation.disabled"></md-datepicker><div \nng-messages="vm.editForm[field.field].$error" class="form-date-error" role="alert" multiple="multiple"><div \nng-message="required">{{field.validation.messages.isRequired | translate}}</div><div ng-message="pattern">\n{{field.validation.messages.pattern | translate}}</div></div></div><div ng-switch-when="date-without-time" \nlayout="column" flex><span ng-if="field.IsSeasonless && field.editable && !vm.isNew" class="attribute-criteria-icon">\n<md-tooltip><span>{{ \'MESSAGES.CONTENT.SEASONLESS_ATTRIBUTE_INFO_MESSAGE\' | translate }}</span></md-tooltip></span>\n<label class="md-caption" ng-class="vm.editForm[field.field].$invalid ? \'form-date-error\': \'\'">\n{{field.displayLabel | translate}}</label><div class="external-change-message" \nng-if="field.isAllowChangeRequestEnabled && !vm.isNew && field.updateArticleChangeManagementExternalURL !== \'\'"><span>\n{{ \'MESSAGES.CONTENT.NON_EDITABLE_STATE_ATTRIBUTE\' | translate }} <a \nhref="{{field.updateArticleChangeManagementExternalURL}}" target="_blank">here</a></span></div><md-datepicker \nid="dialog_input_{{$first ? \'first\' : $index}}" name="{{field.field}}" ng-model="vm.record[field.field]" \nng-init="vm.record[field.field] = vm.getDateObj(vm.record[field.field], field)" md-placeholder="" \nng-required="vm.isInputRequired(field)" md-autofocus="$first" ng-disabled="field.validation.disabled" \nng-focus="vm.currentFocusedField = field.field" \nng-change="vm.handleFieldChange(field);\r\n                            field.isSourceAttributeForValidation ? vm.sourceAttributeForValidationChanged(field): \'\'; field.isCriteriaDeptAttribute ? vm.criteriaDependentCriteriaAttributeChanged(field): \'\';\r\n                            field.isLookupSourceAttribute ? vm.lookupSourceAttributeChanged(field): \'\';">\n</md-datepicker><div ng-messages="vm.editForm[field.field].$error" class="form-date-error" role="alert" \nmultiple="multiple"><div ng-message="required">{{field.validation.messages.isRequired | translate}}</div><div \nng-message="pattern">{{field.validation.messages.pattern | translate}}</div></div></div><div ng-switch-when="date-utc" \nlayout="column" flex><label class="md-caption" \nng-class="vm.editForm[field.field].$invalid || (vm.model.dateRangeValidation && field.field === vm.model.dateRangeValidation.startDateField && vm.dateRangeStartError) || (vm.model.dateRangeValidation && field.field === vm.model.dateRangeValidation.endDateField && vm.dateRangeEndError) ? \'form-date-error\': \'\'">\n{{field.displayLabel | translate}}</label><md-datepicker id="dialog_input_{{$first ? \'first\' : $index}}" \nname="{{field.field}}" ng-model="vm.record[field.field]" \nng-init="vm.record[field.field] = vm.getDateObj(vm.record[field.field], field, true)" md-placeholder="" \nng-required="vm.isInputRequired(field)" md-autofocus="$first" ng-disabled="field.validation.disabled" \nng-focus="vm.currentFocusedField = field.field" \nng-change="vm.handleFieldChange(field);\r\n                            field.isSourceAttributeForValidation ? vm.sourceAttributeForValidationChanged(field): \'\'; field.isCriteriaDeptAttribute ? vm.criteriaDependentCriteriaAttributeChanged(field): \'\';\r\n                            field.isLookupSourceAttribute ? vm.lookupSourceAttributeChanged(field): \'\';">\n</md-datepicker><div ng-messages="vm.editForm[field.field].$error" class="form-date-error" role="alert" \nmultiple="multiple"><div ng-message="required">{{field.validation.messages.isRequired | translate}}</div><div \nng-message="pattern">{{field.validation.messages.pattern | translate}}</div></div><div \nng-if="vm.model.dateRangeValidation && field.field === vm.model.dateRangeValidation.startDateField && vm.dateRangeStartError" \nclass="form-date-error" role="alert">{{vm.model.dateRangeValidation.messages.startDateError | translate}}</div><div \nng-if="vm.model.dateRangeValidation && field.field === vm.model.dateRangeValidation.endDateField && vm.dateRangeEndError" \nclass="form-date-error" role="alert">{{vm.model.dateRangeValidation.messages.endDateError | translate}}</div></div><div\n ng-switch-when="date-option" layout="column" flex><span ng-if="field.IsSeasonless && field.editable && !vm.isNew" \nclass="attribute-criteria-icon"><md-tooltip><span>\n{{ \'MESSAGES.CONTENT.SEASONLESS_ATTRIBUTE_INFO_MESSAGE\' | translate }}</span></md-tooltip></span><label \nclass="md-caption" ng-class="vm.editForm[field.field].$invalid ? \'form-date-error\': \'\'">\n{{field.displayLabel | translate}}</label><div class="external-change-message" \nng-if="field.isAllowChangeRequestEnabled && !vm.isNew && field.updateArticleChangeManagementExternalURL !== \'\'"><span>\n{{ \'MESSAGES.CONTENT.NON_EDITABLE_STATE_ATTRIBUTE\' | translate }} <a \nhref="{{field.updateArticleChangeManagementExternalURL}}" target="_blank">here</a></span></div><md-datepicker \nid="dialog_input_{{$first ? \'first\' : $index}}" name="{{field.field}}" ng-model="vm.record[field.field]" \nng-init="vm.record[field.field] = vm.getDateObj(vm.record[field.field], field)" md-placeholder="" \nng-required="vm.isInputRequired(field)" md-autofocus="$first" ng-disabled="field.validation.disabled" \nng-focus="vm.currentFocusedField = field.field" \nng-change="vm.handleFieldChange(field);\r\n                            field.isSourceAttributeForValidation ? vm.sourceAttributeForValidationChanged(field): \'\'; field.isCriteriaDeptAttribute ? vm.criteriaDependentCriteriaAttributeChanged(field): \'\';\r\n                            field.isLookupSourceAttribute ? vm.lookupSourceAttributeChanged(field): \'\';">\n</md-datepicker><div ng-messages="vm.editForm[field.field].$error" class="form-date-error" role="alert" \nmultiple="multiple"><div ng-message="required">{{field.validation.messages.isRequired | translate}}</div><div \nng-message="pattern">{{field.validation.messages.pattern | translate}}</div></div></div><div ng-switch-when="icon">\n</div><div ng-switch-when="bool"><md-switch id="dialog_input_{{$first ? \'first\' : $index}}" \nng-model="vm.record[field.field]" aria-label="{{field.displayLabel | translate}}" \nng-disabled="{{field.validation.disabledCriteria || (field.showInEdit && !field.editable && !vm.isNew)}}" \nng-true-value="true" ng-false-value="false" class="md-accent" md-autofocus="$first">{{field.displayLabel | translate}}\n</md-switch></div><div ng-switch-when="bool-str"><span ng-if="field.IsSeasonless && field.editable && !vm.isNew" \nclass="attribute-criteria-icon"><md-tooltip><span>\n{{ \'MESSAGES.CONTENT.SEASONLESS_ATTRIBUTE_INFO_MESSAGE\' | translate }}</span></md-tooltip></span><div \nclass="external-change-message" \nng-if="field.isAllowChangeRequestEnabled && !vm.isNew && field.updateArticleChangeManagementExternalURL !== \'\'"><span>\n{{ \'MESSAGES.CONTENT.NON_EDITABLE_STATE_ATTRIBUTE\' | translate }} <a \nhref="{{field.updateArticleChangeManagementExternalURL}}" target="_blank">here</a></span></div><md-switch \nid="dialog_input_{{$first ? \'first\' : $index}}" ng-model="vm.record[field.field]" \naria-label="{{field.displayLabel | translate}}" \nng-disabled="{{field.validation.disabledCriteria || (field.showInEdit && !field.editable && !vm.isNew)}}" \nng-true-value="\'true\'" ng-false-value="\'false\'" class="md-accent" md-autofocus="$first" \nng-change="vm.handleFieldChange(field);\r\n                                      field.isSourceAttributeForValidation ? vm.sourceAttributeForValidationChanged(field): \'\'; field.isCriteriaDeptAttribute ? vm.criteriaDependentCriteriaAttributeChanged(field): \'\';\r\n                                      field.isLookupSourceAttribute ? vm.lookupSourceAttributeChanged(field): \'\';">\n{{field.displayLabel | translate}}</md-switch></div><div ng-switch-when="bool-int"><md-switch \nid="dialog_input_{{$first ? \'first\' : $index}}" ng-model="vm.record[field.field]" \naria-label="{{field.displayLabel | translate}}" \nng-disabled="{{field.validation.disabledCriteria || (field.showInEdit && !field.editable && !vm.isNew)}}" \nng-true-value="1" ng-false-value="0" class="md-accent" md-autofocus="$first" ng-change="vm.handleFieldChange(field);">\n{{field.displayLabel | translate}}</md-switch></div><div ng-switch-when="int-bool"><md-switch \nid="dialog_input_{{$first ? \'first\' : $index}}" ng-model="vm.record[field.field]" \naria-label="{{field.displayLabel | translate}}" \nng-disabled="{{field.validation.disabledCriteria || (field.showInEdit && !field.editable && !vm.isNew)}}" \nng-true-value="1" ng-false-value="0" class="md-accent" md-autofocus="$first">{{field.displayLabel | translate}}\n</md-switch></div><div ng-switch-when="list"><md-input-container class="md-block"><span \nng-if="field.IsSeasonless && field.editable && !vm.isNew" class="attribute-criteria-icon"><md-tooltip><span>\n{{ \'MESSAGES.CONTENT.SEASONLESS_ATTRIBUTE_INFO_MESSAGE\' | translate }}</span></md-tooltip></span><span \nng-if="field.isCriteriaAdded" class="attribute-criteria-icon"><md-tooltip><span>{{ field.criteriaDisplayMessage }}\n</span></md-tooltip></span><label>{{field.displayLabel | translate}}</label><div class="external-change-message" \nng-if="field.isAllowChangeRequestEnabled && !vm.isNew && field.updateArticleChangeManagementExternalURL !== \'\'"><span>\n{{ \'MESSAGES.CONTENT.NON_EDITABLE_STATE_ATTRIBUTE\' | translate }} <a \nhref="{{field.updateArticleChangeManagementExternalURL}}" target="_blank">here</a></span></div><md-select \nid="dialog_input_{{$first ? \'first\' : $index}}" name="{{field.field}}" ng-model="vm.record[field.field]" \naria-label="{{field.displayLabel | translate}}" ng-required="vm.isInputRequired(field)" \nng-disabled="{{field.validation.disabledCriteria || (field.showInEdit && !field.editable && !vm.isNew)}}" \nmd-autofocus="$first" pattern="{{field.validation.pattern}}" \nng-focus="vm.currentFocusedField = field.field; field.isCriteriaAdded ? vm.getConditionalVettingList(field) : \'\'" \nng-change="vm.handleFieldChange(field)" md-on-close="vm.clearSearchTerm(field.field)"><md-select-header><input \nng-model="vm.searchValue[field.field]" type="search" placeholder="Search" ng-keydown="$event.stopPropagation()">\n</md-select-header><md-option md-option-empty ng-if="!field.validation.isRequired && field.type !== \'int\'" \nng-value="\'\'"><em>None</em></md-option><md-option ng-if="!field.validation.isRequired && field.type === \'int\'" \nng-value="0"><em>0</em></md-option><md-option ng-value="option" \nng-repeat="option in (field.values | mdSelectUniqueoptions) | filter:vm.searchValue[field.field]">{{ option }}\n</md-option></md-select><div ng-messages="vm.editForm[field.field].$error" role="alert" multiple="multiple"><div \nng-message="required">{{field.validation.messages.isRequired | translate}}</div><div ng-message="pattern">\n{{field.validation.messages.pattern | translate}}</div></div></md-input-container></div><div ng-switch-when="color" \nclass="color-div"><md-input-container class="md-block"><label>{{field.displayLabel | translate}}</label><div \nclass="color-palette"><span ng-repeat="color in vm.colors" ng-model="vm.record[field.field]" class="color-tag" \nng-click="vm.record[field.field] = color" ng-style="{\'background-color\': color}" \nng-class="vm.record[field.field].toLowerCase() === color.toLowerCase() ? \'highlist-color-box\': \'\'"></span></div>\n</md-input-container></div><div ng-switch-when="color-picker" class="color-picker"><md-input-container \nclass="md-block"><label>{{field.displayLabel | translate}}</label><input \nid="dialog_input_{{$first ? \'first+1\' : $index + 1}}" name="{{field.field}}" ng-model="vm.record[field.field]" \nng-required="vm.isInputRequired(field)" md-maxlength="{{field.validation.maxLen}}" \npattern="{{field.validation.pattern}}" \ntx-unique-value="vm.existingRecordsForUniqueValue:{{field.field}}:{{field.checkIfUnique}}" \nng-disabled="{{field.validation.disabledCriteria || (field.showInEdit && !field.editable && !vm.isNew)}}" \nng-focus="vm.currentFocusedField = field.field"><div ng-messages="vm.editForm[field.field].$error" role="alert" \nmultiple="multiple"><div ng-message="required">{{field.validation.messages.isRequired | translate}}</div><div \nng-message="{{field.inputType}}">{{field.validation.messages.invalidType | translate}}</div><div ng-message="pattern">\n{{field.validation.messages.pattern | translate}}</div><div ng-message="md-maxlength">\n{{field.validation.messages.maxLen | translate}}</div><div ng-message="tx-unique-value">\n{{\'VALIDATIONS.DUPLICATE\' | translate}}</div></div></md-input-container><input \nid="dialog_input_{{$first ? \'first\' : $index}}" class="picker" name="colorPicker" ng-model="vm.record[field.field]" \ntype="color" ng-disabled="{{field.validation.disabledCriteria || (field.showInEdit && !field.editable && !vm.isNew)}}">\n</div><div ng-switch-when="lookup" class="lookup-element"><div ng-if="!field.showReadOnlyTextWhenValueAssigned"><span \nng-if="field.field === \'RetailIntroMonthId\' || field.field === \'RetailExitMonthId\'" class="attribute-criteria-icon">\n<md-tooltip><span>{{ field.retailMonthDisplayMessage }}</span></md-tooltip></span><md-autocomplete \nid="dialog_input_{{$first ? \'first\' : $index}}" md-input-name="{{field.field}}" \nmd-selected-item="vm.record[field.field]" md-items="item in vm.lookupSearch(vm.searchText[field.field], field)" \nmd-search-text="vm.searchText[field.field]" md-item-text="vm.getLookupDisplayValue(item, field)" md-min-length="0" \nmd-floating-label="{{field.displayLabel | translate}}" \nmd-selected-item-change="vm.lookupChange(vm.record[field.field], field.field, field)" \nng-required="vm.isInputRequired(field)" md-autofocus="$first" md-no-cache="true" tx-clear-autocomplete \nng-click="vm.selectText($event)" md-menu-class="autocomplete-custom" \nng-disabled="{{field.validation.disabledCriteria || (field.showInEdit && !field.editable && !vm.isNew)}}">\n<md-item-template><span class="autocomplete-item md-accent-fg" ng-if="field.field !== \'ColorId\'" \nmd-highlight-text="vm.searchText[field.field]" md-highlight-flags="i">{{item.value}}</span> <span \nclass="autocomplete-item md-accent-fg" ng-if="field.field === \'ColorId\'" \nmd-highlight-text="vm.searchText[field.field]" md-highlight-flags="i">\n{{ vm.showColorTypeInColorPalatteDropdown ? item.ColorTypeName : item.value}}</span> <span \nclass="autocomplete-item color-box" ng-show="item.ColorCode != null && field.showColorBox" \nng-style="{\'background-color\': item.ColorCode}"></span></md-item-template><div \nng-messages="vm.editForm[field.field].$error" role="alert" ng-show="vm.editForm[field.field].$touched"><div \nng-message="required">{{field.validation.messages.isRequired | translate}}</div></div><md-not-found>\nNo Record matching "{{vm.searchText[field.field]}}" were found.<div ng-if="field.allowEnterNewValue">\nNew {{field.displayLabel | translate}} "{{vm.searchText[field.field]}}" will be created on save.</div></md-not-found>\n<div class="info-for-first-100-records" \nng-if="field.isAboveDropDownLimit && !(field.validation.disabledCriteria || (field.showInEdit && !field.editable && !vm.isNew))">\n<md-icon class="icon s14" md-font-icon="icon-information-outline"></md-icon><span>\n{{\'MESSAGES.CONTENT.SHOW_FIRST_100\' | translate}}</span></div></md-autocomplete></div><div \nng-if="field.showReadOnlyTextWhenValueAssigned"><md-input-container ng-if="vm.record[field.field] != null" \nclass="md-block"><label>{{field.displayLabel | translate}}</label><input type="text" \nng-model="vm.record[field.showReadOnlyTextWhenValueAssigned.field]" ng-disabled="true"></md-input-container><div \nng-if="vm.record[field.field] == null"><md-autocomplete id="dialog_input_{{$first ? \'first\' : $index}}" \nmd-input-name="{{field.field}}" md-selected-item="vm.record[field.field]" \nmd-items="item in vm.lookupSearch(vm.searchText[field.field], field)" md-search-text="vm.searchText[field.field]" \nmd-item-text="vm.getLookupDisplayValue(item, field)" md-min-length="0" \nmd-floating-label="{{field.displayLabel | translate}}" \nmd-selected-item-change="vm.lookupChange(vm.record[field.field], field.field, field)" \nng-required="vm.isInputRequired(field)" md-autofocus="$first" md-no-cache="true" tx-clear-autocomplete \nng-click="vm.selectText($event)" md-menu-class="autocomplete-custom" \nng-disabled="{{field.validation.disabledCriteria || (field.showInEdit && !field.editable && !vm.isNew)}}">\n<md-item-template><span class="autocomplete-item md-accent-fg" md-highlight-text="vm.searchText[field.field]" \nmd-highlight-flags="i">{{item.value}}</span> <span class="autocomplete-item color-box" \nng-show="item.ColorCode != null && field.showColorBox" ng-style="{\'background-color\': item.ColorCode}"></span>\n</md-item-template><div ng-messages="vm.editForm[field.field].$error" role="alert" \nng-show="vm.editForm[field.field].$touched"><div ng-message="required">\n{{field.validation.messages.isRequired | translate}}</div></div><md-not-found>\nNo Record matching "{{vm.searchText[field.field]}}" were found.</md-not-found><div class="info-for-first-100-records" \nng-if="field.isAboveDropDownLimit && !(field.validation.disabledCriteria || (field.showInEdit && !field.editable && !vm.isNew))">\n<md-icon class="icon s14" md-font-icon="icon-information-outline"></md-icon><span>\n{{\'MESSAGES.CONTENT.SHOW_FIRST_100\' | translate}}</span></div></md-autocomplete></div></div></div><div \nng-switch-when="custom-lookup" class="lookup-element"><md-autocomplete id="dialog_input_{{$first ? \'first\' : $index}}" \nmd-input-name="{{field.field}}" md-selected-item="vm.record[field.field]" \nmd-items="item in vm.lookupSearch(vm.searchText[field.field], field)" md-search-text="vm.searchText[field.field]" \nmd-item-text="vm.getCustomLookupDisplayValue(item, field)" md-min-length="0" \nmd-floating-label="{{field.displayLabel | translate}}" \nmd-selected-item-change="vm.customLookupChange(vm.record[field.field], field)" ng-required="vm.isInputRequired(field)" \nmd-autofocus="$first" md-no-cache="true" tx-clear-autocomplete ng-click="vm.selectText($event)" \nmd-menu-class="autocomplete-custom" \nng-disabled="{{field.validation.disabledCriteria || (field.showInEdit && !field.editable && !vm.isNew)}}">\n<md-item-template><span class="autocomplete-item md-accent-fg" md-highlight-text="vm.searchText[field.field]" \nmd-highlight-flags="i">{{item.value}}</span> <span class="autocomplete-item color-box" \nng-show="item.ColorCode != null" ng-style="{\'background-color\': item.ColorCode}"></span></md-item-template><div \nng-messages="vm.editForm[field.field].$error" role="alert" ng-show="vm.editForm[field.field].$touched"><div \nng-message="required">{{field.validation.messages.isRequired | translate}}</div></div><md-not-found>\nNo Record matching "{{vm.searchText[field.field]}}" were found.</md-not-found><div class="info-for-first-100-records" \nng-if="field.isAboveDropDownLimit && !(field.validation.disabledCriteria || (field.showInEdit && !field.editable && !vm.isNew))">\n<md-icon class="icon s14" md-font-icon="icon-information-outline"></md-icon><span>\n{{\'MESSAGES.CONTENT.SHOW_FIRST_100\' | translate}}</span></div></md-autocomplete></div><div \nng-switch-when="multi-value"><md-input-container class="md-block"><span \nng-if="field.IsSeasonless && field.editable && !vm.isNew" class="attribute-criteria-icon"><md-tooltip><span>\n{{ \'MESSAGES.CONTENT.SEASONLESS_ATTRIBUTE_INFO_MESSAGE\' | translate }}</span></md-tooltip></span><span \nng-if="field.isCriteriaAdded" class="attribute-criteria-icon"><md-tooltip><span>{{ field.criteriaDisplayMessage }}\n</span></md-tooltip></span><label translate>{{field.displayLabel}}</label><div class="external-change-message" \nng-if="field.isAllowChangeRequestEnabled && !vm.isNew && field.updateArticleChangeManagementExternalURL !== \'\'"><span>\n{{ \'MESSAGES.CONTENT.NON_EDITABLE_STATE_ATTRIBUTE\' | translate }} <a \nhref="{{field.updateArticleChangeManagementExternalURL}}" target="_blank">here</a></span></div><md-chips \nid="dialog_input_{{$first ? \'first\' : $index}}" name="{{field.field}}" ng-model="vm.record[field.field]" \nmd-autocomplete-snap md-transform-chip="vm.transformChip($chip, true)" md-require-match="true" \nng-required="vm.isInputRequired(field)"><md-autocomplete md-selected-item="vm.acSelectedItem[field.field]" \nmd-search-text="vm.acSearchText[field.field]" \nmd-items="item in vm.multiValueQuerySearch(vm.acSearchText[field.field], vm.record[field.field], field)" \nmd-item-text="item" \nng-disabled="{{field.validation.disabledCriteria || (field.showInEdit && !field.editable && !vm.isNew)}}" \nmd-min-length="0" md-no-cache="true" \nmd-selected-item-change="vm.handleFieldChange(field);\r\n                                    field.isSourceAttributeForValidation ? vm.sourceAttributeForValidationChanged(field): \'\'; field.isCriteriaDeptAttribute ? vm.criteriaDependentCriteriaAttributeChanged(field): \'\';\r\n                                    field.isLookupSourceAttribute ? vm.lookupSourceAttributeChanged(field): \'\';" \nmd-menu-class="autocomplete-custom"><md-item-template><span class="autocomplete-item md-accent-fg" \nmd-highlight-text="vm.acSearchText[field.field]">{{item}}</span></md-item-template><md-not-found>\nNo Record matching "{{vm.acSearchText[field.field]}}" were found.</md-not-found></md-autocomplete><md-chip-template \ntx-chip="vm.existingRecords:$chip"><span><strong>{{$chip}}</strong></span></md-chip-template></md-chips><div \nclass="md-chips-messages" ng-messages="vm.editForm[field.field].$error" \nng-show="vm.editForm[field.field].$dirty || vm.editForm[field.field].$submitted"><div ng-message="required">\n{{ \'VALIDATIONS.REQUIRED\' | translate}}</div></div></md-input-container></div><div ng-switch-when="lookup-many" \nclass="lookup-element"><md-input-container class="md-block"><label>{{field.displayLabel | translate}} <span \nng-if="vm.isInputRequired(field)" md-colors="{color: \'red\'}">*</span></label><md-chips \nid="dialog_input_{{$first ? \'first\' : $index}}" name="{{field.field}}" ng-model="vm.record[field.field]" \nmd-autocomplete-snap md-transform-chip="vm.transformChip($chip)" md-require-match="true" \nng-required="vm.isInputRequired(field)"><md-autocomplete md-selected-item="vm.acSelectedItem[field.field]" \nmd-search-text="vm.acSearchText[field.field]" \nmd-items="item in vm.acQuerySearch(vm.acSearchText[field.field], vm.record[field.field], field) | filter: field.lookupFilter" \nmd-item-text="item.value" \nng-disabled="{{field.validation.disabledCriteria || (field.showInEdit && !field.editable && !vm.isNew)}}" \nmd-min-length="0" md-no-cache="true" md-autofocus="$first" md-menu-class="autocomplete-custom"><md-item-template><span \nclass="autocomplete-item md-accent-fg" md-highlight-text="vm.acSearchText[field.field]">{{item.value}}</span>\n</md-item-template><md-not-found>No Record matching "{{vm.acSearchText[field.field]}}" were found.</md-not-found>\n</md-autocomplete><md-chip-template tx-chip="vm.existingRecords:$chip"><span><strong>\n{{ vm.getChipDisplayValue($chip, field) }}</strong></span></md-chip-template></md-chips><div class="md-chips-messages" \nng-messages="vm.editForm[field.field].$error" \nng-show="vm.editForm[field.field].$dirty || vm.editForm[field.field].$submitted"><div ng-message="required">\n{{field.validation.messages.isRequired | translate}}</div></div></md-input-container></div><div \nng-switch-when="dataset" class="lookup-element"><span ng-if="field.IsSeasonless && field.editable && !vm.isNew" \nclass="attribute-criteria-icon"><md-tooltip><span>\n{{ \'MESSAGES.CONTENT.SEASONLESS_ATTRIBUTE_INFO_MESSAGE\' | translate }}</span></md-tooltip></span>\n<tx-dataset-autocomplete tx-field="field" tx-data="vm.record" tx-new="vm.isNew"></tx-dataset-autocomplete></div><div \nng-switch-when="datatable" class="lookup-element"><span ng-if="field.IsSeasonless && field.editable && !vm.isNew" \nclass="attribute-criteria-icon"><md-tooltip><span>\n{{ \'MESSAGES.CONTENT.SEASONLESS_ATTRIBUTE_INFO_MESSAGE\' | translate }}</span></md-tooltip></span><tx-ui-grid \ntx-field="field" tx-data="vm.record" tx-new="vm.isNew" tx-editable="vm.isNew || (!vm.isNew && field.editable)">\n</tx-ui-grid></div><div ng-switch-when="tags"><label>{{field.displayLabel | translate}}<span \nng-if="vm.isInputRequired(field)" md-colors="{color: \'red\'}">*</span></label><md-chips \nng-if="field.field !== \'AllowedValues\' && field.field !== \'Values\'" name="{{field.field}}" \nid="dialog_input_{{$first ? \'first\' : $index}}" ng-model="vm.record[field.field]" \nplaceholder="{{\'ACTIONS.ADD_TAGS\' | translate}}" secondary-placeholder="{{\'ACTIONS.ADD_TAGS\' | translate}}" \nmd-enable-chip-edit="true" md-max-chips="{{vm.maxTags}}" md-on-add="vm.add($chip, vm.record[field.field], field)" \nmd-separator-keys="vm.tagSeperatorKeys[field.field]" ng-required="vm.isInputRequired(field)" \nreadonly="field.validation.disabledCriteria || (field.showInEdit && !field.editable && !vm.isNew)"></md-chips><div \nclass="md-chips-messages" ng-messages="vm.editForm[field.field].$error" \nng-show="vm.editForm[field.field].$dirty || vm.editForm[field.field].$submitted" multiple="multiple"><div \nng-message="required">{{field.validation.messages.isRequired | translate}}</div><div ng-message="md-max-chips">\n{{field.validation.messages.maxLen | translate}}</div></div><div ng-if="vm.add($chip, vm.record[field.field], field)" \nclass="error-message display-error">{{ vm.ErrorMessage}}</div><div \nng-if="field.field === \'AllowedValues\' || field.field === \'Values\'"><div class="vetting-list-textarea">\n<md-input-container class="md-block"><textarea id="dialog_input_{{$first ? \'first\' : $index}}" name="{{field.field}}" \nng-model="vm.textareaValue" columns="1" rows="5" md-maxlength="{{field.validation.maxLen}}" \nplaceholder="Enter values in new line..." ng-change="vm.onTextareaChange()" md-autofocus="$first">\n\r\n                                    </textarea></md-input-container></div></div></div><div \nng-switch-when="target-attributes-json-str"><md-input-container class="md-block"><label>\n{{field.displayLabel | translate}}</label><input id="dialog_input_{{$first ? \'first\' : $index}}" \nname="{{field.field}}" ng-model="vm.record[field.field]" type="text" ng-required="vm.isInputRequired(field)" \nmd-maxlength="{{field.validation.maxLen}}" pattern="{{field.validation.pattern}}" \nng-disabled="{{field.validation.disabledCriteria || (field.showInEdit && !field.editable && !vm.isNew)}}" \nmd-autofocus="$first"><div ng-messages="vm.editForm[field.field].$error" role="alert" multiple="multiple"><div \nng-message="required">{{field.validation.messages.isRequired | translate}}</div><div ng-message="{{field.inputType}}">\n{{field.validation.messages.invalidType | translate}}</div><div ng-message="pattern">\n{{field.validation.messages.pattern | translate}}</div><div ng-message="md-maxlength">\n{{field.validation.messages.maxLen | translate}}</div></div></md-input-container></div><div ng-switch-when="decimal">\n<md-input-container class="md-block"><span ng-if="field.IsSeasonless && field.editable && !vm.isNew" \nclass="attribute-criteria-icon"><md-tooltip><span>\n{{ \'MESSAGES.CONTENT.SEASONLESS_ATTRIBUTE_INFO_MESSAGE\' | translate }}</span></md-tooltip></span><label>\n{{field.displayLabel | translate}}</label><div class="external-change-message" \nng-if="field.isAllowChangeRequestEnabled && !vm.isNew && field.updateArticleChangeManagementExternalURL !== \'\'"><span>\n{{ \'MESSAGES.CONTENT.NON_EDITABLE_STATE_ATTRIBUTE\' | translate }} <a \nhref="{{field.updateArticleChangeManagementExternalURL}}" target="_blank">here</a></span></div><input \nid="dialog_input_{{$first ? \'first\' : $index}}" name="{{field.field}}" ng-model="vm.record[field.field]" type="number" \nng-required="vm.isInputRequired(field)" md-maxlength="{{field.validation.maxLen}}" \npattern="{{field.validation.pattern}}" \ntx-unique-value="vm.existingRecordsForUniqueValue:{{field.field}}:{{field.checkIfUnique}}" \nng-disabled="{{field.validation.disabledCriteria || (field.showInEdit && !field.editable && !vm.isNew)}}" \nmd-autofocus="$first" ng-focus="vm.currentFocusedField = field.field" \nng-change="vm.handleFieldChange(field);\r\n                                field.isSourceAttributeForValidation ? vm.sourceAttributeForValidationChanged(field): \'\'; field.isCriteriaDeptAttribute ? vm.criteriaDependentCriteriaAttributeChanged(field): \'\';\r\n                                field.isLookupSourceAttribute ? vm.lookupSourceAttributeChanged(field): \'\';">\n<div ng-messages="vm.editForm[field.field].$error" role="alert" multiple="multiple"><div ng-message="required">\n{{field.validation.messages.isRequired | translate}}</div><div ng-message="{{field.inputType}}">\n{{field.validation.messages.invalidType | translate}}</div><div ng-message="pattern">\n{{field.validation.messages.pattern | translate}}</div><div ng-message="md-maxlength">\n{{field.validation.messages.maxLen | translate}}</div><div ng-message="tx-unique-value">\n{{\'VALIDATIONS.DUPLICATE\' | translate}}</div></div></md-input-container></div><div ng-switch-when="articlenumber" \nclass="lookup-element"><md-autocomplete id="dialog_input_{{$first ? \'first\' : $index}}" \nmd-input-name="{{field.field}}" md-selected-item="vm.record[field.field]" \nmd-items="item in vm.lookupSearch(vm.searchText[field.field], field)" md-search-text="vm.searchText[field.field]" \nmd-item-text="vm.getLookupDisplayValue(item, field, true)" md-min-length="0" \nmd-floating-label="{{field.displayLabel | translate}}" \nmd-selected-item-change="vm.lookupChange(vm.record[field.field], field.field, field)" \nng-required="vm.isInputRequired(field)" md-autofocus="$first" md-no-cache="true" tx-clear-autocomplete \nng-click="vm.selectText($event)" md-menu-class="autocomplete-custom" \nng-disabled="{{field.validation.disabledCriteria || (field.showInEdit && !field.editable && !vm.isNew)}}">\n<md-item-template><span class="autocomplete-item md-accent-fg" md-highlight-text="vm.searchText[field.field]" \nmd-highlight-flags="i">{{item.value}}</span></md-item-template><div ng-messages="vm.editForm[field.field].$error" \nrole="alert" ng-show="vm.editForm[field.field].$touched"><div ng-message="required">\n{{field.validation.messages.isRequired | translate}}</div></div><md-not-found>\nNo Record matching "{{vm.searchText[field.field]}}" were found.</md-not-found><div class="info-for-first-100-records" \nng-if="field.isAboveDropDownLimit && !(field.validation.disabledCriteria || (field.showInEdit && !field.editable && !vm.isNew))">\n<md-icon class="icon s14" md-font-icon="icon-information-outline"></md-icon><span>\n{{\'MESSAGES.CONTENT.SHOW_FIRST_100\' | translate}}</span></div></md-autocomplete></div><div \nng-switch-when="linkedcatalogarticlenumber"><label>{{field.displayLabel | translate}}</label><tx-linked-article-viewer \ntx-field="field" tx-data="vm.record" tx-new="vm.isNew"></tx-linked-article-viewer></div><div \nng-switch-when="color-palette" class="lookup-element"><div class="external-change-message" \nng-if="field.isAllowChangeRequestEnabled && !vm.isNew && field.updateArticleChangeManagementExternalURL !== \'\'"><span>\n{{ \'MESSAGES.CONTENT.NON_EDITABLE_STATE_ATTRIBUTE\' | translate }} <a \nhref="{{field.updateArticleChangeManagementExternalURL}}" target="_blank">here</a></span></div><md-autocomplete \nid="dialog_input_{{$first ? \'first\' : $index}}" md-input-name="{{field.field}}" \nmd-selected-item="vm.record[field.field]" md-items="item in vm.lookupSearch(vm.searchText[field.field], field)" \nmd-search-text="vm.searchText[field.field]" md-item-text="vm.getCustomLookupDisplayValue(item, field)" \nmd-min-length="0" md-floating-label="{{field.displayLabel | translate}}" \nmd-selected-item-change="vm.colorPaletteLookupChange(vm.record[field.field], field)" \nng-required="vm.isInputRequired(field)" md-autofocus="$first" md-no-cache="true" tx-clear-autocomplete \nng-click="vm.selectText($event)" md-menu-class="autocomplete-custom" \nng-disabled="{{field.validation.disabledCriteria || (field.showInEdit && !field.editable && !vm.isNew)}}">\n<md-item-template><span class="autocomplete-item md-accent-fg" md-highlight-text="vm.searchText[field.field]" \nmd-highlight-flags="i">{{ vm.showColorTypeInColorPalatteDropdown ? item.ColorTypeName : item.value}}</span>\n</md-item-template><div ng-messages="vm.editForm[field.field].$error" role="alert" \nng-show="vm.editForm[field.field].$touched"><div ng-message="required">\n{{field.validation.messages.isRequired | translate}}</div></div><md-not-found>\nNo Record matching "{{vm.searchText[field.field]}}" were found.</md-not-found><div class="info-for-first-100-records" \nng-if="field.isAboveDropDownLimit && !(field.validation.disabledCriteria || (field.showInEdit && !field.editable && !vm.isNew))">\n<md-icon class="icon s14" md-font-icon="icon-information-outline"></md-icon><span>\n{{\'MESSAGES.CONTENT.SHOW_FIRST_100\' | translate}}</span></div></md-autocomplete></div><div \nng-switch-when="modelnumber" class="lookup-element"><md-autocomplete id="dialog_input_{{$first ? \'first\' : $index}}" \nmd-input-name="{{field.field}}" md-selected-item="vm.record[field.field]" \nmd-items="item in vm.lookupSearch(vm.searchText[field.field], field)" md-search-text="vm.searchText[field.field]" \nmd-item-text="vm.getLookupDisplayValue(item, field, true)" md-min-length="0" \nmd-floating-label="{{field.displayLabel | translate}}" \nmd-selected-item-change="vm.lookupChange(vm.record[field.field], field.field, field)" \nng-required="vm.isInputRequired(field)" md-autofocus="$first" md-no-cache="true" tx-clear-autocomplete \nng-click="vm.selectText($event)" md-menu-class="autocomplete-custom" \nng-disabled="{{field.validation.disabledCriteria || (field.showInEdit && !field.editable && !vm.isNew)}}">\n<md-item-template><span class="autocomplete-item md-accent-fg" md-highlight-text="vm.searchText[field.field]" \nmd-highlight-flags="i">{{item.value}}</span></md-item-template><div ng-messages="vm.editForm[field.field].$error" \nrole="alert" ng-show="vm.editForm[field.field].$touched"><div ng-message="required">\n{{field.validation.messages.isRequired | translate}}</div></div><md-not-found>\nNo Record matching "{{vm.searchText[field.field]}}" were found.</md-not-found><div class="info-for-first-100-records" \nng-if="field.isAboveDropDownLimit && !(field.validation.disabledCriteria || (field.showInEdit && !field.editable && !vm.isNew))">\n<md-icon class="icon s14" md-font-icon="icon-information-outline"></md-icon><span>\n{{\'MESSAGES.CONTENT.SHOW_FIRST_100\' | translate}}</span></div></md-autocomplete></div><div \nng-switch-when="parent-model-type"><tx-parent-model-type-viewer tx-field="field" tx-data="vm.record" tx-new="vm.isNew" \ntx-visible-fields="vm.visibleFields"></tx-parent-model-type-viewer></div><div ng-switch-when="lookup-table"><span \nng-if="field.isLookupAdded" class="attribute-criteria-icon"><md-tooltip><span>{{ field.lookupDisplayMessage }}</span>\n</md-tooltip></span><md-input-container class="md-block"><label>{{field.displayLabel | translate}}</label><input \nid="dialog_input_{{$first ? \'first\' : $index}}" name="{{field.field}}" ng-model="vm.record[field.field]" type="text" \nng-required="vm.isInputRequired(field)" ng-disabled="true" md-autofocus="$first"><div \nng-messages="vm.editForm[field.field].$error" role="alert" multiple="multiple"><div ng-message="required">\n{{field.validation.messages.isRequired | translate}}</div></div></md-input-container></div><div \nng-switch-when="number"><md-input-container class="md-block"><span \nng-if="field.IsSeasonless && field.editable && !vm.isNew" class="attribute-criteria-icon"><md-tooltip><span>\n{{ \'MESSAGES.CONTENT.SEASONLESS_ATTRIBUTE_INFO_MESSAGE\' | translate }}</span></md-tooltip></span><label>\n{{field.displayLabel | translate}}</label><div class="external-change-message" \nng-if="field.isAllowChangeRequestEnabled && !vm.isNew && field.updateArticleChangeManagementExternalURL !== \'\'"><span>\n{{ \'MESSAGES.CONTENT.NON_EDITABLE_STATE_ATTRIBUTE\' | translate }} <a \nhref="{{field.updateArticleChangeManagementExternalURL}}" target="_blank">here</a></span></div><input \nid="dialog_input_{{$first ? \'first\' : $index}}" name="{{field.field}}" ng-model="vm.record[field.field]" type="number" \ntx-integer-value ng-required="vm.isInputRequired(field)" md-maxlength="{{field.validation.maxLen}}" \npattern="{{field.validation.pattern}}" \ntx-unique-value="vm.existingRecordsForUniqueValue:{{field.field}}:{{field.checkIfUnique}}" \nng-disabled="{{field.validation.disabledCriteria || (field.showInEdit && !field.editable && !vm.isNew)}}" \nmd-autofocus="$first" ng-focus="vm.currentFocusedField = field.field" \nng-change="vm.handleFieldChange(field);\r\n                                field.isSourceAttributeForValidation ? vm.sourceAttributeForValidationChanged(field): \'\'; field.isCriteriaDeptAttribute ? vm.criteriaDependentCriteriaAttributeChanged(field): \'\';\r\n                                field.isLookupSourceAttribute ? vm.lookupSourceAttributeChanged(field): \'\';">\n<div ng-messages="vm.editForm[field.field].$error" role="alert" multiple="multiple"><div ng-message="required">\n{{field.validation.messages.isRequired | translate}}</div><div ng-message="{{field.inputType}}">\n{{field.validation.messages.invalidType | translate}}</div><div ng-message="pattern">\n{{field.validation.messages.pattern | translate}}</div><div ng-message="md-maxlength">\n{{field.validation.messages.maxLen | translate}}</div><div ng-message="tx-unique-value">\n{{\'VALIDATIONS.DUPLICATE\' | translate}}</div><div ng-message="tx-integer-value">\n{{\'VALIDATIONS.INVALID_INTEGER\' | translate}}</div></div></md-input-container></div><div ng-switch-default>\n<md-input-container class="md-block"><span ng-if="field.IsSeasonless && field.editable && !vm.isNew" \nclass="attribute-criteria-icon"><md-tooltip><span>\n{{ \'MESSAGES.CONTENT.SEASONLESS_ATTRIBUTE_INFO_MESSAGE\' | translate }}</span></md-tooltip></span><label>\n{{field.displayLabel | translate}}</label><div class="external-change-message" \nng-if="field.isAllowChangeRequestEnabled && !vm.isNew && field.updateArticleChangeManagementExternalURL !== \'\'"><span>\n{{ \'MESSAGES.CONTENT.NON_EDITABLE_STATE_ATTRIBUTE\' | translate }} <a \nhref="{{field.updateArticleChangeManagementExternalURL}}" target="_blank">here</a></span></div><input \nid="dialog_input_{{$first ? \'first\' : $index}}" name="{{field.field}}" ng-model="vm.record[field.field]" \ntype="{{field.inputType}}" ng-required="vm.isInputRequired(field)" md-maxlength="{{field.validation.maxLen}}" \npattern="{{field.validation.pattern}}" \ntx-unique-value="vm.existingRecordsForUniqueValue:{{field.field}}:{{field.checkIfUnique}}" \nng-disabled="{{field.validation.disabledCriteria || (field.showInEdit && !field.editable && !vm.isNew)}}" \nmd-autofocus="$first" ng-focus="vm.currentFocusedField = field.field" \nng-change="vm.handleFieldChange(field);\r\n                                field.isSourceAttributeForValidation ? vm.sourceAttributeForValidationChanged(field): \'\'; field.isCriteriaDeptAttribute ? vm.criteriaDependentCriteriaAttributeChanged(field): \'\';\r\n                                field.isLookupSourceAttribute ? vm.lookupSourceAttributeChanged(field): \'\';">\n<div ng-messages="vm.editForm[field.field].$error" role="alert" multiple="multiple"><div ng-message="required">\n{{field.validation.messages.isRequired | translate}}</div><div ng-message="{{field.inputType}}">\n{{field.validation.messages.invalidType | translate}}</div><div ng-message="pattern">\n{{field.validation.messages.pattern | translate}}</div><div ng-message="md-maxlength">\n{{field.validation.messages.maxLen | translate}}</div><div ng-message="tx-unique-value">\n{{\'VALIDATIONS.DUPLICATE\' | translate}}</div></div></md-input-container></div></div></div><div layout="row" \nlayout-align="center center" ng-show="vm.checkingForLockedArticles"><md-progress-circular md-mode="indeterminate" \nclass="md-accent"></md-progress-circular></div></md-dialog-content><md-dialog-actions layout="row" \nlayout-align="end center"><div></div><div layout="row" layout-align="end center"><md-button \nng-click="vm.closeDialog(vm.isDataDirty)" class="send-button md-primary md-raised" aria-label="Cancel" \ntranslate="ACTIONS.DIALOG_CANCEL" translate-attr-aria-label="ACTIONS.DIALOG_CANCEL" ng-disabled="vm.isLoading">CANCEL\n</md-button><md-button ng-click="vm.saveRecord()" class="send-button md-accent md-raised" aria-label="Save" \ntranslate="ACTIONS.SAVE" translate-attr-aria-label="ACTIONS.SAVE" \nng-disabled="vm.isLoading || !vm.isFormValid() || (vm.model.restrictSaveWithoutChange && !vm.isNew && vm.editForm.$pristine)">\nSAVE</md-button><md-button ng-click="vm.saveRecord(true)" class="send-button md-accent md-raised" aria-label="Save" \ntranslate="ACTIONS.SAVE_AND_NEW" translate-attr-aria-label="ACTIONS.SAVE_AND_NEW" \nng-disabled="vm.isLoading || !vm.isFormValid()" ng-show="vm.isNew">SAVE</md-button></div></md-dialog-actions></form>\n</md-dialog>');
$templateCache.put('app/core/directives/ms-info-bar/ms-info-bar.html','<div id="ms-info-bar" layout="row" layout-align="start center" flex><div id="ms-info-bar-message" ng-transclude flex>\n</div><md-button id="ms-info-bar-close" class="md-icon-button" aria-label="Close" ng-click="removeInfoBar()"><md-icon \nmd-font-icon="icon-close s24"></md-icon></md-button></div>');
$templateCache.put('app/core/directives/ms-search-bar/ms-search-bar.html','<div flex layout="row" layout-align="start center"><label for="ms-search-bar-input"><md-icon \nid="ms-search-bar-expander" md-font-icon="icon-magnify" class="icon s24"></md-icon><md-icon \nid="ms-search-bar-collapser" md-font-icon="icon-close" class="icon s24"></md-icon></label><input \nid="ms-search-bar-input" type="text" ng-model="global.search" placeholder="Search" translate \ntranslate-attr-placeholder="TOOLBAR.SEARCH" flex></div>');
$templateCache.put('app/directives/txDataGrid/views/checklist-view.html','<div layout="row" layout-wrap ng-show="!vm.isLoading && vm.filteredDataLength" ng-style="vm.listStyle" \nstyle="overflow: auto"><div ng-repeat="itm in vm.filteredData" layout="column" flex-xs="100" flex-gt-xs="50" \nflex-md="33" flex-gt-md="25" flex-gt-lg="20" class="grid-item"><div flex layout="row" \nlayout-align="space-between center"><div flex="none" class="selection-col" ng-click="vm.onSelectChange()"><md-checkbox \nclass="no-label" ng-model="itm.selected" aria-label="Select"></md-checkbox></div><div layout="column" flex \nclass="checklist-label" ng-click="vm.doItemClick(itm)"><span class="header" ng-if="vm.secondaryProperty">\n{{itm[vm.secondaryProperty]}}</span> <span class="description">{{itm[vm.primaryProperty]}}</span><md-tooltip><span>\n{{itm[vm.hoverProperty]}}</span></md-tooltip></div></div><div class="grid-highlighter" \nng-class="{\'active-row\' : vm.activeRow == $index}"></div></div></div>');
$templateCache.put('app/directives/txDataTable/list-views/charts-view.html','<md-content ng-style="vm.listStyle" id="charts-view"><div layout="row" layout-align="center center" \nng-show="vm.isChartLoading"><md-progress-circular md-mode="indeterminate" class="md-accent"></md-progress-circular>\n</div><div id="widgets" ng-if="!vm.isChartLoading"><div class="widget-group" layout="row" layout-wrap><ms-widget \nng-repeat="chart in vm.chartsConfigObj.charts | filter:{isGlobal:vm.view.chartFilter}" flex="100" flex-gt-xs="50" \nflex-gt-md="25" flex-gt-lg="20" style="min-Width:320px"><ms-widget-front class="white-bg" style="min-height:400px"><div\n class="charts-toolbar ph-8 pv-16 h-55" layout="row" layout-align="space-between center"><div layout="column" \nclass="toolbar-title"><div><div class="ph-8 simplified font-size-14 text-truncate">{{chart.displayLabel}}</div>\n<md-tooltip>{{chart.displayLabel}}</md-tooltip></div><div><span class="ph-8 font-size-12" \nstyle="color: rgba(0, 0, 0, 0.45)">\n{{chart.meta.m === \'1\' ? \'FIELDS.ACTIVE_INACTIVE\' : \'FIELDS.ONLY_ACTIVE\' | translate}}</span></div></div><md-button \nclass="md-icon-button" aria-label="Delete Chart" ng-click="vm.doDeleteChart($index, $event)" \nng-disabled="chart.isGlobal == \'1\' && !vm.isTrasix"><md-icon md-font-icon="icon-delete"></md-icon><md-tooltip><span \ntranslate="ACTIONS.DELETE_CHART">Delete Chart</span></md-tooltip></md-button></div><div layout="column" \nlayout-align="center center" ng-hide="chart.isLoading"><nvd3 class="remove-x-lines" config="vm.chartsConfigObj.config" \noptions="vm.chartsConfigObj.options" data="chart.data"></nvd3></div><div layout="row" layout-align="center center" \nng-show="chart.isLoading"><md-progress-linear md-mode="indeterminate" class="md-accent"></md-progress-linear></div>\n</ms-widget-front></ms-widget></div></div><md-button class="add-chart-button md-fab md-warn" \nng-click="vm.addChart($event)" aria-label="ACTIONS.ADD" translate><md-icon md-font-icon="icon-plus"></md-icon>\n</md-button></md-content>');
$templateCache.put('app/directives/txDataTable/list-views/images-view.html','<md-content ng-style="vm.listStyle" id="images-view"><div class="loading-progress" ng-show="vm.isLoading" \nng-click="$event.stopPropagation()"><md-progress-linear md-mode="query" class="md-accent"></md-progress-linear></div>\n<div class="loading-progress" ng-show="!vm.filteredDataLength && !vm.isLoading"><p translate="MESSAGES.LIST.NO_ITEMS">\nNo items available...</p></div><tx-virtual-repeater ng-if="!vm.isArticleAssetsLoading" \ntx-data-source="vm.filteredData" layout="column" layout-align="space-between stretch" style="margin: 10px" \ntx-item-width="vm.imagesSizeInfo.width" tx-item-height="vm.imagesSizeInfo.height" \ntx-item-margin="vm.imagesSizeInfo.margin" tx-scrollable-container="md-content#images-view" \ntx-on-load-more="vm.onVirtualRepeaterNearBottom()"><div class="grid-tile" \nng-class="{\'selected\' : $parent.itm.selected}" ng-init="itm = $parent.itm; vm.downloadDuneImage($parent.itm)"><div \nclass="tile-img-container" ng-class="(!vm.duneImageSource[itm.Id]) ? \'animated-background\' : \'\'" \nstyle="width:{{vm.imagesSizeInfo.imgWidth}}px; height:{{vm.imagesSizeInfo.imgHeight}}px"><img \nng-class="(!vm.duneImageSource[$parent.itm.Id]) ? \'img-placeholder\' : \'\'" class="tile-img" \nsrc="/assets/images/no-image-available.png" \nng-src="{{vm.duneImageSource[$parent.itm.Id][\'contentType\']}},{{vm.duneImageSource[$parent.itm.Id][\'imageDataUri\']}}">\n</div><md-divider></md-divider><div layout="row" layout-align="space-between center" class="tile-toolbar" \nng-class="{active: $parent.itm[vm.statusField] === 1, active: $parent.itm[vm.statusField], inactive: $parent.itm[vm.statusField] === 0, inactive: !$parent.itm[vm.statusField]}" \nstyle="width:{{vm.imagesSizeInfo.imgWidth}}px"><div class="selection-col" ng-click="$event.stopPropagation()" \nflex="none"><md-checkbox class="no-label" ng-model="$parent.itm.selected" aria-label="Select" \nng-change="vm.onSelectChange()"></md-checkbox></div><div class="bar-info" layout="column" flex><div \nclass="bold text-truncate pt5 lh13" flex>{{$parent.itm.ArticleNumber}}</div><div class="gray-italic text-truncate" \nflex ng-if="$parent.itm.FileName">{{$parent.itm.FileName}}</div><div class="gray-italic text-truncate" flex \nng-if="!$parent.itm.FileName">{{$parent.itm.ArticleName}}<md-tooltip>{{$parent.itm.ArticleName}}</md-tooltip></div>\n</div><span class="image-type-box md-accent-bg" flex="none" ng-if="$parent.itm.typeAbbriviate">\n{{$parent.itm.typeAbbriviate}}</span><div class="actions" flex="none" ng-click="$event.stopPropagation();" \nng-show="vm.view.itemActions && vm.view.itemActions.length && vm.anyItemActionAllowed"><md-menu><md-button \nclass="md-icon-button" aria-label="Action"><md-icon md-font-icon="icon-dots-vertical" ng-click="$mdOpenMenu($event)">\n</md-icon></md-button><md-menu-content width="3"><md-menu-item ng-repeat="act in vm.view.itemActions" \ntx-access="{{::act.privilege}}" ng-show="{{::act.visible}}"><md-button ng-click="vm.doItemAction(act, $parent.itm)" \naria-label="{{::act.label}}" translate-attr-aria-label="{{::act.label}}" ng-disabled="{{act.disabled}}"><md-icon \nmd-font-icon="{{::act.icon}}" class="s18"></md-icon><span translate="{{::act.label}}">{{::act.label}}</span>\n</md-button></md-menu-item></md-menu-content></md-menu></div></div></div></tx-virtual-repeater><div \nng-if="vm.isLoadingNextPage" layout="row" layout-align="center center" style="padding: 16px"><md-progress-circular \nmd-mode="indeterminate" md-diameter="36" class="md-accent"></md-progress-circular></div></md-content>');
$templateCache.put('app/directives/txDataTable/list-views/table-view.html','<md-virtual-repeat-container id="vrepeater" ng-style="vm.listStyle" md-top-index="vm.view.topIndex" \nng-init="vm.virtualRepeatAddScrollEventListener()"><div class="loading-progress" ng-show="vm.isLoading" \nng-click="$event.stopPropagation()"><md-progress-linear md-mode="query" class="md-accent"></md-progress-linear></div>\n<div class="loading-progress" ng-show="!vm.filteredDataLength && !vm.isLoading"><p translate="MESSAGES.LIST.NO_ITEMS">\nNo items available...</p></div><div class="list-item" layout="row" \nng-class="{\'active-row\' : vm.activeRow == $index, \'selected\' : itm.selected == true, \'warn\': itm.warn}" \nlayout-align="start center" layout-padding flex ng-show="!vm.isLoading" ng-click="vm.doItemClick($index)" \ntx-right-click="vm.doItemRightClick($index, $event)" md-virtual-repeat="itm in vm.dataProvider" md-on-demand="true" \nmd-item-size="50"><div flex="none" ng-class="{\'selected\' : itm.selected == true, \'warn\': itm.warn}" \nclass="selection-col" ng-click="vm.onCheckboxClick($index, $event, itm)" ng-if="vm.enableSelection"><md-checkbox \nclass="no-label" ng-model="itm.selected" aria-label="Select" ng-change="vm.onSelectChange($index)"></md-checkbox></div>\n<div layout="row" class="column-field" layout-align="start center" layout-padding flex><div \nclass="column-field-values text-truncate data-column-width-for-devices" ng-repeat="col in vm.colsList track by $index" \nstyle="width:{{vm.colsWidth[col.field]}}px" ng-switch="col.inputType"><div ng-switch-when="lookup">\n{{itm[col.field] | recordRenderer:vm.lookupData:col}}</div><div ng-switch-when="lookup-from-map">\n{{ vm.scope.$eval(col.lookupSource)[itm[col.field]] }}</div><div ng-switch-when="lookup-many"><span \nclass="text-truncate">{{itm[col.field] | lookupManyRenderer:vm.lookupData:col}}</span><md-tooltip>\n{{itm[col.field] | lookupManyRenderer:vm.lookupData:col}}</md-tooltip></div><div ng-switch-when="date"><i \nclass="icon s16 icon-calendar-clock"></i><md-tooltip>{{itm[col.field] || \'Never\' | date:\'MMM d, y h:mm a\' }}\n</md-tooltip><span>{{itm[col.field] || \'Never\' | date:col.displayFormat}}</span></div><div \nng-switch-when="date-without-time"><i class="icon s16 icon-calendar-clock"></i><md-tooltip>\n{{itm[col.field] || \'Never\' | date:\'MMM d, y\' }}</md-tooltip><span>\n{{itm[col.field] || \'Never\' | date:col.displayFormat}}</span></div><div ng-switch-when="date-utc"><i \nclass="icon s16 icon-calendar-clock"></i><md-tooltip>{{itm[col.field] || \'Never\' | date:\'MMM d, y h:mm a\':\'UTC\'}}\n</md-tooltip><span>{{itm[col.field] || \'Never\' | date:col.displayFormat:\'UTC\'}}</span></div><div \nng-switch-when="date-option"><i class="icon s16 icon-calendar-clock"></i><md-tooltip>\n{{itm[col.field] || \'Never\' | date:\'MMM d, y h:mm a\' }}</md-tooltip><span>\n{{itm[col.field] || \'Never\' | date:col.displayFormat}}</span></div><div ng-switch-when="target-attributes-json-str">\n<md-tooltip>{{itm[col.field] | targetAndAggregateAttributesRenderer}}</md-tooltip><span>\n{{itm[col.field] | targetAndAggregateAttributesRenderer}}</span></div><div ng-switch-when="dynamic-attribute-value">\n<tx-dynamic-values tx-value="itm[col.field]" tx-item="itm" tx-field="col.field"></tx-dynamic-values></div><div \nng-switch-when="icon" class="iconImage"><img ng-src="{{itm[col.field]}}" ng-show="itm[col.field]"></div><div \nng-switch-when="array"><md-tooltip>{{itm[col.field] | catalogsRenderer}}</md-tooltip><span>\n{{itm[col.field] | catalogsRenderer}}</span></div><div ng-switch-when="number"><span>{{itm[col.field] | txNumber:col}}\n</span></div><div ng-switch-when="email"><span><a href="mailto:{{itm[col.field]}}">{{itm[col.field]}}</a></span></div>\n<div ng-switch-when="url"><span><a href="{{itm[col.field]}}">{{itm[col.field]}}</a></span></div><div \nng-switch-when="calculated"><span>{{itm[col.field]}}</span></div><div ng-switch-when="calculated-url"><span><a \nhref="{{vm.scope.$eval(col.calculatedExpression, { data: itm }) }}" target="_blank">\n{{vm.scope.$eval(col.calculatedExpression, { data: itm }) }}</a></span></div><div ng-switch-when="bool" layout="row">\n<div ng-if="itm[col.field] === 1 || itm[col.field] === true" class="tag" layout="row" layout-align="start center"><div \nclass="tag-color tag-green"></div><div class="tag-label" translate>PARTS.TRUE</div></div><div \nng-if="itm[col.field] === 0 || itm[col.field] === false" class="tag" layout="row" layout-align="start center"><div \nclass="tag-color tag-red"></div><div class="tag-label" translate>PARTS.FALSE</div></div></div><div \nng-switch-when="bool-str" layout="row"><div ng-if="itm[col.field] === \'true\'" class="tag" layout="row" \nlayout-align="start center"><div class="tag-color tag-green"></div><div class="tag-label" translate>PARTS.TRUE</div>\n</div><div ng-if="itm[col.field] === \'false\'" class="tag" layout="row" layout-align="start center"><div \nclass="tag-color tag-red"></div><div class="tag-label" translate>PARTS.FALSE</div></div></div><div \nng-switch-when="bool-int" layout="row"><div ng-if="itm[col.field] == 1" class="tag" layout="row" \nlayout-align="start center"><div class="tag-color tag-green"></div><div class="tag-label" translate>PARTS.TRUE</div>\n</div><div ng-if="itm[col.field] == 0" class="tag" layout="row" layout-align="start center"><div \nclass="tag-color tag-red"></div><div class="tag-label" translate>PARTS.FALSE</div></div></div><div \nng-switch-when="int-bool" layout="row"><div ng-if="itm[col.field] == 1" class="tag" layout="row" \nlayout-align="start center"><div class="tag-color tag-green"></div><div class="tag-label" translate>PARTS.TRUE</div>\n</div><div ng-if="itm[col.field] == 0" class="tag" layout="row" layout-align="start center"><div \nclass="tag-color tag-red"></div><div class="tag-label" translate>PARTS.FALSE</div></div></div><div \nng-switch-when="status" layout="row"><div ng-if="itm[col.field] === 1" class="tag tx-active-inactive" layout="row" \nlayout-align="start center"><div class="tag-color tag-green"></div><div class="tag-label" translate>STATUS.ACTIVE</div>\n</div><div ng-if="itm[col.field] === 0" class="tag tx-active-inactive" layout="row" layout-align="start center"><div \nclass="tag-color tag-red"></div><div class="tag-label" translate>STATUS.INACTIVE</div></div></div><div \nng-switch-when="article-status" layout="row"><div ng-switch="vm.getArticleStatusValues(itm, col)"><div \nng-switch-when="1" class="tag tx-active-inactive" layout="row" layout-align="start center"><div \nclass="tag-color tag-green"></div><div class="tag-label" translate>STATUS.ACTIVE</div></div><div ng-switch-when="0" \nclass="tag tx-active-inactive" layout="row" layout-align="start center"><div class="tag-color tag-red"></div><div \nclass="tag-label" translate>STATUS.INACTIVE</div></div><div ng-switch-when="2" class="tag tx-active-inactive" \nlayout="row" layout-align="start center"><div class="tag-color tag-red"></div><div class="tag-label" translate>\nSTATUS.GLOBALLY_DROPPED</div></div><div ng-switch-when="3" class="tag tx-active-inactive" layout="row" \nlayout-align="start center"><div class="tag-color tag-blue"></div><div class="tag-label" translate>STATUS.NOT_ASSORTED\n</div></div></div></div><div ng-switch-when="color" layout="row"><div class="color-palette"><span class="color-tag" \nng-style="{\'background-color\': itm[col.field]}"></span></div></div><div ng-switch-when="color-picker" layout="row"><div\n class="color-picker-viewer" layout="row"><span class="color-picker-value">{{itm[col.field]}}</span> <span \nclass="color-box" ng-style="{\'background-color\': itm[col.field]}"></span></div></div><div \nng-switch-when="orderlineStatus" layout="row"><div ng-if="itm[col.field] === 0 && itm[vm.statusField] === 1" \nclass="tag" layout="row" layout-align="start center"><div class="tag-color tag-green"></div><div class="tag-label" \ntranslate>STATUS.ACTIVE</div></div><div ng-if="!(itm[col.field] === 0 && itm[vm.statusField] === 1)" layout="row" \nlayout-align="start center" class="tag"><div class="tag-color tag-red" flex="none"></div><div class="tag-text">\n{{itm.invalidOrderlineReason.join(\', \')}}</div></div></div><div ng-switch-when="forecastLineStatus" layout="row"><div \nng-if="itm[col.field] === 0 && itm[vm.statusField] === 1" class="tag" layout="row" layout-align="start center"><div \nclass="tag-color tag-green"></div><div class="tag-label" translate>STATUS.ACTIVE</div></div><div \nng-if="!(itm[col.field] === 0 && itm[vm.statusField] === 1)" layout="row" layout-align="start center" class="tag"><div \nclass="tag-color tag-red" flex="none"></div><div class="tag-text">{{itm.invalidForecastLineReason.join(\', \')}}</div>\n</div></div><div ng-switch-when="notificationStatus" layout="row"><div \nng-if="itm[col.field] === 0 || itm[col.field] === \'0\'" class="tag" layout="row" layout-align="start center"><div \nclass="tag-color tag-amber"></div><div class="tag-label" translate>NOTIFICATION_TYPE.PENDING</div></div><div \nng-if="itm[col.field] === 10 || itm[col.field] === \'10\'" class="tag" layout="row" layout-align="start center"><div \nclass="tag-color tag-green"></div><div class="tag-label" translate>NOTIFICATION_TYPE.SENT_SUCCESSFULLY</div></div>\n</div><div ng-switch-when="changedType" layout="row"><div ng-if="itm[col.field] === \'new\'" class="tag" layout="row" \nlayout-align="start center"><div class="tag-color tag-green"></div><div class="tag-label" translate>CHANGE_TYPES.NEW\n</div></div><div ng-if="itm[col.field] === \'dropped\'" class="tag" layout="row" layout-align="start center"><div \nclass="tag-color tag-red"></div><div class="tag-label" translate>CHANGE_TYPES.DROPPED</div></div><div \nng-if="itm[col.field] === \'reactivated\'" class="tag" layout="row" layout-align="start center"><div \nclass="tag-color tag-green"></div><div class="tag-label" translate>CHANGE_TYPES.REACTIVATED</div></div><div \nng-if="itm[col.field] === \'reactivated with change\'" class="tag" layout="row" layout-align="start center"><div \nclass="tag-color tag-green"></div><div class="tag-label" translate>CHANGE_TYPES.REACTIVATED_WITH_ATTRIBUTE_CHANGE</div>\n</div><div ng-if="itm[col.field] === \'changed\'" class="tag" layout="row" layout-align="start center"><div \nclass="tag-color tag-amber"></div><div class="tag-label" translate>CHANGE_TYPES.ATTRIBUTE_CHANGE</div></div></div><div \nng-switch-when="status-segmentation" layout="row"><div ng-if="itm[col.field] === 1" class="tag tx-active-inactive" \nlayout="row" layout-align="start center"><div class="tag-color tag-green"></div><div class="tag-label" translate>\nSTATUS.ACTIVE</div></div><div ng-if="itm[col.field] === 0" class="tag tx-active-inactive" layout="row" \nlayout-align="start center"><div class="tag-color tag-red"></div><div class="tag-label" translate>STATUS.INACTIVE</div>\n</div></div><div ng-switch-when="list">{{itm[col.field]}}</div><div ng-switch-when="multi-value">\n{{itm[col.field] | arrayTagsRenderer:col.tagSeparator}}</div><div ng-switch-when="decimal"><span>{{itm[col.field]}}\n</span></div><div ng-switch-when="articlenumber">{{itm[col.field] | recordRenderer:vm.lookupData:col}}</div><div \nng-switch-when="linkedcatalogarticlenumber">{{itm[col.field] | recordRenderer:vm.lookupData:col}}</div><div \nng-switch-when="array-tags">{{itm[col.field] | arrayTagsRenderer:col.tagSeparator}}</div><div \nng-switch-when="color-palette">{{itm[col.field] | colorPaletteRenderer:col}}</div><div ng-switch-when="dataset">\n{{itm[col.field] | colorPaletteRenderer:col}}</div><div ng-switch-when="datatable"><span>\n{{ itm[col.field] | datatableCellRenderer }}</span></div><div ng-switch-when="tags">\n{{itm[col.field] | arrayTagsRenderer:col.tagSeparator}}</div><div ng-switch-when="modelnumber">\n{{itm[col.field] | recordRenderer:vm.lookupData:col}}</div><div ng-switch-when="size-curve-size">\n{{itm[col.field] | sizeCurveSizesRenderer}}</div><div ng-switch-when="lookup-table"><span>{{itm[col.field]}}</span>\n</div><div ng-switch-default><span title="{{col.showTooltip && itm[col.field].length > 0 ? itm[col.field] : \'\'}}">\n{{itm[col.field]}}</span></div></div></div><div class="actions" \nng-class="{\'selected\' : itm.selected == true, \'warn\': itm.warn}" flex="none" ng-click="$event.stopPropagation()" \nng-if="vm.view.itemActions && vm.view.itemActions.length && vm.anyItemActionAllowed"><md-menu><md-button \nclass="md-icon-button" aria-label="Action"><md-icon md-font-icon="icon-dots-vertical" ng-click="$mdOpenMenu($event)">\n</md-icon></md-button><md-menu-content width="3"><md-menu-item ng-repeat="act in vm.view.itemActions track by act.id" \ntx-access="{{::act.privilege}}" ng-show="{{act.visible}}"><md-button ng-click="vm.doItemAction(act, itm)" \naria-label="{{act.label}}" translate-attr-aria-label="{{act.label}}" ng-disabled="{{act.disabled}}"><md-icon \nmd-font-icon="{{act.icon}}" class="s18"></md-icon><span translate="{{act.label}}">{{act.label}}</span></md-button>\n</md-menu-item><md-menu-item ng-if="vm.view.processOrdersItemActions" \nng-repeat="processOrderAct in vm.view.processOrdersItemActions track by processOrderAct.id" \ntx-access="{{::processOrderAct.privilege}}" ng-show="{{processOrderAct.visible}}"><md-button \nng-click="vm.doOrderItemAction(processOrderAct, itm)" aria-label="{{processOrderAct.label}}" \ntranslate-attr-aria-label="{{processOrderAct.label}}" ng-disabled="$eval(processOrderAct.disabled)"><md-icon \nmd-font-icon="{{processOrderAct.icon}}" class="s18"></md-icon><span translate="{{processOrderAct.label}}">\n{{processOrderAct.label}}</span></md-button></md-menu-item></md-menu-content></md-menu></div></div><div \nng-if="vm.isLoadingNextPage" style="position: absolute; bottom: 0; left: 0; right: 0; z-index: 1"><md-progress-linear \nmd-mode="indeterminate" class="md-accent"></md-progress-linear></div></md-virtual-repeat-container>');
$templateCache.put('app/directives/txFilterInput/dialogs/advance-filter.html','<md-dialog class="filter-dialog" aria-label="Filter"><form name="filterForm" class="md-inline-form"><md-toolbar \nclass="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" layout-align="space-between center"><span \nclass="title">{{\'PARTS.FILTER_BY\' | translate}} {{vm.field.displayLabel | translate}}</span><md-button \nclass="md-icon-button" ng-click="vm.closeDialog()" aria-label="Close dialog" tranlate \ntranslate-aria-label="ACTIONS.DIALOG_CLOSE"><md-icon md-font-icon="icon-close"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div layout="column"><div flex="100" class="p-5"><md-input-container class="md-block">\n<label translate="FIELDS.ADVANCE_FILTER">Use next line to add additional filter value</label><textarea \nname="{{vm.field.field}}" ng-model="vm.columnFilterData.filterValues" columns="0" rows="10" md-autofocus ng-pattern="" \nms-scroll ng-disabled="vm.columnFilterData.filterBlank"></textarea><div \nng-messages="filterForm[vm.field.field].$error" role="alert" ng-show="filterForm[vm.field.field].$touched" \nmultiple="multiple"><div ng-message="pattern">{{vm.field.validation.messages.pattern | translate}}</div></div>\n</md-input-container></div><div layout="row" flex="100"><div flex="50" class="p-5"><md-switch name="filterBlank" \nng-true-value="true" ng-false-value="false" ng-model="vm.columnFilterData.filterBlank" \naria-label="{{\'PARTS.FILTER_BLANK\' | translate}}">{{\'PARTS.FILTER_BLANK\' | translate}}</md-switch></div><div flex="50" \nclass="p-5"><md-switch name="exclude" ng-true-value="true" ng-false-value="false" \nng-model="vm.columnFilterData.excludeMode" aria-label="{{\'PARTS.FILTER_EXCLUDE\' | translate}}">\n{{\'PARTS.FILTER_EXCLUDE\' | translate}}</md-switch></div></div></div></md-dialog-content><md-dialog-actions \nlayout="row" layout-align="end center"><div></div><div layout="row" layout-align="end center"><md-button \nng-click="vm.closeDialog()" class="send-button md-primary md-raised" aria-label="Cancel" \ntranslate="ACTIONS.DIALOG_CANCEL" translate-attr-aria-label="ACTIONS.DIALOG_CANCEL">CANCEL</md-button><md-button \nng-click="vm.applyFilter()" class="send-button md-accent md-raised" aria-label="Apply" translate="ACTIONS.APPLY" \ntranslate-attr-aria-label="ACTIONS.APPLY" \nng-disabled="filterForm.$invalid || (!vm.columnFilterData.filterValues && vm.columnFilterData.filterBlank === false)">\nAPPLY</md-button></div></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/directives/txFilterInput/panels/date-range-filter.html','<div class="date-range-filter-container"><md-content class="date-container"><div><md-checkbox \nng-model="vm.filterTypeDate" value="0" ng-change="vm.unCheckCheckBox(0)"></md-checkbox><md-input-container>\n<md-datepicker aria-label="Start date" name="startDate" ng-model="vm.dateRange.startDate" md-placeholder="Start Date" \nmd-max-date="vm.dateRange.endDate"></md-datepicker></md-input-container><md-input-container class="end-date">\n<md-datepicker aria-label="End date" name="endDate" ng-model="vm.dateRange.endDate" md-placeholder="End Date" \nmd-min-date="vm.dateRange.startDate"></md-datepicker></md-input-container></div><div><md-checkbox \nng-model="vm.filterTypeBlank" value="1" ng-change="vm.unCheckCheckBox(1)"><span class="filter-blank-section" \ntranslate="PARTS.FILTER_BLANK"></span></md-checkbox></div><div class="md-actions" layout="row" layout-align="center">\n<div layout="row"><md-button class="md-primary md-raised" ng-click="vm.closePanel()">Cancel</md-button><md-button \nclass="md-accent md-raised" ng-click="vm.filterDateRange(vm.dateRange)" \nng-disabled="(vm.filterTypeDate && !vm.dateRange.startDate && !vm.dateRange.endDate) || (!vm.filterTypeDate && !vm.filterTypeBlank)">\nFilter</md-button></div></div></md-content></div>');
$templateCache.put('app/directives/txFilterInput/views/tx-filter-input-default.html','<div ng-switch="vm.col.inputType" class="tx-filter-input"><div ng-switch-when="date" layout="row" flex><md-icon \nmd-font-icon="icon-calendar" class="date-range-icon" ng-click="vm.showDateRangeFilterPanel($event)"></md-icon>\n<md-input-container flex><input type="search" value="{{vm.columnFilter[vm.col.field] ? vm.dateRange: \'\'}}" \nng-click="vm.showDateRangeFilterPanel($event)" placeholder="{{vm.col.field}}" class="tx-filter-input-element md-text" \nreadonly="readonly"><md-tooltip ng-if="vm.columnFilter[vm.col.field]">{{vm.dateRange}}</md-tooltip>\n</md-input-container></div><div ng-switch-when="date-utc" layout="row" flex><md-icon md-font-icon="icon-calendar" \nclass="date-range-icon" ng-click="vm.showDateRangeFilterPanel($event)"></md-icon><md-input-container flex><input \ntype="search" value="{{vm.columnFilter[vm.col.field] ? vm.dateRange: \'\'}}" \nng-click="vm.showDateRangeFilterPanel($event)" placeholder="{{vm.col.field}}" class="tx-filter-input-element md-text" \nreadonly="readonly"><md-tooltip ng-if="vm.columnFilter[vm.col.field]">{{vm.dateRange}}</md-tooltip>\n</md-input-container></div><div ng-switch-when="date-without-time" layout="row" flex><md-icon \nmd-font-icon="icon-calendar" class="date-range-icon" ng-click="vm.showDateRangeFilterPanel($event)"></md-icon>\n<md-input-container flex><input type="search" value="{{vm.columnFilter[vm.col.field] ? vm.dateRange: \'\'}}" \nng-click="vm.showDateRangeFilterPanel($event)" placeholder="{{vm.col.field}}" class="tx-filter-input-element md-text" \nreadonly="readonly"><md-tooltip ng-if="vm.columnFilter[vm.col.field]">{{vm.dateRange}}</md-tooltip>\n</md-input-container></div><div ng-switch-when="icon" layout="row" flex></div><div ng-switch-when="date-option" \nlayout="row" flex><div layout="row" layout-align="start center"><md-input-container flex><md-select \nng-model="vm.columnFilter[vm.col.field]" ng-change="vm.filterChange({which: 1})" \nmd-on-open="vm.loadUniqueValues(\'date\', vm.col.inputType)" md-on-close="vm.clearSearchText()" \nclass="mt-5 tx-filter-input-element" aria-label="Date List Filter" multiple="multiple"><md-select-header flex><input \nng-model="vm.searchText" type="search" ng-keydown="vm.onKeyDown($event)" placeholder="{{vm.col.field}}" \nclass="tx-filter-input-element md-text"></md-select-header><md-option ng-value="item" \nng-repeat="item in vm.uniqueValues | filter:vm.searchText">{{item}}</md-option></md-select></md-input-container></div>\n</div><div ng-switch-when="status"><md-select ng-model="vm.columnFilter[vm.col.field]" ng-change="vm.filterChange()" \nclass="mt-5 tx-filter-input-element" flex aria-label="Status Filter"><md-option ng-value="\'\'">\n{{\'STATUS.ACTIVE\' | translate}} {{\'PARTS.AND\' | translate}} {{\'STATUS.INACTIVE\' | translate}}</md-option><md-option \nng-value="\'1\'">{{\'STATUS.ACTIVE\' | translate}} {{\'PARTS.ONLY\' | translate}}</md-option><md-option ng-value="\'0\'">\n{{\'STATUS.INACTIVE\' | translate}} {{\'PARTS.ONLY\' | translate}}</md-option></md-select></div><div \nng-switch-when="article-status"><md-select ng-model="vm.columnFilter[vm.col.field]" ng-change="vm.filterChange()" \nclass="mt-5 tx-filter-input-element" flex aria-label="Status Filter"><md-option ng-value="\'\'" \nng-if="vm.dataSourceTypeId === 1">\n{{\'STATUS.ACTIVE\' | translate}} {{\'PARTS.AND\' | translate}} {{\'STATUS.INACTIVE\' | translate}}</md-option><md-option \nng-value="\'\'" ng-if="vm.dataSourceTypeId !== 1">{{\'STATUS.ALL\' | translate}}</md-option><md-option ng-value="\'1\'">\n{{\'STATUS.ACTIVE\' | translate}} {{\'PARTS.ONLY\' | translate}}</md-option><md-option ng-value="\'0\'" \nng-if="vm.dataSourceTypeId === 1">{{\'STATUS.INACTIVE\' | translate}} {{\'PARTS.ONLY\' | translate}}</md-option><md-option \nng-value="\'2\'" ng-if="vm.dataSourceTypeId !== 1">{{\'STATUS.GLOBALLY_DROPPED\' | translate}} {{\'PARTS.ONLY\' | translate}}\n</md-option><md-option ng-value="\'3\'" ng-if="vm.dataSourceTypeId !== 1">\n{{\'STATUS.NOT_ASSORTED\' | translate}} {{\'PARTS.ONLY\' | translate}}</md-option></md-select></div><div \nng-switch-when="color"><div layout="row" layout-align="start center"><md-input-container flex><md-select \nng-model="vm.columnFilter[vm.col.field]" ng-change="vm.filterChange({which: 1})" \nmd-on-open="vm.loadUniqueValues(0, vm.col.inputType)" md-on-close="vm.clearSearchText()" \nclass="mt-5 tx-filter-input-element" aria-label="Color List Filter" multiple="multiple"><md-select-header flex><input \nng-model="vm.searchText" type="search" ng-keydown="vm.onKeyDown($event)" placeholder="{{vm.col.field}}" \nclass="tx-filter-input-element md-text"></md-select-header><md-option ng-value="item" class="color-dropdown-options" \nng-repeat="item in vm.uniqueValues | filter:vm.searchText"><div class="color-palette"><span \nng-model="vm.columnFilter[vm.col.field]" class="color-tag" ng-style="{\'background-color\': item}"></span></div>\n</md-option></md-select></md-input-container></div></div><div ng-switch-when="color-picker"><div class="color-picker" \nlayout="row" layout-align="start center"><md-input-container flex><input id="{{vm.inputId}}" \nng-model="vm.columnFilter[vm.col.field]" type="text" aria-label="{{vm.col.field}}" class="tx-filter-input-element" \nng-keyup="vm.filterChange($event)"></md-input-container><input id="colorPicker_{{vm.inputId}}" class="picker" \nname="colorPicker" ng-model="vm.columnFilter[vm.col.field]" type="color" aria-label="{{vm.col.field}}" \nng-change="vm.onColorPickerUpdate($event)" \nng-disabled="{{field.validation.disabledCriteria || (field.showInEdit && !field.editable && !vm.isNew)}}"><md-button \nclass="md-icon-button" ng-click="vm.showAdvanceFilterDialog($event, vm.col)" aria-label="Advance Filters" translate \ntranslate-attr-aria-label="ACTIONS.FILTER_CLOSE"><md-tooltip>{{\'PARTS.ADVANCED_FILTER\' | translate}}</md-tooltip>\n<md-icon md-font-icon="icon-playlist-plus"></md-icon></md-button></div></div><div ng-switch-when="changedType">\n<md-select ng-model="vm.columnFilter[vm.col.field]" ng-change="vm.filterChange()" class="mt-5 tx-filter-input-element" \nflex aria-label="Status Filter"><md-option ng-value="\'\'">{{\'PARTS.NO_FILTER\' | translate}}</md-option><md-option \nng-value="\'new\'">{{\'CHANGE_TYPES.NEW\' | translate}} {{\'PARTS.ONLY\' | translate}}</md-option><md-option \nng-value="\'dropped\'">{{\'CHANGE_TYPES.DROPPED\' | translate}} {{\'PARTS.ONLY\' | translate}}</md-option><md-option \nng-value="\'reactivated\'">{{\'CHANGE_TYPES.REACTIVATED\' | translate}} {{\'PARTS.ONLY\' | translate}}</md-option><md-option \nng-value="\'reactivated with change\'">\n{{\'CHANGE_TYPES.REACTIVATED_WITH_ATTRIBUTE_CHANGE\' | translate}} {{\'PARTS.ONLY\' | translate}}</md-option><md-option \nng-value="\'changed\'">{{\'CHANGE_TYPES.ATTRIBUTE_CHANGE\' | translate}} {{\'PARTS.ONLY\' | translate}}</md-option>\n</md-select></div><div ng-switch-when="notificationStatus"><md-select ng-model="vm.columnFilter[vm.col.field]" \nng-change="vm.filterChange()" class="mt-5 tx-filter-input-element" flex aria-label="Status Filter"><md-option \nng-value="\'\'">{{\'PARTS.NO_FILTER\' | translate}}</md-option><md-option ng-value="\'!0\'">\n{{\'NOTIFICATION_TYPE.PENDING\' | translate}} {{\'PARTS.ONLY\' | translate}}</md-option><md-option ng-value="\'!10\'">\n{{\'NOTIFICATION_TYPE.SENT_SUCCESSFULLY\' | translate}} {{\'PARTS.ONLY\' | translate}}</md-option></md-select></div><div \nng-switch-when="bool"><md-select ng-model="vm.columnFilter[vm.col.field]" ng-change="vm.filterChange()" \nclass="mt-5 tx-filter-input-element" flex aria-label="Boolean Filter"><md-option ng-value="\'\'">\n{{\'STATUS.ALL\' | translate}}</md-option><md-option ng-value="\'true\'">\n{{\'PARTS.TRUE\' | translate}} {{\'PARTS.ONLY\' | translate}}</md-option><md-option ng-value="\'false\'">\n{{\'PARTS.FALSE\' | translate}} {{\'PARTS.ONLY\' | translate}}</md-option><md-option ng-value="\'blank\'">\n{{\'PARTS.BLANK\' | translate}} {{\'PARTS.ONLY\' | translate}}</md-option></md-select></div><div ng-switch-when="bool-str">\n<md-select ng-model="vm.columnFilter[vm.col.field]" ng-change="vm.filterChange()" class="mt-5 tx-filter-input-element" \nflex aria-label="Boolean Filter"><md-option ng-value="\'\'">{{\'STATUS.ALL\' | translate}}</md-option><md-option \nng-value="\'true\'">{{\'PARTS.TRUE\' | translate}} {{\'PARTS.ONLY\' | translate}}</md-option><md-option ng-value="\'false\'">\n{{\'PARTS.FALSE\' | translate}} {{\'PARTS.ONLY\' | translate}}</md-option><md-option ng-value="\'blank\'">\n{{\'PARTS.BLANK\' | translate}} {{\'PARTS.ONLY\' | translate}}</md-option></md-select></div><div ng-switch-when="bool-int">\n<md-select ng-model="vm.columnFilter[vm.col.field]" ng-change="vm.filterChange()" class="mt-5 tx-filter-input-element" \nflex aria-label="Boolean Filter"><md-option ng-value="\'\'">{{\'STATUS.ALL\' | translate}}</md-option><md-option \nng-value="\'1\'">{{\'PARTS.TRUE\' | translate}} {{\'PARTS.ONLY\' | translate}}</md-option><md-option ng-value="\'0\'">\n{{\'PARTS.FALSE\' | translate}} {{\'PARTS.ONLY\' | translate}}</md-option><md-option ng-value="\'blank\'">\n{{\'PARTS.BLANK\' | translate}} {{\'PARTS.ONLY\' | translate}}</md-option></md-select></div><div ng-switch-when="int-bool">\n<md-select ng-model="vm.columnFilter[vm.col.field]" ng-change="vm.filterChange()" class="mt-5 tx-filter-input-element" \nflex aria-label="Boolean Filter"><md-option ng-value="\'\'">{{\'STATUS.ALL\' | translate}}</md-option><md-option \nng-value="\'1\'">{{\'PARTS.TRUE\' | translate}} {{\'PARTS.ONLY\' | translate}}</md-option><md-option ng-value="\'0\'">\n{{\'PARTS.FALSE\' | translate}} {{\'PARTS.ONLY\' | translate}}</md-option><md-option ng-value="\'blank\'">\n{{\'PARTS.BLANK\' | translate}} {{\'PARTS.ONLY\' | translate}}</md-option></md-select></div><div ng-switch-when="list"><div\n ng-if="!vm.isAdvancedFilter" layout="row" layout-align="start center"><md-input-container flex \nng-if="vm.col.supportFilterLookup"><md-select ng-model="vm.columnFilter[vm.col.field]" \nng-change="vm.filterChange({which: 1})" md-on-open="vm.loadUniqueValues(0, vm.col.inputType)" \nmd-on-close="vm.clearSearchText()" class="mt-5 tx-filter-input-element" aria-label="List Filter" multiple="multiple">\n<md-select-header flex><input ng-model="vm.searchText" type="search" ng-keydown="vm.onKeyDown($event)" \nplaceholder="{{vm.col.field}}" class="tx-filter-input-element md-text"></md-select-header><md-option ng-value="item" \nng-repeat="item in vm.uniqueValues | filter:vm.searchText">{{item}}</md-option></md-select></md-input-container>\n<md-input-container flex ng-if="!vm.col.supportFilterLookup"><input id="{{vm.inputId}}" \nng-model="vm.columnFilter[vm.col.field]" type="text" aria-label="{{vm.col.field}}" class="tx-filter-input-element" \nng-keyup="vm.filterChange($event)"></md-input-container><md-button class="md-icon-button" \nng-click="vm.showAdvanceFilterDialog($event, vm.col)" aria-label="Advance Filters" translate \ntranslate-attr-aria-label="ACTIONS.FILTER_CLOSE"><md-tooltip>{{\'PARTS.ADVANCED_FILTER\' | translate}}</md-tooltip>\n<md-icon md-font-icon="icon-playlist-plus"></md-icon></md-button></div><div ng-if="vm.isAdvancedFilter" layout="row" \nlayout-align="start center" class="advance-filter tx-filter-input-element"><span class="text-box" \nng-click="vm.showAdvanceFilterDialog($event, vm.col)" flex translate="PARTS.ADVANCED_FILTER">Advanced Filter<md-tooltip\n style="max-width:{{vm.colWidth}}px" ng-if="!vm.columnFilter[vm.col.field].filterBlank">\n{{vm.columnFilter[vm.col.field].filterValues}}</md-tooltip><md-tooltip style="max-width:{{vm.colWidth}}px" \nng-if="vm.columnFilter[vm.col.field].filterBlank">{{\'PARTS.FILTER_BLANK\' | translate}}</md-tooltip></span><md-button \nclass="md-icon-button" ng-click="vm.removeAdvancedFilter(vm.col.field)" aria-label="Close Advance Filter" translate \ntranslate-attr-aria-label="ACTIONS.FILTER_CLOSE"><md-icon md-font-icon="icon-close"></md-icon></md-button></div></div>\n<div ng-switch-when="multi-value"><div ng-if="!vm.isAdvancedFilter" layout="row" layout-align="start center">\n<md-input-container flex ng-if="vm.col.supportFilterLookup"><md-select ng-model="vm.columnFilter[vm.col.field]" \nng-change="vm.filterChange({which: 1})" md-on-open="vm.loadUniqueValues(0)" md-on-close="vm.clearSearchText()" \nclass="mt-5 tx-filter-input-element" aria-label="List Filter" multiple="multiple"><md-select-header flex><input \nng-model="vm.searchText" type="search" ng-keydown="vm.onKeyDown($event)" placeholder="{{vm.col.field}}" \nclass="tx-filter-input-element md-text"></md-select-header><md-option ng-value="item" \nng-repeat="item in vm.uniqueValues | filter:vm.searchText">{{item}}</md-option></md-select></md-input-container>\n<md-input-container flex ng-if="!vm.col.supportFilterLookup"><input id="{{vm.inputId}}" \nng-model="vm.columnFilter[vm.col.field]" type="text" aria-label="{{vm.col.field}}" class="tx-filter-input-element" \nng-keyup="vm.filterChange($event)"></md-input-container><md-button class="md-icon-button" \nng-click="vm.showAdvanceFilterDialog($event, vm.col)" aria-label="Advance Filters" translate \ntranslate-attr-aria-label="ACTIONS.FILTER_CLOSE"><md-tooltip>{{\'PARTS.ADVANCED_FILTER\' | translate}}</md-tooltip>\n<md-icon md-font-icon="icon-playlist-plus"></md-icon></md-button></div><div ng-if="vm.isAdvancedFilter" layout="row" \nlayout-align="start center" class="advance-filter tx-filter-input-element"><span class="text-box" \nng-click="vm.showAdvanceFilterDialog($event, vm.col)" flex translate="PARTS.ADVANCED_FILTER">Advanced Filter<md-tooltip\n style="max-width:{{vm.colWidth}}px" ng-if="!vm.columnFilter[vm.col.field].filterBlank">\n{{vm.columnFilter[vm.col.field].filterValues}}</md-tooltip><md-tooltip style="max-width:{{vm.colWidth}}px" \nng-if="vm.columnFilter[vm.col.field].filterBlank">{{\'PARTS.FILTER_BLANK\' | translate}}</md-tooltip></span><md-button \nclass="md-icon-button" ng-click="vm.removeAdvancedFilter(vm.col.field)" aria-label="Close Advance Filter" translate \ntranslate-attr-aria-label="ACTIONS.FILTER_CLOSE"><md-icon md-font-icon="icon-close"></md-icon></md-button></div></div>\n<div ng-switch-when="color-palette"><div ng-if="!vm.isAdvancedFilter" layout="row" layout-align="start center">\n<md-input-container flex ng-if="vm.col.supportFilterLookup"><md-select ng-model="vm.columnFilter[vm.col.field]" \nng-change="vm.filterChange({which: 1})" md-on-open="vm.loadUniqueValues(0, vm.col.inputType)" \nmd-on-close="vm.clearSearchText()" class="mt-5 tx-filter-input-element" aria-label="List Filter" multiple="multiple">\n<md-select-header flex><input ng-model="vm.searchText" type="search" ng-keydown="vm.onKeyDown($event)" \nplaceholder="{{vm.col.field}}" class="tx-filter-input-element md-text"></md-select-header><md-option ng-value="item" \nng-repeat="item in vm.uniqueValues | filter:vm.searchText">{{item}}</md-option></md-select></md-input-container>\n<md-input-container flex ng-if="!vm.col.supportFilterLookup"><input id="{{vm.inputId}}" \nng-model="vm.columnFilter[vm.col.field]" type="text" aria-label="{{vm.col.field}}" class="tx-filter-input-element" \nng-keyup="vm.filterChange($event)"></md-input-container><md-button class="md-icon-button" \nng-click="vm.showAdvanceFilterDialog($event, vm.col)" aria-label="Advance Filters" translate \ntranslate-attr-aria-label="ACTIONS.FILTER_CLOSE"><md-tooltip>{{\'PARTS.ADVANCED_FILTER\' | translate}}</md-tooltip>\n<md-icon md-font-icon="icon-playlist-plus"></md-icon></md-button></div><div ng-if="vm.isAdvancedFilter" layout="row" \nlayout-align="start center" class="advance-filter tx-filter-input-element"><span class="text-box" \nng-click="vm.showAdvanceFilterDialog($event, vm.col)" flex translate="PARTS.ADVANCED_FILTER">Advanced Filter<md-tooltip\n style="max-width:{{vm.colWidth}}px" ng-if="!vm.columnFilter[vm.col.field].filterBlank">\n{{vm.columnFilter[vm.col.field].filterValues}}</md-tooltip><md-tooltip style="max-width:{{vm.colWidth}}px" \nng-if="vm.columnFilter[vm.col.field].filterBlank">{{\'PARTS.FILTER_BLANK\' | translate}}</md-tooltip></span><md-button \nclass="md-icon-button" ng-click="vm.removeAdvancedFilter(vm.col.field)" aria-label="Close Advance Filter" translate \ntranslate-attr-aria-label="ACTIONS.FILTER_CLOSE"><md-icon md-font-icon="icon-close"></md-icon></md-button></div></div>\n<div ng-switch-default><div ng-if="!vm.isAdvancedFilter" layout="row" layout-align="start center"><md-input-container \nflex ng-if="vm.col.supportFilterLookup"><md-select ng-model="vm.columnFilter[vm.col.field]" \nng-change="vm.filterChange({which: 1})" md-on-open="vm.loadUniqueValues(0, vm.col.inputType)" \nmd-on-close="vm.clearSearchText()" class="mt-5 tx-filter-input-element" aria-label="List Filter" multiple="multiple">\n<md-select-header flex><input ng-model="vm.searchText" type="search" ng-keydown="vm.onKeyDown($event)" \nplaceholder="{{vm.col.field}}" class="tx-filter-input-element md-text"></md-select-header><md-option ng-value="item" \nng-repeat="item in vm.uniqueValues | filter:vm.searchText">{{item}}</md-option></md-select></md-input-container>\n<md-input-container flex ng-if="!vm.col.supportFilterLookup"><input id="{{vm.inputId}}" \nng-model="vm.columnFilter[vm.col.field]" type="text" aria-label="{{vm.col.field}}" class="tx-filter-input-element" \nng-keyup="vm.filterChange($event)"></md-input-container><md-button class="md-icon-button" \nng-click="vm.showAdvanceFilterDialog($event, vm.col)" aria-label="Advance Filters" translate \ntranslate-attr-aria-label="ACTIONS.FILTER_CLOSE"><md-tooltip>{{\'PARTS.ADVANCED_FILTER\' | translate}}</md-tooltip>\n<md-icon md-font-icon="icon-playlist-plus"></md-icon></md-button></div><div ng-if="vm.isAdvancedFilter" layout="row" \nlayout-align="start center" class="advance-filter tx-filter-input-element"><span class="text-box" \nng-click="vm.showAdvanceFilterDialog($event, vm.col)" flex translate="PARTS.ADVANCED_FILTER">Advanced Filter<md-tooltip\n style="max-width:{{vm.colWidth}}px" ng-if="!vm.columnFilter[vm.col.field].filterBlank">\n{{vm.columnFilter[vm.col.field].filterValues}}</md-tooltip><md-tooltip style="max-width:{{vm.colWidth}}px" \nng-if="vm.columnFilter[vm.col.field].filterBlank">{{\'PARTS.FILTER_BLANK\' | translate}}</md-tooltip></span><md-button \nclass="md-icon-button" ng-click="vm.removeAdvancedFilter(vm.col.field)" aria-label="Close Advance Filter" translate \ntranslate-attr-aria-label="ACTIONS.FILTER_CLOSE"><md-icon md-font-icon="icon-close"></md-icon></md-button></div></div>\n</div>');
$templateCache.put('app/directives/txFilterInput/views/tx-filter-input-with-label.html','<div ng-switch="vm.col.inputType" class="tx-filter-input"><div ng-switch-when="date" layout="row" flex><md-icon \nmd-font-icon="icon-calendar" class="date-range-icon" ng-click="vm.showDateRangeFilterPanel($event)"></md-icon>\n<md-input-container flex><input type="search" value="{{vm.columnFilter[vm.col.field] ? vm.dateRange: \'\'}}" \nng-click="vm.showDateRangeFilterPanel($event)" placeholder="{{vm.col.field}}" class="tx-filter-input-element md-text" \nreadonly="readonly"><md-tooltip ng-if="vm.columnFilter[vm.col.field]">{{vm.dateRange}}</md-tooltip>\n</md-input-container></div><div ng-switch-when="date-utc" layout="row" flex><md-icon md-font-icon="icon-calendar" \nclass="date-range-icon" ng-click="vm.showDateRangeFilterPanel($event)"></md-icon><md-input-container flex><input \ntype="search" value="{{vm.columnFilter[vm.col.field] ? vm.dateRange: \'\'}}" \nng-click="vm.showDateRangeFilterPanel($event)" placeholder="{{vm.col.field}}" class="tx-filter-input-element md-text" \nreadonly="readonly"><md-tooltip ng-if="vm.columnFilter[vm.col.field]">{{vm.dateRange}}</md-tooltip>\n</md-input-container></div><div ng-switch-when="date-without-time" layout="row" flex><md-icon \nmd-font-icon="icon-calendar" class="date-range-icon" ng-click="vm.showDateRangeFilterPanel($event)"></md-icon>\n<md-input-container flex><input type="search" value="{{vm.columnFilter[vm.col.field] ? vm.dateRange: \'\'}}" \nng-click="vm.showDateRangeFilterPanel($event)" placeholder="{{vm.col.field}}" class="tx-filter-input-element md-text" \nreadonly="readonly"><md-tooltip ng-if="vm.columnFilter[vm.col.field]">{{vm.dateRange}}</md-tooltip>\n</md-input-container></div><div ng-switch-when="icon" layout="row" flex></div><div ng-switch-when="date-option" \nlayout="row" flex><div layout="row" layout-align="start center"><md-input-container flex><md-select \nng-model="vm.columnFilter[vm.col.field]" ng-change="vm.filterChange({which: 1})" \nmd-on-open="vm.loadUniqueValues(\'date\', vm.col.inputType)" md-on-close="vm.clearSearchText()" \nclass="mt-5 tx-filter-input-element" aria-label="Date List Filter" multiple="multiple"><md-select-header flex><input \nng-model="vm.searchText" type="search" ng-keydown="vm.onKeyDown($event)" placeholder="{{vm.col.field}}" \nclass="tx-filter-input-element md-text"></md-select-header><md-option ng-value="item" \nng-repeat="item in vm.uniqueValues | filter:vm.searchText">{{item}}</md-option></md-select></md-input-container></div>\n</div><div ng-switch-when="status"><md-select ng-model="vm.columnFilter[vm.col.field]" ng-change="vm.filterChange()" \nclass="mt-5 tx-filter-input-element" flex aria-label="Status Filter"><md-option ng-value="\'\'">\n{{\'STATUS.ACTIVE\' | translate}} {{\'PARTS.AND\' | translate}} {{\'STATUS.INACTIVE\' | translate}}</md-option><md-option \nng-value="\'1\'">{{\'STATUS.ACTIVE\' | translate}} {{\'PARTS.ONLY\' | translate}}</md-option><md-option ng-value="\'0\'">\n{{\'STATUS.INACTIVE\' | translate}} {{\'PARTS.ONLY\' | translate}}</md-option></md-select></div><div \nng-switch-when="article-status"><md-select ng-model="vm.columnFilter[vm.col.field]" ng-change="vm.filterChange()" \nclass="mt-5 tx-filter-input-element" flex aria-label="Status Filter"><md-option ng-value="\'\'" \nng-if="vm.dataSourceTypeId === 1">\n{{\'STATUS.ACTIVE\' | translate}} {{\'PARTS.AND\' | translate}} {{\'STATUS.INACTIVE\' | translate}}</md-option><md-option \nng-value="\'\'" ng-if="vm.dataSourceTypeId !== 1">{{\'STATUS.ALL\' | translate}}</md-option><md-option ng-value="\'1\'">\n{{\'STATUS.ACTIVE\' | translate}} {{\'PARTS.ONLY\' | translate}}</md-option><md-option ng-value="\'0\'" \nng-if="vm.dataSourceTypeId === 1">{{\'STATUS.INACTIVE\' | translate}} {{\'PARTS.ONLY\' | translate}}</md-option><md-option \nng-value="\'2\'" ng-if="vm.dataSourceTypeId !== 1">{{\'STATUS.GLOBALLY_DROPPED\' | translate}} {{\'PARTS.ONLY\' | translate}}\n</md-option><md-option ng-value="\'3\'" ng-if="vm.dataSourceTypeId !== 1">\n{{\'STATUS.NOT_ASSORTED\' | translate}} {{\'PARTS.ONLY\' | translate}}</md-option></md-select></div><div \nng-switch-when="color"><div layout="row" layout-align="start center"><md-input-container flex><md-select \nng-model="vm.columnFilter[vm.col.field]" ng-change="vm.filterChange({which: 1})" \nmd-on-open="vm.loadUniqueValues(0, vm.col.inputType)" md-on-close="vm.clearSearchText()" \nclass="mt-5 tx-filter-input-element" aria-label="Color List Filter" multiple="multiple"><md-select-header flex><input \nng-model="vm.searchText" type="search" ng-keydown="vm.onKeyDown($event)" placeholder="{{vm.col.field}}" \nclass="tx-filter-input-element md-text"></md-select-header><md-option ng-value="item" class="color-dropdown-options" \nng-repeat="item in vm.uniqueValues | filter:vm.searchText"><div class="color-palette"><span \nng-model="vm.columnFilter[vm.col.field]" class="color-tag" ng-style="{\'background-color\': item}"></span></div>\n</md-option></md-select></md-input-container></div></div><div ng-switch-when="color-picker"><div class="color-picker" \nlayout="row" layout-align="start center"><md-input-container flex><input id="{{vm.inputId}}" \nng-model="vm.columnFilter[vm.col.field]" type="text" aria-label="{{vm.col.field}}" class="tx-filter-input-element" \nng-keyup="vm.filterChange($event)"></md-input-container><input id="colorPicker_{{vm.inputId}}" class="picker" \nname="colorPicker" ng-model="vm.columnFilter[vm.col.field]" type="color" aria-label="{{vm.col.field}}" \nng-change="vm.onColorPickerUpdate($event)" \nng-disabled="{{field.validation.disabledCriteria || (field.showInEdit && !field.editable && !vm.isNew)}}"><md-button \nclass="md-icon-button" ng-click="vm.showAdvanceFilterDialog($event, vm.col)" aria-label="Advance Filters" translate \ntranslate-attr-aria-label="ACTIONS.FILTER_CLOSE"><md-tooltip>{{\'PARTS.ADVANCED_FILTER\' | translate}}</md-tooltip>\n<md-icon md-font-icon="icon-playlist-plus"></md-icon></md-button></div></div><div ng-switch-when="changedType">\n<md-select ng-model="vm.columnFilter[vm.col.field]" ng-change="vm.filterChange()" class="mt-5 tx-filter-input-element" \nflex aria-label="Status Filter"><md-option ng-value="\'\'">{{\'PARTS.NO_FILTER\' | translate}}</md-option><md-option \nng-value="\'new\'">{{\'CHANGE_TYPES.NEW\' | translate}} {{\'PARTS.ONLY\' | translate}}</md-option><md-option \nng-value="\'dropped\'">{{\'CHANGE_TYPES.DROPPED\' | translate}} {{\'PARTS.ONLY\' | translate}}</md-option><md-option \nng-value="\'reactivated\'">{{\'CHANGE_TYPES.REACTIVATED\' | translate}} {{\'PARTS.ONLY\' | translate}}</md-option><md-option \nng-value="\'reactivated with change\'">\n{{\'CHANGE_TYPES.REACTIVATED_WITH_ATTRIBUTE_CHANGE\' | translate}} {{\'PARTS.ONLY\' | translate}}</md-option><md-option \nng-value="\'changed\'">{{\'CHANGE_TYPES.ATTRIBUTE_CHANGE\' | translate}} {{\'PARTS.ONLY\' | translate}}</md-option>\n</md-select></div><div ng-switch-when="notificationStatus"><md-select ng-model="vm.columnFilter[vm.col.field]" \nng-change="vm.filterChange()" class="mt-5 tx-filter-input-element" flex aria-label="Status Filter"><md-option \nng-value="\'\'">{{\'PARTS.NO_FILTER\' | translate}}</md-option><md-option ng-value="\'!0\'">\n{{\'NOTIFICATION_TYPE.PENDING\' | translate}} {{\'PARTS.ONLY\' | translate}}</md-option><md-option ng-value="\'!10\'">\n{{\'NOTIFICATION_TYPE.SENT_SUCCESSFULLY\' | translate}} {{\'PARTS.ONLY\' | translate}}</md-option></md-select></div><div \nng-switch-when="bool"><md-select ng-model="vm.columnFilter[vm.col.field]" ng-change="vm.filterChange()" \nclass="mt-5 tx-filter-input-element" flex aria-label="Boolean Filter"><md-option ng-value="\'\'">\n{{\'STATUS.ALL\' | translate}}</md-option><md-option ng-value="\'true\'">\n{{\'PARTS.TRUE\' | translate}} {{\'PARTS.ONLY\' | translate}}</md-option><md-option ng-value="\'false\'">\n{{\'PARTS.FALSE\' | translate}} {{\'PARTS.ONLY\' | translate}}</md-option></md-select></div><div ng-switch-when="bool-str">\n<md-select ng-model="vm.columnFilter[vm.col.field]" ng-change="vm.filterChange()" class="mt-5 tx-filter-input-element" \nflex aria-label="Boolean Filter"><md-option ng-value="\'\'">{{\'STATUS.ALL\' | translate}}</md-option><md-option \nng-value="\'true\'">{{\'PARTS.TRUE\' | translate}} {{\'PARTS.ONLY\' | translate}}</md-option><md-option ng-value="\'false\'">\n{{\'PARTS.FALSE\' | translate}} {{\'PARTS.ONLY\' | translate}}</md-option></md-select></div><div ng-switch-when="bool-int">\n<md-select ng-model="vm.columnFilter[vm.col.field]" ng-change="vm.filterChange()" class="mt-5 tx-filter-input-element" \nflex aria-label="Boolean Filter"><md-option ng-value="\'\'">{{\'STATUS.ALL\' | translate}}</md-option><md-option \nng-value="\'1\'">{{\'PARTS.TRUE\' | translate}} {{\'PARTS.ONLY\' | translate}}</md-option><md-option ng-value="\'0\'">\n{{\'PARTS.FALSE\' | translate}} {{\'PARTS.ONLY\' | translate}}</md-option></md-select></div><div ng-switch-when="int-bool">\n<md-select ng-model="vm.columnFilter[vm.col.field]" ng-change="vm.filterChange()" class="mt-5 tx-filter-input-element" \nflex aria-label="Boolean Filter"><md-option ng-value="\'\'">{{\'STATUS.ALL\' | translate}}</md-option><md-option \nng-value="\'1\'">{{\'PARTS.TRUE\' | translate}} {{\'PARTS.ONLY\' | translate}}</md-option><md-option ng-value="\'0\'">\n{{\'PARTS.FALSE\' | translate}} {{\'PARTS.ONLY\' | translate}}</md-option></md-select></div><div ng-switch-when="list"><div\n ng-if="!vm.isAdvancedFilter" layout="row" layout-align="start center"><md-input-container flex \nng-if="vm.col.supportFilterLookup"><md-select ng-model="vm.columnFilter[vm.col.field]" \nng-change="vm.filterChange({which: 1})" md-on-open="vm.loadUniqueValues(0, vm.col.inputType)" \nmd-on-close="vm.clearSearchText()" class="mt-5 tx-filter-input-element" aria-label="List Filter" multiple="multiple">\n<md-select-header flex><input ng-model="vm.searchText" type="search" ng-keydown="vm.onKeyDown($event)" \nplaceholder="{{vm.col.field}}" class="tx-filter-input-element md-text"></md-select-header><md-option ng-value="item" \nng-repeat="item in vm.uniqueValues | filter:vm.searchText">{{item}}</md-option></md-select></md-input-container>\n<md-input-container flex ng-if="!vm.col.supportFilterLookup"><input id="{{vm.inputId}}" \nng-model="vm.columnFilter[vm.col.field]" type="text" aria-label="{{vm.col.field}}" class="tx-filter-input-element" \nng-keyup="vm.filterChange($event)"></md-input-container><md-button class="md-icon-button" \nng-click="vm.showAdvanceFilterDialog($event, vm.col)" aria-label="Advance Filters" translate \ntranslate-attr-aria-label="ACTIONS.FILTER_CLOSE"><md-tooltip>{{\'PARTS.ADVANCED_FILTER\' | translate}}</md-tooltip>\n<md-icon md-font-icon="icon-playlist-plus"></md-icon></md-button></div><div ng-if="vm.isAdvancedFilter" layout="row" \nlayout-align="start center" class="advance-filter tx-filter-input-element"><span class="text-box" \nng-click="vm.showAdvanceFilterDialog($event, vm.col)" flex translate="PARTS.ADVANCED_FILTER">Advanced Filter<md-tooltip\n style="max-width:{{vm.colWidth}}px" ng-if="!vm.columnFilter[vm.col.field].filterBlank">\n{{vm.columnFilter[vm.col.field].filterValues}}</md-tooltip><md-tooltip style="max-width:{{vm.colWidth}}px" \nng-if="vm.columnFilter[vm.col.field].filterBlank">{{\'PARTS.FILTER_BLANK\' | translate}}</md-tooltip></span><md-button \nclass="md-icon-button" ng-click="vm.removeAdvancedFilter(vm.col.field)" aria-label="Close Advance Filter" translate \ntranslate-attr-aria-label="ACTIONS.FILTER_CLOSE"><md-icon md-font-icon="icon-close"></md-icon></md-button></div></div>\n<div ng-switch-when="multi-value"><div ng-if="!vm.isAdvancedFilter" layout="row" layout-align="start center">\n<md-input-container flex ng-if="vm.col.supportFilterLookup"><md-select ng-model="vm.columnFilter[vm.col.field]" \nng-change="vm.filterChange({which: 1})" md-on-open="vm.loadUniqueValues(0)" md-on-close="vm.clearSearchText()" \nclass="mt-5 tx-filter-input-element" aria-label="List Filter" multiple="multiple"><md-select-header flex><input \nng-model="vm.searchText" type="search" ng-keydown="vm.onKeyDown($event)" placeholder="{{vm.col.field}}" \nclass="tx-filter-input-element md-text"></md-select-header><md-option ng-value="item" \nng-repeat="item in vm.uniqueValues | filter:vm.searchText">{{item}}</md-option></md-select></md-input-container>\n<md-input-container flex ng-if="!vm.col.supportFilterLookup"><input id="{{vm.inputId}}" \nng-model="vm.columnFilter[vm.col.field]" type="text" aria-label="{{vm.col.field}}" class="tx-filter-input-element" \nng-keyup="vm.filterChange($event)"></md-input-container><md-button class="md-icon-button" \nng-click="vm.showAdvanceFilterDialog($event, vm.col)" aria-label="Advance Filters" translate \ntranslate-attr-aria-label="ACTIONS.FILTER_CLOSE"><md-tooltip>{{\'PARTS.ADVANCED_FILTER\' | translate}}</md-tooltip>\n<md-icon md-font-icon="icon-playlist-plus"></md-icon></md-button></div><div ng-if="vm.isAdvancedFilter" layout="row" \nlayout-align="start center" class="advance-filter tx-filter-input-element"><span class="text-box" \nng-click="vm.showAdvanceFilterDialog($event, vm.col)" flex translate="PARTS.ADVANCED_FILTER">Advanced Filter<md-tooltip\n style="max-width:{{vm.colWidth}}px" ng-if="!vm.columnFilter[vm.col.field].filterBlank">\n{{vm.columnFilter[vm.col.field].filterValues}}</md-tooltip><md-tooltip style="max-width:{{vm.colWidth}}px" \nng-if="vm.columnFilter[vm.col.field].filterBlank">{{\'PARTS.FILTER_BLANK\' | translate}}</md-tooltip></span><md-button \nclass="md-icon-button" ng-click="vm.removeAdvancedFilter(vm.col.field)" aria-label="Close Advance Filter" translate \ntranslate-attr-aria-label="ACTIONS.FILTER_CLOSE"><md-icon md-font-icon="icon-close"></md-icon></md-button></div></div>\n<div ng-switch-when="color-palette"><div ng-if="!vm.isAdvancedFilter" layout="row" layout-align="start center">\n<md-input-container flex ng-if="vm.col.supportFilterLookup"><md-select ng-model="vm.columnFilter[vm.col.field]" \nng-change="vm.filterChange({which: 1})" md-on-open="vm.loadUniqueValues(0, vm.col.inputType)" \nmd-on-close="vm.clearSearchText()" class="mt-5 tx-filter-input-element" aria-label="List Filter" multiple="multiple">\n<md-select-header flex><input ng-model="vm.searchText" type="search" ng-keydown="vm.onKeyDown($event)" \nplaceholder="{{vm.col.field}}" class="tx-filter-input-element md-text"></md-select-header><md-option ng-value="item" \nng-repeat="item in vm.uniqueValues | filter:vm.searchText">{{item}}</md-option></md-select></md-input-container>\n<md-input-container flex ng-if="!vm.col.supportFilterLookup"><input id="{{vm.inputId}}" \nng-model="vm.columnFilter[vm.col.field]" type="text" aria-label="{{vm.col.field}}" class="tx-filter-input-element" \nng-keyup="vm.filterChange($event)"></md-input-container><md-button class="md-icon-button" \nng-click="vm.showAdvanceFilterDialog($event, vm.col)" aria-label="Advance Filters" translate \ntranslate-attr-aria-label="ACTIONS.FILTER_CLOSE"><md-tooltip>{{\'PARTS.ADVANCED_FILTER\' | translate}}</md-tooltip>\n<md-icon md-font-icon="icon-playlist-plus"></md-icon></md-button></div><div ng-if="vm.isAdvancedFilter" layout="row" \nlayout-align="start center" class="advance-filter tx-filter-input-element"><span class="text-box" \nng-click="vm.showAdvanceFilterDialog($event, vm.col)" flex translate="PARTS.ADVANCED_FILTER">Advanced Filter<md-tooltip\n style="max-width:{{vm.colWidth}}px" ng-if="!vm.columnFilter[vm.col.field].filterBlank">\n{{vm.columnFilter[vm.col.field].filterValues}}</md-tooltip><md-tooltip style="max-width:{{vm.colWidth}}px" \nng-if="vm.columnFilter[vm.col.field].filterBlank">{{\'PARTS.FILTER_BLANK\' | translate}}</md-tooltip></span><md-button \nclass="md-icon-button" ng-click="vm.removeAdvancedFilter(vm.col.field)" aria-label="Close Advance Filter" translate \ntranslate-attr-aria-label="ACTIONS.FILTER_CLOSE"><md-icon md-font-icon="icon-close"></md-icon></md-button></div></div>\n<div ng-switch-default><div ng-if="!vm.isAdvancedFilter" layout="row" layout-align="start center"><md-input-container \nflex ng-if="vm.col.supportFilterLookup"><md-select ng-model="vm.columnFilter[vm.col.field]" \nng-change="vm.filterChange({which: 1})" md-on-open="vm.loadUniqueValues(0, vm.col.inputType)" \nmd-on-close="vm.clearSearchText()" class="mt-5 tx-filter-input-element" aria-label="List Filter" multiple="multiple">\n<md-select-header flex><input ng-model="vm.searchText" type="search" ng-keydown="vm.onKeyDown($event)" \nplaceholder="{{vm.col.field}}" class="tx-filter-input-element md-text"></md-select-header><md-option ng-value="item" \nng-repeat="item in vm.uniqueValues | filter:vm.searchText">{{item}}</md-option></md-select></md-input-container>\n<md-input-container flex ng-if="!vm.col.supportFilterLookup"><input id="{{vm.inputId}}" \nng-model="vm.columnFilter[vm.col.field]" type="text" aria-label="{{vm.col.field}}" class="tx-filter-input-element" \nng-keyup="vm.filterChange($event)"></md-input-container><md-button class="md-icon-button" \nng-click="vm.showAdvanceFilterDialog($event, vm.col)" aria-label="Advance Filters" translate \ntranslate-attr-aria-label="ACTIONS.FILTER_CLOSE"><md-tooltip>{{\'PARTS.ADVANCED_FILTER\' | translate}}</md-tooltip>\n<md-icon md-font-icon="icon-playlist-plus"></md-icon></md-button></div><div ng-if="vm.isAdvancedFilter" layout="row" \nlayout-align="start center" class="advance-filter tx-filter-input-element"><span class="text-box" \nng-click="vm.showAdvanceFilterDialog($event, vm.col)" flex translate="PARTS.ADVANCED_FILTER">Advanced Filter<md-tooltip\n style="max-width:{{vm.colWidth}}px" ng-if="!vm.columnFilter[vm.col.field].filterBlank">\n{{vm.columnFilter[vm.col.field].filterValues}}</md-tooltip><md-tooltip style="max-width:{{vm.colWidth}}px" \nng-if="vm.columnFilter[vm.col.field].filterBlank">{{\'PARTS.FILTER_BLANK\' | translate}}</md-tooltip></span><md-button \nclass="md-icon-button" ng-click="vm.removeAdvancedFilter(vm.col.field)" aria-label="Close Advance Filter" translate \ntranslate-attr-aria-label="ACTIONS.FILTER_CLOSE"><md-icon md-font-icon="icon-close"></md-icon></md-button></div></div>\n</div>');
$templateCache.put('app/main/article-states/details/article-states-details.html','<div id="user-details" class="page-layout simple tabbed details-view" layout="column"><div class="content"><md-tabs \nmd-dynamic-height md-selected="vm.tabIndex" md-no-ink><md-tab \nlabel="{{\'ARTICLE_STATES.TABS.ARTICLE_STATE\' | translate}}" tx-access="{{::vm.model.views.privileges.details}}">\n<tx-data-details tx-height-offset="37" tx-is-active="vm.tabIndex === 0" tx-account="vm.articleState" \ntx-parent-id="vm.articleState.Id" tx-title="vm.title" tx-model="vm.model" \ntx-item-actions="vm.model.views.mainDetails.itemActions" tx-item-action-event="vm.doItemAction(action, account)" \ntx-is-loading="vm.isLoading" tx-refresh-action-event="vm.refreshRecord(false)"></tx-data-details></md-tab><md-tab \nlabel="{{\'ARTICLE_STATES.TABS.REQUIRED_ATTRIBUTES\' | translate}}" \ntx-access="{{::vm.stateRequiredAttributesModel.views.privileges.list}}"><div class="list-tab" layout="row" flex="100" \nlayout-wrap><ms-widget layout="row" flex="100"><ms-widget-front class="white-bg"><tx-data-table \ntx-is-active="vm.tabIndex === 1" tx-data="vm.stateRequiredAttributes" tx-model="vm.stateRequiredAttributesModel" \ntx-view="mainList" tx-filtered-data="vm.filteredStateRequiredAttributes" tx-data-filter="global.search" \ntx-is-loading="vm.isLoading" tx-refresh-action-event="vm.refreshRecord(true, false)" tx-height-offset="16">\n</tx-data-table></ms-widget-front></ms-widget></div></md-tab><md-tab \nlabel="{{\'ARTICLE_STATES.TABS.NON_EDITABLE_ATTRIBUTES\' | translate}}" \ntx-access="{{::vm.stateNonEditableAttributesModel.views.privileges.list}}"><div class="list-tab" layout="row" \nflex="100" layout-wrap><ms-widget layout="row" flex="100"><ms-widget-front class="white-bg"><tx-data-table \ntx-is-active="vm.tabIndex === 2" tx-data="vm.stateNonEditableAttributes" tx-model="vm.stateNonEditableAttributesModel" \ntx-view="mainList" tx-filtered-data="vm.filteredStateNonEditableAttributes" tx-data-filter="global.search" \ntx-is-loading="vm.isLoading" tx-refresh-action-event="vm.refreshRecord(true, false)" tx-height-offset="16">\n</tx-data-table></ms-widget-front></ms-widget></div></md-tab></md-tabs><md-button id="txfab" class="md-fab md-warn" \nng-if="vm.tabIndex === 0" ng-click="vm.editItem(vm.articleState, $event)" \naria-label="vm.model.views.mainDetails.fab.label" translate tx-access="{{::vm.model.views.mainDetails.fab.privilege}}" \nng-show="vm.model.views.mainDetails.fab.visible"><md-icon md-font-icon="{{vm.model.views.mainDetails.fab.icon}}">\n</md-icon></md-button></div></div>');
$templateCache.put('app/main/article-states/list/article-states-lists.html','<div id="article-states-list" class="page-layout carded fullwidth list-view" layout="row"><div class="center" \nlayout="column" flex><div class="content-card" layout="column" flex><tx-data-table tx-data="vm.articleStates" \ntx-model="vm.model" tx-view="mainList" tx-filtered-data="vm.filteredArticleStates" tx-data-filter="global.search" \ntx-is-loading="vm.isLoading" tx-item-action-event="vm.doItemAction(action, item)" \ntx-list-action-event="vm.doListAction(action, selectedItems)" tx-item-click-event="vm.viewItem(item)" \ntx-refresh-action-event="vm.refreshItems(true, false)"></tx-data-table><md-button \nclass="add-rec-button md-fab md-warn" ng-click="vm.addUpdateRecord($event)" \naria-label="vm.model.views.mainList.fabAction.label" translate \ntx-access="{{::vm.model.views.mainList.fabAction.privilege}}" ng-show="vm.model.views.mainList.fabAction.visible">\n<md-icon md-font-icon="{{vm.model.views.mainList.fabAction.icon}}"></md-icon></md-button></div></div></div>');
$templateCache.put('app/main/auth/lock/lock.html','<div id="lock" class="flex-scrollable" layout="column" ms-scroll><div id="lock-form-wrapper" layout="column" \nlayout-align="center center"><div id="lock-form" class="md-whiteframe-8dp"><div layout="row" \nlayout-align="start center" layout-sm="column" layout-align-sm="center center" class="mb-30"><div \nclass="avatar-container"><img class="avatar big" src="assets/images/avatars/profile.jpg"><md-icon \nmd-font-icon="icon-lock" class="md-warn-fg s36 md-hue-2"></md-icon></div><div flex layout="column" \nlayout-align="start" layout-align-sm="center center"><div class="title" translate="LOCK.TITLE">Your session is locked\n</div><div class="subtitle" translate="LOCK.SUBTITLE">\nDue to inactivity, your session is locked. Enter your password to continue.</div></div></div><div \nng-hide="vm.processing || vm.processingExternal"><div class="text-semibold red-A700-fg padding-bottom-15" \nng-show="vm.responseError">{{vm.error}} <span class="text-boxed">{{vm.errorCode}}</span></div><form name="lockForm" \nnovalidate><md-input-container class="md-block" md-no-float ng-show="!vm.loggedInUsingExternalSystem"><input \ntype="password" id="password" name="password" ng-model="vm.user.password" placeholder="Password" translate \ntranslate-attr-placeholder="LOCK.PASSWORD" tx-focus="true" ng-keyup="vm.onKeyUp($event)" required><div \nng-messages="lockForm.password.$error" ng-show="lockForm.password.$touched" role="alert"><div ng-message="required">\n<span translate="LOCK.ERRORS.PASSWORD_REQUIRED">Password field is required</span></div></div></md-input-container>\n<md-button ng-click="vm.doLogin()" class="md-raised md-accent" aria-label="UNLOCK" \nng-show="!vm.loggedInUsingExternalSystem" ng-disabled="lockForm.$invalid || vm.processing" translate="LOCK.UNLOCK" \ntranslate-attr-aria-label="LOCK.UNLOCK">UNLOCK</md-button><md-button class="md-raised md-accent" aria-label="UNLOCK" \nng-click="vm.doExternalLogin()" ng-show="vm.loggedInUsingExternalSystem" ng-disabled="vm.processing" \ntranslate="LOCK.UNLOCK" translate-attr-aria-label="LOCK.UNLOCK">UNLOCK</md-button></form><div class="message"><a \nui-sref="app.auth_login" class="md-accent-color"><span translate="LOCK.ARE_YOU_NOT">Are you not</span><span>\n {{vm.userFullname}}?</span></a></div></div><div ng-show="vm.processing"><div class="title" \ntranslate="LOCK.PROCESSING">Logging in...</div><md-progress-linear md-mode="indeterminate" class="md-accent">\n</md-progress-linear></div><div ng-show="!vm.processing && vm.processingExternal"><div \nclass="subhead padding-bottom-30" ng-if="!vm.activeDirectoryLoggingIn" translate="LOCK.PROCESSING_EXTERNAL">\nPlease enter your credentials in the new popup window...</div><div class="subhead padding-bottom-30" \nng-if="vm.activeDirectoryLoggingIn" translate="LOGIN.PROCESSING" ng-if="vm.activeDirectoryLoggingIn">Logging in...\n</div><md-progress-linear md-mode="indeterminate" class="md-accent padding-bottom-30"></md-progress-linear><md-button \nclass="md-raised md-accent" aria-label="CANCEL" ng-click="vm.cancelExternalLoginWindow()" \nng-if="!vm.activeDirectoryLoggingIn">CANCEL</md-button></div></div></div></div>');
$templateCache.put('app/main/auth/login/login.html','<div id="login" class="flex-scrollable" layout="column" ms-scroll><div id="login-form-wrapper" layout="column" \nlayout-align="center center"><div id="login-form" class="md-whiteframe-8dp"><div class="logo md-accent-bg"><span>T1\n</span></div><div \nng-hide="vm.processing || vm.processingExternal || vm.isLogOutFromActiveDirect || vm.requireResetPassword"><div \nclass="header-container" ng-class="(vm.multipleUsers) ? \'login-form-height\': \'\'"><div class="title-login" \ntranslate="LOGIN.TITLE" ng-if="!vm.loginTypeId  || (vm.loginTypeId && vm.loginTypeId!==1 && vm.error)">\nLog in to your account</div><div class="firstname" ng-if="vm.loginTypeId === 1">Hi {{vm.firstName}}</div><div \nclass="username-div" layout="row" ng-if="vm.loginTypeId === 1 && !vm.multipleUsers" \nlayout-align="space-between center" ng-click="vm.resetLoginTypeId()"><md-tooltip>\n{{\'LOGIN.CHANGE_USERNAME\' | translate }}</md-tooltip><img class="avatar-image" src="assets/images/avatars/profile.jpg">\n<div class="username">{{vm.user.username}}</div></div><div class="text-semibold red-A700-fg error-message" \nng-if="vm.responseError">{{vm.error}} <span class="text-boxed" ng-if="vm.error">{{vm.errorCode}}</span></div><div \nng-if="vm.multipleUsers" class="my-users-text"><span translate="LOGIN.MULTIPLE_USERS"></span></div></div><form \nname="loginForm" novalidate><div class="form-container"><md-input-container class="md-block env-container" \nng-if="vm.apiEnvs.length > 1 && !vm.multipleUsers && !vm.isSwitchUser"><label ng-if="vm.apiEnvs.length > 1">Environment\n</label><md-select ng-model="vm.loginEnvironment" ng-model-options="{trackBy: \'$value.name\'}" \nng-if="vm.apiEnvs.length > 1" ng-change="vm.onEnvironmentChange(vm.loginEnvironment.code)" \nng-disabled="vm.loginTypeId === 1 || vm.isDisabled || vm.multipleUsers"><md-option ng-repeat="env in vm.apiEnvs" \nng-value="env">{{env.name}}</md-option></md-select></md-input-container><md-input-container \nclass="md-block username-container" \nng-if="(!vm.loginTypeId || ( vm.loginTypeId && vm.loginTypeId !== 1 && !vm.multipleUsers)) && !vm.isSwitchUser"><label>\n{{\'LOGIN.USERNAME\' | translate}}</label><input name="username" ng-model="vm.user.username" \nng-keyup="vm.onKeyUp($event)" tx-focus="true" ng-disabled="vm.isDisabled" required><div \nng-messages="loginForm.username.$error" ng-show="loginForm.username.$touched" role="alert" multiple="multiple"><div \nng-message="required"><span translate="LOGIN.ERRORS.USERNAME_REQUIRED">Username field is required</span></div></div>\n</md-input-container><md-input-container class="md-block" \nng-if="vm.loginTypeId === 1 && !vm.multipleUsers && !vm.isSwitchUser"><label>{{\'LOGIN.PASSWORD\' | translate}}</label>\n<input type="password" name="password" ng-model="vm.user.password" ng-keyup="vm.onKeyUp($event)" tx-focus="true" \nrequired><div ng-messages="loginForm.password.$error" ng-show="loginForm.password.$touched" role="alert"><div \nng-message="required"><span translate="LOGIN.ERRORS.PASSWORD_REQUIRED">Password field is required</span></div></div>\n</md-input-container><div class="md-block users-container" ng-if="vm.multipleUsers"><md-input-container \nclass="md-block"><label>{{\'LOGIN.SEARCH_USER\' | translate}}</label><input type="text" name="searchUserText" \nid="dialog_input_1" name="phone" ng-model="searchUserText" ng-keyup="vm.onKeyUp($event)" tx-focus="true">\n</md-input-container><ul class="multiple-user flex-scrollable" ms-scroll><li id="user-{{user.username}}" \nng-repeat="user in vm.usersList | filter :searchUserText" class="users-list" \nng-class="user.username.toLowerCase() === vm.selectedUser.username.toLowerCase() ? \'highlight-row\' : \'\'" \nng-click="vm.changeUser(user)"><span class="user-icon"><md-icon md-font-icon="icon-account" class="icon s20"></md-icon>\n</span>{{user.username}}</li></ul></div><div class="remember-forgot-password" layout="row" layout-xs="column" \nng-if="vm.loginTypeId === 1 && !vm.multipleUsers" layout-align="space-between center"><a \nng-click="vm.redirectToSetPassword()" class="forgot-password md-accent-color" translate="LOGIN.FORGOT_PASSWORD">\nForgot Password?</a></div></div><div class="button-container"><md-button class="md-raised md-accent" \naria-label="LOGIN.NEXT" ng-click="vm.getUserLoginType()" \nng-if="!vm.loginTypeId  || (vm.loginTypeId && vm.loginTypeId !== 1 && vm.errorCode != 1005 && !vm.multipleUsers)" \nng-disabled="loginForm.$invalid || vm.processing || !vm.loginEnvironment" translate="LOGIN.NEXT" \ntranslate-attr-aria-label="LOGIN.NEXT">NEXT</md-button><md-button ng-click="vm.getMasterToken()" \nclass="md-raised md-accent" aria-label="LOG IN" ng-if="vm.loginTypeId === 1 && !vm.multipleUsers" \nng-disabled="loginForm.$invalid || vm.processing || !vm.loginEnvironment" translate="LOGIN.LOG_IN" \ntranslate-attr-aria-label="LOGIN.LOG_IN">LOG IN</md-button><md-button class="md-raised md-accent btn-browse" \naria-label="LOGIN.BROWSE" ng-click="vm.doLogin()" ng-if="vm.multipleUsers" \nng-disabled="loginForm.$invalid || vm.processing || !vm.selectedUser.username" translate="LOGIN.BROWSE" \ntranslate-attr-aria-label="LOGIN.BROWSE">BROWSE</md-button></div></form></div><div ng-show="vm.processing"><div \nclass="title" translate="LOGIN.PROCESSING">Logging in...</div><md-progress-linear md-mode="indeterminate" \nclass="md-accent"></md-progress-linear></div><div ng-show="!vm.processing && vm.processingExternal"><div \nclass="subhead padding-bottom-30" translate="LOGIN.PROCESSING_EXTERNAL" ng-if="!vm.activeDirectoryLoggingIn">\nPlease enter your credentials in the new popup window...</div><div class="subhead padding-bottom-30" \ntranslate="LOGIN.PROCESSING" ng-if="vm.activeDirectoryLoggingIn">Logging in...</div><md-progress-linear \nmd-mode="indeterminate" class="md-accent padding-bottom-30"></md-progress-linear><md-button \nclass="md-raised md-accent" aria-label="CANCEL" ng-if="vm.processingExternal && !vm.activeDirectoryLoggingIn" \nng-click="vm.cancelExternalLoginWindow()" translate="LOGIN.CANCEL">CANCEL</md-button></div><div \nng-if="vm.requireResetPassword" class="set-password-section"><div class="subhead padding-bottom-30"><div \nng-if="!vm.processing"><p><span translate="LOGIN.REDIRECT_MESSAGE_PREFIX">\nYou need to set your password in order to use the application, please </span><span class="click-here-text" \nng-click="vm.redirectToSetPassword()" translate="LOGIN.CLICK_HERE">click here</span> <span \ntranslate="LOGIN.REDIRECT_MESSAGE_SUFFIX">to reset your password.</span></p><p translate="LOGIN.REDIRECTING_MESSAGE" \ntranslate-values="{remainingTimeToRedirect: vm.remainingTimeToRedirect}">\nYou will be redirected to reset password page in {{vm.remainingTimeToRedirect}} seconds.</p></div></div></div></div>\n</div></div>');
$templateCache.put('app/main/auth/set-password/set-password.html','<div id="set-password" class="flex-scrollable" layout="column" ms-scroll><div id="set-password-form-wrapper" \nlayout="column" layout-align="center center"><div id="set-password-form" class="md-whiteframe-8dp"><div \nclass="logo md-accent-bg"><span>T1</span></div><div class="title" translate="SET_PASSWORD.SET_TITLE">Set Password</div>\n<div class="subtitle" translate="SET_PASSWORD.RESET_SUBTITLE">\nPlease enter a new password and OTP received in your e-mail\xA0and click on reset.</div><div \nclass="text-semibold red-A700-fg padding-bottom-15" ng-show="vm.responseError">{{vm.error}} <span class="text-boxed">\n{{vm.errorCode}}</span></div><form name="forgotPasswordForm" novalidate ng-submit="vm.setPassword()">\n<md-input-container class="md-block otp"><input type="number" name="otp" ng-model="vm.record.otp" \nplaceholder="Secret Code" translate-attr-placeholder="SET_PASSWORD.SECRET_CODE" ng-required="true"><div \nng-messages="forgotPasswordForm.otp.$error" role="alert"><div ng-message="required">\n{{\'SET_PASSWORD.VALIDATIONS.SECRET_CODE_REQUIRED\' | translate}}</div><div ng-message="md-maxlength">\n{{\'VALIDATIONS.MAXLEN\' | translate}}</div><div ng-message="minlength">{{\'VALIDATIONS.PASSWORD_MINLEN\' | translate}}\n</div><div ng-message="pattern">{{\'VALIDATIONS.INVALID_PASSWORD\' | translate}}</div></div></md-input-container>\n<md-input-container class="md-block password"><input type="password" name="password" ng-model="vm.record.newPassword" \nplaceholder="Password" translate-attr-placeholder="SET_PASSWORD.NEW_PASSWORD" ng-required="true" md-maxlength="20"><div\n ng-messages="forgotPasswordForm.password.$error" role="alert"><div ng-message="required">\n{{\'SET_PASSWORD.VALIDATIONS.PASSWORD_REQUIRED\' | translate}}</div><div ng-message="md-maxlength">\n{{\'VALIDATIONS.MAXLEN\' | translate}}</div></div></md-input-container><md-button type="submit" \nclass="md-raised md-accent" aria-label="RESET PASSWORD" \nng-disabled="forgotPasswordForm.$invalid || forgotPasswordForm.$pristine || vm.processing" \ntranslate="SET_PASSWORD.SET_PASSWORD" translate-attr-aria-label="SET_PASSWORD.SET_PASSWORD">SET PASSWORD</md-button>\n</form></div></div></div>');
$templateCache.put('app/main/catalogs/details/catalog-details.html','<div id="catalogs-details" class="page-layout simple tabbed details-view" layout="column"><div class="content"><md-tabs\n md-dynamic-height md-no-ink><md-tab label="{{\'CATALOGS.TABS.CATALOG\' | translate}}" \nmd-on-select="vm.onActiveTabChange(0)" tx-access="{{vm.model.views.privileges.details}}"><tx-data-details \ntx-height-offset="37" tx-is-active="vm.tabIndex === 0" tx-account="vm.catalog" tx-title="vm.title" tx-model="vm.model" \ntx-item-actions="vm.model.views.mainDetails.itemActions" \ntx-item-action-event="vm.doCatalogItemAction(action, account)" tx-is-loading="vm.isLoading" \ntx-refresh-action-event="vm.refreshRecords(false)"></tx-data-details></md-tab><md-tab \nlabel="{{\'CATALOGS.TABS.ATTRIBUTES\' | translate}}" md-on-select="vm.onActiveTabChange(1)" \nng-disabled="!vm.catalog.Status" tx-access="{{vm.attributesModel.views.privileges.list}}"><div class="list-tab" \nlayout="row" flex="100" layout-wrap><ms-widget layout="row" flex="100"><ms-widget-front class="white-bg"><tx-data-table\n tx-is-active="vm.tabIndex === 1" tx-data="vm.attributes" tx-model="vm.attributesModel" tx-view="mainList" \ntx-filtered-data="vm.filteredAttributes" tx-data-filter="global.search" tx-is-loading="vm.isAttributeLoading" \ntx-item-action-event="vm.doAttributesItemAction(action, item)" \ntx-list-action-event="vm.doAttributesListAction(action, selectedItems)" tx-item-click-event="vm.viewAttribute(item)" \ntx-list-action-event="" tx-refresh-action-event="vm.refreshAttributes(true, false)" tx-height-offset="16">\n</tx-data-table></ms-widget-front></ms-widget></div></md-tab><md-tab \nlabel="{{\'CATALOGS.TABS.RESTRICT_ATTRIBUTES\' | translate}}" ng-disabled="vm.isLoading" \nmd-on-select="vm.onActiveTabChange(2)" tx-access="{{::vm.roleBasedRestrictAttributesModel.views.privileges.list}}"><div\n class="list-tab" layout="row" flex="100" layout-wrap><ms-widget layout="row" flex="100"><ms-widget-front \nclass="white-bg"><tx-data-table tx-is-active="vm.tabIndex === 2" tx-data="vm.roleBasedRestrictedAttributes" \ntx-model="vm.roleBasedRestrictAttributesModel" tx-view="mainList" \ntx-filtered-data="vm.filteredRoleBasedRestrictedAttributes" tx-data-filter="global.search" \ntx-item-action-event="vm.doRoleBasedRestrictedAttributesItemAction(action, item)" \ntx-list-action-event="vm.doRoleBasedRestrictedAttributesListAction(action, selectedItems)" \ntx-is-loading="vm.isRoleBasedRestrictedAttributesLoading" \ntx-refresh-action-event="vm.refreshRoleBasedRestrictedAttributes(true, false)" tx-height-offset="16"></tx-data-table>\n</ms-widget-front></ms-widget><md-button class="add-rec-button md-fab md-warn" \nng-click="vm.addOrUpdateAttributeRoleBasedRestriction($event)" \naria-label="vm.roleBasedRestrictAttributesModel.views.mainList.fabAction.label" translate \ntx-access="{{::vm.roleBasedRestrictAttributesModel.views.mainList.fabAction.privilege}}"><md-icon \nmd-font-icon="{{vm.roleBasedRestrictAttributesModel.views.mainList.fabAction.icon}}"></md-icon></md-button></div>\n</md-tab><md-tab label="{{\'CATALOGS.TABS.CONFIGURATIONS\' | translate}}" ng-disabled="!vm.catalog.Status" \nmd-on-select="vm.onActiveTabChange(3)" tx-access="{{vm.configurationsModel.views.privileges.list}}"><div \nclass="list-tab" layout="row" flex="100" layout-wrap><ms-widget layout="row" flex="100"><ms-widget-front \nclass="white-bg"><tx-data-table tx-is-active="vm.tabIndex === 3" tx-data="vm.configurations" \ntx-model="vm.configurationsModel" tx-view="mainList" tx-filtered-data="vm.filteredConfigurations" \ntx-data-filter="global.search" tx-is-loading="vm.isConfigurationLoading" tx-control="vm.dataTableControles" \ntx-item-action-event="vm.doConfigurationsItemAction(action, item)" \ntx-list-action-event="vm.doConfigurationsListAction(action, selectedItems)" \ntx-refresh-action-event="vm.refreshConfigurations(true, false)" tx-height-offset="16"></tx-data-table>\n</ms-widget-front></ms-widget><md-button class="add-rec-button md-fab md-warn" ng-click="vm.addConfiguration($event)" \naria-label="vm.configurationsModel.views.mainList.fabAction.label" translate \ntx-access="{{vm.configurationsModel.views.mainList.fabAction.privilege}}"><md-icon \nmd-font-icon="{{vm.configurationsModel.views.mainList.fabAction.icon}}"></md-icon></md-button></div></md-tab><md-tab \nlabel="{{\'CATALOGS.TABS.CRDS\' | translate}}" md-on-select="vm.onActiveTabChange(4)" ng-disabled="!vm.catalog.Status" \ntx-access="{{vm.CRDModel.views.privileges.list}}"><div class="list-tab" layout="row" flex="100" layout-wrap><ms-widget \nlayout="row" flex="100"><ms-widget-front class="white-bg"><tx-data-table tx-is-active="vm.tabIndex === 4" \ntx-data="vm.CRD" tx-model="vm.CRDModel" tx-view="mainList" tx-filtered-data="vm.filteredCRD" \ntx-data-filter="global.search" tx-is-loading="vm.isCRDLoading" tx-item-action-event="vm.doCRDItemAction(action, item)" \ntx-list-action-event="vm.doCRDListAction(action, selectedItems)" tx-refresh-action-event="vm.refreshCRDs(true, false)" \ntx-height-offset="16" tx-control="vm.tableControl"></tx-data-table></ms-widget-front></ms-widget><md-button \nclass="add-rec-button md-fab md-warn" ng-click="vm.addCRD($event)" \naria-label="vm.CRDModel.views.mainList.fabAction.label" translate \ntx-access="{{vm.CRDModel.views.mainList.fabAction.privilege}}"><md-icon \nmd-font-icon="{{vm.CRDModel.views.mainList.fabAction.icon}}"></md-icon></md-button></div></md-tab><md-tab \nlabel="{{\'CATALOGS.TABS.SHIPMENT_WINDOWS\' | translate}}" md-on-select="vm.onActiveTabChange(5)" \nng-disabled="!vm.catalog.Status || vm.isRetailWindowViewableRestrictedOnRole" \ntx-access="{{vm.shipmentWindowsModel.views.privileges.list}}" ng-if="vm.isShippingWindowApply == 1"><div \nclass="list-tab" layout="row" flex="100" layout-wrap><ms-widget layout="row" flex="100"><ms-widget-front \nclass="white-bg"><tx-data-table tx-is-active="vm.tabIndex === 5" tx-data="vm.shipmentWindows" \ntx-model="vm.shipmentWindowsModel" tx-view="mainList" tx-filtered-data="vm.filteredShipmentWindows" \ntx-data-filter="global.search" tx-is-loading="vm.isShipmentWindowsLoading" tx-height-offset="16" \ntx-item-action-event="vm.doShipmentWindowsItemAction(action, item)" \ntx-list-action-event="vm.doShipmentWindowsListAction(action, selectedItems)" \ntx-refresh-action-event="vm.refreshShipmentWindows(true, false)"></tx-data-table></ms-widget-front></ms-widget>\n<md-button class="add-rec-button md-fab md-warn" ng-click="vm.addShipmentWindow($event)" \naria-label="vm.shipmentWindowsModel.views.mainList.fabAction.label" translate \ntx-access="{{vm.shipmentWindowsModel.views.mainList.fabAction.privilege}}"><md-icon \nmd-font-icon="{{vm.shipmentWindowsModel.views.mainList.fabAction.icon}}"></md-icon></md-button></div></md-tab><md-tab \nlabel="{{\'CATALOGS.TABS.RESTRICT_RETAIL_WINDOWS\' | translate}}" ng-disabled="vm.isLoading" \nmd-on-select="vm.onActiveTabChange(6)" tx-access="{{::vm.roleBasedRestrictRetailWindowsModel.views.privileges.list}}" \nng-if="vm.isShippingWindowApply == 1"><div class="list-tab" layout="row" flex="100" layout-wrap><ms-widget \nlayout="row" flex="100"><ms-widget-front class="white-bg"><tx-data-table tx-is-active="vm.tabIndex === 6" \ntx-data="vm.roleBasedRestrictedRetailWindows" tx-model="vm.roleBasedRestrictRetailWindowsModel" tx-view="mainList" \ntx-filtered-data="vm.filteredRoleBasedRestrictedRetailWindows" tx-data-filter="global.search" \ntx-item-action-event="vm.doRoleBasedRestrictedRetailWindowsItemAction(action, item)" \ntx-list-action-event="vm.doRoleBasedRestrictedRetailWindowsListAction(action, selectedItems)" \ntx-is-loading="vm.isRoleBasedRestrictedRetailWindowsLoading" \ntx-refresh-action-event="vm.refreshRoleBasedRestrictedRetailWindows(true, false)" tx-height-offset="16">\n</tx-data-table></ms-widget-front></ms-widget><md-button class="add-rec-button md-fab md-warn" \nng-click="vm.addOrUpdateRetailWindowRoleBasedRestriction($event)" \naria-label="vm.roleBasedRestrictRetailWindowsModel.views.mainList.fabAction.label" translate \ntx-access="{{::vm.roleBasedRestrictRetailWindowsModel.views.mainList.fabAction.privilege}}"><md-icon \nmd-font-icon="{{vm.roleBasedRestrictRetailWindowsModel.views.mainList.fabAction.icon}}"></md-icon></md-button></div>\n</md-tab><md-tab label="{{\'CATALOGS.TABS.PRICE_GROUP\' | translate}}" md-on-select="vm.onActiveTabChange(7)" \nng-disabled="!vm.catalog.Status" tx-access="{{vm.priceGroupModel.views.privileges.list}}"><div class="list-tab" \nlayout="row" flex="100" layout-wrap><ms-widget layout="row" flex="100"><ms-widget-front class="white-bg"><tx-data-table\n tx-is-active="vm.tabIndex === 7" tx-data="vm.priceGroup" tx-model="vm.priceGroupModel" tx-view="mainList" \ntx-filtered-data="vm.filteredPriceGroup" tx-data-filter="global.search" tx-is-loading="vm.isPriceGroupLoading" \ntx-item-action-event="vm.doPriceGroupItemAction(action, item)" \ntx-list-action-event="vm.doPriceGroupListAction(action, selectedItems)" \ntx-refresh-action-event="vm.refreshPriceGroups(true, false)" tx-height-offset="16"></tx-data-table></ms-widget-front>\n</ms-widget><md-button class="add-rec-button md-fab md-warn" ng-click="vm.addPriceGroup($event)" \naria-label="vm.priceGroupModel.views.mainList.fabAction.label" translate \ntx-access="{{vm.priceGroupModel.views.mainList.fabAction.privilege}}"><md-icon \nmd-font-icon="{{vm.priceGroupModel.views.mainList.fabAction.icon}}"></md-icon></md-button></div></md-tab><md-tab \nlabel="{{\'CATALOGS.TABS.SEGMENTATION_GROUP\' | translate}}" md-on-select="vm.onActiveTabChange(8)" \nng-disabled="!vm.catalog.Status" tx-access="{{vm.segmentationGroupModel.views.privileges.list}}"><div class="list-tab" \nlayout="row" flex="100" layout-wrap><ms-widget layout="row" flex="100"><ms-widget-front class="white-bg"><tx-data-table\n tx-is-active="vm.tabIndex === 8" tx-data="vm.segmentationGroup" tx-model="vm.segmentationGroupModel" \ntx-view="mainList" tx-filtered-data="vm.filteredSegmentationGroups" tx-data-filter="global.search" \ntx-is-loading="vm.isSegmentationGroupLoading" tx-item-action-event="vm.doSegmentationGroupItemAction(action, item)" \ntx-list-action-event="vm.doSegmentationGroupListAction(action, selectedItems)" \ntx-refresh-action-event="vm.refreshSegmentationGroup(true, false)" tx-height-offset="16"></tx-data-table>\n</ms-widget-front></ms-widget><md-button class="add-rec-button md-fab md-warn" \nng-click="vm.addSegmentationGroup($event)" aria-label="vm.segmentationGroupModel.views.mainList.fabAction.label" \ntranslate tx-access="{{vm.segmentationGroupModel.views.mainList.fabAction.privilege}}"><md-icon \nmd-font-icon="{{vm.segmentationGroupModel.views.mainList.fabAction.icon}}"></md-icon></md-button></div></md-tab><md-tab\n label="{{\'CATALOGS.TABS.SEGMENTATIONS\' | translate}}" md-on-select="vm.onActiveTabChange(9)" \nng-disabled="!vm.catalog.Status" tx-access="{{vm.segmentationsModel.views.privileges.list}}"><div class="list-tab" \nlayout="row" flex="100" layout-wrap><ms-widget layout="row" flex="100"><ms-widget-front class="white-bg"><tx-data-table\n tx-is-active="vm.tabIndex === 9" tx-data="vm.segmentations" tx-model="vm.segmentationsModel" tx-view="mainList" \ntx-filtered-data="vm.filteredSegmentations" tx-data-filter="global.search" tx-is-loading="vm.isSegmentationLoading" \ntx-item-action-event="vm.doSegmentationsItemAction(action, item)" \ntx-list-action-event="vm.doSegmentationsListAction(action, selectedItems)" \ntx-refresh-action-event="vm.refreshSegmentations(true, false)" tx-height-offset="16"></tx-data-table></ms-widget-front>\n</ms-widget><md-button class="add-rec-button md-fab md-warn" ng-click="vm.addSegmentation($event)" \naria-label="vm.segmentationsModel.views.mainList.fabAction.label" translate \ntx-access="{{vm.segmentationsModel.views.mainList.fabAction.privilege}}"><md-icon \nmd-font-icon="{{vm.segmentationsModel.views.mainList.fabAction.icon}}"></md-icon></md-button></div></md-tab><md-tab \nlabel="{{\'CATALOGS.TABS.RESTRICT_SEGMENTATIONS\' | translate}}" ng-disabled="vm.isLoading" \nmd-on-select="vm.onActiveTabChange(10)" tx-access="{{::vm.roleBasedRestrictSegmentationsModel.views.privileges.list}}">\n<div class="list-tab" layout="row" flex="100" layout-wrap><ms-widget layout="row" flex="100"><ms-widget-front \nclass="white-bg"><tx-data-table tx-is-active="vm.tabIndex === 10" tx-data="vm.roleBasedRestrictedSegmentations" \ntx-model="vm.roleBasedRestrictSegmentationsModel" tx-view="mainList" \ntx-filtered-data="vm.filteredRoleBasedRestrictedSegmentations" tx-data-filter="global.search" \ntx-item-action-event="vm.doRoleBasedRestrictedSegmentationsItemAction(action, item)" \ntx-list-action-event="vm.doRoleBasedRestrictedSegmentationsListAction(action, selectedItems)" \ntx-is-loading="vm.isRoleBasedRestrictedSegmentationsLoading" \ntx-refresh-action-event="vm.refreshRoleBasedRestrictedSegmentations(true, false)" tx-height-offset="16">\n</tx-data-table></ms-widget-front></ms-widget><md-button class="add-rec-button md-fab md-warn" \nng-click="vm.addOrUpdateSegmentationRoleBasedRestriction($event)" \naria-label="vm.roleBasedRestrictSegmentationsModel.views.mainList.fabAction.label" translate \ntx-access="{{::vm.roleBasedRestrictSegmentationsModel.views.mainList.fabAction.privilege}}"><md-icon \nmd-font-icon="{{vm.roleBasedRestrictSegmentationsModel.views.mainList.fabAction.icon}}"></md-icon></md-button></div>\n</md-tab><md-tab label="{{\'CATALOGS.TABS.SIZE_SCALE_GROUPS\' | translate}}" ng-disabled="!vm.catalog.Status" \nmd-on-select="vm.onActiveTabChange(11)" tx-access="{{::vm.sizeScaleGroupsModel.views.privileges.list}}" \nng-if="vm.isSizeScaleByStyle == 1"><div class="list-tab" layout="row" flex="100" layout-wrap><ms-widget layout="row" \nflex="100"><ms-widget-front class="white-bg"><tx-data-table tx-is-active="vm.tabIndex === 11" \ntx-data="vm.sizeScaleGroups" tx-model="vm.sizeScaleGroupsModel" tx-view="mainList" \ntx-filtered-data="vm.filteredSizeScaleGroups" tx-data-filter="global.search" \ntx-is-loading="vm.isSizeScaleGroupsLoading" \ntx-list-action-event="vm.doSizeScaleGroupsListAction(action, selectedItems)" \ntx-refresh-action-event="vm.refreshSizeScaleGroups(true, false)" tx-height-offset="16"></tx-data-table>\n</ms-widget-front></ms-widget></div></md-tab><md-tab label="{{\'CATALOGS.TABS.STOCK_DEFINITION\' | translate}}" \nng-disabled="!vm.catalog.Status" md-on-select="vm.onActiveTabChange(12)" \ntx-access="{{::vm.stockDefinitionModel.views.privileges.list}}"><div class="list-tab" layout="row" flex="100" \nlayout-wrap><ms-widget layout="row" flex="100"><ms-widget-front class="white-bg"><tx-data-table \ntx-is-active="vm.tabIndex === 12" tx-data="vm.stockDefinition" tx-model="vm.stockDefinitionModel" tx-view="mainList" \ntx-filtered-data="vm.filteredStockDefinition" tx-data-filter="global.search" \ntx-is-loading="vm.isStockDefinitionLoading" \ntx-list-action-event="vm.doStockDefinitionListAction(action, selectedItems)" \ntx-item-action-event="vm.doStockDefinitionItemAction(action, item)" \ntx-refresh-action-event="vm.refreshStockDefinitions(true, false)" tx-height-offset="16"></tx-data-table>\n</ms-widget-front></ms-widget><md-button class="add-rec-button md-fab md-warn" \nng-click="vm.addStockDefinition($event)" aria-label="vm.stockDefinitionModel.views.mainList.fabAction.label" translate \ntx-access="{{vm.stockDefinitionModel.views.mainList.fabAction.privilege}}"><md-icon \nmd-font-icon="{{vm.stockDefinitionModel.views.mainList.fabAction.icon}}"></md-icon></md-button></div></md-tab><md-tab \nlabel="{{\'CATALOGS.TABS.TREE\' | translate}}" ng-disabled="!vm.catalog.Status" \ntx-access="{{vm.treeModel.views.privileges.list}}" md-on-select="vm.onActiveTabChange(13)"><div class="list-tab" \nlayout="row" flex="100" layout-wrap><ms-widget layout="row" flex="100"><ms-widget-front class="white-bg"><tx-data-table\n tx-is-active="vm.tabIndex === 13" tx-data="vm.treeData" tx-model="vm.treeModel" tx-view="mainList" \ntx-filtered-data="vm.filteredTreeData" tx-data-filter="global.search" tx-is-loading="vm.isTreeLoading" \ntx-list-action-event="vm.doTreeListAction(action, selectedItems)" \ntx-item-action-event="vm.doTreeItemAction(action, item)" tx-refresh-action-event="vm.refreshTree(true, false)" \ntx-height-offset="16"></tx-data-table></ms-widget-front></ms-widget><md-button class="add-rec-button md-fab md-warn" \nng-click="vm.addTree($event)" aria-label="vm.treeModel.views.mainList.fabAction.label" translate \ntx-access="{{vm.treeModel.views.mainList.fabAction.privilege}}"><md-icon \nmd-font-icon="{{vm.treeModel.views.mainList.fabAction.icon}}"></md-icon></md-button></div></md-tab><md-tab \nlabel="{{\'CATALOGS.TABS.ATTRIBUTE_VETTING_LIST\' | translate}}" ng-disabled="!vm.catalog.Status" \nmd-on-select="vm.onActiveTabChange(14)" tx-access="{{vm.attributeVettingListModel.views.privileges.list}}"><div \nclass="list-tab" layout="row" flex="100" layout-wrap><ms-widget layout="row" flex="100"><ms-widget-front \nclass="white-bg"><tx-data-table tx-is-active="vm.tabIndex === 14" tx-data=" vm.attributeVettingList" \ntx-model="vm.attributeVettingListModel" tx-view="mainList" tx-filtered-data="vm.filteredAttributeVettingList" \ntx-data-filter="global.search" tx-is-loading="vm.isAttributeVettingListLoading" \ntx-item-action-event="vm.doAttributeVettingListItemAction(action, item)" \ntx-list-action-event="vm.doAttributeVettingListAction(action, selectedItems)" \ntx-refresh-action-event="vm.refreshAttributeVettingList(true, false)" tx-height-offset="16"></tx-data-table>\n</ms-widget-front></ms-widget><md-button class="add-rec-button md-fab md-warn" \nng-click="vm.addAttributeToAttributeVettingList($event)" \naria-label="vm.attributeVettingListModel.views.mainList.fabAction.label" translate \ntx-access="{{vm.attributeVettingListModel.views.mainList.fabAction.privilege}}"><md-icon \nmd-font-icon="{{vm.attributeVettingListModel.views.mainList.fabAction.icon}}"></md-icon></md-button></div></md-tab>\n<md-tab label="{{\'CATALOGS.TABS.SELLER_USERS\' | translate}}" ng-disabled="vm.isLoading" \nmd-on-select="vm.onActiveTabChange(15)" tx-access="{{::vm.sellerUsersListModel.views.privileges.list}}"><div \nclass="list-tab" layout="row" flex="100" layout-wrap><ms-widget layout="row" flex="100"><ms-widget-front \nclass="white-bg"><tx-data-table tx-is-active="vm.tabIndex === 15" tx-data="vm.sellerUserList" \ntx-model="vm.sellerUsersListModel" tx-view="mainList" tx-filtered-data="vm.filteredSellerUserList" \ntx-data-filter="global.search" tx-is-loading="vm.isSellerUserListLoading" \ntx-refresh-action-event="vm.refreshSellerUserList(true, false)" tx-height-offset="16"></tx-data-table>\n</ms-widget-front></ms-widget></div></md-tab><md-tab label="{{\'CATALOGS.TABS.MODEL_LEVEL_ATTRIBUTES\' | translate}}" \nng-disabled="vm.isLoading" md-on-select="vm.onActiveTabChange(16)" ng-if="vm.catalog.IsLinePlan !== 1" \ntx-access="{{::vm.modelLevelAttributesModel.views.privileges.list}}"><div class="list-tab" layout="row" flex="100" \nlayout-wrap><ms-widget layout="row" flex="100"><ms-widget-front class="white-bg"><tx-data-table \ntx-is-active="vm.tabIndex === 16" tx-data="vm.modelLevelAttributes" tx-model="vm.modelLevelAttributesModel" \ntx-view="mainList" tx-filtered-data="vm.filteredModelLevelAttributes" tx-data-filter="global.search" \ntx-is-loading="vm.isModelLevelAttributesLoading" tx-refresh-action-event="vm.refreshModelLevelAttributes(true, false)" \ntx-height-offset="16"></tx-data-table></ms-widget-front></ms-widget><md-button class="add-rec-button md-fab md-warn" \nng-click="vm.assignModelLevelAttributes($event)" \naria-label="vm.modelLevelAttributesModel.views.mainList.fabAction.label" translate \ntx-access="{{::vm.modelLevelAttributesModel.views.mainList.fabAction.privilege}}"><md-icon \nmd-font-icon="{{vm.modelLevelAttributesModel.views.mainList.fabAction.icon}}"></md-icon></md-button></div></md-tab>\n<md-tab label="{{\'CATALOGS.TABS.REQUEST_ATTRIBUTES\' | translate}}" \nng-disabled="vm.isLoading || vm.catalog.RequestsEnabled === 0" md-on-select="vm.onActiveTabChange(17)" \ntx-access="{{::vm.requestAttributesModel.views.privileges.list}}"><div class="list-tab" layout="row" flex="100" \nlayout-wrap><ms-widget layout="row" flex="100"><ms-widget-front class="white-bg"><tx-data-table \ntx-is-active="vm.tabIndex === 17" tx-data="vm.requestAttributes" tx-model="vm.requestAttributesModel" \ntx-view="mainList" tx-filtered-data="vm.filteredRequestAttributes" tx-data-filter="global.search" \ntx-item-action-event="vm.doRequestAttributeItemAction(action, item)" \ntx-list-action-event="vm.doRequestAttributeListAction(action, selectedItems)" \ntx-is-loading="vm.isRequestAttributesLoading" tx-refresh-action-event="vm.refreshRequestAttributes(true, false)" \ntx-height-offset="16"></tx-data-table></ms-widget-front></ms-widget><md-button class="add-rec-button md-fab md-warn" \nng-click="vm.assignRequestAttributes($event)" aria-label="vm.requestAttributesModel.views.mainList.fabAction.label" \ntranslate tx-access="{{::vm.requestAttributesModel.views.mainList.fabAction.privilege}}"><md-icon \nmd-font-icon="{{vm.requestAttributesModel.views.mainList.fabAction.icon}}"></md-icon></md-button></div></md-tab><md-tab\n label="{{\'CATALOGS.TABS.REQUEST_REASONS\' | translate}}" \nng-disabled="vm.isLoading || vm.catalog.RequestsEnabled === 0" md-on-select="vm.onActiveTabChange(18)" \ntx-access="{{::vm.requestReasonsModel.views.privileges.list}}"><div class="list-tab" layout="row" flex="100" \nlayout-wrap><ms-widget layout="row" flex="100"><ms-widget-front class="white-bg"><tx-data-table \ntx-is-active="vm.tabIndex === 18" tx-data="vm.requestReasons" tx-model="vm.requestReasonsModel" tx-view="mainList" \ntx-filtered-data="vm.filteredRequestReasons" tx-data-filter="global.search" \ntx-item-action-event="vm.doRequestReasonsItemAction(action, item)" \ntx-list-action-event="vm.doRequestReasonsListAction(action, selectedItems)" tx-is-loading="vm.isRequestReasonsLoading" \ntx-refresh-action-event="vm.refreshRequestReasons(true, false)" tx-height-offset="16"></tx-data-table>\n</ms-widget-front></ms-widget><md-button class="add-rec-button md-fab md-warn" ng-click="vm.addRequestReasons($event)" \naria-label="vm.requestReasonsModel.views.mainList.fabAction.label" translate \ntx-access="{{::vm.requestReasonsModel.views.mainList.fabAction.privilege}}"><md-icon \nmd-font-icon="{{vm.requestReasonsModel.views.mainList.fabAction.icon}}"></md-icon></md-button></div></md-tab><md-tab \nlabel="{{\'CATALOGS.TABS.BUCKET_ATTRIBUTES\' | translate}}" ng-disabled="vm.isLoading" \nmd-on-select="vm.onActiveTabChange(19)" tx-access="{{::vm.bucketLevelAttributesModel.views.privileges.list}}"><div \nclass="list-tab" layout="row" flex="100" layout-wrap><ms-widget layout="row" flex="100"><ms-widget-front \nclass="white-bg"><tx-data-table tx-is-active="vm.tabIndex === 19" tx-data="vm.bucketLevelAttributes" \ntx-model="vm.bucketLevelAttributesModel" tx-view="mainList" tx-filtered-data="vm.filteredBucketLevelAttributes" \ntx-data-filter="global.search" tx-item-action-event="vm.doBucketLevelAttributeItemAction(action, item)" \ntx-list-action-event="vm.doBucketLevelAttributeListAction(action, selectedItems)" \ntx-is-loading="vm.isBucketLevelAttributesLoading" \ntx-refresh-action-event="vm.refreshBucketLevelAttributes(true, false)" tx-height-offset="16"></tx-data-table>\n</ms-widget-front></ms-widget><md-button class="add-rec-button md-fab md-warn" \nng-click="vm.assignBucketLevelAttributes($event)" \naria-label="vm.bucketLevelAttributesModel.views.mainList.fabAction.label" translate \ntx-access="{{::vm.bucketLevelAttributesModel.views.mainList.fabAction.privilege}}"><md-icon \nmd-font-icon="{{vm.bucketLevelAttributesModel.views.mainList.fabAction.icon}}"></md-icon></md-button></div></md-tab>\n<md-tab label="{{\'CATALOGS.TABS.RESTRICT_BUCKET_ATTRIBUTES\' | translate}}" ng-disabled="vm.isLoading" \nmd-on-select="vm.onActiveTabChange(20)" tx-access="{{::vm.restrictBucketAttributesRolesModel.views.privileges.list}}">\n<div class="list-tab" layout="row" flex="100" layout-wrap><ms-widget layout="row" flex="100"><ms-widget-front \nclass="white-bg"><tx-data-table tx-is-active="vm.tabIndex === 20" tx-data="vm.restrictBucketAttributes" \ntx-model="vm.restrictBucketAttributesRolesModel" tx-view="mainList" \ntx-filtered-data="vm.filteredRestrictBucketAttributes" tx-data-filter="global.search" \ntx-item-action-event="vm.doRestrictBucketAttributesItemAction(action, item)" \ntx-list-action-event="vm.doRestrictBucketAttributesListAction(action, selectedItems)" \ntx-is-loading="vm.isRestrictBucketAttributesLoading" \ntx-refresh-action-event="vm.refreshRestrictBucketAttributes(true, false)" tx-height-offset="16"></tx-data-table>\n</ms-widget-front></ms-widget><md-button class="add-rec-button md-fab md-warn" \nng-click="vm.addRestrictBucketAttributesRoles($event)" \naria-label="vm.restrictBucketAttributesRolesModel.views.mainList.fabAction.label" translate \ntx-access="{{::vm.restrictBucketAttributesRolesModel.views.mainList.fabAction.privilege}}"><md-icon \nmd-font-icon="{{vm.restrictBucketAttributesRolesModel.views.mainList.fabAction.icon}}"></md-icon></md-button></div>\n</md-tab><md-tab label="{{\'CATALOGS.TABS.LINKED_CATALOGS\' | translate}}" md-on-select="vm.onActiveTabChange(21)" \nng-disabled="!vm.catalog.Status" tx-access="{{vm.model.views.privileges.details}}"><div class="list-tab" layout="row" \nflex="100" layout-wrap><ms-widget layout="row" flex="100"><ms-widget-front class="white-bg"><tx-data-table \ntx-is-active="vm.tabIndex === 21" tx-data="vm.linkedCatalogs" tx-model="vm.linkedCatalogsModel" tx-view="mainList" \ntx-filtered-data="vm.filteredLinkedCatalogs" tx-data-filter="global.search" tx-is-loading="vm.isLoading" \ntx-item-action-event="vm.doLinkedCatalogsItemAction(action, item)" tx-item-click-event="vm.viewLinkedCatalog(item)" \ntx-list-action-event="" tx-refresh-action-event="vm.refreshRecords(false)" tx-height-offset="16"></tx-data-table>\n</ms-widget-front></ms-widget></div></md-tab><md-tab label="{{\'CATALOGS.TABS.LINKED_ATTRIBUTES\' | translate}}" \nmd-on-select="vm.onActiveTabChange(22)" ng-if="vm.catalog.IsLinePlan === 1" ng-disabled="!vm.catalog.Status" \ntx-access="{{vm.model.views.privileges.details}}"><div class="list-tab" layout="row" flex="100" layout-wrap><ms-widget \nlayout="row" flex="100"><ms-widget-front class="white-bg"><tx-data-table tx-is-active="vm.tabIndex === 22" \ntx-data="vm.linkedAttributes" tx-model="vm.linkedAttributesModel" tx-view="mainList" \ntx-filtered-data="vm.filteredLinkedAttributes" tx-data-filter="global.search" tx-is-loading="vm.isLoading" \ntx-item-action-event="vm.doLinkedAttributesItemAction(action, item)" \ntx-item-click-event="vm.viewLinkedAttribute(item)" \ntx-list-action-event="vm.doLinkedAttributesListAction(action, selectedItems)" \ntx-refresh-action-event="vm.refreshRecords(false)" tx-height-offset="16"></tx-data-table></ms-widget-front></ms-widget>\n</div></md-tab><md-tab label="{{\'CATALOGS.TABS.TARGETED_ATTRIBUTES\' | translate}}" \nmd-on-select="vm.onActiveTabChange(23)" ng-if="vm.targetedAttributes.length" ng-disabled="!vm.catalog.Status" \ntx-access="{{vm.model.views.privileges.details}}"><div class="list-tab" layout="row" flex="100" layout-wrap><ms-widget \nlayout="row" flex="100"><ms-widget-front class="white-bg"><tx-data-table tx-is-active="vm.tabIndex === 23" \ntx-data="vm.targetedAttributes" tx-model="vm.targetedAttributesModel" tx-view="mainList" \ntx-filtered-data="vm.filteredTargetedAttributes" tx-data-filter="global.search" tx-is-loading="vm.isLoading" \ntx-item-action-event="vm.doTargetedAttributesItemAction(action, item)" \ntx-item-click-event="vm.viewTargetedAttribute(item)" tx-list-action-event="" \ntx-refresh-action-event="vm.refreshRecords(false)" tx-height-offset="16"></tx-data-table></ms-widget-front></ms-widget>\n</div></md-tab><md-tab label="{{\'CATALOGS.TABS.AGGREGATE_ATTRIBUTES\' | translate}}" \nmd-on-select="vm.onActiveTabChange(24)" ng-if="vm.targetedAttributes.length" ng-disabled="!vm.catalog.Status" \ntx-access="{{vm.model.views.privileges.details}}"><div class="list-tab" layout="row" flex="100" layout-wrap><ms-widget \nlayout="row" flex="100"><ms-widget-front class="white-bg"><tx-data-table tx-is-active="vm.tabIndex === 24" \ntx-data="vm.aggregateAttributes" tx-model="vm.aggregateAttributesModel" tx-view="mainList" \ntx-filtered-data="vm.filteredAggregateAttributes" tx-data-filter="global.search" tx-is-loading="vm.isLoading" \ntx-item-action-event="vm.doAggregateAttributesItemAction(action, item)" \ntx-item-click-event="vm.viewAggregateAttribute(item)" tx-refresh-action-event="vm.refreshRecords(false)" \ntx-height-offset="16"></tx-data-table></ms-widget-front></ms-widget></div></md-tab><md-tab \nlabel="{{\'CATALOGS.TABS.CATALOG_COLOR_PALETTE\' | translate}}" md-on-select="vm.onActiveTabChange(25)" \ntx-access="{{::vm.colorPaletteModelCopy.views.privileges.list}}"><div class="list-tab" layout="row" flex="100" \nlayout-wrap><ms-widget layout="row" flex="100"><ms-widget-front class="white-bg"><tx-data-table \ntx-is-active="vm.tabIndex === 25" tx-data="vm.colorPalette" tx-model="vm.colorPaletteModelCopy" tx-view="mainList" \ntx-filtered-data="vm.filteredColorPalette" tx-data-filter="global.search" tx-is-loading="vm.isColorPaletteLoading" \ntx-list-action-event="vm.doColorPaletteListAction(action, selectedItems)" \ntx-item-action-event="vm.doColorPaletteItemAction(action, item)" \ntx-refresh-action-event="vm.refreshColorPalette(true, false)" tx-height-offset="16"></tx-data-table></ms-widget-front>\n</ms-widget><md-button class="add-rec-button md-fab md-warn" ng-click="vm.addUpdateColorPalette($event)" \naria-label="vm.colorPaletteModelCopy.views.mainList.fabAction.label" translate \ntx-access="{{::vm.colorPaletteModelCopy.views.mainList.fabAction.privilege}}" \nng-show="vm.colorPaletteModelCopy.views.mainList.fabAction.visible"><md-icon \nmd-font-icon="{{vm.colorPaletteModelCopy.views.mainList.fabAction.icon}}"></md-icon></md-button></div></md-tab><md-tab \nlabel="{{\'CATALOGS.TABS.COLOR_DEFINITION\' | translate}}" \nng-disabled="vm.isLoading || vm.catalog.DataSourceTypeId !== 1" md-on-select="vm.onActiveTabChange(26)" \ntx-access="{{::vm.colorDefinitionModel.views.privileges.list}}"><div class="list-tab" layout="row" flex="100" \nlayout-wrap><ms-widget layout="row" flex="100"><ms-widget-front class="white-bg"><tx-data-table \ntx-is-active="vm.tabIndex === 26" tx-data="vm.colorDefinitions" tx-model="vm.colorDefinitionModel" tx-view="mainList" \ntx-filtered-data="vm.filteredColorDefinitions" tx-data-filter="global.search" \ntx-item-action-event="vm.doColorDefinitionItemAction(action, item)" \ntx-list-action-event="vm.doColorDefinitionListAction(action, selectedItems)" \ntx-is-loading="vm.isColorDefinitionsLoading" tx-refresh-action-event="vm.refreshColorDefinitions(true, false)" \ntx-height-offset="16"></tx-data-table></ms-widget-front></ms-widget><md-button class="add-rec-button md-fab md-warn" \nng-click="vm.addColorDefinition($event)" aria-label="vm.colorDefinitionModel.views.mainList.fabAction.label" translate \ntx-access="{{::vm.colorDefinitionModel.views.mainList.fabAction.privilege}}"><md-icon \nmd-font-icon="{{vm.colorDefinitionModel.views.mainList.fabAction.icon}}"></md-icon></md-button></div></md-tab><md-tab \nlabel="{{\'CATALOGS.TABS.RELATION_TYPES\' | translate}}" md-on-select="vm.onActiveTabChange(27)" \nng-if="vm.catalog.IsLive === 1" ng-disabled="!vm.catalog.Status" \ntx-access="{{vm.relationTypesModelCopy.views.privileges.list}}"><div class="list-tab" layout="row" flex="100" \nlayout-wrap><ms-widget layout="row" flex="100"><ms-widget-front class="white-bg"><tx-data-table \ntx-is-active="vm.tabIndex === 27" tx-data="vm.relationTypes" tx-model="vm.relationTypesModelCopy" tx-view="mainList" \ntx-filtered-data="vm.filteredRelationTypes" tx-data-filter="global.search" tx-is-loading="vm.isRelationTypesLoading" \ntx-item-action-event="vm.doRelationTypesItemAction(action, item)" \ntx-list-action-event="vm.doRelationTypesListAction(action, selectedItems)" \ntx-refresh-action-event="vm.refreshRelationTypes(true, false)" tx-height-offset="16"></tx-data-table></ms-widget-front>\n</ms-widget><md-button class="add-rec-button md-fab md-warn" ng-click="vm.addRelationTypes($event)" \naria-label="vm.relationTypesModelCopy.views.mainList.fabAction.label" translate \ntx-access="{{::vm.relationTypesModelCopy.views.mainList.fabAction.privilege}}" \nng-show="vm.relationTypesModelCopy.views.mainList.fabAction.visible"><md-icon \nmd-font-icon="{{vm.relationTypesModelCopy.views.mainList.fabAction.icon}}"></md-icon></md-button></div></md-tab><md-tab\n label="{{\'CATALOGS.TABS.DATASETS\' | translate}}" md-on-select="vm.onActiveTabChange(28)" \nng-disabled="!vm.catalog.Status" tx-access="{{vm.datasetDefinitionsModelCopy.views.privileges.list}}"><div \nclass="list-tab" layout="row" flex="100" layout-wrap><ms-widget layout="row" flex="100"><ms-widget-front \nclass="white-bg"><tx-data-table tx-is-active="vm.tabIndex === 28" tx-data="vm.datasetDefinitions" \ntx-model="vm.datasetDefinitionsModelCopy" tx-view="mainList" tx-filtered-data="vm.filteredDatasetDefinitions" \ntx-data-filter="global.search" tx-is-loading="vm.isDatasetDefinitionsLoading" \ntx-item-action-event="vm.doDatasetDefinitionItemAction(action, item)" \ntx-item-click-event="vm.viewDatasetDefinition(item)" \ntx-refresh-action-event="vm.refreshDatasetDefinitions(true, false)" tx-height-offset="16"></tx-data-table>\n</ms-widget-front></ms-widget></div></md-tab></md-tabs><md-button id="txfab" class="md-fab md-warn" \nng-if="vm.tabIndex === 0" ng-click="vm.editItem(vm.catalog, $event)" aria-label="vm.model.views.mainDetails.fab.label" \ntranslate tx-access="{{::vm.model.views.mainDetails.fab.privilege}}"><md-icon \nmd-font-icon="{{vm.model.views.mainDetails.fab.icon}}"></md-icon></md-button></div></div>');
$templateCache.put('app/main/catalogs/dialogs/create-catalog.html','<md-dialog class="edit-dialog" \naria-label="{{vm.isCopyCatalog ? \'Copy Catalog\' : (vm.isNew && !vm.isCopyCatalog) ? \'New Catalog\' : \'Edit Catalog\'}}">\n<form name="vm.editForm" class="md-inline-form"><md-toolbar class="md-accent md-hue-2"><div class="md-toolbar-tools" \nlayout="row" layout-align="space-between center"><span class="title" \ntranslate="{{vm.isCopyCatalog ? \'CATALOGS.ACTIONS.COPY_CATALOG\' : (vm.isNew && !vm.isCopyCatalog) ? \'CATALOGS.ACTIONS.NEW_CATALOG\' : \'CATALOGS.ACTIONS.EDIT_CATALOG\'}}">\n</span><md-button class="md-icon-button" ng-click="vm.closeDialog(vm.isDataDirty)" aria-label="Close dialog" tranlate \ntranslate-aria-label="ACTIONS.DIALOG_CLOSE"><md-icon md-font-icon="icon-close"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div layout="row" layout-wrap><div flex="100" flex-gt-xs="50" class="p-5">\n<md-input-container class="md-block"><label translate>CATALOGS.FIELDS.SEASON</label><input \nid="catalog_dialog_input_first" name="Season" ng-model="vm.record.Season" type="text" ng-required="true" \nmd-maxlength="100" md-autofocus><div ng-messages="vm.editForm.Season.$error" role="alert" multiple="multiple"><div \nng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div><div ng-message="md-maxlength">\n{{\'VALIDATIONS.MAXLEN\' | translate}}</div></div></md-input-container></div><div flex="100" flex-gt-xs="50" class="p-5">\n<md-input-container class="md-block"><label translate>CATALOGS.FIELDS.YEAR</label><input id="catalog_dialog_input_0" \nname="Year" ng-model="vm.record.Year" type="number" ng-required="true"><div ng-messages="vm.editForm.Year.$error" \nrole="alert" multiple="multiple"><div ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div></div>\n</md-input-container></div><div flex="100" flex-gt-xs="50" class="p-5 lookup-element" \nng-if="vm.isNew && !vm.isCopyCatalog"><md-autocomplete id="catalog_dialog_input_1" md-input-name="DataSourceTypeId" \nmd-selected-item="vm.lookupModel.DataSourceTypeId" \nmd-items="item in vm.lookupSearch(vm.searchText.DataSourceTypeId, \'DataSourceTypeId\')" \nmd-search-text="vm.searchText.DataSourceTypeId" md-item-text="vm.getLookupDisplayValue(item, \'lists.dataSourceTypes\')" \nmd-min-length="0" md-floating-label="{{\'CATALOGS.FIELDS.DATA_SOURCE_TYPE\' | translate}}" ng-required="true" \nmd-no-cache="true" tx-clear-autocomplete tx-force-select ng-click="vm.selectText($event)" \nmd-selected-item-change="vm.onDataSourceChange(vm.lookupModel.DataSourceTypeId, \'DataSourceTypeId\')" \nmd-menu-class="autocomplete-custom"><md-item-template><span class="autocomplete-item md-accent-fg" \nmd-highlight-text="vm.searchText.DataSourceTypeId" md-highlight-flags="i">{{item.value}}</span></md-item-template>\n<md-not-found>No Record matching "{{vm.searchText.DataSourceTypeId}}" were found.</md-not-found><div \nng-messages="vm.editForm.DataSourceTypeId.$error" role="alert" ng-show="vm.editForm.DataSourceTypeId.$touched" \nmultiple="multiple"><div ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div></div></md-autocomplete>\n</div><div flex="100" flex-gt-xs="50" class="p-5" ng-if="vm.isCopyCatalog"><md-input-container class="md-block"><label \ntranslate>CATALOGS.FIELDS.SOURCE_CATALOG</label><input id="catalog_dialog_input_2" name="SourceCatalog" \nng-model="vm.sourceCatalogDisplayVal" type="text" ng-required="true" md-maxlength="100" ng-disabled="true"><div \nng-messages="vm.editForm.SourceCatalog.$error" role="alert" multiple="multiple"><div ng-message="required">\n{{\'VALIDATIONS.REQUIRED\' | translate}}</div><div ng-message="md-maxlength">{{\'VALIDATIONS.MAXLEN\' | translate}}</div>\n</div></md-input-container></div><div flex="100" flex-gt-xs="50" class="p-5 lookup-element" ng-if="!vm.isCopyCatalog">\n<md-autocomplete id="catalog_dialog_input_3" md-input-name="AccountId" md-selected-item="vm.lookupModel.AccountId" \nmd-items="item in vm.lookupSearch(vm.searchText.AccountId, \'AccountId\')" md-search-text="vm.searchText.AccountId" \nmd-item-text="vm.getLookupDisplayValue(item, \'accounts.sellers\')" md-min-length="0" \nmd-floating-label="{{\'CATALOGS.FIELDS.SELLER_ACCOUNT\' | translate}}" ng-required="true" md-no-cache="true" \ntx-clear-autocomplete tx-force-select ng-click="vm.selectText($event)" \nmd-selected-item-change="vm.onSellerAccountChange(vm.lookupModel.AccountId, \'AccountId\')" \nmd-menu-class="autocomplete-custom" ng-disabled="!vm.isNew"><md-item-template><span \nclass="autocomplete-item md-accent-fg" md-highlight-text="vm.searchText.AccountId" md-highlight-flags="i">\n{{item.value}}</span></md-item-template><md-not-found>No Record matching "{{vm.searchText.AccountId}}" were found.\n</md-not-found><div ng-messages="vm.editForm.AccountId.$error" role="alert" ng-show="vm.editForm.AccountId.$touched" \nmultiple="multiple"><div ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div></div></md-autocomplete>\n</div><div flex="100" class="p-5 lookup-element" ng-if="vm.isNew && !vm.isCopyCatalog"><md-input-container \nclass="md-block"><label>{{\'CATALOGS.FIELDS.REFERENCE_CATAOG_CODE\' | translate}}</label><md-chips \nid="catalog_dialog_input_5" name="ReferenceCatalogCode" ng-model="vm.record.ReferenceCatalogCode" md-autocomplete-snap \nng-change="vm.onRefCatalogChange(vm.record.ReferenceCatalogCode, true)" \nmd-transform-chip="vm.transformChip($chip, \'ReferenceCatalogCode\' )" md-max-chips="{{vm.maxChips}}" \nmd-require-match="true" ng-required="vm.record.DataSourceTypeId == 3"><md-autocomplete \nmd-selected-item="vm.acSelectedItem.ReferenceCatalogCode" md-search-text="vm.acSearchText.ReferenceCatalogCode" \nmd-items="item in vm.refCatalogSearch(vm.acSearchText.ReferenceCatalogCode, vm.record.ReferenceCatalogCode)" \nmd-item-text="item.value" ng-disabled="vm.record.DataSourceTypeId !== 3" md-min-length="0" md-no-cache="true" \nmd-menu-class="autocomplete-custom"><md-item-template><span class="autocomplete-item md-accent-fg" \nmd-highlight-text="vm.acSearchText[field.field]">{{item.value}}</span></md-item-template><md-not-found>\nNo Record matching "{{vm.acSearchText.ReferenceCatalogCode}}" were found.</md-not-found></md-autocomplete>\n<md-chip-template><span><strong>{{vm.getChipDisplayValue($chip, \'ReferenceCatalogCode\')}}</strong></span>\n</md-chip-template></md-chips><div class="md-chips-messages" ng-messages="vm.editForm.ReferenceCatalogCode.$error" \nng-show="vm.editForm.ReferenceCatalogCode.$dirty || vm.editForm.ReferenceCatalogCode.$submitted"><div \nng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div><div ng-message="md-max-chips">\n{{\'VALIDATIONS.MAXLEN\'| translate}}</div></div></md-input-container></div><div flex="100" class="p-5 lookup-element" \nng-if="!vm.isCopyCatalog"><md-input-container class="md-block"><label>{{\'CATALOGS.FIELDS.LINKED_CATAOG\' | translate}}\n</label><md-chips id="catalog_dialog_input_5" name="LinkedCatalogs" ng-model="vm.record.LinkedCatalogs" \nmd-autocomplete-snap ng-change="vm.onRefCatalogChange(vm.record.LinkedCatalogs)" \nmd-transform-chip="vm.transformChip($chip, \'LinkedCatalogs\' )" md-max-chips="{{vm.linkedCatalogMaxChips}}" \nmd-require-match="true"><md-autocomplete md-selected-item="vm.acSelectedItem.LinkedCatalogs" \nmd-search-text="vm.acSearchText.LinkedCatalogs" \nmd-items="item in vm.refCatalogSearch(vm.acSearchText.LinkedCatalogs, vm.record.LinkedCatalogs)" \nmd-item-text="item.value" md-min-length="0" md-no-cache="true" md-menu-class="autocomplete-custom"><md-item-template>\n<span class="autocomplete-item md-accent-fg" md-highlight-text="vm.acSearchText[field.field]">{{item.value}}</span>\n</md-item-template><md-not-found>No Record matching "{{vm.acSearchText.LinkedCatalogs}}" were found.</md-not-found>\n</md-autocomplete><md-chip-template><span><strong>{{vm.getChipDisplayValue($chip, \'LinkedCatalogs\')}}</strong></span>\n</md-chip-template></md-chips><div class="md-chips-messages" ng-messages="vm.editForm.LinkedCatalogs.$error" \nng-show="vm.editForm.ReferenceCatalogCode.$dirty || vm.editForm.ReferenceCatalogCode.$submitted"><div \nng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div><div ng-message="md-max-chips">\n{{\'VALIDATIONS.MAXLEN\'| translate}}</div></div></md-input-container></div><div flex="100" flex-gt-xs="50" \nclass="p-5 lookup-element" ng-if="!vm.isCopyCatalog"><md-autocomplete id="catalog_dialog_input_7" \nmd-input-name="ReferenceLineArchCatalog" md-selected-item="vm.lookupModel.ReferenceLineArchCatalog" \nmd-items="item in vm.lookupSearch(vm.searchText.ReferenceLineArchCatalog, \'ReferenceLineArchCatalog\')" \nmd-search-text="vm.searchText.ReferenceLineArchCatalog" \nmd-item-text="vm.getLookupDisplayValue(item, \'catalogs.catalogs\')" md-min-length="0" \nmd-floating-label="{{\'CATALOGS.FIELDS.REFERENCE_LINE_ARCH_CATALOG\' | translate}}" \nng-disabled="vm.record.DataSourceTypeId !== 1" md-no-cache="true" tx-clear-autocomplete \nng-click="vm.selectText($event)" \nmd-selected-item-change="vm.onLookupChange(vm.lookupModel.ReferenceLineArchCatalog, \'ReferenceLineArchCatalog\')" \nmd-menu-class="autocomplete-custom"><md-item-template><span class="autocomplete-item md-accent-fg" \nmd-highlight-text="vm.searchText.ReferenceLineArchCatalog" md-highlight-flags="i">{{item.value}}</span>\n</md-item-template><md-not-found>No Record matching "{{vm.searchText.ReferenceLineArchCatalog}}" were found.\n</md-not-found><div ng-messages="vm.editForm.ReferenceLineArchCatalog.$error" role="alert" \nng-show="vm.editForm.ReferenceLineArchCatalog.$touched" multiple="multiple"><div ng-message="required">\n{{\'VALIDATIONS.REQUIRED\' | translate}}</div></div></md-autocomplete></div><div flex="100" flex-gt-xs="50" class="p-5">\n<md-input-container class="md-block"><label translate>CATALOGS.FIELDS.CATALOG_NAME</label><input \nid="catalog_dialog_input_4" name="CatalogName" ng-model="vm.record.CatalogName" type="text" ng-required="true" \nmd-maxlength="100" tx-unique-value="vm.existingRecordsForUniqueValue:CatalogName:true"><div \nng-messages="vm.editForm.CatalogName.$error" role="alert" multiple="multiple"><div ng-message="required">\n{{\'VALIDATIONS.REQUIRED\' | translate}}</div><div ng-message="pattern">{{ \'VALIDATIONS.PATTERN\' | translate}}</div><div \nng-message="md-maxlength">{{\'VALIDATIONS.MAXLEN\' | translate}}</div><div ng-message="tx-unique-value">\n{{\'VALIDATIONS.NOT_UNIQUE\' | translate}}</div></div></md-input-container></div><div flex="100" flex-gt-xs="50" \nclass="p-5 lookup-element" ng-if="vm.isCopyCatalog"><md-autocomplete id="catalog_dialog_input_5" \nmd-input-name="NewReferenceCatalogCode" md-selected-item="vm.lookupModel.NewReferenceCatalogCode" \nmd-items="item in vm.serachNewReferenceCatalog(vm.searchText.NewReferenceCatalogCode)" \nmd-search-text="vm.searchText.NewReferenceCatalogCode" \nmd-item-text="vm.getLookupDisplayValue(item, \'catalogs.catalogs\')" md-min-length="0" \nmd-floating-label="{{\'CATALOGS.FIELDS.NEW_REFERENCE_CATAOG_CODE\' | translate}}" \nng-required="vm.record.DataSourceTypeId === 3" \nng-disabled="vm.record.DataSourceTypeId !== 3 || !vm.record.SourceCatalog" md-no-cache="true" tx-clear-autocomplete \nng-click="vm.selectText($event)" \nmd-selected-item-change="vm.onNewReferenceCatalogChange(vm.lookupModel.NewReferenceCatalogCode, \'NewReferenceCatalogCode\')" \nmd-menu-class="autocomplete-custom"><md-item-template><span class="autocomplete-item md-accent-fg" \nmd-highlight-text="vm.searchText.NewReferenceCatalogCode" md-highlight-flags="i">{{item.CatalogName}}</span>\n</md-item-template><md-not-found>No Record matching "{{vm.searchText.NewReferenceCatalogCode}}" were found.\n</md-not-found><div ng-messages="vm.editForm.NewReferenceCatalogCode.$error" role="alert" \nng-show="vm.editForm.NewReferenceCatalogCode.$touched" multiple="multiple"><div ng-message="required">\n{{\'VALIDATIONS.REQUIRED\' | translate}}</div></div></md-autocomplete></div><div flex="100" flex-gt-xs="50" class="p-5" \nng-if="!vm.isCopyCatalog"><md-input-container class="md-block"><label>{{\'CATALOGS.FIELDS.STATE\' | translate}}</label>\n<md-select id="catalog_dialog_input_6" name="State" ng-model="vm.record.State" \naria-label="{{\'CATALOGS.FIELDS.STATE\' | translate}}"><md-option value="Draft">Draft</md-option><md-option value="Demo">\nDemo</md-option><md-option value="Live">Live</md-option></md-select></md-input-container></div><div flex="100" \nflex-gt-xs="50" class="p-5 lookup-element" ng-if="vm.isNew && !vm.isCopyCatalog"><md-autocomplete \nid="catalog_dialog_input_7" md-input-name="AttributeGroupId" md-selected-item="vm.lookupModel.AttributeGroupId" \nmd-items="item in vm.lookupSearch(vm.searchText.AttributeGroupId, \'AttributeGroupId\')" \nmd-search-text="vm.searchText.AttributeGroupId" \nmd-item-text="vm.getLookupDisplayValue(item, \'attributes.attributeGroups\')" md-min-length="0" \nmd-floating-label="{{\'CATALOGS.FIELDS.ATTRIBUTE_GROUP_NAME\' | translate}}" \nng-required="vm.record.DataSourceTypeId === 1 || vm.record.DataSourceTypeId === 4" \nng-disabled="vm.record.DataSourceTypeId === 2 || vm.record.DataSourceTypeId === 3" md-no-cache="true" \ntx-clear-autocomplete ng-click="vm.selectText($event)" \nmd-selected-item-change="vm.onLookupChange(vm.lookupModel.AttributeGroupId, \'AttributeGroupId\')" \nmd-menu-class="autocomplete-custom"><md-item-template><span class="autocomplete-item md-accent-fg" \nmd-highlight-text="vm.searchText.AttributeGroupId" md-highlight-flags="i">{{item.value}}</span></md-item-template>\n<md-not-found>No Record matching "{{vm.searchText.AttributeGroupId}}" were found.</md-not-found><div \nng-messages="vm.editForm.AttributeGroupId.$error" role="alert" ng-show="vm.editForm.AttributeGroupId.$touched" \nmultiple="multiple"><div ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div></div></md-autocomplete>\n</div><div flex="100" flex-gt-xs="50" class="p-5 lookup-element" ng-if="!vm.isCopyCatalog"><md-autocomplete \nid="catalog_dialog_input_8" md-input-name="OrderPluginId" md-selected-item="vm.lookupModel.OrderPluginId" \nmd-items="item in vm.lookupSearch(vm.searchText.OrderPluginId, \'OrderPluginId\')" \nmd-search-text="vm.searchText.OrderPluginId" md-item-text="vm.getLookupDisplayValue(item, \'plugins.orderPlugins\')" \nmd-min-length="0" md-floating-label="{{\'CATALOGS.FIELDS.ORDER_PLUGIN\' | translate}}" md-no-cache="true" \ntx-clear-autocomplete ng-click="vm.selectText($event)" \nmd-selected-item-change="vm.onLookupChange(vm.lookupModel.OrderPluginId, \'OrderPluginId\')" \nmd-menu-class="autocomplete-custom"><md-item-template><span class="autocomplete-item md-accent-fg" \nmd-highlight-text="vm.searchText.OrderPluginId" md-highlight-flags="i">{{item.value}}</span></md-item-template>\n<md-not-found>No Record matching "{{vm.searchText.OrderPluginId}}" were found.</md-not-found></md-autocomplete></div>\n<div flex="100" flex-gt-xs="50" class="p-5 lookup-element" ng-if="!vm.isCopyCatalog"><md-autocomplete \nid="catalog_dialog_input_9" md-input-name="ArticleReplacementAttributeId" \nmd-selected-item="vm.lookupModel.ArticleReplacementAttributeId" \nmd-items="item in vm.lookupSearchArticleReplacementAttribute(vm.searchText.ArticleReplacementAttributeId, \'ArticleReplacementAttributeId\')" \nmd-search-text="vm.searchText.ArticleReplacementAttributeId" \nmd-item-text="vm.getArticleReplecementAttributeLookupDisplayValue(item, \'attributes.attributes\')" md-min-length="0" \nmd-floating-label="{{\'CATALOGS.FIELDS.ARTICLE_REPLACEMENT_ATTRIBUTE\' | translate}}" md-no-cache="true" \ntx-clear-autocomplete ng-click="vm.selectText($event)" md-select-on-match \nmd-selected-item-change="vm.onArticleReplecementAttributeLookupChange(vm.lookupModel.ArticleReplacementAttributeId, \'ArticleReplacementAttributeId\')" \nmd-menu-class="autocomplete-custom" \nng-disabled="(vm.isNew && vm.record.DataSourceTypeId === 3 && !vm.record.ReferenceCatalogCode[0]) || (vm.isNew && vm.record.DataSourceTypeId !== 3 && !vm.record.AttributeGroupId)">\n<md-item-template><span class="autocomplete-item md-accent-fg" \nmd-highlight-text="vm.searchText.ArticleReplacementAttributeId" md-highlight-flags="i">{{item.value}}</span>\n</md-item-template><md-not-found>No Record matching "{{vm.searchText.ArticleReplacementAttributeId}}" were found.\n</md-not-found></md-autocomplete></div><div flex="100" flex-gt-xs="50" class="p-5" \nng-if="!vm.isNew && vm.lookupModel.IsLinePlan !== 1"><md-autocomplete id="catalog_dialog_input_10" \nmd-input-name="BuyerLimitPriceGroupId" md-selected-item="vm.lookupModel.BuyerLimitPriceGroupId" \nmd-items="item in vm.lookupSearchBuyerLimitPriceGroup(vm.searchText.BuyerLimitPriceGroupId, \'BuyerLimitPriceGroupId\')" \nmd-search-text="vm.searchText.BuyerLimitPriceGroupId" \nmd-item-text="vm.getBuyerLimitPriceGroupLookupDisplayValue(item)" md-min-length="0" \nmd-floating-label="{{\'CATALOGS.FIELDS.BUYER_LIMIT_PRICEGROUP\' | translate}}" md-no-cache="true" tx-clear-autocomplete \nng-click="vm.selectText($event)" md-select-on-match \nmd-selected-item-change="vm.onBuyerLimitPriceGroupLookupChange(vm.lookupModel.BuyerLimitPriceGroupId, \'BuyerLimitPriceGroupId\')" \nmd-menu-class="autocomplete-custom"><md-item-template><span class="autocomplete-item md-accent-fg" \nmd-highlight-text="vm.searchText.BuyerLimitPriceGroupId" md-highlight-flags="i">{{item.value}}</span>\n</md-item-template><md-not-found>No Record matching "{{vm.searchText.BuyerLimitPriceGroupId}}" were found.\n</md-not-found></md-autocomplete></div><div flex="100" flex-gt-xs="50" class="p-5" ng-if="!vm.isCopyCatalog">\n<md-autocomplete id="catalog_dialog_input_30" md-input-name="Visibility" md-selected-item="vm.lookupModel.Visibility" \nmd-items="item in vm.lookupSearch(vm.searchText.Visibility, \'Visibility\')" md-search-text="vm.searchText.Visibility" \nmd-item-text="vm.getLookupDisplayValue(item, \'lists.catalogVisibilities\')" md-min-length="0" \nmd-floating-label="{{\'CATALOGS.FIELDS.VISIBILITY\' | translate}}" tx-clear-autocomplete md-min-length="0" \nmd-no-cache="true" ng-click="vm.selectText($event)" \nmd-selected-item-change="vm.onLookupChange(vm.lookupModel.Visibility, \'Visibility\')" \nmd-menu-class="autocomplete-custom"><md-item-template><span class="autocomplete-item md-accent-fg" \nmd-highlight-text="vm.searchText.Visibility" md-highlight-flags="i">{{item.value}}</span></md-item-template>\n<md-not-found>No Record matching "{{vm.searchText.Visibility}}" were found.</md-not-found></md-autocomplete></div><div \nflex="100" flex-gt-xs="50" class="p-5 lookup-element" ng-if="!vm.isCopyCatalog"><md-autocomplete \nid="catalog_dialog_input_31" md-input-name="CollectionsType" md-selected-item="vm.lookupModel.CollectionsType" \nmd-items="item in vm.lookupSearch(vm.searchText.CollectionsType, \'CollectionsType\')" \nmd-search-text="vm.searchText.CollectionsType" \nmd-item-text="vm.getLookupDisplayValue(item, \'lists.catalogCollectionTypes\')" md-min-length="0" \nmd-floating-label="{{\'CATALOGS.FIELDS.COLLECTION_TYPE\' | translate}}" tx-clear-autocomplete md-min-length="0" \nmd-no-cache="true" ng-click="vm.selectText($event)" \nmd-selected-item-change="vm.onLookupChange(vm.lookupModel.CollectionsType, \'CollectionsType\')" \nmd-menu-class="autocomplete-custom"><md-item-template><span class="autocomplete-item md-accent-fg" \nmd-highlight-text="vm.searchText.CollectionsType" md-highlight-flags="i">{{item.value}}</span></md-item-template>\n<md-not-found>No Record matching "{{vm.searchText.CollectionsType}}" were found.</md-not-found></md-autocomplete></div>\n<div flex="100" flex-gt-xs="50" class="p-5" ng-if="!vm.isCopyCatalog"><md-input-container class="md-block"><label \ntranslate>CATALOGS.FIELDS.SEASONAL_SEQUENCE</label><input name="SeasonalSequence" \nng-model="vm.record.SeasonalSequence" type="number" ng-pattern="/^[0-9][0-9]*$/" ng-required="false"><div \nng-messages="vm.editForm.SeasonalSequence.$error" role="alert" multiple="multiple"><div ng-message="required">\n{{\'VALIDATIONS.REQUIRED\' | translate}}</div><div ng-message="pattern">{{\'VALIDATIONS.PATTERN\' | translate}}</div></div>\n</md-input-container></div><div flex="100" flex-gt-xs="50" class="p-5" ng-if="!vm.isCopyCatalog"><md-switch \nid="catalog_dialog_input_11" ng-model="vm.record.IsVasInUse" \naria-label="{{\'CATALOGS.FIELDS.IS_VAS_IN_USE\' | translate}}" \nng-disabled="vm.record.DataSourceTypeId === 3 && vm.isNew" ng-true-value="1" ng-false-value="0" class="md-accent">\n{{\'CATALOGS.FIELDS.IS_VAS_IN_USE\' | translate}}<md-tooltip md-direction="right">\n{{vm.record.IsVasInUse === 1 ? \'PARTS.YES\' : \'PARTS.NO\' | translate}}</md-tooltip></md-switch></div><div flex="100" \nflex-gt-xs="50" class="p-5" ng-if="!vm.isCopyCatalog && vm.lookupModel.IsLinePlan !== 1"><md-switch \nid="catalog_dialog_input_30" ng-model="vm.record.SyncSizes" aria-label="{{\'CATALOGS.FIELDS.SYNC_SIZES\' | translate}}" \nng-true-value="1" ng-false-value="0" class="md-accent" \nng-disabled="vm.record.DataSourceTypeId !== 3 || vm.isSizeScaleByStyle === 1 || vm.record.IndependentSizes === 1 || !vm.isNew">\n{{\'CATALOGS.FIELDS.SYNC_SIZES\' | translate}}<md-tooltip md-direction="right">\n{{vm.record.SyncSizes === 1 ? \'PARTS.YES\' : \'PARTS.NO\' | translate}}</md-tooltip></md-switch></div><div flex="100" \nflex-gt-xs="50" class="p-5" ng-if="!vm.isCopyCatalog"><md-switch id="catalog_dialog_input_13" \nng-model="vm.record.IsShippingWindowApply" aria-label="{{\'CATALOGS.FIELDS.APPLY_RETAIL_WINDOW\' | translate}}" \nng-true-value="1" ng-false-value="0" class="md-accent" \nng-disabled="!vm.isNew || vm.masterCalatogIsShippingWindowApply">{{\'CATALOGS.FIELDS.APPLY_RETAIL_WINDOW\' | translate}}\n<md-tooltip md-direction="right">{{vm.record.IsShippingWindowApply === 1 ? \'PARTS.YES\' : \'PARTS.NO\' | translate}}\n</md-tooltip></md-switch></div><div flex="100" flex-gt-xs="50" class="p-5" ng-if="!vm.isCopyCatalog"><md-switch \nid="catalog_dialog_input_14" ng-model="vm.record.IsPriceByStyleApply" \naria-label="{{\'CATALOGS.FIELDS.APPLY_PRICE_BY_STYLE\' | translate}}" ng-true-value="1" ng-false-value="0" \nclass="md-accent">{{\'CATALOGS.FIELDS.APPLY_PRICE_BY_STYLE\' | translate}}<md-tooltip md-direction="right">\n{{vm.record.IsPriceByStyleApply === 1 ? \'PARTS.YES\' : \'PARTS.NO\' | translate}}</md-tooltip></md-switch></div><div \nflex="100" flex-gt-xs="50" class="p-5" ng-if="!vm.isCopyCatalog"><md-switch id="catalog_dialog_input_15" \nng-model="vm.record.IndependentSizes" aria-label="{{\'CATALOGS.FIELDS.INDEPENDENT_SIZES\' | translate}}" \nng-true-value="1" ng-false-value="0" class="md-accent" \nng-disabled="vm.record.DataSourceTypeId != 3 || (vm.record.DataSourceTypeId === 3 && !vm.isNew) || vm.record.SyncSizes === 1">\n{{\'CATALOGS.FIELDS.INDEPENDENT_SIZES\' | translate}}<md-tooltip md-direction="right">\n{{vm.record.IndependentSizes === 1 ? \'PARTS.YES\' : \'PARTS.NO\' | translate}}</md-tooltip></md-switch></div><div \nflex="100" flex-gt-xs="50" class="p-5" ng-if="!vm.isCopyCatalog"><md-switch id="catalog_dialog_input_16" \nng-model="vm.record.ReceiveOrdersWithoutPrice" \naria-label="{{\'CATALOGS.FIELDS.RECEIVE_ORDERS_WITHOUT_PRICE\' | translate}}" ng-true-value="1" ng-false-value="0" \nclass="md-accent">{{\'CATALOGS.FIELDS.RECEIVE_ORDERS_WITHOUT_PRICE\' | translate}}<md-tooltip md-direction="right">\n{{vm.record.ReceiveOrdersWithoutPrice === 1 ? \'PARTS.YES\' : \'PARTS.NO\' | translate}}</md-tooltip></md-switch></div><div\n flex="100" flex-gt-xs="50" class="p-5" ng-if="!vm.isCopyCatalog"><md-switch id="catalog_dialog_input_17" \nng-model="vm.record.ArticleCascading" aria-label="{{\'CATALOGS.FIELDS.ARTICLE_CASCADING\' | translate}}" \nng-true-value="1" ng-false-value="0" class="md-accent">{{\'CATALOGS.FIELDS.ARTICLE_CASCADING\' | translate}}<md-tooltip \nmd-direction="right">{{vm.record.ArticleCascading === 1 ? \'PARTS.YES\' : \'PARTS.NO\' | translate}}</md-tooltip>\n</md-switch></div><div flex="100" flex-gt-xs="50" class="p-5" ng-if="!vm.isCopyCatalog"><md-switch \nid="catalog_dialog_input_18" ng-model="vm.record.IsStockApply" \naria-label="{{\'CATALOGS.FIELDS.IS_STOCK_APPLY\' | translate}}" ng-true-value="1" ng-false-value="0" class="md-accent" \nng-disabled="vm.record.OrderBySizeCurve === 1">{{\'CATALOGS.FIELDS.IS_STOCK_APPLY\' | translate}}<md-tooltip \nmd-direction="right">{{vm.record.IsStockApply === 1 ? \'PARTS.YES\' : \'PARTS.NO\' | translate}}</md-tooltip></md-switch>\n</div><div flex="100" flex-gt-xs="50" class="p-5" ng-if="!vm.isCopyCatalog"><md-switch id="catalog_dialog_input_19" \nng-model="vm.record.SegmentationCascading" aria-label="{{\'CATALOGS.FIELDS.SEGMENTATION_CASCADING\' | translate}}" \nng-true-value="1" ng-false-value="0" class="md-accent" ng-disabled="vm.record.DataSourceTypeId != 3">\n{{\'CATALOGS.FIELDS.SEGMENTATION_CASCADING\' | translate}}<md-tooltip md-direction="right">\n{{vm.record.SegmentationCascading === 1 ? \'PARTS.YES\' : \'PARTS.NO\' | translate}}</md-tooltip></md-switch></div><div \nflex="100" flex-gt-xs="50" class="p-5" ng-if="!vm.isCopyCatalog"><md-switch id="catalog_dialog_input_20" \nng-model="vm.record.MirrorSegmentation" aria-label="{{\'CATALOGS.FIELDS.MIRROR_SEGMENTATION\' | translate}}" \nng-true-value="1" ng-false-value="0" class="md-accent" ng-disabled="vm.record.DataSourceTypeId != 3">\n{{\'CATALOGS.FIELDS.MIRROR_SEGMENTATION\' | translate}}<md-tooltip md-direction="right">\n{{vm.record.MirrorSegmentation === 1 ? \'PARTS.YES\' : \'PARTS.NO\' | translate}}</md-tooltip></md-switch></div><div \nflex="100" flex-gt-xs="50" class="p-5" ng-if="!vm.isCopyCatalog"><md-switch id="catalog_dialog_input_21" \nng-model="vm.record.SegmentationPlanningEnable" \naria-label="{{\'CATALOGS.FIELDS.SEGMENTATION_PLANNING_ENABLE\' | translate}}" ng-true-value="1" ng-false-value="0" \nclass="md-accent">{{\'CATALOGS.FIELDS.SEGMENTATION_PLANNING_ENABLE\' | translate}}<md-tooltip md-direction="right">\n{{vm.record.SegmentationPlanningEnable === 1 ? \'PARTS.YES\' : \'PARTS.NO\' | translate}}</md-tooltip></md-switch></div>\n<div flex="100" flex-gt-xs="50" class="p-5" ng-if="!vm.isCopyCatalog"><md-switch id="catalog_dialog_input_24" \nng-model="vm.record.ArticleLocking" aria-label="{{\'CATALOGS.FIELDS.ARTICLE_LOCKING\' | translate}}" ng-true-value="1" \nng-false-value="0" class="md-accent">{{\'CATALOGS.FIELDS.ARTICLE_LOCKING\' | translate}}<md-tooltip md-direction="right">\n{{vm.record.ArticleLocking === 1 ? \'PARTS.YES\' : \'PARTS.NO\' | translate}}</md-tooltip></md-switch></div><div \nflex="100" flex-gt-xs="50" class="p-5" ng-if="!vm.isCopyCatalog"><md-switch id="catalog_dialog_input_25" \nng-model="vm.record.ChangeLog" aria-label="{{\'CATALOGS.FIELDS.CHANGE_LOG\' | translate}}" ng-true-value="1" \nng-false-value="0" class="md-accent">{{\'CATALOGS.FIELDS.CHANGE_LOG\' | translate}}<md-tooltip md-direction="right">\n{{vm.record.ChangeLog === 1 ? \'PARTS.YES\' : \'PARTS.NO\' | translate}}</md-tooltip></md-switch></div><div flex="100" \nflex-gt-xs="50" class="p-5" ng-if="vm.isNew && !vm.isCopyCatalog"><md-switch id="catalog_dialog_input_26" \nng-model="vm.record.PriceCascading" aria-label="{{\'CATALOGS.FIELDS.PRICE_CASCADING\' | translate}}" ng-true-value="1" \nng-false-value="0" class="md-accent" ng-disabled="vm.record.DataSourceTypeId !== 3">\n{{\'CATALOGS.FIELDS.PRICE_CASCADING\' | translate}}<md-tooltip md-direction="right">\n{{vm.record.PriceCascading === 1 ? \'PARTS.YES\' : \'PARTS.NO\' | translate}}</md-tooltip></md-switch></div><div \nflex="100" flex-gt-xs="50" class="p-5" ng-if="!vm.isCopyCatalog"><md-switch id="catalog_dialog_input_27" \nng-model="vm.record.AllowRequestedArticleCreation" \naria-label="{{\'CATALOGS.FIELDS.ALLOW_REQUESTED_ARTICLE_CREATION\' | translate}}" ng-true-value="1" ng-false-value="0" \nclass="md-accent">{{\'CATALOGS.FIELDS.ALLOW_REQUESTED_ARTICLE_CREATION\' | translate}}<md-tooltip md-direction="right">\n{{vm.record.AllowRequestedArticleCreation === 1 ? \'PARTS.YES\' : \'PARTS.NO\' | translate}}</md-tooltip></md-switch></div>\n<div flex="100" flex-gt-xs="50" class="p-5" ng-if="!vm.isCopyCatalog && vm.lookupModel.IsLinePlan !== 1"><md-switch \nid="catalog_dialog_input_28" ng-model="vm.record.IsLive" aria-label="{{\'CATALOGS.FIELDS.IS_LIVE\' | translate}}" \nng-true-value="1" ng-false-value="0" class="md-accent" \nng-disabled="vm.record.DataSourceTypeId !== 1 && vm.record.DataSourceTypeId !== 3">\n{{\'CATALOGS.FIELDS.IS_LIVE\' | translate}}<md-tooltip md-direction="right">\n{{vm.record.IsLive === 1 ? \'PARTS.YES\' : \'PARTS.NO\' | translate}}</md-tooltip></md-switch></div><div flex="100" \nflex-gt-xs="50" class="p-5" ng-if="!vm.isCopyCatalog && vm.lookupModel.IsLinePlan !== 1"><md-switch \nid="catalog_dialog_input_29" ng-model="vm.record.AssignAllSegmentation" \naria-label="{{\'CATALOGS.FIELDS.ASSIGN_ALL_SEGMENTATION\' | translate}}" ng-true-value="1" ng-false-value="0" \nclass="md-accent" ng-disabled="vm.record.DataSourceTypeId !== 1 && vm.record.DataSourceTypeId !== 3">\n{{\'CATALOGS.FIELDS.ASSIGN_ALL_SEGMENTATION\' | translate}}<md-tooltip md-direction="right">\n{{vm.record.AssignAllSegmentation === 1 ? \'PARTS.YES\' : \'PARTS.NO\' | translate}}</md-tooltip></md-switch></div><div \nflex="100" flex-gt-xs="50" class="p-5" ng-if="!vm.isCopyCatalog"><md-switch id="catalog_dialog_input_30" \nng-model="vm.record.OrderBySizeCurve" aria-label="{{\'CATALOGS.FIELDS.ORDER_BY_SIZE_CURVE\' | translate}}" \nng-true-value="1" ng-false-value="0" class="md-accent" ng-disabled="vm.record.IsStockApply === 1">\n{{\'CATALOGS.FIELDS.ORDER_BY_SIZE_CURVE\' | translate}}<md-tooltip md-direction="right">\n{{vm.record.OrderBySizeCurve === 1 ? \'PARTS.YES\' : \'PARTS.NO\' | translate}}</md-tooltip></md-switch></div><div \nflex="100" flex-gt-xs="50" class="p-5" ng-if="!vm.isCopyCatalog"><md-input-container class="md-block"><label translate>\nCATALOGS.FIELDS.RETAIL_WINDOW_ATTRIBUTE</label><input id="catalog_dialog_input_30" name="RetailWindowAttribute" \nng-model="vm.record.RetailWindowAttribute" type="text" ng-required="vm.record.IsShippingWindowApply === 1"><div \nng-messages="vm.editForm.RetailWindowAttribute.$error" role="alert" multiple="multiple"><div ng-message="required">\n{{\'VALIDATIONS.REQUIRED\' | translate}}</div></div></md-input-container></div><div flex="100" flex-gt-xs="50" \nclass="p-5" ng-if="vm.record.DataSourceTypeId === 1"><md-input-container class="md-block"><label translate>\nCATALOGS.FIELDS.ARTICLE_ATTRIBUTE</label><input id="catalog_dialog_input_31" name="ArticleAttribute" \nng-model="vm.record.ArticleAttribute" type="text"><div ng-messages="vm.editForm.ArticleAttribute.$error" role="alert" \nmultiple="multiple"><div ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div></div></md-input-container>\n</div><div flex="100" flex-gt-xs="50" class="p-5" ng-if="vm.record.DataSourceTypeId === 1"><md-input-container \nclass="md-block"><label translate>CATALOGS.FIELDS.MODEL_ATTRIBUTE</label><input id="catalog_dialog_input_32" \nname="ModelAttribute" ng-model="vm.record.ModelAttribute" type="text"><div \nng-messages="vm.editForm.ModelAttribute.$error" role="alert" multiple="multiple"><div ng-message="required">\n{{\'VALIDATIONS.REQUIRED\' | translate}}</div></div></md-input-container></div><div flex="100" flex-gt-xs="100" \nclass="p-5" ng-if="!vm.isCopyCatalog"><fieldset class="copy-catalog-fieldset"><legend class="header-copy-entities" \ntranslate>CATALOGS.FIELDS.CUSTOMER_REQUIRED_DATE_VALIDATION</legend><div class="range-info" \nng-if="vm.customerRequiredDateValidation.relation === \'<\' || vm.customerRequiredDateValidation.relation === \'>\' || vm.customerRequiredDateValidation.relation === \'>=\' || vm.customerRequiredDateValidation.relation === \'<=\'">\n<md-icon md-font-icon="icon-information"></md-icon><span>\n{{ \'CATALOGS.MESSAGES.CONTENT.CUSTOMER_REQUIRED_DATE_RANGE_MESSAGE\' | translate }}</span></div><div layout="row" \nlayout-wrap flex><div flex-gt-sm="50"><md-input-container class="md-block"><label>\n{{\'CATALOGS.FIELDS.RELATION\' | translate}}</label><md-select name="relation" \nng-model="vm.customerRequiredDateValidation.relation" aria-label="{{\'CATALOGS.FIELDS.RELATION\' | translate}}" \nng-change="vm.updateRangeOperators()"><md-option md-option-empty ng-value="\'\'"><em>None</em></md-option><md-option \nng-repeat="relation in vm.customerRequiredDateValidationOperators" ng-value="relation">{{ relation }}</md-option>\n</md-select></md-input-container></div><div flex-gt-sm="50"><md-input-container class="md-block"><label translate>\nCATALOGS.FIELDS.NUMBER_OF_DAYS</label><input name="numberOfDays" \nng-model="vm.customerRequiredDateValidation.numberOfDays" type="number" ng-pattern="/^\\d+$/"><div \nng-messages="vm.editForm.numberOfDays.$error" role="alert" multiple="multiple"><div ng-message="pattern">\n{{\'VALIDATIONS.INVALID_DECIMAL_POINTS\' | translate}}</div></div></md-input-container></div></div><div layout="row" \nlayout-wrap flex \nng-if="vm.customerRequiredDateValidation.relation === \'<\' || vm.customerRequiredDateValidation.relation === \'>\' || vm.customerRequiredDateValidation.relation === \'>=\' || vm.customerRequiredDateValidation.relation === \'<=\'">\n<div flex-gt-sm="50"><md-input-container class="md-block"><label>{{\'CATALOGS.FIELDS.RELATION\' | translate}}</label>\n<md-select name="relation" ng-model="vm.customerRequiredDateValidation.rangeRelation" \naria-label="{{\'CATALOGS.FIELDS.RELATION\' | translate}}"><md-option md-option-empty ng-value="\'\'"><em>None</em>\n</md-option><md-option ng-repeat="relation in vm.customerRequiredDateValidationRangeOperatorsCopy" ng-value="relation">\n{{ relation }}</md-option></md-select></md-input-container></div><div flex-gt-sm="50"><md-input-container \nclass="md-block"><label translate>CATALOGS.FIELDS.NUMBER_OF_DAYS</label><input name="numberOfDays" \nng-model="vm.customerRequiredDateValidation.rangeNumberOfDays" type="number" ng-pattern="/^\\d+$/"><div \nng-messages="vm.editForm.numberOfDays.$error" role="alert" multiple="multiple"><div ng-message="pattern">\n{{\'VALIDATIONS.INVALID_DECIMAL_POINTS\' | translate}}</div></div></md-input-container></div></div></fieldset></div><div \nflex="100" class="p-5 lookup-element" ng-if="vm.isNew && !vm.isCopyCatalog"><md-input-container class="md-block">\n<label>{{\'CATALOGS.FIELDS.COPY_PRICE_CATALOGS\' | translate}}</label><md-chips id="catalog_dialog_input_33" \nname="CopyPriceCatalogs" ng-model="vm.record.CopyPriceCatalogs" md-autocomplete-snap \nmd-transform-chip="vm.transformChip($chip, \'CopyPriceCatalogs\' )" md-max-chips="3" md-require-match="true" \nng-required="vm.record.PriceCascading === 1"><md-autocomplete md-selected-item="vm.acSelectedItem.CopyPriceCatalogs" \nmd-search-text="vm.acSearchText.CopyPriceCatalogs" \nmd-items="item in vm.copyPriceCatalogSearch(vm.acSearchText.CopyPriceCatalogs, vm.record.CopyPriceCatalogs)" \nmd-item-text="item.value" ng-disabled="vm.record.PriceCascading === 0" md-min-length="0" md-no-cache="true" \nmd-menu-class="autocomplete-custom"><md-item-template><span class="autocomplete-item md-accent-fg" \nmd-highlight-text="vm.acSearchText[field.field]">{{item.value}}</span></md-item-template><md-not-found>\nNo Record matching "{{vm.acSearchText.CopyPriceCatalogs}}" were found.</md-not-found></md-autocomplete>\n<md-chip-template><span><strong>{{vm.getChipDisplayValue($chip, \'CopyPriceCatalogs\')}}</strong></span>\n</md-chip-template></md-chips><div class="md-chips-messages" ng-messages="vm.editForm.CopyPriceCatalogs.$error" \nng-show="vm.editForm.CopyPriceCatalogs.$dirty || vm.editForm.ReferenceCatalogCode.$submitted"><div \nng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div><div ng-message="md-max-chips">\n{{\'VALIDATIONS.MAXLEN\'| translate}}</div></div></md-input-container></div><div flex="100" class="p-5 lookup-element" \nng-if="!vm.isCopyCatalog"><md-input-container class="md-block"><label>\n{{\'CATALOGS.FIELDS.ATTRIBUTE_IDS_LIST\' | translate}}</label><span class="h4">\n{{\'CATALOGS.MESSAGES.CONTENT.NON_EDITABLE_MODEL_ATTRIBUTES\' | translate}}</span><md-chips id="catalog_dialog_input_34" \nname="AttributeId" ng-model="vm.record.AttributeIdsList" md-autocomplete-snap \nmd-transform-chip="vm.transformChip($chip, \'AttributeId\')" md-require-match="true" \nng-required="vm.record.DataSourceTypeId === 3"><md-autocomplete md-selected-item="vm.acSelectedItem.AttributeIdsList" \nmd-search-text="vm.acSearchText.AttributeIdsList" \nmd-items="item in vm.acQuerySearch(vm.acSearchText.AttributeIdsList, vm.record.AttributeIdsList, \'attributes\')" \nmd-item-text="item.AttributeDisplayName" \nng-disabled="(vm.isNew && (vm.record.DataSourceTypeId !== 3 && vm.record.DataSourceTypeId !== 4))" md-min-length="0" \nmd-no-cache="true" md-menu-class="autocomplete-custom"><md-item-template><span class="autocomplete-item md-accent-fg" \nmd-highlight-text="vm.acSearchText.AttributeIdsList">{{item.AttributeDisplayName}}</span></md-item-template>\n</md-autocomplete><md-chip-template tx-chip="vm.nonRemovableModelLevelAttributes:$chip:vm.model.fields"><span><strong>\n{{ vm.getChipDisplayValue($chip, \'AttributeId\') }}</strong></span></md-chip-template></md-chips><div \nclass="md-chips-messages" ng-messages="vm.editForm.AttributeId.$error" \nng-show="vm.editForm.AttributeId.$dirty || vm.editForm.AttributeId.$submitted"><div ng-message="required">\n{{ \'VALIDATIONS.REQUIRED\' | translate}}</div></div></md-input-container></div><div flex="100" \nclass="p-5 lookup-element" ng-if="vm.isNew"><md-input-container class="md-block"><label>\n{{\'CATALOGS.FIELDS.TARGETED_ATTRIBUTE\' | translate}}</label><md-chips id="catalog_dialog_input_35" \nname="targetedAttributeId" ng-model="vm.record.TargettedAttributes" md-autocomplete-snap \nmd-transform-chip="vm.transformChip($chip, \'AttributeId\')" md-require-match="true" ng-required="false"><md-autocomplete\n md-selected-item="vm.acSelectedItem.TargetedAttributes" md-search-text="vm.acSearchText.TargetedAttributes" \nmd-items="item in vm.acQuerySearch(vm.acSearchText.TargetedAttributes, vm.record.TargettedAttributes, \'targetedAttributes\')" \nmd-item-text="item.AttributeDisplayName" \nng-disabled="((vm.record.AccountId == null || vm.record.AttributeGroupId == null)  && !vm.isInheritedCatalog)" \nmd-min-length="0" md-no-cache="true" md-menu-class="autocomplete-custom"><md-item-template><span \nclass="autocomplete-item md-accent-fg" md-highlight-text="vm.acSearchText.TargetedAttributes">\n{{item.AttributeDisplayName}}</span></md-item-template></md-autocomplete><md-chip-template><span><strong>\n{{vm.getChipDisplayValue($chip)}}</strong></span></md-chip-template></md-chips><div class="md-chips-messages" \nng-messages="vm.editForm.targetedAttributeId.$error" \nng-show="vm.editForm.targetedAttributeId.$dirty || vm.editForm.targetedAttributeId.$submitted"><div \nng-message="required">{{ \'VALIDATIONS.REQUIRED\' | translate}}</div></div></md-input-container></div><div flex="100" \nclass="p-5 lookup-element" ng-if="vm.isNew"><md-input-container class="md-block"><label>\n{{\'CATALOGS.FIELDS.AGGREGATE_ATTRIBUTES\' | translate}}</label><md-chips id="catalog_dialog_input_36" \nname="aggregateAttributeId" ng-model="vm.record.AggregateAttributes" md-autocomplete-snap \nmd-transform-chip="vm.transformChip($chip, \'AttributeId\')" md-require-match="true" ng-required="false"><md-autocomplete\n md-selected-item="vm.acSelectedItem.AggregateAttributes" md-search-text="vm.acSearchText.AggregateAttributes" \nmd-items="item in vm.acQuerySearch(vm.acSearchText.AggregateAttributes, vm.record.AggregateAttributes, \'aggregateAttributes\')" \nmd-item-text="item.AttributeDisplayName" \nng-disabled="((vm.record.AccountId == null || vm.record.AttributeGroupId == null) && !vm.isInheritedCatalog)" \nmd-min-length="0" md-no-cache="true" md-menu-class="autocomplete-custom"><md-item-template><span \nclass="autocomplete-item md-accent-fg" md-highlight-text="vm.acSearchText.AggregateAttributes">\n{{item.AttributeDisplayName}}</span></md-item-template></md-autocomplete><md-chip-template><span><strong>\n{{vm.getChipDisplayValue($chip)}}</strong></span></md-chip-template></md-chips><div class="md-chips-messages" \nng-messages="vm.editForm.aggregateAttributeId.$error" \nng-show="vm.editForm.targetedAttributeId.$dirty || vm.editForm.targetedAttributeId.$submitted"><div \nng-message="required">{{ \'VALIDATIONS.REQUIRED\' | translate}}</div></div></md-input-container></div><div flex="100" \nflex-gt-xs="100" class="p-5" ng-if="vm.isCopyCatalog"><fieldset class="copy-catalog-fieldset"><legend \nclass="header-copy-entities" translate>CATALOGS.FIELDS.COPY_ENTITIES</legend><div layout="row" layout-wrap flex><div \nflex-gt-sm="50"><md-checkbox ng-model="vm.record.CopyAttributes" \naria-label="{{\'CATALOGS.TABS.ATTRIBUTES\' | translate}}" ng-true-value="1" ng-false-value="0">\n{{ \'CATALOGS.TABS.ATTRIBUTES\' | translate }}</md-checkbox></div><div flex-gt-sm="50"><md-checkbox \nng-model="vm.record.CopyConfiguration" aria-label="{{\'CONFIGURATIONS.FIELDS.CONFIGURATION\' | translate}}" \nng-true-value="1" ng-false-value="0">{{ \'CONFIGURATIONS.FIELDS.CONFIGURATION\' | translate }}</md-checkbox></div><div \nflex-gt-sm="50"><md-checkbox ng-model="vm.record.CopyPriceGroups" \naria-label="{{\'CATALOGS.FIELDS.PRICE_GROUPS\' | translate}}" ng-true-value="1" ng-false-value="0">\n{{ \'CATALOGS.FIELDS.PRICE_GROUPS\' | translate }}</md-checkbox></div><div flex-gt-sm="50"><md-checkbox \nng-model="vm.record.CopySegmentation" aria-label="{{\'CATALOGS.FIELDS.SEGMENTATION\' | translate}}" ng-true-value="1" \nng-false-value="0">{{ \'CATALOGS.FIELDS.SEGMENTATION\' | translate}}</md-checkbox></div><div flex-gt-sm="50"><md-checkbox\n ng-model="vm.record.CopyTreeDefinition" aria-label="{{\'CATALOGS.FIELDS.TREE_DEFINITION\' | translate}}" \nng-true-value="1" ng-false-value="0">{{ \'CATALOGS.FIELDS.TREE_DEFINITION\' | translate }}</md-checkbox></div></div>\n</fieldset></div></div></md-dialog-content><md-dialog-actions layout="row" layout-align="end center"><div></div><div \nlayout="row" layout-align="end center"><md-button ng-click="vm.closeDialog(vm.isDataDirty)" \nclass="send-button md-primary md-raised" aria-label="Cancel" translate="ACTIONS.DIALOG_CANCEL" \ntranslate-attr-aria-label="ACTIONS.DIALOG_CANCEL" ng-disabled="vm.isLoading">CANCEL</md-button><md-button \nng-click="vm.saveRecord()" class="send-button md-accent md-raised" aria-label="Save" translate="ACTIONS.SAVE" \ntranslate-attr-aria-label="ACTIONS.SAVE" ng-disabled="vm.isLoading || vm.editForm.$invalid">SAVE</md-button><md-button \nng-click="vm.saveRecord(true)" class="send-button md-accent md-raised" aria-label="Save" \ntranslate="ACTIONS.SAVE_AND_NEW" translate-attr-aria-label="ACTIONS.SAVE_AND_NEW" \nng-disabled="vm.isLoading || vm.editForm.$invalid" ng-if="vm.isNew">SAVE</md-button></div></md-dialog-actions></form>\n</md-dialog>');
$templateCache.put('app/main/catalogs/dialogs/sort-attributes.html','<md-dialog class="edit-dialog" aria-label="{{\'Update Sorting\'}}"><form name="vm.editForm" class="md-inline-form">\n<md-toolbar class="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" layout-align="space-between center">\n<span class="title" translate="{{\'ATTRIBUTES.ACTIONS.UPDATE_SORTING\'}}"></span><md-button class="md-icon-button" \nng-click="vm.closeDialog(vm.isDataDirty)" aria-label="Close dialog" tranlate \ntranslate-aria-label="ACTIONS.DIALOG_CLOSE"><md-icon md-font-icon="icon-close"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div layout="row" layout-wrap ng-repeat="record in vm.records"><div \nflex="100" flex-gt-xs="50" class="p-5"><md-input-container class="md-block"><label translate>ATTRIBUTES.FIELDS.NAME\n</label><input id="dialog_input_{{record.AttributeId}}" name="AttributeDisplayName" \nng-model="record.AttributeDisplayName" type="text" ng-disabled="true"></md-input-container></div><div flex="100" \nflex-gt-xs="50" class="p-5"><md-input-container class="md-block"><label translate>ATTRIBUTES.FIELDS.SORT_ORDER</label>\n<input id="dialog_input_{{record.SORT_ORDER}}" name="SortOrder" ng-model="record.SortOrder" type="number">\n</md-input-container></div></div></md-dialog-content><md-dialog-actions layout="row" layout-align="end center"><div>\n</div><div layout="row" layout-align="end center"><md-button ng-click="vm.closeDialog(vm.isDataDirty)" \nclass="send-button md-primary md-raised" aria-label="Cancel" translate="ACTIONS.DIALOG_CANCEL" \ntranslate-attr-aria-label="ACTIONS.DIALOG_CANCEL" ng-disabled="vm.isLoading">CANCEL</md-button><md-button \nng-click="vm.saveRecord()" class="send-button md-accent md-raised" aria-label="Save" translate="ACTIONS.SAVE" \ntranslate-attr-aria-label="ACTIONS.SAVE" ng-disabled="vm.isLoading">SAVE</md-button></div></md-dialog-actions></form>\n</md-dialog>');
$templateCache.put('app/main/catalogs/list/catalogs-list.html','<div id="catalogs-list" class="page-layout carded fullwidth list-view" layout="row"><div class="center" \nlayout="column" flex><div class="content-card" layout="column" flex><tx-data-table tx-data="vm.catalogs" \ntx-model="vm.model" tx-view="mainList" tx-filtered-data="vm.filteredCatalogs" tx-data-filter="global.search" \ntx-is-loading="vm.isLoading" tx-item-action-event="vm.doItemAction(action, item)" \ntx-list-action-event="vm.doListAction(action, selectedItems)" tx-item-click-event="vm.viewItem(item)" \ntx-refresh-action-event="vm.refreshItems(true, false)"></tx-data-table><md-button \nclass="add-rec-button md-fab md-warn" ng-click="vm.addRecord($event)" \naria-label="vm.model.views.mainList.fabAction.label" translate \ntx-access="{{::vm.model.views.mainList.fabAction.privilege}}"><md-icon \nmd-font-icon="{{vm.model.views.mainList.fabAction.icon}}"></md-icon></md-button></div></div></div>');
$templateCache.put('app/main/customers/details/customers-details.html','<div id="customer-details" class="page-layout simple tabbed details-view" layout="column"><div class="content"><md-tabs\n md-dynamic-height md-selected="vm.tabIndex" md-no-ink><md-tab label="{{\'CUSTOMERS.TABS.CUSTOMER\' | translate}}" \ntx-access="{{::vm.model.views.privileges.details}}"><tx-data-details tx-height-offset="37" \ntx-is-active="vm.tabIndex === 0" tx-account="vm.customer" tx-parent-id="vm.sellerId" tx-title="vm.title" \ntx-model="vm.model" tx-item-actions="vm.model.views.mainDetails.itemActions" \ntx-item-action-event="vm.doCustomerItemAction(action, account)" tx-is-loading="vm.isLoading" \ntx-refresh-action-event="vm.refreshRecord(false)"></tx-data-details></md-tab><md-tab \nlabel="{{\'CUSTOMERS.TABS.LOCATIONS\' | translate}}" ng-disabled="!vm.customer.Status" \ntx-access="{{::vm.locationsModel.views.privileges.list}}"><div class="list-tab" layout="row" flex="100" layout-wrap>\n<ms-widget layout="row" flex="100"><ms-widget-front class="white-bg"><tx-data-table tx-is-active="vm.tabIndex === 1" \ntx-data="vm.locations" tx-model="vm.locationsModel" tx-view="mainList" tx-filtered-data="vm.filteredLocations" \ntx-data-filter="global.search" tx-is-loading="vm.isLocationLoading" \ntx-item-action-event="vm.doLocationsItemAction(action, item)" \ntx-list-action-event="vm.doLocationsListAction(action, selectedItems)" tx-item-click-event="vm.viewLocation(item)" \ntx-refresh-action-event="vm.refreshLocations(true)" tx-height-offset="16" tx-control="vm.tableControl"></tx-data-table>\n</ms-widget-front></ms-widget><md-button class="add-rec-button md-fab md-warn" ng-click="vm.addLocation($event)" \naria-label="vm.locationsModel.views.mainList.fabAction.label" translate \ntx-access="{{::vm.locationsModel.views.mainList.fabAction.privilege}}"><md-icon \nmd-font-icon="{{vm.locationsModel.views.mainList.fabAction.icon}}"></md-icon></md-button></div></md-tab><md-tab \nlabel="{{\'CUSTOMERS.TABS.CATALOGS\' | translate}}" ng-disabled="!vm.customer.Status" \ntx-access="{{::vm.catalogsModel.views.privileges.list}}"><div class="list-tab" layout="row" flex="100" layout-wrap>\n<ms-widget layout="row" flex="100"><ms-widget-front class="white-bg"><tx-data-table tx-is-active="vm.tabIndex === 2" \ntx-data="vm.catalogs" tx-model="vm.catalogsModel" tx-view="mainList" tx-filtered-data="vm.filteredCatalogs" \ntx-data-filter="global.search" tx-is-loading="vm.isCatalogLoading" \ntx-item-action-event="vm.doCatalogsItemAction(action, item)" \ntx-list-action-event="vm.doCatalogsListAction(action, selectedItems)" tx-item-click-event="vm.viewCatalog(item)" \ntx-refresh-action-event="vm.refreshCatalogs(true, false)" tx-height-offset="16"></tx-data-table></ms-widget-front>\n</ms-widget><md-button class="add-rec-button md-fab md-warn" ng-click="vm.addCatalog($event)" \naria-label="vm.catalogsModel.views.mainList.fabAction.label" translate \ntx-access="{{::vm.catalogsModel.views.mainList.fabAction.privilege}}"><md-icon \nmd-font-icon="{{vm.catalogsModel.views.mainList.fabAction.icon}}"></md-icon></md-button></div></md-tab></md-tabs>\n<md-button id="txfab" class="md-fab md-warn" ng-if="vm.tabIndex === 0" ng-click="vm.editCustomer(vm.customer, $event)" \naria-label="vm.model.views.mainDetails.fab.label" translate tx-access="{{::vm.model.views.mainDetails.fab.privilege}}">\n<md-icon md-font-icon="{{vm.model.views.mainDetails.fab.icon}}"></md-icon></md-button></div></div>');
$templateCache.put('app/main/data-containers/details/data-containers-details.html','<div id="data-containers-details" class="page-layout simple tabbed details-view" layout="column"><div class="content">\n<md-tabs md-dynamic-height md-selected="vm.tabIndex" md-no-ink><md-tab \nlabel="{{\'DATA_CONTAINERS.TABS.DATA_CONTAINER\' | translate}}" tx-access="{{::vm.model.views.privileges.details}}">\n<tx-data-details tx-height-offset="37" tx-account="vm.dataContainer" tx-title="vm.title" tx-model="vm.model" \ntx-is-loading="vm.isLoading" tx-refresh-action-event="vm.refreshRecord(false)"></tx-data-details></md-tab></md-tabs>\n<md-button id="txfab" class="md-fab md-warn" ng-if="vm.tabIndex === 0" \nng-click="vm.editItem(vm.dataContainer, $event)" aria-label="vm.model.views.mainDetails.fab.label" translate \ntx-access="{{::vm.model.views.mainDetails.fab.privilege}}"><md-icon \nmd-font-icon="{{vm.model.views.mainDetails.fab.icon}}"></md-icon></md-button></div></div>');
$templateCache.put('app/main/data-containers/list/data-containers-list.html','<div id="data-containers-list" class="page-layout carded fullwidth list-view" layout="row"><div class="center" \nlayout="column" flex><div class="content-card" layout="column" flex><tx-data-table tx-data="vm.dataContainers" \ntx-model="vm.model" tx-view="mainList" tx-filtered-data="vm.filteredDataContainers" tx-data-filter="global.search" \ntx-is-loading="vm.isLoading" tx-list-action-event="vm.doListAction(action, selectedItems)" \ntx-item-action-event="vm.doItemAction(action, item)" tx-item-click-event="vm.viewItem(item)" \ntx-refresh-action-event="vm.refreshItems(true, false)"></tx-data-table></div></div></div>');
$templateCache.put('app/main/error-pages/404/error-404.html','<div id="error-404" layout="column" layout-align="center center"><div class="content" layout="column" \nlayout-align="center center"><div class="error-code" translate="ERROR404.TITLE">Oops</div><div class="message" \ntranslate="ERROR404.MESSAGE">Sorry but we couldn\u2019t find the page you are looking for</div><div>&nbsp;</div><a \nclass="back-link md-accent-color" ui-sref="app.pages_landing" translate="ERROR404.GO_BACK">Go back home</a></div></div>');
$templateCache.put('app/main/error-pages/unsupported-browser/unsupported-browser.html','<div id="unsupported-browser" class="flex-scrollable" layout="column" ms-scroll><div \nid="unsupported-browser-form-wrapper" layout="column" layout-align="center center"><div id="unsupported-browser-form" \nclass="md-whiteframe-8dp" layout="column" layout-align="start start"><div class="logo md-accent-bg"><span>T1</span>\n</div><div class="content" layout="column" layout-align="start start"><div class="title" \ntranslate="UNSUPPORTED_BROWSER.TITLE">Unsupported Browser.</div><div translate="UNSUPPORTED_BROWSER.SUBTITLE">\nT1 does not support this browser, Please use Google Chrome for a better experience.</div></div></div></div></div>');
$templateCache.put('app/main/hangfire-dashboard/list/hangfire-dashboard-list.html','<div id="hangfire-dashboard" class="page-layout carded fullwidth list-view" layout="row"><div class="center" \nlayout="column" flex><iframe id="hangfire-frame-id" src="" class="content-card" layout="column" flex></iframe></div>\n</div>');
$templateCache.put('app/main/jobs/details/job-details.html','<div id="jobs-details" class="page-layout simple tabbed details-view" layout="column"><div class="content"><md-tabs \nmd-dynamic-height md-selected="vm.tabIndex" md-no-ink><md-tab label="{{\'JOBS.TABS.JOB\' | translate}}" \ntx-access="{{::vm.model.views.privileges.details}}"><tx-data-details tx-height-offset="37" \ntx-is-active="vm.tabIndex === 0" tx-account="vm.job" tx-title="vm.title" tx-model="vm.model" \ntx-item-actions="vm.model.views.mainDetails.itemActions" tx-item-action-event="vm.doItemAction(action, account)" \ntx-is-loading="vm.isLoading" tx-refresh-action-event="vm.refreshRecord()"></tx-data-details></md-tab><md-tab \nlabel="{{\'JOBS.TABS.ERRORS\' | translate}}" tx-access="{{::vm.model.views.privileges.details}}"><div class="list-tab" \nlayout="row" flex="100" layout-wrap><ms-widget layout="row" flex="100"><ms-widget-front class="white-bg"><tx-data-table\n tx-is-active="vm.tabIndex === 1" tx-data="vm.job.ImportErrorList" tx-model="vm.errorsModel" tx-view="mainList" \ntx-filtered-data="vm.filteredErrors" tx-data-filter="global.search" tx-is-loading="vm.isLoading" \ntx-item-action-event="vm.doErrorsItemAction(action, item)" \ntx-list-action-event="vm.doErrorsListAction(action, selectedItems)" tx-item-click-event="vm.viewError(item)" \ntx-refresh-action-event="vm.refreshRecord(true)" tx-height-offset="16"></tx-data-table></ms-widget-front></ms-widget>\n</div></md-tab></md-tabs></div></div>');
$templateCache.put('app/main/jobs/list/jobs-list.html','<div id="jobs-list" class="page-layout carded fullwidth list-view" layout="row"><div class="center" layout="column" \nflex><div class="content-card" layout="column" flex><tx-data-table tx-data="vm.jobs" tx-model="vm.model" \ntx-view="mainList" tx-filtered-data="vm.filteredJobs" tx-data-filter="global.search" tx-is-loading="vm.isLoading" \ntx-item-action-event="vm.doItemAction(action, item)" tx-list-action-event="vm.doListAction(action, selectedItems)" \ntx-item-click-event="vm.viewItem(item)" tx-refresh-action-event="vm.refreshItems(true)"></tx-data-table></div></div>\n</div>');
$templateCache.put('app/main/notifications/details/notification-details.html','<div id="notification-details" class="page-layout simple tabbed details-view" layout="column"><div class="content">\n<md-tabs md-dynamic-height md-selected="vm.tabIndex" md-no-ink><md-tab \nlabel="{{\'NOTIFICATIONS.TABS.NOTIFICATION\' | translate}}" tx-access="{{::vm.model.views.privileges.details}}">\n<tx-data-details tx-height-offset="37" tx-is-active="vm.tabIndex === 0" tx-account="vm.notification" \ntx-title="vm.title" tx-model="vm.model" tx-is-loading="vm.isLoading" tx-refresh-action-event="vm.refreshRecord(false)">\n</tx-data-details></md-tab></md-tabs></div></div>');
$templateCache.put('app/main/notifications/list/notifications-list.html','<div id="notification-list" class="page-layout carded fullwidth list-view" layout="row"><div class="center" \nlayout="column" flex><div class="content-card" layout="column" flex><tx-data-table tx-data="vm.notifications" \ntx-model="vm.model" tx-view="mainList" tx-filtered-data="vm.filteredNotifications" tx-data-filter="global.search" \ntx-is-loading="vm.isLoading" tx-item-action-event="vm.doItemAction(action, item)" \ntx-list-action-event="vm.doListAction(action, selectedItems)" tx-item-click-event="vm.viewItem(item)" \ntx-refresh-action-event="vm.refreshItems(true, false)"></tx-data-table></div></div></div>');
$templateCache.put('app/main/organizations/details/organization-details.html','<div id="sellers-details" class="page-layout simple tabbed details-view" layout="column"><div class="content"><md-tabs \nmd-dynamic-height md-selected="vm.tabIndex" md-no-ink><md-tab \nlabel="{{\'ORGANIZATIONS.TABS.ORGANIZATION\' | translate}}" tx-access="{{::vm.model.views.privileges.details}}">\n<tx-data-details tx-height-offset="37" tx-is-active="vm.tabIndex === 0" tx-account="vm.organization" \ntx-title="vm.title" tx-model="vm.model" tx-edit-record-event="vm.editItem(event, record)" tx-is-loading="vm.isLoading" \ntx-refresh-action-event="vm.refreshRecord(false)"></tx-data-details></md-tab><md-tab \nlabel="{{\'ORGANIZATIONS.TABS.SALES_DATA\' | translate}}" tx-access="{{::vm.salesDataModel.views.privileges.list}}"><div \nclass="list-tab" layout="row" flex="100" layout-wrap><ms-widget layout="row" flex="100"><ms-widget-front \nclass="white-bg"><tx-data-table tx-is-active="vm.tabIndex === 1" tx-data="vm.salesData" tx-model="vm.salesDataModel" \ntx-view="mainList" tx-filtered-data="vm.filteredSalesData" tx-data-filter="global.search" \ntx-is-loading="vm.isSalesDataLoading" tx-item-action-event="vm.doSalesDataItemAction(action, item)" \ntx-list-action-event="vm.doSalesDataListAction(action, selectedItems)" \ntx-refresh-action-event="vm.refreshSalesData(true, false)" tx-height-offset="16"></tx-data-table></ms-widget-front>\n</ms-widget><md-button class="add-rec-button md-fab md-warn" ng-click="vm.addSalesData($event)" \naria-label="vm.salesDataModel.views.mainList.fabAction.label" translate \ntx-access="{{::vm.salesDataModel.views.mainList.fabAction.privilege}}"><md-icon \nmd-font-icon="{{vm.salesDataModel.views.mainList.fabAction.icon}}"></md-icon></md-button></div></md-tab></md-tabs>\n</div></div>');
$templateCache.put('app/main/organizations/list/organizations-list.html','<div id="organizations-list" class="page-layout carded fullwidth list-view" layout="row"><div class="center" \nlayout="column" flex><div class="content-card" layout="column" flex><tx-data-table tx-data="vm.organizations" \ntx-model="vm.model" tx-view="mainList" tx-filtered-data="vm.filteredOrganizations" tx-data-filter="global.search" \ntx-is-loading="vm.isLoading" tx-item-action-event="vm.doItemAction(action, item)" \ntx-item-click-event="vm.viewItem(item)" tx-refresh-action-event="vm.refreshItems(true, false)"></tx-data-table>\n<md-button class="add-rec-button md-fab md-warn" ng-click="vm.addRecord($event)" \naria-label="vm.model.views.mainList.fabAction.label" translate \ntx-access="{{::vm.model.views.mainList.fabAction.privilege}}"><md-icon \nmd-font-icon="{{vm.model.views.mainList.fabAction.icon}}"></md-icon></md-button></div></div></div>');
$templateCache.put('app/main/plugins-consolidation/list/plugins-consolidation-list.html','<div id="jobs-list" class="page-layout carded fullwidth list-view" layout="row"><div class="center" layout="column" \nflex><div class="content-card" layout="column" flex><tx-data-table tx-data="vm.plugins" tx-model="vm.model" \ntx-view="mainList" tx-filtered-data="vm.filteredPlugins" tx-data-filter="global.search" tx-is-loading="vm.isLoading" \ntx-item-action-event="vm.doItemAction(action, item)" tx-list-action-event="vm.doListAction(action, selectedItems)" \ntx-item-click-event="vm.viewItem(item)" tx-refresh-action-event="vm.refreshItems(true)"></tx-data-table><md-button \nclass="add-rec-button md-fab md-warn" ng-click="vm.addRecord($event)" \naria-label="vm.model.views.mainList.fabAction.label" translate \ntx-access="{{::vm.model.views.mainList.fabAction.privilege}}"><md-icon \nmd-font-icon="{{vm.model.views.mainList.fabAction.icon}}"></md-icon></md-button></div></div></div>');
$templateCache.put('app/main/roles/details/roles-details.html','<div id="sellers-details" class="page-layout simple tabbed details-view" layout="column"><div class="content"><md-tabs \nmd-dynamic-height md-selected="vm.tabIndex" md-no-ink><md-tab label="{{\'ROLES.TABS.ROLE\' | translate}}" \ntx-access="{{::vm.model.views.privileges.details}}"><tx-data-details tx-height-offset="37" \ntx-is-active="vm.tabIndex === 0" tx-account="vm.role" tx-title="vm.title" tx-model="vm.model" \ntx-item-actions="vm.model.views.mainDetails.itemActions" tx-item-action-event="vm.doRoleItemAction(action, account)" \ntx-is-loading="vm.isLoading" tx-refresh-action-event="vm.refreshRecord(false)"></tx-data-details></md-tab><md-tab \nlabel="{{\'ROLES.TABS.PRIVILEGES\' | translate}}" ng-disabled="!vm.role.Status" \ntx-access="{{::vm.privilegesModel.views.privileges.list}}"><div class="list-tab" layout="row" flex="100" layout-wrap>\n<ms-widget layout="row" flex="100"><ms-widget-front class="white-bg"><tx-data-table tx-is-active="vm.tabIndex === 1" \ntx-data="vm.rolePrivileges" tx-model="vm.privilegesModel" tx-view="mainList" \ntx-filtered-data="vm.filteredRolePrivileges" tx-data-filter="global.search" tx-is-loading="vm.isPrivilegesLoading" \ntx-refresh-action-event="vm.refreshPrivileges(true, false)" tx-height-offset="16"></tx-data-table></ms-widget-front>\n</ms-widget><md-button class="add-rec-button md-fab md-warn" ng-click="vm.managePrivileges($event)" \naria-label="vm.privilegesModel.views.mainList.fabAction.label" translate \ntx-access="{{::vm.privilegesModel.views.mainList.fabAction.privilege}}"><md-icon \nmd-font-icon="{{vm.privilegesModel.views.mainList.fabAction.icon}}"></md-icon></md-button></div></md-tab><md-tab \nlabel="{{\'ROLES.TABS.LINKED_CATALOGS\' | translate}}" ng-disabled="!vm.role.Status" \ntx-access="{{::vm.linkedCatalogsModel.views.privileges.list}}"><div class="list-tab" layout="row" flex="100" \nlayout-wrap><ms-widget layout="row" flex="100"><ms-widget-front class="white-bg"><tx-data-table \ntx-is-active="vm.tabIndex === 2" tx-data="vm.linkedCatalogs" tx-model="vm.linkedCatalogsModel" tx-view="mainList" \ntx-filtered-data="vm.filteredLinkedCatalogs" tx-data-filter="global.search" tx-is-loading="vm.isLoading" \ntx-refresh-action-event="vm.refreshRecord(false)" tx-height-offset="16"></tx-data-table></ms-widget-front></ms-widget>\n</div></md-tab></md-tabs></div></div>');
$templateCache.put('app/main/roles/list/roles-list.html','<div id="roles-list" class="page-layout carded fullwidth list-view" layout="row"><div class="center" layout="column" \nflex><div class="content-card" layout="column" flex><tx-data-table tx-data="vm.roles" tx-model="vm.model" \ntx-view="mainList" tx-filtered-data="vm.filteredRoles" tx-data-filter="global.search" tx-is-loading="vm.isLoading" \ntx-item-action-event="vm.doItemAction(action, item)" tx-list-action-event="vm.doListAction(action, selectedItems)" \ntx-item-click-event="vm.viewItem(item)" tx-refresh-action-event="vm.refreshItems(true, false)"></tx-data-table>\n<md-button class="add-rec-button md-fab md-warn" ng-click="vm.addRecord($event)" \naria-label="vm.model.views.mainList.fabAction.label" translate \ntx-access="{{::vm.model.views.mainList.fabAction.privilege}}"><md-icon \nmd-font-icon="{{vm.model.views.mainList.fabAction.icon}}"></md-icon></md-button></div></div></div>');
$templateCache.put('app/main/seller-models/details/seller-models-details.html','<div id="models-details" class="page-layout simple tabbed details-view" layout="column"><div class="content"><md-tabs \nmd-dynamic-height md-selected="vm.tabIndex" md-no-ink><md-tab \nlabel="{{\'SELLER_MODELS.TABS.SELLER_MODEL\' | translate}}" tx-access="{{::vm.model.views.privileges.details}}">\n<tx-data-details tx-height-offset="37" tx-account="vm.modelDetails" tx-title="vm.title" tx-model="vm.model" \ntx-is-loading="vm.isLoading" tx-refresh-action-event="vm.refreshRecord(false)"></tx-data-details></md-tab><md-tab \nlabel="{{\'SELLER_MODELS.TABS.CATALOGS\' | translate}}" tx-access="{{::vm.catalogsModel.views.privileges.list}}"><div \nclass="list-tab"><ms-widget layout="row" flex="100"><ms-widget-front class="white-bg"><tx-data-table \ntx-is-active="vm.tabIndex === 1" tx-data="vm.modelCatalogs" tx-model="vm.catalogsModel" tx-view="mainList" \ntx-filtered-data="vm.filteredModelCatalogs" tx-data-filter="global.search" tx-is-loading="vm.isModelCatalogsLoading" \ntx-refresh-action-event="vm.refreshModelCatalogs(true, false)" tx-height-offset="15"></tx-data-table></ms-widget-front>\n</ms-widget></div></md-tab><md-tab label="{{\'SELLER_MODELS.TABS.ARTICLES\' | translate}}" \ntx-access="{{::vm.articlesModel.views.privileges.list}}"><div class="list-tab" layout="row" flex="100" layout-wrap>\n<ms-widget layout="row" flex="100"><ms-widget-front class="white-bg"><tx-data-table tx-is-active="vm.tabIndex === 2" \ntx-data="vm.modelArticles" tx-model="vm.articlesModel" tx-view="mainList" tx-filtered-data="vm.filteredModelArticles" \ntx-data-filter="global.search" tx-is-loading="vm.isModelArticlesLoading" \ntx-refresh-action-event="vm.refreshModelArticles(true, false)" tx-height-offset="16"></tx-data-table></ms-widget-front>\n</ms-widget></div></md-tab><md-tab label="{{\'SELLER_MODELS.TABS.RESOURCES\' | translate}}" \nng-disabled="!vm.modelDetails.Status" tx-access="{{::vm.sellerModelResourcesModel.views.privileges.list}}"><div \nclass="list-tab" layout="row" flex="100" layout-wrap><ms-widget layout="row" flex="100"><ms-widget-front \nclass="white-bg"><tx-data-table tx-is-active="vm.tabIndex === 3" tx-data="vm.modelResources" \ntx-model="vm.sellerModelResourcesModel" tx-view="mainList" tx-filtered-data="vm.filteredModelResources" \ntx-data-filter="global.search" tx-item-action-event="vm.doResourceItemAction(action, item)" \ntx-list-action-event="vm.doResourceListAction(action, selectedItems)" tx-is-loading="vm.isModelResourcesLoading" \ntx-refresh-action-event="vm.refreshModelResources(true, false)" tx-item-click-event="vm.viewResource(item)" \ntx-height-offset="16"></tx-data-table></ms-widget-front></ms-widget><md-button class="add-rec-button md-fab md-warn" \nng-click="vm.assignResources($event)" aria-label="Assign Resources" \ntx-access="{{vm.sellerModelResourcesModel.views.mainList.fabAction.privilege}}"><md-icon md-font-icon="icon-link">\n</md-icon><md-tooltip md-direction="left"><span translate="SELLER_MODELS.TABS.RESOURCES"></span></md-tooltip>\n</md-button></div></md-tab><md-tab label="{{\'SELLER_MODELS.TABS.SIZES\' | translate}}" \ntx-access="{{::vm.sizesModel.views.privileges.list}}"><div class="list-tab" layout="row" flex="100" layout-wrap>\n<ms-widget layout="row" flex="100"><ms-widget-front class="white-bg"><tx-data-table tx-is-active="vm.tabIndex === 4" \ntx-data="vm.modelSizes" tx-model="vm.sizesModel" tx-view="mainList" tx-filtered-data="vm.filteredModelSizes" \ntx-data-filter="global.search" tx-is-loading="vm.isModelSizesLoading" \ntx-refresh-action-event="vm.refreshRecord(false)" tx-height-offset="16" tx-control="vm.tableSizesControl">\n</tx-data-table></ms-widget-front></ms-widget></div></md-tab></md-tabs><md-button id="txfab" class="md-fab md-warn" \nng-if="vm.tabIndex === 0" ng-click="vm.editItem(vm.modelDetails, $event)" \naria-label="vm.model.views.mainDetails.fab.label" translate tx-access="{{::vm.model.views.mainDetails.fab.privilege}}">\n<md-icon md-font-icon="{{vm.model.views.mainDetails.fab.icon}}"></md-icon></md-button></div></div>');
$templateCache.put('app/main/seller-models/list/seller-models-list.html','<div id="seller-models-list" class="page-layout carded fullwidth list-view" layout="row"><div class="center" \nlayout="column" flex><div class="content-card" layout="column" flex><tx-data-table tx-data="vm.sellerModels" \ntx-model="vm.model" tx-view="mainList" tx-filtered-data="vm.filteredSellerModels" tx-data-filter="global.search" \ntx-is-loading="vm.isLoading" tx-item-action-event="vm.doItemAction(action, item)" \ntx-item-click-event="vm.viewItem(item)" tx-list-action-event="vm.doListAction(action, selectedItems)" \ntx-refresh-action-event="vm.refreshItems(true, false)" tx-control="vm.tableControl"></tx-data-table><md-button \nclass="add-rec-button md-fab md-warn" ng-click="vm.addRecord($event)" \naria-label="vm.model.views.mainList.fabAction.label" translate \ntx-access="{{::vm.model.views.mainList.fabAction.privilege}}"><md-icon \nmd-font-icon="{{vm.model.views.mainList.fabAction.icon}}"></md-icon></md-button></div></div></div>');
$templateCache.put('app/main/vas/details/vas-details.html','<div id="vas-details" class="page-layout simple tabbed details-view" layout="column"><div class="content"><md-tabs \nmd-dynamic-height md-selected="vm.tabIndex" md-no-ink><md-tab label="{{\'VAS.TABS.VAS\' | translate}}" \ntx-access="{{::vm.model.views.privileges.details}}"><tx-data-details tx-height-offset="37" \ntx-is-active="vm.tabIndex === 0" tx-account="vm.vas" tx-parent-id="vm.sellerId" tx-title="vm.title" \ntx-model="vm.model" tx-item-actions="vm.model.views.mainDetails.itemActions" \ntx-item-action-event="vm.doVASItemAction(action, account)" tx-is-loading="vm.isLoading" \ntx-refresh-action-event="vm.refreshRecord(false)"></tx-data-details></md-tab></md-tabs></div></div>');
$templateCache.put('app/main/vetting-lists/privacy-policy-details/privacy-policy-details.html','<div id="privacy-policy" class="page-layout carded fullwidth list-view" layout="row"><div class="center" \nlayout="column" flex><div class="content-card" layout="column" flex><div class="title">{{ vm.record.Title }}</div>\n<ng-quill-editor class="ng-quill-editor" flex ng-model="vm.record.Content" read-only="true" modules="vm.editorConfig">\n</ng-quill-editor><md-button class="add-rec-button md-fab md-warn" ng-click="vm.copyPrivacyPolicy($event)" \naria-label="vm.model.views.mainDetails.fabAction.label" translate \ntx-access="{{::vm.model.views.mainDetails.fabAction.privilege}}"><md-icon \nmd-font-icon="{{vm.model.views.mainDetails.fabAction.icon}}"></md-icon></md-button></div></div></div>');
$templateCache.put('app/navigation/layouts/horizontal-navigation/navigation.html','<div layout="row" layout-align="start center"><ms-navigation-horizontal></ms-navigation-horizontal></div>');
$templateCache.put('app/navigation/layouts/vertical-navigation/navigation.html','<md-toolbar class="navigation-header md-whiteframe-1dp" layout="row" layout-align="space-between center"><div \nclass="logo" layout="row" layout-align="start center"><span class="logo-image">T1</span> <span class="logo-text">\nTrasix One</span></div><md-icon class="fold-toggle s18" md-font-icon="icon-backburger" hide show-gt-sm \nng-click="vm.toggleMsNavigationFolded()"><md-tooltip><span translate="NAVIGATION.SHOW_HIDE_NAV"></span></md-tooltip>\n</md-icon></md-toolbar><div class="menu-search-container"><md-icon class="s18" md-font-icon="icon-magnify"></md-icon>\n<input ng-change="vm.search()" ng-model="vm.searchText" ng-keydown="vm.onKeyDown($event)" placeholder="Search" \nautocomplete="off" ng-model-options="{debounce: 500}" ng-focus="focus=true" class="navigation-search" \nng-blur="focus=false"></div><ms-navigation class="scrollable" folded="vm.folded" ms-scroll="vm.msScrollOptions">\n</ms-navigation>');
$templateCache.put('app/quick-panel/tabs/activity/activity-tab.html','<md-list class="friends"><md-subheader class="md-no-sticky"><span translate="QUICKPANEL.FRIENDS">Friends</span>\n</md-subheader><md-list-item class="friend md-3-line" ng-repeat="friend in vm.activities.friends"><img \nng-src="{{friend.avatar}}" class="md-avatar" alt="{{friend.name}}"><div class="status {{friend.status}}"></div><div \nng-if="contact.unread" class="md-accent-bg unread-message-count">{{contact.unread}}</div><div \nclass="md-list-item-text"><h3 class="message">{{friend.message}}</h3><p class="time">{{friend.time}}</p></div>\n</md-list-item></md-list><md-divider></md-divider><md-list class="servers"><md-subheader class="md-no-sticky"><span \ntranslate="QUICKPANEL.APP_SERVERS">Application Servers</span></md-subheader><md-list-item class="server md-3-line" \nng-repeat="server in vm.activities.servers"><md-icon md-font-icon="icon-checkbox-blank-circle" class="s16 status" \nng-class="server.status"></md-icon><div class="md-list-item-text"><h3>{{server.location}}</h3><p>{{server.detail}}</p>\n</div></md-list-item></md-list><md-divider></md-divider><md-list class="stats"><md-subheader class="md-no-sticky"><span\n translate="QUICKPANEL.USER_STATS">User Stats</span></md-subheader><md-list-item class="stat md-2-line" \nng-repeat="stat in vm.activities.stats"><div class="md-list-item-text"><span>\n{{stat.title}} ({{stat.current}} / {{stat.total}})</span><md-progress-linear ng-class="stat.status" \nmd-mode="determinate" value="{{stat.percent}}"></md-progress-linear></div></md-list-item></md-list>');
$templateCache.put('app/quick-panel/tabs/chat/chat-tab.html','<div class="main animate-slide-left" ng-hide="vm.chatActive"><md-list class="recent"><md-subheader \nclass="md-no-sticky"><span translate="QUICKPANEL.RECENT">Recent</span></md-subheader><md-list-item \nclass="contact md-3-line" ng-repeat="contact in vm.contacts.recent" ng-click="vm.toggleChat(contact)"><img \nng-src="{{contact.avatar}}" class="md-avatar" alt="{{contact.name}}"><div class="status {{contact.status}}"></div><div \nng-if="contact.unread" class="md-accent-bg unread-message-count">{{contact.unread}}</div><div \nclass="md-list-item-text"><h3>{{contact.name}}</h3><p class="last-message">{{contact.lastMessage}}</p></div>\n</md-list-item></md-list><md-divider></md-divider><md-list class="all"><md-subheader class="md-no-sticky"><span \ntranslate="QUICKPANEL.START_NEW_CHAT">Start New Chat</span></md-subheader><md-list-item class="contact" \nng-repeat="contact in vm.contacts.all" ng-click="vm.toggleChat(contact)"><img ng-src="{{contact.avatar}}" \nclass="md-avatar" alt="{{contact.name}}"><div class="status {{contact.status}}"></div><div class="md-list-item-text">\n<h3>{{contact.name}}</h3></div></md-list-item></md-list><md-divider></md-divider></div><div \nclass="chat animate-slide-right" ng-show="vm.chatActive" layout="column"><md-toolbar class="md-accent"><div \nclass="md-toolbar-tools" layout="row" layout-align="space-between center"><div layout="row" \nlayout-align="start center"><md-button class="md-icon-button" ng-click="vm.toggleChat()" aria-label="Back" translate \ntranslate-attr-aria-label="QUICKPANEL.BACK"><md-icon md-font-icon="icon-keyboard-backspace"></md-icon></md-button><h4>\n<span>{{vm.chat.contact.name}}</span></h4></div><div layout="row" layout-align="end center"><md-button \nclass="md-icon-button" aria-label="Call" translate translate-attr-aria-label="QUICKPANEL.CALL"><md-icon \nmd-font-icon="icon-phone"></md-icon></md-button><md-button class="md-icon-button" aria-label="More" translate \ntranslate-attr-aria-label="QUICKPANEL.MORE"><md-icon md-font-icon="icon-dots-vertical"></md-icon></md-button></div>\n</div></md-toolbar><md-content flex layout-paddings ms-scroll id="chat-dialog"><div layout="row" \nng-repeat="dialog in vm.chat.contact.dialog" class="md-padding message-row" ng-class="dialog.who"><img \nng-if="dialog.who ===\'contact\'" ng-src="{{vm.chat.contact.avatar}}" class="avatar" alt="{{vm.chat.contact.name}}"> <img\n ng-if="dialog.who ===\'user\'" class="avatar" src="assets/images/avatars/profile.jpg"><div class="bubble" flex><div \nclass="message">{{dialog.message}}</div><div class="time secondary-text">{{dialog.time}}</div></div></div></md-content>\n<form ng-submit="vm.reply()" layout="row" class="reply" layout-align="start center"><textarea \nng-keyup="$event.keyCode == 13 ? vm.reply() : null" flex ng-model="vm.replyMessage" \nplaceholder="Type and hit enter to send message" translate translate-attr-placeholder="QUICKPANEL.REPLY_PLACEHOLDER">\n</textarea><md-button class="md-fab md-mini md-icon-button" type="submit" aria-label="Send message" translate \ntranslate-attr-aria-label="QUICKPANEL.SEND_MESSAGE"><md-icon md-font-icon="icon-send"></md-icon></md-button></form>\n</div>');
$templateCache.put('app/quick-panel/tabs/today/today-tab.html','<md-list class="date today"><md-list-item><div class="md-title secondary-text"><div layout="row" \nlayout-align="start start">{{vm.date | date:\'EEEE\'}}, <span>{{vm.date | date:\'d\'}}</span> &nbsp; <span>\n{{vm.date | date:\'MMMM\'}}</span></div></div></md-list-item></md-list><md-divider></md-divider><md-list><md-subheader \nclass="md-no-sticky"><span translate="QUICKPANEL.JOBS">Background Jobs</span></md-subheader><md-list-item \nclass="md-2-line" ng-repeat="job in vm.jobs | orderBy : \'-createdOn\' " ng-click="vm.gotoJob(job)"><md-icon \nmd-font-icon="icon-close-circle-outline" class="md-warn md-avatar" ng-if="job.status > 95"></md-icon><md-icon \nmd-font-icon="icon-check-circle" class="md-accent md-avatar" ng-if="job.status == 90 || job.status == 95"></md-icon>\n<md-icon md-font-icon="icon-timer" class="md-avatar" ng-if="job.status < 90"></md-icon><div class="md-list-item-text">\n<h3 translate="{{job.name}}">Bulk Operation</h3><p>\n{{vm.getJobStatus(job.status) | translate}} {{job.elapsed | elapsed}}</p><md-progress-linear md-mode="indeterminate" \nclass="md-accent" ng-if="job.status <= 10"></md-progress-linear></div></md-list-item><md-list-item class="md-2-line" \nng-if="vm.jobs.length == 0"><div class="md-list-item-text"><p class="text-italic" translate="QUICKPANEL.NO_JOBS">\nNo Jobs created</p></div></md-list-item></md-list><md-divider></md-divider><md-list><md-subheader class="md-no-sticky">\n<span translate="QUICKPANEL.FILES">File Uploads</span></md-subheader><md-list-item \nng-repeat="file in vm.files | orderBy : \'-createdOn\' " class="md-2-line"><md-icon \nmd-font-icon="icon-close-circle-outline" class="md-warn md-avatar" ng-if="file.status > 95"></md-icon><md-icon \nmd-font-icon="icon-check-circle" class="md-accent md-avatar" ng-if="file.status == 90"></md-icon><md-icon \nmd-font-icon="icon-timer" class="md-avatar" ng-if="file.status < 90"></md-icon><div class="md-list-item-text" \nlayout="column" style="overflow: hidden"><h3>{{file.name}}</h3><p>\n{{vm.getJobStatus(file.status) | translate}} {{file.elapsed | elapsed}}</p><md-progress-linear md-mode="determinate" \nclass="md-accent" ng-if="file.status <= 10" value="{{file.progress*100}}"></md-progress-linear><p \ntranslate="ACTIONS.CANCEL" ng-click="vm.cancelUpload(file)" ng-if="file.status <= 10" style="cursor: pointer">cancel\n</p></div></md-list-item><md-list-item class="md-2-line" ng-if="vm.files.length === 0"><div class="md-list-item-text">\n<p class="text-italic" translate="QUICKPANEL.NO_FILES">No files uploading</p></div></md-list-item></md-list><div \nclass="release" ng-if="vm.release"><md-divider></md-divider><div ng-if="vm.release"><md-tooltip><span>{{::vm.release}}\n</span></md-tooltip><span translate="QUICKPANEL.RELEASE">Release</span> <span>: {{::vm.release}}</span></div></div>');
$templateCache.put('app/services/dataExporter/dialogs/confirmation.html','<md-dialog class="edit-dialog" aria-label="Export Orderline" flex="35"><md-toolbar class="md-accent md-hue-2"><div \nclass="md-toolbar-tools" layout="row" layout-align="space-between center"><span class="title" \ntranslate="DATAEXPORTER.TITLE">Export Orderlines</span><md-button class="md-icon-button" ng-click="vm.cancel()" \naria-label="Close dialog" tranlate translate-aria-label="ACTIONS.DIALOG_CLOSE"><md-icon md-font-icon="icon-close">\n</md-icon></md-button></div></md-toolbar><md-dialog-content><div ng-show="!vm.processing" flex layout="column"><h2 \ntranslate="DATAEXPORTER.CONFIRM_INCLUDE_DEACTIVATED">Would you like to include deactivated records</h2></div><div \nng-show="vm.processing" layout="column" layout-align="center center" flex="100"><span \ntranslate="DATAEXPORTER.PROCESSING"></span><md-progress-circular md-mode="indeterminate" aria-label="Processing">\n</md-progress-circular></div></md-dialog-content><md-dialog-actions layout="row" layout-align="end center"><div></div>\n<div layout="row" layout-align="end center"><md-button ng-click="vm.exportOrderline(\'no\')" \nclass="md-primary md-raised" translate="DATAEXPORTER.NO" aria-label="No" translate-attr-aria-label="DATAEXPORTER.NO" \nng-disabled="vm.processing">nehi</md-button><md-button ng-click="vm.exportOrderline(\'yes\')" \nclass="md-accent md-raised" translate="DATAEXPORTER.YES" aria-label="Yes" translate-attr-aria-label="DATAEXPORTER.YES" \nng-disabled="vm.processing">haan</md-button></div></md-dialog-actions></md-dialog>');
$templateCache.put('app/services/dataImporter/steps/step-1.html','<div class="md-inline-form"><div layout="column" flex><div flex="100"><md-radio-group ng-model="vm.fileOpt" \nlayout="column"><md-radio-button value="0" ng-disabled="!vm.lastSheetExists">Last Used File</md-radio-button>\n<md-radio-button value="1">New File</md-radio-button></md-radio-group></div><div flex="100" layout="row" \nlayout-align="space-between center" ng-show="vm.fileOpt === \'1\'"><div flex="initial"><span>Filename:</span></div><div \nflex layout="row"><div flex class="text-boxed"><label for="fileName" \nng-show="!vm.fileData.loading && vm.fileData.fileName.length == 0" style="display: block; width: 100%">[none]</label>\n<span ng-show="!vm.fileData.loading && vm.fileData.fileName.length > 0" class="text-truncate">{{vm.fileData.fileName}}\n</span> <span ng-show="vm.fileData.loading">Loading...</span> <span ng-show="vm.fileData.hasError" \nclass="text-truncate">Error: {{vm.fileData.error}}</span></div></div><div flex="initial" style="width:25px" \nlayout-align="center center" ng-show="vm.fileData.loading"><md-progress-circular md-mode="indeterminate" \nmd-diameter="20"></md-progress-circular></div><div flex="initial"><md-button class="md-raised select-file" \nng-disabled="vm.fileData.loading"><label for="fileName">Select...</label></md-button></div></div><input type="file" \nid="fileName" name="fileName" ng-model="vm.stepper.step1.fileName" tx-file-read="vm.fileData" \naccept=".xls,.xlsx,.xlsb" style="visibility:hidden" ng-required="vm.fileOpt === \'1\'"></div></div>');
$templateCache.put('app/services/dataImporter/steps/step-2.html','<div class="md-inline-form"><div layout="column" flex><div><span>\nPlease select the sheet that contains the data you wish to import</span></div><div flex><md-input-container flex="100">\n<md-select name="sheet" ng-model="vm.selectedSheet" required placeholder="Sheet" style="min-width: 200px" \naria-label="Select Sheet"><md-option ng-repeat="sheet in vm.sheetsList" value="{{sheet}}">{{sheet}}</md-option>\n</md-select><div ng-messages="step2.sheet.$error" ng-show="step2.sheet.$touched" role="alert" multiple="multiple"><div \nng-message="required"><span>You must select a sheet.</span></div></div></md-input-container></div></div></div>');
$templateCache.put('app/services/dataImporter/steps/step-3.html','<div class="md-inline-form"><md-content layout="column" flex class="data-mapping-container" ms-scroll><div><span>\nPlease select the columns in your sheet that match each of the following fields.</span> <small>\nAll fields marked with a * are mandatory and must be mapped before continuing.</small></div><div \nng-if="vm.targetModel.modelPath === \'resources.mapToArticles\' || vm.targetModel.modelPath === \'sellers.mapResourcesToArticles\'" \nclass="p-5"><md-switch ng-model="vm.isModelLevelImport" ng-true-value="true" ng-false-value="false" class="md-accent" \nng-change="vm.onImportModelLevelToggle()">{{\'RESOURCES.FIELDS.MODEL_RESOURCE\' | translate}}</md-switch></div><div><div \nclass="import-search-container" flex layout="row"><md-input-container><md-icon class="s18" md-font-icon="icon-magnify">\n</md-icon><input ng-model="vm.searchText" type="search" ng-keydown="vm.onKeyDown($event)" placeholder="Search" \nmd-autofocus ng-change="vm.onSearchTextChanged()"></md-input-container></div><div flex layout="row" \nlayout-align="center center" ng-repeat="item in vm.filteredMapping"><div flex="30" class="text-overflow-wrap">\n{{item.field.displayLabel | translate | ampersand}}<strong ng-show="vm.isInputRequired(item.field, vm.acModel)" \nclass="red-900-fg">*</strong></div><div flex="10">=</div><div flex="50" layout="row"><md-autocomplete \nmd-input-name="field_{{item.field.field}}" md-search-text="vm.acSearchText[item.field.field]" \nmd-selected-item="vm.acModel[item.field.field]" \nmd-items="col in vm.acSearchColumns(vm.columns, vm.acSearchText[item.field.field])" md-item-text="col.v" \nmd-selected-item-change="vm.acChangeEvent(vm.acModel[item.field.field], item)" md-min-length="0" \nmd-floating-label="{{item.field.displayLabel | translate}}" ng-click="vm.acSelectText($event)" \nng-required="vm.isInputRequired(item.field, vm.acModel)" md-no-cache="true" tx-clear-autocomplete \nmd-menu-class="autocomplete-custom" flex="95"><md-item-template><span class="autocomplete-item md-accent-fg" \nmd-highlight-text="vm.acSearchText[item.field.field]" md-highlight-flags="i">{{col.v | ampersand}}</span>\n</md-item-template><div ng-messages="step3[\'field_{{item.field.field}}\'].$error" \nng-show="step3[\'field_{{item.field.field}}\'].$touched" role="alert" multiple="multiple"><div ng-message="required">\n<span>You must select a column</span></div></div><md-not-found>\nNo Record matching "{{vm.acSearchText[item.field.field]}}" were found.</md-not-found></md-autocomplete><md-icon \nmd-font-icon="icon-alert" ng-if="item.warn"><md-tooltip><span translate>\nWarning: This column is already mapped to another field</span></md-tooltip></md-icon></div></div></div></md-content>\n</div>');
$templateCache.put('app/services/dataImporter/steps/step-4.html','<div class="md-inline-form"><md-content layout="column" flex class="data-mapping-container" ms-scroll><div><span>\nWould you like to import all the rows in the sheet or only the rows that match a specific criteria?</span></div><div \nflex="100"><md-radio-group ng-model="vm.sheetFilterOpt.state" layout="column"><md-radio-button value="0">\nImport All Rows</md-radio-button><md-radio-button value="1">Import Only the Rows that match the following criteria:\n</md-radio-button></md-radio-group></div><div flex="100" layout="row" class="import-criteria-form" \nlayout-align="space-between center" ng-show="vm.sheetFilterOpt.state === \'1\'"><md-select \nng-model="vm.sheetFilterOpt.include" ng-required="vm.sheetFilterOpt.state === \'1\'" aria-label="Select Import Option">\n<md-option value="0">Include</md-option><md-option value="1">Exclude</md-option></md-select><span>\nthe Rows where column:</span><md-input-container md-no-float><md-select name="column" placeholder="Column" \nstyle="min-width: 200px" ng-model="vm.sheetFilterOpt.column" ng-required="vm.sheetFilterOpt.state === \'1\'" \naria-label="Select Column" ng-change="vm.onFilterColumnChange()"><md-option></md-option><md-option \nng-repeat="col in vm.columns" value="{{col.c}}">{{col.v}}</md-option></md-select></md-input-container><span>contains\n</span><md-select ng-model="vm.sheetFilterOpt.contains" ng-required="vm.sheetFilterOpt.state === \'1\'" \naria-label="Select Criteria"><md-option value="0">Any Value</md-option><md-option value="1">No Value (Empty)\n</md-option><md-option value="2">A specific Value:</md-option></md-select></div><div flex="100" layout="row" \nlayout-align="space-between center"><md-input-container md-no-float class="md-block" \nng-if="vm.sheetFilterOpt.state === \'1\' && vm.sheetFilterOpt.contains === \'2\'"><input \nng-model="vm.sheetFilterOpt.specificValue" placeholder="Enter the value to match" \nng-required="vm.sheetFilterOpt.state === \'1\' && vm.sheetFilterOpt.contains === \'2\'"></md-input-container></div>\n</md-content></div>');
$templateCache.put('app/services/dataImporter/steps/step-5.html','<div class="md-inline-form step-5"><div layout="column" flex><div style="margin-bottom:15px"><span>\nThe sheet will be processed to identify if all the rows are valid to be imported</span></div><div hidden><input \nname="tempValidation" type="text" ng-model="vm.tempValidation" required></div><div flex layout="row" layout-wrap \nlayout-align="center center"><div flex="100" class="import-data-device-width" style="height:30px; margin-bottom:10px" \nng-show="vm.validationWorking"><md-progress-linear md-mode="determinate" class="md-accent" \nvalue="{{vm.validationProgress}}"></md-progress-linear></div><div flex="50" class="import-data-device-width" \nstyle="height:30px">Status:</div><div flex="50" class="text-boxed">{{vm.validationWorking ? \'Validating\' : \'Finished\'}}\n</div><div flex="50" class="import-data-device-width" style="height:30px">Total Valid Rows:</div><div flex="50" \nclass="text-boxed">{{vm.totalValid}}</div><div flex="50" class="import-data-device-width" style="height:30px">\nTotal Invalid Rows:</div><div flex="50" class="text-boxed">{{vm.totalInvalid}}</div><div flex="50" \nclass="import-data-device-width" style="height:30px">Total Skipped Rows:</div><div flex="50" class="text-boxed">\n{{vm.totalSkipped}}</div><div flex="50" class="important-text import-data-device-width" layout="row"><div \nng-show="(vm.totalInvalid > 0 || vm.totalValid === 0) && !vm.validationWorking && !vm.validationError" flex="none">\n<md-icon md-font-icon="icon-alert-circle" class="md-warn"></md-icon></div><div \nng-show="vm.totalInvalid > 0 && !vm.validationWorking && !vm.validationError" flex>\nThere are currently some invalid rows, please rectify these issues before continuing.</div><div \nng-show="vm.totalInvalid === 0 && vm.totalValid === 0 && vm.isValidExcel !== 0 && vm.isArticleCountWithinLimit && !vm.validationWorking && !vm.validationError" \nflex>There are no rows available to be submitted.</div><div \nng-show="vm.totalInvalid === 0 && vm.totalValid === 0 && vm.isValidExcel === 0 && !vm.validationWorking" flex>\nThere are no attributes available to be submitted</div><div \nng-show="vm.totalInvalid === 0 && vm.totalValid === 0 && vm.isValidExcel !== 0 && !vm.isArticleCountWithinLimit && !vm.validationWorking" \nflex>{{\'ARTICLES.MESSAGES.SHOW_ARTICLE_BACKGROUND_JOB_LIMIT_WARNING\' | translate}}</div><div \nng-show="vm.totalInvalid === 0 && vm.totalValid > 0 && !vm.validationWorking && !vm.validationError" flex="none">\n<md-icon md-font-icon="icon-check-circle" class="md-accent"></md-icon></div><div \nng-show="vm.totalInvalid === 0 && vm.totalValid > 0 && !vm.validationWorking && !vm.validationError" flex>\nNo issues were detected in your source file. The data is ready to be submitted.</div><div flex="none" \nng-if="!vm.validationWorking"><md-button class="md-raised" ng-click="vm.saveResult()" \nng-disabled="vm.validationWorking" ng-hide="vm.resultsLoading || vm.totalInvalid === 0">Get Result</md-button>\n<md-progress-circular md-mode="indeterminate" ng-show="vm.resultsLoading"></md-progress-circular></div></div><div \nflex="100" class="important-text import-data-device-width" layout="row" \nng-show="vm.validationError && !vm.validationWorking"><div flex="none"><md-icon md-font-icon="icon-alert-circle" \nclass="md-warn"></md-icon></div><div flex>{{vm.validationError}}</div></div><div flex="50" \nclass="important-text import-data-device-width" layout="row" \nng-show="vm.totalInvalid !== 0 && vm.totalValid > 0 && !vm.validationWorking && !vm.validationError"><md-checkbox \nng-model="vm.skipInvalidRecords" aria-label="{{\'DATAIMPORTER.SKIP_INVALID_ROWS\' | translate}}" \nng-change="vm.skipInvalidRows()">{{ \'DATAIMPORTER.SKIP_INVALID_ROWS\' | translate }}</md-checkbox></div></div></div>\n</div>');
$templateCache.put('app/services/dataImporter/steps/step-6.html','<div class="md-inline-form"><div layout="column" flex ng-if="vm.validateCustomerAssignedStocks"><div><span>\n{{\'DATAIMPORTER.ACTIONS.SELECT_STOCKS\' | translate}}<span></span></span></div><div flex="50" flex-gt-xs="50" \nclass="p-5 mt-10"><md-autocomplete id="dialog_input_{{$first ? \'first\' : $index}}" md-input-name="stockDefinitionId" \nmd-selected-item="vm.stockDefinitionId" \nmd-items="item in vm.stocksLookupSearch(vm.searchStockText.StockDefinitionId, \'StockDefinitionId\', vm.customerStocks)" \nmd-search-text="vm.searchStockText.StockDefinitionId" \nmd-item-text="vm.getStockLookupDisplayValue(item, vm.customerStocks)" md-min-length="0" \nmd-floating-label="{{\'ORDERS.FIELDS.STOCK\' | translate}}" \nmd-selected-item-change="vm.lookupChange(vm.stockDefinitionId)" ng-required="true" md-no-cache="true" \ntx-clear-autocomplete tx-force-select ng-click="vm.acSelectText($event)" md-menu-class="autocomplete-custom">\n<md-item-template><span class="autocomplete-item md-accent-fg" \nmd-highlight-text="vm.searchStockText.StockDefinitionId" md-highlight-flags="i">{{item.StockName}}</span>\n</md-item-template><md-not-found>No Record matching "{{vm.searchStockText.StockDefinitionId}}" were found.\n</md-not-found></md-autocomplete></div></div><div div layout="column" flex \nng-if="vm.validateCustomerAssignedStocks && vm.invalidArticleStocks.length"><tx-data-table \ntx-data="vm.invalidArticleStocks" tx-model="vm.invalidArticleStocksModel" tx-view="mainList" \ntx-filtered-data="vm.filteredInvalidArticleStocks" tx-data-filter="global.search" tx-height-offset="16">\n</tx-data-table></div><div \nng-if="(!vm.isUpdateArticlesByModel && !vm.isUpdateArticleSegmentationByModel) && !vm.invalidArticleStocks.length">\n<span>Your data is ready to be imported, please click on the Submit button below to submit the request to the server.\n<span></span></span></div><div ng-if="vm.isUpdateArticlesByModel || vm.isUpdateArticleSegmentationByModel"><span>\nYou are about to overwrite data for all Colorways(Model Number).<span></span></span></div></div>');
$templateCache.put('app/toolbar/dialogs/active-catalog/activeCatalog.dialog.html','<md-dialog class="tx-dialog active-catalog-dialog" aria-label="Active Catalog" \ntranslate-attr-aria-label="TOOLBAR.CATALOGS"><form name="editForm" class="md-inline-form" \nng-submit="vm.applyChanges()"><md-toolbar class="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" \nlayout-align="space-between center"><span class="title" translate="TOOLBAR.CATALOGS">Active Catalog</span><md-button \nclass="md-icon-button" ng-click="vm.cancelDialog()" aria-label="Close dialog" tranlate \ntranslate-aria-label="ACTIONS.DIALOG_CLOSE"><md-icon md-font-icon="icon-close"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><p>Please select the Catalog you would like to use</p><md-autocomplete \nid="autocomplete-active-catalog" md-selected-item="vm.currentCatalog" md-search-text="vm.searchText" \nmd-items="item in vm.querySearch(vm.searchText)" md-item-text="item.CatalogName" md-min-length="0" \nplaceholder="Catalog" md-menu-class="autocomplete-custom-active-catalog"><md-item-template><span class="item-seller">\n{{vm.getSellerName(item)}}</span> <span class="item-catalog" \nng-class="item.IsLinePlan === 1 ? \'line-plan-catalog\' : \'md-accent-fg\'" md-highlight-text="vm.searchText" \nmd-highlight-flags="^i">{{::item.CatalogName}}</span></md-item-template><md-not-found>\nNo catalogs matching "{{vm.searchText}}" were found.</md-not-found></md-autocomplete></md-dialog-content>\n<md-dialog-actions layout="row" layout-align="end center"><div></div><div layout="row" layout-align="end center">\n<md-button ng-click="vm.cancelDialog()" class="send-button md-primary md-raised" aria-label="Cancel" \ntranslate="ACTIONS.DIALOG_CANCEL" translate-attr-aria-label="ACTIONS.DIALOG_CANCEL">CANCEL</md-button><md-button \ntype="submit" class="send-button md-accent md-raised" aria-label="Ok" translate="ACTIONS.OK" \ntranslate-attr-aria-label="ACTIONS.OK">OK</md-button></div></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/toolbar/layouts/content-with-toolbar/toolbar.html','<div layout="row" layout-align="space-between center"><div layout="row" layout-align="start center"><div class="logo" \nlayout="row" layout-align="start center"><span class="logo-image">T1</span> <span class="logo-text">Trasix One</span>\n</div><md-progress-circular id="toolbar-progress" ng-if="$root.loadingProgress" class="md-accent" \nmd-mode="indeterminate" md-diameter="32"></md-progress-circular></div><div layout="row" layout-align="start center">\n<div class="toolbar-separator"></div><ms-search-bar></ms-search-bar><div class="toolbar-separator"></div><md-menu-bar \nid="user-menu"><md-menu md-position-mode="left bottom"><md-button class="user-button" ng-click="$mdOpenMenu()" \naria-label="User settings" translate translate-attr-aria-label="TOOLBAR.USER_SETTINGS"><div layout="row" \nlayout-align="space-between center"><div class="avatar-wrapper"><img md-menu-align-target class="avatar" \nsrc="assets/images/avatars/profile.jpg"><md-icon md-font-icon ng-class="vm.userStatus.icon" \nng-style="{\'color\': vm.userStatus.color }" class="icon status s16"></md-icon></div><span class="username" hide-xs>\nJohn Doe</span><md-icon md-font-icon="icon-chevron-down" class="icon s16" hide-xs></md-icon></div></md-button>\n<md-menu-content width="3"><md-menu-item class="md-indent" ui-sref="app.pages_profile"><md-icon \nmd-font-icon="icon-account" class="icon"></md-icon><md-button ui-sref="app.pages_profile">My Profile</md-button>\n</md-menu-item><md-menu-item class="md-indent" ui-sref="app.mail"><md-icon md-font-icon="icon-email" class="icon">\n</md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item class="md-indent"><md-icon md-font-icon \nng-class="vm.userStatus.icon" ng-style="{\'color\': vm.userStatus.color }" class="icon"></md-icon><md-menu \nid="user-status-menu"><md-button ng-click="$mdOpenMenu()" class="status" ng-class="vm.userStatus.class">\n{{vm.userStatus.title}}</md-button><md-menu-content width="2"><md-menu-item class="status md-indent" \nng-class="{\'selected\': status === vm.userStatus}" ng-repeat="status in vm.userStatusOptions"><md-icon \nmd-font-icon="{{status.icon}}" ng-style="{\'color\': status.color }" class="icon"></md-icon><md-button \nng-click="vm.setUserStatus(status)">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class="md-indent"><md-icon md-font-icon="icon-logout" \nclass="icon"></md-icon><md-button ng-click="vm.logout()">Logout</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><div class="toolbar-separator"></div><md-menu id="language-menu" md-offset="0 72" \nmd-position-mode="target-right target"><md-button class="language-button" ng-click="$mdOpenMenu()" \naria-label="Language" md-menu-origin md-menu-align-target><div layout="row" layout-align="center center"><img \nclass="flag" ng-src="assets/images/flags/{{vm.selectedLanguage.flag}}.png"> <span class="iso">\n{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width="3" id="language-menu-content">\n<md-menu-item ng-repeat="(iso, lang) in vm.languages"><md-button ng-click="vm.changeLanguage(lang)" \naria-label="{{lang.title}}" translate translate-attr-aria-label="{{lang.title}}"><span layout="row" \nlayout-align="start center"><img class="flag" ng-src="assets/images/flags/{{lang.flag}}.png"> <span \ntranslate="{{lang.translation}}">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<div class="toolbar-separator"></div><md-button id="quick-panel-toggle" class="md-icon-button" \nng-click="vm.toggleSidenav(\'quick-panel\')" aria-label="Toggle quick panel" translate \ntranslate-attr-aria-label="TOOLBAR.TOGGLE_QUICK_PANEL"><md-icon md-font-icon="icon-format-list-bulleted" class="icon">\n</md-icon><md-icon md-font-icon="icon-alert-circle" class="icon notify-icon" ng-if="vm.showNotificationIcon === true">\n</md-icon></md-button></div></div>');
$templateCache.put('app/toolbar/layouts/horizontal-navigation/toolbar.html','<div layout="row" layout-align="space-between center"><div layout="row" layout-align="start center"><div \nclass="navigation-toggle" hide-gt-sm><md-button class="md-icon-button" ng-click="vm.toggleHorizontalMobileMenu()" \naria-label="Toggle Mobile Navigation"><md-icon md-font-icon="icon-menu"></md-icon></md-button></div><div class="logo" \nlayout="row" layout-align="start center"><span class="logo-image">T1</span> <span class="logo-text">Trasix One</span>\n</div><md-progress-circular id="toolbar-progress" ng-if="$root.loadingProgress" class="md-accent" \nmd-mode="indeterminate" md-diameter="32"></md-progress-circular></div><div layout="row" layout-align="start center">\n<ms-search-bar></ms-search-bar><md-menu-bar id="user-menu"><md-menu md-position-mode="left bottom"><md-button \nclass="user-button" ng-click="$mdOpenMenu()" aria-label="User settings" translate \ntranslate-attr-aria-label="TOOLBAR.USER_SETTINGS"><div layout="row" layout-align="space-between center"><div \nclass="avatar-wrapper"><img md-menu-align-target class="avatar" src="assets/images/avatars/profile.jpg"><md-icon \nmd-font-icon ng-class="vm.userStatus.icon" ng-style="{\'color\': vm.userStatus.color }" class="icon status s16">\n</md-icon></div><span class="username" hide-xs>John Doe</span><md-icon md-font-icon="icon-chevron-down" \nclass="icon s16" hide-xs></md-icon></div></md-button><md-menu-content width="3"><md-menu-item class="md-indent" \nui-sref="app.pages_profile"><md-icon md-font-icon="icon-account" class="icon"></md-icon><md-button>My Profile\n</md-button></md-menu-item><md-menu-item class="md-indent" ui-sref="app.mail"><md-icon md-font-icon="icon-email" \nclass="icon"></md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item class="md-indent"><md-icon \nmd-font-icon ng-class="vm.userStatus.icon" aria-label="avatar" ng-style="{\'color\': vm.userStatus.color }" class="icon">\n</md-icon><md-menu id="user-status-menu"><md-button ng-click="$mdOpenMenu()" class="status" \nng-class="vm.userStatus.class">{{vm.userStatus.title}}</md-button><md-menu-content width="2"><md-menu-item \nclass="status md-indent" ng-class="{\'selected\': status === vm.userStatus}" ng-repeat="status in vm.userStatusOptions">\n<md-icon md-font-icon="{{status.icon}}" ng-style="{\'color\': status.color }" class="icon"></md-icon><md-button \nng-click="vm.setUserStatus(status)">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class="md-indent"><md-icon md-font-icon="icon-logout" \nclass="icon"></md-icon><md-button ng-click="vm.logout()">Logout</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><md-menu id="language-menu" md-offset="0 72" md-position-mode="target-right target"><md-button \nclass="language-button" ng-click="$mdOpenMenu()" aria-label="Language" md-menu-origin md-menu-align-target><div \nlayout="row" layout-align="center center"><img class="flag" \nng-src="assets/images/flags/{{vm.selectedLanguage.flag}}.png"> <span class="iso">{{vm.selectedLanguage.code}}</span>\n</div></md-button><md-menu-content width="3" id="language-menu-content"><md-menu-item \nng-repeat="(iso, lang) in vm.languages"><md-button ng-click="vm.changeLanguage(lang)" aria-label="{{lang.title}}" \ntranslate translate-attr-aria-label="{{lang.title}}"><span layout="row" layout-align="start center"><img class="flag" \nng-src="assets/images/flags/{{lang.flag}}.png"> <span translate="{{lang.translation}}">{{lang.title}}</span></span>\n</md-button></md-menu-item></md-menu-content></md-menu><md-button id="quick-panel-toggle" class="md-icon-button" \nng-click="vm.toggleSidenav(\'quick-panel\')" aria-label="Toggle quick panel" translate \ntranslate-attr-aria-label="TOOLBAR.TOGGLE_QUICK_PANEL"><md-icon md-font-icon="icon-format-list-bulleted" class="icon">\n</md-icon><md-icon md-font-icon="icon-alert-circle" class="icon notify-icon" ng-if="vm.showNotificationIcon === true">\n</md-icon></md-button></div></div>');
$templateCache.put('app/toolbar/layouts/vertical-navigation/toolbar.html','<div layout="row" layout-align="start center" class="top-bar md-accent-bg" \nng-class="vm.isLinePlan ? \'line-plan\' : \'md-accent-bg\'" \nng-style="{\'background-color\': (vm.titleBarBackgroundColor !== \'\') ? vm.titleBarBackgroundColor: \'#039BE5\'}"><div \nlayout="row" layout-align="start center" flex><md-button id="navigation-toggle" class="md-icon-button" \nng-click="vm.toggleSidenav(\'navigation\')" hide-gt-sm aria-label="Toggle navigation" translate \ntranslate-attr-aria-label="TOOLBAR.TOGGLE_NAVIGATION"><md-icon md-font-icon="icon-menu" class="icon"></md-icon>\n</md-button><div id="toolbar-title" flex="auto" layout="row" layout-align="start center"><div \nid="back-button-placeholder"><md-button id="back-button" class="md-icon-button" ng-disabled="!vm.historyExists()" \naria-label="Back" translate translate-attr-aria-label="TOOLBAR.BACK" ng-click="vm.goBack()"><md-icon \nmd-font-icon="icon-arrow-left" class="icon"></md-icon><md-tooltip><span translate="TOOLBAR.BACK">Back</span>\n</md-tooltip></md-button></div><tx-breadcrumbs tx-displayname-property="data.displayName"></tx-breadcrumbs></div></div>\n<div layout="row" layout-align="start center"><div class="toolbar-separator" ng-if="!$root.online"></div><md-button \nid="offline-icon" class="md-icon-button md-warn" ng-click="" ng-if="!$root.online" aria-label="Offline" translate \ntranslate-attr-aria-label="TOOLBAR.OFFLINE"><md-icon md-font-icon="icon-close-network" class="icon" hide-xs></md-icon>\n<md-tooltip><span translate="TOOLBAR.OFFLINE"></span></md-tooltip></md-button><div class="toolbar-separator" hide \nshow-gt-lg ng-if="vm.isMultiEnv"></div><md-button id="current-env" hide show-gt-lg \nng-click="vm.showCurrentEnv($event)" ng-if="vm.isMultiEnv" class="animate-fade-in-out"><div layout="row"><dl><dt \ntranslate="TOOLBAR.ENV">Current Environment</dt><dd>{{vm.env.name}}</dd></dl></div></md-button><div \nclass="toolbar-separator" hide show-gt-md></div><md-button id="active-catalog" hide show-gt-md \nng-click="vm.selectCatalog($event)" ng-disabled="isCatalogDropdownDisabled" class="animate-fade-in-out" \nng-class="isCatalogDropdownDisabled ? \'active-catalog-disabled\' : \'\'"><div layout="row"><dl><dt \ntranslate="TOOLBAR.CATALOGS">Active Catalog</dt><dd>{{vm.activeCatalog[vm.catalogModel.lookupDisplayField]}}</dd></dl>\n<md-icon md-font-icon="icon-chevron-down" class="icon s16 p-5" hide-xs></md-icon></div><md-tooltip><span \ntranslate="TOOLBAR.SET_ACTIVE_CATALOG"></span></md-tooltip></md-button><div class="toolbar-separator"></div>\n<md-menu-bar id="user-menu"><md-menu md-position-mode="left bottom" \nng-class="vm.isLinePlan ? \'line-plan\' : \'md-accent-bg\'" \nng-style="{\'background-color\': (vm.titleBarBackgroundColor !== \'\') ? vm.titleBarBackgroundColor: \'rgb(3,155,229)\'}">\n<md-button class="user-button" ng-click="$mdOpenMenu()" aria-label="User settings" translate \ntranslate-attr-aria-label="TOOLBAR.USER_SETTINGS"><div layout="row" layout-align="space-between center"><div \nclass="avatar-wrapper"><img md-menu-align-target class="avatar" src="assets/images/avatars/profile.jpg"><md-icon \nmd-font-icon aria-label="avatar" ng-class="vm.userStatus.icon" ng-style="{\'color\': vm.userStatus.color }" \nclass="icon status s16"></md-icon></div><span class="username" hide-xs>{{vm.profileName}}</span><md-icon \nmd-font-icon="icon-chevron-down" class="icon s16" hide-xs></md-icon></div></md-button><md-menu-content width="3">\n<md-menu-item class="md-indent" ui-sref="app.pages_profile"><md-icon md-font-icon="icon-account" class="icon">\n</md-icon><md-button>My Profile</md-button></md-menu-item><md-menu-item class="md-indent" \nng-class="vm.allowedChildUsersCount === 1 ? \'cursor-dafault\' : \'\'"><md-icon md-font-icon="icon-account-switch" \nclass="icon" ng-class="vm.allowedChildUsersCount <= 1 ? \'icon-disabled-color\' : \'\'"></md-icon><md-button \nng-disabled="vm.allowedChildUsersCount <= 1" ng-click="vm.switchUser()">{{ vm.profile.UserName }}<md-tooltip><span \ntranslate="TOOLBAR.ACTIONS.SWITCH_USER"></span></md-tooltip></md-button></md-menu-item><md-menu-item class="md-indent">\n<md-icon md-font-icon ng-class="vm.userStatus.icon" ng-style="{\'color\': vm.userStatus.color }" class="icon"></md-icon>\n<md-menu id="user-status-menu"><md-button ng-click="$mdOpenMenu()" class="status" ng-class="vm.userStatus.class">\n{{vm.userStatus.title}}</md-button><md-menu-content width="2"><md-menu-item class="status md-indent" \nng-class="{\'selected\': status === vm.userStatus}" ng-repeat="status in vm.userStatusOptions"><md-icon \nmd-font-icon="{{status.icon}}" ng-style="{\'color\': status.color }" class="icon"></md-icon><md-button \nng-click="vm.setUserStatus(status)">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class="md-indent"><md-icon md-font-icon="icon-logout" \nclass="icon"></md-icon><md-button ng-click="vm.logout()">Logout</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><div hide show-gt-md class="toolbar-separator"></div><md-menu hide show-gt-md id="language-menu" \nmd-offset="0 72" md-position-mode="target-right target"><md-button class="language-button" ng-click="$mdOpenMenu()" \naria-label="Language" md-menu-origin md-menu-align-target><div layout="row" layout-align="center center"><img \nclass="flag" ng-src="assets/images/flags/{{vm.selectedLanguage.flag}}.png"> <span class="iso">\n{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width="3" id="language-menu-content">\n<md-menu-item ng-repeat="(iso, lang) in vm.languages"><md-button ng-click="vm.changeLanguage(lang)" \naria-label="{{lang.title}}" translate translate-attr-aria-label="{{lang.title}}"><span layout="row" \nlayout-align="start center"><img class="flag" ng-src="assets/images/flags/{{lang.flag}}.png"> <span \ntranslate="{{lang.translation}}">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<div class="toolbar-separator"></div><md-button hide show-gt-md id="toggle-full-screen" class="md-icon-button" \nng-click="vm.toggleFullScreen(\'fullScreen\')" aria-label="Toggle full screen" translate \ntranslate-attr-aria-label="TOOLBAR.TOGGLE_FULL_SCREEN"><md-icon md-font-icon="icon-arrow-expand" class="icon">\n</md-icon><md-tooltip><span translate="TOOLBAR.TOGGLE_FULL_SCREEN"></span></md-tooltip></md-button><div hide \nshow-gt-md class="toolbar-separator"></div><md-button hide show-gt-md id="quick-panel-toggle" class="md-icon-button" \nng-click="vm.toggleSidenav(\'quick-panel\')" aria-label="Toggle quick panel" translate \ntranslate-attr-aria-label="TOOLBAR.TOGGLE_QUICK_PANEL"><md-icon md-font-icon="icon-format-list-bulleted" class="icon">\n</md-icon><md-icon md-font-icon="icon-alert-circle" class="icon notify-icon" ng-if="vm.showNotificationIcon === true">\n</md-icon><md-tooltip><span translate="TOOLBAR.TOGGLE_QUICK_PANEL"></span></md-tooltip></md-button><div hide-gt-md \nclass="actions" flex="none"><md-menu><md-button class="md-icon-button" ng-click="$mdOpenMenu($event)" \naria-label="Action"><md-icon md-font-icon="icon-dots-vertical"></md-icon></md-button><md-menu-content width="3">\n<md-menu-item ng-class="isCatalogDropdownDisabled ? \'active-catalog-disabled\' : \'\'"><md-button id="active-catalog" \nclass="active-catalog-menu-width" ng-disabled="isCatalogDropdownDisabled" ng-click="vm.selectCatalog($event)" \naria-label="Active Catalog" translate translate-attr-aria-label="TOOLBAR.CATALOG"><md-icon class="s18" \nmd-font-icon="icon-book-open"></md-icon><span class="capitalize" translate="TOOLBAR.CATALOG"></span><strong> : \n</strong><span class="active-catalog-name">{{vm.activeCatalog[vm.catalogModel.lookupDisplayField]}}</span></md-button>\n</md-menu-item><md-menu-item><md-button id="toggle-full-screen" ng-click="vm.toggleFullScreen(\'fullScreen\')" \naria-label="Toggle full screen" translate translate-attr-aria-label="TOOLBAR.TOGGLE_FULL_SCREEN"><md-icon class="s18" \nmd-font-icon="icon-arrow-expand"></md-icon><span class="capitalize" translate="TOOLBAR.TOGGLE_FULL_SCREEN"></span>\n</md-button></md-menu-item><md-menu-item><md-button id="quick-panel-toggle" ng-click="vm.toggleSidenav(\'quick-panel\')" \naria-label="Toggle quick panel" translate translate-attr-aria-label="TOOLBAR.TOGGLE_QUICK_PANEL"><md-icon class="s18" \nmd-font-icon="icon-format-list-bulleted" class="icon"></md-icon><md-icon md-font-icon="icon-alert-circle" \nclass="icon notify-icon" ng-if="vm.showNotificationIcon === true"></md-icon><span class="capitalize" \ntranslate="TOOLBAR.TOGGLE_QUICK_PANEL"></span></md-button></md-menu-item></md-menu-content></md-menu></div></div></div>');
$templateCache.put('app/core/directives/ms-navigation/templates/horizontal.html','<div class="navigation-toggle" hide-gt-sm><md-button class="md-icon-button" ng-click="vm.toggleHorizontalMobileMenu()" \naria-label="Toggle Mobile Navigation"><md-icon md-font-icon="icon-menu"></md-icon></md-button></div><ul \nclass="horizontal"><li ng-repeat="node in vm.navigation" ms-navigation-horizontal-node="node" \nng-class="{\'has-children\': vm.hasChildren}" ng-include="\'navigation-horizontal-nested.html\'"></li></ul><script \ntype="text/ng-template" id="navigation-horizontal-nested.html">\n<div ms-navigation-horizontal-item layout="row">\r\n\r\n        <div class="ms-navigation-horizontal-button" ng-if="!node.uisref && node.title && !node.hide"\r\n             ng-class="{\'active md-accent-bg\': vm.isActive}">\r\n            <i class="icon s18 {{node.icon}}" ng-if="node.icon"></i>\r\n            <span class="title" translate="{{node.translate}}" flex>{{node.title}}</span>\r\n            <span class="badge white-fg" style="background: {{node.badge.color}}" ng-if="node.badge">{{node.badge.content}}</span>\r\n            <i class="icon-chevron-right s18 arrow" ng-if="vm.hasChildren"></i>\r\n        </div>\r\n\r\n        <a class="ms-navigation-horizontal-button" ui-sref="{{node.uisref}}" ui-sref-active="active md-accent-bg"\r\n           ng-class="{\'active md-accent-bg\': vm.isActive}"\r\n           ng-if="node.uisref && node.title && !node.hide">\r\n            <i class="icon s18 {{node.icon}}" ng-if="node.icon"></i>\r\n            <span class="title" translate="{{node.translate}}" flex>{{node.title}}</span>\r\n            <span class="badge white-fg" style="background: {{node.badge.color}}" ng-if="node.badge">{{node.badge.content}}</span>\r\n            <i class="icon-chevron-right s18 arrow" ng-if="vm.hasChildren"></i>\r\n        </a>\r\n\r\n    </div>\r\n\r\n    <ul ng-if="vm.hasChildren && !node.hide">\r\n        <li ng-repeat="node in node.children" ms-navigation-horizontal-node="node"\r\n            ng-class="{\'has-children\': vm.hasChildren}"\r\n            ng-include="\'navigation-horizontal-nested.html\'"></li>\r\n    </ul>\n</script>');
$templateCache.put('app/core/directives/ms-navigation/templates/vertical.html','<ul><li ng-repeat="node in vm.filteredNavigation" ms-navigation-node="node" \nng-class="{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}" ng-include="\'navigation-nested.html\'"></li></ul>\n<script type="text/ng-template" id="navigation-nested.html">\n<div ms-navigation-item layout="row">\r\n\r\n        <div class="ms-navigation-button" ng-if="!node.uisref && node.title && !node.hide">\r\n            <i class="icon s16 {{node.icon}}" ng-if="node.icon"></i>\r\n            <span class="title" translate="{{node.translate}}" flex>{{node.title}}</span>\r\n            <span class="badge white-fg" ng-style="{\'background\': node.badge.color}" ng-if="node.badge">{{node.badge.content}}</span>\r\n            <i class="icon-chevron-right s16 arrow" ng-if="vm.collapsable && vm.hasChildren"></i>\r\n        </div>\r\n\r\n        <a class="ms-navigation-button" ui-sref="{{node.uisref}}" ui-sref-active="active md-accent-bg"\r\n           ng-if="node.uisref && node.title && !node.hide">\r\n            <i class="icon s16 {{node.icon}}" ng-if="node.icon"></i>\r\n            <span class="title" translate="{{node.translate}}" flex>{{node.title}}</span>\r\n            <span class="badge white-fg" ng-style="{\'background\': node.badge.color}" ng-if="node.badge">{{node.badge.content}}</span>\r\n            <i class="icon-chevron-right s16 arrow" ng-if="vm.collapsable && vm.hasChildren"></i>\r\n        </a>\r\n\r\n    </div>\r\n\r\n    <ul ng-if="vm.hasChildren && !node.hide">\r\n        <li ng-repeat="node in node.children" ms-navigation-node="node"\r\n            ng-class="{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}"\r\n            ng-include="\'navigation-nested.html\'"></li>\r\n    </ul>\n</script>');
$templateCache.put('app/directives/txDataTable/dialogs/chartsEditor/chartsEditor.html','<md-dialog class="chart-creator-dialog" aria-label="{{vm.isNew ? \'Create Chart\': \'Update Chart\'}}" \ntranslate-attr-aria-label="{{vm.isNew? \'TITLES.UPDATE_CHART\' : \'TITLES.CREATE_CHART\'}}"><form name="vm.editForm" \nclass="md-inline-form"><md-toolbar class="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" \nlayout-align="space-between center"><span class="title" \ntranslate="{{vm.isNew ? \'TITLES.CREATE_CHART\' : \'TITLES.UPDATE_CHART\'}}">{{vm.isNew ? \'Create Chart\': \'Update Chart\'}}\n</span><md-button class="md-icon-button" ng-click="vm.closeDialog()" aria-label="Close dialog" tranlate \ntranslate-aria-label="ACTIONS.DIALOG_CLOSE"><md-icon md-font-icon="icon-close"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div layout="row" layout-wrap><div class="p-5 lookup-element" flex="100" \nflex-gt-xs="50"><md-autocomplete id="dialog_input_first" md-input-name="DataRange1" \nmd-selected-item="vm.lookupModel.r1" \nmd-items="item in vm.lookupSearch(vm.searchText.r1, vm.dataRange1Fields, \'displayLabel\')" \nmd-search-text="vm.searchText.r1" md-item-text="vm.getLookupDisplayValue(item, vm.dataRange1Fields, \'field\')" \nmd-min-length="0" md-floating-label="{{\'FIELDS.DATA_RANGE1\' | translate}}" \nmd-selected-item-change="vm.lookupChange(vm.lookupModel.r1, \'r1\', \'field\')" ng-required="true" md-autofocus \nmd-no-cache="true" tx-clear-autocomplete tx-force-select ng-click="vm.selectText($event)" \nmd-menu-class="autocomplete-custom"><md-item-template><span class="autocomplete-item md-accent-fg" \nmd-highlight-text="vm.searchText.r1" md-highlight-flags="i">{{item.displayLabel}}</span></md-item-template><div \nng-messages="vm.editForm.DataRange1.$error" role="alert" ng-show="vm.editForm.DataRange1.$touched"><div \nng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div></div><md-not-found>\nNo Record matching "{{vm.searchText.r1}}" were found.</md-not-found></md-autocomplete></div><div \nclass="p-5 lookup-element" flex="100" flex-gt-xs="50"><md-autocomplete id="dialog_input_1" md-input-name="Type" \nmd-selected-item="vm.lookupModel.o" md-items="item in vm.lookupSearch(vm.searchText.o, vm.types, \'displayLabel\')" \nmd-search-text="vm.searchText.o" md-item-text="vm.getLookupDisplayValue(item, vm.types, \'id\')" md-min-length="0" \nmd-floating-label="{{\'FIELDS.OPERATOR\' | translate}}" \nmd-selected-item-change="vm.lookupChange(vm.lookupModel.o, \'o\', \'id\')" ng-required="true" md-autofocus \nmd-no-cache="true" tx-clear-autocomplete tx-force-select ng-click="vm.selectText($event)" \nmd-menu-class="autocomplete-custom"><md-item-template><span class="autocomplete-item md-accent-fg" \nmd-highlight-text="vm.searchText.o" md-highlight-flags="i">{{item.displayLabel}}</span></md-item-template><div \nng-messages="vm.editForm.Type.$error" role="alert" ng-show="vm.editForm.Type.$touched"><div ng-message="required">\n{{\'VALIDATIONS.REQUIRED\' | translate}}</div></div><md-not-found>No Record matching "{{vm.searchText.o}}" were found.\n</md-not-found></md-autocomplete></div><div class="p-5 lookup-element" flex="100" flex-gt-xs="50"><md-autocomplete \nid="dialog_input_2" md-input-name="DataRange2" md-selected-item="vm.lookupModel.r2" \nmd-items="item in vm.lookupSearch(vm.searchText.r2, vm.dataRange2Fields, \'displayLabel\')" \nmd-search-text="vm.searchText.r2" md-item-text="vm.getLookupDisplayValue(item, vm.dataRange2Fields, \'field\')" \nmd-min-length="0" md-floating-label="{{\'FIELDS.DATA_RANGE2\' | translate}}" \nmd-selected-item-change="vm.lookupChange(vm.lookupModel.r2, \'r2\', \'field\')" ng-required="vm.record.o === 2" \nng-disabled="vm.record.o !== 2" md-autofocus md-no-cache="true" tx-clear-autocomplete ng-click="vm.selectText($event)" \nmd-menu-class="autocomplete-custom"><md-item-template><span class="autocomplete-item md-accent-fg" \nmd-highlight-text="vm.searchText.r2" md-highlight-flags="i">{{item.displayLabel}}</span></md-item-template><div \nng-messages="vm.editForm.DataRange2.$error" role="alert" ng-show="vm.editForm.DataRange2.$touched"><div \nng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div></div><md-not-found>\nNo Record matching "{{vm.searchText.r2}}" were found.</md-not-found></md-autocomplete></div><div class="p-5" \nflex="100" flex-gt-xs="50"><md-switch id="dialog_input_3" ng-model="vm.record.m" \naria-label="{{\'FIELDS.INCLUDE_INACTIVE\' | translate}}" ng-true-value="\'1\'" ng-false-value="\'0\'">\n{{\'FIELDS.INCLUDE_INACTIVE\' | translate}}</md-switch></div><div class="p-5" flex="100" flex-gt-xs="50"><md-switch \nid="dialog_input_4" ng-model="vm.record.g" aria-label="{{\'FIELDS.CREATE_GLOBAL\' | translate}}" ng-true-value="\'1\'" \nng-false-value="\'0\'" ng-if="vm.isTrasix && vm.isCatalogModule">{{\'FIELDS.CREATE_GLOBAL\' | translate}}</md-switch></div>\n</div></md-dialog-content><md-dialog-actions layout="row" layout-align="end center"><div></div><div layout="row" \nlayout-align="end center"><md-button ng-click="vm.closeDialog()" class="send-button md-primary md-raised" \naria-label="Cancel" translate="ACTIONS.DIALOG_CANCEL" translate-attr-aria-label="ACTIONS.DIALOG_CANCEL">CANCEL\n</md-button><md-button ng-click="vm.saveRecord()" class="send-button md-accent md-raised" aria-label="Save" \ntranslate="ACTIONS.SAVE" translate-attr-aria-label="ACTIONS.SAVE" \nng-disabled="vm.editForm.$invalid || !vm.isFormValid()">SAVE</md-button><md-button ng-click="vm.saveRecord(true)" \nclass="send-button md-accent md-raised" aria-label="Save" translate="ACTIONS.SAVE_AND_NEW" \ntranslate-attr-aria-label="ACTIONS.SAVE_AND_NEW" ng-disabled="vm.editForm.$invalid || !vm.isFormValid()" \nng-show="vm.isNew">SAVE</md-button></div></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/directives/txDataTable/dialogs/column-chooser/column-chooser.html','<md-dialog class="tx-dialog column-chooser-dialog" aria-label="Column Chooser" \ntranslate-attr-aria-label="TITLES.COLUMN_CHOOSER"><form name="editForm" class="md-inline-form"><md-toolbar \nclass="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" layout-align="space-between center"><span \nclass="title" translate="TITLES.COLUMN_CHOOSER">Column chooser</span><md-button class="md-icon-button" \nng-click="vm.closeDialog()" aria-label="Close dialog" tranlate translate-aria-label="ACTIONS.DIALOG_CLOSE"><md-icon \nmd-font-icon="icon-close"></md-icon></md-button></div></md-toolbar><md-dialog-content><div class="widget-group" \nlayout="row" flex="100" layout-wrap><div layout="column" flex class="cols-list"><div><span \ntranslate="TITLES.AVAILABLE_COLS" class="h4">Available Columns</span><md-button class="md-icon-button s16" hide \nshow-gt-xs ng-click="vm.onACFilterClick()" aria-label="Show Filter"><md-icon md-font-icon="icon-filter" class="s16">\n</md-icon></md-button></div><md-input-container class="md-block m-0" hide show-gt-xs md-no-float \nng-show="vm.showACFilter"><input id="ACFilter" ng-model="vm.ACFilter.displayLabel" placeholder="Filter" \nng-change="vm.filterAvailableFields(vm.ACFilter.displayLabel)"></md-input-container><md-input-container hide show-xs \nclass="md-block m-0 filter-device-height" md-no-float><md-icon class="s16 md-default-theme md-font material-icons" \nng-click="vm.onACFilterClick()" md-font-icon="icon-filter" role="img" aria-label="icon-filter"></md-icon><input \nid="ACFilter" ng-show="vm.showACFilter" ng-model="vm.ACFilter.displayLabel" placeholder="Filter" \nng-change="vm.filterAvailableFields(vm.ACFilter.displayLabel)"></md-input-container><div id="availableColumns" \ndragula="\'bag-column-choose\'" dragula-model="vm.filteredAvailableFields" class="cols-container"><div \nng-repeat="col in vm.filteredAvailableFields track by $index"><div \nclass="col-chooser-item dragged-element-selector-tag text-overflow-wrap" ng-dblclick="vm.addItem(col)">\n{{col.displayLabel | ampersand }}</div></div></div></div><div layout="column" flex class="cols-list"><div><span \ntranslate="TITLES.SELECTED_COLS" class="h4">Selected Columns</span><md-button class="md-icon-button s16" hide \nshow-gt-xs ng-click="vm.onSCFilterClick()" aria-label="Show Filter"><md-icon md-font-icon="icon-filter" class="s16">\n</md-icon></md-button></div><md-input-container class="md-block m-0" hide show-gt-xs md-no-float \nng-show="vm.showSCFilter"><input id="SCFilter" ng-model="vm.SCFilter.displayLabel" placeholder="Filter" \nng-change="vm.filterSelectedFields(vm.SCFilter.displayLabel)"></md-input-container><md-input-container hide show-xs \nclass="md-block m-0 filter-device-height" md-no-float><md-icon class="s16 md-default-theme md-font material-icons" \nng-click="vm.onSCFilterClick()" md-font-icon="icon-filter" role="img" aria-label="icon-filter"></md-icon><input \nid="ACFilter" ng-show="vm.showSCFilter" ng-model="vm.ACFilter.displayLabel" placeholder="Filter" \nng-change="vm.filterAvailableFields(vm.ACFilter.displayLabel)"></md-input-container><div id="selectedColumns" \ndragula="\'bag-column-choose\'" dragula-model="vm.filteredSelectedFields" class="cols-container"><div \nng-repeat="col in vm.filteredSelectedFields track by $index"><div \nclass="col-chooser-item dragged-element-selector-tag text-overflow-wrap" ng-dblclick="vm.remItem(col)">\n{{col.displayLabel | ampersand }}</div></div></div></div></div></md-dialog-content><md-dialog-actions layout="row" \nlayout-align="space-between center"><div><md-button ng-click="vm.modifyColumns()" class="send-button md-raised" \naria-label="Modify Columns" ng-if="vm.isModifycolumnsActionRequired" \ntranslate="{{vm.isAvailableFieldsEmpty===true ? \'ACTIONS.DIALOG_DEFAULT\' : \'ACTIONS.DIALOG_ADD_ALL\'}}" \ntranslate-attr-aria-label="{{vm.isAvailableFieldsEmpty===true ? \'ACTIONS.DIALOG_DEFAULT\' : \'ACTIONS.DIALOG_ADD_ALL\'}}">\n</md-button></div><div layout="row" layout-align="end center"><md-button ng-click="vm.closeDialog()" \nclass="send-button md-primary md-raised" aria-label="Cancel" translate="ACTIONS.DIALOG_CANCEL" \ntranslate-attr-aria-label="ACTIONS.DIALOG_CANCEL">CANCEL</md-button><md-button ng-click="vm.applyChanges()" \nclass="send-button md-accent md-raised" aria-label="Save" translate="ACTIONS.SAVE" \nng-disabled="!vm.isIndexedAvailableFieldsCreated || vm.processing" translate-attr-aria-label="ACTIONS.SAVE">SAVE\n</md-button></div></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/directives/txDataTable/dialogs/column-saver/column-saver.html','<md-dialog class="tx-dialog column-saver-dialog" aria-label="Column Saver" \ntranslate-attr-aria-label="TITLES.COLUMN_SAVER"><form name="editForm" class="md-inline-form"><md-toolbar \nclass="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" layout-align="space-between center"><span \nclass="title" translate="TITLES.COLUMN_SAVER">Filters</span><md-button class="md-icon-button" \nng-click="vm.closeDialog()" aria-label="Close dialog" tranlate translate-aria-label="ACTIONS.DIALOG_CLOSE"><md-icon \nmd-font-icon="icon-close"></md-icon></md-button></div></md-toolbar><md-dialog-content><div class="widget-group" \nlayout="column" flex="100" layout-wrap><md-input-container class="md-block m-20"><input ng-model="vm.name" \nname="columnName" placeholder="Name" tx-unique-value="vm.columnObjArray:name:true" ng-required="true"><div \nng-messages="editForm.columnName.$error" role="alert" multiple="multiple"><div ng-message="required">\n{{\'VALIDATIONS.REQUIRED\' | translate}}</div><div ng-message="tx-unique-value">{{\'VALIDATIONS.DUPLICATE\' | translate}}\n</div></div></md-input-container><md-checkbox ng-model="vm.columnForCatalog" aria-label="Save as Catalog" \nng-if="vm.isCatalogModule && vm.isTrasix" class="columnsCheck">Save as Catalog Wide Columns</md-checkbox><md-divider>\n</md-divider><md-list><md-subheader class="md-no-sticky">My Columns</md-subheader><md-list-item \nclass="secondary-button-padding" ng-repeat="column in vm.myColumns[vm.modelPath]"><p>{{ column.name }}</p><md-button \nclass="md-secondary" ng-click="vm.doDeleteMyColumn($index)"><md-icon md-font-icon="icon-delete"></md-icon></md-button>\n</md-list-item><md-list-item class="secondary-button-padding" ng-show="vm.myColumns[vm.modelPath].length == 0"><p>\n<small>None</small></p></md-list-item><md-subheader class="md-no-sticky" ng-if="vm.isCatalogModule">Catalog Columns\n</md-subheader><md-list-item class="secondary-button-padding" \nng-repeat="column in vm.catalogImportMapping.columns[vm.modelPath]" ng-if="vm.isCatalogModule"><p>{{ column.name }}</p>\n<md-button class="md-secondary" ng-click="vm.doDeleteCatalogColumn($index)"><md-icon md-font-icon="icon-delete">\n</md-icon></md-button></md-list-item><md-list-item class="secondary-button-padding" \nng-show="vm.catalogImportMapping.columns[vm.modelPath].length == 0" ng-if="vm.isCatalogModule"><p><small>None</small>\n</p></md-list-item></md-list></div></md-dialog-content><md-dialog-actions layout="row" \nlayout-align="space-between center"><div></div><div layout="row" layout-align="end center"><md-button \nng-click="vm.closeDialog()" class="send-button md-primary md-raised" aria-label="Cancel" \ntranslate="ACTIONS.DIALOG_CANCEL" translate-attr-aria-label="ACTIONS.DIALOG_CANCEL">CANCEL</md-button><md-button \nng-click="vm.doSave()" class="send-button md-accent md-raised" aria-label="Save" translate="ACTIONS.SAVE" \nng-disabled="editForm.$invalid" translate-attr-aria-label="ACTIONS.SAVE">SAVE</md-button></div></md-dialog-actions>\n</form></md-dialog>');
$templateCache.put('app/directives/txDataTable/dialogs/filter-by-date-editor/filter-by-date-editor.html','<md-dialog id="filter-by-date" aria-label="Filter Records by Date" translate-attr-aria-label="TITLES.FILTER_BY_DATE">\n<form name="editForm" class="md-inline-form"><md-toolbar class="md-accent md-hue-2"><div class="md-toolbar-tools" \nlayout="row" layout-align="space-between center"><span class="title" translate="TITLES.FILTER_BY_DATE">\nFilter Records by Date</span><md-button class="md-icon-button" ng-click="vm.closeDialog()" aria-label="Close dialog" \ntranlate translate-aria-label="ACTIONS.DIALOG_CLOSE"><md-icon md-font-icon="icon-close"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div class="widget-group" layout="row" flex="100" layout-wrap><div \nlayout="column" flex="100" flex-gt-xs="50" class="p-5"><label class="md-caption">{{\'FIELDS.START_DATE\' | translate}}\n</label><md-datepicker name="startDate" ng-model="vm.record.startDate" ng-required="true" md-autofocus \nmd-max-date="vm.today" md-date-filter="vm.startDateFilter"></md-datepicker><div \nng-messages="editForm.startDate.$error" role="alert" multiple="multiple" ng-show="editForm.startDate.$touched"><div \nng-message="required" class="error-message" \nng-class="{\'display-error\': (editForm.startDate.$error.required == true && editForm.startDate.$touched),\r\n                                   \'remove-error\': !editForm.startDate.$error.required}">\n{{\'VALIDATIONS.REQUIRED\' | translate}}</div></div></div><div layout="column" flex="100" flex-gt-xs="50" class="p-5">\n<label class="md-caption">{{\'FIELDS.END_DATE\' | translate}}</label><md-datepicker name="endDate" \nng-model="vm.record.endDate" md-max-date="vm.today" md-date-filter="vm.endDateFilter"></md-datepicker></div></div>\n</md-dialog-content><md-dialog-actions layout="row" layout-align="space-between center"><div></div><div layout="row" \nlayout-align="end center"><md-button ng-click="vm.closeDialog()" class="send-button md-primary md-raised" \naria-label="Cancel" translate="ACTIONS.DIALOG_CANCEL" translate-attr-aria-label="ACTIONS.DIALOG_CANCEL">CANCEL\n</md-button><md-button ng-click="vm.filterData(vm.record)" class="send-button md-accent md-raised" aria-label="Save" \ntranslate="ACTIONS.SAVE" ng-disabled="editForm.$invalid" translate-attr-aria-label="ACTIONS.SAVE">SAVE</md-button>\n</div></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/directives/txDataTable/dialogs/filterSaver/filterSaver.html','<md-dialog class="tx-dialog file-saver-dialog" aria-label="Column Chooser" \ntranslate-attr-aria-label="TITLES.FILTER_SAVER"><form name="editForm" class="md-inline-form"><md-toolbar \nclass="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" layout-align="space-between center"><span \nclass="title" translate="TITLES.FILTER_SAVER">Filters</span><md-button class="md-icon-button" \nng-click="vm.closeDialog()" aria-label="Close dialog" tranlate translate-aria-label="ACTIONS.DIALOG_CLOSE"><md-icon \nmd-font-icon="icon-close"></md-icon></md-button></div></md-toolbar><md-dialog-content><div class="widget-group" \nlayout="column" flex="100" layout-wrap><md-input-container class="md-block m-20"><input ng-model="vm.filterName" \nname="filterName" placeholder="Filter Name" tx-unique-value="vm.filterObjectArray:name:true" ng-required="true"><div \nng-messages="editForm.filterName.$error" role="alert" multiple="multiple"><div ng-message="required">\n{{\'VALIDATIONS.REQUIRED\' | translate}}</div><div ng-message="tx-unique-value">{{\'VALIDATIONS.DUPLICATE\' | translate}}\n</div></div></md-input-container><md-checkbox ng-model="vm.filterForCatalog" aria-label="Save as Catalog Filter" \nng-if="vm.isCatalogModule && vm.isTrasix" class="filterCheck">Save as Catalog Wide Filter</md-checkbox><md-divider>\n</md-divider><md-list><md-subheader class="md-no-sticky">My Filters</md-subheader><md-list-item \nclass="secondary-button-padding" ng-repeat="f in vm.myFilters[vm.moduleName]"><p>{{ f.name }}</p><md-button \nclass="md-secondary" ng-click="vm.doDeleteMyFilter($index)"><md-icon md-font-icon="icon-delete"></md-icon></md-button>\n</md-list-item><md-list-item class="secondary-button-padding" ng-show="vm.myFilters[vm.moduleName].length == 0"><p>\n<small>None</small></p></md-list-item><md-subheader class="md-no-sticky" ng-if="vm.isCatalogModule">Catalog Filters\n</md-subheader><md-list-item class="secondary-button-padding" \nng-repeat="f in vm.catalogFilters.filters[vm.moduleName]" ng-if="vm.isCatalogModule"><p>{{ f.name }}</p><md-button \nclass="md-secondary" ng-click="vm.doDeleteCatalogFilter($index)"><md-icon md-font-icon="icon-delete"></md-icon>\n</md-button></md-list-item><md-list-item class="secondary-button-padding" \nng-show="vm.catalogFilters.filters[vm.moduleName].length == 0" ng-if="vm.isCatalogModule"><p><small>None</small></p>\n</md-list-item></md-list></div></md-dialog-content><md-dialog-actions layout="row" layout-align="space-between center">\n<div></div><div layout="row" layout-align="end center"><md-button ng-click="vm.closeDialog()" \nclass="send-button md-primary md-raised" aria-label="Cancel" translate="ACTIONS.DIALOG_CANCEL" \ntranslate-attr-aria-label="ACTIONS.DIALOG_CANCEL">CANCEL</md-button><md-button ng-click="vm.doSave()" \nclass="send-button md-accent md-raised" aria-label="Save" translate="ACTIONS.SAVE" ng-disabled="editForm.$invalid" \ntranslate-attr-aria-label="ACTIONS.SAVE">SAVE</md-button></div></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/directives/txDataTable/dialogs/record-details/record-details.html','<md-dialog aria-label="label" class="tx-dialog"><md-toolbar class="md-accent md-hue-2"><div class="md-toolbar-tools" \nlayout="row" layout-align="space-between center"><span class="title" ng-if="vm.model.detailsDialogTitle">\n{{vm.model.detailsDialogTitle | translate}}</span> <span class="title" \nng-if="!vm.model.detailsDialogTitle && !vm.data[vm.model.lookupDisplayField]">{{\'PARTS.RECORD_DETAIL\' | translate}}\n</span> <span class="title" ng-if="!vm.model.detailsDialogTitle && vm.data[vm.model.lookupDisplayField]">\n{{vm.data[vm.model.lookupDisplayField]}}</span><md-button class="md-icon-button" ng-click="vm.closeDialog()" \naria-label="Close dialog" tranlate translate-aria-label="ACTIONS.DIALOG_CLOSE"><md-icon md-font-icon="icon-close">\n</md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div class="p-24" layout="row" \nlayout-align="start start" layout-wrap><div flex-gt-xs="50" flex="100" class="info-line mb-20" \nng-repeat="field in vm.model.fields | filter: {visible: true} track by $index" layout="row" layout-wrap>\n<tx-field-viewer tx-fields="::vm.model.fields" tx-field="::field" tx-data="vm.data" tx-lookup-data="vm.lookupData" \ntx-status-field="{{::vm.statusField}}"></tx-field-viewer></div></div></md-dialog-content></md-dialog>');
$templateCache.put('app/main/accounts/admin-users/list/admin-users-list.html','<div id="admin-users-list" class="page-layout carded fullwidth list-view" layout="row"><div class="center" \nlayout="column" flex><div class="content-card" layout="column" flex><tx-data-table tx-data="vm.adminUsers" \ntx-model="vm.model" tx-view="mainList" tx-filtered-data="vm.filteredAdminUsers" tx-data-filter="global.search" \ntx-is-loading="vm.isLoading" tx-item-action-event="vm.doItemAction(action, item)" \ntx-list-action-event="vm.doListAction(action, selectedItems)" tx-item-click-event="vm.viewItem(item)" \ntx-refresh-action-event="vm.refreshItems(true, false)"></tx-data-table></div></div></div>');
$templateCache.put('app/main/accounts/auth-users/details/auth-users-details.html','<div id="user-details" class="page-layout simple tabbed details-view" layout="column"><div class="content"><md-tabs \nmd-dynamic-height md-selected="vm.tabIndex" md-no-ink><md-tab label="{{\'AUTH_USERS.TABS.USER\' | translate}}" \ntx-access="{{::vm.model.views.privileges.details}}"><tx-data-details tx-height-offset="37" \ntx-is-active="vm.tabIndex === 0" tx-account="vm.user" tx-parent-id="vm.user.AccountId" tx-title="vm.title" \ntx-model="vm.model" tx-item-actions="vm.model.views.mainDetails.itemActions" \ntx-item-action-event="vm.doItemAction(action, account)" tx-is-loading="vm.isLoading" \ntx-refresh-action-event="vm.refreshRecord(false)"></tx-data-details></md-tab><md-tab \nlabel="{{\'AUTH_USERS.TABS.AUTH_ENVIRONMENTS\' | translate}}" ng-disabled="!vm.user.status" \ntx-access="{{::vm.environmentsModel.views.privileges.list}}"><div class="list-tab" layout="row" flex="100" layout-wrap>\n<ms-widget layout="row" flex="100"><ms-widget-front class="white-bg"><tx-data-table tx-is-active="vm.tabIndex === 1" \ntx-data="vm.authEnvironments" tx-model="vm.environmentsModel" tx-view="mainList" \ntx-filtered-data="vm.filteredAuthEnvironments" tx-data-filter="global.search" \ntx-is-loading="vm.isAuthEnvironmentsLoading" tx-item-action-event="vm.doEnvironmentsItemAction(action, item)" \ntx-refresh-action-event="vm.refreshEnvironments(true, false)" tx-height-offset="16"></tx-data-table></ms-widget-front>\n</ms-widget><md-button class="add-rec-button md-fab md-warn" ng-click="vm.addEnvironment($event)" \naria-label="vm.environmentsModel.views.mainList.fabAction.label" translate \ntx-access="{{::vm.environmentsModel.views.mainList.fabAction.privilege}}"><md-icon \nmd-font-icon="{{vm.environmentsModel.views.mainList.fabAction.icon}}"></md-icon></md-button></div></md-tab></md-tabs>\n</div></div>');
$templateCache.put('app/main/accounts/auth-users/list/auth-users-list.html','<div id="auth-users-list" class="page-layout carded fullwidth list-view" layout="row"><div class="center" \nlayout="column" flex><div class="content-card" layout="column" flex><tx-data-table tx-data="vm.authUsers" \ntx-model="vm.model" tx-view="mainList" tx-filtered-data="vm.filteredUsers" tx-data-filter="global.search" \ntx-is-loading="vm.isLoading" tx-item-action-event="vm.doItemAction(action, item)" \ntx-list-action-event="vm.doListAction(action, selectedItems)" tx-item-click-event="vm.viewItem(item)" \ntx-refresh-action-event="vm.refreshItems(true, false)"></tx-data-table><md-button \nclass="add-rec-button md-fab md-warn" ng-click="vm.addRecord($event)" \naria-label="vm.model.views.mainList.fabAction.label" translate \ntx-access="{{::vm.model.views.mainList.fabAction.privilege}}"><md-icon \nmd-font-icon="{{vm.model.views.mainList.fabAction.icon}}"></md-icon></md-button></div></div></div>');
$templateCache.put('app/main/accounts/buyers/details/buyers-details.html','<div id="buyers-details" class="page-layout simple tabbed details-view" layout="column"><div class="content"><md-tabs \nmd-dynamic-height md-selected="vm.tabIndex" md-no-ink><md-tab label="{{\'BUYERS.TABS.BUYER\' | translate}}" \ntx-access="{{::vm.model.views.privileges.details}}"><tx-data-details tx-height-offset="37" \ntx-is-active="vm.tabIndex === 0" tx-account="vm.buyer" tx-title="vm.title" tx-model="vm.model" \ntx-item-actions="vm.model.views.mainDetails.itemActions" tx-item-action-event="vm.doBuyerItemAction(action, account)" \ntx-is-loading="vm.isLoading" tx-refresh-action-event="vm.refreshRecord(false)"></tx-data-details></md-tab><md-tab \nlabel="{{\'BUYERS.TABS.USERS\' | translate}}" ng-disabled="!vm.buyer.Status" \ntx-access="{{::vm.usersModel.views.privileges.list}}"><div class="list-tab" layout="row" flex="100" layout-wrap>\n<ms-widget layout="row" flex="100"><ms-widget-front class="white-bg"><tx-data-table tx-is-active="vm.tabIndex === 1" \ntx-data="vm.buyerUsers" tx-model="vm.usersModel" tx-view="mainList" tx-filtered-data="vm.filteredBuyerUsers" \ntx-data-filter="global.search" tx-is-loading="vm.isUsersLoading" \ntx-item-action-event="vm.doUsersItemAction(action, item)" \ntx-list-action-event="vm.doUsersListAction(action, selectedItems)" tx-item-click-event="vm.viewUser(item)" \ntx-refresh-action-event="vm.refreshUsers(true, false)" tx-height-offset="16"></tx-data-table></ms-widget-front>\n</ms-widget></div></md-tab><md-tab label="{{\'BUYERS.TABS.CATALOGS\' | translate}}" ng-disabled="!vm.buyer.Status" \ntx-access="{{::vm.catalogsModel.views.privileges.list}}"><div class="list-tab"><ms-widget layout="row" flex="100">\n<ms-widget-front class="white-bg"><tx-data-table tx-is-active="vm.tabIndex === 2" tx-data="vm.buyerCatalogs" \ntx-model="vm.catalogsModel" tx-view="mainList" tx-filtered-data="vm.filteredBuyerCatalogs" \ntx-data-filter="global.search" tx-is-loading="vm.isCatalogsLoading" \ntx-item-action-event="vm.doCatalogItemAction(action, item)" tx-item-click-event="vm.viewCatalog(item)" \ntx-refresh-action-event="vm.refreshCatalogs(true, false)" tx-height-offset="15"></tx-data-table></ms-widget-front>\n</ms-widget></div></md-tab><md-tab label="{{\'BUYERS.TABS.CUSTOMERS\' | translate}}" ng-disabled="!vm.buyer.Status" \ntx-access="{{::vm.customersModel.views.privileges.list}}"><div class="list-tab" layout="row" flex="100" layout-wrap>\n<ms-widget layout="row" flex="100"><ms-widget-front class="white-bg"><tx-data-table tx-is-active="vm.tabIndex === 3" \ntx-data="vm.buyerCustomers" tx-model="vm.customersModel" tx-view="mainList" \ntx-filtered-data="vm.filteredBuyerCustomers" tx-data-filter="global.search" tx-is-loading="vm.isCustomersLoading" \ntx-refresh-action-event="vm.refreshCustomers(true, false)" tx-height-offset="16"></tx-data-table></ms-widget-front>\n</ms-widget></div></md-tab></md-tabs></div></div>');
$templateCache.put('app/main/accounts/buyers/dialogs/merge-buyers.html','<md-dialog class="edit-dialog" aria-label="Merge Buyers"><form name="vm.editForm" class="md-inline-form"><md-toolbar \nclass="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" layout-align="space-between center"><span \nclass="title" translate="{{\'ACTIONS.MERGE_BUYER\'}}">{{\'Merge Buyer\'}}</span><md-button class="md-icon-button" \nng-click="vm.closeDialog(vm.isDataDirty)" aria-label="Close dialog" tranlate \ntranslate-aria-label="ACTIONS.DIALOG_CLOSE"><md-icon md-font-icon="icon-close"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div layout="row" layout-wrap><div flex="100" class="p-5"><md-input-container\n class="md-block"><label>{{\'BUYERS.FIELDS.FROM_BUYER_ACCOUNT_NAME\' | translate}}</label><input id="dialog_input_first" \nname="AccountName" ng-model="vm.record.AccountName" type="text" ng-disabled="true"></md-input-container></div><div \nflex="100" flex-gt-xs="50" class="p-5"><md-input-container class="md-block"><label>\n{{\'BUYERS.FIELDS.FROM_BUYER_ACCOUNT_ID\' | translate}}</label><input id="dialog_input_first" name="AccountId" \nng-model="vm.record.AccountId" type="text" ng-disabled="true"></md-input-container></div><div flex="100" \nflex-gt-xs="50" class="p-5"><md-input-container class="md-block"><label>\n{{\'BUYERS.FIELDS.FROM_BUYER_ACCOUNT_EMAIL\' | translate}}</label><input id="dialog_input_first" name="Email" \nng-model="vm.record.Email" type="text" ng-disabled="true"></md-input-container></div><div flex="100" \nclass="p-5 lookup-element"><md-autocomplete id="dialog_input_first" tx-force-select md-input-name="accountId" \nmd-selected-item="vm.lookupModel[0].accountId" md-items="item in vm.searchBuyer(vm.searchText[0].accountId)" \nmd-search-text="vm.searchText[0].accountId" md-item-text="vm.getBuyerDisplayValue(item)" md-min-length="0" \nmd-floating-label="{{\'BUYERS.FIELDS.MERGE_TO_BUYER_ACCOUNT_NAME\' | translate}}" \nmd-selected-item-change="vm.onBuyerChange(vm.lookupModel[0].accountId)" ng-required="true" md-autofocus="true" \nmd-no-cache="true" tx-clear-autocomplete ng-click="vm.selectText($event)" md-menu-class="autocomplete-custom">\n<md-item-template><span class="autocomplete-item md-accent-fg" md-highlight-text="vm.searchText[0].accountId" \nmd-highlight-flags="i">{{item.AccountName}}</span></md-item-template><div ng-messages="vm.editForm.accountId.$error" \nrole="alert" ng-show="vm.editForm.accountId.$touched"><div ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}\n</div></div><md-not-found>No Record matching "{{vm.searchText.accountId}}" were found.</md-not-found></md-autocomplete>\n</div><div flex="100" flex-gt-xs="50" class="p-5" ng-if="vm.mergeIntoBuyer.AccountId"><md-input-container \nclass="md-block"><label>{{\'BUYERS.FIELDS.MERGE_TO_BUYER_ACCOUNT_ID\' | translate}}</label><input \nid="dialog_input_first" name="AccountId" ng-model="vm.mergeIntoBuyer.AccountId" type="text" ng-disabled="true" \nplaceholder="{{\'BUYERS.FIELDS.ID\' | translate}}"></md-input-container></div><div flex="100" flex-gt-xs="50" \nclass="p-5" ng-if="vm.mergeIntoBuyer.Email"><md-input-container class="md-block"><label>\n{{\'BUYERS.FIELDS.MERGE_TO_BUYER_ACCOUNT_EMAIL\' | translate}}</label><input id="dialog_input_first" name="Email" \nng-model="vm.mergeIntoBuyer.Email" type="text" ng-disabled="true" placeholder="{{\'BUYERS.FIELDS.EMAIL\' | translate}}">\n</md-input-container></div></div></md-dialog-content><md-dialog-actions layout="row" layout-align="end center"><div>\n</div><div layout="row" layout-align="end center"><md-button ng-click="vm.closeDialog(vm.isDataDirty)" \nclass="send-button md-primary md-raised" aria-label="Cancel" translate="ACTIONS.DIALOG_CANCEL" \ntranslate-attr-aria-label="ACTIONS.DIALOG_CANCEL" ng-disabled="vm.isLoading">CANCEL</md-button><md-button \nng-click="vm.saveRecord()" class="send-button md-accent md-raised" aria-label="Merge Account" \ntranslate="ACTIONS.MERGE_ACCOUNT" translate-attr-aria-label="ACTIONS.MERGE_ACCOUNT" \nng-disabled="vm.isLoading || vm.editForm.$invalid">MERGE ACCOUNT</md-button></div></md-dialog-actions></form>\n</md-dialog>');
$templateCache.put('app/main/accounts/buyers/list/buyers-list.html','<div id="buyers-list" class="page-layout carded fullwidth list-view" layout="row"><div class="center" layout="column" \nflex><div class="content-card" layout="column" flex><tx-data-table tx-data="vm.buyers" tx-model="vm.model" \ntx-view="mainList" tx-filtered-data="vm.filteredBuyers" tx-data-filter="global.search" tx-is-loading="vm.isLoading" \ntx-item-action-event="vm.doItemAction(action, item)" tx-list-action-event="vm.doListAction(action, selectedItems)" \ntx-item-click-event="vm.viewItem(item)" tx-refresh-action-event="vm.refreshItems(true, false)"></tx-data-table>\n<md-button class="add-rec-button md-fab md-warn" ng-click="vm.addRecord($event)" \naria-label="vm.model.views.mainList.fabAction.label" translate \ntx-access="{{::vm.model.views.mainList.fabAction.privilege}}"><md-icon \nmd-font-icon="{{vm.model.views.mainList.fabAction.icon}}"></md-icon></md-button></div></div></div>');
$templateCache.put('app/main/accounts/interface-users/list/interface-users-list.html','<div id="auth-users-list" class="page-layout carded fullwidth list-view" layout="row"><div class="center" \nlayout="column" flex><div class="content-card" layout="column" flex><tx-data-table tx-data="vm.interfaceUsers" \ntx-model="vm.model" tx-view="mainList" tx-filtered-data="vm.filteredUsers" tx-data-filter="global.search" \ntx-is-loading="vm.isLoading" tx-item-action-event="vm.doItemAction(action, item)" \ntx-list-action-event="vm.doListAction(action, selectedItems)" tx-refresh-action-event="vm.refreshItems(true, false)">\n</tx-data-table><md-button class="add-rec-button md-fab md-warn" ng-click="vm.addRecord($event)" \naria-label="vm.model.views.mainList.fabAction.label" translate \ntx-access="{{::vm.model.views.mainList.fabAction.privilege}}"><md-icon \nmd-font-icon="{{vm.model.views.mainList.fabAction.icon}}"></md-icon></md-button></div></div></div>');
$templateCache.put('app/main/accounts/sellers/details/sellers-details.html','<div id="sellers-details" class="page-layout simple tabbed details-view" layout="column"><div class="content"><md-tabs \nmd-dynamic-height md-no-ink md-selected="vm.selectedTabPosition"><md-tab md-on-select="vm.onActiveTabChange(0)" \nlabel="{{\'SELLERS.TABS.SELLER\' | translate}}" tx-access="{{::vm.model.views.privileges.details}}"><tx-data-details \ntx-height-offset="37" tx-is-active="vm.tabIndex === 0" tx-account="vm.seller" tx-title="vm.title" tx-model="vm.model" \ntx-item-actions="vm.model.views.mainDetails.itemActions" tx-item-action-event="vm.doSellerItemAction(action, account)" \ntx-edit-record-event="vm.editSeller(event, record)" tx-is-loading="vm.isLoading" \ntx-refresh-action-event="vm.refreshRecord(true)"></tx-data-details></md-tab><md-tab \nlabel="{{\'SELLERS.TABS.CONFIGURATIONS\' | translate}}" ng-disabled="!vm.seller.Status" \nmd-on-select="vm.onActiveTabChange(1)" tx-access="{{vm.sellerConfigurationsModel.views.privileges.list}}"><div \nclass="list-tab" layout="row" flex="100" layout-wrap><ms-widget layout="row" flex="100"><ms-widget-front \nclass="white-bg"><tx-data-table tx-is-active="vm.tabIndex === 1" tx-data="vm.sellerConfigurations" \ntx-model="vm.sellerConfigurationsModel" tx-view="mainList" tx-filtered-data="vm.filteredSellerConfigurations" \ntx-data-filter="global.search" tx-is-loading="vm.isSellerConfigurationLoading" \ntx-item-action-event="vm.doSellerConfigurationsItemAction(action, item)" \ntx-list-action-event="vm.doSellerConfigurationsListAction(action, selectedItems)" \ntx-refresh-action-event="vm.refreshSellerConfigurations(true, false)" tx-height-offset="16"></tx-data-table>\n</ms-widget-front></ms-widget><md-button class="add-rec-button md-fab md-warn" \nng-click="vm.addSellerConfiguration($event)" aria-label="vm.sellerConfigurationsModel.views.mainList.fabAction.label" \ntranslate tx-access="{{vm.sellerConfigurationsModel.views.mainList.fabAction.privilege}}"><md-icon \nmd-font-icon="{{vm.sellerConfigurationsModel.views.mainList.fabAction.icon}}"></md-icon></md-button></div></md-tab>\n<md-tab md-on-select="vm.onActiveTabChange(2)" label="{{\'SELLERS.TABS.USERS\' | translate}}" \nng-disabled="!vm.seller.Status" tx-access="{{::vm.usersModel.views.privileges.list}}"><div class="list-tab" \nlayout="row" flex="100" layout-wrap><ms-widget layout="row" flex="100"><ms-widget-front class="white-bg"><tx-data-table\n tx-is-active="vm.tabIndex === 2" tx-data="vm.sellerUsers" tx-model="vm.usersModel" tx-view="mainList" \ntx-filtered-data="vm.filteredSellerUsers" tx-data-filter="global.search" tx-is-loading="vm.isUsersLoading" \ntx-item-action-event="vm.doUsersItemAction(action, item)" \ntx-list-action-event="vm.doUsersListAction(action, selectedItems)" tx-item-click-event="vm.viewUser(item)" \ntx-refresh-action-event="vm.refreshUsers(true, false)" tx-height-offset="16"></tx-data-table></ms-widget-front>\n</ms-widget></div></md-tab><md-tab md-on-select="vm.onActiveTabChange(3)" \nlabel="{{\'SELLERS.TABS.CATALOGS\' | translate}}" ng-disabled="!vm.seller.Status" \ntx-access="{{::vm.catalogsModel.views.privileges.list}}"><div class="list-tab"><ms-widget layout="row" flex="100">\n<ms-widget-front class="white-bg"><tx-data-table tx-is-active="vm.tabIndex === 3" tx-data="vm.sellerCatalogs" \ntx-model="vm.catalogsModel" tx-view="mainList" tx-filtered-data="vm.filteredSellerCatalogs" \ntx-data-filter="global.search" tx-is-loading="vm.isCatalogsLoading" \ntx-item-action-event="vm.doCatalogItemAction(action, item)" tx-item-click-event="vm.viewCatalog(item)" \ntx-refresh-action-event="vm.refreshCatalogs(true, false)" tx-height-offset="15"></tx-data-table></ms-widget-front>\n</ms-widget></div></md-tab><md-tab md-on-select="vm.onActiveTabChange(4)" \nlabel="{{\'SELLERS.TABS.CUSTOMERS\' | translate}}" ng-disabled="!vm.seller.Status" \ntx-access="{{::vm.customersModel.views.privileges.list}}"><div class="list-tab" layout="row" flex="100" layout-wrap>\n<ms-widget layout="row" flex="100"><ms-widget-front class="white-bg"><tx-data-table tx-is-active="vm.tabIndex === 4" \ntx-data="vm.sellerCustomers" tx-model="vm.customersModel" tx-view="mainList" \ntx-filtered-data="vm.filteredSellerCustomers" tx-data-filter="global.search" tx-is-loading="vm.isCustomersLoading" \ntx-item-action-event="vm.doCustomersItemAction(action, item)" \ntx-list-action-event="vm.doCustomersListAction(action, selectedItems)" tx-item-click-event="vm.viewCustomer(item)" \ntx-refresh-action-event="vm.refreshCustomers(true, false)" tx-height-offset="16" tx-control="vm.tableControl">\n</tx-data-table></ms-widget-front></ms-widget><md-button class="add-rec-button md-fab md-warn" \nng-click="vm.addCustomer($event)" aria-label="vm.customersModel.views.mainList.fabAction.label" translate \ntx-access="{{::vm.customersModel.views.mainList.fabAction.privilege}}"><md-icon \nmd-font-icon="{{vm.customersModel.views.mainList.fabAction.icon}}"></md-icon></md-button></div></md-tab><md-tab \nmd-on-select="vm.onActiveTabChange(5)" label="{{\'SELLERS.TABS.RESOURCE_TYPE\' | translate}}" \nng-disabled="!vm.seller.Status" tx-access="{{::vm.resourceTypesModel.views.privileges.list}}"><div class="list-tab" \nlayout="row" flex="100" layout-wrap><ms-widget layout="row" flex="100"><ms-widget-front class="white-bg"><tx-data-table\n tx-is-active="vm.tabIndex === 5" tx-data="vm.resourceTypes" tx-model="vm.resourceTypesModel" tx-view="mainList" \ntx-filtered-data="vm.filteredResourceTypes" tx-data-filter="global.search" tx-is-loading="vm.isResourceTypesLoading" \ntx-item-action-event="vm.doResourceTypeItemAction(action, item)" \ntx-refresh-action-event="vm.refreshResourceTypes(true, false)" tx-height-offset="16"></tx-data-table></ms-widget-front>\n</ms-widget><md-button class="add-rec-button md-fab md-warn" ng-click="vm.addResourceType($event)" \naria-label="vm.resourceTypesModel.views.mainList.fabAction.label" translate \ntx-access="{{::vm.resourceTypesModel.views.mainList.fabAction.privilege}}"><md-icon \nmd-font-icon="{{vm.resourceTypesModel.views.mainList.fabAction.icon}}"></md-icon></md-button></div></md-tab><md-tab \nmd-on-select="vm.onActiveTabChange(6)" label="{{\'SELLERS.TABS.ORDER_TYPES\' | translate}}" \nng-disabled="!vm.seller.Status" tx-access="{{::vm.orderTypesModel.views.privileges.list}}"><div class="list-tab" \nlayout="row" flex="100" layout-wrap><ms-widget layout="row" flex="100"><ms-widget-front class="white-bg"><tx-data-table\n tx-is-active="vm.tabIndex === 6" tx-data="vm.orderTypes" tx-model="vm.orderTypesModel" tx-view="mainList" \ntx-filtered-data="vm.filteredOrderTypes" tx-data-filter="global.search" tx-is-loading="vm.isOrderTypesLoading" \ntx-item-action-event="vm.doOrderTypesItemAction(action, item)" \ntx-list-action-event="vm.doOrderTypesListAction(action, selectedItems)" \ntx-refresh-action-event="vm.refreshOrderTypes(true, false)" tx-height-offset="16"></tx-data-table></ms-widget-front>\n</ms-widget><md-button class="add-rec-button md-fab md-warn" ng-click="vm.addOrderType($event)" \naria-label="vm.orderTypesModel.views.mainList.fabAction.label" translate \ntx-access="{{::vm.orderTypesModel.views.mainList.fabAction.privilege}}"><md-icon \nmd-font-icon="{{vm.orderTypesModel.views.mainList.fabAction.icon}}"></md-icon></md-button></div></md-tab><md-tab \nmd-on-select="vm.onActiveTabChange(7)" label="{{\'SELLERS.TABS.VAS\' | translate}}" ng-disabled="!vm.seller.Status" \ntx-access="{{::vm.VASModel.views.privileges.list}}"><div class="list-tab" layout="row" flex="100" layout-wrap>\n<ms-widget layout="row" flex="100"><ms-widget-front class="white-bg"><tx-data-table tx-is-active="vm.tabIndex === 7" \ntx-data="vm.sellerVAS" tx-model="vm.VASModel" tx-view="mainList" tx-filtered-data="vm.filteredSellerVAS" \ntx-data-filter="global.search" tx-is-loading="vm.isVASLoading" tx-item-action-event="vm.doVASItemAction(action, item)" \ntx-item-click-event="vm.viewVAS(item)" tx-refresh-action-event="vm.refreshVAS(true, false)" tx-height-offset="16">\n</tx-data-table></ms-widget-front></ms-widget><md-button class="add-rec-button md-fab md-warn" \nng-click="vm.addVAS($event)" aria-label="vm.VASModel.views.mainList.fabAction.label" translate \ntx-access="{{::vm.VASModel.views.mainList.fabAction.privilege}}"><md-icon \nmd-font-icon="{{vm.VASModel.views.mainList.fabAction.icon}}"></md-icon></md-button></div></md-tab><md-tab \nmd-on-select="vm.onActiveTabChange(8)" label="{{\'SELLERS.TABS.MASTER_SIZE_SCALES\' | translate}}" \nng-disabled="!vm.seller.Status" tx-access="{{::vm.masterSizeScalesModelCopy.views.privileges.list}}"><div \nclass="list-tab" layout="row" flex="100" layout-wrap><ms-widget layout="row" flex="100"><ms-widget-front \nclass="white-bg"><tx-data-table tx-is-active="vm.tabIndex === 8" tx-data="vm.masterSizeScales" \ntx-model="vm.masterSizeScalesModelCopy" tx-view="mainList" tx-filtered-data="vm.filteredMasterSizeScales" \ntx-data-filter="global.search" tx-item-action-event="vm.doMasterSizeScalesItemAction(action, item)" \ntx-is-loading="vm.isMasterSizeScalesLoading" \ntx-list-action-event="vm.doMasterSizeScalesListAction(action, selectedItems)" \ntx-refresh-action-event="vm.refreshMasterSizeScales(true, false)" tx-height-offset="16"></tx-data-table>\n</ms-widget-front></ms-widget><md-button class="add-rec-button md-fab md-warn" \nng-click="vm.addMasterSizeScales($event)" aria-label="vm.masterSizeScalesModelCopy.views.mainList.fabAction.label" \ntranslate ng-show="vm.masterSizeScalesModelCopy.views.mainList.fabAction.visible" \ntx-access="{{::vm.masterSizeScalesModelCopy.views.mainList.fabAction.privilege}}"><md-icon \nmd-font-icon="{{vm.masterSizeScalesModelCopy.views.mainList.fabAction.icon}}"></md-icon></md-button></div></md-tab>\n<md-tab md-on-select="vm.onActiveTabChange(9)" label="{{\'SELLERS.TABS.SELLER_SIZE_SCALE_GROUP\' | translate}}" \nng-disabled="!vm.seller.Status" tx-access="{{::vm.sizeScaleGroupsModelCopy.views.privileges.list}}"><div \nclass="list-tab" layout="row" flex="100" layout-wrap><ms-widget layout="row" flex="100"><ms-widget-front \nclass="white-bg"><tx-data-table tx-is-active="vm.tabIndex === 9" tx-data="vm.sizeScaleGroups" \ntx-model="vm.sizeScaleGroupsModelCopy" tx-view="mainList" tx-filtered-data="vm.filteredSizeScaleGroups" \ntx-data-filter="global.search" tx-item-action-event="vm.doSizeScaleGroupsItemAction(action, item)" \ntx-is-loading="vm.isSizeScaleGroupsLoading" \ntx-list-action-event="vm.doSizeScaleGroupsListAction(action, selectedItems)" \ntx-refresh-action-event="vm.refreshSizeScaleGroups(true, false)" tx-height-offset="16"></tx-data-table>\n</ms-widget-front></ms-widget><md-button class="add-rec-button md-fab md-warn" ng-click="vm.addSizeScales($event)" \naria-label="vm.sizeScaleGroupsModelCopy.views.mainList.fabAction.label" translate \nng-show="vm.sizeScaleGroupsModelCopy.views.mainList.fabAction.visible" \ntx-access="{{::vm.sizeScaleGroupsModelCopy.views.mainList.fabAction.privilege}}"><md-icon \nmd-font-icon="{{vm.sizeScaleGroupsModelCopy.views.mainList.fabAction.icon}}"></md-icon></md-button></div></md-tab>\n<md-tab md-on-select="vm.onActiveTabChange(10)" label="{{\'SELLERS.TABS.SEASONLESS_ARTICLE_ATTRIBUTES\' | translate}}" \nng-disabled="!vm.seller.Status" tx-access="{{::vm.seasonlessAttributesModel.views.privileges.list}}" \nng-if="vm.seller.AllowSeasonlessAttributes === 1"><div class="list-tab" layout="row" flex="100" layout-wrap><ms-widget \nlayout="row" flex="100"><ms-widget-front class="white-bg"><tx-data-table tx-is-active="vm.tabIndex === 10" \ntx-data="vm.seasonlessAttributes" tx-model="vm.seasonlessAttributesModel" tx-view="mainList" \ntx-filtered-data="vm.filteredSeasonlessAttributes" tx-data-filter="global.search" \ntx-is-loading="vm.isSeasonlessAttributesLoading" \ntx-list-action-event="vm.doSeasonlessAttributesListAction(action, selectedItems)" \ntx-item-action-event="vm.doSeasonlessAttributesItemAction(action, item)" \ntx-refresh-action-event="vm.refreshSeasonlessAttributes(true, false)" tx-height-offset="16"></tx-data-table>\n</ms-widget-front></ms-widget><md-button class="add-rec-button md-fab md-warn" \nng-click="vm.addSeasonlessAttributes($event)" aria-label="vm.seasonlessAttributesModel.views.mainList.fabAction.label" \ntranslate tx-access="{{::vm.seasonlessAttributesModel.views.mainList.fabAction.privilege}}"><md-icon \nmd-font-icon="{{vm.seasonlessAttributesModel.views.mainList.fabAction.icon}}"></md-icon></md-button></div></md-tab>\n<md-tab md-on-select="vm.onActiveTabChange(11)" label="{{\'SELLERS.TABS.SEASONLESS_MODEL_ATTRIBUTES\' | translate}}" \nng-disabled="!vm.seller.Status" tx-access="{{::vm.seasonlessModelAttributesModel.views.privileges.list}}" \nng-if="vm.seller.AllowSeasonlessModelAttributes === 1"><div class="list-tab" layout="row" flex="100" layout-wrap>\n<ms-widget layout="row" flex="100"><ms-widget-front class="white-bg"><tx-data-table tx-is-active="vm.tabIndex === 11" \ntx-data="vm.seasonlessModelAttributes" tx-model="vm.seasonlessModelAttributesModel" tx-view="mainList" \ntx-filtered-data="vm.filteredSeasonlessModelAttributes" tx-data-filter="global.search" \ntx-is-loading="vm.isSeasonlessModelAttributesLoading" \ntx-list-action-event="vm.doSeasonlessModelAttributesListAction(action, selectedItems)" \ntx-item-action-event="vm.doSeasonlessModelAttributesItemAction(action, item)" tx-attribute-groups="vm.attributeGroups" \ntx-selected-attribute-group="vm.seasonlessModelAttributeGroupId" \ntx-attribute-group-change-event="vm.onSeasonlessModelAttributeGroupChange(attributeGroupId)" \ntx-refresh-action-event="vm.refreshSeasonlessModelAttributes(true, false)" tx-height-offset="16"></tx-data-table>\n</ms-widget-front></ms-widget><md-button class="add-rec-button md-fab md-warn" \nng-click="vm.addSeasonlessModelAttributes($event)" \naria-label="vm.seasonlessModelAttributesModel.views.mainList.fabAction.label" translate \ntx-access="{{::vm.seasonlessModelAttributesModel.views.mainList.fabAction.privilege}}"><md-icon \nmd-font-icon="{{vm.seasonlessModelAttributesModel.views.mainList.fabAction.icon}}"></md-icon></md-button></div>\n</md-tab><md-tab md-on-select="vm.onActiveTabChange(12)" label="{{\'SELLERS.TABS.ARTICLE_DROP_REASONS\' | translate}}" \nng-disabled="vm.isLoading" tx-access="{{::vm.articleDropReasonsModelCopy.views.privileges.list}}"><div \nclass="list-tab" layout="row" flex="100" layout-wrap><ms-widget layout="row" flex="100"><ms-widget-front \nclass="white-bg"><tx-data-table tx-is-active="vm.tabIndex === 12" tx-data="vm.articleDropReasons" \ntx-model="vm.articleDropReasonsModelCopy" tx-view="mainList" tx-filtered-data="vm.filteredArticleDropReasons" \ntx-data-filter="global.search" tx-item-action-event="vm.doArticleDropReasonsItemAction(action, item)" \ntx-list-action-event="vm.doArticleDropReasonsListAction(action, selectedItems)" \ntx-is-loading="vm.isArticleDropReasonsLoading" tx-refresh-action-event="vm.refreshArticleDropReasons(true, false)" \ntx-height-offset="16"></tx-data-table></ms-widget-front></ms-widget><md-button class="add-rec-button md-fab md-warn" \nng-click="vm.addArticleDropReasons($event)" aria-label="vm.articleDropReasonsModelCopy.views.mainList.fabAction.label" \ntranslate ng-show="vm.articleDropReasonsModelCopy.views.mainList.fabAction.visible" \ntx-access="{{::vm.articleDropReasonsModelCopy.views.mainList.fabAction.privilege}}"><md-icon \nmd-font-icon="{{vm.articleDropReasonsModelCopy.views.mainList.fabAction.icon}}"></md-icon></md-button></div></md-tab>\n<md-tab md-on-select="vm.onActiveTabChange(13)" label="{{\'SELLERS.TABS.SELLER_LOOKUP_TABLE\' | translate}}" \nng-disabled="vm.isLoading" tx-access="{{::vm.lookupDefinitionsModel.views.privileges.list}}" \nng-if="vm.seller.ParentAccountId === null"><div class="list-tab" layout="row" flex="100" layout-wrap><ms-widget \nlayout="row" flex="100"><ms-widget-front class="white-bg"><tx-data-table tx-is-active="vm.tabIndex === 13" \ntx-data="vm.lookupDefinitions" tx-model="vm.lookupDefinitionsModel" tx-view="mainList" \ntx-filtered-data="vm.filteredLookupDefinitions" tx-data-filter="global.search" \ntx-item-action-event="vm.doLookupDefinitionsItemAction(action, item)" \ntx-item-click-event="vm.viewLookupDefinition(item)" tx-is-loading="vm.isLookupDefinitionsLoading" \ntx-refresh-action-event="vm.refreshLookupDefinitions(true, false)" tx-height-offset="16"></tx-data-table>\n</ms-widget-front></ms-widget><md-button class="add-rec-button md-fab md-warn" \nng-click="vm.addLookupDefinition($event)" aria-label="vm.lookupDefinitionsModel.views.mainList.fabAction.label" \ntranslate tx-access="{{::vm.lookupDefinitionsModel.views.mainList.fabAction.privilege}}"><md-icon \nmd-font-icon="{{vm.lookupDefinitionsModel.views.mainList.fabAction.icon}}"></md-icon></md-button></div></md-tab><md-tab\n label="{{\'SELLERS.TABS.COLORS\' | translate}}" ng-disabled="!vm.seller.Status" md-on-select="vm.onActiveTabChange(14)" \ntx-access="{{vm.sellerColorsModelCopy.views.privileges.list}}"><div class="list-tab" layout="row" flex="100" \nlayout-wrap><ms-widget layout="row" flex="100"><ms-widget-front class="white-bg"><tx-data-table \ntx-is-active="vm.tabIndex === 14" tx-data="vm.sellerColors" tx-model="vm.sellerColorsModelCopy" tx-view="mainList" \ntx-filtered-data="vm.filteredSellerColors" tx-data-filter="global.search" tx-is-loading="vm.isSellerColorsLoading" \ntx-item-action-event="vm.doSellerColorsItemAction(action, item)" \ntx-list-action-event="vm.doSellerColorsListAction(action, selectedItems)" \ntx-refresh-action-event="vm.refreshSellerColors(true, false)" tx-height-offset="16"></tx-data-table></ms-widget-front>\n</ms-widget><md-button class="add-rec-button md-fab md-warn" ng-click="vm.addSellerColor($event)" \naria-label="vm.sellerColorsModelCopy.views.mainList.fabAction.label" translate \nng-show="vm.sellerColorsModelCopy.views.mainList.fabAction.visible" \ntx-access="{{vm.sellerColorsModelCopy.views.mainList.fabAction.privilege}}"><md-icon \nmd-font-icon="{{vm.sellerColorsModelCopy.views.mainList.fabAction.icon}}"></md-icon></md-button></div></md-tab><md-tab \nlabel="{{\'SELLERS.TABS.DATASETS\' | translate}}" ng-disabled="!vm.seller.Status" \nmd-on-select="vm.onActiveTabChange(15)" tx-access="{{vm.sellerColorsModelCopy.views.privileges.list}}"><div \nclass="list-tab" layout="row" flex="100" layout-wrap><ms-widget layout="row" flex="100"><ms-widget-front \nclass="white-bg"><tx-data-table tx-is-active="vm.tabIndex === 15" tx-data="vm.datasetDefinitions" \ntx-model="vm.dataSetDefinitionsModelCopy" tx-view="mainList" tx-filtered-data="vm.filteredDataSetsDefinitionModel" \ntx-data-filter="global.search" tx-is-loading="vm.isDatasetDefinitionsLoading" \ntx-item-action-event="vm.doDatasetDefinitionItemAction(action, item)" \ntx-list-action-event="vm.doDatasetDefinitionListAction(action, selectedItems)" \ntx-item-click-event="vm.viewDatasetDefinition(item)" \ntx-refresh-action-event="vm.refreshDatasetDefinitions(true, false)" tx-height-offset="16"></tx-data-table>\n</ms-widget-front></ms-widget><md-button class="add-rec-button md-fab md-warn" \nng-click="vm.addDatasetDefinition($event)" aria-label="vm.dataSetDefinitionsModelCopy.views.mainList.fabAction.label" \ntranslate ng-show="vm.dataSetDefinitionsModelCopy.views.mainList.fabAction.visible" \ntx-access="{{vm.dataSetDefinitionsModelCopy.views.mainList.fabAction.privilege}}"><md-icon \nmd-font-icon="{{vm.dataSetDefinitionsModelCopy.views.mainList.fabAction.icon}}"></md-icon></md-button></div></md-tab>\n<md-tab label="{{\'SELLERS.TABS.RESOURCES\' | translate}}" ng-disabled="!vm.seller.Status" \nmd-on-select="vm.onActiveTabChange(16)" tx-access="{{vm.sellerResourcesModel.views.privileges.list}}"><div \nclass="list-tab" layout="row" flex="100" layout-wrap><ms-widget layout="row" flex="100"><ms-widget-front \nclass="white-bg"><tx-data-table tx-is-active="vm.tabIndex === 16" tx-data="vm.sellerResources" \ntx-model="vm.sellerResourcesModel" tx-view="mainList" tx-filtered-data="vm.filteredSellerResources" \ntx-data-filter="global.search" tx-is-loading="vm.isSellerResourcesLoading" \ntx-item-action-event="vm.doSellerResourcesItemAction(action, item)" \ntx-list-action-event="vm.doSellerResourcesListAction(action, selectedItems)" \ntx-item-click-event="vm.viewSellerResource(item)" tx-refresh-action-event="vm.refreshSellerResources(true, false)" \ntx-height-offset="16"></tx-data-table></ms-widget-front></ms-widget><md-button class="add-rec-button md-fab md-warn" \nng-click="vm.addSellerResource($event)" aria-label="vm.sellerResourcesModel.views.mainList.fabAction.label" translate \ntx-access="{{vm.sellerResourcesModel.views.mainList.fabAction.privilege}}"><md-icon \nmd-font-icon="{{vm.sellerResourcesModel.views.mainList.fabAction.icon}}"></md-icon></md-button></div></md-tab><md-tab \nlabel="{{\'SELLERS.TABS.CAPACITIES\' | translate}}" ng-disabled="!vm.seller.Status" \nmd-on-select="vm.onActiveTabChange(17)" tx-access="{{::vm.capacitiesModel.views.privileges.list}}"><div \nclass="list-tab" layout="row" flex="100" layout-wrap><ms-widget layout="row" flex="100"><ms-widget-front \nclass="white-bg"><tx-data-table tx-is-active="vm.tabIndex === 17" tx-data="vm.capacities" \ntx-model="vm.capacitiesModel" tx-view="mainList" tx-filtered-data="vm.filteredCapacities" \ntx-data-filter="global.search" tx-is-loading="vm.isCapacitiesLoading" \ntx-item-action-event="vm.doCapacitiesItemAction(action, item)" \ntx-list-action-event="vm.doCapacitiesListAction(action, selectedItems)" tx-item-click-event="vm.viewCapacity(item)" \ntx-refresh-action-event="vm.refreshCapacities(true, false)" tx-height-offset="16"></tx-data-table></ms-widget-front>\n</ms-widget><md-button class="add-rec-button md-fab md-warn" ng-click="vm.addCapacity($event)" \naria-label="vm.capacitiesModel.views.mainList.fabAction.label" translate \ntx-access="{{::vm.capacitiesModel.views.mainList.fabAction.privilege}}"><md-icon \nmd-font-icon="{{vm.capacitiesModel.views.mainList.fabAction.icon}}"></md-icon></md-button></div></md-tab><md-tab \nlabel="{{\'SELLERS.TABS.DESIGN_OPTION_ATTRIBUTES\' | translate}}" ng-disabled="!vm.seller.Status" \nmd-on-select="vm.onActiveTabChange(18)" tx-access="{{vm.designOptionAttributesModelCopy.views.privileges.list}}"><div \nclass="list-tab" layout="row" flex="100" layout-wrap><ms-widget layout="row" flex="100"><ms-widget-front \nclass="white-bg"><tx-data-table tx-is-active="vm.tabIndex === 18" tx-data="vm.designOptionAttributes" \ntx-model="vm.designOptionAttributesModelCopy" tx-view="mainList" tx-filtered-data="vm.filteredDesignOptionAttributes" \ntx-data-filter="global.search" tx-is-loading="vm.isDesignOptionAttributesLoading" \ntx-item-action-event="vm.doDesignOptionAttributesItemAction(action, item)" \ntx-list-action-event="vm.doDesignOptionAttributesListAction(action, selectedItems)" \ntx-refresh-action-event="vm.refreshDesignOptionAttributes(true, false)" tx-height-offset="16"></tx-data-table>\n</ms-widget-front></ms-widget><md-button class="add-rec-button md-fab md-warn" \nng-click="vm.addDesignOptionAttribute($event)" \naria-label="vm.designOptionAttributesModelCopy.views.mainList.fabAction.label" translate \nng-show="vm.designOptionAttributesModelCopy.views.mainList.fabAction.visible" \ntx-access="{{vm.designOptionAttributesModelCopy.views.mainList.fabAction.privilege}}"><md-icon \nmd-font-icon="{{vm.designOptionAttributesModelCopy.views.mainList.fabAction.icon}}"></md-icon></md-button></div>\n</md-tab></md-tabs></div></div>');
$templateCache.put('app/main/accounts/sellers/list/sellers-list.html','<div id="sellers-list" class="page-layout carded fullwidth list-view" layout="row"><div class="center" layout="column" \nflex><div class="content-card" layout="column" flex><tx-data-table tx-data="vm.sellers" tx-model="vm.model" \ntx-view="mainList" tx-filtered-data="vm.filteredSellers" tx-data-filter="global.search" tx-is-loading="vm.isLoading" \ntx-item-action-event="vm.doItemAction(action, item)" tx-list-action-event="vm.doListAction(action, selectedItems)" \ntx-item-click-event="vm.viewItem(item)" tx-refresh-action-event="vm.refreshItems(true, false)"></tx-data-table>\n<md-button class="add-rec-button md-fab md-warn" ng-click="vm.addRecord($event)" \naria-label="vm.model.views.mainList.fabAction.label" translate \ntx-access="{{::vm.model.views.mainList.fabAction.privilege}}"><md-icon \nmd-font-icon="{{vm.model.views.mainList.fabAction.icon}}"></md-icon></md-button></div></div></div>');
$templateCache.put('app/main/accounts/user-groups/details/user-groups-details.html','<div id="user-details" class="page-layout simple tabbed details-view" layout="column"><div class="content"><md-tabs \nmd-dynamic-height md-selected="vm.tabIndex" md-no-ink><md-tab label="{{\'USER_GROUPS.TABS.USER_GROUP\' | translate}}" \ntx-access="{{::vm.model.views.privileges.details}}"><tx-data-details tx-height-offset="37" \ntx-is-active="vm.tabIndex === 0" tx-account="vm.userGroup" tx-parent-id="vm.userGroup.Id" tx-title="vm.title" \ntx-model="vm.model" tx-item-actions="vm.model.views.mainDetails.itemActions" \ntx-item-action-event="vm.doItemAction(action, account)" tx-is-loading="vm.isLoading" \ntx-refresh-action-event="vm.refreshRecord(false)"></tx-data-details></md-tab><md-tab \nlabel="{{\'USER_GROUPS.TABS.USERS\' | translate}}" tx-access="{{::vm.userGroupUsersModel.views.privileges.list}}"><div \nclass="list-tab" layout="row" flex="100" layout-wrap><ms-widget layout="row" flex="100"><ms-widget-front \nclass="white-bg"><tx-data-table tx-is-active="vm.tabIndex === 1" tx-data="vm.userGroupUsers" \ntx-model="vm.userGroupUsersModel" tx-view="mainList" tx-filtered-data="vm.filteredUserGroupUsers" \ntx-data-filter="global.search" tx-is-loading="vm.isLoading" tx-refresh-action-event="vm.refreshRecord(true, false)" \ntx-height-offset="16"></tx-data-table></ms-widget-front></ms-widget><md-button class="add-rec-button md-fab md-warn" \nng-click="vm.assignUsers($event)" aria-label="vm.userGroupUsersModel.views.mainList.fabAction.label" translate \ntx-access="{{::vm.userGroupUsersModel.views.mainList.fabAction.privilege}}"><md-icon \nmd-font-icon="{{vm.userGroupUsersModel.views.mainList.fabAction.icon}}"></md-icon></md-button></div></md-tab></md-tabs>\n<md-button id="txfab" class="md-fab md-warn" ng-if="vm.tabIndex === 0" ng-click="vm.editItem(vm.userGroup, $event)" \naria-label="vm.model.views.mainDetails.fab.label" translate tx-access="{{::vm.model.views.mainDetails.fab.privilege}}">\n<md-icon md-font-icon="{{vm.model.views.mainDetails.fab.icon}}"></md-icon></md-button></div></div>');
$templateCache.put('app/main/accounts/user-groups/list/user-groups-lists.html','<div id="users-list" class="page-layout carded fullwidth list-view" layout="row"><div class="center" layout="column" \nflex><div class="content-card" layout="column" flex><tx-data-table tx-data="vm.userGroups" tx-model="vm.model" \ntx-view="mainList" tx-filtered-data="vm.filteredUserGroups" tx-data-filter="global.search" \ntx-is-loading="vm.isLoading" tx-item-action-event="vm.doItemAction(action, item)" \ntx-list-action-event="vm.doListAction(action, selectedItems)" tx-item-click-event="vm.viewItem(item)" \ntx-refresh-action-event="vm.refreshItems(true, false)"></tx-data-table><md-button \nclass="add-rec-button md-fab md-warn" ng-click="vm.addRecord($event)" \naria-label="vm.model.views.mainList.fabAction.label" translate \ntx-access="{{::vm.model.views.mainList.fabAction.privilege}}"><md-icon \nmd-font-icon="{{vm.model.views.mainList.fabAction.icon}}"></md-icon></md-button></div></div></div>');
$templateCache.put('app/main/accounts/users/details/user-details.html','<div id="user-details" class="page-layout simple tabbed details-view" layout="column"><div class="content"><md-tabs \nmd-dynamic-height md-selected="vm.tabIndex" md-no-ink><md-tab label="{{\'USERS.TABS.USER\' | translate}}" \ntx-access="{{::vm.model.views.privileges.details}}"><tx-data-details tx-height-offset="37" \ntx-is-active="vm.tabIndex === 0" tx-account="vm.user" tx-parent-id="vm.user.AccountId" tx-title="vm.title" \ntx-model="vm.model" tx-item-actions="vm.model.views.mainDetails.itemActions" \ntx-item-action-event="vm.doItemAction(action, account)" tx-edit-record-event="vm.editUser(event, record)" \ntx-is-loading="vm.isLoading" tx-refresh-action-event="vm.refreshRecord(false)"></tx-data-details></md-tab><md-tab \nlabel="{{\'USERS.TABS.NOTIFICATIONS\' | translate}}" ng-disabled="!vm.user.Status" \ntx-access="{{::vm.notificationModel.views.privileges.list}}"><div class="list-tab" layout="row" flex="100" layout-wrap>\n<ms-widget layout="row" flex="100"><ms-widget-front class="white-bg"><tx-data-table tx-is-active="vm.tabIndex === 1" \ntx-data="vm.notifications" tx-model="vm.notificationModel" tx-view="mainList" \ntx-filtered-data="vm.filteredNotifications" tx-data-filter="global.search" tx-is-loading="vm.isNotificationsLoading" \ntx-item-action-event="vm.doNotificationsItemAction(action, item)" tx-item-click-event="vm.viewNotification(item)" \ntx-refresh-action-event="vm.refreshNotifications(true, false)" tx-height-offset="16"></tx-data-table></ms-widget-front>\n</ms-widget></div></md-tab><md-tab label="{{\'USERS.TABS.CATALOG_ACCESS\' | translate}}" \nng-if="vm.account === \'sellers\'" ng-disabled="!vm.user.Status" \ntx-access="{{::vm.catalogAccessModel.views.privileges.list}}"><div class="list-tab" layout="row" flex="100" \nlayout-wrap><ms-widget layout="row" flex="100"><ms-widget-front class="white-bg"><tx-data-table \ntx-is-active="vm.tabIndex === 2" tx-data="vm.catalogAccess" tx-model="vm.catalogAccessModel" tx-view="mainList" \ntx-filtered-data="vm.filteredCatalogAccess" tx-data-filter="global.search" tx-is-loading="vm.isCatalogAccessLoading" \ntx-item-action-event="vm.doCatalogAccessItemAction(action, item)" \ntx-list-action-event="vm.doCatalogAccessListAction(action, selectedItems)" \ntx-refresh-action-event="vm.refreshCatalogAccess(true, false)" tx-height-offset="16"></tx-data-table></ms-widget-front>\n</ms-widget><md-button class="add-rec-button md-fab md-warn" ng-click="vm.linkCatalogs($event)" \naria-label="vm.catalogAccessModel.views.mainList.fabAction.label" translate \ntx-access="{{::vm.catalogAccessModel.views.mainList.fabAction.privilege}}"><md-icon \nmd-font-icon="{{vm.catalogAccessModel.views.mainList.fabAction.icon}}"></md-icon></md-button></div></md-tab><md-tab \nlabel="{{\'USERS.TABS.PRIVACY_POLICY\' | translate}}" ng-if="vm.account !== \'trasix\'" ng-disabled="!vm.user.Status" \ntx-access="{{::vm.privacyPolicyModel.views.privileges.list}}"><div class="list-tab" layout="row" flex="100" \nlayout-wrap><ms-widget layout="row" flex="100"><ms-widget-front class="white-bg"><tx-data-table \ntx-is-active="vm.tabIndex === 3" tx-data="vm.privacyPolicy" tx-model="vm.privacyPolicyModel" tx-view="mainList" \ntx-filtered-data="vm.filteredPrivacyPolicy" tx-data-filter="global.search" tx-is-loading="vm.isPrivacyPolicyLoading" \ntx-refresh-action-event="vm.refreshPrivacyPolicy(true, false)" tx-height-offset="16"></tx-data-table></ms-widget-front>\n</ms-widget></div></md-tab><md-tab label="{{\'USERS.TABS.CUSTOMERS\' | translate}}" ng-if="vm.account === \'buyers\'" \nng-disabled="!vm.user.Status" tx-access="{{::vm.customersModel.views.privileges.list}}"><div class="list-tab" \nlayout="row" flex="100" layout-wrap><ms-widget layout="row" flex="100"><ms-widget-front class="white-bg"><tx-data-table\n tx-is-active="vm.tabIndex === 4" tx-data="vm.customers" tx-model="vm.customersModel" tx-view="mainList" \ntx-filtered-data="vm.filteredCustomers" tx-data-filter="global.search" tx-is-loading="vm.isCustomersLoading" \ntx-item-action-event="vm.doCustomersItemAction(action, item)" \ntx-list-action-event="vm.doCustomersListAction(action, selectedItems)" \ntx-refresh-action-event="vm.refreshCustomers(true, false)" tx-height-offset="16"></tx-data-table></ms-widget-front>\n</ms-widget><md-button class="add-rec-button md-fab md-warn" ng-click="vm.linkCustomers($event)" \naria-label="vm.customersModel.views.mainList.fabAction.label" translate \ntx-access="{{::vm.customersModel.views.mainList.fabAction.privilege}}"><md-icon \nmd-font-icon="{{vm.customersModel.views.mainList.fabAction.icon}}"></md-icon></md-button></div></md-tab><md-tab \nlabel="{{\'USERS.TABS.NOTIFICATION_TYPES\' | translate}}" ng-if="vm.account === \'buyers\'|| vm.account === \'sellers\'" \ntx-access="{{::vm.notificationTypesModel.views.privileges.list}}"><div class="list-tab" layout="row" flex="100" \nlayout-wrap><ms-widget layout="row" flex="100"><ms-widget-front class="white-bg"><tx-data-table \ntx-is-active="vm.tabIndex === 6" tx-data="vm.notificationTypes" tx-model="vm.notificationTypesModel" \ntx-view="mainList" tx-filtered-data="vm.filteredNotificationTypes" tx-data-filter="global.search" \ntx-is-loading="vm.isLoading" tx-refresh-action-event="vm.refreshRecord(true, false)" tx-height-offset="16">\n</tx-data-table></ms-widget-front></ms-widget><md-button class="add-rec-button md-fab md-warn" \nng-click="vm.assignNotificationTypes($event)" aria-label="vm.notificationTypesModel.views.mainList.fabAction.label" \ntranslate tx-access="{{::vm.notificationTypesModel.views.mainList.fabAction.privilege}}"><md-icon \nmd-font-icon="{{vm.notificationTypesModel.views.mainList.fabAction.icon}}"></md-icon></md-button></div></md-tab>\n</md-tabs></div></div>');
$templateCache.put('app/main/accounts/users/list/users-list.html','<div id="users-list" class="page-layout carded fullwidth list-view" layout="row"><div class="center" layout="column" \nflex><div class="content-card" layout="column" flex><tx-data-table tx-data="vm.users" tx-model="vm.model" \ntx-view="mainList" tx-filtered-data="vm.filteredUsers" tx-data-filter="global.search" tx-is-loading="vm.isLoading" \ntx-item-action-event="vm.doItemAction(action, item)" tx-list-action-event="vm.doListAction(action, selectedItems)" \ntx-item-click-event="vm.viewItem(item)" tx-refresh-action-event="vm.refreshItems(true, false)"></tx-data-table></div>\n</div></div>');
$templateCache.put('app/main/article-states/dialogs/add-update-article-states/add-update-article-states.html','<md-dialog class="edit-dialog" aria-label="Create Article State"><form name="vm.editForm" class="md-inline-form">\n<md-toolbar class="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" layout-align="space-between center">\n<span class="title" \ntranslate="{{ vm.isNew? \'ARTICLE_STATES.TITLES.CREATE_ARTICLE_STATE\': \'ARTICLE_STATES.TITLES.UPDATE_ARTICLE_STATE\' }}">\n{{vm.isNew ? \'Create Article State\' : \'Update Article State\'}}</span><md-button class="md-icon-button" \nng-click="vm.closeDialog(vm.isDataDirty)" aria-label="Close dialog" tranlate \ntranslate-aria-label="ACTIONS.DIALOG_CLOSE"><md-icon md-font-icon="icon-close"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div layout="row" layout-align="center center" ng-show="vm.isLookupLoading" \nclass="loader-container"><md-progress-circular md-mode="indeterminate" class="md-accent"></md-progress-circular></div>\n<div layout="row" ng-if="!vm.isLookupLoading" layout-wrap><div flex="100" flex-gt-xs="50" class="p-5" \nng-disabled="!vm.isNew"><md-input-container class="md-block"><label translate>ARTICLE_STATES.FIELDS.STATE_NAME</label>\n<input id="dialog_input_first" name="StateName" ng-model="vm.record.StateName" type="text" ng-required="true" \nng-disabled="!vm.isNew" md-autofocus><div ng-messages="vm.editForm.StateName.$error" role="alert" multiple="multiple">\n<div ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div><div ng-message="tx-unique-value">\n{{\'VALIDATIONS.NOT_UNIQUE\' | translate}}</div></div></md-input-container></div><div flex="100" flex-gt-xs="50" \nclass="p-5" ng-if="vm.isNew"><md-input-container class="md-block"><label translate>ARTICLE_STATES.FIELDS.STATE_RANK\n</label><input id="dialog_input_1" name="StateRank" ng-model="vm.record.StateRank" type="number" ng-required="true" \nng-pattern="/^[0-9][0-9]*$/" tx-unique-value="vm.existingRecordsForUniqueValue:StateRank:true" \nng-change="vm.stateRankChange()"><div ng-messages="vm.editForm.StateRank.$error" role="alert" multiple="multiple"><div \nng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div><div ng-message="pattern">\n{{\'VALIDATIONS.PATTERN\' | translate}}</div><div ng-message="tx-unique-value">{{\'VALIDATIONS.DUPLICATE\' | translate}}\n</div></div></md-input-container></div><div flex="100" flex-gt-xs="50" class="p-5"><md-switch \nid="catalog_dialog_input_2" ng-model="vm.record.IsDefault" aria-label="{{\'CATALOGS.FIELDS.IS_DEFAULT\' | translate}}" \nng-true-value="1" ng-false-value="0" class="md-accent">{{\'ARTICLE_STATES.FIELDS.IS_DEFAULT\' | translate}}<md-tooltip \nmd-direction="right">{{vm.record.IsDefault === 1 ? \'PARTS.YES\' : \'PARTS.NO\' | translate}}</md-tooltip></md-switch>\n</div><div flex="100" flex-gt-xs="50" class="p-5"><md-switch id="catalog_dialog_input_3" \nng-model="vm.record.AssignFinalArticleModelNumber" \naria-label="{{\'CATALOGS.FIELDS.ASSIGN_FINAL_ARTICLE_MODEL_NUMBER\' | translate}}" ng-true-value="1" ng-false-value="0" \nclass="md-accent" \nng-disabled="((vm.record.AssignFinalArticleModelNumber === 1 && !vm.isNew) || vm.disableAssignFinalArticleModelNumber)">\n{{\'ARTICLE_STATES.FIELDS.ASSIGN_FINAL_ARTICLE_MODEL_NUMBER\' | translate}}<md-tooltip md-direction="right">\n{{vm.record.AssignFinalArticleModelNumber === 1 ? \'PARTS.YES\' : \'PARTS.NO\' | translate}}</md-tooltip></md-switch></div>\n<div flex="100" flex-gt-xs="50" class="p-5"><md-switch id="catalog_dialog_input_4" \nng-model="vm.record.IsSizeScaleRequired" aria-label="{{\'CATALOGS.FIELDS.IS_SIZESCALE_REQUIRED\' | translate}}" \nng-true-value="1" ng-false-value="0" class="md-accent">{{\'ARTICLE_STATES.FIELDS.IS_SIZESCALE_REQUIRED\' | translate}}\n<md-tooltip md-direction="right">{{vm.record.IsSizeScaleRequired === 1 ? \'PARTS.YES\' : \'PARTS.NO\' | translate}}\n</md-tooltip></md-switch></div><div flex="100" flex-gt-xs="50" class="p-5"><md-switch id="catalog_dialog_input_5" \nng-model="vm.record.IsPrimaryColorRequired" aria-label="{{\'CATALOGS.FIELDS.IS_PRIMARY_COLOR_REQUIRED\' | translate}}" \nng-true-value="1" ng-false-value="0" class="md-accent">\n{{\'ARTICLE_STATES.FIELDS.IS_PRIMARY_COLOR_REQUIRED\' | translate}}<md-tooltip md-direction="right">\n{{vm.record.IsPrimaryColorRequired === 1 ? \'PARTS.YES\' : \'PARTS.NO\' | translate}}</md-tooltip></md-switch></div><div \nflex="100" flex-gt-xs="50" class="p-5"><md-switch id="catalog_dialog_input_6" ng-model="vm.record.IsModelNameEditable" \naria-label="{{\'CATALOGS.FIELDS.IS_MODEL_NAME_EDITABLE\' | translate}}" ng-true-value="1" ng-false-value="0" \nclass="md-accent">{{\'ARTICLE_STATES.FIELDS.IS_MODEL_NAME_EDITABLE\' | translate}}<md-tooltip md-direction="right">\n{{vm.record.IsModelNameEditable === 1 ? \'PARTS.YES\' : \'PARTS.NO\' | translate}}</md-tooltip></md-switch></div><div \nflex="100" flex-gt-xs="50" class="p-5"><md-switch id="catalog_dialog_input_7" \nng-model="vm.record.AllowChangeRequestForModelName" \naria-label="{{\'CATALOGS.FIELDS.ALLOW_CHANGE_REQUEST_FOR_MODEL_NAME\' | translate}}" ng-true-value="1" \nng-false-value="0" class="md-accent" ng-disabled="vm.record.IsModelNameEditable === 1">\n{{\'ARTICLE_STATES.FIELDS.ALLOW_CHANGE_REQUEST_FOR_MODEL_NAME\' | translate}}<md-tooltip md-direction="right">\n{{vm.record.AllowChangeRequestForModelName === 1 ? \'PARTS.YES\' : \'PARTS.NO\' | translate}}</md-tooltip></md-switch>\n</div><div flex="100" flex-gt-xs="50" class="p-5"><md-switch id="catalog_dialog_input_8" \nng-model="vm.record.IsSizeScaleEditable" aria-label="{{\'CATALOGS.FIELDS.IS_SIZESCALE_EDITABLE\' | translate}}" \nng-true-value="1" ng-false-value="0" class="md-accent">{{\'ARTICLE_STATES.FIELDS.IS_SIZESCALE_EDITABLE\' | translate}}\n<md-tooltip md-direction="right">{{vm.record.IsSizeScaleEditable === 1 ? \'PARTS.YES\' : \'PARTS.NO\' | translate}}\n</md-tooltip></md-switch></div><div flex="100" flex-gt-xs="50" class="p-5"><md-switch id="catalog_dialog_input_9" \nng-model="vm.record.AllowChangeRequestForSizeScale" \naria-label="{{\'CATALOGS.FIELDS.ALLOW_CHANGE_REQUEST_FOR_SIZESCALE\' | translate}}" ng-true-value="1" ng-false-value="0" \nclass="md-accent" ng-disabled="vm.record.IsSizeScaleEditable === 1">\n{{\'ARTICLE_STATES.FIELDS.ALLOW_CHANGE_REQUEST_FOR_SIZESCALE\' | translate}}<md-tooltip md-direction="right">\n{{vm.record.AllowChangeRequestForSizeScale === 1 ? \'PARTS.YES\' : \'PARTS.NO\' | translate}}</md-tooltip></md-switch>\n</div><div flex="100" flex-gt-xs="50" class="p-5"><md-switch id="catalog_dialog_input_10" \nng-model="vm.record.IsArticleNumberEditable" aria-label="{{\'CATALOGS.FIELDS.IS_ARTICLE_NUMBER_EDITABLE\' | translate}}" \nng-true-value="1" ng-false-value="0" class="md-accent">\n{{\'ARTICLE_STATES.FIELDS.IS_ARTICLE_NUMBER_EDITABLE\' | translate}}<md-tooltip md-direction="right">\n{{vm.record.IsArticleNumberEditable === 1 ? \'PARTS.YES\' : \'PARTS.NO\' | translate}}</md-tooltip></md-switch></div><div \nflex="100" class="p-5 lookup-element"><fieldset><legend class="header-non-editable-attributes" translate>\nARTICLE_STATES.FIELDS.REQUIRED_ATTRIBUTES</legend><div ng-repeat="record in vm.record.RequiredAttributes" flex="100" \nlayout="row" layout-wrap><div flex="30" flex-gt-xs="30" class="p-5"><md-autocomplete id="dialog_input_{{$index}}" \nmd-input-name="RequiredAttributeId" md-selected-item="vm.lookupModel[$index].RequiredAttributeId" \nmd-items="item in vm.lookupSearch(vm.searchText[$index].RequiredAttributeId, \'RequiredAttributeId\', \'lists.seasonlessModelAndArticleLevelAttributesList\')" \nmd-search-text="vm.searchText[$index].RequiredAttributeId" \nmd-item-text="vm.getLookupDisplayValue(item, \'NonEditableAttributes\', \'lists.seasonlessModelAndArticleLevelAttributesList\')" \nmd-min-length="0" md-floating-label="{{\'ARTICLE_STATES.FIELDS.REQUIRED_ATTRIBUTE\' | translate}}" md-no-cache="true" \ntx-clear-autocomplete ng-click="vm.selectText($event)" \nmd-selected-item-change="vm.lookupChange(vm.lookupModel[$index].RequiredAttributeId, \'RequiredAttributeId\', $index)" \nmd-menu-class="autocomplete-custom" ng-required="false"><md-item-template><span class="autocomplete-item md-accent-fg" \nmd-highlight-text="vm.searchText[$index].RequiredAttributeId" md-highlight-flags="i">{{item.value}}</span>\n</md-item-template><md-not-found>No Record matching "{{vm.searchText[$index].RequiredAttributeId}}" were found.\n</md-not-found></md-autocomplete></div><div flex="30" flex-gt-xs="30" class="p-5"><md-autocomplete \nid="dialog_input_{{$index}}" md-input-name="DependentAttributeId" \nmd-selected-item="vm.lookupModel[$index].DependentAttributeId" \nmd-items="item in vm.lookupSearch(vm.searchText[$index].DependentAttributeId, \'DependentAttributeId\', \'lists.seasonlessModelAndArticleLevelAttributesList\')" \nmd-search-text="vm.searchText[$index].DependentAttributeId" \nmd-item-text="vm.getLookupDisplayValue(item, \'NonEditableAttributes\', \'lists.seasonlessModelAndArticleLevelAttributesList\')" \nmd-min-length="0" md-floating-label="{{\'ARTICLE_STATES.FIELDS.DEPENDENT_ATTRIBUTE\' | translate}}" md-no-cache="true" \ntx-clear-autocomplete ng-click="vm.selectText($event)" \nmd-selected-item-change="vm.lookupChange(vm.lookupModel[$index].DependentAttributeId, \'DependentAttributeId\', $index)" \nmd-menu-class="autocomplete-custom" ng-required="false" \nng-disabled="vm.lookupModel[$index].RequiredAttributeId == null"><md-item-template><span \nclass="autocomplete-item md-accent-fg" md-highlight-text="vm.searchText[$index].DependentAttributeId" \nmd-highlight-flags="i">{{item.value}}</span></md-item-template><md-not-found>\nNo Record matching "{{vm.searchText[$index].DependentAttributeId}}" were found.</md-not-found></md-autocomplete></div>\n<div flex="40" flex-gt-xs="40" class="p-5" ng-if="vm.record.RequiredAttributes[$index].inputType" \nng-switch="vm.record.RequiredAttributes[$index].inputType"><div class="p-5"><div \nng-if="vm.record.RequiredAttributes[$index].inputType === \'textArea\' || vm.record.RequiredAttributes[$index].inputType === \'calculated\'">\n<md-input-container class="md-block"><input id="dialog_input_{{$first ? \'first\' : $index}}" name="Value" \nng-model="vm.record.RequiredAttributes[$index].Value"></md-input-container></div><div ng-switch-when="number">\n<md-input-container class="md-block"><input type="number" id="dialog_input_{{$first ? \'first\' : $index}}" name="Value" \nng-model="vm.record.RequiredAttributes[$index].Value"></md-input-container></div><div ng-switch-when="date" \nlayout="column" flex><md-datepicker id="dialog_input_{{$first ? \'first\' : $index}}" name="Value" \nng-model="vm.record.RequiredAttributes[$index].Value" \nng-init="vm.record.RequiredAttributes[$index].Value = vm.getDateObj(vm.record.RequiredAttributes[$index].Value)" \nmd-placeholder=""></md-datepicker></div><div ng-switch-when="date-without-time" layout="column" flex><md-datepicker \nid="dialog_input_{{$first ? \'first\' : $index}}" name="Value" ng-model="vm.record.RequiredAttributes[$index].Value" \nmd-placeholder=""></md-datepicker></div><div ng-switch-when="date-option" layout="column" flex><md-datepicker \nid="dialog_input_{{$first ? \'first\' : $index}}" name="Value" ng-model="vm.record.RequiredAttributes[$index].Value" \nng-init="vm.record.RequiredAttributes[$index].Value = vm.getDateObj(vm.record.RequiredAttributes[$index].Value)" \nmd-placeholder=""></md-datepicker></div><div ng-switch-when="bool-str"><md-switch \nid="dialog_input_{{$first ? \'first\' : $index}}" ng-model="vm.record.RequiredAttributes[$index].Value" \naria-label="{{vm.record.RequiredAttributes[$index].displayLabel | translate}}" ng-true-value="\'true\'" \nng-false-value="\'false\'" class="md-accent"></md-switch></div><div ng-switch-when="list"><md-input-container \nclass="md-block"><md-select id="dialog_input_{{$first ? \'first\' : $index}}" name="Value" \nng-model="vm.record.RequiredAttributes[$index].Value" \naria-label="{{vm.record.RequiredAttributes[$index].displayLabel | translate}}"><md-option md-option-empty \nng-value="\'\'"><em>None</em></md-option><md-option ng-value="option" \nng-repeat="option in vm.record.RequiredAttributes[$index].allowedValues">{{ option }}</md-option></md-select>\n</md-input-container></div><div ng-switch-when="multi-value"><md-input-container class="md-block"><md-chips \nid="dialog_input_{{$first ? \'first\' : $index}}" name="Value" ng-model="vm.record.RequiredAttributes[$index].Value" \nmd-autocomplete-snap md-transform-chip="vm.transformChip($chip, true)" \naria-label="{{vm.record.RequiredAttributes[$index].displayLabel | translate}}"><md-autocomplete \nmd-selected-item="vm.acSelectedItem[vm.record.RequiredAttributes[$index].field]" \nmd-search-text="vm.acSearchText[vm.record.RequiredAttributes[$index].field]" \nmd-items="item in vm.multiValueQuerySearch(vm.acSearchText[vm.record.RequiredAttributes[$index].field], vm.record.RequiredAttributes[$index].Value, record)" \nmd-item-text="item" md-min-length="0" md-no-cache="true" md-menu-class="autocomplete-custom"><md-item-template><span \nclass="autocomplete-item md-accent-fg" md-highlight-text="vm.acSearchText[vm.record.RequiredAttributes[$index].field]">\n{{item}}</span></md-item-template><md-not-found>\nNo Record matching "{{vm.acSearchText[vm.record.RequiredAttributes[$index].field]}}" were found.</md-not-found>\n</md-autocomplete><md-chip-template><span><strong>{{$chip}}</strong></span></md-chip-template></md-chips>\n</md-input-container></div><div ng-switch-when="decimal"><md-input-container class="md-block"><input type="number" \nng-if="vm.isNew" id="dialog_input_{{$first ? \'first\' : $index}}" name="Value" \nng-model="vm.record.RequiredAttributes[$index].Value" \npattern="{{vm.record.RequiredAttributes[$index].validation.pattern}}"><input type="text" ng-if="!vm.isNew" \nid="dialog_input_{{$first ? \'first\' : $index}}" name="Value" ng-model="vm.record.RequiredAttributes[$index].Value"><div\n ng-if="vm.isNew" ng-messages="vm.record.RequiredAttributes[$index].Value.$error" role="alert" multiple="multiple"><div\n ng-message="pattern">{{vm.record.RequiredAttributes[$index].validation.messages.pattern | translate}}</div></div>\n</md-input-container></div><div ng-switch-when="tags"><label>\n{{vm.record.RequiredAttributes[$index].displayLabel | translate}}<span md-colors="{color: \'red\'}">*</span></label>\n<md-chips name="Value" id="dialog_input_{{$first ? \'first\' : $index}}" \nng-model="vm.record.RequiredAttributes[$index].Value" md-removable="true"></md-chips></div><div ng-switch-default>\n<md-input-container class="md-block"><input id="dialog_input_{{$first ? \'first\' : $index}}" name="Value" \nng-model="vm.record.RequiredAttributes[$index].Value"></md-input-container></div></div></div></div></fieldset></div>\n<div flex="100" flex-gt-xs="100" class="p-5 lookup-element"><fieldset><legend class="header-non-editable-attributes" \ntranslate>ARTICLE_STATES.FIELDS.NON_EDITABLE_ATTRIBUTES</legend><div \nng-repeat="record in vm.record.NonEditableAttributes" flex="100" layout="row" layout-wrap><div flex="100" \nflex-gt-xs="50" class="p-5"><md-autocomplete id="dialog_input_{{$index}}" md-input-name="AttributeId" \nmd-selected-item="vm.lookupModel[$index].AttributeId" \nmd-items="item in vm.lookupSearch(vm.searchText[$index].AttributeId, \'AttributeId\', \'lists.seasonlessModelAndArticleLevelAttributesList\')" \nmd-search-text="vm.searchText[$index].AttributeId" \nmd-item-text="vm.getLookupDisplayValue(item, \'NonEditableAttributes\', \'lists.seasonlessModelAndArticleLevelAttributesList\')" \nmd-min-length="0" md-floating-label="{{\'ARTICLES_BLOCKING.FIELDS.ATTRIBUTE_ID\' | translate}}" md-no-cache="true" \ntx-clear-autocomplete ng-click="vm.selectText($event)" \nmd-selected-item-change="vm.lookupChange(vm.lookupModel[$index].AttributeId, \'AttributeId\', $index)" \nmd-menu-class="autocomplete-custom" ng-required="false"><md-item-template><span class="autocomplete-item md-accent-fg" \nmd-highlight-text="vm.searchText[$index].AttributeId" md-highlight-flags="i">{{item.value}}</span></md-item-template>\n<md-not-found>No Record matching "{{vm.searchText[$index].AttributeId}}" were found.</md-not-found></md-autocomplete>\n</div><div flex="100" flex-gt-xs="50" class="p-5"><md-switch \nng-model="vm.record.NonEditableAttributes[$index].AllowChangeRequest" id="dialog_input_{{$index}}" \naria-label="{{\'ARTICLE_STATES.FIELDS.ALLOW_CHANGE_REQUEST\' | translate}}" ng-true-value="1" ng-false-value="0" \nclass="md-accent">{{\'ARTICLE_STATES.FIELDS.ALLOW_CHANGE_REQUEST\' | translate}}<md-tooltip md-direction="right">\n{{vm.record.NonEditableAttributes[$index].AllowChangeRequest === 1 ? \'PARTS.YES\' : \'PARTS.NO\' | translate}}\n</md-tooltip></md-switch></div></div></fieldset></div></div></md-dialog-content><md-dialog-actions layout="row" \nlayout-align="end center"><div></div><div layout="row" layout-align="end center"><md-button \nng-click="vm.closeDialog(vm.isDataDirty)" class="send-button md-primary md-raised" aria-label="Cancel" \ntranslate="ACTIONS.DIALOG_CANCEL" translate-attr-aria-label="ACTIONS.DIALOG_CANCEL" \nng-disabled="vm.isLoading || vm.isLookupLoading">CANCEL</md-button><md-button ng-click="vm.saveRecord()" \nclass="send-button md-accent md-raised" aria-label="Save" translate="ACTIONS.SAVE" \ntranslate-attr-aria-label="ACTIONS.SAVE" ng-disabled="vm.isLoading || vm.isLookupLoading || vm.editForm.$invalid">SAVE\n</md-button></div></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/attributes/attribute-groups/details/attribute-group-details.html','<div id="attribute-group" class="page-layout simple tabbed details-view" layout="column"><div class="content"><md-tabs \nmd-dynamic-height md-selected="vm.tabIndex" md-no-ink><md-tab \nlabel="{{\'ATTRIBUTE_GROUPS.TABS.ATTRIBUTE_GROUP\' | translate}}" tx-access="{{::vm.model.views.privileges.details}}">\n<tx-data-details tx-height-offset="37" tx-is-active="vm.tabIndex === 0" tx-account="vm.attributeGroup" \ntx-title="vm.title" tx-model="vm.model" tx-is-loading="vm.isLoading" tx-refresh-action-event="vm.refreshRecord(false)">\n</tx-data-details></md-tab><md-tab label="{{\'ATTRIBUTE_GROUPS.TABS.ATTRIBUTES\' | translate}}" \ntx-access="{{::vm.attListModel.views.privileges.list}}"><div class="list-tab" layout="row" flex="100" layout-wrap>\n<ms-widget layout="row" flex="100"><ms-widget-front class="white-bg"><tx-data-table tx-is-active="vm.tabIndex === 1" \ntx-data="vm.attributes" tx-model="vm.attListModel" tx-view="mainList" tx-filtered-data="vm.filteredAttributes" \ntx-data-filter="global.search" tx-is-loading="vm.isLoading" \ntx-item-action-event="vm.doAttributesListItemAction(action, item)" tx-item-click-event="vm.viewAttribute(item)" \ntx-refresh-action-event="vm.refreshRecord(true, false)" tx-height-offset="16"></tx-data-table></ms-widget-front>\n</ms-widget></div></md-tab></md-tabs><md-button id="txfab" class="md-fab md-warn" ng-if="vm.tabIndex === 0" \nng-click="vm.editItem(vm.attributeGroup, $event)" aria-label="vm.model.views.mainDetails.fab.label" translate \ntx-access="{{::vm.model.views.mainDetails.fab.privilege}}"><md-icon \nmd-font-icon="{{vm.model.views.mainDetails.fab.icon}}"></md-icon></md-button></div></div>');
$templateCache.put('app/main/attributes/attribute-groups/list/attribute-groups.html','<div id="attribute-groups-list" class="page-layout carded fullwidth list-view" layout="row"><div class="center" \nlayout="column" flex><div class="content-card" layout="column" flex><tx-data-table tx-data="vm.attributeGroups" \ntx-model="vm.model" tx-view="mainList" tx-filtered-data="vm.filteredAttributeGroup" tx-data-filter="global.search" \ntx-is-loading="vm.isLoading" tx-item-action-event="vm.doItemAction(action, item)" \ntx-item-click-event="vm.viewItem(item)" tx-refresh-action-event="vm.refreshItems(true, false)"></tx-data-table>\n<md-button class="add-rec-button md-fab md-warn" ng-click="vm.addRecord($event)" \naria-label="vm.model.views.mainList.fabAction.label" translate \ntx-access="{{::vm.model.views.mainList.fabAction.privilege}}"><md-icon \nmd-font-icon="{{vm.model.views.mainList.fabAction.icon}}"></md-icon></md-button></div></div></div>');
$templateCache.put('app/main/attributes/attributes-list/details/attributes-details.html','<div id="attribute" class="page-layout simple tabbed details-view" layout="column"><div class="content"><md-tabs \nmd-dynamic-height md-selected="vm.tabIndex" md-no-ink><md-tab label="{{\'ATTRIBUTES.TABS.ATTRIBUTE\' | translate}}" \ntx-access="{{::vm.model.views.privileges.details}}"><tx-data-details tx-height-offset="37" \ntx-is-active="vm.tabIndex === 0" tx-account="vm.attribute" tx-title="vm.title" tx-model="vm.model" \ntx-is-loading="vm.isLoading" tx-refresh-action-event="vm.refreshRecord(false)"></tx-data-details></md-tab><md-tab \nlabel="{{\'ATTRIBUTES.TABS.ATTRIBUTE_GROUPS\' | translate}}" \ntx-access="{{::vm.attributeGroupsModel.views.privileges.list}}"><div class="list-tab" layout="row" flex="100" \nlayout-wrap><ms-widget layout="row" flex="100"><ms-widget-front class="white-bg"><tx-data-table \ntx-is-active="vm.tabIndex === 1" tx-data="vm.attributeGroups" tx-model="vm.attributeGroupsModel" tx-view="mainList" \ntx-filtered-data="vm.filteredAttributeGroups" tx-data-filter="global.search" \ntx-is-loading="vm.isAttributeGroupsLoading" tx-refresh-action-event="vm.refreshAttributeGroups(true, false)" \ntx-height-offset="15"></tx-data-table></ms-widget-front></ms-widget></div></md-tab></md-tabs><md-button id="txfab" \nclass="md-fab md-warn" ng-if="vm.tabIndex === 0" ng-click="vm.editItem(vm.attribute, $event)" \naria-label="vm.model.views.mainDetails.fab.label" translate tx-access="{{::vm.model.views.mainDetails.fab.privilege}}">\n<md-icon md-font-icon="{{vm.model.views.mainDetails.fab.icon}}"></md-icon></md-button></div></div>');
$templateCache.put('app/main/attributes/attributes-list/list/attributes-list.html','<div id="attributes-list" class="page-layout carded fullwidth list-view" layout="row"><div class="center" \nlayout="column" flex><div class="content-card" layout="column" flex><tx-data-table tx-data="vm.attributes" \ntx-model="vm.model" tx-view="mainList" tx-filtered-data="vm.filteredAttributes" tx-data-filter="global.search" \ntx-is-loading="vm.isLoading" tx-item-action-event="vm.doItemAction(action, item)" \ntx-item-click-event="vm.viewItem(item)" tx-refresh-action-event="vm.refreshItems(true, false)"></tx-data-table>\n<md-button class="add-rec-button md-fab md-warn" ng-click="vm.addRecord($event)" \naria-label="vm.model.views.mainList.fabAction.label" translate \ntx-access="{{::vm.model.views.mainList.fabAction.privilege}}"><md-icon \nmd-font-icon="{{vm.model.views.mainList.fabAction.icon}}"></md-icon></md-button></div></div></div>');
$templateCache.put('app/main/catalogs/sub-modules/change-logs/change-logs.html','<div id="change-logs" class="page-layout carded fullwidth list-view" layout="row"><div class="center" layout="column" \nflex><div class="content-card" layout="column" flex><tx-data-table tx-data="vm.changeLogs" tx-model="vm.model" \ntx-view="mainList" tx-filtered-data="vm.filteredChangeLogs" tx-data-filter="global.search" \ntx-is-loading="vm.isLoading" tx-item-click-event="vm.viewChanges(item)" \ntx-refresh-action-event="vm.refreshItems(true, false)" tx-support-filter-by-date="true"></tx-data-table></div></div>\n</div>');
$templateCache.put('app/main/catalogs/sub-modules/overview/overview.html','<div id="catalog-overview"><div layout="row" class="overview-header" layout-wrap layout-align="end center"><md-button \nclass="md-icon-button" aria-label="Refresh" translate-attr-aria-label="ACTIONS.REFRESH" ng-click="vm.refresh()">\n<md-icon md-font-icon="icon-refresh"></md-icon><md-tooltip><span translate="ACTIONS.REFRESH">Refresh</span>\n</md-tooltip></md-button></div><div layout="row" layout-align="center center" ng-show="vm.isLoading" \nclass="loader-container"><md-progress-circular md-mode="indeterminate" class="md-accent"></md-progress-circular></div>\n<div layout="row" layout-align="center center" ng-show="!vm.isLoading && vm.data.TotalArticles === 0" \nclass="loader-container"><div class="text-italic" translate="MESSAGES.LIST.NO_ITEMS">No items available...</div></div>\n<div id="widgets" ng-if="!vm.isLoading && vm.data.TotalArticles > 0"><div class="widget-group" layout="row" flex="100" \nlayout-wrap><ms-widget layout="column" flex="50"><ms-widget-front class="white-bg"><div \nclass="ph-16 pv-8 border-bottom widget-header" layout="row" layout-align="space-between center" layout-wrap><div \nclass="pv-8 h3" translate>OVERVIEW.ARTICLES</div></div><div layout="column" layout-align="start center" layout-wrap>\n<div class="p-16" layout="column" flex="100" flex-gt-sm="50"><nvd3 class="h-350 remove-x-lines" \nconfig="vm.charts.articles.config" options="vm.charts.articles.options" data="vm.charts.articles.data"></nvd3></div>\n</div><div class="p-16 grey-50-bg border-top" layout="row" layout-align="start center"><span \nclass="h4 secondary-text text-truncate" translate>OVERVIEW.TOTAL_ARTICLES</span> <span class="h4 ml-8">\n{{ vm.data.TotalArticles }}</span></div></ms-widget-front></ms-widget><ms-widget layout="column" flex="50">\n<ms-widget-front class="white-bg"><div class="ph-16 pv-8 border-bottom widget-header" layout="row" \nlayout-align="space-between center" layout-wrap><div class="pv-8 h3" translate>OVERVIEW.ARTICLE_STATES</div></div><div \nlayout="column" layout-align="start center" layout-wrap><div class="p-16" layout="column" flex="100" flex-gt-sm="50">\n<nvd3 class="h-350 remove-x-lines" config="vm.charts.states.config" options="vm.charts.states.options" \ndata="vm.charts.states.data"></nvd3></div></div><div class="p-16 grey-50-bg border-top" layout="row" \nlayout-align="start center"><span class="h4 secondary-text text-truncate" translate>OVERVIEW.TOTAL_ARTICLES</span> \n<span class="h4 ml-8">{{ vm.data.TotalArticles }}</span></div></ms-widget-front></ms-widget></div></div></div>');
$templateCache.put('app/main/customers/locations/details/locations-details.html','<div id="location-details" class="page-layout simple tabbed details-view" layout="column"><div class="content"><md-tabs\n md-dynamic-height md-selected="vm.tabIndex" md-no-ink><md-tab label="{{\'CUSTOMERS.TABS.LOCATION\' | translate}}" \ntx-access="{{::vm.model.views.privileges.details}}"><tx-data-details tx-height-offset="37" \ntx-is-active="vm.tabIndex === 0" tx-account="vm.location" tx-parent-id="vm.parentId" tx-title="vm.title" \ntx-model="vm.model" tx-item-actions="vm.model.views.mainDetails.itemActions" \ntx-item-action-event="vm.doItemAction(action, account)" tx-is-loading="vm.isLoading" \ntx-refresh-action-event="vm.refreshRecord(false)"></tx-data-details></md-tab></md-tabs></div></div>');
$templateCache.put('app/main/plugins-consolidation/dialogs/upload-plugin/upload-plugin.html','<md-dialog class="edit-dialog plugin-uploader" aria-label="New Plugin"><form name="vm.editForm" class="md-inline-form" \nflow-init="vm.flowInit" flow-object="$rootScope.flowObj" flow-file-added="vm.validateFile($file, $event, $flow)" \nflow-files-submitted="vm.upload()" flow-file-success="vm.onSuccessUpload($file, $message, $flow)" \nflow-name="vm.obj.flow"><md-toolbar class="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" \nlayout-align="space-between center"><span class="title" \ntranslate="{{vm.isNew ? \'TITLES.RECORD_NEW\' : \'TITLES.RECORD_EDIT\'}}">New Plugin</span><md-button \nclass="md-icon-button" ng-click="vm.closeDialog(vm.isDataDirty, true)" aria-label="Close dialog" \ntranslate-aria-label="ACTIONS.DIALOG_CLOSE"><md-icon md-font-icon="icon-close"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div layout="row" layout-wrap><div flex="100" class="p-5"><md-input-container\n class="md-block"><label>Plugin Type</label><md-select ng-model="vm.record.PluginType" required \nng-disabled="!vm.isNew"><md-option value="Consolidation">Consolidation</md-option><md-option value="Order">Order\n</md-option></md-select><div ng-messages="vm.editForm.PluginType.$error" role="alert" multiple="multiple"><div \nng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div></div></md-input-container></div><div flex="100" \nclass="p-5" flow-drop ng-if="$flow.support"><label for="flow-upload-file-id" class=""><div \nclass="file-uploader-container upload-success"><div class="upload-label" ng-if="vm.isNew && !$flow.files[0]"><div \nclass="upload-icon"><md-icon ng-style="style" md-font-icon="icon-upload" class="icon s1"></md-icon></div><div \nclass="upload-message" ng-style="style"><span>Choose a .dll file or drag it here.</span></div></div><div \nclass="uploaded-file-name"><label ng-if="!vm.isNew && !$flow.files[0]">{{ vm.record.PluginSource }}</label><label \nng-if="$flow.files[0]">{{ $flow.files[0].name }}</label></div></div></label><div class="upload-error" \nng-show="!vm.isFileValid">{{ \'Invalid file format. Only .dll files are allowed.\' }}</div><md-progress-linear \nmd-mode="determinate" class="md-accent" ng-if="($flow.isUploading() && !vm.isLoading)" \nvalue="{{$flow.progress()*100}}"></md-progress-linear></div><div ng-if="!$flow.support"><span>Browser not supported!\n</span></div></div></md-dialog-content><md-dialog-actions layout="row" layout-align="end center"><div><input \ntype="file" id="flow-upload-file-id" class="ng-hide" flow-btn accept=".dll"></div><div layout="row" \nlayout-align="end center"><md-button ng-click="vm.closeDialog(vm.isDataDirty, true)" \nclass="send-button md-primary md-raised" aria-label="Cancel" translate="ACTIONS.DIALOG_CANCEL" \ntranslate-attr-aria-label="ACTIONS.DIALOG_CANCEL" ng-disabled="vm.isLoading">CANCEL</md-button><md-button \nng-click="vm.saveRecord()" class="send-button md-accent md-raised" aria-label="Save" translate="ACTIONS.SAVE" \ntranslate-attr-aria-label="ACTIONS.SAVE" \nng-disabled="vm.isLoading || vm.editForm.$invalid || (!$flow.files.length) || !vm.isFileValid || $flow.isUploading()">\nSAVE</md-button></div></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/profile/tabs/about/about.html','<div layout="row" layout-wrap><div class="about" layout="column" flex="100" flex-gt-sm="50" flex-gt-md="65"><div \nclass="profile-box info-box general md-whiteframe-1dp" layout="column"><header class="md-accent-bg"><div class="title" \ntranslate="PROFILE.TITLE">Profile</div></header><div class="content" flex layout="row" layout-wrap><div \nclass="info-line" flex="50"><div class="title" translate="PROFILE.FIRSTNAME">First Name</div><div class="info">\n{{vm.profile.FirstName}}</div></div><div class="info-line" flex="50"><div class="title" translate="PROFILE.LASTNAME">\nLast Name</div><div class="info">{{vm.profile.LastName}}</div></div><div class="info-line" flex="50"><div \nclass="title" translate="PROFILE.CITY">City</div><div class="info">{{vm.profile.City}}</div></div><div \nclass="info-line" flex="50"><div class="title" translate="PROFILE.COUNTRY">Country</div><div class="info">\n{{vm.profile.Country}}</div></div><div class="info-line" flex="50"><div class="title" layout="row"><span \nstyle="min-width:80px; width:80px" translate="PROFILE.EMAILS">Email</span></div><div class="info">{{vm.profile.Email}}\n</div></div><div class="info-line" flex="50"><div class="title" layout="row"><span style="min-width:80px; width:80px" \ntranslate="PROFILE.PHONE">Phone</span></div><div class="info">{{vm.profile.Phone}}</div></div><div class="info-line" \nflex="50"><div class="title" translate="PROFILE.ACCOUNT_NAME">Name</div><div class="info">{{vm.profile.AccountName}}\n</div></div><div class="info-line" flex="50"><div class="title" translate="PROFILE.DESIGNATION">Designation</div><div \nclass="info">{{vm.profile.Designation}}</div></div><div class="info-line" flex="50"><div class="title" \ntranslate="PROFILE.DEPARTMENT">Department</div><div class="info">{{vm.profile.Department}}</div></div><div \nclass="info-line" flex="50"><div class="title">Login Type</div><div class="info">{{vm.profile.LoginType}}</div></div>\n</div></div></div></div>');
$templateCache.put('app/main/profile/tabs/log/log-card.template.html','<div class="card-body" layout="column"><div class="p-16" layout="row" layout-align="space-between start"><div \nclass="info"><div class="title secondary-text" ng-if="card.title">{{card.title}}</div><div class="event h2" \nng-if="card.event">{{card.event}}</div><div class="record text-boxed" ng-if="card.record">{{card.record}}</div></div>\n<div class="media ml-16"><md-icon class="s48" md-font-icon="{{card.media.image.src}}"></md-icon><md-tooltip>\n{{card.media.image.alt}}</md-tooltip></div></div><md-divider></md-divider><div layout="row" flex="100" \nlayout-align="space-between center"><div class="buttons" layout-align="start center"><md-button \nng-disabled="isDefinedcard.state != undefined" class="md-primary md-icon-button log-button" aria-label="Go to" \nng-click="card.navigate(card)"><md-icon md-font-icon="icon-fast-forward"></md-icon></md-button><md-button \nng-disabled="card.resultMessage != undefined" class="md-icon-button log-button md-accent" aria-label="Details" \nng-click="card.showDetails(card)"><md-icon md-font-icon="icon-information-outline"></md-icon></md-button></div><div \nclass="status"><div class="tag" ng-if="card.result == \'RESULT.SUCCESS\'" layout="row" layout-align="start center"><div \nclass="tag-color tag-green"></div><div class="tag-label" translate>{{card.result}}</div></div><div class="tag" \nng-if="card.result != \'RESULT.SUCCESS\'" layout="row" layout-align="start center"><div class="tag-color tag-red"></div>\n<div class="tag-label" translate>{{card.result}}</div></div></div></div></div>');
$templateCache.put('app/main/profile/tabs/log/log.html','<div id="profile-log" layout-column flex ms-timeline ms-timeline-load-more="vm.logLoadNextPage()"><div \nms-timeline-item layout="column" layout-align="center center" layout-gt-md="row" layout-align-gt-md="center start" \nng-repeat="item in vm.logItems"><div class="log-card" layout="row" flex="50"><ms-card \ntemplate="\'app/main/profile/tabs/log/log-card.template.html\'" ng-model="item.card"></ms-card></div><div \nclass="log-point md-accent-bg md-whiteframe-2dp"><md-icon md-font-icon="{{item.icon}}"></md-icon></div><div \nclass="log-detail" flex="50"><div class="time">{{item.time | date:\'MMM d, y h:mm a\'}}</div><div class="event">\n{{item.event}}</div></div></div></div>');
$templateCache.put('app/main/profile/tabs/settings/settings.html','<div class="content" layout-gt-xs="row" layout-wrap><div layout="row" layout-align="start center" \nclass="slider-settings" flex flex-gt-xs="50"><md-switch class="md-accent" ng-model="vm.settings.autoLock" \nng-true-value="true" ng-false-value="false" ng-change="vm.switchAutoLock(vm.settings.autoLock)" \naria-label="{{\'PROFILE.SETTINGS_TAB.AUTO_LOCK\' | translate}}" \nng-disabled="vm.profile.AccountDetails.AccountTypeId != 1">{{\'PROFILE.SETTINGS_TAB.AUTO_LOCK\' | translate}}</md-switch>\n<md-slider-container flex="100"><md-slider class="md-accent" ng-model="vm.settings.autoLockInterval" md-discrete \nmin="2" max="60" ng-disabled="!vm.settings.autoLock" flex="85" \naria-label="{{\'PROFILE.SETTINGS_TAB.AUTO_LOCK\' | translate}}"></md-slider><md-input-container><input type="number" \nng-model="vm.settings.autoLockInterval" min="2" max="60" aria-label="{{\'PROFILE.SETTINGS_TAB.AUTO_LOCK\' | translate}}" \nng-disabled="!vm.settings.autoLock"></md-input-container></md-slider-container></div><div layout="row" \nlayout-align="start center" flex="100" flex-gt-xs="50" class="preferred-language"><label \ntranslate="PROFILE.SETTINGS_TAB.PREFERRED_LANGUAGE">Preferred Language</label><md-menu id="language-menu" \nmd-offset="0 72" md-position-mode="target-right target"><md-button class="language-button" ng-click="$mdOpenMenu()" \naria-label="Language" md-menu-origin md-menu-align-target><div layout="row" layout-align="center center"><img \nclass="flag" ng-src="assets/images/flags/{{vm.selectedLanguage.flag}}.png"> <span class="iso">\n{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width="3" id="language-menu-content">\n<md-menu-item ng-repeat="(iso, lang) in vm.languages"><md-button ng-click="vm.changeLanguage(lang)" \naria-label="{{lang.title}}" translate translate-attr-aria-label="{{lang.title}}"><span layout="row" \nlayout-align="start center"><img class="flag" ng-src="assets/images/flags/{{lang.flag}}.png"> <span \ntranslate="{{lang.translation}}">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n</div><div class="reset-buttons" layout-wrap layout-align="start center" flex="100" flex-gt-xs="50"><md-button \nclass="md-raised md-warn" ng-click="vm.resetLayout()" translate="PROFILE.SETTINGS_TAB.RESET_LAYOUT" \ntranslate-attr-aria-label="PROFILE.SETTINGS_TAB.RESET_LAYOUT">Reset Layout<md-tooltip>\n{{\'PROFILE.SETTINGS_TAB.RESET_LAYOUT_HELP\' | translate}}</md-tooltip></md-button><md-button class="md-raised md-warn" \nng-click="vm.resetFilters()" translate="PROFILE.SETTINGS_TAB.RESET_FILTERS" \ntranslate-attr-aria-label="PROFILE.SETTINGS_TAB.RESET_FILTERS">Reset My Pre-defined Filters<md-tooltip>\n{{\'PROFILE.SETTINGS_TAB.RESET_FILTERS_HELP\' | translate}}</md-tooltip></md-button><md-button class="md-raised md-warn" \nng-click="vm.resetColumns()" translate="PROFILE.SETTINGS_TAB.RESET_COLUMNS" \ntranslate-attr-aria-label="PROFILE.SETTINGS_TAB.RESET_COLUMNS">Reset My Pre-defined Columns<md-tooltip>\n{{\'PROFILE.SETTINGS_TAB.RESET_COLUMNS_HELP\' | translate}}</md-tooltip></md-button></div></div>');
$templateCache.put('app/main/vetting-lists/dialogs/create-configuration/create-configuration.html','<md-dialog class="edit-dialog" aria-label="New Configuration"><form name="vm.editForm" class="md-inline-form">\n<md-toolbar class="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" layout-align="space-between center">\n<span class="title">{{\'PARTS.CREATE\' | translate}} {{vm.model.title | translate}}</span><md-button \nclass="md-icon-button" ng-click="vm.closeDialog(vm.isDataDirty)" aria-label="Close dialog" tranlate \ntranslate-aria-label="ACTIONS.DIALOG_CLOSE"><md-icon md-font-icon="icon-close"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div layout="row" layout-wrap><div flex="100" class="p-5"><md-input-container\n class="md-block"><label translate>CONFIGURATIONS.FIELDS.NAME</label><textarea \nid="dialog_input_{{$first ? \'first\' : $index}}" name="Name" ng-model="vm.record.Name" columns="1" rows="1" \nng-required="true" md-maxlength="250" md-autofocus></textarea><div ng-messages="vm.editForm.Name.$error" role="alert" \nmultiple="multiple"><div ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div><div \nng-message="md-maxlength">{{\'VALIDATIONS.MAXLEN\' | translate}}</div></div></md-input-container></div><div flex="100" \nflex-gt-xs="50" class="p-5"><md-input-container class="md-block"><label translate>CONFIGURATIONS.FIELDS.SORTORDER\n</label><input id="dialog_input_{{$first ? \'first\' : $index}}" name="SortOrder" ng-model="vm.record.SortOrder" \ntype="number"></md-input-container></div><div flex="100" flex-gt-xs="50" class="p-5"><md-input-container \nclass="md-block"><label translate>{{\'CONFIGURATIONS.FIELDS.VALUE_TYPE\' | translate}}</label><md-select \nname="DefaultValueType" placeholder="{{\'CONFIGURATIONS.FIELDS.VALUE_TYPE\' | translate}}" \nng-model="vm.record.DefaultValueType" style="min-width: 200px" ng-required="true" \nng-change="vm.onTypeChange(vm.record.DefaultValueType)"><md-option \nng-repeat="item in vm.defaultValueTypes track by item.Id" ng-value="item.Id">{{item.value}}</md-option></md-select><div\n ng-messages="editForm.DefaultValueType.$error" role="alert" multiple="multiple"><div ng-message="required">\n{{\'VALIDATIONS.REQUIRED\' | translate}}</div></div></md-input-container></div><div \nng-if="vm.record.DefaultValueType === \'nvarchar\'" flex="100" flex-gt-xs="50" class="p-5"><md-input-container \nclass="md-block"><label>{{\'CONFIGURATIONS.FIELDS.DEFAULT_VALUE\' | translate}}</label><input \nid="dialog_input_{{$first ? \'first\' : $index}}" name="Value" ng-model="vm.record.Value" type="text" ng-required="true">\n<div ng-messages="vm.editForm.Value.$error" role="alert" multiple="multiple"><div ng-message="required">\n{{\'VALIDATIONS.REQUIRED\' | translate}}</div></div></md-input-container></div><div \nng-if="vm.record.DefaultValueType === \'int\'" flex="100" flex-gt-xs="50" class="p-5"><md-input-container \nclass="md-block"><label>{{\'CONFIGURATIONS.FIELDS.DEFAULT_VALUE\' | translate}}</label><input \nid="dialog_input_{{$first ? \'first\' : $index}}" name="Value" ng-model="vm.record.Value" type="number" \nng-required="true"><div ng-messages="vm.editForm.Value.$error" role="alert" multiple="multiple"><div \nng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div></div></md-input-container></div><div \nng-if="vm.record.DefaultValueType === \'datetime\'" flex="100" flex-gt-xs="50" class="p-5"><md-input-container \nclass="md-block"><md-datepicker id="dialog_input_{{$first ? \'first\' : $index}}" name="Value" \nng-model="vm.record.Value" md-placeholder="" ng-required="true" \naria-label="{{\'CONFIGURATIONS.FIELDS.DEFAULT_VALUE\' | translate}}"></md-datepicker></md-input-container><div \nng-messages="vm.editForm[Value].$error" role="alert" multiple="multiple"><div ng-message="required">\n{{field.validation.messages.isRequired | translate}}</div></div></div><div \nng-if="vm.record.DefaultValueType === \'bool\'" flex="100" flex-gt-xs="50" class="p-5"><md-switch \nid="dialog_input_{{$first ? \'first\' : $index}}" ng-model="vm.record.Value" \naria-label="{{\'CONFIGURATIONS.FIELDS.DEFAULT_VALUE\' | translate}}" ng-true-value="true" ng-false-value="false" \nclass="md-accent">{{\'CONFIGURATIONS.FIELDS.DEFAULT_VALUE\' | translate}}</md-switch></div><div flex="100" class="p-5">\n<md-input-container class="md-block"><label translate>CONFIGURATIONS.FIELDS.DESCRIPTION</label><textarea \nid="dialog_input_{{$first ? \'first\' : $index}}" name="Description" ng-model="vm.record.Description" type="textArea" \ncolumns="1" rows="1" ng-required="false" md-maxlength="500"></textarea><div \nng-messages="vm.editForm.Description.$error" role="alert" multiple="multiple"><div ng-message="md-maxlength">\n{{\'VALIDATIONS.MAXLEN\' | translate}}</div></div></md-input-container></div></div></md-dialog-content><md-dialog-actions\n layout="row" layout-align="end center"><div></div><div layout="row" layout-align="end center"><md-button \nng-click="vm.closeDialog(vm.isDataDirty)" class="send-button md-primary md-raised" aria-label="Cancel" \ntranslate="ACTIONS.DIALOG_CANCEL" translate-attr-aria-label="ACTIONS.DIALOG_CANCEL" ng-disabled="vm.isLoading">CANCEL\n</md-button><md-button ng-click="vm.saveRecord()" class="send-button md-accent md-raised" aria-label="Save" \ntranslate="ACTIONS.SAVE" translate-attr-aria-label="ACTIONS.SAVE" ng-disabled="vm.isLoading || vm.editForm.$invalid">\nSAVE</md-button><md-button ng-click="vm.saveRecord(true)" class="send-button md-accent md-raised" aria-label="Save" \ntranslate="ACTIONS.SAVE_AND_NEW" translate-attr-aria-label="ACTIONS.SAVE_AND_NEW" \nng-disabled="vm.isLoading || vm.editForm.$invalid">SAVE</md-button></div></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/vetting-lists/dialogs/create-privacy-policy/create-privacy-policy.html','<md-dialog class="privacy-policy-dialog" aria-label="New Privacy Policy"><form name="vm.editForm" \nclass="md-inline-form"><md-toolbar class="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" \nlayout-align="space-between center"><span class="title" ng-if="vm.isCopyPrivacyPolicy === false">\n{{\'PARTS.CREATE\' | translate}} {{vm.model.title | translate}}</span> <span class="title" \nng-if="vm.isCopyPrivacyPolicy === true">{{\'PARTS.COPY\' | translate}} {{vm.model.title | translate}}</span><md-button \nclass="md-icon-button" ng-click="vm.closeDialog(vm.isDataDirty)" aria-label="Close dialog" tranlate \ntranslate-aria-label="ACTIONS.DIALOG_CLOSE"><md-icon md-font-icon="icon-close"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div class="div" layout="column" ng-hide="vm.loadingContent"><div \nclass="p-5"><md-input-container class="md-block"><label translate>PRIVACY_POLICY.FIELDS.TITLE</label><input \nid="dialog_input_first" name="Title" ng-model="vm.record.Title" type="text" ng-required="true" md-maxlength="250" \nmd-autofocus><div ng-messages="vm.editForm.Title.$error" role="alert" multiple="multiple"><div ng-message="required">\n{{\'VALIDATIONS.REQUIRED\' | translate}}</div><div ng-message="md-maxlength">{{\'VALIDATIONS.MAXLEN\' | translate}}</div>\n</div></md-input-container></div><div flex class="p-5"><label translate>PRIVACY_POLICY.FIELDS.CONTENT</label>\n<ng-quill-editor class="ng-quill-editor" ng-required="true" name="Content" ng-model="vm.record.Content">\n</ng-quill-editor><div ng-messages="vm.editForm.Content.$error" ng-show="vm.editForm.Content.$touched" role="alert" \nmultiple="multiple" class="error-message" \nng-class="{\'display-error\': vm.editForm.Content.$error.required && vm.editForm.Content.$touched}"><div \nng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div></div></div></div><div ng-show="vm.loadingContent" \nstyle="height: 100%" layout="row" layout-align="center center" flex="100"><md-progress-circular \nmd-mode="indeterminate" aria-label="Processing" class="md-accent"></div></md-dialog-content><md-dialog-actions \nlayout="row" layout-align="end center"><div></div><div layout="row" layout-align="end center"><md-button \nng-click="vm.closeDialog(vm.isDataDirty)" class="send-button md-primary md-raised" aria-label="Cancel" \ntranslate="ACTIONS.DIALOG_CANCEL" translate-attr-aria-label="ACTIONS.DIALOG_CANCEL" ng-disabled="vm.isLoading">CANCEL\n</md-button><md-button ng-click="vm.saveRecord()" class="send-button md-accent md-raised" aria-label="Save" \ntranslate="ACTIONS.SAVE" translate-attr-aria-label="ACTIONS.SAVE" ng-disabled="vm.isLoading || vm.editForm.$invalid">\nSAVE</md-button></div></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/vetting-lists/dialogs/create-resource-types/create-resource-types.html','<md-dialog class="edit-dialog" aria-label="New Resource Type"><form name="vm.editForm" class="md-inline-form">\n<md-toolbar class="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" layout-align="space-between center">\n<span class="title">{{vm.isNew ? \'PARTS.CREATE\' : \'PARTS.EDIT\' | translate}} {{vm.model.title | translate}}</span>\n<md-button class="md-icon-button" ng-click="vm.closeDialog(vm.isDataDirty)" aria-label="Close dialog" tranlate \ntranslate-aria-label="ACTIONS.DIALOG_CLOSE"><md-icon md-font-icon="icon-close"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div layout="row" layout-wrap><div flex="100" flex-gt-xs="50" class="p-5">\n<md-input-container class="md-block"><label translate>RESOURCE_TYPES.FIELDS.TYPE</label><input \nid="resources_input_first" name="Type" ng-model="vm.record.Type" type="text" ng-required="true" md-maxlength="200" \nmd-autofocus tx-unique-value="vm.existingRecords:Type: true"><div ng-messages="vm.editForm.Type.$error" role="alert" \nmultiple="multiple"><div ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div><div \nng-message="md-maxlength">{{\'VALIDATIONS.MAXLEN\' | translate}}</div><div ng-message="tx-unique-value">\n{{\'VALIDATIONS.NOT_UNIQUE\' | translate}}</div></div></md-input-container></div><div flex="100" \nclass="p-5 lookup-element"><md-input-container class="md-block"><label>\n{{\'RESOURCE_TYPES.FIELDS.ALLOWED_FILE_TYPES\' | translate}}<span md-colors="{color: \'red\'}">*</span></label><md-chips \nname="AllowedFileTypes" ng-model="vm.record.AllowedFileTypes" md-autocomplete-snap \nmd-transform-chip="vm.transformChip($chip)" md-require-match="true" ng-required="true"><md-autocomplete \nmd-selected-item="vm.acSelectedItem.AllowedFileTypes" md-search-text="vm.acSearchText.AllowedFileTypes" \nmd-items="item in vm.allowedFileTypesQuerySearch(vm.acSearchText.AllowedFileTypes, vm.record.AllowedFileTypes)" \nmd-item-text="item" md-min-length="0" md-no-cache="true" md-menu-class="autocomplete-custom"><md-item-template><span \nclass="autocomplete-item md-accent-fg" md-highlight-text="vm.acSearchText.AllowedFileTypes">{{item}}</span>\n</md-item-template></md-autocomplete><md-chip-template><span><strong>{{$chip}}</strong></span></md-chip-template>\n</md-chips><div class="md-chips-messages" ng-messages="vm.editForm.AllowedFileTypes.$error" \nng-show="vm.editForm.AllowedFileTypes.$dirty || vm.editForm.AllowedFileTypes.$submitted"><div ng-message="required">\n{{ \'VALIDATIONS.REQUIRED\' | translate}}</div></div></md-input-container></div><div flex="100" flex-gt-xs="50" \nclass="p-5"><label for="icon"><br><span>Click below to upload icon</span><br><img style="width:80px; cursor:pointer" \nsrc="http://goo.gl/pB9rpQ"></label><input id="icon" name="Icon" type="file" accept="image/*" style="display:none">\n</div><div flex="100" flex-gt-xs="50" class="p-5"><md-switch ng-model="vm.record.VisibleInResourcesList" \naria-label="{{\'RESOURCE_TYPES.FIELDS.VISIBLE_IN_RESOURCE_LIST\' | translate}}" ng-true-value="1" ng-false-value="0" \nclass="md-accent">{{\'RESOURCE_TYPES.FIELDS.VISIBLE_IN_RESOURCE_LIST\' | translate}}<md-tooltip md-direction="right">\n{{vm.record.VisibleInResourcesList === 1 ? \'PARTS.YES\' : \'PARTS.NO\' | translate}}</md-tooltip></md-switch></div></div>\n</md-dialog-content><md-dialog-actions layout="row" layout-align="end center"><div></div><div layout="row" \nlayout-align="end center"><md-button ng-click="vm.closeDialog(vm.isDataDirty)" \nclass="send-button md-primary md-raised" aria-label="Cancel" translate="ACTIONS.DIALOG_CANCEL" \ntranslate-attr-aria-label="ACTIONS.DIALOG_CANCEL" ng-disabled="vm.isLoading">CANCEL</md-button><md-button \nng-click="vm.saveRecord()" class="send-button md-accent md-raised" aria-label="Save" translate="ACTIONS.SAVE" \ntranslate-attr-aria-label="ACTIONS.SAVE" ng-disabled="vm.isLoading || vm.editForm.$invalid">SAVE</md-button><md-button \nng-click="vm.saveRecord(true)" class="send-button md-accent md-raised" aria-label="Save" ng-if="vm.isNew" \ntranslate="ACTIONS.SAVE_AND_NEW" translate-attr-aria-label="ACTIONS.SAVE_AND_NEW" \nng-disabled="vm.isLoading || vm.editForm.$invalid">SAVE</md-button></div></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/core/directives/ms-card/templates/template-1/template-1.html','<div class="template-1"><div class="media"><img class="image" ng-src="{{card.media.image.src}}" \nalt="{{card.media.image.alt}}" ng-show="card.media.image"></div><div class="content pv-24 ph-16"><div class="title h1" \nng-if="card.title">{{card.title}}</div><div class="subtitle secondary-text" ng-if="card.subtitle">{{card.subtitle}}\n</div><div class="text pt-16" ng-if="card.text">{{card.text}}</div></div></div>');
$templateCache.put('app/core/directives/ms-card/templates/template-10/template-10.html','<div class="template-10 p-16"><div class="pb-16" layout="row" layout-align="space-between center"><div class="info">\n<div class="title secondary-text" ng-if="card.title">{{card.title}}</div><div class="subtitle h2" \nng-if="card.subtitle">{{card.subtitle}}</div></div><div class="media ml-16"><img class="image" \nng-src="{{card.media.image.src}}" alt="{{card.media.image.alt}}" ng-show="card.media.image"></div></div><div \nclass="text">{{card.text}}</div></div>');
$templateCache.put('app/core/directives/ms-card/templates/template-2/template-2.html','<div class="template-2"><div class="header p-16" layout="row" layout-align="start center"><div ng-if="card.avatar"><img\n class="avatar mr-16" ng-src="{{card.avatar.src}}" alt="{{card.avatar.alt}}"></div><div class="info"><div \nclass="title" ng-if="card.title">{{card.title}}</div><div class="subtitle secondary-text" ng-if="card.subtitle">\n{{card.subtitle}}</div></div></div><div class="media"><img class="image" ng-src="{{card.media.image.src}}" \nalt="{{card.media.image.alt}}" ng-show="card.media.image"></div><div class="text p-16" ng-if="card.text">{{card.text}}\n</div></div>');
$templateCache.put('app/core/directives/ms-card/templates/template-3/template-3.html','<div class="template-3 p-16 teal-bg white-fg" layout="row" layout-align="space-between"><div layout="column" \nlayout-align="space-between"><div class="info"><div class="title h1" ng-if="card.title">{{card.title}}</div><div \nclass="subtitle h3 secondary-text" ng-if="card.subtitle">{{card.subtitle}}</div></div><div class="cta"><md-button \nclass="m-0">{{card.cta}}</md-button></div></div><div class="media pl-16"><img class="image" \nng-src="{{card.media.image.src}}" alt="{{card.media.image.alt}}" ng-show="card.media.image"></div></div>');
$templateCache.put('app/core/directives/ms-card/templates/template-4/template-4.html','<div class="template-4"><div class="info white-fg ph-16 pv-24"><div class="title h1" ng-if="card.title">{{card.title}}\n</div><div class="text" ng-if="card.text">{{card.text}}</div></div><div class="media"><img class="image" \nng-src="{{card.media.image.src}}" alt="{{card.media.image.alt}}" ng-show="card.media.image"></div></div>');
$templateCache.put('app/core/directives/ms-card/templates/template-5/template-5.html','<div class="template-5 p-16" layout="row" layout-align="space-between start"><div class="info"><div \nclass="title secondary-text" ng-if="card.title">{{card.title}}</div><div class="event h2" ng-if="card.event">\n{{card.event}}</div></div><div class="media ml-16"><img class="image" ng-src="{{card.media.image.src}}" \nalt="{{card.media.image.alt}}" ng-show="card.media.image"></div></div>');
$templateCache.put('app/core/directives/ms-card/templates/template-6/template-6.html','<div class="template-6"><div class="content pv-24 ph-16"><div class="subtitle secondary-text" ng-if="card.subtitle">\n{{card.subtitle}}</div><div class="title h2" ng-if="card.title">{{card.title}}</div><div class="text pt-8" \nng-if="card.text">{{card.text}}</div></div></div>');
$templateCache.put('app/core/directives/ms-card/templates/template-7/template-7.html','<div class="template-7" layout="row" layout-align="space-between"><div class="info" layout="column" \nlayout-align="space-between" layout-fill flex><div class="p-16"><div class="title h1" ng-if="card.title">{{card.title}}\n</div><div class="subtitle h4 secondary-text" ng-if="card.subtitle">{{card.subtitle}}</div><div class="text h4 pt-8" \nng-if="card.text">{{card.text}}</div></div><div><md-divider></md-divider><div class="p-8" layout="row"><md-icon \nmd-font-icon="icon-star-outline" class="mh-5"></md-icon><md-icon md-font-icon="icon-star-outline" class="mh-5">\n</md-icon><md-icon md-font-icon="icon-star-outline" class="mh-5"></md-icon><md-icon md-font-icon="icon-star-outline" \nclass="mh-5"></md-icon><md-icon md-font-icon="icon-star-outline" class="mh-5"></md-icon></div></div></div><div \nclass="media"><img class="image" ng-src="{{card.media.image.src}}" alt="{{card.media.image.alt}}" \nng-show="card.media.image"></div></div>');
$templateCache.put('app/core/directives/ms-card/templates/template-8/template-8.html','<div class="template-8"><div class="media"><img class="image" ng-src="{{card.media.image.src}}" \nalt="{{card.media.image.alt}}" ng-show="card.media.image"></div><div class="content pv-24 ph-16"><div class="title h1" \nng-if="card.title">{{card.title}}</div><div class="subtitle secondary-text" ng-if="card.subtitle">{{card.subtitle}}\n</div><div class="buttons pt-16"><md-button class="m-0">{{card.button1}}</md-button><md-button class="m-0 md-accent">\n{{card.button2}}</md-button></div><div class="text pt-16" ng-if="card.text">{{card.text}}</div></div></div>');
$templateCache.put('app/core/directives/ms-card/templates/template-9/template-9.html','<div class="template-9"><div class="header p-16" layout="row" layout-align="start center"><div ng-if="card.avatar"><img\n class="avatar mr-16" ng-src="{{card.avatar.src}}" alt="{{card.avatar.alt}}"></div><div class="info"><div \nclass="title" ng-if="card.title">{{card.title}}</div><div class="subtitle secondary-text" ng-if="card.subtitle">\n{{card.subtitle}}</div></div></div><div class="text ph-16 pb-16" ng-if="card.text">{{card.text}}</div><div \nclass="media"><img class="image" ng-src="{{card.media.image.src}}" alt="{{card.media.image.alt}}" \nng-show="card.media.image"></div><div class="buttons m-8"><md-button class="md-icon-button mr-16" \naria-label="Favorite"><md-icon md-font-icon="icon-heart-outline" class="s24"></md-icon></md-button><md-button \nclass="md-icon-button" aria-label="Share"><md-icon md-font-icon="icon-share" class="s24"></md-icon></md-button></div>\n</div>');
$templateCache.put('app/core/directives/ms-stepper/templates/horizontal/horizontal.html','<div class="ms-stepper-horizontal"><div class="ms-stepper-navigation-wrapper"><div class="ms-stepper-navigation" \nlayout="row" layout-align="center center"><md-button class="ms-stepper-navigation-item" \nng-class="{\'current\': MsStepper.isStepCurrent(step.stepNumber), \'valid\': MsStepper.isStepValid(step.stepNumber), \'disabled\': MsStepper.isStepDisabled(step.stepNumber), \'optional\': MsStepper.isStepOptional(step.stepNumber)}" \nng-click="MsStepper.gotoStep(step.stepNumber)" ng-disabled="MsStepper.isStepDisabled(step.stepNumber)" \nng-repeat="step in MsStepper.steps" layout="row" layout-align="start center"><div class="step md-accent-bg" \nlayout="row" layout-align="center center"><span \nng-if="!MsStepper.isStepValid(step.stepNumber) || MsStepper.isStepOptional(step.stepNumber)">{{step.stepNumber}} \n</span><span ng-if="MsStepper.isStepValid(step.stepNumber) && !MsStepper.isStepOptional(step.stepNumber)"><i \nclass="icon icon-check s18"></i></span></div><div layout="column" layout-align="start start"><div class="title" \ntranslate="{{step.stepTitleTranslate}}">{{step.stepTitle}}</div><div class="subtitle" \nng-if="MsStepper.isStepOptional(step.stepNumber)">Optional</div></div></md-button></div></div><div \nclass="ms-stepper-steps" ng-transclude></div><div class="ms-stepper-controls" layout="row" \nlayout-align="center center"><md-button class="md-accent md-raised" ng-disabled="MsStepper.isFirstStep()" \nng-click="MsStepper.gotoPreviousStep()">Back</md-button><div class="ms-stepper-dots"><span \nng-repeat="step in MsStepper.steps" ng-class="{\'selected md-accent-bg\':MsStepper.currentStepNumber === $index + 1}">\n</span></div><md-button class="md-accent md-raised" ng-if="!MsStepper.isLastStep()" \nng-disabled="!MsStepper.isStepValid(MsStepper.currentStepNumber) || !vm.areAllRequiredColumnsMapped()" \nng-click="MsStepper.gotoNextStep()">Next</md-button><md-button type="submit" class="md-accent md-raised" \nng-click="MsStepper.resetForm()" ng-if="MsStepper.isLastStep()" ng-disabled="!MsStepper.isFormValid()">Submit\n</md-button></div></div>');
$templateCache.put('app/main/catalogs/details/tabs/tree-definition/tree-definition.html','<div layout="row" layout-align="center center" ng-show="vm.isTreeLoading"><md-progress-circular \nmd-mode="indeterminate" class="md-accent"></md-progress-circular></div><div ng-show="!vm.isTreeLoading"><div \nid="toolbar" class="toolbar" layout="row" layout-align="space-between center"><div layout="row" \nlayout-align="start center"><md-button ng-repeat="listAct in vm.treeModel.views.mainList.listActions" \nclass="md-icon-button" aria-label="{{listAct.label}}" translate-attr-aria-label="{{listAct.label}}" \nng-click="vm.doTreeListAction(listAct)" ng-show="{{listAct.visible}}" ng-disabled="{{listAct.disabled}}" \ntx-access="{{::listAct.privilege}}"><md-icon md-font-icon="{{listAct.icon}}"></md-icon><md-tooltip><span translate>\n{{listAct.label}}</span></md-tooltip></md-button><div class="divider-vertical" hide show-gt-xs></div><span \nclass="ml-16 text-boxed md-accent-bg highlight" show-gt-xs>\n{{vm.treeAttributes.length}} {{\'TREE_DEFINITION.FIELDS_SELECTED\' | translate}}</span></div><div><md-button \nclass="md-icon-button" aria-label="Refresh" translate-attr-aria-label="ACTIONS.REFRESH" \nng-click="vm.refreshTree(true, false)"><md-icon md-font-icon="icon-refresh"></md-icon><md-tooltip><span \ntranslate="ACTIONS.REFRESH">Refresh</span></md-tooltip></md-button></div></div><div layout="row" \nclass="draggable-attributes-container" ms-scrol><div data-as-sortable="vm.catalogTreeListeners" \ndata-ng-model="vm.treeUnUtilizedAttributes" class="p-8" flex="50" layout-align="center center"><div \ndata-ng-repeat="item in vm.treeUnUtilizedAttributes" data-as-sortable-item flex layout-align="center center"><div \ndata-as-sortable-item-handle class="col-chooser-item p-4">{{item.AttributeDisplayName}}</div></div></div><div \ndata-as-sortable="vm.treeListeners" data-ng-model="vm.treeAttributes" class="p-8" flex="50" \nlayout-align="center center"><div ng-show="vm.treeAttributes && vm.treeAttributes.length == 0" \nstyle="text-align: center">{{\'TREE_DEFINITION.NO_FIELDS_SELECTED\' | translate}}</div><div \ndata-ng-repeat="item in vm.treeAttributes" data-as-sortable-item flex layout-align="center center"><div \ndata-as-sortable-item-handle class="col-chooser-item p-4">{{item.AttributeDisplayName}}</div></div></div></div></div>');
$templateCache.put('app/main/catalogs/sub-modules/allocation-groups/details/allocation-groups-details.html','<div id="allocation-groups-details" class="page-layout simple tabbed details-view" layout="column"><div \nclass="content"><md-tabs md-dynamic-height md-selected="vm.tabIndex" md-no-ink><md-tab \nlabel="{{\'ALLOCATION_GROUPS.TABS.ALLOCATION_GROUP\' | translate}}" tx-access="{{::vm.model.views.privileges.details}}" \nng-disabled="!vm.allocationGroup.Status"><tx-data-details tx-height-offset="37" tx-account="vm.allocationGroup" \ntx-title="vm.title" tx-model="vm.model" tx-item-actions="vm.model.views.mainDetails.itemActions" \ntx-item-action-event="vm.doArticleItemAction(action, account)" tx-is-loading="vm.isLoading" \ntx-refresh-action-event="vm.refreshRecord(false)" tx-parent-id="vm.activeCatalog.CatalogCode"></tx-data-details>\n</md-tab><md-tab label="{{\'ALLOCATION_GROUPS.TABS.ARTICLES\' | translate}}" ng-disabled="!vm.allocationGroup.Status" \ntx-access="{{::vm.articlesModel.views.privileges.list}}"><div class="list-tab" layout="row" flex="100" layout-wrap>\n<ms-widget layout="row" flex="100"><ms-widget-front class="white-bg"><tx-data-table tx-is-active="vm.tabIndex === 1" \ntx-data="vm.articles" tx-model="vm.articlesModel" tx-view="mainList" tx-filtered-data="vm.filteredArticles" \ntx-data-filter="global.search" tx-is-loading="vm.isLoading" tx-refresh-action-event="vm.refreshRecord(false)" \ntx-item-action-event="vm.doArticlesItemAction(action, item)" tx-item-click-event="vm.viewArticleDetails(item)" \ntx-height-offset="16"></tx-data-table></ms-widget-front></ms-widget></div></md-tab></md-tabs><md-button \nclass="add-rec-button md-fab md-warn" ng-if="vm.tabIndex === 0" ng-click="vm.edit(vm.allocationGroup, $event)" \naria-label="vm.model.views.mainDetails.fab.label" translate tx-access="{{::vm.model.views.mainDetails.fab.privilege}}">\n<md-icon md-font-icon="{{vm.model.views.mainDetails.fab.icon}}"></md-icon></md-button></div></div>');
$templateCache.put('app/main/catalogs/sub-modules/allocation-groups/dialogs/update-allocation-group.html','<md-dialog class="edit-dialog" aria-label="Update allocation groups"><form name="vm.editForm" class="md-inline-form">\n<md-toolbar class="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" layout-align="space-between center">\n<span class="title" \ntranslate="{{vm.isNew ? \'ALLOCATION_GROUPS.TITLE.CREATE_ALLOCATION_GROUP\' : \'ALLOCATION_GROUPS.TITLE.UDPATE_ALLOCATION_GROUP\'}}">\n{{vm.isNew ? \'Create Allocation Group\' : \'Update Allocation Group\'}}</span><md-button class="md-icon-button" \nng-click="vm.closeDialog(vm.isDataDirty)" aria-label="Close dialog" tranlate \ntranslate-aria-label="ACTIONS.DIALOG_CLOSE"><md-icon md-font-icon="icon-close"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div layout="row" layout-wrap><div flex="100" class="p-5"><md-input-container\n class="md-block"><label>{{\'ALLOCATION_GROUPS.FIELDS.ALLOCATION_GROUP_NAME\' | translate}}</label><input \nid="dialog_input_first" name="AllocationGroupName" ng-model="vm.record.AllocationGroupName" type="text" \nng-required="true" md-autofocus="vm.isNew" ng-disabled="!vm.isNew"><div \nng-messages="vm.editForm.AllocationGroupName.$error" role="alert" multiple="multiple"><div ng-message="required">\n{{\'VALIDATIONS.REQUIRED\' | translate}}</div></div></md-input-container></div><div flex="100" flex-gt-xs="50" \nclass="p-5"><md-input-container class="md-block"><label translate="ALLOCATION_GROUPS.FIELDS.ARTICLE_NUMBER">\nArticle Number</label><textarea name="ArticleNumbers" ng-model="vm.inputValues" ng-model-options="{ debounce: 1000 }" \nng-pattern="" tx-exist-value="vm.articles|ArticleNumber|vm.catalogArticlesPromise|{\'Status\': 1}" rows="12" \nng-disabled="!vm.isNew && !vm.isAssignedArticlesLoaded" md-autofocus="!vm.isNew" ng-required="vm.isNew"> </textarea>\n<div ng-messages="vm.editForm.ArticleNumbers.$error" role="alert" multiple="multiple"><div ng-message="pattern">\n{{\'VALIDATIONS.PATTERN\' | translate}}</div><div ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div><div \nng-message="tx-exist-value" translate="ALLOCATION_GROUPS.MESSAGES.TX_EXIST_DATA_ERROR">Articles are not available</div>\n</div></md-input-container><div layout="row" ng-show="vm.editForm.ArticleNumbers.$pending[\'tx-exist-value\']">\n<md-progress-circular class="md-hue-2" md-diameter="20px"></md-progress-circular><span \ntranslate="ALLOCATION_GROUPS.MESSAGES.TX_EXIST_LOADING_DATA" style="padding-left: 10px">\nLooking into database to validate provided data</span></div></div><div flex="100" flex-gt-xs="50" class="p-5" \nng-if="vm.containInvalidRecords"><md-input-container class="md-block"><label \ntranslate="ALLOCATION_GROUPS.FIELDS.INVALID_ARTICLE_NUMBER">Invalid Article Number(s) (won\'t be assigned)</label>\n<textarea ng-model="vm.invalidDataString" rows="12" ng-disabled="!vm.isNew && !vm.isAssignedArticlesLoaded"></textarea>\n</md-input-container></div></div></md-dialog-content><md-dialog-actions layout="row" layout-align="end center"><div>\n</div><div layout="row" layout-align="end center"><md-button ng-click="vm.closeDialog(vm.isDataDirty)" \nclass="send-button md-primary md-raised" aria-label="Cancel" translate="ACTIONS.DIALOG_CANCEL" \ntranslate-attr-aria-label="ACTIONS.DIALOG_CANCEL" ng-disabled="vm.isLoading">CANCEL</md-button><md-button \nng-click="vm.saveRecord()" class="send-button md-accent md-raised" aria-label="Save" translate="ACTIONS.SAVE" \ntranslate-attr-aria-label="ACTIONS.SAVE" \nng-disabled="vm.isLoading || vm.editForm.$invalid  || (!vm.isNew && !vm.isAssignedArticlesLoaded)">SAVE</md-button>\n<md-button ng-click="vm.saveRecord(true)" class="send-button md-accent md-raised" aria-label="Save" \ntranslate="ACTIONS.SAVE_AND_NEW" translate-attr-aria-label="ACTIONS.SAVE_AND_NEW" \nng-disabled="vm.isLoading || vm.editForm.$invalid  || (!vm.isNew && !vm.isAssignedArticlesLoaded)" ng-show="vm.isNew">\nSAVE</md-button></div></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/catalogs/sub-modules/allocation-groups/list/allocation-groups-list.html','<div id="allocation-group-list" class="page-layout carded fullwidth list-view" layout="row"><div class="center" \nlayout="column" flex><div class="content-card" layout="column" flex><tx-data-table tx-data="vm.allocationGroups" \ntx-model="vm.model" tx-view="mainList" tx-filtered-data="vm.filteredAllocationGroups" tx-data-filter="global.search" \ntx-is-loading="vm.isLoading" tx-item-action-event="vm.doItemAction(action, item)" \ntx-list-action-event="vm.doListAction(action, selectedItems)" tx-item-click-event="vm.viewItem(item)" \ntx-refresh-action-event="vm.refreshItems(true, false)"></tx-data-table><md-button \nclass="add-rec-button md-fab md-warn" ng-click="vm.addRecord($event)" \naria-label="vm.model.views.mainList.fabAction.label" translate \ntx-access="{{::vm.model.views.mainList.fabAction.privilege}}"><md-icon \nmd-font-icon="{{vm.model.views.mainList.fabAction.icon}}"></md-icon></md-button></div></div></div>');
$templateCache.put('app/main/catalogs/sub-modules/article-change-logs/list/article-change-logs-list.html','<div id="change-logs" class="page-layout carded fullwidth list-view" layout="row"><div class="center" layout="column" \nflex><div class="content-card" layout="column" flex><tx-data-table tx-data="vm.changeLogs" tx-model="vm.model" \ntx-view="mainList" tx-filtered-data="vm.filteredChangeLogs" tx-data-filter="global.search" \ntx-is-loading="vm.isLoading" tx-refresh-action-event="vm.refreshItems(true, false)" tx-support-filter-by-date="true">\n</tx-data-table></div></div></div>');
$templateCache.put('app/main/catalogs/sub-modules/article-color/list/article-color-list.html','<div id="article-color-list" class="page-layout carded fullwidth list-view" layout="row"><div class="center" \nlayout="column" flex><div class="content-card" layout="column" flex><tx-data-table tx-data="vm.articleColorList" \ntx-model="vm.model" tx-view="mainList" tx-filtered-data="vm.filteredArticleColorList" tx-data-filter="global.search" \ntx-is-loading="vm.isLoading" tx-item-action-event="vm.doItemAction(action, item)" \ntx-list-action-event="vm.doListAction(action, selectedItems)" tx-item-click-event="vm.viewItem(item)" \ntx-refresh-action-event="vm.refreshItems(true, false)"></tx-data-table><md-button \nclass="add-rec-button md-fab md-warn" ng-click="vm.addRecord($event)" \naria-label="vm.model.views.mainList.fabAction.label" translate \ntx-access="{{::vm.model.views.mainList.fabAction.privilege}}"><md-icon \nmd-font-icon="{{vm.model.views.mainList.fabAction.icon}}"></md-icon></md-button></div></div></div>');
$templateCache.put('app/main/catalogs/sub-modules/article-watch-filters/details/article-watch-filters-details.html','<div id="watch-filter-details" class="page-layout simple tabbed details-view" layout="column"><div class="content">\n<md-tabs md-dynamic-height md-selected="vm.tabIndex" md-no-ink><md-tab \nlabel="{{\'WATCH_FILTERS.TABS.WATCH_FILTER\' | translate}}" tx-access="{{::vm.model.views.privileges.details}}">\n<tx-data-details tx-height-offset="37" tx-is-active="vm.tabIndex === 0" tx-account="vm.watchFilter" \ntx-title="vm.title" tx-model="vm.model" tx-is-loading="vm.isLoading" tx-refresh-action-event="vm.refreshRecord(false)">\n</tx-data-details></md-tab></md-tabs></div></div>');
$templateCache.put('app/main/catalogs/sub-modules/article-watch-filters/list/article-watch-filters-list.html','<div id="watch-filters-list" class="page-layout carded fullwidth list-view" layout="row"><div class="center" \nlayout="column" flex><div class="content-card" layout="column" flex><tx-data-table tx-data="vm.watchFilters" \ntx-model="vm.model" tx-view="mainList" tx-filtered-data="vm.filteredWatchFilters" tx-data-filter="global.search" \ntx-is-loading="vm.isLoading" tx-item-action-event="vm.doItemAction(action, item)" \ntx-list-action-event="vm.doListAction(action, selectedItems)" tx-item-click-event="vm.viewItem(item)" \ntx-refresh-action-event="vm.refreshItems(true, false)"></tx-data-table><md-button \nclass="add-rec-button md-fab md-warn" ng-click="vm.addRecord($event)" \naria-label="vm.model.views.mainList.fabAction.label" translate \ntx-access="{{::vm.model.views.mainList.fabAction.privilege}}"><md-icon \nmd-font-icon="{{vm.model.views.mainList.fabAction.icon}}"></md-icon></md-button></div></div></div>');
$templateCache.put('app/main/catalogs/sub-modules/articles/details/articles-details.html','<div id="articles-details" class="page-layout simple tabbed details-view" layout="column"><div class="content"><md-tabs\n md-dynamic-height md-selected="vm.tabIndex" md-no-ink><md-tab label="{{\'ARTICLES.TABS.ARTICLE\' | translate}}" \ntx-access="{{::vm.model.views.privileges.details}}"><tx-data-details tx-height-offset="37" tx-account="vm.article" \ntx-title="vm.title" tx-model="vm.model" tx-item-actions="vm.model.views.mainDetails.itemActions" \ntx-item-action-event="vm.doArticleItemAction(action, account)" tx-is-loading="vm.isLoading" \ntx-refresh-action-event="vm.refreshRecord(false)" tx-parent-id="vm.activeCatalog.CatalogCode" \ntx-refresh-record-button="true"></tx-data-details></md-tab><md-tab label="{{\'ARTICLES.TABS.CRDS\' | translate}}" \ntx-access="{{::vm.CRDModel.views.privileges.list}}"><div class="list-tab" layout="row" flex="100" layout-wrap>\n<ms-widget layout="row" flex="100"><ms-widget-front class="white-bg"><tx-data-table tx-is-active="vm.tabIndex === 1" \ntx-data="vm.articleCRDs" tx-model="vm.CRDModel" tx-view="mainList" tx-filtered-data="vm.filteredArticleCRDs" \ntx-data-filter="global.search" tx-is-loading="vm.isCRDLoading" tx-item-action-event="vm.doCRDItemAction(action, item)" \ntx-list-action-event="vm.doCRDsListAction(action, selectedItems)" \ntx-refresh-action-event="vm.refreshCRDs(true, false)" tx-height-offset="16" tx-control="vm.tableCrdControl">\n</tx-data-table></ms-widget-front></ms-widget><md-button class="add-rec-button md-fab md-warn" \nng-click="vm.addCRD($event)" aria-label="vm.CRDModel.views.mainList.fabAction.label" translate \ntx-access="{{::vm.CRDModel.views.mainList.fabAction.privilege}}"><md-icon \nmd-font-icon="{{vm.CRDModel.views.mainList.fabAction.icon}}"></md-icon></md-button></div></md-tab><md-tab \nlabel="{{\'ARTICLES.TABS.RESOURCES\' | translate}}" ng-disabled="!vm.article.Status" \ntx-access="{{::vm.resourcesModel.views.privileges.list}}"><div class="list-tab" layout="row" flex="100" layout-wrap>\n<ms-widget layout="row" flex="100"><ms-widget-front class="white-bg"><tx-data-table tx-is-active="vm.tabIndex === 2" \ntx-data="vm.articleResources" tx-model="vm.resourcesModel" tx-view="mainList" \ntx-filtered-data="vm.filteredArticleResources" tx-data-filter="global.search" tx-is-loading="vm.isResourceLoading" \ntx-item-action-event="vm.doResourcesItemAction(action, item)" \ntx-list-action-event="vm.doResourcesListAction(action, selectedItems)" tx-item-click-event="vm.viewResource(item)" \ntx-refresh-action-event="vm.refreshResources(true, false)" tx-height-offset="16"></tx-data-table></ms-widget-front>\n</ms-widget><md-button class="add-rec-button md-fab md-warn" ng-click="vm.addResource($event)" \naria-label="vm.resourcesModel.views.mainList.fabAction.label" translate \ntx-access="{{::vm.resourcesModel.views.mainList.fabAction.privilege}}"><md-icon \nmd-font-icon="{{vm.resourcesModel.views.mainList.fabAction.icon}}"></md-icon></md-button></div></md-tab><md-tab \nlabel="{{\'ARTICLES.TABS.IMAGES\' | translate}}" ng-disabled="!vm.article.Status" \ntx-access="{{::vm.imagesModel.views.privileges.list}}"><div class="list-tab" layout="row" flex="100" layout-wrap>\n<ms-widget layout="row" flex="100"><ms-widget-front class="white-bg"><tx-data-table tx-is-active="vm.tabIndex === 3" \ntx-data="vm.articleImages" tx-model="vm.imagesModel" tx-view="mainList" tx-filtered-data="vm.filteredArticleImages" \ntx-data-filter="global.search" tx-is-loading="vm.isImageLoading" tx-support-images-view="true" \ntx-dune-images-view="true" tx-item-action-event="vm.doImagesItemAction(action, item)" \ntx-list-action-event="vm.doImagesListAction(action, selectedItems)" tx-item-click-event="vm.viewImage(item)" \ntx-refresh-action-event="vm.refreshImages(true, false)" tx-height-offset="16" tx-control="vm.tableControl">\n</tx-data-table></ms-widget-front></ms-widget><md-button class="add-rec-button md-fab md-warn" \nng-show="{{::vm.model.views.mainList.fabAction.visible}}" ng-click="vm.addImage($event)" \naria-label="vm.imagesModel.views.mainList.fabAction.label" translate \ntx-access="{{::vm.imagesModel.views.mainList.fabAction.privilege}}"><md-icon \nmd-font-icon="{{vm.imagesModel.views.mainList.fabAction.icon}}"></md-icon></md-button></div></md-tab><md-tab \nlabel="{{\'ARTICLES.TABS.SIZES\' | translate}}" tx-access="{{::vm.sizesModel.views.privileges.list}}"><div \nclass="list-tab" layout="row" flex="100" layout-wrap><ms-widget layout="row" flex="100"><ms-widget-front \nclass="white-bg"><tx-data-table tx-is-active="vm.tabIndex === 4" tx-data="vm.articleSizes" tx-model="vm.sizesModel" \ntx-view="mainList" tx-filtered-data="vm.filteredArticleSizes" tx-data-filter="global.search" \ntx-is-loading="vm.isSizeLoading" tx-item-action-event="vm.doSizesItemAction(action, item, additionalInfo)" \ntx-list-action-event="vm.doSizesListAction(action, selectedItems, additionalInfo)" \ntx-refresh-action-event="vm.refreshSizes(true, false)" tx-height-offset="16" tx-control="vm.tableSizesControl">\n</tx-data-table></ms-widget-front></ms-widget><md-button class="add-rec-button md-fab md-warn" \nng-click="vm.addSize($event)" aria-label="vm.sizesModel.views.mainList.fabAction.label" translate \ntx-access="{{::vm.sizesModel.views.mainList.fabAction.privilege}}" \nng-if="vm.sizesModel.views.mainList.fabAction.visible"><md-icon \nmd-font-icon="{{vm.sizesModel.views.mainList.fabAction.icon}}"></md-icon></md-button></div></md-tab><md-tab \nlabel="{{\'ARTICLES.TABS.PRICES\' | translate}}" ng-disabled="!vm.article.Status" \ntx-access="{{::vm.pricesModel.views.privileges.list}}"><div class="list-tab" layout="row" flex="100" layout-wrap>\n<ms-widget layout="row" flex="100"><ms-widget-front class="white-bg"><tx-data-table tx-is-active="vm.tabIndex === 5" \ntx-data="vm.articlePrices" tx-model="vm.pricesModel" tx-view="mainList" tx-filtered-data="vm.filteredArticlePrices" \ntx-data-filter="global.search" tx-is-loading="vm.isPriceLoading" \ntx-item-action-event="vm.doPricesItemAction(action, item)" \ntx-list-action-event="vm.doPricesListAction(action, selectedItems)" \ntx-refresh-action-event="vm.refreshPrices(true, false)" tx-height-offset="16" tx-control="vm.tablePricesControl">\n</tx-data-table></ms-widget-front></ms-widget><md-button class="add-rec-button md-fab md-warn" \nng-show="vm.pricesModel.views.mainList.fabAction.visible && !(vm.activeCatalog.ArticleLocking === 1 && vm.article.Locked)" \nng-click="vm.addPrice($event)" aria-label="vm.pricesModel.views.mainList.fabAction.label" translate \ntx-access="{{::vm.pricesModel.views.mainList.fabAction.privilege}}"><md-icon \nmd-font-icon="{{vm.pricesModel.views.mainList.fabAction.icon}}"></md-icon></md-button></div></md-tab><md-tab \nlabel="{{\'ARTICLES.TABS.SEGMENTATION\' | translate}}" ng-disabled="!vm.article.Status" \ntx-access="{{::vm.segmentationModelCopy.views.privileges.list}}"><div class="list-tab" layout="row" flex="100" \nlayout-wrap><ms-widget layout="row" flex="100"><ms-widget-front class="white-bg"><tx-data-table \ntx-is-active="vm.tabIndex === 6" tx-data="vm.articleSegmentation" tx-model="vm.segmentationModelCopy" \ntx-view="mainList" tx-filtered-data="vm.filteredArticleSegmentation" tx-data-filter="global.search" \ntx-is-loading="vm.isSegmentationLoading" tx-item-action-event="vm.doSegmentationItemAction(action, item)" \ntx-list-action-event="vm.doSegmentationListAction(action, selectedItems)" \ntx-refresh-action-event="vm.refreshSegmentations(true, false)" tx-height-offset="16" \ntx-control="vm.tableSegmentationsControl"></tx-data-table></ms-widget-front></ms-widget><md-button \nclass="add-rec-button md-fab md-warn" ng-show="vm.segmentationModelCopy.views.mainList.fabAction.visible" \nng-click="vm.addSegmentation($event)" aria-label="vm.segmentationModelCopy.views.mainList.fabAction.label" translate \ntx-access="{{::vm.segmentationModelCopy.views.mainList.fabAction.privilege}}"><md-icon \nmd-font-icon="{{vm.segmentationModelCopy.views.mainList.fabAction.icon}}"></md-icon></md-button></div></md-tab><md-tab \nlabel="{{\'ARTICLES.TABS.AUDIT_TRAIL_HISTORY\' | translate}}" \ntx-access="{{::vm.auditTrailHistoryModel.views.privileges.list}}" md-on-select="vm.refreshAuditTrailHistory(true)"><div\n class="list-tab" layout="row" flex="100" layout-wrap><ms-widget layout="row" flex="100"><ms-widget-front \nclass="white-bg"><div \nng-include="\'app/main/catalogs/sub-modules/articles/details/tabs/audit-trail-history/audit-trail-viewer.html\'" \nid="audit-trail-viewer"></div></ms-widget-front></ms-widget></div></md-tab><md-tab \nlabel="{{\'ARTICLES.TABS.RELATED\' | translate}}" tx-access="{{::vm.articleRelationsModel.views.privileges.list}}"><div \nclass="list-tab" layout="row" flex="100" layout-wrap><ms-widget layout="row" flex="100"><ms-widget-front \nclass="white-bg"><tx-data-table tx-is-active="vm.tabIndex === 7" tx-data="vm.articleRelations" \ntx-model="vm.articleRelationsModel" tx-view="mainList" tx-filtered-data="vm.filteredArticleRelations" \ntx-data-filter="global.search" tx-is-loading="vm.isArticleRelationsLoading" \ntx-item-action-event="vm.doArticleRelationsItemAction(action, item)" \ntx-refresh-action-event="vm.refreshArticleRelations(true, false)" tx-height-offset="16"></tx-data-table>\n</ms-widget-front></ms-widget><md-button class="add-rec-button md-fab md-warn" \nng-show="vm.articleRelationsModel.views.mainList.fabAction.visible" ng-click="vm.addArticleRelations($event)" \naria-label="vm.articleRelationsModel.views.mainList.fabAction.label" translate \ntx-access="{{::vm.articleRelationsModel.views.mainList.fabAction.privilege}}"><md-icon \nmd-font-icon="{{vm.articleRelationsModel.views.mainList.fabAction.icon}}"></md-icon></md-button></div></md-tab>\n</md-tabs><md-button id="txfab" class="md-fab md-warn" ng-if="vm.tabIndex === 0" \nng-click="vm.editArticle(vm.article, $event)" aria-label="vm.model.views.mainDetails.fab.label" translate \ntx-access="{{::vm.model.views.mainDetails.fab.privilege}}"><md-icon \nmd-font-icon="{{vm.model.views.mainDetails.fab.icon}}"></md-icon></md-button></div></div>');
$templateCache.put('app/main/catalogs/sub-modules/articles/list/articles-list.html','<div id="articles-list" class="page-layout carded fullwidth list-view" layout="row"><div class="center" \nlayout="column" flex><div class="content-card" layout="column" flex><tx-data-table tx-data="vm.articles" \ntx-model="vm.model" tx-view="mainList" tx-filtered-data="vm.filteredArticles" tx-data-filter="global.search" \ntx-is-loading="vm.isLoading" tx-support-images-view="true" tx-item-action-event="vm.doItemAction(action, item)" \ntx-list-action-event="vm.doListAction(action, selectedItems)" tx-item-click-event="vm.viewItem(item, $event)" \ntx-refresh-action-event="vm.refreshItems(true, false)" tx-control="vm.tableControl"></tx-data-table><md-fab-speed-dial \nng-if="!vm.model.isInherited" md-open="false" md-direction="up" class="add-rec-button md-scale"><md-fab-trigger>\n<md-button aria-label="menu" class="md-fab md-warn" tx-access="{{::vm.model.views.mainList.fabAction.privilege}}">\n<md-icon md-font-icon="{{::vm.model.views.mainList.fabAction.icon}}"></md-icon><md-tooltip md-direction="left"><span \ntranslate="ARTICLES.ACTIONS.MENU"></span></md-tooltip></md-button></md-fab-trigger><md-fab-actions><md-button \nng-click="vm.addRecord($event)" aria-label="New" class="md-fab md-raised md-mini md-warn"><md-icon \nmd-font-icon="icon-plus"></md-icon><md-tooltip md-direction="left"><span translate="ARTICLES.ACTIONS.NEW"></span>\n</md-tooltip></md-button><md-button ng-if="vm.isLinePLanCatalog === 1" ng-click="vm.addCompArticles($event)" \naria-label="Comp" class="md-fab md-raised md-mini md-warn"><md-icon md-font-icon="icon-equal"></md-icon><md-tooltip \nmd-direction="left"><span translate="ARTICLES.ACTIONS.COMP"></span></md-tooltip></md-button><md-button \nng-if="vm.isLinePLanCatalog === 1" ng-click="vm.addCarryOverArticles($event)" aria-label="Carryover" \nclass="md-fab md-raised md-mini md-warn"><md-icon md-font-icon="icon-redo"></md-icon><md-tooltip md-direction="left">\n<span translate="ARTICLES.ACTIONS.CARRYOVER"></span></md-tooltip></md-button><md-button \nng-if="vm.isLinePLanCatalog !== 1" ng-click="vm.assignArticlesOnMatserCatalog($event)" aria-label="Comp" \nclass="md-fab md-raised md-mini md-warn"><md-icon md-font-icon="icon-link"></md-icon><md-tooltip md-direction="left">\n<span translate="ARTICLES.ACTIONS.ASSIGN_ARTICLES"></span></md-tooltip></md-button></md-fab-actions>\n</md-fab-speed-dial></div></div></div>');
$templateCache.put('app/main/catalogs/sub-modules/articles-blocking/dialogs/affected-articles-list.html','<md-dialog aria-label="label" class="line-plan-dialog tx-dialog"><md-toolbar class="md-accent md-hue-2"><div \nclass="md-toolbar-tools" layout="row" layout-align="space-between center"><span class="title" \nng-if="vm.action === \'affectedArticles\'">{{\'AFFECTED_ARTICLES.NAV\' | translate}}</span> <span class="title" \nng-if="vm.action === \'blockedArticles\'">{{\'AFFECTED_ARTICLES.TITLES.BLOCKED_ARTICLES\' | translate}}</span><md-button \nclass="md-icon-button" ng-click="vm.closeDialog(false)" aria-label="Close dialog" tranlate \ntranslate-aria-label="ACTIONS.DIALOG_CLOSE"><md-icon md-font-icon="icon-close"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div class="page-layout carded fullwidth list-view" layout="row" \nlayout-align="start start"><div class="center" layout="column" flex><div class="content-card" layout="column" flex>\n<tx-data-table tx-data="vm.data" tx-model="vm.model" tx-view="mainList" tx-filtered-data="vm.filteredData" \ntx-data-filter="global.search" tx-is-loading="vm.isLoading" tx-chart-view-enabled="false" tx-control="vm.tableControl" \ntx-disable-selection="true" tx-disable-selection-dropdown="true"></tx-data-table></div></div></div></md-dialog-content>\n<md-dialog-actions layout="row" layout-align="end center" ng-if="vm.action === \'affectedArticles\'"><div></div><div \nlayout="row" layout-align="end center"><md-button ng-click="vm.closeDialog(false)" \nclass="send-button md-primary md-raised" aria-label="Cancel" translate="ACTIONS.DIALOG_CANCEL" \ntranslate-attr-aria-label="ACTIONS.DIALOG_CANCEL" ng-disabled="vm.isLoading">CANCEL</md-button><md-button \nng-click="vm.saveRecord()" class="send-button md-accent md-raised" aria-label="Confirm" translate="ACTIONS.CONFIRM" \ntranslate-attr-aria-label="ACTIONS.CONFIRM" ng-disabled="vm.isLoading || vm.editForm.$invalid">SAVE</md-button></div>\n</md-dialog-actions></md-dialog>');
$templateCache.put('app/main/catalogs/sub-modules/articles-blocking/dialogs/create-articles-blocking.html','<md-dialog class="edit-dialog" aria-label="{{vm.isNew ? \'New Articles Blocking\' : \'Edit Articles Blocking\'}}"><form \nname="vm.editForm" class="md-inline-form"><md-toolbar class="md-accent md-hue-2"><div class="md-toolbar-tools" \nlayout="row" layout-align="space-between center"><span class="title" \ntranslate="{{vm.isNew ? \'ARTICLES_BLOCKING.ACTIONS.NEW_ARTICLES_BLOCKING\' : \'ARTICLES_BLOCKING.ACTIONS.EDIT_ARTICLES_BLOCKING\'}}">\n</span><md-button class="md-icon-button" ng-click="vm.closeDialog(vm.isDataDirty)" aria-label="Close dialog" tranlate \ntranslate-aria-label="ACTIONS.DIALOG_CLOSE"><md-icon md-font-icon="icon-close"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div layout="row" layout-wrap><div flex="100" flex-gt-xs="50" \nclass="p-5 lookup-element"><md-autocomplete id="articles_blocking_dialog_input_1" md-input-name="AttributeId" \nmd-selected-item="vm.record.AttributeId" md-items="item in vm.lookupSearch(vm.searchText.AttributeId, \'AttributeId\')" \nmd-search-text="vm.searchText.AttributeId" md-item-text="vm.getLookupDisplayValue(item, \'AttributeId\')" \nmd-min-length="0" md-floating-label="{{\'ARTICLES_BLOCKING.FIELDS.ATTRIBUTE_ID\' | translate}}" ng-required="true" \nmd-no-cache="true" tx-clear-autocomplete tx-force-select ng-click="vm.selectText($event)" \nmd-selected-item-change="vm.lookupChange(vm.record.AttributeId, \'AttributeId\')" md-menu-class="autocomplete-custom">\n<md-item-template><span class="autocomplete-item md-accent-fg" md-highlight-text="vm.searchText.AttributeId" \nmd-highlight-flags="i">{{item.value}}</span></md-item-template><md-not-found>\nNo Record matching "{{vm.searchText.AttributeId}}" were found.</md-not-found><div \nng-messages="vm.editForm.AttributeId.$error" role="alert" ng-show="vm.editForm.AttributeId.$touched" \nmultiple="multiple"><div ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div></div></md-autocomplete>\n</div><div flex="100" flex-gt-xs="50" class="p-5" ng-if="!vm.isAttributeValueExist"><md-input-container \nclass="md-block"><label translate>ARTICLES_BLOCKING.FIELDS.ATTRIBUTE_VALUE</label><input \nid="articles_blocking_dialog_input_2" name="AttributeValue" ng-model="vm.record.AttributeValue" type="text" \nng-required="true" ng-disabled="false"><div ng-messages="vm.editForm.AttributeValue.$error" role="alert" \nmultiple="multiple"><div ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div></div></md-input-container>\n</div><div flex="100" flex-gt-xs="50" class="p-5 lookup-element" ng-if="vm.isAttributeValueExist"><md-autocomplete \nid="articles_blocking_dialog_input_3" md-input-name="AttributeValue" md-selected-item="vm.record.AttributeValue" \nmd-items="item in vm.getAttributeValues(vm.searchText.AttributeValue)" md-search-text="vm.searchText.AttributeValue" \nmd-item-text="item" md-min-length="0" md-floating-label="{{\'ARTICLES_BLOCKING.FIELDS.ATTRIBUTE_VALUE\' | translate}}" \nng-required="true" md-no-cache="true" tx-clear-autocomplete tx-force-select ng-click="vm.selectText($event)" \nmd-menu-class="autocomplete-custom"><md-item-template><span class="autocomplete-item md-accent-fg" \nmd-highlight-text="vm.searchText.AttributeValue" md-highlight-flags="i">{{item}}</span></md-item-template>\n<md-not-found>No Record matching "{{vm.searchText.AttributeValue}}" were found.</md-not-found><div \nng-messages="vm.editForm.AttributeValue.$error" role="alert" ng-show="vm.editForm.AttributeValue.$touched" \nmultiple="multiple"><div ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div></div></md-autocomplete>\n</div><div flex="100" class="p-5 lookup-element"><md-input-container class="md-block"><label>\n{{\'ARTICLES_BLOCKING.FIELDS.BLOCKED_CATALOGS\' | translate}}</label><md-chips id="articles_blocking_dialog_input_4" \nname="BlockedCatalogs" ng-model="vm.record.BlockedCatalogs" md-autocomplete-snap \nmd-transform-chip="vm.transformChip($chip)" md-require-match="true" ng-required="true"><md-autocomplete \nmd-selected-item="vm.acSelectedItem.BlockedCatalogs" md-search-text="vm.acSearchText.BlockedCatalogs" \nmd-items="item in vm.acQuerySearch(vm.acSearchText.BlockedCatalogs, vm.record.BlockedCatalogs, \'BlockedCatalogs\')" \nmd-item-text="item.value" ng-disabled="false" md-min-length="0" md-no-cache="true" md-menu-class="autocomplete-custom">\n<md-item-template><span class="autocomplete-item md-accent-fg" md-highlight-text="vm.acSearchText.BlockedCatalogs">\n{{item.value}}</span></md-item-template><md-not-found>\nNo Record matching "{{vm.acSearchText.BlockedCatalogs}}" were found.</md-not-found></md-autocomplete><md-chip-template>\n<span><strong>{{vm.getChipDisplayValue($chip, \'BlockedCatalogs\')}}</strong></span></md-chip-template></md-chips><div \nclass="md-chips-messages" ng-messages="vm.editForm.BlockedCatalogs.$error" \nng-show="vm.editForm.BlockedCatalogs.$dirty || vm.editForm.BlockedCatalogs.$submitted"><div ng-message="required">\n{{ \'VALIDATIONS.REQUIRED\' | translate}}</div></div></md-input-container></div><div flex="100" flex-gt-xs="100" \nclass="p-5"><md-input-container class="md-block"><label translate>ARTICLES_BLOCKING.FIELDS.REASON</label><input \nid="articles_blocking_dialog_input_0" name="Reason" ng-model="vm.record.Reason" type="text" ng-required="false"><div \nng-messages="vm.editForm.Reason.$error" role="alert" multiple="multiple"><div ng-message="required">\n{{\'VALIDATIONS.REQUIRED\' | translate}}</div></div></md-input-container></div></div></md-dialog-content>\n<md-dialog-actions layout="row" layout-align="end center"><div></div><div layout="row" layout-align="end center">\n<md-button ng-click="vm.closeDialog(vm.isDataDirty)" class="send-button md-primary md-raised" aria-label="Cancel" \ntranslate="ACTIONS.DIALOG_CANCEL" translate-attr-aria-label="ACTIONS.DIALOG_CANCEL" ng-disabled="vm.isLoading">CANCEL\n</md-button><md-button ng-click="vm.saveRecord($event)" class="send-button md-accent md-raised" aria-label="Save" \ntranslate="ACTIONS.SAVE" translate-attr-aria-label="ACTIONS.SAVE" ng-disabled="vm.isLoading || vm.editForm.$invalid">\nSAVE</md-button></div></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/catalogs/sub-modules/articles-blocking/list/articles-blocking-list.html','<div id="articles-blocking-list" class="page-layout carded fullwidth list-view" layout="row"><div class="center" \nlayout="column" flex><div class="content-card" layout="column" flex><tx-data-table tx-data="vm.blockedArticles" \ntx-model="vm.model" tx-view="mainList" tx-filtered-data="vm.filteredBlockedArticles" tx-data-filter="global.search" \ntx-is-loading="vm.isLoading" tx-item-action-event="vm.doItemAction(action, item)" \ntx-list-action-event="vm.doListAction(action, selectedItems)" tx-refresh-action-event="vm.refreshRecords(true, false)">\n</tx-data-table><md-button class="add-rec-button md-fab md-warn" ng-if="vm.model.views.mainList.fabAction.visible" \nng-click="vm.addRecord($event)" aria-label="vm.model.views.mainList.fabAction.label" translate \ntx-access="{{::vm.model.views.mainList.fabAction.privilege}}"><md-icon \nmd-font-icon="{{vm.model.views.mainList.fabAction.icon}}"></md-icon></md-button></div></div></div>');
$templateCache.put('app/main/catalogs/sub-modules/articles-replacement/dialogs/replace-article.html','<md-dialog class="edit-dialog" aria-label="Replace Article"><form name="vm.editForm" class="md-inline-form"><md-toolbar\n class="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" layout-align="space-between center"><span \nclass="title">{{vm.isNew ? \'ARTICLES_REPLACEMENT.ACTIONS.CREATE\' : \'ARTICLES_REPLACEMENT.ACTIONS.UPDATE\' | translate}}\n</span><md-button class="md-icon-button" ng-click="vm.closeDialog(vm.isDataDirty)" aria-label="Close dialog" tranlate \ntranslate-aria-label="ACTIONS.DIALOG_CLOSE"><md-icon md-font-icon="icon-close"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div layout="row" layout-wrap><div flex="100" flex-gt-xs="50" \nclass="p-5 lookup-element"><md-autocomplete id="dialog_input_articleReplacement_ArticleIdDropped" \nmd-input-name="ArticleIdDropped" md-selected-item="vm.autocompleteModel.ArticleIdDropped" \nmd-items="item in vm.searchOriginalArticles(vm.searchText.ArticleIdDropped)" \nmd-search-text="vm.searchText.ArticleIdDropped" md-item-text="vm.getOriginalArticlesDisplayValue(item)" \nmd-min-length="0" md-floating-label="{{\'ARTICLES_REPLACEMENT.FIELDS.DROPPED_ARTICLE\' | translate}}" \nmd-selected-item-change="vm.onOriginalArticleChange(vm.autocompleteModel.ArticleIdDropped)" ng-required="vm.isNew" \nng-disabled="!vm.isNew" md-autofocus md-no-cache="true" tx-clear-autocomplete ng-click="vm.selectText($event)" \nmd-menu-class="autocomplete-custom"><md-item-template><span class="autocomplete-item md-accent-fg" \nmd-highlight-text="vm.searchText.ArticleIdDropped" md-highlight-flags="i">{{item.ArticleNumber}}</span>\n</md-item-template><div ng-messages="vm.editForm.ArticleIdDropped.$error" role="alert" \nng-show="vm.editForm.ArticleIdDropped.$touched"><div ng-message="required">\n{{field.validation.messages.isRequired | translate}}</div></div><md-not-found>\nNo Record matching "{{vm.searchText.ArticleIdDropped}}" were found.</md-not-found></md-autocomplete></div><div \nflex="100" flex-gt-xs="50" class="p-5 lookup-element"><md-autocomplete \nid="dialog_input_articleReplacement_ArticleIdAlt" md-input-name="ArticleIdAlt" \nmd-selected-item="vm.autocompleteModel.ArticleIdAlt" \nmd-items="item in vm.searchSuggestedArticles(vm.searchText.ArticleIdAlt)" md-search-text="vm.searchText.ArticleIdAlt" \nmd-item-text="vm.getSuggestedArticlesDisplayValue(item)" md-min-length="0" \nmd-floating-label="{{\'ARTICLES_REPLACEMENT.FIELDS.ALTERNATE_ARTICLE\' | translate}}" \nmd-selected-item-change="vm.onSuggestedAticleChange(vm.autocompleteModel.ArticleIdAlt)" ng-required="true" \nmd-autofocus md-no-cache="true" tx-clear-autocomplete tx-force-select ng-click="vm.selectText($event)" \nmd-menu-class="autocomplete-custom" ng-disabled="!vm.autocompleteModel.ArticleIdDropped"><md-item-template><span \nclass="autocomplete-item md-accent-fg" md-highlight-text="vm.searchText.ArticleIdAlt" md-highlight-flags="i">\n{{item.ArticleNumber}}</span></md-item-template><div ng-messages="vm.editForm.ArticleIdAlt.$error" role="alert" \nng-show="vm.editForm.ArticleIdAlt.$touched"><div ng-message="required">\n{{field.validation.messages.isRequired | translate}}</div></div><md-not-found>\nNo Record matching "{{vm.searchText.ArticleIdAlt}}" were found.</md-not-found></md-autocomplete></div></div>\n</md-dialog-content><md-dialog-actions layout="row" layout-align="end center"><div></div><div layout="row" \nlayout-align="end center"><md-button ng-click="vm.closeDialog(vm.isDataDirty)" \nclass="send-button md-primary md-raised" aria-label="Cancel" translate="ACTIONS.DIALOG_CANCEL" \ntranslate-attr-aria-label="ACTIONS.DIALOG_CANCEL" ng-disabled="vm.isLoading">CANCEL</md-button><md-button \nng-click="vm.saveRecord()" class="send-button md-accent md-raised" aria-label="Save" translate="ACTIONS.SAVE" \ntranslate-attr-aria-label="ACTIONS.SAVE" ng-disabled="vm.isLoading || vm.editForm.$invalid">SAVE</md-button><md-button \nng-click="vm.saveRecord(true)" class="send-button md-accent md-raised" aria-label="Save" \ntranslate="ACTIONS.SAVE_AND_NEW" translate-attr-aria-label="ACTIONS.SAVE_AND_NEW" \nng-disabled="vm.isLoading || vm.editForm.$invalid" ng-if="vm.isNew">SAVE</md-button></div></md-dialog-actions></form>\n</md-dialog>');
$templateCache.put('app/main/catalogs/sub-modules/articles-replacement/list/articles-replacement-list.html','<div id="articles-replacement-list" class="page-layout carded fullwidth list-view" layout="row"><div class="center" \nlayout="column" flex><div class="content-card" layout="column" flex><tx-data-table \ntx-data="vm.articlesWithReplacement" tx-model="vm.model" tx-view="mainList" \ntx-filtered-data="vm.filteredArticlesWithReplacement" tx-data-filter="global.search" tx-is-loading="vm.isLoading" \ntx-item-action-event="vm.doItemAction(action, item)" tx-refresh-action-event="vm.refreshRecords(true, false)">\n</tx-data-table><md-button class="add-rec-button md-fab md-warn" ng-click="vm.addRecord($event)" \naria-label="vm.model.views.mainList.fabAction.label" translate \ntx-access="{{::vm.model.views.mainList.fabAction.privilege}}"><md-icon \nmd-font-icon="{{vm.model.views.mainList.fabAction.icon}}"></md-icon></md-button></div></div></div>');
$templateCache.put('app/main/catalogs/sub-modules/assortments/details/assortment-details.html','<div id="assortment-details" class="page-layout simple tabbed details-view" layout="column"><div class="content">\n<md-tabs md-dynamic-height md-selected="vm.tabIndex" md-no-ink><md-tab \nlabel="{{\'ASSORTMENTS.TABS.ASSORTMENT\' | translate}}" tx-access="{{::vm.model.views.privileges.details}}">\n<tx-data-details tx-height-offset="37" tx-is-active="vm.tabIndex === 0" tx-account="vm.assortment" tx-title="vm.title" \ntx-parent-id="vm.activeCatalogCode" tx-model="vm.model" tx-item-actions="vm.model.views.mainDetails.itemActions" \ntx-item-action-event="vm.doAssortmentItemAction(action, account)" tx-is-loading="vm.isLoading" \ntx-refresh-action-event="vm.refreshRecord(false)"></tx-data-details></md-tab><md-tab \nlabel="{{\'ASSORTMENTS.TABS.ARTICLES\' | translate}}" ng-disabled="!vm.assortment.Status" \ntx-access="{{::vm.articlesModel.views.privileges.list}}" ng-if="vm.catalogCollectionType === 1"><div class="list-tab" \nlayout="row" flex="100" layout-wrap><ms-widget layout="row" flex="100"><ms-widget-front class="white-bg"><tx-data-table\n tx-is-active="vm.tabIndex === 1" tx-data="vm.articles" tx-model="vm.articlesModel" tx-view="mainList" \ntx-filtered-data="vm.filteredArticles" tx-data-filter="global.search" tx-is-loading="vm.isLoading" \ntx-item-action-event="vm.doArticleItemAction(action, item)" \ntx-list-action-event="vm.doArticleListAction(action, selectedItems)" tx-item-click-event="vm.viewArticle(item)" \ntx-refresh-action-event="vm.refreshRecord(true)" tx-height-offset="16"></tx-data-table></ms-widget-front></ms-widget>\n<md-button class="add-rec-button md-fab md-warn" ng-click="vm.addArticle($event)" \naria-label="vm.articlesModel.views.mainList.fabAction.label" translate \ntx-access="{{::vm.articlesModel.views.mainList.fabAction.privilege}}"><md-icon \nmd-font-icon="{{vm.articlesModel.views.mainList.fabAction.icon}}"></md-icon></md-button></div></md-tab><md-tab \nlabel="{{\'ASSORTMENTS.TABS.CUSTOMERS\' | translate}}" ng-disabled="!vm.assortment.Status" \ntx-access="{{::vm.customersModel.views.privileges.list}}"><div class="list-tab" layout="row" flex="100" layout-wrap>\n<ms-widget layout="row" flex="100"><ms-widget-front class="white-bg"><tx-data-table tx-is-active="vm.tabIndex === 2" \ntx-data="vm.customers" tx-model="vm.customersModel" tx-view="mainList" tx-filtered-data="vm.filteredCustomers" \ntx-data-filter="global.search" tx-is-loading="vm.isLoading" \ntx-item-action-event="vm.doCustomerItemAction(action, item)" \ntx-list-action-event="vm.doCustomersListAction(action, selectedItems)" tx-item-click-event="vm.viewCustomer(item)" \ntx-refresh-action-event="vm.refreshRecord(true)" tx-height-offset="16"></tx-data-table></ms-widget-front></ms-widget>\n<md-button class="add-rec-button md-fab md-warn" ng-click="vm.addCustomer($event)" \naria-label="vm.customersModel.views.mainList.fabAction.label" translate \ntx-access="{{::vm.customersModel.views.mainList.fabAction.privilege}}"><md-icon \nmd-font-icon="{{vm.customersModel.views.mainList.fabAction.icon}}"></md-icon></md-button></div></md-tab><md-tab \nlabel="{{\'ASSORTMENTS.TABS.USERS\' | translate}}" ng-disabled="!vm.assortment.Status" \ntx-access="{{::vm.sellerUserModel.views.privileges.list}}" ng-if="vm.catalogCollectionType === 2"><div \nclass="list-tab" layout="row" flex="100" layout-wrap><ms-widget layout="row" flex="100"><ms-widget-front \nclass="white-bg"><tx-data-table tx-is-active="vm.tabIndex === 3" tx-data="vm.sellerUsers" \ntx-model="vm.sellerUserModel" tx-view="mainList" tx-filtered-data="vm.filteredSellerUsers" \ntx-data-filter="global.search" tx-is-loading="vm.isLoading" \ntx-item-action-event="vm.doSellerUserItemAction(action, item)" \ntx-list-action-event="vm.doSellerUserListAction(action, selectedItems)" \ntx-refresh-action-event="vm.refreshRecord(true)" tx-height-offset="16"></tx-data-table></ms-widget-front></ms-widget>\n<md-button class="add-rec-button md-fab md-warn" ng-click="vm.assignSellerUsers($event)" \naria-label="vm.sellerUserModel.views.mainList.fabAction.label" translate \ntx-access="{{::vm.sellerUserModel.views.mainList.fabAction.privilege}}"><md-icon \nmd-font-icon="{{vm.sellerUserModel.views.mainList.fabAction.icon}}"></md-icon></md-button></div></md-tab></md-tabs>\n<md-button id="txfab" class="md-fab md-warn" ng-if="vm.tabIndex === 0" ng-click="vm.editItem(vm.assortment, $event)" \naria-label="vm.model.views.mainDetails.fab.label" translate tx-access="{{::vm.model.views.mainDetails.fab.privilege}}">\n<md-icon md-font-icon="{{vm.model.views.mainDetails.fab.icon}}"></md-icon></md-button></div></div>');
$templateCache.put('app/main/catalogs/sub-modules/assortments/list/assortments-list.html','<div id="assortment-list" class="page-layout carded fullwidth list-view" layout="row"><div class="center" \nlayout="column" flex><div class="content-card" layout="column" flex><tx-data-tree \nng-show="vm.currentCollectionView === 0" tx-data="vm.folders" tx-model="vm.model" tx-columns="vm.cols" \ntx-branch-types="vm.branchTypes" tx-data-filter="vm.filter" tx-is-loading="vm.isLoading" \ntx-tree-event-handler="vm.treeOptions" tx-show-filter-row="vm.showFilterRow" tx-refresh-action-event="vm.doRefresh()" \ntx-item-action-event="vm.doItemAction(action, item)" tx-item-click-event="vm.onTreeNodeClick(item)" \ntx-list-action-event="vm.doListAction(action, selectedItems)" tx-prevent-folder-click="true" tx-height-offset="16" \ntx-switch-collections-view-action-event="vm.doSwitchCollectionsView(id)" tx-tree-view-options="vm.treeViewOptions">\n</tx-data-tree><tx-data-table ng-if="vm.currentCollectionView === 1 && vm.tabularArticlesModel" \ntx-data="vm.tabularArticlesData" tx-model="vm.tabularArticlesModel" tx-view="mainList" \ntx-filtered-data="vm.filteredTabularArticlesData" tx-data-filter="global.search" \ntx-item-action-event="vm.doArticlesItemAction(action, item)" tx-is-loading="vm.isLoadingTabularArticlesData" \ntx-support-images-view="false" tx-list-action-event="vm.doArticlesListAction(action, selectedItems)" \ntx-refresh-action-event="vm.refreshTabularArticlesData(true, false)" \ntx-switch-collections-view-action-event="vm.doSwitchCollectionsView(id)" \ntx-current-collection-view="vm.currentCollectionView"></tx-data-table><tx-data-table \nng-if="vm.currentCollectionView === 2 && vm.tabularCustomersModel" tx-data="vm.tabularCustomersData" \ntx-model="vm.tabularCustomersModel" tx-view="mainList" tx-filtered-data="vm.filteredTabularCustomersData" \ntx-data-filter="global.search" tx-is-loading="vm.isLoadingTabularCustomersData" tx-support-images-view="false" \ntx-item-action-event="vm.doCustomersItemAction(action, item)" \ntx-list-action-event="vm.doCustomersListAction(action, selectedItems)" \ntx-refresh-action-event="vm.refreshTabularCustomersData(true, false)" \ntx-switch-collections-view-action-event="vm.doSwitchCollectionsView(id)" \ntx-current-collection-view="vm.currentCollectionView"></tx-data-table><md-button class="add-rec-button md-fab md-warn" \nng-show="vm.currentCollectionView === 0" ng-click="vm.addFolder($event, vm.folders.length)" \naria-label="vm.folderModel.views.mainList.fabAction.label" translate \ntx-access="{{::vm.folderModel.views.mainList.fabAction.privilege}}"><md-icon \nmd-font-icon="{{vm.folderModel.views.mainList.fabAction.icon}}"></md-icon></md-button></div></div></div>');
$templateCache.put('app/main/catalogs/sub-modules/assortments/list/node-renderer.html','<div ui-tree-handle ng-if="node.nodes" layout><md-button ng-click="vm.toggle(this)" \nng-class="{\'icon-arrow-right\': collapsed , \'icon-arrow-down\': !collapsed}" aria-label="icon-arrow-down" data-nodrag>\n</md-button><span flex>{{node.Name}}</span><div class="actions" flex="none" ng-click="$event.stopPropagation()">\n<md-menu data-nodrag><md-button class="md-icon-button" aria-label="Action" \nng-disabled="{{!node.Status || !node.ancestorDisabledStatus}}" ng-click="$mdOpenMenu($event)"><md-icon \nmd-font-icon="icon-plus"></md-icon></md-button><md-menu-content width="3"><md-menu-item \ntx-access="{{::vm.folderModel.views.mainList.addAction.privilege}}" \nng-show="{{vm.folderModel.views.mainList.addAction.visible}}"><md-button \nng-click="vm.addFolder($event, node.nodes.length, node.Id)" \naria-label="{{vm.folderModel.views.mainList.addAction.label}}" \ntranslate-attr-aria-label="{{vm.folderModel.views.mainList.addAction.label}}" \nng-disabled="{{vm.folderModel.views.mainList.addAction.disabled}}"><md-icon \nmd-font-icon="{{vm.folderModel.views.mainList.addAction.icon}}" class="s18"></md-icon><span \ntranslate="{{vm.folderModel.views.mainList.addAction.label}}">{{vm.folderModel.views.mainList.addAction.label}}</span>\n</md-button></md-menu-item><md-menu-item tx-access="{{::vm.model.views.mainList.addAction.privilege}}" \nng-show="{{vm.model.views.mainList.addAction.visible}}"><md-button \nng-click="vm.addAssortment($event, node.nodes.length, node.Id)" \naria-label="{{vm.model.views.mainList.addAction.label}}" \ntranslate-attr-aria-label="{{vm.model.views.mainList.addAction.label}}" \nng-disabled="{{vm.model.views.mainList.addAction.disabled}}"><md-icon \nmd-font-icon="{{vm.model.views.mainList.addAction.icon}}" class="s18"></md-icon><span \ntranslate="{{vm.model.views.mainList.addAction.label}}">{{vm.folderModel.views.mainList.addAction.label}}</span>\n</md-button></md-menu-item></md-menu-content></md-menu><md-button \nng-repeat="itemAction in vm.folderModel.views.mainList.itemActions" class="md-icon-button" \naria-label="{{itemAction.label}}" translate-attr-aria-label="{{itemAction.label}}" \nng-click="vm.doFolderItemAction(itemAction, node)" ng-disabled="{{itemAction.disabled}}" \nng-show="{{itemAction.visible}}" tx-access="{{::itemAction.privilege}}" data-nodrag><md-icon \nmd-font-icon="{{itemAction.icon}}"></md-icon><md-tooltip><span translate>{{itemAction.label}}</span></md-tooltip>\n</md-button></div></div><div ui-tree-handle ng-if="!node.nodes" layout><span flex="5"></span> <span flex>{{node.Name}}\n</span><div flex="none"><md-button ng-repeat="itemAction in vm.model.views.mainList.itemActions" \nclass="md-icon-button" aria-label="{{itemAction.label}}" translate-attr-aria-label="{{itemAction.label}}" \nng-click="vm.doAssortmentItemAction(itemAction, node)" ng-disabled="{{itemAction.disabled}}" \nng-show="{{itemAction.visible}}" tx-access="{{::itemAction.privilege}}" data-nodrag><md-icon \nmd-font-icon="{{itemAction.icon}}"></md-icon><md-tooltip><span translate>{{itemAction.label}}</span></md-tooltip>\n</md-button></div></div><ol ui-tree-nodes="" ng-model="node.nodes" ng-class="{collapsed: collapsed}"><li \nng-repeat="node in node.nodes" ui-tree-node \nng-include="\'app/main/catalogs/sub-modules/assortments/list/node-renderer.html\'"></li></ol>');
$templateCache.put('app/main/catalogs/sub-modules/buy-windows/details/buy-windows-details.html','<div id="buyWindow-details" class="page-layout simple tabbed details-view" layout="column"><div class="content">\n<md-tabs md-dynamic-height md-selected="vm.tabIndex" md-no-ink><md-tab \nlabel="{{\'BUY_WINDOWS.TABS.BUY_WINDOW\' | translate}}" tx-access="{{::vm.model.views.privileges.details}}">\n<tx-data-details tx-height-offset="37" tx-is-active="vm.tabIndex === 0" tx-account="vm.buyWindow" tx-title="vm.title" \ntx-model="vm.model" tx-refresh-action-event="vm.refreshRecord(false)" \ntx-item-actions="vm.model.views.mainDetails.itemActions" tx-item-action-event="vm.doItemAction(action, account)">\n</tx-data-details></md-tab></md-tabs></div></div>');
$templateCache.put('app/main/catalogs/sub-modules/buy-windows/list/buy-windows-list.html','<div id="buyWindow-list" class="page-layout carded fullwidth list-view" layout="row"><div class="center" \nlayout="column" flex><div class="content-card" layout="column" flex><tx-data-table tx-data="vm.buyWindows" \ntx-model="vm.model" tx-view="mainList" tx-filtered-data="vm.filteredBuyWindows" tx-data-filter="global.search" \ntx-is-loading="vm.isLoading" tx-item-action-event="vm.doItemAction(action, item)" \ntx-list-action-event="vm.doListAction(action, selectedItems)" tx-item-click-event="vm.viewItem(item)" \ntx-refresh-action-event="vm.refreshItems(true, false)"></tx-data-table><md-button \nclass="add-rec-button md-fab md-warn" ng-click="vm.addRecord($event)" \naria-label="::vm.model.views.mainList.fabAction.label" translate \ntx-access="{{::vm.model.views.mainList.fabAction.privilege}}"><md-icon \nmd-font-icon="{{::vm.model.views.mainList.fabAction.icon}}"></md-icon></md-button></div></div></div>');
$templateCache.put('app/main/catalogs/sub-modules/buyer-limits/details/buyer-limits-details.html','<div id="buyer-limit-details" class="page-layout simple tabbed details-view" layout="column"><div class="content">\n<md-tabs md-dynamic-height md-selected="vm.tabIndex" md-no-ink><md-tab \nlabel="{{\'BUYER_LIMITS.TABS.BUYER_LIMIT\' | translate}}" tx-access="{{::vm.model.views.privileges.details}}">\n<tx-data-details tx-height-offset="37" tx-account="vm.buyerLimit" tx-title="vm.title" tx-model="vm.model" \ntx-item-actions="vm.model.views.mainDetails.itemActions" \ntx-item-action-event="vm.doBuyerLimitsItemAction(action, account)" tx-is-loading="vm.isLoading" \ntx-refresh-action-event="vm.refreshRecord(false)" tx-parent-id="vm.activeCatalog.CatalogCode"></tx-data-details>\n</md-tab><md-tab label="{{\'BUYER_LIMITS.TABS.CUSTOMERS\' | translate}}"><div class="list-tab" layout="row" flex="100" \nlayout-wrap><ms-widget layout="row" flex="100"><ms-widget-front class="white-bg"><tx-data-table \ntx-is-active="vm.tabIndex === 1" tx-data="vm.buyerLimitCustomers" tx-model="vm.buyerLimitCustomersModel" \ntx-view="mainList" tx-filtered-data="vm.filteredBuyerLimitCustomers" tx-data-filter="global.search" \ntx-is-loading="vm.isLoading" tx-refresh-action-event="vm.refreshRecord(false)" tx-height-offset="16"></tx-data-table>\n</ms-widget-front></ms-widget><md-button class="add-rec-button md-fab md-warn" \nng-click="vm.assignBuyerLimitCustomers($event)" \naria-label="vm.buyerLimitCustomersModel.views.mainList.fabAction.label" translate \ntx-access="{{::vm.buyerLimitCustomersModel.views.mainList.fabAction.privilege}}"><md-icon \nmd-font-icon="{{vm.buyerLimitCustomersModel.views.mainList.fabAction.icon}}"></md-icon></md-button></div></md-tab>\n<md-tab label="{{\'BUYER_LIMITS.TABS.LIMITS_CRITERIA\' | translate}}"><div class="list-tab" layout="row" flex="100" \nlayout-wrap><ms-widget layout="row" flex="100"><ms-widget-front class="white-bg"><tx-data-table \ntx-is-active="vm.tabIndex === 2" tx-data="vm.attributeCriteria" tx-model="vm.attributeCriteriaModel" \ntx-view="mainList" tx-filtered-data="vm.filteredAttributeCriteria" tx-data-filter="global.search" \ntx-is-loading="vm.isLoading" tx-item-click-event="vm.viewAttributeCriteria(item)" \ntx-refresh-action-event="vm.refreshRecord(false)" \ntx-item-action-event="vm.doAttributeCriteriaItemAction(action, item)" \ntx-list-action-event="vm.doAttributeCriteriaListAction(action, selectedItems)" tx-height-offset="16"></tx-data-table>\n</ms-widget-front></ms-widget><md-button class="add-rec-button md-fab md-warn" \nng-click="vm.addAttributeCriteria($event)" aria-label="vm.attributeCriteriaModel.views.mainList.fabAction.label" \ntranslate tx-access="{{vm.attributeCriteriaModel.views.mainList.fabAction.privilege}}"><md-icon \nmd-font-icon="{{vm.attributeCriteriaModel.views.mainList.fabAction.icon}}"></md-icon></md-button></div></md-tab>\n</md-tabs><md-button id="txfab" class="md-fab md-warn" ng-if="vm.tabIndex === 0" \nng-click="vm.editItem(vm.buyerLimit, $event)" aria-label="vm.model.views.mainDetails.fabAction.label" translate \ntx-access="{{::vm.model.views.mainDetails.fabAction.privilege}}"><md-icon \nmd-font-icon="{{vm.model.views.mainDetails.fabAction.icon}}"></md-icon></md-button></div></div>');
$templateCache.put('app/main/catalogs/sub-modules/buyer-limits/list/buyer-limits-list.html','<div id="buyer-limits-list" class="page-layout carded fullwidth list-view" layout="row"><div class="center" \nlayout="column" flex><div class="content-card" layout="column" flex><tx-data-table tx-data="vm.buyerLimits" \ntx-model="vm.model" tx-view="mainList" tx-filtered-data="vm.filteredBuyerLimits" tx-data-filter="global.search" \ntx-is-loading="vm.isLoading" tx-item-action-event="vm.doItemAction(action, item)" \ntx-list-action-event="vm.doListAction(action, selectedItems)" tx-refresh-action-event="vm.refreshItems(true, false)" \ntx-item-click-event="vm.viewItem(item)" tx-control="vm.tableControl"></tx-data-table><md-button \nclass="add-rec-button md-fab md-warn" ng-click="vm.addRecord($event)" \naria-label="::vm.model.views.mainList.fabAction.label" translate \ntx-access="{{::vm.model.views.mainList.fabAction.privilege}}"><md-icon \nmd-font-icon="{{::vm.model.views.mainList.fabAction.icon}}"></md-icon></md-button></div></div></div>');
$templateCache.put('app/main/catalogs/sub-modules/catalog-datasets/details/catalog-datasets-details.html','<div id="catalog-dataset-table-details" class="page-layout simple tabbed details-view" layout="column"><div \nclass="content"><md-tabs md-dynamic-height md-selected="vm.tabIndex" md-no-ink><md-tab \nlabel="{{\'CATALOG_DATASETS.NAV\' | translate}}" tx-access="{{::vm.model.views.privileges.details}}"><tx-data-details \ntx-height-offset="37" tx-is-active="vm.tabIndex === 0" tx-account="vm.datasetDefinition" tx-parent-id="vm.accountId" \ntx-title="vm.title" tx-model="vm.model" tx-is-loading="vm.isLoading" tx-refresh-action-event="vm.refreshRecord(false)">\n</tx-data-details></md-tab><md-tab label="{{\'CATALOG_DATASETS.TABS.VALUES\' | translate}}" \ntx-access="{{::vm.valuesModel.views.privileges.list}}"><div class="list-tab" layout="row" flex="100" layout-wrap>\n<ms-widget layout="row" flex="100"><ms-widget-front class="white-bg"><tx-data-table tx-is-active="vm.tabIndex === 1" \ntx-data="vm.datasetValues" tx-model="vm.valuesModel" tx-view="mainList" tx-filtered-data="vm.filteredDatasetValues" \ntx-data-filter="global.search" tx-is-loading="vm.isValuesLoading" \ntx-list-action-event="vm.doValuesListAction(action, selectedItems)" \ntx-item-action-event="vm.doValuesItemAction(action, item)" tx-refresh-action-event="vm.refreshValues(true)" \ntx-height-offset="16"></tx-data-table></ms-widget-front></ms-widget></div></md-tab></md-tabs></div></div>');
$templateCache.put('app/main/catalogs/sub-modules/catalog-models/details/catalog-models-details.html','<div id="models-details" class="page-layout simple tabbed details-view" layout="column"><div class="content"><md-tabs \nmd-dynamic-height md-selected="vm.tabIndex" md-no-ink><md-tab label="{{\'MODELS.TABS.MODEL\' | translate}}" \ntx-access="{{::vm.model.views.privileges.details}}"><tx-data-details tx-height-offset="37" \ntx-account="vm.modelDetails" tx-title="vm.title" tx-model="vm.model" tx-is-loading="vm.isLoading" \ntx-refresh-action-event="vm.refreshRecord(false)" tx-item-actions="vm.model.views.mainDetails.itemActions" \ntx-item-action-event="vm.doCatalogModelItemAction(action, account)" tx-parent-id="vm.activeCatalog.CatalogCode">\n</tx-data-details></md-tab><md-tab label="{{\'MODELS.TABS.ARTICLES\' | translate}}" \ntx-access="{{::vm.catalogModelArticlesModel.views.privileges.list}}"><div class="list-tab" layout="row" flex="100" \nlayout-wrap><ms-widget layout="row" flex="100"><ms-widget-front class="white-bg"><tx-data-table \ntx-is-active="vm.tabIndex === 1" tx-data="vm.catalogModelsArticles" tx-model="vm.catalogModelArticlesModel" \ntx-view="mainList" tx-filtered-data="vm.filteredCatalogModelsArticles" tx-data-filter="global.search" \ntx-item-action-event="vm.doArticleItemAction(action, item)" tx-is-loading="vm.isModelArticlesLoading" \ntx-refresh-action-event="vm.refreshCatalogModelArticles(true, false)" tx-control="vm.tableControl" \ntx-height-offset="16"></tx-data-table></ms-widget-front></ms-widget><md-fab-speed-dial md-open="false" \nmd-direction="up" class="add-rec-button md-scale"><md-fab-trigger><md-button aria-label="menu" class="md-fab md-warn" \ntx-access="{{::vm.model.views.mainList.fabAction.privilege}}"><md-icon \nmd-font-icon="{{::vm.model.views.mainList.fabAction.icon}}"></md-icon><md-tooltip md-direction="left"><span \ntranslate="ARTICLES.ACTIONS.MENU"></span></md-tooltip></md-button></md-fab-trigger><md-fab-actions><md-button \nng-click="vm.assignArticles($event)" aria-label="Assign Articles" class="md-fab md-raised md-mini md-warn"><md-icon \nmd-font-icon="icon-link"></md-icon><md-tooltip md-direction="left"><span translate="MODELS.ACTIONS.ASSIGN_ARTICLES">\n</span></md-tooltip></md-button><md-button ng-click="vm.addArticle($event)" aria-label="Create Article" \nclass="md-fab md-raised md-mini md-warn" tx-access="{{::vm.catalogArticlesModel.views.mainList.fabAction.privilege}}">\n<md-icon md-font-icon="icon-plus"></md-icon><md-tooltip md-direction="left"><span \ntranslate="MODELS.ACTIONS.CREATE_ARTICLE"></span></md-tooltip></md-button></md-fab-actions></md-fab-speed-dial></div>\n</md-tab><md-tab label="{{\'MODELS.TABS.RESOURCES\' | translate}}" ng-disabled="!vm.modelDetails.Status" \ntx-access="{{::vm.catalogModelResourcesModel.views.privileges.list}}"><div class="list-tab" layout="row" flex="100" \nlayout-wrap><ms-widget layout="row" flex="100"><ms-widget-front class="white-bg"><tx-data-table \ntx-is-active="vm.tabIndex === 2" tx-data="vm.catalogModelResources" tx-model="vm.catalogModelResourcesModel" \ntx-view="mainList" tx-filtered-data="vm.filteredCatalogModelResources" tx-data-filter="global.search" \ntx-item-action-event="vm.doResourceItemAction(action, item)" \ntx-list-action-event="vm.doResourceListAction(action, selectedItems)" tx-is-loading="vm.isModelResourcesLoading" \ntx-refresh-action-event="vm.refreshCatalogModelResources(true, false)" tx-item-click-event="vm.viewResource(item)" \ntx-height-offset="16"></tx-data-table></ms-widget-front></ms-widget><md-button class="add-rec-button md-fab md-warn" \nng-click="vm.assignResources($event)" aria-label="Assign Resources" \ntx-access="{{vm.catalogModelResourcesModel.views.mainList.fabAction.privilege}}"><md-icon md-font-icon="icon-link">\n</md-icon><md-tooltip md-direction="left"><span translate="MODELS.TABS.RESOURCES"></span></md-tooltip></md-button>\n</div></md-tab><md-tab label="{{\'MODELS.TABS.SIZES\' | translate}}" \ntx-access="{{::vm.catalogModelSizesModel.views.privileges.list}}"><div class="list-tab" layout="row" flex="100" \nlayout-wrap><ms-widget layout="row" flex="100"><ms-widget-front class="white-bg"><tx-data-table \ntx-is-active="vm.tabIndex === 3" tx-data="vm.catalogModelSizes" tx-model="vm.catalogModelSizesModel" \ntx-view="mainList" tx-filtered-data="vm.filteredCatalogModelSizes" tx-data-filter="global.search" \ntx-is-loading="vm.isCatalogModelSizesLoading" tx-refresh-action-event="vm.refreshRecord(false)" tx-height-offset="16" \ntx-control="vm.tableSizesControl"></tx-data-table></ms-widget-front></ms-widget></div></md-tab></md-tabs><md-button \nid="txfab" class="md-fab md-warn" ng-if="vm.tabIndex === 0 && vm.model.views.mainDetails.fab.visible" \nng-click="vm.editItem(vm.modelDetails, $event)" aria-label="vm.model.views.mainDetails.fab.label" translate \ntx-access="{{::vm.model.views.mainDetails.fab.privilege}}"><md-icon \nmd-font-icon="{{vm.model.views.mainDetails.fab.icon}}"></md-icon></md-button></div></div>');
$templateCache.put('app/main/catalogs/sub-modules/catalog-models/list/catalog-models-list.html','<div id="catalog-models-list" class="page-layout carded fullwidth list-view" layout="row"><div class="center" \nlayout="column" flex><div class="content-card" layout="column" flex><tx-data-table tx-data="vm.catalogModels" \ntx-model="vm.model" tx-view="mainList" tx-filtered-data="vm.filteredModels" tx-data-filter="global.search" \ntx-is-loading="vm.isLoading" tx-item-action-event="vm.doItemAction(action, item)" \ntx-item-click-event="vm.viewItem(item)" tx-list-action-event="vm.doListAction(action, selectedItems)" \ntx-refresh-action-event="vm.refreshItems(true, false)" tx-control="vm.tableControl"></tx-data-table><md-button \nclass="add-rec-button md-fab md-warn" ng-show="vm.model.views.mainList.fabAction.visible" \nng-click="vm.addRecord($event)" aria-label="vm.model.views.mainList.fabAction.label" translate \ntx-access="{{::vm.model.views.mainList.fabAction.privilege}}"><md-icon \nmd-font-icon="{{vm.model.views.mainList.fabAction.icon}}"></md-icon></md-button></div></div></div>');
$templateCache.put('app/main/catalogs/sub-modules/change-logs/dialogs/changes.dialog.html','<md-dialog class="changes-dialog" aria-label="Changes" flex="35"><md-toolbar class="md-accent md-hue-2"><div \nclass="md-toolbar-tools" layout="row" layout-align="space-between center"><span class="title">\n{{\'CHANGE_LOGS.TITLES.ARTICLE\' | translate:vm.translateVar}}</span><md-button class="md-icon-button" \nng-click="vm.closeDialog()" aria-label="Close dialog" tranlate translate-aria-label="ACTIONS.DIALOG_CLOSE"><md-icon \nmd-font-icon="icon-close"></md-icon></md-button></div></md-toolbar><md-dialog-content><div \nng-if="vm.record.ChangeType === \'dropped\'" layout="row" layout-align="start center" class="dropped pt-15 pb-15">\n<md-icon md-font-icon="icon-cancel" flex="none"></md-icon><div flex class="pl-5" \ntranslate="CHANGE_LOGS.TITLES.DROPPED">Dropped</div></div><div \nng-if="vm.record.ChangeType === \'reactivated\' || vm.record.ChangeType === \'reactivated with change\'" \nclass="reactivate pt-15 pb-15" ng-class="{\'vertical-seperator\': vm.record.ChangeType === \'reactivated with change\'}" \nlayout="row" layout-align="start center"><md-icon md-font-icon="icon-checkbox-marked-circle" flex="none"></md-icon><div\n ng-if="vm.record.ChangeType === \'reactivated\'" flex class="pl-5" translate="CHANGE_LOGS.TITLES.REACTIVATED">\nReactivated</div><div ng-if="vm.record.ChangeType === \'reactivated with change\'" flex class="pl-5" \ntranslate="CHANGE_LOGS.TITLES.CHANGE_REACTIVATED">Changed/Reactivated</div></div><div \nng-if="vm.record.ChangeType === \'reactivated with change\' || vm.record.ChangeType === \'changed\'"><div layout="row" \nlayout-align="start center" layout-padding class="vertical-seperator"><div class="text-truncate text-bold" flex="35">\n{{ \'CHANGE_LOGS.FIELDS.FIELD\' | translate }}</div><div class="text-truncate text-bold" flex="35">\n{{ \'CHANGE_LOGS.FIELDS.OLD_VALUE\' | translate }}</div><div class="text-truncate text-bold" flex="35">\n{{ \'CHANGE_LOGS.FIELDS.NEW_VALUE\' | translate }}</div></div><div class="data-container" ms-scroll><div \nng-repeat="record in vm.record.changeObj" layout="row" layout-align="start center" layout-padding><div \nclass="text-truncate" flex="35">{{record.F}}</div><div class="text-truncate" flex="35">{{record.O}}</div><div \nclass="text-truncate" flex="35">{{record.N}}</div></div></div></div></md-dialog-content></md-dialog>');
$templateCache.put('app/main/catalogs/sub-modules/consolidation-templates/details/consolidation-templates-details.html','<div id="consolidation-template-details" class="page-layout simple tabbed details-view" layout="column"><div \nclass="content"><md-tabs md-dynamic-height md-selected="vm.tabIndex" md-no-ink><md-tab \nlabel="{{\'CONSOLIDATION_TEMPLATES.TABS.CONSOLIDATION_TEMPLATE\' | translate}}" \ntx-access="{{::vm.model.views.privileges.details}}" ng-disabled="!vm.consolidationTemplate.Status"><tx-data-details \ntx-height-offset="37" tx-is-active="vm.tabIndex === 0" tx-account="vm.consolidationTemplate" tx-title="vm.title" \ntx-model="vm.model" tx-item-actions="vm.model.views.mainDetails.itemActions" \ntx-item-action-event="vm.doItemAction(action, account)" tx-refresh-action-event="vm.refreshRecord(false)">\n</tx-data-details></md-tab><md-tab label="{{\'CONSOLIDATION_TEMPLATES.TABS.CRITERIA\' | translate}}" \nng-disabled="!vm.consolidationTemplate.Status" tx-access="{{::vm.criteriaModel.views.privileges.list}}"><div \nclass="list-tab" layout="row" flex="100" layout-wrap><ms-widget layout="row" flex="100"><ms-widget-front \nclass="white-bg"><tx-data-table tx-is-active="vm.tabIndex === 1" tx-data="vm.criteria" tx-model="vm.criteriaModel" \ntx-view="mainList" tx-filtered-data="vm.filteredCriteria" tx-data-filter="global.search" tx-is-loading="vm.isLoading" \ntx-refresh-action-event="vm.refreshRecord(false)" tx-height-offset="16"></tx-data-table></ms-widget-front></ms-widget>\n</div></md-tab><md-tab label="{{\'CONSOLIDATION_TEMPLATES.TABS.OUTPUT\' | translate}}" \nng-disabled="!vm.consolidationTemplate.Status" tx-access="{{::vm.outputModel.views.privileges.list}}"><div \nclass="list-tab" layout="row" flex="100" layout-wrap><ms-widget layout="row" flex="100"><ms-widget-front \nclass="white-bg"><tx-data-table tx-is-active="vm.tabIndex === 2" tx-data="vm.output" tx-model="vm.outputModel" \ntx-view="mainList" tx-filtered-data="vm.filteredOutput" tx-data-filter="global.search" tx-is-loading="vm.isLoading" \ntx-refresh-action-event="vm.refreshRecord(false)" tx-height-offset="16"></tx-data-table></ms-widget-front></ms-widget>\n</div></md-tab></md-tabs><md-button id="txfab" class="md-fab md-warn" ng-if="vm.selectedTabIndex === 0" \nng-disabled="!vm.consolidationTemplate.Status || vm.consolidationTemplate.TotalConsolidation > 0" \nng-click="vm.editRecord(vm.consolidationTemplate, $event)" aria-label="vm.model.views.mainDetails.fab.label" translate \ntx-access="{{::vm.model.views.mainDetails.fab.privilege}}"><md-icon \nmd-font-icon="{{vm.model.views.mainDetails.fab.icon}}"></md-icon></md-button></div></div>');
$templateCache.put('app/main/catalogs/sub-modules/consolidation-templates/dialogs/create-template.html','<md-dialog class="edit-dialog" aria-label="Create Consolidation Template"><form name="vm.editForm" \nclass="md-inline-form"><md-toolbar class="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" \nlayout-align="space-between center"><span class="title" \ntranslate="{{vm.isNew ? \'CONSOLIDATION_TEMPLATES.TITLES.CREATE_TEMPLATE\' : \'CONSOLIDATION_TEMPLATES.TITLES.UPDATE_TEMPLATE\'}}">\nCreate Consolidation Template</span><md-button class="md-icon-button" ng-click="vm.closeDialog(vm.isDataDirty)" \naria-label="Close dialog" tranlate translate-aria-label="ACTIONS.DIALOG_CLOSE"><md-icon md-font-icon="icon-close">\n</md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll ng-hide="vm.isLoadingData"><div layout="row" \nlayout-wrap><div flex="100" flex-gt-xs="50" class="p-5"><md-input-container class="md-block"><label translate>\nCONSOLIDATION_TEMPLATES.FIELDS.NAME</label><input name="Name" ng-model="vm.record.Name" type="text" ng-required="true" \nmd-maxlength="-1"><div ng-messages="vm.editForm.Name.$error" role="alert" multiple="multiple"><div \nng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div></div></md-input-container></div><div flex="100" \nflex-gt-xs="50" class="p-5 lookup-element"><md-autocomplete id="dialog_input_{{$first ? \'first\' : $index}}" \nmd-input-name="ConsolidationPluginId" md-selected-item="vm.lookupModel.ConsolidationPluginId" \nmd-items="item in vm.consolidationPluginSearch(vm.searchText.ConsolidationPluginId, \'ConsolidationPluginId\')" \nmd-search-text="vm.searchText.ConsolidationPluginId" \nmd-item-text="vm.getLookupDisplayValue(item, \'plugins.consolidationPlugins\')" md-min-length="0" \nmd-floating-label="{{\'CONSOLIDATION_TEMPLATES.FIELDS.CONSOLIDATION_PLUGIN\' | translate}}" md-no-cache="true" \ntx-clear-autocomplete ng-click="vm.selectText($event)" \nmd-selected-item-change="vm.lookupChange(vm.lookupModel.ConsolidationPluginId, \'ConsolidationPluginId\')" \nmd-menu-class="autocomplete-custom"><md-item-template><span class="autocomplete-item md-accent-fg" \nmd-highlight-text="vm.searchText.ConsolidationPluginId" md-highlight-flags="i">{{item.value}}</span></md-item-template>\n<md-not-found>No Record matching "{{vm.searchText.ConsolidationPluginId}}" were found.</md-not-found></md-autocomplete>\n</div><div flex="100" class="p-5 lookup-element"><md-input-container class="md-block"><label>\n{{ \'CONSOLIDATION_TEMPLATES.FIELDS.OUTPUT_FIELD\' | translate}}</label><md-chips id="create-template-dialog-output" \nname="output" ng-model="vm.outputFieldIds" md-autocomplete-snap md-transform-chip="vm.transformChip($chip)" \nmd-require-match="true" ng-required="vm.isOutputFieldRequired(vm.outputFieldIds)"><md-autocomplete \nmd-selected-item="vm.selectedOutputFields" md-search-text="vm.acSearchText" \nmd-items="item in vm.acQuerySearch(vm.acSearchText, vm.outputFieldIds, vm.outputFields, \'OUTPUT\')" \nmd-item-text="item.value" md-min-length="0" md-no-cache="true" md-menu-class="autocomplete-custom"><md-item-template>\n<span class="autocomplete-item md-accent-fg" md-highlight-text="vm.acSearchText">{{item.value}}</span>\n</md-item-template><md-not-found>No Record matching "{{vm.acSearchText}}" were found.</md-not-found></md-autocomplete>\n<md-chip-template><span><strong>{{vm.getChipDisplayValue($chip, vm.outputFields.data)}}</strong></span>\n</md-chip-template></md-chips><div class="md-chips-messages" ng-messages="vm.editForm.output.$error" \nng-show="vm.editForm.output.$dirty || vm.editForm.output.$submitted"><div ng-message="required">\n{{\'VALIDATIONS.REQUIRED\' | translate}}</div></div></md-input-container></div><div \nng-repeat="inputField in vm.rowData.rows" ng-init="rowIndex = $index" layout="column" layout-gt-xs="row" flex="100">\n<div flex="100" flex-gt-xs="50" class="p-5 lookup-element"><md-autocomplete \nid="dialog_input_{{$first ? \'first\' : $index}}" md-input-name="InputFieldId[rowIndex]" \nmd-selected-item="vm.lookupModel.InputFieldId[rowIndex]" md-search-text="vm.searchText.InputFieldId[rowIndex]" \nmd-items="item in vm.inputFieldSearch(vm.searchText.InputFieldId[rowIndex], vm.inputFields, \'INPUT\')" \nmd-item-text="vm.getCriteriaDisplayValue(item)" md-min-length="0" \nmd-floating-label="{{\'CONSOLIDATION_TEMPLATES.FIELDS.INPUT_FIELD\' | translate}} {{rowIndex+1}}" \nng-required="vm.rowData.rows[rowIndex].FilterOperator" md-no-cache="true" tx-clear-autocomplete \nng-click="vm.selectText($event)" md-selected-item-change="vm.onCriteriaLookupChange(item, rowIndex)" \nmd-menu-class="autocomplete-custom"><md-item-template><span class="autocomplete-item md-accent-fg" \nmd-highlight-text="vm.searchText.InputFieldId[rowIndex]" md-highlight-flags="i">{{item.value}}</span>\n</md-item-template><md-not-found>No Record matching "{{vm.searchText.InputFieldId[rowIndex]}}" were found.\n</md-not-found><div ng-messages="vm.editForm.InputFieldId[rowIndex].$error" role="alert" \nng-show="vm.editForm.InputFieldId[rowIndex].$touched" multiple="multiple"><div ng-message="required">\ndaf asd{{\'VALIDATIONS.REQUIRED\' | translate}}</div></div></md-autocomplete></div><div flex="100" flex-gt-xs="50" \nclass="p-5 lookup-element"><md-autocomplete id="dialog_input_{{$first ? \'first\' : $index}}" \nmd-input-name="FilterOperator[rowIndex]" md-selected-item="vm.lookupModel.FilterOperator[rowIndex]" \nmd-search-text="vm.searchText.FilterOperator[rowIndex]" \nmd-items="item in vm.filterOperatorSearch(vm.searchText.FilterOperator[rowIndex])" \nmd-item-text="vm.getFilterOperatorDisplayValue(item)" md-min-length="0" \nmd-floating-label="{{\'CONSOLIDATION_TEMPLATES.FIELDS.FILTER_OPERATOR\' | translate}}" \nng-required="vm.rowData.rows[rowIndex].InputFieldId" md-no-cache="true" tx-clear-autocomplete \nng-click="vm.selectText($event)" md-selected-item-change="vm.onFilterOperatorChange(item, rowIndex)" \nmd-menu-class="autocomplete-custom"><md-item-template><span class="autocomplete-item md-accent-fg" \nmd-highlight-text="vm.searchText.FilterOperator[rowIndex]" md-highlight-flags="i">{{item.value}}</span>\n</md-item-template><md-not-found>No Record matching "{{vm.searchText.FilterOperator[rowIndex]}}" were found.\n</md-not-found><div ng-messages="vm.editForm.FilterOperator[rowIndex].$error" role="alert" \nng-show="vm.editForm.FilterOperator[rowIndex].$touched" multiple="multiple"><div ng-message="required">\n{{\'VALIDATIONS.REQUIRED\' | translate}}</div></div></md-autocomplete></div></div></div></md-dialog-content>\n<md-dialog-actions layout="row" layout-align="end center"><div></div><div layout="row" layout-align="end center">\n<md-button ng-click="vm.closeDialog(vm.isDataDirty)" class="send-button md-primary md-raised" aria-label="Cancel" \ntranslate="ACTIONS.DIALOG_CANCEL" translate-attr-aria-label="ACTIONS.DIALOG_CANCEL" ng-disabled="vm.isLoading">CANCEL\n</md-button><md-button ng-click="vm.saveRecord()" class="send-button md-accent md-raised" aria-label="Save" \ntranslate="ACTIONS.SAVE" translate-attr-aria-label="ACTIONS.SAVE" ng-disabled="vm.isLoading || vm.editForm.$invalid">\nSAVE</md-button><md-button ng-click="vm.saveRecord(true)" class="send-button md-accent md-raised" aria-label="Save" \ntranslate="ACTIONS.SAVE_AND_NEW" translate-attr-aria-label="ACTIONS.SAVE_AND_NEW" \nng-disabled="vm.isLoading || vm.editForm.$invalid">SAVE</md-button></div></md-dialog-actions><div layout="row" \nlayout-align="center center" ng-show="vm.isLoadingData"><md-progress-circular md-mode="indeterminate" \nclass="md-accent"></md-progress-circular></div></form></md-dialog>');
$templateCache.put('app/main/catalogs/sub-modules/consolidation-templates/list/consolidation-templates-list.html','<div id="consolidation-templates-list" class="page-layout carded fullwidth list-view" layout="row"><div class="center" \nlayout="column" flex><div class="content-card" layout="column" flex><tx-data-table tx-data="vm.consolidationTempates" \ntx-model="vm.model" tx-view="mainList" tx-filtered-data="vm.filteredConsolidationTempates" \ntx-data-filter="global.search" tx-is-loading="vm.isLoading" tx-item-action-event="vm.doItemAction(action, item)" \ntx-item-click-event="vm.viewRecord(item)" tx-refresh-action-event="vm.refreshItems(true, false)"></tx-data-table>\n<md-fab-speed-dial md-open="false" md-direction="up" class="add-rec-button md-scale"><md-fab-trigger><md-button \naria-label="menu" class="md-fab md-warn" tx-access="{{::vm.model.views.mainList.fabAction.privilege}}"><md-icon \nmd-font-icon="{{::vm.model.views.mainList.fabAction.icon}}"></md-icon><md-tooltip md-direction="left"><span \ntranslate="ARTICLES.ACTIONS.MENU"></span></md-tooltip></md-button></md-fab-trigger><md-fab-actions><md-button \nng-click="vm.addRecord($event)" aria-label="Create Template" class="md-fab md-raised md-mini md-warn" \ntx-access="{{::vm.model.views.mainList.fabAction.privilege}}"><md-icon md-font-icon="icon-plus"></md-icon><md-tooltip \nmd-direction="left"><span translate="CONSOLIDATION_TEMPLATES.ACTIONS.CREATE_TEMPLATE"></span></md-tooltip></md-button>\n<md-button ng-click="vm.copyTemplates($event)" aria-label="Copy Templates" class="md-fab md-raised md-mini md-warn">\n<md-icon md-font-icon="icon-content-copy"></md-icon><md-tooltip md-direction="left"><span \ntranslate="CONSOLIDATION_TEMPLATES.ACTIONS.COPY_TEMPLATES"></span></md-tooltip></md-button></md-fab-actions>\n</md-fab-speed-dial></div></div></div>');
$templateCache.put('app/main/catalogs/sub-modules/consolidations/details/consolidations-details.html','<div id="consolidation-details" class="page-layout simple tabbed details-view" layout="column"><div class="content">\n<md-tabs md-dynamic-height md-selected="vm.tabIndex" md-no-ink><md-tab \nlabel="{{\'CONSOLIDATIONS.TABS.CONSOLIDATION\' | translate}}" tx-access="{{::vm.model.views.privileges.details}}" \nng-disabled="!vm.consolidation.Status"><tx-data-details tx-height-offset="37" tx-is-active="vm.tabIndex === 0" \ntx-account="vm.consolidation" tx-title="vm.title" tx-model="vm.model" \ntx-item-actions="vm.model.views.mainDetails.itemActions" tx-item-action-event="vm.doItemAction(action, account)" \ntx-refresh-action-event="vm.refreshRecord(false)"></tx-data-details></md-tab><md-tab \nlabel="{{\'CONSOLIDATIONS.TABS.CRITERIA\' | translate}}" ng-disabled="!vm.consolidation.Status" \ntx-access="{{::vm.criteriaModel.views.privileges.list}}"><div class="list-tab" layout="row" flex="100" layout-wrap>\n<ms-widget layout="row" flex="100"><ms-widget-front class="white-bg"><tx-data-table tx-is-active="vm.tabIndex === 1" \ntx-data="vm.criteria" tx-model="vm.criteriaModel" tx-view="mainList" tx-filtered-data="vm.filteredCriteria" \ntx-data-filter="global.search" tx-is-loading="vm.isLoading" tx-refresh-action-event="vm.refreshRecord(false)" \ntx-height-offset="16"></tx-data-table></ms-widget-front></ms-widget></div></md-tab><md-tab \nlabel="{{\'CONSOLIDATIONS.TABS.ERROR_LIST\' | translate}}" ng-disabled="!vm.consolidation.Status" \ntx-access="{{::vm.errorsModel.views.privileges.list}}"><div class="list-tab" layout="row" flex="100" layout-wrap>\n<ms-widget layout="row" flex="100"><ms-widget-front class="white-bg"><tx-data-table tx-is-active="vm.tabIndex === 2" \ntx-data="vm.errorList" tx-model="vm.errorsModel" tx-view="mainList" tx-filtered-data="vm.filteredErrorList" \ntx-data-filter="global.search" tx-is-loading="vm.isErrorLoading" \ntx-refresh-action-event="vm.refereshErrors(true, false)" tx-height-offset="16"></tx-data-table></ms-widget-front>\n</ms-widget></div></md-tab></md-tabs></div></div>');
$templateCache.put('app/main/catalogs/sub-modules/consolidations/dialogs/create-consolidation.html','<md-dialog class="edit-dialog" aria-label="Create Consolidation"><form name="vm.editForm" class="md-inline-form">\n<md-toolbar class="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" layout-align="space-between center">\n<span class="title" translate="CONSOLIDATIONS.TITLES.CREATE_CONSOLIDATION">Create Consolidation</span><md-button \nclass="md-icon-button" ng-click="vm.closeDialog()" aria-label="Close dialog" tranlate \ntranslate-aria-label="ACTIONS.DIALOG_CLOSE"><md-icon md-font-icon="icon-close"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div layout="row" layout-wrap><div flex="100" class="p-5"><md-input-container\n class="md-block"><label translate>CONSOLIDATIONS.FIELDS.NAME</label><input \nid="dialog_input_{{$first ? \'first\' : $index}}" name="Name" ng-model="vm.record.Name" type="text" ng-required="true" \ntx-unique-value="vm.existingRecords:Name: true"><div ng-messages="vm.editForm.Name.$error" role="alert" \nmultiple="multiple"><div ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div><div \nng-message="tx-unique-value">{{\'CONSOLIDATIONS.VALIDATIONS.NOT_UNIQUE\' | translate}}</div></div></md-input-container>\n</div><div flex="100" flex-gt-xs="50" class="p-5 lookup-element"><md-autocomplete \nid="dialog_input_{{$first ? \'first\' : $index}}" md-input-name="TemplateId" \nmd-selected-item="vm.lookupModel.TemplateId" \nmd-items="item in vm.lookupSearch(vm.searchText.TemplateId, \'TemplateId\')" md-search-text="vm.searchText.TemplateId" \nmd-item-text="vm.getLookupDisplayValue(item, \'catalogs.consolidationTemplates\')" md-min-length="0" \nmd-floating-label="{{\'CONSOLIDATIONS.FIELDS.TEMPLATE_ID\' | translate}}" \nmd-selected-item-change="vm.lookupChange(vm.lookupModel.TemplateId, \'TemplateId\')" ng-disabled="!vm.isNew" \nng-required="true" md-no-cache="true" tx-clear-autocomplete tx-force-select ng-click="vm.selectText($event)" \nmd-menu-class="autocomplete-custom"><md-item-template><span class="autocomplete-item md-accent-fg" \nmd-highlight-text="vm.searchText.TemplateId" md-highlight-flags="i">{{item.value}}</span></md-item-template>\n<md-not-found>No Record matching "{{vm.searchText.TemplateId}}" were found.</md-not-found><div \nng-messages="vm.editForm.TemplateId.$error" role="alert" ng-show="vm.editForm.TemplateId.$touched"><div \nng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div></div></md-autocomplete></div><div flex="100" \nflex-gt-xs="50" class="p-5"><md-switch id="dialog_input_{{$first ? \'first\' : $index}}" \nng-model="vm.record.IncludeLockedOrders" aria-label="{{CONSOLIDATIONS.FIELDS.INCLUDE_LOCKED_ORDERS | translate}}" \nng-true-value="1" ng-false-value="0" class="md-accent" ng-disabled="!vm.isNew || vm.lockOrders">\n{{\'CONSOLIDATIONS.FIELDS.INCLUDE_LOCKED_ORDERS\' | translate}}</md-switch></div><div flex="100" flex-gt-xs="50" \nclass="p-5" ng-if="vm.canLockOrders"><md-switch id="dialog_input_{{$first ? \'first\' : $index}}" \nng-model="vm.lockOrders" aria-label="{{CONSOLIDATIONS.FIELDS.LOCK_ORDERS | translate}}" ng-true-value="1" \nng-false-value="0" class="md-accent" \nng-disabled="!vm.isNew || vm.record.IncludeRejectedOrders == 1 || vm.record.IncludeLockedOrders === 1">\n{{\'CONSOLIDATIONS.FIELDS.LOCK_ORDERS\' | translate}}</md-switch></div><div flex="100" flex-gt-xs="50" class="p-5">\n<md-switch id="dialog_input_{{$first ? \'first\' : $index}}" ng-model="vm.record.IncludeRejectedOrders" \naria-label="{{CONSOLIDATIONS.FIELDS.CONSOLIDATE_UNAPPROVED_ORDERS | translate}}" ng-true-value="1" ng-false-value="0" \nclass="md-accent" ng-disabled="!vm.isNew || vm.lockOrders === 1" ng-change="vm.onConsolidateUnapproveOrdersChange()">\n{{\'CONSOLIDATIONS.FIELDS.CONSOLIDATE_UNAPPROVED_ORDERS\' | translate}}</md-switch></div><div flex="100" flex-gt-xs="50" \nclass="p-5"><md-switch id="dialog_input_{{$first ? \'first\' : $index}}" ng-model="vm.record.IncludeChildCatalogs" \naria-label="{{CONSOLIDATIONS.FIELDS.INCLUDE_CHILD_CATALOGS | translate}}" ng-true-value="1" ng-false-value="0" \nclass="md-accent" ng-disabled="!vm.isNew">{{\'CONSOLIDATIONS.FIELDS.INCLUDE_CHILD_CATALOGS\' | translate}}</md-switch>\n</div><div ng-repeat="field in vm.templateCriteria" flex="100" flex-gt-xs="{{field.FilterOperator ? 100 : 50}}" \nclass="p-5"><div ng-if="field.ColumnDataType == \'date\' || field.ColumnDataType == \'datetime\'" layout="column" flex><div\n ng-if="field.FilterOperator !== \'BETWEEN\'"><div layout="column"><label class="md-caption">\n{{field.ColumnName}} ({{field.FilterOperator}})</label><md-datepicker id="dialog_input_{{$first ? \'first\' : $index}}" \nname="{{field.ColumnName}}" ng-model="vm.templateFieldMap[field.ConsolidationFieldId]" md-placeholder="" \nng-required="true" ng-disabled="!vm.isNew"></md-datepicker><div ng-messages="vm.editForm[field.ColumnName].$error" \nrole="alert" ng-show="vm.editForm[field.ColumnName].$touched"><div ng-message="required">\n{{\'VALIDATIONS.REQUIRED\' | translate}}</div></div></div></div><div ng-if="field.FilterOperator === \'BETWEEN\'" \nlayout="row"><div flex="50" layout="column"><label class="md-caption">{{field.ColumnName}} (From)</label><md-datepicker\n id="dialog_input_{{$first ? \'first\' : $index}}" name="{{field.ColumnName}}" \nng-model="vm.templateFieldMap[field.ConsolidationFieldId][\'from\']" md-placeholder="" ng-required="true" \nng-disabled="!vm.isNew"></md-datepicker><div ng-messages="vm.editForm[field.ColumnName].$error" role="alert" \nng-show="vm.editForm[field.ColumnName].$touched"><div ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}\n</div></div></div><div flex="50" layout="column"><label class="md-caption">{{field.ColumnName}} (To)</label>\n<md-datepicker id="dialog_input_{{$first ? \'first\' : $index}}" name="{{field.ColumnName}}" \nng-model="vm.templateFieldMap[field.ConsolidationFieldId][\'to\']" md-placeholder="" ng-required="true" \nng-disabled="!vm.isNew"></md-datepicker><div ng-messages="vm.editForm[field.ColumnName].$error" role="alert" \nng-show="vm.editForm[field.ColumnName].$touched"><div ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}\n</div></div></div></div></div><div ng-if="field.ColumnDataType == \'bit\'"><md-switch \nid="dialog_input_{{$first ? \'first\' : $index}}" name="{{field.ColumnName}}" \nng-model="vm.templateFieldMap[field.ConsolidationFieldId]" aria-label="{{field.ColumnName}}" ng-true-value="true" \nng-false-value="false" class="md-accent" ng-disabled="!vm.isNew">{{field.ColumnName}} ({{field.FilterOperator}})\n</md-switch></div><div \nng-if="field.ColumnDataType == \'bigint\' || field.ColumnDataType == \'decimal\' || field.ColumnDataType == \'int\'">\n<md-input-container class="md-block" ng-if="field.FilterOperator === \'IN\' || field.FilterOperator === \'NOT IN\'"><label>\n{{field.ColumnName}} ({{field.FilterOperator}})</label><textarea id="dialog_input_{{$first ? \'first\' : $index}}" \nname="{{field.ColumnName}}" ng-model="vm.templateFieldMap[field.ConsolidationFieldId]" columns="0" rows="2" \nstyle="max-height:100px" ng-required="true" ng-disabled="!vm.isNew" tx-max-values="2000"></textarea><div \nng-messages="vm.editForm[field.ColumnName].$error" role="alert"><div ng-message="required">\n{{\'VALIDATIONS.REQUIRED\' | translate}}</div><div ng-message="tx-max-values">\n{{\'CONSOLIDATIONS.VALIDATIONS.MAX_VALUES\' | translate}}</div></div></md-input-container><div \nng-if="field.FilterOperator === \'BETWEEN\'" layout="row"><md-input-container class="md-block" flex="50" \nstyle="padding-right: 15px"><label>{{field.ColumnName}} (From)</label><input \nid="dialog_input_{{$first ? \'first\' : $index}}" name="{{field.ColumnName}}" \nng-model="vm.templateFieldMap[field.ConsolidationFieldId][\'from\']" type="number" ng-required="true" \nng-disabled="!vm.isNew"><div ng-messages="vm.editForm[field.ColumnName].$error" role="alert"><div \nng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div></div></md-input-container><md-input-container \nclass="md-block" flex="50"><label>{{field.ColumnName}} (To)</label><input \nid="dialog_input_{{$first ? \'first\' : $index}}" name="{{field.ColumnName}}" \nng-model="vm.templateFieldMap[field.ConsolidationFieldId][\'to\']" type="number" ng-required="true" \nng-disabled="!vm.isNew"><div ng-messages="vm.editForm[field.ColumnName].$error" role="alert"><div \nng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div></div></md-input-container></div><md-input-container \nclass="md-block" \nng-if="!(field.FilterOperator === \'IN\' || field.FilterOperator === \'NOT IN\' || field.FilterOperator ===\'BETWEEN\')">\n<label>{{field.ColumnName}} ({{field.FilterOperator}})</label><input id="dialog_input_{{$first ? \'first\' : $index}}" \nname="{{field.ColumnName}}" ng-model="vm.templateFieldMap[field.ConsolidationFieldId]" type="number" \nng-required="true" ng-disabled="!vm.isNew"><div ng-messages="vm.editForm[field.ColumnName].$error" role="alert"><div \nng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div></div></md-input-container></div><div \nng-if="field.ColumnDataType == \'char\' || field.ColumnDataType == \'nchar\' || field.ColumnDataType == \'ntext\'\r\n                        || field.ColumnDataType == \'text\' || field.ColumnDataType == \'nvarchar\' || field.ColumnDataType === \'multivalue\'">\n<md-input-container class="md-block" ng-hide="field.FilterOperator === \'IN\' || field.FilterOperator === \'NOT IN\'">\n<label>{{field.ColumnName}} ({{field.FilterOperator}})</label><input id="dialog_input_{{$first ? \'first\' : $index}}" \nname="{{field.ColumnName}}" ng-model="vm.templateFieldMap[field.ConsolidationFieldId]" type="text" ng-required="true" \nng-disabled="!vm.isNew"><div ng-messages="vm.editForm[field.ColumnName].$error" role="alert"><div \nng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div></div></md-input-container><md-input-container \nclass="md-block" ng-show="field.FilterOperator === \'IN\' || field.FilterOperator === \'NOT IN\'"><label>\n{{field.ColumnName}} ({{field.FilterOperator}})</label><textarea id="dialog_input_{{$first ? \'first\' : $index}}" \nname="{{field.ColumnName}}" ng-model="vm.templateFieldMap[field.ConsolidationFieldId]" columns="0" rows="2" \nstyle="max-height:100px" ng-required="true" ng-disabled="!vm.isNew"></textarea><div \nng-messages="vm.editForm[field.ColumnName].$error" role="alert"><div ng-message="required">\n{{\'VALIDATIONS.REQUIRED\' | translate}}</div><div ng-message="tx-max-values">\n{{\'CONSOLIDATIONS.VALIDATIONS.MAX_VALUES\' | translate}}</div></div></md-input-container></div></div></div>\n</md-dialog-content><md-dialog-actions layout="row" layout-align="end center"><div></div><div layout="row" \nlayout-align="end center"><md-button ng-click="vm.closeDialog()" class="send-button md-primary md-raised" \naria-label="Cancel" translate="ACTIONS.DIALOG_CANCEL" translate-attr-aria-label="ACTIONS.DIALOG_CANCEL" \nng-disabled="vm.isLoading">CANCEL</md-button><md-button ng-click="vm.saveRecord()" \nclass="send-button md-accent md-raised" aria-label="Save" \ntranslate="{{vm.isNew ? \'CONSOLIDATIONS.ACTIONS.RUN\' : \'CONSOLIDATIONS.ACTIONS.RE_RUN\'}}" \ntranslate-attr-aria-label="{{vm.isNew ? \'CONSOLIDATIONS.ACTIONS.RUN\' : \'CONSOLIDATIONS.ACTIONS.RE_RUN\'}}" \nng-disabled="vm.isLoading || vm.editForm.$invalid">Run Consolidation</md-button></div></md-dialog-actions></form>\n</md-dialog>');
$templateCache.put('app/main/catalogs/sub-modules/consolidations/list/consolidations-list.html','<div id="consolidations-list" class="page-layout carded fullwidth list-view" layout="row"><div class="center" \nlayout="column" flex><div class="content-card" layout="column" flex><tx-data-table tx-data="vm.consolidations" \ntx-model="vm.model" tx-view="mainList" tx-filtered-data="vm.filteredConsolidations" tx-data-filter="global.search" \ntx-is-loading="vm.isLoading" tx-item-action-event="vm.doItemAction(action, item)" \ntx-item-click-event="vm.viewItem(item)" tx-refresh-action-event="vm.refreshItems(true, false)"></tx-data-table>\n<md-button class="add-rec-button md-fab md-warn" ng-click="vm.addRecord($event)" \naria-label="vm.model.views.mainList.fabAction.label" translate \ntx-access="{{::vm.model.views.mainList.fabAction.privilege}}"><md-icon \nmd-font-icon="{{vm.model.views.mainList.fabAction.icon}}"></md-icon></md-button></div></div></div>');
$templateCache.put('app/main/catalogs/sub-modules/crds/list/crds-list.html','<div id="crds-list" class="page-layout carded fullwidth list-view" layout="row"><div class="center" layout="column" \nflex><div class="content-card" layout="column" flex><tx-data-table tx-data="vm.CRDs" tx-model="vm.model" \ntx-view="mainList" tx-filtered-data="vm.filteredCRDs" tx-data-filter="global.search" tx-is-loading="vm.isLoading" \ntx-item-action-event="vm.doItemAction(action, item)" tx-list-action-event="vm.doListAction(action, selectedItems)" \ntx-item-click-event="vm.viewItem(item)" tx-refresh-action-event="vm.refreshItems(true, false)"></tx-data-table></div>\n</div></div>');
$templateCache.put('app/main/catalogs/sub-modules/crds-linear/list/crds-linear-list.html','<div id="crds-list" class="page-layout carded fullwidth list-view" layout="row"><div class="center" layout="column" \nflex><div class="content-card" layout="column" flex><tx-data-table tx-data="vm.CRDs" tx-model="vm.model" \ntx-view="mainList" tx-filtered-data="vm.filteredCRDs" tx-data-filter="global.search" tx-is-loading="vm.isLoading" \ntx-item-action-event="vm.doItemAction(action, item)" tx-list-action-event="vm.doListAction(action, selectedItems)" \ntx-item-click-event="vm.viewItem(item)" tx-refresh-action-event="vm.refreshItems(true, false)"></tx-data-table>\n<md-button class="add-rec-button md-fab md-warn" ng-click="vm.assignCRDs($event)" \naria-label="vm.model.views.mainList.fabAction.label" translate \ntx-access="{{::vm.model.views.mainList.fabAction.privilege}}"><md-icon \nmd-font-icon="{{vm.model.views.mainList.fabAction.icon}}"></md-icon></md-button></div></div></div>');
$templateCache.put('app/main/catalogs/sub-modules/customer-allocations/details/customer-allocations-details.html','<div id="allocation-groups-details" class="page-layout simple tabbed details-view" layout="column"><div \nclass="content"><md-tabs md-dynamic-height md-selected="vm.tabIndex" md-no-ink><md-tab \nlabel="{{\'CUSTOMER_ALLOCATIONS.TABS.CUSTOMER_ALLOCATION\' | translate}}" \ntx-access="{{::vm.model.views.privileges.details}}" ng-disabled="!vm.customerAllocation.Status"><tx-data-details \ntx-height-offset="37" tx-account="vm.customerAllocation" tx-title="vm.title" tx-model="vm.model" \ntx-item-actions="vm.model.views.mainDetails.itemActions" \ntx-item-action-event="vm.doArticleItemAction(action, account)" tx-is-loading="vm.isLoading" \ntx-refresh-action-event="vm.refreshRecord(false)" tx-parent-id="vm.activeCatalog.CatalogCode"></tx-data-details>\n</md-tab><md-tab label="{{\'CUSTOMER_ALLOCATIONS.TABS.ALLOCATION_GROUPS\' | translate}}" \nng-disabled="!vm.customerAllocation.Status" tx-access="{{::vm.allocationGroupsModel.views.privileges.list}}"><div \nclass="list-tab" layout="row" flex="100" layout-wrap><ms-widget layout="row" flex="100"><ms-widget-front \nclass="white-bg"><tx-data-table tx-is-active="vm.tabIndex === 1" tx-data="vm.allocationGroups" \ntx-model="vm.allocationGroupsModel" tx-view="mainList" tx-filtered-data="vm.filteredAllocationGroups" \ntx-data-filter="global.search" tx-is-loading="vm.isLoading" tx-refresh-action-event="vm.refreshRecord(false)" \ntx-item-action-event="vm.doAllocationGroupsItemAction(action, item)" \ntx-item-click-event="vm.viewAllocationGroupsDetails(item)" tx-height-offset="16"></tx-data-table></ms-widget-front>\n</ms-widget></div></md-tab></md-tabs><md-button class="add-rec-button md-fab md-warn" ng-if="vm.tabIndex === 0" \nng-click="vm.edit(vm.customerAllocation, $event)" aria-label="vm.model.views.mainDetails.fab.label" translate \ntx-access="{{::vm.model.views.mainDetails.fab.privilege}}"><md-icon \nmd-font-icon="{{vm.model.views.mainDetails.fab.icon}}"></md-icon></md-button></div></div>');
$templateCache.put('app/main/catalogs/sub-modules/customer-allocations/dialogs/assign-allocation-groups.html','<md-dialog class="edit-dialog" aria-label="Assign allocation groups"><form name="vm.editForm" class="md-inline-form">\n<md-toolbar class="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" layout-align="space-between center">\n<span class="title" \ntranslate="{{vm.isNew ? \'CUSTOMER_ALLOCATIONS.TITLE.ASSIGN_ALLOCATION_GROUPS\' : \'CUSTOMER_ALLOCATIONS.TITLE.UPDATE_ALLOCATION_GROUPS\'}}">\n{{vm.isNew ? \'Assign Allocation Groups\' : \'Update Allocation Groups\'}}</span><md-button class="md-icon-button" \nng-click="vm.closeDialog(vm.isDataDirty)" aria-label="Close dialog" tranlate \ntranslate-aria-label="ACTIONS.DIALOG_CLOSE"><md-icon md-font-icon="icon-close"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div layout="row" layout-wrap><div flex="100" class="p-5 lookup-element">\n<md-autocomplete id="dialog_input_first" md-input-name="customerId" md-selected-item="vm.lookupModel[0].customerId" \nmd-items="item in vm.searchCustomer(vm.searchText[0].customerId)" md-search-text="vm.searchText[0].customerId" \nmd-item-text="vm.getCustomerDisplayValue(item)" md-min-length="0" \nmd-floating-label="{{\'CUSTOMER_ALLOCATIONS.FIELDS.CUSTOMER\' | translate}}" \nmd-selected-item-change="vm.onCustomerChange(vm.lookupModel[0].customerId)" ng-required="true" md-autofocus="vm.isNew" \nmd-no-cache="true" tx-clear-autocomplete tx-force-select ng-click="vm.selectText($event)" \nmd-menu-class="autocomplete-custom" ng-disabled="!vm.isNew"><md-item-template><span \nclass="autocomplete-item md-accent-fg" md-highlight-text="vm.searchText[0].customerId" md-highlight-flags="i">\n{{item.CustomerNumber}}</span></md-item-template><div ng-messages="vm.editForm.customerId.$error" role="alert" \nng-show="vm.editForm.customerId.$touched"><div ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div></div>\n<md-not-found>No Record matching "{{vm.searchText.customerId}}" were found.</md-not-found></md-autocomplete></div><div \nng-repeat="record in vm.records" flex="100" layout="row" layout-wrap><div flex="100" flex-gt-xs="50" \nclass="p-5 lookup-element"><md-autocomplete id="allocation_group_{{$index}}" md-input-name="AllocationGroupId_$index" \nmd-selected-item="vm.lookupModel[$index].AllocationGroupId" \nmd-items="item in vm.lookupSearch(vm.searchText[$index].AllocationGroupId)" \nmd-search-text="vm.searchText[$index].AllocationGroupId" md-item-text="vm.getLookupDisplayValue(item)" \nmd-min-length="0" md-floating-label="{{\'CUSTOMER_ALLOCATIONS.FIELDS.ALLOCATION_GROUP_NAME\' | translate}} {{$index+1}}" \nmd-selected-item-change="vm.lookupChange(vm.lookupModel[$index].AllocationGroupId, $index)" \nng-required="vm.isRequired(\'AllocationGroupId\', \'Quantity\', \'MinQuantity\', $index)" md-autofocus="!vm.isNew && $first" \nmd-no-cache="true" tx-clear-autocomplete ng-click="vm.selectText($event)" md-menu-class="autocomplete-custom">\n<md-item-template><span class="autocomplete-item md-accent-fg" \nmd-highlight-text="vm.searchText[$index].AllocationGroupId" md-highlight-flags="i">{{item.AllocationGroupName}}</span>\n</md-item-template><div ng-messages="vm.editForm.AllocationGroupId_$index.$error" role="alert" \nng-show="vm.editForm.AllocationGroupId_$index.$touched"><div ng-message="required">\n{{\'VALIDATIONS.REQUIRED\' | translate}}</div></div><md-not-found>\nNo Record matching "{{vm.searchText[$index].AllocationGroupId}}" were found.</md-not-found></md-autocomplete></div><div\n flex="100" flex-gt-xs="25" class="p-5"><md-input-container class="md-block"><label>\n{{\'CUSTOMER_ALLOCATIONS.FIELDS.MIN_QUANTITY\' | translate}} {{$index+1}}</label><input \nid="customer_allocation_min_quantity_{{$index}}" name="MinQuantity_$index" ng-model="vm.records[$index].MinQuantity" \ntype="number" ng-required="vm.isRequired(\'AllocationGroupId\', \'Quantity\', \'MinQuantity\', $index)" \nng-change="vm.onQuantityChange($index)"><div ng-messages="vm.editForm.MinQuantity_$index.$error" role="alert" \nmultiple="multiple"><div ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div></div></md-input-container>\n</div><div flex="100" flex-gt-xs="25" class="p-5"><md-input-container class="md-block"><label>\n{{\'CUSTOMER_ALLOCATIONS.FIELDS.QUANTITY\' | translate}} {{$index+1}}</label><input \nid="customer_allocation_quantity_{{$index}}" name="Quantity_$index" ng-model="vm.records[$index].Quantity" \ntype="number" ng-required="vm.isRequired(\'AllocationGroupId\', \'Quantity\', \'MinQuantity\', $index)" \nng-change="vm.onQuantityChange($index)" min="{{vm.records[$index].MinQuantity}}"><div \nng-messages="vm.editForm.Quantity_$index.$error" role="alert" multiple="multiple"><div ng-message="required">\n{{\'VALIDATIONS.REQUIRED\' | translate}}</div><div ng-message="min">{{\'VALIDATIONS.MIN_QTY\' | translate}}</div></div>\n</md-input-container></div></div></div></md-dialog-content><md-dialog-actions layout="row" layout-align="end center">\n<div></div><div layout="row" layout-align="end center"><md-button ng-click="vm.closeDialog(vm.isDataDirty)" \nclass="send-button md-primary md-raised" aria-label="Cancel" translate="ACTIONS.DIALOG_CANCEL" \ntranslate-attr-aria-label="ACTIONS.DIALOG_CANCEL" ng-disabled="vm.isLoading">CANCEL</md-button><md-button \nng-click="vm.saveRecord()" class="send-button md-accent md-raised" aria-label="Save" translate="ACTIONS.SAVE" \ntranslate-attr-aria-label="ACTIONS.SAVE" ng-disabled="vm.isLoading || vm.editForm.$invalid">SAVE</md-button><md-button \nng-click="vm.saveRecord(true)" class="send-button md-accent md-raised" aria-label="Save" \ntranslate="ACTIONS.SAVE_AND_NEW" translate-attr-aria-label="ACTIONS.SAVE_AND_NEW" \nng-disabled="vm.isLoading || vm.editForm.$invalid" ng-show="vm.isNew">SAVE</md-button></div></md-dialog-actions></form>\n</md-dialog>');
$templateCache.put('app/main/catalogs/sub-modules/customer-allocations/list/customer-allocations-list.html','<div id="allocation-group-list" class="page-layout carded fullwidth list-view" layout="row"><div class="center" \nlayout="column" flex><div class="content-card" layout="column" flex><tx-data-table tx-data="vm.customerAllocations" \ntx-model="vm.model" tx-view="mainList" tx-filtered-data="vm.filteredCustomerAllocations" \ntx-data-filter="global.search" tx-is-loading="vm.isLoading" tx-item-action-event="vm.doItemAction(action, item)" \ntx-list-action-event="vm.doListAction(action, selectedItems)" tx-item-click-event="vm.viewItem(item)" \ntx-refresh-action-event="vm.refreshItems(true, false)"></tx-data-table><md-button \nclass="add-rec-button md-fab md-warn" ng-click="vm.addRecord($event)" \naria-label="vm.model.views.mainList.fabAction.label" translate \ntx-access="{{::vm.model.views.mainList.fabAction.privilege}}"><md-icon \nmd-font-icon="{{vm.model.views.mainList.fabAction.icon}}"></md-icon></md-button></div></div></div>');
$templateCache.put('app/main/catalogs/sub-modules/customers/details/customers-details.html','<div id="customer-details" class="page-layout simple tabbed details-view" layout="column"><div class="content"><md-tabs\n md-dynamic-height md-selected="vm.tabIndex" md-no-ink><md-tab \nlabel="{{\'LINKED_CUSTOMERS.TABS.CUSTOMER\' | translate}}" tx-access="{{::vm.model.views.privileges.details}}" \nng-disabled="!vm.customer.Status"><tx-data-details tx-height-offset="37" tx-is-active="vm.tabIndex === 0" \ntx-account="vm.customer" tx-title="vm.title" tx-model="vm.model" \ntx-item-actions="vm.model.views.mainDetails.itemActions" tx-is-loading="vm.isLoading" \ntx-item-action-event="vm.doCustomerItemAction(action, account)" tx-refresh-action-event="vm.refreshRecord(false)">\n</tx-data-details></md-tab><md-tab label="{{\'LINKED_CUSTOMERS.TABS.SEGMENTATIONS\' | translate}}" \nng-disabled="!vm.customer.Status" tx-access="{{::vm.segmentationModel.views.privileges.list}}"><div class="list-tab" \nlayout="row" flex="100" layout-wrap><ms-widget layout="row" flex="100"><ms-widget-front class="white-bg"><tx-data-table\n tx-is-active="vm.tabIndex === 1" tx-data="vm.segmentations" tx-model="vm.segmentationModel" tx-view="mainList" \ntx-filtered-data="vm.filteredSegmentations" tx-data-filter="global.search" tx-is-loading="vm.isSegmentationsLoading" \ntx-item-action-event="vm.doSegmentationsItemAction(action, item)" \ntx-list-action-event="vm.doSegmentationsListAction(action, selectedItems)" \ntx-refresh-action-event="vm.refreshSegmentations(true, false)" tx-height-offset="16"></tx-data-table></ms-widget-front>\n</ms-widget><md-button class="add-rec-button md-fab md-warn" ng-click="vm.assignSegmentation($event)" \naria-label="vm.segmentationModel.views.mainList.fabAction.label" translate \ntx-access="{{::vm.segmentationModel.views.mainList.fabAction.privilege}}"><md-icon \nmd-font-icon="{{vm.segmentationModel.views.mainList.fabAction.icon}}"></md-icon></md-button></div></md-tab><md-tab \nlabel="{{\'LINKED_CUSTOMERS.TABS.FAVORITES\' | translate}}" ng-disabled="!vm.customer.Status" \ntx-access="{{::vm.favoriteModel.views.privileges.list}}"><div class="list-tab" layout="row" flex="100" layout-wrap>\n<ms-widget layout="row" flex="100"><ms-widget-front class="white-bg"><tx-data-table tx-is-active="vm.tabIndex === 2" \ntx-data="vm.favorites" tx-model="vm.favoriteModel" tx-view="mainList" tx-filtered-data="vm.filteredFavorites" \ntx-data-filter="global.search" tx-is-loading="vm.isFavoritesLoading" \ntx-item-action-event="vm.doFavoritesItemAction(action, item)" \ntx-list-action-event="vm.doFavoritesListAction(action, selectedItems)" \ntx-refresh-action-event="vm.refreshFavorites(true, false)" tx-height-offset="16"></tx-data-table></ms-widget-front>\n</ms-widget><md-button class="add-rec-button md-fab md-warn" ng-click="vm.createFavorite($event)" \naria-label="vm.favoriteModel.views.mainList.fabAction.label" translate \ntx-access="{{::vm.favoriteModel.views.mainList.fabAction.privilege}}"><md-icon \nmd-font-icon="{{vm.favoriteModel.views.mainList.fabAction.icon}}"></md-icon></md-button></div></md-tab><md-tab \nlabel="{{\'LINKED_CUSTOMERS.TABS.LOCATIONS\' | translate}}" ng-disabled="!vm.customer.Status" \ntx-access="{{::vm.locationsModel.views.privileges.list}}"><div class="list-tab" layout="row" flex="100" layout-wrap>\n<ms-widget layout="row" flex="100"><ms-widget-front class="white-bg"><tx-data-table tx-is-active="vm.tabIndex === 3" \ntx-data="vm.locations" tx-model="vm.locationsModel" tx-view="mainList" tx-filtered-data="vm.filteredLocations" \ntx-data-filter="global.search" tx-is-loading="vm.isLocationLoading" \ntx-item-action-event="vm.doLocationsItemAction(action, item)" \ntx-list-action-event="vm.doLocationsListAction(action, selectedItems)" tx-item-click-event="vm.viewLocation(item)" \ntx-refresh-action-event="vm.refreshLocations(true, false)" tx-height-offset="16"></tx-data-table></ms-widget-front>\n</ms-widget><md-button class="add-rec-button md-fab md-warn" ng-click="vm.addLocation($event)" \naria-label="vm.locationsModel.views.mainList.fabAction.label" translate \ntx-access="{{::vm.locationsModel.views.mainList.fabAction.privilege}}"><md-icon \nmd-font-icon="{{vm.locationsModel.views.mainList.fabAction.icon}}"></md-icon></md-button></div></md-tab><md-tab \nlabel="{{\'LINKED_CUSTOMERS.TABS.STOCKS\' | translate}}" ng-disabled="!vm.customer.Status" \ntx-access="{{::vm.stocksModel.views.privileges.list}}"><div class="list-tab" layout="row" flex="100" layout-wrap>\n<ms-widget layout="row" flex="100"><ms-widget-front class="white-bg"><tx-data-table tx-is-active="vm.tabIndex === 4" \ntx-data="vm.stocks" tx-model="vm.stocksModel" tx-view="mainList" tx-filtered-data="vm.filteredStocks" \ntx-data-filter="global.search" tx-is-loading="vm.isLoading" tx-refresh-action-event="vm.refreshRecord(true, false)" \ntx-height-offset="16"></tx-data-table></ms-widget-front></ms-widget></div></md-tab><md-tab \nlabel="{{\'LINKED_CUSTOMERS.TABS.CAPACITIES\' | translate}}" ng-disabled="!vm.customer.Status" \ntx-access="{{::vm.capacitiesModel.views.privileges.list}}"><div class="list-tab" layout="row" flex="100" layout-wrap>\n<ms-widget layout="row" flex="100"><ms-widget-front class="white-bg"><tx-data-table tx-is-active="vm.tabIndex === 5" \ntx-data="vm.capacities" tx-model="vm.capacitiesModel" tx-view="mainList" tx-filtered-data="vm.filteredCapacities" \ntx-data-filter="global.search" tx-is-loading="vm.isCapacitiesLoading" \ntx-item-action-event="vm.doCapacitiesItemAction(action, item)" \ntx-list-action-event="vm.doCapacitiesListAction(action, selectedItems)" \ntx-refresh-action-event="vm.refreshCapacities(true, false)" tx-height-offset="16"></tx-data-table></ms-widget-front>\n</ms-widget><md-button class="add-rec-button md-fab md-warn" ng-click="vm.assignCapacity($event)" \naria-label="vm.capacitiesModel.views.mainList.fabAction.label" translate \ntx-access="{{::vm.capacitiesModel.views.mainList.fabAction.privilege}}"><md-icon \nmd-font-icon="{{vm.capacitiesModel.views.mainList.fabAction.icon}}"></md-icon></md-button></div></md-tab></md-tabs>\n<md-button id="txfab" class="md-fab md-warn" ng-if="vm.tabIndex === 0" ng-click="vm.editCustomer($event, vm.customer)" \naria-label="vm.model.views.mainDetails.fab.label" translate tx-access="{{::vm.model.views.mainDetails.fab.privilege}}" \nng-disabled="!vm.customer.Status"><md-icon md-font-icon="{{vm.model.views.mainDetails.fab.icon}}"></md-icon>\n</md-button></div></div>');
$templateCache.put('app/main/catalogs/sub-modules/customers/dialogs/update-catalog-customer-relation.html','<md-dialog class="edit-dialog" aria-label="{{vm.isNew ? \'Link Catalog\' : \'Edit Linked Catalog\'}"><form \nname="vm.editForm" class="md-inline-form"><md-toolbar class="md-accent md-hue-2"><div class="md-toolbar-tools" \nlayout="row" layout-align="space-between center"><span class="title" \ntranslate="{{vm.isNew ? \'TITLES.RECORD_NEW\' : \'TITLES.RECORD_EDIT\'}}">New Record</span><md-button \nclass="md-icon-button" ng-click="vm.closeDialog(vm.isDataDirty)" aria-label="Close dialog" tranlate \ntranslate-aria-label="ACTIONS.DIALOG_CLOSE"><md-icon md-font-icon="icon-close"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div layout="row" layout-wrap><div flex="100" flex-gt-xs="50" \nclass="p-5 lookup-element" ng-if="vm.isNew"><md-autocomplete id="dialog_input_{{$first ? \'first\' : $index}}" \nmd-input-name="CustomerId" md-selected-item="vm.acLookupModel.CustomerId" \nmd-items="item in vm.custLookupSearch(vm.searchText.CustomerId, \'CustomerId\', vm.activeCustomers)" \nmd-search-text="vm.searchText.CustomerId" md-item-text="vm.getLookupDisplayValue(item, \'CustomerId\')" \nmd-min-length="0" md-floating-label="{{\'LINKED_CUSTOMERS.FIELDS.CUSTOMER_NUMBER\' | translate}}" \nmd-selected-item-change="vm.lookupChange(vm.acLookupModel.CustomerId, \'CustomerId\')" ng-required="true" \nmd-require-match="true" md-no-cache="true" tx-clear-autocomplete ng-click="vm.selectText($event)" \nmd-menu-class="autocomplete-custom"><md-item-template><span class="autocomplete-item md-accent-fg" \nmd-highlight-text="vm.searchText.CustomerId" md-highlight-flags="i">{{item.value}}</span></md-item-template>\n<md-not-found>No Record matching "{{vm.searchText.CustomerId}}" were found.</md-not-found><div \nng-messages="vm.editForm.CustomerId.$error" role="alert" ng-show="vm.editForm.CustomerId.$touched"><div \nng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div></div></md-autocomplete></div><div flex="100" \nflex-gt-xs="50" class="p-5 lookup-element"><md-autocomplete id="dialog_input_{{$first ? \'first\' : $index}}" \nmd-input-name="WholesalePriceGroupId" md-selected-item="vm.acLookupModel.WholesalePriceGroupId" \nmd-items="item in vm.pgLookupSearch(vm.searchText.WholesalePriceGroupId, \'WholesalePriceGroupId\', vm.priceGroups)" \nmd-search-text="vm.searchText.WholesalePriceGroupId" \nmd-item-text="vm.getLookupDisplayValue(item, \'WholesalePriceGroupId\')" md-min-length="0" \nmd-floating-label="{{\'LINKED_CUSTOMERS.FIELDS.WHOLESALE_PRICE_GROUP\' | translate}}" \nmd-selected-item-change="vm.lookupChange(vm.acLookupModel.WholesalePriceGroupId, \'WholesalePriceGroupId\')" \nng-required="!vm.record.RetailPriceGroupId" md-no-cache="true" tx-clear-autocomplete ng-click="vm.selectText($event)" \nmd-menu-class="autocomplete-custom"><md-item-template><span class="autocomplete-item md-accent-fg" \nmd-highlight-text="vm.searchText.WholesalePriceGroupId" md-highlight-flags="i">{{item.value}}</span></md-item-template>\n<md-not-found>No Record matching "{{vm.searchText.WholesalePriceGroupId}}" were found.</md-not-found><div \nng-messages="vm.editForm.WholesalePriceGroupId.$error" role="alert" \nng-show="vm.editForm.WholesalePriceGroupId.$touched"><div ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}\n</div></div></md-autocomplete></div><div flex="100" flex-gt-xs="50" class="p-5 lookup-element"><md-autocomplete \nid="dialog_input_{{$first ? \'first\' : $index}}" md-input-name="WholesaleAltPriceGroupId" \nmd-selected-item="vm.acLookupModel.WholesaleAltPriceGroupId" \nmd-items="item in vm.pgLookupSearch(vm.searchText.WholesaleAltPriceGroupId, \'WholesaleAltPriceGroupId\', vm.priceGroups)" \nmd-search-text="vm.searchText.WholesaleAltPriceGroupId" \nmd-item-text="vm.getLookupDisplayValue(item, \'WholesaleAltPriceGroupId\')" md-min-length="0" \nmd-floating-label="{{\'LINKED_CUSTOMERS.FIELDS.WHOLESALE_ALT_PRICE_GROUP\' | translate}}" \nmd-selected-item-change="vm.lookupChange(vm.acLookupModel.WholesaleAltPriceGroupId, \'WholesaleAltPriceGroupId\')" \nng-required="false" md-no-cache="true" tx-clear-autocomplete ng-click="vm.selectText($event)" \nmd-menu-class="autocomplete-custom"><md-item-template><span class="autocomplete-item md-accent-fg" \nmd-highlight-text="vm.searchText.WholesaleAltPriceGroupId" md-highlight-flags="i">{{item.value}}</span>\n</md-item-template><md-not-found>No Record matching "{{vm.searchText.WholesaleAltPriceGroupId}}" were found.\n</md-not-found><div ng-messages="vm.editForm.WholesaleAltPriceGroupId.$error" role="alert" \nng-show="vm.editForm.WholesaleAltPriceGroupId.$touched"><div ng-message="required">\n{{\'VALIDATIONS.REQUIRED\' | translate}}</div></div></md-autocomplete></div><div flex="100" flex-gt-xs="50" \nclass="p-5 lookup-element"><md-autocomplete id="dialog_input_{{$first ? \'first\' : $index}}" \nmd-input-name="RetailPriceGroupId" md-selected-item="vm.acLookupModel.RetailPriceGroupId" \nmd-items="item in vm.pgLookupSearch(vm.searchText.RetailPriceGroupId, \'RetailPriceGroupId\', vm.priceGroups)" \nmd-search-text="vm.searchText.RetailPriceGroupId" md-item-text="vm.getLookupDisplayValue(item, \'RetailPriceGroupId\')" \nmd-min-length="0" md-floating-label="{{\'LINKED_CUSTOMERS.FIELDS.RETAIL_PRICE_GROUP\' | translate}}" \nmd-selected-item-change="vm.lookupChange(vm.acLookupModel.RetailPriceGroupId, \'RetailPriceGroupId\')" \nng-required="!vm.record.WholesalePriceGroupId" md-no-cache="true" tx-clear-autocomplete \nng-click="vm.selectText($event)" md-menu-class="autocomplete-custom"><md-item-template><span \nclass="autocomplete-item md-accent-fg" md-highlight-text="vm.searchText.RetailPriceGroupId" md-highlight-flags="i">\n{{item.value}}</span></md-item-template><md-not-found>\nNo Record matching "{{vm.searchText.RetailPriceGroupId}}" were found.</md-not-found><div \nng-messages="vm.editForm.RetailPriceGroupId.$error" role="alert" ng-show="vm.editForm.RetailPriceGroupId.$touched"><div\n ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div></div></md-autocomplete></div><div flex="100" \nflex-gt-xs="50" class="p-5 lookup-element"><md-autocomplete id="dialog_input_{{$first ? \'first\' : $index}}" \nmd-input-name="RetailAltPriceGroupId" md-selected-item="vm.acLookupModel.RetailAltPriceGroupId" \nmd-items="item in vm.pgLookupSearch(vm.searchText.RetailAltPriceGroupId, \'RetailAltPriceGroupId\', vm.priceGroups)" \nmd-search-text="vm.searchText.RetailAltPriceGroupId" \nmd-item-text="vm.getLookupDisplayValue(item, \'RetailAltPriceGroupId\')" md-min-length="0" \nmd-floating-label="{{\'LINKED_CUSTOMERS.FIELDS.RETAIL_ALT_PRICE_GROUP\' | translate}}" \nmd-selected-item-change="vm.lookupChange(vm.acLookupModel.RetailAltPriceGroupId, \'RetailAltPriceGroupId\')" \nng-required="false" md-no-cache="true" tx-clear-autocomplete ng-click="vm.selectText($event)" \nmd-menu-class="autocomplete-custom"><md-item-template><span class="autocomplete-item md-accent-fg" \nmd-highlight-text="vm.searchText.RetailAltPriceGroupId" md-highlight-flags="i">{{item.value}}</span></md-item-template>\n<md-not-found>No Record matching "{{vm.searchText.RetailAltPriceGroupId}}" were found.</md-not-found><div \nng-messages="vm.editForm.RetailAltPriceGroupId.$error" role="alert" \nng-show="vm.editForm.RetailAltPriceGroupId.$touched"><div ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}\n</div></div></md-autocomplete></div><div flex="100" flex-gt-xs="50" class="p-5 lookup-element"><md-autocomplete \nid="dialog_input_{{$first ? \'first\' : $index}}" md-input-name="AccountManager1" \nmd-selected-item="vm.acLookupModel.AccountManager1" \nmd-items="item in vm.usersLookupSearch(vm.searchText.AccountManager1, \'AccountManager1\')" \nmd-search-text="vm.searchText.AccountManager1" md-item-text="vm.getLookupDisplayValue(item, \'AccountManager1\')" \nmd-min-length="0" md-floating-label="{{\'LINKED_CUSTOMERS.FIELDS.ACCOUNT_MANAGER_1\' | translate}}" \nmd-selected-item-change="vm.lookupChange(vm.acLookupModel.AccountManager1, \'AccountManager1\')" ng-required="true" \nmd-no-cache="true" tx-clear-autocomplete ng-click="vm.selectText($event)" md-menu-class="autocomplete-custom">\n<md-item-template><span class="autocomplete-item md-accent-fg" md-highlight-text="vm.searchText.AccountManager1" \nmd-highlight-flags="i">{{item.value}}</span></md-item-template><md-not-found>\nNo Record matching "{{vm.searchText.AccountManager1}}" were found.</md-not-found><div \nng-messages="vm.editForm.AccountManager1.$error" role="alert" ng-show="vm.editForm.AccountManager1.$touched"><div \nng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div></div></md-autocomplete></div><div flex="100" \nflex-gt-xs="50" class="p-5 lookup-element"><md-autocomplete id="dialog_input_{{$first ? \'first\' : $index}}" \nmd-input-name="AccountManager2" md-selected-item="vm.acLookupModel.AccountManager2" \nmd-items="item in vm.usersLookupSearch(vm.searchText.AccountManager2, \'AccountManager2\')" \nmd-search-text="vm.searchText.AccountManager2" md-item-text="vm.getLookupDisplayValue(item, \'AccountManager2\')" \nmd-min-length="0" md-floating-label="{{\'LINKED_CUSTOMERS.FIELDS.ACCOUNT_MANAGER_2\' | translate}}" \nmd-selected-item-change="vm.lookupChange(vm.acLookupModel.AccountManager2, \'AccountManager2\')" ng-required="false" \nmd-no-cache="true" tx-clear-autocomplete ng-click="vm.selectText($event)" md-menu-class="autocomplete-custom">\n<md-item-template><span class="autocomplete-item md-accent-fg" md-highlight-text="vm.searchText.AccountManager2" \nmd-highlight-flags="i">{{item.value}}</span></md-item-template><md-not-found>\nNo Record matching "{{vm.searchText.AccountManager2}}" were found.</md-not-found><div \nng-messages="vm.editForm.AccountManager2.$error" role="alert" ng-show="vm.editForm.AccountManager2.$touched"><div \nng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div></div></md-autocomplete></div><div flex="100" \nflex-gt-xs="50" class="p-5 lookup-element"><md-autocomplete id="dialog_input_{{$first ? \'first\' : $index}}" \nmd-input-name="AccountManager3" md-selected-item="vm.acLookupModel.AccountManager3" \nmd-items="item in vm.usersLookupSearch(vm.searchText.AccountManager3, \'AccountManager3\')" \nmd-search-text="vm.searchText.AccountManager3" md-item-text="vm.getLookupDisplayValue(item, \'AccountManager3\')" \nmd-min-length="0" md-floating-label="{{\'LINKED_CUSTOMERS.FIELDS.ACCOUNT_MANAGER_3\' | translate}}" \nmd-selected-item-change="vm.lookupChange(vm.acLookupModel.AccountManager3, \'AccountManager3\')" ng-required="false" \nmd-no-cache="true" tx-clear-autocomplete ng-click="vm.selectText($event)" md-menu-class="autocomplete-custom">\n<md-item-template><span class="autocomplete-item md-accent-fg" md-highlight-text="vm.searchText.AccountManager3" \nmd-highlight-flags="i">{{item.value}}</span></md-item-template><md-not-found>\nNo Record matching "{{vm.searchText.AccountManager3}}" were found.</md-not-found><div \nng-messages="vm.editForm.AccountManager3.$error" role="alert" ng-show="vm.editForm.AccountManager3.$touched"><div \nng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div></div></md-autocomplete></div><div flex="100" \nflex-gt-xs="50" class="p-5 lookup-element"><md-autocomplete id="dialog_input_{{$first ? \'first\' : $index}}" \nmd-input-name="AccountManager4" md-selected-item="vm.acLookupModel.AccountManager4" \nmd-items="item in vm.usersLookupSearch(vm.searchText.AccountManager4, \'AccountManager4\')" \nmd-search-text="vm.searchText.AccountManager4" md-item-text="vm.getLookupDisplayValue(item, \'AccountManager4\')" \nmd-min-length="0" md-floating-label="{{\'LINKED_CUSTOMERS.FIELDS.ACCOUNT_MANAGER_4\' | translate}}" \nmd-selected-item-change="vm.lookupChange(vm.acLookupModel.AccountManager4, \'AccountManager4\')" ng-required="false" \nmd-no-cache="true" tx-clear-autocomplete ng-click="vm.selectText($event)" md-menu-class="autocomplete-custom">\n<md-item-template><span class="autocomplete-item md-accent-fg" md-highlight-text="vm.searchText.AccountManager4" \nmd-highlight-flags="i">{{item.value}}</span></md-item-template><md-not-found>\nNo Record matching "{{vm.searchText.AccountManager4}}" were found.</md-not-found><div \nng-messages="vm.editForm.AccountManager4.$error" role="alert" ng-show="vm.editForm.AccountManager4.$touched"><div \nng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div></div></md-autocomplete></div><div flex="100" \nflex-gt-xs="50" class="p-5 lookup-element"><md-autocomplete id="dialog_input_{{$first ? \'first\' : $index}}" \nmd-input-name="AccountManager5" md-selected-item="vm.acLookupModel.AccountManager5" \nmd-items="item in vm.usersLookupSearch(vm.searchText.AccountManager5, \'AccountManager5\')" \nmd-search-text="vm.searchText.AccountManager5" md-item-text="vm.getLookupDisplayValue(item, \'AccountManager5\')" \nmd-min-length="0" md-floating-label="{{\'LINKED_CUSTOMERS.FIELDS.ACCOUNT_MANAGER_5\' | translate}}" \nmd-selected-item-change="vm.lookupChange(vm.acLookupModel.AccountManager5, \'AccountManager5\')" ng-required="false" \nmd-no-cache="true" tx-clear-autocomplete ng-click="vm.selectText($event)" md-menu-class="autocomplete-custom">\n<md-item-template><span class="autocomplete-item md-accent-fg" md-highlight-text="vm.searchText.AccountManager5" \nmd-highlight-flags="i">{{item.value}}</span></md-item-template><md-not-found>\nNo Record matching "{{vm.searchText.AccountManager5}}" were found.</md-not-found><div \nng-messages="vm.editForm.AccountManager5.$error" role="alert" ng-show="vm.editForm.AccountManager5.$touched"><div \nng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div></div></md-autocomplete></div><div flex="100" \nflex-gt-xs="50" class="p-5 lookup-element"><md-autocomplete id="dialog_input_{{$first ? \'first\' : $index}}" \nmd-input-name="AccountManager6" md-selected-item="vm.acLookupModel.AccountManager6" \nmd-items="item in vm.usersLookupSearch(vm.searchText.AccountManager6, \'AccountManager6\')" \nmd-search-text="vm.searchText.AccountManager6" md-item-text="vm.getLookupDisplayValue(item, \'AccountManager6\')" \nmd-min-length="0" md-floating-label="{{\'LINKED_CUSTOMERS.FIELDS.ACCOUNT_MANAGER_6\' | translate}}" \nmd-selected-item-change="vm.lookupChange(vm.acLookupModel.AccountManager6, \'AccountManager6\')" ng-required="false" \nmd-no-cache="true" tx-clear-autocomplete ng-click="vm.selectText($event)" md-menu-class="autocomplete-custom">\n<md-item-template><span class="autocomplete-item md-accent-fg" md-highlight-text="vm.searchText.AccountManager6" \nmd-highlight-flags="i">{{item.value}}</span></md-item-template><md-not-found>\nNo Record matching "{{vm.searchText.AccountManager6}}" were found.</md-not-found><div \nng-messages="vm.editForm.AccountManager6.$error" role="alert" ng-show="vm.editForm.AccountManager6.$touched"><div \nng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div></div></md-autocomplete></div><div flex="100" \nflex-gt-xs="50" class="p-5 lookup-element"><md-autocomplete id="dialog_input_{{$first ? \'first\' : $index}}" \nmd-input-name="AccountManager7" md-selected-item="vm.acLookupModel.AccountManager7" \nmd-items="item in vm.usersLookupSearch(vm.searchText.AccountManager7, \'AccountManager7\')" \nmd-search-text="vm.searchText.AccountManager7" md-item-text="vm.getLookupDisplayValue(item, \'AccountManager7\')" \nmd-min-length="0" md-floating-label="{{\'LINKED_CUSTOMERS.FIELDS.ACCOUNT_MANAGER_7\' | translate}}" \nmd-selected-item-change="vm.lookupChange(vm.acLookupModel.AccountManager7, \'AccountManager7\')" ng-required="false" \nmd-no-cache="true" tx-clear-autocomplete ng-click="vm.selectText($event)" md-menu-class="autocomplete-custom">\n<md-item-template><span class="autocomplete-item md-accent-fg" md-highlight-text="vm.searchText.AccountManager7" \nmd-highlight-flags="i">{{item.value}}</span></md-item-template><md-not-found>\nNo Record matching "{{vm.searchText.AccountManager7}}" were found.</md-not-found><div \nng-messages="vm.editForm.AccountManager7.$error" role="alert" ng-show="vm.editForm.AccountManager7.$touched"><div \nng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div></div></md-autocomplete></div><div flex="100" \nflex-gt-xs="50" class="p-5"><md-input-container class="md-block"><label translate>\nLINKED_CUSTOMERS.FIELDS.ORDER_PRICE_GROUP</label><md-select name="OrderPriceGroupId" \nplaceholder="{{\'LINKED_CUSTOMERS.FIELDS.ORDER_PRICE_GROUP\' | translate}}" ng-model="vm.orderPriceGroup" \nstyle="min-width: 200px" ng-disabled="!vm.record.RetailPriceGroupId && !vm.record.WholesalePriceGroupId" \nng-required="true"><md-option ng-value="1" ng-if="vm.record.WholesalePriceGroupId">\n{{\'LINKED_CUSTOMERS.FIELDS.WHOLESALE_PRICE_GROUP\' | translate}}</md-option><md-option ng-value="2" \nng-if="vm.record.RetailPriceGroupId">{{\'LINKED_CUSTOMERS.FIELDS.RETAIL_PRICE_GROUP\' | translate}}</md-option>\n</md-select></md-input-container></div><div flex="100" flex-gt-xs="50" class="p-5"><md-input-container \nclass="md-block"><label>{{\'LINKED_CUSTOMERS.FIELDS.ORDER_QTY_MULTIPLE_OF_RATIO\' | translate}}</label><input \nname="OrderQtyMultipleOfRatio" ng-model="vm.record.OrderQtyMultipleOfRatio" type="number" \nng-pattern="/^([0-9])([.]\\d{0,2})?$/" ng-required="false"><div \nng-messages="vm.editForm.OrderQtyMultipleOfRatio.$error" role="alert" multiple="multiple"><div ng-message="pattern" \ntranslate="LINKED_CUSTOMERS.VALIDATIONS.INVALID_DECIMAL_POINTS"></div></div></md-input-container></div><div flex="100" \nflex-gt-xs="50" class="p-5"><md-switch id="dialog_input_{{$first ? \'first\' : $index}}" ng-model="vm.record.MoqEnabled" \naria-label="{{\'LINKED_CUSTOMERS.FIELDS.MOQ_ENABLED\' | translate}}" ng-true-value="true" ng-false-value="false" \nclass="md-accent">{{\'LINKED_CUSTOMERS.FIELDS.MOQ_ENABLED\' | translate}}<md-tooltip md-direction="right">\n{{vm.record.MoqEnabled === true ? \'PARTS.YES\' : \'PARTS.NO\' | translate}}</md-tooltip></md-switch></div><div flex="100" \nflex-gt-xs="50" class="p-5"><md-switch id="dialog_input_{{$first ? \'first\' : $index}}" \nng-model="vm.record.MultipleOfEnabled" aria-label="{{\'LINKED_CUSTOMERS.FIELDS.MULTIPLE_OF_ENABLED\' | translate}}" \nng-true-value="true" ng-false-value="false" class="md-accent">\n{{\'LINKED_CUSTOMERS.FIELDS.MULTIPLE_OF_ENABLED\' | translate}}<md-tooltip md-direction="right">\n{{vm.record.MultipleOfEnabled === true ? \'PARTS.YES\' : \'PARTS.NO\' | translate}}</md-tooltip></md-switch></div><div \nflex="100" flex-gt-xs="100" class="p-5 lookup-element" ng-if="vm.isStockApply"><md-input-container class="md-block">\n<label>{{\'LINKED_CUSTOMERS.FIELDS.AVAILABLE_STOCKS\' | translate}}</label><md-chips id="dialog_input_16" \nname="StockDefinitionIds" ng-model="vm.record.StockDefinitionIds" md-autocomplete-snap \nmd-transform-chip="vm.transformChip($chip)" md-require-match="true" ng-required="false"><md-autocomplete \nmd-selected-item="vm.acSelectedItem.StockDefinitionIds" md-search-text="vm.acSearchText.StockDefinitionIds" \nmd-items="item in vm.acQuerySearch(vm.acSearchText.StockDefinitionIds, vm.record.StockDefinitionIds, vm.stockDefinitions)" \nmd-item-text="item.StockName" md-min-length="0" md-no-cache="true" md-menu-class="autocomplete-custom">\n<md-item-template><span class="autocomplete-item md-accent-fg" md-highlight-text="vm.acSearchText.StockDefinitionIds">\n{{item.StockCode}}</span></md-item-template><md-not-found>\nNo Record matching "{{vm.acSearchText.StockDefinitionIds}}" were found.</md-not-found></md-autocomplete>\n<md-chip-template><span><strong>{{vm.getChipDisplayValue($chip, vm.stockDefinitions)}}</strong></span>\n</md-chip-template></md-chips></md-input-container></div><div flex="100" flex-gt-xs="50" class="p-5" \nng-if="vm.isStockApply"><md-input-container class="md-block"><label translate>LINKED_CUSTOMERS.FIELDS.STOCK_THRESHOLD\n</label><input id="dialog_input_{{$first ? \'first\' : $index}}" name="StockThreshold" \nng-model="vm.record.StockThreshold" type="number"></md-input-container></div><div flex="100" flex-gt-xs="50" \nclass="p-5" ng-if="vm.isStockApply"><md-switch id="dialog_input_{{$first ? \'first\' : $index}}" \nng-model="vm.record.HideZeroStock" aria-label="{{\'LINKED_CUSTOMERS.FIELDS.HIDE_ZERO_STOCK\' | translate}}" \nng-true-value="true" ng-false-value="false" class="md-accent">{{\'LINKED_CUSTOMERS.FIELDS.HIDE_ZERO_STOCK\' | translate}}\n<md-tooltip md-direction="right">{{vm.record.HideZeroStock === true ? \'PARTS.YES\' : \'PARTS.NO\' | translate}}\n</md-tooltip></md-switch></div><div flex="100" flex-gt-xs="50" class="p-5"><md-input-container class="md-block"><label>\n{{\'LINKED_CUSTOMERS.FIELDS.CUSTOMER_CRITERIA\' | translate}}</label><input name="CustomerCriteria" \nng-model="vm.record.CustomerCriteria" type="text" ng-required="false" ng-model-options="{updateOn: \'default blur\'}" \nng-change="vm.editForm.CustomerCriteria.$setValidity(\'jsonFormat\', !vm.record.CustomerCriteria || !!vm.isValidJSON(vm.record.CustomerCriteria))">\n<div ng-messages="vm.editForm.CustomerCriteria.$error" role="alert" multiple="multiple"><div ng-message="jsonFormat" \ntranslate="LINKED_CUSTOMERS.VALIDATIONS.INVALID_JSON"></div></div></md-input-container></div></div></md-dialog-content>\n<md-dialog-actions layout="row" layout-align="end center"><div></div><div layout="row" layout-align="end center">\n<md-button ng-click="vm.closeDialog(vm.isDataDirty)" class="send-button md-primary md-raised" aria-label="Cancel" \ntranslate="ACTIONS.DIALOG_CANCEL" translate-attr-aria-label="ACTIONS.DIALOG_CANCEL" ng-disabled="vm.isLoading">CANCEL\n</md-button><md-button ng-click="vm.saveRecord()" class="send-button md-accent md-raised" aria-label="Save" \ntranslate="ACTIONS.SAVE" translate-attr-aria-label="ACTIONS.SAVE" ng-disabled="vm.isLoading || vm.editForm.$invalid">\nSAVE</md-button><md-button ng-click="vm.saveRecord(true)" class="send-button md-accent md-raised" aria-label="Save" \ntranslate="ACTIONS.SAVE_AND_NEW" translate-attr-aria-label="ACTIONS.SAVE_AND_NEW" \nng-disabled="vm.isLoading || vm.editForm.$invalid" ng-show="vm.isNew">SAVE</md-button></div></md-dialog-actions></form>\n</md-dialog>');
$templateCache.put('app/main/catalogs/sub-modules/customers/list/customers-list.html','<div id="customers-list" class="page-layout carded fullwidth list-view" layout="row"><div class="center" \nlayout="column" flex><div class="content-card" layout="column" flex><tx-data-table tx-data="vm.customers" \ntx-model="vm.model" tx-view="mainList" tx-filtered-data="vm.filteredCustomers" tx-data-filter="global.search" \ntx-is-loading="vm.isLoading" tx-item-action-event="vm.doItemAction(action, item)" \ntx-list-action-event="vm.doListAction(action, selectedItems)" tx-item-click-event="vm.viewItem(item)" \ntx-refresh-action-event="vm.refreshItems(true, false)" tx-control="vm.tableControl"></tx-data-table><md-button \nclass="add-rec-button md-fab md-warn" ng-click="vm.addRecord($event)" \naria-label="vm.model.views.mainList.fabAction.label" translate \ntx-access="{{::vm.model.views.mainList.fabAction.privilege}}"><md-icon \nmd-font-icon="{{vm.model.views.mainList.fabAction.icon}}"></md-icon></md-button></div></div></div>');
$templateCache.put('app/main/catalogs/sub-modules/customers-locations/list/customers-locations-list.html','<div id="locations-list" class="page-layout carded fullwidth list-view" layout="row"><div class="center" \nlayout="column" flex><div class="content-card" layout="column" flex><tx-data-table tx-data="vm.locations" \ntx-model="vm.model" tx-view="mainList" tx-filtered-data="vm.filteredLocations" tx-data-filter="global.search" \ntx-is-loading="vm.isLoading" tx-item-action-event="vm.doItemAction(action, item)" \ntx-list-action-event="vm.doListAction(action, selectedItems)" tx-item-click-event="vm.viewItem(item)" \ntx-refresh-action-event="vm.refreshItems(true, false)"></tx-data-table></div></div></div>');
$templateCache.put('app/main/catalogs/sub-modules/customers-segmentation/list/customers-segmentation-list.html','<div id="customers-segmentation-list" class="page-layout carded fullwidth list-view" layout="row"><div class="center" \nlayout="column" flex><div class="content-card" layout="column" flex><tx-data-table tx-data="vm.segmentations" \ntx-model="vm.model" tx-view="mainList" tx-filtered-data="vm.filteredSegmentations" tx-data-filter="global.search" \ntx-is-loading="vm.isLoading" tx-item-action-event="vm.doItemAction(action, item)" \ntx-list-action-event="vm.doListAction(action, selectedItems)" tx-item-click-event="vm.viewItem(item)" \ntx-refresh-action-event="vm.refreshItems(true, false)"></tx-data-table></div></div></div>');
$templateCache.put('app/main/catalogs/sub-modules/customers-segmentation-linear/list/customers-segmentation-linear-list.html','<div id="customers-segmentation-list" class="page-layout carded fullwidth list-view" layout="row"><div class="center" \nlayout="column" flex><div class="content-card" layout="column" flex><tx-data-table tx-data="vm.segmentations" \ntx-model="vm.model" tx-view="mainList" tx-filtered-data="vm.filteredSegmentations" tx-data-filter="global.search" \ntx-is-loading="vm.isLoading" tx-item-action-event="vm.doItemAction(action, item)" \ntx-list-action-event="vm.doListAction(action, selectedItems)" tx-item-click-event="vm.viewItem(item)" \ntx-refresh-action-event="vm.refreshItems(true, false)"></tx-data-table><md-button \nclass="add-rec-button md-fab md-warn" ng-click="vm.assignCustomerSegmentations($event)" \naria-label="vm.model.views.mainList.fabAction.label" translate \ntx-access="{{::vm.model.views.mainList.fabAction.privilege}}"><md-icon \nmd-font-icon="{{vm.model.views.mainList.fabAction.icon}}"></md-icon></md-button></div></div></div>');
$templateCache.put('app/main/catalogs/sub-modules/dune-images/details/dune-images-details.html','<div id="image-details" class="page-layout simple tabbed details-view" layout="column"><div class="content"><md-tabs \nmd-dynamic-height md-selected="vm.tabIndex" md-no-ink><md-tab label="{{\'IMAGES.TABS.IMAGE\' | translate}}" \ntx-access="{{::vm.model.views.privileges.details}}"><tx-data-details tx-height-offset="37" \ntx-is-active="vm.tabIndex === 0" tx-account="vm.image" tx-title="vm.title" tx-model="vm.model" \ntx-item-actions="vm.model.views.mainDetails.itemActions" tx-is-loading="vm.isLoading" \ntx-item-action-event="vm.doImageItemAction(action, account)" tx-refresh-action-event="vm.refreshRecord(false)">\n</tx-data-details></md-tab><md-tab label="{{\'T1_DUNE.TABS.TAGS\' | translate}}"><div class="list-tab" layout="row" \nflex="100" layout-wrap><ms-widget layout="row" flex="100"><ms-widget-front class="white-bg"><tx-data-table \ntx-is-active="vm.tabIndex === 1" tx-data="vm.tags" tx-model="vm.tagsModel" tx-view="mainList" \ntx-filtered-data="vm.filteredTags" tx-data-filter="global.search" tx-is-loading="vm.isLoading" \ntx-refresh-action-event="vm.refreshRecord(false)" tx-height-offset="16"></tx-data-table></ms-widget-front></ms-widget>\n</div></md-tab></md-tabs><md-button id="txfab" class="md-fab md-warn" \nng-show="{{::vm.model.views.mainDetails.fab.visible}}" ng-if="vm.tabIndex === 0" \nng-click="vm.editImage($event, vm.image)" aria-label="vm.model.views.mainDetails.fab.label" translate \ntx-access="{{::vm.model.views.mainDetails.fab.privilege}}" ng-disabled="vm.image.Status === 0"><md-icon \nmd-font-icon="{{vm.model.views.mainDetails.fab.icon}}"></md-icon></md-button></div></div>');
$templateCache.put('app/main/catalogs/sub-modules/dune-images/list/dune-images-list.html','<div id="dune-images-list" class="page-layout carded fullwidth list-view" layout="row"><div class="center" \nlayout="column" flex><div class="content-card" layout="column" flex><tx-data-table tx-data="vm.images" \ntx-model="vm.model" tx-view="mainList" tx-filtered-data="vm.filteredImages" tx-data-filter="global.search" \ntx-is-loading="vm.isLoading" tx-support-images-view="true" tx-dune-images-view="true" \ntx-item-action-event="vm.doItemAction(action, item)" tx-list-action-event="vm.doListAction(action, selectedItems)" \ntx-item-click-event="vm.viewRecord(item)" tx-refresh-action-event="vm.refreshRecords(true, false)" \ntx-control="vm.tableControl" tx-load-next-page-event="vm.loadNextPage()" tx-has-more-pages="vm.hasMorePages" \ntx-total-record-count="vm.totalCount"></tx-data-table><md-button class="add-rec-button md-fab md-warn" \nng-show="{{::vm.model.views.mainList.fabAction.visible}}" ng-click="vm.addRecord($event)" \naria-label="vm.model.views.mainList.fabAction.label" translate \ntx-access="{{::vm.model.views.mainList.fabAction.privilege}}"><md-icon \nmd-font-icon="{{vm.model.views.mainList.fabAction.icon}}"></md-icon></md-button></div></div></div>');
$templateCache.put('app/main/catalogs/sub-modules/favorites/details/favorites-details.html','<div id="favorites-details" class="page-layout simple tabbed details-view" layout="column"><div class="content">\n<md-tabs md-dynamic-height md-selected="vm.tabIndex" md-no-ink><md-tab \nlabel="{{\'FAVORITES.TABS.FAVORITE\' | translate}}" tx-access="{{::vm.model.views.privileges.details}}"><tx-data-details \ntx-height-offset="37" tx-account="vm.favorite" tx-title="vm.title" tx-model="vm.model" \ntx-item-actions="vm.model.views.mainDetails.itemActions" \ntx-item-action-event="vm.doFavoriteItemAction(action, account)" tx-is-loading="vm.isLoading" \ntx-refresh-action-event="vm.refreshRecord(false)" tx-parent-id="vm.activeCatalog.CatalogCode"></tx-data-details>\n</md-tab><md-tab label="{{\'FAVORITES.TABS.ARTICLES\' | translate}}"><div class="list-tab" layout="row" flex="100" \nlayout-wrap><ms-widget layout="row" flex="100"><ms-widget-front class="white-bg"><tx-data-table \ntx-is-active="vm.tabIndex === 1" tx-data="vm.articles" tx-model="vm.articlesModel" tx-view="mainList" \ntx-filtered-data="vm.filteredArticles" tx-data-filter="global.search" tx-is-loading="vm.isLoading" \ntx-refresh-action-event="vm.refreshRecord(false)" tx-height-offset="16"></tx-data-table></ms-widget-front></ms-widget>\n</div></md-tab><md-tab label="{{\'FAVORITES.TABS.SHARED_WITH_USERS\' | translate}}"><div class="list-tab" layout="row" \nflex="100" layout-wrap><ms-widget layout="row" flex="100"><ms-widget-front class="white-bg"><tx-data-table \ntx-is-active="vm.tabIndex === 2" tx-data="vm.sharedWithUsers" tx-model="vm.sharedWithModelUsers" tx-view="mainList" \ntx-filtered-data="vm.filteredSharedWithUsers" tx-data-filter="global.search" tx-is-loading="vm.isLoading" \ntx-refresh-action-event="vm.refreshRecord(false)" tx-height-offset="16"></tx-data-table></ms-widget-front></ms-widget>\n</div></md-tab><md-tab label="{{\'FAVORITES.TABS.SHARED_WITH_USER_GROUPS\' | translate}}"><div class="list-tab" \nlayout="row" flex="100" layout-wrap><ms-widget layout="row" flex="100"><ms-widget-front class="white-bg"><tx-data-table\n tx-is-active="vm.tabIndex === 2" tx-data="vm.sharedWithUserGroups" tx-model="vm.sharedWithModelUserGroups" \ntx-view="mainList" tx-filtered-data="vm.filteredSharedWithUserGroups" tx-data-filter="global.search" \ntx-is-loading="vm.isLoading" tx-refresh-action-event="vm.refreshRecord(false)" tx-height-offset="16"></tx-data-table>\n</ms-widget-front></ms-widget></div></md-tab></md-tabs></div></div>');
$templateCache.put('app/main/catalogs/sub-modules/forecast/details/forecast-details.html','<div id="forecast-details" class="page-layout simple tabbed details-view" layout="column"><div class="content"><md-tabs\n md-dynamic-height md-selected="vm.tabIndex" md-no-ink><md-tab label="{{\'FORECAST.TABS.FORECAST\' | translate}}" \ntx-access="{{::vm.model.views.privileges.details}}" ng-disabled="!vm.forecast.Status"><tx-data-details \ntx-height-offset="37" tx-is-active="vm.tabIndex === 0" tx-account="vm.forecast" tx-title="vm.title" \ntx-model="vm.model" tx-refresh-action-event="vm.refreshRecord(false)" \ntx-item-actions="vm.model.views.mainDetails.itemActions" tx-item-action-event="vm.doItemAction(action, account)">\n</tx-data-details></md-tab><md-tab label="{{\'FORECAST.TABS.ARTICLES\' | translate}}" ng-disabled="!vm.forecast.Status" \ntx-access="{{::vm.articlesModel.views.privileges.list}}"><div class="list-tab" layout="row" flex="100" layout-wrap>\n<ms-widget layout="row" flex="100"><ms-widget-front class="white-bg"><tx-data-table tx-is-active="vm.tabIndex === 1" \ntx-data="vm.articles" tx-model="vm.articlesModel" tx-view="mainList" tx-filtered-data="vm.filteredArticles" \ntx-data-filter="global.search" tx-is-loading="vm.isLoading" tx-refresh-action-event="vm.refreshRecord(false)" \ntx-list-action-event="vm.doArticlesListAction(action, selectedItems)" \ntx-item-action-event="vm.doArticlesItemAction(action, item)" tx-item-click-event="vm.viewArticleDetails(item)" \ntx-height-offset="16"></tx-data-table></ms-widget-front></ms-widget></div></md-tab></md-tabs></div></div>');
$templateCache.put('app/main/catalogs/sub-modules/favorites/list/favorites-list.html','<div id="favorites\r\n-list" class="page-layout carded fullwidth list-view" layout="row"><div class="center" \nlayout="column" flex><div class="content-card" layout="column" flex><tx-data-table tx-data="vm.favorites" \ntx-model="vm.model" tx-view="mainList" tx-filtered-data="vm.filteredFavorites" tx-data-filter="global.search" \ntx-is-loading="vm.isLoading" tx-item-action-event="vm.doItemAction(action, item)" \ntx-list-action-event="vm.doListAction(action, selectedItems)" tx-item-click-event="vm.viewItem(item)" \ntx-refresh-action-event="vm.refreshItems(true, false)"></tx-data-table><md-button \nclass="add-rec-button md-fab md-warn" ng-click="vm.addRecord($event)" \naria-label="vm.model.views.mainList.fabAction.label" translate \ntx-access="{{::vm.model.views.mainList.fabAction.privilege}}"><md-icon \nmd-font-icon="{{vm.model.views.mainList.fabAction.icon}}"></md-icon></md-button></div></div></div>');
$templateCache.put('app/main/catalogs/sub-modules/forecast/list/forecast-list.html','<div id="forecast-list" class="page-layout carded fullwidth list-view" layout="row"><div class="center" \nlayout="column" flex><div class="content-card" layout="column" flex><tx-data-table tx-data="vm.forecast" \ntx-model="vm.model" tx-view="mainList" tx-filtered-data="vm.filteredForecast" tx-data-filter="global.search" \ntx-is-loading="vm.isLoading" tx-item-action-event="vm.doItemAction(action, item)" \ntx-list-action-event="vm.doListAction(action, selectedItems)" tx-item-click-event="vm.viewItem(item)" \ntx-refresh-action-event="vm.refreshItems(true, false)"></tx-data-table></div></div></div>');
$templateCache.put('app/main/catalogs/sub-modules/images/details/images-details.html','<div id="image-details" class="page-layout simple tabbed details-view" layout="column"><div class="content"><md-tabs \nmd-dynamic-height md-selected="vm.tabIndex" md-no-ink><md-tab label="{{\'IMAGES.TABS.IMAGE\' | translate}}" \ntx-access="{{::vm.model.views.privileges.details}}"><tx-data-details tx-height-offset="37" \ntx-is-active="vm.tabIndex === 0" tx-account="vm.image" tx-title="vm.title" tx-model="vm.model" \ntx-item-actions="vm.model.views.mainDetails.itemActions" tx-is-loading="vm.isLoading" \ntx-item-action-event="vm.doImageItemAction(action, account)" tx-refresh-action-event="vm.refreshRecord(false)">\n</tx-data-details></md-tab></md-tabs><md-button id="txfab" class="md-fab md-warn" \nng-show="{{::vm.model.views.mainDetails.fab.visible}}" ng-click="vm.editImage($event, vm.image)" \naria-label="vm.model.views.mainDetails.fab.label" translate tx-access="{{::vm.model.views.mainDetails.fab.privilege}}" \nng-disabled="vm.image.Status === 0"><md-icon md-font-icon="{{vm.model.views.mainDetails.fab.icon}}"></md-icon>\n</md-button></div></div>');
$templateCache.put('app/main/catalogs/sub-modules/images/dialogs/upload-image.html','<md-dialog class="edit-dialog image-uploader" aria-label="New Record"><form name="vm.editForm" class="md-inline-form" \nflow-init="vm.flowInit" flow-object="$rootScope.flowObj" flow-file-added="vm.validateFile($file, $event, $flow)" \nflow-files-submitted="vm.upload()" flow-file-success="vm.onSuccessUpload($file, $message, $flow)" \nflow-name="vm.obj.flow"><md-toolbar class="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" \nlayout-align="space-between center"><span class="title" translate="TITLES.RECORD_NEW">New Record</span><md-button \nclass="md-icon-button" ng-click="vm.closeDialog(vm.isDataDirty, true)" aria-label="Close dialog" tranlate \ntranslate-aria-label="ACTIONS.DIALOG_CLOSE"><md-icon md-font-icon="icon-close"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div layout="row" layout-wrap><div flex="100" flex-gt-xs="50" \nclass="p-5 lookup-element"><md-autocomplete id="dialog_input_{{$first ? \'first\' : $index}}" md-input-name="ArticleId" \nmd-selected-item="vm.lookupModel.ArticleId" md-items="item in vm.lookupSearch(vm.searchText.ArticleId, \'ArticleId\')" \nmd-search-text="vm.searchText.ArticleId" md-item-text="vm.getLookupDisplayValue(item, \'ArticleId\')" md-min-length="0" \nmd-floating-label="{{\'IMAGES.FIELDS.ARTICLE_ID\' | translate}}" \nmd-selected-item-change="vm.lookupChange(vm.lookupModel.ArticleId, \'ArticleId\')" ng-required="true" md-no-cache="true" \ntx-clear-autocomplete tx-force-select ng-click="vm.selectText($event)" ng-disabled="!vm.isNew || vm.isArticleDetails" \nmd-menu-class="autocomplete-custom"><md-item-template><span class="autocomplete-item md-accent-fg" \nmd-highlight-text="vm.searchText.ArticleId" md-highlight-flags="i">{{item.value}}</span></md-item-template>\n<md-not-found>No Record matching "{{vm.searchText.ArticleId}}" were found.</md-not-found><div \nng-messages="vm.editForm.ArticleId.$error" role="alert" ng-show="vm.editForm.ArticleId.$touched"><div \nng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div></div></md-autocomplete></div><div flex="100" \nflex-gt-xs="50" class="p-5 lookup-element"><md-autocomplete id="dialog_input_{{$first ? \'first\' : $index}}" \nmd-input-name="TypeId" md-selected-item="vm.lookupModel.TypeId" \nmd-items="item in vm.lookupSearch(vm.searchText.TypeId, \'TypeId\')" md-search-text="vm.searchText.TypeId" \nmd-item-text="vm.getLookupDisplayValue(item, \'TypeId\')" md-min-length="0" \nmd-floating-label="{{\'IMAGES.FIELDS.IMAGE_TYPE_ID\' | translate}}" \nmd-selected-item-change="vm.lookupChange(vm.lookupModel.TypeId, \'TypeId\')" ng-required="true" md-no-cache="true" \ntx-clear-autocomplete tx-force-select ng-click="vm.selectText($event)" md-menu-class="autocomplete-custom">\n<md-item-template><span class="autocomplete-item md-accent-fg" md-highlight-text="vm.searchText.TypeId" \nmd-highlight-flags="i">{{item.value}}</span></md-item-template><md-not-found>\nNo Record matching "{{vm.searchText.TypeId}}" were found.</md-not-found><div ng-messages="vm.editForm.TypeId.$error" \nrole="alert" ng-show="vm.editForm.TypeId.$touched"><div ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}\n</div></div></md-autocomplete></div><div flex="100" class="p-5"></div><div flex="100" class="p-5" flow-drop \nng-if="$flow.support"><label for="flow-upload-file-id" ng-hide="$flow.progress() === 1"><div \nclass="file-uploader-container" flow-drag-enter="style={outline: \'2px dashed rgba(0,0,0,0.38)\', color: \'#939393\' }" \nflow-drag-leave="style={outline: \'2px dashed rgba(0,0,0,0.12)\', color: \'rgba(0,0,0,0.12)\'}" ng-style="style"><div \nclass="upload-label" ng-if="(vm.isNew && !$flow.isUploading()) || (!vm.isNew && vm.imgSrc === \'/\')"><div \nclass="upload-icon"><md-icon ng-style="style" md-font-icon="icon-upload" class="icon s1"></md-icon></div><div \nclass="upload-message" ng-style="style"><span>Choose a file or drag it here.</span></div></div><div \nng-if="!vm.isNew && vm.imgSrc !== \'/\'" class="image-container"><img ng-src="{{vm.imgSrc}}"></div><div \nclass="uploaded-file-name"><label>{{vm.fileName}}</label></div></div></label><label for="flow-upload-file-id" class="" \nng-show="$flow.progress() === 1"><div class="file-uploader-container upload-success"><div class="image-container"><img \nflow-img="$flow.files[0]"></div><div class="uploaded-file-name"><label>{{$flow.files[0].name}}</label></div></div>\n</label><div class="upload-error" ng-show="!vm.isFileValid">{{ \'IMAGES.MESSAGES.INVALID_FILE_FORMAT\' | translate }}\n</div><md-progress-linear md-mode="determinate" class="md-accent" ng-if="$flow.isUploading()" \nvalue="{{$flow.progress()*100}}"></md-progress-linear></div><div ng-if="!$flow.support"><span>Browser not supported!\n</span></div><div flex="100" flex-gt-xs="50" class="p-5"><md-input-container class="md-block"><label>\n{{\'IMAGES.FIELDS.SORT_ORDER\' | translate}}</label><input name="SortOrder" ng-model="vm.record.SortOrder" type="number" \nng-pattern="/^\\d+$/" ng-required="false"><div ng-messages="vm.editForm.SortOrder.$error" role="alert" \nmultiple="multiple"><div ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div><div \nng-message="md-maxlength">{{\'VALIDATIONS.MAXLEN\' | translate}}</div><div ng-message="pattern">\n{{\'VALIDATIONS.INVALID_SORT_ORDER\' | translate}}</div></div></md-input-container></div></div></md-dialog-content>\n<md-dialog-actions layout="row" layout-align="end center"><div><input type="file" id="flow-upload-file-id" \nclass="ng-hide" flow-btn accept=".jpg, .png, .gif, .swf"></div><div layout="row" layout-align="end center"><md-button \nng-click="vm.closeDialog(vm.isDataDirty, true)" class="send-button md-primary md-raised" aria-label="Cancel" \ntranslate="ACTIONS.DIALOG_CANCEL" translate-attr-aria-label="ACTIONS.DIALOG_CANCEL" ng-disabled="vm.isLoading">CANCEL\n</md-button><md-button ng-click="vm.saveRecord()" class="send-button md-accent md-raised" aria-label="Save" \ntranslate="ACTIONS.SAVE" translate-attr-aria-label="ACTIONS.SAVE" \nng-disabled="vm.isLoading || vm.editForm.$invalid || (!$flow.files.length && vm.isNew) || !vm.isFileValid || $flow.isUploading()">\nSAVE</md-button><md-button ng-click="vm.saveRecord(true)" class="send-button md-accent md-raised" aria-label="Save" \nng-show="vm.isNew" translate="ACTIONS.SAVE_AND_NEW" translate-attr-aria-label="ACTIONS.SAVE_AND_NEW" \nng-disabled="vm.isLoading || vm.editForm.$invalid || (!$flow.files.length && vm.isNew) || !vm.isFileValid || $flow.isUploading()">\nSAVE</md-button></div></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/catalogs/sub-modules/images/dialogs/upload-images.html','<md-dialog class="edit-dialog" aria-label="New Record"><form name="editForm" class="md-inline-form" \nflow-init="vm.flowInit" flow-object="$rootScope.flowObj" flow-file-added="vm.validateFile($file, $event, $flow)" \nflow-name="vm.obj.flow"><md-toolbar class="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" \nlayout-align="space-between center"><span class="title" translate="TITLES.RECORD_NEW">New Record</span><md-button \nclass="md-icon-button" ng-click="vm.closeDialog()" aria-label="Close dialog" tranlate \ntranslate-aria-label="ACTIONS.DIALOG_CLOSE"><md-icon md-font-icon="icon-close"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div layout="column" flex><div flex="100" layout="row" \nlayout-align="space-between center"><div flex="initial"><span>Filename:</span></div><div flex layout="row"><div flex \nclass="text-boxed"><label for="fileName" ng-show="$flow.files.length === 0" style="display: block; width: 100%">[none]\n</label><span ng-show="$flow.files.length > 0" class="text-truncate">{{$flow.files[0].name}}</span></div></div><div \nflex="initial"><md-button class="md-raised"><label for="fileName">Select...</label></md-button></div></div><input \ntype="file" flow-btn id="fileName" accept=".zip, .rar, .7z" class="ng-hide" required><div class="error-message" \nng-class="{\'display-error\' : ($flow.files.length > 0 && !vm.isFileValid), \'remove-error\' : !($flow.files.length > 0 && !vm.isFileValid)}" \nng-show="$flow.files.length > 0 && !vm.isFileValid">{{\'VALIDATIONS.INVALID_FORMATE\' | translate}}</div></div>\n</md-dialog-content><md-dialog-actions layout="row" layout-align="end center"><div></div><div layout="row" \nlayout-align="end center"><md-button ng-click="vm.closeDialog()" class="send-button md-primary md-raised" \naria-label="Cancel" translate="ACTIONS.DIALOG_CANCEL" translate-attr-aria-label="ACTIONS.DIALOG_CANCEL" \nng-disabled="vm.isLoading">CANCEL</md-button><md-button ng-click="vm.saveRecord()" \nclass="send-button md-accent md-raised" aria-label="Save" translate="ACTIONS.SAVE" \ntranslate-attr-aria-label="ACTIONS.SAVE" ng-disabled="!$flow.files.length || !vm.isFileValid">SAVE</md-button></div>\n</md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/catalogs/sub-modules/images/list/images-list.html','<div id="images-list" class="page-layout carded fullwidth list-view" layout="row"><div class="center" layout="column" \nflex><div class="content-card" layout="column" flex><tx-data-table tx-data="vm.images" tx-model="vm.model" \ntx-view="mainList" tx-filtered-data="vm.filteredImages" tx-data-filter="global.search" tx-is-loading="vm.isLoading" \ntx-support-images-view="true" tx-dune-images-view="true" tx-item-action-event="vm.doItemAction(action, item)" \ntx-list-action-event="vm.doListAction(action, selectedItems)" tx-item-click-event="vm.viewRecord(item)" \ntx-refresh-action-event="vm.refreshRecords(true, false)" tx-control="vm.tableControl"></tx-data-table><md-button \nclass="add-rec-button md-fab md-warn" ng-show="{{::vm.model.views.mainList.fabAction.visible}}" \nng-click="vm.addRecord($event)" aria-label="vm.model.views.mainList.fabAction.label" translate \ntx-access="{{::vm.model.views.mainList.fabAction.privilege}}"><md-icon \nmd-font-icon="{{vm.model.views.mainList.fabAction.icon}}"></md-icon></md-button></div></div></div>');
$templateCache.put('app/main/catalogs/sub-modules/linked-buyers/list/linked-buyers-list.html','<div id="linked-buyers-list" class="page-layout carded fullwidth list-view" layout="row"><div class="center" \nlayout="column" flex><div class="content-card" layout="column" flex><tx-data-table tx-data="vm.linkedBuyers" \ntx-model="vm.model" tx-view="mainList" tx-filtered-data="vm.filteredLinkedBuyers" tx-data-filter="global.search" \ntx-is-loading="vm.isLoading" tx-refresh-action-event="vm.refreshItems(true, false)"></tx-data-table></div></div></div>');
$templateCache.put('app/main/catalogs/sub-modules/merch-boards/details/merch-boards-details.html','<div id="merch-board-details" class="page-layout simple tabbed details-view" layout="column"><div class="content">\n<md-tabs md-dynamic-height md-selected="vm.tabIndex" md-no-ink><md-tab \nlabel="{{\'MERCH_BOARDS.TABS.MERCH_BOARD\' | translate}}" tx-access="{{::vm.model.views.privileges.details}}">\n<tx-data-details tx-height-offset="37" tx-account="vm.merchSlide" tx-title="vm.title" tx-model="vm.model" \ntx-item-actions="vm.model.views.mainDetails.itemActions" \ntx-item-action-event="vm.doMerchSlideItemAction(action, account)" tx-is-loading="vm.isLoading" \ntx-refresh-action-event="vm.refreshRecord(false)" tx-parent-id="vm.activeCatalog.CatalogCode"></tx-data-details>\n</md-tab><md-tab label="{{\'MERCH_BOARDS.TABS.SHARED_WITH_USERS\' | translate}}"><div class="list-tab" layout="row" \nflex="100" layout-wrap><ms-widget layout="row" flex="100"><ms-widget-front class="white-bg"><tx-data-table \ntx-is-active="vm.tabIndex === 1" tx-data="vm.sharedWithUsers" tx-model="vm.sharedWithModelUsers" tx-view="mainList" \ntx-filtered-data="vm.filteredSharedWithUsers" tx-data-filter="global.search" tx-is-loading="vm.isLoading" \ntx-refresh-action-event="vm.refreshRecord(false)" tx-height-offset="16"></tx-data-table></ms-widget-front></ms-widget>\n</div></md-tab><md-tab label="{{\'MERCH_BOARDS.TABS.SHARED_WITH_USER_GROUPS\' | translate}}"><div class="list-tab" \nlayout="row" flex="100" layout-wrap><ms-widget layout="row" flex="100"><ms-widget-front class="white-bg"><tx-data-table\n tx-is-active="vm.tabIndex === 2" tx-data="vm.sharedWithUserGroups" tx-model="vm.sharedWithUserGroupsModel" \ntx-view="mainList" tx-filtered-data="vm.filteredSharedWithUserGroups" tx-data-filter="global.search" \ntx-is-loading="vm.isLoading" tx-refresh-action-event="vm.refreshRecord(false)" tx-height-offset="16"></tx-data-table>\n</ms-widget-front></ms-widget></div></md-tab><md-tab label="{{\'MERCH_BOARDS.TABS.SHARED_WITH_FOLDERS\' | translate}}">\n<div class="list-tab" layout="row" flex="100" layout-wrap><ms-widget layout="row" flex="100"><ms-widget-front \nclass="white-bg"><tx-data-table tx-is-active="vm.tabIndex === 3" tx-data="vm.sharedWithFolders" \ntx-model="vm.sharedWithFoldersModel" tx-view="mainList" tx-filtered-data="vm.filteredSharedWithFolders" \ntx-data-filter="global.search" tx-is-loading="vm.isLoading" tx-item-click-event="vm.viewFolder(item)" \ntx-item-action-event="vm.doFolderItemAction(action, item)" tx-refresh-action-event="vm.refreshRecord(false)" \ntx-height-offset="16"></tx-data-table></ms-widget-front></ms-widget></div></md-tab></md-tabs></div></div>');
$templateCache.put('app/main/catalogs/sub-modules/merch-boards/list/merch-boards-list.html','<div id="merch-boards" class="page-layout carded fullwidth list-view" layout="row"><div class="center" layout="column" \nflex><div class="content-card" layout="column" flex><tx-data-table tx-data="vm.merchSlides" tx-model="vm.model" \ntx-view="mainList" tx-filtered-data="vm.filteredMerchSlides" tx-data-filter="global.search" \ntx-is-loading="vm.isLoading" tx-item-action-event="vm.doItemAction(action, item)" \ntx-list-action-event="vm.doListAction(action, selectedItems)" tx-item-click-event="vm.viewItem(item)" \ntx-refresh-action-event="vm.refreshItems(true, false)" tx-merch-borad-view-change-event="vm.doMerchViewChange(action)">\n</tx-data-table></div></div></div>');
$templateCache.put('app/main/catalogs/sub-modules/order-adjustments/details/order-adjustments-details.html','<div id="order-adjustments-details-list" class="page-layout simple tabbed list-view" layout="column"><div \nclass="content"><md-tabs md-dynamic-height md-selected="vm.tabIndex" md-no-ink><md-tab \nlabel="{{\'ORDER_ADJUSTMENTS.TABS.ORDER_ADJUSTMENT\' | translate}}" \ntx-access="{{::vm.orderAdjustmentDetailsModel.views.privileges.list}}"><div class="list-tab" layout="row" flex="100" \nlayout-wrap><ms-widget layout="row" flex="100"><ms-widget-front class="white-bg"><tx-data-table \ntx-is-active="vm.tabIndex === 0" tx-data="vm.adjustedLines" tx-model="vm.orderAdjustmentDetailsModel" \ntx-view="mainList" tx-filtered-data="vm.filteredAdjustedLines" tx-data-filter="global.search" \ntx-is-loading="vm.isLoading" tx-refresh-action-event="vm.refreshRecord(false)" tx-height-offset="16"></tx-data-table>\n</ms-widget-front></ms-widget></div></md-tab><md-tab label="{{\'ORDER_ADJUSTMENTS.TABS.IMPACTED_ORDERS\' | translate}}" \ntx-access="{{::vm.impactedOrdersModel.views.privileges.list}}"><div class="list-tab" layout="row" flex="100" \nlayout-wrap><ms-widget layout="row" flex="100"><ms-widget-front class="white-bg"><tx-data-table \ntx-is-active="vm.tabIndex === 1" tx-data="vm.impactedOrders" tx-model="vm.impactedOrdersModel" tx-view="mainList" \ntx-filtered-data="vm.filteredImpactedOrders" tx-data-filter="global.search" tx-is-loading="vm.isLoading" \ntx-refresh-action-event="vm.refreshRecord(false)" tx-height-offset="16"></tx-data-table></ms-widget-front></ms-widget>\n</div></md-tab></md-tabs></div></div>');
$templateCache.put('app/main/catalogs/sub-modules/order-adjustments/list/order-adjustments-list.html','<div id="order-adjustments-list" class="page-layout carded fullwidth list-view" layout="row"><div class="center" \nlayout="column" flex><div class="content-card" layout="column" flex><tx-data-table tx-data="vm.orderAdjustments" \ntx-model="vm.model" tx-view="mainList" tx-filtered-data="vm.filteredOrderAdjustments" tx-data-filter="global.search" \ntx-is-loading="vm.isLoading" tx-item-action-event="vm.doItemAction(action, item)" \ntx-list-action-event="vm.doListAction(action, selectedItems)" tx-item-click-event="vm.viewItem(item)" \ntx-refresh-action-event="vm.refreshItems(true, false)"></tx-data-table></div></div></div>');
$templateCache.put('app/main/catalogs/sub-modules/orders/details/orders-details.html','<div id="order-details" class="page-layout simple tabbed details-view" layout="column"><div class="content"><md-tabs \nmd-dynamic-height md-selected="vm.tabIndex"><md-tab label="{{\'ORDERS.TABS.ORDER\' | translate}}" \ntx-access="{{::vm.model.views.privileges.details}}"><tx-data-details tx-height-offset="37" \ntx-is-active="vm.tabIndex === 0" tx-account="vm.order" tx-title="vm.title" tx-model="vm.model" \ntx-item-actions="vm.model.views.mainDetails.itemActions" tx-item-action-event="vm.doOrderItemAction(action, account)" \ntx-process-order-item-action-event="vm.doProcessOrderItemAction(action, account)" tx-is-loading="vm.isLoading" \ntx-refresh-action-event="vm.refreshRecord(false)" tx-parent-id="vm.activeCatalog.CatalogCode"></tx-data-details>\n</md-tab><md-tab label="{{\'ORDERS.TABS.ORDER_LINES\' | translate}}" ng-disabled="!vm.order.Status" \ntx-access="{{::vm.orderLineModel.views.privileges.list}}"><div class="list-tab" layout="row" flex="100" layout-wrap>\n<ms-widget layout="row" flex="100"><ms-widget-front class="white-bg"><tx-data-table tx-is-active="vm.tabIndex === 1" \ntx-data="vm.orderLines" tx-model="vm.orderLineModel" tx-view="mainList" tx-filtered-data="vm.filteredOrderLines" \ntx-data-filter="global.search" tx-is-loading="vm.isOrederLineLoading" \ntx-item-action-event="vm.doOrderLineItemAction(action, item)" \ntx-list-action-event="vm.doOrderLineListAction(action, selectedItems)" tx-item-click-event="vm.viewOrderLine(item)" \ntx-refresh-action-event="vm.refreshOrderLines(true, false)" tx-height-offset="16"></tx-data-table></ms-widget-front>\n</ms-widget><md-button class="add-rec-button md-fab md-warn" \nng-if="vm.orderLineModel.views.mainList.fabAction.visible" \nng-disabled="!vm.order.Status || !(vm.order.OrderProcessStatusId == 1 || vm.order.OrderProcessStatusId == 5)" \nng-click="vm.addOrderLine($event)" aria-label="vm.orderLineModel.views.mainList.fabAction.label" translate \ntx-access="{{::vm.orderLineModel.views.mainList.fabAction.privilege}}"><md-icon \nmd-font-icon="{{vm.orderLineModel.views.mainList.fabAction.icon}}"></md-icon></md-button></div></md-tab><md-tab \nlabel="{{\'ORDERS.TABS.REJECTED_ORDER_LINES\' | translate}}" ng-disabled="!vm.order.Status" \ntx-access="{{::vm.rejectedOrderlineModel.views.privileges.list}}"><div class="list-tab" layout="row" flex="100" \nlayout-wrap><ms-widget layout="row" flex="100"><ms-widget-front class="white-bg"><tx-data-table \ntx-is-active="vm.tabIndex === 2" tx-data="vm.rejectedOrderlines" tx-model="vm.rejectedOrderlineModel" \ntx-view="mainList" tx-filtered-data="vm.filteredRejectedOrderlines" tx-data-filter="global.search" \ntx-is-loading="vm.isRejectedOrederLineLoading" tx-refresh-action-event="vm.refreshRejectedOrderlines(true, false)" \ntx-height-offset="16"></tx-data-table></ms-widget-front></ms-widget></div></md-tab><md-tab \nlabel="{{\'ORDERS.TABS.FILES\' | translate}}" ng-disabled="!vm.order.Status" \ntx-access="{{::vm.filesModel.views.privileges.list}}"><div class="list-tab" layout="row" flex="100" layout-wrap>\n<ms-widget layout="row" flex="100"><ms-widget-front class="white-bg"><tx-data-table tx-is-active="vm.tabIndex === 3" \ntx-data="vm.files" tx-model="vm.filesModel" tx-view="mainList" tx-filtered-data="vm.filteredFiles" \ntx-data-filter="global.search" tx-is-loading="vm.isFilesLoading" \ntx-item-action-event="vm.doFilesItemAction(action, item)" \ntx-list-action-event="vm.doFilesListAction(action, selectedItems)" \ntx-refresh-action-event="vm.refreshFiles(true, false)" tx-height-offset="16"></tx-data-table></ms-widget-front>\n</ms-widget><md-button class="add-rec-button md-fab md-warn" ng-click="vm.uploadFile($event)" \naria-label="vm.filesModel.views.mainList.fabAction.label" translate \ntx-access="{{::vm.filesModel.views.mainList.fabAction.privilege}}"><md-icon \nmd-font-icon="{{vm.filesModel.views.mainList.fabAction.icon}}"></md-icon></md-button></div></md-tab><md-tab \nlabel="{{\'ORDERS.TABS.NOTIFICATIONS\' | translate}}" ng-disabled="!vm.order.Status" \ntx-access="{{::vm.notificationsModel.views.privileges.list}}"><div class="list-tab" layout="row" flex="100" \nlayout-wrap><ms-widget layout="row" flex="100"><ms-widget-front class="white-bg"><tx-data-table \ntx-is-active="vm.tabIndex === 4" tx-data="vm.notifications" tx-model="vm.notificationsModel" tx-view="mainList" \ntx-filtered-data="vm.filteredNotifications" tx-data-filter="global.search" tx-is-loading="vm.isNotificationsLoading" \ntx-item-action-event="vm.doNotificationItemAction(action, item)" \ntx-refresh-action-event="vm.refreshNotifications(true, false)" tx-height-offset="16"></tx-data-table></ms-widget-front>\n</ms-widget></div></md-tab><md-tab label="{{\'ORDERS.TABS.ORDER_STATUS_HISTORY\' | translate}}" \ntx-access="{{::vm.orderStatusHistoryModel.views.privileges.list}}"><div class="list-tab" layout="row" flex="100" \nlayout-wrap><ms-widget layout="row" flex="100"><ms-widget-front class="white-bg"><tx-data-table \ntx-is-active="vm.tabIndex === 5" tx-data="vm.orderStatusHistoryList" tx-model="vm.orderStatusHistoryModel" \ntx-view="mainList" tx-filtered-data="vm.filteredOrderStatusHistoryList" tx-data-filter="global.search" \ntx-is-loading="vm.isOrderStatusHistoryLoading" tx-refresh-action-event="vm.refreshOrderStatusHistoryList(true, false)" \ntx-height-offset="16"></tx-data-table></ms-widget-front></ms-widget></div></md-tab><md-tab \nlabel="{{\'ORDERS.TABS.IMPACTED_ADJUSTMENTS\' | translate}}" \ntx-access="{{::vm.impactedAdjustmentsModel.views.privileges.list}}"><div class="list-tab" layout="row" flex="100" \nlayout-wrap><ms-widget layout="row" flex="100"><ms-widget-front class="white-bg"><tx-data-table \ntx-is-active="vm.tabIndex === 6" tx-data="vm.impactedAdjustments" tx-model="vm.impactedAdjustmentsModel" \ntx-view="mainList" tx-filtered-data="vm.filteredImpactedAdjustments" tx-data-filter="global.search" \ntx-is-loading="vm.isImpactedAdjustmentsLoading" \ntx-refresh-action-event="vm.refreshImpactedAdjustmentsList(true, false)" tx-height-offset="16"></tx-data-table>\n</ms-widget-front></ms-widget></div></md-tab></md-tabs><md-button id="txfab" class="md-fab md-warn" \nng-if="vm.tabIndex === 0 && vm.model.views.mainDetails.fab.visible" ng-click="vm.editOrder(vm.order, $event)" \naria-label="vm.model.views.mainDetails.fab.label" translate tx-access="{{::vm.model.views.mainDetails.fab.privilege}}" \nng-disabled="!vm.order.Status || !(vm.order.OrderProcessStatusId == 1 || vm.order.OrderProcessStatusId == 5)"><md-icon \nmd-font-icon="{{vm.model.views.mainDetails.fab.icon}}"></md-icon></md-button></div></div>');
$templateCache.put('app/main/catalogs/sub-modules/orders/list/orders-list.html','<div id="order-list" class="page-layout carded fullwidth list-view" layout="row"><div class="center" layout="column" \nflex><div class="content-card" layout="column" flex><tx-data-table tx-data="vm.orders" tx-model="vm.model" \ntx-view="mainList" tx-filtered-data="vm.filteredOrders" tx-data-filter="global.search" tx-is-loading="vm.isLoading" \ntx-item-action-event="vm.doItemAction(action, item)" tx-list-action-event="vm.doListAction(action, selectedItems)" \ntx-item-click-event="vm.viewItem(item)" \ntx-process-order-list-action-event="vm.doProcessOrderListAction(action, selectedItems)" \ntx-process-order-item-action-event="vm.doProcessOrderItemAction(action, item)" \ntx-refresh-action-event="vm.refreshItems(true, false)"></tx-data-table><md-button \nclass="add-rec-button md-fab md-warn" ng-if="vm.model.views.mainList.fabAction.visible" \nng-click="vm.addRecord($event)" aria-label="vm.model.views.mainList.fabAction.label" translate \ntx-access="{{::vm.model.views.mainList.fabAction.privilege}}"><md-icon \nmd-font-icon="{{vm.model.views.mainList.fabAction.icon}}"></md-icon></md-button></div></div></div>');
$templateCache.put('app/main/catalogs/sub-modules/orders-terms-conditions/details/orders-terms-conditions-details.html','<div id="terms-conditions" class="page-layout carded fullwidth list-view" layout="row"><div class="center" \nlayout="column" flex><div class="content-card" layout="column" flex><div class="title">{{ vm.record.Title }}</div>\n<ng-quill-editor class="ng-quill-editor" flex ng-model="vm.record.Content" read-only="true" modules="vm.editorConfig">\n</ng-quill-editor><md-button class="add-rec-button md-fab md-warn" ng-click="vm.copyPrivacyPolicy($event)" \naria-label="vm.model.views.mainDetails.fabAction.label" translate \ntx-access="{{::vm.model.views.mainDetails.fabAction.privilege}}"><md-icon \nmd-font-icon="{{vm.model.views.mainDetails.fabAction.icon}}"></md-icon></md-button></div></div></div>');
$templateCache.put('app/main/catalogs/sub-modules/orders-terms-conditions/list/orders-terms-conditions-list.html','<div id="locations-list" class="page-layout carded fullwidth list-view" layout="row"><div class="center" \nlayout="column" flex><div class="content-card" layout="column" flex><tx-data-table tx-data="vm.termsAndConditions" \ntx-model="vm.model" tx-view="mainList" tx-filtered-data="vm.filteredTtermsAndConditions" \ntx-data-filter="global.search" tx-is-loading="vm.isLoading" tx-item-action-event="vm.doItemAction(action, item)" \ntx-list-action-event="vm.doListAction(action, selectedItems)" tx-item-click-event="vm.viewItem(item)" \ntx-refresh-action-event="vm.refreshItems(true, false)"></tx-data-table><md-button \nclass="add-rec-button md-fab md-warn" ng-click="vm.addRecord($event)" \naria-label="vm.model.views.mainList.fabAction.label" translate \ntx-access="{{::vm.model.views.mainList.fabAction.privilege}}"><md-icon \nmd-font-icon="{{vm.model.views.mainList.fabAction.icon}}"></md-icon></md-button></div></div></div>');
$templateCache.put('app/main/catalogs/sub-modules/packages/details/packages-details.html','<div id="articles-details" class="page-layout simple tabbed details-view" layout="column"><div class="content"><md-tabs\n md-dynamic-height md-selected="vm.tabIndex" md-no-ink><md-tab label="{{\'PACKAGES.TABS.PACKAGE\' | translate}}" \ntx-access="{{::vm.model.views.privileges.details}}"><tx-data-details tx-height-offset="37" tx-account="vm.package" \ntx-is-active="vm.tabIndex === 0" tx-title="vm.title" tx-model="vm.model" \ntx-item-actions="vm.model.views.mainDetails.itemActions" tx-item-action-event="vm.doItemAction(action, account)" \ntx-is-loading="vm.isLoading" tx-refresh-action-event="vm.refreshRecord()"></tx-data-details></md-tab><md-tab \nlabel="{{\'PACKAGES.TABS.ERRORS\' | translate}}" tx-access="{{::vm.errorsModel.views.privileges.list}}"><div \nclass="list-tab" layout="row" flex="100" layout-wrap><ms-widget layout="row" flex="100"><ms-widget-front \nclass="white-bg"><tx-data-table tx-is-active="vm.tabIndex === 1" tx-data="vm.package.ImportErrorList" \ntx-model="vm.errorsModel" tx-view="mainList" tx-filtered-data="vm.filteredErrors" tx-data-filter="global.search" \ntx-is-loading="vm.isLoading" tx-item-action-event="vm.doErrorsItemAction(action, item)" \ntx-item-click-event="vm.viewError(item)" tx-refresh-action-event="vm.refreshRecord()" tx-height-offset="16">\n</tx-data-table></ms-widget-front></ms-widget></div></md-tab></md-tabs></div></div>');
$templateCache.put('app/main/catalogs/sub-modules/packages/list/packages-list.html','<div id="packages-list" class="page-layout carded fullwidth list-view" layout="row"><div class="center" \nlayout="column" flex><div class="content-card" layout="column" flex><tx-data-table tx-data="vm.packages" \ntx-model="vm.model" tx-view="mainList" tx-filtered-data="vm.filteredPackages" tx-data-filter="global.search" \ntx-is-loading="vm.isLoading" tx-item-action-event="vm.doItemAction(action, item)" \ntx-item-click-event="vm.viewRecord(item)" tx-refresh-action-event="vm.refreshRecords(true, false)"></tx-data-table>\n<md-button class="add-rec-button md-fab md-warn" ng-if="vm.model.views.mainList.fabAction.visible" \nng-click="vm.publishRecord($event, vm.model.views.mainList.fabAction)" \naria-label="vm.model.views.mainList.fabAction.label" translate \ntx-access="{{::vm.model.views.mainList.fabAction.privilege}}"><md-icon \nmd-font-icon="{{vm.model.views.mainList.fabAction.icon}}"></md-icon></md-button></div></div></div>');
$templateCache.put('app/main/catalogs/sub-modules/prices/list/prices-list.html','<div id="prices-list" class="page-layout carded fullwidth list-view" layout="row"><div class="center" layout="column" \nflex><div class="content-card" layout="column" flex><tx-data-table tx-data="vm.prices" tx-model="vm.model" \ntx-view="mainList" tx-filtered-data="vm.filteredPrices" tx-data-filter="global.search" tx-is-loading="vm.isLoading" \ntx-item-action-event="vm.doItemAction(action, item)" tx-list-action-event="vm.doListAction(action, selectedItems)" \ntx-item-click-event="vm.viewItem(item)" tx-refresh-action-event="vm.refreshItems(true, false)"></tx-data-table>\n<md-button class="add-rec-button md-fab md-warn" ng-click="vm.addRecord($event)" \naria-label="vm.model.views.mainList.fabAction.label" translate \ntx-access="{{::vm.model.views.mainList.fabAction.privilege}}"><md-icon \nmd-font-icon="{{vm.model.views.mainList.fabAction.icon}}"></md-icon></md-button></div></div></div>');
$templateCache.put('app/main/catalogs/sub-modules/prices-linear/list/prices-linear-list.html','<div id="prices-list" class="page-layout carded fullwidth list-view" layout="row"><div class="center" layout="column" \nflex><div class="content-card" layout="column" flex><tx-data-table tx-data="vm.prices" tx-model="vm.model" \ntx-view="mainList" tx-filtered-data="vm.filteredPrices" tx-data-filter="global.search" tx-is-loading="vm.isLoading" \ntx-item-action-event="vm.doItemAction(action, item)" tx-list-action-event="vm.doListAction(action, selectedItems)" \ntx-item-click-event="vm.viewItem(item)" tx-refresh-action-event="vm.refreshItems(true, false)"></tx-data-table>\n<md-button class="add-rec-button md-fab md-warn" ng-click="vm.addRecord($event)" \naria-label="vm.model.views.mainList.fabAction.label" translate \ntx-access="{{::vm.model.views.mainList.fabAction.privilege}}"><md-icon \nmd-font-icon="{{vm.model.views.mainList.fabAction.icon}}"></md-icon></md-button></div></div></div>');
$templateCache.put('app/main/catalogs/sub-modules/reports/list/reports-list.html','<div id="reports-list" class="page-layout carded fullwidth list-view" layout="row"><div class="center" layout="column" \nflex><div class="content-card" layout="column" flex><tx-data-table tx-data="vm.articlesReport" tx-model="vm.model" \ntx-view="mainList" tx-filtered-data="vm.filteredArticlesReport" tx-data-filter="global.search" \ntx-is-loading="vm.isLoading" tx-item-click-event="vm.viewItem(item)" \ntx-refresh-action-event="vm.refreshItems(true, false)"></tx-data-table></div></div></div>');
$templateCache.put('app/main/catalogs/sub-modules/requests/details/requests-details.html','<div id="REQUEST-details" class="page-layout simple tabbed details-view" layout="column"><div class="content"><md-tabs \nmd-dynamic-height md-selected="vm.tabIndex" md-no-ink><md-tab label="{{\'REQUESTS.TABS.REQUEST\' | translate}}" \ntx-access="{{::vm.model.views.privileges.details}}"><tx-data-details tx-height-offset="37" tx-account="vm.requestData" \ntx-title="vm.title" tx-model="vm.model" tx-item-actions="vm.model.views.mainDetails.itemActions" \ntx-item-action-event="vm.doRequestItemAction(action, account)" tx-is-loading="vm.isLoading" \ntx-refresh-action-event="vm.refreshRecord(false)" tx-is-request-module="true"></tx-data-details></md-tab><md-tab \nlabel="{{\'REQUESTS.TABS.PARTICIPANTS\' | translate}}" tx-access="{{::vm.participantsModel.views.privileges.list}}"><div \nclass="list-tab" layout="row" flex="100" layout-wrap><ms-widget layout="row" flex="100"><ms-widget-front \nclass="white-bg"><tx-data-table tx-is-active="vm.tabIndex === 1" tx-data="vm.participants" \ntx-model="vm.participantsModel" tx-view="mainList" tx-filtered-data="vm.filteredParticipants" \ntx-data-filter="global.search" tx-is-loading="vm.isLoading" tx-refresh-action-event="vm.refreshRecord(false)" \ntx-item-action-event="vm.doParticipantsItemAction(action, item)" \ntx-list-action-event="vm.doParticipantsListAction(action, selectedItems)" tx-height-offset="16"></tx-data-table>\n</ms-widget-front></ms-widget></div></md-tab><md-tab label="{{\'REQUESTS.TABS.ATTACHMENTS\' | translate}}" \ntx-access="{{::vm.attachmentsModel.views.privileges.list}}"><div class="list-tab" layout="row" flex="100" layout-wrap>\n<ms-widget layout="row" flex="100"><ms-widget-front class="white-bg"><tx-data-table tx-is-active="vm.tabIndex === 2" \ntx-data="vm.attachments" tx-model="vm.attachmentsModel" tx-view="mainList" tx-filtered-data="vm.filteredAttachments" \ntx-data-filter="global.search" tx-is-loading="vm.isLoading" tx-refresh-action-event="vm.refreshRecord(false)" \ntx-item-action-event="vm.doAttachmentsItemAction(action, item)" \ntx-list-action-event="vm.doAttachmentsListAction(action, selectedItems)" tx-height-offset="16"></tx-data-table>\n</ms-widget-front></ms-widget></div></md-tab><md-tab label="{{\'REQUESTS.TABS.HISTORY\' | translate}}" \nng-if="vm.requestData.IsCreateArticleRequest" tx-access="{{::vm.requestAuditTrailHistoryModel.views.privileges.list}}" \nmd-on-select="vm.refreshAuditTrailHistory(true)"><div class="list-tab" layout="row" flex="100" layout-wrap><ms-widget \nlayout="row" flex="100"><ms-widget-front class="white-bg"><div \nng-include="\'app/main/catalogs/sub-modules/requests/details/tabs/history/history-viewer.html\'" id="audit-trail-viewer">\n</div></ms-widget-front></ms-widget></div></md-tab></md-tabs></div></div>');
$templateCache.put('app/main/catalogs/sub-modules/requests/list/requests-list.html','<div id="allocation-group-list" class="page-layout carded fullwidth list-view" layout="row"><div class="center" \nlayout="column" flex><div class="content-card" layout="column" flex><tx-data-table tx-data="vm.allRequests" \ntx-model="vm.model" tx-view="mainList" tx-filtered-data="vm.filteredRequests" tx-data-filter="global.search" \ntx-is-loading="vm.isLoading" tx-item-action-event="vm.doItemAction(action, item)" \ntx-list-action-event="vm.doListAction(action, selectedItems)" tx-item-click-event="vm.viewItem(item)" \ntx-refresh-action-event="vm.refreshItems(true, false)"></tx-data-table></div></div></div>');
$templateCache.put('app/main/catalogs/sub-modules/resources/details/resources-details.html','<div id="resource-details" class="page-layout simple tabbed details-view" layout="column"><div class="content"><md-tabs\n md-dynamic-height md-selected="vm.tabIndex" md-no-ink><md-tab label="{{\'RESOURCES.TABS.RESOURCE\' | translate}}" \ntx-access="{{::vm.model.views.privileges.details}}" ng-disabled="!vm.resource.Status"><tx-data-details \ntx-height-offset="37" tx-is-active="vm.tabIndex === 0" tx-account="vm.resource" tx-title="vm.title" \ntx-model="vm.model" tx-item-actions="vm.model.views.mainDetails.itemActions" \ntx-item-action-event="vm.doResourceItemAction(action, account)" tx-refresh-action-event="vm.refreshRecord(false)">\n</tx-data-details></md-tab><md-tab ng-if="!vm.resource.IsModelLevel" label="{{\'RESOURCES.TABS.ARTICLES\' | translate}}" \ntx-access="{{::vm.articleModel.views.privileges.list}}" ng-disabled="!vm.resource.Status"><div class="list-tab" \nlayout="row" flex="100" layout-wrap><ms-widget layout="row" flex="100"><ms-widget-front class="white-bg"><tx-data-table\n tx-is-active="vm.tabIndex === 1" tx-data="vm.assignedArticles" tx-model="vm.articleModel" tx-view="mainList" \ntx-filtered-data="vm.filteredAssignedArticles" tx-data-filter="global.search" tx-is-loading="vm.isLoading" \ntx-item-action-event="vm.doArticleItemAction(action, item)" \ntx-list-action-event="vm.doArticlesListAction(action, selectedItems)" tx-item-click-event="vm.viewArticle(item)" \ntx-refresh-action-event="vm.refreshRecord()" tx-height-offset="16"></tx-data-table></ms-widget-front></ms-widget>\n<md-button class="add-rec-button md-fab md-warn" ng-click="vm.assignArticles($event)" \naria-label="vm.articleModel.views.mainList.fabAction.label" translate \ntx-access="{{::vm.articleModel.views.mainList.fabAction.privilege}}"><md-icon \nmd-font-icon="{{vm.articleModel.views.mainList.fabAction.icon}}"></md-icon></md-button></div></md-tab><md-tab \nng-if="vm.resource.IsModelLevel || vm.isUnlinkedResource" label="{{\'RESOURCES.TABS.MODELS\' | translate}}" \ntx-access="{{::vm.modelModel.views.privileges.list}}" ng-disabled="!vm.resource.Status"><div class="list-tab" \nlayout="row" flex="100" layout-wrap><ms-widget layout="row" flex="100"><ms-widget-front class="white-bg"><tx-data-table\n tx-is-active="vm.tabIndex === 1" tx-data="vm.assignedModels" tx-model="vm.modelModel" tx-view="mainList" \ntx-filtered-data="vm.filteredAssignedModels" tx-data-filter="global.search" tx-is-loading="vm.isLoading" \ntx-item-action-event="vm.doModelItemAction(action, item)" \ntx-list-action-event="vm.doModelsListAction(action, selectedItems)" tx-item-click-event="vm.viewModel(item)" \ntx-refresh-action-event="vm.refreshRecord()" tx-height-offset="16"></tx-data-table></ms-widget-front></ms-widget>\n<md-button class="add-rec-button md-fab md-warn" ng-click="vm.assignModels($event)" \naria-label="vm.modelModel.views.mainList.fabAction.label" translate \ntx-access="{{::vm.modelModel.views.mainList.fabAction.privilege}}"><md-icon \nmd-font-icon="{{vm.modelModel.views.mainList.fabAction.icon}}"></md-icon></md-button></div></md-tab></md-tabs>\n<md-button id="txfab" class="md-fab md-warn" ng-if="vm.tabIndex === 0 && vm.resource.RefResourceId === 0" \nng-click="vm.editResource($event, vm.resource)" aria-label="vm.model.views.mainDetails.fab.label" translate \ntx-access="{{::vm.model.views.mainDetails.fab.privilege}}" ng-disabled="!vm.resource.Status"><md-icon \nmd-font-icon="{{vm.model.views.mainDetails.fab.icon}}"></md-icon></md-button></div></div>');
$templateCache.put('app/main/catalogs/sub-modules/resources/dialogs/copy-resources.html','<md-dialog aria-label="label" class="line-plan-dialog tx-dialog"><md-toolbar class="md-accent md-hue-2"><div \nclass="md-toolbar-tools" layout="row" layout-align="space-between center"><span class="title">\n{{\'RESOURCES.ACTIONS.COPY_RESOURCES\' | translate}}</span><md-button class="md-icon-button" ng-click="vm.closeDialog()" \naria-label="Close dialog" tranlate translate-aria-label="ACTIONS.DIALOG_CLOSE"><md-icon md-font-icon="icon-close">\n</md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div \nclass="page-layout carded fullwidth list-view" layout="row" layout-align="start start"><div class="center" \nlayout="column" flex><div class="content-card" layout="column" flex><tx-data-table tx-data="vm.data" \ntx-model="vm.model" tx-view="mainList" tx-filtered-data="vm.filteredData" tx-data-filter="global.search" \ntx-is-loading="vm.isLoading" tx-list-action-event="vm.doListAction(action, selectedItems)" \ntx-chart-view-enabled="false" tx-control="vm.tableControl"></tx-data-table></div></div></div></md-dialog-content>\n</md-dialog>');
$templateCache.put('app/main/catalogs/sub-modules/resources/dialogs/upload-resource.html','<md-dialog class="edit-dialog resource-uploader" aria-label="{{vm.isNew ? \'New Record\' : \'Edit Record\'}"><form \nname="vm.editForm" class="md-inline-form"><md-toolbar class="md-accent md-hue-2"><div class="md-toolbar-tools" \nlayout="row" layout-align="space-between center"><span class="title" \ntranslate="{{vm.isNew ? \'TITLES.RECORD_NEW\' : \'TITLES.RECORD_EDIT\'}}">New Record</span><md-button \nclass="md-icon-button" ng-click="vm.closeDialog(vm.isDataDirty, true)" aria-label="Close dialog" tranlate \ntranslate-aria-label="ACTIONS.DIALOG_CLOSE"><md-icon md-font-icon="icon-close"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div layout="row" layout-wrap><div flex="100" flex-gt-xs="50" \nclass="p-5 lookup-element"><md-autocomplete id="dialog_input_{{$first ? \'first\' : $index}}" md-input-name="TypeId" \nmd-selected-item="vm.lookupModel.TypeId" md-items="item in vm.lookupSearch(vm.searchText.TypeId, \'TypeId\')" \nmd-search-text="vm.searchText.TypeId" md-item-text="vm.getLookupDisplayValue(item, \'TypeId\')" md-min-length="0" \nmd-floating-label="{{\'RESOURCES.FIELDS.RESOURCE_TYPE_ID\' | translate}}" \nmd-selected-item-change="vm.onResourceTypeChange(vm.lookupModel.TypeId, \'TypeId\', vm.obj.flow.files)" \nng-required="true" md-no-cache="true" tx-clear-autocomplete tx-force-select ng-click="vm.selectText($event)" \nmd-menu-class="autocomplete-custom"><md-item-template><span class="autocomplete-item md-accent-fg" \nmd-highlight-text="vm.searchText.TypeId" md-highlight-flags="i">{{item.value}}</span></md-item-template><md-not-found>\nNo Record matching "{{vm.searchText.TypeId}}" were found.</md-not-found><div ng-messages="vm.editForm.TypeId.$error" \nrole="alert" ng-show="vm.editForm.TypeId.$touched"><div ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}\n</div></div></md-autocomplete></div><div flex="100" flex-gt-xs="50" class="p-5"><md-input-container class="md-block">\n<label translate>RESOURCES.FIELDS.RESOURCE_NAME</label><input name="ResourceName" ng-model="vm.record.ResourceName" \ntype="text" ng-required="true" md-maxlength="100"><div ng-messages="vm.editForm.ResourceName.$error" role="alert" \nmultiple="multiple"><div ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div><div \nng-message="md-maxlength">{{\'VALIDATIONS.MAXLEN\' | translate}}</div></div></md-input-container></div><div><label \ntranslate="RESOURCES.NAV"></label></div><div flex="100" class="p-5" flow-init="vm.flowInit" \nflow-object="$rootScope.flowObj" flow-file-added="vm.validateFile($file, $event, $flow, \'resource\')" \nflow-files-submitted="vm.upload(\'resource\')" flow-name="vm.obj.flow" \nflow-file-success="vm.onSuccessUpload($file, $message, $flow, \'resource\')" flow-drop><label for="flow-upload-file-id" \nng-hide="$flow.progress() === 1"><div class="file-uploader-container" \nflow-drag-enter="style={outline: \'2px dashed rgba(0,0,0,0.38)\', color: \'#939393\' }" \nflow-drag-leave="style={outline: \'2px dashed rgba(0,0,0,0.12)\', color: \'rgba(0,0,0,0.12)\'}" ng-style="style"><div \nclass="upload-label" ng-if="(vm.isNew && !$flow.isUploading()) || (!vm.isNew && vm.imgSrc === \'/\')"><div \nclass="upload-icon"><md-icon ng-style="style" md-font-icon="icon-upload" class="icon s1"></md-icon></div><div \nclass="upload-message" ng-style="style"><span>Choose a file or drag it here.</span></div></div><div \nng-if="!vm.isNew && vm.imgSrc !== \'/\'" class="image-container"><img ng-src="{{vm.imgSrc}}" tx-resource-file="true">\n</div><div class="uploaded-file-name"><label>{{vm.resourceName}}</label></div></div></label><label \nfor="flow-upload-file-id" class="" ng-show="$flow.progress() === 1"><div \nclass="file-uploader-container upload-success"><div class="image-container"><img flow-img="$flow.files[0]" \ntx-resource-file="true"></div><div class="uploaded-file-name"><label>{{$flow.files[0].name}}</label></div></div>\n</label><div class="upload-error" ng-show="!vm.isResourceFileValid">\n{{ \'IMAGES.MESSAGES.INVALID_FILE_FORMAT\' | translate }}</div><md-progress-linear md-mode="determinate" \nclass="md-accent" ng-if="$flow.isUploading()" value="{{$flow.progress()*100}}"></md-progress-linear><input type="file" \nid="flow-upload-file-id" class="ng-hide" flow-btn accept="{{vm.allowedFileTypeExtentions}}"></div><div \nclass="resource-icon-header"><label translate="RESOURCES.FIELDS.ICON"></label></div><div flex="100" class="p-5" \nflow-init="vm.flowInit" flow-object="$rootScope.flowObj2" \nflow-file-added="vm.validateFile($file, $event, $flow, \'icon\')" flow-files-submitted="vm.upload(\'icon\')" \nflow-name="vm.obj2.flow" flow-file-success="vm.onSuccessUpload($file, $message, $flow, \'icon\')" flow-drop><label \nfor="flow-upload-icon-id" ng-hide="$flow.progress() === 1"><div class="file-uploader-container" \nflow-drag-enter="style={outline: \'2px dashed rgba(0,0,0,0.38)\', color: \'#939393\' }" \nflow-drag-leave="style={outline: \'2px dashed rgba(0,0,0,0.12)\', color: \'rgba(0,0,0,0.12)\'}" ng-style="style"><div \nclass="upload-label" ng-if="(vm.isNew && !$flow.isUploading()) || (!vm.isNew && vm.record.Icon === \'\')"><div \nclass="upload-icon"><md-icon ng-style="style" md-font-icon="icon-upload" class="icon s1" hide-xs></md-icon></div><div \nclass="upload-message" ng-style="style"><span>Choose a file or drag it here.</span></div></div><div \nng-if="!vm.isNew && vm.record.Icon !== \'\'" class="image-container"><img ng-src="{{vm.record.Icon}}" \ntx-resource-file="true"></div><div class="uploaded-file-name"><label>{{vm.iconName}}</label></div></div></label><label \nfor="flow-upload-icon-id" class="" ng-show="$flow.progress() === 1"><div \nclass="file-uploader-container upload-success"><div class="image-container"><img flow-img="$flow.files[0]" \ntx-resource-file="true"></div><div class="uploaded-file-name"><label>{{$flow.files[0].name}}</label></div></div>\n</label><div class="upload-error" ng-show="!vm.isIconFileValid">{{ \'IMAGES.MESSAGES.INVALID_FILE_FORMAT\' | translate }}\n</div><md-progress-linear md-mode="determinate" class="md-accent" ng-if="$flow.isUploading()" \nvalue="{{$flow.progress()*100}}"></md-progress-linear><input type="file" id="flow-upload-icon-id" class="ng-hide" \nflow-btn accept="{{vm.allowedFileTypeExtentions}}"></div><div flex="100" flex-gt-xs="50" class="p-5 lookup-element" \nng-if="vm.isNew && !vm.record.IsModelLevel"><md-input-container class="md-block"><label translate>\n{{ \'RESOURCES.FIELDS.ARTICLE_NUMBER\' | translate }}</label><md-chips name="ArticleIds" ng-model="vm.record.ArticleIds" \nmd-autocomplete-snap md-transform-chip="vm.transformChip($chip)" md-require-match="true"><md-autocomplete \nmd-selected-item="vm.acSelectedItem.ArticleIds" md-search-text="vm.acSearchText.ArticleIds" \nmd-items="item in vm.acQuerySearch(vm.acSearchText.ArticleIds, vm.record.ArticleIds, \'ArticleIds\') | filter: {Status: 1}" \nmd-item-text="item.value" md-min-length="0" md-no-cache="true" md-menu-class="autocomplete-custom"><md-item-template>\n<span class="autocomplete-item md-accent-fg" md-highlight-text="vm.acSearchText.ArticleIds">{{item.value}}</span>\n</md-item-template><md-not-found>No Record matching "{{vm.acSearchText.ArticleIds}}" were found.</md-not-found>\n</md-autocomplete><md-chip-template><span><strong>{{vm.getChipDisplayValue($chip, \'ArticleIds\')}}</strong></span>\n</md-chip-template></md-chips><md-progress-linear md-mode="indeterminate" class="md-accent" \nng-if="vm.isArticlesLookupLoading"></md-progress-linear></md-input-container></div><div flex="100" flex-gt-xs="50" \nclass="p-5 lookup-element" ng-if="vm.isNew && vm.record.IsModelLevel"><md-input-container class="md-block"><label \ntranslate>{{ \'RESOURCES.FIELDS.MODEL_NUMBER\' | translate }}</label><md-chips name="ModelIds" \nng-model="vm.record.ModelIds" md-autocomplete-snap md-transform-chip="vm.transformChip($chip)" md-require-match="true">\n<md-autocomplete md-selected-item="vm.acSelectedItem.ModelIds" md-search-text="vm.acSearchText.ModelIds" \nmd-items="item in vm.acQuerySearch(vm.acSearchText.ModelIds, vm.record.ModelIds, \'ModelIds\') | filter: {Status: 1}" \nmd-item-text="item.value" md-min-length="0" md-no-cache="true" md-menu-class="autocomplete-custom"><md-item-template>\n<span class="autocomplete-item md-accent-fg" md-highlight-text="vm.acSearchText.ModelIds">{{item.value}}</span>\n</md-item-template><md-not-found>No Record matching "{{vm.acSearchText.ModelIds}}" were found.</md-not-found>\n</md-autocomplete><md-chip-template><span><strong>{{vm.getChipDisplayValue($chip, \'ModelIds\')}}</strong></span>\n</md-chip-template></md-chips><md-progress-linear md-mode="indeterminate" class="md-accent" \nng-if="vm.isModelsLookupLoading"></md-progress-linear></md-input-container></div><div flex="100" flex-gt-xs="50" \nclass="p-5" ng-if="vm.isNew"><md-switch ng-model="vm.record.IsModelLevel" \naria-label="{{\'RESOURCES.FIELDS.MODEL_RESOURCE\' | translate}}" ng-true-value="true" ng-false-value="false" \nclass="md-accent" ng-change="vm.onModelLevelToggleChange()">{{\'RESOURCES.FIELDS.MODEL_RESOURCE\' | translate}}\n<md-tooltip md-direction="right">{{vm.record.IsModelLevel ? \'PARTS.YES\' : \'PARTS.NO\' | translate}}</md-tooltip>\n</md-switch></div><div flex="100" flex-gt-xs="50" class="p-5"><md-input-container class="md-block"><label translate>\nRESOURCES.FIELDS.SORT_ORDER</label><input name="SortOrder" ng-model="vm.record.SortOrder" type="number" \nng-pattern="/^\\d+$/" ng-required="false"><div ng-messages="vm.editForm.SortOrder.$error" role="alert" \nmultiple="multiple"><div ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div><div \nng-message="md-maxlength">{{\'VALIDATIONS.MAXLEN\' | translate}}</div><div ng-message="pattern">\n{{\'VALIDATIONS.INVALID_SORT_ORDER\' | translate}}</div></div></md-input-container></div><div flex="100" flex-gt-xs="50" \nclass="p-5"><md-switch ng-model="vm.record.Cascading" aria-label="{{\'RESOURCES.FIELDS.CASCADING\' | translate}}" \nng-true-value="1" ng-false-value="0" class="md-accent">{{\'RESOURCES.FIELDS.CASCADING\' | translate}}<md-tooltip \nmd-direction="right">{{vm.record.Cascading === 1 ? \'PARTS.YES\' : \'PARTS.NO\' | translate}}</md-tooltip></md-switch>\n</div><div flex="100" flex-gt-xs="100" class="p-5"><md-input-container class="md-block"><label translate>\nRESOURCES.FIELDS.CATEGORY</label><input name="Category" ng-model="vm.record.Category" type="text" ng-required="false" \nmd-maxlength="1000"><div ng-messages="vm.editForm.Category.$error" role="alert" multiple="multiple"><div \nng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div><div ng-message="md-maxlength">\n{{\'VALIDATIONS.MAXLEN\' | translate}}</div></div></md-input-container></div><div flex="100" flex-gt-xs="100" \nclass="p-5"><md-input-container class="md-block"><label translate>RESOURCES.FIELDS.DESCRIPTION</label><input \nname="Description" ng-model="vm.record.Description" type="text" ng-required="false" md-maxlength="2000"><div \nng-messages="vm.editForm.Description.$error" role="alert" multiple="multiple"><div ng-message="required">\n{{\'VALIDATIONS.REQUIRED\' | translate}}</div><div ng-message="md-maxlength">{{\'VALIDATIONS.MAXLEN\' | translate}}</div>\n</div></md-input-container></div></div></md-dialog-content><md-dialog-actions layout="row" layout-align="end center">\n<div></div><div layout="row" layout-align="end center"><md-button ng-click="vm.closeDialog(vm.isDataDirty, true)" \nclass="send-button md-primary md-raised" aria-label="Cancel" translate="ACTIONS.DIALOG_CANCEL" \ntranslate-attr-aria-label="ACTIONS.DIALOG_CANCEL" ng-disabled="vm.isLoading">CANCEL</md-button><md-button \nng-click="vm.saveRecord()" class="send-button md-accent md-raised" aria-label="Save" translate="ACTIONS.SAVE" \ntranslate-attr-aria-label="ACTIONS.SAVE" \nng-disabled="vm.isLoading || vm.editForm.$invalid || !vm.isFileValid || vm.obj.flow.isUploading() || vm.obj2.flow.isUploading()\r\n                           || ((!vm.record.Icon && !vm.record.IconFileId) && (!vm.record.FilePath && !vm.record.FileId))">\nSAVE</md-button><md-button ng-click="vm.saveRecord(true)" class="send-button md-accent md-raised" aria-label="Save" \nng-show="vm.isNew" translate="ACTIONS.SAVE_AND_NEW" translate-attr-aria-label="ACTIONS.SAVE_AND_NEW" \nng-disabled="vm.isLoading || vm.editForm.$invalid || !vm.isFileValid || vm.obj.flow.isUploading() || vm.obj2.flow.isUploading()\r\n                           || ((!vm.record.Icon && !vm.record.IconFileId) && (!vm.record.FilePath && !vm.record.FileId))">\nSAVE</md-button></div></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/catalogs/sub-modules/resources/dialogs/upload-resources.html','<md-dialog class="edit-dialog" aria-label="New Record"><form name="vm.editForm" class="md-inline-form" \nflow-init="vm.flowInit" flow-object="$rootScope.flowObj" flow-file-added="vm.validateFile($file, $event, $flow)" \nflow-name="vm.obj.flow"><md-toolbar class="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" \nlayout-align="space-between center"><span class="title" translate="TITLES.RECORD_NEW">New Record</span><md-button \nclass="md-icon-button" ng-click="vm.closeDialog()" aria-label="Close dialog" tranlate \ntranslate-aria-label="ACTIONS.DIALOG_CLOSE"><md-icon md-font-icon="icon-close"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div layout="column" flex><div flex="100" flex-gt-xs="50" \nclass="p-5 lookup-element"><md-autocomplete id="dialog_input_{{$first ? \'first\' : $index}}" md-input-name="TypeId" \nmd-selected-item="vm.lookupModel.TypeId" md-items="item in vm.lookupSearch(vm.searchText.TypeId, \'TypeId\')" \nmd-search-text="vm.searchText.TypeId" md-item-text="item.value" md-min-length="0" \nmd-floating-label="{{\'RESOURCES.FIELDS.RESOURCE_TYPE_ID\' | translate}}" \nmd-selected-item-change="vm.lookupChange(vm.lookupModel.TypeId, \'TypeId\')" ng-required="true" md-no-cache="true" \ntx-clear-autocomplete tx-force-select ng-click="vm.selectText($event)" md-menu-class="autocomplete-custom" \nmd-autofocus><md-item-template><span class="autocomplete-item md-accent-fg" md-highlight-text="vm.searchText.TypeId" \nmd-highlight-flags="i">{{item.value}}</span></md-item-template><md-not-found>\nNo Record matching "{{vm.searchText.TypeId}}" were found.</md-not-found><div ng-messages="vm.editForm.TypeId.$error" \nrole="alert" ng-show="vm.editForm.TypeId.$touched"><div ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}\n</div></div></md-autocomplete></div><div flex="100" layout="row" layout-align="space-between center"><div \nflex="initial"><span>Filename:</span></div><div flex layout="row"><div flex class="text-boxed"><label for="fileName" \nng-show="$flow.files.length === 0" style="display: block; width: 100%">[none]</label><span \nng-show="$flow.files.length > 0" class="text-truncate">{{$flow.files[0].name}}</span></div></div><div flex="initial">\n<md-button class="md-raised"><label for="fileName">Select...</label></md-button></div></div><input type="file" \nflow-btn id="fileName" accept=".zip, .rar, .7z" class="ng-hide" required></div></md-dialog-content><md-dialog-actions \nlayout="row" layout-align="end center"><div></div><div layout="row" layout-align="end center"><md-button \nng-click="vm.closeDialog()" class="send-button md-primary md-raised" aria-label="Cancel" \ntranslate="ACTIONS.DIALOG_CANCEL" translate-attr-aria-label="ACTIONS.DIALOG_CANCEL" ng-disabled="vm.isLoading">CANCEL\n</md-button><md-button ng-click="vm.saveRecord()" class="send-button md-accent md-raised" aria-label="Save" \ntranslate="ACTIONS.SAVE" translate-attr-aria-label="ACTIONS.SAVE" \nng-disabled="!$flow.files.length || vm.editForm.$invalid || !vm.isFileValid">SAVE</md-button></div></md-dialog-actions>\n</form></md-dialog>');
$templateCache.put('app/main/catalogs/sub-modules/resources/list/resources-list.html','<div id="resources-list" class="page-layout carded fullwidth list-view" layout="row"><div class="center" \nlayout="column" flex><div class="content-card" layout="column" flex><tx-data-table tx-data="vm.resources" \ntx-model="vm.model" tx-view="mainList" tx-filtered-data="vm.filteredResources" tx-data-filter="global.search" \ntx-is-loading="vm.isLoading" tx-item-action-event="vm.doItemAction(action, item)" \ntx-list-action-event="vm.doListAction(action, selectedItems)" tx-item-click-event="vm.viewRecord(item)" \ntx-refresh-action-event="vm.refreshRecords(true, false)"></tx-data-table><md-button \nclass="add-rec-button md-fab md-warn" ng-click="vm.addRecord($event)" \naria-label="vm.model.views.mainList.fabAction.label" translate \ntx-access="{{::vm.model.views.mainList.fabAction.privilege}}"><md-icon \nmd-font-icon="{{vm.model.views.mainList.fabAction.icon}}"></md-icon></md-button></div></div></div>');
$templateCache.put('app/main/catalogs/sub-modules/saved-views/details/saved-views-details.html','<div id="saved-view-details" class="page-layout simple tabbed details-view" layout="column"><div class="content">\n<md-tabs md-dynamic-height md-selected="vm.tabIndex" md-no-ink><md-tab \nlabel="{{\'SAVED_VIEWS.TABS.SAVED_VIEW\' | translate}}" tx-access="{{::vm.model.views.privileges.details}}">\n<tx-data-details tx-height-offset="37" tx-account="vm.savedView" tx-title="vm.title" tx-model="vm.model" \ntx-item-actions="vm.model.views.mainDetails.itemActions" tx-item-action-event="vm.doItemAction(action, account)" \ntx-is-loading="vm.isLoading" tx-refresh-action-event="vm.refreshRecord(false)"></tx-data-details></md-tab><md-tab \nlabel="{{\'SAVED_VIEWS.TABS.SHARED_WITH_USERS\' | translate}}"><div class="list-tab" layout="row" flex="100" layout-wrap>\n<ms-widget layout="row" flex="100"><ms-widget-front class="white-bg"><tx-data-table tx-is-active="vm.tabIndex === 1" \ntx-data="vm.sharedWithUsers" tx-model="vm.sharedWithModelUsers" tx-view="mainList" \ntx-filtered-data="vm.filteredSharedWithUsers" tx-data-filter="global.search" tx-is-loading="vm.isLoading" \ntx-refresh-action-event="vm.refreshRecord(false)" tx-height-offset="16"></tx-data-table></ms-widget-front></ms-widget>\n</div></md-tab><md-tab label="{{\'SAVED_VIEWS.TABS.SHARED_WITH_USER_GROUPS\' | translate}}"><div class="list-tab" \nlayout="row" flex="100" layout-wrap><ms-widget layout="row" flex="100"><ms-widget-front class="white-bg"><tx-data-table\n tx-is-active="vm.tabIndex === 2" tx-data="vm.sharedWithUserGroups" tx-model="vm.sharedWithModelUserGroups" \ntx-view="mainList" tx-filtered-data="vm.filteredSharedWithUserGroups" tx-data-filter="global.search" \ntx-is-loading="vm.isLoading" tx-refresh-action-event="vm.refreshRecord(false)" tx-height-offset="16"></tx-data-table>\n</ms-widget-front></ms-widget></div></md-tab></md-tabs><md-button id="txfab" class="md-fab md-warn" \nng-if="vm.tabIndex === 0" ng-click="vm.editItem(vm.savedView, $event)" \naria-label="vm.model.views.mainDetails.fab.label" translate tx-access="{{::vm.model.views.mainDetails.fab.privilege}}">\n<md-icon md-font-icon="{{vm.model.views.mainDetails.fab.icon}}"></md-icon></md-button></div></div>');
$templateCache.put('app/main/catalogs/sub-modules/saved-views/list/saved-views-list.html','<div id="saved-views-list" class="page-layout carded fullwidth list-view" layout="row"><div class="center" \nlayout="column" flex><div class="content-card" layout="column" flex><tx-data-table tx-data="vm.savedViews" \ntx-model="vm.model" tx-view="mainList" tx-filtered-data="vm.filteredSavedViews" tx-data-filter="global.search" \ntx-is-loading="vm.isLoading" tx-list-action-event="vm.doListAction(action, selectedItems)" \ntx-item-action-event="vm.doItemAction(action, item)" tx-item-click-event="vm.viewItem(item)" \ntx-refresh-action-event="vm.refreshItems(true, false)"></tx-data-table></div></div></div>');
$templateCache.put('app/main/catalogs/sub-modules/segmentation/list/segmentation-list.html','<div id="segmentation-list" class="page-layout carded fullwidth list-view" layout="row"><div class="center" \nlayout="column" flex><div class="content-card" layout="column" flex><tx-data-table tx-data="vm.segmentations" \ntx-model="vm.model" tx-view="mainList" tx-filtered-data="vm.filteredSegmentations" tx-data-filter="global.search" \ntx-is-loading="vm.isLoading" tx-item-action-event="vm.doItemAction(action, item)" \ntx-list-action-event="vm.doListAction(action, selectedItems)" tx-item-click-event="vm.viewItem(item)" \ntx-refresh-action-event="vm.refreshItems(true, false)"></tx-data-table></div></div></div>');
$templateCache.put('app/main/catalogs/sub-modules/segmentation-linear/list/segmentation-linear-list.html','<div id="segmentation-list" class="page-layout carded fullwidth list-view" layout="row"><div class="center" \nlayout="column" flex><div class="content-card" layout="column" flex><tx-data-table tx-data="vm.segmentations" \ntx-model="vm.model" tx-view="mainList" tx-filtered-data="vm.filteredSegmentations" tx-data-filter="global.search" \ntx-is-loading="vm.isLoading" tx-item-action-event="vm.doItemAction(action, item)" \ntx-list-action-event="vm.doListAction(action, selectedItems)" tx-item-click-event="vm.viewItem(item)" \ntx-refresh-action-event="vm.refreshItems(true, false)"></tx-data-table><md-button \nclass="add-rec-button md-fab md-warn" ng-click="vm.assignArticleSegmentations($event)" \naria-label="vm.model.views.mainList.fabAction.label" translate \ntx-access="{{::vm.model.views.mainList.fabAction.privilege}}"><md-icon \nmd-font-icon="{{vm.model.views.mainList.fabAction.icon}}"></md-icon></md-button></div></div></div>');
$templateCache.put('app/main/catalogs/sub-modules/shared-folders/details/shared-folders-details.html','<div id="shared-folders-details" class="page-layout simple tabbed details-view" layout="column"><div class="content">\n<md-tabs md-dynamic-height md-selected="vm.tabIndex" md-no-ink><md-tab \nlabel="{{\'SHARED_FOLDERS.TABS.SHARED_FOLDER\' | translate}}" tx-access="{{::vm.model.views.privileges.details}}">\n<tx-data-details tx-height-offset="37" tx-account="vm.sharedFolder" tx-title="vm.title" tx-model="vm.model" \ntx-is-loading="vm.isLoading" tx-refresh-action-event="vm.refreshRecord(false)" \ntx-parent-id="vm.activeCatalog.CatalogCode"></tx-data-details></md-tab><md-tab \nlabel="{{\'SHARED_FOLDERS.TABS.USERS\' | translate}}" \nng-disabled="vm.sharedFolder.ParentFolderId != null && vm.sharedFolder.ParentFolderId !== 0" \ntx-access="{{::vm.sharedFolderUsersModel.views.privileges.list}}"><div class="list-tab" layout="row" flex="100" \nlayout-wrap><ms-widget layout="row" flex="100"><ms-widget-front class="white-bg"><tx-data-table \ntx-is-active="vm.tabIndex === 1" tx-data="vm.sharedFolderUsers" tx-model="vm.sharedFolderUsersModel" \ntx-view="mainList" tx-filtered-data="vm.filteredSharedFolderUsers" tx-data-filter="global.search" \ntx-is-loading="vm.isLoading" tx-refresh-action-event="vm.refreshRecord(false)" \ntx-item-action-event="vm.doUsersItemAction(action, item)" \ntx-list-action-event="vm.doUsersListAction(action, selectedItems)" tx-control="vm.tableControl" tx-height-offset="16">\n</tx-data-table></ms-widget-front></ms-widget><md-button class="add-rec-button md-fab md-warn" \nng-click="vm.assignUsers($event)" aria-label="vm.sharedFolderUsersModel.views.mainList.fabAction.label" translate \ntx-access="{{::vm.sharedFolderUsersModel.views.mainList.fabAction.privilege}}"><md-icon \nmd-font-icon="{{vm.sharedFolderUsersModel.views.mainList.fabAction.icon}}"></md-icon></md-button></div></md-tab>\n</md-tabs><md-button id="txfab" class="md-fab md-warn" ng-if="vm.tabIndex === 0" \nng-click="vm.editItem(vm.sharedFolder, $event)" aria-label="vm.model.views.mainDetails.fab.label" translate \ntx-access="{{::vm.model.views.mainDetails.fab.privilege}}"><md-icon \nmd-font-icon="{{vm.model.views.mainDetails.fab.icon}}"></md-icon></md-button></div></div>');
$templateCache.put('app/main/catalogs/sub-modules/shared-folders/list/shared-folders-list.html','<div id="order-adjustments-list" class="page-layout carded fullwidth list-view" layout="row"><div class="center" \nlayout="column" flex><div class="content-card" layout="column" flex><tx-data-table tx-data="vm.sharedFolders" \ntx-model="vm.model" tx-view="mainList" tx-filtered-data="vm.filteredSharedFolders" tx-data-filter="global.search" \ntx-is-loading="vm.isLoading" tx-item-action-event="vm.doItemAction(action, item)" \ntx-list-action-event="vm.doListAction(action, selectedItems)" tx-item-click-event="vm.viewItem(item)" \ntx-refresh-action-event="vm.refreshItems(true, false)"></tx-data-table><md-button \nclass="add-rec-button md-fab md-warn" ng-click="vm.addRecord($event)" \naria-label="::vm.model.views.mainList.fabAction.label" translate \ntx-access="{{::vm.model.views.mainList.fabAction.privilege}}"><md-icon \nmd-font-icon="{{::vm.model.views.mainList.fabAction.icon}}"></md-icon></md-button></div></div></div>');
$templateCache.put('app/main/catalogs/sub-modules/shared-folders-tree/details/shared-folders-tree-details.html','<div id="shared-folders-details" class="page-layout simple tabbed details-view" layout="column"><div class="content">\n<md-tabs md-dynamic-height md-selected="vm.tabIndex" md-no-ink><md-tab \nlabel="{{\'SHARED_FOLDERS.TABS.SHARED_FOLDER\' | translate}}" tx-access="{{::vm.model.views.privileges.details}}">\n<tx-data-details tx-height-offset="37" tx-account="vm.sharedFolder" tx-title="vm.title" tx-model="vm.model" \ntx-is-loading="vm.isLoading" tx-refresh-action-event="vm.refreshRecord(false)" \ntx-parent-id="vm.activeCatalog.CatalogCode"></tx-data-details></md-tab><md-tab \nlabel="{{\'SHARED_FOLDERS.TABS.USERS\' | translate}}" \nng-disabled="vm.sharedFolder.ParentFolderId != null && vm.sharedFolder.ParentFolderId !== 0" \ntx-access="{{::vm.sharedFolderUsersModel.views.privileges.list}}"><div class="list-tab" layout="row" flex="100" \nlayout-wrap><ms-widget layout="row" flex="100"><ms-widget-front class="white-bg"><tx-data-table \ntx-is-active="vm.tabIndex === 1" tx-data="vm.sharedFolderUsers" tx-model="vm.sharedFolderUsersModel" \ntx-view="mainList" tx-filtered-data="vm.filteredSharedFolderUsers" tx-data-filter="global.search" \ntx-is-loading="vm.isLoading" tx-refresh-action-event="vm.refreshRecord(false)" \ntx-item-action-event="vm.doUsersItemAction(action, item)" \ntx-list-action-event="vm.doUsersListAction(action, selectedItems)" tx-control="vm.tableControl" tx-height-offset="16">\n</tx-data-table></ms-widget-front></ms-widget><md-button class="add-rec-button md-fab md-warn" \nng-click="vm.assignUsers($event)" aria-label="vm.sharedFolderUsersModel.views.mainList.fabAction.label" translate \ntx-access="{{::vm.sharedFolderUsersModel.views.mainList.fabAction.privilege}}"><md-icon \nmd-font-icon="{{vm.sharedFolderUsersModel.views.mainList.fabAction.icon}}"></md-icon></md-button></div></md-tab>\n</md-tabs><md-button id="txfab" class="md-fab md-warn" ng-if="vm.tabIndex === 0" \nng-click="vm.editItem(vm.sharedFolder, $event)" aria-label="vm.model.views.mainDetails.fab.label" translate \ntx-access="{{::vm.model.views.mainDetails.fab.privilege}}"><md-icon \nmd-font-icon="{{vm.model.views.mainDetails.fab.icon}}"></md-icon></md-button></div></div>');
$templateCache.put('app/main/catalogs/sub-modules/shared-folders-tree/tree/shared-folders-tree.html','<div id="order-adjustments-list" class="page-layout carded fullwidth list-view" layout="row"><div class="center" \nlayout="column" flex><div class="content-card" layout="column" flex><tx-data-tree tx-data="vm.sharedFoldersTree" \ntx-model="vm.model" tx-columns="vm.cols" tx-branch-types="vm.branchTypes" tx-data-filter="vm.filter" \ntx-is-loading="vm.isLoading" tx-show-filter-row="vm.showFilterRow" \ntx-refresh-action-event="vm.refreshItems(true, false)" tx-item-action-event="vm.doItemAction(action, item)" \ntx-item-click-event="vm.onTreeNodeClick(item)" tx-list-action-event="vm.doListAction(action, selectedItems)" \ntx-prevent-folder-click="false" tx-height-offset="16"></tx-data-tree><md-button class="add-rec-button md-fab md-warn" \nng-click="vm.addRecord($event)" aria-label="::vm.model.views.mainList.fabAction.label" translate \ntx-access="{{::vm.model.views.mainList.fabAction.privilege}}"><md-icon \nmd-font-icon="{{::vm.model.views.mainList.fabAction.icon}}"></md-icon></md-button></div></div></div>');
$templateCache.put('app/main/catalogs/sub-modules/size-curves/dialogs/add-update-size-curve.html','<md-dialog class="edit-dialog" aria-label="Create Size Scale"><form name="vm.editForm" class="md-inline-form">\n<md-toolbar class="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" layout-align="space-between center">\n<span class="title" \ntranslate="{{ vm.isNew? \'SIZE_CURVES.TITLES.CREATE_SIZE_CURVE\': \'SIZE_CURVES.TITLES.UPDATE_SIZE_CURVE\' }}">\n{{vm.isNew ? \'Create Size Scale\' : \'Update Size Scale\'}}</span><md-button class="md-icon-button" \nng-click="vm.closeDialog(vm.isDataDirty)" aria-label="Close dialog" tranlate \ntranslate-aria-label="ACTIONS.DIALOG_CLOSE"><md-icon md-font-icon="icon-close"></md-icon></md-button></div>\n</md-toolbar><div class="loading-progress" ng-show="vm.isLoading" ng-click="$event.stopPropagation()" layout="row" \nlayout-align="center center"><md-progress-circular md-mode="indeterminate" class="md-accent"></md-progress-circular>\n</div><md-dialog-content ms-scroll ng-show="!vm.isLoading"><div layout="row" layout-wrap class="p-5" \nng-if="!vm.showAdditionalFields && vm.isNew && !vm.isSizeCurveByCriteria"><div class="type-label"><label translate>\nSIZE_CURVES.MESSAGES.SELECT_DATA_MESSAGE</label></div><div class="button-group" layout="row" class="p-5"><md-button \nng-click="vm.selectedDataChoice = 1" class="md-raised" aria-label="Article List" \nng-class="{ \'md-accent\': vm.selectedDataChoice === 1 }" translate="SIZE_CURVES.FIELDS.FAVORITES" \ntranslate-attr-aria-label="SIZE_CURVES.FIELDS.FAVORITES">Article List</md-button><md-button \nng-click="vm.selectedDataChoice = 2" class="md-raised" aria-label="Favorites" \nng-class="{ \'md-accent\': vm.selectedDataChoice === 2 }" translate="SIZE_CURVES.FIELDS.ARTICLES_LIST" \ntranslate-attr-aria-label="SIZE_CURVES.FIELDS.ARTICLES_LIST">Favorites</md-button></div><div flex="100" class="p-5" \nng-if="vm.selectedDataChoice === 1" class="lookup-element"><md-input-container class="md-block"><label>\n{{\'SIZE_CURVES.MESSAGES.FAVORITES_TAGS_LABEL\' | translate}}*</label><md-chips name="favorites" ng-model="vm.favorites" \nmd-autocomplete-snap md-transform-chip="vm.transformChip($chip)" md-require-match="true" ng-required="true">\n<md-autocomplete id="dialog_input_{{$index}}" md-selected-item="vm.acSelectedItem.favorites" \nmd-search-text="vm.acSearchText.favorites" \nmd-items="item in vm.acQuerySearch(vm.acSearchText.favorites, vm.favorites)" md-item-text="item.value" \nmd-min-length="0" md-no-cache="true" md-menu-class="autocomplete-custom"><md-item-template><span \nclass="autocomplete-item md-accent-fg" md-highlight-text="vm.acSearchText.favorites">{{item.Tag}}</span>\n</md-item-template><md-not-found>No Record matching "{{vm.acSearchText.favorites}}" were found.</md-not-found>\n</md-autocomplete><md-chip-template><span><strong>{{vm.getChipDisplayValue($chip)}}</strong></span></md-chip-template>\n</md-chips></md-input-container></div><div flex="100" class="p-5" ng-if="vm.selectedDataChoice === 2">\n<md-input-container class="md-block"><label translate>SIZE_CURVES.MESSAGES.ARTICLE_LIST_LABEL</label><textarea \nid="dialog_input_{{$index}}" name="articleNumbers" ng-model="vm.articleNumbers" columns="3" rows="3" \nng-required="true"></textarea><div ng-messages="vm.editForm.articleNumbers.$error" role="alert" multiple="multiple">\n<div ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div></div></md-input-container></div><div \nng-if="vm.noValidSizes"><label class="error-message" translate="SIZE_CURVES.VALIDATIONS.INVALID_SIZES">\nProvided articles doesn\'t have any common size. To create size curve, articles should have at least one common size.\n</label></div></div><div layout="row" layout-wrap class="p-5" \nng-if="vm.showAdditionalFields && (vm.validSizes.length > 0 || vm.isSizeCurveByCriteria)"><div flex="100" \nflex-gt-xs="100" class="p-5"><md-input-container class="md-block"><label translate>SIZE_CURVES.FIELDS.NAME</label>\n<input id="dialog_input_{{$index}}" name="Name" ng-model="vm.record.Name" type="text" ng-required="true" \ntx-unique-value="vm.existingRecordsForUniqueValue:Name:true"><div ng-messages="vm.editForm.Name.$error" role="alert" \nmultiple="multiple"><div ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div><div \nng-message="tx-unique-value">{{\'VALIDATIONS.NOT_UNIQUE\' | translate}}</div></div></md-input-container></div><div \nflex="100" class="p-5" layout="row" layout-wrap layout-align="space-between center"><div flex="45" layout="column">\n<md-input-container class="radio-group-container"><label translate>SIZE_CURVES.FIELDS.LEVEL</label><md-radio-group \nid="dialog_input_{{$index}}" layout="row" ng-model="vm.record.Level" class="radio-group" ng-change="vm.levelChange()" \nng-disabled="!vm.isNew"><md-radio-button value="Catalog" class="radio-button">Catalog</md-radio-button><md-radio-button\n value="Customer" class="radio-button">Customer</md-radio-button></md-radio-group></md-input-container></div><div \nflex="45" ng-if="vm.record.Level === \'Customer\'" layout="column"><md-autocomplete md-input-name="CustomerCode" \nmd-selected-item="vm.recordLookupModel.CustomerCode" md-items="item in vm.lookupSearch(vm.searchText.CustomerCode)" \nmd-search-text="vm.searchText.CustomerCode" md-item-text="vm.getLookupDisplayValue(item)" md-min-length="0" \nmd-floating-label="{{\'SIZE_CURVES.FIELDS.CUSTOMER_CODE\' | translate}}" \nmd-selected-item-change="vm.onCustomerChange(vm.recordLookupModel.CustomerCode)" ng-required="true" md-no-cache="true" \ntx-clear-autocomplete tx-force-select ng-click="vm.selectText($event)" md-menu-class="autocomplete-custom" \nng-disabled="!vm.isNew"><md-item-template><span class="autocomplete-item md-accent-fg" \nmd-highlight-text="vm.searchText.CustomerCode" md-highlight-flags="i">{{item.Name}}</span></md-item-template><div \nng-messages="vm.editForm.CustomerCode.$error" role="alert" ng-show="vm.editForm.CustomerCode.$touched"><div \nng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div></div><md-not-found>\nNo Record matching "{{vm.searchText.Name}}" were found.</md-not-found></md-autocomplete></div></div><div flex="50" \nflex-gt-xs="50" class="p-5"><md-input-container class="radio-group-container"><label translate>\nSIZE_CURVES.FIELDS.ALLOCATION_TYPE</label><md-radio-group id="dialog_input_6" layout="row" \nng-model="vm.record.AllocationType" class="radio-group" ng-change="vm.typeChange()"><md-radio-button value="Quantity" \nclass="radio-button">Quantity</md-radio-button><md-radio-button value="Percentage" class="radio-button">Percentage\n</md-radio-button></md-radio-group></md-input-container></div><div flex="100" flex-gt-xs="100" class="p-5" \nng-if="!vm.isSizeCurveByCriteria"><fieldset><legend>{{\'SIZE_CURVES.FIELDS.SIZES\'| translate}} <span \nng-if="vm.record.AllocationType === \'Percentage\'">{{ \'SIZE_CURVES.MESSAGES.TOTAL_PERCENTAGE\' | translate }}</span>\n</legend><div ng-repeat="size in vm.validSizes track by $index" flex="100" layout="row"><div flex="100" \nflex-gt-xs="50" class="p-5"><md-input-container class="md-block"><label>{{\'SIZE_CURVES.FIELDS.SIZE\'| translate}}\n</label><input id="dialog_input_{{$index}}" name="{{\'Size_\' + size.Size}}" ng-model="size.Size" type="text" \nng-disabled="true"></md-input-container></div><div flex="100" flex-gt-xs="50" class="p-5"><md-input-container \nclass="md-block"><label>{{\'SIZE_CURVES.FIELDS.VALUE\'| translate}}</label><input id="dialog_input_quantity_{{$index}}" \nname="{{\'Quantity_\' + size.Size}}" ng-model="size.Quantity" type="number" \nng-pattern="(vm.record.AllocationType === \'Quantity\') ? vm.quantityRegEx : vm.percentageRegEx" \nng-change="vm.isSizeRequired(); (vm.record.AllocationType === \'Percentage\') ? vm.validateTotalPercentage(): \'\';"><div \nng-messages="vm.editForm[\'Quantity_\' + size.Size].$error" role="alert" multiple="multiple"><div ng-message="pattern">\n{{vm.record.AllocationType === \'Quantity\' ? (\'SIZE_CURVES.VALIDATIONS.NOT_POSITIVE_NUMBER\' | translate) : (\'SIZE_CURVES.VALIDATIONS.INVALID_PERCENTAGE\' | translate)}}\n</div></div></md-input-container></div></div></fieldset></div><div flex="100" flex-gt-xs="100" class="p-5" \nng-if="!vm.isSizeCurveByCriteria"><fieldset><legend translate>SIZE_CURVES.FIELDS.CRITERIA</legend><div flex="100" \nflex-gt-xs="100" class="p-5"><table><tbody><tr ng-repeat="(key, value) in vm.validSizeCurveCriterias" \nstyle="border: 1px solid #dddddd"><td><strong>{{ key }}</strong></td><td>{{ value.join(\', \') }}</td></tr></tbody>\n</table></div></fieldset></div><div ng-if="vm.isSizeCurveByCriteria" flex="100" flex-gt-xs="100" class="p-5"><div \nflex="100" flex-gt-xs="100" class="p-5"><fieldset><legend>{{\'SIZE_CURVES.FIELDS.SIZES\'| translate}} <span \nng-if="vm.record.AllocationType === \'Percentage\'">{{ \'SIZE_CURVES.MESSAGES.TOTAL_PERCENTAGE\' | translate }}</span>\n</legend><div ng-repeat="record in vm.validSizes" flex="100" layout="row"><div flex="100" flex-gt-xs="50" \nclass="p-5 lookup-element"><md-input-container class="md-block"><label>\n{{\'SIZE_CURVES.FIELDS.SIZE\'| translate}} {{$index+1}}</label><input id="dialog_input_{{$index}}" name="Size" \nng-model="vm.validSizes[$index].Size" type="text" \nng-required="vm.isSizeAndQuantityRequired(\'Size\', \'Quantity\', $index)"><div ng-messages="vm.editForm.Size.$error" \nrole="alert" multiple="multiple"><div ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div></div>\n</md-input-container></div><div flex="100" flex-gt-xs="50" class="p-5"><md-input-container class="md-block"><label>\n{{\'SIZE_CURVES.FIELDS.VALUE\'| translate}}</label><input id="dialog_input_quantity_{{$index}}" \nname="{{\'Quantity_\' + size.Size}}" ng-model="vm.validSizes[$index].Quantity" type="number" \nng-pattern="(vm.record.AllocationType === \'Quantity\') ? vm.quantityRegEx : vm.percentageRegEx" \nng-change="vm.isSizeRequired(); (vm.record.AllocationType === \'Percentage\') ? vm.validateTotalPercentage(): \'\';" \nng-blur="vm.onSizeQuantityChange($index)"><div ng-messages="vm.editForm[\'Quantity_\' + size.Size].$error" role="alert" \nmultiple="multiple"><div ng-message="pattern">\n{{vm.record.AllocationType === \'Quantity\' ? (\'SIZE_CURVES.VALIDATIONS.NOT_POSITIVE_NUMBER\' | translate) : (\'SIZE_CURVES.VALIDATIONS.INVALID_PERCENTAGE\' | translate)}}\n</div></div></md-input-container></div></div></fieldset></div><div flex="100" flex-gt-xs="100" \nclass="p-5 lookup-element"><fieldset><legend translate>SIZE_CURVES.FIELDS.CRITERIA</legend><div \nng-repeat="record in vm.criterias" flex="100" layout="row" layout-wrap><div flex="100" flex-gt-xs="50" class="p-5">\n<md-autocomplete id="dialog_input_{{$index}}" md-input-name="Attributeid" \nmd-selected-item="vm.lookupModel[$index].Attributeid" \nmd-items="item in vm.lookupAttributeSearch(vm.searchText[$index].Attributeid, \'Attributeid\')" \nmd-search-text="vm.searchText[$index].Attributeid" \nmd-item-text="vm.getAttributeLookupDisplayValue(item, \'Attributeid\')" md-min-length="0" \nmd-floating-label="{{\'SIZE_CURVES.FIELDS.ATTRIBUTE\' | translate}}" md-no-cache="true" tx-clear-autocomplete \nng-click="vm.selectText($event)" \nmd-selected-item-change="vm.lookupAttributeChange(vm.lookupModel[$index].Attributeid, $index)" \nmd-menu-class="autocomplete-custom"><md-item-template><span class="autocomplete-item md-accent-fg" \nmd-highlight-text="vm.searchText[$index].Attributeid" md-highlight-flags="i">{{item.AttributeDisplayName}}</span>\n</md-item-template><md-not-found>No Record matching "{{vm.searchText[$index].Attributeid}}" were found.</md-not-found>\n<div ng-messages="vm.editForm.Id_$index.$error" role="alert" ng-show="vm.editForm.Id_$index.$touched" \nmultiple="multiple"><div ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div></div></md-autocomplete>\n</div><div flex="100" flex-gt-xs="50" class="p-5" ng-switch="vm.criterias[$index].inputType"><div \nng-if="vm.criterias[$index].inputType === \'date\'" layout="column" flex><md-datepicker \nid="dialog_input_{{$first ? \'first\' : $index}}" name="value" ng-model="vm.criterias[$index].value" \nng-init="vm.criterias[$index].value = vm.getDateObj(vm.criterias[$index].value)" md-placeholder=""></md-datepicker>\n</div><div ng-if="vm.criterias[$index].inputType === \'date-without-time\'" layout="column" flex><md-datepicker \nid="dialog_input_{{$first ? \'first\' : $index}}" name="value" ng-model="vm.criterias[$index].value" md-placeholder="">\n</md-datepicker></div><div ng-if="vm.criterias[$index].inputType === \'date-option\'" layout="column" flex><md-datepicker\n id="dialog_input_{{$first ? \'first\' : $index}}" name="value" ng-model="vm.criterias[$index].value" \nng-init="vm.criterias[$index].value = vm.getDateObj(vm.criterias[$index].value)" md-placeholder=""></md-datepicker>\n</div><div ng-if="vm.criterias[$index].inputType === \'bool-str\'"><md-switch \nid="dialog_input_{{$first ? \'first\' : $index}}" ng-model="vm.criterias[$index].value" \naria-label="{{vm.criterias[$index].displayLabel | translate}}" ng-true-value="\'true\'" ng-false-value="\'false\'" \nclass="md-accent"></md-switch></div><div \nng-if="vm.criterias[$index].inputType === \'textArea\' || vm.criterias[$index].inputType === \'calculated\' || vm.criterias[$index].inputType === \'number\'">\n<md-chips name="value" id="dialog_input_{{$first ? \'first\' : $index}}" ng-model="vm.criterias[$index].value" \nplaceholder="{{\'ACTIONS.ADD_TAGS\' | translate}}" secondary-placeholder="{{\'ACTIONS.ADD_MULTIPLE_VALUES\' | translate}}" \nmd-enable-chip-edit="true" md-max-chips="{{vm.maxTags}}" \nmd-on-add="vm.add($chip, vm.criterias[$index].value, vm.criterias[$index])"></md-chips><div class="md-chips-messages" \nng-messages="vm.criterias[$index].value.$error" \nng-show="vm.editForm[field.field].$dirty || vm.editForm[field.field].$submitted || vm.criterias[$index].inputType === \'decimal\'" \nmultiple="multiple"><div ng-message="required">{{field.validation.messages.isRequired | translate}}</div><div \nng-message="md-max-chips">{{field.validation.messages.maxLen | translate}}</div></div><div \nng-if="vm.add($chip, vm.criterias[$index].value, vm.criterias[$index])" class="error-message display-error">\n{{ vm.ErrorMessage}}</div></div><div \nng-if="vm.criterias[$index].inputType === \'multi-value\' || vm.criterias[$index].inputType === \'list\'">\n<md-input-container class="md-block"><md-chips id="dialog_input_{{$first ? \'first\' : $index}}" name="value" \nng-model="vm.criterias[$index].value" md-autocomplete-snap md-transform-chip="vm.transformAttributeChip($chip, true)" \naria-label="{{vm.criterias[$index].displayLabel | translate}}"><md-autocomplete \nmd-selected-item="vm.acSelectedItem[vm.criterias[$index].field]" \nmd-search-text="vm.acSearchText[vm.criterias[$index].field]" \nmd-items="item in vm.multiValueQuerySearch(vm.acSearchText[vm.criterias[$index].field], record.value, record)" \nmd-item-text="item" md-min-length="0" md-no-cache="true" md-menu-class="autocomplete-custom"><md-item-template><span \nclass="autocomplete-item md-accent-fg" md-highlight-text="vm.acSearchText[vm.criterias[$index].field]">{{item}}</span>\n</md-item-template><md-not-found>No Record matching "{{vm.acSearchText[vm.criterias[$index].field]}}" were found.\n</md-not-found></md-autocomplete><md-chip-template><span><strong>{{$chip}}</strong></span></md-chip-template>\n</md-chips></md-input-container></div></div></div></fieldset></div></div></div></md-dialog-content><md-dialog-actions \nlayout="row" layout-align="end center"><div></div><div layout="row" layout-align="end center"><md-button \nng-click="vm.closeDialog(vm.isDataDirty)" class="send-button md-primary md-raised" aria-label="Cancel" \ntranslate="ACTIONS.DIALOG_CANCEL" translate-attr-aria-label="ACTIONS.DIALOG_CANCEL" ng-disabled="vm.isLoading">CANCEL\n</md-button><md-button ng-click="vm.reset()" ng-if="vm.noValidSizes" class="send-button md-accent md-raised" \naria-label="Next" translate="ACTIONS.RESET" translate-attr-aria-label="ACTIONS.RESET" \nng-disabled="vm.isLoading || vm.editForm.$invalid">RESET</md-button><md-button ng-click="vm.getValidSizes()" \nng-if="!vm.showAdditionalFields && !vm.isSizeCurveByCriteria" class="send-button md-accent md-raised" \naria-label="Next" translate="ACTIONS.NEXT" translate-attr-aria-label="ACTIONS.NEXT" \nng-disabled="vm.isLoading || vm.editForm.$invalid || vm.noValidSizes">NEXT</md-button><md-button \nng-click="vm.saveRecord()" ng-if="vm.showAdditionalFields || vm.isSizeCurveByCriteria" \nclass="send-button md-accent md-raised" aria-label="Save" translate="ACTIONS.SAVE" \ntranslate-attr-aria-label="ACTIONS.SAVE" \nng-disabled="vm.isLoading || vm.editForm.$invalid || !vm.validSizes.length || (vm.record.AllocationType === \'Percentage\' && vm.totalPercentageExceedsLimit) || !vm.isQuantityAdded">\nSAVE</md-button></div></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/catalogs/sub-modules/size-curves/list/size-curves-list.html','<div id="size-curves-list" class="page-layout carded fullwidth list-view" layout="row"><div class="center" \nlayout="column" flex><div class="content-card" layout="column" flex><tx-data-table tx-data="vm.sizeCurves" \ntx-model="vm.model" tx-view="mainList" tx-filtered-data="vm.filteredSizeCurves" tx-data-filter="global.search" \ntx-is-loading="vm.isLoading" tx-list-action-event="vm.doListAction(action, selectedItems)" \ntx-item-action-event="vm.doItemAction(action, item)" tx-refresh-action-event="vm.refreshItems(true, false)">\n</tx-data-table><md-button class="add-rec-button md-fab md-warn" ng-click="vm.addSizeCurves($event)" \naria-label="vm.model.views.mainList.fabAction.label" translate \ntx-access="{{::vm.model.views.mainList.fabAction.privilege}}"><md-icon \nmd-font-icon="{{vm.model.views.mainList.fabAction.icon}}"></md-icon></md-button></div></div></div>');
$templateCache.put('app/main/catalogs/sub-modules/sizes/list/sizes-list.html','<div id="sizes-list" class="page-layout carded fullwidth list-view" layout="row"><div class="center" layout="column" \nflex><div class="content-card" layout="column" flex><tx-data-table tx-data="vm.sizes" tx-model="vm.model" \ntx-view="mainList" tx-filtered-data="vm.filteredSizes" tx-data-filter="global.search" tx-is-loading="vm.isLoading" \ntx-item-action-event="vm.doItemAction(action, item, additionalInfo)" \ntx-list-action-event="vm.doListAction(action, selectedItems, additionalInfo)" tx-item-click-event="vm.viewItem(item)" \ntx-refresh-action-event="vm.refreshItems(true, false)"></tx-data-table></div></div></div>');
$templateCache.put('app/main/catalogs/sub-modules/stock/list/stock-list.html','<div id="stock-list" class="page-layout carded fullwidth list-view" layout="row"><div class="center" layout="column" \nflex><div class="content-card" layout="column" flex><tx-data-table tx-data="vm.stock" tx-model="vm.model" \ntx-view="mainList" tx-filtered-data="vm.filteredStock" tx-data-filter="global.search" tx-is-loading="vm.isLoading" \ntx-item-action-event="vm.doItemAction(action, item, additionalInfo)" \ntx-list-action-event="vm.doListAction(action, selectedItems, additionalInfo)" tx-item-click-event="vm.viewItem(item)" \ntx-refresh-action-event="vm.refreshItems(true, false)"></tx-data-table></div></div></div>');
$templateCache.put('app/main/catalogs/sub-modules/stock-linear/list/stock-linear-list.html','<div id="stock-list" class="page-layout carded fullwidth list-view" layout="row"><div class="center" layout="column" \nflex><div class="content-card" layout="column" flex><tx-data-table tx-data="vm.stock" tx-model="vm.model" \ntx-view="mainList" tx-filtered-data="vm.filteredStock" tx-data-filter="global.search" tx-is-loading="vm.isLoading" \ntx-item-action-event="vm.doItemAction(action, item, additionalInfo)" \ntx-list-action-event="vm.doListAction(action, selectedItems, additionalInfo)" tx-item-click-event="vm.viewItem(item)" \ntx-refresh-action-event="vm.refreshItems(true, false)"></tx-data-table></div></div></div>');
$templateCache.put('app/main/catalogs/sub-modules/targets/dialogs/create-target.html','<md-dialog class="edit-dialog" aria-label="{{vm.isNew ? \'New Target\' : \'Edit target\'}}"><form name="vm.editForm" \nclass="md-inline-form"><md-toolbar class="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" \nlayout-align="space-between center"><span class="title" \ntranslate="{{vm.isNew ? \'TARGETS.ACTIONS.NEW_TARGET\' : \'TARGETS.ACTIONS.EDIT_TARGET\'}}">\n{{vm.isNew ? \'New Target\' : \'Edit target\'}}</span><md-button class="md-icon-button" \nng-click="vm.closeDialog(vm.isDataDirty)" aria-label="Close dialog" tranlate \ntranslate-aria-label="ACTIONS.DIALOG_CLOSE"><md-icon md-font-icon="icon-close"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div layout="row" layout-wrap><div flex="100" flex-gt-xs="50" class="p-5">\n<md-input-container class="md-block"><label translate>TARGETS.FIELDS.SKU_TARGETS</label><input id="dialog_input_first" \nname="SkuTargets" ng-model="vm.record.SkuTargets" type="number" ng-required="true" ng-disabled="false" md-autofocus \nng-pattern="/^[0-9]\\d*$/"><div ng-messages="vm.editForm.SkuTargets.$error" role="alert"><div ng-message="pattern">\n{{\'TARGETS.VALIDATIONS.NOT_POSITIVE_NUMBER\' | translate}}</div></div></md-input-container></div><div flex="100" \nflex-gt-xs="50" class="p-5"><md-input-container class="md-block"><label translate>TARGETS.FIELDS.MODEL_TARGETS</label>\n<input id="dialog_input_1" name="ModelTargets" ng-model="vm.record.ModelTargets" type="number" ng-required="true" \nng-disabled="false" ng-pattern="/^[0-9]\\d*$/"><div ng-messages="vm.editForm.ModelTargets.$error" role="alert"><div \nng-message="pattern">{{\'TARGETS.VALIDATIONS.NOT_POSITIVE_NUMBER\' | translate}}</div></div></md-input-container></div>\n<div flex="100" flex-gt-xs="100" class="p-5"><fieldset><legend class="header-non-editable-attributes" translate>\nTARGETS.FIELDS.TARGETED_ATTRIBUTES</legend><div ng-repeat="record in vm.attributesData" flex="100" layout="row" \nlayout-wrap><div flex="100" flex-gt-xs="50" class="p-5 lookup-element"><md-autocomplete \nid="dialog_input_attribute_{{$index}}" md-input-name="Attributes_$index" \nmd-selected-item="vm.lookupModel[$index].AttributeId" \nmd-items="item in vm.lookupSearch(vm.searchText[$index].AttributeId, $index)" \nmd-search-text="vm.searchText[$index].AttributeId" md-item-text="vm.getLookupDisplayValue(item)" md-min-length="0" \nmd-floating-label="{{\'TARGETS.FIELDS.TARGETED_ATTRIBUTE\' | translate}} {{$index+1}}" \nmd-selected-item-change="vm.lookupChange(vm.lookupModel[$index].AttributeId, $index)" \nng-required="vm.isRequired(\'AttributeId\', \'Value\', $index)" md-no-cache="true" tx-clear-autocomplete \nng-click="vm.selectText($event)" md-menu-class="autocomplete-custom"><md-item-template><span \nclass="autocomplete-item md-accent-fg" md-highlight-text="vm.searchText[$index].AttributeId" md-highlight-flags="i">\n{{item.AttributeDisplayName}}</span></md-item-template><div ng-messages="vm.editForm.Attributes_$index.$error" \nrole="alert" ng-show="vm.editForm.Attributes_$index.$touched"><div ng-message="required">\n{{\'VALIDATIONS.REQUIRED\' | translate}}</div></div><md-not-found>\nNo Record matching "{{vm.searchText[$index].AttributeId}}" were found.</md-not-found></md-autocomplete></div><div \nng-if="(!vm.isVettingListAttribute[$index] && !vm.isMultiValueAttribute[$index]) || (!vm.isVettingListAttribute[$index] && vm.isMultiValueAttribute[$index])" \nflex="100" flex-gt-xs="50" class="p-5"><md-input-container class="md-block"><label>\n{{\'TARGETS.FIELDS.VALUE\'| translate}} {{$index+1}}</label><input id="dialog_vettingList_attribute_input_{{$index}}" \nname="Value_$index" ng-model="vm.attributesData[$index].Value" type="text" \nng-required="vm.isRequired(\'AttributeId\', \'Value\', $index)" ng-blur="vm.onValueChange($index)"><div \nng-messages="vm.editForm.Value_$index.$error" role="alert" multiple="multiple"><div ng-message="required">\n{{\'VALIDATIONS.REQUIRED\' | translate}}</div></div></md-input-container></div><div \nng-if="vm.isVettingListAttribute[$index] && !vm.isMultiValueAttribute[$index]" flex="100" flex-gt-xs="50" class="p-5">\n<md-input-container class="md-block"><label>{{\'TARGETS.FIELDS.VALUE\'| translate}} {{$index+1}}</label><md-select \nid="dialog_input_{{$index}}" name="Value_$index" ng-model="vm.attributesData[$index].Value" \nng-required="vm.isRequired(\'AttributeId\', \'Value\', $index)" ng-change="vm.onValueChange($index)"><md-option \nmd-option-empty ng-value="\'\'"><em>None</em></md-option><md-option ng-value="option" \nng-repeat="option in vm.attributesData[$index].Values">{{ option }}</md-option></md-select><div \nng-messages="vm.editForm.Value_$index.$error" role="alert" multiple="multiple"><div ng-message="required">\n{{\'VALIDATIONS.REQUIRED\' | translate}}</div></div></md-input-container></div><div \nng-if="vm.isMultiValueAttribute[$index] && vm.isVettingListAttribute[$index]" flex="100" flex-gt-xs="50" class="p-5">\n<md-input-container class="md-block"><label>{{\'TARGETS.FIELDS.VALUE\'| translate}} {{$index+1}}</label><md-chips \nid="dialog_input_{{$index}}" name="Value_$index" ng-model="vm.attributesData[$index].Value" md-autocomplete-snap \nmd-transform-chip="vm.transformChip($chip, true)" ng-required="vm.isRequired(\'AttributeId\', \'Value\', $index)" \nng-init="vm.index = $index"><md-autocomplete \nmd-selected-item="vm.acSelectedItem[vm.attributesData[vm.index].AttributeId]" \nmd-search-text="vm.acSearchText[vm.attributesData[vm.index].AttributeId]" \nmd-items="item in vm.multiValueQuerySearch(vm.acSearchText[vm.attributesData[vm.index].AttributeId], vm.attributesData[vm.index].Value, vm.attributesData[vm.index])" \nmd-item-text="item" md-min-length="0" md-no-cache="true" md-menu-class="autocomplete-custom"><md-item-template><span \nclass="autocomplete-item md-accent-fg" md-highlight-text="vm.acSearchText[vm.attributesData[vm.index].AttributeId]">\n{{item}}</span></md-item-template><md-not-found>\nNo Record matching "{{vm.acSearchText[vm.attributesData[vm.index].AttributeId]}}" were found.</md-not-found>\n</md-autocomplete><md-chip-template><span><strong>{{$chip}}</strong></span></md-chip-template></md-chips><div \nclass="md-chips-messages" ng-messages="vm.editForm.Value_$index.$error" role="alert" multiple="multiple"><div \nng-message="required">{{ \'VALIDATIONS.REQUIRED\' | translate}}</div></div></md-input-container></div></div></fieldset>\n</div><div flex="100" flex-gt-xs="100" class="p-5"><fieldset><legend class="header-non-editable-attributes" translate>\nTARGETS.FIELDS.AGGREGATE_ATTRIBUTES</legend><div ng-repeat="record in vm.aggregateAttributesData" flex="100" \nlayout="row"><div flex="100" flex-gt-xs="50" class="p-5 lookup-element"><md-autocomplete \nid="dialog_input_attribute_{{$index}}" md-input-name="Attributes_$index" \nmd-selected-item="vm.lookupModel[$index].AggregateAttributeId" \nmd-items="item in vm.aggregateAttributeLookupSearch(vm.searchText[$index].AggregateAttributeId, $index)" \nmd-search-text="vm.searchText[$index].AggregateAttributeId" \nmd-item-text="vm.getAggregateAttributeLookupDisplayValue(item)" md-min-length="0" \nmd-floating-label="{{\'TARGETS.FIELDS.AGGREGATE_ATTRIBUTE\' | translate}} {{$index+1}}" \nmd-selected-item-change="vm.aggregateAttributeLookupChange(vm.lookupModel[$index].AggregateAttributeId, $index)" \nng-required="vm.isAggregateAttributeRequired(\'AggregateAttributeId\', \'Value\', $index)" md-no-cache="true" \ntx-clear-autocomplete ng-click="vm.selectText($event)" md-menu-class="autocomplete-custom"><md-item-template><span \nclass="autocomplete-item md-accent-fg" md-highlight-text="vm.searchText[$index].AggregateAttributeId" \nmd-highlight-flags="i">{{item.AttributeDisplayName}}</span></md-item-template><md-not-found>\nNo Record matching "{{vm.searchText[$index].AggregateAttributeId}}" were found.</md-not-found></md-autocomplete></div>\n<div flex="100" flex-gt-xs="50" class="p-5"><md-input-container class="md-block"><label>\n{{\'TARGETS.FIELDS.TARGET\'| translate}} {{$index+1}}</label><input id="dialog_vettingList_attribute_input_{{$index}}" \nname="Value_$index" ng-model="vm.aggregateAttributesData[$index].Target" type="number" \nng-required="vm.isAggregateAttributeRequired(\'AggregateAttributeId\', \'Value\', $index)" \nng-blur="vm.onAggregateAttributeValueChange($index)" ng-pattern="/^[0-9]\\d*$/"><div \nng-messages="vm.editForm.Value_$index.$error" role="alert" multiple="multiple"><div ng-message="pattern">\n{{\'TARGETS.VALIDATIONS.NOT_POSITIVE_NUMBER\' | translate}}</div></div></md-input-container></div></div></fieldset></div>\n</div></md-dialog-content><md-dialog-actions layout="row" layout-align="end center"><div></div><div layout="row" \nlayout-align="end center"><md-button ng-click="vm.closeDialog(vm.isDataDirty)" \nclass="send-button md-primary md-raised" aria-label="Cancel" translate="ACTIONS.DIALOG_CANCEL" \ntranslate-attr-aria-label="ACTIONS.DIALOG_CANCEL" ng-disabled="vm.isLoading">CANCEL</md-button><md-button \nng-click="vm.saveRecord()" class="send-button md-accent md-raised" aria-label="Save" translate="ACTIONS.SAVE" \ntranslate-attr-aria-label="ACTIONS.SAVE" ng-disabled="vm.isLoading || vm.editForm.$invalid">SAVE</md-button><md-button \nng-click="vm.saveRecord(true)" class="send-button md-accent md-raised" aria-label="Save" \ntranslate="ACTIONS.SAVE_AND_NEW" translate-attr-aria-label="ACTIONS.SAVE_AND_NEW" \nng-disabled="vm.isLoading || vm.editForm.$invalid" ng-show="vm.isNew">SAVE</md-button></div></md-dialog-actions></form>\n</md-dialog>');
$templateCache.put('app/main/catalogs/sub-modules/targets/list/targets-list.html','<div id="targets-list" class="page-layout carded fullwidth list-view" layout="row"><div class="center" layout="column" \nflex><div class="content-card" layout="column" flex><tx-data-table tx-data="vm.targets" tx-model="vm.model" \ntx-view="mainList" tx-filtered-data="vm.filteredTargets" tx-data-filter="global.search" tx-is-loading="vm.isLoading" \ntx-item-action-event="vm.doItemAction(action, item)" tx-list-action-event="vm.doListAction(action, selectedItems)" \ntx-refresh-action-event="vm.refreshItems(true, false)" tx-control="vm.tableControl"></tx-data-table><md-button \nclass="add-rec-button md-fab md-warn" ng-click="vm.addRecord($event)" \naria-label="::vm.model.views.mainList.fabAction.label" translate \ntx-access="{{::vm.model.views.mainList.fabAction.privilege}}"><md-icon \nmd-font-icon="{{::vm.model.views.mainList.fabAction.icon}}"></md-icon></md-button></div></div></div>');
$templateCache.put('app/main/catalogs/sub-modules/tree/nodes/tree-nodes.html','<div id="catalog-tree" class="page-layout carded fullwidth" layout="row"><div class="center" layout="column" flex><div \nclass="content-card" layout="column" flex><tx-data-tree tx-data="vm.tree" tx-branch-types="vm.branchTypes" \ntx-model="vm.model" tx-list-actions="vm.model.views.mainList.listActions" tx-data-filter="vm.filter" \ntx-is-loading="vm.isLoading" tx-tree-event-handler="vm.treeOptions" tx-show-filter-row="vm.showFilterRow" \ntx-refresh-action-event="vm.doRefresh()" tx-show-tree-list="true" tx-list-action-event="vm.doTreeListAction(action)" \ntx-height-offset="16" tx-tree-view-options="vm.treeViewOptions"></tx-data-tree></div></div></div>');
$templateCache.put('app/main/catalogs/sub-modules/tree-list/list/tree-list.html','<div id="assortment-list" class="page-layout carded fullwidth" layout="row"><div class="center" layout="column" flex>\n<div class="content-card" layout="column" flex><tx-data-table tx-data="vm.treeListData" tx-model="vm.model" \ntx-view="mainList" tx-filtered-data="vm.filteredTreeListData" tx-data-filter="global.search" \ntx-is-loading="vm.isLoading" tx-support-images-view="false" tx-show-tree-list="true" \ntx-refresh-action-event="vm.doRefresh(true, false)" tx-item-action-event="vm.doItemAction(action, item)">\n</tx-data-table></div></div></div>');
$templateCache.put('app/main/seller-models/list/dialogs/set-model-size-scales/set-model-size-scales.html','<md-dialog class="edit-dialog" aria-label="Set Size Scale"><form name="vm.editForm" class="md-inline-form"><md-toolbar \nclass="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" layout-align="space-between center"><span \nclass="title" translate="{{\'SELLER_MODELS.ACTIONS.SET_SIZES\'}}">Set Size Scale</span><md-button class="md-icon-button" \nng-click="vm.closeDialog(vm.isDataDirty)" aria-label="Close dialog" tranlate \ntranslate-aria-label="ACTIONS.DIALOG_CLOSE"><md-icon md-font-icon="icon-close"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div class="loading-progress" ng-if="vm.isMasterSizeScalesLoading" \nng-click="$event.stopPropagation()" layout="row" layout-align="center center"><md-progress-circular \nmd-mode="indeterminate" class="md-accent"></md-progress-circular></div><div layout="row" layout-wrap \nng-if="!vm.isMasterSizeScalesLoading"><div flex="100" flex-gt-xs="100" class="p-5 lookup-element"><span \nng-if="vm.isMasterSizeScaleObsolete" class="attribute-criteria-icon"><md-tooltip><span>\n{{ \'MESSAGES.CONTENT.MASTER_SIZE_SCALE_OBSELETE\' | translate }}</span></md-tooltip></span><md-autocomplete \nid="dialog_input_{{$first ? \'first\' : $index}}" md-input-name="MasterSizeScaleId" \nmd-selected-item="vm.lookupModel.MasterSizeScaleId" \nmd-items="item in vm.masterSizeScaleLookupSearch(vm.searchText.MasterSizeScaleId, \'SizeScale\')" \nmd-search-text="vm.searchText.MasterSizeScaleId" \nmd-item-text="vm.getMasterSizeScaleLookupDisplayValue(item, \'SizeScale\')" md-min-length="0" \nmd-floating-label="{{\'SELLER_MODELS.FIELDS.MASTER_SIZE_SCALE\' | translate}}" \nmd-selected-item-change="vm.masterSizeScaleLookupChange(vm.lookupModel.MasterSizeScaleId, \'MasterSizeScaleId\')" \nng-required="vm.record.MasterSizeScaleId == null" md-no-cache="true" md-autofocus="true" tx-clear-autocomplete \ntx-force-select ng-click="vm.selectText($event)" md-menu-class="autocomplete-custom"><md-item-template><span \nclass="autocomplete-item md-accent-fg" md-highlight-text="vm.searchText.MasterSizeScaleId" md-highlight-flags="i">\n{{item.SizeScale}}</span></md-item-template><md-not-found>\nNo Record matching "{{vm.searchText.MasterSizeScaleId}}" were found.</md-not-found><div \nclass="info-for-first-100-records" ng-if="vm.isAboveDropDownLimit"><md-icon class="icon s14" \nmd-font-icon="icon-information-outline"></md-icon><span>{{\'MESSAGES.CONTENT.SHOW_FIRST_100\' | translate}}</span></div>\n<div ng-messages="vm.editForm.MasterSizeScaleId.$error" role="alert" ng-show="vm.editForm.SizeScaleId.$touched"><div \nng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div></div></md-autocomplete></div><div flex="100" \nflex-gt-xs="100" class="p-5 lookup-element"><md-autocomplete id="dialog_input_{{$first ? \'first\' : $index}}" \nmd-input-name="SizeScaleId" md-selected-item="vm.lookupModel.SizeScaleId" \nmd-items="item in vm.lookupSearch(vm.searchText.SizeScaleId, \'SizeScale\')" md-search-text="vm.searchText.SizeScaleId" \nmd-item-text="vm.getLookupDisplayValue(item, \'SizeScale\')" md-min-length="0" \nmd-floating-label="{{\'SELLER_MODELS.FIELDS.SIZE_SCALE\' | translate}}" \nmd-selected-item-change="vm.lookupChange(vm.lookupModel.SizeScaleId, \'SizeScale\')" \nng-required="vm.record.SizeScaleId == null" md-no-cache="true" md-autofocus="true" tx-clear-autocomplete \ntx-force-select ng-disabled="vm.record.MasterSizeScaleId == null || vm.isMasterSizeScaleObsolete" \nng-click="vm.selectText($event)" md-menu-class="autocomplete-custom"><md-item-template><span \nclass="autocomplete-item md-accent-fg" md-highlight-text="vm.searchText.SizeScaleId" md-highlight-flags="i">\n{{item.SizeScale}}</span></md-item-template><md-not-found>\nNo Record matching "{{vm.searchText.SizeScaleId}}" were found.</md-not-found><div class="info-for-first-100-records" \nng-if="vm.isAboveDropDownLimit"><md-icon class="icon s14" md-font-icon="icon-information-outline"></md-icon><span>\n{{\'MESSAGES.CONTENT.SHOW_FIRST_100\' | translate}}</span></div><div ng-messages="vm.editForm.SizeScaleId.$error" \nrole="alert" ng-show="vm.editForm.SizeScaleId.$touched"><div ng-message="required">\n{{\'VALIDATIONS.REQUIRED\' | translate}}</div></div></md-autocomplete></div></div></md-dialog-content><md-dialog-actions \nlayout="row" layout-align="end center"><div></div><div layout="row" layout-align="end center"><md-button \nng-click="vm.closeDialog(vm.isDataDirty)" class="send-button md-primary md-raised" aria-label="Cancel" \ntranslate="ACTIONS.DIALOG_CANCEL" translate-attr-aria-label="ACTIONS.DIALOG_CANCEL" ng-disabled="vm.isLoading">CANCEL\n</md-button><md-button ng-click="vm.saveRecord()" class="send-button md-accent md-raised" aria-label="Save" \ntranslate="ACTIONS.SAVE" translate-attr-aria-label="ACTIONS.SAVE" \nng-disabled="vm.isLoading || vm.editForm.$invalid || vm.isMasterSizeScaleObsolete">SAVE</md-button></div>\n</md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/accounts/auth-users/list/dialogs/create-auth-user/create-auth-user.html','<md-dialog class="edit-dialog" aria-label="New User"><form name="vm.editForm" class="md-inline-form"><md-toolbar \nclass="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" layout-align="space-between center"><span \nclass="title" translate="{{vm.isNew ? \'AUTH_USERS.TITLES.NEW_USER\' : \'AUTH_USERS.TITLES.UPDATE_USER\'}}">New User</span>\n<md-button class="md-icon-button" ng-click="vm.closeDialog(vm.isDataDirty)" aria-label="Close dialog" tranlate \ntranslate-aria-label="ACTIONS.DIALOG_CLOSE"><md-icon md-font-icon="icon-close"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div layout="row" layout-wrap><div flex="100" flex-gt-xs="50" class="p-5" \nng-if="vm.isNew"><md-select id="dialog_input_$first" ng-model="vm.accountType" \nplaceholder="{{\'AUTH_USERS.FIELDS.ACCOUNT_TYPE\' | translate}}" aria-label="Account Type" \nng-change="vm.onAccountTypeChange(vm.accountType)" ng-required="vm.isNew"><md-option \nng-repeat="accountType in vm.accountTypes | orderBy:\'value\'" ng-value="accountType">{{ accountType.value }}</md-option>\n</md-select></div><div flex="100" flex-gt-xs="50" class="p-5 lookup-element" ng-if="vm.isNew"><md-autocomplete \nid="dialog_input_1" md-input-name="accountId" md-selected-item="vm.lookupModel.accountId" \nmd-items="item in vm.lookupSearch(vm.searchText.accountId, vm.accountType[\'value\'], vm.accountType[\'lookupSource\'], {\'Status\': 1})" \nmd-search-text="vm.searchText.accountId" \nmd-item-text="vm.getLookupDisplayValue(item, vm.accountType[\'value\'], vm.accountType[\'lookupSource\'])" \nmd-selected-item-change="vm.lookupChange(vm.lookupModel.accountId, \'accountId\')" md-min-length="0" \nmd-floating-label="{{\'AUTH_USERS.FIELDS.ACCOUNT\' | translate}}" ng-required="vm.isNew && vm.accountType.id !== 1" \nmd-no-cache="true" tx-clear-autocomplete ng-click="vm.selectText($event)" md-menu-class="autocomplete-custom" \nng-disabled="!vm.accountType.id || vm.accountType.id === 1"><md-item-template><span \nclass="autocomplete-item md-accent-fg" md-highlight-text="vm.searchText.accountId" md-highlight-flags="i">\n{{item.value}}</span></md-item-template><div ng-messages="vm.editForm.accountId.$error" role="alert" \nng-show="vm.editForm.accountId.$touched"><div ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div></div>\n<md-not-found>No Record matching "{{vm.searchText.accountId}}" were found.</md-not-found></md-autocomplete></div><div \nflex="100" flex-gt-xs="50" class="p-5 lookup-element"><md-autocomplete id="dialog_input_2" \nmd-selected-item="vm.lookupModel.masterUser" md-search-text="vm.masterUser" \nmd-items="item in vm.querySearch(vm.masterUser)" md-item-text="item.username" md-min-length="0" \nmd-floating-label="{{\'AUTH_USERS.FIELDS.MASTER_USER\' | translate}}" ng-required="false" md-no-cache="true" \ntx-clear-autocomplete md-selected-item-change="vm.masterUserChange(item)" md-menu-class="autocomplete-custom">\n<md-item-template><span class="autocomplete-item md-accent-fg" md-highlight-text="vm.masterUser" \nmd-highlight-flags="i">{{::item.username}}</span></md-item-template><div ng-messages="vm.editForm.masterUser.$error" \nrole="alert" ng-show="vm.editForm.masterUser.$touched"><div ng-message="required">\n{{\'VALIDATIONS.REQUIRED\' | translate}}</div></div><md-not-found>\nNo Record matching "{{vm.searchText.MasterUser}}" were found.</md-not-found><div class="info-for-first-100-records" \nng-if="vm.isAboveMasterUserDropDownLimit"><md-icon class="icon s14" md-font-icon="icon-information-outline"></md-icon>\n<span>{{\'MESSAGES.CONTENT.SHOW_FIRST_100\' | translate}}</span></div></md-autocomplete></div><div flex="100" \nflex-gt-xs="50" class="p-5"><md-input-container class="md-block"><label>{{\'AUTH_USERS.FIELDS.FIRST_NAME\' | translate}}\n</label><input id="dialog_input_3" name="FirstName" ng-model="vm.record.firstName" type="text" ng-required="true" \nng-pattern="/^[A-Za-z]+$/" md-maxlength="20"><div ng-messages="vm.editForm.FirstName.$error" role="alert" \nmultiple="multiple"><div ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div><div \nng-message="md-maxlength">{{\'VALIDATIONS.MAXLEN\' | translate}}</div><div ng-message="pattern">\n{{\'VALIDATIONS.INVALID_NAME\' | translate}}</div></div></md-input-container></div><div flex="100" flex-gt-xs="50" \nclass="p-5"><md-input-container class="md-block"><label>{{\'AUTH_USERS.FIELDS.LAST_NAME\' | translate}}</label><input \nid="dialog_input_4" name="LastName" ng-model="vm.record.lastName" type="text" ng-required="true" \nng-pattern="/^[A-Za-z]+$/" md-maxlength="20"><div ng-messages="vm.editForm.LastName.$error" role="alert" \nmultiple="multiple"><div ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div><div \nng-message="md-maxlength">{{\'VALIDATIONS.MAXLEN\' | translate}}</div><div ng-message="pattern">\n{{\'VALIDATIONS.INVALID_NAME\' | translate}}</div></div></md-input-container></div><div flex="100" flex-gt-xs="50" \nclass="p-5" ng-if="vm.isNew"><md-input-container class="md-block"><label>{{\'AUTH_USERS.FIELDS.EMAIL\' | translate}}\n</label><input id="dialog_input_5" name="email" ng-model="vm.record.email" type="text" ng-required="true" \nmd-maxlength="500" ng-pattern="/^[A-Za-z]+[A-Za-z0-9._+-]+@{1}[A-Za-z0-9._-]+\\.[A-Za-z.]{2,}$/" \nng-change="vm.validateEmail()"><div ng-messages="vm.editForm.email.$error" role="alert" multiple="multiple"><div \nng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div><div ng-message="pattern">\n{{\'VALIDATIONS.INVALID_EMAIL\' | translate}}</div><div ng-message="md-maxlength">{{\'VALIDATIONS.MAXLEN\' | translate}}\n</div><div ng-message="emailUnique">{{\'VALIDATIONS.EMAIL_NOT_UNIQUE\' | translate}}</div></div></md-input-container>\n</div><div flex="100" flex-gt-xs="50" class="p-5" ng-if="vm.isNew"><md-input-container class="md-block"><label>\n{{\'AUTH_USERS.FIELDS.USER_NAME\' | translate}}</label><input id="dialog_input_6" name="username" \nng-model="vm.record.username" type="text" ng-required="true" md-maxlength="50" \ntx-unique-value="vm.existingUsers:username:true"><div ng-messages="vm.editForm.username.$error" role="alert" \nmultiple="multiple"><div ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div><div \nng-message="md-maxlength">{{\'VALIDATIONS.MAXLEN\' | translate}}</div><div ng-message="tx-unique-value">\n{{\'VALIDATIONS.NOT_UNIQUE\' | translate}}</div></div></md-input-container></div><div flex="100" flex-gt-xs="50" \nclass="p-5"><md-input-container class="md-block"><label>{{\'AUTH_USERS.FIELDS.PHONE\' | translate}}</label><input \nid="dialog_input_7" name="phone" ng-model="vm.record.phone" type="tel" ng-required="false" md-maxlength="20" \nng-pattern="/[0-9]*/"><div ng-messages="vm.editForm.phone.$error" role="alert" multiple="multiple"><div \nng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div><div ng-message="pattern">\n{{\'VALIDATIONS.PATTERN\' | translate}}</div><div ng-message="md-maxlength">{{\'VALIDATIONS.MAXLEN\' | translate}}</div>\n</div></md-input-container></div><div flex="100" flex-gt-xs="50" class="p-5 lookup-element"><md-autocomplete \nid="dialog_input_8" md-input-name="countryCode" md-selected-item="vm.lookupModel.countryCode" \nmd-items="item in vm.lookupSearch(vm.searchText.countryCode, \'countryCode\', \'lists.countries\')" \nmd-search-text="vm.searchText.countryCode" \nmd-item-text="vm.getLookupDisplayValue(item, \'countryCode\', \'lists.countries\')" md-min-length="0" \nmd-floating-label="{{\'AUTH_USERS.FIELDS.COUNTRY_CODE\' | translate}}" \nmd-selected-item-change="vm.lookupChange(vm.lookupModel.countryCode, \'countryCode\')" ng-required="true" \nmd-no-cache="true" tx-clear-autocomplete tx-force-select ng-click="vm.selectText($event)" \nmd-menu-class="autocomplete-custom"><md-item-template><span class="autocomplete-item md-accent-fg" \nmd-highlight-text="vm.searchText.countryCode" md-highlight-flags="i">{{item.value}}</span></md-item-template><div \nng-messages="vm.editForm.countryCode.$error" role="alert" ng-show="vm.editForm.countryCode.$touched"><div \nng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div></div><md-not-found>\nNo Record matching "{{vm.searchText.countryCode}}" were found.</md-not-found></md-autocomplete></div><div flex="100" \nflex-gt-xs="50" class="p-5"><md-input-container class="md-block"><label>{{\'AUTH_USERS.FIELDS.CITY\' | translate}}\n</label><input id="dialog_input_9" name="city" ng-model="vm.record.city" type="text" ng-required="false" \nmd-maxlength="25"><div ng-messages="vm.editForm.city.$error" role="alert" multiple="multiple"><div \nng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div><div ng-message="md-maxlength">\n{{\'VALIDATIONS.MAXLEN\' | translate}}</div></div></md-input-container></div><div flex="100" flex-gt-xs="50" class="p-5">\n<md-input-container class="md-block"><label>{{\'AUTH_USERS.FIELDS.DESIGNATION\' | translate}}</label><input \nid="dialog_input_10" name="designation" ng-model="vm.record.designation" type="text" ng-required="false" \nmd-maxlength="20"><div ng-messages="vm.editForm.designation.$error" role="alert" multiple="multiple"><div \nng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div><div ng-message="md-maxlength">\n{{\'VALIDATIONS.MAXLEN\' | translate}}</div></div></md-input-container></div><div flex="100" flex-gt-xs="50" class="p-5">\n<md-input-container class="md-block"><label>{{\'AUTH_USERS.FIELDS.DEPARTMENT\' | translate}}</label><input \nid="dialog_input_11" name="department" ng-model="vm.record.department" type="text" ng-required="false" \nmd-maxlength="20"><div ng-messages="vm.editForm.department.$error" role="alert" multiple="multiple"><div \nng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div><div ng-message="md-maxlength">\n{{\'VALIDATIONS.MAXLEN\' | translate}}</div></div></md-input-container></div><div flex="100" flex-gt-xs="50" class="p-5">\n<md-input-container class="md-block"><label>{{\'AUTH_USERS.FIELDS.DESCRIPTION\' | translate}}</label><input \nid="dialog_input_13" name="description" ng-model="vm.record.description" type="text" ng-required="false" \nmd-maxlength="200"><div ng-messages="vm.editForm.description.$error" role="alert" multiple="multiple"><div \nng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div><div ng-message="md-maxlength">\n{{\'VALIDATIONS.MAXLEN\' | translate}}</div></div></md-input-container></div><div flex="100" flex-gt-xs="50" \nclass="p-5 lookup-element" ng-hide="!vm.isNew && vm.record.masterUser > 0"><md-autocomplete id="dialog_input_14" \nmd-input-name="loginType" md-selected-item="vm.lookupModel.loginType" \nmd-items="item in vm.lookupSearch(vm.searchText.LoginType, \'loginType\', \'lists.AuthLoginTypes\')" \nmd-search-text="vm.searchText.loginType" ng-required="true" \nmd-item-text="vm.getLookupDisplayValue(item, \'loginType\', \'lists.AuthLoginTypes\')" md-min-length="0" \nmd-floating-label="{{\'AUTH_USERS.FIELDS.LOGIN_TYPE\' | translate}}" \nmd-selected-item-change="vm.lookupChange(vm.lookupModel.loginType, \'loginType\')" md-no-cache="true" \ntx-clear-autocomplete ng-click="vm.selectText($event)" md-menu-class="autocomplete-custom"><md-item-template><span \nclass="autocomplete-item md-accent-fg" md-highlight-text="vm.searchText.loginType" md-highlight-flags="i">\n{{item.value}}</span></md-item-template><div ng-messages="vm.editForm.loginType.$error" role="alert" \nng-show="vm.editForm.loginType.$touched"><div ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div></div>\n<md-not-found>No Record matching "{{vm.searchText.loginType}}" were found.</md-not-found></md-autocomplete></div><div \nflex="100" flex-gt-xs="50" class="p-5" ng-show="(vm.accountType.id === 2 || vm.accountTypeId === 2) && vm.isNew">\n<md-switch id="dialog_input_12" ng-model="vm.record.restrictFullRange" \naria-label="{{\'AUTH_USERS.FIELDS.RESTRICT_FULL_RANGE\' | translate}}" ng-true-value="1" ng-false-value="0" \nclass="md-accent">{{\'AUTH_USERS.FIELDS.RESTRICT_FULL_RANGE\' | translate}}<md-tooltip md-direction="right">\n{{vm.record.restrictFullRange === 1 ? \'PARTS.YES\' : \'PARTS.NO\' | translate}}</md-tooltip></md-switch></div><div \nflex="100" class="p-5"><md-input-container class="md-block lookup-element"><label>\n{{\'AUTH_USERS.FIELDS.ALLOWED_CLIENTS\' | translate}}*</label><md-chips id="dialog_input_16" name="allowedClients" \nng-model="vm.record.allowedClients" md-autocomplete-snap md-transform-chip="vm.transformChip($chip)" \nmd-require-match="true" ng-required="true"><md-autocomplete md-selected-item="vm.acSelectedItem.allowedClients" \nmd-search-text="vm.acSearchText.allowedClients" \nmd-items="item in vm.acQuerySearch(vm.acSearchText.allowedClients, vm.record.allowedClients, \'allowedClients\')" \nmd-item-text="item.value" md-min-length="0" md-no-cache="true" md-menu-class="autocomplete-custom"><md-item-template>\n<span class="autocomplete-item md-accent-fg" md-highlight-text="vm.acSearchText.AllowedClients">{{item.value}}</span>\n</md-item-template><md-not-found>No Record matching "{{vm.acSearchText.allowedClients}}" were found.</md-not-found>\n</md-autocomplete><md-chip-template><span><strong>{{vm.getChipDisplayValue($chip, \'allowedClients\')}}</strong></span>\n</md-chip-template></md-chips></md-input-container></div></div></md-dialog-content><md-dialog-actions layout="row" \nlayout-align="end center"><div></div><div layout="row" layout-align="end center"><md-button \nng-click="vm.closeDialog(vm.isDataDirty)" class="send-button md-primary md-raised" aria-label="Cancel" \ntranslate="ACTIONS.DIALOG_CANCEL" translate-attr-aria-label="ACTIONS.DIALOG_CANCEL" ng-disabled="vm.isLoading">CANCEL\n</md-button><md-button ng-click="vm.saveRecord()" class="send-button md-accent md-raised" aria-label="Save" \ntranslate="ACTIONS.SAVE" translate-attr-aria-label="ACTIONS.SAVE" ng-disabled="vm.isLoading || vm.editForm.$invalid">\nSAVE</md-button><md-button ng-click="vm.saveRecord(true)" class="send-button md-accent md-raised" aria-label="Save" \ntranslate="ACTIONS.SAVE_AND_NEW" translate-attr-aria-label="ACTIONS.SAVE_AND_NEW" \nng-disabled="vm.isLoading || vm.editForm.$invalid" ng-show="vm.isNew">SAVE AND NEW</md-button></div>\n</md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/accounts/interface-users/list/dialogs/create-interface-users/create-interface-user.html','<md-dialog class="edit-dialog" aria-label="New User"><form name="vm.editForm" class="md-inline-form"><md-toolbar \nclass="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" layout-align="space-between center"><span \nclass="title" translate="{{INTERFACE_USERS.TITLES.NEW_USER}}">New User</span><md-button class="md-icon-button" \nng-click="vm.closeDialog(vm.isDataDirty)" aria-label="Close dialog" tranlate \ntranslate-aria-label="ACTIONS.DIALOG_CLOSE"><md-icon md-font-icon="icon-close"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div layout="row" layout-wrap><div flex="100" flex-gt-xs="50" class="p-5" \nng-hide="!vm.isNew"><md-select id="dialog_input_$first" ng-model="vm.accountType" \nplaceholder="{{\'INTERFACE_USERS.FIELDS.ACCOUNT_TYPE\' | translate}}" aria-label="Account Type" \nng-change="vm.onAccountTypeChange(vm.accountType)" ng-required="vm.isNew"><md-option \nng-repeat="accountType in vm.accountTypes | orderBy:\'value\'" ng-value="accountType">{{ accountType.value }}</md-option>\n</md-select></div><div flex="100" flex-gt-xs="50" class="p-5 lookup-element" ng-hide="!vm.isNew"><md-autocomplete \nid="dialog_input_1" md-input-name="accountId" md-selected-item="vm.lookupModel.accountId" \nmd-items="item in vm.lookupSearch(vm.searchText.accountId, vm.accountType[\'value\'], vm.accountType[\'lookupSource\'], {\'Status\': 1})" \nmd-search-text="vm.searchText.accountId" \nmd-item-text="vm.getLookupDisplayValue(item, vm.accountType[\'value\'], vm.accountType[\'lookupSource\'])" \nmd-selected-item-change="vm.lookupChange(vm.lookupModel.accountId, \'accountId\')" md-min-length="0" \nmd-floating-label="{{\'INTERFACE_USERS.FIELDS.ACCOUNT\' | translate}}" ng-required="vm.isNew && vm.accountType.id !== 1" \nmd-no-cache="true" tx-clear-autocomplete ng-click="vm.selectText($event)" md-menu-class="autocomplete-custom" \nng-disabled="!vm.accountType.id || vm.accountType.id === 1"><md-item-template><span \nclass="autocomplete-item md-accent-fg" md-highlight-text="vm.searchText.accountId" md-highlight-flags="i">\n{{item.value}}</span></md-item-template><div ng-messages="vm.editForm.accountId.$error" role="alert" \nng-show="vm.editForm.accountId.$touched"><div ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div></div>\n<md-not-found>No Record matching "{{vm.searchText.accountId}}" were found.</md-not-found></md-autocomplete></div><div \nflex="100" flex-gt-xs="50" class="p-5"><md-input-container class="md-block"><label>\n{{\'INTERFACE_USERS.FIELDS.T1_USER_NAME\' | translate}}</label><input id="dialog_input_2" name="t1Username" \nng-model="vm.record.t1Username" type="text" ng-required="true" md-maxlength="50"><div \nng-messages="vm.editForm.t1Username.$error" role="alert" multiple="multiple"><div ng-message="required">\n{{\'VALIDATIONS.REQUIRED\' | translate}}</div><div ng-message="md-maxlength">{{\'VALIDATIONS.MAXLEN\' | translate}}</div>\n</div></md-input-container></div><div flex="100" flex-gt-xs="50" class="p-5"><md-input-container class="md-block">\n<label>{{\'INTERFACE_USERS.FIELDS.CODE_RECEIVER_EMAIL\' | translate}}</label><input id="dialog_input_3" \nname="codeReceiverEmail" ng-model="vm.record.codeReceiverEmail" type="codeReceiverEmail" ng-required="true" \nmd-maxlength="50" ng-pattern="/.+@.+/"><div ng-messages="vm.editForm.codeReceiverEmail.$error" role="alert" \nmultiple="multiple"><div ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div><div ng-message="pattern">\n{{\'VALIDATIONS.INVALID_EMAIL\' | translate}}</div><div ng-message="md-maxlength">{{\'VALIDATIONS.MAXLEN\' | translate}}\n</div></div></md-input-container></div><div flex="50" class="p-5 lookup-element"><md-autocomplete id="dialog_input_4" \nmd-input-name="allowedClientCode" md-selected-item="vm.lookupModel.allowedClientCode" \nmd-items="item in vm.lookupSearch(vm.searchText.allowedClientCode, \'allowedClientCode\', \'lists.authClients\')" \nmd-search-text="vm.searchText.allowedClientCode" ng-required="true" \nmd-item-text="vm.getLookupDisplayValue(item, \'allowedClientCode\', \'lists.authClients\')" md-min-length="0" \nmd-floating-label="{{\'INTERFACE_USERS.FIELDS.ALLOWED_CLIENT\' | translate}}" \nmd-selected-item-change="vm.lookupChange(vm.lookupModel.allowedClientCode, \'allowedClientCode\')" md-no-cache="true" \ntx-clear-autocomplete ng-click="vm.selectText($event)" md-menu-class="autocomplete-custom"><md-item-template><span \nclass="autocomplete-item md-accent-fg" md-highlight-text="vm.searchText.allowedClientCode" md-highlight-flags="i">\n{{item.value}}</span></md-item-template><div ng-messages="vm.editForm.allowedClientCode.$error" role="alert" \nng-show="vm.editForm.allowedClientCode.$touched"><div ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}\n</div></div><md-not-found>No Record matching "{{vm.searchText.allowedClientCode}}" were found.</md-not-found>\n</md-autocomplete></div></div><div flex="100" flex-gt-xs="50" class="p-5 lookup-element"><md-autocomplete \nid="dialog_input_5" md-input-name="envCode" md-selected-item="vm.lookupModel.envCode" \nmd-items="item in vm.lookupSearch(vm.searchText.envCode, \'envCode\', \'lists.environments\')" \nmd-search-text="vm.searchText.envCode" ng-required="true" \nmd-item-text="vm.getLookupDisplayValue(item, \'envCode\', \'lists.environments\')" md-min-length="0" \nmd-floating-label="{{\'INTERFACE_USERS.FIELDS.ALLOWED_ENVIRONMENT\' | translate}}" \nmd-selected-item-change="vm.lookupChange(vm.lookupModel.envCode, \'envCode\')" md-no-cache="true" tx-clear-autocomplete \nng-click="vm.selectText($event)" md-menu-class="autocomplete-custom"><md-item-template><span \nclass="autocomplete-item md-accent-fg" md-highlight-text="vm.searchText.envCode" md-highlight-flags="i">{{item.value}}\n</span></md-item-template><div ng-messages="vm.editForm.envCode.$error" role="alert" \nng-show="vm.editForm.envCode.$touched"><div ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div></div>\n<md-not-found>No Record matching "{{vm.searchText.envCode}}" were found.</md-not-found></md-autocomplete></div><div \nflex="50" flex-gt-xs="50" class="p-5"><md-input-container class="md-block"><label>\n{{\'INTERFACE_USERS.FIELDS.DESCRIPTION\' | translate}}</label><input id="dialog_input_6" name="description" \nng-model="vm.record.description" type="text" ng-required="false" md-maxlength="200"><div \nng-messages="vm.editForm.description.$error" role="alert" multiple="multiple"><div ng-message="required">\n{{\'VALIDATIONS.REQUIRED\' | translate}}</div><div ng-message="md-maxlength">{{\'VALIDATIONS.MAXLEN\' | translate}}</div>\n</div></md-input-container></div><div flex="50" flex-gt-xs="50" class="p-5"><md-switch id="dialog_input_7" \nng-model="vm.record.createUserOnT1" aria-label="{{\'INTERFACE_USERS.FIELDS.CREATE_USER_ON_T1\' | translate}}" \nng-true-value="true" ng-false-value="false" class="md-accent">\n{{\'INTERFACE_USERS.FIELDS.CREATE_USER_ON_T1\' | translate}}<md-tooltip md-direction="right">\n{{vm.record.createUserOnT1 === true ? \'PARTS.YES\' : \'PARTS.NO\' | translate}}</md-tooltip></md-switch></div>\n</md-dialog-content><md-dialog-actions layout="row" layout-align="end center"><div></div><div layout="row" \nlayout-align="end center"><md-button ng-click="vm.closeDialog(vm.isDataDirty)" \nclass="send-button md-primary md-raised" aria-label="Cancel" translate="ACTIONS.DIALOG_CANCEL" \ntranslate-attr-aria-label="ACTIONS.DIALOG_CANCEL" ng-disabled="vm.isLoading">CANCEL</md-button><md-button \nng-click="vm.saveRecord()" class="send-button md-accent md-raised" aria-label="Save" translate="ACTIONS.SAVE" \ntranslate-attr-aria-label="ACTIONS.SAVE" ng-disabled="vm.isLoading || vm.editForm.$invalid">SAVE</md-button><md-button \nng-click="vm.saveRecord(true)" class="send-button md-accent md-raised" aria-label="Save" \ntranslate="ACTIONS.SAVE_AND_NEW" translate-attr-aria-label="ACTIONS.SAVE_AND_NEW" \nng-disabled="vm.isLoading || vm.editForm.$invalid" ng-show="vm.isNew">SAVE AND NEW</md-button></div>\n</md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/accounts/user-groups/list/dialogs/update-user-groups/update-user-groups.html','<md-dialog class="edit-dialog" aria-label="New User"><form name="vm.editForm" class="md-inline-form"><md-toolbar \nclass="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" layout-align="space-between center"><span \nclass="title" \ntranslate="{{vm.isNew ? \'USER_GROUPS.TITLES.NEW_USER_GROUPS\' : \'USER_GROUPS.TITLES.UPDATE_USER_GROUPS\'}}">New User\n</span><md-button class="md-icon-button" ng-click="vm.closeDialog(vm.isDataDirty)" aria-label="Close dialog" tranlate \ntranslate-aria-label="ACTIONS.DIALOG_CLOSE"><md-icon md-font-icon="icon-close"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div layout="row" layout-wrap><div flex="100" flex-gt-xs="100" class="p-5">\n<md-input-container class="md-block"><label>{{\'USER_GROUPS.FIELDS.NAME\' | translate}}</label><input \nid="dialog_input_{{$first ? \'first\' : $index}}" name="Name" ng-model="vm.record.Name" type="text" ng-required="true" \nmd-maxlength="500"><div ng-messages="vm.editForm.Name.$error" role="alert" multiple="multiple"><div \nng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div><div ng-message="md-maxlength">\n{{\'VALIDATIONS.MAXLEN\' | translate}}</div><div ng-message="uniqueNameSource">\n{{\'USER_GROUPS.VALIDATIONS.NAME_SOURCE_NOT_UNIQUE\' | translate}}</div></div></md-input-container></div><div flex="100" \nflex-gt-xs="50" class="p-5" ng-if="vm.isNew"><md-select id="dialog_input_{{$first ? \'first\' : $index}}" \nng-model="vm.accountType" placeholder="{{\'USER_GROUPS.FIELDS.ACCOUNT_TYPE\' | translate}}" aria-label="Account Type" \nng-change="vm.onAccountTypeChange(vm.accountType)" ng-required="vm.isNew"><md-option \nng-repeat="accountType in vm.accountTypes | orderBy:\'value\'" ng-value="accountType">{{ accountType.value }}</md-option>\n</md-select></div><div flex="100" flex-gt-xs="50" class="p-5 lookup-element" ng-if="vm.isNew"><md-autocomplete \nid="dialog_input_{{$first ? \'first\' : $index}}" md-input-name="AccountId" md-selected-item="vm.lookupModel.AccountId" \nmd-items="item in vm.lookupSearch(vm.searchText.AccountId, vm.accountType[\'value\'], vm.accountType[\'lookupSource\'], {\'Status\': 1})" \nmd-search-text="vm.searchText.AccountId" \nmd-item-text="vm.getLookupDisplayValue(item, vm.accountType[\'value\'], vm.accountType[\'lookupSource\'])" \nmd-selected-item-change="vm.lookupChange(vm.lookupModel.AccountId, \'AccountId\')" md-min-length="0" \nmd-floating-label="{{\'USER_GROUPS.FIELDS.ACCOUNT\' | translate}}" ng-required="vm.isNew && vm.accountType.id !== 1" \nmd-no-cache="true" tx-clear-autocomplete ng-click="vm.selectText($event)" md-menu-class="autocomplete-custom" \nng-disabled="!vm.accountType.id || vm.accountType.id === 1"><md-item-template><span \nclass="autocomplete-item md-accent-fg" md-highlight-text="vm.searchText.AccountId" md-highlight-flags="i">\n{{item.value}}</span></md-item-template><div ng-messages="vm.editForm.AccountId.$error" role="alert" \nng-show="vm.editForm.AccountId.$touched"><div ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div></div>\n<md-not-found>No Record matching "{{vm.searchText.AccountId}}" were found.</md-not-found></md-autocomplete></div><div \nflex="100" flex-gt-xs="50" class="p-5"><md-select id="dialog_input_{{$first ? \'first\' : $index}}" \nng-model="vm.record.Source" placeholder="{{\'USER_GROUPS.FIELDS.SOURCE\' | translate}}" aria-label="SOURCE" \nng-change="vm.onSourceChange()"><md-option ng-value="source.id" ng-repeat="source in vm.sourceList">{{ source.value }}\n</md-option></md-select></div><div flex="100" class="p-5 lookup-element" ng-if="vm.record.Source === \'Requests\'">\n<md-input-container class="md-block"><label>{{\'USER_GROUPS.FIELDS.CRITERIA\' | translate}}</label><md-chips \nid="dialog_input_{{$first ? \'first\' : $index}}" name="Criteria" ng-model="vm.record.Criteria" md-autocomplete-snap \nmd-transform-chip="vm.transformChip($chip)" md-require-match="true" ng-required="false"><md-autocomplete \nmd-selected-item="vm.acSelectedItem.Criteria" md-search-text="vm.acSearchText.Criteria" \nmd-items="item in vm.acQuerySearch(vm.acSearchText.Criteria, vm.record.Criteria, \'Criteria\')" \nmd-item-text="item.value" md-min-length="0" md-no-cache="true" md-menu-class="autocomplete-custom"><md-item-template>\n<span class="autocomplete-item md-accent-fg" md-highlight-text="vm.acSearchText.Criteria">{{item.value}}</span>\n</md-item-template><md-not-found>No Record matching "{{vm.acSearchText.Criteria}}" were found.</md-not-found>\n</md-autocomplete><md-chip-template><span><strong>{{vm.getChipDisplayValue($chip, \'Criteria\')}}</strong></span>\n</md-chip-template></md-chips></md-input-container></div><div flex="100" class="p-5 lookup-element" \nng-if="vm.record.Source === \'Requests\'"><md-input-container class="md-block"><label>\n{{\'USER_GROUPS.FIELDS.ACTIONS\' | translate}}</label><md-chips id="dialog_input_{{$first ? \'first\' : $index}}" \nname="Actions" ng-model="vm.record.Actions" md-autocomplete-snap md-transform-chip="vm.transformChip($chip)" \nmd-require-match="true" ng-required="false"><md-autocomplete md-selected-item="vm.acSelectedItem.Actions" \nmd-search-text="vm.acSearchText.Actions" \nmd-items="item in vm.acQuerySearch(vm.acSearchText.Actions, vm.record.Actions, \'Actions\')" md-item-text="item.value" \nmd-min-length="0" md-no-cache="true" md-menu-class="autocomplete-custom"><md-item-template><span \nclass="autocomplete-item md-accent-fg" md-highlight-text="vm.acSearchText.Actions">{{item.value}}</span>\n</md-item-template><md-not-found>No Record matching "{{vm.acSearchText.Actions}}" were found.</md-not-found>\n</md-autocomplete><md-chip-template><span><strong>{{vm.getChipDisplayValue($chip, \'Actions\')}}</strong></span>\n</md-chip-template></md-chips></md-input-container></div><div flex="100" class="p-5 lookup-element" \nng-if="vm.record.Source === \'Requests\'"><md-input-container class="md-block"><label>\n{{\'USER_GROUPS.FIELDS.ADDITIONAL_CRITERIA\' | translate}}</label><textarea \nid="dialog_input_{{$first ? \'first\' : $index}}" name="AdditionalCriteria" ng-model="vm.record.AdditionalCriteria" \ncolumns="1" rows="1" ng-change="vm.validateJSON(\'AdditionalCriteria\')"></textarea><div \nng-messages="vm.editForm.AdditionalCriteria.$error" role="alert" multiple="multiple"><div \nng-message="checkIfValidJson">{{\'VALIDATIONS.INVALID_JSON\' | translate}}</div></div></md-input-container></div><div \nflex="100" class="p-5 lookup-element" ng-if="vm.isNew"><md-input-container class="md-block"><label>\n{{\'USER_GROUPS.FIELDS.USERS\' | translate}}</label><md-chips id="dialog_input_16" name="Users" \nng-model="vm.record.Users" md-autocomplete-snap md-transform-chip="vm.transformChip($chip)" md-require-match="true" \nng-required="false"><md-autocomplete md-selected-item="vm.acSelectedItem.Users" md-search-text="vm.acSearchText.Users" \nmd-items="item in vm.acQuerySearch(vm.acSearchText.Users, vm.record.Users, \'Users\')" md-item-text="item.value" \nmd-min-length="0" md-no-cache="true" md-menu-class="autocomplete-custom"><md-item-template><span \nclass="autocomplete-item md-accent-fg" md-highlight-text="vm.acSearchText.Users">{{item.value}}</span>\n</md-item-template><md-not-found>No Record matching "{{vm.acSearchText.Users}}" were found.</md-not-found>\n</md-autocomplete><md-chip-template><span><strong>{{vm.getChipDisplayValue($chip, \'Users\')}}</strong></span>\n</md-chip-template></md-chips></md-input-container></div></div></md-dialog-content><md-dialog-actions layout="row" \nlayout-align="end center"><div></div><div layout="row" layout-align="end center"><md-button \nng-click="vm.closeDialog(vm.isDataDirty)" class="send-button md-primary md-raised" aria-label="Cancel" \ntranslate="ACTIONS.DIALOG_CANCEL" translate-attr-aria-label="ACTIONS.DIALOG_CANCEL" ng-disabled="vm.isLoading">CANCEL\n</md-button><md-button ng-click="vm.saveRecord()" class="send-button md-accent md-raised" aria-label="Save" \ntranslate="ACTIONS.SAVE" translate-attr-aria-label="ACTIONS.SAVE" ng-disabled="vm.isLoading || vm.editForm.$invalid">\nSAVE</md-button><md-button ng-click="vm.saveRecord(true)" class="send-button md-accent md-raised" aria-label="Save" \ntranslate="ACTIONS.SAVE_AND_NEW" translate-attr-aria-label="ACTIONS.SAVE_AND_NEW" \nng-disabled="vm.isLoading || vm.editForm.$invalid" ng-show="vm.isNew">SAVE AND NEW</md-button></div>\n</md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/accounts/users/list/dialogs/change-user-account/change-user-account.html','<md-dialog class="edit-dialog" aria-label="New User"><form name="vm.editForm" class="md-inline-form"><md-toolbar \nclass="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" layout-align="space-between center"><span \nclass="title" translate="USERS.ACTIONS.CHANGE_ACCOUNT">Change Account</span><md-button class="md-icon-button" \nng-click="vm.closeDialog(vm.isDataDirty)" aria-label="Close dialog" tranlate \ntranslate-aria-label="ACTIONS.DIALOG_CLOSE"><md-icon md-font-icon="icon-close"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div layout="row" layout-wrap><div flex="100" flex-gt-xs="50" class="p-5">\n<md-select id="dialog_input_$first" ng-model="vm.accountType" \nplaceholder="{{\'AUTH_USERS.FIELDS.ACCOUNT_TYPE\' | translate}}" aria-label="Account Type" \nng-change="vm.onAccountTypeChange(vm.accountType)" ng-required="true"><md-option \nng-repeat="accountType in vm.accountTypes | orderBy:\'value\'" ng-value="accountType">{{ accountType.value }}</md-option>\n</md-select></div><div flex="100" flex-gt-xs="50" class="p-5 lookup-element"><md-autocomplete id="dialog_input_1" \nmd-input-name="accountId" md-selected-item="vm.lookupModel.accountId" \nmd-items="item in vm.lookupSearch(vm.searchText.accountId, vm.accountType[\'value\'], vm.accountType[\'lookupSource\'], {\'Status\': 1})" \nmd-search-text="vm.searchText.accountId" \nmd-item-text="vm.getLookupDisplayValue(item, vm.accountType[\'value\'], vm.accountType[\'lookupSource\'])" \nmd-selected-item-change="vm.lookupChange(vm.lookupModel.accountId, \'accountId\')" md-min-length="0" \nmd-floating-label="{{\'AUTH_USERS.FIELDS.ACCOUNT\' | translate}}" ng-required="true" md-no-cache="true" \ntx-clear-autocomplete ng-click="vm.selectText($event)" md-menu-class="autocomplete-custom" \nng-disabled="!vm.accountType.id"><md-item-template><span class="autocomplete-item md-accent-fg" \nmd-highlight-text="vm.searchText.accountId" md-highlight-flags="i">{{item.value}}</span></md-item-template><div \nng-messages="vm.editForm.accountId.$error" role="alert" ng-show="vm.editForm.accountId.$touched"><div \nng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div></div><md-not-found>\nNo Record matching "{{vm.searchText.accountId}}" were found.</md-not-found></md-autocomplete></div></div>\n</md-dialog-content><md-dialog-actions layout="row" layout-align="end center"><div></div><div layout="row" \nlayout-align="end center"><md-button ng-click="vm.closeDialog(vm.isDataDirty)" \nclass="send-button md-primary md-raised" aria-label="Cancel" translate="ACTIONS.DIALOG_CANCEL" \ntranslate-attr-aria-label="ACTIONS.DIALOG_CANCEL" ng-disabled="vm.isLoading">CANCEL</md-button><md-button \nng-click="vm.saveRecord()" class="send-button md-accent md-raised" aria-label="Save" translate="ACTIONS.SAVE" \ntranslate-attr-aria-label="ACTIONS.SAVE" ng-disabled="vm.isLoading || vm.editForm.$invalid">SAVE</md-button></div>\n</md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/accounts/users/list/dialogs/update-user/update-user.html','<md-dialog class="edit-dialog" aria-label="Edit User"><form name="vm.editForm" class="md-inline-form"><md-toolbar \nclass="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" layout-align="space-between center"><span \nclass="title" translate="USERS.TITLES.UPDATE_USER">Edit User</span><md-button class="md-icon-button" \nng-click="vm.closeDialog(vm.isDataDirty)" aria-label="Close dialog" tranlate \ntranslate-aria-label="ACTIONS.DIALOG_CLOSE"><md-icon md-font-icon="icon-close"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div layout="row" layout-wrap><div flex="100" flex-gt-xs="50" class="p-5" \nng-if="!vm.isNew"><md-input-container class="md-block"><label>{{\'USERS.FIELDS.ACCOUNT\' | translate}}</label><input \nid="dialog_input_20" ng-model="vm.record.AccountName" type="text" ng-disabled="true"></md-input-container></div><div \nflex="100" flex-gt-xs="50" class="p-5"><md-input-container class="md-block"><label>\n{{\'USERS.FIELDS.FIRST_NAME\' | translate}}</label><input id="dialog_input_2" name="FirstName" \nng-model="vm.record.FirstName" type="text" ng-required="true" md-maxlength="20"><div \nng-messages="vm.editForm.FirstName.$error" role="alert" multiple="multiple"><div ng-message="required">\n{{\'VALIDATIONS.REQUIRED\' | translate}}</div><div ng-message="md-maxlength">{{\'VALIDATIONS.MAXLEN\' | translate}}</div>\n</div></md-input-container></div><div flex="100" flex-gt-xs="50" class="p-5"><md-input-container class="md-block">\n<label>{{\'USERS.FIELDS.LAST_NAME\' | translate}}</label><input id="dialog_input_3" name="LastName" \nng-model="vm.record.LastName" type="text" ng-required="true" md-maxlength="20"><div \nng-messages="vm.editForm.LastName.$error" role="alert" multiple="multiple"><div ng-message="required">\n{{\'VALIDATIONS.REQUIRED\' | translate}}</div><div ng-message="md-maxlength">{{\'VALIDATIONS.MAXLEN\' | translate}}</div>\n</div></md-input-container></div><div flex="100" flex-gt-xs="50" class="p-5"><md-input-container class="md-block">\n<label>{{\'USERS.FIELDS.EMAIL\' | translate}}</label><input id="dialog_input_4" name="Email" ng-model="vm.record.Email" \ntype="text" ng-required="true" md-maxlength="500" \nng-pattern="/^[A-Za-z]+[A-Za-z0-9._+-]+@{1}[A-Za-z0-9._-]+\\.[A-Za-z.]{2,}$/"><div \nng-messages="vm.editForm.Email.$error" role="alert" multiple="multiple"><div ng-message="required">\n{{\'VALIDATIONS.REQUIRED\' | translate}}</div><div ng-message="pattern">{{\'VALIDATIONS.INVALID_EMAIL\' | translate}}</div>\n<div ng-message="md-maxlength">{{\'VALIDATIONS.MAXLEN\' | translate}}</div></div></md-input-container></div><div \nflex="100" flex-gt-xs="50" class="p-5"><md-input-container class="md-block"><label>\n{{\'USERS.FIELDS.USER_NAME\' | translate}}</label><input id="dialog_input_5" name="UserName" \nng-model="vm.record.UserName" type="text" ng-required="true" md-maxlength="50"><div \nng-messages="vm.editForm.UserName.$error" role="alert" multiple="multiple"><div ng-message="required">\n{{\'VALIDATIONS.REQUIRED\' | translate}}</div><div ng-message="md-maxlength">{{\'VALIDATIONS.MAXLEN\' | translate}}</div>\n</div></md-input-container></div><div flex="100" flex-gt-xs="50" class="p-5"><md-input-container class="md-block">\n<label>{{\'USERS.FIELDS.PHONE\' | translate}}</label><input id="dialog_input_6" name="Phone" ng-model="vm.record.Phone" \ntype="tel" ng-required="false" md-maxlength="20" ng-pattern="/[0-9]*/"><div ng-messages="vm.editForm.Phone.$error" \nrole="alert" multiple="multiple"><div ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div><div \nng-message="pattern">{{\'VALIDATIONS.PATTERN\' | translate}}</div><div ng-message="md-maxlength">\n{{\'VALIDATIONS.MAXLEN\' | translate}}</div></div></md-input-container></div><div flex="100" flex-gt-xs="50" \nclass="p-5 lookup-element"><md-autocomplete id="dialog_input_7" md-input-name="CountryCode" \nmd-selected-item="vm.lookupModel.CountryCode" \nmd-items="item in vm.lookupSearch(vm.searchText.CountryCode, \'CountryCode\', \'lists.countries\')" \nmd-search-text="vm.searchText.CountryCode" \nmd-item-text="vm.getLookupDisplayValue(item, \'CountryCode\', \'lists.countries\')" md-min-length="0" \nmd-floating-label="{{\'USERS.FIELDS.COUNTRY\' | translate}}" \nmd-selected-item-change="vm.lookupChange(vm.lookupModel.CountryCode, \'CountryCode\')" ng-required="true" \nmd-no-cache="true" tx-clear-autocomplete tx-force-select ng-click="vm.selectText($event)" \nmd-menu-class="autocomplete-custom"><md-item-template><span class="autocomplete-item md-accent-fg" \nmd-highlight-text="vm.searchText.CountryCode" md-highlight-flags="i">{{item.value}}</span></md-item-template><div \nng-messages="vm.editForm.CountryCode.$error" role="alert" ng-show="vm.editForm.CountryCode.$touched"><div \nng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div></div><md-not-found>\nNo Record matching "{{vm.searchText.CountryCode}}" were found.</md-not-found></md-autocomplete></div><div flex="100" \nflex-gt-xs="50" class="p-5"><md-input-container class="md-block"><label>{{\'USERS.FIELDS.CITY\' | translate}}</label>\n<input id="dialog_input_8" name="City" ng-model="vm.record.City" type="text" ng-required="false" md-maxlength="25"><div\n ng-messages="vm.editForm.City.$error" role="alert" multiple="multiple"><div ng-message="required">\n{{\'VALIDATIONS.REQUIRED\' | translate}}</div><div ng-message="md-maxlength">{{\'VALIDATIONS.MAXLEN\' | translate}}</div>\n</div></md-input-container></div><div flex="100" flex-gt-xs="50" class="p-5"><md-input-container class="md-block">\n<label>{{\'USERS.FIELDS.DESIGNATION\' | translate}}</label><input id="dialog_input_9" name="Designation" \nng-model="vm.record.Designation" type="text" ng-required="false" md-maxlength="20"><div \nng-messages="vm.editForm.Designation.$error" role="alert" multiple="multiple"><div ng-message="required">\n{{\'VALIDATIONS.REQUIRED\' | translate}}</div><div ng-message="md-maxlength">{{\'VALIDATIONS.MAXLEN\' | translate}}</div>\n</div></md-input-container></div><div flex="100" flex-gt-xs="50" class="p-5"><md-input-container class="md-block">\n<label>{{\'USERS.FIELDS.DEPARTMENT\' | translate}}</label><input id="dialog_input_10" name="Department" \nng-model="vm.record.Department" type="text" ng-required="false" md-maxlength="20"><div \nng-messages="vm.editForm.Department.$error" role="alert" multiple="multiple"><div ng-message="required">\n{{\'VALIDATIONS.REQUIRED\' | translate}}</div><div ng-message="md-maxlength">{{\'VALIDATIONS.MAXLEN\' | translate}}</div>\n</div></md-input-container></div><div flex="100" flex-gt-xs="50" class="p-5" \nng-show="vm.accountType.id === 2 || vm.record.AccountTypeId === 2"><md-switch id="dialog_input_11" \nng-model="vm.record.RestrictFullRange" aria-label="{{\'USERS.FIELDS.RESTRICT_FULL_RANGE\' | translate}}" \nng-true-value="1" ng-false-value="0" class="md-accent">{{\'USERS.FIELDS.RESTRICT_FULL_RANGE\' | translate}}<md-tooltip \nmd-direction="right">{{vm.record.RestrictFullRange === 1 ? \'PARTS.YES\' : \'PARTS.NO\' | translate}}</md-tooltip>\n</md-switch></div><div flex="100" class="p-5 lookup-element"><md-input-container class="md-block"><label>\n{{\'USERS.FIELDS.USER_ROLE\' | translate}}</label><md-chips id="dialog_input_13" name="role" ng-model="vm.record.Roles" \nmd-autocomplete-snap md-transform-chip="vm.transformChip($chip)" md-require-match="true"><md-autocomplete \nmd-selected-item="vm.acSelectedItem.Roles" md-search-text="vm.acSearchText.Roles" \nmd-items="item in vm.acQuerySearch(vm.acSearchText.Roles, vm.record.Roles, \'Roles\')" md-item-text="item.value" \nmd-min-length="0" md-no-cache="true" md-menu-class="autocomplete-custom" ng-disabled="vm.isNew && !vm.accountType.id">\n<md-item-template><span class="autocomplete-item md-accent-fg" md-highlight-text="vm.acSearchText.Roles">{{item.value}}\n</span></md-item-template><md-not-found>No Record matching "{{vm.acSearchText.Roles}}" were found.</md-not-found>\n</md-autocomplete><md-chip-template><span><strong>{{vm.getChipDisplayValue($chip, \'Roles\')}}</strong></span>\n</md-chip-template></md-chips></md-input-container></div><div flex="100" class="p-5 lookup-element"><md-input-container\n class="md-block"><label>{{\'USERS.FIELDS.LICENSE_TYPES\' | translate}}</label><md-chips id="dialog_input_14" \nname="license_types" ng-model="vm.record.LicenseTypeIds" md-autocomplete-snap \nmd-transform-chip="vm.transformChip($chip)" md-require-match="true"><md-autocomplete \nmd-selected-item="vm.acSelectedItem.LicenseTypeIds" md-search-text="vm.acSearchText.LicenseTypeIds" \nmd-items="item in vm.acQuerySearch(vm.acSearchText.LicenseTypeIds, vm.record.LicenseTypeIds, \'LicenseTypeIds\')" \nmd-item-text="item.value" md-min-length="0" md-no-cache="true" md-menu-class="autocomplete-custom" \nng-disabled="vm.isNew && !vm.accountType.id"><md-item-template><span class="autocomplete-item md-accent-fg" \nmd-highlight-text="vm.acSearchText.LicenseTypeIds">{{item.value}}</span></md-item-template><md-not-found>\nNo Record matching "{{vm.acSearchText.LicenseTypeIds}}" were found.</md-not-found></md-autocomplete><md-chip-template>\n<span><strong>{{vm.getChipDisplayValue($chip, \'LicenseTypeIds\')}}</strong></span></md-chip-template></md-chips>\n</md-input-container></div></div></md-dialog-content><md-dialog-actions layout="row" layout-align="end center"><div>\n</div><div layout="row" layout-align="end center"><md-button ng-click="vm.closeDialog(vm.isDataDirty)" \nclass="send-button md-primary md-raised" aria-label="Cancel" translate="ACTIONS.DIALOG_CANCEL" \ntranslate-attr-aria-label="ACTIONS.DIALOG_CANCEL" ng-disabled="vm.isLoading">CANCEL</md-button><md-button \nng-click="vm.saveRecord()" class="send-button md-accent md-raised" aria-label="Save" translate="ACTIONS.SAVE" \ntranslate-attr-aria-label="ACTIONS.SAVE" ng-disabled="vm.isLoading || vm.editForm.$invalid">SAVE</md-button></div>\n</md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/catalogs/details/tabs/configurations/dialogs/update-configuration.html','<md-dialog class="edit-dialog" aria-label="{{vm.isNew ? \'New Configuration\' : \'Edit Configuration\'}}"><form \nname="vm.editForm" class="md-inline-form"><md-toolbar class="md-accent md-hue-2"><div class="md-toolbar-tools" \nlayout="row" layout-align="space-between center"><span class="title" \ntranslate="{{vm.isNew ? \'CONFIGURATIONS.ACTIONS.CREATE\' : \'CONFIGURATIONS.ACTIONS.UPDATE\'}}">\n{{vm.isNew ? \'New Configuration\' : \'Edit Configuration\'}}</span><md-button class="md-icon-button" \nng-click="vm.closeDialog(vm.isDataDirty)" aria-label="Close dialog" tranlate \ntranslate-aria-label="ACTIONS.DIALOG_CLOSE"><md-icon md-font-icon="icon-close"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div layout="row" layout-wrap><div flex="100" flex-gt-xs="50" \nclass="p-5 lookup-element" ng-show="vm.isNew"><md-autocomplete id="dialog_input_first" md-input-name="ConfigId" \nmd-selected-item="vm.lookupModel.ConfigId" md-search-text="vm.searchText.ConfigId" \nmd-items="item in vm.lookupSearch(vm.searchText.ConfigId)" md-item-text="vm.getConfigurationDisplayValue(item)" \nmd-selected-item-change="vm.lookupChange(vm.lookupModel.ConfigId, \'ConfigId\')" md-min-length="0" \nmd-floating-label="{{\'CONFIGURATIONS.FIELDS.NAME\' | translate}}" ng-required="vm.isNew" md-no-cache="true" \ntx-clear-autocomplete ng-click="vm.selectText($event)" md-menu-class="autocomplete-custom"><md-item-template><span \nclass="autocomplete-item md-accent-fg" md-highlight-text="vm.searchText.ConfigId" md-highlight-flags="i">\n{{item[vm.masterConfigurationsModel.lookupDisplayField]}}</span></md-item-template><div \nng-messages="vm.editForm.ConfigId.$error" role="alert" ng-show="vm.editForm.ConfigId.$touched"><div \nng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div></div></md-autocomplete></div><div flex="100" \nflex-gt-xs="50" class="p-5" ng-if="vm.isNew"><md-input-container class="md-block"><label translate>\nCONFIGURATIONS.FIELDS.SORTORDER</label><input name="SortOrder" ng-model="vm.record.SortOrder" type="number" \nng-disabled="vm.isExistingSelected"></md-input-container></div><div flex="100" flex-gt-xs="50" class="p-5" \nng-if="vm.isNew"><md-input-container class="md-block"><label translate>\n{{\'CONFIGURATIONS.FIELDS.VALUE_TYPE\' | translate}}</label><md-select name="DefaultValueType" \nplaceholder="{{\'CONFIGURATIONS.FIELDS.VALUE_TYPE\' | translate}}" ng-model="vm.record.DefaultValueType" \nstyle="min-width: 200px" ng-required="!vm.isExistingSelected" ng-disabled="vm.isExistingSelected" \nng-change="vm.onTypeChange(vm.record.DefaultValueType)"><md-option \nng-repeat="item in vm.defaultValueTypes track by item.Id" ng-value="item.Id">{{item.value}}</md-option></md-select><div\n ng-messages="vm.editForm.DefaultValueType.$error" role="alert" multiple="multiple"><div ng-message="required">\n{{\'VALIDATIONS.REQUIRED\' | translate}}</div></div></md-input-container></div><div flex="100" flex-gt-xs="50" \nclass="p-5" ng-if="vm.isNew && (vm.configType === \'\' || vm.configType === \'nvarchar\')"><md-input-container \nclass="md-block"><label>{{\'CONFIGURATIONS.FIELDS.DEFAULT_VALUE\' | translate}}</label><input name="DefaultValue" \nng-model="vm.record.DefaultValue" type="text" ng-required="!vm.isExistingSelected" ng-disabled="vm.isExistingSelected">\n<div ng-messages="vm.editForm.DefaultValue.$error" role="alert"><div ng-message="required">\n{{\'VALIDATIONS.REQUIRED\' | translate}}</div></div></md-input-container></div><div flex="100" flex-gt-xs="50" \nclass="p-5" ng-if="vm.isNew && vm.configType === \'int\'"><md-input-container class="md-block"><label>\n{{\'CONFIGURATIONS.FIELDS.DEFAULT_VALUE\' | translate}}</label><input name="DefaultValue" \nng-model="vm.record.DefaultValue" type="number" ng-required="!vm.isExistingSelected" \nng-disabled="vm.isExistingSelected"><div ng-messages="vm.editForm.DefaultValue.$error" role="alert"><div \nng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div></div></md-input-container></div><div flex="100" \nflex-gt-xs="50" class="p-5" ng-if="vm.isNew && vm.configType === \'bool\'"><md-switch name="DefaultValue" \nng-model="vm.record.DefaultValue" aria-label="Default Value" ng-true-value="\'true\'" ng-false-value="\'false\'" \nng-disabled="vm.isExistingSelected" class="md-accent">{{\'CONFIGURATIONS.FIELDS.DEFAULT_VALUE\' | translate}}</md-switch>\n</div><div flex="100" flex-gt-xs="50" class="p-5" ng-if="vm.isNew && vm.configType === \'datetime\'" layout="column">\n<label class="md-caption">{{\'CONFIGURATIONS.FIELDS.DEFAULT_VALUE\' | translate}}</label><md-datepicker \nname="DefaultValue" ng-model="vm.record.DefaultValue" md-placeholder="" ng-required="!vm.isExistingSelected" \nng-disabled="vm.isExistingSelected"></md-datepicker><div ng-messages="vm.editForm.DefaultValue.$error" role="alert" \nng-show="vm.editForm.DefaultValue.$touched"><div ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div>\n</div></div><div flex="100" class="p-5" ng-if="vm.isNew"><md-input-container class="md-block"><label translate>\nCONFIGURATIONS.FIELDS.DESCRIPTION</label><textarea name="Description" ng-model="vm.record.Description" columns="1" \nrows="1" ng-required="false" md-maxlength="500" ng-disabled="vm.isExistingSelected"></textarea><div \nng-messages="vm.editForm.Description.$error" role="alert" multiple="multiple"><div ng-message="md-maxlength">\n{{\'VALIDATIONS.MAXLEN\' | translate}}</div></div></md-input-container></div><div flex="100" flex-gt-xs="50" class="p-5" \nng-if="vm.configType === \'\' || vm.configType === \'nvarchar\'"><md-input-container class="md-block"><label>\n{{\'CONFIGURATIONS.FIELDS.VALUE\' | translate}}</label><input id="dialog_input_1" name="Value" \nng-model="vm.record.Value" type="text" ng-required="true" ng-disabled="vm.configType === \'\'"><div \nng-messages="vm.editForm.Value.$error" role="alert"><div ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}\n</div></div></md-input-container></div><div flex="100" flex-gt-xs="50" class="p-5" ng-if="vm.configType === \'int\'">\n<md-input-container class="md-block"><label>{{\'CONFIGURATIONS.FIELDS.VALUE\' | translate}}</label><input \nid="dialog_input_2" name="Value" ng-model="vm.record.Value" type="number" ng-required="true" \npattern="{{(vm.lookupModel.ConfigId.Name === \'T1S-NumberOfDecimalsForPrices\' || vm.record.Name === \'T1S-NumberOfDecimalsForPrices\') ? \'^[0-4]$\': \'\'}}">\n<div ng-messages="vm.editForm.Value.$error" role="alert"><div ng-message="required">\n{{\'VALIDATIONS.REQUIRED\' | translate}}</div><div ng-message="pattern">\n{{\'VALIDATIONS.INVALID_DECIMAL_POINTS\' | translate}}</div></div></md-input-container></div><div flex="100" \nflex-gt-xs="50" class="p-5" ng-if="vm.configType === \'bool\'"><md-switch id="dialog_input_3" name="Value" \nng-model="vm.record.Value" aria-label="Value" ng-true-value="\'true\'" ng-false-value="\'false\'" class="md-accent">\n{{\'CONFIGURATIONS.FIELDS.VALUE\' | translate}}</md-switch></div><div flex="100" flex-gt-xs="50" class="p-5" \nng-if="vm.configType == \'datetime\'" layout="column"><label class="md-caption">\n{{\'CONFIGURATIONS.FIELDS.VALUE\' | translate}}</label><md-datepicker id="dialog_input_4" name="Value" \nng-model="vm.record.Value" md-placeholder="" ng-required="true"></md-datepicker><div \nng-messages="vm.editForm.Value.$error" role="alert" ng-show="vm.editForm.Value.$touched"><div ng-message="required">\n{{\'VALIDATIONS.REQUIRED\' | translate}}</div></div></div></div></md-dialog-content><md-dialog-actions layout="row" \nlayout-align="end center"><div></div><div layout="row" layout-align="end center"><md-button \nng-click="vm.closeDialog(vm.isDataDirty)" class="send-button md-primary md-raised" aria-label="Cancel" \ntranslate="ACTIONS.DIALOG_CANCEL" translate-attr-aria-label="ACTIONS.DIALOG_CANCEL" ng-disabled="vm.isLoading">CANCEL\n</md-button><md-button ng-click="vm.saveRecord()" class="send-button md-accent md-raised" aria-label="Save" \ntranslate="ACTIONS.SAVE" translate-attr-aria-label="ACTIONS.SAVE" ng-disabled="vm.isLoading || vm.editForm.$invalid">\nSAVE</md-button><md-button ng-click="vm.saveRecord(true)" class="send-button md-accent md-raised" aria-label="Save" \ntranslate="ACTIONS.SAVE_AND_NEW" translate-attr-aria-label="ACTIONS.SAVE_AND_NEW" \nng-disabled="vm.isLoading || vm.editForm.$invalid" ng-show="vm.isNew">SAVE</md-button></div></md-dialog-actions></form>\n</md-dialog>');
$templateCache.put('app/main/catalogs/details/tabs/model-level-attributes/dialogs/assign-model-level-attributes.html','<md-dialog class="edit-dialog" aria-label="New Model Attributes"><form name="editForm" class="md-inline-form">\n<md-toolbar class="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" layout-align="space-between center">\n<span class="title" translate="TITLES.RECORD_NEW">New Record</span><md-button class="md-icon-button" \nng-click="vm.closeDialog(false)" aria-label="Close dialog" tranlate translate-aria-label="ACTIONS.DIALOG_CLOSE">\n<md-icon md-font-icon="icon-close"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div \nlayout="row" layout-wrap><div flex="100" class="p-5 lookup-element"><md-input-container class="md-block"><label>\n{{\'MODEL_LEVEL_ATTRIBUTES.FIELDS.ATTRIBUTE_ID\' | translate}}</label><md-chips id="dialog_input_13" name="AttributeId" \nng-model="vm.record.AttributeId" md-autocomplete-snap md-transform-chip="vm.transformChip($chip)" \nmd-require-match="true"><md-autocomplete md-selected-item="vm.acSelectedItem.AttributeId" \nmd-search-text="vm.acSearchText.AttributeId" \nmd-items="item in vm.acQuerySearch(vm.acSearchText.AttributeId, vm.record.AttributeId, vm.allAttributes)" \nmd-item-text="item.AttributeDisplayName" md-min-length="0" md-no-cache="true" md-menu-class="autocomplete-custom">\n<md-item-template><span class="autocomplete-item md-accent-fg" md-highlight-text="vm.acSearchText.AttributeId">\n{{item.AttributeDisplayName}}</span></md-item-template><md-not-found>\nNo Record matching "{{vm.acSearchText.AttributeId}}" were found.</md-not-found></md-autocomplete><md-chip-template>\n<span><strong>{{vm.getChipDisplayValue($chip, vm.allAttributes)}}</strong></span></md-chip-template></md-chips>\n</md-input-container></div></div></md-dialog-content><md-dialog-actions layout="row" layout-align="end center"><div>\n</div><div layout="row" layout-align="end center"><md-button ng-click="vm.closeDialog(false)" \nclass="send-button md-primary md-raised" aria-label="Cancel" translate="ACTIONS.DIALOG_CANCEL" \ntranslate-attr-aria-label="ACTIONS.DIALOG_CANCEL" ng-disabled="vm.isLoading">CANCEL</md-button><md-button \nng-click="vm.saveRecord()" class="send-button md-accent md-raised" aria-label="Save" translate="ACTIONS.SAVE" \ntranslate-attr-aria-label="ACTIONS.SAVE" ng-disabled="vm.isLoading || editForm.$invalid">SAVE</md-button></div>\n</md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/catalogs/sub-modules/articles/dialogs/assign-articles-to-master-catalog/assign-articles-to-master-catalog.html','<md-dialog class="edit-dialog" aria-label="Assign Articles"><form name="vm.editForm" class="md-inline-form"><md-toolbar\n class="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" layout-align="space-between center"><span \nclass="title" translate="{{\'ARTICLES.TITLES.ASSIGN_ARTICLES\'}}">Assign Articles</span><md-button \nclass="md-icon-button" ng-click="vm.closeDialog(vm.isDataDirty)" aria-label="Close dialog" tranlate \ntranslate-aria-label="ACTIONS.DIALOG_CLOSE"><md-icon md-font-icon="icon-close"></md-icon></md-button></div>\n</md-toolbar><div layout="row" layout-align="center center" ng-if="vm.isLoading"><md-progress-circular \nmd-mode="indeterminate" class="md-accent"></md-progress-circular></div><md-dialog-content ms-scroll \nng-if="!vm.isLoading"><div class="import-search-container" layout="row"><md-input-container flex-gt-xs="100" \nflex="100"><md-icon class="s18" md-font-icon="icon-magnify"></md-icon><input md-autofocus ng-model="vm.searchPageText" \ntype="search" ng-keydown="vm.onKeyDown($event)" placeholder="Search" md-autofocus ng-change="vm.onSearchTextChanged()">\n</md-input-container></div><div layout="row" layout-wrap><div flex="100" flex-gt-xs="50" class="p-5 lookup-element">\n<md-autocomplete id="dialog_input_1" md-input-name="ModelNumber" md-selected-item="vm.record.ModelNumber" \nmd-items="item in vm.searchModels(vm.searchText.ModelNumber)" md-search-text="vm.searchText.ModelNumber" \nmd-item-text="vm.getModelDisplayValue(item)" md-min-length="0" \nmd-floating-label="{{\'ARTICLES.FIELDS.MODEL_NUMBER\' | translate}}" \nmd-selected-item-change="vm.onModelsChange(vm.record.ModelNumber)" ng-required="true" md-no-cache="true" \ntx-clear-autocomplete ng-click="vm.selectText($event)" md-menu-class="autocomplete-custom"><md-item-template><span \nclass="autocomplete-item md-accent-fg" md-highlight-text="vm.searchText.ModelNumber" md-highlight-flags="i">\n{{item.ModelNumber}}</span></md-item-template><div ng-messages="vm.editForm.ModelNumber.$error" role="alert" \nng-show="vm.editForm.ModelNumber.$touched"><div ng-message="required">\n{{field.validation.messages.isRequired | translate}}</div></div><md-not-found>\nNo Record matching "{{vm.searchText.ModelNumber}}" were found.</md-not-found><div class="info-for-first-100-records" \nng-if="vm.isAboveModelDropDownLimit"><md-icon class="icon s14" md-font-icon="icon-information-outline"></md-icon><span>\n{{\'MESSAGES.CONTENT.SHOW_FIRST_100\' | translate}}</span></div></md-autocomplete></div><div flex="100" flex-gt-xs="50" \nclass="p-5 lookup-element"><md-autocomplete id="dialog_input_2" md-input-name="ArticleNumber" \nmd-selected-item="vm.record.ArticleNumber" md-items="item in vm.searchArticles(vm.searchText.ArticleNumber)" \nmd-search-text="vm.searchText.ArticleNumber" md-item-text="vm.getArticleDisplayValue(item)" md-min-length="0" \nmd-floating-label="{{\'ARTICLES.FIELDS.ARTICLE_NUMBER\' | translate}}" \nmd-selected-item-change="vm.onArticlesChange(vm.record.ArticleNumber)" ng-required="true" \nng-disabled="!vm.record.ModelNumber" md-no-cache="true" tx-clear-autocomplete tx-force-select \nng-click="vm.selectText($event)" md-menu-class="autocomplete-custom"><md-item-template><span \nclass="autocomplete-item md-accent-fg" md-highlight-text="vm.searchText.ArticleNumber" md-highlight-flags="i">\n{{item.ArticleNumber}}</span></md-item-template><div ng-messages="vm.editForm.ArticleNumber.$error" role="alert" \nng-show="vm.editForm.ArticleNumber.$touched"><div ng-message="required">\n{{field.validation.messages.isRequired | translate}}</div></div><md-not-found>\nNo Record matching "{{vm.searchText.ArticleNumber}}" were found.</md-not-found><div class="info-for-first-100-records" \nng-if="vm.isAboveArticleDropDownLimit"><md-icon class="icon s14" md-font-icon="icon-information-outline"></md-icon>\n<span>{{\'MESSAGES.CONTENT.SHOW_FIRST_100\' | translate}}</span></div></md-autocomplete></div><div \nng-repeat="field in vm.filteredVisibleAttributeFields" flex="100" flex-gt-xs="50" class="p-5" \nng-switch="field.inputType"><div ng-switch-when="text"><md-input-container class="md-block"><span \nng-if="field.IsSeasonless && field.editable && !vm.isNew" class="attribute-criteria-icon"><md-tooltip><span>\n{{ \'MESSAGES.CONTENT.SEASONLESS_ATTRIBUTE_INFO_MESSAGE\' | translate }}</span></md-tooltip></span><label>\n{{field.displayLabel | translate}}</label><input id="dialog_input_{{$first ? \'first\' : $index}}" \nname="{{field.field}}" ng-model="vm.record[field.field]" type="{{field.inputType}}" \nng-required="vm.isInputRequired(field)" md-maxlength="{{field.validation.maxLen}}" \npattern="{{field.validation.pattern}}" \ntx-unique-value="vm.existingRecordsForUniqueValue:{{field.field}}:{{field.checkIfUnique}}" \nng-disabled="{{field.validation.disabledCriteria || (field.showInEdit && !field.editable && !vm.isNew)}}" \nng-focus="vm.currentFocusedField = field.field" ng-change="vm.handleFieldChange(field);"><div \nng-messages="vm.editForm[field.field].$error" role="alert" multiple="multiple"><div ng-message="required">\n{{field.validation.messages.isRequired | translate}}</div><div ng-message="{{field.inputType}}">\n{{field.validation.messages.invalidType | translate}}</div><div ng-message="pattern">\n{{field.validation.messages.pattern | translate}}</div><div ng-message="md-maxlength">\n{{field.validation.messages.maxLen | translate}}</div><div ng-message="tx-unique-value">\n{{\'VALIDATIONS.DUPLICATE\' | translate}}</div></div></md-input-container></div><div ng-switch-when="textArea">\n<md-input-container class="md-block" md-is-error="vm.editForm[field.field].$invalid"><span \nng-if="field.IsSeasonless && field.editable && !vm.isNew" class="attribute-criteria-icon"><md-tooltip><span>\n{{ \'MESSAGES.CONTENT.SEASONLESS_ATTRIBUTE_INFO_MESSAGE\' | translate }}</span></md-tooltip></span><label>\n{{field.displayLabel | translate}}</label><textarea id="dialog_input_{{$first ? \'first\' : $index}}" \nname="{{field.field}}" ng-model="vm.record[field.field]" columns="1" rows="1" ng-required="vm.isInputRequired(field)" \nmd-maxlength="{{field.validation.maxLen}}" pattern="{{field.validation.pattern}}" \nng-focus="vm.currentFocusedField = field.field" \nng-change="vm.handleFieldChange(field);\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tfield.validation.checkIfValidJson ? vm.validateJSON(field) : \'\';" \nng-disabled="{{field.validation.disabledCriteria}}"></textarea><div ng-messages="vm.editForm[field.field].$error" \nrole="alert" multiple="multiple"><div ng-message="required">{{field.validation.messages.isRequired | translate}}</div>\n<div ng-message="pattern">{{field.validation.messages.pattern | translate}}</div><div ng-message="md-maxlength">\n{{field.validation.messages.maxLen | translate}}</div><div ng-message="checkIfValidJson">\n{{field.validation.messages.isValidJson | translate}}</div></div></md-input-container></div><div ng-switch-when="date" \nlayout="column" flex><span ng-if="field.IsSeasonless && field.editable && !vm.isNew" class="attribute-criteria-icon">\n<md-tooltip><span>{{ \'MESSAGES.CONTENT.SEASONLESS_ATTRIBUTE_INFO_MESSAGE\' | translate }}</span></md-tooltip></span>\n<label class="md-caption" ng-class="vm.editForm[field.field].$invalid ? \'form-date-error\': \'\'">\n{{field.displayLabel | translate}}</label><md-datepicker id="dialog_input_{{$first ? \'first\' : $index}}" \nname="{{field.field}}" ng-model="vm.record[field.field]" \nng-init="vm.record[field.field] = vm.getDateObj(vm.record[field.field])" md-placeholder="" \nng-required="vm.isInputRequired(field)" ng-focus="vm.currentFocusedField = field.field" \nng-change="vm.handleFieldChange(field);" ng-disabled="field.validation.disabled"></md-datepicker><div \nng-messages="vm.editForm[field.field].$error" class="form-date-error" role="alert" multiple="multiple"><div \nng-message="required">{{field.validation.messages.isRequired | translate}}</div><div ng-message="pattern">\n{{field.validation.messages.pattern | translate}}</div></div></div><div ng-switch-when="date-without-time" \nlayout="column" flex><span ng-if="field.IsSeasonless && field.editable && !vm.isNew" class="attribute-criteria-icon">\n<md-tooltip><span>{{ \'MESSAGES.CONTENT.SEASONLESS_ATTRIBUTE_INFO_MESSAGE\' | translate }}</span></md-tooltip></span>\n<label class="md-caption" ng-class="vm.editForm[field.field].$invalid ? \'form-date-error\': \'\'">\n{{field.displayLabel | translate}}</label><md-datepicker id="dialog_input_{{$first ? \'first\' : $index}}" \nname="{{field.field}}" ng-model="vm.record[field.field]" \nng-init="vm.record[field.field] = vm.getDateObj(vm.record[field.field])" md-placeholder="" \nng-required="vm.isInputRequired(field)" ng-disabled="field.validation.disabled" \nng-focus="vm.currentFocusedField = field.field" ng-change="vm.handleFieldChange(field);"></md-datepicker><div \nng-messages="vm.editForm[field.field].$error" class="form-date-error" role="alert" multiple="multiple"><div \nng-message="required">{{field.validation.messages.isRequired | translate}}</div><div ng-message="pattern">\n{{field.validation.messages.pattern | translate}}</div></div></div><div ng-switch-when="date-utc" layout="column" flex>\n<label class="md-caption" ng-class="vm.editForm[field.field].$invalid ? \'form-date-error\': \'\'">\n{{field.displayLabel | translate}}</label><md-datepicker id="dialog_input_{{$first ? \'first\' : $index}}" \nname="{{field.field}}" ng-model="vm.record[field.field]" \nng-init="vm.record[field.field] = vm.getDateObj(vm.record[field.field], true)" md-placeholder="" \nng-required="vm.isInputRequired(field)" ng-disabled="field.validation.disabled" \nng-focus="vm.currentFocusedField = field.field" ng-change="vm.handleFieldChange(field);"></md-datepicker><div \nng-messages="vm.editForm[field.field].$error" class="form-date-error" role="alert" multiple="multiple"><div \nng-message="required">{{field.validation.messages.isRequired | translate}}</div><div ng-message="pattern">\n{{field.validation.messages.pattern | translate}}</div></div></div><div ng-switch-when="date-option" layout="column" \nflex><span ng-if="field.IsSeasonless && field.editable && !vm.isNew" class="attribute-criteria-icon"><md-tooltip><span>\n{{ \'MESSAGES.CONTENT.SEASONLESS_ATTRIBUTE_INFO_MESSAGE\' | translate }}</span></md-tooltip></span><label \nclass="md-caption" ng-class="vm.editForm[field.field].$invalid ? \'form-date-error\': \'\'">\n{{field.displayLabel | translate}}</label><md-datepicker id="dialog_input_{{$first ? \'first\' : $index}}" \nname="{{field.field}}" ng-model="vm.record[field.field]" \nng-init="vm.record[field.field] = vm.getDateObj(vm.record[field.field])" md-placeholder="" \nng-required="vm.isInputRequired(field)" ng-disabled="field.validation.disabled" \nng-focus="vm.currentFocusedField = field.field" ng-change="vm.handleFieldChange(field);"></md-datepicker><div \nng-messages="vm.editForm[field.field].$error" class="form-date-error" role="alert" multiple="multiple"><div \nng-message="required">{{field.validation.messages.isRequired | translate}}</div><div ng-message="pattern">\n{{field.validation.messages.pattern | translate}}</div></div></div><div ng-switch-when="icon"></div><div \nng-switch-when="bool"><md-switch id="dialog_input_{{$first ? \'first\' : $index}}" ng-model="vm.record[field.field]" \naria-label="{{field.displayLabel | translate}}" ng-disabled="{{field.validation.disabledCriteria}}" \nng-true-value="true" ng-false-value="false" class="md-accent">{{field.displayLabel | translate}}</md-switch></div><div \nng-switch-when="bool-str"><span ng-if="field.IsSeasonless && field.editable && !vm.isNew" \nclass="attribute-criteria-icon"><md-tooltip><span>\n{{ \'MESSAGES.CONTENT.SEASONLESS_ATTRIBUTE_INFO_MESSAGE\' | translate }}</span></md-tooltip></span><md-switch \nid="dialog_input_{{$first ? \'first\' : $index}}" ng-model="vm.record[field.field]" \naria-label="{{field.displayLabel | translate}}" ng-disabled="{{field.validation.disabledCriteria}}" \nng-true-value="\'true\'" ng-false-value="\'false\'" class="md-accent" \nng-change="vm.handleFieldChange(field);\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tfield.isLookupSourceAttribute ? vm.lookupSourceAttributeChanged(field): \'\';">\n{{field.displayLabel | translate}}</md-switch></div><div ng-switch-when="bool-int"><md-switch \nid="dialog_input_{{$first ? \'first\' : $index}}" ng-model="vm.record[field.field]" \naria-label="{{field.displayLabel | translate}}" ng-disabled="{{field.validation.disabledCriteria}}" ng-true-value="1" \nng-false-value="0" class="md-accent">{{field.displayLabel | translate}}</md-switch></div><div \nng-switch-when="int-bool"><md-switch id="dialog_input_{{$first ? \'first\' : $index}}" ng-model="vm.record[field.field]" \naria-label="{{field.displayLabel | translate}}" ng-disabled="{{field.validation.disabledCriteria}}" ng-true-value="1" \nng-false-value="0" class="md-accent">{{field.displayLabel | translate}}</md-switch></div><div ng-switch-when="list">\n<md-input-container class="md-block"><span ng-if="field.IsSeasonless && field.editable && !vm.isNew" \nclass="attribute-criteria-icon"><md-tooltip><span>\n{{ \'MESSAGES.CONTENT.SEASONLESS_ATTRIBUTE_INFO_MESSAGE\' | translate }}</span></md-tooltip></span><span \nng-if="field.isCriteriaAdded" class="attribute-criteria-icon"><md-tooltip><span>{{ field.criteriaDisplayMessage }}\n</span></md-tooltip></span><label>{{field.displayLabel | translate}}</label><md-select \nid="dialog_input_{{$first ? \'first\' : $index}}" name="{{field.field}}" ng-model="vm.record[field.field]" \naria-label="{{field.displayLabel | translate}}" ng-required="vm.isInputRequired(field)" \nng-disabled="{{field.validation.disabledCriteria}}" pattern="{{field.validation.pattern}}" \nng-focus="vm.currentFocusedField = field.field; field.isCriteriaAdded ? vm.getConditionalVettingList(field) : \'\'" \nng-change="vm.handleFieldChange(field)"><md-option md-option-empty \nng-if="!field.validation.isRequired && field.type !== \'int\'" ng-value="\'\'"><em>None</em></md-option><md-option \nng-if="!field.validation.isRequired && field.type === \'int\'" ng-value="0"><em>0</em></md-option><md-option \nng-value="option" ng-repeat="option in (field.values | mdSelectUniqueoptions)">{{ option }}</md-option></md-select><div\n ng-messages="vm.editForm[field.field].$error" role="alert" multiple="multiple"><div ng-message="required">\n{{field.validation.messages.isRequired | translate}}</div><div ng-message="pattern">\n{{field.validation.messages.pattern | translate}}</div></div></md-input-container></div><div ng-switch-when="color" \nclass="color-div"><md-input-container class="md-block"><label>{{field.displayLabel | translate}}</label><div \nclass="color-palette"><span ng-repeat="color in vm.colors" ng-model="vm.record[field.field]" class="color-tag" \nng-click="vm.record[field.field] = color" ng-style="{\'background-color\': color}" \nng-class="vm.record[field.field] === color ? \'highlist-color-box\': \'\'"></span></div></md-input-container></div><div \nng-switch-when="color-picker" class="color-picker"><md-input-container class="md-block"><label>\n{{field.displayLabel | translate}}</label><input id="dialog_input_{{$first ? \'first+1\' : $index + 1}}" \nname="{{field.field}}" ng-model="vm.record[field.field]" ng-required="vm.isInputRequired(field)" \nmd-maxlength="{{field.validation.maxLen}}" pattern="{{field.validation.pattern}}" \ntx-unique-value="vm.existingRecordsForUniqueValue:{{field.field}}:{{field.checkIfUnique}}" \nng-disabled="{{field.validation.disabledCriteria}}" ng-focus="vm.currentFocusedField = field.field"><div \nng-messages="vm.editForm[field.field].$error" role="alert" multiple="multiple"><div ng-message="required">\n{{field.validation.messages.isRequired | translate}}</div><div ng-message="{{field.inputType}}">\n{{field.validation.messages.invalidType | translate}}</div><div ng-message="pattern">\n{{field.validation.messages.pattern | translate}}</div><div ng-message="md-maxlength">\n{{field.validation.messages.maxLen | translate}}</div><div ng-message="tx-unique-value">\n{{\'VALIDATIONS.DUPLICATE\' | translate}}</div></div></md-input-container><input \nid="dialog_input_{{$first ? \'first\' : $index}}" class="picker" name="colorPicker" ng-model="vm.record[field.field]" \ntype="color" ng-disabled="{{field.validation.disabledCriteria}}"></div><div ng-switch-when="lookup" \nclass="lookup-element" ng-if="field.field !== \'ModelId\'"><span \nng-if="field.field === \'RetailIntroMonthId\' || field.field === \'RetailExitMonthId\'" class="attribute-criteria-icon">\n<md-tooltip><span>{{ field.retailMonthDisplayMessage }}</span></md-tooltip></span><md-autocomplete \nid="dialog_input_{{$first ? \'first\' : $index}}" md-input-name="{{field.field}}" \nmd-selected-item="vm.record[field.field]" md-items="item in vm.lookupSearch(vm.searchText[field.field], field)" \nmd-search-text="vm.searchText[field.field]" md-item-text="vm.getLookupDisplayValue(item, field)" md-min-length="0" \nmd-floating-label="{{field.displayLabel | translate}}" \nmd-selected-item-change="vm.lookupChange(vm.record[field.field], field.field, field)" \nng-required="vm.isInputRequired(field)" md-no-cache="true" tx-clear-autocomplete ng-click="vm.selectText($event)" \nmd-menu-class="autocomplete-custom" ng-disabled="{{field.validation.disabledCriteria}}" md-mode="virtual" \nmd-on-demand="true" md-item-size="50"><md-item-template><span class="autocomplete-item md-accent-fg" \nng-if="field.field !== \'ColorId\'" md-highlight-text="vm.searchText[field.field]" md-highlight-flags="i">{{item.value}}\n</span> <span class="autocomplete-item md-accent-fg" ng-if="field.field === \'ColorId\'" \nmd-highlight-text="vm.searchText[field.field]" md-highlight-flags="i">\n{{ vm.showColorTypeInColorPalatteDropdown ? item.ColorTypeName : item.value}}</span> <span \nclass="autocomplete-item color-box" ng-show="item.ColorCode != null && field.showColorBox" \nng-style="{\'background-color\': item.ColorCode}"></span></md-item-template><div \nng-messages="vm.editForm[field.field].$error" role="alert" ng-show="vm.editForm[field.field].$touched"><div \nng-message="required">{{field.validation.messages.isRequired | translate}}</div></div><md-not-found>\nNo Record matching "{{vm.searchText[field.field]}}" were found.</md-not-found><div class="info-for-first-100-records" \nng-if="field.isAboveDropDownLimit && !(field.validation.disabledCriteria || (field.showInEdit && !field.editable && !vm.isNew))">\n<md-icon class="icon s14" md-font-icon="icon-information-outline"></md-icon><span>\n{{\'MESSAGES.CONTENT.SHOW_FIRST_100\' | translate}}</span></div></md-autocomplete></div><div \nng-switch-when="custom-lookup" class="lookup-element"><md-autocomplete id="dialog_input_{{$first ? \'first\' : $index}}" \nmd-input-name="{{field.field}}" md-selected-item="vm.record[field.field]" \nmd-items="item in vm.lookupSearch(vm.searchText[field.field], field)" md-search-text="vm.searchText[field.field]" \nmd-item-text="vm.getCustomLookupDisplayValue(item, field)" md-min-length="0" \nmd-floating-label="{{field.displayLabel | translate}}" \nmd-selected-item-change="vm.customLookupChange(vm.record[field.field], field)" ng-required="vm.isInputRequired(field)" \nmd-no-cache="true" tx-clear-autocomplete ng-click="vm.selectText($event)" md-menu-class="autocomplete-custom" \nng-disabled="{{field.validation.disabledCriteria}}"><md-item-template><span class="autocomplete-item md-accent-fg" \nmd-highlight-text="vm.searchText[field.field]" md-highlight-flags="i">{{item.value}}</span> <span \nclass="autocomplete-item color-box" ng-show="item.ColorCode != null" ng-style="{\'background-color\': item.ColorCode}">\n</span></md-item-template><div ng-messages="vm.editForm[field.field].$error" role="alert" \nng-show="vm.editForm[field.field].$touched"><div ng-message="required">\n{{field.validation.messages.isRequired | translate}}</div></div><md-not-found>\nNo Record matching "{{vm.searchText[field.field]}}" were found.</md-not-found><div class="info-for-first-100-records" \nng-if="field.isAboveDropDownLimit && !(field.validation.disabledCriteria || (field.showInEdit && !field.editable && !vm.isNew))">\n<md-icon class="icon s14" md-font-icon="icon-information-outline"></md-icon><span>\n{{\'MESSAGES.CONTENT.SHOW_FIRST_100\' | translate}}</span></div></md-autocomplete></div><div \nng-switch-when="multi-value"><md-input-container class="md-block"><span \nng-if="field.IsSeasonless && field.editable && !vm.isNew" class="attribute-criteria-icon"><md-tooltip><span>\n{{ \'MESSAGES.CONTENT.SEASONLESS_ATTRIBUTE_INFO_MESSAGE\' | translate }}</span></md-tooltip></span><span \nng-if="field.isCriteriaAdded" class="attribute-criteria-icon"><md-tooltip><span>{{ field.criteriaDisplayMessage }}\n</span></md-tooltip></span><label translate>{{field.displayLabel}}</label><md-chips \nid="dialog_input_{{$first ? \'first\' : $index}}" name="{{field.field}}" ng-model="vm.record[field.field]" \nmd-autocomplete-snap md-transform-chip="vm.transformChip($chip, true)" md-require-match="true" \nng-required="vm.isInputRequired(field)"><md-autocomplete md-selected-item="vm.acSelectedItem[field.field]" \nmd-search-text="vm.acSearchText[field.field]" \nmd-items="item in vm.multiValueQuerySearch(vm.acSearchText[field.field], vm.record[field.field], field)" \nmd-item-text="item" ng-disabled="{{field.validation.disabledCriteria}}" md-min-length="0" md-no-cache="true" \nmd-selected-item-change="vm.handleFieldChange(field);\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tfield.isLookupSourceAttribute ? vm.lookupSourceAttributeChanged(field): \'\';" \nmd-menu-class="autocomplete-custom"><md-item-template><span class="autocomplete-item md-accent-fg" \nmd-highlight-text="vm.acSearchText[field.field]">{{item}}</span></md-item-template><md-not-found>\nNo Record matching "{{vm.acSearchText[field.field]}}" were found.</md-not-found></md-autocomplete><md-chip-template \ntx-chip="vm.existingRecords:$chip"><span><strong>{{$chip}}</strong></span></md-chip-template></md-chips><div \nclass="md-chips-messages" ng-messages="vm.editForm[field.field].$error" \nng-show="vm.editForm[field.field].$dirty || vm.editForm[field.field].$submitted"><div ng-message="required">\n{{ \'VALIDATIONS.REQUIRED\' | translate}}</div></div></md-input-container></div><div ng-switch-when="lookup-many" \nclass="lookup-element"><md-input-container class="md-block"><label>{{field.displayLabel | translate}}</label><md-chips \nid="dialog_input_{{$first ? \'first\' : $index}}" name="{{field.field}}" ng-model="vm.record[field.field]" \nmd-autocomplete-snap md-transform-chip="vm.transformChip($chip)" md-require-match="true" \nng-required="vm.isInputRequired(field)"><md-autocomplete md-selected-item="vm.acSelectedItem[field.field]" \nmd-search-text="vm.acSearchText[field.field]" \nmd-items="item in vm.acQuerySearch(vm.acSearchText[field.field], vm.record[field.field], field) | filter: field.lookupFilter" \nmd-item-text="item.value" ng-disabled="{{field.validation.disabledCriteria}}" md-min-length="0" md-no-cache="true" \nmd-menu-class="autocomplete-custom"><md-item-template><span class="autocomplete-item md-accent-fg" \nmd-highlight-text="vm.acSearchText[field.field]">{{item.value}}</span></md-item-template><md-not-found>\nNo Record matching "{{vm.acSearchText[field.field]}}" were found.</md-not-found></md-autocomplete><md-chip-template \ntx-chip="vm.existingRecords:$chip"><span><strong>{{ vm.getChipDisplayValue($chip, field) }}</strong></span>\n</md-chip-template></md-chips><div class="md-chips-messages" ng-messages="vm.editForm[field.field].$error" \nng-show="vm.editForm[field.field].$dirty || vm.editForm[field.field].$submitted"><div ng-message="required">\n{{field.validation.messages.isRequired | translate}}</div></div></md-input-container></div><div \nng-switch-when="dataset" class="lookup-element"><span ng-if="field.IsSeasonless && field.editable && !vm.isNew" \nclass="attribute-criteria-icon"><md-tooltip><span>\n{{ \'MESSAGES.CONTENT.SEASONLESS_ATTRIBUTE_INFO_MESSAGE\' | translate }}</span></md-tooltip></span>\n<tx-dataset-autocomplete tx-field="field" tx-data="vm.record" tx-new="vm.isNew"></tx-dataset-autocomplete></div><div \nng-switch-when="datatable"><span ng-if="field.IsSeasonless && field.editable && !vm.isNew" \nclass="attribute-criteria-icon"><md-tooltip><span>\n{{ \'MESSAGES.CONTENT.SEASONLESS_ATTRIBUTE_INFO_MESSAGE\' | translate }}</span></md-tooltip></span><tx-ui-grid \ntx-field="field" tx-data="vm.record" tx-new="vm.isNew" tx-editable="field.editable"></tx-ui-grid></div><div \nng-switch-when="tags"><label>{{field.displayLabel | translate}}<span ng-if="vm.isInputRequired(field)" \nmd-colors="{color: \'red\'}">*</span></label><md-chips name="{{field.field}}" \nid="dialog_input_{{$first ? \'first\' : $index}}" ng-model="vm.record[field.field]" \nplaceholder="{{\'ACTIONS.ADD_TAGS\' | translate}}" secondary-placeholder="{{\'ACTIONS.ADD_TAGS\' | translate}}" \nmd-enable-chip-edit="true" md-max-chips="{{vm.maxTags}}" md-on-add="vm.add($chip, vm.record[field.field], field)" \nmd-separator-keys="vm.tagSeperatorKeys[field.field]" ng-required="vm.isInputRequired(field)" \nreadonly="field.validation.disabledCriteria"></md-chips><div class="md-chips-messages" \nng-messages="vm.editForm[field.field].$error" \nng-show="vm.editForm[field.field].$dirty || vm.editForm[field.field].$submitted" multiple="multiple"><div \nng-message="required">{{field.validation.messages.isRequired | translate}}</div><div ng-message="md-max-chips">\n{{field.validation.messages.maxLen | translate}}</div></div><div ng-if="vm.add($chip, vm.record[field.field], field)" \nclass="error-message display-error">{{ vm.ErrorMessage}}</div></div><div ng-switch-when="target-attributes-json-str">\n<md-input-container class="md-block"><label>{{field.displayLabel | translate}}</label><input \nid="dialog_input_{{$first ? \'first\' : $index}}" name="{{field.field}}" ng-model="vm.record[field.field]" type="text" \nng-required="vm.isInputRequired(field)" md-maxlength="{{field.validation.maxLen}}" \npattern="{{field.validation.pattern}}" ng-disabled="{{field.validation.disabledCriteria}}"><div \nng-messages="vm.editForm[field.field].$error" role="alert" multiple="multiple"><div ng-message="required">\n{{field.validation.messages.isRequired | translate}}</div><div ng-message="{{field.inputType}}">\n{{field.validation.messages.invalidType | translate}}</div><div ng-message="pattern">\n{{field.validation.messages.pattern | translate}}</div><div ng-message="md-maxlength">\n{{field.validation.messages.maxLen | translate}}</div></div></md-input-container></div><div ng-switch-when="decimal">\n<md-input-container class="md-block"><span ng-if="field.IsSeasonless && field.editable && !vm.isNew" \nclass="attribute-criteria-icon"><md-tooltip><span>\n{{ \'MESSAGES.CONTENT.SEASONLESS_ATTRIBUTE_INFO_MESSAGE\' | translate }}</span></md-tooltip></span><label>\n{{field.displayLabel | translate}}</label><input id="dialog_input_{{$first ? \'first\' : $index}}" \nname="{{field.field}}" ng-model="vm.record[field.field]" type="number" ng-required="vm.isInputRequired(field)" \nmd-maxlength="{{field.validation.maxLen}}" pattern="{{field.validation.pattern}}" \ntx-unique-value="vm.existingRecordsForUniqueValue:{{field.field}}:{{field.checkIfUnique}}" \nng-disabled="{{field.validation.disabledCriteria}}" ng-focus="vm.currentFocusedField = field.field" \nng-change="vm.handleFieldChange(field);"><div ng-messages="vm.editForm[field.field].$error" role="alert" \nmultiple="multiple"><div ng-message="required">{{field.validation.messages.isRequired | translate}}</div><div \nng-message="{{field.inputType}}">{{field.validation.messages.invalidType | translate}}</div><div ng-message="pattern">\n{{field.validation.messages.pattern | translate}}</div><div ng-message="md-maxlength">\n{{field.validation.messages.maxLen | translate}}</div><div ng-message="tx-unique-value">\n{{\'VALIDATIONS.DUPLICATE\' | translate}}</div></div></md-input-container></div><div ng-switch-when="articlenumber" \nclass="lookup-element"><md-autocomplete id="dialog_input_{{$first ? \'first\' : $index}}" \nmd-input-name="{{field.field}}" md-selected-item="vm.record[field.field]" \nmd-items="item in vm.lookupSearch(vm.searchText[field.field], field)" md-search-text="vm.searchText[field.field]" \nmd-item-text="vm.getLookupDisplayValue(item, field, true)" md-min-length="0" \nmd-floating-label="{{field.displayLabel | translate}}" \nmd-selected-item-change="vm.lookupChange(vm.record[field.field], field.field, field)" \nng-required="vm.isInputRequired(field)" md-no-cache="true" tx-clear-autocomplete ng-click="vm.selectText($event)" \nmd-menu-class="autocomplete-custom" ng-disabled="{{field.validation.disabledCriteria}}"><md-item-template><span \nclass="autocomplete-item md-accent-fg" md-highlight-text="vm.searchText[field.field]" md-highlight-flags="i">\n{{item.value}}</span></md-item-template><div ng-messages="vm.editForm[field.field].$error" role="alert" \nng-show="vm.editForm[field.field].$touched"><div ng-message="required">\n{{field.validation.messages.isRequired | translate}}</div></div><md-not-found>\nNo Record matching "{{vm.searchText[field.field]}}" were found.</md-not-found><div class="info-for-first-100-records" \nng-if="field.isAboveDropDownLimit && !(field.validation.disabledCriteria || (field.showInEdit && !field.editable && !vm.isNew))">\n<md-icon class="icon s14" md-font-icon="icon-information-outline"></md-icon><span>\n{{\'MESSAGES.CONTENT.SHOW_FIRST_100\' | translate}}</span></div></md-autocomplete></div><div \nng-switch-when="linkedcatalogarticlenumber"><label>{{field.displayLabel | translate}}</label><tx-linked-article-viewer \ntx-field="field" tx-data="vm.record" tx-new="vm.isNew"></tx-linked-article-viewer></div><div \nng-switch-when="color-palette" class="lookup-element"><md-autocomplete id="dialog_input_{{$first ? \'first\' : $index}}" \nmd-input-name="{{field.field}}" md-selected-item="vm.record[field.field]" \nmd-items="item in vm.lookupSearch(vm.searchText[field.field], field)" md-search-text="vm.searchText[field.field]" \nmd-item-text="vm.getCustomLookupDisplayValue(item, field)" md-min-length="0" \nmd-floating-label="{{field.displayLabel | translate}}" \nmd-selected-item-change="vm.colorPaletteLookupChange(vm.record[field.field], field)" \nng-required="vm.isInputRequired(field)" md-no-cache="true" tx-clear-autocomplete ng-click="vm.selectText($event)" \nmd-menu-class="autocomplete-custom" ng-disabled="{{field.validation.disabledCriteria}}" md-mode="virtual" \nmd-on-demand="true" md-item-size="50"><md-item-template><span class="autocomplete-item md-accent-fg" \nmd-highlight-text="vm.searchText[field.field]" md-highlight-flags="i">\n{{ vm.showColorTypeInColorPalatteDropdown ? item.ColorTypeName : item.value}}</span></md-item-template><div \nng-messages="vm.editForm[field.field].$error" role="alert" ng-show="vm.editForm[field.field].$touched"><div \nng-message="required">{{field.validation.messages.isRequired | translate}}</div></div><md-not-found>\nNo Record matching "{{vm.searchText[field.field]}}" were found.</md-not-found><div class="info-for-first-100-records" \nng-if="field.isAboveDropDownLimit && !(field.validation.disabledCriteria || (field.showInEdit && !field.editable && !vm.isNew))">\n<md-icon class="icon s14" md-font-icon="icon-information-outline"></md-icon><span>\n{{\'MESSAGES.CONTENT.SHOW_FIRST_100\' | translate}}</span></div></md-autocomplete></div><div \nng-switch-when="modelnumber" class="lookup-element"><md-autocomplete id="dialog_input_{{$first ? \'first\' : $index}}" \nmd-input-name="{{field.field}}" md-selected-item="vm.record[field.field]" \nmd-items="item in vm.lookupSearch(vm.searchText[field.field], field)" md-search-text="vm.searchText[field.field]" \nmd-item-text="vm.getLookupDisplayValue(item, field, true)" md-min-length="0" \nmd-floating-label="{{field.displayLabel | translate}}" \nmd-selected-item-change="vm.lookupChange(vm.record[field.field], field.field, field)" \nng-required="vm.isInputRequired(field)" md-no-cache="true" tx-clear-autocomplete ng-click="vm.selectText($event)" \nmd-menu-class="autocomplete-custom" ng-disabled="{{field.validation.disabledCriteria}}"><md-item-template><span \nclass="autocomplete-item md-accent-fg" md-highlight-text="vm.searchText[field.field]" md-highlight-flags="i">\n{{item.value}}</span></md-item-template><div ng-messages="vm.editForm[field.field].$error" role="alert" \nng-show="vm.editForm[field.field].$touched"><div ng-message="required">\n{{field.validation.messages.isRequired | translate}}</div></div><md-not-found>\nNo Record matching "{{vm.searchText[field.field]}}" were found.</md-not-found><div class="info-for-first-100-records" \nng-if="field.isAboveDropDownLimit && !(field.validation.disabledCriteria || (field.showInEdit && !field.editable && !vm.isNew))">\n<md-icon class="icon s14" md-font-icon="icon-information-outline"></md-icon><span>\n{{\'MESSAGES.CONTENT.SHOW_FIRST_100\' | translate}}</span></div></md-autocomplete></div><div \nng-switch-when="lookup-table"><span ng-if="field.isLookupAdded" class="attribute-criteria-icon"><md-tooltip><span>\n{{ field.lookupDisplayMessage }}</span></md-tooltip></span><md-input-container class="md-block"><label>\n{{field.displayLabel | translate}}</label><input id="dialog_input_{{$first ? \'first\' : $index}}" \nname="{{field.field}}" ng-model="vm.record[field.field]" type="text" ng-required="vm.isInputRequired(field)" \nng-disabled="true" md-autofocus="$first"><div ng-messages="vm.editForm[field.field].$error" role="alert" \nmultiple="multiple"><div ng-message="required">{{field.validation.messages.isRequired | translate}}</div></div>\n</md-input-container></div><div ng-switch-when="number"><md-input-container class="md-block"><span \nng-if="field.IsSeasonless && field.editable && !vm.isNew" class="attribute-criteria-icon"><md-tooltip><span>\n{{ \'MESSAGES.CONTENT.SEASONLESS_ATTRIBUTE_INFO_MESSAGE\' | translate }}</span></md-tooltip></span><label>\n{{field.displayLabel | translate}}</label><div class="external-change-message" \nng-if="field.isAllowChangeRequestEnabled && !vm.isNew && field.updateArticleChangeManagementExternalURL !== \'\'"><span>\n{{ \'MESSAGES.CONTENT.NON_EDITABLE_STATE_ATTRIBUTE\' | translate }} <a \nhref="{{field.updateArticleChangeManagementExternalURL}}" target="_blank">here</a></span></div><input \nid="dialog_input_{{$first ? \'first\' : $index}}" name="{{field.field}}" ng-model="vm.record[field.field]" type="number" \ntx-integer-value ng-required="vm.isInputRequired(field)" md-maxlength="{{field.validation.maxLen}}" \npattern="{{field.validation.pattern}}" \ntx-unique-value="vm.existingRecordsForUniqueValue:{{field.field}}:{{field.checkIfUnique}}" \nng-disabled="{{field.validation.disabledCriteria || (field.showInEdit && !field.editable && !vm.isNew)}}" \nmd-autofocus="$first" ng-focus="vm.currentFocusedField = field.field" \nng-change="vm.handleFieldChange(field);\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tfield.isSourceAttributeForValidation ? vm.sourceAttributeForValidationChanged(field): \'\'; field.isCriteriaDeptAttribute ? vm.criteriaDependentCriteriaAttributeChanged(field): \'\';\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tfield.isLookupSourceAttribute ? vm.lookupSourceAttributeChanged(field): \'\';">\n<div ng-messages="vm.editForm[field.field].$error" role="alert" multiple="multiple"><div ng-message="required">\n{{field.validation.messages.isRequired | translate}}</div><div ng-message="{{field.inputType}}">\n{{field.validation.messages.invalidType | translate}}</div><div ng-message="pattern">\n{{field.validation.messages.pattern | translate}}</div><div ng-message="md-maxlength">\n{{field.validation.messages.maxLen | translate}}</div><div ng-message="tx-unique-value">\n{{\'VALIDATIONS.DUPLICATE\' | translate}}</div><div ng-message="tx-integer-value">\n{{\'VALIDATIONS.INVALID_INTEGER\' | translate}}</div></div></md-input-container></div><div ng-switch-default>\n<md-input-container class="md-block"><span ng-if="field.IsSeasonless && field.editable && !vm.isNew" \nclass="attribute-criteria-icon"><md-tooltip><span>\n{{ \'MESSAGES.CONTENT.SEASONLESS_ATTRIBUTE_INFO_MESSAGE\' | translate }}</span></md-tooltip></span><label>\n{{field.displayLabel | translate}}</label><input id="dialog_input_{{$first ? \'first\' : $index}}" \nname="{{field.field}}" ng-model="vm.record[field.field]" type="{{field.inputType}}" \nng-required="vm.isInputRequired(field)" md-maxlength="{{field.validation.maxLen}}" \npattern="{{field.validation.pattern}}" \ntx-unique-value="vm.existingRecordsForUniqueValue:{{field.field}}:{{field.checkIfUnique}}" \nng-disabled="{{field.validation.disabledCriteria}}" ng-focus="vm.currentFocusedField = field.field" \nng-change="vm.handleFieldChange(field);"><div ng-messages="vm.editForm[field.field].$error" role="alert" \nmultiple="multiple"><div ng-message="required">{{field.validation.messages.isRequired | translate}}</div><div \nng-message="{{field.inputType}}">{{field.validation.messages.invalidType | translate}}</div><div ng-message="pattern">\n{{field.validation.messages.pattern | translate}}</div><div ng-message="md-maxlength">\n{{field.validation.messages.maxLen | translate}}</div><div ng-message="tx-unique-value">\n{{\'VALIDATIONS.DUPLICATE\' | translate}}</div></div></md-input-container></div></div></div></md-dialog-content>\n<md-dialog-actions layout="row" layout-align="end center"><div></div><div layout="row" layout-align="end center">\n<md-button ng-click="vm.closeDialog(vm.isDataDirty)" class="send-button md-primary md-raised" aria-label="Cancel" \ntranslate="ACTIONS.DIALOG_CANCEL" translate-attr-aria-label="ACTIONS.DIALOG_CANCEL" ng-disabled="vm.isLoading">CANCEL\n</md-button><md-button ng-click="vm.saveRecord()" class="send-button md-accent md-raised" aria-label="Save" \ntranslate="ACTIONS.SAVE" translate-attr-aria-label="ACTIONS.SAVE" ng-disabled="vm.isLoading || !vm.isFormValid()">SAVE\n</md-button></div></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/catalogs/sub-modules/articles/dialogs/confirm-drop/confirm-drop.html','<md-dialog class="edit-dialog" aria-label="Confirm Drop" flex="35"><md-toolbar class="md-accent md-hue-2"><div \nclass="md-toolbar-tools" layout="row" layout-align="space-between center"><span class="title" translate="{{vm.title}}">\n{{vm.title}}</span><md-button class="md-icon-button" ng-click="vm.cancel(\'cancel\')" aria-label="Close dialog" tranlate \ntranslate-aria-label="ACTIONS.DIALOG_CLOSE"><md-icon md-font-icon="icon-close"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div layout="column" class="lookup-element"><h2>\n{{vm.message | translate:vm.translateVar}}</h2></div><div layout="column" ng-if="vm.isDropReasonsAdded" \nclass="lookup-element"><md-autocomplete md-input-name="DropReasonId" md-selected-item="vm.lookupModel.DropReasonId" \nmd-items="item in vm.lookupArticleDropReasons(vm.searchText[\'DropReasonId\'])" \nmd-search-text="vm.searchText[\'DropReasonId\']" md-item-text="vm.getLookupArticleDropReasonDisplayValue(item)" \nmd-min-length="0" md-floating-label="{{\'ARTICLES.FIELDS.DROP_REASON\' | translate}}" \nmd-selected-item-change="vm.lookupArticleDropReasonChange(item)" md-no-cache="true" tx-clear-autocomplete \ntx-force-select ng-click="vm.selectText($event)" md-menu-class="autocomplete-custom" ng-required="true">\n<md-item-template><span class="autocomplete-item md-accent-fg" md-highlight-text="vm.searchText[\'DropReasonId\']" \nmd-highlight-flags="i">{{item[\'Reason\']}}</span></md-item-template><md-not-found>\nNo Record matching "{{vm.searchText[\'DropReasonId\']}}" were found.</md-not-found></md-autocomplete></div><div \nlayout="column" class="lookup-element"><md-autocomplete md-selected-item="vm.lookupModel.RAID" \nmd-items="item in vm.lookupSearch(vm.searchText[\'ArticleId\'])" md-search-text="vm.searchText[\'ArticleId\']" \nmd-item-text="vm.getLookupDisplayValue(item)" md-min-length="0" \nmd-floating-label="{{\'ARTICLES.FIELDS.ARTICLE\' | translate}}" md-selected-item-change="vm.lookupChange(item)" \nmd-no-cache="true" tx-clear-autocomplete tx-force-select ng-click="vm.selectText($event)" \nmd-menu-class="autocomplete-custom" ng-required="vm.requiresReplacement"><md-item-template><span \nclass="autocomplete-item md-accent-fg" md-highlight-text="vm.searchText[\'ArticleId\']" md-highlight-flags="i">\n{{item[\'ArticleNumber\']}}</span></md-item-template><md-not-found>\nNo Record matching "{{vm.searchText[\'ArticleId\']}}" were found.</md-not-found></md-autocomplete></div><div \nlayout="column" ng-if="vm.requiresComment" class="lookup-element"><md-input-container class="md-block"><label \ntranslate="ARTICLES.FIELDS.DROP_COMMENT">Comment</label><textarea ng-model="vm.dropComment" rows="1" \nmd-maxlength="1000" ng-required="vm.requiresComment"></textarea></md-input-container></div></md-dialog-content>\n<md-dialog-actions layout="row" layout-align="end center"><div></div><div layout="row" layout-align="end center">\n<md-button ng-click="vm.cancel(\'cancel\')" class="md-primary md-raised" translate="ACTIONS.DIALOG_CANCEL" \naria-label="Cancel" translate-attr-aria-label="ACTIONS.DIALOG_CANCEL">CANCEL</md-button><md-button \nng-click="vm.closeDialog()" class="md-accent md-raised" translate="{{vm.action}}" aria-label="Drop" \ntranslate-attr-aria-label="{{vm.action}}" \nng-disabled="(vm.isDropReasonsAdded && !vm.lookupModel.DropReasonId) || (vm.requiresReplacement && !vm.lookupModel.RAID) || (vm.requiresComment && !vm.dropComment)">\n{{vm.action | translate}}</md-button></div></md-dialog-actions></md-dialog>');
$templateCache.put('app/main/catalogs/sub-modules/articles/dialogs/create-article/create-article.html','<md-dialog class="edit-dialog" aria-label="{{vm.isNew ? \'New Buyer\' : \'Edit Buyer\'}}"><form name="vm.editForm" \nclass="md-inline-form"><md-toolbar class="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" \nlayout-align="space-between center"><span class="title" \ntranslate="{{vm.isNew ? \'TITLES.RECORD_NEW\' : \'TITLES.RECORD_EDIT\'}}">Edit Record</span><md-button \nclass="md-icon-button" ng-click="vm.closeDialog(false)" aria-label="Close dialog" tranlate \ntranslate-aria-label="ACTIONS.DIALOG_CLOSE"><md-icon md-font-icon="icon-close"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div class="import-search-container" layout="row"><md-input-container \nflex-gt-xs="100" flex="100"><md-icon class="s18" md-font-icon="icon-magnify"></md-icon><input \nng-model="vm.searchPageText" type="search" placeholder="Search" md-autofocus ng-change="vm.onSearchTextChanged()">\n</md-input-container></div><div class="import-search-container" layout="row"><div \nng-if="vm.isStateValidationFailedWithoutElement" class="form-date-error" flex="100"><span \nng-repeat="errorMessage in vm.requiredAttributesErrorMessages">{{ errorMessage }}</span></div></div><div layout="row" \nlayout-wrap ng-show="!(vm.AllowExternalChangeManagement || vm.checkingForLockedArticles)"><div \nng-repeat="field in vm.filteredVisibleFields" flex="100" \nflex-gt-xs="{{field.inputType == \'textArea\' || field.inputType == \'lookup-many\' || field.inputType == \'tags\' || field.inputType == \'color\' || field.inputType == \'datatable\' ? 100 : 50}}" \nclass="p-5" ng-switch="field.inputType"><div ng-switch-when="textArea"><md-input-container class="md-block" \nmd-is-error="vm.editForm[field.field].$invalid"><span ng-if="field.IsSeasonless && field.editable && !vm.isNew" \nclass="attribute-criteria-icon"><md-tooltip><span>\n{{ \'MESSAGES.CONTENT.SEASONLESS_ATTRIBUTE_INFO_MESSAGE\' | translate }}</span></md-tooltip></span><label>\n{{field.displayLabel | translate}}</label><textarea id="dialog_input_{{$first ? \'first\' : $index}}" \nname="{{field.field}}" ng-model="vm.record[field.field]" columns="1" rows="1" ng-required="vm.isInputRequired(field)" \nmd-maxlength="{{field.validation.maxLen}}" pattern="{{field.validation.pattern}}" \nng-focus="vm.currentFocusedField = field.field" \nng-change="vm.handleFieldChange(field);\r\n\t\t\t\t\t\t\t\t\tfield.validation.checkIfValidJson ? vm.validateJSON(field) : \'\';" \nng-disabled="{{field.validation.disabledCriteria || (field.showInEdit && !field.editable && !vm.isNew)}}" \nmd-autofocus="$first"></textarea><div ng-messages="vm.editForm[field.field].$error" role="alert" multiple="multiple">\n<div ng-message="required">{{field.validation.messages.isRequired | translate}}</div><div ng-message="pattern">\n{{field.validation.messages.pattern | translate}}</div><div ng-message="md-maxlength">\n{{field.validation.messages.maxLen | translate}}</div><div ng-message="checkIfValidJson">\n{{field.validation.messages.isValidJson | translate}}</div></div></md-input-container></div><div ng-switch-when="date" \nlayout="column" flex><span ng-if="field.IsSeasonless && field.editable && !vm.isNew" class="attribute-criteria-icon">\n<md-tooltip><span>{{ \'MESSAGES.CONTENT.SEASONLESS_ATTRIBUTE_INFO_MESSAGE\' | translate }}</span></md-tooltip></span>\n<label class="md-caption" ng-class="vm.editForm[field.field].$invalid ? \'form-date-error\': \'\'">\n{{field.displayLabel | translate}}</label><md-datepicker id="dialog_input_{{$first ? \'first\' : $index}}" \nname="{{field.field}}" ng-model="vm.record[field.field]" \nng-init="vm.record[field.field] = vm.getDateObj(vm.record[field.field])" md-placeholder="" \nng-required="vm.isInputRequired(field)" ng-focus="vm.currentFocusedField = field.field" \nng-change="vm.handleFieldChange(field);" md-autofocus="$first" ng-disabled="field.validation.disabled"></md-datepicker>\n<div ng-messages="vm.editForm[field.field].$error" class="form-date-error" role="alert" multiple="multiple"><div \nng-message="required">{{field.validation.messages.isRequired | translate}}</div><div ng-message="pattern">\n{{field.validation.messages.pattern | translate}}</div></div></div><div ng-switch-when="date-without-time" \nlayout="column" flex><span ng-if="field.IsSeasonless && field.editable && !vm.isNew" class="attribute-criteria-icon">\n<md-tooltip><span>{{ \'MESSAGES.CONTENT.SEASONLESS_ATTRIBUTE_INFO_MESSAGE\' | translate }}</span></md-tooltip></span>\n<label class="md-caption" ng-class="vm.editForm[field.field].$invalid ? \'form-date-error\': \'\'">\n{{field.displayLabel | translate}}</label><md-datepicker id="dialog_input_{{$first ? \'first\' : $index}}" \nname="{{field.field}}" ng-model="vm.record[field.field]" \nng-init="vm.record[field.field] = vm.getDateObj(vm.record[field.field])" md-placeholder="" \nng-required="vm.isInputRequired(field)" md-autofocus="$first" ng-disabled="field.validation.disabled" \nng-focus="vm.currentFocusedField = field.field" ng-change="vm.handleFieldChange(field);"></md-datepicker><div \nng-messages="vm.editForm[field.field].$error" class="form-date-error" role="alert" multiple="multiple"><div \nng-message="required">{{field.validation.messages.isRequired | translate}}</div><div ng-message="pattern">\n{{field.validation.messages.pattern | translate}}</div></div></div><div ng-switch-when="date-utc" layout="column" flex>\n<label class="md-caption" ng-class="vm.editForm[field.field].$invalid ? \'form-date-error\': \'\'">\n{{field.displayLabel | translate}}</label><md-datepicker id="dialog_input_{{$first ? \'first\' : $index}}" \nname="{{field.field}}" ng-model="vm.record[field.field]" \nng-init="vm.record[field.field] = vm.getDateObj(vm.record[field.field], true)" md-placeholder="" \nng-required="vm.isInputRequired(field)" md-autofocus="$first" ng-disabled="field.validation.disabled" \nng-focus="vm.currentFocusedField = field.field" ng-change="vm.handleFieldChange(field);"></md-datepicker><div \nng-messages="vm.editForm[field.field].$error" class="form-date-error" role="alert" multiple="multiple"><div \nng-message="required">{{field.validation.messages.isRequired | translate}}</div><div ng-message="pattern">\n{{field.validation.messages.pattern | translate}}</div></div></div><div ng-switch-when="date-option" layout="column" \nflex><span ng-if="field.IsSeasonless && field.editable && !vm.isNew" class="attribute-criteria-icon"><md-tooltip><span>\n{{ \'MESSAGES.CONTENT.SEASONLESS_ATTRIBUTE_INFO_MESSAGE\' | translate }}</span></md-tooltip></span><label \nclass="md-caption" ng-class="vm.editForm[field.field].$invalid ? \'form-date-error\': \'\'">\n{{field.displayLabel | translate}}</label><md-datepicker id="dialog_input_{{$first ? \'first\' : $index}}" \nname="{{field.field}}" ng-model="vm.record[field.field]" \nng-init="vm.record[field.field] = vm.getDateObj(vm.record[field.field])" md-placeholder="" \nng-required="vm.isInputRequired(field)" md-autofocus="$first" ng-disabled="field.validation.disabled" \nng-focus="vm.currentFocusedField = field.field" ng-change="vm.handleFieldChange(field);"></md-datepicker><div \nng-messages="vm.editForm[field.field].$error" class="form-date-error" role="alert" multiple="multiple"><div \nng-message="required">{{field.validation.messages.isRequired | translate}}</div><div ng-message="pattern">\n{{field.validation.messages.pattern | translate}}</div></div></div><div ng-switch-when="icon"></div><div \nng-switch-when="bool"><md-switch id="dialog_input_{{$first ? \'first\' : $index}}" ng-model="vm.record[field.field]" \naria-label="{{field.displayLabel | translate}}" \nng-disabled="{{field.validation.disabledCriteria || (field.showInEdit && !field.editable && !vm.isNew)}}" \nng-true-value="true" ng-false-value="false" class="md-accent" md-autofocus="$first">{{field.displayLabel | translate}}\n</md-switch></div><div ng-switch-when="bool-str"><span ng-if="field.IsSeasonless && field.editable && !vm.isNew" \nclass="attribute-criteria-icon"><md-tooltip><span>\n{{ \'MESSAGES.CONTENT.SEASONLESS_ATTRIBUTE_INFO_MESSAGE\' | translate }}</span></md-tooltip></span><md-switch \nid="dialog_input_{{$first ? \'first\' : $index}}" ng-model="vm.record[field.field]" \naria-label="{{field.displayLabel | translate}}" \nng-disabled="{{field.validation.disabledCriteria || (field.showInEdit && !field.editable && !vm.isNew)}}" \nng-true-value="\'true\'" ng-false-value="\'false\'" class="md-accent" md-autofocus="$first" \nng-change="vm.handleFieldChange(field);">{{field.displayLabel | translate}}</md-switch></div><div \nng-switch-when="bool-int"><md-switch id="dialog_input_{{$first ? \'first\' : $index}}" ng-model="vm.record[field.field]" \naria-label="{{field.displayLabel | translate}}" \nng-disabled="{{field.validation.disabledCriteria || (field.showInEdit && !field.editable && !vm.isNew)}}" \nng-true-value="1" ng-false-value="0" class="md-accent" md-autofocus="$first">{{field.displayLabel | translate}}\n</md-switch></div><div ng-switch-when="int-bool"><md-switch id="dialog_input_{{$first ? \'first\' : $index}}" \nng-model="vm.record[field.field]" aria-label="{{field.displayLabel | translate}}" \nng-disabled="{{field.validation.disabledCriteria || (field.showInEdit && !field.editable && !vm.isNew)}}" \nng-true-value="1" ng-false-value="0" class="md-accent" md-autofocus="$first">{{field.displayLabel | translate}}\n</md-switch></div><div ng-switch-when="list"><md-input-container class="md-block"><span \nng-if="field.IsSeasonless && field.editable && !vm.isNew" class="attribute-criteria-icon"><md-tooltip><span>\n{{ \'MESSAGES.CONTENT.SEASONLESS_ATTRIBUTE_INFO_MESSAGE\' | translate }}</span></md-tooltip></span><span \nng-if="field.isCriteriaAdded" class="attribute-criteria-icon"><md-tooltip><span>{{ field.criteriaDisplayMessage }}\n</span></md-tooltip></span><label>{{field.displayLabel | translate}}</label><md-select \nid="dialog_input_{{$first ? \'first\' : $index}}" name="{{field.field}}" ng-model="vm.record[field.field]" \naria-label="{{field.displayLabel | translate}}" ng-required="vm.isInputRequired(field)" \nng-disabled="{{field.validation.disabledCriteria || (field.showInEdit && !field.editable && !vm.isNew) || field.isModelLevelAttribute}}" \nmd-autofocus="$first" pattern="{{field.validation.pattern}}" \nng-focus="vm.currentFocusedField = field.field; field.isCriteriaAdded ? vm.getConditionalVettingList(field) : \'\'" \nng-change="vm.handleFieldChange(field)" md-on-close="vm.clearSearchTerm(field.field)"><md-select-header><input \nng-model="vm.searchValue[field.field]" type="search" placeholder="Search" ng-keydown="$event.stopPropagation()">\n</md-select-header><md-option md-option-empty ng-if="!field.validation.isRequired && field.type !== \'int\'" \nng-value="\'\'"><em>None</em></md-option><md-option ng-if="!field.validation.isRequired && field.type === \'int\'" \nng-value="0"><em>0</em></md-option><md-option ng-value="option" \nng-repeat="option in (field.values | mdSelectUniqueoptions) | filter:vm.searchValue[field.field]">{{ option }}\n</md-option></md-select><div ng-messages="vm.editForm[field.field].$error" role="alert" multiple="multiple"><div \nng-message="required">{{field.validation.messages.isRequired | translate}}</div><div ng-message="pattern">\n{{field.validation.messages.pattern | translate}}</div></div></md-input-container></div><div ng-switch-when="color" \nclass="color-div"><md-input-container class="md-block"><label>{{field.displayLabel | translate}}</label><div \nclass="color-palette"><span ng-repeat="color in vm.colors" ng-model="vm.record[field.field]" class="color-tag" \nng-click="vm.record[field.field] = color" ng-style="{\'background-color\': color}" \nng-class="vm.record[field.field] === color ? \'highlist-color-box\': \'\'"></span></div></md-input-container></div><div \nng-switch-when="color-picker" class="color-picker"><md-input-container class="md-block"><label>\n{{field.displayLabel | translate}}</label><input id="dialog_input_{{$first ? \'first+1\' : $index + 1}}" \nname="{{field.field}}" ng-model="vm.record[field.field]" ng-required="vm.isInputRequired(field)" \nmd-maxlength="{{field.validation.maxLen}}" pattern="{{field.validation.pattern}}" \ntx-unique-value="vm.existingRecordsForUniqueValue:{{field.field}}:{{field.checkIfUnique}}" \nng-disabled="{{field.validation.disabledCriteria || (field.showInEdit && !field.editable && !vm.isNew)}}" \nng-focus="vm.currentFocusedField = field.field"><div ng-messages="vm.editForm[field.field].$error" role="alert" \nmultiple="multiple"><div ng-message="required">{{field.validation.messages.isRequired | translate}}</div><div \nng-message="{{field.inputType}}">{{field.validation.messages.invalidType | translate}}</div><div ng-message="pattern">\n{{field.validation.messages.pattern | translate}}</div><div ng-message="md-maxlength">\n{{field.validation.messages.maxLen | translate}}</div><div ng-message="tx-unique-value">\n{{\'VALIDATIONS.DUPLICATE\' | translate}}</div></div></md-input-container><input \nid="dialog_input_{{$first ? \'first\' : $index}}" class="picker" name="colorPicker" ng-model="vm.record[field.field]" \ntype="color" ng-disabled="{{field.validation.disabledCriteria || (field.showInEdit && !field.editable && !vm.isNew)}}">\n</div><div ng-switch-when="lookup" class="lookup-element"><span \nng-if="field.field === \'RetailIntroMonthId\' || field.field === \'RetailExitMonthId\'" class="attribute-criteria-icon">\n<md-tooltip><span>{{ field.retailMonthDisplayMessage }}</span></md-tooltip></span><span \nng-if="field.requiredAttributeNames && field.requiredAttributeNames.length" class="attribute-criteria-icon">\n<md-tooltip><span>{{ field.requiredAttributeNames }}</span></md-tooltip></span><md-autocomplete \nid="dialog_input_{{$first ? \'first\' : $index}}" md-input-name="{{field.field}}" \nmd-selected-item="vm.record[field.field]" md-items="item in vm.lookupSearch(vm.searchText[field.field], field)" \nmd-search-text="vm.searchText[field.field]" md-item-text="vm.getLookupDisplayValue(item, field)" md-min-length="0" \nmd-floating-label="{{field.displayLabel | translate}}" \nmd-selected-item-change="vm.lookupChange(vm.record[field.field], field.field, field)" \nng-required="vm.isInputRequired(field)" md-autofocus="$first" md-no-cache="true" tx-clear-autocomplete \nng-click="vm.selectText($event)" md-menu-class="autocomplete-custom" \nng-disabled="{{field.validation.disabledCriteria || (field.showInEdit && !field.editable && !vm.isNew)}}">\n<md-item-template><span class="autocomplete-item md-accent-fg" ng-if="field.field !== \'ColorId\'" \nmd-highlight-text="vm.searchText[field.field]" md-highlight-flags="i">{{item.value}}</span> <span \nclass="autocomplete-item md-accent-fg" ng-if="field.field === \'ColorId\'" \nmd-highlight-text="vm.searchText[field.field]" md-highlight-flags="i">\n{{ vm.showColorTypeInColorPalatteDropdown ? item.ColorTypeName : item.value}}</span> <span \nclass="autocomplete-item color-box" ng-show="item.ColorCode != null && field.showColorBox" \nng-style="{\'background-color\': item.ColorCode}"></span></md-item-template><div \nng-messages="vm.editForm[field.field].$error" role="alert" ng-show="vm.editForm[field.field].$touched"><div \nng-message="required">{{field.validation.messages.isRequired | translate}}</div><div ng-message="stateRequirement">\n<span ng-repeat="errorMessage in vm.requiredAttributesErrorMessages">{{ errorMessage }}</span></div></div>\n<md-not-found>No Record matching "{{vm.searchText[field.field]}}" were found.<div ng-if="field.allowEnterNewValue">\nNew {{field.displayLabel | translate}} "{{vm.searchText[field.field]}}" will be created on save.</div></md-not-found>\n<div class="info-for-first-100-records" \nng-if="field.isAboveDropDownLimit && !(field.validation.disabledCriteria || (field.showInEdit && !field.editable && !vm.isNew))">\n<md-icon class="icon s14" md-font-icon="icon-information-outline"></md-icon><span>\n{{\'MESSAGES.CONTENT.SHOW_FIRST_100\' | translate}}</span></div></md-autocomplete></div><div \nng-switch-when="custom-lookup" class="lookup-element"><md-autocomplete id="dialog_input_{{$first ? \'first\' : $index}}" \nmd-input-name="{{field.field}}" md-selected-item="vm.record[field.field]" \nmd-items="item in vm.lookupSearch(vm.searchText[field.field], field)" md-search-text="vm.searchText[field.field]" \nmd-item-text="vm.getCustomLookupDisplayValue(item, field)" md-min-length="0" \nmd-floating-label="{{field.displayLabel | translate}}" \nmd-selected-item-change="vm.customLookupChange(vm.record[field.field], field)" ng-required="vm.isInputRequired(field)" \nmd-autofocus="$first" md-no-cache="true" tx-clear-autocomplete ng-click="vm.selectText($event)" \nmd-menu-class="autocomplete-custom" \nng-disabled="{{field.validation.disabledCriteria || (field.showInEdit && !field.editable && !vm.isNew)}}">\n<md-item-template><span class="autocomplete-item md-accent-fg" md-highlight-text="vm.searchText[field.field]" \nmd-highlight-flags="i">{{item.value}}</span> <span class="autocomplete-item color-box" \nng-show="item.ColorCode != null" ng-style="{\'background-color\': item.ColorCode}"></span></md-item-template><div \nng-messages="vm.editForm[field.field].$error" role="alert" ng-show="vm.editForm[field.field].$touched"><div \nng-message="required">{{field.validation.messages.isRequired | translate}}</div></div><md-not-found>\nNo Record matching "{{vm.searchText[field.field]}}" were found.</md-not-found><div class="info-for-first-100-records" \nng-if="field.isAboveDropDownLimit && !(field.validation.disabledCriteria || (field.showInEdit && !field.editable && !vm.isNew))">\n<md-icon class="icon s14" md-font-icon="icon-information-outline"></md-icon><span>\n{{\'MESSAGES.CONTENT.SHOW_FIRST_100\' | translate}}</span></div></md-autocomplete></div><div \nng-switch-when="multi-value"><md-input-container class="md-block"><span \nng-if="field.IsSeasonless && field.editable && !vm.isNew" class="attribute-criteria-icon"><md-tooltip><span>\n{{ \'MESSAGES.CONTENT.SEASONLESS_ATTRIBUTE_INFO_MESSAGE\' | translate }}</span></md-tooltip></span><span \nng-if="field.isCriteriaAdded" class="attribute-criteria-icon"><md-tooltip><span>{{ field.criteriaDisplayMessage }}\n</span></md-tooltip></span><label translate>{{field.displayLabel}}</label><md-chips \nid="dialog_input_{{$first ? \'first\' : $index}}" name="{{field.field}}" ng-model="vm.record[field.field]" \nmd-autocomplete-snap md-transform-chip="vm.transformChip($chip, true)" md-require-match="true" \nng-required="vm.isInputRequired(field)"><md-autocomplete md-selected-item="vm.acSelectedItem[field.field]" \nmd-search-text="vm.acSearchText[field.field]" \nmd-items="item in vm.multiValueQuerySearch(vm.acSearchText[field.field], vm.record[field.field], field)" \nmd-item-text="item" \nng-disabled="{{field.validation.disabledCriteria || (field.showInEdit && !field.editable && !vm.isNew)}}" \nmd-min-length="0" md-no-cache="true" md-selected-item-change="vm.handleFieldChange(field);" \nmd-menu-class="autocomplete-custom"><md-item-template><span class="autocomplete-item md-accent-fg" \nmd-highlight-text="vm.acSearchText[field.field]">{{item}}</span></md-item-template><md-not-found>\nNo Record matching "{{vm.acSearchText[field.field]}}" were found.</md-not-found></md-autocomplete><md-chip-template \ntx-chip="vm.existingRecords:$chip"><span><strong>{{$chip}}</strong></span></md-chip-template></md-chips><div \nclass="md-chips-messages" ng-messages="vm.editForm[field.field].$error" \nng-show="vm.editForm[field.field].$dirty || vm.editForm[field.field].$submitted"><div ng-message="required">\n{{ \'VALIDATIONS.REQUIRED\' | translate}}</div></div></md-input-container></div><div ng-switch-when="lookup-many" \nclass="lookup-element"><md-input-container class="md-block"><label>{{field.displayLabel | translate}}</label><md-chips \nid="dialog_input_{{$first ? \'first\' : $index}}" name="{{field.field}}" ng-model="vm.record[field.field]" \nmd-autocomplete-snap md-transform-chip="vm.transformChip($chip)" md-require-match="true" \nng-required="vm.isInputRequired(field)"><md-autocomplete md-selected-item="vm.acSelectedItem[field.field]" \nmd-search-text="vm.acSearchText[field.field]" \nmd-items="item in vm.acQuerySearch(vm.acSearchText[field.field], vm.record[field.field], field) | filter: field.lookupFilter" \nmd-item-text="item.value" \nng-disabled="{{field.validation.disabledCriteria || (field.showInEdit && !field.editable && !vm.isNew)}}" \nmd-min-length="0" md-no-cache="true" md-autofocus="$first" md-menu-class="autocomplete-custom"><md-item-template><span \nclass="autocomplete-item md-accent-fg" md-highlight-text="vm.acSearchText[field.field]">{{item.value}}</span>\n</md-item-template><md-not-found>No Record matching "{{vm.acSearchText[field.field]}}" were found.</md-not-found>\n</md-autocomplete><md-chip-template tx-chip="vm.existingRecords:$chip"><span><strong>\n{{ vm.getChipDisplayValue($chip, field) }}</strong></span></md-chip-template></md-chips><div class="md-chips-messages" \nng-messages="vm.editForm[field.field].$error" \nng-show="vm.editForm[field.field].$dirty || vm.editForm[field.field].$submitted"><div ng-message="required">\n{{field.validation.messages.isRequired | translate}}</div></div></md-input-container></div><div \nng-switch-when="dataset" class="lookup-element"><span ng-if="field.IsSeasonless && field.editable && !vm.isNew" \nclass="attribute-criteria-icon"><md-tooltip><span>\n{{ \'MESSAGES.CONTENT.SEASONLESS_ATTRIBUTE_INFO_MESSAGE\' | translate }}</span></md-tooltip></span>\n<tx-dataset-autocomplete tx-field="field" tx-data="vm.record" tx-new="vm.isNew"></tx-dataset-autocomplete></div><div \nng-switch-when="datatable"><span ng-if="field.IsSeasonless && field.editable && !vm.isNew" \nclass="attribute-criteria-icon"><md-tooltip><span>\n{{ \'MESSAGES.CONTENT.SEASONLESS_ATTRIBUTE_INFO_MESSAGE\' | translate }}</span></md-tooltip></span><tx-ui-grid \ntx-field="field" tx-data="vm.record" tx-new="vm.isNew" tx-editable="!field.isModelLevelAttribute"></tx-ui-grid></div>\n<div ng-switch-when="tags"><label>{{field.displayLabel | translate}}<span ng-if="vm.isInputRequired(field)" \nmd-colors="{color: \'red\'}">*</span></label><md-chips name="{{field.field}}" \nid="dialog_input_{{$first ? \'first\' : $index}}" ng-model="vm.record[field.field]" \nplaceholder="{{\'ACTIONS.ADD_TAGS\' | translate}}" secondary-placeholder="{{\'ACTIONS.ADD_TAGS\' | translate}}" \nmd-enable-chip-edit="true" md-max-chips="{{vm.maxTags}}" md-on-add="vm.add($chip, vm.record[field.field], field)" \nmd-separator-keys="vm.tagSeperatorKeys[field.field]" ng-required="vm.isInputRequired(field)" \nreadonly="field.validation.disabledCriteria || (field.showInEdit && !field.editable && !vm.isNew)"></md-chips><div \nclass="md-chips-messages" ng-messages="vm.editForm[field.field].$error" \nng-show="vm.editForm[field.field].$dirty || vm.editForm[field.field].$submitted" multiple="multiple"><div \nng-message="required">{{field.validation.messages.isRequired | translate}}</div><div ng-message="md-max-chips">\n{{field.validation.messages.maxLen | translate}}</div></div><div ng-if="vm.add($chip, vm.record[field.field], field)" \nclass="error-message display-error">{{ vm.ErrorMessage}}</div></div><div ng-switch-when="target-attributes-json-str">\n<md-input-container class="md-block"><label>{{field.displayLabel | translate}}</label><input \nid="dialog_input_{{$first ? \'first\' : $index}}" name="{{field.field}}" ng-model="vm.record[field.field]" type="text" \nng-required="vm.isInputRequired(field)" md-maxlength="{{field.validation.maxLen}}" \npattern="{{field.validation.pattern}}" \nng-disabled="{{field.validation.disabledCriteria || (field.showInEdit && !field.editable && !vm.isNew)}}" \nmd-autofocus="$first"><div ng-messages="vm.editForm[field.field].$error" role="alert" multiple="multiple"><div \nng-message="required">{{field.validation.messages.isRequired | translate}}</div><div ng-message="{{field.inputType}}">\n{{field.validation.messages.invalidType | translate}}</div><div ng-message="pattern">\n{{field.validation.messages.pattern | translate}}</div><div ng-message="md-maxlength">\n{{field.validation.messages.maxLen | translate}}</div></div></md-input-container></div><div ng-switch-when="decimal">\n<md-input-container class="md-block"><span ng-if="field.IsSeasonless && field.editable && !vm.isNew" \nclass="attribute-criteria-icon"><md-tooltip><span>\n{{ \'MESSAGES.CONTENT.SEASONLESS_ATTRIBUTE_INFO_MESSAGE\' | translate }}</span></md-tooltip></span><label>\n{{field.displayLabel | translate}}</label><input id="dialog_input_{{$first ? \'first\' : $index}}" \nname="{{field.field}}" ng-model="vm.record[field.field]" type="number" ng-required="vm.isInputRequired(field)" \nmd-maxlength="{{field.validation.maxLen}}" pattern="{{field.validation.pattern}}" \ntx-unique-value="vm.existingRecordsForUniqueValue:{{field.field}}:{{field.checkIfUnique}}" \nng-disabled="{{field.validation.disabledCriteria || (field.showInEdit && !field.editable && !vm.isNew)}}" \nmd-autofocus="$first" ng-focus="vm.currentFocusedField = field.field" ng-change="vm.handleFieldChange(field);"><div \nng-messages="vm.editForm[field.field].$error" role="alert" multiple="multiple"><div ng-message="required">\n{{field.validation.messages.isRequired | translate}}</div><div ng-message="{{field.inputType}}">\n{{field.validation.messages.invalidType | translate}}</div><div ng-message="pattern">\n{{field.validation.messages.pattern | translate}}</div><div ng-message="md-maxlength">\n{{field.validation.messages.maxLen | translate}}</div><div ng-message="tx-unique-value">\n{{\'VALIDATIONS.DUPLICATE\' | translate}}</div></div></md-input-container></div><div ng-switch-when="articlenumber" \nclass="lookup-element"><md-autocomplete id="dialog_input_{{$first ? \'first\' : $index}}" \nmd-input-name="{{field.field}}" md-selected-item="vm.record[field.field]" \nmd-items="item in vm.lookupSearch(vm.searchText[field.field], field)" md-search-text="vm.searchText[field.field]" \nmd-item-text="vm.getLookupDisplayValue(item, field, true)" md-min-length="0" \nmd-floating-label="{{field.displayLabel | translate}}" \nmd-selected-item-change="vm.lookupChange(vm.record[field.field], field.field, field)" \nng-required="vm.isInputRequired(field)" md-autofocus="$first" md-no-cache="true" tx-clear-autocomplete \nng-click="vm.selectText($event)" md-menu-class="autocomplete-custom" \nng-disabled="{{field.validation.disabledCriteria || (field.showInEdit && !field.editable && !vm.isNew)}}">\n<md-item-template><span class="autocomplete-item md-accent-fg" md-highlight-text="vm.searchText[field.field]" \nmd-highlight-flags="i">{{item.value}}</span></md-item-template><div ng-messages="vm.editForm[field.field].$error" \nrole="alert" ng-show="vm.editForm[field.field].$touched"><div ng-message="required">\n{{field.validation.messages.isRequired | translate}}</div></div><md-not-found>\nNo Record matching "{{vm.searchText[field.field]}}" were found.</md-not-found><div class="info-for-first-100-records" \nng-if="field.isAboveDropDownLimit && !(field.validation.disabledCriteria || (field.showInEdit && !field.editable && !vm.isNew))">\n<md-icon class="icon s14" md-font-icon="icon-information-outline"></md-icon><span>\n{{\'MESSAGES.CONTENT.SHOW_FIRST_100\' | translate}}</span></div></md-autocomplete></div><div \nng-switch-when="linkedcatalogarticlenumber"><label>{{field.displayLabel | translate}}</label><tx-linked-article-viewer \ntx-field="field" tx-data="vm.record" tx-new="vm.isNew"></tx-linked-article-viewer></div><div \nng-switch-when="color-palette" class="lookup-element"><span ng-if="field.IsSeasonless && field.editable && !vm.isNew" \nclass="attribute-criteria-icon"><md-tooltip><span>\n{{ \'MESSAGES.CONTENT.SEASONLESS_ATTRIBUTE_INFO_MESSAGE\' | translate }}</span></md-tooltip></span><md-autocomplete \nid="dialog_input_{{$first ? \'first\' : $index}}" md-input-name="{{field.field}}" \nmd-selected-item="vm.record[field.field]" md-items="item in vm.lookupSearch(vm.searchText[field.field], field)" \nmd-search-text="vm.searchText[field.field]" md-item-text="vm.getCustomLookupDisplayValue(item, field)" \nmd-min-length="0" md-floating-label="{{field.displayLabel | translate}}" \nmd-selected-item-change="vm.colorPaletteLookupChange(vm.record[field.field], field); vm.handleFieldChange(field)" \nng-required="vm.isInputRequired(field)" md-autofocus="$first" md-no-cache="true" tx-clear-autocomplete \nng-click="vm.selectText($event)" md-menu-class="autocomplete-custom" \nng-disabled="{{field.validation.disabledCriteria || (field.showInEdit && !field.editable && !vm.isNew)}}">\n<md-item-template><span class="autocomplete-item md-accent-fg" md-highlight-text="vm.searchText[field.field]" \nmd-highlight-flags="i">{{ vm.showColorTypeInColorPalatteDropdown ? item.ColorTypeName : item.value}}</span>\n</md-item-template><div ng-messages="vm.editForm[field.field].$error" role="alert" \nng-show="vm.editForm[field.field].$touched"><div ng-message="required">\n{{field.validation.messages.isRequired | translate}}</div></div><md-not-found>\nNo Record matching "{{vm.searchText[field.field]}}" were found.</md-not-found><div class="info-for-first-100-records" \nng-if="field.isAboveDropDownLimit && !(field.validation.disabledCriteria || (field.showInEdit && !field.editable && !vm.isNew))">\n<md-icon class="icon s14" md-font-icon="icon-information-outline"></md-icon><span>\n{{\'MESSAGES.CONTENT.SHOW_FIRST_100\' | translate}}</span></div></md-autocomplete></div><div \nng-switch-when="modelnumber" class="lookup-element"><md-autocomplete id="dialog_input_{{$first ? \'first\' : $index}}" \nmd-input-name="{{field.field}}" md-selected-item="vm.record[field.field]" \nmd-items="item in vm.lookupSearch(vm.searchText[field.field], field)" md-search-text="vm.searchText[field.field]" \nmd-item-text="vm.getLookupDisplayValue(item, field, true)" md-min-length="0" \nmd-floating-label="{{field.displayLabel | translate}}" \nmd-selected-item-change="vm.lookupChange(vm.record[field.field], field.field, field)" \nng-required="vm.isInputRequired(field)" md-autofocus="$first" md-no-cache="true" tx-clear-autocomplete \nng-click="vm.selectText($event)" md-menu-class="autocomplete-custom" \nng-disabled="{{field.validation.disabledCriteria || (field.showInEdit && !field.editable && !vm.isNew)}}">\n<md-item-template><span class="autocomplete-item md-accent-fg" md-highlight-text="vm.searchText[field.field]" \nmd-highlight-flags="i">{{item.value}}</span></md-item-template><div ng-messages="vm.editForm[field.field].$error" \nrole="alert" ng-show="vm.editForm[field.field].$touched"><div ng-message="required">\n{{field.validation.messages.isRequired | translate}}</div></div><md-not-found>\nNo Record matching "{{vm.searchText[field.field]}}" were found.</md-not-found><div class="info-for-first-100-records" \nng-if="field.isAboveDropDownLimit && !(field.validation.disabledCriteria || (field.showInEdit && !field.editable && !vm.isNew))">\n<md-icon class="icon s14" md-font-icon="icon-information-outline"></md-icon><span>\n{{\'MESSAGES.CONTENT.SHOW_FIRST_100\' | translate}}</span></div></md-autocomplete></div><div \nng-switch-when="lookup-table"><span ng-if="field.isLookupAdded" class="attribute-criteria-icon"><md-tooltip><span>\n{{ field.lookupDisplayMessage }}</span></md-tooltip></span><md-input-container class="md-block"><label>\n{{field.displayLabel | translate}}</label><input id="dialog_input_{{$first ? \'first\' : $index}}" \nname="{{field.field}}" ng-model="vm.record[field.field]" type="text" ng-required="vm.isInputRequired(field)" \nng-disabled="true" md-autofocus="$first"><div ng-messages="vm.editForm[field.field].$error" role="alert" \nmultiple="multiple"><div ng-message="required">{{field.validation.messages.isRequired | translate}}</div></div>\n</md-input-container></div><div ng-switch-when="number"><md-input-container class="md-block"><span \nng-if="field.IsSeasonless && field.editable && !vm.isNew" class="attribute-criteria-icon"><md-tooltip><span>\n{{ \'MESSAGES.CONTENT.SEASONLESS_ATTRIBUTE_INFO_MESSAGE\' | translate }}</span></md-tooltip></span><label>\n{{field.displayLabel | translate}}</label><div class="external-change-message" \nng-if="field.isAllowChangeRequestEnabled && !vm.isNew && field.updateArticleChangeManagementExternalURL !== \'\'"><span>\n{{ \'MESSAGES.CONTENT.NON_EDITABLE_STATE_ATTRIBUTE\' | translate }} <a \nhref="{{field.updateArticleChangeManagementExternalURL}}" target="_blank">here</a></span></div><input \nid="dialog_input_{{$first ? \'first\' : $index}}" name="{{field.field}}" ng-model="vm.record[field.field]" type="number" \ntx-integer-value ng-required="vm.isInputRequired(field)" md-maxlength="{{field.validation.maxLen}}" \npattern="{{field.validation.pattern}}" \ntx-unique-value="vm.existingRecordsForUniqueValue:{{field.field}}:{{field.checkIfUnique}}" \nng-disabled="{{field.validation.disabledCriteria || (field.showInEdit && !field.editable && !vm.isNew)}}" \nmd-autofocus="$first" ng-focus="vm.currentFocusedField = field.field" \nng-change="vm.handleFieldChange(field);\r\n\t\t\t\t\t\t\t\t\t\tfield.isSourceAttributeForValidation ? vm.sourceAttributeForValidationChanged(field): \'\'; field.isCriteriaDeptAttribute ? vm.criteriaDependentCriteriaAttributeChanged(field): \'\';\r\n\t\t\t\t\t\t\t\t\t\tfield.isLookupSourceAttribute ? vm.lookupSourceAttributeChanged(field): \'\';">\n<div ng-messages="vm.editForm[field.field].$error" role="alert" multiple="multiple"><div ng-message="required">\n{{field.validation.messages.isRequired | translate}}</div><div ng-message="{{field.inputType}}">\n{{field.validation.messages.invalidType | translate}}</div><div ng-message="pattern">\n{{field.validation.messages.pattern | translate}}</div><div ng-message="md-maxlength">\n{{field.validation.messages.maxLen | translate}}</div><div ng-message="tx-unique-value">\n{{\'VALIDATIONS.DUPLICATE\' | translate}}</div><div ng-message="tx-integer-value">\n{{\'VALIDATIONS.INVALID_INTEGER\' | translate}}</div></div></md-input-container></div><div ng-switch-default>\n<md-input-container class="md-block"><span ng-if="field.IsSeasonless && field.editable && !vm.isNew" \nclass="attribute-criteria-icon"><md-tooltip><span>\n{{ \'MESSAGES.CONTENT.SEASONLESS_ATTRIBUTE_INFO_MESSAGE\' | translate }}</span></md-tooltip></span><label>\n{{field.displayLabel | translate}}</label><input id="dialog_input_{{$first ? \'first\' : $index}}" \nname="{{field.field}}" ng-model="vm.record[field.field]" type="{{field.inputType}}" \nng-required="vm.isInputRequired(field)" md-maxlength="{{field.validation.maxLen}}" \npattern="{{field.validation.pattern}}" \ntx-unique-value="vm.existingRecordsForUniqueValue:{{field.field}}:{{field.checkIfUnique}}" \nng-disabled="{{field.validation.disabledCriteria || (field.showInEdit && !field.editable && !vm.isNew)}}" \nmd-autofocus="$first" ng-focus="vm.currentFocusedField = field.field" ng-change="vm.handleFieldChange(field);"><div \nng-messages="vm.editForm[field.field].$error" role="alert" multiple="multiple"><div ng-message="required">\n{{field.validation.messages.isRequired | translate}}</div><div ng-message="{{field.inputType}}">\n{{field.validation.messages.invalidType | translate}}</div><div ng-message="pattern">\n{{field.validation.messages.pattern | translate}}</div><div ng-message="md-maxlength">\n{{field.validation.messages.maxLen | translate}}</div><div ng-message="tx-unique-value">\n{{\'VALIDATIONS.DUPLICATE\' | translate}}</div></div></md-input-container></div></div></div><div layout="row" \nlayout-align="center center" ng-show="vm.checkingForLockedArticles"><md-progress-circular md-mode="indeterminate" \nclass="md-accent"></md-progress-circular></div></md-dialog-content><md-dialog-actions layout="row" \nlayout-align="end center"><div></div><div layout="row" layout-align="end center"><md-button \nng-click="vm.closeDialog(false)" class="send-button md-primary md-raised" aria-label="Cancel" \ntranslate="ACTIONS.DIALOG_CANCEL" translate-attr-aria-label="ACTIONS.DIALOG_CANCEL" ng-disabled="vm.isLoading">CANCEL\n</md-button><md-button ng-click="vm.saveRecord()" class="send-button md-accent md-raised" aria-label="Save" \ntranslate="ACTIONS.SAVE" translate-attr-aria-label="ACTIONS.SAVE" \nng-disabled="vm.isLoading || !vm.isFormValid() || vm.requiredAttributesErrorMessages.length">SAVE</md-button><md-button\n ng-click="vm.saveRecord(true)" class="send-button md-accent md-raised" aria-label="Save" \ntranslate="ACTIONS.SAVE_AND_NEW" translate-attr-aria-label="ACTIONS.SAVE_AND_NEW" \nng-disabled="vm.isLoading || !vm.isFormValid() || vm.requiredAttributesErrorMessages.length" ng-show="vm.isNew">SAVE\n</md-button></div></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/catalogs/sub-modules/articles/dialogs/create-line-plan-articles/create-line-plan-articles.html','<md-dialog aria-label="label" class="line-plan-dialog tx-dialog"><md-toolbar class="md-accent md-hue-2"><div \nclass="md-toolbar-tools" layout="row" layout-align="space-between center"><span class="title" \nng-if="vm.articleType === \'carryover\'">{{\'ARTICLES.TITLES.CREATE_CARRYOVER_ARTICLES\' | translate}}</span> <span \nclass="title" ng-if="vm.articleType === \'new\'">{{\'ARTICLES.TITLES.CREATE_COMP_ARTICLES\' | translate}}</span><md-button \nclass="md-icon-button" ng-click="vm.closeDialog()" aria-label="Close dialog" tranlate \ntranslate-aria-label="ACTIONS.DIALOG_CLOSE"><md-icon md-font-icon="icon-close"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div class="page-layout carded fullwidth list-view" layout="row" \nlayout-align="start start"><div class="center" layout="column" flex><div class="content-card" layout="column" flex>\n<tx-data-table tx-data="vm.data" tx-model="vm.model" tx-view="mainList" tx-filtered-data="vm.filteredData" \ntx-data-filter="global.search" tx-is-loading="vm.isLoading" \ntx-list-action-event="vm.doListAction(action, selectedItems)" tx-chart-view-enabled="false" \ntx-control="vm.tableControl"></tx-data-table></div></div></div></md-dialog-content></md-dialog>');
$templateCache.put('app/main/catalogs/sub-modules/articles/dialogs/create-line-plan-articles/create-single-line-plan-article.html','<md-dialog class="edit-dialog"><form name="vm.editForm" class="md-inline-form"><md-toolbar class="md-accent md-hue-2">\n<div class="md-toolbar-tools" layout="row" layout-align="space-between center"><span class="title" \ntranslate="{{\'TITLES.RECORD_NEW\'}}">New Record</span><md-button class="md-icon-button" \nng-click="vm.closeDialog(vm.isDataDirty)" aria-label="Close dialog" tranlate \ntranslate-aria-label="ACTIONS.DIALOG_CLOSE"><md-icon md-font-icon="icon-close"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div layout="row" layout-wrap><div class="import-search-container" flex \nlayout="row"><md-input-container><md-icon class="s18" md-font-icon="icon-magnify"></md-icon><input \nng-model="vm.searchPageText" type="search" placeholder="Search" md-autofocus ng-change="vm.onSearchTextChanged()">\n</md-input-container></div><div ng-repeat="field in vm.filteredVisibleFields" flex="100" \nflex-gt-xs="{{field.inputType == \'textArea\' || field.inputType == \'lookup-many\' || field.inputType == \'tags\' ? 100 : 50}}" \nclass="p-5" ng-switch="field.inputType"><div ng-switch-when="textArea"><md-input-container class="md-block"><label>\n{{field.displayLabel | translate}}</label><textarea id="dialog_input_{{$first ? \'first\' : $index}}" \nname="{{field.field}}" ng-model="vm.record[field.field]" columns="1" rows="1" ng-required="vm.isInputRequired(field)" \nmd-maxlength="{{field.validation.maxLen}}" pattern="{{field.validation.pattern}}" \nng-disabled="{{field.validation.disabledCriteria || (field.showInEdit && !field.editable)}}" md-autofocus="$first" \nng-change="vm.handleFieldChange(field);\r\n                                  field.isLookupSourceAttribute ? vm.lookupSourceAttributeChanged(field): \'\';">\n</textarea><div ng-messages="vm.editForm[field.field].$error" role="alert" multiple="multiple"><div \nng-message="required">{{field.validation.messages.isRequired | translate}}</div><div ng-message="pattern">\n{{field.validation.messages.pattern | translate}}</div><div ng-message="md-maxlength">\n{{field.validation.messages.maxLen | translate}}</div></div></md-input-container></div><div ng-switch-when="date" \nlayout="column" flex><label class="md-caption">{{field.displayLabel | translate}}</label><md-datepicker \nid="dialog_input_{{$first ? \'first\' : $index}}" name="{{field.field}}" ng-model="vm.record[field.field]" \nng-init="vm.record[field.field] = vm.getDateObj(vm.record[field.field], field)" md-placeholder="" \nng-required="vm.isInputRequired(field)" md-autofocus="$first" ng-disabled="field.validation.disabled" \nng-change="vm.handleFieldChange(field);\r\n                                      field.isLookupSourceAttribute ? vm.lookupSourceAttributeChanged(field): \'\';">\n</md-datepicker><div ng-messages="vm.editForm[field.field].$error" role="alert" multiple="multiple"><div \nng-message="required">{{field.validation.messages.isRequired | translate}}</div></div></div><div \nng-switch-when="date-without-time" layout="column" flex><label class="md-caption">{{field.displayLabel | translate}}\n</label><md-datepicker id="dialog_input_{{$first ? \'first\' : $index}}" name="{{field.field}}" \nng-model="vm.record[field.field]" ng-init="vm.record[field.field] = vm.getDateObj(vm.record[field.field], field)" \nmd-placeholder="" ng-required="vm.isInputRequired(field)" md-autofocus="$first" \nng-disabled="field.validation.disabled" \nng-change="vm.handleFieldChange(field);\r\n                          field.isLookupSourceAttribute ? vm.lookupSourceAttributeChanged(field): \'\';">\n</md-datepicker><div ng-messages="vm.editForm[field.field].$error" role="alert" multiple="multiple"><div \nng-message="required">{{field.validation.messages.isRequired | translate}}</div></div></div><div \nng-switch-when="date-option" layout="column" flex><label class="md-caption">{{field.displayLabel | translate}}</label>\n<md-datepicker id="dialog_input_{{$first ? \'first\' : $index}}" name="{{field.field}}" \nng-model="vm.record[field.field]" ng-init="vm.record[field.field] = vm.getDateObj(vm.record[field.field], field)" \nmd-placeholder="" ng-required="vm.isInputRequired(field)" md-autofocus="$first" \nng-disabled="field.validation.disabled" \nng-change="vm.handleFieldChange(field);\r\n                        field.isLookupSourceAttribute ? vm.lookupSourceAttributeChanged(field): \'\';">\n</md-datepicker><div ng-messages="vm.editForm[field.field].$error" role="alert" multiple="multiple"><div \nng-message="required">{{field.validation.messages.isRequired | translate}}</div></div></div><div \nng-switch-when="bool-str"><md-switch id="dialog_input_{{$first ? \'first\' : $index}}" ng-model="vm.record[field.field]" \naria-label="{{field.displayLabel | translate}}" \nng-disabled="{{field.validation.disabledCriteria || (field.showInEdit && !field.editable)}}" ng-true-value="\'true\'" \nng-false-value="\'false\'" class="md-accent" md-autofocus="$first" ng-change="vm.handleFieldChange(field)">\n{{field.displayLabel | translate}}</md-switch></div><div ng-switch-when="list"><md-input-container class="md-block">\n<span ng-if="field.isCriteriaAdded" class="attribute-criteria-icon"><md-tooltip><span>\n{{ field.criteriaDisplayMessage }}</span></md-tooltip></span><label>{{field.displayLabel | translate}}</label>\n<md-select id="dialog_input_{{$first ? \'first\' : $index}}" name="{{field.field}}" ng-model="vm.record[field.field]" \naria-label="{{field.displayLabel | translate}}" ng-required="vm.isInputRequired(field)" \nng-disabled="{{field.validation.disabledCriteria || (field.showInEdit && !field.editable)}}" md-autofocus="$first" \nng-focus="field.isCriteriaAdded ? vm.getConditionalVettingList(field) : \'\'" ng-change="vm.handleFieldChange(field)" \nmd-on-close="vm.clearSearchTerm(field.field)"><md-select-header><input ng-model="vm.searchValue[field.field]" \ntype="search" placeholder="Search" ng-keydown="$event.stopPropagation()"></md-select-header><md-option md-option-empty \nng-if="!field.validation.isRequired && field.type !== \'int\'" ng-value="\'\'"><em>None</em></md-option><md-option \nng-if="!field.validation.isRequired && field.type === \'int\'" ng-value="0"><em>0</em></md-option><md-option \nng-value="option" ng-repeat="option in (field.values | mdSelectUniqueoptions) | filter:vm.searchValue[field.field]">\n{{ option }}</md-option></md-select><div ng-messages="vm.editForm[field.field].$error" role="alert" \nmultiple="multiple"><div ng-message="required">{{field.validation.messages.isRequired | translate}}</div></div>\n</md-input-container></div><div ng-switch-when="multi-value"><md-input-container class="md-block"><span \nng-if="field.isCriteriaAdded" class="attribute-criteria-icon"><md-tooltip><span>{{ field.criteriaDisplayMessage }}\n</span></md-tooltip></span><label translate>{{field.displayLabel}}</label><md-chips \nid="dialog_input_{{$first ? \'first\' : $index}}" name="{{field.field}}" ng-model="vm.record[field.field]" \nmd-autocomplete-snap md-transform-chip="vm.transformChip($chip, true)" md-require-match="true" \nng-required="vm.isInputRequired(field)"><md-autocomplete md-selected-item="vm.acSelectedItem[field.field]" \nmd-search-text="vm.acSearchText[field.field]" \nmd-items="item in vm.multiValueQuerySearch(vm.acSearchText[field.field], vm.record[field.field], field)" \nmd-item-text="item" \nng-disabled="{{field.validation.disabledCriteria || (field.showInEdit && !field.editable && !vm.isNew)}}" \nmd-min-length="0" md-no-cache="true" \nmd-selected-item-change="vm.handleFieldChange(field);\r\n                                field.isLookupSourceAttribute ? vm.lookupSourceAttributeChanged(field): \'\';" \nmd-menu-class="autocomplete-custom"><md-item-template><span class="autocomplete-item md-accent-fg" \nmd-highlight-text="vm.acSearchText[field.field]">{{item}}</span></md-item-template><md-not-found>\nNo Record matching "{{vm.acSearchText[field.field]}}" were found.</md-not-found></md-autocomplete><md-chip-template \ntx-chip="vm.existingRecords:$chip"><span><strong>{{$chip}}</strong></span></md-chip-template></md-chips><div \nclass="md-chips-messages" ng-messages="vm.editForm[field.field].$error" \nng-show="vm.editForm[field.field].$dirty || vm.editForm[field.field].$submitted"><div ng-message="required">\n{{ \'VALIDATIONS.REQUIRED\' | translate}}</div></div></md-input-container></div><div ng-switch-when="decimal">\n<md-input-container class="md-block"><label>{{field.displayLabel | translate}}</label><input \nid="dialog_input_{{$first ? \'first\' : $index}}" name="{{field.field}}" ng-model="vm.record[field.field]" type="number" \nng-required="vm.isInputRequired(field)" md-maxlength="{{field.validation.maxLen}}" \npattern="{{field.validation.pattern}}" \nng-disabled="{{field.validation.disabledCriteria || (field.showInEdit && !field.editable)}}" md-autofocus="$first" \nng-change="vm.handleFieldChange(field);\r\n                              field.isLookupSourceAttribute ? vm.lookupSourceAttributeChanged(field): \'\';">\n<div ng-messages="vm.editForm[field.field].$error" role="alert" multiple="multiple"><div ng-message="required">\n{{field.validation.messages.isRequired | translate}}</div><div ng-message="{{field.inputType}}">\n{{field.validation.messages.invalidType | translate}}</div><div ng-message="pattern">\n{{field.validation.messages.pattern | translate}}</div><div ng-message="md-maxlength">\n{{field.validation.messages.maxLen | translate}}</div></div></md-input-container></div><div \nng-switch-when="articlenumber" class="lookup-element"><md-autocomplete id="dialog_input_{{$first ? \'first\' : $index}}" \nmd-input-name="{{field.field}}" md-selected-item="vm.record[field.field]" \nmd-items="item in vm.lookupSearch(vm.searchText[field.field], field)" md-search-text="vm.searchText[field.field]" \nmd-item-text="vm.getLookupDisplayValue(item, field, true)" md-min-length="0" \nmd-floating-label="{{field.displayLabel | translate}}" \nmd-selected-item-change="vm.lookupChange(vm.record[field.field], field.field)" ng-required="vm.isInputRequired(field)" \nmd-autofocus="$first" md-no-cache="true" tx-clear-autocomplete ng-click="vm.selectText($event)" \nmd-menu-class="autocomplete-custom" \nng-disabled="{{field.validation.disabledCriteria || (field.showInEdit && !field.editable && !vm.isNew)}}">\n<md-item-template><span class="autocomplete-item md-accent-fg" md-highlight-text="vm.searchText[field.field]" \nmd-highlight-flags="i">{{item.value}}</span></md-item-template><div ng-messages="vm.editForm[field.field].$error" \nrole="alert" ng-show="vm.editForm[field.field].$touched"><div ng-message="required">\n{{field.validation.messages.isRequired | translate}}</div></div><md-not-found>\nNo Record matching "{{vm.searchText[field.field]}}" were found.</md-not-found></md-autocomplete></div><div \nng-switch-when="linkedcatalogarticlenumber"><label>{{field.displayLabel | translate}}</label><tx-linked-article-viewer \ntx-field="field" tx-data="vm.record" tx-new="vm.isNew"></tx-linked-article-viewer></div><div \nng-switch-when="color-palette" class="lookup-element"><md-autocomplete id="dialog_input_{{$first ? \'first\' : $index}}" \nmd-input-name="{{field.field}}" md-selected-item="vm.record[field.field]" \nmd-items="item in vm.lookupSearch(vm.searchText[field.field], field)" md-search-text="vm.searchText[field.field]" \nmd-item-text="vm.getCustomLookupDisplayValue(item, field)" md-min-length="0" \nmd-floating-label="{{field.displayLabel | translate}}" \nmd-selected-item-change="vm.colorPaletteLookupChange(vm.record[field.field], field)" \nng-required="vm.isInputRequired(field)" md-autofocus="$first" md-no-cache="true" tx-clear-autocomplete \nng-click="vm.selectText($event)" md-menu-class="autocomplete-custom" \nng-disabled="{{field.validation.disabledCriteria || (field.showInEdit && !field.editable && !vm.isNew)}}">\n<md-item-template><span class="autocomplete-item md-accent-fg" md-highlight-text="vm.searchText[field.field]" \nmd-highlight-flags="i">{{item.value}}</span> <span class="autocomplete-item color-box" \nng-show="item.ColorCode != null && field.showColorBox" ng-style="{\'background-color\': item.ColorCode}"></span>\n</md-item-template><div ng-messages="vm.editForm[field.field].$error" role="alert" \nng-show="vm.editForm[field.field].$touched"><div ng-message="required">\n{{field.validation.messages.isRequired | translate}}</div></div><md-not-found>\nNo Record matching "{{vm.searchText[field.field]}}" were found.<div ng-if="field.allowEnterNewValue">\nNew {{field.displayLabel | translate}} "{{vm.searchText[field.field]}}" will be created on save.</div></md-not-found>\n</md-autocomplete></div><div ng-switch-when="modelnumber" class="lookup-element"><md-autocomplete \nid="dialog_input_{{$first ? \'first\' : $index}}" md-input-name="{{field.field}}" \nmd-selected-item="vm.record[field.field]" md-items="item in vm.lookupSearch(vm.searchText[field.field], field)" \nmd-search-text="vm.searchText[field.field]" md-item-text="vm.getLookupDisplayValue(item, field, true)" \nmd-min-length="0" md-floating-label="{{field.displayLabel | translate}}" \nmd-selected-item-change="vm.lookupChange(vm.record[field.field], field.field)" ng-required="vm.isInputRequired(field)" \nmd-autofocus="$first" md-no-cache="true" tx-clear-autocomplete ng-click="vm.selectText($event)" \nmd-menu-class="autocomplete-custom" \nng-disabled="{{field.validation.disabledCriteria || (field.showInEdit && !field.editable && !vm.isNew)}}">\n<md-item-template><span class="autocomplete-item md-accent-fg" md-highlight-text="vm.searchText[field.field]" \nmd-highlight-flags="i">{{item.value}}</span></md-item-template><div ng-messages="vm.editForm[field.field].$error" \nrole="alert" ng-show="vm.editForm[field.field].$touched"><div ng-message="required">\n{{field.validation.messages.isRequired | translate}}</div></div><md-not-found>\nNo Record matching "{{vm.searchText[field.field]}}" were found.</md-not-found></md-autocomplete></div><div \nng-switch-when="lookup-table"><span ng-if="field.isLookupAdded" class="attribute-criteria-icon"><md-tooltip><span>\n{{ field.lookupDisplayMessage }}</span></md-tooltip></span><md-input-container class="md-block"><label>\n{{field.displayLabel | translate}}</label><input id="dialog_input_{{$first ? \'first\' : $index}}" \nname="{{field.field}}" ng-model="vm.record[field.field]" type="text" ng-required="vm.isInputRequired(field)" \nng-disabled="true" md-autofocus="$first"><div ng-messages="vm.editForm[field.field].$error" role="alert" \nmultiple="multiple"><div ng-message="required">{{field.validation.messages.isRequired | translate}}</div></div>\n</md-input-container></div><div ng-switch-default><md-input-container class="md-block"><label>\n{{field.displayLabel | translate}}</label><input id="dialog_input_{{$first ? \'first\' : $index}}" \nname="{{field.field}}" ng-model="vm.record[field.field]" type="{{field.inputType}}" \nng-required="vm.isInputRequired(field)" md-maxlength="{{field.validation.maxLen}}" \npattern="{{field.validation.pattern}}" \nng-disabled="{{field.validation.disabledCriteria || (field.showInEdit && !field.editable)}}" md-autofocus="$first" \nng-change="vm.handleFieldChange(field);\r\n                            field.isLookupSourceAttribute ? vm.lookupSourceAttributeChanged(field): \'\';">\n<div ng-messages="vm.editForm[field.field].$error" role="alert" multiple="multiple"><div ng-message="required">\n{{field.validation.messages.isRequired | translate}}</div><div ng-message="{{field.inputType}}">\n{{field.validation.messages.invalidType | translate}}</div><div ng-message="pattern">\n{{field.validation.messages.pattern | translate}}</div><div ng-message="md-maxlength">\n{{field.validation.messages.maxLen | translate}}</div></div></md-input-container></div></div></div></md-dialog-content>\n<md-dialog-actions layout="row" layout-align="end center"><div></div><div layout="row" layout-align="end center">\n<md-button ng-click="vm.closeDialog(vm.isDataDirty)" class="send-button md-primary md-raised" aria-label="Cancel" \ntranslate="ACTIONS.DIALOG_CANCEL" translate-attr-aria-label="ACTIONS.DIALOG_CANCEL" ng-disabled="vm.isLoading">CANCEL\n</md-button><md-button ng-click="vm.saveRecord()" class="send-button md-accent md-raised" aria-label="Save" \ntranslate="ACTIONS.SAVE" translate-attr-aria-label="ACTIONS.SAVE" ng-disabled="vm.isLoading || vm.editForm.$invalid">\nSAVE</md-button></div></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/catalogs/sub-modules/articles/dialogs/manage-articles-state/manage-articles-state.html','<md-dialog class="edit-dialog" aria-label="Manage State"><form name="vm.editForm" class="md-inline-form"><md-toolbar \nclass="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" layout-align="space-between center"><span \nclass="title" translate="{{\'ARTICLES.TITLES.MANAGE_STATE\'}}">MANAGE_STATE</span><md-button class="md-icon-button" \nng-click="vm.closeDialog(vm.isDataDirty)" aria-label="Close dialog" tranlate \ntranslate-aria-label="ACTIONS.DIALOG_CLOSE"><md-icon md-font-icon="icon-close"></md-icon></md-button></div>\n</md-toolbar><div layout="row" layout-align="center center" ng-if="vm.isLoading"><md-progress-circular \nmd-mode="indeterminate" class="md-accent"></md-progress-circular></div><md-dialog-content ms-scroll \nng-if="!vm.isLoading"><div class="import-search-container" layout="row"><md-input-container flex-gt-xs="100" \nflex="100"><md-icon class="s18" md-font-icon="icon-magnify"></md-icon><input md-autofocus ng-model="vm.searchPageText" \ntype="search" ng-keydown="vm.onKeyDown($event)" placeholder="Search" md-autofocus ng-change="vm.onSearchTextChanged()">\n</md-input-container></div><div layout="row" layout-wrap><div flex="100" flex-gt-xs="50" class="p-5 lookup-element">\n<md-autocomplete id="dialog_input_1" md-input-name="StateId" md-selected-item="vm.record.StateId" \nmd-items="item in vm.searchArticleStates(vm.searchText.StateId)" md-search-text="vm.searchText.StateId" \nmd-item-text="vm.getArticleStateDisplayValue(item)" md-min-length="0" \nmd-floating-label="{{\'ARTICLES.FIELDS.STATE_NAME\' | translate}}" \nmd-selected-item-change="vm.onArticleStateChange(vm.record.StateId)" ng-required="true" md-no-cache="true" \ntx-clear-autocomplete ng-click="vm.selectText($event)" md-menu-class="autocomplete-custom"><md-item-template><span \nclass="autocomplete-item md-accent-fg" md-highlight-text="vm.searchText.StateId" md-highlight-flags="i">\n{{item.StateName}}</span></md-item-template><div ng-messages="vm.editForm.StateId.$error" role="alert" \nng-show="vm.editForm.StateId.$touched"><div ng-message="required">{{field.validation.messages.isRequired | translate}}\n</div></div><md-not-found>No Record matching "{{vm.searchText.StateId}}" were found.</md-not-found><div \nclass="info-for-first-100-records" ng-if="vm.isAboveDropDownLimit"><md-icon class="icon s14" \nmd-font-icon="icon-information-outline"></md-icon><span>{{\'MESSAGES.CONTENT.SHOW_FIRST_100\' | translate}}</span></div>\n</md-autocomplete></div><div flex="100" ng-if="vm.requiredAttributesErrorMessages.length" \nclass="error-message display-error"><div ng-repeat="message in vm.requiredAttributesErrorMessages">{{ message }}</div>\n</div><div ng-if="vm.requiredAttributesList.length && !vm.requiredAttributesErrorMessages.length">\n{{ \'ARTICLES.MESSAGES.SELECT_REQUIRED_ATTRIBUTES\' | translate }}</div><div ng-if="vm.requiredAttributesList.length" \nng-repeat="field in vm.filteredRequiredAttributesList" flex="100" \nflex-gt-xs="{{field.inputType == \'textArea\' || field.inputType == \'lookup-many\' || field.inputType == \'tags\' || field.inputType == \'color\' || field.inputType == \'datatable\' ? 100 : 50}}" \nclass="p-5" ng-switch="field.inputType" style="margin-left: 1px"><div ng-switch-when="text"><md-input-container \nclass="md-block"><span ng-if="field.IsSeasonless && field.editable && !vm.isNew" class="attribute-criteria-icon">\n<md-tooltip><span>{{ \'MESSAGES.CONTENT.SEASONLESS_ATTRIBUTE_INFO_MESSAGE\' | translate }}</span></md-tooltip></span>\n<span ng-if="field.attributeNonEditableOnStateMessage && field.attributeNonEditableOnStateMessage.length" \nclass="attribute-criteria-icon"><md-tooltip><span>{{ field.attributeNonEditableOnStateMessage }}</span></md-tooltip>\n</span><label>{{field.displayLabel | translate}}</label><input id="dialog_input_{{$first ? \'first\' : $index}}" \nname="{{field.field}}" ng-model="vm.record[field.field]" type="{{field.inputType}}" \nng-required="vm.isInputRequired(field)" md-maxlength="{{field.validation.maxLen}}" \npattern="{{field.validation.pattern}}" \ntx-unique-value="vm.existingRecordsForUniqueValue:{{field.field}}:{{field.checkIfUnique}}" \nng-focus="vm.currentFocusedField = field.field" \nng-change="vm.onRequiredAttributesChange(field.field); vm.handleFieldChange(field);" \nng-disabled="{{field.validation.disabledCriteria}}"><div ng-messages="vm.editForm[field.field].$error" role="alert" \nmultiple="multiple"><div ng-message="required">{{field.validation.messages.isRequired | translate}}</div><div \nng-message="{{field.inputType}}">{{field.validation.messages.invalidType | translate}}</div><div ng-message="pattern">\n{{field.validation.messages.pattern | translate}}</div><div ng-message="md-maxlength">\n{{field.validation.messages.maxLen | translate}}</div><div ng-message="tx-unique-value">\n{{\'VALIDATIONS.DUPLICATE\' | translate}}</div></div></md-input-container></div><div ng-switch-when="textArea">\n<md-input-container class="md-block" md-is-error="vm.editForm[field.field].$invalid"><span \nng-if="field.IsSeasonless && field.editable && !vm.isNew" class="attribute-criteria-icon"><md-tooltip><span>\n{{ \'MESSAGES.CONTENT.SEASONLESS_ATTRIBUTE_INFO_MESSAGE\' | translate }}</span></md-tooltip></span><span \nng-if="field.attributeNonEditableOnStateMessage && field.attributeNonEditableOnStateMessage.length" \nclass="attribute-criteria-icon"><md-tooltip><span>{{ field.attributeNonEditableOnStateMessage }}</span></md-tooltip>\n</span><label>{{field.displayLabel | translate}}</label><textarea id="dialog_input_{{$first ? \'first\' : $index}}" \nname="{{field.field}}" ng-model="vm.record[field.field]" columns="1" rows="1" ng-required="vm.isInputRequired(field)" \nmd-maxlength="{{field.validation.maxLen}}" pattern="{{field.validation.pattern}}" \nng-focus="vm.currentFocusedField = field.field" ng-disabled="{{field.validation.disabledCriteria}}" \nng-change="vm.onRequiredAttributesChange(field.field); vm.handleFieldChange(field);"></textarea><div \nng-messages="vm.editForm[field.field].$error" role="alert" multiple="multiple"><div ng-message="required">\n{{field.validation.messages.isRequired | translate}}</div><div ng-message="pattern">\n{{field.validation.messages.pattern | translate}}</div><div ng-message="md-maxlength">\n{{field.validation.messages.maxLen | translate}}</div><div ng-message="checkIfValidJson">\n{{field.validation.messages.isValidJson | translate}}</div></div></md-input-container></div><div ng-switch-when="date" \nlayout="column" flex><span ng-if="field.IsSeasonless && field.editable && !vm.isNew" class="attribute-criteria-icon">\n<md-tooltip><span>{{ \'MESSAGES.CONTENT.SEASONLESS_ATTRIBUTE_INFO_MESSAGE\' | translate }}</span></md-tooltip></span>\n<span ng-if="field.attributeNonEditableOnStateMessage && field.attributeNonEditableOnStateMessage.length" \nclass="attribute-criteria-icon"><md-tooltip><span>{{ field.attributeNonEditableOnStateMessage }}</span></md-tooltip>\n</span><label class="md-caption" ng-class="vm.editForm[field.field].$invalid ? \'form-date-error\': \'\'">\n{{field.displayLabel | translate}}</label><md-datepicker id="dialog_input_{{$first ? \'first\' : $index}}" \nname="{{field.field}}" ng-model="vm.record[field.field]" \nng-init="vm.record[field.field] = vm.getDateObj(vm.record[field.field])" md-placeholder="" \nng-required="vm.isInputRequired(field)" ng-focus="vm.currentFocusedField = field.field" \nng-change="vm.onRequiredAttributesChange(field.field); vm.handleFieldChange(field);"></md-datepicker><div \nng-messages="vm.editForm[field.field].$error" class="form-date-error" role="alert" multiple="multiple"><div \nng-message="required">{{field.validation.messages.isRequired | translate}}</div><div ng-message="pattern">\n{{field.validation.messages.pattern | translate}}</div></div></div><div ng-switch-when="date-without-time" \nlayout="column" flex><span ng-if="field.IsSeasonless && field.editable && !vm.isNew" class="attribute-criteria-icon">\n<md-tooltip><span>{{ \'MESSAGES.CONTENT.SEASONLESS_ATTRIBUTE_INFO_MESSAGE\' | translate }}</span></md-tooltip></span>\n<span ng-if="field.attributeNonEditableOnStateMessage && field.attributeNonEditableOnStateMessage.length" \nclass="attribute-criteria-icon"><md-tooltip><span>{{ field.attributeNonEditableOnStateMessage }}</span></md-tooltip>\n</span><label class="md-caption" ng-class="vm.editForm[field.field].$invalid ? \'form-date-error\': \'\'">\n{{field.displayLabel | translate}}</label><md-datepicker id="dialog_input_{{$first ? \'first\' : $index}}" \nname="{{field.field}}" ng-model="vm.record[field.field]" \nng-init="vm.record[field.field] = vm.getDateObj(vm.record[field.field])" md-placeholder="" \nng-required="vm.isInputRequired(field)" ng-focus="vm.currentFocusedField = field.field" \nng-change="vm.onRequiredAttributesChange(field.field); vm.handleFieldChange(field);"></md-datepicker><div \nng-messages="vm.editForm[field.field].$error" class="form-date-error" role="alert" multiple="multiple"><div \nng-message="required">{{field.validation.messages.isRequired | translate}}</div><div ng-message="pattern">\n{{field.validation.messages.pattern | translate}}</div></div></div><div ng-switch-when="date-utc" layout="column" flex>\n<label class="md-caption" ng-class="vm.editForm[field.field].$invalid ? \'form-date-error\': \'\'">\n{{field.displayLabel | translate}}</label><md-datepicker id="dialog_input_{{$first ? \'first\' : $index}}" \nname="{{field.field}}" ng-model="vm.record[field.field]" \nng-init="vm.record[field.field] = vm.getDateObj(vm.record[field.field], true)" md-placeholder="" \nng-required="vm.isInputRequired(field)" ng-focus="vm.currentFocusedField = field.field" \nng-change="vm.onRequiredAttributesChange(field.field); vm.handleFieldChange(field);"></md-datepicker><div \nng-messages="vm.editForm[field.field].$error" class="form-date-error" role="alert" multiple="multiple"><div \nng-message="required">{{field.validation.messages.isRequired | translate}}</div><div ng-message="pattern">\n{{field.validation.messages.pattern | translate}}</div></div></div><div ng-switch-when="date-option" layout="column" \nflex><span ng-if="field.IsSeasonless && field.editable && !vm.isNew" class="attribute-criteria-icon"><md-tooltip><span>\n{{ \'MESSAGES.CONTENT.SEASONLESS_ATTRIBUTE_INFO_MESSAGE\' | translate }}</span></md-tooltip></span><span \nng-if="field.attributeNonEditableOnStateMessage && field.attributeNonEditableOnStateMessage.length" \nclass="attribute-criteria-icon"><md-tooltip><span>{{ field.attributeNonEditableOnStateMessage }}</span></md-tooltip>\n</span><label class="md-caption" ng-class="vm.editForm[field.field].$invalid ? \'form-date-error\': \'\'">\n{{field.displayLabel | translate}}</label><md-datepicker id="dialog_input_{{$first ? \'first\' : $index}}" \nname="{{field.field}}" ng-model="vm.record[field.field]" \nng-init="vm.record[field.field] = vm.getDateObj(vm.record[field.field])" md-placeholder="" \nng-required="vm.isInputRequired(field)" ng-focus="vm.currentFocusedField = field.field" \nng-change="vm.onRequiredAttributesChange(field.field); vm.handleFieldChange(field);"></md-datepicker><div \nng-messages="vm.editForm[field.field].$error" class="form-date-error" role="alert" multiple="multiple"><div \nng-message="required">{{field.validation.messages.isRequired | translate}}</div><div ng-message="pattern">\n{{field.validation.messages.pattern | translate}}</div></div></div><div ng-switch-when="bool"><md-switch \nid="dialog_input_{{$first ? \'first\' : $index}}" ng-model="vm.record[field.field]" \naria-label="{{field.displayLabel | translate}}" ng-true-value="true" ng-false-value="false" class="md-accent" \nng-change="vm.onRequiredAttributesChange(field.field)">{{field.displayLabel | translate}}</md-switch></div><div \nng-switch-when="bool-str"><span ng-if="field.IsSeasonless && field.editable && !vm.isNew" \nclass="attribute-criteria-icon"><md-tooltip><span>\n{{ \'MESSAGES.CONTENT.SEASONLESS_ATTRIBUTE_INFO_MESSAGE\' | translate }}</span></md-tooltip></span><span \nng-if="field.attributeNonEditableOnStateMessage && field.attributeNonEditableOnStateMessage.length" \nclass="attribute-criteria-icon"><md-tooltip><span>{{ field.attributeNonEditableOnStateMessage }}</span></md-tooltip>\n</span><md-switch id="dialog_input_{{$first ? \'first\' : $index}}" ng-model="vm.record[field.field]" \naria-label="{{field.displayLabel | translate}}" ng-true-value="\'true\'" ng-false-value="\'false\'" class="md-accent" \nng-disabled="{{field.validation.disabledCriteria}}" \nng-change="vm.onRequiredAttributesChange(field.field);vm.handleFieldChange(field);\r\n\t\t\t\t\t\t\t">\n{{field.displayLabel | translate}}</md-switch></div><div ng-switch-when="bool-int"><md-switch \nid="dialog_input_{{$first ? \'first\' : $index}}" ng-model="vm.record[field.field]" \naria-label="{{field.displayLabel | translate}}" ng-true-value="1" ng-false-value="0" class="md-accent" \nng-change="vm.onRequiredAttributesChange(field.field)">{{field.displayLabel | translate}}</md-switch></div><div \nng-switch-when="int-bool"><md-switch id="dialog_input_{{$first ? \'first\' : $index}}" ng-model="vm.record[field.field]" \naria-label="{{field.displayLabel | translate}}" ng-true-value="1" ng-false-value="0" class="md-accent" \nng-change="vm.onRequiredAttributesChange(field.field)">{{field.displayLabel | translate}}</md-switch></div><div \nng-switch-when="list"><md-input-container class="md-block"><span \nng-if="field.IsSeasonless && field.editable && !vm.isNew" class="attribute-criteria-icon"><md-tooltip><span>\n{{ \'MESSAGES.CONTENT.SEASONLESS_ATTRIBUTE_INFO_MESSAGE\' | translate }}</span></md-tooltip></span><span \nng-if="field.isCriteriaAdded && field.criteriaDisplayMessage.length" class="attribute-criteria-icon"><md-tooltip><span>\n{{ field.criteriaDisplayMessage }}</span></md-tooltip></span><span \nng-if="field.attributeNonEditableOnStateMessage && field.attributeNonEditableOnStateMessage.length" \nclass="attribute-criteria-icon"><md-tooltip><span>{{ field.attributeNonEditableOnStateMessage }}</span></md-tooltip>\n</span><label>{{field.displayLabel | translate}}</label><md-select id="dialog_input_{{$first ? \'first\' : $index}}" \nname="{{field.field}}" ng-model="vm.record[field.field]" aria-label="{{field.displayLabel | translate}}" \nng-required="vm.isInputRequired(field)" pattern="{{field.validation.pattern}}" \nng-disabled="{{field.validation.disabledCriteria}}" \nng-focus="vm.currentFocusedField = field.field; field.isCriteriaAdded ? vm.getConditionalVettingList(field) : \'\'" \nng-change="vm.onRequiredAttributesChange(field.field);vm.handleFieldChange(field)"><md-option md-option-empty \nng-if="!field.validation.isRequired && field.type !== \'int\'" ng-value="\'\'"><em>None</em></md-option><md-option \nng-if="!field.validation.isRequired && field.type === \'int\'" ng-value="0"><em>0</em></md-option><md-option \nng-value="option" ng-repeat="option in (field.values | mdSelectUniqueoptions)">{{ option }}</md-option></md-select><div\n ng-messages="vm.editForm[field.field].$error" role="alert" multiple="multiple"><div ng-message="required">\n{{field.validation.messages.isRequired | translate}}</div><div ng-message="pattern">\n{{field.validation.messages.pattern | translate}}</div></div></md-input-container></div><div ng-switch-when="color" \nclass="color-div"><md-input-container class="md-block"><label>{{field.displayLabel | translate}}</label><div \nclass="color-palette"><span ng-repeat="color in vm.colors" ng-model="vm.record[field.field]" class="color-tag" \nng-click="vm.record[field.field] = color" ng-style="{\'background-color\': color}" \nng-class="vm.record[field.field] === color ? \'highlist-color-box\': \'\'"></span></div></md-input-container></div><div \nng-switch-when="color-picker" class="color-picker"><md-input-container class="md-block"><label>\n{{field.displayLabel | translate}}</label><input id="dialog_input_{{$first ? \'first+1\' : $index + 1}}" \nname="{{field.field}}" ng-model="vm.record[field.field]" ng-required="vm.isInputRequired(field)" \nmd-maxlength="{{field.validation.maxLen}}" pattern="{{field.validation.pattern}}" \ntx-unique-value="vm.existingRecordsForUniqueValue:{{field.field}}:{{field.checkIfUnique}}" \nng-focus="vm.currentFocusedField = field.field"><div ng-messages="vm.editForm[field.field].$error" role="alert" \nmultiple="multiple"><div ng-message="required">{{field.validation.messages.isRequired | translate}}</div><div \nng-message="{{field.inputType}}">{{field.validation.messages.invalidType | translate}}</div><div ng-message="pattern">\n{{field.validation.messages.pattern | translate}}</div><div ng-message="md-maxlength">\n{{field.validation.messages.maxLen | translate}}</div><div ng-message="tx-unique-value">\n{{\'VALIDATIONS.DUPLICATE\' | translate}}</div></div></md-input-container><input \nid="dialog_input_{{$first ? \'first\' : $index}}" class="picker" name="colorPicker" ng-model="vm.record[field.field]" \ntype="color"></div><div ng-switch-when="lookup" class="lookup-element" ng-if="field.field !== \'ModelId\'"><div \nclass="external-change-message" \nng-if="field.isAllowChangeRequestEnabled && !vm.isNew && field.updateArticleChangeManagementExternalURL !== \'\'"><span>\n{{ \'MESSAGES.CONTENT.NON_EDITABLE_STATE_ATTRIBUTE\' | translate }} <a \nhref="{{field.updateArticleChangeManagementExternalURL}}" target="_blank">here</a></span></div><span \nng-if="field.field === \'RetailIntroMonthId\' || field.field === \'RetailExitMonthId\'" class="attribute-criteria-icon">\n<md-tooltip><span>{{ field.retailMonthDisplayMessage }}</span></md-tooltip></span><span \nng-if="vm.isMasterSizeScaleObsolete && field.field === \'MasterSizeScaleId\'" class="attribute-criteria-icon">\n<md-tooltip><span>{{ \'MESSAGES.CONTENT.MASTER_SIZE_SCALE_OBSELETE\' | translate }}</span></md-tooltip></span><span \nng-if="field.attributeNonEditableOnStateMessage && field.attributeNonEditableOnStateMessage.length" \nclass="attribute-criteria-icon"><md-tooltip><span>{{ field.attributeNonEditableOnStateMessage }}</span></md-tooltip>\n</span><md-autocomplete id="dialog_input_{{$first ? \'first\' : $index}}" md-input-name="{{field.field}}" \nmd-selected-item="vm.record[field.field]" md-items="item in vm.lookupSearch(vm.searchText[field.field], field)" \nmd-search-text="vm.searchText[field.field]" md-item-text="vm.getLookupDisplayValue(item, field)" md-min-length="0" \nmd-floating-label="{{field.displayLabel | translate}}" \nmd-selected-item-change="vm.lookupChange(vm.record[field.field], field.field);vm.onRequiredAttributesChange(field.field);" \nng-required="vm.isInputRequired(field)" md-no-cache="true" tx-clear-autocomplete ng-click="vm.selectText($event)" \nmd-menu-class="autocomplete-custom" md-mode="virtual" md-on-demand="true" \nng-disabled="{{field.validation.disabledCriteria || (vm.isMasterSizeScaleObsolete && field.field === \'SizeScaleId\')}}" \nmd-item-size="50"><md-item-template><span class="autocomplete-item md-accent-fg" ng-if="field.field !== \'ColorId\'" \nmd-highlight-text="vm.searchText[field.field]" md-highlight-flags="i">{{item.value}}</span> <span \nclass="autocomplete-item md-accent-fg" ng-if="field.field === \'ColorId\'" \nmd-highlight-text="vm.searchText[field.field]" md-highlight-flags="i">\n{{ vm.showColorTypeInColorPalatteDropdown ? item.ColorTypeName : item.value}}</span> <span \nclass="autocomplete-item color-box" ng-show="item.ColorCode != null && field.showColorBox" \nng-style="{\'background-color\': item.ColorCode}"></span></md-item-template><div \nng-messages="vm.editForm[field.field].$error" role="alert" ng-show="vm.editForm[field.field].$touched"><div \nng-message="required">{{field.validation.messages.isRequired | translate}}</div></div><md-not-found>\nNo Record matching "{{vm.searchText[field.field]}}" were found.</md-not-found><div class="info-for-first-100-records" \nng-if="field.isAboveDropDownLimit && !(field.validation.disabledCriteria || (field.showInEdit && !field.editable && !vm.isNew))">\n<md-icon class="icon s14" md-font-icon="icon-information-outline"></md-icon><span>\n{{\'MESSAGES.CONTENT.SHOW_FIRST_100\' | translate}}</span></div></md-autocomplete></div><div \nng-switch-when="custom-lookup" class="lookup-element"><md-autocomplete id="dialog_input_{{$first ? \'first\' : $index}}" \nmd-input-name="{{field.field}}" md-selected-item="vm.record[field.field]" \nmd-items="item in vm.lookupSearch(vm.searchText[field.field], field)" md-search-text="vm.searchText[field.field]" \nmd-item-text="vm.getCustomLookupDisplayValue(item, field)" md-min-length="0" \nmd-floating-label="{{field.displayLabel | translate}}" \nmd-selected-item-change="vm.customLookupChange(vm.record[field.field], field);vm.onRequiredAttributesChange(field.field);" \nng-required="vm.isInputRequired(field)" md-no-cache="true" tx-clear-autocomplete ng-click="vm.selectText($event)" \nmd-menu-class="autocomplete-custom"><md-item-template><span class="autocomplete-item md-accent-fg" \nmd-highlight-text="vm.searchText[field.field]" md-highlight-flags="i">{{item.value}}</span> <span \nclass="autocomplete-item color-box" ng-show="item.ColorCode != null" ng-style="{\'background-color\': item.ColorCode}">\n</span></md-item-template><div ng-messages="vm.editForm[field.field].$error" role="alert" \nng-show="vm.editForm[field.field].$touched"><div ng-message="required">\n{{field.validation.messages.isRequired | translate}}</div></div><md-not-found>\nNo Record matching "{{vm.searchText[field.field]}}" were found.</md-not-found><div class="info-for-first-100-records" \nng-if="field.isAboveDropDownLimit && !(field.validation.disabledCriteria || (field.showInEdit && !field.editable && !vm.isNew))">\n<md-icon class="icon s14" md-font-icon="icon-information-outline"></md-icon><span>\n{{\'MESSAGES.CONTENT.SHOW_FIRST_100\' | translate}}</span></div></md-autocomplete></div><div \nng-switch-when="multi-value"><md-input-container class="md-block"><span \nng-if="field.IsSeasonless && field.editable && !vm.isNew" class="attribute-criteria-icon"><md-tooltip><span>\n{{ \'MESSAGES.CONTENT.SEASONLESS_ATTRIBUTE_INFO_MESSAGE\' | translate }}</span></md-tooltip></span><span \nng-if="field.isCriteriaAdded" class="attribute-criteria-icon"><md-tooltip><span>{{ field.criteriaDisplayMessage }}\n</span></md-tooltip></span><span \nng-if="field.attributeNonEditableOnStateMessage && field.attributeNonEditableOnStateMessage.length" \nclass="attribute-criteria-icon"><md-tooltip><span>{{ field.attributeNonEditableOnStateMessage }}</span></md-tooltip>\n</span><label translate>{{field.displayLabel}}</label><md-chips id="dialog_input_{{$first ? \'first\' : $index}}" \nname="{{field.field}}" ng-model="vm.record[field.field]" md-autocomplete-snap \nmd-transform-chip="vm.transformChip($chip, true)" md-require-match="true" ng-required="vm.isInputRequired(field)">\n<md-autocomplete md-selected-item="vm.acSelectedItem[field.field]" md-search-text="vm.acSearchText[field.field]" \nmd-items="item in vm.multiValueQuerySearch(vm.acSearchText[field.field], vm.record[field.field], field)" \nmd-item-text="item" md-min-length="0" md-no-cache="true" ng-disabled="{{field.validation.disabledCriteria}}" \nmd-selected-item-change="vm.handleFieldChange(field);\r\n\t\t\t\t\t\t\t\t\tfield.isLookupSourceAttribute ? vm.lookupSourceAttributeChanged(field): \'\';vm.onRequiredAttributesChange(field.field);" \nmd-menu-class="autocomplete-custom"><md-item-template><span class="autocomplete-item md-accent-fg" \nmd-highlight-text="vm.acSearchText[field.field]">{{item}}</span></md-item-template><md-not-found>\nNo Record matching "{{vm.acSearchText[field.field]}}" were found.</md-not-found></md-autocomplete><md-chip-template \ntx-chip="vm.existingRecords:$chip"><span><strong>{{$chip}}</strong></span></md-chip-template></md-chips><div \nclass="md-chips-messages" ng-messages="vm.editForm[field.field].$error" \nng-show="vm.editForm[field.field].$dirty || vm.editForm[field.field].$submitted"><div ng-message="required">\n{{ \'VALIDATIONS.REQUIRED\' | translate}}</div></div></md-input-container></div><div ng-switch-when="lookup-many" \nclass="lookup-element"><md-input-container class="md-block"><label>{{field.displayLabel | translate}}</label><md-chips \nid="dialog_input_{{$first ? \'first\' : $index}}" name="{{field.field}}" ng-model="vm.record[field.field]" \nmd-autocomplete-snap md-transform-chip="vm.transformChip($chip)" md-require-match="true" \nng-required="vm.isInputRequired(field)"><md-autocomplete md-selected-item="vm.acSelectedItem[field.field]" \nmd-search-text="vm.acSearchText[field.field]" \nmd-items="item in vm.acQuerySearch(vm.acSearchText[field.field], vm.record[field.field], field) | filter: field.lookupFilter" \nmd-item-text="item.value" md-min-length="0" md-no-cache="true" md-menu-class="autocomplete-custom"><md-item-template>\n<span class="autocomplete-item md-accent-fg" md-highlight-text="vm.acSearchText[field.field]">{{item.value}}</span>\n</md-item-template><md-not-found>No Record matching "{{vm.acSearchText[field.field]}}" were found.</md-not-found>\n</md-autocomplete><md-chip-template tx-chip="vm.existingRecords:$chip"><span><strong>\n{{ vm.getChipDisplayValue($chip, field) }}</strong></span></md-chip-template></md-chips><div class="md-chips-messages" \nng-messages="vm.editForm[field.field].$error" \nng-show="vm.editForm[field.field].$dirty || vm.editForm[field.field].$submitted"><div ng-message="required">\n{{field.validation.messages.isRequired | translate}}</div></div></md-input-container></div><div \nng-switch-when="dataset" class="lookup-element"><span ng-if="field.IsSeasonless && field.editable && !vm.isNew" \nclass="attribute-criteria-icon"><md-tooltip><span>\n{{ \'MESSAGES.CONTENT.SEASONLESS_ATTRIBUTE_INFO_MESSAGE\' | translate }}</span></md-tooltip></span>\n<tx-dataset-autocomplete tx-field="field" tx-data="vm.record" tx-new="vm.isNew"></tx-dataset-autocomplete></div><div \nng-switch-when="datatable"><span ng-if="field.IsSeasonless && field.editable && !vm.isNew" \nclass="attribute-criteria-icon"><md-tooltip><span>\n{{ \'MESSAGES.CONTENT.SEASONLESS_ATTRIBUTE_INFO_MESSAGE\' | translate }}</span></md-tooltip></span><tx-ui-grid \ntx-field="field" tx-data="vm.record" tx-new="vm.isNew" tx-editable="field.editable"></tx-ui-grid></div><div \nng-switch-when="tags"><label>{{field.displayLabel | translate}}<span ng-if="vm.isInputRequired(field)" \nmd-colors="{color: \'red\'}">*</span></label><md-chips name="{{field.field}}" \nid="dialog_input_{{$first ? \'first\' : $index}}" ng-model="vm.record[field.field]" \nplaceholder="{{\'ACTIONS.ADD_TAGS\' | translate}}" secondary-placeholder="{{\'ACTIONS.ADD_TAGS\' | translate}}" \nmd-enable-chip-edit="true" md-max-chips="{{vm.maxTags}}" md-on-add="vm.add($chip, vm.record[field.field], field)" \nmd-separator-keys="vm.tagSeperatorKeys[field.field]" ng-required="vm.isInputRequired(field)" \nreadonly="{{field.validation.disabledCriteria}}"></md-chips><div class="md-chips-messages" \nng-messages="vm.editForm[field.field].$error" \nng-show="vm.editForm[field.field].$dirty || vm.editForm[field.field].$submitted" multiple="multiple"><div \nng-message="required">{{field.validation.messages.isRequired | translate}}</div><div ng-message="md-max-chips">\n{{field.validation.messages.maxLen | translate}}</div></div><div ng-if="vm.add($chip, vm.record[field.field], field)" \nclass="error-message display-error">{{ vm.ErrorMessage}}</div></div><div ng-switch-when="target-attributes-json-str">\n<md-input-container class="md-block"><label>{{field.displayLabel | translate}}</label><input \nid="dialog_input_{{$first ? \'first\' : $index}}" name="{{field.field}}" ng-model="vm.record[field.field]" type="text" \nng-required="vm.isInputRequired(field)" md-maxlength="{{field.validation.maxLen}}" \npattern="{{field.validation.pattern}}"><div ng-messages="vm.editForm[field.field].$error" role="alert" \nmultiple="multiple"><div ng-message="required">{{field.validation.messages.isRequired | translate}}</div><div \nng-message="{{field.inputType}}">{{field.validation.messages.invalidType | translate}}</div><div ng-message="pattern">\n{{field.validation.messages.pattern | translate}}</div><div ng-message="md-maxlength">\n{{field.validation.messages.maxLen | translate}}</div></div></md-input-container></div><div ng-switch-when="decimal">\n<md-input-container class="md-block"><span ng-if="field.IsSeasonless && field.editable && !vm.isNew" \nclass="attribute-criteria-icon"><md-tooltip><span>\n{{ \'MESSAGES.CONTENT.SEASONLESS_ATTRIBUTE_INFO_MESSAGE\' | translate }}</span></md-tooltip></span><span \nng-if="field.attributeNonEditableOnStateMessage && field.attributeNonEditableOnStateMessage.length" \nclass="attribute-criteria-icon"><md-tooltip><span>{{ field.attributeNonEditableOnStateMessage }}</span></md-tooltip>\n</span><label>{{field.displayLabel | translate}}</label><input id="dialog_input_{{$first ? \'first\' : $index}}" \nname="{{field.field}}" ng-model="vm.record[field.field]" type="number" ng-required="vm.isInputRequired(field)" \nmd-maxlength="{{field.validation.maxLen}}" pattern="{{field.validation.pattern}}" \ntx-unique-value="vm.existingRecordsForUniqueValue:{{field.field}}:{{field.checkIfUnique}}" \nng-focus="vm.currentFocusedField = field.field" ng-disabled="{{field.validation.disabledCriteria}}" \nng-change="vm.onRequiredAttributesChange(field.field); vm.handleFieldChange(field);"><div \nng-messages="vm.editForm[field.field].$error" role="alert" multiple="multiple"><div ng-message="required">\n{{field.validation.messages.isRequired | translate}}</div><div ng-message="{{field.inputType}}">\n{{field.validation.messages.invalidType | translate}}</div><div ng-message="pattern">\n{{field.validation.messages.pattern | translate}}</div><div ng-message="md-maxlength">\n{{field.validation.messages.maxLen | translate}}</div><div ng-message="tx-unique-value">\n{{\'VALIDATIONS.DUPLICATE\' | translate}}</div></div></md-input-container></div><div ng-switch-when="articlenumber" \nclass="lookup-element"><md-autocomplete id="dialog_input_{{$first ? \'first\' : $index}}" \nmd-input-name="{{field.field}}" md-selected-item="vm.record[field.field]" \nmd-items="item in vm.lookupSearch(vm.searchText[field.field], field)" md-search-text="vm.searchText[field.field]" \nmd-item-text="vm.getLookupDisplayValue(item, field, true)" md-min-length="0" \nmd-floating-label="{{field.displayLabel | translate}}" \nmd-selected-item-change="vm.lookupChange(vm.record[field.field], field.field, field);vm.onRequiredAttributesChange(field.field);" \nng-required="vm.isInputRequired(field)" md-no-cache="true" tx-clear-autocomplete ng-click="vm.selectText($event)" \nmd-menu-class="autocomplete-custom"><md-item-template><span class="autocomplete-item md-accent-fg" \nmd-highlight-text="vm.searchText[field.field]" md-highlight-flags="i">{{item.value}}</span></md-item-template><div \nng-messages="vm.editForm[field.field].$error" role="alert" ng-show="vm.editForm[field.field].$touched"><div \nng-message="required">{{field.validation.messages.isRequired | translate}}</div></div><md-not-found>\nNo Record matching "{{vm.searchText[field.field]}}" were found.</md-not-found><div class="info-for-first-100-records" \nng-if="field.isAboveDropDownLimit && !(field.validation.disabledCriteria || (field.showInEdit && !field.editable && !vm.isNew))">\n<md-icon class="icon s14" md-font-icon="icon-information-outline"></md-icon><span>\n{{\'MESSAGES.CONTENT.SHOW_FIRST_100\' | translate}}</span></div></md-autocomplete></div><div \nng-switch-when="linkedcatalogarticlenumber"><label>{{field.displayLabel | translate}}</label><tx-linked-article-viewer \ntx-field="field" tx-data="vm.record" tx-new="vm.isNew"></tx-linked-article-viewer></div><div \nng-switch-when="color-palette" class="lookup-element"><md-autocomplete id="dialog_input_{{$first ? \'first\' : $index}}" \nmd-input-name="{{field.field}}" md-selected-item="vm.record[field.field]" \nmd-items="item in vm.lookupSearch(vm.searchText[field.field], field)" md-search-text="vm.searchText[field.field]" \nmd-item-text="vm.getCustomLookupDisplayValue(item, field)" md-min-length="0" \nmd-floating-label="{{field.displayLabel | translate}}" \nmd-selected-item-change="vm.colorPaletteLookupChange(vm.record[field.field], field);vm.onRequiredAttributesChange(field.field);" \nng-required="vm.isInputRequired(field)" md-no-cache="true" tx-clear-autocomplete \nng-disabled="{{field.validation.disabledCriteria}}" ng-click="vm.selectText($event)" \nmd-menu-class="autocomplete-custom" md-mode="virtual" md-on-demand="true" md-item-size="50"><md-item-template><span \nclass="autocomplete-item md-accent-fg" md-highlight-text="vm.searchText[field.field]" md-highlight-flags="i">\n{{ vm.showColorTypeInColorPalatteDropdown ? item.ColorTypeName : item.value}}</span></md-item-template><div \nng-messages="vm.editForm[field.field].$error" role="alert" ng-show="vm.editForm[field.field].$touched"><div \nng-message="required">{{field.validation.messages.isRequired | translate}}</div></div><md-not-found>\nNo Record matching "{{vm.searchText[field.field]}}" were found.</md-not-found><div class="info-for-first-100-records" \nng-if="field.isAboveDropDownLimit && !(field.validation.disabledCriteria || (field.showInEdit && !field.editable && !vm.isNew))">\n<md-icon class="icon s14" md-font-icon="icon-information-outline"></md-icon><span>\n{{\'MESSAGES.CONTENT.SHOW_FIRST_100\' | translate}}</span></div></md-autocomplete></div><div \nng-switch-when="modelnumber" class="lookup-element"><md-autocomplete id="dialog_input_{{$first ? \'first\' : $index}}" \nmd-input-name="{{field.field}}" md-selected-item="vm.record[field.field]" \nmd-items="item in vm.lookupSearch(vm.searchText[field.field], field)" md-search-text="vm.searchText[field.field]" \nmd-item-text="vm.getLookupDisplayValue(item, field, true)" md-min-length="0" \nmd-floating-label="{{field.displayLabel | translate}}" \nmd-selected-item-change="vm.lookupChange(vm.record[field.field], field.field, field);vm.onRequiredAttributesChange(field.field);" \nng-required="vm.isInputRequired(field)" md-no-cache="true" tx-clear-autocomplete ng-click="vm.selectText($event)" \nmd-menu-class="autocomplete-custom"><md-item-template><span class="autocomplete-item md-accent-fg" \nmd-highlight-text="vm.searchText[field.field]" md-highlight-flags="i">{{item.value}}</span></md-item-template><div \nng-messages="vm.editForm[field.field].$error" role="alert" ng-show="vm.editForm[field.field].$touched"><div \nng-message="required">{{field.validation.messages.isRequired | translate}}</div></div><md-not-found>\nNo Record matching "{{vm.searchText[field.field]}}" were found.</md-not-found><div class="info-for-first-100-records" \nng-if="field.isAboveDropDownLimit && !(field.validation.disabledCriteria || (field.showInEdit && !field.editable && !vm.isNew))">\n<md-icon class="icon s14" md-font-icon="icon-information-outline"></md-icon><span>\n{{\'MESSAGES.CONTENT.SHOW_FIRST_100\' | translate}}</span></div></md-autocomplete></div><div \nng-switch-when="lookup-table"><span ng-if="field.isLookupAdded" class="attribute-criteria-icon"><md-tooltip><span>\n{{ field.lookupDisplayMessage }}</span></md-tooltip></span><md-input-container class="md-block"><label>\n{{field.displayLabel | translate}}</label><input id="dialog_input_{{$first ? \'first\' : $index}}" \nname="{{field.field}}" ng-model="vm.record[field.field]" type="text" ng-required="vm.isInputRequired(field)" \nng-disabled="true" md-autofocus="$first"><div ng-messages="vm.editForm[field.field].$error" role="alert" \nmultiple="multiple"><div ng-message="required">{{field.validation.messages.isRequired | translate}}</div></div>\n</md-input-container></div><div ng-switch-when="number"><md-input-container class="md-block"><span \nng-if="field.IsSeasonless && field.editable && !vm.isNew" class="attribute-criteria-icon"><md-tooltip><span>\n{{ \'MESSAGES.CONTENT.SEASONLESS_ATTRIBUTE_INFO_MESSAGE\' | translate }}</span></md-tooltip></span><span \nng-if="field.attributeNonEditableOnStateMessage && field.attributeNonEditableOnStateMessage.length" \nclass="attribute-criteria-icon"><md-tooltip><span>{{ field.attributeNonEditableOnStateMessage }}</span></md-tooltip>\n</span><label>{{field.displayLabel | translate}}</label><input id="dialog_input_{{$first ? \'first\' : $index}}" \nname="{{field.field}}" ng-model="vm.record[field.field]" type="{{field.inputType}}" \nng-required="vm.isInputRequired(field)" tx-integer-value md-maxlength="{{field.validation.maxLen}}" \npattern="{{field.validation.pattern}}" \ntx-unique-value="vm.existingRecordsForUniqueValue:{{field.field}}:{{field.checkIfUnique}}" \nng-focus="vm.currentFocusedField = field.field" ng-disabled="{{field.validation.disabledCriteria}}" \nng-change="vm.onRequiredAttributesChange(field.field); vm.handleFieldChange(field);"><div \nng-messages="vm.editForm[field.field].$error" role="alert" multiple="multiple"><div ng-message="required">\n{{field.validation.messages.isRequired | translate}}</div><div ng-message="{{field.inputType}}">\n{{field.validation.messages.invalidType | translate}}</div><div ng-message="pattern">\n{{field.validation.messages.pattern | translate}}</div><div ng-message="md-maxlength">\n{{field.validation.messages.maxLen | translate}}</div><div ng-message="tx-unique-value">\n{{\'VALIDATIONS.DUPLICATE\' | translate}}</div><div ng-message="tx-integer-value">\n{{\'VALIDATIONS.INVALID_INTEGER\' | translate}}</div></div></md-input-container></div><div ng-switch-default>\n<md-input-container class="md-block"><span ng-if="field.IsSeasonless && field.editable && !vm.isNew" \nclass="attribute-criteria-icon"><md-tooltip><span>\n{{ \'MESSAGES.CONTENT.SEASONLESS_ATTRIBUTE_INFO_MESSAGE\' | translate }}</span></md-tooltip></span><span \nng-if="field.attributeNonEditableOnStateMessage && field.attributeNonEditableOnStateMessage.length" \nclass="attribute-criteria-icon"><md-tooltip><span>{{ field.attributeNonEditableOnStateMessage }}</span></md-tooltip>\n</span><label>{{field.displayLabel | translate}}</label><input id="dialog_input_{{$first ? \'first\' : $index}}" \nname="{{field.field}}" ng-model="vm.record[field.field]" type="{{field.inputType}}" \nng-required="vm.isInputRequired(field)" md-maxlength="{{field.validation.maxLen}}" \npattern="{{field.validation.pattern}}" \ntx-unique-value="vm.existingRecordsForUniqueValue:{{field.field}}:{{field.checkIfUnique}}" \nng-focus="vm.currentFocusedField = field.field" ng-disabled="{{field.validation.disabledCriteria}}" \nng-change="vm.onRequiredAttributesChange(field.field); vm.handleFieldChange(field);"><div \nng-messages="vm.editForm[field.field].$error" role="alert" multiple="multiple"><div ng-message="required">\n{{field.validation.messages.isRequired | translate}}</div><div ng-message="{{field.inputType}}">\n{{field.validation.messages.invalidType | translate}}</div><div ng-message="pattern">\n{{field.validation.messages.pattern | translate}}</div><div ng-message="md-maxlength">\n{{field.validation.messages.maxLen | translate}}</div><div ng-message="tx-unique-value">\n{{\'VALIDATIONS.DUPLICATE\' | translate}}</div></div></md-input-container></div></div></div></md-dialog-content>\n<md-dialog-actions layout="row" layout-align="end center"><div></div><div layout="row" layout-align="end center">\n<md-button ng-click="vm.closeDialog(vm.isDataDirty)" class="send-button md-primary md-raised" aria-label="Cancel" \ntranslate="ACTIONS.DIALOG_CANCEL" translate-attr-aria-label="ACTIONS.DIALOG_CANCEL" ng-disabled="vm.isLoading">CANCEL\n</md-button><md-button ng-click="vm.saveRecord()" class="send-button md-accent md-raised" aria-label="Save" \ntranslate="ACTIONS.SAVE" translate-attr-aria-label="ACTIONS.SAVE" \nng-disabled="vm.isLoading || vm.editForm.$invalid || vm.requiredAttributesErrorMessages.length || !vm.isFormDirty || !vm.isFormValid()">\nSAVE</md-button></div></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/catalogs/sub-modules/articles/dialogs/select-article-drop-reason/select-article-drop-reason.html','<md-dialog class="edit-dialog" aria-label="Confirm Drop" flex="35"><md-toolbar class="md-accent md-hue-2"><div \nclass="md-toolbar-tools" layout="row" layout-align="space-between center"><span class="title" \ntranslate="{{\'ARTICLES.TITLES.SELECT_ARTICLE_DROP_REASON\'}}">Select Article Drop Reason</span><md-button \nclass="md-icon-button" ng-click="vm.cancel(\'cancel\')" aria-label="Close dialog" tranlate \ntranslate-aria-label="ACTIONS.DIALOG_CLOSE"><md-icon md-font-icon="icon-close"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div layout="column" class="lookup-element"><md-autocomplete \nmd-input-name="DropReasonId" md-selected-item="vm.lookupModel.DropReasonId" \nmd-items="item in vm.lookupSearch(vm.searchText[\'DropReasonId\'])" md-search-text="vm.searchText[\'DropReasonId\']" \nmd-item-text="vm.getLookupDisplayValue(item)" md-min-length="0" \nmd-floating-label="{{\'ARTICLES.FIELDS.DROP_REASON\' | translate}}" md-selected-item-change="vm.lookupChange(item)" \nmd-no-cache="true" tx-clear-autocomplete tx-force-select ng-click="vm.selectText($event)" \nmd-menu-class="autocomplete-custom" ng-required="true"><md-item-template><span class="autocomplete-item md-accent-fg" \nmd-highlight-text="vm.searchText[\'DropReasonId\']" md-highlight-flags="i">{{item[\'Reason\']}}</span></md-item-template>\n<md-not-found>No Record matching "{{vm.searchText[\'DropReasonId\']}}" were found.</md-not-found></md-autocomplete></div>\n<div ng-if="vm.requiresReplacement" layout="column" class="lookup-element"><div \nng-repeat="articleRow in vm.articleRows" layout="row" layout-align="start center" flex="100"><span flex="30">\n{{articleRow.ArticleNumber}}</span><md-autocomplete flex="70" md-input-name="ReplacementArticleId_{{$index}}" \nmd-selected-item="articleRow.selectedReplacement" \nmd-items="item in vm.lookupReplacementArticles(articleRow.searchText, articleRow)" \nmd-search-text="articleRow.searchText" md-item-text="vm.getReplacementDisplayValue(item)" md-min-length="0" \nmd-floating-label="{{\'ARTICLES.FIELDS.REPLACEMENT_ARTICLE\' | translate}}" \nmd-selected-item-change="vm.replacementChange(articleRow, item)" md-no-cache="true" tx-clear-autocomplete \ntx-force-select ng-click="vm.selectText($event)" md-menu-class="autocomplete-custom" ng-required="true">\n<md-item-template><span class="autocomplete-item md-accent-fg" md-highlight-text="articleRow.searchText" \nmd-highlight-flags="i">{{item[\'ArticleNumber\']}}</span></md-item-template><md-not-found>\nNo Record matching "{{articleRow.searchText}}" were found.</md-not-found></md-autocomplete></div></div><div \nng-if="vm.requiresComment" layout="column" class="lookup-element"><md-input-container class="md-block"><label \ntranslate="ARTICLES.FIELDS.DROP_COMMENT">Comment</label><textarea ng-model="vm.dropComment" rows="1" \nmd-maxlength="1000" ng-required="vm.requiresComment"></textarea></md-input-container></div></md-dialog-content>\n<md-dialog-actions layout="row" layout-align="end center"><div></div><div layout="row" layout-align="end center">\n<md-button ng-click="vm.cancel(\'cancel\')" class="md-primary md-raised" translate="ACTIONS.DIALOG_CANCEL" \naria-label="Cancel" translate-attr-aria-label="ACTIONS.DIALOG_CANCEL">CANCEL</md-button><md-button \nng-click="vm.closeDialog()" class="md-accent md-raised" translate="ACTIONS.SAVE" aria-label="Drop" \ntranslate-attr-aria-label="{{vm.action}}" ng-disabled="vm.isSaveDisabled()">{{\'ACTIONS.SAVE\' | translate}}</md-button>\n</div></md-dialog-actions></md-dialog>');
$templateCache.put('app/main/catalogs/sub-modules/articles/dialogs/summary-report/summary-report.html','<md-dialog aria-label="label" class="summary-report-dialog tx-dialog"><md-toolbar class="md-accent md-hue-2"><div \nclass="md-toolbar-tools" layout="row" layout-align="space-between center"><span class="title">\n{{\'ARTICLES.TITLES.REPORTS\' | translate}}</span><md-button class="md-icon-button" ng-click="vm.closeDialog()" \naria-label="Close dialog" tranlate translate-aria-label="ACTIONS.DIALOG_CLOSE"><md-icon md-font-icon="icon-close">\n</md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div \nclass="page-layout carded fullwidth list-view" layout="row" layout-align="start start"><div class="center" \nlayout="column" flex><div class="content-card" layout="column" flex><tx-data-table tx-data="vm.data" \ntx-model="vm.model" tx-view="mainList" tx-filtered-data="vm.filteredData" tx-data-filter="global.search" \ntx-is-loading="vm.isLoading" tx-chart-view-enabled="false" tx-control="vm.tableControl" \ntx-hide-refresh-and-save-button="true"></tx-data-table></div></div></div></md-dialog-content></md-dialog>');
$templateCache.put('app/main/catalogs/sub-modules/catalog-models/dialogs/create-catalog-models/create-catalog-models.html','<md-dialog class="edit-dialog" aria-label="{{vm.isNew ? \'New Buyer\' : \'Edit Buyer\'}}"><form name="vm.editForm" \nclass="md-inline-form"><md-toolbar class="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" \nlayout-align="space-between center"><span class="title" \ntranslate="{{vm.isNew ? \'TITLES.RECORD_NEW\' : \'TITLES.RECORD_EDIT\'}}">Edit Record</span><md-button \nclass="md-icon-button" ng-click="vm.closeDialog(false)" aria-label="Close dialog" tranlate \ntranslate-aria-label="ACTIONS.DIALOG_CLOSE"><md-icon md-font-icon="icon-close"></md-icon></md-button></div>\n</md-toolbar><div layout="row" layout-align="center center" ng-if="vm.isLoading"><md-progress-circular \nmd-mode="indeterminate" class="md-accent"></md-progress-circular></div><md-dialog-content ms-scroll \nng-if="!vm.isLoading"><div class="import-search-container" layout="row"><md-input-container flex="100" \nflex-gt-xs="100"><md-icon class="s18" md-font-icon="icon-magnify"></md-icon><input ng-model="vm.searchPageText" \ntype="search" placeholder="Search" md-autofocus ng-change="vm.onSearchTextChanged()"></md-input-container></div><div \nlayout="row" layout-wrap class="model-switch-container"><div flex="100" flex-gt-xs="100" class="p-5 model-switch-div">\n<md-switch id="catalog_dialog_input_29" ng-model="vm.isModelFromSeller" \naria-label="{{\'MODELS.ACTIONS.ADD_FROM_EXISTING\' | translate}}" ng-true-value="true" ng-false-value="false" \nclass="md-accent" ng-change="vm.onToggleChange()">{{\'MODELS.ACTIONS.ADD_FROM_EXISTING\' | translate}}<md-tooltip \nmd-direction="right">{{\'MODELS.ACTIONS.ADD_FROM_EXISTING\' | translate}}</md-tooltip></md-switch><span \nclass="info-for-create-new-model" ng-if="vm.isModelFromSeller"><md-icon class="icon s14" \nmd-font-icon="icon-information-outline"></md-icon><span>{{\'MODELS.MESSAGES.SWITCH_TO_CREATE_NEW\' | translate}}</span>\n</span></div></div><div layout="row" layout-wrap><div ng-repeat="field in vm.filteredVisibleFields" flex="100" \nflex-gt-xs="{{field.inputType == \'textArea\' || field.inputType == \'lookup-many\' || field.inputType == \'tags\' || field.inputType == \'color\' || field.inputType == \'parent-model-type\' || field.inputType == \'datatable\' ? 100 : 50}}" \nclass="p-5" ng-switch="field.inputType" style="margin-left: 1px"><div class="lookup-element" \nng-if="field.inputType === \'lookup\' && field.field === \'ModelId\' && vm.isModelFromSeller"><md-autocomplete \nid="dialog_input_{{$first ? \'first\' : $index}}" md-input-name="{{field.field}}" \nmd-selected-item="vm.record[field.field]" md-items="item in vm.lookupSearch(vm.searchText[field.field], field)" \nmd-search-text="vm.searchText[field.field]" md-item-text="vm.getLookupDisplayValue(item, field)" md-min-length="0" \nmd-floating-label="{{field.displayLabel | translate}}" \nmd-selected-item-change="vm.lookupChange(vm.record[field.field], field.field, field)" \nng-required="vm.isInputRequired(field)" md-autofocus="$first" md-no-cache="true" tx-clear-autocomplete \nng-click="vm.selectText($event)" md-menu-class="autocomplete-custom" \nng-disabled="{{field.validation.disabledCriteria || (field.showInEdit && !field.editable && !vm.isNew)}}" \nmd-mode="virtual" md-on-demand="true" md-item-size="50"><md-item-template><span class="autocomplete-item md-accent-fg" \nmd-highlight-text="vm.searchText[field.field]" md-highlight-flags="i">{{item.value}}</span> <span \nclass="autocomplete-item color-box" ng-show="item.ColorCode != null && field.showColorBox" \nng-style="{\'background-color\': item.ColorCode}"></span></md-item-template><div \nng-messages="vm.editForm[field.field].$error" role="alert" ng-show="vm.editForm[field.field].$touched"><div \nng-message="required">{{field.validation.messages.isRequired | translate}}</div></div><md-not-found>\nNo Record matching "{{vm.searchText[field.field]}}" were found.</md-not-found><div class="info-for-first-100-records" \nng-if="field.isAboveDropDownLimit && !(field.validation.disabledCriteria || (field.showInEdit && !field.editable && !vm.isNew))">\n<md-icon class="icon s14" md-font-icon="icon-information-outline"></md-icon><span>\n{{\'MESSAGES.CONTENT.SHOW_FIRST_100\' | translate}}</span></div></md-autocomplete></div><div \nng-if="field.inputType === \'text\' && field.field === \'ModelNumber\' && vm.isModelFromSeller && !vm.isAutomaticNumberingEnabled">\n<md-input-container class="md-block"><span ng-if="field.IsSeasonless && field.editable && !vm.isNew" \nclass="attribute-criteria-icon"><md-tooltip><span>\n{{ \'MESSAGES.CONTENT.SEASONLESS_ATTRIBUTE_INFO_MESSAGE\' | translate }}</span></md-tooltip></span><label>\n{{field.displayLabel | translate}}</label><input id="dialog_input_{{$first ? \'first\' : $index}}" \nname="{{field.field}}" ng-model="vm.record[field.field]" type="{{field.inputType}}" \nng-required="vm.isInputRequired(field)" md-maxlength="{{field.validation.maxLen}}" \npattern="{{field.validation.pattern}}" \nng-disabled="{{field.validation.disabledCriteria || (field.showInEdit && !field.editable && !vm.isNew)}}" \nmd-autofocus="$first" ng-focus="vm.currentFocusedField = field.field" ng-change="vm.handleFieldChange(field);"><div \nng-messages="vm.editForm[field.field].$error" role="alert" multiple="multiple"><div ng-message="required">\n{{field.validation.messages.isRequired | translate}}</div><div ng-message="{{field.inputType}}">\n{{field.validation.messages.invalidType | translate}}</div><div ng-message="pattern">\n{{field.validation.messages.pattern | translate}}</div><div ng-message="md-maxlength">\n{{field.validation.messages.maxLen | translate}}</div></div></md-input-container></div><div ng-switch-when="textArea" \nng-if="(vm.isModelFromSeller && !field.IsSeasonlessModelAttribute) || (!vm.isModelFromSeller)"><md-input-container \nclass="md-block" md-is-error="vm.editForm[field.field].$invalid"><span \nng-if="field.IsSeasonless && field.editable && !vm.isNew" class="attribute-criteria-icon"><md-tooltip><span>\n{{ \'MESSAGES.CONTENT.SEASONLESS_ATTRIBUTE_INFO_MESSAGE\' | translate }}</span></md-tooltip></span><label>\n{{field.displayLabel | translate}}</label><textarea id="dialog_input_{{$first ? \'first\' : $index}}" \nname="{{field.field}}" ng-model="vm.record[field.field]" columns="1" rows="1" ng-required="vm.isInputRequired(field)" \nmd-maxlength="{{field.validation.maxLen}}" pattern="{{field.validation.pattern}}" \nng-focus="vm.currentFocusedField = field.field" \nng-change="vm.handleFieldChange(field);\r\n                                    field.validation.checkIfValidJson ? vm.validateJSON(field) : \'\';" \nng-disabled="{{field.validation.disabledCriteria || (field.showInEdit && !field.editable && !vm.isNew)}}" \nmd-autofocus="$first"></textarea><div ng-messages="vm.editForm[field.field].$error" role="alert" multiple="multiple">\n<div ng-message="required">{{field.validation.messages.isRequired | translate}}</div><div ng-message="pattern">\n{{field.validation.messages.pattern | translate}}</div><div ng-message="md-maxlength">\n{{field.validation.messages.maxLen | translate}}</div><div ng-message="checkIfValidJson">\n{{field.validation.messages.isValidJson | translate}}</div></div></md-input-container></div><div ng-switch-when="date" \nlayout="column" flex><span ng-if="field.IsSeasonless && field.editable && !vm.isNew" class="attribute-criteria-icon">\n<md-tooltip><span>{{ \'MESSAGES.CONTENT.SEASONLESS_ATTRIBUTE_INFO_MESSAGE\' | translate }}</span></md-tooltip></span>\n<label class="md-caption" ng-class="vm.editForm[field.field].$invalid ? \'form-date-error\': \'\'">\n{{field.displayLabel | translate}}</label><md-datepicker id="dialog_input_{{$first ? \'first\' : $index}}" \nname="{{field.field}}" ng-model="vm.record[field.field]" \nng-init="vm.record[field.field] = vm.getDateObj(vm.record[field.field])" md-placeholder="" \nng-required="vm.isInputRequired(field)" ng-focus="vm.currentFocusedField = field.field" \nng-change="vm.handleFieldChange(field);" md-autofocus="$first" ng-disabled="field.validation.disabled"></md-datepicker>\n<div ng-messages="vm.editForm[field.field].$error" class="form-date-error" role="alert" multiple="multiple"><div \nng-message="required">{{field.validation.messages.isRequired | translate}}</div><div ng-message="pattern">\n{{field.validation.messages.pattern | translate}}</div></div></div><div ng-switch-when="date-without-time" \nlayout="column" flex><span ng-if="field.IsSeasonless && field.editable && !vm.isNew" class="attribute-criteria-icon">\n<md-tooltip><span>{{ \'MESSAGES.CONTENT.SEASONLESS_ATTRIBUTE_INFO_MESSAGE\' | translate }}</span></md-tooltip></span>\n<label class="md-caption" ng-class="vm.editForm[field.field].$invalid ? \'form-date-error\': \'\'">\n{{field.displayLabel | translate}}</label><md-datepicker id="dialog_input_{{$first ? \'first\' : $index}}" \nname="{{field.field}}" ng-model="vm.record[field.field]" \nng-init="vm.record[field.field] = vm.getDateObj(vm.record[field.field])" md-placeholder="" \nng-required="vm.isInputRequired(field)" md-autofocus="$first" ng-disabled="field.validation.disabled" \nng-focus="vm.currentFocusedField = field.field" ng-change="vm.handleFieldChange(field);"></md-datepicker><div \nng-messages="vm.editForm[field.field].$error" class="form-date-error" role="alert" multiple="multiple"><div \nng-message="required">{{field.validation.messages.isRequired | translate}}</div><div ng-message="pattern">\n{{field.validation.messages.pattern | translate}}</div></div></div><div ng-switch-when="date-utc" layout="column" flex>\n<label class="md-caption" ng-class="vm.editForm[field.field].$invalid ? \'form-date-error\': \'\'">\n{{field.displayLabel | translate}}</label><md-datepicker id="dialog_input_{{$first ? \'first\' : $index}}" \nname="{{field.field}}" ng-model="vm.record[field.field]" \nng-init="vm.record[field.field] = vm.getDateObj(vm.record[field.field], true)" md-placeholder="" \nng-required="vm.isInputRequired(field)" md-autofocus="$first" ng-disabled="field.validation.disabled" \nng-focus="vm.currentFocusedField = field.field" ng-change="vm.handleFieldChange(field);"></md-datepicker><div \nng-messages="vm.editForm[field.field].$error" class="form-date-error" role="alert" multiple="multiple"><div \nng-message="required">{{field.validation.messages.isRequired | translate}}</div><div ng-message="pattern">\n{{field.validation.messages.pattern | translate}}</div></div></div><div ng-switch-when="date-option" layout="column" \nflex><span ng-if="field.IsSeasonless && field.editable && !vm.isNew" class="attribute-criteria-icon"><md-tooltip><span>\n{{ \'MESSAGES.CONTENT.SEASONLESS_ATTRIBUTE_INFO_MESSAGE\' | translate }}</span></md-tooltip></span><label \nclass="md-caption" ng-class="vm.editForm[field.field].$invalid ? \'form-date-error\': \'\'">\n{{field.displayLabel | translate}}</label><md-datepicker id="dialog_input_{{$first ? \'first\' : $index}}" \nname="{{field.field}}" ng-model="vm.record[field.field]" \nng-init="vm.record[field.field] = vm.getDateObj(vm.record[field.field])" md-placeholder="" \nng-required="vm.isInputRequired(field)" md-autofocus="$first" ng-disabled="field.validation.disabled" \nng-focus="vm.currentFocusedField = field.field" ng-change="vm.handleFieldChange(field);"></md-datepicker><div \nng-messages="vm.editForm[field.field].$error" class="form-date-error" role="alert" multiple="multiple"><div \nng-message="required">{{field.validation.messages.isRequired | translate}}</div><div ng-message="pattern">\n{{field.validation.messages.pattern | translate}}</div></div></div><div ng-switch-when="icon"></div><div \nng-switch-when="bool" ng-if="(vm.isModelFromSeller && !field.IsSeasonlessModelAttribute) || (!vm.isModelFromSeller)">\n<md-switch id="dialog_input_{{$first ? \'first\' : $index}}" ng-model="vm.record[field.field]" \naria-label="{{field.displayLabel | translate}}" \nng-disabled="{{field.validation.disabledCriteria || (field.showInEdit && !field.editable && !vm.isNew)}}" \nng-true-value="true" ng-false-value="false" class="md-accent" md-autofocus="$first">{{field.displayLabel | translate}}\n</md-switch></div><div ng-switch-when="bool-str" \nng-if="(vm.isModelFromSeller && !field.IsSeasonlessModelAttribute) || (!vm.isModelFromSeller)"><span \nng-if="field.IsSeasonless && field.editable && !vm.isNew" class="attribute-criteria-icon"><md-tooltip><span>\n{{ \'MESSAGES.CONTENT.SEASONLESS_ATTRIBUTE_INFO_MESSAGE\' | translate }}</span></md-tooltip></span><md-switch \nid="dialog_input_{{$first ? \'first\' : $index}}" ng-model="vm.record[field.field]" \naria-label="{{field.displayLabel | translate}}" \nng-disabled="{{field.validation.disabledCriteria || (field.showInEdit && !field.editable && !vm.isNew)}}" \nng-true-value="\'true\'" ng-false-value="\'false\'" class="md-accent" md-autofocus="$first" \nng-change="vm.handleFieldChange(field);">{{field.displayLabel | translate}}</md-switch></div><div \nng-switch-when="bool-int" \nng-if="(vm.isModelFromSeller && !field.IsSeasonlessModelAttribute) || (!vm.isModelFromSeller)"><md-switch \nid="dialog_input_{{$first ? \'first\' : $index}}" ng-model="vm.record[field.field]" \naria-label="{{field.displayLabel | translate}}" \nng-disabled="{{field.validation.disabledCriteria || (field.showInEdit && !field.editable && !vm.isNew)}}" \nng-true-value="1" ng-false-value="0" class="md-accent" md-autofocus="$first">{{field.displayLabel | translate}}\n</md-switch></div><div ng-switch-when="int-bool" \nng-if="(vm.isModelFromSeller && !field.IsSeasonlessModelAttribute) || (!vm.isModelFromSeller)"><md-switch \nid="dialog_input_{{$first ? \'first\' : $index}}" ng-model="vm.record[field.field]" \naria-label="{{field.displayLabel | translate}}" \nng-disabled="{{field.validation.disabledCriteria || (field.showInEdit && !field.editable && !vm.isNew)}}" \nng-true-value="1" ng-false-value="0" class="md-accent" md-autofocus="$first">{{field.displayLabel | translate}}\n</md-switch></div><div ng-switch-when="list" \nng-if="(vm.isModelFromSeller && !field.IsSeasonlessModelAttribute) || (!vm.isModelFromSeller)"><md-input-container \nclass="md-block"><span ng-if="field.IsSeasonless && field.editable && !vm.isNew" class="attribute-criteria-icon">\n<md-tooltip><span>{{ \'MESSAGES.CONTENT.SEASONLESS_ATTRIBUTE_INFO_MESSAGE\' | translate }}</span></md-tooltip></span>\n<span ng-if="field.isCriteriaAdded" class="attribute-criteria-icon"><md-tooltip><span>\n{{ field.criteriaDisplayMessage }}</span></md-tooltip></span><label>{{field.displayLabel | translate}}</label>\n<md-select id="dialog_input_{{$first ? \'first\' : $index}}" name="{{field.field}}" ng-model="vm.record[field.field]" \naria-label="{{field.displayLabel | translate}}" ng-required="vm.isInputRequired(field)" \nng-disabled="{{field.validation.disabledCriteria || (field.showInEdit && !field.editable && !vm.isNew)}}" \nmd-autofocus="$first" pattern="{{field.validation.pattern}}" \nng-focus="vm.currentFocusedField = field.field; field.isCriteriaAdded ? vm.getConditionalVettingList(field) : \'\'" \nng-change="vm.handleFieldChange(field)"><md-option md-option-empty \nng-if="!field.validation.isRequired && field.type !== \'int\'" ng-value="\'\'"><em>None</em></md-option><md-option \nng-if="!field.validation.isRequired && field.type === \'int\'" ng-value="0"><em>0</em></md-option><md-option \nng-value="option" ng-repeat="option in (field.values | mdSelectUniqueoptions)">{{ option }}</md-option></md-select><div\n ng-messages="vm.editForm[field.field].$error" role="alert" multiple="multiple"><div ng-message="required">\n{{field.validation.messages.isRequired | translate}}</div><div ng-message="pattern">\n{{field.validation.messages.pattern | translate}}</div></div></md-input-container></div><div ng-switch-when="color" \nclass="color-div" ng-if="(vm.isModelFromSeller && !field.IsSeasonlessModelAttribute) || (!vm.isModelFromSeller)">\n<md-input-container class="md-block"><label>{{field.displayLabel | translate}}</label><div class="color-palette"><span \nng-repeat="color in vm.colors" ng-model="vm.record[field.field]" class="color-tag" \nng-click="vm.record[field.field] = color" ng-style="{\'background-color\': color}" \nng-class="vm.record[field.field] === color ? \'highlist-color-box\': \'\'"></span></div></md-input-container></div><div \nng-switch-when="color-picker" class="color-picker" \nng-if="(vm.isModelFromSeller && !field.IsSeasonlessModelAttribute) || (!vm.isModelFromSeller)"><md-input-container \nclass="md-block"><label>{{field.displayLabel | translate}}</label><input \nid="dialog_input_{{$first ? \'first+1\' : $index + 1}}" name="{{field.field}}" ng-model="vm.record[field.field]" \nng-required="vm.isInputRequired(field)" md-maxlength="{{field.validation.maxLen}}" \npattern="{{field.validation.pattern}}" \nng-disabled="{{field.validation.disabledCriteria || (field.showInEdit && !field.editable && !vm.isNew)}}" \nng-focus="vm.currentFocusedField = field.field"><div ng-messages="vm.editForm[field.field].$error" role="alert" \nmultiple="multiple"><div ng-message="required">{{field.validation.messages.isRequired | translate}}</div><div \nng-message="{{field.inputType}}">{{field.validation.messages.invalidType | translate}}</div><div ng-message="pattern">\n{{field.validation.messages.pattern | translate}}</div><div ng-message="md-maxlength">\n{{field.validation.messages.maxLen | translate}}</div></div></md-input-container><input \nid="dialog_input_{{$first ? \'first\' : $index}}" class="picker" name="colorPicker" ng-model="vm.record[field.field]" \ntype="color" ng-disabled="{{field.validation.disabledCriteria || (field.showInEdit && !field.editable && !vm.isNew)}}">\n</div><div ng-switch-when="lookup" class="lookup-element" \nng-if="(field.field !== \'ModelId\') && ((vm.isModelFromSeller && !field.IsSeasonlessModelAttribute) || (!vm.isModelFromSeller))">\n<md-autocomplete id="dialog_input_{{$first ? \'first\' : $index}}" md-input-name="{{field.field}}" \nmd-selected-item="vm.record[field.field]" md-items="item in vm.lookupSearch(vm.searchText[field.field], field)" \nmd-search-text="vm.searchText[field.field]" md-item-text="vm.getLookupDisplayValue(item, field)" md-min-length="0" \nmd-floating-label="{{field.displayLabel | translate}}" \nmd-selected-item-change="vm.lookupChange(vm.record[field.field], field.field, field)" \nng-required="vm.isInputRequired(field)" md-autofocus="$first" md-no-cache="true" tx-clear-autocomplete \nng-click="vm.selectText($event)" md-menu-class="autocomplete-custom" \nng-disabled="{{field.validation.disabledCriteria || (field.showInEdit && !field.editable && !vm.isNew)}}" \nmd-mode="virtual" md-on-demand="true" md-item-size="50"><md-item-template><span class="autocomplete-item md-accent-fg" \nng-if="field.field !== \'ColorId\'" md-highlight-text="vm.searchText[field.field]" md-highlight-flags="i">{{item.value}}\n</span> <span class="autocomplete-item md-accent-fg" ng-if="field.field === \'ColorId\'" \nmd-highlight-text="vm.searchText[field.field]" md-highlight-flags="i">\n{{ vm.showColorTypeInColorPalatteDropdown ? item.ColorTypeName : item.value}}</span> <span \nclass="autocomplete-item color-box" ng-show="item.ColorCode != null && field.showColorBox" \nng-style="{\'background-color\': item.ColorCode}"></span></md-item-template><div \nng-messages="vm.editForm[field.field].$error" role="alert" ng-show="vm.editForm[field.field].$touched"><div \nng-message="required">{{field.validation.messages.isRequired | translate}}</div></div><md-not-found>\nNo Record matching "{{vm.searchText[field.field]}}" were found.</md-not-found><div class="info-for-first-100-records" \nng-if="field.isAboveDropDownLimit && !(field.validation.disabledCriteria || (field.showInEdit && !field.editable && !vm.isNew))">\n<md-icon class="icon s14" md-font-icon="icon-information-outline"></md-icon><span>\n{{\'MESSAGES.CONTENT.SHOW_FIRST_100\' | translate}}</span></div></md-autocomplete></div><div \nng-switch-when="custom-lookup" class="lookup-element" \nng-if="(vm.isModelFromSeller && !field.IsSeasonlessModelAttribute) || (!vm.isModelFromSeller)"><md-autocomplete \nid="dialog_input_{{$first ? \'first\' : $index}}" md-input-name="{{field.field}}" \nmd-selected-item="vm.record[field.field]" md-items="item in vm.lookupSearch(vm.searchText[field.field], field)" \nmd-search-text="vm.searchText[field.field]" md-item-text="vm.getCustomLookupDisplayValue(item, field)" \nmd-min-length="0" md-floating-label="{{field.displayLabel | translate}}" \nmd-selected-item-change="vm.customLookupChange(vm.record[field.field], field)" ng-required="vm.isInputRequired(field)" \nmd-autofocus="$first" md-no-cache="true" tx-clear-autocomplete ng-click="vm.selectText($event)" \nmd-menu-class="autocomplete-custom" \nng-disabled="{{field.validation.disabledCriteria || (field.showInEdit && !field.editable && !vm.isNew)}}">\n<md-item-template><span class="autocomplete-item md-accent-fg" md-highlight-text="vm.searchText[field.field]" \nmd-highlight-flags="i">{{item.value}}</span> <span class="autocomplete-item color-box" \nng-show="item.ColorCode != null" ng-style="{\'background-color\': item.ColorCode}"></span></md-item-template><div \nng-messages="vm.editForm[field.field].$error" role="alert" ng-show="vm.editForm[field.field].$touched"><div \nng-message="required">{{field.validation.messages.isRequired | translate}}</div></div><md-not-found>\nNo Record matching "{{vm.searchText[field.field]}}" were found.</md-not-found><div class="info-for-first-100-records" \nng-if="field.isAboveDropDownLimit && !(field.validation.disabledCriteria || (field.showInEdit && !field.editable && !vm.isNew))">\n<md-icon class="icon s14" md-font-icon="icon-information-outline"></md-icon><span>\n{{\'MESSAGES.CONTENT.SHOW_FIRST_100\' | translate}}</span></div></md-autocomplete></div><div \nng-switch-when="multi-value" \nng-if="(vm.isModelFromSeller && !field.IsSeasonlessModelAttribute) || (!vm.isModelFromSeller)"><md-input-container \nclass="md-block"><span ng-if="field.IsSeasonless && field.editable && !vm.isNew" class="attribute-criteria-icon">\n<md-tooltip><span>{{ \'MESSAGES.CONTENT.SEASONLESS_ATTRIBUTE_INFO_MESSAGE\' | translate }}</span></md-tooltip></span>\n<span ng-if="field.isCriteriaAdded" class="attribute-criteria-icon"><md-tooltip><span>\n{{ field.criteriaDisplayMessage }}</span></md-tooltip></span><label translate>{{field.displayLabel}}</label><md-chips \nid="dialog_input_{{$first ? \'first\' : $index}}" name="{{field.field}}" ng-model="vm.record[field.field]" \nmd-autocomplete-snap md-transform-chip="vm.transformChip($chip, true)" md-require-match="true" \nng-required="vm.isInputRequired(field)"><md-autocomplete md-selected-item="vm.acSelectedItem[field.field]" \nmd-search-text="vm.acSearchText[field.field]" \nmd-items="item in vm.multiValueQuerySearch(vm.acSearchText[field.field], vm.record[field.field], field)" \nmd-item-text="item" \nng-disabled="{{field.validation.disabledCriteria || (field.showInEdit && !field.editable && !vm.isNew)}}" \nmd-min-length="0" md-no-cache="true" md-selected-item-change="vm.handleFieldChange(field);" \nmd-menu-class="autocomplete-custom"><md-item-template><span class="autocomplete-item md-accent-fg" \nmd-highlight-text="vm.acSearchText[field.field]">{{item}}</span></md-item-template><md-not-found>\nNo Record matching "{{vm.acSearchText[field.field]}}" were found.</md-not-found></md-autocomplete><md-chip-template \ntx-chip="vm.existingRecords:$chip"><span><strong>{{$chip}}</strong></span></md-chip-template></md-chips><div \nclass="md-chips-messages" ng-messages="vm.editForm[field.field].$error" \nng-show="vm.editForm[field.field].$dirty || vm.editForm[field.field].$submitted"><div ng-message="required">\n{{ \'VALIDATIONS.REQUIRED\' | translate}}</div></div></md-input-container></div><div ng-switch-when="lookup-many" \nclass="lookup-element" ng-if="(vm.isModelFromSeller && !field.IsSeasonlessModelAttribute) || (!vm.isModelFromSeller)">\n<md-input-container class="md-block"><label>{{field.displayLabel | translate}}</label><md-chips \nid="dialog_input_{{$first ? \'first\' : $index}}" name="{{field.field}}" ng-model="vm.record[field.field]" \nmd-autocomplete-snap md-transform-chip="vm.transformChip($chip)" md-require-match="true" \nng-required="vm.isInputRequired(field)"><md-autocomplete md-selected-item="vm.acSelectedItem[field.field]" \nmd-search-text="vm.acSearchText[field.field]" \nmd-items="item in vm.acQuerySearch(vm.acSearchText[field.field], vm.record[field.field], field) | filter: field.lookupFilter" \nmd-item-text="item.value" \nng-disabled="{{field.validation.disabledCriteria || (field.showInEdit && !field.editable && !vm.isNew)}}" \nmd-min-length="0" md-no-cache="true" md-autofocus="$first" md-menu-class="autocomplete-custom"><md-item-template><span \nclass="autocomplete-item md-accent-fg" md-highlight-text="vm.acSearchText[field.field]">{{item.value}}</span>\n</md-item-template><md-not-found>No Record matching "{{vm.acSearchText[field.field]}}" were found.</md-not-found>\n</md-autocomplete><md-chip-template tx-chip="vm.existingRecords:$chip"><span><strong>\n{{ vm.getChipDisplayValue($chip, field) }}</strong></span></md-chip-template></md-chips><div class="md-chips-messages" \nng-messages="vm.editForm[field.field].$error" \nng-show="vm.editForm[field.field].$dirty || vm.editForm[field.field].$submitted"><div ng-message="required">\n{{field.validation.messages.isRequired | translate}}</div></div></md-input-container></div><div \nng-switch-when="dataset" class="lookup-element" \nng-if="(vm.isModelFromSeller && !field.IsSeasonlessModelAttribute) || (!vm.isModelFromSeller)"><span \nng-if="field.IsSeasonless && field.editable && !vm.isNew" class="attribute-criteria-icon"><md-tooltip><span>\n{{ \'MESSAGES.CONTENT.SEASONLESS_ATTRIBUTE_INFO_MESSAGE\' | translate }}</span></md-tooltip></span>\n<tx-dataset-autocomplete tx-field="field" tx-data="vm.record" tx-new="vm.isNew"></tx-dataset-autocomplete></div><div \nng-switch-when="datatable"><span ng-if="field.IsSeasonless && field.editable && !vm.isNew" \nclass="attribute-criteria-icon"><md-tooltip><span>\n{{ \'MESSAGES.CONTENT.SEASONLESS_ATTRIBUTE_INFO_MESSAGE\' | translate }}</span></md-tooltip></span><tx-ui-grid \ntx-field="field" tx-data="vm.record" tx-new="vm.isNew" tx-editable="vm.isNew || (!vm.isNew && field.editable)">\n</tx-ui-grid></div><div ng-switch-when="tags" \nng-if="(vm.isModelFromSeller && !field.IsSeasonlessModelAttribute) || (!vm.isModelFromSeller)"><label>\n{{field.displayLabel | translate}} <span ng-if="vm.isInputRequired(field)">*</span></label><md-chips \nname="{{field.field}}" id="dialog_input_{{$first ? \'first\' : $index}}" ng-model="vm.record[field.field]" \nplaceholder="{{\'ACTIONS.ADD_TAGS\' | translate}}" secondary-placeholder="{{\'ACTIONS.ADD_TAGS\' | translate}}" \nmd-enable-chip-edit="vm.isNew || (field.showInEdit && !field.editable && !vm.isNew)" md-max-chips="{{vm.maxTags}}" \nmd-on-add="vm.add($chip, vm.record[field.field], field)" md-separator-keys="vm.tagSeperatorKeys[field.field]" \nng-required="vm.isInputRequired(field)" \nreadonly="field.validation.disabledCriteria || (field.showInEdit && !field.editable && !vm.isNew)"></md-chips><div \nclass="md-chips-messages" ng-messages="vm.editForm[field.field].$error" \nng-show="vm.editForm[field.field].$dirty || vm.editForm[field.field].$submitted" multiple="multiple"><div \nng-message="required">{{field.validation.messages.isRequired | translate}}</div><div ng-message="md-max-chips">\n{{field.validation.messages.maxLen | translate}}</div></div><div ng-if="vm.add($chip, vm.record[field.field], field)" \nclass="error-message display-error">{{ vm.ErrorMessage}}</div></div><div ng-switch-when="target-attributes-json-str" \nng-if="(vm.isModelFromSeller && !field.IsSeasonlessModelAttribute) || (!vm.isModelFromSeller)"><md-input-container \nclass="md-block"><label>{{field.displayLabel | translate}}</label><input \nid="dialog_input_{{$first ? \'first\' : $index}}" name="{{field.field}}" ng-model="vm.record[field.field]" type="text" \nng-required="vm.isInputRequired(field)" md-maxlength="{{field.validation.maxLen}}" \npattern="{{field.validation.pattern}}" \nng-disabled="{{field.validation.disabledCriteria || (field.showInEdit && !field.editable && !vm.isNew)}}" \nmd-autofocus="$first"><div ng-messages="vm.editForm[field.field].$error" role="alert" multiple="multiple"><div \nng-message="required">{{field.validation.messages.isRequired | translate}}</div><div ng-message="{{field.inputType}}">\n{{field.validation.messages.invalidType | translate}}</div><div ng-message="pattern">\n{{field.validation.messages.pattern | translate}}</div><div ng-message="md-maxlength">\n{{field.validation.messages.maxLen | translate}}</div></div></md-input-container></div><div ng-switch-when="decimal" \nng-if="(vm.isModelFromSeller && !field.IsSeasonlessModelAttribute) || (!vm.isModelFromSeller)"><md-input-container \nclass="md-block"><span ng-if="field.IsSeasonless && field.editable && !vm.isNew" class="attribute-criteria-icon">\n<md-tooltip><span>{{ \'MESSAGES.CONTENT.SEASONLESS_ATTRIBUTE_INFO_MESSAGE\' | translate }}</span></md-tooltip></span>\n<label>{{field.displayLabel | translate}}</label><input id="dialog_input_{{$first ? \'first\' : $index}}" \nname="{{field.field}}" ng-model="vm.record[field.field]" type="number" ng-required="vm.isInputRequired(field)" \nmd-maxlength="{{field.validation.maxLen}}" pattern="{{field.validation.pattern}}" \nng-disabled="{{field.validation.disabledCriteria || (field.showInEdit && !field.editable && !vm.isNew)}}" \nmd-autofocus="$first" ng-focus="vm.currentFocusedField = field.field" ng-change="vm.handleFieldChange(field);"><div \nng-messages="vm.editForm[field.field].$error" role="alert" multiple="multiple"><div ng-message="required">\n{{field.validation.messages.isRequired | translate}}</div><div ng-message="{{field.inputType}}">\n{{field.validation.messages.invalidType | translate}}</div><div ng-message="pattern">\n{{field.validation.messages.pattern | translate}}</div><div ng-message="md-maxlength">\n{{field.validation.messages.maxLen | translate}}</div></div></md-input-container></div><div \nng-switch-when="articlenumber" class="lookup-element" \nng-if="(vm.isModelFromSeller && !field.IsSeasonlessModelAttribute) || (!vm.isModelFromSeller)"><md-autocomplete \nid="dialog_input_{{$first ? \'first\' : $index}}" md-input-name="{{field.field}}" \nmd-selected-item="vm.record[field.field]" md-items="item in vm.lookupSearch(vm.searchText[field.field], field)" \nmd-search-text="vm.searchText[field.field]" md-item-text="vm.getLookupDisplayValue(item, field, true)" \nmd-min-length="0" md-floating-label="{{field.displayLabel | translate}}" \nmd-selected-item-change="vm.lookupChange(vm.record[field.field], field.field, field)" \nng-required="vm.isInputRequired(field)" md-autofocus="$first" md-no-cache="true" tx-clear-autocomplete \nng-click="vm.selectText($event)" md-menu-class="autocomplete-custom" \nng-disabled="{{field.validation.disabledCriteria || (field.showInEdit && !field.editable && !vm.isNew)}}">\n<md-item-template><span class="autocomplete-item md-accent-fg" md-highlight-text="vm.searchText[field.field]" \nmd-highlight-flags="i">{{item.value}}</span></md-item-template><div ng-messages="vm.editForm[field.field].$error" \nrole="alert" ng-show="vm.editForm[field.field].$touched"><div ng-message="required">\n{{field.validation.messages.isRequired | translate}}</div></div><md-not-found>\nNo Record matching "{{vm.searchText[field.field]}}" were found.</md-not-found><div class="info-for-first-100-records" \nng-if="field.isAboveDropDownLimit && !(field.validation.disabledCriteria || (field.showInEdit && !field.editable && !vm.isNew))">\n<md-icon class="icon s14" md-font-icon="icon-information-outline"></md-icon><span>\n{{\'MESSAGES.CONTENT.SHOW_FIRST_100\' | translate}}</span></div></md-autocomplete></div><div \nng-switch-when="linkedcatalogarticlenumber" \nng-if="(vm.isModelFromSeller && !field.IsSeasonlessModelAttribute) || (!vm.isModelFromSeller)"><label>\n{{field.displayLabel | translate}}</label><tx-linked-article-viewer tx-field="field" tx-data="vm.record" \ntx-new="vm.isNew"></tx-linked-article-viewer></div><div ng-switch-when="color-palette" class="lookup-element" \nng-if="(vm.isModelFromSeller && !field.IsSeasonlessModelAttribute) || (!vm.isModelFromSeller)"><md-autocomplete \nid="dialog_input_{{$first ? \'first\' : $index}}" md-input-name="{{field.field}}" \nmd-selected-item="vm.record[field.field]" md-items="item in vm.lookupSearch(vm.searchText[field.field], field)" \nmd-search-text="vm.searchText[field.field]" md-item-text="vm.getCustomLookupDisplayValue(item, field)" \nmd-min-length="0" md-floating-label="{{field.displayLabel | translate}}" \nmd-selected-item-change="vm.customLookupChange(vm.record[field.field], field)" ng-required="vm.isInputRequired(field)" \nmd-autofocus="$first" md-no-cache="true" tx-clear-autocomplete ng-click="vm.selectText($event)" \nmd-menu-class="autocomplete-custom" \nng-disabled="{{field.validation.disabledCriteria || (field.showInEdit && !field.editable && !vm.isNew)}}" \nmd-mode="virtual" md-on-demand="true" md-item-size="50"><md-item-template><span class="autocomplete-item md-accent-fg" \nmd-highlight-text="vm.searchText[field.field]" md-highlight-flags="i">\n{{ vm.showColorTypeInColorPalatteDropdown ? item.ColorTypeName : item.value}}</span></md-item-template><div \nng-messages="vm.editForm[field.field].$error" role="alert" ng-show="vm.editForm[field.field].$touched"><div \nng-message="required">{{field.validation.messages.isRequired | translate}}</div></div><md-not-found>\nNo Record matching "{{vm.searchText[field.field]}}" were found.</md-not-found><div class="info-for-first-100-records" \nng-if="field.isAboveDropDownLimit && !(field.validation.disabledCriteria || (field.showInEdit && !field.editable && !vm.isNew))">\n<md-icon class="icon s14" md-font-icon="icon-information-outline"></md-icon><span>\n{{\'MESSAGES.CONTENT.SHOW_FIRST_100\' | translate}}</span></div></md-autocomplete></div><div \nng-switch-when="modelnumber" class="lookup-element" \nng-if="(vm.isModelFromSeller && !field.IsSeasonlessModelAttribute) || (!vm.isModelFromSeller)"><md-autocomplete \nid="dialog_input_{{$first ? \'first\' : $index}}" md-input-name="{{field.field}}" \nmd-selected-item="vm.record[field.field]" md-items="item in vm.lookupSearch(vm.searchText[field.field], field)" \nmd-search-text="vm.searchText[field.field]" md-item-text="vm.getLookupDisplayValue(item, field, true)" \nmd-min-length="0" md-floating-label="{{field.displayLabel | translate}}" \nmd-selected-item-change="vm.lookupChange(vm.record[field.field], field.field, field)" \nng-required="vm.isInputRequired(field)" md-autofocus="$first" md-no-cache="true" tx-clear-autocomplete \nng-click="vm.selectText($event)" md-menu-class="autocomplete-custom" \nng-disabled="{{field.validation.disabledCriteria || (field.showInEdit && !field.editable && !vm.isNew)}}">\n<md-item-template><span class="autocomplete-item md-accent-fg" md-highlight-text="vm.searchText[field.field]" \nmd-highlight-flags="i">{{item.value}}</span></md-item-template><div ng-messages="vm.editForm[field.field].$error" \nrole="alert" ng-show="vm.editForm[field.field].$touched"><div ng-message="required">\n{{field.validation.messages.isRequired | translate}}</div></div><md-not-found>\nNo Record matching "{{vm.searchText[field.field]}}" were found.</md-not-found><div class="info-for-first-100-records" \nng-if="field.isAboveDropDownLimit && !(field.validation.disabledCriteria || (field.showInEdit && !field.editable && !vm.isNew))">\n<md-icon class="icon s14" md-font-icon="icon-information-outline"></md-icon><span>\n{{\'MESSAGES.CONTENT.SHOW_FIRST_100\' | translate}}</span></div></md-autocomplete></div><div \nng-switch-when="parent-model-type" \nng-if="(vm.isModelFromSeller && !field.IsSeasonlessModelAttribute) || (!vm.isModelFromSeller)">\n<tx-parent-model-type-viewer tx-field="field" tx-data="vm.record" tx-new="vm.isNew" \ntx-visible-fields="vm.visibleFields"></tx-parent-model-type-viewer></div><div ng-switch-when="lookup-table"><span \nng-if="field.isLookupAdded" class="attribute-criteria-icon"><md-tooltip><span>{{ field.lookupDisplayMessage }}</span>\n</md-tooltip></span><md-input-container class="md-block"><label>{{field.displayLabel | translate}}</label><input \nid="dialog_input_{{$first ? \'first\' : $index}}" name="{{field.field}}" ng-model="vm.record[field.field]" type="text" \nng-required="vm.isInputRequired(field)" ng-disabled="true" md-autofocus="$first"><div \nng-messages="vm.editForm[field.field].$error" role="alert" multiple="multiple"><div ng-message="required">\n{{field.validation.messages.isRequired | translate}}</div></div></md-input-container></div><div \nng-switch-when="number" \nng-if="(field.field === \'ModelNumber\' && vm.isModelFromSeller && !vm.isAutomaticNumberingEnabled) || (field.field !== \'ModelNumber\' && ((vm.isModelFromSeller && !field.IsSeasonlessModelAttribute) || !vm.isModelFromSeller))">\n<md-input-container class="md-block"><span ng-if="field.IsSeasonless && field.editable && !vm.isNew" \nclass="attribute-criteria-icon"><md-tooltip><span>\n{{ \'MESSAGES.CONTENT.SEASONLESS_ATTRIBUTE_INFO_MESSAGE\' | translate }}</span></md-tooltip></span><label>\n{{field.displayLabel | translate}}</label><input id="dialog_input_{{$first ? \'first\' : $index}}" \nname="{{field.field}}" ng-model="vm.record[field.field]" type="{{field.inputType}}" tx-integer-value \nng-required="vm.isInputRequired(field)" md-maxlength="{{field.validation.maxLen}}" \npattern="{{field.validation.pattern}}" \nng-disabled="field.validation.disabledCriteria || (field.field === \'ModelName\' && vm.isModelFromSeller)" \nmd-autofocus="$first" ng-focus="vm.currentFocusedField = field.field" ng-change="vm.handleFieldChange(field);"><div \nng-messages="vm.editForm[field.field].$error" role="alert" multiple="multiple"><div ng-message="required">\n{{field.validation.messages.isRequired | translate}}</div><div ng-message="{{field.inputType}}">\n{{field.validation.messages.invalidType | translate}}</div><div ng-message="pattern">\n{{field.validation.messages.pattern | translate}}</div><div ng-message="md-maxlength">\n{{field.validation.messages.maxLen | translate}}</div><div ng-message="tx-integer-value">\n{{\'VALIDATIONS.INVALID_INTEGER\' | translate}}</div></div></md-input-container></div><div ng-switch-default \nng-if="(field.field === \'ModelNumber\' && vm.isModelFromSeller && !vm.isAutomaticNumberingEnabled) || (field.field !== \'ModelNumber\' && ((vm.isModelFromSeller && !field.IsSeasonlessModelAttribute) || !vm.isModelFromSeller))">\n<md-input-container class="md-block"><span ng-if="field.IsSeasonless && field.editable && !vm.isNew" \nclass="attribute-criteria-icon"><md-tooltip><span>\n{{ \'MESSAGES.CONTENT.SEASONLESS_ATTRIBUTE_INFO_MESSAGE\' | translate }}</span></md-tooltip></span><label>\n{{field.displayLabel | translate}}</label><input id="dialog_input_{{$first ? \'first\' : $index}}" \nname="{{field.field}}" ng-model="vm.record[field.field]" type="{{field.inputType}}" \nng-required="vm.isInputRequired(field)" md-maxlength="{{field.validation.maxLen}}" \npattern="{{field.validation.pattern}}" \nng-disabled="field.validation.disabledCriteria || (field.field === \'ModelName\' && vm.isModelFromSeller)" \nmd-autofocus="$first" ng-focus="vm.currentFocusedField = field.field" ng-change="vm.handleFieldChange(field);"><div \nng-messages="vm.editForm[field.field].$error" role="alert" multiple="multiple"><div ng-message="required">\n{{field.validation.messages.isRequired | translate}}</div><div ng-message="{{field.inputType}}">\n{{field.validation.messages.invalidType | translate}}</div><div ng-message="pattern">\n{{field.validation.messages.pattern | translate}}</div><div ng-message="md-maxlength">\n{{field.validation.messages.maxLen | translate}}</div></div></md-input-container></div></div></div></md-dialog-content>\n<md-dialog-actions layout="row" layout-align="end center"><div></div><div layout="row" layout-align="end center">\n<md-button ng-click="vm.closeDialog(false)" class="send-button md-primary md-raised" aria-label="Cancel" \ntranslate="ACTIONS.DIALOG_CANCEL" translate-attr-aria-label="ACTIONS.DIALOG_CANCEL" ng-disabled="vm.isLoading">CANCEL\n</md-button><md-button ng-click="vm.saveRecord()" class="send-button md-accent md-raised" aria-label="Save" \ntranslate="ACTIONS.SAVE" translate-attr-aria-label="ACTIONS.SAVE" ng-disabled="vm.isLoading || !vm.isFormValid()">SAVE\n</md-button></div></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/catalogs/sub-modules/consolidation-templates/dialogs/copy-templates/copy-templates.html','<md-dialog class="edit-dialog" aria-label="Copy Templates"><form name="vm.editForm" class="md-inline-form"><md-toolbar \nclass="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" layout-align="space-between center"><span \nclass="title" translate="CONSOLIDATION_TEMPLATES.ACTIONS.COPY_TEMPLATES">Copy Templates</span><md-button \nclass="md-icon-button" ng-click="vm.closeDialog(vm.isDataDirty)" aria-label="Close dialog" tranlate \ntranslate-aria-label="ACTIONS.DIALOG_CLOSE"><md-icon md-font-icon="icon-close"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div layout="row" layout-wrap><div flex="100" flex-gt-xs="50" \nclass="p-5 lookup-element"><md-autocomplete id="dialog_input_1" md-input-name="CatalogCode" \nmd-selected-item="vm.lookupModel.SourceCatalogCode" \nmd-items="item in vm.lookupSearch(vm.searchText.SourceCatalogCode, \'CatalogCode\')" \nmd-search-text="vm.searchText.SourceCatalogCode" md-item-text="vm.getLookupDisplayValue(item, \'catalogs.catalogs\')" \nmd-min-length="0" md-floating-label="{{\'CONSOLIDATION_TEMPLATES.FIELDS.CATALOG_CODE\' | translate}}" ng-required="true" \nmd-no-cache="true" tx-clear-autocomplete ng-click="vm.selectText($event)" \nmd-selected-item-change="vm.onLookupChange(vm.lookupModel.SourceCatalogCode, \'SourceCatalogCode\')" \nmd-menu-class="autocomplete-custom"><md-item-template><span class="autocomplete-item md-accent-fg" \nmd-highlight-text="vm.searchText.SourceCatalogCode" md-highlight-flags="i">{{item.value}}</span></md-item-template>\n<md-not-found>No Record matching "{{vm.searchText.SourceCatalogCode}}" were found.</md-not-found><div \nng-messages="vm.editForm.SourceCatalogCode.$error" role="alert" ng-show="vm.editForm.SourceCatalogCode.$touched" \nmultiple="multiple"><div ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div></div></md-autocomplete>\n</div><div flex="100" class="p-5 lookup-element"><md-input-container class="md-block"><label>\n{{\'CONSOLIDATION_TEMPLATES.FIELDS.TEMPLATES\' | translate}}*</label><md-chips id="dialog_input_2" name="TemplateIds" \nng-model="vm.record.TemplateIds" md-autocomplete-snap md-transform-chip="vm.transformChip($chip, \'TemplateIds\')" \nmd-require-match="true" ng-required="true"><md-autocomplete md-selected-item="vm.acSelectedItem.TemplateIds" \nmd-search-text="vm.acSearchText.TemplateIds" \nmd-items="item in vm.acQuerySearch(vm.acSearchText.TemplateIds, vm.record.TemplateIds)" md-item-text="item.Name" \nng-disabled="vm.record.SourceCatalogCode == null" md-min-length="0" md-no-cache="true" \nmd-menu-class="autocomplete-custom"><md-item-template><span class="autocomplete-item md-accent-fg" \nmd-highlight-text="vm.acSearchText.TemplateIds">{{item.Name}}</span></md-item-template></md-autocomplete>\n<md-chip-template><span><strong>{{vm.getChipDisplayValue($chip, \'TemplateIds\')}}</strong></span></md-chip-template>\n</md-chips><div class="md-chips-messages" ng-messages="vm.editForm.TemplateIds.$error" \nng-show="vm.editForm.TemplateIds.$dirty || vm.editForm.TemplateIds.$submitted"><div ng-message="required">\n{{ \'VALIDATIONS.REQUIRED\' | translate}}</div></div></md-input-container></div></div></md-dialog-content>\n<md-dialog-actions layout="row" layout-align="end center"><div></div><div layout="row" layout-align="end center">\n<md-button ng-click="vm.closeDialog(vm.isDataDirty)" class="send-button md-primary md-raised" aria-label="Cancel" \ntranslate="ACTIONS.DIALOG_CANCEL" translate-attr-aria-label="ACTIONS.DIALOG_CANCEL" ng-disabled="vm.isLoading">CANCEL\n</md-button><md-button ng-click="vm.saveRecord()" class="send-button md-accent md-raised" aria-label="Save" \ntranslate="ACTIONS.SAVE" translate-attr-aria-label="ACTIONS.SAVE" ng-disabled="vm.isLoading || vm.editForm.$invalid">\nSAVE</md-button></div></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/catalogs/sub-modules/crds-linear/dialogs/assign-crds/assign-crds.html','<md-dialog class="edit-dialog" aria-label="Assign Delivery Dates"><form name="vm.editForm" class="md-inline-form">\n<md-toolbar class="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" layout-align="space-between center">\n<span class="title" translate="{{\'CRD_LINEAR.TITLES.ASSIGN_DELIVERY_DATES\'}}">Assign Delivery Dates</span><md-button \nclass="md-icon-button" ng-click="vm.closeDialog(vm.isDataDirty)" aria-label="Close dialog" tranlate \ntranslate-aria-label="ACTIONS.DIALOG_CLOSE"><md-icon md-font-icon="icon-close"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div layout="row" layout-wrap><div flex="100" class="p-5 lookup-element">\n<md-input-container class="md-block"><label>{{\'CRD_LINEAR.FIELDS.ARTICLE_NUMBER\' | translate}}</label><md-chips \nid="dialog_input_1" name="ArticleId" ng-model="vm.record.ArticleId" md-autocomplete-snap \nmd-transform-chip="vm.transformChip($chip, \'ArticleId\')" md-require-match="true" ng-required="true"><md-autocomplete \nmd-selected-item="vm.acSelectedItem.ArticleId" md-search-text="vm.acSearchText.ArticleId" \nmd-items="item in vm.acQuerySearch(vm.acSearchText.ArticleId, vm.record.ArticleId, \'ArticleId\')" \nmd-item-text="item.value" md-min-length="0" md-no-cache="true" md-menu-class="autocomplete-custom"><md-item-template>\n<span class="autocomplete-item md-accent-fg" md-highlight-text="vm.acSearchText.ArticleId">{{item.value}}</span>\n</md-item-template><md-not-found>No Record matching "{{vm.acSearchText.ArticleId}}" were found.</md-not-found>\n</md-autocomplete><md-chip-template><span><strong>{{vm.getChipDisplayValue($chip, \'ArticleId\')}}</strong></span>\n</md-chip-template></md-chips></md-input-container></div><div flex="100" class="p-5 lookup-element"><md-input-container\n class="md-block"><label>{{\'CRD_LINEAR.FIELDS.CRD\' | translate}}</label><md-chips id="dialog_input_2" name="CrdId" \nng-model="vm.record.CrdId" md-autocomplete-snap md-transform-chip="vm.transformChip($chip, \'CrdId\')" \nmd-require-match="true"><md-autocomplete md-selected-item="vm.acSelectedItem.CrdId" \nmd-search-text="vm.acSearchText.CrdId" \nmd-items="item in vm.acQuerySearch(vm.acSearchText.CrdId, vm.record.CrdId, \'CrdId\')" md-item-text="item.value" \nmd-min-length="0" md-no-cache="true" md-menu-class="autocomplete-custom"><md-item-template><span \nclass="autocomplete-item md-accent-fg" md-highlight-text="vm.acSearchText.CrdId">{{item.value}}</span>\n</md-item-template><md-not-found>No Record matching "{{vm.acSearchText.CrdId}}" were found.</md-not-found>\n</md-autocomplete><md-chip-template><span><strong>{{vm.getChipDisplayValue($chip, \'CrdId\')}}</strong></span>\n</md-chip-template></md-chips></md-input-container></div></div></md-dialog-content><md-dialog-actions layout="row" \nlayout-align="end center"><div></div><div layout="row" layout-align="end center"><md-button \nng-click="vm.closeDialog(vm.isDataDirty)" class="send-button md-primary md-raised" aria-label="Cancel" \ntranslate="ACTIONS.DIALOG_CANCEL" translate-attr-aria-label="ACTIONS.DIALOG_CANCEL" ng-disabled="vm.isLoading">CANCEL\n</md-button><md-button ng-click="vm.saveRecord()" class="send-button md-accent md-raised" aria-label="Save" \ntranslate="ACTIONS.SAVE" translate-attr-aria-label="ACTIONS.SAVE" ng-disabled="vm.isLoading || vm.editForm.$invalid">\nSAVE</md-button></div></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/catalogs/sub-modules/customers-segmentation-linear/dialogs/assign-customers-segmentation/assign-customers-segmentation.html','<md-dialog class="edit-dialog" aria-label="Assign Delivery Dates"><form name="vm.editForm" class="md-inline-form">\n<md-toolbar class="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" layout-align="space-between center">\n<span class="title" translate="{{\'CUSTOMERS_SEGMENTATION_LINEAR.TITLES.ASSIGN_CUSTOMER_SEGMENTATIONS\'}}">\nAssign Customer Segmentations</span><md-button class="md-icon-button" ng-click="vm.closeDialog(vm.isDataDirty)" \naria-label="Close dialog" tranlate translate-aria-label="ACTIONS.DIALOG_CLOSE"><md-icon md-font-icon="icon-close">\n</md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div layout="row" layout-wrap><div flex="100" \nclass="p-5 lookup-element"><md-input-container class="md-block"><label>\n{{\'CUSTOMERS_SEGMENTATION_LINEAR.FIELDS.CUSTOMER_NUMBER\' | translate}}</label><md-chips id="dialog_input_1" \nname="CustomerNumber" ng-model="vm.record.CustomerNumber" md-autocomplete-snap \nmd-transform-chip="vm.transformChip($chip, \'CustomerNumber\')" md-require-match="true" ng-required="true">\n<md-autocomplete md-selected-item="vm.acSelectedItem.CustomerNumber" md-search-text="vm.acSearchText.CustomerNumber" \nmd-items="item in vm.acCustomerNumberQuerySearch(vm.acSearchText.CustomerNumber, vm.record.CustomerNumber, vm.allLinkedCustomers)" \nmd-item-text="item.CustomerNumber" md-min-length="0" md-no-cache="true" md-menu-class="autocomplete-custom">\n<md-item-template><span class="autocomplete-item md-accent-fg" md-highlight-text="vm.acSearchText.CustomerNumber">\n{{item.CustomerNumber}}</span></md-item-template><md-not-found>\nNo Record matching "{{vm.acSearchText.CustomerNumber}}" were found.</md-not-found></md-autocomplete><md-chip-template>\n<span><strong>{{vm.getCustomerNumberChipDisplayValue($chip, vm.allLinkedCustomers)}}</strong></span></md-chip-template>\n</md-chips></md-input-container></div><div flex="100" class="p-5 lookup-element"><md-input-container class="md-block">\n<label>{{\'CUSTOMERS_SEGMENTATION_LINEAR.FIELDS.SEGMENTATION_NAME\' | translate}}</label><md-chips id="dialog_input_2" \nname="SegmentationId" ng-model="vm.record.SegmentationId" md-autocomplete-snap \nmd-transform-chip="vm.transformChip($chip, \'SegmentationId\')" md-require-match="true"><md-autocomplete \nmd-selected-item="vm.acSelectedItem.SegmentationId" md-search-text="vm.acSearchText.SegmentationId" \nmd-items="item in vm.acQuerySearch(vm.acSearchText.SegmentationId, vm.record.SegmentationId, \'SegmentationId\')" \nmd-item-text="item.value" md-min-length="0" md-no-cache="true" md-menu-class="autocomplete-custom"><md-item-template>\n<span class="autocomplete-item md-accent-fg" md-highlight-text="vm.acSearchText.SegmentationId">{{item.value}}</span>\n</md-item-template><md-not-found>No Record matching "{{vm.acSearchText.SegmentationId}}" were found.</md-not-found>\n</md-autocomplete><md-chip-template><span><strong>{{vm.getChipDisplayValue($chip, \'SegmentationId\')}}</strong></span>\n</md-chip-template></md-chips></md-input-container></div></div></md-dialog-content><md-dialog-actions layout="row" \nlayout-align="end center"><div></div><div layout="row" layout-align="end center"><md-button \nng-click="vm.closeDialog(vm.isDataDirty)" class="send-button md-primary md-raised" aria-label="Cancel" \ntranslate="ACTIONS.DIALOG_CANCEL" translate-attr-aria-label="ACTIONS.DIALOG_CANCEL" ng-disabled="vm.isLoading">CANCEL\n</md-button><md-button ng-click="vm.saveRecord()" class="send-button md-accent md-raised" aria-label="Save" \ntranslate="ACTIONS.SAVE" translate-attr-aria-label="ACTIONS.SAVE" ng-disabled="vm.isLoading || vm.editForm.$invalid">\nSAVE</md-button></div></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/catalogs/sub-modules/dune-images/dialogs/remove-tag/remove-tag.html','<md-dialog class="edit-dialog" aria-label="Remove Tag"><form name="vm.editForm" class="md-inline-form"><md-toolbar \nclass="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" layout-align="space-between center"><span \nclass="title" translate="T1_DUNE.TITLES.REMOVE_TAG">Remove Tag</span><md-button class="md-icon-button" \nng-click="vm.closeDialog(vm.isDataDirty)" aria-label="Close dialog" tranlate \ntranslate-aria-label="ACTIONS.DIALOG_CLOSE"><md-icon md-font-icon="icon-close"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div layout="row" layout-wrap><div flex="100" flex-gt-xs="50" class="p-5">\n<md-select id="dialog_input_$first" ng-model="vm.tag" placeholder="{{\'T1_DUNE.FIELDS.TAGS\' | translate}}" \naria-label="Tags"><md-option ng-repeat="tag in vm.tags" ng-value="tag">{{ tag }}</md-option></md-select></div></div>\n</md-dialog-content><md-dialog-actions layout="row" layout-align="end center"><div></div><div layout="row" \nlayout-align="end center"><md-button ng-click="vm.closeDialog(vm.isDataDirty)" \nclass="send-button md-primary md-raised" aria-label="Cancel" translate="ACTIONS.DIALOG_CANCEL" \ntranslate-attr-aria-label="ACTIONS.DIALOG_CANCEL" ng-disabled="vm.isLoading">CANCEL</md-button><md-button \nng-click="vm.saveRecord()" class="send-button md-accent md-raised" aria-label="Save" translate="ACTIONS.SAVE" \ntranslate-attr-aria-label="ACTIONS.SAVE" ng-disabled="vm.isLoading || vm.editForm.$invalid">SAVE</md-button></div>\n</md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/catalogs/sub-modules/dune-images/dialogs/upload-dune-image/upload-dune-image.html','<md-dialog class="edit-dialog dune-images-image-uploader" aria-label="New Record"><form name="vm.editForm" \nclass="md-inline-form" flow-init="vm.flowInit" flow-object="$rootScope.flowObj" \nflow-file-added="vm.validateFile($file, $event, $flow)" flow-files-submitted="vm.upload()" \nflow-file-success="vm.onSuccessUpload($file, $message, $flow)" flow-name="vm.obj.flow"><md-toolbar \nclass="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" layout-align="space-between center"><span \nclass="title" translate="{{vm.isNew ? \'TITLES.RECORD_NEW\' : \'TITLES.RECORD_EDIT\'}}">New Record</span><md-button \nclass="md-icon-button" ng-click="vm.closeDialog(vm.isDataDirty, true)" aria-label="Close dialog" tranlate \ntranslate-aria-label="ACTIONS.DIALOG_CLOSE"><md-icon md-font-icon="icon-close"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div layout="row" layout-wrap><div flex="100" flex-gt-xs="50" class="p-5" \nng-if="!vm.isEditSortOrder"><md-input-container class="md-block"><label>{{\'T1_DUNE.FIELDS.IMAGE_SET\' | translate}}\n</label><input name="ImageSet" ng-model="vm.record.ImageSet" type="text" ng-required="true" md-maxlength="250"><div \nng-messages="vm.editForm.ImageSet.$error" role="alert" multiple="multiple"><div ng-message="required">\n{{\'VALIDATIONS.REQUIRED\' | translate}}</div><div ng-message="md-maxlength">{{\'VALIDATIONS.MAXLEN\' | translate}}</div>\n</div></md-input-container></div><div flex="100" flex-gt-xs="50" class="p-5" ng-if="!vm.isEditSortOrder">\n<md-input-container class="md-block"><label>{{\'T1_DUNE.FIELDS.KEY\' | translate}}</label><input name="Key" \nng-model="vm.record.Key" type="text" ng-required="true" md-maxlength="250"><div ng-messages="vm.editForm.Key.$error" \nrole="alert" multiple="multiple"><div ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div><div \nng-message="md-maxlength">{{\'VALIDATIONS.MAXLEN\' | translate}}</div></div></md-input-container></div><div flex="100" \nflex-gt-xs="50" class="p-5" ng-if="!vm.isEditSortOrder"><md-input-container class="md-block"><label>\n{{\'T1_DUNE.FIELDS.ASSET_TYPE\' | translate}}</label><md-select name="AssetTypeId" ng-model="vm.record.AssetTypeId" \nng-required="true"><md-option ng-repeat="assetType in vm.assetTypes" ng-value="assetType.Id">{{assetType.Name}}\n</md-option></md-select><md-progress-linear ng-if="vm.isAssetTypesLoading" md-mode="query" class="md-accent">\n</md-progress-linear><div ng-messages="vm.editForm.AssetTypeId.$error" role="alert" multiple="multiple"><div \nng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div></div></md-input-container></div><div flex="100" \nflex-gt-xs="50" class="p-5"><md-input-container class="md-block"><label>{{\'T1_DUNE.FIELDS.SORT_ORDER\' | translate}}\n</label><input name="SortOrder" ng-model="vm.record.SortOrder" type="number" ng-pattern="/^\\d+$/" ng-required="true">\n<div ng-messages="vm.editForm.SortOrder.$error" role="alert" multiple="multiple"><div ng-message="required">\n{{\'VALIDATIONS.REQUIRED\' | translate}}</div><div ng-message="md-maxlength">{{\'VALIDATIONS.MAXLEN\' | translate}}</div>\n<div ng-message="pattern">{{\'VALIDATIONS.INVALID_SORT_ORDER\' | translate}}</div></div></md-input-container></div><div \nflex="100" class="p-5" flow-drop ng-if="$flow.support" ng-show="!vm.isEditSortOrder"><label for="flow-upload-file-id">\n<div class="file-uploader-container" ng-show="!vm.isNew && !vm.isImageChanged" \nflow-drag-enter="style={outline: \'2px dashed rgba(0,0,0,0.38)\', color: \'#939393\' }" \nflow-drag-leave="style={outline: \'2px dashed rgba(0,0,0,0.12)\', color: \'rgba(0,0,0,0.12)\'}" ng-style="style"><div \nng-if="!vm.isNew && !vm.isImageChanged" class="image-container"><img \nng-src="{{vm.duneImageSource[vm.record.Id][\'contentType\']}},{{vm.duneImageSource[vm.record.Id][\'imageDataUri\']}}">\n</div><div class="uploaded-file-name" ng-if="!vm.isNew && !vm.isImageChanged"><label>{{vm.fileName}}</label></div>\n</div></label><label for="flow-upload-file-id" class="" ng-show="vm.isNew || (!vm.isNew && vm.isImageChanged)"><div \nclass="file-uploader-container upload-success"><div class="upload-label" ng-if="vm.isNew && !$flow.files[0]"><div \nclass="upload-icon"><md-icon ng-style="style" md-font-icon="icon-upload" class="icon s1"></md-icon></div><div \nclass="upload-message" ng-style="style"><span>Choose a file or drag it here.</span></div></div><div \nclass="image-container"><img flow-img="$flow.files[0]"></div><div class="uploaded-file-name"><label>\n{{$flow.files[0].name}}</label></div></div></label><div class="upload-error" ng-show="!vm.isFileValid">\n{{ \'T1_DUNE.MESSAGES.INVALID_FILE_FORMAT\' | translate }}</div><md-progress-linear md-mode="determinate" \nclass="md-accent" ng-if="($flow.isUploading() && !vm.isImageLoading) || (!$flow.isUploading() && vm.isImageLoading)" \nvalue="{{$flow.progress()*100}}"></md-progress-linear></div><div ng-if="!$flow.support"><span>Browser not supported!\n</span></div></div></md-dialog-content><md-dialog-actions layout="row" layout-align="end center"><div><input \ntype="file" id="flow-upload-file-id" class="ng-hide" flow-btn accept=".jpg, .png, .jpeg, .tif, .tiff"></div><div \nlayout="row" layout-align="end center"><md-button ng-click="vm.closeDialog(vm.isDataDirty, true)" \nclass="send-button md-primary md-raised" aria-label="Cancel" translate="ACTIONS.DIALOG_CANCEL" \ntranslate-attr-aria-label="ACTIONS.DIALOG_CANCEL" ng-disabled="vm.isLoading">CANCEL</md-button><md-button \nng-click="vm.saveRecord()" class="send-button md-accent md-raised" aria-label="Save" translate="ACTIONS.SAVE" \ntranslate-attr-aria-label="ACTIONS.SAVE" \nng-disabled="vm.isLoading || vm.editForm.$invalid || (!$flow.files.length && vm.isNew) || !vm.isFileValid || $flow.isUploading()">\nSAVE</md-button><md-button ng-click="vm.saveRecord(true)" class="send-button md-accent md-raised" aria-label="Save" \nng-show="vm.isNew" translate="ACTIONS.SAVE_AND_NEW" translate-attr-aria-label="ACTIONS.SAVE_AND_NEW" \nng-disabled="vm.isLoading || vm.editForm.$invalid || (!$flow.files.length && vm.isNew) || !vm.isFileValid || $flow.isUploading()">\nSAVE</md-button></div></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/catalogs/sub-modules/dune-images/dialogs/upload-dune-images/upload-dune-images.html','<md-dialog class="edit-dialog" aria-label="New Record"><form name="vm.editForm" class="md-inline-form" \nflow-init="vm.flowInit" flow-object="$rootScope.flowObj" flow-file-added="vm.validateFile($file, $event, $flow)" \nflow-name="vm.obj.flow"><md-toolbar class="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" \nlayout-align="space-between center"><span class="title" translate="TITLES.RECORD_NEW">New Record</span><md-button \nclass="md-icon-button" ng-click="vm.closeDialog()" aria-label="Close dialog" tranlate \ntranslate-aria-label="ACTIONS.DIALOG_CLOSE"><md-icon md-font-icon="icon-close"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div layout="row" layout-wrap><div flex="100" layout="row" \nlayout-align="space-between center"><div flex="initial"><span>Filename:</span></div><div flex layout="row"><div flex \nclass="text-boxed"><label for="fileName" ng-show="$flow.files.length === 0" style="display: block; width: 100%">[none]\n</label><span ng-show="$flow.files.length > 0" class="text-truncate">{{$flow.files[0].name}}</span></div></div><div \nflex="initial"><md-button class="md-raised"><label for="fileName">{{\'T1_DUNE.ACTIONS.SELECT\' | translate}}</label>\n</md-button></div></div><input type="file" flow-btn id="fileName" accept=".zip" class="ng-hide" required><div \nclass="error-message" \nng-class="{\'display-error\' : ($flow.files.length > 0 && !vm.isFileValid), \'remove-error\' : !($flow.files.length > 0 && !vm.isFileValid)}" \nng-show="$flow.files.length > 0 && !vm.isFileValid">{{\'VALIDATIONS.INVALID_FORMATE\' | translate}}</div></div><div \nflex="100"><md-switch ng-model="vm.record.Boxify" aria-label="{{\'T1_DUNE.FIELDS.BOXIFY\' | translate}}" \nng-true-value="true" ng-false-value="false" class="md-accent">{{\'T1_DUNE.FIELDS.BOXIFY\' | translate}}</md-switch></div>\n<div flex="100"><md-switch ng-model="vm.record.Trim" aria-label="{{\'T1_DUNE.FIELDS.TRIM\' | translate}}" \nng-true-value="true" ng-false-value="false" class="md-accent">{{\'T1_DUNE.FIELDS.TRIM\' | translate}}</md-switch></div>\n</md-dialog-content><md-dialog-actions layout="row" layout-align="end center"><div></div><div layout="row" \nlayout-align="end center"><md-button ng-click="vm.closeDialog()" class="send-button md-primary md-raised" \naria-label="Cancel" translate="ACTIONS.DIALOG_CANCEL" translate-attr-aria-label="ACTIONS.DIALOG_CANCEL" \nng-disabled="vm.isLoading">CANCEL</md-button><md-button ng-click="vm.saveRecord()" \nclass="send-button md-accent md-raised" aria-label="Save" translate="ACTIONS.SAVE" \ntranslate-attr-aria-label="ACTIONS.SAVE" \nng-disabled="vm.isLoading || vm.editForm.$invalid  || !vm.isFileValid || $flow.isUploading()">SAVE</md-button></div>\n</md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/catalogs/sub-modules/orders/dialogs/approve-orders/approve-orders.html','<md-dialog class="edit-dialog" aria-label="Details" flex="35"><form name="approveOrderForm" class="md-inline-form">\n<md-toolbar class="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" layout-align="space-between center">\n<span class="title" translate="MESSAGES.TITLE.ALERT">Alert<span><md-button class="md-icon-button" \nng-click="vm.cancel()" aria-label="Close dialog" tranlate translate-aria-label="ACTIONS.DIALOG_CLOSE"><md-icon \nmd-font-icon="icon-close"></md-icon></md-button></span></span></div></md-toolbar><md-dialog-content><div \nlayout="column"><span class="alert md-warn-bg text-boxed" ng-if="vm.isRejectedOrInactiveOrderlines === true" \nstyle="width:235px" translate="MESSAGES.CONTENT.INACTIVE_OR_REJECTED_ORDERLINES"></span><h2>\n{{\'MESSAGES.CONTENT.CONFIRM_APPROVE\' | translate}}</h2><md-chips ng-model="vm.items" readonly="true"><md-chip-template>\n<strong ng-if="$chip[\'Alias\']">{{$chip[\'Alias\']}}</strong> <strong ng-if="$chip[\'Alias\']">{{\' - \'}}</strong> <strong \nng-if="$chip[vm.model.lookupDisplayField] && !vm.isDate">{{$chip[vm.model.lookupDisplayField]}}</strong> <strong \nng-if="$chip[vm.model.lookupDisplayField] && vm.isDate">{{$chip[vm.model.lookupDisplayField] | date:\'MMM d, y\'}}\n</strong></md-chip-template></md-chips><div ng-if="vm.items[0].UseOrderType == 1" style="margin-top:20px" \nclass="lookup-element"><h2>{{\'ORDERS.MISC.SELECT_ORDER_TYPE\' | translate}}</h2><md-autocomplete tx-force-select \nmd-input-name="orderType" md-selected-item="vm.lookupModel.orderType" \nmd-items="item in vm.lookupSearch(vm.searchText[orderType], field)" md-search-text="vm.searchText[orderType]" \nmd-item-text="item.value" md-min-length="0" md-floating-label="{{\'ORDERS.MISC.ORDER_TYPE\' | translate}}" \nmd-selected-item-change="vm.lookupChange(vm.lookupModel.orderType)" ng-required="true" md-autofocus md-no-cache="true" \ntx-clear-autocomplete ng-click="vm.selectText($event)" md-menu-class="autocomplete-custom"><md-item-template><span \nclass="autocomplete-item md-accent-fg" md-highlight-text="vm.searchText[orderType]" md-highlight-flags="i">\n{{item.value}}</span></md-item-template><div ng-messages="approveOrderForm.orderType.$error" role="alert" \nng-show="approveOrderForm.orderType.$touched"><div ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div>\n</div><md-not-found>No Record matching "{{vm.searchText[orderType]}}" were found.</md-not-found></md-autocomplete>\n</div></div></md-dialog-content><md-dialog-actions layout="row" layout-align="end center"><div></div><div layout="row" \nlayout-align="end center"><md-button ng-click="vm.cancel()" class="md-primary md-raised" \ntranslate="ACTIONS.DIALOG_CANCEL" aria-label="Cancel" translate-attr-aria-label="ACTIONS.DIALOG_CANCEL">CANCEL\n</md-button><md-button ng-click="vm.closeDialog(\'confirm\')" class="md-accent md-raised" \ntranslate="ACTIONS.APPROVE_ORDERS" ng-disabled="approveOrderForm.$invalid" aria-label="Approve Order(s)" \ntranslate-attr-aria-label="ACTIONS.APPROVE_ORDERS">{{\'ACTIONS.APPROVE_ORDERS\' | translate}}</md-button></div>\n</md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/catalogs/sub-modules/orders/dialogs/update-order/orders-dialog.html','<md-dialog class="edit-dialog" aria-label="{{vm.isNew ? \'New Order\' : \'Update Order\'}"><form name="vm.editForm" \nclass="md-inline-form"><md-toolbar class="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" \nlayout-align="space-between center"><span class="title">\n{{vm.isNew ? \'PARTS.CREATE\' : \'PARTS.EDIT\' | translate}} {{vm.model.title | translate}}</span><md-button \nclass="md-icon-button" ng-click="vm.closeDialog(vm.isDataDirty)" aria-label="Close dialog" tranlate \ntranslate-aria-label="ACTIONS.DIALOG_CLOSE"><md-icon md-font-icon="icon-close"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div layout="row" layout-wrap><div flex="100" flex-gt-xs="50" \nclass="p-5 lookup-element"><md-autocomplete id="dialog_input_{{$first ? \'first\' : $index}}" md-input-name="CustomerId" \nmd-selected-item="vm.lookupModel.CustomerId" \nmd-items="item in vm.lookupSearch(vm.searchText.CustomerId, \'CustomerId\')" md-search-text="vm.searchText.CustomerId" \nmd-item-text="vm.getLookupDisplayValue(item, \'CustomerId\')" md-min-length="0" \nmd-floating-label="{{\'ORDERS.FIELDS.CUSTOMER_ID\' | translate}}" \nmd-selected-item-change="vm.onCustomerChange(vm.lookupModel.CustomerId, \'CustomerId\')" ng-disabled="!vm.isNew" \nng-required="true" md-no-cache="true" tx-clear-autocomplete tx-force-select ng-click="vm.selectText($event)" \nmd-menu-class="autocomplete-custom"><md-item-template><span class="autocomplete-item md-accent-fg" \nmd-highlight-text="vm.searchText.CustomerId" md-highlight-flags="i">{{item.value}}</span></md-item-template>\n<md-not-found>No Record matching "{{vm.searchText.CustomerId}}" were found.</md-not-found><div \nng-messages="vm.editForm.CustomerId.$error" role="alert" ng-show="vm.editForm.CustomerId.$touched"><div \nng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div></div></md-autocomplete></div><div flex="100" \nflex-gt-xs="50" class="p-5"><md-input-container class="md-block"><label translate>ORDERS.FIELDS.CUSTOMER_REFERENCE\n</label><input name="CustomerReference" ng-model="vm.record.CustomerReference" type="text" ng-required="false" \nmd-maxlength="-1" ng-pattern=""><div ng-messages="vm.editForm.CustomerReference.$error" role="alert" \nmultiple="multiple"><div ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div><div ng-message="pattern">\n{{\'VALIDATIONS.PATTERN\' | translate}}</div><div ng-message="md-maxlength">{{\'VALIDATIONS.MAXLEN\' | translate}}</div>\n</div></md-input-container></div><div flex="100" flex-gt-xs="50" class="p-5 lookup-element"><md-autocomplete \nid="dialog_input_{{$first ? \'first\' : $index}}" md-input-name="LocationId" \nmd-selected-item="vm.lookupModel.LocationId" \nmd-items="item in vm.locationSearch(vm.searchText.LocationId, \'LocationId\')" md-search-text="vm.searchText.LocationId" \nmd-item-text="vm.getLocationDisplayValue(item, \'LocationId\')" md-min-length="0" \nmd-floating-label="{{\'ORDERS.FIELDS.LOCATION_ID\' | translate}}" \nmd-selected-item-change="vm.onLocationChange(vm.lookupModel.LocationId, \'LocationId\')" \nng-disabled="!vm.isNew || !vm.lookupModel.CustomerId" ng-required="true" md-no-cache="true" tx-clear-autocomplete \ntx-force-select ng-click="vm.selectText($event)" md-menu-class="autocomplete-custom"><md-item-template><span \nclass="autocomplete-item md-accent-fg" md-highlight-text="vm.searchText.LocationId" md-highlight-flags="i">\n{{item[vm.locationModel.lookupDisplayField]}}</span></md-item-template><md-not-found>\nNo Record matching "{{vm.searchText.LocationId}}" were found.</md-not-found><div \nng-messages="vm.editForm.LocationId.$error" role="alert" ng-show="vm.editForm.LocationId.$touched"><div \nng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div></div></md-autocomplete></div><div flex="100" \nflex-gt-xs="50" class="p-5"><md-input-container class="md-block"><label translate>ORDERS.FIELDS.ALIAS</label><input \nname="Alias" ng-model="vm.record.Alias" type="text" ng-required="false" md-maxlength="300" ng-pattern=""><div \nng-messages="vm.editForm.Alias.$error" role="alert" multiple="multiple"><div ng-message="md-maxlength">\n{{\'VALIDATIONS.MAXLEN\' | translate}}</div></div></md-input-container></div><div flex="100" flex-gt-xs="50" \nclass="p-5 lookup-element" ng-if="vm.isStockApply"><md-autocomplete id="dialog_input_{{$first ? \'first\' : $index}}" \nmd-input-name="StockDefinitionId" md-selected-item="vm.lookupModel.StockDefinitionId" \nmd-items="item in vm.stocksLookupSearch(vm.searchText.StockDefinitionId, \'StockDefinitionId\', vm.customerStocks)" \nmd-search-text="vm.searchText.StockDefinitionId" md-item-text="vm.getStockLookupDisplayValue(item, vm.customerStocks)" \nmd-min-length="0" md-floating-label="{{\'ORDERS.FIELDS.STOCK\' | translate}}" \nmd-selected-item-change="vm.lookupChange(vm.lookupModel.StockDefinitionId, \'StockDefinitionId\')" \nng-disabled="!vm.isNew || !vm.lookupModel.CustomerId" ng-required="true" md-no-cache="true" tx-clear-autocomplete \ntx-force-select ng-click="vm.selectText($event)" md-menu-class="autocomplete-custom"><md-item-template><span \nclass="autocomplete-item md-accent-fg" md-highlight-text="vm.searchText.StockDefinitionId" md-highlight-flags="i">\n{{item.StockName}}</span></md-item-template><md-not-found>\nNo Record matching "{{vm.searchText.StockDefinitionId}}" were found.</md-not-found><div \nng-messages="vm.editForm.StockDefinitionId.$error" role="alert" ng-show="vm.editForm.StockDefinitionId.$touched"><div \nng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div></div></md-autocomplete></div></div>\n</md-dialog-content><md-dialog-actions layout="row" layout-align="end center"><div></div><div layout="row" \nlayout-align="end center"><md-button ng-click="vm.closeDialog(vm.isDataDirty)" \nclass="send-button md-primary md-raised" aria-label="Cancel" translate="ACTIONS.DIALOG_CANCEL" \ntranslate-attr-aria-label="ACTIONS.DIALOG_CANCEL" ng-disabled="vm.isLoading">CANCEL</md-button><md-button \nng-click="vm.saveRecord()" class="send-button md-accent md-raised" aria-label="Save" translate="ACTIONS.SAVE" \ntranslate-attr-aria-label="ACTIONS.SAVE" ng-disabled="vm.isLoading || vm.editForm.$invalid">SAVE</md-button><md-button \nng-click="vm.saveRecord(true)" class="send-button md-accent md-raised" aria-label="Save" \ntranslate="ACTIONS.SAVE_AND_NEW" translate-attr-aria-label="ACTIONS.SAVE_AND_NEW" \nng-disabled="vm.isLoading || vm.editForm.$invalid" ng-if="vm.isNew">SAVE</md-button></div></md-dialog-actions></form>\n</md-dialog>');
$templateCache.put('app/main/catalogs/sub-modules/orders-terms-conditions/dialogs/create-terms-conditions/create-terms-conditions.html','<md-dialog class="terms-conditions-dialog" aria-label="New Privacy Policy"><form name="vm.editForm" \nclass="md-inline-form"><md-toolbar class="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" \nlayout-align="space-between center"><span class="title" ng-if="vm.isCopyTermsAndConditions === false">\n{{\'PARTS.CREATE\' | translate}} {{vm.model.title | translate}}</span> <span class="title" \nng-if="vm.isCopyTermsAndConditions === true">{{\'PARTS.COPY\' | translate}} {{vm.model.title | translate}}</span>\n<md-button class="md-icon-button" ng-click="vm.closeDialog(vm.isDataDirty)" aria-label="Close dialog" tranlate \ntranslate-aria-label="ACTIONS.DIALOG_CLOSE"><md-icon md-font-icon="icon-close"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div class="div" layout="column" ng-hide="vm.loadingContent"><div \nclass="p-5"><md-input-container class="md-block"><label translate>PRIVACY_POLICY.FIELDS.TITLE</label><input \nid="dialog_input_first" name="Title" ng-model="vm.record.Title" type="text" ng-required="true" md-maxlength="250" \nmd-autofocus><div ng-messages="vm.editForm.Title.$error" role="alert" multiple="multiple"><div ng-message="required">\n{{\'VALIDATIONS.REQUIRED\' | translate}}</div><div ng-message="md-maxlength">{{\'VALIDATIONS.MAXLEN\' | translate}}</div>\n</div></md-input-container></div><div flex class="p-5"><label translate>PRIVACY_POLICY.FIELDS.CONTENT</label>\n<ng-quill-editor class="ng-quill-editor" ng-required="true" name="Content" ng-model="vm.record.Content">\n</ng-quill-editor><div ng-messages="vm.editForm.Content.$error" ng-show="vm.editForm.Content.$touched" role="alert" \nmultiple="multiple" class="error-message" \nng-class="{\'display-error\': vm.editForm.Content.$error.required && vm.editForm.Content.$touched}"><div \nng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div></div></div></div><div ng-show="vm.loadingContent" \nstyle="height: 100%" layout="row" layout-align="center center" flex="100"><md-progress-circular \nmd-mode="indeterminate" aria-label="Processing" class="md-accent"></div></md-dialog-content><md-dialog-actions \nlayout="row" layout-align="end center"><div></div><div layout="row" layout-align="end center"><md-button \nng-click="vm.closeDialog(vm.isDataDirty)" class="send-button md-primary md-raised" aria-label="Cancel" \ntranslate="ACTIONS.DIALOG_CANCEL" translate-attr-aria-label="ACTIONS.DIALOG_CANCEL" ng-disabled="vm.isLoading">CANCEL\n</md-button><md-button ng-click="vm.saveRecord()" class="send-button md-accent md-raised" aria-label="Save" \ntranslate="ACTIONS.SAVE" translate-attr-aria-label="ACTIONS.SAVE" ng-disabled="vm.isLoading || vm.editForm.$invalid">\nSAVE</md-button></div></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/catalogs/sub-modules/prices/dialogs/update-prices/update-prices.html','<md-dialog class="edit-dialog" aria-label="Update Prices"><form name="vm.editForm" class="md-inline-form"><md-toolbar \nclass="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" layout-align="space-between center"><span \nclass="title" translate="PRICES.ACTIONS.UPDATE_PRICES">Update Prices</span><md-button class="md-icon-button" \nng-click="vm.closeDialog(false)" aria-label="Close dialog" tranlate translate-aria-label="ACTIONS.DIALOG_CLOSE">\n<md-icon md-font-icon="icon-close"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div \nlayout="row" layout-wrap><div ng-repeat="record in vm.record.Prices track by $index" class="p-5" flex="100" \nflex-gt-xs="50"><md-input-container class="md-block"><div class="external-change-message" \nng-if="record.priceGroupNonEditable"><span>{{ \'ARTICLES.MESSAGES.NON_EDITABLE_PRICE_GROUP\' | translate }} </span><span \nng-if="record.isAllowChangeRequestEnabled && vm.updatePricesChangeManagementExternalURL !== \'\'">\n{{ \'ARTICLES.MESSAGES.NON_EDITABLE_PRICE_GROUP_EXTERNAL_URL\' | translate }} <a \nhref="{{vm.updatePricesChangeManagementExternalURL}}" target="_blank">here</a></span></div><label>\n{{record.displayLabel}}</label><input name="{{record.displayLabel}}" ng-model="record.Price" type="number" \nmd-maxlength="-1" md-autofocus="$first" \nng-pattern="record.isMandatory\r\n                            ? \'^[+]?((\\\\d*[1-9]\\\\d*)([.]\\\\d{0,\' + vm.numberOfDecimalsForPrices + \'})?)$\'\r\n                            : \'^[+]?\\\\d+([.]\\\\d{0,\' + vm.numberOfDecimalsForPrices + \'})?$\'" \nng-required="record.isMandatory" ng-disabled="record.readOnly || record.priceGroupNonEditable"><div \nng-messages="vm.editForm[record.displayLabel].$error" role="alert" multiple="multiple"><div ng-message="pattern" \ntranslate="{{ record.isMandatory ? \'VALIDATIONS.PRICE_GREATER_THAN_ZERO\' : \'VALIDATIONS.PRICE\' }}" \ntranslate-values="{numberOfDecimalsForPrices: vm.numberOfDecimalsForPrices}"></div><div ng-message="required">\n{{\'VALIDATIONS.REQUIRED\' | translate}}</div></div></md-input-container></div></div></md-dialog-content>\n<md-dialog-actions layout="row" layout-align="end center"><div></div><div layout="row" layout-align="end center">\n<md-button ng-click="vm.closeDialog(false)" class="send-button md-primary md-raised" aria-label="Cancel" \ntranslate="ACTIONS.DIALOG_CANCEL" translate-attr-aria-label="ACTIONS.DIALOG_CANCEL" ng-disabled="vm.isLoading">CANCEL\n</md-button><md-button ng-click="vm.saveRecord()" class="send-button md-accent md-raised" aria-label="Save" \ntranslate="ACTIONS.SAVE" translate-attr-aria-label="ACTIONS.SAVE" ng-disabled="vm.isLoading || vm.editForm.$invalid">\nSAVE</md-button></div></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/catalogs/sub-modules/prices-linear/dialogs/update-prices-linear/update-prices-linear.html','<md-dialog class="edit-dialog" aria-label="Update Prices"><form name="vm.editForm" class="md-inline-form"><md-toolbar \nclass="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" layout-align="space-between center"><span \nclass="title" translate="PRICES_LINEAR.ACTIONS.UPDATE_PRICES">Update Prices</span><md-button class="md-icon-button" \nng-click="vm.closeDialog(false)" aria-label="Close dialog" tranlate translate-aria-label="ACTIONS.DIALOG_CLOSE">\n<md-icon md-font-icon="icon-close"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div \nlayout="row" layout-wrap><div flex="100" flex-gt-xs="50" class="p-5 lookup-element"><md-autocomplete \nid="dialog_input_1" md-input-name="PriceGroupId" md-selected-item="vm.lookupModel.PriceGroupId" \nmd-items="item in vm.lookupSearch(vm.searchText.PriceGroupId, \'PriceGroupId\', \'catalogs.priceGroup\')" \nmd-search-text="vm.searchText.PriceGroupId" \nmd-item-text="vm.getLookupDisplayValue(item, \'PriceGroupId\', \'catalogs.priceGroup\')" md-min-length="0" \nmd-floating-label="{{\'PRICES_LINEAR.FIELDS.PRICEGROUP_ID\' | translate}}" ng-disabled="true" md-no-cache="true" \ntx-clear-autocomplete tx-force-select md-menu-class="autocomplete-custom"><md-item-template><span \nclass="autocomplete-item md-accent-fg" md-highlight-text="vm.searchText.PriceGroupId" md-highlight-flags="i">\n{{item.value}}</span></md-item-template></md-autocomplete></div><div class="p-5" flex="100" flex-gt-xs="50">\n<md-input-container class="md-block"><div class="external-change-message" ng-if="vm.priceGroupNonEditable"><span>\n{{ \'ARTICLES.MESSAGES.NON_EDITABLE_PRICE_GROUP\' | translate }} </span><span \nng-if="vm.isAllowChangeRequestEnabled && vm.updatePricesChangeManagementExternalURL !== \'\'">\n{{ \'ARTICLES.MESSAGES.NON_EDITABLE_PRICE_GROUP_EXTERNAL_URL\' | translate }} <a \nhref="{{vm.updatePricesChangeManagementExternalURL}}" target="_blank">here</a></span></div><label>\n{{ \'PRICES_LINEAR.FIELDS.PRICE\' | translate}}</label><input name="price" ng-model="vm.record.Price" type="number" \nmd-maxlength="-1" md-autofocus="$first" \nng-pattern="vm.record.isMandatory\r\n\t\t\t\t\t\t\t\t? \'^[+]?((\\\\d*[1-9]\\\\d*)([.]\\\\d{0,\' + vm.numberOfDecimalsForPrices + \'})?)$\'\r\n\t\t\t\t\t\t\t\t: \'^[+]?\\\\d+([.]\\\\d{0,\' + vm.numberOfDecimalsForPrices + \'})?$\'" \nng-required="vm.record.isMandatory" ng-disabled="vm.record.readOnly"><div ng-messages="vm.editForm.price.$error" \nrole="alert" multiple="multiple"><div ng-message="pattern" \ntranslate="{{ vm.record.isMandatory ? \'VALIDATIONS.PRICE_GREATER_THAN_ZERO\' : \'VALIDATIONS.PRICE\' }}" \ntranslate-values="{numberOfDecimalsForPrices: vm.numberOfDecimalsForPrices}"></div><div ng-message="required">\n{{\'VALIDATIONS.REQUIRED\' | translate}}</div></div></md-input-container></div></div></md-dialog-content>\n<md-dialog-actions layout="row" layout-align="end center"><div></div><div layout="row" layout-align="end center">\n<md-button ng-click="vm.closeDialog(false)" class="send-button md-primary md-raised" aria-label="Cancel" \ntranslate="ACTIONS.DIALOG_CANCEL" translate-attr-aria-label="ACTIONS.DIALOG_CANCEL" ng-disabled="vm.isLoading">CANCEL\n</md-button><md-button ng-click="vm.saveRecord()" class="send-button md-accent md-raised" aria-label="Save" \ntranslate="ACTIONS.SAVE" translate-attr-aria-label="ACTIONS.SAVE" ng-disabled="vm.isLoading || vm.editForm.$invalid">\nSAVE</md-button></div></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/catalogs/sub-modules/reports/article-prices/list/article-prices-list.html','<div id="articles-prices-list" class="page-layout carded fullwidth list-view" layout="row"><div class="center" \nlayout="column" flex><div class="content-card" layout="column" flex><tx-data-table tx-data="vm.articlePrices" \ntx-model="vm.model" tx-view="mainList" tx-filtered-data="vm.filteredArticlePrices" tx-data-filter="global.search" \ntx-item-click-event="vm.viewItem(item)" tx-is-loading="vm.isLoading" \ntx-refresh-action-event="vm.refreshItems(true, false)"></tx-data-table></div></div></div>');
$templateCache.put('app/main/catalogs/sub-modules/reports/article-status/list/article-status-list.html','<div id="articles-status-list" class="page-layout carded fullwidth list-view" layout="row"><div class="center" \nlayout="column" flex><div class="content-card" layout="column" flex><tx-data-table tx-data="vm.articleStatus" \ntx-model="vm.model" tx-view="mainList" tx-filtered-data="vm.filteredArticleStatus" tx-data-filter="global.search" \ntx-item-click-event="vm.viewItem(item)" tx-is-loading="vm.isLoading" \ntx-refresh-action-event="vm.refreshItems(true, false)"></tx-data-table></div></div></div>');
$templateCache.put('app/main/catalogs/sub-modules/segmentation/dialogs/update-segmentations/update-segmentations.html','<md-dialog class="edit-dialog" aria-label="Update Segmentations"><form name="vm.editForm" class="md-inline-form">\n<md-toolbar class="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" layout-align="space-between center">\n<span class="title" translate="SEGMENTATION.ACTIONS.UPDATE_SEGMENTATIONS">Update Segmentations</span><md-button \nclass="md-icon-button" ng-click="vm.closeDialog(false)" aria-label="Close dialog" tranlate \ntranslate-aria-label="ACTIONS.DIALOG_CLOSE"><md-icon md-font-icon="icon-close"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div class="import-search-container" layout="row"><md-input-container \nflex-gt-xs="100" flex="100"><md-icon class="s18" md-font-icon="icon-magnify"></md-icon><input \nng-model="vm.searchPageText" type="search" placeholder="Search" md-autofocus ng-change="vm.onSearchTextChanged()">\n</md-input-container></div><div flex="100" flex-gt-xs="50" class="p-5" ng-if="vm.isSegmentationGroup">\n<md-input-container ng-if="vm.isSegmentationGroup" class="md-block"><label translate>\nSEGMENTATION.FIELDS.SEGMENTATION_GROUP</label><md-select id="dialog_input_{{$first ? \'first\' : $index}}" \nname="SegmentationGroup" ng-model="vm.SegmentationGroup.SegmentationGroup" \nplaceholder="{{\'SEGMENTATION.FIELDS.SEGMENTATION_GROUP\' | translate}}" ng-change="vm.onSegmentationGroupChange()" \nmd-autofocus="$first"><md-option ng-value="option.SegmentationGroup" ng-repeat="option in vm.SegmentationGroupList">\n{{ option.SegmentationGroup }}</md-option></md-select></md-input-container></div><div layout="row" layout-wrap \nlayout-align="space-between center"><md-switch ng-model="vm.open" \naria-label="{{\'SEGMENTATION.ACTIONS.OPEN_ALL_SEGMENTAIONS\' | translate}}" ng-true-value="1" ng-false-value="0" \nclass="md-accent" ng-change="vm.onOpenValueChange(vm.open)">\n{{\'SEGMENTATION.ACTIONS.OPEN_ALL_SEGMENTAIONS\' | translate}}</md-switch></div><div layout="row" layout-wrap \nlayout-align="space-between center"><div ng-repeat="record in vm.filteredEditableFields track by $index" class="p-5" \nlayout="row" layout-wrap layout-align="space-between center" flex="100" \nflex-gt-xs="{{vm.isSegmentationPlanningEnable}} ? 50 : 100"><md-switch ng-model="record.value" \naria-label="{{record.displayLabel}}" ng-change="vm.onSegmentationValueChange(record)" class="md-accent">\n{{record.displayLabel}}</md-switch><md-input-container ng-if="vm.isSegmentationPlanningEnable && record.value" \nclass="md-block" flex="50" flex-xs="100"><label translate>SEGMENTATION.FIELDS.PLANNING_VALUE</label><md-select \nng-model="record.PlanningValue" placeholder="{{\'SEGMENTATION.FIELDS.PLANNING_VALUE\' | translate}}" required \nng-change="vm.onPlanningValueChange(record)"><md-option ng-repeat="planningValue in vm.planningValue" \nng-value="planningValue">{{ planningValue}}</md-option></md-select></md-input-container></div></div>\n</md-dialog-content><md-dialog-actions layout="row" layout-align="end center"><div></div><div layout="row" \nlayout-align="end center"><md-button ng-click="vm.closeDialog(false)" class="send-button md-primary md-raised" \naria-label="Cancel" translate="ACTIONS.DIALOG_CANCEL" translate-attr-aria-label="ACTIONS.DIALOG_CANCEL" \nng-disabled="vm.isLoading">CANCEL</md-button><md-button ng-click="vm.saveRecord()" \nclass="send-button md-accent md-raised" aria-label="Save" translate="ACTIONS.SAVE" \ntranslate-attr-aria-label="ACTIONS.SAVE" ng-disabled="vm.isLoading || vm.editForm.$invalid || !vm.changedCount">SAVE\n</md-button></div></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/catalogs/sub-modules/segmentation-linear/dialogs/assign-article-segmentation/assign-article-segmentation.html','<md-dialog class="edit-dialog" aria-label="Assign Delivery Dates"><form name="vm.editForm" class="md-inline-form">\n<md-toolbar class="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" layout-align="space-between center">\n<span class="title" translate="{{\'SEGMENTATION_LINEAR.TITLES.ASSIGN_ARTICLE_SEGMENTATIONS\'}}">\nAssign Article Segmentations</span><md-button class="md-icon-button" ng-click="vm.closeDialog(vm.isDataDirty)" \naria-label="Close dialog" tranlate translate-aria-label="ACTIONS.DIALOG_CLOSE"><md-icon md-font-icon="icon-close">\n</md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div layout="row" layout-wrap><div flex="100" \nclass="p-5 lookup-element"><md-input-container class="md-block"><label>\n{{\'CRD_LINEAR.FIELDS.ARTICLE_NUMBER\' | translate}}</label><md-chips id="dialog_input_1" name="ArticleId" \nng-model="vm.record.ArticleId" md-autocomplete-snap md-transform-chip="vm.transformChip($chip)" \nmd-require-match="true" ng-required="true"><md-autocomplete md-selected-item="vm.acSelectedItem.ArticleId" \nmd-search-text="vm.acSearchText.ArticleId" \nmd-items="item in vm.acQuerySearch(vm.acSearchText.ArticleId, vm.record.ArticleId, \'ArticleId\')" \nmd-item-text="item.value" md-min-length="0" md-no-cache="true" md-menu-class="autocomplete-custom"><md-item-template>\n<span class="autocomplete-item md-accent-fg" md-highlight-text="vm.acSearchText.ArticleId">{{item.value}}</span>\n</md-item-template><md-not-found>No Record matching "{{vm.acSearchText.ArticleId}}" were found.</md-not-found>\n</md-autocomplete><md-chip-template><span><strong>{{vm.getChipDisplayValue($chip, \'ArticleId\')}}</strong></span>\n</md-chip-template></md-chips></md-input-container></div><div flex="100" class="p-5"><md-switch ng-model="vm.open" \naria-label="{{\'SEGMENTATION.ACTIONS.OPEN_ALL_SEGMENTAIONS\' | translate}}" ng-true-value="1" ng-false-value="0" \nclass="md-accent" ng-change="vm.onOpenValueChange(vm.open, \'SegmentationId\')">\n{{\'SEGMENTATION.ACTIONS.OPEN_ALL_SEGMENTAIONS\' | translate}}</md-switch></div><div flex="100" \nclass="p-5 lookup-element"><md-input-container class="md-block"><label>\n{{\'SEGMENTATION_LINEAR.FIELDS.SEGMENTATION_NAME\' | translate}}</label><md-chips id="dialog_input_2" \nname="SegmentationId" ng-model="vm.record.SegmentationId" md-autocomplete-snap \nmd-transform-chip="vm.transformChip($chip)" md-require-match="true" ng-required="true"><md-autocomplete \nmd-selected-item="vm.acSelectedItem.SegmentationId" md-search-text="vm.acSearchText.SegmentationId" \nmd-items="item in vm.acQuerySearch(vm.acSearchText.SegmentationId, vm.record.SegmentationId, \'SegmentationId\')" \nmd-item-text="item.value" md-min-length="0" md-no-cache="true" md-menu-class="autocomplete-custom"><md-item-template>\n<span class="autocomplete-item md-accent-fg" md-highlight-text="vm.acSearchText.SegmentationId">{{item.value}}</span>\n</md-item-template><md-not-found>No Record matching "{{vm.acSearchText.SegmentationId}}" were found.</md-not-found>\n</md-autocomplete><md-chip-template><span><strong>{{vm.getChipDisplayValue($chip, \'SegmentationId\')}}</strong></span>\n</md-chip-template></md-chips></md-input-container></div></div></md-dialog-content><md-dialog-actions layout="row" \nlayout-align="end center"><div></div><div layout="row" layout-align="end center"><md-button \nng-click="vm.closeDialog(vm.isDataDirty)" class="send-button md-primary md-raised" aria-label="Cancel" \ntranslate="ACTIONS.DIALOG_CANCEL" translate-attr-aria-label="ACTIONS.DIALOG_CANCEL" ng-disabled="vm.isLoading">CANCEL\n</md-button><md-button ng-click="vm.saveRecord()" class="send-button md-accent md-raised" aria-label="Save" \ntranslate="ACTIONS.SAVE" translate-attr-aria-label="ACTIONS.SAVE" ng-disabled="vm.isLoading || vm.editForm.$invalid">\nSAVE</md-button></div></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/catalogs/sub-modules/shared-folders/dialogs/add-update-shared-folder/add-update-shared-folder.html','<md-dialog class="edit-dialog" aria-label="Create Shared Folder"><form name="vm.editForm" class="md-inline-form">\n<md-toolbar class="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" layout-align="space-between center">\n<span ng-if="!vm.isToggleSharing && !vm.fromUsers" class="title" \ntranslate="{{ vm.isNew ? \'SHARED_FOLDERS.TITLES.CREATE_SHARED_FOLDER\': \'SHARED_FOLDERS.TITLES.UPDATE_SHARED_FOLDER\' }}">\n{{vm.isNew ? \'Create Shared Folder\' : \'Update Shared Folder\'}}</span> <span ng-if="vm.isToggleSharing" class="title" \ntranslate="{{ \'SHARED_FOLDERS.TITLES.TOGGLE_SHARING\' }}">Toggle Sharing </span><span ng-if="vm.fromUsers" \nclass="title" translate="{{ \'SHARED_FOLDERS.TITLES.ADD_USERS\' }}">Add Users</span><md-button class="md-icon-button" \nng-click="vm.closeDialog(vm.isDataDirty)" aria-label="Close dialog" tranlate \ntranslate-aria-label="ACTIONS.DIALOG_CLOSE"><md-icon md-font-icon="icon-close"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div layout="row" layout-align="center center" ng-show="vm.isLoading" \nstyle="height: inherit"><md-progress-circular md-mode="indeterminate" class="md-accent"></md-progress-circular></div>\n<div layout="row" ng-show="!vm.isLoading" layout-wrap><div flex="100" flex-gt-xs="50" class="p-5" \nng-if="!vm.isToggleSharing && !vm.fromUsers"><md-input-container class="md-block"><label translate>\nSHARED_FOLDERS.FIELDS.NAME</label><input id="dialog_input_first" name="Name" ng-model="vm.record.Name" type="text" \nng-required="true" md-autofocus tx-unique-value="vm.existingRecordsForUniqueValue:Name:true"><div \nng-messages="vm.editForm.Name.$error" role="alert" multiple="multiple"><div ng-message="required">\n{{\'VALIDATIONS.REQUIRED\' | translate}}</div><div ng-message="tx-unique-value">{{\'VALIDATIONS.NOT_UNIQUE\' | translate}}\n</div></div></md-input-container></div><div flex="100" flex-gt-xs="50" class="p-5" \nng-if="vm.isNew && !vm.isToggleSharing"><md-autocomplete id="dialog_input_{{$index}}" md-input-name="Entity" \nmd-selected-item="vm.lookupModel.Entity" md-items="item in vm.entityLookupSearch(vm.searchText[\'Entity\'])" \nmd-search-text="vm.searchText.Entity" \nmd-item-text="vm.getEntityLookupDisplayValue(item, \'Entity\', \'lists.entityList\')" md-min-length="0" \nmd-floating-label="{{\'SHARED_FOLDERS.FIELDS.ENTITY\' | translate}}" \nmd-selected-item-change="vm.entityLookupChange(item, \'Entity\')" ng-required="true" md-no-cache="true" \ntx-clear-autocomplete ng-click="vm.selectText($event)" md-menu-class="autocomplete-custom"><md-item-template><span \nclass="autocomplete-item md-accent-fg" md-highlight-text="vm.searchText.Entity" md-highlight-flags="i">{{item.value}}\n</span></md-item-template><div ng-messages="vm.editForm.Entity.$error" role="alert" \nng-show="vm.editForm.Entity.$touched"><div ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div></div>\n<md-not-found>No Record matching "{{vm.searchText.Entity}}" were found.</md-not-found></md-autocomplete></div><div \nflex="100" flex-gt-xs="100" class="p-5" \nng-if="(vm.isNew && (vm.record.ParentFolderId === null || vm.record.ParentFolderId === 0)) || vm.isToggleSharing || vm.fromUsers">\n<fieldset><legend class="header-non-editable-attributes" translate>SHARED_FOLDERS.FIELDS.USERS</legend><div \nng-repeat="record in vm.record.Users" flex="100" layout="row" layout-wrap ng-if="!record.hidden"><div flex="100" \nflex-gt-xs="70" class="p-5 lookup-element"><md-autocomplete id="dialog_input_{{$index}}" md-input-name="UserId" \nmd-selected-item="vm.lookupModel[$index].UserId" \nmd-items="item in vm.lookupSearch(vm.searchText[$index].UserId, \'UserId\', \'lists.accessibleUsers\', {\'Status\': 1})" \nmd-search-text="vm.searchText[$index].UserId" \nmd-item-text="vm.getLookupDisplayValue(item, \'Users\', \'lists.accessibleUsers\')" md-min-length="0" \nmd-floating-label="{{\'SHARED_FOLDERS.FIELDS.USER\' | translate}} {{$index + 1}}" md-no-cache="true" \ntx-clear-autocomplete ng-click="vm.selectText($event)" \nmd-selected-item-change="vm.lookupChange(vm.lookupModel[$index].UserId, \'UserId\', $index)" \nmd-menu-class="autocomplete-custom" ng-required="false" ng-disabled="record.disable"><md-item-template><span \nclass="autocomplete-item md-accent-fg" md-highlight-text="vm.searchText[$index].UserId" md-highlight-flags="i">\n{{item.value}}</span></md-item-template><md-not-found>No Record matching "{{vm.searchText[$index].UserId}}" were found.\n</md-not-found></md-autocomplete></div><div flex="100" flex-gt-xs="30" class="p-5"><md-switch \nng-model="vm.record.Users[$index].AllowSharing" id="dialog_input_{{$index}}" \naria-label="{{\'SHARED_FOLDERS.FIELDS.ALLOW_SHARING\' | translate}}" ng-true-value="1" ng-false-value="0" \nclass="md-accent">{{\'SHARED_FOLDERS.FIELDS.ALLOW_SHARING\' | translate}}<md-tooltip md-direction="right">\n{{vm.record.Users[$index].AllowSharing === 1 ? \'PARTS.YES\' : \'PARTS.NO\' | translate}}</md-tooltip></md-switch></div>\n</div></fieldset></div></div></md-dialog-content><md-dialog-actions layout="row" layout-align="end center"><div></div>\n<div layout="row" layout-align="end center"><md-button ng-click="vm.closeDialog(vm.isDataDirty)" \nclass="send-button md-primary md-raised" aria-label="Cancel" translate="ACTIONS.DIALOG_CANCEL" \ntranslate-attr-aria-label="ACTIONS.DIALOG_CANCEL" ng-disabled="vm.isLoading || vm.isLookupLoading">CANCEL</md-button>\n<md-button ng-click="vm.saveRecord()" class="send-button md-accent md-raised" aria-label="Save" \ntranslate="ACTIONS.SAVE" translate-attr-aria-label="ACTIONS.SAVE" \nng-disabled="vm.isLoading || vm.isLookupLoading || vm.editForm.$invalid">SAVE</md-button></div></md-dialog-actions>\n</form></md-dialog>');
$templateCache.put('app/main/catalogs/sub-modules/tree-list/dialogs/update-sort-order/update-sort-order.html','<md-dialog class="edit-dialog" aria-label="Update Sort Order"><form name="vm.editForm" class="md-inline-form">\n<md-toolbar class="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" layout-align="space-between center">\n<span class="title" translate="CATALOG_TREE.ACTIONS.EDIT_SORT_ORDER">Update Sort Order</span><md-button \nclass="md-icon-button" ng-click="vm.closeDialog(false)" aria-label="Close dialog" tranlate \ntranslate-aria-label="ACTIONS.DIALOG_CLOSE"><md-icon md-font-icon="icon-close"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div flex="100" flex-gt-xs="50" class="p-5"><md-input-container \nclass="md-block"><label>{{\'CATALOG_TREE.FIELDS.SORT_ORDER \'| translate}}</label><input id="dialog_input_1" \nname="SortOrder" ng-model="vm.record.SortOrder" type="number" md-autofocus="true" min="{{vm.min}}" max="{{vm.max}}" \nrequired><div ng-messages="vm.editForm.SortOrder.$error" role="alert" multiple="multiple"><div ng-message="required">\n{{field.validation.messages.isRequired | translate}}</div><div ng-message="min" \ntranslate="CATALOG_TREE.VALIDATIONS.MIN" translate-values="{min: vm.min}"></div><div ng-message="max" \ntranslate="CATALOG_TREE.VALIDATIONS.MAX" translate-values="{max: vm.max}"></div></div></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout="row" layout-align="end center"><div></div><div layout="row" \nlayout-align="end center"><md-button ng-click="vm.closeDialog(false)" class="send-button md-primary md-raised" \naria-label="Cancel" translate="ACTIONS.DIALOG_CANCEL" translate-attr-aria-label="ACTIONS.DIALOG_CANCEL" \nng-disabled="vm.isLoading">CANCEL</md-button><md-button ng-click="vm.saveRecord()" \nclass="send-button md-accent md-raised" aria-label="Save" translate="ACTIONS.SAVE" \ntranslate-attr-aria-label="ACTIONS.SAVE" ng-disabled="vm.isLoading || vm.editForm.$invalid">SAVE</md-button></div>\n</md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/customers/details/tabs/catalogs/dialogs/update-customer-catalog-relation.html','<md-dialog class="edit-dialog" aria-label="{{vm.isNew ? \'Link Catalog\' : \'Edit Linked Catalog\'}"><form \nname="vm.editForm" class="md-inline-form"><md-toolbar class="md-accent md-hue-2"><div class="md-toolbar-tools" \nlayout="row" layout-align="space-between center"><span class="title" \ntranslate="{{vm.isNew ? \'CUSTOMERS.TITLES.LINK_CATALOG\' : \'CUSTOMERS.TITLES.UPDATE_LINKED_CATALOG\'}}">New Record</span>\n<md-button class="md-icon-button" ng-click="vm.closeDialog(vm.isDataDirty)" aria-label="Close dialog" tranlate \ntranslate-aria-label="ACTIONS.DIALOG_CLOSE"><md-icon md-font-icon="icon-close"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div layout="row" layout-wrap><div flex="100" flex-gt-xs="50" \nclass="p-5 lookup-element" ng-if="vm.isNew"><md-autocomplete id="dialog_input_first" md-input-name="CatalogCode" \nmd-selected-item="vm.acLookupModel.CatalogCode" \nmd-items="item in vm.catLookupSearch(vm.searchText.CatalogCode, \'CatalogCode\', vm.activeCatalogs)" \nmd-search-text="vm.searchText.CatalogCode" md-item-text="vm.getCatLookupDisplayValue(item, \'CatalogCode\')" \nmd-min-length="0" md-floating-label="{{\'CATALOGS.FIELDS.CATALOG_NAME\' | translate}}" \nmd-selected-item-change="vm.catLookupChange(vm.acLookupModel.CatalogCode, \'CatalogCode\')" ng-required="true" \nmd-no-cache="true" tx-clear-autocomplete tx-force-select ng-click="vm.selectText($event)" \nmd-menu-class="autocomplete-custom" md-autofocus="vm.isNew"><md-item-template><span \nclass="autocomplete-item md-accent-fg" md-highlight-text="vm.searchText.CatalogCode" md-highlight-flags="i">\n{{item[vm.sellerCatalogModel.lookupDisplayField]}}</span></md-item-template><md-not-found>\nNo Record matching "{{vm.searchText.CatalogCode}}" were found.</md-not-found><div \nng-messages="vm.editForm.CatalogCode.$error" role="alert" ng-show="vm.editForm.CatalogCode.$touched"><div \nng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div></div></md-autocomplete></div><div flex="100" \nflex-gt-xs="50" class="p-5 lookup-element"><md-autocomplete id="dialog_input_1" md-input-name="WholesalePriceGroupId" \nmd-selected-item="vm.acLookupModel.WholesalePriceGroupId" \nmd-items="item in vm.pgLookupSearch(vm.searchText.WholesalePriceGroupId, \'WholesalePriceGroupId\', vm.activeCustomers)" \nmd-search-text="vm.searchText.WholesalePriceGroupId" \nmd-item-text="vm.getPgLookupDisplayValue(item, \'WholesalePriceGroupId\')" md-min-length="0" \nmd-floating-label="{{\'CUSTOMERS.FIELDS.WHOLESALE_PRICE_GROUP\' | translate}}" \nmd-selected-item-change="vm.pgLookupChange(vm.acLookupModel.WholesalePriceGroupId, \'WholesalePriceGroupId\')" \nng-required="!vm.record.RetailPriceGroupId" md-no-cache="true" tx-clear-autocomplete ng-click="vm.selectText($event)" \nng-disabled="!vm.record.CatalogCode" md-menu-class="autocomplete-custom"><md-item-template><span \nclass="autocomplete-item md-accent-fg" md-highlight-text="vm.searchText.WholesalePriceGroupId" md-highlight-flags="i">\n{{item[vm.priceGroupModel.lookupDisplayField]}}</span></md-item-template><md-not-found>\nNo Record matching "{{vm.searchText.WholesalePriceGroupId}}" were found.</md-not-found><div \nng-messages="vm.editForm.WholesalePriceGroupId.$error" role="alert" \nng-show="vm.editForm.WholesalePriceGroupId.$touched"><div ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}\n</div></div></md-autocomplete></div><div flex="100" flex-gt-xs="50" class="p-5 lookup-element"><md-autocomplete \nid="dialog_input_2" md-input-name="WholesaleAltPriceGroupId" \nmd-selected-item="vm.acLookupModel.WholesaleAltPriceGroupId" \nmd-items="item in vm.pgLookupSearch(vm.searchText.WholesaleAltPriceGroupId, \'WholesaleAltPriceGroupId\', vm.activeCustomers)" \nmd-search-text="vm.searchText.WholesaleAltPriceGroupId" \nmd-item-text="vm.getPgLookupDisplayValue(item, \'WholesaleAltPriceGroupId\')" md-min-length="0" \nmd-floating-label="{{\'CUSTOMERS.FIELDS.WHOLESALE_ALT_PRICE_GROUP\' | translate}}" \nmd-selected-item-change="vm.pgLookupChange(vm.acLookupModel.WholesaleAltPriceGroupId, \'WholesaleAltPriceGroupId\')" \nng-required="false" md-no-cache="true" tx-clear-autocomplete ng-click="vm.selectText($event)" \nng-disabled="!vm.record.CatalogCode" md-menu-class="autocomplete-custom"><md-item-template><span \nclass="autocomplete-item md-accent-fg" md-highlight-text="vm.searchText.WholesaleAltPriceGroupId" \nmd-highlight-flags="i">{{item[vm.priceGroupModel.lookupDisplayField]}}</span></md-item-template><md-not-found>\nNo Record matching "{{vm.searchText.WholesaleAltPriceGroupId}}" were found.</md-not-found><div \nng-messages="vm.editForm.WholesaleAltPriceGroupId.$error" role="alert" \nng-show="vm.editForm.WholesaleAltPriceGroupId.$touched"><div ng-message="required">\n{{\'VALIDATIONS.REQUIRED\' | translate}}</div></div></md-autocomplete></div><div flex="100" flex-gt-xs="50" \nclass="p-5 lookup-element"><md-autocomplete id="dialog_input_3" md-input-name="RetailPriceGroupId" \nmd-selected-item="vm.acLookupModel.RetailPriceGroupId" \nmd-items="item in vm.pgLookupSearch(vm.searchText.RetailPriceGroupId, \'RetailPriceGroupId\', vm.activeCustomers)" \nmd-search-text="vm.searchText.RetailPriceGroupId" \nmd-item-text="vm.getPgLookupDisplayValue(item, \'RetailPriceGroupId\')" md-min-length="0" \nmd-floating-label="{{\'CUSTOMERS.FIELDS.RETAIL_PRICE_GROUP\' | translate}}" \nmd-selected-item-change="vm.pgLookupChange(vm.acLookupModel.RetailPriceGroupId, \'RetailPriceGroupId\')" \nng-required="!vm.record.WholesalePriceGroupId" md-no-cache="true" tx-clear-autocomplete \nng-click="vm.selectText($event)" ng-disabled="!vm.record.CatalogCode" md-menu-class="autocomplete-custom">\n<md-item-template><span class="autocomplete-item md-accent-fg" md-highlight-text="vm.searchText.RetailPriceGroupId" \nmd-highlight-flags="i">{{item[vm.priceGroupModel.lookupDisplayField]}}</span></md-item-template><md-not-found>\nNo Record matching "{{vm.searchText.RetailPriceGroupId}}" were found.</md-not-found><div \nng-messages="vm.editForm.RetailPriceGroupId.$error" role="alert" ng-show="vm.editForm.RetailPriceGroupId.$touched"><div\n ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div></div></md-autocomplete></div><div flex="100" \nflex-gt-xs="50" class="p-5 lookup-element"><md-autocomplete id="dialog_input_4" md-input-name="RetailAltPriceGroupId" \nmd-selected-item="vm.acLookupModel.RetailAltPriceGroupId" \nmd-items="item in vm.pgLookupSearch(vm.searchText.RetailAltPriceGroupId, \'RetailAltPriceGroupId\', vm.activeCustomers)" \nmd-search-text="vm.searchText.RetailAltPriceGroupId" \nmd-item-text="vm.getPgLookupDisplayValue(item, \'RetailAltPriceGroupId\')" md-min-length="0" \nmd-floating-label="{{\'CUSTOMERS.FIELDS.RETAIL_ALT_PRICE_GROUP\' | translate}}" \nmd-selected-item-change="vm.pgLookupChange(vm.acLookupModel.RetailAltPriceGroupId, \'RetailAltPriceGroupId\')" \nng-required="false" md-no-cache="true" tx-clear-autocomplete ng-click="vm.selectText($event)" \nng-disabled="!vm.record.CatalogCode" md-menu-class="autocomplete-custom"><md-item-template><span \nclass="autocomplete-item md-accent-fg" md-highlight-text="vm.searchText.RetailAltPriceGroupId" md-highlight-flags="i">\n{{item[vm.priceGroupModel.lookupDisplayField]}}</span></md-item-template><md-not-found>\nNo Record matching "{{vm.searchText.RetailAltPriceGroupId}}" were found.</md-not-found><div \nng-messages="vm.editForm.RetailAltPriceGroupId.$error" role="alert" \nng-show="vm.editForm.RetailAltPriceGroupId.$touched"><div ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}\n</div></div></md-autocomplete></div><div flex="100" flex-gt-xs="50" class="p-5 lookup-element"><md-autocomplete \nid="dialog_input_5" md-input-name="AccountManager1" md-selected-item="vm.acLookupModel.AccountManager1" \nmd-items="item in vm.usersLookupSearch(vm.searchText.AccountManager1)" md-search-text="vm.searchText.AccountManager1" \nmd-item-text="vm.getUserLookupDisplayValue(item)" md-min-length="0" \nmd-floating-label="{{\'CUSTOMERS.FIELDS.ACCOUNT_MANAGER_1\' | translate}}" \nmd-selected-item-change="vm.userLookupChange(vm.acLookupModel.AccountManager1, \'AccountManager1\')" ng-required="true" \nmd-no-cache="true" tx-clear-autocomplete tx-force-select ng-click="vm.selectText($event)" \nmd-menu-class="autocomplete-custom"><md-item-template><span class="autocomplete-item md-accent-fg" \nmd-highlight-text="vm.searchText.AccountManager1" md-highlight-flags="i">\n{{item[vm.sellerUsersModel.lookupDisplayField]}}</span></md-item-template><md-not-found>\nNo Record matching "{{vm.searchText.AccountManager1}}" were found.</md-not-found><div \nng-messages="vm.editForm.AccountManager1.$error" role="alert" ng-show="vm.editForm.AccountManager1.$touched"><div \nng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div></div></md-autocomplete></div><div flex="100" \nflex-gt-xs="50" class="p-5 lookup-element"><md-autocomplete id="dialog_input_6" md-input-name="AccountManager2" \nmd-selected-item="vm.acLookupModel.AccountManager2" \nmd-items="item in vm.usersLookupSearch(vm.searchText.AccountManager2)" md-search-text="vm.searchText.AccountManager2" \nmd-item-text="vm.getUserLookupDisplayValue(item)" md-min-length="0" \nmd-floating-label="{{\'CUSTOMERS.FIELDS.ACCOUNT_MANAGER_2\' | translate}}" \nmd-selected-item-change="vm.userLookupChange(vm.acLookupModel.AccountManager2, \'AccountManager2\')" ng-required="true" \nmd-no-cache="true" tx-clear-autocomplete tx-force-select ng-click="vm.selectText($event)" \nmd-menu-class="autocomplete-custom"><md-item-template><span class="autocomplete-item md-accent-fg" \nmd-highlight-text="vm.searchText.AccountManager2" md-highlight-flags="i">\n{{item[vm.sellerUsersModel.lookupDisplayField]}}</span></md-item-template><md-not-found>\nNo Record matching "{{vm.searchText.AccountManager2}}" were found.</md-not-found><div \nng-messages="vm.editForm.AccountManager2.$error" role="alert" ng-show="vm.editForm.AccountManager2.$touched"><div \nng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div></div></md-autocomplete></div><div flex="100" \nflex-gt-xs="50" class="p-5"><md-input-container class="md-block"><label translate>CUSTOMERS.FIELDS.ORDER_PRICE_GROUP\n</label><md-select name="OrderPriceGroupId" placeholder="{{\'CUSTOMERS.FIELDS.ORDER_PRICE_GROUP\' | translate}}" \nng-model="vm.orderPriceGroup" style="min-width: 200px" \nng-disabled="!vm.record.RetailPriceGroupId && !vm.record.WholesalePriceGroupId" ng-required="true"><md-option \nng-value="1" ng-if="vm.record.WholesalePriceGroupId">{{\'CUSTOMERS.FIELDS.WHOLESALE_PRICE_GROUP\' | translate}}\n</md-option><md-option ng-value="2" ng-if="vm.record.RetailPriceGroupId">\n{{\'CUSTOMERS.FIELDS.RETAIL_PRICE_GROUP\' | translate}}</md-option></md-select><div \nng-messages="vm.editForm.OrderPriceGroupId.$error" role="alert" ng-show="vm.editForm.OrderPriceGroupId.$touched"><div \nng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div></div></md-input-container></div></div>\n</md-dialog-content><md-dialog-actions layout="row" layout-align="end center"><div></div><div layout="row" \nlayout-align="end center"><md-button ng-click="vm.closeDialog(vm.isDataDirty)" \nclass="send-button md-primary md-raised" aria-label="Cancel" translate="ACTIONS.DIALOG_CANCEL" \ntranslate-attr-aria-label="ACTIONS.DIALOG_CANCEL" ng-disabled="vm.isLoading">CANCEL</md-button><md-button \nng-click="vm.saveRecord()" class="send-button md-accent md-raised" aria-label="Save" translate="ACTIONS.SAVE" \ntranslate-attr-aria-label="ACTIONS.SAVE" ng-disabled="vm.isLoading || vm.editForm.$invalid">SAVE</md-button><md-button \nng-click="vm.saveRecord(true)" class="send-button md-accent md-raised" aria-label="Save" \ntranslate="ACTIONS.SAVE_AND_NEW" translate-attr-aria-label="ACTIONS.SAVE_AND_NEW" \nng-disabled="vm.isLoading || vm.editForm.$invalid" ng-show="vm.isNew">SAVE</md-button></div></md-dialog-actions></form>\n</md-dialog>');
$templateCache.put('app/main/roles/details/tabs/privileges/dialogs/manage-privileges.html','<md-dialog class="privileges-dialog" aria-label="Manage Privileges" style="min-width:80%;min-height:80%"><form \nname="vm.editForm" class="md-inline-form"><md-toolbar id="titlebar" class="md-accent md-hue-2"><div \nclass="md-toolbar-tools" layout="row" layout-align="space-between center"><span class="title" \ntranslate="PRIVILEGES.TITLES.MANAGE_PRIVILEGES">Manage Privileges</span><md-button class="md-icon-button" \nng-click="vm.closeDialog(false)" aria-label="Close dialog" tranlate translate-aria-label="ACTIONS.DIALOG_CLOSE">\n<md-icon md-font-icon="icon-close"></md-icon></md-button></div></md-toolbar><md-dialog-content><div \nclass="content-card" layout="column" flex><tx-data-grid tx-data="vm.privilegesList" tx-model="vm.model" \ntx-assigned-records="::vm.assignedPrivileges" tx-view-type="checklistView" tx-primary-property="discription" \ntx-secondary-property="Id" tx-hover-property="discription" tx-is-loading="vm.isLoading" \ntx-selected-records="vm.selectedPrivileges" tx-advanced-search="true"></tx-data-grid></div></md-dialog-content>\n<md-dialog-actions layout="row" layout-align="end center" id="actionbar"><div></div><div layout="row" \nlayout-align="end center"><md-button ng-click="vm.closeDialog(false)" class="send-button md-primary md-raised" \naria-label="Cancel" translate="ACTIONS.DIALOG_CANCEL" translate-attr-aria-label="ACTIONS.DIALOG_CANCEL" \nng-disabled="vm.isSaving">CANCEL</md-button><md-button ng-click="vm.saveRecord()" \nclass="send-button md-accent md-raised" aria-label="Save" translate="ACTIONS.SAVE" \ntranslate-attr-aria-label="ACTIONS.SAVE" ng-disabled="vm.isSaving">SAVE</md-button></div></md-dialog-actions></form>\n</md-dialog>');
$templateCache.put('app/main/seller-models/details/tabs/seller-model-resources/dialogs/assign-seller-model-resources.html','<md-dialog class="edit-dialog" aria-label="Assign Resources"><form name="vm.editForm" class="md-inline-form">\n<md-toolbar class="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" layout-align="space-between center">\n<span class="title" translate="TITLES.RECORD_NEW">Assign Resources</span><md-button class="md-icon-button" \nng-click="vm.closeDialog()" aria-label="Close dialog" translate-aria-label="ACTIONS.DIALOG_CLOSE"><md-icon \nmd-font-icon="icon-close"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div layout="row" \nlayout-wrap><div flex="100" class="p-5 lookup-element"><md-input-container class="md-block"><label translate>\n{{ \'RESOURCES.FIELDS.RESOURCE_ID\' | translate }}</label><md-chips name="ResourceId" ng-model="vm.record.ResourceId" \nmd-autocomplete-snap md-transform-chip="vm.transformChip($chip)" md-require-match="true"><md-autocomplete \nmd-selected-item="vm.acSelectedItem" md-search-text="vm.acSearchText" \nmd-items="item in vm.acQuerySearch(vm.acSearchText, vm.record.ResourceId, vm.resourceLookup)" \nmd-item-text="item.value" md-min-length="0" md-no-cache="true" md-menu-class="autocomplete-custom"><md-item-template>\n<span class="autocomplete-item md-accent-fg" md-highlight-text="vm.acSearchText">{{item.value}}</span>\n</md-item-template><md-not-found>No Record matching "{{vm.acSearchText}}" were found.</md-not-found></md-autocomplete>\n<md-chip-template><span><strong>{{vm.getChipDisplayValue($chip, vm.resourceLookup)}}</strong></span></md-chip-template>\n</md-chips></md-input-container></div></div></md-dialog-content><md-dialog-actions layout="row" \nlayout-align="end center"><div layout="row" layout-align="end center"><md-button ng-click="vm.closeDialog()" \nclass="send-button md-primary md-raised" aria-label="Cancel" translate="ACTIONS.DIALOG_CANCEL" \ntranslate-attr-aria-label="ACTIONS.DIALOG_CANCEL" ng-disabled="vm.isLoading">CANCEL</md-button><md-button \nng-click="vm.saveRecord()" class="send-button md-accent md-raised" aria-label="Save" translate="ACTIONS.SAVE" \ntranslate-attr-aria-label="ACTIONS.SAVE" \nng-disabled="vm.isLoading || vm.editForm.$invalid || vm.record.ResourceId.length === 0">SAVE</md-button></div>\n</md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/accounts/auth-users/details/tabs/user-environments/dialogs/add-environment-to-auth-user.html','<md-dialog class="edit-dialog" aria-label="Link Segmentation"><form name="vm.editForm" class="md-inline-form">\n<md-toolbar class="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" layout-align="space-between center">\n<span class="title" \ntranslate="{{vm.isNew ? \'AUTH_ENVIRONMENTS.TITLES.ADD_ENVIRONMENT\' : \'AUTH_ENVIRONMENTS.TITLES.DELETE_ENVIRONMENT\'}}">\n</span><md-button class="md-icon-button" ng-click="vm.closeDialog(vm.isDataDirty)" aria-label="Close dialog" tranlate \ntranslate-aria-label="ACTIONS.DIALOG_CLOSE"><md-icon md-font-icon="icon-close"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div layout="row" layout-wrap><div flex="100" flex-gt-xs="100" class="p-5">\n<md-switch id="dialog_input_{{$first ? \'first\' : $index}}" ng-model="vm.record.updateT1" \naria-label="{{\'AUTH_ENVIRONMENTS.FIELDS.UPDATE_T1\' | translate}}" ng-true-value="true" ng-false-value="false" \nclass="md-accent">{{\'AUTH_ENVIRONMENTS.FIELDS.UPDATE_T1\' | translate}}<md-tooltip md-direction="right">\n{{vm.record.updateT1 === true ? \'PARTS.YES\' : \'PARTS.NO\' | translate}}</md-tooltip></md-switch></div><div flex="100" \nflex-gt-xs="50" class="p-5" ng-if="vm.record.updateT1"><md-select id="dialog_input_{{$first ? \'first\' : $index}}" \nng-model="vm.accountType" placeholder="{{\'AUTH_USERS.FIELDS.ACCOUNT_TYPE\' | translate}}" aria-label="Account Type" \nng-change="vm.onAccountTypeChange(vm.accountType)" ng-required="true"><md-option \nng-repeat="accountType in vm.accountTypes | orderBy:\'value\'" ng-value="accountType">{{ accountType.value }}</md-option>\n</md-select></div><div flex="100" flex-gt-xs="50" class="p-5 lookup-element" ng-if="vm.record.updateT1">\n<md-autocomplete id="dialog_input_{{$first ? \'first\' : $index}}" md-input-name="accountId" \nmd-selected-item="vm.lookupModel.accountId" \nmd-items="item in vm.accountLookupSearch(vm.searchText.accountId, vm.accountType[\'value\'], vm.accountType[\'lookupSource\'], {\'Status\': 1})" \nmd-search-text="vm.searchText.accountId" \nmd-item-text="vm.getAccountLookupDisplayValue(item, vm.accountType[\'value\'], vm.accountType[\'lookupSource\'])" \nmd-selected-item-change="vm.accountLookupChange(vm.lookupModel.accountId, \'accountId\')" md-min-length="0" \nmd-floating-label="{{\'AUTH_USERS.FIELDS.ACCOUNT\' | translate}}" ng-required="vm.isNew && vm.accountType.id !== 1" \nmd-no-cache="true" tx-clear-autocomplete ng-click="vm.selectText($event)" md-menu-class="autocomplete-custom" \nng-disabled="!vm.accountType.id || vm.accountType.id === 1"><md-item-template><span \nclass="autocomplete-item md-accent-fg" md-highlight-text="vm.searchText.accountId" md-highlight-flags="i">\n{{item.value}}</span></md-item-template><div ng-messages="vm.editForm.accountId.$error" role="alert" \nng-show="vm.editForm.accountId.$touched"><div ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div></div>\n<md-not-found>No Record matching "{{vm.searchText.accountId}}" were found.</md-not-found></md-autocomplete></div><div \nflex="100" flex-gt-xs="50" class="p-5 lookup-element"><md-autocomplete id="dialog_input_{{$first ? \'first\' : $index}}" \nmd-input-name="code" md-selected-item="vm.lookupModel.name" \nmd-items="item in vm.lookupSearch(vm.searchText.name, vm.unAssignedEnvironments, \'name\')" \nmd-search-text="vm.searchText.name" md-item-text="vm.getLookupDisplayValue(item, vm.unAssignedEnvironments, \'name\')" \nmd-min-length="0" md-floating-label="{{\'AUTH_USERS.TABS.AUTH_ENVIRONMENTS\' | translate}}" \nmd-selected-item-change="vm.lookupChange(vm.lookupModel.name, \'envCode\', \'code\')" ng-required="true" \nmd-no-cache="true" tx-clear-autocomplete tx-force-select ng-click="vm.selectText($event)" \nmd-menu-class="autocomplete-custom" ng-disabled="!vm.isNew"><md-item-template><span \nclass="autocomplete-item md-accent-fg" md-highlight-text="vm.searchText.code" md-highlight-flags="i">{{item.name}}\n</span></md-item-template><md-not-found>No Record matching "{{vm.searchText.name}}" were found.</md-not-found><div \nng-messages="vm.editForm.code.$error" role="alert" ng-show="vm.editForm.code.$touched"><div ng-message="required">\n{{\'VALIDATIONS.REQUIRED\' | translate}}</div></div></md-autocomplete></div></div></md-dialog-content><md-dialog-actions \nlayout="row" layout-align="end center"><div></div><div layout="row" layout-align="end center"><md-button \nng-click="vm.closeDialog(vm.isDataDirty)" class="send-button md-primary md-raised" aria-label="Cancel" \ntranslate="ACTIONS.DIALOG_CANCEL" translate-attr-aria-label="ACTIONS.DIALOG_CANCEL" ng-disabled="vm.isLoading">CANCEL\n</md-button><md-button ng-click="vm.saveRecord()" class="send-button md-accent md-raised" aria-label="Save" \nng-if="vm.isNew" translate="ACTIONS.SAVE" translate-attr-aria-label="ACTIONS.SAVE" \nng-disabled="vm.isLoading || vm.editForm.$invalid">SAVE</md-button><md-button ng-click="vm.saveRecord(true)" \nclass="send-button md-accent md-raised" aria-label="Save" ng-if="vm.isNew" translate="ACTIONS.SAVE_AND_NEW" \ntranslate-attr-aria-label="ACTIONS.SAVE_AND_NEW" ng-disabled="vm.isLoading || vm.editForm.$invalid">SAVE</md-button>\n<md-button ng-click="vm.saveRecord()" class="send-button md-accent md-raised" aria-label="Delete" ng-if="!vm.isNew" \ntranslate="ACTIONS.DELETE" ng-disabled="vm.isLoading || vm.editForm.$invalid"></md-button></div></md-dialog-actions>\n</form></md-dialog>');
$templateCache.put('app/main/accounts/sellers/details/tabs/capacities/details/capacity-details.html','<div id="capacity-details" class="page-layout simple tabbed details-view" layout="column"><div class="content"><md-tabs\n md-dynamic-height md-selected="vm.tabIndex" md-no-ink><md-tab \nlabel="{{\'SELLERS.CAPACITIES.TABS.CAPACITY\' | translate}}" tx-access="{{::vm.capacitiesModel.views.privileges.list}}">\n<tx-data-details tx-height-offset="37" tx-is-active="vm.tabIndex === 0" tx-account="vm.capacity" tx-title="vm.title" \ntx-model="vm.capacitiesModel" tx-is-loading="vm.isLoading" tx-refresh-action-event="vm.refreshRecord(false)">\n</tx-data-details></md-tab><md-tab label="{{\'SELLERS.CAPACITIES.LINKED_CUSTOMERS.NAV\' | translate}}" \ntx-access="{{::vm.capacityCustomersModel.views.privileges.list}}"><div class="list-tab" layout="row" flex="100" \nlayout-wrap><ms-widget layout="row" flex="100"><ms-widget-front class="white-bg"><tx-data-table \ntx-is-active="vm.tabIndex === 1" tx-data="vm.customers" tx-model="vm.capacityCustomersModel" tx-view="mainList" \ntx-filtered-data="vm.filteredCustomers" tx-data-filter="global.search" tx-is-loading="vm.isLoading" \ntx-refresh-action-event="vm.refreshRecord(true)" tx-height-offset="16"></tx-data-table></ms-widget-front></ms-widget>\n</div></md-tab></md-tabs></div></div>');
$templateCache.put('app/main/accounts/sellers/details/tabs/master-size-scales/dialogs/add-update-master-size-scale.html','<md-dialog class="edit-dialog" aria-label="Create Size Scale"><form name="vm.editForm" class="md-inline-form">\n<md-toolbar class="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" layout-align="space-between center">\n<span class="title" \ntranslate="{{ vm.isNew? \'SELLER_SIZE_SCALE_GROUP.TITLES.CREATE_MASTER_SIZE_SCALE\': vm.isEditCriteria ? \'SELLER_SIZE_SCALE_GROUP.ACTIONS.UPDATE_CRITERIA\' : \'SELLER_SIZE_SCALE_GROUP.TITLES.UPDATE_MASTER_SIZE_SCALE\' }}">\n{{vm.isNew ? \'Create Master Size Scale\' : vm.isEditCriteria ? \'Edit Criteria\' : \'Update Master Size Scale\'}}</span>\n<md-button class="md-icon-button" ng-click="vm.closeDialog(vm.isDataDirty)" aria-label="Close dialog" tranlate \ntranslate-aria-label="ACTIONS.DIALOG_CLOSE"><md-icon md-font-icon="icon-close"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div layout="row" layout-wrap><div flex="100" flex-gt-xs="100" class="p-5" \nng-if="!vm.isEditCriteria"><md-input-container class="md-block"><label translate>\nSELLER_SIZE_SCALE_GROUP.FIELDS.SIZE_SCALE</label><input id="dialog_input_1" name="SizeScale" \nng-model="vm.record.SizeScale" type="text" ng-required="true" \ntx-unique-value="vm.existingRecordsForUniqueValue:SizeScale:true"><div ng-messages="vm.editForm.SizeScale.$error" \nrole="alert" multiple="multiple"><div ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div><div \nng-message="tx-unique-value">{{\'VALIDATIONS.NOT_UNIQUE\' | translate}}</div></div></md-input-container></div><div \nflex="100" flex-gt-xs="100" class="p-5 lookup-element" ng-if="!vm.isEditCriteria"><label>\n{{\'SELLER_SIZE_SCALE_GROUP.FIELDS.SIZES\' | translate}}*</label><md-chips name="value" \nid="dialog_input_{{$first ? \'first\' : $index}}" ng-model="vm.record.Sizes" \nplaceholder="{{\'ACTIONS.ADD_TAGS\' | translate}}" ng-required="true" \nsecondary-placeholder="{{\'ACTIONS.ADD_TAGS\' | translate}}" md-enable-chip-edit="true" md-max-chips="{{vm.maxTags}}" \nmd-on-add="vm.addSizes($chip, vm.record.Sizes, vm.record)"></md-chips><div \nng-if="vm.addSizes($chip, vm.record.Sizes, vm.record)" class="error-message display-error">{{ vm.ErrorMessage}}</div>\n</div><div flex="100" flex-gt-xs="50" class="p-5" ng-if="!vm.isNew && !vm.isEditCriteria"><md-switch \nid="catalog_dialog_input_3" ng-model="vm.record.IsObsolete" \naria-label="{{\'SELLER_SIZE_SCALE_GROUP.FIELDS.IS_OBSOLETE\' | translate}}" ng-true-value="1" ng-false-value="0" \nclass="md-accent">{{\'SELLER_SIZE_SCALE_GROUP.FIELDS.IS_OBSOLETE\' | translate}}<md-tooltip md-direction="right">\n{{vm.record.IsObsolete === 1 ? \'PARTS.YES\' : \'PARTS.NO\' | translate}}</md-tooltip></md-switch></div><div flex="100" \nflex-gt-xs="100" class="p-5 lookup-element" ng-if="!vm.isNew && !vm.isEditCriteria"><label>\n{{\'SELLER_SIZE_SCALE_GROUP.FIELDS.OBSOLETE_SIZES\' | translate}}</label><md-chips name="value" \nid="dialog_input_{{$first ? \'first\' : $index}}" ng-model="vm.record.ObsoleteSizes" \nplaceholder="{{\'ACTIONS.ADD_TAGS\' | translate}}" secondary-placeholder="{{\'ACTIONS.ADD_TAGS\' | translate}}" \nmd-enable-chip-edit="true" md-max-chips="{{vm.maxTags}}" \nmd-on-add="vm.addSizes($chip, vm.record.ObsoleteSizes, vm.record)"></md-chips><div \nng-if="vm.addSizes($chip, vm.record.ObsoleteSizes, vm.record)" class="error-message display-error">{{ vm.ErrorMessage}}\n</div></div><div flex="100" flex-gt-xs="100" class="p-5 lookup-element"><fieldset><legend \nclass="header-non-editable-attributes" translate>SELLER_SIZE_SCALE_GROUP.FIELDS.CRITERIA</legend><div \nng-repeat="record in vm.criterias track by $index" ng-init="customIndex = $index" flex="100" layout="row" layout-wrap>\n<div flex="100" flex-gt-xs="50" class="p-5"><md-autocomplete id="dialog_input_{{customIndex}}" \nmd-input-name="Attributeid" md-selected-item="vm.lookupModel[customIndex].Attributeid" \nmd-items="item in vm.lookupAttributeSearch(vm.searchText[customIndex].Attributeid, \'Attributeid\')" \nmd-search-text="vm.searchText[customIndex].Attributeid" \nmd-item-text="vm.getAttributeLookupDisplayValue(item, \'Attributeid\')" md-min-length="0" \nmd-floating-label="{{\'CATALOG_COLOR_PALETTE.FIELDS.ATTRIBUTE\' | translate}}" md-no-cache="true" tx-clear-autocomplete \nng-click="vm.selectText($event)" \nmd-selected-item-change="vm.lookupAttributeChange(vm.lookupModel[customIndex].Attributeid, customIndex)" \nmd-menu-class="autocomplete-custom"><md-item-template><span class="autocomplete-item md-accent-fg" \nmd-highlight-text="vm.searchText[customIndex].Attributeid" md-highlight-flags="i">{{item.AttributeDisplayName}}</span>\n</md-item-template><md-not-found>No Record matching "{{vm.searchText[customIndex].Attributeid}}" were found.\n</md-not-found><div ng-messages="vm.editForm.Id_customIndex.$error" role="alert" \nng-show="vm.editForm.Id_customIndex.$touched" multiple="multiple"><div ng-message="required">\n{{\'VALIDATIONS.REQUIRED\' | translate}}</div></div></md-autocomplete></div><div flex="100" flex-gt-xs="50" class="p-5" \nng-switch="vm.criterias[customIndex].inputType"><div class="p-5"><div \nng-if="vm.criterias[customIndex].inputType === \'textArea\' || vm.criterias[customIndex].inputType === \'calculated\' || vm.criterias[customIndex].inputType === \'lookup-table\'">\n<md-input-container class="md-block"><input id="dialog_input_{{$first ? \'first\' : customIndex}}" name="value" \nng-model="vm.criterias[customIndex].value"></md-input-container></div><div \nng-if="vm.criterias[customIndex].inputType === \'number\'"><md-input-container class="md-block"><input type="number" \nid="dialog_input_{{$first ? \'first\' : customIndex}}" name="value" ng-model="vm.criterias[customIndex].value">\n</md-input-container></div><div ng-if="vm.criterias[customIndex].inputType === \'date\'" layout="column" flex>\n<md-datepicker id="dialog_input_{{$first ? \'first\' : customIndex}}" name="value" \nng-model="vm.criterias[customIndex].value" \nng-init="vm.criterias[customIndex].value = vm.getDateObj(vm.criterias[customIndex].value)" md-placeholder="">\n</md-datepicker></div><div ng-if="vm.criterias[customIndex].inputType === \'date-without-time\'" layout="column" flex>\n<md-datepicker id="dialog_input_{{$first ? \'first\' : customIndex}}" name="value" \nng-model="vm.criterias[customIndex].value" md-placeholder=""></md-datepicker></div><div \nng-if="vm.criterias[customIndex].inputType === \'date-option\'" layout="column" flex><md-datepicker \nid="dialog_input_{{$first ? \'first\' : customIndex}}" name="value" ng-model="vm.criterias[customIndex].value" \nng-init="vm.criterias[customIndex].value = vm.getDateObj(vm.criterias[customIndex].value)" md-placeholder="">\n</md-datepicker></div><div ng-if="vm.criterias[customIndex].inputType === \'bool-str\'"><md-switch \nid="dialog_input_{{$first ? \'first\' : customIndex}}" ng-model="vm.criterias[customIndex].value" \naria-label="{{vm.criterias[customIndex].displayLabel | translate}}" ng-true-value="\'true\'" ng-false-value="\'false\'" \nclass="md-accent"></md-switch></div><div ng-switch-when="tags"><md-chips name="value" \nid="dialog_input_{{$first ? \'first\' : customIndex}}" ng-model="vm.criterias[customIndex].value" \nplaceholder="{{\'ACTIONS.ADD_TAGS\' | translate}}" secondary-placeholder="{{\'ACTIONS.ADD_TAGS\' | translate}}" \nmd-enable-chip-edit="true" md-max-chips="{{vm.maxTags}}" md-on-add="vm.add($chip, vm.criterias, customIndex)" \nmd-separator-keys="vm.tagSeperatorKeys[vm.criterias[customIndex].value]"></md-chips></div><div \nng-if="vm.criterias[customIndex].inputType === \'list\'"><md-input-container class="md-block"><md-select \nid="dialog_input_{{$first ? \'first\' : customIndex}}" name="value" ng-model="vm.criterias[customIndex].value" \naria-label="{{vm.criterias[customIndex].displayLabel | translate}}"><md-option md-option-empty ng-value="\'\'"><em>None\n</em></md-option><md-option ng-value="option" ng-repeat="option in vm.criterias[customIndex].values">{{ option }}\n</md-option></md-select></md-input-container></div><div ng-if="vm.criterias[customIndex].inputType === \'multi-value\'">\n<md-input-container class="md-block"><md-chips id="dialog_input_{{$first ? \'first\' : customIndex}}" name="value" \nng-model="vm.criterias[customIndex].value" md-autocomplete-snap md-transform-chip="vm.transformChip($chip, true)" \naria-label="{{vm.criterias[customIndex].displayLabel | translate}}"><md-autocomplete \nmd-selected-item="vm.acSelectedItem[vm.criterias[customIndex].field]" \nmd-search-text="vm.acSearchText[vm.criterias[customIndex].field]" \nmd-items="item in vm.multiValueQuerySearch(vm.acSearchText[vm.criterias[customIndex].field], vm.criterias[customIndex].value, record)" \nmd-item-text="item" md-min-length="0" md-no-cache="true" md-menu-class="autocomplete-custom"><md-item-template><span \nclass="autocomplete-item md-accent-fg" md-highlight-text="vm.acSearchText[vm.criterias[customIndex].field]">{{item}}\n</span></md-item-template><md-not-found>\nNo Record matching "{{vm.acSearchText[vm.criterias[customIndex].field]}}" were found.</md-not-found></md-autocomplete>\n<md-chip-template><span><strong>{{$chip}}</strong></span></md-chip-template></md-chips></md-input-container></div><div \nng-if="vm.criterias[customIndex].inputType === \'decimal\'"><md-input-container class="md-block"><input type="number" \nng-if="vm.isNew" id="dialog_input_{{$first ? \'first\' : customIndex}}" name="value" \nng-model="vm.criterias[customIndex].value" pattern="{{vm.criterias[customIndex].validation.pattern}}"><input \ntype="text" ng-if="!vm.isNew" id="dialog_input_{{$first ? \'first\' : customIndex}}" name="value" \nng-model="vm.criterias[customIndex].value"><div ng-if="vm.isNew" ng-messages="vm.criterias[customIndex].value.$error" \nrole="alert" multiple="multiple"><div ng-message="pattern">\n{{vm.criterias[customIndex].validation.messages.pattern | translate}}</div></div></md-input-container></div></div>\n</div></div></fieldset></div></div></md-dialog-content><md-dialog-actions layout="row" layout-align="end center"><div>\n</div><div layout="row" layout-align="end center"><md-button ng-click="vm.closeDialog(vm.isDataDirty)" \nclass="send-button md-primary md-raised" aria-label="Cancel" translate="ACTIONS.DIALOG_CANCEL" \ntranslate-attr-aria-label="ACTIONS.DIALOG_CANCEL" ng-disabled="vm.isLoading">CANCEL</md-button><md-button \nng-click="vm.saveRecord()" class="send-button md-accent md-raised" aria-label="Save" translate="ACTIONS.SAVE" \ntranslate-attr-aria-label="ACTIONS.SAVE" ng-disabled="vm.isLoading || vm.editForm.$invalid">SAVE</md-button></div>\n</md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/accounts/sellers/details/tabs/resource-types/dialogs/create-resource-type.html','<md-dialog class="edit-dialog" aria-label="{{vm.isNew ? \'New Resource Types\' : \'Edit Resource Types\'}"><form \nname="vm.editForm" class="md-inline-form"><md-toolbar class="md-accent md-hue-2"><div class="md-toolbar-tools" \nlayout="row" layout-align="space-between center"><span class="title" \ntranslate="{{vm.isNew ? \'TITLES.RECORD_NEW\' : \'TITLES.RECORD_EDIT\'}}">Edit Record</span><md-button \nclass="md-icon-button" ng-click="vm.closeDialog(vm.isDataDirty)" aria-label="Close dialog" tranlate \ntranslate-aria-label="ACTIONS.DIALOG_CLOSE"><md-icon md-font-icon="icon-close"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div layout="row" layout-wrap><div flex="100" flex-gt-xs="50" class="p-5">\n<md-input-container class="md-block"><label translate>RESOURCE_TYPES.FIELDS.TYPE</label><input \nid="dialog_input_{{$first ? \'first\' : $index}}" name="Type" ng-model="vm.record.Type" type="text" ng-required="true" \nmd-maxlength="50" md-autofocus><div ng-messages="vm.editForm.Type.$error" role="alert" multiple="multiple"><div \nng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div><div ng-message="md-maxlength">\n{{\'VALIDATIONS.MAXLEN\' | translate}}</div></div></md-input-container></div><div flex="100" flex-gt-xs="50" class="p-5">\n<md-input-container class="md-block"><label>{{\'RESOURCE_TYPES.FIELDS.EXPRESSION\' | translate}}</label><input \nid="dialog_input_{{$first ? \'first\' : $index}}" name="Expression" ng-model="vm.record.Expression" type="text" \nng-required="true" md-maxlength="100"><div ng-messages="vm.editForm.Expression.$error" role="alert" \nmultiple="multiple"><div ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div><div \nng-message="md-maxlength">{{\'VALIDATIONS.MAXLEN\' | translate}}</div></div></md-input-container></div><div flex="100" \nflex-gt-xs="50" class="p-5"><md-input-container class="md-block"><label translate>RESOURCE_TYPES.FIELDS.SORT_ORDER\n</label><input id="dialog_input_{{$first ? \'first\' : $index}}" name="SortOrder" ng-model="vm.record.SortOrder" \ntype="number"></md-input-container></div></div></md-dialog-content><md-dialog-actions layout="row" \nlayout-align="end center"><div></div><div layout="row" layout-align="end center"><md-button \nng-click="vm.closeDialog(vm.isDataDirty)" class="send-button md-primary md-raised" aria-label="Cancel" \ntranslate="ACTIONS.DIALOG_CANCEL" translate-attr-aria-label="ACTIONS.DIALOG_CANCEL" ng-disabled="vm.isLoading">CANCEL\n</md-button><md-button ng-click="vm.saveRecord()" class="send-button md-accent md-raised" aria-label="Save" \ntranslate="ACTIONS.SAVE" translate-attr-aria-label="ACTIONS.SAVE" ng-disabled="vm.isLoading || vm.editForm.$invalid">\nSAVE</md-button><md-button ng-click="vm.saveRecord(true)" class="send-button md-accent md-raised" aria-label="Save" \ntranslate="ACTIONS.SAVE_AND_NEW" translate-attr-aria-label="ACTIONS.SAVE_AND_NEW" \nng-disabled="vm.isLoading || vm.editForm.$invalid" ng-show="vm.isNew">SAVE</md-button></div></md-dialog-actions></form>\n</md-dialog>');
$templateCache.put('app/main/accounts/sellers/details/tabs/seller-configurations/dialogs/update-seller-configuration.html','<md-dialog class="edit-dialog" aria-label="{{vm.isNew ? \'New Configuration\' : \'Edit Configuration\'}}"><form \nname="vm.editForm" class="md-inline-form"><md-toolbar class="md-accent md-hue-2"><div class="md-toolbar-tools" \nlayout="row" layout-align="space-between center"><span class="title" \ntranslate="{{vm.isNew ? \'CONFIGURATIONS.ACTIONS.CREATE\' : \'CONFIGURATIONS.ACTIONS.UPDATE\'}}">\n{{vm.isNew ? \'New Configuration\' : \'Edit Configuration\'}}</span><md-button class="md-icon-button" \nng-click="vm.closeDialog(vm.isDataDirty)" aria-label="Close dialog" tranlate \ntranslate-aria-label="ACTIONS.DIALOG_CLOSE"><md-icon md-font-icon="icon-close"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div layout="row" layout-wrap><div flex="100" flex-gt-xs="50" \nclass="p-5 lookup-element" ng-show="vm.isNew"><md-autocomplete id="dialog_input_first" md-input-name="ConfigId" \nmd-selected-item="vm.lookupModel.ConfigId" md-search-text="vm.searchText.ConfigId" \nmd-items="item in vm.lookupSearch(vm.searchText.ConfigId)" md-item-text="vm.getConfigurationDisplayValue(item)" \nmd-selected-item-change="vm.lookupChange(vm.lookupModel.ConfigId, \'ConfigId\')" md-min-length="0" \nmd-floating-label="{{\'CONFIGURATIONS.FIELDS.NAME\' | translate}}" ng-required="vm.isNew" md-no-cache="true" \ntx-clear-autocomplete ng-click="vm.selectText($event)" md-menu-class="autocomplete-custom"><md-item-template><span \nclass="autocomplete-item md-accent-fg" md-highlight-text="vm.searchText.ConfigId" md-highlight-flags="i">\n{{item[vm.masterConfigurationsModel.lookupDisplayField]}}</span></md-item-template><div \nng-messages="vm.editForm.ConfigId.$error" role="alert" ng-show="vm.editForm.ConfigId.$touched"><div \nng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div></div></md-autocomplete></div><div flex="100" \nflex-gt-xs="50" class="p-5" ng-if="vm.isNew"><md-input-container class="md-block"><label translate>\nCONFIGURATIONS.FIELDS.SORTORDER</label><input name="SortOrder" ng-model="vm.record.SortOrder" type="number" \nng-disabled="vm.isExistingSelected"></md-input-container></div><div flex="100" flex-gt-xs="50" class="p-5" \nng-if="vm.isNew"><md-input-container class="md-block"><label translate>\n{{\'CONFIGURATIONS.FIELDS.VALUE_TYPE\' | translate}}</label><md-select name="DefaultValueType" \nplaceholder="{{\'CONFIGURATIONS.FIELDS.VALUE_TYPE\' | translate}}" ng-model="vm.record.DefaultValueType" \nstyle="min-width: 200px" ng-required="!vm.isExistingSelected" ng-disabled="vm.isExistingSelected" \nng-change="vm.onTypeChange(vm.record.DefaultValueType)"><md-option \nng-repeat="item in vm.defaultValueTypes track by item.Id" ng-value="item.Id">{{item.value}}</md-option></md-select><div\n ng-messages="vm.editForm.DefaultValueType.$error" role="alert" multiple="multiple"><div ng-message="required">\n{{\'VALIDATIONS.REQUIRED\' | translate}}</div></div></md-input-container></div><div flex="100" flex-gt-xs="50" \nclass="p-5" ng-if="vm.isNew && (vm.configType === \'\' || vm.configType === \'nvarchar\')"><md-input-container \nclass="md-block"><label>{{\'CONFIGURATIONS.FIELDS.DEFAULT_VALUE\' | translate}}</label><input name="DefaultValue" \nng-model="vm.record.DefaultValue" type="text" ng-required="!vm.isExistingSelected" ng-disabled="vm.isExistingSelected">\n<div ng-messages="vm.editForm.DefaultValue.$error" role="alert"><div ng-message="required">\n{{\'VALIDATIONS.REQUIRED\' | translate}}</div></div></md-input-container></div><div flex="100" flex-gt-xs="50" \nclass="p-5" ng-if="vm.isNew && vm.configType === \'int\'"><md-input-container class="md-block"><label>\n{{\'CONFIGURATIONS.FIELDS.DEFAULT_VALUE\' | translate}}</label><input name="DefaultValue" \nng-model="vm.record.DefaultValue" type="number" ng-required="!vm.isExistingSelected" \nng-disabled="vm.isExistingSelected"><div ng-messages="vm.editForm.DefaultValue.$error" role="alert"><div \nng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div></div></md-input-container></div><div flex="100" \nflex-gt-xs="50" class="p-5" ng-if="vm.isNew && vm.configType === \'bool\'"><md-switch name="DefaultValue" \nng-model="vm.record.DefaultValue" aria-label="Default Value" ng-true-value="\'true\'" ng-false-value="\'false\'" \nng-disabled="vm.isExistingSelected" class="md-accent">{{\'CONFIGURATIONS.FIELDS.DEFAULT_VALUE\' | translate}}</md-switch>\n</div><div flex="100" flex-gt-xs="50" class="p-5" ng-if="vm.isNew && vm.configType === \'datetime\'" layout="column">\n<label class="md-caption">{{\'CONFIGURATIONS.FIELDS.DEFAULT_VALUE\' | translate}}</label><md-datepicker \nname="DefaultValue" ng-model="vm.record.DefaultValue" md-placeholder="" ng-required="!vm.isExistingSelected" \nng-disabled="vm.isExistingSelected"></md-datepicker><div ng-messages="vm.editForm.DefaultValue.$error" role="alert" \nng-show="vm.editForm.DefaultValue.$touched"><div ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div>\n</div></div><div flex="100" class="p-5" ng-if="vm.isNew"><md-input-container class="md-block"><label translate>\nCONFIGURATIONS.FIELDS.DESCRIPTION</label><textarea name="Description" ng-model="vm.record.Description" columns="1" \nrows="1" ng-required="false" md-maxlength="500" ng-disabled="vm.isExistingSelected"></textarea><div \nng-messages="vm.editForm.Description.$error" role="alert" multiple="multiple"><div ng-message="md-maxlength">\n{{\'VALIDATIONS.MAXLEN\' | translate}}</div></div></md-input-container></div><div flex="100" flex-gt-xs="50" class="p-5" \nng-if="vm.configType === \'\' || vm.configType === \'nvarchar\'"><md-input-container class="md-block"><label>\n{{\'CONFIGURATIONS.FIELDS.VALUE\' | translate}}</label><input id="dialog_input_1" name="Value" \nng-model="vm.record.Value" type="text" ng-required="true" ng-disabled="vm.configType === \'\'"><div \nng-messages="vm.editForm.Value.$error" role="alert"><div ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}\n</div></div></md-input-container></div><div flex="100" flex-gt-xs="50" class="p-5" ng-if="vm.configType === \'int\'">\n<md-input-container class="md-block"><label>{{\'CONFIGURATIONS.FIELDS.VALUE\' | translate}}</label><input \nid="dialog_input_2" name="Value" ng-model="vm.record.Value" type="number" ng-required="true" \npattern="{{(vm.lookupModel.ConfigId.Name === \'T1S-NumberOfDecimalsForPrices\' || vm.record.Name === \'T1S-NumberOfDecimalsForPrices\') ? \'^[0-4]$\': \'\'}}">\n<div ng-messages="vm.editForm.Value.$error" role="alert"><div ng-message="required">\n{{\'VALIDATIONS.REQUIRED\' | translate}}</div><div ng-message="pattern">\n{{\'VALIDATIONS.INVALID_DECIMAL_POINTS\' | translate}}</div></div></md-input-container></div><div flex="100" \nflex-gt-xs="50" class="p-5" ng-if="vm.configType === \'bool\'"><md-switch id="dialog_input_3" name="Value" \nng-model="vm.record.Value" aria-label="Value" ng-true-value="\'true\'" ng-false-value="\'false\'" class="md-accent">\n{{\'CONFIGURATIONS.FIELDS.VALUE\' | translate}}</md-switch></div><div flex="100" flex-gt-xs="50" class="p-5" \nng-if="vm.configType == \'datetime\'" layout="column"><label class="md-caption">\n{{\'CONFIGURATIONS.FIELDS.VALUE\' | translate}}</label><md-datepicker id="dialog_input_4" name="Value" \nng-model="vm.record.Value" md-placeholder="" ng-required="true"></md-datepicker><div \nng-messages="vm.editForm.Value.$error" role="alert" ng-show="vm.editForm.Value.$touched"><div ng-message="required">\n{{\'VALIDATIONS.REQUIRED\' | translate}}</div></div></div></div></md-dialog-content><md-dialog-actions layout="row" \nlayout-align="end center"><div></div><div layout="row" layout-align="end center"><md-button \nng-click="vm.closeDialog(vm.isDataDirty)" class="send-button md-primary md-raised" aria-label="Cancel" \ntranslate="ACTIONS.DIALOG_CANCEL" translate-attr-aria-label="ACTIONS.DIALOG_CANCEL" ng-disabled="vm.isLoading">CANCEL\n</md-button><md-button ng-click="vm.saveRecord()" class="send-button md-accent md-raised" aria-label="Save" \ntranslate="ACTIONS.SAVE" translate-attr-aria-label="ACTIONS.SAVE" ng-disabled="vm.isLoading || vm.editForm.$invalid">\nSAVE</md-button><md-button ng-click="vm.saveRecord(true)" class="send-button md-accent md-raised" aria-label="Save" \ntranslate="ACTIONS.SAVE_AND_NEW" translate-attr-aria-label="ACTIONS.SAVE_AND_NEW" \nng-disabled="vm.isLoading || vm.editForm.$invalid" ng-show="vm.isNew">SAVE</md-button></div></md-dialog-actions></form>\n</md-dialog>');
$templateCache.put('app/main/accounts/sellers/details/tabs/seller-datasets/details/seller-datasets-details.html','<div id="dataset-table-details" class="page-layout simple tabbed details-view" layout="column"><div class="content">\n<md-tabs md-dynamic-height md-selected="vm.tabIndex" md-no-ink><md-tab label="{{\'SELLER_DATASETS.NAV\' | translate}}" \ntx-access="{{::vm.model.views.privileges.details}}"><tx-data-details tx-height-offset="37" \ntx-is-active="vm.tabIndex === 0" tx-account="vm.datasetDefinition" tx-parent-id="vm.sellerId" tx-title="vm.title" \ntx-model="vm.model" tx-is-loading="vm.isLoading" tx-refresh-action-event="vm.refreshRecord(false)"></tx-data-details>\n</md-tab><md-tab label="{{\'SELLER_DATASETS.TABS.VALUES\' | translate}}" \ntx-access="{{::vm.valuesModel.views.privileges.list}}"><div class="list-tab" layout="row" flex="100" layout-wrap>\n<ms-widget layout="row" flex="100"><ms-widget-front class="white-bg"><tx-data-table tx-is-active="vm.tabIndex === 1" \ntx-data="vm.datasetValues" tx-model="vm.valuesModel" tx-view="mainList" tx-filtered-data="vm.filteredDatasetValues" \ntx-data-filter="global.search" tx-is-loading="vm.isValuesLoading" \ntx-list-action-event="vm.doValuesListAction(action, selectedItems)" \ntx-item-action-event="vm.doValuesItemAction(action, item)" tx-refresh-action-event="vm.refreshValues(true)" \ntx-height-offset="16"></tx-data-table></ms-widget-front></ms-widget></div></md-tab></md-tabs></div></div>');
$templateCache.put('app/main/accounts/sellers/details/tabs/seller-lookup-table/details/seller-lookup-table-details.html','<div id="lookup-table-details" class="page-layout simple tabbed details-view" layout="column"><div class="content">\n<md-tabs md-dynamic-height md-selected="vm.tabIndex" md-no-ink><md-tab \nlabel="{{\'SELLER_LOOKUP_TABLE.NAV\' | translate}}" tx-access="{{::vm.model.views.privileges.details}}"><tx-data-details \ntx-height-offset="37" tx-is-active="vm.tabIndex === 0" tx-account="vm.lookupDefinition" tx-parent-id="vm.sellerId" \ntx-title="vm.title" tx-model="vm.model" tx-is-loading="vm.isLoading" tx-refresh-action-event="vm.refreshRecord(false)">\n</tx-data-details></md-tab><md-tab label="{{\'SELLER_LOOKUP_TABLE.TABS.VALUES\' | translate}}" \ntx-access="{{::vm.valuesModel.views.privileges.list}}"><div class="list-tab" layout="row" flex="100" layout-wrap>\n<ms-widget layout="row" flex="100"><ms-widget-front class="white-bg"><tx-data-table tx-is-active="vm.tabIndex === 1" \ntx-data="vm.lookupValues" tx-model="vm.valuesModel" tx-view="mainList" tx-filtered-data="vm.filteredLookupValues" \ntx-data-filter="global.search" tx-is-loading="vm.isLoading" \ntx-list-action-event="vm.doValuesListAction(action, selectedItems)" tx-refresh-action-event="vm.refreshRecord(true)" \ntx-height-offset="16"></tx-data-table></ms-widget-front></ms-widget></div></md-tab></md-tabs></div></div>');
$templateCache.put('app/main/accounts/sellers/details/tabs/seller-resources/details/seller-resource-details.html','<div id="seller-resource-details" class="page-layout simple tabbed details-view" layout="column"><div class="content">\n<md-tabs md-dynamic-height md-selected="vm.tabIndex" md-no-ink><md-tab \nlabel="{{\'RESOURCES.TABS.RESOURCE\' | translate}}" ng-disabled="!vm.resource.Status"><tx-data-details \ntx-height-offset="37" tx-is-active="vm.tabIndex === 0" tx-account="vm.resource" tx-title="vm.title" \ntx-model="vm.detailsModel" tx-is-loading="vm.isLoading" tx-refresh-action-event="vm.refreshRecord(false)">\n</tx-data-details></md-tab><md-tab ng-if="!vm.resource.IsModelLevel" label="{{\'RESOURCES.TABS.ARTICLES\' | translate}}" \nng-disabled="!vm.resource.Status"><div class="list-tab" layout="row" flex="100" layout-wrap><ms-widget layout="row" \nflex="100"><ms-widget-front class="white-bg"><tx-data-table tx-is-active="vm.tabIndex === 1" \ntx-data="vm.assignedArticles" tx-model="vm.articleModel" tx-view="mainList" \ntx-filtered-data="vm.filteredAssignedArticles" tx-data-filter="global.search" tx-is-loading="vm.isLoading" \ntx-item-action-event="vm.doArticleItemAction(action, item)" \ntx-list-action-event="vm.doArticleListAction(action, selectedItems)" tx-refresh-action-event="vm.refreshRecord()" \ntx-height-offset="16"></tx-data-table></ms-widget-front></ms-widget><md-button class="add-rec-button md-fab md-warn" \nng-click="vm.assignArticles($event)" aria-label="Assign Articles"><md-icon md-font-icon="icon-link"></md-icon>\n</md-button></div></md-tab><md-tab ng-if="vm.resource.IsModelLevel || vm.isUnlinkedResource" \nlabel="{{\'RESOURCES.TABS.MODELS\' | translate}}" ng-disabled="!vm.resource.Status"><div class="list-tab" layout="row" \nflex="100" layout-wrap><ms-widget layout="row" flex="100"><ms-widget-front class="white-bg"><tx-data-table \ntx-is-active="vm.tabIndex === 1 || vm.tabIndex === 2" tx-data="vm.assignedModels" tx-model="vm.modelModel" \ntx-view="mainList" tx-filtered-data="vm.filteredAssignedModels" tx-data-filter="global.search" \ntx-is-loading="vm.isLoading" tx-item-action-event="vm.doModelItemAction(action, item)" \ntx-list-action-event="vm.doModelListAction(action, selectedItems)" tx-item-click-event="vm.viewModel(item)" \ntx-refresh-action-event="vm.refreshRecord()" tx-height-offset="16"></tx-data-table></ms-widget-front></ms-widget>\n<md-button class="add-rec-button md-fab md-warn" ng-click="vm.assignModels($event)" aria-label="Assign Models"><md-icon\n md-font-icon="icon-link"></md-icon></md-button></div></md-tab></md-tabs><md-button id="txfab" class="md-fab md-warn" \nng-if="vm.tabIndex === 0 && vm.resource.ResourceId" ng-click="vm.editResource($event, vm.resource)" aria-label="Edit" \ntranslate ng-disabled="!vm.resource.Status"><md-icon md-font-icon="icon-pencil"></md-icon></md-button></div></div>');
$templateCache.put('app/main/accounts/sellers/details/tabs/seller-resources/dialogs/create-seller-resource.html','<md-dialog class="edit-dialog resource-uploader" aria-label="{{vm.isNew ? \'New Record\' : \'Edit Record\'}}"><form \nname="vm.editForm" class="md-inline-form"><md-toolbar class="md-accent md-hue-2"><div class="md-toolbar-tools" \nlayout="row" layout-align="space-between center"><span class="title" \ntranslate="{{vm.isNew ? \'TITLES.RECORD_NEW\' : \'TITLES.RECORD_EDIT\'}}"></span><md-button class="md-icon-button" \nng-click="vm.closeDialog(vm.isDataDirty, true)" aria-label="Close dialog" translate-aria-label="ACTIONS.DIALOG_CLOSE">\n<md-icon md-font-icon="icon-close"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div \nlayout="row" layout-wrap><div flex="100" flex-gt-xs="50" class="p-5 lookup-element"><md-autocomplete \nid="dialog_input_first" md-input-name="TypeId" md-selected-item="vm.lookupModel.TypeId" \nmd-items="item in vm.lookupSearch(vm.searchText.TypeId, \'TypeId\')" md-search-text="vm.searchText.TypeId" \nmd-item-text="vm.getLookupDisplayValue(item, \'TypeId\')" md-min-length="0" \nmd-floating-label="{{\'RESOURCES.FIELDS.RESOURCE_TYPE_ID\' | translate}}" \nmd-selected-item-change="vm.onResourceTypeChange(vm.lookupModel.TypeId, \'TypeId\', vm.obj.flow.files)" \nng-required="true" md-no-cache="true" tx-clear-autocomplete tx-force-select ng-click="vm.selectText($event)" \nmd-menu-class="autocomplete-custom"><md-item-template><span class="autocomplete-item md-accent-fg" \nmd-highlight-text="vm.searchText.TypeId" md-highlight-flags="i">{{item.value}}</span></md-item-template><md-not-found>\nNo Record matching "{{vm.searchText.TypeId}}" were found.</md-not-found><div ng-messages="vm.editForm.TypeId.$error" \nrole="alert" ng-show="vm.editForm.TypeId.$touched"><div ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}\n</div></div></md-autocomplete></div><div flex="100" flex-gt-xs="50" class="p-5"><md-input-container class="md-block">\n<label translate>RESOURCES.FIELDS.RESOURCE_NAME</label><input name="ResourceName" ng-model="vm.record.ResourceName" \ntype="text" ng-required="true" md-maxlength="100"><div ng-messages="vm.editForm.ResourceName.$error" role="alert" \nmultiple="multiple"><div ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div><div \nng-message="md-maxlength">{{\'VALIDATIONS.MAXLEN\' | translate}}</div></div></md-input-container></div><div><label \ntranslate="RESOURCES.NAV"></label></div><div flex="100" class="p-5" flow-init="vm.flowInit" \nflow-object="$rootScope.flowObj" flow-file-added="vm.validateFile($file, $event, $flow, \'resource\')" \nflow-files-submitted="vm.upload(\'resource\')" flow-name="vm.obj.flow" \nflow-file-success="vm.onSuccessUpload($file, $message, $flow, \'resource\')" flow-drop><label for="flow-upload-file-id" \nng-hide="$flow.progress() === 1"><div class="file-uploader-container" \nflow-drag-enter="style={outline: \'2px dashed rgba(0,0,0,0.38)\', color: \'#939393\' }" \nflow-drag-leave="style={outline: \'2px dashed rgba(0,0,0,0.12)\', color: \'rgba(0,0,0,0.12)\'}" ng-style="style"><div \nclass="upload-label"><div class="upload-icon"><md-icon ng-style="style" md-font-icon="icon-upload" class="icon s1">\n</md-icon></div><div class="upload-message" ng-style="style"><span>Choose a file or drag it here.</span></div></div>\n</div></label><label for="flow-upload-file-id" class="" ng-show="$flow.progress() === 1"><div \nclass="file-uploader-container upload-success"><div class="image-container"><img flow-img="$flow.files[0]" \ntx-resource-file="true"></div><div class="uploaded-file-name"><label>{{$flow.files[0].name}}</label></div></div>\n</label><div class="upload-error" ng-show="!vm.isResourceFileValid">\n{{ \'IMAGES.MESSAGES.INVALID_FILE_FORMAT\' | translate }}</div><md-progress-linear md-mode="determinate" \nclass="md-accent" ng-if="$flow.isUploading()" value="{{$flow.progress()*100}}"></md-progress-linear><input type="file" \nid="flow-upload-file-id" class="ng-hide" flow-btn accept="{{vm.allowedFileTypeExtentions}}"></div><div \nclass="resource-icon-header"><label translate="RESOURCES.FIELDS.ICON"></label></div><div flex="100" class="p-5" \nflow-init="vm.flowInit" flow-object="$rootScope.flowObj2" \nflow-file-added="vm.validateFile($file, $event, $flow, \'icon\')" flow-files-submitted="vm.upload(\'icon\')" \nflow-name="vm.obj2.flow" flow-file-success="vm.onSuccessUpload($file, $message, $flow, \'icon\')" flow-drop><label \nfor="flow-upload-icon-id" ng-hide="$flow.progress() === 1"><div class="file-uploader-container" \nflow-drag-enter="style={outline: \'2px dashed rgba(0,0,0,0.38)\', color: \'#939393\' }" \nflow-drag-leave="style={outline: \'2px dashed rgba(0,0,0,0.12)\', color: \'rgba(0,0,0,0.12)\'}" ng-style="style"><div \nclass="upload-label"><div class="upload-icon"><md-icon ng-style="style" md-font-icon="icon-upload" class="icon s1" \nhide-xs></md-icon></div><div class="upload-message" ng-style="style"><span>Choose a file or drag it here.</span></div>\n</div></div></label><label for="flow-upload-icon-id" class="" ng-show="$flow.progress() === 1"><div \nclass="file-uploader-container upload-success"><div class="image-container"><img flow-img="$flow.files[0]" \ntx-resource-file="true"></div><div class="uploaded-file-name"><label>{{$flow.files[0].name}}</label></div></div>\n</label><div class="upload-error" ng-show="!vm.isIconFileValid">{{ \'IMAGES.MESSAGES.INVALID_FILE_FORMAT\' | translate }}\n</div><md-progress-linear md-mode="determinate" class="md-accent" ng-if="$flow.isUploading()" \nvalue="{{$flow.progress()*100}}"></md-progress-linear><input type="file" id="flow-upload-icon-id" class="ng-hide" \nflow-btn accept="{{vm.allowedFileTypeExtentions}}"></div><div flex="100" flex-gt-xs="50" class="p-5 lookup-element" \nng-if="vm.isNew && !vm.record.IsModelLevel"><md-input-container class="md-block"><label translate>\n{{ \'RESOURCES.FIELDS.ARTICLE_NUMBER\' | translate }}</label><md-chips name="ArticleIds" ng-model="vm.record.ArticleIds" \nmd-autocomplete-snap md-transform-chip="vm.transformChip($chip)" md-require-match="true"><md-autocomplete \nmd-selected-item="vm.acSelectedItem.ArticleIds" md-search-text="vm.acSearchText.ArticleIds" \nmd-items="item in vm.acQuerySearch(vm.acSearchText.ArticleIds, vm.record.ArticleIds, \'ArticleIds\')" \nmd-item-text="item.value" md-min-length="0" md-no-cache="true" md-menu-class="autocomplete-custom"><md-item-template>\n<span class="autocomplete-item md-accent-fg" md-highlight-text="vm.acSearchText.ArticleIds">{{item.value}}</span>\n</md-item-template><md-not-found>No Record matching "{{vm.acSearchText.ArticleIds}}" were found.</md-not-found>\n</md-autocomplete><md-chip-template><span><strong>{{vm.getChipDisplayValue($chip, \'ArticleIds\')}}</strong></span>\n</md-chip-template></md-chips><md-progress-linear md-mode="indeterminate" class="md-accent" \nng-if="vm.isArticlesLookupLoading"></md-progress-linear></md-input-container></div><div flex="100" flex-gt-xs="50" \nclass="p-5 lookup-element" ng-if="vm.isNew && vm.record.IsModelLevel"><md-input-container class="md-block"><label \ntranslate>{{ \'RESOURCES.FIELDS.MODEL_NUMBER\' | translate }}</label><md-chips name="ModelIds" \nng-model="vm.record.ModelIds" md-autocomplete-snap md-transform-chip="vm.transformChip($chip)" md-require-match="true">\n<md-autocomplete md-selected-item="vm.acSelectedItem.ModelIds" md-search-text="vm.acSearchText.ModelIds" \nmd-items="item in vm.acQuerySearch(vm.acSearchText.ModelIds, vm.record.ModelIds, \'ModelIds\')" \nmd-item-text="item.value" md-min-length="0" md-no-cache="true" md-menu-class="autocomplete-custom"><md-item-template>\n<span class="autocomplete-item md-accent-fg" md-highlight-text="vm.acSearchText.ModelIds">{{item.value}}</span>\n</md-item-template><md-not-found>No Record matching "{{vm.acSearchText.ModelIds}}" were found.</md-not-found>\n</md-autocomplete><md-chip-template><span><strong>{{vm.getChipDisplayValue($chip, \'ModelIds\')}}</strong></span>\n</md-chip-template></md-chips><md-progress-linear md-mode="indeterminate" class="md-accent" \nng-if="vm.isModelsLookupLoading"></md-progress-linear></md-input-container></div><div flex="100" flex-gt-xs="50" \nclass="p-5" ng-if="vm.isNew"><md-switch ng-model="vm.record.IsModelLevel" \naria-label="{{\'RESOURCES.FIELDS.MODEL_RESOURCE\' | translate}}" ng-true-value="true" ng-false-value="false" \nclass="md-accent" ng-change="vm.onModelLevelToggleChange()">{{\'RESOURCES.FIELDS.MODEL_RESOURCE\' | translate}}\n<md-tooltip md-direction="right">{{vm.record.IsModelLevel ? \'PARTS.YES\' : \'PARTS.NO\' | translate}}</md-tooltip>\n</md-switch></div><div flex="100" flex-gt-xs="50" class="p-5"><md-input-container class="md-block"><label translate>\nRESOURCES.FIELDS.SORT_ORDER</label><input name="SortOrder" ng-model="vm.record.SortOrder" type="number" \nng-pattern="/^\\d+$/" ng-required="false"><div ng-messages="vm.editForm.SortOrder.$error" role="alert" \nmultiple="multiple"><div ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div><div \nng-message="md-maxlength">{{\'VALIDATIONS.MAXLEN\' | translate}}</div><div ng-message="pattern">\n{{\'VALIDATIONS.INVALID_SORT_ORDER\' | translate}}</div></div></md-input-container></div><div flex="100" flex-gt-xs="50" \nclass="p-5"><md-switch ng-model="vm.record.Cascading" aria-label="{{\'RESOURCES.FIELDS.CASCADING\' | translate}}" \nng-true-value="1" ng-false-value="0" class="md-accent">{{\'RESOURCES.FIELDS.CASCADING\' | translate}}<md-tooltip \nmd-direction="right">{{vm.record.Cascading === 1 ? \'PARTS.YES\' : \'PARTS.NO\' | translate}}</md-tooltip></md-switch>\n</div><div flex="100" flex-gt-xs="100" class="p-5"><md-input-container class="md-block"><label translate>\nRESOURCES.FIELDS.CATEGORY</label><input name="Category" ng-model="vm.record.Category" type="text" ng-required="false" \nmd-maxlength="1000"><div ng-messages="vm.editForm.Category.$error" role="alert" multiple="multiple"><div \nng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div><div ng-message="md-maxlength">\n{{\'VALIDATIONS.MAXLEN\' | translate}}</div></div></md-input-container></div><div flex="100" flex-gt-xs="100" \nclass="p-5"><md-input-container class="md-block"><label translate>RESOURCES.FIELDS.DESCRIPTION</label><input \nname="Description" ng-model="vm.record.Description" type="text" ng-required="false" md-maxlength="2000"><div \nng-messages="vm.editForm.Description.$error" role="alert" multiple="multiple"><div ng-message="required">\n{{\'VALIDATIONS.REQUIRED\' | translate}}</div><div ng-message="md-maxlength">{{\'VALIDATIONS.MAXLEN\' | translate}}</div>\n</div></md-input-container></div></div></md-dialog-content><md-dialog-actions layout="row" layout-align="end center">\n<div></div><div layout="row" layout-align="end center"><md-button ng-click="vm.closeDialog(vm.isDataDirty, true)" \nclass="send-button md-primary md-raised" aria-label="Cancel" translate="ACTIONS.DIALOG_CANCEL" \ntranslate-attr-aria-label="ACTIONS.DIALOG_CANCEL" ng-disabled="vm.isLoading">CANCEL</md-button><md-button \nng-click="vm.saveRecord()" class="send-button md-accent md-raised" aria-label="Save" translate="ACTIONS.SAVE" \ntranslate-attr-aria-label="ACTIONS.SAVE" \nng-disabled="vm.isLoading || vm.editForm.$invalid || !vm.isFileValid || vm.obj.flow.isUploading() || vm.obj2.flow.isUploading()\r\n                           || (vm.isNew && !vm.record.IconFileId && !vm.record.FileId)">\nSAVE</md-button><md-button ng-click="vm.saveRecord(true)" class="send-button md-accent md-raised" aria-label="Save" \nng-show="vm.isNew" translate="ACTIONS.SAVE_AND_NEW" translate-attr-aria-label="ACTIONS.SAVE_AND_NEW" \nng-disabled="vm.isLoading || vm.editForm.$invalid || !vm.isFileValid || vm.obj.flow.isUploading() || vm.obj2.flow.isUploading()\r\n                           || (vm.isNew && !vm.record.IconFileId && !vm.record.FileId)">\nSAVE</md-button></div></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/accounts/sellers/details/tabs/size-scale-groups/dialogs/add-update-size-scale.html','<md-dialog class="edit-dialog" aria-label="Create Size Scale"><form name="vm.editForm" class="md-inline-form">\n<md-toolbar class="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" layout-align="space-between center">\n<span class="title" \ntranslate="{{ vm.isNew? \'SELLER_SIZE_SCALE_GROUP.TITLES.CREATE_SIZE_SCALE\': vm.isEditCriteria ? \'SELLER_SIZE_SCALE_GROUP.ACTIONS.UPDATE_CRITERIA\' : \'SELLER_SIZE_SCALE_GROUP.TITLES.UPDATE_SIZE_SCALE\' }}">\n{{vm.isNew ? \'Create Size Scale\' : vm.isEditCriteria ? \'Edit Criteria\' : \'Update Size Scale\'}}</span><md-button \nclass="md-icon-button" ng-click="vm.closeDialog(vm.isDataDirty)" aria-label="Close dialog" tranlate \ntranslate-aria-label="ACTIONS.DIALOG_CLOSE"><md-icon md-font-icon="icon-close"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div layout="row" layout-wrap><div flex="100" class="p-5 lookup-element" \nng-if="!vm.isEditCriteria"><md-autocomplete id="dialog_input_{{customIndex}}" md-input-name="MasterSizeScaleId" \nmd-selected-item="vm.lookupModel.MasterSizeScaleId" \nmd-items="item in vm.searchMasterSizeScale(vm.searchText.MasterSizeScaleId)" \nmd-search-text="vm.searchText.MasterSizeScaleId" md-item-text="vm.getMasterSizeScaleDisplayValue(item)" \nmd-min-length="0" md-floating-label="{{\'SELLER_SIZE_SCALE_GROUP.FIELDS.MASTER_SIZE_SCALE\' | translate}}" \nmd-selected-item-change="vm.onMasterSizeScaleChange(vm.lookupModel.MasterSizeScaleId)" ng-required="true" \nmd-no-cache="true" tx-clear-autocomplete ng-click="vm.selectText($event)" md-menu-class="autocomplete-custom">\n<md-item-template><span class="autocomplete-item md-accent-fg" md-highlight-text="vm.searchText.MasterSizeScaleId" \nmd-highlight-flags="i">{{item.SizeScale}}</span></md-item-template><div \nng-messages="vm.editForm.MasterSizeScaleId.$error" role="alert" ng-show="vm.editForm.MasterSizeScaleId.$touched"><div \nng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div></div><md-not-found>\nNo Record matching "{{vm.searchText.MasterSizeScaleId}}" were found.</md-not-found></md-autocomplete></div><div \nflex="100" flex-gt-xs="100" class="p-5" ng-if="!vm.isEditCriteria"><md-input-container class="md-block"><label \ntranslate>SELLER_SIZE_SCALE_GROUP.FIELDS.SIZE_SCALE</label><input id="dialog_input_1" name="SizeScale" \nng-model="vm.record.SizeScale" type="text" ng-required="true" \ntx-unique-value="vm.existingRecordsForUniqueValue:SizeScale:true" ng-disabled="vm.record.MasterSizeScaleId == null">\n<div ng-messages="vm.editForm.SizeScale.$error" role="alert" multiple="multiple"><div ng-message="required">\n{{\'VALIDATIONS.REQUIRED\' | translate}}</div><div ng-message="tx-unique-value">{{\'VALIDATIONS.NOT_UNIQUE\' | translate}}\n</div></div></md-input-container></div><div flex="100" flex-gt-xs="100" class="p-5 lookup-element" \nng-if="!vm.isEditCriteria"><md-input-container class="md-block"><label>\n{{\'SELLER_SIZE_SCALE_GROUP.FIELDS.SIZES\' | translate}}*</label><md-chips id="dialog_input_2" name="Sizes" \nng-model="vm.record.Sizes" md-autocomplete-snap md-transform-chip="vm.transformChip($chip)" md-require-match="true" \nng-required="true"><md-autocomplete md-selected-item="vm.acSelectedItem.Sizes" md-search-text="vm.acSearchText.Sizes" \nmd-items="item in vm.acQuerySearch(vm.acSearchText.Sizes, vm.record.Sizes, vm.availableSizes)" md-item-text="item" \nmd-min-length="0" md-no-cache="true" md-menu-class="autocomplete-custom"><md-item-template><span \nclass="autocomplete-item md-accent-fg" md-highlight-text="vm.acSearchText.Sizes">{{item}}</span></md-item-template>\n<md-not-found>No Record matching "{{vm.acSearchText.Sizes}}" were found.</md-not-found></md-autocomplete>\n<md-chip-template><span><strong>{{vm.getChipDisplayValue($chip, vm.availableSizes)}}</strong></span></md-chip-template>\n</md-chips><div class="md-chips-messages" ng-messages="vm.editForm.Sizes.$error" \nng-show="vm.editForm.BlockedCatalogs.$dirty || vm.editForm.BlockedCatalogs.$submitted"><div ng-message="required">\n{{ \'VALIDATIONS.REQUIRED\' | translate}}</div></div></md-input-container></div><div flex="100" flex-gt-xs="50" \nclass="p-5" ng-if="!vm.isNew && !vm.isEditCriteria"><md-switch id="catalog_dialog_input_3" \nng-model="vm.record.IsObsolete" aria-label="{{\'SIZE_SCALE_GROUP.FIELDS.IS_OBSOLETE\' | translate}}" ng-true-value="1" \nng-false-value="0" class="md-accent">{{\'SIZE_SCALE_GROUP.FIELDS.IS_OBSOLETE\' | translate}}<md-tooltip \nmd-direction="right">{{vm.record.IsObsolete === 1 ? \'PARTS.YES\' : \'PARTS.NO\' | translate}}</md-tooltip></md-switch>\n</div></div></md-dialog-content><md-dialog-actions layout="row" layout-align="end center"><div></div><div layout="row" \nlayout-align="end center"><md-button ng-click="vm.closeDialog(vm.isDataDirty)" \nclass="send-button md-primary md-raised" aria-label="Cancel" translate="ACTIONS.DIALOG_CANCEL" \ntranslate-attr-aria-label="ACTIONS.DIALOG_CANCEL" ng-disabled="vm.isLoading">CANCEL</md-button><md-button \nng-click="vm.saveRecord()" class="send-button md-accent md-raised" aria-label="Save" translate="ACTIONS.SAVE" \ntranslate-attr-aria-label="ACTIONS.SAVE" ng-disabled="vm.isLoading || vm.editForm.$invalid">SAVE</md-button></div>\n</md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/accounts/users/details/tabs/catalog-access/dialogs/assign-catalogs-to-user.html','<md-dialog class="edit-dialog" aria-label="Assign Catalog"><form name="vm.editForm" class="md-inline-form"><md-toolbar \nclass="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" layout-align="space-between center"><span \nclass="title" translate="CATALOG_ACCESS.TITLES.ASSIGN_CATALOGS">Assign Catalogs</span><md-button \nclass="md-icon-button" ng-click="vm.closeDialog(vm.isDataDirty)" aria-label="Close dialog" \ntranslate-aria-label="ACTIONS.DIALOG_CLOSE"><md-icon md-font-icon="icon-close"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div layout="row" layout-wrap><div flex="100" class="p-5 lookup-element">\n<md-input-container class="md-block"><label>{{\'CATALOGS.FIELDS.CATALOG_NAME\' | translate}}</label><md-chips \nid="assign-catalog-dialog-catalogCode" name="CatalogCode" ng-model="vm.assignedCatalogCodes" md-autocomplete-snap \nmd-transform-chip="vm.transformChip($chip)" md-require-match="true" ng-required="true"><md-autocomplete \nmd-selected-item="vm.acSelectedItem.CatalogCode" md-search-text="vm.searchText" \nmd-items="item in vm.querySearch(vm.searchText, vm.assignedCatalogCodes)" md-item-text="item.CatalogName" \nmd-min-length="0" md-no-cache="true" md-autofocus md-menu-class="autocomplete-custom"><md-item-template><span \nclass="autocomplete-item md-accent-fg" md-highlight-text="vm.searchText" md-highlight-flags="^i">{{item.CatalogName}}\n</span></md-item-template><md-not-found>No Record matching "{{vm.searchText}}" were found.</md-not-found>\n</md-autocomplete><md-chip-template><span><strong>{{vm.getChipDisplayValue($chip)}}</strong></span></md-chip-template>\n</md-chips><div class="md-chips-messages" ng-messages="vm.editForm.CatalogCode.$error" \nng-show="vm.editForm.CatalogCode.$dirty || vm.editForm.CatalogCode.$submitted"><div ng-message="required">\n{{ \'VALIDATIONS.REQUIRED\' | translate}}</div></div></md-input-container></div></div></md-dialog-content>\n<md-dialog-actions layout="row" layout-align="end center"><div></div><div layout="row" layout-align="end center">\n<md-button ng-click="vm.closeDialog(vm.isDataDirty)" class="send-button md-primary md-raised" aria-label="Cancel" \ntranslate="ACTIONS.DIALOG_CANCEL" translate-attr-aria-label="ACTIONS.DIALOG_CANCEL" ng-disabled="vm.isLoading">CANCEL\n</md-button><md-button ng-click="vm.saveRecord()" class="send-button md-accent md-raised" aria-label="Save" \ntranslate="ACTIONS.SAVE" translate-attr-aria-label="ACTIONS.SAVE" \nng-disabled="vm.isLoading || vm.assignedCatalogCodes.length < 1">SAVE</md-button><md-button \nng-click="vm.saveRecord(true)" class="send-button md-accent md-raised" aria-label="Save" \ntranslate="ACTIONS.SAVE_AND_NEW" translate-attr-aria-label="ACTIONS.SAVE_AND_NEW" \nng-disabled="vm.isLoading || vm.assignedCatalogCodes.length < 1">SAVE</md-button></div></md-dialog-actions></form>\n</md-dialog>');
$templateCache.put('app/main/catalogs/details/tabs/catalog-color-palette/dialogs/add-update-catalog-color-palette/add-update-catalog-color-palette.html','<md-dialog class="edit-dialog color-palette-dialog" aria-label="Create Color Palette"><form name="vm.editForm" \nclass="md-inline-form"><md-toolbar class="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" \nlayout-align="space-between center"><span class="title" \ntranslate="{{ vm.isNew? \'CATALOG_COLOR_PALETTE.TITLES.CREATE_COLOR_PALETTE\': \'CATALOG_COLOR_PALETTE.TITLES.UPDATE_COLOR_PALETTE\' }}">\n{{vm.isNew ? \'Create Color Palette\' : \'Update Color Palette\'}}</span><md-button class="md-icon-button" \nng-click="vm.closeDialog(vm.isDataDirty)" aria-label="Close dialog" tranlate \ntranslate-aria-label="ACTIONS.DIALOG_CLOSE"><md-icon md-font-icon="icon-close"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div layout="row" layout-wrap><div flex="100" flex-gt-xs="50" class="p-5">\n<md-input-container class="md-block"><label translate>CATALOG_COLOR_PALETTE.FIELDS.NAME</label><input \nid="dialog_input_first" name="Name" ng-model="vm.record.Name" type="text" ng-required="true" md-autofocus \ntx-unique-value="vm.existingRecordsForUniqueValue:Name:true"><div ng-messages="vm.editForm.Name.$error" role="alert" \nmultiple="multiple"><div ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div><div \nng-message="tx-unique-value">{{\'VALIDATIONS.NOT_UNIQUE\' | translate}}</div></div></md-input-container></div><div \nflex="100" flex-gt-xs="100" class="p-5 lookup-element"><md-input-container class="md-block"><label>\n{{\'CATALOG_COLOR_PALETTE.FIELDS.COLORS\' | translate}}*</label><md-chips id="dialog_input_1" name="SellerColorIds" \nng-model="vm.record.SellerColorIds" md-autocomplete-snap md-transform-chip="vm.transformColorChip($chip)" \nmd-require-match="true" ng-required="true"><md-autocomplete md-selected-item="vm.acSelectedItem.SellerColorIds" \nmd-search-text="vm.acSearchText.SellerColorIds" \nmd-items="item in vm.acQuerySearch(vm.acSearchText.SellerColorIds, vm.record.SellerColorIds, vm.sellerColors)" \nmd-item-text="item.ColorName" md-min-length="0" md-no-cache="true" md-menu-class="autocomplete-custom">\n<md-item-template><span class="autocomplete-item md-accent-fg" md-highlight-text="vm.acSearchText.SellerColorIds">\n{{item.ColorName}}</span></md-item-template><md-not-found>\nNo Record matching "{{vm.acSearchText.SellerColorIds}}" were found.</md-not-found></md-autocomplete><md-chip-template>\n<span><strong>{{vm.getChipDisplayValue($chip, vm.sellerColors)}}</strong></span></md-chip-template></md-chips>\n</md-input-container></div><div flex="100" flex-gt-xs="100" class="p-5 lookup-element"><div \nng-repeat="group in vm.criteriaGroups track by $index" ng-init="gi = $index" flex="100"><div class="criteria-or" \nng-if="!$first" layout="row" layout-align="center center"><span translate>CATALOG_COLOR_PALETTE.CRITERIA.OR</span>\n</div><fieldset class="criteria-group" ng-class="{\'criteria-group-invalid\': group.isDuplicate}"><legend \nclass="header-non-editable-attributes">{{\'CATALOG_COLOR_PALETTE.CRITERIA.TITLE\' | translate:{number: gi + 1} }}\n</legend><md-button class="md-icon-button criteria-group-delete" ng-if="vm.criteriaGroups.length > 1" \nng-click="vm.removeGroup(gi)" aria-label="{{\'CATALOG_COLOR_PALETTE.CRITERIA.REMOVE\' | translate}}"><md-icon \nmd-font-icon="icon-delete"></md-icon><md-tooltip md-direction="top">\n{{\'CATALOG_COLOR_PALETTE.CRITERIA.REMOVE\' | translate}}</md-tooltip></md-button><div \nng-repeat="row in group.rows track by $index" ng-init="ri = $index" flex="100" layout="row" layout-wrap><div \nflex="100" flex-gt-xs="45" class="p-5 lookup-element"><md-autocomplete id="dialog_input_attr_{{gi}}_{{ri}}" \nmd-input-name="attr_{{gi}}_{{ri}}" md-selected-item="vm.lookupModel[gi][ri].Attributeid" \nmd-items="item in vm.lookupAttributeSearch(vm.searchText[gi][ri].Attributeid, gi)" \nmd-search-text="vm.searchText[gi][ri].Attributeid" md-item-text="vm.getAttributeLookupDisplayValue(item)" \nmd-min-length="0" md-floating-label="{{\'CATALOG_COLOR_PALETTE.FIELDS.ATTRIBUTE\' | translate}}" md-no-cache="true" \ntx-clear-autocomplete ng-click="vm.selectText($event)" \nmd-selected-item-change="vm.lookupAttributeChange(vm.lookupModel[gi][ri].Attributeid, gi, ri)" \nmd-menu-class="autocomplete-custom"><md-item-template><span class="autocomplete-item md-accent-fg" \nmd-highlight-text="vm.searchText[gi][ri].Attributeid" md-highlight-flags="i">{{item.AttributeDisplayName}}</span>\n</md-item-template><md-not-found>No Record matching "{{vm.searchText[gi][ri].Attributeid}}" were found.</md-not-found>\n</md-autocomplete></div><div flex="100" flex-gt-xs="45" class="p-5" ng-if="row.Attributeid != null" \nng-include="\'app/main/catalogs/details/tabs/catalog-color-palette/dialogs/add-update-catalog-color-palette/criteria-value-editor.html\'">\n</div><div flex="10" class="p-5 criteria-row-actions" ng-if="row.Attributeid != null"><md-button \nclass="md-icon-button" ng-click="vm.removeRow(gi, ri)" \naria-label="{{\'CATALOG_COLOR_PALETTE.CRITERIA.REMOVE_CONDITION\' | translate}}"><md-icon \nmd-font-icon="icon-close-circle"></md-icon><md-tooltip md-direction="top">\n{{\'CATALOG_COLOR_PALETTE.CRITERIA.REMOVE_CONDITION\' | translate}}</md-tooltip></md-button></div></div><div \nclass="criteria-summary criteria-summary-invalid" ng-if="group.isDuplicate" role="alert" translate>\nCATALOG_COLOR_PALETTE.MESSAGES.CRITERIA_DUPLICATE_HINT</div></fieldset></div><div class="p-5"><md-button \nclass="md-accent criteria-add" ng-click="vm.addGroup()" \naria-label="{{\'CATALOG_COLOR_PALETTE.CRITERIA.ADD\' | translate}}"><md-icon md-font-icon="icon-plus"></md-icon><span \ntranslate>CATALOG_COLOR_PALETTE.CRITERIA.ADD</span></md-button></div></div></div></md-dialog-content><md-dialog-actions\n layout="row" layout-align="end center"><div></div><div layout="row" layout-align="end center"><md-button \nng-click="vm.closeDialog(vm.isDataDirty)" class="send-button md-primary md-raised" aria-label="Cancel" \ntranslate="ACTIONS.DIALOG_CANCEL" translate-attr-aria-label="ACTIONS.DIALOG_CANCEL" ng-disabled="vm.isLoading">CANCEL\n</md-button><md-button ng-click="vm.saveRecord()" class="send-button md-accent md-raised" aria-label="Save" \ntranslate="ACTIONS.SAVE" translate-attr-aria-label="ACTIONS.SAVE" ng-disabled="vm.isLoading || vm.editForm.$invalid">\nSAVE</md-button></div></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/catalogs/details/tabs/catalog-color-palette/dialogs/add-update-catalog-color-palette/criteria-value-editor.html','<div ng-switch="row.inputType" class="criteria-value"><md-input-container class="md-block" ng-switch-when="textArea">\n<input id="dialog_input_value_{{gi}}_{{ri}}" name="value_{{gi}}_{{ri}}" type="text" ng-model="row.value" \nng-change="vm.clearRowError(row)" aria-label="{{row.AttributeDisplayName}}"></md-input-container><md-input-container \nclass="md-block" ng-switch-when="calculated"><input id="dialog_input_value_{{gi}}_{{ri}}" name="value_{{gi}}_{{ri}}" \ntype="text" ng-model="row.value" ng-change="vm.clearRowError(row)" aria-label="{{row.AttributeDisplayName}}">\n</md-input-container><md-input-container class="md-block" ng-switch-when="number"><input \nid="dialog_input_value_{{gi}}_{{ri}}" name="value_{{gi}}_{{ri}}" type="number" ng-model="row.value" \nng-change="vm.clearRowError(row)" aria-label="{{row.AttributeDisplayName}}"></md-input-container><md-input-container \nclass="md-block" ng-switch-when="decimal"><input id="dialog_input_value_{{gi}}_{{ri}}" name="value_{{gi}}_{{ri}}" \ntype="number" ng-model="row.value" ng-change="vm.clearRowError(row)" pattern="{{row.validation.pattern}}" \naria-label="{{row.AttributeDisplayName}}"><div ng-messages="vm.editForm[\'value_\' + gi + \'_\' + ri].$error" role="alert" \nmultiple="multiple"><div ng-message="pattern">{{row.validation.messages.pattern | translate}}</div></div>\n</md-input-container><div ng-switch-when="date" layout="column" flex><md-datepicker \nid="dialog_input_value_{{gi}}_{{ri}}" name="value_{{gi}}_{{ri}}" ng-model="row.value" \nng-change="vm.clearRowError(row)" ng-init="row.value = vm.getDateObj(row.value)" md-placeholder=""></md-datepicker>\n</div><div ng-switch-when="date-without-time" layout="column" flex><md-datepicker \nid="dialog_input_value_{{gi}}_{{ri}}" name="value_{{gi}}_{{ri}}" ng-model="row.value" \nng-change="vm.clearRowError(row)" ng-init="row.value = vm.getDateObj(row.value)" md-placeholder=""></md-datepicker>\n</div><div ng-switch-when="date-option" layout="column" flex><md-datepicker id="dialog_input_value_{{gi}}_{{ri}}" \nname="value_{{gi}}_{{ri}}" ng-model="row.value" ng-change="vm.clearRowError(row)" \nng-init="row.value = vm.getDateObj(row.value)" md-placeholder=""></md-datepicker></div><div ng-switch-when="bool-str">\n<md-switch id="dialog_input_value_{{gi}}_{{ri}}" name="value_{{gi}}_{{ri}}" ng-model="row.value" \nng-change="vm.clearRowError(row)" aria-label="{{row.AttributeDisplayName}}" ng-true-value="\'true\'" \nng-false-value="\'false\'" class="md-accent"></md-switch></div><md-input-container class="md-block" \nng-switch-when="list"><md-select id="dialog_input_value_{{gi}}_{{ri}}" name="value_{{gi}}_{{ri}}" ng-model="row.value" \nng-change="vm.clearRowError(row)" aria-label="{{row.AttributeDisplayName}}"><md-option md-option-empty ng-value="\'\'">\n<em>None</em></md-option><md-option ng-value="option" ng-repeat="option in row.values">{{ option }}</md-option>\n</md-select></md-input-container><div ng-switch-when="tags"><md-chips id="dialog_input_value_{{gi}}_{{ri}}" \nname="value_{{gi}}_{{ri}}" ng-model="row.value" placeholder="{{\'ACTIONS.ADD_TAGS\' | translate}}" \nsecondary-placeholder="{{\'ACTIONS.ADD_TAGS\' | translate}}" md-enable-chip-edit="true" md-on-add="vm.add($chip, row)" \nmd-separator-keys="vm.tagSeperatorKeys[row.AttributeSystemName]"></md-chips></div><md-input-container class="md-block" \nng-switch-when="multi-value"><md-chips id="dialog_input_value_{{gi}}_{{ri}}" name="value_{{gi}}_{{ri}}" \nng-model="row.value" md-autocomplete-snap md-transform-chip="vm.transformChip($chip)" \nmd-on-add="vm.clearRowError(row)" aria-label="{{row.AttributeDisplayName}}"><md-autocomplete \nmd-selected-item="vm.acSelectedItem[row.AttributeSystemName]" \nmd-search-text="vm.acSearchText[row.AttributeSystemName]" \nmd-items="item in vm.multiValueQuerySearch(vm.acSearchText[row.AttributeSystemName], row.value, row)" \nmd-item-text="item" md-min-length="0" md-no-cache="true" md-menu-class="autocomplete-custom"><md-item-template><span \nclass="autocomplete-item md-accent-fg" md-highlight-text="vm.acSearchText[row.AttributeSystemName]">{{item}}</span>\n</md-item-template><md-not-found>No Record matching "{{vm.acSearchText[row.AttributeSystemName]}}" were found.\n</md-not-found></md-autocomplete><md-chip-template><span><strong>{{$chip}}</strong></span></md-chip-template>\n</md-chips></md-input-container><div class="criteria-value-error" ng-if="row.hasValueError" role="alert">\n{{\'VALIDATIONS.REQUIRED\' | translate}}</div></div>');
$templateCache.put('app/main/catalogs/details/tabs/catalog-color-palette/dialogs/view-colors/view-colors.html','<md-dialog aria-label="label" class="restricted-attributes-dialog tx-dialog"><md-toolbar class="md-accent md-hue-2">\n<div class="md-toolbar-tools" layout="row" layout-align="space-between center"><span class="title">\n{{\'CATALOG_COLOR_PALETTE.TITLES.COLORS\' | translate}}</span><md-button class="md-icon-button" \nng-click="vm.closeDialog()" aria-label="Close dialog" tranlate translate-aria-label="ACTIONS.DIALOG_CLOSE"><md-icon \nmd-font-icon="icon-close"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div \nclass="page-layout carded fullwidth list-view" layout="row" layout-align="start start"><div class="center" \nlayout="column" flex><div class="content-card" layout="column" flex><tx-data-table tx-data="vm.data" \ntx-model="vm.model" tx-view="mainList" tx-filtered-data="vm.filteredData" tx-data-filter="global.search">\n</tx-data-table></div></div></div></md-dialog-content></md-dialog>');
$templateCache.put('app/main/catalogs/details/tabs/restrict-attributes/dialogs/add-update-restricted-attributes/add-update-restricted-attributes.html','<md-dialog class="edit-dialog" aria-label="Create Attribute Restriction"><form name="vm.editForm" \nclass="md-inline-form"><md-toolbar class="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" \nlayout-align="space-between center"><span class="title" \ntranslate="{{ vm.isNew? \'RESTRICT_ATTRIBUTES.TITLES.CREATE_ATTRIBUTE_RESTRICTION\': \'RESTRICT_ATTRIBUTES.TITLES.UPDATE_ATTRIBUTE_RESTRICTION\' }}">\n{{vm.isNew ? \'Create Attribute Restriction\' : \'Update Attribute Restriction\'}}</span><md-button class="md-icon-button" \nng-click="vm.closeDialog(vm.isDataDirty)" aria-label="Close dialog" tranlate \ntranslate-aria-label="ACTIONS.DIALOG_CLOSE"><md-icon md-font-icon="icon-close"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div layout="row" layout-wrap><div flex="100" flex-gt-xs="50" class="p-5" \nng-if="vm.isNew"><md-select id="dialog_input_$first" ng-model="vm.accountType" \nplaceholder="{{\'AUTH_USERS.FIELDS.ACCOUNT_TYPE\' | translate}}" aria-label="Account Type" \nng-change="vm.onAccountTypeChange(vm.accountType)" ng-required="vm.isNew"><md-option \nng-repeat="accountType in vm.accountTypes | orderBy:\'value\'" ng-value="accountType">{{ accountType.value }}</md-option>\n</md-select></div><div flex="100" class="p-5 lookup-element" ng-if="vm.isNew"><md-autocomplete \nid="dialog_input_{{$index}}" md-input-name="roleId" md-selected-item="vm.lookupModel.roleId" \nmd-items="item in vm.searchRole(vm.searchText.roleId)" md-search-text="vm.searchText.roleId" \nmd-item-text="vm.getRoleDisplayValue(item)" md-min-length="0" \nmd-floating-label="{{\'RESTRICT_BUCKET_ATTRIBUTES.FIELDS.ROLE_NAME\' | translate}}" \nmd-selected-item-change="vm.onRoleChange(vm.lookupModel.roleId)" ng-required="true" md-no-cache="true" \ntx-clear-autocomplete tx-force-select ng-click="vm.selectText($event)" md-menu-class="autocomplete-custom">\n<md-item-template><span class="autocomplete-item md-accent-fg" md-highlight-text="vm.searchText.roleId" \nmd-highlight-flags="i">{{item.UserRole}}</span></md-item-template><div ng-messages="vm.editForm.roleId.$error" \nrole="alert" ng-show="vm.editForm.roleId.$touched"><div ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}\n</div></div><md-not-found>No Record matching "{{vm.searchText.roleId}}" were found.</md-not-found></md-autocomplete>\n</div><div flex="100" flex-gt-xs="50" class="p-5" ng-if="!vm.isNew"><md-input-container class="md-block"><input \nid="dialog_input_{{$index}}" name="roleName" ng-model="vm.lookupModel.roleName" type="text" ng-disabled="true">\n</md-input-container></div><div ng-repeat="record in vm.records" flex="100" layout="row" layout-wrap><div flex="100" \nflex-gt-xs="50" class="p-5 lookup-element"><md-autocomplete id="dialog_input_{{$index}}" md-input-name="Id" \nmd-selected-item="vm.lookupModel[$index].Id" md-items="item in vm.lookupSearch(vm.searchText[$index].Id, \'Id\')" \nmd-search-text="vm.searchText[$index].Id" md-item-text="vm.getLookupDisplayValue(item, \'Id\')" md-min-length="0" \nmd-floating-label="{{\'ARTICLES_BLOCKING.FIELDS.ATTRIBUTE_ID\' | translate}}" md-no-cache="true" tx-clear-autocomplete \ntx-force-select ng-click="vm.selectText($event)" \nmd-selected-item-change="vm.lookupChange(vm.lookupModel[$index].Id, $index)" md-menu-class="autocomplete-custom">\n<md-item-template><span class="autocomplete-item md-accent-fg" md-highlight-text="vm.searchText[$index].Id" \nmd-highlight-flags="i">{{item.AttributeDisplayName}}</span></md-item-template><md-not-found>\nNo Record matching "{{vm.searchText[$index].Id}}" were found.</md-not-found><div \nng-messages="vm.editForm.Id_$index.$error" role="alert" ng-show="vm.editForm.Id_$index.$touched" multiple="multiple">\n<div ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div></div></md-autocomplete></div><div flex="100" \nflex-gt-xs="25" class="p-5"><md-switch ng-model="vm.records[$index].NotViewable" id="dialog_input_{{$index}}" \naria-label="{{\'RESTRICT_BUCKET_ATTRIBUTES.FIELDS.NOT_VIEWABLE\' | translate}}" ng-true-value="1" ng-false-value="0" \nclass="md-accent" ng-click="vm.records[$index].NotEditable = 1">\n{{\'RESTRICT_BUCKET_ATTRIBUTES.FIELDS.NOT_VIEWABLE\' | translate}}<md-tooltip md-direction="right">\n{{vm.records[$index].NotViewable === 1 ? \'PARTS.YES\' : \'PARTS.NO\' | translate}}</md-tooltip></md-switch></div><div \nflex="100" flex-gt-xs="25" class="p-5"><md-switch ng-model="vm.records[$index].NotEditable" \nid="dialog_input_{{$index}}" aria-label="{{\'RESTRICT_BUCKET_ATTRIBUTES.FIELDS.NOT_EDITABLE\' | translate}}" \nng-true-value="1" ng-false-value="0" class="md-accent" ng-disabled="vm.records[$index].NotViewable === 1">\n{{\'RESTRICT_BUCKET_ATTRIBUTES.FIELDS.NOT_EDITABLE\' | translate}}<md-tooltip md-direction="right">\n{{vm.records[$index].NotEditable === 1 ? \'PARTS.YES\' : \'PARTS.NO\' | translate}}</md-tooltip></md-switch></div></div>\n</div></md-dialog-content><md-dialog-actions layout="row" layout-align="end center"><div></div><div layout="row" \nlayout-align="end center"><md-button ng-click="vm.closeDialog(vm.isDataDirty)" \nclass="send-button md-primary md-raised" aria-label="Cancel" translate="ACTIONS.DIALOG_CANCEL" \ntranslate-attr-aria-label="ACTIONS.DIALOG_CANCEL" ng-disabled="vm.isLoading">CANCEL</md-button><md-button \nng-click="vm.saveRecord()" class="send-button md-accent md-raised" aria-label="Save" translate="ACTIONS.SAVE" \ntranslate-attr-aria-label="ACTIONS.SAVE" ng-disabled="vm.isLoading || vm.editForm.$invalid">SAVE</md-button></div>\n</md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/catalogs/details/tabs/restrict-attributes/dialogs/view-restricted-attributes/view-restricted-attributes.html','<md-dialog aria-label="label" class="restricted-attributes-dialog tx-dialog"><md-toolbar class="md-accent md-hue-2">\n<div class="md-toolbar-tools" layout="row" layout-align="space-between center"><span class="title">\n{{\'RESTRICT_ATTRIBUTES.TITLES.ATTRIBUTES\' | translate}}</span><md-button class="md-icon-button" \nng-click="vm.closeDialog()" aria-label="Close dialog" tranlate translate-aria-label="ACTIONS.DIALOG_CLOSE"><md-icon \nmd-font-icon="icon-close"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div \nclass="page-layout carded fullwidth list-view" layout="row" layout-align="start start"><div class="center" \nlayout="column" flex><div class="content-card" layout="column" flex><tx-data-table tx-data="vm.data" \ntx-model="vm.model" tx-view="mainList" tx-filtered-data="vm.filteredData" tx-data-filter="global.search">\n</tx-data-table></div></div></div></md-dialog-content></md-dialog>');
$templateCache.put('app/main/catalogs/details/tabs/restrict-bucket-attributes/dialogs/update-restricted-bucket-attributes/update-restricted-bucket-attributes.html','<md-dialog class="edit-dialog" aria-label="Assign allocation groups"><form name="vm.editForm" class="md-inline-form">\n<md-toolbar class="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" layout-align="space-between center">\n<span class="title" \ntranslate="{{vm.isNew ? \'RESTRICT_BUCKET_ATTRIBUTES.ACTIONS.CREATE_BUCKET_ATTRIBUTES\': \'RESTRICT_BUCKET_ATTRIBUTES.ACTIONS.EDIT_BUCKET_ATTRIBUTES\'}}">\n{{vm.isNew ? \'Create Restrictions\' : \'Edit Restrictions\'}}</span><md-button class="md-icon-button" \nng-click="vm.closeDialog(vm.isDataDirty)" aria-label="Close dialog" tranlate \ntranslate-aria-label="ACTIONS.DIALOG_CLOSE"><md-icon md-font-icon="icon-close"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div layout="row" layout-wrap><div flex="100" flex-gt-xs="50" class="p-5" \nng-if="vm.isNew"><md-select id="dialog_input_$first" ng-model="vm.accountType" \nplaceholder="{{\'AUTH_USERS.FIELDS.ACCOUNT_TYPE\' | translate}}" aria-label="Account Type" \nng-change="vm.onAccountTypeChange(vm.accountType)" ng-required="vm.isNew"><md-option \nng-repeat="accountType in vm.accountTypes | orderBy:\'value\'" ng-value="accountType">{{ accountType.value }}</md-option>\n</md-select></div><div flex="100" class="p-5 lookup-element" ng-if="vm.isNew"><md-autocomplete \nid="dialog_input_{{$index}}" md-input-name="roleId" md-selected-item="vm.lookupModel.roleId" \nmd-items="item in vm.searchRole(vm.searchText.roleId)" md-search-text="vm.searchText.roleId" \nmd-item-text="vm.getRoleDisplayValue(item)" md-min-length="0" \nmd-floating-label="{{\'RESTRICT_BUCKET_ATTRIBUTES.FIELDS.ROLE_NAME\' | translate}}" \nmd-selected-item-change="vm.onRoleChange(vm.lookupModel.roleId)" ng-required="true" md-no-cache="true" \ntx-clear-autocomplete tx-force-select ng-click="vm.selectText($event)" md-menu-class="autocomplete-custom">\n<md-item-template><span class="autocomplete-item md-accent-fg" md-highlight-text="vm.searchText.roleId" \nmd-highlight-flags="i">{{item.UserRole}}</span></md-item-template><div ng-messages="vm.editForm.roleId.$error" \nrole="alert" ng-show="vm.editForm.roleId.$touched"><div ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}\n</div></div><md-not-found>No Record matching "{{vm.searchText.roleId}}" were found.</md-not-found></md-autocomplete>\n</div><div flex="100" flex-gt-xs="50" class="p-5" ng-if="!vm.isNew"><md-input-container class="md-block"><input \nid="dialog_input_{{$index}}" name="roleName" ng-model="vm.lookupModel.roleName" type="text" ng-disabled="true">\n</md-input-container></div><div ng-repeat="record in vm.records" flex="100" layout="row" layout-wrap><div flex="100" \nflex-gt-xs="50" class="p-5 lookup-element"><md-autocomplete id="dialog_input_{{$index}}" md-input-name="Id" \nmd-selected-item="vm.lookupModel[$index].Id" md-items="item in vm.lookupSearch(vm.searchText[$index].Id, \'Id\')" \nmd-search-text="vm.searchText[$index].Id" md-item-text="vm.getLookupDisplayValue(item, \'Id\')" md-min-length="0" \nmd-floating-label="{{\'ARTICLES_BLOCKING.FIELDS.ATTRIBUTE_ID\' | translate}}" md-no-cache="true" tx-clear-autocomplete \ntx-force-select ng-click="vm.selectText($event)" \nmd-selected-item-change="vm.lookupChange(vm.lookupModel[$index].Id, $index)" md-menu-class="autocomplete-custom">\n<md-item-template><span class="autocomplete-item md-accent-fg" md-highlight-text="vm.searchText[$index].Id" \nmd-highlight-flags="i">{{item.AttributeDisplayName}}</span></md-item-template><md-not-found>\nNo Record matching "{{vm.searchText[$index].Id}}" were found.</md-not-found><div \nng-messages="vm.editForm.Id_$index.$error" role="alert" ng-show="vm.editForm.Id_$index.$touched" multiple="multiple">\n<div ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div></div></md-autocomplete></div><div flex="100" \nflex-gt-xs="25" class="p-5"><md-switch ng-model="vm.records[$index].NotViewable" id="dialog_input_{{$index}}" \naria-label="{{\'RESTRICT_BUCKET_ATTRIBUTES.FIELDS.NOT_VIEWABLE\' | translate}}" ng-true-value="1" ng-false-value="0" \nclass="md-accent" ng-click="vm.records[$index].NotEditable = 1">\n{{\'RESTRICT_BUCKET_ATTRIBUTES.FIELDS.NOT_VIEWABLE\' | translate}}<md-tooltip md-direction="right">\n{{vm.records[$index].NotViewable === 1 ? \'PARTS.YES\' : \'PARTS.NO\' | translate}}</md-tooltip></md-switch></div><div \nflex="100" flex-gt-xs="25" class="p-5"><md-switch ng-model="vm.records[$index].NotEditable" \nid="dialog_input_{{$index}}" aria-label="{{\'RESTRICT_BUCKET_ATTRIBUTES.FIELDS.NOT_EDITABLE\' | translate}}" \nng-true-value="1" ng-false-value="0" class="md-accent" ng-disabled="vm.records[$index].NotViewable === 1">\n{{\'RESTRICT_BUCKET_ATTRIBUTES.FIELDS.NOT_EDITABLE\' | translate}}<md-tooltip md-direction="right">\n{{vm.records[$index].NotEditable === 1 ? \'PARTS.YES\' : \'PARTS.NO\' | translate}}</md-tooltip></md-switch></div></div>\n</div></md-dialog-content><md-dialog-actions layout="row" layout-align="end center"><div></div><div layout="row" \nlayout-align="end center"><md-button ng-click="vm.closeDialog(vm.isDataDirty)" \nclass="send-button md-primary md-raised" aria-label="Cancel" translate="ACTIONS.DIALOG_CANCEL" \ntranslate-attr-aria-label="ACTIONS.DIALOG_CANCEL" ng-disabled="vm.isLoading">CANCEL</md-button><md-button \nng-click="vm.saveRecord()" class="send-button md-accent md-raised" aria-label="Save" translate="ACTIONS.SAVE" \ntranslate-attr-aria-label="ACTIONS.SAVE" ng-disabled="vm.isLoading || vm.editForm.$invalid">SAVE</md-button></div>\n</md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/catalogs/details/tabs/restrict-bucket-attributes/dialogs/view-restricted-bucket-attributes/view-restricted-bucket-attributes.html','<md-dialog aria-label="label" class="restricted-bucket-attributes-dialog tx-dialog"><md-toolbar \nclass="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" layout-align="space-between center"><span \nclass="title">{{\'RESTRICT_BUCKET_ATTRIBUTES.TITLES.BUCKET_ATTRIBUTES\' | translate}}</span><md-button \nclass="md-icon-button" ng-click="vm.closeDialog()" aria-label="Close dialog" tranlate \ntranslate-aria-label="ACTIONS.DIALOG_CLOSE"><md-icon md-font-icon="icon-close"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div class="page-layout carded fullwidth list-view" layout="row" \nlayout-align="start start"><div class="center" layout="column" flex><div class="content-card" layout="column" flex>\n<tx-data-table tx-data="vm.data" tx-model="vm.model" tx-view="mainList" tx-filtered-data="vm.filteredData" \ntx-data-filter="global.search"></tx-data-table></div></div></div></md-dialog-content></md-dialog>');
$templateCache.put('app/main/catalogs/details/tabs/restrict-retail-windows/dialogs/add-update-restricted-retail-windows/add-update-restricted-retail-windows.html','<md-dialog class="edit-dialog" aria-label="Create Retail Windows Restriction"><form name="vm.editForm" \nclass="md-inline-form"><md-toolbar class="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" \nlayout-align="space-between center"><span class="title" \ntranslate="{{ vm.isNew? \'RESTRICT_RETAIL_WINDOWS.TITLES.CREATE_RETAIL_WINDOWS_RESTRICTION\': \'RESTRICT_RETAIL_WINDOWS.TITLES.UPDATE_RETAIL_WINDOWS_RESTRICTION\' }}">\n{{vm.isNew ? \'Create Retail Windows Restriction\' : \'Update Retail Windows Restriction\'}}</span><md-button \nclass="md-icon-button" ng-click="vm.closeDialog(vm.isDataDirty)" aria-label="Close dialog" tranlate \ntranslate-aria-label="ACTIONS.DIALOG_CLOSE"><md-icon md-font-icon="icon-close"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div layout="row" layout-wrap><div flex="100" flex-gt-xs="50" class="p-5" \nng-if="vm.isNew"><md-select id="dialog_input_$first" ng-model="vm.accountType" \nplaceholder="{{\'AUTH_USERS.FIELDS.ACCOUNT_TYPE\' | translate}}" aria-label="Account Type" \nng-change="vm.onAccountTypeChange(vm.accountType)" ng-required="vm.isNew"><md-option \nng-repeat="accountType in vm.accountTypes | orderBy:\'value\'" ng-value="accountType">{{ accountType.value }}</md-option>\n</md-select></div><div flex="100" class="p-5 lookup-element" ng-if="vm.isNew"><md-autocomplete \nid="dialog_input_{{$index}}" md-input-name="roleId" md-selected-item="vm.lookupModel.roleId" \nmd-items="item in vm.searchRole(vm.searchText.roleId)" md-search-text="vm.searchText.roleId" \nmd-item-text="vm.getRoleDisplayValue(item)" md-min-length="0" \nmd-floating-label="{{\'RESTRICT_RETAIL_WINDOWS.FIELDS.ROLE_NAME\' | translate}}" \nmd-selected-item-change="vm.onRoleChange(vm.lookupModel.roleId)" ng-required="true" md-no-cache="true" \ntx-clear-autocomplete tx-force-select ng-click="vm.selectText($event)" md-menu-class="autocomplete-custom">\n<md-item-template><span class="autocomplete-item md-accent-fg" md-highlight-text="vm.searchText.roleId" \nmd-highlight-flags="i">{{item.UserRole}}</span></md-item-template><div ng-messages="vm.editForm.roleId.$error" \nrole="alert" ng-show="vm.editForm.roleId.$touched"><div ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}\n</div></div><md-not-found>No Record matching "{{vm.searchText.roleId}}" were found.</md-not-found></md-autocomplete>\n</div><div flex="100" flex-gt-xs="50" class="p-5" ng-if="!vm.isNew"><md-input-container class="md-block"><input \nid="dialog_input_{{$index}}" name="roleName" ng-model="vm.lookupModel.roleName" type="text" ng-disabled="true">\n</md-input-container></div><div flex="100" layout="row" layout-wrap><div flex="100" flex-gt-xs="25" class="p-5">\n<md-switch ng-model="vm.record.NotViewable" id="dialog_input_{{$index}}" \naria-label="{{\'RESTRICT_RETAIL_WINDOWS.FIELDS.NOT_VIEWABLE\' | translate}}" ng-true-value="1" ng-false-value="0" \nclass="md-accent" ng-click="vm.record.NotEditable = 1">{{\'RESTRICT_RETAIL_WINDOWS.FIELDS.NOT_VIEWABLE\' | translate}}\n<md-tooltip md-direction="right">{{vm.record.NotViewable === 1 ? \'PARTS.YES\' : \'PARTS.NO\' | translate}}</md-tooltip>\n</md-switch></div><div flex="100" flex-gt-xs="25" class="p-5"><md-switch ng-model="vm.record.NotEditable" \nid="dialog_input_{{$index}}" aria-label="{{\'RESTRICT_RETAIL_WINDOWS.FIELDS.NOT_EDITABLE\' | translate}}" \nng-true-value="1" ng-false-value="0" class="md-accent" ng-disabled="vm.record.NotViewable === 1">\n{{\'RESTRICT_RETAIL_WINDOWS.FIELDS.NOT_EDITABLE\' | translate}}<md-tooltip md-direction="right">\n{{vm.record.NotEditable === 1 ? \'PARTS.YES\' : \'PARTS.NO\' | translate}}</md-tooltip></md-switch></div></div></div>\n</md-dialog-content><md-dialog-actions layout="row" layout-align="end center"><div></div><div layout="row" \nlayout-align="end center"><md-button ng-click="vm.closeDialog(vm.isDataDirty)" \nclass="send-button md-primary md-raised" aria-label="Cancel" translate="ACTIONS.DIALOG_CANCEL" \ntranslate-attr-aria-label="ACTIONS.DIALOG_CANCEL" ng-disabled="vm.isLoading">CANCEL</md-button><md-button \nng-click="vm.saveRecord()" class="send-button md-accent md-raised" aria-label="Save" translate="ACTIONS.SAVE" \ntranslate-attr-aria-label="ACTIONS.SAVE" ng-disabled="vm.isLoading || vm.editForm.$invalid">SAVE</md-button></div>\n</md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/catalogs/details/tabs/restrict-segmentations/dialogs/add-update-restricted-segmentations/add-update-restricted-segmentations.html','<md-dialog class="edit-dialog" aria-label="Create Attribute Restriction"><form name="vm.editForm" \nclass="md-inline-form"><md-toolbar class="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" \nlayout-align="space-between center"><span class="title" \ntranslate="{{ vm.isNew? \'RESTRICT_SEGMENTATIONS.TITLES.CREATE_SEGMENTATIONS_RESTRICTION\': \'RESTRICT_SEGMENTATIONS.TITLES.UPDATE_SEGMENTATIONS_RESTRICTION\' }}">\n{{vm.isNew ? \'Create Segmentation Restriction\' : \'Update Segmentation Restriction\'}}</span><md-button \nclass="md-icon-button" ng-click="vm.closeDialog(vm.isDataDirty)" aria-label="Close dialog" tranlate \ntranslate-aria-label="ACTIONS.DIALOG_CLOSE"><md-icon md-font-icon="icon-close"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div layout="row" layout-wrap><div flex="100" flex-gt-xs="50" class="p-5" \nng-if="vm.isNew"><md-select id="dialog_input_$first" ng-model="vm.accountType" \nplaceholder="{{\'AUTH_USERS.FIELDS.ACCOUNT_TYPE\' | translate}}" aria-label="Account Type" \nng-change="vm.onAccountTypeChange(vm.accountType)" ng-required="vm.isNew"><md-option \nng-repeat="accountType in vm.accountTypes | orderBy:\'value\'" ng-value="accountType">{{ accountType.value }}</md-option>\n</md-select></div><div flex="100" class="p-5 lookup-element" ng-if="vm.isNew"><md-autocomplete \nid="dialog_input_{{$index}}" md-input-name="roleId" md-selected-item="vm.lookupModel.roleId" \nmd-items="item in vm.searchRole(vm.searchText.roleId)" md-search-text="vm.searchText.roleId" \nmd-item-text="vm.getRoleDisplayValue(item)" md-min-length="0" \nmd-floating-label="{{\'RESTRICT_SEGMENTATIONS.FIELDS.ROLE_NAME\' | translate}}" \nmd-selected-item-change="vm.onRoleChange(vm.lookupModel.roleId)" ng-required="true" md-no-cache="true" \ntx-clear-autocomplete tx-force-select ng-click="vm.selectText($event)" md-menu-class="autocomplete-custom">\n<md-item-template><span class="autocomplete-item md-accent-fg" md-highlight-text="vm.searchText.roleId" \nmd-highlight-flags="i">{{item.UserRole}}</span></md-item-template><div ng-messages="vm.editForm.roleId.$error" \nrole="alert" ng-show="vm.editForm.roleId.$touched"><div ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}\n</div></div><md-not-found>No Record matching "{{vm.searchText.roleId}}" were found.</md-not-found></md-autocomplete>\n</div><div flex="100" flex-gt-xs="50" class="p-5" ng-if="!vm.isNew"><md-input-container class="md-block"><input \nid="dialog_input_{{$index}}" name="roleName" ng-model="vm.lookupModel.roleName" type="text" ng-disabled="true">\n</md-input-container></div><div ng-repeat="record in vm.records" flex="100" layout="row" layout-wrap><div flex="100" \nflex-gt-xs="50" class="p-5 lookup-element"><md-autocomplete id="dialog_input_{{$index}}" md-input-name="Id" \nmd-selected-item="vm.lookupModel[$index].Id" md-items="item in vm.lookupSearch(vm.searchText[$index].Id, \'Id\')" \nmd-search-text="vm.searchText[$index].Id" md-item-text="vm.getLookupDisplayValue(item, \'Id\')" md-min-length="0" \nmd-floating-label="{{\'RESTRICT_SEGMENTATIONS.FIELDS.SEGMENTATION\' | translate}}" md-no-cache="true" \ntx-clear-autocomplete tx-force-select ng-click="vm.selectText($event)" \nmd-selected-item-change="vm.lookupChange(vm.lookupModel[$index].Id, $index)" md-menu-class="autocomplete-custom">\n<md-item-template><span class="autocomplete-item md-accent-fg" md-highlight-text="vm.searchText[$index].Id" \nmd-highlight-flags="i">{{item.Name}}</span></md-item-template><md-not-found>\nNo Record matching "{{vm.searchText[$index].Id}}" were found.</md-not-found><div \nng-messages="vm.editForm.Id_$index.$error" role="alert" ng-show="vm.editForm.Id_$index.$touched" multiple="multiple">\n<div ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div></div></md-autocomplete></div><div flex="100" \nflex-gt-xs="25" class="p-5"><md-switch ng-model="vm.records[$index].NotViewable" id="dialog_input_{{$index}}" \naria-label="{{\'RESTRICT_SEGMENTATIONS.FIELDS.NOT_VIEWABLE\' | translate}}" ng-true-value="1" ng-false-value="0" \nclass="md-accent" ng-click="vm.records[$index].NotEditable = 1">\n{{\'RESTRICT_SEGMENTATIONS.FIELDS.NOT_VIEWABLE\' | translate}}<md-tooltip md-direction="right">\n{{vm.records[$index].NotViewable === 1 ? \'PARTS.YES\' : \'PARTS.NO\' | translate}}</md-tooltip></md-switch></div><div \nflex="100" flex-gt-xs="25" class="p-5"><md-switch ng-model="vm.records[$index].NotEditable" \nid="dialog_input_{{$index}}" aria-label="{{\'RESTRICT_SEGMENTATIONS.FIELDS.NOT_EDITABLE\' | translate}}" \nng-true-value="1" ng-false-value="0" class="md-accent" ng-disabled="vm.records[$index].NotViewable === 1">\n{{\'RESTRICT_SEGMENTATIONS.FIELDS.NOT_EDITABLE\' | translate}}<md-tooltip md-direction="right">\n{{vm.records[$index].NotEditable === 1 ? \'PARTS.YES\' : \'PARTS.NO\' | translate}}</md-tooltip></md-switch></div></div>\n</div></md-dialog-content><md-dialog-actions layout="row" layout-align="end center"><div></div><div layout="row" \nlayout-align="end center"><md-button ng-click="vm.closeDialog(vm.isDataDirty)" \nclass="send-button md-primary md-raised" aria-label="Cancel" translate="ACTIONS.DIALOG_CANCEL" \ntranslate-attr-aria-label="ACTIONS.DIALOG_CANCEL" ng-disabled="vm.isLoading">CANCEL</md-button><md-button \nng-click="vm.saveRecord()" class="send-button md-accent md-raised" aria-label="Save" translate="ACTIONS.SAVE" \ntranslate-attr-aria-label="ACTIONS.SAVE" ng-disabled="vm.isLoading || vm.editForm.$invalid">SAVE</md-button></div>\n</md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/catalogs/details/tabs/restrict-segmentations/dialogs/view-restricted-segmentations/view-restricted-segmentations.html','<md-dialog aria-label="label" class="restricted-attributes-dialog tx-dialog"><md-toolbar class="md-accent md-hue-2">\n<div class="md-toolbar-tools" layout="row" layout-align="space-between center"><span class="title">\n{{\'RESTRICT_SEGMENTATIONS.TITLES.SEGMENTATIONS\' | translate}}</span><md-button class="md-icon-button" \nng-click="vm.closeDialog()" aria-label="Close dialog" tranlate translate-aria-label="ACTIONS.DIALOG_CLOSE"><md-icon \nmd-font-icon="icon-close"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div \nclass="page-layout carded fullwidth list-view" layout="row" layout-align="start start"><div class="center" \nlayout="column" flex><div class="content-card" layout="column" flex><tx-data-table tx-data="vm.data" \ntx-model="vm.model" tx-view="mainList" tx-filtered-data="vm.filteredData" tx-data-filter="global.search">\n</tx-data-table></div></div></div></md-dialog-content></md-dialog>');
$templateCache.put('app/main/catalogs/details/tabs/segmentation-group/dialogs/update-segmentation-groups/update-segmentation-groups.html','<md-dialog class="edit-dialog" aria-label="New User"><form name="vm.editForm" class="md-inline-form"><md-toolbar \nclass="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" layout-align="space-between center"><span \nclass="title" \ntranslate="{{vm.isNew ? \'SEGMENTATION_GROUP.TITLES.NEW_SEGMENTATION_GROUP\' : \'SEGMENTATION_GROUP.TITLES.UPDATE_SEGMENTATION_GROUP\'}}">\nNew Segmentation Group</span><md-button class="md-icon-button" ng-click="vm.closeDialog(vm.isDataDirty)" \naria-label="Close dialog" tranlate translate-aria-label="ACTIONS.DIALOG_CLOSE"><md-icon md-font-icon="icon-close">\n</md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div layout="row" layout-wrap><div flex="100" \nflex-gt-xs="50" class="p-5" ng-if="vm.isNew"><md-input-container class="md-block"><label>\n{{\'SEGMENTATION_GROUP.FIELDS.SEGMENTATION_GROUP\' | translate}}</label><input id="dialog_input_first" \nname="SegmentationGroup" ng-model="vm.record.SegmentationGroup" type="text" ng-required="true" md-maxlength="100" \ntx-unique-value="vm.existingRecordsForUniqueValue:SegmentationGroup:true"><div \nng-messages="vm.editForm.SegmentationGroup.$error" role="alert" multiple="multiple"><div ng-message="required">\n{{\'VALIDATIONS.REQUIRED\' | translate}}</div><div ng-message="md-maxlength">{{\'VALIDATIONS.MAXLEN\' | translate}}</div>\n<div ng-message="tx-unique-value">{{\'VALIDATIONS.NOT_UNIQUE\' | translate}}</div></div></md-input-container></div><div \nflex="100" class="p-5 lookup-element"><md-input-container class="md-block"><label>\n{{\'SEGMENTATION_GROUP.FIELDS.SEGMENTATIONS\' | translate}}</label><md-chips id="dialog_input_1" \nname="SegmentationidsList" ng-model="vm.record.SegmentationidsList" md-autocomplete-snap \nmd-transform-chip="vm.transformChip($chip)" md-require-match="true" ng-required="false"><md-autocomplete \nmd-selected-item="vm.acSelectedItem.SegmentationidsList" md-search-text="vm.acSearchText.SegmentationidsList" \nmd-items="item in vm.acQuerySearch(vm.acSearchText.SegmentationidsList, vm.record.SegmentationidsList, \'SegmentationidsList\')" \nmd-item-text="item.Name" md-min-length="0" md-no-cache="true" md-menu-class="autocomplete-custom"><md-item-template>\n<span class="autocomplete-item md-accent-fg" md-highlight-text="vm.acSearchText.SegmentationidsList">{{item.Name}}\n</span></md-item-template><md-not-found>No Record matching "{{vm.acSearchText.SegmentationidsList}}" were found.\n</md-not-found></md-autocomplete><md-chip-template tx-chip="vm.existingRecords:$chip"><span><strong>\n{{vm.getChipDisplayValue($chip)}}</strong></span></md-chip-template></md-chips></md-input-container></div></div>\n</md-dialog-content><md-dialog-actions layout="row" layout-align="end center"><div></div><div layout="row" \nlayout-align="end center"><md-button ng-click="vm.closeDialog(vm.isDataDirty)" \nclass="send-button md-primary md-raised" aria-label="Cancel" translate="ACTIONS.DIALOG_CANCEL" \ntranslate-attr-aria-label="ACTIONS.DIALOG_CANCEL" ng-disabled="vm.isLoading">CANCEL</md-button><md-button \nng-click="vm.saveRecord()" class="send-button md-accent md-raised" aria-label="Save" translate="ACTIONS.SAVE" \ntranslate-attr-aria-label="ACTIONS.SAVE" ng-disabled="vm.isLoading || vm.editForm.$invalid">SAVE</md-button><md-button \nng-click="vm.saveRecord(true)" class="send-button md-accent md-raised" aria-label="Save" \ntranslate="ACTIONS.SAVE_AND_NEW" translate-attr-aria-label="ACTIONS.SAVE_AND_NEW" \nng-disabled="vm.isLoading || vm.editForm.$invalid" ng-show="vm.isNew">SAVE AND NEW</md-button></div>\n</md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/catalogs/details/tabs/tree-definition/dialogs/create-tree/create-tree.html','<md-dialog class="edit-dialog" aria-label="Create Tree"><form name="vm.editForm" class="md-inline-form"><md-toolbar \nclass="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" layout-align="space-between center"><span \nclass="title" \ntranslate="{{vm.isNew ? \'TREE_DEFINITION.TITLES.NEW_TREE_DEFINITION\' : \'TREE_DEFINITION.TITLES.UPDATE_TREE_DEFINITION\'}}">\nCreate Tree</span><md-button class="md-icon-button" ng-click="vm.closeDialog(vm.isDataDirty)" \naria-label="Close dialog" tranlate translate-aria-label="ACTIONS.DIALOG_CLOSE"><md-icon md-font-icon="icon-close">\n</md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div layout="row" layout-wrap><div flex="100" \nflex-gt-xs="50" class="p-5"><md-input-container class="md-block"><label>{{\'TREE_DEFINITION.FIELDS.NAME\' | translate}}\n</label><input id="dialog_input_1" name="Name" ng-model="vm.record.Name" type="text" ng-required="true" \ntx-unique-value="vm.existingRecordsForUniqueValue:Name:true" md-maxlength="1000" md-autofocus><div \nng-messages="vm.editForm.Name.$error" role="alert" multiple="multiple"><div ng-message="required">\n{{\'VALIDATIONS.REQUIRED\' | translate}}</div><div ng-message="md-maxlength">{{\'VALIDATIONS.MAXLEN\' | translate}}</div>\n<div ng-message="tx-unique-value">{{\'VALIDATIONS.NOT_UNIQUE\' | translate}}</div></div></md-input-container></div><div \nflex="100" flex-gt-xs="50" class="p-5"><md-switch ng-model="vm.record.IsDefault" \naria-label="{{\'TREE_DEFINITION.FIELDS.IS_DEFAULT\' | translate}}" ng-true-value="1" ng-false-value="0" \nclass="md-accent">{{\'TREE_DEFINITION.FIELDS.IS_DEFAULT\' | translate}}</md-switch></div><div flex="100" \nflex-gt-xs="100" class="p-5 attribute-draggable-section" ms-scroll><div layout="row"><div \ndata-as-sortable="vm.catalogTreeListeners" data-ng-model="vm.treeUnUtilizedAttributes" flex="50" class="p-8" \nlayout-align="center center"><div data-ng-repeat="item in vm.treeUnUtilizedAttributes" data-as-sortable-item flex \nlayout-align="center center"><div data-as-sortable-item-handle class="col-chooser-item p-4">\n{{item.AttributeDisplayName}}</div></div></div><div data-as-sortable="vm.treeListeners" \ndata-ng-model="vm.record.Attributes" flex="50" class="p-8" layout-align="center center"><div \nng-show="vm.record.Attributes && vm.record.Attributes.length == 0" style="text-align: center">\n{{\'TREE_DEFINITION.NO_FIELDS_SELECTED\' | translate}}</div><div data-ng-repeat="item in vm.record.Attributes" \ndata-as-sortable-item flex layout-align="center center"><div data-as-sortable-item-handle class="col-chooser-item p-4">\n{{item.AttributeDisplayName}}</div></div></div></div></div></div></md-dialog-content><md-dialog-actions layout="row" \nlayout-align="end center"><div></div><div layout="row" layout-align="end center"><md-button \nng-click="vm.closeDialog(vm.isDataDirty)" class="send-button md-primary md-raised" aria-label="Cancel" \ntranslate="ACTIONS.DIALOG_CANCEL" translate-attr-aria-label="ACTIONS.DIALOG_CANCEL" ng-disabled="vm.isLoading">CANCEL\n</md-button><md-button ng-click="vm.saveRecord()" class="send-button md-accent md-raised" aria-label="Save" \ntranslate="ACTIONS.SAVE" translate-attr-aria-label="ACTIONS.SAVE" ng-disabled="vm.isLoading || vm.editForm.$invalid">\nSAVE</md-button></div></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/catalogs/sub-modules/articles/details/tabs/audit-trail-history/audit-trail-viewer.html','<div class="audit-trail-viewer"><div layout="row" class="audit-trail-header" layout-wrap layout-align="end center"><div\n layout-wrap layout-align="start center"><span class="ml-16 text-boxed md-accent-bg highlight" hide show-gt-xs \nng-hide="vm.viewOptions.hideBranchesInfo">\n{{vm.articleAuditTrailHistory.length}} {{\'AUDIT_TRAIL_HISTORY.TITLES.AUDIT_TRAIL_HISTORY\' | translate}}</span></div>\n<md-button class="md-icon-button" aria-label="Refresh" translate-attr-aria-label="ACTIONS.REFRESH" \nng-click="vm.refreshAuditTrailHistory(true, false)"><md-icon md-font-icon="icon-refresh"></md-icon><md-tooltip><span \ntranslate="ACTIONS.REFRESH">Refresh</span></md-tooltip></md-button></div><div layout="row" \nlayout-align="center center" ng-show="vm.isAuditTrailHistoryLoading" class="loader-container"><md-progress-circular \nmd-mode="indeterminate" class="md-accent"></md-progress-circular></div><md-content class="audit-trail-content" \nms-scroll><section id="timeline" class="timeline-outer" ng-if="!vm.isAuditTrailHistoryLoading"><div class="container">\n<div><ul class="timeline"><li class="event" ng-if="vm.articleAuditTrailHistory.length === 0"><div class="text-italic" \ntranslate="MESSAGES.LIST.NO_ITEMS">No items available...</div></li><li class="event" \nng-repeat="record in vm.articleAuditTrailHistory | limitTo: vm.articleAuditTrailHistoryLimit" \ndata-date="{{ record.ChangeDate | date:\'MMM d, y h:mm a\' }}"><h3 ng-if="record.ChangeMaker">{{ record.ChangeMaker }}\n</h3><h3 ng-if="record.CreatedBy"><b>Created By:</b> {{ record.CreatedBy }}</h3><p><ul><li \nng-repeat="item in record.Changes" style="padding:5px;margin:5px"><span style="font-weight: bold">{{ item.FieldName }}:\n</span> <span ng-if="item.Old || item.New" \nstyle="margin:5px;padding:5px;background-color:lightgrey;text-decoration:line-through">{{ item.Old }}</span> <span \nng-if="item.New || item.Old" style="margin:5px;padding:5px;background-color:lightgreen">{{ item.New }}</span><br><ul>\n<li ng-if="item.NestedValues" ng-repeat="nestedItem in item.NestedValues" style="padding:5px;margin:5px"><span \nstyle="font-weight: bold">{{ nestedItem.FieldName }}:</span> <span \nstyle="margin:5px;padding:5px;background-color:lightgrey;text-decoration:line-through">{{ nestedItem.Old }}</span> \n<span style="margin:5px;padding:5px;background-color:lightgreen">{{ nestedItem.New }}</span><br></li></ul></li></ul>\n</p></li><li ng-if="vm.articleAuditTrailHistory.length > vm.articleAuditTrailHistoryLimit"><md-button \nclass="md-accent md-raised" ng-click="vm.loadMoreAuditHistory()" aria-label="Load More"><span \ntranslate="{{AUDIT_TRAIL_HISTORY.ACTIONS.LOAD_MORE}}">{{ \'AUDIT_TRAIL_HISTORY.ACTIONS.LOAD_MORE\' | translate}}</span>\n</md-button></li></ul></div></div></section></md-content><br></div>');
$templateCache.put('app/main/catalogs/sub-modules/assortments/list/dialogs/create-criteria-collection/create-criteria-collection.html','<md-dialog class="edit-dialog dune-images-image-uploader" aria-label="New Record"><form name="vm.editForm" \nclass="md-inline-form" flow-init="vm.flowInit" flow-object="$rootScope.flowObj" \nflow-file-added="vm.validateFile($file, $event, $flow)" flow-files-submitted="vm.upload()" \nflow-file-success="vm.onSuccessUpload($file, $message, $flow)" flow-name="vm.obj.flow"><md-toolbar \nclass="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" layout-align="space-between center"><span \nclass="title" translate="{{vm.isNew ? \'TITLES.RECORD_NEW\' : \'TITLES.RECORD_EDIT\'}}">New Record</span><md-button \nclass="md-icon-button" ng-click="vm.closeDialog(vm.isDataDirty, true)" aria-label="Close dialog" tranlate \ntranslate-aria-label="ACTIONS.DIALOG_CLOSE"><md-icon md-font-icon="icon-close"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div layout="row" layout-wrap><div flex="100" flex-gt-xs="50" class="p-5">\n<md-input-container class="md-block"><label translate>ASSORTMENTS.FIELDS.NAME</label><input \nid="catalog_dialog_input_4" name="Name" ng-model="vm.record.Name" type="text" ng-required="true" md-maxlength="50"><div\n ng-messages="vm.editForm.Name.$error" role="alert" multiple="multiple"><div ng-message="required">\n{{\'VALIDATIONS.REQUIRED\' | translate}}</div><div ng-message="md-maxlength">{{\'VALIDATIONS.MAXLEN\' | translate}}</div>\n</div></md-input-container></div><div flex="100" flex-gt-xs="50" class="p-5"><md-input-container class="md-block">\n<label translate>ASSORTMENTS.FIELDS.SORT_ORDER</label><input id="dialog_input_{{$first ? \'first\' : $index}}" \nname="SortOrder" ng-model="vm.record.SortOrder" type="number"></md-input-container></div><div flex="100" \nflex-gt-xs="50" class="p-5"><md-input-container class="md-block"><label translate>ASSORTMENTS.FIELDS.CRITERIA</label>\n<textarea name="Name" ng-model="vm.record.FilterCriteria" columns="1" rows="1" ms-scroll ng-required="true">\r\n\t\t\t\t\t\t\t\n</textarea><div ng-messages="vm.editForm.FilterCriteria.$error" role="alert" multiple="multiple"><div \nng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div></div></md-input-container></div><div flex="100" \nflex-gt-xs="50" class="p-5"><md-input-container class="md-block"><label>{{\'T1_DUNE.FIELDS.ASSET_TYPE\' | translate}}\n</label><md-select name="AssetTypeId" ng-model="vm.record.AssetTypeId" ng-required="true"><md-option \nng-repeat="assetType in vm.assetTypes" ng-value="assetType.Id">{{assetType.Name}}</md-option></md-select>\n<md-progress-linear ng-if="vm.isAssetTypesLoading" md-mode="query" class="md-accent"></md-progress-linear><div \nng-messages="vm.editForm.AssetTypeId.$error" role="alert" multiple="multiple"><div ng-message="required">\n{{\'VALIDATIONS.REQUIRED\' | translate}}</div></div></md-input-container></div><div layout="row" flex="100" \nflex-gt-xs="100" class="p-5"><div><span class="h3">{{ \'ASSORTMENTS.FIELDS.COVER_PICTURE\' | translate }}</span></div>\n</div><div flex="100" class="p-5" flow-drop ng-if="$flow.support"><label for="flow-upload-file-id"><div \nclass="file-uploader-container" ng-show="!vm.isNew && !vm.isImageChanged" \nflow-drag-enter="style={outline: \'2px dashed rgba(0,0,0,0.38)\', color: \'#939393\' }" \nflow-drag-leave="style={outline: \'2px dashed rgba(0,0,0,0.12)\', color: \'rgba(0,0,0,0.12)\'}" ng-style="style"><div \nng-if="!vm.isNew && !vm.isImageChanged" class="image-container"><img \nng-src="{{vm.duneImageSource[vm.record.DunesImageSet][\'contentType\']}},{{vm.duneImageSource[vm.record.DunesImageSet][\'imageDataUri\']}}">\n</div><div class="uploaded-file-name" ng-if="!vm.isNew && !vm.isImageChanged"><label>{{vm.fileName}}</label></div>\n</div></label><label for="flow-upload-file-id" class="" ng-show="vm.isNew || (!vm.isNew && vm.isImageChanged)"><div \nclass="file-uploader-container upload-success"><div class="upload-label" ng-if="vm.isNew && !$flow.files[0]"><div \nclass="upload-icon"><md-icon ng-style="style" md-font-icon="icon-upload" class="icon s1"></md-icon></div><div \nclass="upload-message" ng-style="style"><span>Choose a file or drag it here.</span></div></div><div \nclass="image-container"><img flow-img="$flow.files[0]"></div><div class="uploaded-file-name"><label>\n{{$flow.files[0].name}}</label></div></div></label><div class="upload-error" ng-show="!vm.isFileValid">\n{{ \'T1_DUNE.MESSAGES.INVALID_FILE_FORMAT\' | translate }}</div><md-progress-linear md-mode="determinate" \nclass="md-accent" ng-if="($flow.isUploading() && !vm.isImageLoading) || (!$flow.isUploading() && vm.isImageLoading)" \nvalue="{{$flow.progress()*100}}"></md-progress-linear></div><div ng-if="!$flow.support"><span>Browser not supported!\n</span></div></div></md-dialog-content><md-dialog-actions layout="row" layout-align="end center"><div><input \ntype="file" id="flow-upload-file-id" class="ng-hide" flow-btn accept=".jpg, .png, .jpeg, .tif, .tiff"></div><div \nlayout="row" layout-align="end center"><md-button ng-click="vm.closeDialog(vm.isDataDirty, true)" \nclass="send-button md-primary md-raised" aria-label="Cancel" translate="ACTIONS.DIALOG_CANCEL" \ntranslate-attr-aria-label="ACTIONS.DIALOG_CANCEL" ng-disabled="vm.isLoading">CANCEL</md-button><md-button \nng-click="vm.saveRecord()" class="send-button md-accent md-raised" aria-label="Save" translate="ACTIONS.SAVE" \ntranslate-attr-aria-label="ACTIONS.SAVE" \nng-disabled="vm.isLoading || vm.editForm.$invalid || !vm.isFileValid || $flow.isUploading()">SAVE</md-button></div>\n</md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/catalogs/sub-modules/assortments/list/dialogs/set-articles/set-articles.html','<md-dialog class="edit-dialog" aria-label="Set Articles"><form name="vm.editForm" class="md-inline-form"><md-toolbar \nclass="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" layout-align="space-between center"><span \nclass="title" translate="ASSORTMENTS.DIALOGS.TITLE.SET_ARTICLES">Set Collection\'s\' Articles</span><md-button \nclass="md-icon-button" ng-click="vm.closeDialog(false)" aria-label="Close dialog" tranlate \ntranslate-aria-label="ACTIONS.DIALOG_CLOSE"><md-icon md-font-icon="icon-close"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div layout="row" layout-wrap><div flex="100" flex-gt-xs="50" \nclass="article-number p-5"><label class="error-message" translate="ASSORTMENTS.DIALOGS.MESSAGE.INVALID_ARTICLES" \nng-if="vm.displayError">Please make sure provided articles exist and are active</label><md-input-container \nclass="md-block"><label translate="ASSORTMENTS.DIALOGS.FIELDS.ARTICLE_NUMBER">Article Number</label><textarea \nname="ArticleNumbers" ng-model="vm.inputValues" columns="0" rows="10" md-autofocus ng-pattern="" ms-scroll \nng-required="true" ng-focus="vm.displayError=false"></textarea><div ng-messages="vm.editForm.ArticleNumbers.$error" \nrole="alert" multiple="multiple"><div ng-message="pattern">{{\'VALIDATIONS.PATTERN\' | translate}}</div><div \nng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div></div></md-input-container></div></div>\n</md-dialog-content><md-dialog-actions layout="row" layout-align="end center"><div></div><div layout="row" \nlayout-align="end center"><md-button ng-click="vm.closeDialog(false)" class="send-button md-primary md-raised" \naria-label="Cancel" translate="ACTIONS.DIALOG_CANCEL" translate-attr-aria-label="ACTIONS.DIALOG_CANCEL" \nng-disabled="vm.isLoading">CANCEL</md-button><md-button ng-click="vm.saveRecord()" \nclass="send-button md-accent md-raised" aria-label="Save" translate="ACTIONS.SAVE" \ntranslate-attr-aria-label="ACTIONS.SAVE" ng-disabled="vm.isLoading || vm.editForm.$invalid">SAVE</md-button></div>\n</md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/catalogs/sub-modules/assortments/list/dialogs/set-customers/set-customers.html','<md-dialog class="edit-dialog" aria-label="Set Customers"><form name="vm.editForm" class="md-inline-form"><md-toolbar \nclass="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" layout-align="space-between center"><span \nclass="title" translate="ASSORTMENTS.DIALOGS.TITLE.SET_CUSTOMERS">Set Collection\'s\' Customers</span><md-button \nclass="md-icon-button" ng-click="vm.closeDialog(false)" aria-label="Close dialog" tranlate \ntranslate-aria-label="ACTIONS.DIALOG_CLOSE"><md-icon md-font-icon="icon-close"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div layout="row" layout-wrap><div flex="100" flex-gt-xs="50" \nclass="customer-code p-5"><label class="error-message" translate="ASSORTMENTS.DIALOGS.MESSAGE.INVALID_CUSTOMERS" \nng-if="vm.displayError">Please make sure provided customers exist and are active</label><md-input-container \nclass="md-block"><label translate="ASSORTMENTS.DIALOGS.FIELDS.CUSTOMERS_CODES">Customers Code</label><textarea \nname="CustomerCode" ng-model="vm.inputValues" columns="0" rows="10" md-autofocus ng-pattern="" ms-scroll \nng-required="true" ng-focus="vm.displayError=false"></textarea><div ng-messages="vm.editForm.CustomerCode.$error" \nrole="alert" multiple="multiple"><div ng-message="pattern">{{\'VALIDATIONS.PATTERN\' | translate}}</div><div \nng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div></div></md-input-container></div></div>\n</md-dialog-content><md-dialog-actions layout="row" layout-align="end center"><div></div><div layout="row" \nlayout-align="end center"><md-button ng-click="vm.closeDialog(false)" class="send-button md-primary md-raised" \naria-label="Cancel" translate="ACTIONS.DIALOG_CANCEL" translate-attr-aria-label="ACTIONS.DIALOG_CANCEL" \nng-disabled="vm.isLoading">CANCEL</md-button><md-button ng-click="vm.saveRecord()" \nclass="send-button md-accent md-raised" aria-label="Save" translate="ACTIONS.SAVE" \ntranslate-attr-aria-label="ACTIONS.SAVE" ng-disabled="vm.isLoading || vm.editForm.$invalid">SAVE</md-button></div>\n</md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/catalogs/sub-modules/catalog-models/details/catalog-models-resources/dialogs/assign-catalog-model-resources.html','<md-dialog class="edit-dialog" aria-label="Assign Resources"><form name="vm.editForm" class="md-inline-form">\n<md-toolbar class="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" layout-align="space-between center">\n<span class="title" translate="TITLES.RECORD_NEW">Assign Resources</span><md-button class="md-icon-button" \nng-click="vm.closeDialog()" aria-label="Close dialog" translate-aria-label="ACTIONS.DIALOG_CLOSE"><md-icon \nmd-font-icon="icon-close"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div layout="row" \nlayout-wrap><div flex="100" class="p-5 lookup-element"><md-input-container class="md-block"><label translate>\n{{ \'RESOURCES.FIELDS.RESOURCE_ID\' | translate }}</label><md-chips name="ResourceId" ng-model="vm.record.ResourceId" \nmd-autocomplete-snap md-transform-chip="vm.transformChip($chip)" md-require-match="true"><md-autocomplete \nmd-selected-item="vm.acSelectedItem" md-search-text="vm.acSearchText" \nmd-items="item in vm.acQuerySearch(vm.acSearchText, vm.record.ResourceId, vm.resourceLookup)" \nmd-item-text="item.value" md-min-length="0" md-no-cache="true" md-menu-class="autocomplete-custom"><md-item-template>\n<span class="autocomplete-item md-accent-fg" md-highlight-text="vm.acSearchText">{{item.value}}</span>\n</md-item-template><md-not-found>No Record matching "{{vm.acSearchText}}" were found.</md-not-found></md-autocomplete>\n<md-chip-template><span><strong>{{vm.getChipDisplayValue($chip, vm.resourceLookup)}}</strong></span></md-chip-template>\n</md-chips></md-input-container></div></div></md-dialog-content><md-dialog-actions layout="row" \nlayout-align="end center"><div layout="row" layout-align="end center"><md-button ng-click="vm.closeDialog()" \nclass="send-button md-primary md-raised" aria-label="Cancel" translate="ACTIONS.DIALOG_CANCEL" \ntranslate-attr-aria-label="ACTIONS.DIALOG_CANCEL" ng-disabled="vm.isLoading">CANCEL</md-button><md-button \nng-click="vm.saveRecord()" class="send-button md-accent md-raised" aria-label="Save" translate="ACTIONS.SAVE" \ntranslate-attr-aria-label="ACTIONS.SAVE" \nng-disabled="vm.isLoading || vm.editForm.$invalid || vm.record.ResourceId.length === 0">SAVE</md-button></div>\n</md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/catalogs/sub-modules/merch-boards/list/dialogs/select-user-for-filter/select-user-for-filter.html','<md-dialog class="edit-dialog" aria-label="Select User"><form name="vm.editForm" class="md-inline-form"><md-toolbar \nclass="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" layout-align="space-between center"><span \nclass="title" translate="{{MERCH_BOARDS.TITLES.SELECT_USER}}">Select User</span><md-button class="md-icon-button" \nng-click="vm.closeDialog(vm.isDataDirty)" aria-label="Close dialog" tranlate \ntranslate-aria-label="ACTIONS.DIALOG_CLOSE"><md-icon md-font-icon="icon-close"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div layout="row" layout-wrap><div flex="100" flex-gt-xs="50" \nclass="p-5 lookup-element"><md-autocomplete id="dialog_input_2" md-selected-item="vm.lookupModel.user" \nmd-search-text="vm.user" md-items="item in vm.querySearch(vm.user)" md-item-text="item.UserNameWithAccount" \nmd-min-length="0" md-floating-label="{{\'MERCH_BOARDS.FIELDS.USER\' | translate}}" ng-required="true" md-no-cache="true" \ntx-clear-autocomplete md-selected-item-change="vm.userChange(item)" md-menu-class="autocomplete-custom">\n<md-item-template><span class="autocomplete-item md-accent-fg" md-highlight-text="vm.user" md-highlight-flags="i">\n{{::item.UserNameWithAccount}}</span></md-item-template><div ng-messages="vm.editForm.user.$error" role="alert" \nng-show="vm.editForm.user.$touched"><div ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div></div>\n<md-not-found>No Record matching "{{vm.searchText.user}}" were found.</md-not-found></md-autocomplete></div></div>\n</md-dialog-content><md-dialog-actions layout="row" layout-align="end center"><div></div><div layout="row" \nlayout-align="end center"><md-button ng-click="vm.closeDialog(vm.isDataDirty)" \nclass="send-button md-primary md-raised" aria-label="Cancel" translate="ACTIONS.DIALOG_CANCEL" \ntranslate-attr-aria-label="ACTIONS.DIALOG_CANCEL" ng-disabled="vm.isLoading">CANCEL</md-button><md-button \nng-click="vm.saveRecord()" class="send-button md-accent md-raised" aria-label="Save" translate="ACTIONS.SELECT.SELECT" \ntranslate-attr-aria-label="ACTIONS.SAVE" ng-disabled="vm.isLoading || vm.editForm.$invalid">SELECT</md-button></div>\n</md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/catalogs/sub-modules/requests/details/tabs/history/history-viewer.html','<div class="audit-trail-viewer"><div layout="row" class="audit-trail-header" layout-wrap layout-align="end center"><div\n layout-wrap layout-align="start center"><span class="ml-16 text-boxed md-accent-bg highlight" hide show-gt-xs \nng-hide="vm.viewOptions.hideBranchesInfo">\n{{vm.articleAuditTrailHistory.length}} {{\'AUDIT_TRAIL_HISTORY.TITLES.AUDIT_TRAIL_HISTORY\' | translate}}</span></div>\n<md-button class="md-icon-button" aria-label="Refresh" translate-attr-aria-label="ACTIONS.REFRESH" \nng-click="vm.refreshAuditTrailHistory(true, false)"><md-icon md-font-icon="icon-refresh"></md-icon><md-tooltip><span \ntranslate="ACTIONS.REFRESH">Refresh</span></md-tooltip></md-button></div><div layout="row" \nlayout-align="center center" ng-show="vm.isAuditTrailHistoryLoading" class="loader-container"><md-progress-circular \nmd-mode="indeterminate" class="md-accent"></md-progress-circular></div><md-content class="audit-trail-content" \nms-scroll><section id="timeline" class="timeline-outer" ng-if="!vm.isAuditTrailHistoryLoading"><div class="container">\n<div><ul class="timeline"><li class="event" ng-if="vm.requestAuditTrailHistory.length === 0"><div class="text-italic" \ntranslate="MESSAGES.LIST.NO_ITEMS">No items available...</div></li><li class="event" \nng-repeat="record in vm.requestAuditTrailHistory | limitTo: vm.requestAuditTrailHistoryLimit" \ndata-date="{{ record.ChangeDate | date:\'MMM d, y h:mm a\' }}"><h3>{{ record.ChangeMaker }}</h3><p><ul><li \nng-repeat="item in record.Changes" style="padding:5px;margin:5px"><span style="font-weight: bold">{{ item.FieldName }}:\n</span> <span ng-if="item.Old || item.New" \nstyle="margin:5px;padding:5px;background-color:lightgrey;text-decoration:line-through">{{ item.Old }}</span> <span \nng-if="item.New || item.Old" style="margin:5px;padding:5px;background-color:lightgreen">{{ item.New }}</span><br><ul>\n<li ng-if="item.NestedValues" ng-repeat="nestedItem in item.NestedValues" style="padding:5px;margin:5px"><span \nstyle="font-weight: bold">{{ nestedItem.FieldName }}:</span> <span \nstyle="margin:5px;padding:5px;background-color:lightgrey;text-decoration:line-through">{{ nestedItem.Old }}</span> \n<span style="margin:5px;padding:5px;background-color:lightgreen">{{ nestedItem.New }}</span><br></li></ul></li></ul>\n</p></li><li ng-if="vm.requestAuditTrailHistory.length > vm.requestAuditTrailHistoryLimit"><md-button \nclass="md-accent md-raised" ng-click="vm.loadMoreAuditHistory()" aria-label="Load More"><span \ntranslate="{{AUDIT_TRAIL_HISTORY.ACTIONS.LOAD_MORE}}">{{ \'AUDIT_TRAIL_HISTORY.ACTIONS.LOAD_MORE\' | translate}}</span>\n</md-button></li></ul></div></div></section></md-content><br></div>');
$templateCache.put('app/main/accounts/sellers/details/tabs/capacities/dialogs/create-capacity/create-capacity.html','<md-dialog class="edit-dialog" aria-label="Create Capacity"><form name="vm.editForm" class="md-inline-form"><md-toolbar\n class="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" layout-align="space-between center"><span \nclass="title" translate="{{ vm.isNew ? \'SELLERS.CAPACITIES.ACTIONS.CREATE\' : \'SELLERS.CAPACITIES.ACTIONS.EDIT\' }}">\n{{ vm.isNew ? \'Create Capacity\' : \'Update Capacity\' }}</span><md-button class="md-icon-button" \nng-click="vm.closeDialog(vm.isDataDirty)" aria-label="Close dialog" translate-aria-label="ACTIONS.DIALOG_CLOSE">\n<md-icon md-font-icon="icon-close"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div \nlayout="row" layout-wrap><div flex="100" flex-gt-xs="100" class="p-5"><md-input-container class="md-block"><label \ntranslate>SELLERS.CAPACITIES.FIELDS.NAME</label><input id="dialog_input_first" name="Name" ng-model="vm.record.Name" \ntype="text" ng-required="true" ng-maxlength="500" tx-unique-value="vm.existingRecordsForUniqueValue:Name:true"><div \nng-messages="vm.editForm.Name.$error" role="alert" multiple="multiple"><div ng-message="required">\n{{\'VALIDATIONS.REQUIRED\' | translate}}</div><div ng-message="maxlength">{{\'VALIDATIONS.MAXLEN\' | translate}}</div><div \nng-message="tx-unique-value">{{\'SELLERS.CAPACITIES.MESSAGES.NAME_NOT_UNIQUE\' | translate}}</div></div>\n</md-input-container></div><div flex="100" flex-gt-xs="100" class="p-5 lookup-element"><fieldset><legend \nclass="header-non-editable-attributes" translate>SELLERS.CAPACITIES.FIELDS.CRITERIA</legend><div \nng-repeat="record in vm.criterias track by $index" ng-init="customIndex = $index" flex="100" layout="row" layout-wrap>\n<div flex="100" flex-gt-xs="50" class="p-5"><md-autocomplete id="dialog_input_{{customIndex}}" \nmd-input-name="Attributeid" md-selected-item="vm.lookupModel[customIndex].Attributeid" \nmd-items="item in vm.lookupAttributeSearch(vm.searchText[customIndex].Attributeid)" \nmd-search-text="vm.searchText[customIndex].Attributeid" md-item-text="vm.getAttributeLookupDisplayValue(item)" \nmd-min-length="0" md-floating-label="{{\'SELLERS.CAPACITIES.FIELDS.ATTRIBUTE\' | translate}}" md-no-cache="true" \ntx-clear-autocomplete ng-click="vm.selectText($event)" \nmd-selected-item-change="vm.lookupAttributeChange(vm.lookupModel[customIndex].Attributeid, customIndex)" \nmd-menu-class="autocomplete-custom"><md-item-template><span class="autocomplete-item md-accent-fg" \nmd-highlight-text="vm.searchText[customIndex].Attributeid" md-highlight-flags="i">{{item.AttributeDisplayName}}</span>\n</md-item-template><md-not-found>No Record matching "{{vm.searchText[customIndex].Attributeid}}" were found.\n</md-not-found></md-autocomplete></div><div flex="100" flex-gt-xs="50" class="p-5" \nng-if="vm.criterias[customIndex].Attributeid != null"><md-input-container class="md-block"><label translate>\nSELLERS.CAPACITIES.FIELDS.VALUE</label><md-chips id="dialog_input_val_{{customIndex}}" name="value" \nng-model="vm.criterias[customIndex].value" md-enable-chip-edit="true" placeholder="{{\'ACTIONS.ADD_TAGS\' | translate}}" \nsecondary-placeholder="{{\'ACTIONS.ADD_TAGS\' | translate}}"></md-chips></md-input-container></div></div></fieldset>\n</div></div></md-dialog-content><md-dialog-actions layout="row" layout-align="end center"><div></div><div layout="row" \nlayout-align="end center"><md-button ng-click="vm.closeDialog(vm.isDataDirty)" \nclass="send-button md-primary md-raised" aria-label="Cancel" translate="ACTIONS.DIALOG_CANCEL" \ntranslate-attr-aria-label="ACTIONS.DIALOG_CANCEL" ng-disabled="vm.isLoading">CANCEL</md-button><md-button \nng-click="vm.saveRecord()" class="send-button md-accent md-raised" aria-label="Save" translate="ACTIONS.SAVE" \ntranslate-attr-aria-label="ACTIONS.SAVE" ng-disabled="vm.isLoading || vm.editForm.$invalid">SAVE</md-button></div>\n</md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/accounts/sellers/details/tabs/seller-datasets/dialogs/create-seller-datasets/create-seller-datasets.html','<md-dialog class="edit-dialog" aria-label="New Lookup"><form name="vm.editForm" class="md-inline-form"><md-toolbar \nclass="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" layout-align="space-between center"><span \nclass="title" \ntranslate="{{vm.isNew ? \'SELLER_DATASETS.TITLES.NEW_DATASET\' : \'SELLER_DATASETS.TITLES.UPDATE_DATASET\'}}">New Dataset\n</span><md-button class="md-icon-button" ng-click="vm.closeDialog(vm.isDataDirty)" aria-label="Close dialog" tranlate \ntranslate-aria-label="ACTIONS.DIALOG_CLOSE"><md-icon md-font-icon="icon-close"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div layout="row" layout-wrap><div flex="100" flex-gt-xs="50" class="p-5">\n<md-input-container class="md-block"><label>{{\'SELLER_DATASETS.FIELDS.NAME\' | translate}}</label><input \nid="dialog_input_1" name="Name" ng-model="vm.record.Name" type="text" ng-required="true" md-maxlength="500" \ntx-unique-value="vm.existingRecordsForUniqueValue:Name:true"><div ng-messages="vm.editForm.Name.$error" role="alert" \nmultiple="multiple"><div ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div><div \nng-message="md-maxlength">{{\'VALIDATIONS.MAXLEN\' | translate}}</div><div ng-message="tx-unique-value">\n{{\'VALIDATIONS.NOT_UNIQUE\' | translate}}</div></div></md-input-container></div><div flex="100" flex-gt-xs="50" \nclass="p-5"><md-input-container class="md-block"><label>{{\'SELLER_DATASETS.FIELDS.CODE\' | translate}}</label><input \nid="dialog_input_2" name="Code" ng-model="vm.record.Code" type="text" ng-required="true" md-maxlength="100" \ntx-unique-value="vm.existingRecordsForUniqueValue:Code:true"><div ng-messages="vm.editForm.Code.$error" role="alert" \nmultiple="multiple"><div ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div><div \nng-message="md-maxlength">{{\'VALIDATIONS.MAXLEN\' | translate}}</div><div ng-message="tx-unique-value">\n{{\'VALIDATIONS.NOT_UNIQUE\' | translate}}</div></div></md-input-container></div><div flex="100" flex-gt-xs="100" \nclass="p-5"><md-input-container class="md-block"><label>\n{{\'SELLER_DATASETS.FIELDS.DISPLAY_VALUE_EXPRESSION\' | translate}}</label><input id="dialog_input_3" \nname="DisplayValueExpression" ng-model="vm.record.DisplayValueExpression" type="textArea" ng-required="true" \nmd-maxlength="1000"><div ng-messages="vm.editForm.DisplayValueExpression.$error" role="alert" multiple="multiple"><div \nng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div><div ng-message="md-maxlength">\n{{\'VALIDATIONS.MAXLEN\' | translate}}</div></div></md-input-container></div><div flex="100" class="p-5 lookup-element">\n<md-input-container class="md-block"><label>{{\'SELLER_DATASETS.FIELDS.ATTRIBUTES\' | translate}} <span \nmd-colors="{color: \'red\'}">*</span></label><md-chips id="dialog_input_{{$first ? \'first\' : $index}}" \nname="AttributesIds" ng-model="vm.record.AttributesIds" md-autocomplete-snap \nmd-transform-chip="vm.transformChip($chip)" md-require-match="true" ng-required="true"><md-autocomplete \nmd-selected-item="vm.acSelectedItem.AttributesIds" md-search-text="vm.acSearchText.AttributesIds" \nmd-items="item in vm.acQuerySearch(vm.acSearchText.AttributesIds, vm.record.AttributesIds, \'AttributesIds\')" \nmd-item-text="item.value" md-min-length="0" md-no-cache="true" md-menu-class="autocomplete-custom"><md-item-template>\n<span class="autocomplete-item md-accent-fg" md-highlight-text="vm.acSearchText.AttributesIds">{{item.value}}</span>\n</md-item-template><md-not-found>No Record matching "{{vm.acSearchText.AttributesIds}}" were found.</md-not-found>\n</md-autocomplete><md-chip-template><span><strong>{{vm.getChipDisplayValue($chip, \'AttributesIds\')}}</strong></span>\n</md-chip-template></md-chips></md-input-container></div></div></md-dialog-content><md-dialog-actions layout="row" \nlayout-align="end center"><div></div><div layout="row" layout-align="end center"><md-button \nng-click="vm.closeDialog(vm.isDataDirty)" class="send-button md-primary md-raised" aria-label="Cancel" \ntranslate="ACTIONS.DIALOG_CANCEL" translate-attr-aria-label="ACTIONS.DIALOG_CANCEL" ng-disabled="vm.isLoading">CANCEL\n</md-button><md-button ng-click="vm.saveRecord()" class="send-button md-accent md-raised" aria-label="Save" \ntranslate="ACTIONS.SAVE" translate-attr-aria-label="ACTIONS.SAVE" ng-disabled="vm.isLoading || vm.editForm.$invalid">\nSAVE</md-button></div></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/accounts/sellers/details/tabs/seller-lookup-table/dialogs/create-seller-lookup/create-seller-lookup.html','<md-dialog class="edit-dialog" aria-label="New Lookup"><form name="vm.editForm" class="md-inline-form"><md-toolbar \nclass="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" layout-align="space-between center"><span \nclass="title" translate="SELLER_LOOKUP_TABLE.TITLES.NEW_LOOKUP">New Lookup</span><md-button class="md-icon-button" \nng-click="vm.closeDialog(vm.isDataDirty)" aria-label="Close dialog" tranlate \ntranslate-aria-label="ACTIONS.DIALOG_CLOSE"><md-icon md-font-icon="icon-close"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div layout="row" layout-wrap><div flex="100" flex-gt-xs="100" class="p-5">\n<md-input-container class="md-block"><label>{{\'SELLER_LOOKUP_TABLE.FIELDS.NAME\' | translate}}</label><input \nid="dialog_input_1" name="Name" ng-model="vm.record.Name" type="text" ng-required="true" md-maxlength="500" \ntx-unique-value="vm.existingRecordsForUniqueValue:Name:true"><div ng-messages="vm.editForm.Name.$error" role="alert" \nmultiple="multiple"><div ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div><div \nng-message="md-maxlength">{{\'VALIDATIONS.MAXLEN\' | translate}}</div><div ng-message="tx-unique-value">\n{{\'VALIDATIONS.NOT_UNIQUE\' | translate}}</div></div></md-input-container></div><div flex="100" flex-gt-xs="50" \nclass="p-5 lookup-element"><md-autocomplete id="dialog_input_2" md-input-name="AttributeGroupId" \nmd-selected-item="vm.lookupModel.AttributeGroupId" \nmd-items="item in vm.lookupSearch(vm.searchText.AttributeGroupId, \'AttributeGroupId\')" \nmd-search-text="vm.searchText.AttributeGroupId" \nmd-item-text="vm.getLookupDisplayValue(item, \'attributes.attributeGroups\')" md-min-length="0" \nmd-floating-label="{{\'SELLER_LOOKUP_TABLE.FIELDS.ATTRIBUTE_GROUP_NAME\' | translate}}" ng-required="true" \nmd-no-cache="true" tx-clear-autocomplete ng-click="vm.selectText($event)" \nmd-selected-item-change="vm.onLookupChange(vm.lookupModel.AttributeGroupId, \'AttributeGroupId\')" \nmd-menu-class="autocomplete-custom"><md-item-template><span class="autocomplete-item md-accent-fg" \nmd-highlight-text="vm.searchText.AttributeGroupId" md-highlight-flags="i">{{item.value}}</span></md-item-template>\n<md-not-found>No Record matching "{{vm.searchText.AttributeGroupId}}" were found.</md-not-found><div \nng-messages="vm.editForm.AttributeGroupId.$error" role="alert" ng-show="vm.editForm.AttributeGroupId.$touched" \nmultiple="multiple"><div ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div></div></md-autocomplete>\n</div><div flex="100" class="p-5 lookup-elements"><md-input-container class="md-block"><label>\n{{\'SELLER_LOOKUP_TABLE.FIELDS.SOURCE_ATTRIBUTES\' | translate}}*</label><md-chips id="dialog_input_2" \nname="SourceAttributesIds" ng-model="vm.record.SourceAttributesIds" md-autocomplete-snap \nmd-transform-chip="vm.transformChip($chip, \'AttributeId\')" md-require-match="true" ng-required="true"><md-autocomplete \nmd-selected-item="vm.acSelectedItem.SourceAttributesIds" md-search-text="vm.acSearchText.SourceAttributesIds" \nmd-items="item in vm.acQuerySearch(vm.acSearchText.SourceAttributesIds, vm.record.SourceAttributesIds, true)" \nmd-item-text="item.AttributeDisplayName" ng-disabled="vm.record.AttributeGroupId == null" md-min-length="0" \nmd-no-cache="true" md-menu-class="autocomplete-custom"><md-item-template><span class="autocomplete-item md-accent-fg" \nmd-highlight-text="vm.acSearchText.SourceAttributesIds">{{item.AttributeDisplayName}}</span></md-item-template>\n</md-autocomplete><md-chip-template><span><strong>{{vm.getChipDisplayValue($chip, \'SourceAttributesIds\')}}</strong>\n</span></md-chip-template></md-chips><div class="md-chips-messages" \nng-messages="vm.editForm.SourceAttributesIds.$error" \nng-show="vm.editForm.SourceAttributesIds.$dirty || vm.editForm.SourceAttributesIds.$submitted"><div \nng-message="required">{{ \'VALIDATIONS.REQUIRED\' | translate}}</div></div></md-input-container></div><div flex="100" \nclass="p-5 lookup-element"><md-input-container class="md-block"><label>\n{{\'SELLER_LOOKUP_TABLE.FIELDS.DESTINATION_ATTRIBUTES\' | translate}}*</label><md-chips id="dialog_input_3" \nname="DestinationAttributesIds" ng-model="vm.record.DestinationAttributesIds" md-autocomplete-snap \nmd-transform-chip="vm.transformChip($chip, \'AttributeId\')" md-require-match="true" ng-required="true"><md-autocomplete \nmd-selected-item="vm.acSelectedItem.DestinationAttributesIds" \nmd-search-text="vm.acSearchText.DestinationAttributesIds" \nmd-items="item in vm.acQuerySearch(vm.acSearchText.DestinationAttributesIds, vm.record.DestinationAttributesIds, false)" \nmd-item-text="item.AttributeDisplayName" ng-disabled="vm.record.AttributeGroupId == null" md-min-length="0" \nmd-no-cache="true" md-menu-class="autocomplete-custom"><md-item-template><span class="autocomplete-item md-accent-fg" \nmd-highlight-text="vm.acSearchText.DestinationAttributesIds">{{item.AttributeDisplayName}}</span></md-item-template>\n</md-autocomplete><md-chip-template><span><strong>{{vm.getChipDisplayValue($chip, \'DestinationAttributesIds\')}}\n</strong></span></md-chip-template></md-chips><div class="md-chips-messages" \nng-messages="vm.editForm.DestinationAttributesIds.$error" \nng-show="vm.editForm.DestinationAttributesIds.$dirty || vm.editForm.DestinationAttributesIds.$submitted"><div \nng-message="required">{{ \'VALIDATIONS.REQUIRED\' | translate}}</div></div></md-input-container></div></div>\n</md-dialog-content><md-dialog-actions layout="row" layout-align="end center"><div></div><div layout="row" \nlayout-align="end center"><md-button ng-click="vm.closeDialog(vm.isDataDirty)" \nclass="send-button md-primary md-raised" aria-label="Cancel" translate="ACTIONS.DIALOG_CANCEL" \ntranslate-attr-aria-label="ACTIONS.DIALOG_CANCEL" ng-disabled="vm.isLoading">CANCEL</md-button><md-button \nng-click="vm.saveRecord()" class="send-button md-accent md-raised" aria-label="Save" translate="ACTIONS.SAVE" \ntranslate-attr-aria-label="ACTIONS.SAVE" ng-disabled="vm.isLoading || vm.editForm.$invalid">SAVE</md-button></div>\n</md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/accounts/sellers/details/tabs/seller-resources/details/dialogs/assign-seller-resource-entities.html','<md-dialog class="edit-dialog" aria-label="Assign"><form name="vm.editForm" class="md-inline-form"><md-toolbar \nclass="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" layout-align="space-between center"><span \nclass="title" translate="TITLES.RECORD_NEW"></span><md-button class="md-icon-button" ng-click="vm.closeDialog()" \naria-label="Close dialog"><md-icon md-font-icon="icon-close"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll><div layout="row" layout-wrap><div flex="100" class="p-5 lookup-element">\n<md-input-container class="md-block"><label>{{vm.label}}</label><md-chips name="EntityIds" ng-model="vm.selectedIds" \nmd-autocomplete-snap md-transform-chip="vm.transformChip($chip)" md-require-match="true"><md-autocomplete \nmd-selected-item="vm.acSelectedItem" md-search-text="vm.acSearchText" \nmd-items="item in vm.querySearch(vm.acSearchText, vm.selectedIds, vm.entityLookup)" md-item-text="item.value" \nmd-min-length="0" md-no-cache="true" md-menu-class="autocomplete-custom"><md-item-template><span \nclass="autocomplete-item md-accent-fg" md-highlight-text="vm.acSearchText">{{item.value}}</span></md-item-template>\n<md-not-found>No Record matching "{{vm.acSearchText}}" were found.</md-not-found></md-autocomplete><md-chip-template>\n<span><strong>{{vm.getChipDisplayValue($chip, vm.entityLookup)}}</strong></span></md-chip-template></md-chips>\n<md-progress-linear md-mode="indeterminate" class="md-accent" ng-if="vm.isLookupLoading"></md-progress-linear>\n</md-input-container></div></div></md-dialog-content><md-dialog-actions layout="row" layout-align="end center">\n<md-button ng-click="vm.closeDialog()" class="send-button md-primary md-raised" translate="ACTIONS.DIALOG_CANCEL" \nng-disabled="vm.isLoading"></md-button><md-button ng-click="vm.saveRecord()" class="send-button md-accent md-raised" \ntranslate="ACTIONS.SAVE" ng-disabled="vm.isLoading || vm.selectedIds.length === 0"></md-button></md-dialog-actions>\n</form></md-dialog>');
$templateCache.put('app/main/catalogs/sub-modules/articles/details/tabs/prices/dialogs/create-article-price.html','<md-dialog class="edit-dialog" aria-label="New Price"><form name="vm.editForm" class="md-inline-form"><md-toolbar \nclass="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" layout-align="space-between center"><span \nclass="title" translate="TITLES.RECORD_NEW">New Record</span><md-button class="md-icon-button" \nng-click="vm.closeDialog(vm.isDataDirty)" aria-label="Close dialog" tranlate \ntranslate-aria-label="ACTIONS.DIALOG_CLOSE"><md-icon md-font-icon="icon-close"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div layout="row" layout-wrap><div flex="100" flex-gt-xs="50" \nclass="p-5 lookup-element"><md-autocomplete id="dialog_input_{{$first ? \'first\' : $index}}" \nmd-input-name="PriceGroupId" md-selected-item="vm.lookupModel.PriceGroupId" \nmd-items="item in vm.lookupSearch(vm.searchText.PriceGroupId, \'PriceGroupId\')" \nmd-search-text="vm.searchText.PriceGroupId" md-item-text="vm.getLookupDisplayValue(item, \'PriceGroupId\')" \nmd-min-length="0" md-floating-label="{{\'PRICES.FIELDS.PRICEGROUP_ID\' | translate}}" \nmd-selected-item-change="vm.lookupChange(vm.lookupModel.PriceGroupId, \'PriceGroupId\')" ng-required="true" \nmd-no-cache="true" tx-clear-autocomplete tx-force-select ng-click="vm.selectText($event)" \nmd-menu-class="autocomplete-custom"><md-item-template><span class="autocomplete-item md-accent-fg" \nmd-highlight-text="vm.searchText.PriceGroupId" md-highlight-flags="i">{{item.value}}</span></md-item-template>\n<md-not-found>No Record matching "{{vm.searchText.PriceGroupId}}" were found.</md-not-found><div \nng-messages="vm.editForm.PriceGroupId.$error" role="alert" ng-show="vm.editForm.PriceGroupId.$touched"><div \nng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div></div></md-autocomplete></div><div flex="100" \nflex-gt-xs="50" class="p-5"><md-input-container class="md-block"><div class="external-change-message" \nng-if="vm.priceGroupNonEditable"><span>{{ \'ARTICLES.MESSAGES.NON_EDITABLE_PRICE_GROUP\' | translate }} </span><span \nng-if="vm.isAllowChangeRequestEnabled && vm.updatePricesChangeManagementExternalURL !== \'\'">\n{{ \'ARTICLES.MESSAGES.NON_EDITABLE_PRICE_GROUP_EXTERNAL_URL\' | translate }} <a \nhref="{{vm.updatePricesChangeManagementExternalURL}}" target="_blank">here</a></span></div><label translate>\nPRICES.FIELDS.PRICE</label><input name="price" ng-model="vm.record.price" type="number" md-maxlength="-1" \nng-pattern="vm.isPriceMandatory\r\n                            ? \'^[+]?((\\\\d*[1-9]\\\\d*)([.]\\\\d{0,\' + vm.numberOfDecimalsForPrices + \'})?)$\'\r\n                            : \'^[+]?\\\\d+([.]\\\\d{0,\' + vm.numberOfDecimalsForPrices + \'})?$\'" \nng-required="vm.isPriceMandatory" ng-disabled="vm.priceGroupNonEditable"><div ng-messages="vm.editForm.price.$error" \nrole="alert" multiple="multiple"><div ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div><div \nng-message="pattern" \ntranslate="{{ vm.isPriceMandatory ? \'VALIDATIONS.PRICE_GREATER_THAN_ZERO\' : \'VALIDATIONS.PRICE\' }}" \ntranslate-values="{numberOfDecimalsForPrices: vm.numberOfDecimalsForPrices}"></div><div ng-message="md-maxlength">\n{{\'VALIDATIONS.MAXLEN\' | translate}}</div></div></md-input-container></div></div></md-dialog-content><md-dialog-actions\n layout="row" layout-align="end center"><div></div><div layout="row" layout-align="end center"><md-button \nng-click="vm.closeDialog(vm.isDataDirty)" class="send-button md-primary md-raised" aria-label="Cancel" \ntranslate="ACTIONS.DIALOG_CANCEL" translate-attr-aria-label="ACTIONS.DIALOG_CANCEL" ng-disabled="vm.isLoading">CANCEL\n</md-button><md-button ng-click="vm.saveRecord()" class="send-button md-accent md-raised" aria-label="Save" \ntranslate="ACTIONS.SAVE" translate-attr-aria-label="ACTIONS.SAVE" \nng-disabled="vm.isLoading || vm.editForm.$invalid || vm.record.price === null">SAVE</md-button><md-button \nng-click="vm.saveRecord(true)" class="send-button md-accent md-raised" aria-label="Save" \ntranslate="ACTIONS.SAVE_AND_NEW" translate-attr-aria-label="ACTIONS.SAVE_AND_NEW" \nng-disabled="vm.isLoading || vm.editForm.$invalid || vm.record.price === null">SAVE</md-button></div>\n</md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/catalogs/sub-modules/articles/details/tabs/resources/dialogs/assign-resources.html','<md-dialog class="edit-dialog" aria-label="New Price"><form name="editForm" class="md-inline-form"><md-toolbar \nclass="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" layout-align="space-between center"><span \nclass="title" translate="TITLES.RECORD_NEW">New Record</span><md-button class="md-icon-button" \nng-click="vm.closeDialog(false)" aria-label="Close dialog" tranlate translate-aria-label="ACTIONS.DIALOG_CLOSE">\n<md-icon md-font-icon="icon-close"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div \nlayout="row" layout-wrap><div flex="100" class="p-5 lookup-element"><md-input-container class="md-block"><label \ntranslate>RESOURCES.FIELDS.RESOURCE_ID</label><md-chips name="ResourceId" ng-model="vm.record.ResourceId" \nmd-autocomplete-snap md-transform-chip="vm.transformChip($chip)" md-require-match="true"><md-autocomplete \nmd-selected-item="vm.acSelectedItem.ResourceId" md-search-text="vm.acSearchText.ResourceId" \nmd-items="item in vm.acQuerySearch(vm.acSearchText.ResourceId, vm.record.ResourceId, vm.resourceLookup)" \nmd-item-text="item.value" md-min-length="0" md-no-cache="true" md-menu-class="autocomplete-custom"><md-item-template>\n<span class="autocomplete-item md-accent-fg" md-highlight-text="vm.acSearchText.ResourceId">{{item.value}}</span>\n</md-item-template><md-not-found>No Record matching "{{vm.acSearchText.ResourceId}}" were found.</md-not-found>\n</md-autocomplete><md-chip-template><span><strong>{{vm.getChipDisplayValue($chip, vm.resourceLookup)}}</strong></span>\n</md-chip-template></md-chips></md-input-container></div></div></md-dialog-content><md-dialog-actions layout="row" \nlayout-align="end center"><div></div><div layout="row" layout-align="end center"><md-button \nng-click="vm.closeDialog(false)" class="send-button md-primary md-raised" aria-label="Cancel" \ntranslate="ACTIONS.DIALOG_CANCEL" translate-attr-aria-label="ACTIONS.DIALOG_CANCEL" ng-disabled="vm.isLoading">CANCEL\n</md-button><md-button ng-click="vm.saveRecord()" class="send-button md-accent md-raised" aria-label="Save" \ntranslate="ACTIONS.SAVE" translate-attr-aria-label="ACTIONS.SAVE" \nng-disabled="vm.isLoading || editForm.$invalid || vm.record.ResourceId.length <= 0">SAVE</md-button></div>\n</md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/catalogs/sub-modules/articles/details/tabs/segmentation/dialogs/assign-segmentation-to-article.html','<md-dialog class="edit-dialog" aria-label="Link Segmentation"><form name="vm.editForm" class="md-inline-form">\n<md-toolbar class="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" layout-align="space-between center">\n<span class="title" translate="TITLES.RECORD_NEW">New Record</span><md-button class="md-icon-button" \nng-click="vm.closeDialog(vm.isDataDirty)" aria-label="Close dialog" tranlate \ntranslate-aria-label="ACTIONS.DIALOG_CLOSE"><md-icon md-font-icon="icon-close"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div layout="row" layout-wrap><div flex="100" flex-gt-xs="50" \nclass="p-5 lookup-element"><md-autocomplete id="dialog_input_{{$first ? \'first\' : $index}}" \nmd-input-name="SegmentationId" md-selected-item="vm.lookupModel.SegmentationId" \nmd-items="item in vm.lookupSearch(vm.searchText.SegmentationId, \'SegmentationId\')" \nmd-search-text="vm.searchText.SegmentationId" md-item-text="vm.getLookupDisplayValue(item, \'SegmentationId\')" \nmd-min-length="0" md-floating-label="{{\'SEGMENTATIONS.FIELDS.ID\' | translate}}" \nmd-selected-item-change="vm.lookupChange(vm.lookupModel.SegmentationId, \'SegmentationId\')" ng-required="true" \nmd-no-cache="true" tx-clear-autocomplete tx-force-select ng-click="vm.selectText($event)" \nmd-menu-class="autocomplete-custom"><md-item-template><span class="autocomplete-item md-accent-fg" \nmd-highlight-text="vm.searchText.SegmentationId" md-highlight-flags="i">{{item.value}}</span></md-item-template>\n<md-not-found>No Record matching "{{vm.searchText.SegmentationId}}" were found.</md-not-found><div \nng-messages="vm.editForm.SegmentationId.$error" role="alert" ng-show="vm.editForm.SegmentationId.$touched"><div \nng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div></div></md-autocomplete></div><div lex="100" \nflex-gt-xs="50" class="p-5"><md-input-container \nng-if="vm.isSegmentationPlanningEnable && (vm.record.SegmentationId || vm.record.SegmentationId === 0)" \nclass="md-block"><label translate>SEGMENTATION.FIELDS.PLANNING_VALUE</label><md-select \nng-model="vm.record.PlanningValue" placeholder="{{\'SEGMENTATION.FIELDS.PLANNING_VALUE\' | translate}}" required>\n<md-option ng-repeat="planningValue in vm.planningValue" ng-value="planningValue">{{ planningValue}}</md-option>\n</md-select></md-input-container></div></div></md-dialog-content><md-dialog-actions layout="row" \nlayout-align="end center"><div></div><div layout="row" layout-align="end center"><md-button \nng-click="vm.closeDialog(vm.isDataDirty)" class="send-button md-primary md-raised" aria-label="Cancel" \ntranslate="ACTIONS.DIALOG_CANCEL" translate-attr-aria-label="ACTIONS.DIALOG_CANCEL" ng-disabled="vm.isLoading">CANCEL\n</md-button><md-button ng-click="vm.saveRecord()" class="send-button md-accent md-raised" aria-label="Save" \ntranslate="ACTIONS.SAVE" translate-attr-aria-label="ACTIONS.SAVE" ng-disabled="vm.isLoading || vm.editForm.$invalid">\nSAVE</md-button><md-button ng-click="vm.saveRecord(true)" class="send-button md-accent md-raised" aria-label="Save" \ntranslate="ACTIONS.SAVE_AND_NEW" translate-attr-aria-label="ACTIONS.SAVE_AND_NEW" \nng-disabled="vm.isLoading || vm.editForm.$invalid">SAVE</md-button></div></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/catalogs/sub-modules/assortments/details/tabs/articles/dialogs/create-assortment-article.html','<md-dialog class="edit-dialog" aria-label="Link Article"><form name="vm.editForm" class="md-inline-form"><md-toolbar \nclass="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" layout-align="space-between center"><span \nclass="title" translate="ASSORTMENTS.DIALOGS.TITLE.ASSIGN_ARTICLES">Assign Articles</span><md-button \nclass="md-icon-button" ng-click="vm.closeDialog(false)" aria-label="Close dialog" tranlate \ntranslate-aria-label="ACTIONS.DIALOG_CLOSE"><md-icon md-font-icon="icon-close"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div layout="row" layout-wrap><div flex="100" flex-gt-xs="50" class="p-5">\n<md-input-container class="md-block"><label translate="ASSORTMENTS.DIALOGS.FIELDS.ARTICLE_NUMBER">Article NUmbers\n</label><textarea name="ArticleNumber" ng-model="vm.inputValues" ng-model-options="{ debounce: 1000 }" ng-pattern="" \ntx-exist-value="vm.availableArticles|ArticleNumber|vm.catalogArticlessPromise|{\'Status\': 1}" rows="12" \nng-required="true"></textarea><div ng-messages="vm.editForm.ArticleNumber.$error" role="alert" multiple="multiple"><div\n ng-message="pattern">{{\'VALIDATIONS.PATTERN\' | translate}}</div><div ng-message="required">\n{{\'VALIDATIONS.REQUIRED\' | translate}}</div><div ng-message="tx-exist-value" \ntranslate="ALLOCATION_GROUPS.MESSAGES.TX_EXIST_DATA_ERROR_ARTICLES">Articles are not available</div></div>\n</md-input-container><div layout="row" ng-show="vm.editForm.ArticleNumber.$pending[\'tx-exist-value\']">\n<md-progress-circular class="md-hue-2" md-diameter="20px"></md-progress-circular><span \ntranslate="ALLOCATION_GROUPS.MESSAGES.TX_EXIST_LOADING_DATA" style="padding-left: 10px">\nLooking into database to validate provided data</span></div></div><div flex="100" flex-gt-xs="50" class="p-5" \nng-if="vm.containInvalidRecords"><md-input-container class="md-block"><label \ntranslate="ASSORTMENTS.FIELDS.INVALID_ARTICLE_NUMBER" class="show-full-label">\nInvalid Article Number(s) (won\'t be assigned)</label><textarea ng-model="vm.invalidDataString" rows="12"></textarea>\n</md-input-container></div></div></md-dialog-content><md-dialog-actions layout="row" layout-align="end center"><div>\n</div><div layout="row" layout-align="end center"><md-button ng-click="vm.closeDialog(false)" \nclass="send-button md-primary md-raised" aria-label="Cancel" translate="ACTIONS.DIALOG_CANCEL" \ntranslate-attr-aria-label="ACTIONS.DIALOG_CANCEL" ng-disabled="vm.isLoading">CANCEL</md-button><md-button \nng-click="vm.saveRecord()" class="send-button md-accent md-raised" aria-label="Save" translate="ACTIONS.SAVE" \ntranslate-attr-aria-label="ACTIONS.SAVE" ng-disabled="vm.isLoading || vm.editForm.$invalid">SAVE</md-button></div>\n</md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/catalogs/sub-modules/assortments/details/tabs/customers/dialogs/create-assortment-customer.html','<md-dialog class="edit-dialog" aria-label="Link Customer"><form name="vm.editForm" class="md-inline-form"><md-toolbar \nclass="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" layout-align="space-between center"><span \nclass="title" translate="ASSORTMENTS.DIALOGS.TITLE.ASSIGN_CUSTOMERS">Assign Customers</span><md-button \nclass="md-icon-button" ng-click="vm.closeDialog(false)" aria-label="Close dialog" tranlate \ntranslate-aria-label="ACTIONS.DIALOG_CLOSE"><md-icon md-font-icon="icon-close"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div layout="row" layout-wrap><div flex="100" flex-gt-xs="50" class="p-5">\n<md-input-container class="md-block"><label translate="ASSORTMENTS.DIALOGS.FIELDS.CUSTOMERS_CODES">Customers Code\n</label><textarea name="CustomersCode" ng-model="vm.inputValues" ng-model-options="{ debounce: 1000 }" ng-pattern="" \ntx-exist-value="vm.availableCustomers|CustomerNumber|vm.catalogCustomersPromise|{\'Status\': 1}" rows="12" \nng-required="true"></textarea><div ng-messages="vm.editForm.CustomersCode.$error" role="alert" multiple="multiple"><div\n ng-message="pattern">{{\'VALIDATIONS.PATTERN\' | translate}}</div><div ng-message="required">\n{{\'VALIDATIONS.REQUIRED\' | translate}}</div><div ng-message="tx-exist-value" \ntranslate="ALLOCATION_GROUPS.MESSAGES.TX_EXIST_DATA_ERROR_CUSTOMERS">Customers are not available</div></div>\n</md-input-container><div layout="row" ng-show="vm.editForm.CustomersCode.$pending[\'tx-exist-value\']">\n<md-progress-circular class="md-hue-2" md-diameter="20px"></md-progress-circular><span \ntranslate="ALLOCATION_GROUPS.MESSAGES.TX_EXIST_LOADING_DATA" style="padding-left: 10px">\nLooking into database to validate provided data</span></div></div><div flex="100" flex-gt-xs="50" class="p-5" \nng-if="vm.containInvalidRecords"><md-input-container class="md-block"><label \ntranslate="ASSORTMENTS.FIELDS.INVALID_CUSTOMER_NUMBER" class="show-full-label">\nInvalid Customer Number(s) (won\'t be assigned)</label><textarea ng-model="vm.invalidDataString" rows="12"></textarea>\n</md-input-container></div></div></md-dialog-content><md-dialog-actions layout="row" layout-align="end center"><div>\n</div><div layout="row" layout-align="end center"><md-button ng-click="vm.closeDialog(false)" \nclass="send-button md-primary md-raised" aria-label="Cancel" translate="ACTIONS.DIALOG_CANCEL" \ntranslate-attr-aria-label="ACTIONS.DIALOG_CANCEL" ng-disabled="vm.isLoading">CANCEL</md-button><md-button \nng-click="vm.saveRecord()" class="send-button md-accent md-raised" aria-label="Save" translate="ACTIONS.SAVE" \ntranslate-attr-aria-label="ACTIONS.SAVE" ng-disabled="vm.isLoading || vm.editForm.$invalid">SAVE</md-button></div>\n</md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/catalogs/sub-modules/buyer-limits/details/tabs/limits-criteria/details/limits-criteria-details.html','<div id="limits-criteria-details" class="page-layout simple tabbed details-view" layout="column"><div class="content">\n<md-tabs md-dynamic-height md-selected="vm.tabIndex" md-no-ink><md-tab label="{{\'LIMITS_CRITERIA.NAV\' | translate}}" \ntx-access="{{::vm.model.views.privileges.details}}"><tx-data-details tx-height-offset="37" \ntx-is-active="vm.tabIndex === 0" tx-account="vm.attributeCriteria" tx-parent-id="vm.buyerLimitId" tx-title="vm.title" \ntx-model="vm.model" tx-item-actions="vm.model.views.mainDetails.itemActions" \ntx-item-action-event="vm.doAttributeCriteriaItemAction(action, account)" tx-is-loading="vm.isLoading" \ntx-refresh-action-event="vm.refreshRecord(false)"></tx-data-details></md-tab><md-tab \nlabel="{{\'LIMITS_CRITERIA.TABS.NOTIFY_USERS\' | translate}}" \ntx-access="{{::vm.notifyUsersModel.views.privileges.list}}"><div class="list-tab" layout="row" flex="100" layout-wrap>\n<ms-widget layout="row" flex="100"><ms-widget-front class="white-bg"><tx-data-table tx-is-active="vm.tabIndex === 1" \ntx-data="vm.notifyUsers" tx-model="vm.notifyUsersModel" tx-view="mainList" tx-filtered-data="vm.filteredNotifyUsers" \ntx-data-filter="global.search" tx-is-loading="vm.isLoading" tx-refresh-action-event="vm.refreshRecord(true)" \ntx-height-offset="16"></tx-data-table></ms-widget-front></ms-widget><md-button class="add-rec-button md-fab md-warn" \nng-click="vm.assignNotifyUsers($event)" aria-label="vm.notifyUsersModel.views.mainList.fabAction.label" translate \ntx-access="{{::vm.notifyUsersModel.views.mainList.fabAction.privilege}}"><md-icon \nmd-font-icon="{{vm.notifyUsersModel.views.mainList.fabAction.icon}}"></md-icon></md-button></div></md-tab></md-tabs>\n<md-button id="txfab" class="md-fab md-warn" ng-if="vm.tabIndex === 0" \nng-click="vm.editAttributeCriteria(vm.attributeCriteria, $event)" aria-label="vm.model.views.mainDetails.fab.label" \ntranslate tx-access="{{::vm.model.views.mainDetails.fab.privilege}}"><md-icon \nmd-font-icon="{{vm.model.views.mainDetails.fab.icon}}"></md-icon></md-button></div></div>');
$templateCache.put('app/main/catalogs/sub-modules/buyer-limits/details/tabs/limits-criteria/dialogs/create-limits-criteria.html','<md-dialog class="edit-dialog" aria-label="{{vm.isNew ? \'Link Catalog\' : \'Edit Linked Catalog\'}}"><form \nname="vm.editForm" class="md-inline-form"><md-toolbar class="md-accent md-hue-2"><div class="md-toolbar-tools" \nlayout="row" layout-align="space-between center"><span class="title" \ntranslate="{{vm.isNew ? \'LIMITS_CRITERIA.TITLES.CREATE_LIMITS_CRITERIA\' : \'LIMITS_CRITERIA.TITLES.UPDATE_LIMITS_CRITERIA\'}}">\nNew Record</span><md-button class="md-icon-button" ng-click="vm.closeDialog(vm.isDataDirty)" aria-label="Close dialog" \ntranlate translate-aria-label="ACTIONS.DIALOG_CLOSE"><md-icon md-font-icon="icon-close"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div layout="row" layout-wrap><div flex="100" flex-gt-xs="100" class="p-5">\n<md-input-container flex="50" class="md-block"><label translate>LIMITS_CRITERIA.FIELDS.NAME</label><input \nid="dialog_input_first" name="Name" ng-model="vm.record.Name" type="text" ng-required="true" md-autofocus \ntx-unique-value="vm.assignedRecords:Name: true"><div ng-messages="vm.editForm.Name.$error" role="alert" \nmultiple="multiple"><div ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div><div \nng-message="tx-unique-value">{{\'VALIDATIONS.NOT_UNIQUE\' | translate}}</div></div></md-input-container></div><div \nflex="100" flex-gt-xs="50" class="p-5"><md-input-container class="md-block"><label translate>\nLIMITS_CRITERIA.FIELDS.LIMIT</label><input id="dialog_input_6" name="Limit" ng-model="vm.record.Limit" type="number" \nng-required="true"><div ng-messages="vm.editForm.Limit.$error" role="alert" multiple="multiple"><div \nng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div></div></md-input-container></div><div flex="100" \nflex-gt-xs="50" class="p-5"><md-input-container class="md-block"><label translate>LIMITS_CRITERIA.FIELDS.TARGET</label>\n<input id="dialog_input_5" name="Target" ng-model="vm.record.Target" type="number" ng-required="true" \nmax="{{vm.record.Limit}}"><div ng-messages="vm.editForm.Target.$error" role="alert" multiple="multiple"><div \nng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div><div ng-message="max">\n{{\'LIMITS_CRITERIA.VALIDATIONS.MAX_TARGET\' | translate}}</div></div></md-input-container></div><div flex="100" \nflex-gt-xs="50" class="p-5 lookup-element"><md-autocomplete id="dialog_input_2" md-input-name="Attribute_1_Id" \nmd-selected-item="vm.acLookupModel.Attribute_1_Id" \nmd-items="item in vm.lookupSearch(vm.searchText.Attribute_1_Id, \'Attribute_1_Id\', vm.availableCatalogAttributes)" \nmd-search-text="vm.searchText.Attribute_1_Id" \nmd-item-text="vm.getlookupDisplayValue(item, vm.availableCatalogAttributes)" md-min-length="0" \nmd-floating-label="{{\'LIMITS_CRITERIA.FIELDS.ATTRIBUTE_1\' | translate}}" \nmd-selected-item-change="vm.lookupChange(vm.acLookupModel.Attribute_1_Id, \'Attribute_1_Id\')" md-no-cache="true" \ntx-clear-autocomplete ng-click="vm.selectText($event)" md-menu-class="autocomplete-custom"><md-item-template><span \nclass="autocomplete-item md-accent-fg" md-highlight-text="vm.searchText.Attribute_1_Id" md-highlight-flags="i">\n{{item.AttributeDisplayName}}</span></md-item-template><md-not-found>\nNo Record matching "{{vm.searchText.Attribute_1_Id}}" were found.</md-not-found></md-autocomplete></div><div \nflex="100" flex-gt-xs="50" class="p-5"><div class="p-5"><div \nng-if="vm.selectedAttibute.inputType === \'textArea\' || vm.selectedAttibute.inputType === \'calculated\'">\n<md-input-container class="md-block"><input id="dialog_input_{{$first ? \'first\' : $index}}" name="Attribute_1_Value" \nng-model="vm.record.Attribute_1_Value"></md-input-container></div><div \nng-if="vm.selectedAttibute.inputType === \'number\'"><md-input-container class="md-block"><input type="number" \nng-if="vm.isNew" id="dialog_input_{{$first ? \'first\' : $index}}" name="Attribute_1_Value" \nng-model="vm.record.Attribute_1_Value"><input type="text" ng-if="!vm.isNew" \nid="dialog_input_{{$first ? \'first\' : $index}}" name="Attribute_1_Value" ng-model="vm.record.Attribute_1_Value">\n</md-input-container></div><div ng-if="vm.selectedAttibute.inputType === \'date\'" layout="column" flex><md-datepicker \nid="dialog_input_{{$first ? \'first\' : $index}}" name="Attribute_1_Value" ng-model="vm.record.Attribute_1_Value" \nng-init="vm.record.Attribute_1_Value = vm.getDateObj(vm.record.Attribute_1_Value, vm.selectedAttibute)" \nmd-placeholder=""></md-datepicker></div><div ng-if="vm.selectedAttibute.inputType === \'date-without-time\'" \nlayout="column" flex><md-datepicker id="dialog_input_{{$first ? \'first\' : $index}}" name="Attribute_1_Value" \nng-model="vm.record.Attribute_1_Value" \nng-init="vm.record.Attribute_1_Value = vm.getDateObj(vm.record.Attribute_1_Value, vm.selectedAttibute)" \nmd-placeholder=""></md-datepicker></div><div ng-if="vm.selectedAttibute.inputType === \'date-option\'" layout="column" \nflex><md-datepicker id="dialog_input_{{$first ? \'first\' : $index}}" name="Attribute_1_Value" \nng-model="vm.record.Attribute_1_Value" \nng-init="vm.record.Attribute_1_Value = vm.getDateObj(vm.record.Attribute_1_Value, vm.selectedAttibute)" \nmd-placeholder=""></md-datepicker></div><div ng-if="vm.selectedAttibute.inputType === \'bool-str\'"><md-switch \nid="dialog_input_{{$first ? \'first\' : $index}}" ng-model="vm.record.Attribute_1_Value" \naria-label="{{vm.selectedAttibute.displayLabel | translate}}" ng-true-value="\'true\'" ng-false-value="\'false\'" \nclass="md-accent"></md-switch></div><div ng-if="vm.selectedAttibute.inputType === \'list\'"><md-input-container \nclass="md-block"><md-select id="dialog_input_{{$first ? \'first\' : $index}}" name="Attribute_1_Value" \nng-model="vm.record.Attribute_1_Value" aria-label="{{vm.selectedAttibute.displayLabel | translate}}"><md-option \nmd-option-empty ng-value="\'\'"><em>None</em></md-option><md-option ng-value="option" \nng-repeat="option in vm.selectedAttibute.values">{{ option }}</md-option></md-select></md-input-container></div><div \nng-if="vm.selectedAttibute.inputType === \'multi-value\'"><md-input-container class="md-block"><md-chips \nid="dialog_input_{{$first ? \'first\' : $index}}" name="Attribute_1_Value" ng-model="vm.record.Attribute_1_Value" \nmd-autocomplete-snap md-transform-chip="vm.transformChip($chip, true)" \naria-label="{{vm.selectedAttibute.displayLabel | translate}}"><md-autocomplete \nmd-selected-item="vm.acSelectedItem[vm.selectedAttibute.field]" \nmd-search-text="vm.acSearchText[vm.selectedAttibute.field]" \nmd-items="item in vm.multiValueQuerySearch(vm.acSearchText[vm.selectedAttibute.field], vm.record.Attribute_1_Value, vm.selectedAttibute)" \nmd-item-text="item" md-min-length="0" md-no-cache="true" md-menu-class="autocomplete-custom"><md-item-template><span \nclass="autocomplete-item md-accent-fg" md-highlight-text="vm.acSearchText[vm.selectedAttibute.field]">{{item}}</span>\n</md-item-template><md-not-found>No Record matching "{{vm.acSearchText[vm.selectedAttibute.field]}}" were found.\n</md-not-found></md-autocomplete><md-chip-template><span><strong>{{$chip}}</strong></span></md-chip-template>\n</md-chips></md-input-container></div><div ng-if="vm.selectedAttibute.inputType === \'decimal\'"><md-input-container \nclass="md-block"><input type="number" ng-if="vm.isNew" id="dialog_input_{{$first ? \'first\' : $index}}" \nname="Attribute_1_Value" ng-model="vm.record.Attribute_1_Value" pattern="{{vm.selectedAttibute.validation.pattern}}">\n<input type="text" ng-if="!vm.isNew" id="dialog_input_{{$first ? \'first\' : $index}}" name="Attribute_1_Value" \nng-model="vm.record.Attribute_1_Value"><div ng-if="vm.isNew" ng-messages="vm.editForm.Attribute_1_Value.$error" \nrole="alert" multiple="multiple"><div ng-message="pattern">\n{{vm.selectedAttibute.validation.messages.pattern | translate}}</div></div></md-input-container></div></div></div><div \nflex="100" flex-gt-xs="50" class="p-5 lookup-element"><md-autocomplete id="dialog_input_3" \nmd-input-name="Attribute_2_Id" md-selected-item="vm.acLookupModel.Attribute_2_Id" \nmd-items="item in vm.lookupSearch(vm.searchText.Attribute_2_Id, \'Attribute_2_Id\', vm.availableCatalogAttributes)" \nmd-search-text="vm.searchText.Attribute_2_Id" \nmd-item-text="vm.getlookupDisplayValue(item, vm.availableCatalogAttributes)" md-min-length="0" \nmd-floating-label="{{\'LIMITS_CRITERIA.FIELDS.ATTRIBUTE_2\' | translate}}" \nmd-selected-item-change="vm.lookupChangeAttribute2(vm.acLookupModel.Attribute_2_Id, \'Attribute_2_Id\')" \nmd-no-cache="true" tx-clear-autocomplete ng-click="vm.selectText($event)" md-menu-class="autocomplete-custom">\n<md-item-template><span class="autocomplete-item md-accent-fg" md-highlight-text="vm.searchText.Attribute_2_Id" \nmd-highlight-flags="i">{{item.AttributeDisplayName}}</span></md-item-template><md-not-found>\nNo Record matching "{{vm.searchText.Attribute_2_Id}}" were found.</md-not-found></md-autocomplete></div><div \nflex="100" flex-gt-xs="50" class="p-5"><div class="p-5"><div \nng-if="vm.selectedAttibute2.inputType === \'textArea\' || vm.selectedAttibute2.inputType === \'calculated\'">\n<md-input-container class="md-block"><input id="dialog_input_{{$first ? \'first\' : $index}}" name="Attribute_2_Value" \nng-model="vm.record.Attribute_2_Value"></md-input-container></div><div \nng-if="vm.selectedAttibute2.inputType === \'number\'"><md-input-container class="md-block"><input type="number" \nid="dialog_input_{{$first ? \'first\' : $index}}" name="Attribute_2_Value" ng-model="vm.record.Attribute_2_Value">\n</md-input-container></div><div ng-if="vm.selectedAttibute2.inputType === \'date\'" layout="column" flex><md-datepicker \nid="dialog_input_{{$first ? \'first\' : $index}}" name="Attribute_2_Value" ng-model="vm.record.Attribute_2_Value" \nng-init="vm.record.Attribute_2_Value = vm.getDateObj(vm.record.Attribute_2_Value, vm.selectedAttibute2)" \nmd-placeholder=""></md-datepicker></div><div ng-if="vm.selectedAttibute2.inputType === \'date-without-time\'" \nlayout="column" flex><md-datepicker id="dialog_input_{{$first ? \'first\' : $index}}" name="Attribute_2_Value" \nng-model="vm.record.Attribute_2_Value" \nng-init="vm.record.Attribute_2_Value = vm.getDateObj(vm.record.Attribute_2_Value, vm.selectedAttibute2)" \nmd-placeholder=""></md-datepicker></div><div ng-if="vm.selectedAttibute2.inputType === \'date-option\'" layout="column" \nflex><md-datepicker id="dialog_input_{{$first ? \'first\' : $index}}" name="Attribute_2_Value" \nng-model="vm.record.Attribute_2_Value" \nng-init="vm.record.Attribute_2_Value = vm.getDateObj(vm.record.Attribute_2_Value, vm.selectedAttibute2)" \nmd-placeholder=""></md-datepicker></div><div ng-if="vm.selectedAttibute2.inputType === \'bool-str\'"><md-switch \nid="dialog_input_{{$first ? \'first\' : $index}}" ng-model="vm.record.Attribute_2_Value" \naria-label="{{vm.selectedAttibute2.displayLabel | translate}}" ng-true-value="\'true\'" ng-false-value="\'false\'" \nclass="md-accent"></md-switch></div><div ng-if="vm.selectedAttibute2.inputType === \'list\'"><md-input-container \nclass="md-block"><md-select id="dialog_input_{{$first ? \'first\' : $index}}" name="Attribute_2_Value" \nng-model="vm.record.Attribute_2_Value" aria-label="{{vm.selectedAttibute2.displayLabel | translate}}"><md-option \nmd-option-empty ng-value="\'\'"><em>None</em></md-option><md-option ng-value="option" \nng-repeat="option in vm.selectedAttibute2.values">{{ option }}</md-option></md-select></md-input-container></div><div \nng-if="vm.selectedAttibute2.inputType === \'multi-value\'"><md-input-container class="md-block"><md-chips \nid="dialog_input_{{$first ? \'first\' : $index}}" name="Attribute_2_Value" ng-model="vm.record.Attribute_2_Value" \nmd-autocomplete-snap md-transform-chip="vm.transformChip($chip, true)" \naria-label="{{vm.selectedAttibute2.displayLabel | translate}}"><md-autocomplete \nmd-selected-item="vm.acSelectedItem[vm.selectedAttibute2.field]" \nmd-search-text="vm.acSearchText[vm.selectedAttibute2.field]" \nmd-items="item in vm.multiValueQuerySearch(vm.acSearchText[vm.selectedAttibute2.field], vm.record.Attribute_2_Value, vm.selectedAttibute2)" \nmd-item-text="item" md-min-length="0" md-no-cache="true" md-menu-class="autocomplete-custom"><md-item-template><span \nclass="autocomplete-item md-accent-fg" md-highlight-text="vm.acSearchText[vm.selectedAttibute2.field]">{{item}}</span>\n</md-item-template><md-not-found>No Record matching "{{vm.acSearchText[vm.selectedAttibute2.field]}}" were found.\n</md-not-found></md-autocomplete><md-chip-template><span><strong>{{$chip}}</strong></span></md-chip-template>\n</md-chips></md-input-container></div><div ng-if="vm.selectedAttibute2.inputType === \'decimal\'"><md-input-container \nclass="md-block"><input type="number" id="dialog_input_{{$first ? \'first\' : $index}}" name="Attribute_2_Value" \nng-model="vm.record.Attribute_2_Value" pattern="{{vm.selectedAttibute2.validation.pattern}}"><div \nng-messages="vm.editForm.Attribute_2_Value.$error" role="alert" multiple="multiple"><div ng-message="pattern">\n{{vm.selectedAttibute2.validation.messages.pattern | translate}}</div></div></md-input-container></div></div></div><div\n flex="100" flex-gt-xs="50" class="p-5 lookup-element"><md-autocomplete id="dialog_input_4" \nmd-input-name="Attribute_3_Id" md-selected-item="vm.acLookupModel.Attribute_3_Id" \nmd-items="item in vm.lookupSearch(vm.searchText.Attribute_3_Id, \'Attribute_3_Id\', vm.availableCatalogAttributes)" \nmd-search-text="vm.searchText.Attribute_3_Id" \nmd-item-text="vm.getlookupDisplayValue(item, vm.availableCatalogAttributes)" md-min-length="0" \nmd-floating-label="{{\'LIMITS_CRITERIA.FIELDS.ATTRIBUTE_3\' | translate}}" \nmd-selected-item-change="vm.lookupChangeAttribute3(vm.acLookupModel.Attribute_3_Id, \'Attribute_3_Id\')" \nmd-no-cache="true" tx-clear-autocomplete ng-click="vm.selectText($event)" md-menu-class="autocomplete-custom">\n<md-item-template><span class="autocomplete-item md-accent-fg" md-highlight-text="vm.searchText.Attribute_3_Id" \nmd-highlight-flags="i">{{item.AttributeDisplayName}}</span></md-item-template><md-not-found>\nNo Record matching "{{vm.searchText.Attribute_3_Id}}" were found.</md-not-found></md-autocomplete></div><div \nflex="100" flex-gt-xs="50" class="p-5"><div class="p-5"><div \nng-if="vm.selectedAttibute3.inputType === \'textArea\' || vm.selectedAttibute3.inputType === \'calculated\'">\n<md-input-container class="md-block"><input id="dialog_input_{{$first ? \'first\' : $index}}" name="Attribute_3_Value" \nng-model="vm.record.Attribute_3_Value"></md-input-container></div><div \nng-if="vm.selectedAttibute3.inputType === \'number\'"><md-input-container class="md-block"><input type="number" \nid="dialog_input_{{$first ? \'first\' : $index}}" name="Attribute_3_Value" ng-model="vm.record.Attribute_3_Value">\n</md-input-container></div><div ng-if="vm.selectedAttibute3.inputType === \'date\'" layout="column" flex><md-datepicker \nid="dialog_input_{{$first ? \'first\' : $index}}" name="Attribute_3_Value" ng-model="vm.record.Attribute_3_Value" \nng-init="vm.record.Attribute_3_Value = vm.getDateObj(vm.record.Attribute_3_Value, vm.selectedAttibute3)" \nmd-placeholder=""></md-datepicker></div><div ng-if="vm.selectedAttibute3.inputType === \'date-without-time\'" \nlayout="column" flex><md-datepicker id="dialog_input_{{$first ? \'first\' : $index}}" name="Attribute_3_Value" \nng-model="vm.record.Attribute_3_Value" \nng-init="vm.record.Attribute_3_Value = vm.getDateObj(vm.record.Attribute_3_Value, vm.selectedAttibute3)" \nmd-placeholder=""></md-datepicker></div><div ng-if="vm.selectedAttibute3.inputType === \'date-option\'" layout="column" \nflex><md-datepicker id="dialog_input_{{$first ? \'first\' : $index}}" name="Attribute_3_Value" \nng-model="vm.record.Attribute_3_Value" \nng-init="vm.record.Attribute_3_Value = vm.getDateObj(vm.record.Attribute_3_Value, vm.selectedAttibute3)" \nmd-placeholder=""></md-datepicker></div><div ng-if="vm.selectedAttibute3.inputType === \'bool-str\'"><md-switch \nid="dialog_input_{{$first ? \'first\' : $index}}" ng-model="vm.record.Attribute_3_Value" \naria-label="{{vm.selectedAttibute3.displayLabel | translate}}" ng-true-value="\'true\'" ng-false-value="\'false\'" \nclass="md-accent"></md-switch></div><div ng-if="vm.selectedAttibute3.inputType === \'list\'"><md-input-container \nclass="md-block"><md-select id="dialog_input_{{$first ? \'first\' : $index}}" name="Attribute_3_Value" \nng-model="vm.record.Attribute_3_Value" aria-label="{{vm.selectedAttibute3.displayLabel | translate}}"><md-option \nmd-option-empty ng-value="\'\'"><em>None</em></md-option><md-option ng-value="option" \nng-repeat="option in vm.selectedAttibute3.values">{{ option }}</md-option></md-select></md-input-container></div><div \nng-if="vm.selectedAttibute3.inputType === \'multi-value\'"><md-input-container class="md-block"><md-chips \nid="dialog_input_{{$first ? \'first\' : $index}}" name="Attribute_3_Value" ng-model="vm.record.Attribute_3_Value" \nmd-autocomplete-snap md-transform-chip="vm.transformChip($chip, true)" \naria-label="{{vm.selectedAttibute3.displayLabel | translate}}"><md-autocomplete \nmd-selected-item="vm.acSelectedItem[vm.selectedAttibute3.field]" \nmd-search-text="vm.acSearchText[vm.selectedAttibute3.field]" \nmd-items="item in vm.multiValueQuerySearch(vm.acSearchText[vm.selectedAttibute3.field], vm.record.Attribute_3_Value, vm.selectedAttibute3)" \nmd-item-text="item" md-min-length="0" md-no-cache="true" md-menu-class="autocomplete-custom"><md-item-template><span \nclass="autocomplete-item md-accent-fg" md-highlight-text="vm.acSearchText[vm.selectedAttibute3.field]">{{item}}</span>\n</md-item-template><md-not-found>No Record matching "{{vm.acSearchText[vm.selectedAttibute3.field]}}" were found.\n</md-not-found></md-autocomplete><md-chip-template><span><strong>{{$chip}}</strong></span></md-chip-template>\n</md-chips></md-input-container></div><div ng-if="vm.selectedAttibute3.inputType === \'decimal\'"><md-input-container \nclass="md-block"><input type="number" id="dialog_input_{{$first ? \'first\' : $index}}" name="Attribute_3_Value" \nng-model="vm.record.Attribute_3_Value" pattern="{{vm.selectedAttibute3.validation.pattern}}"><div \nng-messages="vm.editForm.Attribute_3_Value.$error" role="alert" multiple="multiple"><div ng-message="pattern">\n{{vm.selectedAttibute3.validation.messages.pattern | translate}}</div></div></md-input-container></div></div></div><div\n flex="100" flex-gt-xs="50" class="p-5 lookup-element"><md-autocomplete id="dialog_input_first" \nmd-input-name="Attribute_4_Id" md-selected-item="vm.acLookupModel.Attribute_4_Id" \nmd-items="item in vm.lookupSearch(vm.searchText.Attribute_4_Id, \'Attribute_4_Id\', vm.availableCatalogAttributes)" \nmd-search-text="vm.searchText.Attribute_4_Id" \nmd-item-text="vm.getlookupDisplayValue(item, vm.availableCatalogAttributes)" md-min-length="0" \nmd-floating-label="{{\'LIMITS_CRITERIA.FIELDS.ATTRIBUTE_4\' | translate}}" \nmd-selected-item-change="vm.lookupChangeAttribute4(vm.acLookupModel.Attribute_4_Id, \'Attribute_4_Id\')" \nmd-no-cache="true" tx-clear-autocomplete tx-force-select ng-click="vm.selectText($event)" \nmd-menu-class="autocomplete-custom"><md-item-template><span class="autocomplete-item md-accent-fg" \nmd-highlight-text="vm.searchText.Attribute_4_Id" md-highlight-flags="i">{{item.AttributeDisplayName}}</span>\n</md-item-template><md-not-found>No Record matching "{{vm.searchText.Attribute_4_Id}}" were found.</md-not-found>\n</md-autocomplete></div><div flex="100" flex-gt-xs="50" class="p-5"><div class="p-5"><div \nng-if="vm.selectedAttibute4.inputType === \'textArea\' || vm.selectedAttibute4.inputType === \'calculated\'">\n<md-input-container class="md-block"><input id="dialog_input_{{$first ? \'first\' : $index}}" name="Attribute_4_Value" \nng-model="vm.record.Attribute_4_Value"></md-input-container></div><div \nng-if="vm.selectedAttibute4.inputType === \'number\'"><md-input-container class="md-block"><input type="number" \nid="dialog_input_{{$first ? \'first\' : $index}}" name="Attribute_4_Value" ng-model="vm.record.Attribute_4_Value">\n</md-input-container></div><div ng-if="vm.selectedAttibute4.inputType === \'date\'" layout="column" flex><md-datepicker \nid="dialog_input_{{$first ? \'first\' : $index}}" name="Attribute_4_Value" ng-model="vm.record.Attribute_4_Value" \nng-init="vm.record.Attribute_4_Value = vm.getDateObj(vm.record.Attribute_4_Value, vm.selectedAttibute4)" \nmd-placeholder=""></md-datepicker></div><div ng-if="vm.selectedAttibute4.inputType === \'date-without-time\'" \nlayout="column" flex><md-datepicker id="dialog_input_{{$first ? \'first\' : $index}}" name="Attribute_4_Value" \nng-model="vm.record.Attribute_4_Value" \nng-init="vm.record.Attribute_4_Value = vm.getDateObj(vm.record.Attribute_4_Value, vm.selectedAttibute4)" \nmd-placeholder=""></md-datepicker></div><div ng-if="vm.selectedAttibute4.inputType === \'date-option\'" layout="column" \nflex><md-datepicker id="dialog_input_{{$first ? \'first\' : $index}}" name="Attribute_4_Value" \nng-model="vm.record.Attribute_4_Value" \nng-init="vm.record.Attribute_4_Value = vm.getDateObj(vm.record.Attribute_4_Value, vm.selectedAttibute4)" \nmd-placeholder=""></md-datepicker></div><div ng-if="vm.selectedAttibute4.inputType === \'bool-str\'"><md-switch \nid="dialog_input_{{$first ? \'first\' : $index}}" ng-model="vm.record.Attribute_4_Value" \naria-label="{{vm.selectedAttibute4.displayLabel | translate}}" ng-true-value="\'true\'" ng-false-value="\'false\'" \nclass="md-accent"></md-switch></div><div ng-if="vm.selectedAttibute4.inputType === \'list\'"><md-input-container \nclass="md-block"><md-select id="dialog_input_{{$first ? \'first\' : $index}}" name="Attribute_4_Value" \nng-model="vm.record.Attribute_4_Value" aria-label="{{vm.selectedAttibute4.displayLabel | translate}}"><md-option \nmd-option-empty ng-value="\'\'"><em>None</em></md-option><md-option ng-value="option" \nng-repeat="option in vm.selectedAttibute4.values">{{ option }}</md-option></md-select></md-input-container></div><div \nng-if="vm.selectedAttibute4.inputType === \'multi-value\'"><md-input-container class="md-block"><md-chips \nid="dialog_input_{{$first ? \'first\' : $index}}" name="Attribute_4_Value" ng-model="vm.record.Attribute_4_Value" \nmd-autocomplete-snap md-transform-chip="vm.transformChip($chip, true)" \naria-label="{{vm.selectedAttibute4.displayLabel | translate}}"><md-autocomplete \nmd-selected-item="vm.acSelectedItem[vm.selectedAttibute4.field]" \nmd-search-text="vm.acSearchText[vm.selectedAttibute4.field]" \nmd-items="item in vm.multiValueQuerySearch(vm.acSearchText[vm.selectedAttibute4.field], vm.record.Attribute_4_Value, vm.selectedAttibute4)" \nmd-item-text="item" md-min-length="0" md-no-cache="true" md-menu-class="autocomplete-custom"><md-item-template><span \nclass="autocomplete-item md-accent-fg" md-highlight-text="vm.acSearchText[vm.selectedAttibute4.field]">{{item}}</span>\n</md-item-template><md-not-found>No Record matching "{{vm.acSearchText[vm.selectedAttibute4.field]}}" were found.\n</md-not-found></md-autocomplete><md-chip-template><span><strong>{{$chip}}</strong></span></md-chip-template>\n</md-chips></md-input-container></div><div ng-if="vm.selectedAttibute4.inputType === \'decimal\'"><md-input-container \nclass="md-block"><input type="number" id="dialog_input_{{$first ? \'first\' : $index}}" name="Attribute_4_Value" \nng-model="vm.record.Attribute_4_Value" pattern="{{vm.selectedAttibute4.validation.pattern}}"><div \nng-messages="vm.editForm.Attribute_4_Value.$error" role="alert" multiple="multiple"><div ng-message="pattern">\n{{vm.selectedAttibute4.validation.messages.pattern | translate}}</div></div></md-input-container></div></div></div>\n</div></md-dialog-content><md-dialog-actions layout="row" layout-align="end center"><div></div><div layout="row" \nlayout-align="end center"><md-button ng-click="vm.closeDialog(vm.isDataDirty)" \nclass="send-button md-primary md-raised" aria-label="Cancel" translate="ACTIONS.DIALOG_CANCEL" \ntranslate-attr-aria-label="ACTIONS.DIALOG_CANCEL" ng-disabled="vm.isLoading">CANCEL</md-button><md-button \nng-click="vm.saveRecord()" class="send-button md-accent md-raised" aria-label="Save" translate="ACTIONS.SAVE" \ntranslate-attr-aria-label="ACTIONS.SAVE" ng-disabled="vm.isLoading || vm.editForm.$invalid">SAVE</md-button><md-button \nng-click="vm.saveRecord(true)" class="send-button md-accent md-raised" aria-label="Save" \ntranslate="ACTIONS.SAVE_AND_NEW" translate-attr-aria-label="ACTIONS.SAVE_AND_NEW" \nng-disabled="vm.isLoading || vm.editForm.$invalid" ng-show="vm.isNew">SAVE</md-button></div></md-dialog-actions></form>\n</md-dialog>');
$templateCache.put('app/main/catalogs/sub-modules/customers/details/tabs/capacities/dialogs/assign-capacity-to-customer.html','<md-dialog class="edit-dialog" aria-label="Link Capacity"><form name="vm.editForm" class="md-inline-form"><md-toolbar \nclass="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" layout-align="space-between center"><span \nclass="title" translate="LINKED_CUSTOMERS.ACTIONS.LINK_CAPACITIES">Link Capacities</span><md-button \nclass="md-icon-button" ng-click="vm.closeDialog(vm.isDataDirty)" aria-label="Close dialog" \ntranslate-aria-label="ACTIONS.DIALOG_CLOSE"><md-icon md-font-icon="icon-close"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div layout="row" layout-wrap><div flex="100" flex-gt-xs="100" \nclass="p-5 lookup-element"><md-autocomplete id="dialog_input_first" md-input-name="CapacityId" \nmd-selected-item="vm.lookupModel.CapacityId" \nmd-items="item in vm.lookupSearch(vm.searchText.CapacityId, \'CapacityId\')" md-search-text="vm.searchText.CapacityId" \nmd-item-text="vm.getLookupDisplayValue(item, \'CapacityId\')" md-min-length="0" \nmd-floating-label="{{\'SELLERS.CAPACITIES.FIELDS.NAME\' | translate}}" \nmd-selected-item-change="vm.lookupChange(vm.lookupModel.CapacityId, \'CapacityId\')" ng-required="true" \nmd-no-cache="true" tx-clear-autocomplete tx-force-select ng-click="vm.selectText($event)" \nmd-menu-class="autocomplete-custom"><md-item-template><span class="autocomplete-item md-accent-fg" \nmd-highlight-text="vm.searchText.CapacityId" md-highlight-flags="i">{{item.value}}</span></md-item-template>\n<md-not-found>No Record matching "{{vm.searchText.CapacityId}}" were found.</md-not-found><div \nng-messages="vm.editForm.CapacityId.$error" role="alert" ng-show="vm.editForm.CapacityId.$touched"><div \nng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div></div></md-autocomplete></div><div flex="100" \nflex-gt-xs="50" class="p-5"><md-input-container class="md-block"><label translate>\nSELLERS.CAPACITIES.FIELDS.ARTICLE_CAPACITY</label><input type="number" name="ArticleCapacity" \nng-model="vm.record.ArticleCapacity" min="0" step="1" ng-required="true" ng-pattern="/^\\d+$/"><div \nng-messages="vm.editForm.ArticleCapacity.$error" role="alert" multiple="multiple"><div ng-message="required">\n{{\'VALIDATIONS.REQUIRED\' | translate}}</div><div ng-message="pattern">{{\'VALIDATIONS.POSITIVE_NUMBER\' | translate}}\n</div><div ng-message="min">{{\'VALIDATIONS.POSITIVE_NUMBER\' | translate}}</div></div></md-input-container></div><div \nflex="100" flex-gt-xs="50" class="p-5"><md-input-container class="md-block"><label translate>\nSELLERS.CAPACITIES.FIELDS.MODEL_CAPACITY</label><input type="number" name="ModelCapacity" \nng-model="vm.record.ModelCapacity" min="0" step="1" ng-required="true" ng-pattern="/^\\d+$/"><div \nng-messages="vm.editForm.ModelCapacity.$error" role="alert" multiple="multiple"><div ng-message="required">\n{{\'VALIDATIONS.REQUIRED\' | translate}}</div><div ng-message="pattern">{{\'VALIDATIONS.POSITIVE_NUMBER\' | translate}}\n</div><div ng-message="min">{{\'VALIDATIONS.POSITIVE_NUMBER\' | translate}}</div></div></md-input-container></div></div>\n</md-dialog-content><md-dialog-actions layout="row" layout-align="end center"><div></div><div layout="row" \nlayout-align="end center"><md-button ng-click="vm.closeDialog(vm.isDataDirty)" \nclass="send-button md-primary md-raised" aria-label="Cancel" translate="ACTIONS.DIALOG_CANCEL" \ntranslate-attr-aria-label="ACTIONS.DIALOG_CANCEL" ng-disabled="vm.isLoading">CANCEL</md-button><md-button \nng-click="vm.saveRecord()" class="send-button md-accent md-raised" aria-label="Save" translate="ACTIONS.SAVE" \ntranslate-attr-aria-label="ACTIONS.SAVE" ng-disabled="vm.isLoading || vm.editForm.$invalid">SAVE</md-button></div>\n</md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/catalogs/sub-modules/customers/details/tabs/segmentations/dialogs/assign-segmentation-to-customer.html','<md-dialog class="edit-dialog" aria-label="Link Segmentation"><form name="vm.editForm" class="md-inline-form">\n<md-toolbar class="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" layout-align="space-between center">\n<span class="title" translate="TITLES.RECORD_NEW">New Record</span><md-button class="md-icon-button" \nng-click="vm.closeDialog(vm.isDataDirty)" aria-label="Close dialog" tranlate \ntranslate-aria-label="ACTIONS.DIALOG_CLOSE"><md-icon md-font-icon="icon-close"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div layout="row" layout-wrap><div flex="100" flex-gt-xs="50" \nclass="p-5 lookup-element"><md-autocomplete id="dialog_input_{{$first ? \'first\' : $index}}" \nmd-input-name="SegmentationId" md-selected-item="vm.lookupModel.SegmentationId" \nmd-items="item in vm.lookupSearch(vm.searchText.SegmentationId, \'SegmentationId\')" \nmd-search-text="vm.searchText.SegmentationId" md-item-text="vm.getLookupDisplayValue(item, \'SegmentationId\')" \nmd-min-length="0" md-floating-label="{{\'SEGMENTATIONS.FIELDS.ID\' | translate}}" \nmd-selected-item-change="vm.lookupChange(vm.lookupModel.SegmentationId, \'SegmentationId\')" ng-required="true" \nmd-no-cache="true" tx-clear-autocomplete tx-force-select ng-click="vm.selectText($event)" \nmd-menu-class="autocomplete-custom"><md-item-template><span class="autocomplete-item md-accent-fg" \nmd-highlight-text="vm.searchText.SegmentationId" md-highlight-flags="i">{{item.value}}</span></md-item-template>\n<md-not-found>No Record matching "{{vm.searchText.SegmentationId}}" were found.</md-not-found><div \nng-messages="vm.editForm.SegmentationId.$error" role="alert" ng-show="vm.editForm.SegmentationId.$touched"><div \nng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div></div></md-autocomplete></div></div>\n</md-dialog-content><md-dialog-actions layout="row" layout-align="end center"><div></div><div layout="row" \nlayout-align="end center"><md-button ng-click="vm.closeDialog(vm.isDataDirty)" \nclass="send-button md-primary md-raised" aria-label="Cancel" translate="ACTIONS.DIALOG_CANCEL" \ntranslate-attr-aria-label="ACTIONS.DIALOG_CANCEL" ng-disabled="vm.isLoading">CANCEL</md-button><md-button \nng-click="vm.saveRecord()" class="send-button md-accent md-raised" aria-label="Save" translate="ACTIONS.SAVE" \ntranslate-attr-aria-label="ACTIONS.SAVE" ng-disabled="vm.isLoading || vm.editForm.$invalid">SAVE</md-button><md-button \nng-click="vm.saveRecord(true)" class="send-button md-accent md-raised" aria-label="Save" \ntranslate="ACTIONS.SAVE_AND_NEW" translate-attr-aria-label="ACTIONS.SAVE_AND_NEW" \nng-disabled="vm.isLoading || vm.editForm.$invalid">SAVE</md-button></div></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/catalogs/sub-modules/orders/details/tabs/files/dialogs/upload-files.html','<md-dialog class="edit-dialog" aria-label="Upload File"><form name="vm.editForm" class="md-inline-form" \nflow-init="vm.flowInit" flow-object="$rootScope.flowObj" flow-file-added="vm.validateFile($file, $event, $flow)" \nflow-name="vm.obj.flow"><md-toolbar class="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" \nlayout-align="space-between center"><span class="title" translate="FILES.DIALOG_TITLES.UPLOAD_FILE">Upload File</span>\n<md-button class="md-icon-button" ng-click="vm.closeDialog()" aria-label="Close dialog" tranlate \ntranslate-aria-label="ACTIONS.DIALOG_CLOSE"><md-icon md-font-icon="icon-close"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div layout="column" flex><div flex="100" layout="row" \nlayout-align="space-between center" style="margin: 18px 7px"><div flex="initial"><span>Filename:</span></div><div flex \nlayout="row"><div flex class="text-boxed"><label for="fileName" ng-show="$flow.files.length === 0" \nstyle="display: block; width: 100%">[none]</label><span ng-show="$flow.files.length > 0" class="text-truncate">\n{{$flow.files[0].name}}</span></div></div><div flex="initial"><md-button class="md-raised" \nng-disabled="!vm.enableFileSelector"><label for="fileName">Select...</label></md-button></div></div><input type="file" \nflow-btn id="fileName" accept="{{vm.commaSeparatedValidTypes}}" class="ng-hide" required><div class="error-message" \nng-class="{\'display-error\' : ($flow.files.length > 0 && !vm.isFileValid), \'remove-error\' : !($flow.files.length > 0 && !vm.isFileValid)}" \nng-show="$flow.files.length > 0 && !vm.isFileValid">{{\'VALIDATIONS.INVALID_FORMATE\' | translate}}</div><div flex="100" \nflex-gt-xs="50" class="p-5"><md-input-container class="md-block"><label>{{\'FILES.FIELDS.DESCRIPTION\' | translate}}\n</label><input name="Description" ng-model="vm.record.Description" type="text" md-maxlength="250"><div \nng-messages="vm.editForm.Description.$error" role="alert" multiple="multiple"><div ng-message="md-maxlength">\n{{field.validation.messages.maxLen | translate}}</div></div></md-input-container></div></div></md-dialog-content>\n<md-dialog-actions layout="row" layout-align="end center"><div></div><div layout="row" layout-align="end center">\n<md-button ng-click="vm.closeDialog()" class="send-button md-primary md-raised" aria-label="Cancel" \ntranslate="ACTIONS.DIALOG_CANCEL" translate-attr-aria-label="ACTIONS.DIALOG_CANCEL" ng-disabled="vm.isLoading">CANCEL\n</md-button><md-button ng-click="vm.saveRecord()" class="send-button md-accent md-raised" aria-label="Save" \ntranslate="ACTIONS.SAVE" translate-attr-aria-label="ACTIONS.SAVE" \nng-disabled="!$flow.files.length || !vm.isFileValid || vm.editForm.$invalid">SAVE</md-button></div></md-dialog-actions>\n</form></md-dialog>');
$templateCache.put('app/main/catalogs/sub-modules/orders/details/tabs/order-line/details/orderline-details.html','<div id="order-line-details" class="page-layout simple tabbed details-view" layout="column"><div class="content">\n<md-tabs md-dynamic-height md-selected="vm.tabIndex"><md-tab label="{{\'ORDERLINE.TABS.ORDERLINE\' | translate}}" \ntx-access="{{::vm.model.views.privileges.details}}" ng-disabled="!vm.orderLine.IsActive"><tx-data-details \ntx-height-offset="37" tx-is-active="vm.tabIndex === 0" tx-account="vm.orderLine" tx-title="vm.title" \ntx-model="vm.model" tx-item-actions="vm.model.views.mainDetails.itemActions" \ntx-item-action-event="vm.doOrderLineItemAction(action, account)" tx-is-loading="vm.isLoading" \ntx-refresh-action-event="vm.refreshRecord(false)" tx-parent-id="vm.activeCatalog.CatalogCode" \ntx-status="vm.orderLine.IsActive" tx-custom-status="true"></tx-data-details></md-tab><md-tab \nlabel="{{\'ORDERLINE.TABS.SIZES\' | translate}}" ng-disabled="!vm.orderLine.IsActive" \ntx-access="{{::vm.sizesModel.views.privileges.list}}"><div class="list-tab" layout="row" flex="100" layout-wrap>\n<ms-widget layout="row" flex="100"><ms-widget-front class="white-bg"><tx-data-table tx-is-active="vm.tabIndex === 1" \ntx-data="vm.sizes" tx-model="vm.sizesModel" tx-view="mainList" tx-filtered-data="vm.filteredSizes" \ntx-data-filter="global.search" tx-is-loading="vm.isLoading" tx-refresh-action-event="vm.refreshRecord(false)" \ntx-height-offset="16"></tx-data-table></ms-widget-front></ms-widget></div></md-tab><md-tab \nlabel="{{\'ORDERLINE.TABS.VAS\' | translate}}" ng-disabled="!vm.orderLine.IsActive" \ntx-access="{{::vm.VASModel.views.privileges.list}}" ng-if="vm.activeCatalog.IsVasInUse == 1"><div class="list-tab" \nlayout="row" flex="100" layout-wrap><ms-widget layout="row" flex="100"><ms-widget-front class="white-bg"><tx-data-table\n tx-is-active="vm.tabIndex === 2" tx-data="vm.VAS" tx-model="vm.VASModel" tx-view="mainList" \ntx-filtered-data="vm.filteredVAS" tx-data-filter="global.search" tx-is-loading="vm.isLoading" \ntx-refresh-action-event="vm.refreshRecord(false)" tx-height-offset="16"></tx-data-table></ms-widget-front></ms-widget>\n</div></md-tab></md-tabs><md-button id="txfab" class="md-fab md-warn" \nng-if="vm.tabIndex === 0 && vm.model.views.mainDetails.fab.visible" ng-click="vm.editOrderline(vm.orderLine, $event)" \naria-label="vm.model.views.mainDetails.fab.label" translate tx-access="{{::vm.model.views.mainDetails.fab.privilege}}" \nng-disabled="!vm.orderLine.IsActive || !(vm.orderLine.OrderProcessStatusId == 1 || vm.orderLine.OrderProcessStatusId == 5) || vm.orderLine.ConsolidationId != 0">\n<md-icon md-font-icon="{{vm.model.views.mainDetails.fab.icon}}"></md-icon></md-button></div></div>');
$templateCache.put('app/main/catalogs/sub-modules/orders/details/tabs/order-line/dialogs/orderline-dialog.html','<md-dialog class="edit-dialog" aria-label="{{vm.isNew ? \'New Order Line\' : \'Update Order Line\'}}"><form \nname="vm.editForm" class="md-inline-form"><md-toolbar class="md-accent md-hue-2"><div class="md-toolbar-tools" \nlayout="row" layout-align="space-between center"><span class="title">\n{{vm.isNew ? \'PARTS.CREATE\' : \'PARTS.EDIT\' | translate}} {{vm.model.title | translate}}</span><md-button \nclass="md-icon-button" ng-click="vm.closeDialog(vm.isDataDirty)" aria-label="Close dialog" tranlate \ntranslate-aria-label="ACTIONS.DIALOG_CLOSE"><md-icon md-font-icon="icon-close"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div layout="row" layout-wrap><div flex="100" flex-gt-xs="50" \nclass="p-5 lookup-element"><md-autocomplete id="dialog_input_first" md-input-name="ArticleId" \nmd-selected-item="vm.lookupData.ArticleId" md-items="item in vm.lookupSearch(vm.searchText.ArticleId, \'ArticleId\')" \nmd-search-text="vm.searchText.ArticleId" md-item-text="vm.getLookupDisplayValue(item, \'ArticleId\')" md-min-length="0" \nmd-floating-label="{{\'ORDERLINE.FIELDS.ARTICLE_NUMBER\' | translate}}" \nmd-selected-item-change="vm.onArticleChange(vm.lookupData.ArticleId, \'ArticleId\')" ng-disabled="!vm.isNew" \nng-required="true" md-no-cache="true" tx-clear-autocomplete tx-force-select ng-click="vm.selectText($event)" \nmd-menu-class="autocomplete-custom"><md-item-template><span class="autocomplete-item md-accent-fg" \nmd-highlight-text="vm.searchText.ArticleId" md-highlight-flags="i">{{item.value}}</span></md-item-template>\n<md-not-found>No Record matching "{{vm.searchText.ArticleId}}" were found.</md-not-found><div \nng-messages="vm.editForm.ArticleId.$error" role="alert" ng-show="vm.editForm.ArticleId.$touched"><div \nng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div></div></md-autocomplete></div><div flex="100" \nflex-gt-xs="50" class="p-5 lookup-element" ng-if="!vm.isStockApply"><md-autocomplete id="dialog_input_1" \nmd-input-name="CrdId" md-selected-item="vm.lookupData.CrdId" \nmd-items="item in vm.articleRelatedLookupSearch(vm.searchText.CrdId, \'CrdId\')" md-search-text="vm.searchText.CrdId" \nmd-item-text="vm.getArticleCRDLookupDisplayValue(item, \'CrdId\')" md-min-length="0" \nmd-floating-label="{{\'ORDERLINE.FIELDS.CRD_ID\' | translate}}" \nmd-selected-item-change="vm.onCRDLookupChange(vm.lookupData.CrdId)" \nng-disabled="!vm.isNew || !vm.lookupData.ArticleId" ng-required="true" md-no-cache="true" tx-clear-autocomplete \ntx-force-select ng-click="vm.selectText($event)" md-menu-class="autocomplete-custom"><md-item-template><span \nclass="autocomplete-item md-accent-fg" md-highlight-text="vm.searchText.CrdId" md-highlight-flags="i">\n{{item[vm.articleCRDsModel.lookupDisplayField]}}</span></md-item-template><md-not-found>\nNo Record matching "{{vm.searchText.CrdId}}" were found.</md-not-found><div ng-messages="vm.editForm.CrdId.$error" \nrole="alert" ng-show="vm.editForm.CrdId.$touched"><div ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}\n</div></div></md-autocomplete></div><div layout="column" flex="100" flex-gt-xs="50" class="p-5" \nng-if="!vm.isStockApply && vm.isCustomerRequiredDateValidationAdded"><label class="md-caption" \nng-class="vm.editForm.DeliveryDate.$invalid ? \'form-date-error\': \'\'">{{\'ORDERLINE.FIELDS.DELIVERY_DATE \'| translate}}\n</label><md-datepicker id="dialog_input_3" name="DeliveryDate" md-min-date="vm.startDate" md-max-date="vm.endDate" \nng-model="vm.record.DeliveryDate" md-placeholder="" ng-required="true" ng-disabled="!vm.lookupData.CrdId" md-autofocus \nmd-date-filter="vm.showValidDateRangeFilter"></md-datepicker><div ng-messages="vm.editForm.DeliveryDate.$error" \nclass="form-date-error" role="alert" multiple="multiple"><div ng-message="required">\n{{\'VALIDATIONS.REQUIRED\' | translate}}</div><div ng-message="pattern">{{vm.crdValidationError | translate}}</div></div>\n</div><div flex="100" class="p-5" ng-if="vm.order.OrderProcessStatusId !== 1 && vm.order.OrderProcessStatusId !== 5">\n<md-input-container class="md-block"><label translate>ORDERLINE.FIELDS.COMMENT</label><textarea id="dialog_input_4" \ncolumns="1" rows="3" name="Comment" ng-model="vm.record.Comment" ng-required="false" md-maxlength="2000" ng-pattern="" \nng-disabled="!vm.isNew"></textarea><div ng-messages="vm.editForm.Comment.$error" role="alert" multiple="multiple"><div \nng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div><div ng-message="pattern">\n{{\'VALIDATIONS.PATTERN\' | translate}}</div><div ng-message="md-maxlength">{{\'VALIDATIONS.MAXLEN\' | translate}}</div>\n</div></md-input-container></div><div ng-if="vm.articleSizes.length > 0" flex="100"><span class="h3">\n{{ \'ORDERLINE.TABS.SIZES\' | translate }}</span></div><div \nng-repeat="size in vm.articleSizes | orderBy:[\'SortOrder\', \'SizeIndex\']" flex="50" flex-gt-xs="25" class="p-5" \nlayout-wrap><div><md-input-container class="md-block" \nng-class="{\'md-input-invalid\': vm.editForm[size[vm.api.articles.sizes.lookupDisplayField]].$error.max}"><label>\n{{size[vm.api.articles.sizes.lookupDisplayField]}}</label><input ng-if="!vm.isStockApply" id="dialog_input_6" \nname="{{size[vm.api.articles.sizes.lookupDisplayField]}}" ng-model="size.quantity" type="number" \nng-required="vm.isQuantityRequired(vm.articleRelatedLookupData.SizeId)" md-maxlength="-1" ng-pattern="/^\\d+$/" \nng-click="vm.selectText($event)"> <input ng-if="vm.isStockApply" id="dialog_input_6" \nname="{{size[vm.api.articles.sizes.lookupDisplayField]}}" ng-model="size.quantity" \nmax="{{vm.availableStocksSizeIdMap[size.Id]}}" type="number" \nng-required="vm.isQuantityRequired(vm.articleRelatedLookupData.SizeId)" md-maxlength="-1" ng-pattern="/^\\d+$/" \nng-click="vm.selectText($event)"><div ng-messages="vm.editForm[size[vm.api.articles.sizes.lookupDisplayField]].$error" \nclass="form-date-error" role="alert" multiple="multiple"><div ng-message="required">\n{{\'VALIDATIONS.REQUIRED\' | translate}}</div><div ng-message="md-maxlength">{{\'VALIDATIONS.MAXLEN\' | translate}}</div>\n<div ng-message="pattern">{{\'VALIDATIONS.PATTERN\' | translate}}</div><div ng-message="max" \ntranslate="ORDERLINE.VALIDATIONS.INVALID_QUANTITY" \ntranslate-values="{size: size[vm.api.articles.sizes.lookupDisplayField], availableStock: vm.availableStocksSizeIdMap[size.Id]}">\n</div></div></md-input-container></div></div><div ng-if="vm.sellerVAS.length > 0" flex="100"><span class="h3">\n{{ \'ORDERLINE.TABS.VAS\' | translate }}</span></div><div ng-repeat="VAS in vm.sellerVAS" flex="100" flex-gt-xs="50" \nclass="p-5" layout-wrap><div layout="row"><md-checkbox ng-model="vm.checkedVAS[VAS.id]" aria-label="AdditionalInfo" \nng-disabled="!vm.isNew"></md-checkbox><md-input-container class="md-block"><label>{{VAS.value}}</label><input \nid="dialog_input_5_{{$index}}" name="AdditionalInfo" ng-model="VAS.AdditionalInfo" type="text" md-maxlength="2000" \nng-click="vm.selectText($event)" ng-change="vm.checkVASEmpty(VAS)" ng-disabled="!vm.isNew"><div \nng-messages="vm.editForm.AdditionalInfo.$error" role="alert" multiple="multiple"><div ng-message="md-maxlength">\n{{\'VALIDATIONS.MAXLEN\' | translate}}</div></div></md-input-container></div></div></div></md-dialog-content>\n<md-dialog-actions layout="row" layout-align="end center"><div></div><div layout="row" layout-align="end center">\n<md-button ng-click="vm.closeDialog(vm.isDataDirty)" class="send-button md-primary md-raised" aria-label="Cancel" \ntranslate="ACTIONS.DIALOG_CANCEL" translate-attr-aria-label="ACTIONS.DIALOG_CANCEL" ng-disabled="vm.isLoading">CANCEL\n</md-button><md-button ng-click="vm.saveRecord()" class="send-button md-accent md-raised" aria-label="Save" \ntranslate="ACTIONS.SAVE" translate-attr-aria-label="ACTIONS.SAVE" ng-disabled="vm.isLoading || vm.editForm.$invalid">\nSAVE</md-button><md-button ng-click="vm.saveRecord(true)" class="send-button md-accent md-raised" aria-label="Save" \ntranslate="ACTIONS.SAVE_AND_NEW" translate-attr-aria-label="ACTIONS.SAVE_AND_NEW" \nng-disabled="vm.isLoading || vm.editForm.$invalid" ng-if="vm.isNew">SAVE</md-button></div></md-dialog-actions></form>\n</md-dialog>');
$templateCache.put('app/main/catalogs/sub-modules/resources/details/tabs/articles/dialogs/assign-articles.html','<md-dialog class="edit-dialog" aria-label="New Record"><form name="vm.editForm" class="md-inline-form"><md-toolbar \nclass="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" layout-align="space-between center"><span \nclass="title" translate="TITLES.RECORD_NEW">New Record</span><md-button class="md-icon-button" \nng-click="vm.closeDialog(vm.isDataDirty)" aria-label="Close dialog" tranlate \ntranslate-aria-label="ACTIONS.DIALOG_CLOSE"><md-icon md-font-icon="icon-close"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div layout="row" layout-wrap><div flex="100" flex-gt-xs="50" \nclass="p-5 lookup-element"><md-autocomplete id="dialog_input_{{$first ? \'first\' : $index}}" md-input-name="ArticleIds" \nmd-selected-item="vm.acLookupModel.ArticleIds" \nmd-items="item in vm.lookupSearch(vm.searchText.ArticleIds, \'ArticleIds\')" md-search-text="vm.searchText.ArticleIds" \nmd-item-text="vm.getLookupDisplayValue(item, \'ArticleIds\')" md-min-length="0" \nmd-floating-label="{{\'RESOURCES.FIELDS.ARTICLE_NUMBER\' | translate}}" md-selected-item-change="" ng-required="true" \nmd-no-cache="true" tx-clear-autocomplete tx-force-select ng-click="vm.selectText($event)" \nmd-menu-class="autocomplete-custom"><md-item-template><span class="autocomplete-item md-accent-fg" \nmd-highlight-text="vm.searchText.ArticleIds" md-highlight-flags="i">{{item.value}}</span></md-item-template>\n<md-not-found>No Record matching "{{vm.searchText.ArticleIds}}" were found.</md-not-found><div \nng-messages="vm.editForm.ArticleIds.$error" role="alert" ng-show="vm.editForm.ArticleIds.$touched"><div \nng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div></div></md-autocomplete></div></div>\n</md-dialog-content><md-dialog-actions layout="row" layout-align="end center"><div></div><div layout="row" \nlayout-align="end center"><md-button ng-click="vm.closeDialog(vm.isDataDirty)" \nclass="send-button md-primary md-raised" aria-label="Cancel" translate="ACTIONS.DIALOG_CANCEL" \ntranslate-attr-aria-label="ACTIONS.DIALOG_CANCEL" ng-disabled="vm.isLoading">CANCEL</md-button><md-button \nng-click="vm.saveRecord()" class="send-button md-accent md-raised" aria-label="Save" translate="ACTIONS.SAVE" \ntranslate-attr-aria-label="ACTIONS.SAVE" ng-disabled="vm.isLoading || vm.editForm.$invalid">SAVE</md-button><md-button \nng-click="vm.saveRecord(true)" class="send-button md-accent md-raised" aria-label="Save" \ntranslate="ACTIONS.SAVE_AND_NEW" translate-attr-aria-label="ACTIONS.SAVE_AND_NEW" \nng-disabled="vm.isLoading || vm.editForm.$invalid">SAVE</md-button></div></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/catalogs/sub-modules/resources/details/tabs/models/dialogs/assign-models.html','<md-dialog class="edit-dialog" aria-label="New Record"><form name="vm.editForm" class="md-inline-form"><md-toolbar \nclass="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" layout-align="space-between center"><span \nclass="title" translate="TITLES.RECORD_NEW">New Record</span><md-button class="md-icon-button" \nng-click="vm.closeDialog(vm.isDataDirty)" aria-label="Close dialog" translate-aria-label="ACTIONS.DIALOG_CLOSE">\n<md-icon md-font-icon="icon-close"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div \nlayout="row" layout-wrap><div flex="100" flex-gt-xs="50" class="p-5 lookup-element"><md-autocomplete \nid="dialog_input_{{$first ? \'first\' : $index}}" md-input-name="ModelIds" md-selected-item="vm.acLookupModel.ModelIds" \nmd-items="item in vm.lookupSearch(vm.searchText.ModelIds, \'ModelIds\')" md-search-text="vm.searchText.ModelIds" \nmd-item-text="vm.getLookupDisplayValue(item, \'ModelIds\')" md-min-length="0" \nmd-floating-label="{{\'RESOURCES.FIELDS.MODEL_NUMBER\' | translate}}" md-selected-item-change="" ng-required="true" \nmd-no-cache="true" tx-clear-autocomplete tx-force-select ng-click="vm.selectText($event)" \nmd-menu-class="autocomplete-custom"><md-item-template><span class="autocomplete-item md-accent-fg" \nmd-highlight-text="vm.searchText.ModelIds" md-highlight-flags="i">{{item.value}}</span></md-item-template>\n<md-not-found>No Record matching "{{vm.searchText.ModelIds}}" were found.</md-not-found><div \nng-messages="vm.editForm.ModelIds.$error" role="alert" ng-show="vm.editForm.ModelIds.$touched"><div \nng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</div></div></md-autocomplete></div></div>\n</md-dialog-content><md-dialog-actions layout="row" layout-align="end center"><div></div><div layout="row" \nlayout-align="end center"><md-button ng-click="vm.closeDialog(vm.isDataDirty)" \nclass="send-button md-primary md-raised" aria-label="Cancel" translate="ACTIONS.DIALOG_CANCEL" \ntranslate-attr-aria-label="ACTIONS.DIALOG_CANCEL" ng-disabled="vm.isLoading">CANCEL</md-button><md-button \nng-click="vm.saveRecord()" class="send-button md-accent md-raised" aria-label="Save" translate="ACTIONS.SAVE" \ntranslate-attr-aria-label="ACTIONS.SAVE" ng-disabled="vm.isLoading || vm.editForm.$invalid">SAVE</md-button><md-button \nng-click="vm.saveRecord(true)" class="send-button md-accent md-raised" aria-label="Save" \ntranslate="ACTIONS.SAVE_AND_NEW" translate-attr-aria-label="ACTIONS.SAVE_AND_NEW" \nng-disabled="vm.isLoading || vm.editForm.$invalid">SAVE</md-button></div></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/catalogs/sub-modules/articles/details/tabs/sizes/dialogs/assign-size/assign-size.html','<md-dialog class="edit-dialog" aria-label="Assign Size"><form name="vm.editForm" class="md-inline-form"><md-toolbar \nclass="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" layout-align="space-between center"><span \nclass="title" translate="SIZES.ACTIONS.ASSIGN_SIZE">Assign Size</span><md-button class="md-icon-button" \nng-click="vm.closeDialog(vm.isDataDirty)" aria-label="Close dialog" tranlate \ntranslate-aria-label="ACTIONS.DIALOG_CLOSE"><md-icon md-font-icon="icon-close"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div layout="row" layout-wrap><div flex="100" flex-gt-xs="50" \nclass="p-5 lookup-element"><md-autocomplete id="dialog_input_assignSize" md-input-name="Size" \nmd-selected-item="vm.lookupModel[\'Size\']" md-items="item in vm.lookupSearch(vm.searchText[\'Size\'])" \nmd-search-text="vm.searchText[\'Size\']" md-item-text="item[vm.model.lookupDisplayField]" md-min-length="0" \nmd-floating-label="{{\'SIZES.FIELDS.SIZE_NAME\' | translate}}" md-selected-item-change="vm.lookupChange(item)" \nng-required="true" md-no-cache="true" tx-clear-autocomplete tx-force-select ng-click="vm.selectText($event)" \nmd-menu-class="autocomplete-custom"><md-item-template><span class="autocomplete-item md-accent-fg" \nmd-highlight-text="vm.searchText[\'Size\']" md-highlight-flags="i">{{item[vm.model.lookupDisplayField]}}</span>\n</md-item-template><div ng-messages="vm.editForm[\'Size\'].$error" role="alert" ng-show="vm.editForm[\'Size\'].$touched">\n<div ng-message="required">{{field.validation.messages.isRequired | translate}}</div></div><md-not-found>\nNo Record matching "{{vm.searchText[\'Size\']}}" were found.</md-not-found></md-autocomplete></div></div>\n</md-dialog-content><md-dialog-actions layout="row" layout-align="end center"><div></div><div layout="row" \nlayout-align="end center"><md-button ng-click="vm.closeDialog(vm.isDataDirty)" \nclass="send-button md-primary md-raised" aria-label="Cancel" translate="ACTIONS.DIALOG_CANCEL" \ntranslate-attr-aria-label="ACTIONS.DIALOG_CANCEL" ng-disabled="vm.isLoading">CANCEL</md-button><md-button \nng-click="vm.saveRecord()" class="send-button md-accent md-raised" aria-label="Save" translate="ACTIONS.SAVE" \ntranslate-attr-aria-label="ACTIONS.SAVE" ng-disabled="vm.isLoading || vm.editForm.$invalid">SAVE</md-button><md-button \nng-click="vm.saveRecord(true)" class="send-button md-accent md-raised" aria-label="Save" \ntranslate="ACTIONS.SAVE_AND_NEW" translate-attr-aria-label="ACTIONS.SAVE_AND_NEW" \nng-disabled="vm.isLoading || vm.editForm.$invalid">SAVE</md-button></div></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/catalogs/sub-modules/assortments/details/tabs/users/dialogs/set-users/set-users.html','<md-dialog class="edit-dialog" aria-label="Set Customers"><form name="vm.editForm" class="md-inline-form"><md-toolbar \nclass="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" layout-align="space-between center"><span \nclass="title" translate="ASSORTMENTS.DIALOGS.TITLE.SET_USERS">Set Collection\'s\' Customers</span><md-button \nclass="md-icon-button" ng-click="vm.closeDialog(false)" aria-label="Close dialog" tranlate \ntranslate-aria-label="ACTIONS.DIALOG_CLOSE"><md-icon md-font-icon="icon-close"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div flex="100" class="p-5 lookup-element"><md-input-container \nclass="md-block"><label>{{\'ASSORTMENTS.FIELDS.USERS\' | translate}}</label><md-chips id="dialog_input_16" name="Users" \nng-model="vm.record.Users" md-autocomplete-snap md-transform-chip="vm.transformChip($chip)" md-require-match="true" \nng-required="false"><md-autocomplete md-selected-item="vm.acSelectedItem.Users" md-search-text="vm.acSearchText.Users" \nmd-items="item in vm.acQuerySearch(vm.acSearchText.Users, vm.record.Users, \'Users\')" md-item-text="item.value" \nmd-min-length="0" md-no-cache="true" md-menu-class="autocomplete-custom"><md-item-template><span \nclass="autocomplete-item md-accent-fg" md-highlight-text="vm.acSearchText.Users">{{item.value}}</span>\n</md-item-template><md-not-found>No Record matching "{{vm.acSearchText.Users}}" were found.</md-not-found>\n</md-autocomplete><md-chip-template><span><strong>{{vm.getChipDisplayValue($chip, \'Users\')}}</strong></span>\n</md-chip-template></md-chips></md-input-container></div></md-dialog-content><md-dialog-actions layout="row" \nlayout-align="end center"><div></div><div layout="row" layout-align="end center"><md-button \nng-click="vm.closeDialog(false)" class="send-button md-primary md-raised" aria-label="Cancel" \ntranslate="ACTIONS.DIALOG_CANCEL" translate-attr-aria-label="ACTIONS.DIALOG_CANCEL" ng-disabled="vm.isLoading">CANCEL\n</md-button><md-button ng-click="vm.saveRecord()" class="send-button md-accent md-raised" aria-label="Save" \ntranslate="ACTIONS.SAVE" translate-attr-aria-label="ACTIONS.SAVE" ng-disabled="vm.isLoading || vm.editForm.$invalid">\nSAVE</md-button></div></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/catalogs/sub-modules/requests/details/tabs/attachments/dialogs/view-image/view-image.html','<md-dialog class="edit-dialog" aria-label="New Record"><form name="vm.editForm" class="md-inline-form"><md-toolbar \nclass="md-accent md-hue-2"><div class="md-toolbar-tools" layout="row" layout-align="space-between center"><span \nclass="title" translate="{{REQUESTS.ATTACHMENT}}">Attachment</span><md-button class="md-icon-button" \nng-click="vm.closeDialog()" aria-label="Close dialog" tranlate translate-aria-label="ACTIONS.DIALOG_CLOSE"><md-icon \nmd-font-icon="icon-close"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div layout="row" \nlayout-wrap><div flex="100" class="p-5"><div><img ng-src="{{vm.record.FilePath}}"></div><div><label>\n{{vm.record.FileName}}</label></div></div></div></md-dialog-content><md-dialog-actions layout="row" \nlayout-align="end center"><div></div><div layout="row" layout-align="end center"><md-button \nng-click="vm.closeDialog()" class="send-button md-accent md-raised" aria-label="CLOSE" translate="ACTIONS.CLOSE" \ntranslate-attr-aria-label="ACTIONS.CLOSE" ng-disabled="vm.isLoading">Close</md-button></div></md-dialog-actions></form>\n</md-dialog>');}]);